/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "../";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1261);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1509);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["_"] = __webpack_require__(1377);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1538)();
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v2.1.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright 2005, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-04-28T16:01Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//

var arr = [];

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	// Use the correct document accordingly with window argument (sandbox)
	document = window.document,

	version = "2.1.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {
		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {
	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	// (You can seed the arguments with an array of args, but this is
	// only used internally.)
	each: function( callback, args ) {
		return jQuery.each( this, callback, args );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map(this, function( elem, i ) {
			return callback.call( elem, i, elem );
		}));
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[j] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor(null);
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[0] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {
		// Only deal with non-null/undefined values
		if ( (options = arguments[ i ]) != null ) {
			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray(src) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject(src) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend({
	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type(obj) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {
		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		return !jQuery.isArray( obj ) && (obj - parseFloat( obj ) + 1) >= 0;
	},

	isPlainObject: function( obj ) {
		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		if ( obj.constructor &&
				!hasOwn.call( obj.constructor.prototype, "isPrototypeOf" ) ) {
			return false;
		}

		// If the function hasn't returned already, we're confident that
		// |obj| is a plain object, created by {} or constructed with new Object
		return true;
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call(obj) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {
			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf("use strict") === 1 ) {
				script = document.createElement("script");
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {
			// Otherwise, avoid the DOM node creation, insertion
			// and removal by using an indirect global eval
				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	// args is for internal usage only
	each: function( obj, callback, args ) {
		var value,
			i = 0,
			length = obj.length,
			isArray = isArraylike( obj );

		if ( args ) {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.apply( obj[ i ], args );

					if ( value === false ) {
						break;
					}
				}
			}

		// A special, fast, case for the most common use of each
		} else {
			if ( isArray ) {
				for ( ; i < length; i++ ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					value = callback.call( obj[ i ], i, obj[ i ] );

					if ( value === false ) {
						break;
					}
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArraylike( Object(arr) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var value,
			i = 0,
			length = elems.length,
			isArray = isArraylike( elems ),
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArray ) {
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
});

// Populate the class2type map
jQuery.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function(i, name) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
});

function isArraylike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	if ( obj.nodeType === 1 && length ) {
		return true;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.0-pre
 * http://sizzlejs.com/
 *
 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2014-12-16
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",
	// http://www.w3.org/TR/css3-syntax/#characters
	characterEncoding = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Loosely modeled on CSS identifier characters
	// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors
	// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = characterEncoding.replace( "w", "w#" ),

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + characterEncoding + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + characterEncoding + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + characterEncoding + ")" ),
		"CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
		"TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var match, elem, m, nodeType,
		// QSA vars
		i, groups, old, nid, newContext, newSelector;

	if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
		setDocument( context );
	}

	context = context || document;
	results = results || [];
	nodeType = context.nodeType;

	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	if ( !seed && documentIsHTML ) {

		// Try to shortcut find operations when possible (e.g., not under DocumentFragment)
		if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
			// Speed-up: Sizzle("#ID")
			if ( (m = match[1]) ) {
				if ( nodeType === 9 ) {
					elem = context.getElementById( m );
					// Check parentNode to catch when Blackberry 4.6 returns
					// nodes that are no longer in the document (jQuery #6963)
					if ( elem && elem.parentNode ) {
						// Handle the case where IE, Opera, and Webkit return items
						// by name instead of ID
						if ( elem.id === m ) {
							results.push( elem );
							return results;
						}
					} else {
						return results;
					}
				} else {
					// Context is not a document
					if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
						contains( context, elem ) && elem.id === m ) {
						results.push( elem );
						return results;
					}
				}

			// Speed-up: Sizzle("TAG")
			} else if ( match[2] ) {
				push.apply( results, context.getElementsByTagName( selector ) );
				return results;

			// Speed-up: Sizzle(".CLASS")
			} else if ( (m = match[3]) && support.getElementsByClassName ) {
				push.apply( results, context.getElementsByClassName( m ) );
				return results;
			}
		}

		// QSA path
		if ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
			nid = old = expando;
			newContext = context;
			newSelector = nodeType !== 1 && selector;

			// qSA works strangely on Element-rooted queries
			// We can work around this by specifying an extra ID on the root
			// and working up from there (Thanks to Andrew Dupont for the technique)
			// IE 8 doesn't work on object elements
			if ( nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
				groups = tokenize( selector );

				if ( (old = context.getAttribute("id")) ) {
					nid = old.replace( rescape, "\\$&" );
				} else {
					context.setAttribute( "id", nid );
				}
				nid = "[id='" + nid + "'] ";

				i = groups.length;
				while ( i-- ) {
					groups[i] = nid + toSelector( groups[i] );
				}
				newContext = rsibling.test( selector ) && testContext( context.parentNode ) || context;
				newSelector = groups.join(",");
			}

			if ( newSelector ) {
				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch(qsaError) {
				} finally {
					if ( !old ) {
						context.removeAttribute("id");
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = attrs.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// If no document and documentElement is available, return
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Set our document
	document = doc;
	docElem = doc.documentElement;
	parent = doc.defaultView;

	// Support: IE>8
	// If iframe document is assigned to "document" variable and if iframe has been reloaded,
	// IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	// IE6-8 do not support the defaultView property so parent will be undefined
	if ( parent && parent !== parent.top ) {
		// IE11 does not have attachEvent, so all must suffer
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Support tests
	---------------------------------------------------------------------- */
	documentIsHTML = !isXML( doc );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( doc.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( doc.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !doc.getElementsByName || !doc.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				// Check parentNode to catch when Blackberry 4.6 returns
				// nodes that are no longer in the document #6963
				return m && m.parentNode ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\f]' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.2+, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.7+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = doc.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully does not implement inclusive descendent
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === doc ? -1 :
				b === doc ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return doc;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, outerCache, node, diff, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {
										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {
							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || (parent[ expando ] = {});
							cache = outerCache[ type ] || [];
							nodeIndex = cache[0] === dirruns && cache[1];
							diff = cache[0] === dirruns && cache[2];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						// Use previously-cached element index if available
						} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {
							diff = cache[1];

						// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
						} else {
							// Use the same loop as above to seek `elem` from the start
							while ( (node = ++nodeIndex && node && node[ dir ] ||
								(diff = nodeIndex = 0) || start.pop()) ) {

								if ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {
									// Cache the index of each encountered element
									if ( useCache ) {
										(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];
									}

									if ( node === elem ) {
										break;
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});
						if ( (oldCache = outerCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							outerCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context !== document && context;
			}

			// Add elements passing elementMatchers directly to results
			// Keep `i` a string if there are no elements so `matchedCount` will be "00" below
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// Apply set filters to unmatched elements
			matchedCount += i;
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is no seed and only one group
	if ( match.length === 1 ) {

		// Take a shortcut and set the context if the root selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[":"] = jQuery.expr.pseudos;
jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = (/^<(\w+)\s*\/?>(?:<\/\1>|)$/);



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		});

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		});

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) >= 0 ) !== not;
	});
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		}));
};

jQuery.fn.extend({
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter(function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			}) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow(this, selector || [], false) );
	},
	not: function( selector ) {
		return this.pushStack( winnow(this, selector || [], true) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
});


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[0] === "<" && selector[ selector.length - 1 ] === ">" && selector.length >= 3 ) {
				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && (match[1] || !context) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[1] ) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[1],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {
							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[2] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {
						// Inject the element directly into the jQuery object
						this.length = 1;
						this[0] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || rootjQuery ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[0] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return typeof rootjQuery.ready !== "undefined" ?
				rootjQuery.ready( selector ) :
				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.extend({
	dir: function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;

		while ( (elem = elem[ dir ]) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	},

	sibling: function( n, elem ) {
		var matched = [];

		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}

		return matched;
	}
});

jQuery.fn.extend({
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter(function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[i] ) ) {
					return true;
				}
			}
		});
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[i]; cur && cur !== context; cur = cur.parentNode ) {
				// Always skip document fragments
				if ( cur.nodeType < 11 && (pos ?
					pos.index(cur) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector(cur, selectors)) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.unique( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.unique(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter(selector)
		);
	}
});

function sibling( cur, dir ) {
	while ( (cur = cur[dir]) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each({
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return jQuery.dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return jQuery.dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return jQuery.dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return jQuery.dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return jQuery.sibling( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {
			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.unique( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
});
var rnotwhite = (/\S+/g);



// String to Object options format cache
var optionsCache = {};

// Convert String-formatted options into Object-formatted ones and store in cache
function createOptions( options ) {
	var object = optionsCache[ options ] = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	});
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		( optionsCache[ options ] || createOptions( options ) ) :
		jQuery.extend( {}, options );

	var // Last fire value (for non-forgettable lists)
		memory,
		// Flag to know if list was already fired
		fired,
		// Flag to know if list is currently firing
		firing,
		// First callback to fire (used internally by add and fireWith)
		firingStart,
		// End of the loop when firing
		firingLength,
		// Index of currently firing callback (modified by remove if needed)
		firingIndex,
		// Actual callback list
		list = [],
		// Stack of fire calls for repeatable lists
		stack = !options.once && [],
		// Fire callbacks
		fire = function( data ) {
			memory = options.memory && data;
			fired = true;
			firingIndex = firingStart || 0;
			firingStart = 0;
			firingLength = list.length;
			firing = true;
			for ( ; list && firingIndex < firingLength; firingIndex++ ) {
				if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
					memory = false; // To prevent further calls using add
					break;
				}
			}
			firing = false;
			if ( list ) {
				if ( stack ) {
					if ( stack.length ) {
						fire( stack.shift() );
					}
				} else if ( memory ) {
					list = [];
				} else {
					self.disable();
				}
			}
		},
		// Actual Callbacks object
		self = {
			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {
					// First, we save the current length
					var start = list.length;
					(function add( args ) {
						jQuery.each( args, function( _, arg ) {
							var type = jQuery.type( arg );
							if ( type === "function" ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && type !== "string" ) {
								// Inspect recursively
								add( arg );
							}
						});
					})( arguments );
					// Do we need to add the callbacks to the
					// current firing batch?
					if ( firing ) {
						firingLength = list.length;
					// With memory, if we're not firing then
					// we should call right away
					} else if ( memory ) {
						firingStart = start;
						fire( memory );
					}
				}
				return this;
			},
			// Remove a callback from the list
			remove: function() {
				if ( list ) {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
							// Handle firing indexes
							if ( firing ) {
								if ( index <= firingLength ) {
									firingLength--;
								}
								if ( index <= firingIndex ) {
									firingIndex--;
								}
							}
						}
					});
				}
				return this;
			},
			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ? jQuery.inArray( fn, list ) > -1 : !!( list && list.length );
			},
			// Remove all callbacks from the list
			empty: function() {
				list = [];
				firingLength = 0;
				return this;
			},
			// Have the list do nothing anymore
			disable: function() {
				list = stack = memory = undefined;
				return this;
			},
			// Is it disabled?
			disabled: function() {
				return !list;
			},
			// Lock the list in its current state
			lock: function() {
				stack = undefined;
				if ( !memory ) {
					self.disable();
				}
				return this;
			},
			// Is it locked?
			locked: function() {
				return !stack;
			},
			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( list && ( !fired || stack ) ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					if ( firing ) {
						stack.push( args );
					} else {
						fire( args );
					}
				}
				return this;
			},
			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},
			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend({

	Deferred: function( func ) {
		var tuples = [
				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks("memory") ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred(function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];
							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[1] ](function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.done( newDefer.resolve )
										.fail( newDefer.reject )
										.progress( newDefer.notify );
								} else {
									newDefer[ tuple[ 0 ] + "With" ]( this === promise ? newDefer.promise() : this, fn ? [ returned ] : arguments );
								}
							});
						});
						fns = null;
					}).promise();
				},
				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[1] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(function() {
					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[0] ] = function() {
				deferred[ tuple[0] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[0] + "With" ] = list.fireWith;
		});

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred. If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject )
						.progress( updateFunc( i, progressContexts, progressValues ) );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
});


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {
	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend({
	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
});

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed, false );
	window.removeEventListener( "load", completed, false );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called after the browser event has already occurred.
		// We once tried to use readyState "interactive" here, but it caused issues like the one
		// discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
		if ( document.readyState === "complete" ) {
			// Handle it asynchronously to allow scripts the opportunity to delay ready
			setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed, false );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed, false );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = jQuery.access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			jQuery.access( elems, fn, i, key[i], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {
			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn( elems[i], key, raw ? value : value.call( elems[i], i, fn( elems[i], key ) ) );
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[0], key ) : emptyGet;
};


/**
 * Determines whether an object can have data
 */
jQuery.acceptData = function( owner ) {
	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};


function Data() {
	// Support: Android<4,
	// Old WebKit does not have Object.preventExtensions/freeze method,
	// return new empty object instead with no [[set]] accessor
	Object.defineProperty( this.cache = {}, 0, {
		get: function() {
			return {};
		}
	});

	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;
Data.accepts = jQuery.acceptData;

Data.prototype = {
	key: function( owner ) {
		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return the key for a frozen object.
		if ( !Data.accepts( owner ) ) {
			return 0;
		}

		var descriptor = {},
			// Check if the owner object already has a cache key
			unlock = owner[ this.expando ];

		// If not, create one
		if ( !unlock ) {
			unlock = Data.uid++;

			// Secure it in a non-enumerable, non-writable property
			try {
				descriptor[ this.expando ] = { value: unlock };
				Object.defineProperties( owner, descriptor );

			// Support: Android<4
			// Fallback to a less secure definition
			} catch ( e ) {
				descriptor[ this.expando ] = unlock;
				jQuery.extend( owner, descriptor );
			}
		}

		// Ensure the cache object
		if ( !this.cache[ unlock ] ) {
			this.cache[ unlock ] = {};
		}

		return unlock;
	},
	set: function( owner, data, value ) {
		var prop,
			// There may be an unlock assigned to this node,
			// if there is no entry for this "owner", create one inline
			// and set the unlock as though an owner entry had always existed
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {
			// Fresh assignments by object are shallow copied
			if ( jQuery.isEmptyObject( cache ) ) {
				jQuery.extend( this.cache[ unlock ], data );
			// Otherwise, copy the properties one-by-one to the cache object
			} else {
				for ( prop in data ) {
					cache[ prop ] = data[ prop ];
				}
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		// Either a valid cache is found, or will be created.
		// New caches will be created and the unlock returned,
		// allowing direct access to the newly created
		// empty data object. A valid owner object must be provided.
		var cache = this.cache[ this.key( owner ) ];

		return key === undefined ?
			cache : cache[ key ];
	},
	access: function( owner, key, value ) {
		var stored;
		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				((key && typeof key === "string") && value === undefined) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase(key) );
		}

		// [*]When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			unlock = this.key( owner ),
			cache = this.cache[ unlock ];

		if ( key === undefined ) {
			this.cache[ unlock ] = {};

		} else {
			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {
				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );
				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;
			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}
	},
	hasData: function( owner ) {
		return !jQuery.isEmptyObject(
			this.cache[ owner[ this.expando ] ] || {}
		);
	},
	discard: function( owner ) {
		if ( owner[ this.expando ] ) {
			delete this.cache[ owner[ this.expando ] ];
		}
	}
};
var data_priv = new Data();

var data_user = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /([A-Z])/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :
					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch( e ) {}

			// Make sure we set the data so it isn't changed later
			data_user.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend({
	hasData: function( elem ) {
		return data_user.hasData( elem ) || data_priv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return data_user.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		data_user.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to data_priv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return data_priv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		data_priv.remove( elem, name );
	}
});

jQuery.fn.extend({
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = data_user.get( elem );

				if ( elem.nodeType === 1 && !data_priv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice(5) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					data_priv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each(function() {
				data_user.set( this, key );
			});
		}

		return access( this, function( value ) {
			var data,
				camelKey = jQuery.camelCase( key );

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {
				// Attempt to get data from the cache
				// with the key as-is
				data = data_user.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to get data from the cache
				// with the key camelized
				data = data_user.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each(function() {
				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = data_user.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				data_user.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf("-") !== -1 && data !== undefined ) {
					data_user.set( this, key, value );
				}
			});
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each(function() {
			data_user.remove( this, key );
		});
	}
});


jQuery.extend({
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = data_priv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = data_priv.access( elem, type, jQuery.makeArray(data) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return data_priv.get( elem, key ) || data_priv.access( elem, key, {
			empty: jQuery.Callbacks("once memory").add(function() {
				data_priv.remove( elem, [ type + "queue", key ] );
			})
		});
	}
});

jQuery.fn.extend({
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[0], type );
		}

		return data === undefined ?
			this :
			this.each(function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[0] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			});
	},
	dequeue: function( type ) {
		return this.each(function() {
			jQuery.dequeue( this, type );
		});
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},
	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = data_priv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
});
var pnum = (/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/).source;

var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {
		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	};

var rcheckableType = (/^(?:checkbox|radio)$/i);



(function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
})();
var strundefined = typeof undefined;



support.focusinBubbles = "onfocusin" in window;


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu)|click/,
	rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)$/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !(events = elemData.events) ) {
			events = elemData.events = {};
		}
		if ( !(eventHandle = elemData.handle) ) {
			eventHandle = elemData.handle = function( e ) {
				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== strundefined && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend({
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join(".")
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !(handlers = events[ type ]) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle, false );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = data_priv.hasData( elem ) && data_priv.get( elem );

		if ( !elemData || !(events = elemData.events) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[t] ) || [];
			type = origType = tmp[1];
			namespaces = ( tmp[2] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[2] && new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			delete elemData.handle;
			data_priv.remove( elem, "events" );
		}
	},

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split(".") : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf(".") >= 0 ) {
			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split(".");
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf(":") < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join(".");
		event.namespace_re = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === (elem.ownerDocument || document) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( (cur = eventPath[i++]) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( data_priv.get( cur, "events" ) || {} )[ event.type ] && data_priv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && jQuery.acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( (!special._default || special._default.apply( eventPath.pop(), data ) === false) &&
				jQuery.acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( data_priv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[0] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( (matched = handlerQueue[ i++ ]) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( (handleObj = matched.handlers[ j++ ]) && !event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.namespace_re || event.namespace_re.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
							.apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( (event.result = ret) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		// Avoid non-left-click bubbling in Firefox (#3861)
		if ( delegateCount && cur.nodeType && (!event.button || event.type !== "click") ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.disabled !== true || event.type !== "click" ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) >= 0 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push({ elem: cur, handlers: matches });
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push({ elem: this, handlers: handlers.slice( delegateCount ) });
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split(" "),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {
			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {
			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {
			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	},

	simulate: function( type, elem, event, bubble ) {
		// Piggyback on a donor event to simulate a different one.
		// Fake originalEvent to avoid donor's stopPropagation, but if the
		// simulated event prevents default then we do the same on the donor.
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true,
				originalEvent: {}
			}
		);
		if ( bubble ) {
			jQuery.event.trigger( e, null, elem );
		} else {
			jQuery.event.dispatch.call( elem, e );
		}
		if ( e.isDefaultPrevented() ) {
			event.preventDefault();
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle, false );
	}
};

jQuery.Event = function( src, props ) {
	// Allow instantiation without the 'new' keyword
	if ( !(this instanceof jQuery.Event) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&
				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && e.preventDefault ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && e.stopPropagation ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && e.stopImmediatePropagation ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// Support: Chrome 15+
jQuery.each({
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mousenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
});

// Support: Firefox, Chrome, Safari
// Create "bubbling" focus and blur events
if ( !support.focusinBubbles ) {
	jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
			};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				data_priv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = data_priv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					data_priv.remove( doc, fix );

				} else {
					data_priv.access( doc, fix, attaches );
				}
			}
		};
	});
}

jQuery.fn.extend({

	on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				this.on( type, selector, data, types[ type ], one );
			}
			return this;
		}

		if ( data == null && fn == null ) {
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return this;
		}

		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return this.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		});
	},
	one: function( types, selector, data, fn ) {
		return this.on( types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {
			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {
			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {
			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each(function() {
			jQuery.event.remove( this, types, fn, selector );
		});
	},

	trigger: function( type, data ) {
		return this.each(function() {
			jQuery.event.trigger( type, data, this );
		});
	},
	triggerHandler: function( type, data ) {
		var elem = this[0];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
});


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	rtagName = /<([\w:]+)/,
	rhtml = /<|&#?\w+;/,
	rnoInnerhtml = /<(?:script|style|link)/i,
	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptType = /^$|\/(?:java|ecma)script/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g,

	// We have to close these tags to support XHTML (#13200)
	wrapMap = {

		// Support: IE9
		option: [ 1, "<select multiple='multiple'>", "</select>" ],

		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

		_default: [ 0, "", "" ]
	};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: 1.x compatibility
// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName("tbody")[0] ||
			elem.appendChild( elem.ownerDocument.createElement("tbody") ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute("type");
	}

	return elem;
}

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		data_priv.set(
			elems[ i ], "globalEval", !refElements || data_priv.get( refElements[ i ], "globalEval" )
		);
	}
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( data_priv.hasData( src ) ) {
		pdataOld = data_priv.access( src );
		pdataCur = data_priv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( data_user.hasData( src ) ) {
		udataOld = data_user.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		data_user.set( dest, udataCur );
	}
}

function getAll( context, tag ) {
	var ret = context.getElementsByTagName ? context.getElementsByTagName( tag || "*" ) :
			context.querySelectorAll ? context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

jQuery.extend({
	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	buildFragment: function( elems, context, scripts, selection ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;

		for ( ; i < l; i++ ) {
			elem = elems[ i ];

			if ( elem || elem === 0 ) {

				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );

				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement("div") );

					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + elem.replace( rxhtmlTag, "<$1></$2>" ) + wrap[ 2 ];

					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}

					// Support: QtWebKit, PhantomJS
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while ( (elem = nodes[ i++ ]) ) {

			// #4087 - If origin and destination elements are the same, and this is
			// that element, do not do anything
			if ( selection && jQuery.inArray( elem, selection ) !== -1 ) {
				continue;
			}

			contains = jQuery.contains( elem.ownerDocument, elem );

			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );

			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}

			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( (elem = tmp[ j++ ]) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}

		return fragment;
	},

	cleanData: function( elems ) {
		var data, elem, type, key,
			special = jQuery.event.special,
			i = 0;

		for ( ; (elem = elems[ i ]) !== undefined; i++ ) {
			if ( jQuery.acceptData( elem ) ) {
				key = elem[ data_priv.expando ];

				if ( key && (data = data_priv.cache[ key ]) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}
					if ( data_priv.cache[ key ] ) {
						// Discard any remaining `private` data
						delete data_priv.cache[ key ];
					}
				}
			}
			// Discard any remaining `user` data
			delete data_user.cache[ elem[ data_user.expando ] ];
		}
	}
});

jQuery.fn.extend({
	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each(function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				});
		}, null, value, arguments.length );
	},

	append: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		});
	},

	prepend: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		});
	},

	before: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		});
	},

	after: function() {
		return this.domManip( arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		});
	},

	remove: function( selector, keepData /* Internal Use Only */ ) {
		var elem,
			elems = selector ? jQuery.filter( selector, this ) : this,
			i = 0;

		for ( ; (elem = elems[i]) != null; i++ ) {
			if ( !keepData && elem.nodeType === 1 ) {
				jQuery.cleanData( getAll( elem ) );
			}

			if ( elem.parentNode ) {
				if ( keepData && jQuery.contains( elem.ownerDocument, elem ) ) {
					setGlobalEval( getAll( elem, "script" ) );
				}
				elem.parentNode.removeChild( elem );
			}
		}

		return this;
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; (elem = this[i]) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map(function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		});
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = value.replace( rxhtmlTag, "<$1></$2>" );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var arg = arguments[ 0 ];

		// Make the changes, replacing each context element with the new content
		this.domManip( arguments, function( elem ) {
			arg = this.parentNode;

			jQuery.cleanData( getAll( this ) );

			if ( arg ) {
				arg.replaceChild( elem, this );
			}
		});

		// Force removal if there was no new content (e.g., from empty arguments)
		return arg && (arg.length || arg.nodeType) ? this : this.remove();
	},

	detach: function( selector ) {
		return this.remove( selector, true );
	},

	domManip: function( args, callback ) {

		// Flatten any nested arrays
		args = concat.apply( [], args );

		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = this.length,
			set = this,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );

		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return this.each(function( index ) {
				var self = set.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				self.domManip( args, callback );
			});
		}

		if ( l ) {
			fragment = jQuery.buildFragment( args, this[ 0 ].ownerDocument, false, this );
			first = fragment.firstChild;

			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}

			if ( first ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;

				// Use the original fragment for the last item instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;

					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );

						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
							// Support: QtWebKit
							// jQuery.merge because push.apply(_, arraylike) throws
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}

					callback.call( this[ i ], node, i );
				}

				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;

					// Reenable scripts
					jQuery.map( scripts, restoreScript );

					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!data_priv.access( node, "globalEval" ) && jQuery.contains( doc, node ) ) {

							if ( node.src ) {
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
							}
						}
					}
				}
			}
		}

		return this;
	}
});

jQuery.each({
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
});


var iframe,
	elemdisplay = {};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */
// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var style,
		elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		// getDefaultComputedStyle might be reliably used only on attached element
		display = window.getDefaultComputedStyle && ( style = window.getDefaultComputedStyle( elem[ 0 ] ) ) ?

			// Use of this method is a temporary fix (more like optimization) until something better comes along,
			// since it was removed from specification and supported only in FF
			style.display : jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = (iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" )).appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = (/^margin/);

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {
		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		if ( elem.ownerDocument.defaultView.opener ) {
			return elem.ownerDocument.defaultView.getComputedStyle( elem, null );
		}

		return window.getComputedStyle( elem, null );
	};



function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];
	}

	if ( computed ) {

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// Support: iOS < 6
		// A tribute to the "awesome hack by Dean Edwards"
		// iOS < 6 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
		// this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
		if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?
		// Support: IE
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {
	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {
				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return (this.get = hookFn).apply( this, arguments );
		}
	};
}


(function() {
	var pixelPositionVal, boxSizingReliableVal,
		docElem = document.documentElement,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;" +
		"position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computePixelPositionAndBoxSizingReliable() {
		div.style.cssText =
			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;" +
			"box-sizing:border-box;display:block;margin-top:1%;top:1%;" +
			"border:1px;padding:1px;width:4px;position:absolute";
		div.innerHTML = "";
		docElem.appendChild( container );

		var divStyle = window.getComputedStyle( div, null );
		pixelPositionVal = divStyle.top !== "1%";
		boxSizingReliableVal = divStyle.width === "4px";

		docElem.removeChild( container );
	}

	// Support: node.js jsdom
	// Don't assume that getComputedStyle is a property of the global object
	if ( window.getComputedStyle ) {
		jQuery.extend( support, {
			pixelPosition: function() {

				// This test is executed only once but we still do memoizing
				// since we can use the boxSizingReliable pre-computing.
				// No need to check if the test was already performed, though.
				computePixelPositionAndBoxSizingReliable();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				if ( boxSizingReliableVal == null ) {
					computePixelPositionAndBoxSizingReliable();
				}
				return boxSizingReliableVal;
			},
			reliableMarginRight: function() {

				// Support: Android 2.3
				// Check if div with explicit width and no margin-right incorrectly
				// gets computed margin-right based on width of container. (#3333)
				// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
				// This support function is only executed once so no memoizing is needed.
				var ret,
					marginDiv = div.appendChild( document.createElement( "div" ) );

				// Reset CSS: box-sizing; display; margin; border; padding
				marginDiv.style.cssText = div.style.cssText =
					// Support: Firefox<29, Android 2.3
					// Vendor-prefix box-sizing
					"-webkit-box-sizing:content-box;-moz-box-sizing:content-box;" +
					"box-sizing:content-box;display:block;margin:0;border:0;padding:0";
				marginDiv.style.marginRight = marginDiv.style.width = "0";
				div.style.width = "1px";
				docElem.appendChild( container );

				ret = !parseFloat( window.getComputedStyle( marginDiv, null ).marginRight );

				docElem.removeChild( container );
				div.removeChild( marginDiv );

				return ret;
			}
		});
	}
})();


// A method for quickly swapping in/out CSS properties to get correct calculations.
jQuery.swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var
	// Swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rnumsplit = new RegExp( "^(" + pnum + ")(.*)$", "i" ),
	rrelNum = new RegExp( "^([+-])=(" + pnum + ")", "i" ),

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ];

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( style, name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in style ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[0].toUpperCase() + name.slice(1),
		origName = name,
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in style ) {
			return name;
		}
	}

	return origName;
}

function setPositiveNumber( elem, value, subtract ) {
	var matches = rnumsplit.exec( value );
	return matches ?
		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?
		// If we already have the right measurement, avoid augmentation
		4 :
		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {
		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {
			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {
			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {
		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test(val) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = data_priv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {
			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = data_priv.access( elem, "olddisplay", defaultDisplay(elem.nodeName) );
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				data_priv.set( elem, "olddisplay", hidden ? display : jQuery.css( elem, "display" ) );
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend({

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && (ret = rrelNum.exec( value )) ) {
				value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number, add 'px' to the (except for certain CSS properties)
			if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
				value += "px";
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
				style[ name ] = value;
			}

		} else {
			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || jQuery.isNumeric( num ) ? num || 0 : val;
		}
		return val;
	}
});

jQuery.each([ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) && elem.offsetWidth === 0 ?
					jQuery.swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, name, extra );
					}) :
					getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var styles = extra && getStyles( elem );
			return setPositiveNumber( elem, value, extra ?
				augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				) : 0
			);
		}
	};
});

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return jQuery.swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each({
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
});

jQuery.fn.extend({
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each(function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		});
	}
});


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || "swing";
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			if ( tween.elem[ tween.prop ] != null &&
				(!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );
			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {
			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	}
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rfxnum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" ),
	rrun = /queueHooks$/,
	animationPrefilters = [ defaultPrefilter ],
	tweeners = {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value ),
				target = tween.cur(),
				parts = rfxnum.exec( value ),
				unit = parts && parts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

				// Starting value computation is required for potential unit mismatches
				start = ( jQuery.cssNumber[ prop ] || unit !== "px" && +target ) &&
					rfxnum.exec( jQuery.css( tween.elem, prop ) ),
				scale = 1,
				maxIterations = 20;

			if ( start && start[ 3 ] !== unit ) {
				// Trust units reported by jQuery.css
				unit = unit || start[ 3 ];

				// Make sure we update the tween properties later on
				parts = parts || [];

				// Iteratively approximate from a nonzero starting point
				start = +target || 1;

				do {
					// If previous iteration zeroed out, double until we get *something*.
					// Use string for doubling so we don't accidentally see scale as unchanged below
					scale = scale || ".5";

					// Adjust and apply
					start = start / scale;
					jQuery.style( tween.elem, prop, start + unit );

				// Update scale, tolerating zero or NaN from tween.cur(),
				// break the loop if scale is unchanged or perfect, or if we've just had enough
				} while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
			}

			// Update tween properties
			if ( parts ) {
				start = tween.start = +start || +target || 0;
				tween.unit = unit;
				// If a +=/-= token was provided, we're doing a relative animation
				tween.end = parts[ 1 ] ?
					start + ( parts[ 1 ] + 1 ) * parts[ 2 ] :
					+parts[ 2 ];
			}

			return tween;
		} ]
	};

// Animations created synchronously will run synchronously
function createFxNow() {
	setTimeout(function() {
		fxNow = undefined;
	});
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( (tween = collection[ index ].call( animation, prop, value )) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = data_priv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always(function() {
			// Ensure the complete handler is called before this completes
			anim.always(function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			});
		});
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			data_priv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always(function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		});
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = data_priv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done(function() {
				jQuery( elem ).hide();
			});
		}
		anim.done(function() {
			var prop;

			data_priv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		});
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( (display === "none" ? defaultDisplay( elem.nodeName ) : display) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = animationPrefilters.length,
		deferred = jQuery.Deferred().always( function() {
			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ]);

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise({
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, { specialEasing: {} }, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,
					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		}),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		})
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.split(" ");
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			tweeners[ prop ] = tweeners[ prop ] || [];
			tweeners[ prop ].unshift( callback );
		}
	},

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			animationPrefilters.unshift( callback );
		} else {
			animationPrefilters.push( callback );
		}
	}
});

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
		opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend({
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {
				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || data_priv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each(function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = data_priv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		});
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each(function() {
			var index,
				data = data_priv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		});
	}
});

jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
});

// Generate shortcuts for custom animations
jQuery.each({
	slideDown: genFx("show"),
	slideUp: genFx("hide"),
	slideToggle: genFx("toggle"),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
});

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];
		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;

jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	clearInterval( timerId );
	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,
	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = setTimeout( next, time );
		hooks.stop = function() {
			clearTimeout( timeout );
		};
	});
};


(function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
})();


var nodeHook, boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend({
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each(function() {
			jQuery.removeAttr( this, name );
		});
	}
});

jQuery.extend({
	attr: function( elem, name, value ) {
		var hooks, ret,
			nType = elem.nodeType;

		// don't get/set attributes on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === strundefined ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : nodeHook );
		}

		if ( value !== undefined ) {

			if ( value === null ) {
				jQuery.removeAttr( elem, name );

			} else if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
				return ret;

			} else {
				elem.setAttribute( name, value + "" );
				return value;
			}

		} else if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
			return ret;

		} else {
			ret = jQuery.find.attr( elem, name );

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ?
				undefined :
				ret;
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( (name = attrNames[i++]) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {
					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	}
});

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {
			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {
			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
});




var rfocusable = /^(?:input|select|textarea|button)$/i;

jQuery.fn.extend({
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each(function() {
			delete this[ jQuery.propFix[ name ] || name ];
		});
	}
});

jQuery.extend({
	propFix: {
		"for": "htmlFor",
		"class": "className"
	},

	prop: function( elem, name, value ) {
		var ret, hooks, notxml,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		notxml = nType !== 1 || !jQuery.isXMLDoc( elem );

		if ( notxml ) {
			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			return hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ?
				ret :
				( elem[ name ] = value );

		} else {
			return hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ?
				ret :
				elem[ name ];
		}
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {
				return elem.hasAttribute( "tabindex" ) || rfocusable.test( elem.nodeName ) || elem.href ?
					elem.tabIndex :
					-1;
			}
		}
	}
});

if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		}
	};
}

jQuery.each([
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
});




var rclass = /[\t\r\n\f]/g;

jQuery.fn.extend({
	addClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).addClass( value.call( this, j, this.className ) );
			});
		}

		if ( proceed ) {
			// The disjunction here is for better compressibility (see removeClass)
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					" "
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, clazz, j, finalValue,
			proceed = arguments.length === 0 || typeof value === "string" && value,
			i = 0,
			len = this.length;

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( j ) {
				jQuery( this ).removeClass( value.call( this, j, this.className ) );
			});
		}
		if ( proceed ) {
			classes = ( value || "" ).match( rnotwhite ) || [];

			for ( ; i < len; i++ ) {
				elem = this[ i ];
				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( elem.className ?
					( " " + elem.className + " " ).replace( rclass, " " ) :
					""
				);

				if ( cur ) {
					j = 0;
					while ( (clazz = classes[j++]) ) {
						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) >= 0 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = value ? jQuery.trim( cur ) : "";
					if ( elem.className !== finalValue ) {
						elem.className = finalValue;
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each(function( i ) {
				jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
			});
		}

		return this.each(function() {
			if ( type === "string" ) {
				// Toggle individual class names
				var className,
					i = 0,
					self = jQuery( this ),
					classNames = value.match( rnotwhite ) || [];

				while ( (className = classNames[ i++ ]) ) {
					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( type === strundefined || type === "boolean" ) {
				if ( this.className ) {
					// store className if set
					data_priv.set( this, "__className__", this.className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				this.className = this.className || value === false ? "" : data_priv.get( this, "__className__" ) || "";
			}
		});
	},

	hasClass: function( selector ) {
		var className = " " + selector + " ",
			i = 0,
			l = this.length;
		for ( ; i < l; i++ ) {
			if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
				return true;
			}
		}

		return false;
	}
});




var rreturn = /\r/g;

jQuery.fn.extend({
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[0];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?
					// Handle most common string cases
					ret.replace(rreturn, "") :
					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each(function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				});
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		});
	}
});

jQuery.extend({
	valHooks: {
		option: {
			get: function( elem ) {
				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :
					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					jQuery.trim( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE6-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&
							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ? !option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( (option.selected = jQuery.inArray( option.value, values ) >= 0) ) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
});

// Radios and checkboxes getter/setter
jQuery.each([ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute("value") === null ? "on" : elem.value;
		};
	}
});




// Return jQuery for attributes-only inclusion


jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
});

jQuery.fn.extend({
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	},

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {
		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	}
});


var nonce = jQuery.now();

var rquery = (/\?/);



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, tmp;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		tmp = new DOMParser();
		xml = tmp.parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,
	rurl = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Document location
	ajaxLocation = window.location.href,

	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {
			// For each dataType in the dataTypeExpression
			while ( (dataType = dataTypes[i++]) ) {
				// Prepend if requested
				if ( dataType[0] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					(structure[ dataType ] = structure[ dataType ] || []).unshift( func );

				// Otherwise append
				} else {
					(structure[ dataType ] = structure[ dataType ] || []).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[ dataTypeOrTransport ] ) {
				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		});
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || (deep = {}) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {
		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}
		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},
		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {
								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s[ "throws" ] ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend({

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: ajaxLocation,
		type: "GET",
		isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /xml/,
			html: /html/,
			json: /json/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,
			// URL without anti-cache param
			cacheURL,
			// Response headers
			responseHeadersString,
			responseHeaders,
			// timeout handle
			timeoutTimer,
			// Cross-domain detection vars
			parts,
			// To know if global events are to be dispatched
			fireGlobals,
			// Loop variable
			i,
			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),
			// Callbacks context
			callbackContext = s.context || s,
			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && ( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,
			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks("once memory"),
			// Status-dependent callbacks
			statusCode = s.statusCode || {},
			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},
			// The jqXHR state
			state = 0,
			// Default abort message
			strAbort = "canceled",
			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( (match = rheaders.exec( responseHeadersString )) ) {
								responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {
								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {
							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || ajaxLocation ) + "" ).replace( rhash, "" )
			.replace( rprotocol, ajaxLocParts[ 1 ] + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when we have a protocol:host:port mismatch
		if ( s.crossDomain == null ) {
			parts = rurl.exec( s.url.toLowerCase() );
			s.crossDomain = !!( parts &&
				( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
					( parts[ 3 ] || ( parts[ 1 ] === "http:" ? "80" : "443" ) ) !==
						( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? "80" : "443" ) ) )
			);
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger("ajaxStart");
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );
				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
				s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}
			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = setTimeout(function() {
					jqXHR.abort("timeout");
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {
				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );
				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader("Last-Modified");
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader("etag");
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {
				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger("ajaxStop");
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
});

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {
		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		return jQuery.ajax({
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		});
	};
});


jQuery._evalUrl = function( url ) {
	return jQuery.ajax({
		url: url,
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	});
};


jQuery.fn.extend({
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapAll( html.call(this, i) );
			});
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map(function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			}).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each(function( i ) {
				jQuery( this ).wrapInner( html.call(this, i) );
			});
		}

		return this.each(function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		});
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each(function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
		});
	},

	unwrap: function() {
		return this.parent().each(function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		}).end();
	}
});


jQuery.expr.filters.hidden = function( elem ) {
	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	return elem.offsetWidth <= 0 && elem.offsetHeight <= 0;
};
jQuery.expr.filters.visible = function( elem ) {
	return !jQuery.expr.filters.hidden( elem );
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {
		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {
				// Treat each array item as a scalar.
				add( prefix, v );

			} else {
				// Item is non-scalar (array or object), encode its numeric index.
				buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
			}
		});

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {
		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {
		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {
			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		});

	} else {
		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend({
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map(function() {
			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		})
		.filter(function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		})
		.map(function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					}) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		}).get();
	}
});


jQuery.ajaxSettings.xhr = function() {
	try {
		return new XMLHttpRequest();
	} catch( e ) {}
};

var xhrId = 0,
	xhrCallbacks = {},
	xhrSuccessStatus = {
		// file protocol always yields status code 0, assume 200
		0: 200,
		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

// Support: IE9
// Open requests must be manually aborted on unload (#5280)
// See https://support.microsoft.com/kb/2856746 for more info
if ( window.attachEvent ) {
	window.attachEvent( "onunload", function() {
		for ( var key in xhrCallbacks ) {
			xhrCallbacks[ key ]();
		}
	});
}

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport(function( options ) {
	var callback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr(),
					id = ++xhrId;

				xhr.open( options.type, options.url, options.async, options.username, options.password );

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers["X-Requested-With"] ) {
					headers["X-Requested-With"] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							delete xhrCallbacks[ id ];
							callback = xhr.onload = xhr.onerror = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {
								complete(
									// file: protocol always yields status 0; see #8605, #14207
									xhr.status,
									xhr.statusText
								);
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,
									// Support: IE9
									// Accessing binary-data responseText throws an exception
									// (#11426)
									typeof xhr.responseText === "string" ? {
										text: xhr.responseText
									} : undefined,
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				xhr.onerror = callback("error");

				// Create the abort callback
				callback = xhrCallbacks[ id ] = callback("abort");

				try {
					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {
					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




// Install script dataType
jQuery.ajaxSetup({
	accepts: {
		script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /(?:java|ecma)script/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
});

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
});

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {
	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery("<script>").prop({
					async: true,
					charset: s.scriptCharset,
					src: s.url
				}).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
});




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup({
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
});

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" && !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") && rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters["script json"] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always(function() {
			// Restore preexisting value
			window[ callbackName ] = overwritten;

			// Save back as free
			if ( s[ callbackName ] ) {
				// make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		});

		// Delegate to script
		return "script";
	}
});




// data: string of html
// context (optional): If specified, the fragment will be created in this context, defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[1] ) ];
	}

	parsed = jQuery.buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf(" ");

	if ( off >= 0 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax({
			url: url,

			// if "type" variable is undefined, then "GET" method will be used
			type: type,
			dataType: "html",
			data: params
		}).done(function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		}).complete( callback && function( jqXHR, status ) {
			self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
		});
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [ "ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend" ], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
});




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep(jQuery.timers, function( fn ) {
		return elem === fn.elem;
	}).length;
};




var docElem = window.document.documentElement;

/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf("auto") > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {
			options = options.call( elem, i, curOffset );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend({
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each(function( i ) {
					jQuery.offset.setOffset( this, options, i );
				});
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		// Support: BlackBerry 5, iOS 3 (original iPhone)
		// If we don't have gBCR, just use 0,0 rather than error
		if ( typeof elem.getBoundingClientRect !== strundefined ) {
			box = elem.getBoundingClientRect();
		}
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0}, because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {
			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {
			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	offsetParent: function() {
		return this.map(function() {
			var offsetParent = this.offsetParent || docElem;

			while ( offsetParent && ( !jQuery.nodeName( offsetParent, "html" ) && jQuery.css( offsetParent, "position" ) === "static" ) ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || docElem;
		});
	}
});

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : window.pageXOffset,
					top ? val : window.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length, null );
	};
});

// Support: Safari<7+, Chrome<37+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );
				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
});


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {
					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?
					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	});
});


// The number of elements contained in the matched element set
jQuery.fn.size = function() {
	return this.length;
};

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var
	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === strundefined ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;

}));


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__ = __webpack_require__(128);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose_js__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ReactBridge = __webpack_require__(137);
    var _ = __webpack_require__(1),
        Marionette = __webpack_require__(10),
        Configuration = __webpack_require__(27),
        DefaultFooterView = __webpack_require__(1512);
    var AnalyticsPropertiesView = __webpack_require__(1514).default;
    var OnLoadAction = __webpack_require__(1681).default;
    var BehaviorSettings = __webpack_require__(1686).default;
    /**
     * Improved Marionette Layout/ItemView with some extra options.
     *
     * @author Bo Gotthardt
     * @class ImprovedView
     */
    return Marionette.Layout.extend({

        _subModelEvents: null,

        constructor: function constructor() {
            // Inject configuration into template helpers...
            if (_.isFunction(this.templateHelpers)) {
                var _templateHelpers = this.templateHelpers.bind(this);
                this.templateHelpers = function () {
                    var helpers = _templateHelpers();
                    helpers.config = Configuration; // TODO: we should  also inject Permissions

                    return helpers;
                };

                // May be an object, or not set at all...
            } else {
                if (!this.templateHelpers) {
                    this.templateHelpers = {};
                }

                this.templateHelpers.config = Configuration; // TODO: ditto
            }

            this.listenTo(this, "item:rendered", function () {
                // Add support for the default footer view
                if (this.defaultFooterRegion) {
                    this.defaultFooterRegion.show(new DefaultFooterView());
                }
            });

            // Setup any "sub model events"
            this._setupSubModelEvents();

            // Invoke super constructor
            this.__super();
        },

        append: function append(child, container) {
            container = container || this.$el;

            if (_.isFunction(child.render)) {
                child = child.render().$el;
            }

            container.append(child);
        },

        _setupSubModelEvents: function _setupSubModelEvents() {
            this._subModelEvents = [];

            _.each(Marionette.getOption(this, "modelEvents"), function (method, eventName) {
                var i = eventName.indexOf(".");

                if (i > -1) {
                    var subModelPropertyName = eventName.substring(0, i),
                        subModelEventName = eventName.substring(i + 1, eventName.length),
                        bindings = {};

                    bindings[subModelEventName] = method;

                    this._subModelEvents.push({
                        subModelPropertyName: subModelPropertyName,
                        subModelEventName: subModelEventName,
                        bindings: bindings
                    });
                }
            }, this);
        },

        /**
         * Add Analytics label
         */
        _setAnalyticsLabel: function _setAnalyticsLabel(_ref) {
            var widgetModel = _ref.model;

            var emailModeChangeWidgetEvent = "emailModeChange";
            var experienceModel = this.viewScope.viewModel.get("experience");
            this.listenTo(experienceModel, "change:emailModeEnabled", function () {
                widgetModel.trigger(emailModeChangeWidgetEvent);
            });
            var getScopedProps = function getScopedProps(_ref2) {
                var model = _ref2.model,
                    experience = _ref2.experience;

                var currentAnalytics = model.get("analytics") || {};
                var emailModeEnabled = experience.get("emailModeEnabled");
                return {
                    onChange: function onChange(value) {
                        var analytics = { label: value };
                        model.set("analytics", analytics);
                    },
                    labelValue: currentAnalytics.label,
                    emailModeEnabled: emailModeEnabled
                };
            };

            return ReactBridge.viewFromComponent(AnalyticsPropertiesView, {
                model: widgetModel,
                experience: experienceModel,
                observe: {
                    model: ["change", emailModeChangeWidgetEvent]
                },
                getProps: getScopedProps
            });
        },
        _setBehaviorAction: function _setBehaviorAction(_ref3) {
            var widgetModel = _ref3.model;

            var experienceModel = this.viewScope.viewModel.get("experience");
            var getScopedProps = function getScopedProps() {
                var _require = __webpack_require__(551),
                    mapWidgetMetaData = _require.mapWidgetMetaData;

                return {
                    getExperience: function getExperience() {
                        return experienceModel.toJSON();
                    },
                    notifyParent: function notifyParent(expJson, state) {
                        experienceModel.set("behaviors", expJson.behaviors);
                        experienceModel.set("behaviorConfig", expJson.behaviorConfig);
                        if (state === "saved") {
                            experienceModel.trigger("behaviorSaved");
                        }
                    },
                    getBaseUrl: function getBaseUrl() {
                        return {"env":"PROD","cncViewFullBaseUrl":"https://cnc-api.zmags.com/view/full/","cncViewLiteBaseUrl":"https://cnc-api.zmags.com/view/lite/","psdImportBaseUrl":"https://design-file-import.creator-prod.zmags.com","behaviorUiBaseUrl":"https://behaviors.zmags.com","creatorSettingApiBaseUrl":"https://creator-settings.api.zmags.com","c3ApibaseUrl":"https://contentcontrol.api.zmags.com","adminApiBaseUrl":"https://creator-api.zmags.com","editorBaseUrl":"//creator.zmags.com","viewerBaseUrl":"//c.zmags.com","viewerApiBaseUrl":"//c.zmags.com","cncStaticAssetsBaseUrl":"//c.zmags.com/static/","cncStaticAssetsFiles":["client.js","manifest.js","vendor.js","styles.css"],"cncSsrApiBaseUrl":"//c.zmags.com","viewerAliasApiBaseUrl":"//creator.zmags.com","communityBaseUrl":"https://creatorcommunity.zmags.com","errorQueueUrl":"https://c.zmags.com/queue/error/","statsDUrl":"https://statsd.zmags.com/stats","auth0Domain":"https://zmags.us.auth0.com","auth0Audience":"https://api.zmags.com/","auth0ClientId":"XGTeepJiX2c78VRgP8OFxN0Mf4kggvby","ometriaApiUrl":"https://ometria.api.zmags.com/v1/email/generate","klaviyoApiUrl":"https://klaviyo.api.zmags.com/v1/email/generate","sfmcApiUrl":"https://sfmc.api.zmags.com/v1/email/generate","cloudinaryProviderUrl":"https://images.creator-prod.zmags.com/image/upload","salesEmail":"sales@zmags.com","supportEmail":"support@zmags.com","editorSegmentIOKey":"20jbiv8frx","matomoConfig":{"trackingScriptUrl":"//c.z-analytics.net/reporting/optimize/ztracker.js","trackerUrl":"","dashboardUrl":"//auth.reporting.creator-prod.zmags.com","segmentUrl":"//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php","siteID":1},"zsitesConfig":"//auth.reporting.creator-prod.zmags.com/","zsitesSecret":"zM4gzS3cr3t","inventoryUrl":"https://authproxy.creator-prod.zmags.com/inventory/v1/products/map","answerFileUrl":"https://static.inventory.creator-prod.zmags.com/dynamic_pricing/answer_files/","experienceUrl2PngBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/experience/signed/url2png/","experienceSharedEntityBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/sharedEntity/","msExperiencesUrl":"https://authproxy.creator-prod.zmags.com/experiences","microserviceCompanyUrl":"https://authproxy.creator-prod.zmags.com/company/","proxyUrl":"https://authproxy.creator-prod.zmags.com","forgotPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","resetPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","changePasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithTokenBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithSsoBaseUrl":"https://authproxy.creator-prod.zmags.com","loginActiveDirectoryBaseUrl":"https://creator-api.zmags.com","googleWebFontsApiBaseUrl":"https://www.googleapis.com/webfonts/v1/webfonts","googleWebFontsApiKey":"AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI","casUrl":"https://cas.zma.gs/","contentControlUrl":"https://manage.creatorbyzmags.com/","enableLogging":1,"logId":null,"trackErrors":true,"sentryEnabled":true,"sentryDSN":"https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460","experienceId":null,"groupId":null,"scene":null,"statsDBucket":"creator.prod","version":"livadug4","maxRetries":3}.behaviorUiBaseUrl;
                    }
                };
            };
            return ReactBridge.viewFromComponent(BehaviorSettings, {
                model: widgetModel,
                experience: experienceModel,
                getProps: getScopedProps
            });
        },
        _setOnLoadAction: function _setOnLoadAction(_ref4) {
            var widgetModel = _ref4.model;

            var emailModeChangeWidgetEvent = "emailModeChange";
            var experienceModel = this.viewScope.viewModel.get("experience");
            this.listenTo(experienceModel, "change:emailModeEnabled", function () {
                widgetModel.trigger(emailModeChangeWidgetEvent);
            });
            var getScopedProps = function getScopedProps(_ref5) {
                var model = _ref5.model;

                var currentOnLoadJs = model.get("onloadJs") || {};
                var name = currentOnLoadJs.name ? currentOnLoadJs.name : "";
                var parameters = currentOnLoadJs.parameters ? currentOnLoadJs.parameters : {};
                var params = !_.isEmpty(parameters) ? Object.keys(parameters).map(function (el) {
                    return { paramLabel: el, paramValue: parameters[el] };
                }) : [];
                return {
                    onChange: function onChange(value) {
                        // Holds all the paramLabel and their respective value that are used to keep the state in sync with the props
                        var params = [];

                        if (value.label === "None") {
                            model.set("onloadJs", null);
                            value.model = null;
                        }

                        if (value.model) {
                            var attr = value.model,
                                onloadJs = {
                                type: attr.type,
                                code: attr.code,
                                actionId: attr.actionId,
                                name: value.label,
                                parameters: attr.parameters
                            };
                            model.set("onloadJs", onloadJs);

                            // If the parameters are not empty than transform it to params[] i.e. {key: paramLabel, key: paramValue}
                            if (!_.isEmpty(onloadJs.parameters)) {
                                params = Object.keys(onloadJs.parameters).map(function (el) {
                                    return { paramLabel: el, paramValue: onloadJs.parameters[el] };
                                });
                            }
                        }
                        return params;
                    },
                    name: name,
                    parameters: parameters,
                    params: params
                };
            };

            return ReactBridge.viewFromComponent(OnLoadAction, {
                model: widgetModel,
                experience: experienceModel,
                observe: { model: ["change", emailModeChangeWidgetEvent] },
                getProps: getScopedProps
            });
        },


        delegateEvents: function delegateEvents() {
            Marionette.Layout.prototype.delegateEvents.apply(this, _.toArray(arguments));

            _.each(this._subModelEvents, function (descriptor) {
                Marionette.bindEntityEvents(this, this.model[descriptor.subModelPropertyName], descriptor.bindings);
            }, this);
        },

        undelegateEvents: function undelegateEvents() {
            Marionette.Layout.prototype.undelegateEvents.apply(this, _.toArray(arguments));

            _.each(this._subModelEvents, function (descriptor) {
                Marionette.unbindEntityEvents(this, this.model[descriptor.subModelPropertyName], descriptor.bindings);
            }, this);
        },

        toString: function toString() {
            return "ImprovedView[cid: " + this.cid + "]";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

//     Backbone.js 1.0.0

//     (c) 2010-2013 Jeremy Ashkenas, DocumentCloud Inc.
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(){

  // Initial Setup
  // -------------

  // Save a reference to the global object (`window` in the browser, `exports`
  // on the server).
  var root = this;

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create local references to array methods we'll want to use later.
  var array = [];
  var push = array.push;
  var slice = array.slice;
  var splice = array.splice;

  // The top-level namespace. All public Backbone classes and modules will
  // be attached to this. Exported for both the browser and the server.
  var Backbone;
  if (true) {
    Backbone = exports;
  } else {
    Backbone = root.Backbone = {};
  }

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.0.0';

  // Require Underscore, if we're on the server, and it's not already present.
  var _ = root._;
  if (!_ && ("function" !== 'undefined')) _ = __webpack_require__(1);

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = root.jQuery || root.Zepto || root.ender || root.$;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // custom events. You may bind with `on` or remove with `off` callback
  // functions to an event; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {

    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
      if (!eventsApi(this, 'on', name, [callback, context]) || !callback) return this;
      this._events || (this._events = {});
      var events = this._events[name] || (this._events[name] = []);
      events.push({callback: callback, context: context, ctx: context || this});
      return this;
    },

    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
      if (!eventsApi(this, 'once', name, [callback, context]) || !callback) return this;
      var self = this;
      var once = _.once(function() {
        self.off(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
      return this.on(name, once, context);
    },

    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
      var retain, ev, events, names, i, l, j, k;
      if (!this._events || !eventsApi(this, 'off', name, [callback, context])) return this;
      if (!name && !callback && !context) {
        this._events = {};
        return this;
      }

      names = name ? [name] : _.keys(this._events);
      for (i = 0, l = names.length; i < l; i++) {
        name = names[i];
        if (events = this._events[name]) {
          this._events[name] = retain = [];
          if (callback || context) {
            for (j = 0, k = events.length; j < k; j++) {
              ev = events[j];
              if ((callback && callback !== ev.callback && callback !== ev.callback._callback) ||
                  (context && context !== ev.context)) {
                retain.push(ev);
              }
            }
          }
          if (!retain.length) delete this._events[name];
        }
      }

      return this;
    },

    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
      if (!this._events) return this;
      var args = slice.call(arguments, 1);
      if (!eventsApi(this, 'trigger', name, args)) return this;
      var events = this._events[name];
      var allEvents = this._events.all;
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, arguments);
      return this;
    },

    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
      var listeners = this._listeners;
      if (!listeners) return this;
      var deleteListener = !name && !callback;
      if (typeof name === 'object') callback = this;
      if (obj) (listeners = {})[obj._listenerId] = obj;
      for (var id in listeners) {
        listeners[id].off(name, callback, this);
        if (deleteListener) delete this._listeners[id];
      }
      return this;
    }

  };

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Implement fancy features of the Events API such as multiple event
  // names `"change blur"` and jQuery-style event maps `{change: action}`
  // in terms of the existing API.
  var eventsApi = function(obj, action, name, rest) {
    if (!name) return true;

    // Handle event maps.
    if (typeof name === 'object') {
      for (var key in name) {
        obj[action].apply(obj, [key, name[key]].concat(rest));
      }
      return false;
    }

    // Handle space separated event names.
    if (eventSplitter.test(name)) {
      var names = name.split(eventSplitter);
      for (var i = 0, l = names.length; i < l; i++) {
        obj[action].apply(obj, [names[i]].concat(rest));
      }
      return false;
    }

    return true;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args);
    }
  };

  var listenMethods = {listenTo: 'on', listenToOnce: 'once'};

  // Inversion-of-control versions of `on` and `once`. Tell *this* object to
  // listen to an event in another object ... keeping track of what it's
  // listening to.
  _.each(listenMethods, function(implementation, method) {
    Events[method] = function(obj, name, callback) {
      var listeners = this._listeners || (this._listeners = {});
      var id = obj._listenerId || (obj._listenerId = _.uniqueId('l'));
      listeners[id] = obj;
      if (typeof name === 'object') callback = this;
      obj[implementation](name, callback, this);
      return this;
    };
  });

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var defaults;
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId('c');
    this.attributes = {};
    _.extend(this, _.pick(options, modelOptions));
    if (options.parse) attrs = this.parse(attrs, options) || {};
    if (defaults = _.result(this, 'defaults')) {
      attrs = _.defaults({}, attrs, defaults);
    }
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // A list of options to be attached directly to the model, if provided.
  var modelOptions = ['url', 'urlRoot', 'collection'];

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      var attr, attrs, unset, changes, silent, changing, prev, current;
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      unset           = options.unset;
      silent          = options.silent;
      changes         = [];
      changing        = this._changing;
      this._changing  = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }
      current = this.attributes, prev = this._previousAttributes;

      // Check for changes of `id`.
      if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

      // For each `set` attribute, update or delete the current value.
      for (attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          this.changed[attr] = val;
        } else {
          delete this.changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = true;
        for (var i = 0, l = changes.length; i < l; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var val, changed = false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      for (var attr in diff) {
        if (_.isEqual(old[attr], (val = diff[attr]))) continue;
        (changed || (changed = {}))[attr] = val;
      }
      return changed;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        if (!model.set(model.parse(resp, options), options)) return false;
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      var attrs, method, xhr, attributes = this.attributes;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      // If we're not waiting and attributes exist, save acts as `set(attr).save(null, opts)`.
      if (attrs && (!options || !options.wait) && !this.set(attrs, options)) return false;

      options = _.extend({validate: true}, options);

      // Do not persist invalid models.
      if (!this._validate(attrs, options)) return false;

      // Set temporary attributes if `{wait: true}`.
      if (attrs && options.wait) {
        this.attributes = _.extend({}, attributes, attrs);
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      if (options.parse === void 0) options.parse = true;
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = model.parse(resp, options);
        if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
        if (_.isObject(serverAttrs) && !model.set(serverAttrs, options)) {
          return false;
        }
        if (success) success(model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch') options.attrs = attrs;
      xhr = this.sync(method, this, options);

      // Restore attributes.
      if (attrs && options.wait) this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;

      var destroy = function() {
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (options.wait || model.isNew()) destroy();
        if (success) success(model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      if (this.isNew()) {
        options.success();
        return false;
      }
      wrapError(this, options);

      var xhr = this.sync('delete', this, options);
      if (!options.wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base = _.result(this, 'urlRoot') || _.result(this.collection, 'url') || urlError();
      if (this.isNew()) return base;
      return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return this.id == null;
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend(options || {}, { validate: true }));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options || {}, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model.
  var modelMethods = ['keys', 'values', 'pairs', 'invert', 'pick', 'omit'];

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  _.each(modelMethods, function(method) {
    Model.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.attributes);
      return _[method].apply(_, args);
    };
  });

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analagous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.url) this.url = options.url;
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, merge: false, remove: false};

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model){ return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set.
    add: function(models, options) {
      return this.set(models, _.defaults(options || {}, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      models = _.isArray(models) ? models.slice() : [models];
      options || (options = {});
      var i, l, index, model;
      for (i = 0, l = models.length; i < l; i++) {
        model = this.get(models[i]);
        if (!model) continue;
        delete this._byId[model.id];
        delete this._byId[model.cid];
        index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;
        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }
        this._removeReference(model);
      }
      return this;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      options = _.defaults(options || {}, setOptions);
      if (options.parse) models = this.parse(models, options);
      if (!_.isArray(models)) models = models ? [models] : [];
      var i, l, model, attrs, existing, sort;
      var at = options.at;
      var sortable = this.comparator && (at == null) && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;
      var toAdd = [], toRemove = [], modelMap = {};

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      for (i = 0, l = models.length; i < l; i++) {
        if (!(model = this._prepareModel(models[i], options))) continue;

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        if (existing = this.get(model)) {
          if (options.remove) modelMap[existing.cid] = true;
          if (options.merge) {
            existing.set(model.attributes, options);
            if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
          }

        // This is a new model, push it to the `toAdd` list.
        } else if (options.add) {
          toAdd.push(model);

          // Listen to added models' events, and index models for lookup by
          // `id` and by `cid`.
          model.on('all', this._onModelEvent, this);
          this._byId[model.cid] = model;
          if (model.id != null) this._byId[model.id] = model;
        }
      }

      // Remove nonexistent models if appropriate.
      if (options.remove) {
        for (i = 0, l = this.length; i < l; ++i) {
          if (!modelMap[(model = this.models[i]).cid]) toRemove.push(model);
        }
        if (toRemove.length) this.remove(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      if (toAdd.length) {
        if (sortable) sort = true;
        this.length += toAdd.length;
        if (at != null) {
          splice.apply(this.models, [at, 0].concat(toAdd));
        } else {
          push.apply(this.models, toAdd);
        }
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      if (options.silent) return this;

      // Trigger `add` events.
      for (i = 0, l = toAdd.length; i < l; i++) {
        (model = toAdd[i]).trigger('add', model, this, options);
      }

      // Trigger `sort` if the collection was sorted.
      if (sort) this.trigger('sort', this, options);
      return this;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options || (options = {});
      for (var i = 0, l = this.models.length; i < l; i++) {
        this._removeReference(this.models[i]);
      }
      options.previousModels = this.models;
      this._reset();
      this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return this;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: this.length}, options));
      return model;
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      this.remove(model, options);
      return model;
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      model = this._prepareModel(model, options);
      this.add(model, _.extend({at: 0}, options));
      return model;
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      this.remove(model, options);
      return model;
    },

    // Slice out a sub-array of models from the collection.
    slice: function(begin, end) {
      return this.models.slice(begin, end);
    },

    // Get a model from the set by id.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj.id != null ? obj.id : obj.cid || obj];
    },

    // Get the model at the given index.
    at: function(index) {
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      if (_.isEmpty(attrs)) return first ? void 0 : [];
      return this[first ? 'find' : 'filter'](function(model) {
        for (var key in attrs) {
          if (attrs[key] !== model.get(key)) return false;
        }
        return true;
      });
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      // Run sort based on type of `comparator`.
      if (_.isString(this.comparator) || this.comparator.length === 1) {
        this.models = this.sortBy(this.comparator, this);
      } else {
        this.models.sort(_.bind(this.comparator, this));
      }

      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Figure out the smallest index at which a model should be inserted so as
    // to maintain order.
    sortedIndex: function(model, value, context) {
      value || (value = this.comparator);
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _.sortedIndex(this.models, model, iterator, context);
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return _.invoke(this.models, 'get', attr);
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = options ? _.clone(options) : {};
      if (options.parse === void 0) options.parse = true;
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success(collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      if (!(model = this._prepareModel(model, options))) return false;
      if (!options.wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(resp) {
        if (options.wait) collection.add(model, options);
        if (success) success(model, resp, options);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models);
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (attrs instanceof Model) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options || (options = {});
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model._validate(attrs, options)) {
        this.trigger('invalid', this, attrs, options);
        return false;
      }
      return model;
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model) {
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if ((event === 'add' || event === 'remove') && collection !== this) return;
      if (event === 'destroy') this.remove(model, options);
      if (model && event === 'change:' + model.idAttribute) {
        delete this._byId[model.previous(model.idAttribute)];
        if (model.id != null) this._byId[model.id] = model;
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var methods = ['forEach', 'each', 'map', 'collect', 'reduce', 'foldl',
    'inject', 'reduceRight', 'foldr', 'find', 'detect', 'filter', 'select',
    'reject', 'every', 'all', 'some', 'any', 'include', 'contains', 'invoke',
    'max', 'min', 'toArray', 'size', 'first', 'head', 'take', 'initial', 'rest',
    'tail', 'drop', 'last', 'without', 'indexOf', 'shuffle', 'lastIndexOf',
    'isEmpty', 'chain'];

  // Mix in each Underscore method as a proxy to `Collection#models`.
  _.each(methods, function(method) {
    Collection.prototype[method] = function() {
      var args = slice.call(arguments);
      args.unshift(this.models);
      return _[method].apply(_, args);
    };
  });

  // Underscore methods that take a property name as an argument.
  var attributeMethods = ['groupBy', 'countBy', 'sortBy'];

  // Use attributes instead of properties.
  _.each(attributeMethods, function(method) {
    Collection.prototype[method] = function(value, context) {
      var iterator = _.isFunction(value) ? value : function(model) {
        return model.get(value);
      };
      return _[method](this.models, iterator, context);
    };
  });

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    this._configure(options || {});
    this._ensureElement();
    this.initialize.apply(this, arguments);
    this.delegateEvents();
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be merged as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be prefered to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this.$el.remove();
      this.stopListening();
      return this;
    },

    // Change the view's element (`this.el` property), including event
    // re-delegation.
    setElement: function(element, delegate) {
      if (this.$el) this.undelegateEvents();
      this.$el = element instanceof Backbone.$ ? element : Backbone.$(element);
      this.el = this.$el[0];
      if (delegate !== false) this.delegateEvents();
      return this;
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save'
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
      if (!(events || (events = _.result(this, 'events')))) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[events[key]];
        if (!method) continue;

        var match = key.match(delegateEventSplitter);
        var eventName = match[1], selector = match[2];
        method = _.bind(method, this);
        eventName += '.delegateEvents' + this.cid;
        if (selector === '') {
          this.$el.on(eventName, method);
        } else {
          this.$el.on(eventName, selector, method);
        }
      }
      return this;
    },

    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // Performs the initial configuration of a View with a set of options.
    // Keys with special meaning *(e.g. model, collection, id, className)* are
    // attached directly to the view.  See `viewOptions` for an exhaustive
    // list.
    _configure: function(options) {
      if (this.options) options = _.extend({}, _.result(this, 'options'), options);
      _.extend(this, _.pick(options, viewOptions));
      this.options = options;
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        var $el = Backbone.$('<' + _.result(this, 'tagName') + '>').attr(attrs);
        this.setElement($el, false);
      } else {
        this.setElement(_.result(this, 'el'), false);
      }
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // If we're sending a `PATCH` request, and we're in an old Internet Explorer
    // that still has ActiveX enabled by default, override jQuery to use that
    // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
    if (params.type === 'PATCH' && window.ActiveXObject &&
          !(window.external && window.external.msActiveXFilteringEnabled)) {
      params.xhr = function() {
        return new ActiveXObject("Microsoft.XMLHTTP");
      };
    }

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch':  'PATCH',
    'delete': 'DELETE',
    'read':   'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        callback && callback.apply(router, args);
        router.trigger.apply(router, ['route:' + name].concat(args));
        router.trigger('route', name, args);
        Backbone.history.trigger('route', router, name, args);
      });
      return this;
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional){
                     return optional ? match : '([^\/]+)';
                   })
                   .replace(splatParam, '(.*?)');
      return new RegExp('^' + route + '$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param) {
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    _.bindAll(this, 'checkUrl');

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for detecting MSIE.
  var isExplorer = /msie [\w.]+/;

  // Cached regex for removing a trailing slash.
  var trailingSlash = /\/$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the cross-browser normalized URL fragment, either from the URL,
    // the hash, or the override.
    getFragment: function(fragment, forcePushState) {
      if (fragment == null) {
        if (this._hasPushState || !this._wantsHashChange || forcePushState) {
          fragment = this.location.pathname;
          var root = this.root.replace(trailingSlash, '');
          if (!fragment.indexOf(root)) fragment = fragment.substr(root.length);
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error("Backbone.history has already been started");
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({}, {root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.options.pushState && this.history && this.history.pushState);
      var fragment          = this.getFragment();
      var docMode           = document.documentMode;
      var oldIE             = (isExplorer.exec(navigator.userAgent.toLowerCase()) && (!docMode || docMode <= 7));

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      if (oldIE && this._wantsHashChange) {
        this.iframe = Backbone.$('<iframe src="javascript:0" tabindex="-1" />').hide().appendTo('body')[0].contentWindow;
        this.navigate(fragment);
      }

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._hasPushState) {
        Backbone.$(window).on('popstate', this.checkUrl);
      } else if (this._wantsHashChange && ('onhashchange' in window) && !oldIE) {
        Backbone.$(window).on('hashchange', this.checkUrl);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      // Determine if we need to change the base url, for a pushState link
      // opened by a non-pushState browser.
      this.fragment = fragment;
      var loc = this.location;
      var atRoot = loc.pathname.replace(/[^\/]$/, '$&/') === this.root;

      // If we've started off with a route from a `pushState`-enabled browser,
      // but we're currently in a browser that doesn't support it...
      if (this._wantsHashChange && this._wantsPushState && !this._hasPushState && !atRoot) {
        this.fragment = this.getFragment(null, true);
        this.location.replace(this.root + this.location.search + '#' + this.fragment);
        // Return immediately as browser will do redirect to new url
        return true;

      // Or if we've started out with a hash-based route, but we're currently
      // in a browser where it could be `pushState`-based instead...
      } else if (this._wantsPushState && this._hasPushState && atRoot && loc.hash) {
        this.fragment = this.getHash().replace(routeStripper, '');
        this.history.replaceState({}, document.title, this.root + this.fragment + loc.search);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      Backbone.$(window).off('popstate', this.checkUrl).off('hashchange', this.checkUrl);
      clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();
      if (current === this.fragment && this.iframe) {
        current = this.getFragment(this.getHash(this.iframe));
      }
      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl() || this.loadUrl(this.getHash());
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragmentOverride) {
      var fragment = this.fragment = this.getFragment(fragmentOverride);
      var matched = _.any(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
      return matched;
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: options};
      fragment = this.getFragment(fragment || '');
      if (this.fragment === fragment) return;
      this.fragment = fragment;
      var url = this.root + fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._hasPushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && (fragment !== this.getFragment(this.getHash(this.iframe)))) {
          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if(!options.replace) this.iframe.document.open().close();
          this._updateHash(this.iframe.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain, for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    // Add prototype properties (instance properties) to the subclass,
    // if supplied.
    if (protoProps) _.extend(child.prototype, protoProps);

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function (model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error(model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

}).call(this);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(315);




function withStyles(stylesOrCreator, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["g" /* withStyles */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
  }, options));
}

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x
			}
		}
	}
	return str;
});


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// MarionetteJS (Backbone.Marionette)
// ----------------------------------
// v1.7.4
//
// Copyright (c)2014 Derick Bailey, Muted Solutions, LLC.
// Distributed under MIT license
//
// http://marionettejs.com



/*!
 * Includes BabySitter
 * https://github.com/marionettejs/backbone.babysitter/
 *
 * Includes Wreqr
 * https://github.com/marionettejs/backbone.wreqr/
 */

(function (root, factory) {
  if (true) {

    var underscore = __webpack_require__(1);
    var backbone = __webpack_require__(7);
    var wreqr = __webpack_require__(1381);
    var babysitter = __webpack_require__(1382);

    module.exports = factory(underscore, backbone, wreqr, babysitter);

  } else if (typeof define === 'function' && define.amd) {

    define(['underscore', 'backbone', 'backbone.wreqr', 'backbone.babysitter'], factory);

  }
}(this, function (_, Backbone) {

  var Marionette = (function(global, Backbone, _){
  "use strict";

  // Define and export the Marionette namespace
  var Marionette = {};
  Backbone.Marionette = Marionette;

  // Get the DOM manipulator for later use
  Marionette.$ = Backbone.$;

// Helpers
// -------

// For slicing `arguments` in functions
var slice = Array.prototype.slice;

function throwError(message, name) {
  var error = new Error(message);
  error.name = name || 'Error';
  throw error;
}

// Marionette.extend
// -----------------

// Borrow the Backbone `extend` method so we can use it as needed
Marionette.extend = Backbone.Model.extend;

// Marionette.getOption
// --------------------

// Retrieve an object, function or other value from a target
// object or its `options`, with `options` taking precedence.
Marionette.getOption = function(target, optionName){
  if (!target || !optionName){ return; }
  var value;

  if (target.options && (optionName in target.options) && (target.options[optionName] !== undefined)){
    value = target.options[optionName];
  } else {
    value = target[optionName];
  }

  return value;
};

// Marionette.normalizeMethods
// ----------------------

// Pass in a mapping of events => functions or function names
// and return a mapping of events => functions
Marionette.normalizeMethods = function(hash) {
  var normalizedHash = {}, method;
  _.each(hash, function(fn, name) {
    method = fn;
    if (!_.isFunction(method)) {
      method = this[method];
    }
    if (!method) {
      return;
    }
    normalizedHash[name] = method;
  }, this);
  return normalizedHash;
};


// allows for the use of the @ui. syntax within
// a given key for triggers and events
// swaps the @ui with the associated selector
Marionette.normalizeUIKeys = function(hash, ui) {
  if (typeof(hash) === "undefined") {
    return;
  }

  _.each(_.keys(hash), function(v) {
    var pattern = /@ui.[a-zA-Z_$0-9]*/g;
    if (v.match(pattern)) {
      hash[v.replace(pattern, function(r) {
        return ui[r.slice(4)];
      })] = hash[v];
      delete hash[v];
    }
  });

  return hash;
};

// Trigger an event and/or a corresponding method name. Examples:
//
// `this.triggerMethod("foo")` will trigger the "foo" event and
// call the "onFoo" method.
//
// `this.triggerMethod("foo:bar")` will trigger the "foo:bar" event and
// call the "onFooBar" method.
Marionette.triggerMethod = (function(){

  // split the event name on the ":"
  var splitter = /(^|:)(\w)/gi;

  // take the event section ("section1:section2:section3")
  // and turn it in to uppercase name
  function getEventName(match, prefix, eventName) {
    return eventName.toUpperCase();
  }

  // actual triggerMethod implementation
  var triggerMethod = function(event) {
    // get the method name from the event name
    var methodName = 'on' + event.replace(splitter, getEventName);
    var method = this[methodName];

    // trigger the event, if a trigger method exists
    if(_.isFunction(this.trigger)) {
      this.trigger.apply(this, arguments);
    }

    // call the onMethodName if it exists
    if (_.isFunction(method)) {
      // pass all arguments, except the event name
      return method.apply(this, _.tail(arguments));
    }
  };

  return triggerMethod;
})();

// DOMRefresh
// ----------
//
// Monitor a view's state, and after it has been rendered and shown
// in the DOM, trigger a "dom:refresh" event every time it is
// re-rendered.

Marionette.MonitorDOMRefresh = (function(documentElement){
  // track when the view has been shown in the DOM,
  // using a Marionette.Region (or by other means of triggering "show")
  function handleShow(view){
    view._isShown = true;
    triggerDOMRefresh(view);
  }

  // track when the view has been rendered
  function handleRender(view){
    view._isRendered = true;
    triggerDOMRefresh(view);
  }

  // Trigger the "dom:refresh" event and corresponding "onDomRefresh" method
  function triggerDOMRefresh(view){
    if (view._isShown && view._isRendered && isInDOM(view)){
      if (_.isFunction(view.triggerMethod)){
        view.triggerMethod("dom:refresh");
      }
    }
  }

  function isInDOM(view) {
    return documentElement.contains(view.el);
  }

  // Export public API
  return function(view){
    view.listenTo(view, "show", function(){
      handleShow(view);
    });

    view.listenTo(view, "render", function(){
      handleRender(view);
    });
  };
})(document.documentElement);


// Marionette.bindEntityEvents & unbindEntityEvents
// ---------------------------
//
// These methods are used to bind/unbind a backbone "entity" (collection/model)
// to methods on a target object.
//
// The first parameter, `target`, must have a `listenTo` method from the
// EventBinder object.
//
// The second parameter is the entity (Backbone.Model or Backbone.Collection)
// to bind the events from.
//
// The third parameter is a hash of { "event:name": "eventHandler" }
// configuration. Multiple handlers can be separated by a space. A
// function can be supplied instead of a string handler name.

(function(Marionette){
  "use strict";

  // Bind the event to handlers specified as a string of
  // handler names on the target object
  function bindFromStrings(target, entity, evt, methods){
    var methodNames = methods.split(/\s+/);

    _.each(methodNames,function(methodName) {

      var method = target[methodName];
      if(!method) {
        throwError("Method '"+ methodName +"' was configured as an event handler, but does not exist.");
      }

      target.listenTo(entity, evt, method);
    });
  }

  // Bind the event to a supplied callback function
  function bindToFunction(target, entity, evt, method){
      target.listenTo(entity, evt, method);
  }

  // Bind the event to handlers specified as a string of
  // handler names on the target object
  function unbindFromStrings(target, entity, evt, methods){
    var methodNames = methods.split(/\s+/);

    _.each(methodNames,function(methodName) {
      var method = target[methodName];
      target.stopListening(entity, evt, method);
    });
  }

  // Bind the event to a supplied callback function
  function unbindToFunction(target, entity, evt, method){
      target.stopListening(entity, evt, method);
  }


  // generic looping function
  function iterateEvents(target, entity, bindings, functionCallback, stringCallback){
    if (!entity || !bindings) { return; }

    // allow the bindings to be a function
    if (_.isFunction(bindings)){
      bindings = bindings.call(target);
    }

    // iterate the bindings and bind them
    _.each(bindings, function(methods, evt){

      // allow for a function as the handler,
      // or a list of event names as a string
      if (_.isFunction(methods)){
        functionCallback(target, entity, evt, methods);
      } else {
        stringCallback(target, entity, evt, methods);
      }

    });
  }

  // Export Public API
  Marionette.bindEntityEvents = function(target, entity, bindings){
    iterateEvents(target, entity, bindings, bindToFunction, bindFromStrings);
  };

  Marionette.unbindEntityEvents = function(target, entity, bindings){
    iterateEvents(target, entity, bindings, unbindToFunction, unbindFromStrings);
  };

})(Marionette);


// Callbacks
// ---------

// A simple way of managing a collection of callbacks
// and executing them at a later point in time, using jQuery's
// `Deferred` object.
Marionette.Callbacks = function(){
  this._deferred = Marionette.$.Deferred();
  this._callbacks = [];
};

_.extend(Marionette.Callbacks.prototype, {

  // Add a callback to be executed. Callbacks added here are
  // guaranteed to execute, even if they are added after the
  // `run` method is called.
  add: function(callback, contextOverride){
    this._callbacks.push({cb: callback, ctx: contextOverride});

    this._deferred.done(function(context, options){
      if (contextOverride){ context = contextOverride; }
      callback.call(context, options);
    });
  },

  // Run all registered callbacks with the context specified.
  // Additional callbacks can be added after this has been run
  // and they will still be executed.
  run: function(options, context){
    this._deferred.resolve(context, options);
  },

  // Resets the list of callbacks to be run, allowing the same list
  // to be run multiple times - whenever the `run` method is called.
  reset: function(){
    var callbacks = this._callbacks;
    this._deferred = Marionette.$.Deferred();
    this._callbacks = [];

    _.each(callbacks, function(cb){
      this.add(cb.cb, cb.ctx);
    }, this);
  }
});


// Marionette Controller
// ---------------------
//
// A multi-purpose object to use as a controller for
// modules and routers, and as a mediator for workflow
// and coordination of other objects, views, and more.
Marionette.Controller = function(options){
  this.triggerMethod = Marionette.triggerMethod;
  this.options = options || {};

  if (_.isFunction(this.initialize)){
    this.initialize(this.options);
  }
};

Marionette.Controller.extend = Marionette.extend;

// Controller Methods
// --------------

// Ensure it can trigger events with Backbone.Events
_.extend(Marionette.Controller.prototype, Backbone.Events, {
  close: function(){
    this.stopListening();
    var args = Array.prototype.slice.call(arguments);
    this.triggerMethod.apply(this, ["close"].concat(args));
    this.unbind();
  }
});

// Region
// ------
//
// Manage the visual regions of your composite application. See
// http://lostechies.com/derickbailey/2011/12/12/composite-js-apps-regions-and-region-managers/

Marionette.Region = function(options){
  this.options = options || {};
  this.el = Marionette.getOption(this, "el");

  if (!this.el){
    throwError("An 'el' must be specified for a region.", "NoElError");
  }

  if (this.initialize){
    var args = Array.prototype.slice.apply(arguments);
    this.initialize.apply(this, args);
  }
};


// Region Type methods
// -------------------

_.extend(Marionette.Region, {

  // Build an instance of a region by passing in a configuration object
  // and a default region type to use if none is specified in the config.
  //
  // The config object should either be a string as a jQuery DOM selector,
  // a Region type directly, or an object literal that specifies both
  // a selector and regionType:
  //
  // ```js
  // {
  //   selector: "#foo",
  //   regionType: MyCustomRegion
  // }
  // ```
  //
  buildRegion: function(regionConfig, defaultRegionType){
    var regionIsString = _.isString(regionConfig);
    var regionSelectorIsString = _.isString(regionConfig.selector);
    var regionTypeIsUndefined = _.isUndefined(regionConfig.regionType);
    var regionIsType = _.isFunction(regionConfig);

    if (!regionIsType && !regionIsString && !regionSelectorIsString) {
      throwError("Region must be specified as a Region type, a selector string or an object with selector property");
    }

    var selector, RegionType;

    // get the selector for the region

    if (regionIsString) {
      selector = regionConfig;
    }

    if (regionConfig.selector) {
      selector = regionConfig.selector;
      delete regionConfig.selector;
    }

    // get the type for the region

    if (regionIsType){
      RegionType = regionConfig;
    }

    if (!regionIsType && regionTypeIsUndefined) {
      RegionType = defaultRegionType;
    }

    if (regionConfig.regionType) {
      RegionType = regionConfig.regionType;
      delete regionConfig.regionType;
    }

    if (regionIsString || regionIsType) {
      regionConfig = {};
    }

    regionConfig.el = selector;

    // build the region instance
    var region = new RegionType(regionConfig);

    // override the `getEl` function if we have a parentEl
    // this must be overridden to ensure the selector is found
    // on the first use of the region. if we try to assign the
    // region's `el` to `parentEl.find(selector)` in the object
    // literal to build the region, the element will not be
    // guaranteed to be in the DOM already, and will cause problems
    if (regionConfig.parentEl){
      region.getEl = function(selector) {
        var parentEl = regionConfig.parentEl;
        if (_.isFunction(parentEl)){
          parentEl = parentEl();
        }
        return parentEl.find(selector);
      };
    }

    return region;
  }

});

// Region Instance Methods
// -----------------------

_.extend(Marionette.Region.prototype, Backbone.Events, {

  // Displays a backbone view instance inside of the region.
  // Handles calling the `render` method for you. Reads content
  // directly from the `el` attribute. Also calls an optional
  // `onShow` and `close` method on your view, just after showing
  // or just before closing the view, respectively.
  show: function(view){
    this.ensureEl();

    var isViewClosed = view.isClosed || _.isUndefined(view.$el);
    var isDifferentView = view !== this.currentView;

    if (isDifferentView) {
      this.close();
    }

    view.render();
    Marionette.triggerMethod.call(this, "before:show", view);
    Marionette.triggerMethod.call(view, "before:show");

    if (isDifferentView || isViewClosed) {
      this.open(view);
    }

    this.currentView = view;

    Marionette.triggerMethod.call(this, "show", view);
    Marionette.triggerMethod.call(view, "show");
  },

  ensureEl: function(){
    if (!this.$el || this.$el.length === 0){
      this.$el = this.getEl(this.el);
    }
  },

  // Override this method to change how the region finds the
  // DOM element that it manages. Return a jQuery selector object.
  getEl: function(selector){
    return Marionette.$(selector);
  },

  // Override this method to change how the new view is
  // appended to the `$el` that the region is managing
  open: function(view){
    this.$el.empty().append(view.el);
  },

  // Close the current view, if there is one. If there is no
  // current view, it does nothing and returns immediately.
  close: function(){
    var view = this.currentView;
    if (!view || view.isClosed){ return; }

    // call 'close' or 'remove', depending on which is found
    if (view.close) { view.close(); }
    else if (view.remove) { view.remove(); }

    Marionette.triggerMethod.call(this, "close", view);

    delete this.currentView;
  },

  // Attach an existing view to the region. This
  // will not call `render` or `onShow` for the new view,
  // and will not replace the current HTML for the `el`
  // of the region.
  attachView: function(view){
    this.currentView = view;
  },

  // Reset the region by closing any existing view and
  // clearing out the cached `$el`. The next time a view
  // is shown via this region, the region will re-query the
  // DOM for the region's `el`.
  reset: function(){
    this.close();
    delete this.$el;
  }
});

// Copy the `extend` function used by Backbone's classes
Marionette.Region.extend = Marionette.extend;

// Marionette.RegionManager
// ------------------------
//
// Manage one or more related `Marionette.Region` objects.
Marionette.RegionManager = (function(Marionette){

  var RegionManager = Marionette.Controller.extend({
    constructor: function(options){
      this._regions = {};
      Marionette.Controller.prototype.constructor.call(this, options);
    },

    // Add multiple regions using an object literal, where
    // each key becomes the region name, and each value is
    // the region definition.
    addRegions: function(regionDefinitions, defaults){
      var regions = {};

      _.each(regionDefinitions, function(definition, name){
        if (_.isString(definition)){
          definition = { selector: definition };
        }

        if (definition.selector){
          definition = _.defaults({}, definition, defaults);
        }

        var region = this.addRegion(name, definition);
        regions[name] = region;
      }, this);

      return regions;
    },

    // Add an individual region to the region manager,
    // and return the region instance
    addRegion: function(name, definition){
      var region;

      var isObject = _.isObject(definition);
      var isString = _.isString(definition);
      var hasSelector = !!definition.selector;

      if (isString || (isObject && hasSelector)){
        region = Marionette.Region.buildRegion(definition, Marionette.Region);
      } else if (_.isFunction(definition)){
        region = Marionette.Region.buildRegion(definition, Marionette.Region);
      } else {
        region = definition;
      }

      this._store(name, region);
      this.triggerMethod("region:add", name, region);
      return region;
    },

    // Get a region by name
    get: function(name){
      return this._regions[name];
    },

    // Remove a region by name
    removeRegion: function(name){
      var region = this._regions[name];
      this._remove(name, region);
    },

    // Close all regions in the region manager, and
    // remove them
    removeRegions: function(){
      _.each(this._regions, function(region, name){
        this._remove(name, region);
      }, this);
    },

    // Close all regions in the region manager, but
    // leave them attached
    closeRegions: function(){
      _.each(this._regions, function(region, name){
        region.close();
      }, this);
    },

    // Close all regions and shut down the region
    // manager entirely
    close: function(){
      this.removeRegions();
      Marionette.Controller.prototype.close.apply(this, arguments);
    },

    // internal method to store regions
    _store: function(name, region){
      this._regions[name] = region;
      this._setLength();
    },

    // internal method to remove a region
    _remove: function(name, region){
      region.close();
      delete this._regions[name];
      this._setLength();
      this.triggerMethod("region:remove", name, region);
    },

    // set the number of regions current held
    _setLength: function(){
      this.length = _.size(this._regions);
    }

  });

  // Borrowing this code from Backbone.Collection:
  // http://backbonejs.org/docs/backbone.html#section-106
  //
  // Mix in methods from Underscore, for iteration, and other
  // collection related features.
  var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
    'select', 'reject', 'every', 'all', 'some', 'any', 'include',
    'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
    'last', 'without', 'isEmpty', 'pluck'];

  _.each(methods, function(method) {
    RegionManager.prototype[method] = function() {
      var regions = _.values(this._regions);
      var args = [regions].concat(_.toArray(arguments));
      return _[method].apply(_, args);
    };
  });

  return RegionManager;
})(Marionette);


// Template Cache
// --------------

// Manage templates stored in `<script>` blocks,
// caching them for faster access.
Marionette.TemplateCache = function(templateId){
  this.templateId = templateId;
};

// TemplateCache object-level methods. Manage the template
// caches from these method calls instead of creating
// your own TemplateCache instances
_.extend(Marionette.TemplateCache, {
  templateCaches: {},

  // Get the specified template by id. Either
  // retrieves the cached version, or loads it
  // from the DOM.
  get: function(templateId){
    var cachedTemplate = this.templateCaches[templateId];

    if (!cachedTemplate){
      cachedTemplate = new Marionette.TemplateCache(templateId);
      this.templateCaches[templateId] = cachedTemplate;
    }

    return cachedTemplate.load();
  },

  // Clear templates from the cache. If no arguments
  // are specified, clears all templates:
  // `clear()`
  //
  // If arguments are specified, clears each of the
  // specified templates from the cache:
  // `clear("#t1", "#t2", "...")`
  clear: function(){
    var i;
    var args = slice.call(arguments);
    var length = args.length;

    if (length > 0){
      for(i=0; i<length; i++){
        delete this.templateCaches[args[i]];
      }
    } else {
      this.templateCaches = {};
    }
  }
});

// TemplateCache instance methods, allowing each
// template cache object to manage its own state
// and know whether or not it has been loaded
_.extend(Marionette.TemplateCache.prototype, {

  // Internal method to load the template
  load: function(){
    // Guard clause to prevent loading this template more than once
    if (this.compiledTemplate){
      return this.compiledTemplate;
    }

    // Load the template and compile it
    var template = this.loadTemplate(this.templateId);
    this.compiledTemplate = this.compileTemplate(template);

    return this.compiledTemplate;
  },

  // Load a template from the DOM, by default. Override
  // this method to provide your own template retrieval
  // For asynchronous loading with AMD/RequireJS, consider
  // using a template-loader plugin as described here:
  // https://github.com/marionettejs/backbone.marionette/wiki/Using-marionette-with-requirejs
  loadTemplate: function(templateId){
    var template = Marionette.$(templateId).html();

    if (!template || template.length === 0){
      throwError("Could not find template: '" + templateId + "'", "NoTemplateError");
    }

    return template;
  },

  // Pre-compile the template before caching it. Override
  // this method if you do not need to pre-compile a template
  // (JST / RequireJS for example) or if you want to change
  // the template engine used (Handebars, etc).
  compileTemplate: function(rawTemplate){
    return _.template(rawTemplate);
  }
});


// Renderer
// --------

// Render a template with data by passing in the template
// selector and the data to render.
Marionette.Renderer = {

  // Render a template with data. The `template` parameter is
  // passed to the `TemplateCache` object to retrieve the
  // template function. Override this method to provide your own
  // custom rendering and template handling for all of Marionette.
  render: function(template, data){

    if (!template) {
      throwError("Cannot render the template since it's false, null or undefined.", "TemplateNotFoundError");
    }

    var templateFunc;
    if (typeof template === "function"){
      templateFunc = template;
    } else {
      templateFunc = Marionette.TemplateCache.get(template);
    }

    return templateFunc(data);
  }
};



// Marionette.View
// ---------------

// The core view type that other Marionette views extend from.
Marionette.View = Backbone.View.extend({

  constructor: function(options){
    _.bindAll(this, "render");

    if (_.isObject(this.behaviors)) {
      new Marionette.Behaviors(this);
    }

    // this exposes view options to the view initializer
    // this is a backfill since backbone removed the assignment
    // of this.options
    // at some point however this may be removed
    this.options = _.extend({}, _.result(this, 'options'), _.isFunction(options) ? options.call(this) : options);

    // parses out the @ui DSL for events
    this.events = this.normalizeUIKeys(_.result(this, 'events'));
    Backbone.View.prototype.constructor.apply(this, arguments);

    Marionette.MonitorDOMRefresh(this);
    this.listenTo(this, "show", this.onShowCalled);
  },

  // import the "triggerMethod" to trigger events with corresponding
  // methods if the method exists
  triggerMethod: Marionette.triggerMethod,

  // Imports the "normalizeMethods" to transform hashes of
  // events=>function references/names to a hash of events=>function references
  normalizeMethods: Marionette.normalizeMethods,

  // Get the template for this view
  // instance. You can set a `template` attribute in the view
  // definition or pass a `template: "whatever"` parameter in
  // to the constructor options.
  getTemplate: function(){
    return Marionette.getOption(this, "template");
  },

  // Mix in template helper methods. Looks for a
  // `templateHelpers` attribute, which can either be an
  // object literal, or a function that returns an object
  // literal. All methods and attributes from this object
  // are copies to the object passed in.
  mixinTemplateHelpers: function(target){
    target = target || {};
    var templateHelpers = Marionette.getOption(this, "templateHelpers");
    if (_.isFunction(templateHelpers)){
      templateHelpers = templateHelpers.call(this);
    }
    return _.extend(target, templateHelpers);
  },


  normalizeUIKeys: function(hash) {
    var ui = _.result(this, 'ui');
    return Marionette.normalizeUIKeys(hash, ui);
  },

  // Configure `triggers` to forward DOM events to view
  // events. `triggers: {"click .foo": "do:foo"}`
  configureTriggers: function(){
    if (!this.triggers) { return; }

    var triggerEvents = {};

    // Allow `triggers` to be configured as a function
    var triggers = this.normalizeUIKeys(_.result(this, "triggers"));

    // Configure the triggers, prevent default
    // action and stop propagation of DOM events
    _.each(triggers, function(value, key){

      var hasOptions = _.isObject(value);
      var eventName = hasOptions ? value.event : value;

      // build the event handler function for the DOM event
      triggerEvents[key] = function(e){

        // stop the event in its tracks
        if (e) {
          var prevent = e.preventDefault;
          var stop = e.stopPropagation;

          var shouldPrevent = hasOptions ? value.preventDefault : prevent;
          var shouldStop = hasOptions ? value.stopPropagation : stop;

          if (shouldPrevent && prevent) { prevent.apply(e); }
          if (shouldStop && stop) { stop.apply(e); }
        }

        // build the args for the event
        var args = {
          view: this,
          model: this.model,
          collection: this.collection
        };

        // trigger the event
        this.triggerMethod(eventName, args);
      };

    }, this);

    return triggerEvents;
  },

  // Overriding Backbone.View's delegateEvents to handle
  // the `triggers`, `modelEvents`, and `collectionEvents` configuration
  delegateEvents: function(events){
    this._delegateDOMEvents(events);
    Marionette.bindEntityEvents(this, this.model, Marionette.getOption(this, "modelEvents"));
    Marionette.bindEntityEvents(this, this.collection, Marionette.getOption(this, "collectionEvents"));
  },

  // internal method to delegate DOM events and triggers
  _delegateDOMEvents: function(events){
    events = events || this.events;
    if (_.isFunction(events)){ events = events.call(this); }

    var combinedEvents = {};

    // look up if this view has behavior events
    var behaviorEvents = _.result(this, 'behaviorEvents') || {};
    var triggers = this.configureTriggers();

    // behavior events will be overriden by view events and or triggers
    _.extend(combinedEvents, behaviorEvents, events, triggers);

    Backbone.View.prototype.delegateEvents.call(this, combinedEvents);
  },

  // Overriding Backbone.View's undelegateEvents to handle unbinding
  // the `triggers`, `modelEvents`, and `collectionEvents` config
  undelegateEvents: function(){
    var args = Array.prototype.slice.call(arguments);
    Backbone.View.prototype.undelegateEvents.apply(this, args);

    Marionette.unbindEntityEvents(this, this.model, Marionette.getOption(this, "modelEvents"));
    Marionette.unbindEntityEvents(this, this.collection, Marionette.getOption(this, "collectionEvents"));
  },

  // Internal method, handles the `show` event.
  onShowCalled: function(){},

  // Default `close` implementation, for removing a view from the
  // DOM and unbinding it. Regions will call this method
  // for you. You can specify an `onClose` method in your view to
  // add custom code that is called after the view is closed.
  close: function(){
    if (this.isClosed) { return; }

    var args = Array.prototype.slice.call(arguments);

    // allow the close to be stopped by returning `false`
    // from the `onBeforeClose` method
    var shouldClose = this.triggerMethod.apply(this, ["before:close"].concat(args));
    if (shouldClose === false){
      return;
    }

    // mark as closed before doing the actual close, to
    // prevent infinite loops within "close" event handlers
    // that are trying to close other views
    this.isClosed = true;
    this.triggerMethod.apply(this, ["close"].concat(args));

    // unbind UI elements
    this.unbindUIElements();

    // remove the view from the DOM
    this.remove();
  },

  // This method binds the elements specified in the "ui" hash inside the view's code with
  // the associated jQuery selectors.
  bindUIElements: function(){
    if (!this.ui) { return; }

    // store the ui hash in _uiBindings so they can be reset later
    // and so re-rendering the view will be able to find the bindings
    if (!this._uiBindings){
      this._uiBindings = this.ui;
    }

    // get the bindings result, as a function or otherwise
    var bindings = _.result(this, "_uiBindings");

    // empty the ui so we don't have anything to start with
    this.ui = {};

    // bind each of the selectors
    _.each(_.keys(bindings), function(key) {
      var selector = bindings[key];
      this.ui[key] = this.$(selector);
    }, this);
  },

  // This method unbinds the elements specified in the "ui" hash
  unbindUIElements: function(){
    if (!this.ui || !this._uiBindings){ return; }

    // delete all of the existing ui bindings
    _.each(this.ui, function($el, name){
      delete this.ui[name];
    }, this);

    // reset the ui element to the original bindings configuration
    this.ui = this._uiBindings;
    delete this._uiBindings;
  }
});

// Item View
// ---------

// A single item view implementation that contains code for rendering
// with underscore.js templates, serializing the view's model or collection,
// and calling several methods on extended views, such as `onRender`.
Marionette.ItemView = Marionette.View.extend({

  // Setting up the inheritance chain which allows changes to
  // Marionette.View.prototype.constructor which allows overriding
  constructor: function(){
    Marionette.View.prototype.constructor.apply(this, arguments);
  },

  // Serialize the model or collection for the view. If a model is
  // found, `.toJSON()` is called. If a collection is found, `.toJSON()`
  // is also called, but is used to populate an `items` array in the
  // resulting data. If both are found, defaults to the model.
  // You can override the `serializeData` method in your own view
  // definition, to provide custom serialization for your view's data.
  serializeData: function(){
    var data = {};

    if (this.model) {
      data = this.model.toJSON();
    }
    else if (this.collection) {
      data = { items: this.collection.toJSON() };
    }

    return data;
  },

  // Render the view, defaulting to underscore.js templates.
  // You can override this in your view definition to provide
  // a very specific rendering for your view. In general, though,
  // you should override the `Marionette.Renderer` object to
  // change how Marionette renders views.
  render: function(){
    this.isClosed = false;

    this.triggerMethod("before:render", this);
    this.triggerMethod("item:before:render", this);

    var data = this.serializeData();
    data = this.mixinTemplateHelpers(data);

    var template = this.getTemplate();
    var html = Marionette.Renderer.render(template, data);

    this.$el.html(html);
    this.bindUIElements();

    this.triggerMethod("render", this);
    this.triggerMethod("item:rendered", this);

    return this;
  },

  // Override the default close event to add a few
  // more events that are triggered.
  close: function(){
    if (this.isClosed){ return; }

    this.triggerMethod('item:before:close');

    Marionette.View.prototype.close.apply(this, arguments);

    this.triggerMethod('item:closed');
  }
});

// Collection View
// ---------------

// A view that iterates over a Backbone.Collection
// and renders an individual ItemView for each model.
Marionette.CollectionView = Marionette.View.extend({
  // used as the prefix for item view events
  // that are forwarded through the collectionview
  itemViewEventPrefix: "itemview",

  // constructor
  constructor: function(options){
    this._initChildViewStorage();

    Marionette.View.prototype.constructor.apply(this, arguments);

    this._initialEvents();
    this.initRenderBuffer();
  },

  // Instead of inserting elements one by one into the page,
  // it's much more performant to insert elements into a document
  // fragment and then insert that document fragment into the page
  initRenderBuffer: function() {
    this.elBuffer = document.createDocumentFragment();
    this._bufferedChildren = [];
  },

  startBuffering: function() {
    this.initRenderBuffer();
    this.isBuffering = true;
  },

  endBuffering: function() {
    this.isBuffering = false;
    this.appendBuffer(this, this.elBuffer);
    this._triggerShowBufferedChildren();
    this.initRenderBuffer();
  },

  _triggerShowBufferedChildren: function () {
    if (this._isShown) {
      _.each(this._bufferedChildren, function (child) {
        Marionette.triggerMethod.call(child, "show");
      });
      this._bufferedChildren = [];
    }
  },

  // Configured the initial events that the collection view
  // binds to.
  _initialEvents: function(){
    if (this.collection){
      this.listenTo(this.collection, "add", this.addChildView);
      this.listenTo(this.collection, "remove", this.removeItemView);
      this.listenTo(this.collection, "reset", this.render);
    }
  },

  // Handle a child item added to the collection
  addChildView: function(item, collection, options){
    this.closeEmptyView();
    var ItemView = this.getItemView(item);
    var index = this.collection.indexOf(item);
    this.addItemView(item, ItemView, index);
  },

  // Override from `Marionette.View` to guarantee the `onShow` method
  // of child views is called.
  onShowCalled: function(){
    this.children.each(function(child){
      Marionette.triggerMethod.call(child, "show");
    });
  },

  // Internal method to trigger the before render callbacks
  // and events
  triggerBeforeRender: function(){
    this.triggerMethod("before:render", this);
    this.triggerMethod("collection:before:render", this);
  },

  // Internal method to trigger the rendered callbacks and
  // events
  triggerRendered: function(){
    this.triggerMethod("render", this);
    this.triggerMethod("collection:rendered", this);
  },

  // Render the collection of items. Override this method to
  // provide your own implementation of a render function for
  // the collection view.
  render: function(){
    this.isClosed = false;
    this.triggerBeforeRender();
    this._renderChildren();
    this.triggerRendered();
    return this;
  },

  // Internal method. Separated so that CompositeView can have
  // more control over events being triggered, around the rendering
  // process
  _renderChildren: function(){
    this.startBuffering();

    this.closeEmptyView();
    this.closeChildren();

    if (!this.isEmpty(this.collection)) {
      this.showCollection();
    } else {
      this.showEmptyView();
    }

    this.endBuffering();
  },

  // Internal method to loop through each item in the
  // collection view and show it
  showCollection: function(){
    var ItemView;
    this.collection.each(function(item, index){
      ItemView = this.getItemView(item);
      this.addItemView(item, ItemView, index);
    }, this);
  },

  // Internal method to show an empty view in place of
  // a collection of item views, when the collection is
  // empty
  showEmptyView: function(){
    var EmptyView = this.getEmptyView();

    if (EmptyView && !this._showingEmptyView){
      this._showingEmptyView = true;
      var model = new Backbone.Model();
      this.addItemView(model, EmptyView, 0);
    }
  },

  // Internal method to close an existing emptyView instance
  // if one exists. Called when a collection view has been
  // rendered empty, and then an item is added to the collection.
  closeEmptyView: function(){
    if (this._showingEmptyView){
      this.closeChildren();
      delete this._showingEmptyView;
    }
  },

  // Retrieve the empty view type
  getEmptyView: function(){
    return Marionette.getOption(this, "emptyView");
  },

  // Retrieve the itemView type, either from `this.options.itemView`
  // or from the `itemView` in the object definition. The "options"
  // takes precedence.
  getItemView: function(item){
    var itemView = Marionette.getOption(this, "itemView");

    if (!itemView){
      throwError("An `itemView` must be specified", "NoItemViewError");
    }

    return itemView;
  },

  // Render the child item's view and add it to the
  // HTML for the collection view.
  addItemView: function(item, ItemView, index){
    // get the itemViewOptions if any were specified
    var itemViewOptions = Marionette.getOption(this, "itemViewOptions");
    if (_.isFunction(itemViewOptions)){
      itemViewOptions = itemViewOptions.call(this, item, index);
    }

    // build the view
    var view = this.buildItemView(item, ItemView, itemViewOptions);

    // set up the child view event forwarding
    this.addChildViewEventForwarding(view);

    // this view is about to be added
    this.triggerMethod("before:item:added", view);

    // Store the child view itself so we can properly
    // remove and/or close it later
    this.children.add(view);

    // Render it and show it
    this.renderItemView(view, index);

    // call the "show" method if the collection view
    // has already been shown
    if (this._isShown && !this.isBuffering){
      Marionette.triggerMethod.call(view, "show");
    }

    // this view was added
    this.triggerMethod("after:item:added", view);

    return view;
  },

  // Set up the child view event forwarding. Uses an "itemview:"
  // prefix in front of all forwarded events.
  addChildViewEventForwarding: function(view){
    var prefix = Marionette.getOption(this, "itemViewEventPrefix");

    // Forward all child item view events through the parent,
    // prepending "itemview:" to the event name
    this.listenTo(view, "all", function(){
      var args = slice.call(arguments);
      var rootEvent = args[0];
      var itemEvents = this.normalizeMethods(this.getItemEvents());

      args[0] = prefix + ":" + rootEvent;
      args.splice(1, 0, view);

      // call collectionView itemEvent if defined
      if (typeof itemEvents !== "undefined" && _.isFunction(itemEvents[rootEvent])) {
        itemEvents[rootEvent].apply(this, args);
      }

      Marionette.triggerMethod.apply(this, args);
    }, this);
  },

  // returns the value of itemEvents depending on if a function
  getItemEvents: function() {
    if (_.isFunction(this.itemEvents)) {
      return this.itemEvents.call(this);
    }

    return this.itemEvents;
  },

  // render the item view
  renderItemView: function(view, index) {
    view.render();
    this.appendHtml(this, view, index);
  },

  // Build an `itemView` for every model in the collection.
  buildItemView: function(item, ItemViewType, itemViewOptions){
    var options = _.extend({model: item}, itemViewOptions);
    return new ItemViewType(options);
  },

  // get the child view by item it holds, and remove it
  removeItemView: function(item){
    var view = this.children.findByModel(item);
    this.removeChildView(view);
    this.checkEmpty();
  },

  // Remove the child view and close it
  removeChildView: function(view){

    // shut down the child view properly,
    // including events that the collection has from it
    if (view){
      this.stopListening(view);

      // call 'close' or 'remove', depending on which is found
      if (view.close) { view.close(); }
      else if (view.remove) { view.remove(); }

      this.children.remove(view);
    }

    this.triggerMethod("item:removed", view);
  },

  // helper to check if the collection is empty
  isEmpty: function(collection){
    // check if we're empty now
    return !this.collection || this.collection.length === 0;
  },

  // If empty, show the empty view
  checkEmpty: function (){
    if (this.isEmpty(this.collection)){
      this.showEmptyView();
    }
  },

  // You might need to override this if you've overridden appendHtml
  appendBuffer: function(collectionView, buffer) {
    collectionView.$el.append(buffer);
  },

  // Append the HTML to the collection's `el`.
  // Override this method to do something other
  // than `.append`.
  appendHtml: function(collectionView, itemView, index){
    if (collectionView.isBuffering) {
      // buffering happens on reset events and initial renders
      // in order to reduce the number of inserts into the
      // document, which are expensive.
      collectionView.elBuffer.appendChild(itemView.el);
      collectionView._bufferedChildren.push(itemView);
    }
    else {
      // If we've already rendered the main collection, just
      // append the new items directly into the element.
      collectionView.$el.append(itemView.el);
    }
  },

  // Internal method to set up the `children` object for
  // storing all of the child views
  _initChildViewStorage: function(){
    this.children = new Backbone.ChildViewContainer();
  },

  // Handle cleanup and other closing needs for
  // the collection of views.
  close: function(){
    if (this.isClosed){ return; }

    this.triggerMethod("collection:before:close");
    this.closeChildren();
    this.triggerMethod("collection:closed");

    Marionette.View.prototype.close.apply(this, arguments);
  },

  // Close the child views that this collection view
  // is holding on to, if any
  closeChildren: function(){
    this.children.each(function(child){
      this.removeChildView(child);
    }, this);
    this.checkEmpty();
  }
});


// Composite View
// --------------

// Used for rendering a branch-leaf, hierarchical structure.
// Extends directly from CollectionView and also renders an
// an item view as `modelView`, for the top leaf
Marionette.CompositeView = Marionette.CollectionView.extend({

  // Setting up the inheritance chain which allows changes to
  // Marionette.CollectionView.prototype.constructor which allows overriding
  constructor: function(){
    Marionette.CollectionView.prototype.constructor.apply(this, arguments);
  },

  // Configured the initial events that the composite view
  // binds to. Override this method to prevent the initial
  // events, or to add your own initial events.
  _initialEvents: function(){

    // Bind only after composite view is rendered to avoid adding child views
    // to nonexistent itemViewContainer
    this.once('render', function () {
      if (this.collection){
        this.listenTo(this.collection, "add", this.addChildView);
        this.listenTo(this.collection, "remove", this.removeItemView);
        this.listenTo(this.collection, "reset", this._renderChildren);
      }
    });

  },

  // Retrieve the `itemView` to be used when rendering each of
  // the items in the collection. The default is to return
  // `this.itemView` or Marionette.CompositeView if no `itemView`
  // has been defined
  getItemView: function(item){
    var itemView = Marionette.getOption(this, "itemView") || this.constructor;

    if (!itemView){
      throwError("An `itemView` must be specified", "NoItemViewError");
    }

    return itemView;
  },

  // Serialize the collection for the view.
  // You can override the `serializeData` method in your own view
  // definition, to provide custom serialization for your view's data.
  serializeData: function(){
    var data = {};

    if (this.model){
      data = this.model.toJSON();
    }

    return data;
  },

  // Renders the model once, and the collection once. Calling
  // this again will tell the model's view to re-render itself
  // but the collection will not re-render.
  render: function(){
    this.isRendered = true;
    this.isClosed = false;
    this.resetItemViewContainer();

    this.triggerBeforeRender();
    var html = this.renderModel();
    this.$el.html(html);
    // the ui bindings is done here and not at the end of render since they
    // will not be available until after the model is rendered, but should be
    // available before the collection is rendered.
    this.bindUIElements();
    this.triggerMethod("composite:model:rendered");

    this._renderChildren();

    this.triggerMethod("composite:rendered");
    this.triggerRendered();
    return this;
  },

  _renderChildren: function(){
    if (this.isRendered){
      this.triggerMethod("composite:collection:before:render");
      Marionette.CollectionView.prototype._renderChildren.call(this);
      this.triggerMethod("composite:collection:rendered");
    }
  },

  // Render an individual model, if we have one, as
  // part of a composite view (branch / leaf). For example:
  // a treeview.
  renderModel: function(){
    var data = {};
    data = this.serializeData();
    data = this.mixinTemplateHelpers(data);

    var template = this.getTemplate();
    return Marionette.Renderer.render(template, data);
  },


  // You might need to override this if you've overridden appendHtml
  appendBuffer: function(compositeView, buffer) {
    var $container = this.getItemViewContainer(compositeView);
    $container.append(buffer);
  },

  // Appends the `el` of itemView instances to the specified
  // `itemViewContainer` (a jQuery selector). Override this method to
  // provide custom logic of how the child item view instances have their
  // HTML appended to the composite view instance.
  appendHtml: function(compositeView, itemView, index){
    if (compositeView.isBuffering) {
      compositeView.elBuffer.appendChild(itemView.el);
      compositeView._bufferedChildren.push(itemView);
    }
    else {
      // If we've already rendered the main collection, just
      // append the new items directly into the element.
      var $container = this.getItemViewContainer(compositeView);
      $container.append(itemView.el);
    }
  },


  // Internal method to ensure an `$itemViewContainer` exists, for the
  // `appendHtml` method to use.
  getItemViewContainer: function(containerView){
    if ("$itemViewContainer" in containerView){
      return containerView.$itemViewContainer;
    }

    var container;
    var itemViewContainer = Marionette.getOption(containerView, "itemViewContainer");
    if (itemViewContainer){

      var selector = _.isFunction(itemViewContainer) ? itemViewContainer.call(this) : itemViewContainer;
      container = containerView.$(selector);
      if (container.length <= 0) {
        throwError("The specified `itemViewContainer` was not found: " + containerView.itemViewContainer, "ItemViewContainerMissingError");
      }

    } else {
      container = containerView.$el;
    }

    containerView.$itemViewContainer = container;
    return container;
  },

  // Internal method to reset the `$itemViewContainer` on render
  resetItemViewContainer: function(){
    if (this.$itemViewContainer){
      delete this.$itemViewContainer;
    }
  }
});


// Layout
// ------

// Used for managing application layouts, nested layouts and
// multiple regions within an application or sub-application.
//
// A specialized view type that renders an area of HTML and then
// attaches `Region` instances to the specified `regions`.
// Used for composite view management and sub-application areas.
Marionette.Layout = Marionette.ItemView.extend({
  regionType: Marionette.Region,

  // Ensure the regions are available when the `initialize` method
  // is called.
  constructor: function (options) {
    options = options || {};

    this._firstRender = true;
    this._initializeRegions(options);

    Marionette.ItemView.prototype.constructor.call(this, options);
  },

  // Layout's render will use the existing region objects the
  // first time it is called. Subsequent calls will close the
  // views that the regions are showing and then reset the `el`
  // for the regions to the newly rendered DOM elements.
  render: function(){

    if (this.isClosed){
      // a previously closed layout means we need to
      // completely re-initialize the regions
      this._initializeRegions();
    }
    if (this._firstRender) {
      // if this is the first render, don't do anything to
      // reset the regions
      this._firstRender = false;
    } else if (!this.isClosed){
      // If this is not the first render call, then we need to
      // re-initializing the `el` for each region
      this._reInitializeRegions();
    }

    return Marionette.ItemView.prototype.render.apply(this, arguments);
  },

  // Handle closing regions, and then close the view itself.
  close: function () {
    if (this.isClosed){ return; }
    this.regionManager.close();
    Marionette.ItemView.prototype.close.apply(this, arguments);
  },

  // Add a single region, by name, to the layout
  addRegion: function(name, definition){
    var regions = {};
    regions[name] = definition;
    return this._buildRegions(regions)[name];
  },

  // Add multiple regions as a {name: definition, name2: def2} object literal
  addRegions: function(regions){
    this.regions = _.extend({}, this.regions, regions);
    return this._buildRegions(regions);
  },

  // Remove a single region from the Layout, by name
  removeRegion: function(name){
    delete this.regions[name];
    return this.regionManager.removeRegion(name);
  },

  // internal method to build regions
  _buildRegions: function(regions){
    var that = this;

    var defaults = {
      regionType: Marionette.getOption(this, "regionType"),
      parentEl: function(){ return that.$el; }
    };

    return this.regionManager.addRegions(regions, defaults);
  },

  // Internal method to initialize the regions that have been defined in a
  // `regions` attribute on this layout.
  _initializeRegions: function (options) {
    var regions;
    this._initRegionManager();

    if (_.isFunction(this.regions)) {
      regions = this.regions(options);
    } else {
      regions = this.regions || {};
    }

    this.addRegions(regions);
  },

  // Internal method to re-initialize all of the regions by updating the `el` that
  // they point to
  _reInitializeRegions: function(){
    this.regionManager.closeRegions();
    this.regionManager.each(function(region){
      region.reset();
    });
  },

  // Internal method to initialize the region manager
  // and all regions in it
  _initRegionManager: function(){
    this.regionManager = new Marionette.RegionManager();

    this.listenTo(this.regionManager, "region:add", function(name, region){
      this[name] = region;
      this.trigger("region:add", name, region);
    });

    this.listenTo(this.regionManager, "region:remove", function(name, region){
      delete this[name];
      this.trigger("region:remove", name, region);
    });
  }
});


Marionette.Behavior = (function(_, Backbone){
  function Behavior(options, view){
    this.view = view;
    this.defaults = _.result(this, "defaults") || {};
    this.options  = _.extend({}, this.defaults, options);

    // proxy behavior $ method to the view
    this.$ = function() {
      return this.view.$.apply(this.view, arguments);
    };

    this.initialize.apply(this, arguments);
  }

  _.extend(Behavior.prototype, {
    initialize: function(){},

    triggerMethod: Marionette.triggerMethod
  });

  // Borrow Backbones extend implementation
  _.extend(Behavior, {
    extend: Backbone.View.extend
  });

  return Behavior;
})(_, Backbone);

Marionette.Behaviors = (function(Marionette, _) {

  function Behaviors(view) {
    this.behaviors = Behaviors.parseBehaviors(view, view.behaviors);

    Behaviors.wrap(view, this.behaviors, [
      'bindUIElements', 'unbindUIElements',
      'delegateEvents', 'undelegateEvents',
      'onShow', 'onClose',
      'behaviorEvents', 'triggerMethod',
      'setElement'
    ]);
  }

  var methods = {
    setElement: function(setElement, behaviors) {
      setElement.apply(this, _.tail(arguments, 2));

      // proxy behavior $el to the view's $el
      _.each(behaviors, function(b) {
        b.$el = this.$el;
      }, this);
    },

    onShow: function(onShow, behaviors) {
      var args = _.tail(arguments, 2);

      _.each(behaviors, function(b) {
        Marionette.triggerMethod.apply(b, ["show"].concat(args));
      });

      if (_.isFunction(onShow)) {
        onShow.apply(this, args);
      }
    },

    onClose: function(onClose, behaviors){
      var args = _.tail(arguments, 2);

      _.each(behaviors, function(b) {
        Marionette.triggerMethod.apply(b, ["close"].concat(args));
      });

      if (_.isFunction(onClose)) {
        onClose.apply(this, args);
      }
    },

    bindUIElements: function(bindUIElements, behaviors) {
      bindUIElements.apply(this);
      _.invoke(behaviors, bindUIElements);
    },

    unbindUIElements: function(unbindUIElements, behaviors) {
      unbindUIElements.apply(this);
      _.invoke(behaviors, unbindUIElements);
    },

    triggerMethod: function(triggerMethod, behaviors) {
      var args = _.tail(arguments, 2);
      triggerMethod.apply(this, args);

      _.each(behaviors, function(b) {
        triggerMethod.apply(b, args);
      });
    },

    delegateEvents: function(delegateEvents, behaviors) {
      var args = _.tail(arguments, 2);
      delegateEvents.apply(this, args);

      _.each(behaviors, function(b){
        Marionette.bindEntityEvents(this, this.model, Marionette.getOption(b, "modelEvents"));
        Marionette.bindEntityEvents(this, this.collection, Marionette.getOption(b, "collectionEvents"));
      }, this);
    },

    undelegateEvents: function(undelegateEvents, behaviors) {
      var args = _.tail(arguments, 2);
      undelegateEvents.apply(this, args);

      _.each(behaviors, function(b) {
        Marionette.unbindEntityEvents(this, this.model, Marionette.getOption(b, "modelEvents"));
        Marionette.unbindEntityEvents(this, this.collection, Marionette.getOption(b, "collectionEvents"));
      }, this);
    },

    behaviorEvents: function(behaviorEvents, behaviors) {
      var _behaviorsEvents = {};
      var viewUI = _.result(this, 'ui');

      _.each(behaviors, function(b, i) {
        var _events = {};
        var behaviorEvents = _.result(b, 'events') || {};
        var behaviorUI = _.result(b, 'ui');
        var ui = _.extend({}, viewUI, behaviorUI);

        behaviorEvents = Marionette.normalizeUIKeys(behaviorEvents, ui);

        _.each(_.keys(behaviorEvents), function(key) {
          // append white-space at the end of each key to prevent behavior key collisions
          // this is relying on the fact backbone events considers "click .foo" the same  "click .foo "
          // starts with an array of two so the first behavior has one space
          var whitespace = (new Array(i+2)).join(" ");
          var eventKey   = key + whitespace;
          var handler    = _.isFunction(behaviorEvents[key]) ? behaviorEvents[key] : b[behaviorEvents[key]];

          _events[eventKey] = _.bind(handler, b);
        });

        _behaviorsEvents = _.extend(_behaviorsEvents, _events);
      });

      return _behaviorsEvents;
    }
 };

  _.extend(Behaviors, {

    // placeholder method to be extended by the user
    // should define the object that stores the behaviors
    // i.e.
    //
    // Marionette.Behaviors.behaviorsLookup: function() {
    //   return App.Behaviors
    // }
    behaviorsLookup: function() {
      throw new Error("You must define where your behaviors are stored. See https://github.com/marionettejs/backbone.marionette/blob/master/docs/marionette.behaviors.md#behaviorslookup");
    },

    getBehaviorClass: function(options, key) {
      if (options.behaviorClass) {
        return options.behaviorClass;
      }

      // Get behavior class can be either a flat object or a method
      return _.isFunction(Behaviors.behaviorsLookup) ? Behaviors.behaviorsLookup.apply(this, arguments)[key] : Behaviors.behaviorsLookup[key];
    },

    parseBehaviors: function(view, behaviors){
      return _.map(behaviors, function(options, key){
        var BehaviorClass = Behaviors.getBehaviorClass(options, key);
        return new BehaviorClass(options, view);
      });
    },

    // wrap view internal methods so that they delegate to behaviors.
    // For example, onClose should trigger close on all of the behaviors and then close itself.
    // i.e.
    //
    // view.delegateEvents = _.partial(methods.delegateEvents, view.delegateEvents, behaviors);
    wrap: function(view, behaviors, methodNames) {
      _.each(methodNames, function(methodName) {
        view[methodName] = _.partial(methods[methodName], view[methodName], behaviors);
      });
    }
  });

  return Behaviors;

})(Marionette, _);


// AppRouter
// ---------

// Reduce the boilerplate code of handling route events
// and then calling a single method on another object.
// Have your routers configured to call the method on
// your object, directly.
//
// Configure an AppRouter with `appRoutes`.
//
// App routers can only take one `controller` object.
// It is recommended that you divide your controller
// objects in to smaller pieces of related functionality
// and have multiple routers / controllers, instead of
// just one giant router and controller.
//
// You can also add standard routes to an AppRouter.

Marionette.AppRouter = Backbone.Router.extend({

  constructor: function(options){
    Backbone.Router.prototype.constructor.apply(this, arguments);
	
    this.options = options || {};

    var appRoutes = Marionette.getOption(this, "appRoutes");
    var controller = this._getController();
    this.processAppRoutes(controller, appRoutes);
  },

  // Similar to route method on a Backbone Router but
  // method is called on the controller
  appRoute: function(route, methodName) {
    var controller = this._getController();
    this._addAppRoute(controller, route, methodName);
  },

  // Internal method to process the `appRoutes` for the
  // router, and turn them in to routes that trigger the
  // specified method on the specified `controller`.
  processAppRoutes: function(controller, appRoutes) {
    if (!appRoutes){ return; }

    var routeNames = _.keys(appRoutes).reverse(); // Backbone requires reverted order of routes

    _.each(routeNames, function(route) {
      this._addAppRoute(controller, route, appRoutes[route]);
    }, this);
  },

  _getController: function(){
    return Marionette.getOption(this, "controller");
  },

  _addAppRoute: function(controller, route, methodName){
    var method = controller[methodName];

    if (!method) {
      throwError("Method '" + methodName + "' was not found on the controller");
    }

    this.route(route, methodName, _.bind(method, controller));
  }
});


// Application
// -----------

// Contain and manage the composite application as a whole.
// Stores and starts up `Region` objects, includes an
// event aggregator as `app.vent`
Marionette.Application = function(options){
  this._initRegionManager();
  this._initCallbacks = new Marionette.Callbacks();
  this.vent = new Backbone.Wreqr.EventAggregator();
  this.commands = new Backbone.Wreqr.Commands();
  this.reqres = new Backbone.Wreqr.RequestResponse();
  this.submodules = {};

  _.extend(this, options);

  this.triggerMethod = Marionette.triggerMethod;
};

_.extend(Marionette.Application.prototype, Backbone.Events, {
  // Command execution, facilitated by Backbone.Wreqr.Commands
  execute: function(){
    this.commands.execute.apply(this.commands, arguments);
  },

  // Request/response, facilitated by Backbone.Wreqr.RequestResponse
  request: function(){
    return this.reqres.request.apply(this.reqres, arguments);
  },

  // Add an initializer that is either run at when the `start`
  // method is called, or run immediately if added after `start`
  // has already been called.
  addInitializer: function(initializer){
    this._initCallbacks.add(initializer);
  },

  // kick off all of the application's processes.
  // initializes all of the regions that have been added
  // to the app, and runs all of the initializer functions
  start: function(options){
    this.triggerMethod("initialize:before", options);
    this._initCallbacks.run(options, this);
    this.triggerMethod("initialize:after", options);

    this.triggerMethod("start", options);
  },

  // Add regions to your app.
  // Accepts a hash of named strings or Region objects
  // addRegions({something: "#someRegion"})
  // addRegions({something: Region.extend({el: "#someRegion"}) });
  addRegions: function(regions){
    return this._regionManager.addRegions(regions);
  },

  // Close all regions in the app, without removing them
  closeRegions: function(){
    this._regionManager.closeRegions();
  },

  // Removes a region from your app, by name
  // Accepts the regions name
  // removeRegion('myRegion')
  removeRegion: function(region) {
    this._regionManager.removeRegion(region);
  },

  // Provides alternative access to regions
  // Accepts the region name
  // getRegion('main')
  getRegion: function(region) {
    return this._regionManager.get(region);
  },

  // Create a module, attached to the application
  module: function(moduleNames, moduleDefinition){

    // Overwrite the module class if the user specifies one
    var ModuleClass = Marionette.Module.getClass(moduleDefinition);

    // slice the args, and add this application object as the
    // first argument of the array
    var args = slice.call(arguments);
    args.unshift(this);

    // see the Marionette.Module object for more information
    return ModuleClass.create.apply(ModuleClass, args);
  },

  // Internal method to set up the region manager
  _initRegionManager: function(){
    this._regionManager = new Marionette.RegionManager();

    this.listenTo(this._regionManager, "region:add", function(name, region){
      this[name] = region;
    });

    this.listenTo(this._regionManager, "region:remove", function(name, region){
      delete this[name];
    });
  }
});

// Copy the `extend` function used by Backbone's classes
Marionette.Application.extend = Marionette.extend;

// Module
// ------

// A simple module system, used to create privacy and encapsulation in
// Marionette applications
Marionette.Module = function(moduleName, app, options){
  this.moduleName = moduleName;
  this.options = _.extend({}, this.options, options);
  this.initialize = options.initialize || this.initialize;

  // store sub-modules
  this.submodules = {};

  this._setupInitializersAndFinalizers();

  // store the configuration for this module
  this.app = app;
  this.startWithParent = true;

  this.triggerMethod = Marionette.triggerMethod;

  if (_.isFunction(this.initialize)){
    this.initialize(this.options, moduleName, app);
  }
};

Marionette.Module.extend = Marionette.extend;

// Extend the Module prototype with events / listenTo, so that the module
// can be used as an event aggregator or pub/sub.
_.extend(Marionette.Module.prototype, Backbone.Events, {

  // Initialize is an empty function by default. Override it with your own
  // initialization logic when extending Marionette.Module.
  initialize: function(){},

  // Initializer for a specific module. Initializers are run when the
  // module's `start` method is called.
  addInitializer: function(callback){
    this._initializerCallbacks.add(callback);
  },

  // Finalizers are run when a module is stopped. They are used to teardown
  // and finalize any variables, references, events and other code that the
  // module had set up.
  addFinalizer: function(callback){
    this._finalizerCallbacks.add(callback);
  },

  // Start the module, and run all of its initializers
  start: function(options){
    // Prevent re-starting a module that is already started
    if (this._isInitialized){ return; }

    // start the sub-modules (depth-first hierarchy)
    _.each(this.submodules, function(mod){
      // check to see if we should start the sub-module with this parent
      if (mod.startWithParent){
        mod.start(options);
      }
    });

    // run the callbacks to "start" the current module
    this.triggerMethod("before:start", options);

    this._initializerCallbacks.run(options, this);
    this._isInitialized = true;

    this.triggerMethod("start", options);
  },

  // Stop this module by running its finalizers and then stop all of
  // the sub-modules for this module
  stop: function(){
    // if we are not initialized, don't bother finalizing
    if (!this._isInitialized){ return; }
    this._isInitialized = false;

    Marionette.triggerMethod.call(this, "before:stop");

    // stop the sub-modules; depth-first, to make sure the
    // sub-modules are stopped / finalized before parents
    _.each(this.submodules, function(mod){ mod.stop(); });

    // run the finalizers
    this._finalizerCallbacks.run(undefined,this);

    // reset the initializers and finalizers
    this._initializerCallbacks.reset();
    this._finalizerCallbacks.reset();

    Marionette.triggerMethod.call(this, "stop");
  },

  // Configure the module with a definition function and any custom args
  // that are to be passed in to the definition function
  addDefinition: function(moduleDefinition, customArgs){
    this._runModuleDefinition(moduleDefinition, customArgs);
  },

  // Internal method: run the module definition function with the correct
  // arguments
  _runModuleDefinition: function(definition, customArgs){
    if (!definition){ return; }

    // build the correct list of arguments for the module definition
    var args = _.flatten([
      this,
      this.app,
      Backbone,
      Marionette,
      Marionette.$, _,
      customArgs
    ]);

    definition.apply(this, args);
  },

  // Internal method: set up new copies of initializers and finalizers.
  // Calling this method will wipe out all existing initializers and
  // finalizers.
  _setupInitializersAndFinalizers: function(){
    this._initializerCallbacks = new Marionette.Callbacks();
    this._finalizerCallbacks = new Marionette.Callbacks();
  }
});

// Type methods to create modules
_.extend(Marionette.Module, {

  // Create a module, hanging off the app parameter as the parent object.
  create: function(app, moduleNames, moduleDefinition){
    var module = app;

    // get the custom args passed in after the module definition and
    // get rid of the module name and definition function
    var customArgs = slice.call(arguments);
    customArgs.splice(0, 3);

    // split the module names and get the length
    moduleNames = moduleNames.split(".");
    var length = moduleNames.length;

    // store the module definition for the last module in the chain
    var moduleDefinitions = [];
    moduleDefinitions[length-1] = moduleDefinition;

    // Loop through all the parts of the module definition
    _.each(moduleNames, function(moduleName, i){
      var parentModule = module;
      module = this._getModule(parentModule, moduleName, app, moduleDefinition);
      this._addModuleDefinition(parentModule, module, moduleDefinitions[i], customArgs);
    }, this);

    // Return the last module in the definition chain
    return module;
  },

  _getModule: function(parentModule, moduleName, app, def, args){
    var options = _.extend({}, def);
    var ModuleClass = this.getClass(def);

    // Get an existing module of this name if we have one
    var module = parentModule[moduleName];

    if (!module){
      // Create a new module if we don't have one
      module = new ModuleClass(moduleName, app, options);
      parentModule[moduleName] = module;
      // store the module on the parent
      parentModule.submodules[moduleName] = module;
    }

    return module;
  },

  getClass: function(moduleDefinition) {
    var ModuleClass = Marionette.Module;

    if (!moduleDefinition) {
      return ModuleClass;
    }

    if (moduleDefinition.prototype instanceof ModuleClass) {
      return moduleDefinition;
    }

    return moduleDefinition.moduleClass || ModuleClass;
  },

  // Add the module definition and add a startWithParent initializer function.
  // This is complicated because module definitions are heavily overloaded
  // and support an anonymous function, module class, or options object
  _addModuleDefinition: function(parentModule, module, def, args){
    var fn = this._getDefine(def);
    var startWithParent = this._getStartWithParent(def, module);

    if (fn){
      module.addDefinition(fn, args);
    }

    this._addStartWithParent(parentModule, module, startWithParent);
  },

  _getStartWithParent: function(def, module) {
    var swp;

    if (_.isFunction(def) && (def.prototype instanceof Marionette.Module)) {
      swp = module.constructor.prototype.startWithParent;
      return _.isUndefined(swp) ? true : swp;
    }

    if (_.isObject(def)){
      swp = def.startWithParent;
      return _.isUndefined(swp) ? true : swp;
    }

    return true;
  },

  _getDefine: function(def) {
    if (_.isFunction(def) && !(def.prototype instanceof Marionette.Module)) {
      return def;
    }

    if (_.isObject(def)){
      return def.define;
    }

    return null;
  },

  _addStartWithParent: function(parentModule, module, startWithParent) {
    module.startWithParent = module.startWithParent && startWithParent;

    if (!module.startWithParent || !!module.startWithParentIsConfigured){
      return;
    }

    module.startWithParentIsConfigured = true;

    parentModule.addInitializer(function(options){
      if (module.startWithParent){
        module.start(options);
      }
    });
  }
});



  return Marionette;
})(this, Backbone, _);

  return Backbone.Marionette;

}));


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_create__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__ = __webpack_require__(1529);


function _inheritsLoose(subClass, superClass) {
  subClass.prototype = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_create___default()(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__);

function _extends() {
  _extends = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default.a ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default.a.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys__);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_keys___default()(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var log = new Logger("Preconditions");

    var errorLogger = null;

    /**
     * Preconditions class for validating arguments and state.
     *
     * @class Preconditions
     */
    var Preconditions = function Preconditions() {};

    function isNotNullOrUndefined(expression) {
        return !_.isNull(expression) && !_.isUndefined(expression);
    }

    function expect(expression, errorMessage, element) {
        if (expression === false) {
            if (element) {
                log.error(errorMessage, element);
            } else {
                log.error(errorMessage);
            }

            if (errorMessage instanceof Error || !errorLogger) {
                throw errorMessage;
            } else if (errorLogger) {
                errorLogger.log(errorMessage); // only log no raised errors (above), since unhandled errors are already logged...
            }
        }

        return expression;
    }

    // Takes any argument and return its type. One of:
    // array, object, string, date, regexp, function, boolean number, null, or undefined
    function getType(element) {
        return Object.prototype.toString.call(element).slice(8, -1).toLowerCase();
    }

    function isType(expectedType, element) {
        expectedType = expectedType.toLowerCase();

        function main(element_) {
            var elementType = getType(element_);
            var errorMessage = "Expected " + expectedType + ", but got " + elementType + ". Checked argument: ";
            var elementTypeIsExpectedType = elementType === expectedType;

            expect(elementTypeIsExpectedType, errorMessage, element_);

            return element_;
        }

        return arguments.length === 1 ? main : main(element);
    }

    Preconditions.prototype = {
        setErrorLogger: function setErrorLogger(value) {
            errorLogger = value;
        },


        /**
         * Checks that the specified argument is not <tt>null</tt> or <tt>undefined</tt>.
         *
         * @param  {*}       argument       The argument to check.
         * @param  {*|[]}    [errorMessage] Optional error message(s).
         * @return {Boolean} True if the check succeeded, false if it failed.
         */
        checkArgument: function checkArgument(argument, errorMessage) {
            errorMessage = errorMessage || "Precondition failed, argument is null or undefined.";

            return expect(isNotNullOrUndefined(argument), errorMessage);
        },


        /**
         * Checks all the arguments passed to this method against <tt>checkArgument</tt>.
         *
         * @return {Boolean} True if the check succeeded for each argument, false otherwise.
         */
        checkArguments: function checkArguments() {
            var _this = this;

            var success = true;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            _.each(args, function (argument) {
                success = _this.checkArgument(argument) && success;
            });

            return success;
        },


        /**
         * Checks whether the specified instance is an instance of the specified class/constructor function.
         *
         * @param  {*} instance             The instance to check.
         * @param  {Function} expectedClass The class/constructor function that the specified instance needs
         *                                  to be an instance of.
         * @param  {[type]} errorMessage    Optional error message(s).
         *
         * @return {Boolean} True if the check succeeded, false if it failed.
         */
        instanceOf: function instanceOf(instance, expectedClass, errorMessage) {
            errorMessage = errorMessage || "Unexpected instance of " + expectedClass;

            return expect(instance instanceof expectedClass, errorMessage);
        },


        /**
         * Ensures the truth of an expression involving the state of the calling
         * instance, but not involving any parameters to the calling method.
         *
         * @param  {Boolean} expression     The argument to check.
         * @param  {*|[]}    [errorMessage] Optional error message(s).
         * @param  {*}       [element]      Optional element to log.
         * @return {Boolean} True if the check succeeded, false if it failed.
         */
        checkState: function checkState(expression, errorMessage, element) {
            return expect(_.isBoolean(expression) && expression, errorMessage || "Invalid state, expected expression to be true.", element);
        },


        /**
         * Simply calls <tt>checkState(false, errorMessage)</tt>.
         *
         * @param  {*|[]}    [errorMessage] Optional error message(s).
         * @param  {*}       [element]      Optional element to log.
         *
         * @return {Boolean} false.
         */
        fail: function fail(errorMessage, element) {
            return this.checkState(false, errorMessage, element);
        },


        /**
         * Ensures <tt>warningMessage</tt> is logged and reported via the frontend error log, if any. <p>
         *
         * This function is included here so Preconditions is sufficient to report non fatal errors as well,
         * instead of requiring the error logger to be injected into for example model instances.
         *
         * @param  {*|[]}    [warningMessage] Warnings message(s).
         * @param  {*}       [element]        Optional element to log.
         *
         * @return {Boolean} false.
         */
        warn: function warn(warningMessage, element) {
            if (element) {
                log.warn(warningMessage, element);
            } else {
                log.warn(warningMessage);
            }
            if (errorLogger) {
                errorLogger.log(warningMessage);
            }
            return false;
        },


        isType: isType,
        isString: isType("string"),
        isArray: isType("array"),
        isObject: isType("object"),
        isDate: isType("date"),
        isRegexp: isType("regexp"),
        isFunction: isType("function"),
        isBoolean: isType("boolean"),
        isNumber: isType("number"),
        isNull: isType("null"),
        isUndefined: isType("undefined"),

        // Special cases

        // Element
        isElement: function isElement(element) {
            expect(_.isElement(element), "Expected an element, got: " + element);
        },
        isElementOrTextNode: function isElementOrTextNode(element) {
            var isElement = _.isElement(element);
            var isTextNode = element && element.nodeType === 3;

            expect(isElement || isTextNode, "Expected either an element or a text node");
        },


        // jQuery Element
        is$element: function is$element(element) {
            var is$ = element.jquery; // jQuery version number
            var containsElement = !!element.get(0);

            expect(is$ && containsElement, "Expected a jQuery element, got: " + element);
        },


        // Model
        isModel: function isModel(element) {
            expect(_.isObject(element.attributes), "Expected a model");
        },


        // Collection
        isCollection: function isCollection(element) {
            expect(_.isObject(element._byId), "Expected a collection");
        },


        /**
         * Checks for truthiness of a preset condition (cond).
         *
         * @param {String|Function} cond  A string that can be evaluated to a conditional,
         *                                or a function taking one argument and returning
         *                                a "truthy" or "falsy"
         * @param {*}               value The value checked against the condition
         *
         * The function is curried, meaning these are equivalent:
         *      condition("===2", 3);
         *      condition("===2")(3);
         *
         *  Examples:
         *      condition("<2", 1);                 => true
         *      _.map([4,3,2,1], condition(">1"))   => fails when it reaches 1
         *      condition(".length === 3")("foo")   => true (the length of foo is 3)
         *
         */
        condition: function condition(cond, value) {
            // eslint-disable-next-line no-new-func
            var condition = _.isFunction(cond) ? cond : new Function("x", "return x" + cond + ";");

            function main(_value) {
                expect(!!condition(_value), ["The condition wasn't met (value was: " + _value + ").", cond]);
                return _value;
            }

            return arguments.length === 1 ? main : main(value);
        },


        /**
         * Will throw an error, if called. Use this precondition in abstract methods.
         */
        abstractMethodError: function abstractMethodError() {
            expect(false, "Abstract method, must be implemented by subclass.");
        }
    };

    return new Preconditions();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(289)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(475);
var hasOwn = __webpack_require__(114);
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);

    var _require = __webpack_require__(120),
        DateUtil = _require.DateUtil;

    var EventDispatcher = __webpack_require__(54);
    var EditorEventsConstants = __webpack_require__(1405);
    var LoggedInUserState = __webpack_require__(19);
    var Preconditions = __webpack_require__(14);

    /**
     * The singleton event bus used to track events in the editor and send events to Mix Panel
     *
     * <p>Events in this case are simple strings describing the user action. A general pattern for it is
     * [action]:[target] and must follow the format specified in EditorEventsConstants.</p>
     *
     * <p>If the event requires additional properties, pass them as a single object when triggering the event.
     * Only include primitives, as analytics engines do not necessarily support things like arrays, objects, etc.</p>
     *
     * @class EditorEvents
     * @constructor
     */
    var EditorEvents = EventDispatcher.extend({

        /**
         * Send event to MixPanel via Segment integration
         * @param {String} eventName The name of the event, built based on EventNames in EditorEventConstants, never null.
         * @param {Object} eventProperties The properties/payload to be sent to MixPanel. TriggerOrigin field is mandatory.
         */
        trigger: function trigger(eventName, eventProperties) {
            Preconditions.checkArgument(eventName);
            Preconditions.checkArgument(eventProperties);

            Preconditions.checkState(EditorEventsConstants.checkEvent(eventName), "Missing Event name from EditorEventConstants list");
            // Mandatory field
            Preconditions.checkState(!_.isUndefined(eventProperties.triggerOrigin), "Missing triggerOrigin property");

            eventProperties.timestamp = DateUtil.now();
            eventProperties.location = LoggedInUserState.get("location");

            // Remove null/undefined properties
            _.each(eventProperties, function (eventProperty, key) {
                if (_.isNull(eventProperty) || _.isUndefined(eventProperty)) {
                    delete eventProperties[key];
                }
            });

            this.__super();
        },


        constants: EditorEventsConstants.EventNames
    });

    // Singleton
    return new EditorEvents();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["f"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = splitBsPropsAndOmit;
/* unused harmony export addStyle */
/* unused harmony export _curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(74);


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.




function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];

    if (typeof last === 'function') {
      return fn.apply(void 0, args);
    }

    return function (Component) {
      return fn.apply(void 0, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return bsClass + (variant ? "-" + variant : '');
}
var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;
  return Component;
});
var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};
  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });
  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing); // expose the values on the propType function for documentation

  Component.STYLES = existing;
  propType._values = existing;
  Component.propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});
var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};
  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });
  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][size];

    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });
  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values; // expose the values on the propType function for documentation

  Component.SIZES = existing;
  Component.propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }

    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});
function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });
  var elementProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */

function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}
var _curry = curry;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Backbone = __webpack_require__(7);
    var Time = __webpack_require__(121);
    var Storage = __webpack_require__(34);

    /**
     * Trackable Editor locations.
     */
    var Location = {
        DEFAULT: "",
        LOGIN: "login",
        DASHBOARD_EXPERIENCES: "dashboard",
        DASHBOARD_IMAGES: "imageLibrary",
        DASHBOARD_PUBLISH: "publish",
        DASHBOARD_TEMPLATES: "templates",
        PROJECT_DASHBOARD_EXPERIENCES: "projectDashboardExperiences",
        PROJECT_DASHBOARD_IMAGES: "projectDashboardImages",
        PROJECT_DASHBOARD_PUBLISH: "projectDashboardPublish",
        PROJECT_CREATE: "projectCreate",
        REPORTING: "reporting",
        REPORTING_SEGMENT: "reportingSegment",
        EDIT: "edit",
        MEASURE: "measure",
        MANAGE_ACCOUNT: "manageAccount",
        PSD_IMPORT: "psdImport",
        FONTS: "fonts",
        ANALYTICS: "analytics",
        EXPORT: "export",
        BREAKPOINTS: "breakpoints",
        INTEGRATIONS: "integrations",
        PREVIEW: "preview",
        PREVIEW_TEMPLATE: "previewTemplate"
    };

    // Returns a storage key for the specified user to track last visited
    var lastVisitKey = function lastVisitKey(user) {
        return "lastVisit-" + user.get("id");
    };

    // Returns stored last visit key...
    var lastVisit = function lastVisit(user) {
        var key = lastVisitKey(user);

        return Storage.Local.get(Storage.Keys.LOGIN, key) || JSON.parse(localStorage.getItem(key)) || // legacy issue, did not use storage
        {};
    };

    /**
     * Model containing cached data for the user associated with the currently logged in principal. Once all data
     * is ready for said user, the a change event for the <tt>ready</tt> property will fire. On principal logout,
     * the change event will fire again. <p>
     *
     * Do <b>NOT</b> use the <tt>user</tt> property to test for permissions, use <tt>LoggedIn.principal()</tt> instead.
     * The <tt>user</tt> property set here is the user available via <tt>principal.get("user")</tt> once the
     * principal on question has been logged in successfully. <p>
     *
     * This model is initialized as a singleton. The rationale for this is that this information is used
     * virtually everywhere in the application, so access should be as easy as possible. The contents of the model can
     * be mocked to ensure testability. <p>
     *
     * Avoid adding dependencies to our internal classes, as we want this class to be available everywhere without
     * needing to worry about circular dependencies. As a result of this rule, the logic for fetching collections
     * associated with the user is done in AuthenticationController.<p>
     *
     * @class LoggedInUserState
     *
     * @cfg {Boolean}                       ready       Whether a principal for <tt>user</tt> has logged in *and* all global
     *                                                  data for <tt>user</tt> is guaranteed to be available.
     * @cfg {User}                          user        The user model. Do <b>NOT</b> use this user to test for permissions,
     *                                                  use <tt>LoggedIn.principal()</tt> instead!
     * @cfg {Company}                       company     The company model for the company of <tt>user</tt>.
     * @cfg {CompanySettings}               settings    The company settings model for <tt>company</tt>.
     * @cfg {Boolean}                       internal    Whether the user is logged in from an internal IP address.
     * @cfg {ExperienceMetadataCollection}  experiences The experience collection for the current user.
     * @cfg {ProjectCollection}             projects    The project collection for the current user.
     * @cfg {ImageCollection}               images      The image collection for the current user.
     */
    var LoggedInUserState = Backbone.Model.extend({

        _collectionPromiseCache: [],

        defaults: {
            ready: false,
            user: null,
            company: null,
            companySettings: null,
            experiences: null,
            projects: null,
            images: null,

            /**
             * @type IntegrationCollection
             */
            integrations: null,

            location: Location.DEFAULT,
            lastVisit: {}
        },

        /**
         * Sets the user model to the given user, updating related properties. <p>
         *
         * This does not trigger a change event for <tt>ready</tt>, as other things like loading global collections
         * needs to be done first (externally to this class).
         *
         * @param {User} user The user associated with the currently logged in principal; cannot be null.
         */
        setUser: function setUser(user) {
            this.set({
                user: user,
                lastVisit: lastVisit(user)
            });
        },


        /**
         * Clear all states, reverting to the default values. This is called when the AuthenticationController
         * logs a principal out. <p>
         *
         * This will trigger (among others) a change event for <tt>ready</tt>.
         */
        clear: function clear() {
            this.set(this.defaults);
            this._collectionPromiseCache = [];
        },


        /**
         * Register a visit to an experience.
         *
         * @param {String} experienceId The ID of the experience visited.
         * @param {number} [offset] Offset to add to the timestamp. Defaults to 0.
         */
        registerExperienceVisit: function registerExperienceVisit(experienceId, offset) {
            if (experienceId) {
                var _lastVisit = this.get("lastVisit");

                // Initialize experience object if not already registered
                if (!_lastVisit[experienceId] || !_lastVisit[experienceId].sceneVisits) {
                    _lastVisit[experienceId] = { sceneVisits: {} };
                }

                _lastVisit[experienceId].visit = Time.server() + (offset || 0);
                this.set("lastVisit", _lastVisit);
                Storage.Local.update(Storage.Keys.LOGIN, lastVisitKey(this.get("user")), _lastVisit);
            }
        },


        /**
         * Register a visit to a scene.
         * @param {String} experienceId The ID of the experience containing the scene.
         * @param {String} sceneId The ID of the scene.
         */
        registerSceneVisit: function registerSceneVisit(experienceId, sceneId) {
            if (experienceId && sceneId) {
                var _lastVisit2 = this.get("lastVisit");

                if (_lastVisit2[experienceId]) {
                    _lastVisit2[experienceId].sceneVisits[sceneId] = _lastVisit2[experienceId].visit;
                    this.set("lastVisit", _lastVisit2);
                    Storage.Local.update(Storage.Keys.LOGIN, lastVisitKey(this.get("user")), _lastVisit2);
                }
            }
        },


        /**
         * Gets an object describing the last visit to an experience and its scenes.
         *
         * <p>The object contains the following properties:</p>
         * <ul>
         *     <li><b>visit</b>: The timestamp of the last visit to the experience in server time. Will be 0 if the experience has not been visited.</li>
         *     <li><b>sceneVisits</b>: A hash of scene ID to last visit to the scene. Will be empty if the experience has not been visited.</li>
         * </ul>
         *
         * @param {String} experienceId The ID of the experience.
         * @returns {Object} Object as described above.
         */
        getLastExperienceVisit: function getLastExperienceVisit(experienceId) {
            var experienceLastVisit = this.get("lastVisit")[experienceId];

            if (experienceLastVisit) {
                // Clone to decouple the objects
                return JSON.parse(JSON.stringify(experienceLastVisit));
            }

            return { visit: 0, sceneVisits: {} };
        },


        /**
         * Fetches a collection that should be cached globally. For example, pass a UserCollection to get the collection
         * of users on the same company as the logged-in user.
         *
         * @param {Function} Type A type of collection to fetch.
         * @returns {Promise} A promise that will resolve to the fetched collection.
         */
        fetchGlobalCollection: function fetchGlobalCollection(Type) {
            var collectionPromise = void 0;

            // Attempt to find it in the cache
            _.every(this._collectionPromiseCache, function (cachedCollectionPromise) {
                if (cachedCollectionPromise.Type === Type) {
                    collectionPromise = cachedCollectionPromise;

                    // Don't bother checking the next promise
                    return false;
                }

                // Check the next promise
                return true;
            });

            // If not found, create it and push it into the cache
            if (!collectionPromise) {
                collectionPromise = $.Deferred(function (deferred) {
                    var collection = new Type();
                    collection.fetch().done(function () {
                        deferred.resolve(collection);
                    });
                }).promise();
                collectionPromise.Type = Type;
                this._collectionPromiseCache.push(collectionPromise);
            }

            return collectionPromise;
        },


        /**
         * Invalidates the cached global collection of the given type, so it will be fetched from the server the next
         * time someone requests it.
         *
         * @param {Function} Type A type of collection to invalidate.
         */
        invalidateGlobalCollection: function invalidateGlobalCollection(Type) {
            this._collectionPromiseCache = _.filter(this._collectionPromiseCache, function (cachedCollectionPromise) {
                return cachedCollectionPromise.Type !== Type;
            });
        },


        Location: Location

    });

    // Singleton
    return new LoggedInUserState();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chainPropTypes__ = __webpack_require__(563);
/* unused harmony reexport chainPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepmerge__ = __webpack_require__(1804);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__deepmerge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elementAcceptingRef__ = __webpack_require__(1805);
/* unused harmony reexport elementAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elementTypeAcceptingRef__ = __webpack_require__(1806);
/* unused harmony reexport elementTypeAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exactProp__ = __webpack_require__(1807);
/* unused harmony reexport exactProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__ = __webpack_require__(1808);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__formatMuiErrorMessage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getDisplayName__ = __webpack_require__(1809);
/* unused harmony reexport getDisplayName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HTMLElementType__ = __webpack_require__(1810);
/* unused harmony reexport HTMLElementType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ponyfillGlobal__ = __webpack_require__(1811);
/* unused harmony reexport ponyfillGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__refType__ = __webpack_require__(1812);
/* unused harmony reexport refType */
/** @license Material-UI v4.11.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */











/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);

    /**
     * Utility class for Promises/Deferreds. Also defines the Promise class to stop IntelliJ warning about it not being found.
     *
     * The actual Promise/Deferred class is from jQuery, see <a href="http://api.jquery.com/category/deferred-object/">jQuery Deferred documentation</a>.
     *
     * @author Bo Gotthardt
     * @class Promise
     * @constructor
     */
    function Promise() {}

    /**
     * See <a href="http://api.jquery.com/deferred.then/">deferred.then()</a>.
     *
     * @param {Function} doneFilter
     * @param {Function} [failFilter]
     * @param {Function} [progressFilter]
     */
    // eslint-disable-next-line no-unused-vars
    Promise.prototype.then = function (doneFilter, failFilter, progressFilter) {};
    /**
     * See <a href="http://api.jquery.com/deferred.done/">deferred.done()</a>.
     *
     * @param {Function} callback
     */
    // eslint-disable-next-line no-unused-vars
    Promise.prototype.done = function (callback) {};
    /**
     * See <a href="http://api.jquery.com/deferred.fail/">deferred.fail()</a>.
     *
     * @param {Function} callback
     */
    // eslint-disable-next-line no-unused-vars
    Promise.prototype.fail = function (callback) {};
    /**
     * See <a href="http://api.jquery.com/deferred.progress/">deferred.progress()</a>.
     *
     * @param {Function} callback
     */
    // eslint-disable-next-line no-unused-vars
    Promise.prototype.progress = function (callback) {};
    /**
     * See <a href="http://api.jquery.com/deferred.always/">deferred.always()</a>.
     *
     * @param {Function} callback
     */
    // eslint-disable-next-line no-unused-vars
    Promise.prototype.always = function (callback) {};

    // TODO Fix these to work with any number of arguments.
    // There seems to be a problem with new $.Deferred().reject.apply() returning window.
    /**
     * Create a rejected promise.
     *
     * @static
     *
     * @param {*} [arg]
     * @return {Promise}
     */
    Promise.rejected = function (arg) {
        return new $.Deferred().reject(arg).promise();
    };

    /**
     * Create a resolved promise.
     *
     * @static
     *
     * @param {*} [arg]
     * @return {Promise}
     */
    Promise.resolved = function (arg) {
        return new $.Deferred().resolve(arg).promise();
    };

    /**
     * Creates a rejected or resolved promise depending on the "truthness" of <tt>rejected</tt>.
     *
     * @param {*}       rejected Truthy to create a rejected promise, falsey to create a resolved promise.
     * @param {*}       [arg]    The optional argument to reject or resolve.
     * @return {Promise} The rejected/resolved promise; never falsey.
     */
    Promise.completed = function (rejected, arg) {
        if (rejected) {
            return Promise.rejected(arg);
        }

        return Promise.resolved(arg);
    };

    /**
     * Creates a new deferred that can be signalled as resolved or rejected, optionally with the supplied
     * extended properties. If a deferred worker is supplied as the first argument, a promise will be returned
     * instead, as the worker will be called with the created deferred and can thus resolve or reject the
     * backing deferred.
     *
     * @param  {Function|*} [worker] Optional deferred worker to be called by the deferred as itself as the sole argument.
     *                               The worker can then resolve or reject the deferred as required. If not a function,
     *                               assumed to be <tt>props</tt>.
     * @param  {*}          [props]  The additional (key,value) property pairs to augment the returned deferred with,
     *                               if any. Can also be supplied as the first argument if no worker is used.
     *                               Use carefully - will override existing deferred properties like "resolve",
     *                               "reject", etc.!
     * @return {$.Deferred|Promise} A newly created (augmented) deferred, or a promise for said deferred if
     *                              <tt>worker</tt> is supplied; never null.
     *
     * @see     #create
     */
    Promise.deferred = function (worker, props) {
        if (!_.isFunction(worker)) {
            props = worker;
            worker = undefined;
        }
        var deferred = new $.Deferred(worker);
        if (props) {
            _.extend(deferred, props);
        }
        return worker ? deferred.promise() : deferred;
    };

    /**
     * Creates a new promise from the supplied deferred, optionally with the supplied extended properties.
     *
     * @param  {$.Deferred} deferred The deferred to get the promise for; cannot be falsey.
     * @param  {*}          [props]  The additional (key,value) property pairs to augment the returned promise with,
     *                               if any. Use carefully - will override existing deferred properties like "done",
     *                               "fail", etc.!
     * @return {Promise} A newly created (augmented) promise for <tt>deferred</tt>; never null.
     *
     * @see     #deferred
     */
    Promise.create = function (deferred, props) {
        var promise = deferred.promise();
        if (props) {
            _.extend(promise, props);
        }
        return promise;
    };

    /**
     * Set up the specified list of subordinate deferreds to progress the combined deferred when done.
     *
     * @param {*[]} subordinates
     * @param {Deferred} combinedDeferred
     */
    function notification(subordinates, combinedDeferred) {
        var numDone = 0;

        _.each(subordinates, function (subordinate) {
            // The subordinates can be both promises and already computed synchronous values.
            // This is the same check as in $.when().
            if (Promise.isPromise(subordinate)) {
                subordinate.done(function (arg) {
                    numDone++;
                    combinedDeferred.notify.call(combinedDeferred, arg, numDone / subordinates.length);
                });
            } else {
                numDone++;
                combinedDeferred.notify.call(combinedDeferred, subordinate, numDone / subordinates.length);
            }
        });
    }

    /**
     * An improved version of $.when() that returns the values as a single list. <p>
     *
     * Also progresses when individual subordinates are done. The progress event will have the resolved Promise's
     * value and the percentage of subordinates that are done as parameters. <p>
     *
     * Note that due to the way progress() behaves, this function has a rather subtle gotcha when one or more of
     * the subordinates are done already (i.e. non-Promises or already resolved Promises).
     * These will then trigger the progress events <b>synchronously</b> while inside this function call. And unlike
     * done() and fail(), progress() handlers attached later are not called with previously triggered events.
     * So it is therefore not guaranteed how many progress events the caller will actually get, unless they create
     * their own deferred, set up a progress handler and only then pass it as the combinedDeferred parameter.
     *
     * @static
     *
     * @param {*[]} subordinates The list of subordinates, either Promises or arbitrary values.
     * @param {Deferred} [combinedDeferred] The "combined" deferred (not Promise) to use, instead of creating it internally.
     * @return {Promise} A promise for the list of the values of all the subordinates.
     *                   The promise interface of combinedDeferred if that was passed.
     */
    Promise.all = function (subordinates, combinedDeferred) {
        // We would like the returned promise to progress whenever an individual promise has resolved, but $.when()
        // does not support that. So we have to create our own deferred that can be resolved by $.when(), and
        // progressed by done() from the individual promises.
        combinedDeferred = combinedDeferred || new $.Deferred();

        notification(subordinates, combinedDeferred);

        $.when.apply(undefined, subordinates).done(function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            // Return the subordinates' values as one list, instead of as individual arguments.
            combinedDeferred.resolve(Array.prototype.slice.call(args, 0));
        }).fail(combinedDeferred.reject);

        return combinedDeferred.promise();
    };

    /**
     * Returns a new promise from the one specified, that will check/call the provided predicate
     * to perform a truth test. If the test fails (predicate returns <tt>false</tt>), the promise
     * will be rejected.
     *
     * @param  {Promise} promise The promise to intercept and filter based on <tt>predicate</tt>; cannot be falsey.
     * @param  {Function|{predicate:Function, resolve: Function([])->Object, reject:*}} predicate The predicate callback
     *              performing the truth test, or as options storing said predicate, optional <tt>resolve</tt> function
     *              to return resolved value based on arguments supplied to the "then" handler, and optional
     *              <tt>reject</tt> property storing value to reject when <tt>predicate()</tt> returns a non-truthy
     *              value. If <tt>resolve</tt> is not specified, the first argument passed to the "then" handler
     *              will be resolved (returned).
     * @return {Promise} The new promise to use in place of <tt>promise</tt>; never falsey.
     */
    Promise.predicate = function (promise, predicate) {
        var options = _.isFunction(predicate) ? { predicate: predicate, resolve: null, reject: null } : predicate;

        // Make sure we have a resolve function...
        if (!_.isFunction(options.resolve)) {
            options.resolve = function (args) {
                return args[0];
            };
        }

        return promise.then(function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            try {
                // All good, pass on argument (if any) and return
                if (options.predicate()) {
                    return options.resolve(args);
                }
                return Promise.rejected(options.reject);
            } catch (error) {
                // If an error occurs during execution of the callback
                return Promise.rejected(options.reject || error);
            }
        });
    };

    /**
     * Alternative version of $.when() that always resolves with a list of the return vales of the subordinates that resolved.
     *
     * Also progresses when individual subordinates are done. The progress event will have the resolved Promise's
     * value and the percentage of subordinates that are done as parameters.
     *
     * See Promise.all() for a note on how the progress events work.
     *
     * @static
     *
     * @param {*[]} subordinates The list of subordinates, either Promises or arbitrary values.
     * @param {Deferred} [combinedDeferred] The "combined" deferred (not Promise) to use, instead of creating it internally.
     * @return {Promise} A promise for a list of the values of the subordinates that resolved.
     */
    Promise.any = function (subordinates, combinedDeferred) {
        combinedDeferred = combinedDeferred || new $.Deferred();

        notification(subordinates, combinedDeferred);

        subordinates = _.map(subordinates, function (subordinate) {
            if (Promise.isPromise(subordinate)) {
                // Always resolve subordinates rather than reject so the when() deferred always resolves.
                return subordinate.then(null, function () {
                    return Promise.resolved();
                });
            }
            return subordinate;
        });

        $.when.apply(this, subordinates).done(function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            // Return the subordinates as one list, instead of as individual arguments.
            // Filter out empty values caused by the resolution above.
            combinedDeferred.resolve(Array.prototype.filter.call(args, function (item) {
                return item !== undefined;
            }));
        });

        return combinedDeferred.promise();
    };

    /**
     * @static
     * Determine whether the specified argument is a Promise.
     *
     * @param {*} possiblePromise The object to test if a promise; can be falsey. Note that a $.Deferred type will also
     *                            cause true to be returned.
     * @return {Boolean} True if a promise, false otherwise.
     */
    Promise.isPromise = function (possiblePromise) {
        return possiblePromise && _.isFunction(possiblePromise.promise);
    }; // This is how jQuery#when() does it internally.

    /**
     * @static
     * Determine whether the specified argument is a $.Deferred type (thus also doubling as a promise for itself).
     *
     * @param {*} possibleDeferred The object to test if a deferred; can be falsey. Note that a Promise type will not
     *                              cause true to be returned, but false (unless also a $.Deferred).
     * @return {Boolean} True if a deferred (and promise), false otherwise.
     */
    Promise.isDeferred = function (possibleDeferred) {
        return possibleDeferred && _.isFunction(possibleDeferred.resolve);
    };

    /**
     * Whether the specified promise has a pending state, i.e. <tt>promise.state() === "pending"</tt>.
     *
     * @param  {Promise}  promise The promise to check.
     * @return {Boolean}          <tt>true</tt> if the specified promise has a pending state, <tt>false</tt> if not.
     */
    Promise.isPending = function (promise) {
        return promise.state() === Promise.State.PENDING;
    };

    /**
     * Takes a deferred and creates a new promise which will time out after the specified ms, to be rejected with
     * the specified value, if any, after said timeout if not already resolved or rejected. <p>
     *
     * The returned promise will be augmented with a <tt>clearTimeout()</tt> function that will clear the timeout,
     * if so needed, and an <tt>age()</tt> function that will return the promise age in ms (can be larger than
     * the timeout). <p>
     *
     * Note: the return value from this function (<tt>Promise</tt>) differs from that of <tt>timeout(..)</tt>!
     *
     * @param  {Deferred} deferred  The deferred create a timed promise for; cannot be falsey.
     * @param  {Number}   [timeout] The timeout in ms; defaults to 20s.
     * @param  {*}        [arg]     Optional value to reject; can be falsey, will default to "timeout".
     *
     * @return {Promise} A new promise that will timeout; never null. Will be augmented
     *                   with a <tt>clearTimeout()</tt> function to explicitly clear the timeout if needed.
     */
    Promise.timeout = function (deferred, timeout, arg) {
        var promise = deferred.promise();
        Promise.time(deferred, promise, timeout, arg);
        return promise;
    };

    /**
     * Takes a deferred and pre-existing promise and ensures the deferred will be rejected with the supplied argument
     * after the specified timeout in ms from "now" if and only if the supplied pre-existing promise is still pending
     * after said timeout. <p>
     *
     * <tt>promise</tt> need not have been created by <tt>deferred</tt>. <p>
     *
     * <tt>promise</tt> will be augmented with a <tt>clearTimeout()</tt> function that will clear the timeout,
     * if so needed, and an <tt>age()</tt> function to returns its age in ms (can be larger than timeout). If
     * <tt>promise</tt> already has an old associated timeout, i.e. this function already called for it, it will
     * be cleared before the new timeout is set ("re-start"). On timeout or when <tt>promise</tt> is resolved,
     * <tt>clearTimeout</tt> will be removed from <tt>promise</tt> again.
     *
     * Note: the return value from this function (<tt>Function</tt>) differs from that of <tt>time(..)</tt>!
     *
     * @param  {Deferred} deferred  The deferred to reject on timeout of <tt>promise</tt>; cannot be falsey.
     * @param  {Promise}  promise   A pre-existing promise, which does not have to be a promise for <tt>deferred</tt>,
     *                              that must be completed with <tt>timeout</tt> or <tt>deferred</tt> will be
     *                              rejected; cannot be falsey.
     * @param  {Number}   [timeout] The timeout in ms; defaults to 20s.
     * @param  {*}        [arg]     Optional value to reject; can be falsey, will default to "timeout".
     *
     * @return {Function} the <tt>clearTimeout()</tt> function also set on <tt>promise</tt>; never falsey.
     */
    Promise.time = function (deferred, promise, timeout, arg) {
        var timer = void 0;
        var time = timeout || 20000;

        // Timeout callback...
        var callback = function callback() {
            clear();
            // Must still be pending to be rejected, e.g. could have been resolved...
            if (Promise.isPending(promise)) {
                deferred.reject(typeof arg === "undefined" ? "timeout" : arg); // to allow 0 (number)
            }
        };

        // Clear timeout callback...
        var clear = function clear() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
                delete promise.clearTimeout;
            }
            return promise.age();
        };

        var start = Date.now();

        // Clear old timeout on promise re-use...
        if (_.isFunction(promise.clearTimeout)) {
            promise.clearTimeout();
        }

        // Augment with (new) "clearTimeout" function to let the context explicitly clear the timeout if needed,
        // and we give it a nice "toString" function to easily see the current promise age/state...
        promise.clearTimeout = clear;
        promise.age = function () {
            return Date.now() - start;
        };
        promise.toString = function () {
            return "Promise[state: " + promise.state() + "; age: " + promise.age() + "/" + time + "]";
        };

        if (time >= 0) {
            timer = setTimeout(callback, time);

            // Negative time means timeout...
        } else {
            callback();
        }

        // Make sure we clear timeout on completion. If "promise" is already complete, this will actually call "clear"
        // and clean up...
        promise.always(clear);

        return clear;
    };

    /**
     * Enumeration describing the promise state(s), as the values returned by <tt>promise.state()</tt>.
     *
     * @type {Object}
     */
    Promise.State = {
        // The Deferred object can be in one of three states.
        PENDING: "pending",
        RESOLVED: "resolved",
        REJECTED: "rejected"
    };

    return Promise;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var LoggedIn = __webpack_require__(31);
    var Class = __webpack_require__(26);
    var Enum = __webpack_require__(77);

    /**
     * Returns true if the supplied set of roles/role names or privileges/privilege names are the same,
     * false otherwise. The test is done on instances, secondarily on names only, case-sensitive.
     *
     * @param {Role|Privilege}        scope   The role or privilege to test against a supplied role, privilege, or name;
     *                                        never null.
     * @param {Role|Privilege|String} [other] The role, privilege, or name to test against <tt>scope</tt>; a falsey value
     *                                        will cause false to be returned.
     * @return {Boolean} True if the same role/privilege, false otherwise.
     */
    function _is(scope, other) {
        if (scope === other) {
            return true;
        }

        if (typeof other === "string") {
            return other === scope.name;
        } else if (other) {
            return other.name === scope.name;
        }

        return false;
    }

    /**
     * Tests the required array of privileges against the granted privileges, and returns true
     * if all privileges in <tt>required</tt> (and maybe more) are contained in the granted array
     * of privileges, false otherwise.
     *
     * @param  {Privilege[]} required The required privileges; never null, but can be empty.
     * @param  {Privilege[]} granted  The granted privileges; never null, but can be empty.
     * @return {Boolean} True if <tt>granted</tt> contains at least all the privileges in <tt>required</tt>,
     *                   false otherwise.
     */
    function has(required, granted) {
        // No required privileges, "object" has access...
        if (!required.length) {
            return true;
        }
        // Find the privileges granted to "object": "required" must contain all of these for this function to
        // return true, but more may be contained...
        var n = required.length;
        var m = granted.length;

        var privilege = void 0;
        var i = void 0;
        var j = void 0;

        // If more privileges are required than granted, we can return false immediately...
        if (n > m) {
            return false;
        }
        // Test each required privilege...
        loop: for (i = 0; i < n; i++) {
            privilege = required[i];
            // Against each granted one; this is O(n2), but we operate with few privileges, so it will suffice for now...
            for (j = 0; j < m; j++) {
                if (privilege === granted[j]) {
                    continue loop;
                }
            }
            return false;
        }
        return true;
    }

    /**
     * Returns the role granted to the supplied object, if any. <p>
     *
     * The granted role is deduced as: <ol>
     *
     * <li> If <tt>object</tt> is falsey, the role of the currently logged in principal is returned, if any.
     * <li> If <tt>object</tt> is otherwise falsey, null is returned.
     * <li> If <tt>object</tt> is a role, the role is returned.
     * <li> If <tt>object</tt> is a string, the role with said name is returned.
     * <li> If <tt>object</tt> is an object declaring a raw "role" property, this function is called
     *      recursively with the value of said property as "object".
     * <li> If <tt>object</tt> is a Backbone model declaring a "role" property, this function is called
     *      recursively with the value of said property as "object".
     * </ol>
     *
     * @param  {Principal|Role|String|*} object     The object to get the role for; can be falsey.
     * @param  {Boolean}                [recursive] True when called recursively, false otherwise.
     * @return {Role} The role; can be null.
     */
    function getGrantedRole(object, recursive) {
        // Falsey, e.g. when a principal has not logged in...
        if (object) {
            // Role...
            if (object instanceof Role) {
                return object;
                // Role name, not principal name...
            } else if (typeof object === "string") {
                return Roles[object] || new Role(object); // Create new role, but with no privileges!
                // Recurse for raw "role" property...
            } else if (object.role) {
                return getGrantedRole(object.role, true);
                // Recurse for Backbone model "role" property; this will also catch Principal!...
            } else if (typeof object.get === "function") {
                return getGrantedRole(object.get("role"), true);
            }
        } else if (!recursive) {
            return getGrantedRole(LoggedIn.principal(), true);
        }
        return null;
    }

    /**
     * Returns the privileges granted to the supplied object, if any. <p>
     *
     * The granted privileges are deduced as: <ol>
     *
     * <li> If <tt>object</tt> is falsey, the privileges of the currently logged in principal are returned, if any.
     * <li> If <tt>object</tt> is otherwise falsey, an empty array is returned.
     * <li> If <tt>object</tt> is a role, the privileges of the role are returned.
     * <li> If <tt>object</tt> is a privilege, an array with only said privilege is returned.
     * <li> If <tt>object</tt> is a string, the privileges of the role with said name are returned.
     * <li> If <tt>object</tt> is an object declaring a raw "role" property, this function is called
     *      recursively with the value of said property as "object".
     * <li> If <tt>object</tt> is a Backbone model declaring a "role" property, this function is called
     *      recursively with the value of said property as "object".
     * </ol>
     *
     * @param  {Principal|Role|Privilege|String|*} object The object to get the privileges for; can be falsey.
     * @return {Privilege[]} The array of privileges; never null, but can be empty.
     */
    function getGrantedPrivileges(object) {
        if (object instanceof Privilege) {
            return [object];
        }
        var role = getGrantedRole(object);
        return role === null ? [] : role._privileges;
    }

    /**
     * @private
     * @constructor
     * A <i>role</i> describes a potentially empty set of privileges assigned to a guarded entity,
     * like a principal. <p>
     *
     * A role can also be assigned to other type of guarded entities, but access enforcement is always done
     * with respect to a principal. A user, for example, also has a role describing the role assigned to the user,
     * but a user will never be checked for the role, only via the principal logged in on behalf of the user. <p>
     *
     * To test if the current logged in principal, if any, has <b>at least</b> all the privileges of a given role,
     * simply do:
     * <pre>
     *    if (Permissions.Roles.MANAGER.can()) {
     *        // principal has all the privileges of the manager role
     *    }
     *    ..
     *    if (Permissions.Roles.PUBLISHER.cannot()) {
     *        // principal does not have all the privileges of the publisher role
     *    }
     * </pre>
     *
     * In addition, any entity model declaring a raw or Backbone <tt>role</tt> property storing a role name or
     * an actual role, a role name, a role, or a privilege can all be tested against this role in the same
     * way, like:
     * <pre>
     *    var entity = {role: "Manager", ..};
     *    if (Permissions.Roles.PUBLISHER.can(entity)) {
     *        // "entity" has at least the all the privileges of the publisher role since manager
     *    }
     *    ..
     *    var user = new User(..); // e.g. user.get("role")
     *    if (Permissions.Roles.CREATOR.cannot(user)) {
     *        // "user" does not have the all the privileges of the creator role
     *    }
     *    ..
     *    var privilege = Permissions.Privileges.Publish;
     *    if (Permissions.Roles.ADMIN.can(privilege)) {
     *        // true
     *    }
     *    if (Permissions.Roles.ADMIN.cannot(privilege)) {
     *        // false
     *    }
     *    ..
     * </pre>
     *
     * All roles are exposed under <tt>Permissions.Roles.all()</tt>.
     *
     * @param {String}       name        The name of this role; never null.
     * @param {Privilege[]} [privileges] The privileges associated with this role; can be null, i.e. none. Immutable,
     *                                   never changes once assigned.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    var Role = Class.extend({

        /**
         * @type {String}
         * The read-only name of this role; never null.
         */
        name: null,

        /**
         * @private
         * @type {Privilege[]}
         * The privileges associated with this role; never null, but can be empty. No duplicates.
         */
        _privileges: null,

        constructor: function constructor(name, privileges) {
            this.name = name;
            this._privileges = privileges || [];
        },


        /**
         * Returns true if this role is the same role as the role granted to the supplied object, and thus
         * can perform the action(s) guarded by it, false otherwise. <p>
         *
         * The comparison is done on role name only, case-sensitive.
         *
         * @param  {Principal|Role|String|*} [object] The role or object granted to the role to test; will default to
         *                                            the role of the currently logged in principal, if any. A string
         *                                            means a role name.
         * @return {Boolean} True if the same role, false if it is not.
         * @see    #not
         */
        is: function is(object) {
            return _is(this, getGrantedRole(object));
        },


        /**
         * Returns true if this role is not the same role as the role granted to the supplied object, and thus
         * cannot perform the exact action(s) guarded by it, false if it is. <p>
         *
         * The comparison is done on role name only, case-sensitive.
         *
         * @param  {Principal|Role|String|*} [object] The role or object granted to the role to test; will default to the
         *                                            role of the currently logged in principal, if any. A string means
         *                                            a role name.
         * @return {Boolean} True if not the same role, false if it is.
         * @see    #is
         */
        not: function not(object) {
            return !this.is(object);
        },


        /**
         * Returns true if the supplied object has at least all the privileges granted to this role, and can
         * thus perform the action(s) guarded by this role, false otherwise
         *
         * @param  {Principal|Role|Privilege|String|*} [object] The object to test; will default to the currently
         *                                                      logged in principal, if any. A string means a role name.
         * @return {Boolean} True if the (defaulted) object has at least all the privileges granted to this role,
         *                   false otherwise.
         * @see    #cannot
         */
        can: function can(object) {
            return has(this._privileges, getGrantedPrivileges(object));
        },


        /**
         * Returns true if the supplied object does not have all the privileges granted to this role, and thus cannot
         * perform the action(s) guarded by this role, false otherwise
         *
         * @param  {Principal|Role|Privilege|String|*} [object] The object to test; will default to the currently logged
         *                                                      in principal, if any. A string means a role name.
         * @return {Boolean} True if the (defaulted) object does not have all the privileges granted to this role,
         *                   false otherwise.
         * @see    #can
         */
        cannot: function cannot(object) {
            return !this.can(object);
        },


        /**
         * Returns the string representation of this role.
         *
         * @return {String} The string representation; never null.
         */
        toString: function toString() {
            return this.name;
        }
    });

    /**
     * @private
     * @constructor
     * A <i>privilege</i> describes a given permission assigned to a role. <p>
     *
     * To test if the current logged in principal, if any, has a given privilege, simply do:
     * <pre>
     *    if (Permissions.Privilege.PUBLISH.can()) {
     *        // principal has the privilege to publish
     *    }
     *    ..
     *    if (Permissions.Privilege.CREATE.cannot()) {
     *        // principal does not have the privilege to create
     *    }
     * </pre>
     *
     * In addition, any entity model declaring a raw or Backbone <tt>role</tt> property storing a role name or
     * an actual role, a role name, a role, or a privilege can all be tested against this privilege in the same
     * way, like:
     * <pre>
     *    var entity = {role: "Manager", ..};
     *    if (Permissions.Privilege.PUBLISH.can(entity)) {
     *        // "entity" has the privilege to publish
     *    }
     *    ..
     *    var user = new User(..); // e.g. user.get("role")
     *    if (Permissions.Privilege.CREATE.cannot(user)) {
     *        // "user" does not have the privilege to create
     *    }
     *    ..
     *    var role = Permissions.Roles.PUBLISHER;
     *    if (Permissions.Privilege.ADMIN.can(role)) {
     *        // always false
     *    }
     *    if (Permissions.Privilege.ADMIN.cannot(role)) {
     *        // always true
     *    }
     * </pre>
     *
     * All privileges are exposed under <tt>Permissions.Privileges.all()</tt>.
     *
     * @param {String} name The name of this privilege; never null.
     */
    var Privilege = Class.extend({

        /**
         * @type {String}
         * The read-only case-sensitive name of this privilege; never null.
         */
        name: null,

        constructor: function constructor(name) {
            this.name = name;
        },


        /**
         * Returns true if the supplied privilege or privilege name is the same as this privilege,
         * false if it is not. <p>
         *
         * The comparison is case-sensitive.
         *
         * @param {String|Privilege} privilege The privilege or privilege name to test against this privilege;
         *                                     a falsey value will cause false to be returned.
         * @return {Boolean} True if the same privilege, false if it is not.
         * @see    #not
         */
        is: function is(privilege) {
            return _is(this, privilege);
        },


        /**
         * Returns true if the supplied privilege or privilege name is not the same as this privilege,
         * false if it is. <p>
         *
         * The comparison is case-sensitive.
         *
         * @param {String|Privilege} privilege The privilege or privilege name to test against this privilege;
         *                                     a falsey value will cause true to be returned.
         * @return {Boolean} True if not the same privilege, false if it is.
         * @see    #is
         */
        not: function not(privilege) {
            return !this.is(privilege);
        },


        /**
         * Returns true if the supplied object has this privilege and can perform the action guarded by it,
         * false otherwise.
         *
         * @param  {Principal|Role|Privilege|String|*} [object] The object to test; will default to the currently logged
         *                                                      in principal, if any. A string means a role name.
         * @return {Boolean} True if (the defaulted) object has this privilege, false otherwise.
         * @see    #cannot
         */
        can: function can(object) {
            // The required privileges are just this privilege, and the granted ones those from the object...
            return has([this], getGrantedPrivileges(object));
        },


        /**
         * Returns true if the supplied object does not have this privilege and cannot perform the action guarded by it,
         * false otherwise.
         *
         * @param  {Principal|Role|Privilege|String|*} [object] The object to test; will default to the currently logged
         *                                                      in principal, if any. A string means a role name.
         * @return {Boolean} True if (the defaulted) object does not have this privilege, false otherwise.
         * @see    #can
         */
        cannot: function cannot(object) {
            return !this.can(object);
        },


        /**
         * Returns the string representation of this privilege.
         *
         * @return {String} The string representation; never null.
         */
        toString: function toString() {
            return this.name;
        }
    });

    /**
     * @private
     * @type {*}
     * The supported privileges, indexed by their actual name. <p>
     *
     * Each role with have an associated array of privileges.
     */
    var Privileges = {
        Create: new Privilege("Create"),
        Publish: new Privilege("Publish"),
        Admin: new Privilege("Admin"),
        SiteAdmin: new Privilege("SiteAdmin"),
        Unobtainable: new Privilege("Unobtainable") // not assigned to any principal, so testing against this privilege will always fail!
    };

    /**
     * @private
     * @type {*}
     * All supported roles, where associated privileges are indexed by the actual role name for fast lookup. <p>
     *
     * At principal creation time, any role not defined here, will be assigned to the principal, but without any
     * associated privileges!
     */
    var Roles = {
        Spectator: new Role("Spectator"),
        Creator: new Role("Creator", [Privileges.Create]),
        Publisher: new Role("Publisher", [Privileges.Create, Privileges.Publish]),
        Manager: new Role("Manager", [Privileges.Create, Privileges.Publish, Privileges.Admin]),
        SiteManager: new Role("SiteManager", [Privileges.Create, Privileges.Publish, Privileges.Admin, Privileges.SiteAdmin])
    };

    /**
     * @type {*}
     * All supported roles and privileges as exposed by this module.
     */
    var Permissions = {

        /**
         * Defines all privileges.
         */
        Privileges: Enum.create("Privilege", "name", {

            CREATE: Privileges.Create,
            PUBLISH: Privileges.Publish,
            ADMIN: Privileges.Admin,
            SITEADMIN: Privileges.SiteAdmin,
            UNOBTAINABLE: Privileges.Unobtainable

        }, {

            /**
             * Returns the privilege identified by the supplied privilege or name, or null if unknown.
             *
             * @param {String|Privilege} privilege The privilege name or privilege to find; a falsey value will return null.
             * @return {Privilege} The corresponding privilege; or null if not found.
             */
            of: function of(privilege) {
                if (privilege instanceof Privilege) {
                    return privilege;
                } else if (!privilege) {
                    return null;
                }
                return Privileges[privilege] || null;
            }
        }),

        /**
         * Defines all known roles. <p>
         *
         * At runtime, new roles may be created based on an unknown role name, but if so, will always be associated
         * with an empty array of privileges.
         */
        Roles: Enum.create("Role", "name", {

            SPECTATOR: Roles.Spectator,
            CREATOR: Roles.Creator,
            PUBLISHER: Roles.Publisher,
            MANAGER: Roles.Manager,
            SITEMANAGER: Roles.SiteManager

        }, {

            /**
             * Returns the role granted to the supplied object, if any, defaulting to Spectator. <p>
             *
             * The role is deduced as: <ol>
             *
             * <li> If <tt>object</tt> is falsey, the Spectator role is returned.
             * <li> If <tt>object</tt> is a role, the role is returned.
             * <li> If <tt>object</tt> is a string, the role with said name is returned. If no such role exist, a
             *      new role is created with the name, but <b>no</b> privileges.
             * <li> If <tt>object</tt> is an object declaring a raw "role" property, this function is called
             *      recursively with the value of said property as "object".
             * <li> If <tt>object</tt> is a Backbone model declaring a "role" property, this function is called
             *      recursively with the value of said property as "object".
             * </ol>
             *
             * @param  {Principal|Role|String|*} object The object to get the role for; can be falsey, in which
             *                                          case Spectator is returned.
             * @return {Role} The corresponding role; never null.
             */
            of: function of(object) {
                // true argument: Do *not* default to the logged in principal here...
                return getGrantedRole(object, true) || Roles.Spectator;
            },
            can: function can(role, object) {
                return Permissions.Roles.of(role).can(object);
            },
            cannot: function cannot(role, object) {
                return Permissions.Roles.of(role).cannot(object);
            }
        })
    };

    return Permissions;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES5Type = __webpack_require__(1280);

// https://ecma-international.org/ecma-262/6.0/#sec-ecmascript-data-types-and-values

module.exports = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	return ES5Type(x);
};


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return Logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_xp_config__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);


var OFF = 0;
var ERROR = 1;
var LOG = 2;
var VERBOSE = 3;
// 0 = off, 1 = warnings/errors, 2 = log, 3 = verbose (where supported)
// @ts-ignore
var level = __WEBPACK_IMPORTED_MODULE_0_shared_xp_config__["Configuration"].val({ name: "zmagsLog", configName: "enableLogging", type: "number", defaultValue: ERROR });
// Old IE doesn't inherit the logging functions from Function. This also means that ES5-shim's bind() doesn't work
// on it. This, we cannot supply it multiple arguments at runtime then. Using emulation mode in IE 11 will fail
// this test, though, so we re-test using Error.stack, which is not present in legacy IEs - the test is only
// performed once, so it will not impact performance. Also, iOS (5) is faulty as well, only printing the first
// supplied argument, so we have to join into a string argument there as well...
var singleArgument = (typeof console !== "undefined" && typeof console.info !== "function"); // handle ios FIXME
if (!singleArgument) {
    try {
        throw new Error();
    }
    catch (e) {
        singleArgument = !e.stack;
    }
}
/**
 * A simple instantiable logger.
 *
 * @author Bo Gotthardt
 * @class Logger
 * @constructor
 *
 * @param {String} name The logger name.
 */
var Logger = /** @class */ (function () {
    function Logger(name) {
        this._name = name + (Logger.id ? ":" + Logger.id : "");
    }
    /**
     * Use the specified console function name to print the list of data.
     *
     * @private
     *
     * @param {String} functionName
     * @param {Arguments/ *[]} dataList
     */
    Logger.prototype._callPrintFunction = function (functionName, dataList) {
        var messages = ["[" + this._name + "]"];
        var now = new Date();
        messages.push(now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + ":" + now.getMilliseconds());
        messages = messages.concat(Array.prototype.slice.call(dataList));
        if (singleArgument) {
            // @ts-ignore
            console[functionName](messages.join(" "));
        }
        else {
            // @ts-ignore
            // Chrome requires the console as it's own context.
            console[functionName].apply(console, messages);
        }
    };
    /**
     * Print the list of data to the console if the lvl is met. <p>
     *
     * If there is only one argument and it is a Promise, it's resolved value will be logged instead.
     *
     * @private
     *
     * @param {Number}    lvl          The desired level to log.
     * @param {String}    functionName The console name to call, e.g. "info", "warn".
     * @param {Arguments} dataList     The data to log.
     */
    // @ts-ignore
    Logger.prototype._print = function (lvl, functionName, dataList) {
        if (typeof console !== "undefined" && level >= lvl) {
            var scope_1 = this;
            if (dataList[0] && dataList[0].promise && Object(__WEBPACK_IMPORTED_MODULE_1_underscore__["isFunction"])(dataList[0].promise) && dataList.length === 1) {
                dataList[0]
                    //@ts-ignore
                    .done(function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    scope_1._callPrintFunction(functionName, args);
                })
                    .fail(function () {
                    scope_1._callPrintFunction(functionName, ["Promise failed."]);
                });
            }
            else {
                scope_1._callPrintFunction(functionName, dataList);
            }
        }
    };
    /**
     * Log informational message.
     */
    Logger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._print(LOG, "info", args);
    };
    /**
     * Log verbose message.
     */
    Logger.prototype.verbose = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._print(VERBOSE, "info", args);
    };
    /**
     * Log warning about undesired behavior.
     */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._print(ERROR, "warn", args);
    };
    /**
     * Log error message.
     */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._print(ERROR, "error", args);
    };
    /** Logging off *completely*. */
    Logger.OFF = OFF;
    /** Logging on, but only for errors. */
    Logger.ERROR = ERROR;
    /** Logging on. */
    Logger.LOG = LOG;
    /** Logging on, including verbose where supported. */
    Logger.VERBOSE = VERBOSE;
    /**
     * @type {String}
     * The logger id to postfix all logs created by the current context (viewer). <p>
     *
     * This is used by the viewer to distinguish logs when more viewers are activated on the same page. It supports
     * checking the current (direct) url for an embedded/lightbox value, which by convention stores the Experience id.
     */
    // @ts-ignore
    Logger.id = __WEBPACK_IMPORTED_MODULE_0_shared_xp_config__["Configuration"].val({ name: ["embedded", "lightbox"], configName: "logId", type: "string" }); // *not* used by the Editor!
    /**
     * Sets/returns the global log level. <p>
     *
     * Note: the log level will be initially set via the <tt>zmagsLog</tt> query parameter, secondarily from the
     * configuration, but can then be changed at runtime via this method.
     *
     * Logger.OFF: logging off (no errors logged either!).
     * Logger.ERROR: logging on for warnings/errors only.
     * Logger.LOG: logging on.
     * Logger.VERBOSE: verbose (where supported by modules).
     * Logger.TIMED: verbose + timestamp for each logged statement.
     *
     * @param  {Number} [lvl] The new log level; can be null/undefined, in which case the current log level is kept.
     * @return {Number} The current global log level; defaults to the configured value.
     */
    Logger.level = function (lvl) {
        if (typeof lvl === "number") {
            level = lvl;
            new Logger("Logger").info("Set log level: " + level);
        }
        return level;
    };
    return Logger;
}());

// Set initial log level so we can log it...
Logger.level(level);


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AssociatedModel = __webpack_require__(352);
    var Promise = __webpack_require__(21);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    /**
     * Extends Backbone model with the following features:
     * <ul>
     *     <li>
     *         <p>The "computed" property can be used to set up read-only computed properties. It's a map of property
     *         names to objects with the following parameters:</p>
     *         <ul>
     *             <li><b>dep</b>: The list of properties the computed value depends on. The value will be recomputed
     *                 whenever any of these values change.</li>
     *             <li><b>value</b>: The function that computes the value. Takes the values of the properties defined
     *                 in <b>dep</b> as parameters.</li>
     *             <li><b>computeDefault</b>: If true, the initial value of the property will be computed by invoking
     *                 the <b>value</b> function shortly after the model is constructed.</li>
     *             <li><b>resolvePromises</b>: If true, when the value function returns a promise, the computed
     *                 property will be set to the value of the promise when it resolves. Otherwise, the property will
     *                 be set to the promise itself.</li>
     *         </ul>
     *         <p>All properties are optional, but if <b>dep</b> or <b>computeDefault</b> are defined, <b>value</b> is
     *         required.</p>
     *         <p>If you define a computed property without configuring dependencies, it will behave like a normal
     *         property, but will not be included when the model is saved. So this is useful for defining transient
     *         properties.</p>
     *         <p>Set a default value for a computed property by setting it in the normal default object for the model.</p>
     *     </li>
     *     <li>
     *         Models will not be automatically updated when saved to the server. This ensures that change events will
     *         not be triggered as the result of a save.
     *     </li>
     *     <li>
     *         The "fetchNewUrl" property, if defined, will be used when fetching new models. This allows you to use a
     *         different URL for initial fetches.
     *     </li>
     *     <li>
     *         Static findById, findByQuery, and findOrCreate methods for looking up models across caching layers.
     *     </li>
     * </ul>
     *
     * @author Bo Gotthardt
     * @class ImprovedModel
     * @constructor
     */


    return AssociatedModel.extend("ImprovedModel", {
        constructor: function constructor() {
            var _this = this;

            // Computed attributes.
            if (this.computed) {
                // Factory method that returns a new listener function bound to the property name and configuration,
                // but supplied the options given to the "set(..)" call that triggered this computation as well...
                var listener = function listener(name, config) {
                    var instanceScope = _this;
                    return function () {
                        var _ref;

                        instanceScope._computeProperty(name, config, (_ref = arguments.length - 1, arguments.length <= _ref ? undefined : arguments[_ref])); // options always last on change events
                    };
                };

                _.each(this.computed, function (config, name) {
                    var callback = listener(name, config);
                    // Listen for changes for all the required attributes.
                    if (config.deps) {
                        _.each(config.deps, function (dep) {
                            _this.listenTo(_this, "change:" + dep + " add:" + dep + " remove:" + dep + " nested-change:" + dep, callback);
                        });
                    }

                    if (config.computeDefault) {
                        _.defer(callback);
                    }
                });
            }

            // Now call super constructor, only after we have computed the properties, since the computed
            // properties are managed by Backbone...
            this.__super();
        },
        _computeProperty: function _computeProperty(propertyName, config, options) {
            var _this2 = this;

            // Get each of the required attributes to use as parameters.
            var parameters = config.deps.map(function (dep) {
                return _this2.get(dep);
            });
            // Add "options", if any, from the set that trigger this computing as the last argument...
            parameters.push(options);

            // Compute the value, but do so silently if it depends on it self, e.g. when a property name is actually
            // an identifier for a enum constant to be resolved. However, this will fire the first change event, e.g.
            // by name, not the second time around, but the use-case for self-dependencies is currently limited to
            // "enum types", so we should be good. In addition, "updateOnSync" can specify "silent", then trigger
            // a non-silent change here, which we must also handle...
            var silent = typeof config.silent === "undefined" ? config.deps.indexOf(propertyName) !== -1 : config.silent;
            var val = config.value.apply(this, parameters);
            var opts = _.extend({ computedProperty: true, silent: silent }, options);

            // For promises, wait for the resolved value
            if (config.resolvePromises && Promise.isPromise(val)) {
                val.done(function (value) {
                    _this2.set(propertyName, value, opts);
                });

                // Otherwise just set the value
            } else {
                this.set(propertyName, val, opts);
            }
        },


        /**
         * Returns a user-friendly distinguished name for this model instance, typically used to report errors.
         * Uses `this._distinguishedName()` to find a name, or if not found uses the model `__typeName` property, or falls back to `"resource"`.
         * Then applies Id and version information, depending on the log level.
         *
         * @return {String} The distinguished name; never null, but can be empty if not applicable for this model type.
         */
        distinguishedName: function distinguishedName() {
            // override _distinguishedName() in sub-classes, not this method!
            var id = this.get("id");
            var name = this._distinguishedName();
            var version = void 0;
            var i = void 0;

            // Default name?
            if (!name) {
                name = this.__typeName || "resource";
            }

            // Verbose name for easier debugging? Note that not all models may have an id, or it may not have been
            // set yet...
            if (Logger.level() >= Logger.LOG && id) {
                // We may already have debug information in the name from sub-type, so append to it...
                if (name.charAt(name.length - 1) === "]") {
                    name = name.substring(0, name.length - 1) + ", ";
                    // Add verbose information start marker ([)...
                } else {
                    name += " [";
                }

                i = name.indexOf(id);

                if (i === -1) {
                    name += id;
                }
                // Include version, which will be there if an id *and* if versioned. Can be negative
                // for stale data like old pushed experiences (we do not want to save those by
                // accident, but we need to know the exact (abs) version)...
                if (this.has("version")) {
                    version = Math.abs(this.get("version"));

                    if (i === -1) {
                        name += ", ";
                    }

                    name += "#" + version;
                }

                name += "]";
            }

            return name;
        },


        /**
         * Sub-class specific hook to override the distinguished name of this model type.
         *
         * @return {String} The distinguished name; can be falsey, which will default to the class name of
         *                  this type, secondarily the string "resource".
         */
        _distinguishedName: function _distinguishedName() {
            return null;
        },


        // Only supported in the editor, and then only where mixed in for non immutable types...
        save: function save() {},
        destroy: function destroy() {},


        /**
         * A general method to return a valid editedAt, because editedAt will be null at creation,
         * and we want the editedAt to be createdAt in most cases.
         */
        getEditedAt: function getEditedAt() {
            return this.get("editedAt") || this.get("createdAt");
        }
    }, {

        /** -----------------------------------
         *  Static methods
         *  ---------------------------------- */

        /**
         * Find the model of this type with the specified id.
         *
         * @param   {String} id The model if; cannot be falsey.
         * @returns {Promise} A promise for the model; never falsey.
         */
        findById: function findById(id) {
            return this.findByQuery({ id: id });
        },


        /**
         * Find the first model with the same attributes as the query argument.
         *
         * @param   {Object} query The query; cannot be falsey.
         * @returns {Promise} A promise for the model; never falsey.
         */
        findByQuery: function findByQuery(query) {
            var Type = this;
            var model = new Type(query);
            // No queuing used in the viewer, hence the resolved result from "fetch()" is raw json, which we do not
            // want - we want the actual model instance, updated with the json...
            return model.fetch().then(function () {
                return model;
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var extend = __webpack_require__(763);

  var Class = function Class() {};

  /**
   * Provides a simple mechanism for inheritance (currently wrapping Backbone"s #extend).
   *
   * Any type extended by <tt>Class</tt> will also define a "mixin({..})" function to add mixin behaviour,
   * including constructor behaviour as illustrated below. <p>
   *
   * Example of how to define a Foo object/class (notice the <tt>constructor</tt> declaration):
   *
   * <pre>
   *
   *  var Foo = Class.extend({
   *
   *      _name: null,
   *
   *      constructor: function (name) {
   *          this._name = name;
   *      },
   *
   *      hello: function () {
   *          console.log("Hello", this._name);
   *      }
   *
   *  });
   *
   *  var f = new Foo("King");
   *  f.hello(); // Hello King
   *
   * </pre>
   *
   * The second argument passed to <tt>Class.extend</tt>, defines the static fields:
   *
   * <pre>
   *
   *  var Bar = Class.extend({}, {
   *
   *      DEFAULT_VALUE: "123",
   *
   *      adjust: function (bar) {
   *          console.log("adjusting", bar);
   *          return bar;
   *      }
   *
   *  });
   *
   *  Bar.adjust(new Bar());
   *
   *  console.log(Bar.DEFAULT_VALUE);
   *
   * </pre>
   *
   * @class Class
   * @constructor
   */
  Class.extend = extend;

  // Create actual "Class"...
  return Class.extend("Class");
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        extend = _require.extend;

    /**
     * Finds the first supplied query parameter from the supplied url and return the value if found. <p>
     *
     * This is defined here because of cyclic references with <tt>UrlUtil</tt>.
     *
     * @param  {String}           url  The url to find the query parameters for; never null. If the url does not
     *                                 contain a "?", it is assumed to be the search part of an url.
     * @param  {String|String[]}  name The name(s) to find, in order; never null.
     *
     * @return {String|undefined} The query value for the first found name; can be undefined if not found.
     */


    var findQueryParameter = function findQueryParameter(url, name) {
        // window.location.search can very well be empty...
        if (url) {
            var names = Array.isArray(name) ? name : [name];
            var parameters = url.slice(url.indexOf("?") + 1).split("&");

            var pair = void 0;
            var i = void 0;
            var j = void 0;

            for (j = 0; j < names.length; j++) {
                name = names[j];
                for (i = 0; i < parameters.length; i++) {
                    pair = parameters[i].split("=");
                    if (pair[0] === name) {
                        return pair[1]; // can be empty!
                    }
                }
            }
        }

        return undefined;
    };

    /**
     * Default converters from actual type to desired type, e.g. "number('42', 'string') -> 42.
     */
    var converters = {
        string: function string(value, type) {
            return type === "undefined" ? "" : value.toString();
        },
        number: function number(value, type) {
            if (type === "boolean" || type === "undefined") {
                return value ? 1 : 0;
            }
            return parseInt(value.toString(), 10) || undefined; // NaN -> undefined
        },
        boolean: function boolean(value, type) {
            if (type === "number") {
                return !!value;
            } else if (type === "undefined") {
                return false;
            }
            return (/yes|true|on/i.test(value.toString())
            );
        },
        function: function _function(value) {
            return function () {
                return value;
            };
        }
    };

    /**
     * A configuration, where each raw configuration value can be access directly as a property, or via the
     * "val(options)" method that supports query parameter overwriting and/or type coercion.
     *
     * @author Gunni Rode
     * @author Bruce Mackenzie Nielsen
     *
     * @class Configuration
     */

    var Configuration = function () {
        function Configuration() {
            _classCallCheck(this, Configuration);
        }

        _createClass(Configuration, [{
            key: "val",

            /**
             * Returns the specified configuration value. <p>
             *
             * Options:
             * <pre>
             * {
             *    name:         String|String[],
             *    configName:   String,
             *    type:         String,
             *    url:          String|Boolean,
             *    defaultValue: *,
             *    converter:    Function -> fn(value:<args.type>, type:String): <options.type>
             * }
             * </pre>
             *
             * If "options.url" is not false and if a query parameter named "options.name" is specified, it will be used.
             * The query parameter is that of <tt>window.location</tt> unless "options.url" is specified as a string. If no
             * such query parameter, the configuration values "this.name", secondarily "this.configName", are tried. If the
             * value is still undefined, "options.defaultValue" is used, if any. <p>
             *
             * If "options.type" is specified, any value above must match said type or it will not be used, eventually
             * returning undefined if neither match. If no type coercion, the first defined value is used. The
             * default types "string", "number", and "boolean" are supported out of the box. "function" will wrap
             * any non-function type in a function that will return said value. "object" has no conversion. <p>
             *
             * If "options.converter" is a conversion type like "fn(value, jsType):options.type", it will be used for the
             * type coercion if the types does not already match. No conversion will ever be made if the types match. Any
             * valid JS type, e.g. also "object" and "function", can be used if "options.converter" can handle it. <p>
             *
             * Examples:
             * <pre>
             *   // Looks up query parameter "foo", then "this.foo" if no such value, and return the value what ever type
             *   // it is, e.g. a string if found as a query parameter, but can be any value if found in this
             *   // configuration directly...
             *   var a = Configuration.val({name: "foo"});
             *
             *   // Different query parameter name: looks up query parameter "foo", then "this.bar" if no such value, and
             *   // return the value what ever type it is, e.g. a string if found as a query parameter, but can be any
             *   // value if found in this configuration directly...
             *   var b = Configuration.val({name: "foo", configName: "bar"});
             *
             *   // Coerce type: looks up query parameter "foo", then "this.foo" if no such value, and coerce value
             *   // into a number, or return undefined if it cannot be coerced into a number...
             *   var c = Configuration.val({name: "foo", type: "number"});
             *   // -> typeof c is "number" or "undefined"
             *
             *   // Coerce type: looks up query parameter "foo", then "this.foo" if no such value, and coerce value
             *   // into a number, or return default value if it cannot be coerced into a number. Notice the default
             *   // value will also be coerced; if not possible, undefined will still be returned...
             *   var c = Configuration.val({name: "foo", type: "number", defaultValue: "42"});
             *   // -> typeof c is "number" or "undefined". If no foo found, 42 is returned
             *
             *   // Lookup based on defaults: looks up query parameter "foo", then "this.foo" if no such value, and
             *   // coerce value into a number, or return default value (42) if it cannot be coerced into a number.
             *   var c = Configuration.val({defaultValue: 42}, {name: "foo", type: "number"});
             *   // -> typeof c is "number" or "undefined"
             *   ..
             * </pre>
             *
             * @param  {*} options          The options to use; can be null/undefined if <tt>defaultOptions</tt> are
             *                              supplied. See examples above.
             * @param  {*} [defaultOptions] Optional default options to add to <tt>options</tt> where not supplied;
             *                              can be falsey. Useful if <tt>options</tt> is supplied by a given context,
             *                              e.g. a default value, and these default options will fill in the blanks
             *                              needed, e.g. the actual config name to look up. See example above.
             *
             * @return {*} The corresponding configuration value, or undefined if not found or not matching "options.type".
             */
            value: function val(options, defaultOptions) {
                if (defaultOptions) {
                    options = extend(options || {}, defaultOptions);
                }
                // Type of value always a "string" or "undefined" here; can never be null (object)...
                var value = options.url !== false ? findQueryParameter(options.url || window.location.search, options.name) : undefined;
                var type = typeof value === "undefined" ? "undefined" : _typeof(value);

                if (type === "undefined") {
                    // Type of value can be any type here, including "undefined"...
                    value = this[options.configName || options.name];
                    // Make sure null means undefined...
                    if (value === null) {
                        value = undefined;
                    }
                    type = typeof value === "undefined" ? "undefined" : _typeof(value);
                }
                // If a type has been specified and it matches, simply return it...
                if (type === options.type) {
                    return value;
                    // No specified type, so return value or what ever default value if the value is undefined...
                } else if (!options.type) {
                    return type === "undefined" ? options.defaultValue : value;
                }

                // See if we have a converter from "type" to "options.type"...
                var converter = options.converter || converters[options.type];
                var defaultType = _typeof(options.defaultValue);

                if (converter) {
                    // Converter will return valid type, or undefined...
                    if (type !== "undefined") {
                        value = converter(value, type);
                    }
                    // Still no value, so try default...
                    if (typeof value === "undefined") {
                        // Proper type or do we need to convert default value as well?...
                        return defaultType === options.type ? options.defaultValue : converter(options.defaultValue, defaultType);
                    }
                    return value;
                }
                // No converter, but wrong type, which is not what we want. Check if we have a matching default value,
                // or we must return undefined...
                return defaultType === options.type ? options.defaultValue : undefined;
            }
        }]);

        return Configuration;
    }();

    // Merge global config into our configuration to avoid awkward Configuration.config syntax. This will *not*
    // overwrite our special "val" function!...


    return extend(new Configuration(), window.CONFIG || {});
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1510);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var LoggedIn = __webpack_require__(31);
    var Configuration = __webpack_require__(27);
    var Class = __webpack_require__(26);

    /**
     * Singleton managing access to the REST API.
     *
     * @class RestApi
     * @constructor
     */
    var RestApi = Class.extend({

        /**
         * The collections available in the database.
         * @constant
         */
        Collections: {
            ACTIONS: "actions",
            ANALYTICS: "analytics",
            CHANNEL_CONFIG_CHANNELS: "channelConfigs/channels",
            CHANNELS: "channels",
            CHANNELS_PUSH: "channels/push",
            CHANNELS_UNPUSHED: "channels/unpushed",
            CHANNEL_CONFIG: "channelConfigs",
            CHANNELS_COUNT: "channels/count",
            CHANNEL_CONFIGS_COUNT: "channelConfigs/channels/count",
            COMBINED: "combined",
            COMMENTS: "comments",
            COMPANIES: "companies",
            CONTENTS: "contents",
            CONTENTS_COUNT: "contents/count",
            EXPERIENCES: "experiences",
            EXPERIENCES_META: "experiences/meta",
            EXPERIENCE_CODES: "experience_codes",
            FONTS: "fonts",
            GROUPS: "groups",
            GROUPS_ASSETS: "groups/assets",
            IMAGES: "images",
            IMAGES_COUNT: "images/count",
            INTEGRATIONS: "integrations",
            PROJECTS: "projects",
            PROJECTS_META: "projects/meta",
            PROJECTS_ALL_CONTENTS: "projects/contents",
            PUBLISHABLES: "contents/publishables",
            PUBLISHABLES_COUNT: "contents/publishables/count",
            SCENES: "scenes",
            SETTINGS: "settings",
            SHARES: "shares",
            SCENE7_IMAGES: "images/scene7",
            TEMPLATES: "templates",
            TEMPLATES_COUNT: "templates/count",
            TEMPLATES_PUBLISHABLE: "templates/publishable",
            TRAFFIC: "traffic",
            USERS: "users",
            WIDGETS: "widgets",
            EXPERIENCE_EMAIL_SEND: "messaging/api/email/company/send"
        },

        // PE-1216: These are collections supported by new C3 API which will determine which API_URL will be used
        C3Collections: ['images', 'experiences'],

        /**
         * The URL to the API.
         */
        API_URL: null,

        /**
         * Let us access the settings for the company
         */
        COMPANY_SETTINGS: null,

        /**
         * The path to the proxy server in this environment.
         */
        PROXY_URL: null,

        /**
         * Initialize the REST API client. Must be called prior to using the API.
         *
         * @param {String} baseUrl The base URL to the API.
         * @param {String } proxyUrl the URL to get to proxy for the given environment.
         */
        init: function init(baseUrl) {
            var proxyUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            this.API_URL = baseUrl + "/api";
            this.PROXY_URL = proxyUrl;
            // PE-1216: LEGACY_API_URL will be used to toggle the value of API_URL between the new C3 API URL and the LEGACY URL
            // depending on the collection required
            this.LEGACY_API_URL = baseUrl + "/api";
        },


        /**
         * Qualifies the specified path with the base url of the REST api.
         *
         * @param {String} [path] The path to be qualified; can be falsey, in which case the base url is simply returned,
         *                        with no trailing slash. If already prefixed with the REST api base url, <tt>path</tt>
         *                        is simply returned as is.
         * @return {String} The qualified path; will be falsey if the base url has not been initialized.
         */
        qualify: function qualify(path) {
            var url = this.API_URL;
            if (path === "time") {
                this.API_URL = Configuration.adminApiBaseUrl + "/api";
                url = this.API_URL + "/time";
                return url;
            }
            if (url && path) {
                // Do not prefix if already prefix...
                if (path.indexOf(url) !== 0) {
                    // Make sure we get exactly a single slash between the base url and the path...
                    if (path.charAt(0) !== "/") {
                        path = "/" + path;
                    }
                    url += path;
                }
            }
            return url;
        },


        /**
         * Generates a path to a specific resource.
         *
         * @param {String} collection The collection containing the resource.
         * @param {String} id The id of the resource.
         * @returns {String} The path to the resource.
         */
        pathToSpecificResource: function pathToSpecificResource(collection, id) {
            var url = void 0;
            var newDashboardExperience = (0, _C3Utils.isC3Experience)();
            if (newDashboardExperience && this.C3Collections.includes(collection)) {
                // directly using Configuration.c3ApibaseUrl in url is not working (i.e Auth Token missing from request header)
                this.API_URL = Configuration.c3ApibaseUrl + "/v1";
                url = this.API_URL + "/" + collection + "/" + id;
            } else {
                this.API_URL = this.LEGACY_API_URL;
                url = this.API_URL + "/" + collection + "/" + id;
            }
            return url;
        },


        /**
         * Generates a path to a collection.
         *
         * @param {String} collection The collection.
         * @param {boolean} useAlternate if true, the code will use an alternate URL (to conditionally replace functionality.)
         * @returns {String} The path to the collection.
         */
        pathToCollection: function pathToCollection(collection) {
            var useAlternate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (useAlternate) {
                var companyId = LoggedIn.principal().get("companyId");
                // Temporary hack until we get per-company configuration working.
                // This array is a mix of staging and production company ids we want to try the alternate dashboard
                // call with.  If the company id isn't in this list, it goes back to using the regular call.
                var companyIndex = ["5bbe70ef6b7ecf180f9600a2", // Derek staging
                "5b215af9464bf670c5a43f7fX", // esmith staging
                "5b215b60464bf670c5a43fa8" // Dom staging
                ].indexOf(companyId);

                var altUrl = null;

                if (companyIndex !== -1) {
                    if (this.Collections.CONTENTS === collection) {
                        altUrl = this.PROXY_URL + "/experiences/api/contents";
                    }

                    if (altUrl) {
                        return "" + altUrl;
                    }
                }
            }
            // If useAlternate is false, if the company id isn't in the array, or if the alternate url is missing...
            // then we use the original/default URL.
            var newDashboardExperience = (0, _C3Utils.isC3Experience)();
            if (newDashboardExperience && this.C3Collections.includes(collection)) {
                this.API_URL = Configuration.c3ApibaseUrl + "/v1";
            } else {
                // PE-1216: Due to changing of API_URL in the pathToSpecificResource, we need to make sure that
                // it reverts back to the legacy base uri for legacy endpoints
                this.API_URL = this.LEGACY_API_URL;
            }
            return this.API_URL + "/" + collection;
        },


        /**
         * Generates a path to a collection belonging to a specific resource.
         *
         * @param {String} collection The collection containing the resource.
         * @param {String} id The id of the resource.
         * @param {String} subCollection The collection belonging to the resource.
         * @param {Boolean} [useProxy=false] Defines whenever to use proxy url or API url by default
         * @returns {String} The path to the collection belonging to the specific resource.
         */
        pathToCollectionOnResource: function pathToCollectionOnResource(collection, id, subCollection) {
            var useProxy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            return (useProxy ? this.PROXY_URL + "/experiences/api" : this.API_URL) + "/" + collection + "/" + id + "/" + subCollection;
        },


        /**
         * Generates a path to a specific resource.
         *
         * @param {String} resourceCollection The collection containing the resource.
         * @param {String} resourceId The id of the resource.
         * @param {String} subResourceCollection The collection containing the subresource.
         * @param {String} subResourceId The id of the subresource.
         * @param {String} collection The collection.
         * @returns {String} The path to the resource.
         */
        pathToCollectionOnSubResource: function pathToCollectionOnSubResource(resourceCollection, resourceId, subResourceCollection, subResourceId, collection) {
            return this.API_URL + "/" + resourceCollection + "/" + resourceId + "/" + subResourceCollection + "/" + subResourceId + "/" + collection;
        }
    });

    return new RestApi();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["isBlank"] = isBlank;
/* harmony export (immutable) */ __webpack_exports__["startsWith"] = startsWith;
/* harmony export (immutable) */ __webpack_exports__["contains"] = contains;
/* harmony export (immutable) */ __webpack_exports__["capitalize"] = capitalize;
/* harmony export (immutable) */ __webpack_exports__["titleize"] = titleize;
/* harmony export (immutable) */ __webpack_exports__["camelize"] = camelize;
/* harmony export (immutable) */ __webpack_exports__["dasherize"] = dasherize;
/* harmony export (immutable) */ __webpack_exports__["rtrim"] = rtrim;
/* harmony export (immutable) */ __webpack_exports__["trim"] = trim;
/**
 * Ensure some object is a coerced to a string
 * The old dependency underscore.string had a guard for null and undefined.
 * @param {*} object
 * @return {String}
 */
var makeString = function (object) { return (object == null ? "" : "" + object); };
/**
 * Check if a string contains any characters
 * White space and New line are escaped.
 * @param {String} str
 * @return {boolean}
 */
function isBlank(str) {
    str = makeString(str);
    if (str.length === 0) {
        return true;
    }
    return str.trim().length === 0;
}
/**
 * Verify that a string his in the beginning of an other
 * @param {String} str
 * @param {String} searchString The string to search
 * @param {Number} [position=0] The position to start
 * @return {boolean}
 */
function startsWith(str, searchString, position) {
    if (position === void 0) { position = 0; }
    // ht: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
    return makeString(str).substr(!position || position < 0 ? 0 : +position, searchString.length) === searchString;
}
/**
 * Verify that a string his included in a string
 * @param {String} str
 * @param {String} searchString The string to search
 * @param {Number} [position=0] The position to start
 * @return {boolean}
 */
function contains(str, searchString, position) {
    if (position === void 0) { position = 0; }
    str = makeString(str);
    // ht: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
    if (position + searchString.length > str.length) {
        return false;
    }
    else {
        return str.indexOf(searchString, position) !== -1;
    }
}
/**
 * Capitalize the first letter of a String
 * @param {String} str
 * @return {String}
 */
function capitalize(str) {
    str = makeString(str);
    return "" + str.charAt(0).toUpperCase() + str.slice(1);
}
/**
 * Capitalize every first character of each word in a sentence
 * @param {String} str
 * @return {String}
 */
function titleize(str) {
    return makeString(str).toLowerCase()
        .replace(/(?:^|\s|-)\S/g, function (c) { return c.toUpperCase(); });
}
/**
 * Converts underscored or dasherized string to a camelized one.
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
    return makeString(str).trim()
        .replace(/[-_\s]+(.)?/g, function (match, c) { return (match !== "" ? c.toUpperCase() : ""); });
}
/**
 * Converts underscord or dasherized string to a camelized one.
 * @param {String} str
 * @return {String}
 */
function dasherize(str) {
    return makeString(str).replace(/([A-Z])/g, "-$1")
        .replace(/[-_\s]+/g, "-")
        .toLowerCase();
}
/**
 * Delete whitespaces at the end of a String
 * @param {String} str
 * @return {String}
 */
function rtrim(str) {
    str = makeString(str);
    return str.replace(/\s*$/, "");
}
/**
 * Delete whitespaces at the beginning and the end of a String
 * @param {String} str
 * @return {String}
 */
function trim(str) {
    return makeString(str).trim();
}
var StringUtils = /** @class */ (function () {
    function StringUtils() {
    }
    StringUtils.isBlank = isBlank;
    StringUtils.startsWith = startsWith;
    StringUtils.contains = contains;
    StringUtils.capitalize = capitalize;
    StringUtils.titleize = titleize;
    StringUtils.camelize = camelize;
    StringUtils.dasherize = dasherize;
    StringUtils.rtrim = rtrim;
    StringUtils.trim = trim;
    return StringUtils;
}());
/* harmony default export */ __webpack_exports__["default"] = (StringUtils);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var CompanyState = __webpack_require__(242);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var log = new Logger("Login"); // name same as in Login module!

    /**
     * A standalone wrapper for the potentially logged in principal, needed to avoid nasty circular dependencies with
     * the <tt>Login</tt> service. <p>
     *
     * To get the currently logged in principal, do <tt>LoggedIn.principal()</tt>; will be null if no principal
     * is logged in. In addition, the convenience function <tt>ad():Boolean</tt> will return true if a principal
     * is logged in via the AD, false otherwise. <p>
     *
     * To listen for changes to login, do <tt>LoggedIn.on("change:login", function(principal) { ..not null if logged in.. });</tt>.
     *
     * To listen for changes to the user backing the currently logged in principal, for example on name change, do
     * <tt>LoggedIn.on("change:user", function(principal) { ..principal never null, principal.get("user") changed.. });</tt>.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    var LoggedIn = Backbone.Model.extend({

        /**
         * @private
         * @type {Principal}
         * The currently logged in principal if not null.
         */
        _principal: null,

        /**
         * @private
         * Triggers a principal change: logged in, re-login, or logout (null principal).
         */
        _trigger: function _trigger() {
            this.trigger("change:login", this._principal);
        },


        /**
         * @private
         * Handles an external principal change - that should never happen!
         */
        _handleChange: function _handleChange() {
            // this will never catch silent changes... :(
            log.error("Principal changed - logging out!");
            this._logout();
        },


        /**
         * @private
         * Handle user confirmation by potentially upgrading the role to the actual one now confirmed. The backend
         * does all the hard work, this is just to ensure frontend consistency without having to do a full reload...
         */
        _handleConfirmed: function _handleConfirmed() {
            var user = this.user();

            if (user) {
                user.off("change:confirmedAt", this._handleConfirmed);
                // We know the token will never be read only, since just confirmed, but we may still have company
                // restrictions. We never want to change principal roles on AD login...
                if (this._principal.get("type") !== "AD" && this._principal.get("state") === CompanyState.ACTIVE) {
                    var role = user.get("role");
                    this._principal.set({
                        type: "Normal",
                        role: role,
                        updated: role !== this._principal.get("role")
                    }, { silent: true });
                }

                log.info("User confirmed: " + this._principal);

                // Re-login to trigger change...
                this._trigger();
            }
        },


        /**
         * @private
         * When a new user logs in and sets the name (and password), we need to make sure the principal display name
         * matches <b>or</b> when the user edits her own name via the settings page.
         */
        _handleName: function _handleName() {
            var user = this.user();

            if (user) {
                // Never update principal display name on AD since it cannot change; the principal can edit the name
                // of the logged in user, but not of the principal...
                if (this._principal.get("type") !== "AD") {
                    this._principal.set("displayName", user.get("name"), { silent: true });
                }
                // This is unfortunately needed to to detect changes to the backing user higher up...
                this.trigger("change:user", this._principal);
            }
        },


        /**
         * @private
         * Logs in the supplied principal, if not null.
         *
         * @param {Principal} principal The principal that has logged in; never null.
         */
        _login: function _login(principal) {
            // actually "public" - called from Login, to avoid circular dependencies!
            if (principal) {
                this._principal = principal;
                // Make sure the principal is not changed...
                this._principal.on("change", this._handleChange);

                // Listen for user confirmation if not confirmed...
                var user = this._principal.get("user");

                if (!user.isConfirmed()) {
                    user.on("change:confirmedAt", this._handleConfirmed);
                }
                // Listen for relogin *or* edit name...
                user.on("change:name", this._handleName);

                log.info("Logged in: " + this._principal);
                this._trigger();
            }
        },


        /**
         * @private
         * Logs out the current supplied principal, if not null.
         *
         * @param {Principal} [principal] The principal, if any, that just failed to log in, presumably different
         *                                from the principal now logged out. This is used to trigger an
         *                                "error:login_restricted" event.
         */
        _logout: function _logout(principal) {
            // actually "public" - called from Login, to avoid circular dependencies!
            if (this._principal) {
                log.info("Log out: " + this._principal);

                try {
                    this._principal.off();
                    this._principal.get("user").off("change:confirmedAt", this._handleConfirmed);
                } finally {
                    this._principal = null;
                    this._trigger();
                }
            }

            if (principal) {
                this.trigger("error:login_restricted", principal);
            }
        },


        /**
         * @private
         * Triggers a <tt>login:tooManyAttempts</tt> event with the lookout time in seconds as the second event
         * argument and the currently logged in principal as the first, if any. <p>
         *
         * Note that a principal can be signed in, i.e. this can occur both on first sign in, but also if the principal
         * tries to re sign in when trying to upgrade a read only token.
         *
         * @param {Number} lookout The lookout time in seconds; a falsey value will default to 5 minutes worth of
         *                         timeout.
         */
        _tooManyAttempts: function _tooManyAttempts(lookout) {
            this.trigger("login:tooManyAttempts", this._principal, lookout || 5 * 60); // principal can be falsey!
        },


        /**
         * Returns the currently logged in principal, if any. <p>
         *
         * The test for roles and privileges are <b>always</b> performed via this principal, not via the
         * associated user. The user associated with the principal is available as <tt>principal().get("user")</tt>.
         *
         * @return {Principal} The currently logged in principal; can be null.
         * @see    #user()
         */
        principal: function principal() {
            return this._principal;
        },


        /**
         * Returns the user associated with the currently logged in principal, if any. This is just syntactic
         * sugar for <tt>var user = principal() && principal().get("user")</tt>. <p>
         *
         * The returned user is <b>not</b> used to test for roles and privileges, <tt>principal()</tt> is!
         *
         * @return {User} The user associated with currently logged in principal; can be null. If no principal,
         *                null will be returned.
         * @see    #principal()
         */
        user: function user() {
            return this._principal && this._principal.get("user");
        },


        /**
         * Returns the id of the company for the user associated with the currently logged in principal, if any.
         * This is just syntactic sugar for <tt>var companyId = principal() && principal().get("companyId")</tt>.
         *
         * @return {String} The id of the company associated with currently logged in principal; can be null. If no
         *                  principal, null will be returned.
         * @see    #user()
         */
        companyId: function companyId() {
            return this._principal && this._principal.get("companyId");
        },


        /**
         * Returns true if and only if a principal is currently logged in via the AD, false otherwise.
         *
         * @return {Boolean} True if and only if a principal is currently logged in via the AD, false otherwise.
         */
        ad: function ad() {
            return this._principal && this._principal.get("type") === "AD";
        },


        /**
         * Returns true if and only if a principal is currently logged in on the internal network, false otherwise. <p>
         *
         * The internal flag <b>must</b> not be used to test for privileged information, but fine to use to log/show
         * information depending on it.
         *
         * @return {Boolean} True if and only if a principal is currently logged on the internal network, false otherwise.
         */
        internal: function internal() {
            return this._principal && this._principal.get("internal");
        },
        initialize: function initialize() {
            this._handleChange = this._handleChange.bind(this);
            this._handleConfirmed = this._handleConfirmed.bind(this);
            this._handleName = this._handleName.bind(this);
        }
    });

    // Listenable singleton...
    return new LoggedIn();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactCSS = exports.loop = exports.handleActive = exports.handleHover = exports.hover = undefined;

var _flattenNames = __webpack_require__(2285);

var _flattenNames2 = _interopRequireDefault(_flattenNames);

var _mergeClasses = __webpack_require__(2332);

var _mergeClasses2 = _interopRequireDefault(_mergeClasses);

var _autoprefix = __webpack_require__(2358);

var _autoprefix2 = _interopRequireDefault(_autoprefix);

var _hover2 = __webpack_require__(2359);

var _hover3 = _interopRequireDefault(_hover2);

var _active = __webpack_require__(2360);

var _active2 = _interopRequireDefault(_active);

var _loop2 = __webpack_require__(2361);

var _loop3 = _interopRequireDefault(_loop2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.hover = _hover3.default;
exports.handleHover = _hover3.default;
exports.handleActive = _active2.default;
exports.loop = _loop3.default;
var ReactCSS = exports.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

exports.default = ReactCSS;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Browser = __webpack_require__(39);
    var Class = __webpack_require__(26);

    /**
     * @private @type {String}
     * Prefix to any key stored in local or session storage as this class may be run at the client domain, i.e. in
     * DnD or the viewer. We do not want to conflict with any existing keys there.
     */
    var KEY_PREFIX = "zmags_"; // someprefix + underscore seems to be the naming convention

    /**
     * The storage class will index distinct sub-trees of properties based on specific keys. This means that the
     * same property names can be reused across keys. <p>
     *
     * Since local storage stores strings, the stored representation is json. Hence, any value tried stored must
     * be json formattable.
     */
    var Storage = Class.extend({

        /**
         * @private @type {Storage}
         * The backing storage: local or session storage.
         */
        _storage: null,

        /**
         * @private @type {Object}
         * Copy of what's in <tt>_storage</tt>.
         *
         * Will be built up as user is asking for different fields.
         */
        _attributes: null, // TODO: this will lead to wrong in-mem state if two different windows update the storage, fx. editor and DnD!

        /**
         * Constructor.
         *
         * @param {Storage} storage The storage to use; never null.
         */
        constructor: function constructor(storage) {
            this._storage = storage;
            this._attributes = {};
        },


        /**
         * @private
         * Fetches all stored properties under the specified key and updates this storage accordingly.
         *
         * @param {String} key The fully qualified key to fetch data for, e.g. some key defined in
         *                     <tt>Storage.Keys</tt> plus some postfix; never null.
         *
         * @return {*} The properties; the in-memory representation will also be updated by this.
         */
        _getProperties: function _getProperties(key) {
            if (!this._attributes.hasOwnProperty(key)) {
                var properties = void 0;

                try {
                    properties = JSON.parse(this._storage.getItem(KEY_PREFIX + key) || this._storage.getItem(key)); // TODO: legacy issue looking up without prefix, remove eventually in the future...

                    // Catch all, as we do not want this storage to interfere with normal behaviour otherwise...
                } catch (e) {
                    // Fall-through, which will default...
                }

                this._attributes[key] = properties || {};
            }

            return this._attributes[key];
        },


        /**
         * @private
         * Helper function to sync a part of `attributes` with storage. <p>
         *
         * On Safari, incognito mode is enforced by setting the quota to zero whenever writing to local storage. This
         * will raise an exception (and for example cause login to fail since it relies on local/session storage). In
         * addition, a quota exceeded exception can be raised at any time if the actual quota is exceeded, so we have
         * to catch errors in the general case anyways. On errors, we return false from here, so the caller can check
         * if the sync was successful or not.
         *
         * @param {String}   key The fully qualified key to sync, e.g. some key defined in <tt>Storage.Keys</tt> plus
         *                        some postfix; never null.
         *
         * @return {Boolean} True if the sync was a success, false otherwise.
         */
        _sync: function _sync(key) {
            try {
                this._storage.setItem(KEY_PREFIX + key, JSON.stringify(this._attributes[key] || {}));

                return true;
            } catch (e) {
                return false;
            }
        },


        /**
         * Updates the property or properties in the sub-tree indexed by the specified key, by adding new
         * keys to it or update the ones that overlap.
         *
         * @param {String}   key        The key for the property sub-tree were to update.
         * @param {*|String} properties The specific property or map of properties to update. Any such existing
         *                              property will be overridden. If a map of properties, its json representation
         *                              will be merged into the existing properties.
         * @param {*}        value      The value to store if a single property is specified. The value will be
         *                              json formatted.
         *
         * @return {Boolean} True if the updates were synced with this storage, false otherwise. The in-memory storage
         *                   will still be updated even if the sync fails.
         */
        update: function update(key, properties, value) {
            var currentProperties = this._getProperties(key);
            var newProperties = {};

            if (_.isObject(properties)) {
                // also true for null
                newProperties = properties || {};
            } else {
                newProperties[properties] = value;
            }

            this._attributes[key] = _.extend(currentProperties, newProperties);

            return this._sync(key);
        },


        /**
         * Returns the property or properties from the property sub-tree indexed by the specified key. <p>
         *
         * <tt>property</tt> can be a string for a single property and a single value will be returned, or it can
         * be an array of properties to be looked up, which will return an object with matching (key, value) pairs.
         *
         * If <tt>property</tt> is falsey, the entire sub-tree will be returned. The sub-tree is mutable, and changes
         * to it will be reflected in storage once <tt>update</tt>, <tt>unset</tt>, or <tt>remove</tt> is called. <p>
         *
         * All property values returned complies with a data type supported by json, e.g. string or number or array
         * of such.
         *
         * @param {String}          key           The key for the property sub-tree were to find the property or
         *                                        properties.
         * @param {*|String|Array} [property]     Property or array of properties we want to retrieve
         * @param {*}              [defaultValue] If <tt>property</tt> is specified as a string, the
         *                                        <tt>defaultValue</tt> will be returned if no such property exists.
         *
         * @return {*|String|*} The property, properties, or map of matching properties; or falsey if invalid
         *                      parameter types.
         */
        get: function get(key, property, defaultValue) {
            var properties = this._getProperties(key);

            switch (true) {
                case arguments.length === 1:
                    return properties || {};

                case _.isString(property):
                    return properties.hasOwnProperty(property) ? properties[property] : defaultValue;

                case _.isArray(property):
                    return _.pick.apply(null, [properties].concat(property)) || {};

                default:
                    // No log needed here.
                    break;
            }
        },


        /**
         * Un-sets (removes) a single property under the specified key. <p>
         *
         * If <tt>property</tt> is the last remaining property under <tt>key</tt>, the entire (empty) sub-tree
         * under <tt>key</tt> will be removed from storage altogether.
         *
         * @param {String} key      The key for the property sub-tree were <tt>property</tt> should be removed.
         * @param {String} property The property to remove.
         *
         * @return {Boolean} True if the updates were synced with this storage, false otherwise. The in-memory storage
         *                   will still be updated even if the sync fails.
         */
        unset: function unset(key, property) {
            var values = this._attributes[key];

            if (values && values.hasOwnProperty(property)) {
                delete values[property];
                // Other properties remain? If so, sync...
                for (property in values) {
                    if (values.hasOwnProperty(property)) {
                        return this._sync(key);
                    }
                }
                // No other properties remain, so we delete the key as to not leave traces behind client side...
                return this.remove(key);
            }

            // Return true since nothing to update, so we call it a success...
            return true;
        },


        /**
         * Removes the entire property sub-tree indexed by the supplied key, regardless of how many
         * properties are stored in it.
         *
         * @param {String} key The key for the property sub-tree to be removed altogether; cannot be falsey.
         *
         * @return {Boolean} True if the removals were synced with this storage, false otherwise. The in-memory storage
         *                   will still be updated even if the sync fails.
         */
        remove: function remove(key) {
            try {
                delete this._attributes[key];
                this._storage.removeItem(KEY_PREFIX + key);
                this._storage.removeItem(key); // TODO: legacy issue, remove eventually!

                return true;
            } catch (e) {
                return false;
            }
        }
    });

    return {
        from: function from(store) {
            return new Storage(store);
        },


        /**
         * Local storage interface; never null.
         */
        Local: new Storage(Browser.getSafeStorage("localStorage")),

        /**
         * Session storage interface; never null.
         */
        Session: new Storage(Browser.getSafeStorage("sessionStorage")),

        /**
         * @type {String,String}
         * Keys indexing sub-trees of stored properties. <p>
         *
         * These are the keys supplied as the <tt>key</tt> argument to the <tt>get</tt>, <tt>update</tt>,
         * <tt>unset</tt>, and <tt>remove</tt> functions.
         */
        Keys: {
            COMMENTS: "comments",
            DASHBOARD: "dashboard",
            DASHBOARD_SORTING_PANEL: "dashboardSortingPanel",
            EDITOR: "editor",
            EXPERIENCE_COLLECTION: "experienceCollection",
            EXPERIENCE_OVERVIEW_VIEW: "experienceOverviewView",
            IMAGE_COLLECTION: "imageCollection",
            IMAGE_LIBRARY_SORTING_PANEL: "imageLibrarySortingPanel",
            INTEGRATIONS: "integrations",
            LAST_USED_SOCIAL_PROPERTIES: "lastUsedSocialProperties",
            LAST_USED_TEXT_PROPERTIES: "lastUsedTextProperties",
            ALIGNED_TO_SCENE_CHECKBOX: "alignedToSceneCheckbox",
            LAST_USED_BUTTON_PROPERTIES: "lastUsedButtonProperties",
            LOGIN: "login",
            MASTER_LAYERS: "masterLayers",
            PROJECT_COLLECTION: "projectCollection",
            PROJECT_DASHBOARD_EXPERIENCES: "projectDashboardExperiences",
            PUBLISH_VIEW: "publishView",
            RULERS_SHOWN: "rulersShown",
            SNAPPING_ENABLED: "editorSnapping",
            TEMPLATE_SORTING_PANEL: "templateSortingPanel",
            CREATOR_CONNECT: "connect",
            ONLOAD_ACTION_ENABLED: "onloadActionEnabled",
            ONLOAD_COMPONENT_INIT_COUNT: "onloadComponentInitCount",
            BEHAVIOR_COMPONENT_INIT_COUNT: "behaviorComponentInitCount",
            CONTENT_CONTROL_BETA: "contentControlBeta",
            NEW_DASHBOARD_EXP: "newDashboardExperience"
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        $ = __webpack_require__(4),
        Backbone = __webpack_require__(7),
        Window = __webpack_require__(48),
        Class = __webpack_require__(26),
        Preconditions = __webpack_require__(14);

    // Also used in Channels Admin Application - cannot include Browser module!
    function getTemplate(settings) {
        function tooltipCSS(settings) {
            return setMarginCSS(settings, tooltipOffset, { width: settings.width, height: settings.height });
        }

        function arrow(settings) {
            return $("<div></div>", {
                "class": "arrow",
                css: setMarginCSS(settings, arrowOffset.bind(null, settings.offset.align), {})
            });
        }

        function setMarginCSS(settings, fn, obj) {
            obj[getMargin(settings.offset.align)] = getsignFn(settings.offset.align)(fn.apply(null, getDists(settings)));

            return obj;
        }

        function getsignFn(align) {
            return function (n) {
                return isLoT(align) ? -n : n;
            };
        }

        function getMargin(align) {
            return isLoR(align) ? "margin-left" : "margin-top";
        }

        function isLoR(x) {
            return x === "left" || x === "right";
        }

        function isLoT(x) {
            return x === "left" || x === "top";
        }

        function tooltipOffset(dist, dist2) {
            return dist / 2 - dist2 / 2;
        }

        function arrowOffset(align, dist, dist2) {
            return -tooltipOffset(dist, dist2) - getsignFn(align)(11);
        }

        function getDists(settings) {
            if (isLoR(settings.offset.align)) {
                return [settings.offset.elementWidth, settings.width];
            }

            return [settings.offset.elementHeight, settings.height];
        }

        var html = "<div class='popover-content'></div>";

        if (settings.title !== false) {
            html = "<div class='popover-title'></div>" + html;
        }

        return $("<div></div>", {
            html: html,
            "class": "popover zmags-tooltip " + settings.background + " " + settings.classes,
            css: tooltipCSS(settings)
        }).prepend(arrow(settings));
    }

    function getContent(settings, type, element) {
        var content = settings[type];

        if (content) {
            if (content instanceof Backbone.View) {
                // Render on demand instead of on initialization
                var rendered = false;

                return function () {
                    if (rendered) {
                        return content.$el;
                    }

                    rendered = true;

                    return content.render().$el;
                };
            } else if (typeof content === "string") {
                // Selector, or just plain text?
                if (content.charAt(0) === ":") {
                    // Return a function, so it can be invoked each time the tooltip is to be shown, to ensure
                    // that the content is updated according to the current dom...
                    return function () {
                        var e = element.parent().find(content.substring(1)).clone();
                        e.css("display", "block");

                        return $("<div></div>").append(e).html();
                    };
                }
            }

            return content; // can be a function, dom element, or a string...
        }

        return _.escape(element.data(type));
    }

    function getTitle(settings, element) {
        return getContent(settings, "title", element);
    }

    function getData(settings, element) {
        return getContent(settings, "content", element);
    }

    // Applies "fn($(E))" for each element, say E, in "element" (dom element or $ selector) with a scope of $(E), and
    // returns an array of all such jQuery elements affected...
    function apply(element, fn) {
        Preconditions.checkArguments(element);

        var elementsArray;
        if (typeof element === "string") {
            elementsArray = $("body").find(element);
        } else if (_.isArray(element)) {
            elementsArray = element;
        } else {
            elementsArray = [element];
        }

        var appliedElements = [];
        _.each(elementsArray, function (e) {
            e = e.jquery ? e : $(e);
            fn.call(e, e); // e is scope, but also supplied as single argument, hence "call", and not "apply" used!
            appliedElements.push(e);
        });

        return appliedElements;
    }

    /**
     * Utility class to manage tooltips. <p>
     *
     * By default, tooltip content and optional title normally fetched as "data-content" and "data-title", respectively,
     * from the element(s) the tooltip is added to. <p>
     *
     * Example usage:
     *
     *  Tooltip.add(this.ui.test, { // or array of elements, or a jQuery selector for relevant element(s) under "body"
     *      trigger: "click",       // see defaults below
     *      placement: "right",
     *
     *      // You can set height and width manually. Height is required if you
     *      // define an offset with align: "top" or "bottom"
     *      height: 400,
     *
     *      // without offset: {}, the tooltips will be aligned in the center.
     *      // elementHeight and elementWidth should be the height and width of
     *      // the element that the tooltip is being applied to and is need
     *      offset: {
     *          align: "top",       // "bottom" | "left" | "right"
     *          elementHeight: 21,  // only needed if align = "top" or "bottom"
     *          elementWidth: 81    // only needed if align = "left" or "right"
     *      },
     *
     *      // Optional title/content for the pop-up, can also be specified as "data-title"/"data-content"
     *      // on the dom element. Can be a function, invoked with dom element scope for
     *      // the element the tooltip is attached to, a jQuery element for which the *outer* html is to be added,
     *      // but with "display:block", a string as-is, or a jQuery selector if a string starting with ":" (":" is
     *      // thus ignored), executed from the *parent* of the element the tooltip is attached to.
     *      title: "Tooltip title",
     *      content: function() { return "Tadaaa"; }
     *  });
     *
     * @author Gorm Casper / <a href="http://www.zmags.com">Zmags</a>
     * @author Gunni Rode  / <a href="http://www.zmags.com">Zmags</a>
     *
     * @class Tooltip
     */
    return Class.extend({}, {

        /**
         * Add a tooltip to the given element(s).
         *
         * @param {String|jQuery|jQuery[]} element The element(s) to add the tooltip to, or a selector to find element(s)
         *                                         to add the tooltip to.
         * @param {Object}                 config  The configuration object. For documentation on the config/settings,
         *                                         see http://getbootstrap.com/javascript/#popovers. Can be null/undefined.
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         *
         * @see    #create
         * @see    #remove
         */
        add: function add(element, config) {
            config = config || {};

            var settings = _.extend({
                html: false, // enables html tooltip content
                container: "body", // the tooltip DOM el gets appended to this
                trigger: "hover", // how the tooltip will be triggered; can be hover, click, focus, manual
                placement: "bottom", // where tooltip will be placed in relation to the element provided
                offset: "", // where tooltip arrow will be placed in relation to the element provided
                background: "", // "" (white) | "tooltip-danger" | "tooltip-warning" (add more when needed in components/tooltip.less),
                classes: "", // additional classes to add
                width: "auto", // tooltip width
                height: "auto", // tooltip height
                duration: 5000 // the duration that tooltip should auto hide, set to 0 or negative value will not hide automatically
            }, config);

            settings.template = getTemplate(settings);

            // "element" can be a string, an element, or an array of elements...
            return apply(element, function () {
                // Invariant: this = e = this jQuery element, not (necessarily) "element"

                var self = this,
                    timeoutHandler = null;

                // Update settings with title and content per element...
                settings.title = getTitle(settings, this);

                settings.content = getData(settings, this);

                // There is nothing called dropdown, so we have to emulate it
                // as best we can.
                if (settings.trigger === "dropdown") {
                    settings.trigger = "click";

                    var el = self.get(0),
                        subscription = Window.on("click", function (event) {
                        var popover = $(".popover.in")[0],
                            target = event.target;

                        if (popover && el !== target && popover !== target && !$.contains(popover, target)) {
                            self.popover("hide");
                        }
                    });

                    // Unsubscribe when the element is removed.
                    self.on("destroyed", subscription.off);
                }

                this.popover(settings);

                this.on("shown.bs.popover", function () {
                    if (timeoutHandler) {
                        clearTimeout(timeoutHandler);
                    }

                    if (settings.duration > 0) {
                        timeoutHandler = setTimeout(function () {
                            self.popover("hide");
                        }, settings.duration);
                    }
                });
            });
        },

        /**
         * (Re-)adds a tooltip to the given element(s) by first removing the tooltip, if any, then adds it again.
         *
         * @param {String|jQuery|jQuery[]} element The element(s) to (re-)add the tooltip to, or a selector to find
         *                                         element(s) to (re-)add the tooltip to.
         * @param {Object}                 config  The configuration object. For documentation on the config/settings,
         *                                         see http://getbootstrap.com/javascript/#popovers. Can be null/undefined.
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         *
         * @see    #remove
         * @see    #add
         */
        create: function create(element, config) {
            return this.add(this.remove(element), config);
        },

        /**
         * Shows the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery} element The element to show the already added tooltip for, or a selector to find
         *                                element(s) to show the tooltip for.
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         * @see    #hide
         */
        show: function show(element) {
            return apply(element, function () {
                this.popover("show");
            });
        },

        /**
         * Returns true if the tooltip is currently showing, false otherwise.
         *
         * @param {String|jQuery} element The element to test is shown or not, or a selector to find
         *                                element(s) to test if shown; if just one is shown, true will be
         *                                returned.
         * @return {Boolean} True if currently shown, false otherwise.
         * @see    #show
         */
        shown: function shown(element) {
            var shown = false;
            apply(element, function () {
                var data = this.data("bs.popover");
                shown = shown || data && data.hoverState === "in";
            });

            return shown;
        },

        /**
         * Hides the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery} element The element to hide the already added tooltip for, or a selector to find
         *                                element(s) to hide the tooltip for.
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         *
         * @see    #show
         */
        hide: function hide(element) {
            return apply(element, function () {
                this.popover("hide");
            });
        },

        /**
         * Removes the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery|Array} element The element to remove the already added tooltip for, or a selector to find
         *                                element(s) to remove the tooltip for.
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         * @see    #add
         * @see    #create
         */
        remove: function remove(element) {
            return apply(element, function () {
                this.popover("destroy");
            });
        },

        /**
         * Disable the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery} element to be disabled
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         * @see    #add
         * @see    #create
         */
        disable: function disable(element) {
            return apply(element, function () {
                this.popover("disable");
            });
        },

        /**
         * Enable the tooltip already added for the specified element(s).
         *
         * @param {String|jQuery} element to be enable
         *
         * @return {jQuery[]} The array of jQuery elements (selected) in question; never null, but can be empty.
         * @see    #add
         * @see    #create
         */
        enable: function enable(element) {
            return apply(element, function () {
                this.popover("enable");
            });
        },

        /**
         * Returns the actual size tooltip dom element added to the supplied jQuery element.
         *
         * @param   {jQuery} element The jQuery element assumed to have a tooltip added to it.
         * @returns {{width:Number, height:Number}} A (width,height) pair for the actual tooltip dom element; never null.
         */
        size: function size(element) {
            Preconditions.checkArguments(element);
            var e = element.find(".popover");

            return { width: e.outerWidth(), height: e.outerHeight() };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(20);

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error( false ? "Material-UI: capitalize(string) expects a string argument." : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Validators_1 = __webpack_require__(41);
var GET = 'get', SET = 'set';
exports.Factory = {
    addGetterSetter: function (constructor, attr, def, validator, after) {
        exports.Factory.addGetter(constructor, attr, def);
        exports.Factory.addSetter(constructor, attr, validator, after);
        exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addGetter: function (constructor, attr, def) {
        var method = GET + Util_1.Util._capitalize(attr);
        constructor.prototype[method] =
            constructor.prototype[method] ||
                function () {
                    var val = this.attrs[attr];
                    return val === undefined ? def : val;
                };
    },
    addSetter: function (constructor, attr, validator, after) {
        var method = SET + Util_1.Util._capitalize(attr);
        if (!constructor.prototype[method]) {
            exports.Factory.overWriteSetter(constructor, attr, validator, after);
        }
    },
    overWriteSetter: function (constructor, attr, validator, after) {
        var method = SET + Util_1.Util._capitalize(attr);
        constructor.prototype[method] = function (val) {
            if (validator && val !== undefined && val !== null) {
                val = validator.call(this, val, attr);
            }
            this._setAttr(attr, val);
            if (after) {
                after.call(this);
            }
            return this;
        };
    },
    addComponentsGetterSetter: function (constructor, attr, components, validator, after) {
        var len = components.length, capitalize = Util_1.Util._capitalize, getter = GET + capitalize(attr), setter = SET + capitalize(attr), n, component;
        constructor.prototype[getter] = function () {
            var ret = {};
            for (n = 0; n < len; n++) {
                component = components[n];
                ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
        };
        var basicValidator = Validators_1.getComponentValidator(components);
        constructor.prototype[setter] = function (val) {
            var oldVal = this.attrs[attr], key;
            if (validator) {
                val = validator.call(this, val);
            }
            if (basicValidator) {
                basicValidator.call(this, val, attr);
            }
            for (key in val) {
                if (!val.hasOwnProperty(key)) {
                    continue;
                }
                this._setAttr(attr + capitalize(key), val[key]);
            }
            this._fireChangeEvent(attr, oldVal, val);
            if (after) {
                after.call(this);
            }
            return this;
        };
        exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    addOverloadedGetterSetter: function (constructor, attr) {
        var capitalizedAttr = Util_1.Util._capitalize(attr), setter = SET + capitalizedAttr, getter = GET + capitalizedAttr;
        constructor.prototype[attr] = function () {
            if (arguments.length) {
                this[setter](arguments[0]);
                return this;
            }
            return this[getter]();
        };
    },
    addDeprecatedGetterSetter: function (constructor, attr, def, validator) {
        Util_1.Util.error('Adding deprecated ' + attr);
        var method = GET + Util_1.Util._capitalize(attr);
        var message = attr +
            ' property is deprecated and will be removed soon. Look at Konva change log for more information.';
        constructor.prototype[method] = function () {
            Util_1.Util.error(message);
            var val = this.attrs[attr];
            return val === undefined ? def : val;
        };
        exports.Factory.addSetter(constructor, attr, validator, function () {
            Util_1.Util.error(message);
        });
        exports.Factory.addOverloadedGetterSetter(constructor, attr);
    },
    backCompat: function (constructor, methods) {
        Util_1.Util.each(methods, function (oldMethodName, newMethodName) {
            var method = constructor.prototype[newMethodName];
            var oldGetter = GET + Util_1.Util._capitalize(oldMethodName);
            var oldSetter = SET + Util_1.Util._capitalize(oldMethodName);
            function deprecated() {
                method.apply(this, arguments);
                Util_1.Util.error('"' +
                    oldMethodName +
                    '" method is deprecated and will be removed soon. Use ""' +
                    newMethodName +
                    '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
        });
    },
    afterSetFilter: function () {
        this._filterUpToDate = false;
    },
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
Object.defineProperty(exports, "__esModule", { value: true });
var PI_OVER_180 = Math.PI / 180;
function detectBrowser() {
    return (typeof window !== 'undefined' &&
        ({}.toString.call(window) === '[object Window]' ||
            {}.toString.call(window) === '[object global]'));
}
var _detectIE = function (ua) {
    var msie = ua.indexOf('msie ');
    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    var trident = ua.indexOf('trident/');
    if (trident > 0) {
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    var edge = ua.indexOf('edge/');
    if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    return false;
};
exports._parseUA = function (userAgent) {
    var ua = userAgent.toLowerCase(), match = /(chrome)[ /]([\w.]+)/.exec(ua) ||
        /(webkit)[ /]([\w.]+)/.exec(ua) ||
        /(opera)(?:.*version|)[ /]([\w.]+)/.exec(ua) ||
        /(msie) ([\w.]+)/.exec(ua) ||
        (ua.indexOf('compatible') < 0 &&
            /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua)) ||
        [], mobile = !!userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i), ieMobile = !!userAgent.match(/IEMobile/i);
    return {
        browser: match[1] || '',
        version: match[2] || '0',
        isIE: _detectIE(ua),
        mobile: mobile,
        ieMobile: ieMobile
    };
};
exports.glob = typeof global !== 'undefined'
    ? global
    : typeof window !== 'undefined'
        ? window
        : typeof WorkerGlobalScope !== 'undefined'
            ? self
            : {};
exports.Konva = {
    _global: exports.glob,
    version: '7.0.6',
    isBrowser: detectBrowser(),
    isUnminified: /param/.test(function (param) { }.toString()),
    dblClickWindow: 400,
    getAngle: function (angle) {
        return exports.Konva.angleDeg ? angle * PI_OVER_180 : angle;
    },
    enableTrace: false,
    _pointerEventsEnabled: false,
    hitOnDragEnabled: false,
    captureTouchEventsEnabled: false,
    listenClickTap: false,
    inDblClickWindow: false,
    pixelRatio: undefined,
    dragDistance: 3,
    angleDeg: true,
    showWarnings: true,
    dragButtons: [0, 1],
    isDragging: function () {
        return exports.Konva['DD'].isDragging;
    },
    isDragReady: function () {
        return !!exports.Konva['DD'].node;
    },
    UA: exports._parseUA((exports.glob.navigator && exports.glob.navigator.userAgent) || ''),
    document: exports.glob.document,
    _injectGlobal: function (Konva) {
        exports.glob.Konva = Konva;
    },
    _parseUA: exports._parseUA
};
exports._NODES_REGISTRY = {};
exports._registerNode = function (NodeClass) {
    exports._NODES_REGISTRY[NodeClass.prototype.getClassName()] = NodeClass;
    exports.Konva[NodeClass.prototype.getClassName()] = NodeClass;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var TweenMax = __webpack_require__(152);
    var UrlUtil = __webpack_require__(46);
    var EventDispatcher = __webpack_require__(54);
    var BrowserCapabilitiesDetector = __webpack_require__(492);

    var ANIMATION_END_EVENT_NAME = "animationend";

    var userAgent = window.navigator.userAgent;

    var capabilities = BrowserCapabilitiesDetector.detect(userAgent);

    /**
     * Browser abstraction for looking up information on the browser. <p>
     *
     * User <tt>Browser.capabilities</tt> to query for capabilities instead of creating new capabilities on the fly.
     *
     * @class Browser
     */
    var Browser = EventDispatcher.extend({

        /**
         * The browser's user agent.
         *
         * @type {String}
         */
        userAgent: userAgent,

        /**
         * The detected browser capabilities.
         *
         * @type {*}
         */
        capabilities: capabilities, // viewer

        /**
         * Information about the currently used browser. Can be used like `Browser.type.edge`.
         * See: browserDetector.js
         * Whenever possible, we should use feature detection rather than browser detection.
         *
         * @type {*}
         */
        type: capabilities.browser,

        /**
         * For readability we also give access via `.os` and `.environment` for values where it
         * makes sense.
         *
         * @type {*}
         */
        os: {
            android: capabilities.browser.android,
            iOS: capabilities.browser.iOS,
            macOS: capabilities.browser.macOS,
            winOS: capabilities.browser.winOS,
            version: capabilities.browser.osVersion
        },

        /**
         * See above.
         *
         * @type {*}
         */
        environment: {
            desktop: capabilities.browser.desktop,
            tablet: capabilities.browser.tablet,
            mobile: capabilities.browser.mobile
        },

        /**
         * Returns the device pixel ratio or 1 if not specified.
         *
         * @returns {Number} the device pixel ratio.
         */
        devicePixelRatio: function devicePixelRatio() {
            return window.devicePixelRatio || 1.0;
        },


        /**
         * Applies the specified transform options to the provided <tt>HTMLElement</tt>.
         *
         * @param  {HTMLElement|jQuery} element The <tt>HTMLElement</tt> (or jQuery wrapped) instance.
         * @param  {Object} options The transform options, e.g.: <tt>{x: 100, y: 100, scale: 0.5}</tt>.
         *
         * @see  http://greensock.com/docs/#/HTML5/GSAP/TweenMax/set/
         */
        transform: function transform(element, options) {
            options.force3D = this.capabilities.is3dAnimationsSupported;
            // Delegate to TweenMax for consistency - it also handles any style prefixing
            // TODO: It would be great if it is possible to remove this dependency?
            TweenMax.set(element, options);
        },


        /**
         * Gets the name of the animation end event in this browser.
         * @returns {String} The name of the animation end event in this browser.
         */
        animationEndEventName: function animationEndEventName() {
            return ANIMATION_END_EVENT_NAME;
        },
        createElement: function createElement(tagName, config) {
            var element = document.createElement(tagName);

            element.innerHTML = config.html || "";
            element.className = config.className || "";

            if (config.contentEditable !== undefined) {
                element.setAttribute("contenteditable", config.contentEditable);
            }

            return element;
        },


        /**
         * Disables scaling of the document's viewport by setting the <tt>initial-scale</tt> and
         * <tt>maximum-scale</tt> (of the viewport meta tag/element) to 1.<p>
         *
         * This method assumes that a viewport meta tag is already present in the DOM.
         */
        disableViewportScaling: function disableViewportScaling() {
            var viewport = window.document.querySelector("meta[name=viewport]");

            if (viewport) {
                viewport.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1");
            }
        },


        /**
         * Gets the computed style of an element.
         * @param {HTMLElement} element The element.
         * @returns {CSSStyleDeclaration} The element style.
         */
        computedStyle: function computedStyle(element) {
            return window.getComputedStyle(element, null);
        },


        /**
         * Adds a node to the end of the list of children of body object.
         * @param {HTMLElement} element The element to be added.
         */
        appendElement: function appendElement(element) {
            window.document.body.appendChild(element);
        },


        /**
         * Removes a node to the end of the list of children of body object.
         * @param {HTMLElement} element The element to be removed.
         */
        removeElement: function removeElement(element) {
            window.document.body.removeChild(element);
        },


        /**
         * Sets the window title. This is the experience name.
         * @param {String} title The title to set
         */
        setTitle: function setTitle(title) {
            window.document.title = title;
            // If we're in an iframe we want to set the title attribute.
            if (window.frameElement && typeof window.frameElement.title === "string" && window.frameElement.title.length === 0) {
                window.frameElement.title = title;
            }
        },
        setLanguage: function setLanguage(language) {
            document.documentElement.setAttribute("lang", language);
        },


        /**
         * Returns an map containing all query parameters and its values from the current browser URL.
         *
         * @return {Object) A object with a all query parameters.
         */
        getQueryParameters: function getQueryParameters() {
            return UrlUtil.location(window.location.href, "query");
        },


        /**
         * Wraps the window.alert function to display a JavaScript popup.
         * @param {String} msg - Message to be displayed.
         */
        alert: function alert(msg) {
            window.alert(msg);
        },


        /**
         * Wraps the window.confirm function to display a JavaScript confirm popup with conditional choice.
         * @param {String} msg - Message to be displayed.
         * @returns {Boolean} -true if selecting OK in the confirm popup.
         */
        confirm: function confirm(msg) {
            return window.confirm(msg);
        },


        /**
         * Will return the asked for storage (window.localStorage or
         * window.sessionStorage), if it is available and writeable. If the
         * user has blocked cookies and saving locally, then it will return a
         * dummy object, with an interface resembling the asked for storage.
         *
         * @param {String} storageType  - Either "localStorage" or "sessionStorage".
         * @return {Storage|Object}     - Either the asked for storage, or a
         *                                dummy with an interface mimicking a
         *                                real storage.
         */
        getSafeStorage: function getSafeStorage(storageType) {
            try {
                return window[storageType];
            } catch (e) {
                // Standard sessionStorage/localStorage interface
                return {
                    setItem: function setItem() {},
                    getItem: function getItem() {},
                    removeItem: function removeItem() {},

                    keys: [],
                    length: 0
                };
            }
        },


        /**
         * Disable the browser spellcheck that is by default enabled for textarea and contenteditable element
         *
         */
        disableNativeSpellChecker: function disableNativeSpellChecker() {
            window.document.body.setAttribute("spellcheck", false);
        }
    });

    return new Browser();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Global_1 = __webpack_require__(38);
var Util_1 = __webpack_require__(43);
function _formatValue(val) {
    if (Util_1.Util._isString(val)) {
        return '"' + val + '"';
    }
    if (Object.prototype.toString.call(val) === '[object Number]') {
        return val;
    }
    if (Util_1.Util._isBoolean(val)) {
        return val;
    }
    return Object.prototype.toString.call(val);
}
function RGBComponent(val) {
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    return Math.round(val);
}
exports.RGBComponent = RGBComponent;
function alphaComponent(val) {
    if (val > 1) {
        return 1;
    }
    else if (val < 0.0001) {
        return 0.0001;
    }
    return val;
}
exports.alphaComponent = alphaComponent;
function getNumberValidator() {
    if (Global_1.Konva.isUnminified) {
        return function (val, attr) {
            if (!Util_1.Util._isNumber(val)) {
                Util_1.Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a number.');
            }
            return val;
        };
    }
}
exports.getNumberValidator = getNumberValidator;
function getNumberOrAutoValidator() {
    if (Global_1.Konva.isUnminified) {
        return function (val, attr) {
            var isNumber = Util_1.Util._isNumber(val);
            var isAuto = val === 'auto';
            if (!(isNumber || isAuto)) {
                Util_1.Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a number or "auto".');
            }
            return val;
        };
    }
}
exports.getNumberOrAutoValidator = getNumberOrAutoValidator;
function getStringValidator() {
    if (Global_1.Konva.isUnminified) {
        return function (val, attr) {
            if (!Util_1.Util._isString(val)) {
                Util_1.Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a string.');
            }
            return val;
        };
    }
}
exports.getStringValidator = getStringValidator;
function getFunctionValidator() {
    if (Global_1.Konva.isUnminified) {
        return function (val, attr) {
            if (!Util_1.Util._isFunction(val)) {
                Util_1.Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a function.');
            }
            return val;
        };
    }
}
exports.getFunctionValidator = getFunctionValidator;
function getNumberArrayValidator() {
    if (Global_1.Konva.isUnminified) {
        return function (val, attr) {
            if (!Util_1.Util._isArray(val)) {
                Util_1.Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a array of numbers.');
            }
            else {
                val.forEach(function (item) {
                    if (!Util_1.Util._isNumber(item)) {
                        Util_1.Util.warn('"' +
                            attr +
                            '" attribute has non numeric element ' +
                            item +
                            '. Make sure that all elements are numbers.');
                    }
                });
            }
            return val;
        };
    }
}
exports.getNumberArrayValidator = getNumberArrayValidator;
function getBooleanValidator() {
    if (Global_1.Konva.isUnminified) {
        return function (val, attr) {
            var isBool = val === true || val === false;
            if (!isBool) {
                Util_1.Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be a boolean.');
            }
            return val;
        };
    }
}
exports.getBooleanValidator = getBooleanValidator;
function getComponentValidator(components) {
    if (Global_1.Konva.isUnminified) {
        return function (val, attr) {
            if (!Util_1.Util.isObject(val)) {
                Util_1.Util.warn(_formatValue(val) +
                    ' is a not valid value for "' +
                    attr +
                    '" attribute. The value should be an object with properties ' +
                    components);
            }
            return val;
        };
    }
}
exports.getComponentValidator = getComponentValidator;


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Global_1 = __webpack_require__(38);
var Collection = (function () {
    function Collection() {
    }
    Collection.toCollection = function (arr) {
        var collection = new Collection(), len = arr.length, n;
        for (n = 0; n < len; n++) {
            collection.push(arr[n]);
        }
        return collection;
    };
    Collection._mapMethod = function (methodName) {
        Collection.prototype[methodName] = function () {
            var len = this.length, i;
            var args = [].slice.call(arguments);
            for (i = 0; i < len; i++) {
                this[i][methodName].apply(this[i], args);
            }
            return this;
        };
    };
    Collection.mapMethods = function (constructor) {
        var prot = constructor.prototype;
        for (var methodName in prot) {
            Collection._mapMethod(methodName);
        }
    };
    return Collection;
}());
exports.Collection = Collection;
Collection.prototype = [];
Collection.prototype.each = function (func) {
    for (var n = 0; n < this.length; n++) {
        func(this[n], n);
    }
};
Collection.prototype.toArray = function () {
    var arr = [], len = this.length, n;
    for (n = 0; n < len; n++) {
        arr.push(this[n]);
    }
    return arr;
};
var Transform = (function () {
    function Transform(m) {
        if (m === void 0) { m = [1, 0, 0, 1, 0, 0]; }
        this.dirty = false;
        this.m = (m && m.slice()) || [1, 0, 0, 1, 0, 0];
    }
    Transform.prototype.reset = function () {
        this.m[0] = 1;
        this.m[1] = 0;
        this.m[2] = 0;
        this.m[3] = 1;
        this.m[4] = 0;
        this.m[5] = 0;
    };
    Transform.prototype.copy = function () {
        return new Transform(this.m);
    };
    Transform.prototype.copyInto = function (tr) {
        tr.m[0] = this.m[0];
        tr.m[1] = this.m[1];
        tr.m[2] = this.m[2];
        tr.m[3] = this.m[3];
        tr.m[4] = this.m[4];
        tr.m[5] = this.m[5];
    };
    Transform.prototype.point = function (point) {
        var m = this.m;
        return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5],
        };
    };
    Transform.prototype.translate = function (x, y) {
        this.m[4] += this.m[0] * x + this.m[2] * y;
        this.m[5] += this.m[1] * x + this.m[3] * y;
        return this;
    };
    Transform.prototype.scale = function (sx, sy) {
        this.m[0] *= sx;
        this.m[1] *= sx;
        this.m[2] *= sy;
        this.m[3] *= sy;
        return this;
    };
    Transform.prototype.rotate = function (rad) {
        var c = Math.cos(rad);
        var s = Math.sin(rad);
        var m11 = this.m[0] * c + this.m[2] * s;
        var m12 = this.m[1] * c + this.m[3] * s;
        var m21 = this.m[0] * -s + this.m[2] * c;
        var m22 = this.m[1] * -s + this.m[3] * c;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    };
    Transform.prototype.getTranslation = function () {
        return {
            x: this.m[4],
            y: this.m[5],
        };
    };
    Transform.prototype.skew = function (sx, sy) {
        var m11 = this.m[0] + this.m[2] * sy;
        var m12 = this.m[1] + this.m[3] * sy;
        var m21 = this.m[2] + this.m[0] * sx;
        var m22 = this.m[3] + this.m[1] * sx;
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        return this;
    };
    Transform.prototype.multiply = function (matrix) {
        var m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
        var m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
        var m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
        var m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
        var dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
        var dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
        this.m[0] = m11;
        this.m[1] = m12;
        this.m[2] = m21;
        this.m[3] = m22;
        this.m[4] = dx;
        this.m[5] = dy;
        return this;
    };
    Transform.prototype.invert = function () {
        var d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
        var m0 = this.m[3] * d;
        var m1 = -this.m[1] * d;
        var m2 = -this.m[2] * d;
        var m3 = this.m[0] * d;
        var m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
        var m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
        this.m[0] = m0;
        this.m[1] = m1;
        this.m[2] = m2;
        this.m[3] = m3;
        this.m[4] = m4;
        this.m[5] = m5;
        return this;
    };
    Transform.prototype.getMatrix = function () {
        return this.m;
    };
    Transform.prototype.setAbsolutePosition = function (x, y) {
        var m0 = this.m[0], m1 = this.m[1], m2 = this.m[2], m3 = this.m[3], m4 = this.m[4], m5 = this.m[5], yt = (m0 * (y - m5) - m1 * (x - m4)) / (m0 * m3 - m1 * m2), xt = (x - m4 - m2 * yt) / m0;
        return this.translate(xt, yt);
    };
    Transform.prototype.decompose = function () {
        var a = this.m[0];
        var b = this.m[1];
        var c = this.m[2];
        var d = this.m[3];
        var e = this.m[4];
        var f = this.m[5];
        var delta = a * d - b * c;
        var result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0,
        };
        if (a != 0 || b != 0) {
            var r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
        }
        else if (c != 0 || d != 0) {
            var s = Math.sqrt(c * c + d * d);
            result.rotation =
                Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
        }
        else {
        }
        result.rotation = exports.Util._getRotation(result.rotation);
        return result;
    };
    return Transform;
}());
exports.Transform = Transform;
var OBJECT_ARRAY = '[object Array]', OBJECT_NUMBER = '[object Number]', OBJECT_STRING = '[object String]', OBJECT_BOOLEAN = '[object Boolean]', PI_OVER_DEG180 = Math.PI / 180, DEG180_OVER_PI = 180 / Math.PI, HASH = '#', EMPTY_STRING = '', ZERO = '0', KONVA_WARNING = 'Konva warning: ', KONVA_ERROR = 'Konva error: ', RGB_PAREN = 'rgb(', COLORS = {
    aliceblue: [240, 248, 255],
    antiquewhite: [250, 235, 215],
    aqua: [0, 255, 255],
    aquamarine: [127, 255, 212],
    azure: [240, 255, 255],
    beige: [245, 245, 220],
    bisque: [255, 228, 196],
    black: [0, 0, 0],
    blanchedalmond: [255, 235, 205],
    blue: [0, 0, 255],
    blueviolet: [138, 43, 226],
    brown: [165, 42, 42],
    burlywood: [222, 184, 135],
    cadetblue: [95, 158, 160],
    chartreuse: [127, 255, 0],
    chocolate: [210, 105, 30],
    coral: [255, 127, 80],
    cornflowerblue: [100, 149, 237],
    cornsilk: [255, 248, 220],
    crimson: [220, 20, 60],
    cyan: [0, 255, 255],
    darkblue: [0, 0, 139],
    darkcyan: [0, 139, 139],
    darkgoldenrod: [184, 132, 11],
    darkgray: [169, 169, 169],
    darkgreen: [0, 100, 0],
    darkgrey: [169, 169, 169],
    darkkhaki: [189, 183, 107],
    darkmagenta: [139, 0, 139],
    darkolivegreen: [85, 107, 47],
    darkorange: [255, 140, 0],
    darkorchid: [153, 50, 204],
    darkred: [139, 0, 0],
    darksalmon: [233, 150, 122],
    darkseagreen: [143, 188, 143],
    darkslateblue: [72, 61, 139],
    darkslategray: [47, 79, 79],
    darkslategrey: [47, 79, 79],
    darkturquoise: [0, 206, 209],
    darkviolet: [148, 0, 211],
    deeppink: [255, 20, 147],
    deepskyblue: [0, 191, 255],
    dimgray: [105, 105, 105],
    dimgrey: [105, 105, 105],
    dodgerblue: [30, 144, 255],
    firebrick: [178, 34, 34],
    floralwhite: [255, 255, 240],
    forestgreen: [34, 139, 34],
    fuchsia: [255, 0, 255],
    gainsboro: [220, 220, 220],
    ghostwhite: [248, 248, 255],
    gold: [255, 215, 0],
    goldenrod: [218, 165, 32],
    gray: [128, 128, 128],
    green: [0, 128, 0],
    greenyellow: [173, 255, 47],
    grey: [128, 128, 128],
    honeydew: [240, 255, 240],
    hotpink: [255, 105, 180],
    indianred: [205, 92, 92],
    indigo: [75, 0, 130],
    ivory: [255, 255, 240],
    khaki: [240, 230, 140],
    lavender: [230, 230, 250],
    lavenderblush: [255, 240, 245],
    lawngreen: [124, 252, 0],
    lemonchiffon: [255, 250, 205],
    lightblue: [173, 216, 230],
    lightcoral: [240, 128, 128],
    lightcyan: [224, 255, 255],
    lightgoldenrodyellow: [250, 250, 210],
    lightgray: [211, 211, 211],
    lightgreen: [144, 238, 144],
    lightgrey: [211, 211, 211],
    lightpink: [255, 182, 193],
    lightsalmon: [255, 160, 122],
    lightseagreen: [32, 178, 170],
    lightskyblue: [135, 206, 250],
    lightslategray: [119, 136, 153],
    lightslategrey: [119, 136, 153],
    lightsteelblue: [176, 196, 222],
    lightyellow: [255, 255, 224],
    lime: [0, 255, 0],
    limegreen: [50, 205, 50],
    linen: [250, 240, 230],
    magenta: [255, 0, 255],
    maroon: [128, 0, 0],
    mediumaquamarine: [102, 205, 170],
    mediumblue: [0, 0, 205],
    mediumorchid: [186, 85, 211],
    mediumpurple: [147, 112, 219],
    mediumseagreen: [60, 179, 113],
    mediumslateblue: [123, 104, 238],
    mediumspringgreen: [0, 250, 154],
    mediumturquoise: [72, 209, 204],
    mediumvioletred: [199, 21, 133],
    midnightblue: [25, 25, 112],
    mintcream: [245, 255, 250],
    mistyrose: [255, 228, 225],
    moccasin: [255, 228, 181],
    navajowhite: [255, 222, 173],
    navy: [0, 0, 128],
    oldlace: [253, 245, 230],
    olive: [128, 128, 0],
    olivedrab: [107, 142, 35],
    orange: [255, 165, 0],
    orangered: [255, 69, 0],
    orchid: [218, 112, 214],
    palegoldenrod: [238, 232, 170],
    palegreen: [152, 251, 152],
    paleturquoise: [175, 238, 238],
    palevioletred: [219, 112, 147],
    papayawhip: [255, 239, 213],
    peachpuff: [255, 218, 185],
    peru: [205, 133, 63],
    pink: [255, 192, 203],
    plum: [221, 160, 203],
    powderblue: [176, 224, 230],
    purple: [128, 0, 128],
    rebeccapurple: [102, 51, 153],
    red: [255, 0, 0],
    rosybrown: [188, 143, 143],
    royalblue: [65, 105, 225],
    saddlebrown: [139, 69, 19],
    salmon: [250, 128, 114],
    sandybrown: [244, 164, 96],
    seagreen: [46, 139, 87],
    seashell: [255, 245, 238],
    sienna: [160, 82, 45],
    silver: [192, 192, 192],
    skyblue: [135, 206, 235],
    slateblue: [106, 90, 205],
    slategray: [119, 128, 144],
    slategrey: [119, 128, 144],
    snow: [255, 255, 250],
    springgreen: [0, 255, 127],
    steelblue: [70, 130, 180],
    tan: [210, 180, 140],
    teal: [0, 128, 128],
    thistle: [216, 191, 216],
    transparent: [255, 255, 255, 0],
    tomato: [255, 99, 71],
    turquoise: [64, 224, 208],
    violet: [238, 130, 238],
    wheat: [245, 222, 179],
    white: [255, 255, 255],
    whitesmoke: [245, 245, 245],
    yellow: [255, 255, 0],
    yellowgreen: [154, 205, 5],
}, RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/, animQueue = [];
exports.Util = {
    _isElement: function (obj) {
        return !!(obj && obj.nodeType == 1);
    },
    _isFunction: function (obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    },
    _isPlainObject: function (obj) {
        return !!obj && obj.constructor === Object;
    },
    _isArray: function (obj) {
        return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
    },
    _isNumber: function (obj) {
        return (Object.prototype.toString.call(obj) === OBJECT_NUMBER &&
            !isNaN(obj) &&
            isFinite(obj));
    },
    _isString: function (obj) {
        return Object.prototype.toString.call(obj) === OBJECT_STRING;
    },
    _isBoolean: function (obj) {
        return Object.prototype.toString.call(obj) === OBJECT_BOOLEAN;
    },
    isObject: function (val) {
        return val instanceof Object;
    },
    isValidSelector: function (selector) {
        if (typeof selector !== 'string') {
            return false;
        }
        var firstChar = selector[0];
        return (firstChar === '#' ||
            firstChar === '.' ||
            firstChar === firstChar.toUpperCase());
    },
    _sign: function (number) {
        if (number === 0) {
            return 0;
        }
        if (number > 0) {
            return 1;
        }
        else {
            return -1;
        }
    },
    requestAnimFrame: function (callback) {
        animQueue.push(callback);
        if (animQueue.length === 1) {
            requestAnimationFrame(function () {
                var queue = animQueue;
                animQueue = [];
                queue.forEach(function (cb) {
                    cb();
                });
            });
        }
    },
    createCanvasElement: function () {
        var canvas = document.createElement('canvas');
        try {
            canvas.style = canvas.style || {};
        }
        catch (e) { }
        return canvas;
    },
    createImageElement: function () {
        return document.createElement('img');
    },
    _isInDocument: function (el) {
        while ((el = el.parentNode)) {
            if (el == document) {
                return true;
            }
        }
        return false;
    },
    _simplifyArray: function (arr) {
        var retArr = [], len = arr.length, util = exports.Util, n, val;
        for (n = 0; n < len; n++) {
            val = arr[n];
            if (util._isNumber(val)) {
                val = Math.round(val * 1000) / 1000;
            }
            else if (!util._isString(val)) {
                val = val.toString();
            }
            retArr.push(val);
        }
        return retArr;
    },
    _urlToImage: function (url, callback) {
        var imageObj = new Global_1.glob.Image();
        imageObj.onload = function () {
            callback(imageObj);
        };
        imageObj.src = url;
    },
    _rgbToHex: function (r, g, b) {
        return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    },
    _hexToRgb: function (hex) {
        hex = hex.replace(HASH, EMPTY_STRING);
        var bigint = parseInt(hex, 16);
        return {
            r: (bigint >> 16) & 255,
            g: (bigint >> 8) & 255,
            b: bigint & 255,
        };
    },
    getRandomColor: function () {
        var randColor = ((Math.random() * 0xffffff) << 0).toString(16);
        while (randColor.length < 6) {
            randColor = ZERO + randColor;
        }
        return HASH + randColor;
    },
    get: function (val, def) {
        if (val === undefined) {
            return def;
        }
        else {
            return val;
        }
    },
    getRGB: function (color) {
        var rgb;
        if (color in COLORS) {
            rgb = COLORS[color];
            return {
                r: rgb[0],
                g: rgb[1],
                b: rgb[2],
            };
        }
        else if (color[0] === HASH) {
            return this._hexToRgb(color.substring(1));
        }
        else if (color.substr(0, 4) === RGB_PAREN) {
            rgb = RGB_REGEX.exec(color.replace(/ /g, ''));
            return {
                r: parseInt(rgb[1], 10),
                g: parseInt(rgb[2], 10),
                b: parseInt(rgb[3], 10),
            };
        }
        else {
            return {
                r: 0,
                g: 0,
                b: 0,
            };
        }
    },
    colorToRGBA: function (str) {
        str = str || 'black';
        return (exports.Util._namedColorToRBA(str) ||
            exports.Util._hex3ColorToRGBA(str) ||
            exports.Util._hex6ColorToRGBA(str) ||
            exports.Util._rgbColorToRGBA(str) ||
            exports.Util._rgbaColorToRGBA(str) ||
            exports.Util._hslColorToRGBA(str));
    },
    _namedColorToRBA: function (str) {
        var c = COLORS[str.toLowerCase()];
        if (!c) {
            return null;
        }
        return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1,
        };
    },
    _rgbColorToRGBA: function (str) {
        if (str.indexOf('rgb(') === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: 1,
            };
        }
    },
    _rgbaColorToRGBA: function (str) {
        if (str.indexOf('rgba(') === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            var parts = str.split(/ *, */).map(Number);
            return {
                r: parts[0],
                g: parts[1],
                b: parts[2],
                a: parts[3],
            };
        }
    },
    _hex6ColorToRGBA: function (str) {
        if (str[0] === '#' && str.length === 7) {
            return {
                r: parseInt(str.slice(1, 3), 16),
                g: parseInt(str.slice(3, 5), 16),
                b: parseInt(str.slice(5, 7), 16),
                a: 1,
            };
        }
    },
    _hex3ColorToRGBA: function (str) {
        if (str[0] === '#' && str.length === 4) {
            return {
                r: parseInt(str[1] + str[1], 16),
                g: parseInt(str[2] + str[2], 16),
                b: parseInt(str[3] + str[3], 16),
                a: 1,
            };
        }
    },
    _hslColorToRGBA: function (str) {
        if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            var _a = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str), _ = _a[0], hsl = _a.slice(1);
            var h = Number(hsl[0]) / 360;
            var s = Number(hsl[1]) / 100;
            var l = Number(hsl[2]) / 100;
            var t2 = void 0;
            var t3 = void 0;
            var val = void 0;
            if (s === 0) {
                val = l * 255;
                return {
                    r: Math.round(val),
                    g: Math.round(val),
                    b: Math.round(val),
                    a: 1,
                };
            }
            if (l < 0.5) {
                t2 = l * (1 + s);
            }
            else {
                t2 = l + s - l * s;
            }
            var t1 = 2 * l - t2;
            var rgb = [0, 0, 0];
            for (var i = 0; i < 3; i++) {
                t3 = h + (1 / 3) * -(i - 1);
                if (t3 < 0) {
                    t3++;
                }
                if (t3 > 1) {
                    t3--;
                }
                if (6 * t3 < 1) {
                    val = t1 + (t2 - t1) * 6 * t3;
                }
                else if (2 * t3 < 1) {
                    val = t2;
                }
                else if (3 * t3 < 2) {
                    val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
                }
                else {
                    val = t1;
                }
                rgb[i] = val * 255;
            }
            return {
                r: Math.round(rgb[0]),
                g: Math.round(rgb[1]),
                b: Math.round(rgb[2]),
                a: 1,
            };
        }
    },
    haveIntersection: function (r1, r2) {
        return !(r2.x > r1.x + r1.width ||
            r2.x + r2.width < r1.x ||
            r2.y > r1.y + r1.height ||
            r2.y + r2.height < r1.y);
    },
    cloneObject: function (obj) {
        var retObj = {};
        for (var key in obj) {
            if (this._isPlainObject(obj[key])) {
                retObj[key] = this.cloneObject(obj[key]);
            }
            else if (this._isArray(obj[key])) {
                retObj[key] = this.cloneArray(obj[key]);
            }
            else {
                retObj[key] = obj[key];
            }
        }
        return retObj;
    },
    cloneArray: function (arr) {
        return arr.slice(0);
    },
    _degToRad: function (deg) {
        return deg * PI_OVER_DEG180;
    },
    _radToDeg: function (rad) {
        return rad * DEG180_OVER_PI;
    },
    _getRotation: function (radians) {
        return Global_1.Konva.angleDeg ? exports.Util._radToDeg(radians) : radians;
    },
    _capitalize: function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    throw: function (str) {
        throw new Error(KONVA_ERROR + str);
    },
    error: function (str) {
        console.error(KONVA_ERROR + str);
    },
    warn: function (str) {
        if (!Global_1.Konva.showWarnings) {
            return;
        }
        console.warn(KONVA_WARNING + str);
    },
    extend: function (child, parent) {
        function Ctor() {
            this.constructor = child;
        }
        Ctor.prototype = parent.prototype;
        var oldProto = child.prototype;
        child.prototype = new Ctor();
        for (var key in oldProto) {
            if (oldProto.hasOwnProperty(key)) {
                child.prototype[key] = oldProto[key];
            }
        }
        child.__super__ = parent.prototype;
        child.super = parent;
    },
    _getControlPoints: function (x0, y0, x1, y1, x2, y2, t) {
        var d01 = Math.sqrt(Math.pow(x1 - x0, 2) + Math.pow(y1 - y0, 2)), d12 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)), fa = (t * d01) / (d01 + d12), fb = (t * d12) / (d01 + d12), p1x = x1 - fa * (x2 - x0), p1y = y1 - fa * (y2 - y0), p2x = x1 + fb * (x2 - x0), p2y = y1 + fb * (y2 - y0);
        return [p1x, p1y, p2x, p2y];
    },
    _expandPoints: function (p, tension) {
        var len = p.length, allPoints = [], n, cp;
        for (n = 2; n < len - 2; n += 2) {
            cp = exports.Util._getControlPoints(p[n - 2], p[n - 1], p[n], p[n + 1], p[n + 2], p[n + 3], tension);
            allPoints.push(cp[0]);
            allPoints.push(cp[1]);
            allPoints.push(p[n]);
            allPoints.push(p[n + 1]);
            allPoints.push(cp[2]);
            allPoints.push(cp[3]);
        }
        return allPoints;
    },
    each: function (obj, func) {
        for (var key in obj) {
            func(key, obj[key]);
        }
    },
    _inRange: function (val, left, right) {
        return left <= val && val < right;
    },
    _getProjectionToSegment: function (x1, y1, x2, y2, x3, y3) {
        var x, y, dist;
        var pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
        if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
        }
        else {
            var u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
                x = x1;
                y = y1;
                dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            }
            else if (u > 1.0) {
                x = x2;
                y = y2;
                dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            }
            else {
                x = x1 + u * (x2 - x1);
                y = y1 + u * (y2 - y1);
                dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
        }
        return [x, y, dist];
    },
    _getProjectionToLine: function (pt, line, isClosed) {
        var pc = exports.Util.cloneObject(pt);
        var dist = Number.MAX_VALUE;
        line.forEach(function (p1, i) {
            if (!isClosed && i === line.length - 1) {
                return;
            }
            var p2 = line[(i + 1) % line.length];
            var proj = exports.Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            var px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
                pc.x = px;
                pc.y = py;
                dist = pdist;
            }
        });
        return pc;
    },
    _prepareArrayForTween: function (startArray, endArray, isClosed) {
        var n, start = [], end = [];
        if (startArray.length > endArray.length) {
            var temp = endArray;
            endArray = startArray;
            startArray = temp;
        }
        for (n = 0; n < startArray.length; n += 2) {
            start.push({
                x: startArray[n],
                y: startArray[n + 1],
            });
        }
        for (n = 0; n < endArray.length; n += 2) {
            end.push({
                x: endArray[n],
                y: endArray[n + 1],
            });
        }
        var newStart = [];
        end.forEach(function (point) {
            var pr = exports.Util._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
        });
        return newStart;
    },
    _prepareToStringify: function (obj) {
        var desc;
        obj.visitedByCircularReferenceRemoval = true;
        for (var key in obj) {
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == 'object')) {
                continue;
            }
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval ||
                exports.Util._isElement(obj[key])) {
                if (desc.configurable) {
                    delete obj[key];
                }
                else {
                    return null;
                }
            }
            else if (exports.Util._prepareToStringify(obj[key]) === null) {
                if (desc.configurable) {
                    delete obj[key];
                }
                else {
                    return null;
                }
            }
        }
        delete obj.visitedByCircularReferenceRemoval;
        return obj;
    },
    _assign: function (target, source) {
        for (var key in source) {
            target[key] = source[key];
        }
        return target;
    },
    _getFirstPointerId: function (evt) {
        if (!evt.touches) {
            return 999;
        }
        else {
            return evt.changedTouches[0].identifier;
        }
    },
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var EventDispatcher = __webpack_require__(54);
    var RestApi = __webpack_require__(29);
    var Syncer = __webpack_require__(50);
    var TargetQueue = __webpack_require__(1394);
    var SequentialQueue = __webpack_require__(1395);
    var Preconditions = __webpack_require__(14);
    var ParallelQueue = __webpack_require__(1396);
    var Promise = __webpack_require__(21);
    var UrlUtil = __webpack_require__(46);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var log = new Logger("SyncManager");
    /**
     * @class {SyncManager}
     * A <i>sync manager</i> that will handle all target sync requests against some deferred service. <p>
     *
     * The following traits will hold for any target instance synced using this sync manager: <ul>
     *
     * <li> "Horizontal queueing": different target instances (with different ids) can be ordered so the i'th target will
     *      complete its sync before the i+1'th target will start its sync. This is done by supplying an ordered array of
     *      targets to the <tt>sync</tt> function, like <tt>sync(..)</tt>, like <tt>sync("save", [modelA, modelB, modelC])</tt>.
     *      Here, "modelA.save()" will complete before "modelB.save()" starts, and "modelB.save()" will complete
     *      before "modelC.save()" starts. <p>
     *
     *      Relevant queues are sequential and parallel queues. <p>
     *
     * <li> "Vertical queueing": the same target instance (with the same id) cannot have more than one executing sync
     *      request, all others will be queued. This means that when trying to sync a target where sync requests are
     *      already pending, the new request will be queued. So, <tt>sync("save", modelA)" will block any other sync
     *      request for "modelA" while pending, like <tt>sync("fetch", modelA)</tt>. It also means that an array of
     *      ordered targets like in the bullet above ([modelA, modelB, modelC]) can be blocked at any place because of
     *      pending requests for the target (model) in question: here, the array will be blocked already on "modelA" it
     *      is has pending requests (and the same goes for all other objects). <p>
     *
     *      Relevant queue is a target queue. <p>
     *
     * <li> Future requests will not block earlier requests.
     *
     * </ul>
     *
     * Different ways of syncing: <ol>
     *
     * <li> "Vertical queueing" - single target:
     *       <pre>
     *          return manager.sync("save", modelA, ..).promise().done(..).fail(..);
     *       </pre>
     *
     * <li> "Vertical queueing" - single target (same as above, though more verbose):
     *       <pre>
     *          var queue = manager.queue(modelA);
     *          var promise = queue.enqueue("save", ..).done(..).fail(..); // note: promise handlers on "enqueue" result, when the enqueued request is complete
     *          queue.sync();
     *          return promise;
     *       </pre>
     *
     * <li> "Horizontal sequential queueing" - multiple targets, single sync method:
     *       <pre>
     *         return manager.sync("save", [modelA, modelB, modelC], ..).promise().done(..).fail(..);
     *       </pre>
     *
     * <li> "Horizontal sequential queueing" - multiple targets, multiple sync methods:
     *       <pre>
     *         return manager.queue() // or .queue(false)
     *             .enqueue("save", modelA, ..)
     *             .enqueue("publish", modelB, ..)
     *             .enqueue("save", [modelC, modelD], ..)
     *             .sync()
     *             .promise()
     *             .done(..).fail(..); // note: promise handlers on "sync" result, when all sync requests are complete
     *       </pre>
     *
     * <li> "Horizontal parallel queueing" - multiple targets, multiple sync methods:
     *       <pre>
     *         return manager.queue(true) // true = parallel
     *             .enqueue("save", modelA, ..)
     *             .enqueue("publish", modelB, ..)
     *             .enqueue("save", [modelC, modelD], ..)
     *             .sync()
     *             .promise()
     *             .done(..).fail(..); // note: promise handlers on "sync" result, when all sync requests are complete
     *       </pre>
     *
     * </ol>
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     *
     */
    var SyncManager = EventDispatcher.extend("SyncManager", {

        /**
         * @private {SequentialQueue[]|ParallelQueue[]}
         * Queue of sequential and/or parallel queues. <p>
         *
         * Individual queues may or may not block each other, and may be executing currently. For example, two
         * different queue may reference different targets entirely, or there may be an overlap. On overlap,
         * the first added queue will block the latter queue (at some point). <p>
         *
         * Once a queue is empty, it will be discarded by sync manager altogether.
         */
        _bulkQueues: null,
        /**
         * @private @type {Map<*,TargetQueue>}
         * Map of target instances/identifiers -> target queue per target entity (instance). The same queue
         * may be indexed by numerous identifiers, but always by the target itself at least. <p>
         *
         * Once a queue is empty, it will be discarded by this sync manager altogether.
         *
         * @see #_targetQueuesSize
         */
        _targetQueues: null,
        /**
         * @private @type {Number}
         * The number of unique target queues currently in <tt>_targetQueues</tt>.
         *
         * @see #_targetQueues
         */
        _targetQueuesSize: null,
        /**
         * @private @type {Map<*,Syncer>}
         * Map of target syncers in play, will only differ from <tt>_targetQueues</tt> in case we have pending
         * sync requests on for example debounced syncing, such as debounced sync in the editor.
         */
        _syncers: null,
        /**
         * @private @type {Number}
         * The current number of actively dequeuing queues, i.e. where syncs are in progress (i.e. a blocked queue
         * will not be included in this count). <p>
         *
         * Note the number does not say anything about the number of active targets, since it reflects all queues. <p>
         *
         * A change in this number will cause this manager to trigger events.
         */
        _dequeuing: null,
        /**
         * @private @type {*}
         * Options for this sync manager. <p>
         *
         * Can contain:
         * <pre>
         *    {
         *       timeout: Number // sync timeout in ms, defaults to 20s, for individual sync requests
         *    }
         * </pre>
         */
        _options: null,

        /**
         * @constructor
         * Constructor, which creates this sync manager.
         *
         * @param {*} [options] The options to use for this manager; will default.
         */
        constructor: function constructor(options) {
            this._options = options || {};
            this._bulkQueues = [];
            this._targetQueues = new Map();
            this._targetQueuesSize = 0;
            this._syncers = new Map();
            this._dequeuing = 0;
        },


        /**
         * Returns the globally unique target identifier(s) for the supplied target.
         *
         * @param  {*}   target The target to find its current globally unique identifiers for; cannot be falsey.
         *                      Any target must be a mutable object type since it will (eventually) be assigned a
         *                      <tt>syncState</tt> property, if not already.
         * @return {[]}  The globally unique target identifier(s); never empty, will always contain <tt>target</tt>.
         * @throw  Error If <tt>target</tt> is a non-boolean, non-mutable object type (e.g. a string).
         */
        targetIdentifiers: function targetIdentifiers(target) {
            var unique = Syncer.State.state(target).unique;
            // Function to return unique identifiers...
            if (_.isFunction(unique)) {
                return unique(target);
            }
            // Props...
            return this._targetIdentifiers(target, unique);
        },


        /**
         * @private
         * Returns a new array of all currently defined target identifiers for the supplied target, where only those
         * properties storing a defined identifiers in <tt>props</tt> will cause an identifier to be returned. <p>
         *
         * The returned array will always contain <tt>target</tt> as the first index, i.e. can uniquely identify
         * its own instance.
         *
         * @param {*}        target The target to find the identifiers for; cannot be falsey.
         * @param {String[]} props  The properties in the synced target that can store a globally unique identifier for
         *                          it (besides the target instance itself); never falsey. Properties will be tried
         *                          looked up based on Backbone getter, secondly as a normal property.
         * @return {[]} An array of available globally unique identifiers; never falsey, and never empty (will always
         *              contain the supplied target instance at least).
         */
        _targetIdentifiers: function _targetIdentifiers(target, props) {
            // Target *instance* is also a target identifier by itself...
            var identifiers = [target];

            var prop = function prop(name) {
                if (_.isFunction(target.get)) {
                    return target.has(name) && target.get(name);
                }

                return _.result(target, name);
            };

            var identifier = void 0;
            var name = void 0;
            var i = void 0;

            for (i = 0; i < props.length; i++) {
                name = props[i];
                identifier = prop(name);
                if (identifier) {
                    identifier = name + ":" + identifier;
                    if (target.__typeName) {
                        identifier = target.__typeName + ":" + identifier;
                    }
                    identifiers.push(identifier);
                }
            }
            return identifiers;
        },


        /**
         * Returns a (new) <i>target queue</i>, a new <i>sequential queue</i>, <<b>or</b> a new <i>parallel queue</i>. <p>
         *
         * In case a pre-existing target queue is returned, it may already be syncing/dequeuing! Freshly created
         * queues, regardless of type, are not started. <p>
         *
         * See class documentation for example use-cases.
         *
         * @param {*|Boolean} [target]        The target used for the target queue, or false for a sequential queue or true
         *                                    for a parallel queue to be created and returned. All non boolean types must
         *                                    be a mutable object type since <tt>target</tt> will then be assigned a
         *                                    <tt>syncState</tt> property, if not already.
         * @param {Function}  [resultHandler] The result handler to transform results for the created queue, if any.
         *                                    Will default so each target synced will be resolved as-is, in queued
         *                                    order for bulk queues, and a single target for target queues.
         * @param {Boolean}  [doNotCreate]    True to return null if no such target queue exists or is stale, false to
         *                                    create and register a new target queue (default). Ignored for any
         *                                    type of queue except target queues.
         *
         * @return {Queue} The corresponding (new) queue; can ever only be null if <tt>doNotCreate</tt> is true.
         *                 If a queue is returned, it will be discarded once it becomes empty again.
         * @throw  Error   If <tt>target</tt> is a non-boolean, non-mutable object type (e.g. a string).
         */
        queue: function queue(target, resultHandler, doNotCreate) {
            var _this = this;

            if (_.isUndefined(target)) {
                target = false; // sequential
            }

            // Sequential or parallel bulk queue?
            if (_.isBoolean(target)) {
                // No explicit target, so we create a sequential or parallel queue as specified, where targets can be
                // added to before synced...
                var q = target ? new ParallelQueue(this, resultHandler) : new SequentialQueue(this, resultHandler);
                this._bulkQueues.push(q);
                // Remember to clean up when empty...
                q.promise().always(function () {
                    var i = _this._bulkQueues.indexOf(q);
                    if (i !== -1) {
                        _this._bulkQueues.splice(i, 1);
                        log.verbose("Discarded queue: " + q + " -> " + _this, q, _this);
                    }
                });
                return q;
            }

            // If we have an individual target, we (re-)use a target queue based on target identifier(s) (which may
            // be the target instance itself)...
            var identifiers = this.targetIdentifiers(target);

            var tq = null;
            var i = void 0;

            for (i = 0; i < identifiers.length; i++) {
                tq = this._targetQueues.get(identifiers[i]);
                // Find *active* queue, if possible...
                if (tq && !tq._stop) {
                    break;
                }
            }
            if (!tq || tq._stop) {
                // do not reuse stale target queues...

                // If true, only return existing queues, used for testing queue existence...
                if (doNotCreate) {
                    return null;
                }

                tq = new TargetQueue(this, this._syncer(target, identifiers), resultHandler);
                // Remember to clean up when empty...
                tq.promise().always(function () {
                    _this._unregisterQueue(tq);
                    log.verbose("Discarded queue: " + tq + " -> " + _this, tq, _this);
                });

                this._registerQueue(tq, identifiers);
            }
            return tq;
        },


        /**
         * @protected
         * Registers the supplied target queue, and optionally its associated syncer, as in use by this
         * sync manager. <p>
         *
         * Since a target may changes its global unique identifiers over time, i.e. on creation or simply because it
         * has several unique properties, this is needed to associate the same target queue instances will numerous
         * global target identifiers for it. When the queue is depleted, all such identifiers will be cleared.
         *
         * @param {TargetQueue}  queue         The target queue to register; cannot be falsey.
         * @param {[]}           [identifiers] The target identifier(s) to register the target queue by, defaulting to
         *                                     the identifiers calculated "now".
         */
        _registerQueue: function _registerQueue(queue, identifiers) {
            if (arguments.length === 1) {
                identifiers = this.targetIdentifiers(queue._syncer.target);
            }
            // We know we have a new queue if the target itself is not in the map as "identifiers" will always contain
            // at least the synced target itself...
            var newQueue = !this._targetQueues.has(queue._syncer.target);

            var identifier = void 0;
            var i = identifiers.length;
            var j = void 0;

            if (newQueue) {
                this._targetQueuesSize++;
            }

            loop: while (i--) {
                identifier = identifiers[i]; // possible new identifier...
                for (j = 0; j < queue._identifiers.length; j++) {
                    // Does it already exist? If so, we ignore it...
                    if (queue._identifiers[j] === identifier) {
                        continue loop;
                    }
                }
                // Identifier is new, so register it for the queue/syncer...
                queue._identifiers.push(identifier);
                // Register queue and syncer itself, so we know the correlate...
                this._targetQueues.set(identifier, queue);
                this._syncers.set(identifier, queue._syncer);
            }
        },


        /**
         * @private
         * Unregisters the supplied target queue after it has stopped (depleted). The queue will thus be completed
         * discarded, never to be used again.
         *
         * @param {TargetQueue} queue The target queue to unregister; never falsey.
         * @see   #_registerQueue
         */
        _unregisterQueue: function _unregisterQueue(queue) {
            var identifier = void 0;
            var i = void 0;

            for (i = 0; i < queue._identifiers.length; i++) {
                identifier = queue._identifiers[i];
                this._targetQueues.delete(identifier);
                this._syncers.delete(identifier);
            }
            this._targetQueuesSize--;
        },


        /**
         * @protected
         * Queue callback to keep track of overall sync state for this sync manager. <p>
         *
         * On actual state change, the "syncing" event will be triggered, with two arguments: a boolean flag
         * that will be true if this manager went from not syncing to syncing, or false if it went from
         * syncing to no longer syncing; and this manager as the second argument.
         *
         * @param {Boolean} True if the caller queue is currently active dequeuing stuff, false if it is not.
         *
         * @see   #syncing
         */
        _state: function _state(dequeuing) {
            var trigger = false;
            var syncing = false;

            // Dequeuing started, a count of one now?
            if (dequeuing) {
                if (++this._dequeuing === 1) {
                    trigger = true;
                    syncing = true;
                }

                // Dequeuing all done, back to zero?
            } else if (--this._dequeuing === 0) {
                trigger = true; // syncing already false
            }

            if (trigger) {
                log.verbose("Changed sync state: " + this + " -> " + syncing);
                this.trigger("syncing", syncing, this);
            }
        },


        /**
         * Returns true if this sync manager is current syncing (in the background), false otherwise. <p>
         *
         * State changes will also be notified via the event "syncing", with two arguments: a boolean flag
         * that will be true if this manager went from not syncing to syncing, or false if it went from
         * syncing to no longer syncing; and this manager as the second argument.
         *
         * @return {Boolean} True if this sync manager is current syncing, false otherwise.
         */
        syncing: function syncing() {
            return !!this._dequeuing;
        },


        /**
         * @private
         * Returns a (new) syncer to (eventually) invoke sync requests for the supplied target. <p>
         *
         * An existing syncer may be returned in case the target in question has pending sync requests, such as
         * for example a debounced save in the editor. <p>
         *
         * Note that <tt>target</tt> cannot be a read-only value, as it will be augmented with a
         * <tt>syncState</tt> property, e.g. cannot be a string.
         *
         * @param  {*} target        The target to (eventually) invoke sync requests for; cannot be falsey. Must be a
         *                           type that is an object, e.g. cannot assign properties to primitive types.
         * @param  {*} [identifiers] The specified identifier(s) to use for <tt>target</tt>, defaulting to the current
         *                           target identifiers of <tt>target</tt> if not supplied.
         * @return {Syncer} A (new and) configured syncer for <tt>target</tt>; never null.
         * @throw  Error If <tt>target</tt> is not a mutable object.
         */
        _syncer: function _syncer(target, identifiers) {
            Preconditions.checkState(_.isObject(target), new Error("Target must be an object, not: '" + target + "'"));
            if (arguments.length === 1) {
                identifiers = this.targetIdentifiers(target);
            }
            var syncer = void 0;
            var i = void 0;

            for (i = 0; i < identifiers.length; i++) {
                syncer = this._syncers.get(identifiers[i]);
                if (syncer) {
                    break;
                }
            }
            if (!syncer) {
                syncer = new Syncer(this, target, this._options.timeout);
                for (i = 0; i < identifiers.length; i++) {
                    this._syncers.set(identifiers[i], syncer);
                }
            }
            return syncer;
        },


        /**
         * Blocks <tt>target</tt> until each target to wait for (those in <tt>waitFor</tt>) have a blocking await
         * request at the head of their individual target queues (enqueued here). The effect of this is to ensure
         * that one target can be blocked while other requests for other targets are syncing, while blocking said
         * targets while the target it self is syncing. An example could be to wait for all assets in a group to
         * have synced before pushing the group and assets. <p>
         *
         * The return value is a "wait function" that must be invoked to actually start the waiting. This function
         * will enqueue relevant blocking requests, but the individual queues will not be actually unblocked until
         * the wait function has been called, even if the blocking await requests for each target in <tt>waitFor</tt>
         * is already at the head of their respective queues. This is to ensure the calling context can enqueue
         * additional requests for <tt>target</tt> to be synced before we allow the wait for target queues to
         * proceed. <p>
         *
         * In addition, a set of sync options and var-args can be specified, which will enqueue such a sync request
         * for each wait for target individually, but not for <tt>target</tt>, immediately after the block request
         * to wait for. The effect of this is that such request will be executed immediately after the await request
         * is unblocked per target.
         *
         * @param  {*}        target   The target to block until <tt>waitFor</tt> are all stable <b>after</tt> the
         *                             returned wait function has been called; cannot be falsey.
         * @param  {*|[]}     waitFor  The target(s) to wait for before <tt>target</tt> is unblocked; cannot be falsey.
         *                             While the target queue for <tt>target</tt> is then syncing actively, all these
         *                             targets will be blocked until the target queue for <tt>target</tt> is empty.
         * @param {String|*} [options] Optional sync method name, e.g. "_save" or "save", or sync options for a sync
         *                             request to enqueue after the block request per wait for target (not for
         *                             <tt>target</tt>!); can be falsey.
         * @param {...*}     [argumentsJsDoc] Arguments, as var-args, for the actual sync method when invoked if <tt>options</tt>
         *                             is specified, if any. Will default to an empty array of arguments.
         *
         * @return {Function} An wait function to call once the target queue for <tt>target</tt> is ready to start
         *                    waiting; never falsey. The return value of the wait function is a promise that will
         *                    resolve once the entire await logic is done. Must be call to start the actual waiting;
         *                    until called, the queues in question (i.e. those for <tt>target</tt> and each target
         *                    in <tt>waitFor</tt> can still be changed without them ever getting past the enqueued
         *                    blocked requests).
         *
         * @see    #block
         * @see    Queue#block
         * @see    Queue#sync
         */
        // eslint-disable-next-line no-unused-vars
        await: function _await(target, waitFor, options, argumentsJsDoc) {
            if (!_.isArray(waitFor)) {
                waitFor = [waitFor];
            }

            var n = waitFor.length;
            var promises = [];
            var queues = [];

            var blocked = "await";
            var notify = false;
            var promise = void 0;
            var tq = void 0;
            var i = void 0;

            // Target unblocker, implicitly creating a target queue for the target if not already. The enqueued
            // block request will thus go to the end of the queue since blocked...
            var targetUnblock = this.block(target);

            // Wait for unblocker...
            var waitForUnblock = function waitForUnblock() {
                if (blocked) {
                    blocked = false;
                    // Try and sync each queue, but they may still be blocked...
                    for (var j = 0; j < n; j++) {
                        queues[j].queue.sync();
                    }
                }
            };

            var blockedHandler = function blockedHandler() {
                if (notify && n === queues.length) {
                    // latter check because we call "sync" on each target queue after queuing a "block" request...
                    var entry = void 0;
                    var j = void 0;
                    // Check each queue and make sure to (re-)start syncing if it was blocked because of our blocker...
                    for (j = 0; j < n; j++) {
                        entry = queues[j];
                        if (entry.queue.head() !== entry.entry) {
                            return blocked;
                        }
                    }
                    notify = false;
                    targetUnblock();

                    // Fall-through - still blocked until unblocker called!
                }

                return blocked;
            };

            // Find the target queue for each target to wait for and block it. We get a promise for each the tail of
            // each queue, which is either the block requests or the request enqueued after it based on "options"
            // and "varArgs"...

            for (var _len = arguments.length, args = Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
                args[_key - 4] = arguments[_key];
            }

            for (i = 0; i < n; i++) {
                tq = this.queue(waitFor[i]); // may already be syncing...
                queues.push({ queue: tq, entry: tq.block(blockedHandler).entry });

                // Enqueue a sync request *per* queue to be dequeued once the unblocker is called?
                if (options) {
                    var enqueueArgs = [argumentsJsDoc].concat(args);
                    tq.enqueue(options, enqueueArgs); // varArgs -> []
                }

                // Get promise from the tail at this point in time, to be combined into a single promise to eventually
                // return by the return wait function to represent the completion of this entire await operation...
                promises.push(tq.tail().promise());
            }

            // Save a reference to the actual target queue for the wait function below...
            tq = this.queue(target);

            // Return wait function, to start the logic to (eventually) unblock "waitFor" targets once the
            // target queue for "target" is ready, i.e. added additional requests to it. The wait function will
            // return the promise that will resolve once the entire await operation has completed, i.e. after
            // all "waitFor" targets have been unblocked after "target" has been synced...
            return function () {
                if (!promise) {
                    notify = true;

                    // Make sure we call "waitForUnblock" once the target is unblocked and have synced with regards to
                    // this await invocation. The block of "target" added above is guaranteed to be in the target queue
                    // at this point since blocked by design, but other sync requests can (will) have been added
                    // after "await" was called for "target" and until this wait function is called. We thus know
                    // we have a valid tail of the target queue for "target", which will be the block request if nothing
                    // else have been enqueued. We cannot simply wait for the entire target queue to finish, since
                    // more stuff can be added to it while we wait...
                    tq.tail().promise().always(waitForUnblock); // always: to ensure cancel and failure also handled

                    for (var j = 0; j < n; j++) {
                        queues[j].queue.sync();
                    }

                    // Get a combined promise for all "waitFor" target queues...
                    promise = Promise.all(promises);
                }
                return promise;
            };
        },


        /**
         * Enqueues an immutable sync method that will simply return each target when synced (resolved), but effectively
         * blocking each supplied target until the returned unblocker function has been called to unblock each block
         * request (per target) just enqueued. This is useful to block targets across different queues. <p>
         *
         * Even though the returned unblocker has been called, individual targets may still be blocked from
         * elsewhere! <p>
         *
         * In addition, a set of sync options and var-args can be specified, which will enqueue such a sync request
         * for each target individually (using the same target queue) immediately after the block request, i.e. will
         * simply call <tt>sync(options, target[i], var-args)</tt>. The effect of this is that such request will be
         * executed immediately after the block request is unblocked, per target.
         *
         * @param  {*|[]}     targets  The target(s) to enqueue a blocking sync request for; cannot be falsey.
         * @param {String|*} [options] Optional sync method name, e.g. "_save" or "save", or sync options for a sync
         *                             request to enqueue after the block request per target; can be falsey.
         * @param {...*}     [argumentsJsDoc] Arguments, as var-args, for the actual sync method when invoked if <tt>options</tt>
         *                             is specified, if any. Will default to an empty array of arguments.
         *
         * @return {Function} An unblocker function to call once the blocking just enqueued should cease to block;
         *                    never falsey. If <tt>options</tt> (and optionally <tt>varArgs</tt>) is supplied, the
         *                    corresponding sync request will be dequeued once the unblocker is called.
         *
         * @see    #await
         * @see    Queue#block
         * @see    Queue#sync
         */
        // eslint-disable-next-line no-unused-vars
        block: function block(targets, options, argumentsJsDoc) {
            var blockedHandler = function blockedHandler() {
                return blocked;
            };
            var queues = [];

            var blocked = "blocked";
            var tq = void 0;
            var i = void 0;

            if (!_.isArray(targets)) {
                targets = [targets];
            }
            // Find the target queue for each target and block it...

            for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
                args[_key2 - 3] = arguments[_key2];
            }

            for (i = 0; i < targets.length; i++) {
                tq = this.queue(targets[i]);
                queues.push({ queue: tq, entry: tq.block(blockedHandler).entry });

                // Enqueue a sync request *per* queue to be dequeued once the unblocker is called?
                if (options) {
                    var enqueueArgs = [argumentsJsDoc].concat(args);
                    tq.enqueue(options, enqueueArgs); // varArgs -> []
                }
            }

            // Unblocker function...
            return function () {
                if (blocked) {
                    blocked = false;
                    // Try and sync each queue, but they may still be blocked...
                    for (var j = 0; j < queues.length; j++) {
                        queues[j].queue.sync();
                    }
                }
            };
        },


        /**
         * Cancels any pending or queue sync methods with the specified name for the specified target, returning
         * true if actual cancellation took place, false otherwise.
         *
         * @param  {*}      target The target in question; cannot be falsey.
         * @param  {String} method The sync method for <tt>target</tt> cancel; cannot be falsey.
         *
         * @return {Boolean} True if (at least one) such a request was cancelled, false otherwise.
         * @throw  Error If <tt>target</tt> is not a mutable object.
         *
         * @see    #sync
         * @see    Queue#cancel
         */
        cancel: function cancel(target, method) {
            // Since we know all sync requests will eventually be queued via a target queue for any target in
            // question, we get said queue, if it exists, and cancel where applicable: any pending, including queued,
            // sync request with the specified type will be cancelled. This is needed because even though we drop
            // successive identical sync methods on queuing, sync methods can still alternate like "save", "push",
            // "save", "push", etc., i.e. same sync method can be present in the queue. However, this may leave
            // the same type of sync methods in the queue, e.g. "push" followed by "push", but for simplicity we leave
            // them be, since we have already given out promises for their completion. A bit more work will then
            // be performed, but it is a rare case anyway and no need to make the queue implementation even more
            // complex...
            var tq = this._targetQueues.get(target);

            var cancelled = false;

            if (tq) {
                cancelled = tq.cancelMethod(method);
            }

            return cancelled;
        },


        /**
         * Short-cut for calling <tt>Syncer.cancelable(promise)</tt> on the syncer used <tt>target</tt>. <p>
         *
         * This function should be called from within any sync method logic using an external promise that should
         * be cancelable, e.g. to mask a promise for a http request doing the actual work.
         *
         * @param  {*}               target  The target in question; cannot be falsey.
         * @param  {Promise|Boolean} promise The actual promise describing the actual sync method, e.g. the promise for a
         *                                   http request to save <tt>target</tt>; or a boolean false value when
         *                                   Backbone will not do a server round trip, like when destroying an
         *                                   unsaved model. In the latter case, this function will return a resolved
         *                                   promise with <tt>target</tt> as the resolved value.
         *
         * @return {Promise} A new promise to use in place of <tt>promise</tt>; never falsey. If <tt>promise</tt> is
         *                   false, a new promise already resolved to <tt>target</tt> is returned.
         *
         * @see    Syncer#cancelable
         * @see    #pending
         * @see    #sync
         */
        cancelable: function cancelable(target, promise) {
            return this._syncer(target).cancelable(promise); // TODO: TargetQueue instead? Like on cancel()?
        },


        /**
         * Convenience function to listen for a ("sync:state", state, method, target) event for the specified target(s),
         * one-time only or continuously. <p>
         *
         * Options can have the following format:
         * <pre>
         *   {
         *      target:   *|Collection,                // mandatory, the target(s) to listen for "sync:state" event(s),
         *                                             // optionally in a Backbone collection.
         *      callback: Function,                    // mandatory, a standard listener for "sync:state" events on
         *                                             // <tt>options.target</tt>, having the format
         *                                             // <tt>fn(state:Syncer.State, method:String, error:*, target:*)</tt>.
         *                                             // Will be invoked with the relevant target scope.
         *      state:    Syncer.State|Syncer.State[], // optional, the specific Syncer.State(s) to listen for,
         *                                             // defaulting to <tt>Syncer.State.Synced</tt> if undefined. Use
         *                                             // null to be notified on any state.
         *      method:   String|String[],             // optional, the specific sync method(s) to listen for, defaulting
         *                                             // to any method (combined with <tt>options.state</tt>).
         *      once:     Boolean,                     // optional, true to only listen for the first such sync state
         *                                             // event, false to listen continuously (default).
         *      context:  *                            // optional, the context listening for the "sync:state" event(s),
         *                                             // defaulting to <tt>options.target</tt>.
         *   }
         * </pre>
         *
         * <tt>options.context</tt> must support Backbone's <tt>listenTo</tt> and <tt>stopListening</tt> to functions,
         * and <tt>options.targets</tt> must support Backbone's <tt>trigger/tt> function for this to work. <p>
         *
         * @param {*} options The options as described above; cannot be falsey.
         * @return {Function} A no-arg function to remove the callback manually, if not already removed; if so, the
         *                    returned function will be a no-op when invoked.
         * @throws {Error} If <tt>context</tt> does not support Backbone's <tt>listenTo</tt> and <tt>stopListening</tt>
         *                 functions.
         * @see    #promise
         */
        onSync: function onSync(options) {
            // null to allow a default or all (Synced on undefined, all on null)...
            var context = options.context || options.target;

            var state = options.state === null ? null : options.state || Syncer.State.Synced;
            var method = options.method;

            if (state && !_.isArray(state)) {
                state = [state];
            }
            if (method && !_.isArray(method)) {
                method = [method];
            }

            // The sync:state handler will always be supplied the actual target as the last argument, which we have
            // to use here, as "options.target" can be a Backbone Collection that will re-trigger events from
            // contained models (targets)...
            var handler = function handler(s, m, error, target) {
                if ((!state || state.indexOf(s) !== -1) && (!method || method.indexOf(m) !== -1)) {
                    if (options.once) {
                        remove();
                    }
                    options.callback.call(target, s, m, error, target);
                }
            };

            var remove = function remove() {
                context.stopListening(options.target, "sync:state", handler);
            };

            context.listenTo(options.target, "sync:state", handler);
            return remove;
        },


        /**
         * Returns a promise that will resolve when no sync requests are syncing and/or queued from the supplied
         * targets, or be rejected on error or because sync requests keep getting enqueued or on a specified allow
         * timeout to wait. <p>
         *
         * If at call time no queues are active for the target(s), the returned promise will already have been
         * resolved (and <tt>done</tt> handlers will fire immediately).
         *
         * @param {*|[]}    targets   The target(s) to wait for, either a single target or an array of targets; cannot be falsey.
         * @param {Number} [timeout]  The timeout in milliseconds to wait until the returned promise should be rejected;
         *                            default no timeout.
         * @param {*}      [deferred] The backing deferred (private, used for recursion).
         *
         * @return {Promise} A promise that will resolve when no active and/or queued sync requests for the specified
         *                   target(s); never falsey.
         * @see    #onSync
         */
        promise: function promise(targets, timeout, deferred) {
            var _this2 = this;

            // "deferred" private, used on recursion!
            if (!deferred) {
                deferred = Promise.deferred();
            }

            var resolved = true;

            // Simply optimisation attempt: no target queues mean no syncing, so we can return resolved promise as-is...
            if (this._targetQueuesSize) {
                if (!_.isArray(targets)) {
                    targets = [targets];
                }

                var promises = [];

                var tq = void 0;
                var i = void 0;

                for (i = 0; i < targets.length; i++) {
                    // We know each target will always reference its own queue, perhaps with other identifiers, but
                    // always by its own instance, so it suffices to check for this here...
                    tq = this._targetQueues.get(targets[i]);
                    if (tq && !tq._stop) {
                        promises.push(tq.promise());
                    }
                }

                // Since we may have any number of pending queues, we cannot simply use the resolved
                // value from it. Zero pending requests means that we are ready for "targets"...
                if (promises.length) {
                    var promise = promises.length === 1 ? promises[0] : Promise.all(promises);

                    if (Promise.isPending(promise)) {
                        promise = promise.done(function () {
                            // Recurse, as we could have had concurrently pending sync requests; we no longer applicable,
                            // we will have more promises, or queues at all, and we will fall through to resolving below.
                            // We must cancel pending timeout, and subtract already used time...
                            if (timeout && _.isFunction(promise.clearTimeout)) {
                                timeout -= promise.clearTimeout();
                            }
                            // No need to return a new promise here, since the promises are all internal - we ever
                            // only return promises based on "deferred"...
                            _this2.promise(targets, timeout, deferred);
                        });

                        if (timeout) {
                            Promise.time(deferred, promise, timeout);
                        }
                        resolved = false;
                    }
                }
            }

            if (resolved) {
                deferred.resolve(targets);
            }

            // Return the *public* promise then, always from the (recursively) defined deferred...
            return deferred.promise();
        },


        /**
         * Performs the specified sync method on the supplied target(s), returning a promise that will resolve or
         * reject when the sync request(s) has (have) completed successfully or (just one) failed, respectively. <p>
         *
         * <tt>options</tt> can have the following structure (or be a string):
         * <pre>
         * {
         *   method:        String,            // mandatory: logical name used for triggering sync:state events, e.g. "save" or "_save".
         *   fn:            Function|*,        // optional: function to perform the work; ajax options if "http" is true; or result to
         *                                     // return as-is otherwise. If not specified, the function is looked up the target(s) based
         *                                     // on "method". Will be invoked with target scope.
         *   silent:        Boolean,           // true to suppress "sync:state" events for the request, false otherwise (default).
         *   parallel:      Boolean,           // optional: true for parallel execution if multiple targets, false (default) for sequential execution.
         *   promise:       Boolean,           // optional: true to return a <tt>Promise</tt> for the request just enqueued,
         *                                     // false to return the <tt>Queue</tt> in question (default).
         *   delay:         Number,            // optional: debounce delay in ms before the sync request can be executed: will
         *                                     // be debounced if an equivalent request is enqueued in the queue within this time span.
         *   http:          Boolean,           // optional: true for http sync requests (default), false otherwise. Used to
         *                                     // determine http error codes.
         *   immutable:     Boolean,           // optional: true if the sync request will is read-only, false if it is assumed
         *                                     // to updates stuff/the target (default).
         *   validate:      Function|Boolean,  // optional: a function to return null on success, <tt>Syncer.State.Cancel</tt> to
         *                                     // cancel the request at request invocation time, or any other value to be raised
         *                                     // as an error at request invocation time. Default null. Invoked with target scope after
         *                                     // "privilege" or "role" has been tested.
         *   resultHandler: Function,          // optional: function to transform each sync method result before resolved; will
         *                                     // default to the synced target for target queues, and to all synced
         *                                     // targets for bulk queues, in queuing order. Invoked with target scope.
         *   errorHandler:  Function,          // optional: error handler passed to the ErrorHandler type to process errors. Invoked
         *                                     // with target scope.
         *   cancelable:    Function,          // optional: a function that will determine if the request is considered cancelable
         *                                     // or not. Any request can be cancelled, but the actual promise may resolve later,
         *                                     // e.g. if cancelled because of timeout. This function determines if such a
         *                                     // "late resolve" should be allowed to update the target or not. For versioned models,
         *                                     // for example, they should be allowed on updates or a 409 is likely to
         *                                     // follow on next update. For this to make sense, the actual promise
         *                                     // should be wrapped via SyncManager.cancelable(target, promise).
         *   privilege:     Privilege,         // optional: privilege to be allowed to do the sync request, if any, OR
         *   role:          Role               // optional: role to be allowed to do the sync request, if any (privilege takes precedence)
         * }
         * </pre>
         *
         * If <tt>options</tt> is a string, say "_save", it is treated like this structure for each synced target:
         * <pre>
         *   {
         *       method:     "save",          // "save" -> "save", "_save" -> "save"
         *       fn:         target["_save"], // can be private
         *       silent:     false,           // not silent, i.e. trigger "sync:state" for targets that supports "trigger"
         *       parallel:   false,           // not parallel
         *       http:       true,            // assumed http
         *       immutable:  false,           // assumed mutable
         *       promise:    false            // returns the queue, not a promise
         *   }
         * </pre>
         *
         * @param {String|*} options  The sync method name, e.g. "_save" or "save", or options like described
         *                            above; never falsey. The (deduced) sync method can be any closure to be synced
         *                            on <tt>targets</tt>, though it will normally operate on said target(s). If a string,
         *                            such a (private allowed) function is expected to be defined on each target. Sync
         *                            events triggered for each target in <tt>targets</tt> will never use a private method
         *                            name, e.g. "_save" will be triggered as "save".
         * @param {*|[]}    targets   The target(s) in question; cannot be falsey. Each target in must be a type that is
         *                            a mutable object, e.g. cannot assign properties to primitive or read-only types.
         * @param {...*}    [argumentsJsDoc] Arguments, as var-args, for the actual sync method when invoked, if any. Will
         *                            default to an empty array of arguments.
         *
         * @return {Queue|Promise} The queue handling the sync request(s) <b>or</b> a promise is so specified for
         *                         the enqueued requests (not for the queue); never falsey. If a queue, obtain a promise
         *                         that that will resolve once all sync requests have completed via
         *                         <tt>returnedQueue.promise()</tt>. To cancel the queue, call
         *                         <tt>returnedQueue.cancel()</tt>.
         * @throws {Error} If <tt>options</tt> is a string and no such (private) sync function is defined on the
         *                 target(s), or if a target is not a mutable object.
         *
         * @see    #queue
         * @see    #pending
         * @see    #cancel
         * @see    #cancelable
         */
        // eslint-disable-next-line no-unused-vars
        sync: function sync(options, targets, argumentsJsDoc) {
            // (method, targets, ..)
            // "Promise mode", i.e. assumed to be making a request for some data outside model scope...
            if (options.promise) {
                // Give me data and not model...
                if (!options.resultHandler) {
                    options.resultHandler = function (data) {
                        return data;
                    };
                }
                // Suppress timeouts...
                if (!options.errorHandler) {
                    options.errorHandler = function () {
                        return false;
                    };
                }
            }

            for (var _len3 = arguments.length, args = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
                args[_key3 - 3] = arguments[_key3];
            }

            var syncArgs = [argumentsJsDoc].concat(args);

            // Do we need a bulk queue for explicit ordering between different target entities? Only if an array
            // of targets is supplied with a length larger than one...
            if (_.isArray(targets)) {
                if (targets.length > 1) {
                    return this._syncMany(options, targets, syncArgs); // default sequential!
                }
                targets = targets[0];
                // Fall-through
            }
            // ..or just a single target, in which case a target queue will suffice!?...
            return this._syncOne(options, targets, syncArgs);
        },


        /**
         * @private
         * Performs the specified sync method on the supplied target, returning a promise that will
         * resolve when the sync request has completed.
         *
         * @param {String|{method:String, fn:Function}} options The sync method, e.g. "save" or options like
         *                                                      <tt>{method: "foo", fn: this.foo.bind(this)}</tt>;
         *                                                      never falsey. The <tt>fn</tt> can be any closure to
         *                                                      be synced on <tt>targets</tt>, though it will normally
         *                                                      operate on said targets. If a string, such a (private
         *                                                      allowed) function is expected to be defined on
         *                                                      <tt>target</tt>.
         * @param {*}      target The target in question; never null, but can be empty.
         * @param {[]}     syncOneArgs   Arguments for the sync method when invoked; never falsey, but can be empty.
         *
         * @return {Queue|Promise} The queue used for the sync <b>or</b> the promise for the request just
         *                         enqueued if <tt>options.promise</tt> is truthy; never null.
         *
         * @see    #_syncMany
         */
        _syncOne: function _syncOne(options, target, syncOneArgs) {
            // (Re-)use *target queue* for the specified target and ensure sync request...
            var tq = this.queue(target);

            // Enqueue...
            var promise = tq.enqueue(options, syncOneArgs);

            // Start dequeuing, if not already, and when ready. That is, the queue may be blocked, now or later,
            // until ready to invoke the current sync request...
            tq.sync(); // note: returns promise that resolve on queue empty, not what we need here!

            // Return queue *or* promise if so requested...
            return options.promise ? promise : tq;
        },


        /**
         * @private
         * Performs the specified sync method on all supplied targets in sequential or parallel order, returning a
         * promise that will resolve when all sync requests have completed.
         *
         * @param {String|{method:String, fn:Function, ..}} options The sync method, e.g. "save" or options like
         *                                                          <tt>{method: "foo", fn: this.foo.bind(this), ..}</tt>;
         *                                                          never falsey. The <tt>fn</tt> can be any closure to
         *                                                          be synced on <tt>targets</tt>, though it will normally
         *                                                          operate on said targets. If a string, such a (private
         *                                                          allowed) function is expected to be defined on each
         *                                                          target.
         * @param {[]} targets The targets in question; never null, but can be empty.
         * @param {[]} args    Arguments for the sync method when invoked; never falsey, but can be empty.
         *
         * @return {Queue|Promise} The queue used for the sync <b>or</b> the promise for the request just
         *                         enqueued for all targets if <tt>options.promise</tt> is truthy; never null.
         *
         * @see    #_syncOne
         */
        _syncMany: function _syncMany(options, targets, args) {
            // Create sequential/parallel bulk queue...
            var bk = this.queue(options.parallel, options.result);

            // Enqueue the sync method for all targets...
            var promise = bk.enqueue(options, targets, args);

            // Start the sync (if not already by nested target queues)...
            bk.sync();

            // Return bulk queue...
            return options.promise ? promise : bk;
        },


        /**
         * Convenient for performing a silent http(s) GET request for the specified relative path, resolving to the
         * returned result as-is. <p>
         *
         * The default sync options used are:
         * <pre>
         *    method:    ..,   // last part from "location", e.g. "foo" from "bar/foo?optional-query-parameters".
         *    immutable: true,
         *    promise:   true  // per request, not per queue
         *    silent:    true, // no notifications on errors, use "fail(..) handler where required
         *    http:      true,
         *    fn:        { type: "GET", url: "path" qualified }
         * </pre>
         *
         * @param {String} location  The absolute URL or the relative path of the url, will be qualified with the base
         *                           url from the REST api; cannot be falsey.
         * @param {*}      target    The target to specify the queue to use; cannot be falsey.
         * @param {*}      [options] Additional options to use for the request, if any; can be falsey.
         *
         * @return {Promise} A promise that will resolve with the raw result from the GET request; never falsey.
         */
        get: function get(location, target, options) {
            // Can be null if called before REST api is initialised...
            var url = UrlUtil.isAbsoluteUrl(location) ? location : RestApi.qualify(location);
            if (!url) {
                return Promise.rejected();
            }

            var parts = url.split("/");
            var method = parts[parts.length - 1];
            var query = method.indexOf("?");

            // Drop query parameters from the method name...
            if (query !== -1) {
                method = method.substring(0, query);
            }

            return this.sync(_.extend({
                method: method,
                promise: true,
                immutable: true,
                silent: true, // will also suppress error notifications!
                fn: {
                    url: url,
                    type: "GET"
                }

            }, options || {}), target);
        },
        getJSON: function getJSON(location, target, options) {
            var url = UrlUtil.isAbsoluteUrl(location) ? location : RestApi.qualify(location);

            return this.get(location, target, _.extend({
                fn: {
                    url: url,
                    type: "GET",
                    dataType: "json"
                }
            }, options || {}));
        },


        /**
         * Convenient method for creating a new identified target to sync on (to identify a unique queue). <p>
         *
         * The returned target is a plain old JS object like:
         * <pre>
         *     {
         *         id:        String,   // the specified id
         *         toString:  Function, // simple returns the specified id
         *         syncState: {}        // sync state for the returned target
         *     }
         * </pre>
         *
         * If <tt>options</tt> are specified, they will be merged into <tt>syncState</tt> as described by
         * <tt>Syncer.State.init(..)</tt>.
         *
         * @param  {*} id        The id to uniquely identify the returned target; cannot be null or undefined.
         * @param  {*} [options] Additional sync options, if any.
         *
         * @return {*} A new target as specified; never falsey.
         */
        target: function target(id, options) {
            var target = {
                id: id,
                toString: function toString() {
                    return String(id);
                }
            };

            Syncer.State.init(target, _.extend({ unique: ["id"] }, options));

            return target;
        },


        /**
         * Returns the string representation of this manager.
         *
         * @return {String} The string representation; never falsey.
         */
        toString: function toString() {
            return "SyncManager[dequeuing: " + this._dequeuing + "; tq: " + this._targetQueuesSize + "; bq: " + this._bulkQueues.length + "]";
        }
    });

    return new SyncManager();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var callBind = __webpack_require__(476);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Configuration = __webpack_require__(27);
    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Window = __webpack_require__(48);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var channelBridge = __webpack_require__(241);

    var URLS = {};
    var _location = void 0;

    // valid url simply: https://.., http://.., //.., or /.. (relative)
    var VALID_REGEX = /^https:\/\/|^http:\/\/|^\//; // none of these use /g, so we do not care about lastIndex!
    var EMBED_REGEX = /(?:viewer.html(?:\?([a-z]+)=[^#]+)?#|^#)(group\/)?([0-9a-f]{24})(\/\d+)?$/; // allow short hand notation like "#id", "#group/id", and "#group/id/scene" as well

    /**
     * Contains url utility functions.
     *
     * @class UrlUtil
     */
    var scope = {

        /**
         * Returns the origin of the currently-loaded page. <p>
         *
         * If embedded via channels, this will be the actual client url; when viewed via a direct link, this will be
         * the viewer url. <p>
         *
         * @returns {String} The origin of the currently-loaded page; never falsey.
         */
        origin: function origin() {
            var location = window.location;
            return location.origin || location.protocol + "//" + location.host;
        },


        /**
         * Returns the base url of the client, i.e. origin + path name, excluding a trailing slash. <p>
         *
         * If embedded via channels, this will be the actual client base url; when viewed via a direct link,
         * this will be the viewer base url. <p>
         *
         * @returns {String} The base URL of the client; never falsey.
         */
        baseUrl: function baseUrl() {
            var url = scope.origin() + window.location.pathname;

            if (url.substr(-1) === "/") {
                return url.substr(0, url.length - 1);
            }

            return url;
        },


        /**
         * Gets an url descriptor for the specified url. <p>
         *
         * If the url is determined to link to an Experience or Group, the returned meta data will identify said
         * content via the <tt>id</tt> property and the <tt>type</tt> property will be either "experience" or
         * "group", and "valid" will be true. <p>
         *
         * If the embed url does not represent an Experience or Group, the <tt>type</tt> property will be set
         * to "url" and the <tt>valid</tt> property will describe if the url is determined to be valid or not.
         * The validation is simple, only checking for "https://", "http://", "//", or "/" prefixes. The
         * "sameOrigin" property will be true if the url has the same domain as the top most reachable window,
         * e.g. the client embedding an Experience, including if "url" is relative. <p>
         *
         * The returned descriptor will also successfully match an embed url for an Experience or Group generated
         * via <tt>getEmbedURL(descriptor, embedType, scene)</tt>.
         *
         * @param   {String} url The url to test for embedding; can be falsey.
         * @returns {{id:String, scene:Number, url:String, type:String, embedType:String, sameOrigin:Boolean, valid:Boolean}} A descriptor
         *          describing the embed url; never falsey, but <tt>id</tt> property will only be set if the url is
         *          determined to link to an Experience or Group.
         *
         * @see     #getEmbedURL
         */
        getUrlDescriptor: function getUrlDescriptor(url) {
            url = url || "";
            var match = EMBED_REGEX.exec(url);
            var descriptor = { type: "url", url: url };
            var topLocation = Window.topWindow().location;

            // (Recursively) embedded Experience or Group...
            if (match) {
                descriptor.id = match[3];
                descriptor.type = match[2] ? "group" : "experience"; // match[1] undefined on experience match
                descriptor.scene = match[4] ? parseInt(match[4].substr(1), 10) || 1 : 1; // matched "/" + \d+ or undefined, so drop "/" on match
                descriptor.embedType = match[1] || "none"; // e.g. "lightbox" or "embedded"
                descriptor.valid = true; // TODO: consider valid() checking for pushed content in Editor only, requires async method
                // Since we know the viewer base url is always a zmags domain, this will be false when embedded
                // successfully via channels, e.g. client domain vs Zmags domain, or true when embedded via a
                // direct url, perhaps because of a fallback direct url if the embedding via channels fails. It will
                // also be false in the editor for a top level Viewer embedding an Experience, as the Editor does
                // things differently... :/
                descriptor.sameOrigin = scope.sameOrigin(Configuration.viewerBaseUrl, topLocation);

                // Some other url *non* Experience/Group url...
            } else {
                descriptor.valid = VALID_REGEX.test(url);
                // Same origin on the url, e.g. a link to a client specific resource when embedded via channels; must
                // be embedded, or the origin with be that of the viewer. The use case for a url descriptor ensures
                // us that a relative url will always be opened relative to the top level window, so any relative
                // url is by default on the same origin...
                descriptor.sameOrigin = scope.sameOrigin(url, topLocation);
            }

            return descriptor;
        },


        /**
         * Gets the URL for to use for as the "src" for the iframe eventually embedded in the dom, either in the
         * Viewer or Editor context. <p>
         *
         * If the url is invalid, "about:blank" will be returned as nothing can be displayed for such an embedded
         * iframe.
         *
         * @param   {{id:String, scene:Number, type:String, url:String, embedType:String, sameOrigin:Boolean, valid:Boolean}} descriptor
         *          The url descriptor to use, earlier obtained via <tt>getUrlDescriptor</tt>; cannot be falsey.
         *
         * @param   {String} [embedType] The embed type, e.g. "lightbox" or "embedded"; can be falsey to generate a
         *                               "raw embed url", i.e. ignored. NOTE: new values require Akamai to be
         *                               configured accordingly!
         *
         * @param   {Number} [scene]     The current scene in this Experience/Viewer to qualify the url, not the
         *                               scene specified by the url descriptor; can be falsey when generating a
         *                               "raw embed url". This is also used to qualify log names in embedded Viewers.
         *
         * @returns {String} The embed URL for the for an iframe to eventually embed; never falsey.
         *
         * @see     #getUrlDescriptor
         */
        getEmbedURL: function getEmbedURL(descriptor, embedType, scene) {
            var url = void 0;

            // For embedded Experiences and Group, we manually construct the url to use on embedding, regardless of
            // what the user actually entered...
            if (descriptor.type !== "url") {
                // IMPORTANT:
                // To avoid cross domain issues in the Editor on preview/quickview, the Viewer always live on
                // c.zmags.com and the editor on creator.zmags.com. Trying to visit "creator.zmags.com/viewer.html?.."
                // will redirect to "c.zmags.com/viewer.html?..". The Viewer url is configured, and we must thus
                // always use its configured url, regardless what the user has entered for the embed url (descriptor).
                // So, all recursively nested Experiences will use the same configured domain, e.g. "c.zmags.com" in
                // prod, but we must still remember the client protocol and optional path (to the viewer, in branch
                // environment)...

                // Generate raw Viewer url, always ending with "/viewer.html" and using the client protocol, then
                // we add relevant query parameters and hash value, which we control...
                url = scope.getViewerUrl();

                if (embedType) {
                    url += "?" + embedType + "=" + descriptor.id + ":" + scene + "&zmagsLog=" + Logger.level();
                }

                url += "#";

                // Finally add (qualified) id...
                if (descriptor.type === "group") {
                    url += "group/";
                }
                url += descriptor.id;

                // Scene 1 is default, so do not bother with it...
                if (descriptor.scene !== 1) {
                    url += "/" + descriptor.scene;
                }

                // Note that "url" can be relative, effectively against the top most reachable window, i.e.
                // the client page when embedded via channels, or the viewer url when via a direct url...
            } else {
                url = descriptor.valid ? descriptor.url : "about:blank";
            }

            return url;
        },


        /**
         * Returns true if the specified urls have the same origin, false otherwise.
         *
         * @param   {String} a The first url to test; cannot be null/undefined.
         * @param   {String} b The second url to test; cannot be null/undefined.
         * @returns {Boolean} True if the same origin, false otherwise.
         */
        sameOrigin: function sameOrigin(a, b) {
            return scope.location(a).origin === scope.location(b).origin;
        },


        /**
         * Returns true if the specified urls have the same hostname, false otherwise.
         *
         * @param   {String} a The first url to test; cannot be null/undefined.
         * @param   {String} b The second url to test; cannot be null/undefined.
         * @returns {Boolean} True if the same Hostname, false otherwise.
         */
        sameHostname: function sameHostname(a, b) {
            return !!a && !!b && scope.location(a).hostname === scope.location(b).hostname;
        },


        /**
         * Prepends "http://" to the given URL, if it doesn't already contain a valid protocol prefix.
         *
         * @param {String}  url The url.
         * @param {Boolean} [forceHttps] should force to use https instead of http; optional.
         * @returns {String} The url, prepended with the protocol.
         */
        prependHTTP: function prependHTTP(url, forceHttps) {
            var HTTP_PREFIX = "http://";
            var HTTPS_PREFIX = "https://";
            var DOUBLE_SLASH_PREFIX = "//";
            var lowercaseUrl = url.toLowerCase();

            if (lowercaseUrl.indexOf(HTTP_PREFIX) !== 0 && lowercaseUrl.indexOf(HTTPS_PREFIX) !== 0 && lowercaseUrl.indexOf(DOUBLE_SLASH_PREFIX) !== 0) {
                return (forceHttps ? HTTPS_PREFIX : HTTP_PREFIX) + url;
            }

            return url;
        },


        /**
         * Prepends "http://" or the "https://" to the given URL, if it doesn't already contain a valid protocol prefix.
         * Prepended protocol depends on the current page protocol, for prevent mixed content.
         *
         * @param {String}  url The url.
         * @returns {String} The url, prepended with the protocol.
         */
        prependProtocol: function prependProtocol(url) {
            var HTTP_PREFIX = "http://";
            var HTTPS_PREFIX = "https://";
            var DOUBLE_SLASH_PREFIX = "//";
            var lowercaseUrl = url.toLowerCase();
            var currentProtocol = window.location.protocol;

            if (lowercaseUrl.indexOf(HTTP_PREFIX) !== 0 && lowercaseUrl.indexOf(HTTPS_PREFIX) !== 0) {
                if (lowercaseUrl.indexOf(DOUBLE_SLASH_PREFIX) === 0) {
                    return "" + currentProtocol + url;
                }
                return "" + currentProtocol + DOUBLE_SLASH_PREFIX + url;
            }

            return url;
        },


        /**
         * Returns a "mock" location object for the supplied url, defaulting to the current location of the top
         * most reachable window, or a specific property, e.g. "hostname", from said  mock location. <p>
         *
         * Note: if <tt>url</tt> does not have a protocol, i.e. http:, https:, or //, <tt>url</tt> will be treated
         * as a relative url to the top most reachable window location!
         *
         * @param   {String|*} [url]  The url to return the location object for; will default to the current location
         *                            of the top most reachable window.
         * @param   {String}   [part] The specific part requested, if any; can be null/undefined.
         *
         * @returns {{protocol:String, host:String, hostname:String, href:String, port:String, origin:String, pathname:String, last:String, hash:String, search:String, query:{}}|String}
         *          A "mock" location object describing <tt>url</tt>, or the part from it as specified by
         *          <tt>part</tt>.
         */
        location: function location(url, part) {
            var win = Window.topWindow();
            url = url || win.location.href;
            if (!_location) {
                _location = win.document.createElement("a");
            }

            // Will calculate fields for us, like "host", "pathname", etc...
            _location.href = url.href || url;

            // IE has trouble with // urls like this, and we cannot simply set the href of "window" or "document"... :/
            var protocol = _location.protocol || win.location.protocol;

            var parts = {
                protocol: protocol,
                host: _location.host,
                hostname: _location.hostname,
                href: _location.href, // correct in IE even when protocol agnostic!
                port: _location.port,
                origin: _location.origin || protocol + "//" + _location.host,
                pathname: _location.pathname, // never empty and always prefixed with "/"
                last: _location.pathname.split("/").pop(),
                hash: _location.hash,
                search: _location.search,
                query: {}
            };

            // Parse search part into query parameters when needed...
            if ((!part || part === "query") && parts.search) {
                var query = parts.search.substr(1).split("&"); // drop "?" before params
                var pair = void 0;
                var i = void 0;

                for (i = 0; i < query.length; i++) {
                    pair = query[i].split("=");
                    parts.query[pair[0]] = pair[1];
                }
            }

            return part ? parts[part] : parts;
        },


        /**
         * Appends a query parameter to the given url.
         *
         * @param {String} url The url to append a query parameter to.
         * @param {String} param The query parameter.
         * @returns {String} The url with a parameter appended.
         */
        appendParam: function appendParam(url, param) {
            var firstPart = void 0;
            var lastPart = void 0;

            if (url.indexOf("?") !== -1) {
                firstPart = url.split("?")[0];
                lastPart = url.split("?")[1];

                return firstPart + "?" + param + "&" + lastPart;
            } else if (url.indexOf("#") !== -1) {
                firstPart = url.split("#")[0];
                lastPart = url.split("#")[1];

                return firstPart + "?" + param + "#" + lastPart;
            }

            return url + "?" + param;
        },


        /**
         * Create a serialized representation of the specified object (or array) and
         * appends it to the specified URL, returning the new URL string.
         *
         * @param  {String} url         The base URL.
         * @param  {Object|Array} paramObject An array or object to serialize.
         * @return {String}             The new URL string.
         */
        appendParamObject: function appendParamObject(url, paramObject) {
            var paramString = $.param(paramObject);
            var delimiter = url.indexOf("?") !== -1 ? "&" : "?";

            return url + delimiter + paramString;
        },


        /**
         * Returns the absolute URL for a given path or URL.
         * An empty path ("") will return "".
         *
         * @param   {String} path The path or URL to get as an absolute URL.
         * @returns {String}      An absolute URL for the path.
         */
        getAbsoluteViewerApiUrl: function getAbsoluteViewerApiUrl(path) {
            if (this.isAbsoluteUrl(path) || path === "") {
                return path;
            }

            // Fix of closed LB images url to S3 source
            if (this.isImageUrl(path) && Configuration.branchImagesBaseUrl) {
                return Configuration.branchImagesBaseUrl + "/" + path;
            }

            return this.getStaticDomain(path) + "/" + path;
        },


        /**
         * Returns the (configured) protocol agnostic Viewer url, respecting an optional intermediate path, but
         * with out any query parameters or hash value. That is, the url will always end with "/viewer.html".
         *
         * @returns {String} (configured) protocol agnostic Viewer url; never falsey.
         */
        getViewerUrl: function getViewerUrl() {
            // This relies on the fact that config urls running on both http and https are defined as protocol
            // agnostic, e.g. starting with "//" and not, e.g. "http://". We know the "url.href" below does not
            // include query parameters or a hash value since constructed based on the path name...
            var url = Configuration.viewerBaseUrl;

            // This can still be called while in bridge mode in case the embedding via channels fails and in such
            // cases we want to be able to generate a useful viewer url...
            if (!channelBridge()) {
                url += window.location.pathname;
            }

            url = scope.location(url); // path name always starts with "/", even if empty otherwise

            // Can already point to the viewer in case of embedded Experiences...
            if (url.last === "viewer.html") {
                // viewer
                return url.href;

                // Editor...
            } else if (url.last === "index.html") {
                // editor
                url.href = url.href.substring(0, url.href.length - 10); // drop "index.html"
            }

            // Always append "viewer.html"; at this point, "url.href" will always end with a "/"...
            return url.href + "viewer.html";
        },
        _getAbsoluteContentUrl: function _getAbsoluteContentUrl(postfix) {
            var viewerUrl = scope.getViewerUrl() + "#" + postfix;
            var urlPrefix = viewerUrl.indexOf("http") >= 0 ? "" : "http:";

            return urlPrefix + viewerUrl;
        },


        /**
         * Returns the absolute URL for a given experience.
         *
         * @param   {String} experienceId The id of an experience.
         * @returns {String}              An absolute URL for the experience.
         */
        getAbsoluteExperienceUrl: function getAbsoluteExperienceUrl(experienceId) {
            return "" + {"env":"PROD","cncViewFullBaseUrl":"https://cnc-api.zmags.com/view/full/","cncViewLiteBaseUrl":"https://cnc-api.zmags.com/view/lite/","psdImportBaseUrl":"https://design-file-import.creator-prod.zmags.com","behaviorUiBaseUrl":"https://behaviors.zmags.com","creatorSettingApiBaseUrl":"https://creator-settings.api.zmags.com","c3ApibaseUrl":"https://contentcontrol.api.zmags.com","adminApiBaseUrl":"https://creator-api.zmags.com","editorBaseUrl":"//creator.zmags.com","viewerBaseUrl":"//c.zmags.com","viewerApiBaseUrl":"//c.zmags.com","cncStaticAssetsBaseUrl":"//c.zmags.com/static/","cncStaticAssetsFiles":["client.js","manifest.js","vendor.js","styles.css"],"cncSsrApiBaseUrl":"//c.zmags.com","viewerAliasApiBaseUrl":"//creator.zmags.com","communityBaseUrl":"https://creatorcommunity.zmags.com","errorQueueUrl":"https://c.zmags.com/queue/error/","statsDUrl":"https://statsd.zmags.com/stats","auth0Domain":"https://zmags.us.auth0.com","auth0Audience":"https://api.zmags.com/","auth0ClientId":"XGTeepJiX2c78VRgP8OFxN0Mf4kggvby","ometriaApiUrl":"https://ometria.api.zmags.com/v1/email/generate","klaviyoApiUrl":"https://klaviyo.api.zmags.com/v1/email/generate","sfmcApiUrl":"https://sfmc.api.zmags.com/v1/email/generate","cloudinaryProviderUrl":"https://images.creator-prod.zmags.com/image/upload","salesEmail":"sales@zmags.com","supportEmail":"support@zmags.com","editorSegmentIOKey":"20jbiv8frx","matomoConfig":{"trackingScriptUrl":"//c.z-analytics.net/reporting/optimize/ztracker.js","trackerUrl":"","dashboardUrl":"//auth.reporting.creator-prod.zmags.com","segmentUrl":"//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php","siteID":1},"zsitesConfig":"//auth.reporting.creator-prod.zmags.com/","zsitesSecret":"zM4gzS3cr3t","inventoryUrl":"https://authproxy.creator-prod.zmags.com/inventory/v1/products/map","answerFileUrl":"https://static.inventory.creator-prod.zmags.com/dynamic_pricing/answer_files/","experienceUrl2PngBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/experience/signed/url2png/","experienceSharedEntityBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/sharedEntity/","msExperiencesUrl":"https://authproxy.creator-prod.zmags.com/experiences","microserviceCompanyUrl":"https://authproxy.creator-prod.zmags.com/company/","proxyUrl":"https://authproxy.creator-prod.zmags.com","forgotPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","resetPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","changePasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithTokenBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithSsoBaseUrl":"https://authproxy.creator-prod.zmags.com","loginActiveDirectoryBaseUrl":"https://creator-api.zmags.com","googleWebFontsApiBaseUrl":"https://www.googleapis.com/webfonts/v1/webfonts","googleWebFontsApiKey":"AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI","casUrl":"https://cas.zma.gs/","contentControlUrl":"https://manage.creatorbyzmags.com/","enableLogging":1,"logId":null,"trackErrors":true,"sentryEnabled":true,"sentryDSN":"https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460","experienceId":null,"groupId":null,"scene":null,"statsDBucket":"creator.prod","version":"livadug4","maxRetries":3}.cncViewLiteBaseUrl + experienceId;
        },


        /**
         * Returns the absolute URL for a given group.
         *
         * @param   {String} groupId The id of a group.
         * @returns {String}         An absolute URL for the group.
         */
        getAbsoluteGroupUrl: function getAbsoluteGroupUrl(groupId) {
            return this._getAbsoluteContentUrl("group/" + groupId);
        },


        /**
         * Tests if the URL starts with "http" or "//".
         *
         * @param {String} url The URL to test.
         */
        isAbsoluteUrl: function isAbsoluteUrl(url) {
            return url.indexOf("http") === 0 || url.indexOf("//") === 0;
        },


        /**
         * Tests if the URL contains image path 'assets/images'
         *
         * @param {String} url The URL to test.
         */
        isImageUrl: function isImageUrl(url) {
            return url.indexOf("assets/images") > -1;
        },


        /**
         * Given a URL or path, returns the file name with extension or <tt>null</tt> if none.
         *
         * @param  {String} url URL or path pointing to a specific file.
         * @return {String}     The name with extension, if any. E.g. 'foo/image.jpg' will return 'image.jpg'.
         */
        getFileNameWithExtension: function getFileNameWithExtension(url) {
            if (!url) {
                return null;
            }
            return url.split("/").pop().replace(/[?|#].+/, "");
        },


        /**
         * Given a URL or path, returns the file extension or <tt>null</tt> if none.
         *
         * @param  {String} url URL or path pointing to a specific file.
         * @return {String}     The file extension, if any. E.g. 'foo/image.jpg' will return 'jpg'.
         */
        getFileExtension: function getFileExtension(url) {
            // Also remove query string if any
            var fileName = url.split("/").pop().replace(/[?|#].+/, "");
            // There may be multiple dots in the file name, we need to match the last dot
            var match = fileName.match(/\.(?=[^.]*$)([^?]+)/);

            return match ? match[1] : null;
        },


        /**
         * Get static domain for an asset.
         *
         * We have two static domains and we will distribute them evenly for assets. All the requested asset URLs
         * are stored in the URLs map. We use the total number of assets in the map to compute the oddness of current
         * assets, if odd return one domain, else return another.
         *
         * @param {String} url   The relative url of an asset
         */
        getStaticDomain: function getStaticDomain(url) {
            var domain = URLS[url];
            var isOdd = _.keys(URLS).length % 2;

            if (!domain) {
                domain = isOdd ? Configuration.viewerAliasApiBaseUrl : Configuration.viewerApiBaseUrl;
                URLS[url] = domain;
            }

            return domain;
        },


        /**
         * Safe concatenation of two or more pieces of url.<p>
         * e.g:
         *     concat('zmags.salesforcecommerce.com/','/dw/shop/v15_1/')
         *     concat('zmags.salesforcecommerce.com','/dw/shop/v15_1/')
         *     concat('zmags.salesforcecommerce.com/','dw/shop/v15_1/')
         *     concat('zmags.salesforcecommerce.com','dw/shop/','v15_1/')
         *
         * @returns {String}
         */
        concat: function concat() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var begin = "";
            var i = 0;
            var end = void 0;
            var slash = void 0;

            while (i < arguments.length) {
                begin += args[i++] || "";

                end = i < arguments.length ? args[i++] || "" : "";
                // if begin and end are defined
                slash = begin && end ? "/" : "";

                while (begin[begin.length - 1] === "/") {
                    begin = begin.substring(0, begin.length - 1);
                }

                while (end[0] === "/") {
                    end = end.substring(1);
                }

                begin = begin + slash + end;
            }

            return begin;
        }
    };

    return scope;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var Promise = __webpack_require__(21);

    var _require = __webpack_require__(764),
        openAdapted = _require.openAdapted,
        topWindowAdapted = _require.topWindowAdapted,
        visitAdapted = _require.visitAdapted,
        runAdapted = _require.runAdapted;

    // Window referenced wrapped in a jQuery element...


    var $win = $(window);

    // Global flag to turn on/off all window listeners added by "on", "until", "unload", or "error", set via
    // Win.active(active: boolean). Used to pause all "global" handlers while the Viewer is hidden on
    // for example an adjacent scene. This is really not the best way to do this, but the global state
    // is at the very core dependent of the ExperienceViewModel used in the ExperienceController, which
    // can be delegated from GroupController and what not, with no access to said model. So, instead
    // the ExperienceController will notify Window.active(..) when it changes from active to inactive or
    // vice versa, without intermediate controllers and what not requiring to handle this in numerous
    // places...
    var _active = true; // TODO: this should then be a general concept, no? E.g. also for window.document

    /**
     * @class Win
     * Window abstraction for hooking up events directly on window.
     */
    var Win = { // Explicit different from Browser, since used in both Viewer, Editor, And Channels Admin apps!
        // Naming to ensure we do not conflict native Window type here, might want to use it...

        /**
         * User agent for the current window.
         */
        userAgent: window.navigator.userAgent,

        /**
         * Visits all accessible parent windows in reverse order, optionally invoking the specified callback when
         * each such window is visited.
         *
         * @param {Function} [callback] Optional callback like <tt>fn(parent: Window, window: Window, error:Error): *</tt>
         *                              to be invoked for each accessible window, which will break the traversal if a
         *                              defined value is returned. If a non accessible window is encountered, the
         *                              parent argument will be null and the error will be supplied as the third
         *                              argument. Will always be invoked at least once (perhaps will null parent) if
         *                              supplied.
         *
         * @return {Window|*} The top most accessible window, or the first defined value returned by <tt>callback</tt>.
         */
        visit: function visit(callback) {
            return visitAdapted(callback);
        },


        /**
         * Returns a reference to the current window ("self").
         *
         * @return {Window} The current window; never falsey.
         */
        self: function self() {
            return window;
        },


        /**
         * Returns the parent window if present and accessible. Always use this function to get a reference to the
         * patent window, never do "window.parent" as it may not be accessible! <p>
         *
         * @return {Window} The parent window we have access to, if any; can be null if no parent or if the parent
         *                  is not accessible (e.g. on direct url).
         *
         * @see    #topWindow
         */
        parent: function parent() {
            return Win.visit(function (parent) {
                return parent;
            }); // will cause "visit" to break immediately
        },


        /**
         * Returns the top-most window currently accessible. Always use this function to get a reference to the
         * top most window, never do "window.top" as it may not be accessible! <p>
         *
         * This will not always be the top level window, for example when running DnD in framed mode in IE, but the
         * same can in principle be true for any client site.
         *
         * @param  {Boolean} [excludeSelf] True to return null if the top most accessible window is this window,
         *                                 false otherwise (default).
         * @return {Window} The top-most level window we have access to; never falsey, will default to this window.
         *
         * @see    #parent
         * @see    #run
         */
        topWindow: function topWindow(excludeSelf) {
            return topWindowAdapted(excludeSelf);
        },


        /**
         * Short-cut method to access the ViewerProxy for a Viewer instance in some specific Window, optionally
         * a ViewerProxy property, e.g. a function, which can also be invoked if found. <p>
         *
         * A call like <tt>Window.viewer("parent", "state")</tt> is equivalent to
         * <tt>Window.sandbox("viewer.state", Window.parent())</tt>; or <tt>Window.viewer("topWindow")</tt> to
         * <tt>Window.sandbox("viewer", Window.topWindow())</tt>; or <tt>Window.viewer()</tt> to
         * <tt>Window.sandbox("viewer", Window.self())</tt>. <p>
         *
         * To call said state method, if present, do something like
         * <tt>Window.viewer(win, "state", {name: "active": value: false})</tt>, which will return the result
         * of the invocation. If no such method to call is found, the call is simply a no-op. <p>
         *
         * Caveat 1: the top most window on a direct url will return the Viewer itself if called from there, while
         * the same call when embedded via channels will return null as the top window will there be the client
         * window doing the embedding via channels. <p>
         *
         * Caveat 2: the Viewer defined in the parent window may not be the logical parent of the Viewer defined
         * in the current window if the current Viewer is opened in a Lightbox. This is because Lightboxes live
         * in the top most window/dom, but logically such Viewers live in the iframe window used by the Lightbox.
         * That is, <tt>Window.viewer("parent")</tt> may <b>not</b> be the same as
         * <tt>Window.viewer("self", "parent")</tt> as the first will access <tt>window.parent.viewer</tt> and
         * the latter <tt>window.viewer.parent</tt>. <p>
         *
         * So - to find the top most reachable viewer in any scenario, from any ancestor window, do
         * <tt>Window.viewer().root()</tt>. <p>
         *
         * @param {String|*} [where]    A string like "self", "parent", or "topWindow" to describe any function
         *                              defined on this type to return a Window instance, or a scope as is; can
         *                              be undefined if no other arguments, resulting in the Viewer will be looked
         *                              up in the current window/iframe.
         * @param {String}   [property] Optional property path, supporting dot notation, to access some recursive
         *                              property in the Viewer (like a sandbox path); if not specified, the ViewerProxy
         *                              itself is merely returned.
         * @param  {*}       [varArgs]  Optional arguments to invoke the specified function via <tt>property</tt>,
         *                              returning its value in place of the ViewerProxy property.
         * @return {*} The ViewerProxy or the specified ViewerProxy property; can be falsey.
         */
        viewer: function viewer() {
            var where = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "self";
            var path = arguments[1];

            var p = "viewer";

            if (path) {
                p += "." + path;
            }
            // viewer() -> "self", but not otherwise...
            if (typeof where === "string") {
                // e.g. "self"
                where = Win[where]();
            } else if ("contentWindow" in where) {
                // iframe
                where = where.contentWindow;
            }
            var v = Win.sandbox(p, where); // e.g. a Window

            // We know ViewerProxy functions handle scoping well...

            for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
                args[_key - 2] = arguments[_key];
            }

            if (typeof v === "function" && args.length > 0) {
                return v.apply(undefined, _toConsumableArray(args));
            }

            return v;
        },


        /**
         * Computes the offset (top left coordinates) of the specified element, relative to the top most window/document.
         *
         * @param  {HTMLElement|jQuery} element The target element.
         * @return {Object} The offset, e.g. <tt>{top: 100, left: 100}</tt>.
         */
        offset: function offset(element) {
            var $element = element instanceof $ ? element : $(element);
            var offset = $element.offset();

            Win.visit(function (parent) {
                if (parent) {
                    // will be null if not accessible...
                    var frameOffset = $(parent.frameElement).offset();
                    if (frameOffset) {
                        offset.top += frameOffset.top;
                        offset.left += frameOffset.left;
                    }
                }
            });

            return offset;
        },


        /**
         * Runs the specified code in a given window. <p>
         *
         * <tt>options</tt> can be a string, the code to evaluate in the top most accessible window, or it can have
         * the following format for more control:
         * <pre>
         *    {
         *        code:    String,  // Mandatory code to run (eval) in <tt>options.win</tt>.
         *        win:     Window,  // Optional window to run the code in, defaulting to the top most accessible one.
         *        errback: Function // Optional errback handler to suppress errors; if not specified, errors will be thrown as is.
         *    }
         * </pre>
         *
         * @param {String|{code:String, win:Window, errback:Function}} options
         *        If a string, the code to run (eval) in the top most accessible window; otherwise a set of options as
         *        described above; cannot be falsey.
         *
         * @return {*} The result of the evaluation, if any; can be any value.
         *
         * @throws {Error} If the run (eval) raises an error and <tt>errback</tt> is not supplied to handle it.
         */
        run: function run(options) {
            return runAdapted(options);
        },


        /**
         * Returns a reference to the specified sandbox in client space under <tt>scope</tt> based on <tt>path</tt>,
         * where <tt>scope</tt> will default to the top most accessible window. If <tt>scope</tt> is already supplied,
         * it can be any type of object. If a cross domain Window, the sandbox will always be off limit and undefined
         * will be returned. The same is true if <tt>path</tt> at some point will reference a cross domain value. <p>
         *
         * This will <b>not</b> create any such sandbox, merely reference it and its properties (when accessible).
         * If you need to export something (to some global sandbox), this must be done explicitly elsewhere. <p>
         *
         * By convention, all properties/values under this scope are considered read-only.
         *
         * @param  {String|String[]} path    Mandatory path to access some property or the sandbox itself under <tt>scope</tt>;
         *                                   cannot be falsey, and supports dot notation. If an array, each path in it will
         *                                   be looked up and the first one returning a defined value will be used.
         * @param  {Window|*}        [scope] The scope to access the sandbox in, defaulting to the top most accessible window
         *                                   scope on undefined, but not on null (on null, undefined will always be returned).
         *                                   Can be any object type.
         *
         * @return {*} The specified sandbox/property; can be any value.
         */
        sandbox: function sandbox(path, scope) {
            var paths = typeof path === "string" ? [path] : path;
            var parts = void 0;
            var o = void 0;
            var i = void 0;
            var j = void 0;

            // "scope" can be null, for example if the scope is acquired via this function by an earlier call, which
            // will result in undefined being returned by this function. We differentiate between null and undefined
            // to allow a sensible default (top window) when no scope is supplied...
            if (typeof scope === "undefined") {
                scope = Win.topWindow(); // will be accessible!
            }

            // eslint-disable-next-line eqeqeq
            if (scope != null) {
                // Look up specific path, e.g. "window.__zmags.lightbox"?
                loop: for (i = 0; i < paths.length; i++) {
                    // Reset to original scope for each path to traverse...
                    o = scope;
                    parts = paths[i].split(".");
                    for (j = 0; j < parts.length; j++) {
                        try {
                            o = o[parts[j]];
                        } catch (e) {
                            // e.g. Security Error, TypeError (non-readable property)
                            o = null;
                            // Fall-through
                        }
                        // eslint-disable-next-line eqeqeq
                        if (o == null) {
                            continue loop;
                        }
                    }
                    return o;
                }
            }

            // undefined
        },


        /**
         * Returns a Promise that will resolve once the specified sandbox in client space under <tt>scope</tt> based
         * on <tt>path</tt> is defined and not null, where <tt>scope</tt> will default to the top most accessible
         * window. The resolved value is the sandbox value (never null, nor undefined), but the returned promise
         * may be rejected after <tt>timeout</tt> milliseconds if the sandbox value is not accessible, not defined,
         * and not null by then. <p>
         *
         * If <tt>scope</tt> is already supplied as a cross domain Window, the sandbox will always be off limit and
         * the promise will be rejected after the specified timeout always. The same is true if <tt>path</tt> at some point reference a cross domain value. <p>
         *
         * This will <b>not</b> create any such sandbox, merely reference it and its properties (when accessible).
         * If you need to export something (to some global sandbox), this must be done explicitly elsewhere. <p>
         *
         * By convention, all properties/values under this scope are considered read-only.
         *
         * @param  {String|String[]} path      Mandatory path to access some property or the sandbox itself under <tt>scope</tt>;
         *                                     cannot be falsey, and supports dot notation. If an array, each path in it will
         *                                     be looked up and the first one returning a defined value will be used.
         * @param  {Window|*}        [scope]   The scope to access the sandbox in, defaulting to the top most accessible window
         *                                     scope on undefined, but not on null (on null, undefined will always be returned).
         *                                     Can be any object (non-primitive) type.
         * @param  {Number}          [timeout] The timeout in milliseconds to poll for the sandbox before giving up; will default
         *                                     to 5 seconds. Can be supplied as the second argument as well if the top most
         *                                     accessible window is the scope.
         *
         * @return {Promise} A Promise that will resolve with the specified sandbox/property, which can be any value, or that
         *                   will be rejected after <tt>timeout</tt> ms. The promise may already have been resolved upon
         *                   return, i.e. if the sandbox is already available at call time.
         * @see    #sandbox
         */
        sandboxPromise: function sandboxPromise(path, scope, timeout) {
            if (typeof scope === "number") {
                timeout = scope;
                scope = undefined; // will default to top most window
            }
            var deferred = Promise.deferred();
            var promise = deferred.promise();
            var timer = void 0;
            var start = void 0;

            var clearTimer = function clearTimer() {
                if (timer) {
                    window.clearTimeout(timer);
                    timer = null;
                }
            };

            var poll = function poll() {
                var result = Win.sandbox(path, scope);
                // eslint-disable-next-line eqeqeq
                if (result != null) {
                    clearTimer();
                    deferred.resolve(result);
                    return false;
                }

                return true; // keep polling
            };

            // Do an initial poll before firing up a polling interval...
            if (poll()) {
                timeout = timeout || 5000; // 5s
                start = Date.now();

                timer = window.setInterval(function () {
                    // "poll" will resolve and clear timer on success, we only need to reject on timeout...
                    if (poll() && Date.now() - start > timeout) {
                        clearTimer();
                        deferred.reject();
                    }
                }, 200);
            }

            return promise;
        },


        /**
         * Specifies whether or not all "on", "until", "unload", and "error" listeners are active or inactive,
         * default active. This will not remove/add any listeners, merely activate/deactivate listeners
         * already defined. <p>
         *
         * This can be used to temporarily turn off window events while this Viewer does not have
         * focus, e.g. hidden on some adjacent scene current not shown.
         *
         * @param {Boolean} [active] True to activate, falsey to deactivate. If not specified, the current
         *                           active state is returned.
         * @return {Boolean} True if now active, false if inactive.
         *
         * @see    #on
         * @see    #until
         * @see    #unload
         * @see    #error
         */
        active: function active(_active2) {
            if (arguments.length) {
                _active = _active2;
            }
            return _active;
        },


        /**
         * Open a new window via the top most reachable window, either in the same window or a new window/tab,
         * ensuring a short delay before opening in the same window so stats and/or pending http requests have
         * a chance of completing if the new window/location will replace the current (client) page. <p>
         *
         * Do <b>not</b> use <tt>window.open(..)</tt> or set <tt>window.location</tt> directly, always use this
         * function! <p>
         *
         * Caveat: opening a window via <tt>setTimeout</tt> is subject to pop-up blockers, but this is the only
         * way we can ensure pending requests have a change of completing when updating the location of the
         * current (top-most) window.
         *
         * @param {String} url      The url to open; cannot be falsey.
         * @param {String} [target] The window target/name; will default to "_blank", i.e. new window.
         * @param {String} [specs]  Optional window specs for new windows only; can be falsey.
         *
         * @return {Window} A reference to the JS Window type opened, or null if the opening failed. It will expose
         *                  a <tt>close()</tt> function as per spec.
         */
        open: function open(url, target, specs) {
            return openAdapted(url, target, specs);
        },


        /**
         * Subscribes the supplied callback to the given event(s) for the specified window, either based on a
         * set of options or via event name and associated callback (and window). <p>
         *
         * The options can take the following form:
         * <pre>
         *   {
         *      event:     String,             // space-separated list of event names to listen for on the window in question.
         *      callback:  Function,           // the function to invoke on the specified events.
         *      scope:     *,                  // optional scope for <tt>callback</tt>, defaulting to the function itself.
         *      win:       Window,             // optional window to listen to, defaulting to the current window.
         *      predicate: Function():Boolean, // optional predicate to suppress event callbacks when the predicate
         *                                     // returns false, e.g. to temporarily disable <tt>callback</tt> without
         *                                     // removing it. Will only be called while <tt>Window.active()</tt>
         *                                     // returns true!
         *      throttle:  Number,             // optional throttle delay in ms to wrap <tt>callback</tt> in. Can be combined
         *                                     // with <tt>debounce</tt>.
         *      debounce:  Number,             // optional debounce delay in ms to wrap <tt>callback</tt> in. Can be combined
         *                                     // with <tt>throttle</tt>.
         *   }
         * </pre>
         *
         * Alternatively, this is also legal:
         * <pre>
         *      Window.on("event1 event2 ..", callback, win); // "win" optional, default current window
         * </pre>
         *
         * @param  {String|*} options    If a single argument, the options to use; otherwise the event name(s) as a
         *                               space separated string, requiring <tt>callback</tt> and optionally <tt>win</tt>
         *                               to be specified as well.
         * @param  {Function} [callback] The callback function to be invoked continuously for the specified event(s)
         *                               if <tt>options</tt> is a string; cannot be null if so.
         * @param  {Window}   [win]      The window in question of <tt>options</tt> is a string, defaulting to the
         *                               current one; can be falsey.
         *
         * @return {{off:Function, win:jQuery, callback:Function}} An object storing the actual <tt>callback</tt>
         *         and an <tt>off()</tt> function to remove the callback again; never falsey. For convenience, the
         *         window used is stored under <tt>win</tt> in a jQuery wrapper.
         */
        on: function on(options) {
            // event, callback, win) {
            if (typeof options === "string") {
                options = { event: options, callback: arguments.length <= 1 ? undefined : arguments[1], win: arguments.length <= 2 ? undefined : arguments[2] }; // e.g. Window.on("foo", fn, win) allowed
            }
            var $w = options.win ? $(options.win) : $win;
            var fn = options.callback;
            var scope = options.scope || fn;
            var predicate = options.predicate;

            var event = options.event; // can be more than one
            var listener = null;

            // Predicate is used to temporarily turn of an event, e.g. when this Viewer is hidden on some
            // adjacent scene, but can never override make an inactive Viewer become active...
            var callback = function callback() {
                if ($win[0].closed || $w[0].closed) {
                    // remember to off leaked listeners!
                    listener.off();
                } else if (_active && event && (!predicate || predicate())) {
                    for (var _len2 = arguments.length, cbArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        cbArgs[_key2] = arguments[_key2];
                    }

                    fn.apply(scope, cbArgs);
                }
            };

            if (typeof options.throttle === "number") {
                callback = _.throttle(callback, options.throttle);
            }
            if (typeof options.debounce === "number") {
                callback = _.debounce(callback, options.debounce);
            }

            $w.on(event, callback);

            listener = {
                off: function off() {
                    if (event) {
                        $w.off(event, callback);
                        event = null; // ensure off for good, also "callback" reference below
                    }
                },

                win: $w,
                callback: callback,
                toString: function toString() {
                    return event ? "off" : event;
                }
            };

            return listener;
        },


        /**
         * Subscribes the supplied callback for the specified event(s) for the specified window, firing on events
         * until <tt>callback</tt> returns a defined truthy value. This means that unlike jQuery.one, the callback
         * will be notified until it says it is done by returning a defined truthy value. <p>
         *
         * It can either be based on a set of options or via event name and associated callback (and window). <p>
         *
         * The options can take the following form:
         * <pre>
         *   {
         *      event:    String,             // space-separated list of event names to listen for on the window in question.
         *      callback: Function: Boolean,  // the function to invoke on the specified events, which will be removed
         *                                    // again once a defined value is returned.
         *      scope:    *,                  // optional scope for <tt>callback</tt>, defaulting to the function itself.
         *      win:      Window,             // optional window to listen to, defaulting to the current window.
         *      throttle: Number,             // optional throttle delay in ms to wrap <tt>callback</tt> in. Can be combined
         *                                    // with <tt>debounce</tt>.
         *      debounce: Number,             // optional debounce delay in ms to wrap <tt>callback</tt> in. Can be combined
         *                                    // with <tt>throttle</tt>.
         *   }
         * </pre>
         *
         * Alternatively, this is also legal:
         * <pre>
         *      Window.until("event1 event2 ..", callback, win); // "win" optional, default current window
         * </pre>
         *
         * @param  {String|*} options    If a single argument, the options to use; otherwise the event name(s) as a
         *                               space separated string, requiring <tt>callback</tt> and optionally <tt>win</tt>
         *                               to be specified as well.
         * @param  {Function} [callback] The callback function to be invoked on the specified event(s) until specified
         *                               if <tt>options</tt> is a string; cannot be null if so. Once this callback returns
         *                               a defined truthy value, it will be removed automatically (if not already
         *                               removed by calling <tt>off()</tt> on the return value.
         * @param  {Window}   [win]      The window in question of <tt>options</tt> is a string, defaulting to the
         *                               current one; can be falsey.
         *
         *
         * @return {{off:Function, callback:Function}} An object storing <tt>callback</tt> and an <tt>off()</tt>
         *         function to remove the callback again.
         */
        until: function until(options) {
            if (typeof options === "string") {
                options = { event: options, callback: arguments.length <= 1 ? undefined : arguments[1], win: arguments.length <= 2 ? undefined : arguments[2] }; // e.g. Window.on("foo", fn, win) allowed
            }
            var listener = void 0;
            var callback = options.callback;

            options.callback = function () {
                for (var _len3 = arguments.length, cbArgs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    cbArgs[_key3] = arguments[_key3];
                }

                // "callback" will already have been bound to proper scope if specified, so we simply default to the
                // callback it self...
                if (callback.apply(options.scope || callback, cbArgs)) {
                    listener.off();
                }
            };
            listener = Win.on(options);

            return listener;
        },


        /**
         * Subscribes the supplied callback to the <tt>window.onerror</tt> for the specified window.
         *
         * <tt>callback</tt> with be notified with two argument: the first, "resolved", contains a resolved
         * error and message, like <tt>{error:Error, message:String}</tt>, while the second, "event", contains
         * the original jQuery event. To check for the specific error, use "resolved"!
         *
         * @param {Function} callback The listener/callback function to be invoked when a
         *                            runtime error occurs; cannot be null.
         * @param {Window}   [win]    The window in question, defaulting to the current one; can be falsey.
         *
         * @return {{off:Function, callback:Function}} An object storing <tt>callback</tt> and an <tt>off()</tt>
         *         function to remove the callback again.
         */
        error: function error(callback, win) {
            return Win.on("error", function (event) {
                // The originalEvent does not seem to set on mobile devices either, so we have to check for that
                // as well, and create if need be. We have to deduce error and message since jQuery seems to ignore
                // error messages for legacy IE browsers, supplied as arguments to the onerror event handler or set
                // on window.event.errorMessage...
                var original = event.originalEvent || {};
                var message = original.message || window.event && window.event.errorMessage || "Unknown error";
                var error = original.error || new Error(message); // "error" will be set in legacy IE
                var resolved = { error: error, message: message };

                // jQuery event, so we can augment it...
                event.resolved = resolved;

                // Call!...
                return callback(resolved, event);
            }, win);
        },


        /**
         * Subscribes the supplied callback to be notified before unload of the specified window.
         *
         * @param {Function} callback The callback function to be invoked before unload; ignored if not
         *                            a function.
         * @param {Window}   [win]    The window in question, defaulting to the current one; can be falsey.
         *
         * @return {{off:Function, callback:Function}} An object storing <tt>callback</tt> and an <tt>off()</tt>
         *         function to remove the callback again.
         */
        unload: function unload(callback, win) {
            return Win.until("beforeunload", callback, win);
        }
    };

    // Add handler to log unhandled errors; we have do to it like this, or we will log the unhandled error for
    // each active error handler.
    //
    // NOTE: this will (may) also log third party errors by the viewer, which may look like the error originated
    //       at the viewer - since catched/logged here - which is in fact not the case for such third party
    //       unhandled errors...
    Win.error(function (resolved) {
        // TODO: should we only log in the editor instead, and not in the viewer?
        // Akin to unhandled exceptions being logged as errors by Events.js. Note that
        // console.error may not be a function!
        /* eslint-disable no-console */
        if (typeof console !== "undefined" && typeof console.error !== "undefined") {
            // No prefix, should mimic unhandled errors when logged by the browser by default...
            console.error("Uncaught " + (resolved.error.stack || resolved.error));
            // So other listeners can see if this message has been logged...
            resolved.logged = true;
        }
        /* eslint-enable no-console */
    });

    return Win;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["e"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator.throw(value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Class = __webpack_require__(26);
    var HttpStatusCodes = __webpack_require__(189);
    var Promise = __webpack_require__(21);
    var Permissions = __webpack_require__(22);
    var ErrorHandler = __webpack_require__(119);
    var LoggedIn = __webpack_require__(31);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var log = new Logger("Syncer");

    /**
     * @type {String}
     * Value rejected by any promise returned by <tt>invoke(..)</tt> for this syncer if the sync request
     * was cancelled for whatever reason, e.g. manually or because of timeout.
     */
    var CANCELLED = "cancelled";

    /**
     * @class {State}
     * Enum of all sync states. <p>
     *
     * Publicly exposed as <tt>Syncer.State</tt>.
     */
    var State = {
        Unsynced: "unsynced",
        Pending: "pending",
        Syncing: "syncing",
        Synced: "synced",
        Failed: "failed",
        Cancel: "cancel",

        /**
         * Returns true if the current sync state of the specified target is complete, i.e. not syncing or pending.
         *
         * @param {*} target The target to test; cannot be falsey.
         * @return {Boolean} True if complete, false otherwise.
         */
        complete: function complete(target) {
            var state = State.current(target);
            return state !== State.Syncing && state !== State.Pending;
        },


        /**
         * Any synced target will have an augmented <tt>syncState</tt> property via this function, storing the state
         * for the <tt>current</tt> sync state (i.e. what is going on now during an active (pending) sync), and an
         * <tt>actual</tt> state (i.e. what was the last completed sync state). This is why targets must always be a
         * mutable object so we can assign said <tt>syncState</tt> property. <p>
         *
         * This function is invoked for any target tried synced, thus creating a <tt>syncState</tt> property for
         * the target, if not already. <p>
         *
         * The <tt>syncState</tt> object has the following format:
         * <pre>
         *   {
         *      actual: {             // actual completed target sync state
         *          state:  State,    // actual sync state for the target (typically State.Synced or State.Failed)
         *          method: String,   // actual sync method, e.g. "save"
         *          error:  *         // actual (first) error on State.Failed
         *      },
         *      current: {            // current target sync state (i.e. while ongoing sync)
         *           state:  State,   // current sync state, any constant from State
         *           method: String,  // sync method, e.g. "save"
         *           error:  *        // current error on State.Failed
         *      },
         *      immutable: Boolean,   // whether or not the target is immutable (default no); if so, all mutable requests will be dropped
         *      unique: Function|[],  // a function to return array of globally unique ids for the synced target,
         *                            // or an array of such unique properties on target; will default to
         *                            // target *instance* itself.
         *      alias:  {},           // user-friendly aliases map for better notifications, e.g. "save" -> "share" for Share models
         *      time:   Date.now(),   // latest sync time, for stats
         *      synced: [
         *          {
         *              method: String, // successful sync method
         *              time:   Number  // successful time of sync
         *          },
         *          ..
         *      ],
         *      failed: [
         *          {
         *              method: String,  // failed sync method
         *              time:   Number,  // time of failed sync
         *              id:     String   // notification id, if any, of the notification shown because of the failure,
         *                               // to be discarded on next actual successful success.
         *          },
         *           ..
         *      ]
         *   }
         * </pre>
         *
         * For both <tt>actual</tt> and <tt>current</tt>, each individual sync state can be:
         * <ul>
         * <li> <tt>State.Unsynced</tt> ("unsynced"): Initial state, not synced yet.
         * <li> <tt>State.Pending</tt> ("pending"):   Changes detected, but syncing is debounced a bit to check if more
         *                                            changes are coming before actually invoking the sync; used to avoid
         *                                            flooding the server with sync request for each small change.
         * <li> <tt>State.Syncing</tt> ("syncing"):   While a sync request (e.g. to the backend) is ongoing, e.g. request
         *                                            submitted for "save" or "destroy", but no response yet.
         * <li> <tt>State.Synced</tt> ("synced"):     deferred (request) succeeded, e.g. successful save.
         * <li> <tt>State.Failed</tt> ("failed"):     Syncing failed, e.g. because of a http error or some JS (uncaught)
         *                                            error.
         * </ul>
         *
         * In addition, <tt>current</tt> can have a state of <tt>State.Cancel</tt> ("cancel") if the a cancel is made
         * while a sync request was not actually syncing (yet). Cancellation thus only makes sense for pending
         * sync requests. <p>
         *
         * The <tt>actual</tt> state will be updated once the <tt>current</tt> state changes, but only where relevant.
         * For example, <tt>actual</tt> will not be set to "syncing" during save if it already has a state of "synced"
         * or "failed", in order to track the actual state even while a save is ongoing. Also, the first actual
         * <tt>error</tt> encountered will never be overridden until a save succeeds (and perhaps a later one
         * fails again). <p>
         *
         * For both <tt>active</tt> and <tt>current</tt>, <tt>method</tt> is the logical type of syncing performed,
         * defaulting to "save". Can be "fetch", "save", and "destroy", but is also used by sub-classes for additional
         * sync types, such as "push" for <tt>ExperienceModel</tt> that is also known to update/save the model. <p>
         *
         * During syncing, the <tt>sync:state</tt> event will be triggered accordingly, e.g. <tt>sync:state</tt>
         * will be triggered multiple times during a save. During these events, listeners can check the state of the
         * model in question via <tt>model.syncState.current<p>, or by the supplied listener arguments
         * (state, method, error), in that order. <p>
         *
         * Backbones <tt>sync</tt> event is raised <b>after</b> <tt>sync:state</tt> "synced".
         *
         * The <tt>syncState</tt> is considered read-only, only updated by the sync manager.
         *
         * @param {*}  target   The target to initialise with the sync state; cannot be falsey.
         * @param {*} [options] Optional options to register, e.g. <tt>{alias: {destroy: "delete"}}</tt>.
         *
         * @return {*} The sync state (not target); never falsey.
         */
        init: function init(target, options) {
            var syncState = target.syncState;
            // Initialise sync state for the target instance if first time synced (at all)...
            if (!syncState) {
                syncState = {
                    actual: {
                        state: State.Unsynced,
                        method: "",
                        error: null
                    },
                    current: {
                        state: State.Unsynced,
                        method: "",
                        error: null
                    },
                    immutable: false,
                    unique: [],
                    alias: {}, // user-friendly aliases for better notifications
                    time: Date.now() // stats
                };
            }

            if (options) {
                _.extend(syncState, options); // we assume we play nice...
            }

            // Stats; we only ever initialise error array on first error since only for stats...
            if (!syncState.synced) {
                syncState.synced = [];
            }

            target.syncState = syncState;

            return syncState;
        },


        /**
         * Returns the <tt>syncState</tt> object for the supplied target, creating it if need be (and not the
         * specific current state).
         *
         * @param {*} target The target to get the sync state object for; cannot be falsey.
         * @return {*} The sync state object for <tt>target</tt>; never falsey.
         */
        state: function state(target) {
            if (!target.syncState) {
                State.init(target);
            }
            return target.syncState;
        },


        /**
         * Returns the current state of the supplied target.
         *
         * @param {*} target The target to get the current sync state for; cannot be falsey.
         * @return {State} The current sync state for <tt>target</tt>, defaulting to <tt>State.Unsynced</tt> if
         *                 no sync state is found for <tt>target</tt>.
         */
        current: function current(target) {
            return State.state(target).current.state;
        }
    };

    /**
     * @class {Syncer}
     * A <i>syncer</i> performs the actual sync with some (backend) endpoint for a given target in a defacto
     * sequential manner as it is used by a target queue, which guarantees just that per target instance. It
     * also ensures that any sync method will timeout after a configured time if not already completed. <p>
     *
     * The syncing is performed via deferreds, typically - but not required to - connecting to some backend
     * endpoint to de some remote work described by, and perhaps to be reflected in, the given target. <p>
     *
     * Any target synced by a syncer will be augmented with a <tt>syncState</tt> property that stores the
     * sync state for that specific target. It will be assigned automatically when first synced, or manually
     * via <tt>State.init(target)</tt>. When the sync state changes for the target, the
     * "sync:" + method + ":" + state event will be triggered for the target, if and only if the target
     * supports a <tt>trigger</tt> method, like models or views.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     *
     * @see    State#init
     * @see    TargetQueue
     */
    return Class.extend("Syncer", {

        /**
         * @type {SyncManager}
         * The sync manager that created this syncer; never falsey.
         */
        manager: null,
        /**
         * @type {*}
         * The target being synced; never falsey.
         */
        target: null,
        /**
         * @private @type {Number}
         * The timeout in ms for sync requests.
         */
        _timeout: null,
        /**
         * @protected @type {Number}
         * Nested invocation count, e.g. if a (de-)queued requests queues another request. Used to avoid
         * deadlocks in such situations.
         */
        _nested: null,

        /**
         * @constructor
         * Constructor, which creates this syncer.
         *
         * @param {SyncManager} manager   The sync manager that uses this syncer; never falsey.
         * @param {*}           target    The target to sync; never falsey.
         * @param {Number}      [timeout] The timeout for sync requests, defaults to 60s.
         */
        constructor: function constructor(manager, target, timeout) {
            this.manager = manager;
            this.target = target;
            this._timeout = timeout || 60000; // 60s
            this._nested = 0;

            // Make sure we have a "syncState" property, if not already, on the (to be) synced target...
            State.state(this.target);
        },


        /**
         * Returns the <tt>syncState</tt> object for the target synced by this syncer.
         *
         * @return {State} The sync state object for the target synced by this syncer; never falsey.
         * @see    State#state
         */
        syncState: function syncState() {
            return this.target.syncState;
        },


        /**
         * Returns the current globally unique target identifiers for the target synced by this syncer.
         *
         * @return {[]} The current globally unique target identifiers; never falsey, and will always contain
         *              at the least the synced target.
         * @see    SyncManager#targetIdentifiers
         */
        targetIdentifiers: function targetIdentifiers() {
            return this.manager.targetIdentifiers(this.target);
        },


        /**
         * @protected
         * Tags the target as having the specified sync request as pending, to be executed (or cancelled) sometime in
         * the near future. If such a sync method is already in progress, the state is not changed, i.e. we do not
         * go from "save:syncing" (or any other sync method for that matter) to "save:pending" without the current sync
         * to complete first. <p>
         *
         * The actual sync request will already have been queued in the proper queue, blocking it until the pending
         * delay is reached. <p>
         *
         * Do not call, used by <tt>TargetQueue</tt> to signal pending requests via this syncer.
         *
         * @param {*} request The pending request for sync method, e.g. for a pending "save".
         *
         * @see   #cancel
         * @see   #invoke
         */
        _pending: function _pending(request) {
            if (State.complete(this.target)) {
                this._state(request, State.Pending, false); // will not re-trigger pending
            } else {
                log.info("Ignoring pending state, sync in progress: " + request + " -> " + this, this);
            }
        },


        /**
         * @private
         * Validates the supplied request before invoking the actual sync request, returning the error to reject
         * the sync request with, or a falsey value (null) to indicate no error.
         *
         * Returning <tt>State.Cancel</tt> will cancel the request before an actual sync is performed, akin to
         * a cancellation having been made for the request after queue time. <p>
         *
         * A principal must be logged in, or the request will be cancelled. In addition, if a privilege or role
         * has been specified for the request, the principal will be validated against it, returning 403 if
         * insufficient privileges.
         *
         * @param {*}  request The sync request to validate; never null.
         * @return {*} The validation error as any non-null value, <tt>State.Cancel</tt> for cancellation,
         *             including if no logged in principal, or null for no error.
         */
        _validate: function _validate(request) {
            // Make sure the logged in principal has access to the sync method in question if a permission has
            // be specified on the method object. A principal must always be present, e.g. we will drop all
            // sync requests after the principal has logged out, for example...
            var error = null; // null = no error!
            var principal = LoggedIn.principal();
            var permission = Permissions.Privileges.of(request.privilege) || Permissions.Roles.of(request.role);

            // Cancel, since no principal (e.g. on log out)...
            if (!principal) {
                return State.Cancel;
            } else if (permission && permission.cannot(principal)) {
                error = HttpStatusCodes.FORBIDDEN; // permission denied!
            } else if (request.validate) {
                try {
                    error = request.validate.call(this.target);
                    if (typeof error === "undefined") {
                        error = null; // no error!
                    }
                } catch (e) {
                    error = e;
                }
            }
            // Log error here for clarity...
            if (error !== null) {
                log.error("Validation error for: " + request + " -> " + error, request, error);
                // On http, we assume invalid submitted data since the validation failed...
                if (_.isString(error) && request.http) {
                    error = HttpStatusCodes.BAD_REQUEST; // bad request
                }
            }
            return error;
        },


        /**
         * Creates a new deferred for the supplied request. <p>
         *
         * A factory method like this is needed to ensure we can cancel (reject) a queued request that has not been
         * invoked, which must trigger target sync state correctly.
         *
         * @param {*} request The sync request about to be enqueued, to be invoked at a later time; never falsey.
         * @return {$.Deferred} The deferred to handle the invocation of <tt>request</tt>; never null.
         */
        _deferred: function _deferred(request) {
            var _this = this;

            return Promise.deferred()
            // Synced handler...
            .done(function () {
                _this._state(request, State.Synced);
            })

            // Fail/Cancelled handler...
            .fail(function () {
                // For http requests, the first argument is the xhr request with its "status" property used
                // to deduce the error; otherwise the first argument is assumed to be the error. However,
                // if deferreds are "manually rejected" for xhr requests, like in the font loader if linked
                // fonts are not supported, we might not even get an xhr request as we would otherwise do
                // had the actual (http) request failed. In lack of a better status code, we use 501 - Not
                // Implemented...
                var error = (arguments.length <= 0 ? undefined : arguments[0]) || (request.http ? { status: 501 } : {});
                var state = State.Failed;
                var silent = false;

                if (error === CANCELLED) {
                    state = State.Cancel;
                    silent = arguments.length <= 1 ? undefined : arguments[1];
                    error = null; // cancelled is not an error as such
                }

                // On error, "syncState.current.error" will be set to the current error...
                _this._state(request, state, silent, error); // "error" ignored on "cancel", i.e. CANCELLED

                // Do we have an undo handler...?
                if (request.undoHandler) {
                    // Actual error...
                    error = _this.syncState.current.error;
                    try {
                        request.undoHandler(error, request);
                        log.info("Undo handler called for: " + request, request);
                    } catch (e) {
                        log.error("Undo handler failed: " + request + " -> " + error, request, error);
                        // Fall-through...
                    }
                }
            });
        },


        /**
         * Invokes the specified sync request on the target handled by this syncer, notifying the deferred associated
         * with request on completion (success or failure).
         *
         * @param  {*}       request The sync request to invoke (created via <tt>queue.request(..)</tt>); never falsey.
         * @return {Promise} The internal promise used by this syncer, <b>not</b> a publicly exposed one (which can
         *                   be obtained via <tt>request.promise()</tt>. One nested enqueuing, the returned promise
         *                   will reveal its queue via the <tt>queue</tt> property.
         *
         * @throws Error If the target synced does not have a complete sync state when this function is invoked, e.g.
         *               if a sync is already in progress.
         *
         * @see    #pending
         * @see    #cancel
         */
        invoke: function invoke(request) {
            var deferred = request.deferred(); // deferred used publicly to hand out promises
            var target = this.target;
            var promise = null; // sync method promise, *not* a promise from "deferred"!
            var error = this._validate(request); // make sure request is valid!

            // Have we been cancelled while we were pending, either explicitly or because the validation returns
            // State.Cancel? This can be the case on debounced save or because the affect of syncing is no
            // longer needed, or in case of logout, for example...
            if (error === State.Cancel || State.current(target) === State.Cancel) {
                error = CANCELLED;
            }

            // Signal that we are now syncing for "target"....
            if (error === null) {
                // Sync method promise, not the promise given by this syncer. That is, this promise typically
                // describes some http(s) call...
                try {
                    if (!this._nested++) {
                        this._state(request, State.Syncing);
                    }

                    // On nested queuing, the return value is a promise, tagged with the (this) queue in
                    // the "queue" property, i.e. "promise.queue". On such cases, we cannot simply resolve our
                    // request/deferred to allow the nested sync request to be dequeued as that would trigger
                    // context listeners about the top level requests is finished, while its actual sync method
                    // is actually still pending (i.e. the nested sync request). This is why we have to handle
                    // this on nested enqueue time (where we simply share the top level deferred)...
                    promise = request.invoke();

                    // On error, we (may not) have a promise either, so we also create one there...
                } catch (e) {
                    error = e;
                    log.error("Sync method raised error: " + request, target, e);
                    // Fall-through!
                } finally {
                    this._nested--;
                }
            }

            // In certain cases, Backbone will never do a server round trip, such as when deleting/destroying an
            // unsaved model. If so, Backbone sync methods do not return promises, but the boolean value false.
            // Other user defined sync methods may also return non-promise values. If so, we create an already
            // resolved/rejected promise to use here, which will trigger the corresponding sync state immediately...
            if (!Promise.isPromise(promise)) {
                promise = error !== null ? Promise.rejected(error) : Promise.resolved(promise || target); // "promise" is return value from "request.invoke(..)" here
            }

            // We only need to handle timeout if the sync request promise is still pending, e.g.
            // doing a asynchronous http request. On timeout, "deferred" will be rejected, and its fail handler
            // called (set up in "_deferred(request)" function before this function was called)...
            if (Promise.isPending(promise)) {
                Promise.time(deferred, promise, this._timeout, HttpStatusCodes.REQUEST_TIMEOUT);
            } else {
                log.verbose("Promise already", error ? "rejected" : "resolved", "for: " + request, promise, this);
            }

            // Make sure the backing deferred is resolved once the sync request promise is complete and that we
            // single property sync:state events. Note these callbacks can arrive after we have resolved "deferred",
            // e.g. on timeout. If "promise" is not a cancelable promise, the work done in its "done/fail/always"
            // handlers will still be called, which may trigger strange side effects based, like cascading updates and
            // events fired. However, "deferred" will have completed in such cases, and it will not be resolved again,
            // i.e. the "deferred.done/fail" set above will not be triggered...
            return promise.done(function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                var applyArgs = args;

                // Resolve, either with values as is, or by transforming incoming values to some result format...
                if (_.isFunction(request.resultHandler)) {
                    // Add request and target as extra arguments...
                    applyArgs.push(request);
                    applyArgs.push(target);
                    try {
                        // Always make this an array as to respect a returned array as well...
                        applyArgs = [request.resultHandler.apply(target, applyArgs)];

                        // Make sure the result handler does not mess the internal state up on unexpected error...
                    } catch (e) {
                        deferred.rejectWith(deferred, [e]); // internal error, should never happen!
                        return;
                    }
                }
                deferred.resolveWith(deferred, applyArgs); // will trigger deferred.done set up in "_deferred(request)"!
            }).fail(function () {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                deferred.rejectWith(deferred, args); // will trigger deferred.fail set up in "_deferred(request)"!
            });
        },


        /**
         * Returns a new promise in place of <tt>promise</tt> that will only fire <tt>done</tt> handlers on
         * <tt>promise</tt> if the target used by this syncer has not been cancelled while <tt>promise</tt>
         * was executing. If cancelled, <tt>promise</tt> (and the returned promise) will be rejected with
         * a value of <tt>CANCELLED</tt>. <p>
         *
         * This function is expected to be called from within an actual sync function performing some form of
         * physical updates on the target, e.g. "save", to mask the promise returned by the actual sync method.
         * That is, a request must be pending or it does not make sense to mask <tt>promise</tt>. In addition,
         * the current request must be tagged as cancelable. If both these requirements are not met,
         * <tt>promise</tt> is simply returned by this function. <p>
         *
         * Nested sync requests are backed by the same deferred,
         *
         * Sync methods that do not update a target, e.g. "fetch", can use this function, but it is really not
         * needed.
         *
         * @param  {Promise|Boolean} promise  The promise to intercept, or a boolean false value in case Backbone
         *                                    will not do a server round trip, like when trying to destroy an unsaved
         *                                    model. In the latter case, this function will just return an already
         *                                    resolved promise that will resolved with the target used by this
         *                                    syncer.
         * @param  {*}               [nested] The nested request actually executing, if any and if known; can be
         *                                    falsey. Only used when nested.
         * @return {Promise} The (new) promise to use in place <tt>promise</tt>; never falsey.
         */
        cancelable: function cancelable(promise, nested) {
            if (!promise) {
                return Promise.resolved(this.target);
            }

            // Expected to be called during sync, so nested will always be 1 on normal requests, and thus
            // something larger than 1 on nested requests...
            var current = this.target.syncState.current;
            var parent = current.request;
            var request = this._nested > 1 ? nested || parent : parent;

            // No (parent) request means this is function is not called from within actual sync logic, so we can never
            // cancel it. We cannot cancel requests already issued known to for example update model version
            // numbers...
            if (!parent || !request.cancelable.call(this.target)) {
                // TODO: should we eventually check both requests?
                return promise;
            }

            // Since this is expected to be executed before actual done handlers for "promise", e.g. to update
            // a model with a server response, we know that we have not changed the sync state of the target
            // in question yet, so it must still be syncing - unless it has been cancelled in the meantime. We
            // cannot cancel a different sync request, so we ignore such situations by returning true here.
            // On nested sync requests (promises), the "sync:state" of target will only change once the top level
            // request is done, i.e. when the "parent" request is done...
            return Promise.predicate(promise, {
                predicate: function predicate() {
                    // never called on "fail"!
                    return current.request !== parent || current.state !== State.Cancel;
                },

                reject: CANCELLED
            });
        },


        /**
         * Cancels the supplied sync request by rejecting its backing deferred with a value of <tt>CANCELLED</tt>. <p>
         *
         * Already executing sync requests cannot be cancelled as they might be doing all kinds of work on some
         * server elsewhere, i.e. the actual effect in the executing sync request cannot be cancelled. However, it
         * is possible to reject the currently executing promise, returned by <tt>invoke(..)</tt>, which will cause a
         * "sync:" + current.method + ":failed" event to be raised.
         *
         * @param  {*} request The sync request to cancel; cannot be falsey.
         * @return {Boolean} True if cancelled "now", false otherwise (i.e. if the backing deferred is not pending).
         *
         * @see   #invoke
         */
        cancel: function cancel(request, silent) {
            var deferred = request.deferred();
            if (Promise.isPending(deferred)) {
                deferred.rejectWith(deferred, [CANCELLED, silent]);
                return true;
            }
            return false;
        },


        /**
         * @private
         * Sets the new state of the target handled by this syncer to the supplied state if and only if the new
         * state is applicable.
         *
         * @param {String|*} request  The request causing the state change, or just the sync method name, e.g. "save"
         *                            (never a private name like "_save") on "pending" or "cancel"; never falsey.
         * @param {String}   state    The new state, as a constant from <tt>State</tt>; never falsey.
         * @param {Boolean}  [silent] True if silent, false otherwise (default). If silent, no event will be triggered.
         * @param {Error|*}  [error]  Optional error or error value in case of <tt>State.Failed</tt>; can be falsey.
         *
         * @return {Boolean} True if the current sync for the handled target was cancelled because of the state
         *                   change, false otherwise.
         */
        _state: function _state(request, state, silent, error) {
            silent = silent || request.silent;
            try {
                var syncState = this.target.syncState;
                var method = request.method || request; // i.e. when "request" is just a method name for "pending" or "cancel"
                var now = Date.now();
                var current = syncState.current; // current state, changed here
                var actual = syncState.actual; // actual state, only changed on completion here
                var changed = current.state !== state;
                var trigger = !silent && changed && _.isFunction(this.target.trigger); // only trigger when supported, not silent, and on change
                var cancelled = current.state === State.Cancel; // cancelled already? If so, we do not cancel again...

                // A new cancellation? Will ever only cancel a sync request if currently "pending" or possibly if
                // "syncing" as well...
                if (state === State.Cancel) {
                    // If a sync is already in progress, e.g. calling some server, we cannot cancel and must ignore the
                    // cancellation request - the backend is probably busy doing stuff. We cannot even cancel on fetch, as
                    // we do not know which callback hooks are waiting for the result. We check for pending, since a
                    // cancellation means nothing for states prior to sync, i.e. "unsynced", or post to sync, i.e. "synced"
                    // or "failed"...
                    if (current.state !== State.Pending && current.state !== State.Syncing) {
                        return false; // continue as this call never happened, ignore cancellation!
                    }
                    cancelled = true;
                }

                // Update current sync state...
                current.state = state;
                current.method = method;
                current.error = undefined;
                current.request = null;

                // Unfortunately, we have to use a timer for each time a sync starts, to ensure that unhandled errors
                // will still be reflected in the target sync state, e.g. if a listener on "sync:state", for example,
                // raises an unhandled error, done() and fail() handlers will *not* be called. The timer will have been
                // started by "invoke(deferred, request)"...
                if (state === State.Syncing) {
                    // Have we been cancelled already? Then make sure the state matches the "actual" state and return...
                    if (cancelled) {
                        current.state = actual.state;
                        current.method = actual.method;
                        current.error = actual.error;
                        return true; // signal cancelled!
                    }
                    // Tag with syncing request...
                    current.request = request;
                }

                // Update actual state if the state indicates the sync has completed, successfully or not...
                if (state === State.Synced || state === State.Unsynced) {
                    actual.method = method;
                    actual.state = state;
                    actual.error = undefined;

                    syncState.synced.push({ method: method, time: now }); // stats, for debug

                    // Discard error messages since we are now synced successfully (again) unless silent...
                    if (!silent) {
                        _.each(syncState.failed, function (entry) {
                            if (entry.id) {
                                ErrorHandler.discard(entry.id);
                            }
                        });
                    }
                    delete syncState.failed;

                    // Preserve the first error for consistency as the actual error!
                } else if (state === State.Failed) {
                    // Resolve http(s) status code into error, which is not resolved completely yet, or make sure we
                    // always have an error to avoid odd cascading errors from error handling on an unexpectedly
                    // undefined error...
                    if (request.http) {
                        error = ErrorHandler.fromHttp(error);
                    } else if (typeof error === "undefined") {
                        error = "unknown";
                    }

                    if (_.isString(error)) {
                        error = { message: error };
                    }

                    // Alert error if so the specified handler says so; this will also format the actual
                    // "current.error" with a properly formatted error message, if not already. We save
                    // a reference to the returned id(s), so we can close reported errors if the syncing
                    // later succeeds...
                    var id = !silent && ErrorHandler.fail(error, request.errorHandler || { method: method });

                    // Assign current error...
                    current.error = error;

                    actual.state = state;

                    // ...but only store first actual error...
                    if (!actual.error) {
                        actual.method = method;
                        actual.error = current.error;
                    }

                    if (!syncState.failed) {
                        // stats
                        syncState.failed = [];
                    }
                    syncState.failed.push({ method: method, time: now, id: id });
                }

                // Trigger on changed state only (and when not specified to be silent)...
                if (changed) {
                    log.info("Sync state " + (silent ? "silent " : "") + " change after", now - syncState.time, "ms: " + request + ":" + state, "->  " + this.target, this.target);
                    if (error) {
                        log.error(error);
                    }
                    syncState.time = now;
                    // So we still log and set meta data, but only trigger if we have a trigger function and unless
                    // not silent...
                    if (trigger) {
                        // Supplied target as last argument since it will otherwise not be available when target is
                        // re-triggered via a containing Backbone collection...
                        this.target.trigger("sync:state", state, method, error, this.target);
                    }
                }
                return cancelled;

                // Make sure unexpected exceptions will not interfere...
            } catch (e) {
                log.error("Unexpected error: {}", e);
                return false;
            }
        },


        /**
         * Returns the string representation of this syncer.
         *
         * @return {String} The string representation of this syncer; never falsey.
         */
        toString: function toString() {
            return "Syncer[identifiers: [" + this.targetIdentifiers().join(", ") + "]; timeout: " + this._timeout + "ms]";
        }
    }, {

        State: State,

        /** Value rejected by this syncer on sync cancellation. */
        CANCELLED: CANCELLED
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(75);

var _createChainableTypeChecker = __webpack_require__(387);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorState
 * @format
 * 
 */



var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BlockTree = __webpack_require__(1034);
var ContentState = __webpack_require__(606);
var EditorBidiService = __webpack_require__(2120);
var Immutable = __webpack_require__(40);
var SelectionState = __webpack_require__(271);

var OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Stack = Immutable.Stack;


var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};

var EditorStateRecord = Record(defaultRecord);

var EditorState = function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _extends({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });
    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;
      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;
        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();
      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });

    return new EditorState(map);
  };

  EditorState.prototype.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  EditorState.prototype.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  EditorState.prototype.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  EditorState.prototype.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  EditorState.prototype.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  EditorState.prototype.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  EditorState.prototype.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  EditorState.prototype.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  EditorState.prototype.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  };

  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */


  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
  };

  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */


  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();
    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  EditorState.prototype.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  };

  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */


  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  };

  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */


  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }
    return updateSelection(editorState, selection, true);
  };

  /**
   * Move selection to the end of the editor without forcing focus.
   */


  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();

    return EditorState.acceptSelection(editorState, new SelectionState({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  };

  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */


  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  };

  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */


  EditorState.push = function push(editorState, contentState, changeType) {
    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var forceSelection = changeType !== 'insert-characters';
    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride();

    // Don't discard inline style overrides for the following change types:
    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };

    return EditorState.set(editorState, editorStateChanges);
  };

  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */


  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  };

  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */


  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();
    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());

    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  };

  /**
   * Not for public consumption.
   */


  function EditorState(immutable) {
    _classCallCheck(this, EditorState);

    this._immutable = immutable;
  }

  /**
   * Not for public consumption.
   */


  EditorState.prototype.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();

/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}

/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */
function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}

/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */
function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}

/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */
function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree.generate(content, block, decorator);
  }));
}

/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */
function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.
  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey);

  // If there is a character just inside the selection, use its style.
  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  }

  // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.
  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  }

  // Otherwise, look upward in the document to find the closest character.
  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  return OrderedSet();
}

module.exports = EditorState;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        Configuration = __webpack_require__(27),
        CONSTANTS = __webpack_require__(209),
        ErrorHandler = __webpack_require__(119),
        ErrorAction = __webpack_require__(560),
        ImprovedView = __webpack_require__(6),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        Marionette = __webpack_require__(10),
        RemoveIncompatibleWidgets = __webpack_require__(1771),
        SyncManager = __webpack_require__(44),
        template = __webpack_require__(1777);


    var log = new Logger("NotificationBar");

    var NOTIFICATION_BAR_EXPANDED = "notification-bar-expanded",


    /** Default events for each notification. */
    DEFAULT_EVENTS = {
        // Close button clicked...
        "click .close-icon": function clickCloseIcon() {
            this.close("manual");
        },
        // Close link clicked, which may still activate an actual link...
        "click .close-notification": function clickCloseNotification() {
            this.close("manual");
        },
        // Reload/retry/duplicate/community/support action(s)...
        "click .action": function clickAction(event) {
            event.preventDefault();
            this._action(event.target);
        },
        // Flip to next notification...
        "click .next-notification": function clickNextNotification(event) {
            event.preventDefault();
            this.close("flip"); // TODO: remove focus from link after click - how?
        }
    },


    /** Default options for each notification. */
    DEFAULT_OPTIONS = {

        /**
         * @type {String}
         * The id assigned for the notification, used to ensure that the same logical notification is not
         * shown twice in the same notification queue. An auto assigned id will be generated if none
         * supplied. Could for example be some prefix + experience id to identify an given type of error
         * related to an experience.
         */
        id: null,
        /**
         * @type {Boolean}
         * True to ensure the notification can be closed (default), false otherwise. A non-closeable notification
         * is typically a system wide notification, such as unsupported browser. <p>
         *
         * A non-closeable notification can <b>only</b> be closed explicitly via is notification id, never
         * as part of a close based on tag or something else.
         */
        closeable: true,
        /**
         * @type {Boolean}
         * True to a manual show close button with notification (default), false otherwise.
         * Can also be manual closed via a link in the notification message like
         * <a class="close-notification">Close me</a>.
         */
        showCloseButton: true,
        /**
         * @type {*|String}
         * Map with keys "global", "manual", "delay", "hide", and "flip" with allowed values "all", "self", "tag",
         * or "no", indicating if notifications must be removed on a given close type. For example, "manual" = "self"
         * means that closing a notification via the close button will remove it from the queue of notifications
         * in the bar, while "flip" = "no" means the notification is not removed when the user flips through
         * the notifications manually, while "hide" = "self" means that when the notification is automatically
         * replaced (i.e. non user triggered) by another one, it should be removed. <p>
         *
         * If a string, each key will be assigned the string value.
         */
        clearOnClose: {
            global: "all", manual: "self", delay: "self", hide: "no", flip: "no"
        },
        /**
         * @type {Boolean}
         * True to show queued notification count (default), false otherwise. If shown, the count
         * is clickable to flip through messages. Each message manually closed will be removed
         * from the queue; if no manual close button, it will be removed on flipping.
         */
        showCount: true,
        /**
         * @type {Number}
         * Optional delay in ms before the current notification is closed (default none).
         * If queued notifications, the next one will be shown after delay.
         */
        closeDelay: undefined,
        /**
         * @type {Boolean}
         * True to ignore a notification if it has the same content as an already queued
         * notification (default), false otherwise.
         */
        ignoreDuplicate: true,
        /**
         * @type {Boolean}
         * True for removing the incompatible widgets in email creator
         * notification, false (default) otherwise.
         */
        removeIncompatibleWidgets: false,
        /**
         * @type {Boolean}
         * True to queue notification for later display (default), false otherwise. If false,
         * the notification will be shown immediately.
         */
        queue: true,
        /**
         * @type {*|Boolean}
         * Map with keys "hide", "flip", "queue", "delay", and "duplicate" and boolean values, where a true value
         * indicates that the notification bar should flash on the given event. For example, "flip" = true means
         * the notification bar will flash when the user flips to the next notification, while "hide" = false
         * means no flashing if the notification is replaced by another one getting focus (non user triggered). <p>
         *
         * If a boolean, each key will be assigned the boolean value.
         */
        flash: {
            hide: true, flip: true, queue: true, duplicate: true, delay: true
        },
        /**
         * @type {Boolean}
         * True if the notification is an error, false otherwise (default). Errors are styled differently.
         */
        error: false,
        /**
         * @type {Boolean}
         * True to alert the notification error via <tt>window.alert(..)</tt> if and only if the log level
         * is <tt>Logger.VERBOSE</tt>, false otherwise (default). The error will still be notification as
         * a normal notification error as well. <p>
         *
         * An error with the <tt>options.alert</tt> options set to true will only ever be alerted once, and only
         * if no other alert is pending as we do not want to spam the user with alert boxes. Errors with alerts
         * will be displayed immediately if no other alerts are shown at notification time, i.e. flipping from
         * existing notification shown if so.
         */
        alert: false,
        /**
         * @type {Boolean}
         * True to raise the notification as an <tt>Error</tt> one time only, and if and only if
         * <tt>options.error</tt> is also true, false otherwise (default).
         */
        raise: false,
        /**
         * @type {String}
         * A tag to group the notification with similar notifications, so they can be removed together. <p>
         *
         * For example, <tt>options.clearOnClose.manual = "someTag"</tt> will removed all notifications
         * with "someTag" on manual close. If the tag value ends with colon (":"), any notification with
         * the tag prefix will be removed, excluding the colon itself. For example, "someTag:" will remove
         * both "someTagXX" and "someTagYY". <p>
         *
         * If no tag is specified, errors will be given "error" and normal notifications "message" unless
         * a default tag has been specified via <tt>NotificationBar.tag(tag:String)</tt>.
         */
        tag: null,
        /**
         * @type {String}
         * An optional statsD name to be issued when the notification is opened, queued, or closed, and the actual
         * statsD name will be <tt>notificationbar.open</tt>, <tt>notificationbar.queue</tt>, and
         * <tt>notificationbar.close</tt>, respectively. If no specified, the <tt>options.tag</tt> will be
         * used to track said events.
         */
        statsD: null,
        /**
         * @type {{nameAndSelector:String, handler:Function}}
         * Hook for events to add to this notification bar for the specific notification in jQuery style.
         */
        events: undefined
    },


    /**
     * @type {Number}
     * Counter for auto assigned id for a notification where no explicit id has been assigned on show.
     */
    ID = 0,


    /**
     * @type {Number}
     * The delay in ms for the flash duration on flash. Should be (a bit) larger than the CSS class "flash" used
     * or the flash animation will never complete before removed again.
     */
    FLASH_DURATION = 300;

    /**
     * @class Notification
     * A <i>notification</i> describes a message, normal or error, shown by this notification bar.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags.com</a>
     */
    var Notification = function Notification(content, options) {
        /** @type {String} The id of this notification. */
        this.id = (options.id || ++ID) + "";
        /** @type {{message:String, ..}} The formatted content of this option, can also be an error. */
        this.content = content;
        /** @type {*} The options for this notification. */
        this.options = options;
        /** @type {Number} The creation time is ms since the epoch, client time. */
        this.timestamp = Date.now();

        // Must show queue count if non-closeable, since other notifications would be hidden forever. Still allowed
        // to be removed via "id", e.g. on delay...
        if (!this.options.closeable) {
            this.options.showCloseButton = false;
            this.options.showCount = true;
        }

        this.toString = function () {
            var s = "Notification[id: " + this.id;
            if (this.options.tag) {
                s += "; tag: <" + this.options.tag + ">";
            }
            if (!this.options.closeable) {
                s += "; non-closable";
            }
            s += "; " + (this.options.error ? "error" : "message") + ": " + this.content.message + "]";
            return s;
        };
    };

    /**
     * Global notification bar that sits on top of the main content section (just below the top navigation bar).
     *
     * <pre>
     *
     * this.viewScope.showNotification("Hello notification bar - close me <a class='close-notification'>here</a>", {
     *     onClose: function () {
     *         console.log("I was just closed...");
     *     },
     *     showCloseButton: false,
     *     closeDelay: 5000 // Closing in 5 seconds
     * });
     *
     * </pre>
     *
     * @class NotificationBar
     *
     * @author Kim Knudsen / <a href="http://www.zmags.com">Zmags.com</a>
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags.com</a>
     */
    var NotificationBar = ImprovedView.extend({

        template: template,

        /**
         * @type {HTMLElement}
         * The HTMLElement defined in index.html
         */
        el: ".notification-bar",

        ui: {
            content: ".content",
            messageContent: ".message",
            nextNotification: ".next-notification"
        },

        regions: {
            removeIncompatibleWidgetsRegion: ".remove-incompatible-widgets-region"
        },

        /**
         * The template helpers will at render time be set to the options for <tt>this._notification</tt>, will
         * be set to the options for the opened notifications plus the "action" property.
         */
        templateHelpers: { showCloseButton: false, action: "", request: "" }, // properties known to be referenced there...

        events: DEFAULT_EVENTS,

        /**
         * @private @type {Notification[]}
         * Queued notification messages, ordered according to queue time. <p>
         */
        _notifications: [],

        /**
         * @private @type {Notification}
         * The current notification from <tt>this._notifications</tt> that is active (and thus shown if open).
         */
        _notification: null,

        /**
         * @private @type {Number}
         * Timestamp of when this notification bar was last opened or flashed, to prevent flashing on notifications
         * queued closely together in time, e.g. on multiple variant failures from "one save".
         */
        _timestamp: Date.now(),

        /**
         * @private @type {Boolean}
         * True if an error is currently also alerted via <tt>alert(..)</tt>, false otherwise. <p>
         */
        _alertOpen: false,

        /**
         * @private @type {String}
         * The current default tag to assign to each notification without a tag. <p>
         *
         * This can change over time via <tt>NotificationBar.tag(tagOrView:String|ImprovedView)</tt>, for example a
         * given tag only relevant when in preview mode. <p>
         *
         * If no tag is set here, errors and normal notifications will be tagged with "error" and "message",
         * respectively.
         */
        _tag: null,

        popupModel: null,

        //

        /**
         * Opens the supplied notification, regardless if from the queue or not.
         *
         * @param  {Notification} notification The notification to open; never null.
         * @return {String} The id of <tt>notification</tt>; never null.
         */
        _open: function _open(notification) {
            var options = notification.options;
            // Set the current notification...
            this._notification = notification;

            var model = notification.content.model,
                action = notification.content.action || "",
                noDuplicate = action.indexOf(ErrorHandler.Actions.DUPLICATE) !== -1,
                request = "";

            if (model) {
                request = model.syncState.current.method || model.syncState.actual.method;
                // We only support duplicate for Experiences for now...
                noDuplicate = noDuplicate && model.__typeName !== "Experience";
            }

            // Remove duplicate if a non-Experience model or if no model at all...
            if (noDuplicate) {
                action = action.replace(ErrorHandler.Actions.DUPLICATE, "");
            }

            // Make the options object available to the template...
            this.templateHelpers = _.extend({}, options);
            this.templateHelpers.action = action;
            this.templateHelpers.request = request;

            // Add events based on options as well...
            this._addEvents(options);

            // Re-render...
            this.render();

            // Actual formatted content, e.g. a normal notification or perhaps an error message...
            var content = this._notification.content.message;

            // Update dom...
            this.ui.messageContent.html(content);
            this._renderQueueCount(options);

            // Make sure events are up to date with the current UI
            this.delegateEvents();

            var root = $("html");
            root.addClass(NOTIFICATION_BAR_EXPANDED);
            this.$el.removeClass("closed").addClass("open");

            // Do we need to alert and/or raise the error?
            if (options.error) {
                // Tag with "error" class...
                this.ui.content.addClass("error");

                // Alert?
                if (options.alert) {
                    this._alert(notification);
                }
                // Raise?
                if (options.raise) {
                    options.raise = false;
                    log.error("Raising notification: " + notification);
                    throw new Error(content);
                }

                // Ensure not tagged with "error" class...
            } else {
                this.ui.content.removeClass("error");
            }

            log.verbose("Opening notification: " + notification);

            // Track open...
            this._track("open", options);

            return this._notification.id;
        },

        /**
         * Alerts the supplied notification via <tt>window.alert</tt> at most one time, and only if no alert is
         * currently shown.
         *
         * @param {Notification} notification The notification to potentially alert via <tt>windows.alert</tt>.
         */
        _alert: function _alert(notification) {
            // Never alert this again, even if we do not alert now if the alert box is already opened!
            notification.options.alert = false;
            if (this._alertOpen) {
                return;
            }
            this._alertOpen = true;

            // Generate message based on error options...
            var error = notification.content,
                msg = error.message,
                scope = this;

            if (error.action) {
                if (error.action.indexOf(ErrorHandler.Actions.RELOAD) !== -1) {
                    msg += "\n\nPlease refresh before you continue your work!";
                }
                if (error.action.indexOf(ErrorHandler.Actions.RETRY) !== -1) {
                    msg += "\n\nPlease try again!";
                }
                // No need to alert info about the community in an alert box...
                if (error.action.indexOf(ErrorHandler.Actions.SUPPORT) !== -1 && Configuration.supportEmail) {
                    msg += "\n\nPlease contact " + Configuration.supportEmail + " if you need further assistance.";
                }
            }

            // Let relevant views update themselves before we alert and stop the world...
            setTimeout(function () {
                alert(msg);
                // Do not clear flag until pending work has been allowed to execute or the next one will alert again
                // immediately...
                setTimeout(function () {
                    scope._alertOpen = false;
                }, 50); // 50 - let other (0) timeouts complete before this one...
            }, 50); // ditto
        },

        /**
         * Adds a flash effect to this notification bar if so configured via the supplied options for the specified
         * transition type, e.g. on "hide" or "flip". <p>
         *
         * For a flash effect to be applied to this notification bar, the following must hold:
         *
         * - No <tt>window.alert</tt> is shown, or pending to be shown immediately.
         * - <tt>options.flash[type]</tt> is truthy
         * - A flash effect has not been applied within the last FLASH_DURATION * 3 ms
         * - A flash effect is not already applied to this notification bar.
         *
         * @param {*}      options The notification options; never null.
         * @param {String} type    The notification transition type to potentially add the flash effect for if
         *                         so configured in <tt>options</tt>, e.g. "hide" or "flip"; never null.
         *
         * @return {Boolean} True if a flash will be applied, false otherwise.
         */
        _flash: function _flash(options, type) {
            var _this = this;

            var now = Date.now();
            if (!this._alertOpen && options.flash[type] && !this.$el.hasClass("flash")) {
                // Prevent flashing if we for example queue multiple notifications just after each other...
                if (now - this._timestamp > FLASH_DURATION * 3) {
                    this._timestamp = now;
                    this.$el.addClass("flash");
                    setTimeout(function () {
                        _this.$el.removeClass("flash");
                    }, FLASH_DURATION);
                    return true;
                }
            } else {
                this._timestamp = now;
            }
            return false;
        },

        _action: function _action(element) {
            var notification = this._notification,
                action = $(element).parent()[0].className,
                done; // "reload", "duplicate", "retry", "community", "removeIncompatibleWidgets" or "support"...

            // Special case for duplicate as we might want to continue editing another (new) model. At this point,
            // we know we only have an Experience, since the DUPLICATE action will have been removed for other
            // model types when opening the notification...
            if (action === ErrorHandler.Actions.DUPLICATE) {
                // We do not need a fail handler, since failures to save (create) an improved model is already
                // notified via this notification bar via the error handler... :)
                done = function (type, clone) {
                    // Do no give the action to duplicate again for the current notification since we just did
                    // exactly that...
                    notification.content.action = notification.content.action.replace(action, "");
                    var options = {
                        tag: "duplicate_created",
                        queue: false,
                        closeDelay: 60000,
                        events: {
                            "click .duplicate": function () {
                                // Remove notification about conflict and this notification, since the user just
                                // clicked the link to edit the duplicate experience...
                                this.close({ id: notification.id });
                                this.close({ tag: "duplicate_created" });
                            }.bind(this)
                        }
                    };
                    this.open({ message: "Copy created: \"" + clone.distinguishedName() + "\". <a class='duplicate' href='#experience/" + clone.get("id") + "/edit'>Click to edit it</a> - your changes here will be lost.", model: clone }, options);
                }.bind(this);
            } else if (action === ErrorHandler.Actions.RELOGIN) {
                // Only do this once to avoid flooding the server with futile relogin attempts...
                notification.content.action = notification.content.action.replace(action, "");
            } else if (action === ErrorHandler.Actions.REMOVE_INCOMPATIBLE_WIDGETS) {
                this.removeIncompatibleWidgetsRegion.show(new RemoveIncompatibleWidgets({
                    model: this.popupModel
                }));
                this.popupModel.set({ state: CONSTANTS.OPEN });
            }

            // Will also work if no model. If a model, we already have a listener for it to close
            // the notification on successful syncing. However, on "duplicate", we will have a new model, so
            // we have test for that and notify the user once done...
            ErrorAction.forError(notification.content, action)("notificationbar", done);
        },

        _track: function _track(type, options) {
            if (this.options.statsD) {
                this.options.statsD.track("notificationbar." + type + "." + (options.statsD || options.tag));
            }
        },

        //

        _handleOptions: function _handleOptions(options) {
            options = options || {};
            var o = options.clearOnClose;
            // Handle option short cuts and nested options...
            if (_.isString(o)) {
                options.clearOnClose = {
                    global: o, manual: o, hide: o, flip: o, delay: o
                };
            } else if (o) {
                _.defaults(o, DEFAULT_OPTIONS.clearOnClose);
            }
            o = options.flash;
            if (_.isBoolean(o)) {
                options.flash = {
                    queue: o, hide: o, flip: o, duplicate: o
                };
            } else if (o) {
                _.defaults(o, DEFAULT_OPTIONS.flash);
            }

            // Add default tag if none supplied, e.g. makes it easier to remove all errors, for example...
            if (!options.tag) {
                options.tag = this._tag || (options.error ? "error" : "message");
            }

            // Store a reference to the current options
            return _.defaults(options, DEFAULT_OPTIONS);
        },

        _parseContent: function _parseContent(content, options) {
            if (_.isFunction(content)) {
                return { message: content.call(this, options) };
            } else if (_.isString(content)) {
                return { message: content };
            }
            // {message:String, ..}, e.g. an error...
            return content;
        },

        _clearDelayTimer: function _clearDelayTimer(options) {
            if (options.timer) {
                clearTimeout(options.timer);
                options.timer = null;
            }
        },

        _setDelayTimer: function _setDelayTimer(options) {
            var _this2 = this;

            if (_.isNumber(options.closeDelay)) {
                options.timer = setTimeout(function () {
                    _this2._clearDelayTimer(options);
                    _this2.close("delay");
                }, options.closeDelay);
            }
        },

        _addEvents: function _addEvents(options) {
            this._setDelayTimer(options);
            if (_.isObject(options.events)) {
                this.events = _.extend(DEFAULT_EVENTS, options.events);
            }
        },

        _renderQueueCount: function _renderQueueCount(options) {
            // -1 since we always have all notifications to the queue, including the one shown...
            var length = options.showCount && this._notifications.length - 1;
            this.ui.nextNotification.html(length ? length + " more..." : "");
        },

        _matches: function _matches(notification, ignoreDuplicate) {
            var i, l, n;

            // This works because all notifications are queue in "this._notifications", even the one currently shown...
            for (i = 0, l = this._notifications.length; i < l; i++) {
                n = this._notifications[i];
                if (n.id === notification.id) {
                    return n;
                    // Ignore duplicates? If so, the content *and* tag must match...
                } else if (ignoreDuplicate && n.options.tag === notification.options.tag && n.content.message === notification.content.message) {
                    return n;
                }
            }
            return null;
        },

        //

        /**
         * Sets the default tag for this notification bar. <p>
         *
         * Any notification without an explicit tag will be tagged with the supplied tag. If falsey, errors and
         * normal notifications will be tagged with "error" and "message" henceforth, respectively. <p>
         *
         * If the supplied tag is a view, a unique tag is generated and used until said view is closed.
         *
         * @param {String|ImprovedView} [tagOrView] The default tag for any notification without a tag; can be falsey,
         *                                          which will clear the already set default tag.
         */
        tag: function tag(tagOrView) {
            var _this3 = this;

            var tag = tagOrView;
            if (tagOrView instanceof Marionette.Layout) {
                tag = "view" + Date.now(); // cid may not be ready
                this.listenToOnce(tagOrView, "close", function () {
                    // Clear tag if not overridden by another context/view...
                    if (_this3._tag === tag) {
                        _this3.tag();
                    }
                    // Remove notifications with it...
                    _this3.close({ tag: tag, clear: "tag" });
                });
            }
            this._tag = tag;
            log.info("Setting default tag: <" + (tag || "") + ">");
        },

        /**
         * Opens/shows the notification error with the specified content, or enqueues it for later viewing depending
         * on <tt>options</tt> and if this notification bar is currently opened or not. <p>
         *
         * This is merely syntactic sugar for setting <tt>options.error = true</tt> and then calling
         * <tt>this.open(content, options)</tt>. <p>
         *
         * If no <tt>options.tag</tt> is specified, the tag "error" will be set for the notification. <p>
         *
         * If <tt>content</tt> is an object like an error, this notification bar will recognise a
         * <tt>content.action</tt> value of "reload", "retry", "community", or "support", or a combination thereof,
         * and add a relevant link to such an action when the notification is shown. See <tt>ErrorHandler.Actions</tt>.
         *
         * @param  {String|*|Function} content A string message (HTML supported), a template function that will be
         *                                     invoked with the options as the only argument, or a notification object
         *                                     like <tt>{message:String, action:String, ..}</tt> (complies
         *                                     with errors as dictated by <tt>ErrorHandler</tt>). If falsey, including
         *                                     if the return value from the function is falsey, the notification will
         *                                     be ignored.
         *
         * @param  {*}              [options] Options for configuring the notification; will default if not supplied.
         *
         * @return {String} The id assigned to the shown or queued notification error; will be null if neither shown,
         *                  nor queued.
         */
        error: function error(content, options) {
            options = options || {};
            options.error = true;
            return this.open(content, options);
        },

        /**
         * Opens/shows the notification with the specified content, or enqueues it for later viewing depending
         * on <tt>options</tt> and if this notification bar is currently opened or not. <p>
         *
         * If closed and no arguments supplied, the last opened one or alternatively the first queued one will be
         * opened, if any. <p>
         *
         * If <tt>content</tt> is an object like an error, this notification bar will recognise a
         * <tt>content.action</tt> value of "reload", "retry", "community", or "support", or a combination thereof,
         * and add a relevant link to such an action when the notification is shown (from <tt>ErrorHandler.Actions</tt>).
         * This is typically the case for errors, but is also applicable for normal notifications. <p>
         *
         * If no <tt>options.tag</tt> is specified, the tag "error" will be set for the notification if
         * <tt>options.error</tt> is true, otherwise the tag will be set to "message". <p>
         *
         * @param  {String|*|Function} [content] A string message (HTML supported), a template function that will be
         *                                       invoked with the options as the only argument, or a notification object
         *                                       like <tt>{message:String, action:String, ..}</tt> (complies
         *                                       with errors as dictated by <tt>ErrorHandler</tt>). If falsey, including
         *                                       if the return value from the function is falsey, the notification will
         *                                       be ignored.
         *
         * @param  {*}               [options] Options for configuring the notification; will default if not supplied.
         *
         * @return {String} The id assigned to the shown or queued notification; will be null if neither shown,
         *                  nor queued.
         */
        open: function open(content, options) {
            var opened = this.opened();

            // Re-open if closed the last opened one or take the first queued one otherwise...
            if (!opened && !arguments.length && this._notifications.length) {
                return this._open(this._notification || this._notifications[0]);
            }

            // Merge supplied options with default ones...
            options = this._handleOptions(options);
            // We have to parse the content here, since it might be queued and we want to reflect the value the
            // notification had the time of queuing. We do not add the notification again if duplicate, either
            // based on notification id, or based on duplicate content if so configured in the options.
            content = this._parseContent(content, options);

            // Never alert if already an alert open and only on VERBOSE...
            options.alert = Logger.level() === Logger.VERBOSE && options.alert && !this._alertOpen;

            // Create notification and push it to array of notifications...
            var notification = new Notification(content, options);

            this.popupModel = options.popupModel || this.popupModel;
            // Ignore if no content, or if the configuration content matches that of an already queued notification
            // if so configured via "options.ignoreDuplicate" or id...
            if (!content) {
                log.warn("Ignoring notification with no content");
                return null;
            }
            var existing = this._matches(notification, options.ignoreDuplicate);
            if (existing) {
                log.verbose("Ignoring notification matching existing one: " + notification + " -> " + existing, notification, existing);
                // If the existing one is an error, go to it. Otherwise flash the existing notification, regardless
                // which is match the supplied notification, to signal to the user that something is up...
                if (opened) {
                    // If the existing is already opened, simply flash if so configured...
                    if (existing.options.error && existing !== this._notification) {
                        this.close({ type: "duplicate", next: existing });
                        return existing.id;
                    }
                    // Set close delay timer if set, since relevant again, and restart it again...
                    options = existing.options;
                    this._clearDelayTimer(options);
                    this._setDelayTimer(options);

                    // Note: we do show updated actions, i.e. we may have removed some from the existing notification
                    // which we do not want to add again (one time actions)...
                    this._flash(options, "duplicate");
                    return null;
                }
                // If not opened, we open again to notify the user (without flash)...
                return this._open(existing);
            }

            // Always enqueue the notification so we can find it again *and* the next one to display on close...
            this._notifications.push(notification);

            // If we have a model associated with the notification, make sure this notification is removed
            // if the model is synced successfully, for example because of a reload or retry of a save. We
            // also remove other notifications for the same model, since probably no longer relevant. We do
            // this here, even if queued, since we might get notifications for model variants as well in the
            // background...
            var model = notification.content.model;
            if (model) {
                SyncManager.onSync({
                    context: this,
                    target: model,
                    callback: function () {
                        this.close({ model: model, clear: "model" }); // will also remove this listener!
                    }.bind(this)
                });
            }

            // Close existing one if opened unless we are about to queue...
            if (opened) {
                // Enqueue only? Adhered to options *unless* the current notification is not an error and we are
                // supplying an error now...
                if (options.queue && (this._notification.options.error || !options.error)) {
                    log.verbose("Enqueued notification: " + notification);
                    // Never alert some message we later dequeue...
                    options.alert = false;
                    this._flash(options, "queue");
                    this._renderQueueCount(options);

                    // Track queued...
                    this._track("queue", options);
                    return notification.id;
                }

                // Close existing one first, if any, by doing a hide to the new one about to be shown to adhered to the
                // rules about deleting on different types of closing. We ensure we show the one just pushed by
                // supplied the index of it to close...
                this.close({ type: "hide", next: notification });
                return notification.id;
            }

            // No existing one shown, so simply open...
            return this._open(notification);
        },

        /**
         * Returns the current notification opened in this notification bar. <p>
         *
         * If this notification bar is not opened, a falsey value will be returned.
         *
         * @return {Notification} The current notification opened, or a falsey value.
         */
        opened: function opened() {
            return this.$el.hasClass("open") && this._notification;
        },

        /**
         * Removes all notifications matches by the supplied options, but not not update this notification bar
         * visually or its internal state otherwise. <p>
         *
         * Non-closeable notifications are <b>not</b> affected by this except if deleted by id explicitly! <p>
         *
         * This will also clear the current active one if it was removed because of it; if this notification bar
         * is open, it will then flip to the next one to be shown. <p>
         *
         * Examples:
         * <pre>
         *    // Remove all *closeable* notifications...
         *    var notification = this._remove(); // or this._remove({}) or this._remove({close: false})
         *    // -> "notification" will be the active one just removed, if any
         *
         *    // Remove *all* notifications, regardless if closeable or not (e.g. on logout)...
         *    var notification = this._remove({close: true});
         *    // -> "notification" will be the active one just removed, if any
         *
         *    // Removes the notification with the specified id...
         *    var notification = this._remove({id: "xx"});
         *    // -> "notification" will be the active one just removed if it had the id "xx", otherwise null.
         *
         *    // Removes the notifications with the specified *exact* tag (ignoring case)...
         *    var notification = this._remove({tag: "foo"});
         *    // -> "notification" will be the active one just removed if it had the exact tag "foo", otherwise null.
         *
         *    // Removes the notifications with the *starting* with the specified tag...
         *    var notification = this._remove({tag: "foo:"});
         *    // -> "notification" will be the active one just removed if it had a tag starting with "foo", otherwise null.
         *    ..
         *
         *    // Via value from <tt>options.clearOnClose</tt> when called as part of the close flow, e.g.
         *    // if configured as <tt>options.clearOnClose.manual = "self":
         *
         *    // Remove all...
         *    var notification = this._remove({type: "all"});
         *    // same as this._remove() or this._remove({})
         *
         *    // Removes the current active notification, if any...
         *    var notification = this._remove({type: "self"});
         *    // -> "notification" will be the active one just removed, if any, otherwise null.
         *
         *    // Removes the notifications with the specified *exact* tag (ignoring case)...
         *    var notification = this._remove({type: "foo"});
         *    // -> "notification" will be the active one just removed if it had the exact tag "foo", otherwise null.
         *
         *    // Removes the notifications with the *starting* with the specified tag...
         *    var notification = this._remove({type: "foo:"});
         *    // -> "notification" will be the active one just removed if it had a tag starting with "foo", otherwise null.
         *
         *    // -> "notification" always null, no notifications removed
         *    // Do not remove notifications...
         *    var notification = this._remove({type: "no"});
         *    // -> "notification" always null, no notifications removed
         *    ..
         * </pre>
         *
         * @param {*} [options] The options to remove notifications by. If falsey or <tt>options.clear</tt> = "no",
         *                      no notifications will be removed.  If <tt>options.id</tt> is defined, the notification
         *                      with said id, if any, will be removed (ignoring <tt>options.tag</tt>). If
         *                      <tt>options.tag</tt> is supplied, all notifications with said tag will be removed
         *                      (ignoring case). If <tt>options.tag</tt> ends with a colon (":"), any tag starting with
         *                      the <tt>options.tag</tt> value excluding the colon will be removed ("tag wild card",
         *                      ignoring case). Finally, none of these cases match, all notification will be
         *                      removed.
         *
         * @return {Number} The number of notifications removed.
         */
        _remove: function _remove(options) {
            // Removes all notifications based on the supplied predicate and returns the removed count...
            var remove = function (predicate) {
                var n = this._notifications.length,
                    notification,
                    i = 0;

                while (n--) {
                    notification = this._notifications[n];
                    if (predicate(notification)) {
                        log.verbose("Removing notification: " + notification);
                        this._stopListening(notification);
                        this._notifications.splice(n, 1);
                        // No break here!
                        i++;
                    }
                }
                return i;
            }.bind(this);

            // Number of removed notifications...
            var i = 0;

            // No options, so nothing to remove, but can still be hidden or flipped, for example, so need to be closed...
            if (!options || options.clear === "no") {
                return 0;

                // Remove by id, ignoring any tag. Note that non-closeable notifications *can* be closed based on id...
            } else if (options.id) {
                i = remove(function (notification) {
                    return notification.id === options.id; // also non-closeable ones!
                });

                // Remove by tag, or a prefix of such...
            } else if (options.tag) {
                var tag = options.tag,
                    regex;

                // Wild card, e.g. all "concurrent:XXX"...
                if (tag.indexOf(":") === tag.length - 1) {
                    regex = new RegExp("^" + tag.substring(0, tag.length - 1), "i");

                    // Exact tag, ignoring case...
                } else {
                    regex = new RegExp("^" + tag + "$", "i");
                }
                i = remove(function (notification) {
                    return notification.options.closeable && regex.test(notification.options.tag);
                });

                // Remove all errors for the specified model?
            } else if (options.model) {
                i = remove(function (notification) {
                    return notification.options.closeable && notification.content.model === options.model;
                });

                // Empty options, or options.clear = "all" specified, so clear all (closeable) notifications...
            } else {
                var all = options.clear === "all";
                i = remove(function (notification) {
                    // A bit of hack, since that is truly not closeable, not even after logout... :)
                    return all && notification.options.tag !== "unsupported_browser" || notification.options.closeable;
                });
            }
            return i;
        },

        /**
         * @private
         * Stop listening for "sync:state" for the supplied removed notification if it has an associated
         * model.
         *
         * @param {Notification} notification Removed notification; never null, nor empty.
         */
        _stopListening: function _stopListening(notification) {
            var model = notification.content.model;
            if (model) {
                this.stopListening(model, "sync:state");
            }
        },

        /**
         * Generates usable close options based on the supplied options.
         *
         * @param {*|String} options The close options, or <tt>clearOnClose<tt> type.
         * @return {*} Usable close options for use in <tt>this.close()</tt>.
         */
        _handleCloseOptions: function _handleCloseOptions(options) {
            // Can be a close type like "manual", or close options like {id: xx}...
            if (!options) {
                options = { type: "global" };
            } else if (_.isString(options)) {
                options = { type: options };
            } else if (!options.type) {
                options.type = "global";
            }

            // If no current notification, we use "no" since not really much we can do otherwise. This also means
            // that all cases below testing on "notification" will work since never hit if no notification...
            if (!options.clear) {
                options.clear = this._notification ? this._notification.options.clearOnClose[options.type] || "no" : "no";
            }

            // Translate close type, if any, i.e. "all", "self", "no", or a tag to relevant options for removal below...
            switch (options.clear) {
                case "all":
                case "no":
                    // Remove all...
                    break;

                case "tag":
                    // Remove via tag on active notification unless a tag has already been specified...
                    if (options.tag) {
                        break;
                    } else if (this._notification && this._notification.options.tag) {
                        options.tag = this._notification.options.tag;
                        break;
                    }
                // Fall through.

                case "self":
                    // Remove via id or self, e.g. when active...
                    if (!options.id && this._notification) {
                        options.id = this._notification.id;
                        break;
                    }
                // Fall through.

                case "model":
                    // Remove notifications associated with given model...
                    if (options.model) {
                        break;
                    } else if (this._notification && this._notification.content.model) {
                        options.model = this._notification.content.model;
                        break;
                    }
                // Fall through.

                default:
                    // Remove via actual tag or tag prefix...
                    options.tag = options.type; // actually a tag here...
                    break;
            }

            return options;
        },

        /**
         * Returns the number of notifications for this bar that has not been removed, e.g. those not removed on
         * close or flip. <p>
         *
         * To open this bar when closed to show existing notifications, simply call <tt>open()</tt> (with no
         * arguments).
         *
         * @return {Number} The number of notifications.
         */
        count: function count() {
            return this._notifications.length;
        },

        /**
         * Returns the the list of all notification messages.
         *
         *
         * @return {List} Returns the list active notification messages in queue.
         */
        list: function list() {
            var notifications = [];

            this._notifications.map(function (notification) {
                return notifications.push({
                    id: notification.id,
                    message: notification.content.message
                });
            });

            return notifications;
        },

        /**
         * Finds the next notification to show, if any, as part of the close flow.
         *
         * @param {*}            closeOptions The close options used; never null.
         * @param {Notification} notification The active notification just closed, if any; can be null, and
         *                                    can at this point still be in the list of notifications or it may
         *                                    not be.
         *
         * @return {Notification} The next notification to show; or null if none is to be showed.
         */
        _next: function _next(closeOptions, notification) {
            // Invariant: called after removal as part of close logic...

            var n = this._notifications.length,
                i,
                j = -1,
                error = false;

            // No more notifications? Then no next one to show, so we will close the bar entirely...
            if (!n) {
                return null;

                // Next one already specified, i.e. when opening spawns a close of the existing one that then opens
                // the supplied notification....
            } else if (closeOptions.next) {
                return closeOptions.next;

                // If supplied, "notification" is the notification just removed and/or the one currently active...
            } else if (notification) {
                // Make sure we do not select this again as the next notification...
                i = this._notifications.indexOf(notification);
                // Removed, so find non-closeable message, secondarily first error, or message if no errors...
                if (i === -1) {
                    for (i = 0; i < n; i++) {
                        notification = this._notifications[i];
                        // Use first non-closeable one...
                        if (!notification.options.closeable) {
                            j = i;
                            break;

                            // First first error, but may still find a non-closeable one, so no break...
                        } else if (notification.options.error && !error) {
                            error = true;
                            j = i;
                            // No break here

                            // First one then, but may be overruled by non-closeable or error...
                        } else if (!error && j === -1) {
                            j = i;
                        }
                    }

                    // Not removed, so take next...
                } else {
                    j = ++i % n;
                }
                return this._notifications[j];
            }
            return null;
        },

        /**
         * Closes this notification bar, and removes relevant notifications based on the supplied
         * close options or <tt>clearOnClose</tt> type. <p>
         *
         * Close options can be a <tt>clearOnType</tt> type from the notification configuration, e.g. "manual",
         * "flip", etc. The active notification will then be removed based on the configured <tt>clearOnClose</tt>
         * type for the current active notification. <p>
         *
         * The close options can also be a query like structure:
         * - {id: XX, clear:String, type:String, ..}:  removes the notification with the specified id and closes
         *   this bar if said notification was the active one.
         * - {tag: XX, clear:String, type:String, ..}: removes all notifications with the specified tag (prefix) and
         *   closes this bar if the active notification was removed because of this.
         * - {model:ImprovedModel}: removes all notification errors with the specified model.
         * - {}: removes all notifications and closes this notification bar.
         *
         * @param {*|String} [closeOptions] Close options, or a <tt>clearOnClose</tt> type.
         */
        close: function close(closeOptions) {
            var _this4 = this;

            // Can be a close type like "manual", or close options like {id: xx}...
            closeOptions = this._handleCloseOptions(closeOptions);

            // Remove notifications based on close options, which could be zero if <tt>options.clear</tt> = "no", or
            // on no matching notifications, e.g. no such tag found. We will need to update the visible count count
            // in any case if "removed" > 0...
            var removed = this._remove(closeOptions),
                notification = this._notification;

            // No active, bar is already closed, and no need to update queue count either (closed)...
            if (!notification) {
                return;

                // Remove as active if no longer queued, i.e. just removed because of the supplied close options...
            } else if (this._notifications.indexOf(notification) === -1) {
                this._notification = null;

                // We did not remove the active one, so no one to close, but we did remove some other ones, e.g.
                // based on tag, so update the visual queue count. We must always do this if the queue count is
                // visible, since we know we have at least one more notification now, i.e. the active one...
            } else if (removed || closeOptions.clear !== "no") {
                this._renderQueueCount(notification.options);
                return;
            }

            log.verbose("Closing notification: " + notification, closeOptions);

            var options = notification.options;

            // Clear close delay timer...
            this._clearDelayTimer(options);

            // Content may depend on the close handler for each message, so we have to call it even if we immediately
            // show a queued notification...
            if (_.isFunction(options.onClose)) {
                options.onClose();
            }

            // Clean up...
            this.events = DEFAULT_EVENTS;

            // Find the next notification to show, if any. If no such notification, we close this bar now...
            notification = this._next(closeOptions, notification);
            if (notification) {
                this._open(notification);
                // Add (optional) flash effect, since this bar is already open...
                this._flash(notification.options, closeOptions.type);
                return;
            }

            // Track close per type when the active notification was *active* was closed, e.g. to see if the user
            // manually dismisses notification messages...
            this._track("close." + closeOptions.type, options);

            // No next one to show, so close for real...
            var root = $("html");
            root.removeClass(NOTIFICATION_BAR_EXPANDED);

            // Clear dom after animation completes, but only if no other notification has been opened in the meantime...
            setTimeout(function () {
                if (!_this4._notification) {
                    _this4.ui.content.html("");
                }
            }, FLASH_DURATION);

            this.$el.removeClass("open").addClass("closed");
        }
    });

    // Return a single (rendered) instance
    var instance = new NotificationBar();
    instance.render();
    return instance;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var _ = __webpack_require__(1);
  var Class = __webpack_require__(26);
  var Backbone = __webpack_require__(7);

  /**
   * Abstract base class providing event dispatcher and listen-to functionality utilizing Backbone.Events.
   *
   * This class may be useful if you need basic event logic.
   *
   * @class EventDispatcher
   */

  var EventDispatcher = function EventDispatcher() {}; // TODO: bad name, since both dispatch and listening - why not simply Events?

  EventDispatcher.extend = Class.extend;

  _.extend(EventDispatcher.prototype, Backbone.Events);

  return EventDispatcher;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(3161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(722);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__(287);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(723);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_3__logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memo__ = __webpack_require__(1251);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc__ = __webpack_require__(344);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__object__ = __webpack_require__(1252);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__path__ = __webpack_require__(3163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__promisebuffer__ = __webpack_require__(3164);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__promisebuffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__string__ = __webpack_require__(724);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__supports__ = __webpack_require__(1254);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__syncpromise__ = __webpack_require__(1253);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__syncpromise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__instrument__ = __webpack_require__(3165);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__instrument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dsn__ = __webpack_require__(3166);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_13__dsn__["a"]; });














//# sourceMappingURL=index.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alpha = __webpack_require__(2362);

Object.defineProperty(exports, 'Alpha', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Checkboard = __webpack_require__(649);

Object.defineProperty(exports, 'Checkboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkboard).default;
  }
});

var _EditableInput = __webpack_require__(2365);

Object.defineProperty(exports, 'EditableInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditableInput).default;
  }
});

var _Hue = __webpack_require__(2366);

Object.defineProperty(exports, 'Hue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Raised = __webpack_require__(2368);

Object.defineProperty(exports, 'Raised', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Raised).default;
  }
});

var _Saturation = __webpack_require__(2428);

Object.defineProperty(exports, 'Saturation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Saturation).default;
  }
});

var _ColorWrap = __webpack_require__(1115);

Object.defineProperty(exports, 'ColorWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Swatch = __webpack_require__(2444);

Object.defineProperty(exports, 'Swatch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var CompositeWidgetModel = __webpack_require__(173);
    var RestApi = __webpack_require__(29);
    var ImprovedModel = __webpack_require__(25);
    var OverlayScene = __webpack_require__(1474);
    var BackgroundScene = __webpack_require__(1475);
    var Backdrop = __webpack_require__(523);
    var SceneTransitionTypes = __webpack_require__(524).default;
    var SceneCollection = __webpack_require__(1476);
    var Size = __webpack_require__(84);
    var Scale = __webpack_require__(360);

    var DEFAULT_NAME = "(Untitled Experience)";
    var DEFAULT_TRANSITION = SceneTransitionTypes.SLIDE_FROM_RIGHT;
    var DEFAULT_SCENE_AUTOPLAY_DELAY = 5000;
    var DEFAULT_BEHAVIOR = [{
        name: "",
        connection: "",
        branches: "",
        variables: "",
        conditions: []
    }];

    /**
     * The experience model.
     *
     * @class ExperienceModel
     * @constructor
     */
    var ExperienceModel = ImprovedModel.extend("Experience", {
        url: function url() {
            return RestApi.pathToSpecificResource(RestApi.Collections.EXPERIENCES, this.get("id"));
        },


        relations: [{
            type: Backbone.Many,
            key: "scenes",
            collectionType: SceneCollection
        }, {
            type: Backbone.One,
            key: "overlayScene",
            relatedModel: OverlayScene
        }, {
            type: Backbone.One,
            key: "backgroundScene",
            relatedModel: BackgroundScene,
            reverseRelation: {
                key: "experience"
            }
        }, {
            type: Backbone.One,
            key: "backdrop",
            relatedModel: Backdrop,
            reverseRelation: {
                key: "experience"
            }
        }],

        defaults: {

            /**
             * The <tt>SceneCollection</tt>, initially defined by "backbone.associations" (the empty array is needed).<p>
             *
             * The <tt>ExperienceModel</tt> is born with an empty collection of scenes - for now, the editor is responsible
             * for adding at least one scene before persisting.
             *
             * @see  EditorController#editNewExperience
             * @type {SceneCollection}
             */
            scenes: [],

            /**
             * Defaults to <tt>OverlayScene</tt>, handled by "backbone.associations" (the empty object is needed).
             *
             * @type {OverlayScene}
             */
            overlayScene: {},

            /**
             * Defaults to <tt>BackgroundScene</tt>, handled by "backbone.associations" (the empty object is needed).
             *
             * @type {BackgroundScene}
             */
            backgroundScene: {},

            name: DEFAULT_NAME,
            width: null,
            height: null,
            companyId: null,
            transition: DEFAULT_TRANSITION.id,
            autoPlayDelay: DEFAULT_SCENE_AUTOPLAY_DELAY,
            behaviorConfig: DEFAULT_BEHAVIOR,
            state: null, // also used by Viewer
            // Use a plain object in order for backbone.association to create a default backdrop model, which is
            // needed when we render data into view. We cannot just do new Backdrop() here,
            // because the defaults go to prototype and the new instance will be shared among all experiences
            backdrop: {},

            /**
             * Represents the current scale of the experience, prior to it's
             * defined size (width and height).
             *
             * When viewed, the experience might be contained within a viewport of
             * a different size, resulting in a scaled experience.
             *
             * Note that this is a transient property.
             *
             * @see  #scaledWidth
             * @see  #scaledHeight
             *
             * @type {Scale}
             */
            scale: new Scale(),

            /**
             * Image integrations are a part of the experience model as they are critical
             * for the rendering of images when third party image integrations are used (e.g. Scene7)
             * This is necessary as we cannot wait for more requests to finished before we start rendering (See MOS-3438)
             */
            integrations: [],
            language: "en-US",
            experienceMetadata: {
                dynamicProductIds: []
            },

            emailModeEnabled: false
        },

        computed: {
            scaledWidth: {
                deps: ["scale", "width"],
                value: function value(scale, width) {
                    return scale.x * width;
                }
            },

            scaledHeight: {
                deps: ["scale", "height"],
                value: function value(scale, height) {
                    return scale.y * height;
                }
            }
        },

        /**
         * Constructor.
         */
        constructor: function constructor() {
            var _this = this;

            this.__super();

            // Update all contained scenes (and eventually their contained widgets) with the new scale.
            this.listenTo(this, "change:scale", function (model, scale) {
                _.invoke(_this.getAllScenes(), "set", "scale", scale);
            });
        },


        /**
         * Returns a convenience array containing all widgets, including the grouped, overlay, and background widgets.
         *
         * @return {AbstractWidgetModel[]} Array referencing all widgets.
         */
        getAllWidgets: function getAllWidgets() {
            return _.flatten(_.map(this.getAllScenes(), function (scene) {
                var widgets = scene.get("widgets");
                var subModels = widgets.filter(function (widget) {
                    return widget instanceof CompositeWidgetModel && widget.has("group");
                }).map(function (compositeWidget) {
                    return compositeWidget.get("group").models;
                });
                return [widgets.models, subModels];
            }));
        },


        /**
         * Returns a convenience array containing all scenes, including the overlay and background scenes.
         *
         * @return {Scenes[]} Array referencing all scenes.
         */
        getAllScenes: function getAllScenes() {
            var scenes = _.clone(this.get("scenes").models);
            scenes.push(this.get("overlayScene"), this.get("backgroundScene"));
            return scenes;
        },


        /**
         * Returns the number of scenes (<tt>length</tt> of the inner scenes collection), excluding
         * overlay and background scenes.
         *
         * @return {Number} The number of scenes.
         */
        getNumberOfScenes: function getNumberOfScenes() {
            return this.get("scenes").length;
        },
        getPixelPosition: function getPixelPosition(point) {
            var w = this.get("width");
            var h = this.get("height");
            var pixelPosition = {};

            if (point.hasOwnProperty("left")) {
                pixelPosition.left = point.left / 100 * w;
            }

            if (point.hasOwnProperty("top")) {
                pixelPosition.top = point.top / 100 * h;
            }

            return pixelPosition;
        },
        getPixelSize: function getPixelSize(size) {
            var w = this.get("width");
            var h = this.get("height");
            var pixelSize = {};

            if (size.hasOwnProperty("width")) {
                pixelSize.width = size.width / 100 * w;
            }

            if (size.hasOwnProperty("height")) {
                pixelSize.height = size.height / 100 * h;
            }

            return pixelSize;
        },
        getPercentagePosition: function getPercentagePosition(point) {
            var w = this.get("width");
            var h = this.get("height");
            var percentagePosition = {};

            if (point.hasOwnProperty("left")) {
                percentagePosition.left = point.left / w * 100;
            }

            if (point.hasOwnProperty("top")) {
                percentagePosition.top = point.top / h * 100;
            }

            return percentagePosition;
        },


        /**
         * Returns a given size in pixels calculated as a percentage of the size of this
         * experience.
         * @param {Object} sizeInPixels An object with width and height properties.
         * @returns {Size}
         */
        getPercentageSize: function getPercentageSize(sizeInPixels) {
            var percentageWidth = void 0;
            var percentageHeight = void 0;

            if (sizeInPixels.hasOwnProperty("width")) {
                percentageWidth = sizeInPixels.width / this.get("width") * 100;
            }

            if (sizeInPixels.hasOwnProperty("height")) {
                percentageHeight = sizeInPixels.height / this.get("height") * 100;
            }

            return new Size(percentageWidth, percentageHeight);
        },


        /**
         * Gets the dimensions of the experience as an object containing a width and height property. If a bounding box
         * size is specified, the dimensions are scaled to fit within this box.
         *
         * @param {Object} [boundingBoxSize] Bounding box size. You may choose to specify one of width and height or both.
         * @returns {Object} The scaled dimensions of the experience. Contains three properties: width, height, and scale.
         */
        getDimensions: function getDimensions(boundingBoxSize) {
            var height = this.get("height");
            var width = this.get("width");

            var scaleRatio = 1.0;

            if (boundingBoxSize) {
                scaleRatio = Math.min(1.0, boundingBoxSize.height ? boundingBoxSize.height / height : 1.0, boundingBoxSize.width ? boundingBoxSize.width / width : 1.0);
            }

            return {
                width: Math.round(width * scaleRatio),
                height: Math.round(height * scaleRatio),
                scale: scaleRatio
            };
        },


        /**
         * Gets the scene with the given ID, or null if no scene matching the ID is found.
         * @param {String} sceneId The scene ID.
         * @returns {Scene} The scene matching the given ID.
         */
        getSceneById: function getSceneById(sceneId) {
            if (this.get("overlayScene").get("id") === sceneId) {
                return this.get("overlayScene");
            }

            if (this.get("backgroundScene").get("id") === sceneId) {
                return this.get("backgroundScene");
            }

            return this.get("scenes").findWhere({ id: sceneId }) || null;
        },
        getSceneBySceneNumber: function getSceneBySceneNumber(sceneNum) {
            if (sceneNum === "overlay") {
                return this.get("overlayScene");
            } else if (sceneNum === "background") {
                return this.get("backgroundScene");
            } else if (sceneNum >= 0) {
                return this.get("scenes").at(sceneNum - 1);
            }

            return null;
        },


        /**
         * Returns the size of the experience, in pixels.
         *
         * Pass <tt>true</tt> to get the scaled experience size.
         *
         * @param  {Boolean} scaled Whether to return the scaled experience
         * size or the original size.
         *
         * @see  scale
         *
         * @return {Size} The size of the experience, either the original
         * (default behavior), or if specified, the scaled size.
         */
        getSize: function getSize(scaled) {
            if (scaled) {
                return new Size(this.get("scaledWidth"), this.get("scaledHeight"));
            }

            return new Size(this.get("width"), this.get("height"));
        },
        isInactive: function isInactive() {
            // Only inactive filters will actually push the state, and then as "Inactive", but for legacy reasons,
            // we have to handle cases where a state is marshaled anyway... :/
            return this.get("state") === "Inactive"; // Viewer thing, do not include complex enum state for this!
        },


        /**
         * Returns the matching integration on the experience model
         *
         * @param {String} type Integration type name to lookup in the array of integrations
         * @returns {Object} The matching integration data object, returns undefined if type wasn't found
         */
        getIntegration: function getIntegration(type) {
            var experienceIntegrations = this.get("integrations");
            return _.find(experienceIntegrations, function (integration) {
                return integration.type === type;
            });
        }
    }, {
        type: "Experience",
        DEFAULT_NAME: DEFAULT_NAME
    });

    return ExperienceModel;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useForkRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setRef__ = __webpack_require__(214);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refA, refValue);
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Canvas_1 = __webpack_require__(449);
var Global_1 = __webpack_require__(38);
var DragAndDrop_1 = __webpack_require__(664);
var Validators_1 = __webpack_require__(41);
exports.ids = {};
exports.names = {};
var _addId = function (node, id) {
    if (!id) {
        return;
    }
    exports.ids[id] = node;
};
exports._removeId = function (id, node) {
    if (!id) {
        return;
    }
    if (exports.ids[id] !== node) {
        return;
    }
    delete exports.ids[id];
};
exports._addName = function (node, name) {
    if (name) {
        if (!exports.names[name]) {
            exports.names[name] = [];
        }
        exports.names[name].push(node);
    }
};
exports._removeName = function (name, _id) {
    if (!name) {
        return;
    }
    var nodes = exports.names[name];
    if (!nodes) {
        return;
    }
    for (var n = 0; n < nodes.length; n++) {
        var no = nodes[n];
        if (no._id === _id) {
            nodes.splice(n, 1);
        }
    }
    if (nodes.length === 0) {
        delete exports.names[name];
    }
};
var ABSOLUTE_OPACITY = 'absoluteOpacity', ABSOLUTE_TRANSFORM = 'absoluteTransform', ABSOLUTE_SCALE = 'absoluteScale', CANVAS = 'canvas', CHANGE = 'Change', CHILDREN = 'children', KONVA = 'konva', LISTENING = 'listening', MOUSEENTER = 'mouseenter', MOUSELEAVE = 'mouseleave', NAME = 'name', SET = 'set', SHAPE = 'Shape', SPACE = ' ', STAGE = 'stage', TRANSFORM = 'transform', UPPER_STAGE = 'Stage', VISIBLE = 'visible', TRANSFORM_CHANGE_STR = [
    'xChange.konva',
    'yChange.konva',
    'scaleXChange.konva',
    'scaleYChange.konva',
    'skewXChange.konva',
    'skewYChange.konva',
    'rotationChange.konva',
    'offsetXChange.konva',
    'offsetYChange.konva',
    'transformsEnabledChange.konva',
].join(SPACE), SCALE_CHANGE_STR = ['scaleXChange.konva', 'scaleYChange.konva'].join(SPACE);
var emptyChildren = new Util_1.Collection();
var idCounter = 1;
var Node = (function () {
    function Node(config) {
        this._id = idCounter++;
        this.eventListeners = {};
        this.attrs = {};
        this.index = 0;
        this.parent = null;
        this._cache = new Map();
        this._attachedDepsListeners = new Map();
        this._lastPos = null;
        this._batchingTransformChange = false;
        this._needClearTransformCache = false;
        this._filterUpToDate = false;
        this._isUnderCache = false;
        this.children = emptyChildren;
        this._dragEventId = null;
        this._shouldFireChangeEvents = false;
        this.setAttrs(config);
        this._shouldFireChangeEvents = true;
    }
    Node.prototype.hasChildren = function () {
        return false;
    };
    Node.prototype.getChildren = function () {
        return emptyChildren;
    };
    Node.prototype._clearCache = function (attr) {
        if ((attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM) &&
            this._cache.get(attr)) {
            this._cache.get(attr).dirty = true;
        }
        else if (attr) {
            this._cache.delete(attr);
        }
        else {
            this._cache.clear();
        }
    };
    Node.prototype._getCache = function (attr, privateGetter) {
        var cache = this._cache.get(attr);
        var isTransform = attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM;
        var invalid = cache === undefined || (isTransform && cache.dirty === true);
        if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
        }
        return cache;
    };
    Node.prototype._calculate = function (name, deps, getter) {
        var _this = this;
        if (!this._attachedDepsListeners.get(name)) {
            var depsString = deps.map(function (dep) { return dep + 'Change.konva'; }).join(SPACE);
            this.on(depsString, function () {
                _this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
        }
        return this._getCache(name, getter);
    };
    Node.prototype._getCanvasCache = function () {
        return this._cache.get(CANVAS);
    };
    Node.prototype._clearSelfAndDescendantCache = function (attr, forceEvent) {
        this._clearCache(attr);
        if (forceEvent && attr === ABSOLUTE_TRANSFORM) {
            this.fire('_clearTransformCache');
        }
        if (this.isCached()) {
            return;
        }
        if (this.children) {
            this.children.each(function (node) {
                node._clearSelfAndDescendantCache(attr, true);
            });
        }
    };
    Node.prototype.clearCache = function () {
        this._cache.delete(CANVAS);
        this._clearSelfAndDescendantCache();
        return this;
    };
    Node.prototype.cache = function (config) {
        var conf = config || {};
        var rect = {};
        if (conf.x === undefined ||
            conf.y === undefined ||
            conf.width === undefined ||
            conf.height === undefined) {
            rect = this.getClientRect({
                skipTransform: true,
                relativeTo: this.getParent(),
            });
        }
        var width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === undefined ? rect.x : conf.x, y = conf.y === undefined ? rect.y : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false;
        if (!width || !height) {
            Util_1.Util.error('Can not cache the node. Width or height of the node equals 0. Caching is skipped.');
            return;
        }
        width += offset * 2;
        height += offset * 2;
        x -= offset;
        y -= offset;
        var cachedSceneCanvas = new Canvas_1.SceneCanvas({
            pixelRatio: pixelRatio,
            width: width,
            height: height,
        }), cachedFilterCanvas = new Canvas_1.SceneCanvas({
            pixelRatio: pixelRatio,
            width: 0,
            height: 0,
        }), cachedHitCanvas = new Canvas_1.HitCanvas({
            pixelRatio: 1,
            width: width,
            height: height,
        }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
        cachedHitCanvas.isCache = true;
        cachedSceneCanvas.isCache = true;
        this._cache.delete('canvas');
        this._filterUpToDate = false;
        if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
        }
        sceneContext.save();
        hitContext.save();
        sceneContext.translate(-x, -y);
        hitContext.translate(-x, -y);
        this._isUnderCache = true;
        this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
        this.drawScene(cachedSceneCanvas, this);
        this.drawHit(cachedHitCanvas, this);
        this._isUnderCache = false;
        sceneContext.restore();
        hitContext.restore();
        if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr('strokeStyle', 'red');
            sceneContext.setAttr('lineWidth', 5);
            sceneContext.stroke();
            sceneContext.restore();
        }
        this._cache.set(CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            x: x,
            y: y,
        });
        return this;
    };
    Node.prototype.isCached = function () {
        return this._cache.has('canvas');
    };
    Node.prototype.getClientRect = function (config) {
        throw new Error('abstract "getClientRect" method call');
    };
    Node.prototype._transformedRect = function (rect, top) {
        var points = [
            { x: rect.x, y: rect.y },
            { x: rect.x + rect.width, y: rect.y },
            { x: rect.x + rect.width, y: rect.y + rect.height },
            { x: rect.x, y: rect.y + rect.height },
        ];
        var minX, minY, maxX, maxY;
        var trans = this.getAbsoluteTransform(top);
        points.forEach(function (point) {
            var transformed = trans.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY,
        };
    };
    Node.prototype._drawCachedSceneCanvas = function (context) {
        context.save();
        context._applyOpacity(this);
        context._applyGlobalCompositeOperation(this);
        var canvasCache = this._getCanvasCache();
        context.translate(canvasCache.x, canvasCache.y);
        var cacheCanvas = this._getCachedSceneCanvas();
        var ratio = cacheCanvas.pixelRatio;
        context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
        context.restore();
    };
    Node.prototype._drawCachedHitCanvas = function (context) {
        var canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
        context.save();
        context.translate(canvasCache.x, canvasCache.y);
        context.drawImage(hitCanvas._canvas, 0, 0);
        context.restore();
    };
    Node.prototype._getCachedSceneCanvas = function () {
        var filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
        if (filters) {
            if (!this._filterUpToDate) {
                var ratio = sceneCanvas.pixelRatio;
                filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
                try {
                    len = filters.length;
                    filterContext.clear();
                    filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
                    imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
                    for (n = 0; n < len; n++) {
                        filter = filters[n];
                        if (typeof filter !== 'function') {
                            Util_1.Util.error('Filter should be type of function, but got ' +
                                typeof filter +
                                ' instead. Please check correct filters');
                            continue;
                        }
                        filter.call(this, imageData);
                        filterContext.putImageData(imageData, 0, 0);
                    }
                }
                catch (e) {
                    Util_1.Util.error('Unable to apply filter. ' +
                        e.message +
                        ' This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                }
                this._filterUpToDate = true;
            }
            return filterCanvas;
        }
        return sceneCanvas;
    };
    Node.prototype.on = function (evtStr, handler) {
        if (arguments.length === 3) {
            return this._delegate.apply(this, arguments);
        }
        var events = evtStr.split(SPACE), len = events.length, n, event, parts, baseEvent, name;
        for (n = 0; n < len; n++) {
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1] || '';
            if (!this.eventListeners[baseEvent]) {
                this.eventListeners[baseEvent] = [];
            }
            this.eventListeners[baseEvent].push({
                name: name,
                handler: handler,
            });
        }
        return this;
    };
    Node.prototype.off = function (evtStr, callback) {
        var events = (evtStr || '').split(SPACE), len = events.length, n, t, event, parts, baseEvent, name;
        if (!evtStr) {
            for (t in this.eventListeners) {
                this._off(t);
            }
        }
        for (n = 0; n < len; n++) {
            event = events[n];
            parts = event.split('.');
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
                if (this.eventListeners[baseEvent]) {
                    this._off(baseEvent, name, callback);
                }
            }
            else {
                for (t in this.eventListeners) {
                    this._off(t, name, callback);
                }
            }
        }
        return this;
    };
    Node.prototype.dispatchEvent = function (evt) {
        var e = {
            target: this,
            type: evt.type,
            evt: evt,
        };
        this.fire(evt.type, e);
        return this;
    };
    Node.prototype.addEventListener = function (type, handler) {
        this.on(type, function (evt) {
            handler.call(this, evt.evt);
        });
        return this;
    };
    Node.prototype.removeEventListener = function (type) {
        this.off(type);
        return this;
    };
    Node.prototype._delegate = function (event, selector, handler) {
        var stopNode = this;
        this.on(event, function (evt) {
            var targets = evt.target.findAncestors(selector, true, stopNode);
            for (var i = 0; i < targets.length; i++) {
                evt = Util_1.Util.cloneObject(evt);
                evt.currentTarget = targets[i];
                handler.call(targets[i], evt);
            }
        });
    };
    Node.prototype.remove = function () {
        if (this.isDragging()) {
            this.stopDrag();
        }
        DragAndDrop_1.DD._dragElements.delete(this._id);
        this._remove();
        return this;
    };
    Node.prototype._clearCaches = function () {
        this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
        this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
        this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
        this._clearSelfAndDescendantCache(STAGE);
        this._clearSelfAndDescendantCache(VISIBLE);
        this._clearSelfAndDescendantCache(LISTENING);
    };
    Node.prototype._remove = function () {
        this._clearCaches();
        var parent = this.getParent();
        if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
        }
    };
    Node.prototype.destroy = function () {
        exports._removeId(this.id(), this);
        var names = (this.name() || '').split(/\s/g);
        for (var i = 0; i < names.length; i++) {
            var subname = names[i];
            exports._removeName(subname, this._id);
        }
        this.remove();
        return this;
    };
    Node.prototype.getAttr = function (attr) {
        var method = 'get' + Util_1.Util._capitalize(attr);
        if (Util_1.Util._isFunction(this[method])) {
            return this[method]();
        }
        return this.attrs[attr];
    };
    Node.prototype.getAncestors = function () {
        var parent = this.getParent(), ancestors = new Util_1.Collection();
        while (parent) {
            ancestors.push(parent);
            parent = parent.getParent();
        }
        return ancestors;
    };
    Node.prototype.getAttrs = function () {
        return this.attrs || {};
    };
    Node.prototype.setAttrs = function (config) {
        var _this = this;
        this._batchTransformChanges(function () {
            var key, method;
            if (!config) {
                return _this;
            }
            for (key in config) {
                if (key === CHILDREN) {
                    continue;
                }
                method = SET + Util_1.Util._capitalize(key);
                if (Util_1.Util._isFunction(_this[method])) {
                    _this[method](config[key]);
                }
                else {
                    _this._setAttr(key, config[key]);
                }
            }
        });
        return this;
    };
    Node.prototype.isListening = function () {
        return this._getCache(LISTENING, this._isListening);
    };
    Node.prototype._isListening = function (relativeTo) {
        var listening = this.listening();
        if (!listening) {
            return false;
        }
        var parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) {
            return parent._isListening(relativeTo);
        }
        else {
            return true;
        }
    };
    Node.prototype.isVisible = function () {
        return this._getCache(VISIBLE, this._isVisible);
    };
    Node.prototype._isVisible = function (relativeTo) {
        var visible = this.visible();
        if (!visible) {
            return false;
        }
        var parent = this.getParent();
        if (parent && parent !== relativeTo && this !== relativeTo) {
            return parent._isVisible(relativeTo);
        }
        else {
            return true;
        }
    };
    Node.prototype.shouldDrawHit = function (top) {
        if (top) {
            return this._isVisible(top) && this._isListening(top);
        }
        var layer = this.getLayer();
        var layerUnderDrag = false;
        DragAndDrop_1.DD._dragElements.forEach(function (elem) {
            if (elem.dragStatus !== 'dragging') {
                return;
            }
            else if (elem.node.nodeType === 'Stage') {
                layerUnderDrag = true;
            }
            else if (elem.node.getLayer() === layer) {
                layerUnderDrag = true;
            }
        });
        var dragSkip = !Global_1.Konva.hitOnDragEnabled && layerUnderDrag;
        return this.isListening() && this.isVisible() && !dragSkip;
    };
    Node.prototype.show = function () {
        this.visible(true);
        return this;
    };
    Node.prototype.hide = function () {
        this.visible(false);
        return this;
    };
    Node.prototype.getZIndex = function () {
        return this.index || 0;
    };
    Node.prototype.getAbsoluteZIndex = function () {
        var depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
        function addChildren(children) {
            nodes = [];
            len = children.length;
            for (n = 0; n < len; n++) {
                child = children[n];
                index++;
                if (child.nodeType !== SHAPE) {
                    nodes = nodes.concat(child.getChildren().toArray());
                }
                if (child._id === that._id) {
                    n = len;
                }
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) {
                addChildren(nodes);
            }
        }
        if (that.nodeType !== UPPER_STAGE) {
            addChildren(that.getStage().getChildren());
        }
        return index;
    };
    Node.prototype.getDepth = function () {
        var depth = 0, parent = this.parent;
        while (parent) {
            depth++;
            parent = parent.parent;
        }
        return depth;
    };
    Node.prototype._batchTransformChanges = function (func) {
        this._batchingTransformChange = true;
        func();
        this._batchingTransformChange = false;
        if (this._needClearTransformCache) {
            this._clearCache(TRANSFORM);
            this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM, true);
        }
        this._needClearTransformCache = false;
    };
    Node.prototype.setPosition = function (pos) {
        var _this = this;
        this._batchTransformChanges(function () {
            _this.x(pos.x);
            _this.y(pos.y);
        });
        return this;
    };
    Node.prototype.getPosition = function () {
        return {
            x: this.x(),
            y: this.y(),
        };
    };
    Node.prototype.getAbsolutePosition = function (top) {
        var haveCachedParent = false;
        var parent = this.parent;
        while (parent) {
            if (parent.isCached()) {
                haveCachedParent = true;
                break;
            }
            parent = parent.parent;
        }
        if (haveCachedParent && !top) {
            top = true;
        }
        var absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new Util_1.Transform(), offset = this.offset();
        absoluteTransform.m = absoluteMatrix.slice();
        absoluteTransform.translate(offset.x, offset.y);
        return absoluteTransform.getTranslation();
    };
    Node.prototype.setAbsolutePosition = function (pos) {
        var origTrans = this._clearTransform();
        this.attrs.x = origTrans.x;
        this.attrs.y = origTrans.y;
        delete origTrans.x;
        delete origTrans.y;
        this._clearCache(TRANSFORM);
        var it = this._getAbsoluteTransform().copy();
        it.invert();
        it.translate(pos.x, pos.y);
        pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y,
        };
        this._setTransform(origTrans);
        this.setPosition({ x: pos.x, y: pos.y });
        this._clearCache(TRANSFORM);
        this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
        return this;
    };
    Node.prototype._setTransform = function (trans) {
        var key;
        for (key in trans) {
            this.attrs[key] = trans[key];
        }
    };
    Node.prototype._clearTransform = function () {
        var trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY(),
        };
        this.attrs.x = 0;
        this.attrs.y = 0;
        this.attrs.rotation = 0;
        this.attrs.scaleX = 1;
        this.attrs.scaleY = 1;
        this.attrs.offsetX = 0;
        this.attrs.offsetY = 0;
        this.attrs.skewX = 0;
        this.attrs.skewY = 0;
        return trans;
    };
    Node.prototype.move = function (change) {
        var changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
        if (changeX !== undefined) {
            x += changeX;
        }
        if (changeY !== undefined) {
            y += changeY;
        }
        this.setPosition({ x: x, y: y });
        return this;
    };
    Node.prototype._eachAncestorReverse = function (func, top) {
        var family = [], parent = this.getParent(), len, n;
        if (top && top._id === this._id) {
            return;
        }
        family.unshift(this);
        while (parent && (!top || parent._id !== top._id)) {
            family.unshift(parent);
            parent = parent.parent;
        }
        len = family.length;
        for (n = 0; n < len; n++) {
            func(family[n]);
        }
    };
    Node.prototype.rotate = function (theta) {
        this.rotation(this.rotation() + theta);
        return this;
    };
    Node.prototype.moveToTop = function () {
        if (!this.parent) {
            Util_1.Util.warn('Node has no parent. moveToTop function is ignored.');
            return false;
        }
        var index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.push(this);
        this.parent._setChildrenIndices();
        return true;
    };
    Node.prototype.moveUp = function () {
        if (!this.parent) {
            Util_1.Util.warn('Node has no parent. moveUp function is ignored.');
            return false;
        }
        var index = this.index, len = this.parent.getChildren().length;
        if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    };
    Node.prototype.moveDown = function () {
        if (!this.parent) {
            Util_1.Util.warn('Node has no parent. moveDown function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    };
    Node.prototype.moveToBottom = function () {
        if (!this.parent) {
            Util_1.Util.warn('Node has no parent. moveToBottom function is ignored.');
            return false;
        }
        var index = this.index;
        if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
        }
        return false;
    };
    Node.prototype.setZIndex = function (zIndex) {
        if (!this.parent) {
            Util_1.Util.warn('Node has no parent. zIndex parameter is ignored.');
            return this;
        }
        if (zIndex < 0 || zIndex >= this.parent.children.length) {
            Util_1.Util.warn('Unexpected value ' +
                zIndex +
                ' for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to ' +
                (this.parent.children.length - 1) +
                '.');
        }
        var index = this.index;
        this.parent.children.splice(index, 1);
        this.parent.children.splice(zIndex, 0, this);
        this.parent._setChildrenIndices();
        return this;
    };
    Node.prototype.getAbsoluteOpacity = function () {
        return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
    };
    Node.prototype._getAbsoluteOpacity = function () {
        var absOpacity = this.opacity();
        var parent = this.getParent();
        if (parent && !parent._isUnderCache) {
            absOpacity *= parent.getAbsoluteOpacity();
        }
        return absOpacity;
    };
    Node.prototype.moveTo = function (newContainer) {
        if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
        }
        return this;
    };
    Node.prototype.toObject = function () {
        var obj = {}, attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
        obj.attrs = {};
        for (key in attrs) {
            val = attrs[key];
            nonPlainObject =
                Util_1.Util.isObject(val) && !Util_1.Util._isPlainObject(val) && !Util_1.Util._isArray(val);
            if (nonPlainObject) {
                continue;
            }
            getter = typeof this[key] === 'function' && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) {
                obj.attrs[key] = val;
            }
        }
        obj.className = this.getClassName();
        return Util_1.Util._prepareToStringify(obj);
    };
    Node.prototype.toJSON = function () {
        return JSON.stringify(this.toObject());
    };
    Node.prototype.getParent = function () {
        return this.parent;
    };
    Node.prototype.findAncestors = function (selector, includeSelf, stopNode) {
        var res = [];
        if (includeSelf && this._isMatch(selector)) {
            res.push(this);
        }
        var ancestor = this.parent;
        while (ancestor) {
            if (ancestor === stopNode) {
                return res;
            }
            if (ancestor._isMatch(selector)) {
                res.push(ancestor);
            }
            ancestor = ancestor.parent;
        }
        return res;
    };
    Node.prototype.isAncestorOf = function (node) {
        return false;
    };
    Node.prototype.findAncestor = function (selector, includeSelf, stopNode) {
        return this.findAncestors(selector, includeSelf, stopNode)[0];
    };
    Node.prototype._isMatch = function (selector) {
        if (!selector) {
            return false;
        }
        if (typeof selector === 'function') {
            return selector(this);
        }
        var selectorArr = selector.replace(/ /g, '').split(','), len = selectorArr.length, n, sel;
        for (n = 0; n < len; n++) {
            sel = selectorArr[n];
            if (!Util_1.Util.isValidSelector(sel)) {
                Util_1.Util.warn('Selector "' +
                    sel +
                    '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
                Util_1.Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
                Util_1.Util.warn('Konva is awesome, right?');
            }
            if (sel.charAt(0) === '#') {
                if (this.id() === sel.slice(1)) {
                    return true;
                }
            }
            else if (sel.charAt(0) === '.') {
                if (this.hasName(sel.slice(1))) {
                    return true;
                }
            }
            else if (this.className === sel || this.nodeType === sel) {
                return true;
            }
        }
        return false;
    };
    Node.prototype.getLayer = function () {
        var parent = this.getParent();
        return parent ? parent.getLayer() : null;
    };
    Node.prototype.getStage = function () {
        return this._getCache(STAGE, this._getStage);
    };
    Node.prototype._getStage = function () {
        var parent = this.getParent();
        if (parent) {
            return parent.getStage();
        }
        else {
            return undefined;
        }
    };
    Node.prototype.fire = function (eventType, evt, bubble) {
        if (evt === void 0) { evt = {}; }
        evt.target = evt.target || this;
        if (bubble) {
            this._fireAndBubble(eventType, evt);
        }
        else {
            this._fire(eventType, evt);
        }
        return this;
    };
    Node.prototype.getAbsoluteTransform = function (top) {
        if (top) {
            return this._getAbsoluteTransform(top);
        }
        else {
            return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
        }
    };
    Node.prototype._getAbsoluteTransform = function (top) {
        var at;
        if (top) {
            at = new Util_1.Transform();
            this._eachAncestorReverse(function (node) {
                var transformsEnabled = node.transformsEnabled();
                if (transformsEnabled === 'all') {
                    at.multiply(node.getTransform());
                }
                else if (transformsEnabled === 'position') {
                    at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
                }
            }, top);
            return at;
        }
        else {
            at = this._cache.get(ABSOLUTE_TRANSFORM) || new Util_1.Transform();
            if (this.parent) {
                this.parent.getAbsoluteTransform().copyInto(at);
            }
            else {
                at.reset();
            }
            var transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === 'all') {
                at.multiply(this.getTransform());
            }
            else if (transformsEnabled === 'position') {
                var x = this.attrs.x || 0;
                var y = this.attrs.y || 0;
                var offsetX = this.attrs.offsetX || 0;
                var offsetY = this.attrs.offsetY || 0;
                at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
        }
    };
    Node.prototype.getAbsoluteScale = function (top) {
        var parent = this;
        while (parent) {
            if (parent._isUnderCache) {
                top = parent;
            }
            parent = parent.getParent();
        }
        var transform = this.getAbsoluteTransform(top);
        var attrs = transform.decompose();
        return {
            x: attrs.scaleX,
            y: attrs.scaleY,
        };
    };
    Node.prototype.getAbsoluteRotation = function () {
        return this.getAbsoluteTransform().decompose().rotation;
    };
    Node.prototype.getTransform = function () {
        return this._getCache(TRANSFORM, this._getTransform);
    };
    Node.prototype._getTransform = function () {
        var _a, _b;
        var m = this._cache.get(TRANSFORM) || new Util_1.Transform();
        m.reset();
        var x = this.x(), y = this.y(), rotation = Global_1.Konva.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
        if (x !== 0 || y !== 0) {
            m.translate(x, y);
        }
        if (rotation !== 0) {
            m.rotate(rotation);
        }
        if (skewX !== 0 || skewY !== 0) {
            m.skew(skewX, skewY);
        }
        if (scaleX !== 1 || scaleY !== 1) {
            m.scale(scaleX, scaleY);
        }
        if (offsetX !== 0 || offsetY !== 0) {
            m.translate(-1 * offsetX, -1 * offsetY);
        }
        m.dirty = false;
        return m;
    };
    Node.prototype.clone = function (obj) {
        var attrs = Util_1.Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
        for (key in obj) {
            attrs[key] = obj[key];
        }
        var node = new this.constructor(attrs);
        for (key in this.eventListeners) {
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for (n = 0; n < len; n++) {
                listener = allListeners[n];
                if (listener.name.indexOf(KONVA) < 0) {
                    if (!node.eventListeners[key]) {
                        node.eventListeners[key] = [];
                    }
                    node.eventListeners[key].push(listener);
                }
            }
        }
        return node;
    };
    Node.prototype._toKonvaCanvas = function (config) {
        config = config || {};
        var box = this.getClientRect();
        var stage = this.getStage(), x = config.x !== undefined ? config.x : box.x, y = config.y !== undefined ? config.y : box.y, pixelRatio = config.pixelRatio || 1, canvas = new Canvas_1.SceneCanvas({
            width: config.width || box.width || (stage ? stage.width() : 0),
            height: config.height || box.height || (stage ? stage.height() : 0),
            pixelRatio: pixelRatio,
        }), context = canvas.getContext();
        context.save();
        if (x || y) {
            context.translate(-1 * x, -1 * y);
        }
        this.drawScene(canvas);
        context.restore();
        return canvas;
    };
    Node.prototype.toCanvas = function (config) {
        return this._toKonvaCanvas(config)._canvas;
    };
    Node.prototype.toDataURL = function (config) {
        config = config || {};
        var mimeType = config.mimeType || null, quality = config.quality || null;
        var url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
        if (config.callback) {
            config.callback(url);
        }
        return url;
    };
    Node.prototype.toImage = function (config) {
        if (!config || !config.callback) {
            throw 'callback required for toImage method config argument';
        }
        var callback = config.callback;
        delete config.callback;
        Util_1.Util._urlToImage(this.toDataURL(config), function (img) {
            callback(img);
        });
    };
    Node.prototype.setSize = function (size) {
        this.width(size.width);
        this.height(size.height);
        return this;
    };
    Node.prototype.getSize = function () {
        return {
            width: this.width(),
            height: this.height(),
        };
    };
    Node.prototype.getClassName = function () {
        return this.className || this.nodeType;
    };
    Node.prototype.getType = function () {
        return this.nodeType;
    };
    Node.prototype.getDragDistance = function () {
        if (this.attrs.dragDistance !== undefined) {
            return this.attrs.dragDistance;
        }
        else if (this.parent) {
            return this.parent.getDragDistance();
        }
        else {
            return Global_1.Konva.dragDistance;
        }
    };
    Node.prototype._off = function (type, name, callback) {
        var evtListeners = this.eventListeners[type], i, evtName, handler;
        for (i = 0; i < evtListeners.length; i++) {
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== 'konva' || name === 'konva') &&
                (!name || evtName === name) &&
                (!callback || callback === handler)) {
                evtListeners.splice(i, 1);
                if (evtListeners.length === 0) {
                    delete this.eventListeners[type];
                    break;
                }
                i--;
            }
        }
    };
    Node.prototype._fireChangeEvent = function (attr, oldVal, newVal) {
        this._fire(attr + CHANGE, {
            oldVal: oldVal,
            newVal: newVal,
        });
    };
    Node.prototype.setId = function (id) {
        var oldId = this.id();
        exports._removeId(oldId, this);
        _addId(this, id);
        this._setAttr('id', id);
        return this;
    };
    Node.prototype.setName = function (name) {
        var oldNames = (this.name() || '').split(/\s/g);
        var newNames = (name || '').split(/\s/g);
        var subname, i;
        for (i = 0; i < oldNames.length; i++) {
            subname = oldNames[i];
            if (newNames.indexOf(subname) === -1 && subname) {
                exports._removeName(subname, this._id);
            }
        }
        for (i = 0; i < newNames.length; i++) {
            subname = newNames[i];
            if (oldNames.indexOf(subname) === -1 && subname) {
                exports._addName(this, subname);
            }
        }
        this._setAttr(NAME, name);
        return this;
    };
    Node.prototype.addName = function (name) {
        if (!this.hasName(name)) {
            var oldName = this.name();
            var newName = oldName ? oldName + ' ' + name : name;
            this.setName(newName);
        }
        return this;
    };
    Node.prototype.hasName = function (name) {
        if (!name) {
            return false;
        }
        var fullName = this.name();
        if (!fullName) {
            return false;
        }
        var names = (fullName || '').split(/\s/g);
        return names.indexOf(name) !== -1;
    };
    Node.prototype.removeName = function (name) {
        var names = (this.name() || '').split(/\s/g);
        var index = names.indexOf(name);
        if (index !== -1) {
            names.splice(index, 1);
            this.setName(names.join(' '));
        }
        return this;
    };
    Node.prototype.setAttr = function (attr, val) {
        var func = this[SET + Util_1.Util._capitalize(attr)];
        if (Util_1.Util._isFunction(func)) {
            func.call(this, val);
        }
        else {
            this._setAttr(attr, val);
        }
        return this;
    };
    Node.prototype._setAttr = function (key, val, skipFire) {
        if (skipFire === void 0) { skipFire = false; }
        var oldVal = this.attrs[key];
        if (oldVal === val && !Util_1.Util.isObject(val)) {
            return;
        }
        if (val === undefined || val === null) {
            delete this.attrs[key];
        }
        else {
            this.attrs[key] = val;
        }
        if (this._shouldFireChangeEvents) {
            this._fireChangeEvent(key, oldVal, val);
        }
    };
    Node.prototype._setComponentAttr = function (key, component, val) {
        var oldVal;
        if (val !== undefined) {
            oldVal = this.attrs[key];
            if (!oldVal) {
                this.attrs[key] = this.getAttr(key);
            }
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
        }
    };
    Node.prototype._fireAndBubble = function (eventType, evt, compareShape) {
        if (evt && this.nodeType === SHAPE) {
            evt.target = this;
        }
        var shouldStop = (eventType === MOUSEENTER || eventType === MOUSELEAVE) &&
            ((compareShape &&
                (this === compareShape ||
                    (this.isAncestorOf && this.isAncestorOf(compareShape)))) ||
                (this.nodeType === 'Stage' && !compareShape));
        if (!shouldStop) {
            this._fire(eventType, evt);
            var stopBubble = (eventType === MOUSEENTER || eventType === MOUSELEAVE) &&
                compareShape &&
                compareShape.isAncestorOf &&
                compareShape.isAncestorOf(this) &&
                !compareShape.isAncestorOf(this.parent);
            if (((evt && !evt.cancelBubble) || !evt) &&
                this.parent &&
                this.parent.isListening() &&
                !stopBubble) {
                if (compareShape && compareShape.parent) {
                    this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
                }
                else {
                    this._fireAndBubble.call(this.parent, eventType, evt);
                }
            }
        }
    };
    Node.prototype._getListeners = function (eventType) {
        var totalEvents = [];
        var obj;
        while (true) {
            obj = obj ? Object.getPrototypeOf(obj) : this;
            if (!obj) {
                break;
            }
            if (!obj.eventListeners) {
                continue;
            }
            var events = obj.eventListeners[eventType];
            if (!events) {
                continue;
            }
            totalEvents = events.concat(totalEvents);
            obj = Object.getPrototypeOf(obj);
        }
        return totalEvents;
    };
    Node.prototype._fire = function (eventType, evt) {
        var events = this._getListeners(eventType), i;
        if (events.length) {
            evt = evt || {};
            evt.currentTarget = this;
            evt.type = eventType;
            for (i = 0; i < events.length; i++) {
                events[i].handler.call(this, evt);
            }
        }
    };
    Node.prototype.draw = function () {
        this.drawScene();
        this.drawHit();
        return this;
    };
    Node.prototype._createDragElement = function (evt) {
        var pointerId = evt ? evt.pointerId : undefined;
        var stage = this.getStage();
        var ap = this.getAbsolutePosition();
        var pos = stage._getPointerById(pointerId) ||
            stage._changedPointerPositions[0] ||
            ap;
        DragAndDrop_1.DD._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
                x: pos.x - ap.x,
                y: pos.y - ap.y,
            },
            dragStatus: 'ready',
            pointerId: pointerId,
        });
    };
    Node.prototype.startDrag = function (evt) {
        if (!DragAndDrop_1.DD._dragElements.has(this._id)) {
            this._createDragElement(evt);
        }
        var elem = DragAndDrop_1.DD._dragElements.get(this._id);
        elem.dragStatus = 'dragging';
        this.fire('dragstart', {
            type: 'dragstart',
            target: this,
            evt: evt && evt.evt,
        }, true);
    };
    Node.prototype._setDragPosition = function (evt, elem) {
        var pos = this.getStage()._getPointerById(elem.pointerId);
        if (!pos) {
            return;
        }
        var newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y,
        };
        var dbf = this.dragBoundFunc();
        if (dbf !== undefined) {
            var bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) {
                Util_1.Util.warn('dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.');
            }
            else {
                newNodePos = bounded;
            }
        }
        if (!this._lastPos ||
            this._lastPos.x !== newNodePos.x ||
            this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            if (this.getLayer()) {
                this.getLayer().batchDraw();
            }
            else if (this.getStage()) {
                this.getStage().batchDraw();
            }
        }
        this._lastPos = newNodePos;
    };
    Node.prototype.stopDrag = function (evt) {
        var elem = DragAndDrop_1.DD._dragElements.get(this._id);
        if (elem) {
            elem.dragStatus = 'stopped';
        }
        DragAndDrop_1.DD._endDragBefore(evt);
        DragAndDrop_1.DD._endDragAfter(evt);
    };
    Node.prototype.setDraggable = function (draggable) {
        this._setAttr('draggable', draggable);
        this._dragChange();
    };
    Node.prototype.isDragging = function () {
        var elem = DragAndDrop_1.DD._dragElements.get(this._id);
        return elem ? elem.dragStatus === 'dragging' : false;
    };
    Node.prototype._listenDrag = function () {
        this._dragCleanup();
        this.on('mousedown.konva touchstart.konva', function (evt) {
            var _this = this;
            var shouldCheckButton = evt.evt['button'] !== undefined;
            var canDrag = !shouldCheckButton || Global_1.Konva.dragButtons.indexOf(evt.evt['button']) >= 0;
            if (!canDrag) {
                return;
            }
            if (this.isDragging()) {
                return;
            }
            var hasDraggingChild = false;
            DragAndDrop_1.DD._dragElements.forEach(function (elem) {
                if (_this.isAncestorOf(elem.node)) {
                    hasDraggingChild = true;
                }
            });
            if (!hasDraggingChild) {
                this._createDragElement(evt);
            }
        });
    };
    Node.prototype._dragChange = function () {
        if (this.attrs.draggable) {
            this._listenDrag();
        }
        else {
            this._dragCleanup();
            var stage = this.getStage();
            if (!stage) {
                return;
            }
            var dragElement = DragAndDrop_1.DD._dragElements.get(this._id);
            var isDragging = dragElement && dragElement.dragStatus === 'dragging';
            var isReady = dragElement && dragElement.dragStatus === 'ready';
            if (isDragging) {
                this.stopDrag();
            }
            else if (isReady) {
                DragAndDrop_1.DD._dragElements.delete(this._id);
            }
        }
    };
    Node.prototype._dragCleanup = function () {
        this.off('mousedown.konva');
        this.off('touchstart.konva');
    };
    Node.create = function (data, container) {
        if (Util_1.Util._isString(data)) {
            data = JSON.parse(data);
        }
        return this._createNode(data, container);
    };
    Node._createNode = function (obj, container) {
        var className = Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
        if (container) {
            obj.attrs.container = container;
        }
        if (!Global_1._NODES_REGISTRY[className]) {
            Util_1.Util.warn('Can not find a node with class name "' +
                className +
                '". Fallback to "Shape".');
            className = 'Shape';
        }
        var Class = Global_1._NODES_REGISTRY[className];
        no = new Class(obj.attrs);
        if (children) {
            len = children.length;
            for (n = 0; n < len; n++) {
                no.add(Node._createNode(children[n]));
            }
        }
        return no;
    };
    return Node;
}());
exports.Node = Node;
Node.prototype.nodeType = 'Node';
Node.prototype._attrsAffectingSize = [];
Node.prototype.eventListeners = {};
Node.prototype.on.call(Node.prototype, TRANSFORM_CHANGE_STR, function () {
    if (this._batchingTransformChange) {
        this._needClearTransformCache = true;
        return;
    }
    this._clearCache(TRANSFORM);
    this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
});
Node.prototype.on.call(Node.prototype, 'visibleChange.konva', function () {
    this._clearSelfAndDescendantCache(VISIBLE);
});
Node.prototype.on.call(Node.prototype, 'listeningChange.konva', function () {
    this._clearSelfAndDescendantCache(LISTENING);
});
Node.prototype.on.call(Node.prototype, 'opacityChange.konva', function () {
    this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
});
var addGetterSetter = Factory_1.Factory.addGetterSetter;
addGetterSetter(Node, 'zIndex');
addGetterSetter(Node, 'absolutePosition');
addGetterSetter(Node, 'position');
addGetterSetter(Node, 'x', 0, Validators_1.getNumberValidator());
addGetterSetter(Node, 'y', 0, Validators_1.getNumberValidator());
addGetterSetter(Node, 'globalCompositeOperation', 'source-over', Validators_1.getStringValidator());
addGetterSetter(Node, 'opacity', 1, Validators_1.getNumberValidator());
addGetterSetter(Node, 'name', '', Validators_1.getStringValidator());
addGetterSetter(Node, 'id', '', Validators_1.getStringValidator());
addGetterSetter(Node, 'rotation', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addComponentsGetterSetter(Node, 'scale', ['x', 'y']);
addGetterSetter(Node, 'scaleX', 1, Validators_1.getNumberValidator());
addGetterSetter(Node, 'scaleY', 1, Validators_1.getNumberValidator());
Factory_1.Factory.addComponentsGetterSetter(Node, 'skew', ['x', 'y']);
addGetterSetter(Node, 'skewX', 0, Validators_1.getNumberValidator());
addGetterSetter(Node, 'skewY', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addComponentsGetterSetter(Node, 'offset', ['x', 'y']);
addGetterSetter(Node, 'offsetX', 0, Validators_1.getNumberValidator());
addGetterSetter(Node, 'offsetY', 0, Validators_1.getNumberValidator());
addGetterSetter(Node, 'dragDistance', null, Validators_1.getNumberValidator());
addGetterSetter(Node, 'width', 0, Validators_1.getNumberValidator());
addGetterSetter(Node, 'height', 0, Validators_1.getNumberValidator());
addGetterSetter(Node, 'listening', true, Validators_1.getBooleanValidator());
addGetterSetter(Node, 'preventDefault', true, Validators_1.getBooleanValidator());
addGetterSetter(Node, 'filters', null, function (val) {
    this._filterUpToDate = false;
    return val;
});
addGetterSetter(Node, 'visible', true, Validators_1.getBooleanValidator());
addGetterSetter(Node, 'transformsEnabled', 'all', Validators_1.getStringValidator());
addGetterSetter(Node, 'size');
addGetterSetter(Node, 'dragBoundFunc');
addGetterSetter(Node, 'draggable', false, Validators_1.getBooleanValidator());
Factory_1.Factory.backCompat(Node, {
    rotateDeg: 'rotate',
    setRotationDeg: 'setRotation',
    getRotationDeg: 'getRotation',
});
Util_1.Collection.mapMethods(Node);


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        invoke = _require.invoke,
        extend = _require.extend,
        clone = _require.clone,
        result = _require.result,
        defer = _require.defer;

    var AnimationTypes = __webpack_require__(769);
    var Browser = __webpack_require__(39);
    var Color = __webpack_require__(194);
    var EffectController = __webpack_require__(1436);
    var Marionette = __webpack_require__(10);
    var MathUtil = __webpack_require__(72).default;
    var Promise = __webpack_require__(21);

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var Rectangle = __webpack_require__(248);
    var TweenMax = __webpack_require__(152);
    var WidgetScaleMode = __webpack_require__(246);

    var _require3 = __webpack_require__(1451),
        encapsulateInnerDom = _require3.encapsulateInnerDom;

    /**
     * Base view for the rendering of widgets.
     *
     * @class AbstractWidgetView
     * @constructor
     *
     * @cfg {AbstractWidgetModel} model The widget being rendered.
     * @cfg {ExperienceViewModel|EditorViewModel} viewModel The view model corresponding to the context the widget is rendered in.
     * @cfg {boolean} [edited] If true, indicates the widget is being edited.
     * @cfg {boolean} [enableAnimations] If true, indicates animations are enabled on the widget.
     */


    return Marionette.ItemView.extend({

        className: "widget-component",

        _animControllers: null,

        _effectController: null,

        _startAnimationsPending: false,

        _rendered: false,

        /**
         * @private
         * First rendering always inactive by default, the current Scene will then trigger a re-render when
         * becoming active, notifying this all other recursively contained widgets. This ensures that all other
         * Scenes/Widgets are inactive by default - as they should be - when rendered the first time (e.g. on
         * an adjacent Scene).
         *
         * @see SceneViewer#_active
         */
        _active: null,

        /**
         * @private
         * A lazy initialized logger with a name corresponding to this widget, acquired via
         * <tt>log()</tt>.
         */
        _logger: null,

        template: function template() {
            return "";
        },

        events: {
            // Do nothing, widget selection is handled by SceneEditorTransformer
            "click": function click() {}
        },

        modelEvents: {
            "change": "render"
        },

        initialize: function initialize() {
            this._active = false;

            // Invoke onInitialize hook, passing the jQuery wrapped element
            this.onInitialize(this.$el);

            if (this.model.get("isLocked")) {
                this.$el.addClass("is-locked");
            }
            if (this.model.get("isEditorHidden")) {
                this.$el.addClass("is-hidden");
            }
        },


        /**
         * @protected
         * Returns the logger associated with this Widget, lazily initialized it on first
         * request.
         *
         * @return {Logger} The logger to use for this widget; neveer falsey.
         */
        _log: function _log() {
            if (!this._logger) {
                this._logger = new Logger(this.__typeName);
            }
            return this._logger;
        },
        _viewModel: function _viewModel() {
            this.viewModel = this.options.viewModel || this.viewScope.viewModel;
            return this.viewModel;
        },
        _experienceSize: function _experienceSize(scaled) {
            return this._viewModel().get("experience").getSize(scaled);
        },


        /**
         * @private
         * Invoked when this widget is clicked/tapped if and only if this widget has an action.
         */
        _activate: function _activate() {
            if (this._active) {
                var viewModel = this._viewModel();
                // TODO: Revisit
                // The 'actions' array has been deprecated - we'll continue to be backwards compatible in the viewer (for now).
                if (this.model.has("actions")) {
                    this.model.get("actions").each(function (action) {
                        action.activate(viewModel);
                    });
                }
                // Activate action...
                var action = this.model.get("action");
                if (action) {
                    if (this.model.has("uuid")) {
                        action.attributes.widgetId = this.model.get("uuid");
                    }
                    action.activate(viewModel);
                }
            }
        },
        _hasAnimations: function _hasAnimations() {
            return !this.model.get("animations").isEmpty();
        },


        /**
         * Gets the bounding box of the widget's element.
         * If the <tt>global</tt> boolean is passed in as <tt>true</tt>, the coordinates
         * will be calculated according to the global window and not the scene.
         *
         * @param  {Boolean} global   Whether the coordinates should be relative to the <tt>Window</tt>.
         * @return {Rectangle}        The bounds.
         */
        getBoundingBox: function getBoundingBox(global) {
            var rotation = this.model.get("rotation");
            var rect = void 0;

            if (global) {
                // Round bounding client rectangle long float to the integer pixels value
                rect = MathUtil.roundRect(this.el.getBoundingClientRect());
                rect.x = rect.left;
                rect.y = rect.top;
                return new Rectangle(rect);
            }

            rect = this.getRect();

            if (rotation !== 0) {
                var unscaledExperienceSize = this._experienceSize();
                var x = this.model.get("scaledLeft") / 100 * unscaledExperienceSize.width;
                var y = this.model.get("scaledTop") / 100 * unscaledExperienceSize.height;
                var _rect = rect,
                    width = _rect.width,
                    height = _rect.height;

                return new Rectangle(MathUtil.rotateRect({
                    x: x, y: y, width: width, height: height
                }, { x: x, y: y }, rotation));
            }
            // If no rotation is applied to the widget, simply return the persisted rectangle data
            return rect;
        },


        /**
         * Returns a rectangle representing the size and position of the widget.
         *
         * Note that the returned rectangle bounds does not consider rotation, see #getBoundingBox.
         *
         * @return {Rectangle} a rectangle representing the size and position of the widget.
         */
        getRect: function getRect() {
            var width = 0;
            var height = 0;
            var unscaledExperienceSize = this._experienceSize();
            var scale = this.model.get("scale");
            var rotation = this.model.get("rotation");
            var scaleMode = this.model.get("scaleMode");
            var rect = {
                x: MathUtil.round(this.model.get("scaledLeft") / 100 * unscaledExperienceSize.width),
                y: MathUtil.round(this.model.get("scaledTop") / 100 * unscaledExperienceSize.height)
            };

            // Not all widget models contains dimensions (i.e. text based widgets may only contain width)
            if (this.model.has("width")) {
                width = MathUtil.round(this.model.get("scaledWidth") / 100 * unscaledExperienceSize.width);
            } else {
                // Let's ask jQuery then...
                width = this.$el.outerWidth();
            }

            if (this.model.has("height")) {
                height = MathUtil.round(this.model.get("scaledHeight") / 100 * unscaledExperienceSize.height);
            } else {
                height = this.$el.outerHeight();
            }

            rect.width = width;
            rect.height = height;

            if (!this.options.edited) {
                // When rotation is applied inside the editor, the pivot point is located at top left (0,0) - courtesy of free transform?
                // Inside the viewer context, we operate with a centered pivot point, aka. a transform origin of 50% 50% (.transform-origin(50% 50%))
                // So we need to compensate for that to render correctly...
                var rotatedPoint = MathUtil.rotatePoint(rect, { x: rect.x + rect.width / 2, y: rect.y + rect.height / 2 }, rotation);

                rect.x += rect.x - rotatedPoint.x;
                rect.y += rect.y - rotatedPoint.y;
            }

            rect.right = rect.x + rect.width;
            rect.bottom = rect.y + rect.height;

            // If we're "stretch scaling", compensate for the fact that scaling is done
            // from the center (transformOrigin 50% 50%) - and adjust the position.
            if (scaleMode === WidgetScaleMode.STRETCH) {
                var xf = rect.width - rect.width * scale.x;
                var yf = rect.height - rect.height * scale.y;

                rect.x -= xf * 0.5;
                rect.y -= yf * 0.5;
            }

            // For consistency...
            rect.top = rect.y;
            rect.left = rect.x;

            return new Rectangle(rect);
        },


        /**
         * Returns the parent container element, wrapped in a jQuery instance.
         *
         * @return {jQueryElement} the parent container element, wrapped in a jQuery instance.
         */
        getParentContainer: function getParentContainer() {
            return this.options.container;
        },
        setActive: function setActive(active) {
            if (active === this._active) {
                return;
            }

            this._active = active;

            if (this._effectController) {
                this._effectController.setActive(active);
            }

            if (this._rendered) {
                this._triggerUpdateRendering(this.$el, this.getRect(), active, this.options.edited, undefined /* no model changes */);

                if (active) {
                    this._startAnimationsPending = false;
                    this.startAnimations();
                } else {
                    this.stopAnimations();
                }
            }
        },


        /**
         * Returns widget active state
         *
         * @return {Boolean} true if widget is active
         */
        isActive: function isActive() {
            return this._active;
        },


        /**
         * Animates the widget by applying all of the animations defined on the model.
         *
         * @private
         */
        startAnimations: function startAnimations() {
            // Wait for the animation controllers to be set up if this method is invoked before DOM rendering is complete
            if (!this._animControllers) {
                // Since the animation controllers aren't constructed, they will be at the initial position
                this._startAnimationsPending = true;

                return;
            }

            // Make sure the element is visible
            this.$el.css("visibility", "");

            // Start the animations
            var i = this._animControllers.length;
            var controller = void 0;

            // Animations with 'immediateRender' set to true, needs to be started at the end, see #onShow
            while (i--) {
                controller = this._animControllers[i];
                controller.start();
            }
        },


        /**
         * Stop the animations.
         *
         * @private
         */
        stopAnimations: function stopAnimations() {
            // Stop any ongoing animations
            if (this._animControllers) {
                var i = this._animControllers.length;
                var controller = void 0;

                // Animations with 'immediateRender' set to true, needs to be stopped first in order to preserve state, see #onShow
                while (i--) {
                    controller = this._animControllers[i];
                    controller.stop();
                }
            }
        },
        onClose: function onClose() {
            // Cleanup
            this.$el.off();

            // Dispose animations, if any...
            invoke(this._animControllers, "close");

            if (this._effectController) {
                this._effectController.dispose();
            }
        },


        /**
         * Callback invoked during the <tt>initialize</tt> cycle.
         *
         * @param  {jQuery} element The associated DOM element wrapped in a <tt>jQuery</tt> instance.
         */
        // eslint-disable-next-line no-unused-vars
        onInitialize: function onInitialize(element) {},


        /**
         * Tells the widget to update it's rendering.<p>
         *
         * This is an abstract method that must be implemented by it's subclass.
         *
         * @param {HTMLElement} element jQuery wrapped HTMLElement.
         * @param {Rectangle} bounds Rectangular object representing the bounds of the widget.
         * @param {Boolean} active Whether the widget is in it's active state or not.
         * @param {Boolean} edited Whether the widget is currently being edited.
         * @param {Object} [changedProperties] Map of the properties that have changed. If unspecified, consider all properties as changed.
         */
        // eslint-disable-next-line no-unused-vars
        updateRendering: function updateRendering(element, bounds, active, edited, changedProperties) {},


        /**
         * @private
         *
         * Returns the default CSS to be applied initially. These styles may be overridden by subclasses.
         *
         * @return {Object} A hash of CSS values mapped to property names.
         */
        defaultCSS: function defaultCSS() {
            var css = {};

            // Handle any background color
            if (this.model.has("backgroundColor")) {
                var backgroundHex = this.model.get("backgroundColor");
                var backgroundOpacity = this.model.get("backgroundOpacity");

                if (typeof backgroundOpacity !== "number") {
                    backgroundOpacity = 1;
                }

                if (backgroundHex === "transparent" || backgroundHex === "") {
                    css.backgroundColor = "transparent";
                } else {
                    css.backgroundColor = Color.hexToRgba(backgroundHex, backgroundOpacity);
                }
            } else {
                css.background = "transparent";
            }

            return css;
        },


        /**
         * @private
         *
         * Updates the appearance/style of the widget - applying the constructed CSS to the
         * associated HTML element.
         *
         * @param  {Object} style Optional CSS object representing the default styles.
         */
        _updateAppearance: function _updateAppearance(style) {
            var rect = this.getRect();
            var rotation = this.model.get("rotation") || 0;
            var scale = this.model.get("scale");
            var css = style || {};

            if (this.model.has("width")) {
                css.width = rect.width;
            }

            if (this.model.has("height")) {
                css.height = rect.height;
            }

            if (this.model.get("scaleMode") === WidgetScaleMode.STRETCH) {
                css.scaleX = scale.x;
                css.scaleY = scale.y;
            }

            if (!this.model.get("isVisible")) {
                css.display = "none";
            } else {
                css.display = "block";
            }

            extend(css, {
                x: rect.x,
                y: rect.y,
                rotation: rotation,
                // Leave some z-index room for static elements
                zIndex: css.zIndex ? css.zIndex : this.model.get("layerIndex") + 100,
                force3D: Browser.capabilities.is3dAnimationsSupported
            });

            // avoid infinite error triggering with bad data
            if (css.boxShadow === true) {
                delete css.boxShadow;
            }
            TweenMax.set(this.el, css);

            invoke(this._animControllers, "invalidate");
        },


        // TODO: The methods below seems to deal with editor specific logic - candidate for the/a Transformable widget?
        /**
         * @private
         *
         * The 'centeredPivotPoint' property is used to initially center a
         * widget around it's coordinates (i.e. when dropped from the editor interface).
         *
         * This property is not persisted, and removed (unset) once the widget has been
         * positioned.
         *
         * @see  #_validatePosition
         *
         * @return {Boolean} <tt>true</tt> if the widget should be centered, <tt>false</tt> if not.
         */
        _centeredPivotPoint: function _centeredPivotPoint() {
            return this.model.has("centeredPivotPoint") && this.model.get("centeredPivotPoint");
        },


        /**
         * Validates the widget position according to the 'centeredPivotPoint' property.
         */
        _validatePosition: function _validatePosition() {
            var rect = this.getRect();

            // Don't handle 'centeredPivotPoint' if the rect is 'invalid'
            if (rect.width === 0 && rect.height === 0) {
                return rect;
            }

            // If the coordinates are to the center of the widget, adjust them now
            if (this._centeredPivotPoint()) {
                var experienceSize = this._experienceSize();
                var widthDelta = rect.width / experienceSize.width * 50; // Multiplied by 100 for percent, then divided by 2
                var heightDelta = rect.height / experienceSize.height * 50;

                this.model.set({
                    left: this.model.get("left") - widthDelta,
                    top: this.model.get("top") - heightDelta
                });

                // We no longer needs the property
                this.model.unset("centeredPivotPoint", { silent: true });
            }
        },


        /**
         * @private
         *
         * Sets up the effect controller, responsible for managing the hover and loop
         * effects. Passing in the animation controllers to allow any needed coupling
         * between effects and transitions.
         */
        _setupEffects: function _setupEffects() {
            if (this.options.enableAnimations && !this._effectController) {
                this._effectController = new EffectController(this, this._animControllers);
                this._effectController.setActive(this._active);
            }
        },


        /**
         * @private
         *
         * Sets up the widget zIndex. Which turns it to be over others widgets and
         * over the experience editor shadow.
         * Also it adds the box shadow, to accent highlighted widget
         * It removes boxShadow back, if unhighlighted.
         * It didn't removes the zIndex, because it will be overwritten
         * inside _updateAppearance function
         *
         * For the widgets, which has specific requirements for highlight
         * the highlight can be extended (changed) inside widget.
         * Jsut define and implement `applyWidgetSpecificHighlight` method inside.
         * (like image - it absolutely positioned over it's widget container)
         * (like text or line - it has transparent background by default)
         */
        _updateHightlight: function _updateHightlight() {
            // Update widget with corrected zIndex and border selection if highlighted
            if (this.model.get("highlighted")) {
                this._updateAppearance({
                    zIndex: 301, // From 101 starts widgets + layer index, so z-index should be calculated
                    boxShadow: "0px 0px 0px 3px #8c01ff"
                });
            } else if (this.model.get("overlapped")) {
                this._updateAppearance({
                    boxShadow: "0px 0px 0px 3px #8c01ff"
                });
            } else if (!this.model.get("borderWidth")) {
                // Remove border, if highlight is ended and there are no border applied
                this._updateAppearance({
                    boxShadow: "0px 0px 0px 0px transparent"
                });
            }
            if (typeof this.applyWidgetSpecificHighlight === "function") {
                this.applyWidgetSpecificHighlight();
            }
        },


        /**
         * Returns a <tt>Promise</tt> that represents the widget view's load state. Once
         * resolved, the widget is considered "loaded".
         *
         * The default implementation returns a resolved <tt>Promise</tt>. Widgets that rely
         * on external resources, e.g. image widgets, might wanna implement this method and
         * resolve the promise once the needed data has been fetched.
         *
         * @return {Promise} A <tt>Promise</tt> that represents the widget view's load state.
         */
        promise: function promise() {
            return Promise.resolved();
        },


        /**
         * @override
         *
         * Override to avoid some of the default rendering behavior provided by Marionette, i.e. we
         * don't want the HTML content to be cleared for each rendering cycle.
         *
         * @return {AbstractWidgetView} This instance.
         */
        render: function render() {
            // Respect the Marionette life cycle
            this.isClosed = false;

            this.triggerMethod("before:render", this);
            this.triggerMethod("item:before:render", this);

            this.bindUIElements();

            this.triggerMethod("render", this);
            this.triggerMethod("item:rendered", this);

            var rect = this.getRect();
            // Clone the changed properties, as they might not be the same when our promise is resolved
            var changed = clone(this.model.changed);

            // Update the initial appearance applying the default CSS
            this._updateAppearance(this.defaultCSS());

            // Update TabOrder highlight
            this._updateHightlight();

            // Call updateRendering to notify subclasses to update their rendering
            this._triggerUpdateRendering(this.$el, rect, this._active, this.options.edited, this._rendered ? changed : undefined);

            // Enabled options if not being edited, if not explicitly turned off, and if we have any...
            var enableActions = !this.options.edited && this.options.enableActions && this.model.isInteractive(); // TODO: why do we not only test for actions here (but also effects)?

            // Manually register click listener for triggering actions. We don't wanna use the Backbone 'events' object
            // for the sake of subclasses, and sub-classes can still listen explicitly for (jQuery) "activate"
            // event if they do *not* use actions...
            if (enableActions) {
                // still allow clicks on non-activateable actions, so we can track it!
                this.$el.off("activate");
                this.$el.on("activate", this._activate.bind(this)).css("cursor", this.model.hasActions() ? "pointer" : "auto");
            }

            // Initially hide the element - attempt to avoid flickering for elements (like text)
            // that requires a rendering cycle in the DOM before it's visual appearance is correct.
            if (this._centeredPivotPoint() || !this._rendered) {
                this.$el.css("visibility", "hidden");
            }

            if (this.model.get("isLocked")) {
                this.$el.addClass("is-locked");
            } else {
                this.$el.removeClass("is-locked");
            }

            if (this.model.get("isEditorHidden")) {
                this.$el.addClass("is-hidden");
            } else {
                this.$el.removeClass("is-hidden");
            }

            this.el.id = this.cid;

            this.el.setAttribute("data-contain-widget-uuid", this.model.get("uuid"));

            // Keep track of the rendering state
            this._rendered = true;
            return this;
        },


        /**
         * @private
         *
         * Apply an extra function if an {@link Action} is attached to the widget.
         */
        _injectActionElement: function _injectActionElement() {
            var action = this.model.get("action");

            // In order to not give responsibility to the Action with the DOM,
            // we handle the DOM logic into this class.
            if (action && !this.options.edited && this.options.enableActions) {
                var _action$getElement = action.getElement(this.el, this.model.get("title")),
                    element = _action$getElement.element,
                    isWrapper = _action$getElement.isWrapper;

                // If and element is present, then we injected into the dom.


                if (element) {
                    // Wrap all of the HTMLElement of the Widget.
                    if (isWrapper) {
                        encapsulateInnerDom(this.el, element);
                    } else {
                        this.el.appendChild(element);
                    }
                }
            }
        },


        /**
         * Tells the widget to update it's rendering, and fire an event.<p>
         *
         * @fires updatedRendering
         *
         * @param {HTMLElement} element jQuery wrapped HTMLElement.
         * @param {Rectangle} bounds Rectangular object representing the bounds of the widget.
         * @param {Boolean} active Whether the widget is in it's active state or not.
         * @param {Boolean} edited Whether the widget is currently being edited.
         * @param {Object} [changedProperties] Map of the properties that have changed. If unspecified, consider all properties as changed.
         */
        _triggerUpdateRendering: function _triggerUpdateRendering(element, bounds, active, edited, changedProperties) {
            this.updateRendering(element, bounds, active, edited, changedProperties);
            this._injectActionElement();
            this.triggerMethod("updated:rendering", this);
        },


        // Runs logic after the view is in the dom, so we can get correct bounds
        showView: function showView() {
            var _this = this;

            // Validate the position here where we know the size
            // Validate the position and appearance here where we know the size
            this._validatePosition();
            this._updateAppearance();

            // Setup animation controllers if needed
            if (this.options.enableAnimations && this._hasAnimations()) {
                // Sort all animations by delay, and make sure all initial animations are set to "render immediately"
                var sortedAnimationModels = this.model.get("animations").sortBy(function (animationModel) {
                    return animationModel.get("delay");
                });
                var minDelay = sortedAnimationModels[0].get("delay");

                this._animControllers = sortedAnimationModels.map(function (animationModel) {
                    var AnimationController = AnimationTypes.fromString(animationModel.get("type")).animationControllerClass;
                    var delay = animationModel.get("delay");
                    var immediateRender = delay === minDelay;

                    minDelay = delay;

                    return new AnimationController({
                        animationModel: animationModel,
                        widgetView: _this,
                        unscaledExperienceSize: _this._experienceSize(),
                        immediateRender: immediateRender,
                        positionOffset: result(_this.options, "getPositionOffset") || { top: 0, left: 0 }
                    });
                });

                // Start animations if needed
                if (this._active && this._startAnimationsPending) {
                    this._startAnimationsPending = false;
                    this.startAnimations();
                }
            }

            if (!this.options.edited && this.model.hasEffects()) {
                this._setupEffects();
            }

            // Make sure the element is visible at this point (see #render)
            this.$el.css("visibility", "");
        },
        onShow: function onShow() {
            // Defer to ensure we have the correct bounds
            defer(this.showView.bind(this));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(100);
    var ActionCollection = __webpack_require__(1398);
    var ActionFactory = __webpack_require__(358);
    var AnimationCollection = __webpack_require__(1407);
    var Backbone = __webpack_require__(7);
    var EffectModelCollection = __webpack_require__(1408);
    var ImprovedModel = __webpack_require__(25);
    var Scale = __webpack_require__(360);
    var WidgetScaleMode = __webpack_require__(246);

    /**
     * Base model for widgets.
     *
     * @class AbstractWidgetModel
     * @constructor
     */
    var AbstractWidgetModel = ImprovedModel.extend({

        // Implicitly also "scene: Scene" relation on every widget model because of the (reverse) relation mapping defined in Scene.js

        relations: [{
            type: Backbone.Many,
            key: "animations",
            collectionType: AnimationCollection
        }, {
            type: Backbone.Many,
            key: "effects",
            collectionType: EffectModelCollection
        }, {
            type: Backbone.One,
            key: "action",
            relatedModel: Action,
            // See http://dhruvaray.github.io/backbone-associations/specify-associations.html#sa-map
            map: function map(value) {
                // TODO: Precondition?
                // Only map for raw object representations
                return value instanceof Action ? value : ActionFactory.newActionFromType(value.type, value);
            }
        }, {
            type: Backbone.Many,
            key: "actions",
            collectionType: ActionCollection
        }],

        defaults: {

            left: 0,

            top: 0,

            rotation: 0,

            layerIndex: 0,

            /**
             * Widget opacity - the the computed 'opacity' property below.
             *
             * @type {Number}
             */
            opacity: 1,

            /**
             * Optional action to be activated by the view on interaction.
             *
             * @type {Action}
             */
            action: null,

            /**
             * @deprecated Use action instead (we only allow a single action from now on).
             *
             * @type {ActionCollection}
             */
            actions: [],

            /**
             * Array of effects to be played by the view on interaction.
             *
             * @type {EffectModelCollection}
             */
            effects: [],

            animations: [],

            /**
             * Represents the current scale of the widget. Defaults to 1.0
             *
             * @type {Scale}
             */
            scale: new Scale(),

            /**
             * Defines the sizing strategy when scaled.
             *
             * @type {String}
             */
            scaleMode: WidgetScaleMode.DEFAULT,

            /**
             * Defines the title of the element.
             *
             * @type {String}
             */
            title: "",

            isVisible: true,

            isDraggable: true,

            isLocked: false,

            isEditorHidden: false
        },

        // TODO: these are editor functionality!
        embedded: true,
        transient: ["scale", "scaleMode", "isTransforming"],

        computed: {
            scaledWidth: {
                deps: ["scale", "width"],
                value: function value(scale, width) {
                    return scale.x * width;
                }
            },

            scaledHeight: {
                deps: ["scale", "height"],
                value: function value(scale, height) {
                    return scale.y * height;
                }
            },

            scaledTop: {
                deps: ["scale", "top"],
                value: function value(scale, top) {
                    return scale.y * top;
                }
            },

            scaledLeft: {
                deps: ["scale", "left"],
                value: function value(scale, left) {
                    return scale.x * left;
                }
            },

            // HACK: Regardless of persisted 'opacity', we force the 'opacity' value to 1.0 (due to legacy widget opacity values - see MOS-2375)
            // Remove this once we're comfortable.
            //
            // See ShapeWidgetModel for how to implement 'opacity' support...
            opacity: {
                deps: ["opacity"],
                value: function value() {
                    return 1.0;
                }
            }
        },

        hasActions: function hasActions() {
            return this.has("action") || this.get("actions").length !== 0;
        },


        /**
         * Returns true if this model has any activateable actions, false otherwise. <p>
         *
         * An activateable Action is an action whose <tt>action.activateable(..)</tt> method returns true.
         *
         * @param  {ExperienceViewModel} experienceViewModel The experience view model; can be falsey in which case
         *                                                   false is returned.
         * @return {Boolean} True if this model has any activateable actions, false otherwise.
         * @see    Action#activateable
         */
        hasActivateableActions: function hasActivateableActions(experienceViewModel) {
            var action = this.get("action");
            if (action) {
                return action.activateable(experienceViewModel);
            }
            // Legacy collection of actions...
            var actions = this.get("actions");
            var i = actions.length;

            while (i--) {
                if (actions.at(i).activateable(experienceViewModel)) {
                    return true;
                }
            }
            return !!experienceViewModel;
        },
        hasEffects: function hasEffects() {
            return this.get("effects").length !== 0;
        },


        /**
         * Whether the widget is considered interactive, i.e. contains (activateable) actions or effects. <p>
         *
         * If an <tt>ExperienceViewModel</tt> is supplied as argument, actions, if any, will be tested for whether
         * or not they are currently activateable or not.
         *
         * @param  {ExperienceViewModel} [experienceViewModel] The experience view model; can be falsey, in which
         *                                                     case this function only test for the presence of
         *                                                     actions on this model, not if such actions are
         *                                                     considered activateable or not.
         *
         * @return {Boolean} <tt>true</tt> if the widget contains any actions or effects, <tt>false</tt> if not.
         */
        isInteractive: function isInteractive(experienceViewModel) {
            return this.hasEffects() || (experienceViewModel ? this.hasActivateableActions(experienceViewModel) : this.hasActions());
        },


        /**
         * Given a set of widgets from a scene, return all widgets that are siblings
         * of this one within a widget group. Include the widget itself.
         * @param sceneWidgets
         */
        getGroupSiblings: function getGroupSiblings(sceneWidgets) {
            var _this = this;

            var siblings = null;
            sceneWidgets.forEach(function (widget) {
                if (widget.has("group")) {
                    if (widget.get("group").models.map(function (widget) {
                        return widget.get("uuid");
                    }).includes(_this.get("uuid"))) {
                        siblings = widget.get("group");
                    }
                }
            });
            return siblings;
        },
        getScaledSize: function getScaledSize(scaleX, scaleY) {
            var size = {};

            if (this.has("width")) {
                size.width = this.get("width") * scaleX;
            }

            if (this.has("height")) {
                size.height = this.get("height") * (scaleY || scaleX);
            }

            return size;
        },


        /**
         * Whether the widget model is considered to be in a "valid" state.
         *
         * E.g. a text based widget might be "invalid" if the text property is blank.
         *
         * Be default, all widget models are considered valid.
         *
         * @return {Boolean} <tt>true</tt> if the widget is considered valid, <tt>false</tt> if not.
         */
        isValid: function isValid() {
            return true;
        }
    });

    return AbstractWidgetModel;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);

    /**
     * Abstract properties view to handle shared functionality.
     *
     * @class PropertiesView
     * @constructor
     *
     * @cfg {WidgetModel} model The model for the widget being edited.
     */
    return ImprovedView.extend({
        expandProperty: null,

        _$accordionControl: null,
        _$accordionTarget: null,

        _shouldExpandOnRender: function _shouldExpandOnRender() {
            if ("shouldExpandOnRender" in this.options) {
                return this.options.shouldExpandOnRender;
            }
            return this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty];
        },
        _accordionControlsExist: function _accordionControlsExist() {
            return this._$accordionControl && this._$accordionControl.length > 0;
        },
        onRender: function onRender() {
            this.__super();
            this._$accordionControl = this.$el.find(".collapsible[data-target]");

            if (this._accordionControlsExist()) {
                this._$accordionTarget = this.$el.find(this._$accordionControl.data("target"));
            }
        },
        onShow: function onShow() {
            var _this = this;

            if (!this._accordionControlsExist()) {
                return;
            }
            this._$accordionTarget.on("show.bs.collapse", function () {
                _this._$accordionControl.toggleClass("collapsed", false);
            });

            this._$accordionTarget.on("hide.bs.collapse", function () {
                _this._$accordionControl.toggleClass("collapsed", true);
            });

            if (this._shouldExpandOnRender()) {
                this._$accordionTarget.collapse("show");
            }
        },
        onBeforeClose: function onBeforeClose() {
            if (this._accordionControlsExist()) {
                this._$accordionTarget.off("show.bs.collapse hide.bs.collapse shown.bs.collapse hidden.bs.collapse");

                if (this.expandProperty) {
                    this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] = this._$accordionTarget.hasClass("in");
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Enum = __webpack_require__(77);

    /**
     * Enumeration representing the state of a <i>publishable</i> entity, e.g. an experience, where the <tt>value</tt> is equal
     * to <tt>experienceModel.get("state")</tt>.
     *
     * @see ExperienceModel
     * @see GroupModel
     *
     * @class PublishableState
     * @author Kim
     */
    var PublishableState = Enum.create("PublishableState", "value", {
        DELETED: {
            value: "Deleted",
            displayName: "Deleted"
        },

        INACTIVE: {
            value: "Inactive",
            displayName: "Inactive"
        },

        NOT_PUSHED: {
            value: "NotPushed",
            displayName: "Not pushed"
        },

        PUSHED: {
            value: "Pushed",
            displayName: "Pushed"
        },

        SCHEDULED: {
            value: "Scheduled",
            displayName: "Scheduled"
        },

        PUBLISHED: {
            value: "Published",
            displayName: "Published"
        }
    }, {
        /**
         * Compares the specified states for order, and returns the greatest.<p>
         *
         * If they're equal, the state is returned.
         *
         * @param  {PublishableState|String|Number} a The first state to compare.
         * @param  {PublishableState|String|Number} b The second state to compare.
         *
         * @return {PublishableState} The greatest state, as a <tt>PublishableState</tt> enum.
         */
        greatest: function greatest(a, b) {
            var enumA = PublishableState.getEnum(a);
            var enumB = PublishableState.getEnum(b);

            return enumA._ordinal > enumB._ordinal ? enumA : enumB;
        },
        atLeast: function atLeast(a, b) {
            var enumA = PublishableState.getEnum(a);
            var enumB = PublishableState.getEnum(b);

            return enumA._ordinal >= enumB._ordinal;
        },


        /**
         * Returns the matching enumeration from the specified value. If no enumeration matched, <tt>NOT_PUSHED</tt> is returned.<p>
         *
         * <pre>
         * PublishableState.getEnum(INACTIVE);          // INACTIVE
         * PublishableState.getEnum(INACTIVE.value);    // INACTIVE
         * PublishableState.getEnum(INACTIVE._ordinal); // INACTIVE
         * PublishableState.getEnum(0);                 // INACTIVE
         * PublishableState.getEnum("Published");       // PUBLISHED
         * PublishableState.getEnum(42);                // NOT_PUSHED
         * PublishableState.getEnum("gro");             // NOT_PUSHED
         * </pre>
         *
         * @param  {PublishableState|String|Number} value Either the raw string value, e.g. <tt>"Inactive"</tt> or <tt>INACTIVE.value</tt>, the
         *                                                numeric ordinal value, e.g. <tt>0</tt> or for convenience, a
         *                                                valid <tt>PublishableState</tt> enum.
         *
         * @return {PublishableState}                     The matching enumeration or <tt>NOT_PUSHED</tt> if no enumeration matched.
         */
        getEnum: function getEnum(value) {
            return PublishableState.lookup(value, PublishableState.NOT_PUSHED);
        }
    });

    return PublishableState;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(315);



function useTheme() {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["f" /* useTheme */])() || __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */];

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var PointerEvents = __webpack_require__(1128);
var HAS_SHADOW = 'hasShadow';
var SHADOW_RGBA = 'shadowRGBA';
var patternImage = 'patternImage';
var linearGradient = 'linearGradient';
var radialGradient = 'radialGradient';
var dummyContext;
function getDummyContext() {
    if (dummyContext) {
        return dummyContext;
    }
    dummyContext = Util_1.Util.createCanvasElement().getContext('2d');
    return dummyContext;
}
exports.shapes = {};
function _fillFunc(context) {
    context.fill();
}
function _strokeFunc(context) {
    context.stroke();
}
function _fillFuncHit(context) {
    context.fill();
}
function _strokeFuncHit(context) {
    context.stroke();
}
function _clearHasShadowCache() {
    this._clearCache(HAS_SHADOW);
}
function _clearGetShadowRGBACache() {
    this._clearCache(SHADOW_RGBA);
}
function _clearFillPatternCache() {
    this._clearCache(patternImage);
}
function _clearLinearGradientCache() {
    this._clearCache(linearGradient);
}
function _clearRadialGradientCache() {
    this._clearCache(radialGradient);
}
var Shape = (function (_super) {
    __extends(Shape, _super);
    function Shape(config) {
        var _this = _super.call(this, config) || this;
        var key;
        while (true) {
            key = Util_1.Util.getRandomColor();
            if (key && !(key in exports.shapes)) {
                break;
            }
        }
        _this.colorKey = key;
        exports.shapes[key] = _this;
        return _this;
    }
    Shape.prototype.getContext = function () {
        return this.getLayer().getContext();
    };
    Shape.prototype.getCanvas = function () {
        return this.getLayer().getCanvas();
    };
    Shape.prototype.getSceneFunc = function () {
        return this.attrs.sceneFunc || this['_sceneFunc'];
    };
    Shape.prototype.getHitFunc = function () {
        return this.attrs.hitFunc || this['_hitFunc'];
    };
    Shape.prototype.hasShadow = function () {
        return this._getCache(HAS_SHADOW, this._hasShadow);
    };
    Shape.prototype._hasShadow = function () {
        return (this.shadowEnabled() &&
            this.shadowOpacity() !== 0 &&
            !!(this.shadowColor() ||
                this.shadowBlur() ||
                this.shadowOffsetX() ||
                this.shadowOffsetY()));
    };
    Shape.prototype._getFillPattern = function () {
        return this._getCache(patternImage, this.__getFillPattern);
    };
    Shape.prototype.__getFillPattern = function () {
        if (this.fillPatternImage()) {
            var ctx = getDummyContext();
            var pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || 'repeat');
            return pattern;
        }
    };
    Shape.prototype._getLinearGradient = function () {
        return this._getCache(linearGradient, this.__getLinearGradient);
    };
    Shape.prototype.__getLinearGradient = function () {
        var colorStops = this.fillLinearGradientColorStops();
        if (colorStops) {
            var ctx = getDummyContext();
            var start = this.fillLinearGradientStartPoint();
            var end = this.fillLinearGradientEndPoint();
            var grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for (var n = 0; n < colorStops.length; n += 2) {
                grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            return grd;
        }
    };
    Shape.prototype._getRadialGradient = function () {
        return this._getCache(radialGradient, this.__getRadialGradient);
    };
    Shape.prototype.__getRadialGradient = function () {
        var colorStops = this.fillRadialGradientColorStops();
        if (colorStops) {
            var ctx = getDummyContext();
            var start = this.fillRadialGradientStartPoint();
            var end = this.fillRadialGradientEndPoint();
            var grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for (var n = 0; n < colorStops.length; n += 2) {
                grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            return grd;
        }
    };
    Shape.prototype.getShadowRGBA = function () {
        return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
    };
    Shape.prototype._getShadowRGBA = function () {
        if (this.hasShadow()) {
            var rgba = Util_1.Util.colorToRGBA(this.shadowColor());
            return ('rgba(' +
                rgba.r +
                ',' +
                rgba.g +
                ',' +
                rgba.b +
                ',' +
                rgba.a * (this.shadowOpacity() || 1) +
                ')');
        }
    };
    Shape.prototype.hasFill = function () {
        var _this = this;
        return this._calculate('hasFill', [
            'fillEnabled',
            'fill',
            'fillPatternImage',
            'fillLinearGradientColorStops',
            'fillRadialGradientColorStops',
        ], function () {
            return (_this.fillEnabled() &&
                !!(_this.fill() ||
                    _this.fillPatternImage() ||
                    _this.fillLinearGradientColorStops() ||
                    _this.fillRadialGradientColorStops()));
        });
    };
    Shape.prototype.hasStroke = function () {
        var _this = this;
        return this._calculate('hasStroke', [
            'strokeEnabled',
            'strokeWidth',
            'stroke',
            'strokeLinearGradientColorStops',
        ], function () {
            return (_this.strokeEnabled() &&
                _this.strokeWidth() &&
                !!(_this.stroke() || _this.strokeLinearGradientColorStops()));
        });
    };
    Shape.prototype.hasHitStroke = function () {
        var width = this.hitStrokeWidth();
        if (width === 'auto') {
            return this.hasStroke();
        }
        return this.strokeEnabled() && !!width;
    };
    Shape.prototype.intersects = function (point) {
        var stage = this.getStage(), bufferHitCanvas = stage.bufferHitCanvas, p;
        bufferHitCanvas.getContext().clear();
        this.drawHit(bufferHitCanvas);
        p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
        return p[3] > 0;
    };
    Shape.prototype.destroy = function () {
        Node_1.Node.prototype.destroy.call(this);
        delete exports.shapes[this.colorKey];
        delete this.colorKey;
        return this;
    };
    Shape.prototype._useBufferCanvas = function (forceFill) {
        var _a;
        if (!this.getStage()) {
            return false;
        }
        var perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
        if (!perfectDrawEnabled) {
            return false;
        }
        var hasFill = forceFill || this.hasFill();
        var hasStroke = this.hasStroke();
        var isTransparent = this.getAbsoluteOpacity() !== 1;
        if (hasFill && hasStroke && isTransparent) {
            return true;
        }
        var hasShadow = this.hasShadow();
        var strokeForShadow = this.shadowForStrokeEnabled();
        if (hasFill && hasStroke && hasShadow && strokeForShadow) {
            return true;
        }
        return false;
    };
    Shape.prototype.setStrokeHitEnabled = function (val) {
        Util_1.Util.warn('strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.');
        if (val) {
            this.hitStrokeWidth('auto');
        }
        else {
            this.hitStrokeWidth(0);
        }
    };
    Shape.prototype.getStrokeHitEnabled = function () {
        if (this.hitStrokeWidth() === 0) {
            return false;
        }
        else {
            return true;
        }
    };
    Shape.prototype.getSelfRect = function () {
        var size = this.size();
        return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height,
        };
    };
    Shape.prototype.getClientRect = function (attrs) {
        attrs = attrs || {};
        var skipTransform = attrs.skipTransform;
        var relativeTo = attrs.relativeTo;
        var fillRect = this.getSelfRect();
        var applyStroke = !attrs.skipStroke && this.hasStroke();
        var strokeWidth = (applyStroke && this.strokeWidth()) || 0;
        var fillAndStrokeWidth = fillRect.width + strokeWidth;
        var fillAndStrokeHeight = fillRect.height + strokeWidth;
        var applyShadow = !attrs.skipShadow && this.hasShadow();
        var shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
        var shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
        var preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
        var preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
        var blurRadius = (applyShadow && this.shadowBlur()) || 0;
        var width = preWidth + blurRadius * 2;
        var height = preHeight + blurRadius * 2;
        var roundingOffset = 0;
        if (Math.round(strokeWidth / 2) !== strokeWidth / 2) {
            roundingOffset = 1;
        }
        var rect = {
            width: width + roundingOffset,
            height: height + roundingOffset,
            x: -Math.round(strokeWidth / 2 + blurRadius) +
                Math.min(shadowOffsetX, 0) +
                fillRect.x,
            y: -Math.round(strokeWidth / 2 + blurRadius) +
                Math.min(shadowOffsetY, 0) +
                fillRect.y,
        };
        if (!skipTransform) {
            return this._transformedRect(rect, relativeTo);
        }
        return rect;
    };
    Shape.prototype.drawScene = function (can, top) {
        var layer = this.getLayer(), canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow(), stage, bufferCanvas, bufferContext;
        var caching = canvas.isCache;
        var skipBuffer = canvas.isCache;
        var cachingSelf = top === this;
        if (!this.isVisible() && !caching) {
            return this;
        }
        if (cachedCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) {
            return this;
        }
        context.save();
        if (this._useBufferCanvas() && !skipBuffer) {
            stage = this.getStage();
            bufferCanvas = stage.bufferCanvas;
            bufferContext = bufferCanvas.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            var o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            var ratio = bufferCanvas.pixelRatio;
            if (hasShadow) {
                context._applyShadow(this);
            }
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
            context.drawImage(bufferCanvas._canvas, 0, 0, bufferCanvas.width / ratio, bufferCanvas.height / ratio);
        }
        else {
            context._applyLineJoin(this);
            if (!cachingSelf) {
                var o = this.getAbsoluteTransform(top).getMatrix();
                context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
                context._applyOpacity(this);
                context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) {
                context._applyShadow(this);
            }
            drawFunc.call(this, context, this);
        }
        context.restore();
        return this;
    };
    Shape.prototype.drawHit = function (can, top) {
        if (!this.shouldDrawHit(top)) {
            return this;
        }
        var layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (!this.colorKey) {
            console.log(this);
            Util_1.Util.warn('Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. See the shape in logs above. If you want to reuse shape you should call remove() instead of destroy()');
        }
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
        }
        if (!drawFunc) {
            return this;
        }
        context.save();
        context._applyLineJoin(this);
        var selfCache = this === top;
        if (!selfCache) {
            var o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        }
        drawFunc.call(this, context, this);
        context.restore();
        return this;
    };
    Shape.prototype.drawHitFromCache = function (alphaThreshold) {
        if (alphaThreshold === void 0) { alphaThreshold = 0; }
        var cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight(), hitImageData, hitData, len, rgbColorKey, i, alpha;
        hitContext.clear();
        hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
        try {
            hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            hitData = hitImageData.data;
            len = hitData.length;
            rgbColorKey = Util_1.Util._hexToRgb(this.colorKey);
            for (i = 0; i < len; i += 4) {
                alpha = hitData[i + 3];
                if (alpha > alphaThreshold) {
                    hitData[i] = rgbColorKey.r;
                    hitData[i + 1] = rgbColorKey.g;
                    hitData[i + 2] = rgbColorKey.b;
                    hitData[i + 3] = 255;
                }
                else {
                    hitData[i + 3] = 0;
                }
            }
            hitContext.putImageData(hitImageData, 0, 0);
        }
        catch (e) {
            Util_1.Util.error('Unable to draw hit graph from cached scene canvas. ' + e.message);
        }
        return this;
    };
    Shape.prototype.hasPointerCapture = function (pointerId) {
        return PointerEvents.hasPointerCapture(pointerId, this);
    };
    Shape.prototype.setPointerCapture = function (pointerId) {
        PointerEvents.setPointerCapture(pointerId, this);
    };
    Shape.prototype.releaseCapture = function (pointerId) {
        PointerEvents.releaseCapture(pointerId, this);
    };
    return Shape;
}(Node_1.Node));
exports.Shape = Shape;
Shape.prototype._fillFunc = _fillFunc;
Shape.prototype._strokeFunc = _strokeFunc;
Shape.prototype._fillFuncHit = _fillFuncHit;
Shape.prototype._strokeFuncHit = _strokeFuncHit;
Shape.prototype._centroid = false;
Shape.prototype.nodeType = 'Shape';
Global_1._registerNode(Shape);
Shape.prototype.eventListeners = {};
Shape.prototype.on.call(Shape.prototype, 'shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', _clearHasShadowCache);
Shape.prototype.on.call(Shape.prototype, 'shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva', _clearGetShadowRGBACache);
Shape.prototype.on.call(Shape.prototype, 'fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva', _clearFillPatternCache);
Shape.prototype.on.call(Shape.prototype, 'fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva', _clearLinearGradientCache);
Shape.prototype.on.call(Shape.prototype, 'fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva', _clearRadialGradientCache);
Factory_1.Factory.addGetterSetter(Shape, 'stroke', undefined, Validators_1.getStringValidator());
Factory_1.Factory.addGetterSetter(Shape, 'strokeWidth', 2, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Shape, 'hitStrokeWidth', 'auto', Validators_1.getNumberOrAutoValidator());
Factory_1.Factory.addGetterSetter(Shape, 'strokeHitEnabled', true, Validators_1.getBooleanValidator());
Factory_1.Factory.addGetterSetter(Shape, 'perfectDrawEnabled', true, Validators_1.getBooleanValidator());
Factory_1.Factory.addGetterSetter(Shape, 'shadowForStrokeEnabled', true, Validators_1.getBooleanValidator());
Factory_1.Factory.addGetterSetter(Shape, 'lineJoin');
Factory_1.Factory.addGetterSetter(Shape, 'lineCap');
Factory_1.Factory.addGetterSetter(Shape, 'sceneFunc');
Factory_1.Factory.addGetterSetter(Shape, 'hitFunc');
Factory_1.Factory.addGetterSetter(Shape, 'dash');
Factory_1.Factory.addGetterSetter(Shape, 'dashOffset', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Shape, 'shadowColor', undefined, Validators_1.getStringValidator());
Factory_1.Factory.addGetterSetter(Shape, 'shadowBlur', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Shape, 'shadowOpacity', 1, Validators_1.getNumberValidator());
Factory_1.Factory.addComponentsGetterSetter(Shape, 'shadowOffset', ['x', 'y']);
Factory_1.Factory.addGetterSetter(Shape, 'shadowOffsetX', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Shape, 'shadowOffsetY', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Shape, 'fillPatternImage');
Factory_1.Factory.addGetterSetter(Shape, 'fill', undefined, Validators_1.getStringValidator());
Factory_1.Factory.addGetterSetter(Shape, 'fillPatternX', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Shape, 'fillPatternY', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Shape, 'fillLinearGradientColorStops');
Factory_1.Factory.addGetterSetter(Shape, 'strokeLinearGradientColorStops');
Factory_1.Factory.addGetterSetter(Shape, 'fillRadialGradientStartRadius', 0);
Factory_1.Factory.addGetterSetter(Shape, 'fillRadialGradientEndRadius', 0);
Factory_1.Factory.addGetterSetter(Shape, 'fillRadialGradientColorStops');
Factory_1.Factory.addGetterSetter(Shape, 'fillPatternRepeat', 'repeat');
Factory_1.Factory.addGetterSetter(Shape, 'fillEnabled', true);
Factory_1.Factory.addGetterSetter(Shape, 'strokeEnabled', true);
Factory_1.Factory.addGetterSetter(Shape, 'shadowEnabled', true);
Factory_1.Factory.addGetterSetter(Shape, 'dashEnabled', true);
Factory_1.Factory.addGetterSetter(Shape, 'strokeScaleEnabled', true);
Factory_1.Factory.addGetterSetter(Shape, 'fillPriority', 'color');
Factory_1.Factory.addComponentsGetterSetter(Shape, 'fillPatternOffset', ['x', 'y']);
Factory_1.Factory.addGetterSetter(Shape, 'fillPatternOffsetX', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Shape, 'fillPatternOffsetY', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addComponentsGetterSetter(Shape, 'fillPatternScale', ['x', 'y']);
Factory_1.Factory.addGetterSetter(Shape, 'fillPatternScaleX', 1, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Shape, 'fillPatternScaleY', 1, Validators_1.getNumberValidator());
Factory_1.Factory.addComponentsGetterSetter(Shape, 'fillLinearGradientStartPoint', [
    'x',
    'y',
]);
Factory_1.Factory.addComponentsGetterSetter(Shape, 'strokeLinearGradientStartPoint', [
    'x',
    'y',
]);
Factory_1.Factory.addGetterSetter(Shape, 'fillLinearGradientStartPointX', 0);
Factory_1.Factory.addGetterSetter(Shape, 'strokeLinearGradientStartPointX', 0);
Factory_1.Factory.addGetterSetter(Shape, 'fillLinearGradientStartPointY', 0);
Factory_1.Factory.addGetterSetter(Shape, 'strokeLinearGradientStartPointY', 0);
Factory_1.Factory.addComponentsGetterSetter(Shape, 'fillLinearGradientEndPoint', [
    'x',
    'y',
]);
Factory_1.Factory.addComponentsGetterSetter(Shape, 'strokeLinearGradientEndPoint', [
    'x',
    'y',
]);
Factory_1.Factory.addGetterSetter(Shape, 'fillLinearGradientEndPointX', 0);
Factory_1.Factory.addGetterSetter(Shape, 'strokeLinearGradientEndPointX', 0);
Factory_1.Factory.addGetterSetter(Shape, 'fillLinearGradientEndPointY', 0);
Factory_1.Factory.addGetterSetter(Shape, 'strokeLinearGradientEndPointY', 0);
Factory_1.Factory.addComponentsGetterSetter(Shape, 'fillRadialGradientStartPoint', [
    'x',
    'y',
]);
Factory_1.Factory.addGetterSetter(Shape, 'fillRadialGradientStartPointX', 0);
Factory_1.Factory.addGetterSetter(Shape, 'fillRadialGradientStartPointY', 0);
Factory_1.Factory.addComponentsGetterSetter(Shape, 'fillRadialGradientEndPoint', [
    'x',
    'y',
]);
Factory_1.Factory.addGetterSetter(Shape, 'fillRadialGradientEndPointX', 0);
Factory_1.Factory.addGetterSetter(Shape, 'fillRadialGradientEndPointY', 0);
Factory_1.Factory.addGetterSetter(Shape, 'fillPatternRotation', 0);
Factory_1.Factory.backCompat(Shape, {
    dashArray: 'dash',
    getDashArray: 'getDash',
    setDashArray: 'getDash',
    drawFunc: 'sceneFunc',
    getDrawFunc: 'getSceneFunc',
    setDrawFunc: 'setSceneFunc',
    drawHitFunc: 'hitFunc',
    getDrawHitFunc: 'getHitFunc',
    setDrawHitFunc: 'setHitFunc',
});
Util_1.Collection.mapMethods(Shape);


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ButtonWidgetView = __webpack_require__(768);
    var ButtonWidgetModel = __webpack_require__(305);
    var CompositeWidgetModel = __webpack_require__(173);
    var CompositeWidgetView = __webpack_require__(503);
    var SalesforceCommerceWidgetModel = __webpack_require__(368);
    var SalesforceCommerceWidgetView = __webpack_require__(780);
    var EmbedWidgetModel = __webpack_require__(505);
    var EmbedWidgetView = __webpack_require__(781);
    var HTMLWidgetView = __webpack_require__(506);
    var HTMLWidgetModel = __webpack_require__(782);
    var Enum = __webpack_require__(77);
    var ImageWidgetModel = __webpack_require__(249);
    var ImageWidgetView = __webpack_require__(507);
    var LineWidgetModel = __webpack_require__(508);
    var LineWidgetView = __webpack_require__(509);
    var LinkWidgetModel = __webpack_require__(510);
    var LinkWidgetView = __webpack_require__(783);
    var ProductWidgetModel = __webpack_require__(511);
    var ProductWidgetView = __webpack_require__(784);
    var SceneNavigatorWidgetModel = __webpack_require__(512);
    var SceneNavigatorWidgetView = __webpack_require__(513);
    var ShapeWidgetModel = __webpack_require__(514);
    var ShapeWidgetView = __webpack_require__(785);
    var SocialSharingWidgetModel = __webpack_require__(515);
    var SocialSharingWidgetView = __webpack_require__(516);
    var TextEnhancedWidgetModel = __webpack_require__(367);
    var TextEnhancedWidgetView = __webpack_require__(518);
    var TextWidgetModel = __webpack_require__(366);
    var TextWidgetView = __webpack_require__(369);
    var YoutubeWidgetModel = __webpack_require__(519);
    var YoutubeWidgetView = __webpack_require__(787);
    var DynamicProductWidgetModel = __webpack_require__(520);
    var DynamicProductWidgetView = __webpack_require__(521);

    /**
     * An enumeration declaring all supported Widget types for the Editor. There is another class filling the same role
     * for the viewer. When adding a new widget to this enum also add it to the ViewerWidgetTypes enum.
     *
     * @class {WidgetTypes}
     */
    return Enum.create("WidgetType", "id", {
        BUTTON: {
            id: "button",
            viewClass: ButtonWidgetView,
            modelClass: ButtonWidgetModel
        },
        COMPOSITE: {
            id: "composite",
            viewClass: CompositeWidgetView,
            modelClass: CompositeWidgetModel
        },
        SALESFORCE_COMMERCE: {
            // Demandware is the old name for Salesforce Commerce Cloud.
            // The Api still returns the 'demandware' object and it would fail if this is refactored to salesforce-commerce.
            // AS long as the DB name is 'demandware' the id has to be same.
            id: "demandware",
            viewClass: SalesforceCommerceWidgetView,
            modelClass: SalesforceCommerceWidgetModel
        },
        EMBED: {
            id: "embed",
            viewClass: EmbedWidgetView,
            modelClass: EmbedWidgetModel
        },
        HTML: {
            id: "html",
            viewClass: HTMLWidgetView,
            modelClass: HTMLWidgetModel
        },
        IMAGE: {
            id: "image",
            viewClass: ImageWidgetView,
            modelClass: ImageWidgetModel
        },
        LINE: {
            id: "line",
            viewClass: LineWidgetView,
            modelClass: LineWidgetModel
        },
        LINK: {
            id: "link",
            viewClass: LinkWidgetView,
            modelClass: LinkWidgetModel
        },
        NEXT_SCENE: {
            id: "next-scene",
            viewClass: ImageWidgetView,
            modelClass: ImageWidgetModel
        },
        PREVIOUS_SCENE: {
            id: "previous-scene",
            viewClass: ImageWidgetView,
            modelClass: ImageWidgetModel
        },
        PRODUCT: {
            id: ProductWidgetModel.TYPE,
            viewClass: ProductWidgetView,
            modelClass: ProductWidgetModel
        },
        SCENE_NAVIGATOR: {
            id: "scene-navigator",
            viewClass: SceneNavigatorWidgetView,
            modelClass: SceneNavigatorWidgetModel
        },
        SHAPE: {
            id: "shape",
            viewClass: ShapeWidgetView,
            modelClass: ShapeWidgetModel
        },
        SOCIAL_SHARING: {
            id: "social-sharing",
            viewClass: SocialSharingWidgetView,
            modelClass: SocialSharingWidgetModel
        },
        TEXT: {
            id: "text",
            viewClass: TextWidgetView,
            modelClass: TextWidgetModel
        },
        // The view and model class for this widget is different then the viewer.
        TEXT_ENHANCED: {
            id: "text-enhanced",
            viewClass: TextEnhancedWidgetView,
            modelClass: TextEnhancedWidgetModel
        },
        YOUTUBE: {
            id: "youtube",
            viewClass: YoutubeWidgetView,
            modelClass: YoutubeWidgetModel
        },
        DYNAMIC_PRODUCT: {
            id: "dynamic-product",
            viewClass: DynamicProductWidgetView,
            modelClass: DynamicProductWidgetModel
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defer = _require.defer,
        extend = _require.extend;

    var EditorConstants = __webpack_require__(522);
    var WidgetGroup = __webpack_require__(401);
    var EditorEvents = __webpack_require__(17);
    var MathUtil = __webpack_require__(72).default;
    var Preconditions = __webpack_require__(14);
    var template = __webpack_require__(1754);

    var _require2 = __webpack_require__(30),
        camelize = _require2.camelize;

    var AbstractWidgetPropertiesView = __webpack_require__(63);

    var _require3 = __webpack_require__(34),
        Session = _require3.Session,
        Keys = _require3.Keys;

    var Distribution = __webpack_require__(1755);
    var Alignment = __webpack_require__(872);

    var EXPAND_PROPERTY = "sizeAndPositionExpanded";
    var ALIGNED_TO_SCENE_STORAGE = "alignToScene";

    var compareByLowestLayerIndex = function compareByLowestLayerIndex(a, b) {
        return a.get("layerIndex") > b.get("layerIndex");
    };
    var compareByHighestLayerIndex = function compareByHighestLayerIndex(a, b) {
        return a.get("layerIndex") < b.get("layerIndex");
    };

    /**
     * The properties view for size and position information.
     *
     * @class SizeAndPositionPropertiesView
     * @constructor
     *
     * @cfg {AbstractWidgetModel} model The widget being edited.
     * @cfg {boolean} [hideSizeControls] If true, the size controls will be hidden.
     * @cfg {boolean} [hideRotation] If true, the rotation control will be hidden.
     */
    return AbstractWidgetPropertiesView.extend({
        expandProperty: EXPAND_PROPERTY,

        _experience: null,

        positionInputChanged: false,
        dimensionsInputChanged: false,
        rotationInputChanged: false,

        template: template,

        ui: {
            container: ".size-position-properties",
            legend: "[data-target=\".size-position-properties\"]",
            alignToScene: ".align-to-scene",
            alignToSceneContainer: ".align-to-scene-container",
            fitToScene: ".fit-to-scene",
            rotation: ".rotation",
            grouping: ".grouping",
            groupButton: ".grouping__group",
            ungroupButton: ".grouping__ungroup",
            arrangeControls: ".arrange-controls",
            alignControls: ".align-controls"
        },

        bindings: {
            ".left": {
                observe: "left",
                onGet: "onGet",
                onSet: "onSet"
            },
            ".top": {
                observe: "top",
                onGet: "onGet",
                onSet: "onSet"
            },
            ".width": {
                observe: "width",
                onGet: "onGet",
                onSet: "onSet"
            },
            ".height": {
                observe: "height",
                onGet: "onGet",
                onSet: "onSet"
            },
            ".rotation": {
                observe: "rotation",
                onGet: "_parseRotation",
                onSet: "onSet"
            }
        },

        events: {
            "click .fit-to-scene": "_fitToScene",
            "keyup .rotation": "_changeRotation",
            "click @ui.groupButton": "_groupingHandler",
            "click @ui.ungroupButton": "_ungroupingHandler",
            "change .align-to-scene": "_alignToSceneChangeHandler"
        },

        templateHelpers: function templateHelpers() {
            return {
                showSizeControls: !this.options.hideSizeControls,
                showRotation: !this.options.hideRotation,
                showLineControls: !!this.options.showLineControls,
                showWidthControls: this.options.showWidthControls,
                showGroupingControls: !this.options.hideGrouping,
                editorConstants: EditorConstants
            };
        },
        onGet: function onGet(value, options) {
            switch (options.observe) {
                case "left":
                case "width":
                    return MathUtil.round(value * this._experience.get("width") / 100, 0);
                case "top":
                case "height":
                    return MathUtil.round(value * this._experience.get("height") / 100, 0);
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Position '" + options.observe + "' not recognized.");
                    break;
            }
        },
        onSet: function onSet(value, options) {
            this._trackingChanges(options.observe);
            switch (options.observe) {
                case "left":
                case "width":
                    return MathUtil.roundToContain(value / this._experience.get("width") * 100, this._experience.get("width"));
                case "top":
                case "height":
                    return MathUtil.roundToContain(value / this._experience.get("height") * 100, this._experience.get("height"));
                case "rotation":
                    return Number(value);
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Position '" + options.observe + "' not recognized.");
                    break;
            }
        },
        _trackingChanges: function _trackingChanges(type) {
            switch (type) {
                case "left":
                case "top":
                    this.positionInputChanged = true;
                    break;
                case "width":
                case "height":
                    this.dimensionsInputChanged = true;
                    break;
                case "rotation":
                    this.rotationInputChanged = true;
                    break;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Position '" + type + "' not recognized.");
                    break;
            }
        },
        _fitToScene: function _fitToScene() {
            this.model.fitToScene(this._experience);
            this._triggerEventFitToScene();
        },


        /**
         * @private
         *
         * Sends an event to MixPanel when a there's a click on the button Fit proportionally.
         * @fires EditorEvents#update:widget
         * @type {Object}
         * @property {String} widgetType                The type of the widget.
         * @property {String} updatedProperty           The property of the widget which has been modified.
         * @property {Number} experienceId              The experience id.
         * @property {Number} experienceVersion         The experience version.
         * @property {Number} experiencePushedVersion   The experience pushed version sceneNumber.
         * @property {Number} sceneNumber               The scene number.
         * @property {String} triggerOrigin             The origin of the event.
         */
        _triggerEventFitToScene: function _triggerEventFitToScene() {
            var viewModel = this.viewScope.viewModel;
            var eventProperties = {
                widgetType: this.model.get("type"),
                updatedProperty: "fitProportionally",
                experienceId: this._experience.get("id"),
                experienceVersion: this._experience.get("version"),
                experiencePushedVersion: this._experience.get("pushedVersion"),
                sceneNumber: viewModel.get("sceneNumber"),
                triggerOrigin: "WidgetMenuFitProportionallyButton"
            };

            EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
        },


        /**
         * Handler when the rotation input changes
         *
         * @param {JQuery<Event>} event - The event information when rotation input field is modified.
         */
        _changeRotation: function _changeRotation(event) {
            var position = this._experience.getPercentagePosition(this._calculateNewPosition(event.target.value));

            this.model.set({
                left: position.left,
                top: position.top
            });
        },


        /**
         * Parses the rotation value.
         */
        _parseRotation: function _parseRotation(value) {
            var parsedValue = value;
            if (value < 0) {
                parsedValue += 360;
            }
            if (value > 360) {
                parsedValue -= 360;
            }
            return MathUtil.round(parsedValue, 1);
        },


        /**
         * When rotating the widget from the sidebar, we need to recalculate a
         * new position for it. This is done by calculating the offset for the
         * center, and offsetting the position of the widget in the opposite
         * direction.
         */
        _calculateNewPosition: function _calculateNewPosition(newRotation) {
            var viewModel = this.viewScope.viewModel;
            var position = this._experience.getPixelPosition({
                top: this.model.get("top"),
                left: this.model.get("left")
            });
            var oldRotation = this.model.get("rotation");
            var widgetPosition = { x: position.left, y: position.top };
            var size = void 0;
            var width = void 0;
            var height = void 0;
            var widgetCenter = void 0;
            var oldCenter = void 0;
            var newCenter = void 0;

            if (this.model.has("width") && this.model.has("height")) {
                size = this._experience.getPixelSize({
                    width: this.model.get("width"),
                    height: this.model.get("height")
                });
                width = size.width;
                height = size.height;
            } else {
                var firstWidgetElement = viewModel.selection.get("widgets")[0].$el;
                width = firstWidgetElement.width();
                height = firstWidgetElement.height();
            }

            widgetCenter = {
                x: position.left + width / 2,
                y: position.top + height / 2
            };

            oldCenter = MathUtil.rotatePoint(widgetCenter, widgetPosition, oldRotation);
            newCenter = MathUtil.rotatePoint(widgetCenter, widgetPosition, newRotation);

            return {
                left: MathUtil.roundToContain(position.left - (newCenter.x - oldCenter.x), this._experience.get("width")),
                top: MathUtil.roundToContain(position.top - (newCenter.y - oldCenter.y), this._experience.get("height"))
            };
        },
        onRender: function onRender() {
            this.__super();

            var viewModel = this.viewScope.viewModel;
            var scene = viewModel.get("scene");
            var selectedModels = viewModel.selection.get("models");

            this._experience = viewModel.get("experience");
            // Through out the code we treat group of widgets as the one widget,
            // but we can't rely on this here:
            // grouping options must be hidden for single widget only.
            // That's why we check here if selection contains a group.
            var selectionHasGroups = scene.canUngroupWidgets(selectedModels);
            if (viewModel.selection.isSingle() && !selectionHasGroups) {
                this.ui.grouping.hide();
            } else {
                this.ui.groupButton.prop("disabled", !scene.canGroupWidgets(selectedModels));
                this.ui.ungroupButton.prop("disabled", !selectionHasGroups);
            }

            this._initializeArrangeDropdown();
            this._initializeAlignDropdown();
            this._reloadSelect2Lists();

            if (selectedModels.length > 1) {
                var isAlignedToSceneChecked = Session.get(Keys.ALIGNED_TO_SCENE_CHECKBOX, ALIGNED_TO_SCENE_STORAGE, true);

                this.ui.alignToScene.prop({
                    disabled: false,
                    checked: isAlignedToSceneChecked
                });
            } else {
                Session.unset(Keys.ALIGNED_TO_SCENE_CHECKBOX, ALIGNED_TO_SCENE_STORAGE);
                this.ui.alignToScene.prop("disabled", true);
                this._allowDistribution(false);
            }
        },
        _initializeArrangeDropdown: function _initializeArrangeDropdown() {
            this.ui.arrangeControls.select2({
                placeholder: "Arrange",
                dropdownAutoWidth: true,
                formatResult: this._formatSelectItems,
                minimumResultsForSearch: -1,
                dropdownCssClass: "positioning-controls-selector"
            });
        },
        _initializeAlignDropdown: function _initializeAlignDropdown() {
            this.ui.alignControls.select2({
                placeholder: "Align",
                dropdownAutoWidth: true,
                formatResult: this._formatSelectItems,
                minimumResultsForSearch: -1,
                dropdownCssClass: "positioning-controls-selector"
            });
        },
        onShow: function onShow() {
            // TODO: This feels kind of hacky
            // The logic of not having the animation of the PropertiesView should live
            // in the AbstractWidgetPropertiesView and be configurable.
            if (this._shouldExpandOnRender()) {
                this._$accordionTarget.removeClass("collapsing").addClass("collapse in").height("");
            } else {
                this.__super();
            }

            this.ui.arrangeControls.on("select2-selecting", this._onArrangementSelect.bind(this));
            this.ui.arrangeControls.on("select2-close", this._onSelect2Close.bind(this));
            this.ui.alignControls.on("select2-selecting", this._onAlignDistributeSelect.bind(this));
            this.ui.alignControls.on("select2-close", this._onSelect2Close.bind(this));
        },
        _onSelect2Close: function _onSelect2Close() {
            this.ui.arrangeControls.select2("val", "");
            this.ui.alignControls.select2("val", "");

            // Select2 keeps the focus even after the onClose event, which doesn't let the undo/redo
            // functionality work properly since the focus has to be on the body.
            defer(function () {
                document.activeElement.blur();
            });
        },


        /**
         * Handler for the align to scene checkbox.
         *
         * @param {JQuery<Event>} event - Event containing the alignToScene checkbox data.
         */
        _alignToSceneChangeHandler: function _alignToSceneChangeHandler(event) {
            var models = this.viewScope.viewModel.selection.get("models");

            // We keep the state of alignedToScene if it's unchecked.
            if (!event.target.checked) {
                Session.update(Keys.ALIGNED_TO_SCENE_CHECKBOX, ALIGNED_TO_SCENE_STORAGE, false);
            }
            if (models.length === 2) {
                this._allowDistribution(event.target.checked);
            } else {
                this._allowDistribution(true);
            }
        },


        /**
         * Grays out or activate the Distribution option in the align dropdown.
         *
         * @param {Boolean} isActivated if the distribution should be activated in the drop down
         */
        _allowDistribution: function _allowDistribution(isActivated) {
            this.ui.alignControls.find("option[value=" + EditorConstants.DISTRIBUTE_HORIZONTALLY.value + "]").prop("disabled", !isActivated);
            this.ui.alignControls.find("option[value=" + EditorConstants.DISTRIBUTE_VERTICALLY.value + "]").prop("disabled", !isActivated);

            this._initializeAlignDropdown();
        },


        /**
         * @private
         *
         * The open/close allows to insert the select2 dropdown into the DOM.
         * Which will actually preload the icons instead of loading them,
         * on the first open of the dropdown by the user.
         */
        _reloadSelect2Lists: function _reloadSelect2Lists() {
            this.ui.arrangeControls.select2("open");
            this.ui.arrangeControls.select2("close");
            this.ui.alignControls.select2("open");
            this.ui.alignControls.select2("close");
            document.activeElement.blur();
        },
        _groupingHandler: function _groupingHandler() {
            WidgetGroup.group({ eventProperties: { triggerOrigin: "rightPanel" } });
        },
        _ungroupingHandler: function _ungroupingHandler() {
            WidgetGroup.ungroup({ eventProperties: { triggerOrigin: "rightPanel" } });
        },


        /**
         * @private
         *
         * Create the template for the option of the arrangement.
         * If a data-css-class attribute is set to the option then it will be used
         * when creating the span.
         *
         * @param {Object} currentOption The select2 element
         * @returns {String} The template used by Select2 to render the @see currentOption
         */
        _formatSelectItems: function _formatSelectItems(currentOption) {
            var elementDataSet = currentOption.element[0].dataset;
            var cssClass = elementDataSet.cssClass;

            // In order to get a placeholder in Select2,
            // an empty option has to be inserted in front.
            return cssClass ? "<span class=\"option-icon " + cssClass + "\" ></span>" + currentOption.text : currentOption.text;
        },


        /**
         * Event handler when a element has been selected in the dropdown
         *
         * @param {Select2JQueryEventObject} e - Event containing the selected arrangement option.
         * @private
         */
        _onArrangementSelect: function _onArrangementSelect(e) {
            var _this = this;

            var viewModel = this.viewScope.viewModel;
            var scene = viewModel.get("scene");
            var widgets = viewModel.selection.get("models");
            var sendBack = false;
            var bringToFront = false;
            var selectedOption = void 0;

            switch (+e.val) {
                case EditorConstants.BRING_TO_FRONT.value:
                    widgets.sort(compareByLowestLayerIndex);
                    selectedOption = EditorConstants.BRING_TO_FRONT;
                    break;
                case EditorConstants.SEND_BACK.value:
                    widgets.sort(compareByHighestLayerIndex);
                    selectedOption = EditorConstants.SEND_BACK;
                    break;
                case EditorConstants.BRING_FORWARD.value:
                    widgets.sort(compareByHighestLayerIndex);

                    if (widgets.length > 1) {
                        var highestIndex = scene.getHighestIndex();

                        if (widgets[0].get("layerIndex") === highestIndex) {
                            bringToFront = true;
                        }
                    }
                    selectedOption = EditorConstants.BRING_FORWARD;
                    break;
                case EditorConstants.SEND_BACKWARD.value:
                    widgets.sort(compareByLowestLayerIndex);

                    if (widgets.length > 1) {
                        sendBack = widgets[0].get("layerIndex") === 0;
                    }
                    selectedOption = EditorConstants.SEND_BACKWARD;
                    break;
                default:
                    Preconditions.warn("DefaultSwitchWarn - ArrangeDropDown '" + e.val + "'  not recognized.");
                    break;
            }

            widgets.forEach(function (widgetModel) {
                var siblingWidgets = widgetModel.getGroupSiblings(_this.viewScope.viewModel.get("scene").get("widgets"));
                scene.orderWidget({ widgetModel: widgetModel, to: selectedOption.value, siblingWidgets: siblingWidgets });
            });

            if (sendBack) {
                scene.orderWidget({ widgetModel: widgets[0], to: EditorConstants.SEND_BACK.value });
            }

            if (bringToFront) {
                scene.orderWidget({ widgetModel: widgets[0], to: EditorConstants.BRING_TO_FRONT.value });
            }

            this._triggerPositioningEvent(selectedOption.text, "WidgetMenuArrangeDropdown");
        },


        /**
          * Create a container from the experience widget and height
          *
          * @returns {ContainerSize}
          */
        _getContainerSizeFromExperience: function _getContainerSizeFromExperience() {
            var experienceWidth = this._experience.get("width");
            var experienceHeight = this._experience.get("height");

            return {
                right: experienceWidth,
                left: 0,
                top: 0,
                bottom: experienceHeight,
                verticalCenter: experienceHeight / 2,
                horizontalCenter: experienceWidth / 2
            };
        },


        /**
         * Create the container size out of the selection of widgets
         *
         * @param {Object[]} widgets - The collection of widgets.
         * @returns {ContainerSize}
         */
        _getContainerSizeFromWidgets: function _getContainerSizeFromWidgets(widgets) {
            var furthestPoints = {
                top: Math.min.apply(Math, _toConsumableArray(widgets.map(function (_ref) {
                    var boundingBox = _ref.boundingBox;
                    return boundingBox.top;
                }))),
                bottom: Math.max.apply(Math, _toConsumableArray(widgets.map(function (_ref2) {
                    var boundingBox = _ref2.boundingBox;
                    return boundingBox.bottom;
                }))),
                left: Math.min.apply(Math, _toConsumableArray(widgets.map(function (_ref3) {
                    var boundingBox = _ref3.boundingBox;
                    return boundingBox.left;
                }))),
                right: Math.max.apply(Math, _toConsumableArray(widgets.map(function (_ref4) {
                    var boundingBox = _ref4.boundingBox;
                    return boundingBox.right;
                })))
            };

            return {
                bottom: furthestPoints.bottom,
                left: furthestPoints.left,
                right: furthestPoints.right,
                top: furthestPoints.top,
                verticalCenter: (furthestPoints.bottom + furthestPoints.top) / 2,
                horizontalCenter: (furthestPoints.right + furthestPoints.left) / 2
            };
        },
        _mapWidgetToModelAndContainer: function _mapWidgetToModelAndContainer(widget) {
            return {
                boundingBox: widget.getBoundingBox(),
                rect: widget.getRect(),
                model: widget.model
            };
        },


        /**
         * Handler for the Align dropdown
         * Apply the distribution or the alignement to the widget or a selection widgets.
         *
         * @param {Select2JQueryEventObject} e - The event fired on the dropdown
         * @private
         */
        _onAlignDistributeSelect: function _onAlignDistributeSelect(e) {
            var actionName = void 0;
            var viewModel = this.viewScope.viewModel;
            var isAlignedToScene = this.ui.alignToScene.prop("checked");
            var selectedWidgets = viewModel.selection.get("widgets");
            var widgets = selectedWidgets.map(this._mapWidgetToModelAndContainer);
            var containerSize = isAlignedToScene ? this._getContainerSizeFromExperience() : this._getContainerSizeFromWidgets(widgets);
            var experienceSize = {
                width: this._experience.get("width"),
                height: this._experience.get("height")
            };

            switch (+e.val) {
                case EditorConstants.ALIGN_LEFT.value:
                    {
                        Alignment.alignLeft(widgets, containerSize.left, experienceSize);
                        actionName = EditorConstants.ALIGN_LEFT.text;
                        break;
                    }

                case EditorConstants.ALIGN_CENTER.value:
                    {
                        Alignment.alignCenter(widgets, containerSize.horizontalCenter, experienceSize);
                        actionName = EditorConstants.ALIGN_CENTER.text;
                        break;
                    }

                case EditorConstants.ALIGN_RIGHT.value:
                    {
                        Alignment.alignRight(widgets, containerSize.right, experienceSize);
                        actionName = EditorConstants.ALIGN_RIGHT.text;
                        break;
                    }

                case EditorConstants.ALIGN_TOP.value:
                    {
                        Alignment.alignTop(widgets, containerSize.top, experienceSize);
                        actionName = EditorConstants.ALIGN_TOP.text;
                        break;
                    }

                case EditorConstants.ALIGN_MIDDLE.value:
                    {
                        Alignment.alignMiddle(widgets, containerSize.verticalCenter, experienceSize);
                        actionName = EditorConstants.ALIGN_MIDDLE.text;
                        break;
                    }

                case EditorConstants.ALIGN_BOTTOM.value:
                    {
                        Alignment.alignBottom(widgets, containerSize.bottom, experienceSize);
                        actionName = EditorConstants.ALIGN_BOTTOM.text;
                        break;
                    }

                case EditorConstants.DISTRIBUTE_HORIZONTALLY.value:
                    {
                        Distribution.distributeHorizontally(widgets, containerSize, experienceSize, isAlignedToScene);
                        actionName = EditorConstants.DISTRIBUTE_HORIZONTALLY.text;
                        break;
                    }

                case EditorConstants.DISTRIBUTE_VERTICALLY.value:
                    {
                        Distribution.distributeVertically(widgets, containerSize, experienceSize, isAlignedToScene);
                        actionName = EditorConstants.DISTRIBUTE_VERTICALLY.text;
                        break;
                    }

                default:
                    {
                        Preconditions.warn("DefaultSwitchWarn - Align or distribution options of '" + e.val + "' was not recognized.");
                        break;
                    }
            }

            this._triggerPositioningEvent(actionName, "WidgetMenuAlignControlDropdown");
        },


        /**
         * Send the Mixpanel when a position change is applied.
         *
         * @param {String} actionName - The name for of the action @see EditorConstants#text
         * @param {String} triggerOrigin - Name of where the event is triggered from.
         *
         * @fires EditorEvents#update:widget
         * @type {Object}
         * @property {String} [widgetType]                  The type of the widget if the selection is one.
         * @property {String} updatedProperty               The property of the widget which has been modified. @see EditorConstants#text
         * @property {Number} experienceId                  The experience id.
         * @property {Number} experienceVersion             The experience version.
         * @property {Number} experiencePushedVersion       The experience pushed version sceneNumber.
         * @property {Number} sceneNumber                   The scene number.
         * @property {Boolean} isGrouped                    If the widget is a group
         * @property {Number} [numberOfWidgetInGroup]       If the widget is a group then the number of widget inside is sent.
         * @property {Boolean} isSelection                  If it's a selection of widget
         * @property {Number} [numberOfWidgetInSelection]   If it's a selection of widget the number of widget selected.
         * @property {String} triggerOrigin                 The origin of the event.
         * @private
         */
        _triggerPositioningEvent: function _triggerPositioningEvent(actionName, triggerOrigin) {
            var viewModel = this.viewScope.viewModel;
            var selectedModels = viewModel.selection.get("models");
            var group = this.model.get("group");
            var eventProperties = {
                updatedProperty: camelize(actionName),
                experienceId: this._experience.get("id"),
                experienceVersion: this._experience.get("version"),
                experiencePushedVersion: this._experience.get("pushedVersion"),
                sceneNumber: viewModel.get("sceneNumber"),
                isGrouped: group !== undefined,
                isMultipleWidgets: selectedModels > 1,
                triggerOrigin: triggerOrigin
            };

            if (group) {
                eventProperties.numberOfWidgetInGroup = group.length;
            } else if (selectedModels.length > 1) {
                eventProperties.numberOfWidgetInSelection = selectedModels.length;
            } else if (selectedModels.lentgh === 1) {
                eventProperties.widgetType = this.model.get("type");
            }

            EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
        },
        onBeforeClose: function onBeforeClose() {
            this.ui.arrangeControls.off("select2-selecting");
            this.ui.arrangeControls.off("select2-close");
            this.ui.alignControls.off("select2-selecting");
            this.ui.alignControls.off("select2-close");
        },
        onClosing: function onClosing() {
            var viewModel = this.viewScope.viewModel;
            var eventProperties = {
                widgetType: this.model.get("type"),
                experienceId: this._experience.get("id"),
                experienceVersion: this._experience.get("version"),
                experiencePushedVersion: this._experience.get("pushedVersion"),
                sceneNumber: viewModel.get("sceneNumber")
            };

            if (this.positionInputChanged) {
                extend(eventProperties, {
                    updatedProperty: "position",
                    updatedValue: this.model.get("left") + "-" + this.model.get("top"),
                    triggerOrigin: "WidgetMenuPositionInputField"
                });
                EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
            }
            if (this.dimensionsInputChanged) {
                extend(eventProperties, {
                    updatedProperty: "dimensions",
                    updatedValue: this.model.get("width"),
                    triggerOrigin: "WidgetMenuDimensionsInputField"
                });
                EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
            }
            if (this.rotationInputChanged) {
                extend(eventProperties, {
                    updatedProperty: "rotation",
                    updatedValue: this.model.get("rotation"),
                    triggerOrigin: "WidgetMenuRotationInputField"
                });
                EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
            }
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hexToRgb */
/* unused harmony export rgbToHex */
/* unused harmony export hslToRgb */
/* unused harmony export decomposeColor */
/* unused harmony export recomposeColor */
/* harmony export (immutable) */ __webpack_exports__["d"] = getContrastRatio;
/* unused harmony export getLuminance */
/* harmony export (immutable) */ __webpack_exports__["c"] = emphasize;
/* unused harmony export fade */
/* harmony export (immutable) */ __webpack_exports__["a"] = alpha;
/* harmony export (immutable) */ __webpack_exports__["b"] = darken;
/* harmony export (immutable) */ __webpack_exports__["e"] = lighten;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(20);


/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {
    if (value < min || value > max) {
      console.error("Material-UI: The value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error( false ? "Material-UI: Unsupported `".concat(color, "` color.\nWe support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().") : Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["b" /* formatMuiErrorMessage */])(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
var warnedOnce = false;
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */

function fade(color, value) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: The `fade` color utility was renamed to `alpha` to better describe its functionality.', '', "You should use `import { alpha } from '@material-ui/core/styles'`"].join('\n'));
    }
  }

  return alpha(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/**
 * Math utility functions.
 *
 * @class MathUtil
 */
var MathUtil = /** @class */ (function () {
    function MathUtil() {
    }
    /**
     * Checks for the equivalence of two floating-point numbers within a given epsilon.
     *
     * @param {Number} fp1 The first number to check.
     * @param {Number} fp2 The second number to check.
     * @param epsilon
     * @returns {boolean}
     */
    MathUtil.fpEqual = function (fp1, fp2, epsilon) {
        return Math.abs(fp1 - fp2) < epsilon;
    };
    /**
     * Rounds a value to the passed number of decimals places.
     *
     * @param {Number} value The value to round.
     * @param {Number} numberOfDecimals The number of decimals.
     * @returns {number} The rounded value.
     */
    MathUtil.round = function (value, numberOfDecimals) {
        if (numberOfDecimals === void 0) { numberOfDecimals = 0; }
        var decimals = Math.pow(10, numberOfDecimals);
        return Math.round(value * decimals) / decimals;
    };
    /**
     * Rotates the specified point around the given center point.
     *
     * @param  {Point} point         The point to rotate.
     * @param  {Point} rotationPoint The center point origin.
     * @param  {Number} degrees      The rotation angle, in degrees.
     * @return {Point}               The rotated point.
     */
    MathUtil.rotatePoint = function (point, rotationPoint, degrees) {
        var radians = (Math.PI / 180) * degrees;
        return {
            x: (rotationPoint.x + ((point.x - rotationPoint.x) * Math.cos(radians))) - ((point.y - rotationPoint.y) * Math.sin(radians)),
            y: (rotationPoint.y + ((point.x - rotationPoint.x) * Math.sin(radians))) + ((point.y - rotationPoint.y) * Math.cos(radians))
        };
    };
    /**
     * Type describing the rectangle.
     *
     * We wanna avoid the actual <tt>Rectangle</tt> class here, due to the dependencies it
     * carries (Class.extend). This module is used by "channels".
     *
     * @typedef {Object} RectangleDescriptor
     *
     * @property {Number} x - The left coordinate, x axis.
     * @property {Number} y - The top coordinate, y axis.
     * @property {Number} width - The width.
     * @property {Number} height - The height.
     */
    /**
     * Rotates all coordinates for the specified rectangle and returns a new <tt>RectangleDescriptor</tt>.
     *
     * @param  {Number} options.x      The x coordinate.
     * @param  {Number} options.y      The y coordinate.
     * @param  {Number} options.width  The width of the rectangle.
     * @param  {Number} options.height The height of the rectangle.
     * @param  {Point} rotationPoint   The rotation point.
     * @param  {Number} degrees        The rotation angle, in degrees.
     * @return {RectangleDescriptor}   The rotated <tt>RectangleDescriptor</tt>.
     */
    MathUtil.rotateRect = function (_a, rotationPoint, degrees) {
        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var topLeft = MathUtil.rotatePoint({ x: x, y: y }, rotationPoint, degrees);
        var topRight = MathUtil.rotatePoint({ x: x + width, y: y }, rotationPoint, degrees);
        var bottomLeft = MathUtil.rotatePoint({ x: x, y: y + height }, rotationPoint, degrees);
        var bottomRight = MathUtil.rotatePoint({ x: x + width, y: y + height }, rotationPoint, degrees);
        var xs = [topLeft.x, topRight.x, bottomRight.x, bottomLeft.x];
        var ys = [topLeft.y, topRight.y, bottomRight.y, bottomLeft.y];
        var minX = Math.min.apply(Math, xs);
        var minY = Math.min.apply(Math, ys);
        var maxX = Math.max.apply(Math, xs);
        var maxY = Math.max.apply(Math, ys);
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    };
    /**
     * Returns `true` if the specified point is contained within the provided rectangle, `false` if not.
     *
     * @param {Rectangle|Object} rect The rectangle to test for collision.
     * @param {Object} point The collision point
     * @param {Number} point.x The x coordinate.
     * @param {Number} point.y The y coordinate.
     * @param {Number} [angle=0] The rotation angle, in degrees.
     * @param {Point} [rotationPoint=null] Optional rotation point, will default to the rectangle's x and y coordinates.
     * @return {Boolean} `true` for collision, `false` if not.
     */
    MathUtil.pointInsideRect = function (rect, _a, angle, rotationPoint) {
        var x = _a.x, y = _a.y;
        if (angle === void 0) { angle = 0; }
        if (rotationPoint === void 0) { rotationPoint = null; }
        var rotatedPoint = MathUtil.rotatePoint({ x: x, y: y }, rotationPoint || { x: rect.x, y: rect.y }, angle);
        return rotatedPoint.x >= rect.x &&
            rotatedPoint.x <= (rect.x + rect.width) &&
            rotatedPoint.y >= rect.y &&
            rotatedPoint.y <= (rect.y + rect.height);
    };
    MathUtil.getDistance = function (p1, p2) {
        var a = p2.left - p1.left;
        var b = p2.top - p1.top;
        return Math.sqrt((a * a) + (b * b));
    };
    MathUtil.getAngle = function (p1, p2) {
        return Math.atan2(p2.top - p1.top, p2.left - p1.left) * (180 / Math.PI);
    };
    /**
     * Make sure value is between minimum and maximum: If value is between min and max, return
     * value. If value is smaller than min, return min. If value is bigger than max, return
     * max.
     */
    MathUtil.between = function (value, min, max) {
        return Math.max(Math.min(value, max), min);
    };
    /**
     * Calculate how much one range overlaps another range. The result is returned as a
     * fraction of the size of the overlapping range. If the overlapping range does not overlap
     * a negative value is retuned.
     *
     * @param {Number} overlappedRangeStart
     * @param {Number} overlappedRangeEnd
     * @param {Number} overlappingRangeStart
     * @param {Number} overlappingRangeEnd
     * @returns {Number} Returns a fraction between 0 and 1.
     */
    MathUtil.overlapFraction = function (overlappedRangeStart, overlappedRangeEnd, overlappingRangeStart, overlappingRangeEnd) {
        var overlappingRangeSize = overlappingRangeEnd - overlappingRangeStart;
        if (overlappingRangeSize === 0) {
            return 1;
        }
        var overlapStart = Math.max(overlappedRangeStart, overlappingRangeStart);
        var overlapEnd = Math.min(overlappedRangeEnd, overlappingRangeEnd);
        var overlapSize = overlapEnd - overlapStart;
        var overlappingFragment = overlapSize / overlappingRangeSize;
        return overlappingFragment;
    };
    /**
     * Type describing the vertical bounds.
     *
     * @typedef {Object} VerticalBounds
     *
     * @property {Number} top - The top distance.
     * @property {Number} height - The height.
     */
    /**
     * Given a viewport's bounds, computes the joined bounds from the specified target bounds.
     *
     * The methods only focuses on the vertical axis.
     *
     * @param  {Object|Rectangle} viewportBounds The viewport bounds.
     * @param  {Object|Rectangle} targetBounds   The target bounds.
     * @return {VerticalBounds}                  The vertical bounds.
     */
    MathUtil.computeVerticalBounds = function (targetBounds, viewportBounds) {
        var viewportHeight = viewportBounds.height;
        var viewportBottom = viewportBounds.top + viewportHeight;
        var containerHeight = targetBounds.height;
        var containerTop = targetBounds.top + viewportBounds.top;
        var containerBottom = containerTop + containerHeight;
        var verticalOverlapFraction = MathUtil.overlapFraction(containerTop, containerBottom, viewportBounds.top, viewportBottom);
        return {
            top: MathUtil.between(viewportBounds.top - containerTop, 0, containerHeight),
            height: MathUtil.between(verticalOverlapFraction * viewportHeight, 0, viewportHeight)
        };
    };
    /**
    * The idea of method is to round the input long float percentage value.
    * The rounding is done to exactly contain all integer limiter possible values
    * Returns rounded percentage value
    * @param  {Number} value      The percent(!) value to round.
    * @param  {Number} limiter    The limiter value.
    * @return {Number}            The rounded value.
    */
    MathUtil.roundToContain = function (value, limiter) {
        var bitDepth = limiter.toString().length;
        var realSizeInPixels = (value * limiter) / 100;
        var integerPixelsValue = Math.round(realSizeInPixels);
        var correctToContain = integerPixelsValue / (limiter / 100);
        return MathUtil.round(correctToContain, bitDepth - 2);
    };
    /**
     * Type describing the rectangle.
     *
     * @typedef {Object} DOMRectangle
     *
     * @property {Number} x - The left coordinate, x axis.
     * @property {Number} y - The top coordinate, y axis.
     * @property {Number} width - The width.
     * @property {Number} height - The height.
     * @property {Number} left - The left.
     * @property {Number} top - The top.
     * @property {Number} right - The right.
     * @property {Number} bottom - The bottom.
     */
    /**
    * Rouns all <tt>DOMRectangle</tt> property, according to the experience size to contain it
    * and returns a new <tt>DOMRectangle</tt>.
    * @param  {DOMRectangle} rect      The x coordinate.
    * @param  {Number} experienceWidth      The experience widht.
    * @param  {Number} experienceHeight      The experience height.
    * @return {DOMRectangle}   The rotated <tt>DOMRectangle</tt>.
    */
    MathUtil.roundRect = function (rect) {
        return {
            x: Math.round(rect.x),
            y: Math.round(rect.y),
            width: Math.round(rect.width),
            height: Math.round(rect.height),
            left: Math.round(rect.left),
            top: Math.round(rect.top),
            right: Math.round(rect.right),
            bottom: Math.round(rect.bottom)
        };
    };
    /**
     * Scales a dimension by the give experience size (ie either height or width)
     *
     */
    MathUtil.scaleByExperienceSize = function (dimension, experienceSize) {
        return dimension / experienceSize * 100;
    };
    /**
     * Reverse scale a dimension by the give experience size (ie either height or width)
     *
     */
    MathUtil.invertScaleByExperienceSize = function (dimension, experienceSize) {
        return dimension * experienceSize / 100;
    };
    return MathUtil;
}());
/* harmony default export */ __webpack_exports__["default"] = (MathUtil);
;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};
var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};
var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1548);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonBase__ = __webpack_require__(1869);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ButtonBase__["a"]; });


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    /**
     * @type {*}
     * Map of all known enum types, used for reverse lookup (in for example polymorphic collections).
     */

    var UNIVERSE = {};

    /**
     * A simple and lightweight implementation of an enum. <p>
     *
     * Implementation note: is deliberately not dependent on external libraries such as underscore to avoid potential
     * issues with those in bleeding edge browsers like Google Canary.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    var Enum = {

        /**
         * Creator function that returns a new enum based on the supplied enum constants, either in form of
         * a plain old JS object (map) or an array. <p>
         *
         * The <tt>constants</tt> argument can take the following forms:
         *
         * <pre>
         *   {
         *      FOO: { .. }, // "FOO" key
         *      BAR: { .. }, // "BAR" key
         *      ..
         *   }
         *
         *   OR
         *
         *   [Foo, Bar, ..]  // using idField to deduce the key
         *
         * </pre>
         *
         * The following functions will available on the returned enum:
         * <ul>
         *   <li> each(callback: Function): *              - iterates over all constants, in ordinal order. Also possible
         *                                                   to do for (var constants in enumeration), but with unknown
         *                                                   order (and in modern browsers only).
         *   <li> lookup(id: String|Number|*, silent:*): * - lookup a given constant based on id, key, ordinal, or constant,
         *                                                   optionally fails with an error if not found. Second argument
         *                                                   can be a default constant to return on failure to look up, or
         *                                                   a (true) boolean value to suppress look up errors.
         *   <li> exists(id: String|Number|*): Boolean     - returns true if the specified constant exist, false otherwise.
         *   <li> __enumName: String                       - the specified type (name) of the enum.
         *   <li> __enumSize: Number                       - the number of constants in the enum.
         *   <li> __idField:  String                       - the id field that can also be used for lookup, if any.
         * </ul>
         *
         * In addition, each constant in the enum will be tagged with these properties:
         *
         * <ul>
         *   <li> is(constant:*): Boolean - function to check if the supplied argument corresponds to the constant in
         *                                  question, false otherwise.
         *   <li> _key: String            - its key to look up the ordinal; may be different from the "idField" to
         *                                  support additional look ups.
         *   <li> _ordinal: Number        - the ordinal number in the enum (index), corresponding to the define order
         *                                  <b>or</b> to the <tt>ordinal</tt> property defined on the constant already.
         *   <li> _enum: Enum             - the enum (singleton) the constant belongs to.
         *   <li> __enumName: String      - the specified type (name) of the enum.
         * </ul>
         *
         * If the constant defines an <tt>ordinal</tt> property as a number, all constants will be sorted accordingly.
         * The returned enum, however, will always used normalized ordinals, starting from zero. <p>
         *
         * In addition, defined enums can be statically tested and acquired like:
         * <pre>
         *    Enum.is(o:*): Boolean - returns true if the supplied object is an enum, false otherwise.
         *    Enum.get(o:*): Enum   - returns the internal enum based on the specified value.
         * </pre>
         *
         * @param {String}   type        The enum type as a string, e.g. "WidgetTypes"; cannot be falsey.
         * @param {String|*} idField     The field from each constant to be used on lookup, e.g. "id". If falsey, a
         *                               lookup will be made on the keys deduced from <tt>constants</tt> only when
         *                               a map, but must be supplied if <tt>constants</tt> is an array. If no specific
         *                               id field is to be used expect the enum keys, this can be left out (null) or
         *                               <tt>constants</tt> can be supplied as the second argument as well.
         * @param {[]|*}     [constants] The enum constants, where each key is expected to index the enum value <b>or</b> an
         *                               array indexed by its <tt>idField</tt> property; cannot be falsey. The map/array
         *                               is <b>not</b> modified by this function, but the individual constants will
         *                               be augmented as documented above.
         * @param {*}        [methods]   A set of static enum methods to be added to the returned enum type as well; can
         *                               be falsey. Can also be supplied as the third argument if no <tt>idField</tt> is
         *                               used. Functions named similar to enum functions will cause an error to be
         *                               raised.
         *
         * @return {*} A new enum as described; never falsey.
         */
        create: function create(type, idField, constants, methods) {
            var enumeration = Object.create ? Object.create(null) : {}; // null: no prototype, and properties added below
            var index = {};
            var array = [];
            var sort = false;
            var i = void 0;
            var s = void 0; // cached toString() representation
            var c = void 0;

            if (idField && typeof idField !== "string") {
                methods = constants;
                constants = idField;
                idField = null;
            }

            // Defines the optionally enumerable, but always immutable property "key" on "target" storing "value"...
            var defineProp = function defineProp(target, key, value, enumerable) {
                if (Object.defineProperty) {
                    Object.defineProperty(target, key, {
                        value: value,
                        enumerable: enumerable || false
                    });
                } else {
                    enumeration[key] = value;
                }
            };

            // Helper method to define a constant in this enum, regardless if supplied via an array or map...
            var defineConstant = function defineConstant(constant, key) {
                // Any sealed constant will cause trouble, like a string constant...
                if (Object.isSealed && Object.isSealed(constant)) {
                    constant = {
                        value: constant,
                        toString: function toString() {
                            return this.value;
                        }
                    };
                    idField = "value";
                }

                // A specified ordinal need just be a number, we will make sure it is valid after sorting below...
                if (typeof constant.ordinal === "number") {
                    constant._ordinal = constant.ordinal;
                    sort = true;
                } else {
                    constant._ordinal = array.length;
                }

                // Respect already non-native toString definition...
                if (!constant.toString.prototype) {
                    constant.toString = function () {
                        // user-friendly toString for each constant if none is declared specifically
                        var s = constant._ordinal + ": " + constant._key;
                        if (idField) {
                            return s + "=" + constant[idField];
                        }
                        return s;
                    };
                }

                if (!key) {
                    throw new Error(type + " enum does not define enum key: " + constant);
                }

                // For consistency, and to easier distinguish constants from methods, upper case all enum keys...
                key = key.toUpperCase();

                // Expose this constant under its key, and make it enumerable. We never look up based on "enumeration",
                // though, as it will also define methods like "all"...
                defineProp(enumeration, key, constant, true);
                index[key] = constant;

                // If we have an additional id, register it as well, but we must have it then...
                if (idField) {
                    var id = constant[idField];
                    if (!id) {
                        throw new Error(type + " enum does not define '" + idField + "' field: " + constant);
                    }
                    index[id] = constant;
                }

                // Add to array so we can order by ordinal and iterate accordingly...
                array.push(constant);

                defineProp(constant, "_key", key);
                defineProp(constant, "_enum", enumeration);
                defineProp(constant, "__enumName", type); // for easy lookup

                // Enum types may define this already which we will respect...
                if (typeof constant.is === "undefined") {
                    defineProp(constant, "is", function (c) {
                        return c === constant || enumeration.lookup(c, true) === constant;
                    });
                }
            };

            // Array supplied, so we must have an "idField" to index the constants by <b>and</b> such keys available
            // for  constant...
            if (constants instanceof Array) {
                for (i = 0; i < constants.length; i++) {
                    c = constants[i];
                    defineConstant(c, c[idField]);
                }

                // Map (enum) supplied, where each map key is the constant name...
            } else {
                for (i in constants) {
                    defineConstant(constants[i], i);
                }
            }

            if (sort) {
                array.sort(function (a, b) {
                    return a._ordinal - b._ordinal;
                });
            }

            // Make sure ordinals are sequential, starting with 0, and immutable henceforth...
            for (i = 0; i < array.length; i++) {
                c = array[i];
                delete c._ordinal;
                defineProp(c, "_ordinal", i);
            }

            defineProp(enumeration, "__enumName", type); // explicitly not called "__typeName" to avoid conflicts with Extend!
            defineProp(enumeration, "__enumSize", array.length); // do not call this "length" as that will perhaps make libs think it is array like...
            if (idField) {
                defineProp(enumeration, "__idField", idField);
            }

            UNIVERSE[type] = enumeration;

            // Add static methods...
            if (methods) {
                for (i in methods) {
                    defineProp(enumeration, i, methods[i]);
                }
            }

            /**
             * Returns true if the specified constant is part of this enumeration based on identity, false otherwise.
             *
             * @param  {*} constant The constant instance to test; can be falsey.
             * @return {Boolean} True if <tt>constant</tt> is part of this enumeration, false otherwise.
             * @see    #exists
             */
            defineProp(enumeration, "is", function (constant) {
                return array.indexOf(constant) !== -1;
            });

            /**
             * Calls <tt>callback</tt>, optionally scoped according to <tt>scope</tt>, for each constant in this
             * enum in ordinal order. <p>
             *
             * If <tt>callback</tt> returns a defined value, the iteration will stop and the result will be returned;
             * otherwise null is returned.
             *
             * @param {Function} callback The function to be invoked with the current constant as the single argument,
             *                            optionally returning defined value to stop the iteration (and return said value
             *                            from this function); cannot be falsey.
             *
             * @return {*} The defined value returned by <tt>callback</tt>, if any; otherwise null.
             */
            defineProp(enumeration, "each", function (callback, scope) {
                var result = void 0;
                var i = void 0;

                for (i = 0; i < array.length; i++) {
                    result = callback.call(scope || callback, array[i]);
                    if (typeof result !== "undefined") {
                        return result;
                    }
                }
                return null;
            });

            /**
             * Similar to Array.map, produces a new array of values by mapping each enum value through a transformation
             * function (<tt>callback</tt>). The callback is passed the enum value.
             *
             * @param  {Function} callback The iteratee to be invoked with the current constant as the single argument.
             * @param  {*}        scope Optional callback scope.
             * @return {Array}    The mapped array.
             */
            defineProp(enumeration, "map", function (callback, scope) {
                var result = [];

                enumeration.each(function (value) {
                    result.push(callback.call(scope || callback, value));
                }, scope);

                return result;
            });

            /**
             * Returns a new array of all constants in ordinal order. <p>
             *
             * Modifying the returned array will not affect this enum (but do not change the individual constants).
             *
             * @param  {Function} [sort] Optional sort function to sort constants before returned; can be falsey, in
             *                           which case ordinal order is used.
             *
             * @return {[]} A new array of all constants in ordinal order; never falsey.
             */
            defineProp(enumeration, "all", function (sort) {
                var clone = array.slice();
                if (sort) {
                    clone.sort(sort);
                }
                return clone;
            });

            /**
             * Returns the constant with specified key, alternative id, ordinal, or equal to the specified constant
             * if it exist in this enumeration, undefined or raises an error otherwise, depending on the
             * value of <tt>silent</tt>. <p>
             *
             * If <tt>id</tt> is a string, it will be tried looked up as a constant key in a case sensitive manner.
             *
             * @param  {String|Number|*} id      The key, alternative id, ordinal, or constant to lookup; a falsey
             *                                   value will always return false.
             * @param  {Boolean|*}      [silent] True to return undefined if no found, false to raise an error
             *                                   if not found (default). Alternatively a default constant to
             *                                   return if the lookup fails as a key, alternative id, ordinal,
             *                                   or constant to use (can raise errors!)
             *
             * @return {*} The specified constant from this enum; can be null if <tt>silent</tt> is true.
             */
            defineProp(enumeration, "lookup", function (id, silent) {
                var t = typeof id === "undefined" ? "undefined" : _typeof(id);
                var constant = void 0;

                // eslint-disable-next-line eqeqeq
                if (id != null) {
                    if (t === "string") {
                        // id
                        constant = index[id] || index[id.toUpperCase()]; // first 'ENUM KEY', secondly some additional 'id', or try UPPERCASE id as last resort...
                    } else if (t === "number") {
                        // ordinal
                        constant = array[id];
                    } else if (id.__enumName === type && idField) {
                        // constant
                        constant = index[id[idField]];
                    }
                }

                if (constant) {
                    return constant;
                } else if (silent) {
                    return typeof silent === "boolean" ? null : enumeration.lookup(silent); // may raise an error!
                }
                throw new Error(type + " not found: " + id);
            });

            /**
             * Returns true if the specified id, ordinal, or constant exist in this enumeration,
             * false otherwise.
             *
             * @param  {String|Number|*} id The id, key, ordinal, or constant to lookup; a falsey value will
             *                              always return false.
             *
             * @return {Boolean} True if such a constant exist, false otherwise.
             */
            defineProp(enumeration, "exists", function (id) {
                return !!enumeration.lookup(id, true);
            });

            /**
             * Enum specific mixin function that takes every (key,value) pair from <tt>values</tt> and mixes it
             * into the existing value in this enumeration. <p>
             *
             * If a key does not exist, an error will be raised. If private constant fields like <tt>_oridinal</tt>
             * are tried overridden, an error will be raised.
             *
             * @param  {*}         values       The (key,value) pairs to mixin on existing constants; can be falsey. Does not support
             *                                  arrays. Any value not an object will be ignored.
             * @param  {Function} [initializer] Optional initializer, fn(constant), to be invoked on each constant once
             *                                  relevant values have been mixed in, for example to generate defaults.
             * @return {Enum} This enumeration; never falsey.
             */
            defineProp(enumeration, "mixin", function (values, initializer) {
                // not the same as Extend.mixin, different enum semantics!
                if (values) {
                    var key = void 0;
                    var value = void 0;
                    var constant = void 0;

                    for (key in values) {
                        // Will raise an error if no such constant...
                        constant = enumeration.lookup(key);
                        value = values[key];
                        // Must be an object for us to iterate over...
                        if ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object") {
                            for (key in value) {
                                constant[key] = value[key];
                            }
                        }
                        // Call supplied initializer to allow easy defaults across all constants...
                        if (initializer) {
                            initializer(constant);
                        }
                    }
                }
                return enumeration;
            });

            /**
             * Returns the string representation of this enum.
             *
             * @return {String} The string representation; never falsey.
             */
            defineProp(enumeration, "toString", function () {
                if (!s) {
                    s = "";
                    enumeration.each(function (constant) {
                        if (s) {
                            s += "; ";
                        }
                        s += constant;
                    });
                    s = type + "[" + s + "]";
                }
                return s;
            });

            // If possible, prevent more stuff to be added to the enumeration...
            return Object.freeze ? Object.freeze(enumeration) : enumeration;
        },


        /**
         * Returns true if the supplied object is an enum, false otherwise.
         *
         * @param  {*} o The object to test; can be falsey, in which case false is returned.
         * @return {Boolean} True if <tt>o</tt> is an enum, false otherwise.
         */
        is: function is(o) {
            return o && o.__enumSize > 0;
        },


        /**
         * Returns the enum associated with the supplied object, either a constant or an enum (or something
         * else entirely).
         *
         * @param  {*} o The object to find the enum for; can be falsey, in which case falsey is returned.
         * @return {Enum} The found enum, if any; can be falsey.
         */
        get: function get(o) {
            return o && UNIVERSE[o.__enumName];
        }
    };

    return Enum;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);

    return ImprovedModel.extend({

        defaults: {

            /**
             * The trigger type e.g. <tt>hover</tt>
             * @type {String}
             */
            triggerType: null,

            /**
             * The effect type e.g. <tt>opacity</tt>
             * @type {String}
             */
            type: null,

            duration: 500,

            postDelay: 0
        }

    }, {
        TRIGGER_TYPE_HOVER: "hover",
        TRIGGER_TYPE_ATTENTION: "attention"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 79 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSvgIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SvgIcon__ = __webpack_require__(415);



/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: ref
    }, props), path);
  };

  if (false) {
    // Need to set `displayName` on the inner component for React.memo.
    // React prior to 16.14 ignores `displayName` on the wrapper.
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = __WEBPACK_IMPORTED_MODULE_2__SvgIcon__["a" /* default */].muiName;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.memo( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(Component));
}

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = deprecatedPropType;
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return top; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return right; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return basePlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return start; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return end; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clippingParents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return viewport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return popper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return reference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return variationPlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return placements; });
/* unused harmony export beforeRead */
/* unused harmony export read */
/* unused harmony export afterRead */
/* unused harmony export beforeMain */
/* unused harmony export main */
/* unused harmony export afterMain */
/* unused harmony export beforeWrite */
/* unused harmony export write */
/* unused harmony export afterWrite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return modifierPhases; });
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isC3Experience = isC3Experience;
function isC3Experience() {
    return window.location.hash.split('/').length > 1 && window.location.hash.split('/')[1].startsWith('C3_');
}

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var MathUtil = __webpack_require__(72).default;

    /**
     * Simple size object.
     *
     * @class Size
     *
     * @param {Number} width The width component of the size.
     * @param {Number} height The height component of the size.
     */
    var Size = Class.extend({
        constructor: function constructor(width, height) {
            this.width = width;
            this.height = height;
        },


        /**
         * Shrinks the height or the width so that the new size obeys the specified aspect ratio.
         *
         * @param {Number} aspectRatio The aspect ratio is the width divided by the height.
         *
         * @return {Size} A new size that fits inside the current size.
         */
        shrinkToAspectRatio: function shrinkToAspectRatio(aspectRatio) {
            var thisRatio = this.getAspectRatio();

            var w = this.width;
            var h = this.height;

            if (aspectRatio > thisRatio) {
                w = this.width;
                h = MathUtil.round(this.width / aspectRatio, 2);
            } else if (aspectRatio < thisRatio) {
                h = this.height;
                w = MathUtil.round(this.height * aspectRatio, 2);
            }

            return new Size(w, h);
        },


        /**
         * Grows the height or the width so that the new size obeys the specified aspect ratio.
         *
         * @param {Number} aspectRatio The aspect ratio is the width divided by the height.
         *
         * @return {Size} A new size that fits around the current size.
         */
        growToAspectRatio: function growToAspectRatio(aspectRatio) {
            var thisRatio = this.getAspectRatio();

            var w = this.width;
            var h = this.height;

            if (aspectRatio > thisRatio) {
                h = this.height;
                w = MathUtil.round(this.height * aspectRatio, 2);
            } else if (aspectRatio < thisRatio) {
                w = this.width;
                h = MathUtil.round(this.width / aspectRatio, 2);
            }

            return new Size(w, h);
        },


        /**
         * Returns this size's aspect ratio (the width divided by the height).
         *
         * @return {Number} This size's aspect ratio (the width divided by the height).
         */
        getAspectRatio: function getAspectRatio() {
            return this.width / this.height;
        },


        /**
         * Returns a new size, representing the scaled version of this size, from the provided scale
         * instance.
         *
         * @param {Scale} scale The scale.
         *
         * @return {Size} The scaled size.
         */
        scale: function scale(_scale) {
            return new Size(this.width * _scale.x, this.height * _scale.y);
        },
        area: function area() {
            return this.width * this.height;
        },


        /**
         * Equals.
         */
        equals: function equals(size) {
            if (!size) {
                return false;
            }

            if (size === this) {
                return true;
            }

            if (size instanceof Size) {
                return this.width === size.width && this.height === size.height;
            }

            return false;
        }
    }, {

        /**
         * Static convenience method for creating a new <tt>Size</tt> instance.
         *
         * <pre>
         * var size = Size.from(100, 100);
         * </pre>
         *
         * If called with a single argument, it's expected to be an object specifying the bounds, e.g.:
         *
         * <pre>
         * var size = Size.from({width: 100, height: 100});
         * </pre>
         *
         * @param  {Number|Object} width  The width or an object specifying the width and height.
         * @param  {Number} height        The height.
         *
         * @return {Size} A new <tt>Size</tt> instance.
         */
        from: function from(width, height) {
            if (arguments.length === 1) {
                var bounds = width;

                return new Size(bounds.width, bounds.height);
            }

            return new Size(width, height);
        }
    });

    return Size;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */

function map(children, func, context) {
  var index = 0;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}
/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */


function forEach(children, func, context) {
  var index = 0;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}
/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */


function count(children) {
  var result = 0;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });
  return result;
}
/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */


function filter(children, func, context) {
  var index = 0;
  var result = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });
  return result;
}

function find(children, func, context) {
  var index = 0;
  var result;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });
  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });
  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });
  return result;
}

function toArray(children) {
  var result = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftModifier
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(93);
var ContentStateInlineStyle = __webpack_require__(2109);
var DraftFeatureFlags = __webpack_require__(181);
var Immutable = __webpack_require__(40);

var applyEntityToContentState = __webpack_require__(2110);
var getCharacterRemovalRange = __webpack_require__(2112);
var getContentStateFragment = __webpack_require__(428);
var insertFragmentIntoContentState = __webpack_require__(2115);
var insertTextIntoContentState = __webpack_require__(2116);
var invariant = __webpack_require__(47);
var modifyBlockForContentState = __webpack_require__(2117);
var removeEntitiesAtEdges = __webpack_require__(1031);
var removeRangeFromContentState = __webpack_require__(2118);
var splitBlockInContentState = __webpack_require__(2119);

var OrderedSet = Immutable.OrderedSet;

/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);

    var character = CharacterMetadata.create({
      style: inlineStyle || OrderedSet(),
      entity: entityKey || null
    });

    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },

  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },

  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment(contentState, removalRange);

    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');

    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },

  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);

    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
  },

  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey = void 0,
        endKey = void 0,
        startBlock = void 0,
        endBlock = void 0;
    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }
    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();

    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1);

    // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.
    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, _adjustedRemovalRange);
      }
    }
    var adjustedRemovalRange = rangeToRemove;
    if (DraftFeatureFlags.draft_segmented_entities_behavior) {
      // Adjust the selection to properly delete segemented and immutable
      // entities
      adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
    }

    var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
    return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
  },

  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);

    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },

  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },

  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },

  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ type: blockType, depth: 0 });
    });
  },

  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: blockData });
    });
  },

  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({ data: block.getData().merge(blockData) });
    });
  },

  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};

module.exports = DraftModifier;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!(module.exports = {
    CANCEL: 3,
    HELP: 6,
    BACK_SPACE: 8,
    TAB: 9,
    CLEAR: 12,
    RETURN: 13,
    ENTER: 14,
    SHIFT: 16,
    CONTROL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PRINTSCREEN: 44,
    INSERT: 45,
    DELETE: 46,
    0: 48,
    1: 49,
    2: 50,
    3: 51,
    4: 52,
    5: 53,
    6: 54,
    7: 55,
    8: 56,
    9: 57,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    LEFT_COMMAND_MACOS_WEBKIT: 91,
    CONTEXT_MENU_OR_RIGHT_COMMAND_MACOS_WEBKIT: 93,
    NUMPAD0: 96,
    NUMPAD1: 97,
    NUMPAD2: 98,
    NUMPAD3: 99,
    NUMPAD4: 100,
    NUMPAD5: 101,
    NUMPAD6: 102,
    NUMPAD7: 103,
    NUMPAD8: 104,
    NUMPAD9: 105,
    MULTIPLY: 106,
    ADD: 107,
    SEPARATOR: 108,
    SUBTRACT: 109,
    DECIMAL: 110,
    DIVIDE: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    F13: 124,
    F14: 125,
    F15: 126,
    F16: 127,
    F17: 128,
    F18: 129,
    F19: 130,
    F20: 131,
    F21: 132,
    F22: 133,
    F23: 134,
    F24: 135,
    NUM_LOCK: 144,
    SCROLL_LOCK: 145,
    SEMICOLON: 186,
    EQUALS: 187,
    COMMA: 188,
    DASH: 189,
    PERIOD: 190,
    SLASH: 191,
    BACK_QUOTE: 192,
    OPEN_BRACKET: 219,
    BACK_SLASH: 220,
    CLOSE_BRACKET: 221,
    QUOTE: 222,
    META_OR_COMMAND_MACOS_FIREFOX: 224
});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(254);
var core = __webpack_require__(79);
var ctx = __webpack_require__(533);
var hide = __webpack_require__(380);
var has = __webpack_require__(311);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__ = __webpack_require__(1819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__ = __webpack_require__(1820);




function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableSpread_js__["a" /* default */])();
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(902);




function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createGenerateClassName__ = __webpack_require__(411);
/* unused harmony reexport createGenerateClassName */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createStyles__ = __webpack_require__(906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__createStyles__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getThemeProps__ = __webpack_require__(567);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__getThemeProps__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jssPreset__ = __webpack_require__(568);
/* unused harmony reexport jssPreset */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__makeStyles__ = __webpack_require__(413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__makeStyles__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeClasses__ = __webpack_require__(569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__mergeClasses__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ServerStyleSheets__ = __webpack_require__(911);
/* unused harmony reexport ServerStyleSheets */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__(912);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__styled__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StylesProvider__ = __webpack_require__(414);
/* unused harmony reexport StylesProvider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__ = __webpack_require__(913);
/* unused harmony reexport ThemeProvider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__useTheme__ = __webpack_require__(262);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_11__useTheme__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withStyles__ = __webpack_require__(914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__withStyles__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withTheme__ = __webpack_require__(915);
/* unused harmony reexport withTheme */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_13__withTheme__["a"]; });
/** @license Material-UI v4.11.5
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable import/export */

/* Warning if there are several instances of @material-ui/styles */

if (false) {
  ponyfillGlobal['__@material-ui/styles-init__'] = ponyfillGlobal['__@material-ui/styles-init__'] || 0;

  if (ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://mui.com/r/styles-instance-warning for more info.'].join('\n'));
  }

  ponyfillGlobal['__@material-ui/styles-init__'] += 1;
}




























/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CharacterMetadata
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = __webpack_require__(40),
    Map = _require.Map,
    OrderedSet = _require.OrderedSet,
    Record = _require.Record;

// Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};

var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = function (_CharacterMetadataRec) {
  _inherits(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    _classCallCheck(this, CharacterMetadata);

    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
  }

  CharacterMetadata.prototype.getStyle = function getStyle() {
    return this.get('style');
  };

  CharacterMetadata.prototype.getEntity = function getEntity() {
    return this.get('entity');
  };

  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  };

  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */


  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    };

    // Fill in unspecified properties, if necessary.
    var configMap = Map(defaultConfig).merge(config);

    var existing = pool.get(configMap);
    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map([[Map(defaultRecord), EMPTY]]);

CharacterMetadata.EMPTY = EMPTY;

module.exports = CharacterMetadata;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(2369),
    createAssigner = __webpack_require__(2419);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isHTMLElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isShadowRoot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(167);


function isElement(node) {
  var OwnElement = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}



/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        $ = __webpack_require__(4),
        _require = __webpack_require__(1),
        isString = _require.isString,
        isFunction = _require.isFunction,
        defer = _require.defer,
        isBoolean = _require.isBoolean,
        toArray = _require.toArray,
        isArray = _require.isArray,
        each = _require.each,
        _require2 = __webpack_require__(24),
        Logger = _require2.Logger,
        SyncManager = __webpack_require__(44),
        _require3 = __webpack_require__(30),
        isBlank = _require3.isBlank;


    var log = new Logger("ValidateBehavior");

    /**
     * Clears a displayed validation error.
     *
     * @param {Object} $el The jQuery element to clear the validator for, if any; never null.
     * @see   #validateInputField
     */
    function clearValidationError($el) {
        $el.attr("data-original-title", "");

        $el.removeClass("validation-error"); // e.g. Input type="text"
    }

    /**
     *  Returns the value of the element to be validated.
     * @param {Object} $el The jQuery element to be validated, if any; never null.
     * @returns The selected value for the elements. The text for editables fields as they are implemented with DIV tags.
     */
    function val($el) {
        var isSelectElement = $el.is("select");

        if (isSelectElement) {
            return $el.val(); // Selects may have an empty default option, so val should be called.
        }

        return $el.val() || $el.text(); // e.g. text() for editable divs!
    }

    /**
     * Validates an input field.
     *
     * @param {Object}          $el       The jQuery element validated; never null.
     * @param {Function}        validator The validator function like <tt>fn(val:String, type:String)</tt>; never
     *                                    null. The <tt>type</tt> argument to the function is the <tt>type</tt>
     *                                    argument supplied to this function.
     * @param {Function|String} errorText The error text function like <tt>fn(val:String, submit:Boolean)</tt>, or
     *                                    error message as such, i.e. a String. Never null. The <tt>type</tt> argument
     *                                    to the function is the <tt>type</tt> argument supplied to this function.
     * @param {String}          type      The type of validation, e.g. "init" on initial validation on setup, "blur"
     *                                    on validation when <tt>$el</tt> looses focus, or "submit" when the form
     *                                    is about to be submitted. Supports user defined types, e.g. specific ones
     *                                    for specific views.
     * @param {ImprovedModel}   [model]   The model, if any, to have pending sync requests *tried* cancelled on error.
     *
     * @return {{changed:Boolean, value:String}} The (successfully) validated value, where <tt>changed</tt> indicate
     *         a changed value, and <tt>value</tt> will be null if invalid.
     *
     * @see    #clearValidationError
     */
    function validateInputField($el, validator, errorText, type, model, tooltip, showErrorToUser) {
        var value = val($el) || "",
            changed = value !== $el._lastValue,
            erroneous = !changed && $el._erroneous,
            error;
        $el._lastValue = value;

        if (!erroneous && validator(value, type, $el)) {
            // We do not want to trigger a change while going from one valid value, to some invalid value, then
            // back to the same valid value again; only on a different valid value...
            changed = value !== $el._lastValidValue;
            $el._lastValidValue = value;
            $el._erroneous = null;
            clearValidationError($el);

            // Do not report error for same text again, e.g. keyup can be because of meta keys...
        } else if (changed || !$el.hasClass("validation-error")) {
            // Used carried erroneous for consistent error messages...
            if (erroneous) {
                type = erroneous;
            }

            error = isString(errorText) ? errorText : errorText(value, type, $el);

            if (showErrorToUser || type === "submit") {
                $el.addClass("validation-error"); // e.g. Input type="text"
                $el.parent().addClass("validation-error"); // e.g. form

                if (error && tooltip) {
                    $el.attr("data-original-title", error);
                }
            }

            log.verbose("Input validation failed on '" + type + "' ~ '" + value + "' -> <" + error + ">", $el);

            // Model bound to this view only if so configured. If so, cancel any *pending* request, i.e. debounced save.
            // If so, we clear the last successful value to ensure we trigger a change for the valid value again on
            // next successful validation. Better to sync one too many times that one too little...
            if (model && SyncManager.cancel(model, "save")) {
                log.verbose("Cancelling pending sync: " + model, model);
                $el._lastValidValue = null; // only here if actual cancelled...
            }

            value = null;
        } else {
            value = null; // not changed, but still invalid!
        }

        // Set this here as we might coerce into carried erroneous type..
        $el._lastType = type;

        return { changed: changed, value: value };
    }

    /**
     * Setup the tooltip on the validation field
     * This function is responsible to setup the tooltip on the bottom/right of each field.
     *  - The tooltip must to be aligned with the exclamation icon
     *  - The tooltip should disapear once that the user press focus, however
     *  the tooltip should comeback if the user put hover again.
     *  - The position of tooltip should be calculated automatically
     *
     * @param {Object}          [$el]     The jQuery element validated; never null.
     * @param {Function|String} errorText The error text function like <tt>fn(val:String, submit:Boolean)</tt>, or
     *                                    error message as such, i.e. a String. Never null. The <tt>type</tt> argument
     *                                    to the function is the <tt>type</tt> argument supplied to this function.
     */
    function setupTooltip($el, errorText) {
        $el.tooltip({
            placement: "bottom",
            animation: false
        });

        $el.mouseover(function () {
            // Get the STRING message of the errorText
            var error = isString(errorText) ? errorText : errorText(val($el), "mouseover", $el);

            // Check if the error still valid
            if (!isBlank(error)) {
                $el.tooltip("show");
                var $tooltip = $(".tooltip"),
                    leftPos,
                    tooltipWidth = $(".tooltip").width();

                // Offset to the right of the element
                leftPos = $el.position().left + $el.outerWidth() - tooltipWidth / 2;

                // Align the element in the center of the icon
                if ($el.is("input")) {
                    leftPos -= 20;
                } else {
                    leftPos -= 32;
                }

                $tooltip.css({ "left": leftPos + "px", "width": $tooltip.width() + "px" });
            } else {
                $el.tooltip("hide");
            }
        });

        $el.focus(function () {
            $el.tooltip("hide");
        });
    }

    /**
     * @type {*}
     */
    return Marionette.Behavior.extend({

        defaults: {
            isSubmitted: false,

            buttonSubmit: null,

            inputValidation: null,

            isEnabled: true,

            /*
             *  This function if there are still missing fields to be filled in the right way or not.
             *  In case that everything is fine, the button will be green. Otherwise, it will continues to be black.
             */
            applyFormStateBehavior: function applyFormStateBehavior() {
                if (isString(this.buttonSubmit)) {
                    var $elButtonSubmit = $(this.buttonSubmit);

                    var isFormValid = true;
                    each(this.inputValidation, function (elem) {
                        isFormValid = elem.isChecked && isFormValid;
                    });

                    if (isFormValid) {
                        $elButtonSubmit.removeClass("btn-not-valid");
                        $elButtonSubmit.addClass("btn-valid");
                    } else {
                        $elButtonSubmit.removeClass("btn-valid");
                        $elButtonSubmit.addClass("btn-not-valid");
                    }
                }
            },

            /**
             * Conditions to the validation be fired
             *
             *  This function will determine when the validation can be fired:
             *      eg: After submit, After submit (key up), After blur, After blur(key up)
             *
             * @param {Object}                             validator The validator of the associated field
             * @param {Function|String} type               Type of event
             * @param {Function|String} validateAfter      String saying if the element wish to be validate before or after submit
             *
             */
            validateTriggerCondition: function validateTriggerCondition(validator, type, validateAfter) {
                if (type === "submit") {
                    this.isSubmitted = true;
                }

                if (type === "blur") {
                    validator.isAlreadyFired = true;
                }

                return validator.isAlreadyFired || this.isSubmitted || validateAfter && validateAfter !== "submit";
            }
        },

        /*
         * Create a validator object with all parameters already initialized in the right way
         *
         *  This function will determine when the validation can be fired:
         *      eg: After submit, After submit (key up), After blur, After blur(key up)
         *
         * @param {Object} $el                            jquery element
         * @param {Object} type                           Type of event
          */
        createObject: function createObject($el, options) {
            var behaviorClass = this,
                validator = isString(options.validator) ? this[options.validator] : options.validator,
                button = isFunction(behaviorClass.options.buttonSubmit) ? behaviorClass.options.buttonSubmit : null,
                view = this.view,
                errorText = options.errorText;

            if (typeof options.tooltip === "undefined") {
                options.tooltip = true;
            }

            if (isFunction(errorText)) {
                errorText = errorText.bind(view);
            }

            // Maintain scope, e.g. to reference view models from validators and sequential buttons...
            validator = validator.bind(view);

            if (button) {
                button = button.bind(view);
            }

            return {
                $el: $el,
                validator: validator,
                errorText: errorText || "",
                isAlreadyUsed: false,
                options: options || {},
                behaviorClass: behaviorClass,

                /**
                 * Add a SYNC event for the field
                 *
                 * @param {String} [events]        String containing the name of the events that will fire the validation.
                 * @param {Boolean} [hideTooltip]  It should be true, if the tooltip will be hidden.
                 */
                addEvent: function addEvent(events, hideTooltip) {
                    var _this = this;

                    if (options.tooltip && hideTooltip) {
                        // Hide the element when you are typing
                        this.$el.tooltip("hide");
                    }
                    // Apply always onblur validate for the fields
                    this.$el.on(events, function (event) {
                        _this.handleEvent(event.type);
                    });
                },

                /**
                 * Handle the event
                 *
                 * @param {String} [event]   Type of the event that was fired
                 */
                handleEvent: function handleEvent(event, recursive) {
                    var showErrorToUser = this.behaviorClass.options.validateTriggerCondition(this.validator, event, this.options.validateAfter),
                        value = validateInputField(this.$el, this.validator, this.errorText, event, this.options.model ? this.behaviorClass.view.model : null, options.tooltip, showErrorToUser);

                    this.options.isChecked = value.value !== null;

                    // Do not trigger a "change" on init or on focus, but on "blur" or any user defined
                    // event if and only if the value is actually changed...
                    if (value.value !== null && value.changed && event !== "init" && event !== "focus") {
                        // This is a *view* change, not a model change. The selector for $el is already
                        // available as $el.selector...
                        this.behaviorClass.view.trigger("change", this.$el, value.value, view);
                    }

                    // Function = SequentialButton enable hook to be called with true for no error, false otherwise. We
                    // have to toggle its state based on all input validation fields, not just the current one...
                    if (!recursive) {
                        if (button) {
                            button(view.inputValidation(event, true));
                        } else if (this.behaviorClass.options.buttonSubmit) {
                            this.behaviorClass.options.applyFormStateBehavior();
                        }
                    }

                    return this.options.isChecked;
                }
            };
        },

        // Collection with all validate objects.
        collectionValidateObjects: [],

        onRender: function onRender() {
            var _this2 = this;

            // parameter to disable or enable the ValidateBehavior.
            var isEnabled = isFunction(this.options.isEnabled) ? this.options.isEnabled() : this.options.isEnabled;

            // Handle input validators...
            if (this.options.inputValidation && isEnabled) {
                log.info("Initializing ValidateBehavior");

                this.collectionValidateObjects = [];

                // Once validators have been set up, "inputValidation" will be replaced with a function that
                // will perform the same validation when invoked...
                each(this.options.inputValidation, function (options, element) {
                    var $el = this.$el.find(element);

                    if ($el.length) {
                        // Create a instance of the object
                        var validatorObject = this.createObject($el, options);
                        // Initialize the tooltip, if any...
                        if (validatorObject.errorText && options.tooltip) {
                            setupTooltip($el, validatorObject.errorText);
                        }
                        // Bind the events
                        this.bindEvents(validatorObject);
                        // Save to list of all handleEvents...
                        this.collectionValidateObjects.push(validatorObject);
                    } else {
                        log.warn("No such element to validate: '" + element + "' -> " + this, options);
                    }
                }, this);

                /**
                 * Validates all input fields with configured validators for the specified type, e.g. "submit",
                 * and returns true if all input fields validated successfully, false otherwise.
                 *
                 * @param {String|Boolean} [type]  If a string, the validation type performed, defaults to
                 *                                 "submit". If true, it will give focus to the first element
                 *                                 failing a validation.
                 *
                 *
                 * @return {Boolean} True if all configured input fields could be validated for the specified
                 *                   type, false otherwise.
                 */
                this.view.inputValidation = this.validateAllInputs.bind(this);

                // Once that the page starts will do the first validation
                defer(function () {
                    // Fire the first time
                    _this2.validateAllInputs("init");
                });
            }
        },
        /**
         * This function will be called for the view. It will fire all validators and check if is everything ok.
         *
         * @param {Boolean} [type]      If it's a boolean we replace that for a submit event
         * @param {Boolean} [recursive] True if validation is called recursive, false otherwise (default).
         */
        validateAllInputs: function validateAllInputs(type, recursive) {
            if (isBoolean(type)) {
                type = null;
            }

            var i,
                allOk = true;

            for (i = 0; i < this.collectionValidateObjects.length; i++) {
                allOk = this.collectionValidateObjects[i].handleEvent(type || "submit", recursive) && allOk;
            }

            return allOk;
        },

        /**
         * Bind (Sync/Async) events to the input
         *
         * @param {Object} [validatorObject]  The validator object with all settings of the field
         */
        bindEvents: function bindEvents(validatorObject) {
            var _this3 = this;

            // Async validator(s)?
            if (validatorObject.options.validatorAsync) {
                each(validatorObject.options.validatorAsync, function (asyncOptions, event) {
                    _this3.view.listenTo(asyncOptions.source, event, function () {
                        // Carry async validation state over to normal validators on no change
                        // in input, or we will clear error messages generated by asynchronous
                        // validation...

                        var handleAsyncValidator = function () {
                            return asyncOptions.validator.apply(this, args);
                        }.bind(this);

                        var args = toArray(arguments),
                            valid = validateInputField(validatorObject.$el, handleAsyncValidator, validatorObject.errorText, "async", validatorObject.options.model ? this.model : null, validatorObject.options.tooltip);

                        validatorObject.$el._erroneous = valid ? null : "async";
                    });
                });
            }

            // Sync Validators
            // Add custom events, if any the function has received one different like blur
            if (validatorObject.options.events) {
                validatorObject.options.events = isArray(validatorObject.options.events) ? validatorObject.options.events.join(" ") : validatorObject.options.events;
                validatorObject.addEvent(validatorObject.options.events);
            } else {
                if (validatorObject.$el.is("select")) {
                    // Validate whenever the user change the field
                    validatorObject.addEvent("change");
                } else {
                    validatorObject.addEvent("keyup", true);
                }
                // Apply always onblur validate for the fields
                validatorObject.addEvent("blur", true);
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var GroupModel = __webpack_require__(104);
    var Breakpoint = __webpack_require__(372);
    var ExperienceModel = __webpack_require__(58);

    /**
     * Represents a group of <tt>Breakpoint</tt>'s - referencing <tt>ExperienceModel</tt>'s.
     *
     * @class BreakpointGroup
     */

    var BreakpointGroup = GroupModel.extend("BreakpointGroup", {

        /**
         * @inheritDoc
         */
        types: [Breakpoint, ExperienceModel],

        getAssetByThreshold: function getAssetByThreshold(threshold) {
            var found = this.get("entries").find(function (entry) {
                var value = entry.get("value");
                return value && value.get("threshold") === threshold;
            });

            return found && found.get("asset");
        },

        /**
         * Compare two sets of breakpoint thresholds. They are considered equal if the two sets have same number of
         * thresholds and each threshold has a match.
         *
         * Note: if there is no breakpoint in the group, it is considered equal
         *
         * @param {Breakpoint[]} otherLowerBounds   An array of breakpoints
         * @returns {Boolean} True if they are equal, false otherwise.
         */
        compareThresholds: function compareThresholds(otherLowerBounds) {
            var myLowerBounds = this.getValues();
            var sameNumOfBreakpoints = myLowerBounds.length === otherLowerBounds.length;

            if (!this.hasBreakpoints()) {
                return true;
            }

            if (!sameNumOfBreakpoints) {
                return false;
            }

            return _.every(otherLowerBounds, function (breakpoint) {
                return _.find(myLowerBounds, function (bp) {
                    return breakpoint.get("threshold") === bp.get("threshold");
                });
            });
        },
        hasBreakpoints: function hasBreakpoints() {
            return this.getValues().length;
        }
    }, {

        /**
         * @inheritDoc
         */
        type: "BreakpointGroup"

    });

    return BreakpointGroup;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__ = __webpack_require__(3159);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(3168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__api__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseclient__ = __webpack_require__(3169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__baseclient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basebackend__ = __webpack_require__(3171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__basebackend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__request__ = __webpack_require__(3172);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__request__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sdk__ = __webpack_require__(3173);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_6__sdk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transports_noop__ = __webpack_require__(1255);
/* unused harmony reexport NoopTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__integrations__ = __webpack_require__(3174);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_8__integrations__; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');
var $Number = GetIntrinsic('%Number%');
var $RegExp = GetIntrinsic('%RegExp%');
var $parseInteger = GetIntrinsic('%parseInt%');

var callBound = __webpack_require__(45);
var regexTester = __webpack_require__(733);
var isPrimitive = __webpack_require__(734);

var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace(value, trimRegex, '');
};

var ToPrimitive = __webpack_require__(290);

// https://ecma-international.org/ecma-262/6.0/#sec-tonumber

module.exports = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
	if (typeof value === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		}
		var trimmed = $trim(value);
		if (trimmed !== value) {
			return ToNumber(trimmed);
		}

	}
	return $Number(value);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var ImprovedModel = __webpack_require__(25);
    var ViewerEvents = __webpack_require__(153);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Preconditions = __webpack_require__(14);
    var channelBridge = __webpack_require__(241);

    var log = new Logger("Action");

    /**
     * An action that can be attached to a widget and activated from within the Viewer. This type of action is
     * <b>not</b> used by the Editor itself, only by the Viewer, but Action behaviour when activated can be
     * different in the Editor, for example giving an alert message that a Custom JS Action can only be
     * activated when embedded on the actual client site defining the JS to call. <p>
     *
     * An action can be <i>instantaneous</i>, i.e. completely done once has been executed, or it can be
     * <i>pending</i>, i.e. triggers something that has a duration, like an opened lightbox. In the latter case,
     * such actions may be unfinished when the Viewer unloads and it will therefor call <tt>close()</tt> on
     * each such pending action. <p>
     *
     * Once an a action has been triggered directly by a user, auto play will be disabled for the Experience
     * in question, but not for its embedded or sibling Experiences. It can still be paused/unpaused, but
     * it really has no effect then. <p>
     *
     * Any action has the following type (protected) properties, where the latter two can be overridden by
     * corresponding data (instance) attributes, excluding "_" prefix e.g. "paused" attribute will default
     * to <tt>_paused</tt> (type) property:
     *
     * <ul>
     * <li> TYPE:            String  - a mandatory static attribute storing the unique type/name of the action, e.g.
     *                                 "link" or "customJs". The type will be persisted as a <tt>type</tt> property as
     *                                 well, to allow for re-created of Actions based on json instance data.
     *
     * <li> _clientSpace:    Boolean - true if the action requires access to client space, false otherwise. Default false,
     *                                 for now "static" for the specific Action type.
     *
     * <li> _event:          String  - a non-persisted field storing the event to trigger when activated in the viewer.
     *                                 Default null. If specified (perhaps as an attribute), the event will be triggered like
     *                                 (event, target:Action, experienceId:String, ..)</tt>, where the .. are the arguments
     *                                 optionally returned by <tt>_activate(..)</tt>.
     *
     * <li> _pendingEvent:   String|String[]  - a non-persistent field storing the event that signals the completion of a
     *                                          pending action, fired by the action it self, like the closing of a lightbox that
     *                                          has been opened when the lightbox was executed. Default null. An instantaneous
     *                                          action can be a scene navigation that will not use this type of event. If
     *                                          specified, perhaps as an attribute, the Viewer will consider the action pending
     *                                          until handled, ensuring that the action will be <tt>close()</tt> if the Viewer
     *                                          is closed while the action is pending. The action implementation can trigger this
     *                                          action via <tt>_trigger(..)</tt>.
     *
     * <li> _stalled:         Boolean - true to stall all reachable Experiences on activation, including all parents and
     *                                  siblings, recursively, false otherwise (default). Any Experience stalled will
     *                                  also be paused. If a pending Action, the Experience(s) will be unstalled again
     *                                  when the Action completes, triggering a potential pause change to that of the
     *                                  value at stall time; otherwise the context must ensure this itself.
     * <li> _paused:          Boolean - true to pause the Experience on activation, including all parents recursively
     *                                  embedding it if any, false otherwise (default). If a pending Action, the
     *                                  Experience(s) will be started again when the Action completes; otherwise the
     *                                  context must ensure this itself. If <tt>autoPlay</tt> has been set to false
     *                                  for a given Experience, it unpausing will not resume auto play.
     * <li> _autoPlay:        Boolean - false to disable auto play on activation permanently for the current Experience
     *                                  only (not recursive!), true otherwise. Default true. If set to false on
     *                                  activation, unpausing will not start auto play again. Cannot set set to true
     *                                  again once set to false, e.g. if another Action has disabled auto play, a
     *                                  true value here will be ignored.
     * </ul>
     *
     * Sub-types must implement <tt>_activate(experienceViewModel:ExperienceViewModel):Boolean</tt> to perform the
     * actual action logic, but refrain from triggering events (unless multiple events are required, e.g. on lightbox
     * close as well), pausing the experience, etc. All the boiler plate is handled by this <tt>Action</tt> super-type
     * based on the value of the above properties. <p>
     *
     * To pass along additional arguments with triggered events, return them from <tt>_activate(..)</tt>. <p>
     *
     * In addition. a protected <tt>_log(message:String, type:String)</tt> function will be available for actual
     * implementations when logging is required.
     *
     * @class Action
     * @constructor
     */
    return ImprovedModel.extend("Action", { // TODO: why is an Action both data and behaviour

        embedded: true, // since it has an id and we do not want to call the server on sync!

        defaults: {

            /**
             * @type {String}
             * The fixed type of this Action, corresponding to the static <tt>TYPE</tt> property. <p>
             *
             * Always set in the constructor.
             */
            type: null
        },

        /**
         * @protected @type {Boolean}
         * True if this action requires access to the client page, false otherwise (default). <p>
         *
         * An action that *always* requires access to client space is for example a SalesforceCommerce QuickView Action
         * that calls client defined behaviour to open the Quickview.
         */
        _clientSpace: false,

        /**
         * @protected @type {String}
         * The event triggered when an Action cannot be activated, or if the activation fails because of an exception.
         */
        _errorEvent: ViewerEvents.VIEWER_ERROR,
        /**
         * @protected @type {String|String[]}
         * The standard Viewer event(s) to trigger when activated, if any (default no event). <p>
         *
         * For any event specified, the triggered Viewer event will be passed along the following arguments,
         * in order:
         * <ul>
         * <li> target:Action       - this action instance
         * <li> experienceId:String - the Experience id.
         * <li> ..:*                - additional var args, if any, returned via <tt>_activate(..)</tt>.
         * </ul>
         *
         * If an action needs to trigger additional events, it can uses its protected
         * <tt>_trigger(name:String, experienceViewModel:ExperienceViewModel)</tt> function to do so. <p>
         *
         * If the corresponding named attribute is defined on an instance of this action, stored as a String (array),
         * it will override this value. The attribute can also be set in <tt>_activate()</tt>, but <b>must</b> be
         * defined in <tt>ViewerEvents</tt>! <p>
         *
         * @see #pendingEvent
         * @see #_trigger
         * @see #_activate
         */
        _event: null,
        /**
         * @protected @type {String}
         * Specifies the single Viewer event the Experience Viewer will listen for in order to determine that this pending
         * Action has completed. Default null, meaning this Action is treated as an instantaneous action. <p>
         *
         * A pending Action is an action that starts something that eventually will complete. Like an opened lightbox
         * that will eventually be closed. <p>
         *
         * The specific Action implementation will trigger this event when relevant (not done via <tt>activate()</tt>
         * like for <tt>event</tt>), and this base type will ensure that any pending Action will be stored in the
         * <tt>ExperienceViewModel</tt> used. When the Experience Viewer is closed, any Actions for which this event
         * has not been triggered, will have their <tt>close()</tt> method forcefully invoked, e.g. to ensure that
         * an opened Lightbox will be closed. <p>
         *
         * The event will be triggered with the name specified here, and with the additional arguments as
         * documented for <tt>event</tt>. <p>
         *
         * If the corresponding named attribute is defined on an instance of this action, stored as a String (array),
         * it will override this value. The attribute can also be set in <tt>_activate()</tt>, but <b>must</b> be
         * defined in <tt>ViewerEvents</tt>! <p>
         *
         * @see #close
         * @see #event
         * @see #_trigger
         */
        _pendingEvent: null,
        /**
         * @protected @type {Boolean}
         * True to pause the Experience and all its parents recursively, if any, on activation. Siblings will not
         * be affected by this, e.g. if the parent Experience embeds other Experiences besides the current one,
         * those will not be paused by this (but see <tt>stalled</tt>). <p>
         *
         * If this action is a pending Action, it will be unpaused again once this Action completes, i.e. when
         * <tt>pendingEvent</tt> fires. If not a pending Action, the context using this Action must handle this
         * itself. <p>
         *
         * If the corresponding named attribute is defined on an instance of this action, it will override this value.
         * The attribute can also be set in <tt>_activate()</tt>. <p>
         *
         * On unpause, auto play will only commence again if <tt>autoPlay</tt> is true. <p>
         *
         * Default false.
         *
         * @see #autoPlay
         * @see #stalled
         */
        _paused: false,
        /**
         * @protected @type {Boolean}
         * True to stall all Experiences reachable from the top most Experience, i.e. the Experience embedding all
         * others recursively, false otherwise. Note that if the top most Experience is viewed on a direct url,
         * there may be other sibling Experience to it that cannot be stalled because of cross domain issues. <p>
         *
         * If this action is a pending Action, all reachable Experiences will be unstalled again once this Action
         * completes, i.e. when <tt>pendingEvent</tt> fires, trigger a restore of the paused state it had at stall
         * time (unless changed in the mean time). If not a pending Action, the context using this Action must
         * handle this itself. <p>
         *
         * If the corresponding named attribute is defined on an instance of this action, it will override this value.
         * The attribute can also be set in <tt>_activate()</tt>. <p>
         *
         * Default false.
         *
         * @see #paused
         */
        _stalled: false,
        /**
         * @protected @type {Boolean}
         * True to enable auto play for the Experience on activation, false to disable it permanently. Auto play
         * will only be run if the Experience is not paused. <p>
         *
         * Disabling auto run is not a recursive operation - it will only affect the Experience the user interacted
         * with. And once auto run is disabled, it will never be enabled again for said Experience; that is, if some
         * other Action has disabled auto run, a true value here will be ignored. <p>
         *
         * If the corresponding named attribute is defined on an instance of this action, it will override this value.
         * The attribute can also be set in <tt>_activate()</tt>. <p>
         *
         * Default false, i.e. auto play will be disabled on activation.
         *
         * @see #paused
         * @see #stalled
         */
        _autoPlay: false,

        constructor: function constructor() {
            this.__super(); // will set all attributes if specified...

            // All Actions define a static Type property we must persist as an instance property, to re-create the
            // specific Action based on json data again. We know we have a super constructor already, so we use its
            // reference to get the static TYPE...
            var actionType = this.constructor.TYPE;

            var type = this.get("type");

            // Only empty on creation, not when loaded via json data...
            if (!type) {
                this.set("type", type = actionType, { silent: true }); // nobody listening yet anyways
            }
            Preconditions.checkState(actionType && type === actionType, "Action type mismatch: '" + type + "' != '" + actionType + "'");
        },


        /**
         * @protected @type {Function}
         * Logs the specified message for this action, qualified with its type and action state.
         *
         * @param {String}  message  The message to log.
         * @param {String}  [lvl]    The log level: "error", "warn", "info", or "verbose" (default). If error or warn,
         *                           an error will be reported via the error logger.
         */
        _log: function _log(message, lvl) {
            var msg = "<" + this.get("type") + "> " + message + ": " + this;
            if (lvl === "error") {
                Preconditions.fail(msg, this); // will log error to console and report error via error logger when enabled
            } else if (lvl === "warn") {
                Preconditions.warn(msg, this); // will log warning to console and report error via error logger when enabled
            } else {
                log[lvl || "verbose"](msg, this);
            }
        },


        /**
         * Returns true if this action is currently considered activateable, false otherwise. The actual logic
         * implemented in <tt>activate(..)</tt> function will only be performed if this function returns true at
         * call time. <p>
         *
         * The activation can still fail, of course, even if this function returns true. <p>
         *
         * Actual sub-types can override <tt>_activateable(experienceViewModel:ExperienceViewModel): String</tt> to
         * add additional logic. The logic here will ensure an <tt>ExperienceViewModel</tt> is available and that
         * we are embedded via channels if <tt>clientSpace</tt> is true for this Action.
         *
         * @param {ExperienceViewModel} experienceViewModel The experience view model to use for this action;
         *                                                  can be falsey, in which case false is returned.
         * @return {Boolean} True if this action can be activated, false otherwise.
         *
         * @see    #activate
         */
        activateable: function activateable(experienceViewModel) {
            // second boolean arg used for private use!
            var error = void 0;

            if (!experienceViewModel) {
                error = "No experience view model";
            } else if (this._clientSpace && !channelBridge()) {
                error = "Action can only be invoked when embedded";
            } else {
                // See if we have a specific error to report...
                error = this._activateable(experienceViewModel);
                if (error && typeof error !== "string") {
                    error = "Action is not activateable";
                }
            }

            var internal = arguments.length <= 1 ? undefined : arguments[1];
            if (error) {
                if (internal) {
                    this._log(error + ", cannot activate", "warn");
                    return error; // private
                }
                return false; // public
            } else if (internal) {
                return null; // private
            }

            return true; // public
        },


        /**
         * @protected
         * Returns the instance attribute value for the specified name, defaulting to the prototypical
         * behaviour of the similar but protected type attribute.
         *
         * @param  {String} name The attribute name, e.g. "paused" for "_paused" default; cannot be falsey.
         * @return {*} The desired value; can be falsey.
         */
        _value: function _value(name) {
            var value = this.get(name); // instance data
            // eslint-disable-next-line eqeqeq
            if (value != null) {
                return value;
            }

            return this["_" + name]; // prototype data, protected!
        },


        /**
         * @private
         * Optionally triggers the ExperienceViewModel '"change:" + name = true' event, and the reverse when
         * the <tt>pendingEvent</tt> is fired (if any).
         *
         * @param  {String}              name                The attribute and event name to trigger, e.g.
         *                                                   "paused" or "stalled"; cannot be falsey.
         * @param  {ExperienceViewModel} experienceViewModel The model to potential trigger the change on; cannot
         *                                                   be falsey.
         *
         * @return {Boolean} True the view model was tried set with a true value (which may not trigger a change),
         *                   false otherwise.
         */
        _triggerChange: function _triggerChange(name, experienceViewModel) {
            // not called for "autoPlay" change!
            var value = this._value(name);
            // The test for a true value here is intentional - we do not care about false here; that is, a value
            // of false should not trigger a change...
            if (value) {
                experienceViewModel.set(name, true);

                var pendingEvent = this._value("pendingEvent");
                if (pendingEvent) {
                    this.listenToOnce(ViewerEvents, pendingEvent, function () {
                        experienceViewModel.set(name, false);
                    });
                }
            }
            return value;
        },


        /**
         * Activates this action, triggering a relevant viewer event and potentially stops auto play. <p>
         *
         * This will delegate the actual work to
         * <tt>_activate(experienceViewModel:ExperienceViewModel, bridge:ChannelBridge)</tt>. <p>
         *
         * Any exceptions will be caught, reported, then silently suppressed and false will be returned.
         *
         * @param {ExperienceViewModel} experienceViewModel The experience view model to use for this action;
         *                                                  never falsey. If this Action is a pending Action,
         *                                                  this Action will add it self to the set of Actions
         *                                                  for the model in question, to be removed again ("closed")
         *                                                  once the Action completes or the Viewer closes, which
         *                                                  ever comes first.
         *
         * @return {Boolean} True if this action as indeed successfully activated, false otherwise.
         *
         * @see    #activateable
         */
        activate: function activate(experienceViewModel) {
            var _this = this;

            // TODO: what if executed multiple times?
            // Make sure we can activate this action...
            var error = this.activateable(experienceViewModel, true); // true: internal, we want the error message
            if (error) {
                this._trigger("errorEvent", experienceViewModel, { error: error, type: "activateable" });
                return false;
            }

            // Can be undefined...
            var eventArgs = void 0;

            // Do the work, getting back additional event arguments if required by this Action...
            try {
                eventArgs = this._activate(experienceViewModel);
            } catch (e) {
                this._log("Activation failed: " + e, "error");
                this._trigger("errorEvent", experienceViewModel, { error: e, type: "activate" });
                return false;
            }

            // Action successfully activated, so trigger viewer event for this action if specified...
            this._trigger("event", experienceViewModel, eventArgs);

            // Trigger potential *non recursive* "autoPlay" change, respecting if already disabled as
            // a whole for this Experience?...
            if (experienceViewModel.get("autoPlay") && !this._value("autoPlay")) {
                // i.e. "AND" operation
                experienceViewModel.set("autoPlay", false); // can only disable, never re-enable!
            }

            // Trigger potential *recursive* "stalled" change?
            this._triggerChange("stalled", experienceViewModel);

            // Trigger potential *recursive* "pause" change?
            this._triggerChange("paused", experienceViewModel);

            var pendingEvent = this._value("pendingEvent");
            if (pendingEvent) {
                this._log("Pending action activated", "info");
                experienceViewModel.get("pendingActions").push(this);

                // Remove again on close..,
                this.listenToOnce(ViewerEvents, pendingEvent, function () {
                    _this._log("Pending action complete", "info");

                    var actions = experienceViewModel.get("pendingActions");
                    var i = actions.length;

                    while (i--) {
                        if (actions[i] === _this) {
                            actions.splice(i, 1);
                            break;
                        }
                    }

                    // An Action is not a View, so we have to stop listening manually in
                    // case we were listening to for example the ExperienceViewModel...
                    _this.stopListening();
                });
            } else {
                this._log("Action activated", "info");
            }

            return true;
        },


        /**
         * Closes this Action if this Action is a pending action where <tt>pendingEvent</tt> has not been triggered
         * yet. <p>
         *
         * If this Action is not a pending Action type, this is a no-op.
         *
         * @see #pendingEvent
         */
        close: function close() {
            // Default implementation does nothing...
        },


        /**
         * Triggers the specified Viewer event(s), e.g. "event" or "pendingEvent", passing along this action as the
         * first argument, the experience id as the second, followed by the specified additional event arguments,
         * if any. <p>
         *
         * The event name(s) supplied need not be only <tt>event</tt> or <tt>pendingEvent</tt>, but can be any
         * valid Viewer event triggered by this Action that is defined either as an attribute or as a prototype property.
         *
         * @param {String}              name                The attribute name of the event name to trigger, if any,
         *                                                  e.g. "event" or "pendingEvent"; a falsey resolved value means
         *                                                  no event will be triggered. Additional ones can be triggered
         *                                                  if defined in the action as an attribute or as a prototype
         *                                                  property.
         * @param {ExperienceViewModel} experienceViewModel The experience view model; never falsey.
         * @param {*|[]}                [eventArgs]         Additional event arguments to pass along as the 3'rd, 4'th,
         *                                                  etc arguments for the event triggering, if any. Will have
         *                                                  been obtained as the result value from <tt>_activate(..)</tt>.
         *
         * @see   #event
         * @see   #pendingEvent
         * @see   #_value
         * @see   ViewerEvents
         */
        _trigger: function _trigger(name, experienceViewModel, eventArgs) {
            // Either null, or String(s) storing the name of the Viewer event(s) to trigger...
            var events = this._value(name);
            if (events) {
                if (!_.isArray(events)) {
                    events = [events];
                }

                var experienceId = experienceViewModel.get("experience").get("id");
                var event = void 0;
                var args = void 0;
                var i = void 0;

                for (i = 0; i < events.length; i++) {
                    event = events[i];
                    args = [event, this, experienceId]; // Experience id is at least used by Channels

                    if (typeof eventArgs !== "undefined") {
                        if (_.isArray(eventArgs)) {
                            args = args.concat(eventArgs);
                        } else {
                            args.push(eventArgs);
                        }
                    }

                    // All ViewerEvents constants will be auto mapped to strings as required, also for inversion of
                    // control when others are listening on ViewerEvents. Hence, this will work with both strings
                    // and ViewerEvents constants...
                    ViewerEvents.trigger.apply(ViewerEvents, _toConsumableArray(args));
                }
            }
        },


        /**
         * @protected
         * Returns true if this Action is considered activateable, false otherwise. <p>
         *
         * When invoked, this action will already be validated against running in <tt>clientSpace</tt> if so configured.
         *
         * @param  {ExperienceViewModel} experienceViewModel The experience view model; never falsey.
         * @return {String|*} If a string, a blank/null string means activateable, otherwise the error message to report
         *                    if not activateable, e.g. missing a product id for some product action. Otherwise
         *                    coerced into a boolean, where a truthy value means error, falsey means no error and thus
         *                    activateable.
         * @see    #_activate
         */
        _activateable: function _activateable() {
            return false; // no error by default
        },


        /**
         * @typedef ActionDomElement
         * @property {HTMLElement} element - DomElement
         * @property {Boolean} isWrapper   - Indicates if the DomElement has to wrap the children elements
         */

        /**
         * This function can be overriden.
         * Allow an {@see Action} to create an element that can be injected with the widget.
         *
         * eg: {@see AbstractWidgetView} and the {@see LinkAction} for exemple usage.
         * @param {HTMLElement} rootElement - The root element
         * @returns {ActionDomElement}
         */
        getElement: function getElement(rootElement) {
            // eslint-disable-line no-unused-vars
            return {};
        },


        /**
         * @protected
         * @abstract
         * Activates this action.
         *
         * @param {ExperienceViewModel} experienceViewModel The experience view model; never falsey.
         * @see    #_activateable
         */
        _activate: null

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var EditorEvents = __webpack_require__(17);
    var EventDispatcher = __webpack_require__(54);
    var KeyCode = __webpack_require__(88);
    var Icons = __webpack_require__(357);
    var Marionette = __webpack_require__(10);
    var SpinnerView = __webpack_require__(244);
    var ViewScope = __webpack_require__(171);

    var OVERLAY_CLASS = "zmags-lightbox-overlay";

    /**
     * Shows an element or a Backbone/Marionette view in a lightbox.
     *
     * @event open After the lightbox has been opened.
     * @event close After the lightbox has been closed.
     *
     * @author Bo Gotthardt (logic borrowed from https://github.com/buckwilson/Lightbox_me )
     * @class Lightbox
     */
    return EventDispatcher.extend({

        /**
         * @type {Window}
         */
        window: null,

        /**
         * The default position of the lightbox, when it fits within the window
         * viewport, defaults to `fixed`.
         *
         * @type {String}
         */
        defaultPosition: "fixed",

        /**
         * The default position of the lightbox, when it fits within the window
         * viewport, defaults to `fixed`.
         *
         * @type {String}
         */
        defaultTop: "50%",

        /**
         * @type {jQuery} jQuery wrapped Window instance.
         */
        $window: null,

        /**
         * @type {jQuery} jQuery wrapped Document instance.
         */
        $document: null,

        options: null,

        _element: null,

        _parentView: null,

        _spinnerElement: null,

        /**
         * @type {Backbone.View}
         */
        _view: null,

        /**
         * Disable the dynamic Element Positioning, if set to true and enables the user
         * to handle styling of the ligtbox $element with the customCSS
         *
         * @type {Boolean}
         */
        _disableElementPosition: null,

        /**
         * @private
         * @type {Number}
         * The zIndex to use for the Lightbox overlay, defaulting to a sensible value if not explicitly
         * specified as part of the options. The Lightbox contents will use this index + 1.
         */
        _zIndex: null,

        /**
         * @private @type {Boolean}
         * Guard against multiple closings, e.g. a contained View closing the Lightbox on close, while the Lightbox
         * close method will close the view.
         */
        _closed: false,

        /**
         * @constructor
         *
         * @param {jQuery|Backbone.View} element A <tt>jQuery</tt> wrapped element or a <tt>Backbone.View</tt> to show in the
         * lightbox (view will be closed/removed when the lightbox closes).
         *
         * @param {Object} options containing :
         *    @cfg {Window}  [win]                    The window to open the lightbox in. Optional, defaults to the current window.
         *    @cfg {Object}  [css]                    Optional CSS object to be applied (using jQuery) to the lightbox element.
         *    @cfg {String}  [lightboxClassName]      Optional class name to the lightbox element.
         *    @cfg {Boolean} [showSpinner]            Add a spinner on the overlay if you want visual feed back before the actual Lightbox render.
         *    @cfg {Boolean} [disableElementPosition] Disable the auto positioning if you want full control with css properties.
         *    @cfg {Number}  [zIndex]                 The z index to use for the lightbox overlay, defaulting to the
         *                                            highest z index found for any Creator Lightbox overlay in the
         *                                            dom for <tt>win</tt> + 1000.
         *
         * @param {View} parentView Optional ParentView which will provide its own view scope.
         *
         * Example usage:
         * <pre>
         *
         *  new Lightbox(element, // the view to show in the Lightbox
         *      { // options
         *          lightboxClassName: "my-lightbox",
         *          showSpinner: true,
         *          disableElementPosition: true,
         *          css: { // Pass just a width on the Lightbox or do specific styling like this.
         *              top: "40px",
         *              bottom: "40px",
         *              left: "40px",
         *              right: "40px",
         *              position: "fixed"
         *          }
         *      });
         *
         * </pre>
         */
        constructor: function constructor(element, options, parentView) {
            this._element = element;

            this.options = options || {};

            this._parentView = parentView;

            this._disableElementPosition = !!options.disableElementPosition;

            // Ensure context ("this" scope) for the following methods
            _.bindAll(this, "_setOverlayHeight", "_setElementPosition", "_keypress", "_doOpen");

            this.window = options.win || window;

            // Cache the jQuery objects that are used whenever we recalculate positions.
            this.$window = $(this.window);
            this.$document = $(this.window.document);

            // If no z index is specified, find all Creator overlays, and get the max z index + 1000; we cannot
            // simply multiple by the number of overlays as the z index can be specified. This will work both
            // in the Viewer and the Editor alike...
            this._zIndex = this.options.zIndex;
            if (!this._zIndex) {
                var max = 0;
                var overlays = this.$document.find("." + OVERLAY_CLASS);
                var z = void 0;
                var i = void 0;

                for (i = 0; i < overlays.length; i++) {
                    z = parseInt($(overlays[i]).css("zIndex"), 10) || 0; // TODO: easier way to do this?
                    if (z > max) {
                        max = z;
                    }
                }
                this._zIndex = max + 1000;
            }

            this.overlay = $("<div class=\"" + OVERLAY_CLASS + "\"></div>").css({
                position: "fixed",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                width: "100%",
                zIndex: this._zIndex,
                background: "black",
                opacity: 0.65
            });
        },
        _setupElement: function _setupElement() {
            // Place the styling directly on the elements so we don't need to handle injecting CSS into another window.
            var customCSS = this.options.css || {};
            var lightboxClassName = this.options.lightboxClassName || "";

            // Is the passed 'element' a Backbone.View?
            if (this._element instanceof Backbone.View) {
                // Save the reference so that we can close it/clean up after us
                this._view = this._element;

                ViewScope.register(this._parentView || this, this._view);

                this._element = this._element.render.call(this._element).$el;
            }

            this.closeButton = this.createCloseButton();

            this.$element = this.createRootElement(lightboxClassName);

            this.$element.css(customCSS).append(this.closeButton).append(this._element);

            // In case we have a Backbone.View, simulate the 'show' life cycle defined by Marionette
            if (this._view) {
                Marionette.triggerMethod.call(this._view, "show");
            }
        },


        /**
         * Close button shown inside the lightbox.
         * @returns {*|String}
         */
        createCloseButton: function createCloseButton() {
            return Icons.CLOSE_IN_BOX.createElement().css({
                position: "absolute",
                top: 15,
                right: 12,
                width: 28,
                height: 28,
                cursor: "pointer",
                zIndex: this._zIndex
            });
        },


        /**
         * Creates the lightbox root element.
         * @param {String} lightboxClassName - optional lightbox class name
         * @returns {*|HTMLElement}
         */
        createRootElement: function createRootElement(lightboxClassName) {
            var $zmagsLightbox = $("<div class='zmags-lightbox'></div>");

            if (lightboxClassName) {
                $zmagsLightbox.addClass(lightboxClassName);
            }

            return $zmagsLightbox;
        },


        /**
         * Open the lightbox.
         */
        open: function open() {
            if (this.options.showSpinner) {
                // Overwrite color on the spinner, since it will be shown on the dark overlay
                this._spinnerElement = new SpinnerView({ color: "#afafaf" });

                $(this.window.document.body).append(this.overlay).append(this._spinnerElement.render().$el);
            } else {
                $(this.window.document.body).append(this.overlay);
            }

            _.delay(this._doOpen, 50);

            if (this.options.editorEventProperties) {
                EditorEvents.trigger(EditorEvents.constants.OPEN_MODAL_WINDOW, this.options.editorEventProperties);
            }

            return this;
        },
        _doOpen: function _doOpen() {
            if (this._spinnerElement) {
                this._spinnerElement.destroy();
            }

            this._setupElement();

            $(this.window.document.body).append(this.$element);

            if (!this._disableElementPosition) {
                this._setElementPosition();

                this.$window.on("resize", this._setElementPosition) // TODO: use our Windows.on(..) for consistency!
                .on("scroll", this._setElementPosition);
            }

            this._setOverlayHeight();

            this.$window.on("resize", this._setOverlayHeight).on("keyup", this._keypress);

            if (this._parentView) {
                this.listenToOnce(this._parentView, "close", this.close);
            }

            if (this._view) {
                this.listenToOnce(this._view, "close", this.close);
            }

            this.overlay.on("activate", this.close.bind(this));
            this.closeButton.on("activate", this.close.bind(this));

            this.trigger("open", this);

            this.$element.addClass("open").css({ zIndex: this._zIndex + 1 });
        },


        /**
         * Close the lightbox, if not already. <p>
         *
         * @param {Object} options - options object
         * @property {Boolean} silent - whether to emit an event on close
         *
         * If already closed, this is a no-op.
         */
        close: function close() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            // To avoid triggering "close" events numerous times and to avoid doing dom work already done...
            if (this._closed) {
                return;
            }
            this._closed = true;

            // Handle Backbone/Marionette view close/remove. This might actually close this Lightbox recursively as a
            // close of the owning view may force a close of a used (this) Lightbox.
            if (this._view) {
                if (this._view.close) {
                    this._view.close();
                } else if (this._view.remove) {
                    this._view.remove();
                }
            }

            if (!this._disableElementPosition) {
                this.$window.off("resize", this._setElementPosition).off("scroll", this._setElementPosition);
            }

            this.$window.off("resize", this._setOverlayHeight).off("keyup", this._keypress);

            if (!options.silent) {
                // Trigger a close *before* we remove the actual element, to ensure iframes with contentWindows will still
                // be there for "close" listeners...
                this.trigger("close", this);
            }

            this.$element.remove();
            this.$element.removeClass("open");
            this.$element = null;

            this.overlay.remove();
            this.overlay = null;

            if (this.options.editorEventProperties) {
                EditorEvents.trigger(EditorEvents.constants.CLOSE_MODAL_WINDOW, this.options.editorEventProperties);
            }
        },
        _setOverlayHeight: function _setOverlayHeight() {
            if (this.$window.height() < this.$document.height()) {
                this.overlay.css({
                    height: this.$document.height() + "px"
                });
            } else {
                this.overlay.css({
                    height: "100%"
                });
            }
        },
        _setElementPosition: function _setElementPosition() {
            // If the height of $element is bigger than the window AND the $element isn't already position absolute
            if (this.$element.height() + 80 >= this.$window.height() && this.$element.css("position") !== "fixed") {
                // we position it where the user can see it, but they can still scroll
                // so the top offset is based on the user's scroll position.
                var topOffset = $(this.window.document).scrollTop() + 40;
                this.$element.css({
                    position: "absolute",
                    top: topOffset + "px",
                    marginTop: 0
                });
                // If the height is less than the window height
            } else if (this.$element.height() + 80 < this.$window.height()) {
                // Set the position according to the default positioning ("fixed")
                this.$element.css({
                    position: this.defaultPosition,
                    top: this.defaultTop,
                    marginTop: this.$element.outerHeight() / 2 * -1
                });
            }

            this.$element.css({
                left: "50%",
                marginLeft: this.$element.outerWidth() / 2 * -1,
                zIndex: this._zIndex + 1
            });
        },
        _keypress: function _keypress(event) {
            if (event.keyCode === KeyCode.ESCAPE) {
                this.close();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Enum = __webpack_require__(77);
    var UrlUtil = __webpack_require__(46);
    var Configuration = __webpack_require__(27);

    var sources = {
        CREATOR: {
            name: "creator",
            title: "Creator Images",
            getUrl: function getUrl(url, size, cloudinaryProvider) {
                var extension = UrlUtil.getFileExtension(url) || "";
                var extensionFinalName = extension ? "." + extension : "";
                var urlNoExtension = extension ? url.replace("." + extension, "") : url;

                // Check if mandatory Cloudinary Provider enabled and exists
                if (cloudinaryProvider) {
                    return Configuration.cloudinaryProviderUrl + "/f_auto,q_auto/" + UrlUtil.getFileNameWithExtension(url);
                }

                if (!size) {
                    // Optimized image url are only used for Creator and in the case there are no resize information defined
                    if ((0, _C3Utils.isC3Experience)()) return "" + urlNoExtension + extensionFinalName;

                    return urlNoExtension + "-optimized" + extensionFinalName;
                }

                // Creator resized images
                return urlNoExtension + "_" + size.width + "x" + size.height + extensionFinalName;
            },
            getCropUrl: function getCropUrl(url, crop) {
                return Configuration.cloudinaryProviderUrl + "/w_" + crop.width + ",h_" + crop.height + ",x_" + crop.x + ",y_" + crop.y + ",c_crop,f_auto,q_auto/" + UrlUtil.getFileNameWithExtension(url);
            }
        },
        SCENE7: {
            name: "Scene7Integration",
            title: "Scene7 Images",
            getUrl: function getUrl(url, size) {
                return url + "?size=" + size.width + "," + size.height;
            }
        }
    };

    return Enum.create("ImageLibrarySourceEnum", "name", sources);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Class = __webpack_require__(26);

    /**
     * Represents a specific font provider.
     *
     * @class FontProvider
     * @author Kim
     */
    var FontProvider = Class.extend({

        /**
         * Constructor.
         *
         * @param  {String} value The enum value.
         * @param  {String} name  The name, as a display-friendly version, e.g. "Standard Fonts".
         */
        constructor: function constructor(value, name) {
            this.value = value;
            this.name = name;
        },
        toString: function toString() {
            return "FontProvider[" + this.value + "]";
        }
    }, {

        /**
         * Returns an array of all the enums.
         *
         * @return {FontProvider[]} Array of <tt>FontProvider</tt>'s.
         */
        all: function all() {
            var providers = [];

            var value = void 0;

            for (var p in FontProvider) {
                value = FontProvider[p];

                if (value instanceof FontProvider) {
                    providers.push(value);
                }
            }

            return providers;
        },


        /**
         * Returns the proper <tt>FontProvider</tt> for the specified value string.
         *
         * @param  {String} value The value string.
         * @return {FontProvider} The matching <tt>FontProvider</tt>.
         */
        fromValue: function fromValue(value) {
            return _.find(FontProvider.all(), function (item) {
                return item.value === value;
            });
        }
    });

    FontProvider.CUSTOM = new FontProvider("custom", "Custom Fonts");
    FontProvider.FONTS_DOT_COM = new FontProvider("fontsDotCom", "Fonts.com");
    FontProvider.GOOGLE = new FontProvider("google", "Google Fonts");
    FontProvider.STANDARD = new FontProvider("standard", "Standard Fonts");
    FontProvider.TYPEKIT = new FontProvider("typekit", "Typekit");

    return FontProvider;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        sortBy = _require.sortBy;

    var ImprovedModel = __webpack_require__(25);

    var _require2 = __webpack_require__(30),
        dasherize = _require2.dasherize;

    var Backbone = __webpack_require__(7);
    var RestApi = __webpack_require__(29);
    var Preconditions = __webpack_require__(14);
    var GroupAssetCollection = __webpack_require__(1477);
    var GroupAsset = __webpack_require__(525);
    var _get = __webpack_require__(794);
    /**
     * The abstract base class for creating groups.
     *
     * @see  BreakpointGroup
     * @see  GroupModelEditorMixin
     *
     * @class GroupModel
     */
    return ImprovedModel.extend("Group", {

        /**
         * Array containing the value class and asset (reference) (in that order) class (as constructor functions)
         * e.g. <tt>[Breakpoint, ExperienceModel]</tt>.<p>
         *
         * This static property must be implemented by the subclass.
         *
         * @type {Function[]}
         */
        types: null,

        defaults: {
            /**
             * The group name.
             *
             * @type {String}
             */
            name: "Untitled Group",

            /**
             * The internal entries associated with this group.
             *
             * @type {GroupAssetCollection}
             */
            entries: [],

            /**
             * The type of group.
             *
             * @type {String}
             */
            type: null,

            /**
             * The group state, e.g. <tt>NotPushed</tt>.
             * @type {String}
             *
             * @see PublishableState
             */
            state: null,

            /**
             * The company ID.
             *
             * @type {String}
             */
            companyId: undefined
        },

        relations: [{
            type: Backbone.Many,
            key: "entries",
            collectionType: GroupAssetCollection,
            options: {
                // Expose factory function for creating concrete assets - see *types*...
                assetFactory: function assetFactory(attributes) {
                    var Model = this._assetClass;
                    var resourceId = attributes.reference.resourceId;
                    var modelAttributes = void 0;

                    if (this._resolvedAssets) {
                        modelAttributes = this._resolvedAssets[resourceId];
                    } else {
                        // HACK: The 'resolvedAssets' are (currently) not exposed to the viewer.
                        // We will still construct the asset, but it will only contain the id (and it's default attributes).
                        // We can get away with this since the viewer (for now at least) only needs the id, e.g. asset.get("id") will
                        // still work...
                        modelAttributes = {
                            id: resourceId
                        };
                    }

                    return new Model(modelAttributes);
                }
            }
        }],

        constructor: function constructor(attributes) {
            Preconditions.checkState(!!this.types && this.types.length === 2);

            this._valueClass = this.types[0];
            this._assetClass = this.types[1];
            this._resolvedAssets = attributes.resolvedAssets;

            this.__super();
            // Pick static properties - the type
            var type = this.constructor.type;

            Preconditions.checkArgument(type, "A group model must specify a type via a static property.");

            this.set("type", type, { silent: true });

            this._valueType = GroupAsset.typeFromValueClass(this._valueClass);
        },


        /**
         * The type (class/constructor function) of value. Used for type checking - e.g. when attaching assets.
         *
         * @type {Function}
         */
        _valueClass: null,

        /**
         *
         * @type {String}
         */
        _valueType: null,

        /**
         * The type (class/constructor function) of asset. Used for type checking - e.g. when attaching asserts.
         *
         * @type {Function}
         */
        _assetClass: null,

        url: function url() {
            // Fix of the BreakPoint group error
            // Do no need to request urls that are not exists
            switch (true) {
                // Check if it's duplicate
                // Check if it's synced group and exists
                case this.has("copyOf"):
                case this.syncState !== undefined && this.syncState !== null && _get(this, "syncState.actual.state") !== "unsynced":
                case this.get("state") !== null:
                    return this.isNew() ? RestApi.pathToCollection(RestApi.Collections.GROUPS) : RestApi.pathToSpecificResource(RestApi.Collections.GROUPS, this.id);
                default:
                    return null;
            }
        },


        /**
         * @override
         * @inheritDoc
         */
        parse: function parse(response) {
            // When fetching, e.g. group.fetch() - we need to store a reference to the
            // latest 'resolvedAssets' maps, see the 'assetFactory' above...
            this._resolvedAssets = response.resolvedAssets;

            return this.__super();
        },


        // TODO: Consider returning an array of concrete types, e.g. *GroupEntry*...?
        /**
         * Returns a 2D array containing the <tt>[asset, value]</tt> pairs for each entry.
         *
         * @return {[asset, value][]} A 2D array containing the <tt>[asset, reference]</tt> pairs for each entry.
         */
        entries: function entries() {
            return this.get("entries").map(function (internalAsset) {
                return [internalAsset.get("asset"), internalAsset.get("value")];
            });
        },


        /**
         * Returns all unique assets with values sorted by experiences/assets
         */
        getUniqueEntries: function getUniqueEntries() {
            var assets = this.get("entries").chain().reduce(function (assetsMap, internalAsset) {
                var asset = internalAsset.get("asset");

                if (asset) {
                    var id = asset.get("id");
                    assetsMap[id] = [asset, internalAsset.get("value")];
                }

                return assetsMap;
            }, {}).values().value();

            return sortBy(assets, function (asset) {
                return asset[0].get("createdAt");
            });
        },


        /**
         * Get unique assets referred by this group. This differs from method above, which can contains duplicated assets
         * Get unique (resolved) assets contained in this group. This differs from method above, which can contain
         * duplicated assets
         *
         * @return {Array} An array of (resolved) assets; never null, but can be empty.
         */
        getAssets: function getAssets() {
            return this.get("entries").chain().reduce(function (assetsMap, internalAsset) {
                var asset = internalAsset.get("asset");
                if (asset) {
                    assetsMap[asset.get("id")] = asset;
                }
                return assetsMap;
            }, {}).values().value();
        },


        /**
         * Get unique and sorted assets contained in this group.
         *
         * @param  {String} attribute The attribute to sort by; defaulting to <tt>createdAt</tt>.
         * @return {Array} An array of assets sorted by <tt>attribute</tt>; never falsey, but can be empty.
         */
        getSortedAssets: function getSortedAssets(attribute) {
            var assets = this.getAssets();

            attribute = attribute || "createdAt";

            return sortBy(assets, function (asset) {
                return asset.get(attribute);
            });
        },


        /**
         * Get the all unique values used in this group
         *
         * @returns {Backbone.Model} An array of value models
         */
        getValues: function getValues() {
            return this.get("entries").reduce(function (values, entry) {
                if (entry.get("value")) {
                    values.push(entry.get("value"));
                }

                return values;
            }, []);
        },


        /**
         * Returns the asset from the specified group value.
         *
         * @param  {*} value The group value.
         * @return {*}  The asset, e.g. an <tt>ExperienceModel</tt>.
         */
        assetFromValue: function assetFromValue(value) {
            // TODO: this will not work in the general case, needs a equal method or a comparator function - e.g. to compare on threshold, not on model instance
            var found = this.get("entries").find(function (entry) {
                return entry.get("value") === value;
            });
            return found && found.get("asset");
        },


        /**
         * Find the entry that is associated with an asset of provided id
         *
         * @param assetId
         * @returns {*}
         */
        findEntryByAssetId: function findEntryByAssetId(assetId) {
            var found = null;
            var asset = null;

            found = this.get("entries").find(function (entry) {
                asset = entry.get("asset");
                return asset && asset.get("id") === assetId;
            });

            return found;
        },
        findAssetById: function findAssetById(assetId) {
            var entry = this.findEntryByAssetId(assetId);
            return entry && entry.get("asset");
        },
        getNumOfAssets: function getNumOfAssets() {
            return this.getAssets().length;
        },
        getFirstAsset: function getFirstAsset() {
            return this.getSortedAssets()[0];
        },
        getDashedType: function getDashedType() {
            return dasherize(this.get("type")).substring(1);
        },


        /**
         * Whether a group is considered as one unit when being published and scheduled.
         * For example, breakpoint group is one unit whereas localization group is not.
         *
         * Also, if it is considered one unit, the group can be viewed with an URL.
         *
         * @returns {Boolean}   true if it is consider one unit, false otherwise.
         */
        isOneUnit: function isOneUnit() {
            return true;
        },
        isInactive: function isInactive() {
            // Only inactive filters will actually push the state, and then as "Inactive", but for legacy reasons,
            // we have to handle cases where a state is marshaled anyway... :/
            return this.get("state") === "Inactive"; // Viewer thing, do not include complex enum state for this!
        }
    }, {

        /**
         * The type of group, e.g. <tt>BreakpointGroup</tt>.<p>
         *
         * This static property must be implemented by the subclass.
         *
         * @type {String}
         */
        type: null
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Marionette = __webpack_require__(10);
    var Tooltip = __webpack_require__(35);
    var KeyCode = __webpack_require__(88);
    var Permissions = __webpack_require__(22);
    var Promise = __webpack_require__(21);
    var SyncManager = __webpack_require__(44);
    var Preconditions = __webpack_require__(14);
    var EditBehaviorUtil = __webpack_require__(1731);

    var iconTemplate = _.template("<div class='editable-cell-img'><div class='editable-img'></div></div>");

    var isFieldBeingEdited = false;
    var lastSelectedElement = null;

    /**
     * A behavior for the edit fields. The goal of this class is to be used
     * in all places where we need a renaming feature.
     *
     * @class EditBehavior
     * @author Pedro Augusto
     */
    return Marionette.Behavior.extend({

        _model: null,

        fields: [],

        defaults: {
            editFields: [],
            container: null
        },

        /**
         *  Its Create edit object with the parameters needed. With those parameters
         * will be possible have more than one editable field on the view.
         * Even for the views that are used inside of the CollectionView will be
         * possible to use this BehaviorClass.
         *
         * @param {Object}   input           jquery element
         * @param {Object}   icon            jquery element
         * @param {Array}    hideOnFocus     An array of objects with the elements that will be also hidden on focus.
         * @param {String}   model           String with the model associated name.
         * @param {Function} save            callback save function
         * @param {Function} cancel          callback cancel function
         * @param {Boolean}  tooltip         True to enable tooltip, false otherwise.
         * @param {Boolean}  hideIcon        True to hide the image icon, false otherwise.
         *
         * @returns {Object} Returns a new Field object.
         */
        createFieldObject: function createFieldObject(input, icon, hideOnFocus, model, save, cancel, tooltip, hideIcon) {
            Preconditions.is$element(input);

            var field = {
                icon: icon,
                input: input,
                hideOnFocus: hideOnFocus,
                model: model,
                save: save,
                cancel: cancel,
                tooltip: tooltip,
                hideIcon: hideIcon,
                originalValue: input.is("input") ? input.val() : input.text(),

                /**
                 * Set or Get the value of an `input` field or a `contenteditable` `div`.
                 *
                 * @param  {String|number} [value] The value to set, if any.
                 * @return {String} Field value.
                 */
                val: function val(value) {
                    if (this.input.is("input")) {
                        if (!_.isUndefined(value)) {
                            this.input.val(value);
                        }

                        return this.input.val();
                    }

                    // It should always set the value as html once that
                    // stickit will have already transformed it.
                    if (!_.isUndefined(value)) {
                        return _.escape(value);
                    }
                    // But, In case of retrieve, we should get a text.
                    return EditBehaviorUtil.sanitize(this.input.text());
                }
            };

            return field;
        },


        /**
         *  Add the icon for the field object.
         *
         * @param {Object} field - Field object
         * @private
         */
        _addImageIcon: function _addImageIcon(field) {
            if (!field.icon && !field.hideIcon) {
                field.icon = $(iconTemplate()).insertAfter(field.input);
            }
        },


        /**
         * Get the container for mouseover and leave effects.
         * It can be passed by parameter on the behavior options
         *
         * @returns {Jquery} Returns the container responsible to activate the hover effect
         */
        getViewContainer: function getViewContainer() {
            if (!this.options.container) {
                return this.view.$el;
            }

            return this.view.$el.find(this.options.container);
        },
        initialize: function initialize() {
            // bind all event functions
            _.bindAll(this, "iconMouseEnterHandler", "iconMouseLeaveHandler", "iconStartHandler", "iconEndHandler", "editStart", "editEnd", "editKeyDownHandler");
        },


        /**
         * Bind the events mouse events for the view in question.
         */
        _bindEventsView: function _bindEventsView() {
            this.getViewContainer().on("mouseenter", this.iconMouseEnterHandler);
            this.getViewContainer().on("mouseleave", this.iconMouseLeaveHandler);
        },


        /**
         * Show the icons when the user pass the mouse in the container.
         */
        iconMouseEnterHandler: function iconMouseEnterHandler() {
            if (!isFieldBeingEdited) {
                this.showIcons(true);
            }
        },


        /**
         * Hide the icons when the user pass the mouse in the container.
         */
        iconMouseLeaveHandler: function iconMouseLeaveHandler() {
            this.showIcons(false);
        },


        /**
         * Show or hidden icons of the view
         * @param {boolean} show - It should be showed
         */
        showIcons: function showIcons(show) {
            _.each(this.fields, function (field) {
                if (!field.hideIcon) {
                    field.icon.toggleClass("active", show);
                }
            });
        },


        /**
         * Binds the events for the input and the icon in question.
         * Each input is associated with a icon and they must to have the interactions described on MOS-1698
         *
         * @param {Object}   field   field object
         */
        _bindEventsField: function _bindEventsField(field) {
            if (!field.hideIcon) {
                field.icon.on("mouseup", { field: field }, this.iconStartHandler);
            }

            this.getViewContainer().on("mousedown", { field: field }, this.iconStartHandler);

            field.input.on("blur", { field: field }, this.iconEndHandler);

            field.input.on("keydown", { field: field }, this.editKeyDownHandler);

            if (!field.input.is("input")) {
                field.input.on("paste", { field: field }, this.pasteHandler);
            }
        },

        /**
         * Handler the paste event.
         * If the user trys to paste html it will accept only plain/text.
         *
         * @param {Event} e Jquery paste event.
         */
        pasteHandler: function pasteHandler(e) {
            var content = void 0;

            e.preventDefault();

            if (e.originalEvent.clipboardData) {
                content = (e.originalEvent || e).clipboardData.getData("text/plain");

                document.execCommand("insertText", false, content);
            } else if (window.clipboardData) {
                content = window.clipboardData.getData("Text");

                if (window.getSelection) {
                    window.getSelection().getRangeAt(0).insertNode(document.createTextNode(content));
                }
            }
        },

        /**
         * Remove the bind events from the fields
         */
        onClose: function onClose() {
            this.getViewContainer().off("mouseenter", "mouseleave", "mousedown");

            _.each(this.fields, function (field) {
                if (!field.hideIcon) {
                    field.icon.off("mouseup");
                }

                field.input.off("blur", "keydown", "paste");
            });
        },


        /**
         *  Handlers the enter and esc input
         *
         * @param {event}   event       KeyDown event
         */
        editKeyDownHandler: function editKeyDownHandler(event) {
            var field = event.data.field;

            switch (event.which) {
                case KeyCode.ENTER:
                case KeyCode.RETURN:
                    this.iconEndHandler(event);
                    break;
                case KeyCode.ESCAPE:
                    this.editRollback(field);
                    break;
                default:
                    // No log needed here.
                    break;
            }
        },


        /**
         * The user starts to edit the field.
         *
         * @param {Object}  field object
         */
        editStart: function editStart(field) {
            // Remove the overflow
            field.input.css("text-overflow", "clip");

            this.showIcons(false);

            this.showAdjacentElements(false);

            Tooltip.remove(field.input);
        },

        /**
         * Handler the the start edit event and call the editStart method.
         *
         * @param {Event} event blur.
         */
        iconStartHandler: function iconStartHandler(event) {
            var field = event.data.field;

            this.editStart(field);

            // By feature definition, if you click in the INPUT element the caret position should be positioned in the end.
            // However, if the user click for a second time in the field the caret will keep the wanted position.
            if (lastSelectedElement !== event.target) {
                EditBehaviorUtil.setCaretEndPosition(field.input);

                lastSelectedElement = event.target;
            }

            isFieldBeingEdited = true;

            event.stopPropagation();
        },


        /**
         * Handler the end event and call the editEnd method. Also, show the adjacents elements again like
         * in the case of the imageview that we must to control the timesused tooltip.
         *
         * @param {Event} event Blur.
         */
        iconEndHandler: function iconEndHandler(event) {
            var field = event.data.field;

            this.editEnd(field);

            this.showAdjacentElements(true);

            isFieldBeingEdited = false;

            lastSelectedElement = document.activeElement;

            this._forceFocusMoveOut();

            event.preventDefault();
        },


        /**
         * Manipulate the end of the edition. It must to fire a event for the view passing the new renamed value.
         * However, if the new value is invalid for some reason, It must to Rollback the changes.
         *
         * @param {Object}  field object
         */
        editEnd: function editEnd(field) {
            var _this = this;

            var newValue = field.val();

            var originalValue = field.originalValue;

            // Update the model in any case to avoid problems with StickIt
            if (!_.isUndefined(field.model)) {
                this._updateModel(field.model, newValue);
            }

            if (newValue !== originalValue && _.isFunction(field.save)) {
                try {
                    var promise = field.save.call(this.view, newValue);

                    // Make sure we check the returned promise for async failure so we can rollback if needed.
                    // We have to supply the actual original value, since it will have been changed above to
                    // prematurely...
                    if (Promise.isPromise(promise)) {
                        promise.fail(function () {
                            _this.editRollback(field, originalValue);
                        });
                    }
                } catch (e) {
                    this.editRollback(field);
                }
            }

            field.originalValue = newValue;

            field.input.css("text-overflow", "ellipsis");

            if (field.input.is("div")) {
                field.input.scrollLeft(0);
            }

            if (field.tooltip) {
                this.updateTooltip(field);
            }
        },


        /**
         * Rollback the edited value with the original value passed.
         *
         * @param {Object}  field object
         * @param {Object} [originalValue] The original value to restore in case of async error.
         */
        editRollback: function editRollback(field, originalValue) {
            Preconditions.checkArguments(field);

            if (arguments.length === 1) {
                originalValue = field.originalValue;
            }

            if (_.isFunction(field.cancel)) {
                field.cancel(field.val(), originalValue);
            }

            this._forceFocusMoveOut();

            field.val(originalValue);
        },

        /**
         * Force focus to be moved out of the input field. When the user press enter, escape or blur the field.
         * We should assure that the focus will be removed from the current element.
         *
         * @private
         */
        _forceFocusMoveOut: function _forceFocusMoveOut() {
            // Force the focus to be moved out
            EditBehaviorUtil.setCaretEndPosition(this.getViewContainer());
        },


        /**
         * Show or hide the adjacent elements and the icon
         *
         * @param {boolean} show - Should show the adjacent elements.
         *
         */
        showAdjacentElements: function showAdjacentElements(show) {
            var _this2 = this;

            _.each(this.fields, function (field) {
                if (_.isArray(field.hideOnFocus)) {
                    var arrayElements = _this2.view.$el.find(field.hideOnFocus.join(","));

                    arrayElements.toggleClass("editable-adjacent-hidden", !show);

                    arrayElements.toggleClass("editable-adjacent-show", show);

                    _.each(arrayElements, function (element) {
                        if (!show) {
                            Tooltip.disable(element);
                        } else {
                            Tooltip.enable(element);
                        }
                    });
                }
            });
        },


        /**
         *   Update the tooltip with the CURRENT field object value
         *   @param {Object}  field object
         */
        updateTooltip: function updateTooltip(field) {
            if (EditBehaviorUtil.isEllipsisActive(field)) {
                Tooltip.remove(field.input);

                Tooltip.add(field.input, {
                    content: field.val(),
                    placement: "top",
                    alignCenter: true,
                    offset: {
                        align: "center"
                    },
                    width: "auto",
                    delay: { show: 0, hide: 0 }
                });
            } else {
                Tooltip.remove(field.input);
            }
        },

        /**
         * @private
         * Update the model with new value. It should be  used to avoid conflicts between the
         * EditBehavior and the StickIt.
         *
         * @param {String} modelName name of the model attribute
         * @param {String} val newValue
         */
        _updateModel: function _updateModel(modelName, val) {
            // Similar to the `stickitChange` object, include a `editBehaviorChange` exposing the associated view.
            var editBehaviorChange = {
                view: this.view
            };

            this._model.set(modelName, val, { editBehaviorChange: editBehaviorChange });
        },


        /**
         * @private
         * Factory method that returns a new default "save" function for an edit field backed by a model, which will
         * save a model once its "name" property has been updated, returning the promise for the actual sync request.
         *
         * @param {String} name    The model property to set before saving; never falsey.
         * @param {String} [model] The view property storing the model to update, defaulting to "model".
         * @return {Function} A new "save" function for the edit field in question; never null. Will be invoked
         *                    with the view as scope.
         *
         * @see    #_cancel
         */
        _save: function _save(name, model) {
            return function (val) {
                model.set(name, val);

                return model.saveLater();
            };
        },


        /**
         * @private
         * Factory method that returns a new default "cancel" method for any edit field backed by a model.
         *
         * @param {String} [model] The view property storing the model to update, defaulting to "model".
         * @return {Function} A new "cancel" function for the edit field in question; never null. Will be invoked
         *                    with the view as scope.
         */
        _cancel: function _cancel(model) {
            var _this3 = this;

            return function () {
                return SyncManager.cancel(_this3[model || "model"], "save");
            };
        },


        /**
         *  onShow event from the view. It is needed a _defer function in this case because the StickIt will bind the elements
         *  after the onRender event. It is necessary to retrieve the originalValue.
         */
        onRender: function onRender() {
            var _this4 = this;

            // Checks if the view isn't editable; if no such prop is specified, either as boolean or privilege, we
            // assume the CREATE privilege is required...
            var editable = this.view.options.isEditable;

            if (_.isUndefined(editable)) {
                editable = Permissions.Privileges.CREATE;
            }

            // If a privilege, check to see if editable...
            var privilege = Permissions.Privileges.of(editable);

            if (privilege) {
                editable = privilege.can();
            }

            _.defer(function () {
                // Bind hover events on the view
                _this4._bindEventsView();

                _this4.fields = [];

                // Resolve the data/view model to update - defaults to this.view.model...
                var viewModel = function viewModel() {
                    var model = _this4.options.viewModel;

                    if (model) {
                        if (_.isFunction(model)) {
                            return model.call(_this4.view);
                        }

                        return model;
                    }

                    return _this4.view.model;
                };

                _this4._model = viewModel();

                var editFields = _this4.options.editFields;

                _.every(editFields, function (editField) {
                    var save = editField.save;
                    var cancel = editField.cancel;
                    var model = editField.model;
                    var tooltip = _.isUndefined(editField.tooltip) || editField.tooltip;
                    var hideIcon = !_.isUndefined(editField.hideIcon) || editField.hideIcon;
                    var enableFieldEvents = _.isUndefined(editField.enableFieldEvents) || editField.enableFieldEvents;
                    var $editableField = _this4.view.$el.find(editField.input);

                    // Editable element not found, for instance in the Editor
                    if (!$editableField.length) {
                        return false; // Break, since also the rest of elements wont have an editable field.
                    }

                    if (_.isString(save)) {
                        save = _this4._save(save, _this4._model);

                        if (cancel) {
                            var oldCancel = cancel;
                            var newCancel = _this4._cancel(_this4._model);

                            cancel = function cancel(val, originalVal) {
                                newCancel();

                                oldCancel(val, originalVal);
                            };
                        } else {
                            cancel = _this4._cancel(_this4._model);
                        }
                    }

                    var field = _this4.createFieldObject($editableField, editField.icon ? _this4.view.$el.find(editField.icon) : null, editField.hideOnFocus, model, save, cancel, tooltip, hideIcon);

                    if (editable) {
                        _this4.fields.push(field);

                        _this4._addImageIcon(field);

                        // Reason for this is because we want to disable events when for instance clicking on top
                        // of the edit name field.
                        if (enableFieldEvents) {
                            _this4._bindEventsField(field);
                        }
                    }

                    if (tooltip) {
                        _this4.updateTooltip(field);
                    }

                    // If the behavior is created with "focused" set to
                    // true, then we focus on the input element.
                    if (editField.focused) {
                        _this4.getViewContainer().trigger("mousedown");
                    }
                });
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        escape = _require.escape;

    var EventDispatcher = __webpack_require__(54);
    var MathUtil = __webpack_require__(72).default;
    var NotificationBar = __webpack_require__(53);
    var Permissions = __webpack_require__(22);

    var DEFAULT_CLOSE_DELAY = 7000;

    var instance = null;

    /**
     * Global service used to communicate different messages to the user.
     *
     * It will present info-bars to the user when needed and it will interact with the
     * API to handle the confirmation process.
     *
     * @author Andreea Vasile (avi)
     */
    var SystemMessages = EventDispatcher.extend({
        // TODO: why is this an event dispatcher?

        /**
         * Creates the purge message used in the {@link notifyPurge} method.
         * @param {String} modelName The name of the model that needs to be purged, eg: Experience or Channel.
         * @param {String} operationName The name of the operation that triggered a purge. May be a save (channelConfig) or a push (Experience).
         * @param {Number} purgeTime The time it takes to purge the requests expressed in seconds; can be null or even negative.
         * @param {Boolean} [scheduledNotification] If set, it will add the scheduled notification warning about delays between the expected live live time and the actual time.
         * @returns {String} The purge message to display to the user.
         */
        createPurgeMessage: function createPurgeMessage(modelName, operationName, purgeTime, scheduledNotification) {
            // TODO: I think this should use a templating scheme with options instead
            var minutesToPush = purgeTime === null ? null : MathUtil.round(purgeTime / 60, 0); // null if nothing pushed, can actually happen!
            var message = modelName + " successfully " + operationName;

            // Nothing purged at all...
            if (purgeTime !== null) {
                message += ". The Content Delivery Network ";

                // Somebody else purged this concurrently and we do therefor not know the time it will take for
                // the purge to complete...
                if (purgeTime < 0) {
                    message += "is expected to be updated shortly";

                    // Immediately, or sometime in the future...
                } else {
                    var timeUntilPushes = minutesToPush === 0 ? "immediately" : "within " + minutesToPush + " minutes";
                    message += "will be updated " + timeUntilPushes;
                }

                if (scheduledNotification) {
                    message += " from now or from the scheduled go live time";
                }
            }
            return message + ".";
        },


        /**
         * Notifies the user that a purge operation is currently pending.
         * @param {String} modelName The name of the model that needs to be purged, eg: Experience or Channel.
         * @param {String} operationName The name of the operation that triggered a purge. May be a save (channelConfig) or a push (Experience).
         * @param {Number} purgeTime The time it takes to purge the requests expressed in seconds.
         * @param {Boolean} [scheduledNotification] If set, it will add the scheduled notification warning about delays between the expected live live time and the actual time.
         */
        notifyPurge: function notifyPurge(modelName, operationName, purgeTime, scheduledNotification) {
            if (purgeTime !== undefined) {
                NotificationBar.open(this.createPurgeMessage(modelName, operationName, purgeTime, scheduledNotification), { closeDelay: DEFAULT_CLOSE_DELAY });
            }
        },


        /**
         * Notifies the user via Notification Bar.
         * @param {String} message The message to present in the Notification Bar.
         * @param {Number} closeDelay The time it takes for the notification to close.
         */
        notify: function notify(message) {
            var closeDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_CLOSE_DELAY;

            NotificationBar.open(message, { closeDelay: closeDelay });
        },


        /**
         * Messages associated with managing fonts.
         * @type {Object}
         * @see  EditorWebFontController
         */
        ManageFonts: {
            noCommunication: function noCommunication(integrationName, keyName) {
                if (Permissions.Roles.MANAGER.can()) {
                    var message = "Unable to communicate with the " + integrationName + " API. Make sure to  enter a valid " + keyName + " " + "on the <a href='#fonts'>fonts setup page</a>.";

                    NotificationBar.error(message);
                }
            },
            invalidKey: function invalidKey(integrationName, keyName, key, validateEvent) {
                if (Permissions.Roles.MANAGER.can()) {
                    var message = "The " + integrationName + " " + keyName + " &quot;" + escape(key) + "&quot; appears to be invalid.";

                    NotificationBar.error(message, { closeDelay: DEFAULT_CLOSE_DELAY });

                    instance.trigger(validateEvent, false);
                }
            },
            removedKey: function removedKey(integrationName, keyName) {
                if (Permissions.Roles.MANAGER.can()) {
                    var message = "The " + keyName + " has been removed. This will not impact live expriences, but " + ("you will no longer be able to use " + integrationName + " fonts in new experiences. Editing ") + ("an experience will remove any fonts from " + integrationName + " from the experience.");

                    NotificationBar.open(message, { closeDelay: DEFAULT_CLOSE_DELAY });
                }
            },
            validKey: function validKey(integrationName, keyName, validateEvent) {
                if (Permissions.Roles.MANAGER.can()) {
                    var message = "You have entered a valid " + integrationName + " " + keyName + ". You can now start using " + integrationName + " fonts.";

                    NotificationBar.open(message, { closeDelay: DEFAULT_CLOSE_DELAY });

                    instance.trigger(validateEvent, true);
                }
            }
        }
    });

    // Singleton
    instance = new SystemMessages();

    return instance;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(1790);
/* unused harmony reexport colors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(1803);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__styles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Accordion__ = __webpack_require__(571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Accordion__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AccordionActions__ = __webpack_require__(924);
/* unused harmony reexport AccordionActions */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccordionDetails__ = __webpack_require__(925);
/* unused harmony reexport AccordionDetails */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionSummary__ = __webpack_require__(574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__AccordionSummary__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AppBar__ = __webpack_require__(926);
/* unused harmony reexport AppBar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Avatar__ = __webpack_require__(927);
/* unused harmony reexport Avatar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Backdrop__ = __webpack_require__(419);
/* unused harmony reexport Backdrop */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Badge__ = __webpack_require__(928);
/* unused harmony reexport Badge */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BottomNavigation__ = __webpack_require__(929);
/* unused harmony reexport BottomNavigation */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__BottomNavigationAction__ = __webpack_require__(930);
/* unused harmony reexport BottomNavigationAction */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Box__ = __webpack_require__(931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_13__Box__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Breadcrumbs__ = __webpack_require__(932);
/* unused harmony reexport Breadcrumbs */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Button__ = __webpack_require__(575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_15__Button__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ButtonBase__ = __webpack_require__(76);
/* unused harmony reexport ButtonBase */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__ = __webpack_require__(933);
/* unused harmony reexport ButtonGroup */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Card__ = __webpack_require__(934);
/* unused harmony reexport Card */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__CardActionArea__ = __webpack_require__(935);
/* unused harmony reexport CardActionArea */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__CardActions__ = __webpack_require__(936);
/* unused harmony reexport CardActions */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CardContent__ = __webpack_require__(937);
/* unused harmony reexport CardContent */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__CardHeader__ = __webpack_require__(938);
/* unused harmony reexport CardHeader */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__CardMedia__ = __webpack_require__(939);
/* unused harmony reexport CardMedia */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Checkbox__ = __webpack_require__(940);
/* unused harmony reexport Checkbox */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Chip__ = __webpack_require__(941);
/* unused harmony reexport Chip */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__CircularProgress__ = __webpack_require__(942);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_26__CircularProgress__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__ClickAwayListener__ = __webpack_require__(577);
/* unused harmony reexport ClickAwayListener */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Collapse__ = __webpack_require__(317);
/* unused harmony reexport Collapse */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Container__ = __webpack_require__(943);
/* unused harmony reexport Container */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__CssBaseline__ = __webpack_require__(944);
/* unused harmony reexport CssBaseline */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Dialog__ = __webpack_require__(945);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_31__Dialog__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__DialogActions__ = __webpack_require__(948);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_32__DialogActions__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__DialogContent__ = __webpack_require__(949);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_33__DialogContent__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__DialogContentText__ = __webpack_require__(950);
/* unused harmony reexport DialogContentText */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__DialogTitle__ = __webpack_require__(951);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_35__DialogTitle__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__Divider__ = __webpack_require__(952);
/* unused harmony reexport Divider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Drawer__ = __webpack_require__(953);
/* unused harmony reexport Drawer */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ExpansionPanel__ = __webpack_require__(954);
/* unused harmony reexport ExpansionPanel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__ExpansionPanelActions__ = __webpack_require__(956);
/* unused harmony reexport ExpansionPanelActions */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ExpansionPanelDetails__ = __webpack_require__(957);
/* unused harmony reexport ExpansionPanelDetails */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__ExpansionPanelSummary__ = __webpack_require__(958);
/* unused harmony reexport ExpansionPanelSummary */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__Fab__ = __webpack_require__(959);
/* unused harmony reexport Fab */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Fade__ = __webpack_require__(420);
/* unused harmony reexport Fade */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__FilledInput__ = __webpack_require__(423);
/* unused harmony reexport FilledInput */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__FormControl__ = __webpack_require__(424);
/* unused harmony reexport FormControl */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__FormControlLabel__ = __webpack_require__(960);
/* unused harmony reexport FormControlLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__FormGroup__ = __webpack_require__(583);
/* unused harmony reexport FormGroup */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__FormHelperText__ = __webpack_require__(584);
/* unused harmony reexport FormHelperText */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__FormLabel__ = __webpack_require__(585);
/* unused harmony reexport FormLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Grid__ = __webpack_require__(961);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_50__Grid__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__GridList__ = __webpack_require__(962);
/* unused harmony reexport GridList */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__GridListTile__ = __webpack_require__(963);
/* unused harmony reexport GridListTile */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__GridListTileBar__ = __webpack_require__(964);
/* unused harmony reexport GridListTileBar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Grow__ = __webpack_require__(319);
/* unused harmony reexport Grow */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__Hidden__ = __webpack_require__(965);
/* unused harmony reexport Hidden */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Icon__ = __webpack_require__(967);
/* unused harmony reexport Icon */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__IconButton__ = __webpack_require__(266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_57__IconButton__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__ImageList__ = __webpack_require__(968);
/* unused harmony reexport ImageList */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__ImageListItem__ = __webpack_require__(969);
/* unused harmony reexport ImageListItem */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__ImageListItemBar__ = __webpack_require__(970);
/* unused harmony reexport ImageListItemBar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__Input__ = __webpack_require__(320);
/* unused harmony reexport Input */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__InputAdornment__ = __webpack_require__(971);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_62__InputAdornment__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__InputBase__ = __webpack_require__(267);
/* unused harmony reexport InputBase */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__InputLabel__ = __webpack_require__(587);
/* unused harmony reexport InputLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__LinearProgress__ = __webpack_require__(588);
/* unused harmony reexport LinearProgress */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Link__ = __webpack_require__(972);
/* unused harmony reexport Link */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__List__ = __webpack_require__(589);
/* unused harmony reexport List */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__ListItem__ = __webpack_require__(590);
/* unused harmony reexport ListItem */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__ListItemAvatar__ = __webpack_require__(973);
/* unused harmony reexport ListItemAvatar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__ListItemIcon__ = __webpack_require__(974);
/* unused harmony reexport ListItemIcon */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__ListItemSecondaryAction__ = __webpack_require__(975);
/* unused harmony reexport ListItemSecondaryAction */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__ListItemText__ = __webpack_require__(976);
/* unused harmony reexport ListItemText */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__ListSubheader__ = __webpack_require__(977);
/* unused harmony reexport ListSubheader */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Menu__ = __webpack_require__(978);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_74__Menu__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__MenuItem__ = __webpack_require__(593);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_75__MenuItem__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__MenuList__ = __webpack_require__(592);
/* unused harmony reexport MenuList */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__MobileStepper__ = __webpack_require__(980);
/* unused harmony reexport MobileStepper */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Modal__ = __webpack_require__(318);
/* unused harmony reexport Modal */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__NativeSelect__ = __webpack_require__(981);
/* unused harmony reexport NativeSelect */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__NoSsr__ = __webpack_require__(594);
/* unused harmony reexport NoSsr */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__OutlinedInput__ = __webpack_require__(426);
/* unused harmony reexport OutlinedInput */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Paper__ = __webpack_require__(109);
/* unused harmony reexport Paper */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Popover__ = __webpack_require__(591);
/* unused harmony reexport Popover */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Popper__ = __webpack_require__(595);
/* unused harmony reexport Popper */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__Portal__ = __webpack_require__(422);
/* unused harmony reexport Portal */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__Radio__ = __webpack_require__(985);
/* unused harmony reexport Radio */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__RadioGroup__ = __webpack_require__(988);
/* unused harmony reexport RadioGroup */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__RootRef__ = __webpack_require__(989);
/* unused harmony reexport RootRef */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__Select__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_89__Select__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__Slide__ = __webpack_require__(580);
/* unused harmony reexport Slide */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__Slider__ = __webpack_require__(990);
/* unused harmony reexport Slider */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Snackbar__ = __webpack_require__(991);
/* unused harmony reexport Snackbar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__SnackbarContent__ = __webpack_require__(596);
/* unused harmony reexport SnackbarContent */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Step__ = __webpack_require__(992);
/* unused harmony reexport Step */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__StepButton__ = __webpack_require__(993);
/* unused harmony reexport StepButton */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__StepConnector__ = __webpack_require__(599);
/* unused harmony reexport StepConnector */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__StepContent__ = __webpack_require__(994);
/* unused harmony reexport StepContent */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__StepIcon__ = __webpack_require__(598);
/* unused harmony reexport StepIcon */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__StepLabel__ = __webpack_require__(597);
/* unused harmony reexport StepLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__Stepper__ = __webpack_require__(995);
/* unused harmony reexport Stepper */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__SvgIcon__ = __webpack_require__(415);
/* unused harmony reexport SvgIcon */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__SwipeableDrawer__ = __webpack_require__(996);
/* unused harmony reexport SwipeableDrawer */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__Switch__ = __webpack_require__(997);
/* unused harmony reexport Switch */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__Tab__ = __webpack_require__(998);
/* unused harmony reexport Tab */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__Table__ = __webpack_require__(999);
/* unused harmony reexport Table */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__TableBody__ = __webpack_require__(1001);
/* unused harmony reexport TableBody */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__TableCell__ = __webpack_require__(600);
/* unused harmony reexport TableCell */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__TableContainer__ = __webpack_require__(1002);
/* unused harmony reexport TableContainer */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__TableFooter__ = __webpack_require__(1003);
/* unused harmony reexport TableFooter */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__TableHead__ = __webpack_require__(1004);
/* unused harmony reexport TableHead */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__TablePagination__ = __webpack_require__(1005);
/* unused harmony reexport TablePagination */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__TableRow__ = __webpack_require__(1008);
/* unused harmony reexport TableRow */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__TableSortLabel__ = __webpack_require__(1009);
/* unused harmony reexport TableSortLabel */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__Tabs__ = __webpack_require__(1010);
/* unused harmony reexport Tabs */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__TabScrollButton__ = __webpack_require__(602);
/* unused harmony reexport TabScrollButton */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__TextField__ = __webpack_require__(1011);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_116__TextField__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__TextareaAutosize__ = __webpack_require__(581);
/* unused harmony reexport TextareaAutosize */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__Toolbar__ = __webpack_require__(601);
/* unused harmony reexport Toolbar */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__Tooltip__ = __webpack_require__(1012);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_119__Tooltip__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__Typography__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_120__Typography__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__Unstable_TrapFocus__ = __webpack_require__(578);
/* unused harmony reexport Unstable_TrapFocus */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__useMediaQuery__ = __webpack_require__(586);
/* unused harmony reexport useMediaQuery */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__useScrollTrigger__ = __webpack_require__(1013);
/* unused harmony reexport useScrollTrigger */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__withMobileDialog__ = __webpack_require__(1014);
/* unused harmony reexport withMobileDialog */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__withWidth__ = __webpack_require__(425);
/* unused harmony reexport withWidth */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__Zoom__ = __webpack_require__(1015);
/* unused harmony reexport Zoom */
/* unused harmony namespace reexport */
/** @license Material-UI v4.12.4
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable import/export */















































































































































































































































 // eslint-disable-next-line camelcase














/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paper__ = __webpack_require__(1865);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Paper__["a"]; });


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Typography__ = __webpack_require__(1883);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Typography__["a"]; });


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlockNode
 * @format
 * 
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(93);
var Immutable = __webpack_require__(40);

var findRangesImmutable = __webpack_require__(325);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  parent: null,
  characterList: List(),
  data: Map(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = function (_Record) {
  _inherits(ContentBlockNode, _Record);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

    _classCallCheck(this, ContentBlockNode);

    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
  }

  ContentBlockNode.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlockNode.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlockNode.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlockNode.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlockNode.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlockNode.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  ContentBlockNode.prototype.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record(defaultRecord));

module.exports = ContentBlockNode;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Class = __webpack_require__(26);
    var Ladda = __webpack_require__(340); // for spinner

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var log = new Logger("SequentialButton");

    /**
     * Value to return by sequential buttons that wish to break out of the functionality early, e.g. on
     * input validation error.
     */
    var REJECT = {
        toString: function toString() {
            return "break";
        }
    };

    /**
     * A <i>sequential button</i> can be added to form buttons to ensure that the button(s) can only be
     * activated/clicked sequentially, preventing the user from submitting multiple concurrent requests. <p>
     *
     * Optionally, it supports a spinner to be displayed while the button(s) have a pending action. <p>
     *
     * The button action can also be invoked explicitly, e.g. from a form submit via enter, by simply
     * invoking the function returned from the <tt>add(..)</tt> function.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     * @author Antonio Lagrotteria / <a href="http://www.zmags.com">Zmags</a>
     */
    return Class.extend({}, {

        /**
         * Returns a function that when invoked will disable <tt>button</tt> while <tt>action</tt> is pending, making it
         * active again regardless of action success or failure. If <tt>spinner</tt> is false, the returned function
         * will also be added as a click handler on the button. <p>
         *
         * When passing a jQuery object containing more than one DOM element, the spinner behaviour will be added to all
         * the DOM elements for that jQuery object, but only showing the active one.
         *
         * @param {jQuery}              button            The jQuery element(s) for the button; cannot be null.
         * @param {Function|$.Deferred} action            The action to invoke when the button is activated (clicked), either as
         *                                                a scoped function always returning a $.Deferred object for chaining, or
         *                                                a $.Deferred as-is; cannot be null.
         * @param {Boolean}            [spinner]          True to add a spinner to the the button while activated, false otherwise.
         *                                                Defaults to true if not supplied. If no spinner is used, the returned
         *                                                function is added as a click handler on <tt>button</tt>.
         *                                                Defaults to true if not supplied. If no spinner is used, the returned
         *                                                function is added as a click handler on <tt>button</tt>.
         * @param {Boolean}            [waitUntilStopped] True if a spinner is used and the returned promise should not
         *                                                resolve until the spinner is known to have stopped, false
         *                                                otherwise (default). If falsey, the action will be still be
         *                                                performed as soon as the action resolves, but the returned
         *                                                promise will not resolve until the spinner stops.
         * @param {Number}             [delay]            The delay before the spinner should actually stop; defaults
         *                                                to the spinner default. If <tt>waitUntilStopped</tt>
         *                                                is true, the returned promise will not resolve until at least
         *                                                this time has passed.
         *
         * @return {Function} A function that on invocation will disable <tt>button</tt>, call <tt>action</tt>, and
         *                    enable <tt>button</tt> again, regardless if failure or success. The function will return
         *                    a promise that can be used for chaining handlers to <tt>action</tt>.
         */
        add: function add(button, action, spinner, waitUntilStopped, delay) {
            var progress = typeof spinner === "undefined" || spinner;
            var i = void 0;
            var active = null; // $.Deferred
            var disabled = false;
            var stopped = false;

            waitUntilStopped = waitUntilStopped && spinner;
            // Default Ladda delay on stop is 1000 ms, but that is to include the expand/collapse animation; 300 seems
            // to be a good visual compromise...
            delay = delay || 300;

            function handler() {
                // Invariant: we will never get an active button here if invoked by a dom handler, since once the
                //            buttons are disabled once activated/clicked, but the context can still call this
                //            function explicitly, e.g. based on a form submit via enter in some input field...

                if (active) {
                    log.warn("Button is already active: ", button);
                    return active; // deferred!

                    // Semi-permanently disabled?
                } else if (disabled) {
                    log.warn("Button is disabled: ", button);
                    return new $.Deferred().reject();
                }

                var i = void 0;
                var match = false;

                for (i = 0; i < button.length; i++) {
                    if ($(button.get(i)).is(":visible")) {
                        match = true;
                        break;
                    }
                }

                // Start: the spinner will already disable the button if used...
                if (progress && match) {
                    progress[i].start();
                } else {
                    button.attr("disabled", true);
                }

                stopped = false;

                // Stop: on "always()" callbacks, of if non-Deferred result from "action", or
                // if "action" throws an exception...
                function stop(force, result, error) {
                    function callback() {
                        if (typeof error === "undefined") {
                            error = result === REJECT || result instanceof Error;
                        }
                        if (error) {
                            active.reject(result);
                        } else {
                            active.resolve(result);
                        }
                        active = null;
                        // Make sure disable now if disabled while running...
                        if (disabled) {
                            handler.enable(false);
                        }
                    }

                    if (!stopped && (active || force)) {
                        stopped = true;
                        if (progress && match) {
                            // Do not wait to stop on REJECT...
                            var wait = active && waitUntilStopped && result !== REJECT;
                            progress[i].stop(delay, wait ? callback : null);
                            if (wait) {
                                return;
                            }
                        } else {
                            button.attr("disabled", false);
                        }
                        if (active) {
                            // if we wait, we will already have returned by now...
                            callback();
                        }
                        // Blur button to ensure we get proper styling again...
                        button.blur();
                    }
                }

                // Returns the $.Deferred for possible further chaining. Note that this is not the deferred from
                // the action!
                var promise = new $.Deferred();
                active = promise; // separate reference to avoid ever returned undefined after "stop"...
                try {
                    var result = typeof action === "function" ? action() : action;

                    // Result is a deferred. Once it resolves or is rejected, it will trigger the corresponding
                    // methods in "active"...
                    if (result && typeof result.always === "function") {
                        result.done(function (res) {
                            return stop(false, res, false);
                        }) // not an error
                        .fail(function (res) {
                            return stop(false, res, true);
                        }); // error

                        // If the result is not a deferred, we have to call stop() explicitly, forcing
                        // a stop even though we have no active call anymore...
                    } else {
                        stop(true, result);
                    }

                    // In case "action" raises an exception...
                } catch (e) {
                    log.error("Button action raised exception: ", e);
                    // Force stop and reject...
                    stop(true, e, true);
                }
                return promise; // never null or undefined here, even if stopped...
            }

            // If a spinner is used, it will handle all button click functionality...
            if (progress) {
                progress = [];
                for (i = 0; i < button.length; i++) {
                    progress.push(Ladda.create(button.get(i)));
                }

                // Explicitly listen for button clicks then...
            } else {
                button.on("click", function () {
                    handler();
                });
            }

            /**
             * Enables or disables this button. <p>
             *
             * While disabled, it cannot be clicked at all and the <tt>disabled</tt> css class is added to each
             * target button. <p>
             *
             * If this button is currently active, it will be disabled once stopped.
             *
             * @param {Boolean} enable True to enable this button (enabled by default), false to disable it. When
             *                         disabled, the button can never be clicked until re-enabled with this
             *                         function and a true argument.
             */
            handler.enable = function (enable) {
                disabled = !enable;
                if (disabled) {
                    // Running? If so, wait until completion to disable, i.e. from "stop"...
                    if (!active) {
                        button.addClass("disabled");
                        button.attr("disabled", true);
                    }
                } else {
                    button.removeClass("disabled");
                    button.attr("disabled", false);
                }
            };

            return handler;
        },


        /**
         * @type {*}
         * A constant to return by the action/logic executed by a sequential button when the normal (deferred)
         * execution should be rejected, for example because of input validation error on submit. <p>
         *
         * When this value is returned, the overall action of this sequential button will thus resolve in
         * a rejected call, with this constant as the single argument. This way, <b>external</b> <tt>fail</tt> and/or
         * <tt>always</tt> handlers attached to this button can test for this value before deciding what to do.
         */
        REJECT: REJECT

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["c"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(475);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// var modulo = require('./modulo');
var $floor = Math.floor;

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function floor(x) {
	// return x - modulo(x, 1);
	return $floor(x);
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://ecma-international.org/ecma-262/6.0/#sec-isarray
module.exports = __webpack_require__(741);


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(114);

var assertRecord = __webpack_require__(294);

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

module.exports = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mod = __webpack_require__(1311);

// https://262.ecma-international.org/5.1/#sec-5.2

module.exports = function modulo(x, y) {
	return mod(x, y);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var HttpStatusCodes = __webpack_require__(189);
    var _ = __webpack_require__(1);

    // Standard error prefix for all errors (unless overridden)...
    var PREFIX = "The %{method} of %{name} failed because ";

    // Commonly known error codes. See also <tt>ErrorAction</tt>.
    var CODES = {
        BAD_REQUEST: "badrequest",
        UNSUPPORTED: "unsupported",
        UPLOAD: "upload", // same as "unsupported", but for Images specifically
        FORBIDDEN: "forbidden",
        NOT_FOUND: "notfound",
        TIMEOUT: "timeout",
        VERSIONING: "versioning",
        INTERNAL: "internal",
        UNKNOWN: "unknown",
        UNHANDLED: "unhandled"
    };

    // Actions the user can try and take in case of errors. No action name is a subset of another! See also <tt>ErrorAction</tt>.
    var ACTIONS = {
        RELOGIN: "relogin",
        RELOAD: "reload",
        RETRY: "retry",
        DUPLICATE: "duplicate",
        COMMUNITY: "community",
        SUPPORT: "support",
        REMOVE_INCOMPATIBLE_WIDGETS: "removeIncompatibleWidgets"
    };

    /**
     * An <i>error handler</i> is used to translate actual errors into (more) user-friendly error-messages, such
     * as a http status code into a message, and to supply failure handlers to notify such errors to the users. <p>
     *
     * For now, only used by the editor, including channels admin app, but not by the viewer (because it has a lot
     * of editor specific code in it, should be refactored/re-thought)! <p>
     *
     * An error handler does not report any errors via the frontend error service, nor log them to the console
     * by default, but use configured callbacks to notify and discard the error. This is because the error handler
     * is used both in the viewer and the editor. In the editor, for example, the <tt>NotificationBar</tt> is
     * used to notify the user about errors. The app in question will ensure that the proper mechanisms for
     * notifying and discarding errors will have been set before actually used during app initialisation. <p>
     *
     * Error messages deduced by this error handler all have this format:
     * <pre>
     *   {
     *      message: String,        // The deduced error message to present to the user
     *      prefix:  String,        // The prefix of the deduced error message to present to the user, i.e. the generic
     *                              // part of each error message that will not vary for different causes, but for
     *                              // perhaps different model entities.
     *      model:   ImprovedModel, // The failing improved model, where relevant. Will fx be undefined on global
     *                              // unhandled errors, but set for sync failures.
     *      action:  String,        // The suggestion action(s) to take for the context alerting the error separated by
     *                              // space: "support", "community", "reload", "relogin", "duplicate", or "retry", or
     *                              // for example "reload duplicate". See <tt>ErrorHandler.Actions</tt>.
     *      code:    String         // A (group) code to link to the community, can encompass more (http) status codes.
     *                              // See <tt>ErrorHandler.Codes</tt>.
     *      status:  *              // The cause of the error, e.g. an <tt>Error</tt> or a http request status code.
     *   }
     * <pre>
     *
     * The <tt>error.message</tt> and <tt>error.prefix</tt> properties support simple value placeholders, where
     * actual values can be injected via <tt>ErrorHandler.inject(..)</tt>. This is useful to for example qualify
     * generic messages, as for example those generated by <tt>ErrorHandler.fromHttp(..)</tt>, with information
     * about the specific type of failing request (%{method}), the user-friendly name of the failing entity
     * (%{name}), the user-friendly type name of the entity (%{typeName}), and the cause (%{name}). See
     * <tt>ErrorHandler.inject(..)</tt> for further details.
     *
     * @class ErrorHandler
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    var ErrorHandler = Class.extend({

        /**
         * @type {{show: function(error:*, options:*):String, discard: function(..)}
         *
         * The callbacks used to notify and possible discard notified error messages. <p>
         *
         * The <tt>show</tt> function will take the error object as the first argument and notification
         * objects as the second, returning the logical id of the notification so it eventually can
         * be discarded later on. The error message (and prefix) will have their value placeholders
         * resolved before passed to <tt>show</tt>. <p>
         *
         * The <tt>discard</tt> function takes said any arguments, e.g. a notification id, and will discard
         * the error, if not already and where applicable.
         */
        notify: {},

        /**
         * Alerts a given notification error based on the supplied error, unless the supplied function handler, if
         * any, returns a falsey value ("suppress error"). If supplied, its return values must be "notify", "alert", or
         * some falsey value to suppress the error. <p>
         *
         * In the editor, for example, on "notify" or any other truthy value different from "alert", the error will be
         * notified via <tt>NotificationBar</tt>, potentially queued. On "alert", the error will be shown immediately
         * as the current notification in the <tt>NotificationBar</tt> <b>and</b> optionally alerted via
         * <tt>windows.alert</tt> if no pending windows alert is currently shown and if <tt>windows.alerts</tt> are
         * configured to be used. Any falsey value will suppress the notification from this handler (but can be
         * performed via <tt>handler</tt>, of course). <p>
         *
         * In the viewer, the <tt>NotificationBar</tt> is not available, and the error will generally just be
         * logged to the console if logging is enabled. <p>
         *
         * Instead of a handler, a set of values can be supplied to be injected into the supplied error message
         * via <tt>ErrorHandler.inject(..)</tt>. If a function handler is supplied, it must by itself inject
         * relevant values into the placeholders. <p>
         *
         * Any error alerted via this function can be discarded again via <tt>discard(..)</tt>.
         *
         * @param {*|Number} error The error, as <tt>Error</tt>, a status code, or an error as defined by this error handler,
         *                         i.e. {message:String, action:String, model:ImprovedModel, status:*}. The error messages
         *                         can support at least the value placeholders %{method}, %{name}, %{typeName}, and %{status},
         *                         to have values injected via <tt>ErrorHandler.inject()</tt>. If undefined, an
         *                         error like {message: "unknown"} is used here.
         *
         * @param {Function|*} [handlerOrValues] The handler to potentially suppress or augment the error or a set
         *                                       of values to inject into error message placeholders; can be null. If
         *                                       a function, must return "alert", "notify", or some falsey value to
         *                                       suppress the error. If values, the error will not be suppressed.
         *
         * @return {String} The id of the notified error, if any; can be falsey if no error is notified.
         */
        fail: function fail(error, handlerOrValues) {
            var kind = "alert";
            var options = {};
            var handler = _.isFunction(handlerOrValues) && handlerOrValues;

            if (_.isNumber(error)) {
                error = this.fromHttp(error);
            } else if (typeof error === "undefined") {
                error = { message: "unknown" };
            }
            // Let handler process error, perhaps augmenting the error message and injecting values,
            // or suppressing it altogether...
            if (handler) {
                try {
                    kind = handler(error, options); // "alert", "notify", or falsey

                    // Make sure error processing does not raise a spawned error...
                } catch (e) {
                    error.handlerError = e; // for tracing/reporting
                    // Fall-through
                }
            }
            options.alert = kind === "alert";
            options.queue = !options.alert;

            // Notify the user about the error?
            if (kind && this.notify.show) {
                // Resolve unless the handler was a function...
                if (!handler) {
                    this.inject(error, handlerOrValues);
                } else if (error.model || error.collection) {
                    this.inject(error);
                }
                return this.notify.show(error, options); // e.g. NotificationBar.error(error, options);
            }
        },


        /**
         * Discards the error notified/raised via <tt>ErrorHandler.fail(..)</tt>, if not already discarded.
         *
         * @param {*} [args] Arguments forwarded to <tt>notify.discard</tt> with this error handler as the
         *                   scope, if any.
         */
        discard: function discard() {
            if (this.notify.discard) {
                var _notify;

                (_notify = this.notify).discard.apply(_notify, arguments); // e.g. NotificationBar.close({id: id, clear: "self"});
            }
        },


        /**
         * Adds a <tt>fail</tt> handler to the supplied http request promise. <p>
         *
         * On http error, an error will be deduced by <tt>fromHttp</tt> and if <tt>handlerOrValues</tt> is a function
         * like <tt>handler(error:*, options:*):String</tt>, it will be called with said error. The return value of
         * the handler, if any, can be "notify", "alert", or some falsey value. On "notify" or any other truthy value
         * different from "alert", the error will be notified via <tt>NotificationBar</tt>, potentially queued. On
         * "alert", the error will be shown immediately as the current notification in the <tt>NotificationBar</tt>
         * <b>and</b> optionally alerted via <tt>windows.alert</tt> if no pending windows alert is currently shown.
         * Any falsey value will suppress the notification from this handler (but can be performed via the handler,
         * of course). If a function handler is used, it must ensure that <tt>ErrorHandler.inject(..)</tt> is called
         * to replace value places in the error with actual values. <p>
         *
         * If <tt>handlerOrValues</tt> is an object storing values, they will be injected into the error on failure.
         *
         * @param {Promise}           promise    The promise for the http request; can be falsey, in which case this
         *                                       function does nothing.
         * @param {Function|*} [handlerOrValues] The handler to potentially suppress or augment the error or a set
         *                                       of values to inject into error message placeholders; can be null. If
         *                                       a function, must return "alert", "notify", or some falsey value to
         *                                       suppress the error. If values, the error will not be suppressed.
         *
         * @return {Promise} A promise with a proper http fail handler; will be falsey if <tt>promise</tt> is falsey.
         *                   The promise will on fail resolve to the id of the notification made, or falsey otherwise.
         */
        failHttp: function failHttp(promise, handlerOrValues) {
            var _this = this;

            return promise && promise.fail(function (xhr) {
                if (xhr !== "cancelled") {
                    // = Syncer.CANCELLED, but cannot be included because of circular dependencies!
                    return _this.fail(_this.fromHttp(xhr), handlerOrValues);
                }
            });
        },


        /**
         * Returns an error message from the supplied failing http request. <p>
         *
         * The error message will consists of a prefix text like "The %{method} of %{name} failed because ", and
         * a message with the detailed error post fixed, like prefix + "somebody else is modifying the %{typeName}."
         * on 409 - CONFLICT. For the error message to be useful, it must be resolved when values are ready for
         * injection into the placeholder via <tt>ErrorHandler.inject(..)</tt>.
         *
         * @param {*|Number} xhrOrStatus An already formatted error, the failing http(s) request or the failing status;
         *                               can be falsey which will default to 501 - Not Implemented. If an already
         *                               formatted error, it will simply be returned.
         * @param {*}       [values]     The values to inject into the described placeholders, if already available;
         *                               can be undefined.
         *
         * @return {{message:String, action:String, status:*}} An error message with the described value
         *         placeholders; never null.
         */
        fromHttp: function fromHttp(xhrOrStatus, values) {
            // Make sure we do not get null pointers for deferred manually rejected, like from the font loader when
            // linked fonts are not supported (in Firefox for example), even though we actually expected the
            // failing xhr request here...
            xhrOrStatus = xhrOrStatus || { status: HttpStatusCodes.NOT_IMPLEMENTED }; // 501 - Not implemented in lack of something better, not used for anything else

            // Assumed already formatted if it has a "message" property (also for Error's)...
            if (xhrOrStatus.message) {
                return xhrOrStatus;
            }

            // TODO xhrOrStatus can also be a string. For instance it will be "timeout" if the browser times out the request.
            var status = typeof xhrOrStatus === "number" ? xhrOrStatus : xhrOrStatus.status;
            var error = {
                prefix: PREFIX, message: null, action: [ACTIONS.SUPPORT], code: null, status: status
            }; // set cause to status code to avoid keeping references to stale requests

            // Was retry!
            switch (status) {
                case HttpStatusCodes.BAD_REQUEST:
                    // i.e. frontend error
                    error.message = "of invalid submitted data."; // does not make sense to retry, data is bad...
                    error.code = CODES.BAD_REQUEST;
                    break;

                case HttpStatusCodes.UNAUTHORIZED:
                case HttpStatusCodes.FORBIDDEN:
                    error.message = "you are not authorized to perform the action for the %{typeName}.";
                    error.code = CODES.FORBIDDEN;
                    error.action.push(ACTIONS.RELOGIN);
                    break;

                case HttpStatusCodes.NOT_FOUND:
                case HttpStatusCodes.METHOD_NOT_ALLOWED:
                    // e.g. no such endpoint for the http method, raised via RESTEasy
                    error.message = "no such %{typeName} could be found."; // nothing to retry, i.e. not found!
                    error.code = CODES.NOT_FOUND;
                    break;

                case HttpStatusCodes.REQUEST_TIMEOUT:
                    error.message = "of timeout.";
                    error.action.push(ACTIONS.RETRY);
                    error.code = CODES.TIMEOUT;
                    break;

                case HttpStatusCodes.CONFLICT:
                    // optimistic locking failed...
                    error.message = "somebody else is modifying the %{typeName}.";
                    error.action.push(ACTIONS.RELOAD, ACTIONS.DUPLICATE); // duplicate only where applicable!
                    error.code = CODES.VERSIONING;
                    break;

                case HttpStatusCodes.GONE:
                    error.message = "the %{typeName} has been deleted."; // nothing to retry, i.e. soft deleted!
                    error.code = CODES.NOT_FOUND;
                    break;

                case HttpStatusCodes.REQUEST_ENTITY_TOO_LARGE: // request entity too large, i.e. user error
                case HttpStatusCodes.UNSUPPORTED_MEDIA_TYPE: // unsupported media type, i.e. user error
                case HttpStatusCodes.NOT_IMPLEMENTED:
                    // not implemented (in lack of something better)
                    error.message = "the requested action is not supported."; // generally, a retry does not make sense, since it is like to be an image upload
                    error.code = CODES.UNSUPPORTED;
                    break;

                case HttpStatusCodes.TOO_MANY_REQUESTS:
                    // too many requests...
                    error.message = "too many requests have been submitted.";
                    break;

                case HttpStatusCodes.INTERNAL_SERVER_ERROR:
                    // Internal server error
                    error.message = "of an internal server error."; // A retry doesn't make sense because this is an edge case. The purging will fail only if Akamai is not available, never happened in Publicator
                    error.code = CODES.INTERNAL;
                    break;

                // Success, which means the frontend caused the failure. This is typically due to a marshall
                // error on the backend, which returns a result (200), but with invalid json data that cannot
                // be parsed on the frontend, thus calling "fail"...
                case HttpStatusCodes.OK:
                    error.message = "of a potential %{typeName} data issue.";
                    error.action.push(ACTIONS.RETRY); // no community error code
                    break;

                default:
                    // some unknown type of server error...
                    error.message = "of a server error (cause %{status}).";
                    error.action.push(ACTIONS.RETRY); // no community error code
                    error.code = CODES.UNKNOWN;
                    break;
            }

            if (error.code) {
                error.action.push(ACTIONS.COMMUNITY);
            }

            // Do we have values to inject already?
            if (values) {
                this.inject(error, values);
            }

            error.action = error.action.join(" ");
            return error;
        },


        /**
         * Injects the specified values into the supplied error. <p>
         *
         * <tt>values</tt> are expected to store "method", "name", "typeName", and "status", but will default
         * to "request", "resource", "resource", and to <tt>error.status</tt> or "unknown", respectively. If the
         * values are a no-arg function, it will be called to return the value to inject. <p>
         *
         * If <tt>error.model</tt> is set, however, "method", "name", and "typeName" will default to
         * the current sync method, the distinguished name of the model, and the type name, respectively. <p>
         *
         * For example, the error prefix text can be something like "The %{method} of %{name} failed because ", and
         * the error message with the detailed error post fixed, like prefix + "somebody else is modifying the
         * %{typeName}." on 409 - CONFLICT. The placeholders %{method}, %{name}, and %{typeName} are expected to be
         * resolved to the logical sync request type, e.g. "save" or "destroy", %{name} to a user-friendly name of the
         * failing entity (model), and %{typeName} to logical type of resource is a user-friendly manner, e.g.
         * <tt>ImprovedModel.__typeName</tt>. In addition, %{status} can also be injected, i.e. the http response code
         * like 409.
         *
         * @param {{prefix:String, message:String, action:String, model:ImprovedModel, status:*}} error The error to
         *        inject resolved values into; cannot be null. If <tt>model</tt> is set, it will provide the default
         *        values of the real defaults.
         * @param {*} [values] The values to inject, indexed by their name. A key of "some_key" will be injected into
         *                     the error prefix/message the placeholder %{some_key} is found. Can be null, will default.
         *
         * @return {{prefix:String, message:String, action:String, status:*}} <tt>error</tt>, now with injected values.
         */
        inject: function inject(error, values) {
            var name = void 0;
            var value = void 0;
            var regex = void 0;

            var resource = error.model || error.collection;

            values = _.isObject(values) ? values : {};

            values.method = values.method || resource && resource.syncState && resource.syncState.current.method || "request";
            values.name = values.name || resource && resource.distinguishedName() || "resource";
            values.typeName = values.typeName || resource && resource.__typeName || "resource";
            values.status = values.status || error.status || "unknown";

            // A bit of a hack, but texts will sound odd otherwise...
            if (values.name === values.typeName) {
                values.name = "the " + values.name;
            }
            if (!error.prefix) {
                error.prefix = PREFIX;
            }
            // Try a final resolve if we do not have a resolved error message at this point. We have to extend
            // the incoming error, since a reference to the actual error...
            if (!error.message) {
                _.extend(error, this.fromHttp(values.status));
            }

            // Replace...
            for (name in values) {
                if (values.hasOwnProperty(name)) {
                    regex = new RegExp("\\%\\{" + name + "\\}", "gi");
                    value = values[name];
                    if (_.isFunction(value)) {
                        value = value();
                    }
                    error.prefix = error.prefix.replace(regex, value);
                    error.message = error.message.replace(regex, value);
                }
            }

            // To handle multiple inject calls...
            if (error.message.indexOf(error.prefix) === -1) {
                error.message = error.prefix + error.message;
            }

            return error;
        }
    });

    // Singleton, so we have to add static variables directly...
    var handler = new ErrorHandler();

    handler.PREFIX = PREFIX;
    handler.Codes = CODES;
    handler.Actions = ACTIONS;

    return handler;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DateUtil", function() { return DateUtil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);

var SHORT_MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
/**
 * Contains date utility functions.
 *
 * @class DateUtil
 * @constructor
 */
var DateUtil = /** @class */ (function () {
    function DateUtil() {
    }
    /**
    * Returns the current timestamp in milliseconds since the epoch.
    *
    * @return {Number} The current timestamp in ms.
    */
    DateUtil.now = function () {
        return Date.now();
    };
    /**
     * Returns the year of the current date according to local time.
     *
     * @return {Number} The current year.
     */
    DateUtil.currentYear = function () {
        return new Date().getFullYear();
    };
    DateUtil._oneDigitPrepender = function (value) {
        return value < 10 ? "0" + value : value;
    };
    /**
     * Formats a date/timestamp in "YYYY-MM-DD, HH:mm" format.
     *
     * @param  {Number|Date} date The date to format. It can be null, in which case an empty string will be returned.
     * @return {String} The formatted date string or an empty string if the passed date is null.
     */
    DateUtil.formatYYYYMMDDHHmm = function (date) {
        if (!date) {
            return "";
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_underscore__["isNumber"])(date)) {
            date = new Date(date);
        }
        var year = date.getFullYear();
        var month = this._oneDigitPrepender(date.getMonth() + 1);
        var day = this._oneDigitPrepender(date.getDate());
        var hour = this._oneDigitPrepender(date.getHours());
        var minute = this._oneDigitPrepender(date.getMinutes());
        return year + "-" + month + "-" + day + ", " + hour + ":" + minute; // will coerce numbers into strings!
    };
    /**
     * Calculate the difference between two dates in days
     *
     * @param  {Number|Date} date1 The date to be calculate1 (Number or date); cannot be null
     * @param  {Number|Date} date2 The date to be calculate2 (Number or date); cannot be null
     * @return {Number} The days difference NOT rounded. It maybe a decimal value e.g. 1.2548
     */
    DateUtil.diffDays = function (date1, date2) {
        if (Object(__WEBPACK_IMPORTED_MODULE_0_underscore__["isNumber"])(date1)) {
            date1 = new Date(date1);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_underscore__["isNumber"])(date2)) {
            date2 = new Date(date2);
        }
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return timeDiff / (1000 * 3600 * 24);
    };
    /**
     * Compute relative time difference between two timestamps and return a nicely formatted string representation.
     *
     * @param {Number}  current   current timestamp in ms
     * @param {Number} [previous] previous timestamp in ms. Optional. Defaults to 0.
     * @returns {string} a nicely formatted string representation
     */
    DateUtil.timeDifference = function (current, previous) {
        var msPerMinute = 60 * 1000;
        var msPerHour = msPerMinute * 60;
        var msPerDay = msPerHour * 24;
        var msPerMonth = msPerDay * 30;
        var msPerYear = msPerDay * 365;
        if (!previous) {
            previous = 0;
        }
        var elapsed = current - previous;
        if (elapsed < msPerHour) {
            var min = Math.round(elapsed / msPerMinute);
            if (min <= 1) {
                return "a minute";
            }
            return min + " minutes";
        }
        else if (elapsed < msPerDay) {
            var hour = Math.round(elapsed / msPerHour);
            var hourString = hour.toString();
            hourString += hour > 1 ? " hours" : " hour";
            return hourString;
        }
        else if (elapsed < msPerMonth) {
            var day = Math.round(elapsed / msPerDay);
            var dayString = day.toString();
            dayString += day > 1 ? " days" : " day";
            return dayString;
        }
        else if (elapsed < msPerYear) {
            var month = Math.round(elapsed / msPerMonth);
            var monthString = month.toString();
            monthString += month > 1 ? " months" : " month";
            return monthString;
        }
        var year = Math.round(elapsed / msPerYear);
        var yearString = year.toString();
        yearString += year > 1 ? " years" : " year";
        return yearString;
    };
    /**
     * Formats the supplied date/timestamp as a named month, e.g. "Jun", a double digit date, e.g. "06", a
     * comma followed by a four digit year, e.g. "2014". For example "Jun 06, 2014".
     *
     * @param {Number|Date} date The date to format. It can be null, in which case an empty string will be returned.
     * @return {String} The formatted date string or an empty string if the passed date is null.
     */
    DateUtil.formatMMDDYYY = function (date) {
        if (!date) {
            return "";
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_0_underscore__["isNumber"])(date)) {
            date = new Date(date);
        }
        var year = date.getFullYear();
        var month = SHORT_MONTH_NAMES[date.getMonth()];
        var day = this._oneDigitPrepender(date.getDate());
        return month + " " + day + ", " + year;
    };
    return DateUtil;
}());



/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(120),
        DateUtil = _require.DateUtil;

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var Syncer = __webpack_require__(50);
    var SyncManager = __webpack_require__(44);

    var log = new Logger("Time");

    var serverTime = 0;
    var clientTime = 0; // user time last time "serverTime" was updated, for "ticks"...

    var failed = false;

    var target = { // for queueing
        id: "time",
        toString: function toString() {
            var server = serverTime ? Time.server(true) : 0; // needed to describe the different scenarios
            var client = Time.client();
            var s = "Time[";

            if (server) {
                s += "server: " + DateUtil.formatYYYYMMDDHHmm(server) + "; ";
            }

            s += "client: " + DateUtil.formatYYYYMMDDHHmm(client);

            if (server) {
                s += "; server-";

                if (server > client) {
                    s += "ahead: " + DateUtil.timeDifference(server, client);
                } else {
                    s += "behind: " + DateUtil.timeDifference(client, server);
                }

                s += " (" + (server - client) + "ms)";
            }

            return s + "]";
        }
    };

    Syncer.State.init(target, {
        immutable: true,
        unique: ["id"]
    });

    /**
     * @class {Time}
     *
     * The <tt>Time</tt> type is used to provide correct dates and times for the <i>server</i> and <i>client</i>
     * times. For model properties normally timestamped by the backend, it is not safe to use the client time
     * because of time zone differences. For each such model property, for example "editedAt", the server time
     * must be used to ensure correctness. For pure frontend behaviour, it suffices to use the client time.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    var Time = {

        /**
         * Returns a promise that will resolve with the server time in ms since the epoch.
         *
         * @return {Promise} A promise that will resolve with the server time in ms since the epoch.
         */
        update: function update() {
            return SyncManager.get("time", target).done(function (timeFromServer) {
                serverTime = parseInt(timeFromServer, 10) || 0; // NaN -> 0
                clientTime = serverTime ? Time.client() : 0;
                log.info("Server time updated: " + serverTime + "ms -> " + target);
            }).fail(function () {
                failed = true;
            });
        },


        /**
         * Returns the (estimated) server time in ms seconds since the epoch in a synchronous fashion. That is,
         * the current estimated server time ("ticked") is returned immediately, calculated based on the last
         * known server time. <p>
         *
         * Always prefer this time over client time when setting timestamps, as user time cannot be trusted. This
         * method may also trigger a silent update of the server time in the background if the last actual server
         * time retrieved is older than 10 minutes, but only if <tt>noUpdate</tt> is falsey.
         *
         * @param  {Boolean} [noUpdate] True to skip a background update of the server time always, false to update if
         *                              its time to do so (default).
         * @return {Number} The server time in ms since the epoch.
         * @throws {Error}  If a previous call of the update method has failed to get the time, an error will be thrown.
         */
        server: function server(noUpdate) {
            if (failed) {
                throw new Error("Failed fetching server time.");
            }

            // User time...
            var client = this.client();
            var ticks = clientTime ? Math.max(client - clientTime, 0) : 0;

            // Update in the background if it has been more than 10 minutes since last update...
            if (!noUpdate && (!serverTime || ticks > 600000)) {
                // 1000 ms/s * 60 s/m * 10 m
                this.update();
            }

            // We may not have a server time yet... :/ But, if we do, add ms passed since last server time was fetched
            // to make the time tick. This cannot be guaranteed to be absolute precise, but as close as we can get
            // when requesting the time synchronously like this...
            if (serverTime) {
                return serverTime + ticks;
            }

            log.verbose("No server time available yet, using client time: " + this);
            return clientTime;
        },


        /**
         * Returns the client (user) time in ms seconds since the epoch. <p>
         *
         * The client time <b>cannot</b> be trusted as the client machine can be set to any date/time.
         *
         * @return {Number} The client time in ms since the epoch.
         */
        client: function client() {
            return Date.now();
        }
    };

    return Time;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(775);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(66);








var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */


var SafeAnchor =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = SafeAnchor.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        href = _this$props.href,
        onClick = _this$props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        disabled = _this$props2.disabled,
        onKeyDown = _this$props2.onKeyDown,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["componentClass", "disabled", "onKeyDown"]);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')

      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        pointerEvents: 'none'
      }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      onClick: this.handleClick,
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationTypes = __webpack_require__(769),
        AnimationEditorTypes = __webpack_require__(1689),
        EditorEvents = __webpack_require__(17),
        template = __webpack_require__(1705),
        AbstractWidgetPropertiesView = __webpack_require__(63);

    var EXPAND_PROPERTY = "animationExpanded";

    /**
     * The animation properties view, containing the subviews for different animation types.
     *
     * @class AnimationPropertiesView
     *
     * @cfg {AbstractWidgetModel} model The widget model being edited.
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        template: template,

        regions: {
            slideAnimationProperties: ".slide-animation-properties",
            slideOutAnimationProperties: ".slide-out-animation-properties",
            fadeAnimationProperties: ".fade-animation-properties",
            fadeOutAnimationProperties: ".fade-out-animation-properties",
            zoomInAnimationProperties: ".zoom-in-animation-properties",
            zoomOutAnimationProperties: ".zoom-out-animation-properties",
            moveAnimationProperties: ".move-animation-properties"
        },

        ui: {
            container: ".animation-properties-accordion",
            legend: "[data-target=\".animation-properties-accordion\"]",
            slideAnimationEnabled: ".slide-animation-enabled",
            slideOutAnimationEnabled: ".slide-out-animation-enabled",
            fadeAnimationEnabled: ".fade-animation-enabled",
            fadeOutAnimationEnabled: ".fade-out-animation-enabled",
            zoomInAnimationEnabled: ".zoom-in-animation-enabled",
            zoomOutAnimationEnabled: ".zoom-out-animation-enabled",
            moveAnimationEnabled: ".move-animation-enabled"
        },

        events: {
            "change .slide-animation-enabled": function changeSlideAnimationEnabled() {
                this._enabledChangeHandler(AnimationTypes.SLIDE, this.ui.slideAnimationEnabled.is(":checked"), this.slideAnimationProperties);
            },
            "change .slide-out-animation-enabled": function changeSlideOutAnimationEnabled() {
                this._enabledChangeHandler(AnimationTypes.SLIDE_OUT, this.ui.slideOutAnimationEnabled.is(":checked"), this.slideOutAnimationProperties);
            },
            "change .fade-animation-enabled": function changeFadeAnimationEnabled() {
                this._enabledChangeHandler(AnimationTypes.FADE, this.ui.fadeAnimationEnabled.is(":checked"), this.fadeAnimationProperties);
            },
            "change .fade-out-animation-enabled": function changeFadeOutAnimationEnabled() {
                this._enabledChangeHandler(AnimationTypes.FADE_OUT, this.ui.fadeOutAnimationEnabled.is(":checked"), this.fadeOutAnimationProperties);
            },
            "change .zoom-in-animation-enabled": function changeZoomInAnimationEnabled() {
                this._enabledChangeHandler(AnimationTypes.ZOOM_IN, this.ui.zoomInAnimationEnabled.is(":checked"), this.zoomInAnimationProperties);
            },
            "change .zoom-out-animation-enabled": function changeZoomOutAnimationEnabled() {
                this._enabledChangeHandler(AnimationTypes.ZOOM_OUT, this.ui.zoomOutAnimationEnabled.is(":checked"), this.zoomOutAnimationProperties);
            },
            "change .move-animation-enabled": function changeMoveAnimationEnabled() {
                this._enabledChangeHandler(AnimationTypes.MOVE, this.ui.moveAnimationEnabled.is(":checked"), this.moveAnimationProperties);
            }
        },

        /**
         * Finds an animation in the animations collection with the given type.
         *
         * @param {Object} animationTypeDescriptor One of AnimationTypes.*
         * @returns {AnimationModel} The found model, or undefined if no match was found.
         * @private
         */
        _findAnimationWithType: function _findAnimationWithType(animationTypeDescriptor) {
            return this.model.get("animations").find(function (model) {
                return animationTypeDescriptor.id === model.get("type");
            });
        },

        /**
         * Handler for changes to the enabled state of a checkbox.
         *
         * @param {Object} animationTypeDescriptor The AnimationTypes.* object for the animation type.
         * @param {boolean} enabled The new enabled state.
         * @param {Object} propertiesViewRegion The region for the properties view.
         * @private
         */
        _enabledChangeHandler: function _enabledChangeHandler(animationTypeDescriptor, enabled, propertiesViewRegion) {
            var animationModel;

            if (enabled) {
                animationModel = new animationTypeDescriptor.modelClass();
                this.model.get("animations").add(animationModel);
                this._showPropertiesView(propertiesViewRegion, animationModel);
                propertiesViewRegion.$el.one("show.bs.collapse hide.bs.collapse shown.bs.collapse hidden.bs.collapse", function (e) {
                    e.stopPropagation();
                });
                propertiesViewRegion.$el.collapse("show");
            } else {
                animationModel = this._findAnimationWithType(animationTypeDescriptor);
                if (animationModel) {
                    this.model.get("animations").remove(animationModel);
                    animationModel.destroy();
                }
                propertiesViewRegion.$el.one("hidden", function () {
                    propertiesViewRegion.close();
                });
                propertiesViewRegion.$el.one("show.bs.collapse hide.bs.collapse shown.bs.collapse hidden.bs.collapse", function (e) {
                    e.stopPropagation();
                });
                propertiesViewRegion.$el.collapse("hide");
            }
            var viewModel = this.viewScope.viewModel,
                experience = viewModel.get("experience"),
                eventProperties = {
                triggerOrigin: "WidgetMenuAnimationCheckbox",
                updatedProperty: "animation-" + animationTypeDescriptor.id,
                updatedValue: enabled,
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                sceneNumber: viewModel.get("sceneNumber"),
                widgetType: this.model.get("type")
            };

            EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
        },

        /**
         * Shows the properties view for the given animation model in the given region.
         *
         * @param {Object} region The region.
         * @param {AnimationModel} model The model.
         * @private
         */
        _showPropertiesView: function _showPropertiesView(region, model) {
            region.show(new (AnimationEditorTypes.fromString(model.get("type")).propertiesViewClass)({
                model: model,
                widgetModel: this.model,
                widgetView: this.options.widgetView
            }));
        },

        onShow: function onShow() {
            this.__super();
            var experience = this.viewScope.viewModel.get("experience");
            this.listenTo(experience, "change:emailModeEnabled", this._toggleAnimationBar);
        },
        _toggleAnimationBar: function _toggleAnimationBar() {
            var experience = this.viewScope.viewModel.get("experience");
            var isEmailModeEnabled = experience.get("emailModeEnabled");
            // close tab if expanded
            if (isEmailModeEnabled && this.ui.container.hasClass("in")) {
                this.ui.container.removeClass("in");
            }
            if (isEmailModeEnabled && !this.ui.legend.hasClass("collapsed")) {
                this.ui.legend.addClass("collapsed");
            }

            this.ui.legend.attr("data-toggle", isEmailModeEnabled ? "disabled" : "collapse");
        },


        onRender: function onRender() {
            this.__super();
            this._toggleAnimationBar();

            var slideAnimationModel = this._findAnimationWithType(AnimationTypes.SLIDE),
                slideOutAnimationModel = this._findAnimationWithType(AnimationTypes.SLIDE_OUT),
                fadeAnimationModel = this._findAnimationWithType(AnimationTypes.FADE),
                fadeOutAnimationModel = this._findAnimationWithType(AnimationTypes.FADE_OUT),
                zoomInAnimationModel = this._findAnimationWithType(AnimationTypes.ZOOM_IN),
                zoomOutAnimationModel = this._findAnimationWithType(AnimationTypes.ZOOM_OUT),
                moveAnimationModel = this._findAnimationWithType(AnimationTypes.MOVE);

            if (slideAnimationModel) {
                this.ui.slideAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.slideAnimationProperties, slideAnimationModel);
                this.slideAnimationProperties.$el.addClass("in");
            }
            if (slideOutAnimationModel) {
                this.ui.slideOutAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.slideOutAnimationProperties, slideOutAnimationModel);
                this.slideOutAnimationProperties.$el.addClass("in");
            }
            if (fadeAnimationModel) {
                this.ui.fadeAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.fadeAnimationProperties, fadeAnimationModel);
                this.fadeAnimationProperties.$el.addClass("in");
            }
            if (fadeOutAnimationModel) {
                this.ui.fadeOutAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.fadeOutAnimationProperties, fadeOutAnimationModel);
                this.fadeOutAnimationProperties.$el.addClass("in");
            }
            if (zoomInAnimationModel) {
                this.ui.zoomInAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.zoomInAnimationProperties, zoomInAnimationModel);
                this.zoomInAnimationProperties.$el.addClass("in");
            }
            if (zoomOutAnimationModel) {
                this.ui.zoomOutAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.zoomOutAnimationProperties, zoomOutAnimationModel);
                this.zoomOutAnimationProperties.$el.addClass("in");
            }
            if (moveAnimationModel) {
                this.ui.moveAnimationEnabled.prop("checked", true);
                this._showPropertiesView(this.moveAnimationProperties, moveAnimationModel);
                this.moveAnimationProperties.$el.addClass("in");
            }
        }
    }, {
        expandProperty: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);

    var _require = __webpack_require__(30),
        capitalize = _require.capitalize;

    var _require2 = __webpack_require__(1),
        isFunction = _require2.isFunction;

    /**
     * A <tt>ViewController</tt> acts as a mediator/controller for a specific
     * view (only <tt>ImprovedView</tt>'s for now) and is responsible for dealing with any related
     * business/application logic, making the actual view as "clean" as possible.
     *
     * @see  ImprovedView
     * @see  SignInView (for implementation example)
     *
     * @class ViewController
     * @author Kim
     */


    return Marionette.Controller.extend({

        view: null,

        options: null,

        model: null,

        ui: null,

        /**
         * Delegate all events emitted directly on the view to the controller
         * as function calls with an "onView"-prefix.
         *
         * ":"'s are removed, and the following word capitalized.
         *
         * Also makes sure `close` the controller is closed when the view is.
         *
         * "toggleComments" -> onViewToggleComments()
         * "quickView:open" -> onViewQuickViewOpen()
         *
         * @private
         */
        _setupViewEvents: function _setupViewEvents() {
            var _this = this;

            // Close controller when view is closed.
            this.listenToOnce(this.view, "close", function () {
                _this.close();
            });

            this.listenToOnce(this.view, "item:rendered", this._itemRenderedHandler);

            // Delegate events triggered on the view to the controller as
            // function calls.
            this.listenTo(this.view, "all", function (eventType) {
                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                var fnName = "onView" + eventType.split(":").map(capitalize).join("");
                var listenerFunction = _this[fnName];

                if (isFunction(listenerFunction)) {
                    listenerFunction.apply(_this, args);
                }
            });
        },
        _itemRenderedHandler: function _itemRenderedHandler() {
            // Store a feference to the view's ui object
            this.ui = this.view.ui;
            // Make sure to clear listeners in case the view was re-rendered
            this.stopListening(this.view);
            // Hook up custom events
            this._setupViewEvents();
            // Invoke onRender callback
            this.onViewRender();
        },
        initialize: function initialize() {
            this.view = this.options.view;
            this.options = this.view.options;
            this.model = this.view.model;

            this.listenToOnce(this.view, "item:rendered", this._itemRenderedHandler);

            this.onInitialize();
        },


        /**
         * Invoked (only once) as part of the initialize cycle.
         */
        onInitialize: function onInitialize() {},


        /**
         * Syncs with the views rendering cycle, invoked when the view is rendered. Similar to
         * the view's #onRender.
         */
        onViewRender: function onViewRender() {}
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var RestApi = __webpack_require__(29);

    /**
     * Abstract base class for creating integrations.
     *
     * @see CustomFontIntegrationModel
     * @see TypekitIntegrationModel
     * @see FontsDotComIntegrationModel
     * @see AmazonRekognitionIntegrationModel
     *
     * @class IntegrationModel
     */
    return ImprovedModel.extend("IntegrationModel", {

        defaults: {
            companyId: undefined
        },

        url: function url() {
            return this.isNew() ? RestApi.pathToCollection(RestApi.Collections.INTEGRATIONS) : RestApi.pathToSpecificResource(RestApi.Collections.INTEGRATIONS, this.id);
        }
    }, {
        /**
         * The integration type, e.g TypekitIntegration.<p>
         *
         * This static property must be implemented by the subclass.
         *
         * @type {String}
         */
        type: null
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1103);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 133 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var inspect = __webpack_require__(745);

var IsPropertyKey = __webpack_require__(64);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-get-o-p

module.exports = function Get(O, P) {
	// 7.3.1.1
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true, got ' + inspect(P));
	}
	// 7.3.1.3
	return O[P];
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var ButtonWidgetModel = __webpack_require__(305);
    var ButtonType = __webpack_require__(364);
    var UrlUtil = __webpack_require__(46);
    var FontDescriptorCollection = __webpack_require__(777);
    var FontProvider = __webpack_require__(103);
    var GoogleFonts = __webpack_require__(1453);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Preconditions = __webpack_require__(14);
    var StandardWebFontList = __webpack_require__(778);
    var TextWidgetModel = __webpack_require__(366);
    var EnhancedTextWidgetModel = __webpack_require__(367);
    var WebFontVariants = __webpack_require__(365).default;

    var fontStyles = ["normal", "italic", "oblique", "initial", "inherit"];

    var logger = new Logger("WebFontsUtil");

    /**
     * Convenience method for setting the `kitID` when dealing with Typekit,
     * the project Id for Fonts.com fonts and `url`, `customFontId`, `format` for custom fonts.
     *
     * @param {String} fontProviderValue The font provider string representation.
     * @param {Object} meta The current text widget metadata.
     *
     * @return {Object} `FontDescriptor` metadata for the specified font provider.
     *
     * Standard and Google fonts do not need any special treatment.
     */
    var fontDescriptorData = function fontDescriptorData(fontProviderValue, meta) {
        var fontProvider = FontProvider.fromValue(fontProviderValue);
        switch (fontProvider) {
            case FontProvider.CUSTOM:
                return {
                    path: _.result(meta, "path"),
                    customFontId: _.result(meta, "customFontId"),
                    format: _.result(meta, "format")
                };

            case FontProvider.TYPEKIT:
                return {
                    kitID: _.result(meta, "kitID")
                };

            case FontProvider.FONTS_DOT_COM:
                return {
                    projectId: _.result(meta, "projectId")
                };

            default:
                // No descriptors for Google and Standard fonts.
                return null;
        }
    };

    /**
     * All static utility class for working with web fonts.
     *
     * @class WebFontsUtil
     * @author Kim
     */
    var WebFontsUtil = {

        /**
         * Convenience method for ensuring backwards compatibility (pre MOS-1405). If a font provider is already
         * defined, that provider is returned. Otherwise it's safe to assume that it's either a standard font or a
         * Google font.
         *
         * @param  {String} fontFamily          The font family.
         * @param  {FontProvider} fontProvider  Optional `FontProvider`.
         * @return {FontProvider}               The correct font provider.
         */
        fontProvider: function fontProvider(fontFamily, _fontProvider) {
            if (_fontProvider) {
                return _fontProvider;
            }

            return WebFontsUtil.isStandardWebFont(fontFamily) ? FontProvider.STANDARD : FontProvider.GOOGLE;
        },


        /**
         * Checks if we have legacy font properties. if there is, we converts them to the new properties
         * This is introduced for the task "advance text editor"
         */
        fontCompatibilityCheck: function fontCompatibilityCheck(widget) {
            var attrs = {};
            var fontFamilies = widget.get("fontFamilies");
            var fontFamily = widget.get("fontFamily");
            var fontStyle = widget.get("fontStyle");
            var fontWeight = widget.get("fontWeight");
            var fontMetadata = widget.get("fontMetadata");
            var fontProviderValue = widget.get("fontProvider");

            // In the older experiences, we may not have a font provider
            if (!fontProviderValue) {
                var fontProvider = WebFontsUtil.fontProvider(fontFamily);
                fontProviderValue = attrs.fontProvider = fontProvider.value;
            }

            // In the old text widget, fontStyle is a font variant which is composed of
            // css font style and font weight
            if (!widget.has("fontWeight") || _.indexOf(fontStyles, fontStyle) === -1) {
                var fontVariant = widget.get("fontStyle");
                var font = WebFontsUtil.toCss(fontFamily, fontVariant, fontProviderValue);

                fontStyle = attrs.fontStyle = font.fontStyle;
                fontWeight = attrs.fontWeight = font.fontWeight;
            }

            if (!fontMetadata) {
                fontMetadata = attrs.fontMetadata = {
                    cssFamilyNames: fontFamily
                };
            } else if (!fontMetadata.cssFamilyNames) {
                fontMetadata.cssFamilyNames = fontFamily;
            }

            if (!fontFamilies || !fontFamilies.length) {
                attrs.fontFamilies = [{
                    fontProvider: fontProviderValue,
                    fontFamily: fontFamily,
                    fontStyle: fontStyle,
                    fontWeight: fontWeight,
                    fontMetadata: fontMetadata
                }];
            }

            // Enhanced text widget have no attrs at this step
            // because it uses not all of old-style text widget props
            // so, construct correct attrs from fontFamilies
            // metadata and available data props
            if (!attrs.fontFamilies && fontFamilies) {
                var constructedFontFamilies = [];
                _.each(fontFamilies, function (font) {
                    font.fontStyle = fontStyle;
                    font.fontWeight = fontWeight;
                    constructedFontFamilies.push(font);
                });

                attrs.fontFamilies = constructedFontFamilies;
            }

            widget.set(attrs, { silent: true });
        },


        /**
         * Creates a new `FontDescriptorCollection` from the specified scene or array of scenes - based on
         * any contained `TextWidgetModel`'s.
         *
         * @param  {Scene|Scene[]} scene The scene or array of scenes to load.
         * @return {FontDescriptorCollection}       The `FontDescriptorCollection`.
         */
        createFontDescriptorCollection: function createFontDescriptorCollection(scene) {
            var _this = this;

            // Normalize to array
            var scenes = _.isArray(scene) ? scene : [scene];
            // Compile a list of TextWidgetModels and classic buttons (label might have a custom font)
            var widgets = _.flatten(scenes.map(function (scene) {
                var textWidgets = scene.widgetsByClass(TextWidgetModel);
                var enhancedTextWidgets = scene.widgetsByClass(EnhancedTextWidgetModel);
                var buttonWidgets = scene.widgetsByClass(ButtonWidgetModel).filter(function (buttonWidgetModel) {
                    return buttonWidgetModel.get("buttonType") !== ButtonType.ICON_ONLY;
                });

                return textWidgets.concat(buttonWidgets).concat(enhancedTextWidgets);
            }));

            // Construct the font descriptor collection
            return _.reduce(widgets, function (collectionMemo, widget) {
                _this.fontCompatibilityCheck(widget);
                _.each(widget.get("fontFamilies"), function (font) {
                    var fontFamily = font.fontFamily;
                    var fontProviderValue = font.fontProvider;
                    var fontProvider = FontProvider.fromValue(fontProviderValue);
                    var fontVariant = WebFontVariants.findVariant(fontProvider, font.fontStyle, font.fontWeight);

                    if (fontFamily && fontVariant) {
                        collectionMemo.addDescriptor(fontFamily, fontVariant.value, WebFontsUtil.fontProvider(fontFamily, fontProvider), fontDescriptorData(fontProviderValue, font.fontMetadata));
                    } else {
                        logger.warn("Invalid font configuration for font family '" + fontFamily + "'", {
                            provider: fontProvider,
                            font: font
                        });
                    }
                });

                return collectionMemo;
            }, new FontDescriptorCollection());
        },
        isStandardWebFont: function isStandardWebFont(fontFamily) {
            var normalizedFontFamily = fontFamily && fontFamily.toLowerCase();

            var found = normalizedFontFamily && _.find(StandardWebFontList.items, function (item) {
                if (item.family.toLowerCase() === normalizedFontFamily) {
                    return true;
                }
                // It might be an alias
                var aliases = _.invoke(item.aliases, "toLowerCase");
                return _.contains(aliases, normalizedFontFamily);
            });

            return found !== undefined;
        },
        getFontAttributes: function getFontAttributes(textWidgetModel) {
            var attributes = {
                "data-font-family": textWidgetModel.attributes.fontFamily,
                "data-font-provider": textWidgetModel.attributes.fontProvider
            };

            var _textWidgetModel$attr = textWidgetModel.attributes.fontMetadata,
                kitID = _textWidgetModel$attr.kitID,
                projectId = _textWidgetModel$attr.projectId,
                path = _textWidgetModel$attr.path,
                customFontId = _textWidgetModel$attr.customFontId,
                format = _textWidgetModel$attr.format;


            if (kitID) {
                attributes["data-kitid"] = kitID;
            }

            if (projectId) {
                attributes["data-projectid"] = projectId;
            }

            if (path && customFontId && format) {
                attributes["data-path"] = path;
                attributes["data-customfontid"] = customFontId;
                attributes["data-format"] = format;
            }

            return attributes;
        },
        getCssFontFamily: function getCssFontFamily(textWidgetModel) {
            var fontFamily = textWidgetModel.get("fontFamily");
            if (fontFamily) {
                var provider = WebFontsUtil.fontProvider(fontFamily, FontProvider.fromValue(textWidgetModel.get("fontProvider")));

                switch (provider) {
                    case FontProvider.STANDARD:
                        return StandardWebFontList.cssFamilyNames(fontFamily);

                    case FontProvider.GOOGLE:
                    case FontProvider.CUSTOM:
                        return fontFamily;

                    case FontProvider.TYPEKIT:
                    case FontProvider.FONTS_DOT_COM:
                        return textWidgetModel.get("fontMetadata").cssFamilyNames.toString();
                    default:
                        // all providers covered above, cannot recognize this one.
                        // TODO Candidate for refactoring during MOS-2934.
                        Preconditions.warn("DefaultSwitchWarn - Provider '" + provider + "' not recognized.");
                        break;
                }
            }
        },


        /**
         * Returns the needed CSS object for rendering the specified `TextWidgetModel`.
         *
         * @param  {TextWidgetModel} textWidgetModel    The `TextWidgetModel`.
         * @return {Object}                             An object representing the font related CSS, e.g.:
         *                                              <pre>
         *                                              {
         *                                                  fontWeight: "700",
         *                                                  fontStyle: "normal",
         *                                                  fontFamily: "Arial"
         *                                              }
         *                                              </pre>
         */
        fontCssFor: function fontCssFor(textWidgetModel) {
            var fontFamily = textWidgetModel.get("fontFamily");
            var provider = WebFontsUtil.fontProvider(fontFamily, FontProvider.fromValue(textWidgetModel.get("fontProvider")));

            // Fall back on a default variant to be compatible with manually entered (non existing) legacy
            // font styles (pre custom fonts)
            var variant = WebFontVariants.fromValue(textWidgetModel.get("fontStyle"), provider) || WebFontVariants.defaultVariant(provider);

            return {
                fontWeight: variant.weight,
                fontStyle: variant.style,
                fontFamily: this.getCssFontFamily(textWidgetModel)
            };
        },
        toCss: function toCss(fontFamily, fontVariant, fontProviderValue) {
            var provider = WebFontsUtil.fontProvider(fontFamily, FontProvider.fromValue(fontProviderValue));

            // Fall back on a default variant to be compatible with manually entered (non existing) legacy
            // font styles (pre custom fonts)
            var variant = WebFontVariants.fromValue(fontVariant, provider) || WebFontVariants.defaultVariant(provider);
            var css = {
                fontWeight: variant.weight,
                fontStyle: variant.style,
                fontFamily: fontFamily
            };

            switch (provider) {
                case FontProvider.STANDARD:
                    css.cssFamilyNames = StandardWebFontList.cssFamilyNames(fontFamily);
                    break;

                case FontProvider.CUSTOM:
                case FontProvider.GOOGLE:
                case FontProvider.FONTS_DOT_COM:
                    css.cssFamilyNames = fontFamily;
                    break;
                default:
                    break;
            }

            return css;
        },


        /**
         * Returns the Google font family string from the specified `fontDescriptorCollection`, formatted
         * to fit the Google Font API.
         *
         * @param  {FontDescriptorCollection|FontDescriptor[]} fontDescriptorCollection the
         * `FontDescriptorCollection` or array of `FontDescriptor`'s.
         *
         * @retun {String[]} E.g. `["Tangerine:bold,bolditalic", "Inconsolata:italic"`.
         *
         * @see https://github.com/typekit/webfontloader#google
         * @see https://developers.google.com/fonts/docs/getting_started#Syntax
         */
        googleFontFamily: function googleFontFamily(fontDescriptorCollection) {
            if (_.isArray(fontDescriptorCollection)) {
                fontDescriptorCollection = new FontDescriptorCollection(fontDescriptorCollection);
            }

            return _.uniq(fontDescriptorCollection.fromProvider(FontProvider.GOOGLE).map(function (fontDescriptor) {
                return (
                    // Ensure correct casing for Google fonts (there might still be manual leftovers
                    // in the db - post "custom fonts")
                    GoogleFonts.fontFamily(fontDescriptor.get("family")) + ":" + fontDescriptor.get("variations").toString()
                );
            }));
        },


        /**
         * Returns an array of Typekit kit id's contained in the given `fontDescriptorCollection`.
         *
         * @param  {FontDescriptorCollection} fontDescriptorCollection [description]
         * @return {String[]}                 Array of Typekit kit id's.
         */
        getTypekitKitIds: function getTypekitKitIds(fontDescriptorCollection) {
            return _.uniq(fontDescriptorCollection.fromProvider(FontProvider.TYPEKIT).map(function (fontDescriptor) {
                return fontDescriptor.get("data").kitID;
            }));
        },
        getFontsDotComFamilies: function getFontsDotComFamilies(fontDescriptorCollection) {
            if (_.isArray(fontDescriptorCollection)) {
                fontDescriptorCollection = new FontDescriptorCollection(fontDescriptorCollection);
            }

            return _.uniq(fontDescriptorCollection.fromProvider(FontProvider.FONTS_DOT_COM).map(function (fontDescriptor) {
                return fontDescriptor.get("family") + ":" + fontDescriptor.get("variations").toString();
            }));
        },
        getFontsDotComProjectIds: function getFontsDotComProjectIds(fontDescriptorCollection) {
            return _.uniq(_.map(fontDescriptorCollection.fromProvider(FontProvider.FONTS_DOT_COM), function (fontDescriptor) {
                return fontDescriptor.get("data").projectId;
            }));
        },


        /**
         * Add quotes around the font family names when it's necessary.
         *
         * Example: "Trebuchet MS, Bauhaus 93, sans-serif" => "Trebuchet MS,'Bauhaus 93',sans-serif".
         *
         * Details: It's a know bug that CKEditor 4 does not quote CSS font family names. This is
         * an issue if the name contains non-identifiers, most often encountered as words that
         * start with a digit, e.g. Avenir 45 Book. Historically we have worked around the issue by
         * filtering out any fonts that contain digits in their name, but this is not compatible
         * with fonts from Fonts.com, since they often contain their weight as part of the name.
         * Note that the ticket discrition on ckeditor.com is wrong about the issue being related
         * all kind of digits in the name of a font family.
         *
         * Does not require escaping: Museo W01_500
         * Requires escaping: Shree Devanagari 714
         *
         * http://dev.ckeditor.com/ticket/12563
         * https://mathiasbynens.be/notes/unquoted-font-family
         */
        quoteSpecialFontNames: function quoteSpecialFontNames(fontNames) {
            return fontNames && fontNames.split(",").map(this._trim.bind(this)).map(this._quoteFontNameIfNecessary.bind(this)).join(",");
        },


        /**
         * Given a `FontDescriptor`, returns a list of possible variants.
         *
         * @param  {FontDescriptor} fontDescriptor [description]
         * @return {Object[]}                [description]
         *
         * @see  WebFontVariants
         */
        variantsFromFontDescriptor: function variantsFromFontDescriptor(fontDescriptor) {
            return WebFontVariants.fromValues(fontDescriptor.get("variations"), fontDescriptor.get("provider"));
        },


        /**
         * From the specified (custom) `FontDescriptor`'s, injects the CSS `font-face` definitions
         * into the `<head>` of the current `document`.
         *
         * `path`, `customFontId` and `format` are required fields of the `FontDescriptor`'s `data` property, i.e. only
         * exposed by Custom Fonts.
         *
         * @param {FontDescriptor[]} fontDescriptors The (custom) `FontDescriptor`'s.
         */
        injectFontFaceCSS: function injectFontFaceCSS(fontDescriptors) {
            var toCSSString = function toCSSString(descriptor) {
                var _descriptor$get = descriptor.get("data"),
                    path = _descriptor$get.path,
                    format = _descriptor$get.format;

                var url = UrlUtil.getAbsoluteViewerApiUrl(path);

                return "\n                    @font-face {\n                        font-family: '" + descriptor.get("family") + "';\n                        src: url(" + url + ") format('" + format + "');\n                    }\n                ";
            };

            var cssString = _.reduce(fontDescriptors, function (memo, descriptor) {
                return memo + toCSSString(descriptor);
            }, "");

            $("<style type=\"text/css\">" + cssString + "</style>").appendTo("head");
        },


        // StringUtils.trim does not work as expected when used in the map above.
        _trim: function _trim(fontName) {
            return fontName.trim();
        },
        _quoteFontNameIfNecessary: function _quoteFontNameIfNecessary(fontName) {
            if (this._containsNonIdentifier(fontName)) {
                return this._quoteFontName(fontName);
            }

            return fontName;
        },
        _containsNonIdentifier: function _containsNonIdentifier(fontName) {
            var words = fontName.split(/\s+/);
            var allWordsAreIdentifiers = words.every(this._isIdentifier);
            return !allWordsAreIdentifiers;
        },
        _isIdentifier: function _isIdentifier(fontName) {
            // Identifiers may not start with 1) a digit, 2) dash followed by a digit or 3) with
            // two dashes.
            return !/^(-?\d|--)/.test(fontName);
        },
        _quoteFontName: function _quoteFontName(fontName) {
            return "'" + fontName + "'";
        }
    };

    return WebFontsUtil;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(10),__webpack_require__(0),__webpack_require__(28)):"function"==typeof define&&define.amd?define(["backbone.marionette","react","react-dom"],t):(e.backbone=e.backbone||{},e.backbone["react-bridge"]=t(e.Marionette,e.React,e.ReactDOM))}(this,function(e,t,n){"use strict";e=e&&e.hasOwnProperty("default")?e.default:e,t=t&&t.hasOwnProperty("default")?t.default:t,n=n&&n.hasOwnProperty("default")?n.default:n;var o=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},i=function(){function e(e,t){for(var n=0;t.length>n;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=Object.assign||function(e){for(var t=1;arguments.length>t;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},a=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)},s=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!=typeof t&&"function"!=typeof t?e:t};function c(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.model,n=e.collection,o=e.state,i=void 0===o?{}:o;return t&&Object.assign(i,t.toJSON()),n&&Object.assign(i,{items:n.toJSON()}),i}function u(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.getProps,n=e.props;return r({},(void 0===t?c:t)(e),n)}function l(){return this.$el.off(),this.stopListening(),this}return{viewFromComponent:function(r){var c=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return new(e.View.extend({initialize:function(){this.listenTo(this,"show render",this._onShowRender),this.listenTo(this,"close destroy",this._onCloseDestroy)},template:function(){},_onShowRender:function(){var e=this;if(this._reactInternalInstance)return!1;var l=function(e){function n(){o(this,n);var e=s(this,(n.__proto__||Object.getPrototypeOf(n)).call(this));return e.state=u(c),e.updateComponentState=e.updateComponentState.bind(e),e}return a(n,t.Component),i(n,[{key:"componentDidMount",value:function(){var e=c.collections,t=c.observe,n=void 0===t?{}:t;this.initListener(c.model,n.model||"change"),this.initListener(e,n.collection||"add remove reset")}},{key:"componentWillUnmount",value:function(){this.destroyListener(c.model),this.destroyListener(c.collection)}},{key:"initListener",value:function(e,t){e&&(t instanceof Array&&(t=t.join(" ")),e.on(t,this.updateComponentState))}},{key:"updateComponentState",value:function(){var e=u(c);this.setState(e)}},{key:"destroyListener",value:function(e){e&&e.off(null,this.updateComponentState)}},{key:"render",value:function(){return t.isValidElement(r)?t.cloneElement(r,this.state):t.createElement(r,this.state)}}]),n}();n.render(t.createElement(l,{ref:function(t){return e._reactInternalInstance=t}}),this.el)},_onCloseDestroy:function(){this.stopListening(this,"show render close destroy"),n.unmountComponentAtNode(this.el),delete this._reactInternalInstance}}))(c)},componentFromView:function(c,u){return function(f){function p(){return o(this,p),s(this,(p.__proto__||Object.getPrototypeOf(p)).apply(this,arguments))}return a(p,t.Component),i(p,[{key:"componentDidMount",value:function(){var t=this._reactInternalFiber?this._reactInternalFiber.child.stateNode:n.findDOMNode(this._reactInternalInstance._instance);c instanceof e.View?(c.setElement(t),this._marionetteView=c,Object.assign(this._marionetteView.options,u)):this._marionetteView=new c(r({el:t},u)),this._marionetteView.remove=l,this.mapEventsToActions(u),this._marionetteView.render()}},{key:"shouldComponentUpdate",value:function(){return!1}},{key:"componentWillUnmount",value:function(){var e=this;Object.keys(u.eventsToActions).forEach(function(t){e._marionetteView.stopListening(e._marionetteView,t)}),this._marionetteView.destroy&&this._marionetteView.destroy(),this._marionetteView.close&&this._marionetteView.close()}},{key:"createTemplate",value:function(n,o){var i=n instanceof e.View?n.tagName:n.prototype.tagName,r=n instanceof e.View?n.className:n.prototype.className;return o.tagName&&(i=o.tagName),o.className&&(r=o.className),t.createElement(i,{className:r},null)}},{key:"delegate",value:function(e){var t;if(this._marionetteView[e]){for(var n=arguments.length,o=Array(n>1?n-1:0),i=1;n>i;i++)o[i-1]=arguments[i];return(t=this._marionetteView)[e].apply(t,o)}}},{key:"mapEventsToActions",value:function(e){var t=this,n=e.eventsToActions,o=e.dispatch;if(!(!n instanceof Object)&&Object.keys(n).length){if(o&&!(!o instanceof Function))return Object.keys(n).forEach(function(e){var o=n[e];t._marionetteView.listenTo(t._marionetteView,e,function(){for(var e=arguments.length,n=Array(e),i=0;e>i;i++)n[i]=arguments[i];var r="function"==typeof o?o.apply(void 0,n):o;(function(){var e;(e=this.options).dispatch.apply(e,arguments)}).apply(t._marionetteView,[r].concat(n))})}),this._marionetteView;console.error("The `dispatch` function is not defined.")}}},{key:"render",value:function(){return this.createTemplate(c,u)}}]),p}()}}});


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ChunkingCollectionQuery = __webpack_require__(868);
    var Class = __webpack_require__(26);
    var FilterQuery = __webpack_require__(1739);
    var IdValidator = __webpack_require__(869);
    var _ = __webpack_require__(1);

    var FilterExpression = Class.extend("FilterExpression", {

        name: null,

        constructor: function constructor() {
            this._expression = {};
        },
        field: function field(_field) {
            this._expression.field = _field;

            return this;
        },
        value: function value(_value) {
            this._expression.value = _value;

            return this;
        },
        toJSON: function toJSON() {
            var json = {};

            json[this.name] = this._expression;

            return json;
        }
    });

    var OperationExpression = FilterExpression.extend("OperationExpression", {

        name: "Operation",

        op: function op(_op) {
            this._expression.op = _op;

            return this;
        }
    });

    var SortQuery = ChunkingCollectionQuery.extend("SortQuery", {
        constructor: function constructor() {
            this.__super();

            this._query = [];
        },
        field: function field(value, direction) {
            this._query.push({
                field: value,
                direction: direction === undefined ? "Descending" : direction
            });

            return this;
        },
        querify: function querify() {
            return {
                sort: JSON.stringify(this._query)
            };
        }
    });

    /**
     * The "root" query returned by <tt>ContentQuery.query</tt> - combines a filter and sort query.
     *
     * @class RootQuery
     */
    var RootQuery = ChunkingCollectionQuery.extend("RootQuery", {

        /**
         * Constructor.
         *
         * @param {FilterQuery} filter The required <tt>FilterQuery</tt>.
         * @param {SortQuery} sort Optional <tt>SortQuery</tt>.
         */
        constructor: function constructor(filter, sort) {
            this.__super();

            this._filter = filter;
            this._sort = sort;
        },
        querify: function querify() {
            var json = this._filter.querify();

            if (this._sort) {
                _.extend(json, this._sort.querify());
            }

            return json;
        }
    });

    var tagNameExpression = function tagNameExpression(name) {
        return new OperationExpression().value(name).field("tags.name").op("~=");
    };

    var nameExpression = function nameExpression(name) {
        return new OperationExpression().value(name).field("name").op("~=");
    };

    var ContentQuery = {
        filter: function filter() {
            return new FilterQuery();
        },
        sort: function sort() {
            return new SortQuery();
        },


        /**
         * Constructs a <tt>RootQuery</tt> from the specified filter and optional sorting query.
         *
         * @param {FilterQuery} filter The required <tt>FilterQuery</tt>.
         * @param {SortQuery} sort Optional <tt>SortQuery</tt>.
         *
         * @returns A <tt>RootQuery</tt> instance.
         */
        query: function query(filter, sort) {
            return new RootQuery(filter, sort);
        },


        /**
         * Convenience for constructing a search query. By default, the passed value will be matched
         * against the <tt>name</tt> field.<p>
         *
         * If a valid MongoDB id is passed, we explicitly search for <tt>id</tt>.
         *
         * @param  {String|String[]} value The search phrase, array of phrases or content id (as a valid mongoDB id).
         * @param  {SortQuery} sortQuery
         * @param  {includeTagName} Boolean If true include tag name in the query
         *
         * @return {ChunkingCollectionQuery} The search query.
         */
        search: function search(value, sortQuery) {
            var includeTagName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var sorting = sortQuery || ContentQuery.sort().field("editedAt");

            if (Array.isArray(value)) {
                var query = new FilterQuery(FilterQuery.TYPE_AND);

                value.forEach(function (phrase) {
                    var name = nameExpression(phrase);
                    var expressions = [name];

                    if (includeTagName) {
                        var tag = tagNameExpression(phrase);
                        expressions.push(tag);

                        if (value.length > 1) {
                            var _phrase = value.join(" ");
                            expressions.push(tagNameExpression(_phrase));
                        }

                        query.or.apply(query, expressions);
                    } else {
                        // If search tags aren't enabled there is no use for nested operators since we only search for one attribute (name).
                        // Also, since some sources (e.g. Adobe Scene7) don't have tag names nor allow querying with nested operators
                        // the searchTags boolean is used to determine whether to only use the root query type as well.
                        query.useRoot.apply(query, expressions);
                    }
                });

                return ContentQuery.query(query, sorting);
            }

            var expression = new OperationExpression().value(value);

            // Search specifically for id if one is specified.
            if (IdValidator.isValid(value)) {
                expression.field("id").op("=");
            } else {
                expression.field("name").op("~=");
            }

            return ContentQuery.query(ContentQuery.filter().and(expression), sorting);
        }
    };

    ContentQuery.ALL = ContentQuery.filter();

    return ContentQuery;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(565);




function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  return path.split('.').reduce(function (acc, item) {
    return acc && acc[item] ? acc[item] : null;
  }, obj);
}

function style(options) {
  var prop = options.prop,
      _options$cssProperty = options.cssProperty,
      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
      themeKey = options.themeKey,
      transform = options.transform;

  var fn = function fn(props) {
    if (props[prop] == null) {
      return null;
    }

    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};

    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value;

      if (typeof themeMapping === 'function') {
        value = themeMapping(propValueFinal);
      } else if (Array.isArray(themeMapping)) {
        value = themeMapping[propValueFinal] || propValueFinal;
      } else {
        value = getPath(themeMapping, propValueFinal) || propValueFinal;

        if (transform) {
          value = transform(value);
        }
      }

      if (cssProperty === false) {
        return value;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, value);
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  };

  fn.propTypes =  false ? _defineProperty({}, prop, responsivePropType) : {};
  fn.filterProps = [prop];
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (style);

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export easing */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return duration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


/* harmony default export */ __webpack_exports__["a"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["duration", "easing", "delay"]);

    if (false) {
      var isString = function isString(value) {
        return typeof value === 'string';
      };

      var isNumber = function isNumber(value) {
        return !isNaN(parseFloat(value));
      };

      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: Argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: Argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: Argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: Argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: Unrecognized argument(s) [".concat(Object.keys(other).join(','), "]."));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Draft
 * @format
 * 
 */



var AtomicBlockUtils = __webpack_require__(2107);
var BlockMapBuilder = __webpack_require__(324);
var CharacterMetadata = __webpack_require__(93);
var CompositeDraftDecorator = __webpack_require__(2123);
var ContentBlock = __webpack_require__(217);
var ContentState = __webpack_require__(606);
var DefaultDraftBlockRenderMap = __webpack_require__(609);
var DefaultDraftInlineStyle = __webpack_require__(1037);
var DraftEditor = __webpack_require__(2124);
var DraftEditorBlock = __webpack_require__(1039);
var DraftEntity = __webpack_require__(429);
var DraftModifier = __webpack_require__(87);
var DraftEntityInstance = __webpack_require__(1035);
var EditorState = __webpack_require__(52);
var KeyBindingUtil = __webpack_require__(616);
var RichTextEditorUtil = __webpack_require__(1053);
var SelectionState = __webpack_require__(271);

var convertFromDraftStateToRaw = __webpack_require__(2185);
var convertFromHTMLToContentBlocks = __webpack_require__(1051);
var convertFromRawToDraftState = __webpack_require__(2188);
var generateRandomKey = __webpack_require__(164);
var getDefaultKeyBinding = __webpack_require__(1054);
var getVisibleSelectionRect = __webpack_require__(2193);

var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState: EditorState,

  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,

  BlockMapBuilder: BlockMapBuilder,
  CharacterMetadata: CharacterMetadata,
  ContentBlock: ContentBlock,
  ContentState: ContentState,
  SelectionState: SelectionState,

  AtomicBlockUtils: AtomicBlockUtils,
  KeyBindingUtil: KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,

  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,

  convertFromHTML: convertFromHTMLToContentBlocks,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding: getDefaultKeyBinding,
  getVisibleSelectionRect: getVisibleSelectionRect
};

module.exports = DraftPublic;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var UserAgentData = __webpack_require__(2130);
var VersionRange = __webpack_require__(2132);

var mapObject = __webpack_require__(2133);
var memoizeStringOnly = __webpack_require__(2134);

/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */
function compare(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  }

  // check for non-matching names
  if (!query.startsWith(name)) {
    return false;
  }

  // full comparison with version
  var range = query.slice(name.length);
  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version);
  }

  return false;
}

/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */
function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}

/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */
var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },


  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },


  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },


  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },


  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },


  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};

module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 146 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1062);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.red = exports.getContrastingColor = exports.isValidHex = exports.toState = exports.simpleCheckForValidColor = undefined;

var _each = __webpack_require__(2435);

var _each2 = _interopRequireDefault(_each);

var _tinycolor = __webpack_require__(2443);

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var simpleCheckForValidColor = exports.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  (0, _each2.default)(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = exports.toState = function toState(data, oldHue) {
  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

var isValidHex = exports.isValidHex = function isValidHex(hex) {
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
};

var getContrastingColor = exports.getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

var red = exports.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

exports.default = exports;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HoursPerDay = 24;
var MinutesPerHour = 60;
var SecondsPerMinute = 60;
var msPerSecond = 1e3;
var msPerMinute = msPerSecond * SecondsPerMinute;
var msPerHour = msPerMinute * MinutesPerHour;
var msPerDay = 86400000;

module.exports = {
	HoursPerDay: HoursPerDay,
	MinutesPerHour: MinutesPerHour,
	SecondsPerMinute: SecondsPerMinute,
	msPerSecond: msPerSecond,
	msPerMinute: msPerMinute,
	msPerHour: msPerHour,
	msPerDay: msPerDay
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 1.20.3
 * DATE: 2017-10-02
 * UPDATES AND DOCS AT: http://greensock.com
 * 
 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("TweenMax",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},e=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c]):e[c%e.length];delete a.cycle},f=function(a,b,d){c.call(this,a,b,d),this._cycle=0,this._yoyo=this.vars.yoyo===!0||!!this.vars.yoyoEase,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._repeat&&this._uncache(!0),this.render=f.prototype.render},g=1e-10,h=c._internals,i=h.isSelector,j=h.isArray,k=f.prototype=c.to({},.1,{}),l=[];f.version="1.20.3",k.constructor=f,k.kill()._gc=!1,f.killTweensOf=f.killDelayedCallsTo=c.killTweensOf,f.getTweensOf=c.getTweensOf,f.lagSmoothing=c.lagSmoothing,f.ticker=c.ticker,f.render=c.render,k.invalidate=function(){return this._yoyo=this.vars.yoyo===!0||!!this.vars.yoyoEase,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._yoyoEase=null,this._uncache(!0),c.prototype.invalidate.call(this)},k.updateTo=function(a,b){var d,e=this.ratio,f=this.vars.immediateRender||a.immediateRender;b&&this._startTime<this._timeline._time&&(this._startTime=this._timeline._time,this._uncache(!1),this._gc?this._enabled(!0,!1):this._timeline.insert(this,this._startTime-this._delay));for(d in a)this.vars[d]=a[d];if(this._initted||f)if(b)this._initted=!1,f&&this.render(0,!0,!0);else if(this._gc&&this._enabled(!0,!1),this._notifyPluginsOfEnabled&&this._firstPT&&c._onPluginEvent("_onDisable",this),this._time/this._duration>.998){var g=this._totalTime;this.render(0,!0,!1),this._initted=!1,this.render(g,!0,!1)}else if(this._initted=!1,this._init(),this._time>0||f)for(var h,i=1/(1-e),j=this._firstPT;j;)h=j.s+j.c,j.c*=i,j.s=h-j.c,j=j._next;return this},k.render=function(a,b,d){this._initted||0===this._duration&&this.vars.repeat&&this.invalidate();var e,f,i,j,k,l,m,n,o,p=this._dirty?this.totalDuration():this._totalDuration,q=this._time,r=this._totalTime,s=this._cycle,t=this._duration,u=this._rawPrevTime;if(a>=p-1e-7&&a>=0?(this._totalTime=p,this._cycle=this._repeat,this._yoyo&&0!==(1&this._cycle)?(this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0):(this._time=t,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1),this._reversed||(e=!0,f="onComplete",d=d||this._timeline.autoRemoveChildren),0===t&&(this._initted||!this.vars.lazy||d)&&(this._startTime===this._timeline._duration&&(a=0),(0>u||0>=a&&a>=-1e-7||u===g&&"isPause"!==this.data)&&u!==a&&(d=!0,u>g&&(f="onReverseComplete")),this._rawPrevTime=n=!b||a||u===a?a:g)):1e-7>a?(this._totalTime=this._time=this._cycle=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==r||0===t&&u>0)&&(f="onReverseComplete",e=this._reversed),0>a&&(this._active=!1,0===t&&(this._initted||!this.vars.lazy||d)&&(u>=0&&(d=!0),this._rawPrevTime=n=!b||a||u===a?a:g)),this._initted||(d=!0)):(this._totalTime=this._time=a,0!==this._repeat&&(j=t+this._repeatDelay,this._cycle=this._totalTime/j>>0,0!==this._cycle&&this._cycle===this._totalTime/j&&a>=r&&this._cycle--,this._time=this._totalTime-this._cycle*j,this._yoyo&&0!==(1&this._cycle)&&(this._time=t-this._time,o=this._yoyoEase||this.vars.yoyoEase,o&&(this._yoyoEase||(o!==!0||this._initted?this._yoyoEase=o=o===!0?this._ease:o instanceof Ease?o:Ease.map[o]:(o=this.vars.ease,this._yoyoEase=o=o?o instanceof Ease?o:"function"==typeof o?new Ease(o,this.vars.easeParams):Ease.map[o]||c.defaultEase:c.defaultEase)),this.ratio=o?1-o.getRatio((t-this._time)/t):0)),this._time>t?this._time=t:this._time<0&&(this._time=0)),this._easeType&&!o?(k=this._time/t,l=this._easeType,m=this._easePower,(1===l||3===l&&k>=.5)&&(k=1-k),3===l&&(k*=2),1===m?k*=k:2===m?k*=k*k:3===m?k*=k*k*k:4===m&&(k*=k*k*k*k),1===l?this.ratio=1-k:2===l?this.ratio=k:this._time/t<.5?this.ratio=k/2:this.ratio=1-k/2):o||(this.ratio=this._ease.getRatio(this._time/t))),q===this._time&&!d&&s===this._cycle)return void(r!==this._totalTime&&this._onUpdate&&(b||this._callback("onUpdate")));if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!d&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=q,this._totalTime=r,this._rawPrevTime=u,this._cycle=s,h.lazyTweens.push(this),void(this._lazy=[a,b]);!this._time||e||o?e&&this._ease._calcEnd&&!o&&(this.ratio=this._ease.getRatio(0===this._time?0:1)):this.ratio=this._ease.getRatio(this._time/t)}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==q&&a>=0&&(this._active=!0),0===r&&(2===this._initted&&a>0&&this._init(),this._startAt&&(a>=0?this._startAt.render(a,!0,d):f||(f="_dummyGS")),this.vars.onStart&&(0!==this._totalTime||0===t)&&(b||this._callback("onStart"))),i=this._firstPT;i;)i.f?i.t[i.p](i.c*this.ratio+i.s):i.t[i.p]=i.c*this.ratio+i.s,i=i._next;this._onUpdate&&(0>a&&this._startAt&&this._startTime&&this._startAt.render(a,!0,d),b||(this._totalTime!==r||f)&&this._callback("onUpdate")),this._cycle!==s&&(b||this._gc||this.vars.onRepeat&&this._callback("onRepeat")),f&&(!this._gc||d)&&(0>a&&this._startAt&&!this._onUpdate&&this._startTime&&this._startAt.render(a,!0,d),e&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[f]&&this._callback(f),0===t&&this._rawPrevTime===g&&n!==g&&(this._rawPrevTime=0))},f.to=function(a,b,c){return new f(a,b,c)},f.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new f(a,b,c)},f.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new f(a,b,d)},f.staggerTo=f.allTo=function(a,b,g,h,k,m,n){h=h||0;var o,p,q,r,s=0,t=[],u=function(){g.onComplete&&g.onComplete.apply(g.onCompleteScope||this,arguments),k.apply(n||g.callbackScope||this,m||l)},v=g.cycle,w=g.startAt&&g.startAt.cycle;for(j(a)||("string"==typeof a&&(a=c.selector(a)||a),i(a)&&(a=d(a))),a=a||[],0>h&&(a=d(a),a.reverse(),h*=-1),o=a.length-1,q=0;o>=q;q++){p={};for(r in g)p[r]=g[r];if(v&&(e(p,a,q),null!=p.duration&&(b=p.duration,delete p.duration)),w){w=p.startAt={};for(r in g.startAt)w[r]=g.startAt[r];e(p.startAt,a,q)}p.delay=s+(p.delay||0),q===o&&k&&(p.onComplete=u),t[q]=new f(a[q],b,p),s+=h}return t},f.staggerFrom=f.allFrom=function(a,b,c,d,e,g,h){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,f.staggerTo(a,b,c,d,e,g,h)},f.staggerFromTo=f.allFromTo=function(a,b,c,d,e,g,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,f.staggerTo(a,b,d,e,g,h,i)},f.delayedCall=function(a,b,c,d,e){return new f(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,useFrames:e,overwrite:0})},f.set=function(a,b){return new f(a,0,b)},f.isTweening=function(a){return c.getTweensOf(a,!0).length>0};var m=function(a,b){for(var d=[],e=0,f=a._first;f;)f instanceof c?d[e++]=f:(b&&(d[e++]=f),d=d.concat(m(f,b)),e=d.length),f=f._next;return d},n=f.getAllTweens=function(b){return m(a._rootTimeline,b).concat(m(a._rootFramesTimeline,b))};f.killAll=function(a,c,d,e){null==c&&(c=!0),null==d&&(d=!0);var f,g,h,i=n(0!=e),j=i.length,k=c&&d&&e;for(h=0;j>h;h++)g=i[h],(k||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&(a?g.totalTime(g._reversed?0:g.totalDuration()):g._enabled(!1,!1))},f.killChildTweensOf=function(a,b){if(null!=a){var e,g,k,l,m,n=h.tweenLookup;if("string"==typeof a&&(a=c.selector(a)||a),i(a)&&(a=d(a)),j(a))for(l=a.length;--l>-1;)f.killChildTweensOf(a[l],b);else{e=[];for(k in n)for(g=n[k].target.parentNode;g;)g===a&&(e=e.concat(n[k].tweens)),g=g.parentNode;for(m=e.length,l=0;m>l;l++)b&&e[l].totalTime(e[l].totalDuration()),e[l]._enabled(!1,!1)}}};var o=function(a,c,d,e){c=c!==!1,d=d!==!1,e=e!==!1;for(var f,g,h=n(e),i=c&&d&&e,j=h.length;--j>-1;)g=h[j],(i||g instanceof b||(f=g.target===g.vars.onComplete)&&d||c&&!f)&&g.paused(a)};return f.pauseAll=function(a,b,c){o(!0,a,b,c)},f.resumeAll=function(a,b,c){o(!1,a,b,c)},f.globalTimeScale=function(b){var d=a._rootTimeline,e=c.ticker.time;return arguments.length?(b=b||g,d._startTime=e-(e-d._startTime)*d._timeScale/b,d=a._rootFramesTimeline,e=c.ticker.frame,d._startTime=e-(e-d._startTime)*d._timeScale/b,d._timeScale=a._rootTimeline._timeScale=b,b):d._timeScale},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()},k.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),a>this._duration&&(a=this._duration),this._yoyo&&0!==(1&this._cycle)?a=this._duration-a+this._cycle*(this._duration+this._repeatDelay):0!==this._repeat&&(a+=this._cycle*(this._duration+this._repeatDelay)),this.totalTime(a,b)):this._time},k.duration=function(b){return arguments.length?a.prototype.duration.call(this,b):this._duration},k.totalDuration=function(a){return arguments.length?-1===this._repeat?this:this.duration((a-this._repeat*this._repeatDelay)/(this._repeat+1)):(this._dirty&&(this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat,this._dirty=!1),this._totalDuration)},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},f},!0),_gsScope._gsDefine("TimelineLite",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){b.call(this,a),this._labels={},this.autoRemoveChildren=this.vars.autoRemoveChildren===!0,this.smoothChildTiming=this.vars.smoothChildTiming===!0,this._sortChildren=!0,this._onUpdate=this.vars.onUpdate;var c,d,e=this.vars;for(d in e)c=e[d],i(c)&&-1!==c.join("").indexOf("{self}")&&(e[d]=this._swapSelfInParams(c));i(e.tweens)&&this.add(e.tweens,0,e.align,e.stagger)},e=1e-10,f=c._internals,g=d._internals={},h=f.isSelector,i=f.isArray,j=f.lazyTweens,k=f.lazyRender,l=_gsScope._gsDefine.globals,m=function(a){var b,c={};for(b in a)c[b]=a[b];return c},n=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c]):e[c%e.length];delete a.cycle},o=g.pauseCallback=function(){},p=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},q=d.prototype=new b;return d.version="1.20.3",q.constructor=d,q.kill()._gc=q._forcingPlayhead=q._hasPause=!1,q.to=function(a,b,d,e){var f=d.repeat&&l.TweenMax||c;return b?this.add(new f(a,b,d),e):this.set(a,d,e)},q.from=function(a,b,d,e){return this.add((d.repeat&&l.TweenMax||c).from(a,b,d),e)},q.fromTo=function(a,b,d,e,f){var g=e.repeat&&l.TweenMax||c;return b?this.add(g.fromTo(a,b,d,e),f):this.set(a,e,f)},q.staggerTo=function(a,b,e,f,g,i,j,k){var l,o,q=new d({onComplete:i,onCompleteParams:j,callbackScope:k,smoothChildTiming:this.smoothChildTiming}),r=e.cycle;for("string"==typeof a&&(a=c.selector(a)||a),a=a||[],h(a)&&(a=p(a)),f=f||0,0>f&&(a=p(a),a.reverse(),f*=-1),o=0;o<a.length;o++)l=m(e),l.startAt&&(l.startAt=m(l.startAt),l.startAt.cycle&&n(l.startAt,a,o)),r&&(n(l,a,o),null!=l.duration&&(b=l.duration,delete l.duration)),q.to(a[o],b,l,o*f);return this.add(q,g)},q.staggerFrom=function(a,b,c,d,e,f,g,h){return c.immediateRender=0!=c.immediateRender,c.runBackwards=!0,this.staggerTo(a,b,c,d,e,f,g,h)},q.staggerFromTo=function(a,b,c,d,e,f,g,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,this.staggerTo(a,b,d,e,f,g,h,i)},q.call=function(a,b,d,e){return this.add(c.delayedCall(0,a,b,d),e)},q.set=function(a,b,d){return d=this._parseTimeOrLabel(d,0,!0),null==b.immediateRender&&(b.immediateRender=d===this._time&&!this._paused),this.add(new c(a,0,b),d)},d.exportRoot=function(a,b){a=a||{},null==a.smoothChildTiming&&(a.smoothChildTiming=!0);var e,f,g,h,i=new d(a),j=i._timeline;for(null==b&&(b=!0),j._remove(i,!0),i._startTime=0,i._rawPrevTime=i._time=i._totalTime=j._time,g=j._first;g;)h=g._next,b&&g instanceof c&&g.target===g.vars.onComplete||(f=g._startTime-g._delay,0>f&&(e=1),i.add(g,f)),g=h;return j.add(i,0),e&&i.totalDuration(),i},q.add=function(e,f,g,h){var j,k,l,m,n,o;if("number"!=typeof f&&(f=this._parseTimeOrLabel(f,0,!0,e)),!(e instanceof a)){if(e instanceof Array||e&&e.push&&i(e)){for(g=g||"normal",h=h||0,j=f,k=e.length,l=0;k>l;l++)i(m=e[l])&&(m=new d({tweens:m})),this.add(m,j),"string"!=typeof m&&"function"!=typeof m&&("sequence"===g?j=m._startTime+m.totalDuration()/m._timeScale:"start"===g&&(m._startTime-=m.delay())),j+=h;return this._uncache(!0)}if("string"==typeof e)return this.addLabel(e,f);if("function"!=typeof e)throw"Cannot add "+e+" into the timeline; it is not a tween, timeline, function, or string.";e=c.delayedCall(0,e)}if(b.prototype.add.call(this,e,f),e._time&&e.render((this.rawTime()-e._startTime)*e._timeScale,!1,!1),(this._gc||this._time===this._duration)&&!this._paused&&this._duration<this.duration())for(n=this,o=n.rawTime()>e._startTime;n._timeline;)o&&n._timeline.smoothChildTiming?n.totalTime(n._totalTime,!0):n._gc&&n._enabled(!0,!1),n=n._timeline;return this},q.remove=function(b){if(b instanceof a){this._remove(b,!1);var c=b._timeline=b.vars.useFrames?a._rootFramesTimeline:a._rootTimeline;return b._startTime=(b._paused?b._pauseTime:c._time)-(b._reversed?b.totalDuration()-b._totalTime:b._totalTime)/b._timeScale,this}if(b instanceof Array||b&&b.push&&i(b)){for(var d=b.length;--d>-1;)this.remove(b[d]);return this}return"string"==typeof b?this.removeLabel(b):this.kill(null,b)},q._remove=function(a,c){b.prototype._remove.call(this,a,c);var d=this._last;return d?this._time>this.duration()&&(this._time=this._duration,this._totalTime=this._totalDuration):this._time=this._totalTime=this._duration=this._totalDuration=0,this},q.append=function(a,b){return this.add(a,this._parseTimeOrLabel(null,b,!0,a))},q.insert=q.insertMultiple=function(a,b,c,d){return this.add(a,b||0,c,d)},q.appendMultiple=function(a,b,c,d){return this.add(a,this._parseTimeOrLabel(null,b,!0,a),c,d)},q.addLabel=function(a,b){return this._labels[a]=this._parseTimeOrLabel(b),this},q.addPause=function(a,b,d,e){var f=c.delayedCall(0,o,d,e||this);return f.vars.onComplete=f.vars.onReverseComplete=b,f.data="isPause",this._hasPause=!0,this.add(f,a)},q.removeLabel=function(a){return delete this._labels[a],this},q.getLabelTime=function(a){return null!=this._labels[a]?this._labels[a]:-1},q._parseTimeOrLabel=function(b,c,d,e){var f,g;if(e instanceof a&&e.timeline===this)this.remove(e);else if(e&&(e instanceof Array||e.push&&i(e)))for(g=e.length;--g>-1;)e[g]instanceof a&&e[g].timeline===this&&this.remove(e[g]);if(f="number"!=typeof b||c?this.duration()>99999999999?this.recent().endTime(!1):this._duration:0,"string"==typeof c)return this._parseTimeOrLabel(c,d&&"number"==typeof b&&null==this._labels[c]?b-f:0,d);if(c=c||0,"string"!=typeof b||!isNaN(b)&&null==this._labels[b])null==b&&(b=f);else{if(g=b.indexOf("="),-1===g)return null==this._labels[b]?d?this._labels[b]=f+c:c:this._labels[b]+c;c=parseInt(b.charAt(g-1)+"1",10)*Number(b.substr(g+1)),b=g>1?this._parseTimeOrLabel(b.substr(0,g-1),0,d):f}return Number(b)+c},q.seek=function(a,b){return this.totalTime("number"==typeof a?a:this._parseTimeOrLabel(a),b!==!1)},q.stop=function(){return this.paused(!0)},q.gotoAndPlay=function(a,b){return this.play(a,b)},q.gotoAndStop=function(a,b){return this.pause(a,b)},q.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,g,h,i,l,m,n=this._time,o=this._dirty?this.totalDuration():this._totalDuration,p=this._startTime,q=this._timeScale,r=this._paused;if(n!==this._time&&(a+=this._time-n),a>=o-1e-7&&a>=0)this._totalTime=this._time=o,this._reversed||this._hasPausedChild()||(f=!0,h="onComplete",i=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||this._rawPrevTime<0||this._rawPrevTime===e)&&this._rawPrevTime!==a&&this._first&&(i=!0,this._rawPrevTime>e&&(h="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,a=o+1e-4;else if(1e-7>a)if(this._totalTime=this._time=0,(0!==n||0===this._duration&&this._rawPrevTime!==e&&(this._rawPrevTime>0||0>a&&this._rawPrevTime>=0))&&(h="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(i=f=!0,h="onReverseComplete"):this._rawPrevTime>=0&&this._first&&(i=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(i=!0)}else{if(this._hasPause&&!this._forcingPlayhead&&!b){if(a>=n)for(d=this._first;d&&d._startTime<=a&&!l;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(l=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!l;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(l=d),d=d._prev;l&&(this._time=a=l._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}this._totalTime=this._time=this._rawPrevTime=a}if(this._time!==n&&this._first||c||i||l){if(this._initted||(this._initted=!0),this._active||!this._paused&&this._time!==n&&a>0&&(this._active=!0),0===n&&this.vars.onStart&&(0===this._time&&this._duration||b||this._callback("onStart")),m=this._time,m>=n)for(d=this._first;d&&(g=d._next,m===this._time&&(!this._paused||r));)(d._active||d._startTime<=m&&!d._paused&&!d._gc)&&(l===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=g;else for(d=this._last;d&&(g=d._prev,m===this._time&&(!this._paused||r));){if(d._active||d._startTime<=n&&!d._paused&&!d._gc){if(l===d){for(l=d._prev;l&&l.endTime()>this._time;)l.render(l._reversed?l.totalDuration()-(a-l._startTime)*l._timeScale:(a-l._startTime)*l._timeScale,b,c),l=l._prev;l=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=g}this._onUpdate&&(b||(j.length&&k(),this._callback("onUpdate"))),h&&(this._gc||(p===this._startTime||q!==this._timeScale)&&(0===this._time||o>=this.totalDuration())&&(f&&(j.length&&k(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[h]&&this._callback(h)))}},q._hasPausedChild=function(){for(var a=this._first;a;){if(a._paused||a instanceof d&&a._hasPausedChild())return!0;a=a._next}return!1},q.getChildren=function(a,b,d,e){e=e||-9999999999;for(var f=[],g=this._first,h=0;g;)g._startTime<e||(g instanceof c?b!==!1&&(f[h++]=g):(d!==!1&&(f[h++]=g),a!==!1&&(f=f.concat(g.getChildren(!0,b,d)),h=f.length))),g=g._next;return f},q.getTweensOf=function(a,b){var d,e,f=this._gc,g=[],h=0;for(f&&this._enabled(!0,!0),d=c.getTweensOf(a),e=d.length;--e>-1;)(d[e].timeline===this||b&&this._contains(d[e]))&&(g[h++]=d[e]);return f&&this._enabled(!1,!0),g},q.recent=function(){return this._recent},q._contains=function(a){for(var b=a.timeline;b;){if(b===this)return!0;b=b.timeline}return!1},q.shiftChildren=function(a,b,c){c=c||0;for(var d,e=this._first,f=this._labels;e;)e._startTime>=c&&(e._startTime+=a),e=e._next;if(b)for(d in f)f[d]>=c&&(f[d]+=a);return this._uncache(!0)},q._kill=function(a,b){if(!a&&!b)return this._enabled(!1,!1);for(var c=b?this.getTweensOf(b):this.getChildren(!0,!0,!1),d=c.length,e=!1;--d>-1;)c[d]._kill(a,b)&&(e=!0);return e},q.clear=function(a){var b=this.getChildren(!1,!0,!0),c=b.length;for(this._time=this._totalTime=0;--c>-1;)b[c]._enabled(!1,!1);return a!==!1&&(this._labels={}),this._uncache(!0)},q.invalidate=function(){for(var b=this._first;b;)b.invalidate(),b=b._next;return a.prototype.invalidate.call(this)},q._enabled=function(a,c){if(a===this._gc)for(var d=this._first;d;)d._enabled(a,!0),d=d._next;return b.prototype._enabled.call(this,a,c)},q.totalTime=function(b,c,d){this._forcingPlayhead=!0;var e=a.prototype.totalTime.apply(this,arguments);return this._forcingPlayhead=!1,e},q.duration=function(a){return arguments.length?(0!==this.duration()&&0!==a&&this.timeScale(this._duration/a),this):(this._dirty&&this.totalDuration(),this._duration)},q.totalDuration=function(a){if(!arguments.length){if(this._dirty){for(var b,c,d=0,e=this._last,f=999999999999;e;)b=e._prev,e._dirty&&e.totalDuration(),e._startTime>f&&this._sortChildren&&!e._paused&&!this._calculatingDuration?(this._calculatingDuration=1,this.add(e,e._startTime-e._delay),this._calculatingDuration=0):f=e._startTime,e._startTime<0&&!e._paused&&(d-=e._startTime,this._timeline.smoothChildTiming&&(this._startTime+=e._startTime/this._timeScale,this._time-=e._startTime,this._totalTime-=e._startTime,this._rawPrevTime-=e._startTime),this.shiftChildren(-e._startTime,!1,-9999999999),f=0),c=e._startTime+e._totalDuration/e._timeScale,c>d&&(d=c),e=b;this._duration=this._totalDuration=d,this._dirty=!1}return this._totalDuration}return a&&this.totalDuration()?this.timeScale(this._totalDuration/a):this},q.paused=function(b){if(!b)for(var c=this._first,d=this._time;c;)c._startTime===d&&"isPause"===c.data&&(c._rawPrevTime=0),c=c._next;return a.prototype.paused.apply(this,arguments)},q.usesFrames=function(){for(var b=this._timeline;b._timeline;)b=b._timeline;return b===a._rootFramesTimeline},q.rawTime=function(a){return a&&(this._paused||this._repeat&&this.time()>0&&this.totalProgress()<1)?this._totalTime%(this._duration+this._repeatDelay):this._paused?this._totalTime:(this._timeline.rawTime(a)-this._startTime)*this._timeScale},d},!0),_gsScope._gsDefine("TimelineMax",["TimelineLite","TweenLite","easing.Ease"],function(a,b,c){var d=function(b){a.call(this,b),this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._cycle=0,this._yoyo=this.vars.yoyo===!0,this._dirty=!0},e=1e-10,f=b._internals,g=f.lazyTweens,h=f.lazyRender,i=_gsScope._gsDefine.globals,j=new c(null,null,1,0),k=d.prototype=new a;return k.constructor=d,k.kill()._gc=!1,d.version="1.20.3",k.invalidate=function(){return this._yoyo=this.vars.yoyo===!0,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._uncache(!0),a.prototype.invalidate.call(this)},k.addCallback=function(a,c,d,e){return this.add(b.delayedCall(0,a,d,e),c)},k.removeCallback=function(a,b){if(a)if(null==b)this._kill(null,a);else for(var c=this.getTweensOf(a,!1),d=c.length,e=this._parseTimeOrLabel(b);--d>-1;)c[d]._startTime===e&&c[d]._enabled(!1,!1);return this},k.removePause=function(b){return this.removeCallback(a._internals.pauseCallback,b)},k.tweenTo=function(a,c){c=c||{};var d,e,f,g={ease:j,useFrames:this.usesFrames(),immediateRender:!1},h=c.repeat&&i.TweenMax||b;for(e in c)g[e]=c[e];return g.time=this._parseTimeOrLabel(a),d=Math.abs(Number(g.time)-this._time)/this._timeScale||.001,f=new h(this,d,g),g.onStart=function(){f.target.paused(!0),f.vars.time!==f.target.time()&&d===f.duration()&&f.duration(Math.abs(f.vars.time-f.target.time())/f.target._timeScale),c.onStart&&c.onStart.apply(c.onStartScope||c.callbackScope||f,c.onStartParams||[])},f},k.tweenFromTo=function(a,b,c){c=c||{},a=this._parseTimeOrLabel(a),c.startAt={onComplete:this.seek,onCompleteParams:[a],callbackScope:this},c.immediateRender=c.immediateRender!==!1;var d=this.tweenTo(b,c);return d.duration(Math.abs(d.vars.time-a)/this._timeScale||.001)},k.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,i,j,k,l,m,n,o=this._time,p=this._dirty?this.totalDuration():this._totalDuration,q=this._duration,r=this._totalTime,s=this._startTime,t=this._timeScale,u=this._rawPrevTime,v=this._paused,w=this._cycle;if(o!==this._time&&(a+=this._time-o),a>=p-1e-7&&a>=0)this._locked||(this._totalTime=p,this._cycle=this._repeat),this._reversed||this._hasPausedChild()||(f=!0,j="onComplete",k=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||0>u||u===e)&&u!==a&&this._first&&(k=!0,u>e&&(j="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,this._yoyo&&0!==(1&this._cycle)?this._time=a=0:(this._time=q,a=q+1e-4);else if(1e-7>a)if(this._locked||(this._totalTime=this._cycle=0),this._time=0,(0!==o||0===q&&u!==e&&(u>0||0>a&&u>=0)&&!this._locked)&&(j="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(k=f=!0,j="onReverseComplete"):u>=0&&this._first&&(k=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=q||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(k=!0)}else if(0===q&&0>u&&(k=!0),this._time=this._rawPrevTime=a,this._locked||(this._totalTime=a,0!==this._repeat&&(l=q+this._repeatDelay,this._cycle=this._totalTime/l>>0,0!==this._cycle&&this._cycle===this._totalTime/l&&a>=r&&this._cycle--,this._time=this._totalTime-this._cycle*l,this._yoyo&&0!==(1&this._cycle)&&(this._time=q-this._time),this._time>q?(this._time=q,a=q+1e-4):this._time<0?this._time=a=0:a=this._time)),this._hasPause&&!this._forcingPlayhead&&!b){if(a=this._time,a>=o||this._repeat&&w!==this._cycle)for(d=this._first;d&&d._startTime<=a&&!m;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(m=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!m;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(m=d),d=d._prev;m&&m._startTime<q&&(this._time=a=m._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}if(this._cycle!==w&&!this._locked){var x=this._yoyo&&0!==(1&w),y=x===(this._yoyo&&0!==(1&this._cycle)),z=this._totalTime,A=this._cycle,B=this._rawPrevTime,C=this._time;if(this._totalTime=w*q,this._cycle<w?x=!x:this._totalTime+=q,this._time=o,this._rawPrevTime=0===q?u-1e-4:u,this._cycle=w,this._locked=!0,o=x?0:q,this.render(o,b,0===q),b||this._gc||this.vars.onRepeat&&(this._cycle=A,this._locked=!1,this._callback("onRepeat")),o!==this._time)return;if(y&&(this._cycle=w,this._locked=!0,o=x?q+1e-4:-1e-4,this.render(o,!0,!1)),this._locked=!1,this._paused&&!v)return;this._time=C,this._totalTime=z,this._cycle=A,this._rawPrevTime=B}if(!(this._time!==o&&this._first||c||k||m))return void(r!==this._totalTime&&this._onUpdate&&(b||this._callback("onUpdate")));if(this._initted||(this._initted=!0),this._active||!this._paused&&this._totalTime!==r&&a>0&&(this._active=!0),0===r&&this.vars.onStart&&(0===this._totalTime&&this._totalDuration||b||this._callback("onStart")),n=this._time,n>=o)for(d=this._first;d&&(i=d._next,n===this._time&&(!this._paused||v));)(d._active||d._startTime<=this._time&&!d._paused&&!d._gc)&&(m===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=i;else for(d=this._last;d&&(i=d._prev,n===this._time&&(!this._paused||v));){if(d._active||d._startTime<=o&&!d._paused&&!d._gc){if(m===d){for(m=d._prev;m&&m.endTime()>this._time;)m.render(m._reversed?m.totalDuration()-(a-m._startTime)*m._timeScale:(a-m._startTime)*m._timeScale,b,c),m=m._prev;m=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=i}this._onUpdate&&(b||(g.length&&h(),this._callback("onUpdate"))),j&&(this._locked||this._gc||(s===this._startTime||t!==this._timeScale)&&(0===this._time||p>=this.totalDuration())&&(f&&(g.length&&h(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[j]&&this._callback(j)))},k.getActive=function(a,b,c){null==a&&(a=!0),null==b&&(b=!0),null==c&&(c=!1);var d,e,f=[],g=this.getChildren(a,b,c),h=0,i=g.length;for(d=0;i>d;d++)e=g[d],e.isActive()&&(f[h++]=e);return f},k.getLabelAfter=function(a){a||0!==a&&(a=this._time);var b,c=this.getLabelsArray(),d=c.length;for(b=0;d>b;b++)if(c[b].time>a)return c[b].name;return null},k.getLabelBefore=function(a){null==a&&(a=this._time);for(var b=this.getLabelsArray(),c=b.length;--c>-1;)if(b[c].time<a)return b[c].name;return null},k.getLabelsArray=function(){var a,b=[],c=0;for(a in this._labels)b[c++]={time:this._labels[a],name:a};return b.sort(function(a,b){return a.time-b.time}),b},k.invalidate=function(){return this._locked=!1,a.prototype.invalidate.call(this)},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()||0},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()||0},k.totalDuration=function(b){return arguments.length?-1!==this._repeat&&b?this.timeScale(this.totalDuration()/b):this:(this._dirty&&(a.prototype.totalDuration.call(this),this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat),this._totalDuration)},k.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),a>this._duration&&(a=this._duration),this._yoyo&&0!==(1&this._cycle)?a=this._duration-a+this._cycle*(this._duration+this._repeatDelay):0!==this._repeat&&(a+=this._cycle*(this._duration+this._repeatDelay)),this.totalTime(a,b)):this._time},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},k.currentLabel=function(a){return arguments.length?this.seek(a,!0):this.getLabelBefore(this._time+1e-8)},d},!0),function(){var a=180/Math.PI,b=[],c=[],d=[],e={},f=_gsScope._gsDefine.globals,g=function(a,b,c,d){c===d&&(c=d-(d-b)/1e6),a===b&&(b=a+(c-a)/1e6),this.a=a,this.b=b,this.c=c,this.d=d,this.da=d-a,this.ca=c-a,this.ba=b-a},h=",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",i=function(a,b,c,d){var e={a:a},f={},g={},h={c:d},i=(a+b)/2,j=(b+c)/2,k=(c+d)/2,l=(i+j)/2,m=(j+k)/2,n=(m-l)/8;return e.b=i+(a-i)/4,f.b=l+n,e.c=f.a=(e.b+f.b)/2,f.c=g.a=(l+m)/2,g.b=m-n,h.b=k+(d-k)/4,g.c=h.a=(g.b+h.b)/2,[e,f,g,h]},j=function(a,e,f,g,h){var j,k,l,m,n,o,p,q,r,s,t,u,v,w=a.length-1,x=0,y=a[0].a;for(j=0;w>j;j++)n=a[x],k=n.a,l=n.d,m=a[x+1].d,h?(t=b[j],u=c[j],v=(u+t)*e*.25/(g?.5:d[j]||.5),o=l-(l-k)*(g?.5*e:0!==t?v/t:0),p=l+(m-l)*(g?.5*e:0!==u?v/u:0),q=l-(o+((p-o)*(3*t/(t+u)+.5)/4||0))):(o=l-(l-k)*e*.5,p=l+(m-l)*e*.5,q=l-(o+p)/2),o+=q,p+=q,n.c=r=o,0!==j?n.b=y:n.b=y=n.a+.6*(n.c-n.a),n.da=l-k,n.ca=r-k,n.ba=y-k,f?(s=i(k,y,r,l),a.splice(x,1,s[0],s[1],s[2],s[3]),x+=4):x++,y=p;n=a[x],n.b=y,n.c=y+.4*(n.d-y),n.da=n.d-n.a,n.ca=n.c-n.a,n.ba=y-n.a,f&&(s=i(n.a,y,n.c,n.d),a.splice(x,1,s[0],s[1],s[2],s[3]))},k=function(a,d,e,f){var h,i,j,k,l,m,n=[];if(f)for(a=[f].concat(a),i=a.length;--i>-1;)"string"==typeof(m=a[i][d])&&"="===m.charAt(1)&&(a[i][d]=f[d]+Number(m.charAt(0)+m.substr(2)));if(h=a.length-2,0>h)return n[0]=new g(a[0][d],0,0,a[0][d]),n;for(i=0;h>i;i++)j=a[i][d],k=a[i+1][d],n[i]=new g(j,0,0,k),e&&(l=a[i+2][d],b[i]=(b[i]||0)+(k-j)*(k-j),c[i]=(c[i]||0)+(l-k)*(l-k));return n[i]=new g(a[i][d],0,0,a[i+1][d]),n},l=function(a,f,g,i,l,m){var n,o,p,q,r,s,t,u,v={},w=[],x=m||a[0];l="string"==typeof l?","+l+",":h,null==f&&(f=1);for(o in a[0])w.push(o);if(a.length>1){for(u=a[a.length-1],t=!0,n=w.length;--n>-1;)if(o=w[n],Math.abs(x[o]-u[o])>.05){t=!1;break}t&&(a=a.concat(),m&&a.unshift(m),a.push(a[1]),m=a[a.length-3])}for(b.length=c.length=d.length=0,n=w.length;--n>-1;)o=w[n],e[o]=-1!==l.indexOf(","+o+","),v[o]=k(a,o,e[o],m);for(n=b.length;--n>-1;)b[n]=Math.sqrt(b[n]),c[n]=Math.sqrt(c[n]);if(!i){for(n=w.length;--n>-1;)if(e[o])for(p=v[w[n]],s=p.length-1,q=0;s>q;q++)r=p[q+1].da/c[q]+p[q].da/b[q]||0,
d[q]=(d[q]||0)+r*r;for(n=d.length;--n>-1;)d[n]=Math.sqrt(d[n])}for(n=w.length,q=g?4:1;--n>-1;)o=w[n],p=v[o],j(p,f,g,i,e[o]),t&&(p.splice(0,q),p.splice(p.length-q,q));return v},m=function(a,b,c){b=b||"soft";var d,e,f,h,i,j,k,l,m,n,o,p={},q="cubic"===b?3:2,r="soft"===b,s=[];if(r&&c&&(a=[c].concat(a)),null==a||a.length<q+1)throw"invalid Bezier data";for(m in a[0])s.push(m);for(j=s.length;--j>-1;){for(m=s[j],p[m]=i=[],n=0,l=a.length,k=0;l>k;k++)d=null==c?a[k][m]:"string"==typeof(o=a[k][m])&&"="===o.charAt(1)?c[m]+Number(o.charAt(0)+o.substr(2)):Number(o),r&&k>1&&l-1>k&&(i[n++]=(d+i[n-2])/2),i[n++]=d;for(l=n-q+1,n=0,k=0;l>k;k+=q)d=i[k],e=i[k+1],f=i[k+2],h=2===q?0:i[k+3],i[n++]=o=3===q?new g(d,e,f,h):new g(d,(2*e+d)/3,(2*e+f)/3,f);i.length=n}return p},n=function(a,b,c){for(var d,e,f,g,h,i,j,k,l,m,n,o=1/c,p=a.length;--p>-1;)for(m=a[p],f=m.a,g=m.d-f,h=m.c-f,i=m.b-f,d=e=0,k=1;c>=k;k++)j=o*k,l=1-j,d=e-(e=(j*j*g+3*l*(j*h+l*i))*j),n=p*c+k-1,b[n]=(b[n]||0)+d*d},o=function(a,b){b=b>>0||6;var c,d,e,f,g=[],h=[],i=0,j=0,k=b-1,l=[],m=[];for(c in a)n(a[c],g,b);for(e=g.length,d=0;e>d;d++)i+=Math.sqrt(g[d]),f=d%b,m[f]=i,f===k&&(j+=i,f=d/b>>0,l[f]=m,h[f]=j,i=0,m=[]);return{length:j,lengths:h,segments:l}},p=_gsScope._gsDefine.plugin({propName:"bezier",priority:-1,version:"1.3.8",API:2,global:!0,init:function(a,b,c){this._target=a,b instanceof Array&&(b={values:b}),this._func={},this._mod={},this._props=[],this._timeRes=null==b.timeResolution?6:parseInt(b.timeResolution,10);var d,e,f,g,h,i=b.values||[],j={},k=i[0],n=b.autoRotate||c.vars.orientToBezier;this._autoRotate=n?n instanceof Array?n:[["x","y","rotation",n===!0?0:Number(n)||0]]:null;for(d in k)this._props.push(d);for(f=this._props.length;--f>-1;)d=this._props[f],this._overwriteProps.push(d),e=this._func[d]="function"==typeof a[d],j[d]=e?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]():parseFloat(a[d]),h||j[d]!==i[0][d]&&(h=j);if(this._beziers="cubic"!==b.type&&"quadratic"!==b.type&&"soft"!==b.type?l(i,isNaN(b.curviness)?1:b.curviness,!1,"thruBasic"===b.type,b.correlate,h):m(i,b.type,j),this._segCount=this._beziers[d].length,this._timeRes){var p=o(this._beziers,this._timeRes);this._length=p.length,this._lengths=p.lengths,this._segments=p.segments,this._l1=this._li=this._s1=this._si=0,this._l2=this._lengths[0],this._curSeg=this._segments[0],this._s2=this._curSeg[0],this._prec=1/this._curSeg.length}if(n=this._autoRotate)for(this._initialRotations=[],n[0]instanceof Array||(this._autoRotate=n=[n]),f=n.length;--f>-1;){for(g=0;3>g;g++)d=n[f][g],this._func[d]="function"==typeof a[d]?a[d.indexOf("set")||"function"!=typeof a["get"+d.substr(3)]?d:"get"+d.substr(3)]:!1;d=n[f][2],this._initialRotations[f]=(this._func[d]?this._func[d].call(this._target):this._target[d])||0,this._overwriteProps.push(d)}return this._startRatio=c.vars.runBackwards?1:0,!0},set:function(b){var c,d,e,f,g,h,i,j,k,l,m=this._segCount,n=this._func,o=this._target,p=b!==this._startRatio;if(this._timeRes){if(k=this._lengths,l=this._curSeg,b*=this._length,e=this._li,b>this._l2&&m-1>e){for(j=m-1;j>e&&(this._l2=k[++e])<=b;);this._l1=k[e-1],this._li=e,this._curSeg=l=this._segments[e],this._s2=l[this._s1=this._si=0]}else if(b<this._l1&&e>0){for(;e>0&&(this._l1=k[--e])>=b;);0===e&&b<this._l1?this._l1=0:e++,this._l2=k[e],this._li=e,this._curSeg=l=this._segments[e],this._s1=l[(this._si=l.length-1)-1]||0,this._s2=l[this._si]}if(c=e,b-=this._l1,e=this._si,b>this._s2&&e<l.length-1){for(j=l.length-1;j>e&&(this._s2=l[++e])<=b;);this._s1=l[e-1],this._si=e}else if(b<this._s1&&e>0){for(;e>0&&(this._s1=l[--e])>=b;);0===e&&b<this._s1?this._s1=0:e++,this._s2=l[e],this._si=e}h=(e+(b-this._s1)/(this._s2-this._s1))*this._prec||0}else c=0>b?0:b>=1?m-1:m*b>>0,h=(b-c*(1/m))*m;for(d=1-h,e=this._props.length;--e>-1;)f=this._props[e],g=this._beziers[f][c],i=(h*h*g.da+3*d*(h*g.ca+d*g.ba))*h+g.a,this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i;if(this._autoRotate){var q,r,s,t,u,v,w,x=this._autoRotate;for(e=x.length;--e>-1;)f=x[e][2],v=x[e][3]||0,w=x[e][4]===!0?1:a,g=this._beziers[x[e][0]],q=this._beziers[x[e][1]],g&&q&&(g=g[c],q=q[c],r=g.a+(g.b-g.a)*h,t=g.b+(g.c-g.b)*h,r+=(t-r)*h,t+=(g.c+(g.d-g.c)*h-t)*h,s=q.a+(q.b-q.a)*h,u=q.b+(q.c-q.b)*h,s+=(u-s)*h,u+=(q.c+(q.d-q.c)*h-u)*h,i=p?Math.atan2(u-s,t-r)*w+v:this._initialRotations[e],this._mod[f]&&(i=this._mod[f](i,o)),n[f]?o[f](i):o[f]=i)}}}),q=p.prototype;p.bezierThrough=l,p.cubicToQuadratic=i,p._autoCSS=!0,p.quadraticToCubic=function(a,b,c){return new g(a,(2*b+a)/3,(2*b+c)/3,c)},p._cssRegister=function(){var a=f.CSSPlugin;if(a){var b=a._internals,c=b._parseToProxy,d=b._setPluginRatio,e=b.CSSPropTween;b._registerComplexSpecialProp("bezier",{parser:function(a,b,f,g,h,i){b instanceof Array&&(b={values:b}),i=new p;var j,k,l,m=b.values,n=m.length-1,o=[],q={};if(0>n)return h;for(j=0;n>=j;j++)l=c(a,m[j],g,h,i,n!==j),o[j]=l.end;for(k in b)q[k]=b[k];return q.values=o,h=new e(a,"bezier",0,0,l.pt,2),h.data=l,h.plugin=i,h.setRatio=d,0===q.autoRotate&&(q.autoRotate=!0),!q.autoRotate||q.autoRotate instanceof Array||(j=q.autoRotate===!0?0:Number(q.autoRotate),q.autoRotate=null!=l.end.left?[["left","top","rotation",j,!1]]:null!=l.end.x?[["x","y","rotation",j,!1]]:!1),q.autoRotate&&(g._transform||g._enableTransforms(!1),l.autoRotate=g._target._gsTransform,l.proxy.rotation=l.autoRotate.rotation||0,g._overwriteProps.push("rotation")),i._onInitTween(l.proxy,q,g._tween),h}})}},q._mod=function(a){for(var b,c=this._overwriteProps,d=c.length;--d>-1;)b=a[c[d]],b&&"function"==typeof b&&(this._mod[c[d]]=b)},q._kill=function(a){var b,c,d=this._props;for(b in this._beziers)if(b in a)for(delete this._beziers[b],delete this._func[b],c=d.length;--c>-1;)d[c]===b&&d.splice(c,1);if(d=this._autoRotate)for(c=d.length;--c>-1;)a[d[c][2]]&&d.splice(c,1);return this._super._kill.call(this,a)}}(),_gsScope._gsDefine("plugins.CSSPlugin",["plugins.TweenPlugin","TweenLite"],function(a,b){var c,d,e,f,g=function(){a.call(this,"css"),this._overwriteProps.length=0,this.setRatio=g.prototype.setRatio},h=_gsScope._gsDefine.globals,i={},j=g.prototype=new a("css");j.constructor=g,g.version="1.20.3",g.API=2,g.defaultTransformPerspective=0,g.defaultSkewType="compensated",g.defaultSmoothOrigin=!0,j="px",g.suffixMap={top:j,right:j,bottom:j,left:j,width:j,height:j,fontSize:j,padding:j,margin:j,perspective:j,lineHeight:""};var k,l,m,n,o,p,q,r,s=/(?:\-|\.|\b)(\d|\.|e\-)+/g,t=/(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,u=/(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,v=/(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,w=/(?:\d|\-|\+|=|#|\.)*/g,x=/opacity *= *([^)]*)/i,y=/opacity:([^;]*)/i,z=/alpha\(opacity *=.+?\)/i,A=/^(rgb|hsl)/,B=/([A-Z])/g,C=/-([a-z])/gi,D=/(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,E=function(a,b){return b.toUpperCase()},F=/(?:Left|Right|Width)/i,G=/(M11|M12|M21|M22)=[\d\-\.e]+/gi,H=/progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,I=/,(?=[^\)]*(?:\(|$))/gi,J=/[\s,\(]/i,K=Math.PI/180,L=180/Math.PI,M={},N={style:{}},O=_gsScope.document||{createElement:function(){return N}},P=function(a,b){return O.createElementNS?O.createElementNS(b||"http://www.w3.org/1999/xhtml",a):O.createElement(a)},Q=P("div"),R=P("img"),S=g._internals={_specialProps:i},T=(_gsScope.navigator||{}).userAgent||"",U=function(){var a=T.indexOf("Android"),b=P("a");return m=-1!==T.indexOf("Safari")&&-1===T.indexOf("Chrome")&&(-1===a||parseFloat(T.substr(a+8,2))>3),o=m&&parseFloat(T.substr(T.indexOf("Version/")+8,2))<6,n=-1!==T.indexOf("Firefox"),(/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(T)||/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(T))&&(p=parseFloat(RegExp.$1)),b?(b.style.cssText="top:1px;opacity:.55;",/^0.55/.test(b.style.opacity)):!1}(),V=function(a){return x.test("string"==typeof a?a:(a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?parseFloat(RegExp.$1)/100:1},W=function(a){_gsScope.console&&console.log(a)},X="",Y="",Z=function(a,b){b=b||Q;var c,d,e=b.style;if(void 0!==e[a])return a;for(a=a.charAt(0).toUpperCase()+a.substr(1),c=["O","Moz","ms","Ms","Webkit"],d=5;--d>-1&&void 0===e[c[d]+a];);return d>=0?(Y=3===d?"ms":c[d],X="-"+Y.toLowerCase()+"-",Y+a):null},$=O.defaultView?O.defaultView.getComputedStyle:function(){},_=g.getStyle=function(a,b,c,d,e){var f;return U||"opacity"!==b?(!d&&a.style[b]?f=a.style[b]:(c=c||$(a))?f=c[b]||c.getPropertyValue(b)||c.getPropertyValue(b.replace(B,"-$1").toLowerCase()):a.currentStyle&&(f=a.currentStyle[b]),null==e||f&&"none"!==f&&"auto"!==f&&"auto auto"!==f?f:e):V(a)},aa=S.convertToPixels=function(a,c,d,e,f){if("px"===e||!e&&"lineHeight"!==c)return d;if("auto"===e||!d)return 0;var h,i,j,k=F.test(c),l=a,m=Q.style,n=0>d,o=1===d;if(n&&(d=-d),o&&(d*=100),"lineHeight"!==c||e)if("%"===e&&-1!==c.indexOf("border"))h=d/100*(k?a.clientWidth:a.clientHeight);else{if(m.cssText="border:0 solid red;position:"+_(a,"position")+";line-height:0;","%"!==e&&l.appendChild&&"v"!==e.charAt(0)&&"rem"!==e)m[k?"borderLeftWidth":"borderTopWidth"]=d+e;else{if(l=a.parentNode||O.body,-1!==_(l,"display").indexOf("flex")&&(m.position="absolute"),i=l._gsCache,j=b.ticker.frame,i&&k&&i.time===j)return i.width*d/100;m[k?"width":"height"]=d+e}l.appendChild(Q),h=parseFloat(Q[k?"offsetWidth":"offsetHeight"]),l.removeChild(Q),k&&"%"===e&&g.cacheWidths!==!1&&(i=l._gsCache=l._gsCache||{},i.time=j,i.width=h/d*100),0!==h||f||(h=aa(a,c,d,e,!0))}else i=$(a).lineHeight,a.style.lineHeight=d,h=parseFloat($(a).lineHeight),a.style.lineHeight=i;return o&&(h/=100),n?-h:h},ba=S.calculateOffset=function(a,b,c){if("absolute"!==_(a,"position",c))return 0;var d="left"===b?"Left":"Top",e=_(a,"margin"+d,c);return a["offset"+d]-(aa(a,b,parseFloat(e),e.replace(w,""))||0)},ca=function(a,b){var c,d,e,f={};if(b=b||$(a,null))if(c=b.length)for(;--c>-1;)e=b[c],(-1===e.indexOf("-transform")||Da===e)&&(f[e.replace(C,E)]=b.getPropertyValue(e));else for(c in b)(-1===c.indexOf("Transform")||Ca===c)&&(f[c]=b[c]);else if(b=a.currentStyle||a.style)for(c in b)"string"==typeof c&&void 0===f[c]&&(f[c.replace(C,E)]=b[c]);return U||(f.opacity=V(a)),d=Ra(a,b,!1),f.rotation=d.rotation,f.skewX=d.skewX,f.scaleX=d.scaleX,f.scaleY=d.scaleY,f.x=d.x,f.y=d.y,Fa&&(f.z=d.z,f.rotationX=d.rotationX,f.rotationY=d.rotationY,f.scaleZ=d.scaleZ),f.filters&&delete f.filters,f},da=function(a,b,c,d,e){var f,g,h,i={},j=a.style;for(g in c)"cssText"!==g&&"length"!==g&&isNaN(g)&&(b[g]!==(f=c[g])||e&&e[g])&&-1===g.indexOf("Origin")&&("number"==typeof f||"string"==typeof f)&&(i[g]="auto"!==f||"left"!==g&&"top"!==g?""!==f&&"auto"!==f&&"none"!==f||"string"!=typeof b[g]||""===b[g].replace(v,"")?f:0:ba(a,g),void 0!==j[g]&&(h=new sa(j,g,j[g],h)));if(d)for(g in d)"className"!==g&&(i[g]=d[g]);return{difs:i,firstMPT:h}},ea={width:["Left","Right"],height:["Top","Bottom"]},fa=["marginLeft","marginRight","marginTop","marginBottom"],ga=function(a,b,c){if("svg"===(a.nodeName+"").toLowerCase())return(c||$(a))[b]||0;if(a.getCTM&&Oa(a))return a.getBBox()[b]||0;var d=parseFloat("width"===b?a.offsetWidth:a.offsetHeight),e=ea[b],f=e.length;for(c=c||$(a,null);--f>-1;)d-=parseFloat(_(a,"padding"+e[f],c,!0))||0,d-=parseFloat(_(a,"border"+e[f]+"Width",c,!0))||0;return d},ha=function(a,b){if("contain"===a||"auto"===a||"auto auto"===a)return a+" ";(null==a||""===a)&&(a="0 0");var c,d=a.split(" "),e=-1!==a.indexOf("left")?"0%":-1!==a.indexOf("right")?"100%":d[0],f=-1!==a.indexOf("top")?"0%":-1!==a.indexOf("bottom")?"100%":d[1];if(d.length>3&&!b){for(d=a.split(", ").join(",").split(","),a=[],c=0;c<d.length;c++)a.push(ha(d[c]));return a.join(",")}return null==f?f="center"===e?"50%":"0":"center"===f&&(f="50%"),("center"===e||isNaN(parseFloat(e))&&-1===(e+"").indexOf("="))&&(e="50%"),a=e+" "+f+(d.length>2?" "+d[2]:""),b&&(b.oxp=-1!==e.indexOf("%"),b.oyp=-1!==f.indexOf("%"),b.oxr="="===e.charAt(1),b.oyr="="===f.charAt(1),b.ox=parseFloat(e.replace(v,"")),b.oy=parseFloat(f.replace(v,"")),b.v=a),b||a},ia=function(a,b){return"function"==typeof a&&(a=a(r,q)),"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2)):parseFloat(a)-parseFloat(b)||0},ja=function(a,b){return"function"==typeof a&&(a=a(r,q)),null==a?b:"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2))+b:parseFloat(a)||0},ka=function(a,b,c,d){var e,f,g,h,i,j=1e-6;return"function"==typeof a&&(a=a(r,q)),null==a?h=b:"number"==typeof a?h=a:(e=360,f=a.split("_"),i="="===a.charAt(1),g=(i?parseInt(a.charAt(0)+"1",10)*parseFloat(f[0].substr(2)):parseFloat(f[0]))*(-1===a.indexOf("rad")?1:L)-(i?0:b),f.length&&(d&&(d[c]=b+g),-1!==a.indexOf("short")&&(g%=e,g!==g%(e/2)&&(g=0>g?g+e:g-e)),-1!==a.indexOf("_cw")&&0>g?g=(g+9999999999*e)%e-(g/e|0)*e:-1!==a.indexOf("ccw")&&g>0&&(g=(g-9999999999*e)%e-(g/e|0)*e)),h=b+g),j>h&&h>-j&&(h=0),h},la={aqua:[0,255,255],lime:[0,255,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,255],navy:[0,0,128],white:[255,255,255],fuchsia:[255,0,255],olive:[128,128,0],yellow:[255,255,0],orange:[255,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[255,0,0],pink:[255,192,203],cyan:[0,255,255],transparent:[255,255,255,0]},ma=function(a,b,c){return a=0>a?a+1:a>1?a-1:a,255*(1>6*a?b+(c-b)*a*6:.5>a?c:2>3*a?b+(c-b)*(2/3-a)*6:b)+.5|0},na=g.parseColor=function(a,b){var c,d,e,f,g,h,i,j,k,l,m;if(a)if("number"==typeof a)c=[a>>16,a>>8&255,255&a];else{if(","===a.charAt(a.length-1)&&(a=a.substr(0,a.length-1)),la[a])c=la[a];else if("#"===a.charAt(0))4===a.length&&(d=a.charAt(1),e=a.charAt(2),f=a.charAt(3),a="#"+d+d+e+e+f+f),a=parseInt(a.substr(1),16),c=[a>>16,a>>8&255,255&a];else if("hsl"===a.substr(0,3))if(c=m=a.match(s),b){if(-1!==a.indexOf("="))return a.match(t)}else g=Number(c[0])%360/360,h=Number(c[1])/100,i=Number(c[2])/100,e=.5>=i?i*(h+1):i+h-i*h,d=2*i-e,c.length>3&&(c[3]=Number(c[3])),c[0]=ma(g+1/3,d,e),c[1]=ma(g,d,e),c[2]=ma(g-1/3,d,e);else c=a.match(s)||la.transparent;c[0]=Number(c[0]),c[1]=Number(c[1]),c[2]=Number(c[2]),c.length>3&&(c[3]=Number(c[3]))}else c=la.black;return b&&!m&&(d=c[0]/255,e=c[1]/255,f=c[2]/255,j=Math.max(d,e,f),k=Math.min(d,e,f),i=(j+k)/2,j===k?g=h=0:(l=j-k,h=i>.5?l/(2-j-k):l/(j+k),g=j===d?(e-f)/l+(f>e?6:0):j===e?(f-d)/l+2:(d-e)/l+4,g*=60),c[0]=g+.5|0,c[1]=100*h+.5|0,c[2]=100*i+.5|0),c},oa=function(a,b){var c,d,e,f=a.match(pa)||[],g=0,h="";if(!f.length)return a;for(c=0;c<f.length;c++)d=f[c],e=a.substr(g,a.indexOf(d,g)-g),g+=e.length+d.length,d=na(d,b),3===d.length&&d.push(1),h+=e+(b?"hsla("+d[0]+","+d[1]+"%,"+d[2]+"%,"+d[3]:"rgba("+d.join(","))+")";return h+a.substr(g)},pa="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";for(j in la)pa+="|"+j+"\\b";pa=new RegExp(pa+")","gi"),g.colorStringFilter=function(a){var b,c=a[0]+" "+a[1];pa.test(c)&&(b=-1!==c.indexOf("hsl(")||-1!==c.indexOf("hsla("),a[0]=oa(a[0],b),a[1]=oa(a[1],b)),pa.lastIndex=0},b.defaultStringFilter||(b.defaultStringFilter=g.colorStringFilter);var qa=function(a,b,c,d){if(null==a)return function(a){return a};var e,f=b?(a.match(pa)||[""])[0]:"",g=a.split(f).join("").match(u)||[],h=a.substr(0,a.indexOf(g[0])),i=")"===a.charAt(a.length-1)?")":"",j=-1!==a.indexOf(" ")?" ":",",k=g.length,l=k>0?g[0].replace(s,""):"";return k?e=b?function(a){var b,m,n,o;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(o=a.replace(I,"|").split("|"),n=0;n<o.length;n++)o[n]=e(o[n]);return o.join(",")}if(b=(a.match(pa)||[f])[0],m=a.split(b).join("").match(u)||[],n=m.length,k>n--)for(;++n<k;)m[n]=c?m[(n-1)/2|0]:g[n];return h+m.join(j)+j+b+i+(-1!==a.indexOf("inset")?" inset":"")}:function(a){var b,f,m;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(f=a.replace(I,"|").split("|"),m=0;m<f.length;m++)f[m]=e(f[m]);return f.join(",")}if(b=a.match(u)||[],m=b.length,k>m--)for(;++m<k;)b[m]=c?b[(m-1)/2|0]:g[m];return h+b.join(j)+i}:function(a){return a}},ra=function(a){return a=a.split(","),function(b,c,d,e,f,g,h){var i,j=(c+"").split(" ");for(h={},i=0;4>i;i++)h[a[i]]=j[i]=j[i]||j[(i-1)/2>>0];return e.parse(b,h,f,g)}},sa=(S._setPluginRatio=function(a){this.plugin.setRatio(a);for(var b,c,d,e,f,g=this.data,h=g.proxy,i=g.firstMPT,j=1e-6;i;)b=h[i.v],i.r?b=Math.round(b):j>b&&b>-j&&(b=0),i.t[i.p]=b,i=i._next;if(g.autoRotate&&(g.autoRotate.rotation=g.mod?g.mod(h.rotation,this.t):h.rotation),1===a||0===a)for(i=g.firstMPT,f=1===a?"e":"b";i;){if(c=i.t,c.type){if(1===c.type){for(e=c.xs0+c.s+c.xs1,d=1;d<c.l;d++)e+=c["xn"+d]+c["xs"+(d+1)];c[f]=e}}else c[f]=c.s+c.xs0;i=i._next}},function(a,b,c,d,e){this.t=a,this.p=b,this.v=c,this.r=e,d&&(d._prev=this,this._next=d)}),ta=(S._parseToProxy=function(a,b,c,d,e,f){var g,h,i,j,k,l=d,m={},n={},o=c._transform,p=M;for(c._transform=null,M=b,d=k=c.parse(a,b,d,e),M=p,f&&(c._transform=o,l&&(l._prev=null,l._prev&&(l._prev._next=null)));d&&d!==l;){if(d.type<=1&&(h=d.p,n[h]=d.s+d.c,m[h]=d.s,f||(j=new sa(d,"s",h,j,d.r),d.c=0),1===d.type))for(g=d.l;--g>0;)i="xn"+g,h=d.p+"_"+i,n[h]=d.data[i],m[h]=d[i],f||(j=new sa(d,i,h,j,d.rxp[i]));d=d._next}return{proxy:m,end:n,firstMPT:j,pt:k}},S.CSSPropTween=function(a,b,d,e,g,h,i,j,k,l,m){this.t=a,this.p=b,this.s=d,this.c=e,this.n=i||b,a instanceof ta||f.push(this.n),this.r=j,this.type=h||0,k&&(this.pr=k,c=!0),this.b=void 0===l?d:l,this.e=void 0===m?d+e:m,g&&(this._next=g,g._prev=this)}),ua=function(a,b,c,d,e,f){var g=new ta(a,b,c,d-c,e,-1,f);return g.b=c,g.e=g.xs0=d,g},va=g.parseComplex=function(a,b,c,d,e,f,h,i,j,l){c=c||f||"","function"==typeof d&&(d=d(r,q)),h=new ta(a,b,0,0,h,l?2:1,null,!1,i,c,d),d+="",e&&pa.test(d+c)&&(d=[c,d],g.colorStringFilter(d),c=d[0],d=d[1]);var m,n,o,p,u,v,w,x,y,z,A,B,C,D=c.split(", ").join(",").split(" "),E=d.split(", ").join(",").split(" "),F=D.length,G=k!==!1;for((-1!==d.indexOf(",")||-1!==c.indexOf(","))&&(-1!==(d+c).indexOf("rgb")||-1!==(d+c).indexOf("hsl")?(D=D.join(" ").replace(I,", ").split(" "),E=E.join(" ").replace(I,", ").split(" ")):(D=D.join(" ").split(",").join(", ").split(" "),E=E.join(" ").split(",").join(", ").split(" ")),F=D.length),F!==E.length&&(D=(f||"").split(" "),F=D.length),h.plugin=j,h.setRatio=l,pa.lastIndex=0,m=0;F>m;m++)if(p=D[m],u=E[m],x=parseFloat(p),x||0===x)h.appendXtra("",x,ia(u,x),u.replace(t,""),G&&-1!==u.indexOf("px"),!0);else if(e&&pa.test(p))B=u.indexOf(")")+1,B=")"+(B?u.substr(B):""),C=-1!==u.indexOf("hsl")&&U,z=u,p=na(p,C),u=na(u,C),y=p.length+u.length>6,y&&!U&&0===u[3]?(h["xs"+h.l]+=h.l?" transparent":"transparent",h.e=h.e.split(E[m]).join("transparent")):(U||(y=!1),C?h.appendXtra(z.substr(0,z.indexOf("hsl"))+(y?"hsla(":"hsl("),p[0],ia(u[0],p[0]),",",!1,!0).appendXtra("",p[1],ia(u[1],p[1]),"%,",!1).appendXtra("",p[2],ia(u[2],p[2]),y?"%,":"%"+B,!1):h.appendXtra(z.substr(0,z.indexOf("rgb"))+(y?"rgba(":"rgb("),p[0],u[0]-p[0],",",!0,!0).appendXtra("",p[1],u[1]-p[1],",",!0).appendXtra("",p[2],u[2]-p[2],y?",":B,!0),y&&(p=p.length<4?1:p[3],h.appendXtra("",p,(u.length<4?1:u[3])-p,B,!1))),pa.lastIndex=0;else if(v=p.match(s)){if(w=u.match(t),!w||w.length!==v.length)return h;for(o=0,n=0;n<v.length;n++)A=v[n],z=p.indexOf(A,o),h.appendXtra(p.substr(o,z-o),Number(A),ia(w[n],A),"",G&&"px"===p.substr(z+A.length,2),0===n),o=z+A.length;h["xs"+h.l]+=p.substr(o)}else h["xs"+h.l]+=h.l||h["xs"+h.l]?" "+u:u;if(-1!==d.indexOf("=")&&h.data){for(B=h.xs0+h.data.s,m=1;m<h.l;m++)B+=h["xs"+m]+h.data["xn"+m];h.e=B+h["xs"+m]}return h.l||(h.type=-1,h.xs0=h.e),h.xfirst||h},wa=9;for(j=ta.prototype,j.l=j.pr=0;--wa>0;)j["xn"+wa]=0,j["xs"+wa]="";j.xs0="",j._next=j._prev=j.xfirst=j.data=j.plugin=j.setRatio=j.rxp=null,j.appendXtra=function(a,b,c,d,e,f){var g=this,h=g.l;return g["xs"+h]+=f&&(h||g["xs"+h])?" "+a:a||"",c||0===h||g.plugin?(g.l++,g.type=g.setRatio?2:1,g["xs"+g.l]=d||"",h>0?(g.data["xn"+h]=b+c,g.rxp["xn"+h]=e,g["xn"+h]=b,g.plugin||(g.xfirst=new ta(g,"xn"+h,b,c,g.xfirst||g,0,g.n,e,g.pr),g.xfirst.xs0=0),g):(g.data={s:b+c},g.rxp={},g.s=b,g.c=c,g.r=e,g)):(g["xs"+h]+=b+(d||""),g)};var xa=function(a,b){b=b||{},this.p=b.prefix?Z(a)||a:a,i[a]=i[this.p]=this,this.format=b.formatter||qa(b.defaultValue,b.color,b.collapsible,b.multi),b.parser&&(this.parse=b.parser),this.clrs=b.color,this.multi=b.multi,this.keyword=b.keyword,this.dflt=b.defaultValue,this.pr=b.priority||0},ya=S._registerComplexSpecialProp=function(a,b,c){"object"!=typeof b&&(b={parser:c});var d,e,f=a.split(","),g=b.defaultValue;for(c=c||[g],d=0;d<f.length;d++)b.prefix=0===d&&b.prefix,b.defaultValue=c[d]||g,e=new xa(f[d],b)},za=S._registerPluginProp=function(a){if(!i[a]){var b=a.charAt(0).toUpperCase()+a.substr(1)+"Plugin";ya(a,{parser:function(a,c,d,e,f,g,j){var k=h.com.greensock.plugins[b];return k?(k._cssRegister(),i[d].parse(a,c,d,e,f,g,j)):(W("Error: "+b+" js file not loaded."),f)}})}};j=xa.prototype,j.parseComplex=function(a,b,c,d,e,f){var g,h,i,j,k,l,m=this.keyword;if(this.multi&&(I.test(c)||I.test(b)?(h=b.replace(I,"|").split("|"),i=c.replace(I,"|").split("|")):m&&(h=[b],i=[c])),i){for(j=i.length>h.length?i.length:h.length,g=0;j>g;g++)b=h[g]=h[g]||this.dflt,c=i[g]=i[g]||this.dflt,m&&(k=b.indexOf(m),l=c.indexOf(m),k!==l&&(-1===l?h[g]=h[g].split(m).join(""):-1===k&&(h[g]+=" "+m)));b=h.join(", "),c=i.join(", ")}return va(a,this.p,b,c,this.clrs,this.dflt,d,this.pr,e,f)},j.parse=function(a,b,c,d,f,g,h){return this.parseComplex(a.style,this.format(_(a,this.p,e,!1,this.dflt)),this.format(b),f,g)},g.registerSpecialProp=function(a,b,c){ya(a,{parser:function(a,d,e,f,g,h,i){var j=new ta(a,e,0,0,g,2,e,!1,c);return j.plugin=h,j.setRatio=b(a,d,f._tween,e),j},priority:c})},g.useSVGTransformAttr=!0;var Aa,Ba="scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),Ca=Z("transform"),Da=X+"transform",Ea=Z("transformOrigin"),Fa=null!==Z("perspective"),Ga=S.Transform=function(){this.perspective=parseFloat(g.defaultTransformPerspective)||0,this.force3D=g.defaultForce3D!==!1&&Fa?g.defaultForce3D||"auto":!1},Ha=_gsScope.SVGElement,Ia=function(a,b,c){var d,e=O.createElementNS("http://www.w3.org/2000/svg",a),f=/([a-z])([A-Z])/g;for(d in c)e.setAttributeNS(null,d.replace(f,"$1-$2").toLowerCase(),c[d]);return b.appendChild(e),e},Ja=O.documentElement||{},Ka=function(){var a,b,c,d=p||/Android/i.test(T)&&!_gsScope.chrome;return O.createElementNS&&!d&&(a=Ia("svg",Ja),b=Ia("rect",a,{width:100,height:50,x:100}),c=b.getBoundingClientRect().width,b.style[Ea]="50% 50%",b.style[Ca]="scaleX(0.5)",d=c===b.getBoundingClientRect().width&&!(n&&Fa),Ja.removeChild(a)),d}(),La=function(a,b,c,d,e,f){var h,i,j,k,l,m,n,o,p,q,r,s,t,u,v=a._gsTransform,w=Qa(a,!0);v&&(t=v.xOrigin,u=v.yOrigin),(!d||(h=d.split(" ")).length<2)&&(n=a.getBBox(),0===n.x&&0===n.y&&n.width+n.height===0&&(n={x:parseFloat(a.hasAttribute("x")?a.getAttribute("x"):a.hasAttribute("cx")?a.getAttribute("cx"):0)||0,y:parseFloat(a.hasAttribute("y")?a.getAttribute("y"):a.hasAttribute("cy")?a.getAttribute("cy"):0)||0,width:0,height:0}),b=ha(b).split(" "),h=[(-1!==b[0].indexOf("%")?parseFloat(b[0])/100*n.width:parseFloat(b[0]))+n.x,(-1!==b[1].indexOf("%")?parseFloat(b[1])/100*n.height:parseFloat(b[1]))+n.y]),c.xOrigin=k=parseFloat(h[0]),c.yOrigin=l=parseFloat(h[1]),d&&w!==Pa&&(m=w[0],n=w[1],o=w[2],p=w[3],q=w[4],r=w[5],s=m*p-n*o,s&&(i=k*(p/s)+l*(-o/s)+(o*r-p*q)/s,j=k*(-n/s)+l*(m/s)-(m*r-n*q)/s,k=c.xOrigin=h[0]=i,l=c.yOrigin=h[1]=j)),v&&(f&&(c.xOffset=v.xOffset,c.yOffset=v.yOffset,v=c),e||e!==!1&&g.defaultSmoothOrigin!==!1?(i=k-t,j=l-u,v.xOffset+=i*w[0]+j*w[2]-i,v.yOffset+=i*w[1]+j*w[3]-j):v.xOffset=v.yOffset=0),f||a.setAttribute("data-svg-origin",h.join(" "))},Ma=function(a){var b,c=P("svg",this.ownerSVGElement&&this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),d=this.parentNode,e=this.nextSibling,f=this.style.cssText;if(Ja.appendChild(c),c.appendChild(this),this.style.display="block",a)try{b=this.getBBox(),this._originalGetBBox=this.getBBox,this.getBBox=Ma}catch(g){}else this._originalGetBBox&&(b=this._originalGetBBox());return e?d.insertBefore(this,e):d.appendChild(this),Ja.removeChild(c),this.style.cssText=f,b},Na=function(a){try{return a.getBBox()}catch(b){return Ma.call(a,!0)}},Oa=function(a){return!(!Ha||!a.getCTM||a.parentNode&&!a.ownerSVGElement||!Na(a))},Pa=[1,0,0,1,0,0],Qa=function(a,b){var c,d,e,f,g,h,i=a._gsTransform||new Ga,j=1e5,k=a.style;if(Ca?d=_(a,Da,null,!0):a.currentStyle&&(d=a.currentStyle.filter.match(G),d=d&&4===d.length?[d[0].substr(4),Number(d[2].substr(4)),Number(d[1].substr(4)),d[3].substr(4),i.x||0,i.y||0].join(","):""),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,!Ca||!(h=!$(a)||"none"===$(a).display)&&a.parentNode||(h&&(f=k.display,k.display="block"),a.parentNode||(g=1,Ja.appendChild(a)),d=_(a,Da,null,!0),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,f?k.display=f:h&&Va(k,"display"),g&&Ja.removeChild(a)),(i.svg||a.getCTM&&Oa(a))&&(c&&-1!==(k[Ca]+"").indexOf("matrix")&&(d=k[Ca],c=0),e=a.getAttribute("transform"),c&&e&&(-1!==e.indexOf("matrix")?(d=e,c=0):-1!==e.indexOf("translate")&&(d="matrix(1,0,0,1,"+e.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",")+")",c=0))),c)return Pa;for(e=(d||"").match(s)||[],wa=e.length;--wa>-1;)f=Number(e[wa]),e[wa]=(g=f-(f|=0))?(g*j+(0>g?-.5:.5)|0)/j+f:f;return b&&e.length>6?[e[0],e[1],e[4],e[5],e[12],e[13]]:e},Ra=S.getTransform=function(a,c,d,e){if(a._gsTransform&&d&&!e)return a._gsTransform;var f,h,i,j,k,l,m=d?a._gsTransform||new Ga:new Ga,n=m.scaleX<0,o=2e-5,p=1e5,q=Fa?parseFloat(_(a,Ea,c,!1,"0 0 0").split(" ")[2])||m.zOrigin||0:0,r=parseFloat(g.defaultTransformPerspective)||0;if(m.svg=!(!a.getCTM||!Oa(a)),m.svg&&(La(a,_(a,Ea,c,!1,"50% 50%")+"",m,a.getAttribute("data-svg-origin")),Aa=g.useSVGTransformAttr||Ka),f=Qa(a),f!==Pa){if(16===f.length){var s,t,u,v,w,x=f[0],y=f[1],z=f[2],A=f[3],B=f[4],C=f[5],D=f[6],E=f[7],F=f[8],G=f[9],H=f[10],I=f[12],J=f[13],K=f[14],M=f[11],N=Math.atan2(D,H);m.zOrigin&&(K=-m.zOrigin,I=F*K-f[12],J=G*K-f[13],K=H*K+m.zOrigin-f[14]),m.rotationX=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=B*v+F*w,t=C*v+G*w,u=D*v+H*w,F=B*-w+F*v,G=C*-w+G*v,H=D*-w+H*v,M=E*-w+M*v,B=s,C=t,D=u),N=Math.atan2(-z,H),m.rotationY=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=x*v-F*w,t=y*v-G*w,u=z*v-H*w,G=y*w+G*v,H=z*w+H*v,M=A*w+M*v,x=s,y=t,z=u),N=Math.atan2(y,x),m.rotation=N*L,N&&(v=Math.cos(N),w=Math.sin(N),s=x*v+y*w,t=B*v+C*w,u=F*v+G*w,y=y*v-x*w,C=C*v-B*w,G=G*v-F*w,x=s,B=t,F=u),m.rotationX&&Math.abs(m.rotationX)+Math.abs(m.rotation)>359.9&&(m.rotationX=m.rotation=0,m.rotationY=180-m.rotationY),N=Math.atan2(B,C),m.scaleX=(Math.sqrt(x*x+y*y+z*z)*p+.5|0)/p,m.scaleY=(Math.sqrt(C*C+D*D)*p+.5|0)/p,m.scaleZ=(Math.sqrt(F*F+G*G+H*H)*p+.5|0)/p,x/=m.scaleX,B/=m.scaleY,y/=m.scaleX,C/=m.scaleY,Math.abs(N)>o?(m.skewX=N*L,B=0,"simple"!==m.skewType&&(m.scaleY*=1/Math.cos(N))):m.skewX=0,m.perspective=M?1/(0>M?-M:M):0,m.x=I,m.y=J,m.z=K,m.svg&&(m.x-=m.xOrigin-(m.xOrigin*x-m.yOrigin*B),m.y-=m.yOrigin-(m.yOrigin*y-m.xOrigin*C))}else if(!Fa||e||!f.length||m.x!==f[4]||m.y!==f[5]||!m.rotationX&&!m.rotationY){var O=f.length>=6,P=O?f[0]:1,Q=f[1]||0,R=f[2]||0,S=O?f[3]:1;m.x=f[4]||0,m.y=f[5]||0,i=Math.sqrt(P*P+Q*Q),j=Math.sqrt(S*S+R*R),k=P||Q?Math.atan2(Q,P)*L:m.rotation||0,l=R||S?Math.atan2(R,S)*L+k:m.skewX||0,m.scaleX=i,m.scaleY=j,m.rotation=k,m.skewX=l,Fa&&(m.rotationX=m.rotationY=m.z=0,m.perspective=r,m.scaleZ=1),m.svg&&(m.x-=m.xOrigin-(m.xOrigin*P+m.yOrigin*R),m.y-=m.yOrigin-(m.xOrigin*Q+m.yOrigin*S))}Math.abs(m.skewX)>90&&Math.abs(m.skewX)<270&&(n?(m.scaleX*=-1,m.skewX+=m.rotation<=0?180:-180,m.rotation+=m.rotation<=0?180:-180):(m.scaleY*=-1,m.skewX+=m.skewX<=0?180:-180)),m.zOrigin=q;for(h in m)m[h]<o&&m[h]>-o&&(m[h]=0)}return d&&(a._gsTransform=m,m.svg&&(Aa&&a.style[Ca]?b.delayedCall(.001,function(){Va(a.style,Ca)}):!Aa&&a.getAttribute("transform")&&b.delayedCall(.001,function(){a.removeAttribute("transform")}))),m},Sa=function(a){var b,c,d=this.data,e=-d.rotation*K,f=e+d.skewX*K,g=1e5,h=(Math.cos(e)*d.scaleX*g|0)/g,i=(Math.sin(e)*d.scaleX*g|0)/g,j=(Math.sin(f)*-d.scaleY*g|0)/g,k=(Math.cos(f)*d.scaleY*g|0)/g,l=this.t.style,m=this.t.currentStyle;if(m){c=i,i=-j,j=-c,b=m.filter,l.filter="";var n,o,q=this.t.offsetWidth,r=this.t.offsetHeight,s="absolute"!==m.position,t="progid:DXImageTransform.Microsoft.Matrix(M11="+h+", M12="+i+", M21="+j+", M22="+k,u=d.x+q*d.xPercent/100,v=d.y+r*d.yPercent/100;if(null!=d.ox&&(n=(d.oxp?q*d.ox*.01:d.ox)-q/2,o=(d.oyp?r*d.oy*.01:d.oy)-r/2,u+=n-(n*h+o*i),v+=o-(n*j+o*k)),s?(n=q/2,o=r/2,t+=", Dx="+(n-(n*h+o*i)+u)+", Dy="+(o-(n*j+o*k)+v)+")"):t+=", sizingMethod='auto expand')",-1!==b.indexOf("DXImageTransform.Microsoft.Matrix(")?l.filter=b.replace(H,t):l.filter=t+" "+b,(0===a||1===a)&&1===h&&0===i&&0===j&&1===k&&(s&&-1===t.indexOf("Dx=0, Dy=0")||x.test(b)&&100!==parseFloat(RegExp.$1)||-1===b.indexOf(b.indexOf("Alpha"))&&l.removeAttribute("filter")),!s){var y,z,A,B=8>p?1:-1;for(n=d.ieOffsetX||0,o=d.ieOffsetY||0,d.ieOffsetX=Math.round((q-((0>h?-h:h)*q+(0>i?-i:i)*r))/2+u),d.ieOffsetY=Math.round((r-((0>k?-k:k)*r+(0>j?-j:j)*q))/2+v),wa=0;4>wa;wa++)z=fa[wa],y=m[z],c=-1!==y.indexOf("px")?parseFloat(y):aa(this.t,z,parseFloat(y),y.replace(w,""))||0,A=c!==d[z]?2>wa?-d.ieOffsetX:-d.ieOffsetY:2>wa?n-d.ieOffsetX:o-d.ieOffsetY,l[z]=(d[z]=Math.round(c-A*(0===wa||2===wa?1:B)))+"px"}}},Ta=S.set3DTransformRatio=S.setTransformRatio=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,o,p,q,r,s,t,u,v,w,x,y,z=this.data,A=this.t.style,B=z.rotation,C=z.rotationX,D=z.rotationY,E=z.scaleX,F=z.scaleY,G=z.scaleZ,H=z.x,I=z.y,J=z.z,L=z.svg,M=z.perspective,N=z.force3D,O=z.skewY,P=z.skewX;if(O&&(P+=O,B+=O),((1===a||0===a)&&"auto"===N&&(this.tween._totalTime===this.tween._totalDuration||!this.tween._totalTime)||!N)&&!J&&!M&&!D&&!C&&1===G||Aa&&L||!Fa)return void(B||P||L?(B*=K,x=P*K,y=1e5,c=Math.cos(B)*E,f=Math.sin(B)*E,d=Math.sin(B-x)*-F,g=Math.cos(B-x)*F,x&&"simple"===z.skewType&&(b=Math.tan(x-O*K),b=Math.sqrt(1+b*b),d*=b,g*=b,O&&(b=Math.tan(O*K),b=Math.sqrt(1+b*b),c*=b,f*=b)),L&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset,Aa&&(z.xPercent||z.yPercent)&&(q=this.t.getBBox(),H+=.01*z.xPercent*q.width,I+=.01*z.yPercent*q.height),q=1e-6,q>H&&H>-q&&(H=0),q>I&&I>-q&&(I=0)),u=(c*y|0)/y+","+(f*y|0)/y+","+(d*y|0)/y+","+(g*y|0)/y+","+H+","+I+")",L&&Aa?this.t.setAttribute("transform","matrix("+u):A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+u):A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+E+",0,0,"+F+","+H+","+I+")");if(n&&(q=1e-4,q>E&&E>-q&&(E=G=2e-5),q>F&&F>-q&&(F=G=2e-5),!M||z.z||z.rotationX||z.rotationY||(M=0)),B||P)B*=K,r=c=Math.cos(B),s=f=Math.sin(B),P&&(B-=P*K,r=Math.cos(B),s=Math.sin(B),"simple"===z.skewType&&(b=Math.tan((P-O)*K),b=Math.sqrt(1+b*b),r*=b,s*=b,z.skewY&&(b=Math.tan(O*K),b=Math.sqrt(1+b*b),c*=b,f*=b))),d=-s,g=r;else{if(!(D||C||1!==G||M||L))return void(A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) translate3d(":"translate3d(")+H+"px,"+I+"px,"+J+"px)"+(1!==E||1!==F?" scale("+E+","+F+")":""));c=g=1,d=f=0}k=1,e=h=i=j=l=m=0,o=M?-1/M:0,p=z.zOrigin,q=1e-6,v=",",w="0",B=D*K,B&&(r=Math.cos(B),s=Math.sin(B),i=-s,l=o*-s,e=c*s,h=f*s,k=r,o*=r,c*=r,f*=r),B=C*K,B&&(r=Math.cos(B),s=Math.sin(B),b=d*r+e*s,t=g*r+h*s,j=k*s,m=o*s,e=d*-s+e*r,h=g*-s+h*r,k*=r,o*=r,d=b,g=t),1!==G&&(e*=G,h*=G,k*=G,o*=G),1!==F&&(d*=F,g*=F,j*=F,m*=F),1!==E&&(c*=E,f*=E,i*=E,l*=E),(p||L)&&(p&&(H+=e*-p,I+=h*-p,J+=k*-p+p),L&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset),q>H&&H>-q&&(H=w),q>I&&I>-q&&(I=w),q>J&&J>-q&&(J=0)),u=z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix3d(":"matrix3d(",u+=(q>c&&c>-q?w:c)+v+(q>f&&f>-q?w:f)+v+(q>i&&i>-q?w:i),u+=v+(q>l&&l>-q?w:l)+v+(q>d&&d>-q?w:d)+v+(q>g&&g>-q?w:g),C||D||1!==G?(u+=v+(q>j&&j>-q?w:j)+v+(q>m&&m>-q?w:m)+v+(q>e&&e>-q?w:e),u+=v+(q>h&&h>-q?w:h)+v+(q>k&&k>-q?w:k)+v+(q>o&&o>-q?w:o)+v):u+=",0,0,0,0,1,0,",u+=H+v+I+v+J+v+(M?1+-J/M:1)+")",A[Ca]=u};j=Ga.prototype,j.x=j.y=j.z=j.skewX=j.skewY=j.rotation=j.rotationX=j.rotationY=j.zOrigin=j.xPercent=j.yPercent=j.xOffset=j.yOffset=0,j.scaleX=j.scaleY=j.scaleZ=1,ya("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",{
parser:function(a,b,c,d,f,h,i){if(d._lastParsedTransform===i)return f;d._lastParsedTransform=i;var j,k=i.scale&&"function"==typeof i.scale?i.scale:0;"function"==typeof i[c]&&(j=i[c],i[c]=b),k&&(i.scale=k(r,a));var l,m,n,o,p,s,t,u,v,w=a._gsTransform,x=a.style,y=1e-6,z=Ba.length,A=i,B={},C="transformOrigin",D=Ra(a,e,!0,A.parseTransform),E=A.transform&&("function"==typeof A.transform?A.transform(r,q):A.transform);if(D.skewType=A.skewType||D.skewType||g.defaultSkewType,d._transform=D,E&&"string"==typeof E&&Ca)m=Q.style,m[Ca]=E,m.display="block",m.position="absolute",O.body.appendChild(Q),l=Ra(Q,null,!1),"simple"===D.skewType&&(l.scaleY*=Math.cos(l.skewX*K)),D.svg&&(s=D.xOrigin,t=D.yOrigin,l.x-=D.xOffset,l.y-=D.yOffset,(A.transformOrigin||A.svgOrigin)&&(E={},La(a,ha(A.transformOrigin),E,A.svgOrigin,A.smoothOrigin,!0),s=E.xOrigin,t=E.yOrigin,l.x-=E.xOffset-D.xOffset,l.y-=E.yOffset-D.yOffset),(s||t)&&(u=Qa(Q,!0),l.x-=s-(s*u[0]+t*u[2]),l.y-=t-(s*u[1]+t*u[3]))),O.body.removeChild(Q),l.perspective||(l.perspective=D.perspective),null!=A.xPercent&&(l.xPercent=ja(A.xPercent,D.xPercent)),null!=A.yPercent&&(l.yPercent=ja(A.yPercent,D.yPercent));else if("object"==typeof A){if(l={scaleX:ja(null!=A.scaleX?A.scaleX:A.scale,D.scaleX),scaleY:ja(null!=A.scaleY?A.scaleY:A.scale,D.scaleY),scaleZ:ja(A.scaleZ,D.scaleZ),x:ja(A.x,D.x),y:ja(A.y,D.y),z:ja(A.z,D.z),xPercent:ja(A.xPercent,D.xPercent),yPercent:ja(A.yPercent,D.yPercent),perspective:ja(A.transformPerspective,D.perspective)},p=A.directionalRotation,null!=p)if("object"==typeof p)for(m in p)A[m]=p[m];else A.rotation=p;"string"==typeof A.x&&-1!==A.x.indexOf("%")&&(l.x=0,l.xPercent=ja(A.x,D.xPercent)),"string"==typeof A.y&&-1!==A.y.indexOf("%")&&(l.y=0,l.yPercent=ja(A.y,D.yPercent)),l.rotation=ka("rotation"in A?A.rotation:"shortRotation"in A?A.shortRotation+"_short":"rotationZ"in A?A.rotationZ:D.rotation,D.rotation,"rotation",B),Fa&&(l.rotationX=ka("rotationX"in A?A.rotationX:"shortRotationX"in A?A.shortRotationX+"_short":D.rotationX||0,D.rotationX,"rotationX",B),l.rotationY=ka("rotationY"in A?A.rotationY:"shortRotationY"in A?A.shortRotationY+"_short":D.rotationY||0,D.rotationY,"rotationY",B)),l.skewX=ka(A.skewX,D.skewX),l.skewY=ka(A.skewY,D.skewY)}for(Fa&&null!=A.force3D&&(D.force3D=A.force3D,o=!0),n=D.force3D||D.z||D.rotationX||D.rotationY||l.z||l.rotationX||l.rotationY||l.perspective,n||null==A.scale||(l.scaleZ=1);--z>-1;)v=Ba[z],E=l[v]-D[v],(E>y||-y>E||null!=A[v]||null!=M[v])&&(o=!0,f=new ta(D,v,D[v],E,f),v in B&&(f.e=B[v]),f.xs0=0,f.plugin=h,d._overwriteProps.push(f.n));return E=A.transformOrigin,D.svg&&(E||A.svgOrigin)&&(s=D.xOffset,t=D.yOffset,La(a,ha(E),l,A.svgOrigin,A.smoothOrigin),f=ua(D,"xOrigin",(w?D:l).xOrigin,l.xOrigin,f,C),f=ua(D,"yOrigin",(w?D:l).yOrigin,l.yOrigin,f,C),(s!==D.xOffset||t!==D.yOffset)&&(f=ua(D,"xOffset",w?s:D.xOffset,D.xOffset,f,C),f=ua(D,"yOffset",w?t:D.yOffset,D.yOffset,f,C)),E="0px 0px"),(E||Fa&&n&&D.zOrigin)&&(Ca?(o=!0,v=Ea,E=(E||_(a,v,e,!1,"50% 50%"))+"",f=new ta(x,v,0,0,f,-1,C),f.b=x[v],f.plugin=h,Fa?(m=D.zOrigin,E=E.split(" "),D.zOrigin=(E.length>2&&(0===m||"0px"!==E[2])?parseFloat(E[2]):m)||0,f.xs0=f.e=E[0]+" "+(E[1]||"50%")+" 0px",f=new ta(D,"zOrigin",0,0,f,-1,f.n),f.b=m,f.xs0=f.e=D.zOrigin):f.xs0=f.e=E):ha(E+"",D)),o&&(d._transformType=D.svg&&Aa||!n&&3!==this._transformType?2:3),j&&(i[c]=j),k&&(i.scale=k),f},prefix:!0}),ya("boxShadow",{defaultValue:"0px 0px 0px 0px #999",prefix:!0,color:!0,multi:!0,keyword:"inset"}),ya("borderRadius",{defaultValue:"0px",parser:function(a,b,c,f,g,h){b=this.format(b);var i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y=["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],z=a.style;for(q=parseFloat(a.offsetWidth),r=parseFloat(a.offsetHeight),i=b.split(" "),j=0;j<y.length;j++)this.p.indexOf("border")&&(y[j]=Z(y[j])),m=l=_(a,y[j],e,!1,"0px"),-1!==m.indexOf(" ")&&(l=m.split(" "),m=l[0],l=l[1]),n=k=i[j],o=parseFloat(m),t=m.substr((o+"").length),u="="===n.charAt(1),u?(p=parseInt(n.charAt(0)+"1",10),n=n.substr(2),p*=parseFloat(n),s=n.substr((p+"").length-(0>p?1:0))||""):(p=parseFloat(n),s=n.substr((p+"").length)),""===s&&(s=d[c]||t),s!==t&&(v=aa(a,"borderLeft",o,t),w=aa(a,"borderTop",o,t),"%"===s?(m=v/q*100+"%",l=w/r*100+"%"):"em"===s?(x=aa(a,"borderLeft",1,"em"),m=v/x+"em",l=w/x+"em"):(m=v+"px",l=w+"px"),u&&(n=parseFloat(m)+p+s,k=parseFloat(l)+p+s)),g=va(z,y[j],m+" "+l,n+" "+k,!1,"0px",g);return g},prefix:!0,formatter:qa("0px 0px 0px 0px",!1,!0)}),ya("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius",{defaultValue:"0px",parser:function(a,b,c,d,f,g){return va(a.style,c,this.format(_(a,c,e,!1,"0px 0px")),this.format(b),!1,"0px",f)},prefix:!0,formatter:qa("0px 0px",!1,!0)}),ya("backgroundPosition",{defaultValue:"0 0",parser:function(a,b,c,d,f,g){var h,i,j,k,l,m,n="background-position",o=e||$(a,null),q=this.format((o?p?o.getPropertyValue(n+"-x")+" "+o.getPropertyValue(n+"-y"):o.getPropertyValue(n):a.currentStyle.backgroundPositionX+" "+a.currentStyle.backgroundPositionY)||"0 0"),r=this.format(b);if(-1!==q.indexOf("%")!=(-1!==r.indexOf("%"))&&r.split(",").length<2&&(m=_(a,"backgroundImage").replace(D,""),m&&"none"!==m)){for(h=q.split(" "),i=r.split(" "),R.setAttribute("src",m),j=2;--j>-1;)q=h[j],k=-1!==q.indexOf("%"),k!==(-1!==i[j].indexOf("%"))&&(l=0===j?a.offsetWidth-R.width:a.offsetHeight-R.height,h[j]=k?parseFloat(q)/100*l+"px":parseFloat(q)/l*100+"%");q=h.join(" ")}return this.parseComplex(a.style,q,r,f,g)},formatter:ha}),ya("backgroundSize",{defaultValue:"0 0",formatter:function(a){return a+="",ha(-1===a.indexOf(" ")?a+" "+a:a)}}),ya("perspective",{defaultValue:"0px",prefix:!0}),ya("perspectiveOrigin",{defaultValue:"50% 50%",prefix:!0}),ya("transformStyle",{prefix:!0}),ya("backfaceVisibility",{prefix:!0}),ya("userSelect",{prefix:!0}),ya("margin",{parser:ra("marginTop,marginRight,marginBottom,marginLeft")}),ya("padding",{parser:ra("paddingTop,paddingRight,paddingBottom,paddingLeft")}),ya("clip",{defaultValue:"rect(0px,0px,0px,0px)",parser:function(a,b,c,d,f,g){var h,i,j;return 9>p?(i=a.currentStyle,j=8>p?" ":",",h="rect("+i.clipTop+j+i.clipRight+j+i.clipBottom+j+i.clipLeft+")",b=this.format(b).split(",").join(j)):(h=this.format(_(a,this.p,e,!1,this.dflt)),b=this.format(b)),this.parseComplex(a.style,h,b,f,g)}}),ya("textShadow",{defaultValue:"0px 0px 0px #999",color:!0,multi:!0}),ya("autoRound,strictUnits",{parser:function(a,b,c,d,e){return e}}),ya("border",{defaultValue:"0px solid #000",parser:function(a,b,c,d,f,g){var h=_(a,"borderTopWidth",e,!1,"0px"),i=this.format(b).split(" "),j=i[0].replace(w,"");return"px"!==j&&(h=parseFloat(h)/aa(a,"borderTopWidth",1,j)+j),this.parseComplex(a.style,this.format(h+" "+_(a,"borderTopStyle",e,!1,"solid")+" "+_(a,"borderTopColor",e,!1,"#000")),i.join(" "),f,g)},color:!0,formatter:function(a){var b=a.split(" ");return b[0]+" "+(b[1]||"solid")+" "+(a.match(pa)||["#000"])[0]}}),ya("borderWidth",{parser:ra("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}),ya("float,cssFloat,styleFloat",{parser:function(a,b,c,d,e,f){var g=a.style,h="cssFloat"in g?"cssFloat":"styleFloat";return new ta(g,h,0,0,e,-1,c,!1,0,g[h],b)}});var Ua=function(a){var b,c=this.t,d=c.filter||_(this.data,"filter")||"",e=this.s+this.c*a|0;100===e&&(-1===d.indexOf("atrix(")&&-1===d.indexOf("radient(")&&-1===d.indexOf("oader(")?(c.removeAttribute("filter"),b=!_(this.data,"filter")):(c.filter=d.replace(z,""),b=!0)),b||(this.xn1&&(c.filter=d=d||"alpha(opacity="+e+")"),-1===d.indexOf("pacity")?0===e&&this.xn1||(c.filter=d+" alpha(opacity="+e+")"):c.filter=d.replace(x,"opacity="+e))};ya("opacity,alpha,autoAlpha",{defaultValue:"1",parser:function(a,b,c,d,f,g){var h=parseFloat(_(a,"opacity",e,!1,"1")),i=a.style,j="autoAlpha"===c;return"string"==typeof b&&"="===b.charAt(1)&&(b=("-"===b.charAt(0)?-1:1)*parseFloat(b.substr(2))+h),j&&1===h&&"hidden"===_(a,"visibility",e)&&0!==b&&(h=0),U?f=new ta(i,"opacity",h,b-h,f):(f=new ta(i,"opacity",100*h,100*(b-h),f),f.xn1=j?1:0,i.zoom=1,f.type=2,f.b="alpha(opacity="+f.s+")",f.e="alpha(opacity="+(f.s+f.c)+")",f.data=a,f.plugin=g,f.setRatio=Ua),j&&(f=new ta(i,"visibility",0,0,f,-1,null,!1,0,0!==h?"inherit":"hidden",0===b?"hidden":"inherit"),f.xs0="inherit",d._overwriteProps.push(f.n),d._overwriteProps.push(c)),f}});var Va=function(a,b){b&&(a.removeProperty?(("ms"===b.substr(0,2)||"webkit"===b.substr(0,6))&&(b="-"+b),a.removeProperty(b.replace(B,"-$1").toLowerCase())):a.removeAttribute(b))},Wa=function(a){if(this.t._gsClassPT=this,1===a||0===a){this.t.setAttribute("class",0===a?this.b:this.e);for(var b=this.data,c=this.t.style;b;)b.v?c[b.p]=b.v:Va(c,b.p),b=b._next;1===a&&this.t._gsClassPT===this&&(this.t._gsClassPT=null)}else this.t.getAttribute("class")!==this.e&&this.t.setAttribute("class",this.e)};ya("className",{parser:function(a,b,d,f,g,h,i){var j,k,l,m,n,o=a.getAttribute("class")||"",p=a.style.cssText;if(g=f._classNamePT=new ta(a,d,0,0,g,2),g.setRatio=Wa,g.pr=-11,c=!0,g.b=o,k=ca(a,e),l=a._gsClassPT){for(m={},n=l.data;n;)m[n.p]=1,n=n._next;l.setRatio(1)}return a._gsClassPT=g,g.e="="!==b.charAt(1)?b:o.replace(new RegExp("(?:\\s|^)"+b.substr(2)+"(?![\\w-])"),"")+("+"===b.charAt(0)?" "+b.substr(2):""),a.setAttribute("class",g.e),j=da(a,k,ca(a),i,m),a.setAttribute("class",o),g.data=j.firstMPT,a.style.cssText=p,g=g.xfirst=f.parse(a,j.difs,g,h)}});var Xa=function(a){if((1===a||0===a)&&this.data._totalTime===this.data._totalDuration&&"isFromStart"!==this.data.data){var b,c,d,e,f,g=this.t.style,h=i.transform.parse;if("all"===this.e)g.cssText="",e=!0;else for(b=this.e.split(" ").join("").split(","),d=b.length;--d>-1;)c=b[d],i[c]&&(i[c].parse===h?e=!0:c="transformOrigin"===c?Ea:i[c].p),Va(g,c);e&&(Va(g,Ca),f=this.t._gsTransform,f&&(f.svg&&(this.t.removeAttribute("data-svg-origin"),this.t.removeAttribute("transform")),delete this.t._gsTransform))}};for(ya("clearProps",{parser:function(a,b,d,e,f){return f=new ta(a,d,0,0,f,2),f.setRatio=Xa,f.e=b,f.pr=-10,f.data=e._tween,c=!0,f}}),j="bezier,throwProps,physicsProps,physics2D".split(","),wa=j.length;wa--;)za(j[wa]);j=g.prototype,j._firstPT=j._lastParsedTransform=j._transform=null,j._onInitTween=function(a,b,h,j){if(!a.nodeType)return!1;this._target=q=a,this._tween=h,this._vars=b,r=j,k=b.autoRound,c=!1,d=b.suffixMap||g.suffixMap,e=$(a,""),f=this._overwriteProps;var n,p,s,t,u,v,w,x,z,A=a.style;if(l&&""===A.zIndex&&(n=_(a,"zIndex",e),("auto"===n||""===n)&&this._addLazySet(A,"zIndex",0)),"string"==typeof b&&(t=A.cssText,n=ca(a,e),A.cssText=t+";"+b,n=da(a,n,ca(a)).difs,!U&&y.test(b)&&(n.opacity=parseFloat(RegExp.$1)),b=n,A.cssText=t),b.className?this._firstPT=p=i.className.parse(a,b.className,"className",this,null,null,b):this._firstPT=p=this.parse(a,b,null),this._transformType){for(z=3===this._transformType,Ca?m&&(l=!0,""===A.zIndex&&(w=_(a,"zIndex",e),("auto"===w||""===w)&&this._addLazySet(A,"zIndex",0)),o&&this._addLazySet(A,"WebkitBackfaceVisibility",this._vars.WebkitBackfaceVisibility||(z?"visible":"hidden"))):A.zoom=1,s=p;s&&s._next;)s=s._next;x=new ta(a,"transform",0,0,null,2),this._linkCSSP(x,null,s),x.setRatio=Ca?Ta:Sa,x.data=this._transform||Ra(a,e,!0),x.tween=h,x.pr=-1,f.pop()}if(c){for(;p;){for(v=p._next,s=t;s&&s.pr>p.pr;)s=s._next;(p._prev=s?s._prev:u)?p._prev._next=p:t=p,(p._next=s)?s._prev=p:u=p,p=v}this._firstPT=t}return!0},j.parse=function(a,b,c,f){var g,h,j,l,m,n,o,p,s,t,u=a.style;for(g in b){if(n=b[g],"function"==typeof n&&(n=n(r,q)),h=i[g])c=h.parse(a,n,g,this,c,f,b);else{if("--"===g.substr(0,2)){this._tween._propLookup[g]=this._addTween.call(this._tween,a.style,"setProperty",$(a).getPropertyValue(g)+"",n+"",g,!1,g);continue}m=_(a,g,e)+"",s="string"==typeof n,"color"===g||"fill"===g||"stroke"===g||-1!==g.indexOf("Color")||s&&A.test(n)?(s||(n=na(n),n=(n.length>3?"rgba(":"rgb(")+n.join(",")+")"),c=va(u,g,m,n,!0,"transparent",c,0,f)):s&&J.test(n)?c=va(u,g,m,n,!0,null,c,0,f):(j=parseFloat(m),o=j||0===j?m.substr((j+"").length):"",(""===m||"auto"===m)&&("width"===g||"height"===g?(j=ga(a,g,e),o="px"):"left"===g||"top"===g?(j=ba(a,g,e),o="px"):(j="opacity"!==g?0:1,o="")),t=s&&"="===n.charAt(1),t?(l=parseInt(n.charAt(0)+"1",10),n=n.substr(2),l*=parseFloat(n),p=n.replace(w,"")):(l=parseFloat(n),p=s?n.replace(w,""):""),""===p&&(p=g in d?d[g]:o),n=l||0===l?(t?l+j:l)+p:b[g],o!==p&&(""!==p||"lineHeight"===g)&&(l||0===l)&&j&&(j=aa(a,g,j,o),"%"===p?(j/=aa(a,g,100,"%")/100,b.strictUnits!==!0&&(m=j+"%")):"em"===p||"rem"===p||"vw"===p||"vh"===p?j/=aa(a,g,1,p):"px"!==p&&(l=aa(a,g,l,p),p="px"),t&&(l||0===l)&&(n=l+j+p)),t&&(l+=j),!j&&0!==j||!l&&0!==l?void 0!==u[g]&&(n||n+""!="NaN"&&null!=n)?(c=new ta(u,g,l||j||0,0,c,-1,g,!1,0,m,n),c.xs0="none"!==n||"display"!==g&&-1===g.indexOf("Style")?n:m):W("invalid "+g+" tween value: "+b[g]):(c=new ta(u,g,j,l-j,c,0,g,k!==!1&&("px"===p||"zIndex"===g),0,m,n),c.xs0=p))}f&&c&&!c.plugin&&(c.plugin=f)}return c},j.setRatio=function(a){var b,c,d,e=this._firstPT,f=1e-6;if(1!==a||this._tween._time!==this._tween._duration&&0!==this._tween._time)if(a||this._tween._time!==this._tween._duration&&0!==this._tween._time||this._tween._rawPrevTime===-1e-6)for(;e;){if(b=e.c*a+e.s,e.r?b=Math.round(b):f>b&&b>-f&&(b=0),e.type)if(1===e.type)if(d=e.l,2===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2;else if(3===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3;else if(4===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4;else if(5===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4+e.xn4+e.xs5;else{for(c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}else-1===e.type?e.t[e.p]=e.xs0:e.setRatio&&e.setRatio(a);else e.t[e.p]=b+e.xs0;e=e._next}else for(;e;)2!==e.type?e.t[e.p]=e.b:e.setRatio(a),e=e._next;else for(;e;){if(2!==e.type)if(e.r&&-1!==e.type)if(b=Math.round(e.s+e.c),e.type){if(1===e.type){for(d=e.l,c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}}else e.t[e.p]=b+e.xs0;else e.t[e.p]=e.e;else e.setRatio(a);e=e._next}},j._enableTransforms=function(a){this._transform=this._transform||Ra(this._target,e,!0),this._transformType=this._transform.svg&&Aa||!a&&3!==this._transformType?2:3};var Ya=function(a){this.t[this.p]=this.e,this.data._linkCSSP(this,this._next,null,!0)};j._addLazySet=function(a,b,c){var d=this._firstPT=new ta(a,b,0,0,this._firstPT,2);d.e=c,d.setRatio=Ya,d.data=this},j._linkCSSP=function(a,b,c,d){return a&&(b&&(b._prev=a),a._next&&(a._next._prev=a._prev),a._prev?a._prev._next=a._next:this._firstPT===a&&(this._firstPT=a._next,d=!0),c?c._next=a:d||null!==this._firstPT||(this._firstPT=a),a._next=b,a._prev=c),a},j._mod=function(a){for(var b=this._firstPT;b;)"function"==typeof a[b.p]&&a[b.p]===Math.round&&(b.r=1),b=b._next},j._kill=function(b){var c,d,e,f=b;if(b.autoAlpha||b.alpha){f={};for(d in b)f[d]=b[d];f.opacity=1,f.autoAlpha&&(f.visibility=1)}for(b.className&&(c=this._classNamePT)&&(e=c.xfirst,e&&e._prev?this._linkCSSP(e._prev,c._next,e._prev._prev):e===this._firstPT&&(this._firstPT=c._next),c._next&&this._linkCSSP(c._next,c._next._next,e._prev),this._classNamePT=null),c=this._firstPT;c;)c.plugin&&c.plugin!==d&&c.plugin._kill&&(c.plugin._kill(b),d=c.plugin),c=c._next;return a.prototype._kill.call(this,f)};var Za=function(a,b,c){var d,e,f,g;if(a.slice)for(e=a.length;--e>-1;)Za(a[e],b,c);else for(d=a.childNodes,e=d.length;--e>-1;)f=d[e],g=f.type,f.style&&(b.push(ca(f)),c&&c.push(f)),1!==g&&9!==g&&11!==g||!f.childNodes.length||Za(f,b,c)};return g.cascadeTo=function(a,c,d){var e,f,g,h,i=b.to(a,c,d),j=[i],k=[],l=[],m=[],n=b._internals.reservedProps;for(a=i._targets||i.target,Za(a,k,m),i.render(c,!0,!0),Za(a,l),i.render(0,!0,!0),i._enabled(!0),e=m.length;--e>-1;)if(f=da(m[e],k[e],l[e]),f.firstMPT){f=f.difs;for(g in d)n[g]&&(f[g]=d[g]);h={};for(g in f)h[g]=k[e][g];j.push(b.fromTo(m[e],c,h,f))}return j},a.activate([g]),g},!0),function(){var a=_gsScope._gsDefine.plugin({propName:"roundProps",version:"1.6.0",priority:-1,API:2,init:function(a,b,c){return this._tween=c,!0}}),b=function(a){for(;a;)a.f||a.blob||(a.m=Math.round),a=a._next},c=a.prototype;c._onInitAllProps=function(){for(var a,c,d,e=this._tween,f=e.vars.roundProps.join?e.vars.roundProps:e.vars.roundProps.split(","),g=f.length,h={},i=e._propLookup.roundProps;--g>-1;)h[f[g]]=Math.round;for(g=f.length;--g>-1;)for(a=f[g],c=e._firstPT;c;)d=c._next,c.pg?c.t._mod(h):c.n===a&&(2===c.f&&c.t?b(c.t._firstPT):(this._add(c.t,a,c.s,c.c),d&&(d._prev=c._prev),c._prev?c._prev._next=d:e._firstPT===c&&(e._firstPT=d),c._next=c._prev=null,e._propLookup[a]=i)),c=d;return!1},c._add=function(a,b,c,d){this._addTween(a,b,c,c+d,b,Math.round),this._overwriteProps.push(b)}}(),function(){_gsScope._gsDefine.plugin({propName:"attr",API:2,version:"0.6.1",init:function(a,b,c,d){var e,f;if("function"!=typeof a.setAttribute)return!1;for(e in b)f=b[e],"function"==typeof f&&(f=f(d,a)),this._addTween(a,"setAttribute",a.getAttribute(e)+"",f+"",e,!1,e),this._overwriteProps.push(e);return!0}})}(),_gsScope._gsDefine.plugin({propName:"directionalRotation",version:"0.3.1",API:2,init:function(a,b,c,d){"object"!=typeof b&&(b={rotation:b}),this.finals={};var e,f,g,h,i,j,k=b.useRadians===!0?2*Math.PI:360,l=1e-6;for(e in b)"useRadians"!==e&&(h=b[e],"function"==typeof h&&(h=h(d,a)),j=(h+"").split("_"),f=j[0],g=parseFloat("function"!=typeof a[e]?a[e]:a[e.indexOf("set")||"function"!=typeof a["get"+e.substr(3)]?e:"get"+e.substr(3)]()),h=this.finals[e]="string"==typeof f&&"="===f.charAt(1)?g+parseInt(f.charAt(0)+"1",10)*Number(f.substr(2)):Number(f)||0,i=h-g,j.length&&(f=j.join("_"),-1!==f.indexOf("short")&&(i%=k,i!==i%(k/2)&&(i=0>i?i+k:i-k)),-1!==f.indexOf("_cw")&&0>i?i=(i+9999999999*k)%k-(i/k|0)*k:-1!==f.indexOf("ccw")&&i>0&&(i=(i-9999999999*k)%k-(i/k|0)*k)),(i>l||-l>i)&&(this._addTween(a,e,g,g+i,e),this._overwriteProps.push(e)));return!0},set:function(a){var b;if(1!==a)this._super.setRatio.call(this,a);else for(b=this._firstPT;b;)b.f?b.t[b.p](this.finals[b.p]):b.t[b.p]=this.finals[b.p],b=b._next}})._autoCSS=!0,_gsScope._gsDefine("easing.Back",["easing.Ease"],function(a){var b,c,d,e=_gsScope.GreenSockGlobals||_gsScope,f=e.com.greensock,g=2*Math.PI,h=Math.PI/2,i=f._class,j=function(b,c){var d=i("easing."+b,function(){},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,d},k=a.register||function(){},l=function(a,b,c,d,e){var f=i("easing."+a,{easeOut:new b,easeIn:new c,easeInOut:new d},!0);return k(f,a),f},m=function(a,b,c){this.t=a,this.v=b,c&&(this.next=c,c.prev=this,this.c=c.v-b,this.gap=c.t-a)},n=function(b,c){var d=i("easing."+b,function(a){this._p1=a||0===a?a:1.70158,this._p2=1.525*this._p1},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,e.config=function(a){return new d(a)},d},o=l("Back",n("BackOut",function(a){return(a-=1)*a*((this._p1+1)*a+this._p1)+1}),n("BackIn",function(a){return a*a*((this._p1+1)*a-this._p1)}),n("BackInOut",function(a){return(a*=2)<1?.5*a*a*((this._p2+1)*a-this._p2):.5*((a-=2)*a*((this._p2+1)*a+this._p2)+2)})),p=i("easing.SlowMo",function(a,b,c){b=b||0===b?b:.7,null==a?a=.7:a>1&&(a=1),this._p=1!==a?b:0,this._p1=(1-a)/2,this._p2=a,this._p3=this._p1+this._p2,this._calcEnd=c===!0},!0),q=p.prototype=new a;return q.constructor=p,q.getRatio=function(a){var b=a+(.5-a)*this._p;return a<this._p1?this._calcEnd?1-(a=1-a/this._p1)*a:b-(a=1-a/this._p1)*a*a*a*b:a>this._p3?this._calcEnd?1===a?0:1-(a=(a-this._p3)/this._p1)*a:b+(a-b)*(a=(a-this._p3)/this._p1)*a*a*a:this._calcEnd?1:b},p.ease=new p(.7,.7),q.config=p.config=function(a,b,c){return new p(a,b,c)},b=i("easing.SteppedEase",function(a,b){a=a||1,this._p1=1/a,this._p2=a+(b?0:1),this._p3=b?1:0},!0),q=b.prototype=new a,q.constructor=b,q.getRatio=function(a){return 0>a?a=0:a>=1&&(a=.999999999),((this._p2*a|0)+this._p3)*this._p1},q.config=b.config=function(a,c){return new b(a,c)},c=i("easing.RoughEase",function(b){b=b||{};for(var c,d,e,f,g,h,i=b.taper||"none",j=[],k=0,l=0|(b.points||20),n=l,o=b.randomize!==!1,p=b.clamp===!0,q=b.template instanceof a?b.template:null,r="number"==typeof b.strength?.4*b.strength:.4;--n>-1;)c=o?Math.random():1/l*n,d=q?q.getRatio(c):c,"none"===i?e=r:"out"===i?(f=1-c,e=f*f*r):"in"===i?e=c*c*r:.5>c?(f=2*c,e=f*f*.5*r):(f=2*(1-c),e=f*f*.5*r),o?d+=Math.random()*e-.5*e:n%2?d+=.5*e:d-=.5*e,p&&(d>1?d=1:0>d&&(d=0)),j[k++]={x:c,y:d};for(j.sort(function(a,b){return a.x-b.x}),h=new m(1,1,null),n=l;--n>-1;)g=j[n],h=new m(g.x,g.y,h);this._prev=new m(0,0,0!==h.t?h:h.next)},!0),q=c.prototype=new a,q.constructor=c,q.getRatio=function(a){var b=this._prev;if(a>b.t){for(;b.next&&a>=b.t;)b=b.next;b=b.prev}else for(;b.prev&&a<=b.t;)b=b.prev;return this._prev=b,b.v+(a-b.t)/b.gap*b.c},q.config=function(a){return new c(a)},c.ease=new c,l("Bounce",j("BounceOut",function(a){return 1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375}),j("BounceIn",function(a){return(a=1-a)<1/2.75?1-7.5625*a*a:2/2.75>a?1-(7.5625*(a-=1.5/2.75)*a+.75):2.5/2.75>a?1-(7.5625*(a-=2.25/2.75)*a+.9375):1-(7.5625*(a-=2.625/2.75)*a+.984375)}),j("BounceInOut",function(a){var b=.5>a;return a=b?1-2*a:2*a-1,a=1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375,b?.5*(1-a):.5*a+.5})),l("Circ",j("CircOut",function(a){return Math.sqrt(1-(a-=1)*a)}),j("CircIn",function(a){return-(Math.sqrt(1-a*a)-1)}),j("CircInOut",function(a){return(a*=2)<1?-.5*(Math.sqrt(1-a*a)-1):.5*(Math.sqrt(1-(a-=2)*a)+1)})),d=function(b,c,d){var e=i("easing."+b,function(a,b){this._p1=a>=1?a:1,this._p2=(b||d)/(1>a?a:1),this._p3=this._p2/g*(Math.asin(1/this._p1)||0),this._p2=g/this._p2},!0),f=e.prototype=new a;return f.constructor=e,f.getRatio=c,f.config=function(a,b){return new e(a,b)},e},l("Elastic",d("ElasticOut",function(a){return this._p1*Math.pow(2,-10*a)*Math.sin((a-this._p3)*this._p2)+1},.3),d("ElasticIn",function(a){return-(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2))},.3),d("ElasticInOut",function(a){return(a*=2)<1?-.5*(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2)):this._p1*Math.pow(2,-10*(a-=1))*Math.sin((a-this._p3)*this._p2)*.5+1},.45)),l("Expo",j("ExpoOut",function(a){return 1-Math.pow(2,-10*a)}),j("ExpoIn",function(a){return Math.pow(2,10*(a-1))-.001}),j("ExpoInOut",function(a){return(a*=2)<1?.5*Math.pow(2,10*(a-1)):.5*(2-Math.pow(2,-10*(a-1)))})),l("Sine",j("SineOut",function(a){return Math.sin(a*h)}),j("SineIn",function(a){return-Math.cos(a*h)+1}),j("SineInOut",function(a){return-.5*(Math.cos(Math.PI*a)-1)})),i("easing.EaseLookup",{find:function(b){return a.map[b]}},!0),k(e.SlowMo,"SlowMo","ease,"),k(c,"RoughEase","ease,"),k(b,"SteppedEase","ease,"),o},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(a,b){"use strict";var c={},d=a.document,e=a.GreenSockGlobals=a.GreenSockGlobals||a;if(!e.TweenLite){var f,g,h,i,j,k=function(a){var b,c=a.split("."),d=e;for(b=0;b<c.length;b++)d[c[b]]=d=d[c[b]]||{};return d},l=k("com.greensock"),m=1e-10,n=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},o=function(){},p=function(){var a=Object.prototype.toString,b=a.call([]);return function(c){return null!=c&&(c instanceof Array||"object"==typeof c&&!!c.push&&a.call(c)===b)}}(),q={},r=function(d,f,g,h){this.sc=q[d]?q[d].sc:[],q[d]=this,this.gsClass=null,this.func=g;var i=[];this.check=function(j){for(var l,m,n,o,p=f.length,s=p;--p>-1;)(l=q[f[p]]||new r(f[p],[])).gsClass?(i[p]=l.gsClass,s--):j&&l.sc.push(this);if(0===s&&g){if(m=("com.greensock."+d).split("."),n=m.pop(),o=k(m.join("."))[n]=this.gsClass=g.apply(g,i),h)if(e[n]=c[n]=o,"undefined"!=typeof module&&module.exports)if(d===b){module.exports=c[b]=o;for(p in c)o[p]=c[p]}else c[b]&&(c[b][n]=o);else"function"=="function"&&__webpack_require__(240)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return o}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));for(p=0;p<this.sc.length;p++)this.sc[p].check()}},this.check(!0)},s=a._gsDefine=function(a,b,c,d){return new r(a,b,c,d)},t=l._class=function(a,b,c){return b=b||function(){},s(a,[],function(){return b},c),b};s.globals=e;var u=[0,0,1,1],v=t("easing.Ease",function(a,b,c,d){this._func=a,this._type=c||0,this._power=d||0,this._params=b?u.concat(b):u},!0),w=v.map={},x=v.register=function(a,b,c,d){for(var e,f,g,h,i=b.split(","),j=i.length,k=(c||"easeIn,easeOut,easeInOut").split(",");--j>-1;)for(f=i[j],e=d?t("easing."+f,null,!0):l.easing[f]||{},g=k.length;--g>-1;)h=k[g],w[f+"."+h]=w[h+f]=e[h]=a.getRatio?a:a[h]||new a};for(h=v.prototype,h._calcEnd=!1,h.getRatio=function(a){if(this._func)return this._params[0]=a,this._func.apply(null,this._params);var b=this._type,c=this._power,d=1===b?1-a:2===b?a:.5>a?2*a:2*(1-a);return 1===c?d*=d:2===c?d*=d*d:3===c?d*=d*d*d:4===c&&(d*=d*d*d*d),1===b?1-d:2===b?d:.5>a?d/2:1-d/2},f=["Linear","Quad","Cubic","Quart","Quint,Strong"],g=f.length;--g>-1;)h=f[g]+",Power"+g,x(new v(null,null,1,g),h,"easeOut",!0),x(new v(null,null,2,g),h,"easeIn"+(0===g?",easeNone":"")),x(new v(null,null,3,g),h,"easeInOut");w.linear=l.easing.Linear.easeIn,w.swing=l.easing.Quad.easeInOut;var y=t("events.EventDispatcher",function(a){this._listeners={},this._eventTarget=a||this});h=y.prototype,h.addEventListener=function(a,b,c,d,e){e=e||0;var f,g,h=this._listeners[a],k=0;for(this!==i||j||i.wake(),null==h&&(this._listeners[a]=h=[]),g=h.length;--g>-1;)f=h[g],f.c===b&&f.s===c?h.splice(g,1):0===k&&f.pr<e&&(k=g+1);h.splice(k,0,{c:b,s:c,up:d,pr:e})},h.removeEventListener=function(a,b){var c,d=this._listeners[a];if(d)for(c=d.length;--c>-1;)if(d[c].c===b)return void d.splice(c,1)},h.dispatchEvent=function(a){var b,c,d,e=this._listeners[a];if(e)for(b=e.length,b>1&&(e=e.slice(0)),c=this._eventTarget;--b>-1;)d=e[b],d&&(d.up?d.c.call(d.s||c,{type:a,target:c}):d.c.call(d.s||c))};var z=a.requestAnimationFrame,A=a.cancelAnimationFrame,B=Date.now||function(){return(new Date).getTime()},C=B();for(f=["ms","moz","webkit","o"],g=f.length;--g>-1&&!z;)z=a[f[g]+"RequestAnimationFrame"],A=a[f[g]+"CancelAnimationFrame"]||a[f[g]+"CancelRequestAnimationFrame"];t("Ticker",function(a,b){var c,e,f,g,h,k=this,l=B(),n=b!==!1&&z?"auto":!1,p=500,q=33,r="tick",s=function(a){var b,d,i=B()-C;i>p&&(l+=i-q),C+=i,k.time=(C-l)/1e3,b=k.time-h,(!c||b>0||a===!0)&&(k.frame++,h+=b+(b>=g?.004:g-b),d=!0),a!==!0&&(f=e(s)),d&&k.dispatchEvent(r)};y.call(k),k.time=k.frame=0,k.tick=function(){s(!0)},k.lagSmoothing=function(a,b){return arguments.length?(p=a||1/m,void(q=Math.min(b,p,0))):1/m>p},k.sleep=function(){null!=f&&(n&&A?A(f):clearTimeout(f),e=o,f=null,k===i&&(j=!1))},k.wake=function(a){null!==f?k.sleep():a?l+=-C+(C=B()):k.frame>10&&(C=B()-p+5),e=0===c?o:n&&z?z:function(a){return setTimeout(a,1e3*(h-k.time)+1|0)},k===i&&(j=!0),s(2)},k.fps=function(a){return arguments.length?(c=a,g=1/(c||60),h=this.time+g,void k.wake()):c},k.useRAF=function(a){return arguments.length?(k.sleep(),n=a,void k.fps(c)):n},k.fps(a),setTimeout(function(){"auto"===n&&k.frame<5&&"hidden"!==d.visibilityState&&k.useRAF(!1)},1500)}),h=l.Ticker.prototype=new l.events.EventDispatcher,h.constructor=l.Ticker;var D=t("core.Animation",function(a,b){if(this.vars=b=b||{},this._duration=this._totalDuration=a||0,this._delay=Number(b.delay)||0,this._timeScale=1,this._active=b.immediateRender===!0,this.data=b.data,this._reversed=b.reversed===!0,X){j||i.wake();var c=this.vars.useFrames?W:X;c.add(this,c._time),this.vars.paused&&this.paused(!0)}});i=D.ticker=new l.Ticker,h=D.prototype,h._dirty=h._gc=h._initted=h._paused=!1,h._totalTime=h._time=0,h._rawPrevTime=-1,h._next=h._last=h._onUpdate=h._timeline=h.timeline=null,h._paused=!1;var E=function(){j&&B()-C>2e3&&("hidden"!==d.visibilityState||!i.lagSmoothing())&&i.wake();var a=setTimeout(E,2e3);a.unref&&a.unref()};E(),h.play=function(a,b){return null!=a&&this.seek(a,b),this.reversed(!1).paused(!1)},h.pause=function(a,b){return null!=a&&this.seek(a,b),this.paused(!0)},h.resume=function(a,b){return null!=a&&this.seek(a,b),this.paused(!1)},h.seek=function(a,b){return this.totalTime(Number(a),b!==!1)},h.restart=function(a,b){return this.reversed(!1).paused(!1).totalTime(a?-this._delay:0,b!==!1,!0)},h.reverse=function(a,b){return null!=a&&this.seek(a||this.totalDuration(),b),this.reversed(!0).paused(!1)},h.render=function(a,b,c){},h.invalidate=function(){return this._time=this._totalTime=0,this._initted=this._gc=!1,this._rawPrevTime=-1,(this._gc||!this.timeline)&&this._enabled(!0),this},h.isActive=function(){var a,b=this._timeline,c=this._startTime;return!b||!this._gc&&!this._paused&&b.isActive()&&(a=b.rawTime(!0))>=c&&a<c+this.totalDuration()/this._timeScale-1e-7},h._enabled=function(a,b){return j||i.wake(),this._gc=!a,this._active=this.isActive(),b!==!0&&(a&&!this.timeline?this._timeline.add(this,this._startTime-this._delay):!a&&this.timeline&&this._timeline._remove(this,!0)),!1},h._kill=function(a,b){return this._enabled(!1,!1)},h.kill=function(a,b){return this._kill(a,b),this},h._uncache=function(a){for(var b=a?this:this.timeline;b;)b._dirty=!0,b=b.timeline;return this},h._swapSelfInParams=function(a){for(var b=a.length,c=a.concat();--b>-1;)"{self}"===a[b]&&(c[b]=this);return c},h._callback=function(a){var b=this.vars,c=b[a],d=b[a+"Params"],e=b[a+"Scope"]||b.callbackScope||this,f=d?d.length:0;switch(f){case 0:c.call(e);break;case 1:c.call(e,d[0]);break;case 2:c.call(e,d[0],d[1]);break;default:c.apply(e,d)}},h.eventCallback=function(a,b,c,d){if("on"===(a||"").substr(0,2)){var e=this.vars;if(1===arguments.length)return e[a];null==b?delete e[a]:(e[a]=b,e[a+"Params"]=p(c)&&-1!==c.join("").indexOf("{self}")?this._swapSelfInParams(c):c,e[a+"Scope"]=d),"onUpdate"===a&&(this._onUpdate=b)}return this},h.delay=function(a){return arguments.length?(this._timeline.smoothChildTiming&&this.startTime(this._startTime+a-this._delay),this._delay=a,this):this._delay},h.duration=function(a){return arguments.length?(this._duration=this._totalDuration=a,this._uncache(!0),this._timeline.smoothChildTiming&&this._time>0&&this._time<this._duration&&0!==a&&this.totalTime(this._totalTime*(a/this._duration),!0),this):(this._dirty=!1,this._duration)},h.totalDuration=function(a){return this._dirty=!1,arguments.length?this.duration(a):this._totalDuration},h.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),this.totalTime(a>this._duration?this._duration:a,b)):this._time},h.totalTime=function(a,b,c){if(j||i.wake(),!arguments.length)return this._totalTime;if(this._timeline){if(0>a&&!c&&(a+=this.totalDuration()),this._timeline.smoothChildTiming){this._dirty&&this.totalDuration();var d=this._totalDuration,e=this._timeline;if(a>d&&!c&&(a=d),this._startTime=(this._paused?this._pauseTime:e._time)-(this._reversed?d-a:a)/this._timeScale,e._dirty||this._uncache(!1),e._timeline)for(;e._timeline;)e._timeline._time!==(e._startTime+e._totalTime)/e._timeScale&&e.totalTime(e._totalTime,!0),e=e._timeline}this._gc&&this._enabled(!0,!1),(this._totalTime!==a||0===this._duration)&&(J.length&&Z(),this.render(a,b,!1),J.length&&Z())}return this},h.progress=h.totalProgress=function(a,b){var c=this.duration();return arguments.length?this.totalTime(c*a,b):c?this._time/c:this.ratio},h.startTime=function(a){return arguments.length?(a!==this._startTime&&(this._startTime=a,this.timeline&&this.timeline._sortChildren&&this.timeline.add(this,a-this._delay)),this):this._startTime},h.endTime=function(a){return this._startTime+(0!=a?this.totalDuration():this.duration())/this._timeScale},h.timeScale=function(a){if(!arguments.length)return this._timeScale;var b,c;for(a=a||m,this._timeline&&this._timeline.smoothChildTiming&&(b=this._pauseTime,c=b||0===b?b:this._timeline.totalTime(),this._startTime=c-(c-this._startTime)*this._timeScale/a),this._timeScale=a,c=this.timeline;c&&c.timeline;)c._dirty=!0,c.totalDuration(),c=c.timeline;return this},h.reversed=function(a){return arguments.length?(a!=this._reversed&&(this._reversed=a,this.totalTime(this._timeline&&!this._timeline.smoothChildTiming?this.totalDuration()-this._totalTime:this._totalTime,!0)),this):this._reversed},h.paused=function(a){if(!arguments.length)return this._paused;var b,c,d=this._timeline;return a!=this._paused&&d&&(j||a||i.wake(),b=d.rawTime(),c=b-this._pauseTime,!a&&d.smoothChildTiming&&(this._startTime+=c,
this._uncache(!1)),this._pauseTime=a?b:null,this._paused=a,this._active=this.isActive(),!a&&0!==c&&this._initted&&this.duration()&&(b=d.smoothChildTiming?this._totalTime:(b-this._startTime)/this._timeScale,this.render(b,b===this._totalTime,!0))),this._gc&&!a&&this._enabled(!0,!1),this};var F=t("core.SimpleTimeline",function(a){D.call(this,0,a),this.autoRemoveChildren=this.smoothChildTiming=!0});h=F.prototype=new D,h.constructor=F,h.kill()._gc=!1,h._first=h._last=h._recent=null,h._sortChildren=!1,h.add=h.insert=function(a,b,c,d){var e,f;if(a._startTime=Number(b||0)+a._delay,a._paused&&this!==a._timeline&&(a._pauseTime=a._startTime+(this.rawTime()-a._startTime)/a._timeScale),a.timeline&&a.timeline._remove(a,!0),a.timeline=a._timeline=this,a._gc&&a._enabled(!0,!0),e=this._last,this._sortChildren)for(f=a._startTime;e&&e._startTime>f;)e=e._prev;return e?(a._next=e._next,e._next=a):(a._next=this._first,this._first=a),a._next?a._next._prev=a:this._last=a,a._prev=e,this._recent=a,this._timeline&&this._uncache(!0),this},h._remove=function(a,b){return a.timeline===this&&(b||a._enabled(!1,!0),a._prev?a._prev._next=a._next:this._first===a&&(this._first=a._next),a._next?a._next._prev=a._prev:this._last===a&&(this._last=a._prev),a._next=a._prev=a.timeline=null,a===this._recent&&(this._recent=this._last),this._timeline&&this._uncache(!0)),this},h.render=function(a,b,c){var d,e=this._first;for(this._totalTime=this._time=this._rawPrevTime=a;e;)d=e._next,(e._active||a>=e._startTime&&!e._paused&&!e._gc)&&(e._reversed?e.render((e._dirty?e.totalDuration():e._totalDuration)-(a-e._startTime)*e._timeScale,b,c):e.render((a-e._startTime)*e._timeScale,b,c)),e=d},h.rawTime=function(){return j||i.wake(),this._totalTime};var G=t("TweenLite",function(b,c,d){if(D.call(this,c,d),this.render=G.prototype.render,null==b)throw"Cannot tween a null target.";this.target=b="string"!=typeof b?b:G.selector(b)||b;var e,f,g,h=b.jquery||b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType),i=this.vars.overwrite;if(this._overwrite=i=null==i?V[G.defaultOverwrite]:"number"==typeof i?i>>0:V[i],(h||b instanceof Array||b.push&&p(b))&&"number"!=typeof b[0])for(this._targets=g=n(b),this._propLookup=[],this._siblings=[],e=0;e<g.length;e++)f=g[e],f?"string"!=typeof f?f.length&&f!==a&&f[0]&&(f[0]===a||f[0].nodeType&&f[0].style&&!f.nodeType)?(g.splice(e--,1),this._targets=g=g.concat(n(f))):(this._siblings[e]=$(f,this,!1),1===i&&this._siblings[e].length>1&&aa(f,this,null,1,this._siblings[e])):(f=g[e--]=G.selector(f),"string"==typeof f&&g.splice(e+1,1)):g.splice(e--,1);else this._propLookup={},this._siblings=$(b,this,!1),1===i&&this._siblings.length>1&&aa(b,this,null,1,this._siblings);(this.vars.immediateRender||0===c&&0===this._delay&&this.vars.immediateRender!==!1)&&(this._time=-m,this.render(Math.min(0,-this._delay)))},!0),H=function(b){return b&&b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType)},I=function(a,b){var c,d={};for(c in a)U[c]||c in b&&"transform"!==c&&"x"!==c&&"y"!==c&&"width"!==c&&"height"!==c&&"className"!==c&&"border"!==c||!(!R[c]||R[c]&&R[c]._autoCSS)||(d[c]=a[c],delete a[c]);a.css=d};h=G.prototype=new D,h.constructor=G,h.kill()._gc=!1,h.ratio=0,h._firstPT=h._targets=h._overwrittenProps=h._startAt=null,h._notifyPluginsOfEnabled=h._lazy=!1,G.version="1.20.3",G.defaultEase=h._ease=new v(null,null,1,1),G.defaultOverwrite="auto",G.ticker=i,G.autoSleep=120,G.lagSmoothing=function(a,b){i.lagSmoothing(a,b)},G.selector=a.$||a.jQuery||function(b){var c=a.$||a.jQuery;return c?(G.selector=c,c(b)):"undefined"==typeof d?b:d.querySelectorAll?d.querySelectorAll(b):d.getElementById("#"===b.charAt(0)?b.substr(1):b)};var J=[],K={},L=/(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,M=/[\+-]=-?[\.\d]/,N=function(a){for(var b,c=this._firstPT,d=1e-6;c;)b=c.blob?1===a&&null!=this.end?this.end:a?this.join(""):this.start:c.c*a+c.s,c.m?b=c.m(b,this._target||c.t):d>b&&b>-d&&!c.blob&&(b=0),c.f?c.fp?c.t[c.p](c.fp,b):c.t[c.p](b):c.t[c.p]=b,c=c._next},O=function(a,b,c,d){var e,f,g,h,i,j,k,l=[],m=0,n="",o=0;for(l.start=a,l.end=b,a=l[0]=a+"",b=l[1]=b+"",c&&(c(l),a=l[0],b=l[1]),l.length=0,e=a.match(L)||[],f=b.match(L)||[],d&&(d._next=null,d.blob=1,l._firstPT=l._applyPT=d),i=f.length,h=0;i>h;h++)k=f[h],j=b.substr(m,b.indexOf(k,m)-m),n+=j||!h?j:",",m+=j.length,o?o=(o+1)%5:"rgba("===j.substr(-5)&&(o=1),k===e[h]||e.length<=h?n+=k:(n&&(l.push(n),n=""),g=parseFloat(e[h]),l.push(g),l._firstPT={_next:l._firstPT,t:l,p:l.length-1,s:g,c:("="===k.charAt(1)?parseInt(k.charAt(0)+"1",10)*parseFloat(k.substr(2)):parseFloat(k)-g)||0,f:0,m:o&&4>o?Math.round:0}),m+=k.length;return n+=b.substr(m),n&&l.push(n),l.setRatio=N,M.test(b)&&(l.end=null),l},P=function(a,b,c,d,e,f,g,h,i){"function"==typeof d&&(d=d(i||0,a));var j,k=typeof a[b],l="function"!==k?"":b.indexOf("set")||"function"!=typeof a["get"+b.substr(3)]?b:"get"+b.substr(3),m="get"!==c?c:l?g?a[l](g):a[l]():a[b],n="string"==typeof d&&"="===d.charAt(1),o={t:a,p:b,s:m,f:"function"===k,pg:0,n:e||b,m:f?"function"==typeof f?f:Math.round:0,pr:0,c:n?parseInt(d.charAt(0)+"1",10)*parseFloat(d.substr(2)):parseFloat(d)-m||0};return("number"!=typeof m||"number"!=typeof d&&!n)&&(g||isNaN(m)||!n&&isNaN(d)||"boolean"==typeof m||"boolean"==typeof d?(o.fp=g,j=O(m,n?parseFloat(o.s)+o.c:d,h||G.defaultStringFilter,o),o={t:j,p:"setRatio",s:0,c:1,f:2,pg:0,n:e||b,pr:0,m:0}):(o.s=parseFloat(m),n||(o.c=parseFloat(d)-o.s||0))),o.c?((o._next=this._firstPT)&&(o._next._prev=o),this._firstPT=o,o):void 0},Q=G._internals={isArray:p,isSelector:H,lazyTweens:J,blobDif:O},R=G._plugins={},S=Q.tweenLookup={},T=0,U=Q.reservedProps={ease:1,delay:1,overwrite:1,onComplete:1,onCompleteParams:1,onCompleteScope:1,useFrames:1,runBackwards:1,startAt:1,onUpdate:1,onUpdateParams:1,onUpdateScope:1,onStart:1,onStartParams:1,onStartScope:1,onReverseComplete:1,onReverseCompleteParams:1,onReverseCompleteScope:1,onRepeat:1,onRepeatParams:1,onRepeatScope:1,easeParams:1,yoyo:1,immediateRender:1,repeat:1,repeatDelay:1,data:1,paused:1,reversed:1,autoCSS:1,lazy:1,onOverwrite:1,callbackScope:1,stringFilter:1,id:1,yoyoEase:1},V={none:0,all:1,auto:2,concurrent:3,allOnStart:4,preexisting:5,"true":1,"false":0},W=D._rootFramesTimeline=new F,X=D._rootTimeline=new F,Y=30,Z=Q.lazyRender=function(){var a,b=J.length;for(K={};--b>-1;)a=J[b],a&&a._lazy!==!1&&(a.render(a._lazy[0],a._lazy[1],!0),a._lazy=!1);J.length=0};X._startTime=i.time,W._startTime=i.frame,X._active=W._active=!0,setTimeout(Z,1),D._updateRoot=G.render=function(){var a,b,c;if(J.length&&Z(),X.render((i.time-X._startTime)*X._timeScale,!1,!1),W.render((i.frame-W._startTime)*W._timeScale,!1,!1),J.length&&Z(),i.frame>=Y){Y=i.frame+(parseInt(G.autoSleep,10)||120);for(c in S){for(b=S[c].tweens,a=b.length;--a>-1;)b[a]._gc&&b.splice(a,1);0===b.length&&delete S[c]}if(c=X._first,(!c||c._paused)&&G.autoSleep&&!W._first&&1===i._listeners.tick.length){for(;c&&c._paused;)c=c._next;c||i.sleep()}}},i.addEventListener("tick",D._updateRoot);var $=function(a,b,c){var d,e,f=a._gsTweenID;if(S[f||(a._gsTweenID=f="t"+T++)]||(S[f]={target:a,tweens:[]}),b&&(d=S[f].tweens,d[e=d.length]=b,c))for(;--e>-1;)d[e]===b&&d.splice(e,1);return S[f].tweens},_=function(a,b,c,d){var e,f,g=a.vars.onOverwrite;return g&&(e=g(a,b,c,d)),g=G.onOverwrite,g&&(f=g(a,b,c,d)),e!==!1&&f!==!1},aa=function(a,b,c,d,e){var f,g,h,i;if(1===d||d>=4){for(i=e.length,f=0;i>f;f++)if((h=e[f])!==b)h._gc||h._kill(null,a,b)&&(g=!0);else if(5===d)break;return g}var j,k=b._startTime+m,l=[],n=0,o=0===b._duration;for(f=e.length;--f>-1;)(h=e[f])===b||h._gc||h._paused||(h._timeline!==b._timeline?(j=j||ba(b,0,o),0===ba(h,j,o)&&(l[n++]=h)):h._startTime<=k&&h._startTime+h.totalDuration()/h._timeScale>k&&((o||!h._initted)&&k-h._startTime<=2e-10||(l[n++]=h)));for(f=n;--f>-1;)if(h=l[f],2===d&&h._kill(c,a,b)&&(g=!0),2!==d||!h._firstPT&&h._initted){if(2!==d&&!_(h,b))continue;h._enabled(!1,!1)&&(g=!0)}return g},ba=function(a,b,c){for(var d=a._timeline,e=d._timeScale,f=a._startTime;d._timeline;){if(f+=d._startTime,e*=d._timeScale,d._paused)return-100;d=d._timeline}return f/=e,f>b?f-b:c&&f===b||!a._initted&&2*m>f-b?m:(f+=a.totalDuration()/a._timeScale/e)>b+m?0:f-b-m};h._init=function(){var a,b,c,d,e,f,g=this.vars,h=this._overwrittenProps,i=this._duration,j=!!g.immediateRender,k=g.ease;if(g.startAt){this._startAt&&(this._startAt.render(-1,!0),this._startAt.kill()),e={};for(d in g.startAt)e[d]=g.startAt[d];if(e.data="isStart",e.overwrite=!1,e.immediateRender=!0,e.lazy=j&&g.lazy!==!1,e.startAt=e.delay=null,e.onUpdate=g.onUpdate,e.onUpdateParams=g.onUpdateParams,e.onUpdateScope=g.onUpdateScope||g.callbackScope||this,this._startAt=G.to(this.target,0,e),j)if(this._time>0)this._startAt=null;else if(0!==i)return}else if(g.runBackwards&&0!==i)if(this._startAt)this._startAt.render(-1,!0),this._startAt.kill(),this._startAt=null;else{0!==this._time&&(j=!1),c={};for(d in g)U[d]&&"autoCSS"!==d||(c[d]=g[d]);if(c.overwrite=0,c.data="isFromStart",c.lazy=j&&g.lazy!==!1,c.immediateRender=j,this._startAt=G.to(this.target,0,c),j){if(0===this._time)return}else this._startAt._init(),this._startAt._enabled(!1),this.vars.immediateRender&&(this._startAt=null)}if(this._ease=k=k?k instanceof v?k:"function"==typeof k?new v(k,g.easeParams):w[k]||G.defaultEase:G.defaultEase,g.easeParams instanceof Array&&k.config&&(this._ease=k.config.apply(k,g.easeParams)),this._easeType=this._ease._type,this._easePower=this._ease._power,this._firstPT=null,this._targets)for(f=this._targets.length,a=0;f>a;a++)this._initProps(this._targets[a],this._propLookup[a]={},this._siblings[a],h?h[a]:null,a)&&(b=!0);else b=this._initProps(this.target,this._propLookup,this._siblings,h,0);if(b&&G._onPluginEvent("_onInitAllProps",this),h&&(this._firstPT||"function"!=typeof this.target&&this._enabled(!1,!1)),g.runBackwards)for(c=this._firstPT;c;)c.s+=c.c,c.c=-c.c,c=c._next;this._onUpdate=g.onUpdate,this._initted=!0},h._initProps=function(b,c,d,e,f){var g,h,i,j,k,l;if(null==b)return!1;K[b._gsTweenID]&&Z(),this.vars.css||b.style&&b!==a&&b.nodeType&&R.css&&this.vars.autoCSS!==!1&&I(this.vars,b);for(g in this.vars)if(l=this.vars[g],U[g])l&&(l instanceof Array||l.push&&p(l))&&-1!==l.join("").indexOf("{self}")&&(this.vars[g]=l=this._swapSelfInParams(l,this));else if(R[g]&&(j=new R[g])._onInitTween(b,this.vars[g],this,f)){for(this._firstPT=k={_next:this._firstPT,t:j,p:"setRatio",s:0,c:1,f:1,n:g,pg:1,pr:j._priority,m:0},h=j._overwriteProps.length;--h>-1;)c[j._overwriteProps[h]]=this._firstPT;(j._priority||j._onInitAllProps)&&(i=!0),(j._onDisable||j._onEnable)&&(this._notifyPluginsOfEnabled=!0),k._next&&(k._next._prev=k)}else c[g]=P.call(this,b,g,"get",l,g,0,null,this.vars.stringFilter,f);return e&&this._kill(e,b)?this._initProps(b,c,d,e,f):this._overwrite>1&&this._firstPT&&d.length>1&&aa(b,this,c,this._overwrite,d)?(this._kill(c,b),this._initProps(b,c,d,e,f)):(this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration)&&(K[b._gsTweenID]=!0),i)},h.render=function(a,b,c){var d,e,f,g,h=this._time,i=this._duration,j=this._rawPrevTime;if(a>=i-1e-7&&a>=0)this._totalTime=this._time=i,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1,this._reversed||(d=!0,e="onComplete",c=c||this._timeline.autoRemoveChildren),0===i&&(this._initted||!this.vars.lazy||c)&&(this._startTime===this._timeline._duration&&(a=0),(0>j||0>=a&&a>=-1e-7||j===m&&"isPause"!==this.data)&&j!==a&&(c=!0,j>m&&(e="onReverseComplete")),this._rawPrevTime=g=!b||a||j===a?a:m);else if(1e-7>a)this._totalTime=this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==h||0===i&&j>0)&&(e="onReverseComplete",d=this._reversed),0>a&&(this._active=!1,0===i&&(this._initted||!this.vars.lazy||c)&&(j>=0&&(j!==m||"isPause"!==this.data)&&(c=!0),this._rawPrevTime=g=!b||a||j===a?a:m)),(!this._initted||this._startAt&&this._startAt.progress())&&(c=!0);else if(this._totalTime=this._time=a,this._easeType){var k=a/i,l=this._easeType,n=this._easePower;(1===l||3===l&&k>=.5)&&(k=1-k),3===l&&(k*=2),1===n?k*=k:2===n?k*=k*k:3===n?k*=k*k*k:4===n&&(k*=k*k*k*k),1===l?this.ratio=1-k:2===l?this.ratio=k:.5>a/i?this.ratio=k/2:this.ratio=1-k/2}else this.ratio=this._ease.getRatio(a/i);if(this._time!==h||c){if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!c&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=this._totalTime=h,this._rawPrevTime=j,J.push(this),void(this._lazy=[a,b]);this._time&&!d?this.ratio=this._ease.getRatio(this._time/i):d&&this._ease._calcEnd&&(this.ratio=this._ease.getRatio(0===this._time?0:1))}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==h&&a>=0&&(this._active=!0),0===h&&(this._startAt&&(a>=0?this._startAt.render(a,!0,c):e||(e="_dummyGS")),this.vars.onStart&&(0!==this._time||0===i)&&(b||this._callback("onStart"))),f=this._firstPT;f;)f.f?f.t[f.p](f.c*this.ratio+f.s):f.t[f.p]=f.c*this.ratio+f.s,f=f._next;this._onUpdate&&(0>a&&this._startAt&&a!==-1e-4&&this._startAt.render(a,!0,c),b||(this._time!==h||d||c)&&this._callback("onUpdate")),e&&(!this._gc||c)&&(0>a&&this._startAt&&!this._onUpdate&&a!==-1e-4&&this._startAt.render(a,!0,c),d&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[e]&&this._callback(e),0===i&&this._rawPrevTime===m&&g!==m&&(this._rawPrevTime=0))}},h._kill=function(a,b,c){if("all"===a&&(a=null),null==a&&(null==b||b===this.target))return this._lazy=!1,this._enabled(!1,!1);b="string"!=typeof b?b||this._targets||this.target:G.selector(b)||b;var d,e,f,g,h,i,j,k,l,m=c&&this._time&&c._startTime===this._startTime&&this._timeline===c._timeline;if((p(b)||H(b))&&"number"!=typeof b[0])for(d=b.length;--d>-1;)this._kill(a,b[d],c)&&(i=!0);else{if(this._targets){for(d=this._targets.length;--d>-1;)if(b===this._targets[d]){h=this._propLookup[d]||{},this._overwrittenProps=this._overwrittenProps||[],e=this._overwrittenProps[d]=a?this._overwrittenProps[d]||{}:"all";break}}else{if(b!==this.target)return!1;h=this._propLookup,e=this._overwrittenProps=a?this._overwrittenProps||{}:"all"}if(h){if(j=a||h,k=a!==e&&"all"!==e&&a!==h&&("object"!=typeof a||!a._tempKill),c&&(G.onOverwrite||this.vars.onOverwrite)){for(f in j)h[f]&&(l||(l=[]),l.push(f));if((l||!a)&&!_(this,c,b,l))return!1}for(f in j)(g=h[f])&&(m&&(g.f?g.t[g.p](g.s):g.t[g.p]=g.s,i=!0),g.pg&&g.t._kill(j)&&(i=!0),g.pg&&0!==g.t._overwriteProps.length||(g._prev?g._prev._next=g._next:g===this._firstPT&&(this._firstPT=g._next),g._next&&(g._next._prev=g._prev),g._next=g._prev=null),delete h[f]),k&&(e[f]=1);!this._firstPT&&this._initted&&this._enabled(!1,!1)}}return i},h.invalidate=function(){return this._notifyPluginsOfEnabled&&G._onPluginEvent("_onDisable",this),this._firstPT=this._overwrittenProps=this._startAt=this._onUpdate=null,this._notifyPluginsOfEnabled=this._active=this._lazy=!1,this._propLookup=this._targets?{}:[],D.prototype.invalidate.call(this),this.vars.immediateRender&&(this._time=-m,this.render(Math.min(0,-this._delay))),this},h._enabled=function(a,b){if(j||i.wake(),a&&this._gc){var c,d=this._targets;if(d)for(c=d.length;--c>-1;)this._siblings[c]=$(d[c],this,!0);else this._siblings=$(this.target,this,!0)}return D.prototype._enabled.call(this,a,b),this._notifyPluginsOfEnabled&&this._firstPT?G._onPluginEvent(a?"_onEnable":"_onDisable",this):!1},G.to=function(a,b,c){return new G(a,b,c)},G.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new G(a,b,c)},G.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new G(a,b,d)},G.delayedCall=function(a,b,c,d,e){return new G(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,lazy:!1,useFrames:e,overwrite:0})},G.set=function(a,b){return new G(a,0,b)},G.getTweensOf=function(a,b){if(null==a)return[];a="string"!=typeof a?a:G.selector(a)||a;var c,d,e,f;if((p(a)||H(a))&&"number"!=typeof a[0]){for(c=a.length,d=[];--c>-1;)d=d.concat(G.getTweensOf(a[c],b));for(c=d.length;--c>-1;)for(f=d[c],e=c;--e>-1;)f===d[e]&&d.splice(c,1)}else if(a._gsTweenID)for(d=$(a).concat(),c=d.length;--c>-1;)(d[c]._gc||b&&!d[c].isActive())&&d.splice(c,1);return d||[]},G.killTweensOf=G.killDelayedCallsTo=function(a,b,c){"object"==typeof b&&(c=b,b=!1);for(var d=G.getTweensOf(a,b),e=d.length;--e>-1;)d[e]._kill(c,a)};var ca=t("plugins.TweenPlugin",function(a,b){this._overwriteProps=(a||"").split(","),this._propName=this._overwriteProps[0],this._priority=b||0,this._super=ca.prototype},!0);if(h=ca.prototype,ca.version="1.19.0",ca.API=2,h._firstPT=null,h._addTween=P,h.setRatio=N,h._kill=function(a){var b,c=this._overwriteProps,d=this._firstPT;if(null!=a[this._propName])this._overwriteProps=[];else for(b=c.length;--b>-1;)null!=a[c[b]]&&c.splice(b,1);for(;d;)null!=a[d.n]&&(d._next&&(d._next._prev=d._prev),d._prev?(d._prev._next=d._next,d._prev=null):this._firstPT===d&&(this._firstPT=d._next)),d=d._next;return!1},h._mod=h._roundProps=function(a){for(var b,c=this._firstPT;c;)b=a[this._propName]||null!=c.n&&a[c.n.split(this._propName+"_").join("")],b&&"function"==typeof b&&(2===c.f?c.t._applyPT.m=b:c.m=b),c=c._next},G._onPluginEvent=function(a,b){var c,d,e,f,g,h=b._firstPT;if("_onInitAllProps"===a){for(;h;){for(g=h._next,d=e;d&&d.pr>h.pr;)d=d._next;(h._prev=d?d._prev:f)?h._prev._next=h:e=h,(h._next=d)?d._prev=h:f=h,h=g}h=b._firstPT=e}for(;h;)h.pg&&"function"==typeof h.t[a]&&h.t[a]()&&(c=!0),h=h._next;return c},ca.activate=function(a){for(var b=a.length;--b>-1;)a[b].API===ca.API&&(R[(new a[b])._propName]=a[b]);return!0},s.plugin=function(a){if(!(a&&a.propName&&a.init&&a.API))throw"illegal plugin definition.";var b,c=a.propName,d=a.priority||0,e=a.overwriteProps,f={init:"_onInitTween",set:"setRatio",kill:"_kill",round:"_mod",mod:"_mod",initAll:"_onInitAllProps"},g=t("plugins."+c.charAt(0).toUpperCase()+c.substr(1)+"Plugin",function(){ca.call(this,c,d),this._overwriteProps=e||[]},a.global===!0),h=g.prototype=new ca(c);h.constructor=g,g.API=a.API;for(b in f)"function"==typeof a[b]&&(h[f[b]]=a[b]);return g.version=a.version,ca.activate([g]),g},f=a._gsQueue){for(g=0;g<f.length;g++)f[g]();for(h in q)q[h].func||a.console.log("GSAP encountered missing dependency: "+h)}j=!1}}("undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window,"TweenMax");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EventDispatcher = __webpack_require__(54);

    var _require = __webpack_require__(1384),
        LIGHTBOX_OPEN = _require.LIGHTBOX_OPEN,
        LIGHTBOX_CLOSE = _require.LIGHTBOX_CLOSE,
        LINK_VISIT = _require.LINK_VISIT,
        JAVASCRIPT_EXECUTE = _require.JAVASCRIPT_EXECUTE,
        PRODUCT_VIEW = _require.PRODUCT_VIEW,
        SCENE_NAVIGATE = _require.SCENE_NAVIGATE,
        IMAGE_VIEW = _require.IMAGE_VIEW,
        WIDGET_VIEW = _require.WIDGET_VIEW,
        SOCIAL_NETWORK_SHARE = _require.SOCIAL_NETWORK_SHARE,
        VIEWER_ERROR = _require.VIEWER_ERROR;

    /**
     * The singleton event bus used to trigger and/or listen for events internally to the Viewer <b>and</b>
     * Channels. <p>
     *
     * The event names defined here are <b>not</b> the analytics events tracked, but they may be the cause of
     * such tracked events. Internal events are generally coarse ("reusable"), primed with data describing
     * the internal context triggering the event, such as a PRODUCT_VIEWED event describing where or how the
     * product was viewed, e.g. "quickview", "link", etc. <p>
     *
     * All events are triggered with at least two arguments, in order: <ol>
     *
     * <li> <tt>source</tt>: the source of the event, e.g. the Link Action triggering an <tt>LINK_VISIT</tt>
     *                       event; never falsey.
     *
     * <li> <tt>experienceId</tt>: the id of the Experience currently viewed (especially needed by Channels).
     *
     * <li> <tt>varArgs</tt>: additional event specific var args, such as the <tt>LINK_VISIT</tt> supplying the
     *                        visited url as the third argument, or the <tt>PRODUCT_VIEW</tt> event supplying an
     *                        object like <tt>{type: "demandware", context: "quickview", productId: some-id}</tt>.
     *
     * </ul>
     *
     * A note on event naming: all event dispatching is synchronous, triggering listeners while the event is in
     * progress so to speak. For this reason, event constants and names are written in present tense.
     *
     * @class ViewerEvents
     * @constructor
     */


    var ViewerEvents = EventDispatcher.extend("ViewerEvents", {

        LIGHTBOX_OPEN: LIGHTBOX_OPEN,
        LIGHTBOX_CLOSE: LIGHTBOX_CLOSE,
        LINK_VISIT: LINK_VISIT,
        JAVASCRIPT_EXECUTE: JAVASCRIPT_EXECUTE,
        PRODUCT_VIEW: PRODUCT_VIEW,
        SCENE_NAVIGATE: SCENE_NAVIGATE,
        SOCIAL_NETWORK_SHARE: SOCIAL_NETWORK_SHARE,
        IMAGE_VIEW: IMAGE_VIEW,
        WIDGET_VIEW: WIDGET_VIEW,

        // E.g. on Action failing to be activated
        VIEWER_ERROR: VIEWER_ERROR

    });

    // Singleton
    return new ViewerEvents();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EditorEventFilters", function() { return EditorEventFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EditorEventFilters; });
var EditorEventFilters;
(function (EditorEventFilters) {
    EditorEventFilters["UNDO"] = "undo";
    EditorEventFilters["REDO"] = "redo";
    EditorEventFilters["GROUP"] = "group";
    EditorEventFilters["UNGROUP"] = "ungroup";
    EditorEventFilters["SUPERFICIAL"] = "superficial";
})(EditorEventFilters || (EditorEventFilters = {}));



/***/ }),
/* 155 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EventDispatcher = __webpack_require__(54);
    var Promise = __webpack_require__(21);
    var Preconditions = __webpack_require__(14);

    /**
     * Encapsulates a functionality. The <tt>execute</tt> method returns a deferred object to
     * support async and chainable actions.
     *
     * @class Action
     * @see  #execute
     * @see ActionSequence
     *
     * @author Kim
     */
    return EventDispatcher.extend({

        /**
         * Constructor.
         */
        constructor: function constructor() {
            // Make sure we have the right scope inside #execute
            this.execute = this.execute.bind(this);
        },


        /**
         * Whether the action is currently executable. Useful if the current logged in principal don't have permission.
         *
         * The default implementation returns <tt>true</tt>.
         *
         * @return {Boolean} Whether the action is currently executable.
         */
        executable: function executable() {
            return true;
        },


        /**
         * Starts executing the action.
         *
         * @return {Promise}
         *
         * @see ActionSequence
         */
        execute: function execute() {
            Preconditions.checkState(this.executable(), "Not allowed to execute action.");

            var value = this._performExecution.apply(this, arguments);

            return Promise.isPromise(value) ? value : Promise.resolved(value);
        },
        _performExecution: function _performExecution() {
            return Promise.resolved();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(1515);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(1543);
/* unused harmony reexport Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(1546);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(1547);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(816);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(539);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(1549);
/* unused harmony reexport ButtonToolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(1550);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(817);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(1560);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(1561);
/* unused harmony reexport Clearfix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloseButton__ = __webpack_require__(538);
/* unused harmony reexport CloseButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ControlLabel__ = __webpack_require__(1562);
/* unused harmony reexport ControlLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Col__ = __webpack_require__(1563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_14__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Collapse__ = __webpack_require__(542);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_15__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(389);
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownButton__ = __webpack_require__(1590);
/* unused harmony reexport DropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Fade__ = __webpack_require__(392);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form__ = __webpack_require__(1591);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormControl__ = __webpack_require__(1592);
/* unused harmony reexport FormControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormGroup__ = __webpack_require__(1595);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Glyphicon__ = __webpack_require__(541);
/* unused harmony reexport Glyphicon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Grid__ = __webpack_require__(828);
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HelpBlock__ = __webpack_require__(1596);
/* unused harmony reexport HelpBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Image__ = __webpack_require__(1597);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InputGroup__ = __webpack_require__(1598);
/* unused harmony reexport InputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Jumbotron__ = __webpack_require__(1601);
/* unused harmony reexport Jumbotron */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Label__ = __webpack_require__(1602);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroup__ = __webpack_require__(1603);
/* unused harmony reexport ListGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__ = __webpack_require__(829);
/* unused harmony reexport ListGroupItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Media__ = __webpack_require__(393);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(1610);
/* unused harmony reexport MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Modal__ = __webpack_require__(1611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_33__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalBody__ = __webpack_require__(836);
/* unused harmony reexport ModalBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalDialog__ = __webpack_require__(837);
/* unused harmony reexport ModalDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalFooter__ = __webpack_require__(838);
/* unused harmony reexport ModalFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalHeader__ = __webpack_require__(839);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ModalTitle__ = __webpack_require__(840);
/* unused harmony reexport ModalTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Nav__ = __webpack_require__(841);
/* unused harmony reexport Nav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Navbar__ = __webpack_require__(1637);
/* unused harmony reexport Navbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavbarBrand__ = __webpack_require__(842);
/* unused harmony reexport NavbarBrand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NavDropdown__ = __webpack_require__(1641);
/* unused harmony reexport NavDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__NavItem__ = __webpack_require__(843);
/* unused harmony reexport NavItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Overlay__ = __webpack_require__(844);
/* unused harmony reexport Overlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__OverlayTrigger__ = __webpack_require__(1648);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_45__OverlayTrigger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__PageHeader__ = __webpack_require__(1653);
/* unused harmony reexport PageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__PageItem__ = __webpack_require__(1654);
/* unused harmony reexport PageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Pager__ = __webpack_require__(1656);
/* unused harmony reexport Pager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Pagination__ = __webpack_require__(1657);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Panel__ = __webpack_require__(1659);
/* unused harmony reexport Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__PanelGroup__ = __webpack_require__(811);
/* unused harmony reexport PanelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Popover__ = __webpack_require__(1665);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_52__Popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ProgressBar__ = __webpack_require__(1666);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Radio__ = __webpack_require__(1667);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ResponsiveEmbed__ = __webpack_require__(1668);
/* unused harmony reexport ResponsiveEmbed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Row__ = __webpack_require__(1669);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_56__Row__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SafeAnchor__ = __webpack_require__(124);
/* unused harmony reexport SafeAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__SplitButton__ = __webpack_require__(1670);
/* unused harmony reexport SplitButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Tab__ = __webpack_require__(1672);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContainer__ = __webpack_require__(549);
/* unused harmony reexport TabContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__TabContent__ = __webpack_require__(550);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Table__ = __webpack_require__(1673);
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__TabPane__ = __webpack_require__(851);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Tabs__ = __webpack_require__(1674);
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Thumbnail__ = __webpack_require__(1675);
/* unused harmony reexport Thumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ToggleButton__ = __webpack_require__(852);
/* unused harmony reexport ToggleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ToggleButtonGroup__ = __webpack_require__(1676);
/* unused harmony reexport ToggleButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Tooltip__ = __webpack_require__(1677);
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Well__ = __webpack_require__(1678);
/* unused harmony reexport Well */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__utils__ = __webpack_require__(1679);
/* unused harmony reexport utils */















































































































































/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__merge__ = __webpack_require__(410);



function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var fn = function fn(props) {
    return styles.reduce(function (acc, style) {
      var output = style(props);

      if (output) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__merge__["a" /* default */])(acc, output);
      }

      return acc;
    }, {});
  }; // Alternative approach that doesn't yield any performance gain.
  // const handlers = styles.reduce((acc, style) => {
  //   style.filterProps.forEach(prop => {
  //     acc[prop] = style;
  //   });
  //   return acc;
  // }, {});
  // const fn = props => {
  //   return Object.keys(props).reduce((acc, prop) => {
  //     if (handlers[prop]) {
  //       return merge(acc, handlers[prop](props));
  //     }
  //     return acc;
  //   }, {});
  // };


  fn.propTypes =  false ? styles.reduce(function (acc, style) {
    return _extends(acc, style.propTypes);
  }, {}) : {};
  fn.filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (compose);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useEventCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CSSTransition__ = __webpack_require__(1858);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CSSTransition", function() { return __WEBPACK_IMPORTED_MODULE_0__CSSTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__ = __webpack_require__(1862);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReplaceTransition", function() { return __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__ = __webpack_require__(1864);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SwitchTransition", function() { return __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__ = __webpack_require__(922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Transition__ = __webpack_require__(572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Transition", function() { return __WEBPACK_IMPORTED_MODULE_4__Transition__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(920);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "config", function() { return __WEBPACK_IMPORTED_MODULE_5__config__["a"]; });







/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(2011)["default"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
});

var _utils = __webpack_require__(570);

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule generateRandomKey
 * @format
 * 
 */



var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key = void 0;
  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }
  seenKeys[key] = true;
  return key;
}

module.exports = generateRandomKey;

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CacheProvider", function() { return CacheProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClassNames", function() { return ClassNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Global", function() { return Global; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeContext", function() { return ThemeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jsx", function() { return jsx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withEmotionCache", function() { return withEmotionCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(2197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_cache__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_utils__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_serialize__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_sheet__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emotion_css__ = __webpack_require__(274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return __WEBPACK_IMPORTED_MODULE_6__emotion_css__["a"]; });









var EmotionCacheContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? Object(__WEBPACK_IMPORTED_MODULE_2__emotion_cache__["a" /* default */])() : null);
var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])({});
var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  var render = function render(props, ref) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(EmotionCacheContext.Consumer, null, function (cache) {
      return func(props, cache, ref);
    });
  }; // $FlowFixMe


  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(render);
};

// thus we only need to replace what is a valid character for JS, but not for CSS

var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
  return identifier.replace(/\$/g, '-');
};

var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var hasOwnProperty = Object.prototype.hasOwnProperty;

var render = function render(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
  // not passing the registered cache to serializeStyles because it would
  // make certain babel optimisations not possible

  if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
    cssProp = cache.registered[cssProp];
  }

  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = '';

  if (typeof props.className === 'string') {
    className = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["a" /* getRegisteredStyles */])(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])(registeredStyles);

  if (false) {
    var labelFromStack = props[labelPropName];

    if (labelFromStack) {
      serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
    }
  }

  var rules = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(cache, serialized, typeof type === 'string');
  className += cache.key + "-" + serialized.name;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && ("production" === 'production' || key !== labelPropName)) {
      newProps[key] = props[key];
    }
  }

  newProps.ref = ref;
  newProps.className = className;
  var ele = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(type, newProps);

  return ele;
};

var Emotion =
/* #__PURE__ */
withEmotionCache(function (props, cache, ref) {
  // use Context.read for the theme when it's stable
  if (typeof props.css === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
      return render(cache, props, theme, ref);
    });
  }

  return render(cache, props, null, ref);
});

if (false) {
  Emotion.displayName = 'EmotionCssPropInternal';
} // $FlowFixMe


var jsx = function jsx(type, props) {
  var args = arguments;

  if (props == null || !hasOwnProperty.call(props, 'css')) {
    // $FlowFixMe
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(undefined, args);
  }

  if (false) {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  var argsLength = args.length;
  var createElementArgArray = new Array(argsLength);
  createElementArgArray[0] = Emotion;
  var newProps = {};

  for (var key in props) {
    if (hasOwnProperty.call(props, key)) {
      newProps[key] = props[key];
    }
  }

  newProps[typePropName] = type;

  if (false) {
    var error = new Error();

    if (error.stack) {
      // chrome
      var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);

      if (!match) {
        // safari and firefox
        match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
      }

      if (match) {
        newProps[labelPropName] = sanitizeIdentifier(match[1]);
      }
    }
  }

  createElementArgArray[1] = newProps;

  for (var i = 2; i < argsLength; i++) {
    createElementArgArray[i] = args[i];
  } // $FlowFixMe


  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"].apply(null, createElementArgArray);
};

var warnedAboutCssPropForGlobal = false;
var Global =
/* #__PURE__ */
withEmotionCache(function (props, cache) {
  if (false) {
    console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?");
    warnedAboutCssPropForGlobal = true;
  }

  var styles = props.styles;

  if (typeof styles === 'function') {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
      var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])([styles(theme)]);
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
        serialized: serialized,
        cache: cache
      });
    });
  }

  var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])([styles]);
  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(InnerGlobal, {
    serialized: serialized,
    cache: cache
  });
});

// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var InnerGlobal =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_inheritsLoose___default()(InnerGlobal, _React$Component);

  function InnerGlobal(props, context, updater) {
    return _React$Component.call(this, props, context, updater) || this;
  }

  var _proto = InnerGlobal.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.sheet = new __WEBPACK_IMPORTED_MODULE_5__emotion_sheet__["a" /* StyleSheet */]({
      key: this.props.cache.key + "-global",
      nonce: this.props.cache.sheet.nonce,
      container: this.props.cache.sheet.container
    }); // $FlowFixMe

    var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");

    if (node !== null) {
      this.sheet.tags.push(node);
    }

    if (this.props.cache.sheet.tags.length) {
      this.sheet.before = this.props.cache.sheet.tags[0];
    }

    this.insertStyles();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.serialized.name !== this.props.serialized.name) {
      this.insertStyles();
    }
  };

  _proto.insertStyles = function insertStyles$1() {
    if (this.props.serialized.next !== undefined) {
      // insert keyframes
      Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(this.props.cache, this.props.serialized.next, true);
    }

    if (this.sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
      this.sheet.before = element;
      this.sheet.flush();
    }

    this.props.cache.insert("", this.props.serialized, this.sheet, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.sheet.flush();
  };

  _proto.render = function render() {

    return null;
  };

  return InnerGlobal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var keyframes = function keyframes() {
  var insertable = __WEBPACK_IMPORTED_MODULE_6__emotion_css__["a" /* default */].apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["a" /* getRegisteredStyles */])(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var ClassNames = withEmotionCache(function (props, context) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(ThemeContext.Consumer, null, function (theme) {
    var hasRendered = false;

    var css = function css() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('css can only be used during render');
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var serialized = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_serialize__["a" /* serializeStyles */])(args, context.registered);

      {
        Object(__WEBPACK_IMPORTED_MODULE_3__emotion_utils__["b" /* insertStyles */])(context, serialized, false);
      }

      return context.key + "-" + serialized.name;
    };

    var cx = function cx() {
      if (hasRendered && "production" !== 'production') {
        throw new Error('cx can only be used during render');
      }

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return merge(context.registered, css, classnames(args));
    };

    var content = {
      css: css,
      cx: cx,
      theme: theme
    };
    var ele = props.children(content);
    hasRendered = true;

    return ele;
  });
});




/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindow;
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);

    /**
     * Provider for creating URLs related to experience edit/preview used to navigate to the passed experience.
     *
     * @class ExperienceURLProvider
     * @author avi
     */
    return Class.extend({}, {

        /**
        * Experience specific actions.
        */
        ACTION: {
            EDIT: "edit",
            PREVIEW: "preview"
        },

        TYPES: {
            EXPERIENCE: "experience",
            TEMPLATE: "template"
        },

        /**
         * Provides the experienceURL to execute an experience action (e.g preview or edit).
         * @param {String} experienceId the experience ID for which to provide the URL, never null
         * @param {string} action the action to provide. See the ACTION Object
         * @param {Number|underfined} [sceneNumber] optional; the scene number. If it's not passed, it will default to the first scene.
         * @param {String|undefined} [layerName] optional; the layer `name` property. See LayerEnum.
         * @param {string} [experienceType=this.TYPES.EXPERIENCE]
         * @returns {String} the experience URL
         */
        provide: function provide(experienceId, action, sceneNumber, layerName) {
            var experienceType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.TYPES.EXPERIENCE;

            if (!sceneNumber) {
                sceneNumber = 1;
            }

            var sceneURL = experienceType + "/" + experienceId + "/" + action + "/" + sceneNumber;

            return layerName ? sceneURL + "/" + layerName : sceneURL;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(114);

var assertRecord = __webpack_require__(294);

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

module.exports = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(149);

// http://262.ecma-international.org/5.1/#sec-9.12

module.exports = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return $isNaN(x) && $isNaN(y);
};


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var EventDispatcher = __webpack_require__(54);
    var Marionette = __webpack_require__(10);

    /**
     * Represents a view scope, shared by the parent view and all it's children.
     *
     * By subclassing <tt>ImprovedView</tt>, you'll be able to declare a <tt>viewScope</tt>
     * object (or function returning an object), containing properties and functions that will be exposed for the entire view
     * hierarchy. Providing a simple communication channel between the parent view and it's children.
     *
     * @see  Region
     *
     * @author Kim
     * @class  ViewScope
     * @constructor
     */
    var ViewScope = EventDispatcher.extend({}, {

        _topLevelViewScope: null,

        /**
         * Get parent view scope of a target(either a region or view)
         * @param {Region | View} target
         * @returns {*|viewScope|viewScope|viewScope}
         * @private
         */
        _getParentViewScope: function _getParentViewScope(target) {
            var topLevelViewScope = ViewScope._topLevelViewScope || new ViewScope();

            if (target instanceof Marionette.Region) {
                var parentView = target.parentView;

                // If the viewScope is a function, run it.
                // Default to the parentView.viewScope, which may be from its parent view
                return parentView ? _.result(parentView, "viewScope", parentView.viewScope) : topLevelViewScope;
            }

            return target.viewScope ? target.viewScope : topLevelViewScope;
        },


        /**
         * Defines the top level view scope.
         *
         * @param {Function|Object} viewScope the top level view scope.
         */
        setTopLevelViewScope: function setTopLevelViewScope(viewScope) {
            ViewScope._topLevelViewScope = viewScope;
        },


        /**
         * Register a viewScope for a view and also set up the viewScope hierarchy.
         * @param {Region|View} target
         * @param {View}        view
         */
        register: function register(target, view) {
            // If there's no parent view, we assume to be at the top level
            var parentViewScope = ViewScope._getParentViewScope(target);

            if (view.viewScope) {
                // Create or re-create the view scope. We have to re-create the scope since properties already created
                // for it may have changed, for example if a property reflects a changed principal permission...
                view.viewScope = this._createScope(view, view.viewScope) || // first time
                this._createScope(view, view.viewScope._factory) || // re-render
                view.viewScope; // default
                // We no longer need the 'inherit' property
                delete view.viewScope.inherit;
                // Guarantee scope/context belongs to the right object
                _.functions(view.viewScope).forEach(function (functionName) {
                    view.viewScope[functionName] = _.bind(view.viewScope[functionName], view);
                });
            }

            // Store the view scope on the added view
            view.viewScope = _.extend(view.viewScope || new ViewScope(), parentViewScope);
        },
        _createScope: function _createScope(view, scope) {
            var viewScope = void 0;

            if (_.isFunction(scope)) {
                viewScope = scope.call(view);
                viewScope._factory = scope;
            } else {
                // Assuming the view scope is a plain object, create a new (cloned) object so we don't
                // alter the prototype.
                viewScope = _.clone(scope);
            }

            return viewScope;
        }
    });

    return ViewScope;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);

    /**
     * The animation model.
     *
     * @class AnimationModel
     * @constructor
     */
    return Backbone.Model.extend({
        defaults: {
            delay: 1000,
            duration: 1000,
            easing: "linear"
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);
    var Backbone = __webpack_require__(7);
    var WidgetCollection = __webpack_require__(501);

    /**
     * Model for a composite widget.
     *
     * @class CompositeWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("CompositeWidgetModel", {

        relations: (AbstractWidgetModel.prototype.relations || []).concat([{
            type: Backbone.Many,
            key: "group",
            collectionType: WidgetCollection
        }]),

        defaults: _.defaults({
            type: "composite"
        }, AbstractWidgetModel.prototype.defaults),

        _hasPositionOffset: false, // Keep track of bounding box translations state

        initialize: function initialize() {
            var _this = this;

            this.listenTo(this, "change:scale", function (model, value) {
                _this._scaleGroup(value);
            });

            this.__super();
        },


        /**
         * Define size and position of the composite model
         * and update the position of its group widgets
         * to compensate for the position offset
         *
         * @param {Object} setSizeAndPosition Size and position properties (left, top, width and height)
         * @param {Boolean} forceUpdate True to set size and position regardless of current state
         */
        setSizeAndPosition: function setSizeAndPosition(sizeAndPosition, forceUpdate) {
            if (this._hasPositionOffset && !forceUpdate) {
                return;
            }

            this.set({
                left: sizeAndPosition.left + this.get("left"),
                top: sizeAndPosition.top + this.get("top"),
                width: sizeAndPosition.width,
                height: sizeAndPosition.height
            }, {
                cause: "group" // Don't trigger change to the activity manager (undo/redo)
            });

            // Translate group widgets to compensate for the position offset
            this._setGroupPositionOffset({
                left: sizeAndPosition.left,
                top: sizeAndPosition.top
            });

            this._hasPositionOffset = true;
        },
        _setGroupPositionOffset: function _setGroupPositionOffset(positionOffset) {
            this.get("group").each(function (groupWidget) {
                groupWidget.set({
                    top: groupWidget.get("top") - positionOffset.top,
                    left: groupWidget.get("left") - positionOffset.left
                }, {
                    cause: "group" // Don't trigger change to the activity manager (undo/redo)
                });
            });
        },


        /**
         * Reset the position offset done to each widget
         */
        resetGroupPositionOffset: function resetGroupPositionOffset() {
            var _this2 = this;

            if (!this._hasPositionOffset) {
                return;
            }

            this.get("group").each(function (groupWidget) {
                groupWidget.set({
                    top: groupWidget.get("top") + _this2.get("top"),
                    left: groupWidget.get("left") + _this2.get("left")
                }, {
                    cause: "group"
                });
            });

            this._hasPositionOffset = false;
        },
        _scaleGroup: function _scaleGroup(scale) {
            this.get("group").invoke("set", "scale", scale);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* global com */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var TweenMax = __webpack_require__(152);
    var EasingTypes = __webpack_require__(175);
    var Browser = __webpack_require__(39);
    var Preconditions = __webpack_require__(14);
    var _ = __webpack_require__(1);

    // Import/include TweenMax dependencies
    __webpack_require__(1428);
    __webpack_require__(1429);

    /**
     * Describes the different kinds of animations.
     * @see  #type
     * @type {Object}
     */
    var Type = {
        STANDARD: "standard",
        INTRO: "intro",
        OUTRO: "outro"
    };

    /**
     * Returns the (TweenMax) easing object given the html valid name.
     *
     * @param {String} modelValue The htmlValidName of the easing type.
     * @returns {Object} the (TweenMax) easing object given the html valid name.
     */
    function toGSAPEasingType(modelValue) {
        var easing = com.greensock.easing;

        var value = void 0;

        switch (modelValue) {
            case EasingTypes.LINEAR.htmlValidName:
                value = easing.Linear.easeIn;
                break;

            case EasingTypes.EASE_IN.htmlValidName:
                value = easing.Quad.easeIn;
                break;

            case EasingTypes.EASE_OUT.htmlValidName:
                value = easing.Quad.easeOut;
                break;

            case EasingTypes.EASE_IN_OUT.htmlValidName:
                value = easing.Quad.easeInOut;
                break;

            case EasingTypes.BOUNCE.htmlValidName:
                value = easing.Bounce.easeOut;
                break;

            case EasingTypes.ELASTIC.htmlValidName:
                value = easing.Elastic.easeOut;
                break;

            case EasingTypes.BACK_OUT.htmlValidName:
                value = easing.Back.easeOut;
                break;
            default:
                value = easing.Linear.easeIn;
                break;
        }

        return value;
    }

    /**
     * The abstract animation controller.
     *
     * @class AnimationController
     * @constructor
     *
     * @param {AnimationModel} animationModel The animation model.
     * @param {AbstractWidgetView} widgetView The widget to animate.
     * @param {Object} [unscaledExperienceSize] The size of the parent experience, e.g. {width: 800, height: 600}
     * @param {Boolean} [immediateRender] Whether potential "from" values should be rendered/applied
     * immediately. See http://api.greensock.com/js/ for more info.
     */
    return Marionette.Controller.extend({

        /**
         * The animation type, defaulting to <tt>Type.STANDARD</tt>. E.g. for animations fading out or
         * sliding out, the type would be <tt>Type.OUTRO</tt>.
         *
         * @type {String}
         */
        type: Type.STANDARD,

        /**
         * Internal state for whether the animation has been started.
         * @type {Boolean}
         */
        _started: false,

        /**
         * Stores the timeout ID returned by setTimeout - used for managing the delay, if any.
         *
         * @type {Number}
         */
        _timeoutID: null,

        constructor: function constructor(options) {
            this.__super();

            this.animationModel = options.animationModel;
            this.widgetView = options.widgetView;
            this.widgetModel = options.widgetView.model;
            this.element = options.widgetView.el;
            this.elementRect = options.widgetView.getRect();
            this.elementBounds = options.widgetView.getBoundingBox();
            this.unscaledExperienceSize = options.unscaledExperienceSize;
            this.immediateRender = options.immediateRender;
            // We need the duration in seconds
            this.duration = options.animationModel.get("duration") / 1000;
            this.delay = options.animationModel.get("delay");
            this.easing = toGSAPEasingType(options.animationModel.get("easing"));
            this.positionOffset = this.options.positionOffset;

            this.init();
        },
        _getTweenLiteMethodName: function _getTweenLiteMethodName(animationDescriptor) {
            for (var p in animationDescriptor) {
                if (animationDescriptor.hasOwnProperty(p)) {
                    return p;
                }
            }

            return null;
        },
        _getTweenDescriptor: function _getTweenDescriptor() {
            var animationDescriptor = this.descriptor();
            var methodName = this._getTweenLiteMethodName(animationDescriptor);
            var animationDescriptorValue = animationDescriptor[methodName];
            var tweenFunction = TweenMax[methodName];
            var descriptor = {
                tweenFunction: tweenFunction,
                vars: animationDescriptorValue,
                immediateRender: this.immediateRender && methodName !== "to"
            };

            // roundProps to force transform: translate3d to integer values
            var roundProps = { roundProps: "x,y" };

            if (methodName === "fromTo") {
                // Expecting 'animationDescriptorValue' to be an array of 'fromVars' and 'toVars'
                descriptor.from = _.extend(animationDescriptorValue[0], roundProps);
                descriptor.to = _.extend(animationDescriptorValue[1], roundProps);
            } else {
                descriptor.to = _.extend(animationDescriptorValue, roundProps);
            }

            return descriptor;
        },
        _disposeAnimation: function _disposeAnimation() {
            if (this.animation) {
                this.animation.kill();
                this.animation = null;
            }
        },
        init: function init() {
            // Prepare descriptor for the TweenMax API
            var animationDescriptor = this._getTweenDescriptor();
            var defaultDescriptor = {
                force3D: Browser.capabilities.is3dAnimationsSupported, /* see http://api.greensock.com/js/ */
                paused: true,
                ease: this.easing
            };
            var tweenFunction = animationDescriptor.tweenFunction;
            var tweenLiteDescriptor = _.extend(defaultDescriptor, animationDescriptor.to);

            // Method signature is different when using "fromTo" - see http://api.greensock.com/js/
            if (animationDescriptor.from) {
                var _elementRect = this.elementRect,
                    x = _elementRect.x,
                    y = _elementRect.y;
                // For some reason it seems we need to preserve rotation, x and y when using 'fromTo'?

                _.defaults(animationDescriptor.from, { rotation: this.widgetModel.get("rotation"), x: x, y: y });

                // Even though we set 'immediateRender' to true, we still experience a brief flicker of
                // the end state on some devices when using 'fromTo' (MOS-1650)
                if (tweenLiteDescriptor.immediateRender) {
                    TweenMax.set(this.element, animationDescriptor.from);
                }

                this.animation = tweenFunction(this.element, this.duration, animationDescriptor.from, tweenLiteDescriptor);
            } else {
                // Create the animation instance
                this.animation = tweenFunction(this.element, this.duration, tweenLiteDescriptor);
            }
        },


        /**
         * Recalculates and updates target tween values from the current state of the
         * associated widget view (AbstractWidgetView#getRect).
         *
         * @see  _getTweenDescriptor
         */
        invalidate: function invalidate() {
            this.elementRect = this.widgetView.getRect();
            this.elementBounds = this.widgetView.getBoundingBox();

            var animationDescriptor = this._getTweenDescriptor();
            var _elementRect2 = this.elementRect,
                x = _elementRect2.x,
                y = _elementRect2.y;

            var params = {
                css: animationDescriptor.to,
                startAt: animationDescriptor.from || { x: x, y: y }
            };

            // http://greensock.com/docs/#/HTML5/GSAP/TweenMax/updateTo/
            this.animation.invalidate().updateTo(params);
        },


        /**
         * Describes the animation.
         *
         * This is an abstract method that must be overridden by it's subclass.
         *
         * @return {Object} Object describing the animation, in the from:<p>
         *
         * <tt>{from: {opacity: 0}}</tt>
         */
        descriptor: function descriptor() {
            Preconditions.abstractMethodError();
        },


        /**
         * Calculates the size and offset of any "styles" applied to the assosiated widget.
         *
         * @return {Object} An object representing the size and position of the styling element.
         */
        calculateStylingRect: function calculateStylingRect() {
            var size = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };

            if (this.widgetModel.has("boxShadow")) {
                var boxShadow = this.widgetModel.get("boxShadow").match(/(-?\d+px)/g);
                var shadowOffsetY = parseInt(boxShadow[0], 10);
                var shadowOffsetX = parseInt(boxShadow[1], 10);
                var shadowBlur = parseInt(boxShadow[2], 10);
                var shadowSpread = parseInt(boxShadow[3], 10);

                size.width = size.height = shadowBlur + shadowSpread;
                size.x = shadowOffsetX;
                size.y = shadowOffsetY;
            }

            return size;
        },


        /**
         * Returns a descriptor object describing the current appearance
         * (i.e. position and pivot point) of the widget.
         *
         * @return {Object} a descriptor object describing the current appearance
         * (i.e. position and pivot point) of the widget.
         */
        getAppearanceDescriptor: function getAppearanceDescriptor() {
            return {
                scale: this.widgetModel.get("scale"),

                styling: this.calculateStylingRect(),

                position: {
                    x: this.elementRect.x,
                    y: this.elementRect.y
                },

                pivotOffset: {
                    width: (this.elementBounds.width - this.elementRect.width) / 2,
                    height: (this.elementBounds.height - this.elementRect.height) / 2
                },

                positionOffset: {
                    x: this.positionOffset.left,
                    y: this.positionOffset.top
                }
            };
        },


        /**
         * Starts the animation.
         */
        start: function start() {
            if (this._started) {
                return;
            }

            this._started = true;
            // Start the animation in 'this.delay' milliseconds
            this._timeoutID = setTimeout(this.animation.play.bind(this.animation), this.delay);
        },


        /**
         * Stops the animation.
         */
        stop: function stop() {
            if (!this._started) {
                return;
            }

            this._started = false;

            // Clear the timeout callback
            clearTimeout(this._timeoutID);

            // Reset the animation in a paused state
            this.animation.paused(true).totalTime(0);
        },
        paused: function paused(value) {
            return this.animation.paused(value);
        },


        /**
         * Indicates whether or not the animation is currently
         * active (meaning the virtual playhead is actively moving across this
         * instance's time span and it is not paused, nor are any of its
         * ancestor timelines).
         *
         * @return {Boolean} Whether or not the animation is currently active.
         */
        isActive: function isActive() {
            return this.animation.isActive();
        },


        /**
         * Whether the animation has completed.
         *
         * @return {Boolean} <tt>true</tt> if the animation has completed, <tt>false</tt> if not.
         */
        isComplete: function isComplete() {
            return this.animation.time() === this.animation.totalDuration();
        },


        /**
         * Whether the animation is running (has been started), regardless of any delays.
         *
         * @return {Boolean} <tt>true</tt> if the animation has been started and is not completed yet.
         */
        isRunning: function isRunning() {
            return this._started && !this.isComplete();
        },
        onClose: function onClose() {
            this._disposeAnimation();
        }
    }, {
        Type: Type
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);

    var easingTypes = {
        LINEAR: {
            displayName: "Linear",
            htmlValidName: "linear"
        },
        EASE_IN: {
            displayName: "Ease in",
            htmlValidName: "ease-in"
        },
        EASE_OUT: {
            displayName: "Ease out",
            htmlValidName: "ease-out"
        },
        EASE_IN_OUT: {
            displayName: "Ease in and out",
            htmlValidName: "ease-in-and-out"
        },
        BOUNCE: {
            displayName: "Bounce",
            htmlValidName: "bounce"
        },
        ELASTIC: {
            displayName: "Elastic",
            htmlValidName: "elastic"
        },

        BACK_OUT: {
            displayName: "Back Out",
            htmlValidName: "back-out"
        }
    };

    /**
     * The available easing types.
     *
     * @class EasingTypes
     */
    return _.extend({}, easingTypes, {
        /**
         * Gets the easing types as an array of objects containing displayName and htmlValidName
         * for all of the supported easing types.
         *
         * @returns {Array} array of objects containing displayName and htmlValidName
         * for all of the supported easing types.
         */
        getAsArray: function getAsArray() {
            return _.values(easingTypes);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var FontLoader = __webpack_require__(260);
    var FontProvider = __webpack_require__(103);
    var FontsDotComApi = __webpack_require__(875);
    var FontsDotComIntegrationModel = __webpack_require__(403);
    var GoogleFontsApi = __webpack_require__(1769);
    var LoggedInUserState = __webpack_require__(19);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Marionette = __webpack_require__(10);
    var Promise = __webpack_require__(21);
    var StandardWebFontList = __webpack_require__(778);
    var Storage = __webpack_require__(34);
    var SyncManager = __webpack_require__(44);
    var SystemMessages = __webpack_require__(107);
    var TypekitApi = __webpack_require__(876);
    var CustomFontCollection = __webpack_require__(877);
    var CustomFontIntegrationModel = __webpack_require__(562);
    var TypekitIntegrationModel = __webpack_require__(407);

    var logger = new Logger("EditorWebFontController");

    /**
     * Map used for parsing the different font API responses.
     *
     * @type {Map.<FontProvider, Function>}
     */
    var parsers = new Map();

    // Custom
    parsers.set(FontProvider.CUSTOM, function (customFontCollection) {
        return customFontCollection.map(function (customFontModel) {
            var data = {
                path: customFontModel.get("path"),
                customFontId: customFontModel.get("id"),
                format: customFontModel.get("format")
            };

            var fontFamily = customFontModel.get("fontFamily");

            return {
                provider: FontProvider.CUSTOM,
                name: fontFamily,
                cssFamily: fontFamily,
                family: fontFamily,
                variations: ["400"],
                data: data
            };
        });
    });

    // Google
    parsers.set(FontProvider.GOOGLE, function (response) {
        return _.map(response.items, function (value) {
            return {
                provider: FontProvider.GOOGLE,
                name: value.family,
                family: value.family,
                cssFamily: value.family,
                variations: value.variants
            };
        });
    });

    // Typekit
    parsers.set(FontProvider.TYPEKIT, function (response) {
        var descriptors = [];
        _.each(response, function (item) {
            var kit = item.kit;
            _.each(kit.families, function (familiy) {
                descriptors.push({
                    provider: FontProvider.TYPEKIT,
                    name: familiy.name,
                    family: familiy.name,
                    variations: familiy.variations,
                    cssFamily: familiy.css_names.toString(),
                    data: {
                        kitID: kit.id,
                        cssFamilyNames: familiy.css_names
                    }
                });
            });
        });

        return descriptors;
    });

    // FontsDotCom
    parsers.set(FontProvider.FONTS_DOT_COM, function (fontProjects) {
        var descriptors = [];
        _.each(fontProjects, function (fontProject) {
            _.each(fontProject.fonts, function (font) {
                // Variations of fonts from Fonts.com show up as individual fonts.
                // -> family and cssFamily is the same.
                // -> variations is always just "400", i.e. normal weight and not italic.
                descriptors.push({
                    provider: FontProvider.FONTS_DOT_COM,
                    name: font.name,
                    family: font.cssFamily,
                    cssFamily: font.cssFamily,
                    variations: ["400"],
                    data: {
                        projectId: fontProject.projectId,
                        projectName: fontProject.name,
                        cssFamilyNames: font.cssFamily
                    }
                });
            });
        });

        var compareNames = function compareNames(fontDescriptorA, fontDescriptorB) {
            if (fontDescriptorA.name < fontDescriptorB.name) {
                return -1;
            }

            if (fontDescriptorA.name > fontDescriptorB.name) {
                return 1;
            }

            return 0;
        };

        descriptors.sort(compareNames);

        return descriptors;
    });

    /**
     * Responsible for setting up the initial fetching of fonts - Google Fonts and Typekit (if supported).
     * Also acts as the caching layer, exposing the user's fonts via `EditorWebFontController.collection`.
     *
     * Use `EditorWebFontController.promise` to access the collection.
     *
     * Google Fonts are sorted by most popular.
     *
     * The `EditorWebFontController` is a singleton.
     *
     * @class EditorWebFontController
     * @author Kim
     */
    var EditorWebFontController = Marionette.Controller.extend({

        /**
         * @type {FontDescriptorCollection}
         * The loaded font descriptors.
         */
        _collection: null,
        /**
         * @private @type {Promise}
         * A promise that will resolve once all fonts have been loaded, at which point `_collection`
         * will be populated with the loaded font descriptors.
         */
        _promise: null,

        /**
         * Starts the controller.
         *
         * If all global data is available (`ready`), we start fetching the font data immediately.
         */
        start: function start() {
            if (LoggedInUserState.get("ready") && !this._promise) {
                this._startFetching();
            }
            this._listenToReadyEvent();
        },


        /**
         * Clears/resets the contained collection and removes all event listeners.
         */
        clear: function clear() {
            this._collection.reset();
            this.stopListening();
            this._promise = null;
            StandardWebFontList.reset();
        },


        /**
         * Returns a promise that resolves once the font collection has been successfully initialized
         * and ready to use.
         *
         * @return {Promise} A `Promise` instance; never null.
         */
        promise: function promise() {
            return this._promise;
        },


        /**
         * Removes all the Typekit Font descriptors (if any) and reloads font styles.
         * @param  {String} token The Typekit API token.
         */
        reloadKits: function reloadKits(token) {
            var _this = this;

            this._collection.removeByProvider(FontProvider.TYPEKIT);
            this._fetchTypekit(token).done(function (response) {
                logger.info("Adding Typekit fonts");
                var parser = parsers.get(FontProvider.TYPEKIT);

                // Add the fonts to the collection
                _this._collection.add(parser(response));

                // Load the actual font styles
                FontLoader.fromFontDescriptors(_this._collection.fromProvider(FontProvider.TYPEKIT));
            });
        },


        /**
         * Removes all Fonts.com Font descriptors (if any) and reloads font styles.
         */
        reloadFonsDotComFonts: function reloadFonsDotComFonts() {
            var _this2 = this;

            this._collection.removeByProvider(FontProvider.FONTS_DOT_COM);
            this._fetchFontsDotCom(FontsDotComApi).done(function (response) {
                logger.info("Adding Fonts.com fonts");
                var parser = parsers.get(FontProvider.FONTS_DOT_COM);
                _this2._collection.add(parser(response));
                FontLoader.fromFontDescriptors(_this2._collection.fromProvider(FontProvider.FONTS_DOT_COM));
            });
        },
        _readyChangeHandler: function _readyChangeHandler() {
            if (LoggedInUserState.get("ready")) {
                // ready: logged in *and* user data ready
                this._startFetching();
            } else {
                // Reset state.
                this.clear();
                this._listenToReadyEvent();
            }
        },


        /**
         * Registers a listener for the `ready` event on the `LoggedInUserState`.
         */
        _listenToReadyEvent: function _listenToReadyEvent() {
            this.listenTo(LoggedInUserState, "change:ready", this._readyChangeHandler);
        },


        /**
         * @private
         */
        _startFetching: function _startFetching() {
            var _this3 = this;

            var integrations = LoggedInUserState.get("integrations");

            // Initialize the collection of fonts with the standard web fonts, which will be resolved once
            // the queue completes.
            this._collection = StandardWebFontList.collection();

            // Create a parallel queue to fetch the fonts, resolving font descriptors, and adding them to the
            // resolved font collection when the queue completes.
            var queue = SyncManager.queue(true, function (result, request, provider) {
                // "true" -> parallel
                // Get parser for provider and parse "result" into usable font descriptors to store in the
                // font collection eventually resolved.
                _this3._collection.add(parsers.get(provider)(result));
            });

            // Suppress error notifications here, already handled by the font loader itself
            var errorHandler = function errorHandler() {
                return false;
            };

            logger.info("Start loading font data");

            // Enqueue a request to load the Google fonts via the Google Font API.
            queue.enqueue({
                method: FontProvider.GOOGLE.value + ":descriptors",
                fn: function fn() {
                    return GoogleFontsApi.mostPopular();
                },
                errorHandler: errorHandler
            }, FontProvider.GOOGLE);

            // If font integrations are enabled, fetch additional fonts
            if (integrations.fontIntegrationsEnabled()) {
                // Custom Fonts integration
                var customFontsIntegration = integrations.getIntegration(CustomFontIntegrationModel);

                if (customFontsIntegration) {
                    // Enqueue a request to load the any custom fonts.
                    queue.enqueue({
                        method: FontProvider.CUSTOM.value + ":descriptors",
                        fn: function fn() {
                            return new CustomFontCollection().fetch();
                        },
                        errorHandler: errorHandler
                    }, FontProvider.CUSTOM);
                }

                // Typekit Integration
                var typekitIntegration = integrations.getIntegration(TypekitIntegrationModel);

                if (typekitIntegration && typekitIntegration.has("typekitApiToken")) {
                    var typeKit = new TypekitApi(typekitIntegration.get("typekitApiToken"));
                    // Enqueue a request to load the Typekit fonts via the Typekit API.
                    queue.enqueue({
                        method: FontProvider.TYPEKIT.value + ":descriptors",
                        fn: function fn() {
                            return _this3._fetchTypekit(typeKit);
                        },
                        errorHandler: errorHandler
                    }, FontProvider.TYPEKIT);
                }

                // Fonts.com integration
                var fontsDotComIntegration = integrations.getIntegration(FontsDotComIntegrationModel);

                if (fontsDotComIntegration && fontsDotComIntegration.has("authenticationKey")) {
                    // Enqueue a request to load the Fonts.com font families using the Fonts.com api client.
                    queue.enqueue({
                        method: FontProvider.FONTS_DOT_COM.value + ":descriptors",
                        fn: function fn() {
                            return _this3._fetchFontsDotCom();
                        },
                        errorHandler: errorHandler
                    }, FontProvider.FONTS_DOT_COM);
                }
            } else {
                this.clearFontType(FontProvider.CUSTOM);
                this.clearFontType(FontProvider.TYPEKIT);
                this.clearFontType(FontProvider.FONTS_DOT_COM);
            }

            // Get and set promise for when the queue has completed, i.e. loaded fonts.
            this._promise = queue.sync().then(function () {
                _this3.trigger("fontsLoaded");
                logger.info("Font data loaded");
                _this3._loadCssOfInitialFonts();
                return _this3._collection;
            }).fail(function () {
                logger.error("Unable to fetch all font information");
            });
        },


        /**
         * Register fonts with the internal collection, optionally loading them as well.
         *
         * @param {Object|Object[]} font  The raw font data, as provided by the specific font provider - will be passed to the internal parser.
         * @param {FontProvider} provider The `FontProvider` of the specified font data.
         * @param {Boolean} [load=true] Whether to load the font(s) - defaults to `true`.
         */
        register: function register(font, provider) {
            var _this4 = this;

            var load = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var fonts = Array.isArray(font) ? font : [font];
            // Parse the font data to it's raw form.
            var rawFontDescriptors = parsers.get(provider)(fonts);
            // Pass the raw descriptors to the collection.
            this._collection.add(rawFontDescriptors, { at: 0 });

            if (load) {
                // We need the actual concrete model instances in order to load the fonts.
                // It seems that future versions of Backbone.Collection#add returns the model instances - that
                // would be ideal, instead of the below lookup...
                var fontDescriptors = rawFontDescriptors.map(function (rawFontDescriptor) {
                    var name = rawFontDescriptor.name,
                        provider = rawFontDescriptor.provider;

                    return _this4._collection.findWhere({ name: name, provider: provider });
                });

                FontLoader.fromFontDescriptors(fontDescriptors);
            }
        },


        /**
         * Unregister fonts from the internal collection.
         *
         * @param {Object|Object[]} font  The raw font data, as provided by the specific font provider - will be passed to the internal parser.
         * @param {FontProvider} provider The `FontProvider` of the specified font data.
         */
        unregister: function unregister(font, provider) {
            var _this5 = this;

            var fonts = Array.isArray(font) ? font : [font];
            var rawFontDescriptors = parsers.get(provider)(fonts);
            var fontDescriptors = rawFontDescriptors.map(function (rawFontDescriptor) {
                var name = rawFontDescriptor.name,
                    provider = rawFontDescriptor.provider;

                return _this5._collection.findWhere({ name: name, provider: provider });
            });

            this._collection.remove(fontDescriptors);
        },


        /**
         * Clears/removes any previously used font configurations, i.e. removes any fonts from the
         * collection of font descriptors, and any "favoriteFonts" stored in local storage.
         */
        clearFontType: function clearFontType(fontProviderId) {
            // If the token was removed, remove the fonts as well
            this._collection.removeByProvider(fontProviderId);
            // Clean up any previously used fonts
            var favorites = Storage.Local.get(Storage.Keys.EDITOR, "favoriteFonts", []);
            // Store all but Typekit
            Storage.Local.update(Storage.Keys.EDITOR, "favoriteFonts", _.filter(favorites, function (favorite) {
                return favorite.fontProvider !== fontProviderId.value;
            }));
        },


        /**
         * @private
         *
         * Tries to fetch all the font information from Typekit given a specific API token.
         *
         * If the request, for some reason, fails, the returned promise will still resolve, but the NotificationBar
         * is invoked with an error message.
         *
         * @param  {String} typekitApi The Typekit API token
         * @return {Promise}                A promise that always resolves, either with an array of kit
         * data, or an empty array.
         */
        _fetchTypekit: function _fetchTypekit(typekitApi) {
            if (_.isString(typekitApi)) {
                typekitApi = new TypekitApi(typekitApi);
            }
            logger.info("Fetching Typekit kit(s), using API token: " + typekitApi);
            return Promise.deferred(function (deferred) {
                typekitApi.all().done(deferred.resolve).fail(function () {
                    logger.error("Unable to communicate with the Typekit API");
                    SystemMessages.ManageFonts.noCommunication("Typekit", "API token");
                    // Just resolve with "empty response"
                    deferred.resolve([]);
                });
            });
        },


        /**
         * Tries to fetch all the fonts from Fonts.com. The returned promise will never fail. If
         * the request fails a toaster message is show and an empty array is returned.
         *
         * @returns {Promise<Array<FontDescriptor>>}
         */
        _fetchFontsDotCom: function _fetchFontsDotCom() {
            logger.info("Fetching Fonts.com project(s).");
            return Promise.deferred(function (deferred) {
                FontsDotComApi.all().done(deferred.resolve).fail(function () {
                    logger.error("Unable to communicate with Fonts.com.");
                    SystemMessages.ManageFonts.noCommunication("Fonts.com", "authentication key");
                    // Errors are also resolved, but with an empty array.
                    deferred.resolve([]);
                });
            });
        },


        /**
         * @private
         *
         * Validates the specified Typekit API token, by performing an API request, that if proves
         * successful, resolves the returned promise with a boolean value of `true`, otherwise `false`.
         *
         * @param  {String} typekitApiToken The API token.
         * @return {Promise}                A promise the resolves to either `true` or `false`.
         */
        _validateTypekitToken: function _validateTypekitToken(typekitApiToken) {
            return Promise.deferred(function (deferred) {
                var typekitApi = new TypekitApi(typekitApiToken);
                var failed = function failed() {
                    deferred.resolve(false);
                    SystemMessages.ManageFonts.invalidKey("Typekit", "API token", typekitApiToken, "typekit:valid:token");
                };

                typekitApi.kits().done(function (value) {
                    if (value && value.errors) {
                        failed();
                    } else {
                        deferred.resolve(true);
                    }
                }).fail(failed);
            }).promise();
        },


        /**
         * @private
         *
         * Start loading the css of the initial font styles.
         */
        _loadCssOfInitialFonts: function _loadCssOfInitialFonts() {
            // Populate list of fonts to load initially.
            var fonts = this._collection.take(20);

            // We only care about the google fonts since standard fonts
            // does not need to be loaded, and we already load all
            // available Typekit fonts.
            var favoriteGoogleFontDescriptors = this._getFavoriteGoogleFontDescriptors();
            var allGoogleFonts = fonts.get(FontProvider.GOOGLE).concat(favoriteGoogleFontDescriptors);

            fonts.set(FontProvider.GOOGLE, allGoogleFonts);

            // No need to load the "standard" fonts
            fonts.delete(FontProvider.STANDARD);

            var allCustomFonts = this._collection.fromProvider(FontProvider.CUSTOM);
            fonts.delete(FontProvider.CUSTOM);
            fonts.set(FontProvider.CUSTOM, allCustomFonts);

            var queue = SyncManager.queue(true); // parallel

            // Load the initial fonts (including all variants)
            fonts.forEach(function (fontDescriptors, provider) {
                queue.enqueue({
                    method: provider.value,
                    fn: function fn() {
                        return FontLoader.fromFontDescriptors(fontDescriptors, true);
                    },
                    errorHandler: function errorHandler() {
                        // suppress error notifications, already handled by font loader
                        return false;
                    }
                }, provider);
            });

            queue.sync();
        },


        /**
         * Gets the favorite fonts belonging to Google and returns an array of
         * fontDescriptors.
         *
         * @private
         * @return {fontDescriptors[]}  Array of favorite google font
         *                              descriptors.
         */
        _getFavoriteGoogleFontDescriptors: function _getFavoriteGoogleFontDescriptors() {
            var _this6 = this;

            var favorites = Storage.Local.get(Storage.Keys.EDITOR, "favoriteFonts", []);
            var filteredFavorites = _.where(favorites, { fontProvider: FontProvider.GOOGLE.value });

            return _.map(filteredFavorites, function (favorite) {
                return _this6._collection.fromFamily(favorite.fontFamily, FontProvider.GOOGLE);
            });
        }
    });

    // Singleton
    return new EditorWebFontController();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        $ = __webpack_require__(4),
        Class = __webpack_require__(26),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        Cookie = __webpack_require__(406),
        RestApi = __webpack_require__(29),
        Promise = __webpack_require__(21),
        Storage = __webpack_require__(34),
        LoggedIn = __webpack_require__(31),
        Principal = __webpack_require__(1770),
        Configuration = __webpack_require__(27),
        UrlUtil = __webpack_require__(46);

    var log = new Logger("Login");

    var PERSISTENT_NAME = "token";

    /**
     * @private @type {String}
     * The token from <tt>LoggedIn.principal</tt>. <p>
     *
     * The token will be set as the "Authorization" header for each issued request. The token will never be null for
     * a logged in principal.
     */
    var _token = null;

    var _principal = null;

    /**
     * Adds the authentication token for the authenticated principal to all API requests. <p>
     *
     * Note: The Auth token has also been added to /modules/Auth/Auth.php because that is the matomo dashboard and we use the auth token to login.
     *
     * In addition, the version is added as the "X-Zmags-Creator-Version" header.
     *
     * @param {Object} options The jQuery Ajax options hash; never null.
     */
    function addApiAuthHeader(options) {
        if (_token && options && (options.url.indexOf(RestApi.API_URL) === 0 || UrlUtil.sameHostname(options.url, Configuration.matomoConfig.dashboardUrl) || UrlUtil.sameHostname(options.url, Configuration.inventoryUrl) || UrlUtil.sameHostname(options.url, Configuration.experienceUrl2PngBaseUrl) || UrlUtil.sameHostname(options.url, Configuration.proxyUrl) || UrlUtil.sameHostname(options.url, Configuration.experienceSharedEntityBaseUrl) || UrlUtil.sameHostname(options.url, Configuration.microserviceCompanyUrl))) {
            if (!options.headers) {
                options.headers = {};
            }
            options.headers.Authorization = "Bearer " + _token;
            // Add version to each API request...
            if (Configuration.version) {
                options.headers["X-Zmags-Creator-Version"] = Configuration.version;
            }
        }
    }

    // Only set up these once...
    Backbone.$.ajaxPrefilter(addApiAuthHeader);
    $.ajaxPrefilter(addApiAuthHeader);

    /**
     * Logs in the given principal. <p>
     *
     * Note that the token for the principal may be null in case of company restrictions!
     *
     * @param {Principal} principal The principal to login; never null.
     */
    function login(principal) {
        // If "principal.persistent" is true, we use the default cookie timeout, otherwise create it as a
        // session cookie only (timeout 0). This way, the cookie can still be used for inter-tab communication,
        // e.g. when a new tab is opened, either by the user or by the editor - no additional login is then
        // required. This will work since this controller will be hit again, then reading the token from the
        // (session) cookie. The cookie will thus in any case be cleared on explicit log out, or on browser timeout...
        //
        // CAVEAT: Chrome may keep the session cookies even after the browser is closed, especially if the
        //         user has set the option "Remember where I left off", or if extensions keep running in the
        //         backend. However, as Bo states: this is the same for anybody using Chrome, not just us,
        //         so we decided to use session cookies after all because of the benefits regarding not
        //         having to login into multiple tabs and because of easy inter-tab communication. An small
        //         optimisation could be to bind a call to "logout" on "onbeforeunload" with an associated
        //         count in the cookie for the current number of opened windows. We could also store a
        //         timeout value along with the token, e.g. token + ":" + timestamp, and manually enforce
        //         a smaller timeout, so session cookies at least would not live "forever"...
        //
        // CAVEAT: we do *not* store the actual token as a cookie, but in session storage, since Creator runs
        //         on both http and https, meaning that all requests sent via http will include cookies and would
        //         thus include the access token in plain text otherwise!

        // To test for same principal we have to test on user id, not on token, since the token value can be changed on
        // upgrade to normal (re-)login. The id is just that: an id. The is no way to fetch anything regarding the token
        // based on it via the backend API, so safe enough to use it here...
        var existing = _principal !== null,
            token = Date.now(),
            same = existing && principal.get("userId") === _principal.get("userId");

        // Make sure we force a logout if the principal changes in a way that is not allowed, i.e. if different
        // backing user, or if the user changes company...
        if (existing) {
            if (!same) {
                // different backing user...
                same = false;
                log.warn("Logging out old principal before new one can log in: ", _principal);
                logout(_principal);
            } else if (principal.get("companyId") !== _principal.get("companyId")) {
                // same backing user, different company (wtf!)
                same = false;
                log.error("Logging out principal that changed company: ", _principal);
                logout(_principal);
            }
        }

        // Save actual (updated) token here from incoming principal...
        _token = principal.get("token");

        // "principal" will always be a new instance here, but may correspond to the existing logged in principal
        // stored in "_principal", if any. If so, we must update the existing one with properties that potentially
        // could be change, as various views could already keep a reference to it, using it as a model. If different
        // principal, the "update" property is null by default, and we simply set it as the logged in principal...
        if (same) {
            var role = principal.get("role"),
                state = principal.get("state");

            _principal.set({
                displayName: principal.get("displayName"),
                type: principal.get("type"),
                user: principal.get("user"), // never null for a valid login!
                role: role,
                state: state,
                updated: _principal.get("role") !== role || _principal.get("state") !== state
            }, { silent: true });

            // Already a mock token, so keep using the same...
            token = _principal.get("token");

            // First time login for "principal"...
        } else {
            _principal = principal;
        }

        // Set mock token on principal, so we do not expose it elsewhere...
        _principal.set("token", token, { silent: true });

        var persistent = _principal.get("persistent");

        //
        // On cookies and security, see fx: http://resources.infosecinstitute.com/securing-cookies-httponly-secure-flags/
        //

        // The actual token may live longer than the session cookie, but will only be used if the cookie is set.
        // We cannot, however, store the actual token in *local* storage if not persistent, since the app can
        // be left at any time, e.g. the user entering a new url in the browser, without us having time to
        // clean up (i.e. do a logout). We have to use session storage otherwise, as DnD (and other stuff) will
        // not work otherwise, since it relies on auto login. Once MOS-1509 is in place, i.e. no http in the editor,
        // we can switch to secure cookies only, not using local/session storage any longer...

        // We assume persistent, i.e. "Keep me signed in", per default...
        var use = Storage.Local,
            clear = Storage.Session;

        if (!persistent) {
            use = Storage.Session;
            clear = Storage.Local;
        }

        var synced = use.update(Storage.Keys.LOGIN, PERSISTENT_NAME, _token);

        // And - one final caveat: Safari incognito mode enforces a quota of zero for local storage, i.e. it cannot
        // be used. We thus have to check when writing to local storage - on false, we have to go "non-persistent"
        // and use session storage instead...
        if (!synced) {
            // Try and switch then, so we use session storage. This is only a guess of what is wrong, of course, but
            // if we do not try this here, we cannot login (and use DnD)...
            if (persistent) {
                log.warn("Principal cannot use 'Keep me signed in': " + principal);
                use = Storage.Session;
                synced = use.update(Storage.Keys.LOGIN, PERSISTENT_NAME, _token);
                if (synced) {
                    clear = Storage.Local;
                    persistent = false;
                    _principal.set("persistent", false, { silent: true });

                    // Nothing to do then, at all, so keep state as it was...
                } else {
                    use = Storage.Local;
                }
            }
        }
        clear.unset(Storage.Keys.LOGIN, PERSISTENT_NAME);

        // Mock token stored in cookie, for 60 days which is the current read-only timeout for tokens...
        Cookie.set(PERSISTENT_NAME, token, persistent ? 60 * 24 : 0);

        // This will trigger a change event on LoggedIn that modules can listen for...
        LoggedIn._login(_principal);
    }

    /**
     * Logs out the current principal, if any.
     *
     * @param {Principal} [principal] The principal that just tried to log in, but failed to do so because of
     *                                login restrictions. This is <b>NOT</b> (necessarily) the principal to log out.
     *                                On failure to validated credentials, always null. If supplied, this will trigger
     *                                an "error:login_restricted" event from the <tt>LoggedIn</tt> module.
     */
    function logout(principal) {
        LoggedIn._logout(principal);

        if (!_token) {
            return;
        }
        _principal = null;
        _token = null;

        // Destroy the cookie and local/session storage. This will actually have no effect if the cookie is a session
        // cookie (expect perhaps in Chrome, unfortunately), i.e. the user has opted not to remember the cookie,
        // since that will be deleted by default. But it will delete the token from local storage, preventing
        // login with the removed token in any case...
        Cookie.remove(PERSISTENT_NAME);
        Storage.Local.unset(Storage.Keys.LOGIN, PERSISTENT_NAME);
        Storage.Session.unset(Storage.Keys.LOGIN, PERSISTENT_NAME);
        Storage.Local.remove(Storage.Keys.ONLOAD_ACTION_ENABLED);
        Storage.Local.remove(Storage.Keys.CREATOR_CONNECT);
        Storage.Local.remove(Storage.Keys.CONTENT_CONTROL_BETA);
    }

    /**
     * Checks an valid (200!) authorization response and logs in the authorized principal if available. This is never
     * called on authentication errors like 401, 403, nor on 404. <p>
     *
     * On successful login, the authorized principal with a token is resolved and returned; if not valid, a rejected
     * promise is returned, also with the principal, but without any associated token or user.
     *
     * @param {*}        auth        The authorization response (200) from the API; never null.
     * @param {String}   message     A user friendly message describing the type of login method performed (for
     *                               logging only); never null.
     * @param {Boolean} [persistent] True if "Keep me signed in" is checked in the ui, false otherwise. Will default to
     *                               the existing cookie value if not specified.
     *
     * @return {Principal|Promise} The authorized principal, or a rejected promise with the principal (with no token).
     */
    function checkPrincipal(auth, message, persistent) {
        // Create principal based on the authorization response...
        var principal = new Principal(auth);

        // On login restrictions, we can an empty response on otherwise successful login, not an error, so we have
        // to take this into account on actual non-AD login...
        if (principal.get("token")) {
            // Mark principal as persistent ("Keep me signed in") or not...
            principal.set("persistent", typeof persistent === "undefined" ? !!Cookie.get(PERSISTENT_NAME) : persistent);

            // Generate user-friendly message about the type of login...
            message += ": " + principal.get("type");
            if (!principal.get("user").get("confirmedAt")) {
                message += " (Unconfirmed)";
            }
            log.info(message += " -> <" + principal.get("displayName") + ">", auth.user); // log json for clarity, not 'principal.get("user")'!

            // Do the actual login, i.e. henceforth use the access token for the principal to access the API...
            login(principal);

            return principal;
        }

        log.warn(message + " restricted");

        // Ensure the rejected user is logged out (i.e. if it was a re-login)...
        logout(principal);

        return Promise.rejected(principal);
    }

    /**
     * Performs a login based on the specified Ajax options, and returns a promise that will resolve to the logged
     * in user on success. On error, the promise will be rejected, optionally resolving to a company state.
     *
     * @param {String}   type        A user friendly string describing the type of login method performed (for logging);
     *                               never null.
     * @param {*}        options     The Ajax options for the specific type of login; never null.
     * @param {Boolean} [persistent] True if "Keep me signed in" is checked in the ui, false otherwise. Will default to
     *                               the existing cookie value if not specified.
     * @return {Promise} A promise that will resolve to the authorized user, or on rejection resolves to an optional
     *                   company state; never null.
     */
    function doLogin(type, options, persistent) {
        return $.ajax(options).fail(function (xhr) {
            // No logout here, we could be trying to get a normal token from a read-only token...
            log.warn(type + " failed", xhr);
            // Special case: too many login attempts if a short period...
            if (xhr.status === 429) {
                LoggedIn._tooManyAttempts(parseInt(xhr.getResponseHeader("Retry-After"), 10));
            }
        }).then(function (auth) {
            return checkPrincipal(auth, type, persistent);
        });
    }

    //
    //

    /**
     * The login service. <p>
     *
     * Once a principal is logged in, it will be available via <tt>principal()</tt>. <p>
     *
     * This class provides the raw login methods and manages the authorization token on API requests. Any logic
     * related to routing, displaying the login form, etc. should be handled elsewhere.
     *
     * @class Login
     * @constructor
     */
    var Login = Class.extend({

        /**
         * @private
         * Tries to login via the specified token.
         *
         * @param {String} type  A user friendly string describing the type of login method performed (for logging);
         *                       never null.
         * @param {String} token The token to use for login; never null.
         * @return {Promise} A promise resolving to the logged in principal, a rejected promise with the token-less
         *                   principal with company restrictions, or undefined on failure to login altogether.
         */
        _loginWithToken: function _loginWithToken(type, token) {
            // Ensure the token is (still) valid...
            _token = token; // now set as request header!

            var url = Configuration.loginWithTokenBaseUrl + "/api/token";

            return doLogin(type, {
                url: url,
                dataType: "json"
            });
        },

        /**
         * Tries to re-login via the current token, e.g. to upgrade the token from unconfirmed or read-only to
         * normal.
         *
         * @return {Promise} A promise resolving to the new logged in principal, where the "updated"
         *                   property will be set to true if the role and/or company state has changed, or undefined
         *                   on failure to login altogether.
         */
        relogin: function relogin() {
            return this._loginWithToken("Re-login with token", _token);
        },

        /**
         * Attempts a login with a potential persisted user, i.e. previously logged in with "Keep me signed in" checked.
         *
         * @return {Promise} A promise resolving to the logged in principal, a rejected promise with the token-less
         *                   principal with company restrictions, or undefined on failure to login altogether.
         */
        loginPersistedUser: function loginPersistedUser() {
            // Check if we have a stored token to use for the login: this will be local storage when persistent, i.e.
            // when "Keep me signed in" is checked, otherwise session storage...
            var token = Storage.Local.get(Storage.Keys.LOGIN, PERSISTENT_NAME) || Storage.Session.get(Storage.Keys.LOGIN, PERSISTENT_NAME);

            // Check if there is a valid corresponding (session) cookie. Note that Chrome ignores session cookies,
            // but the backend will check for the token lifespan in any case...
            if (!(token && Cookie.get(PERSISTENT_NAME))) {
                // Make sure any expired token is deleted for consistency...
                Storage.Local.unset(Storage.Keys.LOGIN, PERSISTENT_NAME);
                Storage.Session.unset(Storage.Keys.LOGIN, PERSISTENT_NAME);
                return Promise.rejected();
            }
            // Ensure the token is still valid...
            return this._loginWithToken("Persisted user login", token);
        },

        /**
         * Attempt a login with a username and password.
         *
         * @param {String}   username    The username.
         * @param {String}   password    The password.
         * @param {Boolean} [persistent] True if "Keep me signed in" is checked in the ui, false otherwise. Will default to
         *                               the existing cookie value if not specified.
         *
         * @return {Promise} A promise resolving to the logged in principal, a rejected promise with the token-less
         *                   principal with company restrictions, or undefined on failure to login altogether.
         */
        loginWithPassword: function loginWithPassword(username, password, persistent) {
            var url = Configuration.loginWithPasswordBaseUrl + "/api/token";
            return doLogin("Password login for <" + username + ">", {
                url: url,
                type: "POST",
                data: JSON.stringify({
                    username: username,
                    password: password
                }),
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            }, persistent);
        },

        /**
         * Attempt a login with a JWT issued by the ZMags Auth0 tenant for SSO.
         *
         * @param {String}  jsonWebToken The JWT issued by the ZMags Auth0 tenant.
         * @return {Promise} A promise resolving to the logged in principal, a rejected promise with the token-less
         *                   principal with company restrictions, or undefined on failure to login altogether.
         */
        loginWithSSO: function loginWithSSO(jsonWebToken) {
            var url = Configuration.loginWithSsoBaseUrl + "/api/token/auth0";
            return doLogin("JWT login", {
                url: url,
                type: "POST",
                data: JSON.stringify({
                    password: jsonWebToken
                }),
                contentType: "application/json; charset=utf-8",
                dataType: "json"
            });
        },

        /**
         * Attempts a login for a new user using a token supplied in the link.
         *
         * @param {String}  token The access token for the new user; cannot be null. After successful login, the token
         *                        will be deleted, and a new one granted to the user. Hence, clicking the same link
         *                        will never succeed twice if the first call succeeded.
         *
         * @returns {Promise} A promise for having logged in successfully. Will resolve with the logged in principal.
         */
        loginNewUser: function loginNewUser(token) {
            return this._loginWithToken("New user login", token);
        },

        /**
         * Attempts a login with Active Directory credentials.
         *
         * @param {Backbone.Model} model The Active Directory login model. See ADSignInView.
         * @returns {Promise} A promise for having logged in successfully. Will resolve with the logged in principal.
         */
        loginActiveDirectory: function loginActiveDirectory(model) {
            var url = Configuration.loginActiveDirectoryBaseUrl + "/api/token/ad";
            return doLogin("Ad login <" + (model.get("adUsername") || model.get("experienceId") || model.get("publicatorUserId")) + ">", {
                url: url,
                type: "POST",
                data: JSON.stringify(model.toJSON()),
                contentType: "application/json; charset=utf-8"
            });
        },

        /**
         * Changes the password of the user currently associated with the logged in principal. <p>
         *
         * This will cause a re-login (new token).
         *
         * @param {String}    password    The new password.
         * @param {Boolean}  [persistent] True if "Keep me signed in" is checked in the ui, false otherwise. Will default
         *                                to the existing cookie value if not specified.
         * @returns {Promise} A promise for the change of password. Will resolve with the logged in principal once
         *                    the change is complete.
         *
         */
        changePassword: function changePassword(password, persistent) {
            var user = LoggedIn.user();
            var userId = user.get("id");
            var url = Configuration.changePasswordBaseUrl + "/api/" + RestApi.Collections.USERS + "/" + userId + "/password";
            return doLogin("Change password for <" + user.get("username") + ">", {
                url: url,
                type: "PUT",
                data: JSON.stringify({ password: password }),
                contentType: "application/json; charset=utf-8"
            }, persistent);
        },

        /**
         * Resets the password of the user with the specified email to the supplied password, invalidating the
         * old authentication token for the user in question on success. <p>
         *
         * This will cause a re-login (new token).
         *
         * @param {String}  resetToken   The reset token to use for the reset.
         * @param {String}  email        The email (username) of the user in question.
         * @param {String}  password     The (new) password.
         * @param {Boolean} [persistent] True if "Keep me signed in" is checked in the ui, false otherwise. Will default
         *                               to the existing cookie value if not specified.
         *
         * @returns {Promise} A promise for the reset of password. Will resolve with the logged in principal once
         *                    the change is complete.
         */
        resetPassword: function resetPassword(resetToken, email, password, persistent) {
            var url = Configuration.resetPasswordBaseUrl + "/api/" + RestApi.Collections.USERS + "/password/" + resetToken;
            return doLogin("Reset password for <" + email + ">", {
                url: url,
                type: "PUT",
                data: JSON.stringify({
                    email: email,
                    password: password
                }),
                contentType: "application/json; charset=utf-8"
            }, persistent);
        },

        /**
         * Sends a mail to the specified email if a user with said username exist with information
         * about how to reset the password. <p>
         *
         * This will <b>not</b> reset the password. The password reset is not performed until the
         * user clicks an embedded link in said mail that links back to the editor, where the user
         * can confirm the actual reset. <p>
         *
         * The user will remain on the same page, i.e. no navigation is performed on success.
         *
         * @param   {String}  email The email (username) for the user that has forgotten her password;
         *                          cannot be null.
         * @returns {Promise} Promise that resolves when a mail has been sent to the matching user,
         *                    if any.
         */
        forgotPassword: function forgotPassword(email) {
            var url = Configuration.forgotPasswordBaseUrl + "/api/" + RestApi.Collections.USERS + "/password/forgot";
            return $.ajax({
                url: url,
                type: "PUT",
                data: JSON.stringify({
                    email: email,
                    baseUrl: UrlUtil.baseUrl() // PROXY IGNORES THIS AS IT's an attach vector for bad emails!
                }),
                contentType: "application/json; charset=utf-8"
            }).fail(function (xhr) {
                log.warn("Forgot password for <" + email + "> failed", xhr);
            });
        },

        /**
         * Logs the current principal, if any, out.
         */
        logout: logout

    });

    // Singleton...
    return new Login();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useControlled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */

function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default,
      name = _ref.name,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'value' : _ref$state;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  if (false) {
    React.useEffect(function () {
      if (isControlled !== (controlled !== undefined)) {
        console.error(["Material-UI: A component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [controlled]);

    var _React$useRef2 = React.useRef(defaultProp),
        defaultValue = _React$useRef2.current;

    React.useEffect(function () {
      if (!isControlled && defaultValue !== defaultProp) {
        console.error(["Material-UI: A component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
      }
    }, [JSON.stringify(defaultProp)]);
  }

  var setValueIfUncontrolled = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(2108);

module.exports = DraftFeatureFlags;

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBasePlacement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(82);

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(95);

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["a" /* isElement */])(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var User = __webpack_require__(261);
    var LoggedInUserState = __webpack_require__(19);
    var RestApi = __webpack_require__(29);

    /**
     * A collection of users.
     *
     * @author Bruce Mackenzie Nielsen
     * @class UserCollection
     * @constructor
     */
    return Backbone.Collection.extend({
        model: User,

        url: function url() {
            return RestApi.pathToCollection(RestApi.Collections.USERS);
        },
        byExcludingCurrentUser: function byExcludingCurrentUser() {
            return new Backbone.Collection(this.filter(function (user) {
                var currentUserId = LoggedInUserState.get("user").get("id");
                return currentUserId !== user.get("id");
            }));
        },
        undeletedUsers: function undeletedUsers() {
            return new Backbone.Collection(this.filter(function (user) {
                return !user.get("deletedAt");
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var abs = __webpack_require__(292);
var floor = __webpack_require__(115);

var $isNaN = __webpack_require__(149);
var $isFinite = __webpack_require__(150);

// https://ecma-international.org/ecma-262/6.0/#sec-isinteger

module.exports = function IsInteger(argument) {
	if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
		return false;
	}
	var absValue = abs(argument);
	return floor(absValue) === absValue;
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(114);

var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var Type = __webpack_require__(23);
var ToBoolean = __webpack_require__(236);
var IsCallable = __webpack_require__(187);

// https://262.ecma-international.org/5.1/#sec-8.10.5

module.exports = function ToPropertyDescriptor(Obj) {
	if (Type(Obj) !== 'Object') {
		throw new $TypeError('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (has(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (has(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (has(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (has(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (has(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new $TypeError('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (has(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
		throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://262.ecma-international.org/5.1/#sec-9.11

module.exports = __webpack_require__(477);


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $String = GetIntrinsic('%String%');
var $TypeError = GetIntrinsic('%TypeError%');

// https://ecma-international.org/ecma-262/6.0/#sec-tostring

module.exports = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!(module.exports = {

    ACCEPTED: 202,
    BAD_GATEWAY: 502,
    BAD_REQUEST: 400,
    BANDWIDTH_LIMIT_EXCEEDED: 509,
    CONFLICT: 409,
    CONTINUE: 100,
    CREATED: 201,
    EXPECTATION_FAILED: 417,
    FAILED_DEPENDENCY: 424,
    FORBIDDEN: 403,
    GATEWAY_TIME_OUT: 504,
    GONE: 410,
    HTTP_VERSION_NOT_SUPPORTED: 505,
    IM_A_TEAPOT: 418,
    INSUFFICIENT_STORAGE: 507,
    INTERNAL_SERVER_ERROR: 500,
    LENGTH_REQUIRED: 411,
    LOCKED: 423,
    METHOD_NOT_ALLOWED: 405,
    MOVED_PERMANENTLY: 301,
    MOVED_TEMPORARILY: 302,
    MULTIPLE_CHOICES: 300,
    MULTI_STATUS: 207,
    NETWORK_AUTHENTICATION_REQUIRED: 511,
    NON_AUTHORITATIVE_INFORMATION: 203,
    NOT_ACCEPTABLE: 406,
    NOT_EXTENDED: 510,
    NOT_FOUND: 404,
    NOT_IMPLEMENTED: 501,
    NOT_MODIFIED: 304,
    NO_CONTENT: 204,
    OK: 200,
    PARTIAL_CONTENT: 206,
    PAYMENT_REQUIRED: 402,
    PRECONDITION_FAILED: 412,
    PRECONDITION_REQUIRED: 428,
    PROCESSING: 102,
    PROXY_AUTHENTICATION_REQUIRED: 407,
    REQUESTED_RANGE_NOT_SATISFIABLE: 416,
    REQUEST_ENTITY_TOO_LARGE: 413,
    REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
    REQUEST_TIME_OUT: 408,
    REQUEST_URI_TOO_LARGE: 414,
    RESET_CONTENT: 205,
    SEE_OTHER: 303,
    SERVICE_UNAVAILABLE: 503,
    SWITCHING_PROTOCOLS: 101,
    TEMPORARY_REDIRECT: 307,
    TOO_MANY_REQUESTS: 429,
    UNAUTHORIZED: 401,
    UNORDERED_COLLECTION: 425,
    UNPROCESSABLE_ENTITY: 422,
    UNSUPPORTED_MEDIA_TYPE: 415,
    UPGRADE_REQUIRED: 426,
    USE_PROXY: 305,
    VARIANT_ALSO_NEGOTIATES: 506
});

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(100);
    var ParametersHelper = __webpack_require__(298);

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank;

    var ViewerEvents = __webpack_require__(153);
    var Window = __webpack_require__(48);

    var _require2 = __webpack_require__(1),
        each = _require2.each;

    // Register to search for illegal characters in parameters names and values, matching a similar one in the API...


    var PARAMETER_NAME = /([^a-zA-Z0-9_\- ])/; // TODO: we should disallow pre and postfixed spaces, like /(^\s|\s$|[^a-zA-Z0-9_\- ])/
    var PARAMETER_VALUE = /([^a-zA-Z0-9_.*+\-:/\\=?#&])/;

    /**
     * Action that executes a custom javascript action on the top most reachable (client) page.
     *
     * @class CustomJs
     * @constructor
     */
    var CustomJsAction = Action.extend("CustomJSAction", { // TODO: why no extend JsAction with a bit of change?

        // Note: "clientSpace" is not set to true to allow users to enter stuff like "alert(#{foo})" as well.

        defaults: {
            actionId: null, // TODO: doc
            name: "Untitled Custom JavaScript",
            code: "",
            parameters: {}, // Map<String,String> of parameter names (and associated values), e.g. {"Product ID": "abc"}
            usedBy: [] // array of experience ids
        },

        _event: ViewerEvents.JAVASCRIPT_EXECUTE,

        _activateable: function _activateable() {
            if (!this.get("code")) {
                return "Missing code";
            }
            return this.checkCode() ? "Code not runnable" : null;
        },


        /**
         * @protected
         * Activates this Custom JS action. <p>
         *
         * A JS action can ever only run when the owning Experience is embedded via channels or we will get
         * cross domain issues.
         *
         * @return {*} The result of running the code; can be falsey.
         */
        _activate: function _activate() {
            Window.run(this.getRunnableCode());
            return Object.assign({ actionId: this.id, widgetId: this.attributes.widgetId }, { data: { name: this.get("name") } });
        },


        /**
         * Merges the parameter values into the code template and returns the resulting code.
         *
         * @return {String} The runnable code as a string.
         */
        getRunnableCode: function getRunnableCode() {
            return ParametersHelper.inject(this.get("code"), this.get("parameters"));
        },


        /**
         * Checks if the current code set for this model is valid/runnable, returning null if valid
         * or the found error.
         *
         * @return {Error} The error if invalid; otherwise null.
         */
        checkCode: function checkCode() {
            return CustomJsAction.checkRunnableCode(this.get("code"), this.get("parameters"));
        }
    }, {
        TYPE: "customJs",

        /**
         * Checks if the supplied code template is valid/runnable for the supplied parameters, returning null if valid.
         *
         * @param  {String}  template    The code template to check after <tt>parameters</tt> have been injected.
         * @param  {Map}    [parameters] The parameters to optionally check; can be undefined.
         *
         * @return {Error} The error if invalid; otherwise null.
         */
        checkRunnableCode: function checkRunnableCode(template, parameters) {
            try {
                // Parameter names and values must be valid...
                if (parameters) {
                    each(parameters, function (value, name) {
                        var error = CustomJsAction.checkParameter(name, value);
                        if (error) {
                            throw error;
                        }
                    });
                }

                // Inject any arguments, allowing them to be empty...
                var code = ParametersHelper.inject(template, parameters);

                // eslint-disable-next-line no-new, no-new-func
                new Function(code);

                // And JS must be able to be serialized to/from JSON...
                var result = JSON.parse(JSON.stringify({ code: code }));

                if (result.code !== code) {
                    throw new Error("Code cannot be serialized to/from json.");
                }
                return null; // no error
            } catch (error) {
                return error;
            }
        },


        /**
         * Checks the specified parameter name and value and returns an error message if illegal,
         * otherwise returns null.
         *
         * @param  {String} name    The parameter name to check; cannot be empty.
         * @param  {String} [value] The parameter value to check; can be empty or not supplied at all, e.g. for
         *                          validation in the Editor when the Custom JS Action prototype is set up.
         *
         * @return {String} Returns null if not error, otherwise an error message.
         */
        checkParameter: function checkParameter(name, value) {
            var match = PARAMETER_NAME.exec(name);
            if (match) {
                return "Invalid parameter name: '" + match[1] + "' in '" + name + "'";
            } else if (isBlank(name)) {
                return "Parameter name cannot be empty";
            }

            if (arguments.length > 1) {
                match = PARAMETER_VALUE.exec(value);
                if (match) {
                    return "Invalid parameter value: '" + match[1] + "' in " + value;
                }
            }
            return null;
        }
    });

    return CustomJsAction;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(100);
    var ViewerEvents = __webpack_require__(153);

    var NEXT = "next";
    var PREVIOUS = "previous";

    /**
     * Action that navigates to another scene in the experience.
     *
     * @class SceneNavigationAction
     * @constructor
     */
    return Action.extend("SceneNavigationAction", {

        defaults: {
            target: NEXT
        },

        _event: ViewerEvents.SCENE_NAVIGATE,

        // Pause the current Experience and all its parent(s) on user navigation; by default, this will
        // disable auto play as well...
        _paused: true,

        /**
         * @protected
         * Activates this action.
         *
         * @param {ExperienceViewModel} experienceViewModel The view model for the experience being viewed.
         */
        _activate: function _activate(experienceViewModel) {
            var previous = experienceViewModel.get("currentScene");
            var target = this.get("target");

            if (target === NEXT) {
                experienceViewModel.goToNextScene();
            } else if (target === PREVIOUS) {
                experienceViewModel.goToPreviousScene();
            } else {
                var numScenes = experienceViewModel.get("experience").get("scenes").length;
                if (target > 0 && target <= numScenes) {
                    experienceViewModel.goToScene(target);
                }
            }

            // For event triggering...
            return Object.assign({ actionId: this.id, widgetId: this.attributes.widgetId }, { data: { target: target, current: experienceViewModel.get("currentScene"), previous: previous } });
        }
    }, {
        TYPE: "sceneNavigation",
        NEXT: NEXT,
        PREVIOUS: PREVIOUS
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);

    /**
     * The abstract base class for all editor activities.
     *
     * @class EditorActivity
     * @author Kim
     */
    return Class.extend({

        _undone: false,

        isUndone: function isUndone() {
            return this._undone;
        },

        /**
         * Undo this activity.
         */
        undo: function undo() {
            if (!this._undone) {
                this._onUndo();
                this._undone = true;
            }
        },

        /**
         * Redo this activity.
         *
         * Redo is only performed for an activity that was previously undone.
         */
        redo: function redo() {
            if (this._undone) {
                this._onRedo();
                this._undone = false;
            }
        },

        /**
         * @protected
         *
         * Protected method that performs the actual undo
         * logic, should be overridden by the subclass.
         */
        _onUndo: function _onUndo() {},

        /**
         * @protected
         *
         * Protected method that performs the actual rodo
         * logic, should be overridden by the subclass.
         */
        _onRedo: function _onRedo() {},

        /**
         * Disposes the activity.
         */
        dispose: function dispose() {}

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        clone = _require.clone,
        each = _require.each,
        isArray = _require.isArray,
        object = _require.object;

    var Preconditions = __webpack_require__(14);

    function curry(fn) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        return function () {
            for (var _len2 = arguments.length, immediateArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                immediateArgs[_key2] = arguments[_key2];
            }

            return fn.apply(undefined, _toConsumableArray(args.concat(immediateArgs)));
        };
    }

    /**
     * Removes falsy values from the provided object.
     * @param {Object} obj - Object from which falsy attributes will be removed.
     * @returns {Object} - Object without falsy attributes.
     */
    function compactObject(obj) {
        // Underscore < 1.7 required
        // return _.pick(obj, _.identity);
        var cloned = clone(obj);

        each(cloned, function (v, k) {
            if (!v) {
                delete cloned[k];
            }
        });

        return cloned;
    }

    function autoCurry(fn) {
        var numArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : fn.length;

        return function () {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            if (args.length < numArgs) {
                var rem = numArgs - args.length;

                if (numArgs - rem > 0) {
                    return autoCurry(curry.apply(undefined, _toConsumableArray([fn].concat(args))), rem);
                }

                return curry.apply(undefined, _toConsumableArray([fn].concat(args)));
            }

            return fn.apply(undefined, args);
        };
    }

    /**
     * Returns an array of n number of x's.
     *
     * Example.
     *  repeat(3, "foo");   // ["foo", "foo", "foo"]
     *
     * @param {Number} n    - The number of x's you want in the array.
     * @param {Any} x       - The content of the array.
     * @return {Array}      - Array of x's
     */
    var repeat = autoCurry(function (n, x) {
        var result = [];

        while (n--) {
            result.push(x);
        }

        return result;
    });

    /**
     * General utility functions.
     *
     * @class GeneralFunctions
     */
    return {

        /**
         * Example:
         *  _.map([1,2,3,4], eq(3))     => [false, false, true, false]
         */
        eq: autoCurry(function (a, b) {
            return a === b;
        }),

        neq: autoCurry(function (a, b) {
            return a !== b;
        }),

        add: autoCurry(function (a, b) {
            return b + a;
        }),

        subtract: autoCurry(function (a, b) {
            return b - a;
        }),

        multiply: autoCurry(function (a, b) {
            return b * a;
        }),

        divide: autoCurry(function (a, b) {
            return b / a;
        }),

        /**
         * Example:
         *  var listOfObj = [ ...list of objects with a name inside each... ];
         *  var names = _.map(listOfObj, get("name"));
         */
        get: autoCurry(function (prop, obj) {
            return obj[prop];
        }),

        /**
         * Sorts an array of numbers (Just calling .sort() will sort 100
         * before 2, this won't).
         */
        sortNumbers: function sortNumbers(list) {
            list.sort(function (a, b) {
                return a - b;
            });
            return list;
        },


        /**
         * Takes a sorted array and a value and returns the number from the array that is
         * closest to the provided value.
         *
         * Example:
         *  getClosestValue([1,4,7,8], 5)   => 4
         *
         */
        getClosestValue: autoCurry(function (arr, x) {
            var lo = -1;
            var hi = arr.length;

            while (hi - lo > 1) {
                var mid = Math.round((lo + hi) / 2);

                if (arr[mid] <= x) {
                    lo = mid;
                } else {
                    hi = mid;
                }
            }

            if (arr[lo] === x) {
                hi = lo;
            }

            // Edge cases.
            if (arr[lo] === undefined) {
                return arr[hi];
            }

            if (arr[hi] === undefined) {
                return arr[lo];
            }

            return Math.abs(arr[lo] - x) < Math.abs(arr[hi] - x) ? arr[lo] : arr[hi];
        }),

        /**
         * Curried implementation of map.
         *
         * Example:
         *  var alertAll = map(alert);
         *  alertAll([1,2,3]);      => alerts 1.. 2.. 3...
         */
        map: autoCurry(function (fn, coll) {
            return coll.map(fn);
        }),

        /**
         * You give it a function and an object and it returns a new object with the same keys,
         * and the functions having been run on each value
         *
         * Example:
         *      mapOverObj(function(n){return n+1}, {one:1, two:2})     => {one:2, two: 3}
         *
         */
        mapOverObj: autoCurry(function (fn, obj) {
            var result = {};
            Preconditions.isFunction(fn);

            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    result[key] = fn(obj[key]);
                }
            }

            return result;
        }),

        repeat: repeat,

        // This is different from the underscore version, as it will cut off the longest array
        // to fit the size of the shorter.
        zip: autoCurry(function (arr, arr2) {
            var result = [];
            var len = Math.min(arr.length, arr2.length);
            var i = -1;

            while (++i < len) {
                result.push([arr[i], arr2[i]]);
            }

            return result;
        }),

        /**
         * Takes two arrays, one of keys, and one of values. The items in the
         * keys array are expected to be unique. It will return an object with
         * the items from the keys aray as keys, and the items in the values
         * array as the matching values.
         *
         * Alternatively, the "values" array can be a single value, which will
         * then be repeated as the value for each key.
         *
         * Example.
         *  arraysToObj(["one", "two"], [1, 2])     => {one: 1, two: 2}
         *  arraysToObj(["one", "two"], "foo")      => {one: "foo", two: "foo"}
         *
         * @param {Array} keys      Array of values that will be used as keys.
         * @param {Array|*} values  Array of values, or single value.
         * @returns {Object}        See example above.
         */
        arraysToObj: autoCurry(function (keys, values) {
            if (!isArray(values)) {
                values = repeat(keys.length, values);
            }

            return object(keys, values);
        }),

        /**
         * Call curry on any function and it will be a curried version of it.
         *
         * Examples:
         *      var add = function (x, y) { return x+y }
         *      add(5, 2)                       => 7
         *      add(5)(2)                       => NaN  (Not what you want)
         *      var curriedAdd = curry(add);
         *      curriedAdd(5, 2)                => 7
         *      curriedAdd(5)(2)                => 7
         *
         *      var add = curry(function (x, y) { return x+y });
         *      _.map([1, 2, 3], add(2))        => [3, 5, 6]
         */
        curry: autoCurry,

        compactObject: compactObject
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var Preconditions = __webpack_require__(14);

    return Class.extend({}, {
        rgbaToHex: function rgbaToHex(rgba) {
            Preconditions.checkArguments(rgba);

            var _parseRgba = this.parseRgba(rgba),
                r = _parseRgba.r,
                g = _parseRgba.g,
                b = _parseRgba.b,
                a = _parseRgba.a;

            var hex = "#" + this._componentToHex(r) + this._componentToHex(g) + this._componentToHex(b);

            return {
                hex: hex,
                a: a
            };
        },
        isValidHex: function isValidHex(hex, prefixed) {
            var result = true;

            if (prefixed) {
                if (hex.charAt(0) !== "#") {
                    result = false;
                }

                hex = hex.slice(1);
            }

            if (hex.length !== 3 && hex.length !== 6) {
                result = false;
            }

            hex.split("").forEach(function (character) {
                var to16 = parseInt(character, 16);
                if (to16 > 15 || isNaN(to16)) {
                    result = false;
                }
            });

            return result;
        },
        hexToRgba: function hexToRgba(hex, alpha) {
            Preconditions.checkArguments(hex, alpha);
            Preconditions.condition(".length === 7", hex);

            alpha = parseFloat(alpha, 10);
            if (alpha < 0) alpha = 0;
            if (alpha > 1) alpha = 1;

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            var rgbObj = {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            };

            return "rgba(" + rgbObj.r + ", " + rgbObj.g + ", " + rgbObj.b + ", " + alpha + ")";
        },
        parseRgba: function parseRgba(rgba) {
            var numberMatches = rgba.match(/(?:\d*\.)?\d+/g);
            var rgbaArray = numberMatches.map(function (str) {
                return parseFloat(str, 10);
            });

            // Alpha is set to undefined, it isn't used anywhere in the code for now.
            // But the old implementation did return the property.
            return {
                r: rgbaArray[0],
                g: rgbaArray[1],
                b: rgbaArray[2],
                a: rgbaArray[3] || undefined
            };
        },
        formatRgbaToHex: function formatRgbaToHex(_ref) {
            var r = _ref.r,
                g = _ref.g,
                b = _ref.b;

            return "#" + this._componentToHex(r) + this._componentToHex(g) + this._componentToHex(b);
        },
        formatRgbaToStyle: function formatRgbaToStyle(_ref2) {
            var r = _ref2.r,
                g = _ref2.g,
                b = _ref2.b,
                a = _ref2.a;

            return "rgba(" + r + "," + g + "," + b + "," + (a || 1) + ")";
        },
        _componentToHex: function _componentToHex(c) {
            var hex = c.toString(16);
            return hex.length === 1 ? "0" + hex : hex;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(303),
    getRawTag = __webpack_require__(1449),
    objectToString = __webpack_require__(1450);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 196 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        Class = __webpack_require__(26),
        EditorEvents = __webpack_require__(17),
        Keyboard = __webpack_require__(243);

    var MAX_ENTRIES = 10;

    /**
     * The EditorActivityManager keeps track of certain activities inside the
     * editor, providing undo/redo functionality.
     *
     * @class EditorActivityManager
     * @author Kim
     */
    var EditorActivityManager = Class.extend({

        /**
         * The internal state/index.
         *
         * @type {Number}
         */
        _index: 0,

        /**
         * List of activities.
         *
         * @type {Array} Array of <tt>EditorActivity</tt>.
         */
        _entries: [],

        /**
         * The unique id is needed to mark activity as part of batch of activities.
         *
         * @type {String}
         */
        _batchActivityId: null,

        /**
         * Constructor.
         */
        constructor: function constructor() {
            var self = this;

            // Convenience method for creating a shortcut handler that will only invoke the callback if the
            // document's active element does not have native support for undo/redo
            function handler(callback) {
                return function () {
                    // Returning true will perform the default browser behavior
                    return self._hasNativeSupport() ? true : callback.call(self, true);
                };
            }
            Keyboard.Shortcut.bind(["ctrl+z", "meta+z"], handler(this.undo));
            Keyboard.Shortcut.bind(["ctrl+y", "meta+y"], handler(this.redo));
        },

        getUndoRedoButtons: function getUndoRedoButtons() {
            this.undoButton = document.getElementsByClassName("editor-undo")[0];
            this.redoButton = document.getElementsByClassName("editor-redo")[0];
        },
        enableDisableUndoRedoButtons: function enableDisableUndoRedoButtons() {
            if (!this.undoButton || !this.redoButton) {
                this.getUndoRedoButtons();
            }

            if (this.undoButton) {
                if (this.canUndo()) {
                    this.undoButton.classList.remove("disabled");
                } else {
                    this.undoButton.classList.add("disabled");
                }
            }

            if (this.redoButton) {
                if (this.canRedo()) {
                    this.redoButton.classList.remove("disabled");
                } else {
                    this.redoButton.classList.add("disabled");
                }
            }
        },


        _hasNativeSupport: function _hasNativeSupport() {
            return $(document.activeElement).is(":input") || window.getSelection().type === "Range";
        },

        /**
         * Detects undo/redo events on Dynamic Product Widgets and performs required steps to
         * ensure the parent widget behaves properly.
         * activity, i.e. any subsequent #undo call will invoke the activity's undo method.
         *
         * @param {EditorActivity} activity The activity to inspect for a Dynamic Product Widget update.
         */
        _updateDynamicProductWidgets: function _updateDynamicProductWidgets(activity) {
            var _widgetModel = activity._widgetModel;

            if (_widgetModel && _widgetModel.attributes && _widgetModel.attributes.subtype) {
                // Dynamic Product sub widgets have the "subtype" attribute.
                // Triggering the "transformed" is required to adjust the parent widget's selection box.
                activity._widgetModel.trigger("transformed");
            }
        },

        _getWidgetType: function _getWidgetType(activity) {
            var widgetModelType = activity._widgetModel ? activity._widgetModel.get("type") : activity._widgetModels[0].get("type");
            return activity.widgetType || widgetModelType;
        },


        getActivity: function getActivity(index) {
            return this._entries[index];
        },

        setBatchActivityId: function setBatchActivityId(batchActivityId) {
            this._batchActivityId = batchActivityId;
        },


        /**
         * You cannot undo, if there are no activities yet or if your current state
         * is the oldest activity.
         *
         * @return {Boolean} Returns true, if redo is a doable action
         */
        canUndo: function canUndo() {
            return !(this._entries.length === 0 || this._index === this._entries.length);
        },

        /**
         * You cannot redo, if your current state is the latest activity.
         *
         * @return {Boolean} Returns true, if redo is a doable action
         */
        canRedo: function canRedo() {
            return this._index !== 0;
        },

        /**
         * Adds/registers an activity. The activity will be added as the most recent
         * activity, i.e. any subsequent #undo call will invoke the activity's undo method.
         *
         * @param {EditorActivity} activity The activity to add.
         */
        add: function add(activity) {
            activity._batchActivityId = this._batchActivityId;
            // Add the activity at the current state/index of the list of entries
            this._entries.splice(this._index, 0, activity);

            if (this._entries.length > MAX_ENTRIES) {
                var leastRecentActivity = this._entries.pop();
                leastRecentActivity.dispose();
            }

            this.enableDisableUndoRedoButtons();
        },

        /**
         * Undo the most recent activity.
         * @param {Boolean} keyboard, whether the event was triggered by a keyboard pressure
         * @returns {Boolean} Always false, to prevent default browser behaviour.
         */
        undo: function undo(keyboard) {
            var activity = this.getActivity(this._index);

            if (activity && !activity.isUndone()) {
                activity.undo();
                this._updateDynamicProductWidgets(activity);
                this._index = Math.min(this._entries.length, this._index + 1);

                var eventProperties = {
                    triggerOrigin: keyboard ? "KeyPress" : "EditorContextRightClickMenu",
                    widgetType: this._getWidgetType(activity),
                    changedAttributes: activity._changedAttributes
                };

                EditorEvents.trigger(EditorEvents.constants.UNDO_ACTIVITY, eventProperties);

                var prevActivity = this.getActivity(this._index);
                if (prevActivity && prevActivity._batchActivityId && prevActivity._batchActivityId === activity._batchActivityId) {
                    this.undo(keyboard);
                }
            }
            this.enableDisableUndoRedoButtons();
            // Prevent default browser behavior
            return false;
        },

        /**
         * Redo what was recently undone.
         * @param {Boolean} keyboard, whether the event was triggered by a keyboard pressure
         * @returns {Boolean} Always false, to prevent default browser behaviour.
         */
        redo: function redo(keyboard) {
            var index = Math.max(0, this._index - 1),
                activity = this.getActivity(index);

            if (activity && activity.isUndone()) {
                activity.redo();
                this._updateDynamicProductWidgets(activity);
                this._index = index;

                var eventProperties = {
                    triggerOrigin: keyboard ? "KeyPress" : "EditorContextRightClickMenu",
                    widgetType: this._getWidgetType(activity),
                    changedAttributes: activity._changedAttributes
                };

                EditorEvents.trigger(EditorEvents.constants.REDO_ACTIVITY, eventProperties);

                var nextActivity = this.getActivity(this._index - 1);
                if (nextActivity && nextActivity._batchActivityId && nextActivity._batchActivityId === activity._batchActivityId) {
                    this.redo(keyboard);
                }
            }
            this.enableDisableUndoRedoButtons();
            // Prevent default browser behavior
            return false;
        },

        /**
         * Clears all activies. Resetting the state of the activity manager.
         */
        clear: function clear() {
            _.invoke(this._entries, "dispose");

            this._entries = [];
            this._index = 0;
            this.undoButton = null;
            this.redoButton = null;
        }

    });

    // Singleton
    return new EditorActivityManager();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1486),
    getValue = __webpack_require__(1489);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(310)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = uncontrollable;

var _react = _interopRequireDefault(__webpack_require__(0));

var _invariant = _interopRequireDefault(__webpack_require__(138));

var Utils = _interopRequireWildcard(__webpack_require__(1540));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var isCompositeComponent = Utils.isReactComponent(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(isCompositeComponent || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          _this._values[propName] = value;
          if (!_this.unmounted) _this.forceUpdate();
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (isCompositeComponent) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let the forceUpdate trigger the update
      return !this._notifying;
    };

    _proto.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var props = this.props;
      this._values = Object.create(null);
      controlledProps.forEach(function (key) {
        _this2._values[key] = props[Utils.defaultKey(key)];
      });
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var props = this.props;
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        if (!Utils.isProp(nextProps, key) && Utils.isProp(props, key)) {
          _this3._values[key] = nextProps[Utils.defaultKey(key)];
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.getControlledInstance = function getControlledInstance() {
      return this.inner;
    };

    _proto.render = function render() {
      var _this4 = this;

      var props = _extends({}, this.props);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this4.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this4._values[propName];
      });
      return _react.default.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(_react.default.Component);

  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = Utils.uncontrolledPropTypes(controlledValues, displayName);
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _inner;

      return (_inner = this.inner)[method].apply(_inner, arguments);
    };
  });
  UncontrolledComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  UncontrolledComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return UncontrolledComponent;
}

module.exports = exports["default"];

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1544);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(806)('wks');
var uid = __webpack_require__(808);
var Symbol = __webpack_require__(254).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    // Covert a scientific numbers to a decimal number such as 1.0e-6 to 0.000001

    function scitodec(n) {
        n = String(n);
        var info = /([\d\.]+)e-(\d+)/i.exec(n);
        if (!info) {
            return n;
        }

        var num = info[1].replace(".", ""),
            numDecs = info[2] - 1;
        var output = "0.";
        for (var i = 0; i < numDecs; i++) {
            output += "0";
        }
        output += num;

        return output;
    }

    /**
     * Home-made Matrix class, for matrix computations and manipulations
     *
     * @param a
     * @param b
     * @param c
     * @param d
     * @param x
     * @param y
     * @constructor  create a new matrix
     */
    function Matrix(a, b, c, d, x, y) {
        this.a = a != null ? a : 1;
        this.b = b || 0;
        this.c = c || 0;
        this.d = d != null ? d : 1;
        this.x = x || 0;
        this.y = y || 0;
    }

    Matrix.createFromString = function (matrix) {
        var m = new Matrix(),
            mVal = matrix && matrix.match(/\((.*?)\)/);

        if (mVal) {
            var mArray = mVal[1].split(",");

            m.a = parseFloat(mArray[0]);
            m.b = parseFloat(mArray[1]);
            m.c = parseFloat(mArray[2]);
            m.d = parseFloat(mArray[3]);
            m.x = parseFloat(mArray[4]);
            m.y = parseFloat(mArray[5]);
        }
        return m;
    };

    Matrix.createFromDom = function (ele) {
        var st = window.getComputedStyle(ele, null),
            m = st.getPropertyValue("-webkit-transform") || st.getPropertyValue("-moz-transform") || st.getPropertyValue("-ms-transform") || st.getPropertyValue("-o-transform") || st.getPropertyValue("transform");

        return Matrix.createFromString(m);
    };

    Matrix.prototype = {

        copyFrom: function copyFrom(m) {
            this.a = m.a;
            this.b = m.b;
            this.c = m.c;
            this.d = m.d;
            this.x = m.x;
            this.y = m.y;
        },

        identity: function identity() {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.x = 0;
            this.y = 0;
        },

        rotate: function rotate(angle) {
            var u = Math.cos(angle),
                v = Math.sin(angle);

            var temp = this.a;
            this.a = u * this.a - v * this.b;
            this.b = v * temp + u * this.b;

            temp = this.c;
            this.c = u * this.c - v * this.d;
            this.d = v * temp + u * this.d;

            temp = this.x;
            this.x = u * this.x - v * this.y;
            this.y = v * temp + u * this.y;
        },

        rotateCenter: function rotateCenter(angle) {
            var u = Math.cos(angle),
                v = Math.sin(angle);

            var temp = this.a;
            this.a = u * this.a - v * this.b;
            this.b = v * temp + u * this.b;

            temp = this.c;
            this.c = u * this.c - v * this.d;
            this.d = v * temp + u * this.d;
        },

        translate: function translate(x, y) {
            this.x += x;
            this.y += y;
        },

        scale: function scale(x, y) {
            this.a *= x;
            this.b *= y;
            this.c *= x;
            this.d *= y;
            this.x *= x;
            this.y *= y;
        },

        scaleSize: function scaleSize(x, y) {
            this.a *= x;
            this.b *= y;
            this.c *= x;
            this.d *= y;
        },

        concat: function concat(m) {
            var a = this.a * m.a,
                b = 0,
                c = 0,
                d = this.d * m.d,
                x = this.x * m.a + m.x,
                y = this.y * m.d + m.y;

            if (this.b !== 0 || this.c !== 0 || m.b !== 0 || m.c !== 0) {
                a += this.b * m.c;
                d += this.c * m.b;
                b += this.a * m.b + this.b * m.d;
                c += this.c * m.a + this.d * m.c;
                x += this.y * m.c;
                y += this.x * m.b;
            }

            this.a = a;
            this.b = b;
            this.c = c;
            this.d = d;
            this.x = x;
            this.y = y;
        },

        invert: function invert() {
            if (this.b === 0 && this.c === 0 && this.a !== 0 && this.d !== 0) {
                this.a = 1 / this.a;
                this.d = 1 / this.d;
                this.b = 0;
                this.c = 0;
                this.x = -this.a * this.x;
                this.y = -this.d * this.y;
            } else {
                var det = this.a * this.d - this.b * this.c;
                if (det === 0) {
                    this.identity();
                    return;
                }
                det = 1 / det;

                var temp = this.a;
                this.a = this.d * det;
                this.b = -this.b * det;
                this.c = -this.c * det;
                this.d = temp * det;

                temp = this.y;
                this.y = -(this.b * this.x + this.d * this.y);
                this.x = -(this.a * this.x + this.c * temp);
            }
        },

        // if a value is represented as the format 1.0e-15, normalize to
        // float value to prevent inaccurate string representation.
        toString: function toString() {
            var m = this.clone();
            m.a = scitodec(m.a);
            m.b = scitodec(m.b);
            m.c = scitodec(m.c);
            m.d = scitodec(m.d);

            return "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.x + "," + m.y + ")";
        },
        // if a value is represented as the format 1.0e-15, normalize to
        // float value to prevent inaccurate string representation.
        to3dString: function to3dString() {
            var m = this.clone();
            m.a = scitodec(m.a);
            m.d = scitodec(m.d);

            return "scale3d(" + m.a + "," + m.d + ",1) translate(" + m.x + "px," + m.y + "px)";
        },

        equals: function equals(m) {
            return this.a === m.a && this.b === m.b && this.c === m.c && this.d === m.d && this.x === m.x && this.y === m.y;
        },

        clone: function clone() {
            return new Matrix(this.a, this.b, this.c, this.d, this.x, this.y);
        },

        containsPoint: function containsPoint(x, y, w, h) {
            // find mouse in local target space
            // and check within bounds of that area
            var inv = new Matrix(); // use pooled Matrix to reduce allocations
            inv.copyFrom(this);
            inv.invert();

            var tx = inv.x + inv.a * x + inv.c * y,
                ty = inv.y + inv.d * y + inv.b * x;

            // compare locations in non-transformed space (inverted)
            return tx >= 0 && tx <= w && ty >= 0 && ty <= h;
        },

        getRotationX: function getRotationX() {
            return Math.atan2(this.b, this.a);
        },

        getRotationY: function getRotationY() {
            return Math.atan2(this.c, this.d);
        },

        getRotation: function getRotation() {
            return Math.atan2(this.b, this.a) * (180 / Math.PI);
        },

        getScaleX: function getScaleX() {
            return Math.sqrt(this.a * this.a + this.b * this.b);
        },

        getScaleY: function getScaleY() {
            return Math.sqrt(this.c * this.c + this.d * this.d);
        },

        getGlobalCoordByLocalCoord: function getGlobalCoordByLocalCoord(x, y) {
            return {
                x: this.x + this.a * x + this.c * y,
                y: this.y + this.d * y + this.b * x
            };
        }
    };

    return Matrix;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        ActionFactory = __webpack_require__(358),
        ActionHelper = __webpack_require__(856),
        ActionsView = __webpack_require__(1718),
        EffectsView = __webpack_require__(1721),
        LoggedInUserState = __webpack_require__(19),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        template = __webpack_require__(1753),
        AbstractWidgetPropertiesView = __webpack_require__(63);


    var log = new Logger("ActionPropertiesView");

    var EXPAND_PROPERTY = "actionExpanded";

    /**
     * The actions collapsible containing the actions drop down menu and the properties view for
     * the selected action.
     */
    return AbstractWidgetPropertiesView.extend("ActionPropertiesView", {
        expandProperty: EXPAND_PROPERTY,

        template: template,

        templateHelpers: function templateHelpers() {
            var panelName = this.options.onlyShowProductActions ? "Product Actions" : "Actions";

            return {
                panelName: panelName,
                showEffects: this.options.showEffects
            };
        },

        regions: {
            actionsRegion: ".actions-region",
            effectsRegion: ".effects-region",
            onLoadsRegion: ".onloads-region"
        },

        ui: {
            container: ".action-properties-accordion",
            legend: "[data-target=\".action-properties-accordion\"]"
        },

        initialize: function initialize() {
            this.options = _.defaults(this.options, {
                onlyShowProductActions: false,
                showEffects: true
            });
        },

        onRender: function onRender() {
            this.__super();

            // Actions are not supported on the background scene
            if (this.viewScope.viewModel.get("isBackgroundScene")) {
                this.$el.hide();
            }
        },

        _showActionView: function _showActionView() {
            this.actionsRegion.show(new ActionsView({
                model: this.model,
                onlyShowProductActions: this.options.onlyShowProductActions
            }));
        },


        onShow: function onShow() {
            var _this = this;

            this.__super();

            this.listenTo(this.viewScope.viewModel.get("experience"), "change:emailModeEnabled", function () {
                _this._showActionView();
            });

            if (this.model.get("defaultActionId") && !this.model.get("defaultValueHasBeenSet")) {
                this._setDefaultAction();
            }

            if (this.options.showEffects) {
                this.effectsRegion.show(new EffectsView({ model: this.model, viewModel: this.viewScope.viewModel }));
            }

            this._showActionView();

            this.onLoadsRegion.show(this._setOnLoadAction({ model: this.model }));
        },

        _setDefaultAction: function _setDefaultAction() {
            this.model.set("defaultValueHasBeenSet", true);

            // Guard against the defaultActionId not being configured correctly.
            var prototypeAction = LoggedInUserState.get("prototypeActionCollection").findWhere({ "id": this.model.get("defaultActionId") });
            if (prototypeAction === undefined) {
                log.warn("The default action with ID '" + this.model.get("defaultActionId") + "' was not found.");
                return;
            }

            // Matches what Action.getIndetifier() returns.
            var actionIdentifier = {
                actionId: this.model.get("defaultActionId"),
                type: prototypeAction.get("action").get("type")
            };
            var options = ActionHelper.getActionOptions(actionIdentifier);
            var defaultAction = ActionFactory.newActionFromType(actionIdentifier.type, options);

            this.model.set("action", defaultAction);
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        contains = _require.contains,
        isString = _require.isString,
        extend = _require.extend,
        Class = __webpack_require__(26),
        GUID = __webpack_require__(858),
        LoggedInUserState = __webpack_require__(19),
        _require2 = __webpack_require__(24),
        Logger = _require2.Logger,
        Permissions = __webpack_require__(22),
        Preconditions = __webpack_require__(14),
        Promise = __webpack_require__(21),
        _require3 = __webpack_require__(30),
        isBlank = _require3.isBlank,
        Syncer = __webpack_require__(50),
        SyncManager = __webpack_require__(44),
        UrlUtil = __webpack_require__(46);

    var DEFAULT_SITE_ID = "SiteGenesis",
        SHOP_PREFIX = "/s/" + DEFAULT_SITE_ID + "/dw/shop/",
        log = new Logger("SalesforceCommerce");

    /**
     * @class {SalesforceCommerce}
     * A <i>connect</i> that will handle all connections for SalesforceCommerce. <p>
     * <ul>
     *     <li> Possibility to connect to the <tt>SalesforceCommerce Open Commerce Api</tt>.
     *     <li> Test connections given urls or clients.
     *     <li> Try to infer the  SalesforceCommerce web address.
     *     <li> Validate the settings of a conn\ection like clientId or Url.
     * </ul>
     * @author Pedro Augusto/ <a href="http://www.zmags.com">Zmags</a>
     */
    var SalesforceCommerce = Class.extend("SalesforceCommerce", {

        /**
         * {SalesforceCommerceSettingsModel} SalesforceCommerce settings model
         */
        getSettings: function getSettings() {
            /** @see {WidgetTypes.SALESFORCE_COMMERCE} */
            return LoggedInUserState.get("companySettings").demandware();
        },

        /**
         * Returns the SalesforceCommerce site id based on the internal site Id (the Mongo ObjectId of the site).
         * @param {String} siteObjectId the site Id to search for.
         * @returns {String} the siteId if it can be found or undefined if not or the company does not have any sites.
         */
        getSiteByObjectId: function getSiteByObjectId(siteObjectId) {
            if (!siteObjectId) {
                return null;
            }
            var sites = this.getSettings().get("sites");

            if (sites) {
                var site = sites.get(siteObjectId);
                return site ? site.get("siteId") : null;
            }
            return null;
        },

        /**
         * Versions of the SalesforceCommerceApi where the widget was tested.
         */
        supportedVersions: ["v15_1", "v15_2", "v15_4", "v14_8", "v14_6", "v14_2"],

        /**
         * Generate possibilities according to the url provided by the user.
         * Those possibilities are the SalesforceCommerce versions tested by this API.
         *
         * TODO - remove these possibilities check if we expose versioning on the integrations page.
         *
         * @param {String} url The url for the SalesforceCommerce service endpoint.
         * @param {String} siteId The id of the SalesforceCommerce site it's trying to connect to.
         * @return {String[]} The array of url possibilities; never falsey, never empty.
         */
        generatePossibilities: function generatePossibilities(url, siteId) {
            Preconditions.checkArgument(url);

            var self = this,
                shopPrefix = SHOP_PREFIX,
                possibilities = [],

            // If there aren't http or https, it will include https.
            newUrl = UrlUtil.prependHTTP(url, true),

            // Given an URL it will generate possibilities for all supported versions.
            generateUrlsByDifferentBaseAddress = function generateUrlsByDifferentBaseAddress(url) {
                self.supportedVersions.forEach(function (version) {
                    possibilities.push(UrlUtil.concat(url, shopPrefix, version) + "/");
                });
            };

            if (siteId) {
                shopPrefix = SHOP_PREFIX.replace(DEFAULT_SITE_ID, siteId);
            }

            // OK, I will generate combinations for the first set of address.
            generateUrlsByDifferentBaseAddress(newUrl);

            // Well, but if base url was modified it means that the userUrl didn't contains a https OR http.
            if (newUrl !== url) {
                // This is not the perfect scenario, but let' try to connect using HTTP.
                newUrl = UrlUtil.prependHTTP(url);

                // Generate again all possibilities for http.
                generateUrlsByDifferentBaseAddress(newUrl);
            }

            return possibilities;
        },

        /**
         * Extract the version give a SalesforceCommerce url.
         * @param {String} url
         */
        extractVersion: function extractVersion(url) {
            Preconditions.checkArgument(url);

            var regex = new RegExp("/dw/shop/(.*)+/"),
                matches = regex.exec(url);

            return matches ? matches[1] : matches;
        },

        /**
         * Returns true if the supplied client id is a valid SalesforceCommerce client id (UUID), false otherwise.
         *
         * @return {Boolean} True if valid, false otherwise.
         */
        validateClientId: function validateClientId(clientId) {
            return isString(clientId) && GUID.validate(clientId);
        },

        /**
         * Validate if url is null or a supported version.
         * @param {String} url address provided by the user.
         * @return {String} Returns true if the supplied url has a supported version, false otherwise.
         */
        validateUrl: function validateUrl(url) {
            var error = null,
                version = this.extractVersion(url);

            if (!url || isBlank(url)) {
                error = "You must provide a valid Salesforce Commerce Cloud address";
            } else if (version) {
                if (!contains(this.supportedVersions, version)) {
                    error = "The version " + version + " is not supported";
                    log.info("Cannot use unsupported version of Salesforce Commerce Cloud: " + version);
                }
            }

            return error;
        },

        /**
         * Validate basic parameters of the server settings. It won't try to connect
         * for the SalesforceCommerce Server, however, it will validate at least if there are
         * parameters passed.
         *
         * @param {SalesforceCommerceSettingsModel} settings to be validated.
         * @return {Boolean} True if valid, false otherwise.
         */
        validateServerSettings: function validateServerSettings(settings) {
            Preconditions.checkArgument(settings);

            log.info("Validating for Client ID", settings.get("clientId"), " userUrl ", settings.get("userUrl"));

            return this.validateClientId(settings.get("clientId")) && !this.validateUrl(settings.get("userUrl"));
        },

        /**
         * The system will try to connect for the address provided for the url,
         * but it will also try to connect for some address possibilities.
         * For example, if the user inputs: <p>
         *   input:   salesforcecommerce.zmags.com <p>
         *   output:<p>
         * <ol>
         * <li>http://salesforcecommerce.zmags.com/  (invalid, but user friendly)
         * <li>http://salesforcecommerce.zmags.com/dw/shop/v15_1/ (valid)
         * <li> The system will take this as a priority. The reason why this version of the WebApi is a priority is
         * because was the one used for develop this app. However, the system was also tested with other api versions.
         * <li> http://salesforcecommerce.zmags.com/dw/shop/v15_2/ (valid)
         * <li>  http://salesforcecommerce.zmags.com/dw/shop/v15_4/ (valid)
         * </ol>
         * @param {String} url provided for the user.
         * @param {String} clientId SalesforceCommerce clientId.
         * @return {Promise} A promise that will resolve with the resolved url.
         */
        inferAddress: function inferAddress(url, clientId, siteId) {
            var self = this,
                possibilities = this.generatePossibilities(url, siteId),
                deferred = Promise.deferred();

            log.info("Infer address for: " + possibilities);

            var tryConnect = function tryConnect(possibility) {
                log.info("Testing: <" + possibility + ">...");

                self.testConnect(possibility, clientId).done(function () {
                    log.info("Success, could connect to: <" + possibility + ">");

                    deferred.resolve(possibility);
                }).fail(function () {
                    log.info("Fail, could not connect to: <" + possibility + ">");

                    if (possibilities.length === 0) {
                        deferred.reject();
                    } else {
                        tryConnect(possibilities.shift());
                    }
                });
            };

            if (possibilities.length > 0) {
                tryConnect(possibilities.shift());
            }

            return deferred.promise();
        },

        /**
         * Wrapper function to call the restApi.
         *
         * @param {Object} options (method,url(sufix of the webapi))
         * @return {Promise} A promise that will resolve once the api call completes/fails.
         */
        callRestApi: function callRestApi(options) {
            var settings = this.getSettings(),
                baseURL = settings.get("webApiUrl"),
                data = extend({
                // eslint-disable-next-line camelcase
                client_id: settings.get("clientId"),
                expand: "images,prices,availability"
            }, options.data);

            if (options.siteId) {
                baseURL = baseURL.replace(DEFAULT_SITE_ID, options.siteId);
            }

            return this._call({
                method: options.method,
                fn: {
                    url: baseURL + options.url,
                    type: "GET",
                    data: data,
                    dataType: "json"
                },
                privilege: Permissions.Privileges.CREATE,
                resultHandler: options.resultHandler,
                errorHandler: function errorHandler() {
                    return false;
                }
            }, options.args);
        },

        /**
         * Test connections with a SalesforceCommerce server.
         *
         * @param {String} url with the SalesforceCommerce server address
         * @param {String} clientId allowed to crossdomain communication.
         * @return {Promise} returns a Promise.
         */
        testConnect: function testConnect(url, clientId) {
            return this._call({
                method: "connect",
                options: {
                    // The default timeout of SyncManager is 20seconds, but 3 seconds
                    // must to be enough to validate a connection.
                    timeout: 3000
                },
                fn: {
                    url: UrlUtil.concat(url, "product_search"),
                    type: "GET",
                    // eslint-disable-next-line camelcase
                    data: { q: "", client_id: clientId },
                    dataType: "json"
                },
                errorHandler: function errorHandler() {
                    return false;
                }
            });
        },

        /**
         * @private
         * Invoke the SyncManager creating an queue for each request.
         *
         * @param  {Object} request The request to execute using its own queue; never falsey.
         * @param  {Object} [id]    The id to queue on, e.g. a product id or a search term. Can be falsey.
         * @return {Promise} A promise that will resolve once the request (queue) is empty.
         */
        _call: function _call(request, id) {
            // Create a target to queue on, primed with supplied id, if any. This means that we will queue based on
            // the id only, e.g. a product id, so two different products can be fetched concurrently.
            var target = {
                id: id,
                toString: function toString() {
                    var s = "SalesforceCommerce[method: " + request.method;
                    if (id) {
                        s += "; arg: '" + id + "'";
                    }
                    return s + "]";
                }
            };

            Syncer.State.init(target, { unique: ["id"] });

            // Get queue for this connector.
            var queue = SyncManager.queue(target);

            // Execute the specific request and get a promise for when it is done.
            var promise = queue.enqueue(request);

            // Start sync, if not already
            queue.sync();

            // Return the promise for "request" (not for the entire queue)
            return promise;
        },

        isWidgetEnabled: function isWidgetEnabled() {
            return this.getSettings().get("enabled");
        },

        isQuickViewEnabled: function isQuickViewEnabled() {
            return this.getSettings().get("enabled");
        }
    });

    return new SalesforceCommerce();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var template = __webpack_require__(1730);

    /**
     * View class for when the user has applied a filter to a collection that returns no results.
     *
     * @class NoResultsItemView
     * @constructor
     *
     * @cfg {String} [noResultsMessage] The message to display in the view.
     * @cfg {String} [type] The type to display in the default message (could be Experiences/Images/Projects/Contents).
     */
    return Marionette.ItemView.extend({
        className: "no-result-message",

        template: template,

        ui: {
            message: ".message"
        },

        onRender: function onRender() {
            var _options = this.options,
                noResultsMessage = _options.noResultsMessage,
                type = _options.type;

            this.ui.message.text(noResultsMessage || "No " + type + " found.");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var $ = __webpack_require__(4);
    var Color = __webpack_require__(194);
    var EditorEvents = __webpack_require__(17);
    var KeyCode = __webpack_require__(88);

    var DEFAULT_COLOR = "#000000";
    var COLOR_LIBRARY_HEX = [["#000000", "#626262", "#9b9b9b", "#dbdbdb", "#eeeeee", "#ffffff", "transparent"], // row 1
    ["#5d393f", "#4f483f", "#4d523f", "#20523f", "#20393f", "#203958", "#5d395e"], // row 2
    ["#b9615a", "#c19d32", "#bfc200", "#00ab57", "#3e92c8", "#4463bd", "#b961af"], // row 3
    ["#ff615a", "#ffc32c", "#ffff00", "#43d76d", "#50cdff", "#5f89ff", "#ff61e3"], // row 4
    ["#ffa59a", "#ffd496", "#f8ee87", "#92ea92", "#a4e5f4", "#bfdcff", "#f2ceda"], // row 5
    ["#ffefe7", "#fff7d8", "#ffffc4", "#d9ffde", "#e3fbff", "#e3ecff", "#fceeff"] // row 6
    ];

    return Class.extend({
        _color: null,
        _input: null,
        _colorBox: null,
        _library: null,
        _includeTransparency: false,

        _trackingName: null,
        _trackHexKeyUp: false,
        _trackColorLibraryClick: false,

        constructor: function constructor(args) {
            this._color = args.color;
            this._input = args.input;
            this._colorBox = args.colorBox;
            this._includeTransparency = !!args.includeTransparency;

            this._setupColorpicker(args.color);

            if (args.library) {
                this._library = args.library;
                COLOR_LIBRARY_HEX.forEach(this._addRowOfColorSquaresToLibrary.bind(this));
            }

            // Set up listeners
            this._eventListeners();

            if (args.tracking) {
                this._trackingName = args.tracking;
                this._setUpTracking();
            }
        },


        // Sets up event listeners
        _eventListeners: function _eventListeners() {
            this._input.on("changeColor", this._colorpickerHandler.bind(this)).on("keyup", this._keyupEventHandler.bind(this));

            this._colorBox.on("click", this._colorBoxHandler.bind(this));

            if (this._library) {
                this._library.on("click", this._colorLibraryHandler.bind(this));
            }
        },


        // HANDLERS

        // ColorPicker handler
        _colorpickerHandler: function _colorpickerHandler(event) {
            var color = event.color.toHex();

            this._input.val(color).trigger("change");
            this._updateColorBox(color);
            this._updateSelectedLibraryColor();
        },


        // Input field handler
        _keyupEventHandler: function _keyupEventHandler(event) {
            var color = event.target.value;

            switch (event.keyCode) {
                case KeyCode.LEFT:
                case KeyCode.RIGHT:
                case KeyCode.UP:
                case KeyCode.DOWN:
                    return;
                default:
                    if (this._isValidHex(color)) {
                        this._triggerChange();
                        this._updateColorBox(color);
                    }
                    this._updateSelectedLibraryColor();
            }
        },


        // Color box handler (the tiny box next to the input field)
        _colorBoxHandler: function _colorBoxHandler() {
            this._input.trigger("focus");
        },


        // Clicking on the colored squares in the library (if it's included)
        _colorLibraryHandler: function _colorLibraryHandler(event) {
            var target = $(event.target);
            var color = target.data("transparent") ? "transparent" : Color.rgbaToHex(target.css("background-color")).hex;

            if (target.prop("tagName") !== "SPAN") return;

            if (this._isTransparent(color)) {
                this._input.val("");
            } else {
                this._input.colorpicker("setValue", color);
            }
            this._triggerChange();
            this._updateColorBox(color);

            // update selected state in ui
            this._updateSelectedLibraryColor(target);
        },


        // Set up the color picker with the right color from the model
        _setupColorpicker: function _setupColorpicker(color) {
            if (color) {
                this._input.colorpicker("setValue", color);
            } else {
                this._input.colorpicker();
            }
            this._updateColorBox(color);
        },


        // Used by the library to create the squares
        _addRowOfColorSquaresToLibrary: function _addRowOfColorSquaresToLibrary(arrayOfHexes) {
            var _this = this;

            var row = $("<div>", { "class": "color-row" });
            arrayOfHexes.forEach(function (hex) {
                if (_this._includeTransparency || !_this._isTransparent(hex)) {
                    row.append(_this._createColorSquare(hex));
                }
            });
            this._library.append(row);
        },
        _createColorSquare: function _createColorSquare(color) {
            var attributes = this._isTransparent(color) ? { "data-transparent": true } : { css: { backgroundColor: color } };
            var isSelected = color === this._color || color === "transparent" && !this._color;
            return $("<span>", attributes).toggleClass("selected", isSelected);
        },
        dispose: function dispose() {
            this._input.colorpicker("dispose").off();
            this._colorBox.off();
            if (this._library) this._library.off();
            this._sendTracking();
        },


        // Helper function
        _isValidHex: function _isValidHex(hex) {
            return (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hex)
            );
        },


        // Takes a "maybe hex" and returns a real hex or its default color
        hexOrDefault: function hexOrDefault(hex) {
            if (hex === "" && this._includeTransparency) return "";

            if (/(^#[0-9A-F]{6}$)/i.test(hex)) {
                return hex;
            } else if (/(^#[0-9A-F]{3}$)/i.test(hex)) {
                // 3 digit to 6diget (#f0a -> #ff00aa)
                return hex[0] + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
            }

            return DEFAULT_COLOR;
        },


        // Saves to model and updates the actual widget
        _triggerChange: function _triggerChange() {
            this._input.trigger("change");
        },


        // Checks if a color is transparent
        _isTransparent: function _isTransparent(color) {
            return color === "transparent" || color === "";
        },


        // Helper function
        _updateSelectedLibraryColor: function _updateSelectedLibraryColor(element) {
            if (this._library) {
                this._library.find(".selected").removeClass("selected");
                if (element) element.addClass("selected");
            }
        },


        // Updates the color (and class) of the little colored box next to the input field
        _updateColorBox: function _updateColorBox(color) {
            if (this._isTransparent(color)) {
                this._colorBox.addClass("transparent").css("backgroundColor", color);
            } else {
                this._colorBox.removeClass("transparent").css("backgroundColor", this.hexOrDefault(color));
            }
        },


        // TRACKING

        _setUpTracking: function _setUpTracking() {
            var _this2 = this;

            this._input.on("keyup", function () {
                _this2._trackHexKeyUp = true;
            });

            this._library.on("click", function () {
                _this2._trackColorLibraryClick = true;
            });
        },


        // Fire events for tracking with segment.io
        _sendTracking: function _sendTracking() {
            if (this._trackHexKeyUp) EditorEvents.trigger(EditorEvents.constants.SELECT_COLOR, { triggerOrigin: "customColorInputField" });
            if (this._trackColorLibraryClick) EditorEvents.trigger(EditorEvents.constants.SELECT_COLOR, { triggerOrigin: "colorPickerGridLibrary" });
        }
    }, {
        DEFAULT_COLOR: DEFAULT_COLOR
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    CLOSE: 0,
    OPEN: 1,
    SEND_EMAIL: 2,
    PROCESSING_EMAIL: 3,
    SENT_EMAIL: 4,
    SENT_EMAIL_WITH_SIZE_WARNING: 6,
    ERROR_EMAIL: 5,
    // Reusing few constants and adding an appropriate name for confirm button constant for incompatible widgets
    REMOVE_WIDGETS: 2,
    OPEN_NOTIFICATION: 3
};

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["a"] = (warning);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RuleList; });
/* unused harmony export SheetsManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SheetsRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createJss; });
/* unused harmony export createGenerateId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDynamicStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasCSSTOMSupport; });
/* unused harmony export sheets */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toCssValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_in_browser__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_warning__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
     false ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.9.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: __WEBPACK_IMPORTED_MODULE_1_is_in_browser__["a" /* default */] ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 * Used in react-jss.
 */

var SheetsManager =
/*#__PURE__*/
function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["a" /* default */])(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}();

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();

/* unused harmony default export */ var _unused_webpack_default_export = (index);



/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(412);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(75);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setRef;
// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFormControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormControlContext__ = __webpack_require__(421);


function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__FormControlContext__["a" /* default */]);
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentBlock
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(93);
var Immutable = __webpack_require__(40);

var findRangesImmutable = __webpack_require__(325);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var EMPTY_SET = OrderedSet();

var defaultRecord = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map()
};

var ContentBlockRecord = Record(defaultRecord);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;


  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = function (_ContentBlockRecord) {
  _inherits(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    _classCallCheck(this, ContentBlock);

    return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
  }

  ContentBlock.prototype.getKey = function getKey() {
    return this.get('key');
  };

  ContentBlock.prototype.getType = function getType() {
    return this.get('type');
  };

  ContentBlock.prototype.getText = function getText() {
    return this.get('text');
  };

  ContentBlock.prototype.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  ContentBlock.prototype.getLength = function getLength() {
    return this.getText().length;
  };

  ContentBlock.prototype.getDepth = function getDepth() {
    return this.get('depth');
  };

  ContentBlock.prototype.getData = function getData() {
    return this.get('data');
  };

  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  /**
   * Execute a callback for every contiguous range of styles within the block.
   */


  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  /**
   * Execute a callback for every contiguous range of entities within the block.
   */


  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

module.exports = ContentBlock;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Unicode-enabled replacesments for basic String functions.
 *
 * All the functions in this module assume that the input string is a valid
 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
 * will be undefined.
 *
 * WARNING: Since this module is typechecks-enforced, you may find new bugs
 * when replacing normal String functions with ones provided here.
 */



var invariant = __webpack_require__(47);

// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.
var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;

/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */
function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}

/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */
function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
  if (index + 1 === str.length) {
    return false;
  }
  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}

/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */
function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}

/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */
function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}

/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */
function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }
  return len;
}

/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */
function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0;

  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  }

  // Obvious cases
  var size = str.length;
  if (size <= 0 || start > size || length <= 0) {
    return '';
  }

  // Find the actual starting position
  var posA = 0;
  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }
    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }
    if (posA < 0) {
      posA = 0;
    }
  }

  // Find the actual ending position
  var posB = size;
  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}

/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */
function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }
  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}

/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */
function getCodePoints(str) {
  var codePoints = [];
  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }
  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};

module.exports = UnicodeUtils;

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(2210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(2211);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(2223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(2226);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(2380),
    getValue = __webpack_require__(2385);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 222 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(1117),
    baseIteratee = __webpack_require__(2449),
    baseMap = __webpack_require__(2487),
    isArray = __webpack_require__(134);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeName;
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return round; });
var max = Math.max;
var min = Math.min;
var round = Math.round;

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReactReduxContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ReactReduxContext = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ReactReduxContext.displayName = 'ReactRedux';
}

/* unused harmony default export */ var _unused_webpack_default_export = (ReactReduxContext);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SchemaType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_has__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_cloneDeepWith__ = __webpack_require__(2632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_toArray__ = __webpack_require__(2633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locale__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Condition__ = __webpack_require__(2640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_runValidations__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_prependDeep__ = __webpack_require__(2641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_isSchema__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_createValidation__ = __webpack_require__(2642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_printValue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Reference__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_reach__ = __webpack_require__(1176);



function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }














var RefSet = /*#__PURE__*/function () {
  function RefSet() {
    this.list = new Set();
    this.refs = new Map();
  }

  var _proto = RefSet.prototype;

  _proto.describe = function describe() {
    var description = [];

    for (var _iterator = _createForOfIteratorHelperLoose(this.list), _step; !(_step = _iterator()).done;) {
      var item = _step.value;
      description.push(item);
    }

    for (var _iterator2 = _createForOfIteratorHelperLoose(this.refs), _step2; !(_step2 = _iterator2()).done;) {
      var _step2$value = _step2.value,
          ref = _step2$value[1];
      description.push(ref.describe());
    }

    return description;
  };

  _proto.toArray = function toArray() {
    return Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_toArray__["a" /* default */])(this.list).concat(Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_toArray__["a" /* default */])(this.refs.values()));
  };

  _proto.add = function add(value) {
    __WEBPACK_IMPORTED_MODULE_12__Reference__["a" /* default */].isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  };

  _proto.delete = function _delete(value) {
    __WEBPACK_IMPORTED_MODULE_12__Reference__["a" /* default */].isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  };

  _proto.has = function has(value, resolve) {
    if (this.list.has(value)) return true;
    var item,
        values = this.refs.values();

    while (item = values.next(), !item.done) {
      if (resolve(item.value) === value) return true;
    }

    return false;
  };

  _proto.clone = function clone() {
    var next = new RefSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  };

  _proto.merge = function merge(newItems, removeItems) {
    var next = this.clone();
    newItems.list.forEach(function (value) {
      return next.add(value);
    });
    newItems.refs.forEach(function (value) {
      return next.add(value);
    });
    removeItems.list.forEach(function (value) {
      return next.delete(value);
    });
    removeItems.refs.forEach(function (value) {
      return next.delete(value);
    });
    return next;
  };

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(RefSet, [{
    key: "size",
    get: function get() {
      return this.list.size + this.refs.size;
    }
  }]);

  return RefSet;
}();

function SchemaType(options) {
  var _this = this;

  if (options === void 0) {
    options = {};
  }

  if (!(this instanceof SchemaType)) return new SchemaType();
  this._deps = [];
  this._conditions = [];
  this._options = {
    abortEarly: true,
    recursive: true
  };
  this._exclusive = Object.create(null);
  this._whitelist = new RefSet();
  this._blacklist = new RefSet();
  this.tests = [];
  this.transforms = [];
  this.withMutation(function () {
    _this.typeError(__WEBPACK_IMPORTED_MODULE_5__locale__["d" /* mixed */].notType);
  });
  if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_has__["a" /* default */])(options, 'default')) this._defaultDefault = options.default;
  this.type = options.type || 'mixed'; // TODO: remove

  this._type = options.type || 'mixed';
}
var proto = SchemaType.prototype = {
  __isYupSchema__: true,
  constructor: SchemaType,
  clone: function clone() {
    var _this2 = this;

    if (this._mutate) return this; // if the nested value is a schema we can skip cloning, since
    // they are already immutable

    return Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_cloneDeepWith__["a" /* default */])(this, function (value) {
      if (Object(__WEBPACK_IMPORTED_MODULE_9__util_isSchema__["a" /* default */])(value) && value !== _this2) return value;
    });
  },
  label: function label(_label) {
    var next = this.clone();
    next._label = _label;
    return next;
  },
  meta: function meta(obj) {
    if (arguments.length === 0) return this._meta;
    var next = this.clone();
    next._meta = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(next._meta || {}, obj);
    return next;
  },
  withMutation: function withMutation(fn) {
    var before = this._mutate;
    this._mutate = true;
    var result = fn(this);
    this._mutate = before;
    return result;
  },
  concat: function concat(schema) {
    if (!schema || schema === this) return this;
    if (schema._type !== this._type && this._type !== 'mixed') throw new TypeError("You cannot `concat()` schema's of different types: " + this._type + " and " + schema._type);
    var next = Object(__WEBPACK_IMPORTED_MODULE_8__util_prependDeep__["a" /* default */])(schema.clone(), this); // new undefined default is overridden by old non-undefined one, revert

    if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_has__["a" /* default */])(schema, '_default')) next._default = schema._default;
    next.tests = this.tests;
    next._exclusive = this._exclusive; // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    next._whitelist = this._whitelist.merge(schema._whitelist, schema._blacklist);
    next._blacklist = this._blacklist.merge(schema._blacklist, schema._whitelist); // manually add the new tests to ensure
    // the deduping logic is consistent

    next.withMutation(function (next) {
      schema.tests.forEach(function (fn) {
        next.test(fn.OPTIONS);
      });
    });
    return next;
  },
  isType: function isType(v) {
    if (this._nullable && v === null) return true;
    return !this._typeCheck || this._typeCheck(v);
  },
  resolve: function resolve(options) {
    var schema = this;

    if (schema._conditions.length) {
      var conditions = schema._conditions;
      schema = schema.clone();
      schema._conditions = [];
      schema = conditions.reduce(function (schema, condition) {
        return condition.resolve(schema, options);
      }, schema);
      schema = schema.resolve(options);
    }

    return schema;
  },
  cast: function cast(value, options) {
    if (options === void 0) {
      options = {};
    }

    var resolvedSchema = this.resolve(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      value: value
    }));

    var result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      var formattedValue = Object(__WEBPACK_IMPORTED_MODULE_11__util_printValue__["a" /* default */])(value);
      var formattedResult = Object(__WEBPACK_IMPORTED_MODULE_11__util_printValue__["a" /* default */])(result);
      throw new TypeError("The value of " + (options.path || 'field') + " could not be cast to a value " + ("that satisfies the schema type: \"" + resolvedSchema._type + "\". \n\n") + ("attempted value: " + formattedValue + " \n") + (formattedResult !== formattedValue ? "result of cast: " + formattedResult : ''));
    }

    return result;
  },
  _cast: function _cast(rawValue) {
    var _this3 = this;

    var value = rawValue === undefined ? rawValue : this.transforms.reduce(function (value, fn) {
      return fn.call(_this3, value, rawValue);
    }, rawValue);

    if (value === undefined && Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_has__["a" /* default */])(this, '_default')) {
      value = this.default();
    }

    return value;
  },
  _validate: function _validate(_value, options) {
    var _this4 = this;

    if (options === void 0) {
      options = {};
    }

    var value = _value;
    var originalValue = options.originalValue != null ? options.originalValue : _value;

    var isStrict = this._option('strict', options);

    var endEarly = this._option('abortEarly', options);

    var sync = options.sync;
    var path = options.path;
    var label = this._label;

    if (!isStrict) {
      value = this._cast(value, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        assert: false
      }, options));
    } // value is cast, we can check if it meets type requirements


    var validationParams = {
      value: value,
      path: path,
      schema: this,
      options: options,
      label: label,
      originalValue: originalValue,
      sync: sync
    };

    if (options.from) {
      validationParams.from = options.from;
    }

    var initialTests = [];
    if (this._typeError) initialTests.push(this._typeError(validationParams));
    if (this._whitelistError) initialTests.push(this._whitelistError(validationParams));
    if (this._blacklistError) initialTests.push(this._blacklistError(validationParams));
    return Object(__WEBPACK_IMPORTED_MODULE_7__util_runValidations__["a" /* default */])({
      validations: initialTests,
      endEarly: endEarly,
      value: value,
      path: path,
      sync: sync
    }).then(function (value) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__util_runValidations__["a" /* default */])({
        path: path,
        sync: sync,
        value: value,
        endEarly: endEarly,
        validations: _this4.tests.map(function (fn) {
          return fn(validationParams);
        })
      });
    });
  },
  validate: function validate(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      value: value
    }));
    return schema._validate(value, options);
  },
  validateSync: function validateSync(value, options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      value: value
    }));
    var result, err;

    schema._validate(value, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      sync: true
    })).then(function (r) {
      return result = r;
    }).catch(function (e) {
      return err = e;
    });

    if (err) throw err;
    return result;
  },
  isValid: function isValid(value, options) {
    return this.validate(value, options).then(function () {
      return true;
    }).catch(function (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    });
  },
  isValidSync: function isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (err.name === 'ValidationError') return false;
      throw err;
    }
  },
  getDefault: function getDefault(options) {
    if (options === void 0) {
      options = {};
    }

    var schema = this.resolve(options);
    return schema.default();
  },
  default: function _default(def) {
    if (arguments.length === 0) {
      var defaultValue = Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_has__["a" /* default */])(this, '_default') ? this._default : this._defaultDefault;
      return typeof defaultValue === 'function' ? defaultValue.call(this) : Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_cloneDeepWith__["a" /* default */])(defaultValue);
    }

    var next = this.clone();
    next._default = def;
    return next;
  },
  strict: function strict(isStrict) {
    if (isStrict === void 0) {
      isStrict = true;
    }

    var next = this.clone();
    next._options.strict = isStrict;
    return next;
  },
  _isPresent: function _isPresent(value) {
    return value != null;
  },
  required: function required(message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_5__locale__["d" /* mixed */].required;
    }

    return this.test({
      message: message,
      name: 'required',
      exclusive: true,
      test: function test(value) {
        return this.schema._isPresent(value);
      }
    });
  },
  notRequired: function notRequired() {
    var next = this.clone();
    next.tests = next.tests.filter(function (test) {
      return test.OPTIONS.name !== 'required';
    });
    return next;
  },
  nullable: function nullable(isNullable) {
    if (isNullable === void 0) {
      isNullable = true;
    }

    var next = this.clone();
    next._nullable = isNullable;
    return next;
  },
  transform: function transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  },

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test: function test() {
    var opts;

    if (arguments.length === 1) {
      if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function') {
        opts = {
          test: arguments.length <= 0 ? undefined : arguments[0]
        };
      } else {
        opts = arguments.length <= 0 ? undefined : arguments[0];
      }
    } else if (arguments.length === 2) {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        test: arguments.length <= 1 ? undefined : arguments[1]
      };
    } else {
      opts = {
        name: arguments.length <= 0 ? undefined : arguments[0],
        message: arguments.length <= 1 ? undefined : arguments[1],
        test: arguments.length <= 2 ? undefined : arguments[2]
      };
    }

    if (opts.message === undefined) opts.message = __WEBPACK_IMPORTED_MODULE_5__locale__["d" /* mixed */].default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    var next = this.clone();
    var validate = Object(__WEBPACK_IMPORTED_MODULE_10__util_createValidation__["a" /* default */])(opts);
    var isExclusive = opts.exclusive || opts.name && next._exclusive[opts.name] === true;

    if (opts.exclusive && !opts.name) {
      throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    next._exclusive[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(function (fn) {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  },
  when: function when(keys, options) {
    if (arguments.length === 1) {
      options = keys;
      keys = '.';
    }

    var next = this.clone(),
        deps = [].concat(keys).map(function (key) {
      return new __WEBPACK_IMPORTED_MODULE_12__Reference__["a" /* default */](key);
    });
    deps.forEach(function (dep) {
      if (dep.isSibling) next._deps.push(dep.key);
    });

    next._conditions.push(new __WEBPACK_IMPORTED_MODULE_6__Condition__["a" /* default */](deps, options));

    return next;
  },
  typeError: function typeError(message) {
    var next = this.clone();
    next._typeError = Object(__WEBPACK_IMPORTED_MODULE_10__util_createValidation__["a" /* default */])({
      message: message,
      name: 'typeError',
      test: function test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }
    });
    return next;
  },
  oneOf: function oneOf(enums, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_5__locale__["d" /* mixed */].oneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = Object(__WEBPACK_IMPORTED_MODULE_10__util_createValidation__["a" /* default */])({
      message: message,
      name: 'oneOf',
      test: function test(value) {
        if (value === undefined) return true;
        var valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }
    });
    return next;
  },
  notOneOf: function notOneOf(enums, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_5__locale__["d" /* mixed */].notOneOf;
    }

    var next = this.clone();
    enums.forEach(function (val) {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = Object(__WEBPACK_IMPORTED_MODULE_10__util_createValidation__["a" /* default */])({
      message: message,
      name: 'notOneOf',
      test: function test(value) {
        var invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }
    });
    return next;
  },
  strip: function strip(_strip) {
    if (_strip === void 0) {
      _strip = true;
    }

    var next = this.clone();
    next._strip = _strip;
    return next;
  },
  _option: function _option(key, overrides) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_has__["a" /* default */])(overrides, key) ? overrides[key] : this._options[key];
  },
  describe: function describe() {
    var next = this.clone();
    var description = {
      type: next._type,
      meta: next._meta,
      label: next._label,
      tests: next.tests.map(function (fn) {
        return {
          name: fn.OPTIONS.name,
          params: fn.OPTIONS.params
        };
      }).filter(function (n, idx, list) {
        return list.findIndex(function (c) {
          return c.name === n.name;
        }) === idx;
      })
    };
    if (next._whitelist.size) description.oneOf = next._whitelist.describe();
    if (next._blacklist.size) description.notOneOf = next._blacklist.describe();
    return description;
  },
  defined: function defined(message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_5__locale__["d" /* mixed */].defined;
    }

    return this.nullable().test({
      message: message,
      name: 'defined',
      exclusive: true,
      test: function test(value) {
        return value !== undefined;
      }
    });
  }
};

var _loop = function _loop() {
  var method = _arr[_i];

  proto[method + "At"] = function (path, value, options) {
    if (options === void 0) {
      options = {};
    }

    var _getIn = Object(__WEBPACK_IMPORTED_MODULE_13__util_reach__["a" /* getIn */])(this, path, value, options.context),
        parent = _getIn.parent,
        parentPath = _getIn.parentPath,
        schema = _getIn.schema;

    return schema[method](parent && parent[parentPath], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: parent,
      path: path
    }));
  };
};

for (var _i = 0, _arr = ['validate', 'validateSync']; _i < _arr.length; _i++) {
  _loop();
}

for (var _i2 = 0, _arr2 = ['equals', 'is']; _i2 < _arr2.length; _i2++) {
  var alias = _arr2[_i2];
  proto[alias] = proto.oneOf;
}

for (var _i3 = 0, _arr3 = ['not', 'nope']; _i3 < _arr3.length; _i3++) {
  var _alias = _arr3[_i3];
  proto[_alias] = proto.notOneOf;
}

proto.optional = proto.notRequired;

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mixed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return string; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return date; });
/* unused harmony export boolean */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return object; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return array; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_printValue__ = __webpack_require__(455);

var mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: function notType(_ref) {
    var path = _ref.path,
        type = _ref.type,
        value = _ref.value,
        originalValue = _ref.originalValue;
    var isCast = originalValue != null && originalValue !== value;
    var msg = path + " must be a `" + type + "` type, " + ("but the final value was: `" + Object(__WEBPACK_IMPORTED_MODULE_0__util_printValue__["a" /* default */])(value, true) + "`") + (isCast ? " (cast from the value `" + Object(__WEBPACK_IMPORTED_MODULE_0__util_printValue__["a" /* default */])(originalValue, true) + "`)." : '.');

    if (value === null) {
      msg += "\n If \"null\" is intended as an empty value be sure to mark the schema as `.nullable()`";
    }

    return msg;
  },
  defined: '${path} must be defined'
};
var string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
var number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  notEqual: '${path} must be not equal to ${notEqual}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
var date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
var boolean = {};
var object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
var array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items'
};
/* harmony default export */ __webpack_exports__["c"] = ({
  mixed: mixed,
  string: string,
  number: number,
  date: date,
  object: object,
  array: array,
  boolean: boolean
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (obj) {
  return obj && obj.__isYupSchema__;
});

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);

    /**
     * A parent view for all the setting pages.
     *
     * @class SettingView
     * @constructor
     *
     * @cfg {Model} model The CompanySetting model.
     */
    return ImprovedView.extend({

        className: "pt-page settings",

        regions: {
            defaultFooterRegion: ".default-footer"
        },

        // Configure the animation for the setting page
        transitions: {
            "in": "pt-page-scaleUp",
            "out": "pt-page-scaleDown"
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank;

    // regular expression borrowed from http://stackoverflow.com/q/46155/725901


    var REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    /**
     * Contains email utility functions.
     *
     * @class EmailUtil
     * @constructor
     */
    return {

        /**
         * Validates the specified email, returning true if considered valid.
         *
         * @param  {String} email The email to be validated; a falsey value will return false.
         * @return {Boolean} True is specified email is valid, false otherwise.
         */
        validateEmail: function validateEmail(email) {
            return !isBlank(email) && REGEX.test(email);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var GroupModel = __webpack_require__(104);
  var Locale = __webpack_require__(373);
  var ExperienceModel = __webpack_require__(58);

  /**
   * Represents a group of <tt>locale</tt>'s - referencing <tt>ExperienceModel</tt>'s.
   *
   * @class LocalizationGroup
   */

  return GroupModel.extend("LocalizationGroup", {

    /**
     * @inheritDoc
     */
    types: [Locale, ExperienceModel],

    /**
     * LocalizationGroup is not considered as one unit when published or scheduled.
     *
     * @override
     * @returns {boolean}
     */
    isOneUnit: function isOneUnit() {
      return false;
    }
  }, {

    /**
     * @inheritDoc
     */
    type: "LocalizationGroup"
  });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        clone = _require.clone;

    var ImprovedModel = __webpack_require__(25);
    var SyncManager = __webpack_require__(44);
    var Permissions = __webpack_require__(22);
    var Publishables = __webpack_require__(462);
    var RestApi = __webpack_require__(29);

    // TODO Rename to ChannelModel
    /**
     * @class {Channel}
     * Immutable editor type only, viewer used representation from S3.
     */
    var Channel = ImprovedModel.extend("Slot", {
        // a channel is a slot in user terminology

        url: function url() {
            if (this.isNew()) {
                return RestApi.pathToCollection(RestApi.Collections.CHANNELS);
            }
            return RestApi.pathToSpecificResource(RestApi.Collections.CHANNELS, this.get("id"));
        },


        defaults: {
            name: "(Untitled Slot)",
            selector: "",
            url: null,

            experience: null, // these two are mutually exclusive
            group: null, //
            publishable: null,
            restoreType: null, // supported by the backend and channels.js, but currently
            loadingIndicator: null, // not editable, but defined for clarity and consistency!
            preload: null, //
            timeout: null, //
            cacheable: null, //
            updated: false, // if channel/slot was updated/modified by user in dnd or manual publishing
            dnd: null, // if created in DnD
            manual: null, // if created/modified via manual publishing
            schedules: []
        },

        transient: ["resolvedReferences"],

        // Collapse resolved Experiences into references again (in json) to avoid to much data being submitted. We
        // have to submit entire groups as the "type" property is needed to marshal it successfully...
        transformBeforeSync: function transformBeforeSync(options) {
            if (options.sync !== "fetch" && options.sync !== "marshal") {
                // marshal handled by DnD!
                return [{
                    name: "publishable",
                    transform: function transform(publishable) {
                        return Publishables.toReference(publishable);
                    }
                }, {
                    name: "experience",
                    transform: function transform(experience) {
                        return Publishables.toReference(experience);
                    }
                }, {
                    name: "group",
                    transform: function transform(group) {
                        return Publishables.toReference(group);
                    }
                }, {
                    name: "schedules",
                    transform: function transform(schedules) {
                        var i = 0;
                        var clonedScheduled = [];

                        if (schedules) {
                            for (i = 0; i < schedules.length; i++) {
                                var schedule = clone(schedules[i]);
                                // At least one will be null!
                                schedule.experience = Publishables.toReference(schedule.experience);
                                schedule.group = Publishables.toReference(schedule.group);
                                schedule.publishable = schedule.experience || schedule.group;

                                delete schedule.resolvedReferences;
                                clonedScheduled.push(schedule);
                            }
                        }
                        return clonedScheduled;
                    }
                }];
            }
        },


        computed: {
            publishable: {
                deps: ["experience", "group", "resolvedReferences"],
                value: function value(experience, group, resolvedReferences) {
                    var publishable = experience || group;
                    return Publishables.resolveReference(publishable, resolvedReferences);
                },
                transient: false
            },
            experience: {
                deps: ["experience", "resolvedReferences"],
                value: function value(experience, resolvedReferences) {
                    return Publishables.resolveReference(experience, resolvedReferences);
                },
                transient: false
            },
            group: {
                deps: ["group", "resolvedReferences"],
                value: function value(group, resolvedReferences) {
                    return Publishables.resolveReference(group, resolvedReferences);
                },
                transient: false
            },
            schedules: {
                deps: ["schedules"],
                value: function value(schedules) {
                    var schedule,
                        i = 0;

                    if (schedules) {
                        for (i = 0; i < schedules.length; i++) {
                            schedule = schedules[i];
                            // At least one will be null!
                            schedule.experience = Publishables.resolveReference(schedule.experience, schedule.resolvedReferences);
                            schedule.group = Publishables.resolveReference(schedule.group, schedule.resolvedReferences);
                            schedule.publishable = schedule.experience ? schedule.experience : schedule.group;
                        }
                    }
                    return schedules;
                },
                transient: false
            }
        },

        _distinguishedName: function _distinguishedName() {
            return this.get("name");
        },
        getFirstSchedule: function getFirstSchedule() {
            return this.get("schedules")[0];
        },
        hasLive: function hasLive() {
            return Boolean(this.get("publishable"));
        },
        hasSchedule: function hasSchedule() {
            var schedules = this.get("schedules");
            return schedules && schedules.length === 1;
        }
    }, {
        push: function push() {
            return SyncManager.sync({
                method: "push",
                role: Permissions.Roles.PUBLISH, // must be at least a publisher to update other users
                fn: {
                    url: RestApi.pathToCollection(RestApi.Collections.CHANNELS_PUSH),
                    type: "PUT",
                    dataType: "json"
                },
                resultHandler: function resultHandler(response) {
                    return response;
                }
            }).promise();
        },
        hasUnPushedChannels: function hasUnPushedChannels() {
            return SyncManager.sync({
                method: "request for un-pushed slots",
                role: Permissions.Roles.PUBLISH, // must be at least a publisher to update other users
                fn: {
                    url: RestApi.pathToCollection(RestApi.Collections.CHANNELS_UNPUSHED),
                    type: "GET"
                },
                resultHandler: function resultHandler(response) {
                    return response; // for this example, we want the server response, not "experience"
                }
            }).promise();
        },
        publishCurrentExperience: function publishCurrentExperience(channelJson) {
            var experience = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var reference = Publishables.toReference(experience);

            channelJson.experience = reference;
            channelJson.group = null;
            channelJson.publishable = reference;
        },
        publishCurrentGroup: function publishCurrentGroup(channelJson) {
            var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var reference = Publishables.toReference(group);

            channelJson.group = reference;
            channelJson.experience = null;
            channelJson.publishable = reference;
        },
        publishScheduledExperience: function publishScheduledExperience(channelJson, experience, startTime) {
            Channel.publishScheduled(channelJson, experience, "experience", startTime); // all or nothing, group will be cleared by this
        },
        publishScheduledGroup: function publishScheduledGroup(channelJson, group, startTime) {
            Channel.publishScheduled(channelJson, group, "group", startTime); // all or nothing, experience will be cleared by this
        },
        publishScheduled: function publishScheduled(channelJson, model, type, startTime) {
            var schedules = [];

            // Schedule content...
            if (model) {
                var schedule = {
                    startTime: parseInt(startTime, 10),
                    publishable: Publishables.toReference(model)
                };

                schedule[type] = model;

                schedules.push(schedule);

                // Schedule "No Experience" from "startTime"...
            } else if (startTime) {
                schedules.push({
                    startTime: parseInt(startTime, 10),
                    takeDownCurrent: true
                });
            }
            // Or remove scheduled model altogether (empty)...
            channelJson.schedules = schedules;
        },
        hasContent: function hasContent(channelJson) {
            return channelJson && (channelJson.experience || channelJson.group);
        },
        destroy: function destroy(channelJson) {
            return new Channel(channelJson).destroy();
        }
    });

    return Channel;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        extend = _require.extend;

    var Class = __webpack_require__(26);

    var NO_EXPERIENCE_SCHEDULED = { name: "No Experience" };
    var EMPTY_SLOT = { id: null, text: "-" };
    var EMPTY_SCHEDULED_SLOT = {
        text: "Empty Slot",
        children: [{
            id: NO_EXPERIENCE_SCHEDULED,
            text: "No Experience"
        }]
    };
    var PENDING_OPT_GROUP_RESULT = "---";

    // Private vars common to bookmarklet, snippet URL, and embed snippet...
    var location = window.location;
    var host = location.host;

    var BUNDLED_CHANNELS_URL = "//" + (host + location.pathname) + "channels.";
    var SNIPPET = location.pathname + "channels.js";

    /**
     * All static utility class related to channel views (properties and setup) and Publish toolbar.
     * @class PublishUtil
     */
    return Class.extend({}, {

        /**
         * We need the customers to be able to take out the live content at a certain point in time.<p>
         *
         * Therefore, this no experience scheduled will be added to the "Next to go live" list.
         *
         * @type {{name: string}}
         */
        NO_EXPERIENCE_SCHEDULED: NO_EXPERIENCE_SCHEDULED,

        /**
         * Empty slot selection for a publishable.
         */
        EMPTY_SLOT: EMPTY_SLOT,

        /**
         * Empty slot selection for a scheduled publishable.
         */
        EMPTY_SCHEDULED_SLOT: EMPTY_SCHEDULED_SLOT,

        /**
         *  Name of the opt group used to indicate that pending results have been fetched.
         */
        PENDING_OPT_GROUP_RESULT: PENDING_OPT_GROUP_RESULT,

        BUNDLED_CHANNELS_URL: BUNDLED_CHANNELS_URL,

        SNIPPET: SNIPPET,

        /**
         * Builds a JSON object for channels used when sending as property to Mix Panel channel related events.
         * @param {Object} payload Object containing mandatory properties for the tracking method.
         * @returns {Object} The event property to be sent to Mix Panel.
         */
        buildEventProperties: function buildEventProperties(payload) {
            var channel = payload.channel;


            var channelJson = channel.toJSON ? channel.toJSON() : channel;
            var experience = channelJson.experience;

            var eventProperties = {
                projectId: payload.projectId,
                triggerOrigin: payload.triggerOrigin,
                name: channelJson.name,
                url: channelJson.url,
                dragAndDrop: payload.dragAndDrop,
                manual: payload.manual
            };

            if (experience) {
                eventProperties = extend(eventProperties, {
                    experienceId: experience.id,
                    experienceVersion: experience.version,
                    experiencePushedVersion: experience.pushedVersion,
                    type: "experience"
                });
            }

            var group = channelJson.group;

            if (group) {
                eventProperties = extend(eventProperties, {
                    groupId: group.id,
                    groupVersion: group.version,
                    groupPushedVersion: group.pushedVersion,
                    groupType: group.type,
                    type: "group"
                });
            }

            var schedules = channelJson.schedules;

            if (schedules && schedules.length) {
                var schedule = schedules[0]; // we only support a single schedule.

                if (schedule.experience) {
                    eventProperties = extend(eventProperties, {
                        scheduledExperienceId: schedule.experience.id,
                        scheduledExperienceVersion: schedule.experience.version,
                        scheduledExperiencePushedVersion: schedule.experience.pushedVersion,
                        scheduledType: "experience"
                    });
                }

                if (schedule.group) {
                    eventProperties = extend(eventProperties, {
                        scheduledGroupId: schedule.group.id,
                        scheduledGroupVersion: schedule.group.version,
                        scheduledGroupPushedVersion: schedule.group.pushedVersion,
                        scheduledGroupType: schedule.group.type,
                        scheduledType: "group"
                    });
                }
            }

            return eventProperties;
        },


        /**
         * Returns the snippet URL based on the company's bundling strategy.
         *
         * @param {BundleStrategy} bundleStrategy The bundle strategy, e.g. <tt>BundleStrategy.Channels</tt>.
         * @param {Boolean} bundleStrategy.isBundled Whether the config is bundled.
         * @param {String} channelConfigId The `channelConfigId`.
         *
         * @returns {String} the snippet URL based on the company's bundling strategy
         */
        getSnippetUrl: function getSnippetUrl(_ref, channelConfigId) {
            var isBundled = _ref.isBundled;

            var path = "//" + (host + SNIPPET);

            if (isBundled) {
                path = BUNDLED_CHANNELS_URL + channelConfigId + ".js";
            }

            // Note: by using "text/javascript", and not the correct "application/javascript", we ensure that
            // IE8 still works; it will not load scripts with "application/javascript"! The reason we should
            // be using "application" is to avoid the script being removed by clients using the (common) jQuery
            // Scrollpane plugin, which removes all script nodes inside the scroll pane with type
            // "text/javascript" or no type at all...

            return "<script type=\"text/javascript\" data-channel=\"" + channelConfigId + "\" src=\"" + path + "\"></script>";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loglevel__ = __webpack_require__(3156);
/* unused harmony reexport LogLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__severity__ = __webpack_require__(3157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__severity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__status__ = __webpack_require__(3158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__status__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://262.ecma-international.org/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assertRecord = __webpack_require__(294);
var fromPropertyDescriptor = __webpack_require__(1292);

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

module.exports = function FromPropertyDescriptor(Desc) {
	if (typeof Desc !== 'undefined') {
		assertRecord(Type, 'Property Descriptor', 'Desc', Desc);
	}

	return fromPropertyDescriptor(Desc);
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var isPropertyDescriptor = __webpack_require__(293);
var DefineOwnProperty = __webpack_require__(346);

var FromPropertyDescriptor = __webpack_require__(237);
var IsAccessorDescriptor = __webpack_require__(169);
var IsDataDescriptor = __webpack_require__(117);
var IsPropertyKey = __webpack_require__(64);
var SameValue = __webpack_require__(170);
var ToPropertyDescriptor = __webpack_require__(186);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

module.exports = function DefinePropertyOrThrow(O, P, desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);
var callBound = __webpack_require__(45);

var $TypeError = GetIntrinsic('%TypeError%');

var IsArray = __webpack_require__(116);

var $apply = GetIntrinsic('%Reflect.apply%', true) || callBound('%Function.prototype.apply%');

// https://ecma-international.org/ecma-262/6.0/#sec-call

module.exports = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray(argumentsList)) {
		throw new $TypeError('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};


/***/ }),
/* 240 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {"jQuery":true}))

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EventDispatcher = __webpack_require__(54);
    var Promise = __webpack_require__(21);
    var RestApi = __webpack_require__(29);
    var ViewerEvents = __webpack_require__(153);
    var ViewerProxy = __webpack_require__(1385);
    var Preconditions = __webpack_require__(14);
    var ChannelContentState = __webpack_require__(1386);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);

    var log = new Logger("ChannelBridge");

    /**
     * @type {Window}
     * Iframe window, not top level window!
     */
    var win = window;

    // Odd construct is to allow the bridge to be initialised once via the viewer app when the Controller is available,
    // including its region, and to avoid circular dependencies with controllers using this bridge.
    //
    var _bridge = function bridge(Controller, region) {
        // Have to run in an iframe where the channel has been primed via the channels app...
        if (win.top !== win && win.channel && Controller && region) {
            _bridge = new ChannelBridge(Controller, region, win.channel);
        } else {
            _bridge = null;
            log.verbose("Non channel mode detected");
        }

        if (_bridge) {
            _bridge._start(); // one time only!
        }

        return _bridge;
    };

    // Guard to ensure the Bridge is useless if for example closed on initialisation errors...
    var ensureNotClosed = function ensureNotClosed() {
        // cannot use Preconditions because of circular references!
        if (!_bridge || _bridge.closed && _bridge.closed()) {
            // can still be the init function since we log stuff in the constructor
            throw new Error("Bridge/Viewer is closed");
        }
    };

    /**
     * @class ChannelBridge
     *
     * A <i>channel bridge</i> provides an interface between channels and a viewer, allowing them to notify each
     * other on events like "data preload", "content loaded", etc. It is only used when the viewer is started
     * from a channel, not for direct urls. This module will return a singleton channel bridge instance when
     * embedded via channels, otherwise null. <p>
     *
     * To determine if the viewer is running in channel mode, do:
     * <pre>
     *     ..
     *     // Imports:
     *     var channelBridge = require("ui/viewer/ChannelBridge"); // function!
     *     ..
     *
     *     // Usage in some function - always call at use time, not at import time!
     *     var bridge = channelBridge();
     *     if (bridge) {
     *         // Yes, Viewer embedded via a Channel that can be obtained via "bridge.channel()"
     *         ..
     *     } else {
     *         // No, Viewer not embedded via  Channel, do something else.
     *         ..
     *     }
     *     ..
     * </pre>
     *
     * The channel snippet will be loaded on the client domain, while this channel bridge will be loaded in the
     * embedded iframe, inserted by the channels app. The channel bridge exposes a "viewer proxy" the channel
     * can call, and the viewer will notify the channel once it has loaded content:
     *
     * <pre>
     *     // On the client site, where channels.js is included, the channels app lives in the
     *     // <tt>window.__zmags.channels</tt> sandbox, and active channels under <tt>__zmags.channels.active</tt>
     *     // See <tt>Global.sandbox()</tt> for details.
     *     ..
     *     var channel = window.__zmags.channels.active[0]; // assuming only a single active channel
     *     var viewer = channel.viewer();                   // the viewer proxy exposed by this bridge
     *     ..
     *
     *     // In the embedded iframe, the viewer proxy is exposed under <tt>window.viewer</tt>,
     *     var viewer1  = window.viewer;    // the viewer proxy, same instance as above (that is, as "viewer")
     *     var channel1 = window.channel;   // the channel already set in the iframe window, same channel as
     *                                      // above (that is, same instance as "channel")
     *     // Or get the channel like:
     *     var channel2 = viewer.channel(); // the channel, same instance as above (that is, same instance as
     *                                      // "channel" and "channel1")
     *     ..
     * </pre>
     *
     * The channels app may be configured for preloading json data, and this bridge will ensure that the viewer
     * is only fired up when said content is done loaded. On no preload, the viewer will simply be feed
     * an id for the publishable to load and it will have the load itself (akin to direct urls). <p>
     *
     * The channel bridge can also be used to add <i>embedded Experiences or Groups</i> to the current viewer
     * by creating channels on the fly pointing to such embedded content. For example:
     * <pre>
     *     ..
     *     // In some part of the Viewer code that wants to add embedded content when embedded via channels
     *     var bridge = channelBridge();
     *     if (bridge) {
     *         var options = {
     *             embedType:  "embedded",                  // type of embedding, e.g. "embedded" or "lightbox".
     *             scene:      1,                           // (actual) scene number used to generate pseudo unique but reusable channel ids.
     *             descriptor: ..,                          // url descriptor for content like {id:String, type:String, scene:Number, ..}.
     *             element:    ..,                          // jQuery element for the parent (view) element to insert the embed under.
     *             channel:    { .. },                      // standard channel options like "win", etc.
     *             callback:   function (populated) { .. }, // true on success, false on failure to populate channel.
     *         };
     *
     *         // Embed, and get the temp channel needed to remove the content again when no longer relevant,
     *         // e.g. on page navigation or close...
     *         var channel = bridge.embed(options); // see "embed(..)" function for full doc!
     *         ..
     *     } else {
     *         // optionally just insert an <iframe> with a direct url to the experience/group then
     *     }
     *     ..
     *
     *     ..
     *     // Remove again, e.g. on view close/navigation...
     *     bridge.removeEmbed(channel);
     *     ..
     * </pre>
     *
     * Since the channels app lives in client space and needs to load as fast as possible, it does not utilise
     * <tt>Promise</tt> functionality (need to support legacy browsers), but relies on client side jQuery for
     * preload. This is why the channel bridge implementation is a bit awkward to handle this, ensuring that
     * the data when passed to the viewer is wrapped in a promise promise/deferred. <p>
     *
     * For now, it works with the Creator viewer only, but could (hopefully) easily been extended to for example
     * also support the Verge viewer (Publications).
     *
     * @author Gunni Rode / <a href="http://www.zmags.com>Zmags</a>
     */
    var ChannelBridge = EventDispatcher.extend("ChannelBridge", {

        /**
         * @private @type {ErrorLogger}
         * Error logger, to ensure we wait until an error been reported before we bail out.
         */
        _errorLogger: null,
        /**
         * @private @type {ViewerProxy}
         * The Viewer Proxy used by this bridge; never null.
         */
        _viewer: null,
        /**
         * @private @type {Controller}
         * The Group or Experience controller used (also by <tt>_viewer</tt>).
         */
        _controller: null,

        /**
         * Constructor, which creates this channel bridge.
         *
         * @param {ErrorLogger} errorLogger The error logger to log errors during channel/viewer handshake; injected
         *                                  via DIA.
         * @param {ViewerProxy} viewer      The viewer proxy to use; never null.
         * @param {Channel}     channel     The channel in question; never null.
         */
        constructor: function constructor(errorLogger, Controller, region, channel) {
            // Because of circular dependencies, we have to manually initialise the error logger with the channel...
            this._errorLogger = errorLogger;

            // Create controller to use...
            this._controller = new Controller({ region: region });

            // Make sure the ViewerProxy knows it is using channels...
            this._viewer = new ViewerProxy(this._controller.state.bind(this._controller), channel); // exports itself under "viewer" (iframe window)

            var loc = void 0;
            try {
                loc = win.location.toString();
            } catch (e) {
                // Security error
                loc = "unknown";
            }

            // Listen for all viewer events, such as scene navigation...
            this.listenTo(ViewerEvents, "all", this._viewerEvent);

            log.info("Created channel bridge for (channel <-> viewer) for url: '" + loc + "' -> " + this, this);
        },


        /**
         * @private
         * Notifies the channel about an event triggered by the Viewer, such as "viewer:scene:navigation" or
         * "viewer:lightbox:open", if defined on the channel proxy under <tt>event</tt>, e.g.
         * <tt>channel.callbacks.events["viewer:lightbox:open"] = function (source, experienceId, ..) { .. }</tt>. <p>
         *
         * The events triggered here has nothing to do with the Viewer loading/initialisation, but about Viewer
         * actions being triggered, initiated by user interaction such as scene navigation.
         *
         * @param {String} name      The Viewer event name, e.g. "viewer:scene:navigation"; never falsey.
         * @param {...}    [varArgs] Additional event arguments; never falsey.
         * @throws Error If this bridge/viewer is closed.
         */
        _viewerEvent: function _viewerEvent(name) {
            var channel = this.channel();
            var callback = channel.callbacks.events[name];

            if (typeof callback === "function") {
                for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                }

                callback.apply(channel, args);
            }
        },


        /**
         * Returns true if this bridge - and thus viewer - is actually closed, false otherwise. <p>
         *
         * There is normally no need to test for this; it is only for edge cases where old IE browsers doing stuff
         * synchronously fails during Viewer initialisation, causing the viewer to be closed while it is initialising.
         * The viewer thus guards against this using this function. <p>
         *
         * @return {Boolean} True if this bridge - and thus the viewer - is closed, false otherwise.
         */
        closed: function closed() {
            return this._viewer.state("closed");
        },


        /**
         * Returns the viewer proxy used by this bridge.
         *
         * @return {*} The viewer proxy used; never null while this bridge is active.
         * @throws Error If this bridge/viewer is closed.
         */
        viewer: function viewer() {
            ensureNotClosed();
            return this._viewer;
        },


        /**
         * Returns the channel proxy used by this bridge.
         *
         * @return {*} The channel proxy used; never null while this bridge is active.
         *
         * @throws Error If this bridge/viewer is closed.
         */
        channel: function channel() {
            return this.viewer().channel();
        },


        /**
         * Returns the dom element that has been matched by the channel, wrapped in a fresh jQuery object. <p>
         *
         * <tt>iframeElement()</tt> will return a (jQuery wrapped) dom object that is a child of this object.
         *
         * @return {jQuery} The matched dom element; never falsey.
         * @throws Error If this bridge/viewer is closed.
         * @see    #iframeElement
         */
        matchedElement: function matchedElement() {
            return $(this.channel().element());
        },


        /**
         * Returns the dom iframe containing the viewer, wrapped in a fresh jQuery object. <p>
         *
         * This will be a child of <tt>matchedElement()</tt>.
         *
         * @return {jQuery} The iframe containing the viewer; never falsey.
         * @throws Error If this bridge/viewer is closed.
         * @see    #matchedElement
         */
        iframeElement: function iframeElement() {
            return $(this.channel().container());
        },


        /**
         * Returns the possible channel cached raw json content of the specified type and id, if any.
         *
         * @param  {String} id   The content (model) id; cannot be falsey.
         * @param  {String} type The content type, e.g. "experience" or "group"; cannot be falsey.
         * @return {JSON}   The content, if any; otherwise falsey.
         * @throws Error If this bridge/viewer is closed.
         */
        content: function content(id, type) {
            var json = this.channel().callbacks.content(id, type);
            if (json) {
                log.info("Cached " + type + " content available: '" + id + "'");
            }
            return json;
        },


        /**
         * @private
         * Connects this bridge, triggering a load of the content to use by the viewer if not already.
         *
         * @return {Promise} A promise that will resolve once the initial raw json data for the viewer is ready,
         *                   as specified - and possible preloaded - by the channel used by this bridge, automatically
         *                   calling the controller with said raw json to view the content.
         */
        _start: function _start() {
            var _this = this;

            var channel = this.channel(); // channel proxy!
            var callbacks = channel.callbacks;
            var content = channel.content();
            var state = content.state;

            var url = void 0;
            var promise = void 0;

            // Do we have preloaded/embedded raw json content (experience or group)? The "cache" state will be
            // on programmatically started/stopped channels or in certain embedded cases...
            if (state === ChannelContentState.LOADED || state === ChannelContentState.LOCAL || state === ChannelContentState.CACHE) {
                log.verbose("Content preloaded: '" + state + "' -> " + content, content);

                // No fail handler required here since the content is ready...
                promise = Promise.resolved(content.data());

                // Special case: channels are currently preloading the json data via jQuery found on
                // the client page, so we create a deferred that will resolve once the channel calls
                // the viewer proxy with the loaded json content...
            } else if (state === ChannelContentState.PENDING) {
                log.verbose("Waiting for preload to finish: " + content, content);
                this._viewer._deferred = Promise.deferred();

                // No fail handler required here to signal channels since the channels app already knows if this fails...
                promise = this._viewer._deferred.promise();

                // Here, the content is just a shim for the content, e.g. an experience or group id. For consistency,
                // we need to return the raw json content, so we use the sync manager for this, relying on naming
                // conventions for the REST endpoints...
            } else {
                url = RestApi.API_URL + "/" + content.type + "s/" + content.id();

                log.verbose("Loading content: " + content + " -> '" + url + "'", content);

                // Note: in IE9 (and other legacy browsers), the promises below might run synchronously, which will in
                // fact trigger the viewer to be unloaded while initialising on for example cross domain errors. This
                // means that the viewer can be destroyed during its initialisation, which causes IE9 to log many nasty
                // errors. To ensure this will not happen, this bridge is tagged as closed, but the "bridge" variable
                // not nulled. This means a (useless) reference to it can still be obtained, e.g. to ensure we
                // suddenly do not try to fire up the Viewer based on direct url since no bridge is available.
                // This is only relevant for errors as it will destroy the viewer; content loaded will be handled
                // by the relevant controller once it is fired up...

                // We use raw ajax to avoid including SyncManager in the viewer code (for now). We allow the channel to
                // cache this as well. For all other states, channels will already get an internal callback when the
                // content is ready as channels itself will have initialised the request to begin with; we thus only
                // need to add the hook here. Also note we need to specify request type, etc, to ensure this will also
                // work with IE9 cross domain requests (see XDomainRequestTransport.js and its doc)... Content-Type does
                // seem to be necessary though.
                promise = $.ajax({ url: url, type: "GET", dataType: "json" }).done(function (json) {
                    callbacks.content(json, content.type);
                    log.verbose("Content loaded: " + content + " -> '" + url + "'", content);

                    // Force a fail, which will also report to the error logger used, waiting for it to complete
                    // before signaling channels with error. This is to avoid channels forcefully removing the
                    // viewer before the error has had a chance to be reported...
                }).fail(function (xhr, text, error) {
                    error = error + " (" + xhr.status + ")";
                    var message = "Could not load content: " + content + " -> " + error + ": '" + url + "'";
                    log.error(message);
                    return _this._errorLogger.log(message).always(function () {
                        callbacks.error(error); // can be synchronous in IE9!
                    });
                });
            }

            // Invariant: "promise" has a primed fail handler here where it makes sense already!
            return promise.then(function (json) {
                // Invariant: "json" either a group or experience! Regardless of type, it loaded from here,
                //            it will have been reported already to the channel via "content(..)", setup above
                //            in the ajax call...

                // Invariant: Backbone will mess up json it is used to create a recursive model graph by, i.e. change
                //            arrays to Backbone.Collections and what not. For this reason, channels will ensure a
                //            deep copy is cached...

                // Fire up the controller logic, where the controller can access this bridge via the ChannelBridge module...
                log.verbose("Invoking " + content.type + " controller", json);

                // The controller will return a promise the will resolve when the viewer is fully shown, not just
                // rendered or when a group is processed, or rejected because of some viewer error. For example,
                // when an ExperienceController is used, it will resolve once the Experience is fully shown; when
                // a GroupController is used, the GroupController will determine the Experience to show, then fire
                // up an ExperienceController like above, while not resolving until the chosen Experience is fully.
                // We cannot, however, manually attach a done handler to call "notify" to notify the channel as the
                // viewer itself may use the controller to change experience, e.g. when a breakpoint is hit. The same
                // goes for failures in case nested deferreds are used. Hence, each controller must ensure that
                // "channelBridge.notify(promise:Promise)" is called (attached) as well as
                // "channelBridge.fail(promise:Promise)" where relevant...
                return _this._controller.viewContent(json, content.scene.current);
            });
        },


        /**
         * Attaches "done" and "fail" handlers to the specified promise to notify this channel bridge once the
         * promise resolves the (new) Experience to show or fails in the process.
         *
         * @param {Promise} promise The promise that will resolved to the experience shown, triggering an update
         *                         to the channel; cannot be falsey.
         * @return {Promise} <tt>promise</tt>, with a done and fail handler to update the channel once the experience
         *                   is shown or to notify it of errors; never falsey.
         * @throws Error If this bridge/viewer is closed.
         */
        notify: function notify(promise) {
            var channel = this.channel();
            return this.fail(promise.done(function (experience) {
                // "experience" is an ExperienceModel type, not json!
                log.verbose("Experience shown for channel: '" + experience.id + "' -> " + channel, experience, channel);

                // If the experience was loaded above via the REST promise, its JSON representation is not seen by
                // channels before, so we pass it along for possible caching. If the experience was preloaded or
                // embedded, the cache will already be correctly primed, but still fine to pass the json along to
                // channels. The "shown(..)" callback will also stop spinners and what not...
                channel.callbacks.shown(experience.id, experience.toJSON());
            }));
        },


        /**
         * Attaches a fail handler to the specified promise to notify this channel bridge once the
         * promise fails to resolve; only needed for special cases, like nested deferreds.
         *
         * @param {Promise} promise The promise that will notify the channel bridge of error if rejected.
         * @return {Promise} <tt>promise</tt>, with a fail handler to update the channel if the experience fails
         *                   to be shown; never falsey.
         * @throws Error If this bridge/viewer is closed.
         */
        fail: function fail(promise) {
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
            }

            var channel = this.channel();
            return promise.fail(function (error) {
                var promiseArgs = [promise].concat(args);
                // We assume this error has already been reported by the viewer logic to the frontend
                // error queue, so we just log it here...
                log.error("Viewer error for channel: " + error + " -> " + channel, channel, promiseArgs);
                channel.callbacks.error(error); // can be synchronous in IE9!
            });
        },


        /**
         * Creates a new embedded 'in-place' channel on the fly to insert the content under the specified parent
         * element contained in the dom rendered for the content in the channel used by this channel
         * bridge. That is, creates a "child channel" of the channel used by this bridge in order to utilise
         * channel behaviour, such as allowing cross domain functionality, when embedding Experiences or Groups
         * within other Experiences. <p>
         *
         * The created channel must be removed again manually using <tt>removeEmbed</tt> when the content is no
         * longer relevant, e.g. because the user navigates to a new scene. <p>
         *
         * Note: this does <b>not</b> test for infinite recursion, like Experience A embedding Experience B
         * which embeds Experience A again! <p>
         *
         * <tt>options</tt> have the following format:
         * <pre>
         *   {
         *      descriptor: {id:String, type:String, scene:Number, ..}, - an url descriptor known to have a <tt>type</tt>
         *                                                                property of either "experience" or "group",
         *                                                                obtained via <tt>UrlUtil.getUrlDescriptor()</tt>.
         *
         *      element:    jQuery, - the parent element to use, wrapped in jQuery.
         *
         *      scene:      String, - the scene number of the scene doing the embedding, e.g. "1" or "overlay", used to
         *                            qualify embedded channels so the same content can be embedded on numerous scenes.
         *
         *      embedType:  String, - the logical embed type, e.g. "lightbox" or "embedded" (default).
         *
         *      callback:   fn(populated:Boolean, channel:Channel, descriptor:*) - callback to be invoked once the
         *                  embedded channel has been tried populated; <tt>populated</tt> will be true on success,
         *                  false otherwise. The <tt>channel</tt> argument is channel in question (also returned
         *                  by the <tt>embed(..)</tt> function), and <tt>descriptor</tt> is <tt>options.descriptor</tt>.
         *
         *      channel:    * - optional channel data/options, like  <tt>{win: Window, loadingIndicator: "spinner", ..}</tt>.
         *   }
         * </pre>
         *
         * @param  {*}       options The options to create the embedded channel by; cannot be falsey.
         *
         * @return {Channel} The 'in-place' channel proxy created for the embedded content; never falsey. The actual
         *                   dom element used can be obtained via <tt>returnedChannel.element()</tt>.
         *
         * @throws Error If this bridge/viewer is closed.
         *
         * @see    #removeEmbed
         */
        embed: function embed(options) {
            var _this2 = this;

            // Since we are in Viewer scope, we can afford to use jQuery, making it easy to create dom elements and
            // know when the dom is ready before adding the channel to the owning snippet...
            var channel = this.channel().channel; // actual non-proxy channel
            var snippet = channel.snippet; // actual snippet
            var embedType = options.embedType || "embedded";
            var descriptor = options.descriptor;
            // Qualify channel id with the scene of the channel backing this bridge and the scene from
            // the descriptor as well; we cannot use a sequence number since we must able to reuse the
            // channel on the scene becoming active again...
            var channelId = channel.name + "/" + options.scene + " > " + embedType + " " + descriptor.type + " " + descriptor.id + "/" + descriptor.scene;
            var element = options.element[0];

            // Does such a channel already exist? If so, simply show it since it matched on an id deduced from the
            // actual content id in the format above. This ensures that we can reuse the current scene index associated
            // with the content of the channel when the user is navigating through the inner experience...
            var c = snippet.channel(channelId);
            if (c && !c.ready()) {
                c._dom.element = element; // since old one will have been destroyed when here again!
                log.info("Re-using 'in-place' " + embedType + " channel: " + c, c);
                // Fall-through

                // No such channel, so we create a new 'in-place' channel on the fly. We supply dom element to tag it as
                // an 'in-place' channel, but we cannot add the channel yet as said element will not be ready yet...
            } else {
                // Use these defaults, but allow them to be overridden via "options", then add immutable channel
                // options that cannot be overridden by "options"...
                c = _.extend({
                    cacheable: channel._cacheable * 10, // cache for 10 times as long as the outer channel, we are likely to come back to to when navigating through scenes
                    win: win // make sure we use the dom from this *iframe* window for the embedded channel unless otherwise specified
                }, options.channel, {
                    name: channelId,
                    configId: snippet.configId,
                    url: channel._url, // ensure the embedded channel matches the same url
                    loadingIndicator: "none", // actually works, but issues when navigating since turned on when non-current scene is constructed
                    element: element, // dom element, not jQuery
                    embedded: channel // embedded via "channel" (even if the dom is the same)
                });

                // Add immutable content reference as well, e.g. {experience: {id: "xxx"}}...
                c[descriptor.type] = { id: descriptor.id };

                // Do not populate the channel yet, the dom element is not ready yet...
                snippet.addChannels(c, false);

                // Make sure we return the actually created channel, no just the raw data above...
                c = snippet.channel(channelId);

                // Update with the content with the scene to show
                c.content.scene.current = descriptor.scene;

                log.info("Created " + embedType + " channel: " + c, c);
            }

            // Defer to ensure the element is actually added to the dom used by the channel (associated with
            // options.channel.win or just plain on iframe window (default)...
            _.defer(function () {
                if (!_this2.closed()) {
                    var populated = snippet.populateChannel(c);
                    Preconditions.checkState(populated, "Channel failure for " + embedType + " " + descriptor.type + ": " + c, [descriptor, c]);
                    if (options.callback) {
                        options.callback(populated, c, descriptor);
                    }
                }
            });

            return c.proxy(); // no longer privileged access!
        },


        /**
         * Removes the content populated for the embedded 'in-place' channel, if applicable, and optionally removes
         * the channel itself.
         *
         * @param {String|Channel} channel  The id of the channel to remove or the channel proxy itself; if falsey,
         *                                  or no such channel, this function does nothing.
         * @param {Boolean}       [destroy] True to remove the channel itself, false to keep it for future re-use;
         *                                  the populated content, if any, will be removed in any case.
         *
         * @throws Error If this bridge/viewer is closed.
         *
         * @see    #embed
         */
        removeEmbed: function removeEmbed(channel, destroy) {
            var snippet = this.channel().snippet; // proxy
            if (typeof channel === "string") {
                channel = snippet.channel(channel);
            }

            if (channel) {
                log.info("Removing embedded channel content: " + channel, channel);
                channel.stop(destroy);
            }
        },
        toString: function toString() {
            var content = this.closed() ? "closed" : "channel: " + this.channel() + "; viewer: " + this.viewer();
            return "ChannelBridge[" + content + "]";
        }
    }, {
        injection: {
            parameters: ["errorLogger"]
        }
    });

    return function () {
        return _bridge;
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var States = {
        Active: { name: "Active", description: "Company users can log in normally, and published content is not affected" },
        LoginRestricted: { name: "LoginRestricted", description: "Company users cannot login, but published content is not affected" },
        ContentRestricted: { name: "ContentRestricted", description: "Company users can login as Spectator, but all published content is inactive" },
        Suspended: { name: "Suspended", description: "Company users are denied login and all published content is inactive" }
    };

    /**
     * Enumeration representing the company state, where the <tt>value</tt> is equal
     * to <tt>experienceModel.get("state")</tt>.
     *
     * @see data/CompanyModel
     * @class CompanyState
     * @author Antonio Lagrotteria
     */
    return {
        ACTIVE: States.Active,
        LOGIN_RESTRICTED: States.LoginRestricted,
        CONTENT_RESTRICTED: States.ContentRestricted,
        SUSPENDED: States.Suspended,

        all: [States.Active, States.LoginRestricted, States.ContentRestricted, States.Suspended],

        /**
         * Returns the company state having the specified string value, or <tt>state</tt> itself.
         *
         * @param {String|{name:String,description:String}} state The state value, or an actual state.
         * @return {name:String,description:String}} The corresponding state; never null, will default to ACTIVE.
         */
        of: function of(state) {
            var name = !state || typeof state === "string" ? state : state.name;

            return States[name || "Active"] || States.Active;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var Mousetrap = __webpack_require__(1389);
    var KeyCode = __webpack_require__(88);

    var win = $(window);
    var listeners = [];

    function setupOn(type) {
        return function (keycode, callback, context) {
            // context is used by listenTo() as the "key" for all event name/callback pair from a particular object.
            // The same key will then be given to off() rather than giving it each event name/callback pair.
            var modifiers = void 0;
            var selector = void 0;
            var correctModifiers = void 0;

            // If the keycode is a string, then it's a list with the key code, modifiers and element selector separated by /.
            // Trying to use a list or an object triggers some annoying method overloading detection in Backbone.
            if (_.isString(keycode)) {
                var blah = keycode.split("/");
                modifiers = blah[1];
                selector = blah[2];
                keycode = parseInt(blah[0], 10);

                if (modifiers) {
                    var modifierNames = [];

                    _.each(["ctrl", "shift", "alt"], function (mod) {
                        if (modifiers.indexOf(mod) !== -1) {
                            modifierNames.push(mod + "Key");
                        }
                    });

                    correctModifiers = function correctModifiers(event) {
                        return _.every(modifierNames, function (modifierName) {
                            return event[modifierName];
                        });
                    };
                }
            }

            var handler = function handler(event) {
                if (event.keyCode === keycode && (!modifiers || correctModifiers(event))) {
                    callback.call(context, event);
                }
            };

            if (selector) {
                win.on(type, selector, handler);
            } else {
                win.on(type, handler);
            }

            // Save a reference to the generated handler function so we can use it in the off() call.
            listeners.push({
                type: type,
                keycode: keycode,
                callback: callback,
                handler: handler,
                context: context,
                selector: selector
            });
        };
    }

    function setupOff(type) {
        return function (keycode, callback, context) {
            // keycode and callback are always null when using listenTo() in views.

            var currentListeners = listeners.filter(function (listener) {
                return listener.type === type && (listener.context === context || listener.keycode === keycode && listener.callback === callback);
            });

            currentListeners.forEach(function (listener) {
                if (listener.selector) {
                    win.off(type, listener.selector, listener.handler);
                } else {
                    win.off(type, listener.handler);
                }
            });

            listeners = _.difference(listeners, currentListeners);
        };
    }

    /**
     * Utility class for listening to keyboard events with automatic cleanup.
     *
     * Usage:
     * this.listenTo(Keyboard, KeyCode.BLAH, function (event) { ... });
     *
     * Defaults to listening for keyup, use Keyboard.Down if you need keydown.
     *
     * @author Bo Gotthardt
     * @class Keyboard
     */
    return {
        on: setupOn("keyup"),
        off: setupOff("keyup"),

        Down: {
            on: setupOn("keydown"),
            off: setupOff("keydown")
        },

        KeyCode: KeyCode,

        Shortcut: Mousetrap
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var Spinner = __webpack_require__(766);
    var $ = __webpack_require__(4);

    /**
     * Simple <tt>Backbone</tt> view wrapping a "spinner".
     *
     * @class SpinnerView
     */
    return Backbone.View.extend({
        render: function render() {
            var options = _.defaults(this.options, {
                color: "#000"
            });
            var spinner = new Spinner(options).spin();
            var element = $(spinner.el).css({
                position: "absolute",
                top: "50%",
                left: "50%"
            });

            this.$el.append(element);

            return this;
        },
        destroy: function destroy() {
            this.$el.remove();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var EffectModel = __webpack_require__(78);

    var TYPE = "opacity";

    return EffectModel.extend({
        defaults: _.defaults({
            type: TYPE,
            opacity: 0.5
        }, EffectModel.prototype.defaults)
    }, {
        TYPE: TYPE
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    return {
        NONE: "none",
        STRETCH: "stretch",
        DEFAULT: "default"
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 1.20.3
 * DATE: 2017-10-02
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
!function(a,b){"use strict";var c={},d=a.document,e=a.GreenSockGlobals=a.GreenSockGlobals||a;if(!e.TweenLite){var f,g,h,i,j,k=function(a){var b,c=a.split("."),d=e;for(b=0;b<c.length;b++)d[c[b]]=d=d[c[b]]||{};return d},l=k("com.greensock"),m=1e-10,n=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},o=function(){},p=function(){var a=Object.prototype.toString,b=a.call([]);return function(c){return null!=c&&(c instanceof Array||"object"==typeof c&&!!c.push&&a.call(c)===b)}}(),q={},r=function(d,f,g,h){this.sc=q[d]?q[d].sc:[],q[d]=this,this.gsClass=null,this.func=g;var i=[];this.check=function(j){for(var l,m,n,o,p=f.length,s=p;--p>-1;)(l=q[f[p]]||new r(f[p],[])).gsClass?(i[p]=l.gsClass,s--):j&&l.sc.push(this);if(0===s&&g){if(m=("com.greensock."+d).split("."),n=m.pop(),o=k(m.join("."))[n]=this.gsClass=g.apply(g,i),h)if(e[n]=c[n]=o,"undefined"!=typeof module&&module.exports)if(d===b){module.exports=c[b]=o;for(p in c)o[p]=c[p]}else c[b]&&(c[b][n]=o);else"function"=="function"&&__webpack_require__(240)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){return o}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));for(p=0;p<this.sc.length;p++)this.sc[p].check()}},this.check(!0)},s=a._gsDefine=function(a,b,c,d){return new r(a,b,c,d)},t=l._class=function(a,b,c){return b=b||function(){},s(a,[],function(){return b},c),b};s.globals=e;var u=[0,0,1,1],v=t("easing.Ease",function(a,b,c,d){this._func=a,this._type=c||0,this._power=d||0,this._params=b?u.concat(b):u},!0),w=v.map={},x=v.register=function(a,b,c,d){for(var e,f,g,h,i=b.split(","),j=i.length,k=(c||"easeIn,easeOut,easeInOut").split(",");--j>-1;)for(f=i[j],e=d?t("easing."+f,null,!0):l.easing[f]||{},g=k.length;--g>-1;)h=k[g],w[f+"."+h]=w[h+f]=e[h]=a.getRatio?a:a[h]||new a};for(h=v.prototype,h._calcEnd=!1,h.getRatio=function(a){if(this._func)return this._params[0]=a,this._func.apply(null,this._params);var b=this._type,c=this._power,d=1===b?1-a:2===b?a:.5>a?2*a:2*(1-a);return 1===c?d*=d:2===c?d*=d*d:3===c?d*=d*d*d:4===c&&(d*=d*d*d*d),1===b?1-d:2===b?d:.5>a?d/2:1-d/2},f=["Linear","Quad","Cubic","Quart","Quint,Strong"],g=f.length;--g>-1;)h=f[g]+",Power"+g,x(new v(null,null,1,g),h,"easeOut",!0),x(new v(null,null,2,g),h,"easeIn"+(0===g?",easeNone":"")),x(new v(null,null,3,g),h,"easeInOut");w.linear=l.easing.Linear.easeIn,w.swing=l.easing.Quad.easeInOut;var y=t("events.EventDispatcher",function(a){this._listeners={},this._eventTarget=a||this});h=y.prototype,h.addEventListener=function(a,b,c,d,e){e=e||0;var f,g,h=this._listeners[a],k=0;for(this!==i||j||i.wake(),null==h&&(this._listeners[a]=h=[]),g=h.length;--g>-1;)f=h[g],f.c===b&&f.s===c?h.splice(g,1):0===k&&f.pr<e&&(k=g+1);h.splice(k,0,{c:b,s:c,up:d,pr:e})},h.removeEventListener=function(a,b){var c,d=this._listeners[a];if(d)for(c=d.length;--c>-1;)if(d[c].c===b)return void d.splice(c,1)},h.dispatchEvent=function(a){var b,c,d,e=this._listeners[a];if(e)for(b=e.length,b>1&&(e=e.slice(0)),c=this._eventTarget;--b>-1;)d=e[b],d&&(d.up?d.c.call(d.s||c,{type:a,target:c}):d.c.call(d.s||c))};var z=a.requestAnimationFrame,A=a.cancelAnimationFrame,B=Date.now||function(){return(new Date).getTime()},C=B();for(f=["ms","moz","webkit","o"],g=f.length;--g>-1&&!z;)z=a[f[g]+"RequestAnimationFrame"],A=a[f[g]+"CancelAnimationFrame"]||a[f[g]+"CancelRequestAnimationFrame"];t("Ticker",function(a,b){var c,e,f,g,h,k=this,l=B(),n=b!==!1&&z?"auto":!1,p=500,q=33,r="tick",s=function(a){var b,d,i=B()-C;i>p&&(l+=i-q),C+=i,k.time=(C-l)/1e3,b=k.time-h,(!c||b>0||a===!0)&&(k.frame++,h+=b+(b>=g?.004:g-b),d=!0),a!==!0&&(f=e(s)),d&&k.dispatchEvent(r)};y.call(k),k.time=k.frame=0,k.tick=function(){s(!0)},k.lagSmoothing=function(a,b){return arguments.length?(p=a||1/m,void(q=Math.min(b,p,0))):1/m>p},k.sleep=function(){null!=f&&(n&&A?A(f):clearTimeout(f),e=o,f=null,k===i&&(j=!1))},k.wake=function(a){null!==f?k.sleep():a?l+=-C+(C=B()):k.frame>10&&(C=B()-p+5),e=0===c?o:n&&z?z:function(a){return setTimeout(a,1e3*(h-k.time)+1|0)},k===i&&(j=!0),s(2)},k.fps=function(a){return arguments.length?(c=a,g=1/(c||60),h=this.time+g,void k.wake()):c},k.useRAF=function(a){return arguments.length?(k.sleep(),n=a,void k.fps(c)):n},k.fps(a),setTimeout(function(){"auto"===n&&k.frame<5&&"hidden"!==d.visibilityState&&k.useRAF(!1)},1500)}),h=l.Ticker.prototype=new l.events.EventDispatcher,h.constructor=l.Ticker;var D=t("core.Animation",function(a,b){if(this.vars=b=b||{},this._duration=this._totalDuration=a||0,this._delay=Number(b.delay)||0,this._timeScale=1,this._active=b.immediateRender===!0,this.data=b.data,this._reversed=b.reversed===!0,X){j||i.wake();var c=this.vars.useFrames?W:X;c.add(this,c._time),this.vars.paused&&this.paused(!0)}});i=D.ticker=new l.Ticker,h=D.prototype,h._dirty=h._gc=h._initted=h._paused=!1,h._totalTime=h._time=0,h._rawPrevTime=-1,h._next=h._last=h._onUpdate=h._timeline=h.timeline=null,h._paused=!1;var E=function(){j&&B()-C>2e3&&("hidden"!==d.visibilityState||!i.lagSmoothing())&&i.wake();var a=setTimeout(E,2e3);a.unref&&a.unref()};E(),h.play=function(a,b){return null!=a&&this.seek(a,b),this.reversed(!1).paused(!1)},h.pause=function(a,b){return null!=a&&this.seek(a,b),this.paused(!0)},h.resume=function(a,b){return null!=a&&this.seek(a,b),this.paused(!1)},h.seek=function(a,b){return this.totalTime(Number(a),b!==!1)},h.restart=function(a,b){return this.reversed(!1).paused(!1).totalTime(a?-this._delay:0,b!==!1,!0)},h.reverse=function(a,b){return null!=a&&this.seek(a||this.totalDuration(),b),this.reversed(!0).paused(!1)},h.render=function(a,b,c){},h.invalidate=function(){return this._time=this._totalTime=0,this._initted=this._gc=!1,this._rawPrevTime=-1,(this._gc||!this.timeline)&&this._enabled(!0),this},h.isActive=function(){var a,b=this._timeline,c=this._startTime;return!b||!this._gc&&!this._paused&&b.isActive()&&(a=b.rawTime(!0))>=c&&a<c+this.totalDuration()/this._timeScale-1e-7},h._enabled=function(a,b){return j||i.wake(),this._gc=!a,this._active=this.isActive(),b!==!0&&(a&&!this.timeline?this._timeline.add(this,this._startTime-this._delay):!a&&this.timeline&&this._timeline._remove(this,!0)),!1},h._kill=function(a,b){return this._enabled(!1,!1)},h.kill=function(a,b){return this._kill(a,b),this},h._uncache=function(a){for(var b=a?this:this.timeline;b;)b._dirty=!0,b=b.timeline;return this},h._swapSelfInParams=function(a){for(var b=a.length,c=a.concat();--b>-1;)"{self}"===a[b]&&(c[b]=this);return c},h._callback=function(a){var b=this.vars,c=b[a],d=b[a+"Params"],e=b[a+"Scope"]||b.callbackScope||this,f=d?d.length:0;switch(f){case 0:c.call(e);break;case 1:c.call(e,d[0]);break;case 2:c.call(e,d[0],d[1]);break;default:c.apply(e,d)}},h.eventCallback=function(a,b,c,d){if("on"===(a||"").substr(0,2)){var e=this.vars;if(1===arguments.length)return e[a];null==b?delete e[a]:(e[a]=b,e[a+"Params"]=p(c)&&-1!==c.join("").indexOf("{self}")?this._swapSelfInParams(c):c,e[a+"Scope"]=d),"onUpdate"===a&&(this._onUpdate=b)}return this},h.delay=function(a){return arguments.length?(this._timeline.smoothChildTiming&&this.startTime(this._startTime+a-this._delay),this._delay=a,this):this._delay},h.duration=function(a){return arguments.length?(this._duration=this._totalDuration=a,this._uncache(!0),this._timeline.smoothChildTiming&&this._time>0&&this._time<this._duration&&0!==a&&this.totalTime(this._totalTime*(a/this._duration),!0),this):(this._dirty=!1,this._duration)},h.totalDuration=function(a){return this._dirty=!1,arguments.length?this.duration(a):this._totalDuration},h.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),this.totalTime(a>this._duration?this._duration:a,b)):this._time},h.totalTime=function(a,b,c){if(j||i.wake(),!arguments.length)return this._totalTime;if(this._timeline){if(0>a&&!c&&(a+=this.totalDuration()),this._timeline.smoothChildTiming){this._dirty&&this.totalDuration();var d=this._totalDuration,e=this._timeline;if(a>d&&!c&&(a=d),this._startTime=(this._paused?this._pauseTime:e._time)-(this._reversed?d-a:a)/this._timeScale,e._dirty||this._uncache(!1),e._timeline)for(;e._timeline;)e._timeline._time!==(e._startTime+e._totalTime)/e._timeScale&&e.totalTime(e._totalTime,!0),e=e._timeline}this._gc&&this._enabled(!0,!1),(this._totalTime!==a||0===this._duration)&&(J.length&&Z(),this.render(a,b,!1),J.length&&Z())}return this},h.progress=h.totalProgress=function(a,b){var c=this.duration();return arguments.length?this.totalTime(c*a,b):c?this._time/c:this.ratio},h.startTime=function(a){return arguments.length?(a!==this._startTime&&(this._startTime=a,this.timeline&&this.timeline._sortChildren&&this.timeline.add(this,a-this._delay)),this):this._startTime},h.endTime=function(a){return this._startTime+(0!=a?this.totalDuration():this.duration())/this._timeScale},h.timeScale=function(a){if(!arguments.length)return this._timeScale;var b,c;for(a=a||m,this._timeline&&this._timeline.smoothChildTiming&&(b=this._pauseTime,c=b||0===b?b:this._timeline.totalTime(),this._startTime=c-(c-this._startTime)*this._timeScale/a),this._timeScale=a,c=this.timeline;c&&c.timeline;)c._dirty=!0,c.totalDuration(),c=c.timeline;return this},h.reversed=function(a){return arguments.length?(a!=this._reversed&&(this._reversed=a,this.totalTime(this._timeline&&!this._timeline.smoothChildTiming?this.totalDuration()-this._totalTime:this._totalTime,!0)),this):this._reversed},h.paused=function(a){if(!arguments.length)return this._paused;var b,c,d=this._timeline;return a!=this._paused&&d&&(j||a||i.wake(),b=d.rawTime(),c=b-this._pauseTime,!a&&d.smoothChildTiming&&(this._startTime+=c,this._uncache(!1)),this._pauseTime=a?b:null,this._paused=a,this._active=this.isActive(),!a&&0!==c&&this._initted&&this.duration()&&(b=d.smoothChildTiming?this._totalTime:(b-this._startTime)/this._timeScale,this.render(b,b===this._totalTime,!0))),this._gc&&!a&&this._enabled(!0,!1),this};var F=t("core.SimpleTimeline",function(a){D.call(this,0,a),this.autoRemoveChildren=this.smoothChildTiming=!0});h=F.prototype=new D,h.constructor=F,h.kill()._gc=!1,h._first=h._last=h._recent=null,h._sortChildren=!1,h.add=h.insert=function(a,b,c,d){var e,f;if(a._startTime=Number(b||0)+a._delay,a._paused&&this!==a._timeline&&(a._pauseTime=a._startTime+(this.rawTime()-a._startTime)/a._timeScale),a.timeline&&a.timeline._remove(a,!0),a.timeline=a._timeline=this,a._gc&&a._enabled(!0,!0),e=this._last,this._sortChildren)for(f=a._startTime;e&&e._startTime>f;)e=e._prev;return e?(a._next=e._next,e._next=a):(a._next=this._first,this._first=a),a._next?a._next._prev=a:this._last=a,a._prev=e,this._recent=a,this._timeline&&this._uncache(!0),this},h._remove=function(a,b){return a.timeline===this&&(b||a._enabled(!1,!0),a._prev?a._prev._next=a._next:this._first===a&&(this._first=a._next),a._next?a._next._prev=a._prev:this._last===a&&(this._last=a._prev),a._next=a._prev=a.timeline=null,a===this._recent&&(this._recent=this._last),this._timeline&&this._uncache(!0)),this},h.render=function(a,b,c){var d,e=this._first;for(this._totalTime=this._time=this._rawPrevTime=a;e;)d=e._next,(e._active||a>=e._startTime&&!e._paused&&!e._gc)&&(e._reversed?e.render((e._dirty?e.totalDuration():e._totalDuration)-(a-e._startTime)*e._timeScale,b,c):e.render((a-e._startTime)*e._timeScale,b,c)),e=d},h.rawTime=function(){return j||i.wake(),this._totalTime};var G=t("TweenLite",function(b,c,d){if(D.call(this,c,d),this.render=G.prototype.render,null==b)throw"Cannot tween a null target.";this.target=b="string"!=typeof b?b:G.selector(b)||b;var e,f,g,h=b.jquery||b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType),i=this.vars.overwrite;if(this._overwrite=i=null==i?V[G.defaultOverwrite]:"number"==typeof i?i>>0:V[i],(h||b instanceof Array||b.push&&p(b))&&"number"!=typeof b[0])for(this._targets=g=n(b),this._propLookup=[],this._siblings=[],e=0;e<g.length;e++)f=g[e],f?"string"!=typeof f?f.length&&f!==a&&f[0]&&(f[0]===a||f[0].nodeType&&f[0].style&&!f.nodeType)?(g.splice(e--,1),this._targets=g=g.concat(n(f))):(this._siblings[e]=$(f,this,!1),1===i&&this._siblings[e].length>1&&aa(f,this,null,1,this._siblings[e])):(f=g[e--]=G.selector(f),"string"==typeof f&&g.splice(e+1,1)):g.splice(e--,1);else this._propLookup={},this._siblings=$(b,this,!1),1===i&&this._siblings.length>1&&aa(b,this,null,1,this._siblings);(this.vars.immediateRender||0===c&&0===this._delay&&this.vars.immediateRender!==!1)&&(this._time=-m,this.render(Math.min(0,-this._delay)))},!0),H=function(b){return b&&b.length&&b!==a&&b[0]&&(b[0]===a||b[0].nodeType&&b[0].style&&!b.nodeType)},I=function(a,b){var c,d={};for(c in a)U[c]||c in b&&"transform"!==c&&"x"!==c&&"y"!==c&&"width"!==c&&"height"!==c&&"className"!==c&&"border"!==c||!(!R[c]||R[c]&&R[c]._autoCSS)||(d[c]=a[c],delete a[c]);a.css=d};h=G.prototype=new D,h.constructor=G,h.kill()._gc=!1,h.ratio=0,h._firstPT=h._targets=h._overwrittenProps=h._startAt=null,h._notifyPluginsOfEnabled=h._lazy=!1,G.version="1.20.3",G.defaultEase=h._ease=new v(null,null,1,1),G.defaultOverwrite="auto",G.ticker=i,G.autoSleep=120,G.lagSmoothing=function(a,b){i.lagSmoothing(a,b)},G.selector=a.$||a.jQuery||function(b){var c=a.$||a.jQuery;return c?(G.selector=c,c(b)):"undefined"==typeof d?b:d.querySelectorAll?d.querySelectorAll(b):d.getElementById("#"===b.charAt(0)?b.substr(1):b)};var J=[],K={},L=/(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,M=/[\+-]=-?[\.\d]/,N=function(a){for(var b,c=this._firstPT,d=1e-6;c;)b=c.blob?1===a&&null!=this.end?this.end:a?this.join(""):this.start:c.c*a+c.s,c.m?b=c.m(b,this._target||c.t):d>b&&b>-d&&!c.blob&&(b=0),c.f?c.fp?c.t[c.p](c.fp,b):c.t[c.p](b):c.t[c.p]=b,c=c._next},O=function(a,b,c,d){var e,f,g,h,i,j,k,l=[],m=0,n="",o=0;for(l.start=a,l.end=b,a=l[0]=a+"",b=l[1]=b+"",c&&(c(l),a=l[0],b=l[1]),l.length=0,e=a.match(L)||[],f=b.match(L)||[],d&&(d._next=null,d.blob=1,l._firstPT=l._applyPT=d),i=f.length,h=0;i>h;h++)k=f[h],j=b.substr(m,b.indexOf(k,m)-m),n+=j||!h?j:",",m+=j.length,o?o=(o+1)%5:"rgba("===j.substr(-5)&&(o=1),k===e[h]||e.length<=h?n+=k:(n&&(l.push(n),n=""),g=parseFloat(e[h]),l.push(g),l._firstPT={_next:l._firstPT,t:l,p:l.length-1,s:g,c:("="===k.charAt(1)?parseInt(k.charAt(0)+"1",10)*parseFloat(k.substr(2)):parseFloat(k)-g)||0,f:0,m:o&&4>o?Math.round:0}),m+=k.length;return n+=b.substr(m),n&&l.push(n),l.setRatio=N,M.test(b)&&(l.end=null),l},P=function(a,b,c,d,e,f,g,h,i){"function"==typeof d&&(d=d(i||0,a));var j,k=typeof a[b],l="function"!==k?"":b.indexOf("set")||"function"!=typeof a["get"+b.substr(3)]?b:"get"+b.substr(3),m="get"!==c?c:l?g?a[l](g):a[l]():a[b],n="string"==typeof d&&"="===d.charAt(1),o={t:a,p:b,s:m,f:"function"===k,pg:0,n:e||b,m:f?"function"==typeof f?f:Math.round:0,pr:0,c:n?parseInt(d.charAt(0)+"1",10)*parseFloat(d.substr(2)):parseFloat(d)-m||0};return("number"!=typeof m||"number"!=typeof d&&!n)&&(g||isNaN(m)||!n&&isNaN(d)||"boolean"==typeof m||"boolean"==typeof d?(o.fp=g,j=O(m,n?parseFloat(o.s)+o.c:d,h||G.defaultStringFilter,o),o={t:j,p:"setRatio",s:0,c:1,f:2,pg:0,n:e||b,pr:0,m:0}):(o.s=parseFloat(m),n||(o.c=parseFloat(d)-o.s||0))),o.c?((o._next=this._firstPT)&&(o._next._prev=o),this._firstPT=o,o):void 0},Q=G._internals={isArray:p,isSelector:H,lazyTweens:J,blobDif:O},R=G._plugins={},S=Q.tweenLookup={},T=0,U=Q.reservedProps={ease:1,delay:1,overwrite:1,onComplete:1,onCompleteParams:1,onCompleteScope:1,useFrames:1,runBackwards:1,startAt:1,onUpdate:1,onUpdateParams:1,onUpdateScope:1,onStart:1,onStartParams:1,onStartScope:1,onReverseComplete:1,onReverseCompleteParams:1,onReverseCompleteScope:1,onRepeat:1,onRepeatParams:1,onRepeatScope:1,easeParams:1,yoyo:1,immediateRender:1,repeat:1,repeatDelay:1,data:1,paused:1,reversed:1,autoCSS:1,lazy:1,onOverwrite:1,callbackScope:1,stringFilter:1,id:1,yoyoEase:1},V={none:0,all:1,auto:2,concurrent:3,allOnStart:4,preexisting:5,"true":1,"false":0},W=D._rootFramesTimeline=new F,X=D._rootTimeline=new F,Y=30,Z=Q.lazyRender=function(){var a,b=J.length;for(K={};--b>-1;)a=J[b],a&&a._lazy!==!1&&(a.render(a._lazy[0],a._lazy[1],!0),a._lazy=!1);J.length=0};X._startTime=i.time,W._startTime=i.frame,X._active=W._active=!0,setTimeout(Z,1),D._updateRoot=G.render=function(){var a,b,c;if(J.length&&Z(),X.render((i.time-X._startTime)*X._timeScale,!1,!1),W.render((i.frame-W._startTime)*W._timeScale,!1,!1),J.length&&Z(),i.frame>=Y){Y=i.frame+(parseInt(G.autoSleep,10)||120);for(c in S){for(b=S[c].tweens,a=b.length;--a>-1;)b[a]._gc&&b.splice(a,1);0===b.length&&delete S[c]}if(c=X._first,(!c||c._paused)&&G.autoSleep&&!W._first&&1===i._listeners.tick.length){for(;c&&c._paused;)c=c._next;c||i.sleep()}}},i.addEventListener("tick",D._updateRoot);var $=function(a,b,c){var d,e,f=a._gsTweenID;if(S[f||(a._gsTweenID=f="t"+T++)]||(S[f]={target:a,tweens:[]}),b&&(d=S[f].tweens,d[e=d.length]=b,c))for(;--e>-1;)d[e]===b&&d.splice(e,1);return S[f].tweens},_=function(a,b,c,d){var e,f,g=a.vars.onOverwrite;return g&&(e=g(a,b,c,d)),g=G.onOverwrite,g&&(f=g(a,b,c,d)),e!==!1&&f!==!1},aa=function(a,b,c,d,e){var f,g,h,i;if(1===d||d>=4){for(i=e.length,f=0;i>f;f++)if((h=e[f])!==b)h._gc||h._kill(null,a,b)&&(g=!0);else if(5===d)break;return g}var j,k=b._startTime+m,l=[],n=0,o=0===b._duration;for(f=e.length;--f>-1;)(h=e[f])===b||h._gc||h._paused||(h._timeline!==b._timeline?(j=j||ba(b,0,o),0===ba(h,j,o)&&(l[n++]=h)):h._startTime<=k&&h._startTime+h.totalDuration()/h._timeScale>k&&((o||!h._initted)&&k-h._startTime<=2e-10||(l[n++]=h)));for(f=n;--f>-1;)if(h=l[f],2===d&&h._kill(c,a,b)&&(g=!0),2!==d||!h._firstPT&&h._initted){if(2!==d&&!_(h,b))continue;h._enabled(!1,!1)&&(g=!0)}return g},ba=function(a,b,c){for(var d=a._timeline,e=d._timeScale,f=a._startTime;d._timeline;){if(f+=d._startTime,e*=d._timeScale,d._paused)return-100;d=d._timeline}return f/=e,f>b?f-b:c&&f===b||!a._initted&&2*m>f-b?m:(f+=a.totalDuration()/a._timeScale/e)>b+m?0:f-b-m};h._init=function(){var a,b,c,d,e,f,g=this.vars,h=this._overwrittenProps,i=this._duration,j=!!g.immediateRender,k=g.ease;if(g.startAt){this._startAt&&(this._startAt.render(-1,!0),this._startAt.kill()),e={};for(d in g.startAt)e[d]=g.startAt[d];if(e.data="isStart",e.overwrite=!1,e.immediateRender=!0,e.lazy=j&&g.lazy!==!1,e.startAt=e.delay=null,e.onUpdate=g.onUpdate,e.onUpdateParams=g.onUpdateParams,e.onUpdateScope=g.onUpdateScope||g.callbackScope||this,this._startAt=G.to(this.target,0,e),j)if(this._time>0)this._startAt=null;else if(0!==i)return}else if(g.runBackwards&&0!==i)if(this._startAt)this._startAt.render(-1,!0),this._startAt.kill(),this._startAt=null;else{0!==this._time&&(j=!1),c={};for(d in g)U[d]&&"autoCSS"!==d||(c[d]=g[d]);if(c.overwrite=0,c.data="isFromStart",c.lazy=j&&g.lazy!==!1,c.immediateRender=j,this._startAt=G.to(this.target,0,c),j){if(0===this._time)return}else this._startAt._init(),this._startAt._enabled(!1),this.vars.immediateRender&&(this._startAt=null)}if(this._ease=k=k?k instanceof v?k:"function"==typeof k?new v(k,g.easeParams):w[k]||G.defaultEase:G.defaultEase,g.easeParams instanceof Array&&k.config&&(this._ease=k.config.apply(k,g.easeParams)),this._easeType=this._ease._type,this._easePower=this._ease._power,this._firstPT=null,this._targets)for(f=this._targets.length,a=0;f>a;a++)this._initProps(this._targets[a],this._propLookup[a]={},this._siblings[a],h?h[a]:null,a)&&(b=!0);else b=this._initProps(this.target,this._propLookup,this._siblings,h,0);if(b&&G._onPluginEvent("_onInitAllProps",this),h&&(this._firstPT||"function"!=typeof this.target&&this._enabled(!1,!1)),g.runBackwards)for(c=this._firstPT;c;)c.s+=c.c,c.c=-c.c,c=c._next;this._onUpdate=g.onUpdate,this._initted=!0},h._initProps=function(b,c,d,e,f){var g,h,i,j,k,l;if(null==b)return!1;K[b._gsTweenID]&&Z(),this.vars.css||b.style&&b!==a&&b.nodeType&&R.css&&this.vars.autoCSS!==!1&&I(this.vars,b);for(g in this.vars)if(l=this.vars[g],U[g])l&&(l instanceof Array||l.push&&p(l))&&-1!==l.join("").indexOf("{self}")&&(this.vars[g]=l=this._swapSelfInParams(l,this));else if(R[g]&&(j=new R[g])._onInitTween(b,this.vars[g],this,f)){for(this._firstPT=k={_next:this._firstPT,t:j,p:"setRatio",s:0,c:1,f:1,n:g,pg:1,pr:j._priority,m:0},h=j._overwriteProps.length;--h>-1;)c[j._overwriteProps[h]]=this._firstPT;(j._priority||j._onInitAllProps)&&(i=!0),(j._onDisable||j._onEnable)&&(this._notifyPluginsOfEnabled=!0),k._next&&(k._next._prev=k)}else c[g]=P.call(this,b,g,"get",l,g,0,null,this.vars.stringFilter,f);return e&&this._kill(e,b)?this._initProps(b,c,d,e,f):this._overwrite>1&&this._firstPT&&d.length>1&&aa(b,this,c,this._overwrite,d)?(this._kill(c,b),this._initProps(b,c,d,e,f)):(this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration)&&(K[b._gsTweenID]=!0),i)},h.render=function(a,b,c){var d,e,f,g,h=this._time,i=this._duration,j=this._rawPrevTime;if(a>=i-1e-7&&a>=0)this._totalTime=this._time=i,this.ratio=this._ease._calcEnd?this._ease.getRatio(1):1,this._reversed||(d=!0,e="onComplete",c=c||this._timeline.autoRemoveChildren),0===i&&(this._initted||!this.vars.lazy||c)&&(this._startTime===this._timeline._duration&&(a=0),(0>j||0>=a&&a>=-1e-7||j===m&&"isPause"!==this.data)&&j!==a&&(c=!0,j>m&&(e="onReverseComplete")),this._rawPrevTime=g=!b||a||j===a?a:m);else if(1e-7>a)this._totalTime=this._time=0,this.ratio=this._ease._calcEnd?this._ease.getRatio(0):0,(0!==h||0===i&&j>0)&&(e="onReverseComplete",d=this._reversed),0>a&&(this._active=!1,0===i&&(this._initted||!this.vars.lazy||c)&&(j>=0&&(j!==m||"isPause"!==this.data)&&(c=!0),this._rawPrevTime=g=!b||a||j===a?a:m)),(!this._initted||this._startAt&&this._startAt.progress())&&(c=!0);else if(this._totalTime=this._time=a,this._easeType){var k=a/i,l=this._easeType,n=this._easePower;(1===l||3===l&&k>=.5)&&(k=1-k),3===l&&(k*=2),1===n?k*=k:2===n?k*=k*k:3===n?k*=k*k*k:4===n&&(k*=k*k*k*k),1===l?this.ratio=1-k:2===l?this.ratio=k:.5>a/i?this.ratio=k/2:this.ratio=1-k/2}else this.ratio=this._ease.getRatio(a/i);if(this._time!==h||c){if(!this._initted){if(this._init(),!this._initted||this._gc)return;if(!c&&this._firstPT&&(this.vars.lazy!==!1&&this._duration||this.vars.lazy&&!this._duration))return this._time=this._totalTime=h,this._rawPrevTime=j,J.push(this),void(this._lazy=[a,b]);this._time&&!d?this.ratio=this._ease.getRatio(this._time/i):d&&this._ease._calcEnd&&(this.ratio=this._ease.getRatio(0===this._time?0:1))}for(this._lazy!==!1&&(this._lazy=!1),this._active||!this._paused&&this._time!==h&&a>=0&&(this._active=!0),0===h&&(this._startAt&&(a>=0?this._startAt.render(a,!0,c):e||(e="_dummyGS")),this.vars.onStart&&(0!==this._time||0===i)&&(b||this._callback("onStart"))),f=this._firstPT;f;)f.f?f.t[f.p](f.c*this.ratio+f.s):f.t[f.p]=f.c*this.ratio+f.s,f=f._next;this._onUpdate&&(0>a&&this._startAt&&a!==-1e-4&&this._startAt.render(a,!0,c),b||(this._time!==h||d||c)&&this._callback("onUpdate")),e&&(!this._gc||c)&&(0>a&&this._startAt&&!this._onUpdate&&a!==-1e-4&&this._startAt.render(a,!0,c),d&&(this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[e]&&this._callback(e),0===i&&this._rawPrevTime===m&&g!==m&&(this._rawPrevTime=0))}},h._kill=function(a,b,c){if("all"===a&&(a=null),null==a&&(null==b||b===this.target))return this._lazy=!1,this._enabled(!1,!1);b="string"!=typeof b?b||this._targets||this.target:G.selector(b)||b;var d,e,f,g,h,i,j,k,l,m=c&&this._time&&c._startTime===this._startTime&&this._timeline===c._timeline;if((p(b)||H(b))&&"number"!=typeof b[0])for(d=b.length;--d>-1;)this._kill(a,b[d],c)&&(i=!0);else{if(this._targets){for(d=this._targets.length;--d>-1;)if(b===this._targets[d]){h=this._propLookup[d]||{},this._overwrittenProps=this._overwrittenProps||[],e=this._overwrittenProps[d]=a?this._overwrittenProps[d]||{}:"all";break}}else{if(b!==this.target)return!1;h=this._propLookup,e=this._overwrittenProps=a?this._overwrittenProps||{}:"all"}if(h){if(j=a||h,k=a!==e&&"all"!==e&&a!==h&&("object"!=typeof a||!a._tempKill),c&&(G.onOverwrite||this.vars.onOverwrite)){for(f in j)h[f]&&(l||(l=[]),l.push(f));if((l||!a)&&!_(this,c,b,l))return!1}for(f in j)(g=h[f])&&(m&&(g.f?g.t[g.p](g.s):g.t[g.p]=g.s,i=!0),g.pg&&g.t._kill(j)&&(i=!0),g.pg&&0!==g.t._overwriteProps.length||(g._prev?g._prev._next=g._next:g===this._firstPT&&(this._firstPT=g._next),g._next&&(g._next._prev=g._prev),g._next=g._prev=null),delete h[f]),k&&(e[f]=1);!this._firstPT&&this._initted&&this._enabled(!1,!1)}}return i},h.invalidate=function(){return this._notifyPluginsOfEnabled&&G._onPluginEvent("_onDisable",this),this._firstPT=this._overwrittenProps=this._startAt=this._onUpdate=null,this._notifyPluginsOfEnabled=this._active=this._lazy=!1,this._propLookup=this._targets?{}:[],D.prototype.invalidate.call(this),this.vars.immediateRender&&(this._time=-m,this.render(Math.min(0,-this._delay))),this},h._enabled=function(a,b){if(j||i.wake(),a&&this._gc){var c,d=this._targets;if(d)for(c=d.length;--c>-1;)this._siblings[c]=$(d[c],this,!0);else this._siblings=$(this.target,this,!0)}return D.prototype._enabled.call(this,a,b),this._notifyPluginsOfEnabled&&this._firstPT?G._onPluginEvent(a?"_onEnable":"_onDisable",this):!1},G.to=function(a,b,c){return new G(a,b,c)},G.from=function(a,b,c){return c.runBackwards=!0,c.immediateRender=0!=c.immediateRender,new G(a,b,c)},G.fromTo=function(a,b,c,d){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,new G(a,b,d)},G.delayedCall=function(a,b,c,d,e){return new G(b,0,{delay:a,onComplete:b,onCompleteParams:c,callbackScope:d,onReverseComplete:b,onReverseCompleteParams:c,immediateRender:!1,lazy:!1,useFrames:e,overwrite:0})},G.set=function(a,b){return new G(a,0,b)},G.getTweensOf=function(a,b){if(null==a)return[];a="string"!=typeof a?a:G.selector(a)||a;var c,d,e,f;if((p(a)||H(a))&&"number"!=typeof a[0]){for(c=a.length,d=[];--c>-1;)d=d.concat(G.getTweensOf(a[c],b));for(c=d.length;--c>-1;)for(f=d[c],e=c;--e>-1;)f===d[e]&&d.splice(c,1)}else if(a._gsTweenID)for(d=$(a).concat(),c=d.length;--c>-1;)(d[c]._gc||b&&!d[c].isActive())&&d.splice(c,1);return d||[]},G.killTweensOf=G.killDelayedCallsTo=function(a,b,c){"object"==typeof b&&(c=b,b=!1);for(var d=G.getTweensOf(a,b),e=d.length;--e>-1;)d[e]._kill(c,a)};var ca=t("plugins.TweenPlugin",function(a,b){this._overwriteProps=(a||"").split(","),this._propName=this._overwriteProps[0],this._priority=b||0,this._super=ca.prototype},!0);if(h=ca.prototype,ca.version="1.19.0",ca.API=2,h._firstPT=null,h._addTween=P,h.setRatio=N,h._kill=function(a){var b,c=this._overwriteProps,d=this._firstPT;if(null!=a[this._propName])this._overwriteProps=[];else for(b=c.length;--b>-1;)null!=a[c[b]]&&c.splice(b,1);for(;d;)null!=a[d.n]&&(d._next&&(d._next._prev=d._prev),d._prev?(d._prev._next=d._next,d._prev=null):this._firstPT===d&&(this._firstPT=d._next)),d=d._next;return!1},h._mod=h._roundProps=function(a){for(var b,c=this._firstPT;c;)b=a[this._propName]||null!=c.n&&a[c.n.split(this._propName+"_").join("")],b&&"function"==typeof b&&(2===c.f?c.t._applyPT.m=b:c.m=b),c=c._next},G._onPluginEvent=function(a,b){var c,d,e,f,g,h=b._firstPT;if("_onInitAllProps"===a){for(;h;){for(g=h._next,d=e;d&&d.pr>h.pr;)d=d._next;(h._prev=d?d._prev:f)?h._prev._next=h:e=h,(h._next=d)?d._prev=h:f=h,h=g}h=b._firstPT=e}for(;h;)h.pg&&"function"==typeof h.t[a]&&h.t[a]()&&(c=!0),h=h._next;return c},ca.activate=function(a){for(var b=a.length;--b>-1;)a[b].API===ca.API&&(R[(new a[b])._propName]=a[b]);return!0},s.plugin=function(a){if(!(a&&a.propName&&a.init&&a.API))throw"illegal plugin definition.";var b,c=a.propName,d=a.priority||0,e=a.overwriteProps,f={init:"_onInitTween",set:"setRatio",kill:"_kill",round:"_mod",mod:"_mod",initAll:"_onInitAllProps"},g=t("plugins."+c.charAt(0).toUpperCase()+c.substr(1)+"Plugin",function(){ca.call(this,c,d),this._overwriteProps=e||[]},a.global===!0),h=g.prototype=new ca(c);h.constructor=g,g.API=a.API;for(b in f)"function"==typeof a[b]&&(h[f[b]]=a[b]);return g.version=a.version,ca.activate([g]),g},f=a._gsQueue){for(g=0;g<f.length;g++)f[g]();for(h in q)q[h].func||a.console.log("GSAP encountered missing dependency: "+h)}j=!1}}("undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window,"TweenLite");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var Size = __webpack_require__(84);

    /**
     * Represents a rectangle.
     *
     * @class Rectangle
     */
    var Rectangle = Class.extend({

        /**
         * Constructor.
         *
         * @param  {Number|Object} top The top distance or a raw object (as the only argument)
         * describing the rectangle, e.g. <tt>{top: 0, left: 0, width: 100, height: 100}</tt>.
         *
         * @param  {Number} left   The left distance.
         * @param  {Number} width  The width of the rectangle.
         * @param  {Number} height The height of the rectangle.
         */
        constructor: function constructor(top, left, width, height) {
            if (arguments.length === 1) {
                var rectangle = top;

                this.top = rectangle.top || rectangle.y || 0;
                this.left = rectangle.left || rectangle.x || 0;

                this.width = rectangle.width;
                this.height = rectangle.height;
            } else {
                this.top = top;
                this.left = left;
                this.width = width;
                this.height = height;
            }

            // Add bottom and right...
            this.bottom = this.top + this.height;
            this.right = this.left + this.width;

            // Consistency/legacy...
            this.x = this.left;
            this.y = this.top;
        },


        /**
         * Whether the specified rectangle is fully contained within *this* rectangle.
         *
         * @param  {Rectangle} rectangle The rectangle to check.
         * @return {Boolean}   <tt>true</tt> if the specified rectangle is fully contained
         * within *this* rectangle, otherwise <tt>false</tt>.
         */
        contains: function contains(rectangle) {
            if (this.left <= rectangle.left && this.top <= rectangle.top && rectangle.left + rectangle.width <= this.left + this.width && rectangle.top + rectangle.height <= this.top + this.height) {
                return true;
            }

            return false;
        },


        /**
         * Whether the specified rectangle intersects/overlaps with *this* rectangle.
         *
         * @param  {Rectangle} rectangle The rectangle to check.
         * @return {Boolean}              <tt>true</tt> if the specified rectangle intersects/overlaps
         *                                             with *this* rectangle, otherwise <tt>false</tt>.
         */
        intersects: function intersects(rectangle) {
            // Return false when rectangle is empty (ie has no area)
            if (this.isEmpty()) {
                return false;
            }

            // http://stackoverflow.com/questions/2752349/fast-rectangle-to-rectangle-intersection
            return !(this.left > rectangle.right || this.right < rectangle.left || this.top > rectangle.bottom || this.bottom < rectangle.top);
        },
        area: function area() {
            return this.width * this.height;
        },
        intersectionArea: function intersectionArea(rectangle) {
            var xOverlap = Math.max(0, Math.min(this.right, rectangle.right) - Math.max(this.left, rectangle.left));
            var yOverlap = Math.max(0, Math.min(this.bottom, rectangle.bottom) - Math.max(this.top, rectangle.top));

            return xOverlap * yOverlap;
        },


        /**
         * Returns a <tt>Size</tt> representation of this Rectangle.
         *
         * @return A new size for this Rectangle as (this.width, this.height); never falsey.
         */
        toSize: function toSize() {
            return new Size(this.width, this.height);
        },


        /**
         * Determines whether *this* <tt>Rectangle</tt> is empty. When a <tt>Rectangle</tt> is empty, it encloses no area.
         *
         * @return {Boolean} <tt>true</tt> if considered empty, <tt>false</tt> if not.
         */
        isEmpty: function isEmpty() {
            return this.width === 0 || this.height === 0;
        },
        toString: function toString() {
            return "Rectangle[top: " + this.top + "; left: " + this.left + "; width: " + this.width + "; height: " + this.height + "]";
        },


        /**
         * Returns a new scaled <tt>Rectangle</tt> based on *this*.
         *
         * @param  {Number} factor The scale factor, e.g. <tt>1.50</tt> to scale by 50%.
         * @return {Rectangle}     The new scaled <tt>Rectangle</tt> instance.
         */
        scale: function scale(factor) {
            return new Rectangle(this.top * factor, this.left * factor, this.width * factor, this.height * factor);
        }
    });

    return Rectangle;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);
    var SceneNavigationAction = __webpack_require__(191);

    // Need to require file for Webpack to pick it up without compromising the image structure for the image widget.
    // Adding this as CSS will show arrows twice, thus we can import them as js.
    __webpack_require__(1456);
    __webpack_require__(1457);
    __webpack_require__(1458);

    // Using a transparent gif pixel as default image because otherwise Chrome draws a border on
    // the image. The icon in the center of the placeholder is set using CSS.
    //   The default image icon used to be images/image_default.svg. That file will be kept for a
    // while to avoid empty image widgets in experiences that still have the old default image.
    var DEFAULT_IMAGE_URL = "images/transparent-pixel.gif";
    var DEFAULT_NEXT_URL = "images/image_default_next_scene.svg";
    var DEFAULT_PREV_URL = "images/image_default_previous_scene.svg";

    /**
     * Model for an image widget.
     *
     * @class ImageWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Image widget", {

        defaults: _.defaults({
            altText: null,
            borderRadius: 0, // px
            height: 0,
            imageId: null,
            originalImageHeight: 0, // px
            originalImageWidth: 0, // px
            supportsResize: false,
            src: null,
            type: "image",
            width: 0,
            crop: null,
            isDynamic: false
        }, AbstractWidgetModel.prototype.defaults),
        computed: _.extend({
            imageUrl: {
                deps: ["src", "action", "actions"],
                value: function value(src, action, actions) {
                    // Return the image source if defined
                    if (src) {
                        return src;
                    }

                    var sceneNavigationAction = void 0;

                    // 'actions' has been deprecated, but we still need to be compatible...
                    if (actions.length) {
                        // If the widget has a next or previous scene action, default to an arrow
                        sceneNavigationAction = actions.find(function (model) {
                            return model instanceof SceneNavigationAction;
                        });
                    }

                    if (action instanceof SceneNavigationAction) {
                        sceneNavigationAction = action;
                    }

                    if (sceneNavigationAction) {
                        if (sceneNavigationAction.get("target") === "next") {
                            return DEFAULT_NEXT_URL;
                        }

                        if (sceneNavigationAction.get("target") === "previous") {
                            return DEFAULT_PREV_URL;
                        }
                    }

                    return DEFAULT_IMAGE_URL;
                }
            }
        }, AbstractWidgetModel.prototype.computed),

        hasImage: function hasImage() {
            return this.has("src");
        },


        /**
         * Whether *this* widget contains a valid original size of the associated image, if any.
         *
         * @return {Boolean} <tt>true</tt> if *this* widget contains a valid original size of the associated image, <tt>false</tt> otherwise.
         */
        containsImageSize: function containsImageSize() {
            return this.get("originalImageWidth") > 0 && this.get("originalImageHeight") > 0;
        }
    }, {
        DEFAULT_IMAGE_URL: DEFAULT_IMAGE_URL
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var generate = __webpack_require__(767);
    var uuidAlphabet = "0123456789abcdefghijklmnopqrstuvwxyz-";

    return {
        createUUID: function createUUID(uuid) {
            uuid = uuid && uuid.length > 0 ? uuid : generate(uuidAlphabet, 21);
            return uuid;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Enum = __webpack_require__(77);

    var values = {
        OVERLAY: {
            value: "overlay",
            name: "Overlay"
        },
        SCENE: {
            value: "scene",
            name: "Scene"
        },
        BACKGROUND: {
            value: "background",
            name: "Background"
        }
    };

    var LayerEnum = Enum.create("LayerEnum", "value", values);

    return LayerEnum;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);

    var GuidelineModel = ImprovedModel.extend("GuidelineModel", {
        defaults: {
            direction: null,
            position: null
        }
    }, {
        HORIZONTAL: "HORIZONTAL",
        VERTICAL: "VERTICAL"
    });

    return GuidelineModel;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var CompositeWidgetModel = __webpack_require__(173);
    var WidgetCollection = __webpack_require__(501);
    var Scale = __webpack_require__(360);
    var ImprovedModel = __webpack_require__(25);

    /**
     * A scene (model) in an experience.
     *
     * @author Gorm Casper
     * @author Bo Gotthardt
     *
     * @class Scene
     */
    return ImprovedModel.extend("Scene", {

        relations: [{
            type: Backbone.Many,
            key: "widgets",
            collectionType: WidgetCollection,
            // TODO: Investigate whether this is still needed/used. Should be removed...
            reverseRelation: {
                key: "scene"
            }
        }],

        defaults: {
            sceneNumber: null,

            widgets: [],

            widgetTabOrder: null,

            removedWidgetTabOrder: null,

            /**
             * Represents the current scale of the scene.
             *
             * Setting the scale will affect the contained widget
             * model's scale.
             *
             * Note that this is a transient property.
             *
             * @type {Scale}
             */
            scale: new Scale()
        },

        computed: {
            isOverlayScene: {
                deps: ["sceneNumber"],
                value: function value(sceneNumber) {
                    return sceneNumber === "overlay";
                }
            },
            isBackgroundScene: {
                deps: ["sceneNumber"],
                value: function value(sceneNumber) {
                    return sceneNumber === "background";
                }
            }
        },

        transient: ["widgetTabOrderMetaData", "removedWidgetTabOrderMetaData"],

        /**
         * Constructor.
         */
        constructor: function constructor() {
            var _this = this;

            this.__super();

            // Delegate the scale to the contained widget models
            this.listenTo(this, "change:scale", function (model, scale) {
                _this.get("widgets").invoke("set", "scale", scale);
            });
        },
        _distinguishedName: function _distinguishedName() {
            var sceneNumber = this.get("sceneNumber");
            var name = "Scene";

            return sceneNumber ? name + " " + sceneNumber : name;
        },


        // sceneNumber is a string, while this will return a number and set index to 0 for overlay and background scenes
        getSceneIndex: function getSceneIndex() {
            return parseInt(this.get("sceneNumber"), 10);
        },
        widgetsByClass: function widgetsByClass(widgetClass) {
            var widgets = this.get("widgets");

            if (widgets) {
                // all widgets include grouped widgets
                var allWidgets = [];

                widgets.each(function (widget) {
                    if (widget instanceof CompositeWidgetModel) {
                        var groupedWidgets = widget.get("group");
                        allWidgets = allWidgets.concat(groupedWidgets.models);
                    } else {
                        allWidgets.push(widget);
                    }
                });

                return allWidgets.filter(function (widget) {
                    return widget instanceof widgetClass;
                });
            }

            return [];
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 254 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(313);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PropertyContainerComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(157);




var PropertyContainerComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PropertyContainerComponent, _super);
    function PropertyContainerComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCollapse = function () {
            _this.setState({ collapsed: !_this.state.collapsed });
        };
        _this.state = {
            collapsed: props.widgetSelected,
            previousWidgetSelected: props.widgetSelected,
        };
        return _this;
    }
    PropertyContainerComponent.getDerivedStateFromProps = function (props, state) {
        if (props.widgetSelected !== state.previousWidgetSelected) {
            return { collapsed: props.widgetSelected, previousWidgetSelected: props.widgetSelected };
        }
        return null;
    };
    PropertyContainerComponent.prototype.componentDidMount = function () {
        var _this = this;
        if (this.props.animateExpandOnMount) {
            setTimeout(function () {
                _this.setState({
                    collapsed: false
                });
            }, 100);
        }
    };
    PropertyContainerComponent.prototype.render = function () {
        var _a = this.props, children = _a.children, name = _a.name, label = _a.label, isEnabled = _a.isEnabled;
        var collapsed = this.state.collapsed;
        // Do we actually need this or are we doing the job of react-bootstrap?
        var collapsedClass = collapsed ? "collapsible collapsed" : "collapsible";
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("fieldset", { className: name + "-properties" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", { className: collapsedClass + " " + (isEnabled ? "" : "disabled"), onClick: this.toggleCollapse }, label),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */], { in: !collapsed && isEnabled, className: name + "-properties-container zmags-input-control" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, children))));
    };
    PropertyContainerComponent.defaultProps = {
        isEnabled: true
    };
    return PropertyContainerComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
// noinspection JSUnusedGlobalSymbols



/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var ImageLibrarySourceEnum = __webpack_require__(102);
    var ImageTagCollection = __webpack_require__(1725);
    var ImprovedModel = __webpack_require__(25);
    var LoggedIn = __webpack_require__(31);
    var LoggedInUserState = __webpack_require__(19);
    var RestApi = __webpack_require__(29);
    var Size = __webpack_require__(84);
    var UrlUtil = __webpack_require__(46);
    var ImageTagModel = __webpack_require__(554);

    var sourceResourceMap = new Map();
    sourceResourceMap.set(ImageLibrarySourceEnum.CREATOR, RestApi.Collections.IMAGES);
    sourceResourceMap.set(ImageLibrarySourceEnum.SCENE7, RestApi.Collections.SCENE7_IMAGES);

    /**
     * Editor Image Model representing editable metadata about an image asset.
     *
     * @class ImageModel
     */
    return ImprovedModel.extend("Image", {
        defaults: function defaults() {
            var principal = LoggedIn.principal();

            return {
                altText: "",
                height: 0,
                name: "Untitled",
                supportsResize: false,
                thumbUrl: "",
                url: "",
                width: 0,
                version: null,
                size: 0,
                timesUsed: 0,
                createdAt: 0,
                createdBy: principal.get("userId"),
                companyId: principal.get("companyId"),
                tags: [] // ImageTagCollection
            };
        },


        relations: [{
            type: Backbone.Many,
            key: "tags",
            collectionType: ImageTagCollection
        }],

        computed: {
            absoluteThumbUrl: {
                deps: ["thumbUrl", "url"],
                value: function value(thumbUrl, url) {
                    return this._getAbsoluteUrl(thumbUrl || url);
                }
            },

            /**
             * @type {String}
             * The file extension of the image, e.g. <tt>png</tt> for an image with an url like <tt>bar/foo.png</tt>.
             */
            extension: {
                deps: ["url", "name"], // default to extension from name on upload, until actual model data is ready
                value: function value(url, name) {
                    var ext = function ext(nameOrUrl) {
                        // Can still have a name with no extension...
                        if (nameOrUrl) {
                            var i = nameOrUrl.lastIndexOf(".");
                            if (i !== -1) {
                                return nameOrUrl.substr(i + 1).toLowerCase(); // can still be empty
                            }
                        }
                        return false;
                    };
                    return ext(url) || ext(name) || "?"; // e.g. ? on upload of legal image with no extension in file name
                }
            },

            /**
             * Returns the number of bytes in a human readable format.
             *
             * @return {String} The number of bytes in human-readable format.
             *
             * @type {String}
             */
            displaySize: {
                deps: ["size"],
                value: function value(size) {
                    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
                    var posttxt = 0;

                    if (size === 0) {
                        return "";
                    }

                    while (size >= 1000) {
                        posttxt++;
                        size /= 1024;
                    }

                    return parseInt(size, 10).toFixed(0) + " " + sizes[posttxt];
                }
            },

            imageTags: {
                deps: ["tags"],
                value: function value(tags) {
                    var imageTags = tags.filter(function (imageTag) {
                        return imageTag.get("type") !== ImageTagModel.Types.ZMAGS_GROUP_ID;
                    });

                    var imageTagCollection = new ImageTagCollection(imageTags);

                    return imageTagCollection;
                }
            },
            inventoryTags: {
                deps: ["tags"],
                value: function value(tags) {
                    var inventoryTags = tags.filter(function (inventoryTag) {
                        return inventoryTag.get("type") === ImageTagModel.Types.ZMAGS_GROUP_ID;
                    });
                    var inventoryTagCollection = new ImageTagCollection(inventoryTags);

                    return inventoryTagCollection;
                }
            }
        },

        transient: [
        // Used for showing progress when uploading
        "uploading", "progress", "timesUsed" // Computed by the backend
        ],

        /**
         * @returns {Size}
         */
        getSize: function getSize() {
            return new Size(this.get("width"), this.get("height"));
        },
        _distinguishedName: function _distinguishedName() {
            return this.get("name");
        },
        _getAbsoluteUrl: function _getAbsoluteUrl(url) {
            var sourceType = this.get("sourceType");
            if (sourceType) {
                var servingUrl = LoggedInUserState.get("integrations").getImageSourceTypeServingUrl(sourceType);
                return UrlUtil.concat(servingUrl, url);
            }

            return url && UrlUtil.getAbsoluteViewerApiUrl(url);
        },


        /**
         * Utility function to get the source which this image belongs based on the <tt>sourceType</tt> attribute.
         * The lookup happens in the <tt>ImageLibrarySourceEnum</tt> which contains all valid source types.
         *
         * @return {ImageLibrarySourceEnum}  A <tt>ImageLibrarySourceEnum</tt> constant if this model has a source defined otherwise undefined.
         */
        getSource: function getSource() {
            var sourceType = this.get("sourceType");
            var source = sourceType && ImageLibrarySourceEnum.lookup(sourceType, true);
            return source;
        },


        /**
         * Utility function to check if the model source is equal to another.
         *
         * Example:
         * <pre>
         *    const isScene7 = model.isSource(ImageLibrarySourceEnum.SCENE7)
         * </pre>
         *
         * @param  {ImageLibrarySourceEnum}  compareSource A ImageLibrarySourceEnum constant
         * @return {Boolean} true if the provided source is equal to the one in this model
         */
        isSource: function isSource(compareSource) {
            var source = this.getSource();
            return source && source === compareSource;
        },
        url: function url() {
            var source = this.getSource() || ImageLibrarySourceEnum.CREATOR;
            var resource = sourceResourceMap.get(source);

            if (this.isNew()) {
                return RestApi.pathToCollection(resource);
            }

            return RestApi.pathToSpecificResource(resource, this.get("id"));
        }
    }, {
        findByIdFromSource: function findByIdFromSource(id, sourceType) {
            return this.findByQuery({ id: id, sourceType: sourceType });
        },
        resourceFromSource: function resourceFromSource(source) {
            var lookupSource = ImageLibrarySourceEnum.lookup(source);
            return sourceResourceMap.get(lookupSource);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ChunkingCollectionView = __webpack_require__(1729),
        SlimSpinnerView = __webpack_require__(862),
        Backbone = __webpack_require__(7),
        Syncer = __webpack_require__(50),
        _ = __webpack_require__(1),
        $ = __webpack_require__(4);

    /**
     * Computes the height of the specified container by iterating it's children, only looking at the visible ones.
     *
     * This is needed to support the desired behavior on the dashboard, since we keep the tapped views in the same container, toggling visibility.
     *
     * @param  {jQueryElement} $container The container element, <tt>jQuery</tt> wrapped.
     * @return {Number} The computed height.
     */
    function computeHeight($container) {
        var height = 0;

        $container.children().each(function () {
            var $element = $(this);

            if ($element.is(":visible")) {
                height += $element.outerHeight(true);
            }
        });

        return height;
    }

    var SpinnerContainer = Backbone.View.extend({

        className: "spinner-container",

        render: function render() {
            this.$el.append(new SlimSpinnerView().render().el);

            return this;
        }

    });

    /**
     * A <tt>ChunkingCollectionView</tt> subclass that enables the classic lazy loading UX when scrolling to the bottom of the page/view.
     *
     * @cfg {ChunkingCollection} collection The <tt>ChunkingCollection</tt> instance.
     * @cfg {Number} horizontalBuffer       Additional horizontal space, i.e. the distance from the bottom of the scrollbar to the bottom of the
     *                                      page/view - deciding when to start fetching the next chuck.
     *
     * @cfg {jQueryElement} scrollTarget    Optional, the element firing the scroll events. If not defined, we'll ask the <tt>viewScope.scrollTarget</tt>.
     *
     * @class InfiniteScrollingCollectionView
     */
    return ChunkingCollectionView.extend({

        className: "infinite-container",

        /**
         * @type {Boolean}
         */
        _pending: false,

        /**
         * @type {Boolean}
         * True when the spinner is spinning, false otherwise.
         */
        _spinning: false,

        /**
         * @type {SpinnerContainer}
         */
        _spinner: null,

        /**
         * The element firing the scroll events.
         *
         * @type {jQueryElement}
         */
        _$scrollTarget: null,

        /**
         * The container element to append the spinner view,
         * generated by the optional options.spinnerContainer selector
         *
         * @type {jQueryElement}
         */
        _$spinnerContainer: null,

        initialize: function initialize() {
            this._scrollHandler = this._scrollHandler.bind(this);
        },

        onShow: function onShow() {
            this.__super();

            this._spinner = new SpinnerContainer();
            this._spinner.render();

            this._$spinnerContainer = this.spinnerContainer ? this.$el.find(this.spinnerContainer) : this._$spinnerContainer;

            this._$scrollTarget = _.result(this.options, "scrollTarget") || _.result(this.viewScope, "scrollTarget");
            this._listenForScrollEvents();

            this.listenTo(this.collection, {
                "sync:state": function syncState() {
                    // Start spinner on sync, including if pending to avoid a "visual jump" on the dashboard
                    // between clearing the old content and adding this spinner, stop it on completion...
                    var complete = Syncer.State.complete(this.collection);

                    if (complete) {
                        if (this._spinning) {
                            this._spinning = false;
                            this._spinner.$el.detach();
                        }
                        this._pending = false;

                        this.triggerMethod("load:end");

                        // Start, on time only ("_pending" is used slightly different, not set to true via sync event, but
                        // via scroll)...
                    } else if (!this._spinning) {
                        this._spinning = true;

                        if (this._$spinnerContainer) {
                            this._$spinnerContainer.append(this._spinner.el);
                        } else {
                            this.$el.append(this._spinner.el);
                        }

                        this.triggerMethod("load:start");
                    }
                }
            });
        },

        /**
         * Whether the view is considered active (default) - when inactive, we won't listen for any scroll events.
         *
         * @param  {Boolean} active The current active state.
         */
        active: function active(_active) {
            if (_active) {
                this._listenForScrollEvents();
            } else {
                this._disposeScrollListener();
            }
        },

        _listenForScrollEvents: function _listenForScrollEvents() {
            this._$scrollTarget.on("scroll", this._scrollHandler);
        },

        _disposeScrollListener: function _disposeScrollListener() {
            this._$scrollTarget.off("scroll", this._scrollHandler);
        },

        /**
         * @private
         *
         * Handles scrolling.
         */
        _scrollHandler: function _scrollHandler() {
            var horizontalBuffer = this.options.horizontalBuffer || 0,

            // TODO: only compute height when collection has changed?
            scrollTargetHeight = computeHeight(this._$scrollTarget),
                viewportHeight = this._$scrollTarget.height();

            // Sanity check
            if (scrollTargetHeight < viewportHeight) {
                return;
            }

            var threshold = scrollTargetHeight - viewportHeight - horizontalBuffer;

            // Fetch the next chuck when we reach the bottom...
            if (this._$scrollTarget.scrollTop() > threshold && !this._pending && !this.collection.isPending() && this.collection.hasMore()) {
                this._pending = true;
                this.collection.next(); // will start triggering sync events!
            }
        },

        /**
         * @inheritDoc
         */
        onClose: function onClose() {
            this.__super();

            this._disposeScrollListener();
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Browser = __webpack_require__(39);
    var Class = __webpack_require__(26);
    var FontConstants = __webpack_require__(1766);
    var FontProvider = __webpack_require__(103);
    var Preconditions = __webpack_require__(14);
    var Promise = __webpack_require__(21);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var WebFontLoader = __webpack_require__(1767);
    var WebFontsUtil = __webpack_require__(136);

    var logger = new Logger("FontLoader");

    /**
     * Start the font loading using the wrapped <tt>WebFontLoader</tt>.
     *
     * If the current browser does not support web fonts (i.e. Google Bot), a
     * resolved promise is returned immediately.
     *
     * @param  {Object} config   Configuration containing the load information.
     * @return {Promise}         A promise that resolves when the fonts have been
     *                           successfully loaded.
     *
     * @see  https://github.com/typekit/webfontloader
     * @see  http://jira.zmags.com/browse/MOS-1483
     */
    function load(config) {
        if (!Browser.capabilities.isWebFontsSupported) {
            return Promise.resolved();
        }

        // Wraps the webfontloader logic in a promise
        var deferred = Promise.deferred();

        // We should really be waiting for all fonts to load, i.e. use the active callback. See
        // MOS-2490.
        config.fontactive = function () {
            deferred.resolve();
        };

        config.inactive = function () {
            deferred.reject("Browser does not support linked fonts or none of the fonts could be loaded. Config: " + JSON.stringify(config));
        };

        config.fontinactive = function (familyName) {
            deferred.reject("Failed loading font family: " + familyName + ". Failed loading config: " + JSON.stringify(config));
        };

        WebFontLoader.load(config);

        return Promise.timeout(deferred, FontConstants.LOAD_FONTS_TIMEOUT, "Loading fonts is slow to respond. config: " + JSON.stringify(config));
    }

    /**
     * A set of unique string values representing each font request. Used as a simple "caching" mechanism (guard) to
     * avoid loading the same font multiple times.
     *
     * @see #filterEntries
     *
     * @type {Set.<String>}
     */
    var entries = new Set();

    /**
     * Map used for loading fonts (the actual CSS needed to render) using the FontLoader.
     *
     * @type {Map.<FontProvider, Function>}
     */
    var fontLoaders = new Map();

    // Custom
    fontLoaders.set(FontProvider.CUSTOM, function (fontDescriptors) {
        return FontLoader.custom(fontDescriptors);
    });

    // Google
    fontLoaders.set(FontProvider.GOOGLE, function (fontDescriptors, loadVariants) {
        var families = void 0;

        if (loadVariants) {
            families = WebFontsUtil.googleFontFamily(fontDescriptors);
        } else {
            families = _.map(fontDescriptors, function (fontDescriptor) {
                return fontDescriptor.get("family");
            });
        }

        return FontLoader.google(families);
    });

    // Typekit
    fontLoaders.set(FontProvider.TYPEKIT, function (fontDescriptors) {
        // Populate list of Typekit kit ID's (stored in the data container)
        var kitIDs = _.uniq(_.map(fontDescriptors, function (fontDescriptor) {
            return fontDescriptor.get("data").kitID;
        }));

        return FontLoader.typekit(kitIDs);
    });

    fontLoaders.set(FontProvider.FONTS_DOT_COM, function (fontDescriptors) {
        var projectIds = _.uniq(_.map(fontDescriptors, function (fontDescriptor) {
            return fontDescriptor.get("data").projectId;
        }));

        return FontLoader.fontsDotCom(projectIds, WebFontsUtil.getFontsDotComFamilies(fontDescriptors));
    });

    /**
     * Utility class for loading web fonts - wrapping
     * the <a href="https://github.com/typekit/webfontloader" target="_blank">Web Font Loader</a>.
     *
     * Includes a simple "caching" mechanism (guard) to avoid loading the same font multiple times.
     *
     * @class FontLoader
     * @author Kim
     */
    var FontLoader = Class.extend({}, {

        /**
         * Filter out already loaded fonts. Fonts are identified differently depending on the font
         * provider:
         *
         * Custom and Google Fonts: The name of the font.
         * Typekit: The Kit ID containing the font.
         * Fonts.com: The Project ID containing the font.
         *
         * Example: ["Open Sans", "Roboto", "Oswald", "eka2gcy", "tpf2man"] => ["Roboto", "eka2gcy"]
         *
         * @param {String[]} fontEntries
         *
         * @returns {String[]} Returns a new array containing the entries that has not yet been loaded.
         */
        filterOutAlreadyLoadedFonts: function filterOutAlreadyLoadedFonts(fontEntries) {
            return _.filter(fontEntries, function (entry) {
                if (entries.has(entry)) {
                    return false;
                }
                entries.add(entry);
                return true;
            });
        },


        /**
         * Start loading the fonts represented by the list of font descriptors.
         *
         * @param  {FontDescriptor[]} fontDescriptors Array of <tt>FontDescriptor</tt>'s.
         *
         * @param  {Boolean} [loadVariants] Whether to load all the variants associated to the
         *                                  specified font descriptors. Defaults to <tt>false</tt>.
         * @return {Promise} A promise that resolves when all font have been successfully loaded.
         */
        fromFontDescriptors: function fromFontDescriptors(fontDescriptors, loadVariants) {
            var fontProviderToFontDescriptors = new Map();
            var promises = [];

            // Create a mapping between font providers and descriptors
            _.each(fontDescriptors, function (fontDescriptor) {
                var provider = fontDescriptor.get("provider");
                if (fontProviderToFontDescriptors.has(provider)) {
                    var list = fontProviderToFontDescriptors.get(provider);
                    list.push(fontDescriptor);
                } else {
                    fontProviderToFontDescriptors.set(provider, [fontDescriptor]);
                }
            });

            fontProviderToFontDescriptors.forEach(function (fontDescriptors, fontProvider) {
                var loader = fontLoaders.get(fontProvider);
                promises.push(loader(fontDescriptors, loadVariants));
            });

            return Promise.all(promises);
        },


        /**
         * Loads all of the fonts used in the given experience.
         *
         * @param {ExperienceModel} experienceModel The experience.
         * @returns {Promise} A promise that resolves when all fonts are loaded.
         */
        loadExperienceFonts: function loadExperienceFonts(experienceModel) {
            return FontLoader.loadSceneFonts(experienceModel.getAllScenes(), experienceModel);
        },


        /**
         * Loads all of the fonts used on the given scene or array of scenes.
         *
         * @param {Scene|Scene[]} scenes The scene or array of scenes to load.*
         * @param {ExperienceModel} experience experience model, used for logging
         * @returns {Promise} A promise that resolves when all fonts are loaded.
         */
        loadSceneFonts: function loadSceneFonts(scenes, experience) {
            var fontDescriptorCollection = WebFontsUtil.createFontDescriptorCollection(scenes);

            return FontLoader.loadFonts(fontDescriptorCollection, experience);
        },


        /**
         * Loads all fonts from the fonts descriptor collection.
         *
         * @param {FontDescriptorCollection} fontDescriptorCollection The fonts descriptor collection.
         * @param {ExperienceModel} experience experience model, used for logging
         * @returns {Promise} A promise that resolves when all fonts are loaded.
         */
        loadFonts: function loadFonts(fontDescriptorCollection, experience) {
            var customFontsPromise = FontLoader.custom(fontDescriptorCollection.fromProvider(FontProvider.CUSTOM));
            var googleFontsPromise = FontLoader.google(WebFontsUtil.googleFontFamily(fontDescriptorCollection));
            var typekitPromise = FontLoader.typekit(WebFontsUtil.getTypekitKitIds(fontDescriptorCollection));
            var fontsDotComPromise = FontLoader.fontsDotCom(WebFontsUtil.getFontsDotComProjectIds(fontDescriptorCollection), WebFontsUtil.getFontsDotComFamilies(fontDescriptorCollection));

            var fontLoadStartTimestamp = Date.now();
            var loadingDuration = void 0;
            return Promise.all([customFontsPromise, googleFontsPromise, typekitPromise, fontsDotComPromise]).always(function () {
                loadingDuration = Date.now() - fontLoadStartTimestamp;
            }).then(function () {
                var textToLog = ["Font loading for experience Id " + experience.get("id") + ", name: '" + experience.get("name") + "' finished successfully in " + loadingDuration + "ms.", "Font Descriptor: " + FontLoader._generateFontDescriptorText(fontDescriptorCollection)].join("\n");

                logger.info(textToLog);
            }).fail(function (reason) {
                var textToLog = ["Font loading failed for experience Id " + experience.get("id") + ", name: '" + experience.get("name") + "' in " + loadingDuration + "ms.", "Reason: '" + reason + "'.", "Font Descriptor (all providers): " + FontLoader._generateFontDescriptorText(fontDescriptorCollection)].join("\n");

                logger.warn(textToLog);
            });
        },
        _generateFontDescriptorText: function _generateFontDescriptorText(fontDescriptorCollection) {
            var fontDescriptorsWithoutSyncState = fontDescriptorCollection.map(function (fontDescriptor) {
                var provider = fontDescriptor.get("provider");
                var providerLoggedObject = {};
                Object.keys(provider).forEach(function (key) {
                    // filter out syncState as it throws a circular error when using toJSON()
                    if (key !== "syncState") {
                        providerLoggedObject[key] = provider[key];
                    }
                });

                var fontDescriptorObject = $.extend(true, {}, fontDescriptor.toJSON());

                fontDescriptorObject.provider = providerLoggedObject; // remove syncState circular reference

                return fontDescriptorObject;
            });

            return JSON.stringify(fontDescriptorsWithoutSyncState);
        },

        /**
         * Loads the specified array of custom font families.
         *
         * @param  {FontDescriptor[]} fontDescriptors Array of custom `FontDescriptor`'s.
         *
         * @return {Promise} A promise that resolves when loading is complete.
         */
        custom: function custom(fontDescriptors) {
            Preconditions.checkArgument(fontDescriptors);

            var families = this.filterOutAlreadyLoadedFonts(fontDescriptors.map(function (fontDescriptor) {
                return fontDescriptor.get("family");
            }));

            if (_.isEmpty(families)) {
                return Promise.resolved();
            }

            WebFontsUtil.injectFontFaceCSS(fontDescriptors);

            return load({
                custom: {
                    families: families
                }
            });
        },


        /**
         * Loads the specified Typekit kit(s).
         *
         * Note: Due to a bug in the webfontloader/typekit, it's only possible to load a single
         * kit via the webfontloader ( https://github.com/typekit/webfontloader/issues/152 ). It
         * seems that the kit concept is tied to a single kit/package per domain/site.
         *
         * The below logic circumvents this issue.
         *
         * @param  {String|String[]} kits The raw kit ID or an array of kit ID's.
         * @return {Promise} A promise that resolves when all kit's have been fetched.
         */
        typekit: function typekit(kits) {
            var _this = this;

            Preconditions.checkArgument(kits);

            function kit(id) {
                Preconditions.checkArgument(id);

                return load({ typekit: { id: id } });
            }

            kits = this.filterOutAlreadyLoadedFonts(_.isString(kits) ? [kits] : kits);

            if (_.isEmpty(kits)) {
                return Promise.resolved();
            }

            // Hack: It's important that the kit's are loaded in sequence, not in parallel.
            return Promise.deferred(function (deferred) {
                var when = $.when(kit(kits.shift()));

                while (kits.length) {
                    when = when.then(kit.bind(_this, kits.shift()));
                }

                when.done(deferred.resolve).fail(deferred.reject);
            });
        },


        /**
         * Loads the specified array of Google font families.
         *
         * @param  {String[]} families Array of Google font
         * families, e.g. <tt>["Just Another Hand:regular", "Roboto Condensed:700italic"]</tt>.
         *
         * @return {Promise} A promise that resolves when loading is complete.
         */
        google: function google(families) {
            Preconditions.checkArgument(families);

            families = this.filterOutAlreadyLoadedFonts(families);

            if (_.isEmpty(families)) {
                return Promise.resolved();
            }

            return load({
                google: {
                    families: families
                }
            });
        },


        /**
         * Loads the specified Fonts.com project(s).
         *
         * This class has a ViewerMixin for this method to load fonts from fonts.com directly instead of using Webfontloader
         *
         * @param {String|String[]} projectIds A Fonts.com project ID (a GUID) or an array of project IDs.
         * @param  {String[]} families Array of Fonts.com font
         * families, e.g. <tt>["Just Another Hand:regular", "Roboto Condensed:700italic"]</tt>.
         *
         * @return {Promise} A promise that resolves when all projects have been fetched.
         */
        fontsDotCom: function fontsDotCom(projectIds) {
            if (_.isString(projectIds)) {
                projectIds = [projectIds];
            }

            _.each(projectIds, function (projectId) {
                if (_.isEmpty(projectId)) {
                    Preconditions.fail("projectId is not defined.");
                }
            });

            var projectsIdsToLoad = this.filterOutAlreadyLoadedFonts(projectIds);

            if (_.isEmpty(projectsIdsToLoad)) {
                return Promise.resolved();
            }

            var project = function project(projectId) {
                return load({
                    monotype: {
                        loadAllFonts: true,
                        projectId: projectId
                    }
                });
            };

            var loadFontProjects = _.map(projectsIdsToLoad, function (projectId) {
                return project(projectId);
            });
            return Promise.all(loadFontProjects);
        }
    });

    return FontLoader;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25),
        _ = __webpack_require__(1),
        Permissions = __webpack_require__(22),
        Syncer = __webpack_require__(50),
        RestApi = __webpack_require__(29);

    // The color codes to use when coloring a background for this user
    var BackgroundColorCodes = ["#c6c6c6", "#ffff93", "#b0edff", "#ffb1b1", "#caed7f", "#ddcdb0", "#ffc4ff", "#a6c9f6", "#99eec4", "#dfbce9", "#eec699"];

    /**
     * @class {User}
     * The user model, an editor type only.
     */
    return ImprovedModel.extend("User", {

        defaults: {
            id: null,
            name: null,
            version: null,
            companyId: null,
            username: null,
            confirmedAt: null,
            lastUsedProperties: null,
            serialNumber: 0
        },

        computed: {
            role: {
                deps: ["role"],
                value: function value(role) {
                    return Permissions.Roles.of(role);
                }
            },
            displayName: {
                deps: ["name", "username"],
                value: function value(name, username) {
                    return name || username;
                }
            },
            backgroundColor: {
                deps: ["serialNumber"],
                value: function value(serialNumber) {
                    return BackgroundColorCodes[serialNumber % BackgroundColorCodes.length];
                }
            }
        },

        /**
         * @constructor
         */
        constructor: function constructor() {
            this.__super();

            // Updating a user does not require privileges, guarded by user identity...
            Syncer.State.init(this, {
                permissions: {
                    save: null, // only own user can edit herself
                    destroy: Permissions.Privileges.ADMIN
                }
            });
        },

        /**
         * Get the URL to the user model.
         *
         * @returns {String} The URL to the user model.
         */
        url: function url() {
            if (this.get("id")) {
                return RestApi.pathToSpecificResource(RestApi.Collections.USERS, this.get("id"));
            }
            return RestApi.API_URL + "/" + RestApi.Collections.USERS + "/create";
        },

        setLastUsedProperties: function setLastUsedProperties(type, properties) {
            var lastUsedProperties = this.get("lastUsedProperties") || {};
            lastUsedProperties[type] = _.extend(lastUsedProperties[type] || {}, properties);
            this.set("lastUsedProperties", lastUsedProperties);
        },

        getLastUsedProperties: function getLastUsedProperties(type) {
            var lastUsedProperties = this.get("lastUsedProperties");
            return lastUsedProperties ? lastUsedProperties[type] : null;
        },

        _distinguishedName: function _distinguishedName() {
            return this.get("displayName");
        },

        /**
         * Returns true if this user has confirmed her identity, false otherwise.
         *
         * @return {Boolean} True if confirmed, false otherwise.
         */
        isConfirmed: function isConfirmed() {
            return this.get("confirmedAt") !== null;
        }

    }, {
        BackgroundColorCodes: BackgroundColorCodes
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useTheme__ = __webpack_require__(1843);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useTheme__["a"]; });


/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {
      if (typeof func !== 'function') {
        console.error('Material-UI: Invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMuiElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](element) && muiNames.indexOf(element.type.muiName) !== -1;
}

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reflow; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionProps;
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconButton__ = __webpack_require__(1872);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IconButton__["a"]; });


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputBase__ = __webpack_require__(1921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputBase__["a"]; });


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formControlState;
function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(412);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(159);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectionState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(40);

var Record = Immutable.Record;


var defaultRecord = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};

var SelectionStateRecord = Record(defaultRecord);

var SelectionState = function (_SelectionStateRecord) {
  _inherits(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    _classCallCheck(this, SelectionState);

    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
  }

  SelectionState.prototype.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  SelectionState.prototype.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  SelectionState.prototype.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  SelectionState.prototype.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  };

  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */


  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionEnd && selectionStart <= end;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();

    return start <= offsetToCheck && end >= offsetToCheck;
  };

  SelectionState.prototype.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  SelectionState.prototype.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  SelectionState.prototype.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  SelectionState.prototype.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  SelectionState.prototype.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

module.exports = SelectionState;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }
  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

module.exports = cx;

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActionArea", function() { return ActionAreaComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AutoLinksForm", function() { return AutoLinksForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckBox", function() { return CheckBoxComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ColorPicker", function() { return ColorPickerComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreatableSelect", function() { return CreatableSelectComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return DividerComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DraggableColumnComponent", function() { return DraggableColumnComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return DropdownComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExternalLinkPropertiesForm", function() { return ExternalLinkPropertiesForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileUpload", function() { return FileUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return Image; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InternalLinkPropertiesForm", function() { return InternalLinkPropertiesForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinkPropertiesForm", function() { return LinkPropertiesForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Message", function() { return Message; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Navigation", function() { return NavigationComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Navigator", function() { return NavigatorComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumericInputComponent", function() { return NumericInputComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProductLinkPropertiesForm", function() { return ProductLinkPropertiesForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return RadioComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadioGroup", function() { return RadioGroupComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Slider", function() { return SliderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextArea", function() { return TextAreaComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Themes", function() { return themes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ToolsMenu", function() { return ToolsMenuComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toast_notifications__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_toast_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_toast_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_formik__ = __webpack_require__(2206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_core__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_emotion_theming__ = __webpack_require__(2277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_styled__ = __webpack_require__(2279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce__ = __webpack_require__(2282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isnumber__ = __webpack_require__(2283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isnumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isnumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_color__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_polished__ = __webpack_require__(2522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge__ = __webpack_require__(2527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_konva__ = __webpack_require__(2528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_konva___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_konva__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_chunk__ = __webpack_require__(2577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_select__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nanoid__ = __webpack_require__(2578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_nanoid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_nanoid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tippyjs_react__ = __webpack_require__(2579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_select_creatable__ = __webpack_require__(2628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_use_image__ = __webpack_require__(2629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_use_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_use_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_yup__ = __webpack_require__(2630);






















/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */
var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) {
            for (var p in b)
                if (b.hasOwnProperty(p))
                    d[p] = b[p];
        };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++)
        s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
}

var Toast = function (_a) {
    var title = _a.title, appearance = _a.appearance;
    var addToast = Object(__WEBPACK_IMPORTED_MODULE_1_react_toast_notifications__["useToasts"])().addToast;
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        addToast(title, { appearance: appearance });
    }, [title, appearance]);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null);
};
var Message = function (_a) {
    var _b = _a.placement, placement = _b === void 0 ? "bottom-right" : _b, _c = _a.autoDismiss, autoDismiss = _c === void 0 ? true : _c, _d = _a.title, title = _d === void 0 ? "Saved successfully" : _d, _e = _a.appearance, appearance = _e === void 0 ? "info" : _e;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_toast_notifications__["ToastProvider"], { placement: placement, children: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Toast, { title: title, appearance: appearance }), autoDismiss: autoDismiss }));
};
// We need to wrap component in `forwardRef` in order to gain
// access to the ref object that is assigned using the `ref` prop.
// This ref is passed as the second parameter to the function component.
var MessageEmitterComponent = function (props, ref) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null), message = _a[0], setMessage = _a[1];
    // The component instance will be extended
    // with whatever you return from the callback passed
    // as the second argument
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(ref, function () { return ({
        emitMessage: function (messageProps) {
            setMessage(messageProps ? messageProps : props);
        },
    }); });
    return message ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Message, __assign({}, message)) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null);
};
var MessageEmitter = Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(MessageEmitterComponent);

var styles = function (theme) { return ({
    horizontal: function () { return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\twidth: 100%;\n\t\theight: ", ";\n\t\tmargin: 4px 0;\n\t\tposition: relative;\n\t\t::before {\n\t\t\ttop: 50%;\n\t\t\twidth: 100%;\n\t\t\tborder-top: 1px solid #f0f0f0;\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t}\n\t"], ["\n\t\twidth: 100%;\n\t\theight: ", ";\n\t\tmargin: 4px 0;\n\t\tposition: relative;\n\t\t::before {\n\t\t\ttop: 50%;\n\t\t\twidth: 100%;\n\t\t\tborder-top: 1px solid #f0f0f0;\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t}\n\t"])), theme.spacing.sm); },
    vertical: function () { return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\twidth: 24px;\n\t\tmin-height: 24px;\n\t\theight: 100%;\n\t\tmargin: 0 4px;\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\t::before {\n\t\t\tleft: 50%;\n\t\t\theight: 100%;\n\t\t\tborder-right: 1px solid #f0f0f0;\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t}\n\t"], ["\n\t\twidth: 24px;\n\t\tmin-height: 24px;\n\t\theight: 100%;\n\t\tmargin: 0 4px;\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t\t::before {\n\t\t\tleft: 50%;\n\t\t\theight: 100%;\n\t\t\tborder-right: 1px solid #f0f0f0;\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t}\n\t"]))); },
}); };
var templateObject_1, templateObject_2;

/** @jsx jsx */
var DividerDirection;
(function (DividerDirection) {
    DividerDirection["HORIZONTAL"] = "horizontal";
    DividerDirection["VERTICAL"] = "vertical";
})(DividerDirection || (DividerDirection = {}));
var DividerComponent = function (props) {
    var direction = props.direction;
    var theme = Object(__WEBPACK_IMPORTED_MODULE_4_emotion_theming__["a" /* useTheme */])();
    var style = styles(theme);
    return (Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("div", { css: [
            direction === DividerDirection.VERTICAL
                ? style.vertical()
                : style.horizontal(),
        ] }));
};

var Target;
(function (Target) {
    Target["NewWindowOrTab"] = "_blank";
    Target["CurrentOrTab"] = "_self";
    Target["ParentFrame"] = "_parent";
    Target["Lightbox"] = "_ZMAGS_LIGHTBOX";
    Target["Custom"] = "-1";
})(Target || (Target = {}));

var FieldWrapper = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n\tpadding: 4px;\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tflex: 1 1 auto;\n"], ["\n\tpadding: 4px;\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\tjustify-content: flex-start;\n\talign-items: center;\n\tflex: 1 1 auto;\n"])));
var Field = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n\tflex: 1 1 auto;\n\t&&& > *,\n\t&&& input[type=\"text\"] {\n\t\twidth: 100%;\n\t\tbox-sizing: border-box;\n\t}\n\t&&& > input[type=\"checkbox\"] {\n\t\twidth: auto;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tvertical-align: middle;\n\t}\n"], ["\n\tflex: 1 1 auto;\n\t&&& > *,\n\t&&& input[type=\"text\"] {\n\t\twidth: 100%;\n\t\tbox-sizing: border-box;\n\t}\n\t&&& > input[type=\"checkbox\"] {\n\t\twidth: auto;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tvertical-align: middle;\n\t}\n"])));
var Group = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: space-between;\n\talign-items: center;\n\t&&& > * {\n\t\tflex: 1 1 auto;\n\t}\n"], ["\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: space-between;\n\talign-items: center;\n\t&&& > * {\n\t\tflex: 1 1 auto;\n\t}\n"])));
var LabelH1 = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].label(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\ttext-align: right;\n\tmargin-right: 6px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfont-size: 18px;\n\tfont-weight: bold;\n"], ["\n\ttext-align: right;\n\tmargin-right: 6px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfont-size: 18px;\n\tfont-weight: bold;\n"])));
var Label = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].label(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tflex: 0 0 124px;\n\ttext-align: right;\n\ttext-align: right;\n\tmargin-right: 6px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfont-size: 14px;\n"], ["\n\tflex: 0 0 124px;\n\ttext-align: right;\n\ttext-align: right;\n\tmargin-right: 6px;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfont-size: 14px;\n"])));
var templateObject_1$1, templateObject_2$1, templateObject_3, templateObject_4, templateObject_5;

var Constants = {
    NUMBER_REGEX: new RegExp(/^(-?\d+\.?\d?)/g),
    POSITIVE_NUMBER_REGEX: new RegExp(/^(\d+\.?\d?)/g),
    KEY_UP: 38,
    KEY_DOWN: 40,
};

var InputType;
(function (InputType) {
    InputType["TEXT"] = "text";
})(InputType || (InputType = {}));
var NumericInputComponent = /** @class */ (function (_super) {
    __extends(NumericInputComponent, _super);
    function NumericInputComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.stringify = function (value) { return String(value); };
        _this.isEmpty = function (value) { return value.length === 0; };
        _this.endsWithDot = function (value) { return value.endsWith("."); };
        _this.isMinus = function (value) { return value === "-"; };
        _this.getNumberValue = function (value) {
            var numberMatch = value.match(Constants.NUMBER_REGEX);
            return numberMatch ? numberMatch[0] : "";
        };
        _this.getCorrectValue = function (value) {
            var _a = _this.props, min = _a.min, max = _a.max;
            if (__WEBPACK_IMPORTED_MODULE_7_lodash_isnumber___default()(min) && value < min) {
                return min;
            }
            if (__WEBPACK_IMPORTED_MODULE_7_lodash_isnumber___default()(max) && value > max) {
                return max;
            }
            return value;
        };
        _this.isValidValue = function (value) {
            var numberValue = Number(value);
            var _a = _this.props, min = _a.min, max = _a.max;
            var isValidMin = !__WEBPACK_IMPORTED_MODULE_7_lodash_isnumber___default()(min) || numberValue >= min;
            var isValidMax = !__WEBPACK_IMPORTED_MODULE_7_lodash_isnumber___default()(max) || numberValue <= max;
            return isValidMin && isValidMax;
        };
        _this.saveChanges = function (data) {
            _this.props.onChange(Number(data));
            _this.setState({ isDebounced: false });
        };
        _this.setCorrectValue = function (data) {
            var _a = _this.props, value = _a.value, defaultValue = _a.defaultValue;
            if (_this.isEmpty(data) || _this.endsWithDot(data) || _this.isMinus(data)) {
                var numberValue = _this.getNumberValue(_this.stringify(value || defaultValue));
                _this.setState({ internalValue: numberValue });
            }
            else if (!_this.isValidValue(data)) {
                var correctValue = _this.stringify(_this.getCorrectValue(Number(data)));
                _this.setState({ internalValue: correctValue });
                _this.saveChanges(correctValue);
            }
        };
        _this.handleChange = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var value = e.target.value;
            _this.updateValueState(value);
        };
        _this.updateValueState = function (value) {
            var numberMatch = value.match(Constants.NUMBER_REGEX);
            var isMinus = _this.isMinus(value);
            var numberValue = numberMatch ? numberMatch[0] : "";
            if (!numberValue && isMinus) {
                numberValue = value;
            }
            _this.setState({ internalValue: numberValue, isDebounced: true });
            if (!_this.isEmpty(numberValue) &&
                !_this.endsWithDot(numberValue) &&
                !isMinus) {
                if (_this.isValidValue(numberValue)) {
                    _this.debouncedUpdate.cancel();
                    _this.setState({ isDebounced: false });
                    _this.saveChanges(numberValue);
                }
                else {
                    _this.debouncedUpdate(numberValue);
                }
            }
        };
        _this.onKeyDown = function (e) {
            var keyCode = e.keyCode;
            var isKeyUp = keyCode === Constants.KEY_UP;
            var isKeyDown = keyCode === Constants.KEY_DOWN;
            if (isKeyUp || isKeyDown) {
                // have to call this method to avoid moving caret in the input
                e.preventDefault();
                var step = _this.props.step;
                var internalValue = _this.state.internalValue;
                var internalNumberValue = Number(internalValue);
                if (isKeyDown) {
                    _this.updateValueState(_this.stringify(internalNumberValue - step));
                }
                if (isKeyUp) {
                    _this.updateValueState(_this.stringify(internalNumberValue + step));
                }
            }
        };
        _this.onBlur = function () {
            var internalValue = _this.state.internalValue;
            if (_this.isEmpty(internalValue) ||
                _this.endsWithDot(internalValue) ||
                _this.isMinus(internalValue)) {
                _this.debouncedUpdate(internalValue);
            }
        };
        var _a = _this.props, value = _a.value, defaultValue = _a.defaultValue, debounceDelay = _a.debounceDelay;
        _this.state = {
            // we have to extract number value from props, because sometimes component receives it in format "32px"
            internalValue: _this.getNumberValue(_this.stringify(value || defaultValue)),
            isDebounced: false,
        };
        _this.saveChanges = __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(_this.saveChanges, debounceDelay);
        // you can't use this.debouncedUpdate = debounce(this.debouncedUpdate, ...),
        // because it leads to TS error if you want to this.debouncedUpdate.cancel()
        _this.debouncedUpdate = __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(_this.setCorrectValue, debounceDelay);
        return _this;
    }
    NumericInputComponent.prototype.componentWillUnmount = function () {
        this.debouncedUpdate.cancel();
    };
    NumericInputComponent.prototype.componentDidUpdate = function (prevProps) {
        var prevNumberValue = this.getNumberValue(this.stringify(prevProps.value));
        var currentNumberValue = this.getNumberValue(this.stringify(this.props.value));
        if (!this.state.isDebounced &&
            prevNumberValue !== currentNumberValue &&
            currentNumberValue !== this.state.internalValue) {
            this.setState({ internalValue: currentNumberValue });
        }
    };
    NumericInputComponent.prototype.render = function () {
        var _a = this.props, label = _a.label, units = _a.units, classNames = _a.classNames, disabled = _a.disabled, wrapperClassNames = _a.wrapperClassNames, title = _a.title;
        var internalValue = this.state.internalValue;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { "data-unit": units, className: wrapperClassNames, title: title },
            label,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { 
                // we can't use input type="number" here,
                // because each browser provides us with different values on dot typing
                type: InputType.TEXT, className: classNames, disabled: disabled, value: internalValue, onChange: this.handleChange, onKeyDown: this.onKeyDown, onBlur: this.onBlur })));
    };
    NumericInputComponent.defaultProps = {
        disabled: false,
        defaultValue: 0,
        debounceDelay: 0,
        step: 1,
        classNames: "",
        wrapperClassNames: "",
    };
    return NumericInputComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]));

var isEqual = function (props, name, expected) { return props.values[name] === expected; };

var Form = function (props) {
    var target = props.target, values = props.values, setTarget = props.setTarget, setLightBox = props.setLightBox, setLightBoxWidth = props.setLightBoxWidth, setLightBoxHeight = props.setLightBoxHeight;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(values.target), targetAttr = _a[0], setTargetAttr = _a[1];
    // Update lightbox based on current target selected
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var isLightBox = isEqual(props, "target", Target.Lightbox);
        setLightBox(isLightBox);
        if (!isLightBox) {
            setLightBoxWidth(0);
            setLightBoxHeight(0);
        }
    }, [values.target]);
    // Update target based on selected
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setTarget(targetAttr !== Target.Custom ? targetAttr : "_blank");
    }, [targetAttr]);
    var handleTargetAttrChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        return setTargetAttr(event.currentTarget.options[event.currentTarget.selectedIndex].value);
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, null, "Open link in"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { as: "select", options: target, disabled: false, value: targetAttr, onChange: handleTargetAttrChange }, target.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); })))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "target", value: values.target, type: "text", disabled: targetAttr !== Target.Custom })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "target" }))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "lightBoxWidth" }, "Lightbox width"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "lightBoxWidth", value: values.lightBoxWidth, as: NumericInputComponent, min: 0, disabled: !isEqual(props, "target", Target.Lightbox), onChange: setLightBoxWidth })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "lightBoxWidth" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "lightBoxHeight" }, "Lightbox height"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "lightBoxHeight", value: values.lightBoxHeight, as: NumericInputComponent, min: 0, disabled: !isEqual(props, "target", Target.Lightbox), onChange: setLightBoxHeight })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "lightBoxHeight" })))));
};

var withDebounceChange = function (WrappedComponent) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(DebounceChangeComponent, _super);
            function DebounceChangeComponent(props) {
                var _this = _super.call(this, props) || this;
                _this.handleChange = function (event) {
                    var onChange = _this.props.onChange;
                    if (onChange) {
                        event.persist();
                        _this.debouncedChangeHandler(event);
                    }
                };
                var _a = _this.props, onChange = _a.onChange, onChangeWait = _a.onChangeWait, onChangeMaxWait = _a.onChangeMaxWait;
                var debounceOptions = __assign({}, (onChangeMaxWait && {
                    maxWait: onChangeMaxWait,
                }));
                if (onChange) {
                    _this.debouncedChangeHandler = __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(onChange, onChangeWait, debounceOptions);
                }
                return _this;
            }
            DebounceChangeComponent.prototype.componentWillUnmount = function () {
                if (this.debouncedChangeHandler) {
                    this.debouncedChangeHandler.flush();
                }
            };
            DebounceChangeComponent.prototype.render = function () {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WrappedComponent, __assign({}, this.props, { onChange: this.handleChange }));
            };
            return DebounceChangeComponent;
        }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)),
        _a.displayName = "debounced(" + WrappedComponent.displayName + ")",
        /*
            Due to an issue with required props, defaultProps, and typing a component that implement this HoC will have its
            optional defaultProps be marked as required. I haven't been able to find a clean and generic approach that will
            solve this issue for us. When using this component we must be aware that all props will be required regardless of
            defaultProps. It may make sense in the future to use functional components and hooks in place of an HoC.
         */
        _a.defaultProps = __assign(__assign({}, (WrappedComponent.defaultProps || {})), { onChangeWait: 200, onChangeMaxWait: 500 }),
        _a;
};

var SliderComponent = /** @class */ (function (_super) {
    __extends(SliderComponent, _super);
    function SliderComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            var valueStr = event.target.value;
            var value = Number(valueStr);
            _this.setState({ value: value });
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(event);
            }
        };
        var value = props.value;
        _this.state = {
            value: value,
        };
        return _this;
    }
    SliderComponent.prototype.componentDidUpdate = function (prevProps) {
        var value = this.props.value;
        if (prevProps.value !== value) {
            this.setState({ value: value });
        }
    };
    SliderComponent.prototype.render = function () {
        var _a = this.props, id = _a.id, name = _a.name, min = _a.min, max = _a.max, step = _a.step, disabled = _a.disabled, formatValueOutput = _a.formatValueOutput, showValueOutput = _a.showValueOutput, label = _a.label;
        var value = this.state.value;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", null,
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("label", { htmlFor: id },
                label && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null, label),
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("input", { type: "range", id: id, name: name, min: min, max: max, step: step, value: value, disabled: disabled, onChange: disabled ? null : this.handleChange }),
                showValueOutput && (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("output", { htmlFor: id }, formatValueOutput ? formatValueOutput(value) : value)))));
    };
    SliderComponent.defaultProps = {
        id: "",
        name: "",
        value: 0,
        min: 0,
        max: 100,
        step: 1,
        disabled: false,
        showValueOutput: true,
        label: "",
    };
    return SliderComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));
var Slider = withDebounceChange(SliderComponent);

var styles$1 = {
    swatch: {
        width: "24px",
        height: "16px",
        padding: "2px",
        background: "#fff",
        borderColor: "#d3d3d3",
        borderStyle: "solid",
        borderWidth: "1px",
        cursor: "pointer",
        marginBottom: "2px",
    },
    color: {
        width: "100%",
        height: "100%",
    },
    popover: {
        position: "absolute",
    },
    cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
    },
};
var ColorPickerComponent = /** @class */ (function (_super) {
    __extends(ColorPickerComponent, _super);
    function ColorPickerComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChangeComplete = function (color) {
            var hex = color.hex;
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(hex);
            }
        };
        _this.handleChange = function (color) {
            var hex = color.hex;
            _this.setState({ color: hex });
        };
        _this.togglePicker = function () {
            var displayColorPicker = _this.state.displayColorPicker;
            _this.setState({ displayColorPicker: !displayColorPicker });
        };
        _this.closePicker = function () {
            var color = _this.props.color;
            _this.setState({ displayColorPicker: false, color: color });
        };
        var color = props.color;
        _this.state = {
            color: color,
            displayColorPicker: false,
        };
        return _this;
    }
    ColorPickerComponent.prototype.componentDidUpdate = function (prevProps) {
        var color = this.props.color;
        if (prevProps.color !== color) {
            this.setState({ color: color });
        }
    };
    ColorPickerComponent.prototype.render = function () {
        var _a = this.props, presetColors = _a.presetColors, disableAlpha = _a.disableAlpha;
        var _b = this.state, color = _b.color, displayColorPicker = _b.displayColorPicker;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles$1.swatch, onClick: this.togglePicker },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: __assign(__assign({}, styles$1.color), { background: color }) })),
            displayColorPicker && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles$1.popover },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: styles$1.cover, onClick: this.closePicker }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_color__["SketchPicker"], { color: color, presetColors: presetColors, disableAlpha: disableAlpha, onChange: this.handleChange, onChangeComplete: this.handleChangeComplete })))));
    };
    ColorPickerComponent.defaultProps = {
        color: "",
        presetColors: [],
        disableAlpha: false,
    };
    return ColorPickerComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var RadioComponent = /** @class */ (function (_super) {
    __extends(RadioComponent, _super);
    function RadioComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            var checked = event.target.checked;
            _this.setState({ checked: checked });
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(event);
            }
        };
        var checked = props.checked;
        _this.state = {
            checked: checked,
        };
        return _this;
    }
    RadioComponent.prototype.componentDidUpdate = function (prevProps) {
        var checked = this.props.checked;
        if (prevProps.checked !== checked) {
            this.setState({ checked: checked });
        }
    };
    RadioComponent.prototype.render = function () {
        var _a = this.props, id = _a.id, disabled = _a.disabled, label = _a.label, name = _a.name, value = _a.value;
        var checked = this.state.checked;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("label", { htmlFor: id },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("input", { id: id, type: "radio", checked: checked, onChange: disabled ? null : this.handleChange, disabled: disabled, name: name, value: value }),
            label && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null, label)));
    };
    RadioComponent.defaultProps = {
        id: "",
        checked: false,
        disabled: false,
        label: "",
        name: "",
        value: "",
    };
    return RadioComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

/**
 * To render items for radio group use this placeholder.
 * Radio group renders Radio for each placeholder with name, checked state based on current value of the Radio group.
 */
var RadioGroupItemComponent = function () { return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)); };
var RadioGroupComponent = /** @class */ (function (_super) {
    __extends(RadioGroupComponent, _super);
    function RadioGroupComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            var _a = event.target, checked = _a.checked, value = _a.value;
            if (checked) {
                _this.setState({ value: value });
            }
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(event);
            }
        };
        var value = props.value;
        _this.state = {
            value: value,
        };
        return _this;
    }
    RadioGroupComponent.prototype.componentDidUpdate = function (prevProps) {
        var value = this.props.value;
        if (prevProps.value !== value) {
            this.setState({ value: value });
        }
    };
    RadioGroupComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, name = _a.name;
        var value = this.state.value;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (radio) {
            if (!radio || radio.type !== RadioGroupItemComponent) {
                return null;
            }
            var props = radio.props;
            var radioValue = props.value;
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(RadioComponent, __assign({}, props, { name: name, checked: value === radioValue, onChange: _this.handleChange })));
        })));
    };
    RadioGroupComponent.Radio = RadioGroupItemComponent;
    return RadioGroupComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var getColorDependsOnType = function (_a) {
    var theme = _a.theme, feedback = _a.feedback, disabled = _a.disabled, _b = _a.type, type = _b === void 0 ? "primary" : _b;
    var color = theme.colors[type].medium;
    var hoverColor = theme.colors[type].light;
    if (disabled) {
        color = theme.colors.disabled.light;
        hoverColor = theme.colors.disabled.light;
    }
    else if (feedback) {
        color = theme.colors.feedback[feedback];
        hoverColor = Object(__WEBPACK_IMPORTED_MODULE_9_polished__["b" /* lighten */])(0.1, theme.colors.feedback[feedback]);
    }
    return {
        color: color,
        hoverColor: hoverColor,
    };
};
var getDefaultButtonStyles = function (theme, feedback, disabled) {
    var _a = getColorDependsOnType({
        theme: theme,
        feedback: feedback,
        disabled: disabled,
    }), color = _a.color, hoverColor = _a.hoverColor;
    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n\t\tcolor: ", ";\n\t\tbackground: ", ";\n\t\tborder: 1px solid ", ";\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t"], ["\n\t\tcolor: ", ";\n\t\tbackground: ", ";\n\t\tborder: 1px solid ", ";\n\t\t&:hover {\n\t\t\tborder-color: ", ";\n\t\t\tcolor: ", ";\n\t\t}\n\t"])), color, theme.colors.bg.primary, color, hoverColor, hoverColor);
};
var getCircleSize = function (size) {
    var val;
    switch (size) {
        case "small":
            val = "40px";
            break;
        case "middle":
            val = "50px";
            break;
        case "large":
            val = "70px";
            break;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n\t\theight: ", ";\n\t\twidth: ", ";\n\t"], ["\n\t\theight: ", ";\n\t\twidth: ", ";\n\t"])), val, val);
};
var styles$2 = function (theme) {
    return {
        commonStyles: function () { return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n\t\t\toutline: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: transparent;\n\t\t\tborder: none;\n\t\t\tpadding: 0;\n\t\t\tcursor: pointer;\n\t\t\tborder-radius: 5px;\n\t\t"], ["\n\t\t\toutline: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tbackground: transparent;\n\t\t\tborder: none;\n\t\t\tpadding: 0;\n\t\t\tcursor: pointer;\n\t\t\tborder-radius: 5px;\n\t\t"]))); },
        sizeStyles: function (size) {
            switch (size) {
                case "small":
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n\t\t\t\t\t\tfont-size: ", ";\n\t\t\t\t\t\tpadding: ", " ", ";\n\t\t\t\t\t"], ["\n\t\t\t\t\t\tfont-size: ", ";\n\t\t\t\t\t\tpadding: ", " ", ";\n\t\t\t\t\t"])), theme.typography.size.sm, theme.spacing.xs, theme.spacing.xs);
                case "middle":
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n\t\t\t\t\t\tfont-size: ", ";\n\t\t\t\t\t\tpadding: ", " ", ";\n\t\t\t\t\t"], ["\n\t\t\t\t\t\tfont-size: ", ";\n\t\t\t\t\t\tpadding: ", " ", ";\n\t\t\t\t\t"])), theme.typography.size.lg, theme.spacing.sm, theme.spacing.sm);
                case "large":
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\t\t\t\t\t\tfont-size: ", ";\n\t\t\t\t\t\tpadding: ", " ", ";\n\t\t\t\t\t"], ["\n\t\t\t\t\t\tfont-size: ", ";\n\t\t\t\t\t\tpadding: ", " ", ";\n\t\t\t\t\t"])), theme.typography.size.xl, theme.spacing.md, theme.spacing.md);
                default:
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_7 || (templateObject_7 = __makeTemplateObject([""], [""])));
            }
        },
        typeStyles: function (type, feedback, isButtonDisabled) {
            var _a = getColorDependsOnType({
                theme: theme,
                feedback: feedback,
                disabled: isButtonDisabled,
                type: "primary",
            }), color = _a.color, hoverColor = _a.hoverColor;
            var _b = getColorDependsOnType({
                theme: theme,
                feedback: feedback,
                disabled: isButtonDisabled,
                type: "secondary",
            }), secondaryColor = _b.color, secondaryHoverColor = _b.hoverColor;
            switch (type) {
                case "primary":
                    return [
                        Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t"], ["\n\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t"])), theme.colors.text, color, hoverColor),
                    ];
                case "secondary":
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t}\n\t\t\t\t\t"], ["\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\t}\n\t\t\t\t\t"])), theme.colors.text, secondaryColor, secondaryHoverColor);
                case "default":
                    return getDefaultButtonStyles(theme, feedback, isButtonDisabled);
                case "dashed":
                    return [
                        getDefaultButtonStyles(theme, feedback, isButtonDisabled),
                        Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\t\t\t\t\t\t\tborder-style: dashed;\n\t\t\t\t\t\t"], ["\n\t\t\t\t\t\t\tborder-style: dashed;\n\t\t\t\t\t\t"]))),
                    ];
                case "link":
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t}\n\t\t\t\t\t"], ["\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\t}\n\t\t\t\t\t"])), theme.colors.link.default, theme.colors.link.hover);
                case "transparent":
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t"], ["\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tbackground: none;\n\t\t\t\t\t"])));
                default:
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""])));
            }
        },
        shapeStyles: function (shape, size) {
            switch (shape) {
                case "circle":
                    return [
                        getCircleSize(size),
                        Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t"], ["\n\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\toverflow: hidden;\n\t\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\t"]))),
                    ];
                case "sharp":
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t"], ["\n\t\t\t\t\t\tborder-radius: 0;\n\t\t\t\t\t"])));
                default:
                    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_16 || (templateObject_16 = __makeTemplateObject([""], [""])));
            }
        },
        iconStyles: function () { return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n\t\t\tspan {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t\tspan + span {\n\t\t\t\tmargin-left: ", ";\n\t\t\t}\n\t\t"], ["\n\t\t\tspan {\n\t\t\t\tdisplay: flex;\n\t\t\t}\n\t\t\tspan + span {\n\t\t\t\tmargin-left: ", ";\n\t\t\t}\n\t\t"])), theme.spacing.xs); },
    };
};
var templateObject_1$2, templateObject_2$2, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;

/*
Ideally we would use https://emotion.sh/docs/@emotion/babel-preset-css-prop to replace the JSX pragma requirement. The
issue is that ts-loader processes this file before it reaches babel. To get ts-loader to play nice we need to change the
tsconfig value "jsx" from "react" to "preserve" https://github.com/emotion-js/emotion/issues/1748. But this change
appears to blow up something in our stack. I believe this may be caused by react-docgen-typescript-loader, but I haven't
looked farther into it.
 */
var Button = function (_a) {
    var label = _a.label, _b = _a.size, size = _b === void 0 ? "middle" : _b, _c = _a.type, type = _c === void 0 ? "primary" : _c, feedback = _a.feedback, shape = _a.shape, disabled = _a.disabled, icon = _a.icon, onClick = _a.onClick;
    var theme = Object(__WEBPACK_IMPORTED_MODULE_4_emotion_theming__["a" /* useTheme */])();
    var _d = styles$2(theme), commonStyles = _d.commonStyles, sizeStyles = _d.sizeStyles, typeStyles = _d.typeStyles, shapeStyles = _d.shapeStyles, iconStyles = _d.iconStyles;
    var isButtonDisabled = disabled;
    return (Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("button", { css: [
            commonStyles(),
            sizeStyles(size),
            typeStyles(type, feedback, isButtonDisabled),
            shapeStyles(shape, size),
            icon ? iconStyles() : null,
        ], disabled: isButtonDisabled, onClick: onClick },
        icon && Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("span", null, icon),
        label && (shape !== "circle" || !icon) && Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("span", null, label)));
};

var FormPanel = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n\tflex: 0 0 520px;\n\tpadding: 10px;\n\tbox-sizing: border-box;\n"], ["\n\tflex: 0 0 520px;\n\tpadding: 10px;\n\tbox-sizing: border-box;\n"])));
var Form$1 = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n\tdisplay: inline-flex;\n\tflex-flow: column nowrap;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n"], ["\n\tdisplay: inline-flex;\n\tflex-flow: column nowrap;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n"])));
var Group$1 = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n\tdisplay: inline-flex;\n\tflex-flow: row nowrap;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\theight: 520px;\n"], ["\n\tdisplay: inline-flex;\n\tflex-flow: row nowrap;\n\tjustify-content: flex-start;\n\talign-items: flex-start;\n\theight: 520px;\n"])));
var Footer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: flex-end;\n\talign-items: center;\n"], ["\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\tjustify-content: flex-end;\n\talign-items: center;\n"])));
var templateObject_1$3, templateObject_2$3, templateObject_3$2, templateObject_4$2;

var Form$2 = function (props) {
    var _a;
    var options = props.options, currentPage = props.currentPage, values = props.values, setFieldValue = props.setFieldValue, submitForm = props.submitForm;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), thisPageOnly = _b[0], setThisPageOnly = _b[1];
    var maxPage = options.pages.length;
    // Update select field value
    var handleSelectChange = function (name) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
            return setFieldValue(name, Number(event.currentTarget.options[event.currentTarget.selectedIndex].value));
        }, []);
    };
    // Update number field value since onchange receive number, not event
    var handleNumberChange = function (name) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (value) { return setFieldValue(name, value); }, []);
    };
    function handleThisPageOnlyChange(event) {
        var checked = event.target.checked;
        setThisPageOnly(checked);
    }
    function handleProductSourceChange(event) {
        var value = event.target.value;
        setFieldValue("productSource", Number(value));
    }
    function handleChangeColor(color) {
        setFieldValue("colour", color.replace("#", ""));
    }
    function setTarget(value) {
        setFieldValue("linkTarget", value);
    }
    function setLightBox(value) {
        setFieldValue("isLightbox", value);
    }
    function setLightBoxWidth(value) {
        setFieldValue("lightBoxWidth", value);
    }
    function setLightBoxHeight(value) {
        setFieldValue("lightBoxHeight", value);
    }
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setFieldValue("pageFrom", currentPage);
        setFieldValue("pageTo", currentPage);
    }, [thisPageOnly]);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["c" /* Form */], null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Form$1, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group$1, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormPanel, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelH1, null, "External Links"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "specific" }, "Search for"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "specific", type: "text", disabled: false })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "specific" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "specificURL" }, "Specific URL"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "specificURL", type: "url", placeholder: "" })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "specificURL" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Form, { target: options.target, values: {
                            target: values.linkTarget,
                            lightBox: values.isLightbox,
                            lightBoxWidth: values.lightBoxWidth,
                            lightBoxHeight: values.lightBoxHeight,
                        }, setTarget: setTarget, setLightBox: setLightBox, setLightBoxWidth: setLightBoxWidth, setLightBoxHeight: setLightBoxHeight }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "pdfLinks" }, "Include PDF Links"),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "pdfLinks", type: "checkbox", disabled: false })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "pdfLinks" })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "webLinks" }, "Search for web links"),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "webLinks", type: "checkbox", disabled: false })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "webLinks" })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "emailLinks" }, "Search for e-mails"),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "emailLinks", type: "checkbox", disabled: false })),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "emailLinks" }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DividerComponent, { direction: DividerDirection.HORIZONTAL }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelH1, null, "External Links (Advanced)"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "regex" }, "Regular expression"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "regex", type: "text", disabled: false })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "regex" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "regexLink" }, "Link"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "regexLink", type: "url", placeholder: "" })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "regexLink" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DividerComponent, { direction: DividerDirection.HORIZONTAL }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelH1, null, "Internal Links"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "internalRegex" }, "Regular expression"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "internalRegex", type: "text", disabled: false })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "internalRegex" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "internalRegexPage" }, "Target page"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { as: "select", options: options.pages, disabled: false, value: values.internalRegexPage, onChange: handleSelectChange("internalRegexPage") }, options.pages.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "internalRegexPage" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DividerComponent, { direction: DividerDirection.HORIZONTAL }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelH1, null, "Product Links"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "productRegex" }, "Regular expression"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "productRegex", type: "text", disabled: false })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "productRegex" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, null, "Product source"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RadioGroupComponent, { name: "productSource", value: (_a = values.productSource) === null || _a === void 0 ? void 0 : _a.toString(), onChange: handleProductSourceChange },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RadioGroupComponent.Radio, { id: "2", key: "2", value: "2", label: "External", disabled: false }),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RadioGroupComponent.Radio, { id: "1", key: "1", value: "1", label: "Product database", disabled: false })))),
                    values.productSource === 1 && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "allowInvalidProductSKU" }, "Create links for missing products"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "allowInvalidProductSKU", type: "checkbox", disabled: false })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "allowInvalidProductSKU" })))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DividerComponent, { direction: DividerDirection.VERTICAL }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FormPanel, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelH1, null, "Appearance"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "tooltipExternal" }, "External tooltip"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "tooltipExternal", type: "text", disabled: false })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "tooltipExternal" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "tooltipInternal" }, "Internal tooltip"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "tooltipInternal", type: "text", disabled: false })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "tooltipInternal" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "tooltipMail" }, "E-mail tooltip"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "tooltipMail", type: "text", disabled: false })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "tooltipMail" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "tooltipProduct" }, "Product link tooltip"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "tooltipProduct", type: "text", disabled: false })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "tooltipProduct" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "effect" }, "Effect"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "effect", as: "select", disabled: false, onChange: handleSelectChange("effect") }, options.effect.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "effect" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "transparency" }, "Opacity"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "transparency", as: Slider, disabled: false, min: 0, max: 100, step: 1 })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "transparency" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "colour" }, " Link color"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorPickerComponent, { color: "#" + values.colour, disableAlpha: false, presetColors: [], onChange: handleChangeColor })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "colour" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DividerComponent, { direction: DividerDirection.HORIZONTAL }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelH1, null, "Page range (default: All pages)"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, null, "This page only"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "checkbox", checked: thisPageOnly, onChange: handleThisPageOnlyChange }))),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, null, "Pages"),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { as: NumericInputComponent, disabled: thisPageOnly, min: 1, max: maxPage - 1, value: values.fromPage, name: "fromPage", onChange: handleNumberChange("fromPage") }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "fromPage" }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { as: NumericInputComponent, disabled: thisPageOnly, min: 1, max: maxPage, value: values.toPage, name: "toPage", onChange: handleNumberChange("toPage") }),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "toPage" }))))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, { type: "primary", label: "Import links", onClick: submitForm })))));
};

var AutoLinksForm = function (props) {
    var initialValues = props.initialValues, values = props.values, currentPage = props.currentPage, options = props.options, onSubmit = props.onSubmit;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["d" /* Formik */], { initialValues: initialValues, onSubmit: onSubmit }, function (formProps) {
        var initialErrors = formProps.initialErrors, initialTouched = formProps.initialTouched, formValues = formProps.values, errors = formProps.errors, touched = formProps.touched, dirty = formProps.dirty, isValid = formProps.isValid, isSubmitting = formProps.isSubmitting, isValidating = formProps.isValidating, submitCount = formProps.submitCount, setValues = formProps.setValues, setFieldValue = formProps.setFieldValue, setStatus = formProps.setStatus, setErrors = formProps.setErrors, setSubmitting = formProps.setSubmitting, setTouched = formProps.setTouched, setFieldError = formProps.setFieldError, setFieldTouched = formProps.setFieldTouched, validateField = formProps.validateField, validateForm = formProps.validateForm, resetForm = formProps.resetForm, submitForm = formProps.submitForm, setFormikState = formProps.setFormikState, handleBlur = formProps.handleBlur, handleChange = formProps.handleChange, handleReset = formProps.handleReset, handleSubmit = formProps.handleSubmit, getFieldProps = formProps.getFieldProps, getFieldHelpers = formProps.getFieldHelpers, getFieldMeta = formProps.getFieldMeta, registerField = formProps.registerField, unregisterField = formProps.unregisterField;
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
            if (values) {
                setValues(values, false);
            }
        }, [values]);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Form$2, { currentPage: currentPage, options: options, initialValues: initialValues, initialErrors: initialErrors, initialTouched: initialTouched, values: formValues, errors: errors, touched: touched, dirty: dirty, isValid: isValid, isSubmitting: isSubmitting, isValidating: isValidating, submitCount: submitCount, setFieldValue: setFieldValue, setValues: setValues, setStatus: setStatus, setErrors: setErrors, setSubmitting: setSubmitting, setTouched: setTouched, setFieldError: setFieldError, setFieldTouched: setFieldTouched, validateField: validateField, validateForm: validateForm, resetForm: resetForm, submitForm: submitForm, setFormikState: setFormikState, handleBlur: handleBlur, handleChange: handleChange, handleReset: handleReset, handleSubmit: handleSubmit, getFieldProps: getFieldProps, getFieldHelpers: getFieldHelpers, getFieldMeta: getFieldMeta, registerField: registerField, unregisterField: unregisterField }));
    }));
};

var I = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].span(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n\t@font-face {\n\t\tfont-family: \"Material Icons\";\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tsrc: url(https://fonts.gstatic.com/s/materialicons/v53/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2)\n\t\t\tformat(\"woff2\");\n\t}\n\tfont-family: \"Material Icons\";\n\tfont-weight: normal;\n\tfont-style: normal;\n\tline-height: 1;\n\tletter-spacing: normal;\n\ttext-transform: none;\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\tword-wrap: normal;\n\tdirection: ltr;\n\t-webkit-font-feature-settings: \"liga\";\n\t-webkit-font-smoothing: antialiased;\n"], ["\n\t@font-face {\n\t\tfont-family: \"Material Icons\";\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tsrc: url(https://fonts.gstatic.com/s/materialicons/v53/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2)\n\t\t\tformat(\"woff2\");\n\t}\n\tfont-family: \"Material Icons\";\n\tfont-weight: normal;\n\tfont-style: normal;\n\tline-height: 1;\n\tletter-spacing: normal;\n\ttext-transform: none;\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\tword-wrap: normal;\n\tdirection: ltr;\n\t-webkit-font-feature-settings: \"liga\";\n\t-webkit-font-smoothing: antialiased;\n"])));
var templateObject_1$4;

var Icon = function (_a) {
    var name = _a.name, style = _a.style;
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(I, { style: style }, name);
};

var UploadContainer = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n\tdisplay: inline-flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tpadding: 4px;\n\tposition: relative;\n"], ["\n\tdisplay: inline-flex;\n\talign-items: flex-start;\n\tjustify-content: flex-start;\n\tpadding: 4px;\n\tposition: relative;\n"])));
var DropZone = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tz-index: 2;\n"], ["\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n\tz-index: 2;\n"])));
var FilesList = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n\tpadding: 6px;\n"], ["\n\tpadding: 6px;\n"])));
var File = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n\tdisplay: flex;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tfont-size: 14px;\n\t> * {\n\t\tpadding-right: 4px;\n\t}\n\t> span {\n\t\tcolor: rgba(0, 0, 0, 0.45);\n\t}\n"], ["\n\tdisplay: flex;\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tfont-size: 14px;\n\t> * {\n\t\tpadding-right: 4px;\n\t}\n\t> span {\n\t\tcolor: rgba(0, 0, 0, 0.45);\n\t}\n"])));
var templateObject_1$5, templateObject_2$4, templateObject_3$3, templateObject_4$3;

var FileUpload = function (props) {
    var id = props.id, name = props.name, label = props.label, disabled = props.disabled, accept = props.accept, multiple = props.multiple, withDragDrop = props.withDragDrop, onChange = props.onChange;
    var inputRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null), files = _a[0], setFiles = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), dragProgress = _b[0], setDragProgress = _b[1];
    function openFileUpload() {
        if (inputRef) {
            var current = inputRef.current;
            if (current) {
                current.click();
            }
        }
    }
    function handleChange(event) {
        setFiles(Array.from(event.currentTarget.files));
        if (onChange) {
            onChange(event);
        }
    }
    function handleDrop(event) {
        event.preventDefault();
        event.stopPropagation();
        var transferFiles = Array.from(event.dataTransfer.files);
        setFiles(multiple ? transferFiles : transferFiles.slice(0, 1));
        setDragProgress(false);
    }
    function handleDragLeave(event) {
        event.preventDefault();
        event.stopPropagation();
        setDragProgress(false);
    }
    function handleDragEnter(event) {
        event.preventDefault();
        event.stopPropagation();
        setDragProgress(true);
    }
    function handleDragOver(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UploadContainer, null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, { icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "cloud_upload" }), size: "small", type: dragProgress ? "dashed" : "default", label: label, disabled: disabled, onClick: openFileUpload }),
        withDragDrop && !disabled && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropZone, { onClick: openFileUpload, onDrop: handleDrop, onDragLeave: handleDragLeave, onDragEnter: handleDragEnter, onDragOver: handleDragOver })),
        !!files && !!files.length && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FilesList, null, files.map(function (file) {
            return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(File, { key: file.name },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "attach_file" }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, file.name)));
        }))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "file", id: id, name: name, disabled: disabled, accept: accept, multiple: multiple, style: { display: "none" }, ref: inputRef, onChange: disabled ? null : handleChange })));
};

var withAutoCommit = function (Component) { return function (props) {
    var values = props.values, dirty = props.dirty, submitForm = props.submitForm;
    var debouncedSubmitForm = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(__WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(submitForm, 500), [
        submitForm,
    ]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (dirty) {
            debouncedSubmitForm();
        }
        return debouncedSubmitForm.cancel;
    }, [values]);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, props);
}; };

var Form$3 = function (props) {
    var options = props.options, values = props.values, setFieldValue = props.setFieldValue;
    var handleDestinationPageChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        return setFieldValue("pageNumber", Number(event.currentTarget.options[event.currentTarget.selectedIndex].value));
    }, []);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["c" /* Form */], null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, null, "Destination page"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { as: "select", options: options.pages, disabled: false, value: values.pageNumber, onChange: handleDestinationPageChange }, options.pages.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "pageNumber" }))));
};

var AutoCommitForm = withAutoCommit(Form$3);
var InternalLinkPropertiesForm = function (props) {
    var initialValues = props.initialValues, values = props.values, options = props.options, onSubmit = props.onSubmit;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["d" /* Formik */], { initialValues: initialValues, onSubmit: onSubmit }, function (formProps) {
        var initialErrors = formProps.initialErrors, initialTouched = formProps.initialTouched, formValues = formProps.values, errors = formProps.errors, touched = formProps.touched, dirty = formProps.dirty, isValid = formProps.isValid, isSubmitting = formProps.isSubmitting, isValidating = formProps.isValidating, submitCount = formProps.submitCount, setValues = formProps.setValues, setFieldValue = formProps.setFieldValue, setStatus = formProps.setStatus, setErrors = formProps.setErrors, setSubmitting = formProps.setSubmitting, setTouched = formProps.setTouched, setFieldError = formProps.setFieldError, setFieldTouched = formProps.setFieldTouched, validateField = formProps.validateField, validateForm = formProps.validateForm, resetForm = formProps.resetForm, submitForm = formProps.submitForm, setFormikState = formProps.setFormikState, handleBlur = formProps.handleBlur, handleChange = formProps.handleChange, handleReset = formProps.handleReset, handleSubmit = formProps.handleSubmit, getFieldProps = formProps.getFieldProps, getFieldHelpers = formProps.getFieldHelpers, getFieldMeta = formProps.getFieldMeta, registerField = formProps.registerField, unregisterField = formProps.unregisterField;
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
            if (values) {
                setValues(values, false);
            }
        }, [values]);
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCommitForm, { options: options, initialValues: initialValues, initialErrors: initialErrors, initialTouched: initialTouched, values: formValues, errors: errors, touched: touched, dirty: dirty, isValid: isValid, isSubmitting: isSubmitting, isValidating: isValidating, submitCount: submitCount, setFieldValue: setFieldValue, setValues: setValues, setStatus: setStatus, setErrors: setErrors, setSubmitting: setSubmitting, setTouched: setTouched, setFieldError: setFieldError, setFieldTouched: setFieldTouched, validateField: validateField, validateForm: validateForm, resetForm: resetForm, submitForm: submitForm, setFormikState: setFormikState, handleBlur: handleBlur, handleChange: handleChange, handleReset: handleReset, handleSubmit: handleSubmit, getFieldProps: getFieldProps, getFieldHelpers: getFieldHelpers, getFieldMeta: getFieldMeta, registerField: registerField, unregisterField: unregisterField }));
    }));
};

var generateCommonColorSpectrum = function (color) { return ({
    darker: Object(__WEBPACK_IMPORTED_MODULE_9_polished__["a" /* darken */])(0.3, color),
    dark: Object(__WEBPACK_IMPORTED_MODULE_9_polished__["a" /* darken */])(0.1, color),
    medium: color,
    light: Object(__WEBPACK_IMPORTED_MODULE_9_polished__["b" /* lighten */])(0.1, color),
    lighter: Object(__WEBPACK_IMPORTED_MODULE_9_polished__["b" /* lighten */])(0.3, color),
}); };
var generateLinkSpectrum = function (color) { return ({
    visited: Object(__WEBPACK_IMPORTED_MODULE_9_polished__["a" /* darken */])(0.2, color),
    default: color,
    hover: Object(__WEBPACK_IMPORTED_MODULE_9_polished__["b" /* lighten */])(0.1, color),
}); };

var theme = {
    colors: {
        primary: generateCommonColorSpectrum("#f12c2c"),
        secondary: generateCommonColorSpectrum("#3b3ba8"),
        disabled: generateCommonColorSpectrum("#848383"),
        link: generateLinkSpectrum("#699ed5"),
        bg: {
            primary: "#fff",
            secondary: "#bfbcbc",
        },
        feedback: {
            success: "#52a72f",
            error: "#f56403",
            warning: "#e7a11a",
            default: "#848383",
            info: "#1ea7fd"
        },
        text: "#ffffff",
    },
    spacing: {
        xxxs: "2px",
        xxs: "4px",
        xs: "8px",
        sm: "12px",
        md: "16px",
        lg: "24px",
        xl: "32px",
        xxl: "40px",
    },
    typography: {
        size: {
            xxxs: "6px",
            xxs: "8px",
            xs: "10px",
            sm: "12px",
            md: "16px",
            lg: "18px",
            xl: "26px",
            xxl: "32px",
            xxxl: "42px",
        },
        family: "Arial",
    },
};

var customTheme = __WEBPACK_IMPORTED_MODULE_10_lodash_merge___default()({}, theme, {
    colors: {
        primary: generateCommonColorSpectrum("#16b6cd"),
        feedback: {
            success: "#28a745",
            error: "#dc3545",
            warning: "#ffc107",
            default: "#6c757d",
            info: "#17a2b8"
        },
        text: "#ffffff",
    },
    spacing: {
        md: "30px",
    },
});

var themes = { defaultTheme: theme, customTheme: customTheme };

var Shape = function (_a) {
    var inputPoints = _a.points, id = _a.id, fill = _a.fill, stroke = _a.stroke, strokeWidth = _a.strokeWidth, opacity = _a.opacity, draggable = _a.draggable, isSelected = _a.isSelected, dragOnly = _a.dragOnly, keepRatio = _a.keepRatio, rotateEnabled = _a.rotateEnabled, centeredScaling = _a.centeredScaling, onSelect = _a.onSelect, onChange = _a.onChange, groupElements = _a.groupElements, type = _a.type;
    var shapeRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(undefined);
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), childrenElementsDelta = _b[0], updateChildrenElementsDelta = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([0, 0]), minPoints = _c[0], setMinPoints = _c[1];
    var resetTransformationParams = function () {
        shapeRef.current.x(0);
        shapeRef.current.y(0);
        shapeRef.current.rotation(0);
        shapeRef.current.scaleX(1);
        shapeRef.current.scaleY(1);
    };
    var getMinXY = function (points) {
        var chunked = __WEBPACK_IMPORTED_MODULE_12_lodash_chunk___default()(points, 2);
        var minX = chunked[0][0];
        var minY = chunked[0][1];
        chunked.forEach(function (_a) {
            var x = _a[0], y = _a[1];
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
        });
        return [minX, minY];
    };
    var trRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(undefined);
    var handleSelect = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_a) {
        var evt = _a.evt;
        onSelect ? onSelect({ id: id, type: type, event: evt }) : null;
    }, [id, type, onSelect]);
    var handleTransformation = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        var transformedPoints = [];
        var points = event.currentTarget.attrs.points;
        var chunked = __WEBPACK_IMPORTED_MODULE_12_lodash_chunk___default()(points, 2);
        var stage = event.target.getStage();
        var transform = stage.getTransform().copy();
        transform.invert();
        chunked.forEach(function (_a) {
            var x = _a[0], y = _a[1];
            var currentPoints = shapeRef.current.getTransform().point({ x: x, y: y });
            var absoluteX = currentPoints.x, absoluteY = currentPoints.y;
            transformedPoints.push.apply(transformedPoints, [absoluteX, absoluteY]);
        });
        if (transformedPoints) {
            resetTransformationParams();
            var minX_1 = minPoints[0], minY_1 = minPoints[1];
            var modifiedGroupElements = groupElements
                ? groupElements.map(function (groupElement, index) {
                    var _a = childrenElementsDelta[index], deltaX = _a[0], deltaY = _a[1];
                    return __assign(__assign({}, groupElement), { props: __assign(__assign({}, groupElement.props), { x: minX_1 - deltaX, y: minY_1 - deltaY }) });
                })
                : undefined;
            onChange({
                id: id,
                points: transformedPoints,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                opacity: opacity,
                groupElements: modifiedGroupElements,
                type: type,
            });
        }
    }, [childrenElementsDelta, groupElements, minPoints]);
    function handleMoveChanges(event) {
        var stage = event.target.getStage();
        var _a = event.currentTarget.getClientRect({
            skipTransform: false,
            skipStroke: true,
            relativeTo: stage,
        }), x = _a.x, y = _a.y;
        setMinPoints([x, y]);
    }
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var _a, _b;
        if (isSelected) {
            (_a = trRef.current) === null || _a === void 0 ? void 0 : _a.setNode(shapeRef.current);
            (_b = trRef.current) === null || _b === void 0 ? void 0 : _b.getLayer().batchDraw();
        }
    }, [isSelected]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (groupElements) {
            var _a = getMinXY(inputPoints), minParentX_1 = _a[0], minParentY_1 = _a[1];
            var deltaArray_1 = [];
            groupElements.forEach(function (groupElement, index) {
                var _a = groupElement.props, x = _a.x, y = _a.y;
                deltaArray_1[index] = [minParentX_1 - x, minParentY_1 - y];
            });
            setMinPoints([minParentX_1, minParentY_1]);
            updateChildrenElementsDelta(deltaArray_1);
        }
    }, [groupElements, updateChildrenElementsDelta]);
    var minX = minPoints[0], minY = minPoints[1];
    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11_react_konva__["Group"], null,
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11_react_konva__["Line"], { draggable: draggable, id: id, points: inputPoints, fill: fill, stroke: stroke, strokeWidth: strokeWidth, opacity: opacity, closed: true, onClick: handleSelect, onTap: handleSelect, onDragMove: handleMoveChanges, onDragEnd: handleTransformation, onTransformEnd: handleTransformation, onTransform: handleMoveChanges, ref: shapeRef }),
            __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(groupElements, function (element, index) {
                var props = element.props;
                var _a = childrenElementsDelta[index] || [], _b = _a[0], deltaX = _b === void 0 ? 0 : _b, _c = _a[1], deltaY = _c === void 0 ? 0 : _c;
                return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(element, __assign(__assign({}, props), { parentId: id, x: minX - deltaX, y: minY - deltaY, id: index }), props.children);
            })),
        isSelected && !dragOnly && (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11_react_konva__["Transformer"], { keepRatio: keepRatio, rotateEnabled: rotateEnabled, centeredScaling: centeredScaling, ref: trRef }))));
};

var DrawPolygonArea = function (_a, ref) {
    var onFinish = _a.onFinish, drawingOpacity = _a.drawingOpacity, drawingStrokeWidth = _a.drawingStrokeWidth, drawingStrokeColor = _a.drawingStrokeColor, drawingFillColor = _a.drawingFillColor, scaleIndex = _a.scaleIndex;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([0, 0]), curMousePos = _b[0], setCurMousePos = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]), points = _c[0], setPoints = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isMouseOverStartPoint = _d[0], setMouseOverStartPoint = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isFinished = _e[0], setIsFinished = _e[1];
    var cornerDotsScale = scaleIndex < 1 ? scaleIndex + 1 : 1;
    var getMousePos = function (stage) {
        var transform = stage.getAbsoluteTransform().copy();
        transform.invert();
        var _a = transform.point(stage.getPointerPosition()), x = _a.x, y = _a.y;
        return [x, y];
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(ref, function () { return ({
        clear: function () {
            setPoints([]);
        },
        handleMouseDown: function (event) {
            var stage = event.target.getStage();
            var mousePos = getMousePos(stage);
            if (isFinished) {
                return;
            }
            if (isMouseOverStartPoint && points.length >= 3) {
                setIsFinished(true);
            }
            else {
                setPoints(__spreadArrays(points, [mousePos]));
                return;
            }
        },
        handleMouseMove: function (event) {
            var stage = event.target.getStage();
            var mousePos = getMousePos(stage);
            if (isMouseOverStartPoint && points.length >= 3) {
                var x = points[0], y = points[1];
                setCurMousePos([x, y]);
            }
            else {
                setCurMousePos(mousePos);
            }
            return;
        },
        handleMouseUp: function () {
            return;
        },
    }); });
    var handleMouseOverStartPoint = function () {
        if (isFinished || points.length < 3) {
            return;
        }
        setMouseOverStartPoint(true);
    };
    var handleMouseOutStartPoint = function () {
        setMouseOverStartPoint(false);
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (isFinished) {
            onFinish(points.reduce(function (a, b) { return a.concat(b); }, []));
        }
        setPoints([]);
        setCurMousePos([0, 0]);
        setMouseOverStartPoint(false);
        setIsFinished(false);
    }, [isFinished]);
    var flattenedPoints = points
        .concat(isFinished ? [] : curMousePos)
        .reduce(function (a, b) { return a.concat(b); }, []);
    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null,
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11_react_konva__["Line"], { points: flattenedPoints, stroke: drawingStrokeColor, opacity: drawingOpacity, strokeWidth: drawingStrokeWidth, closed: isFinished }),
        points.map(function (point, index) {
            var width = 5;
            var x = point[0] - width / 2;
            var y = point[1] - width / 2;
            var isFirstPoint = index === 0;
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11_react_konva__["Rect"], { key: index, x: x, y: y, width: width, height: width, scale: { x: cornerDotsScale, y: cornerDotsScale }, fill: drawingFillColor, stroke: drawingStrokeColor, opacity: drawingOpacity, strokeWidth: drawingStrokeWidth, hitStrokeWidth: isFirstPoint ? 10 : 0, onMouseOver: isFirstPoint ? handleMouseOverStartPoint : undefined, onMouseOut: isFirstPoint ? handleMouseOutStartPoint : undefined }));
        })));
};
var DrawPolygonArea$1 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(DrawPolygonArea);

var DrawRectangleArea = function (_a, ref) {
    var onFinish = _a.onFinish, drawingOpacity = _a.drawingOpacity, drawingStrokeWidth = _a.drawingStrokeWidth, drawingStrokeColor = _a.drawingStrokeColor, drawingFillColor = _a.drawingFillColor;
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined), position = _b[0], setPosition = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), isFinished = _c[0], setIsFinished = _c[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(ref, function () { return ({
        clear: function () {
            setPosition(undefined);
        },
        handleMouseDown: function (event) {
            var stage = event.target.getStage();
            var transform = stage.getAbsoluteTransform().copy();
            transform.invert();
            var _a = transform.point(stage.getPointerPosition()), x = _a.x, y = _a.y;
            setPosition({
                x: x,
                y: y,
                width: 0,
                height: 0,
            });
        },
        handleMouseMove: function (event) {
            if (position) {
                var startX = position.x, startY = position.y;
                var stage = event.target.getStage();
                var transform = stage.getAbsoluteTransform().copy();
                transform.invert();
                var _a = transform.point(stage.getPointerPosition()), x = _a.x, y = _a.y;
                var width = x - startX;
                var height = y - startY;
                setPosition({
                    x: startX,
                    y: startY,
                    width: width,
                    height: height,
                });
            }
        },
        handleMouseUp: function () {
            setIsFinished(true);
        },
    }); });
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (isFinished && position) {
            var x = position.x, y = position.y, width = position.width, height = position.height;
            if (width === 0 && height === 0) {
                return;
            }
            onFinish([x, y, x, y + height, x + width, y + height, x + width, y]);
            setIsFinished(false);
            setPosition(undefined);
        }
    }, [isFinished, position]);
    return (position && (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11_react_konva__["Rect"], { fill: drawingFillColor, stroke: drawingStrokeColor, opacity: drawingOpacity, strokeWidth: drawingStrokeWidth, width: position.width, height: position.height, x: position.x, y: position.y })));
};
var DrawRectangleArea$1 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(DrawRectangleArea);

var ActionAreaComponent = function (_a) {
    var drawMode = _a.drawMode, transformMode = _a.transformMode, _b = _a.drawingFillColor, drawingFillColor = _b === void 0 ? "red" : _b, _c = _a.drawingStrokeColor, drawingStrokeColor = _c === void 0 ? "blue" : _c, _d = _a.drawingStrokeWidth, drawingStrokeWidth = _d === void 0 ? 1 : _d, _e = _a.drawingOpacity, drawingOpacity = _e === void 0 ? 0 : _e, _f = _a.fill, fill = _f === void 0 ? "orange" : _f, _g = _a.stroke, stroke = _g === void 0 ? "orange" : _g, _h = _a.strokeWidth, strokeWidth = _h === void 0 ? 0.5 : _h, _j = _a.opacity, opacity = _j === void 0 ? 0.8 : _j, _k = _a.idPrefix, idPrefix = _k === void 0 ? "shape" : _k, onShapeAdded = _a.onShapeAdded, onShapeRemoved = _a.onShapeRemoved, onShapeChanged = _a.onShapeChanged, onShapeFocused = _a.onShapeFocused, onShapeBlur = _a.onShapeBlur, onClick = _a.onClick, shapes = _a.shapes, image = _a.image, _l = _a.scaleIndex, scaleIndex = _l === void 0 ? undefined : _l, _m = _a.fitImageToStage, fitImageToStage = _m === void 0 ? true : _m, width = _a.width, height = _a.height, _o = _a.transformKeepRatio, transformKeepRatio = _o === void 0 ? false : _o, _p = _a.transformRotateEnabled, transformRotateEnabled = _p === void 0 ? true : _p, _q = _a.transformCenteredScaling, transformCenteredScaling = _q === void 0 ? false : _q;
    var _r = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(scaleIndex), scaling = _r[0], setScaling = _r[1];
    var _s = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null), selectedId = _s[0], selectShape = _s[1];
    var layer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var imageRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var drawerRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
    var clickedOnShape = function (e) {
        return !e.target.attrs.hasOwnProperty("image") && e.target !== e.target.getStage();
    };
    var addShape = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (points) {
        var shapeToAdd = {
            id: "" + idPrefix + (shapes.length + 1),
            points: points,
            fill: fill,
            stroke: stroke,
            opacity: opacity,
            strokeWidth: strokeWidth,
        };
        if (onShapeAdded) {
            onShapeAdded(shapeToAdd);
        }
    }, [shapes]);
    var removeShape = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (id) {
        var index = shapes.findIndex(function (s) { return s.id === id; });
        if (onShapeRemoved) {
            onShapeRemoved(shapes[index]);
        }
    }, [shapes]);
    var handleShapeChanges = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (shape) {
        var shapesToModify = __spreadArrays(shapes);
        var index = shapesToModify.findIndex(function (s) { return s.id === shape.id; });
        shapesToModify[index] = shape;
        if (onShapeChanged) {
            onShapeChanged(shape);
        }
    }, [shapes]);
    var keyDownHandler = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
        var _a;
        if (e.key === "Escape") {
            (_a = drawerRef.current) === null || _a === void 0 ? void 0 : _a.clear();
        }
        if (removeShape &&
            selectedId &&
            (e.key === "Backspace" || e.key === "Delete")) {
            removeShape(selectedId);
        }
    }, [selectedId]);
    var mouseMoveHandler = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) { var _a; return !transformMode ? (_a = drawerRef.current) === null || _a === void 0 ? void 0 : _a.handleMouseMove(e) : null; }, [transformMode]);
    var mouseDownHandler = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
        var _a;
        if (transformMode) {
            if (!clickedOnShape(e)) {
                onShapeBlur ? onShapeBlur(selectedId) : null;
                selectShape(null);
            }
        }
        else {
            (_a = drawerRef.current) === null || _a === void 0 ? void 0 : _a.handleMouseDown(e);
        }
    }, [selectedId, imageRef, drawerRef, transformMode, onShapeBlur]);
    var mouseClickHandler = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
        if (onClick) {
            onClick({
                isClickedOnShape: clickedOnShape(e),
                isTransformMode: transformMode !== undefined,
                event: e.evt,
            });
        }
    }, [selectedId, imageRef, drawerRef, transformMode]);
    var mouseUpHandler = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) { var _a; return !transformMode ? (_a = drawerRef.current) === null || _a === void 0 ? void 0 : _a.handleMouseUp(e) : null; }, [transformMode]);
    var handleSelectShape = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_a) {
        var id = _a.id, type = _a.type, event = _a.event;
        selectShape(id);
        if (onShapeFocused) {
            onShapeFocused({ id: id, type: type, event: event });
        }
    }, [selectShape, onShapeFocused]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (image && fitImageToStage && !scaling) {
            var naturalHeight = image.naturalHeight, naturalWidth = image.naturalWidth;
            var scalingY = 1;
            var scalingX = 1;
            if (naturalHeight > height) {
                scalingY = height / naturalHeight;
            }
            if (naturalWidth > width) {
                scalingX = width / naturalWidth;
            }
            setScaling(Math.min(scalingY, scalingX));
        }
        else {
            setScaling(scaleIndex);
        }
    }, [image, fitImageToStage, scaleIndex]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (!transformMode) {
            selectShape(null);
        }
    }, [transformMode]);
    var dragOnly = transformMode === "dragOnly";
    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { id: "container", tabIndex: 1, onKeyDown: keyDownHandler, style: { outlineStyle: "none" } },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11_react_konva__["Stage"], { onMouseMove: mouseMoveHandler, onMouseDown: mouseDownHandler, onClick: mouseClickHandler, onMouseUp: mouseUpHandler, scaleX: scaling, scaleY: scaling, width: width, height: height },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11_react_konva__["Layer"], { ref: layer },
                image && (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_11_react_konva__["Image"], { ref: imageRef, preventDefault: false, scaleX: 1, scaleY: 1, image: image })),
                shapes.map(function (shape) {
                    var id = shape.id, points = shape.points, shapeFill = shape.fill, shapeStroke = shape.stroke, shapeStrokeWidth = shape.strokeWidth, shapeOpacity = shape.opacity, groupElements = shape.groupElements, isShapeSelected = shape.isShapeSelected, type = shape.type;
                    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Shape, { id: id, key: id, points: points, isSelected: transformMode && (isShapeSelected !== null && isShapeSelected !== void 0 ? isShapeSelected : id === selectedId), draggable: id === selectedId || dragOnly, onSelect: transformMode ? handleSelectShape : undefined, onChange: handleShapeChanges, dragOnly: dragOnly, keepRatio: transformKeepRatio, rotateEnabled: transformRotateEnabled, centeredScaling: transformCenteredScaling, fill: shapeFill || fill, stroke: shapeStroke || stroke, strokeWidth: shapeStrokeWidth || strokeWidth, opacity: shapeOpacity || opacity, groupElements: groupElements, type: type }));
                }),
                !transformMode && drawMode === "rectangle" && (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(DrawRectangleArea$1, { ref: drawerRef, onFinish: addShape, drawingFillColor: drawingFillColor, drawingStrokeColor: drawingStrokeColor, drawingStrokeWidth: drawingStrokeWidth, drawingOpacity: drawingOpacity })),
                !transformMode && drawMode === "polygon" && (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(DrawPolygonArea$1, { ref: drawerRef, onFinish: addShape, scaleIndex: scaleIndex, drawingFillColor: drawingFillColor, drawingStrokeColor: drawingStrokeColor, drawingStrokeWidth: drawingStrokeWidth, drawingOpacity: drawingOpacity }))))));
};

var isFixed = function (dropdownValue, fixedUsers) {
    return fixedUsers.indexOf(dropdownValue) !== -1;
};
var DropdownPresenter = function (props) {
    var selectedValues = props.selectedValues, fixedValues = props.fixedValues, values = props.values, onChange = props.onChange, isDisabled = props.isDisabled;
    var styles = {
        multiValueRemove: function (base, state) {
            // Spread the base css minus the hover to remove it
            var alignItems = base.alignItems, borderRadius = base.borderRadius, backgroundColor = base.backgroundColor, display = base.display, paddingLeft = base.paddingLeft, paddingRight = base.paddingRight, boxSizing = base.boxSizing;
            return isFixed(state.data, fixedValues)
                ? { display: "none" }
                : {
                    alignItems: alignItems,
                    borderRadius: borderRadius,
                    backgroundColor: backgroundColor,
                    display: display,
                    paddingLeft: paddingLeft,
                    paddingRight: paddingRight,
                    boxSizing: boxSizing,
                };
        },
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_select__["b" /* default */], { value: selectedValues, isDisabled: isDisabled, isClearable: false, isMulti: true, styles: styles, name: "colors", className: "zmags-dropdown", classNamePrefix: "zmags-dropdown", onChange: onChange, options: values }));
};

var isSelected = function (dropdownValue) {
    return dropdownValue.isSelected;
};
var DropdownComponent = /** @class */ (function (_super) {
    __extends(DropdownComponent, _super);
    function DropdownComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeHandler = function (values, actionMetadata) {
            var action = actionMetadata.action;
            var _a = _this.props, fixedValues = _a.fixedValues, onChange = _a.onChange;
            var isClearAction = action === "clear";
            var newValues = isClearAction ? fixedValues : values;
            if (onChange) {
                var previousValues = _this.state.selectedValues;
                onChange(newValues, previousValues);
            }
            _this.setState({ selectedValues: newValues });
        };
        var _a = _this.props, fixedValues = _a.fixedValues, values = _a.values;
        _this.state = {
            selectedValues: fixedValues.concat(values.filter(isSelected)),
        };
        return _this;
    }
    DropdownComponent.prototype.render = function () {
        var _a = this.props, isDisabled = _a.isDisabled, fixedValues = _a.fixedValues, values = _a.values;
        var selectedValues = this.state.selectedValues;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownPresenter, { isDisabled: isDisabled, values: values, selectedValues: selectedValues, fixedValues: fixedValues, onChange: this.onChangeHandler }));
    };
    return DropdownComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var Checkbox = function (_a) {
    var checked = _a.checked, id = _a.id, onChange = _a.onChange, disabled = _a.disabled;
    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("input", { type: "checkbox", checked: checked, onChange: onChange, id: id, disabled: disabled }));
};
var CheckBoxPresenter = function (props) {
    var checked = props.checked, label = props.label, onChange = props.onChange, id = props.id, disabled = props.disabled;
    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("label", { htmlFor: id },
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Checkbox, { disabled: disabled, checked: checked, onChange: onChange, id: id }),
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null,
            " ",
            label,
            " ")));
};

var CheckBoxComponent = /** @class */ (function (_super) {
    __extends(CheckBoxComponent, _super);
    function CheckBoxComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.id = "";
        // Its a bit strange to have event handling in the component here, but i dont think it belongs in the presenter
        //  and I need it to update my state here
        _this.handleCheckboxChange = function (event) {
            var checked = event.target.checked;
            _this.setState({ checked: checked });
            var onChange = _this.props.onChange;
            if (onChange) {
                onChange(checked);
            }
        };
        _this.id = __WEBPACK_IMPORTED_MODULE_14_nanoid___default()();
        var checked = props.checked;
        _this.state = {
            checked: checked,
        };
        return _this;
    }
    CheckBoxComponent.prototype.render = function () {
        var _a = this.props, label = _a.label, disabled = _a.disabled;
        var checked = this.state.checked;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(CheckBoxPresenter, { checked: checked, label: label, disabled: disabled, onChange: this.handleCheckboxChange, id: this.id }));
    };
    CheckBoxComponent.defaultProps = {
        onChange: function () { return undefined; },
    };
    return CheckBoxComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var Image = function (_a) {
    var src = _a.src, alt = _a.alt, height = _a.height, width = _a.width, onLoadFn = _a.onLoad, onErrorFn = _a.onError;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: src, alt: alt, onLoad: onLoadFn, onError: onErrorFn, height: height, width: width }));
};

var ToolsMenuDivider = function () { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DividerComponent, { direction: DividerDirection.HORIZONTAL })); };

var styles$3 = function (theme) { return ({
    toolsItem: function () { return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n\t\tmargin: 0;\n\t\tpadding: ", ";\n\t\twhite-space: nowrap;\n\t\tlist-style-type: none;\n\t\tcursor: pointer;\n\t\t:hover {\n\t\t\tbackground: rgba(211, 211, 211, 0.2);\n\t\t}\n\t"], ["\n\t\tmargin: 0;\n\t\tpadding: ", ";\n\t\twhite-space: nowrap;\n\t\tlist-style-type: none;\n\t\tcursor: pointer;\n\t\t:hover {\n\t\t\tbackground: rgba(211, 211, 211, 0.2);\n\t\t}\n\t"])), theme.spacing.xxs); },
    disabled: function () { return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n\t\tpointer-events: none;\n\t\tcursor: default;\n\t"], ["\n\t\tpointer-events: none;\n\t\tcursor: default;\n\t"]))); },
    toolsSubMenu: function () { return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n\t\tlist-style-type: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\twhite-space: nowrap;\n\t\t.tippy-box[data-theme~=\"light\"] {\n\t\t\tbackground: ", ";\n\t\t\tborder-radius: ", ";\n\t\t\tbox-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px,\n\t\t\t\trgba(0, 0, 0, 0.15) 0px 8px 16px;\n\t\t}\n\t"], ["\n\t\tlist-style-type: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\twhite-space: nowrap;\n\t\t.tippy-box[data-theme~=\"light\"] {\n\t\t\tbackground: ", ";\n\t\t\tborder-radius: ", ";\n\t\t\tbox-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px,\n\t\t\t\trgba(0, 0, 0, 0.15) 0px 8px 16px;\n\t\t}\n\t"])), theme.colors.bg.primary, theme.spacing.xxs); },
    toolsMenu: function () { return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n\t\tlist-style-type: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tdisplay: inline-block;\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t\tborder: 1px solid rgba(0, 0, 0, 0.15);\n\t"], ["\n\t\tlist-style-type: none;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tdisplay: inline-block;\n\t\tbackground: ", ";\n\t\tborder-radius: ", ";\n\t\tborder: 1px solid rgba(0, 0, 0, 0.15);\n\t"])), theme.colors.bg.primary, theme.spacing.xxs); },
}); };
var templateObject_1$6, templateObject_2$5, templateObject_3$4, templateObject_4$4;

/** @jsx jsx */
var ToolsItemComponent = function (props) {
    var disabled = props.disabled, children = props.children;
    var theme = Object(__WEBPACK_IMPORTED_MODULE_4_emotion_theming__["a" /* useTheme */])();
    var style = styles$3(theme);
    return (Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("li", { css: [style.toolsItem(), disabled ? style.disabled() : null] }, children));
};

/** @jsx jsx */
var ToolsSubMenuComponent = function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_4_emotion_theming__["a" /* useTheme */])();
    var style = styles$3(theme);
    var title = props.title, disabled = props.disabled, _a = props.trigger, trigger = _a === void 0 ? "mouseenter focus" : _a, children = props.children;
    var titleNode = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("div", { css: [style.toolsItem()] }, title);
    return (Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("li", { css: [style.toolsSubMenu(), disabled ? style.disabled() : {}] }, Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])(__WEBPACK_IMPORTED_MODULE_15__tippyjs_react__["a" /* default */], { content: Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("ul", { css: style.toolsSubMenu() }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (node) {
            return ([
                ToolsMenuDivider,
                ToolsItemComponent,
                ToolsSubMenuComponent,
            ].includes(node.type) && node);
        })), placement: "right-start", interactive: true, hideOnClick: true, theme: "light", trigger: trigger, arrow: false, duration: 200, delay: [75, 0], offset: [0, 4], disabled: disabled }, titleNode)));
};

/** @jsx jsx */
var ToolsMenuComponent = function (props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_4_emotion_theming__["a" /* useTheme */])();
    var style = styles$3(theme);
    var children = props.children;
    return (Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("ul", { css: [style.toolsMenu()] }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (node) {
        return ([
            ToolsMenuDivider,
            ToolsItemComponent,
            ToolsSubMenuComponent,
        ].includes(node.type) && node);
    })));
};

var TextAreaComponent = /** @class */ (function (_super) {
    __extends(TextAreaComponent, _super);
    function TextAreaComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.onChangeHandler = function (event) {
            var contentChangeHandler = _this.props.contentChangeHandler;
            if (contentChangeHandler && event.target.value !== _this.state.value) {
                event.persist();
                _this.debouncedContentChangeHandler(event);
            }
            _this.setState({ value: event.target.value });
        };
        var _a = _this.props, contentChangeHandler = _a.contentChangeHandler, contentChangeHandlerWait = _a.contentChangeHandlerWait, contentChangeHandlerMaxWait = _a.contentChangeHandlerMaxWait, initialValue = _a.initialValue;
        _this.state = { value: initialValue };
        var debounceOptions = __assign({}, (contentChangeHandlerMaxWait && {
            maxWait: contentChangeHandlerMaxWait,
        }));
        if (contentChangeHandler) {
            _this.debouncedContentChangeHandler = __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(contentChangeHandler, contentChangeHandlerWait, debounceOptions);
        }
        return _this;
    }
    TextAreaComponent.prototype.componentWillUnmount = function () {
        if (this.debouncedContentChangeHandler) {
            this.debouncedContentChangeHandler.flush();
        }
    };
    TextAreaComponent.prototype.render = function () {
        var _a = this.props, id = _a.id, name = _a.name, rows = _a.rows, cols = _a.cols, resize = _a.resize, disabled = _a.disabled, maxLength = _a.maxLength, minLength = _a.minLength, placeholder = _a.placeholder, readOnly = _a.readOnly, required = _a.required, spellCheck = _a.spellCheck, wrap = _a.wrap, styleProp = _a.style;
        var style = __assign(__assign({}, styleProp), (resize === false && { resize: "none" }));
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", { id: id, name: name, rows: rows, cols: cols, disabled: disabled, maxLength: maxLength, minLength: minLength, placeholder: placeholder, readOnly: readOnly, required: required, spellCheck: spellCheck, wrap: wrap, style: style, value: this.state.value, onChange: this.onChangeHandler }));
    };
    TextAreaComponent.defaultProps = {
        rows: 5,
        cols: 30,
        resize: true,
        contentChangeHandlerWait: 200,
        contentChangeHandlerMaxWait: 500,
        initialValue: "",
    };
    return TextAreaComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var getCheckboxPadding = function (size, spacing) {
    switch (size) {
        case "large":
            return spacing.md;
        case "small":
            return spacing.sm;
        case "middle":
        default:
            return spacing.md;
    }
};
var getFontSize = function (size, fontSize) {
    switch (size) {
        case "large":
            return fontSize.xl;
        case "small":
            return fontSize.sm;
        case "middle":
        default:
            return fontSize.md;
    }
};
var getFloat = function (type) {
    switch (type) {
        case "left":
            return "flex-start";
        case "right":
            return "flex-end";
        case "middle":
            return "center";
        case "between":
            return "space-between";
        default:
            return "space-between";
    }
};
var ToolboxModeStyles = function (_a) {
    var theme = _a.theme, active = _a.active;
    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n\t\tmargin: ", ";\n\t\tborder-width: 0 !important;\n\t\tbackground-color: ", ";\n\t\t&:hover {\n\t\t\tcolor: ", ";\n\t\t\tbackground-color: ", ";\n\t\t}\n\t"], ["\n\t\tmargin: ", ";\n\t\tborder-width: 0 !important;\n\t\tbackground-color: ", ";\n\t\t&:hover {\n\t\t\tcolor: ", ";\n\t\t\tbackground-color: ",
        ";\n\t\t}\n\t"])), theme.spacing.xxs, active ? theme.colors.primary.lighter : "transparent", theme.colors.primary.dark, active
        ? theme.colors.primary.lighter
        : "transparent");
};
var CheckboxModeStyles = function (_a) {
    var theme = _a.theme, isNested = _a.isNested, active = _a.active;
    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n\t\t&:after {\n\t\t\tposition: absolute;\n\t\t\tright: ", ";\n\t\t\tpadding-left: ", ";\n\t\t\tcontent: \"\\2713\";\n\t\t\tdisplay: inline-block;\n\t\t\ttransform: scale(", ");\n\t\t\ttransition: transform 0.3s;\n\t\t\tpointer-events: none;\n\t\t}\n\t"], ["\n\t\t&:after {\n\t\t\tposition: absolute;\n\t\t\tright: ", ";\n\t\t\tpadding-left: ", ";\n\t\t\tcontent: \"\\\\2713\";\n\t\t\tdisplay: inline-block;\n\t\t\ttransform: scale(", ");\n\t\t\ttransition: transform 0.3s;\n\t\t\tpointer-events: none;\n\t\t}\n\t"])), theme.spacing.xxs, theme.spacing.xs, active && isNested ? 1 : 0);
};
var styles$4 = function (theme) {
    return {
        wrapperStyles: function (_a) {
            var type = _a.type, float = _a.float;
            return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\tlist-style-type: none;\n\t\t\tdisplay: ", ";\n\t\t\tflex-direction: ", ";\n\t\t\tcolor: ", ";\n\t\t\tdisplay: ", ";\n\t\t\tfont-family: ", ";\n\t\t\tjustify-content: ", ";\n\t\t"], ["\n\t\t\tpadding: 0;\n\t\t\tmargin: 0;\n\t\t\tlist-style-type: none;\n\t\t\tdisplay: ", ";\n\t\t\tflex-direction: ", ";\n\t\t\tcolor: ", ";\n\t\t\tdisplay: ", ";\n\t\t\tfont-family: ", ";\n\t\t\tjustify-content: ", ";\n\t\t"])), type === "vertical" ? "flex-inline" : "flex", type === "vertical" ? "column" : "row", theme.colors.primary.medium, type === "vertical" ? "inline-flex" : "flex", theme.typography.family, getFloat(float));
        },
        SubmenuStyles: function (_a) {
            var type = _a.type, float = _a.float;
            return [
                Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding: ", ";\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\tz-index: 10;\n\t\t\t\t\t\t\twidth: ", ";\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\tvisibility: visible;\n\t\t\t\t\t\t\t> li {\n\t\t\t\t\t\t\t\tcolor: white;\n\t\t\t\t\t\t\t\tborder-color: transparent;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t> ul {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\tvisibility: hidden;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\ttop: ", ";\n\t\t\t\t\t\tleft: ", ";\n\t\t\t\t\t\tul {\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\tleft: 100%;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t> li {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t"], ["\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tpadding: ", ";\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\t> ul {\n\t\t\t\t\t\t\tz-index: 10;\n\t\t\t\t\t\t\twidth: ", ";\n\t\t\t\t\t\t\topacity: 1;\n\t\t\t\t\t\t\tvisibility: visible;\n\t\t\t\t\t\t\t> li {\n\t\t\t\t\t\t\t\tcolor: white;\n\t\t\t\t\t\t\t\tborder-color: transparent;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t> ul {\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\tflex-direction: column;\n\t\t\t\t\t\tvisibility: hidden;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\topacity: 0;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\tbackground: ", ";\n\t\t\t\t\t\ttop: ", ";\n\t\t\t\t\t\tleft: ", ";\n\t\t\t\t\t\tul {\n\t\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\t\tleft: 100%;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t> li {\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t"])), theme.spacing.xs, float !== "between" ? "auto" : "none", theme.colors.primary.medium, type === "vertical" ? 0 : "100%", type === "vertical" ? "100%" : 0),
            ];
        },
        ItemStyles: function (_a) {
            var type = _a.type, mode = _a.mode, float = _a.float, size = _a.size, active = _a.active, isNested = _a.isNested;
            var spacing = theme.spacing, colors = theme.colors, typography = theme.typography;
            return [
                Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["css"])(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n\t\t\t\t\tpadding: ", ";\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex: ", ";\n\t\t\t\t\tmargin: 0 ", ";\n\t\t\t\t\tposition: relative;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-width: 0;\n\t\t\t\t\tjustify-content: ", ";\n\t\t\t\t\tfont-size: ", ";\n\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\tborder-right-width: ", ";\n\t\t\t\t\tborder-bottom-width: ", ";\n\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\tspan {\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\tpadding-right: ", ";\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: row;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tcolor: inherit;\n\t\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tspan span {\n\t\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\t}\n\t\t\t\t\tspan + span {\n\t\t\t\t\t\tmargin-left: ", ";\n\t\t\t\t\t}\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\t}\n\t\t\t\t"], ["\n\t\t\t\t\tpadding: ", ";\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex: ", ";\n\t\t\t\t\tmargin: 0 ", ";\n\t\t\t\t\tposition: relative;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-width: 0;\n\t\t\t\t\tjustify-content: ", ";\n\t\t\t\t\tfont-size: ", ";\n\t\t\t\t\tborder-color: ", ";\n\t\t\t\t\tborder-right-width: ", ";\n\t\t\t\t\tborder-bottom-width: ", ";\n\t\t\t\t\tbackground-color: ",
                    ";\n\t\t\t\t\tspan {\n\t\t\t\t\t\twhite-space: nowrap;\n\t\t\t\t\t\tpadding-right: ",
                    ";\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: row;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\ta {\n\t\t\t\t\t\t\tcolor: inherit;\n\t\t\t\t\t\t\ttext-decoration: none;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tspan span {\n\t\t\t\t\t\tpadding-right: 0;\n\t\t\t\t\t}\n\t\t\t\t\tspan + span {\n\t\t\t\t\t\tmargin-left: ", ";\n\t\t\t\t\t}\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\tcolor: ", ";\n\t\t\t\t\t\tbackground-color: ", ";\n\t\t\t\t\t}\n\t\t\t\t"])), spacing.xs, float === "between" ? 1 : "initial", spacing.xs, type === "vertical" ? "flex-start" : "center", getFontSize(size, typography.size), active ? colors.primary.medium : "transparent", type === "vertical" ? "2px" : 0, type === "horizontal" ? "2px" : 0, isNested && active
                    ? colors.primary.light
                    : "none", mode === "checkbox" && isNested
                    ? getCheckboxPadding(size, spacing)
                    : 0, spacing.xs, colors.primary.dark, isNested ? colors.primary.light : "none"),
                mode === "toolbox" && !isNested
                    ? ToolboxModeStyles({ theme: theme, active: active })
                    : null,
                mode === "checkbox" && isNested
                    ? CheckboxModeStyles({ theme: theme, isNested: isNested, active: active })
                    : null,
            ];
        },
    };
};
var templateObject_1$7, templateObject_2$6, templateObject_3$5, templateObject_4$5, templateObject_5$2;

/*
Ideally we would use https://emotion.sh/docs/@emotion/babel-preset-css-prop to replace the JSX pragma requirement. The
issue is that ts-loader processes this file before it reaches babel. To get ts-loader to play nice we need to change the
tsconfig value "jsx" from "react" to "preserve" https://github.com/emotion-js/emotion/issues/1748. But this change
appears to blow up something in our stack. I believe this may be caused by react-docgen-typescript-loader, but I haven't
looked farther into it.
 */
var Submenu = function () { return (Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)); };
var SubmenuComponent = function (_a) {
    var id = _a.id, children = _a.children, type = _a.type, mode = _a.mode, float = _a.float, size = _a.size, icon = _a.icon, title = _a.title, isNested = _a.isNested, activeItems = _a.activeItems, handleClick = _a.handleClick;
    var commonProps = { type: type, mode: mode, size: size, float: float, activeItems: activeItems, handleClick: handleClick };
    var theme = Object(__WEBPACK_IMPORTED_MODULE_4_emotion_theming__["a" /* useTheme */])();
    var _b = styles$4(theme), SubmenuStyles = _b.SubmenuStyles, ItemStyles = _b.ItemStyles;
    var onClick = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) { return handleClick(id, e); }, [id, handleClick]);
    var active = id ? activeItems.indexOf(id) !== -1 : false;
    var childrenWithProps = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
        return renderChild({
            childType: child.type,
            childProps: child.props,
            commonProps: commonProps,
            isNested: true,
        });
    });
    return (Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("li", { css: [
            SubmenuStyles({ type: type, float: float }),
            ItemStyles({ active: active, type: type, float: float, size: size, mode: mode, isNested: isNested }),
        ] },
        Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("span", { className: "sub-item-wrapper", onClick: onClick },
            icon,
            title && Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("span", null, title)),
        Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("ul", null, childrenWithProps)));
};

/*
Ideally we would use https://emotion.sh/docs/@emotion/babel-preset-css-prop to replace the JSX pragma requirement. The
issue is that ts-loader processes this file before it reaches babel. To get ts-loader to play nice we need to change the
tsconfig value "jsx" from "react" to "preserve" https://github.com/emotion-js/emotion/issues/1748. But this change
appears to blow up something in our stack. I believe this may be caused by react-docgen-typescript-loader, but I haven't
looked farther into it.
 */
var Item = function () { return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null); };
var ItemComponent = function (_a) {
    var children = _a.children, id = _a.id, type = _a.type, float = _a.float, size = _a.size, mode = _a.mode, isNested = _a.isNested, activeItems = _a.activeItems, icon = _a.icon, handleClick = _a.handleClick;
    var theme = Object(__WEBPACK_IMPORTED_MODULE_4_emotion_theming__["a" /* useTheme */])();
    var ItemStyles = styles$4(theme).ItemStyles;
    var active = id ? activeItems.indexOf(id) !== -1 : false;
    var onClick = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) { return handleClick(id, e); }, [id, handleClick]);
    return (Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("li", { css: [ItemStyles({ type: type, float: float, size: size, active: active, mode: mode, isNested: isNested })], onClick: onClick },
        icon && icon,
        children && Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("span", null, children)));
};

var renderChild = function (_a) {
    var childType = _a.childType, childProps = _a.childProps, commonProps = _a.commonProps, isNested = _a.isNested;
    var type = commonProps.type, mode = commonProps.mode, size = commonProps.size, float = commonProps.float, activeItems = commonProps.activeItems, handleClick = commonProps.handleClick;
    if (childType === Submenu) {
        var id = childProps.id, title = childProps.title, icon = childProps.icon, children = childProps.children;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubmenuComponent, { id: id, title: title, icon: icon, children: children, type: type, mode: mode, float: float, size: size, activeItems: activeItems, handleClick: handleClick, isNested: isNested }));
    }
    if (childType === Item) {
        var id = childProps.id, icon = childProps.icon, children = childProps.children;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemComponent, { id: id, children: children, icon: icon, type: type, mode: mode, float: float, size: size, activeItems: activeItems, handleClick: handleClick, isNested: isNested }));
    }
    return null;
};

/*
Ideally we would use https://emotion.sh/docs/@emotion/babel-preset-css-prop to replace the JSX pragma requirement. The
issue is that ts-loader processes this file before it reaches babel. To get ts-loader to play nice we need to change the
tsconfig value "jsx" from "react" to "preserve" https://github.com/emotion-js/emotion/issues/1748. But this change
appears to blow up something in our stack. I believe this may be caused by react-docgen-typescript-loader, but I haven't
looked farther into it.
 */
var Wrapper = function (_a) {
    var float = _a.float, type = _a.type, mode = _a.mode, size = _a.size, handleClick = _a.handleClick, children = _a.children, activeItems = _a.activeItems;
    var commonProps = { type: type, mode: mode, size: size, float: float, activeItems: activeItems, handleClick: handleClick };
    var theme = Object(__WEBPACK_IMPORTED_MODULE_4_emotion_theming__["a" /* useTheme */])();
    var wrapperStyles = styles$4(theme).wrapperStyles;
    var childrenWithProps = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child) {
        return renderChild({
            childType: child.type,
            childProps: child.props,
            commonProps: commonProps,
            isNested: false,
        });
    });
    return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["jsx"])("ul", { css: [wrapperStyles({ type: type, float: float })] }, childrenWithProps);
};

var NavigationComponent = /** @class */ (function (_super) {
    __extends(NavigationComponent, _super);
    function NavigationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavigationComponent.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper, __assign({}, this.props));
    };
    NavigationComponent.Item = Item;
    NavigationComponent.SubMenu = Submenu;
    return NavigationComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component));

var portal = document.createElement("div");
if (!document.body) {
    throw new Error("body not ready for portal creation!");
}
document.body.appendChild(portal);
var DraggablePortalComponent = function (props) {
    var provided = props.provided;
    var snapshot = props.snapshot;
    var usePortal = snapshot.isDragging;
    var child = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", __assign({ ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps), props.children));
    if (!usePortal) {
        return child;
    }
    // if dragging - put the item in a portal
    // This is known issue and solution
    // https://github.com/atlassian/react-beautiful-dnd/issues/192
    return __WEBPACK_IMPORTED_MODULE_17_react_dom___default.a.createPortal(child, portal);
};

var getParentElements = function (node) { return (node.parentElement ? getParentElements(node.parentElement) : []).concat([node]); };

/**
 * Component that alerts if you click outside of it
 */
var DraggableOutsideComponent = /** @class */ (function (_super) {
    __extends(DraggableOutsideComponent, _super);
    function DraggableOutsideComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.containerRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        return _this;
    }
    DraggableOutsideComponent.prototype.componentDidMount = function () {
        document.addEventListener("mousedown", this.handleClickOutside);
    };
    DraggableOutsideComponent.prototype.componentWillUnmount = function () {
        document.removeEventListener("mousedown", this.handleClickOutside);
    };
    /**
     * Alert if clicked on outside of element
     */
    DraggableOutsideComponent.prototype.handleClickOutside = function (event) {
        var ignoredOutsideClickClassName = this.props.ignoredOutsideClickClassName;
        var noIgnoredElement = ignoredOutsideClickClassName
            ? !getParentElements(event.target).find(function (el) {
                return el &&
                    el.classList &&
                    el.classList.contains(ignoredOutsideClickClassName);
            })
            : true;
        if (this.containerRef &&
            !this.containerRef.current.contains(event.target) &&
            noIgnoredElement) {
            this.props.outsideHandler();
        }
    };
    DraggableOutsideComponent.prototype.render = function () {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { ref: this.containerRef }, this.props.children);
    };
    return DraggableOutsideComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var actionIconStyle = {
    width: "18px",
    height: "18px",
    cursor: "pointer",
    marginLeft: "7px",
};
var ActionIconComponent = function (props) {
    var id = props.id, enabled = props.enabled, iconEnabled = props.iconEnabled, iconDisabled = props.iconDisabled, type = props.type, isActionDisabled = props.isActionDisabled, onActionClick = props.onActionClick;
    var onMouseDown = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
        e.stopPropagation();
        if (!isActionDisabled) {
            onActionClick(id, type);
        }
    }, [id, type]);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: enabled ? iconEnabled : iconDisabled, style: __assign(__assign({}, actionIconStyle), { cursor: isActionDisabled ? "not-allowed" : "pointer" }), onMouseDown: onMouseDown }));
};

var rowStyle = {
    margin: "5px 0",
    padding: "0 7px",
    color: "#afafaf",
    border: "1px solid #c6c6c6",
    backgroundColor: "#333333",
    fontSize: "13px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: "28px",
};
var rowInfoStyle = {
    display: "flex",
    alignItems: "center",
};
var smallIconStyle = {
    width: "18px",
    height: "18px",
    borderRadius: "4px",
    position: "absolute",
};
var removeIconStyle = {
    cursor: "pointer",
    fontSize: "21px",
    paddingLeft: "8px",
};
var textStyle = {
    marginLeft: "24px",
};
var maxDescriptionLength = 25;
var DraggableRowComponent = /** @class */ (function (_super) {
    __extends(DraggableRowComponent, _super);
    function DraggableRowComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.isMoved = false;
        _this.isClicked = false;
        _this.onMouseUp = function () {
            var _a = _this.props, id = _a.id, onDragRelease = _a.onDragRelease;
            if (!_this.isMoved) {
                onDragRelease && onDragRelease(id);
            }
            _this.isClicked = false;
            _this.isMoved = false;
        };
        /**
         * On item cancel select event
         * click outside of selected item is used
         */
        _this.onOutsideDraggableClick = function () {
            var id = _this.props.id;
            if (_this.props.isSelected || _this.state.isSelected) {
                _this.setState({
                    isSelected: false,
                });
                _this.props.onDragCancel(id);
            }
            _this.isClicked = false;
            _this.isMoved = false;
        };
        /**
         * On item remove icon click
         */
        _this.onRemoveClick = function () {
            var _a = _this.props, onRemoveItem = _a.onRemoveItem, id = _a.id, index = _a.index, columnId = _a.columnId;
            onRemoveItem(id, columnId, index);
        };
        /**
         * First 25 characters in the text requirement
         */
        _this.getDescription = function () {
            var description = _this.props.description;
            return description.length < maxDescriptionLength
                ? description
                : description.substring(0, maxDescriptionLength) + "...";
        };
        /**
         * On item select event
         * onMouseDown at droppable
         */
        _this.onMouseDown = function () {
            _this.isClicked = true;
            _this.setState({
                isSelected: true,
            });
            _this.props.onDragSelect(_this.props.id);
        };
        _this.onMouseMove = function () {
            if (_this.isClicked) {
                _this.isMoved = true;
            }
        };
        _this.renderChangeListIcon = function () {
            var changeIcon = _this.props.changeIcon;
            return changeIcon ? (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", { style: removeIconStyle, onClick: _this.onRemoveClick, dangerouslySetInnerHTML: { __html: changeIcon } })) : null;
        };
        _this.renderWidgetActions = function () {
            var _a = _this.props, id = _a.id, actions = _a.actions, onActionClick = _a.onActionClick;
            return actions && actions.length > 0
                ? actions.map(function (_a) {
                    var enabled = _a.enabled, iconEnabled = _a.iconEnabled, iconDisabled = _a.iconDisabled, type = _a.type, isActionDisabled = _a.isActionDisabled;
                    return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ActionIconComponent, { key: type, id: id, enabled: enabled, iconEnabled: iconEnabled, iconDisabled: iconDisabled, type: type, isActionDisabled: isActionDisabled, onActionClick: onActionClick }));
                })
                : null;
        };
        _this.renderItem = function (provided, snapshot) {
            var _a = _this.props, isSelected = _a.isSelected, icon = _a.icon;
            var draggableRowStyle = isSelected || _this.state.isSelected
                ? __assign(__assign({}, rowStyle), { backgroundColor: "#8c01ff", color: "white" }) : rowStyle;
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(DraggablePortalComponent, { provided: provided, snapshot: snapshot },
                Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { style: draggableRowStyle, onMouseUp: _this.onMouseUp, onMouseDown: _this.onMouseDown, onMouseMove: _this.onMouseMove },
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { style: rowInfoStyle },
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { style: __assign(__assign({}, smallIconStyle), { backgroundImage: "url(" + icon + ")", filter: "brightness(120%)" }) }),
                        Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", { style: textStyle }, _this.getDescription())),
                    Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { style: rowInfoStyle },
                        _this.renderWidgetActions(),
                        _this.renderChangeListIcon()))));
        };
        _this.state = {
            isSelected: false,
        };
        return _this;
    }
    DraggableRowComponent.getDerivedStateFromProps = function (nextProps, prevState) {
        // Handle case where we switch from state `isSelected` to props `isSelected`
        return prevState.isSelected && nextProps.isSelected
            ? {
                isSelected: false,
            }
            : null;
    };
    DraggableRowComponent.prototype.componentDidUpdate = function () {
        if (this.props.touchedId === this.props.id) {
            this.isClicked = false;
        }
    };
    DraggableRowComponent.prototype.renderComponent = function () {
        // I attempted to update the draggableId to see if it fixed some caching, but that doesn't seem to be the case.
        var _a = this.props, index = _a.index, isSelected = _a.isSelected, id = _a.id;
        var draggableClass = "" + (isSelected || this.state.isSelected ? "editor-draggable-item" : "");
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { className: draggableClass },
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["b" /* Draggable */], { key: id, draggableId: id, index: index }, this.renderItem)));
    };
    DraggableRowComponent.prototype.render = function () {
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(DraggableOutsideComponent, { outsideHandler: this.onOutsideDraggableClick, ignoredOutsideClickClassName: this.props.ignoredOutsideClickClassName }, this.renderComponent()));
    };
    DraggableRowComponent.defaultProps = {
        changeIcon: "",
        onRemoveItem: function () { return undefined; },
        onActionClick: function () { return undefined; },
    };
    return DraggableRowComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var labelStyle = {
    fontWeight: 600,
    color: "#c6c6c6",
    fontSize: "14px",
};
var columnStyle = {
    paddingBottom: "10px",
};
var droppableStyle = {
    minHeight: "28px",
};
var DraggableColumnComponent = /** @class */ (function (_super) {
    __extends(DraggableColumnComponent, _super);
    function DraggableColumnComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderItems = function (provided, snapshot) {
            var _a = _this.props, items = _a.items, onDragStart = _a.onDragStart, onRemoveItem = _a.onRemoveItem, onDragCancel = _a.onDragCancel, onActionClick = _a.onActionClick, onDragRelease = _a.onDragRelease, selectedId = _a.selectedId, columnId = _a.columnId, changeIcon = _a.changeIcon, touchedId = _a.touchedId, ignoredOutsideClickClassName = _a.ignoredOutsideClickClassName, _b = _a.draggableWrapperClassName, draggableWrapperClassName = _b === void 0 ? "" : _b;
            var styleCurrent = snapshot.isDraggingOver
                ? __assign({ backgroundColor: "#626262" }, droppableStyle) : __assign({}, droppableStyle);
            return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", __assign({ className: draggableWrapperClassName }, provided.droppableProps, { ref: provided.innerRef, style: styleCurrent }),
                items &&
                    items.map(function (item, index) {
                        var id = item.id, description = item.description, icon = item.icon, actions = item.actions;
                        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(DraggableRowComponent, { key: id, id: id, index: index, description: description, icon: icon, actions: actions, columnId: columnId, onDragSelect: onDragStart, onDragRelease: onDragRelease, onDragCancel: onDragCancel, onRemoveItem: onRemoveItem, onActionClick: onActionClick, isSelected: selectedId && selectedId === id, changeIcon: changeIcon, touchedId: touchedId, ignoredOutsideClickClassName: ignoredOutsideClickClassName }));
                    }),
                provided.placeholder));
        };
        return _this;
    }
    DraggableColumnComponent.prototype.render = function () {
        var _a = this.props, columnId = _a.columnId, label = _a.label;
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { style: columnStyle },
            label && Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { style: labelStyle }, label),
            Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_16_react_beautiful_dnd__["c" /* Droppable */], { droppableId: columnId }, this.renderItems)));
    };
    return DraggableColumnComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var CreatableChangeInputActions;
(function (CreatableChangeInputActions) {
    CreatableChangeInputActions["SET_VALUE"] = "set-value";
    CreatableChangeInputActions["INPUT_CHANGE"] = "input-change";
    CreatableChangeInputActions["INPUT_BLUR"] = "input-blur";
    CreatableChangeInputActions["MENU_CLOSE"] = "menu-close";
})(CreatableChangeInputActions || (CreatableChangeInputActions = {}));
var CreatableChangeActions;
(function (CreatableChangeActions) {
    CreatableChangeActions["CLEAR"] = "clear";
    CreatableChangeActions["CREATE_OPTION"] = "create-option";
    CreatableChangeActions["DESESECT_OPTION"] = "deselect-option";
    CreatableChangeActions["POP_VALUE"] = "pop-value";
    CreatableChangeActions["REMOVE_VALUE"] = "remove-value";
    CreatableChangeActions["SELECT_OPTION"] = "select-option";
    CreatableChangeActions["SET_VALUE"] = "set-value";
})(CreatableChangeActions || (CreatableChangeActions = {}));

/**
 * This function returns clear number string without other symbols
 */
var getNumber = function (inputValue) {
    var parsedValue = inputValue;
    // A JavaScript RegExp object is stateful.
    Constants.POSITIVE_NUMBER_REGEX.lastIndex = 0;
    var numberRegex = Constants.POSITIVE_NUMBER_REGEX;
    var regexResult = numberRegex.exec(parsedValue.toString());
    if (regexResult && regexResult.length > 0) {
        parsedValue = regexResult[0];
    }
    return parsedValue;
};
/**
 * Make creatable select option from value
 */
var toCreatableValue = function (inputValue) {
    return { value: inputValue, label: inputValue };
};
var CreatableSelectComponent = /** @class */ (function (_super) {
    __extends(CreatableSelectComponent, _super);
    function CreatableSelectComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSaveChanges = function (newValue) {
            var onChange = _this.props.onChange;
            var isFocused = _this.state.isFocused;
            onChange(parseFloat(_this.getValue(newValue).toString()));
            // Stop debounce state and update input value and cursor, if under focused right now
            _this.setState({ isDebounce: false }, function () {
                if (isFocused) {
                    _this.handleFocus();
                }
            });
        };
        _this.saveChanges = function (newValue) {
            // Start debouncing
            _this.setState({ isDebounce: true });
            // and call debounced function
            _this.debouncedSave(newValue);
        };
        /**
         * Disable client side filtering by react-select because
         * we want to show all variants to user always
         */
        _this.filterOption = function (_option, _input) {
            return true;
        };
        /**
         * Creatable select option value change (selected from list)
         */
        _this.handleChange = function (newValue, actionMeta) {
            var onChange = _this.props.onChange;
            if (actionMeta.action === CreatableChangeActions.SELECT_OPTION &&
                newValue !== undefined) {
                onChange(parseFloat(_this.getValue(newValue.value).toString()));
            }
        };
        /**
         * Creatable select input value change
         */
        _this.handleInputChange = function (inputValue, actionMeta) {
            var value = _this.state.creatableValue.value;
            if (actionMeta.action === CreatableChangeInputActions.INPUT_CHANGE &&
                inputValue !== undefined) {
                // Clear input string, accept numbers only (ex 31.4)
                var val = _this.getValue(inputValue).toString();
                if (inputValue === "" || inputValue === "0") {
                    // Correctly handle empty value, but not save it (the previous saved val will be used if left)
                    _this.setState({ creatableValue: toCreatableValue(inputValue) });
                    _this.saveChanges(value);
                }
                else if (val === inputValue.toString() || inputValue === "") {
                    // Compare clear and input value strings.
                    // if they have unacceptable difference
                    // If not - changed value is correct
                    // So, save it, and parent cb
                    _this.saveChanges(inputValue);
                    _this.setState({
                        creatableValue: toCreatableValue(inputValue),
                        isDebounce: true,
                    });
                }
                else {
                    // In case values are different
                    // This tricky method is used there, to correct input value
                    // if it contains wrong symbols\charters.
                    // It changes value back, to the last correct saved
                    _this.setState({ creatableValue: toCreatableValue(val) }, function () {
                        return _this.handleFocus();
                    });
                }
            }
        };
        /**
         * This method is used there, to prevent of show the "Create new..." option
         */
        _this.isValidNewOption = function (_inputValue, _selectValue, _selectOptions) {
            return false;
        };
        _this.formatCreateLabel = function (inputValue) {
            return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", null, inputValue);
        };
        /**
         * This basic method is used, for value get
         * Priority: inputValue > state.value > value > defaultValue
         */
        _this.getValue = function (inputValue, strict) {
            var _a = _this.props, defaultValue = _a.defaultValue, value = _a.value;
            var parsedValue = inputValue || (!strict && (inputValue === "" || inputValue === "0"))
                ? inputValue.toString()
                : _this.state
                    ? _this.state.creatableValue.value
                    : value;
            parsedValue =
                parsedValue || (!strict && (parsedValue === "" || parsedValue === "0"))
                    ? parsedValue.toString()
                    : defaultValue.toString();
            return getNumber(parsedValue);
        };
        /**
         * Make input value editable on click hook
         */
        _this.handleFocus = function () {
            var isFocused = _this.state.isFocused;
            if (_this.select) {
                var option = toCreatableValue(_this.getValue());
                var actionMeta = {
                    action: "create-option",
                    option: option,
                };
                _this.select.onChange(option, actionMeta);
                // Set focused state property, if not already set
                if (!isFocused) {
                    _this.setState({ isFocused: true });
                }
            }
        };
        _this.onBlur = function (_event) {
            _this.setState({ isFocused: false });
            _this.verifyValueBeforeExit();
        };
        /**
         * General recommendation for mobile\tablet devices
         */
        _this.handleMenuClose = function () {
            _this.verifyValueBeforeExit();
        };
        /**
         * Change dropdown indicator to the label, if required
         */
        _this.dropdownIndicator = function () { return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", { style: { padding: "8px 12px" } }, _this.props.label)); };
        /**
         * Reset value back, if it's empty or zero
         */
        _this.verifyValueBeforeExit = function () {
            var isDebounce = _this.state.isDebounce;
            var _a = _this.props, onChange = _a.onChange, value = _a.value;
            var actualValue = _this.state.creatableValue.value;
            // Prevent empty value
            if (actualValue === "" || actualValue.toString() === "0") {
                // Use previously saved correct value
                onChange(parseFloat(_this.getValue(value).toString()));
            }
            else if (isDebounce && actualValue) {
                // Save debouncing value immediately, before component will be unmounted
                onChange(parseFloat(_this.getValue(actualValue).toString()));
            }
        };
        // We have own controlled `creatableValue` prop
        // to have a chance control user input, and accept numeric input only
        // also we control the moment when we debouncing the input changes
        // additionally we manage isFocused state for creatable input
        _this.state = {
            creatableValue: toCreatableValue(_this.getValue(null, true)),
            isDebounce: false,
            isFocused: false,
        };
        // Debounce
        _this.debouncedSave = __WEBPACK_IMPORTED_MODULE_6_lodash_debounce___default()(_this.handleSaveChanges, _this.props.debounceDelay);
        return _this;
    }
    CreatableSelectComponent.getDerivedStateFromProps = function (nextProps, prevState) {
        var nextPropsVal = nextProps.value
            ? getNumber(nextProps.value.toString())
            : null;
        // Update state value, if props has been changed and not <debounce> now
        if (nextPropsVal &&
            !prevState.isDebounce &&
            prevState.creatableValue &&
            nextPropsVal !== prevState.creatableValue.value) {
            return { creatableValue: toCreatableValue(nextPropsVal) };
        }
        return null;
    };
    CreatableSelectComponent.prototype.componentWillUnmount = function () {
        this.verifyValueBeforeExit();
        // Prevent memory leak with async setState call
        this.debouncedSave.cancel();
    };
    CreatableSelectComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, defaultValue = _a.defaultValue, label = _a.label, styles = _a.styles, options = _a.options;
        var creatableValue = this.state.creatableValue;
        var components = label
            ? { DropdownIndicator: this.dropdownIndicator, IndicatorSeparator: null }
            : {};
        return (Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_18_react_select_creatable__["a" /* default */], { value: creatableValue, inputValue: creatableValue.value.toString(), defaultValue: toCreatableValue(defaultValue), onChange: this.handleChange, onInputChange: this.handleInputChange, options: options, 
            /* eslint-disable-next-line react/jsx-no-bind */
            ref: function (ref) { return (_this.select = ref); }, blurInputOnSelect: false, onMenuClose: this.handleMenuClose, onFocus: this.handleFocus, isValidNewOption: this.isValidNewOption, formatCreateLabel: this.formatCreateLabel, className: "select-creatable-element", classNamePrefix: "select-creatable", styles: styles, components: components, filterOption: this.filterOption, onBlur: this.onBlur }));
    };
    CreatableSelectComponent.defaultProps = {
        value: 14,
        defaultValue: 14,
        debounceDelay: 500,
        styles: undefined,
        options: [],
    };
    return CreatableSelectComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]));

var Navigator = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n\tpadding: 8px 4px;\n"], ["\n\tpadding: 8px 4px;\n"])));
var Pagination = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\t& > select {\n\t\theight: 28px;\n\t\tflex: 1 1 auto;\n\t\tmargin-left: 6px;\n\t\tmargin-right: 6px;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100%;\n\t& > select {\n\t\theight: 28px;\n\t\tflex: 1 1 auto;\n\t\tmargin-left: 6px;\n\t\tmargin-right: 6px;\n\t}\n"])));
var Divider = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 1px;\n\tbackground: gray;\n\tmargin: 4px 0;\n"], ["\n\twidth: 100%;\n\theight: 1px;\n\tbackground: gray;\n\tmargin: 4px 0;\n"])));
var RowLayout = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 0 8px;\n\t&:not(:last-child) {\n\t\tmargin-bottom: 4px;\n\t}\n"], ["\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\tpadding: 0 8px;\n\t&:not(:last-child) {\n\t\tmargin-bottom: 4px;\n\t}\n"])));
var Thumb = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n\ttext-align: center;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-flow: row nowrap;\n\twidth: 100%;\n"], ["\n\ttext-align: center;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-flow: row nowrap;\n\twidth: 100%;\n"])));
var Styled = {
    Navigator: Navigator,
    Divider: Divider,
    Pagination: Pagination,
    RowLayout: RowLayout,
    Thumb: Thumb,
};
var templateObject_1$8, templateObject_2$7, templateObject_3$6, templateObject_4$6, templateObject_5$3;

var checkShapeInsideArea = function (shapePoints, areaWidth, areaHeight) {
    var x0 = 0;
    var y0 = 0;
    var x1 = areaWidth;
    var y1 = areaHeight;
    var points = __spreadArrays(shapePoints);
    if (points[0] < x0) {
        points[4] = points[6] -= points[0];
        points[0] = points[2] = x0;
    }
    if (points[1] < y0) {
        points[5] = points[3] -= points[1];
        points[1] = points[7] = y0;
    }
    if (points[4] > x1) {
        points[0] = points[2] -= points[4] - x1;
        points[4] = points[6] = x1;
    }
    if (points[5] > y1) {
        points[1] = points[7] -= points[5] - y1;
        points[5] = points[3] = y1;
    }
    return points;
};
var NavigatorComponent = function (props) {
    var _a, _b, _c;
    var pageIdx = props.pageIdx, pages = props.pages, onChangePage = props.onChangePage, color = props.color, onChangeColor = props.onChangeColor, initialIsHighlightColor = props.initialIsHighlightColor, onChangeIsHighlightColor = props.onChangeIsHighlightColor, imageWidth = props.imageWidth, imageHeight = props.imageHeight, hasZoom = props.hasZoom, zoom = props.zoom, zoomFrom = props.zoomFrom, zoomTo = props.zoomTo, _d = props.zoomStyles, zoomStyles = _d === void 0 ? {
        fill: "#8080803d",
        stroke: "red",
        opacity: 1,
        strokeWidth: 1,
    } : _d, onChangeZoom = props.onChangeZoom, previewPosition = props.previewPosition, onChangePreviewPosition = props.onChangePreviewPosition;
    var _e = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialIsHighlightColor), isHighlightColor = _e[0], setIsHighlightColor = _e[1];
    // Pagination
    var canMoveNextPage = pageIdx < pages.length - 1;
    var canMovePrevPage = pageIdx > 0;
    // Image zoom
    var image = __WEBPACK_IMPORTED_MODULE_19_use_image___default()((_a = pages[pageIdx]) === null || _a === void 0 ? void 0 : _a.path)[0];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({ offsetX: 0, offsetY: 0 }), offset = _f[0], setOffset = _f[1];
    var safeSetCurrentPageIdx = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (currentPageIdx) {
        var nextPageIdx = currentPageIdx;
        var firstPage = 0;
        var lastPage = pages.length - 1;
        if (nextPageIdx < firstPage) {
            nextPageIdx = firstPage;
        }
        if (nextPageIdx > lastPage) {
            nextPageIdx = lastPage;
        }
        if (nextPageIdx !== pageIdx) {
            onChangePage(nextPageIdx);
        }
    }, [pageIdx, pages.length, onChangePage]);
    var setCurrentPage = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        return safeSetCurrentPageIdx(event.target.selectedIndex);
    }, [safeSetCurrentPageIdx]);
    var movePrevPage = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        safeSetCurrentPageIdx(pageIdx - 1);
    }, [pageIdx, safeSetCurrentPageIdx]);
    var moveNextPage = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
        safeSetCurrentPageIdx(pageIdx + 1);
    }, [pageIdx, safeSetCurrentPageIdx]);
    var formatZoom = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (value) { return value + "%"; }, []);
    var handleZoomChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        return onChangeZoom(Number(event.target.value));
    }, [onChangeZoom]);
    var handleShapeMoved = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (shapeToChange) {
        var currentOffsetX = offset.offsetX, currentOffsetY = offset.offsetY;
        var safePoints = checkShapeInsideArea(shapeToChange.points, imageWidth, imageHeight);
        var x0 = previewPosition[0], y0 = previewPosition[1];
        var x1 = safePoints[0], y1 = safePoints[1];
        var offsetX = x1 - x0;
        var offsetY = y1 - y0;
        setOffset({
            offsetX: currentOffsetX + offsetX,
            offsetY: currentOffsetY + offsetY,
        });
    }, [previewPosition, offset, imageWidth, imageHeight]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (zoom === zoomFrom) {
            setOffset({
                offsetX: 0,
                offsetY: 0,
            });
        }
    }, [zoom, zoomFrom]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        setOffset({
            offsetX: 0,
            offsetY: 0,
        });
    }, [pageIdx]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        var offsetX = offset.offsetX, offsetY = offset.offsetY;
        var delta = (100 - (zoom - zoomFrom) / ((zoomTo - zoomFrom) / 100) / 2) / 100;
        var midWidth = imageWidth / 2;
        var midHeight = imageHeight / 2;
        var dWidth = midWidth * delta;
        var dHeight = midHeight * delta;
        var points = [
            Math.trunc(midWidth - dWidth + offsetX),
            Math.trunc(midHeight - dHeight + offsetY),
            Math.trunc(midWidth - dWidth + offsetX),
            Math.trunc(midHeight + dHeight + offsetY),
            Math.trunc(midWidth + dWidth + offsetX),
            Math.trunc(midHeight + dHeight + offsetY),
            Math.trunc(midWidth + dWidth + offsetX),
            Math.trunc(midHeight - dHeight + offsetY),
        ];
        var safePoints = checkShapeInsideArea(points, imageWidth, imageHeight);
        onChangePreviewPosition(safePoints);
    }, [offset, zoom, zoomFrom, zoomTo, imageWidth, imageHeight, onChangePreviewPosition]);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        if (onChangeIsHighlightColor) {
            onChangeIsHighlightColor(isHighlightColor);
        }
    }, [isHighlightColor, onChangeIsHighlightColor]);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Styled.Navigator, null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Styled.Thumb, null, hasZoom ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionAreaComponent, { transformMode: "dragOnly", onShapeChanged: handleShapeMoved, shapes: [__assign({ id: "navigatorPreview", points: previewPosition }, zoomStyles)], image: image, scaleIndex: 1, fitImageToStage: true, width: imageWidth, height: imageHeight })) : (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image, { src: (_b = pages[pageIdx]) === null || _b === void 0 ? void 0 : _b.path, width: imageWidth, height: imageHeight }))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Styled.Divider, null),
        hasZoom && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Styled.RowLayout, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Slider, { value: zoom, min: zoomFrom, max: zoomTo, step: 1, disabled: false, showValueOutput: true, formatValueOutput: formatZoom, onChange: handleZoomChange })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Styled.Divider, null))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Styled.RowLayout, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Styled.Pagination, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, { icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "arrow_left" }), onClick: movePrevPage, size: "small", type: "secondary", disabled: !canMovePrevPage }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("select", { value: (_c = pages[pageIdx]) === null || _c === void 0 ? void 0 : _c.id, onChange: setCurrentPage }, pages.map(function (page) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: page.id, value: page.id }, page.name)); })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, { icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "arrow_right" }), onClick: moveNextPage, size: "small", type: "secondary", disabled: !canMoveNextPage }))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Styled.RowLayout, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckBoxComponent, { disabled: false, checked: isHighlightColor, label: "Highlight color:", onChange: setIsHighlightColor }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColorPickerComponent, { color: color, presetColors: [], disableAlpha: true, onChange: onChangeColor }))));
};

var InnerForm = function (props) {
    var options = props.options, values = props.values, setFieldValue = props.setFieldValue;
    function setTarget(value) {
        setFieldValue("target", value);
    }
    function setLightBox(value) {
        setFieldValue("lightBox", value);
    }
    function setLightBoxWidth(value) {
        setFieldValue("lightBoxWidth", value);
    }
    function setLightBoxHeight(value) {
        setFieldValue("lightBoxHeight", value);
    }
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["c" /* Form */], null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "url" }, "URL"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "url", type: "url", placeholder: "http://" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "url" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Form, { target: options.target, values: values, setTarget: setTarget, setLightBox: setLightBox, setLightBoxWidth: setLightBoxWidth, setLightBoxHeight: setLightBoxHeight })));
};
var AutoCommitInnerForm = withAutoCommit(InnerForm);
var ExternalLinkPropertiesFormSchema = Object(__WEBPACK_IMPORTED_MODULE_20_yup__["b" /* object */])().shape({
    url: Object(__WEBPACK_IMPORTED_MODULE_20_yup__["c" /* string */])().url(),
    lightBoxWidth: Object(__WEBPACK_IMPORTED_MODULE_20_yup__["a" /* number */])().min(0),
    lightBoxHeight: Object(__WEBPACK_IMPORTED_MODULE_20_yup__["a" /* number */])().min(0),
});
var ExternalLinkPropertiesForm = function (props) {
    var initialValues = props.initialValues, onSubmit = props.onSubmit;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["d" /* Formik */], { initialValues: initialValues, validationSchema: ExternalLinkPropertiesFormSchema, onSubmit: onSubmit }, function (formProps) { return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCommitInnerForm, __assign({}, props, formProps)); }));
};

var LockTop = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n\theight: 8px;\n\twidth: 12px;\n\tborder-right: 1px solid gray;\n\tborder-top: 1px solid gray;\n\tmargin-left: 3px;\n"], ["\n\theight: 8px;\n\twidth: 12px;\n\tborder-right: 1px solid gray;\n\tborder-top: 1px solid gray;\n\tmargin-left: 3px;\n"])));
var LockBottom = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n\theight: 8px;\n\twidth: 12px;\n\tborder-right: 1px solid gray;\n\tborder-bottom: 1px solid gray;\n\tmargin-left: 3px;\n"], ["\n\theight: 8px;\n\twidth: 12px;\n\tborder-right: 1px solid gray;\n\tborder-bottom: 1px solid gray;\n\tmargin-left: 3px;\n"])));
var templateObject_1$9, templateObject_2$8;

var TooltipType;
(function (TooltipType) {
    /**
     * Text media tooltips shows.
     */
    TooltipType[TooltipType["Text"] = 0] = "Text";
    /**
     * Media tooltips show media (e.g. an image or a SWF) in the tooltip.
     */
    TooltipType[TooltipType["Media"] = 1] = "Media";
})(TooltipType || (TooltipType = {}));
var Stretch;
(function (Stretch) {
    /**
     * No stretch.
     */
    Stretch["None"] = "NONE";
    /**
     * Stretch horizontally. Takes up all horizontal space available.
     */
    Stretch["Horizontal"] = "HORIZONTAL";
    /**
     * Stretch vertically. Takes up all vertical space available.
     */
    Stretch["Vertical"] = "VERTICAL";
    /**
     * Stretch horizontally and vertically. Takes up all space available.
     */
    Stretch["Both"] = "BOTH";
})(Stretch || (Stretch = {}));
var HorizontalAlignment;
(function (HorizontalAlignment) {
    /**
     * No alignment.
     */
    HorizontalAlignment[HorizontalAlignment["None"] = 0] = "None";
    /**
     * Align to the left.
     */
    HorizontalAlignment[HorizontalAlignment["Left"] = 1] = "Left";
    /**
     * Align to the center.
     */
    HorizontalAlignment[HorizontalAlignment["Center"] = 2] = "Center";
    /**
     * Align to the right.
     */
    HorizontalAlignment[HorizontalAlignment["Right"] = 3] = "Right";
})(HorizontalAlignment || (HorizontalAlignment = {}));
var VerticalAlignment;
(function (VerticalAlignment) {
    /**
     * No alignment.
     */
    VerticalAlignment[VerticalAlignment["None"] = 0] = "None";
    /**
     * Align to the top.
     */
    VerticalAlignment[VerticalAlignment["Top"] = 1] = "Top";
    /**
     * Align to the middle.
     */
    VerticalAlignment[VerticalAlignment["Middle"] = 2] = "Middle";
    /**
     * Align to the bottom.
     */
    VerticalAlignment[VerticalAlignment["Bottom"] = 3] = "Bottom";
})(VerticalAlignment || (VerticalAlignment = {}));
var Effect;
(function (Effect) {
    /**
     * No effect.
     */
    Effect[Effect["None"] = 0] = "None";
    /**
     * Fade in the out.
     */
    Effect[Effect["FADE_INOUT"] = 1] = "FADE_INOUT";
    /**
     * Continually fade in and out.
     */
    Effect[Effect["PULSATING"] = 2] = "PULSATING";
    /**
     * Frames the link with a shadow.
     */
    Effect[Effect["SHADOW_FRAME"] = 3] = "SHADOW_FRAME";
    /**
     * Frames the link.
     */
    Effect[Effect["FRAME"] = 4] = "FRAME";
})(Effect || (Effect = {}));

var InnerForm$1 = function (props) {
    var options = props.options, values = props.values, setFieldValue = props.setFieldValue;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), constrainProportion = _a[0], setConstrainProportion = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), spanPages = _b[0], setSpanPages = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(-1), tooltipSuggestedText = _c[0], setTooltipSuggestedText = _c[1];
    // Update number field value since onchange receive number, not event
    var handleNumberChange = function (name) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (value) { return setFieldValue(name, value); }, []);
    };
    // Update select field value
    var handleSelectChange = function (name) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
            return setFieldValue(name, Number(event.currentTarget.options[event.currentTarget.selectedIndex].value));
        }, []);
    };
    var handleSelectHorizontalAlignment = handleSelectChange("horizontalAlignment");
    var handleSelectVerticalAlignment = handleSelectChange("verticalAlignment");
    // Update tooltip options for media and text types
    var handleTooltipSuggestedTextChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        var value = Number(event.currentTarget.options[event.currentTarget.selectedIndex].value);
        var option = options.tooltipSuggestedText.find(function (o) { return o.value === value; });
        setTooltipSuggestedText(Number(option.value));
        // Update tooltip text from suggestion
        setFieldValue("tooltip", option.value === -1 ? "" : option.label);
    }, [options.tooltipSuggestedText]);
    // Update stretch options
    var handleStretchChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        var value = event.currentTarget.options[event.currentTarget.selectedIndex].value;
        var option = options.stretch.find(function (o) { return o.value === value; });
        setFieldValue("stretch", option.value);
        // Update horizontal alignment to default if option is not allowed
        if (option.value === Stretch.Horizontal ||
            option.value === Stretch.Both) {
            setFieldValue("horizontalAlignment", HorizontalAlignment.None);
        }
        // Update vertical alignment to default if option is not allowed
        if (option.value === Stretch.Vertical || option.value === Stretch.Both) {
            setFieldValue("verticalAlignment", VerticalAlignment.None);
        }
    }, [options.stretch]);
    var handleConstrainProportionChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
        if (e) {
            e.preventDefault();
        }
        setConstrainProportion(!constrainProportion);
    }, [constrainProportion]);
    var handleSpanPagesChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        var checked = event.target.checked;
        setSpanPages(checked);
    }, [spanPages]);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["c" /* Form */], null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, { style: { width: "auto" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "width" }, "Width"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "width", as: NumericInputComponent, min: 0, onChange: handleNumberChange("width") })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "width" })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "height" }, "Height"),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "height", as: NumericInputComponent, min: 0, onChange: handleNumberChange("height") })),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "height" }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                    constrainProportion && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LockTop, null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, { icon: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon, { name: "lock" }), onClick: handleConstrainProportionChange, size: "small", shape: "sharp", type: "default" }),
                    constrainProportion && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LockBottom, null))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "y" }, "Top"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "y", as: NumericInputComponent, min: 0, onChange: handleNumberChange("y") })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "y" })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "x" }, "Left"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "x", as: NumericInputComponent, min: 0, onChange: handleNumberChange("x") })),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "x" })))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "tooltipType" }, "Tooltip type"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "tooltipType", as: "select", disabled: false, onChange: handleSelectChange("tooltipType") }, options.tooltipType.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "tooltipType" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "tooltipMediaSource" }, "Media source"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "tooltipMediaSource", as: "select", disabled: !isEqual(props, "tooltipType", TooltipType.Media), onChange: handleSelectChange("tooltipMediaSource") }, options.tooltipMediaSource.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "tooltipMediaSource" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "tooltipMediaTitle" }, "Media title"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "tooltipMediaTitle", type: "text", disabled: !isEqual(props, "tooltipType", TooltipType.Media) })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "tooltipMediaTitle" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "tooltipMediaDescription" }, "Media description"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "tooltipMediaDescription", type: "text", disabled: !isEqual(props, "tooltipType", TooltipType.Media) })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "tooltipMediaDescription" }))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "tooltip" }, "Tooltip text"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "tooltip", type: "text", disabled: !isEqual(props, "tooltipType", TooltipType.Text) })),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "tooltip" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, null, "Select tooltip"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { as: "select", value: tooltipSuggestedText, disabled: !isEqual(props, "tooltipType", TooltipType.Text), onChange: handleTooltipSuggestedTextChange }, options.tooltipSuggestedText.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "effect" }, "Effect"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "effect", as: "select", disabled: false, onChange: handleSelectChange("effect") }, options.effect.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "effect" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "externalSource" }, "External source"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "externalSource", as: "select", disabled: false, onChange: handleSelectChange("externalSource") }, options.externalSource.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "externalSource" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "alpha" }, "Opacity"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "alpha", as: Slider, disabled: false, min: 0, max: 100, step: 1 })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "alpha" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, null, "Span pages"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { type: "checkbox", disabled: false, checked: spanPages, onChange: handleSpanPagesChange }))),
        !!spanPages && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, null, "Page range"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { as: NumericInputComponent, disabled: true, min: 0, max: 100, step: 1, value: values.fromPageNumber }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, "-"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { as: NumericInputComponent, disabled: true, min: 0, max: 100, step: 1, value: values.toPageNumber })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "stretch" }, "Stretch"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "stretch", as: "select", disabled: false, onChange: handleStretchChange }, options.stretch.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "stretch" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "horizontalAlignment" }, "Horizontal Alignment"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "horizontalAlignment", as: "select", disabled: isEqual(props, "stretch", Stretch.Horizontal) ||
                            isEqual(props, "stretch", Stretch.Both), onChange: handleSelectHorizontalAlignment }, options.horizontalAlignment.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "horizontalAlignment" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "verticalAlignment" }, "Vertical Alignment"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "verticalAlignment", as: "select", disabled: isEqual(props, "stretch", Stretch.Vertical) ||
                            isEqual(props, "stretch", Stretch.Both), onChange: handleSelectVerticalAlignment }, options.verticalAlignment.map(function (option) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "verticalAlignment" }))))));
};
var AutoCommitInnerForm$1 = withAutoCommit(InnerForm$1);
var LinkPropertiesFormSchema = Object(__WEBPACK_IMPORTED_MODULE_20_yup__["b" /* object */])().shape({
    width: Object(__WEBPACK_IMPORTED_MODULE_20_yup__["a" /* number */])().min(0),
    height: Object(__WEBPACK_IMPORTED_MODULE_20_yup__["a" /* number */])().min(0),
    x: Object(__WEBPACK_IMPORTED_MODULE_20_yup__["a" /* number */])().min(0),
    y: Object(__WEBPACK_IMPORTED_MODULE_20_yup__["a" /* number */])().min(0),
});
var LinkPropertiesForm = function (props) {
    var initialValues = props.initialValues, values = props.values, onSubmit = props.onSubmit;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["d" /* Formik */], { initialValues: initialValues, validationSchema: LinkPropertiesFormSchema, onSubmit: onSubmit }, function (formProps) {
        var setValues = formProps.setValues;
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
            if (values) {
                setValues(values, false);
            }
        }, [values]);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCommitInnerForm$1, __assign({}, props, formProps));
    }));
};

var FieldActions = __WEBPACK_IMPORTED_MODULE_5__emotion_styled__["a" /* default */].div(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n\tmargin-left: 4px;\n"], ["\n\tmargin-left: 4px;\n"])));
var templateObject_1$a;

var Form$4 = function (props) {
    var values = props.values, setFieldValue = props.setFieldValue, searchProduct = props.searchProduct, searchingProduct = props.searchingProduct;
    // Update number field value since onchange receive number, not event
    var handleNumberChange = function (name) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (value) { return setFieldValue(name, value); }, []);
    };
    var handleChangeHasProduct = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        var checked = event.target.checked;
        setFieldValue("useProductDatabase", !checked);
        setFieldValue("hasProduct", checked);
    }, []);
    var handleChangeUseProductDatabase = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
        var checked = event.target.checked;
        setFieldValue("useProductDatabase", checked);
        setFieldValue("hasProduct", !checked);
    }, []);
    var handleSearchProduct = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
        if (e) {
            e.preventDefault();
        }
        searchProduct(values.magid, values.productID);
    }, [searchProduct, values.magid, values.productID]);
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["c" /* Form */], null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, null, "Product source"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Group, null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RadioComponent, { id: "hasProduct", name: "hasProduct", label: "Manual", disabled: false, checked: values.hasProduct, onChange: handleChangeHasProduct }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RadioComponent, { id: "useProductDatabase", name: "useProductDatabase", label: "Product database", disabled: false, checked: values.useProductDatabase, onChange: handleChangeUseProductDatabase })))),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "productID" }, "Product ID"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "productID", type: "text", disabled: false })),
            values.useProductDatabase && (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldActions, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button, { onClick: handleSearchProduct, size: "small", shape: "sharp", type: "default", label: searchingProduct ? "Searching..." : "Search", disabled: !values.productID }))),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "productID" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "itemName" }, "Product name"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "itemName", type: "text", disabled: values.useProductDatabase })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "itemName" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "description" }, "Product description"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "description", type: "text", disabled: values.useProductDatabase })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "description" })),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FieldWrapper, null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label, { htmlFor: "price" }, "Product price"),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Field, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["b" /* Field */], { name: "price", as: NumericInputComponent, min: 0, disabled: values.useProductDatabase, onChange: handleNumberChange("price") })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["a" /* ErrorMessage */], { name: "price" }))));
};

var AutoCommitForm$1 = withAutoCommit(Form$4);
var ProductLinkPropertiesForm = function (props) {
    var initialValues = props.initialValues, values = props.values, onSubmit = props.onSubmit;
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_formik__["d" /* Formik */], { initialValues: initialValues, onSubmit: onSubmit }, function (formProps) {
        var setValues = formProps.setValues;
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
            if (values) {
                setValues(values, false);
            }
        }, [values]);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AutoCommitForm$1, __assign({}, props, formProps));
    }));
};


//# sourceMappingURL=index.js.map


/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_serialize__ = __webpack_require__(621);


function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__emotion_serialize__["a" /* serializeStyles */])(args);
}

/* harmony default export */ __webpack_exports__["a"] = (css);


/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(147);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(2246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(635);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(2275);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(443),
    getRawTag = __webpack_require__(2381),
    objectToString = __webpack_require__(2382);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(652),
    isLength = __webpack_require__(657);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getComputedStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(167);

function getComputedStyle(element) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element).getComputedStyle(element);
}

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);

function inherits(ctor, superCtor, spec) {
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(ctor.prototype, spec);
}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        _ = __webpack_require__(1),
        BreakpointGroup = __webpack_require__(97),
        LocalizationGroup = __webpack_require__(232),
        ExperienceModel = __webpack_require__(58),
        ImageModel = __webpack_require__(258),
        Channel = __webpack_require__(233);

    /**
     * @type {Object}
     * The currently supported asset types.
     */
    var Type = {
        BREAKPOINTGROUP: "BreakpointGroup",
        LOCALIZATIONGROUP: "LocalizationGroup",
        EXPERIENCE: "Experience",
        IMAGE: "Image",
        CHANNEL: "Channel"
    };

    /**
     * @private @type {Map.<Function, String>}
     * Mapped constructor functions to asset types.
     */
    var types = new Map();

    types.set(BreakpointGroup, Type.BREAKPOINTGROUP);
    types.set(LocalizationGroup, Type.LOCALIZATIONGROUP);
    types.set(ExperienceModel, Type.EXPERIENCE);
    types.set(ImageModel, Type.IMAGE);
    types.set(Channel, Type.CHANNEL);

    /**
     * A project asset - consisting of an id and a type identifier.
     *
     * @class ProjectAsset
     * @constructor
     */
    var ProjectAsset = Backbone.Model.extend("Project Asset", {

        idAttribute: "resourceId",

        defaults: {

            /**
             * @type {String}
             * The asset ID.
             */
            resourceId: null,

            /**
             * @type {String}
             * The asset type, e.g. <tt>Experience</tt>.
             */
            resourceType: null
        }

    }, {
        Type: Type,

        /**
         * Whether the specified type is a valid asset type.
         *
         * @param  {String} type The asset type.
         * @return {Boolean}     <tt>true</tt> if the specified asset type is valid, i.e. one
         * of the <tt>Type.XXX</tt> constants values.
         */
        validType: function validType(type) {
            return _.contains(Type, type);
        },

        /**
         * Returns the asset type for the supplied model, or undefined if unknown.
         *
         * @param  {ImprovedModel|ImprovedModel[]|Backbone-} model The model entity to find the asset type for, e.g.
         *                                                         an <tt>ExperienceModel</tt> instance; cannot be falsey.
         * @return {String} The asset type (as a constant from <tt>ProjectAsset.TYPE</tt>, or undefined if
         *                  <tt>model</tt> is not a model doubling as an asset.
         * @throw  Error If <tt>model</tt> is not a valid type, including if falsey.
         */
        typeFromModel: function typeFromModel(model) {
            return types.get(model.constructor);
        },

        /**
         * Returns a new asset instance describing the supplied model, if possible. <p>
         *
         * If <tt>model</tt> is not a type that can be described as an asset, null will be returned. If <tt>model</tt>
         * does not have an id, or a temp id for non-saved identifiable types, null will be returned.
         *
         * @param {ImprovedModel|ImprovedModel[]|Backbone-} model The model to describe as a project asset; cannot
         *                                                        be falsey.
         * @return {ProjectAsset} A project asset describing <tt>model</tt>, or null if it cannot be represented as
         *                        an asset.
         * @throw  Error If <tt>model</tt> is not a valid type, including if falsey.
         */
        asAsset: function asAsset(model) {
            var id = model.identifier(),
                // also handles unsaved models...
            type = ProjectAsset.typeFromModel(model);

            return id && type ? new ProjectAsset({ resourceId: id, resourceType: type }) : null;
        },

        /**
         * Normalize the model when handling project model and project assets.
         * @param {ProjectModel | ProjectModel[] | ProjectAsset | ProjectAsset[]} modelOrAsset An array or single project model or project asset..
         * @returns {ProjectModel[] | ProjectAsset[]} An array of project models or project assets.
         */
        toArray: function toArray(modelOrAsset) {
            if (_.isArray(modelOrAsset)) {
                return modelOrAsset;
            }

            if (_.isArray(modelOrAsset.models)) {
                return modelOrAsset.models;
            }

            return [modelOrAsset];
        }
    });

    return ProjectAsset;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var format = __webpack_require__(464);

    var PATCHED = "__zmagsPatched";

    // Return a new patched function...
    var patch = function patch(name, fn) {
        // Reuse already patched function, if so, for consistency...
        if (fn[PATCHED]) {
            return fn;
        }

        var f = function f() {
            return fn.apply(this, [this].concat(Array.prototype.slice.call(arguments))); // patch convention: use "this" as first argument
        };

        f[PATCHED] = name;

        return f;
    };

    /**
     * Standalone util functions that requires some form of polyfill or another, separate from <tt>Context</tt>
     * to avoid circular dependencies, but only for those functions we know to be a problem for some client/browser
     * combination!
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    var util = {

        /**
         * The global (window) sandbox we operate in, e.g. where channels are located, global hooks,
         * active snippets, etc. Always required to handle multiple snippet inclusions and for legacy browsers
         * requiring our custom Sizzle. <p>
         *
         * Optionally, a <i>path</i> to look up a reference in the sandbox can be specified, e.g.
         * <tt>sandbox("app")</tt> to return the <tt>app</tt> reference from the sandbox, if available. <p>
         *
         * All properties/values under this scope are considered read-only. <p>
         *
         * Based on the supplied window, the path is <tt>window.__zmags.channels</tt> (setup when called),
         * and will (may) store:
         *
         * <pre>
         * {
         *     channels: {
         *         app: {                 // singleton, even across scripts!
         *             start:   Function, // fn(configId:String)
         *             stop:    Function, // fn(configId:String)
         *             log:     Function, // fn(configId:String, level:Number|String) or fn(level:Number|String)
         *             destroy: Function  // stops all, and removes "app"
         *         },
         *         snippets: Snippet.proxy[]  // all current snippets for this app
         *         active:   Channel.proxy[]  // current displayed experiences via channels
         *         sizzle:   Function         // custom Zmags Sizzle implementation for legacy browsers
         *         configs: {
         *             configId -> Channel[], // For customers using the "Channels" bundle strategy, the channel
         *             ..                     // configuration will be exposed in the sandbox under the channel config
         *         }                          // id, defined in the script returned by the backend.
         *     }
         * }
         * <pre>
         *
         * In addition, <tt>__zmags.channels.add(..)</tt> can be used to add channels directly as by calling
         * <tt>app.add(..)</tt>.
         *
         * @param  {String|Window} [path] Optional path to find under the sandbox, e.g. "app" or "app.start"; can be falsey.
         *                                If the path cannot be found, falsey will be returned. Any function found as
         *                                part of the path is executed with no arguments, use the result to continue down
         *                                the path. If the path is omitted, can also represent the <tt>win/tt> argument.
         * @param  {Window}        [win]  The window to access; defaults to the current <tt>window</tt> scope. If
         *                                the <tt>path</tt> argument is omitted, this can be supplied as the first
         *                                argument as well.
         *
         * @return {*} The channel sandbox, optional for the specified path; never falsey if no path, i.e. sandbox will
         *             be created if not already available, but can be falsey if the path does not exist.
         */
        sandbox: function sandbox(path, win) {
            if (arguments.length && typeof path !== "string") {
                win = path;
                path = null;
            }

            win = win || window;

            // Always create sandbox itself it does not exist...
            var sandbox = win.__zmags || (win.__zmags = {});
            sandbox.channels = sandbox.channels || {};

            var scope = sandbox.channels,
                parts,
                i;

            // Loop up specific path, e.g. "app"?
            if (path) {
                parts = path.split(".");
                for (i = 0; i < parts.length; i++) {
                    scope = scope[parts[i]];
                    if (typeof scope === "function") {
                        scope = scope();
                    }

                    // eslint-disable-next-line eqeqeq
                    if (scope == null) {
                        return; // undefined
                    }
                }
            }

            return scope;
        },

        /**
         * Returns true if the supplied function is native, false if it has been overridden. <p>
         *
         * This does not cover all cases, e.g. constructors and non-function arguments, but it suffices for
         * our needs.
         *
         * @param {Function} f The function to check whether it is is native or not, e.g.
         *                     <tt>Array.prototype.indexOf</tt>; can be falsey, in which case false is returned.
         * @return {Boolean} True if <tt>f</tt> is considered native, false otherwise.
         * @see #patchOverriddenNativeFunctions
         */
        isNative: function isNative(f) {
            // Cannot test for "function" type here, as old IE will give "object" for window and DOM functions...
            return f && !("prototype" in f);
        },

        /**
         * Parses the specified value into an int, defaulting to <tt>defaultValue</tt> if not a number, secondarily
         * zero.
         *
         * @param {*}  value         The value to parse into an int; can be null/undefined, will default to
         *                           <tt>defaultValue</tt>.
         * @param {*} [defaultValue] The default value to parse into an int if <tt>value</tt> cannot be parsed to
         *                           a number; will default to zero.
         * @return {Number} The corresponding int value (based on 10 radix), defaulting to <tt>defaultValue</tt>,
         *                  defaulting to zero.
         */
        int: function int(value, defaultValue) {
            return parseInt(value, 10) || parseInt(defaultValue, 10) || 0;
        },

        /**
         * Returns a boolean value for the specified value. <p>
         *
         * Any boolean value will simply be returned. Null or undefined yields false. A number different from zero (0)
         * will return true. The string "true" will return true. Any other values will return false.
         *
         * @param {*}  value         The value to parse into an boolean; can be null/undefined, which will cause
         *                           false to be returned.
         * @return {Boolean} The corresponding boolean value.
         */
        boolean: function boolean(value) {
            // eslint-disable-next-line eqeqeq
            if (value == null) {
                return false;
            }

            var type = typeof value === "undefined" ? "undefined" : _typeof(value);
            if (type === "boolean") {
                return value;
            } else if (type === "number") {
                return value !== 0;
            }
            value = value.toString();
            return value === "true";
        },

        /**
         * Returns a specified time in ms based on <tt>time</tt>, secondarily <tt>defaultTime</tt> if <tt>time</tt>
         * is undefined or not parseable to a number. <p>
         *
         * The returned time will always be coerced to a non-negative number.
         *
         * @param {*}  time         The time to parse into an ms number; can be null/undefined, in which case it
         *                          will default to <tt>defaultTime</tt>, but will not default if zero. In it cannot
         *                          be parsed to a number, it will default to zero.
         * @param {*} [defaultTime] The default time to parse into an ms number if <tt>time</tt> cannot be parsed to
         *                          a number; will default to zero.
         * @return {Number} The corresponding non-negative time value in ms (based on 10 radix), defaulting to
         *                  <tt>defaultTime</tt>, defaulting to zero.
         */
        time: function time(_time, defaultTime) {
            var t;
            // "time" can be null in admin mode, or undefined in viewer...
            // eslint-disable-next-line eqeqeq
            if (_time != null) {
                t = parseInt(_time, 10); // cannot use util.int since it will eventually default to zero!
            }

            // If still not a valid time, we must default to zero only here...
            if (isNaN(t)) {
                t = parseInt(defaultTime, 10) || 0;
            }
            return Math.abs(t);
        },

        /**
         * Returns the trimmed version of the specified string.
         *
         * @param  {String} s The string to trim; cannot be null.
         * @return {String} The trimmed version; never null, but can be the empty string.
         */
        trim: function trim(s) {
            return typeof s.trim === "function" ? s.trim() : s.replace(/^\s+|\s+$/g, "");
        },

        /**
         * Returns the trimmed camelCased version of <tt>name</tt>, e.g. " foo" -> "foo", "foo-bar " -> "fooBar".
         *
         * @param  {String} name The name to camelCase; cannot be null/undefined..
         * @return {String} The camelCased trimmed version of <tt>name</tt>; never falsey.
         */
        camelCase: function camelCase(name) {
            return util.trim(name).replace(/(-([a-z]){1})/g, function () {
                // e.g. foo-bar -> fooBar
                return arguments[2].toUpperCase();
            });
        },

        /**
         * Parses options in string form like "auto:js", "background-color=#fff,color", or "zmagsLog=3&foo=&bar=foo"
         * into a JS options, here respectively {auto: "", js: ""}, {backgroundColor: "#ff", color: ""}, and
         * {zmagsLog: "3", foo: "", bar: "foo"}. <p>
         *
         * (name,value) pairs are always divided by an equals char (=), but the delimiter between different pairs
         * can be specified, defaulting to semi-colon. A pair with an empty value will still be included in
         * the returned options, e.g. "foo=", but a pair with an empty name will be ignored, e.g. "=foo". <p>
         *
         * Any dash (-) separated option will be camelCased in the returned options, e.g. "background-color" becomes
         * "backgroundColor".
         *
         * @param {String|*}      opts          The options to parse; if not a string, it will simply be returned,
         *                                      without any kind of processing though defaulting to the empty object
         *                                      if falsey. Can be a falsey string in which case {} is returned.
         * @param {String|RegExp} [delimiter]   The delimiter to spilt <tt>opts</tt> into (name,value) pairs to be split
         *                                      again on = always; defaults to a semi-colon, i.e. ";".
         * @param {String}        [defaultName] An optional default name a single non-delimited token as a option value as
         *                                      opposed to the default behaviour of a name. By default, if <tt>options</tt>
         *                                      is simply "foo", it will be treated as {foo: ""}, but if <tt>defaultName</tt>
         *                                      is supplied as "bar", this will instead yield {bar: "foo"}.
         *
         *
         * @return {*} The parsed options; never falsey.
         * @see    #camelCase
         */
        options: function options(opts, delimiter, defaultName) {
            if (typeof opts !== "string") {
                return opts || {};
            }

            var options = {},
                pairs,
                pair,
                name,
                n,
                i;

            if (opts) {
                pairs = opts.toString().split(delimiter || ";");
                n = pairs.length;
                for (i = 0; i < n; i++) {
                    pair = pairs[i].split("=", 2);
                    // Special case: could be single value supplied as the name, e.g. "spinner" meaning
                    // {type: "spinner"}, but it could also be a single actual name, e.g {auto: ""}, so
                    // we have to let the calling context decide this based on whether they supplied
                    // a default name or not...
                    if (n === 1 && pair.length === 1 && defaultName) {
                        pair.unshift(defaultName);
                    }
                    name = util.camelCase(pair[0]);
                    if (name) {
                        options[name] = pair[1];
                    }
                }
            }
            return options;
        },

        /**
         * Returns an array of the names of the native functions that has been overridden for the specified types,
         * if any. For any such function, we will try and patch it if we have a patch available. However, crazy
         * client code can unfortunately still wreck it again, e.g. if the client code is executed (again) later.
         *
         * @return {[]} An array of the names of the native functions overridden for the specified (defaulted) types,
         *              if any; never falsey, but can (hopefully) be empty.
         * @see #isNative
         */
        patchOverriddenNativeFunctions: function patchOverriddenNativeFunctions() {
            // TODO: use Kim's suggestion using new iframe to supply the implementations
            var overridden = [],
                entry,
                proto,
                qualifiedName,
                name,
                fn,
                i;

            for (name in NATIVE_FUNCTIONS) {
                if (NATIVE_FUNCTIONS.hasOwnProperty(name)) {
                    entry = NATIVE_FUNCTIONS[name];
                    proto = entry.type.prototype;

                    for (i = 0; i < entry.functions.length; i++) {
                        fn = entry.functions[i];

                        if (typeof fn === "string") {
                            fn = { name: fn }; // no patch
                        }

                        // Re-patch our patches to ensure we for example will trace this via the channel admin
                        // error logger...
                        if (!util.isNative(proto[fn.name])) {
                            qualifiedName = name + "." + fn.name;
                            // Do we have a patch? We must set in on the prototype as third party libraries used by
                            // us (and others) is likely already broken...
                            if (fn.patch) {
                                proto[fn.name] = patch(qualifiedName, fn.patch);
                                qualifiedName += ":patched";
                            }

                            overridden.push(qualifiedName);
                        }
                    }
                }
            }

            return overridden;
        },

        /**
         * Returns the current timestamp in milliseconds since the epoch. Date.now is not supported
         * by IE 8.
         *
         * @return {Number} The current timestamp in ms.
         */
        now: Date.now || function () {
            return new Date().getTime();
        },

        /**
         * Returns the index of the specified element in the supplied string or array using the === operator, or returns
         * -1 otherwise.
         *
         * @param {String|[]} source   The string or array to search; can be false, in which case falsey is returned.
         * @param {*}         value    The value to find in <tt>source</tt> based on ===; can be any value, including
         *                             null/undefined for arrays.
         * @param {Number}    [offset] The offset to start from, if any. Defaults to zero.
         * @return {Number} The index of <tt>value</tt> in <tt>source</tt> based on the === operator, or -1 if not
         *                  found.
         */
        idx: function idx(source, value, offset) {
            if (source) {
                if (util.isNative(source.indexOf) && typeof source.indexOf === "function") {
                    return source.indexOf(value, offset || 0);

                    // String where we do not have a native "indexOf" function, so we take advantage of regular expressions...
                } else if (typeof source === "string" && value) {
                    // We have to escape special characters: http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
                    var regex = new RegExp(value.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&"), "g"),
                        match;

                    if (offset) {
                        regex.lastIndex = offset;
                    }
                    match = regex.exec(source);
                    if (match) {
                        return match.index;
                    }
                    // Fall-through

                    // Array in legacy browsers or where we do not have a native "indexOf" function...
                } else {
                    var i;
                    for (i = offset || 0; i < source.length; i++) {
                        if (source[i] === value) {
                            return i;
                        }
                    }
                    // Fall-through
                }
            }

            return -1;
        },

        /**
         * @private @type {Number}
         * A multiplier to multiply to any (indirect) <tt>defer(..)</tt> call, which by default is 1. It
         * does <b>not</b> affect cache timeouts and the likes. <p>
         *
         * On alternate urls, like Google Cache or Microsoft Translate, this factor will be increased to
         * handle such slower services. <p>
         *
         * On mobile connections, the factor will be further doubled to handle potentially slow mobile
         * network connections.
         *
         * Timeouts of zero will thus always remain zero.
         */
        _deferMultiplier: 1, // defined publicly because of circular references to "global".

        /**
         * Get/sets the defer multiplier. <p>
         *
         * If <tt>multiplier</tt> is specified, it is the factor to be multiplied onto the existing defer multiplier.
         *
         * @param {Number} [multiplier] The multiplier to multiply against the current defer multiplier (initially 1);
         *                              if not specified, the existing defer multiplier is returned. A value of zero
         *                              will reset the default multiplier (to 1).
         *
         * @return {Number} The (perhaps updated) defer multiplier used; default is 1.
         * @see    #defer
         */
        deferMultiplier: function deferMultiplier(multiplier) {
            if (arguments.length) {
                util._deferMultiplier = util._deferMultiplier * multiplier || 1;
            }
            return util._deferMultiplier;
        },

        /**
         * Calls the scope function in a deferred (asynchronous) manner.
         *
         * @param  {Function} fn        The no-arg scoped function to call deferred; never null.
         * @param  {Number}   [timeout] The deferred timeout in ms, defaults to 0. If on an alternate url, e.g.
         *                              Google Cache or Microsoft Translate, the timeout may be multiplied by the
         *                              specific multiplier set via <tt>util.deferMultiplier()</tt> to handle such
         *                              slower services (so zero remains zero always).
         *
         * @return {{timer:Number, timeout:Number}} A handle for the created timer, tagged with the actual timeout
         *         used; never falsey. To clear the timer, simply call <tt>util.defer(timer)</tt>.
         *
         * @see    #deferMultiplier
         */
        defer: function defer(fn, timeout) {
            timeout = (timeout || 0) * util._deferMultiplier;
            return {
                timer: setTimeout(fn, timeout),
                timeout: timeout,
                toString: function toString() {
                    return "" + timeout;
                }
            };
        },

        /**
         * Clears the specifier timer handle for a deferred function obtained via <tt>defer</tt>.
         *
         * @param  {{timer:Number, timeout:Number}} timer The handle for the deferred timeout to clear, previously
         *         obtained from <tt>util.defer(..)</tt>; if falsey, or no <tt>timer.timer</tt> property, this function
         *         is a no-op. Will delete the <tt>timer.timer</tt> property on successful clearing.
         */
        clearDefer: function clearDefer(timer) {
            if (timer && timer.timer) {
                clearTimeout(timer.timer);
                delete timer.timer;
            }
        },

        /**
         * Returns a function wrapping the specified function, <tt>fn</tt>, that when called with ever only invoke
         * <tt>fn</tt> one time. In addition, a timer is started to notify about failure to call <tt>fn</tt> within
         * the configured time span in ms.
         *
         * @param  {Log}      log       The log to use; never null.
         * @param  {String}   name      The logical name of the <tt>fn</tt>, used for logging only.
         * @param  {Function} fn        The function to call at most one time; cannot be null. The function is assumed to
         *                              be scoped and will be called without any arguments.
         * @param  {Number}   [timeout] The timeout in ms to raise an error if not called. Defaults to 10s. If negative,
         *                              <tt>fn</tt> will be executed on timeout with no args (if so, be sure to use a
         *                              high timeout as it may conflict with slow network connections otherwise).
         *                              If on an alternate url, e.g. Google Cache or Microsoft Translate, the timeout
         *                              will be multiplied by the factor set via <tt>util.deferMultiplier()</tt> to
         *                              handle slower services.
         * @return {Function} A new function that will call <tt>fn</tt> at most one time the supplied argument(s), e.g.
         *                    an <tt>Event</tt>. The returned function has a <tt>clear()</tt> function that will clear
         *                    the timeout check, for example in case of an appropriate errback being invoked instead by
         *                    some context.
         */
        one: function one(log, name, fn, timeout) {
            timeout = timeout || 10000;
            var invoked = false,
                execute = false,
                timer,
                _f;

            if (timeout < 0) {
                execute = true;
                timeout = -timeout;
            }
            _f = function f() {
                if (!invoked) {
                    invoked = true;
                    _f.clear();
                    // 0 or 1 arguments is the standard use-case...
                    switch (arguments.length) {
                        case 0:
                            return fn();
                        case 1:
                            return fn(arguments[0]);
                        default:
                            return fn.apply(fn, Array.prototype.slice.call(arguments));
                    }
                }
            };
            _f.clear = function () {
                if (timer) {
                    util.clearDefer(timer);
                    timer = null;
                }
            };

            // Start timer...
            timer = util.defer(function () {
                if (!invoked) {
                    log.error("One-time function not called within ", timer, " ms: ", format.val(name), execute ? " -> calling it now!" : "");
                    if (execute) {
                        _f();
                    }
                }
            }, timeout);

            return _f;
        }

    };

    /**
     * The native functions we test to see if overridden (badly) by a client site, typically in browsers running
     * old JS versions, e.g. where Arrays does not have an "indexOf" function. Worse, client sites may include all
     * kinds of scripts that define/override such functions, we have to test to see if this is the case as it
     * is bound to give us trouble. There are many other functions, of course, but we only test here for a somewhat
     * meaningful subset we know can cause trouble for our supported browser matrix.
     */
    var NATIVE_FUNCTIONS = {
        "array": {
            type: Array,
            functions: [{ name: "indexOf", patch: util.idx }, "lastIndexOf", "slice"]
        },
        "string": {
            type: String,
            functions: [{ name: "indexOf", patch: util.idx }, "lastIndexOf", "trim"]
        },
        "function": {
            type: Function,
            functions: ["bind"]
        }
    };

    return util;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    return {
        GROUP: "GROUP",
        EXPERIENCE: "EXPERIENCE"
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scope__ = __webpack_require__(1249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hub__ = __webpack_require__(3167);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["c"]; });
/* unused harmony reexport getMainCarrier */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["d"]; });
/* unused harmony reexport setHubOnCarrier */


//# sourceMappingURL=index.js.map

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isError;
/* harmony export (immutable) */ __webpack_exports__["e"] = isErrorEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDOMError;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDOMException;
/* harmony export (immutable) */ __webpack_exports__["k"] = isString;
/* harmony export (immutable) */ __webpack_exports__["i"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["h"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["f"] = isEvent;
/* harmony export (immutable) */ __webpack_exports__["c"] = isElement;
/* harmony export (immutable) */ __webpack_exports__["j"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["m"] = isThenable;
/* harmony export (immutable) */ __webpack_exports__["l"] = isSyntheticEvent;
/* harmony export (immutable) */ __webpack_exports__["g"] = isInstanceOf;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // tslint:disable:no-unsafe-any
    return Boolean(wat && wat.then && typeof wat.then === 'function');
    // tslint:enable:no-unsafe-any
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    // tslint:disable-next-line:no-unsafe-any
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
//# sourceMappingURL=is.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(730);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1274);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(474);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toPrimitive = __webpack_require__(1278);

// https://ecma-international.org/ecma-262/6.0/#sec-toprimitive

module.exports = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return toPrimitive(input, arguments[1]);
	}
	return toPrimitive(input);
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(474);

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $abs = GetIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function abs(x) {
	return $abs(x);
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var has = __webpack_require__(114);
var $TypeError = GetIntrinsic('%TypeError%');

module.exports = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

	for (var key in Desc) { // eslint-disable-line no-restricted-syntax
		if (has(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(114);

var isMatchRecord = __webpack_require__(1290);

var predicates = {
	// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Desc) {
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	},
	// https://262.ecma-international.org/13.0/#sec-match-records
	'Match Record': isMatchRecord
};

module.exports = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError('unknown record type: ' + recordType);
	}
	if (Type(value) !== 'Object' || !predicate(value)) {
		throw new $TypeError(argumentName + ' must be a ' + recordType);
	}
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $preventExtensions = GetIntrinsic('%Object.preventExtensions%', true);
var $isExtensible = GetIntrinsic('%Object.isExtensible%', true);

var isPrimitive = __webpack_require__(734);

// https://ecma-international.org/ecma-262/6.0/#sec-isextensible-o

module.exports = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) {
		return !isPrimitive(obj);
	};


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Configuration", function() { return Configuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);


var Environments = __webpack_require__(1379);
// This should reflect what is set in the webpack config by DefinePlugin.
var _a = Object({"NODE_ENV":"production","APP_CONFIG":{"env":"PROD","cncViewFullBaseUrl":"https://cnc-api.zmags.com/view/full/","cncViewLiteBaseUrl":"https://cnc-api.zmags.com/view/lite/","psdImportBaseUrl":"https://design-file-import.creator-prod.zmags.com","behaviorUiBaseUrl":"https://behaviors.zmags.com","creatorSettingApiBaseUrl":"https://creator-settings.api.zmags.com","c3ApibaseUrl":"https://contentcontrol.api.zmags.com","adminApiBaseUrl":"https://creator-api.zmags.com","editorBaseUrl":"//creator.zmags.com","viewerBaseUrl":"//c.zmags.com","viewerApiBaseUrl":"//c.zmags.com","cncStaticAssetsBaseUrl":"//c.zmags.com/static/","cncStaticAssetsFiles":["client.js","manifest.js","vendor.js","styles.css"],"cncSsrApiBaseUrl":"//c.zmags.com","viewerAliasApiBaseUrl":"//creator.zmags.com","communityBaseUrl":"https://creatorcommunity.zmags.com","errorQueueUrl":"https://c.zmags.com/queue/error/","statsDUrl":"https://statsd.zmags.com/stats","auth0Domain":"https://zmags.us.auth0.com","auth0Audience":"https://api.zmags.com/","auth0ClientId":"XGTeepJiX2c78VRgP8OFxN0Mf4kggvby","ometriaApiUrl":"https://ometria.api.zmags.com/v1/email/generate","klaviyoApiUrl":"https://klaviyo.api.zmags.com/v1/email/generate","sfmcApiUrl":"https://sfmc.api.zmags.com/v1/email/generate","cloudinaryProviderUrl":"https://images.creator-prod.zmags.com/image/upload","salesEmail":"sales@zmags.com","supportEmail":"support@zmags.com","editorSegmentIOKey":"20jbiv8frx","matomoConfig":{"trackingScriptUrl":"//c.z-analytics.net/reporting/optimize/ztracker.js","trackerUrl":"","dashboardUrl":"//auth.reporting.creator-prod.zmags.com","segmentUrl":"//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php","siteID":1},"zsitesConfig":"//auth.reporting.creator-prod.zmags.com/","zsitesSecret":"zM4gzS3cr3t","inventoryUrl":"https://authproxy.creator-prod.zmags.com/inventory/v1/products/map","answerFileUrl":"https://static.inventory.creator-prod.zmags.com/dynamic_pricing/answer_files/","experienceUrl2PngBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/experience/signed/url2png/","experienceSharedEntityBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/sharedEntity/","msExperiencesUrl":"https://authproxy.creator-prod.zmags.com/experiences","microserviceCompanyUrl":"https://authproxy.creator-prod.zmags.com/company/","proxyUrl":"https://authproxy.creator-prod.zmags.com","forgotPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","resetPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","changePasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithTokenBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithSsoBaseUrl":"https://authproxy.creator-prod.zmags.com","loginActiveDirectoryBaseUrl":"https://creator-api.zmags.com","googleWebFontsApiBaseUrl":"https://www.googleapis.com/webfonts/v1/webfonts","googleWebFontsApiKey":"AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI","casUrl":"https://cas.zma.gs/","contentControlUrl":"https://manage.creatorbyzmags.com/","enableLogging":1,"logId":null,"trackErrors":true,"sentryEnabled":true,"sentryDSN":"https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460","experienceId":null,"groupId":null,"scene":null,"statsDBucket":"creator.prod","version":"livadug4","maxRetries":3},"VERSION_DATA":{"hash":"d470bd93f6","numCommits":32725,"buildDate":1686721411191,"dirty":false,"name":"creator"}}), APP_CONFIG = _a.APP_CONFIG, NODE_ENV = _a.NODE_ENV, PORT = _a.PORT, TARGET_ENV = _a.TARGET_ENV;
var providedConfig = typeof APP_CONFIG === "string" ? JSON.parse(APP_CONFIG) : APP_CONFIG;
// FIXME FIND BETTER SOLUTION
var findQueryParameter = function (url, name) {
    // window.location.search can very well be empty...
    if (url) {
        var names = Array.isArray(name) ? name : [name];
        var parameters = url.slice(url.indexOf("?") + 1).split("&");
        var pair = void 0;
        var i = void 0;
        var j = void 0;
        for (j = 0; j < names.length; j++) {
            name = names[j];
            for (i = 0; i < parameters.length; i++) {
                pair = parameters[i].split("=");
                if (pair[0] === name) {
                    return pair[1]; // can be empty!
                }
            }
        }
    }
    return undefined;
};
/**
 * Default converters from actual type to desired type, e.g. "number('42', 'string') -> 42.
 */
var converters = {
    string: function (value, type) {
        return type === "undefined" ? "" : value.toString();
    },
    number: function (value, type) {
        if (type === "boolean" || type === "undefined") {
            return value ? 1 : 0;
        }
        return parseInt(value.toString(), 10) || undefined; // NaN -> undefined
    },
    boolean: function (value, type) {
        if (type === "number") {
            return !!value;
        }
        else if (type === "undefined") {
            return false;
        }
        return /yes|true|on/i.test(value.toString());
    },
    function: function (value) {
        return function () { return value; };
    }
};
/**
 * A configuration, where each raw configuration value can be access directly as a property, or via the
 * "val(options)" method that supports query parameter overwriting and/or type coercion.
 *
 * @author Gunni Rode
 * @author Bruce Mackenzie Nielsen
 *
 * @class Configuration
 */
var Configuration = /** @class */ (function () {
    function Configuration() {
    }
    /**
     * Returns the specified configuration value. <p>
     *
     * Options:
     * <pre>
     * {
     *    name:         String|String[],
     *    configName:   String,
     *    type:         String,
     *    url:          String|Boolean,
     *    defaultValue: *,
     *    converter:    Function -> fn(value:<args.type>, type:String): <options.type>
     * }
     * </pre>
     *
     * If "options.url" is not false and if a query parameter named "options.name" is specified, it will be used.
     * The query parameter is that of <tt>window.location</tt> unless "options.url" is specified as a string. If no
     * such query parameter, the configuration values "this.name", secondarily "this.configName", are tried. If the
     * value is still undefined, "options.defaultValue" is used, if any. <p>
     *
     * If "options.type" is specified, any value above must match said type or it will not be used, eventually
     * returning undefined if neither match. If no type coercion, the first defined value is used. The
     * default types "string", "number", and "boolean" are supported out of the box. "function" will wrap
     * any non-function type in a function that will return said value. "object" has no conversion. <p>
     *
     * If "options.converter" is a conversion type like "fn(value, jsType):options.type", it will be used for the
     * type coercion if the types does not already match. No conversion will ever be made if the types match. Any
     * valid JS type, e.g. also "object" and "function", can be used if "options.converter" can handle it. <p>
     *
     * Examples:
     * <pre>
     *   // Looks up query parameter "foo", then "this.foo" if no such value, and return the value what ever type
     *   // it is, e.g. a string if found as a query parameter, but can be any value if found in this
     *   // configuration directly...
     *   var a = Configuration.val({name: "foo"});
     *
     *   // Different query parameter name: looks up query parameter "foo", then "this.bar" if no such value, and
     *   // return the value what ever type it is, e.g. a string if found as a query parameter, but can be any
     *   // value if found in this configuration directly...
     *   var b = Configuration.val({name: "foo", configName: "bar"});
     *
     *   // Coerce type: looks up query parameter "foo", then "this.foo" if no such value, and coerce value
     *   // into a number, or return undefined if it cannot be coerced into a number...
     *   var c = Configuration.val({name: "foo", type: "number"});
     *   // -> typeof c is "number" or "undefined"
     *
     *   // Coerce type: looks up query parameter "foo", then "this.foo" if no such value, and coerce value
     *   // into a number, or return default value if it cannot be coerced into a number. Notice the default
     *   // value will also be coerced; if not possible, undefined will still be returned...
     *   var c = Configuration.val({name: "foo", type: "number", defaultValue: "42"});
     *   // -> typeof c is "number" or "undefined". If no foo found, 42 is returned
     *
     *   // Lookup based on defaults: looks up query parameter "foo", then "this.foo" if no such value, and
     *   // coerce value into a number, or return default value (42) if it cannot be coerced into a number.
     *   var c = Configuration.val({defaultValue: 42}, {name: "foo", type: "number"});
     *   // -> typeof c is "number" or "undefined"
     *   ..
     * </pre>
     *
     * @param  {*} options          The options to use; can be null/undefined if <tt>defaultOptions</tt> are
     *                              supplied. See examples above.
     * @param  {*} [defaultOptions] Optional default options to add to <tt>options</tt> where not supplied;
     *                              can be falsey. Useful if <tt>options</tt> is supplied by a given context,
     *                              e.g. a default value, and these default options will fill in the blanks
     *                              needed, e.g. the actual config name to look up. See example above.
     *
     * @return {*} The corresponding configuration value, or undefined if not found or not matching "options.type".
     */
    Configuration.val = function (options, defaultOptions) {
        if (defaultOptions) {
            options = Object(__WEBPACK_IMPORTED_MODULE_1_underscore__["extend"])(options || {}, defaultOptions);
        }
        var windowDefined = "undefined" !== typeof window;
        // @ts-ignore
        var optionValue = options.url || windowDefined ? window.location.search : "";
        // Type of value always a "string" or "undefined" here; can never be null (object)...
        // @ts-ignore
        var value = options.url !== false ?
            // @ts-ignore
            findQueryParameter(optionValue, options.name) :
            undefined;
        var type = typeof value;
        if (type === "undefined") {
            // Type of value can be any type here, including "undefined"...
            // @ts-ignore
            value = this[options.configName || options.name];
            // Make sure null means undefined...
            if (value === null) {
                value = undefined;
            }
            type = typeof value;
        }
        // If a type has been specified and it matches, simply return it...
        // @ts-ignore
        if (type === options.type) {
            return value;
            // No specified type, so return value or what ever default value if the value is undefined...
            // @ts-ignore
        }
        else if (!options.type) {
            // @ts-ignore
            return type === "undefined" ? options.defaultValue : value;
        }
        // See if we have a converter from "type" to "options.type"...
        // @ts-ignore
        var converter = options.converter || converters[options.type];
        // @ts-ignore
        var defaultType = typeof options.defaultValue;
        if (converter) {
            // Converter will return valid type, or undefined...
            if (type !== "undefined") {
                value = converter(value, type);
            }
            // Still no value, so try default...
            if (typeof value === "undefined") {
                // Proper type or do we need to convert default value as well?...
                // @ts-ignore
                return defaultType === options.type ?
                    // @ts-ignore
                    options.defaultValue : converter(options.defaultValue, defaultType);
            }
            return value;
        }
        // No converter, but wrong type, which is not what we want. Check if we have a matching default value,
        // or we must return undefined...
        // @ts-ignore
        return defaultType === options.type ? options.defaultValue : undefined;
    };
    return Configuration;
}());

// Merge global config into our configuration to avoid awkward Configuration.config syntax. This will *not*
// overwrite our special "val" function!...
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedConfig, { production: NODE_ENV === "production", port: PORT || 8081, targetEnv: TARGET_ENV || Environments.Names.DEV }));


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank;

    var ParametersHelper = {

        PARAMETER_BEGIN: "#{",
        PARAMETER_END: "}",

        /**
         * Replaces the parameter placeholders with values of the parameters. <p>
         *
         * Example: Supplying "/product/#{Product ID}" and {"Product ID": "1234"} will return
         * "/product/1234". <p>
         *
         * Currently, we do not support the concept of mandatory parameters, so the returned value can be the
         * odd for empty parameters <b>unless</b> <tt>allowEmpty</tt> has explicitly been supplied as false,
         * in which case the empty string will be returned if just one parameter is empty. <p>
         *
         * Example: Supplying "/product/#{Product ID}" and {"Product ID": ""} or {"Some Else": "foo"} will return
         * the empty string for <tt>allowEmpty</tt> set to false; if truthy or undefined, the same template and
         * arguments would yield "/product/" (default behaviour).
         *
         * @param {String} template      A string with #{...} escape parameter placeholders; cannot be falsey.
         * @param {Object} args          A hash with name-value pairs, i.e. {"name1": "value1", "name2":
         *                               "value2", ...}. The values can be non-strings, will be coerced into Strings via
         *                               their <tt>toString()</tt> representations. Can be falsey/empty.
         * @param {Boolean} [allowEmpty] True or undefined to allow empty parameters (default), false otherwise; in the
         *                               latter case, just a single empty parameter will cause the empty string to be returned.
         *
         * @return {String}         The supplied template with inserted parameter values; will be the empty string
         *                          if just one parameter is empty/undefined and <tt>allowEmpty</tt> is falsey.
         */
        inject: function inject(template, args, allowEmpty) {
            var name = void 0;
            var value = void 0;

            if (args) {
                if (typeof allowEmpty === "undefined") {
                    allowEmpty = true;
                }
                for (name in args) {
                    value = args[name];

                    // eslint-disable-next-line eqeqeq
                    if (value == null) {
                        value = "";
                    } else {
                        value = value.toString();
                    }

                    if (isBlank(value) && !allowEmpty) {
                        return "";
                    }
                    template = template.replace(new RegExp(this.PARAMETER_BEGIN + name + this.PARAMETER_END, "g"), value);
                }
            }

            return template;
        }
    };

    return ParametersHelper;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(100);
    var Window = __webpack_require__(48);
    var ViewerEvents = __webpack_require__(153);

    var TYPE = "link";

    var CURRENT_WINDOW = "_top"; // "_top", not "_parent", to ensure embedded Experiences/Groups also works
    var NEW_WINDOW = "_blank";

    /**
     * Action that opens a link.
     *
     * @class LinkAction
     * @constructor
     */
    return Action.extend("LinkAction", {

        defaults: {
            url: "",
            target: CURRENT_WINDOW // defaults to CURRENT_WINDOW (_top) because of legacy Editor behaviour doing the same!
        },

        _event: ViewerEvents.LINK_VISIT,

        /**
         * @protected
         * Sub-type hook to return the full url to open via this link option, defaulting to just returning the
         * "url" attribute. <p>
         *
         * The url does currently not support linking to a normalised Experience or Group, but can be an absolute
         * "../viewer.html#.." link just fine.
         *
         * @return {String} The url to visit; can be falsey (which means this action cannot be activated).
         */
        _url: function _url() {
            return this.get("url");
        },
        _activateable: function _activateable(experienceViewModel) {
            return this._url(experienceViewModel) ? null : "Missing url";
        },


        /**
         * Create an anchor tag with the necessary attributes.
         *
         * @param {HTMLElement} rootElement - The parent html element
         * @param {title} string - The parent models title
         * @returns {ActionDomElement}      - Returns an anchor tag if none is present. If one is present returns an empty object.
         */
        getElement: function getElement(rootElement, title) {
            // We have to check if an anchor tag is already present, since the updateRendering in the AbstractWidgetView is called twice.
            // In the case of the TextWidget CKEditor will strip out the <a> tag.
            // The other widgets (Image/Link) where the LinkAction can be applied, still have the Anchor since it hasn't been removed.
            if (!rootElement.querySelector("a")) {
                var anchorTag = document.createElement("a");

                anchorTag.setAttribute("href", this.get("url"));
                anchorTag.setAttribute("target", this.get("target") || "_top");
                anchorTag.addEventListener("click", function (e) {
                    e.preventDefault();
                    return false;
                });

                if (!rootElement.firstChild) {
                    var url = this.get("url");
                    var elementTitle = title && title.length > 0 ? title : url;
                    anchorTag.setAttribute("title", elementTitle);
                }

                return {
                    element: anchorTag,
                    isWrapper: true
                };
            }

            return {
                element: null,
                isWrapper: false
            };
        },
        _activate: function _activate(experienceViewModel) {
            var url = this._url(experienceViewModel);
            var target = this.get("target") || CURRENT_WINDOW;
            var win = Window.topWindow();

            // Resolve relative URLs to the top level window, if available. If not, the top most window will be
            // the outermost Experience accessible via a direct url. Strictly speaking we are in client
            // space here, but we do not set "clientSpace" to true since we might be able to handle
            // the link anyways, i.e. can potentially work outside client space...
            var a = win.document.createElement("a");
            a.href = url;
            Window.open(a.href, target); // will make the ResponsiveViewerController pause this Experience if the new target tab/window is shown

            var eventArgs = { context: TYPE, url: a.href, target: target }; // include "target" as it may have defaulted
            if (url !== a.href) {
                eventArgs.relative = url;
            }
            return Object.assign({ actionId: this.id, widgetId: this.attributes.widgetId }, eventArgs);
        }
    }, {
        TYPE: TYPE,
        CURRENT_WINDOW: CURRENT_WINDOW,
        NEW_WINDOW: NEW_WINDOW
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var Preconditions = __webpack_require__(14);

    /**
     * Base class for a collection that contains polymorphic models. <p>
     *
     * The model type is determined by the "type" property on each model. Declare a "modelTypes" hash mapping the type
     * values to model classes when extending this collection <b>or</b> define "modelTypes" to be an enum with an
     * optional "modelClass" property to specify how to find the actual type name of the deduced enum type. <p>
     *
     * In addition, the "defaultModelType" property can be specified to use in case no such type is found. <p>
     *
     * Enum examples:
     * <pre>
     *    ..
     *    modelTypes: WidgetTypes,   // use WidgetTypes enum
     *    modelClass: "modelClass",  // and get the actual WidgetType class from the "modelClass" property on the enum constant
     *    ..
     *
     *    ..
     *    modelTypes: Actions,       // here the Actions enum is actually an enum of the types, so no need for "modelClass"
     *    ..
     * </pre>
     *
     * @class PolymorphicCollection
     * @author Bruce Mackenzie Nielsen
     */
    return Backbone.Collection.extend({

        /**
         * Factory method (and not a Model constructor) to return the proper polymorphic type. Actually invoked
         * as "new model(attributes, options)", where "model" is this function. Hence, not in scope of this
         * collection.
         */
        model: function model(attributes, options) {
            if (attributes instanceof Backbone.Model || _.isArray(attributes)) {
                return attributes;
            }

            var type = attributes.type;
            var types = options.collection.modelTypes;
            var map = _.isFunction(types) ? types.call(this) : types;
            var typesMap = map.__enumName ? map.lookup(type, true) : map[type]; // normal [] lookup may also work for enums, but lookup is more powerful
            var prop = options.collection.modelClass;
            var Model = prop ? typesMap[prop] : typesMap;

            // Make sure we can handle the type, i.e. do not explode if unknown, but silently discard.
            Preconditions.checkArgument(Model, "Unknown polymorphic type: '" + (options.collection.__typeName || "?") + "." + type + "'");

            if (Model) {
                return new Model(attributes, options);
            }
            // The Backbone.Collection always expects a model to be returned, so we just fake it by returning
            // an "empty model" with a validate function that will always return false, causing the model to
            // be discarded eventually by the collection. However, if the polymorphic collection has a default type,
            // it will be used...
            return {
                _validate: function _validate() {
                    return false;
                }
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var _ = __webpack_require__(1);
  var Effect = __webpack_require__(78);

  var TYPE = "imageToggle";

  return Effect.extend({

    defaults: _.defaults({
      /**
       * @type {String}
       */
      type: TYPE,

      /**
       * The relative image source, e.g. <tt>assets/images/57a04e8ee4b05c37b56240c6.jpeg"</tt>.
       *
       * @type {String}
       */
      src: null,

      /**
       * @type {Number}
       */
      originalImageWidth: 0,

      /**
       * @type {Number}
       */
      originalImageHeight: 0,

      /**
       * Whether the associated image "supports resize", i.e. has resized representations on S3.
       *
       * @type {Boolean}
       */
      supportsResize: false,

      /**
       * Id of the associated image.
       *
       * @type {String}
       */
      imageId: null,

      /**
       * The image alt text.
       *
       * @type {String}
       */
      altText: null
    }, Effect.prototype.defaults),

    computed: {
      imageUrl: {
        deps: ["src"],
        value: function value(src) {
          return src;
        }
      }
    },

    /**
     * Whether *this* effect contains a valid original size of the associated image, if any.
     *
     * @return {Boolean} <tt>true</tt> if *this* effect contains a valid original size of the associated image, <tt>false</tt> otherwise.
     */
    containsImageSize: function containsImageSize() {
      return this.get("originalImageWidth") > 0 && this.get("originalImageHeight") > 0;
    }
  }, {
    TYPE: TYPE
  });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* global com */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Class = __webpack_require__(26);
    var EffectModel = __webpack_require__(78);
    var TweenMax = __webpack_require__(152);
    var TimelineMax = __webpack_require__(1438);
    var Preconditions = __webpack_require__(14);
    var Promise = __webpack_require__(21);
    var Browser = __webpack_require__(39);

    /**
     * The abstract base class for all effects.
     *
     * @class Effect
     */
    return Class.extend("Effect", {

        /**
         * @type {Backbone.View}
         */
        view: null,

        /**
         * The target element.
         *
         * @type {HTMLElement}
         */
        element: null,

        reversible: true,

        /**
         * @type {EffectModel}
         */
        model: null,

        /**
         * The GSAP instance.
         * @type {*}
         */
        _tween: null,

        _reverseDeferred: null,

        /**
         * Constructor.
         *
         * @param  {Backbone.View} view The associated view.
         * @param  {EffectModel} model   A concrete effect model.
         */
        constructor: function constructor(view, model) {
            this.view = view;
            this.element = view.el;
            this.model = model;

            this.onInitialize();
            this._initializeTween();
        },


        /**
         * Starts playing the effect.
         */
        play: function play() {
            this._tween.play();
        },


        /**
         * Pauses the effect.
         *
         * @param {*} atTime Optional, the time (or label for TimelineLite/TimelineMax instances) that
         * the instance should jump to before pausing (if none is defined, it will pause wherever the
         * playhead is currently located).
         */
        pause: function pause(atTime) {
            this._tween.pause(atTime);
        },
        stop: function stop() {
            this._tween.restart(true);
            this._tween.pause();
        },
        finish: function finish() {
            if (this.repeats()) {
                this.pause();

                return Promise.resolved();
            }

            return this.reverse();
        },


        /**
         * Plays the effect backwards, if supported.
         * @see #reversible
         */
        reverse: function reverse() {
            if (this.reversible) {
                // If there should be any pending reverse animations, we make
                // sure to resolve it before overwriting it.
                if (this._reverseDeferred) {
                    this._reverseDeferred.resolve();
                }

                this._reverseDeferred = new $.Deferred();
                this._tween.reverse();

                return this._reverseDeferred.promise();
            }

            return Promise.resolved();
        },
        kill: function kill() {
            this._tween.kill();
        },


        /**
         * Whether the effect should repeat indefinitely.
         *
         * The default implementation returns true for 'loop' effects - i.e. triggerType is
         * equal to <tt>EffectModel.TRIGGER_TYPE_ATTENTION</tt>.
         *
         * @return {Boolean} <tt>true</tt> if the effect should repeat
         * indefinitely, <tt>false</tt> if not.
         */
        repeats: function repeats() {
            return this.model.get("triggerType") === EffectModel.TRIGGER_TYPE_ATTENTION;
        },


        /**
         * Returns the configuration object passed to GSAP.
         *
         * Abstract method that must be overridden.
         *
         * @return {Object} The tween configuration, e.g. <tt>{opacity: 0.6}</tt>.
         */
        config: function config() {
            Preconditions.abstractMethodError();
        },


        /**
         * Optional subclass callback for overwriting the default tween duration. Might be useful
         * when a specific <tt>triggerType</tt> needs a specific duration.
         *
         * By default, this method returns <tt>null</tt>.
         *
         * @param  {String} triggerType For convenience, passed <tt>this.model.get("triggerType")</tt>.
         * @return {Number}             The duration, in seconds, or <tt>null</tt> to use
         *                              the <tt>duration</tt> value in <tt>this.model</tt>.
         */
        // eslint-disable-next-line no-unused-vars
        duration: function duration(triggerType) {
            return null;
        },


        /**
         * Callback to be invoked at initialization time.
         */
        onInitialize: function onInitialize() {},


        /**
         * Callback invoked every time the animation updates (on every frame while the animation is active).
         */
        onUpdate: function onUpdate() {},
        _initializeTween: function _initializeTween() {
            var _this = this;

            if (this._tween) {
                this._tween.kill();
                this._tween = null;
            }

            var tweenConfig = this.config();
            var element = tweenConfig.element || this.element;
            var yoyo = _.isBoolean(tweenConfig.yoyo) ? tweenConfig.yoyo : true;
            // Determine duration
            var duration = this.duration(this.model.get("triggerType")) || tweenConfig.duration || this.model.get("duration") / 1000;
            // Need to adapt animations to the scaled widget size
            if (tweenConfig.scale && this.view.model.get("scale")) {
                tweenConfig.scale *= this.view.model.get("scale").x;
            }

            // No need to pass these to GSAP
            delete tweenConfig.element;
            delete tweenConfig.duration;
            delete tweenConfig.yoyo;

            var options = _.extend({
                force3D: Browser.capabilities.is3dAnimationsSupported, /* see http://api.greensock.com/js/ */
                paused: true,
                onUpdate: this.onUpdate.bind(this)
            }, tweenConfig);

            if (this.repeats()) {
                // Repeat indefinitely
                options.repeat = -1;

                this._tween = new TimelineMax(options);

                this._tween.to(element, duration, _.extend({ repeat: 1, yoyo: yoyo }, tweenConfig))
                // A dummy tween representing the pause/postDelay
                // TODO: Is there a more official way of achieving this?
                // Run looping/repeating effects with double speed to compensate for the reverse/yoyo time.
                .to(element, this.model.get("postDelay") / 1000 * 2, {}).timeScale(2.0);
            } else {
                options.onReverseComplete = function () {
                    _this._reverseDeferred.resolve();
                };

                this._tween = TweenMax.to(element, duration, options);
            }
        }
    }, {
        // Expose easing - see http://greensock.com/docs/#/HTML5/GSAP/Easing/
        Easing: com.greensock.easing
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(122);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);

    var Placement = {
        BEFORE: "before",
        AFTER: "after"
    };

    /**
     * ButtonIconModel is the model for the Icon part of a Button Widget.
     */
    return ImprovedModel.extend("ButtonIconModel", {
        defaults: {
            iconId: null,
            name: null,
            groupId: null,
            size: 24,
            placement: Placement.AFTER,
            color: "#FFFFFF"
        },

        getIconUrl: function getIconUrl() {
            var _pick = this.pick(["groupId", "iconId", "size"]),
                groupId = _pick.groupId,
                iconId = _pick.iconId,
                size = _pick.size;

            return "images/material-design-icons/" + groupId + "/svg/production/ic_" + iconId + "_" + size + "px.svg";
        }
    }, {

        Placement: Placement

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defaults = _require.defaults,
        extend = _require.extend,
        omit = _require.omit;

    var Backbone = __webpack_require__(7);
    var ButtonIconModel = __webpack_require__(304);
    var ButtonType = __webpack_require__(364);
    var WidgetScaleMode = __webpack_require__(246);
    var AbstractWidgetModel = __webpack_require__(62);

    var BUTTON_DEFAULTS = {
        type: "button",

        buttonType: ButtonType.TEXT_AND_ICON,

        label: "Button",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: "400",
        color: "#ffffff",
        fontFamily: "Arial",
        fontProvider: "standard",
        fontMetadata: {},

        padding: 12,

        backgroundColor: "#9b9b9b",
        borderColor: null,
        borderWidth: null,
        radius: 16,

        icon: null // when dragging in, this is set in WidgetTypesEditorMixin
    };

    var buttonWidgetDefaults = defaults({
        scaleMode: WidgetScaleMode.STRETCH
    }, BUTTON_DEFAULTS, AbstractWidgetModel.prototype.defaults);

    /**
     *
     * @class AbstractWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("ButtonWidgetModel", {

        relations: AbstractWidgetModel.prototype.relations.concat([{
            type: Backbone.One,
            key: "icon",
            relatedModel: ButtonIconModel
        }]),

        defaults: function defaults() {
            return extend(buttonWidgetDefaults);
        },

        // HACK: This line is needed for widgets supporting opacity. Remove
        // this (and the computed 'opacity' property in AbstractWidgetModel) once
        // we're comfortable... (see MOS-2375)
        computed: omit(AbstractWidgetModel.prototype.computed, "opacity"),

        fitToScene: function fitToScene() {}
    }, {
        ButtonType: ButtonType,

        buttonDefaults: BUTTON_DEFAULTS
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Time = __webpack_require__(121),
        ExperienceModel = __webpack_require__(58),
        PublishableState = __webpack_require__(65);

    /**
     * Note: any function accepting the experience collection as the second (last) argument will default to the
     *       global collection of experiences if no specific collection is supplied at call time.
     */
    var GroupUtil = { // TODO: this should really be refactored to a VariantModel for an experience/variants of it, we keep doing the same work over and over!

        LOCALIZATION: "LocalizationGroup",

        BREAKPOINT: "BreakpointGroup",

        _checkInterval: function _checkInterval(updated, variant, userId, interval, now) {
            // "now" = server time
            // Ignore if the user did the update, or if not yet edited (updated)...
            var editedBy = variant.get("editedBy");

            if (editedBy && editedBy !== userId) {
                var editedAt = variant.getEditedAt();
                // First check because of server/client time skew...
                if (editedAt >= now || now - editedAt < interval) {
                    updated.count++;
                    updated.variants[variant.get("id")] = variant;
                }
            }
        },

        isUpdatedWithin: function isUpdatedWithin(experience, group, userId, interval, now) {
            var _this = this;

            var updated = { count: 0, variants: {} };

            if (typeof now === "undefined") {
                now = Time.server(); // server time, since all date fields are server time, e.g. "editedAt"
            }

            if (group) {
                group.getAssets().forEach(function (variant) {
                    _this._checkInterval(updated, variant, userId, interval, now);
                });
            } else {
                this._checkInterval(updated, experience, userId, interval, now);
            }

            return updated;
        },

        /**
         * Returns the greatest state, from the enum ordinal, of the contained assets.
         *
         * @param  {GroupModel} group                           The group containing the assets.
         *
         * @return {Object}     The <tt>PublishableState</tt> enum representing the greatest asset state.
         */
        greatestAssetsState: function greatestAssetsState(group) {
            var assets = group.getAssets(),
                highestOrdinalAsset = _.max(assets, function (asset) {
                return PublishableState.getEnum(asset.get("state"))._ordinal;
            });

            return PublishableState.getEnum(highestOrdinalAsset.get("state"));
        },

        getState: function getState(publishable) {
            if (publishable instanceof ExperienceModel) {
                return publishable.getState();
            }

            // Assume it's a group...
            var assetState = GroupUtil.greatestAssetsState(publishable);

            return PublishableState.greatest(publishable.get("state"), assetState);
        },

        /**
         * @private
         *
         * Convenience method returning all variants for the specified experience, or if the experience represents
         * a breakpoint group, an array containing that group.
         *
         * @param  {ExperienceModel|GroupModel} model The model representing the publishable entity.
         * @return {Model[]}                         Array of variants.
         */
        _allVariantsOrGroup: function _allVariantsOrGroup(model) {
            if (model instanceof ExperienceModel) {
                return [model];
            }

            return model.isOneUnit() ? [model] : model.getAssets();
        },

        /**
         * @private
         *
         * Used internally to find all slots for the supplied experience and its variants or groups.
         *
         * @param {ExperienceModel} experienceModel The experience model to find the slots for.
         * @param {Function} filterCallback         The filtering callback function.
         * @return {Channel[]}                      Array of <tt>Channel</tt>'s.
         *
         */
        _findSlots: function _findSlots(experienceModel, filterCallback) {
            return _.chain(this._allVariantsOrGroup(experienceModel)).map(filterCallback).flatten().value();
        },

        /**
         * Returns an array of experience assets, with at least the specified state (or *pushed* if none defined) in the specified group.
         *
         * @param  {GroupModel} group        The group model.
         * @param  {PublishableState} state  Optional state enum.
         * @return {Object[]}                Array of experience asset objects e.g.: <tt>{resourceId: "foo", resourceType: "Experience"}</tt>
         */
        breakpointRangeAssets: function breakpointRangeAssets(group, state) {
            return _.chain(group.rangeAssets()).filter(function (asset) {
                return asset.hasAtLeastState(state || PublishableState.PUSHED);
            }).value();
        }
    };

    return GroupUtil;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputComponent; });
/* unused harmony export InputComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



var BaseInputComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](BaseInputComponent, _super);
    function BaseInputComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseInputComponent.prototype.render = function () {
        var _a = this.props, type = _a.type, label = _a.label, name = _a.name, units = _a.units, classNames = _a.classNames, inputElementId = _a.inputElementId, disabled = _a.disabled, readOnly = _a.readOnly, onChange = _a.onChange, onClick = _a.onClick, value = _a.value, forwardedRef = _a.forwardedRef, placeholder = _a.placeholder, onBlur = _a.onBlur;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { onClick: onClick },
            label,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", { type: type, name: name, className: classNames, id: inputElementId, disabled: disabled, readOnly: readOnly, onChange: onChange, value: value, ref: forwardedRef, placeholder: placeholder, onBlur: onBlur }),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "units" }, units)));
    };
    return BaseInputComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
// Syntax for forwarding refs in class components is a little convoluted. For more detail see:
// https://www.reddit.com/r/reactjs/comments/91ua32/reactforwardref_in_a_class_based_component/
function ForwardRef(props, ref) {
    return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BaseInputComponent, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props, { forwardedRef: ref }));
}
var InputComponent = __WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](ForwardRef);



/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(309);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 309 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 310 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 311 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SafeAnchor__ = __webpack_require__(124);











var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};
var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Button, _React$Component);

  function Button() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  _proto.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["componentClass"]);

    var Component = componentClass || 'button';
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        active = _this$props.active,
        block = _this$props.block,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "block", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'block')] = block, _extends2));

    var fullClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('btn', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].XSMALL], Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, Button))));

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ChunkingCollection = __webpack_require__(400);
    var ImageModel = __webpack_require__(258);
    var ImageLibrarySourceEnum = __webpack_require__(102);
    var SyncManager = __webpack_require__(44);
    var RestApi = __webpack_require__(29);

    var _require = __webpack_require__(189),
        GATEWAY_TIME_OUT = _require.GATEWAY_TIME_OUT,
        BAD_GATEWAY = _require.BAD_GATEWAY;

    /**
     * Status codes mapped to error messages used for Scene7 errors.
     *
     * @type Map.<Number, String>
     */


    var errorMessages = new Map();
    errorMessages.set(GATEWAY_TIME_OUT, "Timed out while trying to access your Adobe Scene7 account. Please try again or contact Adobe with questions regarding your Scene7 account.");
    errorMessages.set(BAD_GATEWAY, "Unable to access your Adobe Scene7 account. Please try again or contact Adobe with questions regarding your Scene7 account status.");

    /**
     * Represents a (chunking) collection of images, supporting "lazy loading".
     *
     * @see  ChunkingCollection
     * @class ImageCollection
     */
    var ImageCollection = ChunkingCollection.extend("ImageCollection", {

        source: ImageLibrarySourceEnum.CREATOR, // default to Creator

        model: ImageModel,

        /**
         * Set the source to a valid source item in <tt>ImageLibrarySourceEnum</tt>
         *
         * @see  ImageLibrarySourceEnum
         * @param ImageLibrarySourceEnum item
         */
        updateSource: function updateSource(source) {
            this.source = source;
            this.trigger("source:changed", source);
        },
        url: function url() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            // Only allow Creator images (i.e. no sourceType) for project images
            if (options.project) {
                // projects/PROJECT_ID/images
                return RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, options.project.get("id"), RestApi.Collections.IMAGES);
            }

            return RestApi.pathToCollection(ImageModel.resourceFromSource(this.source));
        },
        _handleError: function _handleError(error) {
            var status = error.status;

            // Handle custom error messages...

            if (this.source === ImageLibrarySourceEnum.SCENE7 && errorMessages.has(status)) {
                error.action = "reload";
                error.prefix = "";
                error.message = errorMessages.get(status);

                return "alert";
            }

            return this.__super();
        }
    }, {

        /**
         * Counts the total amount of (the logged in principal's) images
         * in the Creator image library (i.e. *not* 3rd party image library integrations such as Scene7)
         *
         * @param  {Object}         options Options set of options.
         * @param  {ProjectModel}   options.project A <tt>ProjectModel</tt> - for counting all project specific images.
         * @return {Promise}        A <tt>Promise</tt> that resolves with the total number of (the logged in principal's) images.
         */
        count: function count(options) {
            var location = RestApi.Collections.IMAGES_COUNT;
            var project = options && options.project;

            if (project) {
                // projects/{ID}/images/count
                location = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.IMAGES_COUNT);
            }

            return SyncManager.get(location, SyncManager.target("ImageCollection.count"));
        }
    });

    return ImageCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createTheme__ = __webpack_require__(564);

var defaultTheme = Object(__WEBPACK_IMPORTED_MODULE_0__createTheme__["a" /* default */])();
/* harmony default export */ __webpack_exports__["a"] = (defaultTheme);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export teardown */
/* harmony export (immutable) */ __webpack_exports__["a"] = useIsFocusVisible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function teardown(doc) {
  doc.removeEventListener('keydown', handleKeyDown, true);
  doc.removeEventListener('mousedown', handlePointerDown, true);
  doc.removeEventListener('pointerdown', handlePointerDown, true);
  doc.removeEventListener('touchstart', handlePointerDown, true);
  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    var node = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(isFocusVisible);
  }

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collapse__ = __webpack_require__(1857);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collapse__["a"]; });


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(1905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalManager__ = __webpack_require__(946);
/* unused harmony reexport ModalManager */



/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grow__ = __webpack_require__(1932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grow__["a"]; });


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(1941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var ListContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});

if (false) {
  ListContext.displayName = 'ListContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ListContext);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var Tablelvl2Context = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  Tablelvl2Context.displayName = 'Tablelvl2Context';
}

/* harmony default export */ __webpack_exports__["a"] = (Tablelvl2Context);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__can_use_dom_dist_reach_utils_can_use_dom_esm_js__ = __webpack_require__(1016);



/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */

var useIsomorphicLayoutEffect = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__can_use_dom_dist_reach_utils_can_use_dom_esm_js__["a" /* canUseDOM */])() ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];




/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockMapBuilder
 * @format
 * 
 */



var Immutable = __webpack_require__(40);

var OrderedMap = Immutable.OrderedMap;


var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};

module.exports = BlockMapBuilder;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findRangesImmutable
 * @format
 * 
 */



/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;

  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }
      cursor = nextIndex;
    }
    return nextValue;
  });

  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

module.exports = findRangesImmutable;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventHandled
 * @format
 * 
 */



/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled(value) {
  return value === 'handled' || value === true;
}

module.exports = isEventHandled;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeTextWithStrategy
 * @format
 * 
 */



var DraftModifier = __webpack_require__(87);

/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */
function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);
    if (target === selection) {
      return content;
    }
  }
  return DraftModifier.removeRange(content, target, direction);
}

module.exports = removeTextWithStrategy;

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return inlineStyleTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DraftStyles; });
/* unused harmony export discardedInlineStyleTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return exportedInlineStyleTypes; });
/* unused harmony export DraftEntityMutability */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FONT_METADATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_FONT_VARIANT_LIGATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnchorTarget; });
var FONT_METADATA = "FONTMETADATA";
var DEFAULT_FONT_VARIANT_LIGATURES = "none";
var DraftStyles;
(function (DraftStyles) {
    DraftStyles["ITALIC"] = "ITALIC";
    DraftStyles["STRIKETHROUGH"] = "STRIKETHROUGH";
    DraftStyles["SHADOW"] = "SHADOW";
    DraftStyles["CAPITAL"] = "CAPITAL";
    DraftStyles["SMALLCAPS"] = "SMALLCAPS";
    DraftStyles["UNDERLINE"] = "UNDERLINE";
    DraftStyles["HIGHLIGHT"] = "HIGHLIGHT";
})(DraftStyles || (DraftStyles = {}));
var DraftEntityMutability;
(function (DraftEntityMutability) {
    DraftEntityMutability["mutable"] = "MUTABLE";
    DraftEntityMutability["immutable"] = "IMMUTABLE";
    DraftEntityMutability["segmented"] = "SEGMENTED";
})(DraftEntityMutability || (DraftEntityMutability = {}));
var AnchorTarget;
(function (AnchorTarget) {
    AnchorTarget["self"] = "_self";
    AnchorTarget["target"] = "_target";
})(AnchorTarget || (AnchorTarget = {}));
var exportedInlineStyleTypes = [
    {
        label: "Italics",
        draftStyle: DraftStyles.ITALIC,
        customStyles: {
            element: "span",
            style: {
                fontStyle: "italic",
            }
        },
        exported: true,
    },
    {
        label: "Line-Through",
        draftStyle: DraftStyles.STRIKETHROUGH,
        customStyles: {
            element: "span",
            style: {
                textDecoration: "line-through",
            }
        },
        exported: true,
    },
    {
        label: "Shadow",
        draftStyle: DraftStyles.SHADOW,
        customStyles: {
            element: "span",
            style: {
                textShadow: "2px 2px 6px rgba(0,0,0,0.5)",
            }
        },
        exported: true,
    },
    {
        label: "Capital",
        draftStyle: DraftStyles.CAPITAL,
        customStyles: {
            element: "span",
            style: {
                textTransform: "uppercase",
            }
        },
        exported: true,
    },
    {
        label: "Small Caps",
        draftStyle: DraftStyles.SMALLCAPS,
        customStyles: {
            element: "span",
            style: {
                fontVariant: "small-caps",
            }
        },
        exported: true,
    },
    {
        label: "Underline",
        draftStyle: DraftStyles.UNDERLINE,
        customStyles: {
            element: "span",
            style: {
                textDecoration: "underline",
            }
        },
        exported: true,
    },
    {
        label: "Highlight",
        draftStyle: DraftStyles.HIGHLIGHT,
        customStyles: {
            element: "span",
            style: {
                background: "#328efe",
                // This rule doesn't work when there is an inline color
                color: "rgb(255,255,255)",
            }
        },
        exported: false,
    }
];
var discardedInlineStyleTypes = [
    {
        label: "Highlight",
        draftStyle: DraftStyles.HIGHLIGHT,
        customStyles: {
            element: "span",
            style: {
                background: "#328efe",
                // This rule doesn't work when there is an inline color
                color: "rgb(255,255,255)",
            }
        },
        exported: false,
    }
];
var inlineStyleTypes = exportedInlineStyleTypes.concat(discardedInlineStyleTypes);



/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(2256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(2257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(2258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(2259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(1065);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(438);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1080),
    baseKeys = __webpack_require__(2295),
    isArrayLike = __webpack_require__(439);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 332 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBoundingClientRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_math_js__ = __webpack_require__(225);


function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["b" /* isHTMLElement */])(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = Object(__WEBPACK_IMPORTED_MODULE_1__utils_math_js__["c" /* round */])(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = Object(__WEBPACK_IMPORTED_MODULE_1__utils_math_js__["c" /* round */])(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffsetParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNodeName_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isTableElement_js__ = __webpack_require__(2581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getParentNode_js__ = __webpack_require__(454);







function getTrueOffsetParent(element) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(element) || // https://github.com/popperjs/popper-core/issues/837
  Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = Object(__WEBPACK_IMPORTED_MODULE_5__getParentNode_js__["a" /* default */])(element);

  if (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["c" /* isShadowRoot */])(currentNode)) {
    currentNode = currentNode.host;
  }

  while (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(currentNode) && ['html', 'body'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(currentNode)) < 0) {
    var css = Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && Object(__WEBPACK_IMPORTED_MODULE_4__isTableElement_js__["a" /* default */])(offsetParent) && Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (Object(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(offsetParent) === 'html' || Object(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(offsetParent) === 'body' && Object(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getVariation;
function getVariation(placement) {
  return placement.split('-')[1];
}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = detectOverflow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getClippingRect_js__ = __webpack_require__(2584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getDocumentElement_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_getBoundingClientRect_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__computeOffsets_js__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rectToClientRect_js__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_utils_instanceOf_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mergePaddingObject_js__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__expandToHashMap_js__ = __webpack_require__(1144);








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["d" /* clippingParents */] : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["o" /* viewport */] : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = Object(__WEBPACK_IMPORTED_MODULE_7__mergePaddingObject_js__["a" /* default */])(typeof padding !== 'number' ? padding : Object(__WEBPACK_IMPORTED_MODULE_8__expandToHashMap_js__["a" /* default */])(padding, __WEBPACK_IMPORTED_MODULE_5__enums_js__["b" /* basePlacements */]));
  var altContext = elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["j" /* reference */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */];
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getClippingRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__dom_utils_instanceOf_js__["a" /* isElement */])(element) ? element : element.contextElement || Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getDocumentElement_js__["a" /* default */])(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getBoundingClientRect_js__["a" /* default */])(state.elements.reference);
  var popperOffsets = Object(__WEBPACK_IMPORTED_MODULE_3__computeOffsets_js__["a" /* default */])({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = Object(__WEBPACK_IMPORTED_MODULE_4__rectToClientRect_js__["a" /* default */])(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* popper */] && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["k" /* right */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */]].indexOf(key) >= 0 ? 1 : -1;
      var axis = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */]].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHas_js__ = __webpack_require__(2631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(1162);



/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHas_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (has);


/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reference; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_property_expr__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_property_expr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_property_expr__);


var prefixes = {
  context: '$',
  value: '.'
};

var Reference = /*#__PURE__*/function () {
  function Reference(key, options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    var prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && Object(__WEBPACK_IMPORTED_MODULE_1_property_expr__["getter"])(this.path, true);
    this.map = options.map;
  }

  var _proto = Reference.prototype;

  _proto.getValue = function getValue(options) {
    var result = this.isContext ? options.context : this.isValue ? options.value : options.parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  };

  _proto.cast = function cast(value, options) {
    return this.getValue(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      value: value
    }));
  };

  _proto.resolve = function resolve() {
    return this;
  };

  _proto.describe = function describe() {
    return {
      type: 'ref',
      key: this.key
    };
  };

  _proto.toString = function toString() {
    return "Ref(" + this.key + ")";
  };

  Reference.isRef = function isRef(value) {
    return value && value.__isYupRef;
  };

  return Reference;
}();


Reference.prototype.__isYupRef = true;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Class = __webpack_require__(26);
    var HttpStatusCodes = __webpack_require__(189);
    var NotificationBar = __webpack_require__(53);
    var RestApi = __webpack_require__(29);
    var Time = __webpack_require__(121);
    var LoggedIn = __webpack_require__(31);
    var LoggedInUserState = __webpack_require__(19);

    var _require = __webpack_require__(120),
        DateUtil = _require.DateUtil;

    var Preconditions = __webpack_require__(14);
    var Permissions = __webpack_require__(22);
    var Promise = __webpack_require__(21);
    var UrlUtil = __webpack_require__(46);

    var TAG = "confirm_identity";

    // Used to ensure the user is notified about the need for confirmation every "max" location change
    // when unconfirmed...
    var NORMAL_MAX = 6;
    var SENT_MAX = 18;
    var max = NORMAL_MAX;
    var count = max - 1; // to notify immediately upon first location change...

    // True when a request to confirm is pending, false otherwise...
    var confirming = false;

    /**
     * Returns a new set of options to use for notifications related to user confirmation.
     *
     * @param  {String} tag The postfix for the tag to use in the options. The tag prefix is always
     *                      <tt>confirm_identity</tt>.
     * @return {*} A new set of options to use; never null.
     */
    function options(tag) {
        return {
            tag: TAG + "_" + tag,
            ignoreDuplicates: true,
            flash: { duplicate: true },
            clearOnClose: "tag",
            closeDelay: tag === "error" ? 30000 : 15000,
            queue: false,
            onClose: function onClose() {
                count = 0;
            },

            events: {
                "click .resend-confirmation": function clickResendConfirmation(event) {
                    event.preventDefault();
                    manager.requestConfirmationInfo(true);
                }
            }
        };
    }

    /**
     * Returns true if the user account is already confirmed for the user associated with the logged in principal,
     * false otherwise. <p>
     *
     * If said user is already confirmed, a notification message is shown if <tt>notify</tt> is true.
     *
     * @param {Boolean} [notify] True to show a notification on already confirmed where applicable, false otherwise.
     * @return {Boolean} True if already confirmed, false otherwise.
     */
    function checkConfirmed(notify) {
        var user = LoggedIn.user();
        var date = user && user.get("confirmedAt");

        if (date) {
            if (notify) {
                NotificationBar.open("Your account for " + user.get("username") + " was already confirmed on " + DateUtil.formatMMDDYYY(date) + ".", options("already_confirmed"));
            }
            return true;
        }

        return false;
    }

    /** Shows a generic error message for unknown confirmation error. */
    function unknownError() {
        var user = LoggedIn.user();
        var userName = user ? " for " + user.get("username") : "";
        NotificationBar.error({
            message: "There was an unknown error confirming your account" + userName + ". Please try again later.",
            action: "support community"
        }, options("error"));
    }

    /** Closes all notification messages about confirmation, if any. */
    function close() {
        NotificationBar.close({ tag: TAG + ":" }); // any such prefixed tag
    }

    /**
     * Handles all confirmation logic with regards to users confirming their identity only. <p>
     *
     * It will present info-bars to the user when needed and it will interact with the
     * API to handle the confirmation process.
     *
     * @author Jacob Midtgaard-Olesen / <a href="http://www.zmags.com">Zmags</a>
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    var ConfirmationManager = Class.extend({

        /**
         * Attempt to confirm the logged in user with the given token (from a link in an email). <p>
         *
         * If the user is already confirmed, a message will be displayed saying so.
         *
         * @param {String} token The account confirm token for the user in question, supplied via a link in a email
         *                       with the token.
         * @return {Promise} A promise that will resolve when the confirmation has been made, or fail otherwise.
         */
        confirm: function confirm(token) {
            Preconditions.checkArgument(token, "Missing user confirm token");

            // Already confirmed?
            if (checkConfirmed(true)) {
                return Promise.resolved();
            }

            // To avoid getting duplicate messages...
            confirming = true;

            // Hide notification messages related to confirmation, if any...
            close();

            var principal = LoggedIn.principal();
            var user = principal.get("user");
            var scope = this;

            return $.ajax({
                url: RestApi.pathToSpecificResource(RestApi.Collections.USERS, "confirm/" + token),
                type: "GET"
            }).done(function () {
                // Mark user as confirmed, which will trigger a principal re-login...
                user.set("confirmedAt", Time.server());
                NotificationBar.open("Your account (" + user.get("username") + ") is now confirmed. Thank you!", options("confirmed"));
            }).fail(function (data) {
                var ops = options("error");

                // Not found...
                if (data.status === HttpStatusCodes.NOT_FOUND) {
                    NotificationBar.error("Your confirmation link seems to be invalid.&nbsp;&nbsp;&nbsp;<a href='#user/requestConfirmEmail' class='resend-confirmation'>Please reconfirm your identity</a>" + scope._lastSent(user), ops);

                    // Gone/expired...
                } else if (data.status === HttpStatusCodes.GONE) {
                    scope.requestConfirmationInfo(false).done(function () {
                        NotificationBar.open("Your confirmation link has expired, but we have sent a new confirmation email to " + user.get("username") + ".", ops);
                    }).fail(unknownError);

                    // Something else...
                } else {
                    unknownError();
                }
            }).always(function () {
                confirming = false;
            });
        },


        /**
         * Sends an email with a link for the logged in user to confirm the identity if not already confirmed.
         *
         * @param {Boolean} [notify] True to show a notification about the identity already confirmed, or on success or
         *                           failure of the sending of such a confirmation email.
         * @return {Promise} A promise that will resolve when the request confirmation has been sent, or fail otherwise.
         */
        requestConfirmationInfo: function requestConfirmationInfo(notify) {
            // Already confirming or confirmed? Then do nothing except perhaps show a notification for the user...
            if (confirming || checkConfirmed(notify)) {
                return Promise.resolved();
            }

            var user = LoggedIn.user();
            var ops = notify ? options("request") : null;

            return $.ajax({
                url: RestApi.pathToSpecificResource(RestApi.Collections.USERS, "confirm"),
                type: "POST",
                data: JSON.stringify({ baseUrl: UrlUtil.baseUrl() }),
                dataType: "json",
                contentType: "application/json"
            }).done(function () {
                // Set a dummy date to avoid several silent requests before user model reloaded from server (read only
                // on server model). The user can still request additional mails via the settings menu...
                user.set("lastConfirmationEmailSent", Time.server());
                // The user just requested confirmation, so stop bugging her a while, since we assume she will confirm
                // very soon in the current session...
                if (notify) {
                    max = SENT_MAX;
                    NotificationBar.open("A confirmation email has been sent to " + user.get("username") + ". Please follow the instructions in it to confirm your identity.", ops);
                } else {
                    close();
                }
            }).fail(function () {
                max = NORMAL_MAX;

                if (notify) {
                    NotificationBar.open({ message: "Sorry, but we could not send a confirmation email to " + user.get("username") + " at this time. Please try again later.", action: "support community" }, options("error"));
                } else {
                    close();
                }
            });
        },


        /**
         * @private
         * Returns a user friendly string of the date a confirmation mail was last sent.
         *
         * @param {User} user The unconfirmed user; never null.
         * @return {String} The user friendly message, or empty if no mail ever sent.
         */
        _lastSent: function _lastSent(user) {
            var lastSent = user.get("lastConfirmationEmailSent");
            if (lastSent) {
                return " - last email sent " + DateUtil.formatMMDDYYY(lastSent);
            }

            return "";
        },


        /**
         * Returns the specified user, defaulting to the one associated with the currently logged in principal,
         * if confirmation is required, false otherwise. <p>
         *
         * We only require mandatory confirmation for any user not confirmed yet <b>and</b> where the role is higher
         * than Spectator; the default role is Spectator anyways, so the user is free to confirm her identity (via
         * the Settings menu), but we will not force her to (until the role is increased).
         *
         * @param {User} [user] The user to check; will default to the user associated with the currently logged in
         *                      principal, if any.
         * @return {User} The (defaulted) user if confirmation is required, null otherwise.
         */
        confirmationRequired: function confirmationRequired() {
            var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : LoggedIn.user();

            var principal = LoggedIn.principal();

            // No confirmation is required if we're logged in through the AD directory
            if (principal && principal.get("type") === "AD") {
                return null;
            }

            return user && !user.isConfirmed() && Permissions.Roles.SPECTATOR.not(user) ? user : null;
        }
    });

    // Singleton...
    var manager = new ConfirmationManager();

    // Make sure the user is notified every 6th time the location changes if unconfirmed...
    LoggedInUserState.on("change:location", function () {
        var user = !confirming && manager.confirmationRequired();

        if (user) {
            // Can actually be larger than "max" if notification is shown, and the user changes location
            // drastically, but "count" will not be reset until such a notification closes...
            if (++count % max === 0) {
                var ops = options("confirm");
                ops.flash.duplicate = false;
                NotificationBar.open("You are currently in Spectator mode, and you need to confirm your identity (" + user.get("username") + ")\n                     in order to use your " + user.get("role").name + "\n                     role.&nbsp;&nbsp;&nbsp;<a href='#user/requestConfirmEmail' class='resend-confirmation'>Confirm your identity</a>" + manager._lastSent(user), ops);

                max = NORMAL_MAX;
            }
        } else {
            max = NORMAL_MAX;
        }
    });

    return manager;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Ladda 0.4.2 (2013-06-14, 21:49)
 * http://lab.hakim.se/ladda
 * MIT licensed
 *
 * Copyright (C) 2013 Hakim El Hattab, http://hakim.se
 *
 * Patched to support data attributes, default offset height, and optional delay and callback on stop.
 * Patched to force AMD usage over CommonJS
 */
(function (t, e) {
   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(766)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : t.Ladda = e(t.Spinner);
})(undefined, function (t) {
  "use strict";
  function e(t) {
    if (t === void 0) throw "Target must be defined.";var e = o(t),
        n = document.createElement("span");n.className = "ladda-spinner", t.appendChild(n);var i,
        a = { start: function start() {
        return t.setAttribute("disabled", ""), t.setAttribute("data-loading", ""), clearTimeout(i), e.spin(n), this.setProgress(0), this;
      }, stop: function stop(d, c) {
        return t.removeAttribute("disabled"), t.removeAttribute("data-loading"), clearTimeout(i), i = setTimeout(function () {
          e.stop();if (c) {
            c();
          }
        }, isNaN(d) ? 1e3 : d), this;
      }, toggle: function toggle() {
        return this.isLoading() ? this.stop() : this.start(), this;
      }, setProgress: function setProgress(e) {
        var n = t.querySelector(".ladda-progress");0 === e && n && n.parentNode ? n.parentNode.removeChild(n) : (n || (n = document.createElement("div"), n.className = "ladda-progress", t.appendChild(n)), n.style.width = (e || 0) * t.offsetWidth + "px");
      }, enable: function enable() {
        return this.stop(), this;
      }, disable: function disable() {
        return this.stop(), t.setAttribute("disabled", ""), this;
      }, isLoading: function isLoading() {
        return t.hasAttribute("data-loading");
      } };return r.push(a), a;
  }function n(t, n) {
    n = n || {};var i = [];"string" == typeof t ? i = [].slice.call(document.querySelectorAll(t)) : "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "string" == typeof t.nodeName && (i = [i]);for (var o = 0, r = i.length; r > o; o++) {
      (function () {
        var t = i[o];if ("function" == typeof t.addEventListener) {
          var r = e(t),
              a = -1;t.addEventListener("click", function () {
            r.start(), "number" == typeof n.timeout && (clearTimeout(a), a = setTimeout(r.stop, n.timeout)), "function" == typeof n.callback && n.callback.apply(null, [r]);
          }, !1);
        }
      })();
    }
  }function i() {
    for (var t = 0, e = r.length; e > t; t++) {
      r[t].stop();
    }
  }function o(e) {
    var h = e.offsetHeight || 32,
        c;if (h > 32) {
      h *= 0.8;
    }if (e.hasAttribute('data-spinner-size')) {
      h = parseInt(e.getAttribute('data-spinner-size'), 10);
    } else if (e.hasAttribute('data-size')) {
      h = parseInt(e.getAttribute('data-size'), 10);
    }if (e.hasAttribute('data-spinner-color')) {
      c = e.getAttribute('data-spinner-color');
    }var n = 12,
        r = h * 0.2,
        l = r * 0.6,
        w = r < 7 ? 2 : 3;return new t({ color: c || "#fff", lines: n, radius: r, length: l, width: w, zIndex: "initial", top: "auto", left: "auto", className: "" });
  }var r = [];return { bind: n, create: e, stopAll: i };
});

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Enum = __webpack_require__(77);
    var Sorting = __webpack_require__(696);
    var SortingHelperMethods = __webpack_require__(1192);
    var Storage = __webpack_require__(34);

    var SORTING_KEY = "sorting";

    var DashboardSorting = Enum.create("DashboardSorting", "value", {

        MONTH: new Sorting("month", ["editedAt"]),

        ALPHABETICAL: new Sorting("alphabetical", [{ name: "normalizedName", direction: "Ascending" }]),

        PERSON: new Sorting("person", ["createdBy", "editedAt"]),

        STATE: new Sorting("state", ["state", "editedAt"])

    }, {
        // We need to create a closure so we have access to the DashboardSorting variable.
        current: function current() {
            return SortingHelperMethods.current(Storage.Keys.DASHBOARD_SORTING_PANEL, SORTING_KEY, DashboardSorting, DashboardSorting.MONTH)();
        },

        set: SortingHelperMethods.set(Storage.Keys.DASHBOARD_SORTING_PANEL, SORTING_KEY),

        fromValue: function fromValue(value) {
            return SortingHelperMethods.fromValue(DashboardSorting)(value);
        }
    });

    return DashboardSorting;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    return {

        // "channels_admin" (client site) -> "toolbar" (editor)
        PAGE_IS_CHANNELS_ENABLED: "pageIsChannelsEnabled",
        PUBLISH_TO_CHANNEL: "publishToChannel",
        CONTENT: "content",
        CREATE_CHANNEL_AND_PUBLISH: "createChannelAndPublish",
        REMOVE_CURRENT_CONTENT: "removeCurrentContent",
        REMOVE_SCHEDULED_CONTENT: "removeScheduledContent",
        DELETE_CHANNEL: "deleteChannel",
        SCHEDULED_DATE_CHANGED: "scheduledDateChanged",
        WRONG_CONFIG_ID: "wrongConfigId",
        WRONG_BOOKMARKLET: "wrongBookmarklet",
        BROWSER_NOT_SUPPORTED: "browserNotSupported",
        SET_FLAGS: "setFlags",

        // "toolbar" (editor) -> "channels_admin" (client site) or vise versa in certain cases
        INITIALIZE_CHANNELS: "initializeChannels",
        POPULATE_CHANNELS: "populateChannels",
        SET_HIGHLIGHT: "setHighlight",
        DRAG_START: "dragStartMessage",
        DRAG_END: "dragEndMessage",

        // "drop_page" (iframe with "src = dropPage.html" inserted in "channels_admin" page) -> "channels_admin"
        DRAG: "dragMessage",
        DRAG_LEAVE: "dragLeaveMessage",
        DROP: "dropMessage",

        NAVIGATE_TO: "navigateTo",
        SUPPORT: "support"
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var Rectangle = __webpack_require__(248);
    var Preconditions = __webpack_require__(14);

    var DIRECTION_FORWARD = "forward";
    var DIRECTION_REVERSE = "reverse"; // TODO: bad naming, should be something like BACKWARDS to support DIRECTION_UPWARDS/DOWNWARDS eventually

    /**
     * View model for the experience viewer.
     *
     * @class ExperienceViewModel
     * @constructor
     */
    return ImprovedModel.extend("ExperienceViewModel", { // we require "computed" functionality to handle stalled/paused state

        immutable: true, // not a persisted model!

        defaults: {
            /**
             * @type {ExperienceModel}
             * The Experience in question.
             */
            experience: null,
            /**
             * @type {Number}
             * The current scene shown for the Experience.
             */
            currentScene: 1,
            /**
             * @type {Boolean}
             * Only set to true to trigger a close of the Experience/Viewer. Once this set to true, if ever, this
             * Viewer is permanently closed (destroyed).
             */
            closed: false,
            /**
             * @type {Boolean}
             * True when the tab containing the Experience/Viewer is shown in the browser, false otherwise. Even
             * when shown, the Experience/Viewer may be not be visible to the user, e.g. if embedded on an adjacent
             * Scene. <p>
             *
             * This will be set for non-embedded Viewers only - we only listen at the top level - as a change here
             * will trigger a corresponding recursive "change:active" event.
             */
            shown: true,
            /**
             * @type {Boolean}
             * True if the Experience is currently visible (in the Browser viewport/DOM), false otherwise. When
             * visible, the Experience may currently not be visible to the end user if she is viewing a different
             * tab, for example, in the browser.
             */
            visible: true,
            /**
             * @type {Boolean}
             * Whether or not the Viewer is active "as a whole" or not. When active, only a single Scene will be
             * active at a time - the current Scene. Once the user (or auto play) transitions to the next Scene,
             * the previous Scene becomes inactive and the new Scene becomes active. When the Viewer is inactive,
             * all Scenes are inactive. <p>
             *
             * Inactive Scenes may be rendered differently and will not listen for events (in affect "stalled").
             * As a whole, an inactive Viewer/Experience will not listen for global events like "resize" or "scroll". <p>
             *
             * Normally, a Viewer/Experience is always active, with a single active Scene. Embedded Viewers/Experiences,
             * however, may or may not be inactive when they are embedded. Viewers/Experiences embedded on adjacent
             * Scenes will be tagged as inactive as they should not influence the current Scene. When such a Scene is
             * transitioned into the current Scene, the embedded Viewer/Experience will be tagged as active, and the
             * previous Scene as inactive, recursing into possible embedded Viewers/Experiences embedded there, and so
             * forth. <p>
             *
             * Embedded Viewers/Experiences on the same Scene will not be tagged as inactive when the embedding Scene
             * is active, as they are part of the current content for the Scene. On transition, they will like always
             * be set as inactive. <p>
             *
             * Note that an active Viewer can be stalled, i.e. ignores mouse events but still listens for resize
             * events, for example during an open Lightbox.
             *
             * @see ResponsiveViewerController
             */
            active: true,
            /**
             * @type {Boolean}
             * True if the Experience is stale with respect to mouse events, false otherwise. A stale Experience
             * will always be paused, but a paused Experience need not be stale. For example, a paused Experience
             * will resume auto play, if so configured, once the user triggers a mouse leave on it, but if also stale,
             * such mouse events are ignored, ensuring the Experience remains "where it is in time". This is typically
             * needed when lightboxes are opened. <p>
             *
             * Once this value is set to true, it will trigger <tt>paused</tt> being set to true as well, but not
             * the reverse.
             *
             * @see #paused
             * @see #autoPlay
             */
            stalled: false,
            /**
             * @type {Boolean}
             * True if the Experience is currently paused (with regards to auto play), false otherwise. An Experience
             * is typically paused when the user interacts with the Experience, including on mouse hover, and normally
             * resumes auto play on for example mouse leave. However, if the Experience is also tagged as "stale",
             * such mouse events will be ignored, ensuring the Experience remains "where it is in time".
             *
             * @see #stalled
             * @see #autoPlay
             */
            paused: false,
            /**
             * @type {Boolean}
             * True when auto play is enabled (default), false otherwise. Once a user interacts directly with an
             * Experience via an Action set to disable auto play, auto play will be disabled henceforth for it,
             * but it will not affect other Experiences, neither parents, siblings, or children (embedded) ones.
             * This means that individual actions cannot re-enable auto play again. <p>
             *
             * When false, the Experience can still be stalled/unstalled and/or paused/unpaused, but unpausing will
             * thus not start auto play.
             *
             * @see #paused
             */
            autoPlay: true, // true here, not false like on Action by default!
            /**
             * @type {String}
             * Auto play direction, as an enum string, e.g. "forward" or "reverse".
             *
             * @see #DIRECTION_FORWARD
             * @see #DIRECTION_REVERSE
             */
            direction: "forward",
            /**
             * @type {Rectangle}
             * The current viewport size.
             */
            viewportVisibility: new Rectangle(0, 0, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            /**
             * @type {Action[]}
             * Array of pending Actions, such as a lightbox that has been activated but not closed, to ensure
             * such pending actions will be forcefully closed when the Experience Viewer (and thus this model)
             * is destroyed.
             *
             * @see Action#pendingEvent
             * @see Action#activate
             */
            pendingActions: [],
            /**
             * @type {CompanySettings}
             * this is the Company Settings for Classic Viewer
             */
            companySettings: {}
        },

        computed: {
            _paused: { // ensures that changes to "paused" while stalled will be reflected to be restored when no longer stalled...
                deps: ["paused"],
                value: function value(paused, options) {
                    // Make sure "_paused" is only updated while "stalled" is true...
                    if (this.get("stalled")) {
                        // Make sure we only initialise "_paused" based on it being stalled, not because somebody
                        // sets this concurrently while stalled...
                        if (options.stalled) {
                            return true;

                            // Update "_paused" if already defined (from the if-statement above sometime in the past)...
                        } else if (this.has("_paused")) {
                            return paused;
                        }
                    }
                    // undefined
                },

                silent: true
            }
        },

        /**
         * Gets and/or sets the named state on this view model, potentially triggering recursive changes to other
         * related Viewers. On set, the previous state is returned.
         *
         * @param {String}   name       The state name: "shown", "visible", "stalled", "paused", "autoPlay", or "closed".
         * @param {Boolean} [value]     The state value to set, if any; can be undefined.
         * @param {Boolean} [recursive] True if recursive, false otherwise.
         *
         * @return {Boolean} The (previous) state value; never undefined.
         */
        state: function state(name, value, recursive) {
            // for example used to pause embedded experiences
            var val = false;
            // Set?
            if (typeof value !== "undefined") {
                val = this.get(name);
                // Disabled auto play cannot be re-enabled for *this* Experience...
                if (name === "autoPlay") {
                    value = val && value;
                    recursive = false;
                }
                this.set(name, value, { recursive: recursive });

                // Get!
            } else {
                val = this.get(name);
            }
            return val;
        },


        /**
         * Gets the scene ID of the current scene.
         * @returns {String} The scene ID of the current scene.
         */
        getCurrentSceneId: function getCurrentSceneId() {
            Preconditions.checkState(this.has("experience"), "No experience defined");
            var experience = this.get("experience");
            var currentSceneNum = this.get("currentScene");
            var currentScene = experience.getSceneBySceneNumber(currentSceneNum);
            return currentScene.get("id");
        },


        /**
         * Updates the model to point to the specified <tt>sceneNumber</tt>.
         *
         * @param  {Number} sceneNumber The scene number.
         */
        goToScene: function goToScene(sceneNumber) {
            var totalNumberOfScenes = this.get("experience").get("scenes").length;
            var currentSceneNumber = this.get("currentScene");

            sceneNumber = Math.min(totalNumberOfScenes, Math.max(1, sceneNumber));

            this.set({
                direction: sceneNumber > currentSceneNumber ? "forward" : "reverse",
                currentScene: sceneNumber
            });
        },


        /**
         * Updates the model to point at the next scene, wrapping around if the current scene is at the end of the
         * experience.
         */
        goToNextScene: function goToNextScene() {
            this.set("direction", "forward");
            this.set("currentScene", this.getNextScene());
        },


        /**
         * Gets the scene number after the current scene, which may wrap around to the first scene.
         * @returns {Number} The scene number after the current scene.
         */
        getNextScene: function getNextScene() {
            var nextScene = this.get("currentScene") + 1;

            if (nextScene > this.get("experience").get("scenes").length) {
                nextScene = 1;
            }

            return nextScene;
        },


        /**
         * Gets the scene number before the current scene, which may wrap around to the last scene.
         * @returns {Number} The scene number before the current scene.
         */
        getPreviousScene: function getPreviousScene() {
            var previousScene = this.get("currentScene") - 1;

            if (previousScene < 1) {
                previousScene = this.get("experience").get("scenes").length;
            }

            return previousScene;
        },


        /**
         * Updates the model to point at the previous scene, wrapping around if the current scene is at the start of the
         * experience.
         */
        goToPreviousScene: function goToPreviousScene() {
            this.set("direction", "reverse");
            this.set("currentScene", this.getPreviousScene());
        }
    }, {

        DIRECTION_FORWARD: DIRECTION_FORWARD,
        DIRECTION_REVERSE: DIRECTION_REVERSE

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global, module) {/* unused harmony export dynamicRequire */
/* harmony export (immutable) */ __webpack_exports__["i"] = isNodeEnv;
/* harmony export (immutable) */ __webpack_exports__["f"] = getGlobalObject;
/* harmony export (immutable) */ __webpack_exports__["m"] = uuid4;
/* harmony export (immutable) */ __webpack_exports__["k"] = parseUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = getEventDescription;
/* harmony export (immutable) */ __webpack_exports__["c"] = consoleSandbox;
/* harmony export (immutable) */ __webpack_exports__["b"] = addExceptionTypeValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = addExceptionMechanism;
/* harmony export (immutable) */ __webpack_exports__["g"] = getLocationHref;
/* harmony export (immutable) */ __webpack_exports__["h"] = htmlTreeAsString;
/* unused harmony export crossPlatformPerformance */
/* harmony export (immutable) */ __webpack_exports__["l"] = timestampWithMs;
/* unused harmony export parseSemver */
/* harmony export (immutable) */ __webpack_exports__["j"] = parseRetryAfterHeader;
/* harmony export (immutable) */ __webpack_exports__["e"] = getFunctionName;
/* unused harmony export addContextToFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__string__ = __webpack_require__(724);


/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    // tslint:disable-next-line: no-unsafe-any
    return mod.require(request);
}
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // tslint:disable:strict-type-predicates
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (isNodeEnv()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // tslint:disable-next-line:no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // tslint:disable-next-line:no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = (Math.random() * 16) | 0;
        // tslint:disable-next-line:no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
}
/**
 * Adds exception mechanism to a given event.
 * @param event The event to modify.
 * @param mechanism Mechanism of the mechanism.
 * @hidden
 */
function addExceptionMechanism(event, mechanism) {
    if (mechanism === void 0) { mechanism = {}; }
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore
        // tslint:disable:no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function (key) {
            // @ts-ignore
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    }
    catch (_oO) {
        // no-empty
    }
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    try {
        return document.location.href;
    }
    catch (oO) {
        return '';
    }
}
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    className = elem.className;
    if (className && Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
var INITIAL_TIME = Date.now();
var prevNow = 0;
var performanceFallback = {
    now: function () {
        var now = Date.now() - INITIAL_TIME;
        if (now < prevNow) {
            now = prevNow;
        }
        prevNow = now;
        return now;
    },
    timeOrigin: INITIAL_TIME,
};
var crossPlatformPerformance = (function () {
    if (isNodeEnv()) {
        try {
            var perfHooks = dynamicRequire(module, 'perf_hooks');
            return perfHooks.performance;
        }
        catch (_) {
            return performanceFallback;
        }
    }
    var performance = getGlobalObject().performance;
    if (!performance || !performance.now) {
        return performanceFallback;
    }
    // Polyfill for performance.timeOrigin.
    //
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // tslint:disable-next-line:strict-type-predicates
    if (performance.timeOrigin === undefined) {
        // As of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always a
        // valid fallback. In the absence of a initial time provided by the browser, fallback to INITIAL_TIME.
        // @ts-ignore
        // tslint:disable-next-line:deprecation
        performance.timeOrigin = (performance.timing && performance.timing.navigationStart) || INITIAL_TIME;
    }
    return performance;
})();
/**
 * Returns a timestamp in seconds with milliseconds precision since the UNIX epoch calculated with the monotonic clock.
 */
function timestampWithMs() {
    return (crossPlatformPerformance.timeOrigin + crossPlatformPerformance.now()) / 1000;
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4],
    };
}
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) { linesOfContext = 5; }
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines
        .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
        .map(function (line) { return Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(line, 0); });
    frame.context_line = Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines
        .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
        .map(function (line) { return Object(__WEBPACK_IMPORTED_MODULE_1__string__["c" /* snipLine */])(line, 0); });
}
//# sourceMappingURL=misc.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(473), __webpack_require__(42), __webpack_require__(437)(module)))

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(288);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = __webpack_require__(731)();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasPropertyDescriptors = __webpack_require__(731);

var GetIntrinsic = __webpack_require__(15);

var $defineProperty = hasPropertyDescriptors() && GetIntrinsic('%Object.defineProperty%', true);

var hasArrayLengthDefineBug = hasPropertyDescriptors.hasArrayLengthDefineBug();

// eslint-disable-next-line global-require
var isArray = hasArrayLengthDefineBug && __webpack_require__(741);

var callBound = __webpack_require__(45);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
module.exports = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	if (
		hasArrayLengthDefineBug
		&& P === 'length'
		&& '[[Value]]' in desc
		&& isArray(O)
		&& O.length !== desc['[[Value]]']
	) {
		// eslint-disable-next-line no-param-reassign
		O.length = desc['[[Value]]'];
		return O.length === desc['[[Value]]'];
	}

	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(1296);

var $construct = GetIntrinsic('%Reflect.construct%', true);

var DefinePropertyOrThrow = __webpack_require__(238);
try {
	DefinePropertyOrThrow({}, '', { '[[Get]]': function () {} });
} catch (e) {
	// Accessor properties aren't supported
	DefinePropertyOrThrow = null;
}

// https://ecma-international.org/ecma-262/6.0/#sec-isconstructor

if (DefinePropertyOrThrow && $construct) {
	var isConstructorMarker = {};
	var badArrayLike = {};
	DefinePropertyOrThrow(badArrayLike, 'length', {
		'[[Get]]': function () {
			throw isConstructorMarker;
		},
		'[[Enumerable]]': true
	});

	module.exports = function IsConstructor(argument) {
		try {
			// `Reflect.construct` invokes `IsConstructor(target)` before `Get(args, 'length')`:
			$construct(argument, badArrayLike);
		} catch (err) {
			return err === isConstructorMarker;
		}
	};
} else {
	module.exports = function IsConstructor(argument) {
		// unfortunately there's no way to truly check this without try/catch `new argument` in old environments
		return typeof argument === 'function' && !!argument.prototype;
	};
}


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES5ToInteger = __webpack_require__(1304);

var ToNumber = __webpack_require__(99);

// https://ecma-international.org/ecma-262/6.0/#sec-tointeger

module.exports = function ToInteger(value) {
	var number = ToNumber(value);
	return ES5ToInteger(number);
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var floor = __webpack_require__(115);

var msPerDay = __webpack_require__(151).msPerDay;

// https://262.ecma-international.org/5.1/#sec-15.9.1.2

module.exports = function Day(t) {
	return floor(t / msPerDay);
};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $Date = GetIntrinsic('%Date%');

var callBound = __webpack_require__(45);

var $getUTCFullYear = callBound('Date.prototype.getUTCFullYear');

// https://262.ecma-international.org/5.1/#sec-15.9.1.3

module.exports = function YearFromTime(t) {
	// largest y such that this.TimeFromYear(y) <= t
	return $getUTCFullYear(new $Date(t));
};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var GetV = __webpack_require__(489);
var IsCallable = __webpack_require__(187);
var IsPropertyKey = __webpack_require__(64);

// https://ecma-international.org/ecma-262/6.0/#sec-getmethod

module.exports = function GetMethod(O, P) {
	// 7.3.9.1
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	// 7.3.9.2
	var func = GetV(O, P);

	// 7.3.9.4
	if (func == null) {
		return void 0;
	}

	// 7.3.9.5
	if (!IsCallable(func)) {
		throw new $TypeError(P + 'is not a function');
	}

	// 7.3.9.6
	return func;
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//  Backbone-associations.js 0.5.3
//
//  (c) 2013 Dhruva Ray, Jaynti Kanani, Persistent Systems Ltd.
//  Backbone-associations may be freely distributed under the MIT license.
//  For all details and documentation:
//  https://github.com/dhruvaray/backbone-associations/
//

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    // Zmags patch for require support
    "use strict";

    var Backbone = __webpack_require__(7),
        _ = __webpack_require__(1);

    // Save a reference to the global object (`window` in the browser, `exports`
    // on the server).
    var root = this;

    // The top-level namespace. All public Backbone classes and modules will be attached to this.
    // Exported for the browser and CommonJS.
    var BackboneModel, BackboneCollection, ModelProto, CollectionProto, defaultEvents, AssociatedModel, pathChecker, collectionEvents, delimiters, pathSeparator;

    // Create local reference `Model` prototype.
    BackboneModel = Backbone.Model;
    BackboneCollection = Backbone.Collection;
    ModelProto = BackboneModel.prototype;
    CollectionProto = BackboneCollection.prototype;

    // Built-in Backbone `events`.
    defaultEvents = ["change", "add", "remove", "reset", "sort", "destroy"];
    collectionEvents = ["reset", "sort"];

    Backbone.Associations = {
        VERSION: "0.5.3"
    };

    // Define `SEPERATOR` property to Backbone.Associations
    Object.defineProperty(Backbone.Associations, 'SEPARATOR', {
        enumerable: true,
        get: function get() {
            return pathSeparator;
        },
        set: function set(value) {
            if (!_.isString(value) || _.size(value) < 1) {
                value = ".";
            }
            // set private properties
            pathSeparator = value;
            pathChecker = new RegExp("[\\" + pathSeparator + "\\[\\]]+", "g");
            delimiters = new RegExp("[^\\" + pathSeparator + "\\[\\]]+", "g");
        }
    });

    // Backbone.AssociatedModel
    // --------------

    //Add `Many` and `One` relations to Backbone Object.
    Backbone.Associations.Many = Backbone.Many = "Many";
    Backbone.Associations.One = Backbone.One = "One";
    Backbone.Associations.Self = Backbone.Self = "Self";
    // Set default separator
    Backbone.Associations.SEPARATOR = ".";
    // Define `AssociatedModel` (Extends Backbone.Model).
    AssociatedModel = Backbone.AssociatedModel = Backbone.Associations.AssociatedModel = BackboneModel.extend({
        // Define relations with Associated Model.
        relations: undefined,
        // Define `Model` property which can keep track of already fired `events`,
        // and prevent redundant event to be triggered in case of cyclic model graphs.
        _proxyCalls: undefined,

        // Get the value of an attribute.
        get: function get(attr) {
            var obj = ModelProto.get.call(this, attr);

            // if the attr is a reverse reference, replace it with an object
            var reverseRelations = this.reverseRelations || this.collection && this.collection.reverseRelations,
                exists = _.some(reverseRelations, function (reverse) {
                return reverse.key === attr;
            });

            if (exists) {
                obj = this[attr] || this.collection && this.collection[attr];
            }

            return obj ? obj : this._getAttr.apply(this, arguments);
        },

        // Set a hash of model attributes on the Backbone Model.
        set: function set(key, value, options) {
            var attributes, result;
            // Duplicate backbone's behavior to allow separate key/value parameters,
            // instead of a single 'attributes' object.
            if (_.isObject(key) || key == null) {
                attributes = key;
                options = value;
            } else {
                attributes = {};
                attributes[key] = value;
            }

            result = this._set(attributes, options);
            // Trigger events which have been blocked until the entire object graph is updated.
            this._processPendingEvents();
            return result;
        },

        // Works with an attribute hash and options + fully qualified paths
        _set: function _set(attributes, options) {
            var attr,
                modelMap,
                modelId,
                obj,
                result = this;
            if (!attributes) return this;
            for (attr in attributes) {
                //Create a map for each unique object whose attributes we want to set
                modelMap || (modelMap = {});
                if (attr.match(pathChecker)) {
                    var pathTokens = getPathArray(attr),
                        initials = _.initial(pathTokens),
                        last = pathTokens[pathTokens.length - 1],
                        parentModel = this.get(initials);
                    if (parentModel instanceof AssociatedModel) {
                        obj = modelMap[parentModel.cid] || (modelMap[parentModel.cid] = { 'model': parentModel, 'data': {} });
                        obj.data[last] = attributes[attr];
                    }
                } else {
                    obj = modelMap[this.cid] || (modelMap[this.cid] = { 'model': this, 'data': {} });
                    obj.data[attr] = attributes[attr];
                }
            }

            if (modelMap) {
                for (modelId in modelMap) {
                    obj = modelMap[modelId];
                    this._setAttr.call(obj.model, obj.data, options) || (result = false);
                }
            } else {
                result = this._setAttr.call(this, attributes, options);
            }
            return result;
        },

        // Set a hash of model attributes on the object,
        // fire Backbone `event` with options.
        // It maintains relations between models during the set operation.
        // It also bubbles up child events to the parent.
        _setAttr: function _setAttr(attributes, options) {
            var self = this,
                attr;

            // Extract attributes and options.
            options || (options = {});
            if (options.unset) for (attr in attributes) {
                attributes[attr] = void 0;
            }if (this.relations) {
                // Iterate over `this.relations` and `set` model and collection values
                // if `relations` are available.
                _.each(this.relations, function (relation) {
                    var relationKey = relation.key,
                        relatedModel = relation.relatedModel,
                        collectionType = relation.collectionType,
                        map = relation.map,
                        reverseRelation = relation.reverseRelation,
                        currVal = this.attributes[relationKey],
                        idKey = currVal && currVal.idAttribute,
                        val,
                        relationOptions,
                        data,
                        relationValue,
                        newCtx = false;

                    // Call function if relatedModel is implemented as a function
                    if (relatedModel && !(relatedModel.prototype instanceof BackboneModel)) relatedModel = _.isFunction(relatedModel) ? relatedModel.call(this, relation, attributes) : relatedModel;

                    // Get class if relation and map is stored as a string.
                    if (relatedModel && _.isString(relatedModel)) {
                        relatedModel = relatedModel === Backbone.Self ? this.constructor : map2Scope(relatedModel);
                    }
                    collectionType && _.isString(collectionType) && (collectionType = map2Scope(collectionType));
                    map && _.isString(map) && (map = map2Scope(map));
                    // Merge in `options` specific to this relation.
                    relationOptions = relation.options ? _.extend({}, bindOptions(relation, self), options) : options;

                    if (!relatedModel && !collectionType) throw new Error('specify either a relatedModel or collectionType');

                    if (attributes[relationKey]) {
                        // Get value of attribute with relation key in `val`.
                        val = _.result(attributes, relationKey);
                        // Map `val` if a transformation function is provided.
                        val = map ? map.call(this, val, collectionType ? collectionType : relatedModel) : val;

                        // If `relation.type` is `Backbone.Many`,
                        // Create `Backbone.Collection` with passed data and perform Backbone `set`.
                        if (relation.type === Backbone.Many) {
                            // `collectionType` of defined `relation` should be instance of `Backbone.Collection`.
                            if (collectionType && !collectionType.prototype instanceof BackboneCollection) {
                                throw new Error('collectionType must inherit from Backbone.Collection');
                            }

                            if (currVal) {
                                // Setting this flag will prevent events from firing immediately. That way clients
                                // will not get events until the entire object graph is updated.
                                currVal._deferEvents = true;

                                // Use Backbone.Collection's `reset` or smart `set` method
                                currVal[relationOptions.reset ? 'reset' : 'set'](val instanceof BackboneCollection ? val.models : val, relationOptions);

                                data = currVal;
                            } else {
                                newCtx = true;

                                if (val instanceof BackboneCollection) {
                                    data = val;
                                } else {
                                    if (collectionType) {
                                        data = relation.options ? new collectionType([], bindOptions(relation, self)) : new collectionType();
                                    } else {
                                        data = this._createCollection(relatedModel);
                                    }

                                    data[relationOptions.reset ? 'reset' : 'set'](val, relationOptions);
                                }
                            }
                        } else if (relation.type === Backbone.One) {

                            if (!relatedModel) throw new Error('specify a relatedModel for Backbone.One type');

                            if (!(relatedModel.prototype instanceof Backbone.AssociatedModel)) throw new Error('specify an AssociatedModel for Backbone.One type');

                            data = val instanceof AssociatedModel ? val : new relatedModel(val, relationOptions);
                            //Is the passed in data for the same key?
                            if (currVal && data[idKey] && currVal[idKey] === data[idKey]) {
                                // Setting this flag will prevent events from firing immediately. That way clients
                                // will not get events until the entire object graph is updated.
                                currVal._deferEvents = true;
                                // Perform the traditional `set` operation
                                currVal._set(val instanceof AssociatedModel ? val.attributes : val, relationOptions);
                                data = currVal;
                            } else {
                                newCtx = true;
                            }
                        } else {
                            throw new Error('type attribute must be specified and have the values Backbone.One or Backbone.Many');
                        }

                        attributes[relationKey] = data;
                        relationValue = data;

                        // Add proxy events to respective parents.
                        // Only add callback if not defined or new Ctx has been identified.
                        if (newCtx || relationValue && !relationValue._proxyCallback) {
                            relationValue._proxyCallback = function () {
                                return this._bubbleEvent.call(this, relationKey, relationValue, arguments);
                            };
                            relationValue.on("all", relationValue._proxyCallback, this);
                        }
                    }
                    //Distinguish between the value of undefined versus a set no-op
                    if (attributes.hasOwnProperty(relationKey) && reverseRelation) {
                        //Maintain reverse pointers
                        var updated = attributes[relationKey],
                            reverseKey = reverseRelation.key;

                        if (updated && reverseRelation.key) {
                            updated[reverseKey] = this;
                            updated.reverseRelations = updated.reverseRelations || [];
                            updated.reverseRelations.push(reverseRelation);
                        }
                    }
                }, this);
            }
            // Return results for `BackboneModel.set`.
            return ModelProto.set.call(this, attributes, options);
        },
        // Bubble-up event to `parent` Model
        _bubbleEvent: function _bubbleEvent(relationKey, relationValue, eventArguments) {
            var args = eventArguments,
                opt = args[0].split(":"),
                eventType = opt[0],
                catch_all = args[0] == "nested-change",
                eventObject = args[1],
                colObject = args[2],
                indexEventObject = -1,
                _proxyCalls = relationValue._proxyCalls,
                cargs,
                eventPath,
                basecolEventPath,
                isDefaultEvent = _.indexOf(defaultEvents, eventType) !== -1;

            //Short circuit the listen in to the nested-graph event
            if (catch_all) return;

            // Change the event name to a fully qualified path.
            _.size(opt) > 1 && (eventPath = opt[1]);

            if (_.indexOf(collectionEvents, eventType) !== -1) {
                colObject = eventObject;
            }

            // Find the specific object in the collection which has changed.
            if (relationValue instanceof BackboneCollection && isDefaultEvent && eventObject) {
                var pathTokens = getPathArray(eventPath),
                    initialTokens = _.initial(pathTokens),
                    colModel;

                colModel = relationValue.find(function (model) {
                    if (eventObject === model) return true;
                    if (!model) return false;
                    var changedModel = model.get(initialTokens);

                    if ((changedModel instanceof AssociatedModel || changedModel instanceof BackboneCollection) && eventObject === changedModel) return true;

                    changedModel = model.get(pathTokens);

                    if ((changedModel instanceof AssociatedModel || changedModel instanceof BackboneCollection) && eventObject === changedModel) return true;

                    if (changedModel instanceof BackboneCollection && colObject && colObject === changedModel) return true;
                });
                colModel && (indexEventObject = relationValue.indexOf(colModel));
            }

            // Manipulate `eventPath`.
            eventPath = relationKey + (indexEventObject !== -1 && (eventType === "change" || eventPath) ? "[" + indexEventObject + "]" : "") + (eventPath ? pathSeparator + eventPath : "");

            // Short circuit collection * events
            if (/\[\*\]/g.test(eventPath)) return this;
            basecolEventPath = eventPath.replace(/\[\d+\]/g, '[*]');

            cargs = [];
            cargs.push.apply(cargs, args);
            cargs[0] = eventType + ":" + eventPath;

            // If event has been already triggered as result of same source `eventPath`,
            // no need to re-trigger event to prevent cycle.
            _proxyCalls = relationValue._proxyCalls = _proxyCalls || {};
            if (this._isEventAvailable.call(this, _proxyCalls, eventPath)) return this;

            // Add `eventPath` in `_proxyCalls` to keep track of already triggered `event`.
            _proxyCalls[eventPath] = true;

            // Set up previous attributes correctly.
            if ("change" === eventType) {
                this._previousAttributes[relationKey] = relationValue._previousAttributes;
                this.changed[relationKey] = relationValue;
            }

            // Bubble up event to parent `model` with new changed arguments.
            this.trigger.apply(this, cargs);

            //Only fire for change. Not change:attribute
            if ("change" === eventType && this.get(eventPath) != args[2] || _.indexOf(["add", "remove", "reset", "sort"], eventType) !== -1) {
                // Zmags patch: this used to test for args[2] only for options, but they are often
                // at args[3] for nested changes. Hence, we know forward the last argument if we deem it
                // to be options...
                var ncargs = ["nested-change", eventPath, args[1]],
                    arg = args[args.length - 1];
                if (arg && !(arg instanceof BackboneModel)) {
                    ncargs.push(arg); //args[2] or [3] will be options if present
                }
                // Zmags patch end
                this.trigger.apply(this, ncargs);
            }

            // Remove `eventPath` from `_proxyCalls`,
            // if `eventPath` and `_proxyCalls` are available,
            // which allow event to be triggered on for next operation of `set`.
            if (_proxyCalls && eventPath) delete _proxyCalls[eventPath];

            // Create a collection modified event with wild-card
            if (eventPath !== basecolEventPath) {
                cargs[0] = eventType + ":" + basecolEventPath;
                this.trigger.apply(this, cargs);
            }

            return this;
        },

        // Has event been fired from this source. Used to prevent event recursion in cyclic graphs
        _isEventAvailable: function _isEventAvailable(_proxyCalls, path) {
            return _.find(_proxyCalls, function (value, eventKey) {
                return path.indexOf(eventKey, path.length - eventKey.length) !== -1;
            });
        },

        // Returns New `collection` of type `relation.relatedModel`.
        _createCollection: function _createCollection(type) {
            var collection,
                relatedModel = type;
            _.isString(relatedModel) && (relatedModel = map2Scope(relatedModel));
            // Creates new `Backbone.Collection` and defines model class.
            if (relatedModel && relatedModel.prototype instanceof AssociatedModel) {
                collection = new BackboneCollection();
                collection.model = relatedModel;
            } else {
                throw new Error('type must inherit from Backbone.AssociatedModel');
            }
            return collection;
        },

        // Process all pending events after the entire object graph has been updated
        _processPendingEvents: function _processPendingEvents() {
            if (!this._processedEvents) {
                this._processedEvents = true;

                this._deferEvents = false;

                // Trigger all pending events
                _.each(this._pendingEvents, function (e) {
                    e.c.trigger.apply(e.c, e.a);
                });

                this._pendingEvents = [];

                // Traverse down the object graph and call process pending events on sub-trees
                _.each(this.relations, function (relation) {
                    var val = this.attributes[relation.key];
                    val && val._processPendingEvents();
                }, this);

                delete this._processedEvents;
            }
        },

        // Override trigger to defer events in the object graph.
        trigger: function trigger(name) {
            // Defer event processing
            if (this._deferEvents) {
                this._pendingEvents = this._pendingEvents || [];
                // Maintain a queue of pending events to trigger after the entire object graph is updated.
                this._pendingEvents.push({ c: this, a: arguments });
            } else {
                ModelProto.trigger.apply(this, arguments);
            }
        },

        // The JSON representation of the model.
        toJSON: function toJSON(options) {
            var json = {},
                aJson;
            json[this.idAttribute] = this.id;
            if (!this.visited) {
                this.visited = true;
                // Get json representation from `BackboneModel.toJSON`.
                json = ModelProto.toJSON.apply(this, arguments);

                var reverseRelations = this.reverseRelations || this.collection && this.collection.reverseRelations;
                if (reverseRelations) {
                    _.each(reverseRelations, function (reverseRelation) {
                        if (reverseRelation.includeInJSON && this[reverseRelation.key]) {
                            json[reverseRelation.key] = this[reverseRelation.key].get(reverseRelation.includeInJSON);
                        } else {
                            delete json[reverseRelation.key];
                        }
                    }, this);
                }

                // If `this.relations` is defined, iterate through each `relation`
                // and added it's json representation to parents' json representation.
                if (this.relations) {
                    _.each(this.relations, function (relation) {
                        var attr = this.attributes[relation.key];
                        if (attr) {
                            // Zmags patch: pass down relation information in order to assign temp ids for non
                            // identifiables stored in collections as they can still move around the collection
                            // until a server response is processed, only needed on sync as we can have
                            // intermediate changes...
                            if (options && options.sync) {
                                var old = options.relation; // handle recursion!
                                options.relation = relation;
                                aJson = attr.toJSON(options);
                                if (old) {
                                    options.relation = old;
                                } else {
                                    delete options.relation;
                                }

                                // Standard backbone way...
                            } else {
                                aJson = attr.toJSON(options);
                            }
                            json[relation.key] = _.isArray(aJson) ? _.compact(aJson) : aJson;
                        }
                    }, this);
                }
                delete this.visited;
            }
            return json;
        },

        // Create a new model with identical attributes to this one.
        clone: function clone() {
            return new this.constructor(this.toJSON());
        },

        // Call this if you want to set an `AssociatedModel` to a falsy value like undefined/null directly.
        // Not calling this will leak memory and have wrong parents.
        // See test case "parent relations"
        cleanup: function cleanup() {
            _.each(this.relations, function (relation) {
                var val = this.attributes[relation.key];
                val && (val.parents = _.difference(val.parents, [this]));
            }, this);
            this.off();
        },

        // Navigate the path to the leaf object in the path to query for the attribute value
        _getAttr: function _getAttr(path) {

            var result = this,

            //Tokenize the path
            attrs = getPathArray(path),
                key,
                i;
            if (_.size(attrs) < 1) return;
            for (i = 0; i < attrs.length; i++) {
                key = attrs[i];
                if (!result) break;
                //Navigate the path to get to the result
                result = result instanceof BackboneCollection ? isNaN(key) ? undefined : result.at(key) : result.attributes[key];
            }
            return result;
        }
    });

    // Tokenize the fully qualified event path
    var getPathArray = function getPathArray(path) {
        if (path === '') return [''];
        return _.isString(path) ? path.match(delimiters) : path || [];
    };

    var map2Scope = function map2Scope(path) {
        return _.reduce(path.split(pathSeparator), function (memo, elem) {
            return memo[elem];
        }, root);
    };

    var bindOptions = function bindOptions(relation, scope) {
        var options = _.clone(relation.options);

        // Make sure all functions declared in relations options are scoped to *this*...
        _.each(options, function (value, name) {
            if (_.isFunction(value)) {
                options[name] = value.bind(scope);
            }
        });

        return options;
    };

    //Infer the relation from the collection's parents and find the appropriate map for the passed in `models`
    /*var map2models = function (parents, target, models) {
        var relation, surrogate;
        //Iterate over collection's parents
        _.find(parents, function (parent) {
            //Iterate over relations
            relation = _.find(parent.relations, function (rel) {
                return parent.get(rel.key) === target;
            }, this);
            if (relation) {
                surrogate = parent;//surrogate for transformation
                return true;//break;
            }
        }, this);
         //If we found a relation and it has a mapping function
        if (relation && relation.map) {
            return relation.map.call(surrogate, models, target);
        }
        return models;
    };*/

    var proxies = {};
    // Proxy Backbone collection methods
    /*_.each(['set', 'remove', 'reset'], function (method) {
        proxies[method] = BackboneCollection.prototype[method];
         CollectionProto[method] = function (models, options) {
            return proxies[method].apply(this, arguments);
        }
    });*/

    // Override trigger to defer events in the object graph.
    proxies['trigger'] = CollectionProto['trigger'];
    CollectionProto['trigger'] = function (name) {
        if (this._deferEvents) {
            this._pendingEvents = this._pendingEvents || [];
            // Maintain a queue of pending events to trigger after the entire object graph is updated.
            this._pendingEvents.push({ c: this, a: arguments });
        } else {
            proxies['trigger'].apply(this, arguments);
        }
    };

    // Attach process pending event functionality on collections as well. Re-use from `AssociatedModel`
    CollectionProto._processPendingEvents = AssociatedModel.prototype._processPendingEvents;

    // Zmags patch to handle serialization of "cid"'s as data (attributes) to track models
    // without ids between a request and (the changes in between) a response! This is needed
    // as our model graphs both include Backbone.Model and ImprovedModel's, mixed together...

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    ModelProto.set = function (key, val, options) {
        var attr, attrs, unset, changes, silent, changing, prev, current;
        if (key == null) return this;

        // Handle both `"key", value` and `{key: value}` -style arguments.
        if ((typeof key === "undefined" ? "undefined" : _typeof(key)) === 'object') {
            attrs = key;
            options = val;
        } else {
            (attrs = {})[key] = val;
        }

        options || (options = {});

        // Run validation.
        if (!this._validate(attrs, options)) return false;

        // Extract attributes and options.
        unset = options.unset;
        silent = options.silent;
        changes = [];
        changing = this._changing;
        this._changing = true;

        if (!changing) {
            this._previousAttributes = _.clone(this.attributes);
            this.changed = {};
        }
        current = this.attributes, prev = this._previousAttributes;

        // Check for changes of `id`.
        if (this.idAttribute in attrs) this.id = attrs[this.idAttribute];

        // Zmags patch: make sure temp id (cid) sent to server and back in responses
        // will never be set as an attribute, it will already have been used to
        // pair relevant models. This is *not* the actual cid set on the model
        // for internal bookkeeping!
        delete attrs.cid;
        // Zmags patch end!

        // For each `set` attribute, update or delete the current value.
        for (attr in attrs) {
            val = attrs[attr];
            if (!_.isEqual(current[attr], val)) changes.push(attr);
            if (!_.isEqual(prev[attr], val)) {
                this.changed[attr] = val;
            } else {
                delete this.changed[attr];
            }
            unset ? delete current[attr] : current[attr] = val;
        }

        // Trigger all relevant attribute changes.
        if (!silent) {
            if (changes.length) this._pending = true;
            for (var i = 0, l = changes.length; i < l; i++) {
                this.trigger('change:' + changes[i], this, current[changes[i]], options);
            }
        }

        // You might be wondering why there's a `while` loop here. Changes can
        // be recursively nested within `"change"` events.
        if (changing) return this;
        if (!silent) {
            while (this._pending) {
                this._pending = false;
                this.trigger('change', this, options);
            }
        }
        this._pending = false;
        this._changing = false;
        return this;
    };

    return AssociatedModel; // Zmags patch
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);

    /**
     * The Injector is used to register specific instances identified by a given
     * token, e.g. <tt>Injector.register("mainController", new MainController())</tt>;
     *
     * The Injector is part of the <tt>zbone/Extend</tt> module, that enables DI at the
     * very core.
     *
     * A typical class definition, using DI, would look like this:
     *
     * <tt>
     * Class.extend({
     *     constructor: function (foo, boo) {
     *
     *     }
     * }, {
     *     injection: ["foo", "boo"]
     * });
     * </tt>
     *
     * The <tt>injection</tt> hash also supports wrapping the arguments in a single "options"
     * hash (the Backbone way):
     *
     * <tt>
     * injection: {
     *     parameters: ["foo", "boo"],
     *     asOptions: true
     * }
     * </tt>
     *
     * @class Injector
     * @constructor
     */
    var Injector = function Injector() {
        this._registry = {};
    };

    Injector.prototype = {
        _createParametersArray: function _createParametersArray(parameters, additionalArguments) {
            var _this = this;

            var instances = [];

            _.each(parameters, function (value) {
                var instance = _this.get(value);
                if (!instance) {
                    throw new Error(value + " has not been registered.");
                }
                instances.push(instance);
            }, this);

            if (additionalArguments) {
                instances = instances.concat(additionalArguments);
            }

            return instances;
        },
        _createParametersObject: function _createParametersObject(parameters, additionalArguments) {
            var _this2 = this;

            var options = {};

            _.each(parameters, function (value) {
                var instance = _this2.get(value);
                if (!instance) {
                    throw new Error(value + " has not been registered.");
                }
                options[value] = instance;
            });

            // Apply any additional options to the parsed hash of options
            if (additionalArguments && additionalArguments.length === 1) {
                var additionalOptions = additionalArguments[0];
                _.extend(options, additionalOptions);
            }

            return [options];
        },
        getParameters: function getParameters(injectionOptions, additionalArguments) {
            var parameters = _.isArray(injectionOptions) ? injectionOptions : injectionOptions.parameters;

            return injectionOptions.asOptions ? this._createParametersObject(parameters, additionalArguments) : this._createParametersArray(parameters, additionalArguments);
        },
        register: function register(identifier, instance) {
            this._registry[identifier] = instance;
        },
        has: function has(identifier) {
            return this._registry[identifier] !== undefined;
        },
        get: function get(identifier) {
            if (!this.has(identifier)) {
                throw new Error("'" + identifier + "' has not been registered with the Injector.");
            }
            return this._registry[identifier];
        }
    };

    // Singleton
    return new Injector();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(100);
    var SalesforceCommerceQuickViewService = __webpack_require__(1400);
    var ViewerEvents = __webpack_require__(153);

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank;

    var Window = __webpack_require__(48);

    /**
     * Action that launches a SalesforceCommerce QuickView JavaScript function on the containing page.
     *
     * @class SalesforceCommerceQuickViewAction
     * @constructor
     */
    return Action.extend("SalesforceCommerceQuickViewAction", {

        defaults: {
            productID: ""
        },

        _clientSpace: true, // all SalesforceCommerce QuickViews run in client space always

        /**
         * @type {jQuery}
         * The root element of the SalesforceCommerce Quickview if and only if we can hook into it.
         */
        _root: null,

        _activateable: function _activateable() {
            if (isBlank(this.get("productID"))) {
                return "Missing product id";
            } else if (!Window.sandbox(["app.quickView.show", "__zmags.demandware.quickview.show"])) {
                return "No SalesforceCommerce Quickview found";
            }
            return null; // no error
        },
        _activate: function _activate(experienceViewModel) {
            var name = experienceViewModel.get("experience").get("name");
            var currentScene = experienceViewModel.get("currentScene");
            var productId = this.get("productID");

            // Will be dependent on the different type of QuickView used... :/
            this._root = SalesforceCommerceQuickViewService.openSalesforceCommerceQuickView(productId, name, currentScene);

            var silent = { silent: true };
            var eventArgs = { type: "demandware", context: "quickview", productId: productId };

            if (this._root) {
                this.set({
                    // Trigger a Lightbox open for consistency, just before the desired PRODUCT_VIEW event. This will
                    // also ensure that DnD behaves nicely, i.e. will close any dangling opened product windows on
                    // reload/update of the DnD page, just like our internal Lightbox...
                    event: [ViewerEvents.LIGHTBOX_OPEN, ViewerEvents.PRODUCT_VIEW],
                    pendingEvent: ViewerEvents.LIGHTBOX_CLOSE,
                    stalled: true,
                    paused: false
                }, silent);

                // Listen for "dialogclose" event from the quickview so we can raise the pending event
                // to signal completion...
                this._root.one("dialogclose", this._trigger.bind(this, "pendingEvent", experienceViewModel, eventArgs));

                // Cannot be pending, but still trigger a PRODUCT_VIEW event!...
            } else {
                this.set({
                    event: ViewerEvents.PRODUCT_VIEW,
                    pendingEvent: null,
                    stalled: null,
                    paused: null
                }, silent);
            }

            // Final event argument...
            return eventArgs;
        },
        close: function close() {
            if (this._root) {
                // Use jQuery to trigger a "close", which will trigger a "dialogclose", which we listen for above - the
                // circle is complete!... :)
                this._root.trigger("close");
                this._root = null;
            }
        }
    }, {
        /** @see {WidgetTypes.SALESFORCE_COMMERCE} */
        TYPE: "demandware"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var Window = __webpack_require__(48);

    /**
     * Exposes a SalesforceCommerce Site Genesis Strategy Class.
     *
     * @class SalesforceCommerceQuickViewSiteGenesisStrategy
     */
    return Class.extend({

        _strategy: null,

        /**
         * Sets the chosen QuickView strategy.
         * @param {SalesforceCommerceQuickViewSiteGenesisStrategy} strategy - The chosen strategy.
         */
        setStrategy: function setStrategy(strategy) {
            this._strategy = strategy;
        },


        /**
         * Returns a *client site jQuery* element wrapping the root of the opened SalesforceCommerce QuickView if
         * currently available (probably a very old jQuery version).
         *
         * @return {jQuery} The SalesforceCommerce QuickView root element, if currently available; can be falsey.
         */
        _quickViewRoot: function _quickViewRoot() {
            var $ = Window.sandbox("$");
            if ($) {
                var root = $("#QuickViewDialog");
                if (root.length && typeof root.dialog === "function") {
                    return root;
                }
            }
            return null;
        },


        /**
         * Opens the specific QuickView given the chosen strategy.
         * @param {String} productID The SalesforceCommerce OCAPI Product Id.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         */
        open: function open(productID, experienceName, currentScene) {
            this._strategy.open(productID, experienceName, currentScene);
            return this._quickViewRoot();
        },


        /**
         * Format the QuickView parameters.
         * @param {String} productID The SalesforceCommerce OCAPI Product Id.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         * @returns {string}
         */
        formatParameters: function formatParameters(productID, experienceName, currentScene) {
            experienceName = encodeURIComponent(experienceName);
            return "?format=ajax&zmagssrc=creator&experienceName=" + experienceName + "&experienceScene=" + currentScene + "&pid=" + productID;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var EmbedMixin = __webpack_require__(765);
    var ViewerLightbox = __webpack_require__(1404);
    var ViewerEvents = __webpack_require__(153);
    var UrlUtil = __webpack_require__(46);
    var Window = __webpack_require__(48);
    var channelBridge = __webpack_require__(241);
    var Action = __webpack_require__(100);

    var TYPE = "lightbox";

    /**
     * Closes the lightbox from within the lightbox (code) itself. <p>
     *
     * See http://documentation.zmags.com/lightboxapi/symbols/com.zmags.api.Lightbox.html
     *
     * @param {Window}         win    The iframe window object, not the global one; never false. This means the
     *                                export will never conflict with other Experiences/Channels.
     * @param {LightboxAction} action The Lightbox action to close; never false.
     */
    function exportClose(win, action) {
        win.com = win.com || {};
        win.com.zmags = win.com.zmags || {};
        win.com.zmags.api = win.com.zmags.api || {};
        win.com.zmags.api.Lightbox = {
            close: function close() {
                action.close();
            }
        };
    }

    /**
     * @class LightboxAction
     * Action for opening an URL in an iframe in a lightbox. <p>
     *
     * This has partly support for embedded Experiences and Groups, akin to the Embed Widget. However, an embedded
     * Experience opening up another lightbox will by design close the first one.
     *
     * @author Bo Gotthardt
     * @author Gunni Rode
     *
     * @constructor
     */
    return Action.extend("LightboxAction", {

        defaults: {
            url: "",
            height: 400,
            width: 600
        },

        // Mixin common embed functionality also used by the Embed Widget...
        mixin: EmbedMixin,

        // Triggered on open, LIGHTBOX_CLOSE triggered manually on close, with arguments (this, experienceId, url)...
        _event: ViewerEvents.LIGHTBOX_OPEN,

        // Triggered on close by this implementation, which the Viewer will listen for to ensure the lightbox
        // is closed when still pending on Viewer close...
        _pendingEvent: ViewerEvents.LIGHTBOX_CLOSE,

        // On open, stall, and thus pause, all Experiences reachable from the top most parent Experience, including
        // siblings, i.e. when embedded Experiences are in play, to ensure that all are paused and all pointer events
        // on them are ignored while this lightbox is open.
        _stalled: true, // implies "paused" = true recursively

        /**
         * @private @type {ViewerLightbox}
         * The opened Lightbox.
         */
        _box: null,
        /**
         * @private @type {HTMLElement}
         * The root of the lightbox dom.
         */
        _element: null,
        /**
         * @private
         * The url descriptor for the opened url shown in the Lightbox. <p>
         *
         * This descriptor is passed along "open" and "close" events as the last argument.
         *
         * @see #_box
         */
        _descriptor: null,
        /**
         * @private @type {Boolean}
         * True if we failed to embed the Experience or Group via channels, false otherwise. If so, a direct url
         * will be used as fallback. If the url is not an embedding url, always false.
         */
        _failedToEmbed: false,

        /**
         * @protected
         * Sub-type hook to return the full url to open via this link option, defaulting to just returning the
         * "url" attribute. Based on the returned url, an url descriptor will be created to check for
         * embedded Experiences or Groups.
         *
         * @param  {ExperienceViewModel} experienceViewModel The current Experience View Model; never falsey.
         * @return {String} The url for the lightbox; can be falsey (which means this action cannot be activated).
         */
        _url: function _url() {
            return this.get("url");
        },
        _activateable: function _activateable() {
            var url = this._url();
            if (!url) {
                return "Missing url";
            }
            return UrlUtil.getUrlDescriptor(url).valid ? null : "Url invalid";
        },


        /**
         * @protected
         * Activates this action.
         */
        _activate: function _activate(experienceViewModel) {
            var _this = this;

            var win = Window.topWindow();
            var scene = experienceViewModel.get("currentScene");

            var embed = false;
            var bridge = void 0;
            var channel = void 0;
            var iframe = void 0; // when no channel bridge is available for Experience/Group or if failed to embed via channels

            // If recursively called because channel embedding failed, re-use existing Lightbox since we will already
            // have issue "event" and listening for "pendingEvent"...
            if (!this._failedToEmbed) {
                // Get url descriptor for embedding support, and to pass it along the events...
                this._descriptor = UrlUtil.getUrlDescriptor(this._url(experienceViewModel));

                // Lightbox, including overlay, *always* lives in the top level dom...
                bridge = channelBridge();
                embed = bridge && this._descriptor.type !== "url";

                // Wrap the iframe in an element with overflow:hidden to avoid an iOS 6 problem where the iframe
                // is always the size of its content. We create the element in the top level dom, as the quickview is
                // a "singleton" that goes on top of all other content...
                this._element = $(win.document.createElement("div")).css({
                    overflow: "hidden",
                    width: this.get("width"),
                    height: this.get("height")
                });

                // We have to always use the top most reachable window for the Lightbox, or the overlay and Lightbox
                // itself will be relative to the (embedded) Viewer only. We use the default computed zIndex for
                // the lightbox as we are using the top level dom, i.e. each embedded Experience via a Lightbox will
                // use a higher z index...
                this._box = new ViewerLightbox(this._element, { win: win });
            }

            // If we have a channel bridge, we still cannot embed until the target element is in the dom, i.e. after
            // the lightbox has opened. This is why we do the embed once the lightbox triggers an "open" event. We
            // always use the top window/document here, since the lightbox uses the top level dom always...
            if (embed) {
                this._descriptor.sameOrigin = true; // for consistency
                this._box.once("open", function () {
                    channel = bridge.embed({
                        // These two for channel naming...
                        scene: scene,
                        descriptor: _this._descriptor,
                        element: _this._element,
                        embedType: TYPE,
                        // Always top level window/dom...
                        channel: { win: win },
                        // If the embedding via channels somehow fails, default to a direct url. This is deferred, so
                        // the "event" will already have been fired and this Action primed to
                        callback: function callback(populated) {
                            if (populated) {
                                _this._childOptions(experienceViewModel, win, channel.container()); // container = iframe
                            } else {
                                // Manually remove now; the removal on close below will just be ignored when invoked...
                                bridge.removeEmbed(channel, _this._failedToEmbed = true); // true: destroy
                                channel = null;
                                // Call this recursively, not "activate", so we do not issue events because of this...
                                _this._activate(experienceViewModel);
                            }
                        }
                    });
                });
                this._box.once("close", function () {
                    // also called on forceful close if the channel embedding fails
                    // Do a full destroy as this lives in the global dom, including calling ViewerProxy.close to close
                    // Viewers recursively...
                    bridge.removeEmbed(channel, true);
                });

                // Use an iframe if no bridge or if just any old url not pointing to an embedded Experience/Group. It will
                // not help us much listening for embedded iframe window "unload" events...
            } else {
                iframe = this._createIframe(this._descriptor, { frameBorder: 0 }).css({
                    height: this.get("height"),
                    width: this.get("width")
                });

                // Manually append the iframe to show in the lightbox. Even we are defaulting to a direct url because
                // the embedding via channels failed, "_element" will be empty as the channel will be been restored...
                this._element.append(iframe);

                // Note that on same domains, 404 will often generate a "load" event because web servers tend
                // to deliver content along side a 404 status code - but the iframe cannot access the state code,
                // only the content...
                iframe.one("load", function () {
                    var iframeWin = iframe.get(0).contentWindow;

                    // If the iframe is on the same domain so we can access it directly, then inject something that
                    // matches the signature of the old lightbox API...
                    if (_this._descriptor.sameOrigin) {
                        exportClose(iframeWin, _this);

                        // If the iframe is yanked out, remember to close the lightbox as well. We can only do this
                        // for same origins or we will get a security error...
                        // sometimes this seems to be called numerous times, so this ensures it will not!
                        Window.unload(function () {
                            return true;
                        }, iframeWin);

                        // Same origin, so safe to sniff the document title for potential error code; this will not
                        // break Lightbox functionality, we just want to report it so we can track it in LogStash...
                        _this._statusCode(iframeWin);
                    }

                    // If we get a command from the old lightbox API, handle it with our lightbox. The lightbox
                    // API always post to its parent, i.e. the parent of the iframe, so we have to listen there...
                    var listener = Window.until("message", function (e) {
                        if (e.originalEvent.data === "closeLightbox") {
                            // See http://documentation.zmags.com/lightboxapi/symbols/com.zmags.api.Lightbox.html
                            _this.close();
                            return true; // done, so remove!
                        }
                    }, Window.parent());

                    _this._box.once("close", listener.off); // already scoped
                });

                if (this._descriptor.type !== "url" && this._descriptor.sameOrigin) {
                    this._childOptions(experienceViewModel, win, iframe[0]);
                }

                // TODO: consider logic for blanking urls like for EmbedWidget, e.g. to stop videos.
                iframe.prop("src", UrlUtil.getEmbedURL(this._descriptor, TYPE, scene)); // e.g. "?lightbox=.." in url
            }

            // Return raw embed url as an event argument, ignoring query parameters, and even when in Channel mode,
            // making it possible to track the same Experience regardless of how it was used based on the same url...
            var eventArgs = { url: UrlUtil.getEmbedURL(this._descriptor), context: TYPE }; // "raw" url!

            // Attached close handler to trigger pending event and open, but only so it if not already done!...
            if (!this._failedToEmbed) {
                // Trigger additional event on close for this lightbox action. The Viewer - and others - will be listening
                // for this event, keeping a reference to this Action to close. This handler will also reset this action
                // for re-activation, e.g. if the widget using this action is clicked again...
                this._box.once("close", function () {
                    _this._trigger("pendingEvent", experienceViewModel, eventArgs); // Viewer event thus like LIGHTBOX_CLOSE: (this, id, eventArgs)

                    // Remember to close embedded Viewer recursively for direct urls, if any, as we do not have
                    // an in-place Channel to call the Viewer proxy for us...
                    if (iframe && _this._descriptor.type !== "url") {
                        Window.viewer(iframe[0], "state", { name: "closed", value: true }); // will recurse
                    }

                    _this._box = null;
                    _this._element.empty(); // make sure iframe is explicitly garbage collected...
                    _this._element = null;
                    _this._descriptor = null;
                    _this._failedToEmbed = false;
                });

                this._box.open();
            }
            return Object.assign({ actionId: this.id, widgetId: this.attributes.widgetId }, eventArgs); // Viewer event thus like LIGHTBOX_OPEN: (this, id, eventArgs)
        },


        /**
         * @private
         * Make sure the Viewer loaded in the Lightbox iframe knows that this Viewer is the parent, not the top most
         * one in the window used for the Lightbox overlay and Lightbox itself.
         *
         * @param {ExperienceViewModel} experienceViewModel The Experience View Model; never null.
         * @param {Window}              win                 The top most window the Lightbox lives in; never null.
         * @param {HTMLElement}         iframe              The iframe storing the embedded Viewer; never null.
         */
        _childOptions: function _childOptions(experienceViewModel, win, iframe) {
            // For direct urls...
            Window.viewer(win, "register", iframe, null, Window.viewer());

            // Since this is an Action, and not a Widget, it is not directly updated based on recursive Viewer
            // state updates like "change:active", triggered via re-render that for example pass on the active
            // state to the EmbedWidgetView. We thus have to listen for "change:active" changes and relay them to
            // the embedded Experience here...
            this.listenTo(experienceViewModel, "change:active", function (model, active) {
                Window.viewer(iframe, "state", { name: "active", value: active }); // will recurse!
            });
        },


        /**
         * Manually closes the opened Lightbox, if still open. <p>
         *
         * The Viewer will ensure this is called if the Viewer is closed while the Lightbox is open.
         */
        close: function close() {
            if (this._box) {
                this._box.close();
            }
        }
    }, {
        TYPE: TYPE
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var SVGContent = __webpack_require__(1406);

    /**
     * Various SVG icons.
     *
     * To get the contents of an .svg file in here, cut out the stuff inside <svg></svg>, edit it to remove linebreaks and tabs, and convert " to '.
     * Also remove any elements with "display: none".
     *
     * @class Icons
     */
    return {
        CLOSE: new SVGContent({
            content: "<g><circle stroke='#FFFFFF' fill='#626262' stroke-width='1.5' stroke-miterlimit='10' cx='14' cy='14' r='13.009'/><g><line stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-miterlimit='10' x1='9.704' y1='18.257' x2='18.296' y2='9.666'/><line stroke='#FFFFFF' stroke-width='1.5' stroke-linecap='round' stroke-miterlimit='10' x1='9.704' y1='9.666' x2='18.296' y2='18.257'/></g></g>",
            width: 28,
            height: 28
        }),
        CLOSE_IN_BOX: new SVGContent({
            content: "<g><line stroke='#626262' stroke-width='1.5' stroke-linecap='round' stroke-miterlimit='10' x1='9.704' y1='18.257' x2='18.296' y2='9.666'/><line stroke='#626262' stroke-width='1.5' stroke-linecap='round' stroke-miterlimit='10' x1='9.704' y1='9.666' x2='18.296' y2='18.257'/></g>",
            width: 28,
            height: 28
        }),
        DROP_TARGET_LARGE: new SVGContent({
            content: "<g><g><circle fill='none' stroke='#FFFFFF' stroke-miterlimit='10' cx='52' cy='52' r='50'/><circle fill='none' stroke='#FFFFFF' stroke-miterlimit='10' cx='52' cy='52' r='40'/></g><g><line fill='none' stroke='#FFFFFF' stroke-miterlimit='10' x1='27' y1='52' x2='77' y2='52'/><line fill='none' stroke='#FFFFFF' stroke-miterlimit='10' x1='52' y1='27' x2='52' y2='77'/></g></g>",
            width: 104,
            height: 104
        }),
        DROP_TARGET_LARGE_DARK: new SVGContent({
            content: "<g><g><circle fill='none' stroke='#343e43' stroke-miterlimit='10' cx='52' cy='52' r='50'/><circle fill='none' stroke='#343e43' stroke-miterlimit='10' cx='52' cy='52' r='40'/></g><g><line fill='none' stroke='#343e43' stroke-miterlimit='10' x1='27' y1='52' x2='77' y2='52'/><line fill='none' stroke='#343e43' stroke-miterlimit='10' x1='52' y1='27' x2='52' y2='77'/></g></g>",
            width: 104,
            height: 104
        }),
        DROP_TARGET_SMALL: new SVGContent({
            content: "<g><g><circle fill='none' stroke='#FFFFFF' stroke-miterlimit='10' cx='26' cy='26' r='25'/><circle fill='none' stroke='#FFFFFF' stroke-miterlimit='10' cx='26' cy='26' r='20'/></g><g><line fill='none' stroke='#FFFFFF' stroke-miterlimit='10' x1='14' y1='26' x2='39' y2='26'/><line fill='none' stroke='#FFFFFF' stroke-miterlimit='10' x1='26' y1='14' x2='26' y2='39'/></g></g>",
            width: 52,
            height: 52
        }),
        QUESTION_MARK: new SVGContent({
            content: "<g><g><g><path fill='#777777' d='M9.241,11.256c0-1.81,2.58-1.966,2.58-3.477c0-0.712-0.556-1.325-1.682-1.325c-1.069,0-1.739,0.47-2.266,1.168L7.16,6.853c0.684-0.883,1.739-1.454,3.093-1.454c1.739,0,2.793,0.983,2.793,2.209c0,2.152-2.765,2.337-2.765,3.734c0,0.229,0.143,0.514,0.385,0.698l-0.87,0.37C9.412,12.083,9.241,11.684,9.241,11.256zM9.312,14.406c0-0.428,0.356-0.784,0.784-0.784s0.784,0.356,0.784,0.784s-0.356,0.783-0.784,0.783S9.312,14.834,9.312,14.406z'/></g></g><circle fill='none' stroke='#777777' stroke-miterlimit='10' cx='10' cy='10' r='9'/></g>",
            width: 20,
            height: 20
        }),
        SHARE_BUTTON: new SVGContent({
            content: "<path class='background' fill='none' stroke='#BCBCBC' stroke-miterlimit='10' d='M63.5,15c0,6.904-5.596,12.5-12.5,12.5H14C7.096,27.5,1.5,21.904,1.5,15l0,0C1.5,8.096,7.096,2.5,14,2.5h37C57.904,2.5,63.5,8.096,63.5,15L63.5,15z'/><g><polyline class='foreground' fill='none' stroke='#B1B2B2' stroke-width='2' stroke-miterlimit='10' points='31,8 25,8 25,22 41,22 41,13 '/></g><g><polyline class='foreground' fill='none' stroke='#B1B2B2' stroke-width='1.5' stroke-miterlimit='10' points='41.218,4.117 44.723,7.622 41.218,11.127 '/></g><g><path class='foreground' fill='none' stroke='#B1B2B2' stroke-width='1.5' stroke-miterlimit='10' d='M34.049,13.659c-1.376-1.376-1.371-3.607,0.005-4.983c0.688-0.688,1.519-1.032,2.497-1.032l8.177-0.022'/></g>",
            width: 65,
            height: 30,
            className: "share-svg"
        }),
        ALTERNATIVE_BUTTON: new SVGContent({
            content: "<path class='background' fill='none' stroke='#BCBCBC' stroke-miterlimit='10' d='M65.5,15c0,6.904-5.596,12.5-12.5,12.5H16C9.096,27.5,3.5,21.904,3.5,15l0,0C3.5,8.096,9.096,2.5,16,2.5h37C59.904,2.5,65.5,8.096,65.5,15L65.5,15z'/><g><rect class='foreground' x='26' y='8' fill='none' stroke='#B1B2B2' stroke-width='2' stroke-miterlimit='10' width='16' height='14'/><line class='foreground' fill='none' stroke='#B1B2B2' stroke-width='1.5' stroke-miterlimit='10' x1='25.976' y1='7.701' x2='42.549' y2='21.883'/><line class='foreground' fill='none' stroke='#B1B2B2' stroke-width='1.5' stroke-miterlimit='10' x1='42.549' y1='7.683' x2='25.749' y2='21.883'/></g>",
            width: 68,
            height: 30
        }),
        PLUS_BUTTON: new SVGContent({
            content: "<path class='background' fill='#626262' d='M27.837,15.181c0,7.159-5.804,12.963-12.963,12.963l0,0c-7.159,0-12.963-5.804-12.963-12.963l0,0c0-7.159,5.804-12.963,12.963-12.963l0,0C22.033,2.219,27.837,8.022,27.837,15.181L27.837,15.181z'/><g><path class='foreground' fill='#FFFFFF' d='M15.626,15.872v3.856h-1.652v-3.856h-3.42v-1.501h3.42v-3.704h1.652v3.704h3.4v1.501H15.626z'/></g>",
            width: 30,
            height: 30
        }),
        X_BUTTON: new SVGContent({
            content: "<g><path class='background' fill='#FFFFFF' d='M20.136,9.598c0,4.592-3.723,8.315-8.315,8.315l0,0c-4.592,0-8.315-3.723-8.315-8.315l0,0c0-4.592,3.723-8.315,8.315-8.315l0,0C16.413,1.283,20.136,5.006,20.136,9.598L20.136,9.598z'/><g><g><path class='foreground' fill='#626262' d='M12.765,9.609l2.153,2.154l-0.922,0.922l-2.153-2.153l-1.909,1.909l-0.838-0.838l1.909-1.909L8.937,7.626l0.922-0.923l2.068,2.068l1.899-1.898l0.838,0.838L12.765,9.609z'/></g></g></g>",
            width: 20,
            height: 20
        })
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var CustomJsAction = __webpack_require__(190);
    var SalesforceCommerceQuickViewAction = __webpack_require__(354);
    var JsAction = __webpack_require__(494);
    var LightboxAction = __webpack_require__(356);
    var LinkAction = __webpack_require__(299);
    var ProductCustomJsAction = __webpack_require__(495);
    var ProductLightboxAction = __webpack_require__(497);
    var ProductLinkAction = __webpack_require__(498);
    var SceneNavigationAction = __webpack_require__(191);

    var ACTION_CLASSES = [CustomJsAction, SalesforceCommerceQuickViewAction, JsAction, LightboxAction, LinkAction, ProductCustomJsAction, ProductLightboxAction, ProductLinkAction, SceneNavigationAction];

    /**
     * A factory/store for creating actions.
     *
     * @class ActionFactory
     */
    var ActionFactory = {

        /**
         * Returns the associated <tt>Action</tt> class/constructor function
         * from the specified type.
         *
         * @param  {String} type The action string representation.
         * @return {Function}    The action class/constructor function.
         */
        fromType: function fromType(type) {
            return _.find(ACTION_CLASSES, function (klass) {
                return klass.TYPE === type;
            });
        },


        /**
         * Creates a new <tt>Action</tt> instance from the specified type with the
         * specified (optional) options.
         *
         * @param  {String} type    The action type, e.g. <tt>LinkAction.TYPE</tt>.
         * @param  {Object} options Optional options passed to the action instance.
         * @return {Action}         A new <tt>Action</tt> instance.
         */
        newActionFromType: function newActionFromType(type, options) {
            var ActionClass = ActionFactory.fromType(type);
            return ActionClass ? new ActionClass(options || {}) : null;
        }
    };

    return ActionFactory;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Effect = __webpack_require__(78);

    var TYPE = "rotate";
    var MODE = {
        Angle: "angle",
        Infinite: "infinite"
    };
    var DIRECTION = {
        Clockwise: "cw",
        Counterclockwise: "ccw"
    };

    return Effect.extend({
        defaults: _.defaults({
            type: TYPE,
            rotation: 10,
            attentionMode: MODE.Angle,
            rotationDirection: DIRECTION.Clockwise
        }, Effect.prototype.defaults)
    }, {
        TYPE: TYPE,
        MODE: MODE,
        DIRECTION: DIRECTION
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);

    /**
     * Represents a scale on two axises, x and y.
     *
     * @class Scale
     */
    var Scale = Class.extend({

        /**
         * Constructor.
         *
         * @param  {Number} x Optional scale value, from 0-1, representing the scale
         * on the x axis. Defaults to 1.0.
         *
         * @param  {Number} y Optional scale value, from 0-1, representing the scale
         * on the y axis. Defaults to 1.0.
         */
        constructor: function constructor(x, y) {
            this.x = x || 1.0;
            this.y = y || 1.0;
        },
        average: function average() {
            return (this.x + this.y) / 2;
        },
        equals: function equals(scale) {
            if (scale === this) {
                return true;
            }

            if (!(scale instanceof Scale)) {
                return false;
            }

            return scale.x === this.x && scale.y === this.y;
        },
        toString: function toString() {
            return "Scale[x: " + this.x + "; y: " + this.y + "]";
        }
    }, {
        from: function from(x, y) {
            return new Scale(x, y);
        }
    });

    return Scale;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var WidgetCreatedActivity = __webpack_require__(1413),
        WidgetPropertiesChangedActivity = __webpack_require__(1414),
        SceneDeletedActivity = __webpack_require__(1415),
        WidgetDeletedActivity = __webpack_require__(1416),
        WidgetsGroupedActivity = __webpack_require__(1417),
        WidgetsUngroupedActivity = __webpack_require__(1418),
        DynamicProductWidgetCreatedActivity = __webpack_require__(1419);

    /**
     * Convenience class holding all the editor activities.
     *
     * @class EditorActivity
     * @author Kim
     */
    return {
        WidgetCreatedActivity: WidgetCreatedActivity,
        WidgetDeletedActivity: WidgetDeletedActivity,
        WidgetPropertiesChangedActivity: WidgetPropertiesChangedActivity,
        SceneDeletedActivity: SceneDeletedActivity,
        WidgetsGroupedActivity: WidgetsGroupedActivity,
        WidgetsUngroupedActivity: WidgetsUngroupedActivity,
        DynamicProductWidgetCreatedActivity: DynamicProductWidgetCreatedActivity
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        sortBy = _require.sortBy,
        find = _require.find,
        isEmpty = _require.isEmpty;

    var UrlUtil = __webpack_require__(46);
    var Configuration = __webpack_require__(27);

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var MathUtil = __webpack_require__(72).default;
    var ImageLibrarySourceEnum = __webpack_require__(102);

    var _require3 = __webpack_require__(1443),
        getAppropriateBoxSize = _require3.getAppropriateBoxSize;

    // Default policy widths.


    var AKAMAI_DEFAULT_WIDTHS = sortBy([320, 640, 1024, 2048, 5000]);

    var logger = new Logger("ImageURLProvider");

    // Configure options (per QA request)
    var queryConfig = {

        imageResizeEnabled: Configuration.val({
            name: "imageResizeEnabled",
            type: "boolean",
            defaultValue: true
        }),

        imageManagerEnabled: Configuration.val({
            name: "imageManagerEnabled",
            type: "boolean",
            defaultValue: false
        }),

        imageManagerPolicy: Configuration.val({
            name: "imageManagerPolicy",
            type: "string",
            defaultValue: ""
        })
    };

    /**
     * Given a valid image URL and approximate size, we build a new URL with the size parameter in and can
     * be used to request the image.
     *
     * @param {String} url  The image URL
     * @param {Boolean} cloudinaryProvider The cloudinary provider flag
     * @param {width: Number, height: Number} size  The approximate image size
     * @param {String} sourceType   The source type from where the image comes from. If undefined, images comes from Creator.
     * @returns {String}    The new URL
     * @private
     */
    function getImageUrl(url, cloudinaryProvider, size, sourceType) {
        var source = checkSourceType(sourceType) ? ImageLibrarySourceEnum.lookup(sourceType) : ImageLibrarySourceEnum.CREATOR;
        return source.getUrl(url, size, cloudinaryProvider);
    }

    /**
     * This functions check if sourceType exists
     *
     * @param {String} sourceType
     * @returns {Boolean}  sourceTypeExists boolean flag
     */
    function checkSourceType(sourceType) {
        return sourceType && ImageLibrarySourceEnum.lookup(sourceType, true);
    }

    function getOriginalImageUrl(url) {
        return UrlUtil.prependProtocol(UrlUtil.getAbsoluteViewerApiUrl(url));
    }

    /**
     * Given a valid image URL and сrop size, we build a new URL with the crop parameters in and can
     * be used to request the crop of image.
     *
     * @param {String} url  The image URL
     * @param {ImageCrop} crop  The approximate image size
     * @param {String} sourceType   The source type from where the image comes from. If undefined, images comes from Creator.
     * @returns {String}    The new URL
     * @private
     */
    function getCropImageUrl(url, crop, sourceType) {
        var source = checkSourceType(sourceType) ? ImageLibrarySourceEnum.lookup(sourceType) : ImageLibrarySourceEnum.CREATOR;
        return source.getCropUrl ? source.getCropUrl(url, crop) : url;
    }

    /**
     * Based on the passed width, will return the smallest box size that fits the passed width.
     * @param {Number} width the bounds width
     * @returns {Number} the smallest box size that fits the passed width.
     */
    function getAkamaiBoxWidth(width) {
        return find(AKAMAI_DEFAULT_WIDTHS, function (akamaiWidth) {
            return width <= akamaiWidth;
        });
    }

    /**
     * Returns the Akamai Image Manager URL.
     * @param {Model} model the Backbone model (either an image model or an effects model).
     * @param {Number} boundsWidth the width of the bounds
     * @returns {String} the akamai image manager url
     */
    function getAkamaiImageManagerUrl(model, boundsWidth) {
        var imagePolicy = queryConfig.imageManagerPolicy;
        var imageWidth = MathUtil.round(boundsWidth, 1);
        var urlParams = {
            imageManagerEnabled: true,
            imwidth: getAkamaiBoxWidth(imageWidth)
        };

        if (!isEmpty(imagePolicy)) {
            urlParams.impolicy = imagePolicy;
        }

        var imageUrl = UrlUtil.appendParamObject(model.get("imageUrl"), urlParams);

        logger.info("Using the following Akamai Image url: " + imageUrl);

        return imageUrl;
    }

    /**
     * All static provider, used by the <tt>ImageWidgetView</tt> and by the <tt>ImageToggleEffect</tt>, for creating URLs using the scaled/optimized images.
     *
     * @class ImageURLProvider
     * @author Kim
     */
    return {
        // Return function to construct actual image src
        getOriginalImageUrl: getOriginalImageUrl,
        /**
         * Returns an optimized or resized version of the image url, depending on the source type (see #getImageUrl)
         *
         * @param {ImageWidgetModel|ImageToggleEffect} model The model. It needs to be an <tt>ImageWidgetModel</tt> or an <tt>ImageToggleEffect</tt> model.
         * @param {Object} options The options object
         * @param {Object|Size} options.bounds The bounds, specifying a <tt>width</tt> and <tt>height</tt>.
         * @param {Object} options.imageServingUrl Sets the base url of source type images
         *
         * @return {String} The URL pointing to the original image or to the scaled one if the resize functionality is enabled
         */
        provide: function provide(model) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var originalImageUrl = model.get("imageUrl");
            var sourceType = model.get("sourceType");
            var crop = model.get("crop");
            var url = void 0;

            // Placeholder image doesn't have src defined
            if (!model.get("src")) {
                return originalImageUrl;
            }

            if (checkSourceType(sourceType)) {
                // Old integrations suppurt (Scene7)
                url = options.imageServingUrl && UrlUtil.concat(options.imageServingUrl, originalImageUrl);
            } else if (crop) {
                // Original creator source cropped image
                var imageUrl = UrlUtil.prependProtocol(UrlUtil.getAbsoluteViewerApiUrl(model.get("src")));
                return getCropImageUrl(imageUrl, crop, sourceType);
            } else {
                // Regular creator image
                url = UrlUtil.getAbsoluteViewerApiUrl(originalImageUrl);
            }

            if (options.bounds) {
                var boxSize = {
                    width: model.get("originalImageWidth"),
                    height: model.get("originalImageHeight")
                };
                var appropriateBoxSize = getAppropriateBoxSize(boxSize, options.bounds);

                if (queryConfig.imageManagerEnabled) {
                    return getAkamaiImageManagerUrl(model, options.bounds.width);
                }

                // The image resize should only be available if resize is supported (viewer mode), if the imageResizeEnabled query param is set to true
                // and if resize is supported (the widget has an originalImage width and height properties set)
                if (queryConfig.imageResizeEnabled && appropriateBoxSize && model.get("supportsResize") && !(sourceType && crop)) {
                    return getImageUrl(url, options.cloudinary, appropriateBoxSize, model.get("sourceType"));
                }
            }

            if (model.get("src") && !model.get("sourceType")) {
                return getImageUrl(url, options.cloudinary);
            }

            return url || originalImageUrl;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isObjectLike = __webpack_require__(196);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!(module.exports = {
    TEXT_AND_ICON: "TEXT_AND_ICON",
    TEXT_ONLY: "TEXT_ONLY",
    ICON_ONLY: "ICON_ONLY"
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WebFontVariants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebFontVariants", function() { return WebFontVariants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_data_fonts_FontProvider__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_data_fonts_FontProvider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shared_data_fonts_FontProvider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_util_Preconditions__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shared_util_Preconditions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shared_util_Preconditions__);



var FONT_WEIGHT_MAP = {
    "normal": "400",
    "bold": "700"
};
var providerToVariants = new Map();
providerToVariants.set(__WEBPACK_IMPORTED_MODULE_1_shared_data_fonts_FontProvider___default.a.STANDARD, (function () {
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.reduce([
        { weight: "400", label: "Normal" },
        { weight: "700", label: "Bold" }
    ], function (arrayMemo, seed) {
        arrayMemo.push({
            value: seed.weight,
            label: seed.label + " (" + seed.weight + ")",
            weight: seed.weight,
            style: "normal"
        });
        arrayMemo.push({
            value: seed.weight + "italic",
            label: seed.label + " Italic (" + seed.weight + ")",
            weight: seed.weight,
            style: "italic"
        });
        return arrayMemo;
    }, []);
})());
providerToVariants.set(__WEBPACK_IMPORTED_MODULE_1_shared_data_fonts_FontProvider___default.a.GOOGLE, (function () {
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.reduce([
        { weight: "100", label: "Thin" },
        { weight: "200", label: "Extra-Light" },
        { weight: "300", label: "Light" },
        { weight: "400", label: "Normal" },
        { weight: "500", label: "Medium" },
        { weight: "600", label: "Semi-Bold" },
        { weight: "700", label: "Bold" },
        { weight: "800", label: "Extra-Bold" },
        { weight: "900", label: "Ultra-Bold" }
    ], function (arrayMemo, seed) {
        arrayMemo.push({
            value: seed.weight === "400" ? "regular" : seed.weight,
            label: seed.label + " " + seed.weight,
            weight: seed.weight,
            style: "normal"
        });
        arrayMemo.push({
            value: seed.weight === "400" ? "italic" : seed.weight + "italic",
            label: seed.label + " " + seed.weight + " Italic",
            weight: seed.weight,
            style: "italic"
        });
        return arrayMemo;
    }, []);
})());
providerToVariants.set(__WEBPACK_IMPORTED_MODULE_1_shared_data_fonts_FontProvider___default.a.TYPEKIT, (function () {
    return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.reduce([
        { weight: "100", label: "Thin" },
        { weight: "300", label: "Light" },
        { weight: "400", label: "Regular" },
        { weight: "600", label: "Semibold" },
        { weight: "700", label: "Bold" },
        { weight: "800", label: "Extra Bold" },
        { weight: "900", label: "Heavy" }
    ], function (arrayMemo, seed) {
        // Typekit variants come in the format n1, n3, n4, i1, i3 etc.
        var idPostfix = seed.weight.charAt(0);
        arrayMemo.push({
            value: "n" + idPostfix,
            label: seed.label + " " + seed.weight,
            weight: seed.weight,
            style: "normal"
        });
        arrayMemo.push({
            value: "i" + idPostfix,
            label: seed.label + " " + seed.weight + " Italic",
            weight: seed.weight,
            style: "italic"
        });
        return arrayMemo;
    }, []);
})());
providerToVariants.set(__WEBPACK_IMPORTED_MODULE_1_shared_data_fonts_FontProvider___default.a.FONTS_DOT_COM, (function () {
    // Returning a single variation and style for all fonts from Fonts.com because Fonts.com
    // do not automatically group variations of fonts (WTF!?). For now we only support
    // ungrouped font projects.
    return [
        {
            value: "400",
            label: "Normal (400)",
            weight: "400",
            style: "normal"
        }
    ];
})());
providerToVariants.set(__WEBPACK_IMPORTED_MODULE_1_shared_data_fonts_FontProvider___default.a.CUSTOM, (function () {
    // Similar to `FontProvider.FONTS_DOT_COM` above
    return [
        {
            value: "400",
            label: "Normal (400)",
            weight: "400",
            style: "normal"
        }
    ];
})());
/**
 * Utility for dealing with font variations.
 *
 * @see  #get
 *
 * @class WebFontVariants
 * @author Kim
 */
var WebFontVariants = {
    /**
     * Returns a display friendly array of variants objects for the specified <tt>FontProvider</tt>.
     *
     * @param  {FontProvider} fontProvider The <tt>FontProvider</tt>.
     * @return {Object[]}                  Array of variant objects, e.g.:
     * <pre>
     * {
     *     value: "700italic",
     *     label: "Bold 700 Italic",
     *     weight: 700,
     *     style: "italic"
     * }
     * </pre>
     *
     * The variant <tt>value</tt> matches that of the associated font API, and is the same value that
     * is being persisted for text widget models <tt>fontStyle</tt>, e.g. <tt>700italic</tt>.
     */
    get: function (fontProvider) {
        __WEBPACK_IMPORTED_MODULE_2_shared_util_Preconditions___default.a.instanceOf(fontProvider, __WEBPACK_IMPORTED_MODULE_1_shared_data_fonts_FontProvider___default.a, "Must be a FontProvider instance");
        return providerToVariants.get(fontProvider);
    },
    /**
     * findVariant
     *
     * @param {Object} fontProvider
     * @param {String} fontStyle
     * @param {String} fontWeight
     * @return {Object}
     */
    findVariant: function (fontProvider, fontStyle, fontWeight) {
        var variants = this.get(fontProvider);
        fontWeight = FONT_WEIGHT_MAP[fontWeight] || fontWeight;
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.find(variants, function (variant) { return variant.weight === fontWeight && variant.style === fontStyle; });
    },
    /**
     * From a list of raw variant values, e.g. ["n1", "n3", "n4"], returns an array of the
     * matching variant objects.
     *
     * @param  {String[]} values        Array of raw variant values.
     * @param  {FontProvider} provider  The <tt>FontProvider</tt> associated with the specified variants.
     * @return {Object[]}               Array of the matching variant objects.
     */
    fromValues: function (values, provider) {
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.filter(WebFontVariants.get(provider), function (variant) { return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.contains(values, variant.value); });
    },
    fromValue: function (value, provider) {
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.first(WebFontVariants.fromValues([value], provider));
    },
    /**
     * Returns the default variant descriptor for a specified font provider.
     *
     * @param  {FontProvider} provider The <tt>FontProvider</tt>.
     * @return {Object}                The "default" variant object, i.e. <tt>normal</tt> font
     *                                 style and a font weight of <tt>400</tt>.
     */
    defaultVariant: function (provider) {
        return __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.find(WebFontVariants.get(provider), function (variant) { return variant.style === "normal" && variant.weight === "400"; });
    }
};



/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defaults = _require.defaults;

    var _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank;

    var AbstractWidgetModel = __webpack_require__(62);

    var DEFAULT_TEXT = "Your text here...";

    /**
     * Model for a text widget.
     *
     * @class TextWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Text widget", {

        transient: AbstractWidgetModel.prototype.transient.concat(["editorModel"]),

        defaults: defaults({
            type: "text",
            text: DEFAULT_TEXT,
            isDynamic: false,
            fontProvider: "standard",
            fontMetadata: {},
            fontSize: 30,
            fontStyle: "normal",
            color: "#000000",
            // Font family for the text widget container
            fontFamily: "Arial",
            lineHeight: 1.4,
            textAlign: "left",
            fontWeight: "400",
            textDecoration: "none",
            textTransform: "none",
            fontVariant: "none",
            textShadow: "none",

            // Contains all parsed font families for the whole text content, which covers nested font families
            fontFamilies: [],

            // Used to temperately store properties that needs to interact with the CharacterPropertyView
            editorModel: null,

            letterSpacing: 0
        }, AbstractWidgetModel.prototype.defaults),

        constructor: function constructor(attributes) {
            this.preserveProperties(attributes);
            this.__super();
        },
        hasText: function hasText() {
            return this.get("text") && this.get("text") !== DEFAULT_TEXT;
        },
        isValid: function isValid() {
            // We need the text string to make sense
            return !isBlank(this.get("text"));
        },
        getScaledSize: function getScaledSize(scaleX) {
            var size = AbstractWidgetModel.prototype.getScaledSize.call(this, scaleX);
            // We want to limit the minimum width to 1%
            size.width = Math.max(1, size.width);

            return size;
        },


        /**
         * Preserve the properties for the compatibility check in the view layer. If we don't do this, the raw response
         * data will be merged with default properties, which may end up corrupt data like font family(google font)
         * mismatching font provider(standard).
         *
         * @See {@link TextWidgetView.onRender calls font compatibility check}
         * @param {Object} attrs
         */
        preserveProperties: function preserveProperties(attrs) {
            if (attrs.fontFamily) {
                if (!attrs.fontProvider) {
                    attrs.fontProvider = null;
                }

                if (!attrs.fontMetadata) {
                    attrs.fontMetadata = {};
                }

                if (!attrs.fontFamilies) {
                    attrs.fontFamilies = [];
                }
            }

            if (!attrs.fontWeight) {
                attrs.fontWeight = null;
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defaults = _require.defaults;

    var AbstractWidgetModel = __webpack_require__(62);

    var _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank;

    var DEFAULT_TEXT = "";
    var DEFAULT_LINE_HEIGHT = 1.4;

    /**
     * Model for a text widget.
     *
     * @class TextWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Text Enhanced widget", {

        transient: AbstractWidgetModel.prototype.transient.concat(["editorModel", "isSelected", "fontProvider", "fontProvider", "fontMetadata", "fontStyle", "color", "fontFamily", "textAlign", "fontWeight", "textDecoration", "textTransform", "fontVariant", "textShadow", "editorModel", "letterSpacing", "rawText"]),

        defaults: defaults({
            type: "text-enhanced",
            text: DEFAULT_TEXT,
            lineHeight: DEFAULT_LINE_HEIGHT
        }, AbstractWidgetModel.prototype.defaults),

        constructor: function constructor(attributes) {
            this.preserveProperties(attributes);
            this.__super();
            // Making sure these properties are set so we always have the same baseline.
            this.set("lineHeight", DEFAULT_LINE_HEIGHT, { silent: true });
        },
        hasText: function hasText() {
            return this.get("text") && this.get("text") !== DEFAULT_TEXT;
        },
        isValid: function isValid() {
            // We need the text string to make sense
            return !isBlank(this.get("text"));
        },
        getScaledSize: function getScaledSize(scaleX) {
            var size = AbstractWidgetModel.prototype.getScaledSize.call(this, scaleX);
            // We want to limit the minimum width to 1%
            size.width = Math.max(1, size.width);

            return size;
        },


        /**
         * Preserve the properties for the compatibility check in the view layer. If we don't do this, the raw response
         * data will be merged with default properties, which may end up corrupt data like font family(google font)
         * mismatching font provider(standard).
         *
         * @See {@link TextWidgetView.onRender calls font compatibility check}
         * @param {Object} attrs
         */
        preserveProperties: function preserveProperties(attrs) {
            if (attrs.fontFamily) {
                if (!attrs.fontProvider) {
                    attrs.fontProvider = null;
                }

                if (!attrs.fontMetadata) {
                    attrs.fontMetadata = {};
                }

                if (!attrs.fontFamilies) {
                    attrs.fontFamilies = [];
                }
            }

            if (!attrs.fontWeight) {
                attrs.fontWeight = null;
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);

    /**
     * Model for a SalesforceCommerce widget.
     *
     * @class SalesforceCommerceWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("SalesforceCommerceWidget", {

        defaults: _.extend({}, AbstractWidgetModel.prototype.defaults, {
            type: "demandware",
            // TODO MOS-2342: Width and height don't seem to be used because FIXED_SIZE is used
            // instead.
            width: 53.3,
            height: 72.5,
            /**
             * @type {String}
             * OCAPI productID, this field is the only thing that the viewer will be able to see.
             */
            productID: null,
            siteId: null
        }),

        fitToScene: function fitToScene() {
            this.set({
                left: 0,
                top: 0,
                rotation: 0,
                width: 100,
                height: 100
            });
        }
    }, {
        FIXED_SIZE: {
            width: 100,
            height: 100
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractWidgetView = __webpack_require__(61);
    var WebFontsUtil = __webpack_require__(136);
    var Browser = __webpack_require__(39);
    var $ = __webpack_require__(4);

    /**
     * A regular expression that matches the <i>font-size</i> of an HTML string. Used to update
     * the font size on scale changes.
     *
     * @type {RegExp}
     */
    var FONT_SIZE_REG_EX = /font-size\s*:\s*(\d+)\s*px/gi;

    /**
     * A regular expression that matches the <i>letter-spacing</i> of an HTML string. Used to update
     * the letter-spacing on scale changes.
     *
     * @type {RegExp}
     */
    var LETTER_SPACING_REG_EX = /letter-spacing\s*:\s*(\d+)\s*px/gi;

    /**
     * Replaces \n with <br/> and updates any font sizes and letter spacings to the specified scale value.
     *
     * @param  {String} text  The HTML formatted string.
     * @param  {Number} scale The current average scale.
     *
     * @return {String} The updated HTML formatted string.
     */
    function constructHTMLText(text, scale) {
        var fontSizeHandler = function fontSizeHandler(match, sizeValue) {
            var size = Math.round(scale * parseInt(sizeValue, 10));
            return "font-size:" + size + "px";
        };

        var letterSpacingHandler = function letterSpacingHandler(match, letterSpacingValue) {
            var letterSpacing = Math.round(scale * parseInt(letterSpacingValue, 10));
            return "letter-spacing:" + letterSpacing + "px";
        };

        return text.replace("\n", "<br/>").replace(FONT_SIZE_REG_EX, fontSizeHandler).replace(LETTER_SPACING_REG_EX, letterSpacingHandler);
    }

    /**
     * The view rendering a text widget.
     *
     * @class TextWidgetView
     * @constructor
     *
     * @cfg {TextWidgetModel} model The model of the text widget being rendered.
     */
    return AbstractWidgetView.extend("TextWidget", {

        tagName: "div",

        updateRendering: function updateRendering(element) {
            // Always set properties that are cheap to handle
            var attributes = this.model.attributes;
            var scale = this.model.get("scale").average();

            /*
             * Hack because of Font boosting ( https://bugs.webkit.org/show_bug.cgi?id=FontBoosting ).
             * This behaviour, happening specifically on Chrome for Android, appears to be based on elements
             * with dynamic heights (as our text widget).
             * We need to reduce the scale of font size (proportional to the scale). The specific number seems to work
             * on most of scenarios, most used font sizes, which are not that big.
             */
            if (Browser.os.android) {
                scale -= 0.04;
            }

            var fontFamily = WebFontsUtil.quoteSpecialFontNames(WebFontsUtil.getCssFontFamily(this.model));

            if (this.model.hasActions()) {
                element.addClass("widget-with-action");
            }

            element.addClass(this.model.get("type"));

            var css = {
                fontFamily: fontFamily,
                color: attributes.color,
                fontStyle: attributes.fontStyle,
                fontWeight: attributes.fontWeight,
                fontSize: attributes.fontSize * scale,
                lineHeight: attributes.lineHeight,
                textAlign: attributes.textAlign,
                letterSpacing: attributes.letterSpacing * scale,
                textDecoration: attributes.textDecoration,
                textTransform: attributes.textTransform,
                fontVariant: attributes.fontVariant,
                textShadow: attributes.textShadow
            };

            // The "new" text widget wants HTML breaks
            var $text = $("<div>").append(constructHTMLText(attributes.text, scale));

            element.css(css);

            // In chrome, we have an issue with font being wonky when it is rotated. The following trick will
            // mitigate this problem but with a drawback that the font is a bit blurry. So the optimized solution
            // is to only apply this to the rotated ones.
            element.toggleClass("rotated", attributes.rotation !== 0);

            // Remove script tags from the text
            $text.find("script").remove();

            // Apply the text
            element.html($text.html());
        },
        onShow: function onShow() {
            var _this = this;

            this.__super();

            // Defer the IE font hack method to ensure the deferred
            // methods in TextWidgetViewEditorMixin and AbstractWidgetView are fired
            setTimeout(function () {
                _this.ieFontHack();
            }, 0);
        },


        /**
         * IE11 on Win7+8 does not render nested fonts correctly.
         * By removing and re-adding the quotes to the inline font family style
         * the fonts are re-rendered correctly
         */
        ieFontHack: function ieFontHack() {
            if (!Browser.type.ie) {
                return;
            }

            var fontElements = this.$el.find("span");

            if (fontElements.length === 0) {
                return;
            }

            fontElements.each(function (index, element) {
                var elementFontFamily = element.style.fontFamily;

                if (!elementFontFamily) {
                    return;
                }

                // Fonts are already loaded due to the initial font family style
                // Now remove the font family to enforce a re-render
                element.style.fontFamily = "";

                // Remove quotes and re-add them as single quotes as this triggers a re-render in IE
                var newFontFamily = elementFontFamily.split(",").map(function (familyName) {
                    var nameWithoutQuotes = familyName.replace(/['"]+/g, "");
                    return "'" + nameWithoutQuotes + "'";
                }).join(",");

                element.style.fontFamily = newFontFamily;
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Action = __webpack_require__(156),
        CompositeWidgetModel = __webpack_require__(173),
        LayerEnum = __webpack_require__(251),
        $ = __webpack_require__(4),
        WidgetTypes = __webpack_require__(69);

    /**
     * An action for adding widgets to a scene
     *
     * @class AddWidgetsAction
     */
    return Action.extend({

        _sceneModel: null,

        _widgetModels: [],

        _doNotSelect: false,

        _options: null,

        /**
         * Constructor
         * @param {Scene} sceneModel    A scene model.
         * @param {AbstractWidgetModel[]} widgetModels  Array of things extending <tt>AbstractWidgetModel</tt>'s.
         * @param {EditorViewModel} viewModel
         * @param {doNotSelect} a boolean used to toggle whether to select the widgets (used in the DynamicProductWidget), default is false
         */
        constructor: function constructor(sceneModel, widgetModels, editorViewModel, select, options) {
            this.__super();

            this._widgetModels = widgetModels;

            this._sceneModel = sceneModel;
            this._editorViewModel = editorViewModel;

            if (select) {
                this._doNotSelect = select;
            }

            this._options = options;
        },

        /**
         * Add widgets to the scene
         * @returns {Promise} A promise that is resolved
         */
        _performExecution: function _performExecution() {
            var currentLayer = this._editorViewModel.get("currentLayer");

            // Filter out not-allowed widgets for background scene. WidgetToolboxView is also
            // checking the hideOnBackgroundScene value.
            if (currentLayer === LayerEnum.BACKGROUND) {
                this._widgetModels = _.filter(this._widgetModels, function (widget) {
                    // Reject if any group widget has: `hideOnBackgroundScene`
                    if (widget instanceof CompositeWidgetModel) {
                        var group = widget.get("group").models;
                        var disabledGroupWidget = _.find(group, function (groupWidget) {
                            return WidgetTypes.lookup(groupWidget.get("type")).hideOnBackgroundScene;
                        });

                        if (disabledGroupWidget) {
                            return;
                        }
                    }

                    return !WidgetTypes.lookup(widget.get("type")).hideOnBackgroundScene;
                });
            }

            var modelToAddTo = void 0;
            switch (currentLayer) {
                case LayerEnum.SCENE:
                    modelToAddTo = this._sceneModel; // not the activeLayerSceneModel, as the widget may have been dropped onto the non-active scene
                    break;
                case LayerEnum.OVERLAY:
                case LayerEnum.BACKGROUND:
                    modelToAddTo = this._editorViewModel.get("activeLayerSceneModel");
                    break;
                default:
                    throw new Error("unexpected layer: " + currentLayer.toString());
            }

            var newOptions = { setLayerIndex: true, selectWidget: this._doNotSelect };

            if (this._options) {
                $.extend(newOptions, this._options);
            }

            modelToAddTo.addWidgets(this._widgetModels, newOptions);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var ExperienceModel = __webpack_require__(58);
    var Breakpoint = __webpack_require__(372);
    var Locale = __webpack_require__(373);
    var LocaleCollection = __webpack_require__(374);
    var Preconditions = __webpack_require__(14);

    var ValueType = {
        BREAKPOINT: "Breakpoint",
        LOCALE: "Localization"
    };

    var AssetReferenceType = {
        EXPERIENCE: "Experience"
    };

    var valueTypes = new Map();
    var assetReferenceTypes = new Map();
    var valueFactories = new Map();

    valueTypes.set(Breakpoint, ValueType.BREAKPOINT);
    valueTypes.set(Locale, ValueType.LOCALE);
    assetReferenceTypes.set(ExperienceModel, AssetReferenceType.EXPERIENCE);

    /**
     * Breakpoint factory
     */
    valueFactories.set(ValueType.BREAKPOINT, function (value) {
        if (value instanceof Breakpoint) {
            return value;
        }

        var threshold = void 0;

        if (value.hasOwnProperty("threshold")) {
            threshold = value.threshold;
        } else {
            threshold = value.attributes.threshold;
        }

        Preconditions.isNumber(threshold);

        return new Breakpoint({ threshold: threshold });
    });

    valueFactories.set(ValueType.LOCALE, function (value) {
        if (value instanceof Locale) {
            return value;
        }

        if (!_.isString(value)) {
            value = value.attributes.value;
        }

        return LocaleCollection.findByLocaleString(value);
    });

    /**
     * Isolates any type knowledge related to group data, in a single module.
     *
     * @module GroupsDescriptor
     */
    return {
        /**
         * Enum representation of the supported asset types, e.g. <tt>ValueType.BREAKPOINT</tt>.
         *
         * @type {Object}
         */
        ValueType: ValueType,

        /**
         * Enum representation of the supported reference types, e.g. <tt>AssetReferenceType.EXPERIENCE</tt>.
         *
         * @type {Object}
         */
        AssetReferenceType: AssetReferenceType,

        /**
         * Group value types - mapped constructor to type.
         *
         * @type {Map.<Function, String>}
         */
        valueTypes: valueTypes,

        /**
         * Group asset reference types - mapped constructor to type.
         *
         * @type {Map.<Function, String>}
         */
        assetReferenceTypes: assetReferenceTypes,

        /**
         * Map of factory functions for creating concrete values.
         *
         * @type {Map.<Function, Function>}
         */
        valueFactories: valueFactories
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var ImprovedModel = __webpack_require__(25);

  /**
   * Describes a layout breakpoint - holding the amount of space needed to cover a specific range of viewport sizes.
   *
   * @class Breakpoint
   */
  var Breakpoint = ImprovedModel.extend("Breakpoint", {

    defaults: {
      /**
       * The space covered by *this* breakpoint in pixels - or an object containing a <tt>threshold</tt> property.
       *
       * @type {Number}
       */
      threshold: NaN
    },

    getIdentifier: function getIdentifier() {
      return this.get("threshold");
    }
  });

  /**
   * Constant value representing a "starting" breakpoint.
   *
   * @type {Breakpoint}
   */
  Breakpoint.BEGIN = new Breakpoint({ threshold: 0 });

  /**
   * Constant value representing an "infinity" breakpoint.
   *
   * @type {Breakpoint}
   */
  Breakpoint.INFINITY = new Breakpoint({ threshold: Number.POSITIVE_INFINITY });

  return Breakpoint;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        find = _require.find;

    var ImprovedModel = __webpack_require__(25);

    /**
     * Represents a specific locale, i.e. a country and a variant, provided as a 2-part locale string e.g. <tt>en-US</tt>.
     *
     * @class Locale
     * @author Kim
     */
    return ImprovedModel.extend("Locale", {

        defaults: {
            // The locale language code
            variant: null,

            // The country code
            country: null,

            // A given readable variant name for this locale
            localeString: null,

            variantName: null
        },

        /**
         * Constructor.
         *
         * @param  {String} localeString A 2-part locale string, e.g. <tt>en-US</tt>.
         * @param  {String} variantName  The display friendly name of the variant, e.g. <tt>American English</tt>.
         */
        constructor: function constructor(localeString, variantName) {
            ImprovedModel.prototype.constructor.call(this);

            var parts = localeString.split("-");
            var variant = parts[0];
            var country = parts[1];

            this.set({
                variant: variant,
                country: country,
                localeString: localeString,
                variantName: variantName
            }, { silent: true });
        },
        getCountry: function getCountry() {
            return this.get("country");
        },
        getVariant: function getVariant() {
            return this.get("variant");
        },
        getVariantName: function getVariantName() {
            return this.get("variantName");
        },
        getLocaleString: function getLocaleString() {
            return this.get("localeString");
        },
        toString: function toString() {
            return this.getVariantName();
        },


        /**
         * Overwrites the toJSON from backbone, because a locale is mainly used as a value in LocalizationGroup.
         * when we save a LocalizationGroup, the backend expect locale to be a string instead of a JSON object.
         *
         * @returns {String} The locale string, e.g. <tt>en-US</tt>
         */
        toJSON: function toJSON() {
            return this.getLocaleString();
        },


        /**
         * The unique identifier represents this Locale.
         *
         * @returns {String} The locale string, e.g. <tt>en-US</tt>
         */
        getIdentifier: function getIdentifier() {
            return this.get("localeString");
        }
    }, {

        /**
         * Returns the correct locale string from the given model.
         *
         * @param {ImprovedModel} model from where to extract the local information.
         * @returns {String} The locale string.
         */
        localeStringFromModel: function localeStringFromModel(model) {
            var group = model.get("group");
            var found = find(group.entries, function (entry) {
                return entry.reference && entry.reference.resourceId === model.get("id");
            });

            if (found) {
                return "(" + found.value.split("-")[1] + ")";
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var Locale = __webpack_require__(373);

    var LocaleCollection = Backbone.Collection.extend("LocaleCollection", {

        model: Locale,

        /**
         * Find the Locale by its identifier(localeString) in this collection
         *
         * @param localeString
         * @returns {*}
         */
        findByLocaleString: function findByLocaleString(localeString) {
            return this.find(function (locale) {
                return locale.getLocaleString() === localeString;
            });
        },


        /**
         * Giving a set of items, this method filters them out from the collection and return the rest items.
         *
         * @param locales
         * @returns {*}
         */
        remainingItems: function remainingItems(locales) {
            return this.filter(function (locale) {
                return !_.find(locales, function (anotherlocale) {
                    return locale === anotherlocale;
                });
            });
        }
    });

    /**
     * A collection of predefined <tt>Locale</tt>'s.
     *
     * @class LocaleCollection
     */
    return new LocaleCollection([new Locale("zh-CN", "Chinese (CN)"), new Locale("da-DK", "Danish (DK)"), new Locale("en-GB", "English (GB)"), new Locale("en-US", "English (US)"), new Locale("fi-FI", "Finnish (FI)"), new Locale("fr-FR", "French (FR)"), new Locale("de-DE", "German (DE)"), new Locale("it-IT", "Italian (IT)"), new Locale("nb-NO", "Norwegian (NO)"), new Locale("pt-PT", "Portuguese (PT)"), new Locale("es-ES", "Spanish (ES)"), new Locale("sv-SE", "Swedish (SE)")]);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(198);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1494),
    listCacheDelete = __webpack_require__(1495),
    listCacheGet = __webpack_require__(1496),
    listCacheHas = __webpack_require__(1497),
    listCacheSet = __webpack_require__(1498);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(528);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1500);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(363);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(381);
var createDesc = __webpack_require__(382);
module.exports = __webpack_require__(199) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(308);
var IE8_DOM_DEFINE = __webpack_require__(801);
var toPrimitive = __webpack_require__(803);
var dP = Object.defineProperty;

exports.f = __webpack_require__(199) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 382 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(1520);
var enumBugKeys = __webpack_require__(809);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(804);
var defined = __webpack_require__(385);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 385 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(385);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(387);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uncontrollable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ButtonGroup__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_ValidComponentChildren__ = __webpack_require__(85);























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__["a" /* default */].defaultProps.bsRole;
var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number])),
  componentClass: __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__["c" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), Object(__WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__["a" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   *
   * *Note: For custom dropdown components, you will have to pass the
   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};
var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_16__ButtonGroup__["a" /* default */]
};

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Dropdown, _React$Component);

  function Dropdown(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleClose = _this.handleClose.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement___default()(document));
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;
    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  _proto.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  _proto.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu || !menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  _proto.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, {
      source: 'click'
    });
  };

  _proto.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, {
            source: 'keydown'
          });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }

        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.handleClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  _proto.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["id", "onSelect", "rootCloseEvent"]);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["e" /* prefix */])(props, 'menu'),
      onClose: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, {
          source: 'select'
        });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  _proto.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      ref: ref,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["e" /* prefix */])(props, 'toggle'),
      onClick: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  _proto.render = function render() {
    var _classes,
        _this4 = this;

    var _this$props = this.props,
        Component = _this$props.componentClass,
        id = _this$props.id,
        dropup = _this$props.dropup,
        disabled = _this$props.disabled,
        pullRight = _this$props.pullRight,
        open = _this$props.open,
        onSelect = _this$props.onSelect,
        role = _this$props.role,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "id", "dropup", "disabled", "pullRight", "open", "onSelect", "role", "bsClass", "className", "rootCloseEvent", "children"]);

    delete props.onToggle;
    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    } // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.


    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_22__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      switch (child.props.bsRole) {
        case TOGGLE_ROLE:
          return _this4.renderToggle(child, {
            id: id,
            disabled: disabled,
            open: open,
            role: role,
            bsClass: bsClass
          });

        case MENU_ROLE:
          return _this4.renderMenu(child, {
            id: id,
            open: open,
            pullRight: pullRight,
            bsClass: bsClass,
            onSelect: onSelect,
            rootCloseEvent: rootCloseEvent
          });

        default:
          return child;
      }
    }));
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', Dropdown);
var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_14_uncontrollable___default()(Dropdown, {
  open: 'onToggle'
});
UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__);

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;
  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__);




var _fadeStyles;





var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__["ENTERING"]] = 'in', _fadeStyles[__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__["ENTERED"]] = 'in', _fadeStyles);

var Fade =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Fade, _React$Component);

  function Fade() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Fade.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition___default.a, props, function (status, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('fade', className, children.props.className, fadeStyles[status])
      }));
    });
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MediaBody__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MediaHeading__ = __webpack_require__(1605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaLeft__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaList__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaListItem__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaRight__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(18);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Media =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Media, _React$Component);

  function Media() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Media.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;
Media.Heading = __WEBPACK_IMPORTED_MODULE_7__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_6__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_8__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_11__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_9__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_10__MediaListItem__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('media', Media));

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(387);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return timeout; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getOptionByValue;
/* harmony export (immutable) */ __webpack_exports__["i"] = getOptionsByValue;
/* harmony export (immutable) */ __webpack_exports__["d"] = getFirstAvailableOption;
/* harmony export (immutable) */ __webpack_exports__["q"] = valueIsNotInFilteredData;
/* harmony export (immutable) */ __webpack_exports__["j"] = getPreviousOption;
/* harmony export (immutable) */ __webpack_exports__["f"] = getNextOption;
/* harmony export (immutable) */ __webpack_exports__["e"] = getLastScrollTopIndex;
/* harmony export (immutable) */ __webpack_exports__["c"] = getFilteredData;
/* harmony export (immutable) */ __webpack_exports__["h"] = getOptionStyle;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDropdownStyle;
/* harmony export (immutable) */ __webpack_exports__["a"] = getContainerStyle;
/* harmony export (immutable) */ __webpack_exports__["l"] = getSelectionStyle;
/* harmony export (immutable) */ __webpack_exports__["m"] = isSearchboxHiddex;
/* harmony export (immutable) */ __webpack_exports__["k"] = getSearchStyle;
/* harmony export (immutable) */ __webpack_exports__["n"] = isSelected;
/* harmony export (immutable) */ __webpack_exports__["o"] = removeSelection;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1684);
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);


var timeout = 200;
var unicodePatterns = [
    { l: 'a', s: /[ⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ]/gi },
    { l: 'aa', s: /ꜳ/gi },
    { l: 'ae', s: /[æǽǣ]/gi },
    { l: 'ao', s: /ꜵ/gi },
    { l: 'au', s: /ꜷ/gi },
    { l: 'av', s: /[ꜹꜻ]/gi },
    { l: 'ay', s: /ꜽ/gi },
    { l: 'b', s: /[ⓑｂḃḅḇƀƃɓ]/gi },
    { l: 'c', s: /[ⓒｃćĉċčçḉƈȼꜿↄ]/gi },
    { l: 'd', s: /[ⓓｄḋďḍḑḓḏđƌɖɗꝺ]/gi },
    { l: 'dz', s: /[ǳǆ]/gi },
    { l: 'e', s: /[ⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ]/gi },
    { l: 'f', s: /[ⓕｆḟƒꝼ]/gi },
    { l: 'g', s: /[ⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ]/gi },
    { l: 'h', s: /[ⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ]/gi },
    { l: 'hv', s: /ƕ/gi },
    { l: 'i', s: /[ⓘｉìíîĩīĭİïḯỉǐȉȋịįḭɨı]/gi },
    { l: 'j', s: /[ⓙｊĵǰɉ]/gi },
    { l: 'k', s: /[ⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ]/gi },
    { l: 'l', s: /[ⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇꝆ]/gi },
    { l: 'lj', s: /ǉ/gi },
    { l: 'm', s: /[ⓜｍḿṁṃɱɯ]/gi },
    { l: 'n', s: /[ⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ]/gi },
    { l: 'nj', s: /ǌ/gi },
    { l: 'o', s: /[ⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔƟꝋꝍɵ]/gi },
    { l: 'oi', s: /ƣ/gi },
    { l: 'oe', s: /œ/gi },
    { l: 'oo', s: /ꝏ/gi },
    { l: 'ou', s: /ȣ/gi },
    { l: 'p', s: /[ⓟｐṕṗƥᵽꝑꝓꝕ]/gi },
    { l: 'q', s: /[ⓠｑɋꝗꝙ]/gi },
    { l: 'r', s: /[ⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ]/gi },
    { l: 's', s: /[ⓢｓßẞśṥŝṡšṧṣṩșşȿꞩꞅẛ]/gi },
    { l: 't', s: /[ⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ]/gi },
    { l: 'tz', s: /ꜩ/gi },
    { l: 'u', s: /[ⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ]/gi },
    { l: 'v', s: /[ⓥｖṽṿʋꝟʌ]/gi },
    { l: 'vy', s: /ꝡ/gi },
    { l: 'w', s: /[ⓦｗẁẃŵẇẅẘẉⱳ]/gi },
    { l: 'x', s: /[ⓧｘẋẍ]/gi },
    { l: 'y', s: /[ⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ]/gi },
    { l: 'z', s: /[ⓩｚźẑżžẓẕƶȥɀⱬꝣ]/gi }
];
function getScrollUpIndex(data, value) {
    var e_1, _a;
    var index = 0;
    try {
        for (var data_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
            var groupOrOption = data_1_1.value;
            var options = groupOrOption.options;
            if (options) {
                index++;
                var valueIndex = options.findIndex(function (op) { return op.value === value; });
                if (valueIndex !== -1) {
                    return index + valueIndex;
                }
                else {
                    index += options.length;
                }
            }
            else {
                if (groupOrOption.value === value) {
                    return index;
                }
                else {
                    index++;
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return 0;
}
function getOptionByValue(data, value) {
    var e_2, _a, e_3, _b;
    try {
        for (var data_2 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(data), data_2_1 = data_2.next(); !data_2_1.done; data_2_1 = data_2.next()) {
            var groupOrOption = data_2_1.value;
            var options = groupOrOption.options;
            if (options) {
                try {
                    for (var options_1 = (e_3 = void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(options)), options_1_1 = options_1.next(); !options_1_1.done; options_1_1 = options_1.next()) {
                        var option = options_1_1.value;
                        if (option.value === value) {
                            return option;
                        }
                    }
                }
                catch (e_3_1) { e_3 = { error: e_3_1 }; }
                finally {
                    try {
                        if (options_1_1 && !options_1_1.done && (_b = options_1.return)) _b.call(options_1);
                    }
                    finally { if (e_3) throw e_3.error; }
                }
            }
            else {
                if (groupOrOption.value === value) {
                    return groupOrOption;
                }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (data_2_1 && !data_2_1.done && (_a = data_2.return)) _a.call(data_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return null;
}
function getOptionsByValue(data, value, multiple) {
    var e_4, _a;
    if (multiple) {
        var values = Array.isArray(value) ? value : [];
        var result = [];
        try {
            for (var values_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                var v = values_1_1.value;
                var option = getOptionByValue(data, v);
                if (option) {
                    result.push(option);
                }
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return result;
    }
    return getOptionByValue(data, value);
}
function getFirstAvailableOption(data) {
    var e_5, _a, e_6, _b;
    try {
        for (var data_3 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(data), data_3_1 = data_3.next(); !data_3_1.done; data_3_1 = data_3.next()) {
            var groupOrOption = data_3_1.value;
            var options = groupOrOption.options;
            if (options) {
                try {
                    for (var options_2 = (e_6 = void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(options)), options_2_1 = options_2.next(); !options_2_1.done; options_2_1 = options_2.next()) {
                        var option = options_2_1.value;
                        if (!option.disabled) {
                            return option.value;
                        }
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (options_2_1 && !options_2_1.done && (_b = options_2.return)) _b.call(options_2);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
            else {
                var option = groupOrOption;
                if (!option.disabled) {
                    return option.value;
                }
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (data_3_1 && !data_3_1.done && (_a = data_3.return)) _a.call(data_3);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return null;
}
function getOptionsCount(data) {
    var e_7, _a;
    var count = 0;
    try {
        for (var data_4 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(data), data_4_1 = data_4.next(); !data_4_1.done; data_4_1 = data_4.next()) {
            var groupOrOption = data_4_1.value;
            var options = groupOrOption.options;
            if (options) {
                count += options.length;
            }
            else {
                count++;
            }
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (data_4_1 && !data_4_1.done && (_a = data_4.return)) _a.call(data_4);
        }
        finally { if (e_7) throw e_7.error; }
    }
    return count;
}
function valueIsNotInFilteredData(filteredData, value) {
    var e_8, _a, e_9, _b;
    if (isNullOrUndefined(value)) {
        return true;
    }
    try {
        for (var filteredData_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(filteredData), filteredData_1_1 = filteredData_1.next(); !filteredData_1_1.done; filteredData_1_1 = filteredData_1.next()) {
            var groupOrOption = filteredData_1_1.value;
            var options = groupOrOption.options;
            if (options) {
                try {
                    for (var options_3 = (e_9 = void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(options)), options_3_1 = options_3.next(); !options_3_1.done; options_3_1 = options_3.next()) {
                        var option = options_3_1.value;
                        if (option.value === value) {
                            return false;
                        }
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (options_3_1 && !options_3_1.done && (_b = options_3.return)) _b.call(options_3);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
            }
            else {
                if (groupOrOption.value === value) {
                    return false;
                }
            }
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (filteredData_1_1 && !filteredData_1_1.done && (_a = filteredData_1.return)) _a.call(filteredData_1);
        }
        finally { if (e_8) throw e_8.error; }
    }
    return true;
}
function getPreviousOption(filteredData, hoveringValue) {
    var findIt = isNullOrUndefined(hoveringValue);
    for (var i = filteredData.length - 1; i >= 0; i--) {
        var groupOrOption = filteredData[i];
        var options = groupOrOption.options;
        if (options) {
            for (var j = options.length - 1; j >= 0; j--) {
                var option = options[j];
                if (findIt && !option.disabled) {
                    return option.value;
                }
                findIt = option.value === hoveringValue;
            }
        }
        else {
            var option = groupOrOption;
            if (findIt && !option.disabled) {
                return option.value;
            }
            findIt = option.value === hoveringValue;
        }
    }
    return findIt ? hoveringValue : null;
}
function getNextOption(filteredData, hoveringValue) {
    var e_10, _a, e_11, _b;
    var findIt = isNullOrUndefined(hoveringValue);
    try {
        for (var filteredData_2 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(filteredData), filteredData_2_1 = filteredData_2.next(); !filteredData_2_1.done; filteredData_2_1 = filteredData_2.next()) {
            var groupOrOption = filteredData_2_1.value;
            var options = groupOrOption.options;
            if (options) {
                try {
                    for (var options_4 = (e_11 = void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(options)), options_4_1 = options_4.next(); !options_4_1.done; options_4_1 = options_4.next()) {
                        var option = options_4_1.value;
                        if (findIt) {
                            if (!option.disabled) {
                                return option.value;
                            }
                        }
                        else {
                            findIt = option.value === hoveringValue;
                        }
                    }
                }
                catch (e_11_1) { e_11 = { error: e_11_1 }; }
                finally {
                    try {
                        if (options_4_1 && !options_4_1.done && (_b = options_4.return)) _b.call(options_4);
                    }
                    finally { if (e_11) throw e_11.error; }
                }
            }
            else {
                var option = groupOrOption;
                if (findIt) {
                    if (!option.disabled) {
                        return option.value;
                    }
                }
                else {
                    findIt = option.value === hoveringValue;
                }
            }
        }
    }
    catch (e_10_1) { e_10 = { error: e_10_1 }; }
    finally {
        try {
            if (filteredData_2_1 && !filteredData_2_1.done && (_a = filteredData_2.return)) _a.call(filteredData_2);
        }
        finally { if (e_10) throw e_10.error; }
    }
    return findIt ? hoveringValue : null;
}
function isNullOrUndefined(value) {
    return value === null || value === undefined;
}
function getLastScrollTopIndex(hoveringValue, results, filteredData, lastScrollTopIndex) {
    if (isNullOrUndefined(hoveringValue)) {
        results.scrollTop = 0;
        return 0;
    }
    else {
        var scrollTop = getScrollUpIndex(filteredData, hoveringValue);
        if (scrollTop - lastScrollTopIndex > 5) {
            lastScrollTopIndex += scrollTop - lastScrollTopIndex - 5;
            var item = results.querySelectorAll('li').item(scrollTop);
            if (item) {
                results.scrollTop = item.offsetTop - results.offsetHeight;
            }
            return lastScrollTopIndex;
        }
        if (lastScrollTopIndex - scrollTop > 0) {
            lastScrollTopIndex -= lastScrollTopIndex - scrollTop;
            var item = results.querySelectorAll('li').item(lastScrollTopIndex - 1);
            if (item) {
                results.scrollTop = item.offsetTop;
            }
            return lastScrollTopIndex;
        }
        return null;
    }
}
function containSearchText(label, searchText, editPattern) {
    return searchText
        ? formatSansUnicode(label).match(new RegExp(formatPattern(searchText, editPattern), 'i')) !== null
        : true;
}
function protectPattern(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
function formatSansUnicode(str) {
    var e_12, _a;
    try {
        for (var unicodePatterns_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(unicodePatterns), unicodePatterns_1_1 = unicodePatterns_1.next(); !unicodePatterns_1_1.done; unicodePatterns_1_1 = unicodePatterns_1.next()) {
            var unicodePattern = unicodePatterns_1_1.value;
            str = str.replace(unicodePattern.s, unicodePattern.l);
        }
    }
    catch (e_12_1) { e_12 = { error: e_12_1 }; }
    finally {
        try {
            if (unicodePatterns_1_1 && !unicodePatterns_1_1.done && (_a = unicodePatterns_1.return)) _a.call(unicodePatterns_1);
        }
        finally { if (e_12) throw e_12.error; }
    }
    return str;
}
function formatPattern(str, editPattern) {
    str = formatSansUnicode(protectPattern(str));
    if (editPattern && typeof editPattern === 'function') {
        str = editPattern(str);
    }
    return str;
}
function getFilteredData(data, searchText, editPattern) {
    var e_13, _a;
    if (searchText) {
        var result = [];
        try {
            for (var data_5 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __values */])(data), data_5_1 = data_5.next(); !data_5_1.done; data_5_1 = data_5.next()) {
                var groupOrOption = data_5_1.value;
                var options = groupOrOption.options;
                if (options) {
                    if (options.some(function (group) { return containSearchText(group.label, searchText, editPattern); })) {
                        var filteredOptions = options.filter(function (group) { return containSearchText(group.label, searchText, editPattern); });
                        result.push({
                            label: groupOrOption.label,
                            options: filteredOptions
                        });
                    }
                }
                else if (containSearchText(groupOrOption.label, searchText, editPattern)) {
                    result.push(groupOrOption);
                }
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (data_5_1 && !data_5_1.done && (_a = data_5.return)) _a.call(data_5);
            }
            finally { if (e_13) throw e_13.error; }
        }
        return result;
    }
    else {
        return data;
    }
}
function getOptionStyle(option, hoveringValue) {
    var extraClasses = option.classes ? ' ' + option.classes : '';
    return option.value === hoveringValue
        ? 'select2-results__option select2-results__option--highlighted' + extraClasses
        : 'select2-results__option' + extraClasses;
}
function getDropdownStyle(isOpen) {
    return isOpen
        ? 'select2-container select2-container--default select2-container-dropdown select2-container--open'
        : 'select2-container select2-container--default select2-container-dropdown';
}
function getContainerStyle(disabled, isOpen) {
    if (disabled === void 0) { disabled = undefined; }
    return "select2 select2-container select2-container--default " + (disabled ? 'select2-container--disabled' : '') + " "
        + ((isOpen ? 'select2-container--open' : '') + " select2-container--below select2-container--focus");
}
function getSelectionStyle(multiple) {
    if (multiple === void 0) { multiple = undefined; }
    return "select2-selection select2-selection--" + (multiple ? 'multiple' : 'single');
}
var defaultMinCountForSearch = 6;
function isSearchboxHiddex(data, minCountForSearch) {
    if (typeof minCountForSearch !== 'number') {
        minCountForSearch = defaultMinCountForSearch;
    }
    var optionCount = getOptionsCount(data);
    return optionCount < minCountForSearch;
}
function getSearchStyle(isHidden) {
    return isHidden
        ? 'select2-search select2-search--dropdown select2-search--hide'
        : 'select2-search select2-search--dropdown';
}
function isSelected(options, option, multiple) {
    if (multiple) {
        return options && options.some(function (op) { return op.value === option.value; }) ? 'true' : 'false';
    }
    else {
        return options && option.value === options.value ? 'true' : 'false';
    }
}
function removeSelection(options, option) {
    for (var i = 0; i < options.length; i++) {
        if (options[i].value === option.value) {
            options.splice(i, 1);
            return;
        }
    }
}



/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);

    var _require = __webpack_require__(1),
        isBoolean = _require.isBoolean;

    var Icons = __webpack_require__(357);
    var ImageDropManager = __webpack_require__(859);

    var _require2 = __webpack_require__(10),
        Renderer = _require2.Renderer,
        Behavior = _require2.Behavior;

    var Permissions = __webpack_require__(22);
    var template = __webpack_require__(1727);

    /**
     * A behavior that represents a "drop area" for uploading specific files.
     *
     * If no `dropManager` is specified, the `ImageDropManager` is used.
     *
     * @class DropAreaHotspot
     */
    return Behavior.extend("DropAreaHotspot", {

        defaults: {
            dropManager: ImageDropManager,
            message: "<strong>Drop image(s)</strong> here to add directly<br>to Image Library",
            iconSize: "small",
            hideOverlayDuringLoad: false,
            uploadEnabled: true
        },

        _$overlay: null,

        coverArea: null,

        events: {
            "change .upload": "_uploadChangeHandler"
        },

        _uploadChangeHandler: function _uploadChangeHandler(event) {
            var uploadDescriptor = this.options.dropManager.upload({ files: event.target.files });

            if (uploadDescriptor.models.length > 0) {
                this.view.triggerMethod("upload", uploadDescriptor);
            }
            // reset input in order the `change` event to be triggered even
            // if a users selects the same file in the file upload dialog
            event.target.form.reset();
        },
        onShow: function onShow() {
            var _this = this;

            this._showDropTarget = this.view.options.showDropTarget !== false && Permissions.Privileges.CREATE.can();
            this._hideOverlayDuringLoad = isBoolean(this.view.options.hideOverlayDuringLoad) ? this.view.options.hideOverlayDuringLoad : this.options.hideOverlayDuringLoad;

            if (this._showDropTarget) {
                this.addOverlay();
                this.addIcon();

                var body = $(document.body);

                this.$el.draghover(function () {
                    _this.$el.addClass("draghover");
                }, function () {
                    _this.$el.removeClass("draghover");
                });

                body.draghover(function () {
                    if (!body.hasClass("internal-drag")) {
                        body.addClass("draghover");
                    }
                }, function () {
                    body.removeClass("draghover");
                });

                if (this.options.uploadEnabled) {
                    var dropManager = this.options.dropManager;


                    dropManager.addElement(this.$el);

                    dropManager.on("upload", function (uploadDescriptor) {
                        _this.view.triggerMethod("upload", uploadDescriptor);
                    });

                    dropManager.on("file:uploaded", function (model) {
                        _this.view.triggerMethod("file:uploaded", model);
                    });
                }
            }
        },
        onClose: function onClose() {
            if (this._showDropTarget && this.options.uploadEnabled) {
                var dropManager = this.options.dropManager;


                dropManager.removeElement(this.$el);
                dropManager.off(null, null, this);
            }
        },


        /**
         * Invoked when the associated view is in a "loading" state, e.g. lazy loading content.
         *
         * Hides the overlay during load.
         */
        onLoadStart: function onLoadStart() {
            if (this._hideOverlayDuringLoad && this._$overlay) {
                this._$overlay.hide();
            }
        },


        /**
         * Invoked when the associated view is no longer in a "loading" state, e.g. lazy loading content.
         *
         * Shows the overlay during load.
         */
        onLoadEnd: function onLoadEnd() {
            if (this._hideOverlayDuringLoad && this._$overlay) {
                this._$overlay.show();
            }
        },


        // Add the hot spot overlay, this will be shown to indicate the area dropable whenever something is dragged in
        addOverlay: function addOverlay() {
            this._$overlay = $(Renderer.render(template));
            this._$overlay.addClass("drop-target-" + this.options.iconSize);
            this._$overlay.find(".drop-target-message").html(this.options.message);

            this.coverArea = this.$(this.options.dropAreaSelector);
            this.coverArea.prepend(this._$overlay);
        },
        addIcon: function addIcon() {
            var icon = this.options.iconSize === "large" ? Icons.DROP_TARGET_LARGE : Icons.DROP_TARGET_SMALL;
            this._$overlay.find(".icon").append(icon.createElement().addClass("drop-target-icon"));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ContentQuery = __webpack_require__(139);
    var Enum = __webpack_require__(77);

    var sorting = {
        LAST_UPLOADED: {
            name: "lastUploaded",
            title: "Last Uploaded",
            query: ContentQuery.sort().field("createdAt")
        },
        ALPHABETICAL: {
            name: "alphabetical",
            title: "Alphabetical",
            query: ContentQuery.sort().field("name", "Ascending")
        },
        MOST_USED: {
            name: "mostUsed",
            title: "Most Used",
            query: ContentQuery.sort().field("timesUsed")
        },
        MOST_VIEWED: {
            name: "mostViewed",
            title: "Most Viewed",
            query: ContentQuery.sort().field("measureData.totalViews")
        }
    };

    return Enum.create("ImageLibrarySortingEnum", "name", sorting, {
        without: function without() {
            for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
                items[_key] = arguments[_key];
            }

            return this.all().filter(function (sortingOption) {
                return items.indexOf(sortingOption) === -1;
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var EventDispatcher = __webpack_require__(54);
    var SyncManager = __webpack_require__(44);
    var Syncer = __webpack_require__(50);
    var Preconditions = __webpack_require__(14);

    /**
     * Abstract collection for loading data in chunks aka lazy loading.
     *
     * Not a <tt>Backbone.Collection</tt> but mimics (roughly) the same semantics for consistency.
     *
     * @class {ChunkingCollection}
     * @see  ContentCollection
     */
    var ChunkingCollection = EventDispatcher.extend({

        /**
         * The model constructor or a <tt>Map</tt> of types to models, e.g. <tt>types.set(ExperienceModel.type, ExperienceModel)</tt>.
         *
         * @see  #_parseJSON
         * @see  ContentCollection#model
         * @type {Function|Map.<String, Model>}
         */
        model: null,

        /**
         * @type {Function}
         */
        url: null,

        /**
         * @type {Number}
         */
        limit: 20,

        /**
         * @type {Number}
         */
        offset: 0,

        /**
         * A reference to the current query.
         *
         * @type {Query}
         */
        _query: null,

        /**
         * @type {Number}
         * A sequence number assigned to each sync request as to only update this collection when sequence
         * number match when results are in, e.g. to discard results for "fo" when the user has entered "foo"
         * in the meantime; the first request is likely to finish after the last one as the criteria is more
         * restrictive. This is needed because different queues may back this collection instance accross time,
         * e.g. if the user is slower to enter a new letter than the debounce set.
         */
        _sequence: 0,

        /**
         * @type {Boolean}
         * True if this collection is tagged to be reset between sync requests, false otherwise.
         */
        _reset: false,

        /**
         *
         * @type {Boolean}
         */
        _hasMore: false,

        /**
         *
         * @type {Model[]}
         */
        _collection: null,

        /**
         * @type {Model[]}
         */
        _latest: null,

        /**
         * @type {Map.<String, Model>}
         */
        _idToModel: null,

        /**
         * Constructor.
         *
         * @param {Object} options The collection options:
         *                         @cfg {Function|String} url The endpoint URL, as a function returning the URL or the raw string URL.
         *                         @cfg {Number} limit The chunk size, defaults to 20. If -1 is defined, no limit will be used, i.e. all entries will be returned.
         */
        constructor: function constructor(options) {
            this.options = options || {};
            this.url = this.options.url || this.url;
            this.limit = _.isNumber(this.options.limit) ? this.options.limit : this.limit;
            this._collection = [];
            this._idToModel = new Map();
        },


        /**
         * Resets the state of the collection and executes the specified query.
         *
         * @param  {ChunkingCollectionQuery} query  The query to execute.
         * @return {Promise}                        A promise that resolves when the query has been successfully executed.
         */
        query: function query(_query) {
            return this.reset()._fetch(_query);
        },


        /**
         * Fetches the next chuck.
         *
         * @return {Promise} Resolves when the chuck has been fetched.
         */
        next: function next() {
            Preconditions.checkState(this.hasMore());

            this.offset += this.limit;

            return this._fetch(this._query);
        },
        currentQuery: function currentQuery() {
            return this._query;
        },


        /**
         * Whether more chucks can be fetched.
         *
         * @return {Boolean} <tt>true</tt> if more chucks can be fetched, <tt>false</tt> if not.
         */
        hasMore: function hasMore() {
            return this._hasMore;
        },
        each: function each(callback) {
            this._collection.forEach(callback);
        },


        /**
         * Returns the latest chucks, as an array of models.
         *
         * @return {Model[]} The latest chunks.
         *
         * @see  #model
         */
        latest: function latest() {
            return _.clone(this._latest);
        },
        get: function get(id) {
            return this._idToModel.get(id);
        },
        has: function has(id) {
            return this._idToModel.has(id);
        },
        at: function at(index) {
            return this._collection[index];
        },


        /**
         * Resets the current chunking collection.
         *
         * @param {Model[]} models An array of Backbone models which, if provided, will reset the chunking collection value.
         * @returns {ChunkingCollection}
         */
        reset: function reset(models) {
            var _this = this;

            if (models) {
                this._collection = models;
                this._latest = models;
                this._idToModel.clear();

                models.forEach(function (model) {
                    _this._idToModel.set(model.get("id"), model);
                });
                this._hasMore = this._collection.length === this.limit;
            } else {
                this._collection = [];
                this._latest = [];
                this._idToModel.clear();
            }

            this.offset = 0;
            this._reset = false;
            this.trigger("reset");
            return this;
        },
        models: function models() {
            return this._collection;
        },
        length: function length() {
            return this._collection.length;
        },
        isEmpty: function isEmpty() {
            return this.length() === 0;
        },
        isPending: function isPending() {
            return !Syncer.State.complete(this);
        },
        toJSON: function toJSON() {
            return this._collection.map(function (model) {
                return model.toJSON();
            });
        },
        add: function add(model, index) {
            var models = Array.isArray(model) ? model : [model];

            this._add(models, index);
        },
        remove: function remove(model) {
            var _this2 = this;

            var ids = []; // supposed to be only one `id`, but lets keep this method more generic just in case...
            this._idToModel.forEach(function (value, id) {
                if (value === model) {
                    ids.push(id);
                }
            });
            ids.forEach(function (id) {
                return _this2._idToModel.delete(id);
            });

            var index = this._collection.indexOf(model);
            if (index >= 0) {
                this._collection.splice(index, 1);

                this.stopListening(model);

                this.trigger("remove", model, index);
            }
        },


        /**
         * Returns a user-friendly distinguished name for this collection.
         * Typically used to report errors.
         * Collections derived from this one may override `_distinguishedName()` method to have other name in logs.
         *
         * @returns {String}
         */
        distinguishedName: function distinguishedName() {
            var name = this._distinguishedName();

            // Default name?
            if (!name) {
                name = this.__typeName || "resource";
            }

            return name;
        },
        _fetch: function _fetch(query) {
            var _this3 = this;

            // Save a reference to the latest query, might be updated when the user enters letters in rapid
            // succession...
            this._query = query;

            // The request sent is not immutable as the same endpoint can describe different queries and thus results
            // and we want the queue promise returned, not the request promise, so we will wait for the user entering
            // more data like "fo" -> "foo"...
            return SyncManager.sync({
                method: "fetch",
                delay: 300, // debounce until the user pauses entering a criteria, e.g. wait for "fo" -> "foo" in rapid succession
                fn: {
                    url: this._url(),
                    dataType: "json",
                    data: function data(request) {
                        request.sequence = ++_this3._sequence;
                        // Generate the query at sync time, not at enqueue time. Also append "limit" and "offset" to
                        // the query request - we check for limit being falsey as it could potentially be set to -1
                        // (hint: ContentCollection#query).
                        return _.extend(_this3._query.querify(), _this3.limit > 0 ? { limit: _this3.limit, offset: _this3.offset } : {});
                    }
                },
                resultHandler: function resultHandler(json, request) {
                    // Ignore stale queries based on sequence number, not on a changed query. The query is allowed
                    // to change while pending, e.g. user rapidly pressing Backspace or Delete, but the sequence
                    // numbers will not.
                    if (_this3._sequence !== request.sequence) {
                        return;
                    }

                    // If the queue at this point has additional queued entries, we now the results here will be
                    // overridden by those from such enqueued requests. Since this request is just about to complete,
                    // it will not be in the queue here. And, since we are using a queue promise, we will never return
                    // until the queue is empty. However, future queued requests may be cancelled before executed, but
                    // this is such a rare case we will ignore it (in the "if" above)...
                    if (_this3._reset) {
                        _this3.reset();
                    }

                    // Reset before processing *next* time around?
                    _this3._reset = request.queue.size() > 0;

                    // Parse json models into a temp collection...
                    var collection = _this3._parseJSON(json);

                    _this3._hasMore = collection.length === _this3.limit;

                    // Add new results to *this* collection...
                    _this3._add(collection);

                    // Explicitly mimic Backbone life cycle "sync" event, after "query:syncing", but before
                    // "query:synced", as triggered by the SyncManager...
                    _this3.trigger("sync");

                    return collection;
                },
                errorHandler: this._handleError

            }, this).promise();
        },
        _parseJSON: function _parseJSON(json) {
            var _this4 = this;

            var results = Array.isArray(json) ? json : [json];
            var factory = void 0;

            if (this.model instanceof Map) {
                factory = function factory(entry) {
                    var type = entry.type;
                    var Model = _this4.model.get(type);

                    return new Model(entry);
                };
            } else {
                factory = function factory(entry) {
                    var Model = _this4.model;

                    return new Model(entry);
                };
            }

            return results.map(factory);
        },


        /**
         * @returns {String} The string "alert"; never null.
         */
        _handleError: function _handleError(error) {
            error.collection = this;
            return "alert";
        },
        _add: function _add(collection, index) {
            var _this5 = this;

            this._latest = [];

            this.trigger("beforeAdd");

            var i = _.isNumber(index) ? index : this._collection.length - 1;

            collection.forEach(function (model) {
                var id = model.get("id");

                // In case the model has no id (yet), create a temp id and wait for a proper id to arrive.
                if (!id) {
                    id = _.uniqueId("temp-");

                    _this5.listenToOnce(model, "change:id", function (model, persistedId) {
                        // In case the new ID is already present in the collection (e.g. the uploaded
                        // image was already present), remove the model again...
                        if (_this5.has(persistedId)) {
                            _this5.remove(model);
                        } else {
                            _this5._idToModel.set(persistedId, model);
                            _this5._idToModel.delete(id);
                        }
                    });
                }

                // Skip duplicates...
                if (!_this5.has(id)) {
                    _this5._collection.splice(++i, 0, model);
                    _this5._latest.push(model);
                    _this5._idToModel.set(id, model);

                    _this5.listenTo(model, "all", _this5._modelEventHandler);
                }
            });

            if (collection.length) {
                this.trigger("add", this.latest(), index);
            }
        },


        /**
         * @private
         *
         * Handles any, i.e. <tt>all</tt>, event(s) triggered from the contained model(s) - mimicking
         * the same collection behavior as the <tt>Backbone.Collection</tt>:<p>
         *
         * <q>Any event that is triggered on a model in a collection will also be triggered on the
         * collection directly, for convenience.</q>
         *
         * @param  {String} event      The event type.
         * @param  {Model} model       The model instance that triggered the event.
         * @param  {Backbone.Collection} collection A potential <tt>Backbone.Collection</tt>.
         */
        _modelEventHandler: function _modelEventHandler(event, model, collection) {
            if ((event === "add" || event === "remove") && collection !== this) {
                return;
            }

            if (event === "destroy" && this.options.autoRemoval) {
                this.remove(model);
            }

            this.trigger(event, model, collection);
        },


        /**
         * Sub-class specific hook to override the distinguished name of current collection.
         *
         * @return {String} The distinguished name; can be falsey, which will default to the class name of
         *                  this type, secondarily the string "resource".
         */
        _distinguishedName: function _distinguishedName() {
            return null;
        },
        _url: function _url() {
            return _.isFunction(this.url) ? this.url(this.options) : this.url;
        }
    }, {

        /**
         * Convenience for executing a single query on the collection.
         *
         * By default, no limit/chunk size is defined.
         *
         * @param  {ChunkingCollectionQuery} query   The query to execute.
         * @param  {Object} options                  Options passed to the underlying collection instance.
         * @return {Promise}                         A promise that resolves when the query has been successfully executed.
         */
        findByQuery: function findByQuery(query, options) {
            var collectionOptions = _.defaults(options || {}, {
                limit: -1 // i.e. no limit/chunk size...
            });

            var Collection = this;

            return new Collection(collectionOptions).query(query);
        }
    });

    return ChunkingCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EventDispatcher = __webpack_require__(54),
        Keyboard = __webpack_require__(243);

    /**
     * The widget grouping event dispatcher singleton.
     *
     * Takes care of detecting the group and ungroup shortcuts, triggering an event when either is
     * detected.
     *
     * @class WidgetGroup
     * @constructor
     */
    var WidgetGroup = EventDispatcher.extend({

        constructor: function constructor() {
            var _this = this;

            // Add binding for grouping
            Keyboard.Shortcut.bind(["ctrl+g", "meta+g"], function () {
                _this.group({ eventProperties: { triggerOrigin: "keyboardShortcut" } });
                return false; // Prevent default browser behaviour
            });

            // Add binding for ungrouping
            Keyboard.Shortcut.bind(["shift+ctrl+g", "shift+meta+g"], function () {
                _this.ungroup({ eventProperties: { triggerOrigin: "keyboardShortcut" } });
                return false; // Prevent default browser behaviour
            });
        },

        /**
         * Trigger event for grouping
         */
        group: function group(options) {
            this.trigger("group", options);
        },

        /**
         * Trigger event for ungrouping
         */
        ungroup: function ungroup(options) {
            this.trigger("ungroup", options);
        }

    });

    return new WidgetGroup();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        range = _require.range;

    var $ = __webpack_require__(4);
    var CharacterPropertiesViewController = __webpack_require__(1765);
    var ColorPicker = __webpack_require__(208);
    var FontProvider = __webpack_require__(103);
    var InputSelection = __webpack_require__(1778);
    var template = __webpack_require__(1779);
    var Preconditions = __webpack_require__(14);
    var Tooltip = __webpack_require__(35);
    var WebFontsUtil = __webpack_require__(136);
    var WebFontVariants = __webpack_require__(365).default;
    var AbstractWidgetPropertiesView = __webpack_require__(63);
    var TextEditorConstants = __webpack_require__(409);

    var MIN_LETTER_SPACING = -9;
    var MAX_LETTER_SPACING = 10;

    var TextCaseOptions = {
        UPPERCASE: "uppercase",
        SMALL_CAPS: "small-caps"
    };
    var TEXT_SHADOW_STYLE = "2px 2px 6px rgba(0,0,0,0.5)";

    var EXPAND_PROPERTY = "characterExpanded";

    /**
     * Properties view for character details, like fonts and colors.
     *
     * @class CharacterPropertiesView
     * @constructor
     *
     * @cfg {EditorModel} model The editor model that is nested in the text widget model.
     */
    var CharacterPropertiesView = AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        _colorPicker: null,

        widgetView: null,

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                TextCaseOptions: TextCaseOptions
            };
        },


        controller: CharacterPropertiesViewController,

        initialize: function initialize() {
            this.__super();
            this.widgetView = this.options.widgetView;
        },


        ui: {
            container: ".character-properties-container",
            legend: "[data-target=\".character-properties-container\"]",
            fontSelector: ".font-selector",
            colorInput: ".color-input",
            colorBox: ".font-color-box",
            fontInfoExclamationSign: ".font-info-section span",
            fontSize: ".font-size",
            fontStyle: ".font-style",
            lineHeight: ".line-height",
            textAlign: ".text-align",
            textAlignmentSection: ".alignment-section",
            fontLetterSpacing: ".font-letter-spacing",
            textDecoration: ".text-decoration",
            textDecorationButtons: ".change-text-decoration",
            textDecorationSection: ".decoration-section",
            changeTextCaseButtons: ".change-text-case",
            uppercaseButton: ".text-transform-uppercase",
            smallCapsButton: ".font-variant-smallcaps",
            textShadow: ".text-shadow",
            textShadowButton: ".change-text-shadow",
            nodeTypeInfo: ".node-name-section .info-tooltip"
        },

        events: {
            "click @ui.colorBox": "_handleColorBoxClick",
            "click .change-text-align": "_handleChangeAlignClick",
            "click @ui.changeTextCaseButtons": "_handleChangeTextCaseClick",
            "click @ui.textDecorationButtons": "_handleChangeDecorationClick",
            "click @ui.textShadowButton": "_handleChangeTextShadowClick",
            "shown.bs.collapse .character-properties-container.collapse-target": "_handleExpand",
            "hidden.bs.collapse .character-properties-container.collapse-target": "_handleCollapse",
            "mousedown": "_handleMouseDown",
            "select2-focus": "_handleSelectFocus"
        },

        bindings: {
            ".color-input": {
                observe: "color",

                onSet: function onSet(color) {
                    return this._colorPicker.hexOrDefault(color);
                }
            },

            ".font-size": {
                observe: "fontSize",
                onGet: function onGet(value) {
                    if (value === null) {
                        return "";
                    }

                    return Math.round(value);
                },
                onSet: function onSet(value) {
                    // prevent string, 0 and negative value
                    return Math.max(5, parseInt(value, 10) || 5);
                }
            },

            ".line-height": {
                observe: "lineHeight",
                onGet: function onGet(value) {
                    return value || "";
                },
                onSet: function onSet(value) {
                    // prevent string, 0 and negative value
                    return Math.max(0.5, parseFloat(value) || 1);
                }
            },

            ".font-letter-spacing": {
                observe: "letterSpacing",
                onGet: function onGet(value) {
                    // Default value for letter spacing can be "normal", so we normalize it to zero.
                    if (value === "normal") {
                        return 0;
                    }

                    return parseInt(value, 10);
                },
                onSet: function onSet(value) {
                    return parseInt(value, 10);
                }
            },

            ".text-align": {
                observe: "textAlign",
                onGet: function onGet(value) {
                    return value || "none";
                },
                update: function update($el, value) {
                    this._updateAlignment(value);
                }
            },

            ".font-selector": {
                observe: ["fontFamily", "fontProvider", "fontMetadata"],

                onSet: function onSet() {
                    var data = this.getSelectedFontData();
                    var provider = data.fontDescriptor.get("provider").value;
                    var fontMetadata = data.fontDescriptor.get("data") || {};

                    return [data.fontFamily, provider, fontMetadata];
                },
                update: function update($el, values) {
                    var fontFamily = values[0];
                    var fontDescription = null;

                    // When fontFamily is set to `null`, stickit converts it to
                    // an empty string for the events. See:
                    // https://github.com/NYTimes/backbone.stickit/blob/master/backbone.stickit.js#L279
                    if (fontFamily) {
                        fontDescription = { id: fontFamily };
                    }

                    this.ui.fontSelector.select2("val", fontDescription);
                }
            },

            ".font-style": {
                observe: ["fontStyle", "fontWeight", "fontFamily"],
                selectOptions: {
                    collection: function collection() {
                        var selectedData = this.getSelectedFontData();

                        if (selectedData) {
                            return ["Select style"].concat(WebFontsUtil.variantsFromFontDescriptor(selectedData.fontDescriptor));
                        }

                        // Don't show any font styles
                        return {};
                    },


                    labelPath: "label",
                    valuePath: "value"
                },

                onSet: function onSet(value) {
                    var selectedData = this.getSelectedFontData();
                    var css = WebFontsUtil.toCss(selectedData.fontFamily, value, this.model.get("fontProvider"));

                    return [css.fontStyle, css.fontWeight, css.fontFamily];
                },
                onGet: function onGet(values /* fontStyle, fontWeight, fontFamily */) {
                    if (values[2]) {
                        var providerValue = this.model.get("fontProvider");
                        var provider = FontProvider.fromValue(providerValue);
                        var variant = WebFontVariants.findVariant(provider, values[0], values[1]);
                        var variantValue = variant && variant.value;

                        return variantValue;
                    }
                }
            },

            ".text-decoration": {
                observe: "textDecoration",
                update: function update($el, value) {
                    this._updateDecorationLine(value);
                }
            },

            ".text-transform-uppercase": {
                observe: "textTransform",
                update: function update($el, value) {
                    var selected = value === TextCaseOptions.UPPERCASE;

                    $el.toggleClass("selected", selected);
                }
            },

            ".font-variant-smallcaps": {
                observe: "fontVariant",
                update: function update($el, value) {
                    var selected = value === TextCaseOptions.SMALL_CAPS;

                    $el.toggleClass("selected", selected);
                }
            },

            ".text-shadow": {
                observe: "textShadow",

                update: function update($el, value) {
                    this._updateTextShadow(value);
                }
            },

            ".node-name": {
                observe: "nodeName",

                selectOptions: {
                    collection: function collection() {
                        // Don't allow a widget level node name change if there are multiple paragraphs
                        var multipleParagraphs = this.widgetView.$el.children().length > 1;
                        var isEditable = this.widgetView.textEditorController.getViewEditable();

                        if (!isEditable && multipleParagraphs) {
                            return {};
                        }

                        var options = TextEditorConstants.HEADINGS.map(function (heading, i) {
                            return { label: "Heading " + ++i, value: heading };
                        });
                        options.unshift({ label: "Default", value: "" });
                        return options;
                    }
                },

                onSet: function onSet(value) {
                    if (value === "") {
                        return null;
                    }

                    return value;
                }
            }
        },

        modelEvents: {
            "change:color": "_changeColorHandler"
        },

        _findValidBlockElement: function _findValidBlockElement(el) {
            if (!el) {
                return;
            }

            if (el.nodeType === 3 || el.nodeName.toLowerCase() === TextEditorConstants.TAGS.SPAN) {
                return this._findValidBlockElement(el.parentNode);
            }

            return el;
        },
        _handleColorBoxClick: function _handleColorBoxClick() {
            this.ui.colorInput.colorpicker("show");
        },
        _handleChangeAlignClick: function _handleChangeAlignClick(event) {
            // On Mac Safari and Chrome, an extra click is fired on the
            // left align button unless this is included
            event.preventDefault();
            this.model.set("textAlign", event.currentTarget.getAttribute("data-align"));
        },
        _handleChangeDecorationClick: function _handleChangeDecorationClick(event) {
            // On Mac Safari and Chrome, an extra click is fired on the
            // left align button unless this is included
            event.preventDefault();

            var selectedDecorationLine = event.currentTarget.getAttribute("data-value");
            var decorationLine = (this.model.get("textDecoration") || "").split(" ");

            var existingIndex = decorationLine.indexOf(selectedDecorationLine);

            if (existingIndex > -1) {
                decorationLine.splice(existingIndex, 1);
            } else if (decorationLine.indexOf("none") > -1) {
                decorationLine = [selectedDecorationLine];
            } else {
                decorationLine = decorationLine.concat([selectedDecorationLine]);
            }

            if (decorationLine.length === 0) {
                decorationLine.push("none");
            }

            this.model.set("textDecoration", decorationLine.join(" "));
        },
        _handleChangeTextShadowClick: function _handleChangeTextShadowClick(event) {
            event.preventDefault();

            var textShadow = this.model.get("textShadow") === "none" ? TEXT_SHADOW_STYLE : "none";

            this.model.set("textShadow", textShadow);
        },


        // Select2 input is outside the character property view, mousedown on the font-family input
        // won't trigger this event, so we need to trigger this on select2.
        _handleSelectFocus: function _handleSelectFocus() {
            this.model.trigger("focus:propertyView");

            // Must be done manually because select2 library stop
            // propagation of the event.
            this._closeInputSelectors();
        },


        // Not using click, because that will make the font-style drop list disappear automatically on first open
        _handleMouseDown: function _handleMouseDown() {
            this.model.trigger("focus:propertyView");
        },
        _handleExpand: function _handleExpand() {
            this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] = true;
        },
        _handleCollapse: function _handleCollapse() {
            this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] = false;
        },
        _handleUppercase: function _handleUppercase(isSelectedNow) {
            if (isSelectedNow) {
                if (this.ui.smallCapsButton.hasClass("selected")) {
                    this.model.set("fontVariant", "none");
                }

                this.model.set("textTransform", TextCaseOptions.UPPERCASE);
            } else {
                this.model.set("textTransform", "none");
            }
        },
        _handleSmallCaps: function _handleSmallCaps(isSelectedNow) {
            if (isSelectedNow) {
                if (this.ui.uppercaseButton.hasClass("selected")) {
                    this.model.set("textTransform", "none");
                }

                this.model.set("fontVariant", TextCaseOptions.SMALL_CAPS);
            } else {
                this.model.set("fontVariant", "none");
            }
        },
        _handleChangeTextCaseClick: function _handleChangeTextCaseClick(event) {
            var $target = $(event.currentTarget);
            var wasSelectedBefore = $target.hasClass("selected");
            var isSelectedNow = !wasSelectedBefore;

            // flip if the button is selected or not
            $target.toggleClass("selected", isSelectedNow);

            switch ($target.attr("data-option")) {
                case TextCaseOptions.UPPERCASE:
                    this._handleUppercase(isSelectedNow);
                    break;
                case TextCaseOptions.SMALL_CAPS:
                    this._handleSmallCaps(isSelectedNow);
                    break;
                default:
                    Preconditions.fail("unhandled text case click change reached: " + $target.attr("data-option"));
                    break;
            }
        },
        _changeColorHandler: function _changeColorHandler(model) {
            this._updateColorBox(model.changed.color);
        },


        /**
         * Updates the color on the little colored box to the
         * right of the color input field.
         *
         * @param {String} color - The hex value of the color. Eg., "#ff0000".
         *                         Empty string or `null` is also acceptable
         *                         input.
         */
        _updateColorBox: function _updateColorBox(color) {
            this.ui.colorBox.css("backgroundColor", color).toggleClass("no-color", !color);
        },
        _updateAlignment: function _updateAlignment(textAlign) {
            // Clear previous selections
            this.ui.textAlignmentSection.find("button").removeClass("selected");

            var $button = this.ui.textAlignmentSection.find("button[data-align='" + textAlign + "']");
            $button.addClass("selected");
        },
        _updateDecorationLine: function _updateDecorationLine() {
            var textDecoration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

            this.ui.textDecorationButtons.each(function (i, button) {
                $(button).toggleClass("selected", textDecoration.indexOf(button.getAttribute("data-value")) > -1);
            });
        },
        _updateTextShadow: function _updateTextShadow() {
            var textShadow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "none";

            var isShadowApplied = textShadow !== "none";

            this.ui.textShadowButton.toggleClass("selected", isShadowApplied);
        },
        onRender: function onRender() {
            this.__super();
            this._colorPicker = new ColorPicker({
                color: this.model.get("color"),
                input: this.ui.colorInput,
                colorBox: this.ui.colorBox
            });

            this.ui.fontSelector.select2({
                placeholder: "Select a font",
                dropdownAutoWidth: true,
                initSelection: this.fontSelectorInitSelection,
                query: this.fontSelectorQuery,
                formatResult: this._fontSelectorFormatResult,
                dropdownCssClass: "font-selector-dropdown"
            });

            this.fontSizeInputSelection = new InputSelection({
                $input: this.ui.fontSize,
                choices: [8, 9, 10, 11, 12, 14, 18, 24, 30, 36, 48, 60, 72, 96]
            });

            // Subclasses might decide not to render the line height control.
            if (this.ui.lineHeight.length) {
                this.lineHeightInputSelection = new InputSelection({
                    $input: this.ui.lineHeight,
                    choices: [0.8, 1, 1.2, 1.4, 1.5, 2, 2.5]
                });
            }

            if (this.ui.fontLetterSpacing.length) {
                this.fontLetterSpacingInputSelection = new InputSelection({
                    $input: this.ui.fontLetterSpacing,
                    choices: range(MIN_LETTER_SPACING, MAX_LETTER_SPACING + 1)
                });
            }

            Tooltip.add(this.ui.fontInfoExclamationSign, {
                delay: { show: 500, hide: 0 },
                placement: "right",
                width: 220
            });

            Tooltip.add(this.ui.nodeTypeInfo, {
                delay: { show: 500, hide: 0 },
                placement: "right",
                width: 220
            });
        },


        // eslint-disable-next-line no-unused-vars
        fontSelectorInitSelection: function fontSelectorInitSelection(element, callback) {},


        // eslint-disable-next-line no-unused-vars
        fontSelectorQuery: function fontSelectorQuery(options) {},
        _fontSelectorFormatResult: function _fontSelectorFormatResult(object, container) {
            var className = object.children ? "header" : "option";

            container.addClass(className);

            if (object.hasOwnProperty("fontDescriptor")) {
                var fontDescriptor = object.fontDescriptor;
                var fontFamily = WebFontsUtil.quoteSpecialFontNames(fontDescriptor.get("cssFamily"));

                switch (fontDescriptor.get("provider")) {
                    case FontProvider.FONTS_DOT_COM:
                    case FontProvider.TYPEKIT:
                        return CharacterPropertiesView._markupForFontWithId(object, fontDescriptor, fontFamily);

                    default:
                        container.css({
                            fontFamily: fontFamily
                        });
                }
            }

            return object.text;
        },
        _closeInputSelectors: function _closeInputSelectors() {
            this.fontSizeInputSelection.closeDropdown();
            if (this.fontLetterSpacingInputSelection) {
                this.fontLetterSpacingInputSelection.closeDropdown();
            }

            if (this.lineHeightInputSelection) {
                this.lineHeightInputSelection.closeDropdown();
            }
        },
        getSelectedFontData: function getSelectedFontData() {
            return this.ui.fontSelector.select2("data");
        },
        onClose: function onClose() {
            this._colorPicker.dispose();
            this.fontSizeInputSelection.dispose();
            if (this.fontLetterSpacingInputSelection) {
                this.fontLetterSpacingInputSelection.dispose();
            }

            if (this.lineHeightInputSelection) {
                this.lineHeightInputSelection.dispose();
            }
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY,

        _markupForFontWithId: function _markupForFontWithId(object, fontDescriptor, fontFamily) {
            var fontProvider = fontDescriptor.get("provider");
            var fontProjectLabel = void 0;
            var html = "<div class=\"font-name\" style=\"font-family: " + fontFamily + "\">" + object.text + "</div>";

            switch (fontProvider) {
                case FontProvider.FONTS_DOT_COM:
                    fontProjectLabel = fontDescriptor.get("data").projectName;
                    html += "<div class=\"font-project-name\">Project: " + fontProjectLabel + "</div>";
                    break;

                case FontProvider.TYPEKIT:
                    fontProjectLabel = fontDescriptor.get("data").kitID;
                    html += "<div class=\"font-project-name\">Kit: " + fontProjectLabel + "</div>";
                    break;

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Font Provider '" + fontProvider + "' not recognized.");
                    break;
            }

            return $("<div>" + html + "</div>");
        }
    });

    return CharacterPropertiesView;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var FontIntegrationModel = __webpack_require__(404);

    /**
     * Fonts.com integration model.
     *
     * @class FontsDotComIntegrationModel
     */
    return FontIntegrationModel.extend("FontsDotComIntegration", {

        defaults: {
            authenticationKey: undefined
        }
    }, {
        type: "FontsDotComIntegration"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var IntegrationModel = __webpack_require__(127);

  /**
   * Marker class for font integrations.
   *
   * @class FontIntegrationModel
   */
  return IntegrationModel.extend("FontIntegration", {});
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(156);
    var EditorEvents = __webpack_require__(17);
    var Permissions = __webpack_require__(22);
    var LoggedIn = __webpack_require__(31);

    /**
     * Action that duplicates an experience.
     *
     * @class DuplicateExperienceAction
     */
    return Action.extend({

        /**
         * Constructor.
         *
         * @param  {ExperienceModel} model   The experience to duplicate.
         * @param  {Object} options Additional options:
         *
         * @cfg {String}         postfix Optional name postfix.
         * @cfg {ProjectContext} projectContext Optional <tt>ProjectContext</tt>.
         */
        constructor: function constructor(model, options) {
            this.__super();

            this._model = model;
            this._options = options || {};
        },

        executable: function executable() {
            return Permissions.Privileges.CREATE.can();
        },

        _performExecution: function _performExecution(eventProperties) {
            var eventTrigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EditorEvents.constants.DUPLICATE_EXPERIENCE;

            var experienceModel = this._model;
            var projectContext = this._options.projectContext;
            var postfix = this._options.postfix ? " (" + this._options.postfix + ")" : "";

            // Make sure we fetch all before cloning...
            return experienceModel.fetchAll().then(function () {
                var clone = experienceModel.clone({ duplicate: true, duplicateExperienceWithUUID: true });

                clone.set("name", experienceModel.get("name") + postfix);
                clone.set("companyId", LoggedIn.principal().get("companyId"));

                return clone.save().then(function () {
                    return clone;
                });
            }).then(function (clone) {
                // Attach the cloned experience to the project, if any...
                if (projectContext) {
                    return projectContext.attach(clone).then(function () {
                        return clone;
                    });
                }

                // Hacky: during grouplicate we get here with an experience, fix it up
                // this avoids a Missing TriggerOrigin property precondition failure later
                // TODO: is any of this used/needed anymore?
                if (eventProperties && eventProperties.triggerOrigin) {
                    eventProperties = {
                        triggerOrigin: eventProperties.triggerOrigin
                    };
                } else if (eventProperties && eventProperties.get("height")) {
                    eventProperties = {
                        experienceId: eventProperties.get("id"),
                        experienceVersion: eventProperties.get("version"),
                        experiencePushedVersion: eventProperties.get("pushedVersion"),
                        triggerOrigin: "ExperienceExport"
                    };
                    eventTrigger = EditorEvents.constants.EXPORT_EXPORT;
                } else {
                    eventProperties = eventProperties || {
                        projectId: projectContext && projectContext.project.get("id"),
                        experienceId: experienceModel.get("id"),
                        experienceVersion: experienceModel.get("version"),
                        experiencePushedVersion: experienceModel.get("pushedVersion"),
                        triggerOrigin: "DuplicateExperienceButton"
                    };
                }

                EditorEvents.trigger(eventTrigger, eventProperties);

                return clone;
            });
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Browser = __webpack_require__(39);

    /**
     * @private @type {String}
     * Prefix to any cookie name stored as this class may be run at the client domain, i.e. in
     * DnD or the viewer. We do not want to conflict with any existing keys there.
     */
    var NAME_PREFIX = "zmags_"; // someprefix + underscore seems to be the cookie naming convention!

    /**
     * Class containing all static methods for handling cookies. <p>
     *
     * Note: all cookies are by default stored as "Secure" if and only if on a secure url/connection, i.e. not sent
     *       along with http requests, as the API is stateless. They cannot be marked as secure on non https, as they
     *       will be impossible to read via Javascript then.
     *
     * @author Bo Gotthardt (borrowed from http://www.quirksmode.org/js/cookies.html)
     *
     * @see  http://resources.infosecinstitute.com/securing-cookies-httponly-secure-flags/
     *
     * @class Cookie
     */
    return {

        /**
         * Set a cookie with the specified name and value. Overwrites the value if it already exists.
         *
         * @param {String} name the name
         * @param {String} value the value
         * @param {Number} [hours=87600] the number of days the cookie should be stored, 0 for the current session only
         */
        set: function set(name, value, hours) {
            var expires = "";
            var postfix = "; path=/";

            if (hours === undefined) {
                hours = 3650 * 24; // 10 years
            }
            if (hours) {
                var date = new Date();
                date.setTime(date.getTime() + hours * 60 * 60 * 1000);
                expires = "; expires=" + date.toGMTString();
            }
            if (Browser.capabilities.isSecure) {
                postfix += "; Secure";
            }
            window.document.cookie = "" + NAME_PREFIX + name + " = " + value + expires + postfix;
        },


        /**
         * Get the value of the cookie with the specified name, or null if it does not exist.
         *
         * @param {String} name the name
         * @return {String} the cookie value, or null
         */
        get: function get(name) {
            return this._get(NAME_PREFIX + name) || this._get(name); // TODO: legacy issue without prefix, remove eventually
        },
        _get: function _get(name) {
            var nameEQ = name + "=";
            var ca = window.document.cookie.split(";");

            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === " ") {
                    c = c.substring(1, c.length);
                }
                if (c.indexOf(nameEQ) === 0) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
            return null;
        },


        /**
         * Remove the cookie with the specified name.
         *
         * @param {String} name the name
         */
        remove: function remove(name) {
            this.set(name, "", -1);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var FontIntegrationModel = __webpack_require__(404);

    /**
     * Typekit integration model.
     *
     * @class TypekitIntegrationModel
     */
    return FontIntegrationModel.extend("TypekitIntegration", {

        defaults: {
            typekitApiToken: null
        }
    }, {
        type: "TypekitIntegration"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        isEmpty = _require.isEmpty;

    var FontProvider = __webpack_require__(103);
    var Storage = __webpack_require__(34);
    var FontLoader = __webpack_require__(260);

    var _require2 = __webpack_require__(30),
        trim = _require2.trim,
        isBlank = _require2.isBlank;

    /**
     * The order in which the different font providers are sorted/presented.
     *
     * @type {FontProvider[]}
     */


    var PREFERRED_ORDER = [FontProvider.CUSTOM, FontProvider.TYPEKIT, FontProvider.FONTS_DOT_COM, FontProvider.GOOGLE, FontProvider.STANDARD];

    /**
     * Controller for the <tt>CharacterPropertiesView</tt>. Responsible for
     * fetching and managing font data.
     *
     * @class CharacterPropertiesViewController
     * @author Kim
     */
    return {

        _fontCollection: null,
        /**
         * @private
         *
         * Invoked directly from the select2 control.
         *
         * @param  {Object} options The options object, containing the search term and callback function.
         *
         * @see  http://ivaynberg.github.io/select2/
         */
        _fontSelectorQuery: function _fontSelectorQuery(options) {
            var term = trim(options.term);

            if (isBlank(term)) {
                // Populate the default result set, including the "favorites"
                options.callback(this._populateResult(this._fontCollection.search(), true));
            } else {
                this._preloadFontsFromSearchTerm(term, options.callback);
            }
        },


        /**
         * Transforms the specified search result into an object that fits the requirement of the select2 control.
         *
         * @param  {Map.<FontProvider, Array>} searchResult A map of search results, where search results are
         * mapped to their respective font provider.
         *
         * @param {Boolean} includeFavorites Optional, whether the populated result set should include the favorite
         * fonts.
         *
         * @return {Object} An object the fits the requirement of the select2 control, see below:
         *
         * @see  http://ivaynberg.github.io/select2/
         * <pre>
         *     {
         *        more: false,
         *        results: [
         *            { text: "Western", children: [
         *                { id: "CA", text: "California" },
         *                { id: "AZ", text: "Arizona" }
         *            ] },
         *            { text: "Eastern", children: [
         *                { id: "FL", text: "Florida" }
         *            ] }
         *        ]
         *     }
         * </pre>
         */
        _populateResult: function _populateResult(searchResult, includeFavorites) {
            var _this = this;

            var results = [];
            var favorites = void 0;
            var fontDescriptors = void 0;

            searchResult.forEach(function (fontDescriptors, fontProvider) {
                if (isEmpty(fontDescriptors)) {
                    return;
                }

                results.push({
                    provider: fontProvider,
                    text: fontProvider.name,
                    children: _this._createOptions(fontDescriptors)
                });
            });

            // Sort results according to PREFERRED_ORDER
            results.sort(function (a, b) {
                var indexA = PREFERRED_ORDER.indexOf(a.provider);
                var indexB = PREFERRED_ORDER.indexOf(b.provider);

                return indexA > indexB ? 1 : -1;
            });

            if (includeFavorites) {
                // Add the favorites - if any...
                favorites = Storage.Local.get(Storage.Keys.EDITOR, "favoriteFonts", []);

                if (favorites.length) {
                    // Create array of font descriptors from the stored favorites
                    fontDescriptors = favorites.reduce(function (arr, favorite) {
                        var fontProvider = FontProvider.fromValue(favorite.fontProvider);
                        var fontDescriptor = _this._fontCollection.fromFamily(favorite.fontFamily, fontProvider);

                        if (fontDescriptor) {
                            arr.push(fontDescriptor);
                        }

                        return arr;
                    }, []);

                    // Add the favorites aka. recents at the top...
                    results.unshift({
                        text: "Recents",
                        children: this._createOptions(fontDescriptors)
                    });
                }
            }

            return {
                more: false,
                results: results
            };
        },


        /**
         * @private
         *
         * Uses the specified search term to perform a lookup for any (Custom and Google Fonts) matches in the
         * font collection. Any results will be loaded using the <tt>FontLoader</tt>.
         *
         * @param  {String}   term     The search term.
         * @param  {Function} callback The callback reference passed from the select2 control.
         */
        _preloadFontsFromSearchTerm: function _preloadFontsFromSearchTerm(term, callback) {
            var _this2 = this;

            var searchResult = this._fontCollection.search(term, 10);

            if (!searchResult.size) {
                // Empty result set
                return callback({
                    results: []
                });
            }

            var googleFontDescriptors = searchResult.get(FontProvider.GOOGLE) || [];
            var customFontDescriptors = searchResult.get(FontProvider.CUSTOM) || [];

            var fontDescriptors = googleFontDescriptors.concat(customFontDescriptors);

            // Start loading the matching fonts (including variants)
            FontLoader.fromFontDescriptors(fontDescriptors, true).then(function () {
                return callback(_this2._populateResult(searchResult));
            });
        },


        /**
         * @private
         *
         * Creates the array of child data objects passed to select2.
         *
         * @param  {FontDescriptor[]} fontDescriptors Array of <tt>FontDescriptor</tt>'s.
         * @return {Object[]}               Array of objects passed to the select2 control
         *
         * @see  #_populateResult
         */
        _createOptions: function _createOptions(fontDescriptors) {
            return fontDescriptors.map(function (fontDescriptor) {
                var name = fontDescriptor.get("name");
                var family = fontDescriptor.get("family");

                return {
                    id: family,
                    text: name,
                    fontFamily: family,
                    fontDescriptor: fontDescriptor
                };
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    return {
        TAGS: { DIV: "div", SPAN: "span" },
        HEADINGS: ["h1", "h2", "h3", "h4", "h5", "h6"],
        HIGH_LIGHT_CLASS: "highlight",
        INLINE_STYLES: ["font-size", "font-weight", "font-style", "font-family", "color", "letter-spacing", "text-decoration", "font-variant", "text-transform", "text-shadow"],
        BLOCK_STYLES: ["text-align", "line-height"],
        // "data-customfontid", "data-path" and "data-format" are reserved for custom fonts.
        // "data-kitid" is reserved for TypeKit
        // "data-projectid" is reserved for Fonts.com
        INLINE_ATTRIBUTES: ["data-font-provider", "data-customfontid", "data-path", "data-format", "data-kitid", "data-font-family", "data-projectid"],
        INHERIT: "inherit",
        ADDSTYLE: "addStyle"
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(20);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["a" /* deepmerge */])(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["a"] = (merge);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__ = __webpack_require__(1827);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__["a"]; });


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__makeStyles__ = __webpack_require__(1840);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__makeStyles__["a"]; });


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StylesProvider__ = __webpack_require__(909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["a"]; });



/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SvgIcon__ = __webpack_require__(1855);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SvgIcon__["a"]; });


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownerWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownerDocument__ = __webpack_require__(129);

function ownerWindow(node) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_0__ownerDocument__["a" /* default */])(node);
  return doc.defaultView || window;
}

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unsupportedProp;
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Backdrop__ = __webpack_require__(1876);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Backdrop__["a"]; });


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fade__ = __webpack_require__(1877);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Fade__["a"]; });


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useFormControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var FormControlContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  FormControlContext.displayName = 'FormControlContext';
}

function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](FormControlContext);
}
/* harmony default export */ __webpack_exports__["a"] = (FormControlContext);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(1906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilledInput__ = __webpack_require__(1920);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FilledInput__["a"]; });


/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormControl__ = __webpack_require__(1923);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useFormControl__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__useFormControl__["a"]; });



/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withWidth__ = __webpack_require__(966);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["c"]; });



/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__ = __webpack_require__(1958);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__["a"]; });


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(1968);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getContentStateFragment
 * @format
 * 
 */



var randomizeBlockMapKeys = __webpack_require__(1030);
var removeEntitiesAtEdges = __webpack_require__(1031);

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.
  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);

  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;

  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

module.exports = getContentStateFragment;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntity
 * @format
 * 
 */

var DraftEntityInstance = __webpack_require__(1035);
var Immutable = __webpack_require__(40);

var invariant = __webpack_require__(47);

var Map = Immutable.Map;


var instances = Map();
var instanceKey = 0;

/**
 * Temporary utility for generating the warnings
 */
function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },

  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return '' + instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    var key = '' + ++instanceKey;
    instances = instances.set(key, instance);
    return key;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);
    var newData = _extends({}, instance.getData(), toMerge);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);
    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};

module.exports = DraftEntity;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftOffsetKey
 * @format
 * 
 */



var KEY_DELIMITER = '-';

var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },

  decode: function decode(offsetKey) {
    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
        blockKey = _offsetKey$split[0],
        decoratorKey = _offsetKey$split[1],
        leafKey = _offsetKey$split[2];

    return {
      blockKey: blockKey,
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};

module.exports = DraftOffsetKey;

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(2214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(2215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(2216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(2217);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(627);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(220);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(2235);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(2240);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(435);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(797),
    isLength = __webpack_require__(643);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(1098),
    baseAssignValue = __webpack_require__(1099);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(2370),
    listCacheDelete = __webpack_require__(2371),
    listCacheGet = __webpack_require__(2372),
    listCacheHas = __webpack_require__(2373),
    listCacheSet = __webpack_require__(2374);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(332);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(132);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(2394);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(279),
    isObjectLike = __webpack_require__(222);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(447);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Context_1 = __webpack_require__(1127);
var Global_1 = __webpack_require__(38);
var Factory_1 = __webpack_require__(37);
var Validators_1 = __webpack_require__(41);
var _pixelRatio;
function getDevicePixelRatio() {
    if (_pixelRatio) {
        return _pixelRatio;
    }
    var canvas = Util_1.Util.createCanvasElement();
    var context = canvas.getContext('2d');
    _pixelRatio = (function () {
        var devicePixelRatio = Global_1.Konva._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio ||
            context.backingStorePixelRatio ||
            1;
        return devicePixelRatio / backingStoreRatio;
    })();
    return _pixelRatio;
}
var Canvas = (function () {
    function Canvas(config) {
        this.pixelRatio = 1;
        this.width = 0;
        this.height = 0;
        this.isCache = false;
        var conf = config || {};
        var pixelRatio = conf.pixelRatio || Global_1.Konva.pixelRatio || getDevicePixelRatio();
        this.pixelRatio = pixelRatio;
        this._canvas = Util_1.Util.createCanvasElement();
        this._canvas.style.padding = '0';
        this._canvas.style.margin = '0';
        this._canvas.style.border = '0';
        this._canvas.style.background = 'transparent';
        this._canvas.style.position = 'absolute';
        this._canvas.style.top = '0';
        this._canvas.style.left = '0';
    }
    Canvas.prototype.getContext = function () {
        return this.context;
    };
    Canvas.prototype.getPixelRatio = function () {
        return this.pixelRatio;
    };
    Canvas.prototype.setPixelRatio = function (pixelRatio) {
        var previousRatio = this.pixelRatio;
        this.pixelRatio = pixelRatio;
        this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
    };
    Canvas.prototype.setWidth = function (width) {
        this.width = this._canvas.width = width * this.pixelRatio;
        this._canvas.style.width = width + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    };
    Canvas.prototype.setHeight = function (height) {
        this.height = this._canvas.height = height * this.pixelRatio;
        this._canvas.style.height = height + 'px';
        var pixelRatio = this.pixelRatio, _context = this.getContext()._context;
        _context.scale(pixelRatio, pixelRatio);
    };
    Canvas.prototype.getWidth = function () {
        return this.width;
    };
    Canvas.prototype.getHeight = function () {
        return this.height;
    };
    Canvas.prototype.setSize = function (width, height) {
        this.setWidth(width || 0);
        this.setHeight(height || 0);
    };
    Canvas.prototype.toDataURL = function (mimeType, quality) {
        try {
            return this._canvas.toDataURL(mimeType, quality);
        }
        catch (e) {
            try {
                return this._canvas.toDataURL();
            }
            catch (err) {
                Util_1.Util.error('Unable to get data URL. ' +
                    err.message +
                    ' For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.');
                return '';
            }
        }
    };
    return Canvas;
}());
exports.Canvas = Canvas;
Factory_1.Factory.addGetterSetter(Canvas, 'pixelRatio', undefined, Validators_1.getNumberValidator());
var SceneCanvas = (function (_super) {
    __extends(SceneCanvas, _super);
    function SceneCanvas(config) {
        if (config === void 0) { config = { width: 0, height: 0 }; }
        var _this = _super.call(this, config) || this;
        _this.context = new Context_1.SceneContext(_this);
        _this.setSize(config.width, config.height);
        return _this;
    }
    return SceneCanvas;
}(Canvas));
exports.SceneCanvas = SceneCanvas;
var HitCanvas = (function (_super) {
    __extends(HitCanvas, _super);
    function HitCanvas(config) {
        if (config === void 0) { config = { width: 0, height: 0 }; }
        var _this = _super.call(this, config) || this;
        _this.hitCanvas = true;
        _this.context = new Context_1.HitContext(_this);
        _this.setSize(config.width, config.height);
        return _this;
    }
    return HitCanvas;
}(Canvas));
exports.HitCanvas = HitCanvas;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
var Container = (function (_super) {
    __extends(Container, _super);
    function Container() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.children = new Util_1.Collection();
        return _this;
    }
    Container.prototype.getChildren = function (filterFunc) {
        if (!filterFunc) {
            return this.children;
        }
        var results = new Util_1.Collection();
        this.children.each(function (child) {
            if (filterFunc(child)) {
                results.push(child);
            }
        });
        return results;
    };
    Container.prototype.hasChildren = function () {
        return this.getChildren().length > 0;
    };
    Container.prototype.removeChildren = function () {
        var child;
        for (var i = 0; i < this.children.length; i++) {
            child = this.children[i];
            child.parent = null;
            child.index = 0;
            child.remove();
        }
        this.children = new Util_1.Collection();
        return this;
    };
    Container.prototype.destroyChildren = function () {
        var child;
        for (var i = 0; i < this.children.length; i++) {
            child = this.children[i];
            child.parent = null;
            child.index = 0;
            child.destroy();
        }
        this.children = new Util_1.Collection();
        return this;
    };
    Container.prototype.add = function () {
        var children = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            children[_i] = arguments[_i];
        }
        if (arguments.length > 1) {
            for (var i = 0; i < arguments.length; i++) {
                this.add(arguments[i]);
            }
            return this;
        }
        var child = children[0];
        if (child.getParent()) {
            child.moveTo(this);
            return this;
        }
        var _children = this.children;
        this._validateAdd(child);
        child._clearCaches();
        child.index = _children.length;
        child.parent = this;
        _children.push(child);
        this._fire('add', {
            child: child,
        });
        return this;
    };
    Container.prototype.destroy = function () {
        if (this.hasChildren()) {
            this.destroyChildren();
        }
        _super.prototype.destroy.call(this);
        return this;
    };
    Container.prototype.find = function (selector) {
        return this._generalFind(selector, false);
    };
    Container.prototype.get = function (selector) {
        Util_1.Util.warn('collection.get() method is deprecated. Please use collection.find() instead.');
        return this.find(selector);
    };
    Container.prototype.findOne = function (selector) {
        var result = this._generalFind(selector, true);
        return result.length > 0 ? result[0] : undefined;
    };
    Container.prototype._generalFind = function (selector, findOne) {
        var retArr = [];
        this._descendants(function (node) {
            var valid = node._isMatch(selector);
            if (valid) {
                retArr.push(node);
            }
            if (valid && findOne) {
                return true;
            }
            return false;
        });
        return Util_1.Collection.toCollection(retArr);
    };
    Container.prototype._descendants = function (fn) {
        var shouldStop = false;
        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            shouldStop = fn(child);
            if (shouldStop) {
                return true;
            }
            if (!child.hasChildren()) {
                continue;
            }
            shouldStop = child._descendants(fn);
            if (shouldStop) {
                return true;
            }
        }
        return false;
    };
    Container.prototype.toObject = function () {
        var obj = Node_1.Node.prototype.toObject.call(this);
        obj.children = [];
        var children = this.getChildren();
        var len = children.length;
        for (var n = 0; n < len; n++) {
            var child = children[n];
            obj.children.push(child.toObject());
        }
        return obj;
    };
    Container.prototype.isAncestorOf = function (node) {
        var parent = node.getParent();
        while (parent) {
            if (parent._id === this._id) {
                return true;
            }
            parent = parent.getParent();
        }
        return false;
    };
    Container.prototype.clone = function (obj) {
        var node = Node_1.Node.prototype.clone.call(this, obj);
        this.getChildren().each(function (no) {
            node.add(no.clone());
        });
        return node;
    };
    Container.prototype.getAllIntersections = function (pos) {
        var arr = [];
        this.find('Shape').each(function (shape) {
            if (shape.isVisible() && shape.intersects(pos)) {
                arr.push(shape);
            }
        });
        return arr;
    };
    Container.prototype._setChildrenIndices = function () {
        this.children.each(function (child, n) {
            child.index = n;
        });
    };
    Container.prototype.drawScene = function (can, top) {
        var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas()), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
        var caching = canvas && canvas.isCache;
        if (!this.isVisible() && !caching) {
            return this;
        }
        if (cachedSceneCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
        }
        else {
            this._drawChildren('drawScene', canvas, top);
        }
        return this;
    };
    Container.prototype.drawHit = function (can, top) {
        if (!this.shouldDrawHit(top)) {
            return this;
        }
        var layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
        if (cachedHitCanvas) {
            context.save();
            var m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
        }
        else {
            this._drawChildren('drawHit', canvas, top);
        }
        return this;
    };
    Container.prototype._drawChildren = function (drawMethod, canvas, top) {
        var context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = (clipWidth && clipHeight) || clipFunc;
        var selfCache = top === this;
        if (hasClip) {
            context.save();
            var transform = this.getAbsoluteTransform(top);
            var m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            if (clipFunc) {
                clipFunc.call(this, context, this);
            }
            else {
                var clipX = this.clipX();
                var clipY = this.clipY();
                context.rect(clipX, clipY, clipWidth, clipHeight);
            }
            context.clip();
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        var hasComposition = !selfCache &&
            this.globalCompositeOperation() !== 'source-over' &&
            drawMethod === 'drawScene';
        if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
        }
        this.children.each(function (child) {
            child[drawMethod](canvas, top);
        });
        if (hasComposition) {
            context.restore();
        }
        if (hasClip) {
            context.restore();
        }
    };
    Container.prototype.getClientRect = function (config) {
        config = config || {};
        var skipTransform = config.skipTransform;
        var relativeTo = config.relativeTo;
        var minX, minY, maxX, maxY;
        var selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0,
        };
        var that = this;
        this.children.each(function (child) {
            if (!child.visible()) {
                return;
            }
            var rect = child.getClientRect({
                relativeTo: that,
                skipShadow: config.skipShadow,
                skipStroke: config.skipStroke,
            });
            if (rect.width === 0 && rect.height === 0) {
                return;
            }
            if (minX === undefined) {
                minX = rect.x;
                minY = rect.y;
                maxX = rect.x + rect.width;
                maxY = rect.y + rect.height;
            }
            else {
                minX = Math.min(minX, rect.x);
                minY = Math.min(minY, rect.y);
                maxX = Math.max(maxX, rect.x + rect.width);
                maxY = Math.max(maxY, rect.y + rect.height);
            }
        });
        var shapes = this.find('Shape');
        var hasVisible = false;
        for (var i = 0; i < shapes.length; i++) {
            var shape = shapes[i];
            if (shape._isVisible(this)) {
                hasVisible = true;
                break;
            }
        }
        if (hasVisible && minX !== undefined) {
            selfRect = {
                x: minX,
                y: minY,
                width: maxX - minX,
                height: maxY - minY,
            };
        }
        else {
            selfRect = {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            };
        }
        if (!skipTransform) {
            return this._transformedRect(selfRect, relativeTo);
        }
        return selfRect;
    };
    return Container;
}(Node_1.Node));
exports.Container = Container;
Factory_1.Factory.addComponentsGetterSetter(Container, 'clip', [
    'x',
    'y',
    'width',
    'height',
]);
Factory_1.Factory.addGetterSetter(Container, 'clipX', undefined, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Container, 'clipY', undefined, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Container, 'clipWidth', undefined, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Container, 'clipHeight', undefined, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Container, 'clipFunc');
Util_1.Collection.mapMethods(Container);


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(55);

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeOne);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getScrollParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getScrollTop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return animatedScrollTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMobileDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isDocumentElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return cleanValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBoundingClientObj; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return scrollIntoView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isTouchCapable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return classNames; });
/* unused harmony export k */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return scrollTo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(140);


// ==============================
// NO OP
// ==============================
var noop = function noop() {};
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/

function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, state, className) {
  var arr = [className];

  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push("".concat(applyPrefixToName(prefix, key)));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
} // ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(value) === 'object' && value !== null) return [value];
  return [];
}; // ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }

  return inputValue;
} // ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }

  return el.scrollTop;
}
function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);

    if (excludeStaticParent && style.position === 'static') {
      continue;
    }

    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
} // Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/

function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;
  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);

    if (currentTime < duration) {
      window.requestAnimationFrame(animateScroll);
    } else {
      callback(element);
    }
  }

  animateScroll();
} // Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect

function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
} // ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch (e) {
    return false;
  }
}




/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParentNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNodeName_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instanceOf_js__ = __webpack_require__(95);



function getParentNode(element) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__getNodeName_js__["a" /* default */])(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    Object(__WEBPACK_IMPORTED_MODULE_2__instanceOf_js__["c" /* isShadowRoot */])(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Object(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element) // fallback

  );
}

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = printValue;
var toString = Object.prototype.toString;
var errorToString = Error.prototype.toString;
var regExpToString = RegExp.prototype.toString;
var symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : function () {
  return '';
};
var SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  var isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings) {
  if (quoteStrings === void 0) {
    quoteStrings = false;
  }

  if (val == null || val === true || val === false) return '' + val;
  var typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? "\"" + val + "\"" : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  var tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  var result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    var result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */


function Cache(maxSize) {
  this._maxSize = maxSize
  this.clear()
}
Cache.prototype.clear = function () {
  this._size = 0
  this._values = Object.create(null)
}
Cache.prototype.get = function (key) {
  return this._values[key]
}
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear()
  if (!(key in this._values)) this._size++

  return (this._values[key] = value)
}

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE)

var config

module.exports = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path)

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0
        var len = parts.length
        var data = obj

        while (index < len - 1) {
          var part = parts[index]
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]]
        }
        data[parts[index]] = value
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path)
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]]
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg)
  },
}

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket

  for (idx = 0; idx < len; idx++) {
    part = parts[idx]

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"'
      }

      isBracket = isQuoted(part)
      isArray = !isBracket && /^\d+$/.test(part)

      iter.call(thisArg, part, isBracket, isArray, idx, parts)
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return value == null;
});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2698);
} else {
  module.exports = require('./cjs/react-dom-server.browser.development.js');
}


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (r1, r2) {
  if (r1.offset === r2.offset) {
    return r2.length - r1.length;
  }
  return r1.offset - r2.offset;
};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = splitReactElement;

var _invariant = __webpack_require__(138);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(458);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// see http://w3c.github.io/html/syntax.html#writing-html-documents-elements
var VOID_TAGS = ['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr'];

function splitReactElement(element) {
  if (VOID_TAGS.indexOf(element.type) !== -1) {
    return _server2.default.renderToStaticMarkup(element);
  }

  var tags = _server2.default.renderToStaticMarkup(_react2.default.cloneElement(element, {}, '\r')).split('\r');

  (0, _invariant2.default)(tags.length > 1, 'convertToHTML: Element of type ' + element.type + ' must render children');

  (0, _invariant2.default)(tags.length < 3, 'convertToHTML: Element of type ' + element.type + ' cannot use carriage return character');

  return {
    start: tags[0],
    end: tags[1]
  };
}

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorEvents = __webpack_require__(17),
        ImprovedView = __webpack_require__(6),
        Ladda = __webpack_require__(340),
        NavBarCurrentPrincipalView = __webpack_require__(2803),
        Permissions = __webpack_require__(22),
        SyncManager = __webpack_require__(44),
        template = __webpack_require__(2808);
    var Storage = __webpack_require__(34);
    /**
     * The navigation bar view.
     *
     * @class NavBarView
     * @constructor
     *
     * @cfg {Principal} [principal] The current logged in principal. If specified, the nav bar options related to
     *                              the current principal (and associated user) are displayed.
     */
    return ImprovedView.extend({
        /**
         * @private @type {Ladda}
         * Spinner activated while global sync(s) is (are) pending. <p>
         */
        _spinner: null,

        _currentPrincipalView: null,

        _currentProject: null,

        template: template,

        templateHelpers: function templateHelpers() {
            var currentProjectName = this._currentProject ? this._currentProject.get("name") : "",
                currentProjectId = this._currentProject ? this._currentProject.get("id") : "";

            return {
                currentProject: this._currentProject,
                currentProjectName: currentProjectName,
                currentProjectId: currentProjectId,
                spectator: this.spectatorMode,
                contentControlBetaEnabled: Storage.Local.get(Storage.Keys.CONTENT_CONTROL_BETA, Storage.Keys.CONTENT_CONTROL_BETA),
                newDashboardExperience: Storage.Local.get(Storage.Keys.NEW_DASHBOARD_EXP, Storage.Keys.NEW_DASHBOARD_EXP)
            };
        },

        regions: {
            currentPrincipal: ".current-principal"
        },

        ui: {
            logo: ".logo",
            projectSelectorBtn: ".project-selector-btn",
            projectContextBtn: ".project-context-btn",
            spinner: ".spinner"
        },

        events: {
            "click @ui.logo": "_trackEditorEvent",
            "click @ui.projectSelectorBtn": "_handleProjectSelectorBtnClick",
            "click @ui.projectContextBtn": "_handleProjectContextClick"
        },

        viewScope: function viewScope() {
            return {
                viewModel: this.options.viewModel
            };
        },

        _handleProjectSelectorBtnClick: function _handleProjectSelectorBtnClick() {
            this.toggleProjectPanel();

            var eventProperties = {
                projectId: this._currentProject && this._currentProject.get("id"),
                triggerOrigin: "ProjectSelectorButton"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_PROJECT_SELECTOR, eventProperties);
        },

        _handleProjectContextClick: function _handleProjectContextClick() {
            var eventProperties = {
                dashboardType: "Experiences",
                projectId: this._currentProject && this._currentProject.get("id"),
                triggerOrigin: "DashboardTab"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_DASHBOARD, eventProperties);
        },

        toggleProjectPanel: function toggleProjectPanel() {
            this.viewScope.toggleProjectSelector();
        },

        _toggleSync: function _toggleSync(syncing) {
            if (this._spinner) {
                if (syncing) {
                    this._spinner.start();
                } else {
                    this._spinner.stop(0); // stop with 0 delay, we know this event is already delay a bit...
                }
            }
        },

        initialize: function initialize(options) {
            var experienceId;
            if (this.model) {
                experienceId = this.model.get("id");
            }

            //on coming to legacy dashboard set the key to false.
            if (window.location.hash.split("/") == 0) {
                Storage.Local.update(Storage.Keys.NEW_DASHBOARD_EXP, Storage.Keys.NEW_DASHBOARD_EXP, false);
            }

            this._currentPrincipalView = new NavBarCurrentPrincipalView({
                model: options.principal,
                project: this._currentProject,
                experienceId: experienceId
            });

            this._currentProject = this.options.project;

            if (this._currentProject) {
                this.listenTo(this._currentProject, "change:name", function (model, value) {
                    this.ui.projectContextBtn.text(value);
                });
            }

            this.spectatorMode = Permissions.Privileges.CREATE.cannot();
        },

        onRender: function onRender() {
            if (this.options.principal) {
                this.currentPrincipal.show(this._currentPrincipalView);
            }

            // Create global spinner...
            if (this.ui.spinner.length) {
                this._spinner = Ladda.create(this.ui.spinner[0]);
                this.listenTo(SyncManager, "syncing", this._toggleSync.bind(this));
                // Set initial state...
                this._toggleSync(SyncManager.syncing());
            }
        },

        onClose: function onClose() {
            this._toggleSync(false);
        },

        /**
         * Tracks Mix Panel event when clicking the Creator logo.
         * @private
         */
        _trackEditorEvent: function _trackEditorEvent() {
            var eventProperties = {
                projectId: this._currentProject && this._currentProject.get("id"),
                dashboardType: "Experiences",
                triggerOrigin: "CreatorLogoLink"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_DASHBOARD, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var ImprovedModel = __webpack_require__(25);
    var PublishableCollection = __webpack_require__(2823);
    var ContentQuery = __webpack_require__(139);
    var BreakpointGroup = __webpack_require__(97);
    var ExperienceModel = __webpack_require__(58);
    var LocalizationGroup = __webpack_require__(232);

    // Defined supported (polymorphic) types/models.
    var contentTypes = new Map();

    contentTypes.set(LocalizationGroup.type, LocalizationGroup);
    contentTypes.set(BreakpointGroup.type, BreakpointGroup);
    contentTypes.set(ExperienceModel.type, ExperienceModel);

    return {

        /**
         * Starts fetching the publishables.
         *
         * @param  {Object} options Options passed to the fetch call.
         * @return {Promise}        Promise that resolves with a <tt>Backbone.Collection</tt> containing the publishables.
         */
        fetch: function fetch() {
            var _this = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var sorting = options.sorting || ContentQuery.sort().field("editedAt");
            var query = null;

            if (options.term) {
                query = ContentQuery.search(options.term, sorting);
            } else {
                query = sorting;
            }

            var publishableCollection = new PublishableCollection(options);
            return publishableCollection.query(query).then(function (results) {
                var models = new Backbone.Collection(results);
                var publishableDescriptors = _this.descriptors(models);

                return {
                    models: models,
                    publishableCollection: publishableCollection,
                    publishableDescriptors: publishableDescriptors
                };
            });
        },
        descriptors: function descriptors(models) {
            return models.map(function (model) {
                return {
                    name: model.publishableDisplayName(),
                    model: model
                };
            });
        },
        toReference: function toReference(publishable, type) {
            if (publishable) {
                var reference = { id: publishable.id };

                reference.type = type || publishable.get("type") || publishable.constructor.type;

                return reference;
            }

            return publishable;
        },
        resolveReference: function resolveReference(reference, resolvedReferences) {
            if (!reference || reference instanceof ImprovedModel || !resolvedReferences) {
                return reference;
            }

            var model = resolvedReferences[reference.id];

            if (model) {
                var modelClass = contentTypes.get(model.type);
                return new modelClass(model);
            }

            return model;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defaults = _require.defaults;

    var BreakpointGroup = __webpack_require__(97);
    var ChunkingCollection = __webpack_require__(400);
    var ExperienceModel = __webpack_require__(58);
    var LocalizationGroup = __webpack_require__(232);
    var RestApi = __webpack_require__(29);
    var SyncManager = __webpack_require__(44);
    var LoggedInUserState = __webpack_require__(19);
    var Configuration = __webpack_require__(27);

    // Defined supported (polymorphic) types/models.
    var contentTypes = new Map();

    contentTypes.set(LocalizationGroup.type, LocalizationGroup);
    contentTypes.set(BreakpointGroup.type, BreakpointGroup);
    contentTypes.set(ExperienceModel.type, ExperienceModel);

    var ContentCollection = ChunkingCollection.extend({

        model: contentTypes,

        url: function url(options) {
            var project = options && options.project;
            var allProjectsContents = options && options.allProjectsContents;
            var isUserPermissionsEnabled = LoggedInUserState.get("companySettings").get("userPermissionsEnabled");

            if (project) {
                // projects/{ID}/contents
                return RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.CONTENTS);
            } else if (allProjectsContents) {
                // projects/contents
                // Dead code path - might want to delete
                return RestApi.pathToCollection(RestApi.Collections.PROJECTS_ALL_CONTENTS);
            }

            return isUserPermissionsEnabled ? Configuration.msExperiencesUrl + "/api/contents/" : RestApi.pathToCollection(RestApi.Collections.CONTENTS, true);
        }
    }, {

        /**
         * Counts the entire content collection.
         *
         * @param  {Object} options Optional options.
         * @cfg {ProjectModel} project         The <tt>ProjectModel</tt> instance, to count content for a specific project, defaults to <tt>null</tt>.
         *
         * @return {Promise}        A <tt>Promise</tt> that resolves with the count/number.
         */
        count: function count(options) {
            options = defaults(options || {}, {
                project: null
            });

            var _options = options,
                project = _options.project;

            var target = SyncManager.target("ContentCollection.count");
            var url = void 0;
            var isUserPermissionsEnabled = LoggedInUserState.get("companySettings").get("userPermissionsEnabled");

            if (project) {
                url = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.CONTENTS_COUNT);
            } else {
                url = isUserPermissionsEnabled ? Configuration.msExperiencesUrl + "/api/contents/counts/" : RestApi.pathToCollection(RestApi.Collections.CONTENTS_COUNT);
            }
            return SyncManager.get(url, target);
        }
    });

    return ContentCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    /**
     * Formats the supplied value based on the type/name of "v", defaulting to "str" if no specific formatter
     * is found.
     *
     * @param {*} v The value to find a formatter for; will default to "str" formatter if undefined.
     * @return {String} The formatted value.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */

    var format = function format(v) {
        // NOTE: will *not* work on minified code, but channel types, e.g. Snippet, also defines toString functions calling this formatter!
        var name;
        if (typeof v !== "undefined") {
            if (v.constructor) {
                // type with constructor function
                name = v.constructor.name;
                if (!name) {
                    // IE trouble again
                    var match = /function ([^(]+)/.exec(v.constructor.toString());
                    name = match && match[1];
                }
            }
            if (!name) {
                name = v.name; // may not be present still...
            }
        }
        var fn = format[(name || "").toLowerCase()] || format.str;
        return fn(v);
    };

    /**
     * Returns the JSON object if available for the current browser, otherwise falsey.
     *
     * @return {JSON} The JSON object, with <tt>parse</tt> and <tt>stringify</tt> methods, if available; can be falsey.
     */
    format.json = function () {
        // Implementation note: defined here because of circular dependencies!
        return typeof JSON !== "undefined" && typeof JSON.parse === "function" && typeof JSON.stringify === "function" && JSON;
    };

    // Formats the supplied snippet...
    format.snippet = function (snippet) {
        var s = "Snippet[id: " + format.val(snippet.configId) + "; mode: " + format.val(snippet.mode);
        if (snippet._preview) {
            s += "; preview: " + format.val(snippet._preview);
        }
        return s + "]";
    };

    // Formats the supplied snippet...
    format.channel = function (channel) {
        var s = "Channel[",
            e;

        if (channel.name) {
            s += "name: " + format.val(channel.name) + "; ";
        }
        s += "state: " + channel.state;
        if (channel.origin) {
            s += "/" + channel.origin;
        }
        s += "; restore-type: " + format.val(channel._restoreType) + "; loading-indicator: " + format.val(channel._loadingIndicator.options);

        if (channel._selector) {
            s += "; selector: " + format.val(channel._selector);
        } else {
            e = channel._dom.element;
            if (e) {
                s += "; in-place-element: " + format.element(e);
            }
        }
        if (channel.embedded) {
            s += "; embedded: " + channel.embedded.id;
        }
        if (channel._url) {
            s += "; url: " + format.val(channel._url);
        }
        return s + "; content: " + format.content(channel.content) + "]";
    };

    // Formats the supplied content...
    format.content = function (content) {
        var s = "Content[type: " + content.type,
            c;

        if (content.type === "experience") {
            c = format.experience(content.data(true)); // true: not dirty
        } else if (content.type === "group") {
            c = format.group(content.data(true));
        }
        if (c) {
            s += "; data: " + c;
            if (content.type === "experience") {
                // only really relevant for Experiences
                s += "; scene: " + content.scene.current;
            }
        }

        return s + "; state: " + content.state + "]";
    };

    // Formats the supplied viewer bridge (for the viewer proxy)...
    format.viewerBridge = function (viewerBridge) {
        var s = "ViewerBridge[",
            c = viewerBridge.channel(),
            v = viewerBridge._viewerProxy();

        if (c) {
            s += "channel-id: " + c.id;
        }
        if (v) {
            if (c) {
                s += "; ";
            }
            s += "viewer: " + v;
        }
        return s + "]";
    };

    // Formats the supplied experience...
    format.experience = function (experience) {
        var s = "Experience[id: " + format.val(experience.id);
        if (experience.name) {
            s += "; name: " + format.val(experience.name);
        }
        return s + "]";
    };

    // Formats the supplied group...
    format.group = function (group) {
        var s = group.type ? group.type : "Group";
        s += "[id: " + format.val(group.id);
        if (group.name) {
            s += "; name: " + format.val(group.name);
        }
        return s + "]";
    };

    // Formats a html element
    format.element = function (element) {
        return element.tagName + "[" + (element.id || element.name || element.className) + "]";
    };

    // Founds a ClientRect/bounds object
    format.bounds = function (bounds) {
        if (bounds) {
            var s = "(w:" + (bounds.width || 0) + ", h:" + (bounds.height || 0);
            if (typeof bounds.left !== "undefined") {
                s += ", x:" + bounds.left;
            }
            if (typeof bounds.top !== "undefined") {
                s += ", y:" + bounds.top;
            }
            return s + ")";
        }
        return "none";
    };

    // Formats the supplied dom match...
    format.match = function (match) {
        var s = "Match[element: <" + (match.element ? match.element.tagName : "") + ">; viewport: " + format.bounds(match.viewport);
        if (match.elements.length) {
            s += "; elements: " + match.elements.length;
        }
        return s + "]";
    };

    // Formats the supplied value as json if possible...
    format.stringify = function (v) {
        if (format.json) {
            try {
                // Will return undefined - go figure - if it cannot be stringified in legacy IE...
                var value = format.json.stringify(v);
                if (typeof value !== "undefined") {
                    return value;
                }
                // Fall-through...
            } catch (e) {
                // Fall-through...
            }
        }
        // This also handles null, undefined, and non-jsonable types, though somewhat poorly as not proper json then...
        return "" + v;
    };

    // Formats the supplied value as a (json) string...
    format.str = function (v) {
        if (typeof v === "string") {
            return v;
        } else if (typeof v === "undefined" || v === null) {
            // null is an Object
            return "";
        }
        var s = v.toString();
        return s === "[object Object]" ? format.stringify(v) : s;
    };

    // Formats the supplied value by enclosing it in single quotes...
    format.val = function (v) {
        return "'" + v + "'";
    };

    return format;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*global:MessageChannel,____message_node_scope,define,JSON2*/

/*
 * MessageNode: a small api for cross-domain (where supported) message passing between windows/tabs/iframes/frames/workers. <p>
 *
 * Supports (at least) Chrome, Opera, Firefox, Safari, IE 8-11 (IE does not support cross domain message passing
 * between windows, only between iframes).
 *
 * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
 */
(function (self, universe) {

    //
    // UTILITIES
    //

    // "def" and "is" required since the type queried for instance of may not exist in the given context. The queried
    // type ("o") has to be a string argument, since JavaScript cannot call a function with a reference that resolves
    // to undefined at call-time. The function are only used where the queried type may not be defined, not for simple
    // tests like "instanceof Context" for types defines here. Be *very* careful before changing the implementation of
    // these functions, or it is likely to break in various browsers...
    function def(o, scope) {
        if (!scope) {
            scope = self;
        }
        return scope && typeof scope[o] !== "undefined";
    }
    function is(o, type, scope) {
        if (!scope) {
            scope = self;
        }

        try {
            return def(type, scope) && o instanceof scope[type];
        } catch (error) {
            return false;
        }
    }

    function obj(o) {
        return (typeof o === "undefined" ? "undefined" : _typeof(o)) === "object";
    }
    function fn(o) {
        return typeof o === "function"; // will not catch legacy IE window or dom functions
    }
    function str(o) {
        return typeof o === "string";
    }
    function itr(o) {
        return o && typeof o.length === "number" && !str(o); // good enough for our usage!
    }
    function forward(node, args, rest) {
        var more = typeof rest !== "undefined";
        if (node.global.legacy() || more) {
            args = Array.prototype.slice.call(args);
            if (more) {
                args = args.concat(rest);
            }
        }
        return args;
    }
    function copy(source, target) {
        // deep!
        target = target || {};
        var name, value;
        for (name in source) {
            if (source.hasOwnProperty(name)) {
                value = source[name];
                if (obj(value)) {
                    copy(value, target[name] = {});
                } else {
                    target[name] = value;
                }
            }
        }
        return target;
    }
    function join(o, delimiter) {
        delimiter = delimiter || "";
        if (isNative(o.join) && fn(o.join)) {
            return o.join(delimiter);
        } else if (itr(o)) {
            // e.g. Arguments
            var i,
                s = "";
            for (i = 0; i < o.length; i++) {
                if (i > 0) {
                    s += delimiter;
                }
                s += o[i];
            }
            return s;
        }
        return o.toString();
    }
    function isNative(f) {
        // Cannot test for "function" type here, as old IE will give "object" for window and DOM functions...
        return f && !("prototype" in f);
    }
    function idx(o, v, offset) {
        if (isNative(o.indexOf) && fn(o.indexOf)) {
            // strings, Array in non-legacy browsers...
            return o.indexOf(v, offset || 0);
        } else if (itr(o)) {
            // arguments, Arrays in legacy browsers (never strings)...
            var i;
            for (i = offset || 0; i < o.length; i++) {
                if (o[i] === v) {
                    return i;
                }
            }
        } else if (str(o) && v) {
            // string in legacy browsers or where "indexOf" has been overridden...
            // We have to escape special characters: http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
            var regex = new RegExp(v.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&"), "g"),
                match;
            if (offset) {
                regex.lastIndex = offset;
            }
            match = regex.exec(o);
            if (match) {
                return match.index;
            }
            // Fall-through
        }
        // Other types may be here, e.g. number, for which we simply return -1...
        return -1;
    }

    // Escapes "delimiter" in s where not already escaped...
    function escape(s, delimiter) {
        var i = idx(s, delimiter),
            j,
            n,
            offset;
        while (i !== -1) {
            j = i;n = 0;
            // Make sure the delimiter is not already escaped using a backslash...
            while (j-- && s.charAt(j) === "\\") {
                n++;
            }
            // Even number of backslashes means not escaped...
            if ((offset = n % 2) === 0) {
                s = s.substring(0, i) + "\\" + s.substring(i);
            }
            // Find next match, if any...
            i = idx(s, delimiter, i + delimiter.length + (1 - offset)); // + 1 for escaped
        }
        return s;
    }

    // Cannot use JavaScript limited split, since it will discard the reminder after "limit"
    // and we need to unescape as well...
    function unescape(s, delimiter, limit) {
        var parts = [],
            part,
            i,
            j,
            n,
            first = 0,
            last = 0,
            any = false,
            regex = new RegExp("\\\\" + delimiter, "g");
        if (!s) {
            return parts;
        }
        while (!limit || parts.length < limit - 1) {
            i = idx(s, delimiter, last);
            if (i === -1) {
                break;
            }
            j = i;n = 0;
            // Make sure the delimiter is not escaped using a backslash...
            while (j-- && s.charAt(j) === "\\") {
                n++;
            }
            // Even number of backslashes means not escaped, but remember to unescape in the
            // individual parts when needed...
            if (n % 2 === 0) {
                part = s.substring(first, i);
                if (any) {
                    part = part.replace(regex, delimiter);
                }
                parts.push(part);
                first = i + delimiter.length;
                any = false;
            } else {
                any = true;
            }
            last = i + delimiter.length;
        }
        // Remember last part, where we always have to replace since not visited here...
        parts.push(s.substring(first).replace(regex, delimiter));
        return parts;
    }

    function path(o, scope) {
        if (obj(scope)) {
            return scope;
        }
        var parts = str(scope) ? scope.split(".") : [],
            i = -1,
            a = o,
            b;
        try {
            while (++i < parts.length) {
                b = a[parts[i]];
                if (b == null) {
                    a[parts[i]] = b = {};
                }
                a = b;
            }
            o = a;
        } catch (e) {// SecurityError, ReferenceError, etc
            // Fall-through!
        }
        return o;
    }

    var now = Date.now || function () {
        return new Date().getTime();
    };

    //
    // JSON
    //


    // Simple json wrapper that takes simple string message payloads into account...
    function Json(json) {
        var scope = this,
            parse,
            format;

        if (!json) {
            json = {};
        }

        // Boolean short cut like "json: false|true" supported...
        if (typeof json !== "boolean" || json) {
            // Configured, JSON2, or JSON?
            parse = json.parse || (def("JSON2") ? JSON2.parse || JSON2.decode : def("JSON") ? JSON.parse : null);
            if (!parse) {
                // jQuery or String?
                parse = def("$") ? $.parseJSON || $.evalJSON : String.prototype.evalJSON ? function (o) {
                    o.toString().evalJSON();
                } : null;
            }
            // Configured, JSON2, or JSON?
            format = json.format || (def("JSON2") ? JSON2.stringify || JSON2.encode : def("JSON") ? JSON.stringify : null);
            if (!format) {
                // jQuery or Object?
                format = def("$") ? $.toJSON : Object.toJSON;
            }
        }

        // Supports simple string message data structures as well as json...
        this.parse = function (s) {
            return fn(parse) && scope.formatted(s) ? parse(s) : s;
        };
        this.format = function (o) {
            return !fn(format) || str(o) ? o.toString() : format(o);
        };

        this.formatted = function (s) {
            return str(s) && s.charAt(0) === "{" && s.charAt(s.length - 1) === "}";
        };
        this.supported = fn(parse) && fn(format);

        this.toString = function () {
            return "Json[supported: " + scope.supported + "]";
        };
    }

    //
    // CONTEXT
    //


    // Determines the context where a given postable/listener lives: "port", "global", "worker", "window", "unknown", or "none"...
    function Context(node, context) {
        var scope = this,
            listeners = {},
            listening = false,
            cachedType,
            legacy = null;

        // Actual context object, e.g. Window or Worker...
        this.ctx = void 0; // undefined

        // Currently, this really means IE < 10. Use to determine how event listeners are added, json support, and how
        // console behaves...
        this.legacy = function () {
            // TODO: <= FF6 does not support json either!
            // FIXME: ie9 issues here - does not report legacy!
            if (legacy === null) {
                legacy = false;
                try {
                    if (!fn(scope.ctx.addEventListener)) {
                        // we need to test on Error.stack in case no ctx set, and this will do the trick
                        return legacy = true;
                    }
                } catch (e) {
                    // SecurityError or intentional NullPointer
                    legacy = !e.stack;
                }
            }
            return legacy;
        };

        function visit(f) {
            var type, entry, i;
            for (type in listeners) {
                if (listeners.hasOwnProperty(type)) {
                    entry = listeners[type];
                    for (i = 0; i < entry.length; i++) {
                        f(type, entry[i]);
                    }
                }
            }
        }
        function add(type, listener) {
            if (!listener.added) {
                try {
                    if (scope.legacy()) {
                        scope.ctx.attachEvent("on" + type, listener.func); // legacy IE
                    } else {
                        scope.ctx.addEventListener(type, listener.func, false);
                    }
                    node.log.verbose("Added event listener: '", type, "': ", scope);
                    listener.added = listening = true;
                } catch (e) {
                    // SecurityError
                    node.log.err("Cannot add event listener: ", scope, " -> '", type, "': ", e);
                    // Fall-though!
                }
            }
        }
        function remove(type, listener) {
            if (listener.added) {
                try {
                    if (scope.legacy()) {
                        scope.ctx.detachEvent("on" + type, listener.func); // legacy IE
                    } else {
                        scope.ctx.removeEventListener(type, listener.func);
                    }
                    node.log.verbose("Removed event listener: '", type, "': ", scope);
                } catch (e) {
                    // e.g. a SecurityError if ctx is a remote (proxy) window...
                    node.log.err("Cannot remove event listener: ", scope, " -> '", type, "': ", e);
                    // Fall-though!
                }
            }
        }

        this.type = function () {
            if (scope.ctx) {
                if (cachedType) {
                    return cachedType;
                }

                // Support "type()" for custom postables...
                var type = scope.val("type"),
                    regex,
                    i,
                    s,

                // "Object" is for cross domain windows (proxies) in Firefox - only works because we use a known sub-set of
                // context types *and* because we support "type()" on them...
                types = ["MessagePort", "global", "Worker", "Window", "Object"],
                    // order and casing important!
                keys = ["port", "global", "worker", "window", "window"];

                if (type) {
                    return cachedType = type;
                }

                cachedType = "unknown";

                try {
                    s = scope.ctx.toString();
                } catch (e) {// SecurityError
                    // Fall-through...
                }

                for (i = 0; i < types.length; i++) {
                    type = types[i];

                    // Non-worker environment, e.g. a Window...
                    if (node.env !== "worker") {
                        // The type may not exist at global scope at all, or if for example a parent window on a different domain,
                        // i.e. not a Window type at all, but some internal browser security proxy object...
                        if (is(scope.ctx, type, node.global.ctx)) {
                            return cachedType = keys[i];
                        }
                        // Fall-through!
                    }

                    // Worker environment, or fall-through for unknown types...
                    if (s) {
                        regex = new RegExp("\\[object [^\\[]*" + type + "[^\\]]*\\]", "i"); // e.g. workers: Chrome: [object global], IE: [object WorkerGlobalScope], Firefox: [object DedicatedWorkerGlobalScope]
                        if (regex.test(s)) {
                            return cachedType = keys[i];
                        }
                    }
                }
                return cachedType; // "unknown"
            }
            return "none";
        };

        this.val = function (path, defaultValue) {
            return Context.val(scope.ctx, path, defaultValue);
        };

        this.set = function () {
            return scope.type() !== "none";
        };

        this.is = function (context) {
            // also handles undefined/null, and supports legacy IE (== instead of ===)...
            return scope.ctx == (context instanceof Context ? context.ctx : context);
        };

        // No need to update if same context, but it can be undefined...
        this.handle = function (context) {
            context = context instanceof Context ? context.ctx : context; // unwrap

            if (!scope.is(context)) {
                // Remove old listeners from old context, if any...
                scope.close();

                // Set new one...
                if (scope.ctx = context) {
                    // Apply already registered listeners, if any...
                    visit(add);
                }
                return true;
            }
            return false;
        };

        this.on = function (type, func) {
            var entry = listeners[type],
                listener;
            if (!entry) {
                listeners[type] = entry = [];
            }
            listener = { func: func, added: false };
            entry.push(listener); // no check for duplicates

            if (scope.ctx) {
                add(type, listener);
            }
            return scope;
        };

        this.off = function (type, func) {
            if (arguments.length) {
                var entry = listeners[type],
                    listener,
                    i;
                if (entry) {
                    i = entry.length;
                    while (i--) {
                        listener = entry[i];
                        if (listener.func === func) {
                            // can be added numerous times
                            entry.splice(i, 1);
                            if (scope.ctx) {
                                remove(type, listener);
                            }
                        }
                    }
                    if (!entry.length) {
                        delete listeners[type];
                    }
                }

                // Remove all, but not not close...
            } else {
                visit(remove);
                listening = false;
                listeners = {};
            }
            return scope;
        };

        this.close = function () {
            if (listening) {
                visit(remove);
            }
            // Never delete listeners added when no actual context is set, since they are likely to be used, e.g.
            // when this function is called from "close"...
            if (scope.ctx) {
                listeners = {};
            }
            listening = false;
            legacy = null;
            cachedType = null;
            scope.ctx = void 0; // undefined
        };

        this.toString = function () {
            var s = "Context[type: " + scope.type(),
                ss,
                type,
                first = true;
            if (scope.legacy()) {
                s += "; legacy";
            }
            if (scope.ctx) {
                s += "; ctx: " + scope.val(null, "[???]");
                // "name" attribute?...
                ss = scope.val("name"); // no (null) default
                if (ss) {
                    s += "; name: " + ss;
                }
                // "location.pathname" attribute?
                ss = scope.val("location.pathname"); // no (null) default
                if (ss) {
                    s += "; location: '" + (ss.split(/\\|\//).pop() || "/") + "'";
                }
            }
            // Listeners...
            for (type in listeners) {
                if (listeners.hasOwnProperty(type)) {
                    if (first) {
                        first = false;
                        s += "; listeners: [";
                    } else {
                        s += ", ";
                    }
                    s += type;
                }
            }
            if (!first) {
                s += "]";
            }
            return s + "]";
        };

        // Initialise...
        scope.handle(context);
    }

    Context.val = function (ctx, path, defaultValue) {
        var parts = path ? path.split(".") : [],
            i = 0,
            value = ctx;
        try {
            while (value != null && i < parts.length) {
                // != intentional!
                value = value[parts[i++]];
            }
            if (fn(value)) {
                value = value(); // can raise SecurityError
            }
            if (value != null) {
                // != intentional!
                value = value.toString(); // can raise SecurityError
            }
        } catch (e) {// SecurityError, ReferenceError, etc
            // Fall-through!
        }
        return str(value) ? value : defaultValue;
    };

    //
    // STORE
    //

    // A simple store to keep track of created objects, e.g. nodes or networks, which is quite useful
    // for single page web applications, as well as support exposing such objects to some global
    // scoped context...
    function Store(type, ctx) {
        var scope = this,
            entries = {},
            size = 0;

        this.get = function (name) {
            return entries[name];
        };

        this.set = function (name, object) {
            var entry;
            if (name && object) {
                if (!entries[name]) {
                    size++;
                }
                entries[name] = entry = { object: object, log: fn(object.log) ? object.log : function () {
                        return this;
                    } };
            }
            return entry;
        };

        this.eksport = function (name, eksport) {
            // "export" reserved keyword
            // Export stored object to some scope for easy reference?
            var entry = entries[name],
                exported;
            if (entry) {
                // Remove old always...
                if (entry.eksport) {
                    delete entry.eksport[name];
                    delete entry.eksport;
                }
                // Add new?
                if (eksport) {
                    entry.eksport = path(ctx || self, eksport);
                    exported = "'" + (str(eksport) ? eksport + "." : "") + name + "'";
                    if (entry.eksport[name]) {
                        entry.log("Warning: object export is overriding existing property: ", exported, ": ", entry.eksport);
                    }
                    entry.eksport[name] = entry.object;
                    return exported;
                }
            }
            return null;
        };

        this.add = function (name, object, eksport) {
            var entry = entries[name];
            if (entry) {
                entry.log("Warning: overriding already created ", type, " for same global context: ", entry.object, " -> ", scope);
                if (fn(entry.object.close)) {
                    entry.object.close(); // clean-up!
                }
            }
            entry = scope.set(name, object);

            var exported = scope.eksport(name, eksport);
            if (exported) {
                entry.log("Created and exported ", type, ": ", exported, " -> ", entry.object);
            } else {
                entry.log("Created ", type, ": ", entry.object);
            }
        };

        this.remove = function (name) {
            if (entries[name]) {
                scope.eksport(name, false);
                delete entries[name];
                size--;
            }
        };

        this.toString = function () {
            return "Scope[type: " + type + "; size: " + size + "]";
        };
    }

    //
    // ORIGINS
    //


    var FILE = "file://",
        LOCATION;

    // An origins map to test for allowed/disallowed node origins.
    function Origins(node, options) {

        // Creates data structure for allowed/disallowed origins for "node"...
        function createMap(tests) {
            var map = { any: false, direct: {}, regex: [], func: [] },
                test,
                i;
            if (tests) {
                if (!itr(tests)) {
                    tests = [tests];
                }
                for (i = 0; i < tests.length; i++) {
                    test = tests[i];
                    if (test) {
                        if (test instanceof RegExp) {
                            map.regex.push(test);
                        } else if (fn(test)) {
                            map.func.push(test);

                            // A direct origin test will ever only succeed if it includes a protocol, domain, and port,
                            // or file://, so we have to handle these cases explicitly...
                        } else if (str(test)) {
                            if (/^http:|^https:/i.test(test)) {
                                map.direct[Origins.origin(test)] = 1;
                                map.any = true;
                            } else if (/^file:/i.test(test)) {
                                map.direct[FILE] = 1;
                                map.any = true;
                            } else if (/^\/\//.test(test)) {
                                map.direct[Origins.origin("http:" + test)] = 1;
                                map.direct[Origins.origin("https:" + test)] = 1;
                                map.any = true;

                                // Must be a regular expression then, since it will never ever generate a match directly...
                            } else {
                                // Ignore potential origin prefixes, such as for example www to handle redirects
                                // from www.foo.bar -> foo.bar...
                                var j,
                                    prefix,
                                    match = true;
                                while (match) {
                                    match = false;
                                    for (j = 0; j < o.ignoreOriginPrefix.length; j++) {
                                        prefix = o.ignoreOriginPrefix[j] + ".";
                                        if (idx(test, prefix) === 0) {
                                            test = test.substring(prefix.length);
                                            match = true;
                                            break; // for loop to outer, since we must re-test all again...
                                        }
                                    }
                                }

                                // Escape meta characters in the url to match (found this online somewhere, cannot remember where)...
                                test = test.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
                                // Common use-case: if the supplied value ends with an assumed domain of two or three letters, match
                                // at the end so we only allow suffixes. This will not catch domains life ".info" or what not, but
                                // then use a regular expression instead...
                                match = /\.[a-zA-Z]{2,3}(:\d+)?$/.exec(test); // :\d+ -> optional port
                                if (match) {
                                    // If no port, we have to add include an expression to match against ports, since we know we
                                    // will always be served a proper origin once we test the origins at runtime...
                                    if (!match[1]) {
                                        test += ":\\d+";
                                    }
                                    test += "$";
                                }
                                map.regex.push(new RegExp(test, "i"));
                            }

                            // This is an error, since origins are all about security...
                        } else {
                            node.err("Illegal type used for origin test: '", typeof test === "undefined" ? "undefined" : _typeof(test), "': ", test);
                        }
                    }
                }
            }
            map.any = map.any || map.regex.length || map.func.length;
            return map;
        }

        // Convenient short-cuts...
        if (itr(options.origins)) {
            options.origins = { allowed: options.origins }; // plus own origin!
        } else if (str(options.origins) || options.origins instanceof RegExp) {
            options.origins = { allowed: [options.origins] }; // ditto
        }

        var scope = this,
            o = options.origins || { addOwnOrigin: false };

        // Prefixes to ignore for origins to gracefully handle browser redirects like www.foo.bar -> foo.bar...
        if (str(o.ignoreOriginPrefix)) {
            o.ignoreOriginPrefix = [o.ignoreOriginPrefix];
        }
        if (!o.ignoreOriginPrefix) {
            o.ignoreOriginPrefix = ["www"];
        }
        var origins = {
            allowed: createMap(o.allowed),
            disallowed: createMap(o.disallowed),
            parent: o.parent, // for connecting to parent only!
            origin: def("location", node.global.ctx) ? Origins.origin(node.global.ctx.location) : "", // this node
            secure: false,
            callback: null
        };

        // Special callback, since user may themselves choose what to do when ever
        // "scope.allowed(context, originOrEvent)" returns false...
        if (fn(o.callback)) {
            origins.callback = o.callback;
        } else {
            var type = str(o.callback) ? o.callback : "verbose",
                illegalOrigins = {};
            origins.callback = function (origin, event, node) {
                // Only log one time per origin to avoid flooding the log unless "verbose"...
                var count = illegalOrigins[origin];
                if (count) {
                    illegalOrigins[origin] = count + 1;
                    if (type != "verbose") {
                        return;
                    }
                }
                illegalOrigins[origin] = 1;
                var args = ["Origin not allowed: '", origin, "': ", node, event];
                switch (type) {
                    case "log":
                        node.log(args);break;
                    case "err":
                        node.log.err(args);break;
                    default:
                        node.log.verbose(args);break;
                }
            };
        }

        function file() {
            return Origins.file(origins.origin);
        }

        origins.secure = /^https:/i.test(origins.origin);

        // Prefix protocol agnostic parent urls with current non-file protocol - required by browsers,
        // i.e. will not simply accept //. Also, the parent origin can be any uri, but only the origin
        // is used by browsers to determine where the message should go...
        if (origins.parent !== "*") {
            // Default to same origin as parent by default, so we do not use wildcard, i.e. "*",
            // by default, only if so configured...
            if (!origins.parent) {
                origins.parent = origins.origin;
            } else {
                // Prefix protocol if not already - we assume the same protocol as this node since we
                // cannot know anything for sure...
                if (/^\/\//.test(origins.parent)) {
                    origins.parent = origins.secure ? "https:" : "http:";
                }
                origins.parent = Origins.origin(origins.parent);
            }
        }

        this.parent = function (actual) {
            if (actual && origins.parent === "*") {
                return node.parentHandler.targetOrigin(); // may still be "*"!
            }
            return origins.parent;
        };
        this.origin = function () {
            return origins.origin;
        };
        this.secure = function () {
            return origins.secure;
        };
        this.file = file;

        // Our own origin is allowed by default if origins have been configured unless it has been configured
        // otherwise, i.e. allow all *or* if a specific origin checker has been configured that will handle
        // own origins...
        if (typeof o.addOwnOrigin === "undefined" && origins.allowed.any || o.addOwnOrigin) {
            origins.allowed.direct[file() ? FILE : origins.origin] = 1; // "origin" never null and already normalised if not FILE protocol!
            origins.allowed.any = true;
        }

        function allowed(context, origin) {
            // protocol + domain + port, "file://", "null", or empty

            function checkOrigin(map) {
                // Direct match?
                if (map.direct[origin]) {
                    return true;
                }
                // Regular expression match?
                var i;
                for (i = 0; i < map.regex.length; i++) {
                    if (map.regex[i].test(origin)) {
                        return true;
                    }
                }
                // Function match?
                for (i = 0; i < map.func.length; i++) {
                    try {
                        if (map.func[i](origin, context, node)) {
                            return true;
                        }
                    } catch (e) {
                        node.log.err("Origin test function no. ", i, " failed: '", origin, "': ", e);
                        // Fall-through!
                    }
                }
                return false;
            }

            var type = context && context.type() || "none";

            // Fall-safe...
            if (type === "none") {
                return false;

                // CAVEAT: the origin will only be supplied for type "window" (and "unknown"), but not for others,
                // e.g. "port". So, when using channels, the origin is not supplied as part of the event. This
                // raises a serious security issue: a "file://" node can insert itself as root of any node in the
                // tree, most importantly for the existing root (the other nodes may already have connected), and
                // thus gain access to the node tree. The existing root can declare it self to be a root node when
                // created, thus not allowing this, but the same cannot be done for other nodes in the tree
                // structure. The *only* way to prevent this is that each node in the tree declares the initial
                // parent origin *and* declares which origins it will accept messages from (as should be done
                // always!)!
            } else if (!origin) {
                return type !== "window";

                // The origin will be the string "null" for the "file://" protocol, i.e. running locally. Note that
                // the message may in theory come from a "file://" origin, while this node may be running on http,
                // for example. If both nodes are local ("file://"), we allow it, otherwise a "file://" origin must
                // be configured to be allowed/disallowed as any other domain...
            } else if (origin === "null") {
                origin = FILE; // to allow it to be matched below on fall-through...
                if (file()) {
                    return true;
                }
                // Fall-through!
            }
            // Must be specifically allowed *and* not disallowed if "origins.allowed.any" is true, otherwise just
            // not disallowed...
            return (!origins.allowed.any || checkOrigin(origins.allowed)) && !checkOrigin(origins.disallowed);
        }

        this.allowed = function (context, originOrEvent) {
            var origin, event;

            // Origin supplied as a string?
            if (str(originOrEvent)) {
                origin = originOrEvent;event = { origin: originOrEvent };

                // Event supplied, so fetch the origin from it. We enforce the origin as a string to we won't get
                // any surprises later on...
            } else {
                origin = (originOrEvent.origin || "").toString();event = originOrEvent;
            }

            // Test *normalised* origin then, since some browsers will ignore default prot and what not...
            if (allowed(context, origin = Origins.origin(origin))) {
                return true;
            }

            // Also allow BETA origin
            if (Origins.origin(origin) === "https://beta.zmags.com:443") {
                return true;
            }

            // Notify callback, if any, of not allowed origin...
            if (origins.callback) {
                try {
                    origins.callback(origin, event, node);
                } catch (e) {
                    node.log.err("Not-allowed origin callback failed: ", e);
                }
            }
            return false;
        };

        // To expose this Origins object safely, so it cannot be tampered with...
        this.proxy = function () {
            return {
                origin: scope.origin,
                parent: scope.parent,
                secure: scope.secure,
                file: scope.file,
                allowed: scope.allowed,
                toString: scope.toString
            };
        };

        this.toString = function () {
            var s = "Origins[origin: '" + origins.origin + "'; parent: '" + origins.parent + "'; secure: " + origins.secure;
            function format(map) {
                var any = false,
                    origin;
                s += "[";
                // Direct...
                for (origin in map.direct) {
                    if (map.direct.hasOwnProperty(origin)) {
                        if (any) {
                            s += ", ";
                        } else {
                            any = true;
                            s += "direct: [";
                        }
                        s += "'" + origin + "'";
                    }
                }
                if (any) {
                    s += "]";
                }
                // Regexes...
                if (map.regex.length) {
                    if (any) {
                        s += "; ";
                    }
                    s += "regex: [" + join(map.regex, ", ") + "]";
                    any = true;
                }
                if (map.func.length) {
                    if (any) {
                        s += "; ";
                    }
                    s += "functions: " + map.func.length;
                }
                s += "]";
            }
            if (origins.allowed.any) {
                s += "; allowed: ";
                format(origins.allowed);
            }
            if (origins.disallowed.any) {
                s += "; disallowed: ";
                format(origins.disallowed);
            }
            return s + "]";
        };
    }

    Origins.file = function (origin) {
        return (/^file:/i.test(origin) || origin === "null"
        );
    }; // "null" string = Firefox
    Origins.defaultPort = function (url) {
        return Origins.file(url) ? null : /^http:/i.test(url) ? 80 : 443;
    };

    // Always returns url as-is in Workers!
    Origins.location = function (url) {
        if (url && def("document") && fn(document.createElement)) {
            if (!LOCATION) {
                LOCATION = document.createElement('a');
            }
            LOCATION.href = url;
            var location = {
                protocol: LOCATION.protocol,
                host: LOCATION.host,
                hostname: LOCATION.hostname,
                href: LOCATION.href,
                port: LOCATION.port,
                origin: LOCATION.origin || LOCATION.protocol + "//" + LOCATION.host, // IE, host = domain + port
                pathname: LOCATION.pathname,
                hash: LOCATION.hash,
                search: LOCATION.search
            },
                port = location.port,
                i;

            // Port may be be missing if default, or never present for FILE protocol...
            if (!Origins.file(location.origin) && !port) {
                // zero is reserved!
                i = location.origin.length;
                location.port = port = Origins.defaultPort(location.protocol);
                location.host += ":" + port;
                location.origin += ":" + port;
                location.href = location.origin + location.href.substring(i);
            }
            return location;
        }
        return url;
    };

    // Generate a origin that always includes protocol, and domain and port for
    // all but file://. Some browsers will ignore default port, i.e. 80 for http,
    // while others will not, and we need a common format to handle origins
    // uniformly. This is also used for locations/origins of remote nodes, so
    // we might not have access, hence the use of Context.val(..) to look up
    // individual parts...
    Origins.origin = function (location) {
        // string, Location, or Object (that mimics Location, see Origins.location)
        // Location may be empty here, since message events from message ports
        // will never supply any origin...
        if (location) {
            if (str(location)) {
                location = Origins.location(location);
            }

            // Firefox also uses "null" here in general (string) for origin, not only in message events...
            if (Origins.file(Context.val(location, "origin"))) {
                return FILE;
            }

            // "protocol" property may not be available in workers...
            var protocol = Context.val(location, "protocol"),
                port,
                origin;
            if (protocol) {
                // Will be null for FILE...
                port = Origins.defaultPort(protocol);
                if (port) {
                    // Same issue here: "port" may not be supplied if default...
                    return protocol + "//" + Context.val(location, "hostname") + ":" + (Context.val(location, "port") || port);
                }
                return FILE;
            }

            // Raw location, i.e. workers...
            origin = Context.val(location); // FIXME: test ports and all!
            if (origin) {
                if (Origins.file(origin)) {
                    return FILE;
                }
                origin = origin.split(/[^\/\\]\/|[^\\\/]\\/)[0];
            }
        }
        return "";
    };

    //
    // MESSAGE
    //


    // A message describes the messages posted between nodes, including type "safety". Actual message functionality
    // like formatting and parsing is delegated to the MessageFactory used. Also, to keep the Message type simple,
    // we use static methods for Method related functionality, e.g. Message.Selectors.add(message, selectors) instead
    // of message.addSelectors(selectors)...
    function Message(tag, origin, id, correlationId, sender, receiver, selectors, action, data, context, event) {
        /** {@type string} */
        this.tag = tag; // typically different ones per network if more than one network
        /** {@type string} */
        this.origin = origin; // node name, not an url origin
        /** {@type string} */
        this.id = id;
        /** {@type string} */
        this.correlationId = correlationId;
        /** {@type string} */
        this.sender = sender;
        /** {@type string} */
        this.receiver = receiver;
        /** {@type string} */
        this.selectors = selectors; // e.g. "*", "?", or "?*"
        /** {@type string} */
        this.action = action;
        /** {@type string|object} */
        this.data = data;
        /** {@type Context} */
        this.context = context; // "context" will be null for local dispatch
        /** {@type MessageEvent} */
        this.event = event || {}; // "event" will be null for local dispatch
    }

    var Actions = { // publicly exposed via a *copy* on Message.Actions, since "protocol(..)" expects these actions only
        CHILD: "child", // message.data: key + "json"|"string" (supported message transport), e.g. "12345;json"
        ACK: "ack", // message.data: encoded string as 'qualified-parent' + message factory separator + 'child origin' + key, e.g. "foo.bar.boo;http://www.goo.com;12345"
        CHILDACK: "childAck", // message.data: encoded string as 'qualified-parent' + message factory separator + 'child origin' + key, e.g. "foo.bar.boo;http://www.goo.com;12345"
        ORIGIN: "origin", // message.data: node origin
        JOIN: "join", // message.data: node origin, e.g. "http://www.goo.com". Message origin is the node that has joined.
        LEAVE: "leave", // message.data: "self"|"global"|"force"
        CLOSE: "close", // message.data: "self"|"global"|"force"
        COMPOSITE: "composite", // message.data: Message[], all assumed with same receivers!
        DUMP: "dump", // message.data: falsey
        NODES: "nodes", // message.data: string[] (node names)
        MESSAGE: "message", // message.data: user (or protocol) defined
        ANY: "any", // message.data: user (or protocol) defined
        ERROR: "error", // message.data: exception message

        protocol: function protocol(actionOrMessage) {
            var action = Actions[((str(actionOrMessage) ? actionOrMessage : actionOrMessage.action) || Actions.MESSAGE).toUpperCase()];
            return str(action) ? action : null;
        }
    };

    var Selectors = { // publicly exposed as Message.Selectors
        ROOT: "@", // invoke action on any node in path starting from root
        ALL: "*", // invoke action on any node in current path
        LIKE: "~", // invoke action on any node in path with a matching name
        FIRST: "+", // invoke action on any node in path until message is consumed, if ever
        REPLY: "?", // invoke action on any node in path, if available, with reply (from root if no match)
        QUEUE: "^", // enqueue always, even with indirect receivers
        NO_QUEUE: "!", // no enqueueing what so ever, takes precedence over QUEUE

        add: function add(message, selectors) {
            if (selectors) {
                if (!message.selectors) {
                    message.selectors = "";
                }
                selectors = itr(selectors) ? selectors : selectors.split(); // "string explode"
                var i;
                for (i = 0; i < selectors.length; i++) {
                    if (idx(message.selectors, selectors[i]) === -1) {
                        message.selectors += selectors[i];
                    }
                }
            }
            return message;
        },
        remove: function remove(message, selectors) {
            if (selectors && message.selectors) {
                selectors = itr(selectors) ? selectors : selectors.split(); // "string explode"
                var i, j, selector;
                for (i = 0; i < selectors.length; i++) {
                    selector = selectors[i];
                    j = idx(message.selectors, selector);
                    if (j !== -1) {
                        if (selector !== Selectors.LIKE) {
                            message.selectors = message.selectors.substring(0, j) + message.selectors.substring(j + selector.length);
                        } else {
                            message.selectors = message.selectors.substring(0, j); // for now, LIKE only allowed as last argument
                        }
                    }
                }
            }
            return message;
        },
        has: function has(message, selectors) {
            // returns first matching
            if (message.selectors) {
                selectors = itr(selectors) ? selectors : selectors.split(); // "string explode"
                var i, j, selector;
                for (i = 0; i < selectors.length; i++) {
                    selector = selectors[i];
                    j = idx(message.selectors, selector);
                    if (j !== -1) {
                        if (selector !== Selectors.LIKE) {
                            return selector;
                        }
                        // Return argument for LIKE, i.e. regex to match against node names. For now, LIKE can only be
                        // the last selector, e.g. "?~foo" correct, while "~foo?" is not...
                        return message.selectors.substring(j + 1);
                    }
                }
            }
            return null;
        }
    };

    var Receivers = { // publicly exposed as a *copy* as Message.Receivers
        ROOT: "root",
        PARENT: "parent",
        CHILDREN: "children",
        LEAFS: "leafs",
        SIBLINGS: "siblings",
        ALL: "all",

        indirect: function indirect(receiverOrMessage) {
            var receiver = Receivers[(str(receiverOrMessage) ? receiverOrMessage : receiverOrMessage.receiver).toUpperCase()];
            return str(receiver) ? receiver : null;
        },
        name: function name(receiverOrMessage) {
            if (receiverOrMessage) {
                var receiver = str(receiverOrMessage) ? receiverOrMessage : receiverOrMessage.receiver,
                    indirect = Receivers.indirect(receiver);
                return indirect ? indirect : "#" + receiver;
            }
            return null;
        }
    };

    //
    // MESSAGE FACTORY
    //


    // Delegate message factory to handle message creation, handlability, formatting, and parsing
    function MessageFactory(node, factory) {
        if (!factory) {
            factory = {};
        }

        var limit = factory.prettyLimit || 100,
            sequence = 0,
            scope = this;

        this.delimiter = factory.delimiter || ":";

        // Supported tags, will automatically also include tags used by networks created...
        var tags = {};

        function handle(o, on) {
            if (typeof o.tag !== "undefined") {
                var objects = tags[o.tag],
                    i;
                if (objects) {
                    i = idx(objects, o);
                    if (i === -1) {
                        if (on) {
                            objects.push(o);
                        }
                    } else if (!on) {
                        objects.splice(i, 1);
                        if (!objects.length) {
                            delete tags[o.tag];
                        }
                    }
                } else if (on) {
                    tags[o.tag] = [o];
                }
            }
            return o;
        }

        // Add node.tag by default...
        handle(node, true);

        function encode() {
            var i,
                encoded = [],
                args = itr(arguments[0]) ? arguments[0] : arguments;
            for (i = 0; i < args.length - 1; i++) {
                encoded.push(escape(args[i], scope.delimiter));
            }
            // No need to escape data in the last part...
            encoded.push(args[i]);
            return join(encoded, scope.delimiter);
        }

        function decode(s) {
            // "very poor man's json", all string values... :)
            var limit = arguments.length - 1,
                parts = unescape(s, scope.delimiter, limit);
            if (limit === 0) {
                return parts; // array as-is
            }
            var o = {},
                i;
            for (i = 0; i < limit; i++) {
                o[arguments[i + 1]] = parts[i];
            }
            return o;
        }

        function closure(configured, standard) {
            return configured ? function () {
                return configured.apply(scope, forward(node, arguments, node));
            } : standard;
        }

        function create(message, context, event) {
            var data,
                create = true;

            // Delegate to factory if specified, which may or may not return a Message instance...
            if (factory.create) {
                message = factory.create.call(scope, message, context, event, node);
                create = !(message instanceof Message);
            }

            // If a string, it can either be encoded where no json is supported, or stringified json...
            if (str(message)) {
                // json...
                if (scope.json.formatted(message)) {
                    message = scope.json.parse(message);

                    // encoded...
                } else {
                    create = false;
                    // Limit split to 9 meaning that we never have to escape the delimiter in the actual payload data when
                    // encoding messages...
                    var m = unescape(message, scope.delimiter, 9);
                    // If we do not have the 9 parts here, the message is in a different format than we expect...
                    if (m.length === 9) {
                        message = new Message(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], scope.json.parse(m[8]), context, event);
                    } else {
                        message = null;
                    }
                    // Fall-through...
                }
            }

            // Supplied object like {tag: .., origin: .., ..}, or even a Message, or if "message" has just been parsed from
            // a string representation into a json object, including if from the delegate factory used. "message" may be null
            // or undefined here, for example if the parsing failed above...
            if (create && message) {
                // Special case: allow data to be a function to supply the actual data, only works on posting or the factory
                // used returns such a function for "message.data"...
                if (fn(data = message.data)) {
                    data = data();
                }
                message = new Message(message.tag, message.origin, message.id, message.correlationId, message.sender, message.receiver, message.selectors, message.action, data, context || message.context, event || message.event);
            }

            // Add pretty toString and equals method...
            if (message) {
                message.toString = function () {
                    return scope.pretty(message);
                };
                message.equals = function (m) {
                    return scope.identifier(message) === scope.identifier(m);
                };
            }
            return message;
        }

        function id() {
            return ++sequence;
        }

        function identifier(message) {
            return message.tag + scope.delimiter + message.origin + scope.delimiter + message.id;
        }

        function format(message, transport) {
            // Just pass the string message through, regardless if legacy or not and "transport", since we then
            // simply do the parsing at the receiver side instead...
            if (str(message)) {
                return message;
            }

            if (transport !== "json") {
                // Format actual payload data. If json is not supported at all, e.g. truly legacy, the string representation
                // of "message.data" is simply used...
                return encode([message.tag, message.origin, message.id, message.correlationId, message.sender, message.receiver, message.selectors, message.action, scope.json.format(message.data || "")]);
            }
            // Format entire message as json *except* associated context and event. For composite messages, we assume they will not
            // have associated contexts/events...
            var context = message.context,
                event = message.event;message.context = undefined;message.event = undefined;
            try {
                return scope.json.format(message); // {tag: m[0], origin: m[1], id: m[2], correlationId: m[3], sender: m[4], receiver: m[5], selectors: m[6], action: m[7], data: m[8]};
            } finally {
                message.context = context;
                message.event = event;
            }
        }

        // The "message.sender" will always be set on "post(..)", so we do not have to validate that here...
        function validate(message) {
            function test(attribute) {
                var value = message[attribute];
                if (typeof value === "undefined" || str(value) && !value) {
                    node.err("Missing ", attribute, ": ", message);
                }
                return test;
            }
            test("origin")("tag")("receiver")("id");

            // Default action...
            if (!message.action) {
                message.action = Actions.MESSAGE;
            }
            return factory.validate ? factory.validate.call(scope, message, node) : message;
        }

        function handleable(message) {
            var tag,
                match = false;
            for (tag in tags) {
                if (tags.hasOwnProperty(tag)) {
                    if (message.tag === tag) {
                        match = true;
                        break;
                    }
                }
            }
            if (match) {
                return factory.handleable ? factory.handleable.call(scope, message, node) : true;
            }
            return false;
        }

        function pretty(message) {
            var s = message.tag + ":(" + message.origin + ":" + message.id + " -> ",
                data,
                length;
            if (message.sender && message.origin !== message.sender) {
                s += message.sender + " -> ";
            }
            if (message.selectors) {
                s += message.selectors + ":";
            }
            s += message.receiver;
            if (message.correlationId) {
                s += ":" + message.correlationId;
            }
            s += ") => {{'" + (message.action || Actions.MESSAGE);
            data = message.data;
            if (data) {
                data = scope.json.format(data);
                length = data.length;
                if (length > limit) {
                    data = data.substring(0, limit) + "..(+" + (length - limit) + " chars)";
                }
                s += "' = '" + data + "'";
            } else {
                s += "'";
            }
            return s + "}}";
        }

        // Override with supplied methods, if any, or use defaults...
        this.create = create;
        this.validate = validate;
        this.handle = handle;
        this.handleable = handleable;
        this.id = closure(factory.id, id);
        this.identifier = closure(factory.identifier, identifier);
        this.format = closure(factory.format, format);
        this.pretty = closure(factory.pretty, pretty);

        this.json = new Json(factory.json); // expose for use by configured factories...
        this.encode = encode;
        this.decode = decode;

        this.toString = function () {
            var s = "MessageFactory[tags: [",
                tag,
                first = true;
            for (tag in tags) {
                if (tags.hasOwnProperty(tag)) {
                    if (first) {
                        first = false;
                    } else {
                        s += ", ";
                    }
                    s += tag;
                }
            }
            return s + "]; json: " + scope.json + "; delimiter: '" + scope.delimiter + "'; limit: " + limit + "]";
        };
    }

    //
    // MESSAGE DISPATCHER
    //


    // Dispatches messages: routing/posting/enqueuing
    function MessageDispatcher(node, queue, validateOnSend, noResult, actions) {

        // Per recursive "post", "received", or "dequeued" dispatching: dispatched messages are added
        // to "dispatched" on "dispatch(message, ..)" start and "count" is increased. "count" is
        // decreased on "dispatch(message, ..)" end, and if zero, ANY callback will be invoked
        // in the order dictated by "dispatched"...
        var dispatched = [],
            count = 0,
            scope = this; // TODO: consider using MessageQueue to also support async

        this.err = function (args, action) {
            var msg = node.log.err.apply(node.log.err, args) || node.log.format(node.log.format, args),
                // latter if "err" logging is turned off
            entry = dispatched[count - 1] || {},
                message = msg.message || entry.message,
                steps = (entry.steps || newSteps(message))("error"),
                error = msg.error || new Error(msg.text || join(args)),
                f = action && callback(message, action + "." + Actions.ERROR) || callback(message, Actions.ERROR);

            if (f) {
                f(message, steps, error, msg.event);
            }
            throw error;
        };

        // Returns a function to perform a MessageNode scoped callback for the supplied (nested) action.
        function callback(message, action) {
            action = action || message && message.action || Actions.MESSAGE;
            var i,
                j,
                entry,
                target,
                parts = action.split("."),
                part,
                error = false,
                functions = [];
            // Each entry in "actions": {on: callbacks, scope: invocation scope}...
            for (i = 0; i < actions.length; i++) {
                var push = function push(name) {
                    var f = target[name]; // only called when "target" is known to be an object!
                    if (fn(f)) {
                        functions.push({ f: f, scope: entry.scope });
                        return true;
                    }
                    return false;
                };

                // Check if specialised callback according to *origin*, not *sender* since the
                // message can very well be relayed through intermediate nodes. We also support
                // the special cases like "parent", "root", or "children" or "descendant",
                // combined...


                entry = actions[i];
                // Check if there is a flag switch to test if this action is currently active or not...
                if (fn(entry.flag) && !entry.flag.apply(entry.scope, message, node)) {
                    continue;
                }
                target = entry.on;
                j = 0;
                while (target && j < parts.length) {
                    part = parts[j++];
                    target = target[part];
                    if (part === Actions.ERROR) {
                        error = true;
                    }
                }

                if (message && obj(target)) {
                    // Takes precedence: do not invoke callbacks like "parent" if we have a callback
                    // for a specific node...
                    if (!push(message.origin)) {
                        if (node.parents) {
                            // Add root specific callback?
                            if (message.origin === node.root()) {
                                push(Receivers.ROOT);
                            }
                            // Add parent specific callback?
                            if (message.origin === node.parent()) {
                                push(Receivers.PARENT);
                            }
                            // Add ancestor specific callback?
                            if (node.ancestor(message.origin)) {
                                push("ancestors");
                            }
                        }
                        if (node.children) {
                            var childHandler = node.children[message.origin];
                            if (childHandler) {
                                // Add direct child specific callback?
                                if (childHandler.is(message.origin)) {
                                    push(Receivers.CHILDREN);
                                }
                                // Add descendant specific callback?
                                push("descendants");
                            }
                        }
                    }
                } else if (fn(target)) {
                    functions.push({ f: target, scope: entry.scope });
                }
            }

            return functions.length === 0 ? null : function invoker(message, steps) {
                // named function for better stack trace
                // args: (message, ?), e.g. error
                var i,
                    args = forward(node, arguments),
                    entry,
                    result;
                for (i = 0; i < functions.length; i++) {
                    entry = functions[i];
                    // Stop processing if a function returns a defined value, but ensure that a failing
                    // callback does not prevent others from being invoked...
                    try {
                        result = entry.f.apply(entry.scope, args); // (message, steps, ?)
                        if (typeof result !== "undefined") {
                            // also handles MessageNode.NO_RESULT!
                            break;
                        }
                    } catch (e) {
                        // Suppress errors if already notified via an error handler...
                        if (error) {
                            node.log.err("Error invocation failed: ", e);
                        } else {
                            throw e;
                        }
                    }
                }
                return result;
            };
        }

        // DISPATCH - on receive, post, and dequeue!
        function dispatch(entry) {

            // Create routing meta data describing how "entry.message" should be processed/routed regardless if posted/received...
            var routing = entry.routing = createRouting(entry);

            // Do additional processed for received messages: for messages posted at this node, we will never invoke
            // any action, so we do not need to determine if such an action must be invoked here, but routing will (may)
            // still be required...
            if (routing.type === "received") {

                // Add receive specific routing: deduce how the message should be default be processed at this node, e.g. if
                // the receiver is this node, or if an indirect receiver like PARENT is received from a descendant node...
                addReceiveRouting(routing);

                // Invoke: invoke action on this node if so deduced by pre routing/selectors...
                if (routing.invoke) {
                    routing.processed = scope.invoke(routing.message, routing.steps);
                }

                // Post selectors: deduce if the routing must continue or stop and ensure that selectors like REPLY will
                // issue replies where relevant...
                if (routing.message.selectors && !routing.self && !routing.ignore && !routing.queue) {
                    applySelectors(routing);
                }

                // Add post/dequeue specific routing...
            } else {
                addPostRouting(routing);
            }

            // Post routing: do the actual routing, if any, of the message...
            doRouting(routing);
        }

        // CREATE ROUTING - on post, receive, and dequeue!
        function createRouting(entry) {

            function relation(name) {
                return name === node.name ? "self" : node.ancestor(name) ? "ancestor" : node.descendant(name) ? "descendant" : "related"; // sibling or cousin, or not yet registered as specific parent/child
            }

            // Receivers can be indirect, origins and senders never...
            var message = entry.message,
                steps = entry.steps,
                indirect = Receivers.indirect(message),
                stepType = steps.type(),
                fromRoot = Selectors.has(message, Selectors.ROOT),
                queue = Selectors.has(message, Selectors.QUEUE),
                noQueue = Selectors.has(message, Selectors.NO_QUEUE),
                sender = relation(message.sender),
                from = relation(message.origin),
                bubble;

            // Always set bubble flag to false for direct receivers, since that will force a lookup of children first.
            // If no such child can be found, the message may still bubble up to the parent, or be enqueued locally if
            // the node in question is a root...
            if (!indirect) {
                bubble = false;

                // Keep *initial* bubble state on received for indirect receivers...
            } else if (stepType === "received") {
                bubble = fromRoot || sender !== "ancestor";

                // Set *initial* bubble state on post/dequeue for indirect receivers...
            } else {
                bubble = fromRoot || message.receiver === Receivers.PARENT || message.receiver === Receivers.ROOT || message.receiver === Receivers.ALL || message.receiver === Receivers.SIBLINGS;
            }

            // NO_QUEUE takes precedence, to allow handshake actions and the likes to be posted still...
            if (noQueue && queue) {
                Selectors.remove(message, Selectors.QUEUE);
                queue = false;
            }

            // Determine (initial) routing information that may be updated for received messages in "preRouting"...
            return {
                message: message,
                steps: steps,
                node: node.type(), // root, node, leaf
                type: stepType, // post, received, dequeued
                indirect: indirect, // e.g. PARENT or undefined if direct
                bubble: bubble, // bubble bottom-up, or back top-down?
                self: node.name === message.origin, // message from this node?
                from: from, // where is the message sent from originally in "abstract terms", e.g. from "ancestor" or "descendant"?
                to: indirect || relation(message.receiver), // where is the message headed in "abstract terms" or specific receiver, e.g. to "parent" or "clientX"?
                sender: sender, // where did the routed message just come from in "abstract terms"?
                relay: from !== "self", // relay/routing message?
                invoke: false, // invoke action on this node?
                stop: queue, // forcefully stop routing altogether? May still stop if no more children, for example
                ignore: false, // not meant for this node at all (special case)? If true, "routing.stop" is also true.
                queue: queue // forcefully queued for now?
            };
        }

        // ADD POST ROUTING - on post/dequeue
        function addPostRouting(routing) {

            // Translate ROOT receiver into "self" when posting from root node...
            if (routing.node === "root") {
                if (routing.message.receiver === Receivers.ROOT) {
                    routing.to = "self";
                } else if (routing.message.receiver === Receivers.ALL) {
                    routing.bubble = false;
                }
                Selectors.remove(routing.message, Selectors.ROOT); // make sure we do not bubble back
            }

            // Cannot post a message to one self...
            routing.stop = routing.to === "self" || routing.queue;
        }

        // ADD RECEIVE ROUTING - on receive only
        function addReceiveRouting(routing) {

            // A direct receiver, e.g. "clientX", can both bubble or not: it will bubble if no such child is found at
            // a given node, and then be dispatched top-down from the root, or enqueued if unknown. The "bubble" flag
            // is thus initially set to false, to allow the actual routing to check the child nodes first, but the
            // message may actually bubble up if no matching child can be found at the current (non-root) node. It is
            // treated the same way regardless if received, posted, or dequeued...
            if (!routing.indirect) {
                // A special case is when multiple nodes uses the same (global/window) context, since messages posted
                // to said context will be duplicated/received as many times as there are siblings using said context.
                // Such messages has to be ignored and stopped, and no callbacks will be invoked for them...
                routing.ignore = routing.to === "related" && routing.sender === "ancestor";
                routing.stop = routing.to === "self" || routing.ignore || routing.queue;
                routing.invoke = routing.to === "self" && routing.from !== "self" && !routing.ignore && !routing.queue;
                return;
            }

            if (routing.queue) {
                return;
            }

            var bubble = routing.bubble,
                stop = !Selectors.has(routing.message, Selectors.ALL);

            // A LIKE selector can for example be used in conjunction with an ALL receiver to visit all nodes
            // sharing some common name prefix...
            var match = Selectors.has(routing.message, Selectors.LIKE);
            if (match) {
                match = new RegExp(match, "i").test(node.name);
            } else {
                match = true;
            }

            // Bottom-up...
            if (routing.bubble) {

                // Invoke: invoke on matching PARENTS, or ROOT only...
                if (routing.message.receiver === Receivers.PARENT) {
                    routing.invoke = match; // never from this node since bubbling
                    routing.stop = stop; // stop unless a selector for all parents is specified
                } else if (routing.message.receiver === Receivers.ROOT) {
                    routing.invoke = routing.stop = routing.node === "root";

                    // Bubble: cancel at parent for SIBLINGS, or when at root, and start traversing top-down...
                } else if (routing.message.receiver === Receivers.SIBLINGS) {
                    routing.bubble = false; // no "bubble = true" since no invoke on parent node for SIBLINGS
                } else if (routing.node === "root") {
                    routing.bubble = bubble = false;
                    Selectors.remove(routing.message, Selectors.ROOT); // make sure we do not bubble again
                }
            }

            // Top-down...
            if (!bubble) {

                // Invoke: invoke on any node for ALL, on children for SIBLINGS, or LEAFS when at leaf, except origin...
                routing.invoke = !routing.self && match;
                if (routing.message.receiver === Receivers.LEAFS) {
                    routing.invoke = routing.invoke && routing.node === "leaf";
                }

                // Stop: when at leaf; or when at children for SIBLINGS; or if no ALL selector for CHILDREN receiver, ALL
                // and LEAFS receivers cannot forcefully stop until at a leaf node; or when a composite action has been
                // invoked (no longer composite)...
                routing.stop = routing.node === "leaf" || routing.message.receiver === Receivers.SIBLINGS || routing.message.receiver === Receivers.CHILDREN && stop || routing.message.action === Actions.COMPOSITE && routing.invoke;
            }
        }

        // INVOKE - only on receive!
        this.invoke = function (message, steps, action) {
            // public for "plugins" like MessageNodeNetwork...
            var processed, f;

            // Create steps, if not already created (needed since this function is public)...
            if (str(steps)) {
                steps = newSteps(message, steps);
            }

            node.log("Invoking action: #", message.origin, " => ", Receivers.name(message.receiver), ": ", message);

            // Can we find a corresponding action in a used target?...
            if (action || message.action) {
                f = callback(message, action);
            }
            // If no action, or no matching callback, see if we can find the default handler
            // for any such message. We do *not* default to MESSAGE action if an explicit
            // action has been supplied...
            if (!(f || action)) {
                f = callback(message, Actions.MESSAGE);
            }

            processed = { callback: f, result: null };

            // Do we have a callback for the specified action to invoke now?
            if (f) {
                steps("invoke-action");
                processed.result = f(message, steps);
            } else {
                steps("no-action");
            }

            return processed;
        };

        // APPLY SELECTORS - only on receive
        function applySelectors(routing) {
            var message = routing.message,
                steps = routing.steps,
                processed = routing.processed || {};

            // Return result to "message.origin", or from the root/leaf if we can go no further, or if we are the actual receiver...
            if (Selectors.has(message, Selectors.REPLY)) {
                // "?"
                if (processed.result) {
                    // only if invoked
                    steps("reply");
                    // Post reply with the same action and a proper correlation id...
                    node.reply(message, processed.result);

                    // No result or not even invoked, but we have no where else to go...
                } else if (routing.stop) {
                    steps("reply-no-result");
                    // Post reply with the same action and a proper correlation id...
                    node.reply(message, noResult);
                } else if (processed.callback) {
                    steps("not-replied");
                }
            }

            // Stop traversing when the a node in the current route consumes/processes the message successfully...
            if (Selectors.has(message, Selectors.FIRST)) {
                // "+"
                if (processed.callback) {
                    steps("consumed");
                    routing.stop = true;

                    // No where else to try?
                } else if (routing.stop) {
                    steps("not-consumed");
                }
            }
        }

        // DO ROUTING - on post, receive, and dequeue!
        function doRouting(routing) {
            var message = routing.message,
                steps = routing.steps,
                child,
                childHandler,
                relay = node.parents,
                any = false;

            // Force queuing (and stop routing now)? If so, the message explicitly be dequeued to be posted eventually...
            if (routing.queue) {
                queue.enqueue(message, steps);
                return;

                // No more routing?
            } else if (routing.stop) {
                // will also be true if "routing.ignore" is true
                return;
            }

            // Top-down?
            if (!routing.bubble) {
                if (routing.indirect) {
                    // indirect receiver like ALL, CHILDREN, SIBLINGS, or LEAFS
                    if (node.children) {
                        for (child in node.children) {
                            if (node.children.hasOwnProperty(child)) {
                                childHandler = node.children[child];
                                // Only post to non-shared ready child handlers that are ready - since ACK can be recursive,
                                // "message" can here have an ACK action as well!...
                                if (childHandler.is(child) && childHandler.ready(message)) {
                                    childHandler.post(message);
                                    if (!any) {
                                        steps("relay-children");
                                        any = true;
                                    }
                                }
                            }
                        }
                    }
                    if (!any) {
                        node.log("Noop message - no ", routing.indirect === Receivers.ALL ? Receivers.CHILDREN : routing.indirect, " to relay to: ", message);
                    }
                    return;

                    // The receiver is an actual receiver, not a indirect one. If we have a *ready* message handler for the
                    // receiver, we post to it, otherwise we relay the message to the parent, if any, *unless* one-way,
                    // i.e. where the state is only "listening". Otherwise we enqueue locally at this node since then a
                    // root node for the child in question. If the handler is not yet ready, i.e. handshake in progress,
                    // we will also enqueue the message at the root instead (below)...
                } else {
                    childHandler = node.children && node.children[message.receiver];
                    if (childHandler) {
                        if (childHandler.ready(message)) {
                            // can be indirect!
                            node.log("Relaying message to child: #", message.origin, " => #", message.receiver, ": ", message);
                            childHandler.post(message);
                            steps("relay-child");
                            return;
                        }
                        // If we cannot post to the child handler, the communication is one way, and we can only
                        // listen for incoming messages, never post to the child. If so, we must never relay to parent
                        // (root), since it will relay the information back to use again, so the message ends here -
                        // either queued or ignored, depending on selectors used...
                        if (relay) {
                            // if we have parents at all
                            // This will eventually result in a "noop" step...
                            relay = childHandler.behaviour().post; // i.e. when state is just "listening"!
                        }
                    }
                    // Fall-through to enqueue/relay to parent for enqueuing!
                }
            }

            // Bottom-up - may be a fall-through for an unknown child...
            if (relay) {
                // Safe-guard: do *not* relay to parent if the message came from an ancestor, since that will likely
                // cause an infinite loop, i.e. some ancestor re-sending the message again...
                if (routing.sender !== "ancestor") {
                    node.log("Relaying message to parent: #", message.origin, " => ", Receivers.name(message.receiver), ": ", message);
                    node.parentHandler.post(message);
                    steps("relay-parent");
                } else {
                    node.err("Cannot relay message from ancestor to parent: ", message);
                }

                // Cannot enqueue messages with indirect receivers like PARENT or if the message originated at this (root) node...
            } else if (!(routing.indirect || Selectors.has(message, Selectors.NO_QUEUE))) {
                // "!" // FIXME: this ok to r || routing.to === "self") {
                queue.enqueue(message, steps);
            }
        }

        //

        this.dispatch = function (message, steps) {
            // public!
            // Create steps, if not already created...
            if (str(steps)) {
                steps = newSteps(message, steps);
            }

            var entry = { routing: null, message: message, steps: steps, ignore: false, error: null },
                validate = steps.has("received") || validateOnSend; // "post" or "dequeued"

            // Push message/steps to dispatcher queue to maintain ordering so we can ensure we invoke
            // client callbacks in correct FIFO order...
            dispatched.push(entry);
            count++;

            try {
                // By default, we only validate on receive, since we assumed messages created to be posted by this node
                // are valid...
                if (validate) {
                    // The handleable callback can for example be used to filter on message tags and actual message
                    // types, e.g. "message.event.type" values. We call it here, since may also be applicable for
                    // composite messages...
                    if (node.factory.handleable(message)) {
                        // Validate message (except sender, which is always set in "post(..)" to ensure correct behaviour). This will
                        // raise an exception if not valid. We *cannot* do this before we can handle the message, since we could
                        // then try and validate messages from arbitrary sources...
                        entry.message = node.factory.validate(message);

                        // Ignore any message we cannot handle...
                    } else {
                        entry.ignore = true;
                    }
                }

                // We do not catch and report errors here, since that is expected to be done already in
                // "dispatch", i.e. if we get an error here, it will (presumably) because "err(..)" was
                // called explicitly...
                if (!entry.ignore) {
                    // Do actual dispatch...
                    dispatch(entry);
                    // Update "ignore" flag...
                    entry.ignore = entry.routing.ignore || entry.routing.processed && entry.routing.processed.result === noResult;
                }

                if (entry.ignore) {
                    steps("ignore"); // for stats...
                }
            } catch (e) {
                entry.error = e;
                // Add "error" step for validation/handleable errors, since dispatch errors will have set an "error" step...
                if (!steps.has("error")) {
                    scope.err(["Dispatch failed: ", message, " -> ", e], message.action);
                }
                throw e;
            } finally {
                // "message" has now been dispatched or failed, perhaps spawning recursive messages, so we are
                // ready to process ANY callback now if we are back to a zero count. On errors, we do not call
                // ANY for the failing message, but we do so for all others. On errors, the ERROR handler,
                // if any, will already have been notified for "message". For message entries where the "ignore"
                // flag has been set, we do not call ANY either...
                if (! --count) {
                    var d = dispatched,
                        i,
                        f;
                    dispatched = []; // clear immediately, in case a callback fails unexpectedly...
                    count = 0;
                    for (i = 0; i < d.length; i++) {
                        entry = d[i];
                        // Add "noop" step if not other step beside "post", "received", or "dequeued" is present...
                        if (entry.steps.steps.length === 1) {
                            entry.steps("noop");
                            node.log("Noop message: ", entry.message);
                        }
                        if (!(entry.ignore || entry.error)) {
                            if (f = callback(entry.message, Actions.ANY)) {
                                f(entry.message, entry.steps, scope);
                            }
                        }
                    }
                }
            }

            // Return original steps, not those from possibly spawned dispatched messages...
            return steps;
        };

        function newSteps(message, s) {
            var stats = MessageDispatcher.stats,
                step = function step(s) {
                if (s) {
                    // Sanity check to avoid infinite recursion and other errors...
                    if (idx(step.steps, s) !== -1) {
                        node.err("Duplicate step: '", s, "' -> ", step, ": ", message);
                    }
                    step.steps.push(s);
                    stats[s] ? stats[s]++ : stats[s] = 1;
                }
                return step;
            };
            step.steps = [];
            step.stats = stats; // for easy client reference
            step.has = function (s) {
                return idx(step.steps, s) !== -1;
            };
            step.type = function () {
                return step.steps[0];
            }; // short-cut...
            step.toString = function () {
                return "[" + join(step.steps, ", ") + "]";
            };

            return s ? step(s) : step;
        }

        this.toString = function () {
            var s = "MessageDispatcher[",
                step,
                stats = MessageDispatcher.stats,
                first = true;
            for (step in stats) {
                if (stats.hasOwnProperty(step)) {
                    if (first) {
                        first = false;
                    } else {
                        s += ", ";
                    }
                    s += step + ": " + stats[step];
                }
            }
            return s + "]";
        };
    }

    MessageDispatcher.stats = {}; // global per environment


    //
    // MESSAGE POSTER
    //


    // Posts messages to a configured "postable" object: Window, MessagePort, Worker (or even some proxy type)...
    function MessagePoster(node, transport, origin, p /*ostable*/) {
        var scope = this,
            postable = new Context(node),
            targetOrigin = "*";

        // Transport mode: string or json...
        transport = !node.factory.json.supported || node.global.legacy() ? "string" : transport || "json";

        this.type = postable.type;

        // The *target* origin posted to, may be updated, e.g. when a child has connected to a parent...
        this.targetOrigin = function (origin) {
            // getter/setter
            if (typeof origin !== "undefined") {
                // Target origin must always be "*" for FILE, or posting will be denied by the browser...
                targetOrigin = !origin || origin === "*" || Origins.file(origin) ? "*" : Origins.origin(origin);
            }
            return targetOrigin;
        };

        this.transport = function (t) {
            // We can go from json to string, but not the reverse, since the initial value is set based on
            // whether or not json is supported by the browser...
            if (typeof t !== "undefined" && transport === "json") {
                transport = t;
            }
            return transport;
        };

        this.post = function (message, transferable) {
            // intentionally not called "postMessage"!
            if (!postable.set()) {
                node.err("No postable set: ", scope);
            }

            // We now have a context...
            message.context = postable;

            // Arguments for postMessage differs based on "postable" type, either:
            // 1: [message] - {worker|global|port}.postMessage
            // 4: [message, [transferable]] - {worker|global}.postMessage init // port
            // 2: [message, target] - {window|unknown}.postMessage
            // 3: [message, target, [transferable]] {window|unknown}.postMessage init // port

            // First argument: always the formatted message..
            var args = [node.factory.format(message, transport)],
                type = scope.type();

            // Intermediate argument, if any: origin, not for workers, nor ports, but windows. We also
            // supply it in case of "unknown", i.e. we could not deduce the type, probably because the
            // browser uses some proxy object instead of the expected type, for example on cross domain
            // communication. This may not be correct, of course, but we should never get an "unknown"
            // type to begin with...
            if (type === "window" || type === "unknown") {
                args.push(targetOrigin);
            }

            // Last argument, if any: transferable, i.e. port, always last argument if supplied. Will
            // only be supplied if MessageChannel is supported, so no need to check for this here...
            if (transferable) {
                args.push([transferable]);
            }

            // Note: no logging here, since that will flood the log when relaying log messages to a
            // parent node, i.e. in a worker environment or where relaying has been configured...
            try {
                // Cannot use "apply", since "postMessage" is not always a function in IE, seems to be
                // related to using file:// protocol or cross domain...
                switch (args.length) {
                    case 1:
                        postable.ctx.postMessage(args[0]);break;
                    case 2:
                        postable.ctx.postMessage(args[0], args[1]);break;
                    default:
                        postable.ctx.postMessage(args[0], args[1], args[2]);break;
                }
            } catch (e) {
                // SecurityError, not supported Error
                node.err("Cannot post message: ", node, " -> ", message, ": ", e, " => arguments: ", args);
            }
        };

        this.handle = function (p) {
            p = p instanceof Context ? p.ctx : p; // unwrap

            // No need to update if same postable, but it can be undefined...
            if (!postable.is(p)) {
                // if (p && typeof p.postMessage === "undefined") { // not a function on proxy windows in IE...
                //    node.err("Postable must declare 'postMessage' function: ", p);
                //}

                // Close old one, if any...
                scope.close();

                // Set new one...
                postable.handle(p);

                // Note: "start()" not needed if "onmessage" handler assigned like "p.onmessage = .."
                // for message ports - go figure!...
                if (postable.type() === "port") {
                    postable.ctx.start();
                }
                return true;
            }
            return false;
        };

        this.close = function () {
            var type = postable.type();
            if (type !== "none") {
                // Close postable unless it is a window, since that will close the window itself. Workers do not
                // expose a "close()" function externally, but have one internally. So, workers are not closed
                // externally, but instead when they receive a "close" action, in which case the test below will
                // succeed and the worker will thus close itself internally...
                if (type !== "window" && type !== "unknown" && fn(postable.ctx.close)) {
                    // dare not close "unknown" since it might be a window failed to be identified
                    try {
                        postable.ctx.close();
                    } catch (e) {
                        // SecurityError
                        node.log.err("Could not close discarded postable: ", scope, " -> ", postable, ": ", e);
                        // Fall-through!
                    }
                }
            }
            postable.close(); // can still have added listeners to remove here...
        };

        this.toString = function () {
            return "MessagePoster[target-origin: '" + targetOrigin + "'; postable: " + postable + "; transport: " + transport + "]";
        };

        // Initialise...
        if (origin) {
            scope.targetOrigin(origin);
        }
        if (p) {
            scope.handle(p);
        }
    }

    //
    // MESSAGE HANDLER
    //


    // A message handlers handles one-way (either way), or two-way communication between two fixed nodes: "node.name" and "recv" (default parent node)
    function MessageHandler(node, options, type, origins, c /*ontext*/, b /*ehaviour*/, recv) {
        var scope = this,
            context = new Context(node),
            poster = new MessagePoster(node, options.transport),
            behaviour = {},
            targetOrigin = "*";

        this.state = "uninitialized";

        // Tree structure describing the message node tree sharing this message handler, only set for shared handlers. Sharing can be
        // for descendant sub-trees and/or for siblings sharing the same backing postable, i.e. window...
        this.shared = null;

        // The *target* origin posted to, i.e. where is the receiving node located at. Never used if this handler is only listening...
        this.targetOrigin = function (origin) {
            // origin of "recv"
            if (typeof origin !== "undefined") {
                // Make sure we write through to actual message poster...
                targetOrigin = poster.targetOrigin(origin);
            }
            return targetOrigin;
        };

        function actualReceiver() {
            return fn(recv) ? recv() : recv;
        } // can be undefined

        this.transport = poster.transport;
        this.behaviour = function () {
            return { post: behaviour.post, listen: behaviour.listen };
        };

        this.ready = function (message) {
            var ready = idx(scope.state, "ready") !== -1 || message && message.action === Actions.ACK && idx(scope.state, "waiting") !== -1; // ACK required to make this handler ready...
            if (!ready) {
                node.log.verbose("Handler not ready: ", scope, " -> message: ", message ? message : "none");
            }
            return ready;
        };

        this.bidirectional = function () {
            return behaviour.post && behaviour.listen; // may still not be ready to post!
        };

        this.post = function (message, transferable) {
            if (scope.ready(message)) {
                if (node.name === message.receiver) {
                    node.err("Cannot send message to itself: ", message);
                }
                // Tag message with sender name. Note that this changes "message"!...
                message.sender = node.name;
                node.log.verbose("Posting message: ", scope, " -> ", message);
                poster.post(message, transferable);
            } else {
                node.err("Handler cannot post: ", scope, " -> ", message);
            }
            return scope;
        };

        this.is = function (nameOrPostable) {
            // or Context
            return str(nameOrPostable) ? actualReceiver() === nameOrPostable : context.is(nameOrPostable);
        };

        this.qualified = function (name) {
            var qualified = { name: "#" + name, origin: targetOrigin },
                parents = [],
                entry;
            if (!scope.is(name)) {
                // Shared descendants?
                entry = scope.shared[name];
                if (entry) {
                    if (entry.origin) {
                        qualified.origin = entry.origin;
                    }
                    while (entry && entry.parent !== node.name) {
                        parents.unshift(entry.parent);
                        entry = scope.shared[entry.parent];
                    }
                    qualified.name = "#" + join(parents, "(*).#") + "(*)." + qualified.name;
                }
            }
            return qualified;
        };

        // Listens for "onmessage" events!
        function handleMessage(event) {
            var start = now();
            if (!event) {
                event = node.global.event; // IE legacy issue
            }

            // No "event.data" means not for us, or return immediately if we are closed...
            var message = event.data;
            if (!message || scope.state === "closed") {
                return; // do not log this, does not concern us...

                // Make sure we have an allowed origin, tested against the normalised *event* origin...
            } else if (!origins.allowed(context, event)) {
                return;

                // Payload probably tried marshalled as json though not supported, i.e. toString representation
                // marshalled...
            } else if (message === "[object Object]") {
                node.log.verbose("Looks like message is tried marshalled as json where not supported from: '", event.origin, "'", event);
                return;
            }

            // Try and create then...
            message = node.factory.create(message, context, event);

            // Ignore if we could not create a message...
            if (!(message instanceof Message)) {
                return;

                // Intercept incoming related log message to be logged here, since the message is not really indented
                // for this node, as to avoid flooding this node. This is a typical scenario for workers using the
                // default log implementation. If this node is also a worker node, the message is simply relayed
                // to the parent, until one is found that is not a worker (if any)...
            } else if (message.action === "log") {
                // TODO: for composites?!?
                node.log(message.data);
                return;

                // Ditto for relayed error messages...
            } else if (message.action === "err") {
                node.log.err(message.data);
                return;
            }

            // Message seems ok, so dispatch it...
            node.dispatcher.dispatch(message, "received");

            node.log.verbose("Processing time: ", now() - start, " ms: ", message);
        }

        this.handle = function (c, b) {
            b = b || {}; // i.e. default (post: false, listen: false)

            // Handle (new) context, implicitly closing the old one, if any. If null context, we assume the same
            // context, which is not the same as undefined, i.e. on init or clean up...
            var newContext = false,
                listening = behaviour.listen;
            if (c !== null) {
                newContext = context.handle(c);
            }

            // If same context and no behaviour change, we are done...
            if (!newContext && !!b.post === !!behaviour.post && !!b.listen === !!listening) {
                return false;
            }

            // Update behaviour, i.e. post and/or listen?
            behaviour = b;

            // Set new postable context, which will close the old one first, if any..
            if (behaviour.post) {
                if (newContext) {
                    poster.handle(context);
                    scope.state = "waiting"; // ready here, but not acknowledged...

                    // If same context, it may already be ready...
                } else {
                    scope.state = idx(scope.state, "ready") !== -1 ? "ready" : "waiting";
                }
            } else if (!behaviour.listen) {
                poster.close(); // will close actual postable, which is bad if we are listening...
            }

            // Start listening for messages...
            if (behaviour.listen) {
                // Make sure we do not add the same listener for the same context multiple times...
                if (newContext || !listening) {
                    context.on("message", handleMessage);
                }
                // If we post, we will already have set the state with regards to posting above...
                scope.state = behaviour.post ? scope.state + "/listening" : "listening";

                // Remember to close old one if we were listening, but not so anymore...
            } else if (behaviour.post) {
                context.off(); // will not close actual context (postable), just remove listeners. Needed if same context is re-supplied...
            } else {
                context.close(); // close and remove...
                poster.close(); // also close actual postable...
                scope.state = "";
            }

            return true;
        };

        this.close = function () {
            if (scope.state !== "closed") {
                node.log("Closed handler: ", this);
            }
            context.close();
            poster.close();

            scope.state = "closed";
        };

        this.toString = function () {
            var s = "MessageHandler[",
                receiver = Receivers.name(actualReceiver()) || "";
            if (receiver) {
                s += "receiver: " + receiver + "; ";
            }
            s += "target-origin: '" + targetOrigin + "'; ";
            // $receiver is for better naming when siblings share an actual postable, e.g. window...
            s += "type: #" + node.name + (type || "").replace(/\$receiver/g, receiver) + "; state: " + scope.state;
            if (behaviour.post) {
                s += "; poster: " + poster;
            }
            if (behaviour.listen) {
                s += "; listening-context: " + context;
            }
            return s + "]";
        };

        // Initialise...
        if (c) {
            scope.handle(c, b);
        }
    }

    //
    // MESSAGE QUEUE
    //


    // A message queue is used to enqueue messages a root nodes with currently unknown receivers.
    function MessageQueue(node) {

        // (receiver -> Message[])
        var queue = {},
            size = 0,
            scope = this;

        // Total number of queued messages for the node, regardless of receiver.
        this.size = function () {
            return size;
        };

        // Enqueues a message if so configured, or with a currently unknown receiver - the latter only called when "node" is
        // a root and with non routing receivers, e.g. no "children" receiver, but selectors like "?" are allowed!
        this.enqueue = function (message, steps) {
            var receiver = message.receiver,
                messages = queue[receiver],
                msg,
                i;
            if (!messages) {
                messages = [];
                queue[receiver] = messages;
            }
            // Make sure the message is not a duplicate...
            for (i = 0; i < messages.length; i++) {
                msg = messages[i];
                // Make sure we have not enqueued this message already...
                if (message.equals(msg)) {
                    node.log("Message already enqueued: #", message.origin, " => ", Receivers.name(receiver), ": ", message);
                    return;
                }
            }
            messages.push(message);
            steps("enqueue");
            size++;
            node.log.verbose("Enqueuing message: #", message.origin, " => ", Receivers.name(receiver), ": ", message);
        };

        // When a receiver becomes known to a given root, or those forcefully enqueued using a selector...
        this.dequeue = function (receiver, withSelector) {
            var messages = queue[receiver],
                message,
                selector,
                i;
            if (messages) {
                // We have to loop forwards to maintain order...
                for (i = 0; i < messages.length;) {
                    message = messages[i];
                    selector = Selectors.has(message, Selectors.QUEUE) ? true : false;
                    if (typeof withSelector === "undefined" || withSelector === selector) {
                        // Remove QUEUE selector *always*, or "message" will be enqueued immediately again...
                        Selectors.remove(message, Selectors.QUEUE);
                        // Removes "message" and decreases "messages.length" by one, so "i" is still at the same index...
                        messages.splice(i, 1);
                        size--;
                        node.log.verbose("Dequeuing message: #", message.origin, " => ", Receivers.name(message.receiver), ": ", message);
                        // This may actually re-queue the message if this node was set to queue all messages before...
                        node.dispatcher.dispatch(message, "dequeued");
                    } else {
                        i++;
                    }
                }
                if (!messages.length) {
                    delete queue[receiver];
                }
            }
        };

        // When a root node is attached as a child of another node, all queued messages will be forwarded to its new (parent) root.
        this.dequeueAll = function (withSelector) {
            var receiver;
            for (receiver in queue) {
                if (queue.hasOwnProperty(receiver)) {
                    scope.dequeue(receiver, withSelector);
                }
            }
        };

        // Purges all queued messages sent by removed nodes *without* any dispatch.
        this.purge = function (remove) {
            // remove[name] = 1 for removal
            var receiver, sender, message, messages, i;
            // Remove queued messages with any removed child as the *origin*...
            for (receiver in queue) {
                if (queue.hasOwnProperty(receiver)) {
                    messages = queue[receiver];
                    i = messages.length;
                    while (i--) {
                        sender = messages[i].origin;
                        if (remove[sender]) {
                            message = messages.splice(i, 1)[0]; // only one removed at a time...
                            node.log.verbose("Purging queued message: ", message);
                            size--;
                        }
                    }
                    if (!messages.length) {
                        delete queue[receiver];
                    }
                }
            }
        };

        // Purges all, i.e. on (root) node close...
        this.purgeAll = function () {
            var receiver, message, messages, i;
            for (receiver in queue) {
                if (queue.hasOwnProperty(receiver)) {
                    messages = queue[receiver];
                    for (i = 0; i < messages.length; i++) {
                        message = messages[i];
                        node.log.verbose("Purging queued message: ", message);
                    }
                }
            }
            size = 0;
            queue = {};
        };

        this.toString = function () {
            var s = "MessageQueue[size: " + size,
                receiver,
                first = true;
            if (size) {
                s += "; queue: [";
                for (receiver in queue) {
                    if (queue.hasOwnProperty(receiver)) {
                        if (first) {
                            first = false;
                        } else {
                            s += ", ";
                        }
                        s += Receivers.name(receiver) + ": " + queue[receiver].length;
                    }
                }
                s += "]";
            }
            return s + "]";
        };
    }

    //
    // MESSAGE NODE CONNECTOR
    //


    // A message node connector is used to initiate the connection between parent and child nodes. It is
    // used both by parent and child nodes, i.e. handles both a child trying to connect to its parent,
    // and a parent listening for incoming children.
    function MessageNodeConnector(node, options, origins) {

        var connectOptions = options && options.connect || {},
            timeout = (node.env === "worker" ? 2 : 1) * (connectOptions.timeout || 250),
            // double timeout in workers, since they are truly asynchronous and likely to start quite fast...
        limit = node.global.ctx.parseInt(connectOptions.limit, 10) || 10000 / timeout,
            // 10 second worth of tries by default...
        listener,
            parentListener,
            timer,
            receiver = connectOptions.parent || Receivers.PARENT,
            key = (connectOptions.key ? fn(connectOptions.key) ? connectOptions.key() : connectOptions.key : now()).toString(),
            targetOrigin,
            transport;

        function clearTimer() {
            if (timer) {
                node.global.ctx.clearTimeout(timer);
            }
            timer = null;
        }

        function fail(msg, error) {
            if (connectOptions.err) {
                node.err(msg);
            } else if (error) {
                node.log.err(msg); // node.err already notified!
            } else {
                node.log(msg);
            }
            // Close "node.parentHandler" for proper state henceforth on the message node - this is *not*
            // the listener(s) (handler(s)) used to listen for incoming children and optionally parent messages
            // used by this connector! Also, we do not close "node.parentPoster", since that may still work, e.g.
            // relaying log messages...
            node.parentHandler.close();
        }

        // Actual connection handler from child->parent...
        function connect(count) {
            clearTimer();

            count++;

            var channel = null,
                message = null;

            if (limit && count >= limit) {
                // Do not raise an exception here, merely log it unless so configured...
                fail(["Could not connect to ", Receivers.name(receiver), " after ", count, " attempts with target origin: '", targetOrigin, "'"], false); // not logged as an error, since a root node will not have a parent!
                return;
            }

            // Negative counts specifies the number of timeouts to skip before trying a connect the first time, useful for
            // when a parent node is closed, i.e. give it time to reload...
            if (count >= 0) {

                // Not supported in Firefox or < IE10...
                if (options.channels) {
                    channel = new MessageChannel();

                    // Update parent handler with the specified port, since ports can only be sent *once* like this, or we get
                    // a data clone error. We therefore have to create a new channel each time we try and connect, and update
                    // the parent handler accordingly. If we are not using channels, the "node.parentContext" will already
                    // have been set once and for all...
                    node.parentHandler.handle(channel.port1, { post: true, listen: true }); // listen for "channel.port1.onmessage" events
                }

                // Signal opener/parent window that we are open for business. If "node" is in fact a root, no parent will ever
                // respond to this message, which we will handle gracefully in the specified timer. The postable supplied with
                // the message will be used by the parent to call this child node...
                try {
                    message = node.newMessage({ action: Actions.CHILD, id: node.factory.id(), data: node.factory.encode(key, transport), receiver: receiver });
                    if (count < 300 && !(count % ~~(2500 / timeout)) || limit && count === limit - 1) {
                        // ~~ = bitwise OR to ensure ints, so we only log every other second to avoid flooding the log...
                        node.log("Posting connect message no. " + (count + 1) + " to ", Receivers.name(receiver), " at '" + targetOrigin + "': ", message);
                    }
                    // In legacy IE, this call is synchronous, and will cause message listeners to be fired immediately
                    // in the parent context, i.e. ACK fired before we continue here. This means that the "timer" for
                    // re-connect will not have been set yet, and it thus cannot be cleared in "connected()". Below, we
                    // thus test for "node.parents" to avoid setting the timer again if already connected...
                    node.parentPoster.post(message, channel && channel.port2);
                } catch (e) {
                    // Do not raise an exception here, merely log it unless so configured...
                    fail(["Cannot call ", Receivers.name(receiver), " with connect message: #", node.name, " -> ", message, ": ", e], true);

                    // Child nodes can still connect to "node" even if here (unless created explicitly as a leaf)...
                    return;
                }
            }

            // Try again in a bit... The test for "node.parents" is to ensure we do not fire a connect message again
            // if we already have parents. This can be the case in legacy IE where "postMessage" is synchronous, i.e.
            // it will invoke message listeners before releasing control (ACK -> connected(..))...
            if (!node.parents) {
                timer = node.global.ctx.setTimeout(function retry() {
                    connect(count);
                }, timeout);
            }
        }

        // Do *not* listen for "onmessage" events here, since we will have no access to attach ourselves to the
        // parent context, e.g. remote window. Luckily, the parent attaches the handler on itself just below
        // when setting up its child listener, and as long as a single message handler is attached. That is,
        // "node.parentContext" === "node.context" on the parent node. We still have to use the handler, and
        // not just "node.parentPoster", to handle logging and (re-)load events...
        var parentRequired = !options.channels && node.parentContext.set(),
            same = node.global.is(node.context);
        if (parentRequired) {
            node.parentHandler.handle(node.parentContext, { post: true }); // do *not* listen for "node.parentContext.onmessage" events (security error!)
        }

        // Message handler to listen for incoming CHILD actions, which will respond with an ACK action.
        // It is *never* used for posting messages, so the supplied "node.name" as default receiver is just
        // to make the logging clearer. However, if we are not using channels, we must ensure that we have
        // at least one "onmessage" listener on "node.context", or the parent node can never communicate
        // with us - the parent cannot add it on the source window ("node.context") during connect because
        // of security constraints - same issue as for "parentContext" described above...
        if (options.type !== "leaf") {
            // respect *initial* type!
            listener = new MessageHandler(node, options, parentRequired && same ? "<-children<-parent" : "<-children", origins, node.context, { listen: true }); // listen for "node.context.onmessage" events
        }

        // In case the context is not the same as the global scope, i.e. a worker and not a window, we must ensure
        // we listen for events posted to the global scope, since that is how the parent will communicate with this
        // node. Workers are not transferables, unfortunately, so we have to use this form of indirection. If channels
        // are used, there is not problem since they are used directly, i.e. they are transferable. This listener is
        // never used for posting...
        if (!(options.channels || same)) {
            parentListener = new MessageHandler(node, options, "<-parent", origins, node.global, { listen: true }); // listen for "node.global.onmessage" events
        }

        // (Re-)connect to parent node...
        this.connect = function () {
            // If the node already has (a) parent(s), no need to connect again. Also, we only need to establish communication
            // to the parent node ("broker") if we have a parent context, otherwise will we simply listen for incoming child
            // request for such communication. Intermediate nodes will do both. The CHILD action posted here will be caught
            // by the "handler" defined above in the parent node connector...
            if (!node.parents && node.parentContext.set()) {
                // Make sure we now have the parent connect meta info we require...
                targetOrigin = node.parentPoster.targetOrigin();
                transport = node.parentPoster.transport();
                // Go!
                connect(node.global.legacy() ? -2 : -1); // to allow old legacy IE browsers to regain control because postMessage is synchronous...
            }
        };

        // Callback to notify this connector that a connection has been made to the parent. We cannot close the dedicated
        // listeners here, since they will still be listening for incoming children and optional parent messages depending
        // on type of contexts used...
        this.connected = function (origin, receivedKey, bidirectional) {
            // A feeble attempt to guard against pure static connect attacks, i.e. the key must at least be known before
            // we can try and connect...
            if (!origin || key !== receivedKey) {
                return false;
            }

            clearTimer();

            // Make sure no longer listening if one way...
            var listen = node.parentHandler.behaviour().listen;
            if (listen && !bidirectional) {
                node.parentHandler.handle(null /*same context*/, { post: true });
                listen = false;
            }
            // Since a parent handler, it will always post; the question is only if it listens...
            node.parentHandler.state = listen ? "ready/listening" : "ready";

            // Update (target) origins for consistency and to use actual origin instead of just "*" if
            // so initially configured; for the listeners, we will never do actual posting to these origins...
            node.parentPoster.targetOrigin(origin);
            node.parentHandler.targetOrigin(origin);

            // Parent listener, used for indirection. If one way communication, we will never listen to events from
            // the parent, so we simply close it altogether...
            if (parentListener) {
                if (listen) {
                    parentListener.targetOrigin(origin);
                } else {
                    parentListener.close(); // dedicated parent listener
                    parentListener = null;
                }
            }
            // Listen for children, so not affected if one-way with parent...
            if (listener && parentRequired && same) {
                listener.targetOrigin(origin);
            }
            return true;
        };

        this.parent = function () {
            return receiver;
        }; // node name or "parent"

        this.close = function (excludeParent) {
            clearTimer();
            if (listener) {
                listener.close(); // children and optionally parent listener
                listener = null;
            }
            if (parentListener && !excludeParent) {
                parentListener.close(); // dedicated parent listener
                parentListener = null;
            }
        };

        this.toString = function () {
            var s = "MessageNodeConnector[";
            if (listener) {
                s += "listener: " + listener;
            }
            if (parentListener) {
                if (listener) {
                    s += "; ";
                }
                s += "parent-listener: " + parentListener;
            }
            return s + "]";
        };
    }

    //
    // MESSAGE NODE
    //

    // Map of created local nodes to avoid re-creating/overriding nodes in a long lasting context, such as a
    // single page app. Closed nodes will remove themselves. Indexes by node name.
    var NODES = new Store("node");

    // A message node handles communication with its parent node, if any, and its child nodes, if any
    function MessageNode(options) {
        // options: name OR object

        // Implementation note: the initialization order of the properties defined below is important,
        //                      since they intricately depend on each other in numerous (unexpected) ways!...

        // JS reference to parent window/frame; undefined means root node...
        var scope = this,
            connector;

        // Global scoped context to attach event listeners, access console, etc...
        this.global = new Context(scope, self);
        // Node environment, *not* the type of postables used. The use of "!=" and not "!==" is intentional,
        // since legacy IE will fail the test if "!==" is used (as it should be)...
        this.env = def("window") ? window.parent && window.parent != window ? "frame" : "window" : "worker";

        // Create default options, if none supplied...
        options = MessageNode.options(options);

        this.name = options.name;
        this.tag = options.tag;

        // Make sure we do not use an illegal node name, i.e. one that will clash with an indirect receiver...
        if (Receivers.indirect(scope.name)) {
            throw new Error("Illegal node name: " + scope.name);
        }

        this.options = function (name) {
            var value = options,
                path,
                i = 0;
            if (name) {
                path = name.split(".");
                while (typeof value !== "undefined" && i < path.length) {
                    value = value[path[i++]];
                }
            }
            return obj(value) ? copy(value) : value;
        };

        this.children = null; // null if no children for easy testing: name -> MessageHandler
        this.parents = null; // null if no parents: parents node names, established on successful child <-> parent handshake, i.e. CHILD->ACK->CHILDACK...

        // Create *private* map of allowed/disallowed origins so it cannot be modified externally...
        var origins = new Origins(scope, options),
            defaults = scope.options("defaults") || {};

        // Default receiver(s) for posted messages with no explicit receiver...
        if (str(defaults)) {
            defaults = { receiver: defaults };
        } else {
            defaults.receiver = defaults.receiver || options.connect && options.connect.parent || Receivers.PARENT;
        }

        // To ensure we do not expose Origins as-is, since it could then be tampered...
        this.origin = function () {
            return origins.origin();
        }; // will normally suffice...
        this.origins = function () {
            return origins.proxy();
        };

        // A queue where messages with unknown receivers are enqueued at this node if and only if this node
        // has no parent, i.e. if this node is a root; if the QUEUE selector is used for a given received message,
        // or if "enqueue(true)" has been called. If this node then becomes a child of another node, i.e.
        // no longer a root, all queued messages will be dispatched to the new root node in the tree (parent or
        // some grand parent). Conversely, when a new child node registers itself to this root node, any
        // messages queued for the child will be dispatched to it...
        var queue = new MessageQueue(scope),
            enqueue = options.enqueue;

        // Special value to indicate no result from other nodes when selectors are used, or returned from
        // an action callback to indicate that no further callbacks should be invoked, e.g. for COMPOSITE
        // action...
        var noResult = options.noResult || MessageNode.NO_RESULT;

        //
        //
        //

        // Use channels?
        options.channels = (typeof options.channels === "undefined" || options.channels) && def("MessageChannel");

        //
        //
        //

        // Internal action dispatcher callbacks that we do not want to expose publicly for
        // parent <-> child communication ("protocol"). Note: the callbacks here do not relay
        // on json formatted data, since json may not be available, or configured not to be
        // used. That is why the factory.encode/decode functions are used explicitly...
        var on = {};

        // at parent (this): child->parent registration received
        on[Actions.CHILD] = function (message) {
            var child = message.origin,
                data = scope.factory.decode(message.data, "key", "transport"),
                receiver,
                sibling,
                childHandler,
                postable,
                shared,
                listen = true;

            // Get existing handler, if any...
            if (scope.children) {
                childHandler = scope.children[child];
                if (childHandler && childHandler.is(child)) {
                    // TODO: what about indirect children?
                    if (!childHandler.ready()) {
                        scope.log("Child connection already in progress: #", child, ": ", scope);
                    }
                    // Remember to close the existing direct handler, if any, but do not clear the queue, if any.
                    // We have to close, since ports cannot be reused once sent, so we have to re-connect anyway...
                    childHandler.close();
                }

                // If this is the first child, including if the child was the only child and reloaded, we have to create
                // the "scope.children" map for use henceforth...
            } else {
                scope.children = {};
            }

            // Create message handler to use to communicate with the child. If the child is configured to use channels,
            // a MessagePort will be sent as part of the connect message, which we will then use, otherwise default
            // to the source (window/worker)...
            postable = message.event.ports && message.event.ports[0];
            if (!postable) {
                postable = message.event.source || message.event.target; // latter for workers
                listen = false;
            }

            // The MessageHandler.handle function implicitly called as part of the construction process will ensure
            // that the postable defined here will have a "postMessage" function, so we just need to make sure we
            // have an object here...
            if (!postable) {
                scope.err("Missing child postable: #", child, " -> ", message);
            }

            // Message ports are never shared by siblings, but a window may be. That is, sibling nodes may share the
            // same parent context (window) as a postable, and we do not want to post a message with an indirect receiver
            // to all such siblings, since they will each receive the message "the number of siblings" times then...
            if (!listen) {
                for (sibling in scope.children) {
                    if (scope.children.hasOwnProperty(sibling)) {
                        childHandler = scope.children[sibling];
                        if (childHandler.is(postable)) {
                            scope.log("Child is sharing postable with existing sibling: #", child, " -> #", sibling);
                            // The existing handler may already be shared, both by other siblings and/or for
                            // descendant nodes as well...
                            shared = childHandler.shared;
                            if (!shared) {
                                childHandler.shared = shared = {};
                            }
                            // The existing child always the first entry in the siblings array, ensuring that if it is deleted,
                            // the next in line is used as the actual receiver, so we will always have at least one child where
                            // "is(..)" will return true...
                            if (!shared.siblings) {
                                shared.siblings = [sibling];
                            }
                            shared.siblings.push(child);
                            break;
                        }
                    }
                }
            }

            // Create new message handler for the child unless shared with a sibling already using the same backing postable...
            if (!shared) {

                // "childHandler.shared" will be undefined when no longer shared, if at all. We use the reference from
                // "childHandler" to avoid keeping a reference to the local "shared" reference here...
                receiver = function receiver() {
                    var shared = childHandler.shared;
                    return shared && shared.siblings && shared.siblings[0] || child;
                };

                // $receiver will be replaced with actual receiver name for better debugging...
                childHandler = new MessageHandler(scope, options, "->$receiver", origins, postable, { post: true, listen: listen }, receiver); // only listen on ports, cannot add handler to remote postable
                // Enforce that we send to the proper origin (url) of the child node...
                childHandler.targetOrigin(message.event.origin);
                // Enforce transport format of messages send to the child, so the child will be able to receive the
                // message at all. However, we can only format as json if this node supports it as well...
                childHandler.transport(data.transport); // note: siblings must use same transport!
            }

            scope.children[child] = childHandler;
            scope.log("Successful child -> parent connection: #", child, " => #", scope.name, ": ", scope, " => ", childHandler);

            // Finally reply with ACK message to it *and* all its grandchildren, done in the "ack" callback, to ensure that
            // the ancestor chain is correct - the child could be a root node! We cannot simply post to "*children" here,
            // since the message payload, i.e. the parent stack, will be different at each level in the sub-tree. Any
            // (grand-)child will response with CHILDACK (see above), causing any queued messages to be dequeued and
            // sent to this node (and possible further up)...
            scope.reply(message, scope.factory.encode(scope.parents ? join(scope.parents, ".") : "", origins.origin(), data.key), Actions.ACK);

            // We also update message data, so user defined CHILD callbacks need not decode themselves...
            message.data = data;
        };

        // at child: parent->child ack received, after CHILD message received at parent (see above)...
        on[Actions.ACK] = function (message) {
            var data = scope.factory.decode(message.data, "parents", "origin", "key"),
                bidirectional = true;

            // If an origin is supplied, the message is from our direct parent as part of the initial connection attempt...
            if (data.origin) {
                // Special case: if we are using channels and a origins.parent = "*" at this node, we really do not know which
                // origin the parent is from, as the origin is empty on message events sent on message ports. If we are not using
                // channels, the parent origin will already have been validated on receive, since it will be posted as part of
                // the message event. Hence, using channels is less restrictive, but what want this node to behave the same
                // regardless if we are using channels or not, so we insert a manual check for origin here for direct child
                // nodes. The check can be faked, of course, since it is based on user data, but in the general case it will
                // ensure the same behaviour channels or not. The lesson is thus: never use "*" as parent target origin if it
                // can be avoided!
                if (!origins.allowed(message.context, data.origin)) {
                    // Break connection attempt, and ensure that user-defined ACK actions will never be invoked. This mimics
                    // the behaviour had we not used channels...
                    if (origins.parent() !== "*") {
                        return noResult;
                    } else {
                        scope.log("One way communication to parent only: ", Receivers.name(scope.name), " -> ", Receivers.name(message.sender));
                        bidirectional = false;
                    }
                }

                // Notify our connector that we are now connected to a parent at "message.data.origin". If the keys does not match,
                // something is off, and we abort the connection attempt. If the message is not from our direct parent, we need
                // not concern ourselves with the connector at this point...
                if (!connector.connected(data.origin, data.key, bidirectional)) {
                    scope.log.err("Connector refused connection attempt: ", message, " -> ", scope);
                    // Break connection attempt...
                    return noResult;
                }
            }

            // Internal composite messages cannot relay on json formatting, since json may not be supported...
            scope.parents = data.parents ? data.parents.split(".") : [];
            scope.parents.push(message.sender);

            var parents = join(scope.parents, ".");
            scope.log("Successful parent ", data.bidirectional ? "->" : "<-", " child connection: #", parents, data.bidirectional ? " => #" : " <= #", scope.name, ": ", scope, " => ", scope.parentHandler);

            // Post with CHILDACK to parent, which we always know is there since "message" originated from it. Note: we cannot use "reply"
            // here, since the parent will differ, i.e. the message will bubble up through the node hierarchy, from one parent to the next...
            scope.post({ action: Actions.CHILDACK, data: scope.factory.encode(parents + "." + scope.name, origins.origin(), bidirectional), receiver: Receivers.PARENT, correlationId: message.id });

            // Relay updated ancestor array to children by forwarding the slightly modified message, i.e. payload data now
            // updated with parent)...
            if (scope.children) {
                scope.post({ action: Actions.ACK, data: parents, receiver: Receivers.CHILDREN, correlationId: message.id });
            }

            // Notify entire network that this node has joined. However, nodes joining after this node will have to request the root
            // for all nodes to know which nodes are currently available, or be part of a network that tracks all nodes in said
            // network...
            if (message.receiver === scope.name) {
                scope.post({ action: Actions.JOIN, data: origins.origin(), receiver: Receivers.ALL });
            }

            // Finally dequeue all queued messages to (*)parent, since we are no longer a root node...
            queue.dequeueAll(false);

            // We also update message data, so user defined ACK callbacks need not decode themselves...
            message.data = data;
        };

        // at parent: child->parent ack received (recursively)
        on[Actions.CHILDACK] = function (message) {
            var data = scope.factory.decode(message.data, "parents", "origin", "bidirectional"),
                parents = data.parents.split("."),
                root = parents.shift(),
                child = parents.pop(),
                childHandler = scope.children[message.sender],
                indirect = child !== message.sender;

            data.bidirectional = data.bidirectional === "true";

            // Use message handler for the sender to handle (indirect) messages to the child node. We have to build
            // a tree structure to describe the sub-trees using the same message handler, to ensure that when a node
            // is closed, all sub-node structure is also removed from this node. Note that we do not handle
            // one-way child handlers here, since indirect: when trying to post to an indirect node that has a one
            // way connection to the parent, the message will in any case be a noop at the parent; this is much
            // easier than changing the behaviour of the shared child handler when nodes join or leave, including
            // shared siblings that potentially could be using the same window context...
            if (indirect) {
                var shared = childHandler.shared,
                    parent,
                    entry,
                    i = parents.length;
                if (!shared) {
                    childHandler.shared = shared = {};
                }
                // Remember the child just registered. This will never override shared information for "child", since
                // the child is a descendant, not a sibling, and thus not seen before at this node...
                shared[child] = entry = { parent: root, children: [], origin: data.origin, bidirectional: data.bidirectional };

                // E.g. 'root.child2.child3.child4' -> "root" = 'root', "child" = 'child4', first "parent" = 'child3'...
                while (i--) {
                    parent = parents[i];
                    entry.parent = parent;
                    entry = shared[parent];
                    if (!entry) {
                        shared[parent] = entry = { parent: root, children: [], bidirectional: data.bidirectional }; // "parent" overridden for nested nodes above!
                    }
                    entry.children.push(child);
                }
                scope.children[child] = childHandler;

                // If bidirectional, we can now be able to post messages using the child handler, no more enqueuing...
            } else {
                // Make sure no longer posting if one way from child to this node (parent)...
                var behaviour = childHandler.behaviour();
                if (!data.bidirectional && behaviour.post) {
                    childHandler.handle(null /*same context*/, { listen: behaviour.listen });
                }
                childHandler.state = data.bidirectional ? "ready/listening" : "listening";
            }

            scope.log("Successful", indirect ? " indirect " : " ", "child", data.bidirectional ? " <" : " ", "-> parent connection: #", child, data.bidirectional ? " <" : " ", "=> #", scope.name, ": ", scope);

            // Relay routing information to parent if and only if we have acknowledgement from the entire node sub-tree,
            // i.e. when the parent path starts with this node...
            if (scope.parents && scope.name !== root) {
                scope.post(message, true); // relay, so we do not loose origin!
            }

            // Notify "child" node that this parent has joined to trigger a "join" action, but we do not post anything
            // about the ancestors. If a child node requires all nodes, use "nodes()" or a network, but this will
            // probably suit most common/simple scenarios...
            if (data.bidirectional) {
                // cannot post if child is not listening!
                scope.post({ action: Actions.JOIN, data: origins.origin(), receiver: child });

                // Relay queued messages, if any, and only if we can actually perform bidirectional
                // communication, i.e. post, to the child...
                queue.dequeue(child);
            }

            // We also update message data, so user defined CHILDACK callbacks need not decode themselves...
            message.data = data;
        };

        // at node: received composite message where the payload is one or more messages, which we then dispatch instead, in order...
        on[Actions.COMPOSITE] = function (message) {
            var data = message.data,
                event = message.event,
                i;
            if (data) {
                if (!itr(data)) {
                    data = [data];
                }
                // Create Message objects to dispatch based on payload data...
                for (i = 0; i < data.length; i++) {
                    message = scope.factory.create(data[i], message.context, event);
                    // Ignore if we could not create a message...
                    if (message instanceof Message) {
                        scope.dispatcher.dispatch(message, "received");
                    }
                }
            }
            return noResult; // ignore ANY callback
        };

        on[Actions.ORIGIN] = function () {
            return scope.origin();
        };

        // at node, child, or parent: message from ancestor to close, or close received from parent or child, respectively
        on[Actions.CLOSE] = function (message) {
            // at this node: when this node environment is a worker, we have to close it by sending it a message, but only
            // allowed from a parent node...
            if (message.receiver === scope.name) {
                if (scope.ancestor(message.origin)) {
                    scope.close(null, message.data); // force
                    return;
                }
                scope.err("Cannot close non descendant node: ", message);
            }

            // at child: if the parent closed, we need to set up shop again to listen to connect to it, since the user may
            // have triggered a reload or what not...
            if (message.sender === scope.parent()) {
                scope.log("Parent node closed: #", message.sender);
                // No more parents - for now...
                scope.parents = null;

                // Update tree structure - already done recursively. We do not supply the "scope.name" as data here, since
                // that is already handled in the "ack" callback fired at the child node. If we are being forcefully closed,
                // no need to try and reconnect...
                if (message.data !== "force") {
                    if (scope.children) {
                        scope.post({ action: Actions.ACK, receiver: Receivers.CHILDREN, correlationId: message.id });
                    }
                    // Try and re-connect then, using same target origin...
                    connector.connect();

                    // If we are forcefully closed, we simply close this worker (node), closing all spawned child workers
                    // implicitly in the process...
                } else if (scope.env === "worker") {
                    scope.log.verbose("Closing worker node: ", this);
                    scope.global.ctx.close(); // TODO: does this kill all spawned workers from this worker?
                }
                return;
            }

            // Relay closing information to parent node...
            if (scope.parents) {
                scope.post(message, true); // relay, so we do not loose origin!
            }

            // at parent: close relevant child handler *unless* indirect, update shared state, and purge queued messages...
            if (scope.children) {
                var child = message.origin,
                    childHandler = scope.children[child],
                    removed = {},
                    empty = true,
                    shared,
                    entry,
                    parent,
                    children,
                    i,
                    j;

                // Mark child as removed, so we can remove the handler and/or queued messages...
                removed[child] = 1;

                // We may not have a handler yet, e.g. if all messages have been enqueued...
                if (childHandler) {

                    // We have to delete all shared sub-tree state. None of the descendants will be direct, so we just remove
                    // them directly, and the same is true for siblings using the same postable...
                    shared = childHandler.shared;
                    if (shared) {
                        // descendants and/or siblings with shared postable...
                        entry = shared[child];
                        if (entry) {
                            delete shared[child];

                            // Add child to list of children to remove below; will only be set if a handler is shared by
                            // descendants, not if shared by siblings using the same postable...
                            children = entry.children;
                            if (children) {
                                children.unshift(child);

                                // Remove shared descendant handlers and mark as removed...
                                for (i = 1; i < children.length; i++) {
                                    // i = 1 intentionally!
                                    child = children[i];
                                    scope.log.verbose("Removing indirect message handler: #", child);
                                    removed[child] = 1;
                                    delete scope.children[child];
                                    delete shared[child];
                                }

                                // Remove removed children from the shared state...
                                while (entry.parent !== scope.name) {
                                    parent = entry.parent;
                                    entry = shared[parent];
                                    i = entry.children.length;
                                    while (i--) {
                                        // O(n2), but we assume few nodes for general use case...
                                        j = children.length;
                                        while (j--) {
                                            if (children[j] === entry.children[i]) {
                                                entry.children.splice(i, 1);
                                                break;
                                            }
                                        }
                                    }
                                    if (!entry.children.length) {
                                        delete shared[parent];
                                    }
                                }
                            }
                        }

                        // Siblings with shared postable...
                        if (shared.siblings) {
                            // By deleting here, the next sibling in line will become the "actual receiver"
                            // of the still shared handler, unless it was the last shared child removed. The
                            // last remaining sibling will in effect always remain in the "shared.siblings"
                            // array in other to express the correct actual receiver...
                            child = message.origin;
                            shared.siblings.splice(idx(shared.siblings, child), 1);
                            removed[child] = 1;
                            if (!shared.siblings.length) {
                                delete shared.siblings;
                            }
                        }

                        // Do we have any shared state left?
                        for (child in shared) {
                            // or "siblings"
                            if (shared.hasOwnProperty(child)) {
                                empty = false;
                                break;
                            }
                        }

                        if (empty) {
                            childHandler.shared = null;
                        } else {
                            empty = true;
                        }
                    }

                    // Do not force close unless non-shared, but always remove from children...
                    child = message.origin;
                    if (childHandler.is(child)) {
                        scope.log.verbose("Closing and removing message handler: #", child);
                        childHandler.close();
                    }
                    delete scope.children[child];

                    // Do we have any children left?
                    for (child in scope.children) {
                        if (scope.children.hasOwnProperty(child)) {
                            empty = false;
                            break;
                        }
                    }
                    if (empty) {
                        scope.children = null;
                    }

                    // Special case: when "node.context" is a worker, the child closed can be a message port
                    // used to communicate with said worker or via the worker itself. In any case, the worker
                    // is now dead - since a child (itself) has been closed - and so will the "node.context"
                    // be if that is said worker...
                    if (scope.context.type() === "worker") {
                        scope.context.close();
                        // Close connector using said worker only, but not the parent (window) connector...
                        connector.close(true); // TODO: shared workers?
                    }
                }

                // Remove queued messages with any removed child as the *origin*...
                queue.purge(removed);
            }
        };

        //
        //
        //

        // Delegate message factory to handle creation, validation, formatting, and parsing of messages...
        this.factory = new MessageFactory(scope, options.factory);

        // Default action callbacks *in order* - more can be added later on using "node.on(..)"...
        var actions = [];

        this.on = function (on, func, invocationScope, flag) {
            if (on) {
                if (str(on)) {
                    var all = on.split(/\s+/),
                        action,
                        i;
                    on = {};
                    for (i = 0; i < all.length; i++) {
                        if (action = all[i]) {
                            on[action] = func;
                        }
                    }
                } else {
                    flag = invocationScope;
                    invocationScope = func;
                }
                actions.push({ on: on, scope: invocationScope || options.scope || scope, flag: flag });
            }
            return on;
        };

        this.off = function (on) {
            // Start from 2: we never allow internal node actions or initially configured actions to be removed...
            if (on) {
                var i = idx(actions, on, 2);
                if (i >= 2) {
                    actions.splice(i, 1);
                }
            } else {
                actions.splice(2, actions.length - 2); // all after 2
            }
            return scope;
        };

        // First: always node scope, others use configured scope, or node scope...
        scope.on(on, scope);
        scope.on(options.on);

        // Create dispatcher!
        this.dispatcher = new MessageDispatcher(scope, queue, options.validateOnSend, noResult, actions);

        //
        //
        //

        // Set up log...
        this.log = createLog(scope, options);

        // Error handler...
        this.err = function () {
            scope.dispatcher.err(forward(scope, arguments));
        }; // raises an error...

        //
        //
        //

        // Returns the relevant (parent) context from the supplied options...
        function context(type) {
            var ctx = options[type];
            // If a MessageNode, reuse actual context, e.g. window...
            if (ctx instanceof MessageNode) {
                return ctx.context; // always "context", not "parentContext"!

                // Worker url: if the parent is a worker url, this node must be a worker...
            } else if (str(ctx)) {
                if (def("Worker")) {
                    try {
                        ctx = new Worker(ctx);
                    } catch (e) {
                        // SecurityError
                        var msg = ": " + scope.global + " -> '" + ctx + "': ";
                        // file:// urls does not work unless security has been disabled locally...
                        if (origins.file()) {
                            msg = "Workers may not work locally with a '" + FILE + "' url and security enabled" + msg;
                        } else {
                            msg = "Cannot create worker" + msg;
                        }
                        scope.err(msg, e);
                    }

                    // If workers are not supported, we default to the global context, since the node can still
                    // function by itself, just not have any worker children...
                } else {
                    scope.log.err("Workers not supported, using default ", type, ": #", scope.name);
                    ctx = null;
                }
            } // no else-if here!

            return ctx;
        }

        // Set up postable context for windows, frames, and web workers, and determine the environment
        // type accordingly, i.e. "window", "frame", or "worker". The "context" is used to listen for
        // incoming CHILD actions in the node connector, and to attach relevant event handlers. For
        // a window/frame, the context is said window/frame, but for workers it is the global worker
        // scope. If a context is shared, the node using another context will register itself as a child
        // during connect...
        this.context = new Context(scope, context("context") || scope.global.ctx); // default to global

        // The "parentContext" is used to post CHILD requests when this node is a child of
        // another node. For a window, it is the window opener; for a frame, it is the window parent;
        // for a worker, it is the global worker scope (thus same as context); or it can undefined,
        // i.e. this node is thus always a root. The parent context can be supplied to allow to
        // nodes in the same window/frame/worker to be parent/child and not just siblings...
        this.parentContext = context("parentContext");

        // Deduce if not supplied...
        if (!scope.parentContext) {
            switch (scope.env) {
                case "worker":
                    scope.parentContext = scope.context.ctx; // worker.self
                    break;
                case "frame":
                    scope.parentContext = scope.global.ctx.parent;
                    break;
                case "window":
                    scope.parentContext = scope.global.ctx.opener;
                    break;
                default:
                    break; // nothing
            }
        }
        // Wrap in actual context, even if no parent context is used ("none")...
        this.parentContext = new Context(scope, scope.parentContext);

        // Add error handler to contexts if workers, so we can report errors at this node from the
        // worker...
        if (scope.context.type() === "worker") {
            scope.context.on("error", function (event) {
                scope.err(event.message, event);
            });
        } else if (scope.parentContext.type() === "worker") {
            // we assume same worker "context" is a worker...
            scope.parentContext.on("error", function (event) {
                scope.err(event.message, event);
            });
        }

        // Poster used to communicate with the parent node to establish the connection between this
        // (possible) child node and its (possible) parent. Even if MessageChannel is used, we still
        // need this to send the actual port to the parent and used for relaying log messages...
        this.parentPoster = scope.parentContext.set() ? new MessagePoster(scope, options.transport, origins.parent(), scope.parentContext) : null;

        this.type = function () {
            if (scope.parents) {
                return scope.children ? "node" : "leaf";
            }
            return "root";
        };

        // Bottom of parent stack is the root...
        this.root = function () {
            return scope.parents ? scope.parents[0] : null;
        };
        // Top of parent stack is the immediate parent, index zero the root...
        this.parent = function () {
            return scope.parents ? scope.parents[scope.parents.length - 1] : null;
        };

        this.ancestor = function () {
            if (scope.parents) {
                var i = scope.parents.length,
                    j;
                while (i--) {
                    for (j = 0; j < arguments.length; j++) {
                        if (scope.parents[i] === arguments[j]) {
                            return true;
                        }
                    }
                }
            }
            return false;
        };
        this.descendant = function () {
            if (scope.children) {
                var i;
                for (i = 0; i < arguments.length; i++) {
                    if (scope.children[arguments[i]]) {
                        return true;
                    }
                }
            }
            return false;
        };

        this.nodes = function () {
            var nodes = [],
                child;
            if (scope.children) {
                for (child in scope.children) {
                    if (scope.children.hasOwnProperty(child)) {
                        nodes.push(child);
                    }
                }
            }
            return nodes;
        };

        this.newContext = function (context) {
            return new Context(scope, context instanceof Context ? context.ctx : context);
        };

        this.newProxy = function (receiver, target, matcher, options) {
            if (arguments.length > 2) {
                return new MessageNodeProxy(scope, receiver, target, matcher, options);
            }
            // For MessageNode itself as the target...
            return new MessageNodeProxy(scope, receiver, scope, function (func) {
                return idx(["type", "root", "parent", "ancestor", "descendant", "nodes", "origin", "dump"], func) === -1 ? null : undefined; // null: not proxied, undefined: proxied, but no extra arguments for proxied function
            }, options || { tag: scope.tag, prefixMessage: true });
        };

        this.newMessage = function (message, processor) {
            // public!
            var messages = createMessages(message, processor);
            return messages.length === 1 ? messages[0] : messages;
        };

        function createMessage(message, processor) {
            // always returns a *new* single message!
            var relay = typeof processor === "boolean" && processor;

            if (str(message)) {
                message = { action: message };
            }

            // Allow origin and tag from passed in message to support relaying of messages...
            var origin = relay && message && message.origin || scope.name,
                tag = relay && message && message.tag || scope.tag;

            // May return a new "empty" message if "message" is undefined...
            message = scope.factory.create(message); // no context yet, not until we actually post...

            if (!message) {
                // null or undefined
                throw new Error("No message to post");
            }

            // Specify this node...
            message.sender = scope.name;

            // Origin/tag: supplied one, if any, on relay, otherwise this node...
            message.origin = origin;
            message.tag = tag;

            // Post processing of "message" after creation? This allows "plugins" to alter message to their needs, for example
            // a network using a specific tag...
            if (fn(processor)) {
                processor("after", message, scope);
            }

            // Make sure protocol actions are not enqueued except composite (and those from networks, since
            // it handles queuing explicitly)...
            if (Actions.protocol(message) && message.action !== Actions.COMPOSITE) {
                Selectors.add(message, Selectors.NO_QUEUE);

                // Enqueue message for now, at this node? Can be dequeued using "node.enqueue(false)"...
            } else if (enqueue) {
                Selectors.add(message, Selectors.QUEUE);
            }

            // Add default selectors, if any...
            if (defaults.selectors) {
                Selectors.add(message, defaults.selectors);
            }

            return message;
        }

        // Create messages, one for each "message.receiver", and though each message is logically the same message,
        // it will be assigned a unique id, so the sender can trace which recipients responded...
        function createMessages(message, processor, defReceiver) {
            var receiver,
                messages = [],
                msg,
                i;
            // Pre processing of *original* "message" before a new message(s) is/are created based on it? This allows
            // "plugins" to alter message to their needs, for example adding receivers to the message. It also allows
            // a user to specify how a message should be created...
            if (fn(processor)) {
                if (msg = processor("before", message, scope)) {
                    message = msg;
                }
            }

            // Find array of receivers: a message will be created for each one...
            var receivers = message && message.receiver || defReceiver;
            if (!itr(receivers)) {
                receivers = [receivers];
            }

            for (i = 0; i < receivers.length; i++) {
                if (receiver = receivers[i]) {
                    // Create *new* message...
                    msg = createMessage(message, processor); // this calls "processor("after", ..) for spawned message
                    msg.id = scope.factory.id();
                    msg.receiver = receiver;
                    messages.push(msg);
                }
            }
            return messages;
        }

        function postSingle(message, processor) {
            var msg,
                steps,
                entry = {},
                i;
            // Single logical message, but different physical ones will be sent to each receiver...
            message = createMessages(message, processor, defaults.receiver);
            for (i = 0; i < message.length; i++) {
                msg = message[i];
                steps = scope.dispatcher.dispatch(msg, "post");
                // Index message by both id and receiver for easy reference...
                entry[msg.id] = entry[msg.receiver] = { message: msg, steps: steps };
            }
            return entry;
        }

        // Undefined behaviour if different/distinct receivers are used per message, "union" assumed. This
        // also allows just the *first* of the messages to specify the receiver(s)...
        function postComposite(messages, processor) {
            if (messages.length === 1) {
                return postSingle(messages[0], processor);
            }
            var data = [],
                receivers = [],
                unique = {},
                message,
                msg,
                receiver,
                i,
                j,
                defReceiver = defaults.receiver;
            for (i = 0; i < messages.length; i++) {
                // First message will default to actual default receivers, but additional ones must default to the
                // receivers for the first message, or composite messages will also be sent to the default receiver...
                message = createMessages(messages[i], processor, defReceiver);
                if (!i) {
                    defReceiver = [];
                }
                for (j = 0; j < message.length; j++) {
                    msg = message[j];
                    data.push(msg);
                    unique[msg.receiver] = 1;
                    if (!i) {
                        defReceiver.push(msg.receiver);
                    }
                }
            }
            for (receiver in unique) {
                if (unique.hasOwnProperty(receiver)) {
                    receivers.push(receiver);
                }
            }
            return postSingle({ action: Actions.COMPOSITE, data: data, receiver: receivers }); // relay already handled
        }

        this.enqueue = function (onOff) {
            if (typeof onOff !== "undefined" && onOff !== enqueue) {
                if (!(enqueue = onOff)) {
                    queue.dequeueAll(true); // dequeue all messages enqueued with a QUEUE selector...
                }
            }
            return enqueue;
        };

        this.post = function (message, processor, interval, ignoreInLog) {
            // negative interval: one-time abs delay, positive: periodic interval, starting "now"
            if (scope.type() === "closed") {
                if (!options.ignorePostAfterClosed) {
                    scope.err("Message node closed: #", scope.name, ": ", scope); // will raise an Error...
                }
                return null;
            } else if (typeof processor === "number") {
                ignoreInLog = interval;
                interval = processor;
                processor = null;
            }

            var entry,
                timer = false,
                delay = false,
                i;
            if (typeof interval === "number" && interval !== 0) {
                timer = true;
                // A negative interval means a one-time delay before posting...
                if (interval < 0) {
                    interval = -interval;
                    delay = true;
                }
            }

            if (!delay) {
                entry = itr(message) ? postComposite(message, processor) : postSingle(message, processor);
            }

            if (timer) {
                var clearTimer = function clearTimer() {
                    if (timer) {
                        scope.global.ctx.clearInterval(timer);
                        entry.timer = timer = null;
                    }
                    if (ignoreInLog) {
                        var i = idx(options.log.ignore, message.action);
                        if (i !== -1) {
                            options.log.ignore.splice(i, 1);
                        }
                    }
                };
                // Context can simply null "entry.timer" to stop the timer...


                if (typeof ignoreInLog === "undefined") {
                    ignoreInLog = true;
                }
                // Since this message will be posted repeatedly, we might want to ignore it in the log...
                if (ignoreInLog) {
                    i = idx(options.log.ignore, message.action);
                    if (i === -1) {
                        options.log.ignore.push(message.action);
                    }
                }

                entry.timer = timer = scope.global.ctx.setInterval(function () {
                    if (entry.timer && scope.type() !== "closed") {
                        entry.last = scope.post(message, processor);
                        if (delay) {
                            clearTimer();
                        }
                    } else {
                        clearTimer();
                    }
                }, interval);
            }
            return entry;
        };

        this.reply = function (received) {
            // reply(received, data, action, selectors) OR reply(received, [{action: .., data: ..}, {..}, .., {..}])
            var message;
            if (itr(arguments[1])) {
                message = arguments[1]; // composite
            } else {
                message = { data: arguments[1], action: arguments[2] || received.action, selectors: arguments[3] };
            }
            // Add processor to attach receiver and correlation id to each message to reply with...
            return scope.post(message, function (type, message) {
                if (type === "before") {
                    message.receiver = received.origin;
                    message.correlationId = received.id;
                }
            });
        };

        this.bind = function (message, processor, interval) {
            return function () {
                return scope.post(message, processor, interval);
            };
        };

        this.close = function (descendant, type) {
            // Already closed?
            if (scope.type() === "closed") {
                return scope;
            }

            // Close a descendant of ours? This will only succeed if the child in question is
            // actually a descendant, and is needed to close (at least) worker children...
            if (str(descendant) || itr(descendant)) {
                // also called on "unload" with Event as argument
                return scope.post({ action: Actions.CLOSE, data: "force", receiver: descendant });
            }

            // Removed exported node if exported and clear if from global map of nodes...
            NODES.remove(scope.name);

            // Remove event handlers...
            scope.global.off();
            scope.context.off();
            scope.parentContext.off();

            // Close connector...
            if (connector) {
                connector.close();
            }

            // Array of "leave" actions, one for each child of this node + this node itself...
            var messages = [],
                parentHandler = scope.parentHandler.ready();

            // Send to children that this node has been closed and then close handlers - we cannot start
            // closing handlers until all messages have been sent, since handlers are unordered. Since the
            // closing will close handlers, we have to notify our descendants explicitly first with a LEAVE
            // action, or they will never get it, since an ALL message will always bubble up to the root
            // before being actually dispatched, at which time this node is closed and no messages can
            // pass through it to its children...
            if (scope.children) {
                scope.post({ action: Actions.LEAVE, data: type || "self", receiver: Receivers.CHILDREN, selectors: Selectors.ALL });
                scope.post({ action: Actions.CLOSE, data: type || "self", receiver: Receivers.CHILDREN });

                var child, childHandler;
                for (child in scope.children) {
                    if (scope.children.hasOwnProperty(child)) {
                        childHandler = scope.children[child];
                        // If we have any children, at least one will be a direct one, and closing it will close
                        // the shared ones as well...
                        if (childHandler.is(child)) {
                            childHandler.close();
                        }
                        // Ok to push here, since any child below this node will be affected by this node being closed. If no
                        // ready parent handler is available, we cannot post anything...
                        if (parentHandler) {
                            messages.push({ action: Actions.LEAVE, origin: child, data: type || "self", receiver: Receivers.ALL });
                        }
                    }
                }
                scope.children = null;
            }

            // Send to parent that this node has been closed. The parent handler will ever only be ready if
            // we have parents, i.e. if it has been acknowledged...
            if (parentHandler) {
                type = type === "force" ? "self" : type || "self";
                // Post "leave" message for this node and for all possible (closed) children *before* we post "close" message to parent, or
                // this message will be ignored...
                messages.unshift({ action: Actions.LEAVE, data: type, receiver: Receivers.ALL });
                scope.post(messages, true); // relay as for each child

                // Post "close" message...
                scope.post({ action: Actions.CLOSE, data: type, receiver: Receivers.PARENT }); // can never force an ancestor...
            }

            // Always close, even if not ready...
            scope.parentHandler.close();
            scope.parents = null; // null here for better logging in the above statement!

            if (scope.parentPoster) {
                // TODO: we did not use to close the parent poster here? Oversight, or intentional?
                scope.parentPoster.close();
            }

            scope.type = function () {
                return "closed";
            };

            // Purge queue...
            queue.purgeAll();

            return scope;
        };

        this.dump = function () {
            var oldLog,
                child,
                childHandler,
                i,
                qualified,
                allActions = function () {
                var count = {},
                    name,
                    names = [],
                    i;
                function action(target, path) {
                    var t, p;
                    if (target) {
                        for (name in target) {
                            if (target.hasOwnProperty(name)) {
                                t = target[name];p = path ? path + "." + name : name;
                                if (obj(t)) {
                                    action(t, p);
                                } else {
                                    count[p] = (count[p] || 0) + 1;
                                }
                            }
                        }
                    }
                }
                // i = 1: do not include internal callbacks, only user defined ones...
                for (i = 1; i < actions.length; i++) {
                    action(actions[i].on);
                }
                for (name in count) {
                    if (count.hasOwnProperty(name)) {
                        names.push(name);
                    }
                }
                if (fn(names.sort)) {
                    names.sort();
                }
                return { names: names, count: count };
            }();

            if (!scope.log.will("log")) {
                oldLog = scope.log.config({ log: true });
            }

            scope.log("Message node:       ", scope);

            for (i = 0; i < allActions.names.length; i++) {
                scope.log("Action:             ", Receivers.name(scope.name), ".on.", allActions.names[i], " (", allActions.count[allActions.names[i]], ")");
            }

            scope.log("Origins:            ", origins);
            scope.log("Node global:        ", scope.global);
            scope.log("Node context:       ", scope.context);

            scope.log("Parent context:     ", scope.parentContext);
            scope.log("Parent poster:      ", scope.parentPoster || "none");
            scope.log("Parent handler:     ", scope.parentHandler);

            scope.log("Node connector:     ", connector);
            scope.log("Message queue:      ", queue);
            scope.log("Message factory:    ", scope.factory);
            scope.log("Message dispatcher: ", scope.dispatcher);
            scope.log("Log:                ", scope.log.toString());

            if (scope.children) {
                for (child in scope.children) {
                    if (scope.children.hasOwnProperty(child)) {
                        childHandler = scope.children[child];
                        qualified = childHandler.qualified(child);
                        if (qualified.origin !== origins.origin()) {
                            scope.log("Child handler (xd): ", qualified.name, " at '", qualified.origin, "' -> ", childHandler);
                        } else {
                            scope.log("Child handler:      ", qualified.name, " -> ", childHandler);
                        }
                    }
                }
            }

            scope.log("Have a nice day! :)");
            if (oldLog) {
                scope.log = oldLog;
            }
            return scope; // neat when called from the console
        };

        this.toString = function () {
            var s = "MessageNode[name: #" + scope.name + "; tag: " + scope.tag + "; type: " + scope.type() + "; env: " + scope.env,
                child,
                first = true;

            if (origins.origin()) {
                s += "; origin: '" + origins.origin() + "'";
            }

            s += "; default-receiver: " + Receivers.name(defaults.receiver);

            if (scope.parents) {
                s += "; parent: #" + join(scope.parents, "(*).#");
            }
            if (scope.children) {
                s += "; children: [";
                for (child in scope.children) {
                    if (scope.children.hasOwnProperty(child)) {
                        if (first) {
                            first = false;
                        } else {
                            s += ", ";
                        }
                        s += scope.children[child].qualified(child).name;
                    }
                }
                s += "]";
            }
            if (queue.size()) {
                s += "; queue: " + queue;
            }
            return s + "; channels: " + options.channels + "]";
        };

        // Create handler to post messages to the parent node, but note that we do not have the actual
        // postable (port) to use yet if channels are used, not until we have connected. The
        // MessageNodeConnector will set/update with the proper postable upon connect attempts.
        // If "options.type" is "root", the handler will never be connected...
        this.parentHandler = new MessageHandler(scope, options, "->parent", origins, null, { post: true }, scope.parent);
        this.parentHandler.targetOrigin(origins.parent());

        // Create connector to establish parent/child connections, if any...
        connector = new MessageNodeConnector(scope, options, origins);

        // Make sure this node listen for "unload" events (has no effect within workers)...
        if (scope.env !== "worker") {
            scope.global.on("unload", function () {
                scope.close(null, "global");
            });
        }

        NODES.add(scope.name, scope, options.eksport);

        // Unless the node type is explicitly set to "root" here, try and connect to the parent node.
        // Even if "connect" is not called, the connector will still listen for incoming requests
        // unless the type is set to "leaf" at this point...
        if (options.type !== "root") {
            // respect *initial* type!
            connector.connect();
        }
    }

    MessageNode.options = function (options) {
        if (!options) {
            options = {};
            // If "options" is a string, assume a node name for convenience...
        } else if (str(options)) {
            options = { name: options };
        }
        // Update options with "tag" and "name", since options may be used by other types as well..
        if (!options.tag) {
            options.tag = "@zmags";
        }
        if (!options.name) {
            options.name = self.name || "node" + now();
        }
        return options;
    };

    // Factory method that will *not* re-create a given node if it already exist for the global scope...
    MessageNode.create = function (options) {
        // Create default options, if none supplied...
        options = MessageNode.options(options);
        var entry = NODES.get(options.name);
        return entry ? entry.object : new MessageNode(options); // constructor creates an entry in NODES
    };

    //
    // PROXY
    //


    function MessageNodeProxy(node, receiver, target, matcher, options) {
        var scope = this,
            functions = {},
            actions = {},
            func,
            args;

        if (obj(matcher)) {
            options = matcher;
            matcher = null;
        }

        this.tag = options.tag || node.tag + "_proxy_" + now();

        var noResult = options.noResult || node.options("noResult") || MessageNode.NO_RESULT;

        // Incoming: Expose functions that can be proxied on *this* node (actually "node"), so a remote node
        // can act as a proxy for them. Each function will be supplied the message data as arguments, and
        // the result will be returned as message data...
        function proxiedFunction(action) {
            functions[action] = function (message) {
                return target[action].apply(target, message.data);
            };
        }
        for (func in target) {
            if (target.hasOwnProperty(func) && fn(func)) {
                if (!matcher || matcher(func, target) !== null) {
                    proxiedFunction(func);
                }
            }
        }
        node.on(functions, target);

        // Outgoing: prime this proxy with similar named functions, to post messages to the proxied node(s) and
        // expect a corresponding result...
        function closure(action, args) {
            // Post request for proxied function...
            scope[action] = function () {
                return node.post({ tag: scope.tag, action: action, data: forward(scope, arguments, args), receiver: receiver, selectors: Selectors.REPLY + Selectors.NO_QUEUE });
            };
            // Receive result...
            actions[action] = function (message) {
                var args = message.data === noResult ? undefined : message.data;
                if (!itr(args)) {
                    args = [args];
                }
                if (options.prefixMessage) {
                    args.unshift(message);
                }
                if (options.postfixMessage) {
                    args.push(message);
                }

                target[action].apply(target, args);
            };
        }

        for (func in target) {
            if (target.hasOwnProperty(func) && fn(func)) {
                if (!matcher || (args = matcher(func, target)) !== null) {
                    closure(func, args);
                }
            }
        }
        node.on(actions, scope, function (message) {
            return message.tag === scope.tag;
        });

        node.factory.handle(scope, true);

        this.close = function () {
            node.factory.handle(scope, false);
            node.off(actions);
            node.off(functions);
        };

        this.toString = function () {
            var s = "MessageNodeProxy[target-node: " + Receivers.name(receiver) + "; target: " + target;
            if (scope.tag !== node.tag) {
                s += "; tag: " + scope.tag;
            }
            return s + "]";
        };
    }

    //
    // LOG
    //


    // Factory method that creates a log to use...
    function createLog(node, options) {

        // Notational short-cuts...
        if (options.log) {
            if (str(options.log)) {
                // err added by default below...
                if (options.log === "log") {
                    options.log = { log: true };
                } else if (options.log === "err") {
                    options.log = {};
                } else if (options.log === "verbose") {
                    options.log = { log: true, verbose: true };
                }
            } else if (!obj(options.log)) {
                options.log = { log: options.log, err: options.log };
            }
        } else if (!obj(options.err)) {
            options.log = { err: options.err }; // enable "err" by default...
            delete options.err;
        }
        // Enable "err" by default if not configured...
        if (typeof options.log.err === "undefined") {
            options.log.err = true;
        }

        // Message actions to ignore during logging since known to flood the log, e.g. pings...
        if (str(options.log.ignore)) {
            options.log.ignore = [options.log.ignore];
        } else if (typeof options.log.ignore === "undefined") {
            options.log.ignore = [];
        }

        var legacy = node.global.legacy(),
            tag = "[" + (options.tag || node.tag) + ":" + (options.log.name || options.name || node.name) + "]";

        // Required since for example no Event type in Worker implementation...
        function evt(o) {
            try {
                return o && (is(o, "Event") || typeof o.srcElement !== "undefined");
            } catch (e) {
                // SecurityError
                return false;
            }
        }

        // Required since (some version of ?) Firefox apparently throws a "wrapped native prototype object" instead of an Error
        // when cross domain communication fails...
        function error(o) {
            try {
                return o && (is(o, "Error") || str(o.name) && idx(o.name, "Error") !== -1 && typeof o.message !== "undefined");
            } catch (e) {
                // SecurityError
                return false;
            }
        }

        function format(args) {
            var msg = { prefix: tag + " <" + ++sequence + "> -", text: "", message: null, error: null, event: null },
                i,
                j,
                arg;

            // Explode if arguments contains a nested array as the single argument...
            if (itr(args[0]) && args.length === 1) {
                args = args[0];
            }

            for (i = 0; i < args.length; i++) {
                arg = args[i];
                if (typeof arg !== "undefined") {
                    if (arg instanceof Message) {
                        msg.message = arg;

                        // Configure actions to ignore during logging to avoid flooding the log...
                        for (j = 0; j < options.log.ignore.length; j++) {
                            if (options.log.ignore[j] === arg.action) {
                                return {}; // nothing to log!
                            }
                        }
                    } else if (error(arg)) {
                        msg.error = arg;
                        arg = def("Error") ? Error.prototype.toString.call(arg) : arg.toString();
                    } else if (evt(arg)) {
                        msg.event = arg;
                        continue; // do not log this as part of the message...
                    }
                    msg.text += Context.val(arg, null, "[???]");
                }
            }

            // To not add prefix to an already prefixed messages, i.e. a relayed message from a worker or console-less environment...
            if (idx(msg.text, "[" + node.tag + ":") === 0) {
                msg.prefix = null;
                sequence--;
            }
            return msg;
        }

        // Used configured out (out.info(..) and out.error(..)) or standard window console...
        var konsole = options.log.out || node.global.ctx.console; // may be undefined!

        // Standard out function logging to the console. The test for prefix is to allow relayed log messages to be
        // handled nicely. Cannot use "apply" and "call" on console function, e.g. "info", because of IE legacy issues...
        function out(type, prefix, msg, relayedOnly) {
            if (!prefix) {
                konsole[type](msg);

                // Prefix means local node...
            } else if (!relayedOnly) {
                if (legacy) {
                    // FIXME: also on Ipad!
                    konsole[type](prefix + " " + msg); // has to use + since , not supported well in legacy browsers when called like this...
                } else {
                    konsole[type](prefix, msg); // to support logging objects...
                }
            }
        }

        // Relay log message to parent node...
        function relay(type, prefix, msg) {
            // Include prefix, since when logged at some parent node, said node will otherwise include its own prefix...
            if (prefix) {
                msg = prefix + " " + msg;
            }
            // Relay directly using bogus id, i.e. "log" or "err"!...
            if (node.parentPoster) {
                // TODO: this will fail if closed, no?
                node.parentPoster.post(node.newMessage({ id: type, action: type, data: msg, receiver: Receivers.PARENT }));
            }
        }

        function configure(option, type) {
            var value = options.log[option]; // option: "log" or "err"
            // No logging...
            if (!value || value === "off") {
                return null;

                // Relay to parent node if so configured, but always for workers (unless off) since they have no console.
                // If explicitly configured as a root, we treat relay as "on"...
            } else if (options.type !== "root" && (value === "relay" || node.env === "worker")) {
                return function doRelay(prefix, msg) {
                    relay(option, prefix, msg);
                }; // "log"/"err"

                // Output function as-is...
            } else if (fn(value)) {
                return value;

                // Probably some IE in non-debugging mode, i.e. console not even declared...
            } else if (typeof konsole === "undefined") {
                return null;
            }
            // "value" is some truthy value here or "relayOnly"...
            return function doOut(prefix, msg) {
                out(type, prefix, msg, value === "relayOnly");
            }; // "info"/"error"
        }

        // Configure how log and error messages are logged, individually. This allows for example error messages for
        // a worker context to be logged, while normal log messages need not be...
        var log = configure("log", "info"),
            err = configure("err", "error"),
            verbose = options.log.verbose,
            sequence = 0;

        function logger() {
            var msg;
            if (log) {
                msg = format.call(format, arguments);
                if (msg.text) {
                    log(msg.prefix, msg.text, log); // String
                }
                if (verbose) {
                    if (msg.message) {
                        log(msg.prefix, msg.message, log);
                    }
                    if (msg.event) {
                        log(msg.prefix, msg.event, log); // Event/Object
                    }
                }
            }
            return msg;
        }

        logger.will = function (type) {
            switch (type) {
                case "log":
                    return log !== null;
                case "err":
                    return err !== null;
                case "verbose":
                    return typeof verbose !== "undefined" && verbose;
                    return false;
            }
        };

        logger.verbose = function () {
            var msg;
            if (verbose) {
                msg = logger.apply(logger, forward(node, arguments));
            }
            return msg;
        };

        logger.err = function () {
            var msg;
            if (err) {
                msg = format.call(format, arguments);
                var error = msg.error ? msg.error : new Error(msg.text),
                    stack;
                // Only log text if we have a specific error as well, since the Error created above will log
                // the text anyway...
                if (msg.text && msg.error) {
                    err(msg.prefix, msg.text, err); // String
                }
                // Stack not always available and will not always contain the actual error message...
                stack = error.stack;
                if (stack) {
                    stack = stack.toString();
                    if (idx(stack, error.message) === -1) {
                        err(msg.prefix, error + " " + stack, err); // Error+stack
                    } else {
                        err(msg.prefix, stack, err); // stack
                    }
                } else {
                    err(msg.prefix, error, err); // Error/Object
                }
                if (msg.message) {
                    err(msg.prefix, msg.message, err); // Message
                }
                if (msg.event) {
                    err(msg.prefix, msg.event, log); // Event/Object
                }
            }
            return msg;
        };

        logger.format = format; // e.g. to format messages to be sent as data

        // Re-configure logger at runtime...
        logger.config = function (opts) {
            var old = node.log;node.log = createLog(node, opts);return old;
        };

        logger.toString = function () {
            return "Log[tag: " + tag + "; log: " + (options.log.log || false) + "; err: " + (options.log.err || false) + "; verbose: " + (verbose || false) + "]";
        };
        return logger;
    }

    //
    // EXPOSE
    //

    MessageNode.NO_RESULT = "*no_result*";

    // Since MessageNode can run in various different environments, we also expose the utility functions needed to
    // handle such varieties, so "plugins" can make use of them as well...
    MessageNode.Fn = { def: def, is: is, obj: obj, fn: fn, str: str, join: join, idx: idx, itr: itr, forward: forward, copy: copy };
    // Expose Message type publicly, also relevant for AMD support...
    MessageNode.Message = Message;
    // Expose Origins publictly to make it somewhat easier to work with normalised origins...
    MessageNode.Origins = Origins;

    // Expose Actions, Receivers, and Selectors publicly...
    Message.Actions = copy(Actions); // copy, so "protocol" still works if more actions are added by "plugins"!
    Message.Receivers = Receivers;
    Message.Selectors = Selectors;

    (function () {

        // MessageNode.Message holds Message type, Message holds Receivers and Selectors types...
        function amd(scope) {
            var dfine = scope ? scope.define : "function" !== "undefined" && __webpack_require__(1199); // latter when declared as "var define"...
            if (fn(dfine) && dfine.amd) {
                dfine("message_node", [], function () {
                    return MessageNode;
                });
                return false;
            }
            return true;
        }

        if (( false ? "undefined" : _typeof(exports)) == 'object') {
            module.exports = MessageNode;
        } else if (typeof universe !== "undefined") {
            var ctx = path(self, universe);
            if (amd(ctx)) {
                // foo.bar.define
                ctx.MessageNode = MessageNode; // foo.bar.MessageNode
            }
        } else if (amd()) {
            // var define, likely ours, i.e. bundled/optimized
            amd(self); // self.define
            // self.MessageNode - we expose this here as well, since it is likely it is not our require at self.require!
            if (typeof self.MessageNode === "undefined") {
                self.MessageNode = MessageNode;
            }
        }
    })();
})(self, self.____message_node_scope);

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        FontLoader = __webpack_require__(260),
        ImprovedView = __webpack_require__(6),
        SceneViewer = __webpack_require__(707),
        Rectangle = __webpack_require__(248),
        template = __webpack_require__(706);

    /**
     * View model for the scene thumbnail.
     *
     * @class SceneThumbnailViewModel
     * @constructor
     */
    var SceneThumbnailViewModel = Backbone.Model.extend({
        defaults: {
            experience: null,
            viewportVisibility: new Rectangle(0, 0, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY)
        }
    });

    /**
     * A scene thumbnail "viewer". Renders a scene with some defined maximum size.
     *
     * @class SceneThumbnailViewer
     * @constructor
     *
     * @cfg {Scene} model The scene to display in the thumbnail.
     * @cfg {ExperienceModel} experience The parent experience.
     * @cfg {Object} [maxDimensions] Optional max dimensions to scale the viewer to. If specified, must contain width, height, or both.
     */
    return ImprovedView.extend({

        className: "scene-thumbnail experience-container",

        template: template,

        ui: {
            sceneWrapper: ".scene-wrapper-inner"
        },

        _experience: null,

        /**
         * @type {SceneViewer}
         */
        _overlayViewer: null,

        /**
         * @type {SceneViewer}
         */
        _sceneViewer: null,

        /**
         * @type {SceneViewer}
         */
        _backgroundViewer: null,

        initialize: function initialize() {
            this._experience = this.options.experience;
        },

        onRender: function onRender() {
            var _this = this;

            FontLoader.loadSceneFonts(this.model, this._experience).always(function () {
                if (_this.isClosed) {
                    return;
                }

                var viewModel = new SceneThumbnailViewModel({ experience: _this._experience });

                _this._sceneViewer = new SceneViewer({
                    model: _this.model,
                    viewModel: viewModel,
                    enableAnimations: false,
                    maxDimensions: _this.options.maxDimensions
                });

                var size = _this._sceneViewer.getSize();

                _this.ui.sceneWrapper.width(size.scaledWidth);
                _this.ui.sceneWrapper.height(size.scaledHeight);
                _this.ui.sceneWrapper.append(_this._sceneViewer.render().el);
                _this._sceneViewer.trigger("show");

                if (_this.options.showStaticScenes) {
                    _this._overlayViewer = new SceneViewer({
                        model: _this._experience.get("overlayScene"),
                        viewModel: viewModel,
                        maxDimensions: _this.options.maxDimensions
                    });

                    _this.ui.sceneWrapper.append(_this._overlayViewer.render().el);
                    _this._overlayViewer.trigger("show");

                    _this._backgroundViewer = new SceneViewer({
                        model: _this._experience.get("backgroundScene"),
                        viewModel: viewModel,
                        maxDimensions: _this.options.maxDimensions
                    });

                    _this.ui.sceneWrapper.prepend(_this._backgroundViewer.render().el);
                    _this._backgroundViewer.trigger("show");
                }
            });
        },

        onClose: function onClose() {
            // Make sure to properly close the viewer instances - they were appended
            // to the DOM outside of the normal (Marionette) lifecycle.
            if (this._overlayViewer) {
                this._overlayViewer.close();
            }

            if (this._sceneViewer) {
                this._sceneViewer.close();
            }

            if (this._backgroundViewer) {
                this._backgroundViewer.close();
            }
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var Promise = __webpack_require__(21);
    var $ = __webpack_require__(4);

    /**
     * Enables execution of multiple actions in sequence. Actions are executed in the order
     * they are added.
     *
     * @class ActionSequence
     * @see  util/Action
     *
     * @author Kim
     */
    return Class.extend({

        _actions: null,

        /**
         * Constructor.
         *
         * @param  {Action[]} actions Optional array of <tt>Action</tt>'s.
         */
        constructor: function constructor(actions) {
            this._actions = actions || [];
        },


        /**
         * Adds a new action.
         *
         * @param {Action} action Action that will be executed.
         */
        add: function add(action) {
            this._actions.push(action);

            return this;
        },


        /**
         * Starts execution.
         *
         * First added action will be executed immediately, once the action's deferred object has been
         * resolved (successful execution), the next action is executed and so forth.
         *
         * @return {Promise} Promise that resolves, with an array of all resolved values, once all actions
         *                           have been successfully executed/resolved.
         */
        execute: function execute() {
            var actions = this._actions;

            return Promise.deferred(function (deferred) {
                var firstAction = actions.shift();
                var results = [];
                var add = function add(deferred) {
                    deferred.then(function (value) {
                        return results.push(value);
                    });

                    return deferred;
                };

                var when = add($.when(firstAction.execute()));

                while (actions.length) {
                    when = add(when.then(actions.shift().execute));
                }

                when.done(deferred.resolve.bind(deferred, results));
            }).promise();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var ExperienceModel = __webpack_require__(58);
    var RestApi = __webpack_require__(29);
    var ImprovedModel = __webpack_require__(25);
    var SyncManager = __webpack_require__(44);

    var DEFAULT_DESCRIPTION = "(New Template)";

    /**
     * The experience template model.
     *
     */
    var TemplateModel = ImprovedModel.extend("TemplateModel", {

        defaults: {
            id: null, // ObjectId
            name: null, // String
            description: DEFAULT_DESCRIPTION,
            content: null, // JSON of ExperienceModel
            companyId: null, // ObjectId
            createdAt: null, // Number(int)
            createdBy: null, // ObjectId
            globallyAccessible: null, // Boolean
            version: null // Number(int)
        },

        relations: [{
            type: Backbone.One,
            key: "content",
            relatedModel: ExperienceModel
        }],

        url: function url() {
            return this.isNew() ? RestApi.pathToCollection(RestApi.Collections.TEMPLATES) : RestApi.pathToSpecificResource(RestApi.Collections.TEMPLATES, this.id);
        }
    }, {

        DEFAULT_DESCRIPTION: DEFAULT_DESCRIPTION,

        fromExperience: function fromExperience(experienceId) {
            var path = RestApi.pathToSpecificResource(RestApi.Collections.TEMPLATES_PUBLISHABLE, experienceId);

            return SyncManager.getJSON(path, SyncManager.target("TemplateModel.fromExperience")).then(function (json) {
                return new TemplateModel(json);
            });
        }
    });

    return TemplateModel;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(156),
        Backbone = __webpack_require__(7),
        _ = __webpack_require__(1),
        ExperienceURLProvider = __webpack_require__(168);

    /**
     * Action that navigates to a specified experience.
     */
    return Action.extend({

        _sceneNumber: null,

        constructor: function constructor(sceneNumber) {
            this.__super();

            this._sceneNumber = sceneNumber || 1;
        },

        _performExecution: function _performExecution(experience, options) {
            if (typeof experience === "undefined") return;

            var id = _.isString(experience) ? experience : experience.get("id");

            if (id) {
                if (options && options.navigateTo) {
                    id = options.navigateTo.get("id");
                }

                this._navigate(this._getUrl(id));
            }
        },

        _getUrl: function _getUrl(experienceId) {
            return ExperienceURLProvider.provide(experienceId, ExperienceURLProvider.ACTION.EDIT, this._sceneNumber);
        },

        _navigate: function _navigate(url) {
            Backbone.history.navigate(url, { trigger: true, replace: true });
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Preconditions = __webpack_require__(14);

    var ELEMENT_NODE = 1,
        TEXT_NODE = 3;

    var DomHandler = {

        clearSelection: function clearSelection() {
            // Taken from:
            // http://stackoverflow.com/questions/3169786/clear-text-selection-with-javascript
            if (window.getSelection) {
                if (window.getSelection().empty) {
                    // Chrome
                    window.getSelection().empty();
                } else if (window.getSelection().removeAllRanges) {
                    // Firefox
                    window.getSelection().removeAllRanges();
                }
            } else if (document.selection) {
                // IE?
                document.selection.empty();
            }
        },

        /**
         * Similar to `applyStyle`, only that it removes the style from the
         * selection (and all children).
         *
         * @param {jQuery} $el   - The jQuery parent.
         * @param {String} style - Css property that will be removed from the
         *                         elements.
         */
        removeStyle: function removeStyle($el, style) {
            Preconditions.is$element($el);
            Preconditions.isString(style);

            $el.find("div").css(style, "");
            DomHandler.removeAllSpanStyle($el[0].children, style);
        },

        /**
         * Removes all the spans with the style, assuming that each span can
         * only have one style.
         *
         * @param {Element[]} elements  jquery $els
         * @param {Object} style        the style to be matched
         */
        removeAllSpanStyle: function removeAllSpanStyle(elements, style) {
            var element,
                len = elements.length;

            while (len--) {
                element = elements[len];
                DomHandler.removeAllSpanStyle(element.children, style);

                if (element instanceof HTMLSpanElement && element.style[style]) {
                    element.outerHTML = element.innerHTML;
                }
            }
        },

        /**
         * getElementsBetweenNodes will return an unordered array of elements
         * between two arbitrarily positioned nodes in the dom. However, it all
         * siblings contained in a parent are included, then it will included
         * none of the siblings, but instead only their parent.
         *
         * The order of the two nodes passed in is important. The first node
         * must occur first in the DOM.
         *
         * @param {Node} startNode  - First node.
         * @param {Node} endNode    - Second node.
         * @return {Elements[]}     - Array of all elements between the two
         *                            nodes.
         *
         *
         * Example:
         *
         * Let's say we have a tree structure like this, with e, e1, e11, etc
         * being elements. The asterisks indicate elements we expect to be
         * included in the return value.
         *
         *  e
         *      e1
         *          e11
         *         *e12
         *              e121
         *                  e1211       <-- walk from here
         *                  e1212
         *              e122
         *         *e13
         *     *e2
         *      e3
         *         *e31
         *              e311
         *          e32
         *             *e321
         *             *e322            <-- to here
         *              e323
         *
         * DomHandler.getElementsBetweenNodes(e1211, e322, e)
         * => [e12, e13, e2, e322, e321, e31] // unordered
         *
         *
         */
        getElementsBetweenNodes: function getElementsBetweenNodes(startNode, endNode, commonAncestor) {
            Preconditions.isElementOrTextNode(startNode);
            Preconditions.isElementOrTextNode(endNode);
            Preconditions.isElementOrTextNode(commonAncestor);

            if (startNode === endNode) {
                return [startNode];
            }

            // e1 in the above example
            var startChild = DomHandler._getChildContainingNode(startNode, commonAncestor),


            // e3 in the above example
            endChild = DomHandler._getChildContainingNode(endNode, commonAncestor),


            // [e2] in the above example
            inbetweenNodes = DomHandler._getNodesBetweenNodes(startChild, endChild),


            // [e12, e13] in above example
            startElements = DomHandler._getBranchElements(startNode, startChild, "after"),


            // [e322, e321, e31] in above example
            endElements = DomHandler._getBranchElements(endNode, endChild, "before");

            // Concatinate all arrays.
            return startElements.concat(inbetweenNodes).concat(endElements);
        },

        /**
         * Gets the immediate child of an ancestor node that is also parent of
         * the node passed in.
         *
         * Example:
         *
         * Dom structure:
         *  span.a
         *      span.b
         *      span.c
         *          span.d
         *              span.e
         *      span.f
         *
         * _getChildContainingNode(span.e, span.a) => span.c
         * _getChildContainingNode(span.d, span.a) => span.c
         * _getChildContainingNode(span.e, span.c) => span.d
         * _getChildContainingNode(span.b, span.a) => span.b
         * _getChildContainingNode(span.a, span.a) => span.a
         *
         * @private
         * @param {Node} node
         * @param {Node} ancestor
         * @return {Node}
         */
        _getChildContainingNode: function _getChildContainingNode(node, ancestor) {
            Preconditions.isElementOrTextNode(node);
            Preconditions.isElementOrTextNode(ancestor);

            // There is no guarantee that the function was not called with
            // identical nodes.
            if (node === ancestor || node.parentNode === ancestor) {
                return node;
            }

            return DomHandler._getChildContainingNode(node.parentNode, ancestor);
        },

        /**
         * Returns an array of nodes between (not including) the two nodes
         * passed in.
         *
         * Assumes that the two nodes are siblings, and that nodeA is
         * positioned before nodeB.
         *
         * Example:
         *
         * Dom structure:
         *  span.a
         *      span.b
         *  span.c
         *  span.d
         *  span.e
         *  span.f
         *
         *  _getNodesBetweenNodes(span.a, span.c) => []
         *  _getNodesBetweenNodes(span.a, span.d) => [span.c]
         *  _getNodesBetweenNodes(span.c, span.f) => [span.d, span.e]
         *
         * @param {Node} nodeA
         * @param {Node} nodeB
         * @return {Node[]}
         */
        _getNodesBetweenNodes: function _getNodesBetweenNodes(nodeA, nodeB) {
            var elements = [];

            if (nodeA === nodeB) {
                return elements;
            }

            var nextSibling = nodeA.nextSibling;

            while (nextSibling && nextSibling !== nodeB) {
                elements.push(nextSibling);

                nextSibling = nextSibling.nextSibling;
            }

            return elements;
        },

        /**
         * See documentation and example for `getElementsBetweenNodes`. This
         * function walks the dom vertically and grabs siblings (either in
         * front or behind it).
         *
         * @private
         * @param {Node} startNode
         * @param {Node} stopNode
         * @param {String} siblingDirection
         * @param {Boolean} [childrenWasAdded]
         */
        _getBranchElements: function _getBranchElements(startNode, stopNode, siblingDirection, childrenWasAdded) {
            Preconditions.isElementOrTextNode(startNode);
            Preconditions.isElementOrTextNode(stopNode);
            Preconditions.isString(siblingDirection);

            // Guard
            if (startNode === stopNode) {
                return childrenWasAdded ? [] : [startNode];
            }

            // We might pick the next or the previous siblings (depending
            // on which end of the selection we are working with).
            var includedSibling = siblingDirection === "after" ? "nextSibling" : "previousSibling",
                excludedSibling = siblingDirection === "after" ? "previousSibling" : "nextSibling",


            // Container for the returned elements.
            elements = [],


            // The first node to (possibly) be added to elements[]. If
            // children were added, then we should not collect the parent,
            // so we go straight for its (possible) sibling in the
            // direction of inclusion.
            node = childrenWasAdded ? startNode[includedSibling] : startNode,
                parentElements;

            // If we don't have any excluded siblings, then we skip this and
            // just take the entire parent.
            while (node && node[excludedSibling]) {
                elements.push(node);

                childrenWasAdded = true;

                node = node[includedSibling];
            }

            // Recursive call with parent (stops when it reaches `stopNode`).
            parentElements = DomHandler._getBranchElements(startNode.parentNode, stopNode, siblingDirection, childrenWasAdded);

            return elements.concat(parentElements);
        },

        /**
         * For each descendent text node in the passed nodes/elements, return
         * its closest parent element. This is used to computed the styles for
         * text nodes, because we can only get style values from element node.
         *
         * @param {Node[]} nodes
         * @returns {Array} An array of element nodes
         */
        getTextNodeParentList: function getTextNodeParentList(nodes) {
            var elements = [],
                node,
                len = nodes.length,
                i = 0;

            for (; i < len; i++) {
                node = nodes[i];

                if (node.nodeType === TEXT_NODE) {
                    elements.push(DomHandler.getParentElement(node));
                } else {
                    elements = elements.concat(DomHandler.getTextNodeParentList(node.childNodes));
                }
            }

            return elements;
        },

        /**
         * IE does not support parentElement, it only supports parentNode, so we have to do this manually
         * This method assumes that we will always hit an element node before it goes wild.
         *
         * @param {Node} node  the dom node
         */
        getParentElement: function getParentElement(node) {
            Preconditions.isElementOrTextNode(node);

            var parentNode = node.parentNode;

            if (parentNode.nodeType === ELEMENT_NODE) {
                return parentNode;
            }

            return DomHandler.getParentElement(parentNode);
        },

        /**
         * Given an element, get the closest parent element(or itself) for
         * which the style font-family is applied.
         *
         * @param {Element} element
         * @param {Element} container   - This function won't get beyond this.
         * @returns {Element}
         */
        getParentWithFontFamily: function getParentWithFontFamily(element, container) {
            Preconditions.isElement(element);

            if (element === container || element.style && element.style["font-family"]) {
                return element;
            }

            return DomHandler.getParentWithFontFamily(DomHandler.getParentElement(element), container);
        }
    };

    return DomHandler;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["d"] = __values;
/* harmony export (immutable) */ __webpack_exports__["c"] = __read;
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(473), __webpack_require__(42)))

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(1275);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(475);
var GetIntrinsic = __webpack_require__(15);

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

module.exports = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var DefineOwnProperty = __webpack_require__(346);
var isPropertyDescriptor = __webpack_require__(293);
var isSamePropertyDescriptor = __webpack_require__(1291);

var FromPropertyDescriptor = __webpack_require__(237);
var IsAccessorDescriptor = __webpack_require__(169);
var IsDataDescriptor = __webpack_require__(117);
var IsGenericDescriptor = __webpack_require__(480);
var IsPropertyKey = __webpack_require__(64);
var SameValue = __webpack_require__(170);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-validateandapplypropertydescriptor
// https://ecma-international.org/ecma-262/8.0/#sec-validateandapplypropertydescriptor

// eslint-disable-next-line max-lines-per-function, max-statements, max-params
module.exports = function ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current) {
	// this uses the ES2017+ logic, since it fixes a number of bugs in the ES2015 logic.
	var oType = Type(O);
	if (oType !== 'Undefined' && oType !== 'Object') {
		throw new $TypeError('Assertion failed: O must be undefined or an Object');
	}
	if (Type(extensible) !== 'Boolean') {
		throw new $TypeError('Assertion failed: extensible must be a Boolean');
	}
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
	}
	if (Type(current) !== 'Undefined' && !isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, current)) {
		throw new $TypeError('Assertion failed: current must be a Property Descriptor, or undefined');
	}
	if (oType !== 'Undefined' && !IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: if O is not undefined, P must be a Property Key');
	}
	if (Type(current) === 'Undefined') {
		if (!extensible) {
			return false;
		}
		if (IsGenericDescriptor(Desc) || IsDataDescriptor(Desc)) {
			if (oType !== 'Undefined') {
				DefineOwnProperty(
					IsDataDescriptor,
					SameValue,
					FromPropertyDescriptor,
					O,
					P,
					{
						'[[Configurable]]': Desc['[[Configurable]]'],
						'[[Enumerable]]': Desc['[[Enumerable]]'],
						'[[Value]]': Desc['[[Value]]'],
						'[[Writable]]': Desc['[[Writable]]']
					}
				);
			}
		} else {
			if (!IsAccessorDescriptor(Desc)) {
				throw new $TypeError('Assertion failed: Desc is not an accessor descriptor');
			}
			if (oType !== 'Undefined') {
				return DefineOwnProperty(
					IsDataDescriptor,
					SameValue,
					FromPropertyDescriptor,
					O,
					P,
					Desc
				);
			}
		}
		return true;
	}
	if (IsGenericDescriptor(Desc) && !('[[Configurable]]' in Desc) && !('[[Enumerable]]' in Desc)) {
		return true;
	}
	if (isSamePropertyDescriptor({ SameValue: SameValue }, Desc, current)) {
		return true; // removed by ES2017, but should still be correct
	}
	// "if every field in Desc is absent, return true" can't really match the assertion that it's a Property Descriptor
	if (!current['[[Configurable]]']) {
		if (Desc['[[Configurable]]']) {
			return false;
		}
		if ('[[Enumerable]]' in Desc && !Desc['[[Enumerable]]'] === !!current['[[Enumerable]]']) {
			return false;
		}
	}
	if (IsGenericDescriptor(Desc)) {
		// no further validation is required.
	} else if (IsDataDescriptor(current) !== IsDataDescriptor(Desc)) {
		if (!current['[[Configurable]]']) {
			return false;
		}
		if (IsDataDescriptor(current)) {
			if (oType !== 'Undefined') {
				DefineOwnProperty(
					IsDataDescriptor,
					SameValue,
					FromPropertyDescriptor,
					O,
					P,
					{
						'[[Configurable]]': current['[[Configurable]]'],
						'[[Enumerable]]': current['[[Enumerable]]'],
						'[[Get]]': undefined
					}
				);
			}
		} else if (oType !== 'Undefined') {
			DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				{
					'[[Configurable]]': current['[[Configurable]]'],
					'[[Enumerable]]': current['[[Enumerable]]'],
					'[[Value]]': undefined
				}
			);
		}
	} else if (IsDataDescriptor(current) && IsDataDescriptor(Desc)) {
		if (!current['[[Configurable]]'] && !current['[[Writable]]']) {
			if ('[[Writable]]' in Desc && Desc['[[Writable]]']) {
				return false;
			}
			if ('[[Value]]' in Desc && !SameValue(Desc['[[Value]]'], current['[[Value]]'])) {
				return false;
			}
			return true;
		}
	} else if (IsAccessorDescriptor(current) && IsAccessorDescriptor(Desc)) {
		if (!current['[[Configurable]]']) {
			if ('[[Set]]' in Desc && !SameValue(Desc['[[Set]]'], current['[[Set]]'])) {
				return false;
			}
			if ('[[Get]]' in Desc && !SameValue(Desc['[[Get]]'], current['[[Get]]'])) {
				return false;
			}
			return true;
		}
	} else {
		throw new $TypeError('Assertion failed: current and Desc are not both data, both accessors, or one accessor and one data.');
	}
	if (oType !== 'Undefined') {
		return DefineOwnProperty(
			IsDataDescriptor,
			SameValue,
			FromPropertyDescriptor,
			O,
			P,
			Desc
		);
	}
	return true;
};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function every(array, predicate) {
	for (var i = 0; i < array.length; i += 1) {
		if (!predicate(array[i], i, array)) {
			return false;
		}
	}
	return true;
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assertRecord = __webpack_require__(294);

var IsAccessorDescriptor = __webpack_require__(169);
var IsDataDescriptor = __webpack_require__(117);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-isgenericdescriptor

module.exports = function IsGenericDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!IsAccessorDescriptor(Desc) && !IsDataDescriptor(Desc)) {
		return true;
	}

	return false;
};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $gOPD = __webpack_require__(295);
var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(45);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

var has = __webpack_require__(114);

var IsArray = __webpack_require__(116);
var IsPropertyKey = __webpack_require__(64);
var IsRegExp = __webpack_require__(743);
var ToPropertyDescriptor = __webpack_require__(186);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

module.exports = function OrdinaryGetOwnProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	if (!has(O, P)) {
		return void 0;
	}
	if (!$gOPD) {
		// ES3 / IE 8 fallback
		var arrayLength = IsArray(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor($gOPD(O, P));
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1301);


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Day = __webpack_require__(349);
var DayFromYear = __webpack_require__(485);
var YearFromTime = __webpack_require__(350);

// https://262.ecma-international.org/5.1/#sec-15.9.1.4

module.exports = function DayWithinYear(t) {
	return Day(t) - DayFromYear(YearFromTime(t));
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var floor = __webpack_require__(115);

// https://262.ecma-international.org/5.1/#sec-15.9.1.3

module.exports = function DayFromYear(y) {
	return (365 * (y - 1970)) + floor((y - 1969) / 4) - floor((y - 1901) / 100) + floor((y - 1601) / 400);
};



/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $EvalError = GetIntrinsic('%EvalError%');

var DaysInYear = __webpack_require__(750);
var YearFromTime = __webpack_require__(350);

// https://262.ecma-international.org/5.1/#sec-15.9.1.3

module.exports = function InLeapYear(t) {
	var days = DaysInYear(YearFromTime(t));
	if (days === 365) {
		return 0;
	}
	if (days === 366) {
		return 1;
	}
	throw new $EvalError('Assertion failed: there are not 365 or 366 days in a year, got: ' + days);
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DayWithinYear = __webpack_require__(484);
var InLeapYear = __webpack_require__(486);

// https://262.ecma-international.org/5.1/#sec-15.9.1.4

module.exports = function MonthFromTime(t) {
	var day = DayWithinYear(t);
	if (0 <= day && day < 31) {
		return 0;
	}
	var leap = InLeapYear(t);
	if (31 <= day && day < (59 + leap)) {
		return 1;
	}
	if ((59 + leap) <= day && day < (90 + leap)) {
		return 2;
	}
	if ((90 + leap) <= day && day < (120 + leap)) {
		return 3;
	}
	if ((120 + leap) <= day && day < (151 + leap)) {
		return 4;
	}
	if ((151 + leap) <= day && day < (181 + leap)) {
		return 5;
	}
	if ((181 + leap) <= day && day < (212 + leap)) {
		return 6;
	}
	if ((212 + leap) <= day && day < (243 + leap)) {
		return 7;
	}
	if ((243 + leap) <= day && day < (273 + leap)) {
		return 8;
	}
	if ((273 + leap) <= day && day < (304 + leap)) {
		return 9;
	}
	if ((304 + leap) <= day && day < (334 + leap)) {
		return 10;
	}
	if ((334 + leap) <= day && day < (365 + leap)) {
		return 11;
	}
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = __webpack_require__(291)();

module.exports = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(64);
var ToObject = __webpack_require__(490);

// https://ecma-international.org/ecma-262/6.0/#sec-getv

module.exports = function GetV(V, P) {
	// 7.3.2.1
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	// 7.3.2.2-3
	var O = ToObject(V);

	// 7.3.2.4
	return O[P];
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $Object = GetIntrinsic('%Object%');

var RequireObjectCoercible = __webpack_require__(482);

// https://ecma-international.org/ecma-262/6.0/#sec-toobject

module.exports = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function forEach(array, callback) {
	for (var i = 0; i < array.length; i += 1) {
		callback(array[i], i, array); // eslint-disable-line callback-return
	}
};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var browserDetector = __webpack_require__(1387);
    var ANDROID_MIN_SUPPORTED_VERSION = [4];
    var FIREFOX_MIN_SUPPORTED_VERSION = [12];
    var IE_EDITOR_MIN_SUPPORTED_VERSION = [11];
    var IE_VIEWER_MIN_SUPPORTED_VERSION = [9];
    var SAFARI_DESKTOP_MIN_SUPPORTED_VERSION = [6];
    var SAFARI_MOBILE_MIN_SUPPORTED_VERSION = [6];

    /**
     * Detects capabilities of the running browser. <p>
     *
     * For normal use, use <tt>Browser.capabilities</tt> instead of detecting the capabilities over and over.
     *
     * @class BrowserCapabilitiesDetector
     */
    return {

        /**
         * Detects the browser capabilities for the supplied user agent.
         *
         * @param {String}  [userAgent] The user agent, will default to <tt>navigator.userAgent</tt>.
         * @param {Boolean} [editor]    True if in the editor, false for the viewer (default).
         *
         * @return {*} The capabilities determined based on the supplied user agent; never null.
         */
        detect: function detect(userAgent, editor) {
            // TODO: revisit when we find a neat way of diff impl for same type for viewer and editor
            if (typeof userAgent === "boolean") {
                editor = userAgent;
                userAgent = null; // will default below
            }

            userAgent = userAgent || window.navigator.userAgent;

            var detectedBrowser = browserDetector.detect(userAgent);

            /**
             * Checks whether the browser/OS combination is supported, specific to the viewer or editor.
             *
             * @return {Boolean} True if the browser/OS combination is supported, false otherwise.
             */
            function isSupported() {
                if (isUnsupportedOS()) {
                    return false;
                }

                return isSupportedMobileOS() || detectedBrowser.chrome || detectedBrowser.googlebot || isSupportedFirefoxBrowser() || isSupportedInternetExplorerBrowser() || isMicrosoftEdge() || isSupportedSafariDesktopBrowser() || isSupportedSafariMobileBrowser();
            }

            // MOS-1273: Editor only supports browsers on Windows and Mac for now...
            function isUnsupportedOS() {
                return editor && userAgent.indexOf("Windows") === -1 && userAgent.indexOf("Mac OS X") === -1;
            }

            /**
             * We support "all" iOS version and Android >= <tt>ANDROID_MIN_SUPPORTED_VERSION</tt>.
             *
             * @return {Boolean} <tt>true</tt> if supported.
             */
            function isSupportedMobileOS() {
                return detectedBrowser.iOS || detectedBrowser.android && isRequiredVersionOrLater(ANDROID_MIN_SUPPORTED_VERSION, detectedBrowser.osVersion);
            }

            /**
             * Checks Firefox browser support.
             * @returns {boolean} True if Firefox browser is supported, false otherwise.
             */
            function isSupportedFirefoxBrowser() {
                return detectedBrowser.firefox && isRequiredVersionOrLater(FIREFOX_MIN_SUPPORTED_VERSION, detectedBrowser.version);
            }

            /**
             * Checks Microsoft Edge browser support.
             * @returns {boolean} True if Microfost Edge browser is supported, false otherwise.
             */
            function isMicrosoftEdge() {
                return detectedBrowser.edge;
            }

            /**
             * Checks Internet Explorer browser support.
             * @returns {boolean} True if Internet Explorer browser is supported, false otherwise.
             */
            function isSupportedInternetExplorerBrowser() {
                if (!detectedBrowser.ie) {
                    return false;
                }
                // Min version will differ between viewer and editor!
                return isRequiredVersionOrLater(editor ? IE_EDITOR_MIN_SUPPORTED_VERSION : IE_VIEWER_MIN_SUPPORTED_VERSION, detectedBrowser.version);
            }

            /**
             * Checks Safari browser support on desktop.
             * @returns {boolean} True if Safari browser is supported on desktop, false otherwise.
             */
            function isSupportedSafariDesktopBrowser() {
                if (!detectedBrowser.safari || detectedBrowser.mobile) {
                    return false;
                }

                return isRequiredVersionOrLater(SAFARI_DESKTOP_MIN_SUPPORTED_VERSION, detectedBrowser.version);
            }

            /**
             * Checks Safari browser support on mobile.
             * @returns {boolean} True if Safari browser is supported on mobile, false otherwise.
             */
            function isSupportedSafariMobileBrowser() {
                // Not supported for the editor!
                if (editor || !detectedBrowser.safari || !detectedBrowser.mobile) {
                    return false;
                }

                return isRequiredVersionOrLater(SAFARI_MOBILE_MIN_SUPPORTED_VERSION, detectedBrowser.version);
            }

            /**
             * Checks whether clicks events are supported.
             * @returns {boolean} - Whether clicks events are supported.
             */
            function isClickSupported() {
                return "onclick" in document;
            }

            /**
             * Checks touch events are supported.
             * @returns {boolean} isTouchSupportedCheck - Whether touch events are supported.
             */
            function isTouchSupported() {
                var isTouchSupportedCheck = "ontouchend" in document;

                // IE user agent on Touch enabled devices is treated as Tablet Pc.
                if (detectedBrowser.ie) {
                    isTouchSupportedCheck = isTouchSupportedCheck || "onmsgesturechange" in window;
                }

                return isTouchSupportedCheck;
            }

            /**
             * Checks that the detected user browser supports mouse events, handling the special case
             * of IE touch-enabled devices.
             * @returns {Boolean} defaultMouseSupportCheck - Whether the browser supports mouse events.
             */
            function isMouseEventsSupported() {
                var defaultMouseSupportCheck = !detectedBrowser.mobile && !detectedBrowser.tablet;
                var isTouchSupportedCheck = isTouchSupported();

                // If browser is IE, we need to check if touch is supported.
                if (isTouchSupportedCheck && detectedBrowser.ie) {
                    return isTouchSupportedCheck;
                }

                return defaultMouseSupportCheck;
            }

            /**
             * Checks that the detected user browser supports iframe scrolling - it appears Apple has decided
             * that the default behavior of an iFrame in mobile Safari is 'no scroll' and expands to prevent it.
             *
             * @return {Boolean} Whether the browser supports iframe scrolling.
             */
            function isIframeScrollingSupported() {
                return !detectedBrowser.iOS;
            }

            /**
             * Checks whether the specified version is later than or equal than the required version.
             *
             * @param  {Number|Number[]} requiredVersion The required version. If an array, the lower the index, the
             *                                           more major the part is, e.g. [7,5,4] means major version 7,
             *                                           then 5, and then 4 (minor).
             * @param  {Number|Number[]} version         The version to check, same semantics as <tt>requiredVersion</tt>.
             * @return {Boolean} True if the specified version is later than or equal than the required version, false if not.
             */
            function isRequiredVersionOrLater(requiredVersion, version) {
                var i = void 0;
                var actual = void 0;
                var required = void 0;

                if (typeof requiredVersion === "number") {
                    requiredVersion = [requiredVersion];
                }

                if (typeof version === "number") {
                    version = [version];
                }

                // Loop through version numbers, starting with the first (the most important)
                for (i = 0; i < requiredVersion.length; ++i) {
                    actual = version[i];
                    required = requiredVersion[i];

                    // If there is no version number, assume there is no match
                    if (!actual) {
                        return false;
                    }

                    // If the actual version is less than the required, return false
                    if (actual < required) {
                        return false;
                    }

                    // If the actual version is greater than the required, return true without checking the next version number
                    if (actual > required) {
                        return true;
                    }
                }

                return true;
            }

            // Based on http://caniuse.com/queryselector
            function hasQuerySelectorSupport() {
                var majorVersion = detectedBrowser.version[0];

                /*
                 * IE 8 only has queryselector support for CSS 2.1, so we
                 * exclude it from our definition of "supported"
                 */
                return document.querySelectorAll && (detectedBrowser.chrome || detectedBrowser.edge || detectedBrowser.firefox && majorVersion > 3 || detectedBrowser.ie && majorVersion > 8 || detectedBrowser.safari && majorVersion > 3 || detectedBrowser.opera && majorVersion > 9);
            }

            function hasSupportedBackForwardCache() {
                var majorVersion = detectedBrowser.version[0];

                /*
                 * The back-forward cache in Mobile Safari prior to version 7 is not supported.
                 */
                return !detectedBrowser.safari || !detectedBrowser.mobile || majorVersion >= 7;
            }

            function is3dAnimationsSupported() {
                // Exclude IE - http://caniuse.com/#search=translate3d
                return !detectedBrowser.ie;
            }

            return {

                /**
                 * Returns the detected browser. Note: this is not a <tt>Browser</tt> instance!
                 *
                 * @type {*} -The detected browser (from the supplied user agent); never null. <p>
                 *
                 */
                browser: detectedBrowser,

                /**
                 * Checks if this browser is on a secure url/connection (https).
                 *
                 * @type {Boolean} - rue if this browser is on a secure url/connection (https), false otherwise.
                 */
                isSecure: window.location.protocol === "https:",

                /**
                 * Checks if the current browser is supported. Note that the viewer and editor
                 * do not have the same level of required browser support!
                 *
                 * @type {Boolean} - True if the browser is supported, false otherwise. <p>
                 *
                 */
                isSupported: isSupported(),

                /**
                 * Checks if the current browser is in the Creator Viewer or Editor.
                 *
                 * @type {Boolean} - True if the viewer, false if the editor.
                 */
                isViewer: !editor,

                /**
                 * Checks whether native document query selector support is available.
                 *
                 * @type {Boolean}- True if native document query selector support is available, false otherwise.
                 */
                isQuerySelectorSupported: hasQuerySelectorSupport(),

                /**
                 * Checks whether back-forward cache is supported.
                 *
                 * @type {Boolean} - True if back-forward cache is supported, false otherwíse.
                 */
                isBackForwardCacheSupported: hasSupportedBackForwardCache(),

                /**
                 * Whether the browser has proper support for 3D animations, i.e. CSS transform translate3d,
                 * false otherwise.
                 *
                 * @type {Boolean}- True if the browser has proper support for 3D animations, i.e. CSS transform.
                 * translate3d, false otherwise.
                 */
                is3dAnimationsSupported: is3dAnimationsSupported(),

                /**
                 * Whether we consider CSS animations/keyframes to be supported, i.e. not IE < 10.
                 *
                 * @type {Boolean} - <tt>true</tt> if CSS animations is supported, <tt>false</tt> if not.
                 */
                isCSSAnimationsSupported: !(detectedBrowser.ie && detectedBrowser.version[0] < 10),

                /**
                 * Whether the browser has proper support for CSS pointer events.
                 *
                 * @type {Boolean}
                 *
                 * @see http://caniuse.com/#feat=pointer
                 */
                // We assume that all browsers (that we support) except IE9 and IE10, has support for pointer events.
                isPointerEventsSupported: !detectedBrowser.ie || detectedBrowser.version[0] >= 11,

                /**
                 * Whether web fonts are supported for the current browser.
                 *
                 * @type {Boolean}
                 */
                isWebFontsSupported: !detectedBrowser.googlebot,

                /**
                 * Whether responsive iframes are supported.
                 *
                 * @type {Boolean}
                 */
                isResponsiveIframesSupported: !detectedBrowser.iOS,

                /**
                 * When embedded via channels, we must inject font scripts in the parent window from within WebViews, Safari and iOS
                 * (see <tt>FontInjector</tt>).
                 *
                 * @param  {Boolean} isEmbedded Whether we're currently embedded via channels.
                 * @return {Boolean}            <tt>true</tt> if supported.
                 */
                isEmbeddedWebFontsSupported: function isEmbeddedWebFontsSupported(isEmbedded) {
                    return !isEmbedded || !detectedBrowser.webView && !detectedBrowser.safari && !detectedBrowser.iOS;
                },


                /**
                 * Checks whether clicks are supported. Note that some devices supports both clicks and touches.
                 *
                 * @type {Boolean}
                 * @see  #isTouchSupported
                 */
                isClicksSupported: isClickSupported(),

                /**
                 * Checks whether touches are supported. Note that some devices supports both clicks and touches.
                 *
                 * @type {Boolean}
                 * @see  #isClicksSupported
                 */
                isTouchSupported: isTouchSupported(),

                /**
                 * Checks whether mouse events are supported.
                 *
                 * @type {Boolean}
                 */
                isMouseEventsSupported: isMouseEventsSupported(),

                /**
                 * Whether the detected browser supports iframe scrolling - it appears Apple has decided
                 * that the default behavior of an iFrame in mobile Safari is 'no scroll' and expands to prevent it.
                 *
                 * @type {Boolean}
                 */
                isIframeScrollingSupported: isIframeScrollingSupported(),

                /**
                 * Checks whether the specified version is later than or equal than the version from the
                 * detected browser.
                 *
                 * @param  {Number|Number[]} version The version to test. If an array, the lower the index, the more
                 *                                   major the part is, e.g. [7,5,4] means major version 7, then 5,
                 *                                   and then 4 (minor).
                 * @return {Boolean} True if the specified version is later than or equal than the version of
                 *                   the detected browser, false if not.
                 */
                hasVersion: function hasVersion(version) {
                    return isRequiredVersionOrLater(version, detectedBrowser.version);
                }
            };
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Class = __webpack_require__(26);
    var Preconditions = __webpack_require__(14);
    var Promise = __webpack_require__(21);
    var Syncer = __webpack_require__(50);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var sequence = 1;

    // A noop function simply used to block based on globally unique id...
    var NOOP = function NOOP() {};

    /**
     * @class {Queue}
     * A <i>queue</i> will queue all <i>actions</i> on given entities so only one action can execute at a time for
     * the queue. Here, an action is just some function to be invoked, not requiring a promise as the return value. <p>
     *
     * Different queue implementations may queue per entity or queue across entities.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    return Class.extend({

        /**
         * @type {String}
         * The unique id of this queue, mainly used for logging purposes.
         */
        id: null,
        /**
         * @protected @type {SyncManager}
         * The sync manager using this queue; never null after construction.
         */
        manager: null,
        /**
         * @private @type {Deferred}
         * The private deferred that eventually will be resolved when this queue is empty, or rejected on queue error,
         * e.g. on timeout or sync failure (just one). <tt>this.promise()</tt> returns a promise obtained from this
         * deferred. <p>
         *
         * This deferred will store a reference to this queue in a (new) property called <tt>queue</tt>.
         *
         * @see #promise
         */
        _deferred: null,
        /**
         * @protected @type {{sync:Function, cancel:Function, promise:Promise, ..}[]}
         * The queued requests for this queue, in FIFO order.
         */
        _queue: null,
        /**
         * @protected @type {{sync:Function, cancel:Function, promise:Promise, ..}}
         * The currently active entry for this queue, no longer present in <tt>_queue</tt>. <p>
         *
         * Will be set on each call to <tt>_dequeue</tt>, and set to null when the entry completes. Note that even
         * though only a single entry can be set as the active entry, other entries may be doing background work.
         */
        _active: null,
        /**
         * @private @type {Boolean}
         * False if <tt>sync()</tt> has never been invoked for this queue. However, actual work may still be
         * pending, for example a parallel queue using individual target queues already started.
         */
        _synced: false,
        /**
         * @private @type {Boolean}
         * True while actively dequeuing, false otherwise (e.g. blocked or not started).
         */
        _dequeuing: false,
        /**
         * @private @type {Number}
         * The start time in ms since the epoch for this queue, used to log queue lifespan on completion.
         */
        _start: null,
        /**
         * @protected @type {Number}
         * The stop time in ms since the epoch for this queue at time of completion. <p>
         *
         * If not null, this queue has stopped - successfully or not - and is henceforth stale.
         */
        _stop: null,
        /**
         * @protected @type {[]}
         * The result(s), in order, for each sync requests synced via this queue. The actual result resolved
         * when this queue completes (is empty) will be this result, or an entry from it.
         */
        _results: null,
        /**
         * @private @type {Function}
         * The default result handler for this queue. <p>
         */
        _resultHandler: null,
        /**
         * @protected @type {Logger}
         * The log used by this queue, aptly named.
         */
        _log: null,

        /**
         * @constructor
         * Constructor, which creates this queue.
         *
         * @param {SyncManager}  manager        The sync manager using this queue; cannot be falsey.
         * @param {Function}    [resultHandler] Default queue result handler to transform each result before resolved.
         */
        constructor: function constructor(manager, resultHandler) {
            this.id = this._generateId();
            this.manager = manager;
            this._resultHandler = resultHandler;
            this._results = [];
            this._deferred = Promise.deferred({ queue: this });
            this._log = new Logger(this.__typeName);
            this._dequeuing = false;
            this._queue = [];
            this._synced = false;
            this._start = Date.now();
            this._stop = null;

            this._log.verbose("Created queue: " + this + " -> " + manager);
        },


        /**
         * @private
         * Generates a unique id for this queue, for easy debugging.
         *
         * @return {String} A unique id for this queue; never falsey
         */
        _generateId: function _generateId() {
            var regex = /([A-Z])/g;

            var id = "";
            var match = void 0;

            for (;;) {
                match = regex.exec(this.__typeName);
                if (match) {
                    id += match[1];
                } else {
                    break;
                }
            }
            return id.toLowerCase() + sequence++;
        },


        /**
         * Returns a new promise for this queue that will resolve when this queue is empty or in case of just one
         * queue failure.
         *
         * @return {Promise} A new promise for this queue; never falsey.
         *
         * @see    #sync
         * @see    #cancel
         */
        promise: function promise() {
            return Promise.create(this._deferred, { queue: this });
        },


        /**
         * Returns the size of this queue, i.e. pending sync requests. <p>
         *
         * @return {Number} The queue size; never falsey.
         */
        size: function size() {
            return this._queue.length;
        },


        /**
         * Returns the active entry for this queue, if any. <p>
         *
         * The active entry is never in the queue, it has already been dequeued in order to sync. Note that even
         * though only a single entry can be active, other queued entries can still be performing (server side)
         * work in the background!
         *
         * @return {promise:Function->Promise, cancel:Function, blocked:Function->Boolean, ..} The active entry for
         *         this queue; can be falsey.
         * @see    #head
         */
        active: function active() {
            return this._active;
        },


        /**
         * Returns the head of this queue, without dequeuing, which is not the same sync request as current syncing,
         * if any.
         *
         * @return {promise:Function->Promise, cancel:Function, blocked:Function->Boolean, ..} The head of this queue; can be falsey.
         */
        head: function head() {
            return this._queue[0];
        },


        /**
         * Returns the tail of this queue, without dequeuing, which is never the same sync request as current syncing,
         * if any. <p>
         *
         * A context can use the tail to ensure it for example should wait until the queue has synced everything up
         * to the tail before continuing (for sequential queues).
         *
         * @return {promise:Function->Promise, cancel:Function, blocked:Function->Boolean, ..} The tail of this queue; can be falsey.
         */
        tail: function tail() {
            return this._queue[this._queue.length - 1];
        },


        /**
         * @private
         * Dequeues the head from this queue, which is now considered the active entry.
         *
         * @return {promise:Function->Promise, cancel:Function, blocked:Function->Boolean, sync:Function, ..}
         *         The removed head from this queue, now active.
         * @see    #active
         */
        _take: function _take() {
            this._active = this._queue.shift();
            return this._active;
        },


        /**
         * Enqueues sync requests for the specified target(s).
         *
         * @param {String|*} options The sync method name, e.g. "save" or "_save", or options like
         *                           <tt>{method:String, fn:Function, ..}</tt>. The precise structure is queue
         *                           implementation specific.
         * @param {*|[]}     targets The target(s) to enqueue the sync request for; never falsey.
         * @param {[]}       args    Arguments for the actual sync method at invocation time, if any.
         * @param {...*}     varArgs Queue implementation specific additional arguments, if any.
         *
         * @return {Promise} A promise that will resolve once all sync requests just enqueued completes; never
         *                   falsey. If this is the first and only time this queue is used, the returned promise
         *                   will complete at the same time as the promise for this entire queue, otherwise not.
         *
         * @throws Error If this queue is stale, i.e. already completed.
         */
        enqueue: function enqueue() {
            // see XxxQueue._enqueue implementations for required/optional args!
            Preconditions.checkState(this._stop === null, "Queue is stale");

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var options = args[0];

            if (_.isString(options)) {
                options = { method: options };
                args[0] = options;
            }
            // Use queue default result handler if not is supplied via options...
            if (!_.isFunction(options.resultHandler)) {
                options.resultHandler = this._resultHandler; // can still be undefined
            }
            args.unshift(this._create.bind(this));
            return this._enqueue.apply(this, _toConsumableArray(args)) || this.promise();
        },


        /**
         * Enqueues an immutable sync method that will simply return each target when synced (resolved), effectively
         * blocking each supplied target until invoked and/or until the optional blocked handler returns false.
         * This is basically syntactic sugar for calling
         * <tt>enqueue({method: "block", blockedHandler: blockedHandler, fn: no-op-fn-that-returns-targetX}, targets)</tt>.
         *
         * @param {Function|*} [blockedHandler] An optional function that should return truthy while the request should be
         *                                      blocked, and not just enqueued, falsey when ready to be synced (no longer
         *                                      actually blocked). If no supplied, the block sync request will never
         *                                      be blocked by itself, but will adhere to queue order and may thus block
         *                                      by its location in the queue alone.
         * @param {*|[]}       [targets]        The target(s) to enqueue a blocking sync request for; can be empty
         *                                      depending on queue type (i.e. for target queues). Can also be supplied
         *                                      as the first argument when no explicit blocked handler is to be used.
         *
         * @return {Promise} A promise that will resolve once all blocking sync requests just enqueued completes; never
         *                   falsey. If this is the first and only time this queue is used, the returned promise
         *                   will complete at the same time as the promise for this entire queue, otherwise not.
         *
         * @throws Error If this queue is stale, i.e. already completed.
         * @see    SyncManager#block
         */
        block: function block(blockedHandler) {
            var targets = void 0;
            if (!_.isFunction(blockedHandler)) {
                targets = blockedHandler; // can still be undefined
                blockedHandler = null;
            } else {
                targets = arguments.length <= 1 ? undefined : arguments[1]; // target or targets or undefined
            }
            var params = [{
                method: "block",
                immutable: true,
                blockedHandler: blockedHandler,
                fn: NOOP
            }];

            if (targets) {
                params.push(targets);
            }
            return this.enqueue.apply(this, params);
        },


        /**
         * @protected @abstract
         * Abstract sub-class hook to create queue entries for specific (a) target(s), which will be passed the creator
         * function for this queue as the first argument, then all arguments, in order and as var-args, passed to
         * <tt>enqueue(..)</tt>, thus shifted one index. That is, when the context is enqueuing a sync request like
         * <tt>enqueue(method, targets, someArg1, someArg2)</tt>,
         * <tt>_enqueue(this._create, method, targets, someArg1, someArg2)</tt> will be called. The sub-class
         * implementation will then call <tt>_create(targets, creator:Function)</tt> to create actual (queue
         * implementation specific) entry types, which in turn will enqueue relevant entries. <p>
         *
         * The sub-class creator function will be called with two arguments, in order: this queue and the target to
         * create an entry for; if more than one targets are supplied to this function, the creator function will be
         * called once per such target. The creator function will return a new queue entry to queue, or falsey if
         * no entry should be enqueued, for the specified target. The entry must have a format like:
         * <pre>
         *   {
         *      promise: Function->Promise, // public, returning the promise that will complete once the entry is complete.
         *      blocked: Function->Boolean, // public, optional callback to query whether the entry is currently
         *                                  //         blocked when at the head of this queue, in which the entry can
         *                                  //         never be dequeued.
         *      sync:    Function,          // private, used to start the sync for the entry.
         *      cancel:  Function,          // public, cancel pending request (if possible)
         *      delay:   Number,            // optional number in ms for delayed/debounced syncing ("pending")
         *      ..                          // sub-class specific properties, if any
         *   }
         * </pre>
         *
         * <tt>promise</tt> will resolve once the queued entry in question is resolved/rejected, and <tt>sync</tt>
         * is called by this queue once the entry in question is dequeued and synced. Do <b>not</b> invoke <tt>sync</tt>
         * explicitly, handled by this queue.
         *
         * @param {Function->{*}} create  The create function for this queue (<tt>_create</tt>) to be called by the
         *                                sub-class implementation.
         * @param {...*}          varArgs Arguments from <tt>enqueue</tt>, in order.
         *
         * @return {Promise} An optional promise that will complete once the entry/entries just enqueued completes;
         *                   can be undefined, in which case the promise for this entire queue will be used.
         *
         * @see    #enqueue
         */
        _enqueue: null,

        /**
         * @private
         * Delegate creator function supplied on enqueue to this queue (sub-class, when <tt>_enqueue(this._create, ..)</tt>
         * is invoke to created queue entries). The queue sub-class will then call this function with the target(s)
         * in question and the actual factory method used to create the entry. <p>
         *
         * The sub-class creator function and the creation flow is documented for <tt>_enqueue</tt>.
         *
         * @param {*|[]}     targets The target(s) to create queue requests for; never falsey, but can be empty.
         * @param {Function} creator The sub-class creator function
         *                           <tt>fn(queue:Queue, target:*)->{promise:Function->Promise, sync:Function, ..}</tt>
         *                           used to create the entry to enqueue.
         *
         * @return {Promise} A promise that will resolve once all entries just queued by this call resolves; will be
         *                   an already resolved if no entries were enqueued.
         *
         * @see   _enqueue
         */
        _create: function _create(targets, creator) {
            var _this = this;

            var promises = [];
            _.each(_.isArray(targets) ? targets : [targets], function (target) {
                var entry = creator(this, target);
                if (entry) {
                    this._queue.push(entry);
                    promises.push(entry.promise());
                    this._log.verbose("Enqueued: " + entry + " -> " + this, entry, this);
                }
            }, this);

            // Or the returned promise will never resolve...
            if (!promises.length) {
                return null;
            }
            // Any queued request that fails will trigger this queue to fail. Since we use Promise.all
            // for multiple queued requests, we still only get one error callback...
            return (promises.length === 1 ? promises[0] : Promise.all(promises)).fail(function () {
                _this._stopSync(true, arguments.length <= 0 ? undefined : arguments[0]); // true = cancel all since error
            });
        },


        /**
         * @private
         * Dequeues the head from this queue if and only if not blocked and starts the sync request for the
         * dequeued entry.
         *
         * @return {Promise} A promise for the current dequeued entry, or falsey if this queue is empty.
         *
         * @see #_state
         */
        _dequeue: function _dequeue() {
            Preconditions.checkState(!!this.active, "Queue busy");
            var entry = this.head();
            var promise = void 0;

            if (entry) {
                // Start sync (if not already), and make sure we dequeue next once the dequeued entry completes.
                // We have to use "done", since we will cancel/purge in case of errors and we always want to
                // proceed past cancelled entries as well. We assign our "done" handler after we call "sync()",
                // to ensure our internal Syncer handlers will have a chance to complete first, i.e. to trigger
                // correct sync:state events first...
                promise = this._sync(entry, true); // true = dequeueing (false = nested queuing -> synced immediately)

                if (promise) {
                    // will be false if blocked
                    promise.done(this._next.bind(this));
                }

                return promise;
            }

            this._state(false); // no longer dequeuing, empty
            if (this._synced && !this._stop) {
                this._stop = Date.now();
                this._log.verbose("Queue empty: " + this, this);
                this._deferred.resolve(this._result(this._results));
                // Clear results, we are done (and the deferred will keep the result)...
                this._results = null;
            }
        },


        /**
         * @private
         * Performs the actual sync of the supplied entry, returning is promise unless blocked in which case
         * false is returned.
         *
         * @param {promise:Function->Promise, cancel:Function, blocked:Function->Boolean, sync:Function, ..} entry The
         *                              (queued) entry (request) to sync; never falsey.
         * @param {Boolean} [dequeuing] True if syncing because <tt>entry</tt> has just been dequeued, false
         *                              otherwise (on nested queuing, where <tt>entry</tt> is synced immediately).
         * @return {Promise|Boolean} The promise from <tt>entry.sync()</tt>, or false if <tt>entry</tt> is blocked.
         */
        _sync: function _sync(entry, dequeuing) {
            if (_.isFunction(entry.blocked)) {
                // no all types of Queues has a blocked handler
                var blocked = entry.blocked.call(this);
                if (blocked) {
                    if (dequeuing) {
                        this._state(false); // no longer dequeuing, blocked
                        this._log.verbose("Blocked (" + blocked + "), cannot dequeue: " + entry + " -> " + this, this);
                    }
                    return false;
                }
            }
            if (dequeuing) {
                this._state(true); // now dequeuing!
                this._take();
                this._log.verbose("Dequeued: " + entry + " -> " + this, this);
            }
            return entry.sync();
        },


        /**
         * @private
         * Callback once the active queue entry has resolved successfully, which will call <tt>_dequeue()</tt>
         * to sync the next queued entry, if any.
         *
         * @param {*} result The result of the sync request that just completed; can be falsey/undefined.
         */
        _next: function _next(result) {
            this._results.push(result);
            this._active = null;
            this._dequeue();
        },


        /**
         * @protected @type {Function}
         * Sub-type hook to return the desired results on completion of this queue, based on the supplied result array
         * storing the result of each successfully complete sync request, in order, for this queue. <p>
         *
         * The default implementation simply returns <tt>results</tt> as-is.
         *
         * @param {[]} results The sync method invocation results; never null, but can contain falsey entries.
         * @return {*} The result to be resolved by this queue when completed (empty); can be falsey.
         */
        _result: function _result(results) {
            return results;
        },


        /**
         * @private
         * Sets the state of this queue to actively dequeuing (true) or not (false, e.g. empty or blocked), if not
         * already in such a respective state. <p>
         *
         * On state change, the sync manager using this queue will be notified which may cause events about the overall
         * sync to be triggered.
         *
         * @param {Boolean} dequeuing True if actively dequeuing, false otherwise.
         *
         * @see #_dequeue
         */
        _state: function _state(dequeuing) {
            if (dequeuing !== this._dequeuing) {
                this._dequeuing = dequeuing;
                // Note: we do not use events for this, events from specific queues not needed and too expensive, but
                // the state change for individual queues may cause events to be triggered by the sync manager, which
                // contexts then can listen for...
                this.manager._state(dequeuing);
            }
            return this._dequeuing;
        },


        /**
         * Starts the sync of this queue, if not already. <p>
         *
         * The promise returned will resolve/reject once this queue is empty or erroneous.
         *
         * @return {Promise} A promise that will resolve/reject once this queue is empty or erroneous; never null.
         *
         * @see #cancel
         * @see #promise
         */
        sync: function sync() {
            if (!this._stop) {
                this._synced = true;
                if (!this._dequeuing) {
                    this._dequeue();
                }
            }
            return this.promise();
        },


        /**
         * @protected
         * Stops this queue in case of error, if not already, optionally cancelling any pending/queue sync requests.
         */
        _stopSync: function _stopSync(cancel, error) {
            if (!this._stop) {
                this._stop = Date.now();
                // Cancel if so specified...
                if (cancel) {
                    this._cancel();
                }
                // Signal manager that we are done dequeuing (though we could already be paused)...
                this._state(false);
                // Clear results...
                this._results = null;
                // Signal listeners that this queue had an error...
                this._deferred.reject(error);
            }
        },


        /**
         * Cancels the sync of this queue, which will cause <b>all</b> pending promises for this queue be rejected.
         * This queue is dead/stale after this call! <p>
         *
         * Sync requests already completed for this queue cannot be cancelled, and will not be affected by
         * this call. Pending sync requests may or may not be able to be cancelled, but the work performed
         * externally cannot be cancelled, e.g. some backend updating a model. The promises for each sync
         * pending sync request will be rejected with an error of <tt>Syncer.CANCELLED</tt>, but the actual
         * target may still be updated in the background sometime in the future if and when the pending promise
         * completes successfully.
         *
         * @see #sync
         * @see #promise
         */
        cancel: function cancel() {
            this._stopSync(true, Syncer.CANCELLED); // checks "_stop"!
        },


        /**
         * @private
         * Cancels this entire queue by cancelling all pending sync requests, including the currently active one, if any.
         */
        _cancel: function _cancel() {
            // Active...
            if (this._active) {
                this._log.info("Cancelling active entry: " + this._active + " -> " + this, this);
                this._active.cancel();
            }
            // Queued...
            if (this.size()) {
                this._log.info("Purging queue: " + this, this);
                // "_take()" updates "_active", but we already cancelled the active one, if any, and will clear
                // the property lastly in this function...
                var entry = this._take();
                while (entry) {
                    this._log.info("Cancelling queued entry: " + entry + " -> " + this, this);
                    entry.cancel();
                    entry = this._take(); // next?
                }
            }
            this._active = null;
        },


        /**
         * Returns the string representation of this queue.
         *
         * @return {String} The string representation of this queue; never falsey.
         */
        toString: function toString() {
            var age = (this._stop || Date.now()) - this._start;
            return this.__typeName + "[id: " + this.id + "; size: " + this.size() + "; age: " + age + "ms]";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(100);
    var Window = __webpack_require__(48);
    var ViewerEvents = __webpack_require__(153);

    /**
     * Action that executes javascript on the top most reachable (client) page.
     *
     * @class JsAction
     * @constructor
     */
    return Action.extend("JsAction", {
        // Note: "clientSpace" is not set to true to allow users to enter stuff like "alert('foo')" as well.

        defaults: {
            code: ""
        },

        _event: ViewerEvents.JAVASCRIPT_EXECUTE,

        _activateable: function _activateable() {
            return this.get("code") ? null : "Missing code";
        },


        /**
         * @protected
         * Activates this JS action. <p>
         *
         * A JS action can ever only run when the owning Experience is embedded via channels or we will get
         * cross domain issues.
         *
         * @return {*} The result of executing the code; can be falsey.
         */
        _activate: function _activate() {
            Window.run(this.get("code"));
            return { actionId: this.id, widgetId: this.attributes.widgetId };
        }
    }, {
        TYPE: "js"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CustomJsAction = __webpack_require__(190);
    var ProductActionMixin = __webpack_require__(496);

    /**
     * Open a product via JavaScript code.
     *
     * @class ProductCustomJsAction
     * @constructor
     */
    return CustomJsAction.extend("ProductCustomJsAction", {

        mixin: ProductActionMixin,

        // Product related logic lives on the client page, not in the Viewer; this type of action thus requires
        // access to client space to make sense...
        _clientSpace: true

    }, {
        TYPE: "productCustomJs"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);

    /**
     * Mixes in product action related functionality across different generic product widgets, ensuring
     * that all product related actions behave as uniformly as possible.
     *
     * @class ProductActionMixin
     * @constructor
     */
    return {

        defaults: {
            productIdParameter: null // mixed in with super Action defaults
        },

        // TODO: uncomment "_event" for proper support for PRODUCT_VIEW events across different implementations, uncommented
        //       to comply with current (bad) behaviour where the implementation type defines the event triggered instead
        //       on focusing on actual data sent! When doing so, remember to update ViewerAnalyticsManager PRODUCT_VIEW
        //       listener! When doing so, also require "productId()" to return an actual product!

        // Even though implemented as various implementations, the semantics is to view a product...
        // _event: ViewerEvents.PRODUCT_VIEW,

        /**
         * Returns the parameter name used to identify the product id for this Action, if any.
         *
         * @return {String} The name of the parameter used to identity the product id; can be falsey if not set or
         *                  if it does not match a declared parameter.
         */
        productIdParameter: function productIdParameter() {
            // Because of current issues with stat tracking, allow the "productIdParameter" to be unspecified...
            var name = this.get("productIdParameter");
            if (name) {
                // If specified, make sure it is a valid parameter name...
                var parameters = this.get("parameters");
                if (parameters && parameters[name]) {
                    return name;
                }
            }
            return null;
        },


        /**
         * Returns the product id for this Action, deduced from the aptly named parameter value. <p>
         *
         * The product id found is the product id that will be tracked for the <tt>PRODUCT_VIEW</tt> event on
         * successful activation.
         *
         * @return {String} The product id; can be falsey if not set, which will current <b>not</b> prevent
         *                  activation; this should be the case, but not so until product related stats have
         *                  been implemented correctly.
         */
        productId: function productId() {
            // If we get a name back here, we know it is declared as a parameter, but the value may still be falsey...
            var name = this.productIdParameter();
            return name && this.get("parameters")[name] || null;
        },
        _activateable: function _activateable() {
            // For now, allow a missing product id until we get proper product action stats...
            var productId = this.productId();
            if (!productId) {
                this._log("Missing product id", "info");
                // Fall-through
            }
            // Call super validation, which can still fail...
            return this.__super();
        },
        _activate: function _activate() {
            // Do the actual activation by calling the super implementation. At this point, we know we have a product
            // id to track as this is ensured in _activateable. The super implementation, e.g. ProductLinkAction
            // -> LinkAction, will return additional argument(s) to include, e.g. {url: "actual/url", target: "actual_target"},
            // so we store those on the returned event args as well. The super arguments are currently what is tracked
            // via external stats (see TODO above)...
            var superEventArgs = this.__super();

            return _.extend(superEventArgs || {}, { type: "generic", context: this.constructor.TYPE, productId: this.productId() });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var LightboxAction = __webpack_require__(356);
    var ParametersHelper = __webpack_require__(298);
    var ProductActionMixin = __webpack_require__(496);

    /**
     * Open a product in a lightbox.
     *
     * @class ProductLightboxAction
     * @constructor
     */
    return LightboxAction.extend("ProductLightboxAction", {

        mixin: ProductActionMixin,

        _url: function _url() {
            // TODO: ensure editor sets the "url" always instead, no need to marshall all this
            return this.get("url") || ParametersHelper.inject(this.get("urlTemplate"), this.get("parameters"));
        }
    }, {
        TYPE: "productLightbox"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var LinkAction = __webpack_require__(299);
    var ParametersHelper = __webpack_require__(298);
    var ProductActionMixin = __webpack_require__(496);

    /**
     * Open a product via a link.
     *
     * @class ProductLinkAction
     * @constructor
     */
    return LinkAction.extend("ProductLinkAction", {

        mixin: ProductActionMixin,

        _url: function _url() {
            // TODO: ensure editor sets the "url" always instead, no need to marshall all this
            return this.get("url") || ParametersHelper.inject(this.get("urlTemplate"), this.get("parameters"));
        }
    }, {
        TYPE: "productLink"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Effect = __webpack_require__(78);

    var TYPE = "scale";

    return Effect.extend({
        defaults: _.defaults({
            type: TYPE,
            scale: 1.2
        }, Effect.prototype.defaults)
    }, {
        TYPE: TYPE
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Effect = __webpack_require__(78);

    var TYPE = "pulse";

    return Effect.extend({
        defaults: _.defaults({
            type: TYPE,
            value: 3
        }, Effect.prototype.defaults)
    }, {
        TYPE: TYPE
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractWidgetModel = __webpack_require__(62);
    var PolymorphicCollection = __webpack_require__(300);
    var Injector = __webpack_require__(353);

    /**
     * A collection of widgets.
     *
     * @class WidgetCollection
     * @author Bruce Mackenzie Nielsen
     */
    return PolymorphicCollection.extend("WidgetCollection", {
        modelTypes: function modelTypes() {
            return Injector.get("WidgetTypes");
        },


        modelClass: "modelClass", // use the "modelClass" property from the deduced WidgetTypes constant to get the Model constructor.
        defaultModelType: AbstractWidgetModel
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        isNumber = _require.isNumber,
        isString = _require.isString;

    var DEFAULT_BORDER_COLOR = "#000000";

    /**
     * A mixin for widgets that can be styled with border width, shadow and border radius.
     */
    return {
        /**
         * Add CSS style border width, shadow and border radius to the default common properties.
         *
         * @return {Object} A hash of CSS values mapped to property names.
         */
        defaultCSS: function defaultCSS() {
            var css = this.__super();

            // Set border
            if (this.model.get("borderWidth") > 0) {
                css.border = this.model.get("borderWidth") + "px solid " + (this.model.get("borderColor") || DEFAULT_BORDER_COLOR);
            } else {
                css.borderWidth = 0;
            }

            // Make sure to remove the previous shadow on re-render
            css.boxShadow = this.computeBoxShadow();

            // Set border radius
            var radius = this.model.get("radius");

            if (isNumber(radius)) {
                var borderRadius = radius * this.model.get("scale").average();
                css.borderRadius = borderRadius + "px";
            } else if (isString(radius)) {
                css.borderRadius = radius;
            }

            // Apply opacity...
            css.opacity = this.model.get("opacity");

            return css;
        },
        computeBoxShadow: function computeBoxShadow() {
            var boxShadow = this.__super();

            return boxShadow || this.model.get("boxShadow") || "none";
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetView = __webpack_require__(61);
    var CompositeWidgetLayout = __webpack_require__(1454);
    var CompositeWidgetCollectionView = __webpack_require__(779);

    var _require = __webpack_require__(504),
        ETW_IS_READY = _require.ETW_IS_READY;

    /*
    * This composite view renders grouped widgets using a collection view inside a layout region
    */

    return AbstractWidgetView.extend("CompositeWidgetView", {

        className: AbstractWidgetView.prototype.className + " composite-widget",

        groupCollection: null,

        groupCollectionView: null,

        _layout: null,

        onInitialize: function onInitialize() {
            this.groupCollection = this.model.get("group");
        },
        showView: function showView() {
            if (this.groupCollection) {
                this._renderLayout();
            }

            this.__super();

            if (!this.options.edited) {
                _.defer(this._makeElementUnreachable.bind(this));
            }
        },


        // Legacy browsers (LTE IE10) do not support pointer-events styling
        // meaning that the click events can't be delegated to child elements.
        // Make the composite widget unreachable so underlying elements are interactive.
        _makeElementUnreachable: function _makeElementUnreachable() {
            this.$el.css("width", 0);
        },
        _setGroupedWidgetCollectionView: function _setGroupedWidgetCollectionView() {
            this.groupCollectionView = new CompositeWidgetCollectionView(_.extend(this.options, {
                collection: this.groupCollection,
                container: this._layout.group,
                compositeModel: this.model
            }));
        },


        /**
         * A translation hook to this model is added to map all translations made
         * to this view model to each widget to compensate for position offsets
         */
        _showGroupedWidgetCollectionView: function _showGroupedWidgetCollectionView() {
            var _this = this;

            if (!this.groupCollectionView) {
                this._setGroupedWidgetCollectionView();
            }

            // Pass on the `viewScope` manually due to the "layout strategy" used in here. The view scope concept
            // relies on Marionette regions (see our `Region.js`), i.e. a layout/view needs to be added to a
            // region for the view scope to work out of the box.
            this.groupCollectionView.viewScope = this.viewScope;

            // Defer rendering due to other deferred renderings (e.g. TextWidgetViewEditorMixin)
            this.listenTo(this.groupCollectionView, "collection:rendered", function () {
                _.defer(function () {
                    if (_this.options.edited) {
                        _this.transformToBoundingBox();
                    } else if (_this._active) {
                        _this.groupCollectionView.updateGroupActiveState();
                    }
                });
            });

            this._layout.group.show(this.groupCollectionView);
        },
        _renderLayout: function _renderLayout() {
            this._layout = new CompositeWidgetLayout({ el: this.$el });
            this._layout.render();
            this._showGroupedWidgetCollectionView();
        },

        /**
         * Update current model position and size to fit
         * the bounding box of all of its grouped widgets
         */
        transformToBoundingBox: function transformToBoundingBox() {
            var _this2 = this;

            var experience = this.options.viewModel.get("experience");
            var boundingBoxProps = this.groupCollectionView.getGroupBoundingBox();

            this.model.setSizeAndPosition(boundingBoxProps);

            // Listen for scene changes and update the boundingBox if its size has changed
            // E.g. this is relevant for the scene navigator widget which dynamically changes size
            this.listenTo(experience, "add:scenes remove:scenes", function () {
                _this2._updateBoundingBox(boundingBoxProps, _this2.groupCollectionView.getGroupBoundingBox());
            });
            this.groupCollection.each(function (widget) {
                _this2.listenTo(widget, "transformed", function () {
                    var newBoundingboxProps = _this2.groupCollectionView.getGroupBoundingBox();
                    if (!_.isEqual(newBoundingboxProps, boundingBoxProps)) {
                        _this2.model.setSizeAndPosition(newBoundingboxProps, true);
                    }
                });
            });

            this.listenTo(this.options.viewModel, ETW_IS_READY, function () {
                _this2._updateBoundingBox(boundingBoxProps, _this2.groupCollectionView.getGroupBoundingBox());
            });
        },
        _updateBoundingBox: function _updateBoundingBox(boundingBoxProps, newBoundingBoxProps) {
            if (!_.isEqual(newBoundingBoxProps, boundingBoxProps)) {
                this.model.setSizeAndPosition(newBoundingBoxProps, true);
            }
        },


        /**
         * When this composite widget is set to active, update active state of children views
         */
        setActive: function setActive(active) {
            this._active = active;

            if (this.groupCollectionView) {
                this.groupCollectionView.updateGroupActiveState(active);
            }

            this.__super();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    var ETW_IS_READY = "ETWIsReady";

    return {
        ETW_IS_READY: ETW_IS_READY
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);

    var DEFAULT_EMBED_HEIGHT_PERCENTAGE = 50;
    var DEFAULT_EMBED_WIDTH_PERCENTAGE = 50;

    /**
     * Model for an embed widget.
     *
     * @class EmbedWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("EmbedWidget", {

        defaults: _.defaults({
            type: "embed",
            // scaleMode: WidgetScaleMode.STRETCH,
            width: DEFAULT_EMBED_WIDTH_PERCENTAGE,
            height: DEFAULT_EMBED_HEIGHT_PERCENTAGE,
            url: ""
        }, AbstractWidgetModel.prototype.defaults),

        fitToScene: function fitToScene() {
            this.set({
                left: 0,
                top: 0,
                rotation: 0,
                width: 100,
                height: 100
            });
        },


        /**
         * Returns true if this model has a - perhaps invalid - non-empty url associated with it, false otherwise.
         *
         * @returns {Boolean} True if this model has a non-empty url, false otherwise.
         */
        hasUrl: function hasUrl() {
            return !!this.get("url");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defer = _require.defer;

    var $ = __webpack_require__(4);
    var AbstractWidgetView = __webpack_require__(61);

    /**
     * The view rendering an html widget.
     *
     * @class HTMLWidgetView
     * @constructor
     *
     * @cfg {HTMLWidgetModel} model The model of the html widget being rendered.
     */
    return AbstractWidgetView.extend("HTMLWidgetView", {

        tagName: "div",

        className: AbstractWidgetView.prototype.className + " html-widget",

        initialize: function initialize(widget) {
            this.model = widget.model;
            this.viewModel = widget.viewModel;

            this.listenTo(this.model, "dropped:to:scene", this._onWidgetDrop);
            this.listenTo(this, "deselect", this._deselectHandler);
        },


        events: {
            mousedown: "_mouseDownHandler"
        },

        _mouseDownHandler: function _mouseDownHandler() {
            var _this = this;

            defer(function () {
                _this.model.set("isSelected", true);
            });
        },
        _isOnlySelection: function _isOnlySelection() {
            var selection = this.viewModel.selection;

            return selection.isSingle() && selection.get("widgets")[0] === this;
        },
        _deselectHandler: function _deselectHandler() {
            if (this._isOnlySelection()) {
                return;
            }

            if (this.model.get("isSelected")) {
                this.model.set("isSelected", false);
            }
        },
        _onWidgetDrop: function _onWidgetDrop() {
            var _this2 = this;

            defer(function () {
                _this2.model.set("isSelected", true);
            });
        },
        updateRendering: function updateRendering(element, bounds, active, edited) {
            var staticRepresentation = !this.options.enableAnimations;

            this._activeState = active;

            // When inside the viewer/player
            if (!edited || !staticRepresentation) {
                var htmlText = this.model.get("htmlText");

                element.empty();

                var iframe = $("<iframe />", {
                    src: "about:blank",
                    allowFullscreen: true
                });

                iframe.appendTo(element);

                var contentWindow = iframe[0].contentWindow;

                var iframeDoc = contentWindow ? contentWindow.document : null;

                if (iframeDoc) {
                    iframeDoc.open();
                    iframeDoc.write(htmlText);
                    iframeDoc.close();
                }

                iframe.css({
                    width: "1px",
                    minWidth: "100%",
                    height: "1px",
                    minHeight: "100%"
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Promise = __webpack_require__(21);
    var AbstractWidgetView = __webpack_require__(61);
    var ImageURLProvider = __webpack_require__(362);
    var StyleableMixin = __webpack_require__(502);
    var LoggedInUserState = __webpack_require__(19);
    /**
     * The view rendering an image widget.
     *
     * @cfg {ImageWidgetModel} model The model of the image widget being rendered.
     *
     * @class ImageWidgetView
     *
     * @see ImageWidgetViewEditorMixin
     */
    return AbstractWidgetView.extend("ImageWidget", {

        className: AbstractWidgetView.prototype.className + " image-widget",

        mixin: StyleableMixin,

        /**
         * The (jQuery) element representing the image.
         *
         * @type {jQuery} jQuery wrapped <tt>HTMLImageElement</tt>.
         */
        _$imageElement: null,

        /**
         * A reference to the image URL, used for state handling.
         *
         * @see #updateRendering
         *
         * @type {String}
         */
        _source: null,

        /**
         * The current image URL, provided by the <tt>ImageURLProvider</tt>.
         *
         * @see #updateRendering
         *
         * @type {String}
         */
        _currentUrl: null,

        /**
         * @type {$.Deferred}
         */
        _imageFetchDeferred: null,

        /**
         * The image base url of the third party image library integration
         *
         * @type {String}
         */
        _imageServingUrl: null,

        /**
         * Image provider settings has been loaded
         *
         * @type {Boolean}
         */
        _imageProviderLoaded: null,

        events: {
            // This prevents the default drag and drop behavior in the browser
            "dragstart": function dragstart() {
                return false;
            }
        },

        modelEvents: {
            "change": "render"
        },

        /**
         * @private
         *
         * Initializes the <tt>Deferred</tt> instance, and registers listeners
         * for <tt>load</tt> and <tt>error</tt> events.
         *
         * @param {jQuery} element The jQuery wrapped element.
         */
        onInitialize: function onInitialize(element) {
            var _this = this;

            this._imageFetchDeferred = Promise.deferred();

            // Create the actual image element - appending it to this element/widget
            this._$imageElement = $("<img />").one("load", this._imageFetchDeferred.resolve.bind(this, this)).one("error", function () {
                _this._renderOriginalImage();
                // Log error
                if (_this.options && _this.options.errorLogger) {
                    _this.options.errorLogger.log("Unable to load image widget URL: " + _this._currentUrl);
                }

                _this._imageFetchDeferred.reject(_this);
            }).appendTo(element);

            // Check widget used in Viewer
            if (!LoggedInUserState.get("companySettings")
            // Check if CompanySettings for viewer already exists
            && typeof this.options.viewModel.get("companySettings").get !== "function") {
                // Add a listener, for provider options async load in CompanySettings change event
                this._imageProviderLoaded = false;
                this._listenToProviderReadyEvent();
            } else {
                this._imageProviderLoaded = true;
            }
        },
        updateRendering: function updateRendering(element, bounds, active, edited, changedProperties) {
            if (this.model.get("sourceType")) {
                this._imageServingUrl = this._getImageServingUrl();
            }

            var altText = this.model.get("altText");
            var resource = this.model.get("imageUrl");
            var sizeChanged = changedProperties && (changedProperties.scaledWidth || changedProperties.scaledHeight);

            // Do not render image, if image provider is not loaded yet
            if ((this._source !== resource || sizeChanged) && this._imageProviderLoaded) {
                var provideOptions = { bounds: bounds };

                if (this.model.get("sourceType")) {
                    provideOptions.imageServingUrl = this._imageServingUrl;
                }

                // Check widget used in Viewer
                if (!LoggedInUserState.get("companySettings")) {
                    var companySettings = this.options.viewModel.get("companySettings");
                    if (companySettings && companySettings.has("cloudinaryDefaultImageProvider")) {
                        provideOptions.cloudinary = companySettings.get("cloudinaryDefaultImageProvider");
                    }
                } else {
                    // Editor or preview
                    var _companySettings = LoggedInUserState.get("companySettings");
                    if (_companySettings && _companySettings.has("cloudinaryDefaultImageProvider")) {
                        provideOptions.cloudinary = _companySettings.get("cloudinaryDefaultImageProvider");
                    }
                }

                this._currentUrl = ImageURLProvider.provide(this.model, provideOptions);
                this._$imageElement.attr({
                    alt: altText,
                    src: this._currentUrl,
                    title: this.model.get("title")
                }).css({
                    position: "absolute",
                    width: "100%",
                    height: "100%"
                });

                this._source = resource;
            }
        },
        _getImageServingUrl: function _getImageServingUrl() {
            var experienceModel = this.options.viewModel.get("experience");
            var imageIntegration = experienceModel.getIntegration(this.model.get("sourceType"));
            return imageIntegration && imageIntegration.imageServingUrl;
        },
        _renderOriginalImage: function _renderOriginalImage() {
            if (this.model.get("sourceType") && !this._imageServingUrl) {
                // The integration is missing, no need to retry the request without a base url
                return;
            }

            this._$imageElement.attr({
                src: ImageURLProvider.provide(this.model, { imageServingUrl: this._imageServingUrl })
            });
        },


        /**
         * Registers a listener for the `companySettings:change` event on the `viewModel`.
         */
        _listenToProviderReadyEvent: function _listenToProviderReadyEvent() {
            var _this2 = this;

            this.listenTo(this.options.viewModel, "change:companySettings", function () {
                _this2._imageProviderLoaded = true;
                // Trigger widget rerender
                _this2.render();
            });
        }
    }, {
        // Inject the current error logger to log if image load fails.
        injection: {
            parameters: ["errorLogger"],
            asOptions: true
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);

    var DEFAULT_LINE_WIDTH_PERCENTAGE = 40;
    var DEFAULT_LINE_HEIGHT_PERCENTAGE = 5;

    /**
     * Model for a line widget.
     *
     * @class LineWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Line widget", {
        defaults: _.extend({}, AbstractWidgetModel.prototype.defaults, {
            type: "line",
            width: DEFAULT_LINE_WIDTH_PERCENTAGE,
            height: DEFAULT_LINE_HEIGHT_PERCENTAGE,
            backgroundColor: "transparent",
            lineColor: "#000000",
            lineHeight: 2 // Pixels
        }),

        isValid: function isValid() {
            // We need a shadow color or background color to represent the line widget
            return this.get("width") > 0 && this.get("height") > 0;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var AbstractWidgetView = __webpack_require__(61);

    /**
     * The view rendering a line widget.
     *
     * @class LineWidgetView
     * @constructor
     *
     * @cfg {LineWidgetModel} model The model of the line widget being rendered.
     */
    return AbstractWidgetView.extend("LineWidget", {

        className: AbstractWidgetView.prototype.className + " line-widget",

        /**
         * Move/translate the current target by x and y
         *
         * @param {Number} x1 first axis coordinate
         * @param {Number} y1 first ordinate coordinate
         * @param {Number} x2 second axis coordinate
         * @param {Number} y2 second ordinate coordinate
         *
         * @returns {jQuery} returns the jQuery element representing the line
         */
        _buildLineFromCoordinates: function _buildLineFromCoordinates(x1, y1, x2, y2) {
            var length = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
            var angle = Math.atan2(y2 - y1, x2 - x1) * (180 / Math.PI);
            var transform = "rotate(\"" + angle + "deg)";
            var attr = this.model.attributes;

            var line = $("<div class ='line'>").css({
                background: attr.lineColor,
                height: attr.lineHeight,
                marginTop: -attr.lineHeight / 2,
                position: "absolute",
                transformOrigin: "0 100%",
                width: length,
                transform: transform
            }).offset({ left: x1, top: y1 });

            return line;
        },
        updateRendering: function updateRendering(element, bounds) {
            var lineFound = element.find(".line");
            var attr = this.model.attributes;

            if (lineFound.length === 0) {
                lineFound = this._buildLineFromCoordinates(0, bounds.height / 2, bounds.width, bounds.height / 2);
                lineFound.appendTo(element);
            } else {
                lineFound.css({
                    background: attr.lineColor,
                    height: attr.lineHeight,
                    left: 0,
                    marginTop: -attr.lineHeight / 2,
                    top: bounds.height / 2,
                    width: "100%"
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);

    var DEFAULT_LINK_HEIGHT_PERCENTAGE = 40;
    var DEFAULT_LINK_WIDTH_PERCENTAGE = 20;

    /**
     * Model for a link widget.
     *
     * @class LinkWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("LinkWidgetModel", {
        defaults: _.extend({}, AbstractWidgetModel.prototype.defaults, {
            type: "link",
            width: DEFAULT_LINK_WIDTH_PERCENTAGE,
            height: DEFAULT_LINK_HEIGHT_PERCENTAGE
        }),

        initialize: function initialize() {
            AbstractWidgetModel.prototype.initialize.call(this);
        },
        fitToScene: function fitToScene() {
            this.set({
                left: 0,
                top: 0,
                rotation: 0,
                width: 100,
                height: 100
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractOwnedWidgetModel = __webpack_require__(1459);

    var TYPE = "ProductWidget";

    /**
     * A product widget.
     *
     * @class ProductWidgetModel
     * @constructor
     */
    return AbstractOwnedWidgetModel.extend("ProductWidgetModel", {

        defaults: _.extend({}, AbstractOwnedWidgetModel.prototype.defaults, {
            defaultActionId: null,
            height: 20,
            icon: null, // can be generic-product, or a product widget for a specific ecommerce platform. See http://confluence.zmags.com/display/MOS/Configuring+the+product+widget
            type: TYPE,
            width: 20
        }),

        initialize: function initialize() {
            AbstractOwnedWidgetModel.prototype.initialize.call(this);
        },
        fitToScene: function fitToScene() {
            this.set({
                left: 0,
                top: 0,
                rotation: 0,
                width: 100,
                height: 100
            });
        }
    }, {
        TYPE: TYPE
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);
    var WidgetScaleMode = __webpack_require__(246);

    var Direction = {
        HORIZONTAL: "horizontal",
        VERTICAL: "vertical"
    };

    /**
     * Model for a scene navigator widget.
     *
     * @class SceneNavigatorWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Scene navigator", {
        defaults: _.defaults({
            type: "scene-navigator",
            direction: Direction.HORIZONTAL,
            theme: "white-1",
            // The scene navigator widget will be stretched (scaled) when the experience is
            // resized. When we get a proper responsive widget layout in place, this should be removed.
            scaleMode: WidgetScaleMode.STRETCH
        }, AbstractWidgetModel.prototype.defaults),

        getScaledSize: function getScaledSize() {
            // Scaling is not supported by the navigator widget - sizing is
            // determined by the 'size' property and the number of scenes
            return {};
        }
    }, {
        Direction: Direction
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractWidgetView = __webpack_require__(61);
    var SceneNavigationAction = __webpack_require__(191);
    var $ = __webpack_require__(4);

    var Shapes = {
        "white-1": "circle",
        "white-2": "circle",
        "white-3": "circle",
        "white-4": "circle",
        "white-5": "square",
        "black-1": "circle",
        "black-2": "circle",
        "black-3": "circle",
        "black-4": "circle",
        "black-5": "square"
    };

    /**
     * The view rendering a scene navigator widget.
     *
     * @class SceneNavigatorWidgetView
     * @constructor
     *
     * @cfg {SceneNavigatorWidgetModel} model The model of the image widget being rendered.
     */
    return AbstractWidgetView.extend("SceneNavigatorWidget", {

        tagName: "ul",

        className: AbstractWidgetView.prototype.className + " scene-navigator-container",

        _currentTheme: null,

        initialize: function initialize() {
            this.listenTo(this.options.viewModel, "change:currentScene", this.render);
            this.listenTo(this.options.viewModel.get("experience"), "add:scenes remove:scenes", this.render);
        },
        updateRendering: function updateRendering(element, bounds, active, edited) {
            var _this = this;

            var container = this.$el;
            var viewModel = this.options.viewModel;
            var scenes = viewModel.get("experience").get("scenes");
            var list = [];
            var theme = this.model.get("theme");
            var shapeCssClass = Shapes[theme];
            var direction = this.model.get("direction");
            var currentScene = this._getSceneNumberToUse(edited, scenes);

            var css = {
                cursor: edited ? "move" : "pointer"
            };

            container.empty();
            container.removeClass(this._currentTheme);
            container.addClass(theme);
            container.attr("data-direction", direction);

            this._currentTheme = theme;

            scenes.each(function (scene, index) {
                var sceneNumber = index + 1;
                var isActive = sceneNumber === currentScene;
                var $li = $("<li></li>").addClass("scene-control").addClass(shapeCssClass).toggleClass("active", isActive).attr("title", "Navigate to Scene " + sceneNumber);

                // Register click handler when inside the viewer
                if (!edited) {
                    var widgetId = _this.model.has("uuid") ? _this.model.get("uuid") : ""; // scene-navigator has no action, need the pass the widget id here.
                    $li.on("activate", function () {
                        // Update the model with current scene number
                        new SceneNavigationAction({ target: sceneNumber, widgetId: widgetId }).activate(viewModel);
                    });
                }

                $li.css(css);
                list.push($li);
            });

            // Append only once to limit the reflow of the page
            container.append(list);
        },
        _getSceneNumberToUse: function _getSceneNumberToUse(edited, scenes) {
            // experiences editor (on each scene, select the icon in the correct position along the navigator widget
            if (edited) {
                return scenes.indexOf(this.parentView.scene) + 1;
            }

            // viewer/preview (show the currently active scene)
            var viewModelCurrentScene = this.options.viewModel.get("currentScene");
            if (viewModelCurrentScene) {
                return viewModelCurrentScene;
            }

            // anywhere that no context is available (example, dashboard thumbnail)
            return 1;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);

    var DEFAULT_SHAPE_HEIGHT_PERCENTAGE = 40;
    var DEFAULT_SHAPE_WIDTH_PERCENTAGE = 20;
    var DEFAULT_COLOR = "#000000";
    var TYPE = "shape";

    /**
     * Model for a shape widget.
     *
     * @class ShapeWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("Shape widget", {

        defaults: _.defaults({
            type: TYPE,
            width: DEFAULT_SHAPE_WIDTH_PERCENTAGE,
            height: DEFAULT_SHAPE_HEIGHT_PERCENTAGE,
            borderColor: DEFAULT_COLOR,
            backgroundColor: DEFAULT_COLOR
        }, AbstractWidgetModel.prototype.defaults),

        // HACK: This line is needed for widgets supporting opacity. Remove
        // this (and the computed 'opacity' property in AbstractWidgetModel) once
        // we're comfortable... (see MOS-2375)
        computed: _.omit(AbstractWidgetModel.prototype.computed, "opacity"),

        fitToScene: function fitToScene() {
            this.set({
                left: 0,
                top: 0,
                rotation: 0,
                width: 100,
                height: 100
            });
        },
        isValid: function isValid() {
            return this.get("width") > 0 && this.get("height") > 0;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);
    var WidgetScaleMode = __webpack_require__(246);

    /**
     * Model for a social sharing widget.
     *
     * @class SocialSharingWidgetModel
     */
    return AbstractWidgetModel.extend("Social sharing", {
        defaults: _.defaults({
            type: "social-sharing",
            url: null,
            style: "flat-squared",
            networks: ["facebook", "twitter", "linkedin", "pinterest"],
            // The Social Sharing widget will be stretched (scaled) when the Experience is
            // resized. When we get a proper responsive widget layout in place, this should be removed.
            scaleMode: WidgetScaleMode.STRETCH
        }, AbstractWidgetModel.prototype.defaults),

        getScaledSize: function getScaledSize() {
            // Scaling is not supported by the Social Sharing widget - sizing is
            // determined by the 'size' property and the number of scenes.
            return {};
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var AbstractWidgetView = __webpack_require__(61);

    var _require = __webpack_require__(517),
        openShareLink = _require.openShareLink;

    var Action = __webpack_require__(100);
    var Browser = __webpack_require__(39);
    var ViewerEvents = __webpack_require__(153);

    /**
     * The view rendering a social sharing widget in the Viewer.
     *
     * @class SocialSharingWidgetView
     *
     * @cfg {SocialSharingWidgetModel} model The model of the social sharing icon being rendered.
     */
    return AbstractWidgetView.extend("SocialSharingWidget", {
        // Contains share-offset css class used to adjust the sharing container in the Viewer,
        // since Editor uses a Select2 component and Viewer uses a different DOM structure.
        className: AbstractWidgetView.prototype.className + " social-sharing-widget share-offset",

        updateRendering: function updateRendering(element, bounds, active) {
            element.empty();
            element.append(this._buildShareLinks(active));
        },


        /**
         * Builds the JQuery element to be added in the viewer, along with it associated click event.
         * @param {String} active - Value to used to disable clicks on thumbnails.
         * @returns {Array} shareLinkList - Array of JQuery elements to be appended in the Viewer.
         */
        _buildShareLinks: function _buildShareLinks(active) {
            var shareLinkList = [];

            _.each(this.model.get("networks"), function (network) {
                var _this = this;

                var $shareImage = $("<img>", {
                    src: "images/sharing/" + this.model.get("style") + "/" + network + ".png",
                    alt: "Visit " + network
                });
                var $shareLink = $("<a>", {
                    "data-network": network,
                    "class": "share-link",
                    "title": "Visit " + network,
                    html: $shareImage
                });

                if (this.options.enableActions) {
                    // Register click handler when inside the viewer
                    $shareLink.on("activate", function (event) {
                        // FIXME: this should be modelled as Actions, like a LinkAction with relevant parameters
                        var shareURL = _this.model.get("url");
                        // This checks that if we are on Experience Preview, we have an alert when trying to share the current URL
                        // while custom/overridden URLs will be visible in the Preview.
                        // TODO This should be generalized, since we will have to have different behaviours in Editor Preview and Viewer
                        if (!Browser.capabilities.isViewer && active) {
                            Browser.alert(Action.NOT_EMBEDDED_MESSAGE); // FIXME: this should not be in the Viewer
                        } else {
                            var currentNetwork = event.currentTarget.getAttribute("data-network");
                            openShareLink(currentNetwork, shareURL);

                            // Make sure the event follows the standard ViewerEvents format: name: (source, experienceId, descriptor)...
                            var experienceId = _this._viewModel().get("experience").get("id");
                            var widgetId = _this.model.has("uuid") ? _this.model.get("uuid") : "";
                            ViewerEvents.trigger(ViewerEvents.SOCIAL_NETWORK_SHARE, _this, experienceId, { context: network, url: shareURL, widgetId: widgetId }); // TODO: consider reporting full url (a.href) and shareUrl as relative:shareUrl for consistency
                        }
                    });
                }

                shareLinkList.push($shareLink);
            }, this);

            return shareLinkList;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACTUAL_NETWORKS", function() { return ACTUAL_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STYLES", function() { return STYLES; });
/* harmony export (immutable) */ __webpack_exports__["openShareLink"] = openShareLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adapters_WindowAdapter__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1460);

var _a, _b;


var WINDOW_POPUP_NAME = "social-window";
var WINDOW_POPUP_FEATURES = "location=1,status=1,scrollbars=1,width=500,height=380";
var PINTEREST_PIN_MARKLET_JS_PATH = "//assets.pinterest.com/js/pinmarklet.js";
var actualNetworkUrls = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetNetwork"].Facebook] = "//www.facebook.com/sharer.php?u=",
    _a[__WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetNetwork"].Twitter] = "//twitter.com/?status=",
    _a[__WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetNetwork"].Pinterest] = "",
    _a[__WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetNetwork"].Linkedin] = "//www.linkedin.com/shareArticle?mini=true&url=",
    _a);
// URLs opened from the social sharing popup window. Pinterest will open a pinmarklet overlay, not a link.
var networkUrls = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, actualNetworkUrls, (_b = {}, _b[__WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetNetwork"].GooglePlus] = "//plus.google.com/share?url=", _b));
var ACTUAL_NETWORKS = Object.keys(actualNetworkUrls);
var STYLES = [
    {
        name: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleName"].Squared,
        category: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleCategory"].FlatSquared
    },
    {
        name: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleName"].Rounded,
        category: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleCategory"].FlatRounded
    },
    {
        name: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleName"].Isolated,
        category: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleCategory"].Isolated
    },
    {
        name: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleName"].Circle,
        category: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleCategory"].FlatCircle
    },
    {
        name: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleName"].White,
        category: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleCategory"].WhiteCircle
    },
    {
        name: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleName"].Black,
        category: __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetStyleCategory"].BlackCircle
    }
];
/**
 * Opens the real share functionality.
 *
 * @param network - The network to open.
 * @param shareURL - The url to share.
 */
function openShareLink(network, shareURL) {
    var win = Object(__WEBPACK_IMPORTED_MODULE_1__adapters_WindowAdapter__["topWindowAdapted"])(false);
    shareURL = shareURL || win.location.href || window.location.href;
    if (network !== __WEBPACK_IMPORTED_MODULE_2__models__["SocialSharingWidgetNetwork"].Pinterest) {
        var a = win.document.createElement("a");
        a.href = networkUrls[network] + encodeURIComponent(shareURL);
        Object(__WEBPACK_IMPORTED_MODULE_1__adapters_WindowAdapter__["openAdapted"])(a.href, WINDOW_POPUP_NAME, WINDOW_POPUP_FEATURES);
    }
    else {
        // Insert the pinmarklet.js on the parent page, so that the Pinterest pinnable overlay will be displayed.
        var e = win.document.createElement("script");
        e.setAttribute("id", "zmags-pinmarklet");
        e.setAttribute("type", "text/javascript");
        e.setAttribute("charset", "UTF-8");
        e.setAttribute("src", PINTEREST_PIN_MARKLET_JS_PATH + "?r=" + Math.random() * 99999999);
        win.document.body.appendChild(e);
    }
}


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractWidgetView = __webpack_require__(61);

    /**
     * The view rendering an enhanced text widget.
     *
     * @class TextEnhancedWidgetView
     * @constructor
     *
     * @cfg {TextEnhancedWidgetModel} model The model of the text widget being rendered.
     */
    var TextEnhancedWidgetView = AbstractWidgetView.extend("TextWidget", {
        showView: function showView() {
            this.__super();
        }
    });

    return TextEnhancedWidgetView;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);

    /**
     * Model for a Youtube widget.
     *
     * @class YoutubeWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("YouTube widget", {
        defaults: _.defaults({
            type: "youtube",
            videoID: null,
            autoplay: false,
            controls: true,
            loop: false,
            mute: false
        }, AbstractWidgetModel.prototype.defaults),

        getPlayerVars: function getPlayerVars() {
            var playerVars = {
                color: "white",
                modestbranding: 0,
                rel: 0,
                html5: 1,
                showinfo: 0,
                // Settings
                controls: +this.get("controls"), // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Arithmetic_Operators#.2B_%28Unary_Plus%29
                loop: +this.get("loop")
            };

            if (playerVars.loop) {
                playerVars.playlist = this.get("videoID");
            }

            return playerVars;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);
    var CompositeWidgetModel = __webpack_require__(173);

    /**
     * Model for a dynamic product widget.
     *
     * @class DynamicProductWidgetModel
     * @constructor
     */
    return CompositeWidgetModel.extend("DynamicProductWidgetModel", {
        defaults: _.defaults({
            type: "dynamic-product",
            subtype: "",
            productID: "",
            dynamicSubwidgetLookup: null
        }, AbstractWidgetModel.prototype.defaults),

        initialize: function initialize() {
            var _this = this;

            // When layer index is updated, make sure subwidgets are
            // all still selectable by setting their index to be 1 higher
            // than the parent's.
            this.on("change:layerIndex", function (model) {
                if (_this.has("group")) {
                    _this.get("group").forEach(function (widget) {
                        widget.set("layerIndex", model.get("layerIndex") + 1);
                    });
                }
            });
        },
        setProductID: function setProductID(productID) {
            this.set("productID", productID);
        },
        setInputProductID: function setInputProductID(inputID) {
            this.set("inputProductID", inputID);
        },
        _scaleGroup: function _scaleGroup(scale) {
            if (this.get("group")) {
                this.get("group").invoke("set", "scale", scale);
            }
        },
        setDynamicSubwidgetLookup: function setDynamicSubwidgetLookup(dynamicSubwidgetLookup) {
            this.set("dynamicSubwidgetLookup", dynamicSubwidgetLookup);
        },
        setGroup: function setGroup(subwidgets) {
            this.set("group", subwidgets);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var AbstractWidgetView = __webpack_require__(61);
    var CompositeWidgetView = __webpack_require__(503);
    var DynamicProductWidgetLayout = __webpack_require__(788);
    var DynamicProductWidgetCollectionView = __webpack_require__(1469);

    return CompositeWidgetView.extend("DynamicProductWidgetView", {

        tagName: "div",

        className: AbstractWidgetView.prototype.className + " dynamic-product-widget",

        hasTab: true,

        _$container: null,

        _$placeholderElement: null,

        _$label: null,

        _$icon: null,

        _tabProperties: { yOffset: 19, width: 54, height: 18 },

        /**
         * Initialization
         */
        initialize: function initialize() {
            this.__super();
            this.options.hasTab = this.hasTab;
            this.options.tabProperties = this._tabProperties;
        },
        showView: function showView() {
            if (this.groupCollection) {
                this._layout = new DynamicProductWidgetLayout({ el: this.$el });
                this._layout.render();

                this._setGroupedWidgetCollectionView();

                if (!this.options.edited) {
                    _.defer(this._makeElementUnreachable.bind(this));
                }
            }

            this.__super();
        },
        updateRendering: function updateRendering(element, bounds, active, edited) {
            if (edited) {
                if (this._$placeholderElement === null) {
                    this._$placeholderElement = $("<div class='placeholder'></div>").appendTo(element);
                }
            } else {
                element.css({
                    backgroundColor: "#fff"
                });
            }
        },
        _setGroupedWidgetCollectionView: function _setGroupedWidgetCollectionView() {
            this.groupCollectionView = new DynamicProductWidgetCollectionView(_.extend(this.options, {
                collection: this.groupCollection,
                container: this._layout.group,
                compositeModel: this.model
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!(module.exports = {
    // Arranging
    SEND_BACK: { value: 0, text: "arrange-send-back" },
    SEND_BACKWARD: { value: 1, text: "arrange-send-backward" },
    BRING_FORWARD: { value: 2, text: "arrange-bring-forward" },
    BRING_TO_FRONT: { value: 3, text: "arrange-bring-to-front" },
    BRING_TO_TARGET: { value: 4, text: "arrange-bring-to-specific" },

    // Aligning
    ALIGN_LEFT: { value: 0, text: "align-left" },
    ALIGN_CENTER: { value: 1, text: "align-center" },
    ALIGN_RIGHT: { value: 2, text: "align-right" },
    ALIGN_TOP: { value: 3, text: "align-top" },
    ALIGN_MIDDLE: { value: 4, text: "align-middle" },
    ALIGN_BOTTOM: { value: 5, text: "align-bottom" },

    // Distribute
    DISTRIBUTE_HORIZONTALLY: { value: 6, text: "distribute-horizontally" },
    DISTRIBUTE_VERTICALLY: { value: 7, text: "distribute-vertically" }
});

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImageWidgetModel = __webpack_require__(249);
    var ImprovedModel = __webpack_require__(25);
    var UrlUtil = __webpack_require__(46);

    var DEFAULT_COLOR = "#ffffff";
    var BackdropOptions = {
        Fit: {
            EXPERIENCE: "Experience",
            CONTAINER: "Container"
        },
        Type: {
            COLOR: "Color",
            IMAGE: "Image"
        }
    };

    /**
     * Model for the experience backdrop.
     *
     * @class Backdrop
     * @constructor
     */
    return ImprovedModel.extend("Backdrop", {

        defaults: {
            fit: BackdropOptions.Fit.EXPERIENCE,
            type: BackdropOptions.Type.COLOR,
            // Default to null, so we know we need to do backward compatibility check in the getColor method.
            color: null,
            image: null
        },

        /**
         * Check whether the backdrop should fit to container.
         *
         * @returns {Boolean} True if the backdrop fits to container, false otherwise.
         */
        isFitContainer: function isFitContainer() {
            return this.get("fit") === BackdropOptions.Fit.CONTAINER;
        },


        /**
         * Check whether the backdrop is type of image.
         *
         * @returns {Boolean} True if the backdrop type is an image, false .
         */
        isTypeImage: function isTypeImage() {
            return this.get("type") === BackdropOptions.Type.IMAGE;
        },


        /**
         * Check whether the background color is transparent or not
         *
         * @returns {Boolean} True if the backdrop color is transparent, false otherwise.
         */
        isTransparent: function isTransparent() {
            return this.getColor() === "transparent";
        },


        /**
         * Get the backdrop color. Fallback to the old background color if no color has been set
         *
         * @returns {String} color  A color value in either format "#xxxxxx" or "transparent".
         * @see {@link  BackdropView#initialize}
         */
        getColor: function getColor() {
            var color = this.get("color");

            if (!color) {
                // A hack to get the old background color. The experience is from backbone.association reverse relation
                color = this.experience.get("backgroundScene").get("backgroundColor") || DEFAULT_COLOR;
            }

            return color;
        },


        /**
         * Get the absolute url of backdrop image.
         *
         * @returns {String} The image url or undefined if there is no image.
         */
        getImageURL: function getImageURL() {
            var image = this.get("image");

            if (image) {
                return UrlUtil.getAbsoluteViewerApiUrl(image.url);
            }
        },


        /**
         * Create a mock/temporary <tt>ImageWidgetModel</tt> instance that can be fed to the <tt>ImageURLProvider</tt> to get the resized image url.
         *
         * @returns {ImageWidgetModel} The <tt>ImageWidgetModel</tt> instance.
         */
        getMockModel: function getMockModel() {
            var _get = this.get("image"),
                supportsResize = _get.supportsResize,
                width = _get.width,
                height = _get.height;

            return new ImageWidgetModel({
                supportsResize: supportsResize,
                src: this.getImageURL(),
                originalImageWidth: width,
                originalImageHeight: height
            });
        }
    }, {
        TYPE: BackdropOptions.Type,
        FIT: BackdropOptions.Fit
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SceneTransitionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SceneTransitionTypes", function() { return SceneTransitionTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SceneTransition__ = __webpack_require__(792);

/**
 * Enumeration of scene transition types.
 * TS "enum" with custom type based on:
 * https://stackoverflow.com/questions/41179474/use-object-in-typescript-enum
 */
var SceneTransitionTypes = /** @class */ (function () {
    function SceneTransitionTypes(key, value) {
        this.key = key;
        this.value = value;
    }
    SceneTransitionTypes.prototype.toString = function () {
        return this.key;
    };
    SceneTransitionTypes.NONE = new SceneTransitionTypes('NONE', {
        id: "none",
        label: "None",
        forwardTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_RIGHT,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_LEFT,
            duration: 0
        },
        reverseTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_LEFT,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_RIGHT,
            duration: 0
        },
        swipeDirections: {},
        supportSwipes: false
    });
    SceneTransitionTypes.SLIDE_FROM_TOP = new SceneTransitionTypes('SLIDE_FROM_TOP', {
        id: "slide-from-top",
        label: "Slide Down",
        forwardTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_TOP,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_BOTTOM
        },
        reverseTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_BOTTOM,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_TOP
        },
        swipeDirections: {
            up: "reverse",
            down: "forward"
        },
        supportSwipes: true,
        allowPageScroll: "horizontal"
    });
    SceneTransitionTypes.SLIDE_FROM_BOTTOM = new SceneTransitionTypes('SLIDE_FROM_BOTTOM', {
        id: "slide-from-bottom",
        label: "Slide Up",
        forwardTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_BOTTOM,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_TOP
        },
        reverseTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_TOP,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_BOTTOM
        },
        swipeDirections: {
            up: "forward",
            down: "reverse"
        },
        supportSwipes: true,
        allowPageScroll: "horizontal"
    });
    SceneTransitionTypes.SLIDE_FROM_LEFT = new SceneTransitionTypes('SLIDE_FROM_LEFT', {
        id: "slide-from-left",
        label: "Slide Right",
        forwardTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_LEFT,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_RIGHT
        },
        reverseTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_RIGHT,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_LEFT
        },
        swipeDirections: {
            left: "reverse",
            right: "forward"
        },
        supportSwipes: true,
        allowPageScroll: "vertical"
    });
    SceneTransitionTypes.SLIDE_FROM_RIGHT = new SceneTransitionTypes('SLIDE_FROM_RIGHT', {
        id: "slide-from-right",
        label: "Slide Left",
        forwardTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_RIGHT,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_LEFT
        },
        reverseTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_FROM_LEFT,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].MOVE_TO_RIGHT
        },
        swipeDirections: {
            left: "forward",
            right: "reverse"
        },
        supportSwipes: true,
        allowPageScroll: "vertical"
    });
    SceneTransitionTypes.FADE = new SceneTransitionTypes('FADE', {
        id: "fade",
        label: "Fade",
        forwardTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].FADE_IN,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].FADE_OUT
        },
        reverseTransition: {
            in: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].FADE_IN,
            out: __WEBPACK_IMPORTED_MODULE_0__SceneTransition__["default"].FADE_OUT
        },
        swipeDirections: {},
        supportSwipes: false
    });
    return SceneTransitionTypes;
}());



/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var Preconditions = __webpack_require__(14);
    var GroupAssetReference = __webpack_require__(1478);
    var GroupsDescriptor = __webpack_require__(371);

    /**
     * @private @type {Map.<Function, String>}
     */
    var valueTypes = GroupsDescriptor.valueTypes;

    /**
     * Represents the internal data structure for an asset in a <tt>GroupModel</tt>, the actual *asset* is referenced via the <tt>value</tt> field.
     *
     * @class GroupAsset
     * @constructor
     */
    var GroupAsset = ImprovedModel.extend("Group Asset", {

        defaults: {

            /**
             * The type of value, e.g. <tt>Breakpoint</tt>.
             *
             * @type {String}
             */
            type: null,

            /**
             * A group specific value (e.g. Breakpoint).
             *
             * @type {Backbone.Model}
             */
            value: null,

            /**
             * The actual asset, e.g. <tt>ExperienceModel</tt>.
             *
             * @type {*}
             */
            asset: null,

            /**
             * @deprecated Deprecated in favor of <tt>asset</tt>.
             *
             * A reference to the asset in question, as an object containing <tt>resourceId</tt> and <tt>resourceType</tt>
             * resourceId could be experience id, image id etc and resourceType could be "Experience", "Image".
             *
             * <pre>
             * "reference": {
             *      "resourceId": null,
             *      "resourceType": null
             * }
             * </pre>
             *
             * @type {Object}
             */
            reference: null
        },

        transient: ["asset"]

    }, {
        validValue: function validValue(asset) {
            return asset && valueTypes.has(asset.constructor);
        },
        typeFromValue: function typeFromValue(value) {
            Preconditions.checkState(GroupAsset.validValue(value), "Invalid value: " + value);

            return GroupAsset.typeFromValueClass(value.constructor);
        },
        typeFromValueClass: function typeFromValueClass(constructorFunction) {
            return valueTypes.get(constructorFunction);
        },


        /**
         * Factory method for creating the internal asset from the specified asset and associated value.
         *
         * @param  {*} asset The asset, e.g. a <tt>ExperienceModel</tt> instance.
         * @param  {*} value The value, e.g. an <tt>Breakpoint</tt> instance.
         * @param  {String} valueType The type of value, e.g. <tt>Breakpoint</tt>.
         *
         * @return {GroupAsset} A new <tt>GroupAsset</tt> instance, to be added to the <tt>GroupAssetCollection</tt>.
         */
        asAsset: function asAsset(asset, value, valueType) {
            var body = {
                asset: asset,
                type: valueType,
                reference: asset instanceof ImprovedModel ? GroupAssetReference.toJSON(asset) : asset
            };

            // Add optional value if present...
            if (value) {
                body.value = value;
            }

            return new GroupAsset(body);
        }
    });

    return GroupAsset;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(123),
    isSymbol = __webpack_require__(363);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1483),
    mapCacheDelete = __webpack_require__(1499),
    mapCacheGet = __webpack_require__(1501),
    mapCacheHas = __webpack_require__(1502),
    mapCacheSet = __webpack_require__(1503);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 528 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(198),
    root = __webpack_require__(122);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var COPY_CODE_BUTTON_STATE = "copyCodeButtonState";

    var BUTTON_STATUS = {
        enabled: "ENABLED",
        disabled: "DISABLED"
    };

    return {
        COPY_CODE_BUTTON_STATE: COPY_CODE_BUTTON_STATE,
        BUTTON_STATUS: BUTTON_STATUS
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PropertyRowComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GlyphButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Glyph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tippy_js_react__ = __webpack_require__(853);





var Glyph = function (_a) {
    var glyphicon = _a.glyphicon, label = _a.label, style = _a.style, onRight = _a.onRight;
    var positionModifier = onRight && "icon-right";
    var glyphClass = glyphicon && "glyphicon glyphicon-" + glyphicon + " " + positionModifier;
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: style, className: glyphClass }, label));
};
var GlyphButton = function (_a) {
    var changeStyleProperty = _a.changeStyleProperty, styleProperty = _a.styleProperty, value = _a.value, title = _a.title, glyphicon = _a.glyphicon, style = _a.style, label = _a.label, _b = _a.selected, selected = _b === void 0 ? false : _b, onClick = _a.onClick;
    var selectedClass = selected ? "selected" : "";
    // The "change-" property is significant to the CSS.
    var buttonClass = "change-" + changeStyleProperty + " " + styleProperty + " button-switch " + selectedClass;
    // onMouseDown works because we can cancel the event and preserve focus.
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("button", { className: buttonClass, "data-value": value, title: title, onMouseDown: onClick },
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Glyph, { label: label, glyphicon: glyphicon, style: style })));
};
// noinspection JSUnusedLocalSymbols
var PropertyRowComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](PropertyRowComponent, _super);
    function PropertyRowComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyRowComponent.prototype.render = function () {
        var _a = this.props, name = _a.name, label = _a.label, tip = _a.tip, children = _a.children, isColStretched = _a.isColStretched;
        var infoColLength = isColStretched ? 12 : 4;
        var childrenColLength = isColStretched ? 12 : 8;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Row */], { className: name + "-section properties", componentClass: "section" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Col */], { md: infoColLength, style: { whiteSpace: "nowrap" } },
                label,
                tip &&
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__tippy_js_react__["a" /* default */], { content: tip, arrow: true, arrowType: "sharp", placement: "left", maxWidth: 230, size: "large", theme: "dark", offset: 25 },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "info-tooltip" }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["b" /* Col */], { md: childrenColLength }, children)));
    };
    return PropertyRowComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1516);

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1518);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 534 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 535 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(806)('keys');
var uid = __webpack_require__(808);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 537 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var defaultProps = {
  label: 'Close'
};

var CloseButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(CloseButton, _React$Component);

  function CloseButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CloseButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        onClick = _this$props.onClick;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
      type: "button",
      className: "close",
      onClick: onClick
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: "sr-only"
    }, label));
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(18);









var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};
var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ButtonGroup, _React$Component);

  function ButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonGroup.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        block = _this$props.block,
        justified = _this$props.justified,
        vertical = _this$props.vertical,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["block", "justified", "vertical", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps)] = !vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'vertical')] = vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('btn-group', ButtonGroup));

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(202));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired
};

var Glyphicon =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Glyphicon, _React$Component);

  function Glyphicon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Glyphicon.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        glyph = _this$props.glyph,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["glyph", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Glyphicon.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('glyphicon', Glyphicon));

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_style__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(66);





var _collapseStyles;








var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
}; // reading a dimension prop will cause the browser to recalculate,
// which will let our animations work

function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem["offset" + Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];
  return value + __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int___default()(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default()(elem, margins[0]), 10) + __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int___default()(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default()(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["EXITED"]] = 'collapse', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["EXITING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERED"]] = 'collapse in', _collapseStyles);
var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Collapse, _React$Component);

  function Collapse() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };

    _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      triggerBrowserReflow(elem);
    };

    _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }; // for testing


  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem["scroll" + Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(dimension)] + "px";
  };
  /* -- Expanding -- */


  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);

    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default.a, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(202));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(255));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(833));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1626));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1628));

var _removeStyle = _interopRequireDefault(__webpack_require__(1629));

var _properties = __webpack_require__(1630);

var _isTransform = _interopRequireDefault(__webpack_require__(1631));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1662);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uncontrollable__);





var TAB = 'tab';
var PANE = 'pane';
var idPropType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]);
var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },

  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
  })
};

var TabContainer =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(TabContainer, _React$Component);

  function TabContainer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TabContainer.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        onSelect = _this$props.onSelect,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;

    var getId = generateChildId || function (key, type) {
      return id ? id + "-" + type + "-" + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["children"]);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_uncontrollable___default()(TabContainer, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(18);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};
var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
  })
};
var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired
  })
};

var TabContent =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(TabContent, _React$Component);

  function TabContent(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handlePaneEnter = _this.handlePaneEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handlePaneExited = _this.handlePaneExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this))); // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.

    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  var _proto = TabContent.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit;
    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();
    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({
        activeKey: null,
        activeChild: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  _proto.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    } // It's possible that this child should be transitioning out.


    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });
    return true;
  };

  _proto.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        className = _this$props2.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["componentClass", "className"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('tab', TabContent));

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var NavigationWidgetTargets = __webpack_require__(855).default;
    var WidgetTypes = __webpack_require__(69);

    var _require = __webpack_require__(1688),
        WIDGET_TYPE_ICONS = _require.WIDGET_TYPE_ICONS;

    function widgetNavigatesScenes(widget) {
        return widget.get("type") === "image" && widget.get("action") && widget.get("action").get("type") === "sceneNavigation" && !widget.get("src");
    }

    function getWidgetMetaDataActions(widget) {
        var isLocked = {
            iconEnabled: "images/icons/unlocked-icon.svg",
            iconDisabled: "images/icons/locked-icon.svg",
            enabled: !widget.get("isLocked"),
            type: "lock",
            isActionDisabled: widget.get("isEditorHidden")
        };
        var isHidden = {
            iconEnabled: "images/icons/visible-icon.svg",
            iconDisabled: "images/icons/not-visible-icon.svg",
            enabled: !widget.get("isEditorHidden"),
            type: "hide",
            isActionDisabled: false
        };
        return [isLocked, isHidden];
    }

    function mapWidgetMetaData(_ref) {
        var widget = _ref.widget,
            _ref$addActions = _ref.addActions,
            addActions = _ref$addActions === undefined ? false : _ref$addActions;

        var isSceneNavigation = widgetNavigatesScenes(widget);
        var widgetType = isSceneNavigation ? widget.get("action").get("target") : widget.get("type");
        var widgetIcon = void 0;
        if (isSceneNavigation && (widgetType !== NavigationWidgetTargets.PREVIOUS_SCENE || widgetType !== NavigationWidgetTargets.NEXT_SCENE)) {
            widgetIcon = WidgetTypes.lookup("image").icon;
        } else {
            var iconName = isSceneNavigation ? widget.get("action").get("target") + "-scene" : widget.get("type");
            widgetIcon = WidgetTypes.lookup(iconName).icon;
        }
        var widgetMetaData = {
            id: widget.get("uuid"),
            description: widget._getBasicDescription(),
            icon: WIDGET_TYPE_ICONS[widgetIcon]
        };

        if (addActions) {
            widgetMetaData.actions = getWidgetMetaDataActions(widget);
        }

        return widgetMetaData;
    }

    return {
        widgetNavigatesScenes: widgetNavigatesScenes,
        getWidgetMetaDataActions: getWidgetMetaDataActions,
        mapWidgetMetaData: mapWidgetMetaData
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defaults = _require.defaults,
        extend = _require.extend;

    var ImageLibraryCollectionView = __webpack_require__(553);
    var ImageLibrarySourceEnum = __webpack_require__(102);

    /**
     * A "compact" version of the <tt>ImageLibraryView</tt> suited for smaller viewport sizes, for use primarily inside the editor.
     *
     * Supports highlighting a selected image.
     *
     * If a <tt>ProjectModel</tt> is passed, a filter dropdown will be rendered next to the search input.
     *
     * @cfg {ImageCollection} collection The <tt>ImageCollection</tt> to be rendered.
     * @cfg {ProjectModel} project The current project, if any, i.e. might be <tt>undefined</tt>.
     * @cfg {Object} itemViewOptions Any options passed to the underlying <tt>ImageThumbnailView</tt> item views.
     * @cfg {String} selectedImageId Optional image model id to represent the initial selected image, if found in the initial chunk (see #onLoadEnd).
     * @cfg {Boolean} autoSelection Optional, ensures that the <tt>CompactImageLibraryView</tt> will select the first image model in the
     *                              collection, if any, and if no <tt>selectedImageId</tt> is found or defined (see #onLoadEnd) - <tt>false</tt> by default.
     *
     * @see  ImageWidgetPropertiesView
     *
     * @class CompactImageLibraryView
     */
    return ImageLibraryCollectionView.extend("CompactImageLibraryView", {

        className: ImageLibraryCollectionView.prototype.className + " compact",

        options: {
            autoSelection: false
        },

        horizontalScrollBuffer: 10,

        /**
         * The options passed to the <tt>SortingPanel</tt>.
         *
         * @type {Object}
         */
        sortingPanelOptions: {
            showSources: true,
            initialSource: null
        },

        /**
         * @type {String}
         */
        _selectedImageId: null,

        constructor: function constructor(options) {
            var _this = this;

            var selectedImage = options.selectedImage;

            if (selectedImage) {
                this._selectedImageId = selectedImage.get("imageId");

                if (selectedImage.get("sourceType")) {
                    this.sortingPanelOptions.initialSource = options.imageLibrarySorting.lookupSourceName(selectedImage.get("sourceType"));
                } else {
                    // If source type isn't defined on the selected image, use Creator source
                    this.sortingPanelOptions.initialSource = ImageLibrarySourceEnum.CREATOR;
                }
            } else {
                this.sortingPanelOptions.initialSource = null;
            }

            // Setup listener for the "selected" event triggered by the ImageThumbnailView - delegate the event as "image:selected"
            this.collectionViewOptions = {
                itemEvents: {
                    "selected": function selected(imageModel) {
                        _this._updateSelectedImageState(imageModel);
                    }
                }
            };

            options.itemViewOptions = options.itemViewOptions || {};

            defaults(options.itemViewOptions, {
                draggable: false,
                isEditable: false,
                showTooltips: true,
                dropTargetSize: "small"
            });

            this.sortingPanelOptions = extend({
                project: options.project
            }, this.sortingPanelOptions, options.sortingPanelOptions);

            this.__super();
        },
        _updateSelectedImageState: function _updateSelectedImageState(imageModel, imageModelView) {
            if (!imageModel) {
                return;
            }

            var currentSelectedImage = this._collectionView.findById(this._selectedImageId);
            if (currentSelectedImage) {
                currentSelectedImage.highlight(false);
            }

            this._selectedImageId = imageModel.get("id");

            var selectedImage = imageModelView || this._collectionView.findById(this._selectedImageId);

            selectedImage.highlight(true);

            this.trigger("image:selected", imageModel);
        },


        /**
         * Invoked every time a chuck of lazy loaded image data has ended.
         *
         * If a <tt>selectedImageId</tt> has been specified, look for the
         * matching item view, if any, and highlight that.
         */
        onLoadEnd: function onLoadEnd() {
            var imageModel = void 0;
            if (this._selectedImageId) {
                imageModel = this.options.collection.get(this._selectedImageId);
            }

            // If 'autoSelection' is enabled, grab the first image model in the collection...
            if (!this._selectedImageId && !imageModel && this.options.autoSelection) {
                imageModel = this.options.collection.at(0);
            }

            if (imageModel) {
                this._updateSelectedImageState(imageModel);
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        extend = _require.extend,
        result = _require.result;

    var DropAreaHotspot = __webpack_require__(398);
    var ImageCollectionView = __webpack_require__(1728);
    var ContentQuery = __webpack_require__(139);
    var EditorEvents = __webpack_require__(17);
    var ImageLibrarySourceEnum = __webpack_require__(102);
    var ImageLibrarySortingEnum = __webpack_require__(399);
    var ImprovedView = __webpack_require__(6);
    var Syncer = __webpack_require__(50);
    var template = __webpack_require__(1740);
    var SortingPanel = __webpack_require__(870);

    return ImprovedView.extend("ImageLibraryView", {

        className: "image-library",

        template: template,

        horizontalScrollBuffer: 220,

        /**
         * Options passed to the <tt>SortingPanel</tt>.
         *
         * @type {Object}
         */
        sortingPanelOptions: {
            project: null,
            showSources: false
        },

        collectionViewOptions: {},

        sourcePanel: null,
        sortingPanel: null,

        regions: {
            sortingPanelRegion: ".sorting-panel-region",
            content: ".content"
        },

        behaviors: {
            dropAreaHotspot: {
                behaviorClass: DropAreaHotspot,
                message: "<h4>Add <br/>images to Library </h4><p>Drag from desktop or click to upload</p>",
                dropAreaSelector: ".collection",
                iconSize: "small"
            }
        },

        initialize: function initialize() {
            this._imageLibrarySorting = this.options.imageLibrarySorting;
            this.collection = this.options.collection;
        },
        onShow: function onShow() {
            var _this = this;

            var imageCollectionViewOptions = extend({
                collection: this.collection,
                itemView: this.itemView || this.options.itemView,
                itemViewOptions: this.options.itemViewOptions,
                horizontalBuffer: this.horizontalScrollBuffer,
                scrollTarget: this._determineScrollTarget()
            }, this.options.collectionViewOptions || this.collectionViewOptions);

            this.sortingPanel = new SortingPanel(extend(this.sortingPanelOptions, {
                sorting: this._imageLibrarySorting,
                sourceEnum: ImageLibrarySourceEnum
            }));

            this._collectionView = new ImageCollectionView(imageCollectionViewOptions);
            this.content.show(this._collectionView);

            this.listenTo(this.collection, {
                "sync:state": function syncState() {
                    // only used for fetch
                    _this.sortingPanel.disable(!Syncer.State.complete(_this.collection));
                }
            });

            this.listenTo(this.sortingPanel, {
                "sort": function sort(sorting) {
                    _this.collection.query(sorting.query);
                },

                "search": function search(tags, sorting, source) {
                    // Searching tag names are only supported for Creator images
                    var includeTagName = source === ImageLibrarySourceEnum.CREATOR;
                    _this.collection.query(ContentQuery.search(tags, sorting.query, includeTagName));
                },

                "source:changed": function sourceChanged(source) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                    var isCreator = source === ImageLibrarySourceEnum.CREATOR;
                    _this.collection.updateSource(source);

                    if (_this.options.project && isCreator) {
                        _this.collection.options.project = _this.options.project;
                    } else {
                        delete _this.collection.options.project;
                    }

                    _this.collection.query(_this.collection.currentQuery());
                    _this.sortingPanel.toggleFiltering(Boolean(_this.sortingPanelOptions.project) && isCreator);

                    // There are cases where events shouldn't trigger source change stats event
                    // e.g. on first click on an image
                    if (!options.ignoreEditorEvent && _this.viewScope.viewModel) {
                        var eventProperties = {
                            triggerOrigin: "ImageLibrary",
                            sourceName: source.name
                        };

                        var experience = _this.viewScope.viewModel.get("experience");

                        if (experience) {
                            eventProperties.experienceId = experience.get("id");
                            eventProperties.experienceVersion = experience.get("version");
                            eventProperties.experiencePushedVersion = experience.get("pushedVersion");

                            if (_this.sortingPanelOptions.project) {
                                eventProperties.projectId = _this.sortingPanelOptions.project.get("id");
                            }
                        }
                        // Make sure we log the event
                        EditorEvents.trigger(EditorEvents.constants.SELECT_SOURCE, eventProperties);
                    }
                }
            });

            if (this.options.project) {
                this.listenTo(this.sortingPanel, "select", function (text) {
                    if (text === SortingPanel.FILTER_ATTRIBUTES.project) {
                        _this.collection.options.project = _this.options.project;
                    } else {
                        delete _this.collection.options.project;
                    }

                    _this.collection.query(_this.collection.currentQuery());
                });
            }

            this.sortingPanelRegion.show(this.sortingPanel);

            // Delegate "load" events (picked up by the DropAreaHotspot)
            this.listenTo(this._collectionView, {
                "load:start": this.triggerMethod.bind(this, "load:start"),
                "load:end": this.triggerMethod.bind(this, "load:end")
            });

            // Set the event listener for upload as the triggerMethod approach
            // does not properly remove the eventlistener
            this.listenTo(this, "upload", this._onUpload);
        },
        refresh: function refresh(sorting) {
            this.sortingPanel.setSorting(sorting || this.sortingPanel.getSorting());
        },
        active: function active(_active) {
            this._collectionView.active(_active);
        },


        /**
         * Invoked when uploading (triggered by the <tt>DropAreaHotspot</tt>).
         *
         * @param  {{promise: Promise, models: ImageModel[], descriptors: Object[]}} descriptor The descriptor object created by the <tt>ImageDropManager</tt>.
         *
         * @see ImageDropManager
         */
        _onUpload: function _onUpload(_ref) {
            var _this2 = this;

            var promise = _ref.promise,
                descriptors = _ref.descriptors,
                models = _ref.models;

            var changeSource = this._imageLibrarySorting.getSelectedSource() !== ImageLibrarySourceEnum.CREATOR;

            // Upload can only happen where Creator is the image source
            if (changeSource) {
                this.sortingPanel.setSource(ImageLibrarySourceEnum.CREATOR);
            }

            promise.then(function () {
                // Avoid re-render if sorting is already set to last uploaded
                if (!changeSource && _this2._imageLibrarySorting.getSelectedSorting() !== ImageLibrarySortingEnum.LAST_UPLOADED) {
                    _this2.sortingPanel.setSorting(ImageLibrarySortingEnum.LAST_UPLOADED);
                }
            }).always(function () {
                _this2.sortingPanel.disable(false);
            });

            // Handle failing upload - make sure to remove the model from the collection.
            descriptors.forEach(function (imageUploadDescriptor) {
                imageUploadDescriptor.promise.fail(function () {
                    _this2.collection.remove(imageUploadDescriptor.model);
                });
            });

            if (models.length > 0) {
                this._trackEditorEvent(models);
            }

            this.sortingPanel.disable();
            this.collection.add(models, 0);
        },
        _trackEditorEvent: function _trackEditorEvent(imageModels) {
            var viewModel = this.viewScope.viewModel;
            var project = this.options.project;

            var imageNames = imageModels.map(function (image) {
                return image.get("name");
            });
            var eventProperties = {
                numberOfUploadedImages: imageModels.length,
                imageNames: imageNames.join(),
                projectId: project && project.get("id")
            };

            // Means we are in the context of an experience
            if (viewModel) {
                var experience = viewModel.get("experience");
                eventProperties.location = "edit";
                eventProperties.experienceId = experience.get("id");
                eventProperties.experienceVersion = experience.get("version");
                eventProperties.experiencePushedVersion = experience.get("pushedVersion");
                eventProperties.triggerOrigin = "ImageLibraryEditor";
            } else {
                eventProperties.triggerOrigin = "ImageLibraryTab";
            }

            EditorEvents.trigger(EditorEvents.constants.UPLOAD_IMAGE, eventProperties);
        },
        _determineScrollTarget: function _determineScrollTarget() {
            var scrollTarget = result(this.options, "scrollTarget") || result(this.viewScope, "scrollTarget");

            return scrollTarget || this.$(".content");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);

    // "MANUAL" is the user created tag type.
    // "ZMAGS_GROUP_ID" is generated by inventory.
    // Anything else is generated by Amazon Rekognition
    var Types = {
        MANUAL: "MANUAL",
        ZMAGS_GROUP_ID: "ZMAGS_GROUP_ID"
    };

    return Backbone.Model.extend({

        defaults: {
            name: "",
            /**
             * how confident this tag is relevant
             * @type number
             */
            confidence: 100,
            type: Types.MANUAL
        },

        /**
         *
         * @param {number} truncateLength example. 30 for first 30 chars
         * @returns {string[]} array of truncated tag names
         */
        toTruncatedTagName: function toTruncatedTagName(truncateLength) {
            var tagName = this.get("name");
            if (tagName.length > truncateLength) {
                return tagName.substring(0, truncateLength) + "\u2026"; // \u2026 = "..."
            }
            return tagName;
        }
    }, {
        Types: Types
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);

    // Regular expression to match the first line in a text...
    var FIRST_LINE_REGEX = /[.,;]|\n|<br>|<p>/igm;
    var TRIM_FIRST = /^\s+/;
    var TRIM_LAST = /\s+$/;

    /**
     * Contains text utility functions.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     *
     * @class TextUtil
     */
    var scope = {

        /**
         * Returns the "first logical line" of text from the supplied text. <p>
         *
         * The first line is determined as, in order:
         * - The first line ending with a dot (.), comma (,), or semi-colon (;).
         * - The text until the first new line or html break ("br" or "p" tag).
         *
         * In either case, the first line will be trimmed and have new lines and "br"/"p" removed (if matched on dot
         * or semi-colon), and will be truncated to the supplied maximum of characters. If truncated, ... will be
         * appended to the text. The first line matcher, e.g. a dot, will not be included in the first line.
         *
         * @param   {String}         text    The text to extract the first line from; if falsey, the empty string is
         *                                   returned.
         * @param   {Number|Boolean} [max]   The maximum numbers of allowed characters, defaulting to 32. Can also be
         *                                   <tt>quote</tt>.
         * @param   {Boolean}        [quote] True to quote the first line of text if non empty, false otherwise
         *                                   (default). Can also be supplied as the second argument.
         *
         * @returns {String} The first line of text; never null/undefined, but can be the empty string.
         */
        firstLine: function firstLine(text, max, quote) {
            // Removed prefixed spaces...
            text = (text || "").replace(TRIM_FIRST, "");
            if (text) {
                if (_.isBoolean(max)) {
                    quote = max;
                    max = 32;
                } else {
                    max = max || 32;
                }
                if (FIRST_LINE_REGEX.test(text)) {
                    text = text.substring(0, FIRST_LINE_REGEX.lastIndex - 1);
                }
                // Trim tailing spaces before we test the max length...
                text = text.replace(TRIM_LAST, "");
                if (text.length > max) {
                    // Truncate, trim last (again), and add ...
                    text = text.substring(0, max).replace(TRIM_LAST, "") + " &#x85;";
                }
                // Could be trimmed entirely, and we do not want to quote the empty string...
                if (quote && text) {
                    text = "\"" + text + "\"";
                }
            }
            return text;
        },


        /**
         * Lists the elements in the specified array, where each element is separated by the supplied
         * separator, with the last separator optionally different.
         *
         * @param {Array|*}  array          The array list generate a list form of; if non an array, will be returned
         *                                  as is. The array is not modified by this call.
         * @param {String}  [separator]     The separator used; will default to ", ".
         * @param {String}  [lastSeparator] The separator used; will default to (the defaulted) <tt>separator</tt>.
         *
         * @return {String|*} A list form the the supplied array; will be <tt>array</tt> as-is if not an array.
         */
        list: function list(array, separator, lastSeparator) {
            var text = array;
            var last = void 0;

            if (_.isArray(array)) {
                if (!separator) {
                    separator = ", ";
                }
                if (!lastSeparator) {
                    lastSeparator = separator;
                }

                if (separator !== lastSeparator) {
                    last = array.pop();
                    text = array.join(separator) + lastSeparator + last;
                    array.push(last); // do not mess up incoming array!
                } else {
                    text = array.join(separator);
                }
            }
            return text;
        }
    };

    return scope;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Browser = __webpack_require__(39);
    var EditBehavior = __webpack_require__(106);
    var ImageDetailsTrackingBehavior = __webpack_require__(863);
    var ImageTagCompositeView = __webpack_require__(557);
    var InventoryTagCompositeView = __webpack_require__(867);
    var ImageLibrarySourceEnum = __webpack_require__(102);
    var ImageTooltipView = __webpack_require__(1736);
    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(1738);
    var Tooltip = __webpack_require__(35);

    // The same dimension we set to the CSS.
    var THUMB_WIDTH = 215;
    var THUMB_HEIGHT = 140;
    var DEFAULT_RATIO = THUMB_WIDTH / THUMB_HEIGHT;

    /**
     * ImprovedView for an image in the image library.
     *
     * @class ImageThumbnailView
     * @constructor
     *
     * @cfg {Boolean} [enableDeletion] Whether to allow deletion of an image via the view, disabled by default.
     * @cfg {Boolean} [showImageInfo] Whether to display info about the image in the view.
     * @cfg {Boolean} [draggable] Whether the image view should be draggable.
     * @cfg {Boolean} [showTooltips] Whether to show a tooltip with image info when the view is
     *                               hovered.
     */
    return ImprovedView.extend({

        _highlighted: false,

        className: "image-wrapper",

        options: {
            enableDeletion: false
        },

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                isEditable: this.options.isEditable,
                enableDeletion: this.options.enableDeletion,
                uploading: this.model.has("uploading"),
                timesUsed: this.model.get("timesUsed"),
                absoluteThumbUrl: this.model.get("absoluteThumbUrl"),
                displaySize: this.model.get("displaySize"),
                extension: this.model.get("extension"),
                imageTaggingEnabled: this.options.imageTaggingEnabled,
                inventoryEnabled: this.options.inventoryEnabled
            };
        },


        regions: {
            imageTagsRegion: ".imageTagsRegion",
            inventoryTagsRegion: ".inventoryTagsRegion"
        },

        bindings: {
            ".js-name": {
                // We need to use updateMethod "html" and escape true, because we are using a tag
                // contenteditable.
                observe: "name",
                updateMethod: "html",
                escape: true
            },
            ".js-alt-text": {
                observe: "altText",
                updateMethod: "html",
                escape: true
            }
        },

        behaviors: {
            nameEditBehavior: {
                behaviorClass: EditBehavior,
                container: ".js-name-editable-container",
                editFields: [{
                    input: ".js-name",
                    icon: ".js-name-icon",
                    hideOnFocus: [".times-used"],
                    model: "name",
                    save: function save() {
                        this.model.saveLater();
                    }
                }]
            },
            altTextEditBehavior: {
                behaviorClass: EditBehavior,
                container: ".js-alt-text-editable-container",
                editFields: [{
                    input: ".js-alt-text",
                    icon: ".js-alt-text-icon",
                    model: "altText",
                    save: function save() {
                        this.model.saveLater();
                    }
                }]
            },
            imageEditingTracking: {
                behaviorClass: ImageDetailsTrackingBehavior,
                tracking: {
                    name: "EditImageNameInputField",
                    altText: "EditImageAltTextInputField"
                }
            }
        },

        ui: {
            deleteImage: ".delete",
            noDeleteImage: ".no-delete",
            imageInfo: ".image-info",
            progressBar: ".progress-bar",
            imgPencil: ".img-pencil",
            timesUsed: ".times-used",
            image: ".image",
            imageThumb: ".image-thumb"
        },

        modelEvents: {
            "change:uploading change:timesUsed change:inventoryTags change:imageTags": "_imageCountChangeHandler",
            "change:progress": "_changeProgressHandler"
        },

        events: {
            click: "_clickHandler",
            dragstart: "_dragStartHandler",
            dragend: "_dragEndHandler",
            "click @ui.imageThumb": "_imageThumbClickHandler",
            "click @ui.deleteImage": "_deleteImageClickHandler"
        },

        initialize: function initialize() {
            this._highlighted = !!this.options.highlighted;
        },


        /**
         * Marks the image as highlighted, i.e. applying the <tt>highlighted</tt> CSS class.
         *
         * @param  {Boolean} value Whether the image should be highlighted or not.
         */
        highlight: function highlight(value) {
            this._highlighted = value;

            this._updateHighlightedState();
        },
        _clickHandler: function _clickHandler() {
            this.trigger("selected", this.model, this);
        },
        _imageThumbClickHandler: function _imageThumbClickHandler() {
            this.trigger("image:clicked", this.model, this);
        },
        _deleteImageClickHandler: function _deleteImageClickHandler() {
            Tooltip.hide(this.ui.deleteImage);

            if (this.options.isEditable && !this.model.get("timesUsed") && confirm("Are you sure you want to delete this image?")) {
                this.model.destroy();
            }
        },
        _imageCountChangeHandler: function _imageCountChangeHandler() {
            this.render();
        },
        _updateHighlightedState: function _updateHighlightedState() {
            if (this.el) {
                this.$el.toggleClass("highlighted", this._highlighted);
            }
        },
        _changeProgressHandler: function _changeProgressHandler(imageModel, progress) {
            this._updateUploadingBar(progress);
        },
        _dragStartHandler: function _dragStartHandler(event) {
            // Prevent default dragging behavior and bail out if "dragging" is not enabled.
            if (!this.options.draggable) {
                return event.preventDefault();
            }
            // Firefox has a bug that causes it to offset the dragged image when displayed in a lightbox. Workaround is
            // to explicitly set the drag image to the dragged element.
            if (Browser.type.firefox) {
                event.originalEvent.dataTransfer.setDragImage(this.el, this.$el.width() / 2, this.$el.height() / 2);
            }

            var data = {
                type: "image",
                options: {
                    imageID: this.model.id
                }
            };

            if (this.model.get("sourceType")) {
                data.options.sourceType = this.model.get("sourceType");
            }

            event.originalEvent.dataTransfer.setData("Text", JSON.stringify(data));

            this.$el.parents("body").addClass("internal-drag");
            // Cancel showing the bootstrap popover.
            this._closeTooltip();
        },
        _dragEndHandler: function _dragEndHandler() {
            this.$el.parents("body").removeClass("internal-drag");
        },
        onRender: function onRender() {
            var _options = this.options,
                draggable = _options.draggable,
                imageTaggingEnabled = _options.imageTaggingEnabled,
                showImageInfo = _options.showImageInfo,
                showTooltips = _options.showTooltips,
                showTimesUsedTooltip = _options.showTimesUsedTooltip,
                inventoryEnabled = _options.inventoryEnabled,
                isEditable = _options.isEditable;
            var _ui = this.ui,
                timesUsed = _ui.timesUsed,
                noDeleteImage = _ui.noDeleteImage,
                deleteImage = _ui.deleteImage;


            this.$el.attr("draggable", !!draggable);

            if (inventoryEnabled) {
                var tagsCollection = this.model.get("inventoryTags");
                var limitedTagCollection = tagsCollection.newCopySortedByConfidence(5);

                // Make sure the copied version of the collection gets updated when removing or adding new models
                this.listenTo(tagsCollection, "add remove sort", function () {
                    limitedTagCollection.reset(tagsCollection.newCopySortedByConfidence(5).models);
                });

                this.inventoryTagsRegion.show(new InventoryTagCompositeView({
                    tagCollection: this._tagsCollection,
                    collection: limitedTagCollection
                }));
            }

            if (imageTaggingEnabled) {
                var _tagsCollection = this.model.get("imageTags");
                var _limitedTagCollection = _tagsCollection.newCopySortedByConfidence(5);

                // Make sure the copied version of the collection gets updated when removing or adding new models
                this.listenTo(_tagsCollection, "add remove sort", function () {
                    _limitedTagCollection.reset(_tagsCollection.newCopySortedByConfidence(5).models);
                });

                this.imageTagsRegion.show(new ImageTagCompositeView({
                    tagCollection: this._tagsCollection,
                    collection: _limitedTagCollection
                }));
            }

            if (!showImageInfo) {
                this.ui.imageInfo.remove();
            }

            var isScene7 = this.model.isSource(ImageLibrarySourceEnum.SCENE7);

            if (showTooltips) {
                Tooltip.add(this.$el, {
                    content: new ImageTooltipView({
                        model: this.model,
                        showExtension: !isScene7,
                        showTags: imageTaggingEnabled && !isScene7,
                        isScene7: isScene7
                    }),
                    container: "body",
                    width: 200,
                    html: true,
                    offset: {
                        align: "right",
                        elementWidth: 50
                    },
                    delay: {
                        show: 1000,
                        hide: 0
                    }
                });
            }

            if (showTimesUsedTooltip) {
                Tooltip.add(timesUsed, {
                    placement: "top",
                    alignCenter: true,
                    width: 220
                });
            }

            // Tooltips for delete button.
            Tooltip.add(noDeleteImage, {
                placement: "top",
                alignCenter: true,
                width: 260
            });

            Tooltip.add(deleteImage, {
                placement: "top",
                alignCenter: true,
                width: isEditable ? 150 : 180
            });

            this._updateHighlightedState();
            this.scaleUp();
        },


        /**
         * This operation is for backwards compatibility (before 20 Oct. 2015) so that images will
         * fit the new box size 215 x 140. To avoid blurry images by scaling up small icons, we
         * only apply it to images wider than 190 or taller than 140.
         */
        scaleUp: function scaleUp() {
            if (this.model.get("width") >= 190 || this.model.get("height") >= 140) {
                var ratio = this.model.get("width") / this.model.get("height");
                var cssClass = ratio > DEFAULT_RATIO ? "horizontal-scale" : "vertical-scale";

                this.ui.image.addClass(cssClass);
            }
        },


        /**
         * Close the boostrap popover if the showToolTips option is true
         */
        _closeTooltip: function _closeTooltip() {
            if (this.options.showTooltips) {
                this.$el.trigger("mouseout");
            }
        },
        onClose: function onClose() {
            this._closeTooltip();
        },
        _showProgress: function _showProgress() {
            return this.model.get("uploading");
        },
        _updateUploadingBar: function _updateUploadingBar(progress) {
            this.ui.progressBar.width(progress * 100 + "%");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var TagCompositeView = __webpack_require__(864);
    var ImageTagTrackingBehavior = __webpack_require__(1733);
    var template = __webpack_require__(1734);

    /**
     * Renders a collection of tags.
     *
     * @see ImageTagCollection
     * @see ImageTagModel
     *
     * @class ImageTagCompositeView
     */
    return TagCompositeView.extend({

        template: template,

        events: {
            "submit .image-tag-new-form": "_tagSubmitHandler",
            "keydown @ui.tagInput": "_tagInputKeydownHandler"
        },

        behaviors: {
            imageTagTracking: {
                behaviorClass: ImageTagTrackingBehavior
            }
        },

        ui: {
            formGroup: ".form-group",
            tagInput: ".tag-input",
            tagInputMessage: ".tag-input-message"
        },

        itemViewOptions: function itemViewOptions() {
            return {
                editable: this.options.editable,
                triggerSource: this
            };
        },
        templateHelpers: function templateHelpers() {
            return {
                editable: this.options.editable,
                maxNameLength: this.itemView.TAG_NAME_MAX_LENGTH
            };
        },
        _tagSubmitHandler: function _tagSubmitHandler() {
            var newTagNameValue = this.$input.val().trim();
            var validation = this._validateTag(newTagNameValue);

            this.$formGroup.toggleClass("has-error", !validation.valid);
            if (validation.valid) {
                var newTag = { name: newTagNameValue };
                this.collection.add(newTag, { triggerSource: this });
                this.options.tagCollection.add(newTag, { triggerSource: this });
                this.$input.val("");
            } else {
                this.$el.find(this.ui.tagInputMessage).text(validation.error);
            }

            return false;
        },
        _validateTag: function _validateTag(value) {
            if (value.length === 0) {
                return {
                    valid: false,
                    error: "Missing tag name"
                };
            }

            var existingName = this.collection.find(function (model) {
                return model.get("name").toUpperCase() === value.toUpperCase();
            });

            if (existingName) {
                return {
                    valid: false,
                    error: "Tag already exists!"
                };
            }

            return {
                valid: true,
                error: null
            };
        },
        onRender: function onRender() {
            this.$input = this.$el.find(this.ui.tagInput);
            this.$formGroup = this.$el.find(this.ui.formGroup);

            if (this._focusInputOnRender) {
                this.$el.find(this.ui.tagInput).focus();
                this._focusInputOnRender = false;
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var Preconditions = __webpack_require__(14);
    var template = __webpack_require__(1743);

    var SLIDER_VALUE_INPUT_WIDTH = 30;
    var SLIDER_THUMB_SIZE = 15;
    var SLIDER_THUMB_ADJUSTMENT = (SLIDER_VALUE_INPUT_WIDTH - SLIDER_THUMB_SIZE) / 2;
    var DEFAULT_STEP = 10;
    var DEFAULT_MIN_VAL = 0;
    var DEFAULT_MAX_VAL = 100;

    function identity(x) {
        return x;
    }
    /**
     * The RangeInput class takes various attributes to customize the slider
     * (step, minVal, maxVal, unit, minLabel, maxLabel)
     */
    return ImprovedView.extend({
        _onGetConverter: null,
        _onSetConverter: null,
        _modelAttribute: null,
        _minVal: null,
        _maxVal: null,
        _sliderWidth: null,

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                step: this.options.step || DEFAULT_STEP,
                minVal: this.options.minVal || DEFAULT_MIN_VAL,
                maxVal: this.options.maxVal || DEFAULT_MAX_VAL,
                staticVal: this.options.staticVal,
                unit: this.options.unit,
                minLabel: this.options.minLabel,
                maxLabel: this.options.maxLabel
            };
        },


        ui: {
            slider: ".slider",
            sliderValue: ".slider-value",
            staticValue: ".static-value",
            sliderLeftColor: ".slider-left-color"
        },

        onRender: function onRender() {
            Preconditions.isModel(this.options.model);
            Preconditions.isString(this.options.modelAttribute);

            this._modelAttribute = this.options.modelAttribute;
            this._onGetConverter = this.options.onGetConverter || identity;
            this._onSetConverter = this.options.onSetConverter || identity;
            this._minVal = this.options.minVal || DEFAULT_MIN_VAL;
            this._maxVal = this.options.maxVal || DEFAULT_MAX_VAL;
            this._bindSliderToModel();

            this.listenTo(this.model, "change:" + this._modelAttribute, this._modelAttributeChangeHandler);
            this._updateDynamicValuePosition(this.model.get(this._modelAttribute));
            this._updateStaticValuePosition(this.options.staticVal);
            this._colorTheBar(this._onGetConverter(this.model.get(this._modelAttribute)));
        },


        /**
         * To be able to use the modelAttribute from the options object
         * we set up Stickit bindings manually
         */
        _bindSliderToModel: function _bindSliderToModel() {
            this.stickit(this.model, {
                ".slider": {
                    observe: this._modelAttribute,
                    onSet: function onSet(value) {
                        return this._onSetConverter(parseInt(value, 10));
                    },
                    onGet: function onGet(value) {
                        return this._onGetConverter(value);
                    }
                },
                ".slider-value": {
                    observe: this._modelAttribute,
                    onGet: function onGet(value) {
                        return this._onGetConverter(value);
                    }
                }
            });
        },
        _modelAttributeChangeHandler: function _modelAttributeChangeHandler(model, value) {
            this._updateDynamicValuePosition(value);
            this._colorTheBar(this._onGetConverter(value));
        },
        _updateDynamicValuePosition: function _updateDynamicValuePosition(value) {
            this.ui.sliderValue.css(this._calculateValuePosition(this._onGetConverter(value)));
        },
        _updateStaticValuePosition: function _updateStaticValuePosition(value) {
            this.ui.staticValue.css(this._calculateValuePosition(value));
        },
        _calculateValuePosition: function _calculateValuePosition(displayValue) {
            var left = (displayValue - this._minVal) * 100 / (this._maxVal - this._minVal);
            var marginLeft = left / 100 * SLIDER_THUMB_SIZE + SLIDER_THUMB_ADJUSTMENT;

            left = Math.max(left, 0);
            left = Math.min(left, 100);

            return { left: left + "%", marginLeft: -marginLeft };
        },
        _colorTheBar: function _colorTheBar(displayValue) {
            var leftWidth = (displayValue - this._minVal) * 100 / (this._maxVal - this._minVal);
            this.ui.sliderLeftColor.css({
                width: leftWidth + "%"
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorEvents = __webpack_require__(17),
        ColorPicker = __webpack_require__(208),
        OpacityPropertiesView = __webpack_require__(871),
        template = __webpack_require__(1756),
        AbstractWidgetPropertiesView = __webpack_require__(63),
        MathUtil = __webpack_require__(72).default;

    // For the color picker
    var DEFAULT_COLOR = "#000000",

    // Applied when the different styles are toggled on
    DEFAULT_SHADOW = "rgb(0, 0, 0) 2px 2px 10px 0px";

    var EXPAND_PROPERTY = "styleExpanded";

    /**
     * The properties view for size and position information.
     *
     * @class SizeAndPositionPropertiesView
     * @constructor
     *
     * @cfg {AbstractWidgetModel} model The widget being edited.
     * @cfg {boolean} [hideSizeControls] If true, the size controls will be hidden.
     * @cfg {boolean} [hideRotation] If true, the rotation control will be hidden.
     * @cfg {boolean} [hideOpacityControls] If true, the opacity control will be hidden.
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        _borderColorPicker: null,

        template: template,

        regions: {
            opacityProperties: ".opacity-properties-region"
        },

        templateHelpers: function templateHelpers() {
            return {
                showBorderControls: !this.options.hideBorderControls,
                showOpacityControls: !this.options.hideOpacityControls,
                showRadiusControls: !this.options.hideRadiusControls
            };
        },

        events: {
            "shown.bs.collapse .style-properties-container": function shownBsCollapseStylePropertiesContainer() {
                this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] = true;
            },
            "hidden.bs.collapse .style-properties-container": function hiddenBsCollapseStylePropertiesContainer() {
                this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] = false;
            },
            "click .border": "_toggleBorderWidth",
            "click .opacity": "_toogleOpacity",
            "click .radius": "_toogleRadius"
        },

        ui: {
            container: ".style-properties-container",
            legend: "[data-target=\".style-properties-container\"]",

            borderCheckBox: ".border",
            borderProperties: ".border-properties",
            borderWidth: ".border-width",
            borderColorBox: ".border-color-box",
            borderColorInput: ".border-color-input",

            radiusCheckBox: ".radius",
            radiusProperties: ".radius-properties-region",

            opacityCheckBox: ".opacity",
            opacityProperties: ".opacity-properties-region"
        },

        bindings: {
            ".border": {
                observe: "borderWidth",
                onGet: function onGet(value) {
                    return value > 0;
                },
                onSet: function onSet(value) {
                    return value ? parseInt(this.ui.borderWidth.val(), 10) : null;
                }
            },
            ".border-width": {
                observe: "borderWidth",
                selectOptions: {
                    collection: [{ value: 1, label: "1px" }, { value: 2, label: "2px" }, { value: 3, label: "3px" }, { value: 5, label: "5px" }, { value: 10, label: "10px" }]
                }
            },
            ".border-color-input": "borderColor",
            ".shadow": {
                observe: "boxShadow",
                onGet: function onGet(value) {
                    return !!value;
                },
                onSet: function onSet(value) {
                    if (value) {
                        var viewModel = this.viewScope.viewModel,
                            experience = viewModel.get("experience"),
                            eventProperties = {
                            widgetType: this.model.get("type"),
                            updatedProperty: "style",
                            updatedValue: "shadow",
                            experienceId: experience.get("id"),
                            experienceVersion: experience.get("version"),
                            experiencePushedVersion: experience.get("pushedVersion"),
                            sceneNumber: viewModel.get("sceneNumber"),
                            triggerOrigin: "WidgetMenuStyleCheckbox"
                        };

                        EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
                    }
                    return value ? DEFAULT_SHADOW : null;
                }
            },
            ".border-radius-input": {
                observe: "radius",
                onGet: function onGet(value) {
                    return value || 0;
                },
                onSet: function onSet(value) {
                    return parseInt(value, 10) || 0;
                }
            }
        },

        onRender: function onRender() {
            this.__super();

            if (!this.options.hideBorderControls) {
                this._borderColorPicker = new ColorPicker({
                    color: this.model.get("borderColor") || DEFAULT_COLOR,
                    input: this.ui.borderColorInput,
                    colorBox: this.ui.borderColorBox
                });
            }

            if (!this.options.hideRadiusControls) {
                if (this.model.get("radius")) {
                    this.ui.radiusCheckBox.prop("checked", true);
                    this.model.get("radius");
                } else {
                    this.ui.radiusProperties.hide();
                }
            }

            if (!this.options.hideOpacityControls) {
                this.opacityProperties.show(new OpacityPropertiesView({ model: this.model, hideName: true }));

                if (this.model.get("opacity") !== 1) {
                    this.ui.opacityCheckBox.prop("checked", true);
                } else {
                    this.ui.opacityProperties.hide();
                }
            }

            this.ui.borderProperties.toggle(this.model.has("borderWidth"));

            this.listenTo(this.model, "change:borderWidth", this._repositionAndResizeWidget.bind(this));
        },

        // This method is called after border of widget has been chaged
        //
        // The rounding here helps not to lost all the precision changes
        // to the integer pixels contain rounding
        // in other words: removes the redundant accuracy
        //
        // TODO: Fix the border adding to widget width here
        // https://jira.zmags.com/browse/DEV-2573
        _repositionAndResizeWidget: function _repositionAndResizeWidget() {
            var from = this.model.previousAttributes().borderWidth || 0,
                to = this.model.get("borderWidth") || 0,
                diff = to - from;

            // if for whatever reason we aren't getting numbers out of the above we cancel the
            // operation
            if (typeof diff !== "number") {
                return;
            }

            var experienceModel = this.viewScope.viewModel.get("experience"),
                diffSize = experienceModel.getPercentageSize({ width: diff, height: diff });
            // reposition widget so top left corner doesn't change position
            this.model.set({
                left: this.model.get("left") - MathUtil.roundToContain(diffSize.width, experienceModel.get("width")),
                top: this.model.get("top") - MathUtil.roundToContain(diffSize.height, experienceModel.get("height"))
            });

            if (this.model.has("width") && this.model.has("height")) {
                // resize widget (to adjust for the new border width)
                this.model.set({
                    width: this.model.get("width") + 2 * MathUtil.roundToContain(diffSize.width, experienceModel.get("width")),
                    height: this.model.get("height") + 2 * MathUtil.roundToContain(diffSize.height, experienceModel.get("height"))
                });
            }
        },

        onClose: function onClose() {
            // Custom color picker cleanup
            if (this._borderColorPicker) {
                this._borderColorPicker.dispose();
            }
        },

        _toggleBorderWidth: function _toggleBorderWidth() {
            if (this.ui.borderCheckBox.is(":checked")) {
                this.ui.borderProperties.slideDown();

                var viewModel = this.viewScope.viewModel,
                    experience = viewModel.get("experience"),
                    eventProperties = {
                    widgetType: this.model.get("type"),
                    updatedProperty: "style",
                    updatedValue: "stroke",
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    sceneNumber: viewModel.get("sceneNumber"),
                    triggerOrigin: "WidgetMenuStyleCheckbox"
                };

                EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
            } else {
                this.ui.borderProperties.slideUp();
            }
        },

        _toogleRadius: function _toogleRadius() {
            if (this.ui.radiusCheckBox.is(":checked")) {
                this.ui.radiusProperties.slideDown();

                var viewModel = this.viewScope.viewModel,
                    experience = viewModel.get("experience"),
                    eventProperties = {
                    widgetType: this.model.get("type"),
                    updatedProperty: "style",
                    updatedValue: "radius",
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    sceneNumber: viewModel.get("sceneNumber"),
                    triggerOrigin: "WidgetMenuStyleCheckbox"
                };

                EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
            } else {
                this.ui.radiusProperties.slideUp();
                this.model.set("radius", 0);
            }
        },

        _toogleOpacity: function _toogleOpacity() {
            if (this.ui.opacityCheckBox.is(":checked")) {
                this.ui.opacityProperties.slideDown();

                var viewModel = this.viewScope.viewModel,
                    experience = viewModel.get("experience"),
                    eventProperties = {
                    widgetType: this.model.get("type"),
                    updatedProperty: "style",
                    updatedValue: "opacity",
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    sceneNumber: viewModel.get("sceneNumber"),
                    triggerOrigin: "WidgetMenuStyleCheckbox"
                };

                EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
            } else {
                this.ui.opacityProperties.slideUp();
                this.model.set("opacity", 1);
            }
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var Configuration = __webpack_require__(27);
    var DuplicateExperienceAction = __webpack_require__(405);
    var ErrorHandler = __webpack_require__(119);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Login = __webpack_require__(177);
    var Window = __webpack_require__(48);

    var log = new Logger("ErrorLogger"); // consistent name for all frontend errors

    // Short-cuts...
    var Actions = ErrorHandler.Actions,
        Codes = ErrorHandler.Codes;

    /**
     * The error page article on the Community, relative to the configured community base url. We use a page
     * for each error code because of Zendesk's poor UI. <p>
     *
     * Keys are <tt>error.code</tt>, see <tt>ErrorHandler.fromHttp<tt> (and elsewhere).
     * @type {Map<string, string>}
     */

    var ERROR_PAGES = new Map();

    ERROR_PAGES.set(Codes.BAD_REQUEST, "201545049");
    ERROR_PAGES.set(Codes.UNSUPPORTED, "201545069");
    ERROR_PAGES.set(Codes.UPLOAD, "202153305"); // same as "unsupported", but for Images specifically
    ERROR_PAGES.set(Codes.FORBIDDEN, "201545029");
    ERROR_PAGES.set(Codes.NOT_FOUND, "201545079");
    ERROR_PAGES.set(Codes.TIMEOUT, "201545099");
    ERROR_PAGES.set(Codes.VERSIONING, "201544999");
    ERROR_PAGES.set(Codes.UNKNOWN, "201545009");
    ERROR_PAGES.set(Codes.UNHANDLED, "201545019");

    /**
     * A user <i>error action</i> describes a user response to some error action, i.e. "reload", "retry", "duplicate",
     * "community", or "support", or a combination thereof, like the user clicking a support link or doing a manual
     * reload. The actions are defined by <tt>ErrorHandler.Actions</tt>. <p>
     *
     * It is used by the editor only.
     *
     * @class ErrorAction
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    var ErrorAction = Class.extend({

        /**
         * @private @type {EditorStatsDAnalytics}
         * The statsD analytics to track when the user clicks to take some recovery action based on an error.
         */
        _statsD: null,

        /**
         * Associate, or not, the supplied statsD client with this error action, to be notified each time
         * an user response to some error action is activated.
         *
         * @param {EditorStatsDAnalytics} statsD The statsD client, if any; can be null/undefined.
         */
        statsD: function statsD(_statsD) {
            this._statsD = _statsD;
        },


        /**
         * Returns a callback to activate the user's response to the supplied error, such as performing a "reload" of
         * the model associated with the error, or trying a manual save. <p>
         *
         * If <tt>error.collection</tt> is defined, <tt>forCollection</tt> is called to create the callback,
         * otherwise if <tt>error.model</tt> is defined, <tt>forModel</tt> is called to create the callback;
         * otherwise <tt>forAction</tt> is called.
         *
         * @param  {*}      error    The error in question; cannot be null.
         * @param  {String} [action] The specific action(s) to take, can differ from <tt>error.action</tt>, but
         *                           will default to it.
         *
         * @return {Function} A callback as described to be invoked when the action is to be performed; never null.
         */
        forError: function forError(error) {
            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : error.action;

            if (error.collection) {
                return this.forCollection(error.collection, action);
            }
            if (error.model) {
                return this.forModel(error.model, action);
            }
            return this.forAction(action, error);
        },


        /**
         * Returns a callback to activate the user's response to an error related to the supplied collection.
         * Right now it can only handle a failed fetch for the collection but may be easily extended to support more.
         *
         * Once the callback is activated, the relevant StatsD counter will be incremented, for example
         * "user.action." + action + "." + context, e.g. "user.action.retry.notificationbar".
         *
         * @param   {Collection} collection  The model in question; can be null, in which case <tt>forAction</tt> is
         *                                  used. The error in question is deduced from this model.
         * @param   {String}       [action]  The specific action(s) to take, can differ from <tt>error.action</tt>,
         *                                  but will default to it.
         *
         * @returns {Function} A callback as described to be invoked when the action is to be performed; never null.
         */
        forCollection: function forCollection(collection, action) {
            var _this = this;

            return function (context, done) {
                if (action.indexOf(Actions.RETRY) >= 0) {
                    var state = collection.syncState.current;
                    // Save a reference to the sync method, since it will/may be updated because of the action...
                    var method = state.method;

                    _this._track(Actions.RETRY + "." + method, context);

                    if (method === "fetch") {
                        // following is exactly the same to what we do for models below in `forModel()` method
                        setTimeout(function () {
                            window.location.reload(true);
                        }, 250); // to allow stats to complete
                        if (done) {
                            done(Actions.RETRY, collection);
                        }
                    } else {
                        log.warn("unknown method: " + method);
                    }
                } else {
                    log.warn("unknown action: " + action + " for collections");
                }
            };
        },


        /**
         * Returns a callback to activate the user's response to an error related to the supplied model, such
         * as performing a "reload" of the model or trying a manual save. <p>
         *
         * The returned callback has the form <tt>fn(context:String, done:Function, fail:Function)</tt>, where
         * <tt>context</tt> is used to identify the context for statsD, e.g. "notificationbar". <tt>done</tt> and
         * </tt>fail</tt> are callbacks to be invoked on success and failure, respectively, where <tt>done</tt>
         * has the form <tt>fn(action:String, model:ImprovedModel)</tt> and <tt>fail</tt> has the form
         * <tt>fn(action:String, model:ImprovedModel, xhr:*)</tt>.
         *
         * Once the callback is activated, the relevant StatsD counter will be incremented, for example
         * "user.action." + action + "." + context, e.g. "user.action.reload.notificationbar".
         *
         * @param  {ImprovedModel} model    The model in question; can be null, in which case <tt>forAction</tt> is
         *                                  used. The error in question is deduced from this model.
         * @param  {String}        [action] The specific action(s) to take, can differ from <tt>error.action</tt>, but
         *                                  will default to it.
         *
         * @return {Function} A callback as described to be invoked when the action is to be performed; never null.
         */
        forModel: function forModel(model, action) {
            var _this2 = this;

            if (!model) {
                return this.forAction(action);
            }
            var url = window.location.href; // save a reference to ensure we do not reload another url at some point in the future...

            return function (context, done, fail) {
                var state = model.syncState.current;
                var id = model.get("id");
                var promise = void 0;

                if (!state.error) {
                    state = model.syncState.actual;
                }
                // Use specified action, or default to the one from the sync state of the desired model...
                action = action || state.error && state.error.action || "";
                // Save a reference to the sync method, since it will/may be updated because of the action...
                var method = state.method;

                // Duplicate? For now, we can only copy Experiences...
                if (action.indexOf(Actions.DUPLICATE) !== -1 && model.__typeName === "Experience") {
                    _this2._track(Actions.DUPLICATE + "." + method, context, id);

                    // We postfix the name of the clone with "copy", not "new" as default, to keep the two
                    // scenarios distinct from a user's point of view...
                    promise = new DuplicateExperienceAction(model, { postfix: "copy" }).execute().done(function (clone) {
                        if (done) {
                            done(Actions.DUPLICATE, clone, model);
                        }
                    });

                    if (fail) {
                        promise.fail(function (xhr) {
                            fail(Actions.DUPLICATE, model, xhr);
                        });
                    }
                }

                // Reload (or retry)?
                if (action.indexOf(Actions.RELOAD) !== -1) {
                    _this2._track(Actions.RELOAD + "." + method, context, id);

                    // Try and reload the model, and if that fails, do a full editor reload...
                    promise = model.fetch({ triggeredByServerUpdate: true }).fail(function (xhr) {
                        // since the change handlers will trigger a save event...
                        if (fail) {
                            fail(Actions.RELOAD, model, xhr);
                        }
                        if (url === window.location.href) {
                            log.error("Could not reload model, will reload url: <" + url + ">");
                            window.location.reload(true);
                        }
                    }).done(function () {
                        if (done) {
                            done(Actions.RELOAD, model);
                        }
                    });

                    // Retry? All these actions can fail, of course, but they will already be hooked into using the
                    // sync:state life cycle, so it should be fine, i.e. we can end up here again based on a new/
                    // duplicate error...
                } else if (action.indexOf(Actions.RETRY) !== -1) {
                    _this2._track(Actions.RETRY + "." + method, context, id);

                    if (method === "save" || method === model.syncState.alias.save) {
                        // save, or aliased save, like "share"...
                        promise = model.save();
                    } else if (method === "destroy") {
                        // never aliased for now...
                        promise = model.destroy();

                        // We could get an issue if the reload fails, i.e. a fetch fails, so better reload all then. We
                        // do not check the url, we need the entire reload...
                    } else if (method === "fetch") {
                        setTimeout(function () {
                            window.location.reload(true);
                        }, 250); // to allow stats to complete
                        if (done) {
                            done(Actions.RETRY, model);
                        }

                        // Experiences or Group only!
                    } else if (method === "push") {
                        promise = model.push();

                        // Group only!
                    } else if (method === "push-with-assets") {
                        promise = model.push(true); // true = with assets
                    }

                    if (promise) {
                        if (done) {
                            promise.done(function () {
                                done(Actions.RETRY, model);
                            });
                        }
                        if (fail) {
                            promise.fail(function (xhr) {
                                fail(Actions.RETRY, model, xhr);
                            });
                        }
                    }
                }

                // Relogin?
                if (action.indexOf(Actions.RELOGIN) !== -1) {
                    _this2._track(Actions.RELOGIN + "." + method, context, id);
                    promise = Login.relogin();
                    if (done) {
                        promise.done(function (principal) {
                            done(Actions.RELOGIN, principal);
                        });
                    }
                    if (fail) {
                        promise.fail(function (xhr) {
                            fail(Actions.RELOGIN, xhr);
                        });
                    }
                }

                // Link to community (as well)?
                if (action.indexOf(Actions.COMMUNITY) !== -1) {
                    var key = _this2._communityLink(state.error); // key will include prefix dot where relevant!
                    _this2._track(Actions.COMMUNITY + key + "." + method, context, id);
                    if (done) {
                        done(Actions.COMMUNITY, model);
                    }
                }
            };
        },


        /**
         * Returns a callback to activate the user's response for the supplied action(s). <p>
         *
         * The returned callback has the form <tt>fn(context:String, done:Function)</tt>, where
         * <tt>context</tt> is used to identify the context for statsD, e.g. "notificationbar". <tt>done</tt>
         * is a callback to be invoked on success and has the form <tt>fn(action:String)</tt>.
         *
         * @param  {String}  [action] The specific action; will default to the empty string, i.e. do nothing.
         * @param  {*}       [error}  The error in question; optional.
         * @return {Function} A callback as described to be invoked when the action is to be performed; never null.
         */
        forAction: function forAction(action, error) {
            var _this3 = this;

            var url = window.location.href;

            return function (context, done, fail) {
                if (!action) {
                    action = "";
                }
                // Reload? We cannot retry or copy if we do not know the model...
                if (action.indexOf(Actions.RELOAD) !== -1) {
                    _this3._track(Actions.RELOAD, context);
                    // Do a full reload, allowing the stats to have a bit of time to complete...
                    setTimeout(function () {
                        if (url === window.location.href) {
                            window.location.reload(true);
                        }
                    }, 250);

                    if (done) {
                        done(Actions.RELOAD);
                    }
                }

                // Relogin, i.e. to get latest company state and role..
                if (action.indexOf(Actions.RELOGIN) !== -1) {
                    _this3._track(Actions.RELOGIN, context);
                    var promise = Login.relogin();
                    if (done) {
                        promise.done(function (changed) {
                            done(Actions.RELOGIN, changed[0], changed[1]); // 0: principal, 1 = changed
                        });
                    }
                    if (fail) {
                        promise.fail(function (xhr) {
                            fail(Actions.RELOGIN, xhr);
                        });
                    }
                }

                // Show support pop-up (as well)?
                if (action.indexOf(Actions.SUPPORT) !== -1) {
                    _this3._track(Actions.SUPPORT, context);
                }

                // Link to community (as well)?
                if (action.indexOf(Actions.COMMUNITY) !== -1) {
                    var key = _this3._communityLink(error);
                    _this3._track(Actions.COMMUNITY + key, context);
                    if (done) {
                        done(Actions.COMMUNITY);
                    }
                }
            };
        },


        // Opens a link to the community, trying to link to the specific error code if possible...
        _communityLink: function _communityLink(error) {
            var url = Configuration.communityBaseUrl;
            var key = "";

            if (url) {
                if (error && error.code) {
                    key = "." + error.code; // for statsD
                    // Do we even have a *specific* community link?
                    error = ERROR_PAGES.get(error.code);
                    if (error) {
                        url += "/hc/en-us/articles/" + error;
                    }
                }
                // Open named window...
                Window.open(url, "zmags_creator_community");
            }
            return key;
        },


        // Logs/tracks the user action...
        _track: function _track(action, context, id) {
            if (context) {
                action = context + "." + action;
            }
            var modelId = id || "unknown model id";
            log.info("User action: <" + action + ">: <" + modelId + "> -> " + window.location.href);
            if (this._statsD) {
                this._statsD.track("user_action." + action + (id ? "." + id : ""));
            }
        }
    });

    return new ErrorAction();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var RestApi = __webpack_require__(29);
    var Permissions = __webpack_require__(22);

    /**
     * JSON Example:
     *
     * ```json
     * {
     *      "id": "595657cae4b00836a8728fb2",
     *      "companyId": "55a7571de4b0e7008a500f8d",
     *      "createdAt": 1498830794356,
     *      "createdBy": "55a7571de4b0e7008a500f91",
     *      "version": 1,
     *      "name": "Arial Narrow Bold Italic",
     *      "fontFamily": "Arial Narrow Bold Italic",
     *      "format": "truetype",
     *      "path": "assets/fonts/55a7571de4b0e7008a500f8d/595657cae4b00836a8728fb2.ttf",
     *      "extension": "ttf",
     *      "timesUsed": 2,
     *      "size": 183932
     * }
     * ```
     * @class CustomFontModel
     */
    return ImprovedModel.extend("CustomFontModel", {
        url: function url() {
            return RestApi.pathToSpecificResource(RestApi.Collections.FONTS, this.get("id"));
        },


        computed: {
            readOnly: {
                deps: ["timesUsed"],
                value: function value(timesUsed) {
                    return Boolean(timesUsed) || Permissions.Roles.MANAGER.cannot();
                }
            }
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var FontIntegrationModel = __webpack_require__(404);

    /**
     * Custom Font integration model.
     *
     * @class CustomFontIntegration
     */
    return FontIntegrationModel.extend("CustomFontIntegration", {}, {
        type: "CustomFontIntegration"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainPropTypes;
function chainPropTypes(propType1, propType2) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createMuiTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createBreakpoints__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createMixins__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createPalette__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createTypography__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shadows__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape__ = __webpack_require__(1817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__createSpacing__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transitions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__zIndex__ = __webpack_require__(904);













function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = Object(__WEBPACK_IMPORTED_MODULE_5__createPalette__["a" /* default */])(paletteInput);
  var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_3__createBreakpoints__["a" /* default */])(breakpointsInput);
  var spacing = Object(__WEBPACK_IMPORTED_MODULE_9__createSpacing__["a" /* default */])(spacingInput);
  var muiTheme = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: Object(__WEBPACK_IMPORTED_MODULE_4__createMixins__["a" /* default */])(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: __WEBPACK_IMPORTED_MODULE_7__shadows__["a" /* default */],
    typography: Object(__WEBPACK_IMPORTED_MODULE_6__createTypography__["a" /* default */])(palette, typographyInput),
    spacing: spacing,
    shape: __WEBPACK_IMPORTED_MODULE_8__shape__["a" /* default */],
    transitions: __WEBPACK_IMPORTED_MODULE_10__transitions__["a" /* default */],
    zIndex: __WEBPACK_IMPORTED_MODULE_11__zIndex__["a" /* default */]
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(acc, argument);
  }, muiTheme);

  if (false) {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: The `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://mui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

var warnedOnce = false;
function createMuiTheme() {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the createMuiTheme function was renamed to createTheme.', '', "You should use `import { createTheme } from '@material-ui/core/styles'`"].join('\n'));
    }
  }

  return createTheme.apply(void 0, arguments);
}
/* harmony default export */ __webpack_exports__["a"] = (createTheme);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__merge__ = __webpack_require__(410);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {
    if (!props.theme) {
      console.error('Material-UI: You are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" /* default */])(base, extended);
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    xs: PropTypes.object,
    sm: PropTypes.object,
    md: PropTypes.object,
    lg: PropTypes.object,
    xl: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* unused harmony default export */ var _unused_webpack_default_export = (breakpoints);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(892);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getThemeProps__ = __webpack_require__(1829);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getThemeProps__["a"]; });


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jssPreset__ = __webpack_require__(1830);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__jssPreset__["a"]; });


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeClasses__ = __webpack_require__(1841);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mergeClasses__["a"]; });


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capitalize__ = __webpack_require__(36);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return __WEBPACK_IMPORTED_MODULE_0__capitalize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createChainedFunction", function() { return __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createSvgIcon__ = __webpack_require__(80);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createSvgIcon", function() { return __WEBPACK_IMPORTED_MODULE_2__createSvgIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__debounce__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() { return __WEBPACK_IMPORTED_MODULE_3__debounce__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deprecatedPropType__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deprecatedPropType", function() { return __WEBPACK_IMPORTED_MODULE_4__deprecatedPropType__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isMuiElement__ = __webpack_require__(264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isMuiElement", function() { return __WEBPACK_IMPORTED_MODULE_5__isMuiElement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ownerDocument__ = __webpack_require__(129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ownerDocument", function() { return __WEBPACK_IMPORTED_MODULE_6__ownerDocument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ownerWindow__ = __webpack_require__(416);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ownerWindow", function() { return __WEBPACK_IMPORTED_MODULE_7__ownerWindow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__requirePropFactory__ = __webpack_require__(918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "requirePropFactory", function() { return __WEBPACK_IMPORTED_MODULE_8__requirePropFactory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__setRef__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setRef", function() { return __WEBPACK_IMPORTED_MODULE_9__setRef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__unsupportedProp__ = __webpack_require__(417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unsupportedProp", function() { return __WEBPACK_IMPORTED_MODULE_10__unsupportedProp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__useControlled__ = __webpack_require__(180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useControlled", function() { return __WEBPACK_IMPORTED_MODULE_11__useControlled__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useEventCallback__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useEventCallback", function() { return __WEBPACK_IMPORTED_MODULE_12__useEventCallback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__useForkRef__ = __webpack_require__(59);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useForkRef", function() { return __WEBPACK_IMPORTED_MODULE_13__useForkRef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__unstable_useId__ = __webpack_require__(418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_useId", function() { return __WEBPACK_IMPORTED_MODULE_14__unstable_useId__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__useIsFocusVisible__ = __webpack_require__(316);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useIsFocusVisible", function() { return __WEBPACK_IMPORTED_MODULE_15__useIsFocusVisible__["a"]; });













 // eslint-disable-next-line camelcase




/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(1856);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Accordion__["a"]; });


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNMOUNTED */
/* unused harmony export EXITED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXITING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_PropTypes__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__ = __webpack_require__(573);








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        _in = _this$props.in,
        _mountOnEnter = _this$props.mountOnEnter,
        _unmountOnExit = _this$props.unmountOnExit,
        _appear = _this$props.appear,
        _enter = _this$props.enter,
        _exit = _this$props.exit,
        _timeout = _this$props.timeout,
        _addEndListener = _this$props.addEndListener,
        _onEnter = _this$props.onEnter,
        _onEntering = _this$props.onEntering,
        _onEntered = _this$props.onEntered,
        _onExit = _this$props.onExit,
        _onExiting = _this$props.onExiting,
        _onExited = _this$props.onExited,
        _nodeRef = _this$props.nodeRef,
        childProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children), childProps))
    );
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Transition.contextType = __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */];
Transition.propTypes =  false ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ __webpack_exports__["d"] = (Transition);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccordionSummary__ = __webpack_require__(1868);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AccordionSummary__["a"]; });


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(1886);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useControlled__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormControl_useFormControl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__IconButton__ = __webpack_require__(266);











var styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useControlled__["a" /* default */])({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_8__FormControl_useFormControl__["a" /* default */])();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "span",
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

 false ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /*
   * @ignore
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,

  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateSwitchBase'
})(SwitchBase));

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClickAwayListener__ = __webpack_require__(1901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ClickAwayListener__["a"]; });


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Unstable_TrapFocus__ = __webpack_require__(1907);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Unstable_TrapFocus__["a"]; });


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony export (immutable) */ __webpack_exports__["c"] = isHorizontal;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAnchor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Backdrop__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Slide__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Paper__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_transitions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_useTheme__ = __webpack_require__(67);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 0
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
var defaultTransitionDuration = {
  enter: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */

var Drawer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Drawer(props, ref) {
  var _props$anchor = props.anchor,
      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
      BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
      _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

  var BackdropPropsProp = _props$ModalProps.BackdropProps,
      ModalProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ModalProps, ["BackdropProps"]),
      onClose = props.onClose,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      SlideProps = props.SlideProps,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_8__Slide__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_12__styles_useTheme__["a" /* default */])(); // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.

  var mounted = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](false);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    mounted.current = true;
  }, []);
  var anchor = getAnchor(theme, anchorProp);
  var drawer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.paper, classes["paperAnchor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(anchor))])
  }), children);

  if (variant === 'permanent') {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.docked, className),
      ref: ref
    }, other), drawer);
  }

  var slidingDrawer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: open,
    direction: oppositeDirection[anchor],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps), drawer);

  if (variant === 'persistent') {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.docked, className),
      ref: ref
    }, other), slidingDrawer);
  } // variant === temporary


  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, BackdropProps, BackdropPropsProp, {
      transitionDuration: transitionDuration
    }),
    BackdropComponent: __WEBPACK_IMPORTED_MODULE_6__Backdrop__["a" /* default */],
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.modal, className),
    open: open,
    onClose: onClose,
    ref: ref
  }, other, ModalProps), slidingDrawer);
});
 false ? Drawer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Side from which the drawer will appear.
   */
  anchor: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),

  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * The contents of the drawer.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The elevation of the drawer.
   */
  elevation: PropTypes.number,

  /**
   * Props applied to the [`Modal`](/api/modal/) element.
   */
  ModalProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * If `true`, the drawer is open.
   */
  open: PropTypes.bool,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Props applied to the [`Slide`](/api/slide/) element.
   */
  SlideProps: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDrawer',
  flip: false
})(Drawer));

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slide__ = __webpack_require__(1914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Slide__["a"]; });


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__ = __webpack_require__(1922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__["a"]; });


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasValue */
/* harmony export (immutable) */ __webpack_exports__["b"] = isFilled;
/* harmony export (immutable) */ __webpack_exports__["a"] = isAdornedStart;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormGroup__ = __webpack_require__(1925);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormGroup__["a"]; });


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormHelperText__ = __webpack_require__(1926);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormHelperText__["a"]; });


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormLabel__ = __webpack_require__(1927);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormLabel__["a"]; });


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __webpack_require__(1935);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__["a"]; });


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputLabel__ = __webpack_require__(1943);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputLabel__["a"]; });


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinearProgress__ = __webpack_require__(1944);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LinearProgress__["a"]; });


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(1946);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });


/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItem__ = __webpack_require__(1947);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItem__["a"]; });


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover__ = __webpack_require__(1953);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popover__["a"]; });


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuList__ = __webpack_require__(1954);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuList__["a"]; });


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuItem__ = __webpack_require__(1955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuItem__["a"]; });


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoSsr__ = __webpack_require__(1957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NoSsr__["a"]; });


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1960);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SnackbarContent__ = __webpack_require__(1973);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SnackbarContent__["a"]; });


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepLabel__ = __webpack_require__(1976);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StepLabel__["a"]; });


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepIcon__ = __webpack_require__(1977);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StepIcon__["a"]; });


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepConnector__ = __webpack_require__(1980);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StepConnector__["a"]; });


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableCell__ = __webpack_require__(1989);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableCell__["a"]; });


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar__ = __webpack_require__(1994);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Toolbar__["a"]; });


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TabScrollButton__ = __webpack_require__(2004);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TabScrollButton__["a"]; });


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isFunction; });
/* unused harmony export isNumber */
/* unused harmony export isString */
/**
 * Checks whether or not a value is a boolean.
 *
 * @param value
 */
function isBoolean(value) {
  return typeof value === "boolean";
}
/**
 * Checks whether or not a value is a function.
 *
 * @param value
 */

function isFunction(value) {
  // eslint-disable-next-line eqeqeq
  return !!(value && {}.toString.call(value) == "[object Function]");
}
/**
 * Checks whether or not a value is a number.
 *
 * @param value
 */

function isNumber(value) {
  return typeof value === "number" && !isNaN(value);
}
/**
 * Checks whether or not a value is a string.
 *
 * @param value
 */

function isString(value) {
  return typeof value === "string";
}




/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);

    /**
     * Model representing metadata about an Product.
     *
     * @class SalesforceCommerceProductModel
     * @constructor
     */
    return Backbone.Model.extend({
        defaults: {
            name: null,
            productID: null,
            price: 0,
            image: null,
            brand: null,
            description: null,
            availability: null
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentState
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BlockMapBuilder = __webpack_require__(324);
var CharacterMetadata = __webpack_require__(93);
var ContentBlock = __webpack_require__(217);
var ContentBlockNode = __webpack_require__(111);
var DraftEntity = __webpack_require__(429);
var DraftFeatureFlags = __webpack_require__(181);
var Immutable = __webpack_require__(40);
var SelectionState = __webpack_require__(271);

var generateRandomKey = __webpack_require__(164);
var sanitizeDraftText = __webpack_require__(607);

var List = Immutable.List,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var defaultRecord = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};

var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var ContentStateRecord = Record(defaultRecord);

var ContentState = function (_ContentStateRecord) {
  _inherits(ContentState, _ContentStateRecord);

  function ContentState() {
    _classCallCheck(this, ContentState);

    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
  }

  ContentState.prototype.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity;
  };

  ContentState.prototype.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  ContentState.prototype.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  ContentState.prototype.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__getLastCreatedEntityKey();
  };

  ContentState.prototype.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || blockMap.first().getLength() > 0;
  };

  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__create(type, mutability, data);
    return this;
  };

  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__mergeData(key, toMerge);
    return this;
  };

  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__replaceData(key, newData);
    return this;
  };

  ContentState.prototype.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__add(instance);
    return this;
  };

  ContentState.prototype.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__get(key);
  };

  ContentState.createFromBlockArray = function createFromBlockArray(
  // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;

    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey(),
        text: block,
        type: 'unstyled',
        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  return ContentState;
}(ContentStateRecord);

module.exports = ContentState;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule sanitizeDraftText
 * @format
 * 
 */



var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

module.exports = sanitizeDraftText;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Constants to represent text directionality
 *
 * Also defines a *global* direciton, to be used in bidi algorithms as a
 * default fallback direciton, when no better direction is found or provided.
 *
 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
 *       global direction value based on the application.
 *
 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var invariant = __webpack_require__(47);

var NEUTRAL = 'NEUTRAL'; // No strong direction
var LTR = 'LTR'; // Left-to-Right direction
var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null;

// == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */
function isStrong(dir) {
  return dir === LTR || dir === RTL;
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */
function getHTMLDir(dir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}

/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */
function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
}

// == Global Direction ==

/**
 * Set the global direction.
 */
function setGlobalDir(dir) {
  globalDir = dir;
}

/**
 * Initialize the global direction
 */
function initGlobalDir() {
  setGlobalDir(LTR);
}

/**
 * Get the global direction
 */
function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }
  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};

module.exports = UnicodeBidiDirection;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftBlockRenderMap
 * @format
 * 
 */



var _require = __webpack_require__(40),
    Map = _require.Map;

var React = __webpack_require__(0);

var cx = __webpack_require__(272);

var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });

var DefaultDraftBlockRenderMap = Map({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});

module.exports = DefaultDraftBlockRenderMap;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEntityKeyForSelection
 * @format
 * 
 */



/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */
function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();
    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }
      return filterKey(contentState.getEntityMap(), entityKey);
    }
    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);

  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);

  return filterKey(contentState.getEntityMap(), entityKey);
}

/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */
function filterKey(entityMap, entityKey) {
  if (entityKey) {
    var entity = entityMap.__get(entityKey);
    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }
  return null;
}

module.exports = getEntityKeyForSelection;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(2137);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getStyleProperty = __webpack_require__(2139);

/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */
function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}

/**
 * Utilities for querying and mutating style properties.
 */
var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }
    var ownerDocument = node.ownerDocument;
    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }
      node = node.parentNode;
    }
    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }

};

module.exports = Style;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var getDocumentScrollElement = __webpack_require__(2144);
var getUnboundedScrollPosition = __webpack_require__(2145);

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */
function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }
  var scrollPosition = getUnboundedScrollPosition(scrollable);

  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;

  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;

  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));

  return scrollPosition;
}

module.exports = getScrollPosition;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findAncestorOffsetKey
 * @format
 * 
 */



var getSelectionOffsetKeyForNode = __webpack_require__(1043);

/**
 * Get the key from the node's nearest offset-aware ancestor.
 */
function findAncestorOffsetKey(node) {
  var searchNode = node;
  while (searchNode && searchNode !== document.documentElement) {
    var key = getSelectionOffsetKeyForNode(searchNode);
    if (key != null) {
      return key;
    }
    searchNode = searchNode.parentNode;
  }
  return null;
}

module.exports = findAncestorOffsetKey;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule KeyBindingUtil
 * @format
 * 
 */



var UserAgent = __webpack_require__(145);

var isOSX = UserAgent.isPlatform('Mac OS X');

var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },

  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },

  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  }
};

module.exports = KeyBindingUtil;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionBackward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();

  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);
    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

module.exports = moveSelectionBackward;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(146)(module)))

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return draftJSUtilsCustom; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draftjs_utils__ = __webpack_require__(2195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draftjs_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_draftjs_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_ui_experience_widgets_textEnhancedWidget_TextEditorControls__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__editorStateConverters__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_util_Color__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_util_Color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_util_Color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models__ = __webpack_require__(328);









var emptyBlockValue = String.fromCharCode(0x200C);
/**
 * Function will merge block level meta-data.
 */
var mergeBlockData = function (editorState, 
// TODO: Figure out how to access immutable JS's typings
data) {
    var newContentState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["Modifier"].mergeBlockData(editorState.getCurrentContent(), editorState.getSelection(), data);
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].push(editorState, newContentState, "change-block-data");
};
/**
 * Function will get a unique list of CSS property values for given key.
 */
var getSelectionStylePropertyValues = function (editorState, cssPropertyKey) {
    var propertyValues = __WEBPACK_IMPORTED_MODULE_3_draftjs_utils__["getSelectedBlocksList"](editorState)
        .map(function (contentBlock) {
        var blockData = contentBlock.getData();
        return blockData.get(cssPropertyKey);
    })
        .reduce(function (accumulator, data) {
        if (accumulator.indexOf(data) === -1) {
            accumulator.push(data);
        }
        return accumulator;
    }, []);
    return propertyValues || [];
};
/**
 * Function will apply an inline style.
 */
var applyInlineStyle = function (editorState, styleName) {
    var newContentState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["Modifier"].applyInlineStyle(editorState.getCurrentContent(), editorState.getSelection(), styleName);
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].push(editorState, newContentState, "change-inline-style");
};
/**
 * Function will remove an inline style.
 */
var removeInlineStyle = function (editorState, styleName) {
    var newContentState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["Modifier"].removeInlineStyle(editorState.getCurrentContent(), editorState.getSelection(), styleName);
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].push(editorState, newContentState, "change-inline-style");
};
/**
 * Function will set Focus and Anchor keys to the Start key in selection
 */
var forceFocusBeginning = function (editorState) {
    var selectionState = editorState.getSelection();
    return forceFocusBeginningOfSelectionState(editorState, selectionState.getStartKey());
};
var forceFocusBeginningOfSelectionState = function (editorState, focusKey) {
    var selectionState = editorState.getSelection();
    // TODO: Fix typing from immutable.js, SelectionState.merge does not return a SelectionState type
    var focusOffset = selectionState.getStartOffset();
    var newSelection = selectionState.merge({
        anchorKey: focusKey,
        focusKey: focusKey,
        anchorOffset: focusOffset || 0,
        focusOffset: focusOffset || 0
    });
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].forceSelection(editorState, newSelection);
};
/**
 * Function will set Focus and Anchor keys to the End key in selection
 */
var forceFocusEnding = function (editorState) {
    var currentContent = editorState.getCurrentContent();
    var lastBlock = currentContent.getBlockMap().last();
    var lastBlockKey = lastBlock.getKey();
    var lengthOfLastBlock = lastBlock.getLength();
    var selection = new __WEBPACK_IMPORTED_MODULE_1_draft_js__["SelectionState"]({
        anchorKey: lastBlockKey,
        anchorOffset: lengthOfLastBlock,
        focusKey: lastBlockKey,
        focusOffset: lengthOfLastBlock,
    });
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].forceSelection(editorState, selection);
};
/**
 * Function will set Focus and Anchor keys to the End key in the current block
 */
var forceFocusBlockEnding = function (editorState, currentContentBlock) {
    var blockKey = currentContentBlock.getKey();
    var lengthOfBlock = currentContentBlock.getLength();
    var selection = new __WEBPACK_IMPORTED_MODULE_1_draft_js__["SelectionState"]({
        anchorKey: blockKey,
        anchorOffset: lengthOfBlock,
        focusKey: blockKey,
        focusOffset: lengthOfBlock,
    });
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].forceSelection(editorState, selection);
};
var forcePreviousFocus = function (editorState) {
    var selectionState = editorState.getSelection();
    var selection = new __WEBPACK_IMPORTED_MODULE_1_draft_js__["SelectionState"]({
        anchorKey: selectionState.getAnchorKey(),
        anchorOffset: selectionState.getAnchorOffset(),
        focusKey: selectionState.getFocusKey(),
        focusOffset: selectionState.getFocusOffset(),
    });
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].forceSelection(editorState, selection);
};
var forceSelectAll = function (editorState) {
    var currentContent = editorState.getCurrentContent();
    var firstBlock = currentContent.getBlockMap().first();
    var lastBlock = currentContent.getBlockMap().last();
    var firstBlockKey = firstBlock.getKey();
    var lastBlockKey = lastBlock.getKey();
    var lengthOfLastBlock = lastBlock.getLength();
    var selection = new __WEBPACK_IMPORTED_MODULE_1_draft_js__["SelectionState"]({
        anchorKey: firstBlockKey,
        anchorOffset: 0,
        focusKey: lastBlockKey,
        focusOffset: lengthOfLastBlock,
    });
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].forceSelection(editorState, selection);
};
var forceUnselectAll = function (editorState) {
    var selectionState = editorState.getSelection();
    var newSelection = new __WEBPACK_IMPORTED_MODULE_1_draft_js__["SelectionState"]({
        anchorKey: selectionState.getStartKey(),
        focusKey: selectionState.getStartKey(),
        anchorOffset: 0,
        focusOffset: 0,
        hasFocus: false
    });
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].forceSelection(editorState, newSelection);
};
/**
 * Function will insert a new block copying the style and removing the block type.
 */
var splitBlockWithData = function (editorState) {
    var currentBlock = __WEBPACK_IMPORTED_MODULE_3_draftjs_utils__["getSelectedBlock"](editorState);
    if (currentBlock) {
        var currentBlockData = currentBlock.getData();
        var splitContentState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["Modifier"].splitBlock(editorState.getCurrentContent(), editorState.getSelection());
        var splitEditorState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].push(editorState, splitContentState, "split-block");
        var fixedBlockTypeEditorState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["RichUtils"].toggleBlockType(splitEditorState, "unstyled");
        return mergeBlockData(fixedBlockTypeEditorState, currentBlockData);
    }
    else {
        return editorState;
    }
};
var getFontMetadataEntityFromFontFamily = function (fontFamilyData) {
    var fontProvider = fontFamilyData.fontProvider, fontFamily = fontFamilyData.fontFamily, fontWeight = fontFamilyData.fontWeight, fontStyle = fontFamilyData.fontStyle, cssFamilyNames = fontFamilyData.cssFamilyNames, url = fontFamilyData.url, target = fontFamilyData.target;
    var entity = {
        fontFamily: fontFamily,
        fontStyle: fontStyle,
        fontWeight: fontWeight,
        fontProvider: fontProvider,
        cssFamilyNames: cssFamilyNames
    };
    switch (fontFamilyData.fontProvider) {
        case "custom" /* CUSTOM */:
            var _a = fontFamilyData.fontMetadata, customFontId = _a.customFontId, format = _a.format, path = _a.path;
            Object.assign(entity, {
                customFontId: customFontId,
                format: format,
                path: path
            });
            break;
        case "typekit" /* TYPEKIT */:
            var kitID = fontFamilyData.fontMetadata.kitID;
            Object.assign(entity, {
                kitID: kitID
            });
            break;
        case "fontsDotCom" /* FONTSDOTCOM */:
            var projectId = fontFamilyData.fontMetadata.projectId;
            Object.assign(entity, {
                projectId: projectId
            });
            break;
        default:
            break;
    }
    if (url !== undefined) {
        Object.assign(entity, {
            url: url, target: target
        });
    }
    return entity;
};
var getFontFamilyFromFontMetadataEntity = function (entity) {
    var fontProvider = entity.fontProvider, fontFamily = entity.fontFamily, fontWeight = entity.fontWeight, fontStyle = entity.fontStyle, cssFamilyNames = entity.cssFamilyNames, url = entity.url, target = entity.target;
    var fontProviderType;
    var fontMetadata;
    switch (fontProvider) {
        case "custom" /* CUSTOM */:
            fontProviderType = "custom" /* CUSTOM */;
            var customFontId = entity.customFontId, format = entity.format, path = entity.path;
            fontMetadata = {
                customFontId: customFontId,
                format: format,
                path: path
            };
            break;
        case "typekit" /* TYPEKIT */:
            fontProviderType = "typekit" /* TYPEKIT */;
            var kitID = entity.kitID;
            fontMetadata = {
                kitID: kitID
            };
            break;
        case "fontsDotCom" /* FONTSDOTCOM */:
            fontProviderType = "fontsDotCom" /* FONTSDOTCOM */;
            var projectId = entity.projectId;
            fontMetadata = {
                projectId: projectId
            };
            break;
        case "standard" /* STANDARD */:
            fontProviderType = "standard" /* STANDARD */;
            break;
        case "google" /* GOOGLE */:
            fontProviderType = "google" /* GOOGLE */;
            break;
    }
    return {
        fontProvider: fontProviderType, fontFamily: fontFamily, fontStyle: fontStyle, fontWeight: fontWeight, fontMetadata: fontMetadata, cssFamilyNames: cssFamilyNames, url: url, target: target
    };
};
var getFontFamilyProviderMetaData = function (fontOption, fontStyle, fontWeight) {
    var fontDescriptor = fontOption.fontDescriptor;
    var fontData = fontDescriptor.get("data") || {};
    var currentFontProvider = fontDescriptor.get("provider").value;
    var cssFamilyNames = fontDescriptor.get("cssFamily");
    var customFontId = fontData.customFontId, format = fontData.format, path = fontData.path, kitID = fontData.kitID, projectId = fontData.projectId;
    var fontProviderMetaData;
    var fontMetadata;
    switch (currentFontProvider) {
        case "custom" /* CUSTOM */:
            fontMetadata = {
                customFontId: customFontId,
                format: format,
                path: path
            };
            fontProviderMetaData = {
                fontProvider: "custom" /* CUSTOM */,
            };
            break;
        case "typekit" /* TYPEKIT */:
            fontMetadata = {
                kitID: kitID
            };
            fontProviderMetaData = {
                fontProvider: "typekit" /* TYPEKIT */,
                fontMetadata: fontMetadata
            };
            break;
        case "fontsDotCom" /* FONTSDOTCOM */:
            fontMetadata = {
                projectId: projectId
            };
            fontProviderMetaData = {
                fontProvider: "fontsDotCom" /* FONTSDOTCOM */,
                fontMetadata: fontMetadata
            };
            break;
        case "google" /* GOOGLE */:
            fontProviderMetaData = {
                fontProvider: "google" /* GOOGLE */
            };
            break;
        case "standard" /* STANDARD */:
            fontProviderMetaData = {
                fontProvider: "standard" /* STANDARD */
            };
            break;
        default:
            break;
    }
    Object.assign(fontProviderMetaData, {
        fontFamily: fontOption.value,
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        fontMetadata: fontMetadata,
        cssFamilyNames: cssFamilyNames
    });
    return fontProviderMetaData;
};
var setDefaultBlockStyles = function (_a) {
    var editorState = _a.editorState, _b = _a.textAlign, textAlign = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_4_shared_ui_experience_widgets_textEnhancedWidget_TextEditorControls__["b" /* textEditorDefaults */].alignment : _b;
    var _c;
    return mergeBlockData(editorState, (_c = {},
        _c[__WEBPACK_IMPORTED_MODULE_5__editorStateConverters__["d" /* customBlockStyleDataKeys */].textAlign] = textAlign,
        _c[__WEBPACK_IMPORTED_MODULE_5__editorStateConverters__["d" /* customBlockStyleDataKeys */].lineHeight] = __WEBPACK_IMPORTED_MODULE_4_shared_ui_experience_widgets_textEnhancedWidget_TextEditorControls__["b" /* textEditorDefaults */].lineHeight.toString(),
        _c));
};
var applyDefaultStyles = function (_a) {
    var editorState = _a.editorState, fontSize = _a.fontSize, fontColor = _a.fontColor, fontWeight = _a.fontWeight, currentFontFamily = _a.currentFontFamily;
    editorState = setDefaultBlockStyles({ editorState: editorState });
    editorState = forceSelectAll(editorState);
    var parsedFontSize = fontSize + "px";
    editorState = __WEBPACK_IMPORTED_MODULE_5__editorStateConverters__["j" /* styles */].fontSize.add(editorState, parsedFontSize);
    editorState = __WEBPACK_IMPORTED_MODULE_5__editorStateConverters__["j" /* styles */].color.add(editorState, __WEBPACK_IMPORTED_MODULE_6_shared_util_Color__["formatRgbaToStyle"](fontColor));
    editorState = __WEBPACK_IMPORTED_MODULE_5__editorStateConverters__["j" /* styles */].fontWeight.add(editorState, fontWeight);
    editorState = __WEBPACK_IMPORTED_MODULE_5__editorStateConverters__["j" /* styles */].fontFamily.add(editorState, currentFontFamily);
    return forceUnselectAll(editorState);
};
var setFontMetaData = function (editorState, fontFamilyData, decorator) {
    var _a;
    var incomingEntityData = getFontMetadataEntityFromFontFamily(fontFamilyData);
    var contentState = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var startBlockKey = selection.getStartKey();
    var endBlockKey = selection.getEndKey();
    var startOffset = selection.getStartOffset();
    var endOffset = selection.getEndOffset();
    var blockMap = contentState.getBlockMap();
    var mergedBlockMap = blockMap;
    var mergedEntities = {};
    var currentBlockKey = startBlockKey;
    while (currentBlockKey) {
        var block = contentState.getBlockForKey(currentBlockKey);
        var characterList = block.getCharacterList();
        var mergedCharacterList = characterList;
        var currentIndex = currentBlockKey === startBlockKey ? startOffset : 0;
        var endIndex = currentBlockKey === endBlockKey ? endOffset : characterList.count();
        for (currentIndex; currentIndex < endIndex; currentIndex++) {
            var characterMetadata = characterList.get(currentIndex);
            var characterEntityKey = characterMetadata.getEntity();
            var existingEntityData = characterEntityKey ? contentState.getEntity(characterEntityKey).getData() : {};
            // merge in new entity data
            var mergedEntityData = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, existingEntityData, incomingEntityData);
            // if existing link was removed, clear it from the merged data
            if (!!existingEntityData.url && incomingEntityData.url && incomingEntityData.url.length === 0) {
                delete mergedEntityData.url;
                delete mergedEntityData.target;
            }
            // check for existing matching entity key to reduce duplication
            var mergedEntityKey = mergedEntities[characterEntityKey];
            if (!mergedEntityKey) {
                mergedEntityKey = __WEBPACK_IMPORTED_MODULE_1_draft_js__["Entity"].create(__WEBPACK_IMPORTED_MODULE_7__models__["d" /* FONT_METADATA */], 'MUTABLE', mergedEntityData);
                mergedEntities[characterEntityKey] = mergedEntityKey;
            }
            // merge the new character metadata into the character list
            mergedCharacterList = mergedCharacterList.set(currentIndex, __WEBPACK_IMPORTED_MODULE_1_draft_js__["CharacterMetadata"].applyEntity(characterMetadata, mergedEntityKey));
        }
        // merge the new character list into the block
        var updatedBlock = block.set('characterList', mergedCharacterList);
        // @ts-ignore
        mergedBlockMap = mergedBlockMap.merge(Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])((_a = {}, _a[currentBlockKey] = updatedBlock, _a)));
        // move to the next block (if any)
        currentBlockKey = currentBlockKey === endBlockKey ? undefined : contentState.getKeyAfter(currentBlockKey);
    }
    // merge the new blocks into the contentState
    // @ts-ignore
    var mergedEditorState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].push(editorState, contentState.merge({ blockMap: mergedBlockMap }), 'apply-entity');
    // force link decorator to be applied (fixes issue with links sometimes not being underlined correctly after being applied)
    return decorator && incomingEntityData.url ? __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].set(mergedEditorState, { decorator: decorator }) : mergedEditorState;
};
/**
 * Function will create block map from provided text with
 * santize pasted text from `\r\n` and replace empty lines with emptyBlockValue (&zwnj;)
 */
var sanitizeTextToBlockMap = function (text) {
    var pastedTextAsBlocks = __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentState"].createFromText(text).getBlockMap();
    var santizedBlocks = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedMap"])();
    // 
    pastedTextAsBlocks.forEach(function (element) {
        var text = (element.getText() !== "") ? element.getText() : emptyBlockValue;
        var cleanBlock = new __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentBlock"]({
            key: element.getKey(),
            type: element.getType(),
            text: text
        });
        santizedBlocks = santizedBlocks.set(element.getKey(), cleanBlock);
    });
    return santizedBlocks;
};
/**
 * Function will insert block map to the to the selection state for the editor state.
 */
var insertBlockMapFragmet = function (editorState, blocks) {
    var newState = __WEBPACK_IMPORTED_MODULE_1_draft_js__["Modifier"].replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), blocks);
    return __WEBPACK_IMPORTED_MODULE_1_draft_js__["EditorState"].push(editorState, newState, "insert-fragment");
};
var draftJSUtilsCustom = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, __WEBPACK_IMPORTED_MODULE_3_draftjs_utils__, { mergeBlockData: mergeBlockData,
    getSelectionStylePropertyValues: getSelectionStylePropertyValues,
    applyInlineStyle: applyInlineStyle,
    removeInlineStyle: removeInlineStyle,
    forceFocusBeginning: forceFocusBeginning,
    splitBlockWithData: splitBlockWithData,
    forceFocusEnding: forceFocusEnding,
    forceFocusBlockEnding: forceFocusBlockEnding,
    forceSelectAll: forceSelectAll,
    forceUnselectAll: forceUnselectAll,
    getFontMetadataEntityFromFontFamily: getFontMetadataEntityFromFontFamily,
    getFontFamilyFromFontMetadataEntity: getFontFamilyFromFontMetadataEntity,
    getFontFamilyProviderMetaData: getFontFamilyProviderMetaData,
    forcePreviousFocus: forcePreviousFocus,
    setDefaultBlockStyles: setDefaultBlockStyles,
    applyDefaultStyles: applyDefaultStyles,
    forceFocusBeginningOfSelectionState: forceFocusBeginningOfSelectionState,
    setFontMetaData: setFontMetaData,
    sanitizeTextToBlockMap: sanitizeTextToBlockMap,
    insertBlockMapFragmet: insertBlockMapFragmet,
    emptyBlockValue: emptyBlockValue });



/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextEditorControls; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return textEditorDefaults; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zmags_zmags_ui_library__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_ui_common_SelectComponent__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__editor_ui_experience_widgets_toolbox_PropertyContainerComponent__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_ui_common_ColorPicker__ = __webpack_require__(2692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_ui_common_InputComponent__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(157);










/**
 * CreatableSelect "emotion-style" like styles
 *
 * Documentation and examles are here:
 * https://react-select.com/styles
 */
var creatableStyles = {
    control: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { backgroundColor: "#333333", color: "white", borderRadius: 0, border: "none", width: "80px" })); },
    input: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { color: "white" })); },
    singleValue: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { color: "white" })); },
    indicatorsContainer: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { color: "#C6C6C6" })); },
    menu: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { width: "80px", borderRadius: "0px", marginTop: "0px", marginBottom: "0px" })); },
    menuList: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { marginTop: "0px", marginBottom: "0px" })); },
    option: function (providedStyles, props) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { paddingTop: "0px", paddingBottom: "0px", color: "#000000", backgroundColor: props.data.__isNew__ && "#DEEBFF" })); }
};
var textEditorDefaults = {
    fontWeight: "400",
    fontStyle: "normal" /* NORMAL */,
    alignment: "left" /* LEFT */,
    blockType: "unstyled",
    fontColor: {
        a: 1,
        b: 0,
        g: 0,
        r: 0,
    },
    lineHeight: 1.4,
    letterSpacing: 0,
    fontSize: 14,
    textDecorations: [],
};
var SelectActions;
(function (SelectActions) {
    SelectActions["INPUTCHANGE"] = "input-change";
    SelectActions["MENUCLOSE"] = "menu-close";
})(SelectActions || (SelectActions = {}));
var fontSizeOptions = [
    { value: "8", label: "8" },
    { value: "9", label: "9" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "14", label: "14" },
    { value: "18", label: "18" },
    { value: "24", label: "24" },
    { value: "30", label: "30" },
    { value: "36", label: "36" },
    { value: "48", label: "48" },
    { value: "60", label: "60" },
    { value: "72", label: "72" },
    { value: "96", label: "96" }
];
var TextEditorControls = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TextEditorControls, _super);
    function TextEditorControls(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFontFamilyInputChange = function (value, actionMeta) {
            var action = actionMeta.action;
            if (action === SelectActions.INPUTCHANGE || action === SelectActions.MENUCLOSE) {
                var term = action === SelectActions.INPUTCHANGE ? value : "";
                _this.setState({ fontFaceSearchTerm: term });
                _this.props.onFontFamilyInputChange(term);
            }
        };
        _this.toggleFontFamily = function (e) {
            var _a = _this.props, fontProvider = _a.fontProvider, onToggleFontFamily = _a.onToggleFontFamily;
            var targetFontFamily = e.value;
            if (!fontProvider || fontProvider.fontFamily !== targetFontFamily) {
                onToggleFontFamily(targetFontFamily);
            }
        };
        // This ugly method exists because I can't just spread this.props because it's type includes React specific props.
        _this.getPartialProps = function () {
            var _a = _this.props, fontWeight = _a.fontWeight, fontStyle = _a.fontStyle, textDecorations = _a.textDecorations, fontSize = _a.fontSize, fontProvider = _a.fontProvider, alignment = _a.alignment, lineHeight = _a.lineHeight, blockType = _a.blockType, letterSpacing = _a.letterSpacing, fontColor = _a.fontColor;
            return {
                fontWeight: fontWeight,
                fontStyle: fontStyle,
                textDecorations: textDecorations,
                fontSize: fontSize,
                fontProvider: fontProvider,
                alignment: alignment,
                lineHeight: lineHeight,
                blockType: blockType,
                letterSpacing: letterSpacing,
                fontColor: fontColor
            };
        };
        _this.toggleColor = function (fontColor) {
            var nextProps = {
                fontColor: fontColor
            };
            _this.onChange(1 /* Color */, nextProps);
        };
        _this.toggleFontStyle = function (fontFaceVariant) {
            var nextFontStyle = fontFaceVariant.style, nextFontWeight = fontFaceVariant.weight;
            var _a = _this.props, currentFontStyle = _a.fontStyle, currentFontWeight = _a.fontWeight;
            var fontWeight = currentFontWeight !== nextFontWeight ? nextFontWeight : currentFontWeight;
            var fontStyle = currentFontStyle !== nextFontStyle ? nextFontStyle : currentFontStyle;
            var nextProps = {
                fontWeight: fontWeight,
                fontStyle: fontStyle,
            };
            return _this.onChange(5 /* FontStyle */, nextProps);
        };
        _this.toggleLetterSpacing = function (letterSpacing) {
            var nextProps = {
                letterSpacing: letterSpacing
            };
            _this.onChange(3 /* LetterSpacing */, nextProps);
        };
        _this.toggleFontSize = function (fontSize) {
            var nextProps = {
                fontSize: fontSize
            };
            _this.onChange(4 /* FontSize */, nextProps);
        };
        _this.toggleBlockType = function (blockType) {
            var nextProps = {
                blockType: blockType
            };
            _this.onChange(7 /* BlockType */, nextProps);
        };
        _this.toggleAlign = function (alignment) {
            var nextProps = {
                alignment: alignment
            };
            _this.onChange(2 /* Alignment */, nextProps);
        };
        _this.toggleLineHeight = function (lineHeight) {
            var nextProps = {
                lineHeight: lineHeight
            };
            _this.onChange(6 /* LineHeight */, nextProps);
        };
        _this.removeStyle = function (style, textDecorations) {
            return textDecorations.filter(function (currentStyleItem) { return currentStyleItem !== style; });
        };
        _this.toggleStyle = function (style) {
            var textDecorations = _this.props.textDecorations;
            if (textDecorations.indexOf(style) === -1) {
                // Both caps can not be applied to a text selection
                if (style === __WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].SMALLCAPS) {
                    textDecorations = _this.removeStyle(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].CAPITAL, textDecorations);
                }
                else if (style === __WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].CAPITAL) {
                    textDecorations = _this.removeStyle(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].SMALLCAPS, textDecorations);
                }
                textDecorations.push(style);
            }
            else {
                textDecorations = textDecorations.filter(function (currentStyleItem) { return currentStyleItem !== style; });
            }
            var nextProps = {
                textDecorations: textDecorations
            };
            _this.onChange(0 /* Decoration */, nextProps);
        };
        _this.getFontFamilyOption = function (targetFontFamily) {
            var fontFamilyOptions = _this.props.fontFamilyOptions;
            var targetFontOption = undefined;
            fontFamilyOptions.filter(function (item) { return !!item; }).forEach(function (fontGroup) {
                if (!targetFontOption) {
                    targetFontOption = fontGroup.options.find(function (fontOptionItem) { return fontOptionItem.value === targetFontFamily; });
                }
            });
            return targetFontOption;
        };
        _this.getDefaultFontFamilyOption = function (fontFamilyOptions) {
            var selectedFontOption = undefined;
            // Choose the default font from either the most recent selection or first standard font.
            fontFamilyOptions.filter(function (item) { return !!item; }).forEach(function (fontOption) {
                var label = fontOption.label.toLowerCase();
                if (label === "recents" || (!selectedFontOption && label === "standard fonts")) {
                    selectedFontOption = fontOption.options[0];
                }
            });
            return selectedFontOption;
        };
        _this.onChange = function (changeSource, propsDelta) {
            var partialProps = _this.getPartialProps();
            var nextProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, partialProps, propsDelta);
            _this.props.onChange(nextProps, changeSource);
        };
        _this.onAnchorAttrsApply = function () {
            var _a = _this.props, anchorUrl = _a.anchorUrl, anchorTarget = _a.anchorTarget, onAnchorAttrsApply = _a.onAnchorAttrsApply;
            onAnchorAttrsApply(anchorUrl, anchorTarget);
        };
        _this.onAnchorUrlChange = function (e) {
            _this.props.handleAnchorUrlChange(e.target.value);
        };
        _this.onAnchorTargetChange = function (option) {
            _this.props.handleAnchorTargetChange(option.value);
        };
        _this.state = {
            fontFaceSearchTerm: "",
            blockTypeOptions: [
                { label: "Default", value: textEditorDefaults.blockType },
                { label: "Heading 1", value: "header-one" },
                { label: "Heading 2", value: "header-two" },
                { label: "Heading 3", value: "header-three" },
                { label: "Heading 4", value: "header-four" },
                { label: "Heading 5", value: "header-five" },
                { label: "Heading 6", value: "header-six" },
            ],
            anchorTargetOptions: [
                { label: "Current window/tab", value: "_self" },
                { label: "Next window/tab", value: "_blank" }
            ],
        };
        return _this;
    }
    TextEditorControls.prototype.render = function () {
        var _this = this;
        var _a = this.state, blockTypeOptions = _a.blockTypeOptions, fontFaceSearchTerm = _a.fontFaceSearchTerm, anchorTargetOptions = _a.anchorTargetOptions;
        var _b = this.props, fontStyle = _b.fontStyle, fontWeight = _b.fontWeight, alignment = _b.alignment, letterSpacing = _b.letterSpacing, lineHeight = _b.lineHeight, fontSize = _b.fontSize, fontColor = _b.fontColor, blockType = _b.blockType, textDecorations = _b.textDecorations, onMouseDown = _b.onMouseDown, fontStyleOptions = _b.fontStyleOptions, fontFamilyOptions = _b.fontFamilyOptions, fontProvider = _b.fontProvider, hasAction = _b.hasAction, anchorUrl = _b.anchorUrl, anchorTarget = _b.anchorTarget, hasSelection = _b.hasSelection, selectionHasLink = _b.selectionHasLink, isEmailMode = _b.isEmailMode;
        var targetFontOption = fontProvider ?
            this.getFontFamilyOption(fontProvider.fontFamily) || this.getDefaultFontFamilyOption(fontFamilyOptions)
            : null;
        var groupStyles = {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        };
        var groupBadgeStyles = {
            backgroundColor: "#EBECF0",
            borderRadius: "2em",
            color: "#172B4D",
            display: "inline-block",
            fontSize: 12,
            fontWeight: "normal",
            lineHeight: "1",
            minWidth: 1,
            padding: "0.16666666666667em 0.5em",
            textAlign: "center",
        };
        var formatGroupLabel = function (data) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: groupStyles },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", null, data.label),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: groupBadgeStyles }, data.options.length))); };
        var selectedFontStyle = fontStyleOptions.find(function (fontStyleOption) {
            return fontStyleOption.style === fontStyle && fontStyleOption.weight === fontWeight;
        });
        var currentAnchorTargetOption = anchorTargetOptions.find(function (_a) {
            var value = _a.value;
            return value === anchorTarget;
        }) || anchorTargetOptions[0];
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__editor_ui_experience_widgets_toolbox_PropertyContainerComponent__["a" /* PropertyContainerComponent */], { widgetSelected: true, label: "Text", name: "character", animateExpandOnMount: true },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "font", label: "Font", tip: "Search all available fonts including Google Fonts not shown in the list" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_shared_ui_common_SelectComponent__["a" /* default */]
                    // The typings for this library are out of date and don't work for grouped data.
                    // @ts-ignore
                    , { 
                        // The typings for this library are out of date and don't work for grouped data.
                        // @ts-ignore
                        onChange: this.toggleFontFamily, onInputChange: this.handleFontFamilyInputChange, inputValue: fontFaceSearchTerm, options: fontFamilyOptions, 
                        // @ts-ignore
                        value: targetFontOption, placeholder: "Select a font", formatGroupLabel: formatGroupLabel, onMenuOpen: onMouseDown, useOptionFontStyle: true })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "style", label: "Style" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_shared_ui_common_SelectComponent__["a" /* default */], { onChange: this.toggleFontStyle, 
                        // no reason to show style options list if there is no selected font-family
                        options: fontProvider ? fontStyleOptions : [], value: selectedFontStyle, placeholder: "Select style", onMenuOpen: onMouseDown })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "decoration" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", { type: "hidden", className: "text-decoration" }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["b" /* GlyphButton */], { glyphicon: "text-color", styleProperty: "text-decoration", changeStyleProperty: "text-decoration", title: "Underline", value: "underline", selected: textDecorations.indexOf(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].UNDERLINE) !== -1, onClick: function () { return _this.toggleStyle(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].UNDERLINE); } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["b" /* GlyphButton */], { glyphicon: "font", styleProperty: "text-decoration", changeStyleProperty: "text-decoration", title: "Line-Through", value: "line-through", selected: textDecorations.indexOf(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].STRIKETHROUGH) !== -1, onClick: function () { return _this.toggleStyle(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].STRIKETHROUGH); } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["b" /* GlyphButton */], { glyphicon: "text-shadow", styleProperty: "text-decoration", changeStyleProperty: "text-shadow", title: "Test Shadow", selected: textDecorations.indexOf(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].SHADOW) !== -1, onClick: function () { return _this.toggleStyle(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].SHADOW); } })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "style", label: "Case" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["b" /* GlyphButton */], { styleProperty: "text-transform-uppercase", changeStyleProperty: "text-case", title: "Capitalize", style: { textTransform: "uppercase" }, label: "ABC", selected: textDecorations.indexOf(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].CAPITAL) !== -1, onClick: function () { return _this.toggleStyle(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].CAPITAL); } }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["b" /* GlyphButton */], { styleProperty: "font-variant-smallcaps", changeStyleProperty: "text-case", title: "Small Caps", style: { fontVariant: "small-caps" }, label: "abc", selected: textDecorations.indexOf(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].SMALLCAPS) !== -1, onClick: function () { return _this.toggleStyle(__WEBPACK_IMPORTED_MODULE_2__models__["c" /* DraftStyles */].SMALLCAPS); } })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "size", label: "Size" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: { display: "inline-block" } },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__zmags_zmags_ui_library__["CreatableSelect"], { value: fontSize, defaultValue: textEditorDefaults.fontSize, onChange: this.toggleFontSize, label: "px", styles: creatableStyles, options: fontSizeOptions })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["a" /* Glyph */], { glyphicon: "text-size", onRight: true })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "color", label: "Color" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_shared_ui_common_ColorPicker__["a" /* ColorPicker */], { color: fontColor, onChange: this.toggleColor, showInput: false })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "line-height", label: "Line Height" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__zmags_zmags_ui_library__["NumericInputComponent"], { classNames: "line-height small", wrapperClassNames: "pull-left", onChange: this.toggleLineHeight, value: lineHeight, defaultValue: textEditorDefaults.lineHeight, disabled: false, step: 0.1, min: 0.1, max: 100, title: "percentage of the font size", debounceDelay: 500 }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["a" /* Glyph */], { glyphicon: "text-height", onRight: true })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "letter-spacing", label: "Letter Spacing" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__zmags_zmags_ui_library__["NumericInputComponent"], { units: "px", defaultValue: textEditorDefaults.letterSpacing, classNames: "font-letter-spacing small", wrapperClassNames: "pull-left", min: -30, onChange: this.toggleLetterSpacing, value: letterSpacing, debounceDelay: 500 }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["a" /* Glyph */], { glyphicon: "text-size", onRight: true })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "alignment", label: "Alignment" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["b" /* GlyphButton */], { changeStyleProperty: "text-align", title: "Left", glyphicon: "align-left", onClick: function () { return _this.toggleAlign("left" /* LEFT */); }, selected: alignment === "left" /* LEFT */ }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["b" /* GlyphButton */], { changeStyleProperty: "text-align", title: "Center", glyphicon: "align-center", onClick: function () { return _this.toggleAlign("center" /* CENTER */); }, selected: alignment === "center" /* CENTER */ }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["b" /* GlyphButton */], { changeStyleProperty: "text-align", title: "Right", glyphicon: "align-right", onClick: function () { return _this.toggleAlign("right" /* RIGHT */); }, selected: alignment === "right" /* RIGHT */ })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "html-tag", label: "HTML Tag", tip: "Used for SEO purposes and won't affect the appearance" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_shared_ui_common_SelectComponent__["a" /* default */], { value: blockTypeOptions.find((function (el) { return el.value === blockType; })), options: blockTypeOptions, classNames: "form-control", disabled: false, onChange: function (val) {
                            var blockValue = val.value;
                            _this.toggleBlockType(blockValue);
                        } })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "hyperlink-target", label: "Hyperlink", tip: isEmailMode
                        ? "This feature cannot be used in email mode."
                        : "Select text to add a hyperlink. Replaces any selected links" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_shared_ui_common_SelectComponent__["a" /* default */], { disabled: isEmailMode, value: currentAnchorTargetOption, options: anchorTargetOptions, classNames: "form-control", onChange: this.onAnchorTargetChange })),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Row */], { className: "hyperlink-url-section properties", componentClass: "section" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["b" /* Col */], { md: 8 },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8_shared_ui_common_InputComponent__["a" /* default */], { disabled: isEmailMode, type: "text", placeholder: "https://example.com", units: null, classNames: "full-width", value: !isEmailMode ? anchorUrl : '', onChange: this.onAnchorUrlChange })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["b" /* Col */], { md: 4 },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["a" /* Button */], { size: "sm", block: true, onClick: this.onAnchorAttrsApply, disabled: hasAction || !hasSelection || isEmailMode || (!selectionHasLink && anchorUrl.length === 0) }, "Apply"))))));
    };
    TextEditorControls.defaultProps = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, textEditorDefaults, { onChange: function () { return undefined; }, onMouseDown: function () { return undefined; }, onFontFamilyInputChange: function () { return undefined; }, onToggleFontFamily: function () { return undefined; }, onAnchorAttrsApply: function () { return undefined; }, fontStyleOptions: [], fontFamilyOptions: [], hasAction: false, handleAnchorUrlChange: function () { return undefined; }, handleAnchorTargetChange: function () { return undefined; }, anchorUrl: "", anchorTarget: __WEBPACK_IMPORTED_MODULE_2__models__["a" /* AnchorTarget */].self, hasSelection: false, selectionHasLink: false, isEmailMode: false });
    return TextEditorControls;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_hash__ = __webpack_require__(2200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(2201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_memoize__ = __webpack_require__(1061);




var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_2__emotion_memoize__["a" /* default */])(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

var shouldWarnAboutInterpolatingClassNameFromCss = true;

function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if (false) {
      throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if (false) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
        } else if (false) {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if (false) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];

  if (false) {
    console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }

  return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if (false) {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var sourceMapPattern;

if (false) {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    if (false) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

    if (stringMode) {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if (false) {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_hash__["a" /* default */])(styles) + identifierName;

  if (false) {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};




/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultToast = exports.shrinkKeyframes = exports.toastWidth = exports.gutter = exports.borderRadius = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['from { height: 100%; } to { height: 0% }'], ['from { height: 100%; } to { height: 0% }']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(165);

var _icons = __webpack_require__(2202);

var _colors = __webpack_require__(2203);

var colors = _interopRequireWildcard(_colors);

var _utils = __webpack_require__(623);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/** @jsx jsx */

// common
var borderRadius = exports.borderRadius = 4;
var gutter = exports.gutter = 8;
var toastWidth = exports.toastWidth = 360;
var shrinkKeyframes = exports.shrinkKeyframes = (0, _core.keyframes)(_templateObject);

// a11y helper
var A11yText = function A11yText(_ref) {
  var Tag = _ref.tag,
      props = _objectWithoutProperties(_ref, ['tag']);

  return (0, _core.jsx)(Tag, _extends({
    css: {
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      whiteSpace: 'nowrap',
      width: 1
    }
  }, props));
};
A11yText.defaultProps = {
  tag: 'span'
};

// default appearances

var appearances = {
  success: {
    icon: _icons.CheckIcon,
    text: colors.G500,
    fg: colors.G300,
    bg: colors.G50
  },
  error: {
    icon: _icons.FlameIcon,
    text: colors.R500,
    fg: colors.R300,
    bg: colors.R50
  },
  warning: {
    icon: _icons.AlertIcon,
    text: colors.Y500,
    fg: colors.Y300,
    bg: colors.Y50
  },
  info: {
    icon: _icons.InfoIcon,
    text: colors.N400,
    fg: colors.B200,
    bg: 'white'
  }
};


var Button = function Button(props) {
  return (0, _core.jsx)('div', _extends({
    role: 'button',
    className: 'react-toast-notifications__toast__dismiss-button',
    css: {
      cursor: 'pointer',
      flexShrink: 0,
      opacity: 0.5,
      padding: gutter + 'px ' + gutter * 1.5 + 'px',
      transition: 'opacity 150ms',

      ':hover': { opacity: 1 }
    }
  }, props));
};

var Content = function Content(props) {
  return (0, _core.jsx)('div', _extends({
    className: 'react-toast-notifications__toast__content',
    css: {
      flexGrow: 1,
      fontSize: 14,
      lineHeight: 1.4,
      minHeight: 40,
      padding: gutter + 'px ' + gutter * 1.5 + 'px'
    }
  }, props));
};

// NOTE: invoke animation when NOT `autoDismiss` with opacity of 0 to avoid a
// paint bug in FireFox.
// https://bugzilla.mozilla.org/show_bug.cgi?id=625289
var Countdown = function Countdown(_ref2) {
  var autoDismissTimeout = _ref2.autoDismissTimeout,
      opacity = _ref2.opacity,
      isRunning = _ref2.isRunning,
      props = _objectWithoutProperties(_ref2, ['autoDismissTimeout', 'opacity', 'isRunning']);

  return (0, _core.jsx)('div', _extends({
    className: 'react-toast-notifications__toast__countdown',
    css: {
      animation: shrinkKeyframes + ' ' + autoDismissTimeout + 'ms linear',
      animationPlayState: isRunning ? 'running' : 'paused',
      backgroundColor: 'rgba(0,0,0,0.1)',
      bottom: 0,
      height: 0,
      left: 0,
      opacity: opacity,
      position: 'absolute',
      width: '100%'
    }
  }, props));
};

var Icon = function Icon(_ref3) {
  var appearance = _ref3.appearance,
      autoDismiss = _ref3.autoDismiss,
      autoDismissTimeout = _ref3.autoDismissTimeout,
      isRunning = _ref3.isRunning;

  var meta = appearances[appearance];
  var Glyph = meta.icon;

  return (0, _core.jsx)(
    'div',
    {
      className: 'react-toast-notifications__toast__icon-wrapper',
      css: {
        backgroundColor: meta.fg,
        borderTopLeftRadius: borderRadius,
        borderBottomLeftRadius: borderRadius,
        color: meta.bg,
        flexShrink: 0,
        paddingBottom: gutter,
        paddingTop: gutter,
        position: 'relative',
        overflow: 'hidden',
        textAlign: 'center',
        width: 30
      }
    },
    (0, _core.jsx)(Countdown, {
      opacity: autoDismiss ? 1 : 0,
      autoDismissTimeout: autoDismissTimeout,
      isRunning: isRunning
    }),
    (0, _core.jsx)(Glyph, {
      className: 'react-toast-notifications__toast__icon',
      css: { position: 'relative', zIndex: 1 }
    })
  );
};

// Transitions
// ------------------------------

function getTranslate(placement) {
  var pos = placement.split('-');
  var relevantPlacement = pos[1] === 'center' ? pos[0] : pos[1];
  var translateMap = {
    right: 'translate3d(120%, 0, 0)',
    left: 'translate3d(-120%, 0, 0)',
    bottom: 'translate3d(0, 120%, 0)',
    top: 'translate3d(0, -120%, 0)'
  };

  return translateMap[relevantPlacement];
}

var toastStates = function toastStates(placement) {
  return {
    entering: { transform: getTranslate(placement) },
    entered: { transform: 'translate3d(0,0,0)' },
    exiting: { transform: 'scale(0.66)', opacity: 0 },
    exited: { transform: 'scale(0.66)', opacity: 0 }
  };
};

var ToastElement = function ToastElement(_ref4) {
  var appearance = _ref4.appearance,
      placement = _ref4.placement,
      transitionDuration = _ref4.transitionDuration,
      transitionState = _ref4.transitionState,
      props = _objectWithoutProperties(_ref4, ['appearance', 'placement', 'transitionDuration', 'transitionState']);

  var _useState = (0, _react.useState)('auto'),
      _useState2 = _slicedToArray(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  var elementRef = (0, _react.useRef)(null);

  (0, _react.useEffect)(function () {
    if (transitionState === 'entered') {
      var el = elementRef.current;
      setHeight(el.offsetHeight + gutter);
    }
    if (transitionState === 'exiting') {
      setHeight(0);
    }
  }, [transitionState]);

  return (0, _core.jsx)(
    'div',
    {
      ref: elementRef,
      style: { height: height },
      css: {
        transition: 'height ' + (transitionDuration - 100) + 'ms 100ms'
      }
    },
    (0, _core.jsx)('div', _extends({
      className: 'react-toast-notifications__toast react-toast-notifications__toast--' + appearance,
      css: _extends({
        backgroundColor: appearances[appearance].bg,
        borderRadius: borderRadius,
        boxShadow: '0 3px 8px rgba(0, 0, 0, 0.175)',
        color: appearances[appearance].text,
        display: 'flex',
        marginBottom: gutter,
        transition: 'transform ' + transitionDuration + 'ms cubic-bezier(0.2, 0, 0, 1), opacity ' + transitionDuration + 'ms',
        width: toastWidth
      }, toastStates(placement)[transitionState])
    }, props))
  );
};

// ==============================
// DefaultToast
// ==============================

var DefaultToast = function DefaultToast(_ref5) {
  var appearance = _ref5.appearance,
      autoDismiss = _ref5.autoDismiss,
      autoDismissTimeout = _ref5.autoDismissTimeout,
      children = _ref5.children,
      isRunning = _ref5.isRunning,
      onDismiss = _ref5.onDismiss,
      placement = _ref5.placement,
      transitionDuration = _ref5.transitionDuration,
      transitionState = _ref5.transitionState,
      onMouseEnter = _ref5.onMouseEnter,
      onMouseLeave = _ref5.onMouseLeave,
      otherProps = _objectWithoutProperties(_ref5, ['appearance', 'autoDismiss', 'autoDismissTimeout', 'children', 'isRunning', 'onDismiss', 'placement', 'transitionDuration', 'transitionState', 'onMouseEnter', 'onMouseLeave']);

  return (0, _core.jsx)(
    ToastElement,
    _extends({
      appearance: appearance,
      placement: placement,
      transitionState: transitionState,
      transitionDuration: transitionDuration,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, otherProps),
    (0, _core.jsx)(Icon, {
      appearance: appearance,
      autoDismiss: autoDismiss,
      autoDismissTimeout: autoDismissTimeout,
      isRunning: isRunning
    }),
    (0, _core.jsx)(
      Content,
      null,
      children
    ),
    onDismiss ? (0, _core.jsx)(
      Button,
      { onClick: onDismiss },
      (0, _core.jsx)(_icons.CloseIcon, { className: 'react-toast-notifications__toast__dismiss-icon' }),
      (0, _core.jsx)(
        A11yText,
        { className: 'react-toast-notifications__toast__dismiss-text' },
        'Close'
      )
    ) : null
  );
};

exports.DefaultToast = DefaultToast;
DefaultToast.defaultProps = {
  onDismiss: _utils.NOOP
};

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUEID = generateUEID;
var NOOP = exports.NOOP = function NOOP() {};
function generateUEID() {
  var first = Math.random() * 46656 | 0;
  var second = Math.random() * 46656 | 0;
  first = ('000' + first.toString(36)).slice(-3);
  second = ('000' + second.toString(36)).slice(-3);
  return first + second;
}

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1063);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayEach_js__ = __webpack_require__(2239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assignValue_js__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseAssign_js__ = __webpack_require__(2241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__copyArray_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__copySymbols_js__ = __webpack_require__(2252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__ = __webpack_require__(2254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__ = __webpack_require__(2255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getTag_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__ = __webpack_require__(2260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__ = __webpack_require__(2261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__ = __webpack_require__(2266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__isBuffer_js__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__isMap_js__ = __webpack_require__(2268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__isObject_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__isSet_js__ = __webpack_require__(2270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__keys_js__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__keysIn_js__ = __webpack_require__(636);























/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!Object(__WEBPACK_IMPORTED_MODULE_18__isObject_js__["a" /* default */])(value)) {
    return value;
  }
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_15__isArray_js__["a" /* default */])(value);
  if (isArr) {
    result = Object(__WEBPACK_IMPORTED_MODULE_12__initCloneArray_js__["a" /* default */])(value);
    if (!isDeep) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__copyArray_js__["a" /* default */])(value, result);
    }
  } else {
    var tag = Object(__WEBPACK_IMPORTED_MODULE_11__getTag_js__["a" /* default */])(value),
        isFunc = tag == funcTag || tag == genTag;

    if (Object(__WEBPACK_IMPORTED_MODULE_16__isBuffer_js__["a" /* default */])(value)) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__cloneBuffer_js__["a" /* default */])(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : Object(__WEBPACK_IMPORTED_MODULE_14__initCloneObject_js__["a" /* default */])(value);
      if (!isDeep) {
        return isFlat
          ? Object(__WEBPACK_IMPORTED_MODULE_8__copySymbolsIn_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_4__baseAssignIn_js__["a" /* default */])(result, value))
          : Object(__WEBPACK_IMPORTED_MODULE_7__copySymbols_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_3__baseAssign_js__["a" /* default */])(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = Object(__WEBPACK_IMPORTED_MODULE_13__initCloneByTag_js__["a" /* default */])(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (Object(__WEBPACK_IMPORTED_MODULE_19__isSet_js__["a" /* default */])(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (Object(__WEBPACK_IMPORTED_MODULE_17__isMap_js__["a" /* default */])(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? __WEBPACK_IMPORTED_MODULE_10__getAllKeysIn_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_9__getAllKeys_js__["a" /* default */])
    : (isFlat ? __WEBPACK_IMPORTED_MODULE_21__keysIn_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_20__keys_js__["a" /* default */]);

  var props = isArr ? undefined : keysFunc(value);
  Object(__WEBPACK_IMPORTED_MODULE_1__arrayEach_js__["a" /* default */])(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    Object(__WEBPACK_IMPORTED_MODULE_2__assignValue_js__["a" /* default */])(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClone);


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(2218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(2219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(2221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(2222);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(147);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(2234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(2236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(2237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(2238);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(2244);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(437)(module)))

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1062);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(437)(module)))

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(631);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(2249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(635);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(2253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(1071);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(1076);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1079),
    castFunction = __webpack_require__(2297);

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn(object, castFunction(iteratee));
}

module.exports = forOwn;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(122),
    stubFalse = __webpack_require__(2291);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 643 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 644 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1084);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(376),
    stackClear = __webpack_require__(2303),
    stackDelete = __webpack_require__(2304),
    stackGet = __webpack_require__(2305),
    stackHas = __webpack_require__(2306),
    stackSet = __webpack_require__(2307);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(2316),
    stubArray = __webpack_require__(1094);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(1088);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkboard = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _checkboard = __webpack_require__(2364);

var checkboard = _interopRequireWildcard(_checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = exports.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;

  var styles = (0, _reactcss2.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return (0, _react.isValidElement)(children) ? _react2.default.cloneElement(children, _extends({}, children.props, { style: _extends({}, children.props.style, styles.grid) })) : _react2.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

exports.default = Checkboard;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(441),
    stackClear = __webpack_require__(2375),
    stackDelete = __webpack_require__(2376),
    stackGet = __webpack_require__(2377),
    stackHas = __webpack_require__(2378),
    stackSet = __webpack_require__(2379);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(132);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(279),
    isObject = __webpack_require__(133);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(2386),
    mapCacheDelete = __webpack_require__(2393),
    mapCacheGet = __webpack_require__(2395),
    mapCacheHas = __webpack_require__(2396),
    mapCacheSet = __webpack_require__(2397);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1106);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 655 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2406),
    isObjectLike = __webpack_require__(222);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 657 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(132),
    stubFalse = __webpack_require__(2408);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2410),
    baseUnary = __webpack_require__(2411),
    nodeUtil = __webpack_require__(2412);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 660 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1113),
    baseKeys = __webpack_require__(2439),
    isArrayLike = __webpack_require__(280);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(134),
    isSymbol = __webpack_require__(447);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _taggedTemplateLiteralLoose;
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Global_1 = __webpack_require__(38);
var Util_1 = __webpack_require__(43);
exports.DD = {
    get isDragging() {
        var flag = false;
        exports.DD._dragElements.forEach(function (elem) {
            if (elem.dragStatus === 'dragging') {
                flag = true;
            }
        });
        return flag;
    },
    justDragged: false,
    get node() {
        var node;
        exports.DD._dragElements.forEach(function (elem) {
            node = elem.node;
        });
        return node;
    },
    _dragElements: new Map(),
    _drag: function (evt) {
        var nodesToFireEvents = [];
        exports.DD._dragElements.forEach(function (elem, key) {
            var node = elem.node;
            var stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === undefined) {
                elem.pointerId = Util_1.Util._getFirstPointerId(evt);
            }
            var pos = stage._changedPointerPositions.find(function (pos) { return pos.id === elem.pointerId; });
            if (!pos) {
                return;
            }
            if (elem.dragStatus !== 'dragging') {
                var dragDistance = node.dragDistance();
                var distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
                if (distance < dragDistance) {
                    return;
                }
                node.startDrag({ evt: evt });
                if (!node.isDragging()) {
                    return;
                }
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
        });
        nodesToFireEvents.forEach(function (node) {
            node.fire('dragmove', {
                type: 'dragmove',
                target: node,
                evt: evt,
            }, true);
        });
    },
    _endDragBefore: function (evt) {
        exports.DD._dragElements.forEach(function (elem, key) {
            var node = elem.node;
            var stage = node.getStage();
            if (evt) {
                stage.setPointersPositions(evt);
            }
            var pos = stage._changedPointerPositions.find(function (pos) { return pos.id === elem.pointerId; });
            if (!pos) {
                return;
            }
            if (elem.dragStatus === 'dragging' || elem.dragStatus === 'stopped') {
                exports.DD.justDragged = true;
                Global_1.Konva.listenClickTap = false;
                elem.dragStatus = 'stopped';
            }
            var drawNode = elem.node.getLayer() ||
                (elem.node instanceof Global_1.Konva['Stage'] && elem.node);
            if (drawNode) {
                drawNode.draw();
            }
        });
    },
    _endDragAfter: function (evt) {
        exports.DD._dragElements.forEach(function (elem, key) {
            if (elem.dragStatus === 'stopped') {
                elem.node.fire('dragend', {
                    type: 'dragend',
                    target: elem.node,
                    evt: evt,
                }, true);
            }
            if (elem.dragStatus !== 'dragging') {
                exports.DD._dragElements.delete(key);
            }
        });
    },
};
if (Global_1.Konva.isBrowser) {
    window.addEventListener('mouseup', exports.DD._endDragBefore, true);
    window.addEventListener('touchend', exports.DD._endDragBefore, true);
    window.addEventListener('mousemove', exports.DD._drag);
    window.addEventListener('touchmove', exports.DD._drag);
    window.addEventListener('mouseup', exports.DD._endDragAfter, false);
    window.addEventListener('touchend', exports.DD._endDragAfter, false);
}


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Container_1 = __webpack_require__(450);
var Global_1 = __webpack_require__(38);
var Group = (function (_super) {
    __extends(Group, _super);
    function Group() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Group.prototype._validateAdd = function (child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') {
            Util_1.Util.throw('You may only add groups and shapes to groups.');
        }
    };
    return Group;
}(Container_1.Container));
exports.Group = Group;
Group.prototype.nodeType = 'Group';
Global_1._registerNode(Group);
Util_1.Collection.mapMethods(Group);


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Global_1 = __webpack_require__(38);
var now = (function () {
    if (Global_1.glob.performance && Global_1.glob.performance.now) {
        return function () {
            return Global_1.glob.performance.now();
        };
    }
    return function () {
        return new Date().getTime();
    };
})();
var Animation = (function () {
    function Animation(func, layers) {
        this.id = Animation.animIdCounter++;
        this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: now(),
            frameRate: 0
        };
        this.func = func;
        this.setLayers(layers);
    }
    Animation.prototype.setLayers = function (layers) {
        var lays = [];
        if (!layers) {
            lays = [];
        }
        else if (layers.length > 0) {
            lays = layers;
        }
        else {
            lays = [layers];
        }
        this.layers = lays;
        return this;
    };
    Animation.prototype.getLayers = function () {
        return this.layers;
    };
    Animation.prototype.addLayer = function (layer) {
        var layers = this.layers, len = layers.length, n;
        for (n = 0; n < len; n++) {
            if (layers[n]._id === layer._id) {
                return false;
            }
        }
        this.layers.push(layer);
        return true;
    };
    Animation.prototype.isRunning = function () {
        var a = Animation, animations = a.animations, len = animations.length, n;
        for (n = 0; n < len; n++) {
            if (animations[n].id === this.id) {
                return true;
            }
        }
        return false;
    };
    Animation.prototype.start = function () {
        this.stop();
        this.frame.timeDiff = 0;
        this.frame.lastTime = now();
        Animation._addAnimation(this);
        return this;
    };
    Animation.prototype.stop = function () {
        Animation._removeAnimation(this);
        return this;
    };
    Animation.prototype._updateFrameObject = function (time) {
        this.frame.timeDiff = time - this.frame.lastTime;
        this.frame.lastTime = time;
        this.frame.time += this.frame.timeDiff;
        this.frame.frameRate = 1000 / this.frame.timeDiff;
    };
    Animation._addAnimation = function (anim) {
        this.animations.push(anim);
        this._handleAnimation();
    };
    Animation._removeAnimation = function (anim) {
        var id = anim.id, animations = this.animations, len = animations.length, n;
        for (n = 0; n < len; n++) {
            if (animations[n].id === id) {
                this.animations.splice(n, 1);
                break;
            }
        }
    };
    Animation._runFrames = function () {
        var layerHash = {}, animations = this.animations, anim, layers, func, n, i, layersLen, layer, key, needRedraw;
        for (n = 0; n < animations.length; n++) {
            anim = animations[n];
            layers = anim.layers;
            func = anim.func;
            anim._updateFrameObject(now());
            layersLen = layers.length;
            if (func) {
                needRedraw = func.call(anim, anim.frame) !== false;
            }
            else {
                needRedraw = true;
            }
            if (!needRedraw) {
                continue;
            }
            for (i = 0; i < layersLen; i++) {
                layer = layers[i];
                if (layer._id !== undefined) {
                    layerHash[layer._id] = layer;
                }
            }
        }
        for (key in layerHash) {
            if (!layerHash.hasOwnProperty(key)) {
                continue;
            }
            layerHash[key].draw();
        }
    };
    Animation._animationLoop = function () {
        var Anim = Animation;
        if (Anim.animations.length) {
            Anim._runFrames();
            requestAnimationFrame(Anim._animationLoop);
        }
        else {
            Anim.animRunning = false;
        }
    };
    Animation._handleAnimation = function () {
        if (!this.animRunning) {
            this.animRunning = true;
            requestAnimationFrame(this._animationLoop);
        }
    };
    Animation.animations = [];
    Animation.animIdCounter = 0;
    Animation.animRunning = false;
    return Animation;
}());
exports.Animation = Animation;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */


var validateFormat =  false ? function (format) {} : function (format) {
  if (format === undefined) {
    throw new Error('invariant(...): Second argument must be a string.');
  }
};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuPlacer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return containerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return clearIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return dropdownIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return groupHeadingCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return indicatorSeparatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return groupCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return inputCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return indicatorsContainerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return loadingMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return menuListCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return loadingIndicatorCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return menuCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return menuPortalCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return multiValueCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return multiValueLabelCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return multiValueRemoveCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return noOptionsMessageCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return optionCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return placeholderCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return css$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return valueContainerCSS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return defaultComponents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return exportedEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return components; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__emotion_core__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__emotion_css__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__babel_runtime_helpers_esm_taggedTemplateLiteral__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_input_autosize__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_input_autosize__);




















function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;
  var scrollParent = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["a"])(menuEl);
  var defaultState = {
    placement: 'bottom',
    maxHeight: maxHeight
  }; // something went wrong, return default state

  if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["b"])(scrollParent);
  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["c"])(scrollParent, scrollDown, scrollDuration);
        }

        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["c"])(scrollParent, scrollDown, scrollDuration);
        } // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.


        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      } // 4. Forked beviour when there isn't enough space below
      // AUTO: flip the menu, render above


      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;
        var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

        if (spaceAbove >= minHeight) {
          _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight
        };
      } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


      if (placement === 'bottom') {
        Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["l" /* s */])(scrollParent, scrollDown);
        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };
      }

      break;

    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 2: the menu will fit, if scrolled


      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["c"])(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: maxHeight
        };
      } // 3: the menu will fit, if constrained


      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["c"])(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      } // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below


      return {
        placement: 'bottom',
        maxHeight: maxHeight
      };

    default:
      throw new Error("Invalid placement provided \"".concat(placement, "\"."));
  } // fulfil contract with flow: implicit return value of undefined


  return defaultState;
} // Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = {
    bottom: 'top',
    top: 'bottom'
  };
  return placement ? placementToCSSProp[placement] : 'bottom';
}

var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {
    label: 'menu'
  }, Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, alignToControl(placement), '100%'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "backgroundColor", colors.neutral0), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "borderRadius", borderRadius), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "boxShadow", '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginBottom", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "marginTop", spacing.menuGutter), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "position", 'absolute'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "width", '100%'), Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_ref3, "zIndex", 1), _ref3;
}; // NOTE: internal only

var MenuPlacer =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPlacer, _Component);

  function MenuPlacer() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPlacer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MenuPlacer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getPlacement", function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;
      if (!ref) return; // DO NOT scroll if position is fixed

      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });
      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    });

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getUpdatedProps", function () {
      var menuPlacement = _this.props.menuPlacement;
      var placement = _this.state.placement || coercePlacement(menuPlacement);
      return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, _this.props, {
        placement: placement,
        maxHeight: _this.state.maxHeight
      });
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPlacer, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);

  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MenuPlacer, "contextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func
});

var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('menu', props),
    className: cx({
      menu: true
    }, className)
  }, innerProps, {
    ref: innerRef
  }), children);
};
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref4) {
  var maxHeight = _ref4.maxHeight,
      baseUnit = _ref4.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative',
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", {
    css: getStyles('menuList', props),
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef
  }, children);
}; // ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref5) {
  var _ref5$theme = _ref5.theme,
      baseUnit = _ref5$theme.spacing.baseUnit,
      colors = _ref5$theme.colors;
  return {
    color: colors.neutral40,
    padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
    textAlign: 'center'
  };
};

var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;
var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('noOptionsMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className)
  }, innerProps), children);
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};
var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('loadingMessage', props),
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className)
  }, innerProps), children);
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
}; // ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};
var MenuPortal =
/*#__PURE__*/
function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MenuPortal, _Component2);

  function MenuPortal() {
    var _getPrototypeOf3;

    var _this2;

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MenuPortal);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf3 = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MenuPortal)).call.apply(_getPrototypeOf3, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this2)), "state", {
      placement: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this2)), "getPortalPlacement", function (_ref7) {
      var placement = _ref7.placement;
      var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

      if (placement !== initialPlacement) {
        _this2.setState({
          placement: placement
        });
      }
    });

    return _this2;
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MenuPortal, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    } // callback for occassions where the menu must "flip"

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["g"])(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", {
        css: getStyles('menuPortal', state)
      }, children);
      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_12_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);

  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MenuPortal, "childContextTypes", {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func
});

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && Object(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_typeof__["a" /* default */])(a) == 'object' && Object(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    } // end fast-deep-equal
    // Custom handling for React


    for (i = length; i-- !== 0;) {
      key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    } // fast-deep-equal index.js 2.0.1


    return true;
  }

  return a !== a && b !== b;
} // end fast-deep-equal


function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    } // some other error. we should definitely know about these


    throw error;
  }
}

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    label: 'container',
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null,
    // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('container', props),
    className: cx({
      '--is-disabled': isDisabled,
      '--is-rtl': isRtl
    }, className)
  }, innerProps), children);
}; // ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(ValueContainer, _Component);

  function ValueContainer() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ValueContainer);

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ValueContainer).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(ValueContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          cx = _this$props.cx,
          isMulti = _this$props.isMulti,
          getStyles = _this$props.getStyles,
          hasValue = _this$props.hasValue;
      return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", {
        css: getStyles('valueContainer', this.props),
        className: cx({
          'value-container': true,
          'value-container--is-multi': isMulti,
          'value-container--has-value': hasValue
        }, className)
      }, children);
    }
  }]);

  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]); // ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", {
    css: getStyles('indicatorsContainer', props),
    className: cx({
      indicators: true
    }, className)
  }, children);
};

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_17__babel_runtime_helpers_esm_taggedTemplateLiteral__["a" /* default */])(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _ref2 =  true ? {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
} : {
  name: "19bqh2r",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
};

// ==============================
// Dropdown & Clear Icons
// ==============================
var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["size"]);

  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("svg", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    height: size,
    width: size,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: _ref2
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(Svg, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
};
var DownChevron = function DownChevron(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(Svg, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: 20
  }, props), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref3) {
  var isFocused = _ref3.isFocused,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    label: 'indicatorContainer',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('dropdownIndicator', props),
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className)
  }), children || Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(DownChevron, null));
};
var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('clearIndicator', props),
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className)
  }), children || Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(CrossIcon, null));
}; // ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
  var isDisabled = _ref4.isDisabled,
      _ref4$theme = _ref4.theme,
      baseUnit = _ref4$theme.spacing.baseUnit,
      colors = _ref4$theme.colors;
  return {
    label: 'indicatorSeparator',
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};
var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('indicatorSeparator', props),
    className: cx({
      'indicator-separator': true
    }, className)
  }));
}; // ==============================
// Loading
// ==============================

var loadingDotAnimations = Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["keyframes"])(_templateObject());
var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
  var isFocused = _ref5.isFocused,
      size = _ref5.size,
      _ref5$theme = _ref5.theme,
      colors = _ref5$theme.colors,
      baseUnit = _ref5$theme.spacing.baseUnit;
  return {
    label: 'loadingIndicator',
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref6) {
  var delay = _ref6.delay,
      offset = _ref6.offset;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("span", {
    css:
    /*#__PURE__*/
    Object(__WEBPACK_IMPORTED_MODULE_16__emotion_css__["a" /* default */])({
      animation: "".concat(loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
      backgroundColor: 'currentColor',
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
};

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isRtl = props.isRtl;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, innerProps, {
    css: getStyles('loadingIndicator', props),
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className)
  }), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(LoadingDot, {
    delay: 0,
    offset: isRtl
  }), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(LoadingDot, {
    delay: 160,
    offset: true
  }), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(LoadingDot, {
    delay: 320,
    offset: !isRtl
  }));
};
LoadingIndicator.defaultProps = {
  size: 4
};

var css = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    label: 'control',
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',
    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps,
      menuIsOpen = props.menuIsOpen;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: innerRef,
    css: getStyles('control', props),
    className: cx({
      control: true,
      'control--is-disabled': isDisabled,
      'control--is-focused': isFocused,
      'control--menu-is-open': menuIsOpen
    }, className)
  }, innerProps), children);
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme,
      selectProps = props.selectProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", {
    css: getStyles('group', props),
    className: cx({
      group: true
    }, className)
  }, Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(Heading, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, headingProps, {
    selectProps: selectProps,
    theme: theme,
    getStyles: getStyles,
    cx: cx
  }), label), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", null, children));
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    label: 'group',
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};
var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      selectProps = props.selectProps,
      cleanProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('groupHeading', Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      theme: theme
    }, cleanProps)),
    className: cx({
      'group-heading': true
    }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};

var inputStyle = function inputStyle(isHidden) {
  return {
    label: 'input',
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      selectProps = _ref2.selectProps,
      props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", {
    css: getStyles('input', Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      theme: theme
    }, props))
  }, Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(__WEBPACK_IMPORTED_MODULE_18_react_input_autosize___default.a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: cx({
      input: true
    }, className),
    inputRef: innerRef,
    inputStyle: inputStyle(isHidden),
    disabled: isDisabled
  }, props)));
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    label: 'multiValue',
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug

  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};
var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", innerProps, children);
};
var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;
var MultiValueRemove =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MultiValueRemove, _Component);

  function MultiValueRemove() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MultiValueRemove);

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MultiValueRemove).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MultiValueRemove, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          innerProps = _this$props.innerProps;
      return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", innerProps, children || Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(CrossIcon, {
        size: 14
      }));
    }
  }]);

  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

var MultiValue =
/*#__PURE__*/
function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_inherits__["a" /* default */])(MultiValue, _Component2);

  function MultiValue() {
    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, MultiValue);

    return Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(MultiValue).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_createClass__["a" /* default */])(MultiValue, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          components = _this$props2.components,
          cx = _this$props2.cx,
          data = _this$props2.data,
          getStyles = _this$props2.getStyles,
          innerProps = _this$props2.innerProps,
          isDisabled = _this$props2.isDisabled,
          removeProps = _this$props2.removeProps,
          selectProps = _this$props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;
      return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["ClassNames"], null, function (_ref5) {
        var css = _ref5.css,
            emotionCx = _ref5.cx;
        return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(Container, {
          data: data,
          innerProps: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, innerProps, {
            className: emotionCx(css(getStyles('multiValue', _this.props)), cx({
              'multi-value': true,
              'multi-value--is-disabled': isDisabled
            }, className))
          }),
          selectProps: selectProps
        }, Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(Label, {
          data: data,
          innerProps: {
            className: emotionCx(css(getStyles('multiValueLabel', _this.props)), cx({
              'multi-value__label': true
            }, className))
          },
          selectProps: selectProps
        }, children), Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])(Remove, {
          data: data,
          innerProps: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
            className: emotionCx(css(getStyles('multiValueRemove', _this.props)), cx({
              'multi-value__remove': true
            }, className))
          }, removeProps),
          selectProps: selectProps
        }));
      });
    }
  }]);

  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(MultiValue, "defaultProps", {
  cropWithEllipsis: true
});

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'option',
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
    // provide some affordance on touch devices
    ':active': {
      backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('option', props),
    className: cx({
      option: true,
      'option--is-disabled': isDisabled,
      'option--is-focused': isFocused,
      'option--is-selected': isSelected
    }, className),
    ref: innerRef
  }, innerProps), children);
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'placeholder',
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('placeholder', props),
    className: cx({
      placeholder: true
    }, className)
  }, innerProps), children);
};

var css$1 = function css(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    label: 'singleValue',
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;
  return Object(__WEBPACK_IMPORTED_MODULE_11__emotion_core__["jsx"])("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: getStyles('singleValue', props),
    className: cx({
      'single-value': true,
      'single-value--is-disabled': isDisabled
    }, className)
  }, innerProps), children);
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};
var defaultComponents = function defaultComponents(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, components, props.components);
};




/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _taggedTemplateLiteral;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select; });
/* unused harmony export a */
/* unused harmony export c */
/* unused harmony export d */
/* unused harmony export m */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoize_one__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emotion_core__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__emotion_css__ = __webpack_require__(274);



















var diacritics = [{
  base: 'A',
  letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
}, {
  base: 'AA',
  letters: /[\uA732]/g
}, {
  base: 'AE',
  letters: /[\u00C6\u01FC\u01E2]/g
}, {
  base: 'AO',
  letters: /[\uA734]/g
}, {
  base: 'AU',
  letters: /[\uA736]/g
}, {
  base: 'AV',
  letters: /[\uA738\uA73A]/g
}, {
  base: 'AY',
  letters: /[\uA73C]/g
}, {
  base: 'B',
  letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
}, {
  base: 'C',
  letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
}, {
  base: 'D',
  letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
}, {
  base: 'DZ',
  letters: /[\u01F1\u01C4]/g
}, {
  base: 'Dz',
  letters: /[\u01F2\u01C5]/g
}, {
  base: 'E',
  letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
}, {
  base: 'F',
  letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
}, {
  base: 'G',
  letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
}, {
  base: 'H',
  letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
}, {
  base: 'I',
  letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
}, {
  base: 'J',
  letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
}, {
  base: 'K',
  letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
}, {
  base: 'L',
  letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
}, {
  base: 'LJ',
  letters: /[\u01C7]/g
}, {
  base: 'Lj',
  letters: /[\u01C8]/g
}, {
  base: 'M',
  letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
}, {
  base: 'N',
  letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
}, {
  base: 'NJ',
  letters: /[\u01CA]/g
}, {
  base: 'Nj',
  letters: /[\u01CB]/g
}, {
  base: 'O',
  letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
}, {
  base: 'OI',
  letters: /[\u01A2]/g
}, {
  base: 'OO',
  letters: /[\uA74E]/g
}, {
  base: 'OU',
  letters: /[\u0222]/g
}, {
  base: 'P',
  letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
}, {
  base: 'Q',
  letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
}, {
  base: 'R',
  letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
}, {
  base: 'S',
  letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
}, {
  base: 'T',
  letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
}, {
  base: 'TZ',
  letters: /[\uA728]/g
}, {
  base: 'U',
  letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
}, {
  base: 'V',
  letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
}, {
  base: 'VY',
  letters: /[\uA760]/g
}, {
  base: 'W',
  letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
}, {
  base: 'X',
  letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
}, {
  base: 'Y',
  letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
}, {
  base: 'Z',
  letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
}, {
  base: 'a',
  letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
}, {
  base: 'aa',
  letters: /[\uA733]/g
}, {
  base: 'ae',
  letters: /[\u00E6\u01FD\u01E3]/g
}, {
  base: 'ao',
  letters: /[\uA735]/g
}, {
  base: 'au',
  letters: /[\uA737]/g
}, {
  base: 'av',
  letters: /[\uA739\uA73B]/g
}, {
  base: 'ay',
  letters: /[\uA73D]/g
}, {
  base: 'b',
  letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
}, {
  base: 'c',
  letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
}, {
  base: 'd',
  letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
}, {
  base: 'dz',
  letters: /[\u01F3\u01C6]/g
}, {
  base: 'e',
  letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
}, {
  base: 'f',
  letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
}, {
  base: 'g',
  letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
}, {
  base: 'h',
  letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
}, {
  base: 'hv',
  letters: /[\u0195]/g
}, {
  base: 'i',
  letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
}, {
  base: 'j',
  letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
}, {
  base: 'k',
  letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
}, {
  base: 'l',
  letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
}, {
  base: 'lj',
  letters: /[\u01C9]/g
}, {
  base: 'm',
  letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
}, {
  base: 'n',
  letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
}, {
  base: 'nj',
  letters: /[\u01CC]/g
}, {
  base: 'o',
  letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
}, {
  base: 'oi',
  letters: /[\u01A3]/g
}, {
  base: 'ou',
  letters: /[\u0223]/g
}, {
  base: 'oo',
  letters: /[\uA74F]/g
}, {
  base: 'p',
  letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
}, {
  base: 'q',
  letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
}, {
  base: 'r',
  letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
}, {
  base: 's',
  letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
}, {
  base: 't',
  letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
}, {
  base: 'tz',
  letters: /[\uA729]/g
}, {
  base: 'u',
  letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
}, {
  base: 'v',
  letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
}, {
  base: 'vy',
  letters: /[\uA761]/g
}, {
  base: 'w',
  letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
}, {
  base: 'x',
  letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
}, {
  base: 'y',
  letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
}, {
  base: 'z',
  letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
}];
var stripDiacritics = function stripDiacritics(str) {
  for (var i = 0; i < diacritics.length; i++) {
    str = str.replace(diacritics[i].letters, diacritics[i].base);
  }

  return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var defaultStringify = function defaultStringify(option) {
  return "".concat(option.label, " ").concat(option.value);
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);

    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }

    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

var _ref =  true ? {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
} : {
  name: "1laao21-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFNIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICAgIDxzcGFuXG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICAgIHpJbmRleDogOTk5OSxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgICAgaGVpZ2h0OiAxLFxuICAgICAgICB3aWR0aDogMSxcbiAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgICB9fVxuICAgICAgey4uLnByb3BzfVxuICAgIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */"
};

var A11yText = function A11yText(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["jsx"])("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    css: _ref
  }, props));
};

var DummyInput =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(DummyInput, _Component);

  function DummyInput() {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, DummyInput);

    return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(DummyInput).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(DummyInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          inProp = _this$props.in,
          out = _this$props.out,
          onExited = _this$props.onExited,
          appear = _this$props.appear,
          enter = _this$props.enter,
          exit = _this$props.exit,
          innerRef = _this$props.innerRef,
          emotion = _this$props.emotion,
          props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

      return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["jsx"])("input", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: innerRef
      }, props, {
        css:
        /*#__PURE__*/
        Object(__WEBPACK_IMPORTED_MODULE_17__emotion_css__["a" /* default */])({
          label: 'dummyInput',
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,
          // important! without `width` browsers won't allow focus
          width: 1,
          // remove cursor on desktop
          color: 'transparent',
          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        },  true ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBWVEiLCJmaWxlIjoiRHVtbXlJbnB1dC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG4vKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL2NvcmUnO1xuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBEdW1teUlucHV0IGV4dGVuZHMgQ29tcG9uZW50PGFueT4ge1xuICByZW5kZXIgKCkge1xuICAgIGNvbnN0IHsgaW46IGluUHJvcCwgb3V0LCBvbkV4aXRlZCwgYXBwZWFyLCBlbnRlciwgZXhpdCwgaW5uZXJSZWYsIGVtb3Rpb24sIC4uLnByb3BzIH0gPSB0aGlzLnByb3BzO1xuICAgIHJldHVybihcbiAgICAgIDxpbnB1dFxuICAgICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgICB7Li4ucHJvcHN9XG4gICAgICAgIGNzcz17e1xuICAgICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgICAgfX1cbiAgICAgIC8+XG4gICAgKTtcbiAgfVxufVxuIl19 */")
      }));
    }
  }]);

  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var NodeResolver =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(NodeResolver, _Component);

  function NodeResolver() {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NodeResolver);

    return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(NodeResolver).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(NodeResolver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_14_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
var LOCK_STYLES = {
  boxSizing: 'border-box',
  // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}
function allowTouchMove(e) {
  e.stopPropagation();
}
function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(window.document && window.document.createElement);
var activeScrollLocks = 0;

var ScrollLock =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollLock, _Component);

  function ScrollLock() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollLock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollLock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "originalStyles", {});

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "listenerOptions", {
      capture: false,
      passive: false
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollLock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(ScrollLock, "defaultProps", {
  accountForScrollbars: true
});

var _ref$1 =  true ? {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
} : {
  name: "1dsbpcp",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var ScrollBlock =
/*#__PURE__*/
function (_PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollBlock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollBlock)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      touchScrollTarget: null
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getScrollTarget", function (ref) {
      if (ref === _this.state.touchScrollTarget) return;

      _this.setState({
        touchScrollTarget: ref
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "blurSelectInput", function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollBlock, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["jsx"])("div", null, Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["jsx"])("div", {
        onClick: this.blurSelectInput,
        css: _ref$1
      }), Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["jsx"])(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? Object(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["jsx"])(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    }
  }]);

  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_11_react__["PureComponent"]);

var ScrollCaptor =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _getPrototypeOf2;

    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollCaptor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollCaptor)).call.apply(_getPrototypeOf2, [this].concat(args)));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isBottom", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isTop", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "scrollTarget", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "touchStart", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "cancelScroll", function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleEventDelta", function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;
      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false; // reset bottom/top flags

      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }

      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      } // bottom limit


      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }

        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true; // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }

        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      } // cancel scroll


      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onWheel", function (event) {
      _this.handleEventDelta(event, event.deltaY);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchStart", function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchMove", function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;

      _this.handleEventDelta(event, deltaY);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getScrollTarget", function (ref) {
      _this.scrollTarget = ref;
    });

    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollCaptor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: "startListening",
    value: function startListening(el) {
      // bail early if no element is available to attach to
      if (!el) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "stopListening",
    value: function stopListening(el) {
      // all the if statements are to appease Flow 😢
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    }
  }]);

  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var ScrollCaptorSwitch =
/*#__PURE__*/
function (_Component2) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ScrollCaptorSwitch);

    return Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(ScrollCaptorSwitch).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(ScrollCaptorSwitch, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          isEnabled = _this$props2.isEnabled,
          props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["isEnabled"]);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);

  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(ScrollCaptorSwitch, "defaultProps", {
  isEnabled: true
});

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label,
      isDisabled = context.isDisabled;

  switch (event) {
    case 'menu':
      return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu, press Tab to select the option and exit the menu.");

    case 'input':
      return "".concat(label ? label : 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');

    case 'value':
      return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
  }
};
var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value,
      isDisabled = context.isDisabled;
  if (!value) return;

  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return "option ".concat(value, ", deselected.");

    case 'select-option':
      return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
  }
};
var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? ' disabled' : '', ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return "".concat(screenReaderMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
var getOptionValue = function getOptionValue(option) {
  return option.value;
};
var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var defaultStyles = {
  clearIndicator: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["d" /* c */],
  container: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["b" /* a */],
  control: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["c" /* b */],
  dropdownIndicator: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["e" /* d */],
  group: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["h" /* g */],
  groupHeading: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["f" /* e */],
  indicatorsContainer: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["j" /* i */],
  indicatorSeparator: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["g" /* f */],
  input: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["i" /* h */],
  loadingIndicator: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["m" /* l */],
  loadingMessage: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["k" /* j */],
  menu: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["n" /* m */],
  menuList: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["l" /* k */],
  menuPortal: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["o" /* n */],
  multiValue: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["p" /* o */],
  multiValueLabel: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["q" /* p */],
  multiValueRemove: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["r" /* q */],
  noOptionsMessage: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["s" /* r */],
  option: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["t" /* s */],
  placeholder: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["u" /* t */],
  singleValue: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["v" /* u */],
  valueContainer: __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["w" /* v */]
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, source); // massage in target styles


  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });
  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',
  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};
var borderRadius = 4; // Used to calculate consistent margin/padding on elements

var baseUnit = 4; // The minimum height of the control

var controlHeight = 38; // The amount of space between the control and menu */

var menuGutter = baseUnit * 2;
var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};
var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["i"])(),
  captureMenuScroll: !Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["i"])(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["d"])(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};
var instanceId = 1;

var Select =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(Select, _Component);

  // Misc. Instance Properties
  // ------------------------------
  // TODO
  // Refs
  // ------------------------------
  // Lifecycle
  // ------------------------------
  function Select(_props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Select);

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Select).call(this, _props));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
      ariaLiveSelection: '',
      ariaLiveContext: '',
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: false,
      isFocused: false,
      menuOptions: {
        render: [],
        focusable: []
      },
      selectValue: []
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "blockOptionHover", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "isComposing", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "clearFocusValueOnUpdate", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "commonProps", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "components", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "hasGroups", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "initialTouchX", 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "initialTouchY", 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "inputIsHiddenAfterUpdate", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "instancePrefix", '');

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "openAfterFocus", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "scrollToFocusedOptionOnUpdate", false);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "userIsDragging", void 0);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "controlRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getControlRef", function (ref) {
      _this.controlRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "focusedOptionRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getFocusedOptionRef", function (ref) {
      _this.focusedOptionRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "menuListRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getMenuListRef", function (ref) {
      _this.menuListRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "inputRef", null);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getInputRef", function (ref) {
      _this.inputRef = ref;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "cacheComponents", function (components) {
      _this.components = Object(__WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["x" /* w */])({
        components: components
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "focus", _this.focusInput);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "blur", _this.blurInput);

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onChange", function (newValue, actionMeta) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          name = _this$props.name;
      onChange(newValue, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, actionMeta, {
        name: name
      }));
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "setValue", function (newValue) {
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
      var option = arguments.length > 2 ? arguments[2] : undefined;
      var _this$props2 = _this.props,
          closeMenuOnSelect = _this$props2.closeMenuOnSelect,
          isMulti = _this$props2.isMulti;

      _this.onInputChange('', {
        action: 'set-value'
      });

      if (closeMenuOnSelect) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } // when the select value should change, we should reset focusedValue


      _this.clearFocusValueOnUpdate = true;

      _this.onChange(newValue, {
        action: action,
        option: option
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "selectOption", function (newValue) {
      var _this$props3 = _this.props,
          blurInputOnSelect = _this$props3.blurInputOnSelect,
          isMulti = _this$props3.isMulti;
      var selectValue = _this.state.selectValue;

      if (isMulti) {
        if (_this.isOptionSelected(newValue, selectValue)) {
          var candidate = _this.getOptionValue(newValue);

          _this.setValue(selectValue.filter(function (i) {
            return _this.getOptionValue(i) !== candidate;
          }), 'deselect-option', newValue);

          _this.announceAriaLiveSelection({
            event: 'deselect-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue([].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(selectValue), [newValue]), 'select-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }
      } else {
        if (!_this.isOptionDisabled(newValue, selectValue)) {
          _this.setValue(newValue, 'select-option');

          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue)
            }
          });
        } else {
          // announce that option is disabled
          _this.announceAriaLiveSelection({
            event: 'select-option',
            context: {
              value: _this.getOptionLabel(newValue),
              isDisabled: true
            }
          });
        }
      }

      if (blurInputOnSelect) {
        _this.blurInput();
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "removeValue", function (removedValue) {
      var selectValue = _this.state.selectValue;

      var candidate = _this.getOptionValue(removedValue);

      var newValue = selectValue.filter(function (i) {
        return _this.getOptionValue(i) !== candidate;
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'remove-value',
        removedValue: removedValue
      });

      _this.announceAriaLiveSelection({
        event: 'remove-value',
        context: {
          value: removedValue ? _this.getOptionLabel(removedValue) : ''
        }
      });

      _this.focusInput();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "clearValue", function () {
      var isMulti = _this.props.isMulti;

      _this.onChange(isMulti ? [] : null, {
        action: 'clear'
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "popValue", function () {
      var selectValue = _this.state.selectValue;
      var lastSelectedValue = selectValue[selectValue.length - 1];
      var newValue = selectValue.slice(0, selectValue.length - 1);

      _this.announceAriaLiveSelection({
        event: 'pop-value',
        context: {
          value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
        }
      });

      _this.onChange(newValue.length ? newValue : null, {
        action: 'pop-value',
        removedValue: lastSelectedValue
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getOptionLabel", function (data) {
      return _this.props.getOptionLabel(data);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getOptionValue", function (data) {
      return _this.props.getOptionValue(data);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getStyles", function (key, props) {
      var base = defaultStyles[key](props);
      base.boxSizing = 'border-box';
      var custom = _this.props.styles[key];
      return custom ? custom(base, props) : base;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getElementId", function (element) {
      return "".concat(_this.instancePrefix, "-").concat(element);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "getActiveDescendentId", function () {
      var menuIsOpen = _this.props.menuIsOpen;
      var _this$state = _this.state,
          menuOptions = _this$state.menuOptions,
          focusedOption = _this$state.focusedOption;
      if (!focusedOption || !menuIsOpen) return undefined;
      var index = menuOptions.focusable.indexOf(focusedOption);
      var option = menuOptions.render[index];
      return option && option.key;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "announceAriaLiveSelection", function (_ref2) {
      var event = _ref2.event,
          context = _ref2.context;

      _this.setState({
        ariaLiveSelection: valueEventAriaMessage(event, context)
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "announceAriaLiveContext", function (_ref3) {
      var event = _ref3.event,
          context = _ref3.context;

      _this.setState({
        ariaLiveContext: instructionsAriaMessage(event, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, context, {
          label: _this.props['aria-label']
        }))
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuMouseDown", function (event) {
      if (event.button !== 0) {
        return;
      }

      event.stopPropagation();
      event.preventDefault();

      _this.focusInput();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuMouseMove", function (event) {
      _this.blockOptionHover = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onControlMouseDown", function (event) {
      var openMenuOnClick = _this.props.openMenuOnClick;

      if (!_this.state.isFocused) {
        if (openMenuOnClick) {
          _this.openAfterFocus = true;
        }

        _this.focusInput();
      } else if (!_this.props.menuIsOpen) {
        if (openMenuOnClick) {
          _this.openMenu('first');
        }
      } else {
        //$FlowFixMe
        if (event.target.tagName !== 'INPUT') {
          _this.onMenuClose();
        }
      } //$FlowFixMe


      if (event.target.tagName !== 'INPUT') {
        event.preventDefault();
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onDropdownIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      if (_this.props.isDisabled) return;
      var _this$props4 = _this.props,
          isMulti = _this$props4.isMulti,
          menuIsOpen = _this$props4.menuIsOpen;

      _this.focusInput();

      if (menuIsOpen) {
        _this.inputIsHiddenAfterUpdate = !isMulti;

        _this.onMenuClose();
      } else {
        _this.openMenu('first');
      }

      event.preventDefault();
      event.stopPropagation();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onClearIndicatorMouseDown", function (event) {
      // ignore mouse events that weren't triggered by the primary button
      if (event && event.type === 'mousedown' && event.button !== 0) {
        return;
      }

      _this.clearValue();

      event.stopPropagation();
      _this.openAfterFocus = false;

      if (event.type === 'touchend') {
        _this.focusInput();
      } else {
        setTimeout(function () {
          return _this.focusInput();
        });
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onScroll", function (event) {
      if (typeof _this.props.closeMenuOnScroll === 'boolean') {
        if (event.target instanceof HTMLElement && Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["e"])(event.target)) {
          _this.props.onMenuClose();
        }
      } else if (typeof _this.props.closeMenuOnScroll === 'function') {
        if (_this.props.closeMenuOnScroll(event)) {
          _this.props.onMenuClose();
        }
      }
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onCompositionStart", function () {
      _this.isComposing = true;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onCompositionEnd", function () {
      _this.isComposing = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchStart", function (_ref4) {
      var touches = _ref4.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      _this.initialTouchX = touch.clientX;
      _this.initialTouchY = touch.clientY;
      _this.userIsDragging = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchMove", function (_ref5) {
      var touches = _ref5.touches;
      var touch = touches.item(0);

      if (!touch) {
        return;
      }

      var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
      var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
      var moveThreshold = 5;
      _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onTouchEnd", function (event) {
      if (_this.userIsDragging) return; // close the menu if the user taps outside
      // we're checking on event.target here instead of event.currentTarget, because we want to assert information
      // on events on child elements, not the document (which we've attached this handler to).

      if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
        _this.blurInput();
      } // reset move vars


      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onControlTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onControlMouseDown(event);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onClearIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onClearIndicatorMouseDown(event);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onDropdownIndicatorTouchEnd", function (event) {
      if (_this.userIsDragging) return;

      _this.onDropdownIndicatorMouseDown(event);
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "handleInputChange", function (event) {
      var inputValue = event.currentTarget.value;
      _this.inputIsHiddenAfterUpdate = false;

      _this.onInputChange(inputValue, {
        action: 'input-change'
      });

      _this.onMenuOpen();
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onInputFocus", function (event) {
      var _this$props5 = _this.props,
          isSearchable = _this$props5.isSearchable,
          isMulti = _this$props5.isMulti;

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.inputIsHiddenAfterUpdate = false;

      _this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });

      _this.setState({
        isFocused: true
      });

      if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
        _this.openMenu('first');
      }

      _this.openAfterFocus = false;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onInputBlur", function (event) {
      if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
        _this.inputRef.focus();

        return;
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.onInputChange('', {
        action: 'input-blur'
      });

      _this.onMenuClose();

      _this.setState({
        focusedValue: null,
        isFocused: false
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onOptionHover", function (focusedOption) {
      if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
        return;
      }

      _this.setState({
        focusedOption: focusedOption
      });
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "shouldHideSelectedOptions", function () {
      var _this$props6 = _this.props,
          hideSelectedOptions = _this$props6.hideSelectedOptions,
          isMulti = _this$props6.isMulti;
      if (hideSelectedOptions === undefined) return isMulti;
      return hideSelectedOptions;
    });

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onKeyDown", function (event) {
      var _this$props7 = _this.props,
          isMulti = _this$props7.isMulti,
          backspaceRemovesValue = _this$props7.backspaceRemovesValue,
          escapeClearsValue = _this$props7.escapeClearsValue,
          inputValue = _this$props7.inputValue,
          isClearable = _this$props7.isClearable,
          isDisabled = _this$props7.isDisabled,
          menuIsOpen = _this$props7.menuIsOpen,
          onKeyDown = _this$props7.onKeyDown,
          tabSelectsValue = _this$props7.tabSelectsValue,
          openMenuOnFocus = _this$props7.openMenuOnFocus;
      var _this$state2 = _this.state,
          focusedOption = _this$state2.focusedOption,
          focusedValue = _this$state2.focusedValue,
          selectValue = _this$state2.selectValue;
      if (isDisabled) return;

      if (typeof onKeyDown === 'function') {
        onKeyDown(event);

        if (event.defaultPrevented) {
          return;
        }
      } // Block option hover events when the user has just pressed a key


      _this.blockOptionHover = true;

      switch (event.key) {
        case 'ArrowLeft':
          if (!isMulti || inputValue) return;

          _this.focusValue('previous');

          break;

        case 'ArrowRight':
          if (!isMulti || inputValue) return;

          _this.focusValue('next');

          break;

        case 'Delete':
        case 'Backspace':
          if (inputValue) return;

          if (focusedValue) {
            _this.removeValue(focusedValue);
          } else {
            if (!backspaceRemovesValue) return;

            if (isMulti) {
              _this.popValue();
            } else if (isClearable) {
              _this.clearValue();
            }
          }

          break;

        case 'Tab':
          if (_this.isComposing) return;

          if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
          // option is already selected; it breaks the flow of navigation
          openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
            return;
          }

          _this.selectOption(focusedOption);

          break;

        case 'Enter':
          if (event.keyCode === 229) {
            // ignore the keydown event from an Input Method Editor(IME)
            // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
            break;
          }

          if (menuIsOpen) {
            if (!focusedOption) return;
            if (_this.isComposing) return;

            _this.selectOption(focusedOption);

            break;
          }

          return;

        case 'Escape':
          if (menuIsOpen) {
            _this.inputIsHiddenAfterUpdate = false;

            _this.onInputChange('', {
              action: 'menu-close'
            });

            _this.onMenuClose();
          } else if (isClearable && escapeClearsValue) {
            _this.clearValue();
          }

          break;

        case ' ':
          // space
          if (inputValue) {
            return;
          }

          if (!menuIsOpen) {
            _this.openMenu('first');

            break;
          }

          if (!focusedOption) return;

          _this.selectOption(focusedOption);

          break;

        case 'ArrowUp':
          if (menuIsOpen) {
            _this.focusOption('up');
          } else {
            _this.openMenu('last');
          }

          break;

        case 'ArrowDown':
          if (menuIsOpen) {
            _this.focusOption('down');
          } else {
            _this.openMenu('first');
          }

          break;

        case 'PageUp':
          if (!menuIsOpen) return;

          _this.focusOption('pageup');

          break;

        case 'PageDown':
          if (!menuIsOpen) return;

          _this.focusOption('pagedown');

          break;

        case 'Home':
          if (!menuIsOpen) return;

          _this.focusOption('first');

          break;

        case 'End':
          if (!menuIsOpen) return;

          _this.focusOption('last');

          break;

        default:
          return;
      }

      event.preventDefault();
    });

    var value = _props.value;
    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_12_memoize_one__["a" /* default */])(_this.cacheComponents, __WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["y" /* x */]).bind(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));

    _this.cacheComponents(_props.components);

    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var _selectValue = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["f"])(value);

    var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
      render: [],
      focusable: []
    };

    _this.state.menuOptions = _menuOptions;
    _this.state.selectValue = _selectValue;
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          menuIsOpen = _this$props8.menuIsOpen,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
        var selectValue = Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["f"])(nextProps.value);
        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
          render: [],
          focusable: []
        };
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        Object(__WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["h"])(this.menuListRef, this.focusedOptionRef);
      }

      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: "onMenuOpen",
    // ==============================
    // Consumer Handlers
    // ==============================
    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================

  }, {
    key: "focusInput",
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers

  }, {
    key: "openMenu",
    value: function openMenu(focusOption) {
      var _this$state3 = this.state,
          menuOptions = _this$state3.menuOptions,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var isMulti = this.props.isMulti;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });
      this.announceAriaLiveContext({
        event: 'menu'
      });
    }
  }, {
    key: "focusValue",
    value: function focusValue(direction) {
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          isSearchable = _this$props11.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: "focusOption",
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu'
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus])
        }
      });
    }
  }, {
    key: "getTheme",
    // ==============================
    // Getters
    // ==============================
    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({}, defaultTheme, this.props.theme);
    }
  }, {
    key: "getCommonProps",
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;
      var hasValue = this.hasValue();

      var getValue = function getValue() {
        return selectValue;
      };

      var cx = __WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["j"].bind(null, classNamePrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: "getNextFocusedValue",
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    }
  }, {
    key: "getNextFocusedOption",
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
  }, {
    key: "hasValue",
    value: function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: "countOptions",
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: "isClearable",
    value: function isClearable() {
      var _this$props12 = this.props,
          isClearable = _this$props12.isClearable,
          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    }
  }, {
    key: "isOptionDisabled",
    value: function isOptionDisabled(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: "filterOption",
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: "formatGroupLabel",
    value: function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: "startListeningComposition",
    // ==============================
    // Composition Handlers
    // ==============================
    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: "stopListeningComposition",
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: "startListeningToTouch",
    // ==============================
    // Touch Handlers
    // ==============================
    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: "stopListeningToTouch",
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "buildMenuOptions",
    // ==============================
    // Menu Options
    // ==============================
    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
          options = props.options;

      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);

        var isSelected = _this3.isOptionSelected(option, selectValue);

        var label = _this3.getOptionLabel(option);

        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({
          label: label,
          value: value,
          data: option
        }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = "".concat(_this3.getElementId('option'), "-").concat(id);
        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;
          var items = item.options;
          var children = items.map(function (child, i) {
            var option = toOption(child, "".concat(itemIndex, "-").concat(i));
            if (option) acc.focusable.push(child);
            return option;
          }).filter(Boolean);

          if (children.length) {
            var groupId = "".concat(_this3.getElementId('group'), "-").concat(itemIndex);
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, "".concat(itemIndex));

          if (option) {
            acc.render.push(option);
            acc.focusable.push(item);
          }
        }

        return acc;
      }, {
        render: [],
        focusable: []
      });
    } // ==============================
    // Renderers
    // ==============================

  }, {
    key: "constructAriaLiveMessage",
    value: function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props13 = this.props,
          options = _this$props13.options,
          menuIsOpen = _this$props13.menuIsOpen,
          inputValue = _this$props13.inputValue,
          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props14 = this.props,
          isDisabled = _this$props14.isDisabled,
          isSearchable = _this$props14.isSearchable,
          inputId = _this$props14.inputId,
          inputValue = _this$props14.inputValue,
          tabIndex = _this$props14.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: __WEBPACK_IMPORTED_MODULE_15__chunk_39d3fda8_browser_esm_js__["k" /* n */],
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          value: ""
        });
      } // aria attributes makes the JSX "noisy", separated for clarity


      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };
      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Input, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props15 = this.props,
          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
          isDisabled = _this$props15.isDisabled,
          isMulti = _this$props15.isMulti,
          inputValue = _this$props15.inputValue,
          placeholder = _this$props15.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Placeholder, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MultiValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: _this4.getOptionValue(opt),
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(SingleValue, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    }
  }, {
    key: "renderClearIndicator",
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isLoading = _this$props16.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ClearIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          isDisabled = _this$props17.isDisabled,
          isLoading = _this$props17.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(LoadingIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(IndicatorSeparator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(DropdownIndicator, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu = _this$components3.Menu,
          MenuList = _this$components3.MenuList,
          MenuPortal = _this$components3.MenuPortal,
          LoadingMessage = _this$components3.LoadingMessage,
          NoOptionsMessage = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props18 = this.props,
          captureMenuScroll = _this$props18.captureMenuScroll,
          inputValue = _this$props18.inputValue,
          isLoading = _this$props18.isLoading,
          loadingMessage = _this$props18.loadingMessage,
          minMenuHeight = _this$props18.minMenuHeight,
          maxMenuHeight = _this$props18.maxMenuHeight,
          menuIsOpen = _this$props18.menuIsOpen,
          menuPlacement = _this$props18.menuPlacement,
          menuPosition = _this$props18.menuPosition,
          menuPortalTarget = _this$props18.menuPortalTarget,
          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
          noOptionsMessage = _this$props18.noOptionsMessage,
          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Option, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(item, ["type"]);

            var headingId = "".concat(item.key, "-heading");
            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Group, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__chunk_80640036_browser_esm_js__["a" /* M */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps), function (_ref6) {
        var ref = _ref6.ref,
            _ref6$placerProps = _ref6.placerProps,
            placement = _ref6$placerProps.placement,
            maxHeight = _ref6$placerProps.maxHeight;
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Menu, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MenuList, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(MenuPortal, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    }
  }, {
    key: "renderFormField",
    value: function renderFormField() {
      var _this6 = this;

      var _this$props19 = this.props,
          delimiter = _this$props19.delimiter,
          isDisabled = _this$props19.isDisabled,
          isMulti = _this$props19.isMulti,
          name = _this$props19.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
              key: "i-".concat(i),
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
            name: name,
            type: "hidden"
          });
          return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("div", null, input);
        }
      } else {
        var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("input", {
          name: name,
          type: "hidden",
          value: _value
        });
      }
    }
  }, {
    key: "renderLiveRegion",
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(A11yText, {
        "aria-live": "polite"
      }, __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement("p", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props20 = this.props,
          className = _this$props20.className,
          id = _this$props20.id,
          isDisabled = _this$props20.isDisabled,
          menuIsOpen = _this$props20.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(SelectContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(Control, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ValueContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(IndicatorsContainer, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Select, "defaultProps", defaultProps);




/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__ = __webpack_require__(95);

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__["b" /* isHTMLElement */])(element) || !Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__["a" /* default */])(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__["b" /* isHTMLElement */])(element) || !Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__["a" /* default */])(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
});

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLayoutRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(333);
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMainAxisFromPlacement;
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapToStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getOffsetParent_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getDocumentElement_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getBasePlacement_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math_js__ = __webpack_require__(225);







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(x * dpr) / dpr || 0,
    y: Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */];
  var sideY = __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */];
  var win = window;

  if (adaptive) {
    var offsetParent = Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getOffsetParent_js__["a" /* default */])(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__["a" /* default */])(popper)) {
      offsetParent = Object(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getDocumentElement_js__["a" /* default */])(popper);

      if (Object(__WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__["a" /* default */])(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] || (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */] || placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */]) && variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["e" /* end */]) {
      sideY = __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */];
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */] || (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] || placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */]) && variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["e" /* end */]) {
      sideX = __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */];
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) {
    var transitionProperty = getComputedStyle(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: Object(__WEBPACK_IMPORTED_MODULE_5__utils_getBasePlacement_js__["a" /* default */])(state.placement),
    variation: Object(__WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__["a" /* default */])(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getWindow_js__ = __webpack_require__(167);
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getWindow_js__["a" /* default */])(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindowScrollBarX;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScroll_js__ = __webpack_require__(678);



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element)).left + Object(__WEBPACK_IMPORTED_MODULE_2__getWindowScroll_js__["a" /* default */])(element).scrollLeft;
}

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindowScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(167);

function getWindowScroll(node) {
  var win = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getComputedStyle_js__ = __webpack_require__(281);

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = Object(__WEBPACK_IMPORTED_MODULE_0__getComputedStyle_js__["a" /* default */])(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_computeOffsets_js__ = __webpack_require__(1148);


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = Object(__WEBPACK_IMPORTED_MODULE_0__utils_computeOffsets_js__["a" /* default */])({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = popperGenerator;
/* unused harmony export createPopper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getCompositeRect_js__ = __webpack_require__(2590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_orderModifiers_js__ = __webpack_require__(2593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debounce_js__ = __webpack_require__(2594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_validateModifiers_js__ = __webpack_require__(2595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_uniqueBy_js__ = __webpack_require__(2597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getBasePlacement_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_mergeByName_js__ = __webpack_require__(2598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_detectOverflow_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__dom_utils_instanceOf_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums_js__ = __webpack_require__(82);
/* unused harmony reexport detectOverflow */














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: Object(__WEBPACK_IMPORTED_MODULE_12__dom_utils_instanceOf_js__["a" /* isElement */])(reference) ? Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(reference) : reference.contextElement ? Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(reference.contextElement) : [],
          popper: Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = Object(__WEBPACK_IMPORTED_MODULE_5__utils_orderModifiers_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_10__utils_mergeByName_js__["a" /* default */])([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: Object(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getCompositeRect_js__["a" /* default */])(reference, Object(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__["a" /* default */])(popper), state.options.strategy === 'fixed'),
          popper: Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__["a" /* default */])(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce_js__["a" /* default */])(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DragDropContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConnectedDraggable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConnectedDroppable; });
/* unused harmony export resetServerContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_use_memo_one__ = __webpack_require__(2600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux__ = __webpack_require__(2601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(2603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_box_model__ = __webpack_require__(2619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_memoize_one__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now__ = __webpack_require__(2620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_raf_schd__ = __webpack_require__(2623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer__ = __webpack_require__(2624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer__);
















var isProduction = "production" === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
var warning = function warning(message) {
  var _console;

  if (isProduction) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console).warn.apply(_console, getFormattedMessage(message));
};

function printFatalError(error) {
  var _console;

  if (true) {
    return;
  }

  (_console = console).error.apply(_console, getFormattedMessage("\n        An error has occurred while a drag is occurring.\n        Any existing drag will be cancelled.\n\n        > " + error.message + "\n        "));

  console.error('raw', error);
}

function shouldRecover(error) {
  return error.message.indexOf('Invariant failed') !== -1;
}

var ErrorBoundary = function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.onError = void 0;

    _this.setOnError = function (fn) {
      _this.onError = fn;
    };

    _this.onFatalError = function (error) {
      printFatalError(error);

      if (_this.onError) {
        _this.onError();
      } else {
         false ? warning('Could not find recovering function') : void 0;
      }

      if (shouldRecover(error)) {
        _this.setState({});
      }
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('error', this.onFatalError);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('error', this.onFatalError);
  };

  _proto.componentDidCatch = function componentDidCatch(error) {
    this.onFatalError(error);

    if (!shouldRecover(error)) {
      throw error;
    }
  };

  _proto.render = function render() {
    return this.props.children(this.setOnError);
  };

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var isEqual$1 = function isEqual(first, second) {
  return first.top === second.top && first.right === second.right && first.bottom === second.bottom && first.left === second.left;
};
var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});

var records = {};
var isEnabled = false;

var isTimingsEnabled = function isTimingsEnabled() {
  return isEnabled;
};
var start = function start(key) {
  if (false) {
    if (!isTimingsEnabled()) {
      return;
    }

    var now = performance.now();
    records[key] = now;
  }
};
var finish = function finish(key) {
  if (false) {
    if (!isTimingsEnabled()) {
      return;
    }

    var now = performance.now();
    var previous = records[key];

    if (!previous) {
      console.warn('cannot finish timing as no previous time found', key);
      return;
    }

    var result = now - previous;
    var rounded = result.toFixed(2);

    var style = function () {
      if (result < 12) {
        return {
          textColor: 'green',
          symbol: '✅'
        };
      }

      if (result < 40) {
        return {
          textColor: 'orange',
          symbol: '⚠️'
        };
      }

      return {
        textColor: 'red',
        symbol: '❌'
      };
    }();

    console.log(style.symbol + " %cTiming %c" + rounded + " %cms %c" + key, 'color: blue; font-weight: bold;', "color: " + style.textColor + "; font-size: 1.1em;", 'color: grey;', 'color: purple; font-weight: bold;');
  }
};

var whatIsDraggedOver = (function (impact) {
  var merge = impact.merge,
      destination = impact.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (merge) {
    return merge.combine.droppableId;
  }

  return null;
});

function values(map) {
  return __WEBPACK_IMPORTED_MODULE_9__babel_runtime_corejs2_core_js_object_values___default()(map);
}
function findIndex(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}

var toDroppableMap = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (droppables) {
  return values(droppables);
});
var toDraggableList = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (draggables) {
  return values(draggables);
});

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPositionInFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (point) {
    return isWithinVertical(point.y) && isWithinVertical(point.y) && isWithinHorizontal(point.x) && isWithinHorizontal(point.x);
  };
});

var getDroppableOver = (function (_ref) {
  var target = _ref.target,
      droppables = _ref.droppables;
  var maybe = find(toDroppableList(droppables), function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    var active = droppable.subject.active;

    if (!active) {
      return false;
    }

    return isPositionInFrame(active)(target);
  });
  return maybe ? maybe.descriptor.id : null;
});

var getDraggablesInsideDroppable = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

var withDroppableScroll = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.value);
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isUserMovingForward = (function (axis, direction) {
  return axis === vertical ? direction.vertical === 'down' : direction.horizontal === 'right';
});

var didStartDisplaced = (function (draggableId, onLift) {
  return Boolean(onLift.wasDisplaced[draggableId]);
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      onLift = _ref.onLift,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced[combineWith]);

  if (didStartDisplaced(combineWith, onLift)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var getWhenEntered = function getWhenEntered(id, current, oldMerge) {
  if (!oldMerge) {
    return current;
  }

  if (id !== oldMerge.combine.draggableId) {
    return current;
  }

  return oldMerge.whenEntered;
};

var isCombiningWith = function isCombiningWith(_ref) {
  var id = _ref.id,
      currentCenter = _ref.currentCenter,
      axis = _ref.axis,
      borderBox = _ref.borderBox,
      displaceBy = _ref.displaceBy,
      currentUserDirection = _ref.currentUserDirection,
      oldMerge = _ref.oldMerge;
  var start = borderBox[axis.start] + displaceBy[axis.line];
  var end = borderBox[axis.end] + displaceBy[axis.line];
  var size = borderBox[axis.size];
  var twoThirdsOfSize = size * 0.666;
  var whenEntered = getWhenEntered(id, currentUserDirection, oldMerge);
  var isMovingForward = isUserMovingForward(axis, whenEntered);
  var targetCenter = currentCenter[axis.line];

  if (isMovingForward) {
    return isWithin(start, start + twoThirdsOfSize)(targetCenter);
  }

  return isWithin(end - twoThirdsOfSize, end)(targetCenter);
};

var getCombineImpact = (function (_ref2) {
  var currentCenter = _ref2.pageBorderBoxCenterWithDroppableScrollChange,
      previousImpact = _ref2.previousImpact,
      destination = _ref2.destination,
      insideDestinationWithoutDraggable = _ref2.insideDestinationWithoutDraggable,
      userDirection = _ref2.userDirection,
      onLift = _ref2.onLift;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var map = previousImpact.movement.map;
  var canBeDisplacedBy = previousImpact.movement.displacedBy;
  var oldMerge = previousImpact.merge;
  var target = find(insideDestinationWithoutDraggable, function (child) {
    var id = child.descriptor.id;
    var displaceBy = getCombinedItemDisplacement({
      displaced: map,
      onLift: onLift,
      combineWith: id,
      displacedBy: canBeDisplacedBy
    });
    return isCombiningWith({
      id: id,
      currentCenter: currentCenter,
      axis: axis,
      borderBox: child.page.borderBox,
      displaceBy: displaceBy,
      currentUserDirection: userDirection,
      oldMerge: oldMerge
    });
  });

  if (!target) {
    return null;
  }

  var merge = {
    whenEntered: getWhenEntered(target.descriptor.id, userDirection, oldMerge),
    combine: {
      draggableId: target.descriptor.id,
      droppableId: destination.descriptor.id
    }
  };

  var withMerge = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, previousImpact, {
    destination: null,
    merge: merge
  });

  return withMerge;
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(forceShouldAnimate, isVisible, previous) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!isVisible) {
    return false;
  }

  if (!previous) {
    return true;
  }

  return previous.shouldAnimate;
};

var getTarget = function getTarget(draggable, onLift) {
  var marginBox = draggable.page.marginBox;

  if (!didStartDisplaced(draggable.descriptor.id, onLift)) {
    return marginBox;
  }

  var expandBy = {
    top: onLift.displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: onLift.displacedBy.point.x
  };
  return Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])(Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["c" /* expand */])(marginBox, expandBy));
};

var getDisplacement = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      onLift = _ref.onLift,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var id = draggable.descriptor.id;
  var map = previousImpact.movement.map;
  var target = getTarget(draggable, onLift);
  var isVisible = isPartiallyVisible({
    target: target,
    destination: destination,
    viewport: viewport,
    withDroppableDisplacement: true
  });
  var shouldAnimate = getShouldAnimate(forceShouldAnimate, isVisible, map[id]);
  var displacement = {
    draggableId: id,
    isVisible: isVisible,
    shouldAnimate: shouldAnimate
  };
  return displacement;
});

var getDisplacementMap = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (displaced) {
  return displaced.reduce(function (map, displacement) {
    map[displacement.draggableId] = displacement;
    return map;
  }, {});
});

var getDisplacedBy = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getReorderImpact = (function (_ref) {
  var currentCenter = _ref.pageBorderBoxCenterWithDroppableScrollChange,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestinationWithoutDraggable = _ref.insideDestinationWithoutDraggable,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      userDirection = _ref.userDirection,
      onLift = _ref.onLift;
  var axis = destination.axis;
  var isMovingForward = isUserMovingForward(destination.axis, userDirection);
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var targetCenter = currentCenter[axis.line];
  var displacement = displacedBy.value;
  var displaced = insideDestinationWithoutDraggable.filter(function (child) {
    var borderBox = child.page.borderBox;
    var start = borderBox[axis.start];
    var end = borderBox[axis.end];
    var didStartDisplaced$1 = didStartDisplaced(child.descriptor.id, onLift);

    if (isMovingForward) {
      if (didStartDisplaced$1) {
        return targetCenter < start;
      }

      return targetCenter < start + displacement;
    }

    if (didStartDisplaced$1) {
      return targetCenter <= end - displacement;
    }

    return targetCenter <= end;
  }).map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: destination,
      previousImpact: previousImpact,
      viewport: viewport.frame,
      onLift: onLift
    });
  });
  var newIndex = insideDestinationWithoutDraggable.length - displaced.length;
  var movement = {
    displacedBy: displacedBy,
    displaced: displaced,
    map: getDisplacementMap(displaced)
  };
  var impact = {
    movement: movement,
    destination: {
      droppableId: destination.descriptor.id,
      index: newIndex
    },
    merge: null
  };
  return impact;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var noMovement = {
  displaced: [],
  map: {},
  displacedBy: noDisplacedBy
};
var noImpact = {
  movement: noMovement,
  destination: null,
  merge: null
};

var removeDraggableFromList = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var getDragImpact = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      userDirection = _ref.userDirection,
      onLift = _ref.onLift;
  var destinationId = getDroppableOver({
    target: pageBorderBoxCenter,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var insideDestinationWithoutDraggable = removeDraggableFromList(draggable, insideDestination);
  var pageBorderBoxCenterWithDroppableScrollChange = withDroppableScroll(destination, pageBorderBoxCenter);
  var withMerge = getCombineImpact({
    pageBorderBoxCenterWithDroppableScrollChange: pageBorderBoxCenterWithDroppableScrollChange,
    previousImpact: previousImpact,
    destination: destination,
    insideDestinationWithoutDraggable: insideDestinationWithoutDraggable,
    userDirection: userDirection,
    onLift: onLift
  });

  if (withMerge) {
    return withMerge;
  }

  return getReorderImpact({
    pageBorderBoxCenterWithDroppableScrollChange: pageBorderBoxCenterWithDroppableScrollChange,
    destination: destination,
    draggable: draggable,
    insideDestinationWithoutDraggable: insideDestinationWithoutDraggable,
    previousImpact: previousImpact,
    viewport: viewport,
    userDirection: userDirection,
    onLift: onLift
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getHomeOnLift = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var originallyDisplaced = insideHome.slice(draggable.descriptor.index + 1);
  var wasDisplaced = originallyDisplaced.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var onLift = {
    displacedBy: displacedBy,
    wasDisplaced: wasDisplaced
  };
  var displaced = originallyDisplaced.map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: home,
      previousImpact: noImpact,
      viewport: viewport.frame,
      forceShouldAnimate: false,
      onLift: onLift
    });
  });
  var movement = {
    displaced: displaced,
    map: getDisplacementMap(displaced),
    displacedBy: displacedBy
  };
  var impact = {
    movement: movement,
    destination: getHomeLocation(draggable.descriptor),
    merge: null
  };
  return {
    impact: impact,
    onLift: onLift
  };
});

var getDragPositions = (function (_ref) {
  var oldInitial = _ref.initial,
      oldCurrent = _ref.current,
      oldClientBorderBoxCenter = _ref.oldClientBorderBoxCenter,
      newClientBorderBoxCenter = _ref.newClientBorderBoxCenter,
      viewport = _ref.viewport;
  var shift = subtract(newClientBorderBoxCenter, oldClientBorderBoxCenter);

  var initial = function () {
    var client = {
      selection: add(oldInitial.client.selection, shift),
      borderBoxCenter: newClientBorderBoxCenter,
      offset: origin
    };
    var page = {
      selection: add(client.selection, viewport.scroll.initial),
      borderBoxCenter: add(client.selection, viewport.scroll.initial)
    };
    return {
      client: client,
      page: page
    };
  }();

  var current = function () {
    var reverse = negate(shift);
    var offset = add(oldCurrent.client.offset, reverse);
    var client = {
      selection: add(initial.client.selection, offset),
      borderBoxCenter: add(initial.client.borderBoxCenter, offset),
      offset: offset
    };
    var page = {
      selection: add(client.selection, viewport.scroll.current),
      borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current)
    };
    !isEqual(oldCurrent.client.borderBoxCenter, client.borderBoxCenter) ?  false ? invariant(false, "\n        Incorrect new client center position.\n        Expected (" + oldCurrent.client.borderBoxCenter.x + ", " + oldCurrent.client.borderBoxCenter.y + ")\n        to equal (" + client.borderBoxCenter.x + ", " + client.borderBoxCenter.y + ")\n      ") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return {
      client: client,
      page: page
    };
  }();

  return {
    current: current,
    initial: initial
  };
});

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["f" /* offset */])(draggable.client, offset$1);
  var page = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(client, initialWindowScroll);

  var moved = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, draggable, {
    placeholder: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var adjustExistingForAdditionsAndRemovals = (function (_ref) {
  var existing = _ref.existing,
      droppables = _ref.droppables,
      addedDraggables = _ref.additions,
      removedDraggables = _ref.removals,
      viewport = _ref.viewport;
  var shifted = {};
  toDroppableList(droppables).forEach(function (droppable) {
    var axis = droppable.axis;
    var original = getDraggablesInsideDroppable(droppable.descriptor.id, existing);
    var toShift = {};

    var addShift = function addShift(id, shift) {
      var previous = toShift[id];

      if (!previous) {
        toShift[id] = shift;
        return;
      }

      toShift[id] = {
        indexChange: previous.indexChange + shift.indexChange,
        offset: add(previous.offset, shift.offset)
      };
    };

    var removals = toDraggableMap(removedDraggables.map(function (id) {
      var item = existing[id];
      !item ?  false ? invariant(false, "Could not find removed draggable \"" + id + "\"") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      return item;
    }).filter(function (draggable) {
      return draggable.descriptor.droppableId === droppable.descriptor.id;
    }));
    var withRemovals = original.filter(function (item, index) {
      var isBeingRemoved = Boolean(removals[item.descriptor.id]);

      if (!isBeingRemoved) {
        return true;
      }

      var offset = negate(patch(axis.line, item.displaceBy[axis.line]));
      original.slice(index).forEach(function (sibling) {
        if (removals[sibling.descriptor.id]) {
          return;
        }

        addShift(sibling.descriptor.id, {
          indexChange: -1,
          offset: offset
        });
      });
      return false;
    });
    var additions = addedDraggables.filter(function (draggable) {
      return draggable.descriptor.droppableId === droppable.descriptor.id;
    });
    var withAdditions = withRemovals.slice(0);
    additions.forEach(function (item) {
      withAdditions.splice(item.descriptor.index, 0, item);
    });
    var additionMap = toDraggableMap(additions);
    withAdditions.forEach(function (item, index) {
      var wasAdded = Boolean(additionMap[item.descriptor.id]);

      if (!wasAdded) {
        return;
      }

      var offset = patch(axis.line, item.client.marginBox[axis.size]);
      withAdditions.slice(index).forEach(function (sibling) {
        if (additionMap[sibling.descriptor.id]) {
          return;
        }

        addShift(sibling.descriptor.id, {
          indexChange: 1,
          offset: offset
        });
      });
    });
    withAdditions.forEach(function (item) {
      if (additionMap[item.descriptor.id]) {
        return;
      }

      var shift = toShift[item.descriptor.id];

      if (!shift) {
        return;
      }

      var moved = offsetDraggable({
        draggable: item,
        offset: shift.offset,
        initialWindowScroll: viewport.scroll.initial
      });
      var index = item.descriptor.index + shift.indexChange;

      var updated = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, moved, {
        descriptor: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, item.descriptor, {
          index: index
        })
      });

      shifted[moved.descriptor.id] = updated;
    });
  });

  var map = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, existing, shifted);

  return map;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = modified.frame;
    !frame ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var adjustAdditionsForCollapsedHome = (function (_ref) {
  var additions = _ref.additions,
      dragging = _ref.dragging,
      home = _ref.home,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, dragging.displaceBy);
  return additions.map(function (draggable) {
    if (draggable.descriptor.droppableId !== home.descriptor.id) {
      return draggable;
    }

    if (draggable.descriptor.index < dragging.descriptor.index) {
      return draggable;
    }

    return offsetDraggable({
      draggable: draggable,
      offset: displacedBy.point,
      initialWindowScroll: viewport.scroll.initial
    });
  });
});

var updateDraggables = (function (_ref) {
  var updatedDroppables = _ref.updatedDroppables,
      criticalId = _ref.criticalId,
      unmodifiedExisting = _ref.existing,
      unmodifiedAdditions = _ref.additions,
      removals = _ref.removals,
      viewport = _ref.viewport;
  var existing = adjustExistingForAdditionsAndRemovals({
    droppables: updatedDroppables,
    existing: unmodifiedExisting,
    additions: unmodifiedAdditions,
    removals: removals,
    viewport: viewport
  });
  var dragging = existing[criticalId];
  var home = updatedDroppables[dragging.descriptor.droppableId];
  var scrolledAdditions = adjustAdditionsForScrollChanges({
    additions: unmodifiedAdditions,
    updatedDroppables: updatedDroppables,
    viewport: viewport
  });
  var additions = adjustAdditionsForCollapsedHome({
    additions: scrolledAdditions,
    dragging: dragging,
    home: home,
    viewport: viewport
  });

  var map = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, existing, toDraggableMap(additions));

  removals.forEach(function (id) {
    delete map[id];
  });
  return map;
});

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;
  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, frame, {
    scroll: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ?  false ? invariant(false, 'Should not add placeholder space to home list') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !!droppable.subject.withPlaceholder ?  false ? invariant(false, 'Cannot add placeholder size to a subject when it already has one') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ?  false ? invariant(false, 'Cannot remove placeholder form subject when there was none') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ?  false ? invariant(false, 'Expected droppable with frame to have old max frame scroll when removing placeholder') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ?  false ? invariant(false, 'Expected Droppable to have a frame') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return frame;
});

var throwIfSpacingChange = function throwIfSpacingChange(old, fresh) {
  if (false) {
    var getMessage = function getMessage(spacingType) {
      return "Cannot change the " + spacingType + " of a Droppable during a drag";
    };

    !isEqual$1(old.margin, fresh.margin) ? process.env.NODE_ENV !== "production" ? invariant(false, getMessage('margin')) : invariant(false) : void 0;
    !isEqual$1(old.border, fresh.border) ? process.env.NODE_ENV !== "production" ? invariant(false, getMessage('border')) : invariant(false) : void 0;
    !isEqual$1(old.padding, fresh.padding) ? process.env.NODE_ENV !== "production" ? invariant(false, getMessage('padding')) : invariant(false) : void 0;
  }
};

var adjustBorderBoxSize = function adjustBorderBoxSize(axis, old, fresh) {
  return {
    top: old.top,
    left: old.left,
    right: old.left + fresh.width,
    bottom: old.top + fresh.height
  };
};

var updateDroppables = (function (_ref) {
  var modified = _ref.modified,
      existing = _ref.existing,
      viewport = _ref.viewport;

  if (!modified.length) {
    return existing;
  }

  var adjusted = modified.map(function (provided) {
    var raw = existing[provided.descriptor.id];
    !raw ?  false ? invariant(false, 'Could not locate droppable in existing droppables') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var hasPlaceholder = Boolean(raw.subject.withPlaceholder);
    var dimension = hasPlaceholder ? removePlaceholder(raw) : raw;
    var oldClient = dimension.client;
    var newClient = provided.client;
    var oldScrollable = getFrame(dimension);
    var newScrollable = getFrame(provided);

    if (false) {
      throwIfSpacingChange(dimension.client, provided.client);
      throwIfSpacingChange(oldScrollable.frameClient, newScrollable.frameClient);
      var isFrameEqual = oldScrollable.frameClient.borderBox.height === newScrollable.frameClient.borderBox.height && oldScrollable.frameClient.borderBox.width === newScrollable.frameClient.borderBox.width;
      !isFrameEqual ? process.env.NODE_ENV !== "production" ? invariant(false, 'The width and height of your Droppable scroll container cannot change when adding or removing Draggables during a drag') : invariant(false) : void 0;
    }

    var client = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["b" /* createBox */])({
      borderBox: adjustBorderBoxSize(dimension.axis, oldClient.borderBox, newClient.borderBox),
      margin: oldClient.margin,
      border: oldClient.border,
      padding: oldClient.padding
    });
    var closest = {
      client: oldScrollable.frameClient,
      page: Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(oldScrollable.frameClient, viewport.scroll.initial),
      shouldClipSubject: oldScrollable.shouldClipSubject,
      scrollSize: newScrollable.scrollSize,
      scroll: oldScrollable.scroll.initial
    };
    var withSizeChanged = getDroppableDimension({
      descriptor: provided.descriptor,
      isEnabled: provided.isEnabled,
      isCombineEnabled: provided.isCombineEnabled,
      isFixedOnPage: provided.isFixedOnPage,
      direction: provided.axis.direction,
      client: client,
      page: Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(client, viewport.scroll.initial),
      closest: closest
    });
    var scrolled = scrollDroppable(withSizeChanged, newScrollable.scroll.current);
    return scrolled;
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, existing, toDroppableMap(adjusted));

  return result;
});

var withNoAnimatedDisplacement = (function (impact) {
  var displaced = impact.movement.displaced;

  if (!displaced.length) {
    return impact;
  }

  var withoutAnimation = displaced.map(function (displacement) {
    if (!displacement.isVisible) {
      return displacement;
    }

    if (!displacement.shouldAnimate) {
      return displacement;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, displacement, {
      shouldAnimate: false
    });
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact, {
    movement: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact.movement, {
      displaced: withoutAnimation,
      map: getDisplacementMap(withoutAnimation)
    })
  });

  return result;
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});

var timingsKey = 'Processing dynamic changes';
var publishWhileDragging = (function (_ref) {
  var _extends2, _extends3;

  var state = _ref.state,
      published = _ref.published;
  start(timingsKey);
  var updatedDroppables = updateDroppables({
    modified: published.modified,
    existing: state.dimensions.droppables,
    viewport: state.viewport
  });
  var draggables = updateDraggables({
    updatedDroppables: updatedDroppables,
    criticalId: state.critical.draggable.id,
    existing: state.dimensions.draggables,
    additions: published.additions,
    removals: published.removals,
    viewport: state.viewport
  });
  var critical = {
    draggable: draggables[state.critical.draggable.id].descriptor,
    droppable: updatedDroppables[state.critical.droppable.id].descriptor
  };
  var original = state.dimensions.draggables[critical.draggable.id];
  var updated = draggables[critical.draggable.id];
  var droppables = recomputePlaceholders({
    draggable: updated,
    draggables: draggables,
    droppables: updatedDroppables,
    previousImpact: state.impact,
    impact: state.impact
  });
  var dimensions = {
    draggables: draggables,
    droppables: droppables
  };

  var _getDragPositions = getDragPositions({
    initial: state.initial,
    current: state.current,
    oldClientBorderBoxCenter: original.client.borderBox.center,
    newClientBorderBoxCenter: updated.client.borderBox.center,
    viewport: state.viewport
  }),
      initial = _getDragPositions.initial,
      current = _getDragPositions.current;

  var _getHomeOnLift = getHomeOnLift({
    draggable: updated,
    home: dimensions.droppables[critical.droppable.id],
    draggables: dimensions.draggables,
    viewport: state.viewport
  }),
      homeImpact = _getHomeOnLift.impact,
      onLift = _getHomeOnLift.onLift;

  var impact = withNoAnimatedDisplacement(getDragImpact({
    pageBorderBoxCenter: current.page.borderBoxCenter,
    draggable: updated,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: homeImpact,
    viewport: state.viewport,
    userDirection: state.userDirection,
    onLift: onLift
  }));
  var isOrphaned = Boolean(state.movementMode === 'SNAP' && !whatIsDraggedOver(impact));
  !!isOrphaned ?  false ? invariant(false, 'Dragging item no longer has a valid merge/destination after a dynamic update. This is not supported') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  finish(timingsKey);

  var draggingState = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
    phase: 'DRAGGING'
  }, state, (_extends2 = {}, _extends2["phase"] = 'DRAGGING', _extends2.critical = critical, _extends2.current = current, _extends2.initial = initial, _extends2.impact = impact, _extends2.dimensions = dimensions, _extends2.onLift = onLift, _extends2.onLiftImpact = homeImpact, _extends2.forceShouldAnimate = false, _extends2));

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
    phase: 'DROP_PENDING'
  }, draggingState, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.reason = state.reason, _extends3.isWaiting = false, _extends3));

  return dropPending;
});

var forward = {
  vertical: 'down',
  horizontal: 'right'
};
var backward = {
  vertical: 'up',
  horizontal: 'left'
};

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      destination = _ref.destination,
      originalInsideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  if (previousImpact.merge) {
    return null;
  }

  var location = previousImpact.destination;
  !location ?  false ? invariant(false, 'Need a previous location to move from into a combine') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var currentIndex = location.index;

  var currentInsideDestination = function () {
    var shallow = originalInsideDestination.slice();

    if (isInHomeList) {
      shallow.splice(draggable.descriptor.index, 1);
    }

    shallow.splice(location.index, 0, draggable);
    return shallow;
  }();

  var targetIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;

  if (targetIndex < 0) {
    return null;
  }

  if (targetIndex > currentInsideDestination.length - 1) {
    return null;
  }

  var target = currentInsideDestination[targetIndex];
  !(target !== draggable) ?  false ? invariant(false, 'Cannot combine with self') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var merge = {
    whenEntered: isMovingForward ? forward : backward,
    combine: {
      draggableId: target.descriptor.id,
      droppableId: destination.descriptor.id
    }
  };
  var impact = {
    movement: previousImpact.movement,
    destination: null,
    merge: merge
  };
  return impact;
});

var addClosest = function addClosest(add, displaced) {
  var added = {
    draggableId: add.descriptor.id,
    isVisible: true,
    shouldAnimate: true
  };
  return [added].concat(displaced);
};
var removeClosest = function removeClosest(displaced) {
  return displaced.slice(1);
};

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      initialInside = _ref.insideDestination,
      location = _ref.location;
  var insideDestination = initialInside.slice();
  var currentIndex = location.index;
  var isInForeignList = !isInHomeList;

  if (isInForeignList) {
    insideDestination.splice(location.index, 0, draggable);
  }

  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;

  if (proposedIndex < 0) {
    return null;
  }

  if (proposedIndex > insideDestination.length - 1) {
    return null;
  }

  return {
    proposedIndex: proposedIndex,
    modifyDisplacement: true
  };
});

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      draggables = _ref.draggables,
      merge = _ref.merge,
      onLift = _ref.onLift;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var movement = previousImpact.movement;
  var combineId = merge.combine.draggableId;
  var combine = draggables[combineId];
  var combineIndex = combine.descriptor.index;
  var wasDisplacedAtStart = didStartDisplaced(combineId, onLift);

  if (wasDisplacedAtStart) {
    var hasDisplacedFromStart = !movement.map[combineId];

    if (hasDisplacedFromStart) {
      if (isMovingForward) {
        return {
          proposedIndex: combineIndex,
          modifyDisplacement: false
        };
      }

      return {
        proposedIndex: combineIndex - 1,
        modifyDisplacement: true
      };
    }

    if (isMovingForward) {
      return {
        proposedIndex: combineIndex,
        modifyDisplacement: true
      };
    }

    return {
      proposedIndex: combineIndex - 1,
      modifyDisplacement: false
    };
  }

  var isDisplaced = Boolean(movement.map[combineId]);

  if (isDisplaced) {
    if (isMovingForward) {
      return {
        proposedIndex: combineIndex + 1,
        modifyDisplacement: true
      };
    }

    return {
      proposedIndex: combineIndex,
      modifyDisplacement: false
    };
  }

  if (isMovingForward) {
    return {
      proposedIndex: combineIndex + 1,
      modifyDisplacement: false
    };
  }

  return {
    proposedIndex: combineIndex,
    modifyDisplacement: true
  };
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      onLift = _ref.onLift;

  var instruction = function () {
    if (previousImpact.destination) {
      return fromReorder({
        isMovingForward: isMovingForward,
        isInHomeList: isInHomeList,
        draggable: draggable,
        location: previousImpact.destination,
        insideDestination: insideDestination
      });
    }

    if (previousImpact.merge) {
      return fromCombine({
        isMovingForward: isMovingForward,
        destination: destination,
        previousImpact: previousImpact,
        draggables: draggables,
        merge: previousImpact.merge,
        onLift: onLift
      });
    }
    return null;
  }();

  if (instruction == null) {
    return null;
  }

  var proposedIndex = instruction.proposedIndex,
      modifyDisplacement = instruction.modifyDisplacement;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);

  var displaced = function () {
    var lastDisplaced = previousImpact.movement.displaced;

    if (!modifyDisplacement) {
      return lastDisplaced;
    }

    if (isMovingForward) {
      return removeClosest(lastDisplaced);
    }

    var withoutDraggable = removeDraggableFromList(draggable, insideDestination);
    var atProposedIndex = withoutDraggable[proposedIndex];
    return addClosest(atProposedIndex, lastDisplaced);
  }();

  return {
    movement: {
      displacedBy: displacedBy,
      displaced: displaced,
      map: getDisplacementMap(displaced)
    },
    destination: {
      droppableId: destination.descriptor.id,
      index: proposedIndex
    },
    merge: null
  };
});

var whenCombining = (function (_ref) {
  var combine = _ref.combine,
      onLift = _ref.onLift,
      movement = _ref.movement,
      draggables = _ref.draggables;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: movement.map,
    onLift: onLift,
    combineWith: combineWith,
    displacedBy: movement.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var movement = _ref.movement,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      onLift = _ref.onLift;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = movement.displaced,
      displacedBy = movement.displacedBy;

  if (displaced.length) {
    var closestAfter = draggables[displaced[0].draggableId];

    if (didStartDisplaced(closestAfter.descriptor.id, onLift)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closestAfter.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["f" /* offset */])(closestAfter.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartDisplaced(last.descriptor.id, onLift)) {
    var page = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["f" /* offset */])(last.page, negate(onLift.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      onLift = _ref.onLift;
  var merge = impact.merge;
  var destination = impact.destination;
  var original = draggable.page.borderBox.center;

  if (!droppable) {
    return original;
  }

  if (destination) {
    return whenReordering({
      movement: impact.movement,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      onLift: onLift
    });
  }

  if (merge) {
    return whenCombining({
      movement: impact.movement,
      combine: merge.combine,
      draggables: draggables,
      onLift: onLift
    });
  }

  return original;
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

var withNewDisplacement = (function (impact, displaced) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact, {
    movement: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, impact.movement, {
      displaced: displaced,
      map: getDisplacementMap(displaced)
    })
  });
});

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange,
      onLift = _ref.onLift;
  var displaced = impact.movement.displaced;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var updated = displaced.map(function (entry) {
    if (entry.isVisible) {
      return entry;
    }

    var draggable = draggables[entry.draggableId];
    var withScrolledViewport = getDisplacement({
      draggable: draggable,
      destination: destination,
      previousImpact: impact,
      viewport: scrolledViewport.frame,
      onLift: onLift,
      forceShouldAnimate: false
    });

    if (withScrolledViewport.isVisible) {
      return withScrolledViewport;
    }

    var withScrolledDroppable = getDisplacement({
      draggable: draggable,
      destination: scrolledDroppable,
      previousImpact: impact,
      viewport: viewport.frame,
      onLift: onLift,
      forceShouldAnimate: false
    });

    if (withScrolledDroppable.isVisible) {
      return withScrolledDroppable;
    }

    return entry;
  });
  return withNewDisplacement(impact, updated);
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      onLift = _ref.onLift;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isInHomeList: isInHomeList,
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    onLift: onLift
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    onLift: onLift
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance,
    onLift: onLift
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ?  false ? invariant(false, 'Cannot get clipped area from droppable') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, onLift) {
  var original = draggable.page.borderBox.center;
  return didStartDisplaced(draggable.descriptor.id, onLift) ? subtract(original, onLift.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, onLift) {
  var original = draggable.page.borderBox;
  return didStartDisplaced(draggable.descriptor.id, onLift) ? offsetByPosition(original, negate(onLift.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      onLift = _ref.onLift;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, onLift),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, onLift)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, onLift)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      onLift = _ref.onLift;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      movement: noMovement,
      destination: {
        droppableId: destination.descriptor.id,
        index: 0
      },
      merge: null
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      onLift: onLift
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] < moveRelativeTo.page.borderBox.center[destination.axis.line]);
  var targetIndex = insideDestination.indexOf(moveRelativeTo);
  !(targetIndex !== -1) ?  false ? invariant(false, 'Cannot find target in list') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

  var proposedIndex = function () {
    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return targetIndex;
    }

    if (isGoingBeforeTarget) {
      return targetIndex;
    }

    return targetIndex + 1;
  }();

  var displaced = removeDraggableFromList(draggable, insideDestination).slice(proposedIndex).map(function (dimension) {
    return getDisplacement({
      draggable: dimension,
      destination: destination,
      viewport: viewport.frame,
      previousImpact: previousImpact,
      onLift: onLift
    });
  });
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var impact = {
    movement: {
      displacedBy: displacedBy,
      displaced: displaced,
      map: getDisplacementMap(displaced)
    },
    destination: {
      droppableId: destination.descriptor.id,
      index: proposedIndex
    },
    merge: null
  };
  return impact;
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      onLift = _ref.onLift;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    onLift: onLift
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    onLift: onLift
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    onLift: onLift
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var getDroppableOver$1 = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver$1(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    onLift: state.onLift
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    previousImpact: state.impact,
    viewport: state.viewport,
    onLift: state.onLift
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

var getVertical = function getVertical(previous, diff) {
  if (diff === 0) {
    return previous;
  }

  return diff > 0 ? 'down' : 'up';
};

var getHorizontal = function getHorizontal(previous, diff) {
  if (diff === 0) {
    return previous;
  }

  return diff > 0 ? 'right' : 'left';
};

var getUserDirection = (function (previous, oldPageBorderBoxCenter, newPageBorderBoxCenter) {
  var diff = subtract(newPageBorderBoxCenter, oldPageBorderBoxCenter);
  return {
    horizontal: getHorizontal(previous.horizontal, diff.x),
    vertical: getVertical(previous.vertical, diff.y)
  };
});

var update = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var currentWindowScroll = viewport.scroll.current;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, currentWindowScroll),
    borderBoxCenter: add(client.borderBoxCenter, currentWindowScroll)
  };
  var current = {
    client: client,
    page: page
  };
  var userDirection = getUserDirection(state.userDirection, state.current.page.borderBoxCenter, current.page.borderBoxCenter);

  if (state.phase === 'COLLECTING') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current,
      userDirection: userDirection
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageBorderBoxCenter: page.borderBoxCenter,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    userDirection: userDirection,
    onLift: state.onLift
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state, {
    current: current,
    userDirection: userDirection,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      onLift = _ref.onLift,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var updated = impact.movement.displaced.map(function (entry) {
    return getDisplacement({
      draggable: draggables[entry.draggableId],
      destination: destination,
      previousImpact: impact,
      viewport: viewport.frame,
      onLift: onLift,
      forceShouldAnimate: forceShouldAnimate
    });
  });
  return withNewDisplacement(impact, updated);
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      onLift = _ref.onLift;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    onLift: onLift
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ?  false ? invariant(false, 'Must be over a destination in SNAP movement mode') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    onLift: state.onLift
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    onLift: state.onLift
  });
  return update({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'CLEAN') {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, idle, {
      shouldFlush: action.payload.shouldFlush
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ?  false ? invariant(false, 'INITIAL_PUBLISH must come after a IDLE phase') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getHomeOnLift = getHomeOnLift({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getHomeOnLift.impact,
        onLift = _getHomeOnLift.onLift;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      onLift: onLift,
      onLiftImpact: impact,
      viewport: viewport,
      userDirection: forward,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    var _extends2;

    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? invariant(false, "Collection cannot start from phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var _result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'COLLECTING'
    }, state, (_extends2 = {}, _extends2["phase"] = 'COLLECTING', _extends2));

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Unexpected " + action.type + " received in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return publishWhileDragging({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    if (state.phase === 'COLLECTING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, action.type + " not permitted in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        offset = _action$payload2.offset;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, offset);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ?  false ? invariant(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    !(_target.isEnabled !== isEnabled) ?  false ? invariant(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var updated = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Attempting to move in an unsupported phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ?  false ? invariant(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ?  false ? invariant(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var _updated = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ?  false ? invariant(false, "Cannot move by window in phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    !state.isWindowScrollAllowed ?  false ? invariant(false, 'Window scrolling is currently not supported for fixed lists. Aborting drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var newScroll = action.payload.newScroll;

    if (isEqual(state.viewport.scroll.current, newScroll)) {
      return state;
    }

    var _viewport = scrollViewport(state.viewport, newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.viewport, {
      scroll: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ?  false ? invariant(false, action.type + " received while not in DRAGGING phase") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var _extends3;

    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ?  false ? invariant(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var newState = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      phase: 'DROP_PENDING'
    }, state, (_extends3 = {}, _extends3["phase"] = 'DROP_PENDING', _extends3.isWaiting = true, _extends3.reason = reason, _extends3));

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot animate drop from phase " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      dimensions: state.dimensions,
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _action$payload6 = action.payload,
        _completed = _action$payload6.completed,
        shouldFlush = _action$payload6.shouldFlush;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: shouldFlush
    };
  }

  return state;
});

var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging$1 = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var clean$1 = function clean(args) {
  if (args === void 0) {
    args = {
      shouldFlush: false
    };
  }

  return {
    type: 'CLEAN',
    payload: args
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed,
            shouldFlush: true
          }));
        }

        !(getState().phase === 'IDLE') ?  false ? invariant(false, 'Incorrect phase to start a drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'CLEAN' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      onLift = _ref.onLift;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    onLift: onLift,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  var merge = impact.merge;

  if (merge && didStartDisplaced(merge.combine.draggableId, onLift)) {
    return subtract(offset, onLift.displacedBy.point);
  }

  return offset;
});

var getDropImpact = (function (_ref) {
  var reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      onLiftImpact = _ref.onLiftImpact,
      onLift = _ref.onLift;
  var didDropInsideDroppable = reason === 'DROP' && Boolean(whatIsDraggedOver(lastImpact));

  if (!didDropInsideDroppable) {
    var impact = recompute({
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      draggables: draggables,
      onLift: onLift,
      forceShouldAnimate: true
    });
    return {
      impact: impact,
      didDropInsideDroppable: didDropInsideDroppable
    };
  }

  if (lastImpact.destination) {
    return {
      impact: lastImpact,
      didDropInsideDroppable: didDropInsideDroppable
    };
  }

  var withoutMovement = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, lastImpact, {
    movement: noMovement
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: didDropInsideDroppable
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ?  false ? invariant(false, 'A DROP action occurred while DROP_PENDING and still waiting') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ?  false ? invariant(false, "Cannot drop in phase: " + state.phase) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        onLift: state.onLift,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var draggable = dimensions.draggables[state.critical.draggable.id];
      var destination = didDropInsideDroppable ? impact.destination : null;
      var combine = didDropInsideDroppable && impact.merge ? impact.merge.combine : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        onLift: state.onLift
      });
      var completed = {
        critical: state.critical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed,
          shouldFlush: false
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + ".\n  Use the arrow keys to move, space bar to drop, and escape to cancel.\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
       false ? warning('Announcement already made. Not making a second announcement') : void 0;
      return;
    }

    if (isExpired) {
       false ? warning("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ?  false ? invariant(false, 'Could not find timer') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start(key);
  fn();
  finish(key);
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ?  false ? invariant(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = impact.destination;
    var combine = impact.merge ? impact.merge.combine : null;
    !dragging ?  false ? invariant(false, 'Cannot fire onDragMove when onDragStart has not been called') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ?  false ? invariant(false, 'Can only flush responders while dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ?  false ? invariant(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'CLEAN') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ?  false ? invariant(false, 'Cannot finish a drop animating when no drop is occurring') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed,
        shouldFlush: false
      }));
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'CLEAN' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'CLEAN';
};

var shouldCancelPending = function shouldCancelPending(action) {
  return action.type === 'COLLECTION_STARTING';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldEnd(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (shouldCancelPending(action)) {
          autoScroller.cancelPending();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ?  false ? invariant(false, 'Expected phase to be DRAGGING after INITIAL_PUBLISH') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : __WEBPACK_IMPORTED_MODULE_5_redux__["c" /* compose */];
var createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["d" /* createStore */])(reducer, composeEnhancers(Object(__WEBPACK_IMPORTED_MODULE_5_redux__["a" /* applyMiddleware */])(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, pendingDrop, autoScroll(autoScroller), responders(getResponders, announce))));
});

var clean$2 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};

var timingKey = 'Publish collection from DOM';
var createPublisher = (function (_ref) {
  var getEntries = _ref.getEntries,
      callbacks = _ref.callbacks;

  var advancedUsageWarning = function () {
    if (true) {
      return function () {};
    }

    var hasAnnounced = false;
    return function () {
      if (hasAnnounced) {
        return;
      }

      hasAnnounced = true;
       false ? warning("\n        Advanced usage warning: you are adding or removing a dimension during a drag\n        This an advanced feature.\n\n        More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/changes-while-dragging.md\n      ") : void 0;
    };
  }();

  var staging = clean$2();
  var frameId = null;

  var collect = function collect() {
    advancedUsageWarning();

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      callbacks.collectionStarting();
      var critical = callbacks.getCritical();
      start(timingKey);
      var entries = getEntries();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;

      var added = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys___default()(additions).map(function (id) {
        return entries.draggables[id].getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });

      var updated = __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys___default()(modified).map(function (id) {
        var entry = entries.droppables[id];
        !entry ?  false ? invariant(false, 'Cannot find dynamically added droppable in cache') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
        var isHome = entry.descriptor.id === critical.droppable.id;
        var options = {
          withoutPlaceholder: !isHome
        };
        return entry.callbacks.recollect(options);
      });

      var result = {
        additions: added,
        removals: __WEBPACK_IMPORTED_MODULE_10__babel_runtime_corejs2_core_js_object_keys___default()(removals),
        modified: updated
      };
      staging = clean$2();
      finish(timingKey);
      callbacks.publish(result);
    });
  };

  var add = function add(descriptor) {
    staging.additions[descriptor.id] = descriptor;
    staging.modified[descriptor.droppableId] = true;

    if (staging.removals[descriptor.id]) {
      delete staging.removals[descriptor.id];
    }

    collect();
  };

  var remove = function remove(descriptor) {
    staging.removals[descriptor.id] = descriptor;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$2();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
});

var getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ?  false ? invariant(false, 'Cannot find document.documentElement') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      entries = _ref.entries;
  var timingKey = 'Initial collection from DOM';
  start(timingKey);
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = values(entries.droppables).filter(function (entry) {
    return entry.descriptor.type === home.type;
  }).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = values(entries.draggables).filter(function (entry) {
    return entry.descriptor.type === critical.draggable.type;
  }).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish(timingKey);
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

var throwIfAddOrRemoveOfWrongType = function throwIfAddOrRemoveOfWrongType(collection, descriptor) {
  !(collection.critical.draggable.type === descriptor.type) ?  false ? invariant(false, "We have detected that you have added a Draggable during a drag.\n      This is not of the same type as the dragging item\n\n      Dragging type: " + collection.critical.draggable.type + ".\n      Added type: " + descriptor.type + "\n\n      We are not allowing this as you can run into problems if your change\n      has shifted the positioning of other Droppables, or has changed the size of the page") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
};

var createDimensionMarshal = (function (callbacks) {
  var entries = {
    droppables: {},
    draggables: {}
  };
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting,
      getCritical: function getCritical() {
        !collection ?  false ? invariant(false, 'Cannot get critical when there is no collection') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
        return collection.critical;
      }
    },
    getEntries: function getEntries() {
      return entries;
    }
  });

  var registerDraggable = function registerDraggable(descriptor, getDimension) {
    var entry = {
      descriptor: descriptor,
      getDimension: getDimension
    };
    entries.draggables[descriptor.id] = entry;

    if (!collection) {
      return;
    }

    throwIfAddOrRemoveOfWrongType(collection, descriptor);
    publisher.add(descriptor);
  };

  var updateDraggable = function updateDraggable(published, descriptor, getDimension) {
    var existing = entries.draggables[published.id];
    !existing ?  false ? invariant(false, 'Cannot update draggable registration as no published registration was found') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (existing.descriptor === published) {
      delete entries.draggables[published.id];
    } else {
       false ? warning("\n        Detected incorrect usage of 'key' on '<Draggable draggableId=\"" + published.id + "\"$ />\n\n        Your 'key' should be:\n        - Unique for each Draggable in a list\n        - Not be based on the index of the Draggable\n\n        Usually you want your 'key' to just be the 'draggableId'\n\n        More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/draggable.md#keys-for-a-list-of-draggable-\n      ") : void 0;
    }

    var entry = {
      descriptor: descriptor,
      getDimension: getDimension
    };
    entries.draggables[descriptor.id] = entry;
  };

  var unregisterDraggable = function unregisterDraggable(descriptor) {
    var entry = entries.draggables[descriptor.id];
    !entry ?  false ? invariant(false, "Cannot unregister Draggable with id:\n      " + descriptor.id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (entry.descriptor !== descriptor) {
      return;
    }

    delete entries.draggables[descriptor.id];

    if (!collection) {
      return;
    }

    !(collection.critical.draggable.id !== descriptor.id) ?  false ? invariant(false, 'Cannot remove the dragging item during a drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    throwIfAddOrRemoveOfWrongType(collection, descriptor);
    publisher.remove(descriptor);
  };

  var registerDroppable = function registerDroppable(descriptor, droppableCallbacks) {
    var id = descriptor.id;
    entries.droppables[id] = {
      descriptor: descriptor,
      callbacks: droppableCallbacks
    };
    !!collection ?  false ? invariant(false, 'Cannot add a Droppable during a drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  };

  var unregisterDroppable = function unregisterDroppable(descriptor) {
    var entry = entries.droppables[descriptor.id];
    !entry ?  false ? invariant(false, "Cannot unregister Droppable with id " + descriptor.id + " as as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (entry.descriptor !== descriptor) {
      return;
    }

    delete entries.droppables[descriptor.id];
    !!collection ?  false ? invariant(false, 'Cannot add a Droppable during a drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  };

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !entries.droppables[id] ?  false ? invariant(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    !entries.droppables[id] ?  false ? invariant(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    !entries.droppables[id] ?  false ? invariant(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableScroll({
      id: id,
      offset: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    var entry = entries.droppables[id];
    !entry ?  false ? invariant(false, "Cannot scroll Droppable " + id + " as it is not registered") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!collection) {
      return;
    }

    entry.callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    values(entries.droppables).filter(function (entry) {
      return entry.descriptor.type === home.type;
    }).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection = null;
  };

  var startPublishing = function startPublishing(request) {
    !!collection ?  false ? invariant(false, 'Cannot start capturing critical dimensions as there is already a collection') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var entry = entries.draggables[request.draggableId];
    !entry ?  false ? invariant(false, 'Cannot find critical draggable entry') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var home = entries.droppables[entry.descriptor.droppableId];
    !home ?  false ? invariant(false, 'Cannot find critical droppable entry') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    collection = {
      critical: critical
    };
    return getInitialPublish({
      critical: critical,
      entries: entries,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    registerDraggable: registerDraggable,
    updateDraggable: updateDraggable,
    unregisterDraggable: unregisterDraggable,
    registerDroppable: registerDroppable,
    unregisterDroppable: unregisterDroppable,
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ?  false ? invariant(false, 'Invalid result') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
     false ? warning("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config.maxPixelScroll * config.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config.durationDampening.accelerateAt;
var stopAt = config.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;

  var now = __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now___default()();

  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$3 = apply(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$3({
    x: x,
    y: y
  });

  if (isEqual(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual(limited, origin) ? null : limited;
});

var smallestSigned = apply(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(scrollWindow);
  var scheduleDroppableScroll = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ?  false ? invariant(false, 'Cannot fluid scroll if not dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var cancelPending = function cancelPending() {
    !dragging ?  false ? invariant(false, 'Cannot cancel pending fluid scroll when not started') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
  };

  var start$1 = function start$1(state) {
    start('starting fluid scroller');
    !!dragging ?  false ? invariant(false, 'Cannot start auto scrolling when already started') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    var dragStartTime = __WEBPACK_IMPORTED_MODULE_11__babel_runtime_corejs2_core_js_date_now___default()();

    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish('starting fluid scroller');

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    cancelPending();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    cancelPending: cancelPending,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ?  false ? invariant(false, 'Cannot perform a jump scroll when there is no destination') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    cancelPending: fluidScroller.cancelPending,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix = 'data-react-beautiful-dnd';
var dragHandle = prefix + "-drag-handle";
var draggable = prefix + "-draggable";
var droppable = prefix + "-droppable";

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (uniqueContext) {
  var getSelector = makeGetSelector(uniqueContext);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_1_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"];

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ?  false ? invariant(false, 'Cannot find the head to append a style to') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl() {
  var el = document.createElement('style');
  el.type = 'text/css';
  return el;
};

function useStyleMarshal(uniqueId) {
  var uniqueContext = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return "" + uniqueId;
  }, [uniqueId]);
  var styles = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return getStyles$1(uniqueContext);
  }, [uniqueContext]);
  var alwaysRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var dynamicRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var setDynamicStyle = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (proposed) {
    var el = dynamicRef.current;
    !el ?  false ? invariant(false, 'Cannot set dynamic style element if it is not set') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (proposed) {
    var el = alwaysRef.current;
    !el ?  false ? invariant(false, 'Cannot set dynamic style element if it is not set') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ?  false ? invariant(false, 'style elements already mounted') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var always = createStyleEl();
    var dynamic = createStyleEl();
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix + "-always", uniqueContext);
    dynamic.setAttribute(prefix + "-dynamic", uniqueContext);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ?  false ? invariant(false, 'Cannot unmount ref as it is not set') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, uniqueContext]);
  var dragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting,
      styleContext: uniqueContext
    };
  }, [dragging, dropping, resting, uniqueContext]);
  return marshal;
}

var StoreContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ?  false ? invariant(false, 'Cannot find document.body') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};
var getId = function getId(uniqueId) {
  return "react-beautiful-dnd-announcement-" + uniqueId;
};
function useAnnouncer(uniqueId) {
  var id = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return getId(uniqueId);
  }, [uniqueId]);
  var ref = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    !!ref.current ?  false ? invariant(false, 'Announcement node already mounted') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('role', 'log');
    el.setAttribute('aria-atomic', 'true');

    __WEBPACK_IMPORTED_MODULE_13__babel_runtime_corejs2_core_js_object_assign___default()(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function () {
      var toBeRemoved = ref.current;
      !toBeRemoved ?  false ? invariant(false, 'Cannot unmount announcement node') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      getBodyElement().removeChild(toBeRemoved);
      ref.current = null;
    };
  }, [id]);
  var announce = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

     false ? warning("\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      \"" + message + "\"\n    ") : void 0;
  }, []);
  return announce;
}

var AppContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(null);

var peerDependencies = {
	react: "^16.8.5"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ?  false ? invariant(false, "Unable to parse React version " + value) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

   false ? warning("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
});

var suffix = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
     false ? warning("\n      No <!doctype html> found.\n\n      " + suffix + "\n    ") : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
     false ? warning("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix + "\n    ") : void 0;
  }

  if (doctype.publicId !== '') {
     false ? warning("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix + "\n    ") : void 0;
  }
});

function useStartupValidation() {
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (true) {
      return;
    }

    checkReactVersion(peerDependencies.react, __WEBPACK_IMPORTED_MODULE_1_react___default.a.version);
    checkDoctype(document);
  }, []);
}

function usePrevious(current) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(current);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    ref.current = current;
  });
  return ref;
}

var createResponders = function createResponders(props) {
  return {
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ?  false ? invariant(false, 'Could not find store from lazy ref') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var uniqueId = props.uniqueId,
      setOnError = props.setOnError;
  var lazyStoreRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  useStartupValidation();
  var lastPropsRef = usePrevious(props);
  var getResponders = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(uniqueId);
  var styleMarshal = useStyleMarshal(uniqueId);
  var lazyDispatch = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var callbacks = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      publishWhileDragging: publishWhileDragging$1,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var dimensionMarshal = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createDimensionMarshal(callbacks);
  }, [callbacks]);
  var autoScroller = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createAutoScroller(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, Object(__WEBPACK_IMPORTED_MODULE_5_redux__["b" /* bindActionCreators */])({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var store = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createStore({
      dimensionMarshal: dimensionMarshal,
      styleMarshal: styleMarshal,
      announce: announce,
      autoScroller: autoScroller,
      getResponders: getResponders
    });
  }, [announce, autoScroller, dimensionMarshal, getResponders, styleMarshal]);

  if (false) {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning('unexpected store change') : void 0;
    }
  }

  lazyStoreRef.current = store;
  var tryResetStore = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(clean$1({
        shouldFlush: true
      }));
    }
  }, []);
  setOnError(tryResetStore);
  var getCanLift = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      marshal: dimensionMarshal,
      style: styleMarshal.styleContext,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed
    };
  }, [dimensionMarshal, getCanLift, getIsMovementAllowed, styleMarshal.styleContext]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AppContext.Provider, {
    value: appContext
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_redux__["a" /* Provider */], {
    context: StoreContext,
    store: store
  }, props.children));
}

var instanceCount = 0;
function resetServerContext() {
  instanceCount = 0;
}
function DragDropContext(props) {
  var uniqueId = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return instanceCount++;
  }, []);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ErrorBoundary, null, function (setOnError) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(App, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      setOnError: setOnError,
      uniqueId: uniqueId
    }, props), props.children);
  });
}

var isEqual$2 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$2('scroll');
var isAuto = isEqual$2('auto');
var isVisible$1 = isEqual$2('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (true) {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

   false ? warning("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

   false ? warning("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["d" /* getBox */])(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["c" /* expand */])(paddingBox, base.border);
  var client = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["b" /* createBox */])({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["d" /* getBox */])(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

function withoutPlaceholder(placeholder, fn) {
  if (!placeholder) {
    return fn();
  }

  var last = placeholder.style.display;
  placeholder.style.display = 'none';
  var result = fn();
  placeholder.style.display = last;
  return result;
}

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(Context);
  !result ?  false ? invariant(false, 'Could not find required context') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppableDimensionPublisher(args) {
  var whileDraggingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var appContext = useRequiredContext(AppContext);
  var marshal = appContext.marshal;
  var previousRef = usePrevious(args);
  var descriptor = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      id: args.droppableId,
      type: args.type
    };
  }, [args.droppableId, args.type]);
  var publishedDescriptorRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(descriptor);
  var memoizedUpdateScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (x, y) {
      !whileDraggingRef.current ?  false ? invariant(false, 'Can only update scroll when dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? invariant(false, 'Could not find scroll options while scrolling') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (windowScroll, options) {
    !!whileDraggingRef.current ?  false ? invariant(false, 'Cannot collect a droppable while a drag is occurring') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ?  false ? invariant(false, 'Cannot collect without a droppable ref') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });

    if (env.closestScrollable) {
      env.closestScrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (false) {
        checkForNestedScrollContainers(env.closestScrollable);
      }
    }

    return dimension;
  }, [descriptor, onClosestScroll, previousRef]);
  var recollect = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (options) {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ?  false ? invariant(false, 'Can only recollect Droppable client for Droppables that have a scroll container') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var previous = previousRef.current;

    var execute = function execute() {
      return getDimension({
        ref: dragging.ref,
        descriptor: dragging.descriptor,
        env: dragging.env,
        windowScroll: origin,
        direction: previous.direction,
        isDropDisabled: previous.isDropDisabled,
        isCombineEnabled: previous.isCombineEnabled,
        shouldClipSubject: !previous.ignoreContainerClipping
      });
    };

    if (!options.withoutPlaceholder) {
      return execute();
    }

    return withoutPlaceholder(previous.getPlaceholderRef(), execute);
  }, [previousRef]);
  var dragStopped = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? invariant(false, 'Cannot stop drag when no active drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ?  false ? invariant(false, 'Cannot scroll when there is no drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ?  false ? invariant(false, 'Cannot scroll a droppable with no closest scrollable') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      recollect: recollect,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, recollect, scroll]);
  useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = descriptor;
    marshal.registerDroppable(descriptor, callbacks);
    return function () {
      if (whileDraggingRef.current) {
         false ? warning('Unsupported: changing the droppableId or type of a Droppable during a drag') : void 0;
        dragStopped();
      }

      marshal.unregisterDroppable(descriptor);
    };
  }, [callbacks, descriptor, dragStopped, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop() {}

var empty = {
  width: 0,
  height: 0,
  margin: noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: transitions.placeholder
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var tryClearAnimateOpenTimer = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      styleContext = props.styleContext;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (!isAnimatingOpenOnMount) {
      return noop;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop;
    }

    if (animateOpenTimerRef.current) {
      return noop;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(props.placeholder.tagName, {
    style: style,
    'data-react-beautiful-dnd-placeholder': styleContext,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = __WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(Placeholder);

var DroppableContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext(null);

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ?  false ? invariant(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
}

function checkOwnProps(props) {
  !props.droppableId ?  false ? invariant(false, 'A Droppable requires a droppableId prop') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !(typeof props.isDropDisabled === 'boolean') ?  false ? invariant(false, 'isDropDisabled must be a boolean') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !(typeof props.isCombineEnabled === 'boolean') ?  false ? invariant(false, 'isCombineEnabled must be a boolean') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !(typeof props.ignoreContainerClipping === 'boolean') ?  false ? invariant(false, 'ignoreContainerClipping must be a boolean') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
}

function checkPlaceholderRef(props, placeholderEl) {
  if (!props.placeholder) {
    return;
  }

  if (placeholderEl) {
    return;
  }

   false ? warning("\n    Droppable setup issue [droppableId: \"" + props.droppableId + "\"]:\n    DroppableProvided > placeholder could not be found.\n\n    Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n  ") : void 0;
}

function useValidation(_ref) {
  var props = _ref.props,
      getDroppableRef = _ref.getDroppableRef,
      getPlaceholderRef = _ref.getPlaceholderRef;
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (false) {
      checkOwnProps(props);
      checkIsValidInnerRef(getDroppableRef());
      checkPlaceholderRef(props, getPlaceholderRef());
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

function Droppable(props) {
  var appContext = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(AppContext);
  !appContext ?  false ? invariant(false, 'Could not find app context') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var styleContext = appContext.style,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var placeholderRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      updateViewportMaxScroll = props.updateViewportMaxScroll;
  var getDroppableRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return droppableRef.current;
  }, []);
  var getPlaceholderRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return placeholderRef.current;
  }, []);
  var setDroppableRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (value) {
    droppableRef.current = value;
  }, []);
  var setPlaceholderRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (value) {
    placeholderRef.current = value;
  }, []);
  var onPlaceholderTransitionEnd = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppableDimensionPublisher({
    droppableId: droppableId,
    type: type,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var placeholder = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      styleContext: styleContext,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-react-beautiful-dnd-droppable': styleContext
      }
    };
  }, [placeholder, setDroppableRef, styleContext]);
  var droppableContext = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      droppableId: droppableId,
      type: type
    };
  }, [droppableId, type]);
  useValidation({
    props: props,
    getDroppableRef: function getDroppableRef() {
      return droppableRef.current;
    },
    getPlaceholderRef: function getPlaceholderRef() {
      return placeholderRef.current;
    }
  });
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot));
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps = function makeMapStateToProps() {
  var idle = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null
    }
  };

  var idleWithoutAnimation = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, idle, {
    shouldAnimatePlaceholder: false
  });

  var getMapProps = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (id, isDraggingOver, dragging, snapshot) {
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: snapshot
      };
    }

    if (!isDraggingOver) {
      return idle;
    }

    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot
    };
  });
  var getSnapshot = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (id, isDraggingOver, dragging) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;
    var draggingOverWith = isDraggingOver ? draggableId : null;
    var draggingFromThisWith = isHome ? draggableId : null;
    return {
      isDraggingOver: isDraggingOver,
      draggingOverWith: draggingOverWith,
      draggingFromThisWith: draggingFromThisWith
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idle;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      var snapshot = getSnapshot(id, isDraggingOver, dragging);
      return getMapProps(id, isDraggingOver, dragging, snapshot);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idle;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      var _snapshot = getSnapshot(id, whatIsDraggedOverFromResult(completed.result) === id, _dragging);

      return getMapProps(id, whatIsDraggedOver(completed.impact) === id, _dragging, _snapshot);
    }

    if (state.phase === 'IDLE' && !state.completed && state.shouldFlush) {
      return idleWithoutAnimation;
    }

    if (state.phase === 'IDLE' && state.completed) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idle;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.merge);

      if (state.shouldFlush) {
        return idleWithoutAnimation;
      }

      if (wasOver) {
        return wasCombining ? idle : idleWithoutAnimation;
      }

      return idle;
    }

    return idle;
  };

  return selector;
};
var mapDispatchToProps = {
  updateViewportMaxScroll: updateViewportMaxScroll
};
var defaultProps = {
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false
};
var ConnectedDroppable = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps;

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

var createEventMarshal = (function () {
  var isMouseDownHandled = false;

  var handle = function handle() {
    !!isMouseDownHandled ?  false ? invariant(false, 'Cannot handle mouse down as it is already handled') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    isMouseDownHandled = true;
  };

  var isHandled = function isHandled() {
    return isMouseDownHandled;
  };

  var reset = function reset() {
    isMouseDownHandled = false;
  };

  return {
    handle: handle,
    isHandled: isHandled,
    reset: reset
  };
});

var getOptions = function getOptions(shared, fromBinding) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, shared, fromBinding);
};

var bindEvents = function bindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
  });
};
var unbindEvents = function unbindEvents(el, bindings, sharedOptions) {
  bindings.forEach(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.removeEventListener(binding.eventName, binding.fn, options);
  });
};

var createScheduler = (function (callbacks) {
  var memoizedMove = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (x, y) {
    var point = {
      x: x,
      y: y
    };
    callbacks.onMove(point);
  });
  var move = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(function (point) {
    return memoizedMove(point.x, point.y);
  });
  var moveUp = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onMoveUp);
  var moveDown = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onMoveDown);
  var moveRight = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onMoveRight);
  var moveLeft = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onMoveLeft);
  var windowScrollMove = Object(__WEBPACK_IMPORTED_MODULE_12_raf_schd__["a" /* default */])(callbacks.onWindowScroll);

  var cancel = function cancel() {
    move.cancel();
    moveUp.cancel();
    moveDown.cancel();
    moveRight.cancel();
    moveLeft.cancel();
    windowScrollMove.cancel();
  };

  return {
    move: move,
    moveUp: moveUp,
    moveDown: moveDown,
    moveRight: moveRight,
    moveLeft: moveLeft,
    windowScrollMove: windowScrollMove,
    cancel: cancel
  };
});

var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight = 39;
var arrowDown = 40;

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var sharedOptions = {
  capture: true
};
var createPostDragEventPreventer = (function (getWindow) {
  var isBound = false;

  var bind = function bind() {
    if (isBound) {
      return;
    }

    isBound = true;
    bindEvents(getWindow(), pointerEvents, sharedOptions);
  };

  var unbind = function unbind() {
    if (!isBound) {
      return;
    }

    isBound = false;
    unbindEvents(getWindow(), pointerEvents, sharedOptions);
  };

  var pointerEvents = [{
    eventName: 'click',
    fn: function fn(event) {
      event.preventDefault();
      unbind();
    }
  }, {
    eventName: 'mousedown',
    fn: unbind
  }, {
    eventName: 'touchstart',
    fn: unbind
  }];

  var preventNext = function preventNext() {
    if (isBound) {
      unbind();
    }

    bind();
  };

  var preventer = {
    preventNext: preventNext,
    abort: unbind
  };
  return preventer;
});

var sloppyClickThreshold = 5;
var isSloppyClickThresholdExceeded = (function (original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
});

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var primaryButton = 0;

var noop$1 = function noop() {};

var mouseDownMarshal = createEventMarshal();
function useMouseSensor(args) {
  var canStartCapturing = args.canStartCapturing,
      getWindow = args.getWindow,
      callbacks = args.callbacks,
      onCaptureStart = args.onCaptureStart,
      onCaptureEnd = args.onCaptureEnd;
  var pendingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var isDraggingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var unbindWindowEventsRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(noop$1);
  var getIsCapturing = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return Boolean(pendingRef.current || isDraggingRef.current);
  }, []);
  var schedule = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsCapturing() ?  false ? invariant(false, 'Should not recreate scheduler while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsCapturing]);
  var postDragEventPreventer = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createPostDragEventPreventer(getWindow);
  }, [getWindow]);
  var stop = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!getIsCapturing()) {
      return;
    }

    schedule.cancel();
    unbindWindowEventsRef.current();
    var shouldBlockClick = isDraggingRef.current;
    mouseDownMarshal.reset();

    if (shouldBlockClick) {
      postDragEventPreventer.preventNext();
    }

    pendingRef.current = null;
    isDraggingRef.current = false;
    onCaptureEnd();
  }, [getIsCapturing, onCaptureEnd, postDragEventPreventer, schedule]);
  var cancel = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var wasDragging = isDraggingRef.current;
    stop();

    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var startDragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    !!isDraggingRef.current ?  false ? invariant(false, 'Cannot start a drag while dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var pending = pendingRef.current;
    !pending ?  false ? invariant(false, 'Cannot start a drag without a pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    pendingRef.current = null;
    isDraggingRef.current = true;
    callbacks.onLift({
      clientSelection: pending,
      movementMode: 'FLUID'
    });
  }, [callbacks]);
  var windowBindings = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsCapturing() ?  false ? invariant(false, 'Should not recreate window bindings while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var bindings = [{
      eventName: 'mousemove',
      fn: function fn(event) {
        var button = event.button,
            clientX = event.clientX,
            clientY = event.clientY;

        if (button !== primaryButton) {
          return;
        }

        var point = {
          x: clientX,
          y: clientY
        };

        if (isDraggingRef.current) {
          event.preventDefault();
          schedule.move(point);
          return;
        }

        var pending = pendingRef.current;

        if (!pending) {
          stop();
           false ? invariant(false, 'Expected there to be an active or pending drag when window mousemove event is received') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false);
        }

        if (!isSloppyClickThresholdExceeded(pending, point)) {
          return;
        }

        event.preventDefault();
        startDragging();
      }
    }, {
      eventName: 'mouseup',
      fn: function fn(event) {
        var wasDragging = isDraggingRef.current;
        stop();

        if (wasDragging) {
          event.preventDefault();
          callbacks.onDrop();
        }
      }
    }, {
      eventName: 'mousedown',
      fn: function fn(event) {
        if (isDraggingRef.current) {
          event.preventDefault();
        }

        cancel();
      }
    }, {
      eventName: 'keydown',
      fn: function fn(event) {
        if (pendingRef.current) {
          stop();
          return;
        }

        if (event.keyCode === escape) {
          event.preventDefault();
          cancel();
          return;
        }

        preventStandardKeyEvents(event);
      }
    }, {
      eventName: 'resize',
      fn: cancel
    }, {
      eventName: 'scroll',
      options: {
        passive: true,
        capture: false
      },
      fn: function fn(event) {
        if (event.currentTarget !== getWindow()) {
          return;
        }

        if (pendingRef.current) {
          stop();
          return;
        }

        schedule.windowScrollMove();
      }
    }, {
      eventName: 'webkitmouseforcedown',
      fn: function fn() {
        cancel();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
    return bindings;
  }, [getIsCapturing, cancel, startDragging, schedule, stop, callbacks, getWindow]);
  var bindWindowEvents = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var win = getWindow();
    var options = {
      capture: true
    };

    unbindWindowEventsRef.current = function () {
      return unbindEvents(win, windowBindings, options);
    };

    bindEvents(win, windowBindings, options);
  }, [getWindow, windowBindings]);
  var startPendingDrag = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (point) {
    !!pendingRef.current ?  false ? invariant(false, 'Expected there to be no pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    pendingRef.current = point;
    onCaptureStart(stop);
    bindWindowEvents();
  }, [bindWindowEvents, onCaptureStart, stop]);
  var onMouseDown = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (mouseDownMarshal.isHandled()) {
      return;
    }

    !!getIsCapturing() ?  false ? invariant(false, 'Should not be able to perform a mouse down while a drag or pending drag is occurring') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!canStartCapturing(event)) {
      return;
    }

    if (event.button !== primaryButton) {
      return;
    }

    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }

    mouseDownMarshal.handle();
    event.preventDefault();
    var point = {
      x: event.clientX,
      y: event.clientY
    };
    startPendingDrag(point);
  }, [canStartCapturing, getIsCapturing, startPendingDrag]);
  return onMouseDown;
}

function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

var isAnInteractiveElement = function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
};

var shouldAllowDraggingFromTarget = (function (event, canDragInteractiveElements) {
  if (canDragInteractiveElements) {
    return true;
  }

  var target = event.target,
      currentTarget = event.currentTarget;

  if (!isElement(target) || !isElement(currentTarget)) {
    return true;
  }

  return !isAnInteractiveElement(currentTarget, target);
});

var getBorderBoxCenterPosition = (function (el) {
  return Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["e" /* getRect */])(el.getBoundingClientRect()).center;
});

var _scrollJumpKeys;
var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function noop$2() {}

function useKeyboardSensor(args) {
  var canStartCapturing = args.canStartCapturing,
      getWindow = args.getWindow,
      callbacks = args.callbacks,
      onCaptureStart = args.onCaptureStart,
      onCaptureEnd = args.onCaptureEnd,
      getDraggableRef = args.getDraggableRef;
  var isDraggingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var unbindWindowEventsRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(noop$2);
  var getIsDragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return isDraggingRef.current;
  }, []);
  var schedule = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsDragging() ?  false ? invariant(false, 'Should not recreate scheduler while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsDragging]);
  var stop = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!getIsDragging()) {
      return;
    }

    schedule.cancel();
    unbindWindowEventsRef.current();
    isDraggingRef.current = false;
    onCaptureEnd();
  }, [getIsDragging, onCaptureEnd, schedule]);
  var cancel = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var wasDragging = isDraggingRef.current;
    stop();

    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var windowBindings = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsDragging() ?  false ? invariant(false, 'Should not recreate window bindings when dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return [{
      eventName: 'mousedown',
      fn: cancel
    }, {
      eventName: 'mouseup',
      fn: cancel
    }, {
      eventName: 'click',
      fn: cancel
    }, {
      eventName: 'touchstart',
      fn: cancel
    }, {
      eventName: 'resize',
      fn: cancel
    }, {
      eventName: 'wheel',
      fn: cancel,
      options: {
        passive: true
      }
    }, {
      eventName: 'scroll',
      options: {
        capture: false
      },
      fn: function fn(event) {
        if (event.currentTarget !== getWindow()) {
          return;
        }

        callbacks.onWindowScroll();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
  }, [callbacks, cancel, getIsDragging, getWindow]);
  var bindWindowEvents = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var win = getWindow();
    var options = {
      capture: true
    };

    unbindWindowEventsRef.current = function () {
      return unbindEvents(win, windowBindings, options);
    };

    bindEvents(win, windowBindings, options);
  }, [getWindow, windowBindings]);
  var startDragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    !!isDraggingRef.current ?  false ? invariant(false, 'Cannot start a drag while dragging') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var ref = getDraggableRef();
    !ref ?  false ? invariant(false, 'Cannot start a keyboard drag without a draggable ref') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    isDraggingRef.current = true;
    onCaptureStart(stop);
    bindWindowEvents();
    var center = getBorderBoxCenterPosition(ref);
    callbacks.onLift({
      clientSelection: center,
      movementMode: 'SNAP'
    });
  }, [bindWindowEvents, callbacks, getDraggableRef, onCaptureStart, stop]);
  var onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (!getIsDragging()) {
      if (event.defaultPrevented) {
        return;
      }

      if (!canStartCapturing(event)) {
        return;
      }

      if (event.keyCode !== space) {
        return;
      }

      event.preventDefault();
      startDragging();
      return;
    }

    if (event.keyCode === escape) {
      event.preventDefault();
      cancel();
      return;
    }

    if (event.keyCode === space) {
      event.preventDefault();
      stop();
      callbacks.onDrop();
      return;
    }

    if (event.keyCode === arrowDown) {
      event.preventDefault();
      schedule.moveDown();
      return;
    }

    if (event.keyCode === arrowUp) {
      event.preventDefault();
      schedule.moveUp();
      return;
    }

    if (event.keyCode === arrowRight) {
      event.preventDefault();
      schedule.moveRight();
      return;
    }

    if (event.keyCode === arrowLeft) {
      event.preventDefault();
      schedule.moveLeft();
      return;
    }

    if (scrollJumpKeys[event.keyCode]) {
      event.preventDefault();
      return;
    }

    preventStandardKeyEvents(event);
  }, [callbacks, canStartCapturing, cancel, getIsDragging, schedule, startDragging, stop]);
  return onKeyDown;
}

var timeForLongPress = 120;
var forcePressThreshold = 0.15;
var touchStartMarshal = createEventMarshal();

var noop$3 = function noop() {};

function useTouchSensor(args) {
  var callbacks = args.callbacks,
      getWindow = args.getWindow,
      canStartCapturing = args.canStartCapturing,
      getShouldRespectForcePress = args.getShouldRespectForcePress,
      onCaptureStart = args.onCaptureStart,
      onCaptureEnd = args.onCaptureEnd;
  var pendingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var isDraggingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var hasMovedRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var unbindWindowEventsRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(noop$3);
  var getIsCapturing = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return Boolean(pendingRef.current || isDraggingRef.current);
  }, []);
  var postDragClickPreventer = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return createPostDragEventPreventer(getWindow);
  }, [getWindow]);
  var schedule = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsCapturing() ?  false ? invariant(false, 'Should not recreate scheduler while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return createScheduler(callbacks);
  }, [callbacks, getIsCapturing]);
  var stop = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    if (!getIsCapturing()) {
      return;
    }

    schedule.cancel();
    unbindWindowEventsRef.current();
    touchStartMarshal.reset();
    hasMovedRef.current = false;
    onCaptureEnd();

    if (isDraggingRef.current) {
      postDragClickPreventer.preventNext();
      isDraggingRef.current = false;
      return;
    }

    var pending = pendingRef.current;
    !pending ?  false ? invariant(false, 'Expected a pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    clearTimeout(pending.longPressTimerId);
    pendingRef.current = null;
  }, [getIsCapturing, onCaptureEnd, postDragClickPreventer, schedule]);
  var cancel = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var wasDragging = isDraggingRef.current;
    stop();

    if (wasDragging) {
      callbacks.onCancel();
    }
  }, [callbacks, stop]);
  var windowBindings = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    !!getIsCapturing() ?  false ? invariant(false, 'Should not recreate window bindings while capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var bindings = [{
      eventName: 'touchmove',
      options: {
        passive: false,
        capture: false
      },
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }

        if (!hasMovedRef.current) {
          hasMovedRef.current = true;
        }

        var touch = event.touches[0];

        if (!touch) {
          return;
        }

        var point = {
          x: touch.clientX,
          y: touch.clientY
        };
        event.preventDefault();
        schedule.move(point);
      }
    }, {
      eventName: 'touchend',
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }

        event.preventDefault();
        stop();
        callbacks.onDrop();
      }
    }, {
      eventName: 'touchcancel',
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          stop();
          return;
        }

        event.preventDefault();
        cancel();
      }
    }, {
      eventName: 'touchstart',
      fn: cancel
    }, {
      eventName: 'orientationchange',
      fn: cancel
    }, {
      eventName: 'resize',
      fn: cancel
    }, {
      eventName: 'scroll',
      options: {
        passive: true,
        capture: false
      },
      fn: function fn() {
        if (pendingRef.current) {
          stop();
          return;
        }

        schedule.windowScrollMove();
      }
    }, {
      eventName: 'contextmenu',
      fn: function fn(event) {
        event.preventDefault();
      }
    }, {
      eventName: 'keydown',
      fn: function fn(event) {
        if (!isDraggingRef.current) {
          cancel();
          return;
        }

        if (event.keyCode === escape) {
          event.preventDefault();
        }

        cancel();
      }
    }, {
      eventName: 'touchforcechange',
      fn: function fn(event) {
        var touch = event.touches[0];
        var isForcePress = touch.force >= forcePressThreshold;

        if (!isForcePress) {
          return;
        }

        var shouldRespect = getShouldRespectForcePress();

        if (pendingRef.current) {
          if (shouldRespect) {
            cancel();
          }

          return;
        }

        if (shouldRespect) {
          if (hasMovedRef.current) {
            event.preventDefault();
            return;
          }

          cancel();
          return;
        }

        event.preventDefault();
      }
    }, {
      eventName: supportedEventName,
      fn: cancel
    }];
    return bindings;
  }, [callbacks, cancel, getIsCapturing, getShouldRespectForcePress, schedule, stop]);
  var bindWindowEvents = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var win = getWindow();
    var options = {
      capture: true
    };

    unbindWindowEventsRef.current = function () {
      return unbindEvents(win, windowBindings, options);
    };

    bindEvents(win, windowBindings, options);
  }, [getWindow, windowBindings]);
  var startDragging = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    var pending = pendingRef.current;
    !pending ?  false ? invariant(false, 'Cannot start a drag without a pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    isDraggingRef.current = true;
    pendingRef.current = null;
    hasMovedRef.current = false;
    callbacks.onLift({
      clientSelection: pending.point,
      movementMode: 'FLUID'
    });
  }, [callbacks]);
  var startPendingDrag = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    !!pendingRef.current ?  false ? invariant(false, 'Expected there to be no pending drag') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var touch = event.touches[0];
    var clientX = touch.clientX,
        clientY = touch.clientY;
    var point = {
      x: clientX,
      y: clientY
    };
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    var pending = {
      point: point,
      longPressTimerId: longPressTimerId
    };
    pendingRef.current = pending;
    onCaptureStart(stop);
    bindWindowEvents();
  }, [bindWindowEvents, onCaptureStart, startDragging, stop]);

  var onTouchStart = function onTouchStart(event) {
    if (touchStartMarshal.isHandled()) {
      return;
    }

    !!getIsCapturing() ?  false ? invariant(false, 'Should not be able to perform a touch start while a drag or pending drag is occurring') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;

    if (!canStartCapturing(event)) {
      return;
    }

    touchStartMarshal.handle();
    startPendingDrag(event);
  };

  useIsomorphicLayoutEffect(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: noop$3,
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
  return onTouchStart;
}

function isSvgElement(el) {
  return Boolean(getWindowFromEl(el).SVGElement) && el instanceof getWindowFromEl(el).SVGElement;
}

var selector = "[" + dragHandle + "]";

var throwIfSVG = function throwIfSVG(el) {
  !!isSvgElement(el) ?  false ? invariant(false, "A drag handle cannot be an SVGElement: it has inconsistent focus support.\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/dragging-svgs.md") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
};

var getDragHandleRef = function getDragHandleRef(draggableRef) {
  if (draggableRef.hasAttribute(dragHandle)) {
    throwIfSVG(draggableRef);
    return draggableRef;
  }

  var el = draggableRef.querySelector(selector);
  throwIfSVG(draggableRef);
  !el ?  false ? invariant(false, "\n      Cannot find drag handle element inside of Draggable.\n      Please be sure to apply the {...provided.dragHandleProps} to your Draggable\n\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/draggable.md\n    ") : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !isHtmlElement(el) ?  false ? invariant(false, 'A drag handle must be a HTMLElement') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  return el;
};

function useValidation$1(_ref) {
  var isEnabled = _ref.isEnabled,
      getDraggableRef = _ref.getDraggableRef;
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (false) {
      if (!isEnabled) {
        return;
      }

      var draggableRef = getDraggableRef();
      !draggableRef ? process.env.NODE_ENV !== "production" ? invariant(false, 'Drag handle was unable to find draggable ref') : invariant(false) : void 0;
      getDragHandleRef(draggableRef);
    }
  }, [getDraggableRef, isEnabled]);
}

var retainingFocusFor = null;
var listenerOptions = {
  capture: true
};

var clearRetentionOnFocusChange = function () {
  var isBound = false;

  var bind = function bind() {
    if (isBound) {
      return;
    }

    isBound = true;
    window.addEventListener('focus', onWindowFocusChange, listenerOptions);
  };

  var unbind = function unbind() {
    if (!isBound) {
      return;
    }

    isBound = false;
    window.removeEventListener('focus', onWindowFocusChange, listenerOptions);
  };

  var onWindowFocusChange = function onWindowFocusChange() {
    unbind();
    retainingFocusFor = null;
  };

  var result = function result() {
    return bind();
  };

  result.cancel = function () {
    return unbind();
  };

  return result;
}();

var retain = function retain(id) {
  retainingFocusFor = id;
  clearRetentionOnFocusChange();
};

var tryRestoreFocus = function tryRestoreFocus(id, draggableRef) {
  if (!retainingFocusFor) {
    return;
  }

  if (id !== retainingFocusFor) {
    return;
  }

  retainingFocusFor = null;
  clearRetentionOnFocusChange.cancel();
  var dragHandleRef = getDragHandleRef(draggableRef);

  if (!dragHandleRef) {
     false ? warning('Could not find drag handle in the DOM to focus on it') : void 0;
    return;
  }

  dragHandleRef.focus();
};

var retainer = {
  retain: retain,
  tryRestoreFocus: tryRestoreFocus
};

function noop$4() {}

function useFocusRetainer(args) {
  var isFocusedRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(false);
  var lastArgsRef = usePrevious(args);
  var getDraggableRef = args.getDraggableRef;
  var onFocus = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    isFocusedRef.current = true;
  }, []);
  var onBlur = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    isFocusedRef.current = false;
  }, []);
  useIsomorphicLayoutEffect(function () {
    var first = lastArgsRef.current;

    if (!first.isEnabled) {
      return noop$4;
    }

    var draggable = getDraggableRef();
    !draggable ?  false ? invariant(false, 'Drag handle could not obtain draggable ref') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var dragHandle = getDragHandleRef(draggable);
    retainer.tryRestoreFocus(first.draggableId, dragHandle);
    return function () {
      var last = lastArgsRef.current;

      var shouldRetainFocus = function () {
        if (!last.isEnabled) {
          return false;
        }

        if (!isFocusedRef.current) {
          return false;
        }

        return last.isDragging || last.isDropAnimating;
      }();

      if (shouldRetainFocus) {
        retainer.retain(last.draggableId);
      }
    };
  }, [getDraggableRef, lastArgsRef]);
  var lastDraggableRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  useIsomorphicLayoutEffect(function () {
    if (!lastDraggableRef.current) {
      return;
    }

    var draggableRef = getDraggableRef();

    if (!draggableRef) {
      return;
    }

    if (draggableRef === lastDraggableRef.current) {
      return;
    }

    if (isFocusedRef.current && lastArgsRef.current.isEnabled) {
      getDragHandleRef(draggableRef).focus();
    }
  });
  useIsomorphicLayoutEffect(function () {
    lastDraggableRef.current = getDraggableRef();
  });
  return {
    onBlur: onBlur,
    onFocus: onFocus
  };
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function useDragHandle(args) {
  var capturingRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var onCaptureStart = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (abort) {
    !!capturingRef.current ?  false ? invariant(false, 'Cannot start capturing while something else is') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    capturingRef.current = {
      abort: abort
    };
  }, []);
  var onCaptureEnd = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    !capturingRef.current ?  false ? invariant(false, 'Cannot stop capturing while nothing is capturing') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    capturingRef.current = null;
  }, []);
  var abortCapture = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    !capturingRef.current ?  false ? invariant(false, 'Cannot abort capture when there is none') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    capturingRef.current.abort();
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      canLift = _useRequiredContext.canLift,
      styleContext = _useRequiredContext.style;

  var isDragging = args.isDragging,
      isEnabled = args.isEnabled,
      draggableId = args.draggableId,
      callbacks = args.callbacks,
      getDraggableRef = args.getDraggableRef,
      getShouldRespectForcePress = args.getShouldRespectForcePress,
      canDragInteractiveElements = args.canDragInteractiveElements;
  var lastArgsRef = usePrevious(args);
  useValidation$1({
    isEnabled: isEnabled,
    getDraggableRef: getDraggableRef
  });
  var getWindow = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return getWindowFromEl(getDraggableRef());
  }, [getDraggableRef]);
  var canStartCapturing = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (!isEnabled) {
      return false;
    }

    if (capturingRef.current) {
      return false;
    }

    if (!canLift(draggableId)) {
      return false;
    }

    return shouldAllowDraggingFromTarget(event, canDragInteractiveElements);
  }, [canDragInteractiveElements, canLift, draggableId, isEnabled]);

  var _useFocusRetainer = useFocusRetainer(args),
      onBlur = _useFocusRetainer.onBlur,
      onFocus = _useFocusRetainer.onFocus;

  var mouseArgs = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      callbacks: callbacks,
      getDraggableRef: getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: canStartCapturing,
      onCaptureStart: onCaptureStart,
      onCaptureEnd: onCaptureEnd,
      getShouldRespectForcePress: getShouldRespectForcePress
    };
  }, [callbacks, getDraggableRef, getWindow, canStartCapturing, onCaptureStart, onCaptureEnd, getShouldRespectForcePress]);
  var onMouseDown = useMouseSensor(mouseArgs);
  var keyboardArgs = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      callbacks: callbacks,
      getDraggableRef: getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: canStartCapturing,
      onCaptureStart: onCaptureStart,
      onCaptureEnd: onCaptureEnd
    };
  }, [callbacks, canStartCapturing, getDraggableRef, getWindow, onCaptureEnd, onCaptureStart]);
  var onKeyDown = useKeyboardSensor(keyboardArgs);
  var touchArgs = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      callbacks: callbacks,
      getDraggableRef: getDraggableRef,
      getWindow: getWindow,
      canStartCapturing: canStartCapturing,
      getShouldRespectForcePress: getShouldRespectForcePress,
      onCaptureStart: onCaptureStart,
      onCaptureEnd: onCaptureEnd
    };
  }, [callbacks, getDraggableRef, getWindow, canStartCapturing, getShouldRespectForcePress, onCaptureStart, onCaptureEnd]);
  var onTouchStart = useTouchSensor(touchArgs);
  useIsomorphicLayoutEffect(function () {
    return function () {
      if (!capturingRef.current) {
        return;
      }

      abortCapture();

      if (lastArgsRef.current.isDragging) {
        lastArgsRef.current.callbacks.onCancel();
      }
    };
  }, []);

  if (!isEnabled && capturingRef.current) {
    abortCapture();

    if (lastArgsRef.current.isDragging) {
       false ? warning('You have disabled dragging on a Draggable while it was dragging. The drag has been cancelled') : void 0;
      callbacks.onCancel();
    }
  }

  useIsomorphicLayoutEffect(function () {
    if (!isDragging && capturingRef.current) {
      abortCapture();
    }
  }, [abortCapture, isDragging]);
  var props = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    if (!isEnabled) {
      return null;
    }

    return {
      onMouseDown: onMouseDown,
      onKeyDown: onKeyDown,
      onTouchStart: onTouchStart,
      onFocus: onFocus,
      onBlur: onBlur,
      tabIndex: 0,
      'data-react-beautiful-dnd-drag-handle': styleContext,
      'aria-roledescription': 'Draggable item. Press space bar to lift',
      draggable: false,
      onDragStart: preventHtml5Dnd
    };
  }, [isEnabled, onBlur, onFocus, onKeyDown, onMouseDown, onTouchStart, styleContext]);
  return props;
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["a" /* calculateBox */])(borderBox, computedStyles);
  var page = Object(__WEBPACK_IMPORTED_MODULE_7_css_box_model__["g" /* withScroll */])(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggableDimensionPublisher(args) {
  var draggableId = args.draggableId,
      index = args.index,
      getDraggableRef = args.getDraggableRef;
  var appContext = useRequiredContext(AppContext);
  var marshal = appContext.marshal;
  var droppableContext = useRequiredContext(DroppableContext);
  var droppableId = droppableContext.droppableId,
      type = droppableContext.type;
  var descriptor = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    var result = {
      id: draggableId,
      droppableId: droppableId,
      type: type,
      index: index
    };
    return result;
  }, [draggableId, droppableId, index, type]);
  var publishedDescriptorRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(descriptor);
  var makeDimension = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (windowScroll) {
    var latest = publishedDescriptorRef.current;
    var el = getDraggableRef();
    !el ?  false ? invariant(false, 'Cannot get dimension when no ref is set') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    return getDimension$1(latest, el, windowScroll);
  }, [getDraggableRef]);
  useIsomorphicLayoutEffect(function () {
    marshal.registerDraggable(publishedDescriptorRef.current, makeDimension);
    return function () {
      return marshal.unregisterDraggable(publishedDescriptorRef.current);
    };
  }, [makeDimension, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (publishedDescriptorRef.current === descriptor) {
      return;
    }

    var previous = publishedDescriptorRef.current;
    publishedDescriptorRef.current = descriptor;
    marshal.updateDraggable(previous, descriptor, makeDimension);
  }, [descriptor, makeDimension, marshal]);
}

function checkOwnProps$1(props) {
  !__WEBPACK_IMPORTED_MODULE_14__babel_runtime_corejs2_core_js_number_is_integer___default()(props.index) ?  false ? invariant(false, 'Draggable requires an integer index prop') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !props.draggableId ?  false ? invariant(false, 'Draggable requires a draggableId') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  !(typeof props.isDragDisabled === 'boolean') ?  false ? invariant(false, 'isDragDisabled must be a boolean') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
}

function checkForOutdatedProps(props) {
  if (Object.prototype.hasOwnProperty.call(props, 'shouldRespectForceTouch')) {
     false ? warning('shouldRespectForceTouch has been renamed to shouldRespectForcePress') : void 0;
  }
}

function useValidation$2(props, getRef) {
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    if (false) {
      checkOwnProps$1(props);
      checkForOutdatedProps(props);
      checkIsValidInnerRef(getRef());
    }
  });
}

function Draggable(props) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(null);
  var setRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (el) {
    ref.current = el;
  }, []);
  var getRef = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return ref.current;
  }, []);
  var appContext = useRequiredContext(AppContext);
  useValidation$2(props, getRef);
  var children = props.children,
      draggableId = props.draggableId,
      isDragDisabled = props.isDragDisabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.disableInteractiveElementBlocking,
      index = props.index,
      mapped = props.mapped,
      moveUpAction = props.moveUp,
      moveAction = props.move,
      dropAction = props.drop,
      moveDownAction = props.moveDown,
      moveRightAction = props.moveRight,
      moveLeftAction = props.moveLeft,
      moveByWindowScrollAction = props.moveByWindowScroll,
      liftAction = props.lift,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  var forPublisher = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      draggableId: draggableId,
      index: index,
      getDraggableRef: getRef
    };
  }, [draggableId, getRef, index]);
  useDraggableDimensionPublisher(forPublisher);
  var onLift = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (options) {
    start('LIFT');
    var el = ref.current;
    !el ?  false ? invariant(false) : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    !!isDragDisabled ?  false ? invariant(false, 'Cannot lift a Draggable when it is disabled') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
    var clientSelection = options.clientSelection,
        movementMode = options.movementMode;
    liftAction({
      id: draggableId,
      clientSelection: clientSelection,
      movementMode: movementMode
    });
    finish('LIFT');
  }, [draggableId, isDragDisabled, liftAction]);
  var getShouldRespectForcePress = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function () {
    return shouldRespectForcePress;
  }, [shouldRespectForcePress]);
  var callbacks = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      onLift: onLift,
      onMove: function onMove(clientSelection) {
        return moveAction({
          client: clientSelection
        });
      },
      onDrop: function onDrop() {
        return dropAction({
          reason: 'DROP'
        });
      },
      onCancel: function onCancel() {
        return dropAction({
          reason: 'CANCEL'
        });
      },
      onMoveUp: moveUpAction,
      onMoveDown: moveDownAction,
      onMoveRight: moveRightAction,
      onMoveLeft: moveLeftAction,
      onWindowScroll: function onWindowScroll() {
        return moveByWindowScrollAction({
          newScroll: getWindowScroll()
        });
      }
    };
  }, [dropAction, moveAction, moveByWindowScrollAction, moveDownAction, moveLeftAction, moveRightAction, moveUpAction, onLift]);
  var isDragging = mapped.type === 'DRAGGING';
  var isDropAnimating = mapped.type === 'DRAGGING' && Boolean(mapped.dropping);
  var dragHandleArgs = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    return {
      draggableId: draggableId,
      isDragging: isDragging,
      isDropAnimating: isDropAnimating,
      isEnabled: !isDragDisabled,
      callbacks: callbacks,
      getDraggableRef: getRef,
      canDragInteractiveElements: canDragInteractiveElements,
      getShouldRespectForcePress: getShouldRespectForcePress
    };
  }, [callbacks, canDragInteractiveElements, draggableId, getRef, getShouldRespectForcePress, isDragDisabled, isDragging, isDropAnimating]);
  var dragHandleProps = useDragHandle(dragHandleArgs);
  var onMoveEnd = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["a" /* useCallback */])(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = Object(__WEBPACK_IMPORTED_MODULE_2_use_memo_one__["b" /* useMemo */])(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-react-beautiful-dnd-draggable': appContext.style,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [appContext.style, dragHandleProps, mapped, onMoveEnd, setRef]);
  return children(provided, mapped.snapshot);
}

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.merge ? impact.merge.combine.draggableId : null;
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var getDraggingSnapshot = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (mode, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getSecondarySnapshot = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (combineTargetFor) {
    return {
      isDragging: false,
      isDropAnimating: false,
      dropAnimation: null,
      mode: null,
      draggingOver: null,
      combineTargetFor: combineTargetFor,
      combineWith: null
    };
  });
  var defaultMapProps = {
    mapped: {
      type: 'SECONDARY',
      offset: origin,
      combineTargetFor: null,
      shouldAnimateDisplacement: true,
      snapshot: getSecondarySnapshot(null)
    }
  };
  var memoizedOffset = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getDraggingProps = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (offset, mode, dimension, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getDraggingSnapshot(mode, draggingOver, combineWith, null)
      }
    };
  });
  var getSecondaryProps = Object(__WEBPACK_IMPORTED_MODULE_8_memoize_one__["a" /* default */])(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getSecondarySnapshot(combineTargetFor)
      }
    };
  });

  var getSecondaryMovement = function getSecondaryMovement(ownId, draggingId, impact) {
    var map = impact.movement.map;
    var displacement = map[ownId];
    var movement = impact.movement;
    var merge = impact.merge;
    var isCombinedWith = Boolean(merge && merge.combine.draggableId === ownId);
    var displacedBy = movement.displacedBy.point;
    var offset = memoizedOffset(displacedBy.x, displacedBy.y);

    if (isCombinedWith) {
      return getSecondaryProps(displacement ? offset : origin, draggingId, displacement ? displacement.shouldAnimate : true);
    }

    if (!displacement) {
      return null;
    }

    if (!displacement.isVisible) {
      return null;
    }

    return getSecondaryProps(offset, null, displacement.shouldAnimate);
  };

  var draggingSelector = function draggingSelector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var mode = state.movementMode;
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getDraggingProps(memoizedOffset(offset.x, offset.y), mode, dimension, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var _mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: _mode,
          forceShouldAnimate: null,
          snapshot: getDraggingSnapshot(_mode, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  var secondarySelector = function secondarySelector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getSecondaryMovement(ownProps.draggableId, state.critical.draggable.id, state.impact);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getSecondaryMovement(ownProps.draggableId, completed.result.draggableId, completed.impact);
    }

    return null;
  };

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || defaultMapProps;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  lift: lift,
  move: move,
  moveUp: moveUp,
  moveDown: moveDown,
  moveLeft: moveLeft,
  moveRight: moveRight,
  moveByWindowScroll: moveByWindowScroll,
  drop: drop,
  dropAnimationFinished: dropAnimationFinished
};
var defaultProps$1 = {
  isDragDisabled: false,
  disableInteractiveElementBlocking: false,
  shouldRespectForcePress: false
};
var ConnectedDraggable = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);
ConnectedDraggable.defaultProps = defaultProps$1;




/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSubscription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__batch__ = __webpack_require__(1154);
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = Object(__WEBPACK_IMPORTED_MODULE_0__batch__["a" /* getBatch */])();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(438);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = propagateErrors;
/* unused harmony export settled */
/* unused harmony export collectErrors */
/* harmony export (immutable) */ __webpack_exports__["a"] = runValidations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_synchronous_promise__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_synchronous_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_synchronous_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidationError__ = __webpack_require__(688);




var promise = function promise(sync) {
  return sync ? __WEBPACK_IMPORTED_MODULE_1_synchronous_promise__["SynchronousPromise"] : Promise;
};

var unwrapError = function unwrapError(errors) {
  if (errors === void 0) {
    errors = [];
  }

  return errors.inner && errors.inner.length ? errors.inner : [].concat(errors);
};

function scopeToValue(promises, value, sync) {
  //console.log('scopeToValue', promises, value)
  var p = promise(sync).all(promises); //console.log('scopeToValue B', p)

  var b = p.catch(function (err) {
    if (err.name === 'ValidationError') err.value = value;
    throw err;
  }); //console.log('scopeToValue c', b)

  var c = b.then(function () {
    return value;
  }); //console.log('scopeToValue d', c)

  return c;
}
/**
 * If not failing on the first error, catch the errors
 * and collect them in an array
 */


function propagateErrors(endEarly, errors) {
  return endEarly ? null : function (err) {
    errors.push(err);
    return err.value;
  };
}
function settled(promises, sync) {
  var Promise = promise(sync);
  return Promise.all(promises.map(function (p) {
    return Promise.resolve(p).then(function (value) {
      return {
        fulfilled: true,
        value: value
      };
    }, function (value) {
      return {
        fulfilled: false,
        value: value
      };
    });
  }));
}
function collectErrors(_ref) {
  var validations = _ref.validations,
      value = _ref.value,
      path = _ref.path,
      sync = _ref.sync,
      errors = _ref.errors,
      sort = _ref.sort;
  errors = unwrapError(errors);
  return settled(validations, sync).then(function (results) {
    var nestedErrors = results.filter(function (r) {
      return !r.fulfilled;
    }).reduce(function (arr, _ref2) {
      var error = _ref2.value;

      // we are only collecting validation errors
      if (!__WEBPACK_IMPORTED_MODULE_2__ValidationError__["a" /* default */].isError(error)) {
        throw error;
      }

      return arr.concat(error);
    }, []);
    if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

    errors = nestedErrors.concat(errors);
    if (errors.length) throw new __WEBPACK_IMPORTED_MODULE_2__ValidationError__["a" /* default */](errors, value, path);
    return value;
  });
}
function runValidations(_ref3) {
  var endEarly = _ref3.endEarly,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["endEarly"]);

  if (endEarly) return scopeToValue(options.validations, options.value, options.sync);
  return collectErrors(options);
}

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node: true */


function makeArrayFrom(obj) {
  return Array.prototype.slice.apply(obj);
}

var
  PENDING = "pending",
  RESOLVED = "resolved",
  REJECTED = "rejected";

function SynchronousPromise(handler) {
  this.status = PENDING;
  this._continuations = [];
  this._parent = null;
  this._paused = false;
  if (handler) {
    handler.call(
      this,
      this._continueWith.bind(this),
      this._failWith.bind(this)
    );
  }
}

function looksLikeAPromise(obj) {
  return obj && typeof (obj.then) === "function";
}

function passThrough(value) {
  return value;
}

SynchronousPromise.prototype = {
  then: function (nextFn, catchFn) {
    var next = SynchronousPromise.unresolved()._setParent(this);
    if (this._isRejected()) {
      if (this._paused) {
        this._continuations.push({
          promise: next,
          nextFn: nextFn,
          catchFn: catchFn
        });
        return next;
      }
      if (catchFn) {
        try {
          var catchResult = catchFn(this._error);
          if (looksLikeAPromise(catchResult)) {
            this._chainPromiseData(catchResult, next);
            return next;
          } else {
            return SynchronousPromise.resolve(catchResult)._setParent(this);
          }
        } catch (e) {
          return SynchronousPromise.reject(e)._setParent(this);
        }
      }
      return SynchronousPromise.reject(this._error)._setParent(this);
    }
    this._continuations.push({
      promise: next,
      nextFn: nextFn,
      catchFn: catchFn
    });
    this._runResolutions();
    return next;
  },
  catch: function (handler) {
    if (this._isResolved()) {
      return SynchronousPromise.resolve(this._data)._setParent(this);
    }
    var next = SynchronousPromise.unresolved()._setParent(this);
    this._continuations.push({
      promise: next,
      catchFn: handler
    });
    this._runRejections();
    return next;
  },
  finally: function (callback) {
    var ran = false;

    function runFinally(result, err) {
      if (!ran) {
        ran = true;
        if (!callback) {
          callback = passThrough;
        }
        var callbackResult = callback(result);
        if (looksLikeAPromise(callbackResult)) {
          return callbackResult.then(function () {
            if (err) {
              throw err;
            }
            return result;
          });
        } else {
          return result;
        }
      }
    }

    return this
      .then(function (result) {
        return runFinally(result);
      })
      .catch(function (err) {
        return runFinally(null, err);
      });
  },
  pause: function () {
    this._paused = true;
    return this;
  },
  resume: function () {
    var firstPaused = this._findFirstPaused();
    if (firstPaused) {
      firstPaused._paused = false;
      firstPaused._runResolutions();
      firstPaused._runRejections();
    }
    return this;
  },
  _findAncestry: function () {
    return this._continuations.reduce(function (acc, cur) {
      if (cur.promise) {
        var node = {
          promise: cur.promise,
          children: cur.promise._findAncestry()
        };
        acc.push(node);
      }
      return acc;
    }, []);
  },
  _setParent: function (parent) {
    if (this._parent) {
      throw new Error("parent already set");
    }
    this._parent = parent;
    return this;
  },
  _continueWith: function (data) {
    var firstPending = this._findFirstPending();
    if (firstPending) {
      firstPending._data = data;
      firstPending._setResolved();
    }
  },
  _findFirstPending: function () {
    return this._findFirstAncestor(function (test) {
      return test._isPending && test._isPending();
    });
  },
  _findFirstPaused: function () {
    return this._findFirstAncestor(function (test) {
      return test._paused;
    });
  },
  _findFirstAncestor: function (matching) {
    var test = this;
    var result;
    while (test) {
      if (matching(test)) {
        result = test;
      }
      test = test._parent;
    }
    return result;
  },
  _failWith: function (error) {
    var firstRejected = this._findFirstPending();
    if (firstRejected) {
      firstRejected._error = error;
      firstRejected._setRejected();
    }
  },
  _takeContinuations: function () {
    return this._continuations.splice(0, this._continuations.length);
  },
  _runRejections: function () {
    if (this._paused || !this._isRejected()) {
      return;
    }
    var
      error = this._error,
      continuations = this._takeContinuations(),
      self = this;
    continuations.forEach(function (cont) {
      if (cont.catchFn) {
        try {
          var catchResult = cont.catchFn(error);
          self._handleUserFunctionResult(catchResult, cont.promise);
        } catch (e) {
          cont.promise.reject(e);
        }
      } else {
        cont.promise.reject(error);
      }
    });
  },
  _runResolutions: function () {
    if (this._paused || !this._isResolved() || this._isPending()) {
      return;
    }
    var continuations = this._takeContinuations();
    if (looksLikeAPromise(this._data)) {
      return this._handleWhenResolvedDataIsPromise(this._data);
    }
    var data = this._data;
    var self = this;
    continuations.forEach(function (cont) {
      if (cont.nextFn) {
        try {
          var result = cont.nextFn(data);
          self._handleUserFunctionResult(result, cont.promise);
        } catch (e) {
          self._handleResolutionError(e, cont);
        }
      } else if (cont.promise) {
        cont.promise.resolve(data);
      }
    });
  },
  _handleResolutionError: function (e, continuation) {
    this._setRejected();
    if (continuation.catchFn) {
      try {
        continuation.catchFn(e);
        return;
      } catch (e2) {
        e = e2;
      }
    }
    if (continuation.promise) {
      continuation.promise.reject(e);
    }
  },
  _handleWhenResolvedDataIsPromise: function (data) {
    var self = this;
    return data.then(function (result) {
      self._data = result;
      self._runResolutions();
    }).catch(function (error) {
      self._error = error;
      self._setRejected();
      self._runRejections();
    });
  },
  _handleUserFunctionResult: function (data, nextSynchronousPromise) {
    if (looksLikeAPromise(data)) {
      this._chainPromiseData(data, nextSynchronousPromise);
    } else {
      nextSynchronousPromise.resolve(data);
    }
  },
  _chainPromiseData: function (promiseData, nextSynchronousPromise) {
    promiseData.then(function (newData) {
      nextSynchronousPromise.resolve(newData);
    }).catch(function (newError) {
      nextSynchronousPromise.reject(newError);
    });
  },
  _setResolved: function () {
    this.status = RESOLVED;
    if (!this._paused) {
      this._runResolutions();
    }
  },
  _setRejected: function () {
    this.status = REJECTED;
    if (!this._paused) {
      this._runRejections();
    }
  },
  _isPending: function () {
    return this.status === PENDING;
  },
  _isResolved: function () {
    return this.status === RESOLVED;
  },
  _isRejected: function () {
    return this.status === REJECTED;
  }
};

SynchronousPromise.resolve = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    if (looksLikeAPromise(result)) {
      result.then(function (newResult) {
        resolve(newResult);
      }).catch(function (error) {
        reject(error);
      });
    } else {
      resolve(result);
    }
  });
};

SynchronousPromise.reject = function (result) {
  return new SynchronousPromise(function (resolve, reject) {
    reject(result);
  });
};

SynchronousPromise.unresolved = function () {
  return new SynchronousPromise(function (resolve, reject) {
    this.resolve = resolve;
    this.reject = reject;
  });
};

SynchronousPromise.all = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allData = [],
      numResolved = 0,
      doResolve = function () {
        if (numResolved === args.length) {
          resolve(allData);
        }
      },
      rejected = false,
      doReject = function (err) {
        if (rejected) {
          return;
        }
        rejected = true;
        reject(err);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = thisResult;
        numResolved += 1;
        doResolve();
      }).catch(function (err) {
        doReject(err);
      });
    });
  });
};

function createAggregateErrorFrom(errors) {
  /* jshint ignore:start */
  if (typeof window !== "undefined" && "AggregateError" in window) {
    return new window.AggregateError(errors);
  }
  /* jshint ignore:end */

  return { errors: errors };
}

SynchronousPromise.any = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.reject(createAggregateErrorFrom([]));
  }
  return new SynchronousPromise(function (resolve, reject) {
    var
      allErrors = [],
      numRejected = 0,
      doReject = function () {
        if (numRejected === args.length) {
          reject(createAggregateErrorFrom(allErrors));
        }
      },
      resolved = false,
      doResolve = function (result) {
        if (resolved) {
          return;
        }
        resolved = true;
        resolve(result);
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        doResolve(thisResult);
      }).catch(function (err) {
        allErrors[idx] = err;
        numRejected += 1;
        doReject();
      });
    });
  });
};

SynchronousPromise.allSettled = function () {
  var args = makeArrayFrom(arguments);
  if (Array.isArray(args[0])) {
    args = args[0];
  }
  if (!args.length) {
    return SynchronousPromise.resolve([]);
  }
  return new SynchronousPromise(function (resolve) {
    var
      allData = [],
      numSettled = 0,
      doSettled = function () {
        numSettled += 1;
        if (numSettled === args.length) {
          resolve(allData);
        }
      };
    args.forEach(function (arg, idx) {
      SynchronousPromise.resolve(arg).then(function (thisResult) {
        allData[idx] = {
          status: "fulfilled",
          value: thisResult
        };
        doSettled();
      }).catch(function (err) {
        allData[idx] = {
          status: "rejected",
          reason: err
        };
        doSettled();
      });
    });
  });
};

/* jshint ignore:start */
if (Promise === SynchronousPromise) {
  throw new Error("Please use SynchronousPromise.installGlobally() to install globally");
}
var RealPromise = Promise;
SynchronousPromise.installGlobally = function (__awaiter) {
  if (Promise === SynchronousPromise) {
    return __awaiter;
  }
  var result = patchAwaiterIfRequired(__awaiter);
  Promise = SynchronousPromise;
  return result;
};

SynchronousPromise.uninstallGlobally = function () {
  if (Promise === SynchronousPromise) {
    Promise = RealPromise;
  }
};

function patchAwaiterIfRequired(__awaiter) {
  if (typeof (__awaiter) === "undefined" || __awaiter.__patched) {
    return __awaiter;
  }
  var originalAwaiter = __awaiter;
  __awaiter = function () {
    var Promise = RealPromise;
    originalAwaiter.apply(this, makeArrayFrom(arguments));
  };
  __awaiter.__patched = true;
  return __awaiter;
}

/* jshint ignore:end */

module.exports = {
  SynchronousPromise: SynchronousPromise
};


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ValidationError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_printValue__ = __webpack_require__(455);

var strReg = /\$\{\s*(\w+)\s*\}/g;

var replace = function replace(str) {
  return function (params) {
    return str.replace(strReg, function (_, key) {
      return Object(__WEBPACK_IMPORTED_MODULE_0__util_printValue__["a" /* default */])(params[key]);
    });
  };
};

function ValidationError(errors, value, field, type) {
  var _this = this;

  this.name = 'ValidationError';
  this.value = value;
  this.path = field;
  this.type = type;
  this.errors = [];
  this.inner = [];
  if (errors) [].concat(errors).forEach(function (err) {
    _this.errors = _this.errors.concat(err.errors || err);
    if (err.inner) _this.inner = _this.inner.concat(err.inner.length ? err.inner : err);
  });
  this.message = this.errors.length > 1 ? this.errors.length + " errors occurred" : this.errors[0];
  if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
}
ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;

ValidationError.isError = function (err) {
  return err && err.name === 'ValidationError';
};

ValidationError.formatError = function (message, params) {
  if (typeof message === 'string') message = replace(message);

  var fn = function fn(params) {
    params.path = params.label || params.path || 'this';
    return typeof message === 'function' ? message(params) : message;
  };

  return arguments.length === 1 ? fn : fn(params);
};

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return styles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return customStyleFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return exporter; });
/* unused harmony export convertFromClassic */
/* unused harmony export importFromHtmlCustomInlineFn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return customInlineStyleMap; });
/* unused harmony export customInlineElementStyleMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return htmlFromEditorState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return editorStateFromHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return blockStyleFn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return customBlockStyleDataKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOM_FONT_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CUSTOM_FONT_WEIGHT_STRING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js_custom_styles__ = __webpack_require__(2693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js_custom_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_js_custom_styles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_convert__ = __webpack_require__(2696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_convert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_draft_convert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_js_import_element__ = __webpack_require__(2710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_draft_js_export_html__ = __webpack_require__(2719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_draft_js_export_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_draft_js_export_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_xp_models_widgets__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_ui_experience_widgets_textEnhancedWidget_utility__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_shared_ui_experience_widgets_textEnhancedWidget_TextEditorControls__ = __webpack_require__(620);
/* unused harmony reexport convertFromHTML */









// This is the default prefix but we're still specifying it.
var prefix = "CUSTOM_";
var customStyles = ["font-size", "letter-spacing", "color", "font-weight", "font-family", "font-variant-ligatures"];
var _a = __WEBPACK_IMPORTED_MODULE_1_draft_js_custom_styles___default()(customStyles, prefix), styles = _a.styles, pluginCustomStyles = _a.customStyleFn, exporter = _a.exporter;
var customBlockStyleDataKeys = {
    textAlign: "text-align",
    lineHeight: "line-height",
};
var customStyleFn = function (style, block) {
    var pluginStyles = pluginCustomStyles(style, block);
    // If there is a custom style for color set, we need to remove it so our mapped HIGHLIGHT style works.
    if (style.has(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].HIGHLIGHT)) {
        delete pluginStyles.color;
    }
    return pluginStyles;
};
var blockElements = ["div", "h1", "h2", "h3", "h4", "h5", "h6"];
// It doesn't seem like draft.js likes <br /> tags.
// I might be able to manage them in textToEntity if we need to use them.
var convertFromClassic = Object(__WEBPACK_IMPORTED_MODULE_2_draft_convert__["convertFromHTML"])({
    htmlToStyle: function (_nodeName, node, currentStyle) {
        var _a = node.innerText, innerText = _a === void 0 ? "" : _a, _b = node.innerHTML, innerHTML = _b === void 0 ? "" : _b, _c = node.style, style = _c === void 0 ? {} : _c;
        // There is so very weird text generated by the existing text editor. If you apply a text shadow, press enter,
        //  toggle another style, then turn off the text shadow the new text will be wrapped with the inline style that
        // applies text shadow then clears it.
        if (innerText.length === 0 || innerHTML.length === 0) {
            // The HTML created by the old text widget is so poorly formed that there are empty elements which can
            // influence the style of our block.
            return currentStyle;
        }
        else if (style.fontStyle) { // I don't believe this is needed since we specify it in the custom map.
            return currentStyle.add(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].ITALIC);
        }
        else if (style.textDecoration) {
            if (style.textDecoration === "line-through") {
                return currentStyle.add(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].STRIKETHROUGH);
            }
            else if (style.textDecoration === "underline") {
                // This might not work.
                return currentStyle.add(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].UNDERLINE);
            }
        }
        else if (style.textShadow) {
            // There is some weird style overrides going on with the old editor. It looks like most scenarios are no
            // contents or a child element clearing the style.
            if (style.textShadow !== "none") {
                return currentStyle.add(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].SHADOW);
            }
            else {
                return currentStyle.remove(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].SHADOW);
            }
        }
        else if (style.textTransform) {
            return currentStyle.add(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].CAPITAL);
        }
        else if (style.fontVariant) {
            return currentStyle.add(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].SMALLCAPS);
        }
        else if (style.color) {
            // It appears that we don't need to add the color VIA the styles object from createStyles.
            return currentStyle.add("CUSTOM_COLOR_" + style.color);
        }
        else if (style.letterSpacing) {
            return currentStyle.add("CUSTOM_LETTER_SPACING_" + style.letterSpacing);
        }
        else if (style.fontSize) {
            return currentStyle.add("CUSTOM_FONT_SIZE_" + style.fontSize);
        }
        else if (style.fontWeight) {
            return currentStyle.add("CUSTOM_FONT_WEIGHT_" + style.fontWeight);
        }
        else if (style.fontFamily) {
            return currentStyle.add("CUSTOM_FONT_FAMILY_" + style.fontFamily);
            // @ts-ignore unfortunatelly fontVariantLigatures available in TS since 3.6.2 version
        }
        else if (style.fontVariantLigatures) {
            // @ts-ignore unfortunatelly fontVariantLigatures available in TS since 3.6.2 version
            return currentStyle.add("CUSTOM_FONT_VARIANT_LIGATURES_" + style.fontVariantLigatures);
        }
        return currentStyle;
    },
    htmlToBlock: function (nodeName, node) {
        // Might want to make this a little smarter in detecting a block level element.
        if (blockElements.some(function (elem) { return elem === nodeName; })) {
            var blockData = {};
            var _a = node.style, _b = _a.textAlign, textAlign = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_8_shared_ui_experience_widgets_textEnhancedWidget_TextEditorControls__["b" /* textEditorDefaults */].alignment : _b, _c = _a.lineHeight, lineHeight = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_8_shared_ui_experience_widgets_textEnhancedWidget_TextEditorControls__["b" /* textEditorDefaults */].lineHeight.toString() : _c;
            blockData[customBlockStyleDataKeys.textAlign] = textAlign;
            blockData[customBlockStyleDataKeys.lineHeight] = lineHeight;
            return { data: blockData };
        }
    }
});
var importFromHtmlCustomInlineFn = function (node, _a) {
    var Style = _a.Style, Entity = _a.Entity;
    // There is so very weird text generated by the existing text editor. If you apply a text shadow, press enter,
    //  toggle another style, then turn off the text shadow the new text will be wrapped with the inline style that
    // applies text shadow then clears it.
    if (node.innerText.length !== 0 || node.innerHTML.length !== 0) {
        // TODO: Fix issue with multiple styles applied to a node.
        if (node.style.fontStyle) { // This does not work with the custom style map.
            return Style(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].ITALIC);
        }
        else if (node.style.textDecoration) {
            if (node.style.textDecoration === "line-through") {
                return Style(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].STRIKETHROUGH);
            }
            else if (node.style.textDecoration === "underline") {
                return Style(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].UNDERLINE);
            }
        }
        else if (node.style.textShadow) {
            return Style(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].SHADOW);
        }
        else if (node.style.textTransform) {
            return Style(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].CAPITAL);
        }
        else if (node.style.fontVariant) {
            return Style(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["c" /* DraftStyles */].SMALLCAPS);
        }
        else if (node.style.color) {
            // It appears that we don't need to add the color VIA the styles object from createStyles.
            return Style("CUSTOM_COLOR_" + node.style.color);
        }
        else if (node.style.letterSpacing) {
            return Style("CUSTOM_LETTER_SPACING_" + node.style.letterSpacing);
        }
        else if (node.style.fontSize) {
            return Style("CUSTOM_FONT_SIZE_" + node.style.fontSize);
        }
        else if (node.style.fontWeight) {
            return Style("CUSTOM_FONT_WEIGHT_" + node.style.fontWeight);
        }
        else if (node.style.fontFamily) {
            return Style("CUSTOM_FONT_FAMILY_" + node.style.fontFamily);
            // @ts-ignore unfortunatelly fontVariantLigatures available in TS since 3.6.2 version
        }
        else if (node.style.fontVariantLigatures) {
            // @ts-ignore unfortunatelly fontVariantLigatures available in TS since 3.6.2 version
            return Style("CUSTOM_FONT_VARIANT_LIGATURES_" + node.style.fontVariantLigatures);
        }
        if (["a", "span"].indexOf(node.tagName.toLowerCase()) !== -1 && node.getAttribute("data-font-provider")) {
            var fontProvider = node.getAttribute("data-font-provider");
            var fontFamily = node.getAttribute("data-font-family");
            var fontWeight = node.getAttribute("data-font-weight");
            var fontStyle = node.getAttribute("data-font-style");
            var cssFamilyNames = node.getAttribute("data-css-family-names");
            var fontFamilyProvider = {
                fontWeight: fontWeight,
                fontStyle: fontStyle,
                fontFamily: fontFamily,
                cssFamilyNames: cssFamilyNames
            };
            var fontMetadata = void 0;
            switch (fontProvider) {
                case "custom" /* CUSTOM */:
                    var fontFormat = node.getAttribute("data-format");
                    var format = void 0;
                    switch (fontFormat) {
                        case __WEBPACK_IMPORTED_MODULE_5_shared_xp_models_widgets__["a" /* FontFormats */].OpenType:
                            format = __WEBPACK_IMPORTED_MODULE_5_shared_xp_models_widgets__["a" /* FontFormats */].OpenType;
                            break;
                        case __WEBPACK_IMPORTED_MODULE_5_shared_xp_models_widgets__["a" /* FontFormats */].TrueType:
                            format = __WEBPACK_IMPORTED_MODULE_5_shared_xp_models_widgets__["a" /* FontFormats */].TrueType;
                            break;
                        case __WEBPACK_IMPORTED_MODULE_5_shared_xp_models_widgets__["a" /* FontFormats */].Woff:
                            format = __WEBPACK_IMPORTED_MODULE_5_shared_xp_models_widgets__["a" /* FontFormats */].Woff;
                            break;
                    }
                    fontMetadata = {
                        customFontId: node.getAttribute("data-custom-font-id"),
                        format: format,
                        path: node.getAttribute("data-path")
                    };
                    Object.assign(fontFamilyProvider, {
                        fontMetadata: fontMetadata,
                        fontProvider: "custom" /* CUSTOM */
                    });
                    break;
                case "typekit" /* TYPEKIT */:
                    fontMetadata = {
                        kitID: node.getAttribute("data-kit-id")
                    };
                    Object.assign(fontFamilyProvider, {
                        fontMetadata: fontMetadata,
                        fontProvider: "typekit" /* TYPEKIT */
                    });
                    break;
                case "fontsDotCom" /* FONTSDOTCOM */:
                    fontMetadata = {
                        projectId: node.getAttribute("data-project-id")
                    };
                    Object.assign(fontFamilyProvider, {
                        fontMetadata: fontMetadata,
                        fontProvider: "fontsDotCom" /* FONTSDOTCOM */
                    });
                    break;
                case "google" /* GOOGLE */:
                    Object.assign(fontFamilyProvider, {
                        fontProvider: "google" /* GOOGLE */
                    });
                    break;
                case "standard" /* STANDARD */:
                    Object.assign(fontFamilyProvider, {
                        fontProvider: "standard" /* STANDARD */
                    });
                    break;
            }
            if (node.tagName.toLowerCase() === "a") {
                Object.assign(fontFamilyProvider, {
                    url: node.getAttribute('href'),
                    target: node.getAttribute('target')
                });
            }
            return Entity(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["d" /* FONT_METADATA */], __WEBPACK_IMPORTED_MODULE_7_shared_ui_experience_widgets_textEnhancedWidget_utility__["a" /* DraftJSUtils */].getFontMetadataEntityFromFontFamily(fontFamilyProvider));
        }
        else if (node.tagName.toLowerCase() === "a") {
            return Entity(__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["d" /* FONT_METADATA */], {
                url: node.getAttribute('href'),
                target: node.getAttribute('target')
            });
        }
    }
};
var importFromHtmlCustomBlockFn = function (node) {
    // Might want to make this a little smarter in detecting a block level element.
    if (blockElements.some(function (elem) { return elem === node.tagName.toLowerCase(); })) {
        var blockData = {};
        if (node.style.textAlign) {
            blockData[customBlockStyleDataKeys.textAlign] = node.style.textAlign;
        }
        if (node.style.lineHeight) {
            blockData[customBlockStyleDataKeys.lineHeight] = node.style.lineHeight;
        }
        return { data: blockData };
    }
};
var blockStyleFn = function (block) {
    var blockData = block.getData();
    var blockAlignment = blockData && blockData.get(customBlockStyleDataKeys.textAlign);
    var blockLineHeight = blockData && blockData.get(customBlockStyleDataKeys.lineHeight) || "";
    var isEmptyClassName = !block.getText() ? "etw-is-empty" : "";
    var alignmentClassName = blockAlignment ? "zmgs-" + blockAlignment + "-aligned-block" : "";
    var lineHeightClassName = blockLineHeight ?
        "zmgs-height-block-" + blockLineHeight.replace(".", "-") : "";
    return (alignmentClassName + " " + lineHeightClassName + " " + isEmptyClassName).trim();
};
// This isn't the same as the custom style map.
// Override the default tag and style.
var customInlineElementStyleMap = {};
// Override just the default style.
var customInlineStyleMap = {};
__WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["f" /* inlineStyleTypes */].forEach(function (inlineStyleTypeItem) {
    var key = inlineStyleTypeItem.draftStyle;
    var innerCustomStyles = inlineStyleTypeItem.customStyles;
    if (inlineStyleTypeItem.exported) {
        customInlineElementStyleMap[key] = innerCustomStyles;
    }
    customInlineStyleMap[key] = innerCustomStyles.style;
});
var exportBlockStyleFn = function (block) {
    var blockData = block.getData();
    var blockAlignment = blockData && blockData.get(customBlockStyleDataKeys.textAlign);
    var blockLineHeight = blockData && blockData.get(customBlockStyleDataKeys.lineHeight);
    var results = undefined;
    if (blockAlignment || blockLineHeight) {
        results = { style: { textAlign: blockAlignment, lineHeight: blockLineHeight } };
    }
    return results;
};
var exportEntityStyleFn = function (entity) {
    var entityType = entity.getType();
    if (entityType === __WEBPACK_IMPORTED_MODULE_6_shared_ui_experience_widgets_textEnhancedWidget_models__["d" /* FONT_METADATA */]) {
        var entityData = entity.getData();
        var attributes = {};
        if (entityData.fontProvider) {
            var data = __WEBPACK_IMPORTED_MODULE_7_shared_ui_experience_widgets_textEnhancedWidget_utility__["a" /* DraftJSUtils */].getFontFamilyFromFontMetadataEntity(entityData);
            Object.assign(attributes, {
                "data-font-provider": data.fontProvider,
                "data-font-family": data.fontFamily,
                "data-font-style": data.fontStyle,
                "data-css-family-names": data.cssFamilyNames,
                "data-font-weight": data.fontWeight
            });
            // Custom fonts
            if (data.fontProvider === "custom" /* CUSTOM */) {
                var metadata = data.fontMetadata;
                var customAttributes = {
                    "data-custom-font-id": metadata.customFontId,
                    "data-format": metadata.format,
                    "data-path": metadata.path
                };
                Object.assign(attributes, customAttributes);
            }
            // TypeKit fonts
            if (data.fontProvider === "typekit" /* TYPEKIT */) {
                var metadata = data.fontMetadata;
                var typekitAttributes = {
                    "data-kit-id": metadata.kitID
                };
                Object.assign(attributes, typekitAttributes);
            }
            // Fonts.com fonts
            if (data.fontProvider === "fontsDotCom" /* FONTSDOTCOM */) {
                var metadata = data.fontMetadata;
                var fontDotComAttributes = {
                    "data-project-id": metadata.projectId,
                };
                Object.assign(attributes, fontDotComAttributes);
            }
        }
        if (entityData.url) {
            var hyperlinkAttributes = {
                href: entityData.url,
                target: entityData.target
            };
            Object.assign(attributes, hyperlinkAttributes);
        }
        var result = {
            element: entityData.url ? "a" : "span",
            attributes: attributes,
            style: {}
        };
        return result;
    }
};
var CUSTOM_FONT_STRING = prefix + "FONT_FAMILY_";
var CUSTOM_FONT_WEIGHT_STRING = prefix + "FONT_WEIGHT_";
var htmlFromEditorState = function (editorState) {
    var exporterInlineStyles = exporter(editorState, customInlineStyleMap);
    // draft-js-custom-styles exporter returns malformed objects when the style name contains underscores
    // this occurs in custom fonts and because the key retains the full original string we're able to repair it here
    var sanitizedInlineStyles = {};
    Object.keys(exporterInlineStyles).forEach(function (key) {
        var styleStringArr = key.split(CUSTOM_FONT_STRING);
        if (styleStringArr[1] && styleStringArr[1].includes("_")) {
            sanitizedInlineStyles[key] = {
                style: { fontFamily: styleStringArr[1] }
            };
        }
        else {
            sanitizedInlineStyles[key] = exporterInlineStyles[key];
        }
    });
    var inlineStyles = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, sanitizedInlineStyles, customInlineElementStyleMap);
    var options = {
        defaultBlockTag: "div",
        inlineStyles: inlineStyles,
        blockStyleFn: exportBlockStyleFn,
        entityStyleFn: exportEntityStyleFn
    };
    var currentContent = editorState.getCurrentContent();
    // It might be possible to strip newline characters as part of the export itself instead of a regex.
    return Object(__WEBPACK_IMPORTED_MODULE_4_draft_js_export_html__["stateToHTML"])(currentContent, options).replace(/\n/gi, "");
};
var editorStateFromHtml = function (text) {
    var contentStateFromHTML = convertFromClassic(text);
    var element = document.createElement("span");
    element.innerHTML = text;
    var contentState = Object(__WEBPACK_IMPORTED_MODULE_3_draft_js_import_element__["a" /* stateFromElement */])(element, {
        customInlineFn: importFromHtmlCustomInlineFn,
        customBlockFn: importFromHtmlCustomBlockFn
    });
    return { contentStateFromHTML: contentStateFromHTML, contentState: contentState };
};



/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(1184);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BLOCK_TYPE", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ENTITY_TYPE", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "INLINE_STYLE", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Constants", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getEntityRanges__ = __webpack_require__(2713);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getEntityRanges", function() { return __WEBPACK_IMPORTED_MODULE_1__getEntityRanges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSelectedBlocks__ = __webpack_require__(691);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getSelectedBlocks", function() { return __WEBPACK_IMPORTED_MODULE_2__getSelectedBlocks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectionContainsEntity__ = __webpack_require__(2714);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "selectionContainsEntity", function() { return __WEBPACK_IMPORTED_MODULE_3__selectionContainsEntity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__callModifierForSelectedBlocks__ = __webpack_require__(2715);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "callModifierForSelectedBlocks", function() { return __WEBPACK_IMPORTED_MODULE_4__callModifierForSelectedBlocks__["a"]; });







/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns an array of all `ContentBlock` instances within two block keys
 *
 * @param  {object} contentState A draft.js `ContentState` instance
 * @param  {string} anchorKey    The block key to start searching from
 * @param  {string} focusKey     The block key until which to search
 *
 * @return {array} An array containing the found content blocks
 */
/* harmony default export */ __webpack_exports__["a"] = (function (contentState, anchorKey, focusKey) {
  var isSameBlock = anchorKey === focusKey;
  var startingBlock = contentState.getBlockForKey(anchorKey);

  if (!startingBlock) {
    return [];
  }

  var selectedBlocks = [startingBlock];

  if (!isSameBlock) {
    var blockKey = anchorKey;

    while (blockKey !== focusKey) {
      var nextBlock = contentState.getBlockAfter(blockKey);

      if (!nextBlock) {
        selectedBlocks = [];
        break;
      }

      selectedBlocks.push(nextBlock);
      blockKey = nextBlock.getKey();
    }
  }

  return selectedBlocks;
});

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(2791),
        DateUtil = __webpack_require__(120),
        Cookie = __webpack_require__(406);

    /**
     * @private @type {String}
     * The prefix for qualified cookie names.
     */
    var LOCKOUT = "lockout:";
    /**
     * @private @type {Number}
     * The default number of seconds to sleep between each view update, i.e. for ticking minutes during
     * a lockout.
     */
    var SLEEP = 6;
    /**
     * @private @type {Number}
     * The default number of seconds to lockout.
     */
    var DEFAULT_LOCKOUT_TIME = 5 * 60;

    /**
     * View for displaying a message about requests to a given (target, ip) being throttled, for example on
     * lockout because too many invalid credentials on the sign in view within a short time. <p>
     *
     * The view maintains a lockout timer internally, backed by cookies for the (target, ip) locked out in question.
     * When the target changes, the existing timer is cancelled, but the remaining lockout time is stored in a cookie,
     * to be restarted when the target changes back again. <p>
     *
     * On lockout start or cancel, this view will raise the "lockout" event with two arguments:
     * (lockout:Boolean, name:String). On lockout start, the <tt>lockout</tt> argument will be true,
     * and false on lockout cancel. The <tt>name</tt> is the qualified target in question.
     *
     * @class ThrottleView
     * @constructor
     *
     * @cfg {String}           [lockout]         The message to display during lockout; defaults to "You have made too
     *                                           many requests". Supported tags: $target and $minutes.
     * @cfg {String}           [retryAfter]      The text informing the user to "Please try again in $minutes minutes",
     *                                           which is the default. Supported tags: $target and $minutes.
     * @cfg {String}           [name]            Optional view name to include in the cookie name to distinguish it from
     *                                           other throttled views, i.e. if they have overlapping target values.
     * @cfg {jQuery}           [target]          An optional jQuery element supplying the current target to listen for.
     * @cfg {Function}         [validate]        A function to return true when the value from <tt>options.target</tt>
     *                                           is a valid target, for example an email validator to avoid checking
     *                                           targets that are not valid emails. Ignore if <tt>options.target</tt>
     *                                           is not specified.
     * @cfg {SequentialButton} [button]          A sequential button to disable, if any, while throttling is in effect,
     *                                           for example the "Sign In" button on the Sign In view.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    return ImprovedView.extend({

        /**
         * @private @type {{target:String, timer:Number}}
         * The current lockout timer ticking while lockout is in effect for a given target. <p>
         *
         * The old timer is cleared once a new target is used. The old timer can then be restarted again when the
         * target changes back, if ever, based on the remaining time stored in a cookie.
         */
        _lockoutTimer: null,
        /**
         * @private @type {Function}
         * A jQuery handler added to <tt>this.options.target</tt> to listen for "change" to update this view (optional).
         */
        _changeHandler: null,
        /**
         * @private @type {Function}
         * A jQuery handler added to <tt>this.options.target</tt> to listen for "keyup" to update this view (optional).
         */
        _keyUpHandler: null,

        template: template,

        ui: {
            throttle: ".throttle",
            lockout: ".lockout",
            retryAfter: ".retry-after"
        },

        /**
         * @private
         * Returns the cookie name for the specified target.
         *
         * @param {String} target The target; cannot be falsey.
         * @return {String} The qualified cookie name; never falsey.
         */
        _name: function _name(target) {
            var name = LOCKOUT;
            if (this.options.name) {
                name += this.options.name + ":";
            }
            return name + target;
        },

        /**
         * @private
         * Returns the current (valid) target value from the configured dom input element to supply target
         * values to handle throttling for.
         *
         * @return {String} The current (valid) target, or null.
         */
        _target: function _target() {
            var target = this.options.target && this.options.target.val();
            return !this.options.validate || this.options.validate(target) ? target : null;
        },

        /**
         * @private
         * Updates this view based on the specified target and seconds remaining of lockout.
         *
         * @param {String} target  The target in lockout; never falsey.
         * @param {Number} seconds The seconds remaining of the lockout for <tt>target</tt>; when <= 1, this view
         *                         will be cleared.
         *
         */
        _updateView: function _updateView(target, seconds) {
            if (!_.isNumber(seconds) || seconds < 1) {
                this._clearView();
                return;
            }

            var ms = Math.ceil(seconds / 60) * 60 * 1000,
                minutes = DateUtil.timeDifference(ms),
                inject = function inject(text) {
                return text.replace(/\$target/g, target).replace(/\$minutes/g, minutes);
            };

            // Set lockout message...
            this.ui.lockout.text(inject(this.options.lockout || "You have made too many requests."));
            // Set retry after message...
            this.ui.retryAfter.text(inject(this.options.retryAfter || "Please try again in $minutes."));
            // Show!
            this.ui.throttle.show();
        },

        /**
         * @private
         * Clears this view altogether (but not closed).
         */
        _clearView: function _clearView() {
            if (!this.isClosed) {
                this.ui.lockout.text("");
                this.ui.retryAfter.text("");
                this.ui.throttle.hide();
            }
        },

        //

        /**
         * @private
         * Clears the current running lockout timer, if any.
         */
        _clearLockoutTimer: function _clearLockoutTimer() {
            if (this._lockoutTimer) {
                clearTimeout(this._lockoutTimer);
                this._lockoutTimer = null;
            }
        },

        /**
         * @private
         * Sets the lockout timer to the number of specified seconds for the specified target; when elapsed,
         * the view will be cleared (no lockout message) and the configured sequential button, if any, will be
         * activated again. <p>
         *
         * @param {String} target  The target to set/clear the timer for; cannot be falsey.
         * @param {Number} seconds The number of seconds remaining of the lockout.
         *
         * @see #_clearLockoutTimer
         */
        _setLockoutTimer: function _setLockoutTimer(target, seconds) {
            var _this = this;

            // Lets run every 6 seconds (10 times a minute), so we do not skew the minute tick too much...
            seconds -= SLEEP;

            if (seconds < 1) {
                this.cancelLockout(target);
                return;
            }

            // Update view...
            this._updateView(target, seconds);

            // Same timestamp, but ensure it reflects the seconds left. This in conjunction with the
            // cookie life time is sufficient...
            Cookie.set(this._name(target), Date.now() + "_" + seconds, seconds / (60 * 60));

            this._lockoutTimer = setTimeout(function () {
                _this._setLockoutTimer(target, seconds);
            }, SLEEP * 1000);
        },

        // PUBLIC

        /**
         * Clears the lockout for the specified target.
         *
         * @param {String}  target       The target to cancel the lockout for; cannot be falsey.
         * @param {Boolean} [keepCookie] True to keep the cookie for the current target, false otherwise (default).
         */
        cancelLockout: function cancelLockout(target, keepCookie) {
            var name = this._name(target);
            if (!keepCookie) {
                Cookie.remove(name);
            }
            this._clearLockoutTimer();
            this._clearView();

            // Re-enable button...
            if (this.options.button) {
                this.options.button.enable(true);
            }
            // Trigger event...
            this.trigger("lockout", false, name);
        },

        /**
         * Checks to see if the supplied target has a cookie for lockout; if so, the lockout timer will
         * be started accordingly.
         *
         * @param  {String} target The target to check; cannot be falsey.
         * @return {Boolean} True if the timer has started, false otherwise.
         */
        checkLockout: function checkLockout(target) {
            var name = this._name(target),
                lockout = Cookie.get(name),
                timer = false;

            if (lockout) {
                // format: 'time since the epoch in ms' + "_" + 'seconds remaining of lockout'
                lockout = lockout.split("_", 2);
                var time = parseInt(lockout[0], 10),
                    seconds = parseInt(lockout[1], 10);

                if (!(_.isNaN(time) && _.isNaN(seconds))) {
                    // Start timer with remaining seconds...
                    seconds -= (Date.now() - time) / 1000;
                    if (seconds > 1) {
                        this.startLockout(target, seconds); // will also disable the configured button, if any...
                        timer = true;
                    }
                }
            }
            if (!timer) {
                this.cancelLockout(target);
            }
            return timer;
        },

        /**
         * @private
         * Returns the deduced xhr response from the supplied arguments, which is either an xhr as-is or an
         * <tt>Arguments</tt> object storing the response.
         *
         * @param  {Arguments|*} xhr The xhr response as-is, or an <tt>Arguments</tt> array storing it; a falsey value
         *                           will return null.
         * @return {*} The deduced xhr response, or null if not found.
         */
        _response: function _response(xhr) {
            if (xhr) {
                if (typeof xhr.status !== "undefined") {
                    // can actually be 0 on client errors
                    return xhr;
                }
                var i, v; // Arguments

                for (i = 0; i < xhr.length; i++) {
                    v = xhr[i];
                    if (v && typeof v.status !== "undefined") {
                        return v;
                    }
                }
            }
            return null;
        },

        /**
         * Checks the supplied http response to see if the status code indicates throttling (429), in which case
         * a lockout is started for the supplied target. Any other status code will cause a cancelling of the
         * lockout. <p>
         *
         * This function is typically called from an ajax deferred <tt>done()</tt>, <tt>fail()</tt>, and/or
         * <tt>always()</tt> handler. These hooks supply the xhr response in different order, which is why the
         * entire <tt>Arguments</tt> array can be supplied from where the xhr response will be found. <p>
         *
         * Example: consider a view that uses this throttle view to display lockout messages, stored in the private
         * variable <tt>_throttleView</tt> shown in some region. Then, when a potentially throttle API endpoint is
         * called via ajax, call this function in the <tt>always()</tt> handler like:
         * <pre>
         *   ..
         *   // Some view using this throttle view in some region...
         *   this._throttleView = ..; // assumed setup onRender/onShow, one-time thing...
         *   ..
         *
         *   // Potentially throttled endpoint...
         *   this._callApi = function (target, ..) {
         *      // Assume "target" is used in ajax request, for example an email...
         *      return $.ajax({..})
         *         .done(..)
         *         .fail(..)
         *         .always(function () {
         *            if (this._throttleView.checkResponse(target, arguments)) {
         *               // optionally do stuff if throttling/lockout is in effect...
         *               ..
         *            }
         *         }.bind(this));
         *   };
         *   ..
         * </pre>
         *
         * @param  {String}              target The target to check; cannot be falsey.
         * @param  {Promise|Arguments|*} xhr    The response as-is, or the the arguments to find the xhr response in,
         *                                      e.g. from a deferred handler like <tt>always()</tt>, from which the
         *                                      status code will be checked for throttling in effect (429); cannot be
         *                                      falsey.
         * @return {Boolean} True if a lockout has now been started, false otherwise.
         */
        checkResponse: function checkResponse(target, xhr) {
            // xhr be something else entirely on chained/nested deferreds, for example a resolved principal. So,
            // if we cannot find the request, we assume success since an actual value is resolved...
            xhr = this._response(xhr);
            if (!xhr || xhr.status !== 429) {
                this.cancelLockout(target, true);
                return false;
            }
            this.startLockout(target, parseInt(xhr.getResponseHeader("Retry-After"), 10));
            return true;
        },

        /**
         * Adds an <tt>always()</tt> callback to the supplied ajax promise that will check the http response to see
         * if the status code indicates throttling (429), in which case a lockout is started for the supplied target.
         * Any other status code will cause a cancelling of the lockout. <p>
         *
         * The response status code is checked using <tt>checkResponse</tt>.
         *
         * @param  {String}  target  The target to check; cannot be falsey.
         * @param  {Promise} promise The ajax promise to eventually check the response for; cannot be falsey.
         * @return {Promise} <tt>promise</tt>, now with an <tt>always()</tt> callback that will check the response.
         */
        checkPromise: function checkPromise(target, promise) {
            return promise.always(function () {
                return this.checkResponse(target, arguments);
            }.bind(this));
        },

        /**
         * Starts a lockout for the specified target for the specified number of seconds.
         *
         * @param {String} target    The target to start the lockout for; cannot be falsey.
         * @param {Number} [seconds] The lockout time in seconds; will default to 300 seconds, i.e. 5 minutes.
         */
        startLockout: function startLockout(target, seconds) {
            if (this.options.button) {
                this.options.button.enable(false);
            }
            // Trigger event...
            this.trigger("lockout", true, this._name(target));

            this._setLockoutTimer(target, seconds || DEFAULT_LOCKOUT_TIME);
        },

        //

        onRender: function onRender() {
            this._clearView();

            if (this.options.target) {
                this._changeHandler = function () {
                    var target = this._target();
                    if (target) {
                        this.checkLockout(target);
                    }
                }.bind(this);

                this._keyUpHandler = function () {
                    var target = this._target();
                    if (target) {
                        this.cancelLockout(target, true); // keep cookie
                    }
                }.bind(this);

                this.options.target.on("change", this._changeHandler);
                this.options.target.on("keyup", this._keyUpHandler);

                // Check initial target value, if any...
                var target = this._target();
                if (target) {
                    this.checkLockout(target);
                }
            }
        },

        /**
         * Closes this view, clearing any running lockout timer.
         */
        onClose: function onClose() {
            this._clearLockoutTimer();
            if (this._changeHandler) {
                this.options.target.off("change", this._changeHandler);
                this._changeHandler = null;
            }
            if (this._keyUpHandler) {
                this.options.target.off("keyup", this._keyUpHandler);
                this._keyUpHandler = null;
            }
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var MAX_LENGTH = 256;
    var MIN_LENGTH = 8;
    var SPECIAL_CHARS = "`~!@#$%^&*()_\\-+={}[\\]|:;\"'<>,.?/\\\\";
    var LOWER_CASE = "(?=.*[a-z])";
    var UPPER_CASE = "(?=.*[A-Z])";
    var DIGIT = "(?=.*\\d)";
    var SPECIAL_CHAR = "(?=.*[" + SPECIAL_CHARS + "])";
    var LENGTH = ".{" + MIN_LENGTH + "," + MAX_LENGTH + "}";
    var LENGTH_PATTERN = new RegExp(LENGTH);
    var LOWER_CASE_PATTERN = new RegExp(LOWER_CASE);
    var UPPER_CASE_PATTERN = new RegExp(UPPER_CASE);
    var DIGIT_PATTERN = new RegExp(DIGIT);
    var SPECIAL_CHAR_PATTERN = new RegExp(SPECIAL_CHAR);
    var VALIDATION_PATTERN = new RegExp(LOWER_CASE + UPPER_CASE + DIGIT + SPECIAL_CHAR + LENGTH);

    /**
     * Validates the quality of a password.
     * <p>
     * Validates using the following rules:
     * <li>Must include at least one English upper case letter (e.g., A, B, C, ...Z)
     * <li>Must include at least one English lower case letter (e.g., a, b, c, ...z)
     * <li>Must include at least one Westernized Arabic numeral (e.g., 1, 2, ...9)
     * <li>Must include at least one Non-alphanumeric ("special characters”) (e.g., ?,!,%,$,#, etc)
     * <li>Minimum 8 characters
     * <li>Maximum 256 characters
     *
     * @class PasswordQualityValidator
     * @author Poul Henriksen
     */
    return {

        /**
         * Checks whether the given password is valid.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password is good enough.
         */
        isValid: function isValid(password) {
            return VALIDATION_PATTERN.test(password);
        },


        /**
         * Checks whether the given password contains at least one lower case character.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password contains a lower case character.
         */
        containsLowerCase: function containsLowerCase(password) {
            return LOWER_CASE_PATTERN.test(password);
        },


        /**
         * Checks whether the given password contains at least one upper case character.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password contains an upper case character.
         */
        containsUpperCase: function containsUpperCase(password) {
            return UPPER_CASE_PATTERN.test(password);
        },


        /**
         * Checks whether the given password contains at least one digit.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password contains a digit.
         */
        containsDigit: function containsDigit(password) {
            return DIGIT_PATTERN.test(password);
        },


        /**
         * Checks whether the given password contains at least one special character.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password contains a special character.
         */
        containsSpecialCharacters: function containsSpecialCharacters(password) {
            return SPECIAL_CHAR_PATTERN.test(password);
        },


        /**
         * Checks whether the given password has the minimum required length.
         * @param {String} password The password to check.
         * @returns {boolean} Whether the password has the minimum required length.
         */
        hasMinimumLength: function hasMinimumLength(password) {
            return LENGTH_PATTERN.test(password);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__(2806),
      utf8 = __webpack_require__(1186).utf8,
      isBuffer = __webpack_require__(2807),
      bin = __webpack_require__(1186).bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message) && message.constructor !== Uint8Array)
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25),
        Backbone = __webpack_require__(7),
        _ = __webpack_require__(1),
        Preconditions = __webpack_require__(14),
        RestApi = __webpack_require__(29),
        SyncManager = __webpack_require__(44),
        Permissions = __webpack_require__(22),
        ProjectAsset = __webpack_require__(283),
        ProjectAssetCollection = __webpack_require__(2824);

    /**
     * Represents a project.
     *
     * @class Project
     * @constructor
     */
    return ImprovedModel.extend("Project", {

        defaults: {

            /**
             * The project name.
             *
             * @type {String}
             */
            name: "Untitled Project",

            /**
             * The project assets.
             *
             * @type {ProjectAssetCollection}
             */
            assets: [],

            /**
             * The inferred project assets.
             *
             * @type {ProjectAssetCollection}
             */
            inferredAssets: []
        },

        relations: [{
            type: Backbone.Many,
            key: "assets",
            collectionType: ProjectAssetCollection,
            reverseRelation: {
                key: "project"
            }
        }, {
            type: Backbone.Many,
            key: "inferredAssets",
            collectionType: ProjectAssetCollection
        }],

        // This are collections, so we will update them entirely! We have to update "assets" as well as it
        // will contain all "interredAssets"...
        updateOnSync: ["assets", "inferredAssets"],

        url: function url() {
            return this.isNew() ? RestApi.pathToCollection(RestApi.Collections.PROJECTS) : RestApi.pathToSpecificResource(RestApi.Collections.PROJECTS, this.get("id"));
        },

        /**
         * Attaches models to a project and saves it.
         * @param {ImprovedModel | ImprovedModel[]} model
         * @returns {*|Promise}
         */
        attach: function attach(model) {
            var options = this._syncOptions("attach");
            options.privilege = Permissions.Privileges.CREATE;

            return SyncManager.sync(options, this, model).promise();
        },

        /**
         * Detaches models to a project and saves it.
         * @param {ImprovedModel | ImprovedModel[]} model
         * @returns {*|Promise}
         */
        detach: function detach(model) {
            var options = this._syncOptions("detach");
            options.privilege = Permissions.Privileges.CREATE;

            return SyncManager.sync(options, this, model).promise();
        },

        /**
         * @private
         *
         * Attaches an asset, or assets, to this project, which gets saved. For convenience specified by model.
         *
         * @param {ImprovedModel|ImprovedModel[]|Backbone.Collection} model The model, or array of models, representing the asset(s).
         *
         * @returns {Promise}
         */
        _attach: function _attach(model) {
            Preconditions.checkArgument(model);

            // Normalize to array
            var models = ProjectAsset.toArray(model),
                assets = this.get("assets");

            // Add the assets for each model
            _.each(models, assets.addModel.bind(assets));

            return this.save();
        },

        /**
         * Detaches an asset, or assets, from this project, which gets saved. For convenience specified by model.
         *
         * @param {ImprovedModel|ImprovedModel[]|Backbone.Collection} model The model, or array of models, representing the asset(s).
         *
         * @returns {Promise}
         */
        _detach: function _detach(model) {
            Preconditions.checkArgument(model);

            // Normalize to array
            var models = ProjectAsset.toArray(model),
                assets = this.get("assets");

            // Add the assets by their respective type
            _.each(models, function (model) {
                assets.removeModel(model);
            });

            return this.save();
        },

        /**
         * Clears/removes any assets by the specified type, e.g. <tt>ProjectAsset.Type.EXPERIENCE</tt>.
         *
         * If no type is specified, all assets are removed, i.e. the asset collection is "reset".
         *
         * @param  {String} type Optional, the asset type, as a <tt>ProjectAsset.Type.XXX</tt> constant value.
         */
        clear: function clear(type) {
            var assets = this.get("assets");

            if (!type) {
                return assets.reset();
            }

            Preconditions.isString(type);

            assets.remove(this.byType(type));
        },

        /**
         * Convenience method for getting an array of <tt>ProjectAsset</tt>, all with type <tt>ProjectAsset.Type.EXPERIENCE</tt>.
         *
         * @return {ProjectAsset[]} Array of <tt>ProjectAsset</tt>'s.
         * @see  #byType
         */
        experiences: function experiences() {
            return this.byType(ProjectAsset.Type.EXPERIENCE);
        },

        /**
         * Convenience method for getting an array of <tt>ProjectAsset</tt>, all with type <tt>ProjectAsset.Type.GROUP</tt>.
         *
         * @return {ProjectAsset[]} Array of <tt>ProjectAsset</tt>'s.
         * @see  #byType
         */
        groups: function groups() {
            var breakpoints = this.byType(ProjectAsset.Type.BREAKPOINTGROUP),
                localizations = this.byType(ProjectAsset.Type.LOCALIZATIONGROUP);

            return breakpoints.concat(localizations);
        },

        /**
         * Convenience method for getting an array of "publishables", i.e. experiences and groups.
         *
         * @return {ProjectAsset[]} Array of <tt>ProjectAsset</tt>'s.
         * @see  #byType
         */
        publishables: function publishables() {
            return this.experiences().concat(this.groups());
        },

        /**
         * Convenience method for getting an array of <tt>ProjectAsset</tt>, all with type <tt>ProjectAsset.Type.IMAGE</tt>.
         *
         * @return {ProjectAsset[]} Array of <tt>ProjectAsset</tt>'s.
         * @see  #byType
         */
        images: function images() {
            return this.byType(ProjectAsset.Type.IMAGE);
        },

        /**
         * Convenience method for getting an array of <tt>ProjectAsset</tt>, all with type <tt>ProjectAsset.Type.CHANNEL</tt>.
         *
         * @return {ProjectAsset[]} Array of <tt>ProjectAsset</tt>'s.
         * @see  #byType
         */
        channels: function channels() {
            return this.byType(ProjectAsset.Type.CHANNEL);
        },

        containsGroup: function containsGroup(resourceId) {
            return this.get("assets").containsGroup(resourceId);
        },

        containsExperience: function containsExperience(resourceId) {
            return this.get("assets").containsExperience(resourceId);
        },

        containsImage: function containsImage(resourceId) {
            return this.get("assets").containsImage(resourceId);
        },

        containsChannel: function containsChannel(resourceId) {
            return this.get("assets").containsChannel(resourceId);
        },

        containsInferredAsset: function containsInferredAsset(resourceId) {
            return this.get("inferredAssets").find(function (asset) {
                return asset.get("resourceId") === resourceId;
            }) !== undefined;
        },

        /**
         * Returns an array of <tt>ProjectAsset</tt>'s with the specified type.
         *
         * @param  {String} type The asset type, as a <tt>ProjectAsset.Type.XXX</tt> constant value.
         * @return {ProjectAsset[]} Array of <tt>ProjectAsset</tt>'s.
         */
        byType: function byType(type) {
            Preconditions.checkState(ProjectAsset.validType(type), "Invalid asset type: " + type);

            return this.get("assets").byType(type);
        },

        fromModel: function fromModel(model) {
            return ProjectAsset.typeFromModel(model);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var ContentQuery = __webpack_require__(139);

    /**
     * A wrapper for ContentQuery Sorting items.
     *
     * @class Sorting
     */
    return Class.extend("Sorting", {
        constructor: function constructor(value, queryItems) {
            var query = ContentQuery.sort();
            queryItems.forEach(function (queryItem) {
                // The query method takes care of defaults
                var name = queryItem.name,
                    direction = queryItem.direction;
                // If we passed in parameterized queryItem use that.

                name = name || queryItem;
                query = query.field(name, direction);
            });

            this.value = value;
            this.query = query;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ChunkingCollection = __webpack_require__(400);
    var SyncManager = __webpack_require__(44);
    var RestApi = __webpack_require__(29);
    var Channel = __webpack_require__(233);

    /**
     * Represents a (chunking) collection of channels, supporting "lazy loading".
     *
     * @see  ChunkingCollection
     * @class ChannelCollection
     */
    var ChannelCollection = ChunkingCollection.extend("ChannelCollection", {

        model: Channel,

        url: function url() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (options.project) {
                // projects/{PROJECT_ID}/channels
                return RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, options.project.get("id"), RestApi.Collections.CHANNELS);
            }

            return RestApi.pathToCollection(RestApi.Collections.CHANNELS);
        }
    }, {

        /**
         * Counts the total amount of (the logged in principal's) channels.
         *
         * @param  {Object}         options Options set of options.
         * @param  {ProjectModel}   options.project A <tt>ProjectModel</tt> - for counting all project specific channels.
         * @return {Promise}        A <tt>Promise</tt> that resolves with the total number of (the logged in principal's) channels.
         */
        count: function count() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var url = RestApi.Collections.CHANNELS_COUNT;
            var project = options && options.project;

            if (project) {
                // projects/{ID}/channels/count
                url = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.CHANNELS_COUNT);
            }

            return SyncManager.get(url, SyncManager.target("ChannelCollection.count"));
        }
    });

    return ChannelCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        find = _require.find;

    var Preconditions = __webpack_require__(14);
    var Storage = __webpack_require__(34);

    var SORTING_KEY = "sorting";
    var SOURCE_KEY = "source";

    /**
     * Provides the sorting options for the image library views.
     *
     * @see ImageLibraryView
     */
    return {

        /**
         * @returns {ImageLibrarySorting}
         */
        provide: function provide(_ref) {
            var sources = _ref.sources,
                _ref$storage = _ref.storage,
                storage = _ref$storage === undefined ? Storage.Local : _ref$storage;

            Preconditions.checkState(Array.isArray(sources) && sources.length > 0, "Missing sources in the image library sorting provider");

            return {

                /**
                 * Return an array of the provided source items (such as creator, scene7, etc.)
                 *
                 * @return {Array} Array of source items
                 */
                getSourceItems: function getSourceItems() {
                    return sources.map(function (sourceItem) {
                        return sourceItem.source;
                    });
                },


                /**
                 * Verifies specified source and returns it if valid.
                 * Defaults to the first item in the sources.
                 *
                 * @return {ImageLibrarySourceEnum} ImageLibrarySourceEnum constant
                 */
                getInitialSource: function getInitialSource(source) {
                    var sourceItems = this.getSourceItems();
                    var foundSource = find(sourceItems, function (sourceItem) {
                        return sourceItem === source;
                    });
                    var fallbackSource = sources[0].source;

                    if (!foundSource) {
                        this.setSelectedSource(fallbackSource);
                        return fallbackSource;
                    }

                    return foundSource;
                },


                /**
                 * Return the selected source in the localStorage
                 * Defaults to the first item in the sources.
                 *
                 * @return {ImageLibrarySourceEnum} ImageLibrarySourceEnum constant
                 */
                getSelectedSource: function getSelectedSource() {
                    var storedSourceName = storage.get(Storage.Keys.IMAGE_LIBRARY_SORTING_PANEL, SOURCE_KEY);
                    var currentSource = this.lookupSourceName(storedSourceName);
                    return currentSource || sources[0].source;
                },


                /**
                 * Updates the provided storage with the name value of the given source
                 *
                 * @param  {ImageLibrarySourceEnum} source A ImageLibrarySourceEnum constant
                 */
                setSelectedSource: function setSelectedSource(source) {
                    var sourceItems = this.getSourceItems();
                    Preconditions.checkState(sourceItems.indexOf(source) > -1);
                    storage.update(Storage.Keys.IMAGE_LIBRARY_SORTING_PANEL, SOURCE_KEY, source.name);
                },


                /**
                 * Returns ImageLibrarySourceEnum constant containing the given source name value
                 *
                 * @param  {String} sourceName A valid name among the constants in ImageLibrarySourceEnum
                 * @return {ImageLibrarySourceEnum} ImageLibrarySourceEnum constant if found otherwise undefined
                 */
                lookupSourceName: function lookupSourceName(sourceName) {
                    var sourceItems = this.getSourceItems();
                    return find(sourceItems, function (sourceItem) {
                        return sourceItem.name === sourceName;
                    });
                },


                /**
                 * Return the sorting items of a given source
                 *
                 * @param  {ImageLibrarySourceEnum} constant A valid source constant in ImageLibrarySourceEnum
                 * @return {Array} Array of sorting items in the source, if the source was found otherwise undefined
                 */
                getSortingItemsFromSource: function getSortingItemsFromSource(source) {
                    var sourceMatch = find(sources, function (sourceItem) {
                        return sourceItem.source === source;
                    });
                    return sourceMatch && sourceMatch.sorting;
                },


                /**
                 * Returns the sorting items in the selected source
                 *
                 * @return {Array} Array of ImageLibrarySortingEnum constants if found otherwise undefined
                 */
                getSortingItems: function getSortingItems() {
                    var source = this.getSelectedSource();
                    var sorting = this.getSortingItemsFromSource(source);
                    return sorting;
                },


                /**
                 * Returns the selected sorting item in the selected source
                 *
                 * @return {ImageLibrarySortingEnum} ImageLibrarySortingEnum constant if found, defaults to Last Uploaded
                 */
                getSelectedSorting: function getSelectedSorting() {
                    var storedSortingName = storage.get(Storage.Keys.IMAGE_LIBRARY_SORTING_PANEL, SORTING_KEY);
                    var currentSorting = this.lookupSortingName(storedSortingName);
                    return currentSorting || sources[0].sorting[0];
                },


                /**
                 * Set the selected sorting to a valid sorting item name
                 *
                 * @param  {ImageLibrarySortingEnum} constant A valid sorting constant in ImageLibrarySortingEnum
                 */
                setSelectedSorting: function setSelectedSorting(sorting) {
                    var sortingItems = this.getSortingItems();
                    Preconditions.checkState(sortingItems.indexOf(sorting) > -1);
                    storage.update(Storage.Keys.IMAGE_LIBRARY_SORTING_PANEL, SORTING_KEY, sorting.name);
                },


                /**
                 * Return the sorting based on a sorting name
                 *
                 * @param  {String} name A valid sorting name value in a ImageLibrarySortingEnum constant
                 * @param  {ImageLibrarySourceEnum} source A provided source from ImageLibrarySortingEnum
                 * @return {ImageLibrarySortingEnum} constant if the source found otherwise undefined
                 */
                lookupSortingName: function lookupSortingName(name, source) {
                    var sorting = void 0;

                    if (source) {
                        var sourceMatch = find(sources, function (sourceSortingItem) {
                            return sourceSortingItem.source === source;
                        });
                        sorting = sourceMatch ? sourceMatch.sorting : [];
                    } else {
                        sorting = this.getSortingItems();
                    }

                    return find(sorting, function (sortingItem) {
                        return sortingItem.name === name;
                    });
                },


                /**
                 * Return the sorting based on a sorting name
                 *
                 * @return {ImageLibrarySortingEnum} constant The first sorting item in the selected source
                 */
                getDefaultSorting: function getDefaultSorting() {
                    var sortingItems = this.getSortingItems();
                    return sortingItems && sortingItems[0];
                }
            };
        },


        SORTING_KEY: SORTING_KEY,
        SOURCE_KEY: SOURCE_KEY
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Publishables = __webpack_require__(462);
    var Promise = __webpack_require__(21);
    var ChannelCollection = __webpack_require__(697);
    var LoggedInUserState = __webpack_require__(19);
    var ChannelConfig = __webpack_require__(1193);
    var ContentQuery = __webpack_require__(139);
    var Channel = __webpack_require__(233);

    return {

        /**
         * Provides channel configs for the company of the logged in user.
         * @return {Promise} promise that resolves with an object with the properties about publishables, channel config and channels information.
         */
        provide: function provide() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var channelCollection = new ChannelCollection(options);
            var query = options.sorting || ContentQuery.sort().field("editedAt");
            var channelConfig = options.fetchChannelConfig && new ChannelConfig();
            var promises = [channelCollection.query(query), Channel.hasUnPushedChannels()];

            if (channelConfig) {
                promises.push(channelConfig.fetch());
            }

            return Promise.all(promises).then(function (results) {
                var companySettings = LoggedInUserState.get("companySettings");
                var bundleStrategy = companySettings.get("bundleStrategy");
                var channelConfigId = companySettings.get("channelConfigId");
                var hasUnPushedChannels = results[1][0];

                // Execute this fetch after channels. Having it executed in parallel may lead to unforeseen memory leaks in backend as channels and publishables are related to each other.
                return Publishables.fetch(options).then(function (publishableOptions) {
                    var publishableCollection = publishableOptions.publishableCollection,
                        publishableDescriptors = publishableOptions.publishableDescriptors;

                    return {
                        bundleStrategy: bundleStrategy,
                        channelConfigId: channelConfigId,
                        channelCollection: channelCollection,
                        channelConfig: channelConfig,
                        publishableCollection: publishableCollection,
                        publishableDescriptors: publishableDescriptors,
                        hasUnPushedChannels: hasUnPushedChannels
                    };
                });
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        extend = _require.extend,
        result = _require.result;

    var Channel = __webpack_require__(233);
    var ChannelSetupManualViewController = __webpack_require__(2837);
    var Promise = __webpack_require__(21);
    var EditorEvents = __webpack_require__(17);
    var ContentQuery = __webpack_require__(139);
    var SequentialButton = __webpack_require__(112);
    var SystemMessages = __webpack_require__(107);
    var template = __webpack_require__(2845);
    var ChannelChangesInfo = __webpack_require__(2846);
    var ImprovedView = __webpack_require__(6);
    var ChannelCollectionView = __webpack_require__(2847);
    var NotificationBar = __webpack_require__(53);

    /**
     * View of all the channels, showing the channels in a list, and the buttons to add a new channel and to publish
     * (which will be disabled if insufficient privileges).
     *
     */
    return ImprovedView.extend("ChannelSetupManualView", {

        template: template,

        channelChangesInfo: null,

        controller: ChannelSetupManualViewController,

        regions: {
            contentRegion: ".content"
        },

        ui: {
            createNewSlot: ".create-new-slot",
            saveAndPublishChannelsButton: "#publish-channels",
            channelItems: ".channel-items"
        },

        initialize: function initialize() {
            this.options = extend(this.options, this.viewOptions || {});
            this.channelChangesInfo = new ChannelChangesInfo();
        },


        events: {
            "click @ui.createNewSlot": "_createNewSlotClickHandler",
            "click @ui.saveAndPublishChannelsButton": "_saveAndPublishChannelsClickHandler"
        },

        templateHelpers: function templateHelpers() {
            var _options = this.options,
                allowedToPublish = _options.allowedToPublish,
                showAttachButton = _options.showAttachButton,
                showCreateSlotField = _options.showCreateSlotField,
                showPublishButton = _options.showPublishButton,
                showAttachActions = _options.showAttachActions,
                showAttachHeader = _options.showAttachHeader,
                showCreateSlotInProjectLabel = _options.showCreateSlotInProjectLabel;

            return {
                attachHeader: "All Slots",
                itemCount: this.collection.length(),
                allowedToPublish: allowedToPublish,
                showAttachButton: showAttachButton,
                showCreateSlotField: showCreateSlotField,
                showPublishButton: showPublishButton,
                showAttachActions: showAttachActions,
                showAttachHeader: showAttachHeader,
                showCreateSlotInProjectLabel: showCreateSlotInProjectLabel
            };
        },
        onRender: function onRender() {
            var _this = this;

            this._handleUnPushedChannels(this.options.hasUnPushedChannels);

            this._saveAndPublishChannelsButton = SequentialButton.add(this.ui.saveAndPublishChannelsButton, function () {
                _this._trackEditorEvent();

                var purgeTime = null;

                return _this.channelChangesInfo.applyChanges().then(function () {
                    return Channel.push();
                }).then(function (channelPushResponse) {
                    purgeTime = channelPushResponse[0].purgeTime;
                    _this.options.hasUnPushedChannels = false;
                    return _this._syncProjectContext();
                }).then(function () {
                    return _this.refresh();
                }).done(function () {
                    // remove un-pushed notification bar if open
                    if (_this._unPushedNotificationBarId) {
                        NotificationBar.close({ id: _this._unPushedNotificationBarId, clear: "self" });
                    }

                    // Update the Channels counter.
                    _this.collection.trigger("sync:state");
                    // Notify the user that a purge has been initiated
                    SystemMessages.notifyPurge("Changes", "saved", purgeTime, true);

                    _this.channelChangesInfo.clear();
                    _this.shouldButtonChange();
                });
            });
        },
        onShow: function onShow() {
            var _this2 = this;

            var _options2 = this.options,
                project = _options2.project,
                collection = _options2.collection,
                collectionViewOptions = _options2.collectionViewOptions;


            var channelCollectionViewOptions = extend({
                collection: collection,
                itemViewOptions: function itemViewOptions() {
                    var _options3 = _this2.options,
                        node = _options3.node,
                        publishableDescriptors = _options3.publishableDescriptors,
                        initialPublishables = _options3.initialPublishables,
                        publishableCollection = _options3.publishableCollection,
                        groups = _options3.groups,
                        allowedToPublish = _options3.allowedToPublish,
                        hasUnPushedChannels = _options3.hasUnPushedChannels;
                    // Since most of options are needed, we just return all options for simplicity.

                    return extend(_this2.options, {
                        channelChangesInfo: _this2.channelChangesInfo,
                        node: node,
                        publishableDescriptors: publishableDescriptors,
                        initialPublishables: initialPublishables,
                        publishableCollection: publishableCollection,
                        groups: groups,
                        allowedToPublish: allowedToPublish,
                        hasUnPushedChannels: hasUnPushedChannels,
                        parentView: _this2
                    });
                },
                horizontalBuffer: 200,
                scrollTarget: this._determineScrollTarget()
            }, collectionViewOptions || this.collectionViewOptions);

            if (project) {
                this.collection.options.project = project;
            }

            this._collectionView = new ChannelCollectionView(channelCollectionViewOptions);
            this.contentRegion.show(this._collectionView);
        },
        shouldButtonChange: function shouldButtonChange(hasUnPushedChannels) {
            var hasChannelBeenModified = this.channelChangesInfo.hasAny() || hasUnPushedChannels; // added/removed/edited
            this.ui.saveAndPublishChannelsButton.toggleClass("unsaved-changes", hasChannelBeenModified);
        },
        refresh: function refresh() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var query = options.sorting || ContentQuery.sort().field("editedAt");
            return this.collection.query(query);
        },
        _handleUnPushedChannels: function _handleUnPushedChannels(hasUnPushedChanges) {
            if (hasUnPushedChanges) {
                this._unPushedNotificationBarId = NotificationBar.open("There are unpushed slots. Please click the Save/Publish button to re-push them.", { closeable: true });
                this.shouldButtonChange(hasUnPushedChanges);

                var eventProperties = {
                    type: "UnPushedChannels",
                    triggerOrigin: "NotificationBar"
                };

                EditorEvents.trigger(EditorEvents.constants.ERROR, eventProperties);
            }
        },


        /**
         * @private
         *
         * Keeps the project in sync, if any, reflecting the current collection, i.e. <tt>this.collection</tt>.
         *
         * @return {Promise} A promise that resolves once the project is synced. A resolved promise
         *                   is returned if we're not in a project context.
         */
        _syncProjectContext: function _syncProjectContext() {
            var _this3 = this;

            var projectContext = this.options.projectContext;

            // Handle project, if any...
            if (projectContext) {
                // Fetch project first to avoid potential versioning issues...
                return projectContext.project.fetch().then(function () {
                    return projectContext.attach(_this3.collection.models());
                });
            }

            return Promise.resolved();
        },
        _trackEditorEvent: function _trackEditorEvent() {
            var projectContext = this.options.projectContext;
            var channels = this.channelChangesInfo.asList().map(function (channel) {
                return channel.get("name");
            });

            var eventProperties = {
                channels: channels,
                triggerOrigin: "SaveAndPublishButton",
                dragAnDrop: false,
                manual: true,
                projectId: projectContext && projectContext.project.get("id")
            };

            EditorEvents.trigger(EditorEvents.constants.PUBLISH_CHANNEL, eventProperties);
        },
        _determineScrollTarget: function _determineScrollTarget() {
            var scrollTarget = result(this.options, "scrollTarget") || result(this.viewScope, "scrollTarget");

            return scrollTarget || this.ui.channelItems;
        },
        _createNewSlotClickHandler: function _createNewSlotClickHandler() {
            this.trigger("createNewSlotOpened");
        },
        _saveAndPublishChannelsClickHandler: function _saveAndPublishChannelsClickHandler() {
            this._saveAndPublishChannelsButton();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var ChannelSetupItemViewController = __webpack_require__(2848);

    var _require = __webpack_require__(120),
        DateUtil = _require.DateUtil;

    var EditorEvents = __webpack_require__(17);
    var Marionette = __webpack_require__(10);
    var PublishUtil = __webpack_require__(234);
    var template = __webpack_require__(2849);
    var Tooltip = __webpack_require__(35);

    var NONE_SIGN = "-";

    /**
     * Item View of a channel, showing the currently live experience, the next experience and the next
     * experience go-live date.
     *
     * @author Antonio "The Publisher" Lagrotteria & Kim "Robin" Knudsen.
     */
    return Marionette.ItemView.extend("ChannelSetupItemView", {

        className: "channel-setup-item-view",

        template: template,

        controller: ChannelSetupItemViewController,

        _allowedToPublish: null,

        /**
         * Used to prevent opening of multiple lightboxes when double clicking the Channel Slot.
         */
        _isLightboxOpening: false,

        templateHelpers: function templateHelpers() {
            return {
                id: this.model.identifier(),
                allowedToPublish: this._allowedToPublish
            };
        },
        initialize: function initialize(options) {
            this._node = options.node; // function!
            this._allowedToPublish = options.allowedToPublish;
        },


        ui: {
            slotName: ".slot-name",
            deleteChannel: ".delete",
            liveDate: ".live-date"
        },

        events: {
            "click @ui.deleteChannel": "_deleteChannelClickHandler",
            "click": "_clickHandler"
        },

        modelEvents: {
            // Re-render when switching between experiences and groups...
            "change:experience change:group": "render",

            // Hack to re-render on "schedules" changes, as above, this is needed when switching between
            // experiences and groups...
            "change:schedules": "render",

            // Re-render channel on sync (E.g.: when clicking Refresh upon error).
            "sync:state": "render"
        },

        bindings: {
            ".slot-name": "name",

            ".live": {
                observe: ["experience", "group"],
                onGet: function onGet(values) {
                    var model = values[0] || values[1];

                    return model ? model.publishableDisplayName() : NONE_SIGN;
                }
            },

            ".next": {
                observe: "schedules",
                onGet: function onGet(schedules) {
                    var schedule = schedules ? schedules[0] : null;

                    if (schedule) {
                        if (schedule.takeDownCurrent) {
                            return PublishUtil.NO_EXPERIENCE_SCHEDULED.name;
                        }

                        var model = schedule.publishable;

                        // FIXME: For some odd reason, schedules can end up containing raw
                        // objects (probably an issue with computed properties on the ImprovedModel and array types?)
                        return model && model.publishableDisplayName ? model.publishableDisplayName() : NONE_SIGN;
                    }

                    return NONE_SIGN;
                }
            },

            ".live-date": {
                observe: "schedules",
                onGet: function onGet(val) {
                    if (val && val[0] && val[0].startTime) {
                        return DateUtil.formatYYYYMMDDHHmm(val[0].startTime);
                    }

                    return NONE_SIGN;
                }
            },

            // These 4 keep the tooltip in sync...
            ".channel-tooltip .editedat": {
                observe: "editedAt",
                onGet: function onGet(date) {
                    return DateUtil.formatYYYYMMDDHHmm(date || this.model.get("createdAt"));
                }
            },

            ".channel-tooltip .url": {
                observe: "url",
                onGet: function onGet(val) {
                    return val || NONE_SIGN;
                }
            },

            ".channel-tooltip .selector": {
                observe: "selector",
                onGet: function onGet(val) {
                    return val || NONE_SIGN;
                }
            }
        },

        _deleteChannelClickHandler: function _deleteChannelClickHandler(event) {
            event.stopPropagation();

            if (this._allowedToPublish && window.confirm("Are you sure you want to delete this Slot?")) {
                var projectContext = this.options.projectContext;

                this.options.parentView.trigger("handleChanges", "delete", this.model);

                var eventProperties = PublishUtil.buildEventProperties({
                    channel: this.model,
                    triggerOrigin: "DeleteChannelButton",
                    dragAndDrop: false,
                    manual: true,
                    projectId: projectContext && projectContext.project.get("id")
                });

                EditorEvents.trigger(EditorEvents.constants.DELETE_CHANNEL, eventProperties);
            }
        },
        _clickHandler: function _clickHandler(_ref) {
            var target = _ref.target;

            this._triggerEditOpened(target);
        },


        /**
         * Overridden in project class.
         * @see ProjectAttachChannelSetupItemView.
         */
        _triggerEditOpened: function _triggerEditOpened(target) {
            if (this._isLightboxOpening) {
                return;
            }

            var className = target ? target.className : "";
            var property = "";

            switch (className) {
                case "slot-name":
                    property = "name";
                    break;

                case "live-experience":
                    property = "experience";
                    break;

                case "next-experience":
                    property = "schedules";
                    break;

                case "live-date":
                    if ($(target).text() !== "-") {
                        property = "schedules.startTime";
                    }
                    break;

                default:
                    // No need to log here.
                    break;
            }

            this._isLightboxOpening = true;
            this.trigger("editOpened", property);
        },
        onRender: function onRender() {
            this.__super();
            this.handleUnPushedChangesOnRender();
        },
        handleUnPushedChangesOnRender: function handleUnPushedChangesOnRender() {
            var version = this.model.get("version");
            var pushedVersion = this.model.get("pushedVersion");

            this.$el.toggleClass("un-pushed", this.options.hasUnPushedChannels && version > pushedVersion);
        },
        onShow: function onShow() {
            Tooltip.add(this.ui.slotName, {
                width: 400,
                placement: "top",
                offset: {
                    align: "left",
                    elementWidth: 150
                },
                html: true,
                content: ":.channel-tooltip" // use this element as the tooltip template
            });

            Tooltip.add(this.ui.deleteChannel, {
                width: !this._allowedToPublish ? 180 : 100,
                placement: "top"
            });
        },
        onClose: function onClose() {
            Tooltip.remove([this.ui.slotName, this.ui.deleteChannel]);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);

    var _require = __webpack_require__(1),
        throttle = _require.throttle,
        contains = _require.contains;

    var EditorEvents = __webpack_require__(17);
    var EventDispatcher = __webpack_require__(54);
    var Keycode = __webpack_require__(88);
    var WidgetValidator = __webpack_require__(1198);

    var COPY_PASTE_MODIFIER_KEY_CODES = [Keycode.CONTROL, Keycode.LEFT_COMMAND_MACOS_WEBKIT, Keycode.META_OR_COMMAND_MACOS_FIREFOX, Keycode.CONTEXT_MENU_OR_RIGHT_COMMAND_MACOS_WEBKIT];
    var modifierDown = false;

    /**
     * The clipboard singleton.
     *
     * <p>This singleton takes care of detecting the copy and paste shortcuts, triggering an event when either is
     * detected.</p>
     *
     * <p>When a listener receives a "copy" event, it can set the Clipboard data by calling setData. If there are more
     * than one copy listener registered, they are responsible for determining which listener should set the data. For
     * example, in the editor view, a widget is copied if selected, otherwise the scene is copied. The copy event
     * includes one argument, the metadata object, which contains one property, isInput, boolean for whether the
     * copy occurred in an input field.</p>
     *
     * <p>The "paste" event includes two arguments: the clipboard data, and metadata for the paste. The metadata
     * includes pastesSinceLastCopy, the number of pastes that have already occurred since the last copy (not including
     * the current paste), isInput, boolean for whether the paste occurred in an input field, and position, the optional
     * position for the paste. The position may not be available, since it only really applies to paste via mouse
     * right-click. If it is specified, it will be an object containing "top" and "left" properties (pixels relative to
     * the body).</p>
     *
     * @class Clipboard
     * @constructor
     */
    var Clipboard = EventDispatcher.extend({

        /**
         * The data currently kept in the clipboard.
         * @type {Object}
         */
        _data: null,

        _pasteCounts: {},

        constructor: function constructor() {
            // Create a throttled version of #paste - as the editor sometimes have
            // a hard time keeping up with multiple paste events (user holds down CTRL+V)
            // for certain widgets (e.g. text)
            this.paste = throttle(this.paste.bind(this), 250);

            // Listen for clipboard shortcut keys
            $(document).on("keydown", this._keyDownListener.bind(this)).on("keyup", this._keyUpListener.bind(this));
        },
        _keyDownListener: function _keyDownListener(event) {
            if (contains(COPY_PASTE_MODIFIER_KEY_CODES, event.keyCode)) {
                modifierDown = true;
            }

            if (!modifierDown) {
                return;
            }

            switch (event.keyCode) {
                case Keycode.C:
                    this.copy();
                    break;

                case Keycode.V:
                    this.paste();
                    break;
                default: // do nothing
            }
        },
        _keyUpListener: function _keyUpListener(event) {
            if (contains(COPY_PASTE_MODIFIER_KEY_CODES, event.keyCode)) {
                modifierDown = false;
            }
        },


        /**
         * Check if the current active element is input, textarea or contenteditable
         */
        isInputActive: function isInputActive() {
            var $ele = $(document.activeElement);
            return $ele.is("input, textarea") || $ele.attr("contenteditable") === "true";
        },


        /**
         * Copies the currently-selected data to the clipboard, via an event to the clipboard's clients.
         */
        copy: function copy() {
            if (this.isInputActive() || window.getSelection().type === "Range") {
                return;
            }

            this._pasteCounts = {};
            // This should make someone call #setData
            this.trigger("copy");

            // This sends events to Mix Panel.
            this._triggerEditorEvent(EditorEvents.constants.COPY_WIDGET);
        },


        /**
         * Pastes the current clipboard data, via an event to the clipboard's clients.
         */
        paste: function paste(position) {
            var isWidgetsValid = true;

            if (this._data && !this.isInputActive()) {
                if (this._data.isEmailModeEnabled && this._data.models) {
                    isWidgetsValid = !WidgetValidator.getActiveIncompatibleEmailWidgets({
                        widgetModelsToCheck: this._data.models,
                        systemMessage: "You are trying to paste widgets that cannot be used in emails: ."
                    }).length;
                }

                if (isWidgetsValid) {
                    this.trigger("paste", this._data, {
                        pasteCounts: this._pasteCounts,
                        position: position
                    });
                    // Signal that a paste action occurred
                    this._triggerEditorEvent(EditorEvents.constants.PASTE_WIDGET);
                }
            }
        },


        /**
         * Sets the current clipboard data.
         * @param {Object} data The clipboard data.
         */
        setData: function setData(data) {
            this._data = data;
            this._pasteCounts[data.sceneId] = 1;
        },
        getData: function getData() {
            return this._data;
        },


        /**
         * Data type constants.
         */
        DataTypes: {
            WIDGET: "widget",
            SCENE: "scene"
        },

        /**
         * Sends Mix Panel events for clipboard actions.
         * @param {String} eventName The name of the event, either a copy or a paste action.
         * @private
         */
        _triggerEditorEvent: function _triggerEditorEvent(eventName) {
            if (this._data) {
                var eventProperties = {
                    targetType: this._data.type,
                    triggerOrigin: "SceneEditor"
                };

                if (eventProperties.targetType === "widget") {
                    var widgetTypes = this._data.models ? this._data.models.map(function (widget) {
                        return widget.get("type");
                    }) : [];
                    if (widgetTypes.length > 0) {
                        eventProperties.widgetTypes = widgetTypes.join();
                        eventProperties.numberOfWidgetSelected = widgetTypes.length;
                    }
                }

                if (this._data.experience) {
                    eventProperties.experienceId = this._data.experience.get("id");
                    eventProperties.experienceVersion = this._data.experience.get("version");
                    eventProperties.experiencePushedVersion = this._data.experience.get("pushedVersion");
                }

                EditorEvents.trigger(eventName, eventProperties);
            }
        }
    });

    return new Clipboard();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var ContentItemView = __webpack_require__(704);
    var ContentQuery = __webpack_require__(139);
    var CreateNewExperienceView = __webpack_require__(1207);
    var DashboardContentCollectionViewController = __webpack_require__(2864);
    var DashboardSortingPanel = __webpack_require__(2867);
    var DashboardHeaderFactory = __webpack_require__(1210);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);
    var InfiniteScrollingCollectionView = __webpack_require__(259);
    var NoResultsItemView = __webpack_require__(207);
    var NotificationBar = __webpack_require__(53);
    var Privileges = __webpack_require__(22).Privileges;
    var QuickView = __webpack_require__(2869);
    var Lightbox = __webpack_require__(101);
    var QuickViewAddExperienceView = __webpack_require__(2887);
    var Syncer = __webpack_require__(50);
    var template = __webpack_require__(2896);

    /**
     *
     * @class DashboardContentCollectionView
     *
     */
    return ImprovedView.extend({

        className: "content-collection-view",

        template: template,

        controller: DashboardContentCollectionViewController,

        itemView: ContentItemView,

        itemViewOptions: null,

        createLabelOptions: function createLabelOptions() {
            return {
                label: "Create<br> New Experience<br> &#43",
                onClick: function onClick(event) {
                    event.preventDefault();
                    event.stopPropagation();

                    var lightboxOptions = {
                        disableElementPosition: true,
                        css: {
                            top: "25vh",
                            left: "15vw",
                            right: "15vw",
                            position: "absolute"
                        },
                        showSpinner: true
                    };

                    var eventProperties = { triggerOrigin: "DashboardContentCollectionView" };
                    EditorEvents.trigger(EditorEvents.constants.LIST_TEMPLATES, eventProperties);

                    var lightboxView = new QuickViewAddExperienceView();
                    new Lightbox(lightboxView, lightboxOptions).open();
                }
            };
        },

        _collectionView: null,

        _sortingPanel: null,

        _showCreateDisclaimer: true,

        viewScope: function viewScope() {
            return {
                openQuickView: function openQuickView(model) {
                    this.trigger("quickView:open", model);
                },

                duplicate: function duplicate(model) {
                    this.trigger("duplicate", model);
                },

                delete: function _delete(model) {
                    this.trigger("delete", model);
                }
            };
        },

        regions: {
            sortingPanelRegion: ".sorting-panel-region",
            content: ".content"
        },

        ui: {
            content: ".content"
        },

        initialize: function initialize() {
            var notification = NotificationBar.list().find(function (notification) {
                return notification.message.includes("This experience contains widgets which cannot be used in emails");
            });
            if (notification) {
                NotificationBar.close({ id: notification.id });
            }

            this.collection = this.options.collection;
            this.itemViewOptions = this.options.itemViewOptions || this.itemViewOptions;
            this._showCreateDisclaimer = this.options.showCreateDisclaimer !== false && Privileges.CREATE.can();

            var dashboardHeaderFactoryOptions = _.pick(this.options, "users", "principal");
            this.dashboardHeaderFactory = new DashboardHeaderFactory(dashboardHeaderFactoryOptions);
        },

        /**
         * Exposes the event source (most likely a collection) associated with the number of
         * items represented by  *this* dashboard sub view. The dashboard will use this for updating
         * the counting labels, by listening for relevant events.
         *
         * @return {Collection} The main collection for this dashboard sub view.
         *
         * @see DashboardView#showTab
         */
        getCountableEventSource: function getCountableEventSource() {
            return this.collection;
        },

        /**
         * @override
         *
         * We don't need Marionette's serialization here.
         */
        serializeData: function serializeData() {
            return {};
        },

        onShow: function onShow() {
            this._sortingPanel = new DashboardSortingPanel();
            this.sortingPanelRegion.show(this._sortingPanel);

            this._collectionView = new InfiniteScrollingCollectionView({
                itemView: this.itemView,
                itemViewOptions: this.itemViewOptions && this.itemViewOptions.bind(this),
                itemEvents: this._bindItemEvents(),
                collection: this.collection,
                horizontalBuffer: 220,
                scrollTarget: _.result(this.options, "scrollTarget")
            });

            this.listenTo(this.collection, {
                "sync:state": function syncState() {
                    // only used for fetch
                    this._sortingPanel.disable(!Syncer.State.complete(this.collection));
                },

                "remove": function remove() {
                    // Edge case: If we're in "search mode" and deletes the last experience/group, call
                    // refresh to update the view, eventually displaying "No content found" (since we're still in "search mode")...
                    if (this.collection.length() === 0 && this._sortingPanel.isSearching()) {
                        this.refresh();
                    }
                },

                "reset": function reset() {
                    this.dashboardHeaderFactory.reset();
                }
            });

            this.listenTo(this._sortingPanel, {
                "sort": function sort(sorting) {
                    this.collection.query(sorting.query);
                },

                "search": function search(searchPhase, sorting) {
                    this.collection.query(ContentQuery.search(searchPhase, sorting.query));
                }
            });

            this._collectionView.onAddingView = this.onAddingView.bind(this);

            this._collectionView.onEmpty = function () {
                if (this._sortingPanel.isSearching()) {
                    return new NoResultsItemView({ type: "content" });
                }
                // Empty items collection top align fix
                var header = this.dashboardHeaderFactory.create("Empty", 0, null);
                if (this._showCreateDisclaimer) {
                    return [header, this._createDisclaimer()];
                }

                return [header];
            }.bind(this);

            this.content.show(this._collectionView);
        },

        refresh: function refresh(sorting) {
            this.dashboardHeaderFactory.reset();

            this._sortingPanel.setSorting(sorting || this.getSorting());
        },

        /**
         * Invoked from the dashboard view when the tab representing this view become active/deactive.
         *
         * @param  {Boolean} active The active state.
         */
        active: function active(_active) {
            // Delegate active state to the InfiniteScrollingCollectionView
            // instance - this will enable/disable the scroll listener.
            this._collectionView.active(_active);

            if (_active) {
                this.refresh();
            }
        },

        setSorting: function setSorting(sorting) {
            this._sortingPanel.setSorting(sorting);
        },

        getSorting: function getSorting() {
            return this._sortingPanel.getSorting();
        },

        openQuickView: function openQuickView(options) {
            this._quickViewLightbox = new Lightbox(new QuickView(options), { css: { width: 540 } }).open();
        },

        onAddingView: function onAddingView(view, index) {
            if (this._collectionView.at(index)) {
                return;
            }

            var header = this.dashboardHeaderFactory.create(this._sortingPanel.getSorting(), index, view.model);

            if (index === 0) {
                // The create disclaimer might be undefined if _showCreateDisclaimer is set to false
                var createItem = this._createDisclaimer();

                return createItem ? [header, createItem] : header;
            }

            return header;
        },

        _createDisclaimer: function _createDisclaimer() {
            if (this._showCreateDisclaimer) {
                return new CreateNewExperienceView(this.createLabelOptions());
            }
            // undefined...
        },

        _bindItemEvents: function _bindItemEvents() {
            var self = this,
                itemEvents = {};

            if (itemEvents) {
                _.each(this.itemEvents, function (callback, event) {
                    itemEvents[event] = callback.bind(self);
                });
            }

            return itemEvents;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        DeleteGroupAction = __webpack_require__(1203),
        GroupModel = __webpack_require__(104),
        LoggedInUserState = __webpack_require__(19),
        ExperienceThumbnailViewer = __webpack_require__(705),
        ExperienceThumbnailImageViewer = __webpack_require__(2861),
        SceneThumbnailViewer = __webpack_require__(466),
        Tooltip = __webpack_require__(35),
        Marionette = __webpack_require__(10),
        Permissions = __webpack_require__(22),
        PublishableState = __webpack_require__(65),
        Size = __webpack_require__(84),
        SpinnerView = __webpack_require__(244),
        template = __webpack_require__(2863),
        ThumbnailLayouter = __webpack_require__(1204),
        WarningMessages = __webpack_require__(1205),
        MatomoReportingModel = __webpack_require__(1206),
        Configuration = __webpack_require__(27);

    var MAX_THUMB_DIMENSION = { width: 215, height: 140 },
        MAX_VARIANT_THUMB_DIMENSION = { width: 130, height: 110 };

    /**
     *
     * @class ContentItemView
     *
     */
    return Marionette.Layout.extend({

        _spectatorMode: null,

        _canDeleteExperiences: null,

        _group: null,

        _entries: null,

        _pending: false,

        /**
         * @type {SceneThumbnailViewer}
         */
        _sceneThumbnailViewer: null,

        className: "content-item experience-item",

        template: template,

        /**
         * Whether the view has been through it's rendering cycle.
         *
         * @type {Boolean}
         */
        rendered: false,

        regions: {
            spinnerRegion: ".spinner-region"
        },

        templateHelpers: function templateHelpers() {
            var state = this.model.getState(),
                readableState = state && state.displayName,
                canDelete = this._canDeleteExperiences,

            // HACK: See comments in #_showComments
            hasComments = (this._group ? this._group.getSortedAssets()[0] : this.model).has("lastCommentedAt"),
                hasMatomoReporting = LoggedInUserState.get("integrations").isMatomoReportingDashboardLinkVisibleIntegrationsEnabled();

            // console.log("readable state", readableState, this._group);

            if (this._group) {
                // FIXME: Seems weird to use the action for permission check?
                canDelete = new DeleteGroupAction(this._group).executable();
            }

            return {
                spectatorMode: this._spectatorMode,
                canDelete: canDelete,
                itemLabel: this._itemLabel,
                // Overwriting the name from the model to avoid js-injection
                name: this.model.get("name"),
                hasComments: hasComments,
                readableState: readableState,
                pending: this._pending,
                group: this._group,
                groupType: this._group && this._group.getDashedType(),
                entries: this._group && this._entries,
                thumbs: this._group && this._getThumbs(),
                hasMatomoReporting: hasMatomoReporting
            };
        },

        modelEvents: {
            "change:name": function changeName(experienceModel, newName) {
                this.ui.title.text(newName);
            },

            "change:state": "render"
        },

        ui: {
            thumbContainer: ".experience-thumb-container",
            groupThumbContainer: ".group-thumb-container",
            thumbWrapper: ".experience-thumb-wrapper",
            duplicate: ".duplicate",
            delete: ".delete",
            report: ".report",
            commentsIndicator: ".comments-indicator",
            titleContainer: ".title-container",
            title: ".title",
            loadingSpinner: ".loading-spinner"
        },

        events: {
            "click @ui.thumbContainer": function clickUiThumbContainer(event) {
                event.preventDefault();
                event.stopPropagation();

                // Signal that we want to open the quick view
                this.viewScope.openQuickView(this.model);
            },

            "click @ui.groupThumbContainer": function clickUiGroupThumbContainer(event) {
                event.preventDefault();

                // Signal that we want to open the quick view
                this.viewScope.openQuickView(this.model);
            },

            "click @ui.duplicate": function clickUiDuplicate(event) {
                event.preventDefault();

                // Necessary to remove the tooltip on click
                $(event.target).trigger("mouseout");

                this._duplicate();
            },

            "click @ui.delete": function clickUiDelete(event) {
                event.preventDefault();

                // Necessary to remove the tooltip on click
                $(event.target).trigger("mouseout");
                this._delete();
            },

            "click @ui.report": function clickUiReport(event) {
                event.preventDefault();

                // Necessary to remove the tooltip on click
                $(event.target).trigger("mouseout");
                this._createMatomoSegment();
            },

            "mouseover @ui.titleContainer": function mouseoverUiTitleContainer() {
                this._addTooltipOnTitle();
            }
        },

        initialize: function initialize() {
            this._spectatorMode = Permissions.Privileges.CREATE.cannot();
            // Must have Create privilege, but also Publish if the experience is pushed, published, or scheduled!
            this._canDeleteExperiences = Permissions.Privileges.CREATE.can() && (!this.model.hasAtLeastState(PublishableState.PUSHED) || Permissions.Privileges.PUBLISH.can());

            this._group = this.model instanceof GroupModel ? this.model : null;
            this._itemLabel = this._group ? "Group" : "Experience";
            this._entries = this._group && this._group.getUniqueEntries();
        },

        onRender: function onRender() {
            var experienceToRender = this._group ? this._entries[0][0] : this.model;

            this._renderThumbnail(experienceToRender);
            this._showComments();
            this.rendered = true;
        },

        _renderThumbnail: function _renderThumbnail(experienceModel) {
            var maxDimensions = this._group ? MAX_VARIANT_THUMB_DIMENSION : MAX_THUMB_DIMENSION;
            var isThumbnailsImageIntegrationsEnabled = LoggedInUserState.get("integrations").isThumbnailsImageIntegrationsEnabled();
            var isThumbnailsNativeContentIntegrationsEnabled = LoggedInUserState.get("integrations").isThumbnailsNativeContentIntegrationsEnabled();
            if (isThumbnailsImageIntegrationsEnabled) {
                this._sceneThumbnailViewer = new ExperienceThumbnailImageViewer({
                    model: experienceModel.get("scenes").at(0),
                    experience: experienceModel,
                    maxDimensions: maxDimensions,
                    showStaticScenes: true,
                    isThumbnailsNativeContentIntegrationsEnabled: isThumbnailsNativeContentIntegrationsEnabled
                });
            } else if (isThumbnailsNativeContentIntegrationsEnabled) {
                this._sceneThumbnailViewer = new ExperienceThumbnailViewer({
                    model: experienceModel.get("scenes").at(0),
                    experience: experienceModel,
                    maxDimensions: maxDimensions,
                    showStaticScenes: true
                });
            } else {
                this._sceneThumbnailViewer = new SceneThumbnailViewer({
                    model: experienceModel.get("scenes").at(0),
                    experience: experienceModel,
                    maxDimensions: maxDimensions,
                    showStaticScenes: true
                });
            }
            this.ui.thumbContainer.prepend(this._sceneThumbnailViewer.render().$el);
            this.$el.addClass(this.model.get("id"));
        },

        onShow: function onShow() {
            Tooltip.add(this.ui.delete, {
                placement: "top",
                width: this._canDeleteExperiences ? 177 : 180
            });

            Tooltip.add(this.ui.duplicate, {
                placement: "top",
                width: !this._spectatorMode ? 152 : 180
            });

            Tooltip.add(this.ui.report, {
                placement: "top",
                width: !this._spectatorMode ? 152 : 180
            });
        },

        onClose: function onClose() {
            // Make sure to properly close the viewer instance - it was added
            // to the DOM outside of the normal (Marionette) lifecycle - see #onRender
            this._sceneThumbnailViewer.close();
        },

        _addTooltipOnTitle: function _addTooltipOnTitle() {
            // jQuery return a rounded width, so to make sure there is room for the title
            // we add 1 to the container width.
            var titleContainerWidth = this.ui.titleContainer.width() + 1,
                titleWidth = this.ui.title.width(),
                showTooltip = titleWidth > titleContainerWidth;

            if (showTooltip) {
                this._titleTooltip = Tooltip.add(this.ui.titleContainer, {
                    placement: "top",
                    width: "auto"
                });
            }
        },

        // Handle state of comments indicator
        _showComments: function _showComments() {
            // Either pick the current experience or the first ("createdAt") from the group model.
            // FIXME: The comments indication might be incorrect for experience meta data, since
            // they only include initial scenes...
            var experienceModel = this._group ? this._group.getSortedAssets()[0] : this.model;

            if (experienceModel.get("lastCommentedAt")) {
                var lastVisit = LoggedInUserState.getLastExperienceVisit(experienceModel.get("id"));

                // Check if there are unread comments since the last experience visit
                if (experienceModel.get("lastCommentedAt") > lastVisit.visit) {
                    this.ui.commentsIndicator.addClass("unread-comments");
                } else {
                    // Check if there are unread comments on any of the scenes
                    var scenes = _.union(experienceModel.get("scenes").models, [experienceModel.get("overlayScene")], [experienceModel.get("backgroundScene")]),
                        hasComments = _.find(scenes, function (scene) {
                        return scene.get("lastCommentedAt") && scene.get("lastCommentedAt") > (lastVisit.sceneVisits[scene.get("id")] || 0);
                    });

                    if (hasComments) {
                        this.ui.commentsIndicator.addClass("unread-comments");
                    }
                }
            }
        },

        _getThumbs: function _getThumbs() {
            if (!this._entries) {
                return null;
            }

            var primaryModel = this._entries[0][0],
                dimensions = _.map(this._entries, function (variant) {
                return {
                    width: variant[0].get("width"),
                    height: variant[0].get("height")
                };
            }),
                layouts;

            if (primaryModel && primaryModel.get("backdrop").isFitContainer()) {
                var first = dimensions[0],
                    size = new Size(first.width, first.height),
                    scaledSize = size.shrinkToAspectRatio(MAX_VARIANT_THUMB_DIMENSION.width / MAX_VARIANT_THUMB_DIMENSION.height);

                _.extend(first, scaledSize);
            }

            layouts = ThumbnailLayouter.calculateLayout(dimensions, {
                fitboxDimensions: {
                    width: MAX_VARIANT_THUMB_DIMENSION.width,
                    height: MAX_VARIANT_THUMB_DIMENSION.height
                }
            });

            return layouts;
        },

        /**
         * Duplicate the current experience item view
         */
        _duplicate: function _duplicate() {
            this.viewScope.duplicate(this._group || this.model);
        },

        /**
         * @private
         *
         * Delete the experience/group associated with this item view.
         */
        _delete: function _delete() {
            var self = this,
                model = self._group || self.model;

            this.ui.delete.addClass("invisible");

            // Show the spinner...
            this.spinnerRegion.show(new SpinnerView());

            var modelTypeText = model.get("type") !== "Experience" ? "Group" : "Experience"; // Simplify type for user messages. See MOS-1994.

            WarningMessages.fetchDeleteExperienceMessage(model, modelTypeText).then(function (messagesText) {
                // ensure the `self.ui` keys have been converted from selector strings to jQuery elements.
                self.bindUIElements();
                // Remove spinner, i.e. empty the region...
                self.spinnerRegion.close();
                self.ui.delete.removeClass("invisible");
                self.ui.delete.show();

                // delay of 50ms to avoid the confirm box popping up before the rendering is complete.
                _.delay(function () {
                    if (confirm(messagesText)) {
                        self.viewScope.delete(model);
                    }
                }, 50);
            });
        },

        _createMatomoSegment: function _createMatomoSegment() {
            // Show the spinner...

            var self = this;

            var experienceId = "";
            var experienceGroupId = "";
            var experienceGroupName = this.model.get("name");
            // if we have a group, then separate the experience ids so the api makes an OR rule here
            if (this._group) {
                var items = [];
                var experienceArray = this._group.getSortedAssets();
                experienceArray.forEach(function (item) {
                    items.push(item.get("id"));
                });
                experienceGroupId = this.model.get("id");
                experienceId = items.join("::");
            } else {
                experienceId = this.model.get("id");
            }

            this.spinnerRegion.show(new SpinnerView());

            var matomoModel = new MatomoReportingModel();

            matomoModel.createNewSegment(experienceId, experienceGroupId, experienceGroupName).then(function (matomoResponse) {
                var segmentDimension = matomoResponse.get("definition");
                var url = Configuration.editorBaseUrl + "/#reporting/segment/" + segmentDimension;
                window.location = url;
            }).always(function () {
                self.spinnerRegion.close();
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var FontLoader = __webpack_require__(260);
    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(706);
    var ImprovedModel = __webpack_require__(25);
    var RestApi = __webpack_require__(29);
    var $ = __webpack_require__(4);
    /**
     * View model for the scene thumbnail.
     *
     * @class ExperienceThumbnailViewModel
     * @constructor
     */
    var ExperienceThumbnailViewModel = ImprovedModel.extend("ExperienceThumbnailViewModel", {
        url: function url() {
            return RestApi.pathToCollectionOnResource(RestApi.Collections.EXPERIENCES, this.get("id"), "thumbnail");
        },

        defaults: {
            id: "",
            html: ""
        }
    });

    /**
     * A scene thumbnail "viewer". Renders a scene with some defined maximum size.
     *
     * @class ExperienceThumbnailViewer
     * @constructor
     *
     * @cfg {ExperienceModel} experience The parent experience.
     * @cfg {Object} [maxDimensions] Optional max dimensions to scale the viewer to. If specified, must contain width, height, or both.
     */
    return ImprovedView.extend({

        className: "scene-thumbnail experience-container",

        template: template,

        ui: {
            sceneWrapper: ".scene-wrapper-inner",
            sceneWrapperOuter: ".scene-wrapper-outer"
        },

        _experience: null,
        _sceneZeroModel: null,
        _maxDimensions: null,
        _showStaticScenes: null,
        _isPushed: false,

        initialize: function initialize() {
            this._experience = this.options.experience;
            this._isPushed = this._experience.get("pushedAt") > 0;
            this._sceneZeroModel = this.options.model;
            this._showStaticScenes = this.options.showStaticScenes;
            this._maxDimensions = this.options.maxDimensions;
        },


        /**
         * Used only when we fail for some reason talking to CNC to get html of the pushed experience.
         * This viewer generates a full experience viewer and is the final viewer fallback before stating we can't get
         * a thumbnail.  If the experience hasn't been pushed we will fall back further to putting a message of:
         * "Thumbnail Unavailable" in place of the thumbnail.
         * @private
         */
        _fallbackThumbnail: function _fallbackThumbnail() {
            // old default thumbnail code.
            var defaultThumbnail = document.createElement("DIV");
            defaultThumbnail.innerHTML += "Thumbnail <br> Unavailable";
            defaultThumbnail.style.cssText = "border: none;text-align: center;color: @grey04;font-size: 18px;font-weight: 800; cursor: default";
            this.$el.find(this.ui.sceneWrapper).append(defaultThumbnail);
        },
        onRender: function onRender() {
            var _this = this;

            this._experience.fetch().then(function (experience) {
                if (!_this.model) {
                    _this._fallbackThumbnail();
                } else {
                    FontLoader.loadSceneFonts(_this.model, experience).always(function () {
                        if (_this.isClosed) {
                            return;
                        }
                        var model = new ExperienceThumbnailViewModel({ id: _this._experience.get("id") });
                        var self = _this;
                        model.fetch({ silent: true }).then(function () {
                            var html = model.get("html");

                            if (html === "" || !_this.model) {
                                self._fallbackThumbnail();
                            } else {
                                var scaledDimensions = self._experience.getDimensions(self.options.maxDimensions);
                                var padX = (scaledDimensions.width * scaledDimensions.scale - scaledDimensions.width) / 2;
                                var padY = (scaledDimensions.height * scaledDimensions.scale - scaledDimensions.height) / 2;

                                var sceneWrapperOuterElement = self.$el.find(self.ui.sceneWrapperOuter);
                                $(sceneWrapperOuterElement).css({
                                    overflow: "hidden"
                                });

                                var pointerDiv = document.createElement("div");
                                $(pointerDiv).css({
                                    cursor: "pointer",
                                    width: self.options.maxDimensions.width,
                                    height: self.options.maxDimensions.height,
                                    top: 0 + "px",
                                    "z-index": 100,
                                    position: "absolute"
                                });
                                sceneWrapperOuterElement.append(pointerDiv);

                                var thumbnail = model.get("html");

                                var scenewrapperElement = self.$el.find(self.ui.sceneWrapper);

                                scenewrapperElement.append(thumbnail);

                                $(scenewrapperElement).css({
                                    top: padY + "px",
                                    left: padX + "px",
                                    transform: "scale(" + scaledDimensions.scale + "," + scaledDimensions.scale + ") ",
                                    width: scaledDimensions.width,
                                    height: scaledDimensions.height
                                });

                                var i = 0;
                                var iframes = $("iframe", self.el);
                                for (i = 0; i < iframes.length; i++) {
                                    var parent = $(iframes[i].parentNode);
                                    var iheight = parent.height();
                                    var iwidth = parent.width();
                                    var iframeReplace = document.createElement("DIV");
                                    $(iframeReplace).css({
                                        height: iheight,
                                        width: iwidth,
                                        "background-color": "#d0a1be"
                                    });
                                    iframes[i].replaceWith(iframeReplace);
                                }
                            }
                        }).fail(function () {
                            self._fallbackThumbnail();
                        });
                    });
                }
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="scene-wrapper-outer">\n    <div class="scene-wrapper-inner">\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImageURLProvider = __webpack_require__(362);
    var Marionette = __webpack_require__(10);
    var Size = __webpack_require__(84);
    var WidgetCollection = __webpack_require__(501);
    var WidgetTypes = __webpack_require__(2862);

    // Class added to any Scene via "hide()" not removed until "show()" is called, which is
    // only when the Scene is actually ready to be shown to the end-user.
    var INVISIBLE_CLASS = "invisible";

    /**
     * Viewer for a single scene.
     *
     * @author Yijie Li
     * @class SceneViewer
     * @constructor
     *
     * @cfg {Scene} model The scene model.
     * @cfg {ExperienceViewModel|SceneThumbnailViewModel} viewModel The view model for the view containing the scene.
     * @cfg {Object} [maxDimensions] Optional max dimensions to scale the viewer to. If specified, must contain width, height, or both.
     * @cfg {Boolean} [enableAnimations] If true, animations will be enabled on the scene.
     * @cfg {Boolean} [extractCollection] Optional, advanced option used for manual handing of the scenes collection. Defaults to true.
     * @cfg {Boolean} [disableScale] If true, the scene will not be scaled to fit its container.
     */
    return Marionette.CompositeView.extend({ // Not ImprovedView, since this class is used in the viewer

        className: "scene-viewer",

        template: function template() {
            return "";
        },

        options: {
            extractCollection: true
        },

        viewScope: {
            getSceneNumber: function getSceneNumber() {
                return this.model.get("sceneNumber");
            }
        },

        /**
         * @private
         * First rendering always inactive by default, the current Scene will then trigger a re-render when
         * becoming active. This ensures that all other Scenes are inactive by default - as they should be -
         * when rendered the first time (as an adjacent Scene).
         */
        _active: false,

        /**
         * @type {ExperienceModel}
         */
        _experience: null,

        /**
         * The backdrop container element, if any...
         *
         * @type {jQueryHTMLElement}
         */
        _backdropContainer: null,

        modelEvents: {
            // Listen for scale/resize changes in order to update scene size
            "change:scale": "_scaleChangeHandler"
        },

        itemViewOptions: function itemViewOptions() {
            return {
                viewModel: this.options.viewModel,
                enableAnimations: this.options.enableAnimations,
                enableActions: this.options.enableActions || this.options.enableAnimations
            };
        },
        getItemView: function getItemView(item) {
            return WidgetTypes.lookup(item.get("type")).viewClass;
        },
        widgetViewFromModel: function widgetViewFromModel(model) {
            return this.children.findByModel(model);
        },
        initialize: function initialize() {
            this._experience = this.options.viewModel.get("experience");

            if (this.options.extractCollection) {
                this.collection = this.model.get("widgets");
            } else {
                this.collection = new WidgetCollection();
                this.listenTo(this.collection, "add", this._updateToActiveState);
            }

            this.listenTo(this, "show", this._renderBackdrop);
        },


        /**
         * Ensures the Scene controlled by this Scene Viewer is no longer invisible to the end-user and
         * potentially ready for interaction, like the user clicking an Action on a Widget in the Scene.
         *
         * @return {SceneViewer} This scene viewer; never falsey.
         * @see    #hide
         */
        show: function show() {
            this.$el.removeClass(INVISIBLE_CLASS);
            return this;
        },


        /**
         * Ensures the Scene controlled by this Scene Viewer is invisible to the end-user and not
         * ready for interaction, but always present in the dom (to avoid all kinds of nasty issues
         * with dom elements not displayed in the dom, e.g. issues with embedding Experiences on
         * adjacent Scenes currently not shown).
         *
         * @return {SceneViewer} This scene viewer; never falsey.
         * @see    #show
         */
        hide: function hide() {
            this.$el.addClass(INVISIBLE_CLASS);
            return this;
        },


        /**
         * Computes the size to view the experience.
         *
         * @returns {{width: *, height: *}}
         */
        getSize: function getSize() {
            var scaledDimensions = this._experience.getDimensions(this.options.maxDimensions);

            scaledDimensions.scaledWidth = scaledDimensions.width;
            scaledDimensions.scaledHeight = scaledDimensions.height;
            scaledDimensions.width = this._experience.get("width");
            scaledDimensions.height = this._experience.get("height");

            return scaledDimensions;
        },


        /**
         * Set the active state of the scene, i.e. any contained widgets will become
         * active, starting animations etc.
         *
         * @param {Boolean} value Whether the scene is considered active or not.
         */
        setActive: function setActive(value) {
            this._active = value;
            this._updateToActiveState();
        },
        isActive: function isActive() {
            return this._active;
        },
        updateToVisibilityState: function updateToVisibilityState() {
            this._updateToActiveState();
        },


        /**
         * Invoked when the scene model's scale changes.
         */
        _scaleChangeHandler: function _scaleChangeHandler() {
            this._updateSize();
        },


        /**
         * Computes the rect for the specified widget view. Default implementation delegates to <tt>AbstractWidgetView#getBoundingBox</tt>.
         *
         * May be overridden by subclasses.
         *
         * @param  {AbstractWidgetView} widget The widget view.
         * @return {Rectangle} a rectangle representing the size and position of the widget.
         */
        _calculateWidgetRect: function _calculateWidgetRect(widget) {
            return widget.getBoundingBox();
        },


        /**
         * @private
         *
         * Delegates the active state to any contained widgets, if we're not in a pending state.
         *
         * @see  #onRender
         */
        _updateToActiveState: function _updateToActiveState() {
            var _this = this;

            if (!this._active) {
                this.children.forEach(function (widget) {
                    widget.setActive(false);
                });

                return;
            }

            var visiblePartOfExperience = this.options.viewModel.get("viewportVisibility");

            this.children.forEach(function (widget) {
                var widgetRectangle = _this._calculateWidgetRect(widget);
                var widgetIsVisible = visiblePartOfExperience.intersects(widgetRectangle);

                widget.setActive(widgetIsVisible);
            });
        },


        /**
         * @private
         *
         * Sets the size of the scene element, equal to the scaled size of the current experience.
         *
         * @see  ExperienceModel.scale
         */
        _updateSize: function _updateSize() {
            this.$el.css({
                width: this._experience.get("scaledWidth"),
                height: this._experience.get("scaledHeight")
            });
        },


        /**
         * @private
         *
         * Applies the size and background color to this scene instance.
         *
         * If the scene is in a pending state, the scene is hidden until all widgets have been
         * successfully loaded.
         */
        onRender: function onRender() {
            var css = {};

            if (this.options.maxDimensions) {
                var scale = this.getSize().scale;
                css.transform = "scale(" + scale + ", " + scale + ")";
            }

            this._updateSize();
            this._updateToActiveState();

            this.$el.css(css);
        },
        onClose: function onClose() {
            // Clean up any backdrop leftovers...
            if (this._backdropContainer) {
                this._backdropContainer.removeClass("fit-container").removeClass("responsive-backdrop").css({
                    backgroundImage: "",
                    backgroundColor: ""
                });
            }
        },


        /**
         * Renders the experience backdrop, either an image or color.
         *
         * @private
         */
        _renderBackdrop: function _renderBackdrop() {
            if (!this.model.get("isBackgroundScene")) {
                return;
            }

            var backdrop = this._experience.get("backdrop");
            var container = backdrop.isFitContainer() ? this.$el.closest(".experience-container") : this.$el;

            if (backdrop.isFitContainer()) {
                container.addClass("fit-container");
            }

            if (backdrop.isTypeImage() && backdrop.has("image")) {
                var image = backdrop.get("image");
                // Note this is called on show, we should be able to get the bounds by jQuery as below. But for views
                // that does not compliant to the backbone render cycle, for example not calling region.show in onShow,
                // the bounds will be {0, 0} here. We probably need another task to solve that issue.
                // If we get the bounds, we need to take into account the ratio in order to get the appropriate size.
                // Otherwise, we may get a smaller image, which will be scaled up and appears blurry.
                var size = new Size(container[0].offsetWidth, container[0].offsetHeight);
                var bounds = size.growToAspectRatio(image.width / image.height);
                var url = ImageURLProvider.provide(backdrop.getMockModel(), { bounds: bounds }) || "";

                container.css("background-image", "url(" + url + ")").addClass("responsive-backdrop");
            } else {
                container.css("background-color", backdrop.getColor());
            }

            // Keep a reference to the backdrop container in order to do proper cleanup later - see #onClose...
            this._backdropContainer = container;
        },


        /**
         * Starts (or re-starts) the animations of all widgets on the scene.
         */
        startAnimations: function startAnimations() {
            this.children.invoke("startAnimations");
        },


        /**
         * Stops and resets the animations of all widgets on the scene.
         */
        stopAnimations: function stopAnimations() {
            this.children.invoke("stopAnimations");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var Configuration = __webpack_require__(27);
    /**
     * An shared entity model using microservices.
     *
     * @class MsSharedEntityModel
     * @constructor
     */
    return ImprovedModel.extend("MsSharedEntityModel", {

        _api: "msExperience",

        defaults: {
            entityId: undefined,
            entityType: undefined,
            sharedWithAll: false,
            companyId: undefined,
            usersSharedWith: []
        },

        moveURL: function moveURL() {
            return Configuration.experienceSharedEntityBaseUrl + "moveSettings";
        },

        patchAddURL: function patchAddURL(entityId) {
            return "" + Configuration.experienceSharedEntityBaseUrl + this.get("entityType") + "/" + this.get("entityId") + "/add/" + entityId;
        },

        patchRemoveURL: function patchRemoveURL(entityId) {
            return "" + Configuration.experienceSharedEntityBaseUrl + this.get("entityType") + "/" + this.get("entityId") + "/remove/" + entityId;
        },

        postURL: function postURL() {
            return "" + Configuration.experienceSharedEntityBaseUrl;
        },

        getURL: function getURL() {
            return "" + Configuration.experienceSharedEntityBaseUrl + this.get("entityType") + "/" + this.get("entityId") + "/";
        },

        fixedValues: null,

        url: function url() {
            return this.getURL();
        },


        sharedWithAllUrl: function sharedWithAllUrl(sharedWithAll) {
            return "" + Configuration.experienceSharedEntityBaseUrl + this.get("entityType") + "/" + this.get("entityId") + "/sharedWithAll/" + sharedWithAll;
        },

        _patchSharedWithAll: function _patchSharedWithAll(sharedWithAll) {
            var options = {
                method: "patch"
            };
            return this._execute(options, {
                url: this.sharedWithAllUrl(sharedWithAll),
                type: "PATCH"
            }).promise;
        },

        onChangeSharedWithAllHandler: function onChangeSharedWithAllHandler(isChecked) {
            this.set("sharedWithAll", isChecked);
            this._patchSharedWithAll(isChecked);
            return isChecked;
        },


        addSharedUser: function addSharedUser(id) {
            return this._execute({
                method: "patch"
            }, {
                url: this.patchAddURL(id),
                type: "PATCH"
            });
        },

        removeSharedUser: function removeSharedUser(entityId) {
            return this._execute({
                method: "patch"
            }, {
                url: this.patchRemoveURL(entityId),
                type: "PATCH"
            }).promise;
        },

        moveSharedEntity: function moveSharedEntity(_ref) {
            var destID = _ref.destID,
                destType = _ref.destType;

            var dest = {
                id: destID,
                type: destType
            };
            var source = {
                id: this.get("entityId"),
                type: this.get("entityType")
            };

            var moveBody = {
                dest: dest,
                source: source
            };

            return this._execute({
                method: "post"
            }, {
                url: this.moveURL(),
                type: "POST",
                data: JSON.stringify(moveBody),
                dataType: "text",
                contentType: "application/json"
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Enum = __webpack_require__(77);
    var Sorting = __webpack_require__(696);
    var SortingHelperMethods = __webpack_require__(1192);
    var Storage = __webpack_require__(34);

    var SORTING_KEY = "sorting";

    var TemplateSorting = Enum.create("TemplateSorting", "value", {

        ALPHABETICAL: new Sorting("alphabetical", [{ name: "name", direction: "Ascending" }]),

        CREATED: new Sorting("created", ["createdAt"])

    }, {
        // We need to create a closure so we have access to the TemplateSorting variable.
        current: function current() {
            return SortingHelperMethods.current(Storage.Keys.TEMPLATE_SORTING_PANEL, SORTING_KEY, TemplateSorting, TemplateSorting.CREATED)();
        },

        set: SortingHelperMethods.set(Storage.Keys.TEMPLATE_SORTING_PANEL, SORTING_KEY),

        fromValue: function fromValue(value) {
            return SortingHelperMethods.fromValue(TemplateSorting)(value);
        }
    });

    return TemplateSorting;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        Backbone = __webpack_require__(7),
        Comment = __webpack_require__(711),
        RestApi = __webpack_require__(29);

    // TODO: This collection should be proper implementated (#url()) http://backbonejs.org/#Collection

    /**
     * A collection of comments.
     *
     * @author Bruce Mackenzie Nielsen
     * @class CommentCollection
     * @constructor
     */
    var CommentCollection = Backbone.Collection.extend({

        model: Comment,

        /**
         * @private
         *
         * Constructs a new comment, attaching the sceneID passed in the options object.
         *
         * @param  {Object} modelData The raw JSON model data.
         * @param  {Object} options   The options object passed.
         * @return {Comment}           A new Comment instance.
         */
        _newComment: function _newComment(modelData, options) {
            var comment = new Comment(modelData);
            comment.sceneID = options.sceneID;
            return comment;
        },

        parse: function parse(response, options) {
            var self = this;

            if (_.isArray(response)) {
                return _.map(response, function (modelData) {
                    return self._newComment(modelData, options);
                });
            }

            return this._newComment(response, options);
        },

        getCommentsForScene: function getCommentsForScene(sceneID) {
            return this.filter(function (comment) {
                return comment.sceneID === sceneID;
            });
        }

    }, {

        fetchCommentsFor: function fetchCommentsFor(experienceId) {
            return $.getJSON(RestApi.pathToCollectionOnResource(RestApi.Collections.EXPERIENCES, experienceId, RestApi.Collections.COMMENTS));
        },

        /**
         * Computes the number of comments posted since the specified date.
         *
         * @param  {String} experienceId The experience Id.
         * @param  {Number} time         The server time to check since.
         * @return {Promise} A pormise that will be resolved with the computed number of comments.
         */
        countCommentsSince: function countCommentsSince(experienceId, time) {
            var counter = 0,
                since = function since(comment) {
                return comment.createdAt > time;
            };

            return CommentCollection.fetchCommentsFor(experienceId).then(function (commentsData) {
                _.each(commentsData, function (sceneCommentsJSON) {
                    _.each(sceneCommentsJSON, function (comment) {
                        if (since(comment)) {
                            counter++;
                        }
                        _.each(comment.replies, function (reply) {
                            if (since(reply)) {
                                counter++;
                            }
                        });
                    });
                });

                return counter;
            });
        }

    });

    return CommentCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ImprovedModel = __webpack_require__(25),
        User = __webpack_require__(261),
        TextUtil = __webpack_require__(555),
        Syncer = __webpack_require__(50),
        RestApi = __webpack_require__(29);

    /**
     * Represents a comment in the editor (only).
     *
     * @author Bruce Mackenzie Nielsen
     * @class Comment
     * @constructor
     */
    return ImprovedModel.extend("Comment", {

        url: function url() {
            if (this.isNew()) {
                // Reply
                if (this.get("parentId")) {
                    return RestApi.pathToSpecificResource(RestApi.Collections.COMMENTS, this.get("parentId"));
                }
                // New thread. Scene and experience must be added to the object on creation.
                return RestApi.pathToCollectionOnSubResource(RestApi.Collections.EXPERIENCES, this.experience, RestApi.Collections.SCENES, this.sceneID, RestApi.Collections.COMMENTS);
            }
            return RestApi.pathToSpecificResource(RestApi.Collections.COMMENTS, this.get("id"));
        },

        defaults: {
            createdBy: null,
            createdAt: null,
            content: "",
            replies: [],
            unread: 0,
            isUnread: false
        },

        relations: [{
            type: Backbone.Many,
            key: "replies",
            relatedModel: Backbone.Self
        }],

        computed: {
            user: {
                deps: ["createdBy"],
                resolvePromises: true,
                computeDefault: true,
                value: function value(createdBy) {
                    return createdBy && User.findById(createdBy); // users not cached, so no need to fetch entire collection
                }
            },
            isNew: {
                deps: ["createdBy"],
                value: function value(createdBy) {
                    return !createdBy;
                }
            },
            // Transient properties used for unread comment handling
            unread: {},
            isUnread: {}
        },

        constructor: function constructor() {
            this.__super();
            Syncer.State.init(this, { permissions: {} }); // no permissions required for comments
        },

        _distinguishedName: function _distinguishedName() {
            return TextUtil.firstLine(this.get("content"), true); // true = quote the name
        },

        /**
         * Gets the number of unread comments since the given timestamp.
         * @param {number} since The timestamp in server time to use when determining unread comments.
         * @returns {number} The number of unread comments.
         */
        getUnreadComments: function getUnreadComments(since) {
            var replies = this.get("replies").models;

            // Look backwards through the replies for the first reply that is read, if there is a match, all later
            // replies are unread
            var i = replies.length;
            while (i--) {
                if (replies[i].get("createdAt") < since) {
                    return replies.length - i - 1;
                }
                replies[i].set("isUnread", true);
            }

            // Check if the root comment is unread
            if (this.get("createdAt") > since) {
                this.set("isUnread", true);
                return replies.length + 1;
            }

            // No read comments were found in the replies, so all replies are unread
            return replies.length;
        },

        /**
         * Get the position of the comment after scaling by zoom level.
         * @param {number} scaleFactor example 1.5 = 150%
         */
        getScaledPosition: function getScaledPosition(scaleFactor) {
            return {
                top: this.get("top") * scaleFactor,
                left: this.get("left") * scaleFactor
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var DuplicateExperienceAction = __webpack_require__(405);
    var DuplicateGroupAction = __webpack_require__(1208);
    var EditorEvents = __webpack_require__(17);
    var GroupModel = __webpack_require__(104);
    var ExperienceURLProvider = __webpack_require__(168);
    var ViewController = __webpack_require__(126);

    /**
     *
     * @class TemplateItemViewController
     *          This class handles both Template Copy and Experience Export
     *
     */
    return ViewController.extend({
        onViewDuplicate: function onViewDuplicate(experienceModel, triggerOrigin) {
            var action = void 0;
            var originalExperienceId = void 0;
            if (experienceModel instanceof GroupModel) {
                action = new DuplicateGroupAction(experienceModel, {
                    postfix: "new",
                    projectContext: this.options.projectContext
                });
                originalExperienceId = experienceModel.getSortedAssets()[0].get("id");
            } else {
                action = new DuplicateExperienceAction(experienceModel, {
                    postfix: "new",
                    projectContext: this.options.projectContext
                });
                originalExperienceId = experienceModel.get("id");
            }
            if (!action.executable()) {
                return;
            }
            var eventProperties = {
                templateExperienceId: originalExperienceId,
                triggerOrigin: triggerOrigin
            };

            var eventTrigger = EditorEvents.constants.EXPORT_EXPORT;
            if (triggerOrigin !== "ExperienceExport") {
                // actual value is "TemplateItemViewCreateButton"
                eventTrigger = EditorEvents.constants.COPY_TEMPLATE;
            }

            return action.execute(eventProperties, eventTrigger).done(function (experience) {
                navigateToUrl(experienceModel, GroupModel, ExperienceURLProvider, experience, Backbone);
                return experience.get("id");
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

function navigateToUrl(experienceModel, GroupModel, ExperienceURLProvider, experience, Backbone) {
    var urlToNavigateTo = void 0;
    if (experienceModel instanceof GroupModel) {
        // If you want to go to the experience URL, then you need to get the URL of the NEW experience
        // OR group..  this is early though so group doesn't yet have internal experience ids
        // experience.getSortedAssets() returns an empty array and I THINK its just an artifact that
        // the eventual DuplicateGroupAction does NOT return here the fully Hydrated Group object,
        // rather just some sort of shell, and worst yet it has the ORIGINAL experience ids
        // which you can extract Object.keys(experience.get("resolvedAssets"))[0]
        // but if you use this to navigate you get a correct and nasty error
        // The save of Desktop (exported) failed because somebody else is modifying the Experience. Make a copy - will not affect this Experience. Refresh - your changes will be lost. Visit the Community
        // as you're trying to view an experience from another account.
        // so it may be possible to get to the first experience_id in the group, its not there now however
        urlToNavigateTo = "#";
    } else {
        urlToNavigateTo = ExperienceURLProvider.provide(experience.get("id"), ExperienceURLProvider.ACTION.EDIT);
    }
    Backbone.history.navigate(urlToNavigateTo, true);
}

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var LoggedInUserState = __webpack_require__(19);
    var MsSharedEntityModel = __webpack_require__(708);

    return {
        movePermissions: function movePermissions(_ref) {
            var sourceID = _ref.sourceID,
                sourceType = _ref.sourceType,
                companyId = _ref.companyId,
                destID = _ref.destID,
                destType = _ref.destType;

            if (LoggedInUserState.get("companySettings").get("userPermissionsEnabled")) {
                // If we switch groups we also need to move the permissions over
                var sharedEntity = new MsSharedEntityModel({
                    entityId: sourceID,
                    companyId: companyId,
                    entityType: sourceType
                });

                sharedEntity.moveSharedEntity({
                    destID: destID,
                    destType: destType
                });
            }
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);

    /**
     * A virtual Backbone collection containing the concatenation of multiple models and/or collections.
     *
     * <p>This collection is only suitable for use as a view of the underlying models/collections. Avoid calling
     * functions that manipulate the collection, as this has undefined behaviour.</p>
     *
     * <p>When a sub-collection is reset or sorted, this collection will fire a reset event. Adds and removes are
     * correctly propagated through.</p>
     *
     * <p>Note that because this collection is modelled as a Backbone collection, it is not valid to have the same
     * model appear multiple times in the collection. If you concatenate two collections that each contain the same
     * model, the behaviour is undefined.</p>
     *
     * @author Bruce Mackenzie Nielsen
     * @class ConcatenatedCollection
     */
    return Backbone.Collection.extend({

        _contents: null,

        _getModelArray: function _getModelArray() {
            var models = [];

            this._contents.forEach(function (modelOrCollection) {
                if (modelOrCollection instanceof Backbone.Collection) {
                    models.push.apply(models, modelOrCollection.models);
                } else {
                    models.push(modelOrCollection);
                }
            });

            return models;
        },


        /**
         * Gets the start index in the concatenated collection of the given subcollection.
         *
         * <p>If the subcollection is not part of the concatenated collection, returns -1.</p>
         *
         * @param {Backbone.Collection} collection The collection.
         * @returns {number} The index, or -1.
         * @private
         */
        _getCollectionStartIndex: function _getCollectionStartIndex(collection) {
            var index = 0;

            var modelOrCollection = this._contents.find(function (modelOrCollection) {
                // Break out of the loop if this is the requested collection
                if (modelOrCollection === collection) {
                    return true;
                }
                // Increment the index by the appropriate amount
                index += modelOrCollection instanceof Backbone.Collection ? modelOrCollection.length : 1;

                return false;
            });

            if (!modelOrCollection) {
                return -1;
            }

            return index;
        },
        _subCollectionResetHandler: function _subCollectionResetHandler() {
            this.reset(this._getModelArray());
        },
        _subCollectionAddHandler: function _subCollectionAddHandler(model, collection, options) {
            var offset = this._getCollectionStartIndex(collection);
            var index = options.at === undefined || options.at === null ? collection.length - 1 : options.at; // options.at might be 0, so can't just do options.at || collection.length - 1
            // Guard for someone changing the collection manually
            if (offset > -1) {
                this.add(model, { at: offset + index });
            }
        },
        _subCollectionRemoveHandler: function _subCollectionRemoveHandler(model) {
            this.remove(model);
        },
        _setupContentsArray: function _setupContentsArray(contents) {
            var _this = this;

            // Store references to the contents
            this._contents = contents;

            // Register event handlers
            contents.forEach(function (modelOrCollection) {
                // Only need to register event handlers for collections
                if (modelOrCollection instanceof Backbone.Collection) {
                    _this.listenTo(modelOrCollection, "reset sort", _this._subCollectionResetHandler);
                    _this.listenTo(modelOrCollection, "add", _this._subCollectionAddHandler);
                    _this.listenTo(modelOrCollection, "remove", _this._subCollectionRemoveHandler);
                }
            });
        },
        constructor: function constructor() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            this._setupContentsArray(args);
            this.__super(this._getModelArray());
        },


        /**
         * Sets the contents of the concatenated collection. Fires a reset on the collection with the new contents.
         */
        setContents: function setContents() {
            // Unregister existing event handlers
            this.stopListening();

            // Set up the contents and reset

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            this._setupContentsArray(args);
            this.reset(this._getModelArray());
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);

    /**
     * Represents a recipient of a share. Used in the share menu when creating a share.
     *
     * <p>A share recipient can either be a registered user, or a new user identified by an email address.</p>
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipient
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            user: null,
            email: "",
            selected: false
        },

        computed: {
            displayName: {
                deps: ["user", "email"],
                value: function value(user, email) {
                    return user && user.get("displayName") || email || "";
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var Configuration = __webpack_require__(27);
var Storage = __webpack_require__(34);

var C3_API_BASE_URI = "" + Configuration.c3ApibaseUrl,
    token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"),
    BEARER_TOKEN = "Bearer " + token;

var createC3Experience = exports.createC3Experience = function createC3Experience(experienceJSON) {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(C3_API_BASE_URI + "/v1/experiences", {
        body: JSON.stringify(experienceJSON),
        headers: {
            "Content-Type": "application/json",
            Authorization: BEARER_TOKEN
        },
        method: "POST"
    }).then(function (response) {
        return response.json();
    });
};

var copyExperienceAsVariant = exports.copyExperienceAsVariant = function copyExperienceAsVariant(copyExperienceJSON) {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(C3_API_BASE_URI + "/v1/copyExperienceAsVariant", {
        body: JSON.stringify(copyExperienceJSON),
        headers: {
            "Content-Type": "application/json",
            Authorization: BEARER_TOKEN
        },
        method: "POST"
    }).then(function (response) {
        return response.json();
    });
};

var updateC3ExpCollection = exports.updateC3ExpCollection = function updateC3ExpCollection(collectionJSON) {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(C3_API_BASE_URI + "/v1/experienceCollections/" + collectionJSON.id, {
        body: JSON.stringify(collectionJSON),
        headers: {
            "Content-Type": "application/json",
            Authorization: BEARER_TOKEN
        },
        method: "PUT"
    }).then(function (response) {
        return response.json();
    });
};

var getC3ExpCollectionById = exports.getC3ExpCollectionById = function getC3ExpCollectionById(collectionId) {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(C3_API_BASE_URI + "/v1/experienceCollections/" + collectionId, {
        method: "GET",
        headers: {
            Authorization: BEARER_TOKEN
        }
    }).then(function (response) {
        return response.json();
    });
};

var getC3ExperienceById = exports.getC3ExperienceById = function getC3ExperienceById(experienceId) {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: C3_API_BASE_URI");

    return fetch(C3_API_BASE_URI + "/v1/experiences/" + experienceId, {
        method: "GET",
        headers: {
            Authorization: BEARER_TOKEN
        }
    }).then(function (response) {
        return response.json();
    });
};

var c3CreateVariantFromParent = exports.c3CreateVariantFromParent = function c3CreateVariantFromParent(parentExperienceId, variantExperienceId) {
    if (!token) throw new Error("Missing Token");
    if (!C3_API_BASE_URI) throw new Error("Missing Environment Configuration: NEXT_PUBLIC_C3_API_BASE_URI");

    return fetch(C3_API_BASE_URI + "/v1/experienceVariantFromParent?parentExperienceId=" + parentExperienceId + "&variantExperienceId=" + variantExperienceId, {
        headers: {
            Authorization: "Bearer " + token
        },
        method: "POST"
    }).then(function (response) {
        return response.json();
    });
};

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var DragSelect = __webpack_require__(2975);
    var AddWidgetsAction = __webpack_require__(370);
    var BackdropViewer = __webpack_require__(2976);
    var DropAreaHotspot = __webpack_require__(398);
    var EditorActivities = __webpack_require__(361);
    var EditorActivityManager = __webpack_require__(197);
    var EditorEvents = __webpack_require__(17);
    var Effect = __webpack_require__(78);
    var ImprovedView = __webpack_require__(6);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var SceneDropHandler = __webpack_require__(2977);
    var SceneEditorLoadingScreen = __webpack_require__(2978);
    var SceneRulers = __webpack_require__(2982);
    var SceneWidgetCollectionViewsLayout = __webpack_require__(2990);
    var Snap = __webpack_require__(3013);
    var SyncManager = __webpack_require__(44);
    var template = __webpack_require__(3015);
    var Tooltip = __webpack_require__(35);
    var WidgetGroup = __webpack_require__(401);
    var WidgetTypes = __webpack_require__(69);
    var EditorEventFilters = __webpack_require__(154).default;

    var _require2 = __webpack_require__(551),
        mapWidgetMetaData = _require2.mapWidgetMetaData;

    var NotificationBar = __webpack_require__(53);
    var ImageToggleEffectModel = __webpack_require__(301);
    var OpacityEffectModel = __webpack_require__(245);

    var log = new Logger("SceneEditor");
    var SCENE_MARGIN = 20;

    return ImprovedView.extend({

        tagName: "div",

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                widgetBoundaryClass: this.viewModel.get("showMasterLayers") ? "master-layers-on" : "master-layers-off",
                spectatorMode: this.viewScope.spectatorMode
            };
        },


        className: "scene-editor",

        experienceModel: null,

        // the editor view model
        viewModel: null,

        _dropHandler: null,

        _sceneClassName: "",

        sceneWidgetCollectionView: null,

        dragSelect: null,

        dragSelectMouseCoords: null,

        ui: {
            guidelinesContainer: ".guidelines-container",
            widgetContainer: ".widgets-container",
            containerBorder: ".container-border",
            sceneFooter: ".scene-footer",
            moveSceneForwards: ".move-scene-forwards",
            moveSceneBackwards: ".move-scene-backwards",
            widgetsBoundary: ".widgets-boundary",
            horizontalRuler: ".horizontal-ruler",
            verticalRuler: ".vertical-ruler",

            snapReplacement: ".snap-replacement",
            snapLineVertical: ".snap-line.vertical",
            snapLineHorizontal: ".snap-line.horizontal",
            snapCross: ".snap-cross",
            deleteScene: ".delete-scene",
            duplicateScene: ".duplicate-scene",
            sceneWidgetCollectionViewsRegionContainer: ".scene-widget-collection-views-region-container"
        },

        regions: {
            sceneWidgetCollectionViewsRegion: ".scene-widget-collection-views-region-container",
            backdropRegion: ".master-layer.backdrop",
            guidelinesContainer: ".guidelines-container",
            loadingRegion: ".scene-loading-region"
        },

        events: {
            "click @ui.deleteScene": "_deleteSceneClickHandler",
            "click @ui.duplicateScene": "duplicate",
            "mousedown @ui.widgetContainer": "handleMouseDownEvent",
            "drop @ui.widgetContainer": "handleDropEvent",
            dragover: "_onDragOver",
            "click @ui.moveSceneForwards": "_onClickMoveSceneForwards",
            "click @ui.moveSceneBackwards": "_onClickMoveSceneBackwards"
        },

        _onChangeSceneNumber: function _onChangeSceneNumber() {
            // Whenever we switch scenes, we should clear any widget selection
            this.viewModel.selection.clear();
            this._updateToCurrentScene();
        },


        modelEvents: {
            "addWidgets": "_addWidgetsHandler",
            "selectWidgets": "_selectWidgetHandler",
            "change:id": "_updateToCurrentScene",
            "change:sceneNumber": "_onModelChangeSceneNumber",
            // Both of these calls need to happen because we can not guarantee if each will happen and in what order.
            "change:widgetTabOrder": "_onModelChangeWidgetTabOrder",
            "change:removedWidgetTabOrder": "_onModelChangeRemovedWidgetTabOrder",
            "change:widgetTabOrderMetaData": "_onModelChangeWidgetTabOrderMetaData",
            "change:removedWidgetTabOrderMetaData": "_onModelChangeRemovedWidgetTabOrderMetaData"
        },

        bindings: {
            ".scene-index": "sceneNumber"
        },

        behaviors: {
            dropAreaHotspot: {
                behaviorClass: DropAreaHotspot,
                message: "<strong>Drop image(s)</strong> here to add directly<br>to Scene and Image Library",
                dropAreaSelector: ".widgets-container",
                iconSize: "large",
                uploadEnabled: false
            },

            snapping: {
                behaviorClass: Snap
            }
        },

        initialize: function initialize(_ref) {
            var _this = this;

            var viewScope = _ref.viewScope,
                experienceModel = _ref.experienceModel;

            this.experienceModel = experienceModel;
            this.viewModel = viewScope.viewModel;

            var sceneEditor = this;

            this._dropHandler = new SceneDropHandler(this);
            this.listenTo(this._dropHandler, SceneDropHandler.ADD_UPLOAD_BARS, this._addUploadBars);

            this.listenTo(this.experienceModel, "change:width change:height", this.render);

            this.listenTo(this.experienceModel, "change:width change:height", this._resetDragSelect);
            this.listenTo(this.experienceModel, "change:emailModeEnabled", function () {
                _this._highlightEmailOverlappedWidgets();
                _this._resetWidgetAction();
                _this._toggleSceneEnabled();
            });

            // Make sure no widgets are selected after a fetch, i.e. user action on error like "refresh",
            // since the old selection would be off sometimes, e.g. if the widgets have changed position
            // or what not...
            SyncManager.onSync({
                context: this,
                target: this.experienceModel,
                method: "fetch",
                callback: function callback() {
                    _.defer(function () {
                        sceneEditor.viewModel.selection.clear();
                    });
                }
            });

            this.listenTo(experienceModel.get("scenes"), "getEmailActionWidgetsBoundingBoxes", this._getEmailActionWidgetsBoundingBoxes);
            this.listenTo(experienceModel.get("overlayScene"), "selectWidgets", this._selectWidgetHandler);
            this.listenTo(experienceModel.get("backgroundScene"), "selectWidgets", this._selectWidgetHandler);

            this.listenTo(this.viewModel, { "change:sceneNumber": this._updateToCurrentScene });

            this.listenTo(this.viewModel, { "change:sceneNumber": this._initializeDragSelect });

            this.listenTo(this.viewModel, { "change:sceneNumber": this._onModelChangeSceneNumber });

            this.listenTo(this.viewModel.get("zoomModel"), { "change:scale": this._updateToCurrentScaleFactor });
            this.listenTo(this.viewModel, "change:currentLayer", this._onSceneLayerChanged);

            this.sceneRulers = new SceneRulers({ sceneEditor: this, viewScope: this.options.viewScope });

            this.listenTo(this.model.get("widgets"), "change:isLocked", this._changeWidgetLockStatus);
            this.listenTo(experienceModel.get("overlayScene").get("widgets"), "change:isLocked", this._changeWidgetLockStatus);
            this.listenTo(experienceModel.get("backgroundScene").get("widgets"), "change:isLocked", this._changeWidgetLockStatus);

            this.listenTo(experienceModel.get("overlayScene"), "change:widgetTabOrder", this._onModelChangeWidgetTabOrder);
            this.listenTo(experienceModel.get("overlayScene"), "change:removedWidgetTabOrder", this._onModelChangeRemovedWidgetTabOrder);

            this.listenTo(experienceModel.get("backgroundScene"), "change:widgetTabOrder", this._onModelChangeWidgetTabOrder);
            this.listenTo(experienceModel.get("backgroundScene"), "change:removedWidgetTabOrder", this._onModelChangeRemovedWidgetTabOrder);

            this.listenTo(EditorEvents, "undo:activity redo:activity", this._resetDragSelect);
        },
        _changeWidgetLockStatus: function _changeWidgetLockStatus(widget) {
            var _this2 = this;

            _.defer(function () {
                _this2._resetDragSelect();
                _this2.dragSelect.clearSelection();

                // after widget is unlocked it should be selected
                if (!widget.get("isLocked")) {
                    _this2._selectWidgetHandler([widget]);
                    widget.trigger("forceWidgetUpdate");
                }
            });
        },
        _removeOverlapping: function _removeOverlapping(widget) {
            widget.set({ overlapped: false });
        },
        _resetWidgetOverlapping: function _resetWidgetOverlapping() {
            var _this3 = this;

            var isEmailModeEnabled = this.experienceModel.get("emailModeEnabled");
            var resetOverlapping = function resetOverlapping(collection) {
                collection.each(function (item) {
                    if (item.model.get("group")) {
                        resetOverlapping(item.groupCollectionView.children);
                        return;
                    }
                    _this3._removeOverlapping(item.model);
                });
            };

            if (isEmailModeEnabled) {
                resetOverlapping(this.sceneWidgetCollectionView.sceneWidgetCollectionView.children);
                resetOverlapping(this.sceneWidgetCollectionView.overlayWidgetCollectionView.children);
                resetOverlapping(this.sceneWidgetCollectionView.backgroundWidgetCollectionView.children);
            }
        },
        _resetWidgetAction: function _resetWidgetAction() {
            var isEmailModeEnabled = this.experienceModel.get("emailModeEnabled");
            var removedIncompatibleWidgetActionOrEffect = false;
            var resetAction = function resetAction(collection) {
                collection.each(function (item) {
                    if (item.model.get("group")) {
                        resetAction(item.groupCollectionView.children);
                        return;
                    }
                    var action = item.model.get("action");
                    var effects = item.model.get("effects");

                    // Remove all attention effects (in background)
                    var attentionEffects = effects.findWhere({ triggerType: Effect.TRIGGER_TYPE_ATTENTION });
                    if (attentionEffects) {
                        removedIncompatibleWidgetActionOrEffect = true;
                        effects.remove(attentionEffects);
                    }

                    // Remove inappropriate hover effects (in background)
                    // Only opacity and image swapping allowed.
                    var inappropriateHoverEffect = effects.models.find(function (effect) {
                        return effect.get("type") !== ImageToggleEffectModel.TYPE && effect.get("type") !== OpacityEffectModel.TYPE;
                    });
                    if (inappropriateHoverEffect) {
                        removedIncompatibleWidgetActionOrEffect = true;
                        effects.remove(inappropriateHoverEffect);
                    }

                    if (action && action.get("type") !== "link") {
                        removedIncompatibleWidgetActionOrEffect = true;
                        item.model.set({ action: null });
                    }
                });
            };

            if (isEmailModeEnabled) {
                resetAction(this.sceneWidgetCollectionView.sceneWidgetCollectionView.children);
                resetAction(this.sceneWidgetCollectionView.overlayWidgetCollectionView.children);
                resetAction(this.sceneWidgetCollectionView.backgroundWidgetCollectionView.children);
            }

            if (removedIncompatibleWidgetActionOrEffect) {
                NotificationBar.open("We have removed actions/animations that are not compatible with email mode from your widgets where applicable.", { closeDelay: 5000 });
            }
        },
        _toggleSceneEnabled: function _toggleSceneEnabled() {
            var isEmailModeEnabled = this.experienceModel.get("emailModeEnabled");
            var isDisabled = !this.viewModel.isOnSceneLayer();
            this.ui.duplicateScene.toggleClass("disabled", isDisabled || isEmailModeEnabled);
        },
        _showHideDisableDuplicateButtons: function _showHideDisableDuplicateButtons() {
            var isDisabled = !this.viewModel.isOnSceneLayer();

            this.ui.deleteScene.toggleClass("disabled", isDisabled);
            this.ui.duplicateScene.toggleClass("disabled", isDisabled);
            this.ui.moveSceneForwards.toggleClass("disabled", isDisabled);
            this.ui.moveSceneBackwards.toggleClass("disabled", isDisabled);

            Tooltip.remove(this.ui.deleteScene);
            Tooltip.remove(this.ui.duplicateScene);
            Tooltip.remove(this.ui.moveSceneForwards);
            Tooltip.remove(this.ui.moveSceneBackwards);

            if (isDisabled) {
                Tooltip.add(this.ui.deleteScene, {
                    content: "You can only delete the scene from the Scene layer",
                    placement: "bottom",
                    alignCenter: true,
                    offset: {
                        align: "center"
                    },
                    width: "auto",
                    delay: { show: 0, hide: 0 }
                });
                Tooltip.add(this.ui.duplicateScene, {
                    content: "You can only duplicate the scene from the Scene layer",
                    placement: "bottom",
                    alignCenter: true,
                    offset: {
                        align: "center"
                    },
                    width: "auto",
                    delay: { show: 0, hide: 0 }
                });

                Tooltip.add(this.ui.moveSceneForwards, {
                    content: "You can only move the scene from the Scene layer",
                    placement: "bottom",
                    alignCenter: true,
                    offset: {
                        align: "center"
                    },
                    width: "auto",
                    delay: { show: 0, hide: 0 }
                });
                Tooltip.add(this.ui.moveSceneBackwards, {
                    content: "You can only move the scene from the Scene layer",
                    placement: "bottom",
                    alignCenter: true,
                    offset: {
                        align: "center"
                    },
                    width: "auto",
                    delay: { show: 0, hide: 0 }
                });
            }
        },
        _onSceneLayerChanged: function _onSceneLayerChanged() {
            this._setTabOrderData();
            this._showHideDisableDuplicateButtons();
            this._initializeDragSelect();
            this._toggleSceneEnabled();
        },
        _getDragSelectSelectables: function _getDragSelectSelectables() {
            // Handle grouped widgets by removing widget-component elements that aren't direct
            // children of the element with the active-layer-widgets class from the selectables.
            // Have to do it in this convoluted way because DragSelect only accepts an HTMLCollection
            // or an array of HTMLElements but not a NodeList which would be returned by querySelectorAll().
            var selectableArray = Array.prototype.slice.call(document.getElementsByClassName("widget-component"));
            var selectables = [];
            switch (this.viewModel.get("currentLayer").value) {
                case "overlay":
                    selectables = selectableArray.filter(function (selectable) {
                        return selectable.parentElement.classList.contains("widget-collection-view-container-overlay");
                    });
                    break;
                case "background":
                    selectables = selectableArray.filter(function (selectable) {
                        return selectable.parentElement.classList.contains("widget-collection-view-container-background");
                    });
                    break;
                case "scene":
                    selectables = selectableArray.filter(function (selectable) {
                        return selectable.parentElement.classList.contains("widget-collection-view-container-scene");
                    });
                    break;
                default:
                    break;
            }
            return selectables.filter(function (element) {
                return !element.classList.contains("is-locked");
            });
        },
        _onModelChangeSceneNumber: function _onModelChangeSceneNumber() {
            this._setTabOrderData();
            // Whenever we switch scenes, we should clear any widget selection
            this.viewModel.selection.clear();
            this._updateToCurrentScene();
        },
        _onModelChangeWidgetTabOrderMetaData: function _onModelChangeWidgetTabOrderMetaData() {
            this.viewModel.trigger("nestedWidgetTabOrderMetaDataChange");
        },
        _onModelChangeWidgetTabOrder: function _onModelChangeWidgetTabOrder() {
            this._setTabOrderData();
            this.viewModel.trigger("nestedWidgetTabOrderMetaDataChange");
        },
        _onModelChangeRemovedWidgetTabOrderMetaData: function _onModelChangeRemovedWidgetTabOrderMetaData() {
            this.viewModel.trigger("nestedWidgetTabOrderMetaDataChange");
        },
        _onModelChangeRemovedWidgetTabOrder: function _onModelChangeRemovedWidgetTabOrder() {
            this._setTabOrderData();
            this.viewModel.trigger("nestedWidgetTabOrderMetaDataChange");
        },


        /**
         * Adds an overlay (if it doesn't already exists) to the scene and sets up loading bars
         * based on the ImageModels passed in.
         *
         * @param {ImageModel[]} imageModels Array of <tt>ImageModel</tt>'s
         */
        _addUploadBars: function _addUploadBars(imageModels) {
            var _this4 = this;

            if (!this._sceneLoadingScreen) {
                this._sceneLoadingScreen = new SceneEditorLoadingScreen();

                this._sceneLoadingScreen.once(SceneEditorLoadingScreen.UPLOADS_DONE, function () {
                    _this4.loadingRegion.close();
                    _this4._sceneLoadingScreen = null;
                });

                this.loadingRegion.show(this._sceneLoadingScreen);
            }

            this._sceneLoadingScreen.addUploads(imageModels);
        },
        _onDragOver: function _onDragOver(event) {
            event.preventDefault();
        },
        _onClickMoveSceneForwards: function _onClickMoveSceneForwards() {
            if (this.ui.moveSceneForwards.hasClass("disabled")) {
                return;
            }

            this._moveScene("forwards", "last");
        },
        _onClickMoveSceneBackwards: function _onClickMoveSceneBackwards() {
            if (this.ui.moveSceneBackwards.hasClass("disabled")) {
                return;
            }

            this._moveScene("backwards", "first");
        },
        _updateToCurrentScaleFactor: function _updateToCurrentScaleFactor() {
            this._setBorder();
        },
        onRender: function onRender() {
            this._updateToCurrentScene();
            this._setBorder();

            this.ui.widgetContainer.css({
                width: this.experienceModel.get("width"),
                height: this.experienceModel.get("height")
            });

            this.sceneWidgetCollectionView = new SceneWidgetCollectionViewsLayout({
                viewScope: this.options.viewScope,
                scene: this.model
            });

            // This is basically checking if it's a re-render (where onShow
            // won't be called). Happens when resizing the scenes.
            if (this._isShown) {
                this.sceneWidgetCollectionViewsRegion.show(this.sceneWidgetCollectionView);
                this._showBackdrop();
            } else {
                // set listeners on widgets added to the overlay and background layers
                this.listenTo(this.options.viewScope.viewModel.get("experience").get("overlayScene"), "addWidgets", this._addWidgetsHandler);
                this.listenTo(this.options.viewScope.viewModel.get("experience").get("backgroundScene"), "addWidgets", this._addWidgetsHandler);
            }

            this.sceneRulers.render();
        },
        onShow: function onShow() {
            var _this5 = this;

            this._showHideDisableDuplicateButtons();
            this.sceneWidgetCollectionViewsRegion.show(this.sceneWidgetCollectionView);

            this._showBackdrop();

            // Listen to changes in toggling on/off
            this.listenTo(this.viewModel, "change:showMasterLayers", function (model, value) {
                _this5.ui.widgetsBoundary.toggleClass("master-layers-on", value).toggleClass("master-layers-off", !value);
            });

            this.listenTo(this.experienceModel.get("backdrop"), "change:color change:image", this._toggleTransparentBackdropClass);
            this._toggleTransparentBackdropClass();

            this.sceneRulers.render();

            this._initializeDragSelect();
            this._initializeTabOrderListeners();
            this._setTabOrderData();
            this._toggleSceneEnabled();
            this._highlightEmailOverlappedWidgets();
        },
        _initializeTabOrderListeners: function _initializeTabOrderListeners() {
            this.listenTo(this.model.get("widgets"), {
                "change:action change:effects": this._removeOverlapping,
                "change:effects add": this._highlightEmailOverlappedWidgets,
                "change": this._widgetChange,
                "add": this._resetWidgetAction,
                "remove": this._deleteWidgetFromTabOrder
            });
            this.listenTo(this.experienceModel.get("backgroundScene").get("widgets"), {
                "change:action change:effects": this._removeOverlapping,
                "change:effects add": this._highlightEmailOverlappedWidgets,
                "change ": this._widgetChange,
                "add": this._resetWidgetAction,
                "remove": this._deleteWidgetFromTabOrder
            });
            this.listenTo(this.experienceModel.get("overlayScene").get("widgets"), {
                "change:action change:effects": this._removeOverlapping,
                "change:effects add": this._highlightEmailOverlappedWidgets,
                "change": this._widgetChange,
                "add": this._resetWidgetAction,
                "remove": this._deleteWidgetFromTabOrder

            });
        },
        _updateWidgetTabOrderMetaData: function _updateWidgetTabOrderMetaData(changedWidget, target) {
            var uuid = changedWidget.get("uuid");
            var activeLayer = this.viewModel.get("activeLayerSceneModel");
            var nextWidgetTabOrderMetaData = activeLayer.get(target).map(function (widgetTabOrderMetaData) {
                if (widgetTabOrderMetaData.id === uuid) {
                    return mapWidgetMetaData({ widget: changedWidget });
                }

                return widgetTabOrderMetaData;
            });

            activeLayer.set(target, nextWidgetTabOrderMetaData, { cause: EditorEventFilters.SUPERFICIAL });
        },


        /**
         * Updates metadata for Tab Order in response to change events on widget models.
         *
         * @param {Widget} changedWidget Widget object
         * @param {EventOptions} options Backbone event options. Set "shouldUpdateTabOrder" to false to ignore in this handler.
         */
        _widgetChange: function _widgetChange(changedWidget, options) {
            var _options$shouldUpdate = options.shouldUpdateTabOrder,
                shouldUpdateTabOrder = _options$shouldUpdate === undefined ? true : _options$shouldUpdate;

            if (!shouldUpdateTabOrder) {
                // Updates to tabOrderMetaData are expensive, ignore high volume events by setting their "shouldUpdateTabOrder" option to false.
                // ex: text widget updates to "text" property, tabOrderMetaData will be updated when the widget selection state changes
                // so updating as a user types is unnecessary.
                return;
            }
            // UUID which is set by a computed field and isn't part of the add event.
            var isNewWidget = !!changedWidget.changed.uuid || !!changedWidget.changed.uuidSet;
            if (isNewWidget) {
                this._addWidgetToTabOrder(changedWidget);
            }
            this._updateWidgetTabOrderMetaData(changedWidget, "widgetTabOrderMetaData");
            this._updateWidgetTabOrderMetaData(changedWidget, "removedWidgetTabOrderMetaData");

            this._highlightEmailOverlappedWidgets();
        },
        _highlightEmailOverlappedWidgets: function _highlightEmailOverlappedWidgets() {
            var _this6 = this;

            var isEmailModeEnabled = this.experienceModel.get("emailModeEnabled");
            var highlight = function highlight(widgets, intersectedEmailWidgets) {
                _this6.viewModel.set({ hasOverlappedEmailWidgets: !!intersectedEmailWidgets.length });
                widgets.forEach(function (widget) {
                    var overlapped = isEmailModeEnabled && intersectedEmailWidgets.length > 1 ? intersectedEmailWidgets.indexOf(widget.uuid) !== -1 : false;
                    widget.model.set({ overlapped: overlapped });
                });
            };
            // this._resetWidgetOverlapping();
            this._getEmailActionWidgetsBoundingBoxes(highlight);
        },
        _addWidgetToTabOrder: function _addWidgetToTabOrder(widgetChange) {
            var activeLayer = this.viewModel.get("activeLayerSceneModel");
            var nextWidgetUUID = widgetChange.get("uuid");
            // without spreading the value changes mutate the source.
            var nextWidgetTabOrder = [].concat(_toConsumableArray(activeLayer.get("widgetTabOrder")));
            var nextWidgetTabOrderMetaData = [].concat(_toConsumableArray(activeLayer.get("widgetTabOrderMetaData")));

            if (typeof nextWidgetUUID !== "undefined" && !nextWidgetTabOrder.includes(nextWidgetUUID)) {
                nextWidgetTabOrder.push(nextWidgetUUID);
                nextWidgetTabOrderMetaData.push(mapWidgetMetaData({ widget: widgetChange }));
            }

            activeLayer.set("widgetTabOrder", nextWidgetTabOrder, { cause: EditorEventFilters.SUPERFICIAL });
            activeLayer.set("widgetTabOrderMetaData", nextWidgetTabOrderMetaData, { cause: EditorEventFilters.SUPERFICIAL });
        },
        _deleteWidgetFromTargetTabOrder: function _deleteWidgetFromTargetTabOrder(uuidToDelete, target) {
            var activeLayer = this.viewModel.get("activeLayerSceneModel");
            var widgetTabOrder = target;
            var widgetTabOrderMetaData = target + "MetaData";
            var nextWidgetTabOrder = [].concat(_toConsumableArray(activeLayer.get(widgetTabOrder)));
            var nextWidgetTabOrderMetaData = [].concat(_toConsumableArray(activeLayer.get(widgetTabOrderMetaData)));
            var prunedWidgetTabOrder = nextWidgetTabOrder.filter(function (widgetUuid) {
                return widgetUuid !== uuidToDelete;
            });
            var prunedWidgetTabOrderMetaData = nextWidgetTabOrderMetaData.filter(function (widgetMetaData) {
                return widgetMetaData.id !== uuidToDelete;
            });
            activeLayer.set(widgetTabOrder, prunedWidgetTabOrder, { cause: EditorEventFilters.SUPERFICIAL });
            activeLayer.set(widgetTabOrderMetaData, prunedWidgetTabOrderMetaData, { cause: EditorEventFilters.SUPERFICIAL });
        },
        _deleteWidgetFromTabOrder: function _deleteWidgetFromTabOrder(deletedWidget) {
            var uuidToDelete = deletedWidget.get("uuid");
            this._deleteWidgetFromTargetTabOrder(uuidToDelete, "widgetTabOrder");
            this._deleteWidgetFromTargetTabOrder(uuidToDelete, "removedWidgetTabOrder");
            this._highlightEmailOverlappedWidgets();
        },
        _setTabOrderData: function _setTabOrderData() {
            var activeLayer = this.viewModel.get("activeLayerSceneModel");
            // Guarding against possible null widgetTabOrder data.
            var currentTabOrder = activeLayer.get("widgetTabOrder").filter(function (widgetTabOrder) {
                return !!widgetTabOrder;
            });

            var currentRemovedTabOrder = activeLayer.get("removedWidgetTabOrder");

            var defaultWidgetOrder = [].concat(_toConsumableArray(activeLayer.get("widgets").models))
            // When widgets are cloned they don't have a UUID yet.
            .filter(function (widget) {
                return widget.has("uuid");
            });

            var widgetTabOrder = currentTabOrder.length > 0 || currentRemovedTabOrder.length > 0 ? currentTabOrder : defaultWidgetOrder.map(function (widget) {
                return widget.get("uuid");
            });

            var widgetTabOrderMetaData = [];

            widgetTabOrder.forEach(function (widgetUUID) {
                var targetWidget = defaultWidgetOrder.find(function (widget) {
                    return widget.get("uuid") === widgetUUID;
                });
                if (targetWidget) {
                    widgetTabOrderMetaData.push(mapWidgetMetaData({ widget: targetWidget }));
                }
            });

            var removedWidgetTabOrderMetaData = [];
            currentRemovedTabOrder.forEach(function (widgetUUID) {
                var targetWidget = defaultWidgetOrder.find(function (widget) {
                    return widget.get("uuid") === widgetUUID;
                });
                if (targetWidget) {
                    removedWidgetTabOrderMetaData.push(mapWidgetMetaData({ widget: targetWidget }));
                }
            });

            activeLayer.set("widgetTabOrderMetaData", widgetTabOrderMetaData, { cause: EditorEventFilters.SUPERFICIAL });
            activeLayer.set("removedWidgetTabOrderMetaData", removedWidgetTabOrderMetaData, { cause: EditorEventFilters.SUPERFICIAL });
            if (!currentTabOrder || currentTabOrder.length === 0) {
                activeLayer.set("widgetTabOrder", widgetTabOrder, { cause: EditorEventFilters.SUPERFICIAL });
            }
        },
        _initializeDragSelect: function _initializeDragSelect() {
            var _this7 = this;

            if (this.dragSelect) {
                // Stop Drag Select that are not related to current scene
                this.dragSelect.stop();
            }
            if (this.viewScope.viewModel.get("sceneNumber") === this.model.get("sceneNumber")) {
                // By default, DragSelect adds an onClick handler to each selectable element.
                // We don't want this to interfere with our own handling, so we disable it.
                // It's a bit ugly but the text widget has some fairly complex handling around
                // what happens when you click on the border vs inside the widget that it
                // seemed undesirable to import here.
                DragSelect.prototype._onClick = function () {};

                var viewportElement = this.ui.widgetsBoundary.parents(".viewport")[0];

                this.dragSelect = new DragSelect({
                    area: viewportElement,
                    selectables: this._getDragSelectSelectables(),
                    // Disable drag select when we're dragging elements to move them.
                    onDragStartBegin: function onDragStartBegin(event) {
                        if (!_this7.viewModel.selection.isEmpty() || event.target.getAttribute("data-dragselectable") !== "true") {
                            _this7.dragSelect.break();
                        }
                        _this7.dragSelectMouseCoords = {
                            startX: event.clientX,
                            startY: event.clientY
                        };
                    },
                    callback: function callback(elements, event) {
                        _this7.viewModel.set("isSelectingElements", true);
                        if (elements.length > 0 && event.type === "mouseup") {
                            _this7.dragSelectMouseCoords.endX = event.clientX;
                            _this7.dragSelectMouseCoords.endY = event.clientY;
                            var currentSceneNumber = _this7.viewModel.get("sceneNumber");
                            var selectedElementsToAppend = [];
                            // Get widgets on current layer
                            var sceneActiveLayerWidgets = _this7.sceneWidgetCollectionView.activeLayerWidgetCollectionView().children;
                            // Get widgets views on current layer
                            var sceneActiveLayerWidgetsViews = sceneActiveLayerWidgets._views;
                            for (var j = 0; j < elements.length; j++) {
                                var elementId = elements[j].id;
                                if (sceneActiveLayerWidgetsViews.hasOwnProperty(elementId)) {
                                    var elementCoords = elements[j].getBoundingClientRect();
                                    if (_this7._isElementInSelectionArea(_this7.dragSelectMouseCoords, elementCoords)) {
                                        var widgetSceneNumber = sceneActiveLayerWidgetsViews[elementId].model.collection.scene.get("sceneNumber");
                                        switch (widgetSceneNumber) {
                                            case currentSceneNumber:
                                            case "overlay":
                                            case "background":
                                                selectedElementsToAppend.push(sceneActiveLayerWidgetsViews[elementId]);
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                }
                            }

                            _this7.viewModel.selection.append(selectedElementsToAppend);
                        }
                    }
                });

                // Grouping/ungrouping changes structure of widgets so we need to
                // reload the drag select selectables list and set the selection
                // to the new composite widget.
                this.listenTo(WidgetGroup, "group", function () {
                    _this7._syncDragSelectFromViewModel();
                });
                this.listenTo(WidgetGroup, "ungroup", function () {
                    _this7._syncDragSelectFromViewModel();
                });
            }
        },
        _syncDragSelectFromViewModel: function _syncDragSelectFromViewModel() {
            var _this8 = this;

            this._resetDragSelect();
            this.dragSelect.clearSelection();
            this.viewModel.selection.get("widgets").forEach(function (widget) {
                _this8.dragSelect.addSelection(widget.el);
            });
        },
        _isElementInSelectionArea: function _isElementInSelectionArea(dragSelectMouseCoords, elementCoords) {
            switch (true) {
                // Selecting widgets from right to left
                case dragSelectMouseCoords.startX > this.dragSelectMouseCoords.endX:
                    switch (true) {
                        case dragSelectMouseCoords.startY > dragSelectMouseCoords.endY:
                            return this._calculateElementInRegion(dragSelectMouseCoords.endX, dragSelectMouseCoords.endY, dragSelectMouseCoords.startX, dragSelectMouseCoords.startY, elementCoords);
                        case dragSelectMouseCoords.startY < dragSelectMouseCoords.endY:
                            return this._calculateElementInRegion(dragSelectMouseCoords.endX, dragSelectMouseCoords.startY, dragSelectMouseCoords.startX, dragSelectMouseCoords.endY, elementCoords);
                        default:
                            break;
                    }
                    break;
                // Selecting widgets from left to right
                case dragSelectMouseCoords.startX < dragSelectMouseCoords.endX:
                    switch (true) {
                        // Select widgets from bottom to top
                        case dragSelectMouseCoords.startY > dragSelectMouseCoords.endY:
                            return this._calculateElementInRegion(dragSelectMouseCoords.startX, dragSelectMouseCoords.endY, dragSelectMouseCoords.endX, dragSelectMouseCoords.startY, elementCoords);
                        // Select widgets from top to bottom
                        case dragSelectMouseCoords.startY < dragSelectMouseCoords.endY:
                            return this._calculateElementInRegion(dragSelectMouseCoords.startX, dragSelectMouseCoords.startY, dragSelectMouseCoords.endX, dragSelectMouseCoords.endY, elementCoords);
                        default:
                            break;
                    }
                    break;
                default:
                    break;
            }
        },
        _calculateElementInRegion: function _calculateElementInRegion(mouseStartX, mouseStartY, mouseEndX, mouseEndY, elementCoords) {
            if (elementCoords.left > mouseStartX && elementCoords.top > mouseStartY) {
                if (elementCoords.left + elementCoords.width < mouseEndX && elementCoords.top + elementCoords.height < mouseEndY) {
                    return true;
                }
            }
        },
        _resetDragSelect: function _resetDragSelect() {
            var selectables = this._getDragSelectSelectables();
            if (this.dragSelect) {
                this.dragSelect.setSelectables(selectables);
            }
        },


        _showBackdrop: function _showBackdrop() {
            this.backdropRegion.show(new BackdropViewer({
                model: this.experienceModel.get("backdrop"),
                experience: this.experienceModel
            }));
        },

        _initializeOverlayAndBackground: function _initializeOverlayAndBackground() {
            // All other scenes than the overlay will show a backdrop
            if (!this.model.get("isOverlayScene")) {
                this.backdropRegion.show(new BackdropViewer({
                    model: this.experienceModel.get("backdrop"),
                    experience: this.experienceModel
                }));
            }
        },
        _toggleTransparentBackdropClass: function _toggleTransparentBackdropClass() {
            var backdrop = this.experienceModel.get("backdrop");
            var isTransparent = backdrop.isTransparent();
            var backgroundIsColor = !backdrop.isTypeImage();

            this.ui.widgetsBoundary.toggleClass("backdrop-is-transparent", isTransparent && backgroundIsColor);
        },
        viewportBoundingBoxProvider: function viewportBoundingBoxProvider() {
            return this.options.viewScope.getViewportElement().get(0).getBoundingClientRect();
        },
        _setBorder: function _setBorder() {
            var size = this.experienceModel.getSize();
            var scale = this.viewModel.get("zoomModel").get("scale");

            this.ui.containerBorder.css({
                width: size.width * scale,
                height: size.height * scale
            });
        },
        _updateToCurrentScene: function _updateToCurrentScene() {
            var currentSceneNumber = this.viewModel.get("sceneNumber").toString();
            var sceneNumber = this.model.get("sceneNumber").toString();

            this.$el.toggleClass("current", currentSceneNumber === sceneNumber);
            this.$el.removeClass(this._sceneClassName);
            this._sceneClassName = this.model.get("id");
            this.$el.addClass(this._sceneClassName);
        },
        _isScene: function _isScene(position) {
            var allScenes = this.experienceModel.get("scenes");
            var sceneIndex = allScenes.indexOf(this.model);

            switch (position) {
                case "first":
                    return sceneIndex === 0;

                case "last":
                    return sceneIndex === allScenes.length - 1;

                default:
                    return false;
            }
        },
        _handleNewWidgets: function _handleNewWidgets(widgetModels) {
            var _this9 = this;

            this.viewModel.set("sceneNumber", this.model.get("sceneNumber"));
            new AddWidgetsAction(this.model, widgetModels, this.viewModel).execute().done(function () {
                _this9._expandSidebar(widgetModels);

                widgetModels.forEach(function (widgetModel) {
                    widgetModel.trigger("dropped:to:scene");

                    var eventProperties = {
                        widgetType: widgetModel.get("type"),
                        experienceId: _this9.experienceModel.get("id"),
                        experienceVersion: _this9.experienceModel.get("version"),
                        experiencePushedVersion: _this9.experienceModel.get("pushedVersion"),
                        sceneNumber: _this9.viewModel.get("activeLayerSceneModel").get("sceneNumber"),
                        triggerOrigin: "SceneEditor"
                    };

                    EditorEvents.trigger(EditorEvents.constants.ADD_WIDGET, eventProperties);
                });
            });
        },
        handleMouseDownEvent: function handleMouseDownEvent(event) {
            // We listen to the mouseDown event to ensure the dropHandler receives an event with coordinates for widget creation.
            if (this.viewScope.getCursorWidgetType()) {
                var self = this;
                event.preventDefault();

                this._dropHandler.handleWidgetDropFromMouseDown(event, this.viewScope.getCursorWidgetType()).done(function (widgetModels) {
                    self._handleNewWidgets(widgetModels);
                });
            }
            this.viewScope.clearCursorWidgetType();
            this.viewScope.onSceneEditorClick(this.model);
        },


        // Things dropped on scene should be always possible to convert it into widget model objects,
        // anything crazy than that should be ignored
        handleDropEvent: function handleDropEvent(event) {
            var self = this;
            event.preventDefault();

            this._dropHandler.handle(event).done(function (widgetModels) {
                self._handleNewWidgets(widgetModels);
            });
        },


        // When adding a new widget we want to (possibly) expand the right pane in the sidebar
        _expandSidebar: function _expandSidebar(widgetModels) {
            if (widgetModels.length === 1) {
                var widgetType = widgetModels[0].get("type");
                var widgetDescriptor = WidgetTypes.lookup(widgetType);
                var expandProperty = widgetDescriptor.propertiesViewClass && widgetDescriptor.propertiesViewClass.EXPAND_PROPERTY;

                if (expandProperty) {
                    var propertyViewsState = this.viewModel.get("widgetPropertyViewsState");
                    propertyViewsState[expandProperty] = true;
                    this.viewModel.set("widgetPropertyViewsState", propertyViewsState);
                }
            }
        },


        /**
         * @param callback
         * @returns array
         * @private
         *
         * For Email purposes we need to separate widgets with action type "link"
         * and get bounding boxes for these widgets - so we could split experience screenshot based on these coordinates
         */
        _getEmailActionWidgetsBoundingBoxes: function _getEmailActionWidgetsBoundingBoxes(callback) {
            var _this10 = this;

            var boundingBoxes = [];
            var parseCollection = function parseCollection(collection) {
                var parentBoundingBox = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { top: 0, left: 0 };

                collection.each(function (item) {
                    if (item.model.get("group") && item.groupCollectionView) {
                        parseCollection(item.groupCollectionView.children, item.getBoundingBox());
                        return;
                    }
                    var action = item.model.get("action");
                    var effects = item.model.get("effects");
                    var hoverOpacity = null;
                    var hoverToggleImage = null;
                    effects.models.forEach(function (model) {
                        if (model.get("triggerType") === "hover") {
                            hoverOpacity = model.get("type") === "opacity" ? model.get("opacity") : null;
                            hoverToggleImage = model.get("type") === "imageToggle" ? model.get("src") : null;
                        }
                    });
                    if (action && action.get("type") === "link" || hoverOpacity || hoverToggleImage) {
                        var _item$getBoundingBox = item.getBoundingBox(),
                            top = _item$getBoundingBox.top,
                            left = _item$getBoundingBox.left,
                            height = _item$getBoundingBox.height,
                            width = _item$getBoundingBox.width;

                        boundingBoxes.push({
                            uuid: item.model.get("uuid"),
                            type: item.model.get("type"),
                            actionUrl: action && action.get("url"),
                            hoverOpacity: hoverOpacity,
                            hoverToggleImage: hoverToggleImage,
                            top: Math.round(top + parentBoundingBox.top),
                            left: Math.round(left + parentBoundingBox.left),
                            height: Math.round(height),
                            width: Math.round(width),
                            altText: action ? action.get("emailAltText") || action.get("url") : null,
                            label: _this10._getWidgetLabelForEmail(item),
                            model: item.model
                        });
                    }
                });
            };
            parseCollection(this.sceneWidgetCollectionView.sceneWidgetCollectionView.children);
            parseCollection(this.sceneWidgetCollectionView.overlayWidgetCollectionView.children);
            parseCollection(this.sceneWidgetCollectionView.backgroundWidgetCollectionView.children);

            return callback(boundingBoxes, this._getEmailWidgetsIntersections(boundingBoxes), this.model.getSceneIndex());
        },
        _getEmailWidgetsIntersections: function _getEmailWidgetsIntersections(boundingBoxes) {
            var intersectedEmailWidgets = [];
            boundingBoxes.forEach(function (widget) {
                var overlapped = boundingBoxes.find(function (widget2) {
                    return widget2.left <= widget.left + widget.width && widget.left <= widget2.left + widget2.width && widget2.top <= widget.top + widget.height && widget.top <= widget2.top + widget2.height && widget2.uuid !== widget.uuid;
                });
                if (overlapped) {
                    intersectedEmailWidgets.push(widget.uuid);
                }
            });
            return intersectedEmailWidgets;
        },
        _getWidgetLabelForEmail: function _getWidgetLabelForEmail(item) {
            var type = item.model.get("type");
            var buttonType = item.model.get("buttonType");
            if (type === "button" && buttonType !== "ICON_ONLY") {
                return item.model.get("label");
            } else if (type === "text-enhanced") {
                return item.model.get("rawText");
            }
            return null;
        },


        /**
         * Handles selecting multiple widgets when they get added. Newly added widgets need to be selected manually
         * as backbone insert widgets one by one, therefore cannot be configured to select multiple
         */
        _addWidgetsHandler: function _addWidgetsHandler(widgetModels) {
            var _this11 = this;

            var self = this;

            _.defer(function () {
                // for a copy/paste of multiple widgets this would select the last 2+ widgets
                var lastAddedWidgets = widgetModels.map(function (widget) {
                    return self.sceneWidgetCollectionView.activeLayerWidgetCollectionView().children.findByModel(widget);
                });
                _this11.viewScope.onWidgetsAdded(lastAddedWidgets);
                // Re-initialize drag select to pick up new widget.
                _this11._resetDragSelect();
            });
        },
        _selectWidgetHandler: function _selectWidgetHandler(widgetModels, showWidgetMenu) {
            var _this12 = this;

            if (showWidgetMenu) {
                this._expandSidebar(widgetModels);
            }
            var widgetViews = widgetModels.map(function (widget) {
                return _this12.sceneWidgetCollectionView.activeLayerWidgetCollectionView().children.findByModel(widget);
            });
            this.viewModel.selection.select(widgetViews);
        },


        /**
         * @private
         *
         * Handles the click events triggered by the delete scene button.
         *
         * If the experience only contains a single scene, it will destroy all
         * the widgets instead of removing the scene.
         */
        _deleteSceneClickHandler: function _deleteSceneClickHandler() {
            if (this.ui.deleteScene.hasClass("disabled")) {
                return;
            }

            var scenes = this.experienceModel.get("scenes"),
                index = scenes.indexOf(this.model);

            log.verbose("Delete scene clicked for: " + this.model, this.model);

            // If the experience only contains a single scene...
            if (scenes.length === 1) {
                // ...remove the widgets
                log.info("Removing all widgets for scene: " + this.model);
                var widgets = _.clone(this.model.get("widgets").models); // TODO: why do we need to clone array here?
                _.invoke(widgets, "destroy");
            } else if (index !== -1) {
                log.info("Deleting scene at index " + index + ": " + this.model + " -> " + this.experienceModel, this.experienceModel);
                // Remove the scene
                this.experienceModel.removeScene(this.model); // fire!
                // Register the activity to enable undo/redo of scene disposal
                EditorActivityManager.add(new EditorActivities.SceneDeletedActivity(this.model, this.experienceModel, index));
            }
        },


        // duplicate this scene
        duplicate: function duplicate() {
            if (this.ui.duplicateScene.hasClass("disabled")) {
                return;
            }

            var sceneNum = this.model.getSceneIndex();
            var clone = this.model.clone({ duplicate: true });
            var newSceneNum = sceneNum + 1;

            // "clone" still has old scene index at this point...
            log.info("Duplicating scene, inserting at index " + newSceneNum + ": " + clone + " -> " + this.experienceModel, this.experienceModel);
            this.experienceModel.addScene(newSceneNum, clone);
        },


        // This does not trigger a save of variants!...
        _moveScene: function _moveScene(direction, badPosition) {
            if (!this._isScene(badPosition)) {
                this.trigger("moveScene", direction);
            }
        },


        // Assuming the scene has the same size as the experience
        getSceneSize: function getSceneSize() {
            return this.viewScope.getExperienceSize();
        },
        onClose: function onClose() {
            // close all external addons
            this._dropHandler.close();
            if (this.dragSelect) {
                this.dragSelect.stop();
            }
        },
        isCurrentScene: function isCurrentScene() {
            // cast to string to handle example: `"3"` and `3`.
            // String instead of number as the background and overlay scenes have the sceneNumber `background` and `overlay` rather than a number.
            return this.viewModel.get("sceneNumber") + "" === this.model.get("sceneNumber") + "";
        }
    }, {
        SCENE_MARGIN: SCENE_MARGIN
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Matrix = __webpack_require__(204);
    var Transformable = __webpack_require__(1236);

    /**
     * An TGroup object inherits from the abstract class {@link Transformable}.
     * It is similar to an {@link TElement} object, but without an actual dom element.
     * This is mainly used in multiple-selection mode.
     *
     * @constructor
     */
    function TGroup(members) {
        this.members = members || [];

        this.width = 0;
        this.height = 0;

        this.matrix = new Matrix();
        this.startMatrix = new Matrix();
        this.endMatrix = new Matrix();
    }

    var abstractObj = new Transformable();

    TGroup.prototype = _.extend({}, abstractObj, {

        /**
         * add a member to the target group
         * @param t a transformable object
         */
        add: function add(t) {
            this.members.push(t);

            // update matrix and control
            this.matrix = this.getMatrix();
            this.draw();
        },


        /**
         * remove a member from the target group
         * @param t a transformable object
         */
        remove: function remove(t) {
            var index = _.indexOf(this.members, t);
            if (index > -1) {
                this.members.splice(index, 1);
            }

            // update matrix and control
            this.matrix = this.getMatrix();
            this.draw();
        },
        getControlsConf: function getControlsConf() {
            // Determine whether `edgeTranslate` should be enabled for `this` group; `true` if any
            // of the contained elements have `edgeTranslate` enabled.
            var edgeTranslate = !!_.find(this.members, function (element) {
                return element.getControlsConf().edgeTranslate;
            });

            return {
                scaleX: false,
                scaleY: false,
                scaleUniform: false,
                rotate: false,
                rotateScale: false,
                edgeTranslate: edgeTranslate
            };
        },


        /**
         * Transform the whole group. For the elements, it delegates to its own transform method
         *
         * @param preMatrix
         * @param postMatrix
         * @param regU
         * @param regV
         */
        transform: function transform(preMatrix, postMatrix, regU, regV) {
            abstractObj.transform.apply(this, arguments);

            this.members.forEach(function (member) {
                member.transform(preMatrix, postMatrix, regU, regV);
            });
        },
        translate: function translate(x, y) {
            abstractObj.transform.apply(this, arguments);

            _.invoke(this.members, "translate", x, y);
        },
        commit: function commit() {
            abstractObj.commit.apply(this);

            _.invoke(this.members, "commit");
        },
        setTransparency: function setTransparency(opacity) {
            _.invoke(this.members, "setTransparency", opacity);
        },
        updateFromTarget: function updateFromTarget() {
            abstractObj.updateFromTarget.apply(this);

            _.invoke(this.members, "updateFromTarget");
        },


        /**
         * Check if the target group has the TElement object
         *
         * @param t a transformable object
         * @returns {boolean} true if yes, false otherwise
         */
        has: function has(t) {
            return _.indexOf(this.members, t) > -1;
        },


        /**
         * Get the width dimension that this group takes up
         * @returns {int} the width
         */
        getWidth: function getWidth() {
            var xs = this._getAllAxis("x");
            return _.max(xs) - _.min(xs);
        },


        /**
         * Get the height dimension that this group takes up
         * @returns {int} the height
         */
        getHeight: function getHeight() {
            var ys = this._getAllAxis("y");
            return _.max(ys) - _.min(ys);
        },


        /**
         * Get the matrix of this group
         * @returns {*}
         */
        getMatrix: function getMatrix() {
            var x = _.min(this._getAllAxis("x"));
            var y = _.min(this._getAllAxis("y"));
            return new Matrix(1, 0, 0, 1, x, y);
        },


        // Currently you can't nest a group inside a group,
        // so this just returns the matrix.
        getMatrixWithParentOffset: function getMatrixWithParentOffset() {
            return this.getMatrix();
        },


        // get all axis of all members
        _getAllAxis: function _getAllAxis(axis) {
            var union = [];
            this.members.forEach(function (t) {
                union = _.union(union, t._getAxis(axis));
            });
            return union;
        },
        setAttr: function setAttr(attr, value) {
            // the group has no element, so only add to the elements inside
            _.invoke(this.members, "setAttr", attr, value);
        }
    });

    return TGroup;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var PolymorphicCollection = __webpack_require__(300);
    var GroupModel = __webpack_require__(104);
    var BreakpointGroup = __webpack_require__(97);
    var LocalizationGroup = __webpack_require__(232);
    var RestApi = __webpack_require__(29);

    /**
     * A collection of <tt>GroupModel</tt>'s.
     *
     * @see GroupModel
     *
     * @class GroupCollection
     *
     */
    var GroupCollection = PolymorphicCollection.extend("GroupCollection", {
        constructor: function constructor(attrs, options) {
            this.__super(attrs, options);

            this.options = options;
        },
        modelTypes: function modelTypes() {
            var map = {};

            map[BreakpointGroup.type] = BreakpointGroup;
            map[LocalizationGroup.type] = LocalizationGroup;

            return map;
        },


        defaultModelType: GroupModel,

        url: function url() {
            var assetId = this.options && this.options.assetId;

            if (assetId) {
                return RestApi.pathToSpecificResource(RestApi.Collections.GROUPS_ASSETS, assetId);
            }

            var groupId = this.options && this.options.groupId;

            if (groupId) {
                return RestApi.pathToSpecificResource(RestApi.Collections.GROUPS, groupId);
            }

            return RestApi.pathToCollection(RestApi.Collections.GROUPS);
        },
        byClass: function byClass(groupClass) {
            return this.filter(function (group) {
                return group instanceof groupClass;
            });
        },
        oneByClass: function oneByClass(groupClass) {
            return this.byClass(groupClass)[0];
        },


        /**
         * Find a group by an asset id, optionally filtered by the value type.
         *
         * @param {String} id       The asset id, for example experience id
         * @param {String} [type] optional; The value type
         * @returns {GroupModel}    A group model
         */
        findByAssetId: function findByAssetId(id, type) {
            return this.find(function (group) {
                return _.find(group.getAssets(), function (asset) {
                    var matchType = true;

                    if (type) {
                        matchType = type === asset.get("type");
                    }

                    return matchType && asset.get("id") === id;
                });
            });
        },


        /**
         * Returns an array of groups, instances of the specified <tt>groupClass</tt>, if provided, that at least has the specified state.
         *
         * @param  {PublishableState} state The state, as a PublishableState.XXX enum.
         * @param  {Function} groupClass Optional, the group class/constructor function.
         * @return {GroupModel[]}        Array of group models.
         */
        hasAtLeastState: function hasAtLeastState(state, groupClass) {
            return this.filter(function (group) {
                var hasAtLeastState = group.hasAtLeastState(state);

                if (groupClass) {
                    return hasAtLeastState && group instanceof groupClass;
                }

                return hasAtLeastState;
            });
        }
    }, {
        fetch: function fetch(options) {
            return new GroupCollection([], options).fetch();
        },
        fetchOne: function fetchOne(id, options) {
            var collection = new GroupCollection(null, { groupId: id });

            return collection.fetch(options).then(function () {
                return collection.shift();
            });
        },


        /**
         * Fetches the groups containing the asset matching the
         * specified asset id, if any.
         *
         * @param  {String} assetId The id of the asset, e.g. an experience id.
         * @return {Promise}        A promise that resolves with a <tt>GroupCollection</tt> instance
         *                          containing the groups that refers the specified asset.
         */
        byAssetId: function byAssetId(assetId) {
            return new GroupCollection([], { assetId: assetId }).fetch();
        },
        parse: function parse(json) {
            var collection = new GroupCollection();
            return collection.model(json, { collection: collection });
        }
    });

    return GroupCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var DashboardConfigurationFactory = __webpack_require__(1191),
        ProjectDashboardContentCollectionView = __webpack_require__(3080),
        ProjectDashboardImageLibraryView = __webpack_require__(3083),
        ProjectDashboardPublishView = __webpack_require__(3086);

    /**
     * Describes the tab configuration needed by the project dashboard - providing project specific views and a different path.
     *
     * @class ProjectDashboardConfiguration
     */
    return DashboardConfigurationFactory.create({
        EXPERIENCES: {
            view: ProjectDashboardContentCollectionView,
            path: function path(context) {
                return "project/" + context.project.get("id");
            }
        },
        IMAGES: {
            view: ProjectDashboardImageLibraryView,
            path: function path(context) {
                return "project/" + context.project.get("id") + "/images";
            }
        },
        PUBLISH: {
            view: ProjectDashboardPublishView,
            path: function path(context) {
                return "project/" + context.project.get("id") + "/publish";
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Promise = __webpack_require__(21),
        ImprovedView = __webpack_require__(6),
        SequentialButton = __webpack_require__(112),
        SpinnerView = __webpack_require__(244),
        template = __webpack_require__(3092);

    var HEADER_TEMPLATE = _.template("<%- label %>&nbsp;<span class='count thin'>&#40;<%- count %>&#41;</span>"),
        NOTIFICATION_TEMPLATE = _.template("<div class='notification-icon' /><%- message %>");

    /**
     *
     * @class AbstractProjectAttachView
     */
    return ImprovedView.extend("AbstractProjectAttachView", {

        template: template,

        tagName: "section",

        className: "project-attach-view",

        regions: {
            contentRegion: ".content-region"
        },

        ui: {
            header: ".attach-header",
            attachButton: ".btn-ok-attach",
            cancelButton: ".btn-cancel-attach",
            notificationMessage: ".notification-message"
        },

        events: {
            "click @ui.attachButton": "_attachClickHandler",
            "click @ui.cancelButton": "_cancelClickHandler"
        },

        collectionView: null,

        _selectedAssets: null,

        _collectionViewInstance: null,

        initialize: function initialize() {
            this._selectedAssets = [];
        },

        collectionOptions: function collectionOptions() {
            return Promise.resolved({});
        },

        onRender: function onRender() {
            this._attach = SequentialButton.add(this.ui.attachButton, this._attach.bind(this, this._selectedAssets), true, true);
        },

        onShow: function onShow() {
            var self = this,
                $el = this.$el,
                contentRegion = this.contentRegion,
                View = this.collectionView,
                itemViewOptions = this._createItemViewOptions();

            contentRegion.show(new SpinnerView());

            $el.addClass("loading");

            this.collectionOptions().then(function (options) {
                self.ui.header.html(HEADER_TEMPLATE(options.header));

                delete options.header;

                $el.removeClass("loading");

                self._collectionViewInstance = new View(_.defaults(options, {
                    itemViewOptions: itemViewOptions,
                    scrollTarget: self.contentRegion.$el
                }));

                contentRegion.show(self._collectionViewInstance);
            });
        },

        onSelect: function onSelect(model, selected, selectedAssets) {// eslint-disable-line no-unused-vars
        },

        onAttach: function onAttach() {
            return Promise.resolved();
        },

        showNotification: function showNotification(message) {
            if (!message) {
                return this.ui.notificationMessage.html("");
            }

            var html = NOTIFICATION_TEMPLATE({ message: message });
            this.ui.notificationMessage.html(html);
        },

        /**
         * @private
         *
         * Injects the 'selectHandler' into the itemViewOptions of the collection view - making
         * options.selectHandler available for the item view(s).
         *
         * @return {Function} The new item view options function.
         */
        _createItemViewOptions: function _createItemViewOptions() {
            var self = this,
                projectContext = this.options.projectContext,
                selectHandler = this._selectHandler.bind(this);

            return function () {
                var superItemViewOptions = _.result(self.collectionView.prototype, "itemViewOptions") || {};

                return _.extend(superItemViewOptions, {
                    projectContext: projectContext,
                    selectHandler: selectHandler
                });
            };
        },

        _attachClickHandler: function _attachClickHandler() {
            if (this._selectedAssets.length) {
                this._attach();
            }
        },

        _attach: function _attach(selectedAssets) {
            var self = this;

            return this.options.projectContext.attach(selectedAssets).then(self.onAttach.bind(self, selectedAssets)).then(function () {
                self.trigger("attached", selectedAssets);
            }).always(self._close.bind(self));
        },

        _close: function _close() {
            this.trigger("close");
        },

        _cancelClickHandler: function _cancelClickHandler() {
            this._close();
        },

        _selectHandler: function _selectHandler(model, selected) {
            if (selected) {
                this._selectedAssets.push(model);
            } else {
                var i = this._selectedAssets.indexOf(model);
                this._selectedAssets.splice(i, 1);
            }

            this.triggerMethod("select", selected, this._selectedAssets);
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentryError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill__ = __webpack_require__(3162);


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        // tslint:disable:no-unsafe-any
        _this.name = _newTarget.prototype.constructor.name;
        Object(__WEBPACK_IMPORTED_MODULE_1__polyfill__["a" /* setPrototypeOf */])(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(344);

// TODO: Implement different loggers for different environments
var global = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["f" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["c" /* consoleSandbox */])(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = truncate;
/* harmony export (immutable) */ __webpack_exports__["c"] = snipLine;
/* harmony export (immutable) */ __webpack_exports__["b"] = safeJoin;
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatchingPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(287);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        colno = ll; // tslint:disable-line:no-parameter-reassignment
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__is__["k" /* isString */])(value)) {
        return false;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["j" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["b"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeStackTrace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
// tslint:disable:object-literal-sort-keys

// global reference to slice
var UNKNOWN_FUNCTION = '?';
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
/** JSDoc */
function computeStackTrace(ex) {
    // tslint:disable:no-unsafe-any
    var stack = null;
    var popSize = ex && ex.framesToPop;
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true,
    };
}
/** JSDoc */
// tslint:disable-next-line:cyclomatic-complexity
function computeStackTraceFromStackProp(ex) {
    // tslint:disable:no-conditional-assignment
    if (!ex || !ex.stack) {
        return null;
    }
    var stack = [];
    var lines = ex.stack.split('\n');
    var isEval;
    var submatch;
    var parts;
    var element;
    for (var i = 0; i < lines.length; ++i) {
        if ((parts = chrome.exec(lines[i]))) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
                // prefix here seems like the quickest solution for now.
                url: parts[2] && parts[2].indexOf('address at ') === 0 ? parts[2].substr('address at '.length) : parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = winjs.exec(lines[i]))) {
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = gecko.exec(lines[i]))) {
            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ''; // no column when eval
            }
            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
            }
            element = {
                url: parts[3],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null,
            };
        }
        else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = UNKNOWN_FUNCTION;
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** JSDoc */
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) {
        return null;
    }
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split('\n');
    var stack = [];
    var parts;
    for (var line = 0; line < lines.length; line += 2) {
        // tslint:disable:no-conditional-assignment
        var element = null;
        if ((parts = opera10Regex.exec(lines[line]))) {
            element = {
                url: parts[2],
                func: parts[3],
                args: [],
                line: +parts[1],
                column: null,
            };
        }
        else if ((parts = opera11Regex.exec(lines[line]))) {
            element = {
                url: parts[6],
                func: parts[3] || parts[4],
                args: parts[5] ? parts[5].split(',') : [],
                line: +parts[1],
                column: +parts[2],
            };
        }
        if (element) {
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** Remove N number of frames from the stack */
function popFrames(stacktrace, popSize) {
    try {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, stacktrace, { stack: stacktrace.stack.slice(popSize) });
    }
    catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(56);


/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* PromiseBuffer */](30);
        this._api = new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["a" /* API */](this.options.dsn);
        // tslint:disable-next-line:deprecation
        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SentryError */]('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalhandlers__ = __webpack_require__(3180);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__globalhandlers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trycatch__ = __webpack_require__(3181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_1__trycatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__ = __webpack_require__(3182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkederrors__ = __webpack_require__(3183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_3__linkederrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useragent__ = __webpack_require__(3184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UserAgent", function() { return __WEBPACK_IMPORTED_MODULE_4__useragent__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shouldIgnoreOnError;
/* unused harmony export ignoreNextOnError */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(56);



var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        // tslint:disable:no-unsafe-any
        try {
            // tslint:disable-next-line:strict-type-predicates
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
            // tslint:enable:no-unsafe-any
        }
        catch (ex) {
            ignoreNextOnError();
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["y" /* withScope */])(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
                    if (options.mechanism) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["f" /* addExceptionTypeValue */])(processedEvent, undefined, undefined);
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* addExceptionMechanism */])(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, processedEvent.extra, { arguments: args });
                    return processedEvent;
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["j" /* captureException */])(ex);
            });
            throw ex;
        }
    };
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // tslint:disable-line:no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
    }
    catch (_oO) {
        /*no-empty*/
    }
    return sentryWrapped;
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1276);


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(45);

var $exec = callBound('RegExp.prototype.exec');

module.exports = function regexTester(regex) {
	return function test(s) { return $exec(regex, s) !== null; };
};


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(289)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false && value;
	};
}


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var IsInteger = __webpack_require__(185);
var Type = __webpack_require__(23);

var MAX_SAFE_INTEGER = __webpack_require__(738);
var isLeadingSurrogate = __webpack_require__(1284);
var isTrailingSurrogate = __webpack_require__(1285);

var $TypeError = GetIntrinsic('%TypeError%');

var $charCodeAt = __webpack_require__(45)('String.prototype.charCodeAt');

// https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex

module.exports = function AdvanceStringIndex(S, index, unicode) {
	if (Type(S) !== 'String') {
		throw new $TypeError('Assertion failed: `S` must be a String');
	}
	if (!IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
		throw new $TypeError('Assertion failed: `length` must be an integer >= 0 and <= 2**53');
	}
	if (Type(unicode) !== 'Boolean') {
		throw new $TypeError('Assertion failed: `unicode` must be a Boolean');
	}
	if (!unicode) {
		return index + 1;
	}
	var length = S.length;
	if ((index + 1) >= length) {
		return index + 1;
	}

	var first = $charCodeAt(S, index);
	if (!isLeadingSurrogate(first)) {
		return index + 1;
	}

	var second = $charCodeAt(S, index + 1);
	if (!isTrailingSurrogate(second)) {
		return index + 1;
	}

	return index + 2;
};


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $Math = GetIntrinsic('%Math%');
var $Number = GetIntrinsic('%Number%');

module.exports = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es6-shim
var keys = __webpack_require__(288);
var canBeObject = function (obj) {
	return typeof obj !== 'undefined' && obj !== null;
};
var hasSymbols = __webpack_require__(474)();
var callBound = __webpack_require__(45);
var toObject = Object;
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
	if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
	var objTarget = toObject(target);
	var s, source, i, props, syms, value, key;
	for (s = 1; s < arguments.length; ++s) {
		source = toObject(arguments[s]);
		props = keys(source);
		var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			syms = getSymbols(source);
			for (i = 0; i < syms.length; ++i) {
				key = syms[i];
				if ($propIsEnumerable(source, key)) {
					$push(props, key);
				}
			}
		}
		for (i = 0; i < props.length; ++i) {
			key = props[i];
			value = source[key];
			if ($propIsEnumerable(source, key)) {
				objTarget[key] = value;
			}
		}
	}
	return objTarget;
};


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(739);

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

module.exports = function getPolyfill() {
	if (!Object.assign) {
		return implementation;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation;
	}
	if (assignHasPendingExceptions()) {
		return implementation;
	}
	return Object.assign;
};


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $Array = GetIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr = !$Array.isArray && __webpack_require__(45)('Object.prototype.toString');

module.exports = $Array.isArray || function IsArray(argument) {
	return toStr(argument) === '[object Array]';
};


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $gOPD = __webpack_require__(295);
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var isPropertyDescriptor = __webpack_require__(293);

var IsAccessorDescriptor = __webpack_require__(169);
var IsDataDescriptor = __webpack_require__(117);
var IsExtensible = __webpack_require__(296);
var IsPropertyKey = __webpack_require__(64);
var ToPropertyDescriptor = __webpack_require__(186);
var SameValue = __webpack_require__(170);
var Type = __webpack_require__(23);
var ValidateAndApplyPropertyDescriptor = __webpack_require__(478);

// https://ecma-international.org/ecma-262/6.0/#sec-ordinarydefineownproperty

module.exports = function OrdinaryDefineOwnProperty(O, P, Desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
	}
	if (!$gOPD) {
		// ES3/IE 8 fallback
		if (IsAccessorDescriptor(Desc)) {
			throw new $SyntaxError('This environment does not support accessor property descriptors.');
		}
		var creatingNormalDataProperty = !(P in O)
			&& Desc['[[Writable]]']
			&& Desc['[[Enumerable]]']
			&& Desc['[[Configurable]]']
			&& '[[Value]]' in Desc;
		var settingExistingDataProperty = (P in O)
			&& (!('[[Configurable]]' in Desc) || Desc['[[Configurable]]'])
			&& (!('[[Enumerable]]' in Desc) || Desc['[[Enumerable]]'])
			&& (!('[[Writable]]' in Desc) || Desc['[[Writable]]'])
			&& '[[Value]]' in Desc;
		if (creatingNormalDataProperty || settingExistingDataProperty) {
			O[P] = Desc['[[Value]]']; // eslint-disable-line no-param-reassign
			return SameValue(O[P], Desc['[[Value]]']);
		}
		throw new $SyntaxError('This environment does not support defining non-writable, non-enumerable, or non-configurable properties');
	}
	var desc = $gOPD(O, P);
	var current = desc && ToPropertyDescriptor(desc);
	var extensible = IsExtensible(O);
	return ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current);
};


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $match = GetIntrinsic('%Symbol.match%', true);

var hasRegExpMatcher = __webpack_require__(1293);

var ToBoolean = __webpack_require__(236);

// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

module.exports = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match) {
		var isRegExp = argument[$match];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return hasRegExpMatcher(argument);
};


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(99);

// http://262.ecma-international.org/5.1/#sec-9.6

module.exports = function ToUint32(x) {
	return ToNumber(x) >>> 0;
};


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(1295);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var SameValue = __webpack_require__(170);
var ToNumber = __webpack_require__(99);
var ToString = __webpack_require__(188);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring

module.exports = function CanonicalNumericIndexString(argument) {
	if (Type(argument) !== 'String') {
		throw new $TypeError('Assertion failed: `argument` must be a String');
	}
	if (argument === '-0') { return -0; }
	var n = ToNumber(argument);
	if (SameValue(ToString(n), argument)) { return n; }
	return void 0;
};


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var DefineOwnProperty = __webpack_require__(346);

var FromPropertyDescriptor = __webpack_require__(237);
var OrdinaryGetOwnProperty = __webpack_require__(481);
var IsDataDescriptor = __webpack_require__(117);
var IsExtensible = __webpack_require__(296);
var IsPropertyKey = __webpack_require__(64);
var SameValue = __webpack_require__(170);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-createdataproperty

module.exports = function CreateDataProperty(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = OrdinaryGetOwnProperty(O, P);
	var extensible = !oldDesc || IsExtensible(O);
	var nonConfigurable = oldDesc && !oldDesc['[[Configurable]]'];
	if (nonConfigurable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MAX_SAFE_INTEGER = __webpack_require__(738);

var ToInteger = __webpack_require__(348);

module.exports = function ToLength(argument) {
	var len = ToInteger(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
	return len;
};


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $EvalError = GetIntrinsic('%EvalError%');

var DayWithinYear = __webpack_require__(484);
var InLeapYear = __webpack_require__(486);
var MonthFromTime = __webpack_require__(487);

// https://262.ecma-international.org/5.1/#sec-15.9.1.5

module.exports = function DateFromTime(t) {
	var m = MonthFromTime(t);
	var d = DayWithinYear(t);
	if (m === 0) {
		return d + 1;
	}
	if (m === 1) {
		return d - 30;
	}
	var leap = InLeapYear(t);
	if (m === 2) {
		return d - 58 - leap;
	}
	if (m === 3) {
		return d - 89 - leap;
	}
	if (m === 4) {
		return d - 119 - leap;
	}
	if (m === 5) {
		return d - 150 - leap;
	}
	if (m === 6) {
		return d - 180 - leap;
	}
	if (m === 7) {
		return d - 211 - leap;
	}
	if (m === 8) {
		return d - 242 - leap;
	}
	if (m === 9) {
		return d - 272 - leap;
	}
	if (m === 10) {
		return d - 303 - leap;
	}
	if (m === 11) {
		return d - 333 - leap;
	}
	throw new $EvalError('Assertion failed: MonthFromTime returned an impossible value: ' + m);
};


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var modulo = __webpack_require__(118);

// https://262.ecma-international.org/5.1/#sec-15.9.1.3

module.exports = function DaysInYear(y) {
	if (modulo(y, 4) !== 0) {
		return 365;
	}
	if (modulo(y, 100) !== 0) {
		return 366;
	}
	if (modulo(y, 400) !== 0) {
		return 365;
	}
	return 366;
};


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $Function = GetIntrinsic('%Function%');
var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(135);
var IsConstructor = __webpack_require__(347);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-getprototypefromconstructor

module.exports = function GetPrototypeFromConstructor(constructor, intrinsicDefaultProto) {
	var intrinsic = GetIntrinsic(intrinsicDefaultProto); // throws if not a valid intrinsic
	if (!IsConstructor(constructor)) {
		throw new $TypeError('Assertion failed: `constructor` must be a constructor');
	}
	var proto = Get(constructor, 'prototype');
	if (Type(proto) !== 'Object') {
		if (!(constructor instanceof $Function)) {
			// ignore other realms, for now
			throw new $TypeError('cross-realm constructors not currently supported');
		}
		proto = intrinsic;
	}
	return proto;
};


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(135);
var IsCallable = __webpack_require__(187);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-ordinaryhasinstance

module.exports = function OrdinaryHasInstance(C, O) {
	if (IsCallable(C) === false) {
		return false;
	}
	if (Type(O) !== 'Object') {
		return false;
	}
	var P = Get(C, 'prototype');
	if (Type(P) !== 'Object') {
		throw new $TypeError('OrdinaryHasInstance called on an object with an invalid prototype property.');
	}
	return O instanceof C;
};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var Call = __webpack_require__(239);
var IsArray = __webpack_require__(116);
var GetV = __webpack_require__(489);
var IsPropertyKey = __webpack_require__(64);

// https://ecma-international.org/ecma-262/6.0/#sec-invoke

module.exports = function Invoke(O, P) {
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray(argumentsList)) {
		throw new $TypeError('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	var func = GetV(O, P);
	return Call(func, O, argumentsList);
};


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(135);
var ToBoolean = __webpack_require__(236);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete

module.exports = function IteratorComplete(iterResult) {
	if (Type(iterResult) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
	}
	return ToBoolean(Get(iterResult, 'done'));
};


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var Invoke = __webpack_require__(753);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratornext

module.exports = function IteratorNext(iterator, value) {
	var result = Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
	if (Type(result) !== 'Object') {
		throw new $TypeError('iterator next must return an object');
	}
	return result;
};


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $ObjectCreate = GetIntrinsic('%Object.create%', true);
var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var Type = __webpack_require__(23);

var hasProto = !({ __proto__: null } instanceof Object);

// https://ecma-international.org/ecma-262/6.0/#sec-objectcreate

module.exports = function ObjectCreate(proto, internalSlotsList) {
	if (proto !== null && Type(proto) !== 'Object') {
		throw new $TypeError('Assertion failed: `proto` must be null or an object');
	}
	var slots = arguments.length < 2 ? [] : internalSlotsList;
	if (slots.length > 0) {
		throw new $SyntaxError('es-abstract does not yet support internal slots');
	}

	if ($ObjectCreate) {
		return $ObjectCreate(proto);
	}
	if (hasProto) {
		return { __proto__: proto };
	}

	if (proto === null) {
		throw new $SyntaxError('native Object.create support is required to create null objects');
	}
	var T = function T() {};
	T.prototype = proto;
	return new T();
};


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var callBind = __webpack_require__(476);
var callBound = __webpack_require__(45);

var $ownKeys = GetIntrinsic('%Reflect.ownKeys%', true);
var $pushApply = callBind.apply(GetIntrinsic('%Array.prototype.push%'));
var $SymbolValueOf = callBound('Symbol.prototype.valueOf', true);
var $gOPN = GetIntrinsic('%Object.getOwnPropertyNames%', true);
var $gOPS = $SymbolValueOf ? GetIntrinsic('%Object.getOwnPropertySymbols%') : null;

var keys = __webpack_require__(288);

module.exports = $ownKeys || function OwnPropertyKeys(source) {
	var ownKeys = ($gOPN || keys)(source);
	if ($gOPS) {
		$pushApply(ownKeys, $gOPS(source));
	}
	return ownKeys;
};


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $BigInt = typeof BigInt !== 'undefined' && BigInt;

module.exports = function hasNativeBigInts() {
	return typeof $BigInt === 'function'
		&& typeof BigInt === 'function'
		&& typeof $BigInt(42) === 'bigint' // eslint-disable-line no-magic-numbers
		&& typeof BigInt(42) === 'bigint'; // eslint-disable-line no-magic-numbers
};


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var abs = __webpack_require__(292);
var floor = __webpack_require__(115);
var modulo = __webpack_require__(118);
var ToNumber = __webpack_require__(99);

var $isNaN = __webpack_require__(149);
var $isFinite = __webpack_require__(150);
var $sign = __webpack_require__(483);

// http://262.ecma-international.org/5.1/#sec-9.7

module.exports = function ToUint16(value) {
	var number = ToNumber(value);
	if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
	var posInt = $sign(number) * floor(abs(number));
	return modulo(posInt, 0x10000);
};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(99);

var $isNaN = __webpack_require__(149);
var $isFinite = __webpack_require__(150);
var $sign = __webpack_require__(483);

var abs = __webpack_require__(292);
var floor = __webpack_require__(115);
var modulo = __webpack_require__(118);

// https://ecma-international.org/ecma-262/6.0/#sec-touint8

module.exports = function ToUint8(argument) {
	var number = ToNumber(argument);
	if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
	var posInt = $sign(number) * floor(abs(number));
	return modulo(posInt, 0x100);
};


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(732);

module.exports = function find(predicate) {
	var list = ES.ToObject(this);
	var length = ES.ToLength(list.length);
	if (!ES.IsCallable(predicate)) {
		throw new TypeError('Array#find: predicate must be a function');
	}
	if (length === 0) {
		return void 0;
	}
	var thisArg;
	if (arguments.length > 0) {
		thisArg = arguments[1];
	}

	for (var i = 0, value; i < length; i++) {
		value = list[i];
		// inlined for performance: if (ES.Call(predicate, thisArg, [value, i, list])) {
		if (predicate.apply(thisArg, [value, i, list])) {
			return value;
		}
	}
	return void 0;
};


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function getPolyfill() {
	// Detect if an implementation exists
	// Detect early implementations which skipped holes in sparse arrays
	// eslint-disable-next-line no-sparse-arrays
	var implemented = Array.prototype.find && [, 1].find(function () {
		return true;
	}) !== 1;

	// eslint-disable-next-line global-require
	return implemented ? Array.prototype.find : __webpack_require__(761);
};


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Module for overriding Backbone's extend logic - providing dependency injection at the very core.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var AssociatedModel = __webpack_require__(352); // required when built/bundled!
    var Injector = __webpack_require__(353);

    var Model = Backbone.Model,
        Collection = Backbone.Collection,
        Router = Backbone.Router,
        View = Backbone.View,
        History = Backbone.History;

    // Reserved prop names...

    var CTOR = "constructor";
    var INJECT = "injection";
    var MIXIN = "mixin";
    var INSTANCEOF = "instanceOf";
    var ASSIGNABLE = "assignableFrom";
    var SUPER = "__super";

    // Reserved (fixed) properties not to override during mixin! Note that CTOR is *not* included here as we want
    // it to be present in props mixed in as it is handled specifically!...
    var RESERVED = new Set(["extend", "ctx", "__super__", "__typeName", INJECT, MIXIN, INSTANCEOF, ASSIGNABLE, "__ctor"]); // __ctor used for runtime book keeping!

    // Used to generate unique mixin names where non are supplied, to be able to test for any type...
    var SEQUENCE = 1;

    // The universe of known types, exposed publicly as "universe" on each "ctx" (shared)...
    var UNIVERSE = {};

    // Required because every object has a prototype "constructor" property!
    var prop = function prop(name, props, remove) {
        // remove will fx be true for static "injection" property...
        var value = void 0;
        if (props && props.hasOwnProperty(name)) {
            value = props[name];
            if (remove) {
                delete props[name];
            }
        }
        return value;
    };

    // Registers a new constructor to "ctx", i.e. mixin constructors *or* the single (parent) one...
    var register = function register(ctx, props, injection, parent) {
        var ctor = prop(CTOR, props) || parent;
        if (_.isFunction(ctor)) {
            // Add "constructor" functions to array of such (mixin) constructors used by the actual
            // constructor wrapper stored in "ctx.ctor", in an entry tagged with required injections.
            // Note that we can still inject (as options) if we have defaulted to "parent" constructor...
            var entry = injection ? { ctor: ctor, injection: injection } : ctor;
            var constructors = prop(CTOR, ctx);

            if (constructors) {
                constructors.push(entry);
            } else {
                ctx[CTOR] = [entry]; // create "constructors" array
            }

            // Make sure update the "props" reference to the actual constructor function, as it will be
            // added (mixed) with the actual type later...
            props[CTOR] = ctx.ctor;
        }
    };

    // Call constructors(s) with the specified scope ("this"), including recursive parent constructor calls where
    // needed, and with injection support all the way...
    var call = function call(self, ctx, args) {
        var called = self.__ctor;
        var constructors = prop(CTOR, ctx);
        var parent = ctx.parent;
        var old = self[SUPER];
        var entry = void 0;
        var ctor = void 0;
        var params = void 0;
        var i = void 0;

        // Expose super constructor for (mixin) constructor about to run, defaulting to a noop so it can always be
        // called (always present). This is a bit different from normal override as mixin can cause constructors
        // to be called multiple times which we do not want...
        self[SUPER] = function () {
            if (parent) {
                if (!called.has(parent)) {
                    called.add(parent);
                    // If the parent constructor is one defined by us, "call" will be recursively called and
                    // "__super" will be exposed below; otherwise it could be a Backbone constructor, which
                    // will never use "__super" anyways...

                    for (var _len = arguments.length, superArgs = Array(_len), _key = 0; _key < _len; _key++) {
                        superArgs[_key] = arguments[_key];
                    }

                    parent.apply(self, superArgs.length === 0 ? args : superArgs);
                }
            }
        };

        // Call each (mixin) constructor not yet called...
        for (i = 0; i < constructors.length; i++) {
            entry = constructors[i];

            // If not a constructor function, it will be an entry like {ctor: Function, injection: *}...
            if (_.isFunction(entry)) {
                params = args;
                ctor = entry;
            } else {
                params = Injector.getParameters(entry.injection, args); // does not clobber "args"!
                ctor = entry.ctor;
            }

            // Has our constructor already run for scope (this)?
            if (!called.has(ctor)) {
                // Record this this constructor has (will) now run, so it will be ignored on future calls, such
                // as multiple call super calls from different mixins...
                called.add(ctor);
                // Call constructor, which will call exposed super constructor when needed...
                ctor.apply(self, params);
            }
        }

        // Remove super constructor, since this constructor has run...
        if (old) {
            self[SUPER] = old;
        } else {
            delete self[SUPER];
        }
    };

    // Wraps the supplied mixin "fn" for the named property if a super function is available at call (mixin) time,
    // making a "__super(..)" reference available at call time. If no super function is available, or if "fn"
    // does not call __super(..)", "fn" is simply returned. However, if "fn" calls "__super()", we must make sure
    // we always have a super function even if no actual super function; if so, "__super()" is just a no-op at
    // call time...
    var override = function override(parent, name, fn, superFn) {
        // If no "__super(..)" reference in the "fn" code, simply use "fn" as-is...
        if (fn.toString().indexOf("." + SUPER + "(") !== -1) {
            // make sure we match invocations, not __super__!

            // Get a reference to the super function at mixin time, since the super reference may change over time...
            superFn = superFn || parent && parent[name];

            // Since "fn" is known to call "__super()", we must make sure it is present. If we have no actual
            // super function, we create a no-op on the fly to use...
            if (!_.isFunction(superFn)) {
                superFn = function superFn() {}; // no-op
            }

            // Qualify function name for super call...
            var typeName = parent && parent.__typeName;
            if (typeName) {
                name = typeName + "." + name;
            }

            // Wrap "fn" with a function that first defines "__super()" primed with a reference to the actual
            // super function at mixin time, making it available to be called with the same args or explicitly
            // added ones at runtime...
            return function () {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                var self = this;
                var old = self[SUPER];

                // Expose "__super()" for "self" at runtime...
                self[SUPER] = function () {
                    for (var _len3 = arguments.length, superArgs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        superArgs[_key3] = arguments[_key3];
                    }

                    return superFn.apply(self, superArgs.length ? superArgs : args);
                };

                // Call actual mixin function, which may end up calling "__super(..)" then. Notice if "__super()"
                // fails, our finally block will be reached below, making sure we clean up in any case...
                try {
                    return fn.apply(self, args);
                } finally {
                    self[SUPER] = old; // TODO: can this be corrupted on recursion?
                }
            };
        }

        // Return as is, we have no reference to a super function to call...
        return fn;
    };

    // Extend "Type" prototype with all the supplied proto props, allowing functions to reference "__super(..)" to
    // easily access super function, if any...
    var def = function def(Type, props) {
        // "props" already defaulted here!
        _.each(props, function (prop, name) {
            if (_.isFunction(prop) && name !== CTOR) {
                // constructor already handled
                prop = override(Type.__super__, name, prop);
            }
            Type.prototype[name] = prop; // TODO: should auto extend props etc like on mixin, but with diff semantics
        });
    };

    // "mixin" is different from "extend": functions will still override, but property maps and arrays
    // should be merged (mixed) with such existing properties, if any, otherwise created. We do also
    // support recursive mixin via a mixin defining a "mixin" property (handled in "mixin(..)"...
    var mix = function mix(self, target, props) {
        _.each(props, function (mixin, name) {
            var existing = target[name];
            var mix = true;
            // Have to check this because _.isObject(someFunction) returns true even if
            // _.isFunction(someFunction) does as well!...
            if (_.isFunction(mixin)) {
                // We can mix stuff like a function returning defaults into a map of existing "defaults"; we
                // do not support the reverse just yet (not needed). We assume "existing" has some sensible
                // value...
                if (!_.isFunction(existing) && _.isObject(existing)) {
                    var fn = mixin.bind(self);
                    mixin = function mixin() {
                        return _.extend(existing, fn());
                    };
                    // Fall-through!

                    // Do not wrap constructors, already handled as they can/must only be invoked once...
                } else if (name !== CTOR) {
                    // Override mixin functions to make their super function available...
                    mixin = override(self.__super__, name, mixin, existing);
                    // Fall-through!
                }
                // Always mix, even "constructor"...

                // Handle array properties: we *cannot* change the "existing" array, or we will/may change
                // the entire prototype chain further up, which is really less than desirable...
            } else if (_.isArray(mixin)) {
                if (_.isArray(existing)) {
                    mixin = existing.concat(mixin);
                    // eslint-disable-next-line eqeqeq
                } else if (existing != null) {
                    // Allow single non-null/non-defined prop to become array...
                    mixin.unshift(existing);
                }

                // Handle maps of properties...
            } else if (_.isObject(mixin)) {
                // TODO: maps!
                if (_.isObject(existing)) {
                    _.extend(existing, mixin); // TODO: reverse, no? Same issue as for arrays...!
                    mix = false; // already set on target!
                }
            } // else some other property we override, like a simple prop...

            if (mix) {
                target[name] = mixin;
            }
        });
    };

    // Mixin properties declared as part of another type declaration/mixin...
    var mixProps = function mixProps(Type, mixins, mixinName) {
        if (mixins) {
            // Either a single mixin or an array of such mixins...
            _.each(_.isArray(mixins) ? mixins : [mixins], function (mixin) {
                var mixinProps = mixin.prototype;
                var staticMixinProps = mixin;
                if (!mixinProps) {
                    mixinProps = staticMixinProps;
                    staticMixinProps = undefined;
                }
                if (mixinName) {
                    // if supplied, used as recursive prefix
                    Type.mixin(mixinName, mixinProps, staticMixinProps, true);
                } else {
                    Type.mixin(mixinProps, staticMixinProps);
                }
            });
        }
    };

    // Defines a "mixin" function on the constructor stored in "ctx", so other types can mixin functionality later...
    var defineMixin = function defineMixin(ctx) {
        var Constructor = ctx.ctor; // declared as this for easier debugging, i.e. stack trace like "Constructor.mixin"...

        Constructor.mixin = function (mixinName, mixinProps, staticMixinProps, recursive) {
            var self = this;
            var typeName = self.prototype.__typeName;
            var i = void 0;
            var props = {};

            // Mixin name is optional but *always* supplied on recursion...
            if (!_.isString(mixinName)) {
                staticMixinProps = mixinProps;
                mixinProps = mixinName;
                mixinName = typeName ? typeName + "Mixin" : "Mixin" + SEQUENCE++;
            } else if (recursive) {
                if (mixinProps.__typeName) {
                    mixinName += "." + mixinProps.__typeName;
                } else {
                    mixinName += ".Mixin" + SEQUENCE++;
                }
            }

            // Make sure we do not mixin the same mixin multiple times as that can cause odd side
            // effects like calling __super() too many times. If so, we simply return the mixin
            // here as already mixed in for the current context...
            for (i in ctx.types) {
                if (ctx.types[i] === mixinProps) {
                    return mixinProps;
                }
            }

            // Mixin injection for *this* mixin constructor?
            var injection = prop(INJECT, staticMixinProps, true); // true: remove "injection" prop if found
            var mixins = prop(MIXIN, mixinProps, true); // ditto
            var merge = function merge(target, source) {
                if (source) {
                    var _prop = void 0;
                    for (_prop in source) {
                        if (!RESERVED.has(_prop) && source.hasOwnProperty(_prop)) {
                            target[_prop] = source[_prop];
                        }
                    }
                }
                return target;
            };

            // Use both *own* prototype and normal mixin props, where the non-prototype (more specific)
            // props take precedence...
            if (mixinProps.prototype) {
                props = merge(props, mixinProps.prototype); // _.extend({}, mixinProps.prototype, mixinProps);
            }
            props = merge(props, mixinProps);

            // Register mixin constructor, but do *not* default to parent constructor...
            register(ctx, props, injection);

            // Mix in prototype properties, if any, which will be reflected in the entire prototype chain...
            mix(self, self.prototype, props);

            // Now perform mixin recursively for any mixins declared via a "mixin" property...
            mixProps(self, mixins, mixinName); // recursive mixin name prefix

            // Modify *incoming* props to ensure contexts can use individual mixins for type testing...
            mixinProps[ASSIGNABLE] = assignableFrom;

            // Mix in static properties, if any. Since static properties are not set on the prototype, we have to
            // manually update all sub-types of the type already created, on the mixed in static properties will
            // never be reflected there...
            if (staticMixinProps) {
                props = merge({}, staticMixinProps);
                mix(self, self, props);
                // May be empty, i.e. no sub-types...
                for (i = 0; i < ctx.children.length; i++) {
                    mix(self, ctx.children[i], props);
                }
            }

            // Remember actual mixin type so we can test for instanceof...
            ctx.types[mixinName] = mixinProps;
            UNIVERSE[mixinName] = mixinProps;

            // So we can easily test for this mixin later on, including for its type (or name)...
            return mixinProps;
        };
    };

    // Returns an *instance* function "instanceOf" to test for inheritance on the specified scope (this), or
    // added mixin type, on created instances...
    var instanceOf = function instanceOf(ctx) {
        return function (type) {
            // Normal instance of...
            if (_.isFunction(type) && this instanceof type) {
                return true;

                // Type or mixin name?
            } else if (_.isString(type)) {
                return !!ctx.types[type];
            }
            return !!_.find(ctx.types, function (t) {
                return type === t;
            });
        };
    };

    // Static type method that does the equivalent of "instanceOf", just with the arguments reversed...
    var assignableFrom = function assignableFrom(target) {
        return target.instanceOf && target.instanceOf(this);
    };

    // Defines a new type, or actually the constructor to create such a new type. The created type (constructor) will
    // besides the static "extend" function also have a static "mixin" function, so other types can mixin functionality
    // later. It also supports injection...
    var defineType = function defineType(parent, typeName, protoProps, staticProps) {
        // Define context to register mixed in constructors for *this* type as well as the actual constructor
        // wrapper, which will call those super/mixin constructors, at "ctx.ctor"...
        var ctx = {
            parent: parent, children: [], ctor: null, types: {}, universe: UNIVERSE
        };
        var injection = prop(INJECT, staticProps, true); // true: remove "injection" prop if found

        // We *always* define a specific constructor this type (for "typeName"), since we must be able
        // to handle both "extend" and "mixin" functionality. That is, we must only mixin on the specified
        // type, not all the way up the prototype chain, though we want to call super constructors
        // during construction...
        var Type = function Type() {
            // Initialise: make sure a given constructor function is only called once during construction...
            if (this.__ctor) {
                this.__ctors++;
            } else {
                this.__ctor = new Set();
                this.__ctors = 1;
            }

            // Call...

            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
            }

            call(this, ctx, args);

            // Clean up...
            if (! --this.__ctors) {
                delete this.__ctors;
                delete this.__ctor;
            }
        };

        // Generate a unique name for anonymous (non-named) types, including parent hierarchy tree...
        var qualifiedName = void 0;
        if (typeName) {
            qualifiedName = typeName;
        } else {
            typeName = "Type" + SEQUENCE++;
            qualifiedName = typeName;
            if (parent.prototype) {
                // parent prototype can be undefined, i.e. root type like "Class"
                qualifiedName += " < " + (parent.__typeName || "?");
            }
        }

        // Add static properties to the constructor function, if supplied, *before* add static functions
        // for it here, or the constructor would for example use the parent "mixin" function - it only took
        // me 1½ days to find this bug... :/
        _.extend(Type, parent, staticProps);

        ctx.ctor = Type;
        Type.ctx = ctx;

        // Make sure the type has an "instanceOf" function to test for types, including mixin ones, also
        // on name...
        Type[ASSIGNABLE] = assignableFrom;
        protoProps[INSTANCEOF] = instanceOf(ctx);

        // To maintain common instanceOf semantics, indexed by (auto-generated, non-qualified) type name...
        ctx.types[typeName] = protoProps;
        if (parent.ctx) {
            _.extend(ctx.types, parent.ctx.types);
        }

        // Tag constructor with type name for easy identification. Created instances will also have
        // a prototype property called "__typeName" as well...
        Type.__typeName = qualifiedName; // "qualifiedName" intentional!

        // Expand universe indexed by qualified name for debugging ease...
        UNIVERSE[qualifiedName] = protoProps;

        // Register "constructor" from "protoProps", or use "parent" constructor. We pass along any "injection"
        // configuration to be applied at runtime (creation time), if any; injection may still be used for
        // "parent" if configured as options...
        register(ctx, protoProps, injection, parent);

        // Define mixin function for the specified constructor, i.e. for "Type", to add additional
        // constructors and initializers at a later time...
        defineMixin(ctx);

        // Return constructor wrapper to create new "Type" instances by some context, to ensure mixins
        // constructors and initializers are called as well...
        return Type;
    };

    /**
     * The following code is a copy of Backbone's #extend with support for a mixin functionality and a
     * user-friendly type name (description). <p>
     *
     * If a type name is supplied as the first (string) argument, it will be set as the prototype property
     * <tt>__typeName</tt>; if no type name is supplied, the <tt>__typeName</tt> attribute is not set.
     *
     * @param {String|*} [typeName]    If a string, the user-friendly type name, for example a model name like
     *                                 "Experience". The  name should be friendly enough as to be presented to the end
     *                                 user as-is, e.g. in a notification error. If not a string, assumed to the the
     *                                 prototype properties for the model. The user friendly class type will be set
     *                                 as the prototype property named "__typeName", and not set if no type name is
     *                                 supplied. Prototype properties are optional.
     * @param {*}        [protoProps]  The prototype properties, or the static properties if <tt>typeName</tt> is not
     *                                 a string (and thus the prototype properties). Both prototype and static
     *                                 properties are optional.
     * @param {*}        [staticProps] The optional static properties if <tt>typeName</tt> is a string.
     */
    var extend = function extend(typeName, protoProps, staticProps) {
        // Type name is optional...
        if (!_.isString(typeName)) {
            staticProps = protoProps;
            protoProps = typeName;
            typeName = null;
        }

        protoProps = protoProps || {};

        // "staticProps" may also define an "injection" property that will handle injection (and will be ignored
        // as a static prop on the type)...
        var Type = defineType(this, typeName, protoProps, staticProps);

        // Make sure we keep a link to the sub-type just created, so we can make sure mixed in static properties
        // will be reflected in all such sub-types already defined at mixin time. This is needed because static
        // properties are not set on the prototype, but on actual types (functions)...
        if (this.ctx) {
            this.ctx.children.push(Type);
        }

        // Set the prototype chain to inherit from this type (parent), without calling the
        // constructor function of this (parent) type...
        var Surrogate = function Surrogate() {
            this.constructor = Type;
        };

        Surrogate.prototype = this.prototype;
        Type.prototype = new Surrogate();

        // Add prototype properties (instance properties) to the subclass, if supplied. If so,
        // the properties supplied during construction can be overridden by mixins...
        // Set a convenience property in case the parent"s prototype is needed later...
        Type.__super__ = this.prototype;

        // Add prototype properties (instance properties) to the subclass, if supplied. If so,
        // the properties supplied during construction takes precedence over mixins, i.e. more specific...
        def(Type, protoProps);

        // Apply mixin(s) defined via "protoProps", if any...
        mixProps(Type, prop(MIXIN, protoProps, true));

        // Add *user-friendly* type name...
        if (typeName) {
            Type.prototype.__typeName = typeName;

            // Add a default toString if not explicitly set for child or proto props; cannot test on prototype,
            // since a toString will always be there...
            if (Type.prototype.toString === Object.prototype.toString) {
                Type.prototype.toString = function () {
                    if (_.isFunction(this.distinguishedName)) {
                        try {
                            // Call fail in certain cases if *this* have not been fully initialised yet...
                            return this.distinguishedName();
                        } catch (e) {
                            // Fall-trough
                        }
                    }
                    var s = this.__typeName.replace(/\s+/g, "_");
                    var id = void 0;

                    // Append 'id' if present
                    if (_.isFunction(this.get)) {
                        id = this.get("id"); // Model, but not an ImprovedModel as it will have a distinguishedName already including the id (and version)
                    } else if (this.hasOwnProperty("cid")) {
                        id = this.cid; // View
                    }
                    if (id) {
                        s += "[" + id + "]";
                    }
                    return s;
                };
            }
        }

        return Type;
    };

    Model.extend = AssociatedModel.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

    return extend;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["visitAdapted"] = visitAdapted;
/* harmony export (immutable) */ __webpack_exports__["topWindowAdapted"] = topWindowAdapted;
/* harmony export (immutable) */ __webpack_exports__["openAdapted"] = openAdapted;
/* harmony export (immutable) */ __webpack_exports__["sandboxAdapted"] = sandboxAdapted;
/* harmony export (immutable) */ __webpack_exports__["sandboxPromiseAdapted"] = sandboxPromiseAdapted;
/* harmony export (immutable) */ __webpack_exports__["runAdapted"] = runAdapted;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise__);
/**
 * Adapter class used to share logic between existing codebase and new viewer.
 */

/**
 * Visits all accessible parent windows in reverse order, optionally invoking the specified callback when
 * each such window is visited.
 *
 * @param callback - Optional callback like <tt>fn(parent: Window, window: Window, error:Error): *</tt>
 *                   to be invoked for each accessible window, which will break the traversal if a
 *                   defined value is returned. If a non accessible window is encountered, the
 *                   parent argument will be null and the error will be supplied as the third
 *                   argument. Will always be invoked at least once (perhaps will null parent) if
 *                   supplied.
 *
 * @return The top most accessible window, or the first defined value returned by <tt>callback</tt>.
 */
function visitAdapted(callback) {
    var win = window;
    var call = true;
    var result;
    // Note: when debugging this, Chrome will often crash if no access... :/
    while (win.parent && win.parent.window && win.parent !== win.self) {
        try {
            // Access any sensitive window property will cause an exception to be raised if no access...
            // tslint:disable-next-line:no-unused-expression
            void win.parent.innerWidth;
            if (callback) {
                result = callback(win.parent, win);
                if (typeof result !== "undefined") {
                    return result;
                }
            }
            // If here, no security error and "win.parent" never null/undefined...
            win = win.parent;
            // Already called at least once (if available), so only do so again on error after we exit this loop...
            call = false;
        }
        catch (e) {
            call = e;
            break;
        }
    }
    // Make sure always called at least once and on error...
    if (call && callback) {
        result = callback(null, win, call); // call = error
    }
    return typeof result === "undefined" ? win : result;
}
function topWindowAdapted(excludeSelf) {
    var win = visitAdapted(); // will default to the top most accessible window
    return excludeSelf && win === window.self ? null : win;
}
/**
 * Open a new window via the top most reachable window, either in the same window or a new window/tab,
 * ensuring a short delay before opening in the same window so stats and/or pending http requests have
 * a chance of completing if the new window/location will replace the current (client) page. <p>
 *
 * Do <b>not</b> use <tt>window.open(..)</tt> or set <tt>window.location</tt> directly, always use this
 * function! <p>
 *
 * Caveat: opening a window via <tt>setTimeout</tt> is subject to pop-up blockers, but this is the only
 * way we can ensure pending requests have a change of completing when updating the location of the
 * current (top-most) window.
 *
 * @param url    - The url to open; cannot be falsey.
 * @param target - The window target/name; will default to "_blank", i.e. new window.
 * @param specs  - Optional window specs for new windows only; can be falsey.
 *
 * @return A reference to the JS Window type opened, or null if the opening failed. It will expose
 *                  a <tt>close()</tt> function as per spec.
 */
function openAdapted(url, target, specs) {
    if (target === void 0) { target = "_blank"; }
    if (specs === void 0) { specs = ""; }
    var win = topWindowAdapted(false);
    // Same window - we delay opening the url in this window a little bit so any analytics that listen for the
    // event have time to finish sending...
    if (["_self", "_parent", "_top"].indexOf(target) !== -1) {
        win.setTimeout(function () {
            win.location.href = url; // Caveat: this is subject to pop-up blockers
        }, 501); // TODO: what about listening for SyncManager not synching instead in the Editor?
        // Same window, but will just update the location in a bit...!
        return win;
    }
    // New window/tab, will not interfere with us...
    return win.open(url, target, specs);
}
function sandboxAdapted(path, scope) {
    var paths = typeof path === "string" ? [path] : path;
    var parts;
    var o;
    var i;
    var j;
    // "scope" can be null, for example if the scope is acquired via this function by an earlier call, which
    // will result in undefined being returned by this function. We differentiate between null and undefined
    // to allow a sensible default (top window) when no scope is supplied...
    if (typeof scope === "undefined") {
        scope = topWindowAdapted(false); // will be accessible!
    }
    // eslint-disable-next-line eqeqeq
    if (scope != null) {
        // Look up specific path, e.g. "window.__zmags.lightbox"?
        loop: for (i = 0; i < paths.length; i++) {
            // Reset to original scope for each path to traverse...
            o = scope;
            parts = paths[i].split(".");
            for (j = 0; j < parts.length; j++) {
                try {
                    // @ts-ignore
                    o = o[parts[j]];
                }
                catch (e) { // e.g. Security Error, TypeError (non-readable property)
                    o = null;
                    // Fall-through
                }
                // eslint-disable-next-line eqeqeq
                if (o == null) {
                    continue loop;
                }
            }
            return o;
        }
    }
    // undefined
}
function sandboxPromiseAdapted(path, timeout, scope) {
    if (typeof scope === "number") {
        timeout = scope;
        scope = undefined; // will default to top most window
    }
    var outsideResolve;
    var outsideReject;
    var promise = new __WEBPACK_IMPORTED_MODULE_0_es6_promise__["Promise"](function (resolve, reject) {
        outsideResolve = resolve;
        outsideReject = reject;
    });
    var timer;
    var start;
    var clearTimer = function () {
        if (timer) {
            window.clearTimeout(timer);
            timer = null;
        }
    };
    var poll = function () {
        var result = sandboxAdapted(path, scope);
        // eslint-disable-next-line eqeqeq
        if (result != null) {
            clearTimer();
            outsideResolve(result);
            return false;
        }
        return true; // keep polling
    };
    // Do an initial poll before firing up a polling interval...
    if (poll()) {
        timeout = timeout || 5000; // 5s
        start = Date.now();
        timer = window.setInterval(function () {
            // "poll" will resolve and clear timer on success, we only need to reject on timeout...
            if (poll() && (Date.now() - start > timeout)) {
                clearTimer();
                outsideReject();
            }
        }, 200);
    }
    return promise;
}
/**
 * Runs the specified code in a given window. <p>
 *
 * <tt>options</tt> can be a string, the code to evaluate in the top most accessible window, or it can have
 * the following format for more control:
 * <pre>
 *    {
 *        code:    String,  // Mandatory code to run (eval) in <tt>options.win</tt>.
 *        win:     Window,  // Optional window to run the code in, defaulting to the top most accessible one.
 *        errback: Function // Optional errback handler to suppress errors;
 *            if not specified, errors will be thrown as is.
 *    }
 * </pre>
 *
 * @param {String|{code:String, win:Window, errback:Function}} options
 *        If a string, the code to run (eval) in the top most accessible window; otherwise a set of options as
 *        described above; cannot be falsey.
 *
 * @return {*} The result of the evaluation, if any; can be any value.
 *
 * @throws {Error} If the run (eval) raises an error and <tt>errback</tt> is not supplied to handle it.
 */
function runAdapted(options) {
    if (typeof options === "string") {
        options = { code: options };
    }
    var code = options.code;
    var win = options.win || topWindowAdapted(false);
    try {
        if (win.eval) {
            return win.eval(code);
        }
        else {
            throw new Error("no win.eval");
        }
    }
    catch (e) {
        if (options.errback) {
            options.errback(e, code);
        }
        else {
            throw e;
        }
    }
}


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Configuration = __webpack_require__(27);
    var Preconditions = __webpack_require__(14);

    // Regex to search for a server 4xx/5xx status/error code in the document title as websites tend to
    // return a valid html document alongside 404's, for example. We have no way of accessing load failures
    // like this via iframe elements, so this is an attempt to detect this (on same domains). On success,
    // that is on for example a detected 404, we simply report this via the frontend error logger so we
    // can track such issues and help our clients...
    var ERROR_CODE = /(?:^|\D)(4\d\d|5\d\d)(?:\D|$)/;

    /**
     * A mixin defining functionality to create iframes related to embedding urls, e.g. in a Lightbox or via
     * an EmbedWidget.
     */
    return {
        __typeName: "EmbedMixin",

        /**
         * @private
         * Creates a new iframe for embedding, optionally with the specified attributes. The url to be embedded
         * may represent an embedded Viewer (Group or Experience), or just some random (cross domain) url. <p>
         *
         * The iframe is not inserted into any document when returned. The "src" property will not be set to
         * <tt>descriptor.url</tt>; it must explicitly be set via <tt>attrs</tt> if required here.
         *
         * @param  {*} descriptor The url descriptor; cannot be falsey.
         * @param  {*} [attrs]    Optional iframe attributes; can be falsey/empty.
         *
         * @return {jQuery} A jQuery element wrapping the created iframe; never falsey.
         */
        _createIframe: function _createIframe(descriptor, attrs) {
            attrs = _.extend({ allowFullscreen: true }, attrs);

            // Embedded Viewer? If so, we must tag the iframe as such as this is used by ViewerProxy...
            if (descriptor.type !== "url") {
                attrs["data-zmags-viewer"] = Configuration.version;
            }

            return $("<iframe />", attrs);
        },


        /**
         * @private
         * Attempts to find a http 4xx/5xx status/error code for the specified iframe window. <p>
         *
         * If such a code is returned, a prudent message will have been logged via the frontend error logger,
         * if enabled.
         *
         * @param  {Window} iframeWin The iframe window; cannot be falsey, and should be accessible.
         * @return {String} The http 4xx/5xx status/error code if so deduced, otherwise falsey.
         */
        _statusCode: function _statusCode(iframeWin) {
            try {
                var code = ERROR_CODE.exec(iframeWin.document.title);
                if (code) {
                    code = code[1]; // [1] stores the actual code.
                    Preconditions.warn("Potential '" + code + "' status code for " + this.__typeName + ": '" + iframeWin.location + "'"); // warn so we can track it
                }
                return code;
            } catch (e) {// e.g. SecurityError on cross domain
                // Fall-through
            }
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

// Patched to force AMD usage over CommonJS
(function (t, e) {
  if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else t.Spinner = e();
})(undefined, function () {
  "use strict";
  var t = ["webkit", "Moz", "ms", "O"],
      e = {},
      i;function o(t, e) {
    var i = document.createElement(t || "div"),
        o;for (o in e) {
      i[o] = e[o];
    }return i;
  }function n(t) {
    for (var e = 1, i = arguments.length; e < i; e++) {
      t.appendChild(arguments[e]);
    }return t;
  }var r = function () {
    var t = o("style", { type: "text/css" });n(document.getElementsByTagName("head")[0], t);return t.sheet || t.styleSheet;
  }();function s(t, o, n, s) {
    var a = ["opacity", o, ~~(t * 100), n, s].join("-"),
        f = .01 + n / s * 100,
        l = Math.max(1 - (1 - t) / o * (100 - f), t),
        u = i.substring(0, i.indexOf("Animation")).toLowerCase(),
        d = u && "-" + u + "-" || "";if (!e[a]) {
      r.insertRule("@" + d + "keyframes " + a + "{" + "0%{opacity:" + l + "}" + f + "%{opacity:" + t + "}" + (f + .01) + "%{opacity:1}" + (f + o) % 100 + "%{opacity:" + t + "}" + "100%{opacity:" + l + "}" + "}", r.cssRules.length);e[a] = 1;
    }return a;
  }function a(e, i) {
    var o = e.style,
        n,
        r;i = i.charAt(0).toUpperCase() + i.slice(1);for (r = 0; r < t.length; r++) {
      n = t[r] + i;if (o[n] !== undefined) return n;
    }if (o[i] !== undefined) return i;
  }function f(t, e) {
    for (var i in e) {
      t.style[a(t, i) || i] = e[i];
    }return t;
  }function l(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];for (var o in i) {
        if (t[o] === undefined) t[o] = i[o];
      }
    }return t;
  }function u(t) {
    var e = { x: t.offsetLeft, y: t.offsetTop };while (t = t.offsetParent) {
      e.x += t.offsetLeft, e.y += t.offsetTop;
    }return e;
  }function d(t, e) {
    return typeof t == "string" ? t : t[e % t.length];
  }var p = { lines: 12, length: 7, width: 5, radius: 10, rotate: 0, corners: 1, color: "#000", direction: 1, speed: 1, trail: 100, opacity: 1 / 4, fps: 20, zIndex: 2e9, className: "spinner", top: "auto", left: "auto", position: "relative" };function c(t) {
    if (typeof this == "undefined") return new c(t);this.opts = l(t || {}, c.defaults, p);
  }c.defaults = {};l(c.prototype, { spin: function spin(t) {
      this.stop();var e = this,
          n = e.opts,
          r = e.el = f(o(0, { className: n.className }), { position: n.position, width: 0, zIndex: n.zIndex }),
          s = n.radius + n.length + n.width,
          a,
          l;if (t) {
        t.insertBefore(r, t.firstChild || null);l = u(t);a = u(r);f(r, { left: (n.left == "auto" ? l.x - a.x + (t.offsetWidth >> 1) : parseInt(n.left, 10) + s) + "px", top: (n.top == "auto" ? l.y - a.y + (t.offsetHeight >> 1) : parseInt(n.top, 10) + s) + "px" });
      }r.setAttribute("role", "progressbar");e.lines(r, e.opts);if (!i) {
        var d = 0,
            p = (n.lines - 1) * (1 - n.direction) / 2,
            c,
            h = n.fps,
            m = h / n.speed,
            y = (1 - n.opacity) / (m * n.trail / 100),
            g = m / n.lines;(function v() {
          d++;for (var t = 0; t < n.lines; t++) {
            c = Math.max(1 - (d + (n.lines - t) * g) % m * y, n.opacity);e.opacity(r, t * n.direction + p, c, n);
          }e.timeout = e.el && setTimeout(v, ~~(1e3 / h));
        })();
      }return e;
    }, stop: function stop() {
      var t = this.el;if (t) {
        clearTimeout(this.timeout);if (t.parentNode) t.parentNode.removeChild(t);this.el = undefined;
      }return this;
    }, lines: function lines(t, e) {
      var r = 0,
          a = (e.lines - 1) * (1 - e.direction) / 2,
          l;function u(t, i) {
        return f(o(), { position: "absolute", width: e.length + e.width + "px", height: e.width + "px", background: t, boxShadow: i, transformOrigin: "left", transform: "rotate(" + ~~(360 / e.lines * r + e.rotate) + "deg) translate(" + e.radius + "px" + ",0)", borderRadius: (e.corners * e.width >> 1) + "px" });
      }for (; r < e.lines; r++) {
        l = f(o(), { position: "absolute", top: 1 + ~(e.width / 2) + "px", transform: e.hwaccel ? "translate3d(0,0,0)" : "", opacity: e.opacity, animation: i && s(e.opacity, e.trail, a + r * e.direction, e.lines) + " " + 1 / e.speed + "s linear infinite" });if (e.shadow) n(l, f(u("#000", "0 0 4px " + "#000"), { top: 2 + "px" }));n(t, n(l, u(d(e.color, r), "0 0 1px rgba(0,0,0,.1)")));
      }return t;
    }, opacity: function opacity(t, e, i) {
      if (e < t.childNodes.length) t.childNodes[e].style.opacity = i;
    } });function h() {
    function t(t, e) {
      return o("<" + t + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', e);
    }r.addRule(".spin-vml", "behavior:url(#default#VML)");c.prototype.lines = function (e, i) {
      var o = i.length + i.width,
          r = 2 * o;function s() {
        return f(t("group", { coordsize: r + " " + r, coordorigin: -o + " " + -o }), { width: r, height: r });
      }var a = -(i.width + i.length) * 2 + "px",
          l = f(s(), { position: "absolute", top: a, left: a }),
          u;function p(e, r, a) {
        n(l, n(f(s(), { rotation: 360 / i.lines * e + "deg", left: ~~r }), n(f(t("roundrect", { arcsize: i.corners }), { width: o, height: i.width, left: i.radius, top: -i.width >> 1, filter: a }), t("fill", { color: d(i.color, e), opacity: i.opacity }), t("stroke", { opacity: 0 }))));
      }if (i.shadow) for (u = 1; u <= i.lines; u++) {
        p(u, -2, "progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)");
      }for (u = 1; u <= i.lines; u++) {
        p(u);
      }return n(e, l);
    };c.prototype.opacity = function (t, e, i, o) {
      var n = t.firstChild;o = o.shadow && o.lines || 0;if (n && e + o < n.childNodes.length) {
        n = n.childNodes[e + o];n = n && n.firstChild;n = n && n.firstChild;if (n) n.opacity = i;
      }
    };
  }var m = f(o("group"), { behavior: "url(#default#VML)" });if (!a(m, "transform") && m.adj) h();else i = a(m, "animation");return c;
});

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var random = __webpack_require__(1410)
var format = __webpack_require__(1411)

/**
 * Low-level function to change alphabet and ID size.
 *
 * Alphabet must contain 256 symbols or less. Otherwise, the generator
 * will not be secure.
 *
 * @param {string} alphabet Symbols to be used in ID.
 * @param {number} size The number of symbols in ID.
 *
 * @return {string} Unique ID.
 *
 * @example
 * const generate = require('nanoid/generate')
 * model.id = generate('0123456789абвгдеё', 5) //=> "8ё56а"
 *
 * @name generate
 * @function
 */
module.exports = format.bind(null, random)


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractWidgetView = __webpack_require__(61);
    var $ = __webpack_require__(4);

    var _require = __webpack_require__(1),
        extend = _require.extend;

    var StyleableMixin = __webpack_require__(502);
    var Color = __webpack_require__(194);
    var ButtonWidgetHelper = __webpack_require__(776);
    var ButtonIconModel = __webpack_require__(304);
    var ButtonType = __webpack_require__(364);
    var WebFontsUtil = __webpack_require__(136);

    return AbstractWidgetView.extend("ButtonWidgetView", {

        className: AbstractWidgetView.prototype.className + " button-widget",

        mixin: StyleableMixin,

        _$container: null,

        _$label: null,

        _$icon: null,

        modelEvents: extend(AbstractWidgetView.prototype.modelEvents, {
            "change:icon": "render"
        }),

        options: {
            fetchIcon: ButtonWidgetHelper.fetchIcon
        },

        onInitialize: function onInitialize(element) {
            this._$container = $("<button></button>").attr("type", "button");
            this._$label = $("<span></span>");
            this._$icon = $("<span></span>");

            this._$label.css({
                whiteSpace: "nowrap",
                overflow: "hidden"
            });

            this._$container.css({
                userSelect: "none",
                pointerEvents: "none",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "transparent"
            });
            element.append(this._$container);
        },
        updateRendering: function updateRendering(element, bounds, active, edited) {
            var attributes = this.model.attributes;
            var buttonType = attributes.buttonType;

            this._$container.empty();

            element.attr("data-button-type", buttonType);

            var fontFamily = null;

            if (buttonType !== ButtonType.ICON_ONLY) {
                var unquotedFontFamily = WebFontsUtil.getCssFontFamily(this.model);
                if (unquotedFontFamily) {
                    fontFamily = WebFontsUtil.quoteSpecialFontNames(unquotedFontFamily);
                }
            }

            var buttonCss = {
                lineHeight: "1.4",
                padding: "6px " + attributes.padding + "px",
                color: attributes.color,
                fontFamily: fontFamily,
                fontStyle: attributes.fontStyle,
                fontWeight: attributes.fontWeight,
                fontSize: parseInt(attributes.fontSize, 10) + "px",
                border: "0",
                minWidth: attributes.fontSize,
                minHeight: attributes.fontSize
            };

            if (buttonType === ButtonType.ICON_ONLY) {
                buttonCss.padding = attributes.padding;
            }

            var iconModel = attributes.icon;
            switch (attributes.buttonType) {
                case ButtonType.ICON_ONLY:
                    this._$label.text("");
                    this.$el.attr("aria-label", iconModel.get("name"));
                    this._$container.append(this._$icon);
                    this._setupIcon();
                    break;
                case ButtonType.TEXT_AND_ICON:
                    this._$label.text(attributes.label);
                    this.$el.attr("aria-label", attributes.label);
                    if (iconModel.get("placement") === ButtonIconModel.Placement.AFTER) {
                        this._$container.append(this._$label);
                        this._$container.append(this._$icon);
                    } else {
                        this._$container.append(this._$icon);
                        this._$container.append(this._$label);
                    }
                    this._setupIcon();
                    break;
                case ButtonType.TEXT_ONLY:
                    this._$label.text(attributes.label);
                    this.$el.attr("aria-label", attributes.label);
                    this._$container.append(this._$label);
                    break;
                default:
                    throw new Error("unexpected button type: '" + attributes.buttonType + "'");
            }

            var buttonActive = !edited;

            if (buttonActive) {
                this._setupMouseEffect(element);
            }

            element.toggleClass("active", buttonActive);
            this._$container.css(buttonCss);
            this._$container.attr("title", this.model.get("title"));
        },
        _setupIcon: function _setupIcon() {
            var _this = this;

            var buttonSize = this.model.get("fontSize");

            this._$icon.css({
                width: buttonSize,
                height: buttonSize,
                lineHeight: 0
            });

            var iconModel = this.model.get("icon");
            this.options.fetchIcon(iconModel).then(function (svg) {
                var fontSize = _this.model.get("fontSize");
                $(svg).css({
                    fill: iconModel.get("color")
                }).attr("width", fontSize).attr("height", fontSize).attr("aria-labelledby", "title");

                var $title = $("<title></title>").text(iconModel.get("name"));

                $(svg).prepend($title);

                _this._$icon.empty();
                _this._$icon.append(svg);
                var buttonType = _this.model.get("buttonType");

                if (buttonType === ButtonType.TEXT_AND_ICON) {
                    if (iconModel.get("placement") === ButtonIconModel.Placement.AFTER) {
                        _this._$icon.css({
                            "margin-left": 5,
                            "margin-right": 0
                        });
                        _this._$container.append(_this._$icon);
                    } else {
                        _this._$icon.css({
                            "margin-left": 0,
                            "margin-right": 5
                        });
                        _this._$container.prepend(_this._$icon);
                    }
                } else {
                    _this._$icon.css({
                        "margin-left": 0,
                        "margin-right": 0
                    });
                }

                // Good practice for async rendering - also needed for WidgetCollectionView
                // to proper update transform controls when in the editor.
                _this.trigger("update");
            });
        },
        _setupMouseEffect: function _setupMouseEffect(element) {
            var backgroundColor = this.model.get("backgroundColor");

            if (!backgroundColor.length) {
                return;
            }

            var hoverColor = Color.hexToRgba(backgroundColor, 0.75);
            var downColor = Color.hexToRgba(backgroundColor, 0.95);

            element.mouseenter(function () {
                element.css("backgroundColor", hoverColor);
            }).mousedown(function () {
                element.css("backgroundColor", downColor);
            }).mouseup(function () {
                element.css("backgroundColor", hoverColor);
            }).mouseleave(function () {
                element.css("backgroundColor", backgroundColor);
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var SlideAnimationModel = __webpack_require__(1420);
    var SlideOutAnimationModel = __webpack_require__(1421);
    var FadeAnimationModel = __webpack_require__(1422);
    var FadeOutAnimationModel = __webpack_require__(1423);
    var ZoomInAnimationModel = __webpack_require__(1424);
    var ZoomOutAnimationModel = __webpack_require__(1425);
    var MoveAnimationModel = __webpack_require__(1426);
    var SlideAnimationController = __webpack_require__(1427);
    var SlideOutAnimationController = __webpack_require__(1430);
    var FadeAnimationController = __webpack_require__(1431);
    var FadeOutAnimationController = __webpack_require__(1432);
    var ZoomInAnimationController = __webpack_require__(1433);
    var ZoomOutAnimationController = __webpack_require__(1434);
    var MoveAnimationController = __webpack_require__(1435);

    /**
     * The different types of animations and non-editor information about them.
     *
     * Editor-specific information goes into {@link AnimationEditorTypes} instead.
     *
     * @class AnimationTypes
     */
    return {
        "SLIDE": {
            id: "slide",
            name: "slide",
            modelClass: SlideAnimationModel,
            animationControllerClass: SlideAnimationController
        },
        "SLIDE_OUT": {
            id: "slideOut",
            name: "slideOut",
            modelClass: SlideOutAnimationModel,
            animationControllerClass: SlideOutAnimationController
        },
        "FADE": {
            id: "fade",
            name: "fade",
            modelClass: FadeAnimationModel,
            animationControllerClass: FadeAnimationController
        },
        "FADE_OUT": {
            id: "fadeOut",
            name: "fadeOut",
            modelClass: FadeOutAnimationModel,
            animationControllerClass: FadeOutAnimationController
        },
        "ZOOM_IN": {
            id: "zoomIn",
            name: "zoomIn",
            modelClass: ZoomInAnimationModel,
            animationControllerClass: ZoomInAnimationController
        },
        "ZOOM_OUT": {
            id: "zoomOut",
            name: "zoomOut",
            modelClass: ZoomOutAnimationModel,
            animationControllerClass: ZoomOutAnimationController
        },
        "MOVE": {
            id: "move",
            name: "move",
            modelClass: MoveAnimationModel,
            animationControllerClass: MoveAnimationController
        },

        /**
         * Gets the animation type for the given type string.
         *
         * @param {String} typeString The type string.
         * @returns {Object} The type descriptor matching the given type, or undefined if not found.
         */
        fromString: function fromString(typeString) {
            return _.find(this, function (type) {
                return type.id === typeString;
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Effect = __webpack_require__(302);
    var EffectModel = __webpack_require__(78);

    var OpacityEffect = Effect.extend({
        duration: function duration(triggerType) {
            return triggerType === EffectModel.TRIGGER_TYPE_HOVER ? 0.100 : null;
        },
        config: function config() {
            return {
                opacity: this.model.get("opacity"),
                ease: Effect.Easing.Linear.easeNone
            };
        }
    });

    return OpacityEffect;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Size__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Point__ = __webpack_require__(773);


var Rect = /** @class */ (function () {
    function Rect(x, y, width, height) {
        if (width === void 0) { width = 0; }
        if (height === void 0) { height = 0; }
        if (x instanceof __WEBPACK_IMPORTED_MODULE_1__Point__["a" /* default */]) {
            this.point = x;
            this._size = y;
            return;
        }
        this.point = new __WEBPACK_IMPORTED_MODULE_1__Point__["a" /* default */](x, y);
        if (width instanceof __WEBPACK_IMPORTED_MODULE_0__Size__["a" /* default */]) {
            this._size = width;
        }
        else {
            this._size = new __WEBPACK_IMPORTED_MODULE_0__Size__["a" /* default */](width, height);
        }
    }
    Object.defineProperty(Rect, "zero", {
        get: function () {
            return new Rect(0, 0, 0, 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "x", {
        get: function () {
            return this.point.x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "y", {
        get: function () {
            return this.point.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "left", {
        get: function () {
            return this.point.x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "top", {
        get: function () {
            return this.point.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "width", {
        get: function () {
            return this._size.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "height", {
        get: function () {
            return this._size.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Rect.prototype, "size", {
        get: function () {
            return this._size.clone();
        },
        enumerable: true,
        configurable: true
    });
    return Rect;
}());
/* harmony default export */ __webpack_exports__["a"] = (Rect);


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_util_MathUtil__ = __webpack_require__(72);

var Size = /** @class */ (function () {
    /**
     * Creates an instance of Size.
     */
    function Size(width, height) {
        if (width === void 0) { width = 0; }
        if (height === void 0) { height = 0; }
        this.width = width;
        this.height = height;
    }
    Object.defineProperty(Size, "zero", {
        get: function () {
            return new Size();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Size.prototype, "aspectRatio", {
        get: function () {
            return this.width / this.height;
        },
        enumerable: true,
        configurable: true
    });
    Size.prototype.shrinkToAspectRatio = function (aspectRatio) {
        var thisRatio = this.aspectRatio;
        var w = this.width;
        var h = this.height;
        if (aspectRatio > thisRatio) {
            w = this.width;
            h = __WEBPACK_IMPORTED_MODULE_0_shared_util_MathUtil__["default"].round(this.width / aspectRatio, 2);
        }
        else if (aspectRatio < thisRatio) {
            h = this.height;
            w = __WEBPACK_IMPORTED_MODULE_0_shared_util_MathUtil__["default"].round(this.height * aspectRatio, 2);
        }
        return new Size(w, h);
    };
    /**
     * Equals.
     */
    Size.prototype.equals = function (size) {
        if (!size) {
            return false;
        }
        if (size === this) {
            return true;
        }
        if (size instanceof Size) {
            return this.width === size.width && this.height === size.height;
        }
        return false;
    };
    Size.prototype.clone = function () {
        return new Size(this.width, this.height);
    };
    return Size;
}());
/* harmony default export */ __webpack_exports__["a"] = (Size);


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Point = /** @class */ (function () {
    function Point(x, y) {
        if (x === void 0) { x = 0; }
        if (y === void 0) { y = 0; }
        this.x = x;
        this.y = y;
    }
    return Point;
}());
/* harmony default export */ __webpack_exports__["a"] = (Point);


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(155),
    now = __webpack_require__(1447),
    toNumber = __webpack_require__(1448);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);

    return function () {
        function _class() {
            _classCallCheck(this, _class);
        }

        _createClass(_class, null, [{
            key: "fetchIcon",
            value: function fetchIcon(model) {
                return $.ajax({
                    url: model.getIconUrl(),
                    crossDomain: true
                }).then(function (result) {
                    return result.documentElement;
                });
            }
        }]);

        return _class;
    }();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        isNumber = _require.isNumber,
        isUndefined = _require.isUndefined,
        first = _require.first;

    var Backbone = __webpack_require__(7);

    var _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank;

    var FontDescriptor = __webpack_require__(1452);
    var Preconditions = __webpack_require__(14);
    var FontProvider = __webpack_require__(103);

    /**
     * The default maximum number of search results per font provider.
     *
     * @type {Number}
     */
    var DEFAULT_SEARCH_LIMIT = 20;
    var DEFAULT_TAKE_AMOUNT = 20;

    /**
     * Convenience collection for working with fonts.
     *
     * The collection is used to store font descriptors from various font providers, e.g. Google, Typekit, standard
     * web fonts etc. - providing a common interface.
     *
     * This should only be used from within the "editor".
     *
     * @see EditorWebFontController
     *
     * @class FontDescriptorCollection
     * @author Kim
     */
    return Backbone.Collection.extend({

        model: FontDescriptor,

        /**
         * Returns an array of <tt>FontDescriptor</tt>'s from the specified <tt>FontProvider</tt>.
         *
         * @param  {FontProvider} fontProvider The <tt>FontProvider</tt>.
         * @return {FontDescriptor[]}          Array of <tt>FontDescriptor</tt>'s.
         */
        fromProvider: function fromProvider(fontProvider) {
            return this.filter(function (fontDescriptor) {
                return fontDescriptor.get("provider") === fontProvider;
            });
        },


        /**
         * Removes all the <tt>FontDescriptor</tt>'s (if any) that belongs to the specified <tt>FontProvider</tt>.
         *
         * @param  {FontProvider} fontProvider The font provider.
         */
        removeByProvider: function removeByProvider(fontProvider) {
            this.remove(this.fromProvider(fontProvider));
        },


        /**
         * Returns the contained <tt>FontDescriptor</tt> from the specified font family and font provider.
         *
         * @param  {String} fontFamily   The font family, e.g. <tt>Arial</tt> (case insensitive).
         * @param  {FontProvider} fontProvider The font provider.
         * @return {FontDescriptor}      The matching font provider, if any.
         */
        fromFamily: function fromFamily(fontFamily, fontProvider) {
            Preconditions.isString(fontFamily);
            Preconditions.instanceOf(fontProvider, FontProvider);

            return this.find(function (fontDescriptor) {
                return fontDescriptor.get("family").toLowerCase() === fontFamily.toLowerCase() && fontDescriptor.get("provider") === fontProvider;
            });
        },


        /**
         * Adds a new <tt>FontDescriptor</tt> to the collection. If a descriptor with the same font family
         * (and provider) already exists, the existing provider gets updated.
         *
         * @param {String} family The font family.
         * @param {String} variation  The variation, i.e. font style/weight.
         * @param {FontProvider} provider  The <tt>FontProvider</tt>.
         * @param {Object} data Optional font descriptor data.
         */
        addDescriptor: function addDescriptor(family, variation, provider, data) {
            var descriptor = this.fromFamily(family, provider);

            if (descriptor && descriptor.get("variations").indexOf(variation) === -1) {
                descriptor.get("variations").push(variation);
            } else {
                var variations = [variation];
                this.add(new FontDescriptor({
                    family: family,
                    provider: provider,
                    variations: variations,
                    data: data
                }));
            }
        },


        /**
         * Performs a basic text search from the specified search <tt>term</tt>, matching any contained font family.
         *
         * @param  {String|Number} term  The term to search for as a string value, or a numeric limit value. If a
         *                               number (or undefined) is used, a map of all font providers are returned, with
         *                               the limited number of search results.
         *
         * @param  {Number} limit        The maximum number of returned search results per font
         *                               provider. Defaults to <tt>DEFAULT_SEARCH_LIMIT</tt>.
         *
         * @return {Map.<FontProvider, FontDescriptor[]>} A map of search results, where <tt>FontDescriptor</tt>'s are
         *                                                mapped to their <tt>FontProvider</tt>.
         */
        search: function search(term, limit) {
            var _this = this;

            var results = new Map();

            if (isNumber(term)) {
                limit = term;
                term = "";
            } else if (isUndefined(term)) {
                term = "";
            }

            FontProvider.all().forEach(function (provider) {
                var providerFonts = _this.fromProvider(provider);
                var isUnlimited = provider === FontProvider.CUSTOM;
                if (providerFonts.length > 0) {
                    var providerResults = isBlank(term) ? providerFonts : providerFonts.filter(function (fontDescriptor) {
                        var family = fontDescriptor.get("family").toLowerCase();
                        return family.indexOf(term.toLowerCase()) !== -1;
                    });

                    if (providerResults.length > 0) {
                        var fontResults = isUnlimited ? providerResults : first(providerResults, limit || DEFAULT_SEARCH_LIMIT);
                        results.set(provider, fontResults);
                    }
                }
            });

            return results;
        },


        /**
         * Takes the first `amount` font descriptors of the collection.
         *
         * @param  {Number} amount      The number of returned items. Defaults
         *                              to DEFAULT_TAKE_AMOUNT.
         *
         * @return {Map.<FontProvider, FontDescriptor[]>}
         *                              A map of search results, where
         *                              <tt>FontDescriptor</tt>'s are mapped to
         *                              their <tt>FontProvider</tt>.
         */
        take: function take(amount) {
            amount = isNumber(amount) ? amount : DEFAULT_TAKE_AMOUNT;

            return this.search("", amount);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var FontDescriptorCollection = __webpack_require__(777);
    var FontProvider = __webpack_require__(103);
    var WebFontVariants = __webpack_require__(365).default;

    /*
     * @type {FontDescriptorCollection}
     */
    var fontDescriptorCollection = null;

    /**
     * An object containing a list of all standard fonts, including their aliases.
     *
     * @class StandardWebFontList
     *
     * @author Bruce Mackenzie Nielsen
     * @author Kim
     */
    var StandardWebFontList = {
        collection: function collection() {
            if (fontDescriptorCollection) {
                return fontDescriptorCollection;
            }

            var variations = _.map(WebFontVariants.get(FontProvider.STANDARD), function (variant) {
                return variant.value;
            });

            var descriptors = StandardWebFontList.items.map(function (item) {
                return {
                    provider: FontProvider.STANDARD,
                    name: item.family,
                    family: item.family,
                    cssFamily: StandardWebFontList.cssFamilyNames(item),
                    variations: variations
                };
            });

            fontDescriptorCollection = new FontDescriptorCollection(descriptors);

            return fontDescriptorCollection;
        },


        /**
         * Convenience method for constructing the CSS font family for a given font family string. <p>
         *
         * For an unknown <tt>value</tt>, <tt>value</tt> is simply returned as-is.
         *
         * @param  {String|Object} value The font family string, e.g. <tt>"Palatino Linotype"</tt>.
         * @return {String} The CSS family string, e.g. <tt>"Palatino Linotype, Book Antiqua, Palatino, serif"</tt>.
         *                  Will be <tt>value</tt> as-is if <tt>value</tt> is unknown.
         */
        cssFamilyNames: function cssFamilyNames(value) {
            var css = value;
            var item = _.isObject(value) ? value : _.find(StandardWebFontList.items, function (item) {
                if (value.toLowerCase() === item.family.toLowerCase()) {
                    return true;
                }
                // Look for a possible alias
                var aliases = _.invoke(item.aliases, "toLowerCase");
                return _.contains(aliases, value.toLowerCase());
            });

            if (item) {
                css = item.family;

                item.aliases.forEach(function (alias) {
                    css += "," + alias;
                });

                css += "," + item.genericFamily;
            }

            return css;
        },


        items: [{
            family: "Arial",
            aliases: ["Helvetica"],
            genericFamily: "sans-serif"
        }, {
            family: "Arial Black",
            aliases: ["Gadget"],
            genericFamily: "sans-serif"
        }, {
            family: "Courier New",
            aliases: [],
            genericFamily: "monospace"
        }, {
            family: "Georgia",
            aliases: [],
            genericFamily: "serif"
        }, {
            family: "Lucida Sans Unicode",
            aliases: ["Lucida Grande"],
            genericFamily: "sans-serif"
        }, {
            family: "Palatino Linotype",
            aliases: ["Book Antiqua", "Palatino"],
            genericFamily: "serif"
        }, {
            family: "Tahoma",
            aliases: ["Geneva"],
            genericFamily: "sans-serif"
        }, {
            family: "Times New Roman",
            aliases: ["Times"],
            genericFamily: "serif"
        }, {
            family: "Trebuchet MS",
            aliases: [],
            genericFamily: "sans-serif"
        }, {
            family: "Verdana",
            aliases: ["Geneva"],
            genericFamily: "sans-serif"
        }],

        reset: function reset() {
            fontDescriptorCollection = null;
        }
    };

    return StandardWebFontList;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Marionette = __webpack_require__(10);
    var WidgetScaleMode = __webpack_require__(246);

    /**
     * Renders and propagates each widget view and state from a composite widget collection
     *
     * @return {Marionette CollectionView}
     */
    return Marionette.CollectionView.extend({

        className: "widget-container-inner",

        _experience: null,
        _compositeModel: null,

        initialize: function initialize() {
            this._compositeModel = this.options.compositeModel;
            this._experience = this.options.viewModel.get("experience");
        },


        /**
         * Get the view for each widget, this overwrites the default from marionette
         *
         * @param {Backbone.Model} widgetModel
         * @returns {Function(WidgetView)} Returns widget view constructor function
         */
        getItemView: function getItemView(widgetModel) {
            var type = widgetModel.get("type");
            var ViewClass = this.options.WidgetTypes.lookup(type).viewClass;

            if (this.options.edited) {
                return this.options.TransformableWidgetFactory.create(type, ViewClass);
            }

            return ViewClass;
        },
        itemViewOptions: function itemViewOptions() {
            var _this = this;

            return {
                viewModel: this.options.viewModel,
                edited: this.options.edited,
                container: this.$el,
                enableActions: this.options.enableActions,
                enableAnimations: this.options.enableAnimations,
                getPositionOffset: function getPositionOffset() {
                    return {
                        left: _this._compositeModel.get("left") * _this._experience.get("scaledWidth") / 100,
                        top: _this._compositeModel.get("top") * _this._experience.get("scaledHeight") / 100
                    };
                }
            };
        },
        updateGroupActiveState: function updateGroupActiveState(active) {
            if (active === false) {
                this.children.each(function (itemView) {
                    itemView.setActive(false);
                });

                return;
            }

            // If group widgets are visible make them active as well
            var visiblePartOfExperience = this.options.viewModel.get("viewportVisibility");
            this.children.each(function (itemView) {
                var widgetRectangle = itemView.getRect();
                var widgetIsVisible = visiblePartOfExperience.intersects(widgetRectangle);
                itemView.setActive(widgetIsVisible);
            });
        },


        /**
         * Calculate the bounding box of all widgets in this collection
         *
         * @returns {left, top, width, height} Returns the position and size of the bounding box
         */
        getGroupBoundingBox: function getGroupBoundingBox() {
            var scale = this._experience.get("scale");
            var topLeftPoint = { x: Infinity, y: Infinity };
            var bottomRightPoint = { x: 1, y: 1 };

            this.children.each(function (itemView) {
                var boundingBox = itemView.getBoundingBox();

                if (itemView.model.get("scaleMode") === WidgetScaleMode.STRETCH) {
                    // Revert the stretch compensation (see AbstractWidgetView #getRect) so
                    // we get the initial values instead of one for positioning
                    var xf = boundingBox.width - boundingBox.width * scale.x;
                    var yf = boundingBox.height - boundingBox.height * scale.y;
                    boundingBox.x += xf * 0.5;
                    boundingBox.y += yf * 0.5;

                    // Take scaling into account for scaled values
                    boundingBox.width *= scale.x;
                    boundingBox.height *= scale.y;
                }

                var x1 = boundingBox.x;
                var y1 = boundingBox.y;
                var x2 = boundingBox.x + boundingBox.width;
                var y2 = boundingBox.y + boundingBox.height;

                if (itemView.model.get("isVisible")) {
                    topLeftPoint.x = _.min([x1, topLeftPoint.x]);
                    topLeftPoint.y = _.min([y1, topLeftPoint.y]);
                    bottomRightPoint.x = _.max([x2, bottomRightPoint.x]);
                    bottomRightPoint.y = _.max([y2, bottomRightPoint.y]);
                }
            });

            return {
                left: topLeftPoint.x / this._experience.get("scaledWidth") * 100,
                top: topLeftPoint.y / this._experience.get("scaledHeight") * 100,
                width: (bottomRightPoint.x - topLeftPoint.x) / this._experience.get("scaledWidth") * 100,
                height: (bottomRightPoint.y - topLeftPoint.y) / this._experience.get("scaledHeight") * 100
            };
        }
    }, {
        injection: {
            parameters: ["WidgetTypes"],
            asOptions: true
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractWidgetView = __webpack_require__(61);
    var SalesforceCommerceQuickViewAction = __webpack_require__(354);

    /**
     * The view rendering an SalesforceCommerce widget.
     *
     * @class SalesforceCommerceWidgetView
     * @constructor
     *
     * @cfg {SalesforceCommerceWidgetModel} model The model of the SalesforceCommerce widget being rendered.
     */
    return AbstractWidgetView.extend("SalesforceCommerceWidget", {

        tagName: "div",

        className: AbstractWidgetView.prototype.className + " salesforce-commerce-widget",

        transient: ["action"], // created on the fly, no need to persist (editor specific)

        constructor: function constructor() {
            this.__super();

            // Create action to handle the Quickview integration; if no product id has been set yet, the action
            // is not activateable...
            var action = new SalesforceCommerceQuickViewAction({ productID: this.model.get("productID") });
            var options = { silent: true };

            // Set backing action silently; it is an implementation detail we do not expose directly to the
            // world as is...
            this.model.set("action", action, options);

            // Make sure we update the backing action according to the product id set...
            this.listenTo(this.model, "change:productID", function (model, productID) {
                // really only ever in the Editor
                action.set("productID", productID, options);
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var AbstractWidgetView = __webpack_require__(61);
    var channelBridge = __webpack_require__(241);
    var EmbedMixin = __webpack_require__(765);
    var UrlUtil = __webpack_require__(46);
    var Window = __webpack_require__(48);
    var Browser = __webpack_require__(39);

    /**
     * The view rendering an embed widget.
     *
     * @class EmbedWidgetView
     * @constructor
     *
     * @cfg {EmbedWidgetModel} model The model of the embed widget being rendered.
     */
    return AbstractWidgetView.extend("EmbedWidgetView", { // TODO: consider retuning a promise from .promise() that resolves when the embedded Experience/Group is resolved,
        //       should probably be configurable per widget...

        mixin: EmbedMixin,

        tagName: "div",

        className: AbstractWidgetView.prototype.className + " embed-widget",

        _channel: null,
        _descriptor: null,

        _embedElement: null,
        _sizingElement: null, // iframe on direct url, matched element on embedded via channels!
        _activeState: null,

        /**
         * @private @type {Boolean}
         * Set to true if the embedding via channels failed for some obscure reason, thus defaulting to the
         * direct url (also on re-render).
         */
        _failedToEmbed: false,

        updateRendering: function updateRendering(element, bounds, active, edited) {
            var _this = this;

            var staticRepresentation = !this.options.enableAnimations;
            var rendering = this._activeState === null; // first render only, also for adjacent Scene rendering
            var becameInactive = !active && (this._activeState || rendering);

            var becameActive = active && !this._activeState;

            this._activeState = active;

            // For the editor and static (thumbnail) state
            if (edited || staticRepresentation) {
                element.empty();

                this._sizingElement = this._embedElement = $("<div class='placeholder'/>").appendTo(element);

                // When inside the viewer/player
            } else {
                this._descriptor = UrlUtil.getUrlDescriptor(this.model.get("url"));

                var embed = true; // since we want direct url behaviour in editor as well
                var bridge = !this._failedToEmbed && channelBridge();
                var url = this._descriptor.type === "url";
                var scene = this.viewScope.getSceneNumber(); // current scene number in *this* Experience
                var iframeUrl = void 0; // some external link or perhaps a direct url for a group/experience

                // Viewer is embedded via a Channel, so we can utilise this to ensure we can embed another
                // Experience or Group that can do cross domain JS calls because of the neatness of channels...
                if (bridge && !url) {
                    this._descriptor.sameOrigin = true; // for consistency
                    if (!this._sizingElement) {
                        // since embedElement can only be set after population
                        element.empty();
                        this._channel = bridge.embed({
                            scene: scene,
                            descriptor: this._descriptor,
                            element: $("<div/>").appendTo(element),
                            callback: function callback(populated) {
                                var channelContainer = _this._channel.container(); // container = iframe
                                _this._failedToEmbed = !populated;

                                if (!populated || !document.body.contains(channelContainer)) {
                                    // If the embedding via channels somehow fails, default to a direct url...
                                    bridge.removeEmbed(_this._channel, true); // true = destroy
                                    _this._sizingElement = null;
                                    _this.render();
                                } else {
                                    // We can now reference the iframe, i.e. actual embed element, and so we must
                                    // remember to set the state we have now...
                                    _this._embedElement = $(channelContainer);
                                    _this._childOptions(_this._activeState, bounds);
                                }
                            }
                        });
                        // Cannot set "embedElement" at this point, the channel will not have been embedded yet, but
                        // we can set the sizingElement just fine...
                        this._sizingElement = $(this._channel.element()); // matched element
                    }
                    embed = false;
                }

                // Not embedded via a Channel, so simply embed using a direct url. The descriptor type can still
                // be any old plain url, it does not have to be an embedded Experience at this point...
                if (embed) {
                    iframeUrl = UrlUtil.getEmbedURL(this._descriptor, "embedded", scene); // can still be cross domain in the Editor!

                    if (!this._sizingElement) {
                        // Disable scrolling on iOS (capabilities.isIframeScrollingSupported) for embedded experiences - due to
                        // the way mobile Safari handles iframes, see discussion
                        // here: http://stackoverflow.com/questions/23083462/how-to-get-an-iframe-to-be-responsive-in-ios-safari
                        var scrolling = Browser.capabilities.isIframeScrollingSupported || url;

                        var frameAttributes = {
                            src: iframeUrl,
                            scrolling: scrolling ? "auto" : "no"
                        };

                        var title = this.model.get("title");
                        if (title && title.length) {
                            frameAttributes.title = title;
                        }

                        this._sizingElement = this._embedElement = this._createIframe(this._descriptor, frameAttributes).appendTo(element);
                    }
                }

                // Keep Experiences/Groups embedded via a direct url or urls for the same (client) origin,
                // but potentially not anything else; the embedded Experiences are handled in the else-block below when
                // on same domain (Viewer), but the Editor will be here for top most Viewers and embedded Experiences...
                if (url || !this._descriptor.sameOrigin) {
                    // OR part for Editor top level preview embedding Viewers via direct url
                    // We only need to do anything on active if we have a blanked url...
                    becameActive = becameActive && this._embedElement.attr("src") !== iframeUrl;

                    // The widget can become inactive in two ways: on the same Scene, e.g. because of scroll or
                    // resize, or because of Scene navigation or adjacent Scene rendering.
                    var viewModel = this._viewModel();
                    // eslint-disable-next-line eqeqeq
                    var type = viewModel.get("currentScene") == scene ? "Scroll" : "Navigate"; // == intentional, string/number

                    // Only on first rendering (not becoming inactive/active) or on special case when navigating
                    // between different tabs in the browser, we coerce a blanking of the src tab to ensure we always
                    // stops embedded videos and what not. This will be the case if we are rendering because of a
                    // "change:shown" event that will have triggered an "change:active" event...
                    if (!viewModel.get("shown")) {
                        // TODO: this logic should eventually also be available for Lightboxes.
                        type = "Hidden";
                    } else if (rendering) {
                        type = "Render";
                    }

                    // Three attributes/states controls how the iframe src is blanked or not:
                    //
                    // - "blankOnRender":   blank when rendered the first time on an adjacent Scene, e.g. if we
                    //                      no the url links to a video player that will auto play. Default
                    //                      false.
                    // - "blankOnNavigate": blank when navigating away from the Scene, e.g. to stop a video
                    //                      when the Scene is hidden. Default true. If true and "blankOnRender"
                    //                      is false, the iframe will will be inserted again in the background
                    //                      while the Scene hidden, to prepare for navigation while the Scene
                    //                      is still rendered in memory.
                    // - "blankOnHidden":   blank when navigating away from the tab in the browser, e.g. to stop a video
                    //                      when the tab containing the Experience is hidden. Default true. If true
                    //                      and "blankOnRender" is false, the iframe will will be inserted again in
                    //                      the background while the tab is still hidden, to prepare for the user
                    //                      clicking back to the tab in a while.
                    // - "blankOnScroll:    blank when the user scrolls/resize out of focus. Default true.
                    //
                    // Currently, no models have these properties, so they all default; eventually we can make
                    // the Editor support this for fine grained control over this behaviour.

                    var blank = this.model.get("blankOn" + type);

                    // Support legacy widget data with no such properties and/or to do a sensible default...
                    // eslint-disable-next-line eqeqeq
                    if (blank == null) {
                        // Default: blank on all except initial rendering to maintain backwards compatibility... :/
                        blank = type !== "Render";
                    }

                    // Same domain url, // e.g. a client linking to a page on its own domain...
                    if (this._descriptor.sameOrigin) {
                        if (becameActive || rendering && !blank) {
                            // Same origin, so safe to sniff the document title for potential error code; this will not
                            // break embed functionality, we just want to report it so we can track it in LogStash...
                            this._embedElement.one("load", function () {
                                _this._statusCode(_this._embedElement[0].contentWindow);
                            });
                        }

                        // Cross domain url...
                    } else {
                        var updateUrl = function updateUrl(clear) {
                            var url = clear ? "about:blank" : iframeUrl;
                            _this._log().verbose("Setting embed url: '" + url + "'", _this);
                            _this._embedElement.attr("src", url);
                        };

                        if (becameActive) {
                            updateUrl();
                        }
                        if (becameInactive) {
                            if (blank) {
                                updateUrl(true);

                                // If we blanked because of navigation, prepare for to insert the url again when
                                // hidden (now, just in the immediate future are the dom update) if we should not
                                // blank on render. This ensures the iframe contents will be as ready as they can
                                // be for when the user navigates back to this Scene again while this Scene instance
                                // is still buffered/rendered...
                                if (url && (type === "Navigate" || type === "Hidden")) {
                                    // url check to avoid restart embedded Experiences again in the Editor
                                    if (!this.model.get("blankOnRender")) {
                                        // also work for default!
                                        _.defer(updateUrl);
                                    }
                                }
                            }
                        }
                    }

                    // Make sure we tell the embedded Experience about its new state, including all its embedded
                    // children recursively. If we do not do this, it will continue auto playing while not shown...
                } else if (this._embedElement) {
                    this._childOptions(this._activeState, bounds);
                }
            }

            this._sizingElement.css({
                width: "1px",
                minWidth: "100%",
                height: "1px",
                minHeight: "100%"
            });
        },


        /**
         * @private
         */
        _childOptions: function _childOptions(active, bounds) {
            // We cannot simply set the state on this Viewer, since that will also affect siblings
            // (e.g. on other scenes), which we do not want, but by calling the specific child, it will
            // recurse down from there (as opposed to the top most Viewer) because we specify {recursive: true}
            // directly. And, we set "active, not just "stalled", as we want timers and what not to be stopped
            // while the embedded Experience is for example hidden on a non-visible adjacent Scene...
            var iframe = this._embedElement[0];
            var childState = Window.viewer(iframe, "state"); // iframe.contentWindow may not be available yet or even cross domain in Editor!
            var state = { name: "active", value: active, recursive: true };

            // Can we talk directly to the child Viewer? If so, it has already been primed with the options
            // sometime in the past and we are only concerned about state changes henceforth as its size, for example,
            // will be handled by its own ResponsibleViewerController...
            if (childState) {
                childState(state); // same origin if available!

                // We do not have a child viewer yet, so save the state and options for when it comes online in a bit. When
                // the embedded child viewer registers it self at this (parent) viewer, it will receive the options and
                // state stored here, which the embedded Viewer will then use during its initialisation routine. In the
                // Editor, however, we will not have a viewer proxy due to cross domain issues, i.e. the viewer being
                // inserted directly into a pre-existing dom element...
            } else {
                Window.viewer("self", "register", iframe, { state: state, initialSize: bounds.toSize() });
            }
        },
        onClose: function onClose() {
            // If we have a channels, it means we have an embedded Experience/Group via an temp in-place channel that
            // when removed will close the Viewer recursively (will be anything by null in the editor)...
            if (this._channel) {
                var bridge = channelBridge();
                if (bridge) {
                    bridge.removeEmbed(this._channel);
                    this._channel = null;
                }

                // Remember to close embedded Viewer recursively for direct urls manually, if any, as we do not have
                // an in-place Channel to call the Viewer proxy for us...
            } else if (this._embedElement && this._descriptor && this._descriptor.type !== "url") {
                // "descriptor" can be null in editor
                Window.viewer(this._embedElement[0], "state", { name: "closed", value: true }); // will recurse
            }

            this.__super();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);

    var DEFAULT_HTML_HEIGHT_PERCENTAGE = 50;
    var DEFAULT_HTML_WIDTH_PERCENTAGE = 50;

    /**
     * Model for the html widget.
     *
     * @class HTMLWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("HTMLWidget", {

        defaults: _.defaults({
            type: "html",
            width: DEFAULT_HTML_HEIGHT_PERCENTAGE,
            height: DEFAULT_HTML_WIDTH_PERCENTAGE,
            htmlText: ""
        }, AbstractWidgetModel.prototype.defaults)

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var AbstractWidgetView = __webpack_require__(61);

    /**
     * The view rendering a link widget.
     *
     * @class LinkWidgetView
     * @constructor
     *
     * @cfg {LinkWidgetModel} model The model of the link widget being rendered.
     */
    return AbstractWidgetView.extend("LinkWidget", {

        _$placeholderElement: null,

        className: AbstractWidgetView.prototype.className + " link-widget",

        updateRendering: function updateRendering(element, bounds, active, edited) {
            if (edited) {
                if (this._$placeholderElement === null) {
                    this._$placeholderElement = $("<div class='placeholder'></div>").appendTo(element);
                }
            } else {
                // IE 10 and below does not handle overlayed widgets correctly unless they have
                // a background.
                element.css({
                    backgroundColor: "#fff",
                    opacity: 0
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var AbstractWidgetView = __webpack_require__(61);

    /**
     * The view rendering a product widget.
     *
     * @class ProductWidgetView
     * @constructor
     *
     * @cfg {ProductWidgetModel} model The model of the link widget being rendered.
     */
    return AbstractWidgetView.extend("ProductWidgetView", {

        _$placeholderElement: null,

        className: AbstractWidgetView.prototype.className + " product-widget",

        updateRendering: function updateRendering(element, bounds, active, edited) {
            if (edited) {
                if (this._$placeholderElement === null) {
                    var icon = this.model.get("icon");
                    this._$placeholderElement = $("<div class=\"placeholder " + icon + "\"></div>").appendTo(element);
                }
            } else {
                // IE 10 and below does not handle overlayed widgets correctly unless they have
                // a background.
                element.css({
                    backgroundColor: "#fff",
                    opacity: 0
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var StyleableMixin = __webpack_require__(502);
    var AbstractWidgetView = __webpack_require__(61);

    /**
     * The view rendering a shape widget.
     *
     * @class ShapeWidgetView
     * @constructor
     *
     * @cfg {ShapeWidgetModel} model The model of the shape widget being rendered.
     */
    return AbstractWidgetView.extend("ShapeWidget", {

        mixin: StyleableMixin

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_BASE_WIDGET */
/* unused harmony export sourceType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SocialSharingWidgetStyleCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SocialSharingWidgetStyleName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SocialSharingWidgetNetwork; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FontFormats; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__geom_Scale__ = __webpack_require__(1462);

var DEFAULT_BASE_WIDGET = {
    type: "composite" /* COMPOSITE */,
    top: 0,
    left: 0,
    rotation: 0,
    layerIndex: 0,
    scale: new __WEBPACK_IMPORTED_MODULE_0__geom_Scale__["a" /* Scale */](),
    onClickHandler: function () { return undefined; },
    trackerEventHandler: function () { return undefined; },
    effects: [],
    animations: [],
    width: 0,
    height: 0,
    sceneNumber: "0",
};
var sourceType;
(function (sourceType) {
    sourceType["Scene7"] = "Scene7Integration";
})(sourceType || (sourceType = {}));
var SocialSharingWidgetStyleCategory;
(function (SocialSharingWidgetStyleCategory) {
    SocialSharingWidgetStyleCategory["FlatSquared"] = "flat-squared";
    SocialSharingWidgetStyleCategory["FlatRounded"] = "flat-rounded";
    SocialSharingWidgetStyleCategory["Isolated"] = "isolated";
    SocialSharingWidgetStyleCategory["FlatCircle"] = "flat-circle";
    SocialSharingWidgetStyleCategory["WhiteCircle"] = "white-circle";
    SocialSharingWidgetStyleCategory["BlackCircle"] = "black-circle";
})(SocialSharingWidgetStyleCategory || (SocialSharingWidgetStyleCategory = {}));
var SocialSharingWidgetStyleName;
(function (SocialSharingWidgetStyleName) {
    SocialSharingWidgetStyleName["Squared"] = "Squared";
    SocialSharingWidgetStyleName["Rounded"] = "Rounded";
    SocialSharingWidgetStyleName["Isolated"] = "Isolated";
    SocialSharingWidgetStyleName["Circle"] = "Circle";
    SocialSharingWidgetStyleName["White"] = "White";
    SocialSharingWidgetStyleName["Black"] = "Black";
})(SocialSharingWidgetStyleName || (SocialSharingWidgetStyleName = {}));
var SocialSharingWidgetNetwork;
(function (SocialSharingWidgetNetwork) {
    SocialSharingWidgetNetwork["Facebook"] = "facebook";
    SocialSharingWidgetNetwork["Twitter"] = "twitter";
    SocialSharingWidgetNetwork["Linkedin"] = "linkedin";
    SocialSharingWidgetNetwork["Pinterest"] = "pinterest";
    SocialSharingWidgetNetwork["GooglePlus"] = "googleplus";
})(SocialSharingWidgetNetwork || (SocialSharingWidgetNetwork = {}));
var FontFormats;
(function (FontFormats) {
    FontFormats["TrueType"] = "truetype";
    FontFormats["Woff"] = "woff";
    FontFormats["OpenType"] = "opentype";
})(FontFormats || (FontFormats = {}));


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var AbstractWidgetView = __webpack_require__(61);
    var Browser = __webpack_require__(39);
    var YouTubeIframeAPI = __webpack_require__(1467);
    var Promise = __webpack_require__(21);

    /**
     * Method for creating the youtube element.
     *
     * @param  {YT} YT  The <tt>YT</tt> iframe API, loaded via the <tt>YouTubeIframeAPI</tt>.
     * @param  {number} width The width of the video element.
     * @param  {number} height The height of the video element.
     * @param  {object} vars Object containing all of the player variables.
     * @param  {string} videoID String containing specific id for the video.
     * @param  {HTMLElement} element The raw <tt>HTMLElement</tt>.
     *
     * @return {Promise}        <tt>Promise</tt> that resolves when the player instance is considered *ready*.
     */
    function youTubePlayerReady(YT, width, height, vars, videoID, element) {
        return Promise.deferred(function (deferred) {
            var player = new YT.Player(element, {
                playerVars: vars,
                height: height,
                width: width,
                videoId: videoID,
                events: {
                    onReady: function onReady() {
                        deferred.resolve(player);
                    }
                }
            });
        }).promise();
    }

    /**
     * Create the container around the preview image
     *
     * @param {object} bounds bounds of widget. Must contain a <code>width</code> and <code>height</code> key
     * @return {jQueryDomObject} jQuery html element
     */
    var createYoutubePreviewImageContainer = function createYoutubePreviewImageContainer(_ref) {
        var width = _ref.width,
            height = _ref.height;
        return $("<div class=\"youtube-preview-video-image-container\" style=\"width: " + width + "px; height: " + height + "px\" />");
    };

    /**
     * The view rendering an YouTube widget.
     *
     * @class YouTubeWidgetView
     * @constructor
     *
     * @cfg {YouTubeWidgetModel} model The model of the Youtube widget being rendered.
     */
    return AbstractWidgetView.extend("YouTubeWidget", {

        tagName: "div",

        className: AbstractWidgetView.prototype.className + " youtube-widget",

        _inactivePane: null,

        _videoElement: null,

        _activeState: false,

        _player: null,

        /**
         * Creates the YouTube player instance by loading the API and replacing the element with the iframe -
         * returning a promise that resolves with the new player instance.<p>
         *
         * @param  {jquery} element A jquery wrapped <tt>HTMLElement</tt>.
         * @return {Promise} <tt>Promise</tt> that resolves when the player instance is considered *ready*.
         */
        _createPlayer: function _createPlayer(element) {
            var videoId = this.model.get("videoID");
            var playerEl = element.get(0);
            var vars = this.model.getPlayerVars();
            var width = this._bounds.width;
            var height = this._bounds.height;

            return YouTubeIframeAPI.load().then(function (YT) {
                return youTubePlayerReady(YT, width, height, vars, videoId, playerEl);
            });
        },


        /**
         * Handles play/pause state - invoked when the active state changes.
         */
        _updateToActiveState: function _updateToActiveState() {
            var _this = this;

            // Get the youtube Iframe API since we need more than what is in the player
            YouTubeIframeAPI.load().then(function (YT) {
                // See https://developers.google.com/youtube/iframe_api_reference
                if (_this._player) {
                    if (_this._activeState && _this.model.get("autoplay")) {
                        // Handles special case when when player has ended and still need to be started
                        if (_this._player.getPlayerState() === YT.PlayerState.ENDED) {
                            _this._player.seekTo(0, true);
                        }

                        // Since most mobile and tablet devices do not support auto play
                        // we want to only call playVideo for desktop browsers to avoid potential
                        // errors or endless loading spinners (see MOS-3197)
                        if (Browser.environment.desktop) {
                            _this._player.playVideo();
                        }
                    } else if (_this._player.getPlayerState() === YT.PlayerState.PLAYING) {
                        // Only pause the player if it actually is playing
                        _this._player.pauseVideo();
                    }
                }
            });
        },
        updateRendering: function updateRendering(element, bounds, active, edited, changedProperties) {
            var _this2 = this;

            this._bounds = bounds;

            // Determine whether the active state has changed since the last update
            var activeChanged = active !== this._activeState;

            // Minor hack to handle the thumbnail state
            var staticRepresentation = !this.options.enableAnimations;
            var videoID = this.model.get("videoID");
            var isThumbnail = !active && !edited && staticRepresentation && videoID;
            var isInSceneInEditor = !active && edited;
            var videoPreviewImageUrl = "//img.youtube.com/vi/" + videoID + "/hqdefault.jpg";

            this._activeState = active;

            // Render the iframe if it hasn't already been rendered, or if certain properties have changed (when editing)
            if (!this._videoElement || changedProperties && !_.isUndefined(changedProperties.videoID)) {
                element.empty();

                if (isInSceneInEditor) {
                    // Create a preview image of the youtube preview if we have a video ID.

                    this._inactivePane = createYoutubePreviewImageContainer(bounds).appendTo(element);

                    if (videoID) {
                        this._inactivePane.css("background-image", "url(\"" + videoPreviewImageUrl + "\")");
                        this._inactivePane.append("<div class=\"youtube-play-button-overlay\" />");
                    }

                    // This covers the thumbnail state
                } else if (isThumbnail) {
                    // Instead of constructing an iframe element, we create an image element
                    // displaying the associated poster image
                    this._inactivePane = createYoutubePreviewImageContainer(bounds).appendTo(element);
                    this._inactivePane.css("background-image", "url(\"" + videoPreviewImageUrl + "\")");
                } else {
                    // We're in the viewer...
                    this._createElement(element).then(function (player) {
                        _this2._player = player;
                        _this2._videoElement = $(_this2._player.getIframe());

                        // Mute Initially...
                        if (_this2.model.get("mute")) {
                            _this2._player.mute();
                        }

                        // Update state...
                        _this2._updateToActiveState();
                    }).fail(function () {
                        _this2._inactivePane = createYoutubePreviewImageContainer(bounds).appendTo(element);
                    });
                }

                // add no-video-id class if no video id, otherwise remove it
                element.toggleClass("no-video-id", !videoID);

                return;
            }

            // Ensure the iframe has the correct size if the properties might have changed
            if (changedProperties) {
                var elementWidth = element.css("width");
                var elementHeight = element.css("height");

                this._setElementSize(this._videoElement, elementWidth, elementHeight);
                this._setElementSize(this._inactivePane, elementWidth, elementHeight);
            }

            // Reload the iframe if it has gone from active to inactive, to stop the video from playing while hidden, or
            // if it has gone from inactive to active and has autoplay enabled

            if (activeChanged) {
                this._updateToActiveState();
            }
        },
        _createElement: function _createElement(parentElement) {
            if (this.model.has("videoID")) {
                this._videoElement = $("<div />").appendTo(parentElement);

                return this._createPlayer(this._videoElement);
            }
            return Promise.rejected("No videoID");
        },
        _setElementSize: function _setElementSize(element, width, height) {
            if (element) {
                element.css({ width: width, height: height });
            }
        },
        onClose: function onClose() {
            this.__super();

            // Dispose player...?
            if (this._player) {
                this._player.clearVideo();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var template = __webpack_require__(1468);

    return Marionette.Layout.extend({

        template: template,

        regions: {
            "groupOverlay": ".group-overlay",
            "group": ".group"
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var Configuration = __webpack_require__(27);

    /**
     * A product property model.
     *
     * @class ProductPropertiesModel
     * @constructor
     */
    return ImprovedModel.extend("ProductPropertiesModel", {

        _api: "productwidget",

        getProduct: function getProduct(productID, lang, companyid) {
            var url = Configuration.inventoryUrl;

            var urloptions = {
                silent: true,
                method: "get",
                type: "GET",
                url: url,
                data: {
                    cid: companyid,
                    lang: lang,
                    view: this._api,
                    ids: productID,
                    contentType: "application/json"
                }
            };

            return this.fetch(urloptions);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CreateWidgetHelper = __webpack_require__(1470),
        WidgetTypes = __webpack_require__(69),
        Promise = __webpack_require__(21),
        UUIDGenerator = __webpack_require__(250),
        LoggedInUserState = __webpack_require__(19),
        CurrencyMapper = __webpack_require__(1471),
        EditorEventFilters = __webpack_require__(154).default,
        MathUtil = __webpack_require__(72).default,
        DynamicProductWidgetModel = __webpack_require__(520),
        DynamicProductWidgetSubtypes = __webpack_require__(791).default;

    return {

        _imageProperties: {
            width: 250, height: 175, xOffset: 0, yOffset: 0, isDynamic: false
        },

        _priceProperties: {
            width: 150, xOffset: 0, yOffset: 180, fontSize: 24, isDynamic: true
        },

        _titleProperties: {
            width: 250, xOffset: 0, yOffset: 215, fontSize: 18, isDynamic: true
        },

        _descriptionProperties: {
            width: 250, xOffset: 0, yOffset: 265, fontSize: 14, isDynamic: true
        },

        createProductWidget: function createProductWidget(product, experience, dynamicProductWidget) {
            var keys = Object.keys(product.get("products"));
            if (keys.length > 0) {
                // We assume that the answer file either has 0 or 1 product
                var correctProductID = keys[0];
                var currentProduct = product.get("products")[keys[0]];
                if (currentProduct) {
                    return this._createProductWidgetTemplate({
                        experience: experience,
                        dynamicProductWidget: dynamicProductWidget,
                        productID: correctProductID,
                        title: currentProduct.title,
                        description: currentProduct.description,
                        price: "" + this._getCurrency(experience.get("language")) + currentProduct.priceValue
                    });
                }
            }
        },
        updateProductWidget: function updateProductWidget(product, experience, dynamicProductWidget) {
            var keys = Object.keys(product.get("products"));
            if (keys.length > 0) {
                // We assume that the answer file either has 0 or 1 product
                var currentProduct = product.get("products")[keys[0]];
                if (currentProduct) {
                    return this._updateProductWidgetTemplate(dynamicProductWidget, currentProduct.id, {
                        title: currentProduct.title,
                        description: currentProduct.description,
                        price: "" + this._getCurrency(experience.get("language")) + currentProduct.priceValue
                    });
                }
            }
        },


        /**
         * Updates a productWidget in the scene when a product ID is specified
         *
         * Generates a DynamicProductWidget widget and moves the specified widgets from the scene widget collection to the dynamic product widget.
         * The newly generated widget is then added to the scene.
         *
         * @param  {DynamicProductWidgetModel} previousProductWidgetModel The previous empty DynamicProductWidget.
         *  (one without a productID the workflow for a widget with a productID is different)
         * @param  {String} productID The productID of the new DynamicProductWidgetModel
         * @param  {widget} widgets The widgets to be added to the DynamicProductWidgetModel
         * @return {DynamicProductWidgetModel} newProductWidget The newly created and updated DynamicProductWidgetModel
         */
        updateProductWidgetOnScene: function updateProductWidgetOnScene(scene, previousProductWidgetModel, productID, widgets) {
            var widgetsOfGroup = widgets.map(function (widget) {
                return widget.clone();
            });

            // Sort the widgets to make sure layerIndex is respected
            widgetsOfGroup.sort(function (a, b) {
                return a.get("layerIndex") - b.get("layerIndex");
            });

            // Deletes the old widgets
            scene.deleteWidgets(widgets, { cause: EditorEventFilters.GROUP });

            // We create and delete the product widget because it's the easiest way to redraw the widget

            var uuid = previousProductWidgetModel.get("uuid");

            scene.deleteWidgetByID(previousProductWidgetModel.get("uuid"), { cause: EditorEventFilters.GROUP });

            var newProductWidget = new DynamicProductWidgetModel({ "group": widgetsOfGroup });
            newProductWidget.set("productID", productID, { cause: EditorEventFilters.SUPERFICIAL });
            newProductWidget.set("inputProductID", productID, { cause: EditorEventFilters.SUPERFICIAL });
            newProductWidget.set("uuid", uuid, { cause: EditorEventFilters.SUPERFICIAL });

            var lowestWidgetIndex = scene.getLowestIndex(widgetsOfGroup);

            scene.addWidget(newProductWidget, {
                cause: EditorEventFilters.SUPERFICIAL,
                at: lowestWidgetIndex - 1
            });

            scene.trigger("selectWidgets", [newProductWidget]);

            scene.reindexLayers(scene.get("widgets").models, 0, { cause: EditorEventFilters.SUPERFICIAL });

            return newProductWidget;
        },
        replaceProductWidget: function replaceProductWidget(scene, currentProductWidgetModel, nextProductWidgetModel) {
            scene.deleteWidgetByID(currentProductWidgetModel.get("uuid"), { cause: EditorEventFilters.UNDO });

            scene.addWidget(nextProductWidgetModel, {
                cause: EditorEventFilters.UNDO
            });

            scene.reindexLayers(scene.get("widgets").models, 0, { cause: EditorEventFilters.SUPERFICIAL });
        },
        _getCurrency: function _getCurrency(language) {
            return CurrencyMapper.getCurrencyMapping(language);
        },
        _updateProductWidgetTemplate: function _updateProductWidgetTemplate(dynamicProductWidget, newProductID, options) {
            var widgets = dynamicProductWidget.get("group");

            dynamicProductWidget.set("inputProductID", newProductID, { cause: EditorEventFilters.SUPERFICIAL });
            dynamicProductWidget.set("productID", newProductID, { cause: EditorEventFilters.SUPERFICIAL });

            var descriptionField = options.description,
                priceField = options.price,
                titleField = options.title;


            this._updateDynamicProductText(descriptionField, DynamicProductWidgetSubtypes.Description, widgets);
            this._updateDynamicProductText(priceField, DynamicProductWidgetSubtypes.Price, widgets);
            this._updateDynamicProductText(titleField, DynamicProductWidgetSubtypes.Title, widgets);

            return dynamicProductWidget;
        },
        _updateDynamicProductText: function _updateDynamicProductText(text, subtype, widgetList) {
            widgetList.forEach(function (widget) {
                if (widget.get("subtype") === subtype) {
                    widget.set("text", text.toString(), { cause: EditorEventFilters.SUPERFICIAL });
                }
            });
        },
        _createProductWidgetTemplate: function _createProductWidgetTemplate(options) {
            // We create the widget UUID's here because we need them at this point and they don't exist yet
            var imageWidgetUUID = UUIDGenerator.createUUID();
            var priceWidgetUUID = UUIDGenerator.createUUID();
            var titleWidgetUUID = UUIDGenerator.createUUID();
            var descriptionWidgetUUID = UUIDGenerator.createUUID();

            return this._createProductWidgetHelper({
                "productWidget": options.dynamicProductWidget,
                "experience": options.experience,
                "title": options.title,
                "description": options.description,
                "price": options.price,
                "imageWidgetUUID": imageWidgetUUID,
                "priceWidgetUUID": priceWidgetUUID,
                "titleWidgetUUID": titleWidgetUUID,
                "descriptionWidgetUUID": descriptionWidgetUUID
            });
        },
        _createProductWidgetHelper: function _createProductWidgetHelper(options) {
            var productX = MathUtil.invertScaleByExperienceSize(options.productWidget.get("left"), options.experience.get("width"));
            var productY = MathUtil.invertScaleByExperienceSize(options.productWidget.get("top"), options.experience.get("height"));
            var textWidgetType = void 0;
            if (LoggedInUserState.get("companySettings").get("enhancedTextWidgetEnabled")) {
                // Use ETW when ETW is enabled
                textWidgetType = WidgetTypes.TEXT_ENHANCED;
            } else {
                textWidgetType = WidgetTypes.TEXT;
            }

            // "unscaleWidgetWith" and "unscaledWidgetHeight" is set because width and height are constantly
            // being modified and changed and we need to know the fixed width and height of the image widget
            // without it being scaled
            var imageWidget = this._generateProductImageSubwidget({
                "experience": options.experience,
                "subtype": DynamicProductWidgetSubtypes.Image,
                "type": WidgetTypes.IMAGE,
                "uuid": options.imageWidgetUUID,
                "isDynamic": this._imageProperties.isDynamic,
                "width": this._imageProperties.width,
                "height": this._imageProperties.height,
                "x": productX + this._imageProperties.xOffset,
                "y": productY + this._imageProperties.yOffset,
                "scaleOnInitialize": true,
                "unscaledWidgetWidth": this._imageProperties.width,
                "unscaledWidgetHeight": this._imageProperties.height
            });

            var priceWidget = this._generateProductTextSubwidget({
                "experience": options.experience,
                "subtype": DynamicProductWidgetSubtypes.Price,
                "type": textWidgetType,
                "uuid": options.priceWidgetUUID,
                "isDynamic": this._priceProperties.isDynamic,
                "width": this._priceProperties.width,
                "height": null,
                "x": productX + this._priceProperties.xOffset,
                "y": productY + this._priceProperties.yOffset,
                "text": options.price.toString(),
                "fontSize": this._priceProperties.fontSize
            });

            var titleWidget = this._generateProductTextSubwidget({
                "experience": options.experience,
                "subtype": DynamicProductWidgetSubtypes.Title,
                "type": textWidgetType,
                "uuid": options.titleWidgetUUID,
                "isDynamic": this._titleProperties.isDynamic,
                "width": this._titleProperties.width,
                "height": null,
                "x": productX + this._titleProperties.xOffset,
                "y": productY + this._titleProperties.yOffset,
                "text": options.title,
                "fontSize": this._titleProperties.fontSize
            });

            var descriptionWidget = this._generateProductTextSubwidget({
                "experience": options.experience,
                "subtype": DynamicProductWidgetSubtypes.Description,
                "type": textWidgetType,
                "uuid": options.descriptionWidgetUUID,
                "isDynamic": this._descriptionProperties.isDynamic,
                "width": this._descriptionProperties.width,
                "height": null,
                "x": productX + this._descriptionProperties.xOffset,
                "y": productY + this._descriptionProperties.yOffset,
                "text": options.description,
                "fontSize": this._descriptionProperties.fontSize
            });

            return Promise.resolved([imageWidget, titleWidget, priceWidget, descriptionWidget]);
        },
        _generateProductImageSubwidget: function _generateProductImageSubwidget(options) {
            var widget = this._createAndSetProductWidgetProperties(options);

            widget.set("scaleOnInitialize", options.scaleOnInitialize, { cause: EditorEventFilters.SUPERFICIAL });
            widget.set("unscaledWidgetWidth", options.unscaledWidgetWidth, { cause: EditorEventFilters.SUPERFICIAL });
            widget.set("unscaledWidgetHeight", options.unscaledWidgetHeight, { cause: EditorEventFilters.SUPERFICIAL });

            return widget;
        },
        _generateProductTextSubwidget: function _generateProductTextSubwidget(options) {
            var experience = options.experience;
            var experienceSize = { height: experience.height, width: experience.width };

            var widget = this._createAndSetProductWidgetProperties(options);

            widget.set("text", options.text, experienceSize);
            widget.set("fontSize", options.fontSize, { cause: EditorEventFilters.SUPERFICIAL });

            return widget;
        },
        _createAndSetProductWidgetProperties: function _createAndSetProductWidgetProperties(options) {
            var experience = options.experience;
            var experienceSize = { height: experience.get("height"), width: experience.get("width") };

            var point = { x: options.x, y: options.y };

            var widget = this._createWidget(options, experienceSize, point);

            // set the left and top because we do not want undefined behavior
            this._setCoordinate(widget, point, experienceSize);

            // Apparently they scale by experience size
            this._setSize(widget, experience, options.width, options.height);
            return widget;
        },
        _createWidget: function _createWidget(options, size, point) {
            var widgetOptions = CreateWidgetHelper.WIDGET_OPTIONS[options.type];
            var extendOptions = CreateWidgetHelper.makeExtendOptions(size, point);
            var extendedOptions = extendOptions(widgetOptions);
            extendedOptions.uuid = options.uuid;
            extendedOptions.subtype = options.subtype;
            extendedOptions.isDynamic = options.isDynamic;
            var widget = CreateWidgetHelper.createWidget(size, options.type, extendedOptions);

            return widget;
        },
        _setCoordinate: function _setCoordinate(widget, coordinate, experienceSize) {
            var left = MathUtil.scaleByExperienceSize(coordinate.x, experienceSize.width);
            var top = MathUtil.scaleByExperienceSize(coordinate.y, experienceSize.height);
            widget.set("left", left, { cause: EditorEventFilters.SUPERFICIAL });
            widget.set("top", top, { cause: EditorEventFilters.SUPERFICIAL });
        },
        _setSize: function _setSize(widget, experience, width, height) {
            if (width) {
                var scaledWidth = MathUtil.scaleByExperienceSize(width, experience.get("width"));
                widget.set("width", scaledWidth, { cause: EditorEventFilters.SUPERFICIAL });
                widget.set("scaledWidgetWidth", scaledWidth, { cause: EditorEventFilters.SUPERFICIAL });
            }

            if (height) {
                var scaledHeight = MathUtil.scaleByExperienceSize(height, experience.get("height"));
                widget.set("height", scaledHeight, { cause: EditorEventFilters.SUPERFICIAL });
                widget.set("scaledWidgetHeight", scaledHeight, { cause: EditorEventFilters.SUPERFICIAL });
            }
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DynamicProductWidgetSubtypes", function() { return DynamicProductWidgetSubtypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DynamicProductWidgetSubtypes; });
var DynamicProductWidgetSubtypes;
(function (DynamicProductWidgetSubtypes) {
    DynamicProductWidgetSubtypes["Image"] = "Image";
    DynamicProductWidgetSubtypes["Price"] = "Price";
    DynamicProductWidgetSubtypes["Title"] = "Title";
    DynamicProductWidgetSubtypes["Description"] = "Description";
})(DynamicProductWidgetSubtypes || (DynamicProductWidgetSubtypes = {}));



/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SceneTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SceneTransition", function() { return SceneTransition; });
var SceneTransition;
(function (SceneTransition) {
    /**
     * List of the available scene transition constants.
     *
     * @class SceneTransition
     */
    SceneTransition["MOVE_FROM_RIGHT"] = "moveFromRight";
    SceneTransition["MOVE_TO_LEFT"] = "moveToLeft";
    SceneTransition["MOVE_FROM_LEFT"] = "moveFromLeft";
    SceneTransition["MOVE_TO_RIGHT"] = "moveToRight";
    SceneTransition["MOVE_FROM_TOP"] = "moveFromTop";
    SceneTransition["MOVE_TO_BOTTOM"] = "moveToBottom";
    SceneTransition["MOVE_FROM_BOTTOM"] = "moveFromBottom";
    SceneTransition["MOVE_TO_TOP"] = "moveToTop";
    SceneTransition["FADE_IN"] = "fadeIn";
    SceneTransition["FADE_OUT"] = "fadeOut";
})(SceneTransition || (SceneTransition = {}));



/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var PublishableState = __webpack_require__(65);
    var GroupModel = __webpack_require__(104);
    var ExperienceModel = __webpack_require__(58);
    var GroupUtil = __webpack_require__(306);
    var Locale = __webpack_require__(373);

    // Common publishable attributes we must clear on clone or update on sync, true for any publishable
    var ATTRIBUTES = ["state", "pushedAt", "pushedBy", "pushedVersion", "purgeTime", "editedAt", "editedBy"];

    /**
     * A mixin adding Publishable behaviour to models.
     */
    return {

        __typeName: "PublishableMixin", // for better type naming

        // Defaults to be mixed in for any Publishable type...
        defaults: {
            state: null, // string, not PublishableState constant
            pushedAt: 0,
            pushedBy: null,
            pushedVersion: null,
            purgeTime: null,
            editedAt: 0, // by definition, there cannot be a default edited time!
            editedBy: null
        },

        // Clear these fields on duplicate, i.e. when we duplicate to save a new copy...
        clearOnClone: function clearOnClone(options) {
            var attributes = this.__super();
            if (options.duplicate) {
                attributes = attributes ? attributes.concat(ATTRIBUTES) : ATTRIBUTES;
            }
            return attributes;
        },


        // Update these attributes after the specified sync method has been performed on this model; common meta data
        // attributes will always be updated where applicable, e.g. "id", "version", "createdBy", etc...
        updateOnSync: function updateOnSync(options) {
            var attributes = this.__super();
            if (options.sync === "save") {
                if (attributes) {
                    attributes.push("state");
                } else {
                    attributes = ["state"];
                }
            } else if (options.sync.indexOf("push") !== -1) {
                // for "push" and "push-with-assets" when pushed as a group asset
                attributes = attributes ? attributes.concat(ATTRIBUTES) : ATTRIBUTES;
            }
            return attributes;
        },


        // Will be mixed in with existing transient properties...
        transient: ["purgeTime", "state"],

        /**
         * Returns the <tt>PublishableState</tt> constant for this publishable, defaulting to
         * <tt>NOT_PUSHED</tt> if no state currently set.
         *
         * @return {PublishableState} The <tt>PublishableState</tt> constant for this publishable; never falsey,
         *                            defaulting to <tt>NOT_PUSHED</tt>.
         */
        getState: function getState() {
            return PublishableState.getEnum(this.get("state"));
        },


        /**
         * Returns true if this publishable has at least the specified state, false otherwise.
         *
         * @param  {Object}  state The state, as the enum representation, e.g. PublishableState.PUSHED, or as
         *                         its key, e.g. "PUSHED".
         * @return {Boolean} <tt>true</tt> if this publishable has at least the specified state, false otherwise.
         */
        hasAtLeastState: function hasAtLeastState(state) {
            return PublishableState.atLeast(this.get("state"), state);
        },


        /**
         * Returns the max purge time between this publishable model and the supplied purge time, if any. <p>
         *
         * If <tt>purgeTime</tt> is not specified, the purge time of this publishable will be returned, defaulting
         * to 0 if not set.
         *
         * @param {Number}  [purgeTime] The optional purge time to test against the purge time of this publishable;
         *                              can be falsey.
         * @return {Number} The (max) purge time for this publishable and <tt>purgeTime</tt>; can be null if not
         *                  applicable.
         */
        getPurgeTime: function getPurgeTime(purgeTime) {
            if (this.has("purgeTime")) {
                return Math.max(purgeTime || 0, this.get("purgeTime"));
            }
            return purgeTime; // can be null!
        },


        /**
         * Returns true if this publishable has changes since last push, false otherwise.
         *
         * @return {Boolean} True if changes since last push, false otherwise.
         * @see    #nonPushedChanges
         */
        isChangedAfterPush: function isChangedAfterPush() {
            // abs to ensure that stale pushed data will also work (negative versions to ensure we cannot
            // ever save such stale data again)...
            return this.hasAtLeastState(PublishableState.PUSHED) && Math.abs(this.get("version")) > this.get("pushedVersion");
        },


        /**
         * Returns true if this publishable has changes that are not pushed, false otherwise.
         *
         * @return {Boolean} True if non-pushed changes, false otherwise.
         * @see    #isChangedAfterPush
         */
        hasNonPushedChanges: function hasNonPushedChanges() {
            return this.getState() === PublishableState.NOT_PUSHED || this.isChangedAfterPush();
        },


        /**
         * Returns true if this publishable is an experience.
         *
         * @returns {Boolean} True if the publishable is an experience.
         */
        isExperience: function isExperience() {
            return (this instanceof ExperienceModel || this.get("type") === "Experience") && !this.get("group");
        },


        /**
         * Returns true if this publishable is a localized experience.
         *
         * @returns {Boolean} True if the publishable is a localized experience.
         */
        isLocalizedExperience: function isLocalizedExperience() {
            var group = this.get("group");
            return (this instanceof ExperienceModel || this.get("type") === "Experience") && group && group.type === GroupUtil.LOCALIZATION; // Embedded group is a plain object
        },


        /**
         * Returns true if this publishable is a breakpoint group.
         *
         * @returns {Boolean} True if the publishable is a breakpoint group.
         */
        isBreakpointGroup: function isBreakpointGroup() {
            return this instanceof GroupModel || this.get("type") === GroupUtil.BREAKPOINT;
        },


        /**
         * Returns the publishable display name, mainly to handle localized experiences name.
         *
         * @returns {String} The publishable name.
         */
        publishableDisplayName: function publishableDisplayName() {
            var displayName = this.get("name");

            if (this.isBreakpointGroup()) {
                return displayName;
            }

            if (this.isLocalizedExperience()) {
                var locale = Locale.localeStringFromModel(this);
                return displayName + " " + locale;
            }

            return displayName;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(795);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(796),
    toKey = __webpack_require__(379);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(123),
    isKey = __webpack_require__(526),
    stringToPath = __webpack_require__(1480),
    toString = __webpack_require__(1504);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isObject = __webpack_require__(155);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 799 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1511);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(199) && !__webpack_require__(310)(function () {
  return Object.defineProperty(__webpack_require__(802)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(309);
var document = __webpack_require__(254).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(309);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(534);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(535);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(79);
var global = __webpack_require__(254);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(807) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 808 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 809 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(308);
var dPs = __webpack_require__(1527);
var enumBugKeys = __webpack_require__(809);
var IE_PROTO = __webpack_require__(536)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(802)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1528).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(815);










var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * An HTML role attribute
   */
  role: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: Object(__WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* generatedId */])('PanelGroup')
};
var defaultProps = {
  accordion: false
};
var childContextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    headerRole: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    panelRole: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
  })
};

var PanelGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelGroup, _React$Component);

  function PanelGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    };

    return _this;
  }

  var _proto = PanelGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        accordion = _this$props.accordion,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;
    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + "-" + type + "-" + key : null;
      };
    }

    return {
      $bs_panelGroup: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        accordion = _this$props2.accordion,
        className = _this$props2.className,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["accordion", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        bsStyle: child.props.bsStyle || bsProps.bsStyle
      });
    }));
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;
PanelGroup.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel-group', PanelGroup), {
  activeKey: 'onSelect'
}));

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1535);

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1541);

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(199);
var getKeys = __webpack_require__(383);
var toIObject = __webpack_require__(384);
var isEnum = __webpack_require__(537).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = generatedId;
/* harmony export (immutable) */ __webpack_exports__["c"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["a"] = exclusiveRoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(85);



var idPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]);
function generatedId(name) {
  return function (props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error("In order to properly initialize the " + name + " in a way that is accessible to assistive technologies " + ("(such as screen readers) an `id` or a `generateChildId` prop to " + name + " is required"));
      }
    }

    return error;
  };
}
function requiredRoles() {
  for (var _len2 = arguments.length, roles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing;
    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error("(children) " + component + " - Missing a required child with bsRole: " + (missing + ". " + component + " must have at least one child of each of ") + ("the following bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}
function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate;
    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error("(children) " + component + " - Duplicate children detected of bsRole: " + (duplicate + ". Only one child each allowed with the following ") + ("bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(124);







var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
var defaultProps = {
  active: false
};

var BreadcrumbItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BreadcrumbItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        href = _this$props.href,
        title = _this$props.title,
        target = _this$props.target,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "href", "title", "target", "className"]); // Don't try to render these props on non-active <span>.


    var linkProps = {
      href: href,
      title: title,
      target: target
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
        active: active
      })
    }, active ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", props) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, linkProps)));
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition__);









var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};
var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = CarouselItem.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({
        direction: null
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;
    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition___default.a.end(__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  _proto.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        direction = _this$props.direction,
        active = _this$props.active,
        animateIn = _this$props.animateIn,
        animateOut = _this$props.animateOut,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["direction", "active", "animateIn", "animateOut", "className"]);

    delete props.onAnimateOutEnd;
    delete props.index;
    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };

    if (direction && active && animateIn) {
      classes[direction] = true;
    }

    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(819));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1555));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1557));

var _removeStyle = _interopRequireDefault(__webpack_require__(1558));

var _properties = __webpack_require__(540);

var _isTransform = _interopRequireDefault(__webpack_require__(1559));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1554));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(2));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(28));

var _reactLifecyclesCompat = __webpack_require__(1569);

var _PropTypes = __webpack_require__(1570);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(381).f;
var has = __webpack_require__(311);
var TAG = __webpack_require__(203)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(546);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(826);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(256);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(1588);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(1589);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(18);









var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DropdownToggle, _React$Component);

  function DropdownToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        noCaret = _this$props.noCaret,
        open = _this$props.open,
        useAnchor = _this$props.useAnchor,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["noCaret", "open", "useAnchor", "bsClass", "className", "children"]);

    delete props.bsRole;
    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */];
    var useCaret = !noCaret; // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.
    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      role: "button",
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClass),
      "aria-haspopup": true,
      "aria-expanded": open
    }), children || props.title, useCaret && ' ', useCaret && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      className: "caret"
    }));
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);








var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Grid, _React$Component);

  function Grid() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Grid.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        fluid = _this$props.fluid,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["fluid", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, fluid && 'fluid');
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('container', Grid));

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(74);









var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  listItem: false
};

var ListGroupItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ListGroupItem, _React$Component);

  function ListGroupItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroupItem.prototype;

  _proto.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(header)) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4", {
      className: headingClassName
    }, header);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        className = _this$props.className,
        header = _this$props.header,
        listItem = _this$props.listItem,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "disabled", "className", "header", "listItem", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes); // TODO: Deprecate `header` prop.

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, elementProps, this.renderHeader(header, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading')), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p", {
        className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'text')
      }, children));
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, elementProps, children);
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('list-group-item', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), ListGroupItem)));

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(202));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(202));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1625));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(395);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(313);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(394);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(396);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(256);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(1634);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var ModalBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalBody, _React$Component);

  function ModalBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-body', ModalBody));

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(74);








var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};

var ModalDialog =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalDialog, _React$Component);

  function ModalDialog() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalDialog.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        dialogClassName = _this$props.dialogClassName,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["dialogClassName", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps);

    var modalStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      display: 'block'
    }, style);

    var dialogClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      tabIndex: "-1",
      role: "dialog",
      style: modalStyle,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(dialogClassName, dialogClasses)
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'),
      role: "document"
    }, children)));
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalDialog.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var ModalFooter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalFooter, _React$Component);

  function ModalFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-footer', ModalFooter));

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CloseButton__ = __webpack_require__(538);








 // TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
  })
};

var ModalHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalHeader, _React$Component);

  function ModalHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        closeLabel = _this$props.closeLabel,
        closeButton = _this$props.closeButton,
        onHide = _this$props.onHide,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["closeLabel", "closeButton", "onHide", "className", "children"]);

    var modal = this.context.$bs_modal;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), closeButton && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CloseButton__["a" /* default */], {
      label: closeLabel,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
    }), children);
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-header', ModalHeader));

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalTitle, _React$Component);

  function ModalTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-title', ModalTitle));

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__ = __webpack_require__(85);












 // TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
// TODO: This `bsStyle` is very unlike the others. Should we rename it?
// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};
var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
  })
};

var Nav =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Nav, _React$Component);

  function Nav() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Nav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;
    var children = this.props.children;

    var _this$getActiveProps = this.getActiveProps(),
        activeKey = _this$getActiveProps.activeKey,
        activeHref = _this$getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    });
    var childrenArray = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);
    var childNodes = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  _proto.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ("activeKey={" + this.props.activeKey + "} />`.")) : void 0;
      return tabContainer;
    }

    return this.props;
  };

  _proto.getNextActiveChild = function getNextActiveChild(offset) {
    var _this2 = this;

    var children = this.props.children;
    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _this$getActiveProps2 = this.getActiveProps(),
        activeKey = _this$getActiveProps2.activeKey,
        activeHref = _this$getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    }); // This assumes the active child is not disabled.

    var activeChildIndex = validChildren.indexOf(activeChild);

    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  _proto.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this3 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;

    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this3.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  _proto.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;

      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;

      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  _proto.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _extends2,
        _this4 = this;

    var _this$props = this.props,
        stacked = _this$props.stacked,
        justified = _this$props.justified,
        onSelect = _this$props.onSelect,
        propsRole = _this$props.role,
        propsNavbar = _this$props.navbar,
        pullRight = _this$props.pullRight,
        pullLeft = _this$props.pullLeft,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["stacked", "justified", "onSelect", "role", "navbar", "pullRight", "pullLeft", "className", "children"]);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _this$getActiveProps3 = this.getActiveProps(),
        activeKey = _this$getActiveProps3.activeKey,
        activeHref = _this$getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().

    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'stacked')] = stacked, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName;
    var pullRightClassName;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || {
        bsClass: 'navbar'
      };
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'nav')] = true;
      pullRightClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right');
      pullLeftClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: role,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      var active = _this4.isActive(child, activeKey, activeHref);

      var childOnSelect = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _this4.getTabProps(child, tabContainer, role, active, childOnSelect), {
        active: active,
        activeKey: activeKey,
        activeHref: activeHref,
        onSelect: childOnSelect
      }));
    }));
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('nav', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsStyles */])(['tabs', 'pills'], Nav)));

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var NavbarBrand =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarBrand, _React$Component);

  function NavbarBrand() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarBrand.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }), children);
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(66);









var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
var defaultProps = {
  active: false,
  disabled: false
};

var NavItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavItem, _React$Component);

  function NavItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = NavItem.prototype;

  _proto.handleClick = function handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        className = _this$props.className,
        style = _this$props.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "disabled", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey; // These are injected down by `<Nav>` for building `<SubNav>`s.

    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      role: "presentation",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      disabled: disabled,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
    })));
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Fade__ = __webpack_require__(392);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default.a.propTypes, {
  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Overlay, _React$Component);

  function Overlay() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Overlay.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        animation = _this$props.animation,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["animation", "children"]);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */] : animation || null;
    var child;

    if (!transition) {
      child = Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default.a, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      transition: transition
    }), child);
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(546));

var _isWindow = _interopRequireDefault(__webpack_require__(395));

var _ownerDocument = _interopRequireDefault(__webpack_require__(313));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 846 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}

module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(395));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(66);









var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PagerItem, _React$Component);

  function PagerItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleSelect = _this.handleSelect.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = PagerItem.prototype;

  _proto.handleSelect = function handleSelect(e) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        previous = _this$props2.previous,
        next = _this$props2.next,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["disabled", "previous", "next", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        disabled: disabled,
        previous: previous,
        next: next
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      disabled: disabled,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
    })));
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(542);






var propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  })
};

var PanelCollapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelCollapse, _React$Component);

  function PanelCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelCollapse.prototype;

  _proto.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      in: expanded
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'collapse')
    }, children));
  };

  return PanelCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelCollapse.propTypes = propTypes;
PanelCollapse.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelCollapse));

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(66);









var propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a
};
var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */]
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    bodyId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
  })
};

var PanelToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelToggle, _React$Component);

  function PanelToggle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = PanelToggle.prototype;

  _proto.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        componentClass = _this$props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onClick", "className", "componentClass"]);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;
    props.onClick = Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleToggle);
    props['aria-expanded'] = expanded;
    props.className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, props);
  };

  return PanelToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PanelToggle.propTypes = propTypes;
PanelToggle.defaultProps = defaultProps;
PanelToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (PanelToggle);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Fade__ = __webpack_require__(392);












var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /** @private * */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /** @private * */
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired
  })
};
/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf([null])
};

var TabPane =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(TabPane, _React$Component);

  function TabPane(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEnter = _this.handleEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.in = false;
    return _this;
  }

  var _proto = TabPane.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  _proto.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  _proto.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  _proto.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  _proto.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;
    return this.props.eventKey === activeKey;
  };

  _proto.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        className = _this$props.className,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        onExited = _this$props.onExited,
        propsMountOnEnter = _this$props.mountOnEnter,
        propsUnmountOnExit = _this$props.unmountOnExit,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["eventKey", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit"]);

    var _this$context = this.context,
        tabContent = _this$context.$bs_tabContent,
        tabContainer = _this$context.$bs_tabContainer;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();
    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_11__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(tabContent, 'pane');
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "tabpanel",
      "aria-hidden": !active,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Transition, {
        in: active && !exiting,
        onEnter: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit
      }, pane);
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('tab-pane', TabPane));

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(312);






var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * [onChange description]
   */
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any.isRequired
};

var ToggleButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ToggleButton, _React$Component);

  function ToggleButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name,
        checked = _this$props.checked,
        type = _this$props.type,
        onChange = _this$props.onChange,
        value = _this$props.value,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "name", "checked", "type", "onChange", "value"]);

    var disabled = props.disabled;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      active: !!checked,
      componentClass: "label"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", {
      name: name,
      type: type,
      autoComplete: "off",
      value: value,
      checked: !!checked,
      disabled: !!disabled,
      onChange: onChange
    }), children);
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ToggleButton.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TippyGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tippy_js__ = __webpack_require__(854);
/* unused harmony reexport tippy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);






function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
function preserveRef(ref, node) {
  if (ref) {
    if (typeof ref === 'function') {
      ref(node);
    }

    if ({}.hasOwnProperty.call(ref, 'current')) {
      ref.current = node;
    }
  }
}
function ssrSafeCreateDiv() {
  return isBrowser && document.createElement('div');
}
function updateClassName(tooltip, action, classNames) {
  classNames.split(/\s+/).forEach(function (name) {
    if (name) {
      tooltip.classList[action](name);
    }
  });
}

// get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect because we want Tippy
// to perform sync mutations to the DOM elements after renders to prevent
// jitters/jumps, especially when updating content.

var useIsomorphicLayoutEffect = isBrowser ? __WEBPACK_IMPORTED_MODULE_1_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"];

function Tippy(_ref) {
  var children = _ref.children,
      content = _ref.content,
      className = _ref.className,
      onCreate = _ref.onCreate,
      isVisible = _ref.isVisible,
      isEnabled = _ref.isEnabled,
      visible = _ref.visible,
      enabled = _ref.enabled,
      _ref$ignoreAttributes = _ref.ignoreAttributes,
      ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? true : _ref$multiple,
      restOfNativeProps = _objectWithoutPropertiesLoose(_ref, ["children", "content", "className", "onCreate", "isVisible", "isEnabled", "visible", "enabled", "ignoreAttributes", "multiple"]);

  // `isVisible` / `isEnabled` renamed to `visible` / `enabled`
  enabled = enabled !== undefined ? enabled : isEnabled !== undefined ? isEnabled : true;
  visible = visible !== undefined ? visible : isVisible;

  var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  var containerRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])(ssrSafeCreateDiv());
  var targetRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();
  var instanceRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();
  var isControlledMode = visible !== undefined;

  var options = _extends({
    ignoreAttributes: ignoreAttributes,
    multiple: multiple
  }, restOfNativeProps, {
    content: containerRef.current
  });

  if (isControlledMode) {
    options.trigger = 'manual';
  }

  useIsomorphicLayoutEffect(function () {
    instanceRef.current = Object(__WEBPACK_IMPORTED_MODULE_0_tippy_js__["a" /* default */])(targetRef.current, options);

    if (onCreate) {
      onCreate(instanceRef.current);
    }

    if (!enabled) {
      instanceRef.current.disable();
    }

    if (visible) {
      instanceRef.current.show();
    }

    setMounted(true);
    return function () {
      instanceRef.current.destroy();
      instanceRef.current = null;
    };
  }, []);
  useIsomorphicLayoutEffect(function () {
    if (!mounted) {
      return;
    }

    instanceRef.current.set(options);

    if (enabled) {
      instanceRef.current.enable();
    } else {
      instanceRef.current.disable();
    }

    if (isControlledMode) {
      if (visible) {
        instanceRef.current.show();
      } else {
        instanceRef.current.hide();
      }
    }
  });
  useIsomorphicLayoutEffect(function () {
    if (className) {
      var tooltip = instanceRef.current.popperChildren.tooltip;
      updateClassName(tooltip, 'add', className);
      return function () {
        updateClassName(tooltip, 'remove', className);
      };
    }
  }, [className]);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(children, {
    ref: function ref(node) {
      targetRef.current = node;
      preserveRef(children.ref, node);
    }
  }), mounted && Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(content, containerRef.current));
}

Tippy.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element]).isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element.isRequired,
  onCreate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  isVisible: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  // deprecated
  isEnabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  // deprecated
  visible: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  enabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
};
var Tippy$1 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(function TippyWrapper(_ref2, _ref3) {
  var children = _ref2.children,
      props = _objectWithoutPropertiesLoose(_ref2, ["children"]);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tippy, props, Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(children, {
    ref: function ref(node) {
      preserveRef(_ref3, node);
      preserveRef(children.ref, node);
    }
  }));
});

function TippyGroup(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var instancesRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])([]);
  Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_0_tippy_js__["a" /* default */].group(instancesRef.current, props);
  });
  return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (child) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, {
      onCreate: function onCreate(instance) {
        if (child.props.onCreate) {
          child.props.onCreate(instance);
        }

        instancesRef.current.push(instance);
      }
    });
  });
}
TippyGroup.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Tippy$1);

//# sourceMappingURL=index.js.map


/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popper_js__ = __webpack_require__(1680);
/**!
* tippy.js v4.3.5
* (c) 2017-2019 atomiks
* MIT License
*/


var css = ".tippy-iOS{cursor:pointer!important;-webkit-tap-highlight-color:transparent}.tippy-popper{transition-timing-function:cubic-bezier(.165,.84,.44,1);max-width:calc(100% - 8px);pointer-events:none;outline:0}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-7px;bottom:-6.5px;-webkit-transform-origin:50% 0;transform-origin:50% 0;margin:0 3px}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;bottom:-7px;margin:0 3px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 25%;transform-origin:0 25%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-55%);transform:scale(1) translate(-50%,-55%)}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%,-45%);transform:scale(.2) translate(-50%,-45%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(-10px);transform:perspective(700px) translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateX(60deg);transform:perspective(700px) rotateX(60deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=top] [data-animation=scale]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px) scale(.5);transform:translateY(-10px) scale(.5)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-7px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%;margin:0 3px}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:8px solid #333;border-right:8px solid transparent;border-left:8px solid transparent;top:-7px;margin:0 3px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -50%;transform-origin:0 -50%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-45%);transform:scale(1) translate(-50%,-45%)}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-50%);transform:scale(.2) translate(-50%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateY(10px);transform:perspective(700px) translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateX(-60deg);transform:perspective(700px) rotateX(-60deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=scale]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px) scale(.5);transform:translateY(10px) scale(.5)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-12px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%;margin:3px 0}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-75%,-50%);transform:scale(.2) translate(-75%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(-10px);transform:perspective(700px) translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateY(-60deg);transform:perspective(700px) rotateY(-60deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=left] [data-animation=scale]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px) scale(.5);transform:translateX(-10px) scale(.5)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-12px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%;margin:3px 0}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:8px solid #333;border-top:8px solid transparent;border-bottom:8px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-50% 0;transform-origin:-50% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(1) translate(-50%,-50%);transform:scale(1) translate(-50%,-50%)}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(.2) translate(-25%,-50%);transform:scale(.2) translate(-25%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{-webkit-transform:perspective(700px) translateX(10px);transform:perspective(700px) translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:perspective(700px) rotateY(60deg);transform:perspective(700px) rotateY(60deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0}.tippy-popper[x-placement^=right] [data-animation=scale]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px) scale(.5);transform:translateX(10px) scale(.5)}.tippy-tooltip{position:relative;color:#fff;border-radius:.25rem;font-size:.875rem;padding:.3125rem .5625rem;line-height:1.4;text-align:center;background-color:#333}.tippy-tooltip[data-size=small]{padding:.1875rem .375rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.375rem .75rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:initial}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] .tippy-roundarrow path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:18px;height:7px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;background-color:#333;border-radius:50%;width:calc(110% + 2rem);left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:\"\";float:left;padding-top:100%}.tippy-backdrop+.tippy-content{transition-property:opacity;will-change:opacity}.tippy-backdrop+.tippy-content[data-state=hidden]{opacity:0}";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var version = "4.3.5";

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var ua = isBrowser ? navigator.userAgent : '';
var isIE = /MSIE |Trident\//.test(ua);
var isUCBrowser = /UCBrowser\//.test(ua);
var isIOS = isBrowser && /iPhone|iPad|iPod/.test(navigator.platform) && !window.MSStream;

var defaultProps = {
  a11y: true,
  allowHTML: true,
  animateFill: true,
  animation: 'shift-away',
  appendTo: function appendTo() {
    return document.body;
  },
  aria: 'describedby',
  arrow: false,
  arrowType: 'sharp',
  boundary: 'scrollParent',
  content: '',
  delay: 0,
  distance: 10,
  duration: [325, 275],
  flip: true,
  flipBehavior: 'flip',
  flipOnUpdate: false,
  followCursor: false,
  hideOnClick: true,
  ignoreAttributes: false,
  inertia: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  lazy: true,
  maxWidth: 350,
  multiple: false,
  offset: 0,
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  placement: 'top',
  popperOptions: {},
  role: 'tooltip',
  showOnInit: false,
  size: 'regular',
  sticky: false,
  target: '',
  theme: 'dark',
  touch: true,
  touchHold: false,
  trigger: 'mouseenter focus',
  triggerTarget: null,
  updateDuration: 0,
  wait: null,
  zIndex: 9999
  /**
   * If the set() method encounters one of these, the popperInstance must be
   * recreated
   */

};
var POPPER_INSTANCE_DEPENDENCIES = ['arrow', 'arrowType', 'boundary', 'distance', 'flip', 'flipBehavior', 'flipOnUpdate', 'offset', 'placement', 'popperOptions'];

var elementProto = isBrowser ? Element.prototype : {};
var matches = elementProto.matches || elementProto.matchesSelector || elementProto.webkitMatchesSelector || elementProto.mozMatchesSelector || elementProto.msMatchesSelector;
/**
 * Ponyfill for Array.from - converts iterable values to an array
 */

function arrayFrom(value) {
  return [].slice.call(value);
}
/**
 * Ponyfill for Element.prototype.closest
 */

function closest(element, selector) {
  return closestCallback(element, function (el) {
    return matches.call(el, selector);
  });
}
/**
 * Works like Element.prototype.closest, but uses a callback instead
 */

function closestCallback(element, callback) {
  while (element) {
    if (callback(element)) {
      return element;
    }

    element = element.parentElement;
  }

  return null;
}

// Passive event listener config
var PASSIVE = {
  passive: true // Popper `preventOverflow` padding

};
var PADDING = 4; // Popper attributes
// In Popper v2 these will be `data-*` instead of `x-*` to adhere to HTML5 spec

var PLACEMENT_ATTRIBUTE = 'x-placement';
var OUT_OF_BOUNDARIES_ATTRIBUTE = 'x-out-of-boundaries'; // Classes

var IOS_CLASS = "tippy-iOS";
var ACTIVE_CLASS = "tippy-active";
var POPPER_CLASS = "tippy-popper";
var TOOLTIP_CLASS = "tippy-tooltip";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var ROUND_ARROW_CLASS = "tippy-roundarrow"; // Selectors

var POPPER_SELECTOR = ".".concat(POPPER_CLASS);
var TOOLTIP_SELECTOR = ".".concat(TOOLTIP_CLASS);
var CONTENT_SELECTOR = ".".concat(CONTENT_CLASS);
var BACKDROP_SELECTOR = ".".concat(BACKDROP_CLASS);
var ARROW_SELECTOR = ".".concat(ARROW_CLASS);
var ROUND_ARROW_SELECTOR = ".".concat(ROUND_ARROW_CLASS);

var isUsingTouch = false;
function onDocumentTouch() {
  if (isUsingTouch) {
    return;
  }

  isUsingTouch = true;

  if (isIOS) {
    document.body.classList.add(IOS_CLASS);
  }

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
var lastMouseMoveTime = 0;
function onDocumentMouseMove() {
  var now = performance.now(); // Chrome 60+ is 1 mousemove per animation frame, use 20ms time difference

  if (now - lastMouseMoveTime < 20) {
    isUsingTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);

    if (!isIOS) {
      document.body.classList.remove(IOS_CLASS);
    }
  }

  lastMouseMoveTime = now;
}
function onWindowBlur() {
  var _document = document,
      activeElement = _document.activeElement;

  if (activeElement && activeElement.blur && activeElement._tippy) {
    activeElement.blur();
  }
}
/**
 * Adds the needed global event listeners
 */

function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouch, PASSIVE);
  window.addEventListener('blur', onWindowBlur);
}

var keys = Object.keys(defaultProps);
/**
 * Returns an object of optional props from data-tippy-* attributes
 */

function getDataAttributeOptions(reference) {
  return keys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-".concat(key)) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
}
/**
 * Polyfills the virtual reference (plain object) with Element.prototype props
 * Mutating because DOM elements are mutated, adds `_tippy` property
 */

function polyfillElementPrototypeProperties(virtualReference) {
  var polyfills = {
    isVirtual: true,
    attributes: virtualReference.attributes || {},
    contains: function contains() {},
    setAttribute: function setAttribute(key, value) {
      virtualReference.attributes[key] = value;
    },
    getAttribute: function getAttribute(key) {
      return virtualReference.attributes[key];
    },
    removeAttribute: function removeAttribute(key) {
      delete virtualReference.attributes[key];
    },
    hasAttribute: function hasAttribute(key) {
      return key in virtualReference.attributes;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    classList: {
      classNames: {},
      add: function add(key) {
        virtualReference.classList.classNames[key] = true;
      },
      remove: function remove(key) {
        delete virtualReference.classList.classNames[key];
      },
      contains: function contains(key) {
        return key in virtualReference.classList.classNames;
      }
    }
  };

  for (var key in polyfills) {
    virtualReference[key] = polyfills[key];
  }
}

/**
 * Determines if a value is a "bare" virtual element (before mutations done
 * by `polyfillElementPrototypeProperties()`). JSDOM elements show up as
 * [object Object], we can check if the value is "element-like" if it has
 * `addEventListener`
 */

function isBareVirtualElement(value) {
  return {}.toString.call(value) === '[object Object]' && !value.addEventListener;
}
/**
 * Determines if the value is a reference element
 */

function isReferenceElement(value) {
  return !!value._tippy && !matches.call(value, POPPER_SELECTOR);
}
/**
 * Safe .hasOwnProperty check, for prototype-less objects
 */

function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
/**
 * Returns an array of elements based on the value
 */

function getArrayOfElements(value) {
  if (isSingular(value)) {
    // TODO: VirtualReference is not compatible to type Element
    return [value];
  }

  if (value instanceof NodeList) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  try {
    return arrayFrom(document.querySelectorAll(value));
  } catch (e) {
    return [];
  }
}
/**
 * Returns a value at a given index depending on if it's an array or number
 */

function getValue(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? defaultValue : v;
  }

  return value;
}
/**
 * Debounce utility. To avoid bloating bundle size, we're only passing 1
 * argument here, a more generic function would pass all arguments. Only
 * `onMouseMove` uses this which takes the event object for now.
 */

function debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
/**
 * Prevents errors from being thrown while accessing nested modifier objects
 * in `popperOptions`
 */

function getModifier(obj, key) {
  return obj && obj.modifiers && obj.modifiers[key];
}
/**
 * Determines if an array or string includes a value
 */

function includes(a, b) {
  return a.indexOf(b) > -1;
}
/**
 * Determines if the value is a real element
 */

function isRealElement(value) {
  return value instanceof Element;
}
/**
 * Determines if the value is singular-like
 */

function isSingular(value) {
  return !!(value && hasOwnProperty(value, 'isVirtual')) || isRealElement(value);
}
/**
 * Firefox extensions don't allow setting .innerHTML directly, this will trick it
 */

function innerHTML() {
  return 'innerHTML';
}
/**
 * Evaluates a function if one, or returns the value
 */

function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(null, args) : value;
}
/**
 * Sets a popperInstance `flip` modifier's enabled state
 */

function setFlipModifierEnabled(modifiers, value) {
  modifiers.filter(function (m) {
    return m.name === 'flip';
  })[0].enabled = value;
}
/**
 * Determines if an element can receive focus
 * Always returns true for virtual objects
 */

function canReceiveFocus(element) {
  return isRealElement(element) ? matches.call(element, 'a[href],area[href],button,details,input,textarea,select,iframe,[tabindex]') && !element.hasAttribute('disabled') : true;
}
/**
 * Returns a new `div` element
 */

function div() {
  return document.createElement('div');
}
/**
 * Applies a transition duration to a list of elements
 */

function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = "".concat(value, "ms");
    }
  });
}
/**
 * Sets the visibility state to elements so they can begin to transition
 */

function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
/**
 * Evaluates the props object by merging data attributes and
 * disabling conflicting options where necessary
 */

function evaluateProps(reference, props) {
  var out = _extends({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeOptions(reference));

  if (out.arrow || isUCBrowser) {
    out.animateFill = false;
  }

  return out;
}
/**
 * Validates an object of options with the valid default props object
 */

function validateOptions(options, defaultProps) {
  Object.keys(options).forEach(function (option) {
    if (!hasOwnProperty(defaultProps, option)) {
      throw new Error("[tippy]: `".concat(option, "` is not a valid option"));
    }
  });
}

/**
 * Sets the innerHTML of an element
 */

function setInnerHTML(element, html) {
  element[innerHTML()] = isRealElement(html) ? html[innerHTML()] : html;
}
/**
 * Sets the content of a tooltip
 */

function setContent(contentEl, props) {
  if (isRealElement(props.content)) {
    setInnerHTML(contentEl, '');
    contentEl.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    var key = props.allowHTML ? 'innerHTML' : 'textContent';
    contentEl[key] = props.content;
  }
}
/**
 * Returns the child elements of a popper element
 */

function getChildren(popper) {
  return {
    tooltip: popper.querySelector(TOOLTIP_SELECTOR),
    backdrop: popper.querySelector(BACKDROP_SELECTOR),
    content: popper.querySelector(CONTENT_SELECTOR),
    arrow: popper.querySelector(ARROW_SELECTOR) || popper.querySelector(ROUND_ARROW_SELECTOR)
  };
}
/**
 * Adds `data-inertia` attribute
 */

function addInertia(tooltip) {
  tooltip.setAttribute('data-inertia', '');
}
/**
 * Removes `data-inertia` attribute
 */

function removeInertia(tooltip) {
  tooltip.removeAttribute('data-inertia');
}
/**
 * Creates an arrow element and returns it
 */

function createArrowElement(arrowType) {
  var arrow = div();

  if (arrowType === 'round') {
    arrow.className = ROUND_ARROW_CLASS;
    setInnerHTML(arrow, '<svg viewBox="0 0 18 7" xmlns="http://www.w3.org/2000/svg"><path d="M0 7s2.021-.015 5.253-4.218C6.584 1.051 7.797.007 9 0c1.203-.007 2.416 1.035 3.761 2.782C16.012 7.005 18 7 18 7H0z"/></svg>');
  } else {
    arrow.className = ARROW_CLASS;
  }

  return arrow;
}
/**
 * Creates a backdrop element and returns it
 */

function createBackdropElement() {
  var backdrop = div();
  backdrop.className = BACKDROP_CLASS;
  backdrop.setAttribute('data-state', 'hidden');
  return backdrop;
}
/**
 * Adds interactive-related attributes
 */

function addInteractive(popper, tooltip) {
  popper.setAttribute('tabindex', '-1');
  tooltip.setAttribute('data-interactive', '');
}
/**
 * Removes interactive-related attributes
 */

function removeInteractive(popper, tooltip) {
  popper.removeAttribute('tabindex');
  tooltip.removeAttribute('data-interactive');
}
/**
 * Add/remove transitionend listener from tooltip
 */

function updateTransitionEndListener(tooltip, action, listener) {
  // UC Browser hasn't adopted the `transitionend` event despite supporting
  // unprefixed transitions...
  var eventName = isUCBrowser && document.body.style.webkitTransition !== undefined ? 'webkitTransitionEnd' : 'transitionend';
  tooltip[action + 'EventListener'](eventName, listener);
}
/**
 * Returns the popper's placement, ignoring shifting (top-start, etc)
 */

function getBasicPlacement(popper) {
  var fullPlacement = popper.getAttribute(PLACEMENT_ATTRIBUTE);
  return fullPlacement ? fullPlacement.split('-')[0] : '';
}
/**
 * Triggers reflow
 */

function reflow(popper) {
  void popper.offsetHeight;
}
/**
 * Adds/removes theme from tooltip's classList
 */

function updateTheme(tooltip, action, theme) {
  theme.split(' ').forEach(function (themeName) {
    tooltip.classList[action](themeName + '-theme');
  });
}
/**
 * Constructs the popper element and returns it
 */

function createPopperElement(id, props) {
  var popper = div();
  popper.className = POPPER_CLASS;
  popper.id = "tippy-".concat(id);
  popper.style.zIndex = '' + props.zIndex;
  popper.style.position = 'absolute';
  popper.style.top = '0';
  popper.style.left = '0';

  if (props.role) {
    popper.setAttribute('role', props.role);
  }

  var tooltip = div();
  tooltip.className = TOOLTIP_CLASS;
  tooltip.style.maxWidth = props.maxWidth + (typeof props.maxWidth === 'number' ? 'px' : '');
  tooltip.setAttribute('data-size', props.size);
  tooltip.setAttribute('data-animation', props.animation);
  tooltip.setAttribute('data-state', 'hidden');
  updateTheme(tooltip, 'add', props.theme);
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');

  if (props.interactive) {
    addInteractive(popper, tooltip);
  }

  if (props.arrow) {
    tooltip.appendChild(createArrowElement(props.arrowType));
  }

  if (props.animateFill) {
    tooltip.appendChild(createBackdropElement());
    tooltip.setAttribute('data-animatefill', '');
  }

  if (props.inertia) {
    addInertia(tooltip);
  }

  setContent(content, props);
  tooltip.appendChild(content);
  popper.appendChild(tooltip);
  return popper;
}
/**
 * Updates the popper element based on the new props
 */

function updatePopperElement(popper, prevProps, nextProps) {
  var _getChildren = getChildren(popper),
      tooltip = _getChildren.tooltip,
      content = _getChildren.content,
      backdrop = _getChildren.backdrop,
      arrow = _getChildren.arrow;

  popper.style.zIndex = '' + nextProps.zIndex;
  tooltip.setAttribute('data-size', nextProps.size);
  tooltip.setAttribute('data-animation', nextProps.animation);
  tooltip.style.maxWidth = nextProps.maxWidth + (typeof nextProps.maxWidth === 'number' ? 'px' : '');

  if (nextProps.role) {
    popper.setAttribute('role', nextProps.role);
  } else {
    popper.removeAttribute('role');
  }

  if (prevProps.content !== nextProps.content) {
    setContent(content, nextProps);
  } // animateFill


  if (!prevProps.animateFill && nextProps.animateFill) {
    tooltip.appendChild(createBackdropElement());
    tooltip.setAttribute('data-animatefill', '');
  } else if (prevProps.animateFill && !nextProps.animateFill) {
    tooltip.removeChild(backdrop);
    tooltip.removeAttribute('data-animatefill');
  } // arrow


  if (!prevProps.arrow && nextProps.arrow) {
    tooltip.appendChild(createArrowElement(nextProps.arrowType));
  } else if (prevProps.arrow && !nextProps.arrow) {
    tooltip.removeChild(arrow);
  } // arrowType


  if (prevProps.arrow && nextProps.arrow && prevProps.arrowType !== nextProps.arrowType) {
    tooltip.replaceChild(createArrowElement(nextProps.arrowType), arrow);
  } // interactive


  if (!prevProps.interactive && nextProps.interactive) {
    addInteractive(popper, tooltip);
  } else if (prevProps.interactive && !nextProps.interactive) {
    removeInteractive(popper, tooltip);
  } // inertia


  if (!prevProps.inertia && nextProps.inertia) {
    addInertia(tooltip);
  } else if (prevProps.inertia && !nextProps.inertia) {
    removeInertia(tooltip);
  } // theme


  if (prevProps.theme !== nextProps.theme) {
    updateTheme(tooltip, 'remove', prevProps.theme);
    updateTheme(tooltip, 'add', nextProps.theme);
  }
}
/**
 * Hides all visible poppers on the document
 */

function hideAll() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      excludedReferenceOrInstance = _ref.exclude,
      duration = _ref.duration;

  arrayFrom(document.querySelectorAll(POPPER_SELECTOR)).forEach(function (popper) {
    var instance = popper._tippy;

    if (instance) {
      var isExcluded = false;

      if (excludedReferenceOrInstance) {
        isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : popper === excludedReferenceOrInstance.popper;
      }

      if (!isExcluded) {
        instance.hide(duration);
      }
    }
  });
}
/**
 * Determines if the mouse cursor is outside of the popper's interactive border
 * region
 */

function isCursorOutsideInteractiveBorder(popperPlacement, popperRect, event, props) {
  if (!popperPlacement) {
    return true;
  }

  var x = event.clientX,
      y = event.clientY;
  var interactiveBorder = props.interactiveBorder,
      distance = props.distance;
  var exceedsTop = popperRect.top - y > (popperPlacement === 'top' ? interactiveBorder + distance : interactiveBorder);
  var exceedsBottom = y - popperRect.bottom > (popperPlacement === 'bottom' ? interactiveBorder + distance : interactiveBorder);
  var exceedsLeft = popperRect.left - x > (popperPlacement === 'left' ? interactiveBorder + distance : interactiveBorder);
  var exceedsRight = x - popperRect.right > (popperPlacement === 'right' ? interactiveBorder + distance : interactiveBorder);
  return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
}
/**
 * Returns the distance offset, taking into account the default offset due to
 * the transform: translate() rule (10px) in CSS
 */

function getOffsetDistanceInPx(distance) {
  return -(distance - 10) + 'px';
}

var idCounter = 1; // Workaround for IE11's lack of new MouseEvent constructor

var mouseMoveListeners = [];
/**
 * Creates and returns a Tippy object. We're using a closure pattern instead of
 * a class so that the exposed object API is clean without private members
 * prefixed with `_`.
 */

function createTippy(reference, collectionProps) {
  var props = evaluateProps(reference, collectionProps); // If the reference shouldn't have multiple tippys, return null early

  if (!props.multiple && reference._tippy) {
    return null;
  }
  /* ======================= 🔒 Private members 🔒 ======================= */


  var lastTriggerEventType;
  var lastMouseMoveEvent;
  var showTimeoutId;
  var hideTimeoutId;
  var scheduleHideAnimationFrameId;
  var isScheduledToShow = false;
  var isBeingDestroyed = false;
  var previousPlacement;
  var wasVisibleDuringPreviousUpdate = false;
  var hasMountCallbackRun = false;
  var currentMountCallback;
  var currentTransitionEndListener;
  var listeners = [];
  var currentComputedPadding;
  var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
  /* ======================= 🔑 Public members 🔑 ======================= */

  var id = idCounter++;
  var popper = createPopperElement(id, props);
  var popperChildren = getChildren(popper);
  var popperInstance = null;
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: popper,
    popperChildren: popperChildren,
    popperInstance: popperInstance,
    props: props,
    state: state,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    set: set,
    setContent: setContent,
    show: show,
    hide: hide,
    enable: enable,
    disable: disable,
    destroy: destroy
    /* ==================== Initial instance mutations =================== */

  };
  reference._tippy = instance;
  popper._tippy = instance;
  addTriggersToReference();

  if (!props.lazy) {
    createPopperInstance();
  }

  if (props.showOnInit) {
    scheduleShow();
  } // Ensure the event listeners target can receive focus


  if (props.a11y && !props.target && !canReceiveFocus(getEventListenersTarget())) {
    getEventListenersTarget().setAttribute('tabindex', '0');
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function (event) {
    if (instance.props.interactive && instance.state.isVisible && lastTriggerEventType === 'mouseenter') {
      // We don't want props.onTrigger() to be called here, since the `event`
      // object is not related to the reference element
      scheduleShow(event, true);
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && lastTriggerEventType === 'mouseenter') {
      document.addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance;
  /* ======================= 🔒 Private methods 🔒 ======================= */

  /**
   * Removes the follow cursor listener
   */

  function removeFollowCursorListener() {
    document.removeEventListener('mousemove', positionVirtualReferenceNearCursor);
  }
  /**
   * Cleans up interactive mouse listeners
   */


  function cleanupInteractiveMouseListeners() {
    document.body.removeEventListener('mouseleave', scheduleHide);
    document.removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }
  /**
   * Returns correct target used for event listeners
   */


  function getEventListenersTarget() {
    return instance.props.triggerTarget || reference;
  }
  /**
   * Adds the document click event listener for the instance
   */


  function addDocumentClickListener() {
    document.addEventListener('click', onDocumentClick, true);
  }
  /**
   * Removes the document click event listener for the instance
   */


  function removeDocumentClickListener() {
    document.removeEventListener('click', onDocumentClick, true);
  }
  /**
   * Returns transitionable inner elements used in show/hide methods
   */


  function getTransitionableElements() {
    return [instance.popperChildren.tooltip, instance.popperChildren.backdrop, instance.popperChildren.content];
  }
  /**
   * Determines if the instance is in `followCursor` mode.
   * NOTE: in v5, touch devices will use `initial` behavior no matter the value.
   */


  function getIsInLooseFollowCursorMode() {
    var followCursor = instance.props.followCursor;
    return followCursor && lastTriggerEventType !== 'focus' || isUsingTouch && followCursor === 'initial';
  }
  /**
   * Updates the tooltip's position on each animation frame
   */


  function makeSticky() {
    setTransitionDuration([popper], isIE ? 0 : instance.props.updateDuration);
    var prevRefRect = reference.getBoundingClientRect();

    function updatePosition() {
      var currentRefRect = reference.getBoundingClientRect(); // Only schedule an update if the reference rect has changed

      if (prevRefRect.top !== currentRefRect.top || prevRefRect.right !== currentRefRect.right || prevRefRect.bottom !== currentRefRect.bottom || prevRefRect.left !== currentRefRect.left) {
        instance.popperInstance.scheduleUpdate();
      }

      prevRefRect = currentRefRect;

      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      }
    }

    updatePosition();
  }
  /**
   * Invokes a callback once the tooltip has fully transitioned out
   */


  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }
  /**
   * Invokes a callback once the tooltip has fully transitioned in
   */


  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }
  /**
   * Invokes a callback once the tooltip's CSS transition ends
   */


  function onTransitionEnd(duration, callback) {
    var tooltip = instance.popperChildren.tooltip;
    /**
     * Listener added as the `transitionend` handler
     */

    function listener(event) {
      if (event.target === tooltip) {
        updateTransitionEndListener(tooltip, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(tooltip, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(tooltip, 'add', listener);
    currentTransitionEndListener = listener;
  }
  /**
   * Adds an event listener to the reference and stores it in `listeners`
   */


  function on(eventType, handler) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    getEventListenersTarget().addEventListener(eventType, handler, options);
    listeners.push({
      eventType: eventType,
      handler: handler,
      options: options
    });
  }
  /**
   * Adds event listeners to the reference based on the `trigger` prop
   */


  function addTriggersToReference() {
    if (instance.props.touchHold && !instance.props.target) {
      on('touchstart', onTrigger, PASSIVE);
      on('touchend', onMouseLeave, PASSIVE);
    }

    instance.props.trigger.trim().split(' ').forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      } // Non-delegates


      if (!instance.props.target) {
        on(eventType, onTrigger);

        switch (eventType) {
          case 'mouseenter':
            on('mouseleave', onMouseLeave);
            break;

          case 'focus':
            on(isIE ? 'focusout' : 'blur', onBlur);
            break;
        }
      } else {
        // Delegates
        switch (eventType) {
          case 'mouseenter':
            on('mouseover', onDelegateShow);
            on('mouseout', onDelegateHide);
            break;

          case 'focus':
            on('focusin', onDelegateShow);
            on('focusout', onDelegateHide);
            break;

          case 'click':
            on(eventType, onDelegateShow);
            break;
        }
      }
    });
  }
  /**
   * Removes event listeners from the reference
   */


  function removeTriggersFromReference() {
    listeners.forEach(function (_ref) {
      var eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      getEventListenersTarget().removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }
  /**
   * Positions the virtual reference near the cursor
   */


  function positionVirtualReferenceNearCursor(event) {
    var _lastMouseMoveEvent = lastMouseMoveEvent = event,
        x = _lastMouseMoveEvent.clientX,
        y = _lastMouseMoveEvent.clientY; // Gets set once popperInstance `onCreate` has been called


    if (!currentComputedPadding) {
      return;
    } // If the instance is interactive, avoid updating the position unless it's
    // over the reference element


    var isCursorOverReference = closestCallback(event.target, function (el) {
      return el === reference;
    });
    var rect = reference.getBoundingClientRect();
    var followCursor = instance.props.followCursor;
    var isHorizontal = followCursor === 'horizontal';
    var isVertical = followCursor === 'vertical'; // The virtual reference needs some size to prevent itself from overflowing

    var isVerticalPlacement = includes(['top', 'bottom'], getBasicPlacement(popper));
    var fullPlacement = popper.getAttribute(PLACEMENT_ATTRIBUTE);
    var isVariation = fullPlacement ? !!fullPlacement.split('-')[1] : false;
    var size = isVerticalPlacement ? popper.offsetWidth : popper.offsetHeight;
    var halfSize = size / 2;
    var verticalIncrease = isVerticalPlacement ? 0 : isVariation ? size : halfSize;
    var horizontalIncrease = isVerticalPlacement ? isVariation ? size : halfSize : 0;

    if (isCursorOverReference || !instance.props.interactive) {
      instance.popperInstance.reference = _extends({}, instance.popperInstance.reference, {
        // This will exist in next Popper.js feature release to fix #532
        // @ts-ignore
        referenceNode: reference,
        // These `client` values don't get used by Popper.js if they are 0
        clientWidth: 0,
        clientHeight: 0,
        getBoundingClientRect: function getBoundingClientRect() {
          return {
            width: isVerticalPlacement ? size : 0,
            height: isVerticalPlacement ? 0 : size,
            top: (isHorizontal ? rect.top : y) - verticalIncrease,
            bottom: (isHorizontal ? rect.bottom : y) + verticalIncrease,
            left: (isVertical ? rect.left : x) - horizontalIncrease,
            right: (isVertical ? rect.right : x) + horizontalIncrease
          };
        }
      });
      instance.popperInstance.update();
    }

    if (followCursor === 'initial' && instance.state.isVisible) {
      removeFollowCursorListener();
    }
  }
  /**
   * Creates the tippy instance for a delegate when it's been triggered
   */


  function createDelegateChildTippy(event) {
    if (event) {
      var targetEl = closest(event.target, instance.props.target);

      if (targetEl && !targetEl._tippy) {
        createTippy(targetEl, _extends({}, instance.props, {
          content: invokeWithArgsOrReturn(collectionProps.content, [targetEl]),
          appendTo: collectionProps.appendTo,
          target: '',
          showOnInit: true
        }));
      }
    }
  }
  /**
   * Event listener invoked upon trigger
   */


  function onTrigger(event) {
    if (!instance.state.isEnabled || isEventListenerStopped(event)) {
      return;
    }

    if (!instance.state.isVisible) {
      lastTriggerEventType = event.type;

      if (event instanceof MouseEvent) {
        lastMouseMoveEvent = event; // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved

        mouseMoveListeners.forEach(function (listener) {
          return listener(event);
        });
      }
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && instance.props.hideOnClick !== false && instance.state.isVisible) {
      scheduleHide();
    } else {
      scheduleShow(event);
    }
  }
  /**
   * Event listener used for interactive tooltips to detect when they should
   * hide
   */


  function onMouseMove(event) {
    var isCursorOverPopper = closest(event.target, POPPER_SELECTOR) === popper;
    var isCursorOverReference = closestCallback(event.target, function (el) {
      return el === reference;
    });

    if (isCursorOverPopper || isCursorOverReference) {
      return;
    }

    if (isCursorOutsideInteractiveBorder(getBasicPlacement(popper), popper.getBoundingClientRect(), event, instance.props)) {
      cleanupInteractiveMouseListeners();
      scheduleHide();
    }
  }
  /**
   * Event listener invoked upon mouseleave
   */


  function onMouseLeave(event) {
    if (isEventListenerStopped(event)) {
      return;
    }

    if (instance.props.interactive) {
      document.body.addEventListener('mouseleave', scheduleHide);
      document.addEventListener('mousemove', debouncedOnMouseMove);
      mouseMoveListeners.push(debouncedOnMouseMove);
      return;
    }

    scheduleHide();
  }
  /**
   * Event listener invoked upon blur
   */


  function onBlur(event) {
    if (event.target !== getEventListenersTarget()) {
      return;
    }

    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide();
  }
  /**
   * Event listener invoked when a child target is triggered
   */


  function onDelegateShow(event) {
    if (closest(event.target, instance.props.target)) {
      scheduleShow(event);
    }
  }
  /**
   * Event listener invoked when a child target should hide
   */


  function onDelegateHide(event) {
    if (closest(event.target, instance.props.target)) {
      scheduleHide();
    }
  }
  /**
   * Determines if an event listener should stop further execution due to the
   * `touchHold` option
   */


  function isEventListenerStopped(event) {
    var supportsTouch = 'ontouchstart' in window;
    var isTouchEvent = includes(event.type, 'touch');
    var touchHold = instance.props.touchHold;
    return supportsTouch && isUsingTouch && touchHold && !isTouchEvent || isUsingTouch && !touchHold && isTouchEvent;
  }
  /**
   * Runs the mount callback
   */


  function runMountCallback() {
    if (!hasMountCallbackRun && currentMountCallback) {
      hasMountCallbackRun = true;
      reflow(popper);
      currentMountCallback();
    }
  }
  /**
   * Creates the popper instance for the instance
   */


  function createPopperInstance() {
    var popperOptions = instance.props.popperOptions;
    var _instance$popperChild = instance.popperChildren,
        tooltip = _instance$popperChild.tooltip,
        arrow = _instance$popperChild.arrow;
    var preventOverflowModifier = getModifier(popperOptions, 'preventOverflow');

    function applyMutations(data) {
      if (instance.props.flip && !instance.props.flipOnUpdate) {
        if (data.flipped) {
          instance.popperInstance.options.placement = data.placement;
        }

        setFlipModifierEnabled(instance.popperInstance.modifiers, false);
      } // Apply all of the popper's attributes to the tootip node as well.
      // Allows users to avoid using the .tippy-popper selector for themes.


      tooltip.setAttribute(PLACEMENT_ATTRIBUTE, data.placement);

      if (data.attributes[OUT_OF_BOUNDARIES_ATTRIBUTE] !== false) {
        tooltip.setAttribute(OUT_OF_BOUNDARIES_ATTRIBUTE, '');
      } else {
        tooltip.removeAttribute(OUT_OF_BOUNDARIES_ATTRIBUTE);
      } // Prevents a transition when changing placements (while tippy is visible)
      // for scroll/resize updates


      if (previousPlacement && previousPlacement !== data.placement && wasVisibleDuringPreviousUpdate) {
        tooltip.style.transition = 'none';
        requestAnimationFrame(function () {
          tooltip.style.transition = '';
        });
      }

      previousPlacement = data.placement;
      wasVisibleDuringPreviousUpdate = instance.state.isVisible;
      var basicPlacement = getBasicPlacement(popper);
      var styles = tooltip.style; // Account for the `distance` offset

      styles.top = styles.bottom = styles.left = styles.right = '';
      styles[basicPlacement] = getOffsetDistanceInPx(instance.props.distance);
      var padding = preventOverflowModifier && preventOverflowModifier.padding !== undefined ? preventOverflowModifier.padding : PADDING;
      var isPaddingNumber = typeof padding === 'number';

      var computedPadding = _extends({
        top: isPaddingNumber ? padding : padding.top,
        bottom: isPaddingNumber ? padding : padding.bottom,
        left: isPaddingNumber ? padding : padding.left,
        right: isPaddingNumber ? padding : padding.right
      }, !isPaddingNumber && padding);

      computedPadding[basicPlacement] = isPaddingNumber ? padding + instance.props.distance : (padding[basicPlacement] || 0) + instance.props.distance;
      instance.popperInstance.modifiers.filter(function (m) {
        return m.name === 'preventOverflow';
      })[0].padding = computedPadding;
      currentComputedPadding = computedPadding;
    }

    var config = _extends({
      eventsEnabled: false,
      placement: instance.props.placement
    }, popperOptions, {
      modifiers: _extends({}, popperOptions ? popperOptions.modifiers : {}, {
        preventOverflow: _extends({
          boundariesElement: instance.props.boundary,
          padding: PADDING
        }, preventOverflowModifier),
        arrow: _extends({
          element: arrow,
          enabled: !!arrow
        }, getModifier(popperOptions, 'arrow')),
        flip: _extends({
          enabled: instance.props.flip,
          // The tooltip is offset by 10px from the popper in CSS,
          // we need to account for its distance
          padding: instance.props.distance + PADDING,
          behavior: instance.props.flipBehavior
        }, getModifier(popperOptions, 'flip')),
        offset: _extends({
          offset: instance.props.offset
        }, getModifier(popperOptions, 'offset'))
      }),
      onCreate: function onCreate(data) {
        applyMutations(data);
        runMountCallback();

        if (popperOptions && popperOptions.onCreate) {
          popperOptions.onCreate(data);
        }
      },
      onUpdate: function onUpdate(data) {
        applyMutations(data);
        runMountCallback();

        if (popperOptions && popperOptions.onUpdate) {
          popperOptions.onUpdate(data);
        }
      }
    });

    instance.popperInstance = new __WEBPACK_IMPORTED_MODULE_0_popper_js__["a" /* default */](reference, popper, config);
  }
  /**
   * Mounts the tooltip to the DOM
   */


  function mount() {
    hasMountCallbackRun = false;
    var isInLooseFollowCursorMode = getIsInLooseFollowCursorMode();

    if (instance.popperInstance) {
      setFlipModifierEnabled(instance.popperInstance.modifiers, instance.props.flip);

      if (!isInLooseFollowCursorMode) {
        instance.popperInstance.reference = reference;
        instance.popperInstance.enableEventListeners();
      }

      instance.popperInstance.scheduleUpdate();
    } else {
      createPopperInstance();

      if (!isInLooseFollowCursorMode) {
        instance.popperInstance.enableEventListeners();
      }
    }

    var appendTo = instance.props.appendTo;
    var parentNode = appendTo === 'parent' ? reference.parentNode : invokeWithArgsOrReturn(appendTo, [reference]);

    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
      instance.props.onMount(instance);
      instance.state.isMounted = true;
    }
  }
  /**
   * Setup before show() is invoked (delays, etc.)
   */


  function scheduleShow(event, shouldAvoidCallingOnTrigger) {
    clearDelayTimeouts();

    if (instance.state.isVisible) {
      return;
    } // Is a delegate, create an instance for the child target


    if (instance.props.target) {
      return createDelegateChildTippy(event);
    }

    isScheduledToShow = true;

    if (event && !shouldAvoidCallingOnTrigger) {
      instance.props.onTrigger(instance, event);
    }

    if (instance.props.wait) {
      return instance.props.wait(instance, event);
    } // If the tooltip has a delay, we need to be listening to the mousemove as
    // soon as the trigger event is fired, so that it's in the correct position
    // upon mount.
    // Edge case: if the tooltip is still mounted, but then scheduleShow() is
    // called, it causes a jump.


    if (getIsInLooseFollowCursorMode() && !instance.state.isMounted) {
      if (!instance.popperInstance) {
        createPopperInstance();
      }

      document.addEventListener('mousemove', positionVirtualReferenceNearCursor);
    }

    addDocumentClickListener();
    var delay = getValue(instance.props.delay, 0, defaultProps.delay);

    if (delay) {
      showTimeoutId = setTimeout(function () {
        show();
      }, delay);
    } else {
      show();
    }
  }
  /**
   * Setup before hide() is invoked (delays, etc.)
   */


  function scheduleHide() {
    clearDelayTimeouts();

    if (!instance.state.isVisible) {
      removeFollowCursorListener();
      removeDocumentClickListener();
      return;
    }

    isScheduledToShow = false;
    var delay = getValue(instance.props.delay, 1, defaultProps.delay);

    if (delay) {
      hideTimeoutId = setTimeout(function () {
        if (instance.state.isVisible) {
          hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrameId = requestAnimationFrame(function () {
        hide();
      });
    }
  }
  /**
   * Listener to handle clicks on the document to determine if the
   * instance should hide
   */


  function onDocumentClick(event) {
    // Clicked on interactive popper
    if (instance.props.interactive && popper.contains(event.target)) {
      return;
    } // Clicked on the event listeners target


    if (getEventListenersTarget().contains(event.target)) {
      if (isUsingTouch) {
        return;
      }

      if (instance.state.isVisible && includes(instance.props.trigger, 'click')) {
        return;
      }
    }

    if (instance.props.hideOnClick === true) {
      clearDelayTimeouts();
      hide();
    }
  }
  /* ======================= 🔑 Public methods 🔑 ======================= */

  /**
   * Enables the instance to allow it to show or hide
   */


  function enable() {
    instance.state.isEnabled = true;
  }
  /**
   * Disables the instance to disallow it to show or hide
   */


  function disable() {
    instance.state.isEnabled = false;
  }
  /**
   * Clears pending timeouts related to the `delay` prop if any
   */


  function clearDelayTimeouts() {
    clearTimeout(showTimeoutId);
    clearTimeout(hideTimeoutId);
    cancelAnimationFrame(scheduleHideAnimationFrameId);
  }
  /**
   * Sets new props for the instance and redraws the tooltip
   */


  function set(options) {
    // Backwards-compatible after TypeScript change
    options = options || {};
    validateOptions(options, defaultProps);
    removeTriggersFromReference();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, _extends({}, instance.props, {}, options, {
      ignoreAttributes: true
    }));
    nextProps.ignoreAttributes = hasOwnProperty(options, 'ignoreAttributes') ? options.ignoreAttributes || false : prevProps.ignoreAttributes;
    instance.props = nextProps;
    addTriggersToReference();
    cleanupInteractiveMouseListeners();
    debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
    updatePopperElement(popper, prevProps, nextProps);
    instance.popperChildren = getChildren(popper);

    if (instance.popperInstance) {
      if (POPPER_INSTANCE_DEPENDENCIES.some(function (prop) {
        return hasOwnProperty(options, prop) && options[prop] !== prevProps[prop];
      })) {
        instance.popperInstance.destroy();
        createPopperInstance();

        if (instance.state.isVisible) {
          instance.popperInstance.enableEventListeners();
        }

        if (instance.props.followCursor && lastMouseMoveEvent) {
          positionVirtualReferenceNearCursor(lastMouseMoveEvent);
        }
      } else {
        instance.popperInstance.update();
      }
    }
  }
  /**
   * Shortcut for .set({ content: newContent })
   */


  function setContent(content) {
    set({
      content: content
    });
  }
  /**
   * Shows the tooltip
   */


  function show() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getValue(instance.props.duration, 0, defaultProps.duration[1]);

    if (instance.state.isDestroyed || !instance.state.isEnabled || isUsingTouch && !instance.props.touch) {
      return;
    } // Standardize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getEventListenersTarget().hasAttribute('disabled')) {
      return;
    }

    if (instance.props.onShow(instance) === false) {
      return;
    }

    addDocumentClickListener();
    popper.style.visibility = 'visible';
    instance.state.isVisible = true;

    if (instance.props.interactive) {
      getEventListenersTarget().classList.add(ACTIVE_CLASS);
    } // Prevent a transition if the popper is at the opposite placement


    var transitionableElements = getTransitionableElements();
    setTransitionDuration(transitionableElements.concat(popper), 0);

    currentMountCallback = function currentMountCallback() {
      if (!instance.state.isVisible) {
        return;
      }

      var isInLooseFollowCursorMode = getIsInLooseFollowCursorMode();

      if (isInLooseFollowCursorMode && lastMouseMoveEvent) {
        positionVirtualReferenceNearCursor(lastMouseMoveEvent);
      } else if (!isInLooseFollowCursorMode) {
        // Double update will apply correct mutations
        instance.popperInstance.update();
      }

      if (instance.popperChildren.backdrop) {
        instance.popperChildren.content.style.transitionDelay = Math.round(duration / 12) + 'ms';
      }

      if (instance.props.sticky) {
        makeSticky();
      }

      setTransitionDuration([popper], instance.props.updateDuration);
      setTransitionDuration(transitionableElements, duration);
      setVisibilityState(transitionableElements, 'visible');
      onTransitionedIn(duration, function () {
        if (instance.props.aria) {
          getEventListenersTarget().setAttribute("aria-".concat(instance.props.aria), popper.id);
        }

        instance.props.onShown(instance);
        instance.state.isShown = true;
      });
    };

    mount();
  }
  /**
   * Hides the tooltip
   */


  function hide() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getValue(instance.props.duration, 1, defaultProps.duration[1]);

    if (instance.state.isDestroyed || !instance.state.isEnabled && !isBeingDestroyed) {
      return;
    }

    if (instance.props.onHide(instance) === false && !isBeingDestroyed) {
      return;
    }

    removeDocumentClickListener();
    popper.style.visibility = 'hidden';
    instance.state.isVisible = false;
    instance.state.isShown = false;
    wasVisibleDuringPreviousUpdate = false;

    if (instance.props.interactive) {
      getEventListenersTarget().classList.remove(ACTIVE_CLASS);
    }

    var transitionableElements = getTransitionableElements();
    setTransitionDuration(transitionableElements, duration);
    setVisibilityState(transitionableElements, 'hidden');
    onTransitionedOut(duration, function () {
      if (!isScheduledToShow) {
        removeFollowCursorListener();
      }

      if (instance.props.aria) {
        getEventListenersTarget().removeAttribute("aria-".concat(instance.props.aria));
      }

      instance.popperInstance.disableEventListeners();
      instance.popperInstance.options.placement = instance.props.placement;
      popper.parentNode.removeChild(popper);
      instance.props.onHidden(instance);
      instance.state.isMounted = false;
    });
  }
  /**
   * Destroys the tooltip
   */


  function destroy(destroyTargetInstances) {
    if (instance.state.isDestroyed) {
      return;
    }

    isBeingDestroyed = true; // If the popper is currently mounted to the DOM, we want to ensure it gets
    // hidden and unmounted instantly upon destruction

    if (instance.state.isMounted) {
      hide(0);
    }

    removeTriggersFromReference();
    delete reference._tippy;
    var target = instance.props.target;

    if (target && destroyTargetInstances && isRealElement(reference)) {
      arrayFrom(reference.querySelectorAll(target)).forEach(function (child) {
        if (child._tippy) {
          child._tippy.destroy();
        }
      });
    }

    if (instance.popperInstance) {
      instance.popperInstance.destroy();
    }

    isBeingDestroyed = false;
    instance.state.isDestroyed = true;
  }
}

/**
 * Groups an array of instances by taking control of their props during
 * certain lifecycles.
 */
function group(instances) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? instances[0].props.delay : _ref$delay,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 0 : _ref$duration;

  var isAnyTippyOpen = false;
  instances.forEach(function (instance) {
    if (instance._originalProps) {
      instance.set(instance._originalProps);
    } else {
      instance._originalProps = _extends({}, instance.props);
    }
  });

  function setIsAnyTippyOpen(value) {
    isAnyTippyOpen = value;
    updateInstances();
  }

  function onShow(instance) {
    instance._originalProps.onShow(instance);

    instances.forEach(function (instance) {
      instance.set({
        duration: duration
      });

      if (instance.state.isVisible) {
        instance.hide();
      }
    });
    setIsAnyTippyOpen(true);
  }

  function onHide(instance) {
    instance._originalProps.onHide(instance);

    setIsAnyTippyOpen(false);
  }

  function onShown(instance) {
    instance._originalProps.onShown(instance);

    instance.set({
      duration: instance._originalProps.duration
    });
  }

  function updateInstances() {
    instances.forEach(function (instance) {
      instance.set({
        onShow: onShow,
        onShown: onShown,
        onHide: onHide,
        delay: isAnyTippyOpen ? [0, Array.isArray(delay) ? delay[1] : delay] : delay,
        duration: isAnyTippyOpen ? duration : instance._originalProps.duration
      });
    });
  }

  updateInstances();
}

var globalEventListenersBound = false;
/**
 * Exported module
 */

function tippy(targets, options) {
  validateOptions(options || {}, defaultProps);

  if (!globalEventListenersBound) {
    bindGlobalEventListeners();
    globalEventListenersBound = true;
  }

  var props = _extends({}, defaultProps, {}, options); // If they are specifying a virtual positioning reference, we need to polyfill
  // some native DOM props


  if (isBareVirtualElement(targets)) {
    polyfillElementPrototypeProperties(targets);
  }

  var instances = getArrayOfElements(targets).reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, props);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isSingular(targets) ? instances[0] : instances;
}
/**
 * Static props
 */


tippy.version = version;
tippy.defaults = defaultProps;
/**
 * Static methods
 */

tippy.setDefaults = function (partialDefaults) {
  Object.keys(partialDefaults).forEach(function (key) {
    // @ts-ignore
    defaultProps[key] = partialDefaults[key];
  });
};

tippy.hideAll = hideAll;
tippy.group = group;
/**
 * Auto-init tooltips for elements with a `data-tippy="..."` attribute
 */

function autoInit() {
  arrayFrom(document.querySelectorAll('[data-tippy]')).forEach(function (el) {
    var content = el.getAttribute('data-tippy');

    if (content) {
      tippy(el, {
        content: content
      });
    }
  });
}

if (isBrowser) {
  setTimeout(autoInit);
}

/**
 * Injects a string of CSS styles to a style node in <head>
 */

function injectCSS(css) {
  if (isBrowser) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.textContent = css;
    style.setAttribute('data-tippy-stylesheet', '');
    var head = document.head;
    var firstStyleOrLinkTag = head.querySelector('style,link');

    if (firstStyleOrLinkTag) {
      head.insertBefore(style, firstStyleOrLinkTag);
    } else {
      head.appendChild(style);
    }
  }
}

injectCSS(css);

/* harmony default export */ __webpack_exports__["a"] = (tippy);
//# sourceMappingURL=index.all.js.map


/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavigationWidgetTargets", function() { return NavigationWidgetTargets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return NavigationWidgetTargets; });
var NavigationWidgetTargets;
(function (NavigationWidgetTargets) {
    NavigationWidgetTargets["PREVIOUS_SCENE"] = "previous";
    NavigationWidgetTargets["NEXT_SCENE"] = "next";
})(NavigationWidgetTargets || (NavigationWidgetTargets = {}));



/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        CustomJsAction = __webpack_require__(190),
        CustomJsActionPropertiesView = __webpack_require__(1706),
        SalesforceCommerceConnect = __webpack_require__(206),
        SalesforceCommerceQuickViewAction = __webpack_require__(354),
        SalesforceCommerceQuickViewActionPropertiesView = __webpack_require__(1707),
        JsAction = __webpack_require__(494),
        JsActionPropertiesView = __webpack_require__(1709),
        LightboxAction = __webpack_require__(356),
        LightboxActionPropertiesView = __webpack_require__(1711),
        LinkAction = __webpack_require__(299),
        LinkActionPropertiesView = __webpack_require__(1713),
        LoggedInUserState = __webpack_require__(19),
        Preconditions = __webpack_require__(14),
        ProductActionPropertiesView = __webpack_require__(1715),
        ProductCustomJsAction = __webpack_require__(495),
        ProductLightboxAction = __webpack_require__(497),
        ProductLinkAction = __webpack_require__(498),
        ProductWidgetModel = __webpack_require__(511),
        SceneNavigationAction = __webpack_require__(191),
        SceneNavigationActionPropertiesView = __webpack_require__(1716);

    var STANDARD_ACTION_SELECT_OPTIONS = [{ label: "Open link", value: { type: LinkAction.TYPE } }, { label: "Run JavaScript code", value: { type: JsAction.TYPE } }, { label: "Open lightbox", value: { type: LightboxAction.TYPE } }, { label: "Navigate scenes", value: { type: SceneNavigationAction.TYPE } }];

    var EMAIL_ACTION_SELECT_OPTIONS = [{ label: "Open link", value: { type: LinkAction.TYPE } }];

    var actionTypeToPropertiesView = new Map(); // TODO: can this be merged into a descriptor like the WidgetTypes? Or only editor related?

    actionTypeToPropertiesView.set(LinkAction.TYPE, LinkActionPropertiesView);
    actionTypeToPropertiesView.set(JsAction.TYPE, JsActionPropertiesView);
    actionTypeToPropertiesView.set(CustomJsAction.TYPE, CustomJsActionPropertiesView);
    actionTypeToPropertiesView.set(LightboxAction.TYPE, LightboxActionPropertiesView);
    actionTypeToPropertiesView.set(SceneNavigationAction.TYPE, SceneNavigationActionPropertiesView);
    // The properties view for the ProductCustomJsAction is identical to the CustomJsAction, so we
    // re-use the view.
    actionTypeToPropertiesView.set(ProductCustomJsAction.TYPE, CustomJsActionPropertiesView);
    actionTypeToPropertiesView.set(ProductLightboxAction.TYPE, ProductActionPropertiesView);
    actionTypeToPropertiesView.set(ProductLinkAction.TYPE, ProductActionPropertiesView);
    actionTypeToPropertiesView.set(SalesforceCommerceQuickViewAction.TYPE, SalesforceCommerceQuickViewActionPropertiesView);

    var ActionHelper = {
        /**
         * Enhances and formats the Action Drop-down with additional metadata (e.g - icons).
         *
         * @param {Object} state Select2 object containing information about the current option.
         * @returns {String|Object} Either a JQuery object or a normal String
         */
        getFormattedOption: function getFormattedOption(state) {
            if (state.id && state.id === SalesforceCommerceQuickViewAction.TYPE) {
                return $("<span>", {
                    "class": "action",
                    html: [state.text, $("<img>", {
                        id: "salesforce-commerce-logo",
                        src: "images/integration/addons/salesforce-commerce/small_icon.png"
                    })]
                });
            }

            return state.text;
        },

        /**
         * Returns the list of available actions formatted for the actions drop down menu. Includes
         * custom JS, SalesforceCommerce and product widget actions, and takes hidden and disabled widgets
         * into account.
         *
         * @param {Boolean} onlyShowProductActions Only show the product actions.
         * @returns {Object} List of actions formatted for a drop down control.
         */
        getActionSelectOptionCollection: function getActionSelectOptionCollection(onlyShowProductActions, isEmailModeEnabled) {
            var ownedPrototypeActions = this._getOwnedPrototypeActions();
            var ACTIVE_ACTION_SELECT_OPTIONS = isEmailModeEnabled ? EMAIL_ACTION_SELECT_OPTIONS : STANDARD_ACTION_SELECT_OPTIONS;

            // If we only have to show product actions, return here without grouping them.
            if (onlyShowProductActions) {
                return ownedPrototypeActions.productPrototypeActions.map(this._toSelectOptionJson);
            }

            // If we don't have any extra actions, just return the standard actions without
            // grouping them.
            if (!SalesforceCommerceConnect.isQuickViewEnabled() && ownedPrototypeActions.customJsPrototypeActions.length === 0 && ownedPrototypeActions.productPrototypeActions.length === 0) {
                return ACTIVE_ACTION_SELECT_OPTIONS;
            }

            var selectOptionCollection = {
                "opt_labels": []
            };

            // Add the standard options as a group.
            this._addToSelectOptionCollection(selectOptionCollection, "Standard", ACTIVE_ACTION_SELECT_OPTIONS);

            // Add SalesforceCommerce to select options.
            if (!isEmailModeEnabled) {
                if (SalesforceCommerceConnect.isQuickViewEnabled()) {
                    var salesforceCommerceSelectOptions = [{
                        label: "SFCC QuickView",
                        value: {
                            type: SalesforceCommerceQuickViewAction.TYPE
                        }
                    }];

                    this._addToSelectOptionCollection(selectOptionCollection, "Add-ons", salesforceCommerceSelectOptions);
                }

                this._addToSelectOptionCollection(selectOptionCollection, "Custom Actions", ownedPrototypeActions.customJsPrototypeActions.map(this._toSelectOptionJson));
                this._addToSelectOptionCollection(selectOptionCollection, "Product Actions", ownedPrototypeActions.productPrototypeActions.map(this._toSelectOptionJson));
            }

            return selectOptionCollection;
        },

        /**
         * Returns the prototype action owned by the current company, split into custom JavaScript
         * prototype actions and product prototype actions.
         */
        _getOwnedPrototypeActions: function _getOwnedPrototypeActions() {
            var _this = this;

            var customJsPrototypeActions = LoggedInUserState.get("prototypeActionCollection").filter(function (prototypeAction) {
                return prototypeAction.get("action").get("type") === CustomJsAction.TYPE;
            });

            var productPrototypeActions = LoggedInUserState.get("prototypeActionCollection").filter(function (prototypeAction) {
                return _this._isVisibleProductWidget(prototypeAction.get("action").get("widgetId"));
            });

            return {
                customJsPrototypeActions: customJsPrototypeActions,
                productPrototypeActions: productPrototypeActions
            };
        },

        /**
         * Checks if the widget is a visible product widget.
         *
         * @param {String} prototypeWidgetId The ID of the widget to be verified.
         * @returns {Boolean}
         * @throws {Error} If more than one matching widget is found.
         */
        _isVisibleProductWidget: function _isVisibleProductWidget(prototypeWidgetId) {
            if (!_.isString(prototypeWidgetId)) {
                return false;
            }

            // Only owned widgets are product widgets.
            var matchingPrototypeWidgets = LoggedInUserState.get("prototypeWidgetCollection").filter(function (prototypeWidget) {
                return prototypeWidget.get("id") === prototypeWidgetId;
            });

            if (matchingPrototypeWidgets.length !== 1) {
                Preconditions.fail("Expected exactly one matching widget. Found " + matchingPrototypeWidgets.length + " matches.");
                return false;
            }

            var widget = matchingPrototypeWidgets[0].get("widget");

            if (!widget.get("visible")) {
                return false;
            }

            if (widget.get("type") !== ProductWidgetModel.TYPE) {
                return false;
            }

            return true;
        },

        /**
         * Returns the action as a JSON object for a Stickit drop down menu.
         */
        _toSelectOptionJson: function _toSelectOptionJson(prototypeAction) {
            var selectOptionJson = {
                label: prototypeAction.get("action").get("name"),
                value: {
                    type: prototypeAction.get("action").get("type"),
                    actionId: prototypeAction.get("id")
                }
            };

            return selectOptionJson;
        },

        /**
         * Add the group to the select option collection and add the select options to that group.
         *
         * @param {Object} collection The collection of select options to add to.
         * @param {String} groupLabel The label for the group header.
         * @param {Object} selectOptions Array of select options to add.
         */
        _addToSelectOptionCollection: function _addToSelectOptionCollection(collection, groupLabel, selectOptions) {
            if (selectOptions.length >= 1) {
                collection.opt_labels.push(groupLabel);
                collection[groupLabel] = selectOptions;
            }
        },

        /**
         * Returns the options for the given action. For normal actions this is just null, but for
         * owned  actions, information like parameter names are extracted from the settings.
         */
        getActionOptions: function getActionOptions(actionIdentifier) {
            // If the action doesn't have an actionId, it is not owned, and we don't have to look
            // any further to dig out the options.
            if (!_.isString(actionIdentifier.actionId)) {
                // Almost sure this is always null. (JAG)
                return actionIdentifier.options;
            }

            var prototypeAction = LoggedInUserState.get("prototypeActionCollection").findWhere({ "id": actionIdentifier.actionId });

            var options = {
                actionId: prototypeAction.get("id"),
                actionVersion: prototypeAction.get("version"),
                name: prototypeAction.get("action").get("name"),
                // Cloning the parameters because we don't want to mess with the default values.
                parameters: _.clone(prototypeAction.get("action").get("parameters"))
            };

            var actionType = prototypeAction.get("action").get("type");

            switch (actionType) {
                case CustomJsAction.TYPE:
                    options.code = prototypeAction.get("action").get("code");
                    break;

                case ProductCustomJsAction.TYPE:
                    options.code = prototypeAction.get("action").get("code");
                    break;

                case ProductLightboxAction.TYPE:
                    options.height = prototypeAction.get("action").get("height");
                    options.urlTemplate = prototypeAction.get("action").get("urlTemplate");
                    options.width = prototypeAction.get("action").get("width");
                    break;

                case ProductLinkAction.TYPE:
                    options.target = prototypeAction.get("action").get("target");
                    options.urlTemplate = prototypeAction.get("action").get("urlTemplate");
                    break;

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Action type passed '" + actionType + "' not recognized.");
                    break;
            }

            return options;
        },

        /**
         * Checks if the specified action type is enabled for the current company. Currently it's
         * only SalesforceCommerce actions that can be disabled.
         *
         * @param {String} type The type of the action, e.g. "LinkAction".
         * @returns {boolean}
         */
        isActionEnabledForCompany: function isActionEnabledForCompany(type) {
            if (type === SalesforceCommerceQuickViewAction.TYPE) {
                return SalesforceCommerceConnect.isQuickViewEnabled();
            }

            return true;
        },

        // Global Action Properties View Map.
        actionTypeToPropertiesViewMap: actionTypeToPropertiesView,

        convertStringToHtml: function convertStringToHtml(text) {
            var htmlText = text.trim();
            var template = document.createElement("template");
            template.innerHTML = htmlText;
            return template.content.firstChild;
        }
    };

    return ActionHelper;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="zmags-input-control">\n    <div class="parameter-inputs">\n        ';
 _.each(parameters, function (value, label) { ;
__p += '\n            <input type="text" value="' +
__e( value ) +
'" class="code full-width" data-label="' +
__e( label ) +
'" placeholder="' +
__e( label ) +
'">\n        ';
 }); ;
__p += '\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);

    /**
     * Regex to validate GUID.
     *
     * {@link http://stackoverflow.com/questions/7905929/how-to-test-valid-uuid-guid}
     * @type {RegExp}
     */
    var REGEX_GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    /**
     * Generate a GUID/UUID String.
     *
     * @class GUID
     * @author avi
     */
    return Class.extend({}, {

        /**
         * Generates a GUID/UUID string.
         *
         * @returns {String} The generated GUID.
         * @example af8a8416-6e18-a307-bd9c-f2c947bbb3aa
         * @link http://slavik.meltser.info/?p=142
         */
        random: function random() {
            return this._p8() + this._p8(true) + this._p8(true) + this._p8();
        },
        _p8: function _p8(s) {
            var p = (Math.random().toString(16) + "000000000").substr(2, 8);
            return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
        },


        /**
         * Validates the supplied GUID/UUID, returning true if valid, false otherwise.
         *
         * {@link https://www.ietf.org/rfc/rfc4122.txt}.
          * @example af8a8416-6e18-a307-bd9c-f2c947bbb3aa
         *
         * @param   {String} guid The uuid as a string to validate; ignores casing. A falsey value will return
         *                        false.
         * @returns {Boolean} True if valid, false otherwise.
         */
        validate: function validate(guid) {
            return REGEX_GUID.test(guid || "");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var FileDropManager = __webpack_require__(860);
    var ImageFileStorage = __webpack_require__(1724);
    var ImageModel = __webpack_require__(258);

    var ImageDropManager = FileDropManager.extend("ImageDropManager", {

        fileModel: ImageModel,

        /**
         * Additional fields needed for the `ImageModel` during upload.
         */
        fileModelAttributes: function fileModelAttributes() {
            var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "?";
            var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "?";
            return {
                name: name,
                // `size` needed for the computed `displaySize`.
                size: size,
                // Include `altText` based on the filename (without extension).
                altText: name.replace(/\.[^/.]+$/, "")
            };
        },

        fileStorage: ImageFileStorage

    });

    // Singleton
    return new ImageDropManager();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        has = _require.has,
        each = _require.each,
        extend = _require.extend;

    var Marionette = __webpack_require__(10);
    var Permissions = __webpack_require__(22);
    var Promise = __webpack_require__(21);
    var Time = __webpack_require__(121);

    var DRAGOVER = "dragover.FileDropManager";
    var DROP = "drop.FileDropManager";

    /**
     * Abstract class for dealing with "dropped" file uploads.
     *
     * A manager that can be attached to an element to help encapsulate drop events.
     *
     * @see ImageDropManager
     * @see CustomFontDropManager
     *
     * @class FileDropManager
     */
    return Marionette.Controller.extend({

        fileModel: null,

        /**
         * Subclass hook invoked at upload time for providing additional model attributes.
         *
         * @param {String} name The raw filename.
         * @param {Number} size The file size, in bytes.
         *
         * @return {Object} Object with addional fields.
         *
         * @see _createPlaceholder
         */
        // eslint-disable-next-line no-unused-vars
        fileModelAttributes: function fileModelAttributes(name, size) {
            return {};
        },


        fileStorage: null,

        addElement: function addElement(element) {
            element.on(DRAGOVER, this._dragoverHandler);
            element.on(DROP, this._dropHandler.bind(this));

            // For chainability
            return this;
        },
        removeElement: function removeElement(element) {
            element.off(DRAGOVER);
            element.off(DROP);
        },
        _dragoverHandler: function _dragoverHandler(event) {
            event.preventDefault();
        },


        /**
         * Handles the drop event, and starts the upload if
         * the event contains files.
         *
         * @param {Event} event
         * @private
         */
        _dropHandler: function _dropHandler(event) {
            var dataTransfer = event.originalEvent.dataTransfer;
            event.preventDefault();

            // Must have CREATE privilege...
            if (Permissions.Privileges.CREATE.can()) {
                // Dropped from desktop
                var descriptor = this.upload(dataTransfer);
                this.trigger("upload", descriptor);
            }
        },


        /**
         * Checks whether the dragged file comes from Creator (e.g.: is either a widget placeholder or an image from image library).
         *
         * @param {DataTransfer} dataTransfer from drag event.
         * @return {Boolean} True if the dragged file is either a placeholder or an image from Creator library.
         */
        isFileDraggedFromCreator: function isFileDraggedFromCreator(dataTransfer) {
            try {
                var data = JSON.parse(dataTransfer.getData("Text"));

                return Boolean(data) && has(data, "type"); // Because both placeholders and images have a type
            } catch (e) {
                // only on parse errors
                return false;
            }
        },


        /**
         * It normalizes an array of files from the data transfer object by adding zero-size files to the list.
         * This is needed because when dragging zipped files from the zip folder into Creator, the file size is set to zero
         * (as the file is not yet unzipped), causing the generation of empty models.
         *
         * File validation is propagated to the AbstractFileStorage class which handles the zero-size scenario,
         * along with all other file validations.
         *
         * @param {DataTransfer} dataTransfer from drag event.
         * @private
         *
         * @return {Files|Object[]} An Array of Files and/or Object. The object should have at least a name and size field
         *                          coming the the File API interface (other fields are not needed). It cannot be a File instance
         *                          because the File API constructor is not supported on all browsers.
         */
        _normalizeFilesFromDataTransfer: function _normalizeFilesFromDataTransfer(dataTransfer) {
            if (!dataTransfer) {
                return [];
            }

            var dataText = dataTransfer.getData && dataTransfer.getData("Text");
            var files = [];

            // Converting FileList type to array of files (and file-like objects). Mainly due because of IE11.
            each(dataTransfer.files, function (file) {
                files.push(file);
            });

            var modelId = dataText && dataText.split(" ")[1];

            // When dragging files from zip folders, you either get file with zero size or no files at all. Here we handle the latter by
            // creating a fake zero-size file, while the first case is just propagated to the File Storage validation.
            if (!modelId && files.length === 0 && !this.isFileDraggedFromCreator(dataTransfer)) {
                files.push({
                    size: 0,
                    name: "file"
                });
            }
            return files;
        },


        /**
         * An object describing the state of the current upload.
         *
         * @typedef {Object} UploadDescriptor
         * @property {Promise[]} promises - Array od promises to be triggered once upload is complete.
         * @property {Backbone.Model[]} models - Models to be created once upload is complete
         * @property {Object[]} descriptors - Object associating promises with models.
         */

        /**
         * Starts uploading of files and fires off a trigger including a
         * dropDescriptor with a promise which triggers once the file has been
         * uploaded.
         *
         * @param {File|Object[]} Array of file(s) from the drop event.
         *                       It also may contain objects respecting the File API interface, with at least name and size as mandatory fields.
         *                       This is due when handling edge case of dragging unzipped files directly from the zip folder, which may inject zero-size files.
         * @return {UploadDescriptor} An object holding information about the upload.
         * @public
         */
        upload: function upload(dataTransfer) {
            var _this = this;

            var promises = [];
            var descriptors = [];
            var models = [];

            this._normalizeFilesFromDataTransfer(dataTransfer).forEach(function (file) {
                var promise = new _this.fileStorage().storeFile(file);

                if (promise.state() !== Promise.State.REJECTED) {
                    var model = _this._createPlaceholder(promise, file.name, file.size);

                    promises.push(promise);
                    models.push(model);

                    descriptors.push({
                        model: model,
                        promise: promise
                    });
                }
            });

            var promise = Promise.all(promises);

            return {
                promise: promise,
                models: models,
                descriptors: descriptors
            };
        },


        /**
         * <p>Creates the "pseudo" model, that eventually gets replaced
         * by the real model.</p>
         *
         * <p>When the promise resolves (should pass in the model of the
         * newly uploaded file) it will remove the placeholder again and add
         * the real model.</p>
         *
         * @param {Promise} promise - Promise that will resolve passing in a
         *                            real model of the uploaded image.
         * @param {String} [name]   - The temporary name of the uploaded file.
         * @param {Number} [size]   - Size (in bytes) of the uploaded image.
         * @return {Backbone.Model} - Placeholder model.
         * @private
         */
        _createPlaceholder: function _createPlaceholder(promise, name, size) {
            var _this2 = this;

            name = name || "?";

            // By default, `createdAt`, `uploading` and `progress` are added to the model
            // at upload time. These are omitted once the upload is complete.
            var modelAttributes = extend({
                createdAt: Time.server(),
                progress: 0,
                uploading: true
            }, this.fileModelAttributes(name, size));

            // We make a "pseudo" model for the collection. The associated view is
            // required to be able to handle this type of model.
            var modelPlaceholder = new this.fileModel(modelAttributes);

            promise.progress(function (progress) {
                modelPlaceholder.set("progress", progress);
            });

            promise
            // A successful upload resolves the promise with the
            // newly create model.
            .then(function (model) {
                modelPlaceholder.set(model.omit("createdAt"));
                modelPlaceholder.unset("uploading");
                modelPlaceholder.unset("progress");

                _this2.trigger("file:uploaded", modelPlaceholder);
            })
            // If the promise fails, we will want to remove
            // the placeholder when the promise ends.
            .fail(function () {
                modelPlaceholder.set("uploadFailed", true);
                modelPlaceholder.trigger("upload:failed", modelPlaceholder);
            });

            return modelPlaceholder;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Class = __webpack_require__(26);
    var HttpStatusCodes = __webpack_require__(189);
    var ErrorHandler = __webpack_require__(119);
    var SyncManager = __webpack_require__(44);
    var Preconditions = __webpack_require__(14);
    var FileSyncManagerValidator = __webpack_require__(1726);
    var TextUtil = __webpack_require__(555);
    var Permissions = __webpack_require__(22);
    var Promise = __webpack_require__(21);
    var Storage = __webpack_require__(34);

    var TYPE = "upload";
    var filenameToFileSizeMap = {};

    /**
     * An abstract file storage service used to upload file in Creator. Currently used only for image upload
     *
     * @class AbstractFileStorage
     *
     * @see ImageFileStorage
     * @see CustomFontFileStorage
     */
    var AbstractFileStorage = Class.extend("AbstractFileStorage", {
        isSameFileBeingUploaded: function isSameFileBeingUploaded(file) {
            return filenameToFileSizeMap[file.name] === file.size;
        },


        /**
         * Stores the given file. <p>
         *
         * When the file is uploaded, the returned promise will resolve to the right model. <p>
         *
         * If the file is a duplicate of an existing file, it will be handle according to the file, byeither returning
         * existing model or throwing an error.
         *
         * @param   {File}    file The file to store; cannot be falsey.
         * @returns {Promise} A promise that will be resolved with the file model when the file has been stored or
         *                    rejected, for example because of an illegal file format.
         */
        storeFile: function storeFile(file) {
            var _this = this;

            var uploadImageOnC3 = function uploadImageOnC3() {
                var token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
                return Promise.deferred(function (deferred) {
                    fetch(modelInfo.url, {
                        body: file,
                        headers: {
                            Authorization: "Bearer " + token
                        },
                        method: "POST"
                    }).then(function (res) {
                        if (res.status === HttpStatusCodes.CONFLICT || res.status === HttpStatusCodes.OK) {
                            return res.json();
                        }
                    }).then(function (data) {
                        var imgData = data.imageDetails || data;
                        ErrorHandler.discard({ tag: TYPE + ":" }); // all such errors
                        var newImgData = Object.assign({}, imgData, { id: imgData.imageId });
                        return modelClass.findOrCreate(newImgData);
                    }).then(function (model) {
                        return deferred.resolve(model);
                    });
                });
            };

            var legacyUpload = function legacyUpload() {
                var fileData = new FormData();
                fileData.append("file", file);
                // We have to call ajax explicitly here, since the upload is two-fold: first the upload,
                // the the file resolving, which contexts will be listening for...
                return $.ajax({
                    type: "POST",
                    // The filename is included as a query parameter because of problems with resteasy: https://issues.jboss.org/browse/RESTEASY-390
                    // and https://issues.jboss.org/browse/RESTEASY-305 and https://jira.zmags.com/browse/MOS-2325.
                    url: modelInfo.url,
                    data: fileData,
                    xhr: function xhr() {
                        var myXhr = $.ajaxSettings.xhr();
                        if (myXhr.upload) {
                            myXhr.upload.addEventListener("progress", function (event) {
                                deferred.notify(event.loaded / event.total);
                            }, false);
                        }
                        return myXhr;
                    },

                    processData: false,
                    contentType: false
                }).then(function (data) {
                    // Make sure we discard any pending error if we make a successful upload
                    ErrorHandler.discard({ tag: TYPE + ":" }); // all such errors
                    return modelClass.findOrCreate(data);
                });
            };
            // Create a fake target based on the file to get a queue for, since we want the exact promise
            // returned so we get obtain the deferred to notify upload progress on...
            var target = SyncManager.target(file.name);

            var deferred = void 0; // initialised below, based on "promise"...
            var queue = SyncManager.queue(target);
            var modelInfo = this._modelInfo(file);

            var modelClass = modelInfo.modelClass;
            var supportedTypes = modelInfo.supportedTypes;

            var promise = queue.enqueue({ // request promise, not overall queue promise!
                method: TYPE,
                role: Permissions.Roles.CREATOR,

                fn: function fn() {
                    if (modelInfo.c3ApiUpload) {
                        return uploadImageOnC3();
                    } else return legacyUpload();
                },


                validate: function validate() {
                    return _this._validate(file, supportedTypes);
                },

                resultHandler: function resultHandler(model) {
                    return model;
                },

                errorHandler: function errorHandler(error, options) {
                    return _this._handleError(file, error, options, modelInfo);
                }
            });

            // Get the deferred backing the queue entry so we can notify against it...
            deferred = promise.entry.request.deferred();

            // Start upload!..
            queue.sync();

            // Make sure clean up before given our promise...
            return promise.always(function () {
                // Remove the file from the pending uploads...
                if (filenameToFileSizeMap[file.name] === file.size) {
                    delete filenameToFileSizeMap[file.name];
                }
            });
        },
        _validate: function _validate(file, supportedTypes) {
            var isSameFileBeingUploaded = this.isSameFileBeingUploaded(file);

            var status = FileSyncManagerValidator.validate(file, isSameFileBeingUploaded, supportedTypes);

            if (status !== HttpStatusCodes.OK) {
                return status;
            }

            filenameToFileSizeMap[file.name] = file.size;
        },


        // Error handler to catch unsupported file types and size
        _handleError: function _handleError(file, error, options, _ref) {
            var errorMessages = _ref.errorMessages,
                supportedTypes = _ref.supportedTypes;

            var fileName = "&quot;" + file.name + "&quot;";
            var hasErrorMessage = Boolean(errorMessages);

            switch (error.status) {
                case HttpStatusCodes.CONFLICT:
                    error.message = hasErrorMessage && errorMessages.CONFLICT || "the file has already been uploaded.";
                    error.action = ""; // Remove the "retry" option
                    break;

                case HttpStatusCodes.LENGTH_REQUIRED:
                    error.message = hasErrorMessage && errorMessages.LENGTH_REQUIRED || "the file provided is not valid.";
                    error.action = "community"; // Will show associated Community article
                    fileName = file.name;
                    break;

                case HttpStatusCodes.REQUEST_ENTITY_TOO_LARGE:
                    error.message = hasErrorMessage && errorMessages.REQUEST_ENTITY_TOO_LARGE || "the file size is too large. Please try again with a smaller file.";
                    break;

                case HttpStatusCodes.UNSUPPORTED_MEDIA_TYPE:
                    // unsupported media type
                    error.message = hasErrorMessage && errorMessages.REQUEST_ENTITY_TOO_LARGE || "the file type is not supported. Please try again with a supported type: " + TextUtil.list(supportedTypes, ", ", ", or ");
                    break;

                default:
                    break;
            }

            error.code = ErrorHandler.Codes.UPLOAD; // for community

            // Resolve error message placeholders
            ErrorHandler.inject(error, {
                method: TYPE,
                name: fileName
            });

            options.tag = TYPE + "." + error.status;
            options.closeDelay = 10000; // do not leave them hangin'

            return "alert";
        },


        // eslint-disable-next-line no-unused-vars
        _modelInfo: function _modelInfo(file) {
            Preconditions.abstractMethodError();
        }
    });

    return AbstractFileStorage;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var SpinnerView = __webpack_require__(244);

    /**
     * A more dimmed version of the default spinner, by courtesy of uncle Leifelt.
     *
     * @class SlimSpinnerView
     */
    return SpinnerView.extend("SlimSpinnerView", {

        options: {
            width: 2,
            opacity: 0,
            radius: 8,
            trail: 62
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EventDispatcher = __webpack_require__(54);
    var EditorEvents = __webpack_require__(17);

    /**
     * Custom behavior for tracking image model related changes.
     *
     * Intentionally not a `Marionette.Behavior` subclass due to lack of event support.
     *
     * Tracking related to the contained `ImageTagCollection` is handled by the `ImageTagTrackingBehavior`.
     *
     * @see ImageDetailsView
     * @see ImageThumbnailView
     * @see ImageTagTrackingBehavior
     *
     * @class ImageDetailsTrackingBehavior
     */
    return EventDispatcher.extend("ImageDetailsTrackingBehavior", {

        /**
         * Represents the tracking options, defined as an object map/dictionary where the key is
         * the property to observe and the value the `triggerOrigin`.
         *
         * @example
         * ```js
         * imageEditingTracking: {
         *      behaviorClass: ImageDetailsTrackingBehavior,
         *      tracking: {
         *          name: "EditImageNameInputFieldQuickview",
         *          altText: "EditImageAltTextInputFieldQuickview"
         *      }
         *  }
         * ```
         * @typedef {Object.<String, String>} TrackingOptions
         */

        /**
         * Constructor.
         *
         * @param {Object} options The options defined for `this` behavior.
         * @param {TrackingOptions} options.tracking The `TrackingOptions`.
         * @param {Backbone.View} view The associated view instance.
         */
        constructor: function constructor(_ref, view) {
            var tracking = _ref.tracking;

            this._tracking = tracking;
            this._view = view;
            this._eventCache = new Map();
        },


        /**
         * Invoked via the Marionette behavior lifecycle.
         */
        onShow: function onShow() {
            var _this = this;

            this._model = this._view.model;
            this.listenTo(this._model, "sync", this._modelSyncedHandler);

            Object.keys(this._tracking).forEach(function (property) {
                _this.listenTo(_this._model, "change:" + property, _this._modelChangeHandler);
            });
        },


        /**
         * Invoked via the Marionette behavior lifecycle.
         */
        onClose: function onClose() {
            this.stopListening();

            // In case we're closed before the "sync" event arrives - make sure to track any pending events.
            if (this._eventCache.size > 0) {
                this._trackEvents();
            }
        },


        /**
         * Invoked on model changes.
         *
         * @see #onShow
         *
         * @param {ImageModel} model The current `ImageModel`.
         * @param {*} value The value of the property that changed.
         * @param {Object} options Any options passed with the event.
         * @param {Object} options.stickitChange Stickit options containing the needed view reference, if stickit caused this change.
         * @param {Object} options.editBehaviorChange `EditBehavior` options containing the needed view reference, if `EditBehavior` caused this change.
         */
        _modelChangeHandler: function _modelChangeHandler(model, value, _ref2) {
            var _this2 = this;

            var stickitChange = _ref2.stickitChange,
                editBehaviorChange = _ref2.editBehaviorChange;
            var changed = model.changed;
            // Determine the view causing the change - based on either stickit or the EditBehavior

            var view = stickitChange && stickitChange.view || editBehaviorChange && editBehaviorChange.view;

            // Ensure that the change origins from the associated view - we may have more than one view modifying the same model instance.
            if (view === this._view) {
                Object.keys(changed).forEach(function (property) {
                    return _this2._eventCache.set(property, changed[property]);
                });
            }
        },
        _modelSyncedHandler: function _modelSyncedHandler() {
            this._trackEvents();
        },


        /**
         * Tracks all events currently in the "event cache", and clears the cache.
         */
        _trackEvents: function _trackEvents() {
            var _this3 = this;

            this._eventCache.forEach(function (value, property) {
                var triggerOrigin = _this3._tracking[property];
                var eventProperties = {
                    imageId: _this3._model.get("id"),
                    imageName: _this3._model.get("name"),
                    triggerOrigin: triggerOrigin,
                    updatedProperty: property,
                    updatedValue: value
                };

                EditorEvents.trigger(EditorEvents.constants.UPDATE_IMAGE, eventProperties);
            });

            this._eventCache.clear();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var ImprovedCompositeView = __webpack_require__(865);
    var ImageTagItemView = __webpack_require__(866);

    /**
    *
    * Tag composite view
    *
    * @see ImageTagCollection
    * @see ImageTagModel
    *
    * @class ImageTagCompositeView
    */
    return ImprovedCompositeView.extend({

        className: "tags-composite",

        itemViewContainer: ".tags-list",

        itemView: ImageTagItemView,

        options: {
            editable: false
        },

        _focusInputOnRender: false,

        $formGroup: null,

        $input: null,

        collectionEvents: {
            "sort": "_resortView"
        },

        itemViewOptions: function itemViewOptions() {
            return {
                editable: this.options.editable,
                triggerSource: this
            };
        },
        _tagInputKeydownHandler: function _tagInputKeydownHandler() {
            this.$formGroup.toggleClass("has-error", false);
        },
        _resortView: function _resortView() {
            this._focusInputOnRender = this.$input.is(":focus");
            this.render();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        ViewScope = __webpack_require__(171);

    /**
     * CompositeView that supports the view scope concept.
     *
     * @class ImprovedCompositeView
     */
    return Marionette.CompositeView.extend({

        renderItemView: function renderItemView(view, index) {
            view.parentView = this;
            ViewScope.register(this, view);
            Marionette.CollectionView.prototype.renderItemView.call(this, view, index);
        },

        appendHtml: function appendHtml(compositeView, itemView, index) {
            if (compositeView.isBuffering) {
                compositeView.elBuffer.appendChild(itemView.el);
                compositeView._bufferedChildren.push(itemView);
            } else {
                // If we've already rendered the main collection, just
                // append the new items directly into the container.
                var $container = this.getItemViewContainer(compositeView);

                var classFilter = itemView.className ? "." + itemView.className : "",
                    $children = $container.find(classFilter);

                if (index >= 0 && $children.length) {
                    if (index === 0) {
                        $children.eq(0).before(itemView.el);
                    } else {
                        $children.eq(index - 1).after(itemView.el);
                    }
                } else {
                    $container.append(itemView.el);
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var EditBehavior = __webpack_require__(106);
    var ImageTagModel = __webpack_require__(554);
    var KeyCode = __webpack_require__(88);
    var Marionette = __webpack_require__(10);
    var template = __webpack_require__(1732);

    var TAG_NAME_MAX_LENGTH = 80;

    return Marionette.ItemView.extend({

        template: template,

        tagName: "li",

        className: "image-tag-list-item",

        ui: {
            tagName: ".name"
        },

        events: {
            "keydown @ui.tagName": "_nameKeydownHandler",
            "blur @ui.tagName": "_nameBlurHandler",
            "click .delete": "_deleteClickHandler"
        },

        behaviors: {
            nameEditBehavior: {
                behaviorClass: EditBehavior,
                editFields: [{
                    input: ".name",
                    model: "name",
                    hideIcon: true
                }]
            }
        },

        bindings: {
            ".name": {
                observe: "name",
                updateMethod: "text",
                events: ["blur"]
            }
        },

        modelEvents: {
            "change:name": "_changeNameHandler"
        },

        options: {
            editable: false
        },

        templateHelpers: function templateHelpers() {
            return {
                editable: this.options.editable
            };
        },


        /**
         * This is really silly.
         * But the way this behaves is that if you change the tag it generally changes to Manual
         * (this includes Amazon Rekognition).
         * However, the ZMAGS_GROUP_ID type should not change even if you change it manually.
         * So we special case the ZMAGS_GROUP_ID.
         *
         * Also we uppercase the name if the type is ZMAGS_GROUP_ID
         */
        _changeNameHandler: function _changeNameHandler() {
            if (this.model.get("type") === ImageTagModel.Types.ZMAGS_GROUP_ID) {
                var upperName = this.model.get("name").toUpperCase();
                this.model.set("name", upperName);
            }
            this.model.set({
                type: this.model.get("type") === ImageTagModel.Types.ZMAGS_GROUP_ID ? ImageTagModel.Types.ZMAGS_GROUP_ID : ImageTagModel.Types.MANUAL,
                confidence: 100
            }, { silent: true });

            this._updateTagDataType();
        },


        /**
         * The way they do this, any types that are not specifically defined is Amazon Rekognition which is "auto".
         * @private
         */
        _updateTagDataType: function _updateTagDataType() {
            var type = "";
            switch (this.model.get("type")) {
                case ImageTagModel.Types.MANUAL:
                    type = "manual";
                    break;
                case ImageTagModel.Types.ZMAGS_GROUP_ID:
                    type = "ZMAGS_GROUP_ID";
                    break;
                default:
                    type = "auto";
            }
            this.$el.attr("data-type", type);
        },
        onBeforeRender: function onBeforeRender() {
            this._updateTagDataType();
        },
        _nameKeydownHandler: function _nameKeydownHandler(_ref) {
            var keyCode = _ref.keyCode;
            var ENTER = KeyCode.ENTER,
                RETURN = KeyCode.RETURN;


            if (keyCode === ENTER || keyCode === RETURN) {
                this.ui.tagName.blur();
            }
        },
        _nameBlurHandler: function _nameBlurHandler() {
            var name = this.ui.tagName.text();
            if (name.length === 0) {
                this._destroy();
            }
        },
        _deleteClickHandler: function _deleteClickHandler() {
            this._destroy();
        },
        _destroy: function _destroy() {
            var triggerSource = this.options.triggerSource;

            this.model.destroy({ triggerSource: triggerSource });
        }
    }, {
        TAG_NAME_MAX_LENGTH: TAG_NAME_MAX_LENGTH
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var TagCompositeView = __webpack_require__(864);
    var ImageTagItemView = __webpack_require__(866);
    var template = __webpack_require__(1735);

    /**
     * Renders a collection of tags.
     *
     * @see ImageTagCollection
     * @see ImageTagModel
     *
     * @class ImageTagCompositeView
     */
    return TagCompositeView.extend({

        template: template,

        itemViewContainer: ".inventory-tags-list",

        events: {
            "submit .inventory-tag-new-form": "_tagSubmitHandler",
            "keydown @ui.inventoryInput": "_tagInputKeydownHandler"
        },

        ui: {
            formGroup: ".inventory-form-group",
            tagInput: ".inventory-tag-input",
            tagInputMessage: ".inventory-tag-input-message"
        },

        collectionEvents: {
            "sort": "_resortView"
        },

        templateHelpers: function templateHelpers() {
            return {
                editable: this.options.editable,
                maxNameLength: ImageTagItemView.TAG_NAME_MAX_LENGTH
            };
        },
        _tagInputKeydownHandler: function _tagInputKeydownHandler() {
            this.$formGroup.toggleClass("has-error", false);
        },
        _tagSubmitHandler: function _tagSubmitHandler() {
            var newTagNameValue = this.$input.val().toUpperCase().trim();
            var validation = this._validateTag(newTagNameValue);

            this.$formGroup.toggleClass("has-error", !validation.valid);

            if (validation.valid) {
                var newTag = { name: newTagNameValue, type: "ZMAGS_GROUP_ID", confidence: 100 };
                this.collection.add(newTag, { triggerSource: this });
                this.options.tagCollection.add(newTag, { triggerSource: this });
                this.$input.val("");
            } else {
                this.$el.find(this.ui.tagInputMessage).text(validation.error);
            }

            return false;
        },
        _validateTag: function _validateTag(value) {
            if (value.length === 0) {
                return {
                    valid: false,
                    error: "Missing Inventory ID"
                };
            }

            /**
             * Checks to see if another tag of type ZMAGS_GROUP_ID already exists.
             */
            var existingType = this.collection.isEmpty();

            if (existingType && existingType.length) {
                return {
                    valid: false,
                    error: "Inventory ID already exists!"
                };
            }

            /**
             * Note that the application is case insensitive. You cannot have two inventory tags of same name but capitalized!
             * Also note that we are comparing only amongst in inventory tags.
             * You can have an inventory and non-inventory tag with the same name.
             * @type {boolean}
             */
            var existingName = this.collection.find(function (model) {
                return model.get("name").toUpperCase() === value.toUpperCase();
            });

            if (existingName) {
                return {
                    valid: false,
                    error: "Inventory ID already exists!"
                };
            }

            return {
                valid: true,
                error: null
            };
        },
        _resortView: function _resortView() {
            this._focusInputOnRender = this.$input.is(":focus");
            this.render();
        },
        onRender: function onRender() {
            this.$input = this.$el.find(this.ui.tagInput);
            this.$formGroup = this.$el.find(this.ui.formGroup);

            if (this._focusInputOnRender) {
                this.$el.find(this.ui.tagInput).focus();
                this._focusInputOnRender = false;
            }

            if (this.collection.length > 19) {
                this.$input.prop("disabled", true);
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var Preconditions = __webpack_require__(14);

    /**
     * Abstract query representation.
     *
     * @class ChunkingCollectionQuery
     * @see ChunkingCollection
     */
    var ChunkingCollectionQuery = Class.extend("ChunkingCollectionQuery", {

        /**
         * Returns the raw representation of *this* query, i.e. the object passed to the supporting endpoint.
         *
         * @return {Object} The raw query representation.
         */
        querify: function querify() {
            Preconditions.abstractMethodError();
        },


        /**
         * Returns a clone of *this* query.
         *
         * @return {ChunkingCollectionQuery} The cloned query.
         */
        clone: function clone() {
            Preconditions.abstractMethodError();
        }
    });

    return ChunkingCollectionQuery;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank;

    return {

        /**
         * Checks whether the given (mongoDB) id is considered valid.
         *
         * @param  {String}  id The hexadecimal string representing the id
         * @return {Boolean}    <tt>true</tt> if the id is vald, <tt>false</tt> otherwise.
         */
        isValid: function isValid(id) {
            return isBlank(id) || /^[0-9a-f]{24}$/.test(id);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        uniq = _require.uniq;

    var ImprovedView = __webpack_require__(6);

    var _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank,
        trim = _require2.trim;

    var template = __webpack_require__(1741);

    var FILTER_ATTRIBUTES = {
        project: "This Project",
        all: "All"
    };

    /**
     * View displaying the general sorting options and the search input.
     *
     * @class SortingPanel
     */
    return ImprovedView.extend({

        template: template,

        templateHelpers: function templateHelpers() {
            var _options = this.options,
                sourceEnum = _options.sourceEnum,
                project = _options.project,
                showSources = _options.showSources;

            return {
                sources: showSources && this._sorting && this._sorting.getSourceItems() || [],
                sorting: this._sortingOptions || [],
                filterAttributes: project && FILTER_ATTRIBUTES,
                isScene7: this._currentSource && sourceEnum && this._currentSource === sourceEnum.SCENE7
            };
        },


        className: "sorting-panel",

        events: {
            "click @ui.sourceOptions": "_sourceClickHandler",
            "click @ui.sortingElements": "_sortClickHandler",
            "keyup @ui.searchInput": "_searchKeyupHandler",
            "change @ui.filterSelect": "_filterSelectHandler"
        },

        ui: {
            sourceOptions: "[data-source]",
            sortingElements: "[data-sort]",
            searchInput: ".content-filtering",
            filterSelect: ".filter-attribute"
        },

        _sorting: null,

        _currentSource: null,

        _initialSourceType: null,

        /**
         * @type {ImageLibrarySorting}
         */
        _currentSorting: null,

        _searching: false,

        _searchPhrase: "",

        initialize: function initialize() {
            this._sorting = this.options.sorting;

            if (this._sorting) {
                this._currentSorting = this._sorting.getSelectedSorting();
                this._currentSource = this._sorting.getSelectedSource();
                this._sortingOptions = this._sorting.getSortingItems();

                if (this.options.initialSource) {
                    this._initialSourceType = this._sorting.getInitialSource(this.options.initialSource);
                }
            }
        },
        toggleFiltering: function toggleFiltering(state) {
            this.$el.toggleClass("project-context", state);
        },
        _sourceClickHandler: function _sourceClickHandler(event) {
            var clickedSource = event.target.getAttribute("data-source");
            if (clickedSource === this._currentSource) {
                return;
            }
            if (this._sorting) {
                this.setSource(this._sorting.lookupSourceName(clickedSource));
            }
        },
        _showActiveSource: function _showActiveSource(source) {
            this.ui.sourceOptions.removeClass("active");
            this.$el.find("[data-source='" + source.name + "']").addClass("active");
        },
        _showActiveSorting: function _showActiveSorting(sorting) {
            this.ui.sortingElements.removeClass("active");
            this.$el.find("[data-sort='" + sorting.name + "']").addClass("active");
        },
        getSource: function getSource() {
            return this._currentSource;
        },
        getSorting: function getSorting() {
            return this._currentSorting;
        },
        setSource: function setSource(source, options) {
            if (this._sorting) {
                this._currentSource = source;
                this._sorting.setSelectedSource(this._currentSource);
                this._currentSorting = this._sorting.getSelectedSorting();
                this._sorting.setSelectedSorting(this._currentSorting);
                this._sortingOptions = this._sorting.getSortingItems();
                this._updateSource(options);
            }
        },
        setSorting: function setSorting(sorting) {
            if (this._sorting) {
                this._showActiveSorting(sorting);
                this._sorting.setSelectedSource(this._currentSource);
                this._sorting.setSelectedSorting(sorting);
                this._currentSorting = this._sorting.getSelectedSorting();
            }

            if (this._searching) {
                this._triggerSearch(this._searchPhrase, true);
            } else {
                this.trigger("sort", sorting);
            }
        },
        _updateSource: function _updateSource(options) {
            this.trigger("source:changed", this._currentSource, options);
            this._resetSearchState();
            this.trigger("sort", this._currentSorting);
            this.render();
            this._showActiveSource(this._currentSource);
            this._showActiveSorting(this._currentSorting);
        },
        isSearching: function isSearching() {
            return this._searching;
        },
        disable: function disable(value) {
            this.$el.toggleClass("disabled", value === true || value === undefined);
        },
        onShow: function onShow() {
            if (this._initialSourceType && this._currentSource !== this._initialSourceType) {
                this.setSource(this._initialSourceType, { ignoreEditorEvent: true });
            } else {
                this.setSource(this._currentSource);
            }
        },
        _triggerSearch: function _triggerSearch(searchString) {
            var forceTrigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (searchString === this._searchPhrase && !forceTrigger) {
                return;
            }

            // If user clears the input field, reset to current sorting.
            if (isBlank(searchString)) {
                this._resetSearchState();
                this.setSorting(this._currentSorting);
                return;
            }

            this._searchPhrase = searchString;

            this._searching = true;

            // Split phrase into "tags", filtering out duplicates
            var uniqueTags = uniq(this._searchPhrase.split(/\s+/));

            // Signal that we're searching...
            this.trigger("search", uniqueTags, this._currentSorting, this._currentSource);
        },
        _filterSelectHandler: function _filterSelectHandler() {
            var selected = this.ui.filterSelect.find("option:selected");
            this.trigger("select", selected.text(), selected.val());
        },
        _searchKeyupHandler: function _searchKeyupHandler(event) {
            var searchString = trim(event.target.value);
            this._triggerSearch(searchString);
        },
        _sortClickHandler: function _sortClickHandler(event) {
            var sorting = event.target.getAttribute("data-sort");

            if (sorting === this._currentSorting.name && !this._searching) {
                return;
            }

            if (this._sorting) {
                this.setSorting(this._sorting.lookupSortingName(sorting, this._currentSource));
            }
        },
        _resetSearchState: function _resetSearchState() {
            this.ui.searchInput.val("");
            this._searching = false;
            this._searchPhrase = "";
        }
    }, {
        FILTER_ATTRIBUTES: FILTER_ATTRIBUTES
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        RangeInput = __webpack_require__(558),
        template = __webpack_require__(1744);

    return ImprovedView.extend({

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                showName: !this.options.hideName
            };
        },

        regions: {
            opacityRangeRegion: ".opacity-range-region"
        },

        onRender: function onRender() {
            this.opacityRangeRegion.show(new RangeInput({
                model: this.model,
                modelAttribute: "opacity",
                step: 10,
                minVal: 0,
                maxVal: 100,
                staticVal: 100,
                unit: "%",
                // Javascript polutes the calculation, hence the parseInt
                onGetConverter: function onGetConverter(x) {
                    return parseInt(x * 100, 10);
                },
                onSetConverter: function onSetConverter(x) {
                    return x / 100;
                }
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

// @ts-check

// @ts-ignore
!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    /**
     * @typedef ExperienceSize
     * @type {Object}
     * @property {Number} width
     * @property {Number} height
     */

    /**
     * Align all of the widgets to the left according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} leftPosition
     * @param {ExperienceSize} experienceSize
     */

    function alignLeft(widgets, leftPosition, experienceSize) {
        widgets.forEach(function (_ref) {
            var boundingBox = _ref.boundingBox,
                rect = _ref.rect,
                model = _ref.model;

            var originOffset = rect.left - boundingBox.left;
            var offsetFromScene = (originOffset + leftPosition) / experienceSize.width * 100;

            model.set("left", offsetFromScene, { render: true });
        });
    }

    /**
     * Align all of the widgets to the center(Horizontal axis) according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} centerPosition
     * @param {ExperienceSize} experienceSize
     */
    function alignCenter(widgets, centerPosition, experienceSize) {
        widgets.forEach(function (_ref2) {
            var boundingBox = _ref2.boundingBox,
                rect = _ref2.rect,
                model = _ref2.model;

            // eslint-disable-next-line no-mixed-operators
            var originOffset = rect.left - (boundingBox.left + (boundingBox.right - boundingBox.left) / 2);
            var offsetFromScene = (originOffset + centerPosition) / experienceSize.width * 100;

            model.set("left", offsetFromScene, { render: true });
        });
    }

    /**
     * Align all of the widgets to the right according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} rightPosition
     * @param {ExperienceSize} experienceSize
     */
    function alignRight(widgets, rightPosition, experienceSize) {
        widgets.forEach(function (_ref3) {
            var boundingBox = _ref3.boundingBox,
                rect = _ref3.rect,
                model = _ref3.model;

            var originOffset = boundingBox.right - rect.left;
            var offsetFromScene = (rightPosition - originOffset) / experienceSize.width * 100;

            model.set("left", offsetFromScene, { render: true });
        });
    }

    /**
     * Align all of the widgets to the top according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} topPostion
     * @param {ExperienceSize} experienceSize
     */
    function alignTop(widgets, topPosition, experienceSize) {
        widgets.forEach(function (_ref4) {
            var boundingBox = _ref4.boundingBox,
                rect = _ref4.rect,
                model = _ref4.model;

            var originOffset = Math.abs(boundingBox.top - rect.top);
            var offsetFromScene = (originOffset + topPosition) / experienceSize.height * 100;

            model.set("top", offsetFromScene, { render: true });
        });
    }

    /**
     * Align all of the widgets to the middle(Vertical Axis) according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} middlePosition
     * @param {ExperienceSize} experienceSize
     */
    function alignMiddle(widgets, middlePosition, experienceSize) {
        widgets.forEach(function (_ref5) {
            var boundingBox = _ref5.boundingBox,
                rect = _ref5.rect,
                model = _ref5.model;

            // eslint-disable-next-line no-mixed-operators
            var originOffset = rect.top - (boundingBox.top + (boundingBox.bottom - boundingBox.top) / 2);
            var offsetFromScene = (originOffset + middlePosition) / experienceSize.height * 100;

            model.set("top", offsetFromScene, { render: true });
        });
    }

    /**
     * Align all of the widgets to the bottom according to the scene or selection
     *
     * @param {Object[]} widgets
     * @param {Number} bottomPosition
     * @param {ExperienceSize} experienceSize
     */
    function alignBottom(widgets, bottomPosition, experienceSize) {
        widgets.forEach(function (_ref6) {
            var boundingBox = _ref6.boundingBox,
                rect = _ref6.rect,
                model = _ref6.model;

            var originOffset = boundingBox.bottom - rect.top;
            var offsetFromScene = (bottomPosition - originOffset) / experienceSize.height * 100;

            model.set("top", offsetFromScene, { render: true });
        });
    }

    return {
        alignBottom: alignBottom,
        alignMiddle: alignMiddle,
        alignTop: alignTop,
        alignRight: alignRight,
        alignCenter: alignCenter,
        alignLeft: alignLeft
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var ButtonIconModel = __webpack_require__(304);

    return Backbone.Collection.extend("ButtonIconCollection", {

        model: ButtonIconModel,

        byGroup: function byGroup(groupId) {
            return this.where({ groupId: groupId });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var ButtonIconModel = __webpack_require__(304);

    // from https://material.io/icons/data/grid.json
    return {
        groups: [{
            "length": 216,
            "data": {
                "id": "action",
                "name": "Action"
            }
        }, {
            "length": 4,
            "data": {
                "id": "alert",
                "name": "Alert"
            }
        }, {
            "length": 80,
            "data": {
                "id": "av",
                "name": "AV"
            }
        }, {
            "length": 50,
            "data": {
                "id": "communication",
                "name": "Communication"
            }
        }, {
            "length": 41,
            "data": {
                "id": "content",
                "name": "Content"
            }
        }, {
            "length": 52,
            "data": {
                "id": "device",
                "name": "Device"
            }
        }, {
            "length": 68,
            "data": {
                "id": "editor",
                "name": "Editor"
            }
        }, {
            "length": 14,
            "data": {
                "id": "file",
                "name": "File"
            }
        }, {
            "length": 48,
            "data": {
                "id": "hardware",
                "name": "Hardware"
            }
        }, {
            "length": 155,
            "data": {
                "id": "image",
                "name": "Image"
            }
        }, {
            "length": 68,
            "data": {
                "id": "maps",
                "name": "Maps"
            }
        }, {
            "length": 25,
            "data": {
                "id": "navigation",
                "name": "Navigation"
            }
        }, {
            "length": 53,
            "data": {
                "id": "notification",
                "name": "Notification"
            }
        }, {
            "length": 19,
            "data": {
                "id": "places",
                "name": "Places"
            }
        }, {
            "length": 30,
            "data": {
                "id": "social",
                "name": "Social"
            }
        }, {
            "length": 8,
            "data": {
                "id": "toggle",
                "name": "Toggle"
            }
        }],
        icons: [{
            "iconId": "3d_rotation",
            "name": "3d rotation",
            "groupId": "action",
            "ligature": "3d_rotation",
            "codepoint": "E84D"
        }, {
            "iconId": "accessibility",
            "name": "accessibility",
            "groupId": "action",
            "ligature": "accessibility",
            "codepoint": "E84E"
        }, {
            "iconId": "accessible",
            "name": "accessible",
            "groupId": "action",
            "ligature": "accessible",
            "codepoint": "E914"
        }, {
            "iconId": "account_balance",
            "name": "account balance",
            "groupId": "action",
            "ligature": "account_balance",
            "codepoint": "E84F"
        }, {
            "iconId": "account_balance_wallet",
            "name": "account balance wallet",
            "groupId": "action",
            "ligature": "account_balance_wallet",
            "codepoint": "E850"
        }, {
            "iconId": "account_box",
            "name": "account box",
            "groupId": "action",
            "ligature": "account_box",
            "codepoint": "E851"
        }, {
            "iconId": "account_circle",
            "name": "account circle",
            "groupId": "action",
            "ligature": "account_circle",
            "codepoint": "E853"
        }, {
            "iconId": "add_shopping_cart",
            "name": "add shopping cart",
            "groupId": "action",
            "ligature": "add_shopping_cart",
            "codepoint": "E854"
        }, {
            "iconId": "alarm",
            "name": "alarm",
            "groupId": "action",
            "ligature": "alarm",
            "codepoint": "E855"
        }, {
            "iconId": "alarm_add",
            "name": "alarm add",
            "groupId": "action",
            "ligature": "alarm_add",
            "codepoint": "E856"
        }, {
            "iconId": "alarm_off",
            "name": "alarm off",
            "groupId": "action",
            "ligature": "alarm_off",
            "codepoint": "E857"
        }, {
            "iconId": "alarm_on",
            "name": "alarm on",
            "groupId": "action",
            "ligature": "alarm_on",
            "codepoint": "E858"
        }, {
            "iconId": "all_out",
            "name": "all out",
            "groupId": "action",
            "ligature": "all_out",
            "codepoint": "E90B"
        }, {
            "iconId": "android",
            "name": "android",
            "groupId": "action",
            "ligature": "android",
            "codepoint": "E859"
        }, {
            "iconId": "announcement",
            "name": "announcement",
            "groupId": "action",
            "ligature": "announcement",
            "codepoint": "E85A"
        }, {
            "iconId": "aspect_ratio",
            "name": "aspect ratio",
            "groupId": "action",
            "ligature": "aspect_ratio",
            "codepoint": "E85B"
        }, {
            "iconId": "assessment",
            "name": "assessment",
            "groupId": "action",
            "ligature": "assessment",
            "codepoint": "E85C"
        }, {
            "iconId": "assignment",
            "name": "assignment",
            "groupId": "action",
            "ligature": "assignment",
            "codepoint": "E85D"
        }, {
            "iconId": "assignment_ind",
            "name": "assignment ind",
            "groupId": "action",
            "ligature": "assignment_ind",
            "codepoint": "E85E"
        }, {
            "iconId": "assignment_late",
            "name": "assignment late",
            "groupId": "action",
            "ligature": "assignment_late",
            "codepoint": "E85F"
        }, {
            "iconId": "assignment_return",
            "name": "assignment return",
            "groupId": "action",
            "ligature": "assignment_return",
            "codepoint": "E860"
        }, {
            "iconId": "assignment_returned",
            "name": "assignment returned",
            "groupId": "action",
            "ligature": "assignment_returned",
            "codepoint": "E861"
        }, {
            "iconId": "assignment_turned_in",
            "name": "assignment turned in",
            "groupId": "action",
            "ligature": "assignment_turned_in",
            "codepoint": "E862"
        }, {
            "iconId": "autorenew",
            "name": "autorenew",
            "groupId": "action",
            "ligature": "autorenew",
            "codepoint": "E863"
        }, {
            "iconId": "backup",
            "name": "backup",
            "groupId": "action",
            "ligature": "backup",
            "codepoint": "E864"
        }, {
            "iconId": "book",
            "name": "book",
            "groupId": "action",
            "ligature": "book",
            "codepoint": "E865"
        }, {
            "iconId": "bookmark",
            "name": "bookmark",
            "groupId": "action",
            "ligature": "bookmark",
            "codepoint": "E866"
        }, {
            "iconId": "bookmark_border",
            "name": "bookmark border",
            "groupId": "action",
            "ligature": "bookmark_border",
            "codepoint": "E867"
        }, {
            "iconId": "bug_report",
            "name": "bug report",
            "groupId": "action",
            "ligature": "bug_report",
            "codepoint": "E868"
        }, {
            "iconId": "build",
            "name": "build",
            "groupId": "action",
            "ligature": "build",
            "codepoint": "E869"
        }, {
            "iconId": "cached",
            "name": "cached",
            "groupId": "action",
            "ligature": "cached",
            "codepoint": "E86A"
        }, {
            "iconId": "camera_enhance",
            "name": "camera enhance",
            "groupId": "action",
            "ligature": "camera_enhance",
            "codepoint": "E8FC"
        }, {
            "iconId": "card_giftcard",
            "name": "card giftcard",
            "groupId": "action",
            "ligature": "card_giftcard",
            "codepoint": "E8F6"
        }, {
            "iconId": "card_membership",
            "name": "card membership",
            "groupId": "action",
            "ligature": "card_membership",
            "codepoint": "E8F7"
        }, {
            "iconId": "card_travel",
            "name": "card travel",
            "groupId": "action",
            "ligature": "card_travel",
            "codepoint": "E8F8"
        }, {
            "iconId": "change_history",
            "name": "change history",
            "groupId": "action",
            "ligature": "change_history",
            "codepoint": "E86B"
        }, {
            "iconId": "check_circle",
            "name": "check circle",
            "groupId": "action",
            "ligature": "check_circle",
            "codepoint": "E86C"
        }, {
            "iconId": "chrome_reader_mode",
            "name": "chrome reader mode",
            "groupId": "action",
            "ligature": "chrome_reader_mode",
            "codepoint": "E86D"
        }, {
            "iconId": "class",
            "name": "class",
            "groupId": "action",
            "ligature": "class",
            "codepoint": "E86E"
        }, {
            "iconId": "code",
            "name": "code",
            "groupId": "action",
            "ligature": "code",
            "codepoint": "E86F"
        }, {
            "iconId": "compare_arrows",
            "name": "compare arrows",
            "groupId": "action",
            "ligature": "compare_arrows",
            "codepoint": "E915"
        }, {
            "iconId": "copyright",
            "name": "copyright",
            "groupId": "action",
            "ligature": "copyright",
            "codepoint": "E90C"
        }, {
            "iconId": "credit_card",
            "name": "credit card",
            "groupId": "action",
            "ligature": "credit_card",
            "codepoint": "E870"
        }, {
            "iconId": "dashboard",
            "name": "dashboard",
            "groupId": "action",
            "ligature": "dashboard",
            "codepoint": "E871"
        }, {
            "iconId": "date_range",
            "name": "date range",
            "groupId": "action",
            "ligature": "date_range",
            "codepoint": "E916"
        }, {
            "iconId": "delete",
            "name": "delete",
            "groupId": "action",
            "ligature": "delete",
            "codepoint": "E872"
        }, {
            "iconId": "delete_forever",
            "name": "delete forever",
            "groupId": "action",
            "ligature": "delete_forever",
            "codepoint": "E92B"
        }, {
            "iconId": "description",
            "name": "description",
            "groupId": "action",
            "ligature": "description",
            "codepoint": "E873"
        }, {
            "iconId": "dns",
            "name": "dns",
            "groupId": "action",
            "ligature": "dns",
            "codepoint": "E875"
        }, {
            "iconId": "done",
            "name": "done",
            "groupId": "action",
            "ligature": "done",
            "codepoint": "E876"
        }, {
            "iconId": "done_all",
            "name": "done all",
            "groupId": "action",
            "ligature": "done_all",
            "codepoint": "E877"
        }, {
            "iconId": "donut_large",
            "name": "donut large",
            "groupId": "action",
            "ligature": "donut_large",
            "codepoint": "E917"
        }, {
            "iconId": "donut_small",
            "name": "donut small",
            "groupId": "action",
            "ligature": "donut_small",
            "codepoint": "E918"
        }, {
            "iconId": "eject",
            "name": "eject",
            "groupId": "action",
            "ligature": "eject",
            "codepoint": "E8FB"
        }, {
            "iconId": "euro_symbol",
            "name": "euro symbol",
            "groupId": "action",
            "ligature": "euro_symbol",
            "codepoint": "E926"
        }, {
            "iconId": "event",
            "name": "event",
            "groupId": "action",
            "ligature": "event",
            "codepoint": "E878"
        }, {
            "iconId": "event_seat",
            "name": "event seat",
            "groupId": "action",
            "ligature": "event_seat",
            "codepoint": "E903"
        }, {
            "iconId": "exit_to_app",
            "name": "exit to app",
            "groupId": "action",
            "ligature": "exit_to_app",
            "codepoint": "E879"
        }, {
            "iconId": "explore",
            "name": "explore",
            "groupId": "action",
            "ligature": "explore",
            "codepoint": "E87A"
        }, {
            "iconId": "extension",
            "name": "extension",
            "groupId": "action",
            "ligature": "extension",
            "codepoint": "E87B"
        }, {
            "iconId": "face",
            "name": "face",
            "groupId": "action",
            "ligature": "face",
            "codepoint": "E87C"
        }, {
            "iconId": "favorite",
            "name": "favorite",
            "groupId": "action",
            "ligature": "favorite",
            "codepoint": "E87D"
        }, {
            "iconId": "favorite_border",
            "name": "favorite border",
            "groupId": "action",
            "ligature": "favorite_border",
            "codepoint": "E87E"
        }, {
            "iconId": "feedback",
            "name": "feedback",
            "groupId": "action",
            "ligature": "feedback",
            "codepoint": "E87F"
        }, {
            "iconId": "find_in_page",
            "name": "find in page",
            "groupId": "action",
            "ligature": "find_in_page",
            "codepoint": "E880"
        }, {
            "iconId": "find_replace",
            "name": "find replace",
            "groupId": "action",
            "ligature": "find_replace",
            "codepoint": "E881"
        }, {
            "iconId": "fingerprint",
            "name": "fingerprint",
            "groupId": "action",
            "ligature": "fingerprint",
            "codepoint": "E90D"
        }, {
            "iconId": "flight_land",
            "name": "flight land",
            "groupId": "action",
            "ligature": "flight_land",
            "codepoint": "E904"
        }, {
            "iconId": "flight_takeoff",
            "name": "flight takeoff",
            "groupId": "action",
            "ligature": "flight_takeoff",
            "codepoint": "E905"
        }, {
            "iconId": "flip_to_back",
            "name": "flip to back",
            "groupId": "action",
            "ligature": "flip_to_back",
            "codepoint": "E882"
        }, {
            "iconId": "flip_to_front",
            "name": "flip to front",
            "groupId": "action",
            "ligature": "flip_to_front",
            "codepoint": "E883"
        }, {
            "iconId": "g_translate",
            "name": "g translate",
            "groupId": "action",
            "ligature": "g_translate",
            "codepoint": "E927"
        }, {
            "iconId": "gavel",
            "name": "gavel",
            "groupId": "action",
            "ligature": "gavel",
            "codepoint": "E90E"
        }, {
            "iconId": "get_app",
            "name": "get app",
            "groupId": "action",
            "ligature": "get_app",
            "codepoint": "E884"
        }, {
            "iconId": "gif",
            "name": "gif",
            "groupId": "action",
            "ligature": "gif",
            "codepoint": "E908"
        }, {
            "iconId": "grade",
            "name": "grade",
            "groupId": "action",
            "ligature": "grade",
            "codepoint": "E885"
        }, {
            "iconId": "group_work",
            "name": "group work",
            "groupId": "action",
            "ligature": "group_work",
            "codepoint": "E886"
        }, {
            "iconId": "help",
            "name": "help",
            "groupId": "action",
            "ligature": "help",
            "codepoint": "E887"
        }, {
            "iconId": "help_outline",
            "name": "help outline",
            "groupId": "action",
            "ligature": "help_outline",
            "codepoint": "E8FD"
        }, {
            "iconId": "highlight_off",
            "name": "highlight off",
            "groupId": "action",
            "ligature": "highlight_off",
            "codepoint": "E888"
        }, {
            "iconId": "history",
            "name": "history",
            "groupId": "action",
            "ligature": "history",
            "codepoint": "E889"
        }, {
            "iconId": "home",
            "name": "home",
            "groupId": "action",
            "ligature": "home",
            "codepoint": "E88A"
        }, {
            "iconId": "hourglass_empty",
            "name": "hourglass empty",
            "groupId": "action",
            "ligature": "hourglass_empty",
            "codepoint": "E88B"
        }, {
            "iconId": "hourglass_full",
            "name": "hourglass full",
            "groupId": "action",
            "ligature": "hourglass_full",
            "codepoint": "E88C"
        }, {
            "iconId": "http",
            "name": "http",
            "groupId": "action",
            "ligature": "http",
            "codepoint": "E902"
        }, {
            "iconId": "https",
            "name": "https",
            "groupId": "action",
            "ligature": "https",
            "codepoint": "E88D"
        }, {
            "iconId": "important_devices",
            "name": "important devices",
            "groupId": "action",
            "ligature": "important_devices",
            "codepoint": "E912"
        }, {
            "iconId": "info",
            "name": "info",
            "groupId": "action",
            "ligature": "info",
            "codepoint": "E88E"
        }, {
            "iconId": "info_outline",
            "name": "info outline",
            "groupId": "action",
            "ligature": "info_outline",
            "codepoint": "E88F"
        }, {
            "iconId": "input",
            "name": "input",
            "groupId": "action",
            "ligature": "input",
            "codepoint": "E890"
        }, {
            "iconId": "invert_colors",
            "name": "invert colors",
            "groupId": "action",
            "ligature": "invert_colors",
            "codepoint": "E891"
        }, {
            "iconId": "label",
            "name": "label",
            "groupId": "action",
            "ligature": "label",
            "codepoint": "E892"
        }, {
            "iconId": "label_outline",
            "name": "label outline",
            "groupId": "action",
            "ligature": "label_outline",
            "codepoint": "E893"
        }, {
            "iconId": "language",
            "name": "language",
            "groupId": "action",
            "ligature": "language",
            "codepoint": "E894"
        }, {
            "iconId": "launch",
            "name": "launch",
            "groupId": "action",
            "ligature": "launch",
            "codepoint": "E895"
        }, {
            "iconId": "lightbulb_outline",
            "name": "lightbulb outline",
            "groupId": "action",
            "ligature": "lightbulb_outline",
            "codepoint": "E90F"
        }, {
            "iconId": "line_style",
            "name": "line style",
            "groupId": "action",
            "ligature": "line_style",
            "codepoint": "E919"
        }, {
            "iconId": "line_weight",
            "name": "line weight",
            "groupId": "action",
            "ligature": "line_weight",
            "codepoint": "E91A"
        }, {
            "iconId": "list",
            "name": "list",
            "groupId": "action",
            "ligature": "list",
            "codepoint": "E896"
        }, {
            "iconId": "lock",
            "name": "lock",
            "groupId": "action",
            "ligature": "lock",
            "codepoint": "E897"
        }, {
            "iconId": "lock_open",
            "name": "lock open",
            "groupId": "action",
            "ligature": "lock_open",
            "codepoint": "E898"
        }, {
            "iconId": "lock_outline",
            "name": "lock outline",
            "groupId": "action",
            "ligature": "lock_outline",
            "codepoint": "E899"
        }, {
            "iconId": "loyalty",
            "name": "loyalty",
            "groupId": "action",
            "ligature": "loyalty",
            "codepoint": "E89A"
        }, {
            "iconId": "markunread_mailbox",
            "name": "markunread mailbox",
            "groupId": "action",
            "ligature": "markunread_mailbox",
            "codepoint": "E89B"
        }, {
            "iconId": "motorcycle",
            "name": "motorcycle",
            "groupId": "action",
            "ligature": "motorcycle",
            "codepoint": "E91B"
        }, {
            "iconId": "note_add",
            "name": "note add",
            "groupId": "action",
            "ligature": "note_add",
            "codepoint": "E89C"
        }, {
            "iconId": "offline_pin",
            "name": "offline pin",
            "groupId": "action",
            "ligature": "offline_pin",
            "codepoint": "E90A"
        }, {
            "iconId": "opacity",
            "name": "opacity",
            "groupId": "action",
            "ligature": "opacity",
            "codepoint": "E91C"
        }, {
            "iconId": "open_in_browser",
            "name": "open in browser",
            "groupId": "action",
            "ligature": "open_in_browser",
            "codepoint": "E89D"
        }, {
            "iconId": "open_in_new",
            "name": "open in new",
            "groupId": "action",
            "ligature": "open_in_new",
            "codepoint": "E89E"
        }, {
            "iconId": "open_with",
            "name": "open with",
            "groupId": "action",
            "ligature": "open_with",
            "codepoint": "E89F"
        }, {
            "iconId": "pageview",
            "name": "pageview",
            "groupId": "action",
            "ligature": "pageview",
            "codepoint": "E8A0"
        }, {
            "iconId": "pan_tool",
            "name": "pan tool",
            "groupId": "action",
            "ligature": "pan_tool",
            "codepoint": "E925"
        }, {
            "iconId": "payment",
            "name": "payment",
            "groupId": "action",
            "ligature": "payment",
            "codepoint": "E8A1"
        }, {
            "iconId": "perm_camera_mic",
            "name": "perm camera mic",
            "groupId": "action",
            "ligature": "perm_camera_mic",
            "codepoint": "E8A2"
        }, {
            "iconId": "perm_contact_calendar",
            "name": "perm contact calendar",
            "groupId": "action",
            "ligature": "perm_contact_calendar",
            "codepoint": "E8A3"
        }, {
            "iconId": "perm_data_setting",
            "name": "perm data setting",
            "groupId": "action",
            "ligature": "perm_data_setting",
            "codepoint": "E8A4"
        }, {
            "iconId": "perm_device_information",
            "name": "perm device information",
            "groupId": "action",
            "ligature": "perm_device_information",
            "codepoint": "E8A5"
        }, {
            "iconId": "perm_identity",
            "name": "perm identity",
            "groupId": "action",
            "ligature": "perm_identity",
            "codepoint": "E8A6"
        }, {
            "iconId": "perm_media",
            "name": "perm media",
            "groupId": "action",
            "ligature": "perm_media",
            "codepoint": "E8A7"
        }, {
            "iconId": "perm_phone_msg",
            "name": "perm phone msg",
            "groupId": "action",
            "ligature": "perm_phone_msg",
            "codepoint": "E8A8"
        }, {
            "iconId": "perm_scan_wifi",
            "name": "perm scan wifi",
            "groupId": "action",
            "ligature": "perm_scan_wifi",
            "codepoint": "E8A9"
        }, {
            "iconId": "pets",
            "name": "pets",
            "groupId": "action",
            "ligature": "pets",
            "codepoint": "E91D"
        }, {
            "iconId": "picture_in_picture",
            "name": "picture in picture",
            "groupId": "action",
            "ligature": "picture_in_picture",
            "codepoint": "E8AA"
        }, {
            "iconId": "picture_in_picture_alt",
            "name": "picture in picture alt",
            "groupId": "action",
            "ligature": "picture_in_picture_alt",
            "codepoint": "E911"
        }, {
            "iconId": "play_for_work",
            "name": "play for work",
            "groupId": "action",
            "ligature": "play_for_work",
            "codepoint": "E906"
        }, {
            "iconId": "polymer",
            "name": "polymer",
            "groupId": "action",
            "ligature": "polymer",
            "codepoint": "E8AB"
        }, {
            "iconId": "power_settings_new",
            "name": "power settings new",
            "groupId": "action",
            "ligature": "power_settings_new",
            "codepoint": "E8AC"
        }, {
            "iconId": "pregnant_woman",
            "name": "pregnant woman",
            "groupId": "action",
            "ligature": "pregnant_woman",
            "codepoint": "E91E"
        }, {
            "iconId": "print",
            "name": "print",
            "groupId": "action",
            "ligature": "print",
            "codepoint": "E8AD"
        }, {
            "iconId": "query_builder",
            "name": "query builder",
            "groupId": "action",
            "ligature": "query_builder",
            "codepoint": "E8AE"
        }, {
            "iconId": "question_answer",
            "name": "question answer",
            "groupId": "action",
            "ligature": "question_answer",
            "codepoint": "E8AF"
        }, {
            "iconId": "receipt",
            "name": "receipt",
            "groupId": "action",
            "ligature": "receipt",
            "codepoint": "E8B0"
        }, {
            "iconId": "record_voice_over",
            "name": "record voice over",
            "groupId": "action",
            "ligature": "record_voice_over",
            "codepoint": "E91F"
        }, {
            "iconId": "redeem",
            "name": "redeem",
            "groupId": "action",
            "ligature": "redeem",
            "codepoint": "E8B1"
        }, {
            "iconId": "remove_shopping_cart",
            "name": "remove shopping cart",
            "groupId": "action",
            "ligature": "remove_shopping_cart",
            "codepoint": "E928"
        }, {
            "iconId": "reorder",
            "name": "reorder",
            "groupId": "action",
            "ligature": "reorder",
            "codepoint": "E8FE"
        }, {
            "iconId": "report_problem",
            "name": "report problem",
            "groupId": "action",
            "ligature": "report_problem",
            "codepoint": "E8B2"
        }, {
            "iconId": "restore",
            "name": "restore",
            "groupId": "action",
            "ligature": "restore",
            "codepoint": "E8B3"
        }, {
            "iconId": "restore_page",
            "name": "restore page",
            "groupId": "action",
            "ligature": "restore_page",
            "codepoint": "E929"
        }, {
            "iconId": "room",
            "name": "room",
            "groupId": "action",
            "ligature": "room",
            "codepoint": "E8B4"
        }, {
            "iconId": "rounded_corner",
            "name": "rounded corner",
            "groupId": "action",
            "ligature": "rounded_corner",
            "codepoint": "E920"
        }, {
            "iconId": "rowing",
            "name": "rowing",
            "groupId": "action",
            "ligature": "rowing",
            "codepoint": "E921"
        }, {
            "iconId": "schedule",
            "name": "schedule",
            "groupId": "action",
            "ligature": "schedule",
            "codepoint": "E8B5"
        }, {
            "iconId": "search",
            "name": "search",
            "groupId": "action",
            "ligature": "search",
            "codepoint": "E8B6"
        }, {
            "iconId": "settings",
            "name": "settings",
            "groupId": "action",
            "ligature": "settings",
            "codepoint": "E8B8"
        }, {
            "iconId": "settings_applications",
            "name": "settings applications",
            "groupId": "action",
            "ligature": "settings_applications",
            "codepoint": "E8B9"
        }, {
            "iconId": "settings_backup_restore",
            "name": "settings backup restore",
            "groupId": "action",
            "ligature": "settings_backup_restore",
            "codepoint": "E8BA"
        }, {
            "iconId": "settings_bluetooth",
            "name": "settings bluetooth",
            "groupId": "action",
            "ligature": "settings_bluetooth",
            "codepoint": "E8BB"
        }, {
            "iconId": "settings_brightness",
            "name": "settings brightness",
            "groupId": "action",
            "ligature": "settings_brightness",
            "codepoint": "E8BD"
        }, {
            "iconId": "settings_cell",
            "name": "settings cell",
            "groupId": "action",
            "ligature": "settings_cell",
            "codepoint": "E8BC"
        }, {
            "iconId": "settings_ethernet",
            "name": "settings ethernet",
            "groupId": "action",
            "ligature": "settings_ethernet",
            "codepoint": "E8BE"
        }, {
            "iconId": "settings_input_antenna",
            "name": "settings input antenna",
            "groupId": "action",
            "ligature": "settings_input_antenna",
            "codepoint": "E8BF"
        }, {
            "iconId": "settings_input_component",
            "name": "settings input component",
            "groupId": "action",
            "ligature": "settings_input_component",
            "codepoint": "E8C0"
        }, {
            "iconId": "settings_input_composite",
            "name": "settings input composite",
            "groupId": "action",
            "ligature": "settings_input_composite",
            "codepoint": "E8C1"
        }, {
            "iconId": "settings_input_hdmi",
            "name": "settings input hdmi",
            "groupId": "action",
            "ligature": "settings_input_hdmi",
            "codepoint": "E8C2"
        }, {
            "iconId": "settings_input_svideo",
            "name": "settings input svideo",
            "groupId": "action",
            "ligature": "settings_input_svideo",
            "codepoint": "E8C3"
        }, {
            "iconId": "settings_overscan",
            "name": "settings overscan",
            "groupId": "action",
            "ligature": "settings_overscan",
            "codepoint": "E8C4"
        }, {
            "iconId": "settings_phone",
            "name": "settings phone",
            "groupId": "action",
            "ligature": "settings_phone",
            "codepoint": "E8C5"
        }, {
            "iconId": "settings_power",
            "name": "settings power",
            "groupId": "action",
            "ligature": "settings_power",
            "codepoint": "E8C6"
        }, {
            "iconId": "settings_remote",
            "name": "settings remote",
            "groupId": "action",
            "ligature": "settings_remote",
            "codepoint": "E8C7"
        }, {
            "iconId": "settings_voice",
            "name": "settings voice",
            "groupId": "action",
            "ligature": "settings_voice",
            "codepoint": "E8C8"
        }, {
            "iconId": "shop",
            "name": "shop",
            "groupId": "action",
            "ligature": "shop",
            "codepoint": "E8C9"
        }, {
            "iconId": "shop_two",
            "name": "shop two",
            "groupId": "action",
            "ligature": "shop_two",
            "codepoint": "E8CA"
        }, {
            "iconId": "shopping_basket",
            "name": "shopping basket",
            "groupId": "action",
            "ligature": "shopping_basket",
            "codepoint": "E8CB"
        }, {
            "iconId": "shopping_cart",
            "name": "shopping cart",
            "groupId": "action",
            "ligature": "shopping_cart",
            "codepoint": "E8CC"
        }, {
            "iconId": "speaker_notes",
            "name": "speaker notes",
            "groupId": "action",
            "ligature": "speaker_notes",
            "codepoint": "E8CD"
        }, {
            "iconId": "speaker_notes_off",
            "name": "speaker notes off",
            "groupId": "action",
            "ligature": "speaker_notes_off",
            "codepoint": "E92A"
        }, {
            "iconId": "spellcheck",
            "name": "spellcheck",
            "groupId": "action",
            "ligature": "spellcheck",
            "codepoint": "E8CE"
        }, {
            "iconId": "star_rate",
            "name": "star rate",
            "groupId": "action",
            "ligature": "star_rate",
            "codepoint": "E8CF"
        }, {
            "iconId": "stars",
            "name": "stars",
            "groupId": "action",
            "ligature": "stars",
            "codepoint": "E8D0"
        }, {
            "iconId": "store",
            "name": "store",
            "groupId": "action",
            "ligature": "store",
            "codepoint": "E8D1"
        }, {
            "iconId": "subject",
            "name": "subject",
            "groupId": "action",
            "ligature": "subject",
            "codepoint": "E8D2"
        }, {
            "iconId": "supervisor_account",
            "name": "supervisor account",
            "groupId": "action",
            "ligature": "supervisor_account",
            "codepoint": "E8D3"
        }, {
            "iconId": "swap_horiz",
            "name": "swap horiz",
            "groupId": "action",
            "ligature": "swap_horiz",
            "codepoint": "E8D4"
        }, {
            "iconId": "swap_vert",
            "name": "swap vert",
            "groupId": "action",
            "ligature": "swap_vert",
            "codepoint": "E8D5"
        }, {
            "iconId": "swap_vertical_circle",
            "name": "swap vertical circle",
            "groupId": "action",
            "ligature": "swap_vertical_circle",
            "codepoint": "E8D6"
        }, {
            "iconId": "system_update_alt",
            "name": "system update alt",
            "groupId": "action",
            "ligature": "system_update_alt",
            "codepoint": "E8D7"
        }, {
            "iconId": "tab",
            "name": "tab",
            "groupId": "action",
            "ligature": "tab",
            "codepoint": "E8D8"
        }, {
            "iconId": "tab_unselected",
            "name": "tab unselected",
            "groupId": "action",
            "ligature": "tab_unselected",
            "codepoint": "E8D9"
        }, {
            "iconId": "theaters",
            "name": "theaters",
            "groupId": "action",
            "ligature": "theaters",
            "codepoint": "E8DA"
        }, {
            "iconId": "thumb_down",
            "name": "thumb down",
            "groupId": "action",
            "ligature": "thumb_down",
            "codepoint": "E8DB"
        }, {
            "iconId": "thumb_up",
            "name": "thumb up",
            "groupId": "action",
            "ligature": "thumb_up",
            "codepoint": "E8DC"
        }, {
            "iconId": "thumbs_up_down",
            "name": "thumbs up down",
            "groupId": "action",
            "ligature": "thumbs_up_down",
            "codepoint": "E8DD"
        }, {
            "iconId": "timeline",
            "name": "timeline",
            "groupId": "action",
            "ligature": "timeline",
            "codepoint": "E922"
        }, {
            "iconId": "toc",
            "name": "toc",
            "groupId": "action",
            "ligature": "toc",
            "codepoint": "E8DE"
        }, {
            "iconId": "today",
            "name": "today",
            "groupId": "action",
            "ligature": "today",
            "codepoint": "E8DF"
        }, {
            "iconId": "toll",
            "name": "toll",
            "groupId": "action",
            "ligature": "toll",
            "codepoint": "E8E0"
        }, {
            "iconId": "touch_app",
            "name": "touch app",
            "groupId": "action",
            "ligature": "touch_app",
            "codepoint": "E913"
        }, {
            "iconId": "track_changes",
            "name": "track changes",
            "groupId": "action",
            "ligature": "track_changes",
            "codepoint": "E8E1"
        }, {
            "iconId": "translate",
            "name": "translate",
            "groupId": "action",
            "ligature": "translate",
            "codepoint": "E8E2"
        }, {
            "iconId": "trending_down",
            "name": "trending down",
            "groupId": "action",
            "ligature": "trending_down",
            "codepoint": "E8E3"
        }, {
            "iconId": "trending_flat",
            "name": "trending flat",
            "groupId": "action",
            "ligature": "trending_flat",
            "codepoint": "E8E4"
        }, {
            "iconId": "trending_up",
            "name": "trending up",
            "groupId": "action",
            "ligature": "trending_up",
            "codepoint": "E8E5"
        }, {
            "iconId": "turned_in",
            "name": "turned in",
            "groupId": "action",
            "ligature": "turned_in",
            "codepoint": "E8E6"
        }, {
            "iconId": "turned_in_not",
            "name": "turned in not",
            "groupId": "action",
            "ligature": "turned_in_not",
            "codepoint": "E8E7"
        }, {
            "iconId": "update",
            "name": "update",
            "groupId": "action",
            "ligature": "update",
            "codepoint": "E923"
        }, {
            "iconId": "verified_user",
            "name": "verified user",
            "groupId": "action",
            "ligature": "verified_user",
            "codepoint": "E8E8"
        }, {
            "iconId": "view_agenda",
            "name": "view agenda",
            "groupId": "action",
            "ligature": "view_agenda",
            "codepoint": "E8E9"
        }, {
            "iconId": "view_array",
            "name": "view array",
            "groupId": "action",
            "ligature": "view_array",
            "codepoint": "E8EA"
        }, {
            "iconId": "view_carousel",
            "name": "view carousel",
            "groupId": "action",
            "ligature": "view_carousel",
            "codepoint": "E8EB"
        }, {
            "iconId": "view_column",
            "name": "view column",
            "groupId": "action",
            "ligature": "view_column",
            "codepoint": "E8EC"
        }, {
            "iconId": "view_day",
            "name": "view day",
            "groupId": "action",
            "ligature": "view_day",
            "codepoint": "E8ED"
        }, {
            "iconId": "view_headline",
            "name": "view headline",
            "groupId": "action",
            "ligature": "view_headline",
            "codepoint": "E8EE"
        }, {
            "iconId": "view_list",
            "name": "view list",
            "groupId": "action",
            "ligature": "view_list",
            "codepoint": "E8EF"
        }, {
            "iconId": "view_module",
            "name": "view module",
            "groupId": "action",
            "ligature": "view_module",
            "codepoint": "E8F0"
        }, {
            "iconId": "view_quilt",
            "name": "view quilt",
            "groupId": "action",
            "ligature": "view_quilt",
            "codepoint": "E8F1"
        }, {
            "iconId": "view_stream",
            "name": "view stream",
            "groupId": "action",
            "ligature": "view_stream",
            "codepoint": "E8F2"
        }, {
            "iconId": "view_week",
            "name": "view week",
            "groupId": "action",
            "ligature": "view_week",
            "codepoint": "E8F3"
        }, {
            "iconId": "visibility",
            "name": "visibility",
            "groupId": "action",
            "ligature": "visibility",
            "codepoint": "E8F4"
        }, {
            "iconId": "visibility_off",
            "name": "visibility off",
            "groupId": "action",
            "ligature": "visibility_off",
            "codepoint": "E8F5"
        }, {
            "iconId": "watch_later",
            "name": "watch later",
            "groupId": "action",
            "ligature": "watch_later",
            "codepoint": "E924"
        }, {
            "iconId": "work",
            "name": "work",
            "groupId": "action",
            "ligature": "work",
            "codepoint": "E8F9"
        }, {
            "iconId": "youtube_searched_for",
            "name": "youtube searched for",
            "groupId": "action",
            "ligature": "youtube_searched_for",
            "codepoint": "E8FA"
        }, {
            "iconId": "zoom_in",
            "name": "zoom in",
            "groupId": "action",
            "ligature": "zoom_in",
            "codepoint": "E8FF"
        }, {
            "iconId": "zoom_out",
            "name": "zoom out",
            "groupId": "action",
            "ligature": "zoom_out",
            "codepoint": "E900"
        }, {
            "iconId": "add_alert",
            "name": "add alert",
            "groupId": "alert",
            "ligature": "add_alert",
            "codepoint": "E003"
        }, {
            "iconId": "error",
            "name": "error",
            "groupId": "alert",
            "ligature": "error",
            "codepoint": "E000"
        }, {
            "iconId": "error_outline",
            "name": "error outline",
            "groupId": "alert",
            "ligature": "error_outline",
            "codepoint": "E001"
        }, {
            "iconId": "warning",
            "name": "warning",
            "groupId": "alert",
            "ligature": "warning",
            "codepoint": "E002"
        }, {
            "iconId": "add_to_queue",
            "name": "add to queue",
            "groupId": "av",
            "ligature": "add_to_queue",
            "codepoint": "E05C"
        }, {
            "iconId": "airplay",
            "name": "airplay",
            "groupId": "av",
            "ligature": "airplay",
            "codepoint": "E055"
        }, {
            "iconId": "album",
            "name": "album",
            "groupId": "av",
            "ligature": "album",
            "codepoint": "E019"
        }, {
            "iconId": "art_track",
            "name": "art track",
            "groupId": "av",
            "ligature": "art_track",
            "codepoint": "E060"
        }, {
            "iconId": "av_timer",
            "name": "av timer",
            "groupId": "av",
            "ligature": "av_timer",
            "codepoint": "E01B"
        }, {
            "iconId": "branding_watermark",
            "name": "branding watermark",
            "groupId": "av",
            "ligature": "branding_watermark",
            "codepoint": "E06B"
        }, {
            "iconId": "call_to_action",
            "name": "call to action",
            "groupId": "av",
            "ligature": "call_to_action",
            "codepoint": "E06C"
        }, {
            "iconId": "closed_caption",
            "name": "closed caption",
            "groupId": "av",
            "ligature": "closed_caption",
            "codepoint": "E01C"
        }, {
            "iconId": "equalizer",
            "name": "equalizer",
            "groupId": "av",
            "ligature": "equalizer",
            "codepoint": "E01D"
        }, {
            "iconId": "explicit",
            "name": "explicit",
            "groupId": "av",
            "ligature": "explicit",
            "codepoint": "E01E"
        }, {
            "iconId": "fast_forward",
            "name": "fast forward",
            "groupId": "av",
            "ligature": "fast_forward",
            "codepoint": "E01F"
        }, {
            "iconId": "fast_rewind",
            "name": "fast rewind",
            "groupId": "av",
            "ligature": "fast_rewind",
            "codepoint": "E020"
        }, {
            "iconId": "featured_play_list",
            "name": "featured play list",
            "groupId": "av",
            "ligature": "featured_play_list",
            "codepoint": "E06D"
        }, {
            "iconId": "featured_video",
            "name": "featured video",
            "groupId": "av",
            "ligature": "featured_video",
            "codepoint": "E06E"
        }, {
            "iconId": "fiber_dvr",
            "name": "fiber dvr",
            "groupId": "av",
            "ligature": "fiber_dvr",
            "codepoint": "E05D"
        }, {
            "iconId": "fiber_manual_record",
            "name": "fiber manual record",
            "groupId": "av",
            "ligature": "fiber_manual_record",
            "codepoint": "E061"
        }, {
            "iconId": "fiber_new",
            "name": "fiber new",
            "groupId": "av",
            "ligature": "fiber_new",
            "codepoint": "E05E"
        }, {
            "iconId": "fiber_pin",
            "name": "fiber pin",
            "groupId": "av",
            "ligature": "fiber_pin",
            "codepoint": "E06A"
        }, {
            "iconId": "fiber_smart_record",
            "name": "fiber smart record",
            "groupId": "av",
            "ligature": "fiber_smart_record",
            "codepoint": "E062"
        }, {
            "iconId": "forward_10",
            "name": "forward 10",
            "groupId": "av",
            "ligature": "forward_10",
            "codepoint": "E056"
        }, {
            "iconId": "forward_30",
            "name": "forward 30",
            "groupId": "av",
            "ligature": "forward_30",
            "codepoint": "E057"
        }, {
            "iconId": "forward_5",
            "name": "forward 5",
            "groupId": "av",
            "ligature": "forward_5",
            "codepoint": "E058"
        }, {
            "iconId": "games",
            "name": "games",
            "groupId": "av",
            "ligature": "games",
            "codepoint": "E021"
        }, {
            "iconId": "hd",
            "name": "hd",
            "groupId": "av",
            "ligature": "hd",
            "codepoint": "E052"
        }, {
            "iconId": "hearing",
            "name": "hearing",
            "groupId": "av",
            "ligature": "hearing",
            "codepoint": "E023"
        }, {
            "iconId": "high_quality",
            "name": "high quality",
            "groupId": "av",
            "ligature": "high_quality",
            "codepoint": "E024"
        }, {
            "iconId": "library_add",
            "name": "library add",
            "groupId": "av",
            "ligature": "library_add",
            "codepoint": "E02E"
        }, {
            "iconId": "library_books",
            "name": "library books",
            "groupId": "av",
            "ligature": "library_books",
            "codepoint": "E02F"
        }, {
            "iconId": "library_music",
            "name": "library music",
            "groupId": "av",
            "ligature": "library_music",
            "codepoint": "E030"
        }, {
            "iconId": "loop",
            "name": "loop",
            "groupId": "av",
            "ligature": "loop",
            "codepoint": "E028"
        }, {
            "iconId": "mic",
            "name": "mic",
            "groupId": "av",
            "ligature": "mic",
            "codepoint": "E029"
        }, {
            "iconId": "mnone",
            "name": "mic none",
            "groupId": "av",
            "ligature": "mnone",
            "codepoint": "E02A"
        }, {
            "iconId": "moff",
            "name": "mic off",
            "groupId": "av",
            "ligature": "moff",
            "codepoint": "E02B"
        }, {
            "iconId": "movie",
            "name": "movie",
            "groupId": "av",
            "ligature": "movie",
            "codepoint": "E02C"
        }, {
            "iconId": "musvideo",
            "name": "music video",
            "groupId": "av",
            "ligature": "musvideo",
            "codepoint": "E063"
        }, {
            "iconId": "new_releases",
            "name": "new releases",
            "groupId": "av",
            "ligature": "new_releases",
            "codepoint": "E031"
        }, {
            "iconId": "not_interested",
            "name": "not interested",
            "groupId": "av",
            "ligature": "not_interested",
            "codepoint": "E033"
        }, {
            "iconId": "note",
            "name": "note",
            "groupId": "av",
            "ligature": "note",
            "codepoint": "E06F"
        }, {
            "iconId": "pause",
            "name": "pause",
            "groupId": "av",
            "ligature": "pause",
            "codepoint": "E034"
        }, {
            "iconId": "pause_circle_filled",
            "name": "pause circle filled",
            "groupId": "av",
            "ligature": "pause_circle_filled",
            "codepoint": "E035"
        }, {
            "iconId": "pause_circle_outline",
            "name": "pause circle outline",
            "groupId": "av",
            "ligature": "pause_circle_outline",
            "codepoint": "E036"
        }, {
            "iconId": "play_arrow",
            "name": "play arrow",
            "groupId": "av",
            "ligature": "play_arrow",
            "codepoint": "E037"
        }, {
            "iconId": "play_circle_filled",
            "name": "play circle filled",
            "groupId": "av",
            "ligature": "play_circle_filled",
            "codepoint": "E038"
        }, {
            "iconId": "play_circle_outline",
            "name": "play circle outline",
            "groupId": "av",
            "ligature": "play_circle_outline",
            "codepoint": "E039"
        }, {
            "iconId": "playlist_add",
            "name": "playlist add",
            "groupId": "av",
            "ligature": "playlist_add",
            "codepoint": "E03B"
        }, {
            "iconId": "playlist_add_check",
            "name": "playlist add check",
            "groupId": "av",
            "ligature": "playlist_add_check",
            "codepoint": "E065"
        }, {
            "iconId": "playlist_play",
            "name": "playlist play",
            "groupId": "av",
            "ligature": "playlist_play",
            "codepoint": "E05F"
        }, {
            "iconId": "queue",
            "name": "queue",
            "groupId": "av",
            "ligature": "queue",
            "codepoint": "E03C"
        }, {
            "iconId": "queue_music",
            "name": "queue music",
            "groupId": "av",
            "ligature": "queue_music",
            "codepoint": "E03D"
        }, {
            "iconId": "queue_play_next",
            "name": "queue play next",
            "groupId": "av",
            "ligature": "queue_play_next",
            "codepoint": "E066"
        }, {
            "iconId": "radio",
            "name": "radio",
            "groupId": "av",
            "ligature": "radio",
            "codepoint": "E03E"
        }, {
            "iconId": "recent_actors",
            "name": "recent actors",
            "groupId": "av",
            "ligature": "recent_actors",
            "codepoint": "E03F"
        }, {
            "iconId": "remove_from_queue",
            "name": "remove from queue",
            "groupId": "av",
            "ligature": "remove_from_queue",
            "codepoint": "E067"
        }, {
            "iconId": "repeat",
            "name": "repeat",
            "groupId": "av",
            "ligature": "repeat",
            "codepoint": "E040"
        }, {
            "iconId": "repeat_one",
            "name": "repeat one",
            "groupId": "av",
            "ligature": "repeat_one",
            "codepoint": "E041"
        }, {
            "iconId": "replay",
            "name": "replay",
            "groupId": "av",
            "ligature": "replay",
            "codepoint": "E042"
        }, {
            "iconId": "replay_10",
            "name": "replay 10",
            "groupId": "av",
            "ligature": "replay_10",
            "codepoint": "E059"
        }, {
            "iconId": "replay_30",
            "name": "replay 30",
            "groupId": "av",
            "ligature": "replay_30",
            "codepoint": "E05A"
        }, {
            "iconId": "replay_5",
            "name": "replay 5",
            "groupId": "av",
            "ligature": "replay_5",
            "codepoint": "E05B"
        }, {
            "iconId": "shuffle",
            "name": "shuffle",
            "groupId": "av",
            "ligature": "shuffle",
            "codepoint": "E043"
        }, {
            "iconId": "skip_next",
            "name": "skip next",
            "groupId": "av",
            "ligature": "skip_next",
            "codepoint": "E044"
        }, {
            "iconId": "skip_previous",
            "name": "skip previous",
            "groupId": "av",
            "ligature": "skip_previous",
            "codepoint": "E045"
        }, {
            "iconId": "slow_motion_video",
            "name": "slow motion video",
            "groupId": "av",
            "ligature": "slow_motion_video",
            "codepoint": "E068"
        }, {
            "iconId": "snooze",
            "name": "snooze",
            "groupId": "av",
            "ligature": "snooze",
            "codepoint": "E046"
        }, {
            "iconId": "sort_by_alpha",
            "name": "sort by alpha",
            "groupId": "av",
            "ligature": "sort_by_alpha",
            "codepoint": "E053"
        }, {
            "iconId": "stop",
            "name": "stop",
            "groupId": "av",
            "ligature": "stop",
            "codepoint": "E047"
        }, {
            "iconId": "subscriptions",
            "name": "subscriptions",
            "groupId": "av",
            "ligature": "subscriptions",
            "codepoint": "E064"
        }, {
            "iconId": "subtitles",
            "name": "subtitles",
            "groupId": "av",
            "ligature": "subtitles",
            "codepoint": "E048"
        }, {
            "iconId": "surround_sound",
            "name": "surround sound",
            "groupId": "av",
            "ligature": "surround_sound",
            "codepoint": "E049"
        }, {
            "iconId": "video_call",
            "name": "video call",
            "groupId": "av",
            "ligature": "video_call",
            "codepoint": "E070"
        }, {
            "iconId": "video_label",
            "name": "video label",
            "groupId": "av",
            "ligature": "video_label",
            "codepoint": "E071"
        }, {
            "iconId": "video_library",
            "name": "video library",
            "groupId": "av",
            "ligature": "video_library",
            "codepoint": "E04A"
        }, {
            "iconId": "videocam",
            "name": "videocam",
            "groupId": "av",
            "ligature": "videocam",
            "codepoint": "E04B"
        }, {
            "iconId": "videocam_off",
            "name": "videocam off",
            "groupId": "av",
            "ligature": "videocam_off",
            "codepoint": "E04C"
        }, {
            "iconId": "volume_down",
            "name": "volume down",
            "groupId": "av",
            "ligature": "volume_down",
            "codepoint": "E04D"
        }, {
            "iconId": "volume_mute",
            "name": "volume mute",
            "groupId": "av",
            "ligature": "volume_mute",
            "codepoint": "E04E"
        }, {
            "iconId": "volume_off",
            "name": "volume off",
            "groupId": "av",
            "ligature": "volume_off",
            "codepoint": "E04F"
        }, {
            "iconId": "volume_up",
            "name": "volume up",
            "groupId": "av",
            "ligature": "volume_up",
            "codepoint": "E050"
        }, {
            "iconId": "web",
            "name": "web",
            "groupId": "av",
            "ligature": "web",
            "codepoint": "E051"
        }, {
            "iconId": "web_asset",
            "name": "web asset",
            "groupId": "av",
            "ligature": "web_asset",
            "codepoint": "E069"
        }, {
            "iconId": "business",
            "name": "business",
            "groupId": "communication",
            "ligature": "business",
            "codepoint": "E0AF"
        }, {
            "iconId": "call",
            "name": "call",
            "groupId": "communication",
            "ligature": "call",
            "codepoint": "E0B0"
        }, {
            "iconId": "call_end",
            "name": "call end",
            "groupId": "communication",
            "ligature": "call_end",
            "codepoint": "E0B1"
        }, {
            "iconId": "call_made",
            "name": "call made",
            "groupId": "communication",
            "ligature": "call_made",
            "codepoint": "E0B2"
        }, {
            "iconId": "call_merge",
            "name": "call merge",
            "groupId": "communication",
            "ligature": "call_merge",
            "codepoint": "E0B3"
        }, {
            "iconId": "call_missed",
            "name": "call missed",
            "groupId": "communication",
            "ligature": "call_missed",
            "codepoint": "E0B4"
        }, {
            "iconId": "call_missed_outgoing",
            "name": "call missed outgoing",
            "groupId": "communication",
            "ligature": "call_missed_outgoing",
            "codepoint": "E0E4"
        }, {
            "iconId": "call_received",
            "name": "call received",
            "groupId": "communication",
            "ligature": "call_received",
            "codepoint": "E0B5"
        }, {
            "iconId": "call_split",
            "name": "call split",
            "groupId": "communication",
            "ligature": "call_split",
            "codepoint": "E0B6"
        }, {
            "iconId": "chat",
            "name": "chat",
            "groupId": "communication",
            "ligature": "chat",
            "codepoint": "E0B7"
        }, {
            "iconId": "chat_bubble",
            "name": "chat bubble",
            "groupId": "communication",
            "ligature": "chat_bubble",
            "codepoint": "E0CA"
        }, {
            "iconId": "chat_bubble_outline",
            "name": "chat bubble outline",
            "groupId": "communication",
            "ligature": "chat_bubble_outline",
            "codepoint": "E0CB"
        }, {
            "iconId": "clear_all",
            "name": "clear all",
            "groupId": "communication",
            "ligature": "clear_all",
            "codepoint": "E0B8"
        }, {
            "iconId": "comment",
            "name": "comment",
            "groupId": "communication",
            "ligature": "comment",
            "codepoint": "E0B9"
        }, {
            "iconId": "contact_mail",
            "name": "contact mail",
            "groupId": "communication",
            "ligature": "contact_mail",
            "codepoint": "E0D0"
        }, {
            "iconId": "contact_phone",
            "name": "contact phone",
            "groupId": "communication",
            "ligature": "contact_phone",
            "codepoint": "E0CF"
        }, {
            "iconId": "contacts",
            "name": "contacts",
            "groupId": "communication",
            "ligature": "contacts",
            "codepoint": "E0BA"
        }, {
            "iconId": "dialer_sip",
            "name": "dialer sip",
            "groupId": "communication",
            "ligature": "dialer_sip",
            "codepoint": "E0BB"
        }, {
            "iconId": "dialpad",
            "name": "dialpad",
            "groupId": "communication",
            "ligature": "dialpad",
            "codepoint": "E0BC"
        }, {
            "iconId": "email",
            "name": "email",
            "groupId": "communication",
            "ligature": "email",
            "codepoint": "E0BE"
        }, {
            "iconId": "forum",
            "name": "forum",
            "groupId": "communication",
            "ligature": "forum",
            "codepoint": "E0BF"
        }, {
            "iconId": "import_contacts",
            "name": "import contacts",
            "groupId": "communication",
            "ligature": "import_contacts",
            "codepoint": "E0E0"
        }, {
            "iconId": "import_export",
            "name": "import export",
            "groupId": "communication",
            "ligature": "import_export",
            "codepoint": "E0C3"
        }, {
            "iconId": "invert_colors_off",
            "name": "invert colors off",
            "groupId": "communication",
            "ligature": "invert_colors_off",
            "codepoint": "E0C4"
        }, {
            "iconId": "live_help",
            "name": "live help",
            "groupId": "communication",
            "ligature": "live_help",
            "codepoint": "E0C6"
        }, {
            "iconId": "location_off",
            "name": "location off",
            "groupId": "communication",
            "ligature": "location_off",
            "codepoint": "E0C7"
        }, {
            "iconId": "location_on",
            "name": "location on",
            "groupId": "communication",
            "ligature": "location_on",
            "codepoint": "E0C8"
        }, {
            "iconId": "mail_outline",
            "name": "mail outline",
            "groupId": "communication",
            "ligature": "mail_outline",
            "codepoint": "E0E1"
        }, {
            "iconId": "message",
            "name": "message",
            "groupId": "communication",
            "ligature": "message",
            "codepoint": "E0C9"
        }, {
            "iconId": "no_sim",
            "name": "no sim",
            "groupId": "communication",
            "ligature": "no_sim",
            "codepoint": "E0CC"
        }, {
            "iconId": "phone",
            "name": "phone",
            "groupId": "communication",
            "ligature": "phone",
            "codepoint": "E0CD"
        }, {
            "iconId": "phonelink_erase",
            "name": "phonelink erase",
            "groupId": "communication",
            "ligature": "phonelink_erase",
            "codepoint": "E0DB"
        }, {
            "iconId": "phonelink_lock",
            "name": "phonelink lock",
            "groupId": "communication",
            "ligature": "phonelink_lock",
            "codepoint": "E0DC"
        }, {
            "iconId": "phonelink_ring",
            "name": "phonelink ring",
            "groupId": "communication",
            "ligature": "phonelink_ring",
            "codepoint": "E0DD"
        }, {
            "iconId": "phonelink_setup",
            "name": "phonelink setup",
            "groupId": "communication",
            "ligature": "phonelink_setup",
            "codepoint": "E0DE"
        }, {
            "iconId": "portable_wifi_off",
            "name": "portable wifi off",
            "groupId": "communication",
            "ligature": "portable_wifi_off",
            "codepoint": "E0CE"
        }, {
            "iconId": "present_to_all",
            "name": "present to all",
            "groupId": "communication",
            "ligature": "present_to_all",
            "codepoint": "E0DF"
        }, {
            "iconId": "ring_volume",
            "name": "ring volume",
            "groupId": "communication",
            "ligature": "ring_volume",
            "codepoint": "E0D1"
        }, {
            "iconId": "rss_feed",
            "name": "rss feed",
            "groupId": "communication",
            "ligature": "rss_feed",
            "codepoint": "E0E5"
        }, {
            "iconId": "screen_share",
            "name": "screen share",
            "groupId": "communication",
            "ligature": "screen_share",
            "codepoint": "E0E2"
        }, {
            "iconId": "speaker_phone",
            "name": "speaker phone",
            "groupId": "communication",
            "ligature": "speaker_phone",
            "codepoint": "E0D2"
        }, {
            "iconId": "stay_current_landscape",
            "name": "stay current landscape",
            "groupId": "communication",
            "ligature": "stay_current_landscape",
            "codepoint": "E0D3"
        }, {
            "iconId": "stay_current_portrait",
            "name": "stay current portrait",
            "groupId": "communication",
            "ligature": "stay_current_portrait",
            "codepoint": "E0D4"
        }, {
            "iconId": "stay_primary_landscape",
            "name": "stay primary landscape",
            "groupId": "communication",
            "ligature": "stay_primary_landscape",
            "codepoint": "E0D5"
        }, {
            "iconId": "stay_primary_portrait",
            "name": "stay primary portrait",
            "groupId": "communication",
            "ligature": "stay_primary_portrait",
            "codepoint": "E0D6"
        }, {
            "iconId": "stop_screen_share",
            "name": "stop screen share",
            "groupId": "communication",
            "ligature": "stop_screen_share",
            "codepoint": "E0E3"
        }, {
            "iconId": "swap_calls",
            "name": "swap calls",
            "groupId": "communication",
            "ligature": "swap_calls",
            "codepoint": "E0D7"
        }, {
            "iconId": "textsms",
            "name": "textsms",
            "groupId": "communication",
            "ligature": "textsms",
            "codepoint": "E0D8"
        }, {
            "iconId": "voicemail",
            "name": "voicemail",
            "groupId": "communication",
            "ligature": "voicemail",
            "codepoint": "E0D9"
        }, {
            "iconId": "vpn_key",
            "name": "vpn key",
            "groupId": "communication",
            "ligature": "vpn_key",
            "codepoint": "E0DA"
        }, {
            "iconId": "add",
            "name": "add",
            "groupId": "content",
            "ligature": "add",
            "codepoint": "E145"
        }, {
            "iconId": "add_box",
            "name": "add box",
            "groupId": "content",
            "ligature": "add_box",
            "codepoint": "E146"
        }, {
            "iconId": "add_circle",
            "name": "add circle",
            "groupId": "content",
            "ligature": "add_circle",
            "codepoint": "E147"
        }, {
            "iconId": "add_circle_outline",
            "name": "add circle outline",
            "groupId": "content",
            "ligature": "add_circle_outline",
            "codepoint": "E148"
        }, {
            "iconId": "archive",
            "name": "archive",
            "groupId": "content",
            "ligature": "archive",
            "codepoint": "E149"
        }, {
            "iconId": "backspace",
            "name": "backspace",
            "groupId": "content",
            "ligature": "backspace",
            "codepoint": "E14A"
        }, {
            "iconId": "block",
            "name": "block",
            "groupId": "content",
            "ligature": "block",
            "codepoint": "E14B"
        }, {
            "iconId": "clear",
            "name": "clear",
            "groupId": "content",
            "ligature": "clear",
            "codepoint": "E14C"
        }, {
            "iconId": "content_copy",
            "name": "content copy",
            "groupId": "content",
            "ligature": "content_copy",
            "codepoint": "E14D"
        }, {
            "iconId": "content_cut",
            "name": "content cut",
            "groupId": "content",
            "ligature": "content_cut",
            "codepoint": "E14E"
        }, {
            "iconId": "content_paste",
            "name": "content paste",
            "groupId": "content",
            "ligature": "content_paste",
            "codepoint": "E14F"
        }, {
            "iconId": "create",
            "name": "create",
            "groupId": "content",
            "ligature": "create",
            "codepoint": "E150"
        }, {
            "iconId": "delete_sweep",
            "name": "delete sweep",
            "groupId": "content",
            "ligature": "delete_sweep",
            "codepoint": "E16C"
        }, {
            "iconId": "drafts",
            "name": "drafts",
            "groupId": "content",
            "ligature": "drafts",
            "codepoint": "E151"
        }, {
            "iconId": "filter_list",
            "name": "filter list",
            "groupId": "content",
            "ligature": "filter_list",
            "codepoint": "E152"
        }, {
            "iconId": "flag",
            "name": "flag",
            "groupId": "content",
            "ligature": "flag",
            "codepoint": "E153"
        }, {
            "iconId": "font_download",
            "name": "font download",
            "groupId": "content",
            "ligature": "font_download",
            "codepoint": "E167"
        }, {
            "iconId": "forward",
            "name": "forward",
            "groupId": "content",
            "ligature": "forward",
            "codepoint": "E154"
        }, {
            "iconId": "gesture",
            "name": "gesture",
            "groupId": "content",
            "ligature": "gesture",
            "codepoint": "E155"
        }, {
            "iconId": "inbox",
            "name": "inbox",
            "groupId": "content",
            "ligature": "inbox",
            "codepoint": "E156"
        }, {
            "iconId": "link",
            "name": "link",
            "groupId": "content",
            "ligature": "link",
            "codepoint": "E157"
        }, {
            "iconId": "low_priority",
            "name": "low priority",
            "groupId": "content",
            "ligature": "low_priority",
            "codepoint": "E16D"
        }, {
            "iconId": "mail",
            "name": "mail",
            "groupId": "content",
            "ligature": "mail",
            "codepoint": "E158"
        }, {
            "iconId": "markunread",
            "name": "markunread",
            "groupId": "content",
            "ligature": "markunread",
            "codepoint": "E159"
        }, {
            "iconId": "move_to_inbox",
            "name": "move to inbox",
            "groupId": "content",
            "ligature": "move_to_inbox",
            "codepoint": "E168"
        }, {
            "iconId": "next_week",
            "name": "next week",
            "groupId": "content",
            "ligature": "next_week",
            "codepoint": "E16A"
        }, {
            "iconId": "redo",
            "name": "redo",
            "groupId": "content",
            "ligature": "redo",
            "codepoint": "E15A"
        }, {
            "iconId": "remove",
            "name": "remove",
            "groupId": "content",
            "ligature": "remove",
            "codepoint": "E15B"
        }, {
            "iconId": "remove_circle",
            "name": "remove circle",
            "groupId": "content",
            "ligature": "remove_circle",
            "codepoint": "E15C"
        }, {
            "iconId": "remove_circle_outline",
            "name": "remove circle outline",
            "groupId": "content",
            "ligature": "remove_circle_outline",
            "codepoint": "E15D"
        }, {
            "iconId": "reply",
            "name": "reply",
            "groupId": "content",
            "ligature": "reply",
            "codepoint": "E15E"
        }, {
            "iconId": "reply_all",
            "name": "reply all",
            "groupId": "content",
            "ligature": "reply_all",
            "codepoint": "E15F"
        }, {
            "iconId": "report",
            "name": "report",
            "groupId": "content",
            "ligature": "report",
            "codepoint": "E160"
        }, {
            "iconId": "save",
            "name": "save",
            "groupId": "content",
            "ligature": "save",
            "codepoint": "E161"
        }, {
            "iconId": "select_all",
            "name": "select all",
            "groupId": "content",
            "ligature": "select_all",
            "codepoint": "E162"
        }, {
            "iconId": "send",
            "name": "send",
            "groupId": "content",
            "ligature": "send",
            "codepoint": "E163"
        }, {
            "iconId": "sort",
            "name": "sort",
            "groupId": "content",
            "ligature": "sort",
            "codepoint": "E164"
        }, {
            "iconId": "text_format",
            "name": "text format",
            "groupId": "content",
            "ligature": "text_format",
            "codepoint": "E165"
        }, {
            "iconId": "unarchive",
            "name": "unarchive",
            "groupId": "content",
            "ligature": "unarchive",
            "codepoint": "E169"
        }, {
            "iconId": "undo",
            "name": "undo",
            "groupId": "content",
            "ligature": "undo",
            "codepoint": "E166"
        }, {
            "iconId": "weekend",
            "name": "weekend",
            "groupId": "content",
            "ligature": "weekend",
            "codepoint": "E16B"
        }, {
            "iconId": "access_alarm",
            "name": "access alarm",
            "groupId": "device",
            "ligature": "access_alarm",
            "codepoint": "E190"
        }, {
            "iconId": "access_alarms",
            "name": "access alarms",
            "groupId": "device",
            "ligature": "access_alarms",
            "codepoint": "E191"
        }, {
            "iconId": "access_time",
            "name": "access time",
            "groupId": "device",
            "ligature": "access_time",
            "codepoint": "E192"
        }, {
            "iconId": "add_alarm",
            "name": "add alarm",
            "groupId": "device",
            "ligature": "add_alarm",
            "codepoint": "E193"
        }, {
            "iconId": "airplanemode_active",
            "name": "airplanemode active",
            "groupId": "device",
            "ligature": "airplanemode_active",
            "codepoint": "E195"
        }, {
            "iconId": "airplanemode_inactive",
            "name": "airplanemode inactive",
            "groupId": "device",
            "ligature": "airplanemode_inactive",
            "codepoint": "E194"
        }, {
            "iconId": "battery_alert",
            "name": "battery alert",
            "groupId": "device",
            "ligature": "battery_alert",
            "codepoint": "E19C"
        }, {
            "iconId": "battery_charging_full",
            "name": "battery charging full",
            "groupId": "device",
            "ligature": "battery_charging_full",
            "codepoint": "E1A3"
        }, {
            "iconId": "battery_full",
            "name": "battery full",
            "groupId": "device",
            "ligature": "battery_full",
            "codepoint": "E1A4"
        }, {
            "iconId": "battery_std",
            "name": "battery std",
            "groupId": "device",
            "ligature": "battery_std",
            "codepoint": "E1A5"
        }, {
            "iconId": "battery_unknown",
            "name": "battery unknown",
            "groupId": "device",
            "ligature": "battery_unknown",
            "codepoint": "E1A6"
        }, {
            "iconId": "bluetooth",
            "name": "bluetooth",
            "groupId": "device",
            "ligature": "bluetooth",
            "codepoint": "E1A7"
        }, {
            "iconId": "bluetooth_connected",
            "name": "bluetooth connected",
            "groupId": "device",
            "ligature": "bluetooth_connected",
            "codepoint": "E1A8"
        }, {
            "iconId": "bluetooth_disabled",
            "name": "bluetooth disabled",
            "groupId": "device",
            "ligature": "bluetooth_disabled",
            "codepoint": "E1A9"
        }, {
            "iconId": "bluetooth_searching",
            "name": "bluetooth searching",
            "groupId": "device",
            "ligature": "bluetooth_searching",
            "codepoint": "E1AA"
        }, {
            "iconId": "brightness_auto",
            "name": "brightness auto",
            "groupId": "device",
            "ligature": "brightness_auto",
            "codepoint": "E1AB"
        }, {
            "iconId": "brightness_high",
            "name": "brightness high",
            "groupId": "device",
            "ligature": "brightness_high",
            "codepoint": "E1AC"
        }, {
            "iconId": "brightness_low",
            "name": "brightness low",
            "groupId": "device",
            "ligature": "brightness_low",
            "codepoint": "E1AD"
        }, {
            "iconId": "brightness_medium",
            "name": "brightness medium",
            "groupId": "device",
            "ligature": "brightness_medium",
            "codepoint": "E1AE"
        }, {
            "iconId": "data_usage",
            "name": "data usage",
            "groupId": "device",
            "ligature": "data_usage",
            "codepoint": "E1AF"
        }, {
            "iconId": "developer_mode",
            "name": "developer mode",
            "groupId": "device",
            "ligature": "developer_mode",
            "codepoint": "E1B0"
        }, {
            "iconId": "devices",
            "name": "devices",
            "groupId": "device",
            "ligature": "devices",
            "codepoint": "E1B1"
        }, {
            "iconId": "dvr",
            "name": "dvr",
            "groupId": "device",
            "ligature": "dvr",
            "codepoint": "E1B2"
        }, {
            "iconId": "gps_fixed",
            "name": "gps fixed",
            "groupId": "device",
            "ligature": "gps_fixed",
            "codepoint": "E1B3"
        }, {
            "iconId": "gps_not_fixed",
            "name": "gps not fixed",
            "groupId": "device",
            "ligature": "gps_not_fixed",
            "codepoint": "E1B4"
        }, {
            "iconId": "gps_off",
            "name": "gps off",
            "groupId": "device",
            "ligature": "gps_off",
            "codepoint": "E1B5"
        }, {
            "iconId": "grapheq",
            "name": "graphic eq",
            "groupId": "device",
            "ligature": "grapheq",
            "codepoint": "E1B8"
        }, {
            "iconId": "location_disabled",
            "name": "location disabled",
            "groupId": "device",
            "ligature": "location_disabled",
            "codepoint": "E1B6"
        }, {
            "iconId": "location_searching",
            "name": "location searching",
            "groupId": "device",
            "ligature": "location_searching",
            "codepoint": "E1B7"
        }, {
            "iconId": "network_cell",
            "name": "network cell",
            "groupId": "device",
            "ligature": "network_cell",
            "codepoint": "E1B9"
        }, {
            "iconId": "network_wifi",
            "name": "network wifi",
            "groupId": "device",
            "ligature": "network_wifi",
            "codepoint": "E1BA"
        }, {
            "iconId": "nfc",
            "name": "nfc",
            "groupId": "device",
            "ligature": "nfc",
            "codepoint": "E1BB"
        }, {
            "iconId": "screen_lock_landscape",
            "name": "screen lock landscape",
            "groupId": "device",
            "ligature": "screen_lock_landscape",
            "codepoint": "E1BE"
        }, {
            "iconId": "screen_lock_portrait",
            "name": "screen lock portrait",
            "groupId": "device",
            "ligature": "screen_lock_portrait",
            "codepoint": "E1BF"
        }, {
            "iconId": "screen_lock_rotation",
            "name": "screen lock rotation",
            "groupId": "device",
            "ligature": "screen_lock_rotation",
            "codepoint": "E1C0"
        }, {
            "iconId": "screen_rotation",
            "name": "screen rotation",
            "groupId": "device",
            "ligature": "screen_rotation",
            "codepoint": "E1C1"
        }, {
            "iconId": "sd_storage",
            "name": "sd storage",
            "groupId": "device",
            "ligature": "sd_storage",
            "codepoint": "E1C2"
        }, {
            "iconId": "settings_system_daydream",
            "name": "settings system daydream",
            "groupId": "device",
            "ligature": "settings_system_daydream",
            "codepoint": "E1C3"
        }, {
            "iconId": "signal_cellular_4_bar",
            "name": "signal cellular 4 bar",
            "groupId": "device",
            "ligature": "signal_cellular_4_bar",
            "codepoint": "E1C8"
        }, {
            "iconId": "signal_cellular_connected_no_internet_4_bar",
            "name": "signal cellular connected no internet 4 bar",
            "groupId": "device",
            "ligature": "signal_cellular_connected_no_internet_4_bar",
            "codepoint": "E1CD"
        }, {
            "iconId": "signal_cellular_no_sim",
            "name": "signal cellular no sim",
            "groupId": "device",
            "ligature": "signal_cellular_no_sim",
            "codepoint": "E1CE"
        }, {
            "iconId": "signal_cellular_null",
            "name": "signal cellular null",
            "groupId": "device",
            "ligature": "signal_cellular_null",
            "codepoint": "E1CF"
        }, {
            "iconId": "signal_cellular_off",
            "name": "signal cellular off",
            "groupId": "device",
            "ligature": "signal_cellular_off",
            "codepoint": "E1D0"
        }, {
            "iconId": "signal_wifi_4_bar",
            "name": "signal wifi 4 bar",
            "groupId": "device",
            "ligature": "signal_wifi_4_bar",
            "codepoint": "E1D8"
        }, {
            "iconId": "signal_wifi_4_bar_lock",
            "name": "signal wifi 4 bar lock",
            "groupId": "device",
            "ligature": "signal_wifi_4_bar_lock",
            "codepoint": "E1D9"
        }, {
            "iconId": "signal_wifi_off",
            "name": "signal wifi off",
            "groupId": "device",
            "ligature": "signal_wifi_off",
            "codepoint": "E1DA"
        }, {
            "iconId": "storage",
            "name": "storage",
            "groupId": "device",
            "ligature": "storage",
            "codepoint": "E1DB"
        }, {
            "iconId": "usb",
            "name": "usb",
            "groupId": "device",
            "ligature": "usb",
            "codepoint": "E1E0"
        }, {
            "iconId": "wallpaper",
            "name": "wallpaper",
            "groupId": "device",
            "ligature": "wallpaper",
            "codepoint": "E1BC"
        }, {
            "iconId": "widgets",
            "name": "widgets",
            "groupId": "device",
            "ligature": "widgets",
            "codepoint": "E1BD"
        }, {
            "iconId": "wifi_lock",
            "name": "wifi lock",
            "groupId": "device",
            "ligature": "wifi_lock",
            "codepoint": "E1E1"
        }, {
            "iconId": "wifi_tethering",
            "name": "wifi tethering",
            "groupId": "device",
            "ligature": "wifi_tethering",
            "codepoint": "E1E2"
        }, {
            "iconId": "attach_file",
            "name": "attach file",
            "groupId": "editor",
            "ligature": "attach_file",
            "codepoint": "E226"
        }, {
            "iconId": "attach_money",
            "name": "attach money",
            "groupId": "editor",
            "ligature": "attach_money",
            "codepoint": "E227"
        }, {
            "iconId": "border_all",
            "name": "border all",
            "groupId": "editor",
            "ligature": "border_all",
            "codepoint": "E228"
        }, {
            "iconId": "border_bottom",
            "name": "border bottom",
            "groupId": "editor",
            "ligature": "border_bottom",
            "codepoint": "E229"
        }, {
            "iconId": "border_clear",
            "name": "border clear",
            "groupId": "editor",
            "ligature": "border_clear",
            "codepoint": "E22A"
        }, {
            "iconId": "border_color",
            "name": "border color",
            "groupId": "editor",
            "ligature": "border_color",
            "codepoint": "E22B"
        }, {
            "iconId": "border_horizontal",
            "name": "border horizontal",
            "groupId": "editor",
            "ligature": "border_horizontal",
            "codepoint": "E22C"
        }, {
            "iconId": "border_inner",
            "name": "border inner",
            "groupId": "editor",
            "ligature": "border_inner",
            "codepoint": "E22D"
        }, {
            "iconId": "border_left",
            "name": "border left",
            "groupId": "editor",
            "ligature": "border_left",
            "codepoint": "E22E"
        }, {
            "iconId": "border_outer",
            "name": "border outer",
            "groupId": "editor",
            "ligature": "border_outer",
            "codepoint": "E22F"
        }, {
            "iconId": "border_right",
            "name": "border right",
            "groupId": "editor",
            "ligature": "border_right",
            "codepoint": "E230"
        }, {
            "iconId": "border_style",
            "name": "border style",
            "groupId": "editor",
            "ligature": "border_style",
            "codepoint": "E231"
        }, {
            "iconId": "border_top",
            "name": "border top",
            "groupId": "editor",
            "ligature": "border_top",
            "codepoint": "E232"
        }, {
            "iconId": "border_vertical",
            "name": "border vertical",
            "groupId": "editor",
            "ligature": "border_vertical",
            "codepoint": "E233"
        }, {
            "iconId": "bubble_chart",
            "name": "bubble chart",
            "groupId": "editor",
            "ligature": "bubble_chart",
            "codepoint": "E6DD"
        }, {
            "iconId": "drag_handle",
            "name": "drag handle",
            "groupId": "editor",
            "ligature": "drag_handle",
            "codepoint": "E25D"
        }, {
            "iconId": "format_align_center",
            "name": "format align center",
            "groupId": "editor",
            "ligature": "format_align_center",
            "codepoint": "E234"
        }, {
            "iconId": "format_align_justify",
            "name": "format align justify",
            "groupId": "editor",
            "ligature": "format_align_justify",
            "codepoint": "E235"
        }, {
            "iconId": "format_align_left",
            "name": "format align left",
            "groupId": "editor",
            "ligature": "format_align_left",
            "codepoint": "E236"
        }, {
            "iconId": "format_align_right",
            "name": "format align right",
            "groupId": "editor",
            "ligature": "format_align_right",
            "codepoint": "E237"
        }, {
            "iconId": "format_bold",
            "name": "format bold",
            "groupId": "editor",
            "ligature": "format_bold",
            "codepoint": "E238"
        }, {
            "iconId": "format_clear",
            "name": "format clear",
            "groupId": "editor",
            "ligature": "format_clear",
            "codepoint": "E239"
        }, {
            "iconId": "format_color_fill",
            "name": "format color fill",
            "groupId": "editor",
            "ligature": "format_color_fill",
            "codepoint": "E23A"
        }, {
            "iconId": "format_color_reset",
            "name": "format color reset",
            "groupId": "editor",
            "ligature": "format_color_reset",
            "codepoint": "E23B"
        }, {
            "iconId": "format_color_text",
            "name": "format color text",
            "groupId": "editor",
            "ligature": "format_color_text",
            "codepoint": "E23C"
        }, {
            "iconId": "format_indent_decrease",
            "name": "format indent decrease",
            "groupId": "editor",
            "ligature": "format_indent_decrease",
            "codepoint": "E23D"
        }, {
            "iconId": "format_indent_increase",
            "name": "format indent increase",
            "groupId": "editor",
            "ligature": "format_indent_increase",
            "codepoint": "E23E"
        }, {
            "iconId": "format_italic",
            "name": "format italic",
            "groupId": "editor",
            "ligature": "format_italic",
            "codepoint": "E23F"
        }, {
            "iconId": "format_line_spacing",
            "name": "format line spacing",
            "groupId": "editor",
            "ligature": "format_line_spacing",
            "codepoint": "E240"
        }, {
            "iconId": "format_list_bulleted",
            "name": "format list bulleted",
            "groupId": "editor",
            "ligature": "format_list_bulleted",
            "codepoint": "E241"
        }, {
            "iconId": "format_list_numbered",
            "name": "format list numbered",
            "groupId": "editor",
            "ligature": "format_list_numbered",
            "codepoint": "E242"
        }, {
            "iconId": "format_paint",
            "name": "format paint",
            "groupId": "editor",
            "ligature": "format_paint",
            "codepoint": "E243"
        }, {
            "iconId": "format_quote",
            "name": "format quote",
            "groupId": "editor",
            "ligature": "format_quote",
            "codepoint": "E244"
        }, {
            "iconId": "format_shapes",
            "name": "format shapes",
            "groupId": "editor",
            "ligature": "format_shapes",
            "codepoint": "E25E"
        }, {
            "iconId": "format_size",
            "name": "format size",
            "groupId": "editor",
            "ligature": "format_size",
            "codepoint": "E245"
        }, {
            "iconId": "format_strikethrough",
            "name": "format strikethrough",
            "groupId": "editor",
            "ligature": "format_strikethrough",
            "codepoint": "E246"
        }, {
            "iconId": "format_textdirection_l_to_r",
            "name": "format textdirection l to r",
            "groupId": "editor",
            "ligature": "format_textdirection_l_to_r",
            "codepoint": "E247"
        }, {
            "iconId": "format_textdirection_r_to_l",
            "name": "format textdirection r to l",
            "groupId": "editor",
            "ligature": "format_textdirection_r_to_l",
            "codepoint": "E248"
        }, {
            "iconId": "format_underlined",
            "name": "format underlined",
            "groupId": "editor",
            "ligature": "format_underlined",
            "codepoint": "E249"
        }, {
            "iconId": "functions",
            "name": "functions",
            "groupId": "editor",
            "ligature": "functions",
            "codepoint": "E24A"
        }, {
            "iconId": "highlight",
            "name": "highlight",
            "groupId": "editor",
            "ligature": "highlight",
            "codepoint": "E25F"
        }, {
            "iconId": "insert_chart",
            "name": "insert chart",
            "groupId": "editor",
            "ligature": "insert_chart",
            "codepoint": "E24B"
        }, {
            "iconId": "insert_comment",
            "name": "insert comment",
            "groupId": "editor",
            "ligature": "insert_comment",
            "codepoint": "E24C"
        }, {
            "iconId": "insert_drive_file",
            "name": "insert drive file",
            "groupId": "editor",
            "ligature": "insert_drive_file",
            "codepoint": "E24D"
        }, {
            "iconId": "insert_emoticon",
            "name": "insert emoticon",
            "groupId": "editor",
            "ligature": "insert_emoticon",
            "codepoint": "E24E"
        }, {
            "iconId": "insert_invitation",
            "name": "insert invitation",
            "groupId": "editor",
            "ligature": "insert_invitation",
            "codepoint": "E24F"
        }, {
            "iconId": "insert_link",
            "name": "insert link",
            "groupId": "editor",
            "ligature": "insert_link",
            "codepoint": "E250"
        }, {
            "iconId": "insert_photo",
            "name": "insert photo",
            "groupId": "editor",
            "ligature": "insert_photo",
            "codepoint": "E251"
        }, {
            "iconId": "linear_scale",
            "name": "linear scale",
            "groupId": "editor",
            "ligature": "linear_scale",
            "codepoint": "E260"
        }, {
            "iconId": "merge_type",
            "name": "merge type",
            "groupId": "editor",
            "ligature": "merge_type",
            "codepoint": "E252"
        }, {
            "iconId": "mode_comment",
            "name": "mode comment",
            "groupId": "editor",
            "ligature": "mode_comment",
            "codepoint": "E253"
        }, {
            "iconId": "mode_edit",
            "name": "mode edit",
            "groupId": "editor",
            "ligature": "mode_edit",
            "codepoint": "E254"
        }, {
            "iconId": "monetization_on",
            "name": "monetization on",
            "groupId": "editor",
            "ligature": "monetization_on",
            "codepoint": "E263"
        }, {
            "iconId": "money_off",
            "name": "money off",
            "groupId": "editor",
            "ligature": "money_off",
            "codepoint": "E25C"
        }, {
            "iconId": "multiline_chart",
            "name": "multiline chart",
            "groupId": "editor",
            "ligature": "multiline_chart",
            "codepoint": "E6DF"
        }, {
            "iconId": "pie_chart",
            "name": "pie chart",
            "groupId": "editor",
            "ligature": "pie_chart",
            "codepoint": "E6C4"
        }, {
            "iconId": "pie_chart_outlined",
            "name": "pie chart outlined",
            "groupId": "editor",
            "ligature": "pie_chart_outlined",
            "codepoint": "E6C5"
        }, {
            "iconId": "publish",
            "name": "publish",
            "groupId": "editor",
            "ligature": "publish",
            "codepoint": "E255"
        }, {
            "iconId": "short_text",
            "name": "short text",
            "groupId": "editor",
            "ligature": "short_text",
            "codepoint": "E261"
        }, {
            "iconId": "show_chart",
            "name": "show chart",
            "groupId": "editor",
            "ligature": "show_chart",
            "codepoint": "E6E1"
        }, {
            "iconId": "space_bar",
            "name": "space bar",
            "groupId": "editor",
            "ligature": "space_bar",
            "codepoint": "E256"
        }, {
            "iconId": "strikethrough_s",
            "name": "strikethrough s",
            "groupId": "editor",
            "ligature": "strikethrough_s",
            "codepoint": "E257"
        }, {
            "iconId": "text_fields",
            "name": "text fields",
            "groupId": "editor",
            "ligature": "text_fields",
            "codepoint": "E262"
        }, {
            "iconId": "title",
            "name": "title",
            "groupId": "editor",
            "ligature": "title",
            "codepoint": "E264"
        }, {
            "iconId": "vertical_align_bottom",
            "name": "vertical align bottom",
            "groupId": "editor",
            "ligature": "vertical_align_bottom",
            "codepoint": "E258"
        }, {
            "iconId": "vertical_align_center",
            "name": "vertical align center",
            "groupId": "editor",
            "ligature": "vertical_align_center",
            "codepoint": "E259"
        }, {
            "iconId": "vertical_align_top",
            "name": "vertical align top",
            "groupId": "editor",
            "ligature": "vertical_align_top",
            "codepoint": "E25A"
        }, {
            "iconId": "wrap_text",
            "name": "wrap text",
            "groupId": "editor",
            "ligature": "wrap_text",
            "codepoint": "E25B"
        }, {
            "iconId": "attachment",
            "name": "attachment",
            "groupId": "file",
            "ligature": "attachment",
            "codepoint": "E2BC"
        }, {
            "iconId": "cloud",
            "name": "cloud",
            "groupId": "file",
            "ligature": "cloud",
            "codepoint": "E2BD"
        }, {
            "iconId": "cloud_circle",
            "name": "cloud circle",
            "groupId": "file",
            "ligature": "cloud_circle",
            "codepoint": "E2BE"
        }, {
            "iconId": "cloud_done",
            "name": "cloud done",
            "groupId": "file",
            "ligature": "cloud_done",
            "codepoint": "E2BF"
        }, {
            "iconId": "cloud_download",
            "name": "cloud download",
            "groupId": "file",
            "ligature": "cloud_download",
            "codepoint": "E2C0"
        }, {
            "iconId": "cloud_off",
            "name": "cloud off",
            "groupId": "file",
            "ligature": "cloud_off",
            "codepoint": "E2C1"
        }, {
            "iconId": "cloud_queue",
            "name": "cloud queue",
            "groupId": "file",
            "ligature": "cloud_queue",
            "codepoint": "E2C2"
        }, {
            "iconId": "cloud_upload",
            "name": "cloud upload",
            "groupId": "file",
            "ligature": "cloud_upload",
            "codepoint": "E2C3"
        }, {
            "iconId": "create_new_folder",
            "name": "create new folder",
            "groupId": "file",
            "ligature": "create_new_folder",
            "codepoint": "E2CC"
        }, {
            "iconId": "file_download",
            "name": "file download",
            "groupId": "file",
            "ligature": "file_download",
            "codepoint": "E2C4"
        }, {
            "iconId": "file_upload",
            "name": "file upload",
            "groupId": "file",
            "ligature": "file_upload",
            "codepoint": "E2C6"
        }, {
            "iconId": "folder",
            "name": "folder",
            "groupId": "file",
            "ligature": "folder",
            "codepoint": "E2C7"
        }, {
            "iconId": "folder_open",
            "name": "folder open",
            "groupId": "file",
            "ligature": "folder_open",
            "codepoint": "E2C8"
        }, {
            "iconId": "folder_shared",
            "name": "folder shared",
            "groupId": "file",
            "ligature": "folder_shared",
            "codepoint": "E2C9"
        }, {
            "iconId": "cast",
            "name": "cast",
            "groupId": "hardware",
            "ligature": "cast",
            "codepoint": "E307"
        }, {
            "iconId": "cast_connected",
            "name": "cast connected",
            "groupId": "hardware",
            "ligature": "cast_connected",
            "codepoint": "E308"
        }, {
            "iconId": "computer",
            "name": "computer",
            "groupId": "hardware",
            "ligature": "computer",
            "codepoint": "E30A"
        }, {
            "iconId": "desktop_mac",
            "name": "desktop mac",
            "groupId": "hardware",
            "ligature": "desktop_mac",
            "codepoint": "E30B"
        }, {
            "iconId": "desktop_windows",
            "name": "desktop windows",
            "groupId": "hardware",
            "ligature": "desktop_windows",
            "codepoint": "E30C"
        }, {
            "iconId": "developer_board",
            "name": "developer board",
            "groupId": "hardware",
            "ligature": "developer_board",
            "codepoint": "E30D"
        }, {
            "iconId": "device_hub",
            "name": "device hub",
            "groupId": "hardware",
            "ligature": "device_hub",
            "codepoint": "E335"
        }, {
            "iconId": "devices_other",
            "name": "devices other",
            "groupId": "hardware",
            "ligature": "devices_other",
            "codepoint": "E337"
        }, {
            "iconId": "dock",
            "name": "dock",
            "groupId": "hardware",
            "ligature": "dock",
            "codepoint": "E30E"
        }, {
            "iconId": "gamepad",
            "name": "gamepad",
            "groupId": "hardware",
            "ligature": "gamepad",
            "codepoint": "E30F"
        }, {
            "iconId": "headset",
            "name": "headset",
            "groupId": "hardware",
            "ligature": "headset",
            "codepoint": "E310"
        }, {
            "iconId": "headset_mic",
            "name": "headset mic",
            "groupId": "hardware",
            "ligature": "headset_mic",
            "codepoint": "E311"
        }, {
            "iconId": "keyboard",
            "name": "keyboard",
            "groupId": "hardware",
            "ligature": "keyboard",
            "codepoint": "E312"
        }, {
            "iconId": "keyboard_arrow_down",
            "name": "keyboard arrow down",
            "groupId": "hardware",
            "ligature": "keyboard_arrow_down",
            "codepoint": "E313"
        }, {
            "iconId": "keyboard_arrow_left",
            "name": "keyboard arrow left",
            "groupId": "hardware",
            "ligature": "keyboard_arrow_left",
            "codepoint": "E314"
        }, {
            "iconId": "keyboard_arrow_right",
            "name": "keyboard arrow right",
            "groupId": "hardware",
            "ligature": "keyboard_arrow_right",
            "codepoint": "E315"
        }, {
            "iconId": "keyboard_arrow_up",
            "name": "keyboard arrow up",
            "groupId": "hardware",
            "ligature": "keyboard_arrow_up",
            "codepoint": "E316"
        }, {
            "iconId": "keyboard_backspace",
            "name": "keyboard backspace",
            "groupId": "hardware",
            "ligature": "keyboard_backspace",
            "codepoint": "E317"
        }, {
            "iconId": "keyboard_capslock",
            "name": "keyboard capslock",
            "groupId": "hardware",
            "ligature": "keyboard_capslock",
            "codepoint": "E318"
        }, {
            "iconId": "keyboard_hide",
            "name": "keyboard hide",
            "groupId": "hardware",
            "ligature": "keyboard_hide",
            "codepoint": "E31A"
        }, {
            "iconId": "keyboard_return",
            "name": "keyboard return",
            "groupId": "hardware",
            "ligature": "keyboard_return",
            "codepoint": "E31B"
        }, {
            "iconId": "keyboard_tab",
            "name": "keyboard tab",
            "groupId": "hardware",
            "ligature": "keyboard_tab",
            "codepoint": "E31C"
        }, {
            "iconId": "keyboard_voice",
            "name": "keyboard voice",
            "groupId": "hardware",
            "ligature": "keyboard_voice",
            "codepoint": "E31D"
        }, {
            "iconId": "laptop",
            "name": "laptop",
            "groupId": "hardware",
            "ligature": "laptop",
            "codepoint": "E31E"
        }, {
            "iconId": "laptop_chromebook",
            "name": "laptop chromebook",
            "groupId": "hardware",
            "ligature": "laptop_chromebook",
            "codepoint": "E31F"
        }, {
            "iconId": "laptop_mac",
            "name": "laptop mac",
            "groupId": "hardware",
            "ligature": "laptop_mac",
            "codepoint": "E320"
        }, {
            "iconId": "laptop_windows",
            "name": "laptop windows",
            "groupId": "hardware",
            "ligature": "laptop_windows",
            "codepoint": "E321"
        }, {
            "iconId": "memory",
            "name": "memory",
            "groupId": "hardware",
            "ligature": "memory",
            "codepoint": "E322"
        }, {
            "iconId": "mouse",
            "name": "mouse",
            "groupId": "hardware",
            "ligature": "mouse",
            "codepoint": "E323"
        }, {
            "iconId": "phone_android",
            "name": "phone android",
            "groupId": "hardware",
            "ligature": "phone_android",
            "codepoint": "E324"
        }, {
            "iconId": "phone_iphone",
            "name": "phone iphone",
            "groupId": "hardware",
            "ligature": "phone_iphone",
            "codepoint": "E325"
        }, {
            "iconId": "phonelink",
            "name": "phonelink",
            "groupId": "hardware",
            "ligature": "phonelink",
            "codepoint": "E326"
        }, {
            "iconId": "phonelink_off",
            "name": "phonelink off",
            "groupId": "hardware",
            "ligature": "phonelink_off",
            "codepoint": "E327"
        }, {
            "iconId": "power_input",
            "name": "power input",
            "groupId": "hardware",
            "ligature": "power_input",
            "codepoint": "E336"
        }, {
            "iconId": "router",
            "name": "router",
            "groupId": "hardware",
            "ligature": "router",
            "codepoint": "E328"
        }, {
            "iconId": "scanner",
            "name": "scanner",
            "groupId": "hardware",
            "ligature": "scanner",
            "codepoint": "E329"
        }, {
            "iconId": "security",
            "name": "security",
            "groupId": "hardware",
            "ligature": "security",
            "codepoint": "E32A"
        }, {
            "iconId": "sim_card",
            "name": "sim card",
            "groupId": "hardware",
            "ligature": "sim_card",
            "codepoint": "E32B"
        }, {
            "iconId": "smartphone",
            "name": "smartphone",
            "groupId": "hardware",
            "ligature": "smartphone",
            "codepoint": "E32C"
        }, {
            "iconId": "speaker",
            "name": "speaker",
            "groupId": "hardware",
            "ligature": "speaker",
            "codepoint": "E32D"
        }, {
            "iconId": "speaker_group",
            "name": "speaker group",
            "groupId": "hardware",
            "ligature": "speaker_group",
            "codepoint": "E32E"
        }, {
            "iconId": "tablet",
            "name": "tablet",
            "groupId": "hardware",
            "ligature": "tablet",
            "codepoint": "E32F"
        }, {
            "iconId": "tablet_android",
            "name": "tablet android",
            "groupId": "hardware",
            "ligature": "tablet_android",
            "codepoint": "E330"
        }, {
            "iconId": "tablet_mac",
            "name": "tablet mac",
            "groupId": "hardware",
            "ligature": "tablet_mac",
            "codepoint": "E331"
        }, {
            "iconId": "toys",
            "name": "toys",
            "groupId": "hardware",
            "ligature": "toys",
            "codepoint": "E332"
        }, {
            "iconId": "tv",
            "name": "tv",
            "groupId": "hardware",
            "ligature": "tv",
            "codepoint": "E333"
        }, {
            "iconId": "videogame_asset",
            "name": "videogame asset",
            "groupId": "hardware",
            "ligature": "videogame_asset",
            "codepoint": "E338"
        }, {
            "iconId": "watch",
            "name": "watch",
            "groupId": "hardware",
            "ligature": "watch",
            "codepoint": "E334"
        }, {
            "iconId": "add_a_photo",
            "name": "add a photo",
            "groupId": "image",
            "ligature": "add_a_photo",
            "codepoint": "E439"
        }, {
            "iconId": "add_to_photos",
            "name": "add to photos",
            "groupId": "image",
            "ligature": "add_to_photos",
            "codepoint": "E39D"
        }, {
            "iconId": "adjust",
            "name": "adjust",
            "groupId": "image",
            "ligature": "adjust",
            "codepoint": "E39E"
        }, {
            "iconId": "assistant",
            "name": "assistant",
            "groupId": "image",
            "ligature": "assistant",
            "codepoint": "E39F"
        }, {
            "iconId": "assistant_photo",
            "name": "assistant photo",
            "groupId": "image",
            "ligature": "assistant_photo",
            "codepoint": "E3A0"
        }, {
            "iconId": "audiotrack",
            "name": "audiotrack",
            "groupId": "image",
            "ligature": "audiotrack",
            "codepoint": "E3A1"
        }, {
            "iconId": "blur_circular",
            "name": "blur circular",
            "groupId": "image",
            "ligature": "blur_circular",
            "codepoint": "E3A2"
        }, {
            "iconId": "blur_linear",
            "name": "blur linear",
            "groupId": "image",
            "ligature": "blur_linear",
            "codepoint": "E3A3"
        }, {
            "iconId": "blur_off",
            "name": "blur off",
            "groupId": "image",
            "ligature": "blur_off",
            "codepoint": "E3A4"
        }, {
            "iconId": "blur_on",
            "name": "blur on",
            "groupId": "image",
            "ligature": "blur_on",
            "codepoint": "E3A5"
        }, {
            "iconId": "brightness_1",
            "name": "brightness 1",
            "groupId": "image",
            "ligature": "brightness_1",
            "codepoint": "E3A6"
        }, {
            "iconId": "brightness_2",
            "name": "brightness 2",
            "groupId": "image",
            "ligature": "brightness_2",
            "codepoint": "E3A7"
        }, {
            "iconId": "brightness_3",
            "name": "brightness 3",
            "groupId": "image",
            "ligature": "brightness_3",
            "codepoint": "E3A8"
        }, {
            "iconId": "brightness_4",
            "name": "brightness 4",
            "groupId": "image",
            "ligature": "brightness_4",
            "codepoint": "E3A9"
        }, {
            "iconId": "brightness_5",
            "name": "brightness 5",
            "groupId": "image",
            "ligature": "brightness_5",
            "codepoint": "E3AA"
        }, {
            "iconId": "brightness_6",
            "name": "brightness 6",
            "groupId": "image",
            "ligature": "brightness_6",
            "codepoint": "E3AB"
        }, {
            "iconId": "brightness_7",
            "name": "brightness 7",
            "groupId": "image",
            "ligature": "brightness_7",
            "codepoint": "E3AC"
        }, {
            "iconId": "broken_image",
            "name": "broken image",
            "groupId": "image",
            "ligature": "broken_image",
            "codepoint": "E3AD"
        }, {
            "iconId": "brush",
            "name": "brush",
            "groupId": "image",
            "ligature": "brush",
            "codepoint": "E3AE"
        }, {
            "iconId": "burst_mode",
            "name": "burst mode",
            "groupId": "image",
            "ligature": "burst_mode",
            "codepoint": "E43C"
        }, {
            "iconId": "camera",
            "name": "camera",
            "groupId": "image",
            "ligature": "camera",
            "codepoint": "E3AF"
        }, {
            "iconId": "camera_alt",
            "name": "camera alt",
            "groupId": "image",
            "ligature": "camera_alt",
            "codepoint": "E3B0"
        }, {
            "iconId": "camera_front",
            "name": "camera front",
            "groupId": "image",
            "ligature": "camera_front",
            "codepoint": "E3B1"
        }, {
            "iconId": "camera_rear",
            "name": "camera rear",
            "groupId": "image",
            "ligature": "camera_rear",
            "codepoint": "E3B2"
        }, {
            "iconId": "camera_roll",
            "name": "camera roll",
            "groupId": "image",
            "ligature": "camera_roll",
            "codepoint": "E3B3"
        }, {
            "iconId": "center_focus_strong",
            "name": "center focus strong",
            "groupId": "image",
            "ligature": "center_focus_strong",
            "codepoint": "E3B4"
        }, {
            "iconId": "center_focus_weak",
            "name": "center focus weak",
            "groupId": "image",
            "ligature": "center_focus_weak",
            "codepoint": "E3B5"
        }, {
            "iconId": "collections",
            "name": "collections",
            "groupId": "image",
            "ligature": "collections",
            "codepoint": "E3B6"
        }, {
            "iconId": "collections_bookmark",
            "name": "collections bookmark",
            "groupId": "image",
            "ligature": "collections_bookmark",
            "codepoint": "E431"
        }, {
            "iconId": "color_lens",
            "name": "color lens",
            "groupId": "image",
            "ligature": "color_lens",
            "codepoint": "E3B7"
        }, {
            "iconId": "colorize",
            "name": "colorize",
            "groupId": "image",
            "ligature": "colorize",
            "codepoint": "E3B8"
        }, {
            "iconId": "compare",
            "name": "compare",
            "groupId": "image",
            "ligature": "compare",
            "codepoint": "E3B9"
        }, {
            "iconId": "control_point",
            "name": "control point",
            "groupId": "image",
            "ligature": "control_point",
            "codepoint": "E3BA"
        }, {
            "iconId": "control_point_duplicate",
            "name": "control point duplicate",
            "groupId": "image",
            "ligature": "control_point_duplicate",
            "codepoint": "E3BB"
        }, {
            "iconId": "crop",
            "name": "crop",
            "groupId": "image",
            "ligature": "crop",
            "codepoint": "E3BE"
        }, {
            "iconId": "crop_16_9",
            "name": "crop 16 9",
            "groupId": "image",
            "ligature": "crop_16_9",
            "codepoint": "E3BC"
        }, {
            "iconId": "crop_3_2",
            "name": "crop 3 2",
            "groupId": "image",
            "ligature": "crop_3_2",
            "codepoint": "E3BD"
        }, {
            "iconId": "crop_5_4",
            "name": "crop 5 4",
            "groupId": "image",
            "ligature": "crop_5_4",
            "codepoint": "E3BF"
        }, {
            "iconId": "crop_7_5",
            "name": "crop 7 5",
            "groupId": "image",
            "ligature": "crop_7_5",
            "codepoint": "E3C0"
        }, {
            "iconId": "crop_din",
            "name": "crop din",
            "groupId": "image",
            "ligature": "crop_din",
            "codepoint": "E3C1"
        }, {
            "iconId": "crop_free",
            "name": "crop free",
            "groupId": "image",
            "ligature": "crop_free",
            "codepoint": "E3C2"
        }, {
            "iconId": "crop_landscape",
            "name": "crop landscape",
            "groupId": "image",
            "ligature": "crop_landscape",
            "codepoint": "E3C3"
        }, {
            "iconId": "crop_original",
            "name": "crop original",
            "groupId": "image",
            "ligature": "crop_original",
            "codepoint": "E3C4"
        }, {
            "iconId": "crop_portrait",
            "name": "crop portrait",
            "groupId": "image",
            "ligature": "crop_portrait",
            "codepoint": "E3C5"
        }, {
            "iconId": "crop_rotate",
            "name": "crop rotate",
            "groupId": "image",
            "ligature": "crop_rotate",
            "codepoint": "E437"
        }, {
            "iconId": "crop_square",
            "name": "crop square",
            "groupId": "image",
            "ligature": "crop_square",
            "codepoint": "E3C6"
        }, {
            "iconId": "dehaze",
            "name": "dehaze",
            "groupId": "image",
            "ligature": "dehaze",
            "codepoint": "E3C7"
        }, {
            "iconId": "details",
            "name": "details",
            "groupId": "image",
            "ligature": "details",
            "codepoint": "E3C8"
        }, {
            "iconId": "edit",
            "name": "edit",
            "groupId": "image",
            "ligature": "edit",
            "codepoint": "E3C9"
        }, {
            "iconId": "exposure",
            "name": "exposure",
            "groupId": "image",
            "ligature": "exposure",
            "codepoint": "E3CA"
        }, {
            "iconId": "exposure_neg_1",
            "name": "exposure neg 1",
            "groupId": "image",
            "ligature": "exposure_neg_1",
            "codepoint": "E3CB"
        }, {
            "iconId": "exposure_neg_2",
            "name": "exposure neg 2",
            "groupId": "image",
            "ligature": "exposure_neg_2",
            "codepoint": "E3CC"
        }, {
            "iconId": "exposure_plus_1",
            "name": "exposure plus 1",
            "groupId": "image",
            "ligature": "exposure_plus_1",
            "codepoint": "E3CD"
        }, {
            "iconId": "exposure_plus_2",
            "name": "exposure plus 2",
            "groupId": "image",
            "ligature": "exposure_plus_2",
            "codepoint": "E3CE"
        }, {
            "iconId": "exposure_zero",
            "name": "exposure zero",
            "groupId": "image",
            "ligature": "exposure_zero",
            "codepoint": "E3CF"
        }, {
            "iconId": "filter",
            "name": "filter",
            "groupId": "image",
            "ligature": "filter",
            "codepoint": "E3D3"
        }, {
            "iconId": "filter_1",
            "name": "filter 1",
            "groupId": "image",
            "ligature": "filter_1",
            "codepoint": "E3D0"
        }, {
            "iconId": "filter_2",
            "name": "filter 2",
            "groupId": "image",
            "ligature": "filter_2",
            "codepoint": "E3D1"
        }, {
            "iconId": "filter_3",
            "name": "filter 3",
            "groupId": "image",
            "ligature": "filter_3",
            "codepoint": "E3D2"
        }, {
            "iconId": "filter_4",
            "name": "filter 4",
            "groupId": "image",
            "ligature": "filter_4",
            "codepoint": "E3D4"
        }, {
            "iconId": "filter_5",
            "name": "filter 5",
            "groupId": "image",
            "ligature": "filter_5",
            "codepoint": "E3D5"
        }, {
            "iconId": "filter_6",
            "name": "filter 6",
            "groupId": "image",
            "ligature": "filter_6",
            "codepoint": "E3D6"
        }, {
            "iconId": "filter_7",
            "name": "filter 7",
            "groupId": "image",
            "ligature": "filter_7",
            "codepoint": "E3D7"
        }, {
            "iconId": "filter_8",
            "name": "filter 8",
            "groupId": "image",
            "ligature": "filter_8",
            "codepoint": "E3D8"
        }, {
            "iconId": "filter_9",
            "name": "filter 9",
            "groupId": "image",
            "ligature": "filter_9",
            "codepoint": "E3D9"
        }, {
            "iconId": "filter_9_plus",
            "name": "filter 9 plus",
            "groupId": "image",
            "ligature": "filter_9_plus",
            "codepoint": "E3DA"
        }, {
            "iconId": "filter_b_and_w",
            "name": "filter b and w",
            "groupId": "image",
            "ligature": "filter_b_and_w",
            "codepoint": "E3DB"
        }, {
            "iconId": "filter_center_focus",
            "name": "filter center focus",
            "groupId": "image",
            "ligature": "filter_center_focus",
            "codepoint": "E3DC"
        }, {
            "iconId": "filter_drama",
            "name": "filter drama",
            "groupId": "image",
            "ligature": "filter_drama",
            "codepoint": "E3DD"
        }, {
            "iconId": "filter_frames",
            "name": "filter frames",
            "groupId": "image",
            "ligature": "filter_frames",
            "codepoint": "E3DE"
        }, {
            "iconId": "filter_hdr",
            "name": "filter hdr",
            "groupId": "image",
            "ligature": "filter_hdr",
            "codepoint": "E3DF"
        }, {
            "iconId": "filter_none",
            "name": "filter none",
            "groupId": "image",
            "ligature": "filter_none",
            "codepoint": "E3E0"
        }, {
            "iconId": "filter_tilt_shift",
            "name": "filter tilt shift",
            "groupId": "image",
            "ligature": "filter_tilt_shift",
            "codepoint": "E3E2"
        }, {
            "iconId": "filter_vintage",
            "name": "filter vintage",
            "groupId": "image",
            "ligature": "filter_vintage",
            "codepoint": "E3E3"
        }, {
            "iconId": "flare",
            "name": "flare",
            "groupId": "image",
            "ligature": "flare",
            "codepoint": "E3E4"
        }, {
            "iconId": "flash_auto",
            "name": "flash auto",
            "groupId": "image",
            "ligature": "flash_auto",
            "codepoint": "E3E5"
        }, {
            "iconId": "flash_off",
            "name": "flash off",
            "groupId": "image",
            "ligature": "flash_off",
            "codepoint": "E3E6"
        }, {
            "iconId": "flash_on",
            "name": "flash on",
            "groupId": "image",
            "ligature": "flash_on",
            "codepoint": "E3E7"
        }, {
            "iconId": "flip",
            "name": "flip",
            "groupId": "image",
            "ligature": "flip",
            "codepoint": "E3E8"
        }, {
            "iconId": "gradient",
            "name": "gradient",
            "groupId": "image",
            "ligature": "gradient",
            "codepoint": "E3E9"
        }, {
            "iconId": "grain",
            "name": "grain",
            "groupId": "image",
            "ligature": "grain",
            "codepoint": "E3EA"
        }, {
            "iconId": "grid_off",
            "name": "grid off",
            "groupId": "image",
            "ligature": "grid_off",
            "codepoint": "E3EB"
        }, {
            "iconId": "grid_on",
            "name": "grid on",
            "groupId": "image",
            "ligature": "grid_on",
            "codepoint": "E3EC"
        }, {
            "iconId": "hdr_off",
            "name": "hdr off",
            "groupId": "image",
            "ligature": "hdr_off",
            "codepoint": "E3ED"
        }, {
            "iconId": "hdr_on",
            "name": "hdr on",
            "groupId": "image",
            "ligature": "hdr_on",
            "codepoint": "E3EE"
        }, {
            "iconId": "hdr_strong",
            "name": "hdr strong",
            "groupId": "image",
            "ligature": "hdr_strong",
            "codepoint": "E3F1"
        }, {
            "iconId": "hdr_weak",
            "name": "hdr weak",
            "groupId": "image",
            "ligature": "hdr_weak",
            "codepoint": "E3F2"
        }, {
            "iconId": "healing",
            "name": "healing",
            "groupId": "image",
            "ligature": "healing",
            "codepoint": "E3F3"
        }, {
            "iconId": "image",
            "name": "image",
            "groupId": "image",
            "ligature": "image",
            "codepoint": "E3F4"
        }, {
            "iconId": "image_aspect_ratio",
            "name": "image aspect ratio",
            "groupId": "image",
            "ligature": "image_aspect_ratio",
            "codepoint": "E3F5"
        }, {
            "iconId": "iso",
            "name": "iso",
            "groupId": "image",
            "ligature": "iso",
            "codepoint": "E3F6"
        }, {
            "iconId": "landscape",
            "name": "landscape",
            "groupId": "image",
            "ligature": "landscape",
            "codepoint": "E3F7"
        }, {
            "iconId": "leak_add",
            "name": "leak add",
            "groupId": "image",
            "ligature": "leak_add",
            "codepoint": "E3F8"
        }, {
            "iconId": "leak_remove",
            "name": "leak remove",
            "groupId": "image",
            "ligature": "leak_remove",
            "codepoint": "E3F9"
        }, {
            "iconId": "lens",
            "name": "lens",
            "groupId": "image",
            "ligature": "lens",
            "codepoint": "E3FA"
        }, {
            "iconId": "linked_camera",
            "name": "linked camera",
            "groupId": "image",
            "ligature": "linked_camera",
            "codepoint": "E438"
        }, {
            "iconId": "looks",
            "name": "looks",
            "groupId": "image",
            "ligature": "looks",
            "codepoint": "E3FC"
        }, {
            "iconId": "looks_3",
            "name": "looks 3",
            "groupId": "image",
            "ligature": "looks_3",
            "codepoint": "E3FB"
        }, {
            "iconId": "looks_4",
            "name": "looks 4",
            "groupId": "image",
            "ligature": "looks_4",
            "codepoint": "E3FD"
        }, {
            "iconId": "looks_5",
            "name": "looks 5",
            "groupId": "image",
            "ligature": "looks_5",
            "codepoint": "E3FE"
        }, {
            "iconId": "looks_6",
            "name": "looks 6",
            "groupId": "image",
            "ligature": "looks_6",
            "codepoint": "E3FF"
        }, {
            "iconId": "looks_one",
            "name": "looks one",
            "groupId": "image",
            "ligature": "looks_one",
            "codepoint": "E400"
        }, {
            "iconId": "looks_two",
            "name": "looks two",
            "groupId": "image",
            "ligature": "looks_two",
            "codepoint": "E401"
        }, {
            "iconId": "loupe",
            "name": "loupe",
            "groupId": "image",
            "ligature": "loupe",
            "codepoint": "E402"
        }, {
            "iconId": "monochrome_photos",
            "name": "monochrome photos",
            "groupId": "image",
            "ligature": "monochrome_photos",
            "codepoint": "E403"
        }, {
            "iconId": "movie_creation",
            "name": "movie creation",
            "groupId": "image",
            "ligature": "movie_creation",
            "codepoint": "E404"
        }, {
            "iconId": "movie_filter",
            "name": "movie filter",
            "groupId": "image",
            "ligature": "movie_filter",
            "codepoint": "E43A"
        }, {
            "iconId": "musnote",
            "name": "music note",
            "groupId": "image",
            "ligature": "musnote",
            "codepoint": "E405"
        }, {
            "iconId": "nature",
            "name": "nature",
            "groupId": "image",
            "ligature": "nature",
            "codepoint": "E406"
        }, {
            "iconId": "nature_people",
            "name": "nature people",
            "groupId": "image",
            "ligature": "nature_people",
            "codepoint": "E407"
        }, {
            "iconId": "navigate_before",
            "name": "navigate before",
            "groupId": "image",
            "ligature": "navigate_before",
            "codepoint": "E408"
        }, {
            "iconId": "navigate_next",
            "name": "navigate next",
            "groupId": "image",
            "ligature": "navigate_next",
            "codepoint": "E409"
        }, {
            "iconId": "palette",
            "name": "palette",
            "groupId": "image",
            "ligature": "palette",
            "codepoint": "E40A"
        }, {
            "iconId": "panorama",
            "name": "panorama",
            "groupId": "image",
            "ligature": "panorama",
            "codepoint": "E40B"
        }, {
            "iconId": "panorama_fish_eye",
            "name": "panorama fish eye",
            "groupId": "image",
            "ligature": "panorama_fish_eye",
            "codepoint": "E40C"
        }, {
            "iconId": "panorama_horizontal",
            "name": "panorama horizontal",
            "groupId": "image",
            "ligature": "panorama_horizontal",
            "codepoint": "E40D"
        }, {
            "iconId": "panorama_vertical",
            "name": "panorama vertical",
            "groupId": "image",
            "ligature": "panorama_vertical",
            "codepoint": "E40E"
        }, {
            "iconId": "panorama_wide_angle",
            "name": "panorama wide angle",
            "groupId": "image",
            "ligature": "panorama_wide_angle",
            "codepoint": "E40F"
        }, {
            "iconId": "photo",
            "name": "photo",
            "groupId": "image",
            "ligature": "photo",
            "codepoint": "E410"
        }, {
            "iconId": "photo_album",
            "name": "photo album",
            "groupId": "image",
            "ligature": "photo_album",
            "codepoint": "E411"
        }, {
            "iconId": "photo_camera",
            "name": "photo camera",
            "groupId": "image",
            "ligature": "photo_camera",
            "codepoint": "E412"
        }, {
            "iconId": "photo_filter",
            "name": "photo filter",
            "groupId": "image",
            "ligature": "photo_filter",
            "codepoint": "E43B"
        }, {
            "iconId": "photo_library",
            "name": "photo library",
            "groupId": "image",
            "ligature": "photo_library",
            "codepoint": "E413"
        }, {
            "iconId": "photo_size_select_actual",
            "name": "photo size select actual",
            "groupId": "image",
            "ligature": "photo_size_select_actual",
            "codepoint": "E432"
        }, {
            "iconId": "photo_size_select_large",
            "name": "photo size select large",
            "groupId": "image",
            "ligature": "photo_size_select_large",
            "codepoint": "E433"
        }, {
            "iconId": "photo_size_select_small",
            "name": "photo size select small",
            "groupId": "image",
            "ligature": "photo_size_select_small",
            "codepoint": "E434"
        }, {
            "iconId": "picture_as_pdf",
            "name": "picture as pdf",
            "groupId": "image",
            "ligature": "picture_as_pdf",
            "codepoint": "E415"
        }, {
            "iconId": "portrait",
            "name": "portrait",
            "groupId": "image",
            "ligature": "portrait",
            "codepoint": "E416"
        }, {
            "iconId": "remove_red_eye",
            "name": "remove red eye",
            "groupId": "image",
            "ligature": "remove_red_eye",
            "codepoint": "E417"
        }, {
            "iconId": "rotate_90_degrees_ccw",
            "name": "rotate 90 degrees ccw",
            "groupId": "image",
            "ligature": "rotate_90_degrees_ccw",
            "codepoint": "E418"
        }, {
            "iconId": "rotate_left",
            "name": "rotate left",
            "groupId": "image",
            "ligature": "rotate_left",
            "codepoint": "E419"
        }, {
            "iconId": "rotate_right",
            "name": "rotate right",
            "groupId": "image",
            "ligature": "rotate_right",
            "codepoint": "E41A"
        }, {
            "iconId": "slideshow",
            "name": "slideshow",
            "groupId": "image",
            "ligature": "slideshow",
            "codepoint": "E41B"
        }, {
            "iconId": "straighten",
            "name": "straighten",
            "groupId": "image",
            "ligature": "straighten",
            "codepoint": "E41C"
        }, {
            "iconId": "style",
            "name": "style",
            "groupId": "image",
            "ligature": "style",
            "codepoint": "E41D"
        }, {
            "iconId": "switch_camera",
            "name": "switch camera",
            "groupId": "image",
            "ligature": "switch_camera",
            "codepoint": "E41E"
        }, {
            "iconId": "switch_video",
            "name": "switch video",
            "groupId": "image",
            "ligature": "switch_video",
            "codepoint": "E41F"
        }, {
            "iconId": "tag_faces",
            "name": "tag faces",
            "groupId": "image",
            "ligature": "tag_faces",
            "codepoint": "E420"
        }, {
            "iconId": "texture",
            "name": "texture",
            "groupId": "image",
            "ligature": "texture",
            "codepoint": "E421"
        }, {
            "iconId": "timelapse",
            "name": "timelapse",
            "groupId": "image",
            "ligature": "timelapse",
            "codepoint": "E422"
        }, {
            "iconId": "timer",
            "name": "timer",
            "groupId": "image",
            "ligature": "timer",
            "codepoint": "E425"
        }, {
            "iconId": "timer_10",
            "name": "timer 10",
            "groupId": "image",
            "ligature": "timer_10",
            "codepoint": "E423"
        }, {
            "iconId": "timer_3",
            "name": "timer 3",
            "groupId": "image",
            "ligature": "timer_3",
            "codepoint": "E424"
        }, {
            "iconId": "timer_off",
            "name": "timer off",
            "groupId": "image",
            "ligature": "timer_off",
            "codepoint": "E426"
        }, {
            "iconId": "tonality",
            "name": "tonality",
            "groupId": "image",
            "ligature": "tonality",
            "codepoint": "E427"
        }, {
            "iconId": "transform",
            "name": "transform",
            "groupId": "image",
            "ligature": "transform",
            "codepoint": "E428"
        }, {
            "iconId": "tune",
            "name": "tune",
            "groupId": "image",
            "ligature": "tune",
            "codepoint": "E429"
        }, {
            "iconId": "view_comfy",
            "name": "view comfy",
            "groupId": "image",
            "ligature": "view_comfy",
            "codepoint": "E42A"
        }, {
            "iconId": "view_compact",
            "name": "view compact",
            "groupId": "image",
            "ligature": "view_compact",
            "codepoint": "E42B"
        }, {
            "iconId": "vignette",
            "name": "vignette",
            "groupId": "image",
            "ligature": "vignette",
            "codepoint": "E435"
        }, {
            "iconId": "wb_auto",
            "name": "wb auto",
            "groupId": "image",
            "ligature": "wb_auto",
            "codepoint": "E42C"
        }, {
            "iconId": "wb_cloudy",
            "name": "wb cloudy",
            "groupId": "image",
            "ligature": "wb_cloudy",
            "codepoint": "E42D"
        }, {
            "iconId": "wb_incandescent",
            "name": "wb incandescent",
            "groupId": "image",
            "ligature": "wb_incandescent",
            "codepoint": "E42E"
        }, {
            "iconId": "wb_iridescent",
            "name": "wb iridescent",
            "groupId": "image",
            "ligature": "wb_iridescent",
            "codepoint": "E436"
        }, {
            "iconId": "wb_sunny",
            "name": "wb sunny",
            "groupId": "image",
            "ligature": "wb_sunny",
            "codepoint": "E430"
        }, {
            "iconId": "add_location",
            "name": "add location",
            "groupId": "maps",
            "ligature": "add_location",
            "codepoint": "E567"
        }, {
            "iconId": "beenhere",
            "name": "beenhere",
            "groupId": "maps",
            "ligature": "beenhere",
            "codepoint": "E52D"
        }, {
            "iconId": "directions",
            "name": "directions",
            "groupId": "maps",
            "ligature": "directions",
            "codepoint": "E52E"
        }, {
            "iconId": "directions_bike",
            "name": "directions bike",
            "groupId": "maps",
            "ligature": "directions_bike",
            "codepoint": "E52F"
        }, {
            "iconId": "directions_boat",
            "name": "directions boat",
            "groupId": "maps",
            "ligature": "directions_boat",
            "codepoint": "E532"
        }, {
            "iconId": "directions_bus",
            "name": "directions bus",
            "groupId": "maps",
            "ligature": "directions_bus",
            "codepoint": "E530"
        }, {
            "iconId": "directions_car",
            "name": "directions car",
            "groupId": "maps",
            "ligature": "directions_car",
            "codepoint": "E531"
        }, {
            "iconId": "directions_railway",
            "name": "directions railway",
            "groupId": "maps",
            "ligature": "directions_railway",
            "codepoint": "E534"
        }, {
            "iconId": "directions_run",
            "name": "directions run",
            "groupId": "maps",
            "ligature": "directions_run",
            "codepoint": "E566"
        }, {
            "iconId": "directions_subway",
            "name": "directions subway",
            "groupId": "maps",
            "ligature": "directions_subway",
            "codepoint": "E533"
        }, {
            "iconId": "directions_transit",
            "name": "directions transit",
            "groupId": "maps",
            "ligature": "directions_transit",
            "codepoint": "E535"
        }, {
            "iconId": "directions_walk",
            "name": "directions walk",
            "groupId": "maps",
            "ligature": "directions_walk",
            "codepoint": "E536"
        }, {
            "iconId": "edit_location",
            "name": "edit location",
            "groupId": "maps",
            "ligature": "edit_location",
            "codepoint": "E568"
        }, {
            "iconId": "ev_station",
            "name": "ev station",
            "groupId": "maps",
            "ligature": "ev_station",
            "codepoint": "E56D"
        }, {
            "iconId": "flight",
            "name": "flight",
            "groupId": "maps",
            "ligature": "flight",
            "codepoint": "E539"
        }, {
            "iconId": "hotel",
            "name": "hotel",
            "groupId": "maps",
            "ligature": "hotel",
            "codepoint": "E53A"
        }, {
            "iconId": "layers",
            "name": "layers",
            "groupId": "maps",
            "ligature": "layers",
            "codepoint": "E53B"
        }, {
            "iconId": "layers_clear",
            "name": "layers clear",
            "groupId": "maps",
            "ligature": "layers_clear",
            "codepoint": "E53C"
        }, {
            "iconId": "local_activity",
            "name": "local activity",
            "groupId": "maps",
            "ligature": "local_activity",
            "codepoint": "E53F"
        }, {
            "iconId": "local_airport",
            "name": "local airport",
            "groupId": "maps",
            "ligature": "local_airport",
            "codepoint": "E53D"
        }, {
            "iconId": "local_atm",
            "name": "local atm",
            "groupId": "maps",
            "ligature": "local_atm",
            "codepoint": "E53E"
        }, {
            "iconId": "local_bar",
            "name": "local bar",
            "groupId": "maps",
            "ligature": "local_bar",
            "codepoint": "E540"
        }, {
            "iconId": "local_cafe",
            "name": "local cafe",
            "groupId": "maps",
            "ligature": "local_cafe",
            "codepoint": "E541"
        }, {
            "iconId": "local_car_wash",
            "name": "local car wash",
            "groupId": "maps",
            "ligature": "local_car_wash",
            "codepoint": "E542"
        }, {
            "iconId": "local_convenience_store",
            "name": "local convenience store",
            "groupId": "maps",
            "ligature": "local_convenience_store",
            "codepoint": "E543"
        }, {
            "iconId": "local_dining",
            "name": "local dining",
            "groupId": "maps",
            "ligature": "local_dining",
            "codepoint": "E556"
        }, {
            "iconId": "local_drink",
            "name": "local drink",
            "groupId": "maps",
            "ligature": "local_drink",
            "codepoint": "E544"
        }, {
            "iconId": "local_florist",
            "name": "local florist",
            "groupId": "maps",
            "ligature": "local_florist",
            "codepoint": "E545"
        }, {
            "iconId": "local_gas_station",
            "name": "local gas station",
            "groupId": "maps",
            "ligature": "local_gas_station",
            "codepoint": "E546"
        }, {
            "iconId": "local_grocery_store",
            "name": "local grocery store",
            "groupId": "maps",
            "ligature": "local_grocery_store",
            "codepoint": "E547"
        }, {
            "iconId": "local_hospital",
            "name": "local hospital",
            "groupId": "maps",
            "ligature": "local_hospital",
            "codepoint": "E548"
        }, {
            "iconId": "local_hotel",
            "name": "local hotel",
            "groupId": "maps",
            "ligature": "local_hotel",
            "codepoint": "E549"
        }, {
            "iconId": "local_laundry_service",
            "name": "local laundry service",
            "groupId": "maps",
            "ligature": "local_laundry_service",
            "codepoint": "E54A"
        }, {
            "iconId": "local_library",
            "name": "local library",
            "groupId": "maps",
            "ligature": "local_library",
            "codepoint": "E54B"
        }, {
            "iconId": "local_mall",
            "name": "local mall",
            "groupId": "maps",
            "ligature": "local_mall",
            "codepoint": "E54C"
        }, {
            "iconId": "local_movies",
            "name": "local movies",
            "groupId": "maps",
            "ligature": "local_movies",
            "codepoint": "E54D"
        }, {
            "iconId": "local_offer",
            "name": "local offer",
            "groupId": "maps",
            "ligature": "local_offer",
            "codepoint": "E54E"
        }, {
            "iconId": "local_parking",
            "name": "local parking",
            "groupId": "maps",
            "ligature": "local_parking",
            "codepoint": "E54F"
        }, {
            "iconId": "local_pharmacy",
            "name": "local pharmacy",
            "groupId": "maps",
            "ligature": "local_pharmacy",
            "codepoint": "E550"
        }, {
            "iconId": "local_phone",
            "name": "local phone",
            "groupId": "maps",
            "ligature": "local_phone",
            "codepoint": "E551"
        }, {
            "iconId": "local_pizza",
            "name": "local pizza",
            "groupId": "maps",
            "ligature": "local_pizza",
            "codepoint": "E552"
        }, {
            "iconId": "local_play",
            "name": "local play",
            "groupId": "maps",
            "ligature": "local_play",
            "codepoint": "E553"
        }, {
            "iconId": "local_post_office",
            "name": "local post office",
            "groupId": "maps",
            "ligature": "local_post_office",
            "codepoint": "E554"
        }, {
            "iconId": "local_printshop",
            "name": "local printshop",
            "groupId": "maps",
            "ligature": "local_printshop",
            "codepoint": "E555"
        }, {
            "iconId": "local_see",
            "name": "local see",
            "groupId": "maps",
            "ligature": "local_see",
            "codepoint": "E557"
        }, {
            "iconId": "local_shipping",
            "name": "local shipping",
            "groupId": "maps",
            "ligature": "local_shipping",
            "codepoint": "E558"
        }, {
            "iconId": "local_taxi",
            "name": "local taxi",
            "groupId": "maps",
            "ligature": "local_taxi",
            "codepoint": "E559"
        }, {
            "iconId": "map",
            "name": "map",
            "groupId": "maps",
            "ligature": "map",
            "codepoint": "E55B"
        }, {
            "iconId": "my_location",
            "name": "my location",
            "groupId": "maps",
            "ligature": "my_location",
            "codepoint": "E55C"
        }, {
            "iconId": "navigation",
            "name": "navigation",
            "groupId": "maps",
            "ligature": "navigation",
            "codepoint": "E55D"
        }, {
            "iconId": "near_me",
            "name": "near me",
            "groupId": "maps",
            "ligature": "near_me",
            "codepoint": "E569"
        }, {
            "iconId": "person_pin",
            "name": "person pin",
            "groupId": "maps",
            "ligature": "person_pin",
            "codepoint": "E55A"
        }, {
            "iconId": "person_pin_circle",
            "name": "person pin circle",
            "groupId": "maps",
            "ligature": "person_pin_circle",
            "codepoint": "E56A"
        }, {
            "iconId": "pin_drop",
            "name": "pin drop",
            "groupId": "maps",
            "ligature": "pin_drop",
            "codepoint": "E55E"
        }, {
            "iconId": "place",
            "name": "place",
            "groupId": "maps",
            "ligature": "place",
            "codepoint": "E55F"
        }, {
            "iconId": "rate_review",
            "name": "rate review",
            "groupId": "maps",
            "ligature": "rate_review",
            "codepoint": "E560"
        }, {
            "iconId": "restaurant",
            "name": "restaurant",
            "groupId": "maps",
            "ligature": "restaurant",
            "codepoint": "E56C"
        }, {
            "iconId": "restaurant_menu",
            "name": "restaurant menu",
            "groupId": "maps",
            "ligature": "restaurant_menu",
            "codepoint": "E561"
        }, {
            "iconId": "satellite",
            "name": "satellite",
            "groupId": "maps",
            "ligature": "satellite",
            "codepoint": "E562"
        }, {
            "iconId": "store_mall_directory",
            "name": "store mall directory",
            "groupId": "maps",
            "ligature": "store_mall_directory",
            "codepoint": "E563"
        }, {
            "iconId": "streetview",
            "name": "streetview",
            "groupId": "maps",
            "ligature": "streetview",
            "codepoint": "E56E"
        }, {
            "iconId": "subway",
            "name": "subway",
            "groupId": "maps",
            "ligature": "subway",
            "codepoint": "E56F"
        }, {
            "iconId": "terrain",
            "name": "terrain",
            "groupId": "maps",
            "ligature": "terrain",
            "codepoint": "E564"
        }, {
            "iconId": "traffic",
            "name": "traffic",
            "groupId": "maps",
            "ligature": "traffic",
            "codepoint": "E565"
        }, {
            "iconId": "train",
            "name": "train",
            "groupId": "maps",
            "ligature": "train",
            "codepoint": "E570"
        }, {
            "iconId": "tram",
            "name": "tram",
            "groupId": "maps",
            "ligature": "tram",
            "codepoint": "E571"
        }, {
            "iconId": "transfer_within_a_station",
            "name": "transfer within a station",
            "groupId": "maps",
            "ligature": "transfer_within_a_station",
            "codepoint": "E572"
        }, {
            "iconId": "zoom_out_map",
            "name": "zoom out map",
            "groupId": "maps",
            "ligature": "zoom_out_map",
            "codepoint": "E56B"
        }, {
            "iconId": "apps",
            "name": "apps",
            "groupId": "navigation",
            "ligature": "apps",
            "codepoint": "E5C3"
        }, {
            "iconId": "arrow_back",
            "name": "arrow back",
            "groupId": "navigation",
            "ligature": "arrow_back",
            "codepoint": "E5C4"
        }, {
            "iconId": "arrow_downward",
            "name": "arrow downward",
            "groupId": "navigation",
            "ligature": "arrow_downward",
            "codepoint": "E5DB"
        }, {
            "iconId": "arrow_drop_down",
            "name": "arrow drop down",
            "groupId": "navigation",
            "ligature": "arrow_drop_down",
            "codepoint": "E5C5"
        }, {
            "iconId": "arrow_drop_down_circle",
            "name": "arrow drop down circle",
            "groupId": "navigation",
            "ligature": "arrow_drop_down_circle",
            "codepoint": "E5C6"
        }, {
            "iconId": "arrow_drop_up",
            "name": "arrow drop up",
            "groupId": "navigation",
            "ligature": "arrow_drop_up",
            "codepoint": "E5C7"
        }, {
            "iconId": "arrow_forward",
            "name": "arrow forward",
            "groupId": "navigation",
            "ligature": "arrow_forward",
            "codepoint": "E5C8"
        }, {
            "iconId": "arrow_upward",
            "name": "arrow upward",
            "groupId": "navigation",
            "ligature": "arrow_upward",
            "codepoint": "E5D8"
        }, {
            "iconId": "cancel",
            "name": "cancel",
            "groupId": "navigation",
            "ligature": "cancel",
            "codepoint": "E5C9"
        }, {
            "iconId": "check",
            "name": "check",
            "groupId": "navigation",
            "ligature": "check",
            "codepoint": "E5CA"
        }, {
            "iconId": "chevron_left",
            "name": "chevron left",
            "groupId": "navigation",
            "ligature": "chevron_left",
            "codepoint": "E5CB"
        }, {
            "iconId": "chevron_right",
            "name": "chevron right",
            "groupId": "navigation",
            "ligature": "chevron_right",
            "codepoint": "E5CC"
        }, {
            "iconId": "close",
            "name": "close",
            "groupId": "navigation",
            "ligature": "close",
            "codepoint": "E5CD"
        }, {
            "iconId": "expand_less",
            "name": "expand less",
            "groupId": "navigation",
            "ligature": "expand_less",
            "codepoint": "E5CE"
        }, {
            "iconId": "expand_more",
            "name": "expand more",
            "groupId": "navigation",
            "ligature": "expand_more",
            "codepoint": "E5CF"
        }, {
            "iconId": "first_page",
            "name": "first page",
            "groupId": "navigation",
            "ligature": "first_page",
            "codepoint": "E5DC"
        }, {
            "iconId": "fullscreen",
            "name": "fullscreen",
            "groupId": "navigation",
            "ligature": "fullscreen",
            "codepoint": "E5D0"
        }, {
            "iconId": "fullscreen_exit",
            "name": "fullscreen exit",
            "groupId": "navigation",
            "ligature": "fullscreen_exit",
            "codepoint": "E5D1"
        }, {
            "iconId": "last_page",
            "name": "last page",
            "groupId": "navigation",
            "ligature": "last_page",
            "codepoint": "E5DD"
        }, {
            "iconId": "menu",
            "name": "menu",
            "groupId": "navigation",
            "ligature": "menu",
            "codepoint": "E5D2"
        }, {
            "iconId": "more_horiz",
            "name": "more horiz",
            "groupId": "navigation",
            "ligature": "more_horiz",
            "codepoint": "E5D3"
        }, {
            "iconId": "more_vert",
            "name": "more vert",
            "groupId": "navigation",
            "ligature": "more_vert",
            "codepoint": "E5D4"
        }, {
            "iconId": "refresh",
            "name": "refresh",
            "groupId": "navigation",
            "ligature": "refresh",
            "codepoint": "E5D5"
        }, {
            "iconId": "subdirectory_arrow_left",
            "name": "subdirectory arrow left",
            "groupId": "navigation",
            "ligature": "subdirectory_arrow_left",
            "codepoint": "E5D9"
        }, {
            "iconId": "subdirectory_arrow_right",
            "name": "subdirectory arrow right",
            "groupId": "navigation",
            "ligature": "subdirectory_arrow_right",
            "codepoint": "E5DA"
        }, {
            "iconId": "adb",
            "name": "adb",
            "groupId": "notification",
            "ligature": "adb",
            "codepoint": "E60E"
        }, {
            "iconId": "airline_seat_flat",
            "name": "airline seat flat",
            "groupId": "notification",
            "ligature": "airline_seat_flat",
            "codepoint": "E630"
        }, {
            "iconId": "airline_seat_flat_angled",
            "name": "airline seat flat angled",
            "groupId": "notification",
            "ligature": "airline_seat_flat_angled",
            "codepoint": "E631"
        }, {
            "iconId": "airline_seat_individual_suite",
            "name": "airline seat individual suite",
            "groupId": "notification",
            "ligature": "airline_seat_individual_suite",
            "codepoint": "E632"
        }, {
            "iconId": "airline_seat_legroom_extra",
            "name": "airline seat legroom extra",
            "groupId": "notification",
            "ligature": "airline_seat_legroom_extra",
            "codepoint": "E633"
        }, {
            "iconId": "airline_seat_legroom_normal",
            "name": "airline seat legroom normal",
            "groupId": "notification",
            "ligature": "airline_seat_legroom_normal",
            "codepoint": "E634"
        }, {
            "iconId": "airline_seat_legroom_reduced",
            "name": "airline seat legroom reduced",
            "groupId": "notification",
            "ligature": "airline_seat_legroom_reduced",
            "codepoint": "E635"
        }, {
            "iconId": "airline_seat_recline_extra",
            "name": "airline seat recline extra",
            "groupId": "notification",
            "ligature": "airline_seat_recline_extra",
            "codepoint": "E636"
        }, {
            "iconId": "airline_seat_recline_normal",
            "name": "airline seat recline normal",
            "groupId": "notification",
            "ligature": "airline_seat_recline_normal",
            "codepoint": "E637"
        }, {
            "iconId": "bluetooth_audio",
            "name": "bluetooth audio",
            "groupId": "notification",
            "ligature": "bluetooth_audio",
            "codepoint": "E60F"
        }, {
            "iconId": "confirmation_number",
            "name": "confirmation number",
            "groupId": "notification",
            "ligature": "confirmation_number",
            "codepoint": "E638"
        }, {
            "iconId": "disc_full",
            "name": "disc full",
            "groupId": "notification",
            "ligature": "disc_full",
            "codepoint": "E610"
        }, {
            "iconId": "do_not_disturb",
            "name": "do not disturb",
            "groupId": "notification",
            "ligature": "do_not_disturb",
            "codepoint": "E612"
        }, {
            "iconId": "do_not_disturb_alt",
            "name": "do not disturb alt",
            "groupId": "notification",
            "ligature": "do_not_disturb_alt",
            "codepoint": "E611"
        }, {
            "iconId": "do_not_disturb_off",
            "name": "do not disturb off",
            "groupId": "notification",
            "ligature": "do_not_disturb_off",
            "codepoint": "E643"
        }, {
            "iconId": "do_not_disturb_on",
            "name": "do not disturb on",
            "groupId": "notification",
            "ligature": "do_not_disturb_on",
            "codepoint": "E644"
        }, {
            "iconId": "drive_eta",
            "name": "drive eta",
            "groupId": "notification",
            "ligature": "drive_eta",
            "codepoint": "E613"
        }, {
            "iconId": "enhanced_encryption",
            "name": "enhanced encryption",
            "groupId": "notification",
            "ligature": "enhanced_encryption",
            "codepoint": "E63F"
        }, {
            "iconId": "event_available",
            "name": "event available",
            "groupId": "notification",
            "ligature": "event_available",
            "codepoint": "E614"
        }, {
            "iconId": "event_busy",
            "name": "event busy",
            "groupId": "notification",
            "ligature": "event_busy",
            "codepoint": "E615"
        }, {
            "iconId": "event_note",
            "name": "event note",
            "groupId": "notification",
            "ligature": "event_note",
            "codepoint": "E616"
        }, {
            "iconId": "folder_special",
            "name": "folder special",
            "groupId": "notification",
            "ligature": "folder_special",
            "codepoint": "E617"
        }, {
            "iconId": "live_tv",
            "name": "live tv",
            "groupId": "notification",
            "ligature": "live_tv",
            "codepoint": "E639"
        }, {
            "iconId": "mms",
            "name": "mms",
            "groupId": "notification",
            "ligature": "mms",
            "codepoint": "E618"
        }, {
            "iconId": "more",
            "name": "more",
            "groupId": "notification",
            "ligature": "more",
            "codepoint": "E619"
        }, {
            "iconId": "network_check",
            "name": "network check",
            "groupId": "notification",
            "ligature": "network_check",
            "codepoint": "E640"
        }, {
            "iconId": "network_locked",
            "name": "network locked",
            "groupId": "notification",
            "ligature": "network_locked",
            "codepoint": "E61A"
        }, {
            "iconId": "no_encryption",
            "name": "no encryption",
            "groupId": "notification",
            "ligature": "no_encryption",
            "codepoint": "E641"
        }, {
            "iconId": "ondemand_video",
            "name": "ondemand video",
            "groupId": "notification",
            "ligature": "ondemand_video",
            "codepoint": "E63A"
        }, {
            "iconId": "personal_video",
            "name": "personal video",
            "groupId": "notification",
            "ligature": "personal_video",
            "codepoint": "E63B"
        }, {
            "iconId": "phone_bluetooth_speaker",
            "name": "phone bluetooth speaker",
            "groupId": "notification",
            "ligature": "phone_bluetooth_speaker",
            "codepoint": "E61B"
        }, {
            "iconId": "phone_forwarded",
            "name": "phone forwarded",
            "groupId": "notification",
            "ligature": "phone_forwarded",
            "codepoint": "E61C"
        }, {
            "iconId": "phone_in_talk",
            "name": "phone in talk",
            "groupId": "notification",
            "ligature": "phone_in_talk",
            "codepoint": "E61D"
        }, {
            "iconId": "phone_locked",
            "name": "phone locked",
            "groupId": "notification",
            "ligature": "phone_locked",
            "codepoint": "E61E"
        }, {
            "iconId": "phone_missed",
            "name": "phone missed",
            "groupId": "notification",
            "ligature": "phone_missed",
            "codepoint": "E61F"
        }, {
            "iconId": "phone_paused",
            "name": "phone paused",
            "groupId": "notification",
            "ligature": "phone_paused",
            "codepoint": "E620"
        }, {
            "iconId": "power",
            "name": "power",
            "groupId": "notification",
            "ligature": "power",
            "codepoint": "E63C"
        }, {
            "iconId": "priority_high",
            "name": "priority high",
            "groupId": "notification",
            "ligature": "priority_high",
            "codepoint": "E645"
        }, {
            "iconId": "sd_card",
            "name": "sd card",
            "groupId": "notification",
            "ligature": "sd_card",
            "codepoint": "E623"
        }, {
            "iconId": "sim_card_alert",
            "name": "sim card alert",
            "groupId": "notification",
            "ligature": "sim_card_alert",
            "codepoint": "E624"
        }, {
            "iconId": "sms",
            "name": "sms",
            "groupId": "notification",
            "ligature": "sms",
            "codepoint": "E625"
        }, {
            "iconId": "sms_failed",
            "name": "sms failed",
            "groupId": "notification",
            "ligature": "sms_failed",
            "codepoint": "E626"
        }, {
            "iconId": "sync",
            "name": "sync",
            "groupId": "notification",
            "ligature": "sync",
            "codepoint": "E627"
        }, {
            "iconId": "sync_disabled",
            "name": "sync disabled",
            "groupId": "notification",
            "ligature": "sync_disabled",
            "codepoint": "E628"
        }, {
            "iconId": "sync_problem",
            "name": "sync problem",
            "groupId": "notification",
            "ligature": "sync_problem",
            "codepoint": "E629"
        }, {
            "iconId": "system_update",
            "name": "system update",
            "groupId": "notification",
            "ligature": "system_update",
            "codepoint": "E62A"
        }, {
            "iconId": "tap_and_play",
            "name": "tap and play",
            "groupId": "notification",
            "ligature": "tap_and_play",
            "codepoint": "E62B"
        }, {
            "iconId": "time_to_leave",
            "name": "time to leave",
            "groupId": "notification",
            "ligature": "time_to_leave",
            "codepoint": "E62C"
        }, {
            "iconId": "vibration",
            "name": "vibration",
            "groupId": "notification",
            "ligature": "vibration",
            "codepoint": "E62D"
        }, {
            "iconId": "voice_chat",
            "name": "voice chat",
            "groupId": "notification",
            "ligature": "voice_chat",
            "codepoint": "E62E"
        }, {
            "iconId": "vpn_lock",
            "name": "vpn lock",
            "groupId": "notification",
            "ligature": "vpn_lock",
            "codepoint": "E62F"
        }, {
            "iconId": "wc",
            "name": "wc",
            "groupId": "notification",
            "ligature": "wc",
            "codepoint": "E63D"
        }, {
            "iconId": "wifi",
            "name": "wifi",
            "groupId": "notification",
            "ligature": "wifi",
            "codepoint": "E63E"
        }, {
            "iconId": "ac_unit",
            "name": "ac unit",
            "groupId": "places",
            "ligature": "ac_unit",
            "codepoint": "EB3B"
        }, {
            "iconId": "airport_shuttle",
            "name": "airport shuttle",
            "groupId": "places",
            "ligature": "airport_shuttle",
            "codepoint": "EB3C"
        }, {
            "iconId": "all_inclusive",
            "name": "all inclusive",
            "groupId": "places",
            "ligature": "all_inclusive",
            "codepoint": "EB3D"
        }, {
            "iconId": "beach_access",
            "name": "beach access",
            "groupId": "places",
            "ligature": "beach_access",
            "codepoint": "EB3E"
        }, {
            "iconId": "business_center",
            "name": "business center",
            "groupId": "places",
            "ligature": "business_center",
            "codepoint": "EB3F"
        }, {
            "iconId": "casino",
            "name": "casino",
            "groupId": "places",
            "ligature": "casino",
            "codepoint": "EB40"
        }, {
            "iconId": "child_care",
            "name": "child care",
            "groupId": "places",
            "ligature": "child_care",
            "codepoint": "EB41"
        }, {
            "iconId": "child_friendly",
            "name": "child friendly",
            "groupId": "places",
            "ligature": "child_friendly",
            "codepoint": "EB42"
        }, {
            "iconId": "fitness_center",
            "name": "fitness center",
            "groupId": "places",
            "ligature": "fitness_center",
            "codepoint": "EB43"
        }, {
            "iconId": "free_breakfast",
            "name": "free breakfast",
            "groupId": "places",
            "ligature": "free_breakfast",
            "codepoint": "EB44"
        }, {
            "iconId": "golf_course",
            "name": "golf course",
            "groupId": "places",
            "ligature": "golf_course",
            "codepoint": "EB45"
        }, {
            "iconId": "hot_tub",
            "name": "hot tub",
            "groupId": "places",
            "ligature": "hot_tub",
            "codepoint": "EB46"
        }, {
            "iconId": "kitchen",
            "name": "kitchen",
            "groupId": "places",
            "ligature": "kitchen",
            "codepoint": "EB47"
        }, {
            "iconId": "pool",
            "name": "pool",
            "groupId": "places",
            "ligature": "pool",
            "codepoint": "EB48"
        }, {
            "iconId": "room_service",
            "name": "room service",
            "groupId": "places",
            "ligature": "room_service",
            "codepoint": "EB49"
        }, {
            "iconId": "rv_hookup",
            "name": "rv hookup",
            "groupId": "places",
            "ligature": "rv_hookup",
            "codepoint": "E642"
        }, {
            "iconId": "smoke_free",
            "name": "smoke free",
            "groupId": "places",
            "ligature": "smoke_free",
            "codepoint": "EB4A"
        }, {
            "iconId": "smoking_rooms",
            "name": "smoking rooms",
            "groupId": "places",
            "ligature": "smoking_rooms",
            "codepoint": "EB4B"
        }, {
            "iconId": "spa",
            "name": "spa",
            "groupId": "places",
            "ligature": "spa",
            "codepoint": "EB4C"
        }, {
            "iconId": "cake",
            "name": "cake",
            "groupId": "social",
            "ligature": "cake",
            "codepoint": "E7E9"
        }, {
            "iconId": "domain",
            "name": "domain",
            "groupId": "social",
            "ligature": "domain",
            "codepoint": "E7EE"
        }, {
            "iconId": "group",
            "name": "group",
            "groupId": "social",
            "ligature": "group",
            "codepoint": "E7EF"
        }, {
            "iconId": "group_add",
            "name": "group add",
            "groupId": "social",
            "ligature": "group_add",
            "codepoint": "E7F0"
        }, {
            "iconId": "location_city",
            "name": "location city",
            "groupId": "social",
            "ligature": "location_city",
            "codepoint": "E7F1"
        }, {
            "iconId": "mood",
            "name": "mood",
            "groupId": "social",
            "ligature": "mood",
            "codepoint": "E7F2"
        }, {
            "iconId": "mood_bad",
            "name": "mood bad",
            "groupId": "social",
            "ligature": "mood_bad",
            "codepoint": "E7F3"
        }, {
            "iconId": "notifications",
            "name": "notifications",
            "groupId": "social",
            "ligature": "notifications",
            "codepoint": "E7F4"
        }, {
            "iconId": "notifications_active",
            "name": "notifications active",
            "groupId": "social",
            "ligature": "notifications_active",
            "codepoint": "E7F7"
        }, {
            "iconId": "notifications_none",
            "name": "notifications none",
            "groupId": "social",
            "ligature": "notifications_none",
            "codepoint": "E7F5"
        }, {
            "iconId": "notifications_off",
            "name": "notifications off",
            "groupId": "social",
            "ligature": "notifications_off",
            "codepoint": "E7F6"
        }, {
            "iconId": "notifications_paused",
            "name": "notifications paused",
            "groupId": "social",
            "ligature": "notifications_paused",
            "codepoint": "E7F8"
        }, {
            "iconId": "pages",
            "name": "pages",
            "groupId": "social",
            "ligature": "pages",
            "codepoint": "E7F9"
        }, {
            "iconId": "party_mode",
            "name": "party mode",
            "groupId": "social",
            "ligature": "party_mode",
            "codepoint": "E7FA"
        }, {
            "iconId": "people",
            "name": "people",
            "groupId": "social",
            "ligature": "people",
            "codepoint": "E7FB"
        }, {
            "iconId": "people_outline",
            "name": "people outline",
            "groupId": "social",
            "ligature": "people_outline",
            "codepoint": "E7FC"
        }, {
            "iconId": "person",
            "name": "person",
            "groupId": "social",
            "ligature": "person",
            "codepoint": "E7FD"
        }, {
            "iconId": "person_add",
            "name": "person add",
            "groupId": "social",
            "ligature": "person_add",
            "codepoint": "E7FE"
        }, {
            "iconId": "person_outline",
            "name": "person outline",
            "groupId": "social",
            "ligature": "person_outline",
            "codepoint": "E7FF"
        }, {
            "iconId": "plus_one",
            "name": "plus one",
            "groupId": "social",
            "ligature": "plus_one",
            "codepoint": "E800"
        }, {
            "iconId": "poll",
            "name": "poll",
            "groupId": "social",
            "ligature": "poll",
            "codepoint": "E801"
        }, {
            "iconId": "public",
            "name": "public",
            "groupId": "social",
            "ligature": "public",
            "codepoint": "E80B"
        }, {
            "iconId": "school",
            "name": "school",
            "groupId": "social",
            "ligature": "school",
            "codepoint": "E80C"
        }, {
            "iconId": "sentiment_dissatisfied",
            "name": "sentiment dissatisfied",
            "groupId": "social",
            "ligature": "sentiment_dissatisfied",
            "codepoint": "E811"
        }, {
            "iconId": "sentiment_neutral",
            "name": "sentiment neutral",
            "groupId": "social",
            "ligature": "sentiment_neutral",
            "codepoint": "E812"
        }, {
            "iconId": "sentiment_satisfied",
            "name": "sentiment satisfied",
            "groupId": "social",
            "ligature": "sentiment_satisfied",
            "codepoint": "E813"
        }, {
            "iconId": "sentiment_very_dissatisfied",
            "name": "sentiment very dissatisfied",
            "groupId": "social",
            "ligature": "sentiment_very_dissatisfied",
            "codepoint": "E814"
        }, {
            "iconId": "sentiment_very_satisfied",
            "name": "sentiment very satisfied",
            "groupId": "social",
            "ligature": "sentiment_very_satisfied",
            "codepoint": "E815"
        }, {
            "iconId": "share",
            "name": "share",
            "groupId": "social",
            "ligature": "share",
            "codepoint": "E80D"
        }, {
            "iconId": "whatshot",
            "name": "whatshot",
            "groupId": "social",
            "ligature": "whatshot",
            "codepoint": "E80E"
        }, {
            "iconId": "check_box",
            "name": "check box",
            "groupId": "toggle",
            "ligature": "check_box",
            "codepoint": "E834"
        }, {
            "iconId": "check_box_outline_blank",
            "name": "check box outline blank",
            "groupId": "toggle",
            "ligature": "check_box_outline_blank",
            "codepoint": "E835"
        }, {
            "iconId": "indeterminate_check_box",
            "name": "indeterminate check box",
            "groupId": "toggle",
            "ligature": "indeterminate_check_box",
            "codepoint": "E909"
        }, {
            "iconId": "radio_button_checked",
            "name": "radio button checked",
            "groupId": "toggle",
            "ligature": "radio_button_checked",
            "codepoint": "E837"
        }, {
            "iconId": "radio_button_unchecked",
            "name": "radio button unchecked",
            "groupId": "toggle",
            "ligature": "radio_button_unchecked",
            "codepoint": "E836"
        }, {
            "iconId": "star",
            "name": "star",
            "groupId": "toggle",
            "ligature": "star",
            "codepoint": "E838"
        }, {
            "iconId": "star_border",
            "name": "star border",
            "groupId": "toggle",
            "ligature": "star_border",
            "codepoint": "E83A"
        }, {
            "iconId": "star_half",
            "name": "star half",
            "groupId": "toggle",
            "ligature": "star_half",
            "codepoint": "E839"
        }],

        modelFromId: function modelFromId(iconId) {
            var icon = _.findWhere(this.icons, { iconId: iconId });

            return new ButtonIconModel(icon);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Class = __webpack_require__(26);
    var Configuration = __webpack_require__(27);

    var FontsDotComApi = Class.extend({
        /**
         * Returns all the fonts from Fonts.com available to the current company. The list is a
         * union of all the Fonts.com font projects that are associated with the current company's
         * authentication key.
         *
         * @returns {Promise<FontDescriptor[]>}
         */
        all: function all() {
            return this._get("fonts");
        },


        /**
         * Validates a Fonts.com authentication key.
         *
         * @param {String} authenticationKey Hexadicimal key, 121 characters long including dashes.
         * @returns {Promise<Boolean>}
         */
        validate: function validate(authenticationKey) {
            return this._get("validate", { authenticationKey: authenticationKey });
        },
        _get: function _get(urlPath, options) {
            var path = Configuration.adminApiBaseUrl + "/api/external/fontsdotcom/" + urlPath;
            return $.getJSON(path, options).then(function (response) {
                return response;
            });
        }
    });

    return new FontsDotComApi();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var $ = __webpack_require__(4);

    var _require = __webpack_require__(1),
        flatten = _require.flatten,
        map = _require.map;

    var Promise = __webpack_require__(21);
    var Preconditions = __webpack_require__(14);
    var Configuration = __webpack_require__(27);

    // Endpoints
    var KITS = "kits";
    var FAMILIES = "families";

    /**
     * Represents the <a href="https://typekit.com/docs/api/" target="_blank">Typekit API</a> - exposing the required endpoints.
     *
     * @class TypekitApi
     * @author Kim
     */
    return Class.extend({

        _apiToken: null,

        constructor: function constructor(apiToken) {
            this._apiToken = apiToken;
        },
        kits: function kits() {
            return this._get(KITS);
        },
        kit: function kit(kitID) {
            Preconditions.checkArgument(kitID);

            return this._get(KITS + "/" + kitID);
        },
        all: function all() {
            var _this = this;

            return this.kits().then(function (response) {
                return Promise.all(map(response.kits, function (kit) {
                    return _this.kit(kit.id);
                }));
            });
        },
        fonts: function fonts() {
            return this.all().then(function (responses) {
                var families = map(responses, function (response) {
                    return response.kit.families;
                });

                return flatten(families);
            });
        },


        /**
         * Fetches the font family information for the specified font name, i.e. the
         * <tt>slug</tt> name, e.g. <tt>"proxima-nova"</tt> and not <tt>"Proxima Nova"</tt>.
         *
         * @param  {String} slug The <tt>slug</tt> name, e.g. <tt>"proxima-nova"</tt> and not <tt>"Proxima Nova"</tt>.
         * @return {Promise}     A <tt>Promise</tt> that resolves with the font family information.
         */
        family: function family(slug) {
            Preconditions.checkArgument(slug);

            return this._get(FAMILIES + "/" + slug);
        },
        _get: function _get(path) {
            // TODO: Use backend proxy
            // TODO: Handle error response(s)

            // {
            //     "errors": ["The Typekit API is down for maintenance"]
            // }

            return $.getJSON(Configuration.adminApiBaseUrl + "/api/typekit/" + path, { token: this._apiToken }).then(function (response) {
                return response;
            });
        },
        toString: function toString() {
            return "TypekitApi[token: " + this._apiToken + "]";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(7),
        Collection = _require.Collection;

    var RestApi = __webpack_require__(29);
    var CustomFontModel = __webpack_require__(561);

    return Collection.extend({

        model: CustomFontModel,

        comparator: function comparator(model) {
            return -model.get("createdAt");
        },

        url: function url() {
            return RestApi.pathToCollection(RestApi.Collections.FONTS);
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractWidgetPropertiesView = __webpack_require__(63);
    var SizeAndPositionPropertiesView = __webpack_require__(70);
    var template = __webpack_require__(1783);

    /**
     * The properties view for a composite widget.
     *
     * @class CompositeWidgetPropertiesView
     * @constructor
     *
     * @cfg {CompositeWidgetModel} model The model for the composite widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("CompositeWidgetPropertiesView", {
        template: template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties"
        },

        onRender: function onRender() {
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                shouldExpandOnRender: true,
                hideSizeControls: true,
                hideRotation: true,
                widgetView: this.options.widgetView
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cross", function() { return Cross; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortIcon", function() { return SortIcon; });
/* harmony export (immutable) */ __webpack_exports__["default"] = C3ImageLibrary;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_ExpandMore__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_CloseRounded__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_CloseRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_CloseRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ImageLibrarySearchbar__ = __webpack_require__(2013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FolderComp__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_waypoint__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__UploadImage__ = __webpack_require__(2035);











var Configuration = __webpack_require__(27);
var Storage = __webpack_require__(34);
var fetchLimit = 20;
var useStyles = Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["s" /* makeStyles */])(function () { return ({
    accordion: {
        '&.MuiPaper-elevation1': {
            boxShadow: 'none'
        }
    },
    accordionSummary: {
        '&.MuiAccordionSummary-root': {
            minHeight: '3vh',
        },
        '& .MuiAccordionSummary-content': {
            margin: 0
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            margin: 0
        },
        '&.MuiAccordionSummary-root.Mui-expanded': {
            minHeight: '3vh'
        }
    },
    accordionContainer: {
        border: '1px solid #94A3B8',
        borderRadius: '4px',
        marginTop: '1vh',
        background: '#FFFFFF',
        boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
    },
    iconBtn: {
        padding: '0.3vh 0'
    },
    folderCompContainer: {
        height: 'auto',
        maxHeight: '23vh',
        overflow: 'auto',
        position: 'absolute',
        zIndex: 2,
        width: '100%',
        top: '4vh',
        border: '1px solid #94A3B8',
        borderRadius: '4px',
        boxShadow: '0px 10px 15px -3px rgba(16, 24, 40, 0.1), 0px 4px 6px -4px rgba(16, 24, 40, 0.1)',
        '& .MuiAccordionSummary-content.Mui-expanded:hover': {
            background: '#E9EBED',
        },
        '& .MuiAccordionSummary-content:hover': {
            background: '#E9EBED'
        }
    },
}); });
var Cross = function () { return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { d: "M12 4L4 12", stroke: "#64748B", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { d: "M4 4L12 12", stroke: "#64748B", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }))); };
var SortIcon = function () { return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { d: "M2 8H7.33333", stroke: "#64748B", strokeLinecap: "round", strokeLinejoin: "round" }),
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { d: "M2 4H10.6667", stroke: "#64748B", strokeLinecap: "round", strokeLinejoin: "round" }),
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { d: "M2 12H4.66667", stroke: "#64748B", strokeLinecap: "round", strokeLinejoin: "round" }),
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { d: "M12.6667 4V12", stroke: "#64748B", strokeLinecap: "round", strokeLinejoin: "round" }),
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", { d: "M15.3333 9.33334L12.6667 12L10 9.33334", stroke: "#64748B", strokeLinecap: "round", strokeLinejoin: "round" }))); };
function C3ImageLibrary(props) {
    var _this = this;
    var classes = useStyles();
    var _a = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(true), imageLibraryDialogOpen = _a[0], setImageLibraryDialogOpen = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])([]), imageList = _b[0], setImageList = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])([]), nestedFolder = _c[0], setNestedFolder = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(null), imageOffset = _d[0], setImageOffset = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])("modifiedAt"), sortBy = _e[0], setSortby = _e[1];
    var _f = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(props.folderPath || "/"), folderPath = _f[0], setFolderPath = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(null), anchorEl = _g[0], setAnchorEl = _g[1];
    var sortMenuOpen = Boolean(anchorEl);
    var _h = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(""), hoveredImage = _h[0], setHoveredImage = _h[1];
    var _j = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false), isLoadingNextImages = _j[0], setLoadingNextImages = _j[1];
    var _k = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(props.accordianTitle || "Select folder"), accordionTitle = _k[0], setAccordionTitle = _k[1];
    var _l = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false), expand = _l[0], setExpand = _l[1]; // for Accordion
    var _m = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false), sortAscending = _m[0], setSortAscending = _m[1]; //for sorting
    var _o = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(undefined), textSearchPrefix = _o[0], setTextSearchPrefix = _o[1];
    var _p = Object(__WEBPACK_IMPORTED_MODULE_4_react__["useState"])(false), onEnterClicked = _p[0], setOnEnterClicked = _p[1];
    Object(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
        if (onEnterClicked) {
            getImages(textSearchPrefix);
        }
    }, [onEnterClicked]);
    Object(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
        setImageList([]);
        getImages();
    }, [sortBy, folderPath]);
    Object(__WEBPACK_IMPORTED_MODULE_4_react__["useEffect"])(function () {
        getNestedFolders();
    }, []);
    var getImages = function (searchPrefix) {
        var token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
        fetch(Configuration.c3ApibaseUrl + "/v1/images?limit=" + fetchLimit + "&sortBy=" + sortBy + "&sortAscending=" + sortAscending + "&folderPath=" + folderPath + (imageOffset ? "&offset=" + imageOffset : "") + (searchPrefix ? "&searchPrefix=" + searchPrefix : ""), {
            headers: {
                Authorization: "Bearer " + token
            },
            method: "GET"
        })
            .then(function (res) { return res.json(); })
            .then(function (imageData) {
            setImageList(function (prev) { return prev.concat(imageData.imageDetailsList); });
            setImageOffset(imageData.nextOffset);
            setOnEnterClicked(false);
        })
            .catch(function (err) { return console.log(err); });
    };
    var getNestedFolders = function () {
        var token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
        fetch(Configuration.c3ApibaseUrl + "/v1/imageFoldersNested?limit=100&folderPath=/", {
            headers: {
                Authorization: "Bearer " + token
            },
            method: "GET"
        })
            .then(function (res) { return res.json(); })
            .then(function (nestedFolder) { return setNestedFolder(function (prev) { return prev.concat(nestedFolder.folderTree.subfolders); }); })
            .catch(function (err) { return console.log(err); });
    };
    var handleFolderClick = function (folderDetails) {
        var newPath = "" + folderDetails.folderPath + folderDetails.folderId;
        setImageOffset(null);
        setFolderPath(newPath);
        setAccordionTitle(folderDetails.name);
        setExpand(false);
    };
    var handleCloseOnAccordion = function (e) {
        e.stopPropagation();
        setFolderPath('/');
        setAccordionTitle("Select folder");
        setExpand(false);
    };
    var handleSortIconClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleSortIconClose = function () {
        setAnchorEl(null);
    };
    var handleSortChange = function (sortBy, datasortAscending) {
        setImageOffset(null);
        setSortAscending(datasortAscending);
        setSortby(sortBy);
        handleSortIconClose();
    };
    var handleSearch = function (searchPrefix) {
        setImageOffset(null);
        setImageList([]);
        setTextSearchPrefix(searchPrefix);
        setOnEnterClicked(true);
    };
    var loadNextImages = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
            if (!imageOffset || isLoadingNextImages) {
                return [2 /*return*/];
            }
            setLoadingNextImages(true);
            try {
                getImages();
            }
            catch (err) {
                console.error("Failed to fetch images", err);
            }
            setLoadingNextImages(false);
            return [2 /*return*/];
        });
    }); };
    var handleImageClick = function (imageModel) {
        props.handleImageClick(imageModel);
    };
    var dragStartHandler = function (event, imageModel, currentfolderPath, currentaccordianTitle) {
        var data = {
            type: "image",
            options: {
                imageID: imageModel.imageId,
                altText: imageModel.altText,
                height: imageModel.height,
                width: imageModel.width,
                originalImageHeight: imageModel.height,
                originalImageWidth: imageModel.width,
                src: imageModel.url,
            }
        };
        props.handleDragStart(currentfolderPath, currentaccordianTitle);
        event.dataTransfer.setData("Text", JSON.stringify(data));
    };
    var renderLoader = function () { return (
    /* @ts-ignore */
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["c" /* Box */], { style: { display: "flex", justifyContent: "center", marginBottom: "4px" } },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* CircularProgress */], { size: 25, color: "inherit" }))); };
    var renderSortMenu = function () { return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* IconButton */], { id: "sort-menu-button", style: { border: "1px solid #94A3B8", borderRadius: "2px", height: "3vh", width: "1.6vw", padding: 0 }, "aria-controls": sortMenuOpen ? 'sort-menu' : undefined, "aria-haspopup": "true", "aria-expanded": sortMenuOpen ? 'true' : undefined, onClick: handleSortIconClick },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(SortIcon, null)),
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["m" /* Menu */], { id: "basic-menu", anchorEl: anchorEl, open: sortMenuOpen, onClose: handleSortIconClose, MenuListProps: {
                'aria-labelledby': 'basic-button',
            } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["n" /* MenuItem */], { style: { fontSize: "14px", fontWeight: 700, opacity: 1 }, disabled: true, onClick: handleSortIconClose }, "Sort by"),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["n" /* MenuItem */], { style: { fontSize: "14px" }, selected: sortBy === "modifiedAt", onClick: function () { return handleSortChange("modifiedAt", false); } }, "Last updated"),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["n" /* MenuItem */], { style: { fontSize: "14px" }, selected: sortBy === "name", onClick: function () { return handleSortChange("name", true); } }, "Alphabetical")))); };
    var renderImageLibraryDialog = function () {
        return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { style: { background: "#FFFFFF", width: "100%", maxHeight: "76vh", padding: "8px", position: "absolute", zIndex: 1, left: 0, marginTop: "4px" } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { style: { display: "flex", justifyContent: "space-between", paddingBottom: "8px", borderBottom: "1px solid #E2E8F0" } },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { style: { fontSize: "16px", lineHeight: "14px", fontWeight: 400, color: "#475569" } }, "Images"),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["a" /* Button */], { style: { margin: 0, height: "1.7vh", minWidth: "1vw", lineHeight: "1.7vh", padding: 0 }, onClick: function () { return setImageLibraryDialogOpen(false); }, edge: "start" },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Cross, null))),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* Grid */], { container: true, wrap: "nowrap", direction: 'column' },
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: classes.accordionContainer },
                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* Accordion */], { expanded: expand, className: classes.accordion, onChange: function () { return setExpand(!expand); } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["b" /* AccordionSummary */], { className: classes.accordionSummary },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* Grid */], { container: true, justifyContent: "space-between", wrap: "nowrap", alignItems: "baseline" },
                                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { style: { color: '#64748B', fontWeight: 400, fontSize: '1.2rem' } }, accordionTitle),
                                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* Grid */], { item: true, alignItems: "center" },
                                    folderPath !== '/' ?
                                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* IconButton */], { style: { marginRight: "1vw" }, className: classes.iconBtn, onClick: handleCloseOnAccordion },
                                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_CloseRounded___default.a, null))
                                        : null,
                                    __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* IconButton */], { className: classes.iconBtn, onClick: function () { return setExpand(!expand); } },
                                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_ExpandMore___default.a, { fontSize: "large" }))))),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { className: classes.folderCompContainer },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FolderComp__["a" /* default */], { folderList: nestedFolder, handleOnFolderClick: handleFolderClick, parentFolderId: '' })))),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ImageLibrarySearchbar__["a" /* default */], { placeholder: "ex: experience name", handleSearch: handleSearch, fetchLimit: fetchLimit, sortBy: sortBy, folderPath: folderPath })),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* Grid */], { container: true, justifyContent: "space-between", alignItems: "center", style: { margin: '1vh 0px 0.5vh 0px' } },
                renderSortMenu(),
                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__UploadImage__["a" /* default */], { setImageList: setImageList, folderPath: folderPath })),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { style: { height: "60vh", overflow: "auto" } }, imageList.map(function (image, index) {
                if (index === imageList.length - 1) {
                    return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], { key: index },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_waypoint__["a" /* Waypoint */], { onEnter: function () { return loadNextImages(); } },
                            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { style: { position: "relative", width: "50%", display: "inline", cursor: "pointer" } },
                                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { key: image.imageId, id: image.imageId, src: image.url, style: { height: "9.13vh", width: "50%", padding: "4px 8px 4px 0" }, onMouseEnter: function () { return setHoveredImage(image.imageId); }, onMouseLeave: function () { return setHoveredImage(""); }, onClick: function () { return handleImageClick(image); }, onDragStart: function (e) { return dragStartHandler(e, image, folderPath, accordionTitle); } }),
                                __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { style: {
                                        display: hoveredImage === image.imageId ? "block" : "none",
                                        background: "linear-gradient(0deg, #363030 -45.83%, #3E39395D 63.54%, #423E3E00 100%)",
                                        width: "95%",
                                        paddingLeft: "4px",
                                        position: "absolute",
                                        textOverflow: "ellipsis",
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        color: "white",
                                        top: "3.13vh",
                                        left: 0
                                    }, onMouseEnter: function () { return setHoveredImage(image.imageId); } }, image.name))),
                        isLoadingNextImages && renderLoader()));
                }
                else {
                    return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { style: { position: "relative", width: "50%", display: "inline", cursor: "pointer" } },
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", { key: image.imageId, id: image.imageId, src: image.url, style: { height: "9.13vh", width: "50%", padding: "4px 8px 4px 0" }, onMouseEnter: function () { return setHoveredImage(image.imageId); }, onMouseLeave: function () { return setHoveredImage(""); }, onClick: function () { return handleImageClick(image); }, onDragStart: function (e) { return dragStartHandler(e, image, folderPath, accordionTitle); } }),
                        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", { style: {
                                display: hoveredImage === image.imageId ? "block" : "none",
                                background: "linear-gradient(0deg, #363030 -45.83%, #3E39395D 63.54%, #423E3E00 100%)",
                                width: "95%",
                                paddingLeft: "4px",
                                position: "absolute",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                color: "white",
                                top: "3.13vh",
                                left: 0
                            }, onMouseEnter: function () { return setHoveredImage(image.imageId); } }, image.name)));
                }
            }))));
    };
    return (__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", { style: { display: "flex", justifyContent: "space-between", fontWeight: 600 } },
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", null, "Creator Images"),
            __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["a" /* Button */], { style: { background: "#8A8A8A", height: "2.43vh", width: "5.27vw", color: "#FAFAFA", fontSize: "14px", lineHeight: "2.43vh", margin: 0 }, onClick: function () { return setImageLibraryDialogOpen(true); } }, "Library")),
        imageLibraryDialogOpen && renderImageLibraryDialog()));
}


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ __webpack_exports__["a"] = (common);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ __webpack_exports__["a"] = (red);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ __webpack_exports__["a"] = (pink);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ __webpack_exports__["a"] = (indigo);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* harmony default export */ __webpack_exports__["a"] = (blue);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* harmony default export */ __webpack_exports__["a"] = (green);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* harmony default export */ __webpack_exports__["a"] = (orange);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ __webpack_exports__["a"] = (grey);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keys; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end);

    if (endIndex === keys.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  var warnedOnce = false;

  function width(key) {
    if (false) {
      if (!warnedOnce) {
        warnedOnce = true;
        console.warn(["Material-UI: The `theme.breakpoints.width` utility is deprecated because it's redundant.", 'Use the `theme.breakpoints.values` instead.'].join('\n'));
      }
    }

    return values[key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__borders__ = __webpack_require__(890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__borders__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__(565);
/* unused harmony reexport breakpoints */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compose__ = __webpack_require__(158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__compose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styleFunctionSx__ = __webpack_require__(894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_3__styleFunctionSx__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__display__ = __webpack_require__(1821);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__display__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flexbox__ = __webpack_require__(895);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__flexbox__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__grid__ = __webpack_require__(896);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__grid__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__palette__ = __webpack_require__(897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__palette__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__positions__ = __webpack_require__(898);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__positions__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shadows__ = __webpack_require__(1822);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__shadows__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sizing__ = __webpack_require__(899);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__sizing__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__spacing__ = __webpack_require__(900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_11__spacing__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__spacing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__style__ = __webpack_require__(141);
/* unused harmony reexport style */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__typography__ = __webpack_require__(903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_13__typography__["a"]; });
/* unused harmony namespace reexport */
/** @license Material-UI v4.12.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
























/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export border */
/* unused harmony export borderTop */
/* unused harmony export borderRight */
/* unused harmony export borderBottom */
/* unused harmony export borderLeft */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(158);



function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return "".concat(value, "px solid");
}

var border = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
var borderTop = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
var borderRight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
var borderBottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
var borderLeft = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
var borderColor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderColor',
  themeKey: 'palette'
});
var borderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRadius',
  themeKey: 'shape'
});
var borders = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
/* harmony default export */ __webpack_exports__["a"] = (borders);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var responsivePropType =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
/* unused harmony default export */ var _unused_webpack_default_export = (responsivePropType);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export css */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__merge__ = __webpack_require__(410);






function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

var warnedOnce = false;

function styleFunctionSx(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" /* default */])(output, styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: props.theme
      }, props.css))), omit(props.css, [styleFunction.filterProps]));
    }

    if (props.sx) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" /* default */])(output, styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: props.theme
      }, props.sx))), omit(props.sx, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    css: chainPropTypes(PropTypes.object, function (props) {
      if (!warnedOnce && props.css !== undefined) {
        warnedOnce = true;
        return new Error('Material-UI: The `css` prop is deprecated, please use the `sx` prop instead.');
      }

      return null;
    }),
    sx: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['css', 'sx'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}
/**
 *
 * @deprecated
 * The css style function is deprecated. Use the `styleFunctionSx` instead.
 */


function css(styleFunction) {
  if (false) {
    console.warn('Material-UI: The `css` function is deprecated. Use the `styleFunctionSx` instead.');
  }

  return styleFunctionSx(styleFunction);
}
/* harmony default export */ __webpack_exports__["a"] = (styleFunctionSx);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export flexBasis */
/* unused harmony export flexDirection */
/* unused harmony export flexWrap */
/* unused harmony export justifyContent */
/* unused harmony export alignItems */
/* unused harmony export alignContent */
/* unused harmony export order */
/* unused harmony export flex */
/* unused harmony export flexGrow */
/* unused harmony export flexShrink */
/* unused harmony export alignSelf */
/* unused harmony export justifyItems */
/* unused harmony export justifySelf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(158);


var flexBasis = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexBasis'
});
var flexDirection = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexDirection'
});
var flexWrap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexWrap'
});
var justifyContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyContent'
});
var alignItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignItems'
});
var alignContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignContent'
});
var order = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'order'
});
var flex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flex'
});
var flexGrow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexGrow'
});
var flexShrink = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexShrink'
});
var alignSelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignSelf'
});
var justifyItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyItems'
});
var justifySelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifySelf'
});
var flexbox = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
/* harmony default export */ __webpack_exports__["a"] = (flexbox);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gridGap */
/* unused harmony export gridColumnGap */
/* unused harmony export gridRowGap */
/* unused harmony export gridColumn */
/* unused harmony export gridRow */
/* unused harmony export gridAutoFlow */
/* unused harmony export gridAutoColumns */
/* unused harmony export gridAutoRows */
/* unused harmony export gridTemplateColumns */
/* unused harmony export gridTemplateRows */
/* unused harmony export gridTemplateAreas */
/* unused harmony export gridArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(158);


var gridGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridGap'
});
var gridColumnGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridColumnGap'
});
var gridRowGap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridRowGap'
});
var gridColumn = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridColumn'
});
var gridRow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridRow'
});
var gridAutoFlow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoFlow'
});
var gridAutoColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoColumns'
});
var gridAutoRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridAutoRows'
});
var gridTemplateColumns = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateColumns'
});
var gridTemplateRows = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateRows'
});
var gridTemplateAreas = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridTemplateAreas'
});
var gridArea = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'gridArea'
});
var grid = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ __webpack_exports__["a"] = (grid);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export color */
/* unused harmony export bgcolor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(158);


var color = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'color',
  themeKey: 'palette'
});
var bgcolor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(color, bgcolor);
/* harmony default export */ __webpack_exports__["a"] = (palette);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export position */
/* unused harmony export zIndex */
/* unused harmony export top */
/* unused harmony export right */
/* unused harmony export bottom */
/* unused harmony export left */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(158);


var position = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'position'
});
var zIndex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
var top = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'top'
});
var right = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'right'
});
var bottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bottom'
});
var left = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'left'
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(position, zIndex, top, right, bottom, left));

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export width */
/* unused harmony export maxWidth */
/* unused harmony export minWidth */
/* unused harmony export height */
/* unused harmony export maxHeight */
/* unused harmony export minHeight */
/* unused harmony export sizeWidth */
/* unused harmony export sizeHeight */
/* unused harmony export boxSizing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(158);



function transform(value) {
  return value <= 1 ? "".concat(value * 100, "%") : value;
}

var width = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'width',
  transform: transform
});
var maxWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxWidth',
  transform: transform
});
var minWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minWidth',
  transform: transform
});
var height = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'height',
  transform: transform
});
var maxHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxHeight',
  transform: transform
});
var minHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minHeight',
  transform: transform
});
var sizeWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'width',
  transform: transform
});
var sizeHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'height',
  transform: transform
});
var boxSizing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'boxSizing'
});
var sizing = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* harmony default export */ __webpack_exports__["a"] = (sizing);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createUnarySpacing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memoize__ = __webpack_require__(1824);





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = Object(__WEBPACK_IMPORTED_MODULE_4__memoize__["a" /* default */])(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      if (false) {
        if (typeof abs !== 'number') {
          console.error("Material-UI: Expected spacing argument to be a number, got ".concat(abs, "."));
        }
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {
        if (abs > themeSpacing.length - 1) {
          console.error(["Material-UI: The value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {
    console.error(["Material-UI: The `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  }).reduce(__WEBPACK_IMPORTED_MODULE_3__merge__["a" /* default */], {});
}

spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ __webpack_exports__["b"] = (spacing);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fontFamily */
/* unused harmony export fontSize */
/* unused harmony export fontStyle */
/* unused harmony export fontWeight */
/* unused harmony export letterSpacing */
/* unused harmony export lineHeight */
/* unused harmony export textAlign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(158);


var fontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontFamily',
  themeKey: 'typography'
});
var fontSize = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontSize',
  themeKey: 'typography'
});
var fontStyle = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontStyle',
  themeKey: 'typography'
});
var fontWeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontWeight',
  themeKey: 'typography'
});
var letterSpacing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'letterSpacing'
});
var lineHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'lineHeight'
});
var textAlign = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textAlign'
});
var typography = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
/* harmony default export */ __webpack_exports__["a"] = (typography);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["a"] = (zIndex);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["a"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStyles__ = __webpack_require__(1828);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createStyles__["a"]; });


/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ThemeContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);

if (false) {
  ThemeContext.displayName = 'ThemeContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ThemeContext);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sheetsManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StylesContext; });
/* harmony export (immutable) */ __webpack_exports__["b"] = StylesProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jssPreset__ = __webpack_require__(568);







 // Default JSS instance.

var jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" /* create */])(Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__["a" /* default */])(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext(defaultOptions);

if (false) {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(StylesContext);

  var context = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (false) {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (false) {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" /* create */])({
      plugins: Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
/* harmony default export */ __webpack_exports__["a"] = (noopTheme);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServerStyleSheets__ = __webpack_require__(1847);
/* unused harmony reexport default */


/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled__ = __webpack_require__(1848);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__styled__["a"]; });


/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider__ = __webpack_require__(1849);
/* unused harmony reexport default */


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withStyles__ = __webpack_require__(1850);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withStyles__["a"]; });


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withTheme__ = __webpack_require__(916);
/* unused harmony reexport default */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withTheme__["a"]; });



/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withThemeCreator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(262);







function withThemeCreator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultTheme = options.defaultTheme;

  var withTheme = function withTheme(Component) {
    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var WithTheme = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithTheme(props, ref) {
      var innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["innerRef"]);

      var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: theme,
        ref: innerRef || ref
      }, other));
    });
     false ? WithTheme.propTypes = {
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return new Error('Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
      })
    } : void 0;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };

  return withTheme;
} // Provide the theme object as a prop to the input component.
// It's an alternative API to useTheme().
// We encourage the usage of useTheme() where possible.

var withTheme = withThemeCreator();
/* unused harmony default export */ var _unused_webpack_default_export = (withTheme);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(315);




var styled = function styled(Component) {
  var componentCreator = Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["e" /* styled */])(Component);
  return function (style, options) {
    return componentCreator(style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
    }, options));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (styled);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requirePropFactory;
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(902);




function _toArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  disabled: false
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeoutsShape */
/* unused harmony export classNamesShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__ = __webpack_require__(1863);









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["b" /* getInitialChildMapping */])(nextProps, handleExited) : Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["c" /* getNextChildMapping */])(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["a" /* getChildMapping */])(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
      value: contextValue
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, props, children));
  };

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (TransitionGroup);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var AccordionContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});

if (false) {
  AccordionContext.displayName = 'AccordionContext';
}

/* harmony default export */ __webpack_exports__["a"] = (AccordionContext);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccordionActions__ = __webpack_require__(1866);
/* unused harmony reexport default */


/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AccordionDetails__ = __webpack_require__(1867);
/* unused harmony reexport default */


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar__ = __webpack_require__(1873);
/* unused harmony reexport default */


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Avatar__ = __webpack_require__(1874);
/* unused harmony reexport default */


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(1878);
/* unused harmony reexport default */


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BottomNavigation__ = __webpack_require__(1879);
/* unused harmony reexport default */


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BottomNavigationAction__ = __webpack_require__(1880);
/* unused harmony reexport default */


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box__ = __webpack_require__(1881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Box__["a"]; });
/* unused harmony reexport styleFunction */


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__ = __webpack_require__(1882);
/* unused harmony reexport default */


/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonGroup__ = __webpack_require__(1887);
/* unused harmony reexport default */


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(1888);
/* unused harmony reexport default */


/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardActionArea__ = __webpack_require__(1889);
/* unused harmony reexport default */


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardActions__ = __webpack_require__(1890);
/* unused harmony reexport default */


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardContent__ = __webpack_require__(1891);
/* unused harmony reexport default */


/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardHeader__ = __webpack_require__(1892);
/* unused harmony reexport default */


/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardMedia__ = __webpack_require__(1893);
/* unused harmony reexport default */


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(1894);
/* unused harmony reexport default */


/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chip__ = __webpack_require__(1898);
/* unused harmony reexport default */


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CircularProgress__ = __webpack_require__(1900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CircularProgress__["a"]; });


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(1902);
/* unused harmony reexport default */


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CssBaseline__ = __webpack_require__(1903);
/* unused harmony reexport default */


/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dialog__ = __webpack_require__(1904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dialog__["a"]; });


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ariaHidden;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModalManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__ = __webpack_require__(416);





 // Is a vertical scrollbar displayed?

function isOverflowing(container) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" /* default */])(container);

  if (doc.body === container) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__["a" /* default */])(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__["a" /* default */])();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" /* default */])(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();



/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollbarSize;
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogActions__ = __webpack_require__(1909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogActions__["a"]; });


/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogContent__ = __webpack_require__(1910);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogContent__["a"]; });


/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogContentText__ = __webpack_require__(1911);
/* unused harmony reexport default */


/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogTitle__ = __webpack_require__(1912);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogTitle__["a"]; });


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Divider__ = __webpack_require__(1913);
/* unused harmony reexport default */


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Drawer__ = __webpack_require__(579);
/* unused harmony reexport default */


/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanel__ = __webpack_require__(1915);
/* unused harmony reexport default */


/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var ExpansionPanelContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({});

if (false) {
  ExpansionPanelContext.displayName = 'ExpansionPanelContext';
}

/* harmony default export */ __webpack_exports__["a"] = (ExpansionPanelContext);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanelActions__ = __webpack_require__(1916);
/* unused harmony reexport default */


/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanelDetails__ = __webpack_require__(1917);
/* unused harmony reexport default */


/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanelSummary__ = __webpack_require__(1918);
/* unused harmony reexport default */


/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fab__ = __webpack_require__(1919);
/* unused harmony reexport default */


/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormControlLabel__ = __webpack_require__(1924);
/* unused harmony reexport default */


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(1928);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });


/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridList__ = __webpack_require__(1929);
/* unused harmony reexport default */


/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridListTile__ = __webpack_require__(1930);
/* unused harmony reexport default */


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridListTileBar__ = __webpack_require__(1931);
/* unused harmony reexport default */


/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hidden__ = __webpack_require__(1933);
/* unused harmony reexport default */


/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isWidthUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWidthDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__useMediaQuery__ = __webpack_require__(586);









 // By default, returns true if screen width is the same or greater than the given breakpoint.

var isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint) <= __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(width);
  }

  return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint) < __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.

var isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(width) <= __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint);
  }

  return __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(width) < __WEBPACK_IMPORTED_MODULE_8__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint);
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$noSSR = options.noSSR,
        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
        initialWidthOption = options.initialWidth;

    function WithWidth(props) {
      var contextTheme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
      var theme = props.theme || contextTheme;

      var _getThemeProps = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["b" /* getThemeProps */])({
        theme: theme,
        name: 'MuiWithWidth',
        props: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props)
      }),
          initialWidth = _getThemeProps.initialWidth,
          width = _getThemeProps.width,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_getThemeProps, ["initialWidth", "width"]);

      var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
          mountedState = _React$useState[0],
          setMountedState = _React$useState[1];

      useEnhancedEffect(function () {
        setMountedState(true);
      }, []);
      /**
       * innerWidth |xs      sm      md      lg      xl
       *            |-------|-------|-------|-------|------>
       * width      |  xs   |  sm   |  md   |  lg   |  xl
       */

      var keys = theme.breakpoints.keys.slice().reverse();
      var widthComputed = keys.reduce(function (output, key) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var matches = Object(__WEBPACK_IMPORTED_MODULE_9__useMediaQuery__["a" /* default */])(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null);

      var more = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
      }, withThemeOption ? {
        theme: theme
      } : {}, other); // When rendering the component on the server,
      // we have no idea about the client browser screen width.
      // In order to prevent blinks and help the reconciliation of the React tree
      // we are not rendering the child component.
      //
      // An alternative is to use the `initialWidth` property.


      if (more.width === undefined) {
        return null;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, more);
    }

     false ? WithWidth.propTypes = {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty component during the first mount.
       * You might want to use an heuristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * https://caniuse.com/#search=client%20hint
       */
      initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      /**
       * @ignore
       */
      theme: PropTypes.object,

      /**
       * Bypass the width calculation logic.
       */
      width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : void 0;

    if (false) {
      WithWidth.displayName = "WithWidth(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(WithWidth, Component);
    return WithWidth;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withWidth);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(1937);
/* unused harmony reexport default */


/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageList__ = __webpack_require__(1938);
/* unused harmony reexport default */


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageListItem__ = __webpack_require__(1939);
/* unused harmony reexport default */


/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageListItemBar__ = __webpack_require__(1940);
/* unused harmony reexport default */


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputAdornment__ = __webpack_require__(1942);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputAdornment__["a"]; });


/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Link__ = __webpack_require__(1945);
/* unused harmony reexport default */


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemAvatar__ = __webpack_require__(1948);
/* unused harmony reexport default */


/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemIcon__ = __webpack_require__(1949);
/* unused harmony reexport default */


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemSecondaryAction__ = __webpack_require__(1950);
/* unused harmony reexport default */


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemText__ = __webpack_require__(1951);
/* unused harmony reexport default */


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListSubheader__ = __webpack_require__(1952);
/* unused harmony reexport default */


/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(979);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Popover__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MenuList__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_setRef__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_deprecatedPropType__ = __webpack_require__(81);














var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  },

  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Menu(props, ref) {
  var _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      _props$disableAutoFoc = props.disableAutoFocusItem,
      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$MenuListProps = props.MenuListProps,
      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
      onClose = props.onClose,
      onEnteringProp = props.onEntering,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      PopoverClasses = props.PopoverClasses,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps;
  _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;

  var onEntering = _props$TransitionProp.onEntering,
      TransitionProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$TransitionProp, ["onEntering"]),
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_12__styles_useTheme__["a" /* default */])();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var contentAnchorRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var getContentAnchorEl = function getContentAnchorEl() {
    return contentAnchorRef.current;
  };

  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEnteringProp) {
      onEnteringProp(element, isAppearing);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
        ref: function ref(instance) {
          // #StrictMode ready
          contentAnchorRef.current = __WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"](instance);
          Object(__WEBPACK_IMPORTED_MODULE_11__utils_setRef__["a" /* default */])(child.ref, instance);
        }
      });
    }

    return child;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Popover__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    getContentAnchorEl: getContentAnchorEl,
    classes: PopoverClasses,
    onClose: onClose,
    TransitionProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      onEntering: handleEntering
    }, TransitionProps),
    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps, {
      classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open: open,
    ref: ref,
    transitionDuration: transitionDuration
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__MenuList__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem: autoFocusItem,
    variant: variant
  }, MenuListProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.list, MenuListProps.className)
  }), items));
});
 false ? Menu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.func]),

  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   */
  autoFocus: PropTypes.bool,

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   */
  disableAutoFocusItem: PropTypes.bool,

  /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the Menu enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired before the Menu exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the Menu is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the menu is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.object,

  /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](http://reactcommunity.org/react-transition-group/transition) component.
   */
  TransitionProps: PropTypes.object,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMenu'
})(Menu));

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileStepper__ = __webpack_require__(1956);
/* unused harmony reexport default */


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NativeSelect__ = __webpack_require__(982);
/* unused harmony reexport default */


/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Input__ = __webpack_require__(320);










var styles = function styles(theme) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},

    /* Styles applied to the select component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      },
      '&&': {
        paddingRight: 24
      }
    },

    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: theme.shape.borderRadius,
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: 'auto',
      // Resets for multpile select with chips
      minHeight: '1.1876em',
      // Required for select\text-field height consistency
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },

    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},

    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      pointerEvents: 'none',
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active,
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },

    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },

    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      opacity: 0,
      pointerEvents: 'none',
      width: '100%'
    }
  };
};
var defaultInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Input__["a" /* default */], null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */

var NativeSelect = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function NativeSelect(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__["a" /* default */] : _props$IconComponent,
      _props$input = props.input,
      input = _props$input === void 0 ? defaultInput : _props$input,
      inputProps = props.inputProps,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](input, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__["a" /* default */],
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? NativeSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value. The DOM API casts this to a string.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
NativeSelect.muiName = 'Select';
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect));

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(36);







/**
 * @ignore - internal component.
 */

var NativeSelectInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function NativeSelectInput(props, ref) {
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("select", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes[variant], className, disabled && classes.disabled),
    disabled: disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant))], disabled && classes.disabled)
  }));
});
 false ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,

  /**
   * @ignore
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (NativeSelectInput);

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown'));

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(1962);
/* unused harmony reexport default */


/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRadioGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RadioGroupContext__ = __webpack_require__(987);


function useRadioGroup() {
  return __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__RadioGroupContext__["a" /* default */]);
}

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var RadioGroupContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  RadioGroupContext.displayName = 'RadioGroupContext';
}

/* harmony default export */ __webpack_exports__["a"] = (RadioGroupContext);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RadioGroup__ = __webpack_require__(1966);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useRadioGroup__ = __webpack_require__(986);
/* unused harmony reexport useRadioGroup */



/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RootRef__ = __webpack_require__(1967);
/* unused harmony reexport default */


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(1970);
/* unused harmony reexport default */


/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Snackbar__ = __webpack_require__(1972);
/* unused harmony reexport default */


/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Step__ = __webpack_require__(1974);
/* unused harmony reexport default */


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepButton__ = __webpack_require__(1975);
/* unused harmony reexport default */


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepContent__ = __webpack_require__(1981);
/* unused harmony reexport default */


/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stepper__ = __webpack_require__(1982);
/* unused harmony reexport default */


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SwipeableDrawer__ = __webpack_require__(1983);
/* unused harmony reexport default */


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Switch__ = __webpack_require__(1985);
/* unused harmony reexport default */


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab__ = __webpack_require__(1986);
/* unused harmony reexport default */


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(1987);
/* unused harmony reexport default */


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var TableContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();

if (false) {
  TableContext.displayName = 'TableContext';
}

/* harmony default export */ __webpack_exports__["a"] = (TableContext);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableBody__ = __webpack_require__(1988);
/* unused harmony reexport default */


/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableContainer__ = __webpack_require__(1990);
/* unused harmony reexport default */


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableFooter__ = __webpack_require__(1991);
/* unused harmony reexport default */


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableHead__ = __webpack_require__(1992);
/* unused harmony reexport default */


/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TablePagination__ = __webpack_require__(1993);
/* unused harmony reexport default */


/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft'));

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight'));

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableRow__ = __webpack_require__(1996);
/* unused harmony reexport default */


/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableSortLabel__ = __webpack_require__(1997);
/* unused harmony reexport default */


/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(1999);
/* unused harmony reexport default */


/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextField__ = __webpack_require__(2005);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextField__["a"]; });


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(2006);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tooltip__["a"]; });


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useScrollTrigger__ = __webpack_require__(2007);
/* unused harmony reexport default */


/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMobileDialog__ = __webpack_require__(2008);
/* unused harmony reexport default */


/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Zoom__ = __webpack_require__(2009);
/* unused harmony reexport default */


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseDOM; });
function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}




/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return noop; });
function noop() {}




/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export assignRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useComposedRefs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_check_dist_reach_utils_type_check_esm_js__ = __webpack_require__(603);



function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

/**
 * Passes or assigns an arbitrary value to a ref function or object.
 *
 * @param ref
 * @param value
 */
function assignRef(ref, value) {
  if (ref == null) return;

  if (Object(__WEBPACK_IMPORTED_MODULE_1__type_check_dist_reach_utils_type_check_esm_js__["b" /* isFunction */])(ref)) {
    ref(value);
  } else {
    try {
      ref.current = value;
    } catch (error) {
      throw new Error("Cannot assign value \"" + value + "\" to ref \"" + ref + "\"");
    }
  }
}
/**
 * Passes or assigns a value to multiple refs (typically a DOM node). Useful for
 * dealing with components that need an explicit ref for DOM calculations but
 * also forwards refs assigned by an app.
 *
 * @param refs Refs to fork
 */

function useComposedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (node) {
    for (var _iterator = _createForOfIteratorHelperLoose(refs), _step; !(_step = _iterator()).done;) {
      var ref = _step.value;
      assignRef(ref, node);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, refs);
}




/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useForceUpdate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/**
 * Forces a re-render, similar to `forceUpdate` in class components.
 */

function useForceUpdate() {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(Object.create(null)),
      dispatch = _useState[1];

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    dispatch(Object.create(null));
  }, []);
}




/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FILE_INVALID_TYPE */
/* unused harmony export FILE_TOO_LARGE */
/* unused harmony export FILE_TOO_SMALL */
/* unused harmony export TOO_MANY_FILES */
/* unused harmony export ErrorCode */
/* unused harmony export getInvalidTypeRejectionErr */
/* unused harmony export getTooLargeRejectionErr */
/* unused harmony export getTooSmallRejectionErr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TOO_MANY_FILES_REJECTION; });
/* harmony export (immutable) */ __webpack_exports__["f"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["g"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["c"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["k"] = isPropagationStopped;
/* harmony export (immutable) */ __webpack_exports__["i"] = isEvtWithFiles;
/* unused harmony export isKindFile */
/* harmony export (immutable) */ __webpack_exports__["m"] = onDocumentDragOver;
/* harmony export (immutable) */ __webpack_exports__["j"] = isIeOrEdge;
/* harmony export (immutable) */ __webpack_exports__["e"] = composeEventHandlers;
/* harmony export (immutable) */ __webpack_exports__["d"] = canUseFileSystemAccessAPI;
/* harmony export (immutable) */ __webpack_exports__["n"] = pickerOptionsFromAccept;
/* harmony export (immutable) */ __webpack_exports__["b"] = acceptPropAsAcceptAttr;
/* harmony export (immutable) */ __webpack_exports__["h"] = isAbort;
/* harmony export (immutable) */ __webpack_exports__["l"] = isSecurityError;
/* unused harmony export isMIMEType */
/* unused harmony export isExt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Error codes

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
var ErrorCode = {
  FileInvalidType: FILE_INVALID_TYPE,
  FileTooLarge: FILE_TOO_LARGE,
  FileTooSmall: FILE_TOO_SMALL,
  TooManyFiles: TOO_MANY_FILES
}; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}
function isKindFile(item) {
  return _typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return {
        accept: _defineProperty({}, mimeType, ext)
      };
    });
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray(a), [mimeType], _toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26),
        SalesforceCommerceOCAPIService = __webpack_require__(2055);

    /**
     * @class {SalesforceCommerceOCAPIServiceFactory}
     *
     * Factory for SalesforceCommerce services.
     *
     * @author Pedro Augusto/ <a href="http://www.zmags.com">Zmags</a>
     */
    var SalesforceCommerceOCAPIServiceFactory = Class.extend("SalesforceCommerceOCAPIServiceFactory", {

        /**
         * Get an instance of the <tt>SalesforceCommerceOCAPIService</tt> according with the SalesforceCommerce version.<p>
         *
         * There is a basic implementation called <tt>SalesforceCommerceOCAPIService</tt> inside of the folder service.
         * However, IF in future, SalesforceCommerce drastically changes the way how they expose them
         * service, we can create a new folder version and extend the classes <tt>SalesforceCommerceDataAdapter</tt>
         * and <tt>SalesforceCommerceOCAPIService</tt>.
         *
         * @return {SalesforceCommerceOCAPIService} The SalesforceCommerce service.
         */
        getService: function getService() {
            return SalesforceCommerceOCAPIService;
        }
    });

    return new SalesforceCommerceOCAPIServiceFactory();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="container container-properties-item">\n    <div class=\'picture\'>\n        ';
 if (image) { ;
__p += '\n            <img src=\'' +
__e( image ) +
'\'/>\n            <div class="no-image hide" title="Product image failed to load: \'' +
__e( image ) +
'\'">Failed to load</div>\n        ';
 } else { ;
__p += '\n            <div class="no-image">No image</div>\n        ';
 } ;
__p += '\n    </div>\n    <div class=\'details\'>\n        ';
 if (name) { ;
__p += '\n        <div>\n            <div class=\'overflow product-name\'>' +
__e( name ) +
' </div>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (productID) { ;
__p += '\n        <div>\n            <span class=\'overflow\'>Id: ' +
__e( productID ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (brand) { ;
__p += '\n        <div>\n            <span class=\'overflow\'>Brand: ' +
__e( brand ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (price) { ;
__p += '\n        <div>\n            <span class=\'overflow\'> ' +
__e( price ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (availability) { ;
__p += '\n        <div>\n            <span class=\'overflow\'>Availability: ' +
__e( availability ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (description) { ;
__p += '\n        <div>\n            <span class=\'wrap\'>Description: ' +
__e( description ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        Class = __webpack_require__(26),
        GoogleAPIClient = __webpack_require__(2077);

    var API_KEY = "AIzaSyBVt3AHkpRiu7x1S7PCKGq43mvEkw7sGGg",
        OAUTH2_CLIENT_ID = "512316622321-dukhlgoahsmbm4gesfmo2vvc3u0rujen.apps.googleusercontent.com",
        OAUTH2_SCOPES = ["https://www.googleapis.com/auth/youtube.readonly"],
        MAX_SEARCH_RESULTS = 9,
        MAX_PLAYLIST_ITEMS = 27; /* Acceptable values are 0 to 50, inclusive. */

    function loadClientInterface(clientInterface, version) {
        return new $.Deferred(function (deferred) {
            GoogleAPIClient.load().then(function (GoogleAPI) {
                GoogleAPI.client.load(clientInterface, version, function () {
                    deferred.resolve();
                });
            });
        }).promise();
    }

    function loadUserChannel() {
        return new $.Deferred(function (deferred) {
            GoogleAPIClient.load().then(function (GoogleAPI) {
                var request = GoogleAPI.client.youtube.channels.list({
                    // "mine: true" indicates that you want to retrieve the authenticated user's channel.
                    mine: true,
                    part: "id,snippet,contentDetails"
                });
                request.execute(function (response) {
                    if (response.error) {
                        deferred.reject(response.error);
                        return;
                    }

                    if (!response.items.length) {
                        deferred.resolve("NoChannelConnected");
                        return;
                    }

                    var item = response.items[0];

                    deferred.resolve({
                        channelID: item.id,
                        uploadsListID: item.contentDetails.relatedPlaylists.uploads,
                        title: item.snippet.title,
                        thumbnails: item.snippet.thumbnails
                    });
                });
            });
        }).promise();
    }

    function loadVideoMetadata(videoIDs) {
        return new $.Deferred(function (deferred) {
            GoogleAPIClient.load().then(function (GoogleAPI) {
                var request = GoogleAPI.client.youtube.videos.list({
                    // The 'id' property value is a comma-separated string of video IDs.
                    id: videoIDs.join(","),
                    key: API_KEY,
                    part: "id,snippet,contentDetails"
                });

                request.execute(function (response) {
                    // TODO: Check for error?
                    deferred.resolve(response);
                });
            });
        }).promise();
    }

    function loadVideoIDs(listID) {
        return new $.Deferred(function (deferred) {
            GoogleAPIClient.load().then(function (GoogleAPI) {
                var request = GoogleAPI.client.youtube.playlistItems.list({
                    playlistId: listID,
                    key: API_KEY,
                    part: "snippet",
                    maxResults: MAX_PLAYLIST_ITEMS
                });

                request.execute(function (response) {
                    var videoIDs = _.map(response.items, function (item) {
                        return item.snippet.resourceId.videoId;
                    });

                    deferred.resolve(videoIDs);
                });
            });
        }).promise();
    }

    function performSearch(query) {
        return new $.Deferred(function (deferred) {
            GoogleAPIClient.load().then(function (GoogleAPI) {
                var request = GoogleAPI.client.youtube.search.list({
                    q: query,
                    part: "snippet",
                    key: API_KEY,
                    maxResults: MAX_SEARCH_RESULTS
                });

                request.execute(function (response) {
                    deferred.resolve(response);
                });
            });
        }).promise();
    }

    /**
     * Exposes the YouTube search API.
     *
     * @class YouTubeService
     * @see https://developers.google.com/youtube/v3/docs/search/list#try-it
     * @see https://developers.google.com/api-client-library/javascript/reference/referencedocs
     */
    return Class.extend({}, {

        /**
         * Returns a collection of search results that match the query parameters specified.
         *
         * Usage:
         *
         *  YouTubeService.search(query)
         *      .done(function (result) {
         *          console.log("Found", result.items.length, "results");
         *      });
         *
         * @param  {String} query The query term to search for.
         * resources created by the channel, optional.
         * @return {Deferred} A jQuery Deferred instance.
         */
        search: function search(query) {
            return loadClientInterface("youtube", "v3").then(function () {
                return performSearch(query);
            }).then(function (response) {
                var videoIDs = _.map(response.items, function (item) {
                    return item.id.videoId;
                });

                return loadVideoMetadata(videoIDs);
            });
        },

        /**
         * Attempt the 'immediate' OAuth 2 client flow.
         *
         * If the currently logged-in Google Account has previously authorized
         * OAUTH2_CLIENT_ID, then it will succeed with no user intervention.
         *
         * Otherwise, it will fail and the user interface that prompts for
         * authorization will need to be displayed. This is acheived by calling
         * this method and passing <tt>false</tt> for the <tt>immediate</t> argument.
         *
         * @param  {Boolean} immediate If <tt>true</tt>, then login uses "immediate mode", which
         * means that the token is refreshed behind the scenes, and no UI is shown to the user.
         * Passing <tt>false</tt> will open a popup window. The parameter is optional, and
         * defaults to <tt>true</tt>.
         *
         * @return {Promise} A promise that will be resolved when the user is
         * successfully authorized, otherwise it will be rejected.
         */
        authorize: function authorize(immediate) {
            var deferred = new $.Deferred();

            if (_.isUndefined(immediate)) {
                immediate = true;
            }

            GoogleAPIClient.load().then(function (GoogleAPI) {
                GoogleAPI.auth.init(function () {
                    _.delay(function () {
                        GoogleAPI.auth.authorize({
                            // eslint-disable-next-line camelcase
                            client_id: OAUTH2_CLIENT_ID,
                            scope: OAUTH2_SCOPES,
                            immediate: immediate
                        }, function (authResult) {
                            if (authResult.error) {
                                deferred.reject(authResult.error);
                            } else {
                                deferred.resolve();
                            }
                        });
                    });
                });
            });

            return deferred.promise();
        },

        getUserData: function getUserData() {
            return loadClientInterface("youtube", "v3").then(loadUserChannel);
        },

        /**
         * Returns a Promise that will be resolved with an array of video meta
         * data for the currently authenticated user's uploaded videos.
         *
         * Make sure to call the #authorize method before fetching video data.
         *
         * @return {Promise} A Promise that will be resolved with an array of video meta
         * data.
         */
        getVideoMetadata: function getVideoMetadata() {
            return loadClientInterface("youtube", "v3").then(loadUserChannel).then(function (response) {
                return loadVideoIDs(response.uploadsListID);
            }).then(loadVideoMetadata).promise();
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26),
        _ = __webpack_require__(1),
        YouTubeImageCollectionView = __webpack_require__(2078),
        YouTubeImageCollection = __webpack_require__(2081),
        YouTubeImageModel = __webpack_require__(1026);

    function mapYouTubeModel(data) {
        var snippet = data.snippet;

        return {
            name: snippet.title,
            description: snippet.description,
            videoID: data.id,
            channelID: snippet.channelId,
            thumbnailUrl: snippet.thumbnails.medium.url,
            duration: data.contentDetails.duration
        };
    }

    return Class.extend({}, {

        toCollectionView: function toCollectionView(videos) {
            var collection = new YouTubeImageCollection();

            _.each(videos, function (video) {
                collection.push(new YouTubeImageModel(mapYouTubeModel(video)));
            });

            return new YouTubeImageCollectionView({
                collection: collection,
                itemViewOptions: {
                    showTooltips: true,
                    showImageInfo: true,
                    dropTargetSize: "large",
                    draggable: true
                }
            });
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<img src="' +
__e( thumbnailUrl ) +
'" class="youtube-thumbnail"/>\n<span class="video-time">' +
__e( displayDuration ) +
'</span>';

}
return __p
}

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);

    /**
     * Model representing metadata about an image asset.
     *
     * @class YouTubeImageModel
     * @constructor
     */
    return Backbone.Model.extend({
        defaults: {
            name: "Untitled",
            description: "",
            videoID: null,
            channelID: null,
            thumbnailUrl: "",
            duration: null
        },

        /**
         * Returns a display friendly version of the specified ISO 8601
         * duration in the format PT#M#S (The duration format used by YouTube).
         *
         * I.e. "PT2H3M38S" will return "2:03:38"
         *
         * @return {String}   A display friendly version of the specified duration.
         */
        formatDuration: function formatDuration() {
            var matches = this.get("duration").match(/(\d+)(?=[MHS])/ig),
                formatDigit = function formatDigit(digit) {
                return digit.length < 2 ? "0" + digit : digit;
            };

            switch (matches.length) {
                // Only seconds
                case 1:
                    return "0:" + formatDigit(matches[0]);
                // Minutes and seconds
                case 2:
                    return matches[0] + ":" + formatDigit(matches[1]);
                // Hours, minutes and seconds
                default:
                    // Case 3 handled here.
                    return matches[0] + ":" + formatDigit(matches[1]) + ":" + formatDigit(matches[2]);
            }
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var CompanyState = __webpack_require__(242);
    var Backbone = __webpack_require__(7);
    var BreakpointCollection = __webpack_require__(2094);
    var RestApi = __webpack_require__(29);

    /**
     * Company Settings Model.
     *
     * @class CompanySettings
     * @constructor
     */
    return ImprovedModel.extend("Company Settings", {

        /**
         * Returns the RestApi url path corresponding to this specific resource.
         *
         * @returns {String} the RestApi url path corresponding to this specific resource
         */
        url: function url() {
            var id = this.get("id");

            if (id) {
                return RestApi.pathToSpecificResource(RestApi.Collections.SETTINGS, id); // for methods like fetch()
            }

            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, this.get("companyId"), RestApi.Collections.SETTINGS); // for load based on company
        },


        defaults: {
            googleAnalyticsId: "",
            segmentIoApiKey: "",
            analyticsEnabled: true,
            companyId: null,
            state: null,
            imageViewedEventsEnabled: false,
            templateSharingEnabled: false,
            channelConfigId: null,
            cloudinaryDefaultImageProvider: false,

            /**
             * Whether the breakpoint feature is enabled.
             *
             * @type {Boolean}
             */
            breakpointEnabled: false,

            /**
             * The company's default breakpoint "template".
             *
             * @type {BreakpointCollection}
             */
            breakpoints: [{ threshold: 768 }, { threshold: 992 }]
        },

        relations: [{
            type: Backbone.Many,
            key: "breakpoints",
            collectionType: BreakpointCollection
        }],

        computed: {
            state: {
                deps: ["state"],
                // First a string name, secondarily the actual state...
                value: function value(state) {
                    return CompanyState.of(state);
                }
            }
        }

    }, {
        State: CompanyState
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PortalCompat__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PortalWithState__ = __webpack_require__(2106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PortalCompat__["a"]; });
/* unused harmony reexport PortalWithState */





/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Portal__ = __webpack_require__(2103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LegacyPortal__ = __webpack_require__(2105);





var Portal = void 0;

if (__WEBPACK_IMPORTED_MODULE_0_react_dom___default.a.createPortal) {
  Portal = __WEBPACK_IMPORTED_MODULE_1__Portal__["a" /* default */];
} else {
  Portal = __WEBPACK_IMPORTED_MODULE_2__LegacyPortal__["a" /* default */];
}

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule randomizeBlockMapKeys
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(111);
var Immutable = __webpack_require__(40);

var generateRandomKey = __webpack_require__(164);

var OrderedMap = Immutable.OrderedMap;


var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {};

  // we keep track of root blocks in order to update subsequent sibling links
  var lastRootBlock = void 0;

  return OrderedMap(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey();

      // new key that we will use to build linking
      var key = generateRandomKey();

      // we will add it here to re-use it later
      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);
        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);
        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);
        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap(blockMap.toArray().map(function (block) {
    var key = generateRandomKey();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

module.exports = randomizeBlockMapKeys;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeEntitiesAtEdges
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(93);

var findRangesImmutable = __webpack_require__(325);
var invariant = __webpack_require__(47);

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();

  var updatedBlocks = {};

  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);
  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}

function getRemovalRange(characters, key, offset) {
  var removalRange;
  findRangesImmutable(characters, function (a, b) {
    return a.getEntity() === b.getEntity();
  }, function (element) {
    return element.getEntity() === key;
  }, function (start, end) {
    if (start <= offset && end >= offset) {
      removalRange = { start: start, end: end };
    }
  });
  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);
    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;
      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
        start++;
      }
      return block.set('characterList', chars);
    }
  }

  return block;
}

module.exports = removeEntitiesAtEdges;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertIntoList
 * @format
 * 
 */



/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList(targetList, toInsert, offset) {
  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }
  return targetList;
}

module.exports = insertIntoList;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNextDelimiterBlockKey
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var ContentBlockNode = __webpack_require__(111);

var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);
  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

module.exports = getNextDelimiterBlockKey;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BlockTree
 * @format
 * 
 */



var Immutable = __webpack_require__(40);

var emptyFunction = __webpack_require__(605);
var findRangesImmutable = __webpack_require__(325);

var List = Immutable.List,
    Repeat = Immutable.Repeat,
    Record = Immutable.Record;


var returnTrue = emptyFunction.thatReturnsTrue;

var FINGERPRINT_DELIMITER = '-';

var defaultLeafRange = {
  start: null,
  end: null
};

var LeafRange = Record(defaultLeafRange);

var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};

var DecoratorRange = Record(defaultDecoratorRange);

var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();
    if (!textLength) {
      return List.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));

    var chars = block.getCharacterList();

    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });

    return List(leafSets);
  },

  /**
   * Create a string representation of the given tree map. This allows us
   * to rapidly determine whether a tree has undergone a significant
   * structural change.
   */
  getFingerprint: function getFingerprint(tree) {
    return tree.map(function (leafSet) {
      var decoratorKey = leafSet.get('decoratorKey');
      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
    }).join(FINGERPRINT_DELIMITER);
  }
};

/**
 * Generate LeafRange records for a given character list.
 */
function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List(leaves);
}

function areEqual(a, b) {
  return a === b;
}

module.exports = BlockTree;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntityInstance
 * @legacyServerCallableInstance
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(40);

var Record = Immutable.Record;


var DraftEntityInstanceRecord = Record({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});

/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = function (_DraftEntityInstanceR) {
  _inherits(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    _classCallCheck(this, DraftEntityInstance);

    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
  }

  DraftEntityInstance.prototype.getType = function getType() {
    return this.get('type');
  };

  DraftEntityInstance.prototype.getMutability = function getMutability() {
    return this.get('mutability');
  };

  DraftEntityInstance.prototype.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

module.exports = DraftEntityInstance;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Basic (stateless) API for text direction detection
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



var UnicodeBidiDirection = __webpack_require__(608);

var invariant = __webpack_require__(47);

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {

  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',

  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',

  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'

};

var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');

/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */
function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */
function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);
  if (strongChar == null) {
    return UnicodeBidiDirection.NEUTRAL;
  }
  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */
function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
  if (!str.length) {
    return fallback;
  }
  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
}

/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */
function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection.getGlobalDir();
  }
  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}

/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */
function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
}

/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */
function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};

module.exports = UnicodeBidi;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultDraftInlineStyle
 * @format
 * 
 */



module.exports = {
  BOLD: {
    fontWeight: 'bold'
  },

  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },

  ITALIC: {
    fontStyle: 'italic'
  },

  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },

  UNDERLINE: {
    textDecoration: 'underline'
  }
};

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isSelectionAtLeafStart
 * @format
 * 
 */



function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();

  var isAtStart = false;

  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');
        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });

  return isAtStart;
}

module.exports = isSelectionAtLeafStart;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorBlock.react
 * @format
 * 
 */



var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorLeaf = __webpack_require__(2128);
var DraftOffsetKey = __webpack_require__(430);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(28);
var Scroll = __webpack_require__(1041);
var Style = __webpack_require__(613);
var UnicodeBidi = __webpack_require__(1036);
var UnicodeBidiDirection = __webpack_require__(608);

var cx = __webpack_require__(272);
var getElementPosition = __webpack_require__(2142);
var getScrollPosition = __webpack_require__(614);
var getViewportDimensions = __webpack_require__(2146);
var invariant = __webpack_require__(47);
var nullthrows = __webpack_require__(130);

var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};

/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */

var DraftEditorBlock = function (_React$Component) {
  _inherits(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    _classCallCheck(this, DraftEditorBlock);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  };

  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */


  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();
    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = ReactDOM.findDOMNode(this);
    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta = void 0;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;
      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !(blockNode instanceof HTMLElement) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;
      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);

    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      var decoratorKey = leafSet.get('decoratorKey');
      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows(_this2.props.decorator);

      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));

      // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);

      return React.createElement(
        DecoratorComponent,
        _extends({}, decoratorProps, {
          contentState: _this2.props.contentState,
          decoratedText: decoratedText,
          dir: dir,
          key: decoratorOffsetKey,
          entityKey: block.getEntityAt(leafSet.get('start')),
          offsetKey: decoratorOffsetKey }),
        leaves
      );
    }).toArray();
  };

  DraftEditorBlock.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        offsetKey = _props.offsetKey;

    var className = cx({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });

    return React.createElement(
      'div',
      { 'data-offset-key': offsetKey, className: className },
      this._renderChildren()
    );
  };

  return DraftEditorBlock;
}(React.Component);

module.exports = DraftEditorBlock;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}

/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */

var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ?
    // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;
    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};

module.exports = Scroll;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var PhotosMimeType = __webpack_require__(2149);

var createArrayFromMixed = __webpack_require__(2150);
var emptyFunction = __webpack_require__(605);

var CR_LF_REGEX = new RegExp('\r\n', 'g');
var LF_ONLY = '\n';

var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};

/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */
function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer = function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    _classCallCheck(this, DataTransfer);

    this.data = data;

    // Types could be DOMStringList or array
    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }

  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    }

    // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.
    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };

  /**
   * Get raw text.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getText = function getText() {
    var text;
    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }
    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };

  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  DataTransfer.prototype.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };

  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };

  /**
   * Get a link url.
   *
   * @return {?string}
   */


  DataTransfer.prototype.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }
      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };

  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();
    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;
      if (!PhotosMimeType.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  DataTransfer.prototype.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }
    return null;
  };

  /**
   * Get files.
   *
   * @return {array}
   */


  DataTransfer.prototype.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };

  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  DataTransfer.prototype.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

module.exports = DataTransfer;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSelectionOffsetKeyForNode
 * @format
 * 
 */



/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

function getSelectionOffsetKeyForNode(node) {
  if (node instanceof Element) {
    var offsetKey = node.getAttribute('data-offset-key');
    if (offsetKey) {
      return offsetKey;
    }
    for (var ii = 0; ii < node.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }
  return null;
}

module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentFromFiles
 * @format
 * 
 */



var invariant = __webpack_require__(47);

var TEXT_CLIPPING_REGEX = /\.textClipping$/;

var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
};

// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
var TEXT_SIZE_UPPER_BOUND = 5000;

/**
 * Extract the text content from a file list.
 */
function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function ( /*blob*/file) {
    readFile(file, function ( /*string*/text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}

/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */
function readFile(file, callback) {
  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var contents = '';
    // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.
    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }
    callback(contents);
    return;
  }

  var reader = new FileReader();
  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
    callback(result);
  };
  reader.onerror = function () {
    callback('');
  };
  reader.readAsText(file);
}

module.exports = getTextContentFromFiles;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getUpdatedSelectionState
 * @format
 * 
 */



var DraftOffsetKey = __webpack_require__(430);

var nullthrows = __webpack_require__(130);

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows(editorState.getSelection());
  if (false) {
    if (!anchorKey || !focusKey) {
      /*eslint-disable no-console */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
      /*eslint-enable no-console */
      return selection;
    }
  }

  var anchorPath = DraftOffsetKey.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);

  var focusPath = DraftOffsetKey.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');

  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;

  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;
  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');
    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

module.exports = getUpdatedSelectionState;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getFragmentFromSelection
 * @format
 * 
 */



var getContentStateFragment = __webpack_require__(428);

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
}

module.exports = getFragmentFromSelection;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeClientRects
 * @format
 * 
 */



var UserAgent = __webpack_require__(145);

var invariant = __webpack_require__(47);

var isChrome = UserAgent.isBrowser('Chrome');

// In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437
/* eslint-disable consistent-return */
function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;
    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }
    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);
    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }
    tempRange.setEndBefore(ancestor);
  }

   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */
var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};

module.exports = getRangeClientRects;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelectionWithNodes
 * @format
 * 
 */



var findAncestorOffsetKey = __webpack_require__(615);
var getSelectionOffsetKeyForNode = __webpack_require__(1043);
var getUpdatedSelectionState = __webpack_require__(1045);
var invariant = __webpack_require__(47);
var nullthrows = __webpack_require__(130);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;

  // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.
  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true;

  // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows(findAncestorOffsetKey(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows(findAncestorOffsetKey(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);

    // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.
    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}

/**
 * Identify the first leaf descendant for the given node.
 */
function getFirstLeaf(node) {
  while (node.firstChild && (
  // data-blocks has no offset
  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Identify the last leaf descendant for the given node.
 */
function getLastLeaf(node) {
  while (node.lastChild && (
  // data-blocks has no offset
  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }
  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey(node);

  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;

  // If the editorRoot is the selection, step downward into the content
  // wrapper.
  if (editorRoot === node) {
    node = node.firstChild;
    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  }

  // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.
  if (childOffset === 0) {
    var key = null;
    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
    }
    return { key: key, offset: 0 };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}

/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */
function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftRemovableWord
 * @format
 * 
 */



var TokenizeUtil = __webpack_require__(2168);

var punctuation = TokenizeUtil.getPunctuation();

// The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.
var CHAMELEON_CHARS = '[\'\u2018\u2019]';

// Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.
var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;

var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);

var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },

  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};

module.exports = DraftRemovableWord;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveSelectionForward
 * @format
 * 
 */



/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */
function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();

  var focusKey = key;
  var focusOffset;

  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
}

module.exports = moveSelectionForward;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromHTMLToContentBlocks
 * @format
 * 
 */



var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _knownListItemDepthCl,
    _assign = __webpack_require__(73);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CharacterMetadata = __webpack_require__(93);
var ContentBlock = __webpack_require__(217);
var ContentBlockNode = __webpack_require__(111);
var DefaultDraftBlockRenderMap = __webpack_require__(609);
var DraftEntity = __webpack_require__(429);
var DraftFeatureFlags = __webpack_require__(181);
var Immutable = __webpack_require__(40);

var _require = __webpack_require__(40),
    Set = _require.Set;

var URI = __webpack_require__(2179);

var cx = __webpack_require__(272);
var generateRandomKey = __webpack_require__(164);
var getSafeBodyFromHTML = __webpack_require__(1052);
var invariant = __webpack_require__(47);
var sanitizeDraftText = __webpack_require__(607);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    OrderedSet = Immutable.OrderedSet;


var NBSP = '&nbsp;';
var SPACE = ' ';

// Arbitrary max indent
var MAX_DEPTH = 4;

// used for replacing characters in HTML
var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g');

// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];

// Block tag flow is different because LIs do not have
// a deterministic style ;_;
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);

var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];

var imgAttr = ['alt', 'className', 'height', 'src', 'width'];

var lastBlock = void 0;

var EMPTY_CHUNK = {
  text: '',
  inlines: [],
  entities: [],
  blocks: []
};

var EMPTY_BLOCK = {
  children: List(),
  depth: 0,
  key: '',
  type: ''
};

var getListBlockType = function getListBlockType(tag, lastList) {
  if (tag === 'li') {
    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
  }
  return null;
};

var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
  var unstyledElement = blockRenderMap.get('unstyled').element;
  var tags = Set([]);

  blockRenderMap.forEach(function (draftBlock) {
    if (draftBlock.aliasedElements) {
      draftBlock.aliasedElements.forEach(function (tag) {
        tags = tags.add(tag);
      });
    }

    tags = tags.add(draftBlock.element);
  });

  return tags.filter(function (tag) {
    return tag && tag !== unstyledElement;
  }).toArray().sort();
};

// custom element conversions
var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
    var matchType = multiMatchExtractor[ii](tag, lastList);
    if (matchType) {
      return matchType;
    }
  }
  return null;
};

var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
      return alias === tag;
    });
  }).keySeq().toSet().toArray().sort();

  // if we dont have any matched type, return unstyled
  // if we have one matched type return it
  // if we have multi matched types use the multi-match function to gather type
  switch (matchedTypes.length) {
    case 0:
      return 'unstyled';
    case 1:
      return matchedTypes[0];
    default:
      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
  }
};

var processInlineTag = function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];
  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    var htmlElement = node;
    currentStyle = currentStyle.withMutations(function (style) {
      var fontWeight = htmlElement.style.fontWeight;
      var fontStyle = htmlElement.style.fontStyle;
      var textDecoration = htmlElement.style.textDecoration;

      if (boldValues.indexOf(fontWeight) >= 0) {
        style.add('BOLD');
      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
        style.remove('BOLD');
      }

      if (fontStyle === 'italic') {
        style.add('ITALIC');
      } else if (fontStyle === 'normal') {
        style.remove('ITALIC');
      }

      if (textDecoration === 'underline') {
        style.add('UNDERLINE');
      }
      if (textDecoration === 'line-through') {
        style.add('STRIKETHROUGH');
      }
      if (textDecoration === 'none') {
        style.remove('UNDERLINE');
        style.remove('STRIKETHROUGH');
      }
    }).toOrderedSet();
  }
  return currentStyle;
};

var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var lastInA = A.text.slice(-1);
  var firstInB = B.text.slice(0, 1);

  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  }

  // Kill whitespace after blocks
  if (lastInA === '\r') {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks)
  };
};

/**
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */
var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
  return blockTags.some(function (tag) {
    return html.indexOf('<' + tag) !== -1;
  });
};

var hasValidLinkText = function hasValidLinkText(link) {
  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
  var protocol = link.protocol;
  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
};

var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);
  if (inEntity) {
    entities[0] = inEntity;
  }
  return _extends({}, EMPTY_CHUNK, {
    text: SPACE,
    inlines: [OrderedSet()],
    entities: entities
  });
};

var getSoftNewlineChunk = function getSoftNewlineChunk() {
  return _extends({}, EMPTY_CHUNK, {
    text: '\n',
    inlines: [OrderedSet()],
    entities: new Array(1)
  });
};

var getChunkedBlock = function getChunkedBlock() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _extends({}, EMPTY_BLOCK, props);
};

var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return {
    text: '\r',
    inlines: [OrderedSet()],
    entities: new Array(1),
    blocks: [getChunkedBlock({
      parent: parentKey,
      key: generateRandomKey(),
      type: block,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    })]
  };
};

/**
 *  If we're pasting from one DraftEditor to another we can check to see if
 *  existing list item depth classes are being used and preserve this style
 */
var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};

var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
  var lastLastBlock = lastBlock;
  var nodeName = node.nodeName.toLowerCase();
  var newEntityMap = entityMap;
  var nextBlockType = 'unstyled';
  var newBlock = false;
  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
  var chunk = _extends({}, EMPTY_CHUNK);
  var newChunk = null;
  var blockKey = void 0;

  // Base Case
  if (nodeName === '#text') {
    var _text = node.textContent;
    var nodeTextContent = _text.trim();

    // We should not create blocks for leading spaces that are
    // existing around ol/ul and their children list items
    if (lastList && nodeTextContent === '' && node.parentElement) {
      var parentNodeName = node.parentElement.nodeName.toLowerCase();
      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
        return { chunk: _extends({}, EMPTY_CHUNK), entityMap: entityMap };
      }
    }

    if (nodeTextContent === '' && inBlock !== 'pre') {
      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
    }
    if (inBlock !== 'pre') {
      // Can't use empty string because MSWord
      _text = _text.replace(REGEX_LF, SPACE);
    }

    // save the last block so we can use it later
    lastBlock = nodeName;

    return {
      chunk: {
        text: _text,
        inlines: Array(_text.length).fill(inlineStyle),
        entities: Array(_text.length).fill(inEntity),
        blocks: []
      },
      entityMap: entityMap
    };
  }

  // save the last block so we can use it later
  lastBlock = nodeName;

  // BR tags
  if (nodeName === 'br') {
    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
      return {
        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
        entityMap: entityMap
      };
    }
    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
  }

  // IMG tags
  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
    var image = node;
    var entityConfig = {};

    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);
      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    });
    // Forcing this node to have children because otherwise no entity will be
    // created for this node.
    // The child text node cannot just have a space or return as content -
    // we strip those out.
    // See https://github.com/facebook/draft-js/issues/231 for some context.
    node.textContent = '\uD83D\uDCF7';

    // TODO: update this when we remove DraftEntity entirely
    inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
  }

  // Inline tags
  inlineStyle = processInlineTag(nodeName, node, inlineStyle);

  // Handle lists
  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }
    lastList = nodeName;
  }

  if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
    depth = getListItemDepth(node, depth);
  }

  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1;

  // Block Tags
  if (inListBlock || inBlockOrHasNestedBlocks) {
    chunk = getBlockDividerChunk(blockType, depth, parentKey);
    blockKey = chunk.blocks[0].key;
    inBlock = nodeName;
    newBlock = !experimentalTreeDataSupport;
  }

  // this is required so that we can handle 'ul' and 'ol'
  if (inListBlock) {
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  }

  // Recurse through children
  var child = node.firstChild;
  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
      (function () {
        var anchor = child;
        var entityConfig = {};

        anchorAttr.forEach(function (attr) {
          var anchorAttribute = anchor.getAttribute(attr);
          if (anchorAttribute) {
            entityConfig[attr] = anchorAttribute;
          }
        });

        entityConfig.url = new URI(anchor.href).toString();
        // TODO: update this when we remove DraftEntity completely
        entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
      })();
    } else {
      entityId = undefined;
    }

    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
        generatedChunk = _genFragment.chunk,
        maybeUpdatedEntityMap = _genFragment.entityMap;

    newChunk = generatedChunk;
    newEntityMap = maybeUpdatedEntityMap;

    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
    var sibling = child.nextSibling;

    // Put in a newline to break up blocks inside blocks
    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
      chunk = joinChunks(chunk, getSoftNewlineChunk());
    }
    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }
    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');

  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);

  var safeBody = DOMBuilder(html);
  if (!safeBody) {
    return null;
  }
  lastBlock = null;

  // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.
  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];

  // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to start with.
  var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);

  var chunk = fragment.chunk;
  var newEntityMap = fragment.entityMap;

  // join with previous block to prevent weirdness on paste
  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  }

  // Kill block delimiter at the end
  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  }

  // If we saw no block tags, put an unstyled one in
  if (chunk.blocks.length === 0) {
    chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
      type: 'unstyled',
      depth: 0
    }));
  }

  // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content
  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
  }

  return { chunk: chunk, entityMap: newEntityMap };
};

var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
    return null;
  }

  var initialState = {
    cacheRef: {},
    contentBlocks: []
  };

  var start = 0;

  var rawBlocks = chunk.blocks,
      rawInlines = chunk.inlines,
      rawEntities = chunk.entities;


  var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);

    var block = rawBlocks[index];
    var end = start + textBlock.length;
    var inlines = rawInlines.slice(start, end);
    var entities = rawEntities.slice(start, end);
    var characterList = List(inlines.map(function (style, index) {
      var data = { style: style, entity: null };
      if (entities[index]) {
        data.entity = entities[index];
      }
      return CharacterMetadata.create(data);
    }));
    start = end + 1;

    var depth = block.depth,
        type = block.type,
        parent = block.parent;


    var key = block.key || generateRandomKey();
    var parentTextNodeKey = null; // will be used to store container text nodes

    // childrens add themselves to their parents since we are iterating in order
    if (parent) {
      var parentIndex = acc.cacheRef[parent];
      var parentRecord = acc.contentBlocks[parentIndex];

      // if parent has text we need to split it into a separate unstyled element
      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
        var parentCharacterList = parentRecord.getCharacterList();
        var parentText = parentRecord.getText();
        parentTextNodeKey = generateRandomKey();

        var textNode = new ContentBlockNode({
          key: parentTextNodeKey,
          text: parentText,
          characterList: parentCharacterList,
          parent: parent,
          nextSibling: key
        });

        acc.contentBlocks.push(textNode);

        parentRecord = parentRecord.withMutations(function (block) {
          block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
        });
      }

      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
    }

    var blockNode = new BlockNodeRecord({
      key: key,
      parent: parent,
      type: type,
      depth: depth,
      text: textBlock,
      characterList: characterList,
      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
    });

    // insert node
    acc.contentBlocks.push(blockNode);

    // cache ref for building links
    acc.cacheRef[blockNode.key] = index;

    return acc;
  }, initialState).contentBlocks;
};

var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;

  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.

  // TODO: replace DraftEntity with an OrderedMap here
  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);

  if (chunkData == null) {
    return null;
  }

  var chunk = chunkData.chunk,
      entityMap = chunkData.entityMap;

  var contentBlocks = convertChunkToContentBlocks(chunk);

  return {
    contentBlocks: contentBlocks,
    entityMap: entityMap
  };
};

module.exports = convertFromHTMLtoContentBlocks;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSafeBodyFromHTML
 * @format
 * 
 */



var UserAgent = __webpack_require__(145);

var invariant = __webpack_require__(47);

var isOldIE = UserAgent.isBrowser('IE <= 9');

// Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null;
  // Provides a safe context
  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }
  return root;
}

module.exports = getSafeBodyFromHTML;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule RichTextEditorUtil
 * @format
 * 
 */



var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);
var SelectionState = __webpack_require__(271);

var adjustBlockDepthForContentState = __webpack_require__(2180);
var nullthrows = __webpack_require__(130);

var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },

  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },

  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return { url: uri.toString() };
  },

  handleKeyCommand: function handleKeyCommand(editorState, command) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);
      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);
      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);
      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },

  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);

    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');

    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    }

    // First, try to remove a preceding atomic block.
    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });
      if (withoutAtomicBlock !== content) {
        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    }

    // If that doesn't succeed, try to remove the current block style.
    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },

  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();
    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength();

    // The cursor is somewhere within the text. Behave normally.
    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });

    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },

  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();
    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();
    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();

    // Only allow indenting one level beyond the block above, and only if
    // the block above is a list item as well.
    var blockAbove = content.getBlockBefore(key);
    if (!blockAbove) {
      return editorState;
    }

    var typeAbove = blockAbove.getType();
    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
      return editorState;
    }

    var depth = block.getDepth();
    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);

    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);

    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
  },

  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection;

    // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.
    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;

    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
  },

  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle();

    // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.
    if (selection.isCollapsed()) {
      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    }

    // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.
    var content = editorState.getCurrentContent();
    var newContent;

    // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.
    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState.push(editorState, newContent, 'change-inline-style');
  },

  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);

    return EditorState.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of the first styled block, or
   * an empty styled block, changes block to 'unstyled'. Returns null if
   * block or selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();
    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);

      var firstBlock = content.getFirstBlock();
      if (block.getLength() > 0 && block !== firstBlock) {
        return null;
      }

      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);
      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier.setBlockType(content, selection, 'unstyled');
      }
    }
    return null;
  }
};

module.exports = RichTextEditorUtil;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDefaultKeyBinding
 * @format
 * 
 */



var KeyBindingUtil = __webpack_require__(616);
var Keys = __webpack_require__(610);
var UserAgent = __webpack_require__(145);

var isOSX = UserAgent.isPlatform('Mac OS X');
var isWindows = UserAgent.isPlatform('Windows');

// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.
var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');

var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;


function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand(e);
}

/**
 * Get the appropriate undo/redo command for a Z key command.
 */
function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }
  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for Windows on Shift + Delete.
  if (isWindows && e.shiftKey) {
    return null;
  }
  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX) {
    return 'backspace-to-start-of-line';
  }
  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}

/**
 * Retrieve a bound key command for the given event.
 */
function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;
    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;
    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;
    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;
    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;
    case 75:
      // K
      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;
    case 84:
      // T
      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;
    case 87:
      // W
      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isWindows ? 'redo' : 'secondary-paste';
      }
      return null;
    case 90:
      // Z
      return getZCommand(e) || null;
    case Keys.RETURN:
      return 'split-block';
    case Keys.DELETE:
      return getDeleteCommand(e);
    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
    default:
      return null;
  }
}

module.exports = getDefaultKeyBinding;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftStringKey
 * @format
 * 
 */



var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },

  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};

module.exports = DraftStringKey;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastContainer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _core = __webpack_require__(165);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(161);

var _ToastElement = __webpack_require__(622);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
/** @jsx jsx */

var placements = {
  'top-left': { top: 0, left: 0 },
  'top-center': { top: 0, left: '50%', transform: 'translateX(-50%)' },
  'top-right': { top: 0, right: 0 },
  'bottom-left': { bottom: 0, left: 0 },
  'bottom-center': { bottom: 0, left: '50%', transform: 'translateX(-50%)' },
  'bottom-right': { bottom: 0, right: 0 }
};

var ToastContainer = function ToastContainer(_ref) {
  var hasToasts = _ref.hasToasts,
      placement = _ref.placement,
      props = _objectWithoutProperties(_ref, ['hasToasts', 'placement']);

  return (0, _core.jsx)('div', _extends({
    className: 'react-toast-notifications__container',
    css: _extends({
      boxSizing: 'border-box',
      maxHeight: '100%',
      overflowX: 'hidden',
      overflowY: 'auto',
      padding: _ToastElement.gutter,
      pointerEvents: hasToasts ? null : 'none',
      position: 'fixed',
      zIndex: 1000
    }, placements[placement])
  }, props));
};
exports.ToastContainer = ToastContainer;

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_weak_memoize__ = __webpack_require__(1059);




// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var delimiter = '/*|*/';
var needle = delimiter + '}';

function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + '}');
  }
}

var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    // property
    case 1:
      {
        switch (content.charCodeAt(0)) {
          case 64:
            {
              // @import
              Sheet.current.insert(content + ';');
              return '';
            }
          // charcode for l

          case 108:
            {
              // charcode for b
              // this ignores label
              if (content.charCodeAt(2) === 98) {
                return '';
              }
            }
        }

        break;
      }
    // selector

    case 2:
      {
        if (ns === 0) return content + delimiter;
        break;
      }
    // at-rule

    case 3:
      {
        switch (ns) {
          // @font-face, @page
          case 102:
          case 112:
            {
              Sheet.current.insert(selectors[0] + content);
              return '';
            }

          default:
            {
              return content + (at === 0 ? delimiter : '');
            }
        }
      }

    case -2:
      {
        content.split(needle).forEach(toSheet);
      }
  }
};

var createCache = function createCache(options) {
  if (options === undefined) options = {};
  var key = options.key || 'css';
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_1__emotion_stylis__["a" /* default */](stylisOptions);

  if (false) {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;

  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function (node) {
      var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

      attrib.split(' ').forEach(function (id) {
        inserted[id] = true;
      });

      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }

  var _insert;

  {
    stylis.use(options.stylisPlugins)(ruleSheet);

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;

      if (false) {
        var map = serialized.map;
        Sheet.current = {
          insert: function insert(rule) {
            sheet.insert(rule + map);
          }
        };
      }

      stylis(selector, serialized.styles);

      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }

  if (false) {
    // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
    var commentStart = /\/\*/g;
    var commentEnd = /\*\//g;
    stylis.use(function (context, content) {
      switch (context) {
        case -1:
          {
            while (commentStart.test(content)) {
              commentEnd.lastIndex = commentStart.lastIndex;

              if (commentEnd.test(content)) {
                commentStart.lastIndex = commentEnd.lastIndex;
                continue;
              }

              throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
            }

            commentStart.lastIndex = 0;
            break;
          }
      }
    });
    stylis.use(function (context, content, selectors) {
      switch (context) {
        case -1:
          {
            var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
            var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

            if (unsafePseudoClasses && cache.compat !== true) {
              unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                var ignore = ignoreRegExp.test(content);

                if (unsafePseudoClass && !ignore) {
                  console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                }
              });
            }

            break;
          }
      }
    });
  }

  var cache = {
    key: key,
    sheet: new __WEBPACK_IMPORTED_MODULE_0__emotion_sheet__["a" /* StyleSheet */]({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};

/* harmony default export */ __webpack_exports__["a"] = (createCache);


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleSheet; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      var _tag = createStyleElement(this);

      var before;

      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }

      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is a really hot path
        // we check the second character first because having "i"
        // as the second character will happen less often than
        // having "@" as the first character
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools

        sheet.insertRule(rule, // we need to insert @import rules before anything else
        // otherwise there will be an error
        // technically this means that the @import rules will
        // _usually_(not always since there could be multiple style tags)
        // be the first ones in prod and generally later in dev
        // this shouldn't really matter in the real world though
        // @import is generally only used for font faces from google fonts and etc.
        // so while this could be technically correct then it would be slower and larger
        // for a tiny bit of correctness that won't matter in the real world
        isImportRule ? 0 : sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();




/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (weakMemoize);


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return insertStyles; });
var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};




/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(276);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(627);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(2242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(1070);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(2243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(2245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(633);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSymbols_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stubArray_js__ = __webpack_require__(1071);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_3__stubArray_js__["a" /* default */] : function(object) {
  var result = [];
  while (object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, Object(__WEBPACK_IMPORTED_MODULE_2__getSymbols_js__["a" /* default */])(object));
    object = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object);
  }
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbolsIn);


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(277);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(131);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(147);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(2273);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomPicker = exports.TwitterPicker = exports.SwatchesPicker = exports.SliderPicker = exports.SketchPicker = exports.PhotoshopPicker = exports.MaterialPicker = exports.HuePicker = exports.GithubPicker = exports.CompactPicker = exports.ChromePicker = exports.default = exports.CirclePicker = exports.BlockPicker = exports.AlphaPicker = undefined;

var _Alpha = __webpack_require__(2284);

Object.defineProperty(exports, 'AlphaPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Block = __webpack_require__(2447);

Object.defineProperty(exports, 'BlockPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Block).default;
  }
});

var _Circle = __webpack_require__(2488);

Object.defineProperty(exports, 'CirclePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _Chrome = __webpack_require__(2490);

Object.defineProperty(exports, 'ChromePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Chrome).default;
  }
});

var _Compact = __webpack_require__(2496);

Object.defineProperty(exports, 'CompactPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Compact).default;
  }
});

var _Github = __webpack_require__(2499);

Object.defineProperty(exports, 'GithubPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Github).default;
  }
});

var _Hue = __webpack_require__(2501);

Object.defineProperty(exports, 'HuePicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Material = __webpack_require__(2503);

Object.defineProperty(exports, 'MaterialPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Material).default;
  }
});

var _Photoshop = __webpack_require__(2504);

Object.defineProperty(exports, 'PhotoshopPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Photoshop).default;
  }
});

var _Sketch = __webpack_require__(2510);

Object.defineProperty(exports, 'SketchPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sketch).default;
  }
});

var _Slider = __webpack_require__(2513);

Object.defineProperty(exports, 'SliderPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Slider).default;
  }
});

var _Swatches = __webpack_require__(2517);

Object.defineProperty(exports, 'SwatchesPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatches).default;
  }
});

var _Twitter = __webpack_require__(2521);

Object.defineProperty(exports, 'TwitterPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Twitter).default;
  }
});

var _ColorWrap = __webpack_require__(1115);

Object.defineProperty(exports, 'CustomPicker', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Chrome2 = _interopRequireDefault(_Chrome);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chrome2.default;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(2287),
    keys = __webpack_require__(331);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(2289),
    isArguments = __webpack_require__(1081),
    isArray = __webpack_require__(123),
    isBuffer = __webpack_require__(642),
    isIndex = __webpack_require__(1082),
    isTypedArray = __webpack_require__(1083);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(2290),
    isObjectLike = __webpack_require__(196);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 1082 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(2292),
    baseUnary = __webpack_require__(2293),
    nodeUtil = __webpack_require__(2294);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 1084 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1085 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2308),
    isObjectLike = __webpack_require__(196);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(2309),
    arraySome = __webpack_require__(2312),
    cacheHas = __webpack_require__(2313);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(122);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1089 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1090 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1092),
    getSymbols = __webpack_require__(647),
    keys = __webpack_require__(331);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1093),
    isArray = __webpack_require__(123);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 1093 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 1094 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2317),
    Map = __webpack_require__(529),
    Promise = __webpack_require__(2318),
    Set = __webpack_require__(2319),
    WeakMap = __webpack_require__(2320),
    baseGetTag = __webpack_require__(195),
    toSource = __webpack_require__(798);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(155);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 1097 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(1099),
    eq = __webpack_require__(528);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(2336);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1080),
    baseKeysIn = __webpack_require__(2339),
    isArrayLike = __webpack_require__(439);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(1093),
    getPrototype = __webpack_require__(645),
    getSymbols = __webpack_require__(647),
    stubArray = __webpack_require__(1094);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 1102 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(654),
    eq = __webpack_require__(332);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2398);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(132);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1110);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 1110 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1111 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1113),
    baseKeysIn = __webpack_require__(2417),
    isArrayLike = __webpack_require__(280);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(2416),
    isArguments = __webpack_require__(656),
    isArray = __webpack_require__(134),
    isBuffer = __webpack_require__(658),
    isIndex = __webpack_require__(660),
    isTypedArray = __webpack_require__(659);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(133),
    now = __webpack_require__(2430),
    toNumber = __webpack_require__(2431);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorWrap = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _debounce = __webpack_require__(1114);

var _debounce2 = _interopRequireDefault(_debounce);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = exports.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck(this, ColorPicker);

      var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = _color2.default.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = _color2.default.toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends({}, _color2.default.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2.default.createElement(Picker, _extends({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends({}, _color2.default.toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(_react.PureComponent || _react.Component);

  ColorPicker.propTypes = _extends({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

exports.default = ColorWrap;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(2438),
    createBaseEach = __webpack_require__(2441);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1117 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2452),
    isObjectLike = __webpack_require__(222);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(2453),
    arraySome = __webpack_require__(2456),
    cacheHas = __webpack_require__(2457);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(133);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 1121 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(1123),
    toKey = __webpack_require__(448);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(134),
    isKey = __webpack_require__(662),
    stringToPath = __webpack_require__(2476),
    toString = __webpack_require__(2479);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "red", function() { return red; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pink", function() { return pink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "purple", function() { return purple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepPurple", function() { return deepPurple; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indigo", function() { return indigo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blue", function() { return blue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightBlue", function() { return lightBlue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cyan", function() { return cyan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "teal", function() { return teal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "green", function() { return green; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightGreen", function() { return lightGreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lime", function() { return lime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yellow", function() { return yellow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "amber", function() { return amber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orange", function() { return orange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepOrange", function() { return deepOrange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "brown", function() { return brown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "grey", function() { return grey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blueGrey", function() { return blueGrey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkText", function() { return darkText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightText", function() { return lightText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkIcons", function() { return darkIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lightIcons", function() { return lightIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "white", function() { return white; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "black", function() { return black; });
var red = {"50":"#ffebee","100":"#ffcdd2","200":"#ef9a9a","300":"#e57373","400":"#ef5350","500":"#f44336","600":"#e53935","700":"#d32f2f","800":"#c62828","900":"#b71c1c","a100":"#ff8a80","a200":"#ff5252","a400":"#ff1744","a700":"#d50000"};
var pink = {"50":"#fce4ec","100":"#f8bbd0","200":"#f48fb1","300":"#f06292","400":"#ec407a","500":"#e91e63","600":"#d81b60","700":"#c2185b","800":"#ad1457","900":"#880e4f","a100":"#ff80ab","a200":"#ff4081","a400":"#f50057","a700":"#c51162"};
var purple = {"50":"#f3e5f5","100":"#e1bee7","200":"#ce93d8","300":"#ba68c8","400":"#ab47bc","500":"#9c27b0","600":"#8e24aa","700":"#7b1fa2","800":"#6a1b9a","900":"#4a148c","a100":"#ea80fc","a200":"#e040fb","a400":"#d500f9","a700":"#aa00ff"};
var deepPurple = {"50":"#ede7f6","100":"#d1c4e9","200":"#b39ddb","300":"#9575cd","400":"#7e57c2","500":"#673ab7","600":"#5e35b1","700":"#512da8","800":"#4527a0","900":"#311b92","a100":"#b388ff","a200":"#7c4dff","a400":"#651fff","a700":"#6200ea"};
var indigo = {"50":"#e8eaf6","100":"#c5cae9","200":"#9fa8da","300":"#7986cb","400":"#5c6bc0","500":"#3f51b5","600":"#3949ab","700":"#303f9f","800":"#283593","900":"#1a237e","a100":"#8c9eff","a200":"#536dfe","a400":"#3d5afe","a700":"#304ffe"};
var blue = {"50":"#e3f2fd","100":"#bbdefb","200":"#90caf9","300":"#64b5f6","400":"#42a5f5","500":"#2196f3","600":"#1e88e5","700":"#1976d2","800":"#1565c0","900":"#0d47a1","a100":"#82b1ff","a200":"#448aff","a400":"#2979ff","a700":"#2962ff"};
var lightBlue = {"50":"#e1f5fe","100":"#b3e5fc","200":"#81d4fa","300":"#4fc3f7","400":"#29b6f6","500":"#03a9f4","600":"#039be5","700":"#0288d1","800":"#0277bd","900":"#01579b","a100":"#80d8ff","a200":"#40c4ff","a400":"#00b0ff","a700":"#0091ea"};
var cyan = {"50":"#e0f7fa","100":"#b2ebf2","200":"#80deea","300":"#4dd0e1","400":"#26c6da","500":"#00bcd4","600":"#00acc1","700":"#0097a7","800":"#00838f","900":"#006064","a100":"#84ffff","a200":"#18ffff","a400":"#00e5ff","a700":"#00b8d4"};
var teal = {"50":"#e0f2f1","100":"#b2dfdb","200":"#80cbc4","300":"#4db6ac","400":"#26a69a","500":"#009688","600":"#00897b","700":"#00796b","800":"#00695c","900":"#004d40","a100":"#a7ffeb","a200":"#64ffda","a400":"#1de9b6","a700":"#00bfa5"};
var green = {"50":"#e8f5e9","100":"#c8e6c9","200":"#a5d6a7","300":"#81c784","400":"#66bb6a","500":"#4caf50","600":"#43a047","700":"#388e3c","800":"#2e7d32","900":"#1b5e20","a100":"#b9f6ca","a200":"#69f0ae","a400":"#00e676","a700":"#00c853"};
var lightGreen = {"50":"#f1f8e9","100":"#dcedc8","200":"#c5e1a5","300":"#aed581","400":"#9ccc65","500":"#8bc34a","600":"#7cb342","700":"#689f38","800":"#558b2f","900":"#33691e","a100":"#ccff90","a200":"#b2ff59","a400":"#76ff03","a700":"#64dd17"};
var lime = {"50":"#f9fbe7","100":"#f0f4c3","200":"#e6ee9c","300":"#dce775","400":"#d4e157","500":"#cddc39","600":"#c0ca33","700":"#afb42b","800":"#9e9d24","900":"#827717","a100":"#f4ff81","a200":"#eeff41","a400":"#c6ff00","a700":"#aeea00"};
var yellow = {"50":"#fffde7","100":"#fff9c4","200":"#fff59d","300":"#fff176","400":"#ffee58","500":"#ffeb3b","600":"#fdd835","700":"#fbc02d","800":"#f9a825","900":"#f57f17","a100":"#ffff8d","a200":"#ffff00","a400":"#ffea00","a700":"#ffd600"};
var amber = {"50":"#fff8e1","100":"#ffecb3","200":"#ffe082","300":"#ffd54f","400":"#ffca28","500":"#ffc107","600":"#ffb300","700":"#ffa000","800":"#ff8f00","900":"#ff6f00","a100":"#ffe57f","a200":"#ffd740","a400":"#ffc400","a700":"#ffab00"};
var orange = {"50":"#fff3e0","100":"#ffe0b2","200":"#ffcc80","300":"#ffb74d","400":"#ffa726","500":"#ff9800","600":"#fb8c00","700":"#f57c00","800":"#ef6c00","900":"#e65100","a100":"#ffd180","a200":"#ffab40","a400":"#ff9100","a700":"#ff6d00"};
var deepOrange = {"50":"#fbe9e7","100":"#ffccbc","200":"#ffab91","300":"#ff8a65","400":"#ff7043","500":"#ff5722","600":"#f4511e","700":"#e64a19","800":"#d84315","900":"#bf360c","a100":"#ff9e80","a200":"#ff6e40","a400":"#ff3d00","a700":"#dd2c00"};
var brown = {"50":"#efebe9","100":"#d7ccc8","200":"#bcaaa4","300":"#a1887f","400":"#8d6e63","500":"#795548","600":"#6d4c41","700":"#5d4037","800":"#4e342e","900":"#3e2723"};
var grey = {"50":"#fafafa","100":"#f5f5f5","200":"#eeeeee","300":"#e0e0e0","400":"#bdbdbd","500":"#9e9e9e","600":"#757575","700":"#616161","800":"#424242","900":"#212121"};
var blueGrey = {"50":"#eceff1","100":"#cfd8dc","200":"#b0bec5","300":"#90a4ae","400":"#78909c","500":"#607d8b","600":"#546e7a","700":"#455a64","800":"#37474f","900":"#263238"};
var darkText = {"primary":"rgba(0, 0, 0, 0.87)","secondary":"rgba(0, 0, 0, 0.54)","disabled":"rgba(0, 0, 0, 0.38)","dividers":"rgba(0, 0, 0, 0.12)"};
var lightText = {"primary":"rgba(255, 255, 255, 1)","secondary":"rgba(255, 255, 255, 0.7)","disabled":"rgba(255, 255, 255, 0.5)","dividers":"rgba(255, 255, 255, 0.12)"};
var darkIcons = {"active":"rgba(0, 0, 0, 0.54)","inactive":"rgba(0, 0, 0, 0.38)"};
var lightIcons = {"active":"rgba(255, 255, 255, 1)","inactive":"rgba(255, 255, 255, 0.5)"};
var white = "#ffffff";
var black = "#000000";

/* harmony default export */ __webpack_exports__["default"] = ({
  red: red,
  pink: pink,
  purple: purple,
  deepPurple: deepPurple,
  indigo: indigo,
  blue: blue,
  lightBlue: lightBlue,
  cyan: cyan,
  teal: teal,
  green: green,
  lightGreen: lightGreen,
  lime: lime,
  yellow: yellow,
  amber: amber,
  orange: orange,
  deepOrange: deepOrange,
  brown: brown,
  grey: grey,
  blueGrey: blueGrey,
  darkText: darkText,
  lightText: lightText,
  darkIcons: darkIcons,
  lightIcons: lightIcons,
  white: white,
  black: black
});


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var Konva = __webpack_require__(1126).Konva;
Konva._injectGlobal(Konva);
exports['default'] = Konva;
Konva.default = Konva;
module.exports = exports['default'];


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Global_1 = __webpack_require__(38);
var Util_1 = __webpack_require__(43);
var Node_1 = __webpack_require__(60);
var Container_1 = __webpack_require__(450);
var Stage_1 = __webpack_require__(2530);
var Layer_1 = __webpack_require__(1129);
var FastLayer_1 = __webpack_require__(2531);
var Group_1 = __webpack_require__(665);
var DragAndDrop_1 = __webpack_require__(664);
var Shape_1 = __webpack_require__(68);
var Animation_1 = __webpack_require__(666);
var Tween_1 = __webpack_require__(2532);
var Context_1 = __webpack_require__(1127);
var Canvas_1 = __webpack_require__(449);
exports.Konva = Util_1.Util._assign(Global_1.Konva, {
    Collection: Util_1.Collection,
    Util: Util_1.Util,
    Transform: Util_1.Transform,
    Node: Node_1.Node,
    ids: Node_1.ids,
    names: Node_1.names,
    Container: Container_1.Container,
    Stage: Stage_1.Stage,
    stages: Stage_1.stages,
    Layer: Layer_1.Layer,
    FastLayer: FastLayer_1.FastLayer,
    Group: Group_1.Group,
    DD: DragAndDrop_1.DD,
    Shape: Shape_1.Shape,
    shapes: Shape_1.shapes,
    Animation: Animation_1.Animation,
    Tween: Tween_1.Tween,
    Easings: Tween_1.Easings,
    Context: Context_1.Context,
    Canvas: Canvas_1.Canvas
});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Global_1 = __webpack_require__(38);
var COMMA = ',', OPEN_PAREN = '(', CLOSE_PAREN = ')', OPEN_PAREN_BRACKET = '([', CLOSE_BRACKET_PAREN = '])', SEMICOLON = ';', DOUBLE_PAREN = '()', EQUALS = '=', CONTEXT_METHODS = [
    'arc',
    'arcTo',
    'beginPath',
    'bezierCurveTo',
    'clearRect',
    'clip',
    'closePath',
    'createLinearGradient',
    'createPattern',
    'createRadialGradient',
    'drawImage',
    'ellipse',
    'fill',
    'fillText',
    'getImageData',
    'createImageData',
    'lineTo',
    'moveTo',
    'putImageData',
    'quadraticCurveTo',
    'rect',
    'restore',
    'rotate',
    'save',
    'scale',
    'setLineDash',
    'setTransform',
    'stroke',
    'strokeText',
    'transform',
    'translate',
];
var CONTEXT_PROPERTIES = [
    'fillStyle',
    'strokeStyle',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'lineCap',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'font',
    'textAlign',
    'textBaseline',
    'globalAlpha',
    'globalCompositeOperation',
    'imageSmoothingEnabled',
];
var traceArrMax = 100;
var Context = (function () {
    function Context(canvas) {
        this.canvas = canvas;
        this._context = canvas._canvas.getContext('2d');
        if (Global_1.Konva.enableTrace) {
            this.traceArr = [];
            this._enableTrace();
        }
    }
    Context.prototype.fillShape = function (shape) {
        if (shape.fillEnabled()) {
            this._fill(shape);
        }
    };
    Context.prototype._fill = function (shape) {
    };
    Context.prototype.strokeShape = function (shape) {
        if (shape.hasStroke()) {
            this._stroke(shape);
        }
    };
    Context.prototype._stroke = function (shape) {
    };
    Context.prototype.fillStrokeShape = function (shape) {
        this.fillShape(shape);
        this.strokeShape(shape);
    };
    Context.prototype.getTrace = function (relaxed) {
        var traceArr = this.traceArr, len = traceArr.length, str = '', n, trace, method, args;
        for (n = 0; n < len; n++) {
            trace = traceArr[n];
            method = trace.method;
            if (method) {
                args = trace.args;
                str += method;
                if (relaxed) {
                    str += DOUBLE_PAREN;
                }
                else {
                    if (Util_1.Util._isArray(args[0])) {
                        str += OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
                    }
                    else {
                        str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
                    }
                }
            }
            else {
                str += trace.property;
                if (!relaxed) {
                    str += EQUALS + trace.val;
                }
            }
            str += SEMICOLON;
        }
        return str;
    };
    Context.prototype.clearTrace = function () {
        this.traceArr = [];
    };
    Context.prototype._trace = function (str) {
        var traceArr = this.traceArr, len;
        traceArr.push(str);
        len = traceArr.length;
        if (len >= traceArrMax) {
            traceArr.shift();
        }
    };
    Context.prototype.reset = function () {
        var pixelRatio = this.getCanvas().getPixelRatio();
        this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
    };
    Context.prototype.getCanvas = function () {
        return this.canvas;
    };
    Context.prototype.clear = function (bounds) {
        var canvas = this.getCanvas();
        if (bounds) {
            this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
        }
        else {
            this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
        }
    };
    Context.prototype._applyLineCap = function (shape) {
        var lineCap = shape.getLineCap();
        if (lineCap) {
            this.setAttr('lineCap', lineCap);
        }
    };
    Context.prototype._applyOpacity = function (shape) {
        var absOpacity = shape.getAbsoluteOpacity();
        if (absOpacity !== 1) {
            this.setAttr('globalAlpha', absOpacity);
        }
    };
    Context.prototype._applyLineJoin = function (shape) {
        var lineJoin = shape.attrs.lineJoin;
        if (lineJoin) {
            this.setAttr('lineJoin', lineJoin);
        }
    };
    Context.prototype.setAttr = function (attr, val) {
        this._context[attr] = val;
    };
    Context.prototype.arc = function (a0, a1, a2, a3, a4, a5) {
        this._context.arc(a0, a1, a2, a3, a4, a5);
    };
    Context.prototype.arcTo = function (a0, a1, a2, a3, a4) {
        this._context.arcTo(a0, a1, a2, a3, a4);
    };
    Context.prototype.beginPath = function () {
        this._context.beginPath();
    };
    Context.prototype.bezierCurveTo = function (a0, a1, a2, a3, a4, a5) {
        this._context.bezierCurveTo(a0, a1, a2, a3, a4, a5);
    };
    Context.prototype.clearRect = function (a0, a1, a2, a3) {
        this._context.clearRect(a0, a1, a2, a3);
    };
    Context.prototype.clip = function () {
        this._context.clip();
    };
    Context.prototype.closePath = function () {
        this._context.closePath();
    };
    Context.prototype.createImageData = function (a0, a1) {
        var a = arguments;
        if (a.length === 2) {
            return this._context.createImageData(a0, a1);
        }
        else if (a.length === 1) {
            return this._context.createImageData(a0);
        }
    };
    Context.prototype.createLinearGradient = function (a0, a1, a2, a3) {
        return this._context.createLinearGradient(a0, a1, a2, a3);
    };
    Context.prototype.createPattern = function (a0, a1) {
        return this._context.createPattern(a0, a1);
    };
    Context.prototype.createRadialGradient = function (a0, a1, a2, a3, a4, a5) {
        return this._context.createRadialGradient(a0, a1, a2, a3, a4, a5);
    };
    Context.prototype.drawImage = function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        var a = arguments, _context = this._context;
        if (a.length === 3) {
            _context.drawImage(a0, a1, a2);
        }
        else if (a.length === 5) {
            _context.drawImage(a0, a1, a2, a3, a4);
        }
        else if (a.length === 9) {
            _context.drawImage(a0, a1, a2, a3, a4, a5, a6, a7, a8);
        }
    };
    Context.prototype.ellipse = function (a0, a1, a2, a3, a4, a5, a6, a7) {
        this._context.ellipse(a0, a1, a2, a3, a4, a5, a6, a7);
    };
    Context.prototype.isPointInPath = function (x, y) {
        return this._context.isPointInPath(x, y);
    };
    Context.prototype.fill = function () {
        this._context.fill();
    };
    Context.prototype.fillRect = function (x, y, width, height) {
        this._context.fillRect(x, y, width, height);
    };
    Context.prototype.strokeRect = function (x, y, width, height) {
        this._context.strokeRect(x, y, width, height);
    };
    Context.prototype.fillText = function (a0, a1, a2) {
        this._context.fillText(a0, a1, a2);
    };
    Context.prototype.measureText = function (text) {
        return this._context.measureText(text);
    };
    Context.prototype.getImageData = function (a0, a1, a2, a3) {
        return this._context.getImageData(a0, a1, a2, a3);
    };
    Context.prototype.lineTo = function (a0, a1) {
        this._context.lineTo(a0, a1);
    };
    Context.prototype.moveTo = function (a0, a1) {
        this._context.moveTo(a0, a1);
    };
    Context.prototype.rect = function (a0, a1, a2, a3) {
        this._context.rect(a0, a1, a2, a3);
    };
    Context.prototype.putImageData = function (a0, a1, a2) {
        this._context.putImageData(a0, a1, a2);
    };
    Context.prototype.quadraticCurveTo = function (a0, a1, a2, a3) {
        this._context.quadraticCurveTo(a0, a1, a2, a3);
    };
    Context.prototype.restore = function () {
        this._context.restore();
    };
    Context.prototype.rotate = function (a0) {
        this._context.rotate(a0);
    };
    Context.prototype.save = function () {
        this._context.save();
    };
    Context.prototype.scale = function (a0, a1) {
        this._context.scale(a0, a1);
    };
    Context.prototype.setLineDash = function (a0) {
        if (this._context.setLineDash) {
            this._context.setLineDash(a0);
        }
        else if ('mozDash' in this._context) {
            this._context['mozDash'] = a0;
        }
        else if ('webkitLineDash' in this._context) {
            this._context['webkitLineDash'] = a0;
        }
    };
    Context.prototype.getLineDash = function () {
        return this._context.getLineDash();
    };
    Context.prototype.setTransform = function (a0, a1, a2, a3, a4, a5) {
        this._context.setTransform(a0, a1, a2, a3, a4, a5);
    };
    Context.prototype.stroke = function () {
        this._context.stroke();
    };
    Context.prototype.strokeText = function (a0, a1, a2, a3) {
        this._context.strokeText(a0, a1, a2, a3);
    };
    Context.prototype.transform = function (a0, a1, a2, a3, a4, a5) {
        this._context.transform(a0, a1, a2, a3, a4, a5);
    };
    Context.prototype.translate = function (a0, a1) {
        this._context.translate(a0, a1);
    };
    Context.prototype._enableTrace = function () {
        var that = this, len = CONTEXT_METHODS.length, _simplifyArray = Util_1.Util._simplifyArray, origSetter = this.setAttr, n, args;
        var func = function (methodName) {
            var origMethod = that[methodName], ret;
            that[methodName] = function () {
                args = _simplifyArray(Array.prototype.slice.call(arguments, 0));
                ret = origMethod.apply(that, arguments);
                that._trace({
                    method: methodName,
                    args: args,
                });
                return ret;
            };
        };
        for (n = 0; n < len; n++) {
            func(CONTEXT_METHODS[n]);
        }
        that.setAttr = function () {
            origSetter.apply(that, arguments);
            var prop = arguments[0];
            var val = arguments[1];
            if (prop === 'shadowOffsetX' ||
                prop === 'shadowOffsetY' ||
                prop === 'shadowBlur') {
                val = val / this.canvas.getPixelRatio();
            }
            that._trace({
                property: prop,
                val: val,
            });
        };
    };
    Context.prototype._applyGlobalCompositeOperation = function (node) {
        var globalCompositeOperation = node.getGlobalCompositeOperation();
        if (globalCompositeOperation !== 'source-over') {
            this.setAttr('globalCompositeOperation', globalCompositeOperation);
        }
    };
    return Context;
}());
exports.Context = Context;
CONTEXT_PROPERTIES.forEach(function (prop) {
    Object.defineProperty(Context.prototype, prop, {
        get: function () {
            return this._context[prop];
        },
        set: function (val) {
            this._context[prop] = val;
        },
    });
});
var SceneContext = (function (_super) {
    __extends(SceneContext, _super);
    function SceneContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SceneContext.prototype._fillColor = function (shape) {
        var fill = shape.fill();
        this.setAttr('fillStyle', fill);
        shape._fillFunc(this);
    };
    SceneContext.prototype._fillPattern = function (shape) {
        var fillPatternX = shape.getFillPatternX(), fillPatternY = shape.getFillPatternY(), fillPatternRotation = Global_1.Konva.getAngle(shape.getFillPatternRotation()), fillPatternOffsetX = shape.getFillPatternOffsetX(), fillPatternOffsetY = shape.getFillPatternOffsetY(), fillPatternScaleX = shape.getFillPatternScaleX(), fillPatternScaleY = shape.getFillPatternScaleY();
        if (fillPatternX || fillPatternY) {
            this.translate(fillPatternX || 0, fillPatternY || 0);
        }
        if (fillPatternRotation) {
            this.rotate(fillPatternRotation);
        }
        if (fillPatternScaleX || fillPatternScaleY) {
            this.scale(fillPatternScaleX, fillPatternScaleY);
        }
        if (fillPatternOffsetX || fillPatternOffsetY) {
            this.translate(-1 * fillPatternOffsetX, -1 * fillPatternOffsetY);
        }
        this.setAttr('fillStyle', shape._getFillPattern());
        shape._fillFunc(this);
    };
    SceneContext.prototype._fillLinearGradient = function (shape) {
        var grd = shape._getLinearGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    };
    SceneContext.prototype._fillRadialGradient = function (shape) {
        var grd = shape._getRadialGradient();
        if (grd) {
            this.setAttr('fillStyle', grd);
            shape._fillFunc(this);
        }
    };
    SceneContext.prototype._fill = function (shape) {
        var hasColor = shape.fill(), fillPriority = shape.getFillPriority();
        if (hasColor && fillPriority === 'color') {
            this._fillColor(shape);
            return;
        }
        var hasPattern = shape.getFillPatternImage();
        if (hasPattern && fillPriority === 'pattern') {
            this._fillPattern(shape);
            return;
        }
        var hasLinearGradient = shape.getFillLinearGradientColorStops();
        if (hasLinearGradient && fillPriority === 'linear-gradient') {
            this._fillLinearGradient(shape);
            return;
        }
        var hasRadialGradient = shape.getFillRadialGradientColorStops();
        if (hasRadialGradient && fillPriority === 'radial-gradient') {
            this._fillRadialGradient(shape);
            return;
        }
        if (hasColor) {
            this._fillColor(shape);
        }
        else if (hasPattern) {
            this._fillPattern(shape);
        }
        else if (hasLinearGradient) {
            this._fillLinearGradient(shape);
        }
        else if (hasRadialGradient) {
            this._fillRadialGradient(shape);
        }
    };
    SceneContext.prototype._strokeLinearGradient = function (shape) {
        var start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
        if (colorStops) {
            for (var n = 0; n < colorStops.length; n += 2) {
                grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            this.setAttr('strokeStyle', grd);
        }
    };
    SceneContext.prototype._stroke = function (shape) {
        var dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
        if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
                this.setLineDash(dash);
                this.setAttr('lineDashOffset', shape.dashOffset());
            }
            this.setAttr('lineWidth', shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) {
                this.setAttr('shadowColor', 'rgba(0,0,0,0)');
            }
            var hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) {
                this._strokeLinearGradient(shape);
            }
            else {
                this.setAttr('strokeStyle', shape.stroke());
            }
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) {
                this.restore();
            }
        }
    };
    SceneContext.prototype._applyShadow = function (shape) {
        var util = Util_1.Util, color = util.get(shape.getShadowRGBA(), 'black'), blur = util.get(shape.getShadowBlur(), 5), offset = util.get(shape.getShadowOffset(), {
            x: 0,
            y: 0,
        }), scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
        this.setAttr('shadowColor', color);
        this.setAttr('shadowBlur', blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
        this.setAttr('shadowOffsetX', offset.x * scaleX);
        this.setAttr('shadowOffsetY', offset.y * scaleY);
    };
    return SceneContext;
}(Context));
exports.SceneContext = SceneContext;
var HitContext = (function (_super) {
    __extends(HitContext, _super);
    function HitContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HitContext.prototype._fill = function (shape) {
        this.save();
        this.setAttr('fillStyle', shape.colorKey);
        shape._fillFuncHit(this);
        this.restore();
    };
    HitContext.prototype.strokeShape = function (shape) {
        if (shape.hasHitStroke()) {
            this._stroke(shape);
        }
    };
    HitContext.prototype._stroke = function (shape) {
        if (shape.hasHitStroke()) {
            var strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
                this.save();
                var pixelRatio = this.getCanvas().getPixelRatio();
                this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            var hitStrokeWidth = shape.hitStrokeWidth();
            var strokeWidth = hitStrokeWidth === 'auto' ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr('lineWidth', strokeWidth);
            this.setAttr('strokeStyle', shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) {
                this.restore();
            }
        }
    };
    return HitContext;
}(Context));
exports.HitContext = HitContext;


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Global_1 = __webpack_require__(38);
var Captures = new Map();
var SUPPORT_POINTER_EVENTS = Global_1.Konva._global['PointerEvent'] !== undefined;
function getCapturedShape(pointerId) {
    return Captures.get(pointerId);
}
exports.getCapturedShape = getCapturedShape;
function createEvent(evt) {
    return {
        evt: evt,
        pointerId: evt.pointerId
    };
}
exports.createEvent = createEvent;
function hasPointerCapture(pointerId, shape) {
    return Captures.get(pointerId) === shape;
}
exports.hasPointerCapture = hasPointerCapture;
function setPointerCapture(pointerId, shape) {
    releaseCapture(pointerId);
    var stage = shape.getStage();
    if (!stage)
        return;
    Captures.set(pointerId, shape);
    if (SUPPORT_POINTER_EVENTS) {
        shape._fire('gotpointercapture', createEvent(new PointerEvent('gotpointercapture')));
    }
}
exports.setPointerCapture = setPointerCapture;
function releaseCapture(pointerId, target) {
    var shape = Captures.get(pointerId);
    if (!shape)
        return;
    var stage = shape.getStage();
    if (stage && stage.content) {
    }
    Captures.delete(pointerId);
    if (SUPPORT_POINTER_EVENTS) {
        shape._fire('lostpointercapture', createEvent(new PointerEvent('lostpointercapture')));
    }
}
exports.releaseCapture = releaseCapture;


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Container_1 = __webpack_require__(450);
var Node_1 = __webpack_require__(60);
var Factory_1 = __webpack_require__(37);
var Canvas_1 = __webpack_require__(449);
var Validators_1 = __webpack_require__(41);
var Shape_1 = __webpack_require__(68);
var Global_1 = __webpack_require__(38);
var HASH = '#', BEFORE_DRAW = 'beforeDraw', DRAW = 'draw', INTERSECTION_OFFSETS = [
    { x: 0, y: 0 },
    { x: -1, y: -1 },
    { x: 1, y: -1 },
    { x: 1, y: 1 },
    { x: -1, y: 1 },
], INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
var Layer = (function (_super) {
    __extends(Layer, _super);
    function Layer(config) {
        var _this = _super.call(this, config) || this;
        _this.canvas = new Canvas_1.SceneCanvas();
        _this.hitCanvas = new Canvas_1.HitCanvas({
            pixelRatio: 1,
        });
        _this._waitingForDraw = false;
        _this.on('visibleChange.konva', _this._checkVisibility);
        _this._checkVisibility();
        _this.on('imageSmoothingEnabledChange.konva', _this._setSmoothEnabled);
        _this._setSmoothEnabled();
        return _this;
    }
    Layer.prototype.createPNGStream = function () {
        var c = this.canvas._canvas;
        return c.createPNGStream();
    };
    Layer.prototype.getCanvas = function () {
        return this.canvas;
    };
    Layer.prototype.getHitCanvas = function () {
        return this.hitCanvas;
    };
    Layer.prototype.getContext = function () {
        return this.getCanvas().getContext();
    };
    Layer.prototype.clear = function (bounds) {
        this.getContext().clear(bounds);
        this.getHitCanvas().getContext().clear(bounds);
        return this;
    };
    Layer.prototype.setZIndex = function (index) {
        _super.prototype.setZIndex.call(this, index);
        var stage = this.getStage();
        if (stage) {
            stage.content.removeChild(this.getCanvas()._canvas);
            if (index < stage.children.length - 1) {
                stage.content.insertBefore(this.getCanvas()._canvas, stage.children[index + 1].getCanvas()._canvas);
            }
            else {
                stage.content.appendChild(this.getCanvas()._canvas);
            }
        }
        return this;
    };
    Layer.prototype.moveToTop = function () {
        Node_1.Node.prototype.moveToTop.call(this);
        var stage = this.getStage();
        if (stage) {
            stage.content.removeChild(this.getCanvas()._canvas);
            stage.content.appendChild(this.getCanvas()._canvas);
        }
        return true;
    };
    Layer.prototype.moveUp = function () {
        var moved = Node_1.Node.prototype.moveUp.call(this);
        if (!moved) {
            return false;
        }
        var stage = this.getStage();
        if (!stage) {
            return false;
        }
        stage.content.removeChild(this.getCanvas()._canvas);
        if (this.index < stage.children.length - 1) {
            stage.content.insertBefore(this.getCanvas()._canvas, stage.children[this.index + 1].getCanvas()._canvas);
        }
        else {
            stage.content.appendChild(this.getCanvas()._canvas);
        }
        return true;
    };
    Layer.prototype.moveDown = function () {
        if (Node_1.Node.prototype.moveDown.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                stage.content.removeChild(this.getCanvas()._canvas);
                stage.content.insertBefore(this.getCanvas()._canvas, children[this.index + 1].getCanvas()._canvas);
            }
            return true;
        }
        return false;
    };
    Layer.prototype.moveToBottom = function () {
        if (Node_1.Node.prototype.moveToBottom.call(this)) {
            var stage = this.getStage();
            if (stage) {
                var children = stage.children;
                stage.content.removeChild(this.getCanvas()._canvas);
                stage.content.insertBefore(this.getCanvas()._canvas, children[1].getCanvas()._canvas);
            }
            return true;
        }
        return false;
    };
    Layer.prototype.getLayer = function () {
        return this;
    };
    Layer.prototype.remove = function () {
        var _canvas = this.getCanvas()._canvas;
        Node_1.Node.prototype.remove.call(this);
        if (_canvas && _canvas.parentNode && Util_1.Util._isInDocument(_canvas)) {
            _canvas.parentNode.removeChild(_canvas);
        }
        return this;
    };
    Layer.prototype.getStage = function () {
        return this.parent;
    };
    Layer.prototype.setSize = function (_a) {
        var width = _a.width, height = _a.height;
        this.canvas.setSize(width, height);
        this.hitCanvas.setSize(width, height);
        this._setSmoothEnabled();
        return this;
    };
    Layer.prototype._validateAdd = function (child) {
        var type = child.getType();
        if (type !== 'Group' && type !== 'Shape') {
            Util_1.Util.throw('You may only add groups and shapes to a layer.');
        }
    };
    Layer.prototype._toKonvaCanvas = function (config) {
        config = config || {};
        config.width = config.width || this.getWidth();
        config.height = config.height || this.getHeight();
        config.x = config.x !== undefined ? config.x : this.x();
        config.y = config.y !== undefined ? config.y : this.y();
        return Node_1.Node.prototype._toKonvaCanvas.call(this, config);
    };
    Layer.prototype._checkVisibility = function () {
        var visible = this.visible();
        if (visible) {
            this.canvas._canvas.style.display = 'block';
        }
        else {
            this.canvas._canvas.style.display = 'none';
        }
    };
    Layer.prototype._setSmoothEnabled = function () {
        this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
    };
    Layer.prototype.getWidth = function () {
        if (this.parent) {
            return this.parent.width();
        }
    };
    Layer.prototype.setWidth = function () {
        Util_1.Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
    };
    Layer.prototype.getHeight = function () {
        if (this.parent) {
            return this.parent.height();
        }
    };
    Layer.prototype.setHeight = function () {
        Util_1.Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
    };
    Layer.prototype.batchDraw = function () {
        var _this = this;
        if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            Util_1.Util.requestAnimFrame(function () {
                _this.draw();
                _this._waitingForDraw = false;
            });
        }
        return this;
    };
    Layer.prototype.getIntersection = function (pos, selector) {
        var obj, i, intersectionOffset, shape;
        if (!this.isListening() || !this.isVisible()) {
            return null;
        }
        var spiralSearchDistance = 1;
        var continueSearch = false;
        while (true) {
            for (i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
                intersectionOffset = INTERSECTION_OFFSETS[i];
                obj = this._getIntersection({
                    x: pos.x + intersectionOffset.x * spiralSearchDistance,
                    y: pos.y + intersectionOffset.y * spiralSearchDistance,
                });
                shape = obj.shape;
                if (shape && selector) {
                    return shape.findAncestor(selector, true);
                }
                else if (shape) {
                    return shape;
                }
                continueSearch = !!obj.antialiased;
                if (!obj.antialiased) {
                    break;
                }
            }
            if (continueSearch) {
                spiralSearchDistance += 1;
            }
            else {
                return null;
            }
        }
    };
    Layer.prototype._getIntersection = function (pos) {
        var ratio = this.hitCanvas.pixelRatio;
        var p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data, p3 = p[3], colorKey, shape;
        if (p3 === 255) {
            colorKey = Util_1.Util._rgbToHex(p[0], p[1], p[2]);
            shape = Shape_1.shapes[HASH + colorKey];
            if (shape) {
                return {
                    shape: shape,
                };
            }
            return {
                antialiased: true,
            };
        }
        else if (p3 > 0) {
            return {
                antialiased: true,
            };
        }
        return {};
    };
    Layer.prototype.drawScene = function (can, top) {
        var layer = this.getLayer(), canvas = can || (layer && layer.getCanvas());
        this._fire(BEFORE_DRAW, {
            node: this,
        });
        if (this.clearBeforeDraw()) {
            canvas.getContext().clear();
        }
        Container_1.Container.prototype.drawScene.call(this, canvas, top);
        this._fire(DRAW, {
            node: this,
        });
        return this;
    };
    Layer.prototype.drawHit = function (can, top) {
        var layer = this.getLayer(), canvas = can || (layer && layer.hitCanvas);
        if (layer && layer.clearBeforeDraw()) {
            layer.getHitCanvas().getContext().clear();
        }
        Container_1.Container.prototype.drawHit.call(this, canvas, top);
        return this;
    };
    Layer.prototype.enableHitGraph = function () {
        this.hitGraphEnabled(true);
        return this;
    };
    Layer.prototype.disableHitGraph = function () {
        this.hitGraphEnabled(false);
        return this;
    };
    Layer.prototype.setHitGraphEnabled = function (val) {
        Util_1.Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        this.listening(val);
    };
    Layer.prototype.getHitGraphEnabled = function (val) {
        Util_1.Util.warn('hitGraphEnabled method is deprecated. Please use layer.listening() instead.');
        return this.listening();
    };
    Layer.prototype.toggleHitCanvas = function () {
        if (!this.parent) {
            return;
        }
        var parent = this.parent;
        var added = !!this.hitCanvas._canvas.parentNode;
        if (added) {
            parent.content.removeChild(this.hitCanvas._canvas);
        }
        else {
            parent.content.appendChild(this.hitCanvas._canvas);
        }
    };
    return Layer;
}(Container_1.Container));
exports.Layer = Layer;
Layer.prototype.nodeType = 'Layer';
Global_1._registerNode(Layer);
Factory_1.Factory.addGetterSetter(Layer, 'imageSmoothingEnabled', true);
Factory_1.Factory.addGetterSetter(Layer, 'clearBeforeDraw', true);
Factory_1.Factory.addGetterSetter(Layer, 'hitGraphEnabled', true, Validators_1.getBooleanValidator());
Util_1.Collection.mapMethods(Layer);


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.toggleStrictMode = toggleStrictMode;
exports.applyNodeProps = applyNodeProps;
exports.updatePicture = updatePicture;
var propsToSkip = {
  children: true,
  ref: true,
  key: true,
  style: true,
  forwardedRef: true,
  unstable_applyCache: true,
  unstable_applyDrawHitFromCache: true
};

var zIndexWarningShowed = false;
var dragWarningShowed = false;

var EVENTS_NAMESPACE = exports.EVENTS_NAMESPACE = '.react-konva-event';

var useStrictMode = false;
function toggleStrictMode(value) {
  useStrictMode = value;
}

var DRAGGABLE_WARNING = 'ReactKonva: You have a Konva node with draggable = true and position defined but no onDragMove or onDragEnd events are handled.\nPosition of a node will be changed during drag&drop, so you should update state of the react app as well.\nConsider to add onDragMove or onDragEnd events.\nFor more info see: https://github.com/konvajs/react-konva/issues/256\n';

var Z_INDEX_WARNING = 'ReactKonva: You are using "zIndex" attribute for a Konva node.\nreact-konva may get confused with ordering. Just define correct order of elements in your render function of a component.\nFor more info see: https://github.com/konvajs/react-konva/issues/194\n';

var EMPTY_PROPS = {};

function applyNodeProps(instance, props) {
  var oldProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_PROPS;

  if (props === oldProps) {
    console.error('same props');
  }
  // don't use zIndex in react-konva
  if (!zIndexWarningShowed && 'zIndex' in props) {
    console.warn(Z_INDEX_WARNING);
    zIndexWarningShowed = true;
  }

  // check correct draggable usage
  if (!dragWarningShowed && props.draggable) {
    var hasPosition = props.x !== undefined || props.y !== undefined;
    var hasEvents = props.onDragEnd || props.onDragMove;
    if (hasPosition && !hasEvents) {
      console.warn(DRAGGABLE_WARNING);
      dragWarningShowed = true;
    }
  }

  // check old props
  // we need to unset properties that are not in new props
  // and remove all events
  for (var key in oldProps) {
    if (propsToSkip[key]) {
      continue;
    }
    var isEvent = key.slice(0, 2) === 'on';
    var propChanged = oldProps[key] !== props[key];

    // if that is a changed event, we need to remvoe it
    if (isEvent && propChanged) {
      var eventName = key.substr(2).toLowerCase();
      if (eventName.substr(0, 7) === 'content') {
        eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
      }
      instance.off(eventName, oldProps[key]);
    }
    var toRemove = !props.hasOwnProperty(key);
    if (toRemove) {
      instance.setAttr(key, undefined);
    }
  }

  var strictUpdate = useStrictMode || props._useStrictMode;
  var updatedProps = {};
  var hasUpdates = false;

  var newEvents = {};

  for (var key in props) {
    if (propsToSkip[key]) {
      continue;
    }
    var isEvent = key.slice(0, 2) === 'on';
    var toAdd = oldProps[key] !== props[key];
    if (isEvent && toAdd) {
      var eventName = key.substr(2).toLowerCase();
      if (eventName.substr(0, 7) === 'content') {
        eventName = 'content' + eventName.substr(7, 1).toUpperCase() + eventName.substr(8);
      }
      // check that event is not undefined
      if (props[key]) {
        newEvents[eventName] = props[key];
      }
    }
    if (!isEvent && (props[key] !== oldProps[key] || strictUpdate && props[key] !== instance.getAttr(key))) {
      hasUpdates = true;
      updatedProps[key] = props[key];
    }
  }

  if (hasUpdates) {
    instance.setAttrs(updatedProps);
    updatePicture(instance);
  }

  // subscribe to events AFTER we set attrs
  // we need it to fix https://github.com/konvajs/react-konva/issues/471
  // settings attrs may add events. Like "draggable: true" will add "mousedown" listener
  for (var eventName in newEvents) {
    instance.on(eventName + EVENTS_NAMESPACE, newEvents[eventName]);
  }
}

function updatePicture(node) {
  var drawingNode = node.getLayer() || node.getStage();
  drawingNode && drawingNode.batchDraw();
}

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var Line = (function (_super) {
    __extends(Line, _super);
    function Line(config) {
        var _this = _super.call(this, config) || this;
        _this.on('pointsChange.konva tensionChange.konva closedChange.konva bezierChange.konva', function () {
            this._clearCache('tensionPoints');
        });
        return _this;
    }
    Line.prototype._sceneFunc = function (context) {
        var points = this.points(), length = points.length, tension = this.tension(), closed = this.closed(), bezier = this.bezier(), tp, len, n;
        if (!length) {
            return;
        }
        context.beginPath();
        context.moveTo(points[0], points[1]);
        if (tension !== 0 && length > 4) {
            tp = this.getTensionPoints();
            len = tp.length;
            n = closed ? 0 : 4;
            if (!closed) {
                context.quadraticCurveTo(tp[0], tp[1], tp[2], tp[3]);
            }
            while (n < len - 2) {
                context.bezierCurveTo(tp[n++], tp[n++], tp[n++], tp[n++], tp[n++], tp[n++]);
            }
            if (!closed) {
                context.quadraticCurveTo(tp[len - 2], tp[len - 1], points[length - 2], points[length - 1]);
            }
        }
        else if (bezier) {
            n = 2;
            while (n < length) {
                context.bezierCurveTo(points[n++], points[n++], points[n++], points[n++], points[n++], points[n++]);
            }
        }
        else {
            for (n = 2; n < length; n += 2) {
                context.lineTo(points[n], points[n + 1]);
            }
        }
        if (closed) {
            context.closePath();
            context.fillStrokeShape(this);
        }
        else {
            context.strokeShape(this);
        }
    };
    Line.prototype.getTensionPoints = function () {
        return this._getCache('tensionPoints', this._getTensionPoints);
    };
    Line.prototype._getTensionPoints = function () {
        if (this.closed()) {
            return this._getTensionPointsClosed();
        }
        else {
            return Util_1.Util._expandPoints(this.points(), this.tension());
        }
    };
    Line.prototype._getTensionPointsClosed = function () {
        var p = this.points(), len = p.length, tension = this.tension(), firstControlPoints = Util_1.Util._getControlPoints(p[len - 2], p[len - 1], p[0], p[1], p[2], p[3], tension), lastControlPoints = Util_1.Util._getControlPoints(p[len - 4], p[len - 3], p[len - 2], p[len - 1], p[0], p[1], tension), middle = Util_1.Util._expandPoints(p, tension), tp = [firstControlPoints[2], firstControlPoints[3]]
            .concat(middle)
            .concat([
            lastControlPoints[0],
            lastControlPoints[1],
            p[len - 2],
            p[len - 1],
            lastControlPoints[2],
            lastControlPoints[3],
            firstControlPoints[0],
            firstControlPoints[1],
            p[0],
            p[1]
        ]);
        return tp;
    };
    Line.prototype.getWidth = function () {
        return this.getSelfRect().width;
    };
    Line.prototype.getHeight = function () {
        return this.getSelfRect().height;
    };
    Line.prototype.getSelfRect = function () {
        var points = this.points();
        if (points.length < 4) {
            return {
                x: points[0] || 0,
                y: points[1] || 0,
                width: 0,
                height: 0
            };
        }
        if (this.tension() !== 0) {
            points = __spreadArrays([
                points[0],
                points[1]
            ], this._getTensionPoints(), [
                points[points.length - 2],
                points[points.length - 1]
            ]);
        }
        else {
            points = this.points();
        }
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for (var i = 0; i < points.length / 2; i++) {
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    };
    return Line;
}(Shape_1.Shape));
exports.Line = Line;
Line.prototype.className = 'Line';
Line.prototype._attrsAffectingSize = ['points', 'bezier', 'tension'];
Global_1._registerNode(Line);
Factory_1.Factory.addGetterSetter(Line, 'closed', false);
Factory_1.Factory.addGetterSetter(Line, 'bezier', false);
Factory_1.Factory.addGetterSetter(Line, 'tension', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Line, 'points', [], Validators_1.getNumberArrayValidator());
Util_1.Collection.mapMethods(Line);


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Global_1 = __webpack_require__(38);
var Path = (function (_super) {
    __extends(Path, _super);
    function Path(config) {
        var _this = _super.call(this, config) || this;
        _this.dataArray = [];
        _this.pathLength = 0;
        _this.dataArray = Path.parsePathData(_this.data());
        _this.pathLength = 0;
        for (var i = 0; i < _this.dataArray.length; ++i) {
            _this.pathLength += _this.dataArray[i].pathLength;
        }
        _this.on('dataChange.konva', function () {
            this.dataArray = Path.parsePathData(this.data());
            this.pathLength = 0;
            for (var i = 0; i < this.dataArray.length; ++i) {
                this.pathLength += this.dataArray[i].pathLength;
            }
        });
        return _this;
    }
    Path.prototype._sceneFunc = function (context) {
        var ca = this.dataArray;
        context.beginPath();
        var isClosed = false;
        for (var n = 0; n < ca.length; n++) {
            var c = ca[n].command;
            var p = ca[n].points;
            switch (c) {
                case 'L':
                    context.lineTo(p[0], p[1]);
                    break;
                case 'M':
                    context.moveTo(p[0], p[1]);
                    break;
                case 'C':
                    context.bezierCurveTo(p[0], p[1], p[2], p[3], p[4], p[5]);
                    break;
                case 'Q':
                    context.quadraticCurveTo(p[0], p[1], p[2], p[3]);
                    break;
                case 'A':
                    var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6], fs = p[7];
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(psi);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, theta, theta + dTheta, 1 - fs);
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-psi);
                    context.translate(-cx, -cy);
                    break;
                case 'z':
                    isClosed = true;
                    context.closePath();
                    break;
            }
        }
        if (!isClosed && !this.hasFill()) {
            context.strokeShape(this);
        }
        else {
            context.fillStrokeShape(this);
        }
    };
    Path.prototype.getSelfRect = function () {
        var points = [];
        this.dataArray.forEach(function (data) {
            if (data.command === 'A') {
                var start = data.points[4];
                var dTheta = data.points[5];
                var end = data.points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) {
                    inc = Math.abs(start - end);
                }
                if (dTheta < 0) {
                    for (var t = start - inc; t > end; t -= inc) {
                        var point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                        points.push(point.x, point.y);
                    }
                }
                else {
                    for (var t = start + inc; t < end; t += inc) {
                        var point = Path.getPointOnEllipticalArc(data.points[0], data.points[1], data.points[2], data.points[3], t, 0);
                        points.push(point.x, point.y);
                    }
                }
            }
            else if (data.command === 'C') {
                for (var t = 0.0; t <= 1; t += 0.01) {
                    var point = Path.getPointOnCubicBezier(t, data.start.x, data.start.y, data.points[0], data.points[1], data.points[2], data.points[3], data.points[4], data.points[5]);
                    points.push(point.x, point.y);
                }
            }
            else {
                points = points.concat(data.points);
            }
        });
        var minX = points[0];
        var maxX = points[0];
        var minY = points[1];
        var maxY = points[1];
        var x, y;
        for (var i = 0; i < points.length / 2; i++) {
            x = points[i * 2];
            y = points[i * 2 + 1];
            if (!isNaN(x)) {
                minX = Math.min(minX, x);
                maxX = Math.max(maxX, x);
            }
            if (!isNaN(y)) {
                minY = Math.min(minY, y);
                maxY = Math.max(maxY, y);
            }
        }
        return {
            x: Math.round(minX),
            y: Math.round(minY),
            width: Math.round(maxX - minX),
            height: Math.round(maxY - minY)
        };
    };
    Path.prototype.getLength = function () {
        return this.pathLength;
    };
    Path.prototype.getPointAtLength = function (length) {
        var point, i = 0, ii = this.dataArray.length;
        if (!ii) {
            return null;
        }
        while (i < ii && length > this.dataArray[i].pathLength) {
            length -= this.dataArray[i].pathLength;
            ++i;
        }
        if (i === ii) {
            point = this.dataArray[i - 1].points.slice(-2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        if (length < 0.01) {
            point = this.dataArray[i].points.slice(0, 2);
            return {
                x: point[0],
                y: point[1]
            };
        }
        var cp = this.dataArray[i];
        var p = cp.points;
        switch (cp.command) {
            case 'L':
                return Path.getPointOnLine(length, cp.start.x, cp.start.y, p[0], p[1]);
            case 'C':
                return Path.getPointOnCubicBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3], p[4], p[5]);
            case 'Q':
                return Path.getPointOnQuadraticBezier(length / cp.pathLength, cp.start.x, cp.start.y, p[0], p[1], p[2], p[3]);
            case 'A':
                var cx = p[0], cy = p[1], rx = p[2], ry = p[3], theta = p[4], dTheta = p[5], psi = p[6];
                theta += (dTheta * length) / cp.pathLength;
                return Path.getPointOnEllipticalArc(cx, cy, rx, ry, theta, psi);
        }
        return null;
    };
    Path.getLineLength = function (x1, y1, x2, y2) {
        return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    };
    Path.getPointOnLine = function (dist, P1x, P1y, P2x, P2y, fromX, fromY) {
        if (fromX === undefined) {
            fromX = P1x;
        }
        if (fromY === undefined) {
            fromY = P1y;
        }
        var m = (P2y - P1y) / (P2x - P1x + 0.00000001);
        var run = Math.sqrt((dist * dist) / (1 + m * m));
        if (P2x < P1x) {
            run *= -1;
        }
        var rise = m * run;
        var pt;
        if (P2x === P1x) {
            pt = {
                x: fromX,
                y: fromY + rise
            };
        }
        else if ((fromY - P1y) / (fromX - P1x + 0.00000001) === m) {
            pt = {
                x: fromX + run,
                y: fromY + rise
            };
        }
        else {
            var ix, iy;
            var len = this.getLineLength(P1x, P1y, P2x, P2y);
            if (len < 0.00000001) {
                return undefined;
            }
            var u = (fromX - P1x) * (P2x - P1x) + (fromY - P1y) * (P2y - P1y);
            u = u / (len * len);
            ix = P1x + u * (P2x - P1x);
            iy = P1y + u * (P2y - P1y);
            var pRise = this.getLineLength(fromX, fromY, ix, iy);
            var pRun = Math.sqrt(dist * dist - pRise * pRise);
            run = Math.sqrt((pRun * pRun) / (1 + m * m));
            if (P2x < P1x) {
                run *= -1;
            }
            rise = m * run;
            pt = {
                x: ix + run,
                y: iy + rise
            };
        }
        return pt;
    };
    Path.getPointOnCubicBezier = function (pct, P1x, P1y, P2x, P2y, P3x, P3y, P4x, P4y) {
        function CB1(t) {
            return t * t * t;
        }
        function CB2(t) {
            return 3 * t * t * (1 - t);
        }
        function CB3(t) {
            return 3 * t * (1 - t) * (1 - t);
        }
        function CB4(t) {
            return (1 - t) * (1 - t) * (1 - t);
        }
        var x = P4x * CB1(pct) + P3x * CB2(pct) + P2x * CB3(pct) + P1x * CB4(pct);
        var y = P4y * CB1(pct) + P3y * CB2(pct) + P2y * CB3(pct) + P1y * CB4(pct);
        return {
            x: x,
            y: y
        };
    };
    Path.getPointOnQuadraticBezier = function (pct, P1x, P1y, P2x, P2y, P3x, P3y) {
        function QB1(t) {
            return t * t;
        }
        function QB2(t) {
            return 2 * t * (1 - t);
        }
        function QB3(t) {
            return (1 - t) * (1 - t);
        }
        var x = P3x * QB1(pct) + P2x * QB2(pct) + P1x * QB3(pct);
        var y = P3y * QB1(pct) + P2y * QB2(pct) + P1y * QB3(pct);
        return {
            x: x,
            y: y
        };
    };
    Path.getPointOnEllipticalArc = function (cx, cy, rx, ry, theta, psi) {
        var cosPsi = Math.cos(psi), sinPsi = Math.sin(psi);
        var pt = {
            x: rx * Math.cos(theta),
            y: ry * Math.sin(theta)
        };
        return {
            x: cx + (pt.x * cosPsi - pt.y * sinPsi),
            y: cy + (pt.x * sinPsi + pt.y * cosPsi)
        };
    };
    Path.parsePathData = function (data) {
        if (!data) {
            return [];
        }
        var cs = data;
        var cc = [
            'm',
            'M',
            'l',
            'L',
            'v',
            'V',
            'h',
            'H',
            'z',
            'Z',
            'c',
            'C',
            'q',
            'Q',
            't',
            'T',
            's',
            'S',
            'a',
            'A'
        ];
        cs = cs.replace(new RegExp(' ', 'g'), ',');
        for (var n = 0; n < cc.length; n++) {
            cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
        }
        var arr = cs.split('|');
        var ca = [];
        var coords = [];
        var cpx = 0;
        var cpy = 0;
        var re = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:e[-+]?\d+)?)/gi;
        var match;
        for (n = 1; n < arr.length; n++) {
            var str = arr[n];
            var c = str.charAt(0);
            str = str.slice(1);
            coords.length = 0;
            while ((match = re.exec(str))) {
                coords.push(match[0]);
            }
            var p = [];
            for (var j = 0, jlen = coords.length; j < jlen; j++) {
                var parsed = parseFloat(coords[j]);
                if (!isNaN(parsed)) {
                    p.push(parsed);
                }
                else {
                    p.push(0);
                }
            }
            while (p.length > 0) {
                if (isNaN(p[0])) {
                    break;
                }
                var cmd = null;
                var points = [];
                var startX = cpx, startY = cpy;
                var prevCmd, ctlPtx, ctlPty;
                var rx, ry, psi, fa, fs, x1, y1;
                switch (c) {
                    case 'l':
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'L':
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'm':
                        var dx = p.shift();
                        var dy = p.shift();
                        cpx += dx;
                        cpy += dy;
                        cmd = 'M';
                        if (ca.length > 2 && ca[ca.length - 1].command === 'z') {
                            for (var idx = ca.length - 2; idx >= 0; idx--) {
                                if (ca[idx].command === 'M') {
                                    cpx = ca[idx].points[0] + dx;
                                    cpy = ca[idx].points[1] + dy;
                                    break;
                                }
                            }
                        }
                        points.push(cpx, cpy);
                        c = 'l';
                        break;
                    case 'M':
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'M';
                        points.push(cpx, cpy);
                        c = 'L';
                        break;
                    case 'h':
                        cpx += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'H':
                        cpx = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'v':
                        cpy += p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'V':
                        cpy = p.shift();
                        cmd = 'L';
                        points.push(cpx, cpy);
                        break;
                    case 'C':
                        points.push(p.shift(), p.shift(), p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'c':
                        points.push(cpx + p.shift(), cpy + p.shift(), cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'S':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 's':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'C') {
                            ctlPtx = cpx + (cpx - prevCmd.points[2]);
                            ctlPty = cpy + (cpy - prevCmd.points[3]);
                        }
                        points.push(ctlPtx, ctlPty, cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'C';
                        points.push(cpx, cpy);
                        break;
                    case 'Q':
                        points.push(p.shift(), p.shift());
                        cpx = p.shift();
                        cpy = p.shift();
                        points.push(cpx, cpy);
                        break;
                    case 'q':
                        points.push(cpx + p.shift(), cpy + p.shift());
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(cpx, cpy);
                        break;
                    case 'T':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 't':
                        ctlPtx = cpx;
                        ctlPty = cpy;
                        prevCmd = ca[ca.length - 1];
                        if (prevCmd.command === 'Q') {
                            ctlPtx = cpx + (cpx - prevCmd.points[0]);
                            ctlPty = cpy + (cpy - prevCmd.points[1]);
                        }
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'Q';
                        points.push(ctlPtx, ctlPty, cpx, cpy);
                        break;
                    case 'A':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx = p.shift();
                        cpy = p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                    case 'a':
                        rx = p.shift();
                        ry = p.shift();
                        psi = p.shift();
                        fa = p.shift();
                        fs = p.shift();
                        x1 = cpx;
                        y1 = cpy;
                        cpx += p.shift();
                        cpy += p.shift();
                        cmd = 'A';
                        points = this.convertEndpointToCenterParameterization(x1, y1, cpx, cpy, fa, fs, rx, ry, psi);
                        break;
                }
                ca.push({
                    command: cmd || c,
                    points: points,
                    start: {
                        x: startX,
                        y: startY
                    },
                    pathLength: this.calcLength(startX, startY, cmd || c, points)
                });
            }
            if (c === 'z' || c === 'Z') {
                ca.push({
                    command: 'z',
                    points: [],
                    start: undefined,
                    pathLength: 0
                });
            }
        }
        return ca;
    };
    Path.calcLength = function (x, y, cmd, points) {
        var len, p1, p2, t;
        var path = Path;
        switch (cmd) {
            case 'L':
                return path.getLineLength(x, y, points[0], points[1]);
            case 'C':
                len = 0.0;
                p1 = path.getPointOnCubicBezier(0, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                for (t = 0.01; t <= 1; t += 0.01) {
                    p2 = path.getPointOnCubicBezier(t, x, y, points[0], points[1], points[2], points[3], points[4], points[5]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case 'Q':
                len = 0.0;
                p1 = path.getPointOnQuadraticBezier(0, x, y, points[0], points[1], points[2], points[3]);
                for (t = 0.01; t <= 1; t += 0.01) {
                    p2 = path.getPointOnQuadraticBezier(t, x, y, points[0], points[1], points[2], points[3]);
                    len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                    p1 = p2;
                }
                return len;
            case 'A':
                len = 0.0;
                var start = points[4];
                var dTheta = points[5];
                var end = points[4] + dTheta;
                var inc = Math.PI / 180.0;
                if (Math.abs(start - end) < inc) {
                    inc = Math.abs(start - end);
                }
                p1 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], start, 0);
                if (dTheta < 0) {
                    for (t = start - inc; t > end; t -= inc) {
                        p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                        len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                        p1 = p2;
                    }
                }
                else {
                    for (t = start + inc; t < end; t += inc) {
                        p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], t, 0);
                        len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                        p1 = p2;
                    }
                }
                p2 = path.getPointOnEllipticalArc(points[0], points[1], points[2], points[3], end, 0);
                len += path.getLineLength(p1.x, p1.y, p2.x, p2.y);
                return len;
        }
        return 0;
    };
    Path.convertEndpointToCenterParameterization = function (x1, y1, x2, y2, fa, fs, rx, ry, psiDeg) {
        var psi = psiDeg * (Math.PI / 180.0);
        var xp = (Math.cos(psi) * (x1 - x2)) / 2.0 + (Math.sin(psi) * (y1 - y2)) / 2.0;
        var yp = (-1 * Math.sin(psi) * (x1 - x2)) / 2.0 +
            (Math.cos(psi) * (y1 - y2)) / 2.0;
        var lambda = (xp * xp) / (rx * rx) + (yp * yp) / (ry * ry);
        if (lambda > 1) {
            rx *= Math.sqrt(lambda);
            ry *= Math.sqrt(lambda);
        }
        var f = Math.sqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) /
            (rx * rx * (yp * yp) + ry * ry * (xp * xp)));
        if (fa === fs) {
            f *= -1;
        }
        if (isNaN(f)) {
            f = 0;
        }
        var cxp = (f * rx * yp) / ry;
        var cyp = (f * -ry * xp) / rx;
        var cx = (x1 + x2) / 2.0 + Math.cos(psi) * cxp - Math.sin(psi) * cyp;
        var cy = (y1 + y2) / 2.0 + Math.sin(psi) * cxp + Math.cos(psi) * cyp;
        var vMag = function (v) {
            return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
        };
        var vRatio = function (u, v) {
            return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
        };
        var vAngle = function (u, v) {
            return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
        };
        var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
        var u = [(xp - cxp) / rx, (yp - cyp) / ry];
        var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
        var dTheta = vAngle(u, v);
        if (vRatio(u, v) <= -1) {
            dTheta = Math.PI;
        }
        if (vRatio(u, v) >= 1) {
            dTheta = 0;
        }
        if (fs === 0 && dTheta > 0) {
            dTheta = dTheta - 2 * Math.PI;
        }
        if (fs === 1 && dTheta < 0) {
            dTheta = dTheta + 2 * Math.PI;
        }
        return [cx, cy, rx, ry, theta, dTheta, psi, fs];
    };
    return Path;
}(Shape_1.Shape));
exports.Path = Path;
Path.prototype.className = 'Path';
Path.prototype._attrsAffectingSize = ['data'];
Global_1._registerNode(Path);
Factory_1.Factory.addGetterSetter(Path, 'data');
Util_1.Collection.mapMethods(Path);


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Global_1 = __webpack_require__(38);
var Rect = (function (_super) {
    __extends(Rect, _super);
    function Rect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Rect.prototype._sceneFunc = function (context) {
        var cornerRadius = this.cornerRadius(), width = this.width(), height = this.height();
        context.beginPath();
        if (!cornerRadius) {
            context.rect(0, 0, width, height);
        }
        else {
            var topLeft = 0;
            var topRight = 0;
            var bottomLeft = 0;
            var bottomRight = 0;
            if (typeof cornerRadius === 'number') {
                topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
            }
            else {
                topLeft = Math.min(cornerRadius[0], width / 2, height / 2);
                topRight = Math.min(cornerRadius[1], width / 2, height / 2);
                bottomRight = Math.min(cornerRadius[2], width / 2, height / 2);
                bottomLeft = Math.min(cornerRadius[3], width / 2, height / 2);
            }
            context.moveTo(topLeft, 0);
            context.lineTo(width - topRight, 0);
            context.arc(width - topRight, topRight, topRight, (Math.PI * 3) / 2, 0, false);
            context.lineTo(width, height - bottomRight);
            context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
            context.lineTo(bottomLeft, height);
            context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
            context.lineTo(0, topLeft);
            context.arc(topLeft, topLeft, topLeft, Math.PI, (Math.PI * 3) / 2, false);
        }
        context.closePath();
        context.fillStrokeShape(this);
    };
    return Rect;
}(Shape_1.Shape));
exports.Rect = Rect;
Rect.prototype.className = 'Rect';
Global_1._registerNode(Rect);
Factory_1.Factory.addGetterSetter(Rect, 'cornerRadius', 0);
Util_1.Collection.mapMethods(Rect);


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Global_1 = __webpack_require__(38);
var Validators_1 = __webpack_require__(41);
var Global_2 = __webpack_require__(38);
var AUTO = 'auto', CENTER = 'center', JUSTIFY = 'justify', CHANGE_KONVA = 'Change.konva', CONTEXT_2D = '2d', DASH = '-', LEFT = 'left', TEXT = 'text', TEXT_UPPER = 'Text', TOP = 'top', BOTTOM = 'bottom', MIDDLE = 'middle', NORMAL = 'normal', PX_SPACE = 'px ', SPACE = ' ', RIGHT = 'right', WORD = 'word', CHAR = 'char', NONE = 'none', ELLIPSIS = '…', ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'padding',
    'align',
    'verticalAlign',
    'lineHeight',
    'text',
    'width',
    'height',
    'wrap',
    'ellipsis',
    'letterSpacing',
], attrChangeListLen = ATTR_CHANGE_LIST.length;
function normalizeFontFamily(fontFamily) {
    return fontFamily
        .split(',')
        .map(function (family) {
        family = family.trim();
        var hasSpace = family.indexOf(' ') >= 0;
        var hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
        if (hasSpace && !hasQuotes) {
            family = "\"" + family + "\"";
        }
        return family;
    })
        .join(', ');
}
var dummyContext;
function getDummyContext() {
    if (dummyContext) {
        return dummyContext;
    }
    dummyContext = Util_1.Util.createCanvasElement().getContext(CONTEXT_2D);
    return dummyContext;
}
function _fillFunc(context) {
    context.fillText(this._partialText, this._partialTextX, this._partialTextY);
}
function _strokeFunc(context) {
    context.strokeText(this._partialText, this._partialTextX, this._partialTextY);
}
function checkDefaultFill(config) {
    config = config || {};
    if (!config.fillLinearGradientColorStops &&
        !config.fillRadialGradientColorStops &&
        !config.fillPatternImage) {
        config.fill = config.fill || 'black';
    }
    return config;
}
var Text = (function (_super) {
    __extends(Text, _super);
    function Text(config) {
        var _this = _super.call(this, checkDefaultFill(config)) || this;
        _this._partialTextX = 0;
        _this._partialTextY = 0;
        for (var n = 0; n < attrChangeListLen; n++) {
            _this.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, _this._setTextData);
        }
        _this._setTextData();
        return _this;
    }
    Text.prototype._sceneFunc = function (context) {
        var padding = this.padding(), fontSize = this.fontSize(), lineHeightPx = this.lineHeight() * fontSize, textArr = this.textArr, textArrLen = textArr.length, verticalAlign = this.verticalAlign(), alignY = 0, align = this.align(), totalWidth = this.getWidth(), letterSpacing = this.letterSpacing(), fill = this.fill(), textDecoration = this.textDecoration(), shouldUnderline = textDecoration.indexOf('underline') !== -1, shouldLineThrough = textDecoration.indexOf('line-through') !== -1, n;
        var translateY = 0;
        var translateY = lineHeightPx / 2;
        var lineTranslateX = 0;
        var lineTranslateY = 0;
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', MIDDLE);
        context.setAttr('textAlign', LEFT);
        if (verticalAlign === MIDDLE) {
            alignY = (this.getHeight() - textArrLen * lineHeightPx - padding * 2) / 2;
        }
        else if (verticalAlign === BOTTOM) {
            alignY = this.getHeight() - textArrLen * lineHeightPx - padding * 2;
        }
        context.translate(padding, alignY + padding);
        for (n = 0; n < textArrLen; n++) {
            var lineTranslateX = 0;
            var lineTranslateY = 0;
            var obj = textArr[n], text = obj.text, width = obj.width, lastLine = n !== textArrLen - 1, spacesNumber, oneWord, lineWidth;
            context.save();
            if (align === RIGHT) {
                lineTranslateX += totalWidth - width - padding * 2;
            }
            else if (align === CENTER) {
                lineTranslateX += (totalWidth - width - padding * 2) / 2;
            }
            if (shouldUnderline) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY + Math.round(fontSize / 2));
                spacesNumber = text.split(' ').length - 1;
                oneWord = spacesNumber === 0;
                lineWidth =
                    align === JUSTIFY && lastLine && !oneWord
                        ? totalWidth - padding * 2
                        : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY + Math.round(fontSize / 2));
                context.lineWidth = fontSize / 15;
                context.strokeStyle = fill;
                context.stroke();
                context.restore();
            }
            if (shouldLineThrough) {
                context.save();
                context.beginPath();
                context.moveTo(lineTranslateX, translateY + lineTranslateY);
                spacesNumber = text.split(' ').length - 1;
                oneWord = spacesNumber === 0;
                lineWidth =
                    align === JUSTIFY && lastLine && !oneWord
                        ? totalWidth - padding * 2
                        : width;
                context.lineTo(lineTranslateX + Math.round(lineWidth), translateY + lineTranslateY);
                context.lineWidth = fontSize / 15;
                context.strokeStyle = fill;
                context.stroke();
                context.restore();
            }
            if (letterSpacing !== 0 || align === JUSTIFY) {
                spacesNumber = text.split(' ').length - 1;
                for (var li = 0; li < text.length; li++) {
                    var letter = text[li];
                    if (letter === ' ' && n !== textArrLen - 1 && align === JUSTIFY) {
                        lineTranslateX += (totalWidth - padding * 2 - width) / spacesNumber;
                    }
                    this._partialTextX = lineTranslateX;
                    this._partialTextY = translateY + lineTranslateY;
                    this._partialText = letter;
                    context.fillStrokeShape(this);
                    lineTranslateX += this.measureSize(letter).width + letterSpacing;
                }
            }
            else {
                this._partialTextX = lineTranslateX;
                this._partialTextY = translateY + lineTranslateY;
                this._partialText = text;
                context.fillStrokeShape(this);
            }
            context.restore();
            if (textArrLen > 1) {
                translateY += lineHeightPx;
            }
        }
    };
    Text.prototype._hitFunc = function (context) {
        var width = this.getWidth(), height = this.getHeight();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    };
    Text.prototype.setText = function (text) {
        var str = Util_1.Util._isString(text)
            ? text
            : text === null || text === undefined
                ? ''
                : text + '';
        this._setAttr(TEXT, str);
        return this;
    };
    Text.prototype.getWidth = function () {
        var isAuto = this.attrs.width === AUTO || this.attrs.width === undefined;
        return isAuto ? this.getTextWidth() + this.padding() * 2 : this.attrs.width;
    };
    Text.prototype.getHeight = function () {
        var isAuto = this.attrs.height === AUTO || this.attrs.height === undefined;
        return isAuto
            ? this.fontSize() * this.textArr.length * this.lineHeight() +
                this.padding() * 2
            : this.attrs.height;
    };
    Text.prototype.getTextWidth = function () {
        return this.textWidth;
    };
    Text.prototype.getTextHeight = function () {
        Util_1.Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    };
    Text.prototype.measureSize = function (text) {
        var _context = getDummyContext(), fontSize = this.fontSize(), metrics;
        _context.save();
        _context.font = this._getContextFont();
        metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: fontSize,
        };
    };
    Text.prototype._getContextFont = function () {
        if (Global_1.Konva.UA.isIE) {
            return (this.fontStyle() +
                SPACE +
                this.fontSize() +
                PX_SPACE +
                this.fontFamily());
        }
        return (this.fontStyle() +
            SPACE +
            this.fontVariant() +
            SPACE +
            (this.fontSize() + PX_SPACE) +
            normalizeFontFamily(this.fontFamily()));
    };
    Text.prototype._addTextLine = function (line) {
        if (this.align() === JUSTIFY) {
            line = line.trim();
        }
        var width = this._getTextWidth(line);
        return this.textArr.push({ text: line, width: width });
    };
    Text.prototype._getTextWidth = function (text) {
        var letterSpacing = this.letterSpacing();
        var length = text.length;
        return (getDummyContext().measureText(text).width +
            (length ? letterSpacing * (length - 1) : 0));
    };
    Text.prototype._setTextData = function () {
        var lines = this.text().split('\n'), fontSize = +this.fontSize(), textWidth = 0, lineHeightPx = this.lineHeight() * fontSize, width = this.attrs.width, height = this.attrs.height, fixedWidth = width !== AUTO && width !== undefined, fixedHeight = height !== AUTO && height !== undefined, padding = this.padding(), maxWidth = width - padding * 2, maxHeightPx = height - padding * 2, currentHeightPx = 0, wrap = this.wrap(), shouldWrap = wrap !== NONE, wrapAtWord = wrap !== CHAR && shouldWrap, shouldAddEllipsis = this.ellipsis() && !shouldWrap;
        this.textArr = [];
        getDummyContext().font = this._getContextFont();
        var additionalWidth = shouldAddEllipsis ? this._getTextWidth(ELLIPSIS) : 0;
        for (var i = 0, max = lines.length; i < max; ++i) {
            var line = lines[i];
            var lineWidth = this._getTextWidth(line);
            if (fixedWidth && lineWidth > maxWidth) {
                while (line.length > 0) {
                    var low = 0, high = line.length, match = '', matchWidth = 0;
                    while (low < high) {
                        var mid = (low + high) >>> 1, substr = line.slice(0, mid + 1), substrWidth = this._getTextWidth(substr) + additionalWidth;
                        if (substrWidth <= maxWidth) {
                            low = mid + 1;
                            match = substr + (shouldAddEllipsis ? ELLIPSIS : '');
                            matchWidth = substrWidth;
                        }
                        else {
                            high = mid;
                        }
                    }
                    if (match) {
                        if (wrapAtWord) {
                            var wrapIndex;
                            var nextChar = line[match.length];
                            var nextIsSpaceOrDash = nextChar === SPACE || nextChar === DASH;
                            if (nextIsSpaceOrDash && matchWidth <= maxWidth) {
                                wrapIndex = match.length;
                            }
                            else {
                                wrapIndex =
                                    Math.max(match.lastIndexOf(SPACE), match.lastIndexOf(DASH)) +
                                        1;
                            }
                            if (wrapIndex > 0) {
                                low = wrapIndex;
                                match = match.slice(0, low);
                                matchWidth = this._getTextWidth(match);
                            }
                        }
                        match = match.trimRight();
                        this._addTextLine(match);
                        textWidth = Math.max(textWidth, matchWidth);
                        currentHeightPx += lineHeightPx;
                        if (!shouldWrap ||
                            (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx)) {
                            break;
                        }
                        line = line.slice(low);
                        line = line.trimLeft();
                        if (line.length > 0) {
                            lineWidth = this._getTextWidth(line);
                            if (lineWidth <= maxWidth) {
                                this._addTextLine(line);
                                currentHeightPx += lineHeightPx;
                                textWidth = Math.max(textWidth, lineWidth);
                                break;
                            }
                        }
                    }
                    else {
                        break;
                    }
                }
            }
            else {
                this._addTextLine(line);
                currentHeightPx += lineHeightPx;
                textWidth = Math.max(textWidth, lineWidth);
            }
            if (fixedHeight && currentHeightPx + lineHeightPx > maxHeightPx) {
                break;
            }
        }
        this.textHeight = fontSize;
        this.textWidth = textWidth;
    };
    Text.prototype.getStrokeScaleEnabled = function () {
        return true;
    };
    return Text;
}(Shape_1.Shape));
exports.Text = Text;
Text.prototype._fillFunc = _fillFunc;
Text.prototype._strokeFunc = _strokeFunc;
Text.prototype.className = TEXT_UPPER;
Text.prototype._attrsAffectingSize = [
    'text',
    'fontSize',
    'padding',
    'wrap',
    'lineHeight',
];
Global_2._registerNode(Text);
Factory_1.Factory.overWriteSetter(Text, 'width', Validators_1.getNumberOrAutoValidator());
Factory_1.Factory.overWriteSetter(Text, 'height', Validators_1.getNumberOrAutoValidator());
Factory_1.Factory.addGetterSetter(Text, 'fontFamily', 'Arial');
Factory_1.Factory.addGetterSetter(Text, 'fontSize', 12, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Text, 'fontStyle', NORMAL);
Factory_1.Factory.addGetterSetter(Text, 'fontVariant', NORMAL);
Factory_1.Factory.addGetterSetter(Text, 'padding', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Text, 'align', LEFT);
Factory_1.Factory.addGetterSetter(Text, 'verticalAlign', TOP);
Factory_1.Factory.addGetterSetter(Text, 'lineHeight', 1, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Text, 'wrap', WORD);
Factory_1.Factory.addGetterSetter(Text, 'ellipsis', false);
Factory_1.Factory.addGetterSetter(Text, 'letterSpacing', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Text, 'text', '', Validators_1.getStringValidator());
Factory_1.Factory.addGetterSetter(Text, 'textDecoration', '');
Util_1.Collection.mapMethods(Text);


/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NonceProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoize_one__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emotion_core__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_esm_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__chunk_39d3fda8_browser_esm_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__chunk_80640036_browser_esm_js__ = __webpack_require__(668);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_18__chunk_80640036_browser_esm_js__["z"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__base_dist_react_select_cac0a5ae_browser_esm_js__ = __webpack_require__(671);
/* unused harmony reexport createFilter */
/* unused harmony reexport defaultTheme */
/* unused harmony reexport mergeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__emotion_css__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__babel_runtime_helpers_esm_taggedTemplateLiteral__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_input_autosize__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__chunk_b36baf1a_browser_esm_js__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__emotion_cache__ = __webpack_require__(1057);



























var NonceProvider =
/*#__PURE__*/
function (_Component) {
  Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(NonceProvider, _Component);

  function NonceProvider(props) {
    var _this;

    Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, NonceProvider);

    _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(NonceProvider).call(this, props));

    Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "createEmotionCache", function (nonce) {
      return Object(__WEBPACK_IMPORTED_MODULE_24__emotion_cache__["a" /* default */])({
        nonce: nonce
      });
    });

    _this.createEmotionCache = Object(__WEBPACK_IMPORTED_MODULE_12_memoize_one__["a" /* default */])(_this.createEmotionCache);
    return _this;
  }

  Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(NonceProvider, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce);
      return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__emotion_core__["CacheProvider"], {
        value: emotionCache
      }, this.props.children);
    }
  }]);

  return NonceProvider;
}(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]);

var index = Object(__WEBPACK_IMPORTED_MODULE_23__chunk_b36baf1a_browser_esm_js__["a" /* m */])(__WEBPACK_IMPORTED_MODULE_19__base_dist_react_select_cac0a5ae_browser_esm_js__["a" /* S */]);

/* harmony default export */ __webpack_exports__["b"] = (index);



/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return manageState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);











var defaultProps = {
  defaultInputValue: '',
  defaultMenuIsOpen: false,
  defaultValue: null
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_inherits__["a" /* default */])(StateManager, _Component);

    function StateManager() {
      var _getPrototypeOf2;

      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, StateManager);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, (_getPrototypeOf2 = Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(StateManager)).call.apply(_getPrototypeOf2, [this].concat(args)));

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "select", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "state", {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onChange", function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);

        _this.setState({
          value: value
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onInputChange", function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);

        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuOpen", function () {
        _this.callProp('onMenuOpen');

        _this.setState({
          menuIsOpen: true
        });
      });

      Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onMenuClose", function () {
        _this.callProp('onMenuClose');

        _this.setState({
          menuIsOpen: false
        });
      });

      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StateManager, [{
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any

    }, {
      key: "getProp",
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any

    }, {
      key: "callProp",
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(SelectComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);

    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]), Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "defaultProps", defaultProps), _temp;
};




/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export animateFill */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSingleton; });
/* unused harmony export delegate */
/* unused harmony export followCursor */
/* unused harmony export hideAll */
/* unused harmony export inlinePositioning */
/* unused harmony export roundArrow */
/* unused harmony export sticky */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__popperjs_core__ = __webpack_require__(2580);
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/


var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};

function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? // @ts-ignore
!!window.msCrypto : false;

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (false) {
  resetVisitedMessages();
}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (false) {
    validateProps(partialProps, []);
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      var _name;

      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function setContent(content, props) {
  if (isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (false) {
      errorWhen(true, 'render() function has not been supplied.');
    }

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target


    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = Object(__WEBPACK_IMPORTED_MODULE_0__popperjs_core__["b" /* createPopper */])(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (false) {
      // Accessibility check
      warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
    }
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
    } // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
    } // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
    }

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
    }

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (false) {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (false) {
    validateTargets(targets);
    validateProps(optionalProps, plugins);
  }

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (false) {
    var isSingleContentElement = isElement(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
  }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      excludedReferenceOrInstance = _ref.exclude,
      duration = _ref.duration;

  mountedInstances.forEach(function (instance) {
    var isExcluded = false;

    if (excludedReferenceOrInstance) {
      isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
    }

    if (!isExcluded) {
      var originalDuration = instance.props.duration;
      instance.setProps({
        duration: duration
      });
      instance.hide();

      if (!instance.state.isDestroyed) {
        instance.setProps({
          duration: originalDuration
        });
      }
    }
  });
};

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

var applyStylesModifier = Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__popperjs_core__["a" /* applyStyles */], {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

var createSingleton = function createSingleton(tippyInstances, optionalProps) {
  var _optionalProps$popper;

  if (optionalProps === void 0) {
    optionalProps = {};
  }

  /* istanbul ignore else */
  if (false) {
    errorWhen(!Array.isArray(tippyInstances), ['The first argument passed to createSingleton() must be an array of', 'tippy instances. The passed value was', String(tippyInstances)].join(' '));
  }

  var individualInstances = tippyInstances;
  var references = [];
  var triggerTargets = [];
  var currentTarget;
  var overrides = optionalProps.overrides;
  var interceptSetPropsCleanups = [];
  var shownOnCreate = false;

  function setTriggerTargets() {
    triggerTargets = individualInstances.map(function (instance) {
      return normalizeToArray(instance.props.triggerTarget || instance.reference);
    }).reduce(function (acc, item) {
      return acc.concat(item);
    }, []);
  }

  function setReferences() {
    references = individualInstances.map(function (instance) {
      return instance.reference;
    });
  }

  function enableInstances(isEnabled) {
    individualInstances.forEach(function (instance) {
      if (isEnabled) {
        instance.enable();
      } else {
        instance.disable();
      }
    });
  }

  function interceptSetProps(singleton) {
    return individualInstances.map(function (instance) {
      var originalSetProps = instance.setProps;

      instance.setProps = function (props) {
        originalSetProps(props);

        if (instance.reference === currentTarget) {
          singleton.setProps(props);
        }
      };

      return function () {
        instance.setProps = originalSetProps;
      };
    });
  } // have to pass singleton, as it maybe undefined on first call


  function prepareInstance(singleton, target) {
    var index = triggerTargets.indexOf(target); // bail-out

    if (target === currentTarget) {
      return;
    }

    currentTarget = target;
    var overrideProps = (overrides || []).concat('content').reduce(function (acc, prop) {
      acc[prop] = individualInstances[index].props[prop];
      return acc;
    }, {});
    singleton.setProps(Object.assign({}, overrideProps, {
      getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function () {
        var _references$index;

        return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
      }
    }));
  }

  enableInstances(false);
  setReferences();
  setTriggerTargets();
  var plugin = {
    fn: function fn() {
      return {
        onDestroy: function onDestroy() {
          enableInstances(true);
        },
        onHidden: function onHidden() {
          currentTarget = null;
        },
        onClickOutside: function onClickOutside(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            currentTarget = null;
          }
        },
        onShow: function onShow(instance) {
          if (instance.props.showOnCreate && !shownOnCreate) {
            shownOnCreate = true;
            prepareInstance(instance, references[0]);
          }
        },
        onTrigger: function onTrigger(instance, event) {
          prepareInstance(instance, event.currentTarget);
        }
      };
    }
  };
  var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, ['overrides']), {
    plugins: [plugin].concat(optionalProps.plugins || []),
    triggerTarget: triggerTargets,
    popperOptions: Object.assign({}, optionalProps.popperOptions, {
      modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [applyStylesModifier])
    })
  }));
  var originalShow = singleton.show;

  singleton.show = function (target) {
    originalShow(); // first time, showOnCreate or programmatic call with no params
    // default to showing first instance

    if (!currentTarget && target == null) {
      return prepareInstance(singleton, references[0]);
    } // triggered from event (do nothing as prepareInstance already called by onTrigger)
    // programmatic call with no params when already visible (do nothing again)


    if (currentTarget && target == null) {
      return;
    } // target is index of instance


    if (typeof target === 'number') {
      return references[target] && prepareInstance(singleton, references[target]);
    } // target is a child tippy instance


    if (individualInstances.indexOf(target) >= 0) {
      var ref = target.reference;
      return prepareInstance(singleton, ref);
    } // target is a ReferenceElement


    if (references.indexOf(target) >= 0) {
      return prepareInstance(singleton, target);
    }
  };

  singleton.showNext = function () {
    var first = references[0];

    if (!currentTarget) {
      return singleton.show(0);
    }

    var index = references.indexOf(currentTarget);
    singleton.show(references[index + 1] || first);
  };

  singleton.showPrevious = function () {
    var last = references[references.length - 1];

    if (!currentTarget) {
      return singleton.show(last);
    }

    var index = references.indexOf(currentTarget);
    var target = references[index - 1] || last;
    singleton.show(target);
  };

  var originalSetProps = singleton.setProps;

  singleton.setProps = function (props) {
    overrides = props.overrides || overrides;
    originalSetProps(props);
  };

  singleton.setInstances = function (nextInstances) {
    enableInstances(true);
    interceptSetPropsCleanups.forEach(function (fn) {
      return fn();
    });
    individualInstances = nextInstances;
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    interceptSetPropsCleanups = interceptSetProps(singleton);
    singleton.setProps({
      triggerTarget: triggerTargets
    });
  };

  interceptSetPropsCleanups = interceptSetProps(singleton);
  return singleton;
};

var BUBBLING_EVENTS_MAP = {
  mouseover: 'mouseenter',
  focusin: 'focus',
  click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */

function delegate(targets, props) {
  /* istanbul ignore else */
  if (false) {
    errorWhen(!(props && props.target), ['You must specity a `target` prop indicating a CSS selector string matching', 'the target elements that should receive a tippy.'].join(' '));
  }

  var listeners = [];
  var childTippyInstances = [];
  var disabled = false;
  var target = props.target;
  var nativeProps = removeProperties(props, ['target']);
  var parentProps = Object.assign({}, nativeProps, {
    trigger: 'manual',
    touch: false
  });
  var childProps = Object.assign({
    touch: defaultProps.touch
  }, nativeProps, {
    showOnCreate: true
  });
  var returnValue = tippy(targets, parentProps);
  var normalizedReturnValue = normalizeToArray(returnValue);

  function onTrigger(event) {
    if (!event.target || disabled) {
      return;
    }

    var targetNode = event.target.closest(target);

    if (!targetNode) {
      return;
    } // Get relevant trigger with fallbacks:
    // 1. Check `data-tippy-trigger` attribute on target node
    // 2. Fallback to `trigger` passed to `delegate()`
    // 3. Fallback to `defaultProps.trigger`


    var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore

    if (targetNode._tippy) {
      return;
    }

    if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') {
      return;
    }

    if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) {
      return;
    }

    var instance = tippy(targetNode, childProps);

    if (instance) {
      childTippyInstances = childTippyInstances.concat(instance);
    }
  }

  function on(node, eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    node.addEventListener(eventType, handler, options);
    listeners.push({
      node: node,
      eventType: eventType,
      handler: handler,
      options: options
    });
  }

  function addEventListeners(instance) {
    var reference = instance.reference;
    on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
    on(reference, 'mouseover', onTrigger);
    on(reference, 'focusin', onTrigger);
    on(reference, 'click', onTrigger);
  }

  function removeEventListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function applyMutations(instance) {
    var originalDestroy = instance.destroy;
    var originalEnable = instance.enable;
    var originalDisable = instance.disable;

    instance.destroy = function (shouldDestroyChildInstances) {
      if (shouldDestroyChildInstances === void 0) {
        shouldDestroyChildInstances = true;
      }

      if (shouldDestroyChildInstances) {
        childTippyInstances.forEach(function (instance) {
          instance.destroy();
        });
      }

      childTippyInstances = [];
      removeEventListeners();
      originalDestroy();
    };

    instance.enable = function () {
      originalEnable();
      childTippyInstances.forEach(function (instance) {
        return instance.enable();
      });
      disabled = false;
    };

    instance.disable = function () {
      originalDisable();
      childTippyInstances.forEach(function (instance) {
        return instance.disable();
      });
      disabled = true;
    };

    addEventListeners(instance);
  }

  normalizedReturnValue.forEach(applyMutations);
  return returnValue;
}

var animateFill = {
  name: 'animateFill',
  defaultValue: false,
  fn: function fn(instance) {
    var _instance$props$rende;

    // @ts-ignore
    if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
      if (false) {
        errorWhen(instance.props.animateFill, 'The `animateFill` plugin requires the default render function.');
      }

      return {};
    }

    var _getChildren = getChildren(instance.popper),
        box = _getChildren.box,
        content = _getChildren.content;

    var backdrop = instance.props.animateFill ? createBackdropElement() : null;
    return {
      onCreate: function onCreate() {
        if (backdrop) {
          box.insertBefore(backdrop, box.firstElementChild);
          box.setAttribute('data-animatefill', '');
          box.style.overflow = 'hidden';
          instance.setProps({
            arrow: false,
            animation: 'shift-away'
          });
        }
      },
      onMount: function onMount() {
        if (backdrop) {
          var transitionDuration = box.style.transitionDuration;
          var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
          // tooltip element. `clip-path` is the other alternative but is not
          // well-supported and is buggy on some devices.

          content.style.transitionDelay = Math.round(duration / 10) + "ms";
          backdrop.style.transitionDuration = transitionDuration;
          setVisibilityState([backdrop], 'visible');
        }
      },
      onShow: function onShow() {
        if (backdrop) {
          backdrop.style.transitionDuration = '0ms';
        }
      },
      onHide: function onHide() {
        if (backdrop) {
          setVisibilityState([backdrop], 'hidden');
        }
      }
    };
  }
};

function createBackdropElement() {
  var backdrop = div();
  backdrop.className = BACKDROP_CLASS;
  setVisibilityState([backdrop], 'hidden');
  return backdrop;
}

var mouseCoords = {
  clientX: 0,
  clientY: 0
};
var activeInstances = [];

function storeMouseCoords(_ref) {
  var clientX = _ref.clientX,
      clientY = _ref.clientY;
  mouseCoords = {
    clientX: clientX,
    clientY: clientY
  };
}

function addMouseCoordsListener(doc) {
  doc.addEventListener('mousemove', storeMouseCoords);
}

function removeMouseCoordsListener(doc) {
  doc.removeEventListener('mousemove', storeMouseCoords);
}

var followCursor = {
  name: 'followCursor',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;
    var doc = getOwnerDocument(instance.props.triggerTarget || reference);
    var isInternalUpdate = false;
    var wasFocusEvent = false;
    var isUnmounted = true;
    var prevProps = instance.props;

    function getIsInitialBehavior() {
      return instance.props.followCursor === 'initial' && instance.state.isVisible;
    }

    function addListener() {
      doc.addEventListener('mousemove', onMouseMove);
    }

    function removeListener() {
      doc.removeEventListener('mousemove', onMouseMove);
    }

    function unsetGetReferenceClientRect() {
      isInternalUpdate = true;
      instance.setProps({
        getReferenceClientRect: null
      });
      isInternalUpdate = false;
    }

    function onMouseMove(event) {
      // If the instance is interactive, avoid updating the position unless it's
      // over the reference element
      var isCursorOverReference = event.target ? reference.contains(event.target) : true;
      var followCursor = instance.props.followCursor;
      var clientX = event.clientX,
          clientY = event.clientY;
      var rect = reference.getBoundingClientRect();
      var relativeX = clientX - rect.left;
      var relativeY = clientY - rect.top;

      if (isCursorOverReference || !instance.props.interactive) {
        instance.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function getReferenceClientRect() {
            var rect = reference.getBoundingClientRect();
            var x = clientX;
            var y = clientY;

            if (followCursor === 'initial') {
              x = rect.left + relativeX;
              y = rect.top + relativeY;
            }

            var top = followCursor === 'horizontal' ? rect.top : y;
            var right = followCursor === 'vertical' ? rect.right : x;
            var bottom = followCursor === 'horizontal' ? rect.bottom : y;
            var left = followCursor === 'vertical' ? rect.left : x;
            return {
              width: right - left,
              height: bottom - top,
              top: top,
              right: right,
              bottom: bottom,
              left: left
            };
          }
        });
      }
    }

    function create() {
      if (instance.props.followCursor) {
        activeInstances.push({
          instance: instance,
          doc: doc
        });
        addMouseCoordsListener(doc);
      }
    }

    function destroy() {
      activeInstances = activeInstances.filter(function (data) {
        return data.instance !== instance;
      });

      if (activeInstances.filter(function (data) {
        return data.doc === doc;
      }).length === 0) {
        removeMouseCoordsListener(doc);
      }
    }

    return {
      onCreate: create,
      onDestroy: destroy,
      onBeforeUpdate: function onBeforeUpdate() {
        prevProps = instance.props;
      },
      onAfterUpdate: function onAfterUpdate(_, _ref2) {
        var followCursor = _ref2.followCursor;

        if (isInternalUpdate) {
          return;
        }

        if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
          destroy();

          if (followCursor) {
            create();

            if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) {
              addListener();
            }
          } else {
            removeListener();
            unsetGetReferenceClientRect();
          }
        }
      },
      onMount: function onMount() {
        if (instance.props.followCursor && !wasFocusEvent) {
          if (isUnmounted) {
            onMouseMove(mouseCoords);
            isUnmounted = false;
          }

          if (!getIsInitialBehavior()) {
            addListener();
          }
        }
      },
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          mouseCoords = {
            clientX: event.clientX,
            clientY: event.clientY
          };
        }

        wasFocusEvent = event.type === 'focus';
      },
      onHidden: function onHidden() {
        if (instance.props.followCursor) {
          unsetGetReferenceClientRect();
          removeListener();
          isUnmounted = true;
        }
      }
    };
  }
};

function getProps(props, modifier) {
  var _props$popperOptions;

  return {
    popperOptions: Object.assign({}, props.popperOptions, {
      modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function (_ref) {
        var name = _ref.name;
        return name !== modifier.name;
      }), [modifier])
    })
  };
}

var inlinePositioning = {
  name: 'inlinePositioning',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference;

    function isEnabled() {
      return !!instance.props.inlinePositioning;
    }

    var placement;
    var cursorRectIndex = -1;
    var isInternalUpdate = false;
    var triedPlacements = [];
    var modifier = {
      name: 'tippyInlinePositioning',
      enabled: true,
      phase: 'afterWrite',
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (isEnabled()) {
          if (triedPlacements.indexOf(state.placement) !== -1) {
            triedPlacements = [];
          }

          if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
            triedPlacements.push(state.placement);
            instance.setProps({
              // @ts-ignore - unneeded DOMRect properties
              getReferenceClientRect: function getReferenceClientRect() {
                return _getReferenceClientRect(state.placement);
              }
            });
          }

          placement = state.placement;
        }
      }
    };

    function _getReferenceClientRect(placement) {
      return getInlineBoundingClientRect(getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
    }

    function setInternalProps(partialProps) {
      isInternalUpdate = true;
      instance.setProps(partialProps);
      isInternalUpdate = false;
    }

    function addModifier() {
      if (!isInternalUpdate) {
        setInternalProps(getProps(instance.props, modifier));
      }
    }

    return {
      onCreate: addModifier,
      onAfterUpdate: addModifier,
      onTrigger: function onTrigger(_, event) {
        if (isMouseEvent(event)) {
          var rects = arrayFrom(instance.reference.getClientRects());
          var cursorRect = rects.find(function (rect) {
            return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
          });
          var index = rects.indexOf(cursorRect);
          cursorRectIndex = index > -1 ? index : cursorRectIndex;
        }
      },
      onHidden: function onHidden() {
        cursorRectIndex = -1;
      }
    };
  }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
  // Not an inline element, or placement is not yet known
  if (clientRects.length < 2 || currentBasePlacement === null) {
    return boundingRect;
  } // There are two rects and they are disjoined


  if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) {
    return clientRects[cursorRectIndex] || boundingRect;
  }

  switch (currentBasePlacement) {
    case 'top':
    case 'bottom':
      {
        var firstRect = clientRects[0];
        var lastRect = clientRects[clientRects.length - 1];
        var isTop = currentBasePlacement === 'top';
        var top = firstRect.top;
        var bottom = lastRect.bottom;
        var left = isTop ? firstRect.left : lastRect.left;
        var right = isTop ? firstRect.right : lastRect.right;
        var width = right - left;
        var height = bottom - top;
        return {
          top: top,
          bottom: bottom,
          left: left,
          right: right,
          width: width,
          height: height
        };
      }

    case 'left':
    case 'right':
      {
        var minLeft = Math.min.apply(Math, clientRects.map(function (rects) {
          return rects.left;
        }));
        var maxRight = Math.max.apply(Math, clientRects.map(function (rects) {
          return rects.right;
        }));
        var measureRects = clientRects.filter(function (rect) {
          return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
        });
        var _top = measureRects[0].top;
        var _bottom = measureRects[measureRects.length - 1].bottom;
        var _left = minLeft;
        var _right = maxRight;

        var _width = _right - _left;

        var _height = _bottom - _top;

        return {
          top: _top,
          bottom: _bottom,
          left: _left,
          right: _right,
          width: _width,
          height: _height
        };
      }

    default:
      {
        return boundingRect;
      }
  }
}

var sticky = {
  name: 'sticky',
  defaultValue: false,
  fn: function fn(instance) {
    var reference = instance.reference,
        popper = instance.popper;

    function getReference() {
      return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
    }

    function shouldCheck(value) {
      return instance.props.sticky === true || instance.props.sticky === value;
    }

    var prevRefRect = null;
    var prevPopRect = null;

    function updatePosition() {
      var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
      var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;

      if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
        if (instance.popperInstance) {
          instance.popperInstance.update();
        }
      }

      prevRefRect = currentRefRect;
      prevPopRect = currentPopRect;

      if (instance.state.isMounted) {
        requestAnimationFrame(updatePosition);
      }
    }

    return {
      onMount: function onMount() {
        if (instance.props.sticky) {
          updatePosition();
        }
      }
    };
  }
};

function areRectsDifferent(rectA, rectB) {
  if (rectA && rectB) {
    return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
  }

  return true;
}

tippy.setDefaultProps({
  render: render
});

/* harmony default export */ __webpack_exports__["b"] = (tippy);

//# sourceMappingURL=tippy.esm.js.map


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyStyles_js__ = __webpack_require__(672);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__applyStyles_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrow_js__ = __webpack_require__(1139);
/* unused harmony reexport arrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__computeStyles_js__ = __webpack_require__(675);
/* unused harmony reexport computeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventListeners_js__ = __webpack_require__(676);
/* unused harmony reexport eventListeners */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flip_js__ = __webpack_require__(1145);
/* unused harmony reexport flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hide_js__ = __webpack_require__(1149);
/* unused harmony reexport hide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__offset_js__ = __webpack_require__(1150);
/* unused harmony reexport offset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__popperOffsets_js__ = __webpack_require__(680);
/* unused harmony reexport popperOffsets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__preventOverflow_js__ = __webpack_require__(1151);
/* unused harmony reexport preventOverflow */










/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_contains_js__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getMainAxisFromPlacement_js__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_within_js__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mergePaddingObject_js__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_expandToHashMap_js__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__dom_utils_instanceOf_js__ = __webpack_require__(95);









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return Object(__WEBPACK_IMPORTED_MODULE_6__utils_mergePaddingObject_js__["a" /* default */])(typeof padding !== 'number' ? padding : Object(__WEBPACK_IMPORTED_MODULE_7__utils_expandToHashMap_js__["a" /* default */])(padding, __WEBPACK_IMPORTED_MODULE_8__enums_js__["b" /* basePlacements */]));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__["a" /* default */])(state.placement);
  var axis = Object(__WEBPACK_IMPORTED_MODULE_4__utils_getMainAxisFromPlacement_js__["a" /* default */])(basePlacement);
  var isVertical = [__WEBPACK_IMPORTED_MODULE_8__enums_js__["f" /* left */], __WEBPACK_IMPORTED_MODULE_8__enums_js__["k" /* right */]].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = Object(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__["a" /* default */])(arrowElement);
  var minProp = axis === 'y' ? __WEBPACK_IMPORTED_MODULE_8__enums_js__["m" /* top */] : __WEBPACK_IMPORTED_MODULE_8__enums_js__["f" /* left */];
  var maxProp = axis === 'y' ? __WEBPACK_IMPORTED_MODULE_8__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_8__enums_js__["k" /* right */];
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = Object(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__["a" /* default */])(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = Object(__WEBPACK_IMPORTED_MODULE_5__utils_within_js__["a" /* within */])(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_2__dom_utils_contains_js__["a" /* default */])(state.elements.popper, arrowElement)) {
    if (false) {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(95);

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && Object(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["c" /* isShadowRoot */])(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = within;
/* harmony export (immutable) */ __webpack_exports__["b"] = withinMaxClamp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(225);

function within(min, value, max) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* max */])(min, Object(__WEBPACK_IMPORTED_MODULE_0__math_js__["b" /* min */])(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergePaddingObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getFreshSideObject_js__ = __webpack_require__(1143);

function mergePaddingObject(paddingObject) {
  return Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0__getFreshSideObject_js__["a" /* default */])(), paddingObject);
}

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFreshSideObject;
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = expandToHashMap;
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__ = __webpack_require__(2582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__ = __webpack_require__(2583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_detectOverflow_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_computeAutoPlacement_js__ = __webpack_require__(2588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__ = __webpack_require__(335);






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["a" /* auto */]) {
    return [];
  }

  var oppositePlacement = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(placement);
  return [Object(__WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__["a" /* default */])(placement), oppositePlacement, Object(__WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__["a" /* default */])(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["a" /* auto */] ? Object(__WEBPACK_IMPORTED_MODULE_4__utils_computeAutoPlacement_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement);

    var isStartVariation = Object(__WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["l" /* start */];
    var isVertical = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */]].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = Object(__WEBPACK_IMPORTED_MODULE_3__utils_detectOverflow_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["k" /* right */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["f" /* left */] : isStartVariation ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* top */];

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(mainVariationSide);
    }

    var altVariationSide = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listScrollParents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getScrollParent_js__ = __webpack_require__(2587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getParentNode_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindow_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isScrollParent_js__ = __webpack_require__(679);




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = Object(__WEBPACK_IMPORTED_MODULE_0__getScrollParent_js__["a" /* default */])(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = Object(__WEBPACK_IMPORTED_MODULE_2__getWindow_js__["a" /* default */])(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], Object(__WEBPACK_IMPORTED_MODULE_3__isScrollParent_js__["a" /* default */])(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(Object(__WEBPACK_IMPORTED_MODULE_1__getParentNode_js__["a" /* default */])(target)));
}

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rectToClientRect;
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeOffsets;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBasePlacement_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVariation_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getMainAxisFromPlacement_js__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_js__ = __webpack_require__(82);




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? Object(__WEBPACK_IMPORTED_MODULE_0__getBasePlacement_js__["a" /* default */])(placement) : null;
  var variation = placement ? Object(__WEBPACK_IMPORTED_MODULE_1__getVariation_js__["a" /* default */])(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["m" /* top */]:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["c" /* bottom */]:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["k" /* right */]:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["f" /* left */]:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? Object(__WEBPACK_IMPORTED_MODULE_2__getMainAxisFromPlacement_js__["a" /* default */])(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case __WEBPACK_IMPORTED_MODULE_3__enums_js__["l" /* start */]:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__enums_js__["e" /* end */]:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__ = __webpack_require__(336);



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [__WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */]].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__["a" /* default */])(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = Object(__WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__["a" /* default */])(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distanceAndSkiddingToXY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(82);

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__["a" /* default */])(placement);
  var invertDistance = [__WEBPACK_IMPORTED_MODULE_1__enums_js__["f" /* left */], __WEBPACK_IMPORTED_MODULE_1__enums_js__["m" /* top */]].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [__WEBPACK_IMPORTED_MODULE_1__enums_js__["f" /* left */], __WEBPACK_IMPORTED_MODULE_1__enums_js__["k" /* right */]].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = __WEBPACK_IMPORTED_MODULE_1__enums_js__["h" /* placements */].reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_getMainAxisFromPlacement_js__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getAltAxis_js__ = __webpack_require__(2589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_within_js__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_utils_getLayoutRect_js__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_utils_getOffsetParent_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getVariation_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getFreshSideObject_js__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_math_js__ = __webpack_require__(225);












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = Object(__WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__["a" /* default */])(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = Object(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(state.placement);
  var variation = Object(__WEBPACK_IMPORTED_MODULE_8__utils_getVariation_js__["a" /* default */])(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = Object(__WEBPACK_IMPORTED_MODULE_2__utils_getMainAxisFromPlacement_js__["a" /* default */])(basePlacement);
  var altAxis = Object(__WEBPACK_IMPORTED_MODULE_3__utils_getAltAxis_js__["a" /* default */])(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */];
    var altSide = mainAxis === 'y' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */];
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["l" /* start */] ? referenceRect[len] : popperRect[len];
    var maxLen = variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["l" /* start */] ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? Object(__WEBPACK_IMPORTED_MODULE_5__dom_utils_getLayoutRect_js__["a" /* default */])(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : Object(__WEBPACK_IMPORTED_MODULE_9__utils_getFreshSideObject_js__["a" /* default */])();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && Object(__WEBPACK_IMPORTED_MODULE_6__dom_utils_getOffsetParent_js__["a" /* default */])(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(tether ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_math_js__["b" /* min */])(min, tetherMin) : min, offset, tether ? Object(__WEBPACK_IMPORTED_MODULE_10__utils_math_js__["a" /* max */])(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */];

    var _altSide = mainAxis === 'x' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* bottom */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* right */];

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [__WEBPACK_IMPORTED_MODULE_0__enums_js__["m" /* top */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["f" /* left */]].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["b" /* withinMaxClamp */])(_tetherMin, _offset, _tetherMax) : Object(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPopper */
/* unused harmony export defaultModifiers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPopper_js__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__ = __webpack_require__(672);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */





var defaultModifiers = [__WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__["a" /* default */]];
var createPopper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__createPopper_js__["a" /* popperGenerator */])({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}




/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setBatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getBatch; });
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(2606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Subscription__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Context__ = __webpack_require__(226);


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  Object(__WEBPACK_IMPORTED_MODULE_6__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Context__["a" /* ReactReduxContext */] : _ref2$context,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, _excluded);

  if (false) {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? __WEBPACK_IMPORTED_MODULE_3_react__["useMemo"] : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && Object(__WEBPACK_IMPORTED_MODULE_4_react_is__["isContextConsumer"])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = Object(__WEBPACK_IMPORTED_MODULE_5__utils_Subscription__["a" /* createSubscription */])(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useReducer"])(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var lastWrapperProps = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(wrapperProps);
      var childPropsFromStoreUpdate = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
      var renderIsScheduled = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(WrappedComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = Object(__WEBPACK_IMPORTED_MODULE_3_react__["useMemo"])(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Connect, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(forwarded, WrappedComponent);
    }

    return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(1158);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(2611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(1159);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStoreHook;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useReduxContext__ = __webpack_require__(1161);



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_2__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = /*#__PURE__*/createStoreHook();

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useReduxContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Context__ = __webpack_require__(226);


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__components_Context__["a" /* ReactReduxContext */]);

  if (false) {
    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
  }

  return contextValue;
}

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(330);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(278);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiToArray_js__ = __webpack_require__(2636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unicodeToArray_js__ = __webpack_require__(2637);




/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
    ? Object(__WEBPACK_IMPORTED_MODULE_2__unicodeToArray_js__["a" /* default */])(string)
    : Object(__WEBPACK_IMPORTED_MODULE_0__asciiToArray_js__["a" /* default */])(string);
}

/* harmony default export */ __webpack_exports__["a"] = (stringToArray);


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/* harmony default export */ __webpack_exports__["a"] = (hasUnicode);


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(1170);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(2643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(277);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(2645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(2656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(2660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(2661);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(2647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(2648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(2651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(2652);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(276);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(330);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_property_expr__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_property_expr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_property_expr__);


var trim = function trim(part) {
  return part.substr(0, part.length - 1).substr(1);
};

function getIn(schema, path, value, context) {
  if (context === void 0) {
    context = value;
  }

  var parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent: parent,
    parentPath: path,
    schema: schema
  };
  Object(__WEBPACK_IMPORTED_MODULE_0_property_expr__["forEach"])(path, function (_part, isBracket, isArray) {
    var part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context: context,
      parent: parent,
      value: value
    });

    if (schema.innerType) {
      var idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error("Yup.reach cannot resolve an array item at index: " + _part + ", in the path: " + path + ". " + "because there is no value at that index. ");
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error("The schema does not contain the path: " + path + ". " + ("(failed at: " + lastPartDebug + " which is a type: \"" + schema._type + "\")"));
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema: schema,
    parent: parent,
    parentPath: lastPart
  };
}

var reach = function reach(obj, path, value, context) {
  return getIn(obj, path, value, context).schema;
};

/* unused harmony default export */ var _unused_webpack_default_export = (reach);

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__ = __webpack_require__(2671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deburr_js__ = __webpack_require__(2672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__words_js__ = __webpack_require__(2675);




/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__words_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__deburr_js__["a" /* default */])(string).replace(reApos, '')), callback, '');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCompounder);


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makePath;
function makePath(strings) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  var path = strings.reduce(function (str, next) {
    var value = values.shift();
    return str + (value == null ? '' : value) + next;
  });
  return path.replace(/^\./, '');
}

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectComponent; });
/* unused harmony export SelectComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(1135);




var dropdownIndicatorStyle = {
    right: "10px",
};
var DropdownIndicator = function (props) {
    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* components */].DropdownIndicator, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, props),
        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: dropdownIndicatorStyle }, "\u25BE")));
};
var SelectComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](SelectComponent, _super);
    function SelectComponent(props) {
        return _super.call(this, props) || this;
    }
    SelectComponent.prototype.render = function () {
        var _this = this;
        var selectStyles = {
            control: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { backgroundColor: "#333333", color: "white", borderRadius: 0, border: "none", width: "auto", height: "25px", minHeight: "25px", boxShadow: "none", "&:hover": {
                    border: "none",
                    boxShadow: "none",
                } })); },
            input: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { color: "white", padding: "0px", margin: "0px" })); },
            singleValue: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { color: "white", height: "25px", lineHeight: "25px", position: "relative", transition: "none", top: "6px" })); },
            indicatorsContainer: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { color: "#C6C6C6", maxHeight: "25px" })); },
            menu: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { width: "100%", borderRadius: "0px", marginTop: "4px", marginBottom: "0px" })); },
            menuList: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { marginTop: "0px", marginBottom: "0px" })); },
            option: function (providedStyles, props) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { paddingTop: "0px", paddingBottom: "0px", color: "#000000", backgroundColor: props.isSelected ? "#868686" : props.data.__isNew__ && "#DEEBFF" }, (_this.props.useOptionFontStyle && { fontFamily: props.data.value }), { "&:hover": {
                    backgroundColor: "#868686"
                } })); },
            valueContainer: function (providedStyles) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, providedStyles, { maxHeight: "25px", overflow: "unset", minWidth: "0px" })); },
        };
        var _a = this.props, onChange = _a.onChange, options = _a.options, value = _a.value, placeholder = _a.placeholder, onMenuOpen = _a.onMenuOpen, inputValue = _a.inputValue, formatGroupLabel = _a.formatGroupLabel, onInputChange = _a.onInputChange, classNames = _a.classNames, disabled = _a.disabled, menuIsOpen = _a.menuIsOpen;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_select__["b" /* default */], { onChange: onChange, options: options, value: value, placeholder: placeholder, getOptionLabel: function (_a) {
                var label = _a.label;
                return label;
            }, 
            // @ts-ignore
            getOptionValue: function (_a) {
                var optionValue = _a.value;
                return optionValue;
            }, onMenuOpen: onMenuOpen, styles: selectStyles, components: {
                IndicatorSeparator: function () { return null; },
                DropdownIndicator: DropdownIndicator
            }, onInputChange: onInputChange, inputValue: inputValue, formatGroupLabel: formatGroupLabel, classNames: classNames, isDisabled: disabled, menuIsOpen: menuIsOpen }));
    };
    return SelectComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = updateMutation;
function updateMutation(mutation, originalOffset, originalLength, newLength, prefixLength, suffixLength) {
  // three cases we can reasonably adjust - disjoint mutations that
  // happen later on where the offset will need to be changed,
  // mutations that completely contain the new one where we can adjust
  // the length, and mutations that occur partially within the new one.
  var lengthDiff = newLength - originalLength;

  var mutationAfterChange = originalOffset + originalLength <= mutation.offset;
  if (mutationAfterChange) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + lengthDiff
    });
  }

  var mutationContainsChange = originalOffset >= mutation.offset && originalOffset + originalLength <= mutation.offset + mutation.length;
  if (mutationContainsChange) {
    return Object.assign({}, mutation, {
      length: mutation.length + lengthDiff
    });
  }

  var mutationWithinPrefixChange = mutation.offset >= originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && prefixLength > 0;
  if (mutationWithinPrefixChange) {
    return Object.assign({}, mutation, {
      offset: mutation.offset + prefixLength
    });
  }

  var mutationContainsPrefix = mutation.offset < originalOffset && mutation.offset + mutation.length <= originalOffset + originalLength && mutation.offset + mutation.length > originalOffset && prefixLength > 0;
  if (mutationContainsPrefix) {
    return [Object.assign({}, mutation, {
      length: originalOffset - mutation.offset
    }), Object.assign({}, mutation, {
      offset: originalOffset + prefixLength,
      length: mutation.offset - originalOffset + mutation.length
    })];
  }

  var mutationContainsSuffix = mutation.offset >= originalOffset && mutation.offset + mutation.length > originalOffset + originalLength && originalOffset + originalLength > mutation.offset && suffixLength > 0;
  if (mutationContainsSuffix) {
    return [Object.assign({}, mutation, {
      offset: mutation.offset + prefixLength,
      length: originalOffset + originalLength - mutation.offset
    }), Object.assign({}, mutation, {
      offset: originalOffset + originalLength + prefixLength + suffixLength,
      length: mutation.offset + mutation.length - (originalOffset + originalLength)
    })];
  }

  return mutation;
}

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = getElementHTML;

var _invariant = __webpack_require__(138);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(458);

var _server2 = _interopRequireDefault(_server);

var _splitReactElement = __webpack_require__(460);

var _splitReactElement2 = _interopRequireDefault(_splitReactElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasChildren(element) {
  return _react2.default.isValidElement(element) && _react2.default.Children.count(element.props.children) > 0;
}

function getElementHTML(element) {
  var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (element === undefined || element === null) {
    return element;
  }

  if (typeof element === 'string') {
    return element;
  }

  if (_react2.default.isValidElement(element)) {
    if (hasChildren(element)) {
      return _server2.default.renderToStaticMarkup(element);
    }

    var tags = (0, _splitReactElement2.default)(element);

    if (text !== null && (typeof tags === 'undefined' ? 'undefined' : _typeof(tags)) === 'object') {
      var start = tags.start,
          end = tags.end;

      return start + text + end;
    }

    return tags;
  }

  (0, _invariant2.default)(Object.prototype.hasOwnProperty.call(element, 'start') && Object.prototype.hasOwnProperty.call(element, 'end'), 'convertToHTML: received conversion data without either an HTML string, ReactElement or an object with start/end tags');

  if (text !== null) {
    var _start = element.start,
        _end = element.end;

    return _start + text + _end;
  }

  return element;
}

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (newFn, rest) {
  return function () {
    var newResult = newFn.apply(undefined, arguments);
    if (newResult !== undefined && newResult !== null) {
      return newResult;
    }

    return rest.apply(undefined, arguments);
  };
};

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseHTML;
var fallback = function fallback(html) {
  var doc = document.implementation.createHTMLDocument('');
  doc.documentElement.innerHTML = html;
  return doc;
};

function parseHTML(html) {
  var doc = void 0;
  if (typeof DOMParser !== 'undefined') {
    var parser = new DOMParser();
    doc = parser.parseFromString(html, 'text/html');
    if (doc === null || doc.body === null) {
      doc = fallback(html);
    }
  } else {
    doc = fallback(html);
  }
  return doc.body;
}

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOCK_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTITY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INLINE_STYLE; });
var BLOCK_TYPE = {
  // This is used to represent a normal text block (paragraph).
  UNSTYLED: 'unstyled',
  HEADER_ONE: 'header-one',
  HEADER_TWO: 'header-two',
  HEADER_THREE: 'header-three',
  HEADER_FOUR: 'header-four',
  HEADER_FIVE: 'header-five',
  HEADER_SIX: 'header-six',
  UNORDERED_LIST_ITEM: 'unordered-list-item',
  ORDERED_LIST_ITEM: 'ordered-list-item',
  BLOCKQUOTE: 'blockquote',
  PULLQUOTE: 'pullquote',
  CODE: 'code-block',
  ATOMIC: 'atomic'
};
var ENTITY_TYPE = {
  LINK: 'LINK',
  IMAGE: 'IMAGE',
  EMBED: 'embed'
};
var INLINE_STYLE = {
  BOLD: 'BOLD',
  CODE: 'CODE',
  ITALIC: 'ITALIC',
  STRIKETHROUGH: 'STRIKETHROUGH',
  UNDERLINE: 'UNDERLINE'
};
/* harmony default export */ __webpack_exports__["d"] = ({
  BLOCK_TYPE: BLOCK_TYPE,
  ENTITY_TYPE: ENTITY_TYPE,
  INLINE_STYLE: INLINE_STYLE
});

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        PasswordQualityValidator = __webpack_require__(693),
        template = __webpack_require__(2794);

    /**
     * View that shows information about the quality of a password.
     *
     * @author Poul Henriksen
     * @class PasswordQualityView
     * @constructor
     *
     * @cfg {Backbone.Model} [model]   The model declaring a <tt>password</tt> property to listen for password change.
     * @cfg {jQuery}         [element] The jQuery password element to listen for password change.
     */
    return ImprovedView.extend({
        template: template,
        className: "password-quality",

        ui: {
            upperCase: ".upper-case",
            lowerCase: ".lower-case",
            digit: ".digit",
            specialCharacter: ".special-character",
            length: ".length"
        },

        modelEvents: {
            "change:password": "_changePasswordModel"
        },

        initialize: function initialize() {
            if (this.options.element) {
                // Bind once and for all so we can remove again explicitly, since a jQuery element, not
                // a Backbone.Model event...
                this._changePasswordElement = this._changePasswordElement.bind(this);
                this.options.element.on("keyup", this._changePasswordElement);
            }
        },

        onClose: function onClose() {
            if (this.options.element) {
                this.options.element.off("keyup", this._changePasswordElement);
            }
        },

        _changePasswordElement: function _changePasswordElement() {
            this._updateQualities(this.options.element.val());
        },

        _changePasswordModel: function _changePasswordModel(model, newPassword) {
            this._updateQualities(newPassword);
        },

        _updateQualities: function _updateQualities(password) {
            this.ui.upperCase.toggleClass("valid", PasswordQualityValidator.containsUpperCase(password));
            this.ui.lowerCase.toggleClass("valid", PasswordQualityValidator.containsLowerCase(password));
            this.ui.digit.toggleClass("valid", PasswordQualityValidator.containsDigit(password));
            this.ui.specialCharacter.toggleClass("valid", PasswordQualityValidator.containsSpecialCharacters(password));
            this.ui.length.toggleClass("valid", PasswordQualityValidator.hasMinimumLength(password));
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImageLibrarySourceEnum = __webpack_require__(102);
    var IntegrationModel = __webpack_require__(127);
    var Scene7HostedRegionEnum = __webpack_require__(1188);

    var _require = __webpack_require__(189),
        UNAUTHORIZED = _require.UNAUTHORIZED,
        SERVICE_UNAVAILABLE = _require.SERVICE_UNAVAILABLE;

    var TYPE_NAME = ImageLibrarySourceEnum.SCENE7.name;

    /**
     * Custom error messages for `401` and `503`.
     *
     * Status codes mapped to error messages.
     *
     * @type Map.<Number, String>
     */
    var errorMessages = new Map();
    errorMessages.set(UNAUTHORIZED, "The Adobe credentials you entered are invalid.");
    errorMessages.set(SERVICE_UNAVAILABLE, "Creator was unable to communicate with Adobe Scene7.");

    return IntegrationModel.extend("Scene7Integration", {
        defaults: {
            username: "",
            password: "",
            type: TYPE_NAME, // other integrations created in Zelp already have this supplied from the backend
            companyName: "",
            region: Scene7HostedRegionEnum.NA.value
        },

        // Added in order to get the image serving url right after initial save.
        updateOnSync: ["imageServingUrl"],

        validate: function validate(attrs) {
            if (!attrs.username) {
                return "A username must be filled in to save this integration";
            }

            if (!attrs.password) {
                return "A password must be filled in to save this integration";
            }
        },
        _handleError: function _handleError(error, options) {
            var status = error.status;

            // Handle custom error messages...

            if (errorMessages.has(status)) {
                error.action = "";
                error.prefix = "";
                error.message = errorMessages.get(status);
                options.closeDelay = 7000;

                return "alert";
            }

            return this.__super();
        }
    }, {
        type: TYPE_NAME
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Enum = __webpack_require__(77);

    return Enum.create("LayerEnum", "value", {
        NA: {
            value: "NA",
            name: "North America"
        },
        EMEA: {
            value: "EMEA",
            name: "EMEA"
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(100),
        ActionFactory = __webpack_require__(358),
        Backbone = __webpack_require__(7),
        ImprovedModel = __webpack_require__(25),
        Permissions = __webpack_require__(22),
        RestApi = __webpack_require__(29),
        Syncer = __webpack_require__(50);

    /**
     * A PrototypeAction acts as a template for actions to be created based on it when it's
     * embedded in experiences. The created actions keep a reference to the prototype in the
     * actionId property.
     *
     * A PrototypeActions has a reference to the PrototypeWidget that it belongs to.
     */
    return ImprovedModel.extend("PrototypeAction", {

        defaults: {
            action: null,
            companyId: null
        },

        relations: [{
            key: "action",
            relatedModel: Action,
            type: Backbone.One,
            // See http://dhruvaray.github.io/backbone-associations/specify-associations.html#sa-map
            map: function map(value) {
                // Only map for raw object representations
                return value instanceof Action ? value : ActionFactory.newActionFromType(value.type, value);
            }
        }],

        constructor: function constructor() {
            this.__super();

            Syncer.State.init(this, {
                permissions: {
                    destroy: Permissions.Privileges.ADMIN,
                    save: Permissions.Privileges.ADMIN
                }
            });
        },

        computed: {
            actionIsInUse: {
                deps: ["action"],
                value: function value(action) {
                    return action && action.get("usedBy").length > 0;
                }
            }
        },

        /**
         * Returns the REST API URL for a PrototypeAction. Used internally by the synchronization
         * mechanism.
         *
         * @returns {String} REST API URL
         */
        url: function url() {
            var id = this.get("id");

            if (id) {
                // URL for GET, PUT and DELETE, i.e. "api/actions/{actionId}"
                return RestApi.pathToSpecificResource(RestApi.Collections.ACTIONS, id);
            }

            // URL for POST, i.e. "api/actions"
            return RestApi.pathToCollection(RestApi.Collections.ACTIONS);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var DashboardConfigurationFactory = __webpack_require__(1191);

    // This singleton is necessary because the EditorRouter uses the values to set locations.
    return DashboardConfigurationFactory.create();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var Enum = __webpack_require__(77);

    var _require = __webpack_require__(1),
        each = _require.each,
        extend = _require.extend,
        isString = _require.isString;

    var DashboardSorting = __webpack_require__(341);
    var LoggedIn = __webpack_require__(31);
    var LoggedInUserState = __webpack_require__(19);
    var ImageCollection = __webpack_require__(314);
    var ChannelCollection = __webpack_require__(697);
    var ImageLibrarySortingEnum = __webpack_require__(399);
    var ImageLibrarySortingProvider = __webpack_require__(698);
    var ImageLibrarySourceEnum = __webpack_require__(102);
    var UserCollection = __webpack_require__(184);
    var Promise = __webpack_require__(21);
    var ContentCollection = __webpack_require__(463);
    var PublishOptionsProvider = __webpack_require__(699);
    var PublishView = __webpack_require__(1194);
    var DashboardImageLibraryView = __webpack_require__(1200);
    var Permissions = __webpack_require__(22);
    var DashboardContentCollectionView = __webpack_require__(703);
    var MatomoReportingView = __webpack_require__(2897);
    var ReportingModel = __webpack_require__(1206);

    // TODO: Remove this monstrosity

    var setReportingTabDisplay = function setReportingTabDisplay() {
        var matomoDashboardVisible = LoggedInUserState.get("integrations").isMatomoReportingDashboardLinkVisibleIntegrationsEnabled();
        if (matomoDashboardVisible) {
            if (!window._zmags_reporting_tab) {
                // Setting a global variable for use in DashboardNavigationView.tpl
                window._zmags_reporting_tab = true; // eslint-disable-line
                var reportingTab = document.getElementById("zmags-reporting-tab"); // This will ensure the tab becomes visible before templates are applied the second time.
                reportingTab.style.display = "inline-block";
            }
        }
    };

    // </monstrosity>

    /**
     * Represents a tab specific configuration.
     *
     * @class DashboardTabConfiguration
     */
    var DashboardTabConfiguration = ImprovedModel.extend("DashboardTabConfiguration", {

        defaults: {
            view: null,
            name: null,
            slug: null,
            path: "",
            collection: null,
            length: 0,
            reloadOptions: false,

            /**
             * Object describing the current context, if any. (Used when in the
             * project context - see ProjectDashboardController)
             *
             * @type {Object}
             */
            context: null
        },

        computed: {
            href: {
                deps: ["path", "context"],
                value: function value(path, context) {
                    return isString(path) ? path : path.call(this, context);
                }
            }
        },

        initialize: function initialize(attributes, options) {
            this.fetchOptions = options.fetchOptions;
            this.count = options && options.count || this.count;
        },
        invalidateLength: function invalidateLength() {
            var _this = this;

            var value = this.count();

            if (Promise.isPromise(value)) {
                return value.then(function (length) {
                    _this.set("length", length);
                });
            }

            this.set("length", value);

            return Promise.resolved(value);
        },
        count: function count() {
            return 0;
        }
    });

    /**
     * Factory for creating a dashboard configuration.
     *
     * This abstraction is needed to support multiple dashboards, e.g. the project dashboard.
     *
     * @class DashboardConfigurationFactory
     *
     * @see ProjectDashboardConfiguration
     */
    return {
        /**
         * Creates the configuration, a an Enumeration of <tt>DashboardTabConfiguration</tt>'s. If no options are
         * passed, the default configuration is returned.
         *
         * @param  {Object} options Options to override the default configuration, see <tt>ProjectDashboardConfiguration</tt>.
         * @return {Enum}           Enumeration of <tt>DashboardTabConfiguration</tt>'s.
         */
        create: function create(options) {
            var idField = {

                EXPERIENCES: new DashboardTabConfiguration({
                    view: DashboardContentCollectionView,
                    name: "Experiences",
                    slug: "experiences",
                    path: ""
                }, {
                    fetchOptions: function fetchOptions() {
                        setReportingTabDisplay();
                        var collection = new ContentCollection(this.get("context"));

                        return Promise.all([collection.query(DashboardSorting.current().query),
                        // We need the list of users to correctly render "Created By"...
                        new UserCollection().fetch()]).then(function (results) {
                            return {
                                collection: collection,
                                principal: LoggedIn.principal(),
                                users: results[1],
                                spectatorMode: Permissions.Privileges.CREATE.cannot()
                            };
                        });
                    },
                    count: function count() {
                        return ContentCollection.count(this.get("context"));
                    }
                }),

                IMAGES: new DashboardTabConfiguration({
                    view: DashboardImageLibraryView,
                    name: "Images",
                    slug: "images",
                    path: "images"
                }, {
                    fetchOptions: function fetchOptions() {
                        setReportingTabDisplay();
                        var imageCollection = new ImageCollection(extend({ autoRemoval: true }, this.get("context")));
                        var imageViewedEventsEnabled = LoggedInUserState.get("companySettings").get("imageViewedEventsEnabled");

                        var creatorSorting = ImageLibrarySortingEnum.without(ImageLibrarySortingEnum.MOST_VIEWED);

                        if (imageViewedEventsEnabled) {
                            creatorSorting = ImageLibrarySortingEnum.all();
                        }

                        var imageLibrarySorting = ImageLibrarySortingProvider.provide({
                            sources: [{ source: ImageLibrarySourceEnum.CREATOR, sorting: creatorSorting }]
                        });

                        var imageTaggingEnabled = LoggedInUserState.get("integrations").imageRekognitionIntegrationsEnabled();

                        var inventoryEnabled = LoggedInUserState.get("integrations").isInventoryEnabled();

                        return imageCollection.query(imageLibrarySorting.getSelectedSorting().query).then(function () {
                            return {
                                imageTaggingEnabled: imageTaggingEnabled,
                                inventoryEnabled: inventoryEnabled,
                                spectatorMode: Permissions.Privileges.CREATE.cannot(),
                                collection: imageCollection,
                                imageViewedEventsEnabled: imageViewedEventsEnabled,
                                imageLibrarySorting: imageLibrarySorting
                            };
                        });
                    },
                    count: function count() {
                        return ImageCollection.count(this.get("context"));
                    }
                }),

                PUBLISH: new DashboardTabConfiguration({
                    view: PublishView,
                    name: "Publish",
                    slug: "publish",
                    path: "publish",
                    // Signal that we wanna reload/fetch the PublishView options every time we enter the publish tab.
                    reloadOptions: true
                }, {
                    /**
                     * Fetch the channel configurations
                     * @returns {Promise} promise with information about the channels information
                     */
                    fetchOptions: function fetchOptions(options) {
                        setReportingTabDisplay();
                        return PublishOptionsProvider.provide(extend(options, { maxScenes: 0 })).then(function (options) {
                            return extend(options, {
                                spectatorMode: Permissions.Privileges.CREATE.cannot()
                            });
                        });
                    },
                    count: function count() {
                        return ChannelCollection.count(this.get("context"));
                    }
                }),
                REPORTING: new DashboardTabConfiguration({
                    view: MatomoReportingView,
                    name: "Reporting",
                    slug: "reporting",
                    path: "reporting",
                    reloadOptions: true
                }, {
                    /**
                     * Since this is not a collection, count() is filler
                     * Also fetchOptions hands the return from a promise to the view as an option
                     */
                    fetchOptions: function fetchOptions(options) {
                        setReportingTabDisplay();
                        var matomoModel = new ReportingModel();
                        switch (LoggedInUserState.get("location")) {
                            case LoggedInUserState.Location.REPORTING_SEGMENT:
                                return matomoModel.redirectToSegmentPage(options.partialViewOptions.segmentDimension);
                            case LoggedInUserState.Location.REPORTING:
                            default:
                                return matomoModel.getMatomoRedirect();
                        }
                    },
                    count: function count() {
                        return 0;
                    }
                })
            };

            // TODO: Remove this after May 14, 2019
            var reportingCalloutEndDate = new Date("April 30, 2019").valueOf();

            if (Date.now() <= reportingCalloutEndDate) {
                idField.REPORTING.set("callout", "NEW");
            }

            var config = Enum.create("DashboardTabConfiguration", idField, {
                context: function context(value) {
                    return this.each(function (tabConfig) {
                        tabConfig.set("context", value);
                    });
                },
                fromSlug: function fromSlug(slug) {
                    return this.each(function (tabConfig) {
                        if (tabConfig.get("slug") === slug) {
                            return tabConfig;
                        }
                    });
                }
            });

            if (options) {
                each(options, function (option, key) {
                    var tabConfig = config[key];

                    tabConfig.set(option, { silent: true });
                });
            }

            return config;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Preconditions = __webpack_require__(14);
    var Sorting = __webpack_require__(696);
    var Storage = __webpack_require__(34);

    /**
     *
     * @class SortingHelperMethods
     */
    var SortingHelperMethods = {
        current: function current(storageKey, sortingKey, sortingEnum, sortingDefault) {
            return function () {
                var currentValue = Storage.Local.get(storageKey, sortingKey);

                if (currentValue) {
                    return sortingEnum.fromValue(currentValue);
                }

                return sortingDefault;
            };
        },

        set: function set(storageKey, sortingKey) {
            return function (value) {
                Preconditions.checkState(_.isString(value) || value instanceof Sorting);

                var storageValue = _.isString(value) ? value : value.value;

                Storage.Local.update(storageKey, sortingKey, storageValue);
            };
        },

        fromValue: function fromValue(sortingEnum) {
            return function (value) {
                return sortingEnum.lookup(value);
            };
        }
    };

    return SortingHelperMethods;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        find = _require.find;

    var ChannelBookmarklet = __webpack_require__(2835);
    var ImprovedModel = __webpack_require__(25);
    var LoggedIn = __webpack_require__(31);
    var RestApi = __webpack_require__(29);
    var SyncManager = __webpack_require__(44);
    var Permissions = __webpack_require__(22);
    var Publishables = __webpack_require__(462);
    var Syncer = __webpack_require__(50);
    var UrlUtil = __webpack_require__(46);

    /**
     * @class {ChannelConfig}
     *
     * Editor type only, viewer uses representation from S3.
     */
    return ImprovedModel.extend("Slot Configuration", { // channels are called slots in user terminology!

        defaults: {
            version: null,
            companyId: null
        },

        updateOnSync: ["purgeTime", "channels"],

        clearOnClone: function clearOnClone(options) {
            if (options.sync) {
                // also for "marshal"
                return ["purgeTime"];
            }
        },


        computed: {
            bookmarklet: {
                deps: ["id"],
                value: function value(id) {
                    return ChannelBookmarklet.fromId(id);
                }
            }
        },

        constructor: function constructor() {
            this.__super();

            // Changing a channel config requires PUBLISH privilege (as well as CREATE)...
            Syncer.State.init(this, {
                permissions: {
                    save: Permissions.Privileges.PUBLISH,
                    destroy: Permissions.Privileges.PUBLISH,
                    domain: Permissions.Privileges.PUBLISH
                }
            });
        },
        url: function url() {
            if (this.isNew()) {
                return RestApi.pathToCollection(RestApi.Collections.CHANNEL_CONFIG);
            }
            return RestApi.pathToSpecificResource(RestApi.Collections.CHANNEL_CONFIG, this.get("id"));
        },
        fetchNewUrl: function fetchNewUrl() {
            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, LoggedIn.companyId(), RestApi.Collections.CHANNEL_CONFIG);
        },
        toJSON: function toJSON() {
            var json = this.__super();

            json.channels = json.channels.map(function (channelJSON) {
                if (!channelJSON.publishable) {
                    channelJSON.publishable = channelJSON.experience ? Publishables.toReference(channelJSON, "Experience") : Publishables.toReference(channelJSON, "BreakpointGroup");
                }

                // Below assignments are required because Channel in backend still uses a serializer expecting id, name and state,
                // but the new Channels API requires a type for any content (experiences and groups (can only be BreakpointGroup)
                // TODO Remove this when we get rid of channel config at all. MOS-3651.
                if (channelJSON.experience && !channelJSON.experience.type) {
                    channelJSON.experience.type = "Experience";
                }

                if (channelJSON.group && !channelJSON.group.type) {
                    channelJSON.group.type = "BreakpointGroup";
                }

                if (channelJSON.schedules && channelJSON.schedules.length === 1) {
                    var schedule = channelJSON.schedules[0];
                    if (schedule.experience) {
                        schedule.experience = Publishables.toReference(schedule.experience, "Experience");
                        delete schedule.group;
                    } else if (schedule.group) {
                        schedule.group = Publishables.toReference(schedule.group, "BreakpointGroup");
                        delete schedule.experience;
                    }
                }

                return channelJSON;
            });

            return json;
        },
        channelById: function channelById(id) {
            return find(this.get("channels"), function (channelJson) {
                return channelJson.id === id || channelJson.cid === id;
            });
        },
        removeChannel: function removeChannel(channelJson) {
            var channels = this.get("channels");
            var i = channels.indexOf(channelJson);

            if (i !== -1) {
                channels.splice(i, 1);
            }
        }
    }, {
        count: function count(options) {
            var location = RestApi.Collections.CHANNEL_CONFIGS_COUNT;
            var project = options && options.project;

            if (project) {
                // projects/{ID}/channels/count
                location = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.CHANNELS_COUNT);
            }

            return SyncManager.get(location, SyncManager.target("ChannelConfig.count"));
        },


        /**
         * Asynchronous fetching of channel config by type and Id
         * @param {string} type - examples: `Experience`, `Group`
         * @param {string} id mongo ObejctId - should be available under model.id
         * @returns {Promise<object[]>} promise resolving with a list of pieces of information about the channels the type and Id resolve to.
         */
        fetchByType: function fetchByType(type, id) {
            var url = UrlUtil.appendParamObject(RestApi.Collections.CHANNEL_CONFIG_CHANNELS, {
                type: type,
                id: id
            });

            return SyncManager.get(url, SyncManager.target("ChannelConfig.fetchByType"));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Backbone = __webpack_require__(7);
    var ChannelSetupManualView = __webpack_require__(700);
    var Browser = __webpack_require__(39);
    var Clipboard = __webpack_require__(702);
    var Configuration = __webpack_require__(27);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var MessageNode = __webpack_require__(465);
    var MessageTypes = __webpack_require__(342);
    var Permissions = __webpack_require__(22);
    var Storage = __webpack_require__(34);
    var template = __webpack_require__(2851);
    var Tooltip = __webpack_require__(35);
    var UrlUtil = __webpack_require__(46);
    var Window = __webpack_require__(48);
    var PublishUtil = __webpack_require__(234);

    var ADMIN_MODE_IDENTIFIER = "zmagsCreatorAdminMode"; // query param *or* session storage
    var LAST_ADDRESS_STORAGE_KEY = "publishLastAddress";
    var SINGLE_WINDOW_KEY = "publishSingleWindow";

    var log = new Logger("PublishView");

    var showSingleWindow = function showSingleWindow() {
        // This could eventually also be based on user preferences (except IE where we have no choice)...
        return Browser.type.ie || Browser.type.edge || Storage.Local.get(Storage.Keys.PUBLISH_VIEW, SINGLE_WINDOW_KEY);
    };

    /**
     * The PublishView is responsible for display publish functionality to the user.
     *
     * @class PublishView
     */
    return ImprovedView.extend({

        /**
         * Prevent that beforeNavigate method is called more than once when moving to experience section, which will include the create and edit sub URLs.
         */
        _confirmed: false,

        _updateFromDnd: false,

        _channelSetupView: null,

        channelSetupViewClass: ChannelSetupManualView,

        _node: null,

        _toolbarWindow: null,

        _customerSiteWindow: null,

        _timer: null,

        _tooltip: null,

        template: template,

        className: "publish-view",

        templateHelpers: function templateHelpers() {
            var key = Browser.os.macOS ? "\u2318" : "Ctrl";
            var _options = this.options,
                bundleStrategy = _options.bundleStrategy,
                channelConfigId = _options.channelConfigId;


            return {
                allowedToPublish: Permissions.Privileges.PUBLISH.can(),
                button: key,
                snippet: PublishUtil.getSnippetUrl(bundleStrategy, channelConfigId)
            };
        },


        regions: {
            channelSetupRegion: "#channel-setup-region",
            publishPrepareLink: "#publish-prepare-link"
        },

        ui: {
            goToAddressForm: ".js-go-to-address-form",
            publishChannel: "#publish-channels",
            publishDetails: "#publish-details",
            publishPrepareLink: "#publish-prepare-link",
            urlInput: "#url-input"
        },

        events: {
            "click @ui.publishDetails": "selectSnippet",

            "click": "_clickHandler",

            "submit @ui.goToAddressForm": function submitUiGoToAddressForm() {
                this._handleGoToAddress();

                // Prevent the default submit action.
                return false;
            }
        },

        getTitle: function getTitle() {
            return "Publish";
        },
        _clickHandler: function _clickHandler(event) {
            switch (event.target.id) {
                case "publish-prepare-link":
                    this.ui.publishPrepareLink.toggleClass("publish-details-open");
                    this.ui.publishDetails.slideToggle(250);
                    break;
                default:
                    this._closeTooltip();
            }
        },
        onRender: function onRender() {
            var _this = this;

            var url = Storage.Local.get(Storage.Keys.PUBLISH_VIEW, LAST_ADDRESS_STORAGE_KEY);
            var _options2 = this.options,
                publishableCollection = _options2.publishableCollection,
                publishableDescriptors = _options2.publishableDescriptors,
                channelCollection = _options2.channelCollection,
                projectContext = _options2.projectContext,
                hasUnPushedChannels = _options2.hasUnPushedChannels;


            this.ui.urlInput.val(this._getDomainURLName(url));
            this.ui.publishDetails.popover();

            this._channelSetupView = new this.channelSetupViewClass({
                publishableCollection: publishableCollection,
                publishableDescriptors: publishableDescriptors,
                collection: channelCollection, // FROM publishables
                projectContext: projectContext,
                allowedToPublish: Permissions.Privileges.PUBLISH.can(),
                node: function node() {
                    return _this._node;
                },
                showPublishButton: true,
                showCreateSlotField: true,
                hasUnPushedChannels: hasUnPushedChannels
            });

            this.channelSetupRegion.show(this._channelSetupView);

            // Let's track when users copy the publish snippet - using the Clipboard to listen for
            // cross-browser 'copy' events.
            this.listenTo(Clipboard, "copy", function () {
                // If the text area containing the snippet currently has focus
                if (document.activeElement === this.$el.find("textarea#snippet").get(0)) {
                    EditorEvents.trigger(EditorEvents.constants.COPY_SNIPPET, {
                        triggerOrigin: "SnippetContainer",
                        projectId: this.options.projectContext && this.options.projectContext.project.get("id")
                    });
                }
            });
        },


        /**
         * Exposes the event source (most likely a collection) associated with the number of
         * items represented by  *this* dashboard sub view. The dashboard will use this for updating
         * the counting labels, by listening for relevant events.
         *
         * @return {Events[]} The event sources needed for the dashboard.
         *
         * @see DashboardView#showTab
         */
        getCountableEventSource: function getCountableEventSource() {
            return this.options.channelCollection;
        },
        selectSnippet: function selectSnippet() {
            var element = this.ui.publishDetails[0];
            var range = void 0;
            var selection = void 0;

            if (document.body.createTextRange) {
                range = document.body.createTextRange();
                range.moveToElementText(element);
                range.select();
            } else if (window.getSelection) {
                selection = window.getSelection();
                range = document.createRange();
                range.selectNodeContents(element);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },


        /**
         * Invoked when navigating away from *this* view - returns <tt>true</tt> if there are any unsaved changes.
         *
         * @return {Boolean} <tt>true</tt> if unsaved changes, <tt>false</tt> otherwise.
         */
        hasUnsavedChanges: function hasUnsavedChanges() {
            // Check the setup view for whether the model has changed...
            return this._channelSetupView.channelChangesInfo.hasAny();
        },


        /**
         * Handles domain naming on Publish WebSite URL.
         * @param {String} domainURL - Domain to be displayed.
         * @returns {String} - Current selected domain, empty string if "None".
         * @private
         */
        _getDomainURLName: function _getDomainURLName(domainURL) {
            return domainURL !== "None" ? domainURL : "";
        },
        _close: function _close() {
            this._closePopups();
            this._closeTooltip();

            // Remove admin mode identifier from storage - this has to be done like this, since channels.js is not
            // using the Storage abstraction, i.e. to ensure correct path...
            if (window.sessionStorage) {
                window.sessionStorage.removeItem(ADMIN_MODE_IDENTIFIER);
            }
        },
        _checkUrl: function _checkUrl(address) {
            if (this._toolbarWindow) {
                var error = 0;

                try {
                    // The following line will succeed if the client has *not* broken out of the frame, i.e. same
                    // domain. Or if the client has broken out of the iframe *and* if we are in a browser like Chrome
                    // with all web security disabled...
                    if (window.location.host.indexOf(this._toolbarWindow.location.host) === -1) {
                        error = 1;
                    }
                } catch (e1) {
                    // SecurityError
                    error = 1;
                    // Fall-through!
                }

                if (!error) {
                    try {
                        // Try and see if we can access to the site iframe location - will be possible if set to
                        // "about:blank" in case the client site uses a "X-Frame-Options: Deny" header, otherwise we
                        // should get a SecurityError. This only works in Chrome (webkit), other browsers still set
                        // the url to "about:blank", but we still get a security error...
                        var iframe = this._toolbarWindow.document.getElementById("site");

                        if (iframe && iframe.contentWindow.location.protocol === "about:") {
                            // === for Chrome with no web security
                            error = 2;
                        }
                    } catch (e2) {// *expected* SecurityError
                        // Fall-through!
                    }
                }

                if (error) {
                    this._close();
                    Storage.Local.unset(Storage.Keys.PUBLISH_VIEW, SINGLE_WINDOW_KEY);

                    var content = " appears that your website cannot be framed for Drag'n Drop publishing in a single window.<br><br>";
                    var msg = "It appears as if the client site '" + address + "'";

                    if (error === 1) {
                        log.error(msg + "has broken out of the publish Drag'n Drop frame!");
                        content = "Unless you explicitly closed your window, it" + content;
                    } else {
                        // error === 2
                        log.error(msg + "uses a 'X-Frame-Origins: Deny' header and cannot be framed!");
                        content = "It" + content;
                    }

                    if (Browser.type.ie || Browser.type.edge) {
                        content += "Unfortunately, the browser you are using does not support drag'n'drop between windows on different domains.<br><br>\n                                   A solution could be to <a href=\"http://browsehappy.com/\">upgrade your browser</a>\n                                   or <a href=\"http://www.google.com/chromeframe/?redirect=true\">activate Google Chrome Frame</a>\n                                   to improve your experience.<br><br>\n                                   However, you can still do manual publishing right here on this page.";
                    } else {
                        content += "Please click \"GO\" again to use two windows for Drag'n Drop publishing.";
                    }

                    if (Configuration.supportEmail) {
                        content += "<br><br>If you still have trouble, please contact <a href=\"mailto:" + Configuration.supportEmail + "\">" + Configuration.supportEmail + "</a>.";
                    }

                    this._tooltip = Tooltip.add(".js-go-to-address-button", {
                        title: "Your website cannot be framed",
                        content: content,
                        trigger: "manual",
                        html: true
                    });
                    Tooltip.show(this._tooltip);
                }
            } else {
                this._closeTooltip();
            }
        },


        /**
         * Handles whether to open or not the drag 'n' drop publishing windows.
         * @private
         */
        _handleGoToAddress: function _handleGoToAddress() {
            // If the channels have been changed, they should be saved first. If the user want to go to DnD
            // with unsaved channels, we want to ask for confirmation if they should be discarded or not.
            if (this._channelSetupView && this._channelSetupView.channelChangesInfo.hasAny()) {
                if (Browser.confirm("You are leaving Manual Publishing with unsaved changes.\n\nDo you want to discard your changes and continue?")) {
                    // Restore channel config state and go to Dnd.
                    this.restoreChannelSetupView();
                    this._goToAddress();
                }
                // else, if want to stay in the Publish tab, since user needs to save the changes before going to Dnd.
            } else {
                this._goToAddress();
            }
        },
        _goToAddress: function _goToAddress() {
            var _this2 = this;

            this._close();

            var old = Storage.Local.get(Storage.Keys.PUBLISH_VIEW, LAST_ADDRESS_STORAGE_KEY),
                address = this.ui.urlInput.val(),
                hostname;

            if (!address) {
                return;
            }

            if (old !== address) {
                Storage.Local.unset(Storage.Keys.PUBLISH_VIEW, SINGLE_WINDOW_KEY); // TODO: remove this when the user can actually choose
            }

            Storage.Local.update(Storage.Keys.PUBLISH_VIEW, LAST_ADDRESS_STORAGE_KEY, address);

            // Re-initialize node, since we can only create Origins upon construction for security reasons! We
            // have to use a regular expression to match against the host, since something like "dr.dk" would
            // probably mean "www.dr.dk" once the server redirects (and then the protocol as well) - but we have no
            // way of knowing this for individual sites at the time we create this node. We just make sure the
            // origins end with the same suffix...
            address = UrlUtil.prependHTTP(address);
            hostname = UrlUtil.location(address, "hostname");

            // Log config; ignore ping about channels being enabled, or it will flood the log...
            var logOptions = { log: Logger.level() >= Logger.LOG, ignore: MessageTypes.PAGE_IS_CHANNELS_ENABLED };

            this._node = new MessageNode({
                name: "publish", eksport: "__zmags.creator.node", log: logOptions, type: "root", origins: { allowed: hostname, callback: "err" }
            });

            var on = {},
                singleWindow = showSingleWindow();

            // Catch this early on, before a client site tries to break out. By first starting the timer here, we
            // ensure that pop-up blockers will not generate false positives...
            if (singleWindow) {
                on[MessageNode.Message.Actions.CHILD] = function (message) {
                    if (message.origin === "frame") {
                        // Check if sites like Tesco breaks out of the iframe. This is easily done, since when iframed, we
                        // can access the location of the opened window; when we no longer can (or if the url changes, i.e.
                        // on Chrome with no web security), the client site is misbehaving...
                        _this2._timer = setInterval(function () {
                            _this2._checkUrl(address);
                        }, 500);
                    }
                };
                // If we get a connection to either leaf node, we assume the client site has not broken out of the
                // frame. This seems to work fine, but it will in reality depend on the client site loading time vs
                // the toolbar loading time...
                on[MessageNode.Message.Actions.CHILDACK] = function (message) {
                    if (message.origin !== "frame") {
                        _this2._closeTooltip();
                    }
                };
            }

            // Close both pop-up windows and tooltip if either of them is closed via "Close-button" click...
            on[MessageNode.Message.Actions.LEAVE] = function (message) {
                if (message.data === "self") {
                    _this2._close();
                }
            };

            on[MessageTypes.NAVIGATE_TO] = function (message) {
                if (message.data.url.charAt(0) === "#") {
                    Backbone.history.navigate(message.data.url, true); // will call onClose for this view, which in turn calls _close()
                } else {
                    Window.open(message.data.url, message.data.target || "zmags_creator");
                }
            };

            // When we get this message with *this* node as a receiver, we know it is because of a save,
            // so we must update the channel setup view accordingly *and* make sure the global experience collection
            // is in sync with the new states from the drag-n-drop publishing - the latter is automatically handled by
            // channel setup view, and this view will render itself again once the channel config is fetched...
            on[MessageTypes.POPULATE_CHANNELS] = function () {
                _this2._updateFromDnd = true; // make sure we do not trigger update back
                _this2._channelSetupView.refresh().always(function () {
                    _this2._updateFromDnd = false;
                });
            };

            this._node.on(on, this);

            var $win = $(window);
            var toolbarWindowWidth = 380;
            var customerSiteWindowWidth = Math.round($win.width() - toolbarWindowWidth - 60);
            var windowHeight = Math.round($win.height() * 0.85);
            var left = 20 + (window.screenX ? window.screenX : window.screenLeft);
            var top = 120 + (window.screenY ? window.screenY : window.screenTop);

            // Check if we have project context. If we have, then open the toolbar with the project context
            var match = window.location.hash.match(/project\/\w+\//);
            var base = "#" + (match ? match[0] : "") + "publishtoolbar/";

            if (singleWindow) {
                this._toolbarWindow = Window.open(this._addLogLevel(base + "framed/" + encodeURIComponent(address)), "publishToolbarWindow", "resizable=yes,scrollbars=yes,width=" + (customerSiteWindowWidth + toolbarWindowWidth) + ",height=" + windowHeight + ",top=" + top + ",left=" + left);
            } else {
                this._toolbarWindow = Window.open(base + encodeURIComponent(address), "publishToolbarWindow", "scrollbars=yes,location=no,addressbar=no,width=" + toolbarWindowWidth + ",height=" + windowHeight + ",top=" + top + ",left=" + (left + customerSiteWindowWidth + 20));
                this._customerSiteWindow = Window.open(this._addLogLevel(UrlUtil.appendParam(address, ADMIN_MODE_IDENTIFIER + "=true")), "customerSiteWindow", "personalbar=yes,scrollbars=yes,menubar=yes,location=no,addressbar=no,toolbar=yes,width=" + customerSiteWindowWidth + ",height=" + windowHeight + ",top=" + top + ",left=" + left);
            }

            // Track the opening of DnD publish event
            var projectContext = this.options.projectContext;
            var eventProperties = {
                triggerOrigin: "GoToDragAndDropPublishingButton"
            };

            if (projectContext) {
                eventProperties.projectId = projectContext.project.get("id");
            }

            EditorEvents.trigger(EditorEvents.constants.OPEN_DRAG_AND_DROP_PUBLISH, eventProperties);
        },
        _addLogLevel: function _addLogLevel(url) {
            // Since we are about to open on a customer window, pass through our logging settings...
            return UrlUtil.appendParam(url, "zmagsLog=" + Logger.level()); // 0 = OFF, 1 = ERROR, 2 = LOG, 3 = VERBOSE
        },
        showSingleDragDropWindow: function showSingleDragDropWindow(single) {
            // will always be single in IE!
            if (single) {
                Storage.Local.update(Storage.Keys.PUBLISH_VIEW, SINGLE_WINDOW_KEY, "single");
            } else {
                Storage.Local.unset(Storage.Keys.PUBLISH_VIEW, SINGLE_WINDOW_KEY);
            }
        },
        _closeTooltip: function _closeTooltip() {
            if (this._tooltip) {
                Tooltip.remove(this._tooltip);
                this._tooltip = null;
            }

            if (this._timer) {
                clearInterval(this._timer);
            }
        },
        _closePopups: function _closePopups() {
            var any = false;

            if (this._customerSiteWindow) {
                this._customerSiteWindow.close();
                any = true;
            }

            if (this._toolbarWindow) {
                this._toolbarWindow.close();
                any = true;
            }

            this._customerSiteWindow = null;
            this._toolbarWindow = null;

            // If no pop-ups, it might be because a reload have been done of this page; the actual opened
            // windows may still be open. If so, we try and force them close by sending a "close" action
            // to them...
            if (this._node) {
                if (!any) {
                    this._node.close(MessageNode.Message.Receivers.ALL);
                }

                this._node.close();
                this._node = null;
            }
        },
        onClose: function onClose() {
            this._close();
        },


        /**
         * Restore channelsSetupView if the view already exists
         */
        restoreChannelSetupView: function restoreChannelSetupView() {
            if (this._channelSetupView) {
                this._channelSetupView.restore();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defer = _require.defer,
        debounce = _require.debounce,
        each = _require.each,
        extend = _require.extend;

    var $ = __webpack_require__(4);
    var Dom = __webpack_require__(2838);
    var ExperienceModel = __webpack_require__(58);
    var EditBehavior = __webpack_require__(106);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);
    var PublishUtil = __webpack_require__(234);

    var _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank;

    var template = __webpack_require__(2843);
    var ValidateBehavior = __webpack_require__(96);
    var ChannelPropertiesViewController = __webpack_require__(2844);

    /**
     * View of the properties of the channel.
     *
     * @author Poul Henriksen
     * @author Antonio Lagrotteria
     */
    return ImprovedView.extend({

        template: template,

        className: "channel-properties-view",

        controller: ChannelPropertiesViewController,

        templateHelpers: function templateHelpers() {
            return {
                notAllowedToPublish: !this.options.allowedToPublish,
                slotName: this.model.get("name")
            };
        },


        ui: {
            nameInput: ".name",
            calendarIcon: ".glyphicon-calendar",
            startTime: ".next-start-time",
            liveSelect: ".live-select",
            nextSelect: ".next-select",
            startTimePicker: ".next-start-time-picker",
            emptyScheduleDate: ".empty-schedule-date",
            okButton: ".btn-ok",
            cancelButton: ".btn-cancel"
        },

        bindings: {
            ".selector": "selector",
            ".url": "url",
            ".slot-schedule-notification": {
                observe: "schedules",
                updateView: false,
                visible: function visible(value) {
                    var scheduledExperience = value ? value[0] : undefined;

                    return scheduledExperience && scheduledExperience.takeDownCurrent;
                }
            },

            ".live-select": {
                observe: ["experience", "group"],

                onSet: function onSet() {
                    var data = this.ui.liveSelect.select2("data");
                    var model = data.id;

                    if (!model) {
                        return [null, null];
                    }

                    if (model instanceof ExperienceModel) {
                        return [model, null];
                    }

                    // Must be group...
                    return [null, model];
                }
            },

            ".next-select": {
                observe: "schedules",

                onGet: function onGet(schedules) {
                    var schedule = schedules ? schedules[0] : null;

                    if (schedule) {
                        if (schedule.takeDownCurrent) {
                            return PublishUtil.NO_EXPERIENCE_SCHEDULED;
                        }

                        return schedule.publishable;
                    }

                    return null;
                },

                onSet: function onSet() {
                    var data = this.ui.nextSelect.select2("data");
                    var publishableModel = data.id;
                    if (publishableModel) {
                        this._enableStartTimePicker(true);

                        var schedule = this.model.getFirstSchedule();

                        if (schedule) {
                            if (this._isNoExperienceScheduled(publishableModel)) {
                                schedule.takeDownCurrent = true;
                                schedule.experience = null;
                                schedule.group = null;
                                schedule.publishable = null;
                                return [schedule];
                            }

                            if (publishableModel instanceof ExperienceModel) {
                                schedule.experience = publishableModel;
                                schedule.group = null;
                            } else {
                                schedule.group = publishableModel;
                                schedule.experience = null;
                            }
                            schedule.publishable = publishableModel;
                            schedule.takeDownCurrent = false;
                            return [schedule];
                        }

                        if (this._isNoExperienceScheduled(publishableModel)) {
                            return [{ takeDownCurrent: true }];
                        }

                        return publishableModel instanceof ExperienceModel ? [{ experience: publishableModel }] : [{ group: publishableModel }];
                    }

                    this._enableStartTimePicker(false);
                    return [];
                }
            }
        },

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,
                container: ".editable-container",
                editFields: [{
                    input: ".name",
                    save: function save(val) {
                        this.model.set("name", val);
                    }
                }]
            },
            validateBehavior: {
                behaviorClass: ValidateBehavior,

                buttonSubmit: ".btn-ok",

                inputValidation: {
                    ".next-start-time": {
                        validator: function validator() {
                            if (isBlank(this.ui.nextSelect.val())) {
                                return true;
                            }
                            return !isBlank(this.ui.startTime.val());
                        },
                        errorText: function errorText() {
                            return "Schedule date required";
                        }
                    },

                    ".selector": {
                        validator: function validator(selector) {
                            // Empty selector allowed
                            if (!isBlank(selector)) {
                                // Try and select using the entered selector; if it succeeds silently, we are ok, but
                                // it will raise an exception when invalid...
                                try {
                                    Dom.selectElements(selector);
                                } catch (e) {
                                    return false;
                                }
                            }
                            return true;
                        },
                        errorText: function errorText() {
                            return "Not a valid CSS selector";
                        }
                    }
                }
            }
        },

        events: {
            "click @ui.okButton": "_okClickHandler",
            "click @ui.cancelButton": "close",
            "click @ui.startTime": "_startTimeClickHandler"
        },

        onRender: function onRender() {
            var _this = this;

            // Set up the time picker
            this.ui.startTimePicker.datetimepicker({
                pickSeconds: false,
                startDate: new Date()
            });

            var picker = this.ui.startTimePicker.data("datetimepicker");
            var schedule = this.model.getFirstSchedule();

            if (schedule && schedule.startTime) {
                picker.setLocalDate(new Date(schedule.startTime));
            }

            this._enableStartTimePicker(!!schedule);
            this.ui.startTimePicker.on("changeDate", function (e) {
                if (e.localDate) {
                    _this.model.getFirstSchedule().startTime = e.localDate.getTime();
                }
            });
        },
        onShow: function onShow() {
            var _ui = this.ui,
                liveSelect = _ui.liveSelect,
                nextSelect = _ui.nextSelect;
            var _options = this.options,
                allowedToPublish = _options.allowedToPublish,
                focus = _options.focus,
                selectedLiveModel = _options.selectedLiveModel,
                selectedScheduledModel = _options.selectedScheduledModel;


            liveSelect.select2(this._buildSelectSettings(selectedLiveModel));
            nextSelect.select2(this._buildSelectSettings(selectedScheduledModel, true));

            if (!allowedToPublish) {
                return;
            }

            this._handleFocus(focus);
        },
        _isNoExperienceScheduled: function _isNoExperienceScheduled(model) {
            return model && model === PublishUtil.NO_EXPERIENCE_SCHEDULED;
        },
        _handleFocus: function _handleFocus(focus) {
            var _this2 = this;

            var _ui2 = this.ui,
                liveSelect = _ui2.liveSelect,
                nextSelect = _ui2.nextSelect,
                nameInput = _ui2.nameInput,
                startTime = _ui2.startTime;

            // Somebody with CSS skills could probably make this *much* nicer...

            var focusFn = null;

            switch (focus) {
                case "name":
                    focusFn = function focusFn() {
                        nameInput.trigger("mousedown");
                    };
                    break;

                case "experience":
                    focusFn = function focusFn() {
                        liveSelect.select2("open");
                    };
                    break;

                case "schedules":
                    focusFn = function focusFn() {
                        nextSelect.select2("open");
                    };
                    break;

                case "schedules.startTime":
                    focusFn = function focusFn() {
                        startTime.trigger("focus");
                        _this2._startTimeClickHandler();
                    };
                    break;

                default:
                    // No need to log here.
                    break;
            }

            if (focusFn) {
                defer(focusFn.bind(this));
            }
        },
        _buildSelectSettings: function _buildSelectSettings(initialModel, schedule) {
            var _this3 = this;

            var projectContext = this.options.projectContext;

            var project = projectContext && projectContext.project;

            return {
                initSelection: function initSelection(element, callback) {
                    _this3.trigger("initSelection", callback, initialModel);
                },

                query: debounce(function (options) {
                    _this3.trigger("fetchResults", options, project, schedule);
                }, 600)
            };
        },
        _okClickHandler: function _okClickHandler() {
            if (!this.inputValidation()) {
                return;
            }

            this.trigger("done", this.model);
            this.close();

            this._triggerEditorEvents();
        },


        /**
         * Sends Mix Panel event for the channel.
         * @private
         */
        _triggerEditorEvents: function _triggerEditorEvents() {
            var _options2 = this.options,
                isNewSlot = _options2.isNewSlot,
                projectContext = _options2.projectContext;

            var eventName = EditorEvents.constants.ADD_CHANNEL;
            var triggerOrigin = "CreateNewChannelSlotModal";

            if (!isNewSlot) {
                eventName = EditorEvents.constants.UPDATE_CHANNEL;
                triggerOrigin = "ExistingChannelSlotModal";
            }

            var projectId = projectContext && projectContext.project.get("id");

            var eventProperties = extend(PublishUtil.buildEventProperties({
                channel: this.model,
                triggerOrigin: triggerOrigin,
                dragAndDrop: false,
                manual: true,
                projectId: projectId
            }), {
                isNewSlot: isNewSlot
            });

            EditorEvents.trigger(eventName, eventProperties);
        },
        _startTimeClickHandler: function _startTimeClickHandler() {
            if (this.options.allowedToPublish) {
                // Trigger datetimepicker on input field
                this.ui.calendarIcon.trigger("click");
            }
        },
        _enableStartTimePicker: function _enableStartTimePicker(enabled) {
            var _ui3 = this.ui,
                emptyScheduleDate = _ui3.emptyScheduleDate,
                startTimePicker = _ui3.startTimePicker;

            if (enabled) {
                emptyScheduleDate.css("visibility", "hidden");
                startTimePicker.css("visibility", "visible");
            } else {
                emptyScheduleDate.css("visibility", "visible");
                startTimePicker.css("visibility", "hidden");
            }
        },


        /**
         * Select2 has a problem when trying to dynamically add nested options under an existing opt group ("All" OR "This Project"), by creating a new one opt group, instead of prepending options to the existing one.
         * (E.g: if "All" category has already options, and the collection has more results, the new options will not be rendered within the "All" opt group, but they will be prepended to a new one)
         *
         * This method removes the opt group for a new set of results, by removing it from the DOM.
         *
         */
        removeEmptyOptGroups: function removeEmptyOptGroups() {
            var labels = $(".select2-results .select2-result-label");
            each(labels, function (label) {
                if ($(label).text().indexOf(PublishUtil.PENDING_OPT_GROUP_RESULT) !== -1) {
                    $(label).remove();
                }
            });
        },
        onClose: function onClose() {
            this.ui.startTimePicker.datetimepicker("destroy");
            this.ui.liveSelect.select2("destroy");
            this.ui.nextSelect.select2("destroy");

            if (this.options.parentView) {
                this.options.parentView._isLightboxOpening = false;
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var util = __webpack_require__(284),
        json = __webpack_require__(464).json();

    var KEY_PREFIX = "zmags_channels:"; // our channel space in the storage

    /**
     * @class
     * A <i>store</i> describes the channel interaction with some form of browser store, such as session storage,
     * local storage, or cookie storage, ensuring a separate name space and option for timeout for values in
     * local storage (e.g. cached raw experience json). <p>
     *
     * Such browser storage may not be available at runtime for several reasons, e.g. incognito mode,
     * quota exceeded, or because of user preferences, but this storage will never fail because of this.
     * Instead, all operations will simply be "no-op"'s, e.g. will never store any values and will never
     * retrieve any either. <p>
     *
     * The backing storage (wrapping session/local storage or document.cookie) must have the following format:
     * <pre>
     *    {
     *        size:   Function(): Number,                                    // Return the number of keys in total,
     *        keys:   Function(index:Number): String                         // Return the key at "index" within [0, size()[,
     *        get:    Function(key:String, timeout:Number): String,          // Returns the value for "key" if the "timeout" in ms has not been exceeded
     *        put:    Function(key:String, value:String, timestamp:Boolean), // Stores the "value" for "key" with an optional timestamp.
     *        remove: Function(key:String)                                   // Removes the value stored for "key".
     *    }
     * </pre>
     * Note the format does not (exactly) match that of the native <tt>Storage</tt> type! <p>
     *
     * If data is stored as json, <tt>format.json()</tt> must be available (i.e. window.JSON). Otherwise this storage
     * will always report a miss when looking up persisted values. Also note that cookie storage is not well suited
     * for storing large chunks of data.
     *
     * @param {Storage} [storage] The backing storage; can be falsey in which case this storage will be disabled (all
     *                            misses, not actual storing made).
     */
    var Store = function Store(storage) {
        // The excessive typeof tests are required as to not break IE7...
        var enabled = !!storage,
            scope = this;

        /**
         * Returns all keys for this storage, optionally only those with the specified key prefix.
         *
         * @param  {String} [prefix] The key prefix, if any; can be falsey.
         * @return {String[]} The keys for this storage; never null, but can be empty.
         */
        this.keys = function (prefix) {
            var keys = [],
                key,
                i;

            if (enabled) {
                if (prefix) {
                    prefix = KEY_PREFIX + prefix;
                } else {
                    prefix = KEY_PREFIX;
                }
                for (i = 0; i < storage.size(); i++) {
                    key = storage.key(i);
                    if (util.idx(key, prefix) === 0) {
                        keys.push(key);
                    }
                }
            }
            return keys;
        };

        /**
         * Clears this storage by removing all keys associated with it, optionally only those with the specified
         * key prefix.
         *
         * @param {String} [prefix] The prefix of keys to to remove, if any; can be falsey.
         * @return {Number} The number of keys removed.
         */
        this.clear = function (prefix) {
            var i,
                keys = scope.keys(prefix);

            for (i = 0; i < keys.length; i++) {
                scope.put(keys[i]); // deletes!
            }
            return keys.length;
        };

        /**
         * Returns the specified value from this storage. <p>
         *
         * Either a string key to look up, or an object like:
         * <pre>
         *   {
         *      key:     String,  // the key to find the value for
         *      json:    Boolean, // true if the stored value is json, false otherwise. If so, the storage value will
         *                        // be parsed into a json object before returned. If json is not supported, the
         *                        // default value from will be returned always.
         *      timeout: Number,  // maximum timeout in ms for the found value. This requires the value stored with
         *                        // an associated timestamp, otherwise ignored. If expired, the persisted value will
         *                        // be deleted from this storage.
         *      defaultValue: *   // the default value to return if none could be found, including if expired.
         *   }
         * </pre>
         *
         * @param {String|*} options The key or options to find the value by; cannot be null.
         * @return {*} The stored (perhaps defaulted) value; can be undefined.
         */
        this.get = function (options) {
            var value;
            if (enabled) {
                try {
                    if (typeof options === "string") {
                        options = { key: options };
                    }
                    value = storage.get(KEY_PREFIX + options.key, options.timeout, options.args);

                    if (options.json) {
                        // Fine to test on just "value" here as a truthy value as expected to be json because of
                        // "options.json" is truthy...
                        if (json && value) {
                            try {
                                value = json.parse(value);
                            } catch (ee) {
                                return options.defaultValue;
                            }
                            // Fall-through, can still default
                        } else {
                            return options.defaultValue;
                        }
                    }

                    // Catch all, as we do not want this storage to interfere with normal behaviour otherwise...
                } catch (e) {
                    // Fall-through, which will default...
                }
            }

            // eslint-disable-next-line eqeqeq
            return value == null ? options.defaultValue : value;
        };

        /**
         * Sets/updates/removes the specified value for this storage. <p>
         *
         * Either a string key to update/delete, or an object like:
         * <pre>
         *   {
         *      key:     String,  // the key to update/delete the value for. If <tt>value</tt> is null/undefined,
         *                        // <tt>key</tt> will be removed from this storage.
         *      value:   *,       // the value to store, or undefined to remove <tt>key</tt>.
         *      json:    Boolean, // true if <tt>value</tt> is json (to be stringified), false otherwise.
         *      timeout: Number   // maximum timeout in ms for the value.
         *   }
         * </pre>
         *
         * @param {String|*} options The key or options to use; cannot be null. If a string, assumed a key to delete.
         * @param {String} The value stored where applicable; can be falsey.
         */
        this.put = function (options) {
            if (enabled) {
                try {
                    if (typeof options === "string") {
                        options = { key: options }; // will delete since no value!
                    }
                    var key = KEY_PREFIX + options.key,
                        value = options.value;

                    if (typeof value === "undefined") {
                        storage.remove(key);
                    } else {
                        if (options.json) {
                            // Fine to test on just "value" here as a truthy value as expected to be json because of
                            // "options.json" is truthy...
                            if (json && value) {
                                try {
                                    value = json.stringify(value);
                                } catch (ee) {
                                    return; // cannot store if it cannot be stringified, but do not disable because of it!
                                }
                            } else {
                                    return; // cannot store json if not available or no value!
                                }
                        }
                        storage.put(key, value, options.timeout);
                        return value;
                    }

                    // QuotaExceededError in incognito mode in Safari, for example, or if truly exceeded; nothing
                    // to do, so we simply fall through after disable this storage henceforth...
                } catch (e) {
                    enabled = false;
                }
            }
        };

        /**
         * Optionally sets, but always returns true if this storage is considered enabled, false otherwise. <p>
         *
         * This storage will be explicitly disabled on for example Quota Exceeded in Safari Incognito mode, of if
         * the user has opted out of cookies and said cookie can be read.
         *
         * @param  {Boolean} [enabled] True to enable this store, false otherwise. If already forcefully
         *                             disabled, e.g. on Quote Exceeded, this store cannot be enabled again.
         * @return {Boolean} True if now enabled, false otherwise.
         */
        this.enabled = function () {
            if (arguments.length) {
                enabled = enabled && arguments[0]; // can have been forcefully disabled, e.g. Quota Exceeded
            }
            return enabled;
        };
    };

    Store.KEY_PREFIX = KEY_PREFIX;

    return Store;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
  "use strict";

  /**
   * @class {State}
   * The <i>State</i> type stores global application state, to potentially be shared among different
   * channel app instances in case a channel snippet is included multiple times on the client page. <p>
   *
   * Any channel related state that must be truly unique for the application must be declared here, as
   * a single state instance will be shared among all applications. This is required to ensure that
   * global scripts are not reloaded, that data is not reloaded, admin mode, etc. <p>
   *
   * The rationale for this awkward design is because multiple snippets will cause multiple scripts to be
   * loaded, initialised during load beyond our control. We can only detect this at app start time, at which
   * point require will already have initialised the duplicate modules. So, we actually do not care about
   * duplicate app instances as such, as long as they share the same state. At app init time when a duplicate
   * snippet is determined, the app state will thus be re-used by the duplicate app.
   *
   * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
   */

  var state = {

    /**
     * Copies all shared state from the source into this state, called when duplicate channel apps are
     * detected. This is a shallow copy, only copying the references to the shared state, so multiple
     * state instances will use the same data.
     *
     * @param  {State} s The state to supply the state references to copy into this state; never null.
     * @return {State} This state to use henceforth; never null.
     */
    copy: function copy(s) {
      var name;
      for (name in s) {
        if (name !== "copy") {
          // ignore this function
          state[name] = s[name]; // by reference!
        }
      }
      return s;
    },

    /**
     * @type {Global}
     * The global setup, available here to be used by the admin application as well.
     */
    global: null,

    /**
     * @type {Log}
     * Short-cut to <tt>Log.global()</tt>, for easy external access to create 'in-place channels' on the fly (no implementation as this comment was changed).
     * It is exposed as "app.log()".
     */
    log: null,

    /**
     * @type {*}
     * Map of configured values, imported from query parameters and/or session storage where available. <p>
     *
     * The map is used to ensure the config will work on devices with no session storage, e.g. old tablets.
     *
     * @see Global
     */
    config: {},

    /**
     * @type {Cache}
     * The global json content cache used by this app, setup in <tt>init</tt>, backed by session storage. <p>
     *
     * The cache will store in-memory json data, e.g. for experiences and groups, but may also be backend
     * by local storage. All content is indexed by id only. <p>
     *
     * If this app is loaded multiple times on a given page, the same cache will be used (since
     * the same app is used).
     *
     * @see  ChannelsApplication
     */
    cache: null,

    /**
     * @type {Snippet[]}
     * The current snippet(s) found in the dom for this app (channel script). Note the bookmarklet, or by fault,
     * can insert the script multiple times. <p>
     *
     * This array will not be cleared between multiple start/stop, but duplicates will be ignored.
     *
     * @see  ChannelsApplication
     */
    snippets: [],

    /**
     * @type {Number}
     * The start time in ms since the epoch for the channels app.
     */
    start: null,

    /**
     * @type {Snippet}
     * The snippet currently forcing this app in admin mode, if any, false otherwise. <p>
     *
     * The snippet will be set once a given snippet is determined to be in admin mode <b>and</b> the
     * channel admin snippet has been loaded, to ensure we do not go into admin mode twice. <p>
     *
     * The snippet mode is coerced to "admin" for the snippet stored here, and all viewer mode configurations
     * cleared (i.e. no preload).
     *
     * @see Snippet#admin
     */
    admin: null,

    /**
     * @type {Dom}
     * The global dom, initialised once the channels app is initialised. <p>
     *
     * This is always for the document associated with <tt>global.win</tt>, but additional doms can be created
     * to represent iframe documents, for example. <p>
     *
     * Never null.
     */
    dom: null,

    /**
     * @type {Dom}
     * A dom wrapping the iframe used to preload scripts in an isolated sandbox/context, avoiding any conflicts
     * with the current window scope. <p>
     *
     * Lazily initialized when a script is loaded with the {.., sandboxed:true, ..} option.
     *
     * @see  Provider#script
     */
    preloadSandbox: null,

    /**
     * @type {*}
     * Map of scripts loaded via the <tt>script</tt> function that are either pending, loaded, or which have
     * failed. <p>
     *
     * Each entry is indexed via the full script url. <p>
     *
     * Each format is like:
     * <pre>
     *   {
     *      requested: Boolean, // True if a load has been performed at all for the script, false otherwise, i.e. if
     *                          // the script was already ready the first time requested.
     *      loaded:    String,  // undefined when not loaded, "callback" when loaded successfully, "errback" when
     *                          // loading has already failed.
     *      sandboxed: Boolean, // True if loaded in an iframe sandbox, false otherwise.
     *      options:   []       // array of queued options as supplied to <tt>script(..)</tt>. Each time <tt>script(..)</tt>
     *                          // is called, its options is enqueued here for the url, the dequeued when ready,
     *                          // successfully or not.
     *   }
     * </pre>
     *
     * @see Provider#script
     */
    scripts: {}

  };

  return state;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CONSTANTS = __webpack_require__(209);
    var EventDispatcher = __webpack_require__(54);
    var IncompatibleWidgetsPopupModel = __webpack_require__(2850);
    var NotificationBar = __webpack_require__(53);

    var ALLOWED_WIDGETS_FOR_EMAIL = ["text", "text-enhanced", "image", "link", "button", "line", "shape"];

    var widgetTypes = {
        "text": "Text",
        "text-enhanced": "Enhanced text",
        "image": "Image",
        "link": "Link",
        "embed": "Embeded URL",
        "html": "HTML",
        "youtube": "Youtube",
        "social-sharing": "Social sharing links",
        "button": "Button",
        "scene-navigator": "Scene navigator",
        "shape": "Shape",
        "line": "Line",
        "demandware": "Cloud product",
        "dynamic-product": "Enhanced product",
        "composite": "Group"
    };

    var widgetImagesURL = {
        "images/image_default_previous_scene.svg": "Previous scene",
        "images/image_default_next_scene.svg": "Next scene"
    };

    /**
     * Widget validation class.
     *
     * <p>Allows to validate widgets for compatibility to "EmailMode",
     *  and returns an array of widgets incompatible with the mode</p>
     *
     * @class WidgetValidator
     * @constructor
     */
    var WidgetValidator = EventDispatcher.extend({
        getIncompatibleWidgetsNames: function getIncompatibleWidgetsNames(incompatibleWidgets) {
            return incompatibleWidgets.map(function (_ref) {
                var widgetName = _ref.widgetName;
                return widgetName;
            }).filter(function (widgetName, i, widgetsNameArray) {
                return widgetsNameArray.indexOf(widgetName) === i;
            }).join(", ");
        },
        getActiveIncompatibleEmailWidgets: function getActiveIncompatibleEmailWidgets(_ref2) {
            var widgetModelsToCheck = _ref2.widgetModelsToCheck,
                systemMessage = _ref2.systemMessage,
                _ref2$isEmailMode = _ref2.isEmailMode,
                isEmailMode = _ref2$isEmailMode === undefined ? true : _ref2$isEmailMode,
                viewModel = _ref2.viewModel;

            var allIncompatibleWidgets = [];

            var checkIncompatibleWidgets = function checkIncompatibleWidgets(widgetModels) {
                widgetModels.forEach(function (widgetModel) {
                    var group = widgetModel.get("group");
                    var type = widgetModel.get("type");
                    if (group) {
                        checkIncompatibleWidgets(group.models);
                    }
                    if (!ALLOWED_WIDGETS_FOR_EMAIL.includes(type)) {
                        if (type === "image") {
                            widgetModel.widgetName = widgetImagesURL[widgetModel.attributes.imageUrl];
                        } else {
                            widgetModel.widgetName = widgetTypes[widgetModel.attributes.type];
                        }
                        allIncompatibleWidgets.push(widgetModel);
                    }
                });
            };
            checkIncompatibleWidgets(widgetModelsToCheck);
            var isRemoveIncompatibleWidgetNotificationOpen = function isRemoveIncompatibleWidgetNotificationOpen() {
                var notification = NotificationBar.list().find(function (notification) {
                    return notification.message.includes("This experience contains widgets which cannot be used in emails");
                });
                if (notification && viewModel) {
                    NotificationBar.close({ id: notification.id });
                }
            };
            /**
             * Display list of incompatible widgets to user
             */

            isRemoveIncompatibleWidgetNotificationOpen();
            var widgetsName = this.getIncompatibleWidgetsNames(allIncompatibleWidgets);
            if (!viewModel && widgetsName.length) {
                systemMessage = systemMessage.replace(": ", ": " + widgetsName);
                NotificationBar.open(systemMessage, { closeDelay: 5000 });
            } else if (isEmailMode && allIncompatibleWidgets.length) {
                var popupModel = new IncompatibleWidgetsPopupModel({
                    allIncompatibleWidgets: allIncompatibleWidgets,
                    viewModel: viewModel,
                    widgetsName: widgetsName,
                    systemMessage: systemMessage
                });
                popupModel.set({ state: CONSTANTS.OPEN_NOTIFICATION });
            }

            return allIncompatibleWidgets;
        }
    });

    return new WidgetValidator();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractImageLibraryView = __webpack_require__(1201);
    var DetailedImageLibraryCollectionView = __webpack_require__(1202);

    /**
     *
     * @class DashboardImageLibraryView
     *
     */
    return AbstractImageLibraryView.extend("DashboardImageLibraryView", {

        imageLibraryClass: DetailedImageLibraryCollectionView,

        /**
         * Invoked from the dashboard view when the tab already exists and we just need to update partial views
         * Invokes update on `imageLibraryView`, see DetailedImageLibraryCollectionView#updatePartialViews
         */
        updatePartialViews: function updatePartialViews(partialViewOptions) {
            this._imageLibraryView.updatePartialViews(partialViewOptions);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var ImageLibraryCollectionView = __webpack_require__(553);
    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(2852);

    return ImprovedView.extend("AbstractImageLibraryView", {

        className: "dashboard-image-view",

        template: template,

        regions: {
            imageLibraryRegion: ".image-library-region"
        },

        /**
         * @type {ImageLibraryCollectionView}
         */
        _imageLibraryView: null,

        /**
         * Exposes the event source (most likely a collection) associated with the number of
         * items represented by  *this* dashboard sub view. The dashboard will use this for updating
         * the counting labels, by listening for relevant events.
         *
         * @return {Collection} The main collection for this dashboard sub view.
         *
         * @see DashboardView#showTab
         */
        getCountableEventSource: function getCountableEventSource() {
            return this.options.collection;
        },
        onShow: function onShow() {
            var ImageLibraryViewClass = this.imageLibraryClass || ImageLibraryCollectionView;
            var imageLibraryViewOptions = _.extend(this.options, {
                itemView: this.itemView,
                itemViewOptions: this._itemViewOptions(),
                hideOverlayDuringLoad: true,
                collectionViewOptions: _.result(this.options, "collectionViewOptions") || this.collectionViewOptions
            });

            this._imageLibraryView = new ImageLibraryViewClass(imageLibraryViewOptions);

            this.imageLibraryRegion.show(this._imageLibraryView);
        },


        /**
         * Invoked from the dashboard view when the tab already exists and we just need to update partial views
         * Implementation example in DashboardImageLibraryView
         */
        updatePartialViews: function updatePartialViews() {},


        /**
         * Invoked from the dashboard view when the tab representing this view become active/deactive.
         *
         * @param  {Boolean} active The active state.
         */
        active: function active(_active) {
            // Delegate active state to the InfiniteScrollingCollectionView
            // instance - this will enable/disable the scroll listener.
            this._imageLibraryView.active(_active);

            if (_active) {
                this._imageLibraryView.refresh();
            }
        },
        _itemViewOptions: function _itemViewOptions() {
            var own = _.result(this, "itemViewOptions") || {};
            var fromOptions = _.result(this.options, "itemViewOptions") || {};

            var _options = this.options,
                spectatorMode = _options.spectatorMode,
                imageViewedEventsEnabled = _options.imageViewedEventsEnabled,
                imageLibrarySorting = _options.imageLibrarySorting;


            return _.extend(own, fromOptions, {
                showTooltips: false,
                showTimesUsedTooltip: true,
                showImageInfo: true,
                showImageViews: imageViewedEventsEnabled,
                dropTargetSize: "large",
                enableDeletion: !spectatorMode,
                isEditable: !spectatorMode,
                imageTaggingEnabled: this.options.imageTaggingEnabled,
                inventoryEnabled: this.options.inventoryEnabled,
                imageLibrarySorting: imageLibrarySorting
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var ImageDetailsView = __webpack_require__(2853);
    var ImageExperienceCollection = __webpack_require__(2859);
    var ImageLibraryCollectionView = __webpack_require__(553);
    var ImageModel = __webpack_require__(258);
    var ImageDetailsLightbox = __webpack_require__(2860);
    var Preconditions = __webpack_require__(14);

    /**
     * A `ImageLibraryCollectionView` that will show a "Image Quickview" when the image thumbnail is clicked.
     *
     * Used by the main image dashboard and the project dashboard.
     *
     * @see DashboardImageLibraryView
     * @see ProjectDashboardImageLibrary
     *
     * @class DetailedImageLibraryCollectionView
     */
    return ImageLibraryCollectionView.extend("DetailedImageLibraryCollectionView", {

        className: ImageLibraryCollectionView.prototype.className + " detailed",

        _lightBox: null,

        _partialViewOptions: null,

        constructor: function constructor() {
            var _this = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var collectionViewOptions = options.collectionViewOptions = options.collectionViewOptions || {};
            var itemEvents = collectionViewOptions.itemEvents = collectionViewOptions.itemEvents || {};
            this._partialViewOptions = options.partialViewOptions;

            itemEvents["image:clicked"] = function (model) {
                return _this._imageClickedHandler(model);
            };

            this.__super(options);

            this._loadSelectedDetails();
        },
        _imageClickedHandler: function _imageClickedHandler(model) {
            var id = model.id;
            this._showDetailsView(model);

            this._partialViewOptions = _.extend(this._partialViewOptions || {}, { id: id, showExperiences: false });
            this._updateRoute("images/details/" + id);
        },


        /**
         * Updates partial views with the specified view options from the editor router
         *
         * @param {Object} partialViewOptions Options for partial views (i.e. image details view)
         * @property {String} id Image id
         * @property {Boolean} showExperiences True if experiences should be displayed
         */
        updatePartialViews: function updatePartialViews(partialViewOptions) {
            this._partialViewOptions = partialViewOptions;
            this._loadSelectedDetails();
        },


        /**
         * Loads the image detail based on the current partial view details
         */
        _loadSelectedDetails: function _loadSelectedDetails() {
            var _this2 = this;

            this._closeLightBox();

            if (this._partialViewOptions) {
                ImageModel.findById(this._partialViewOptions.id).then(function (model) {
                    _this2._showDetailsView(model);
                });
            }
        },
        _updateRoute: function _updateRoute(route) {
            if (this.options.project) {
                route = "project/" + this.options.project.id + "/" + route;
            }

            Backbone.history.navigate(route);
        },
        _showDetailsView: function _showDetailsView(model) {
            var _this3 = this;

            var experienceCollection = new ImageExperienceCollection({ imageId: model.id });

            experienceCollection.count().then(function (experienceCount) {
                var imagedetailsView = new ImageDetailsView(_.extend(_this3.options, {
                    partialViewOptions: _this3._partialViewOptions,
                    model: model,
                    experienceCollection: experienceCollection,
                    experienceCount: experienceCount
                }));

                _this3._lightBox = new ImageDetailsLightbox(imagedetailsView, { css: { width: 540 } });

                _this3._lightBox.open();

                _this3.listenTo(_this3._lightBox, "close", function () {
                    _this3.stopListening(imagedetailsView);
                    _this3._updateRoute("images");
                });

                _this3.listenTo(imagedetailsView, "toggled:experiences", _this3._toggledExperiences);
                _this3.listenTo(imagedetailsView, "edit:experience", _this3._editExperience);
            }).fail(function () {
                Preconditions.fail("Cannot load experience count for image, id: '" + model.id + "'");
            });
        },
        _closeLightBox: function _closeLightBox() {
            if (this._lightBox) {
                // Avoid triggering the close event
                this._lightBox.close({ silent: true });
            }
        },
        _toggledExperiences: function _toggledExperiences(model, isOpen) {
            if (!isOpen) {
                this._updateRoute("images/details/" + model.id + "/experiences");
            } else {
                this._updateRoute("images/details/" + model.id);
            }
        },
        _editExperience: function _editExperience() {
            this._closeLightBox();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(156),
        _ = __webpack_require__(1),
        Preconditions = __webpack_require__(14),
        Permissions = __webpack_require__(22),
        PublishableState = __webpack_require__(65),
        GroupModel = __webpack_require__(104);

    /**
     * Action that deletes a <tt>BreakpointGroup</tt> and all it experiences (assets).
     *
     * @class DeleteBreakpointGroupAction
     */
    return Action.extend("DeleteGroupAction", {

        /**
         * Constructor.
         *
         * DeleteBreakpointGroupAction
         *
         * @param  {GroupModel} group The group or group id.
         * @param  {Object} [options] Optional options (such as project context).
         */
        constructor: function constructor(group, options) {
            this.__super();

            Preconditions.instanceOf(group, GroupModel, "A valid group instance must be specified.");

            this._group = group;

            this._options = options || {};
        },

        executable: function executable() {
            if (!this._group || Permissions.Privileges.CREATE.cannot()) {
                return false;
            }

            // If you cannot publish, you may only delete un-pushed data...
            if (Permissions.Privileges.PUBLISH.cannot()) {
                var experiences = this._group.getAssets();

                return !this._group.hasAtLeastState(PublishableState.PUSHED) && !_.some(experiences, function (experience) {
                    return experience.hasAtLeastState(PublishableState.PUSHED);
                });
            }

            return true;
        },

        _performExecution: function _performExecution() {
            return this._group.destroyWithAssets();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        isEmpty = _require.isEmpty,
        defaults = _require.defaults,
        compose = _require.compose,
        clone = _require.clone,
        identity = _require.identity,
        chain = _require.chain;

    var _defaults = {
        primaryIndex: 0,
        margin: 5,
        containerWidth: 185,
        getFitboxOnly: true,
        fitboxDimensions: {
            width: 130,
            height: 70
        }
    };

    return {
        _sortFn: function _sortFn(item) {
            return -(item.editedAt || item.createdAt);
        },
        _accumulateWidths: function _accumulateWidths(items) {
            return items.reduce(function (accu, item) {
                return accu + item.fitbox.width;
            }, 0);
        },


        /**
         * Returns a function that adds a fitbox property to a supplied dimension. fitbox.width and
         * fitbox.height are calculated so that the item is as big as possible, while still
         * fitting inside the supplied fitboxDimensions.
         *
         * @private
         * @param {Object} fitboxDimensions Width and height that the dimensions should fit into.
         * @returns {Function}
         */
        _getApplyScale: function _getApplyScale(fitboxDimensions) {
            return function (item) {
                var itemWidth = item.width;
                var itemHeight = item.height;
                var widthScale = fitboxDimensions.width / itemWidth;
                var heightScale = fitboxDimensions.height / itemHeight;
                var scalar = widthScale < heightScale ? fitboxDimensions.width / itemWidth : fitboxDimensions.height / itemHeight;

                item.fitbox = {
                    width: Math.round(itemWidth * scalar),
                    height: Math.round(itemHeight * scalar)
                };

                return item;
            };
        },


        /**
         * Returns the overlap and margin values needed to offset the thumbnails. One of the two
         * values will always be zero.
         *
         * @private
         * @param {Number} containerWidth   The width availble for the thumbnails.
         * @param {Number} itemsWidth       The total width of all the thumbnails.
         * @param {Number} numberOfItems    The number of thumbnails.
         * @param {Number} primaryItemWidth The width of the primary thumbnail.
         * @param {Number} maximumMargin    The maximum allowed margin between thumbnails when
                                            tiling them.
         * @returns {Object} Return an object with an overlap and a margin property.
         */
        _getOverlapAndMargin: function _getOverlapAndMargin(containerWidth, itemsWidth, numberOfItems, primaryItemWidth, maximumMargin) {
            // How much will the items overflow if we tile as close as possible, i.e. without
            // any margin?
            var overflow = itemsWidth - containerWidth;

            // 0 = No effect.
            var overlap = 0;
            var margin = 0;

            if (overflow > 0) {
                var leftOverSpace = containerWidth - primaryItemWidth;
                overlap = overflow / (leftOverSpace + overflow);
            } else {
                // We're tiling the thumbnails next to each other. Calculate how much margin
                // between them.
                margin = (containerWidth - itemsWidth) / (numberOfItems - 1);

                if (margin > maximumMargin) {
                    margin = maximumMargin;
                }
            }

            return { overlap: overlap, margin: margin };
        },


        /**
         * Returns a function that sets .fitbox.x on the supplied item. Expects that either overlap
         * or margin is 0.
         *
         * @private
         * @param {Number} overlap  How much each thumbnail should overlap, as a relative value
         *                          from 0 to 1. Settings this to 0 turns off overlapping.
         * @param {Number} margin   How much margins to have between each thumbnail. Setting this
         *                          to 0 turns off margins.
         * @returns {Function}
         */
        _getApplyOffset: function _getApplyOffset(overlap, margin) {
            var accumulatedOffset = 0;

            return function (item, index) {
                item.fitbox.x = accumulatedOffset;
                // Don't apply overlapping to the first item.
                if (index > 0) {
                    item.fitbox.x -= overlap * item.fitbox.width;
                }

                // Update the offset for the next item.
                accumulatedOffset = item.fitbox.x + item.fitbox.width + margin;

                return item;
            };
        },
        _getFitbox: function _getFitbox(item) {
            return item.fitbox;
        },


        /**
         * calculateLayout
         *
         * @param   {Object[]}  dimensions
         * @param   {Object}    [options]
         * @return  {Object[]}
         */
        calculateLayout: function calculateLayout(dimensions, options) {
            if (isEmpty(dimensions)) {
                return [];
            }

            // Assigning simple values.
            var opt = defaults({}, options, _defaults);

            // Cloning and scaling the array of dimensions.
            var applyScale = this._getApplyScale(opt.fitboxDimensions);
            var cloneAndScale = compose(applyScale, clone);
            var items = dimensions.map(cloneAndScale);

            // We need the primary to calculate offsets
            var primary = items[opt.primaryIndex];

            // Is there enough space or do we need to stack the thumbnails?
            var itemsWidth = this._accumulateWidths(items);

            var overlapAndMargin = this._getOverlapAndMargin(opt.containerWidth, itemsWidth, items.length, primary.fitbox.width, opt.margin);

            var applyOffset = this._getApplyOffset(overlapAndMargin.overlap, overlapAndMargin.margin);

            // We have the option to only return the fitbox, rather than
            // the entire object.
            var getFitbox = opt.getFitboxOnly ? this._getFitbox : identity;

            return chain(items) // Begin Chain.
            .sortBy(this._sortFn) // Sort them.
            .without(primary) // Move the primary to...
            .unshift(primary) // ... the front.
            .map(applyOffset) // Apply the offset.
            .reverse() // Reverse so they come out in rendering order.
            .map(getFitbox) // Return just the fitbox if requested.
            .value(); // End chain.
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _templates;

    var _require = __webpack_require__(1),
        template = _require.template,
        pluck = _require.pluck;

    var ChannelConfig = __webpack_require__(1193);
    var GroupUtil = __webpack_require__(306);
    var NotificationBar = __webpack_require__(53);
    var Promise = __webpack_require__(21);
    var PublishableState = __webpack_require__(65);

    var DELETE_PUSHED_ENTITY_TEMPLATE = template("Are you sure you want to delete the <%=typeUnescaped%> <%=itemNameUnescaped%>?");
    var templates = (_templates = {}, _defineProperty(_templates, PublishableState.PUBLISHED.value, template("<%=itemNameUnescaped%> is currently published in: <%= slotsTextUnescaped %> - are you sure you want to delete it?")), _defineProperty(_templates, PublishableState.SCHEDULED.value, template("<%=itemNameUnescaped%> is scheduled for publishing in: <%= slotsTextUnescaped %> - are you sure you want to delete it?")), _defineProperty(_templates, PublishableState.PUSHED.value, DELETE_PUSHED_ENTITY_TEMPLATE), _defineProperty(_templates, PublishableState.NOT_PUSHED.value, DELETE_PUSHED_ENTITY_TEMPLATE), _templates);

    var warnings = {

        /**
         * Returns a warning message based on state and its variants when deleting an experience.
         * The text is unescaped, because this is currently used in a confirm box.
         * @param {ExperienceModel|GroupModel} model Either an Experience model or Group Model (Experience with variants)
         * @param {String} type Display string type of the model ("Experience" / "Variant" / etc)
         * @returns {Promise}    Promise returning the compiled warning message
         */
        fetchDeleteExperienceMessage: function fetchDeleteExperienceMessage(model, type) {

            if ((0, _C3Utils.isC3Experience)()) {
                return Promise.resolved("Are you sure you want to delete this Variant ?");
            }

            var state = GroupUtil.getState(model).value;
            var itemName = "\"" + model.get("name") + "\"";

            switch (state) {
                case PublishableState.PUBLISHED.value:
                // fallthrough
                case PublishableState.SCHEDULED.value:
                    return ChannelConfig.fetchByType(model.get("type"), model.id).then(function (response) {
                        return templates[state]({
                            itemNameUnescaped: itemName,
                            slotsTextUnescaped: pluck(response, "name").join(", ")
                        });
                    }).fail(function () {
                        // API failure
                        NotificationBar.error("Internal error collecting usage data for this " + model.get("type"));
                    });

                default:
                    {
                        var messageText = templates[state]({
                            itemNameUnescaped: itemName,
                            typeUnescaped: type
                        });
                        return Promise.resolved(messageText);
                    }
            }
        }
    };

    return warnings;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var LoggedIn = __webpack_require__(31);
    var Configuration = __webpack_require__(27);

    var MatomoReportingModel = ImprovedModel.extend("MatomoReporting", {

        /**
         * This is sending a call to Matomo for Reporting.
         * We send the bearer token to the Matomo auth wrapper
         * with the users companyID and username
         * in order to Authenticate.
         *
         * Matomo returns either a error if the Authentication is wrong
         * or an html snippet if the Authentication is correct.
         */
        getMatomoRedirect: function getMatomoRedirect() {
            var url = Configuration.matomoConfig.dashboardUrl;
            var urloptions = {
                method: "post",
                type: "POST",
                url: url,
                data: {
                    /**
                     * We don't add the Bearer token because it's added on the Ajax prefilter.
                     * The token on the principal is not correct.
                     * See Login.js
                     */
                    companyId: LoggedIn.principal().get("companyId"),
                    email: LoggedIn.principal().get("user.username")
                },
                contentType: "application/x-www-form-urlencoded; charset=utf-8"
            };

            return this.fetch(urloptions);
        },


        // if you just have a single experience the second will be null, thats ok
        // if you have breakpoints you'll have a group_id and experience ids delimited by ::
        // 488929321039::23823902389032::20832903289 so you can build the right segment
        createNewSegment: function createNewSegment(experienceID, experienceGroupID, experienceGroupName) {
            var url = Configuration.matomoConfig.segmentUrl;

            var urloptions = {
                method: "get",
                type: "GET",
                url: url,
                data: {
                    clientId: LoggedIn.principal().get("companyId"),
                    experienceId: experienceID,
                    experienceGroupId: experienceGroupID,
                    experienceGroupName: experienceGroupName
                }
            };

            return this.fetch(urloptions);
        },
        redirectToSegmentPage: function redirectToSegmentPage(segment) {
            var url = Configuration.matomoConfig.dashboardUrl;
            var urloptions = {
                method: "post",
                type: "POST",
                url: url,
                data: {
                    /**
                     * We don't add the Bearer token because it's added on the Ajax prefilter.
                     * The token on the principal is not correct.
                     * See Login.js
                     */
                    companyId: LoggedIn.principal().get("companyId"),
                    email: LoggedIn.principal().get("user.username"),
                    segment: segment
                },
                contentType: "application/x-www-form-urlencoded; charset=utf-8"
            };

            return this.fetch(urloptions);
        }
    });
    return MatomoReportingModel;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var ImprovedView = __webpack_require__(6);

    /**
     *
     * @class CreateNewExperienceView
     *
     */
    return ImprovedView.extend({

        template: _.template("<div class='text'><%= labelUnescaped %></div>"),

        _onClick: function _onClick() {},

        _labelUnescaped: "",

        // We need a model due to the delete code in the chunking collection.
        model: new Backbone.Model(),

        initialize: function initialize(options) {
            var _options$label = options.label,
                label = _options$label === undefined ? this._labelUnescaped : _options$label,
                _options$onClick = options.onClick,
                onClick = _options$onClick === undefined ? this._onClick : _options$onClick;

            this._labelUnescaped = label;
            this._onClick = onClick;
        },


        templateHelpers: function templateHelpers() {
            return {
                labelUnescaped: this._labelUnescaped
            };
        },

        tagName: "a",

        className: function className() {
            var baseClassName = "create-experience-content-item";
            var className = void 0;
            if (this.options && this.options.additionalClassName) {
                className = this.options.additionalClassName;
            }

            return !className ? baseClassName : baseClassName + " " + className;
        },

        ui: {
            addButton: ".text"
        },

        events: {
            "click @ui.addButton": function clickUiAddButton(event) {
                this._onClick(event);
            }
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(156);
    var ActionSequence = __webpack_require__(467);
    var Promise = __webpack_require__(21);
    var _ = __webpack_require__(1);
    var Preconditions = __webpack_require__(14);
    var GroupModel = __webpack_require__(104);
    var Permissions = __webpack_require__(22);
    var DuplicateExperienceAction = __webpack_require__(405);
    var EditorEvents = __webpack_require__(17);
    var ExperienceModel = __webpack_require__(58);
    var ExportUtilities = __webpack_require__(1209).default;
    var MD5 = __webpack_require__(694);

    /**
     * Finds the cloned experience for the passed experience id in the cloned experiences array.
     * The cloned experience will always have the "copyOf" attribute equals to the original experience.
     *
     * @param {String} experienceId the experience Id to search for
     * @param {ExperienceModel[]} clonedExperiences the cloned experiences array
     * @returns {ExperienceModel} the cloned experience which originated from the passed experience id.
     */
    function findClonedExperience(experienceId, clonedExperiences) {
        return _.find(clonedExperiences, function (clonedExperience) {
            return clonedExperience.get("copyOf") === experienceId;
        });
    }

    /**
     * Action for duplicating a <tt>BreakpointGroup</tt> and all it's experiences (assets).
     *
     * @class DuplicateBreakpointGroupAction
     */
    return Action.extend({

        constructor: function constructor(group, options) {
            this.__super();
            Preconditions.instanceOf(group, GroupModel, "A valid group instance must be specified.");

            this._group = group;

            this._options = options || {};
        },

        executable: function executable() {
            return Permissions.Privileges.CREATE.can();
        },

        _performExecution: function _performExecution() {
            var _this = this;

            var groupClone = this._group.clone({ duplicate: true }); // duplicate: true -> clear fields like id and version since about to be persisted!
            var groupEntries = this._group.entries();
            var experiencesToDuplicate = this._group.getSortedAssets();
            var projectContext = this._options.projectContext;
            var exportedExperienceGroupId = groupClone.get("exportedFromExperienceGroupId");

            // The ordering of the included experiences must be respected - use the ActionSequence (or SyncManager? ping @gro) to
            // ensure experiences are created in sequence, i.e. createdAt get the proper timestamp...
            var actions = _.map(experiencesToDuplicate, function (experienceModel) {
                return new DuplicateExperienceAction(experienceModel);
            });
            // Pass the actions and execute in sequence...
            var sequence = new ActionSequence(actions);
            return sequence.execute().then(function (clonedExperiences) {
                if (exportedExperienceGroupId) {
                    // only dangerous if you duplicate an export :)
                    groupClone.set("exportedFromExperienceGroupId", exportedExperienceGroupId);
                    groupClone.set("exportedExperienceGroupHash", MD5((+new Date()).toString(36), exportedExperienceGroupId));
                }

                var grouplicateHash = groupClone.get("exportedExperienceGroupHash");
                var groupClonePostfix = exportedExperienceGroupId ? " (exported)" : " " + _this._options.postfix;
                groupClone.set("name", groupClone.get("name") + " " + groupClonePostfix);

                // Empty the old entries...
                groupClone.get("entries").reset();
                /*
                 * Iterate through the original group entries and replace the old experience reference with the new one (the cloned one).
                 * Then, attach the newly cloned entries (#attach will also save the group)
                 * There are two race conditions kinda hidden in here:
                 *      1. both modelWithReplacements.save() AND groupClone.attach(clonedModelWithReplacements, value);
                 *          cause the experiences to be saved, so you can get a 409 by not being careful about
                 *          having one finish before the other
                 *      2. if you call getImageIdsMap() for the same image at the same time, then its possible
                 *          to get duplication in the dashboard..  the underlying code of getImageIdsMap
                 *          now stops this from being possible however.
                 */
                var attachPromises = _.map(groupEntries, function (entry) {
                    var experienceId = entry[0].get("id");
                    var value = entry[1];
                    var clonedExperience = findClonedExperience(experienceId, clonedExperiences);
                    var experienceIdOfTheClone = clonedExperience.get("id");
                    var returnValue = void 0;
                    if (exportedExperienceGroupId) {
                        // get the real experience JSON, mutate it and save it back
                        returnValue = new ExperienceModel({ id: experienceIdOfTheClone }).fetch().done(function (model) {
                            var experienceModel = new ExperienceModel(model.toJSON());
                            experienceModel.set("name", model.getDisplayName() + " (exported)");
                            experienceModel.set("exportedFromExperienceGroupId", exportedExperienceGroupId);
                            experienceModel.set("exportedFromExperienceId", experienceId);
                            experienceModel.set("exportedExperienceGroupHash", grouplicateHash);
                            // this DOES NOT GO INTO THE GROUP, its saving changes to the real experience!!
                            var imageIds = ExportUtilities.getImageIds(experienceModel);
                            clonedExperience.set("name",
                            // set on the object that goes back into the group
                            clonedExperience.attributes.name + " (exported)");
                            if (imageIds !== null && imageIds.length !== null && imageIds.length > 0) {
                                return ExportUtilities.getImageIdsMap(imageIds).then(function (imageIdsMap) {
                                    var modelWithReplacements = ExportUtilities.replaceImageIdsGivenMap(experienceModel, imageIdsMap);
                                    return modelWithReplacements.save().then(function () {
                                        return imageIdsMap;
                                    }); // this save generates our 409 if we dont wait here on the save of the Model
                                }).then(function (imageIdsMap) {
                                    // the below makes the changes to the group
                                    var clonedModelWithReplacements = ExportUtilities.replaceImageIdsGivenMap(clonedExperience, imageIdsMap);
                                    // Prevent Breakpoint Save errors by waiting here, cant await return due to lint rule
                                    return groupClone.attach(clonedModelWithReplacements, value); // attach saves the group
                                });
                            } // if there were no images, then we just augment the name, dont call the cms api
                            return groupClone.attach(clonedExperience, value); // attach saves the group
                        });
                    } else {
                        returnValue = groupClone.attach(clonedExperience, value);
                    }
                    return returnValue;
                });

                return Promise.all(attachPromises).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var clonedExperienceReturn;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.next = 2;
                                    return clonedExperiences;

                                case 2:
                                    clonedExperienceReturn = _context.sent;
                                    return _context.abrupt("return", clonedExperienceReturn);

                                case 4:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                })));
            }).then(function () {
                // Attach the group to the project, if in project context.
                if (projectContext) {
                    projectContext.attach(groupClone);
                }

                var eventProperties = {
                    projectId: projectContext && projectContext.project && projectContext.project.get("id"),
                    groupId: groupClone.get("id"),
                    groupPushedVersion: groupClone.get("pushedVersion"),
                    groupType: groupClone.get("type"),
                    groupVersion: groupClone.get("version"),
                    triggerOrigin: "DuplicateGroupButton"
                };

                // Trigger a duplicate group event
                EditorEvents.trigger(EditorEvents.constants.DUPLICATE_GROUP, eventProperties);

                // Return the newly created group clone
                return groupClone;
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_shared_xp_config__ = __webpack_require__(297);


var IMAGE = "image";
// replace image_ids in an experienceModel object given the map from the /cms/ api
var replaceImageIdsGivenMap = function (experienceModel, imageIdsMap) {
    if (Object.keys(imageIdsMap) && Object.keys(imageIdsMap).length > 0) {
        return _replaceIds(experienceModel, imageIdsMap);
    }
    return experienceModel;
};
var _onlyUnique = function (value, index, self) {
    return self.indexOf(value) === index;
};
// given an experienceModel return all of the image_ids contained within it.
var getImageIds = function (experienceModel) {
    var experienceImagesIds = [];
    var backgroundScene = experienceModel.get("backgroundScene");
    var overlayScene = experienceModel.get("overlayScene");
    var allScenes = experienceModel.get("scenes").toArray().slice();
    if (backgroundScene) {
        allScenes.push(backgroundScene);
    }
    if (overlayScene) {
        allScenes.push(overlayScene);
    }
    allScenes.forEach(function (scene) {
        var imageWidgets = scene.get("widgets").filter(function (widget) {
            return widget.get("type") === IMAGE && widget.has("imageId");
        });
        var imageWidgetIds = imageWidgets.map(function (widget) { return widget.get("imageId"); });
        experienceImagesIds = experienceImagesIds.concat(imageWidgetIds);
    });
    return experienceImagesIds.filter(_onlyUnique); // uniq!
};
// here we need to walk the document and replace all instances of the image_ids
var _replaceIds = function (experienceModel, output) {
    var clonedExperienceModel = experienceModel;
    var scenes = clonedExperienceModel.get("scenes");
    var swappedScenes = scenes.toArray().map(function (scene) { return swapImageIdsForScene(scene, output); });
    clonedExperienceModel.set("scenes", swappedScenes);
    var backgroundScene = clonedExperienceModel.get("backgroundScene");
    var swappedBackgroundScene = swapImageIdsForScene(backgroundScene, output);
    clonedExperienceModel.set("backgroundScene", swappedBackgroundScene);
    var overlayScene = clonedExperienceModel.get("overlayScene");
    var swappedOverlayScene = swapImageIdsForScene(overlayScene, output);
    clonedExperienceModel.set("overlayScene", swappedOverlayScene);
    return clonedExperienceModel;
};
var swapImageIdsForScene = function (scene, output) {
    if (scene && scene.get("widgets")) {
        var widgetModels = scene.get("widgets").toArray();
        var swappedWidgetModels = widgetModels.map(function (widget) {
            if (widget.get("type") === IMAGE && widget.has("imageId")) {
                var imageId = widget.get("imageId");
                // when you have fewer scenes than breakpoints then you go can go through again with the same experience
                // you have already swapped, and you'll get a miss on the map
                // check for this case and know we already did the image_id swap, just return the widget
                if (output[imageId]) {
                    var newImageId = output[imageId].imageId;
                    var newImageUrl = widget.get("imageUrl").replace(imageId, newImageId);
                    var newSrc = widget.get("src").replace(imageId, newImageId);
                    widget.set("imageId", newImageId);
                    widget.set("imageUrl", newImageUrl);
                    widget.set("src", newSrc);
                }
            }
            return widget;
        });
        scene.set("widgets", swappedWidgetModels);
    }
    return scene;
};
// this function is synchronous because calling it on the same images at the same time will
// cause some duplication in the dashboard
var getImageIdsMap = function (imageIds) {
    var url = __WEBPACK_IMPORTED_MODULE_1__src_shared_xp_config__["default"].proxyUrl + "/cms/api/images/copy";
    var options = {
        url: url,
        async: false,
        type: "PUT",
        data: JSON.stringify(imageIds),
        contentType: "application/json; charset=utf-8"
    };
    return __WEBPACK_IMPORTED_MODULE_0_jquery__["ajax"](options);
};
/* harmony default export */ __webpack_exports__["default"] = ({ getImageIds: getImageIds, getImageIdsMap: getImageIdsMap, replaceImageIdsGivenMap: replaceImageIdsGivenMap });


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26),
        _ = __webpack_require__(1),
        ImprovedView = __webpack_require__(6),
        DashboardSorting = __webpack_require__(341),
        TemplateSorting = __webpack_require__(709),
        Preconditions = __webpack_require__(14),
        PublishableState = __webpack_require__(65),
        Backbone = __webpack_require__(7),
        Model = Backbone.Model;

    var MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        ALPHABETICAL_GROUPS = {
        "0123456789": "0-9",
        "abcdeABCDE": "A-E",
        "fghijFGHIJ": "F-J",
        "klmnoKLMNO": "K-O",
        "pqrstPQRST": "P-T",
        "uvwxyzUVWXYZ": "U-Z"
    };

    var SortingTitles = {
        PERSON: "Me",
        UNKNOWN_PERSON: "Unknown",
        ALPHABETICAL: "Other"
    };

    var EMPTY = "Empty";

    var Header = ImprovedView.extend({

        template: _.template("<h4 class='experience-group-title'><%- name %></h4>"),

        tagName: "header",

        className: "group-header"

    });

    var Factory = Class.extend({

        /**
         * @type {Function}
         */
        view: Header,

        /**
         * @type {String}
         */
        _name: null,

        constructor: function constructor(options) {
            this.options = options;
        },

        create: function create(index, model) {
            this._name = this.name(model);

            var View = this.view;

            return new View({ model: new Model({ name: this._name }) });
        },

        name: function name() {
            Preconditions.abstractMethodError();
        },

        contains: function contains(model) {
            return this._name === this.name(model);
        }

    });

    var factories = new Map();

    factories.set(DashboardSorting.MONTH, Factory.extend({

        name: function name(model) {
            var date = new Date(model.get("editedAt"));

            return MONTH_NAMES[date.getMonth()] + " " + date.getFullYear();
        }

    }));

    factories.set(DashboardSorting.ALPHABETICAL, Factory.extend({

        name: function name(model) {
            var character = model.get("name").charAt(0);
            var name = _.find(ALPHABETICAL_GROUPS, function (val, key) {
                return _.contains(key, character);
            });

            return _.isUndefined(name) ? SortingTitles.ALPHABETICAL : name;
        }

    }));

    factories.set(DashboardSorting.PERSON, Factory.extend({

        name: function name(model) {
            var users = this.options.users,
                myUserId = this.options.principal.get("userId"),
                createdById = model.get("createdBy");

            if (createdById === myUserId) {
                return SortingTitles.PERSON;
            }

            return users.get(createdById) || SortingTitles.UNKNOWN_PERSON;
        }

    }));

    factories.set(DashboardSorting.STATE, Factory.extend({

        name: function name(model) {
            return PublishableState.getEnum(model.get("state")).displayName;
        }

    }));

    factories.set(TemplateSorting.ALPHABETICAL, Factory.extend({

        name: function name() {
            return "";
        }

    }));

    factories.set(TemplateSorting.CREATED, Factory.extend({

        name: function name() {
            return "New Experience";
        }

    }));

    factories.set(EMPTY, Factory.extend({

        name: function name() {
            return " ";
        }

    }));

    return Class.extend({

        _factory: null,

        _sorting: null,

        constructor: function constructor(options) {
            this.options = options;
        },

        create: function create(sorting, index, model) {
            Preconditions.checkState(factories.has(sorting), "Unknown sorting specified: " + sorting);

            if (this._sorting !== sorting) {
                this._sorting = sorting;

                var _Factory = factories.get(sorting);

                this._factory = new _Factory(this.options);
            }

            if (!this._factory.contains(model)) {
                return this._factory.create(index, model);
            }
        },

        reset: function reset() {
            this._factory = null;
            this._sorting = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var Browser = __webpack_require__(39);
    var ExperienceViewModel = __webpack_require__(343);
    var InitialScenesController = __webpack_require__(2871);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Marionette = __webpack_require__(10);
    var Promise = __webpack_require__(21);
    var ResponsiveViewerController = __webpack_require__(2872);
    var SceneNavigationAction = __webpack_require__(191);
    var SceneTransitionController = __webpack_require__(2873);
    var SceneViewer = __webpack_require__(707);
    var template = __webpack_require__(2874);
    var Window = __webpack_require__(48);

    var Region = Marionette.Region;

    var CLASS_PREFIX = "scene region";
    var NUM_REGIONS = 3; /* Must be an odd number */

    var log = new Logger("ExperienceViewer");

    /**
     * Experience viewer.
     *
     * Used to view an experience with one or more scenes.
     *
     * @author Kim
     * @class ExperienceViewer
     *
     * @cfg {ExperienceViewModel} model The experience view model.
     */
    return Marionette.Layout.extend({ // Not ImprovedView, since this class is used in the viewer

        className: "experience-viewer",

        template: template,

        responsiveViewerControllerOptions: null,

        _autoPlayIntervalId: null,

        /**
         * Additional options passed to the ResponsiveViewerController.
         *
         * See <tt>PreviewExperienceViewer</tt>.
         *
         * @type {Object|Function}
         */
        _responsiveViewerController: null,

        _transitionController: null,

        _sceneRegions: null,

        _shownDeferred: null,

        _pause: function _pause(paused) {
            // Avoid triggering needless events when stalled...
            if (!this.model.get("stalled")) {
                // Special edge case: if the user still hovers on this Experience at the time of unpause (at some
                // earlier point in time), "paused" may actually already be false but auto play will not have been
                // started because of the _.defer(..) wrapper to check for hover on next focus. We can thus be here
                // if we get a "mouseleave" event before the _.defer(..) callback fires. We thus have to start auto
                // play manually here in case unpaused already and about to unpause as well, since no change:paused
                // event will then fire...
                var pause = this.model.get("paused");
                this.model.set("paused", paused);
                if (!pause && !paused) {
                    this._startAutoPlay();
                }
            }
        },


        events: {
            "mouseenter": "_onMouseEnter",
            "mouseleave": "_onMouseLeave"
        },

        regions: {
            overlayRegion: ".overlay-region",
            backgroundRegion: ".background-region"
        },

        modelEvents: {
            "change:currentScene": "_currentSceneChangeHandler",
            "change:viewportVisibility": "_visibilityChangeHandler"
        },

        initialize: function initialize() {
            this._responsiveViewerController = new ResponsiveViewerController(_.extend({
                viewer: this,
                viewportSize: this.options.fixedSize,
                viewportInitialSize: this.options.initialSize,
                embedContainer: this.options.embedContainer,
                verticalAlign: this.options.verticalAlign,
                horizontalAlign: this.options.horizontalAlign,
                scrollableContainer: this.options.scrollableContainer
            }, _.result(this, "responsiveViewerControllerOptions")));

            this._transitionController = new SceneTransitionController(this.model);
            this._shownDeferred = Promise.deferred();

            this.experience = this.model.get("experience");
            this.numOfScenes = this.experience.getNumberOfScenes();

            // Listen for scale/resize changes in order to update the experience size
            this.listenTo(this.experience, "change:scale", this._scaleChangeHandler);

            this._currentSceneChangeHandler = _.throttle(this._currentSceneChangeHandler, 501); // magic number!? (from git commit sha: cdbdce23506)

            this._addEventListeners();
        },
        _onMouseEnter: function _onMouseEnter() {
            this._pause(true);
        },
        _onMouseLeave: function _onMouseLeave() {
            this._pause(false);
        },


        /**
         * Convenience method returning a promise that resolves when the view is initially
         * shown (i.e. triggers it's 'show' event).
         *
         * @return {Promise} a promise that resolves when the view is initially
         * shown (i.e. triggers it's 'show' event).
         */
        ready: function ready() {
            var deferred = Promise.deferred();

            this.listenToOnce(this, "show", deferred.resolve);

            return deferred.promise();
        },
        shown: function shown() {
            return this._shownDeferred.promise();
        },
        fadeIn: function fadeIn() {
            if (this.$el) {
                this.$el.addClass("fade-in");
            }
        },


        /**
         * Sets the position of the experience viewer.
         *
         * @param  {Number} x The position on the x axis.
         * @param  {Number} y The position on the y axis.
         */
        position: function position(x, y) {
            Browser.transform(this.el, { x: x, y: y });
        },
        _addEventListeners: function _addEventListeners() {
            var _this = this;

            // Listen for tab changes in the browser, so we can differentiate between normal activation/deactivation
            // and user navigation via browser tabs, but always trigger a corresponding "change:active" event. We only
            // listen for this for non-embedded top mosyt Viewers as it will recursively triggered an "active" change
            // to any embedded children...
            this.listenTo(this.model, "change:shown", function (model, shown, options) {
                log.verbose("Page " + (shown ? "show" : "hide") + " for: " + model.get("experience"));

                // Did the shown event originate from this - if so top most - Viewer, or via top down
                // recursion from a parent Viewer? If so, trigger "change:active" that will recurse
                // on its own, otherwise do not as any child will be notified via recursion. However,
                // we must manually recurse to notify children about "shown" event always, as embedded
                // Viewers will not listen for such an event. We have to do it like this to ensure
                // we do not accidentally activate Viewers that should not be on show again...
                var viewer = Window.viewer();
                if (viewer) {
                    viewer.state({ name: "shown", value: shown });
                }

                // Only falsey when originating from this Viewer...
                if (!options.recursive) {
                    if (shown) {
                        model.state("active", model.get("_active"), options);
                    } else {
                        // Save previous active state so it can be restored - we do not want to activate embedded
                        // Experiences on adjacent Scenes, for example...
                        model.set("_active", model.state("active", false, options), { silent: true }); // "_active" is private
                    }
                }
            });

            // We need to deactivate any Viewer "as a whole" when the "active" property changes to ensure we do not
            // listen for "global events", e.g. resize or orientation changes, when this Viewer is inactive. This is
            // typically the case when this Viewer is embedded on some adjacent Scene currently not visible. A change
            // will only trigger a full re-render of the current scene, including overlay and background, as it will be
            // the only active Scene. This is initiated from  ViewerProxy.state({name: "active": value: true|false, ..})
            // and will from there recurse into relevant embedded children...
            this.listenTo(this.model, "change:active", function (model, active) {
                log.verbose((active ? "Activated" : "Deactivated") + " experience: " + model.get("experience"));

                // We sure all global window events are disabled once this viewer is inactive, including possible
                // references to parent/top windows. This is not the prettiest solution, but it ensures that other
                // types, like the BreakpointObserver type that knows nothing about the ExperienceViewModel from
                // within the inner most ExperienceController, will not continue to fire global events while
                // said Experience as a whole is hidden...
                Window.active(active);

                // Notify scenes -> widgets -> actions/embedded Experiences...
                _this._getCurrentLayers().forEach(function (layer) {
                    layer.setActive(active);
                });

                // Start playing again (unless still paused/stalled). We manually invoke the start/stop functions
                // as the model "paused" and "stalled" states are likely to have their old values from the time
                // this Viewer was made inactive, meaning a change event will not fire...
                if (active) {
                    _this._startAutoPlay();

                    // Stop playing...
                } else {
                    _this._stopAutoPlay();
                }
            });

            // Regardless if embedded or direct url, if this Experience is stalled, we must do so for all reachable
            // Experiences, i.e. all recursively defined children of the top most Experience/Viewer (on {recursive: false})
            // *or* from this Experience/Viewer (on {recursive: true}), or they may continue to play while for example
            // a lightbox is opened or when navigation occurs away from a scene containing embedded Experiences. <p>
            //
            // This event can thus be triggered in one of three ways:
            //
            //   1. Internally from this Viewer, from 'experienceViewModel.set("stalled", true|false)'.
            //   2. During a top down recursive traversal of all reachable (embedded) Viewers, starting at the top
            //      most one reachable from this Viewer (for both embedded and direct urls). This is via
            //      ViewerProxy.state({stalled: .., ..}) and used to stall/pause all, for example on lightbox open.
            //   3. During a top down recursive traversal of all reachable (embedded) Viewers, starting at this Viewer
            //      (for both embedded and direct urls). This is via ViewerProxy.state({stalled: .., ..}) as well but
            //      used to stall/pause a sub-set of Experiences only, e.g. those reachable from a given Scene only.
            //
            this.listenTo(this.model, "change:stalled", function (model, stalled, options) {
                // Did the stalled event originate from this Viewer, or via recursion?
                var thisViewer = !options.recursive;

                // The "change:stalled" event is triggered internally (case 1), start the top down traversal from the
                // top most reachable Experience (case 2). However, during the top down traversal, we will never hit
                // this Viewer event again, since already stalled hence no change event, but the recursion will still
                // call "state(..)" on all embedded children. Also note that the top most Viewer may even be this Viewer.
                // This is why we fall-through to the pause logic below, knowing that a stall will typically be
                // triggered from an already paused Experience...
                if (thisViewer) {
                    // Start recursing from from the top? We cannot statically fetch the top most viewer as it might
                    // not even exist in the Editor, i.e. the top most Viewer viewed in preview mode uses different
                    // logic, and all embedded ones will actually on a different domain. Also, recursively embedding
                    // via Lightboxes should not (un)stall all those already stalled by other Lightboxes. This means
                    // that we cannot (un)pause such Experiences there. Top most viewer can only be null in the Editor
                    // or on hardcoded cross domain url by the client in the dom. However, the top most reachable
                    // viewer may not be the only top most Viewer as other siblings to it may exist, e.g. multiple
                    // top level Experiences on the same page. Also note that the top most viewer may be in the actual
                    // top level window on a direct url viewed directly as-is, but more likely a top most viewer will
                    // be in an iframe associated with the dom of the top level window (client site)...
                    var viewer = Window.viewer();
                    if (viewer) {
                        // e.g. null in editor
                        // true: start from the closest intermediate root, since all other above it will have
                        // recursively been (un)stalled already...
                        var topMostViewers = viewer.root(true).siblings();
                        for (var i = 0; i < topMostViewers.length; i++) {
                            topMostViewers[i].state({ name: "stalled", value: stalled });
                        }
                    }
                    // Fall-through to make sure *this* Viewer behaves as any of the other viewers except we make sure
                    // we unpause again on unstalling...
                }

                // On "options.recursive=true", it means we are triggered because of a top down traversal of all embedded
                // Viewers, starting from the top most reachable Experience or from some parent wanting to pause
                // all children on for example scene navigation (case 2 or 3, respectively). It is thus ok to trigger
                // a pause event now. This will also trigger pause of this Viewer itself when reached...
                // On stall, save the "paused" state so we do not unpause blindly when no longer stalled...
                var experience = model.get("experience");

                if (stalled) {
                    log.verbose("Stalled experience: " + experience);
                    // If already paused, we do not need to do anything...
                    if (!model.get("paused")) {
                        // Since now stalled, this will trigger "_paused" to be computed whenever "paused" is
                        // changed while stalled. We add a "stalled: true" option is to ensure the computed property
                        // in ExperienceViewModel knows that it is this logic that does this...
                        options.stalled = true;
                        model.set("paused", true, { stalled: true, recursive: true }); // "model.set" options, not "proxy.state" options!

                        // Make sure we unpause on unstall this Viewer since the stall event originated at this Viewer. This
                        // is just by convention, but seem to fit our current use cases quite well...
                    } else if (thisViewer) {
                        model.set("_paused", true, { silent: true });
                    }

                    // No longer stalled, so ensure we restore the "paused" state accordingly. The paused state can have
                    // changed in the mean time, so the setting of it may not trigger a "changed:paused" event...
                } else {
                    log.verbose("Unstalled experience: " + experience);
                    // The "_paused" attribute is "computed" based on "paused", but only while stalled and if it
                    // was originally set above. If present at all, it will be true initially when paused above, but
                    // it can be have flipped to false in the mean time. If so, somebody else explicitly unpaused
                    // while stalled and we will respect this here...
                    if (model.get("_paused")) {
                        // "_paused" intentionally, not "paused"
                        // Since no longer stalled, this will trigger "_paused" to be set to undefined...
                        model.set("paused", false, { recursive: true }); // "model.set" options, not "proxy.state" options!
                    }
                }
            });

            // On first direct user interaction with a so configured action, ensure we stop auto play  - it can never
            // be enabled again for the specific Experience currently. That it, this does not recurse into
            // other Experiences/Viewers like "paused" and "stalled" potentially does...
            this.listenToOnce(this.model, "change:autoPlay", function (model) {
                // i.e. first time from true -> false
                log.verbose("Disabled auto play for experience: " + model.get("experience"));
                _this._stopAutoPlay();
            });

            // Regardless if embedded or direct url, if this Experience is paused/started, we must do so for all parent
            // Experiences recursively embedding this Experience. We do not care about sibling Experiences, e.g.
            // the parent Experience embedding other ones besides this one as well, since they should be allowed
            // to continue while the user is interacting with this one...
            this.listenTo(this.model, "change:paused", function (model, paused, options) {
                // options: model.set options, not proxy.state options
                var experience = model.get("experience");
                var autoPlay = model.get("autoPlay"); // even on unpause, auto play can still be disabled
                var parentState = Window.viewer("self", "parent.state"); // can be null, and may change over time, e.g. in the Editor

                // If this Experience is now paused, ensure that we stop auto play immediately...
                if (paused) {
                    log.verbose("Paused auto play " + (autoPlay ? "enabled" : "disabled") + " experience: " + experience);
                    _this._stopAutoPlay();
                    // And do so recursively for all parents as well...
                    if (parentState && !options.recursive) {
                        // "parentState" already recursively handled?
                        parentState({ name: "paused", value: true, recursive: false });
                    }

                    // If this Experience is no longer paused, start auto play again *unless* the user still hovers on this
                    // Experience on next render. If so, the Experience should still be paused, and the auto play will not
                    // start until "mouseleave" and we trigger yet another recursive "change:paused" event to ensure the
                    // "paused" state is correct, including for all potential listeners...
                } else {
                    _.defer(function () {
                        if (_this.$el.is(":hover")) {
                            model.set("paused", true); // will trigger this listener to be called again with paused = false
                        } else {
                            log.verbose("Unpaused auto play " + (autoPlay ? "enabled" : "disabled") + " experience: " + experience);
                            _this._startAutoPlay();
                            // And do so recursively for all parents as well...
                            if (parentState && !options.recursive) {
                                // "parentState" already recursively handled?
                                parentState({ name: "paused", value: false, recursive: false });
                            }
                        }
                    });
                }
            });

            // Do we have an initial state to trigger on on the view model, passed in as options typically from a
            // parent viewer embedding this one...
            var state = this.options.state;
            if (state) {
                Window.active(state.value);
                // Silent because we are not ready to process the events yet, and relevant contexts will simply
                // initialise themselves bases on the model value at init time, and hence form on changes... :/
                this.model.set(state.name, state.value, { silent: true });
                delete this.options.state;
            }

            // Register for page show/hide events in order to disable scene transitions during inactivity. This is
            // when the user clicks a different browser tab, then comes back again sometime in the future. We only
            // need to do this for top level Viewers, i.e. those not embedded, or alternative all those that cannot
            // find a reachable parent (same thing), as they will recurse down to the embedded children...
            if ($.support.pageVisibility) {
                if (!Window.viewer("self", "parent")) {
                    $(window.document).on({ // only top level doc
                        "show.visibility": function showVisibility() {
                            _this.model.state("shown", true); // start from here, then recurse
                        },
                        "hide.visibility": function hideVisibility() {
                            _this.model.state("shown", false); // start from here, then recurse
                        }
                    });
                }

                // Legacy behaviour, both in terms of functionality and browser. IE9 does not support the modern
                // page visibility api, and the jquery-visibility.js plugin tries to emulate it by focus events,
                // but that is semantically wrong, e.g. we get a "hide" event when the user clicks outside the
                // browser window while the page is still visible to the end user. We cannot trigger the "shown"
                // event as it will cascade into potentially disabling relevant stuff, making it unclickable until
                // the page regains focus, i.e. every second click is lost. This is nowhere near perfect, but probably
                // as good as it will get in IE 9...
            } else {
                var viewer = Window.viewer();
                if (viewer && !viewer.parent) {
                    $(window.document).on({ // only top level doc
                        "show.visibility": function showVisibility() {
                            viewer.state({ name: "paused", value: false, recursive: true }); // top-down recursive
                        },
                        "hide.visibility": function hideVisibility() {
                            viewer.state({ name: "paused", value: true, recursive: true }); // top-down recursive
                        }
                    });
                }
            }

            // Support swiping to change scenes, depending on the transition
            var transitionType = this._transitionController.getTransitionType();

            if (transitionType.supportSwipes && this.numOfScenes > 1) {
                this.$el.swipe({
                    threshold: 40,
                    triggerOnTouchLeave: true,
                    allowPageScroll: transitionType.allowPageScroll || "auto",
                    swipe: function swipe(event, direction) {
                        var experienceDirection = transitionType.swipeDirections[direction];

                        if (experienceDirection === ExperienceViewModel.DIRECTION_FORWARD) {
                            new SceneNavigationAction({ target: SceneNavigationAction.NEXT }).activate(_this.model);
                        } else if (experienceDirection === ExperienceViewModel.DIRECTION_REVERSE) {
                            new SceneNavigationAction({ target: SceneNavigationAction.PREVIOUS }).activate(_this.model);
                        }
                    }
                });
            }
        },


        // Throttle the current scene changed handler
        // Otherwise we see crashes on iOS when scene changes come too rapidly
        // The user will still end up on the correct scene, there just might be intermediate scenes that
        // aren't rendered
        _currentSceneChangeHandler: function _currentSceneChangeHandler(model) {
            var _this2 = this;

            // Since this is throttled, there might be a chance that *this* view is closed once this function
            // is invoked, make sure to bail out if that's the case...
            if (this.isClosed) {
                return;
            }

            // Stop auto play until the scene transition completes
            this._stopAutoPlay();

            var descriptor = this._updateToCurrentSceneNumber(model.previous("currentScene"));

            // Start the transition (and wait for it to complete)
            this._transitionController.transitionTo(descriptor.currentRegion.currentView).done(function (currentViewer, previousViewer) {
                // Activate current scene, but based on the view model "active" state to ensure this Viewer has not
                // been deactivated since transition start...
                currentViewer.show().setActive(model.get("active"));
                // Previous viewer is no longer considered "active"
                if (previousViewer) {
                    previousViewer.setActive(false);
                }

                var disposableRegion = descriptor.disposableRegion;

                if (disposableRegion) {
                    // Dispose the disposable region
                    disposableRegion.close();
                    disposableRegion.$el.remove();
                }

                // Re-start the auto play routine (if we are active)...
                _this2._startAutoPlay();
            });
        },


        /**
         * @private
         *
         * Returns an array of scene numbers representing the current range of
         * scenes that needs to be rendered.
         *
         * @return {Array} an array of scene numbers representing the current range of
         * scenes that needs to be rendered. E.g. if the current scene number is 1, [8, 1, 2]
         * is returned (for an experience with 8 scenes) and <tt>NUM_REGIONS</tt> set to 3.
         */
        _getCurrentRange: function _getCurrentRange() {
            var currentSceneNumber = this.model.get("currentScene");
            var numberOfScenes = this.experience.getNumberOfScenes();
            var numRegions = this._sceneRegions.length;

            // If less than 3 regions, simply return [1] or [1, 2]
            if (numRegions < 3) {
                return _.range(1, numRegions + 1);
            }

            // Determine the range of scene numbers, e.g. [8, 1, 2] (for an experience with 8 scenes)
            var range = [];
            var numAdjacent = (numRegions - 1) / 2;
            var startSceneNumber = currentSceneNumber - numAdjacent;
            var i = 0;

            while (i++ < numRegions) {
                var sceneNumber = startSceneNumber;

                if (sceneNumber < 1) {
                    sceneNumber = numberOfScenes + startSceneNumber;
                } else if (sceneNumber > numberOfScenes) {
                    sceneNumber -= numberOfScenes;
                }

                range.push(sceneNumber);

                startSceneNumber++;
            }

            return range;
        },


        /**
         * @private
         *
         * Returns the region associated with the specified scene number, og <tt>undefined</tt>
         * if no region could be found.
         *
         * @param  {Number} sceneNumber The scene number.
         * @return {Marionette.Region}  the region associated with the specified scene number, og <tt>undefined</tt>
         * if no region could be found.
         */
        _getRegionFromSceneNumber: function _getRegionFromSceneNumber(sceneNumber) {
            return _.find(this._sceneRegions, function (sceneRegion) {
                return sceneRegion.hasOwnProperty("sceneNumber") && sceneRegion.sceneNumber === sceneNumber;
            });
        },


        /**
         * @private
         *
         * Manages the regions used for holding the <tt>SceneViewer</tt>'s.
         *
         * @param   {Number|Array} previousSceneNumber      The scene number of the previous scene or an <tt>Array</tt>
         *                                                  or scene numbers.
         * @param   {Array} range                           Optional range of scene numbers.
         * @param   {Map.<Number, Object>} sceneOptionsMap  Optional map of options for specific scenes.
         * @return  {Object}                                Convenience object containing a reference to the
         *                                                  current, previous and a disposable region (if any).
         *
         * @see #_currentSceneChangeHandler
         */
        _updateToCurrentSceneNumber: function _updateToCurrentSceneNumber(previousSceneNumber, range, sceneOptionsMap) {
            var _this3 = this;

            if (_.isArray(previousSceneNumber)) {
                range = previousSceneNumber;
                previousSceneNumber = undefined;
            }

            var sceneNumbers = range || this._getCurrentRange();
            var currentSceneNumber = this.model.get("currentScene");
            var previousRegion = this._getRegionFromSceneNumber(previousSceneNumber);

            var disposableRegion = null;

            // Determine regions that needs to be reset
            var resetRegions = _.filter(this._sceneRegions, function (sceneRegion) {
                var regionSceneNumber = sceneRegion.sceneNumber; /* We set a sceneNumber on the regions */
                return sceneNumbers.indexOf(regionSceneNumber) === -1;
            });

            var disposePrevious = resetRegions.indexOf(previousRegion) !== -1;

            // If we are to dispose the previous scene, e.g. the user navigated from scene 1 to scene 10
            if (disposePrevious) {
                // We still want the previous scene to transition out, so make sure the assocciated region for the scene is not re-used
                disposableRegion = previousRegion;
                // Remove if from the list of scene regions
                this._sceneRegions.splice(this._sceneRegions.indexOf(disposableRegion), 1);
                // Remove it from the list of regions that can be re-used
                resetRegions.splice(resetRegions.indexOf(disposableRegion), 1);
                // Add a new empty region to both lists
                var emptyRegion = this._addNewRegion();
                resetRegions.push(emptyRegion);
                this._sceneRegions.push(emptyRegion);
            }

            _.each(sceneNumbers, function (sceneNumber) {
                var region = _this3._getRegionFromSceneNumber(sceneNumber);
                var isCurrentScene = sceneNumber === currentSceneNumber;

                // Create new scenes if needed
                if (!region) {
                    region = resetRegions.pop();

                    var sceneOptions = sceneOptionsMap && sceneOptionsMap.has(sceneNumber) && sceneOptionsMap.get(sceneNumber);
                    var sceneViewer = _this3._createSceneViewer(sceneNumber, sceneOptions);

                    // Scenes are born "hidden" - the SceneTransitionController will manage visibility from here.
                    sceneViewer.hide();

                    region.sceneNumber = sceneNumber;
                    region.show(sceneViewer);
                }

                // Update region class name, e.g. "scene region 4 current"
                region.$el.removeClass().addClass(CLASS_PREFIX + " " + sceneNumber + (isCurrentScene ? " current" : ""));
            });

            return {
                currentRegion: this._getRegionFromSceneNumber(currentSceneNumber),
                previousRegion: previousRegion,
                disposableRegion: disposableRegion
            };
        },
        _canStartPlay: function _canStartPlay() {
            return this.model.get("autoPlay") && // set to false on first direct user action
            this.model.get("active") && // can be toggled
            !this.model.get("stalled") && // can be toggled
            !this.model.get("paused") && // can be toggled
            this.model.get("visible") && // can be toggled
            this.experience.getNumberOfScenes() > 1;
        },
        _startAutoPlay: function _startAutoPlay() {
            var autoPlayDelay = this.experience.get("autoPlayDelay");

            if (autoPlayDelay && this._autoPlayIntervalId === null && this._canStartPlay()) {
                this._autoPlayIntervalId = setInterval(this._autoPlayTickHandler.bind(this), autoPlayDelay);
            }
        },
        _stopAutoPlay: function _stopAutoPlay() {
            if (this._autoPlayIntervalId !== null) {
                clearInterval(this._autoPlayIntervalId);
                this._autoPlayIntervalId = null;
            }
        },


        /**
         * @return {SceneViewer[]} A new array of the overlay, background, and current scene, in order; never falsey.
         */
        _getCurrentLayers: function _getCurrentLayers() {
            return [this.overlayRegion.currentView, this.backgroundRegion.currentView, this._getCurrentSceneViewer()];
        },


        /**
         * Invoked when the viewport visibility has changed.
         *
         * @param  {ExperienceViewModel} model The <tt>ExperienceViewModel.js</tt>.
         * @param  {Rectangle} viewport The visible viewport <tt>Rectangle</tt>.
         */
        _visibilityChangeHandler: function _visibilityChangeHandler() /* model, viewport */{
            var _this4 = this;

            this.shown().then(function () {
                _this4._getCurrentLayers().forEach(function (layer) {
                    layer.updateToVisibilityState();
                });
                _this4._updateForVisibilityState();
            });
        },


        /**
         * Updates according to the <tt>viewportVisibility</tt> state, starting and stopping
         * auto play depending on whether the viewport is considered empty or not (part of the experience is visible).
         */
        _updateForVisibilityState: function _updateForVisibilityState() {
            var viewport = this.model.get("viewportVisibility");

            if (viewport.isEmpty()) {
                this._stopAutoPlay();
            } else {
                this._startAutoPlay();
            }
        },
        _autoPlayTickHandler: function _autoPlayTickHandler() {
            // If there is only a single scene, the auto play just needs to replay the animations
            if (this.numOfScenes === 1) {
                this._getCurrentSceneViewer().startAnimations();
            } else {
                this.model.goToNextScene();
            }
        },
        _getCurrentSceneViewer: function _getCurrentSceneViewer() {
            var scene = this.model.get("currentScene");
            var region = void 0;

            if (scene) {
                region = this._getRegionFromSceneNumber(scene);
                if (region) {
                    return region.currentView;
                }
            }
            // undefined
        },
        _addNewRegion: function _addNewRegion(sceneNumber) {
            sceneNumber = sceneNumber || NaN;

            var backgroundRegionElement = this.$(".background-region");
            var element = $("<div />").addClass(CLASS_PREFIX).insertAfter(backgroundRegionElement);

            var region = new Region({ el: element });

            region.sceneNumber = sceneNumber;

            return region;
        },


        /**
         * @private
         *
         * Invoked when the experience model's scale changes.
         */
        _scaleChangeHandler: function _scaleChangeHandler() {
            this._updateSize();
        },


        /**
         * @private
         *
         * Sets the size of the experience element, equal to the scaled size of the current experience.
         */
        _updateSize: function _updateSize() {
            this.$el.css({
                width: this.experience.get("scaledWidth"),
                height: this.experience.get("scaledHeight")
            });
        },


        /**
         * Sets up the needed regions and sets the initial size of the viewer.
         */
        onRender: function onRender() {
            var i = 0;
            var numRegions = Math.min(this.experience.getNumberOfScenes(), NUM_REGIONS);

            // Create regions
            this._sceneRegions = [];

            while (i++ < numRegions) {
                this._sceneRegions.push(this._addNewRegion());
            }

            // Set the experience dimensions
            this.$el.css({
                width: this.experience.get("scaledWidth"),
                height: this.experience.get("scaledHeight")
            });
        },


        /**
         * Will show the experience, as soon as the responsive viewer controller is ready (we have a valid
         * view port size), failing otherwise.
         */
        onShow: function onShow() {
            var _this5 = this;

            this._responsiveViewerController.start().done(function (valid) {
                if (valid) {
                    _this5._doShow();
                }
            });
        },


        /**
         * @private
         * Creates the overlay and background scenes. Performs initial rendering of the current
         * scene and starts auto play if active.
         */
        _doShow: function _doShow() {
            var _this6 = this;

            var overlaySceneViewer = this._newSceneViewer({
                model: this.experience.get("overlayScene"),
                viewModel: this.model,
                extractCollection: false,
                enableAnimations: true
            });

            var backgroundSceneViewer = this._newSceneViewer({
                model: this.experience.get("backgroundScene"),
                viewModel: this.model,
                extractCollection: false,
                enableAnimations: true
            });

            var currentSceneOptions = new Map();
            currentSceneOptions.set(this.model.get("currentScene"), { extractCollection: false });

            var currentSceneViewer = this._updateToCurrentSceneNumber(null, null, currentSceneOptions).currentRegion.currentView;

            // Overlay and background should also stay transparent while rendering.
            overlaySceneViewer.$el.addClass("transparent");
            backgroundSceneViewer.$el.addClass("transparent");

            this.overlayRegion.show(overlaySceneViewer);
            this.backgroundRegion.show(backgroundSceneViewer);

            // Initial layout should only contain the current scene - once loaded, we'll add the adjacent scenes...
            InitialScenesController.process(this.model, overlaySceneViewer, backgroundSceneViewer, currentSceneViewer).then(function () {
                // For browsers that does not have proper support for CSS pointer events, we'll need
                // to inject all the widgets contained in the overlay viewer into 'this' element, the overlay
                // is static, so we can probably get away with this hack...
                if (!Browser.capabilities.isPointerEventsSupported) {
                    _this6.$el.prepend(overlaySceneViewer.$el.children()); // TODO: test embedding experiences in IE?!
                    // Finally we hide the overlay region so it doesn't block pointer events
                    _this6.overlayRegion.$el.hide();
                }
            });

            var descriptor = this._updateToCurrentSceneNumber();
            currentSceneViewer = descriptor.currentRegion.currentView; // scene number may have changed...

            // Register the initial scenes
            this._transitionController.registerInitialSceneViewers(currentSceneViewer, overlaySceneViewer, backgroundSceneViewer);

            // The view model "active" attribute is by default true. But, the view model may be primed with
            // "false" in case the Experience is shown on the next scene as an embedded Experience, not visible
            // yet. If we do not set it to inactive, we have conflicts between scene overlays. All widgets
            // will internally initially have their own active state set to false, and thus only the visible
            // Scene set to active here, or in the transition controller on navigation (but adhering to
            // the view model "active" property). Note the value can actually have changed since "_onShow"
            // was originally called...
            var active = this.model.get("active");

            // Show/(de-)activate all initial scenes...
            overlaySceneViewer.setActive(active);
            backgroundSceneViewer.setActive(active);
            currentSceneViewer.setActive(active);

            // Remove transparency (applied above) when fully rendered.
            overlaySceneViewer.$el.removeClass("transparent");
            backgroundSceneViewer.$el.removeClass("transparent");

            this._updateForVisibilityState();

            // Signal that the viewer is now fully rendered/shown
            this._shownDeferred.resolve(active);
        },


        /**
         * Creates the concrete <tt>SceneViewer</tt> instance.
         *
         * This may be overridden by subclasses.
         *
         * @param  {Object} options The default options passed to the <tt>SceneViewer</tt> constructor, see <tt>#_createSceneViewer</tt>.
         * @return {SceneViewer}    The concrete <tt>SceneViewer</tt> instance.
         */
        _newSceneViewer: function _newSceneViewer(options) {
            return new SceneViewer(options);
        },
        _createSceneViewer: function _createSceneViewer(sceneNumber, options) {
            var sceneOptions = _.extend({
                model: this.experience.get("scenes").at(sceneNumber - 1),
                viewModel: this.model,
                enableAnimations: true,
                disableScale: true,
                sceneNumber: sceneNumber
            }, options || {});

            return this._newSceneViewer(sceneOptions);
        },


        /**
         * @private
         * Ensures that all pending actions, such as a dangling opened Lightbox action, will be closed.
         */
        _closePendingActions: function _closePendingActions() {
            var pendingActions = this.model.get("pendingActions");
            var i = pendingActions.length;

            while (i--) {
                pendingActions[i].close();
            }
        },
        onClose: function onClose() {
            // Close pending actions, such as opened Lightboxes...
            this._closePendingActions();

            // Clear auto play timer if set...
            this._stopAutoPlay();

            // Close responsive viewer controller...
            this._responsiveViewerController.close();

            // Make sure we close down all (dynamically created) regions
            _.invoke(this._sceneRegions, "close");

            // Remove any 'visibility' listeners for browser tab changes...
            $(window.document).off(".visibility");

            log.verbose("Closed Viewer");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var template = __webpack_require__(2875);

    /**
     * Experience preview page.
     *
     * <p>Shows an experience CNC viewer.</p>
     *
     * @class ExperienceCncViewer
     * @constructor
     */
    return Marionette.Layout.extend({
        template: template,

        templateHelpers: function templateHelpers() {
            var _options = this.options,
                fitInHeight = _options.fitInHeight,
                groupsDisable = _options.groupsDisable,
                model = _options.model;

            var experienceId = model.has("experienceId") ? model.get("experienceId") : model.get("experience").id;
            var fixedSize = model.get("fixedSize");
            var templateId = model.get("templateId");
            var viewerStyle = void 0;
            if (fixedSize) {
                viewerStyle = "width: " + fixedSize.width + "px; height: " + fixedSize.height + "px;";
            }

            return {
                fitInHeight: fitInHeight,
                groupsDisable: groupsDisable,
                viewerStyle: viewerStyle,
                experienceId: experienceId,
                templateId: templateId
            };
        },


        initialize: function initialize() {
            if (this.options.startEvent) {
                this.listenTo(this.model.get("experience"), this.options.startEvent, this.startCnc);
            }
        },

        onShow: function onShow() {
            if (!this.options.startEvent) {
                this.startCnc();
            }
        },

        _triggerEvent: function _triggerEvent(eventName) {
            var event = void 0; // The CNC start custom event that will be created

            if (document.createEvent) {
                // Normal browsers
                event = document.createEvent("HTMLEvents");
                event.initEvent(eventName, true, true);
                event.eventName = eventName;
                document.dispatchEvent(event);
            } else {
                // Old IE support
                event = document.createEventObject();
                event.eventName = eventName;
                event.eventType = eventName;
                document.fireEvent("on" + event.eventType, event);
            }
        },

        startCnc: function startCnc() {
            this._triggerEvent("ZmagsInitialize");
        },

        onClose: function onClose() {
            this._triggerEvent("ZmagsCleanup");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var EventNames = {
        QUICK_VIEW_SHOWN: "QuickViewShown"
    };

    return {
        EventNames: EventNames
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Browser = __webpack_require__(39),
        EditorEvents = __webpack_require__(17),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(2877),
        UrlUtil = __webpack_require__(46),
        Window = __webpack_require__(48);

    /**
     * Template for a "URL Box" with input element and open button.
     *
     * @author Jacob Midtgaard-Olesen (jmo@zmags.com)
     * @class URLBox
     * @constructor
     *
     * @cfg {String}    [urlProvider] The input element will be read only and contain the given URL
     */
    return ImprovedView.extend({

        classname: "urlBox",

        template: template,

        templateHelpers: function templateHelpers() {
            var key = Browser.os.macOS ? "\u2318" : "Ctrl";

            return {
                url: this.options.urlProvider() || "",
                helpText: this.options.helpText,
                button: key
            };
        },

        ui: {
            urlInput: "#url-input"
        },

        events: {
            "click .open-button": function clickOpenButton() {
                var eventProperties = {
                    experienceUrl: this.options.urlProvider(),
                    triggerOrigin: this.options.triggerOrigin,
                    quickView: true,
                    projectId: this.options.project && this.options.project.get("id")
                };

                EditorEvents.trigger(EditorEvents.constants.OPEN_DIRECT_URL, eventProperties);

                this._openUrl();
            },
            "keypress #url-input": function keypressUrlInput(event) {
                if (event.keyCode === 13) {
                    this._openUrl();
                }
            }
        },

        onRender: function onRender() {
            var url = this.options.urlProvider();

            if (url) {
                this.ui.urlInput.popover();
            }
        },

        _openUrl: function _openUrl() {
            var url = this.ui.urlInput.val();

            Window.open(UrlUtil.prependHTTP(url));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        _ = __webpack_require__(1),
        Promise = __webpack_require__(21),
        DashboardConfiguration = __webpack_require__(1190),
        DashboardView = __webpack_require__(1216);

    /**
     * Controller for the dashboard.
     *
     * For projects, see ProjectDashboardController.
     *
     * @class LazyDashboardController
     */
    return Marionette.Controller.extend({

        config: DashboardConfiguration,

        dashboardView: DashboardView,

        /**
         * Hook for providing additional options to the dashboard view instance.<p>
         *
         * Note that this method is only invoked once. The default implementation resolves
         * with the same specified options.
         *
         * @param  {*} options The initial options passed to #show
         * @return {Promise}   A <tt>Promise</tt> that resolves with the options to be passed
         * to the dashboard view instance.
         */
        dashboardViewOptions: function dashboardViewOptions(options) {
            return Promise.resolved(options);
        },

        /**
         * @type {DashboardView}
         */
        _view: null,

        /**
         * Shows the dashboard at the tab specified or the "Experiences" tab if none is provided.
         *
         * @param  {*} options The options:
         *                     @cfg tab Optional, the tab to show, as a Tabs.XXX constant.
         */
        show: function show(options) {
            var _this = this;

            var tab = options.tab || this.config.EXPERIENCES,
                region = this.options.region;

            if (options.reset) {
                this._disposeDashboardView();
            }

            // First run...
            if (!this._view) {
                var viewOptions = _.defaults({ tabs: this.config }, options);
                // Fetch any additional (initial) dashboard view options.
                this.dashboardViewOptions(viewOptions).then(function (viewOptions) {
                    _this.onBeforeDashboardShow(viewOptions);
                    _this._view = new _this.dashboardView(viewOptions);
                    region.show(_this._view);
                    _this._view.showTab(tab);
                });
            } else {
                // Pass on potential partial view options... (e.g. quick view parameters)
                this._view.options.partialViewOptions = options.partialViewOptions;
                this._view.showTab(tab);
            }
        },

        /**
         * Invoked after the <tt>dashboardViewOptions</tt> successfully
         * resolves, before the dashboard view is constructed and shown.
         *
         * @param  {*} options The options to be passed to the dashboard view.
         */
        // eslint-disable-next-line no-unused-vars
        onBeforeDashboardShow: function onBeforeDashboardShow(options) {},

        _disposeDashboardView: function _disposeDashboardView() {
            if (this._view) {
                this._view.stopListening();
                this._view = null;
            }
        },

        onClose: function onClose() {
            this._disposeDashboardView();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        DashboardNavigationView = __webpack_require__(2899),
        EditorEvents = __webpack_require__(17),
        ImprovedView = __webpack_require__(6),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        Marionette = __webpack_require__(10),
        Promise = __webpack_require__(21),
        Preconditions = __webpack_require__(14),
        SlimSpinnerView = __webpack_require__(862),
        template = __webpack_require__(2901);


    var logger = new Logger("DashboardView"),
        Region = Marionette.Region;

    /**
     *
     * @class DashboardView
     *
     */
    return ImprovedView.extend("DashboardView", {

        className: "lazy dashboard-view pt-page",

        template: template,

        templateHelpers: {
            headerContentUnescaped: "<h1 class='title'>Dashboard</h1>"
        },

        regions: {
            dashboardNavigationRegion: ".dashboard-navigation-region",
            progressIndicatorRegion: ".progress-indicator-region",
            defaultFooterRegion: ".default-footer"
        },

        ui: {
            dashboardSection: "section.dashboard"
        },

        transitions: {
            in: "pt-page-scaleUp",
            out: "pt-page-scaleDown"
        },

        _dashboardNavigationView: null,

        /**
         * @type {Map.<Tab, Region>}
         */
        _regionsMap: null,

        /**
         * @type {Marionette.Region}
         */
        _activeRegion: null,

        /**
         * Reference to the current tab.
         *
         * @type {DashboardTabConfiguration}
         */
        _tab: null,

        initialize: function initialize() {
            this._regionsMap = new Map();
        },

        serializeData: function serializeData() {
            return {};
        },

        viewScope: function viewScope() {
            return {
                /**
                 * Exposes the element that are to be considered the scrolling element for the "lazy"
                 * collection view(s). In this case we're scrolling the entire dashboard page, and not
                 * only the collection view.
                 *
                 * @type {$}
                 */
                scrollTarget: this.$el
            };
        },

        onShow: function onShow() {
            this._createRegions();

            this._dashboardNavigationView = new DashboardNavigationView({ tabs: this.options.tabs });
            this.dashboardNavigationRegion.show(this._dashboardNavigationView);

            this._invalidateCounting();
        },

        showTab: function showTab(tab) {
            var self = this;

            // Defer to ensure we're 'shown'...
            _.defer(function () {
                self._tab = tab;
                self._dashboardNavigationView.setActiveTab(tab);

                self._activeRegion = self._regionsMap.get(tab);

                // Hide all but current...
                self._regionsMap.forEach(function (mappedRegion) {
                    if (mappedRegion !== self._activeRegion) {
                        mappedRegion.el.hide();

                        self._viewActive(mappedRegion, false);
                    }
                });

                // Show the rendered view (if any), unless we need to reload/fetch the view options...
                if (self._activeRegion.currentView && !tab.get("reloadOptions")) {
                    // Partial views can change regardless of the current view.
                    // Make sure partial views get updated if the view exist (i.e. no reload happening)
                    // if the view has an `updatePartialView` method (e.g. DetailedImageLibraryCollectionView#updatePartialViews)
                    if (self._activeRegion.currentView.updatePartialViews) {
                        self._activeRegion.currentView.updatePartialViews(self.options.partialViewOptions);
                    }

                    self._activeRegion.el.show();
                    self._viewActive(self._activeRegion, true);
                } else {
                    var promise = tab.fetchOptions(self.options);

                    self._showSpinner(promise);
                    self._dashboardNavigationView.disableUntil(promise);

                    promise.then(function (options) {
                        // Sanity check - in theory one could switch tabs
                        // during fetching of tab data, so bail out if tabs have changed at this point.
                        if (tab !== self._tab) {
                            return;
                        }

                        var View = tab.get("view"),

                        // By default, all subviews inherit the options from the main dashboard view.
                        viewOptions = _.extend(options, self.options),
                            view = new View(viewOptions);

                        self._activeRegion.el.show();
                        self._activeRegion.show(view);

                        logger.info("Dashboard '" + tab.get("name") + "' tab loaded and rendered.");

                        Preconditions.checkState(_.isFunction(view.getCountableEventSource), "Dashboard sub view must expose a getCountableEventSource method.");

                        // Listen for relevant changes in the sub view's collection(s) in order to update the counting labels.
                        var countableEventSourceEventSource = view.getCountableEventSource(),
                            sources = _.isArray(countableEventSourceEventSource) ? countableEventSourceEventSource : [countableEventSourceEventSource];

                        sources.forEach(function (eventSource) {
                            self.stopListening(eventSource);
                            self.listenTo(eventSource, "add remove destroy change sync:state", _.debounce(self._invalidateCounting.bind(self), 300));
                        });
                    });
                }
            });

            var eventProperties = {
                dashboardType: tab.get("name"),
                triggerOrigin: "DashboardTab",
                projectId: self._project && self._project.get("id")
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_DASHBOARD, eventProperties);
        },

        /**
         * @private
         *
         * Invokes the 'active' method (if any) on the current view of the specified region.
         *
         * @param  {Region} region  The region holding the view.
         * @param  {Boolean} active The active state.
         */
        _viewActive: function _viewActive(region, active) {
            if (region.currentView && _.isFunction(region.currentView.active)) {
                region.currentView.active(active);
            }
        },

        /**
         * Updates the counting label of the various tabs.
         *
         * @return {Promise} A promise that resolves when the counting has been fetched.
         */
        _invalidateCounting: function _invalidateCounting() {
            var promises = this.options.tabs.map(function (tab) {
                return tab.invalidateLength();
            });

            return Promise.all(promises);
        },

        _showSpinner: function _showSpinner(promise) {
            var _this = this;

            this.progressIndicatorRegion.show(new SlimSpinnerView());
            this.progressIndicatorRegion.$el.show();

            promise.done(function () {
                if (_this.progressIndicatorRegion.$el) {
                    _this.progressIndicatorRegion.$el.hide();
                }
                _this.progressIndicatorRegion.close();
            });
        },

        _createRegions: function _createRegions() {
            var _this2 = this;

            this.options.tabs.each(function (tab) {
                // Create the region element...
                var $element = $("<section />").hide() // Initially hidden...
                .addClass(tab.get("slug") + "-region")
                // This will enable fading when navigating between tabs...
                .addClass("fade-in").insertAfter(_this2.ui.dashboardSection),

                // Initialize the actual region...
                region = new Region({ el: $element });

                // We need to set this explicitly when creating regions "by hand" (to support viewScope)...
                region.parentView = _this2;

                _this2._regionsMap.set(tab, region);
            });
        },

        /**
         * Invoked when the router navigates from *this* view - checks whether the current view has any
         * unsaved changes. (Currently only the publish view uses this feature).
         *
         * @return {Boolean} <tt>true</tt> if unsaved changes, <tt>false</tt> otherwise.
         */
        beforeNavigate: function beforeNavigate() {
            var view = this._activeRegion.currentView;

            // The view might have been disposed by then, check that it's not null before.
            if (view && _.isFunction(view.hasUnsavedChanges)) {
                return view.hasUnsavedChanges();
            }

            return false;
        },

        onClose: function onClose() {
            this._regionsMap.forEach(function (region) {
                region.close();
            });

            this._regionsMap.clear();
            this._regionsMap = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorWebFontController = __webpack_require__(176);
    var ExperienceModel = __webpack_require__(58);
    var FontLoader = __webpack_require__(260);
    var Promise = __webpack_require__(21);
    var TemplateModel = __webpack_require__(468);

    /**
     * Controller for the editor.
     *
     * @class EditorControllerMixin
     * @constructor
     *
     * @cfg {Region} region The main view region, where the editor view should be rendered.
     */
    return {
        /**
         * Fetches the entire experience including all scenes, widgets and fonts.
         *
         * @param  {String} id The raw experience ID.
         * @return {Promise}   A promise that resolves with the fetched <tt>ExperienceModel</tt>.
         */
        _fetchExperienceAndFonts: function _fetchExperienceAndFonts(id) {
            return this._fetchForModel(id, ExperienceModel, function (model) {
                return model;
            });
        },


        /**
         * Fetches the entire template including all meta data and associated experience scenes, widgets and fonts.
         *
         * @param  {String} id The template ID.
         * @return {Promise}   A promise that resolves with the fetched <tt>ExperienceModel</tt>.
         */
        _fetchTemplateExperienceAndFonts: function _fetchTemplateExperienceAndFonts(id) {
            return this._fetchForModel(id, TemplateModel, function (model) {
                return model.get("content");
            });
        },


        /**
         * Returns the Experience Model and associated experience fonts.
         *
         * @param id The template or experience ID to retrieve
         * @param model The model with findById
         * @param experienceModelResolver A function that resolve the results of findById to an ExperienceModel
         * @returns {Promise<any>}
         * @private
         */
        _fetchForModel: function _fetchForModel(id, model, experienceModelResolver) {
            var _this = this;

            var experience = void 0;

            return model.findById(id).then(function (model) {
                experience = experienceModelResolver(model);
                // Make sure all font data is loaded (this may only have an impact initially)
                // Note: We start fetching font data as soon as the user
                // signs in (see EditorWebFontController)
                return EditorWebFontController.promise();
            }).then(function () {
                return Promise.deferred(function (deferred) {
                    FontLoader.loadExperienceFonts(experience).fail(function (reason) {
                        var errorMessage = "Failed loading experience fonts for experience with id: " + experience.get("id") + ". Reason: " + reason;

                        _this.options.errorLogger.log(errorMessage);
                    })
                    // We always resolve the experience so it loads,
                    // even if custom fonts fail to load.
                    .always(function () {
                        deferred.resolve(experience);
                    });
                });
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AddVariantAction = __webpack_require__(1219);
    var BreakpointGroup = __webpack_require__(97);
    var EditorEvents = __webpack_require__(17);
    var LoggedInUserState = __webpack_require__(19);
    var Promise = __webpack_require__(21);
    var SyncManager = __webpack_require__(44);
    var SharedEntityType = __webpack_require__(285);
    var SharedEntityHelper = __webpack_require__(713);
    var Configuration = __webpack_require__(27);

    /**
     * An action that either creates a new breakpoint group or adds an new variant to the existing group.
     *
     * @class AddBreakpointAction
     *
     */
    return AddVariantAction.extend({
        _performExecution: function _performExecution() {
            var _this = this;

            var experience = this._experience;
            var isEmailModeEnabled = experience.attributes.emailModeEnabled;
            if (isEmailModeEnabled) return;
            var isC3Exp = (0, _C3Utils.isC3Experience)();

            var promise = Promise.resolved();
            var groupAlreadyExists = this._group;
            // PE-1504: Fix behavior duplication in Create Variant action
            var clone = experience.clone({ duplicate: true, duplicateExperienceWithUUID: true });

            clone.set("name", experience.get("name") + " (new)", { silent: true });
            // Create new group if not already a group
            if (!groupAlreadyExists && !isC3Exp) {
                var lowerBounds = LoggedInUserState.get("companySettings").get("breakpoints").getLowerBounds();
                var promises = [];

                this._group = new BreakpointGroup({ name: experience.get("name") + " group" });

                // Ensure we only get one save by blocking the queue until all assets added
                var unblock = SyncManager.block(this._group);

                // Copy all breakpoints to the new group and set the first variant as the default asset
                lowerBounds.forEach(function (breakpoint) {
                    promises.push(_this._group.attach(experience, breakpoint.clone()));
                });

                unblock();

                // When group is saved, save the clone and attach it
                promise = Promise.all(promises);
            }

            return promise.then(function () {
                return clone.save();
            }).then(function () {
                // If the group was just created AND we're inside the project
                // context, attach the group to the project and detach the experience.
                if (!groupAlreadyExists && !isC3Exp) {
                    _this._trackVariant(EditorEvents.constants.CREATE_GROUP, {
                        experience: clone,
                        triggerOrigin: "CreateBreakpointGroupDropdown"
                    });
                    if (_this._project) {
                        return _this._project
                        // Fetch to ensure project model is in sync (avoiding potential version conflicts).
                        .fetch().then(function () {
                            return Promise.all([_this._project.detach(experience), _this._project.attach(_this._group)]);
                        });
                    }
                }
            }).then(function () {
                if (isC3Exp) {
                    var newExperienceId = clone.get("id");
                    var currentLanguage = _this._experience.get("language");
                    var experiences = _this._collections.experiences;

                    var currentLanguageExperience = experiences.filter(function (exp) {
                        return exp.language === currentLanguage;
                    });

                    // This will execute for first time when user create device variant
                    if (currentLanguageExperience.length === 1) {
                        var _collections$experien;

                        var mappedLangEperienceId = _this._collections.experiences.reduce(function (acc, exp) {
                            acc[exp.language] = exp.experienceId;
                            return acc;
                        }, {});
                        // we can also use "0" as existing threshold as it's default threshold for experiences when created from C3-Dashboard
                        var existingThreshold = _this._collections.experiences[0].threshold;
                        var allExpLanguages = experiences.map(function (exp) {
                            return exp.language;
                        });
                        var uniqueLanguages = [].concat(_toConsumableArray(new Set(allExpLanguages)));
                        0;
                        var thresholdToAssign = LoggedInUserState.get("companySettings").get("breakpoints").getLowerBounds().map(function (breakpoint) {
                            var threshold = breakpoint.get("threshold");
                            if (existingThreshold !== threshold) {
                                return threshold;
                            }
                        }).filter(function (threshold) {
                            return threshold;
                        });

                        var newExpCollectionToAdd = [];
                        uniqueLanguages.forEach(function (language) {
                            var experienceId = mappedLangEperienceId[language];
                            thresholdToAssign.forEach(function (threshold) {
                                newExpCollectionToAdd.push({
                                    experienceId: experienceId,
                                    threshold: threshold,
                                    language: language
                                });
                            });
                        });
                        (_collections$experien = _this._collections.experiences).push.apply(_collections$experien, newExpCollectionToAdd);
                    }
                    var experienceDetails = {
                        "experienceId": newExperienceId,
                        "threshold": null,
                        "language": clone.get("language")
                    };
                    _this._collections.experiences.push(experienceDetails);

                    var expCollectionId = _this._collections.id,
                        endpointUrl = Configuration.c3ApibaseUrl + "/v1/experienceCollections/" + expCollectionId,
                        token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"),
                        bearerToken = "Bearer " + token;

                    var options = {
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": bearerToken
                        },
                        body: JSON.stringify(_this._collections),
                        method: "PUT"
                    };

                    fetch(endpointUrl, options);
                } else _this._group.attach(clone).then(function () {
                    // We can add variants only to existing groups.
                    if (groupAlreadyExists) {
                        _this._trackVariant(EditorEvents.constants.CREATE_VARIANT, {
                            experience: clone,
                            triggerOrigin: "AddBreakpointVariantPlusIcon"
                        });
                    }
                });
            }).then(function () {
                if (isC3Exp) return;
                SharedEntityHelper.movePermissions({
                    sourceID: _this._experience.get("id"),
                    sourceType: SharedEntityType.EXPERIENCE,
                    companyId: _this._experience.get("companyId"),
                    destID: _this._group.get("id"),
                    destType: SharedEntityType.GROUP
                });
            }).then(function () {
                return (
                    // Refresh the cloned experience to stay in sync with the server.
                    clone.fetch()
                );
            });
        },


        /**
         * Sends Mix Panel event for the variant.
         *
         * @param {String} eventName The name of the event.
         * @param {Object} payload Object containing mandatory properties for the tracking method.
         * @param {ExperienceModel} payload.experience The `ExperienceModel` instance.
         * @param {String} payload.triggerOrigin The `triggerOrigin` used for tracking.
         */
        _trackVariant: function _trackVariant(eventName, _ref) {
            var experience = _ref.experience,
                triggerOrigin = _ref.triggerOrigin;

            var eventProperties = {
                projectId: this._project && this._project.get("id"),
                groupId: this._group.get("id"),
                groupType: this._group.get("type"),
                groupVersion: this._group.get("version"),
                groupPushedVersion: this._group.get("pushedVersion"),
                triggerOrigin: triggerOrigin,
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion")
            };

            EditorEvents.trigger(eventName, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(156);

    return Action.extend({

        _group: null,

        _experience: null,

        _project: null,

        /**
         * Constructor.
         *
         * @param  {GroupModel} group           The <tt>GroupModel</tt>, if any.
         * @param  {ExperienceModel} experience The current <tt>ExperienceModel</tt>.
         * @param  {ProjectModel} project       The <tt>ProjectModel</tt> if in a project context.
         * Below parameter are used for Editor 2.0
         * @param experienceCollection,         Details of Experience Collections.
         */
        constructor: function constructor(group, experience, project, experienceCollection) {
            this.__super();

            this._group = group;
            this._experience = experience;
            this._project = project;
            this._collections = experienceCollection;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AddVariantAction = __webpack_require__(1219);
    var EditorEvents = __webpack_require__(17);
    var LocalizationGroup = __webpack_require__(232);
    var LocaleCollection = __webpack_require__(374);
    var SharedEntityType = __webpack_require__(285);
    var SharedEntityHelper = __webpack_require__(713);

    /**
     * An action that either creates a new localization group or adds an new variant to the existing group.
     *
     * @class AddLocaleAction
     *
     */
    return AddVariantAction.extend({

        localeString: null,

        constructor: function constructor(group, experience, project, localeString) {
            this.__super(group, experience, project);

            this.localeString = localeString;
        },
        _performExecution: function _performExecution() {
            var _this = this;

            var locale = LocaleCollection.findByLocaleString(this.localeString);
            var experience = this._experience;
            var clone = null;

            if (this._group) {
                clone = experience.clone({ duplicate: true });
                clone.set({ "name": experience.get("name") + " (new)" });

                return clone.save().then(function () {
                    _this._trackVariant(EditorEvents.constants.CREATE_VARIANT, {
                        experience: clone,
                        triggerOrigin: "AddLocaleVariantIcon"
                    });

                    _this._group.attach(clone, locale);

                    return clone;
                });
            }

            this._group = new LocalizationGroup({ name: experience.get("name") + " group" });

            return this._group.attach(experience, locale).then(function () {
                // If inside the project context - attach the group to the current project.
                if (_this._project) {
                    return _this._project
                    // Fetch to ensure project model is in sync (avoiding potential version conflicts).
                    .fetch().then(function () {
                        return _this._project.attach(_this._group);
                    });
                }
            }).then(function () {
                _this._trackVariant(EditorEvents.constants.CREATE_GROUP, {
                    experience: clone || _this._experience,
                    triggerOrigin: "CreateLocalizationGroupDropdown"
                });

                return _this._group;
            }).then(function () {
                SharedEntityHelper.movePermissions({
                    sourceID: clone.get("id"),
                    sourceType: SharedEntityType.EXPERIENCE,
                    companyId: clone.get("companyId"),
                    destID: _this._group.get("id"),
                    destType: SharedEntityType.GROUP
                });
            });
        },


        /**
         * Sends Mix Panel event for the variant.
         *
         * @param {String} eventName The name of the event.
         * @param {Object} payload Object containing mandatory properties for the tracking method.
         * @param {ExperienceModel} payload.experience The `ExperienceModel` instance.
         * @param {String} payload.triggerOrigin The `triggerOrigin` used for tracking.
         */
        _trackVariant: function _trackVariant(eventName, _ref) {
            var experience = _ref.experience,
                triggerOrigin = _ref.triggerOrigin;

            var eventProperties = {
                locale: this.localeString,
                projectId: this._project && this._project.get("id"),
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                triggerOrigin: triggerOrigin,
                groupId: this._group.id,
                groupType: this._group.get("type"),
                groupVersion: this._group.get("version"),
                groupPushedVersion: this._group.get("pushedVersion")
            };

            EditorEvents.trigger(eventName, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var _ = __webpack_require__(1);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);
    var ShareMenu = __webpack_require__(1222);
    var ShareViewModel = __webpack_require__(2916);
    var Tooltip = __webpack_require__(35);

    var ShareState = {
        HOVER_BEFORE_SHARING: 0,
        PICKING_RECIPIENT: 1,
        AFTER_SHARING: 2
    };

    var OverlayView = Backbone.View.extend({

        className: "share-overlay",

        events: {
            "activate": "_activateHandler"
        },

        render: function render() {
            if (this.options.invisibleOverlay) {
                this.$el.addClass("transparent");
            }

            return this;
        },
        _activateHandler: function _activateHandler() {
            this.model.set("state", ShareState.HOVER_BEFORE_SHARING);
        }
    }, {

        instance: null,

        show: function show(options) {
            var overlayView = new OverlayView(options);
            overlayView.render().$el.appendTo(window.document.body);

            OverlayView.instance = overlayView;
        },
        remove: function remove() {
            if (OverlayView.instance) {
                OverlayView.instance.remove();
                OverlayView.instance = null;
            }
        }
    });

    /**
     * The share button view.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareButton
     *
     * @cfg {Object} [offset] The offset settings for the tooltip. Defaults to display in the middle.
     */
    return ImprovedView.extend({
        initialize: function initialize() {
            this.model = new ShareViewModel({
                route: this.options.route,
                experience: this.options.experience
            });
        },


        template: function template() {
            return "";
        },

        className: "share-button-inner",

        events: {
            "activate": "_activateHandler"
        },

        modelEvents: {
            "change:state": "_updateTooltip"
        },

        _overlay: null,

        _activateHandler: function _activateHandler(event) {
            event.preventDefault();
            var state = this.model.get("state") === ShareState.PICKING_RECIPIENT ? ShareState.HOVER_BEFORE_SHARING : ShareState.PICKING_RECIPIENT;
            // If a share is in progress, cancel it, otherwise start a share
            this.model.set({ state: state });
        },
        _updateTooltip: function _updateTooltip() {
            var _this = this;

            var settings = {
                width: 170,
                // NOTE: Using tooltip `animation` (fade transition) with the current version (3.3.7) of
                // Bootstrap - will throw an error due to the below usage of the tooltip.
                animation: false,
                trigger: "manual",
                duration: 0,
                classes: ""
            };
            var element = this.options.tooltipContainer || this.$el;

            if (this.options.offset) {
                settings.offset = this.options.offset;
            }

            if (this.options.modal) {
                settings.classes += " modal-popover";
            }

            // Remove any existing tooltip and overlay
            Tooltip.remove(element);
            OverlayView.remove();

            // Add the appropriate tooltip
            switch (this.model.get("state")) {
                case ShareState.HOVER_BEFORE_SHARING:
                    if (!this.options.hideTooltip) {
                        settings.width = 150;
                        settings.content = "Share this experience with a colleague";
                        settings.trigger = "hover";
                        settings = _.extend(this.options.tooltipConfig || {}, settings);
                        Tooltip.add(element, settings);
                    }
                    break;

                case ShareState.PICKING_RECIPIENT:
                    this._trackOpenShareMenu();

                    settings.width = 208;
                    settings.classes += " share-menu-container";
                    settings.content = new ShareMenu({ model: this.model });
                    settings.html = true;
                    Tooltip.add(element, settings);
                    Tooltip.show(element);

                    OverlayView.show({ model: this.model, invisibleOverlay: this.options.invisibleOverlay });

                    break;

                case ShareState.AFTER_SHARING:
                    settings.content = "Thanks for sharing!";
                    Tooltip.add(element, settings);
                    Tooltip.show(element);

                    // Auto-hide the tooltip after 3 seconds, unless the state has changed in the meantime
                    _.delay(function () {
                        if (_this.model.get("state") === ShareState.AFTER_SHARING) {
                            _this.model.set("state", ShareState.HOVER_BEFORE_SHARING);
                        }
                    }, 3000);
                    break;

                default:
                    // No need to log here.
                    break;
            }
        },
        onRender: function onRender() {
            this._updateTooltip();
        },
        onClose: function onClose() {
            Tooltip.remove(this.$el);
            OverlayView.remove();
        },
        _trackOpenShareMenu: function _trackOpenShareMenu() {
            var experience = this.options.experience;

            var eventProperties = {
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                triggerOrigin: "EditorMenu"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_SHARE_MENU, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        ImprovedView = __webpack_require__(6),
        ConcatenatedCollection = __webpack_require__(714),
        EditorEvents = __webpack_require__(17),
        EmailUtil = __webpack_require__(231),
        FilteredCollection = __webpack_require__(2908),
        LoggedIn = __webpack_require__(31),
        LoggedInUserState = __webpack_require__(19),
        ShareRecipient = __webpack_require__(715),
        ShareRecipientDisplayCollectionView = __webpack_require__(2909),
        ShareRecipientCollectionView = __webpack_require__(2912),
        ShareRecipientToLabel = __webpack_require__(1223),
        template = __webpack_require__(2915),
        UserCollection = __webpack_require__(184);

    /**
     * The share menu.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareMenu
     * @constructor
     */
    return ImprovedView.extend({

        template: template,

        className: "share-menu",

        events: {
            "click .choose-recipients-ok": function clickChooseRecipientsOk() {
                this.ui.chooseRecipientsWrapper.collapse("hide");
            },
            "click .share-cancel": function clickShareCancel() {
                this.model.set("state", 0);
            },
            "click .share-send": "_send",
            "click .choose-recipients-add-button": function clickChooseRecipientsAddButton() {
                this.ui.recipientsAddButton.hide();
                this.ui.recipientsAddInputContainer.css("visibility", "visible");
                this.ui.recipientsAddInput.focus();
            },
            "click .choose-recipients-add-ok": "_addRecipient",
            "keyup .choose-recipients-add input": function keyupChooseRecipientsAddInput(event) {
                // Escape
                if (event.keyCode === 27) {
                    this.ui.recipientsAddButton.show();
                    this.ui.recipientsAddInputContainer.css("visibility", "hidden");
                    return;
                }

                // Enter
                if (event.keyCode === 13) {
                    this._addRecipient();
                }
                if (this._validateInviteEmail()) {
                    this.ui.recipientsAddOkButton.addClass("valid");
                } else {
                    this.ui.recipientsAddOkButton.removeClass("valid");
                }
            },
            "click": function click(event) {
                if (!this.ui.recipientsAdd[0].contains(event.target)) {
                    this.ui.recipientsAddButton.show();
                    this.ui.recipientsAddInputContainer.css("visibility", "hidden");
                }
            }
        },

        modelEvents: {
            "change:message": "_updateValidationStates"
        },

        bindings: {
            "textarea": "message"
        },

        ui: {
            recipientsList: ".choose-recipients-list-region",
            recipientsAdd: ".choose-recipients-add",
            recipientsAddButton: ".choose-recipients-add-button",
            recipientsAddInputContainer: ".choose-recipients-add-input-container",
            recipientsAddInput: ".choose-recipients-add-input-wrapper input",
            recipientsAddOkButton: ".choose-recipients-add-ok",
            recipientsOkButton: ".choose-recipients-ok",
            recipientsFooter: ".footer",
            chooseRecipients: ".choose-recipients-body",
            chooseRecipientsWrapper: "#choose-recipients-body-container",
            sendButton: ".share-send button"
        },

        regions: {
            recipientsDisplay: ".recipients-list",
            recipientsList: ".choose-recipients-list-region"
        },

        /**
         * Validate email address
         * @returns {*} the email if valid, null otherwise
         * @private
         */
        _validateInviteEmail: function _validateInviteEmail() {
            var email = this.ui.recipientsAddInput.val();
            return EmailUtil.validateEmail(email) ? email : null;
        },

        _send: function _send() {
            var recipientNames = this._getSelectedRecipientNames();
            if (recipientNames && this.model.get("message")) {
                var experience = this.model.get("experience");

                var eventProperties = {
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    recipients: recipientNames,
                    message: this.model.get("message"),
                    numberOfRecipients: recipientNames.length,
                    link: this.model.get("route"),
                    triggerOrigin: "SendShareExperienceButton"
                };

                EditorEvents.trigger(EditorEvents.constants.SHARE_EXPERIENCE, eventProperties);
                this.model.set("state", 2);
            }
        },

        _addRecipient: function _addRecipient() {
            var email = this._validateInviteEmail(),
                experience = this.model.get("experience");

            if (email) {
                // Add the recipient, unless it already exists
                var existingRecipient = this.model.get("recipients").find(function (recipient) {
                    return recipient.get("email") === email || recipient.get("user") && recipient.get("user").get("username") === email;
                });

                var eventProperties = {
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    recipientEmail: email,
                    isNewUser: false,
                    triggerOrigin: "ShareMenu"
                };

                if (existingRecipient) {
                    existingRecipient.set("selected", true);
                } else {
                    this.model.get("recipients").add(new ShareRecipient({ email: email, selected: true }));
                    this.ui.recipientsList.scrollTop(this.ui.recipientsList.prop("scrollHeight"));
                    eventProperties.isNewUser = true;
                }

                // Trigger event
                EditorEvents.trigger(EditorEvents.constants.ADD_SHARE_EMAIL_RECIPIENT, eventProperties);

                // Reset the button
                this.ui.recipientsAddButton.show();
                this.ui.recipientsAddInputContainer.css("visibility", "hidden");
                this.ui.recipientsAddInput.val("");
            }
        },

        _getSelectedRecipientNames: function _getSelectedRecipientNames() {
            var selectedRecipientNames = [];
            this.model.get("recipients").each(function (recipient) {
                if (recipient.get("selected")) {
                    selectedRecipientNames.push(recipient.get("displayName"));
                }
            });
            return selectedRecipientNames.length > 0 ? selectedRecipientNames : null;
        },

        _updateValidationStates: function _updateValidationStates() {
            // OK button on choose recipients
            if (this._getSelectedRecipientNames()) {
                this.ui.recipientsOkButton.addClass("enabled");
            } else {
                this.ui.recipientsOkButton.removeClass("enabled");
            }

            // Send button on main view
            if (this._getSelectedRecipientNames() && this.model.get("message")) {
                this.ui.sendButton.addClass("enabled");
            } else {
                this.ui.sendButton.removeClass("enabled");
            }
        },

        /**
         * Calling height() on a jQuery element always returns the content height, without any padding or margins, even
         * if the current box sizing model should include them. This method pulls the size from the CSS string, which
         * should always be the correct value.
         *
         * @param {jQuery} element The jQuery element.
         * @returns {Number} The height of the element.
         * @private
         */
        _heightConsideringBoxSizing: function _heightConsideringBoxSizing(element) {
            return parseInt(element.css("height").split("px")[0], 10);
        },

        /**
         * Unfortunately the layout we want here is too complicated to do in pure CSS, since we need to overlay the
         * recipients list over the entire menu, which has variable height, and the recipients list itself contains
         * two sections that will vary in height, where we want one of them to fill the remaining space.
         * @private
         */
        _updateRecipientsSizing: function _updateRecipientsSizing() {
            var _this = this;

            // Defer to allow other rendering changes to finish first
            _.defer(function () {
                // The height of the entire drop-down should be the top position subtracted from the height of the menu
                var chooseRecipientsHeight = _this._heightConsideringBoxSizing(_this.$el) - (_this.ui.chooseRecipients.offset().top - _this.$el.offset().top);
                _this.ui.chooseRecipients.css("height", chooseRecipientsHeight + "px");

                // The height of the list is the height of the drop-down minus the height of the add area and footer
                _this.ui.recipientsList.css("height", _this.ui.recipientsFooter.offset().top - _this.ui.recipientsList.offset().top - _this._heightConsideringBoxSizing(_this.ui.recipientsAdd) + "px");
            });
        },

        onRender: function onRender() {
            var _this2 = this;

            // Render selected recipients in the to field
            var selectedRecipients = new FilteredCollection(this.model.get("recipients"), function (recipient) {
                return recipient instanceof ShareRecipientToLabel || recipient.get("selected");
            });
            this.recipientsDisplay.show(new ShareRecipientDisplayCollectionView({
                collection: new ConcatenatedCollection(new ShareRecipientToLabel({
                    displayName: "To:"
                }), selectedRecipients)
            }));

            // Initially render an empty list of share recipients, then add the registered users when they are loaded
            this.recipientsList.show(new ShareRecipientCollectionView({ collection: this.model.get("recipients") }));

            // Load registered users, if the model wasn't already initialized
            if (this.model.get("recipients").isEmpty()) {
                LoggedInUserState.fetchGlobalCollection(UserCollection).done(function (userCollection) {
                    // Buffer up the recipients to add
                    var recipientsToAdd = [];

                    // Only take users different from the current user
                    userCollection.each(function (user) {
                        if (!LoggedIn.principal().forUser(user)) {
                            recipientsToAdd.push(new ShareRecipient({ user: user, email: user.get("username") }));
                        }
                    });

                    // Add the buffered recipients
                    _this2.model.get("recipients").add(recipientsToAdd);
                });
            }

            this.listenTo(this.model.get("recipients"), "add remove change", this._updateValidationStates);
            this._updateValidationStates();

            this._updateRecipientsSizing();

            _.delay(this.ui.chooseRecipientsWrapper.collapse.bind(this.ui.chooseRecipientsWrapper), 250, "show");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var ImprovedModel = __webpack_require__(25);

  /**
   * Model for the "To" label in the recipients display field. Serves no function but to appear in the collection
   * rendered by the view.
   *
   * @class ShareRecipientToLabel
   * @constructor
   */
  return ImprovedModel.extend({});
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25),
        RestApi = __webpack_require__(29),
        TextUtil = __webpack_require__(555),
        Syncer = __webpack_require__(50);

    /**
     * Represents a share of an entity from one user to one or more users. <p>
     *
     * Pure editor model.
     *
     * @author Bruce Mackenzie Nielsen
     * @class Share
     * @constructor
     */
    return ImprovedModel.extend("Share", {

        defaults: {
            to: [],
            message: "",
            link: ""
        },

        constructor: function constructor() {
            this.__super();

            Syncer.State.init(this, {
                alias: {
                    save: "share"
                },
                permissions: {} // no permissions required for sharing!
            });
        },

        url: function url() {
            if (this.isNew()) {
                return RestApi.pathToCollection(RestApi.Collections.SHARES);
            }
            return RestApi.pathToSpecificResource(RestApi.Collections.SHARES, this.get("id"));
        },

        _distinguishedName: function _distinguishedName() {
            return TextUtil.firstLine(this.get("message"), true); // true = quote the name
        },

        /**
         * Adds a recipient to the share.
         *
         * @param {User} user The user to add as a recipient.
         */
        addRecipient: function addRecipient(user) {
            this.get("to").push({ id: user.get("id") });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ShareRecipient = __webpack_require__(715);

    /**
     * A collection of ShareRecipient.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientCollection
     * @constructor
     */
    return Backbone.Collection.extend({
        model: ShareRecipient
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ErrorHandler = __webpack_require__(119);
    var SyncManager = __webpack_require__(44);
    var RestApi = __webpack_require__(29);

    var PushResourceType = {
        PUSH_GROUPS: "PUSH_GROUPS",
        PUSH_EXPERIENCES: "PUSH_EXPERIENCES",
        PUSH_SETTINGS: "PUSH_SETTINGS"
    };

    function _syncCombinedResource(resourceId, companyId, pushType) {
        var url = RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, companyId, RestApi.Collections.COMBINED, true);

        return SyncManager.sync({
            method: "put",
            promise: true,
            fn: {
                url: url,
                type: "PUT",
                contentType: "application/json",
                data: JSON.stringify({
                    "resourceId": resourceId,
                    "combinedPushType": pushType
                })
            },
            errorHandler: function errorHandler(error) {
                ErrorHandler.inject(error, {
                    method: "fetch",
                    name: RestApi.Collections.COMBINED
                });
                return "alert";
            }
        }).promise();
    }

    /**
     * Contains combined experiences and groups sync functions.
     *
     * @class ResourceCombined
     */
    var ResourceCombined = {
        /**
         *
         * @param {{String}} groupId    The groupId to sync combined resource
         * @param {{String}} companyId  The companyId to sync combined resource
         */
        syncGroup: function syncGroup(groupId, companyId) {
            return _syncCombinedResource(groupId, companyId, PushResourceType.PUSH_GROUPS);
        },


        /**
         *
         * @param {{String}} experienceId    The groupId to sync combined resource
         * @param {{String}} companyId  The companyId to sync combined resource
         */
        syncExperience: function syncExperience(experienceId, companyId) {
            return _syncCombinedResource(experienceId, companyId, PushResourceType.PUSH_EXPERIENCES);
        }
    };

    return ResourceCombined;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var Tooltip = __webpack_require__(35);
    var Syncer = __webpack_require__(50);
    var EmailSliceModel = __webpack_require__(2924);
    var PublishableState = __webpack_require__(65);
    var WidgetValidator = __webpack_require__(1198);

    var TOOLTIPS = {
        PROCESSING: "Please wait... Preparing email HTML.",
        MULTIPLE_SCENES_MODE: "We can not create email for Experience with multiple scenes.",
        NOT_EMAIL_MODE: "Turn on email mode first",
        PROCESSING_EXPERIENCE: "Please wait... Processing experience",
        PROCESSING_EXPERIENCE_FAILED: "Something went wrong... Please try to push experience again.",
        NOT_ALLOWED_WIDGETS: "Your experience contains widgets that cannot be used in emails",
        NOT_PUSHED: "Push your experience to be able to send a test email",
        DEFAULT: "This allows you to quickly send a test version of your email experience to yourself and team.\nTo insure the most up to date version of your email gets sent, remember to <b>push all your changes</b> before hitting \"Send Test Email\"",
        OVERLAPPED_WIDGETS: "You have overlapping interactive elements on your experience (highlighted on the canvas for you). Please separate them to be able to Send Test Email."
    };

    /**
     * Component representing the Email related buttons (SendTestEmailButtonView, CopyEmailButtonView)
     * for the <tt>EditorPreviewMenu</tt>.
     *
     * @cfg {experienceModel} model The current experience model.
     * @cfg {viewModel} model The current view model.
     *
     * @see EditorPreviewMenu
     *
     * @class AbstractEmailButtonView
     */
    return ImprovedView.extend({
        isPushedOnInitialize: null,
        experienceModel: null,
        viewModel: null,
        emailSliceModel: null,
        allIncompatibleWidgets: [],

        ui: {
            popup: ".popup",
            emailBtn: ".email-btn",
            emailBtnDefault: ".email-btn-default",
            emailBtnOmetria: ".email-btn-ometria",
            emailBtnKlaviyo: ".email-btn-klaviyo",
            emailBtnSFMC: ".email-btn-sfmc"
        },

        initialize: function initialize() {
            var _this = this;

            this.tooltips = Object.assign({}, TOOLTIPS);
            this.viewModel = this.options.viewModel;
            this.experienceModel = this.options.viewModel.get("experience");
            this.model = new EmailSliceModel({
                _experience: this.experienceModel,
                _viewModel: this.viewModel
            });
            this.isPushedOnInitialization = this.experienceModel.hasAtLeastState(PublishableState.PUSHED);

            this.listenTo(this.viewModel, "change:isProcessingEmail change:hasOverlappedEmailWidgets", this._updateButtonState);
            this.listenTo(this.viewModel, "nestedWidgetTabOrderMetaDataChange", this._updateEmailEnableBtn);
            this.listenTo(this.experienceModel, "change:emailModeEnabled", this._updateEmailEnableBtn);
            this.listenTo(this.experienceModel, "add:scenes remove:scenes", this._updateListeners);
            this.listenTo(this.experienceModel.get("overlayScene").attributes.widgets, "add remove", this._updateEmailEnableBtn);
            this.listenTo(this.experienceModel.get("backgroundScene").attributes.widgets, "add remove", this._updateEmailEnableBtn);
            this.listenTo(this.experienceModel, "sync:state", function (state, method) {
                if (method !== "destroy") {
                    _this._updateButtonState();
                }
                if (method === "pushed" && state === Syncer.State.Synced) {
                    _this.isPushedOnInitialization = true;
                }
            });
            this._updateListeners();
        },
        _updateListeners: function _updateListeners() {
            var _this2 = this;

            this.experienceModel.get("scenes").models.forEach(function (model) {
                _this2.listenTo(model.attributes.widgets, "add remove", _this2._updateEmailEnableBtn);
            });
            this._updateEmailEnableBtn();
        },
        _updateEmailEnableBtn: function _updateEmailEnableBtn() {
            var _this3 = this;

            setTimeout(function () {
                var widgetModelsToCheckAllScenes = [];
                _this3.experienceModel.get("scenes").models.forEach(function (model) {
                    widgetModelsToCheckAllScenes = [].concat(_toConsumableArray(widgetModelsToCheckAllScenes), _toConsumableArray(model.attributes.widgets.models));
                });
                var widgetModelsToCheckBackground = _this3.experienceModel.get("backgroundScene").attributes.widgets.models;
                var widgetModelsToCheckOverlay = _this3.experienceModel.get("overlayScene").attributes.widgets.models;

                var widgetModelsToCheck = [].concat(_toConsumableArray(widgetModelsToCheckAllScenes), _toConsumableArray(widgetModelsToCheckBackground), _toConsumableArray(widgetModelsToCheckOverlay));
                _this3.allIncompatibleWidgets = WidgetValidator.getActiveIncompatibleEmailWidgets({
                    widgetModelsToCheck: widgetModelsToCheck,
                    systemMessage: "This experience contains widgets which cannot be used in emails: . Please remove these widgets before continuing.",
                    isEmailMode: _this3.experienceModel && _this3.experienceModel.get("emailModeEnabled"),
                    viewModel: _this3.viewModel
                });
                _this3._updateButtonState();
            }, 200);
        },


        onRender: function onRender() {
            this._updateButtonState();
        },

        onClose: function onClose() {
            Tooltip.remove(this.ui.emailBtn);
        },
        onShow: function onShow() {
            this._updateEmailEnableBtn();
        },
        _getCurrentStates: function _getCurrentStates() {
            var isProcessingEmail = this.viewModel.get("isProcessingEmail");
            var hasOverlappedEmailWidgets = this.viewModel.get("hasOverlappedEmailWidgets");
            var isEmailMode = this.experienceModel.get("emailModeEnabled");
            var isPushed = this.experienceModel.hasAtLeastState(PublishableState.PUSHED);
            var hasMultipleScenes = this.experienceModel.get("scenes").length > 1;
            var hasIncompatibleWidgets = !!this.allIncompatibleWidgets.length;

            var pending = Syncer.State.current(this.experienceModel) === Syncer.State.Pending;
            var syncing = Syncer.State.current(this.experienceModel) === Syncer.State.Syncing;
            return {
                isEmailMode: isEmailMode, isProcessingEmail: isProcessingEmail, hasIncompatibleWidgets: hasIncompatibleWidgets, hasOverlappedEmailWidgets: hasOverlappedEmailWidgets, isPushed: isPushed, hasMultipleScenes: hasMultipleScenes, pending: pending, syncing: syncing
            };
        },
        _getTooltipText: function _getTooltipText() {
            var _getCurrentStates2 = this._getCurrentStates(),
                isEmailMode = _getCurrentStates2.isEmailMode,
                isPushed = _getCurrentStates2.isPushed,
                hasMultipleScenes = _getCurrentStates2.hasMultipleScenes,
                pending = _getCurrentStates2.pending,
                syncing = _getCurrentStates2.syncing,
                isProcessingEmail = _getCurrentStates2.isProcessingEmail,
                hasIncompatibleWidgets = _getCurrentStates2.hasIncompatibleWidgets,
                hasOverlappedEmailWidgets = _getCurrentStates2.hasOverlappedEmailWidgets;

            var tooltipText = this.tooltips.DEFAULT;
            if (!isEmailMode) {
                tooltipText = this.tooltips.NOT_EMAIL_MODE;
            } else if (hasOverlappedEmailWidgets) {
                tooltipText = this.tooltips.OVERLAPPED_WIDGETS;
            } else if (hasMultipleScenes) {
                tooltipText = this.tooltips.MULTIPLE_SCENES_MODE;
            } else if (hasIncompatibleWidgets) {
                var widgetsName = WidgetValidator.getIncompatibleWidgetsNames(this.allIncompatibleWidgets);
                tooltipText = this.tooltips.NOT_ALLOWED_WIDGETS + ": " + widgetsName + ".";
            } else if (pending || syncing) {
                tooltipText = this.tooltips.PROCESSING_EXPERIENCE;
            } else if (!isPushed) {
                tooltipText = this.tooltips.NOT_PUSHED;
            } else if (isProcessingEmail) {
                tooltipText = this.tooltips.PROCESSING;
            }

            return tooltipText;
        },
        _getButtonState: function _getButtonState() {
            var _getCurrentStates3 = this._getCurrentStates(),
                isEmailMode = _getCurrentStates3.isEmailMode,
                hasOverlappedEmailWidgets = _getCurrentStates3.hasOverlappedEmailWidgets,
                isPushed = _getCurrentStates3.isPushed,
                hasMultipleScenes = _getCurrentStates3.hasMultipleScenes,
                changedAfterPush = _getCurrentStates3.changedAfterPush,
                pending = _getCurrentStates3.pending,
                failed = _getCurrentStates3.failed,
                syncing = _getCurrentStates3.syncing,
                isProcessingEmail = _getCurrentStates3.isProcessingEmail,
                hasIncompatibleWidgets = _getCurrentStates3.hasIncompatibleWidgets;

            return !isEmailMode || hasOverlappedEmailWidgets || hasMultipleScenes || hasIncompatibleWidgets || !isPushed || changedAfterPush || pending || failed || isProcessingEmail || syncing;
        },
        _updateButtonState: function _updateButtonState() {
            var tooltipText = this._getTooltipText();
            var disabled = this._getButtonState();

            this._updateTooltip(tooltipText);
            this.ui.emailBtn.toggleClass("disabled", disabled);
        },
        _updateTooltip: function _updateTooltip(tooltipText) {
            Tooltip.remove(this.ui.emailBtn);
            var tooltipSettings = {
                width: 200,
                animation: false,
                trigger: "hover",
                placement: "left",
                duration: 0,
                content: tooltipText,
                html: true
            };
            Tooltip.add(this.ui.emailBtn, tooltipSettings);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"navbar":"bootstrap-min_navbar_3LmOW","btn":"bootstrap-min_btn_33rIN","caret":"bootstrap-min_caret_3ADIC","dropup":"bootstrap-min_dropup_2vLDm","label":"bootstrap-min_label_150Wv","table":"bootstrap-min_table_GrZsg","table-bordered":"bootstrap-min_table-bordered_jf6La","glyphicon":"bootstrap-min_glyphicon_34rDf","glyphicon-asterisk":"bootstrap-min_glyphicon-asterisk_lW1YX","glyphicon-plus":"bootstrap-min_glyphicon-plus_3dHu-","glyphicon-eur":"bootstrap-min_glyphicon-eur_2_jkl","glyphicon-euro":"bootstrap-min_glyphicon-euro_3kiqD","glyphicon-minus":"bootstrap-min_glyphicon-minus_w3ZCi","glyphicon-cloud":"bootstrap-min_glyphicon-cloud_CXZAF","glyphicon-envelope":"bootstrap-min_glyphicon-envelope_2xPBI","glyphicon-pencil":"bootstrap-min_glyphicon-pencil_3KEZd","glyphicon-glass":"bootstrap-min_glyphicon-glass_1unj5","glyphicon-music":"bootstrap-min_glyphicon-music_3riyG","glyphicon-search":"bootstrap-min_glyphicon-search_1AgBb","glyphicon-heart":"bootstrap-min_glyphicon-heart_1Ya4S","glyphicon-star":"bootstrap-min_glyphicon-star_16g2-","glyphicon-star-empty":"bootstrap-min_glyphicon-star-empty_y4upW","glyphicon-user":"bootstrap-min_glyphicon-user_1SzoI","glyphicon-film":"bootstrap-min_glyphicon-film_2HuI1","glyphicon-th-large":"bootstrap-min_glyphicon-th-large_u8mnR","glyphicon-th":"bootstrap-min_glyphicon-th_jv0nc","glyphicon-th-list":"bootstrap-min_glyphicon-th-list_jI9Cg","glyphicon-ok":"bootstrap-min_glyphicon-ok_LaIUg","glyphicon-remove":"bootstrap-min_glyphicon-remove_1e-vs","glyphicon-zoom-in":"bootstrap-min_glyphicon-zoom-in_2d8pe","glyphicon-zoom-out":"bootstrap-min_glyphicon-zoom-out_2xoQC","glyphicon-off":"bootstrap-min_glyphicon-off_3LSYU","glyphicon-signal":"bootstrap-min_glyphicon-signal_143xe","glyphicon-cog":"bootstrap-min_glyphicon-cog_3gjT6","glyphicon-trash":"bootstrap-min_glyphicon-trash_1hJjj","glyphicon-home":"bootstrap-min_glyphicon-home_27_jj","glyphicon-file":"bootstrap-min_glyphicon-file_YNmUq","glyphicon-time":"bootstrap-min_glyphicon-time_3xJOB","glyphicon-road":"bootstrap-min_glyphicon-road_2ZPe9","glyphicon-download-alt":"bootstrap-min_glyphicon-download-alt_3TnB1","glyphicon-download":"bootstrap-min_glyphicon-download_3ddH2","glyphicon-upload":"bootstrap-min_glyphicon-upload_3HTEC","glyphicon-inbox":"bootstrap-min_glyphicon-inbox_2ycVi","glyphicon-play-circle":"bootstrap-min_glyphicon-play-circle_r3RFq","glyphicon-repeat":"bootstrap-min_glyphicon-repeat_27fpr","glyphicon-refresh":"bootstrap-min_glyphicon-refresh_3ecul","glyphicon-list-alt":"bootstrap-min_glyphicon-list-alt_vvye0","glyphicon-lock":"bootstrap-min_glyphicon-lock_3LbRq","glyphicon-flag":"bootstrap-min_glyphicon-flag_18Ps7","glyphicon-headphones":"bootstrap-min_glyphicon-headphones_3WkHN","glyphicon-volume-off":"bootstrap-min_glyphicon-volume-off_18zO7","glyphicon-volume-down":"bootstrap-min_glyphicon-volume-down_9KWvZ","glyphicon-volume-up":"bootstrap-min_glyphicon-volume-up_1JHHg","glyphicon-qrcode":"bootstrap-min_glyphicon-qrcode_BYc8o","glyphicon-barcode":"bootstrap-min_glyphicon-barcode_3JY63","glyphicon-tag":"bootstrap-min_glyphicon-tag_31Qde","glyphicon-tags":"bootstrap-min_glyphicon-tags_Zxls_","glyphicon-book":"bootstrap-min_glyphicon-book_vVO9O","glyphicon-bookmark":"bootstrap-min_glyphicon-bookmark_2O2Dw","glyphicon-print":"bootstrap-min_glyphicon-print_aRYTr","glyphicon-camera":"bootstrap-min_glyphicon-camera_2guUp","glyphicon-font":"bootstrap-min_glyphicon-font_23W6L","glyphicon-bold":"bootstrap-min_glyphicon-bold_39mUK","glyphicon-italic":"bootstrap-min_glyphicon-italic_2n2ME","glyphicon-text-height":"bootstrap-min_glyphicon-text-height_3MY3r","glyphicon-text-width":"bootstrap-min_glyphicon-text-width_3qqKI","glyphicon-align-left":"bootstrap-min_glyphicon-align-left_2RTBY","glyphicon-align-center":"bootstrap-min_glyphicon-align-center_2pdVv","glyphicon-align-right":"bootstrap-min_glyphicon-align-right_1E9D1","glyphicon-align-justify":"bootstrap-min_glyphicon-align-justify_2uvLA","glyphicon-list":"bootstrap-min_glyphicon-list_uXmxi","glyphicon-indent-left":"bootstrap-min_glyphicon-indent-left_29Rpm","glyphicon-indent-right":"bootstrap-min_glyphicon-indent-right_2IW-x","glyphicon-facetime-video":"bootstrap-min_glyphicon-facetime-video_B_Ucl","glyphicon-picture":"bootstrap-min_glyphicon-picture_12wcc","glyphicon-map-marker":"bootstrap-min_glyphicon-map-marker_104Qp","glyphicon-adjust":"bootstrap-min_glyphicon-adjust_3laJE","glyphicon-tint":"bootstrap-min_glyphicon-tint_2r8JU","glyphicon-edit":"bootstrap-min_glyphicon-edit_1u_Th","glyphicon-share":"bootstrap-min_glyphicon-share_XCkkw","glyphicon-check":"bootstrap-min_glyphicon-check_FXJny","glyphicon-move":"bootstrap-min_glyphicon-move_3x146","glyphicon-step-backward":"bootstrap-min_glyphicon-step-backward_vf_st","glyphicon-fast-backward":"bootstrap-min_glyphicon-fast-backward_A9Lxl","glyphicon-backward":"bootstrap-min_glyphicon-backward_UShbP","glyphicon-play":"bootstrap-min_glyphicon-play_Oleam","glyphicon-pause":"bootstrap-min_glyphicon-pause_3hzTf","glyphicon-stop":"bootstrap-min_glyphicon-stop_2lJ22","glyphicon-forward":"bootstrap-min_glyphicon-forward_LVud8","glyphicon-fast-forward":"bootstrap-min_glyphicon-fast-forward_2Ei2_","glyphicon-step-forward":"bootstrap-min_glyphicon-step-forward_22nZx","glyphicon-eject":"bootstrap-min_glyphicon-eject_rGNIf","glyphicon-chevron-left":"bootstrap-min_glyphicon-chevron-left_1epG-","glyphicon-chevron-right":"bootstrap-min_glyphicon-chevron-right_1YM1L","glyphicon-plus-sign":"bootstrap-min_glyphicon-plus-sign_iyx6Y","glyphicon-minus-sign":"bootstrap-min_glyphicon-minus-sign_3crIN","glyphicon-remove-sign":"bootstrap-min_glyphicon-remove-sign_hrOs1","glyphicon-ok-sign":"bootstrap-min_glyphicon-ok-sign_1Urvi","glyphicon-question-sign":"bootstrap-min_glyphicon-question-sign_3caS5","glyphicon-info-sign":"bootstrap-min_glyphicon-info-sign_SxH3m","glyphicon-screenshot":"bootstrap-min_glyphicon-screenshot_1e0qb","glyphicon-remove-circle":"bootstrap-min_glyphicon-remove-circle_2KJtp","glyphicon-ok-circle":"bootstrap-min_glyphicon-ok-circle_3-LXd","glyphicon-ban-circle":"bootstrap-min_glyphicon-ban-circle_ItZnl","glyphicon-arrow-left":"bootstrap-min_glyphicon-arrow-left_1o0Ue","glyphicon-arrow-right":"bootstrap-min_glyphicon-arrow-right_2UYsJ","glyphicon-arrow-up":"bootstrap-min_glyphicon-arrow-up_1VvfD","glyphicon-arrow-down":"bootstrap-min_glyphicon-arrow-down_1-KmT","glyphicon-share-alt":"bootstrap-min_glyphicon-share-alt_2Qzh-","glyphicon-resize-full":"bootstrap-min_glyphicon-resize-full_1QR9I","glyphicon-resize-small":"bootstrap-min_glyphicon-resize-small_GMmrq","glyphicon-exclamation-sign":"bootstrap-min_glyphicon-exclamation-sign_1RZRR","glyphicon-gift":"bootstrap-min_glyphicon-gift_3TmpI","glyphicon-leaf":"bootstrap-min_glyphicon-leaf_qdAa4","glyphicon-fire":"bootstrap-min_glyphicon-fire_26J7a","glyphicon-eye-open":"bootstrap-min_glyphicon-eye-open_S_a66","glyphicon-eye-close":"bootstrap-min_glyphicon-eye-close_2IhZz","glyphicon-warning-sign":"bootstrap-min_glyphicon-warning-sign_1H0ww","glyphicon-plane":"bootstrap-min_glyphicon-plane_30MPC","glyphicon-calendar":"bootstrap-min_glyphicon-calendar_2qzJe","glyphicon-random":"bootstrap-min_glyphicon-random_SzvyV","glyphicon-comment":"bootstrap-min_glyphicon-comment_GF9Pj","glyphicon-magnet":"bootstrap-min_glyphicon-magnet_3Z0_q","glyphicon-chevron-up":"bootstrap-min_glyphicon-chevron-up_1vFyx","glyphicon-chevron-down":"bootstrap-min_glyphicon-chevron-down_1OX1m","glyphicon-retweet":"bootstrap-min_glyphicon-retweet_wM4fw","glyphicon-shopping-cart":"bootstrap-min_glyphicon-shopping-cart_1vN7Z","glyphicon-folder-close":"bootstrap-min_glyphicon-folder-close_2ues7","glyphicon-folder-open":"bootstrap-min_glyphicon-folder-open_29whW","glyphicon-resize-vertical":"bootstrap-min_glyphicon-resize-vertical_3S8-8","glyphicon-resize-horizontal":"bootstrap-min_glyphicon-resize-horizontal_3X68K","glyphicon-hdd":"bootstrap-min_glyphicon-hdd_3mLrO","glyphicon-bullhorn":"bootstrap-min_glyphicon-bullhorn_63xfg","glyphicon-bell":"bootstrap-min_glyphicon-bell_3HHDT","glyphicon-certificate":"bootstrap-min_glyphicon-certificate_21Ab5","glyphicon-thumbs-up":"bootstrap-min_glyphicon-thumbs-up_QHDPO","glyphicon-thumbs-down":"bootstrap-min_glyphicon-thumbs-down_13neU","glyphicon-hand-right":"bootstrap-min_glyphicon-hand-right_1wSQE","glyphicon-hand-left":"bootstrap-min_glyphicon-hand-left_1BLnz","glyphicon-hand-up":"bootstrap-min_glyphicon-hand-up_Yxdai","glyphicon-hand-down":"bootstrap-min_glyphicon-hand-down_2MYSz","glyphicon-circle-arrow-right":"bootstrap-min_glyphicon-circle-arrow-right_3OZrQ","glyphicon-circle-arrow-left":"bootstrap-min_glyphicon-circle-arrow-left_fCSgj","glyphicon-circle-arrow-up":"bootstrap-min_glyphicon-circle-arrow-up_29XGx","glyphicon-circle-arrow-down":"bootstrap-min_glyphicon-circle-arrow-down_1h1eb","glyphicon-globe":"bootstrap-min_glyphicon-globe_3dLi1","glyphicon-wrench":"bootstrap-min_glyphicon-wrench_11t-E","glyphicon-tasks":"bootstrap-min_glyphicon-tasks_1rDkF","glyphicon-filter":"bootstrap-min_glyphicon-filter_3_7HR","glyphicon-briefcase":"bootstrap-min_glyphicon-briefcase_287LS","glyphicon-fullscreen":"bootstrap-min_glyphicon-fullscreen_1b0DD","glyphicon-dashboard":"bootstrap-min_glyphicon-dashboard_1VzXT","glyphicon-paperclip":"bootstrap-min_glyphicon-paperclip_3amRi","glyphicon-heart-empty":"bootstrap-min_glyphicon-heart-empty_2C_1J","glyphicon-link":"bootstrap-min_glyphicon-link_19LZF","glyphicon-phone":"bootstrap-min_glyphicon-phone_wh-RB","glyphicon-pushpin":"bootstrap-min_glyphicon-pushpin_WjHxT","glyphicon-usd":"bootstrap-min_glyphicon-usd_OIyOi","glyphicon-gbp":"bootstrap-min_glyphicon-gbp_1h88x","glyphicon-sort":"bootstrap-min_glyphicon-sort_1PtT3","glyphicon-sort-by-alphabet":"bootstrap-min_glyphicon-sort-by-alphabet_2hcJ1","glyphicon-sort-by-alphabet-alt":"bootstrap-min_glyphicon-sort-by-alphabet-alt_2UOvF","glyphicon-sort-by-order":"bootstrap-min_glyphicon-sort-by-order_1gYb8","glyphicon-sort-by-order-alt":"bootstrap-min_glyphicon-sort-by-order-alt_Vg0W-","glyphicon-sort-by-attributes":"bootstrap-min_glyphicon-sort-by-attributes_rBbNT","glyphicon-sort-by-attributes-alt":"bootstrap-min_glyphicon-sort-by-attributes-alt_j43QL","glyphicon-unchecked":"bootstrap-min_glyphicon-unchecked_2RAI9","glyphicon-expand":"bootstrap-min_glyphicon-expand_-Y1Rv","glyphicon-collapse-down":"bootstrap-min_glyphicon-collapse-down_yWNuG","glyphicon-collapse-up":"bootstrap-min_glyphicon-collapse-up_2tRo-","glyphicon-log-in":"bootstrap-min_glyphicon-log-in_2RnJ5","glyphicon-flash":"bootstrap-min_glyphicon-flash_3RmXu","glyphicon-log-out":"bootstrap-min_glyphicon-log-out_19xV1","glyphicon-new-window":"bootstrap-min_glyphicon-new-window_1y4ZP","glyphicon-record":"bootstrap-min_glyphicon-record_2oacc","glyphicon-save":"bootstrap-min_glyphicon-save_1H4Gv","glyphicon-open":"bootstrap-min_glyphicon-open_2qsEt","glyphicon-saved":"bootstrap-min_glyphicon-saved_265Wk","glyphicon-import":"bootstrap-min_glyphicon-import_1tmY0","glyphicon-export":"bootstrap-min_glyphicon-export_3Iv5G","glyphicon-send":"bootstrap-min_glyphicon-send_2EuoQ","glyphicon-floppy-disk":"bootstrap-min_glyphicon-floppy-disk_3c3Uo","glyphicon-floppy-saved":"bootstrap-min_glyphicon-floppy-saved_UA2Hq","glyphicon-floppy-remove":"bootstrap-min_glyphicon-floppy-remove_1qHDK","glyphicon-floppy-save":"bootstrap-min_glyphicon-floppy-save_1z0Kb","glyphicon-floppy-open":"bootstrap-min_glyphicon-floppy-open_1gtXs","glyphicon-credit-card":"bootstrap-min_glyphicon-credit-card_1BBuP","glyphicon-transfer":"bootstrap-min_glyphicon-transfer_gTm4X","glyphicon-cutlery":"bootstrap-min_glyphicon-cutlery_yxITX","glyphicon-header":"bootstrap-min_glyphicon-header_1s9Z9","glyphicon-compressed":"bootstrap-min_glyphicon-compressed_BtwvS","glyphicon-earphone":"bootstrap-min_glyphicon-earphone_1JBfT","glyphicon-phone-alt":"bootstrap-min_glyphicon-phone-alt_201uY","glyphicon-tower":"bootstrap-min_glyphicon-tower_2LmD3","glyphicon-stats":"bootstrap-min_glyphicon-stats_8mgjA","glyphicon-sd-video":"bootstrap-min_glyphicon-sd-video_1bUYl","glyphicon-hd-video":"bootstrap-min_glyphicon-hd-video_33NrR","glyphicon-subtitles":"bootstrap-min_glyphicon-subtitles_2MDrL","glyphicon-sound-stereo":"bootstrap-min_glyphicon-sound-stereo_2nmSF","glyphicon-sound-dolby":"bootstrap-min_glyphicon-sound-dolby_qa8mj","glyphicon-sound-5-1":"bootstrap-min_glyphicon-sound-5-1_2KYwt","glyphicon-sound-6-1":"bootstrap-min_glyphicon-sound-6-1_1wZgZ","glyphicon-sound-7-1":"bootstrap-min_glyphicon-sound-7-1_1x_gO","glyphicon-copyright-mark":"bootstrap-min_glyphicon-copyright-mark_Xh2Nk","glyphicon-registration-mark":"bootstrap-min_glyphicon-registration-mark_k7EcO","glyphicon-cloud-download":"bootstrap-min_glyphicon-cloud-download_I5tKv","glyphicon-cloud-upload":"bootstrap-min_glyphicon-cloud-upload_1yry3","glyphicon-tree-conifer":"bootstrap-min_glyphicon-tree-conifer_3T2sH","glyphicon-tree-deciduous":"bootstrap-min_glyphicon-tree-deciduous_15Tti","glyphicon-cd":"bootstrap-min_glyphicon-cd__18ht","glyphicon-save-file":"bootstrap-min_glyphicon-save-file_17pgq","glyphicon-open-file":"bootstrap-min_glyphicon-open-file_1oUie","glyphicon-level-up":"bootstrap-min_glyphicon-level-up_2zLeR","glyphicon-copy":"bootstrap-min_glyphicon-copy_1dYt5","glyphicon-paste":"bootstrap-min_glyphicon-paste_1sZmL","glyphicon-alert":"bootstrap-min_glyphicon-alert_2C12W","glyphicon-equalizer":"bootstrap-min_glyphicon-equalizer_g7MJc","glyphicon-king":"bootstrap-min_glyphicon-king_2M62S","glyphicon-queen":"bootstrap-min_glyphicon-queen_2HIE4","glyphicon-pawn":"bootstrap-min_glyphicon-pawn_20gsg","glyphicon-bishop":"bootstrap-min_glyphicon-bishop_1XFEM","glyphicon-knight":"bootstrap-min_glyphicon-knight_2pDYX","glyphicon-baby-formula":"bootstrap-min_glyphicon-baby-formula_1QMFE","glyphicon-tent":"bootstrap-min_glyphicon-tent_1oTBb","glyphicon-blackboard":"bootstrap-min_glyphicon-blackboard_1C-oK","glyphicon-bed":"bootstrap-min_glyphicon-bed_2BeSv","glyphicon-apple":"bootstrap-min_glyphicon-apple_1r59x","glyphicon-erase":"bootstrap-min_glyphicon-erase_Y29pP","glyphicon-hourglass":"bootstrap-min_glyphicon-hourglass_3vHbs","glyphicon-lamp":"bootstrap-min_glyphicon-lamp_1bIuS","glyphicon-duplicate":"bootstrap-min_glyphicon-duplicate_1pSWh","glyphicon-piggy-bank":"bootstrap-min_glyphicon-piggy-bank_1WynS","glyphicon-scissors":"bootstrap-min_glyphicon-scissors_otmDh","glyphicon-bitcoin":"bootstrap-min_glyphicon-bitcoin_3LH9F","glyphicon-btc":"bootstrap-min_glyphicon-btc_H4wiC","glyphicon-xbt":"bootstrap-min_glyphicon-xbt_l4cpd","glyphicon-yen":"bootstrap-min_glyphicon-yen_29AlZ","glyphicon-jpy":"bootstrap-min_glyphicon-jpy_1p-ge","glyphicon-ruble":"bootstrap-min_glyphicon-ruble_3yJiA","glyphicon-rub":"bootstrap-min_glyphicon-rub_3_FJH","glyphicon-scale":"bootstrap-min_glyphicon-scale_3rV3l","glyphicon-ice-lolly":"bootstrap-min_glyphicon-ice-lolly_Cve8h","glyphicon-ice-lolly-tasted":"bootstrap-min_glyphicon-ice-lolly-tasted_sl6Vw","glyphicon-education":"bootstrap-min_glyphicon-education_oS39N","glyphicon-option-horizontal":"bootstrap-min_glyphicon-option-horizontal_202Wp","glyphicon-option-vertical":"bootstrap-min_glyphicon-option-vertical_1JWgm","glyphicon-menu-hamburger":"bootstrap-min_glyphicon-menu-hamburger_1PrD_","glyphicon-modal-window":"bootstrap-min_glyphicon-modal-window_t-cLl","glyphicon-oil":"bootstrap-min_glyphicon-oil_22jfS","glyphicon-grain":"bootstrap-min_glyphicon-grain_1GsUd","glyphicon-sunglasses":"bootstrap-min_glyphicon-sunglasses_2o_ch","glyphicon-text-size":"bootstrap-min_glyphicon-text-size_2WRRY","glyphicon-text-color":"bootstrap-min_glyphicon-text-color_2JOU3","glyphicon-text-background":"bootstrap-min_glyphicon-text-background_1Gl_s","glyphicon-object-align-top":"bootstrap-min_glyphicon-object-align-top_3-Mzw","glyphicon-object-align-bottom":"bootstrap-min_glyphicon-object-align-bottom_35srW","glyphicon-object-align-horizontal":"bootstrap-min_glyphicon-object-align-horizontal_2abLC","glyphicon-object-align-left":"bootstrap-min_glyphicon-object-align-left_3uyeA","glyphicon-object-align-vertical":"bootstrap-min_glyphicon-object-align-vertical_2Iazs","glyphicon-object-align-right":"bootstrap-min_glyphicon-object-align-right_1PsJK","glyphicon-triangle-right":"bootstrap-min_glyphicon-triangle-right_1sD8R","glyphicon-triangle-left":"bootstrap-min_glyphicon-triangle-left_2QOzW","glyphicon-triangle-bottom":"bootstrap-min_glyphicon-triangle-bottom_3Rv8w","glyphicon-triangle-top":"bootstrap-min_glyphicon-triangle-top_E8bzD","glyphicon-console":"bootstrap-min_glyphicon-console__P3Lz","glyphicon-superscript":"bootstrap-min_glyphicon-superscript_1WtVv","glyphicon-subscript":"bootstrap-min_glyphicon-subscript_1M0Sy","glyphicon-menu-left":"bootstrap-min_glyphicon-menu-left_D5o4D","glyphicon-menu-right":"bootstrap-min_glyphicon-menu-right_3DViR","glyphicon-menu-down":"bootstrap-min_glyphicon-menu-down_2EXVE","glyphicon-menu-up":"bootstrap-min_glyphicon-menu-up_-njAD","carousel-inner":"bootstrap-min_carousel-inner_2YIqg","item":"bootstrap-min_item_10uhi","img-responsive":"bootstrap-min_img-responsive_32oSW","thumbnail":"bootstrap-min_thumbnail_3gX1s","img-rounded":"bootstrap-min_img-rounded_1wOKF","img-thumbnail":"bootstrap-min_img-thumbnail_2LZov","img-circle":"bootstrap-min_img-circle_1rWH2","sr-only":"bootstrap-min_sr-only_3wlTd","sr-only-focusable":"bootstrap-min_sr-only-focusable_3Y7wD","h1":"bootstrap-min_h1_JLbN0","h2":"bootstrap-min_h2_1Yx4I","h3":"bootstrap-min_h3_2tb_F","h4":"bootstrap-min_h4_mJbUm","h5":"bootstrap-min_h5_pPsEc","h6":"bootstrap-min_h6_2NPYy","small":"bootstrap-min_small_2gJYW","lead":"bootstrap-min_lead_3zmFd","mark":"bootstrap-min_mark_1gm-C","text-left":"bootstrap-min_text-left_oR3hZ","text-right":"bootstrap-min_text-right_3bwyt","text-center":"bootstrap-min_text-center_2R-s3","text-justify":"bootstrap-min_text-justify_fIDtr","text-nowrap":"bootstrap-min_text-nowrap_2y79v","text-lowercase":"bootstrap-min_text-lowercase_2fjX6","text-uppercase":"bootstrap-min_text-uppercase_3Barn","text-capitalize":"bootstrap-min_text-capitalize_35PZS","text-muted":"bootstrap-min_text-muted_1yR3q","text-primary":"bootstrap-min_text-primary_s5dEU","text-success":"bootstrap-min_text-success_1ZQ5o","text-info":"bootstrap-min_text-info_1AU5u","text-warning":"bootstrap-min_text-warning_3cRPX","text-danger":"bootstrap-min_text-danger_2DWla","bg-primary":"bootstrap-min_bg-primary_35XSE","bg-success":"bootstrap-min_bg-success_1oQGL","bg-info":"bootstrap-min_bg-info_u_Bhs","bg-warning":"bootstrap-min_bg-warning_1CCgu","bg-danger":"bootstrap-min_bg-danger_2vxiN","page-header":"bootstrap-min_page-header_2cDhe","list-unstyled":"bootstrap-min_list-unstyled_3EX6R","list-inline":"bootstrap-min_list-inline_TCNFj","dl-horizontal":"bootstrap-min_dl-horizontal_2XFZh","initialism":"bootstrap-min_initialism_3zCIV","blockquote-reverse":"bootstrap-min_blockquote-reverse_Zi05v","pull-right":"bootstrap-min_pull-right_3NWmr","pre-scrollable":"bootstrap-min_pre-scrollable_1sRNU","container":"bootstrap-min_container_3i4Ca","container-fluid":"bootstrap-min_container-fluid_Jx8Kl","row":"bootstrap-min_row_2048F","col-lg-1":"bootstrap-min_col-lg-1_3uad4","col-lg-10":"bootstrap-min_col-lg-10_1yTjU","col-lg-11":"bootstrap-min_col-lg-11_foFwG","col-lg-12":"bootstrap-min_col-lg-12_1Vspn","col-lg-2":"bootstrap-min_col-lg-2_1b4lq","col-lg-3":"bootstrap-min_col-lg-3_3KCMa","col-lg-4":"bootstrap-min_col-lg-4_3gZYS","col-lg-5":"bootstrap-min_col-lg-5_2ewkc","col-lg-6":"bootstrap-min_col-lg-6_15QrV","col-lg-7":"bootstrap-min_col-lg-7_vKsWR","col-lg-8":"bootstrap-min_col-lg-8_AZTLn","col-lg-9":"bootstrap-min_col-lg-9_2459q","col-md-1":"bootstrap-min_col-md-1_3I_2A","col-md-10":"bootstrap-min_col-md-10_1j5LU","col-md-11":"bootstrap-min_col-md-11_1RZFk","col-md-12":"bootstrap-min_col-md-12_2ymaN","col-md-2":"bootstrap-min_col-md-2_p0Q41","col-md-3":"bootstrap-min_col-md-3_1gEUG","col-md-4":"bootstrap-min_col-md-4_A8ARb","col-md-5":"bootstrap-min_col-md-5_15DVD","col-md-6":"bootstrap-min_col-md-6_1vbTi","col-md-7":"bootstrap-min_col-md-7_2QmfU","col-md-8":"bootstrap-min_col-md-8_3iK48","col-md-9":"bootstrap-min_col-md-9_2Apy1","col-sm-1":"bootstrap-min_col-sm-1_2zUq3","col-sm-10":"bootstrap-min_col-sm-10_36KiQ","col-sm-11":"bootstrap-min_col-sm-11_2NDic","col-sm-12":"bootstrap-min_col-sm-12_2voWg","col-sm-2":"bootstrap-min_col-sm-2_1tKJK","col-sm-3":"bootstrap-min_col-sm-3_28kxC","col-sm-4":"bootstrap-min_col-sm-4_1jB7H","col-sm-5":"bootstrap-min_col-sm-5_223ow","col-sm-6":"bootstrap-min_col-sm-6_1V2Ts","col-sm-7":"bootstrap-min_col-sm-7_1TWhA","col-sm-8":"bootstrap-min_col-sm-8_p8PTP","col-sm-9":"bootstrap-min_col-sm-9_3y-wC","col-xs-1":"bootstrap-min_col-xs-1_3nN7O","col-xs-10":"bootstrap-min_col-xs-10_3FOt5","col-xs-11":"bootstrap-min_col-xs-11_GHJGw","col-xs-12":"bootstrap-min_col-xs-12_3ycBY","col-xs-2":"bootstrap-min_col-xs-2_2ghfi","col-xs-3":"bootstrap-min_col-xs-3_380h1","col-xs-4":"bootstrap-min_col-xs-4_B0q9f","col-xs-5":"bootstrap-min_col-xs-5_2zHNX","col-xs-6":"bootstrap-min_col-xs-6_1g2tn","col-xs-7":"bootstrap-min_col-xs-7_3ohDK","col-xs-8":"bootstrap-min_col-xs-8_1mpZ7","col-xs-9":"bootstrap-min_col-xs-9_1KK0L","col-xs-pull-12":"bootstrap-min_col-xs-pull-12_26cGu","col-xs-pull-11":"bootstrap-min_col-xs-pull-11_1joe1","col-xs-pull-10":"bootstrap-min_col-xs-pull-10_2uf7z","col-xs-pull-9":"bootstrap-min_col-xs-pull-9_2tz1J","col-xs-pull-8":"bootstrap-min_col-xs-pull-8_1_uVY","col-xs-pull-7":"bootstrap-min_col-xs-pull-7_y9tGl","col-xs-pull-6":"bootstrap-min_col-xs-pull-6_3xuCv","col-xs-pull-5":"bootstrap-min_col-xs-pull-5_2_htc","col-xs-pull-4":"bootstrap-min_col-xs-pull-4_12QiW","col-xs-pull-3":"bootstrap-min_col-xs-pull-3_Npr4P","col-xs-pull-2":"bootstrap-min_col-xs-pull-2_s-YSR","col-xs-pull-1":"bootstrap-min_col-xs-pull-1_24rOQ","col-xs-pull-0":"bootstrap-min_col-xs-pull-0_1V0X-","col-xs-push-12":"bootstrap-min_col-xs-push-12_3QHSG","col-xs-push-11":"bootstrap-min_col-xs-push-11_2xY6r","col-xs-push-10":"bootstrap-min_col-xs-push-10_3NrFs","col-xs-push-9":"bootstrap-min_col-xs-push-9_nd6bS","col-xs-push-8":"bootstrap-min_col-xs-push-8_aJTs6","col-xs-push-7":"bootstrap-min_col-xs-push-7_18e6I","col-xs-push-6":"bootstrap-min_col-xs-push-6_1Pye-","col-xs-push-5":"bootstrap-min_col-xs-push-5_1ViAW","col-xs-push-4":"bootstrap-min_col-xs-push-4_XLtba","col-xs-push-3":"bootstrap-min_col-xs-push-3_16mCv","col-xs-push-2":"bootstrap-min_col-xs-push-2_vg-Jq","col-xs-push-1":"bootstrap-min_col-xs-push-1_2QsoE","col-xs-push-0":"bootstrap-min_col-xs-push-0_3tdh9","col-xs-offset-12":"bootstrap-min_col-xs-offset-12_2V61i","col-xs-offset-11":"bootstrap-min_col-xs-offset-11_g2KeR","col-xs-offset-10":"bootstrap-min_col-xs-offset-10_3Q1ID","col-xs-offset-9":"bootstrap-min_col-xs-offset-9_2tAPh","col-xs-offset-8":"bootstrap-min_col-xs-offset-8_aScPY","col-xs-offset-7":"bootstrap-min_col-xs-offset-7_D059f","col-xs-offset-6":"bootstrap-min_col-xs-offset-6_1s4OY","col-xs-offset-5":"bootstrap-min_col-xs-offset-5_w21Vn","col-xs-offset-4":"bootstrap-min_col-xs-offset-4_3yb0x","col-xs-offset-3":"bootstrap-min_col-xs-offset-3_2lrtk","col-xs-offset-2":"bootstrap-min_col-xs-offset-2_1ZnCi","col-xs-offset-1":"bootstrap-min_col-xs-offset-1_3ZWvc","col-xs-offset-0":"bootstrap-min_col-xs-offset-0_1mFR8","col-sm-pull-12":"bootstrap-min_col-sm-pull-12_EZwOJ","col-sm-pull-11":"bootstrap-min_col-sm-pull-11_uzZu1","col-sm-pull-10":"bootstrap-min_col-sm-pull-10_3zp-Z","col-sm-pull-9":"bootstrap-min_col-sm-pull-9_14UJt","col-sm-pull-8":"bootstrap-min_col-sm-pull-8_biA4R","col-sm-pull-7":"bootstrap-min_col-sm-pull-7_B1STE","col-sm-pull-6":"bootstrap-min_col-sm-pull-6_65K1h","col-sm-pull-5":"bootstrap-min_col-sm-pull-5_1apGH","col-sm-pull-4":"bootstrap-min_col-sm-pull-4_396EH","col-sm-pull-3":"bootstrap-min_col-sm-pull-3_FUra_","col-sm-pull-2":"bootstrap-min_col-sm-pull-2_1BKOz","col-sm-pull-1":"bootstrap-min_col-sm-pull-1_2DHOz","col-sm-pull-0":"bootstrap-min_col-sm-pull-0_QQ9cF","col-sm-push-12":"bootstrap-min_col-sm-push-12_1u9jP","col-sm-push-11":"bootstrap-min_col-sm-push-11_3GHdj","col-sm-push-10":"bootstrap-min_col-sm-push-10_2xUJl","col-sm-push-9":"bootstrap-min_col-sm-push-9_1UJE6","col-sm-push-8":"bootstrap-min_col-sm-push-8_2kz2v","col-sm-push-7":"bootstrap-min_col-sm-push-7_rrsXw","col-sm-push-6":"bootstrap-min_col-sm-push-6_m2-NC","col-sm-push-5":"bootstrap-min_col-sm-push-5_17u76","col-sm-push-4":"bootstrap-min_col-sm-push-4_3mBe1","col-sm-push-3":"bootstrap-min_col-sm-push-3_l-nd6","col-sm-push-2":"bootstrap-min_col-sm-push-2_z7SG9","col-sm-push-1":"bootstrap-min_col-sm-push-1_2EGma","col-sm-push-0":"bootstrap-min_col-sm-push-0_Do5ZX","col-sm-offset-12":"bootstrap-min_col-sm-offset-12_1PVGs","col-sm-offset-11":"bootstrap-min_col-sm-offset-11_ySvgQ","col-sm-offset-10":"bootstrap-min_col-sm-offset-10_3Sx5Y","col-sm-offset-9":"bootstrap-min_col-sm-offset-9_10gEt","col-sm-offset-8":"bootstrap-min_col-sm-offset-8_2VYs6","col-sm-offset-7":"bootstrap-min_col-sm-offset-7_2CWQU","col-sm-offset-6":"bootstrap-min_col-sm-offset-6_UddZq","col-sm-offset-5":"bootstrap-min_col-sm-offset-5_1rW6s","col-sm-offset-4":"bootstrap-min_col-sm-offset-4_19OrJ","col-sm-offset-3":"bootstrap-min_col-sm-offset-3_3yAOW","col-sm-offset-2":"bootstrap-min_col-sm-offset-2_OolMa","col-sm-offset-1":"bootstrap-min_col-sm-offset-1_3269u","col-sm-offset-0":"bootstrap-min_col-sm-offset-0_3srlw","col-md-pull-12":"bootstrap-min_col-md-pull-12_17aJ_","col-md-pull-11":"bootstrap-min_col-md-pull-11_1fYdH","col-md-pull-10":"bootstrap-min_col-md-pull-10_3OxMg","col-md-pull-9":"bootstrap-min_col-md-pull-9_qWi1B","col-md-pull-8":"bootstrap-min_col-md-pull-8_3EnE5","col-md-pull-7":"bootstrap-min_col-md-pull-7_3vUPN","col-md-pull-6":"bootstrap-min_col-md-pull-6_wUzsR","col-md-pull-5":"bootstrap-min_col-md-pull-5_2cXmq","col-md-pull-4":"bootstrap-min_col-md-pull-4_2OzXI","col-md-pull-3":"bootstrap-min_col-md-pull-3_RIGn1","col-md-pull-2":"bootstrap-min_col-md-pull-2_3oedK","col-md-pull-1":"bootstrap-min_col-md-pull-1_1g-FU","col-md-pull-0":"bootstrap-min_col-md-pull-0_2A0D9","col-md-push-12":"bootstrap-min_col-md-push-12_1YJ2F","col-md-push-11":"bootstrap-min_col-md-push-11_1EYd8","col-md-push-10":"bootstrap-min_col-md-push-10_2rNra","col-md-push-9":"bootstrap-min_col-md-push-9_3Mpj-","col-md-push-8":"bootstrap-min_col-md-push-8_2Nep7","col-md-push-7":"bootstrap-min_col-md-push-7_1szMt","col-md-push-6":"bootstrap-min_col-md-push-6_34E2x","col-md-push-5":"bootstrap-min_col-md-push-5_2q7LJ","col-md-push-4":"bootstrap-min_col-md-push-4_3Mu2Q","col-md-push-3":"bootstrap-min_col-md-push-3_2eH1t","col-md-push-2":"bootstrap-min_col-md-push-2_2htKr","col-md-push-1":"bootstrap-min_col-md-push-1_3vVuP","col-md-push-0":"bootstrap-min_col-md-push-0_3FKdy","col-md-offset-12":"bootstrap-min_col-md-offset-12_ooTj5","col-md-offset-11":"bootstrap-min_col-md-offset-11_10zXz","col-md-offset-10":"bootstrap-min_col-md-offset-10_2KUDQ","col-md-offset-9":"bootstrap-min_col-md-offset-9_1U73N","col-md-offset-8":"bootstrap-min_col-md-offset-8_1bI0P","col-md-offset-7":"bootstrap-min_col-md-offset-7_12OD9","col-md-offset-6":"bootstrap-min_col-md-offset-6_1tMYp","col-md-offset-5":"bootstrap-min_col-md-offset-5_nW0lC","col-md-offset-4":"bootstrap-min_col-md-offset-4_1OH0A","col-md-offset-3":"bootstrap-min_col-md-offset-3_2jBMS","col-md-offset-2":"bootstrap-min_col-md-offset-2_1qLss","col-md-offset-1":"bootstrap-min_col-md-offset-1_a1cU_","col-md-offset-0":"bootstrap-min_col-md-offset-0_27Ujc","col-lg-pull-12":"bootstrap-min_col-lg-pull-12_KUCEr","col-lg-pull-11":"bootstrap-min_col-lg-pull-11_1vONa","col-lg-pull-10":"bootstrap-min_col-lg-pull-10_3DAW_","col-lg-pull-9":"bootstrap-min_col-lg-pull-9_GvsbE","col-lg-pull-8":"bootstrap-min_col-lg-pull-8_1NQmD","col-lg-pull-7":"bootstrap-min_col-lg-pull-7_2joSw","col-lg-pull-6":"bootstrap-min_col-lg-pull-6_30bHf","col-lg-pull-5":"bootstrap-min_col-lg-pull-5_2Q1PG","col-lg-pull-4":"bootstrap-min_col-lg-pull-4_1_DD6","col-lg-pull-3":"bootstrap-min_col-lg-pull-3_1wY8w","col-lg-pull-2":"bootstrap-min_col-lg-pull-2_3L6Bh","col-lg-pull-1":"bootstrap-min_col-lg-pull-1_IfZI2","col-lg-pull-0":"bootstrap-min_col-lg-pull-0_39Pxm","col-lg-push-12":"bootstrap-min_col-lg-push-12_2h3qC","col-lg-push-11":"bootstrap-min_col-lg-push-11_WmQ5z","col-lg-push-10":"bootstrap-min_col-lg-push-10_3eAhp","col-lg-push-9":"bootstrap-min_col-lg-push-9_2SixT","col-lg-push-8":"bootstrap-min_col-lg-push-8_2YnOb","col-lg-push-7":"bootstrap-min_col-lg-push-7_1BLBk","col-lg-push-6":"bootstrap-min_col-lg-push-6_2YtOf","col-lg-push-5":"bootstrap-min_col-lg-push-5_jrOde","col-lg-push-4":"bootstrap-min_col-lg-push-4_U_gW8","col-lg-push-3":"bootstrap-min_col-lg-push-3_1PJi7","col-lg-push-2":"bootstrap-min_col-lg-push-2_3ZqO9","col-lg-push-1":"bootstrap-min_col-lg-push-1_-vVN_","col-lg-push-0":"bootstrap-min_col-lg-push-0_2GtCj","col-lg-offset-12":"bootstrap-min_col-lg-offset-12_emlLY","col-lg-offset-11":"bootstrap-min_col-lg-offset-11_wIML_","col-lg-offset-10":"bootstrap-min_col-lg-offset-10__54LD","col-lg-offset-9":"bootstrap-min_col-lg-offset-9_1Vptu","col-lg-offset-8":"bootstrap-min_col-lg-offset-8_2N00B","col-lg-offset-7":"bootstrap-min_col-lg-offset-7_26O1n","col-lg-offset-6":"bootstrap-min_col-lg-offset-6_suBIH","col-lg-offset-5":"bootstrap-min_col-lg-offset-5_1PRGC","col-lg-offset-4":"bootstrap-min_col-lg-offset-4_1hi_R","col-lg-offset-3":"bootstrap-min_col-lg-offset-3_zh3Ya","col-lg-offset-2":"bootstrap-min_col-lg-offset-2_vsJLM","col-lg-offset-1":"bootstrap-min_col-lg-offset-1_2RFYq","col-lg-offset-0":"bootstrap-min_col-lg-offset-0_3Vdmy","table-condensed":"bootstrap-min_table-condensed_j18m_","table-striped":"bootstrap-min_table-striped_15ObI","table-hover":"bootstrap-min_table-hover_2boCp","active":"bootstrap-min_active_tKiHW","success":"bootstrap-min_success_tB1IK","info":"bootstrap-min_info_WNf4h","warning":"bootstrap-min_warning_1r2uJ","danger":"bootstrap-min_danger_1DCrX","table-responsive":"bootstrap-min_table-responsive_3JORC","form-control":"bootstrap-min_form-control_fANnP","input-group-sm":"bootstrap-min_input-group-sm_1YLWo","input-sm":"bootstrap-min_input-sm_OG19D","input-group-lg":"bootstrap-min_input-group-lg_3ts2N","input-lg":"bootstrap-min_input-lg_1Puif","form-group":"bootstrap-min_form-group_1njHb","checkbox":"bootstrap-min_checkbox_2O2gI","radio":"bootstrap-min_radio_2uUVY","checkbox-inline":"bootstrap-min_checkbox-inline_TucQ_","radio-inline":"bootstrap-min_radio-inline_1bnYZ","disabled":"bootstrap-min_disabled_fTMRt","form-control-static":"bootstrap-min_form-control-static_m_K3F","form-group-sm":"bootstrap-min_form-group-sm_k87hj","form-group-lg":"bootstrap-min_form-group-lg_54vYc","has-feedback":"bootstrap-min_has-feedback_1_d2h","form-control-feedback":"bootstrap-min_form-control-feedback_8gx1F","has-success":"bootstrap-min_has-success_2cW06","control-label":"bootstrap-min_control-label_1rMgt","help-block":"bootstrap-min_help-block_3SwpS","input-group-addon":"bootstrap-min_input-group-addon_2-xs1","has-warning":"bootstrap-min_has-warning_1XNx9","has-error":"bootstrap-min_has-error_gN9tV","form-inline":"bootstrap-min_form-inline_1XVYA","input-group":"bootstrap-min_input-group_3jA_e","input-group-btn":"bootstrap-min_input-group-btn_1U-0o","form-horizontal":"bootstrap-min_form-horizontal_3z8bs","focus":"bootstrap-min_focus_35glV","btn-default":"bootstrap-min_btn-default_SrZrp","open":"bootstrap-min_open_2qV1e","dropdown-toggle":"bootstrap-min_dropdown-toggle_1nQ3V","badge":"bootstrap-min_badge_3pcZA","btn-primary":"bootstrap-min_btn-primary_1uK5i","btn-success":"bootstrap-min_btn-success_2Ish5","btn-info":"bootstrap-min_btn-info_3XM44","btn-warning":"bootstrap-min_btn-warning_3IE29","btn-danger":"bootstrap-min_btn-danger_1PX1f","btn-link":"bootstrap-min_btn-link_3yKvN","btn-group-lg":"bootstrap-min_btn-group-lg_1whjW","btn-lg":"bootstrap-min_btn-lg_1NEsE","btn-group-sm":"bootstrap-min_btn-group-sm_yebtv","btn-sm":"bootstrap-min_btn-sm_3Jksh","btn-group-xs":"bootstrap-min_btn-group-xs_2a2H_","btn-xs":"bootstrap-min_btn-xs_3QLbv","btn-block":"bootstrap-min_btn-block_36r0B","fade":"bootstrap-min_fade_1rBDU","in":"bootstrap-min_in_3DlBr","collapse":"bootstrap-min_collapse_EYjfW","collapsing":"bootstrap-min_collapsing_1zNEv","dropdown":"bootstrap-min_dropdown_24B3o","dropdown-menu":"bootstrap-min_dropdown-menu_1u94g","divider":"bootstrap-min_divider_6FZNV","dropdown-menu-right":"bootstrap-min_dropdown-menu-right_3Qt2w","dropdown-menu-left":"bootstrap-min_dropdown-menu-left_3h_I_","dropdown-header":"bootstrap-min_dropdown-header_1L0Zd","dropdown-backdrop":"bootstrap-min_dropdown-backdrop_3BbhE","navbar-fixed-bottom":"bootstrap-min_navbar-fixed-bottom_Yg7pT","navbar-right":"bootstrap-min_navbar-right_3m0sO","btn-group":"bootstrap-min_btn-group_3RVt3","btn-group-vertical":"bootstrap-min_btn-group-vertical_HGkYe","btn-toolbar":"bootstrap-min_btn-toolbar_3SE_R","btn-group-justified":"bootstrap-min_btn-group-justified_23ZL9","nav":"bootstrap-min_nav_1KQTZ","nav-divider":"bootstrap-min_nav-divider_1ZSR_","nav-tabs":"bootstrap-min_nav-tabs_1DJRQ","nav-justified":"bootstrap-min_nav-justified_1auPN","nav-pills":"bootstrap-min_nav-pills_1ffn9","nav-stacked":"bootstrap-min_nav-stacked_1F6WT","nav-tabs-justified":"bootstrap-min_nav-tabs-justified_3QXW2","tab-content":"bootstrap-min_tab-content_3y46z","tab-pane":"bootstrap-min_tab-pane_2dZcs","navbar-header":"bootstrap-min_navbar-header_L89uF","navbar-collapse":"bootstrap-min_navbar-collapse_1jtm0","navbar-fixed-top":"bootstrap-min_navbar-fixed-top_3c2lb","navbar-static-top":"bootstrap-min_navbar-static-top_1sJB9","navbar-brand":"bootstrap-min_navbar-brand_3b-gG","navbar-toggle":"bootstrap-min_navbar-toggle_34NLI","icon-bar":"bootstrap-min_icon-bar_1PVWp","navbar-nav":"bootstrap-min_navbar-nav_1QAGq","navbar-form":"bootstrap-min_navbar-form_3xY8l","navbar-btn":"bootstrap-min_navbar-btn_1b34d","navbar-text":"bootstrap-min_navbar-text_1YpP7","navbar-left":"bootstrap-min_navbar-left_1MnfJ","navbar-default":"bootstrap-min_navbar-default_jwKNZ","navbar-link":"bootstrap-min_navbar-link_1jldM","navbar-inverse":"bootstrap-min_navbar-inverse_1wqmi","breadcrumb":"bootstrap-min_breadcrumb_3RoW_","pagination":"bootstrap-min_pagination_3r29R","pagination-lg":"bootstrap-min_pagination-lg_3X4yd","pagination-sm":"bootstrap-min_pagination-sm_Y_oRl","pager":"bootstrap-min_pager_2eh1o","next":"bootstrap-min_next_XiNF5","previous":"bootstrap-min_previous_27-Fe","label-default":"bootstrap-min_label-default_2Rx_c","label-primary":"bootstrap-min_label-primary_1Y34b","label-success":"bootstrap-min_label-success_3fSvo","label-info":"bootstrap-min_label-info_vEfvu","label-warning":"bootstrap-min_label-warning_1jWh_","label-danger":"bootstrap-min_label-danger_14QQ4","list-group-item":"bootstrap-min_list-group-item_fxIKy","jumbotron":"bootstrap-min_jumbotron_2S1z9","caption":"bootstrap-min_caption_3jr4A","alert":"bootstrap-min_alert_GSk2G","alert-link":"bootstrap-min_alert-link_2LKI0","alert-dismissable":"bootstrap-min_alert-dismissable_s6i63","alert-dismissible":"bootstrap-min_alert-dismissible_19VOn","close":"bootstrap-min_close_2HFpO","alert-success":"bootstrap-min_alert-success_2MpsS","alert-info":"bootstrap-min_alert-info_29gK4","alert-warning":"bootstrap-min_alert-warning_1fK7e","alert-danger":"bootstrap-min_alert-danger_1wh1S","progress":"bootstrap-min_progress_V1G4m","progress-bar":"bootstrap-min_progress-bar__HHv8","progress-bar-striped":"bootstrap-min_progress-bar-striped_2Muim","progress-striped":"bootstrap-min_progress-striped_1XpLG","progress-bar-stripes":"bootstrap-min_progress-bar-stripes_23bHI","progress-bar-success":"bootstrap-min_progress-bar-success_279Qr","progress-bar-info":"bootstrap-min_progress-bar-info__4c88","progress-bar-warning":"bootstrap-min_progress-bar-warning_22Lov","progress-bar-danger":"bootstrap-min_progress-bar-danger_1HEfZ","media":"bootstrap-min_media_1P6zp","media-body":"bootstrap-min_media-body_2-cp2","media-object":"bootstrap-min_media-object_2cN6M","media-right":"bootstrap-min_media-right_29q-_","media-left":"bootstrap-min_media-left_3Pv4P","pull-left":"bootstrap-min_pull-left_1Cf67","media-middle":"bootstrap-min_media-middle_ORtvY","media-bottom":"bootstrap-min_media-bottom_2d_VB","media-heading":"bootstrap-min_media-heading_25DM-","media-list":"bootstrap-min_media-list_3IzuH","list-group":"bootstrap-min_list-group_2z24x","list-group-item-heading":"bootstrap-min_list-group-item-heading_1B1Ss","list-group-item-text":"bootstrap-min_list-group-item-text_2FrlO","list-group-item-success":"bootstrap-min_list-group-item-success_18JZ0","list-group-item-info":"bootstrap-min_list-group-item-info_30jiO","list-group-item-warning":"bootstrap-min_list-group-item-warning_3EfCM","list-group-item-danger":"bootstrap-min_list-group-item-danger_3AWVv","panel":"bootstrap-min_panel_2CF4i","panel-body":"bootstrap-min_panel-body_27tf-","panel-heading":"bootstrap-min_panel-heading_2FUPc","panel-title":"bootstrap-min_panel-title_N7qu1","panel-footer":"bootstrap-min_panel-footer_2hbdB","panel-collapse":"bootstrap-min_panel-collapse_340M2","panel-group":"bootstrap-min_panel-group_umT4c","panel-default":"bootstrap-min_panel-default_1xVdZ","panel-primary":"bootstrap-min_panel-primary_1v4X7","panel-success":"bootstrap-min_panel-success_BvAt-","panel-info":"bootstrap-min_panel-info_37Dwx","panel-warning":"bootstrap-min_panel-warning_35gXp","panel-danger":"bootstrap-min_panel-danger_33y-k","embed-responsive":"bootstrap-min_embed-responsive_2mWeb","embed-responsive-item":"bootstrap-min_embed-responsive-item_7oAaw","embed-responsive-16by9":"bootstrap-min_embed-responsive-16by9_-ZZ25","embed-responsive-4by3":"bootstrap-min_embed-responsive-4by3_WhFn2","well":"bootstrap-min_well_2DDj4","well-lg":"bootstrap-min_well-lg_iB5Dq","well-sm":"bootstrap-min_well-sm_2ZylQ","modal-open":"bootstrap-min_modal-open_3XYl4","modal":"bootstrap-min_modal_mFY3C","modal-dialog":"bootstrap-min_modal-dialog_-nZgb","modal-content":"bootstrap-min_modal-content_35cuO","modal-backdrop":"bootstrap-min_modal-backdrop_3yf-q","modal-header":"bootstrap-min_modal-header_3JiLK","modal-title":"bootstrap-min_modal-title_12Qxl","modal-body":"bootstrap-min_modal-body_2DLlt","modal-footer":"bootstrap-min_modal-footer_3C3H3","modal-scrollbar-measure":"bootstrap-min_modal-scrollbar-measure_3UbHX","modal-sm":"bootstrap-min_modal-sm_2YqWF","modal-lg":"bootstrap-min_modal-lg_2TdQn","tooltip":"bootstrap-min_tooltip_3yKeV","top":"bootstrap-min_top_1ht4c","right":"bootstrap-min_right_tUBiK","bottom":"bootstrap-min_bottom_1KPzp","left":"bootstrap-min_left_3uQf7","tooltip-inner":"bootstrap-min_tooltip-inner_2gLo2","tooltip-arrow":"bootstrap-min_tooltip-arrow_1s8Cr","top-left":"bootstrap-min_top-left_1SDyl","top-right":"bootstrap-min_top-right_9TdAa","bottom-left":"bootstrap-min_bottom-left_2RRPv","bottom-right":"bootstrap-min_bottom-right_3GOQy","popover":"bootstrap-min_popover_3vSiu","popover-title":"bootstrap-min_popover-title_2_KP2","popover-content":"bootstrap-min_popover-content_2Z5Ln","arrow":"bootstrap-min_arrow_2j1Ku","carousel":"bootstrap-min_carousel_28ccy","prev":"bootstrap-min_prev_1IcUE","carousel-control":"bootstrap-min_carousel-control_1guaI","icon-next":"bootstrap-min_icon-next_1nFS6","icon-prev":"bootstrap-min_icon-prev_1z-5X","carousel-indicators":"bootstrap-min_carousel-indicators_3yTKT","carousel-caption":"bootstrap-min_carousel-caption_3MivW","clearfix":"bootstrap-min_clearfix_2h-1v","center-block":"bootstrap-min_center-block_1vFnD","hide":"bootstrap-min_hide_2WhOT","show":"bootstrap-min_show_21bZy","invisible":"bootstrap-min_invisible_2DJ28","text-hide":"bootstrap-min_text-hide_20Ia5","hidden":"bootstrap-min_hidden_11FJo","affix":"bootstrap-min_affix_3H11j","visible-lg":"bootstrap-min_visible-lg_EK4xH","visible-md":"bootstrap-min_visible-md_xr9eA","visible-sm":"bootstrap-min_visible-sm_3ueAL","visible-xs":"bootstrap-min_visible-xs_3MMqZ","visible-lg-block":"bootstrap-min_visible-lg-block_3PJEF","visible-lg-inline":"bootstrap-min_visible-lg-inline_1VsI9","visible-lg-inline-block":"bootstrap-min_visible-lg-inline-block_31Dfn","visible-md-block":"bootstrap-min_visible-md-block_39AQz","visible-md-inline":"bootstrap-min_visible-md-inline_1AOp4","visible-md-inline-block":"bootstrap-min_visible-md-inline-block_3B2hV","visible-sm-block":"bootstrap-min_visible-sm-block_1VE0l","visible-sm-inline":"bootstrap-min_visible-sm-inline_l9DYA","visible-sm-inline-block":"bootstrap-min_visible-sm-inline-block_35zT8","visible-xs-block":"bootstrap-min_visible-xs-block_1C-M-","visible-xs-inline":"bootstrap-min_visible-xs-inline_1l2Ip","visible-xs-inline-block":"bootstrap-min_visible-xs-inline-block_2GS-a","hidden-xs":"bootstrap-min_hidden-xs_1eNzY","hidden-sm":"bootstrap-min_hidden-sm_3o-PN","hidden-md":"bootstrap-min_hidden-md_ejbFY","hidden-lg":"bootstrap-min_hidden-lg_1LMXw","visible-print":"bootstrap-min_visible-print_30WuY","visible-print-block":"bootstrap-min_visible-print-block_1r-da","visible-print-inline":"bootstrap-min_visible-print-inline_hMQuU","visible-print-inline-block":"bootstrap-min_visible-print-inline-block_5Jj7y","hidden-print":"bootstrap-min_hidden-print_3QUBe"};

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var DeleteVariantAction = __webpack_require__(2949);
    var EditBehavior = __webpack_require__(106);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);
    var LoggedInUserState = __webpack_require__(19);
    var NavigateToExperienceAction = __webpack_require__(469);
    var Permissions = __webpack_require__(22);
    var ResourceCombined = __webpack_require__(1226);
    var SpinnerView = __webpack_require__(244);
    var SyncManager = __webpack_require__(44);
    var template = __webpack_require__(2950);
    var Tooltip = __webpack_require__(35);
    var Window = __webpack_require__(48);
    var ValidateBehavior = __webpack_require__(96);

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank;

    var ViewScope = __webpack_require__(171);
    var ExperienceModel = __webpack_require__(58);
    var WarningMessages = __webpack_require__(1205);
    var Configuration = __webpack_require__(27);
    var Storage = __webpack_require__(34);

    var MAX_NUMBER_OF_ALLOWED_VARIANTS = 12;

    /**
     * A view that represents all variant tabs for a specific breakpoint group.
     *
     * @cfg {GroupModel} model The BreakpointGroup model
     *
     * @class GroupNavView
     */
    return ImprovedView.extend({

        template: template,

        _isSpectator: null,

        _currentExperience: null,

        className: "experience-variant-control",

        experience: null,
        _designFileUIEnabled: null,

        _isNewDashboardExperience: false,

        ui: {
            pushGroupBtn: ".push-group-btn",
            addVariantIcon: ".add-variant-icon",
            experienceImportApiKey: ".import-key",
            importAction: ".btn-import-action",
            variantsRegion: ".variants-region",
            deleteBtn: ".delete-btn",
            firstLine: ".first-line .group-variants",
            secondLine: ".second-line",
            loadingSpinner: ".loading-spinner",
            parameterInputs: ".parameter-inputs input"
        },

        templateHelpers: function templateHelpers() {
            return {
                entries: this.model.getUniqueEntries(),
                currentVariant: this._currentExperience,
                spectator: this._isSpectator,
                designFileUIEnabled: this._designFileUIEnabled,
                hasMaxVariants: this._hasMaxVariants,
                groupType: this.model.getDashedType(),
                isNewDashboardExperience: this._isNewDashboardExperience
            };
        },


        events: {
            "click @ui.addVariantIcon": "addVariant",
            "click @ui.pushGroupBtn": "_pushGroup",
            "click .publish-btn": "_goToPublish",
            "click @ui.importAction": "_importActionClickHandler",
            "click .delete-btn": "_onDeleteVariantClicked",

            "click .variant-icon": function clickVariantIcon(event) {
                if (this._isBreakpointDisabledOnEmailMode()) return;

                var experienceId = event.currentTarget.getAttribute("data-experience-id");
                var eventProperties = {
                    experienceId: experienceId,
                    groupId: this.model.get("id"),
                    groupVersion: this.model.get("version"),
                    groupPushedVersion: this.model.get("pushedVersion"),
                    groupType: this.model.get("type"),
                    projectId: this.options.project && this.options.project.get("id"),
                    triggerOrigin: "VariantIcon"
                };

                EditorEvents.trigger(EditorEvents.constants.SWITCH_VARIANT, eventProperties);

                this.navigateToExperience(experienceId);
                event.preventDefault();
            }
        },

        bindings: {
            ".import-key": "experienceImportApiKey",
            ".notification-box": {
                observe: ["experienceImportApiKey"],
                updateView: false,
                visible: function visible(values) {
                    return values[0] && values[0].length >= 0 && values[1] && values[1].length >= 0;
                }
            },
            ".group-name-input": {
                observe: "name",
                updateMethod: "text",
                escape: false,
                events: ["blur"]
            }
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    ".import-key": {
                        validateAfter: "beforeSubmit",
                        model: true, // mark as bound to model, so make sure we cancel pending save requests on error!
                        validator: function validator(key) {
                            return isBlank(key) || /^\w{24,24}$/.test(key); // at least 24 word characters (upper/lowercase letters + digits)
                        },
                        errorText: function errorText() {
                            return "Not a valid Experience Id";
                        }
                    }
                }
            },
            editBehavior: {
                behaviorClass: EditBehavior,
                container: ".name-container",
                editFields: [{
                    input: ".group-name-input",
                    save: function save(value) {
                        var eventProperties = {
                            groupId: this.model.get("id"),
                            groupType: this.model.get("type"),
                            groupVersion: this.model.get("version"),
                            groupPushedVersion: this.model.get("pushedVersion"),
                            triggerOrigin: "EditGroupNameInputField",
                            quickView: false,
                            projectId: this.options.project && this.options.project.get("id"),
                            updatedProperty: "name",
                            updatedValue: value
                        };

                        EditorEvents.trigger(EditorEvents.constants.UPDATE_GROUP, eventProperties);

                        this.model.set("name", value);
                    }
                }]
            }
        },

        modelEvents: {
            "change:name": function changeName() {
                this.model.save();
            }
        },

        initialize: function initialize() {
            this._currentExperience = this.options.experience;
            this._isSpectator = Permissions.Privileges.CREATE.cannot();
            this._hasMaxVariants = this.model.getNumOfAssets() > MAX_NUMBER_OF_ALLOWED_VARIANTS;
            var settings = LoggedInUserState.get("companySettings");
            this._designFileUIEnabled = settings.get("designFileUIEnabled");
            this._isNewDashboardExperience = this.model.get('id').startsWith('C3_');
            _.bindAll(this, "_renderAndArrangeTabs", "_arrangeTabs", "_updatePushButtonAndArrangeTabs");

            this.listenTo(this._currentExperience, "change", this._updatePushButtonAndArrangeTabs);
            this.listenTo(this._currentExperience, "change:emailModeEnabled", this._isBreakpointDisabledOnEmailMode);
            this._resizeListener = Window.on("resize", this._arrangeTabs); // already bound to this above!
        },
        _importActionClickHandler: function _importActionClickHandler(event) {
            var _this = this;

            ViewScope.register(this, this);
            event.preventDefault();
            Tooltip.remove(this.ui.importAction);
            var experienceId = this.ui.experienceImportApiKey.val();

            if (experienceId && this.inputValidation()) {
                try {
                    this._currentExperience = new ExperienceModel({ id: experienceId }).fetch().then(function (experience) {
                        // this.model has the data after I fetch it
                        return _this.addVariantFromOtherExperience(experience);
                    });
                } catch (e) {
                    alert("Not a valid Experience Id!!:" + experienceId);
                }
            }
        },
        onRender: function onRender() {
            this._updatePushButton();
        },


        /**
         * Re-render the view and arrange the tabs. Note: this method is called as a promise callback, so we need
         * to check whether it is closed.
         *
         * @private
         */
        _renderAndArrangeTabs: function _renderAndArrangeTabs() {
            if (!this.isClosed) {
                this.render();
                this._arrangeTabs();
            }
        },
        _updatePushButtonAndArrangeTabs: function _updatePushButtonAndArrangeTabs() {
            // Hack: Have to wait for the css-transition on the push group button to begin,
            // otherwise the calculation in arrangeTabNavigation will go wrong.
            _.delay(this._arrangeTabs, 100);

            return this._fecthAndUpdatePushButton();
        },
        _isBreakpointDisabledOnEmailMode: function _isBreakpointDisabledOnEmailMode() {
            var emailModeEnabled = this._currentExperience.get("emailModeEnabled");
            if (emailModeEnabled) {
                this.ui.addVariantIcon.toggleClass("disabled", emailModeEnabled);
                Tooltip.create(this.ui.addVariantIcon, {
                    content: "Email mode does not support breakpoint variants. Disable Email Mode to create a breakpoint.",
                    html: true,
                    // This seems necessary to avoid Bootstrap (transition) specific errors
                    // when removing the tooltip?
                    animation: false
                });
                return true;
            }
            this.ui.addVariantIcon.toggleClass("disabled", emailModeEnabled);
            Tooltip.remove(this.ui.addVariantIcon);
            return false;
        },
        onShow: function onShow() {
            SyncManager.promise(this.model.getSortedAssets()).done(this._updatePushButtonAndArrangeTabs);
            SyncManager.onSync({
                context: this,
                target: this.model,
                method: "save",
                callback: this._renderAndArrangeTabs
            });

            this._isBreakpointDisabledOnEmailMode();
            this._arrangeTabs();
            this._addExperienceImportTooltip();
        },


        // If there is no room for the whole navigation in one line, we render the tabnavigation on a separate line
        _arrangeTabs: function _arrangeTabs() {
            this.ui.firstLine.show();
            this.ui.secondLine.hide();

            var variantsRegionHeight = this.options.editorNavBarElement.height(),
                tooNarrow = variantsRegionHeight > 45;

            if (tooNarrow) {
                this.ui.firstLine.hide();
                this.ui.secondLine.show();
            }
        },
        _fecthAndUpdatePushButton: function _fecthAndUpdatePushButton() {
            // For simplicity, we fech the group data in order to get the latest state - remember
            // that *this._currentExperience* is not directly referenced by the group, only referenced by ID in the form of "metadata".
            return this.model.fetch().always(this._updatePushButton.bind(this));
        },


        /**
         * @private
         * Initialize tooltip for copy experience button
         */
        _addExperienceImportTooltip: function _addExperienceImportTooltip() {
            Tooltip.create(this.ui.importAction, {
                content: "Copies the selected experience into this Breakpiont group.<br/>",
                html: true,
                animation: false
            });
        },


        /**
         * @private
         * Update the push button based on the states of Group model and its Experience variants.
         */
        _updatePushButton: function _updatePushButton() {
            if (this._isNewDashboardExperience) return;
            var button = this.ui.pushGroupBtn,
                pushingAssets = this.toBePushedAssets(),
                hasPushingAssets = !!_.size(pushingAssets),
                isPublisher = Permissions.Privileges.PUBLISH.can();

            if (!this.model.hasNonPushedChanges() && !hasPushingAssets || !isPublisher) {
                button.addClass("disabled").attr("disabled", "disabled");
            } else {
                button.removeClass("disabled");
                button[0].removeAttribute("disabled");

                Tooltip.remove(button);
                Tooltip.create(button, {
                    content: "The following items will be pushed: <br/>" + this._createPushedInfoTooltip(pushingAssets),
                    html: true,
                    // This seems necessary to avoid Bootstrap (transition) specific errors
                    // when removing the tooltip?
                    animation: false
                });
            }
        },


        /**
         * Creates the pushed information tooltip for the push group button.
         * @param {Object} pushingAssets the assets that need to be pushed
         * @param {Boolean} identifierInFront   whether or not the identifier string for the model
         *                                      (breakpoint no or localization type) should be placed in the front
         * @returns {String} the pushed info tooltip for the push group button.
         */
        _createPushedInfoTooltip: function _createPushedInfoTooltip(pushingAssets) {
            var _this2 = this;

            var composedTips = "";

            _.each(pushingAssets, function (asset, key) {
                var tip = _.escape(asset.get("name"));
                composedTips += (_this2.options.identifierInFront ? key + ": " + tip : tip + " (" + key + ")") + "<br/>";
            });

            // If there is a change to the group, we just inform users by list "Group data".
            if (this.model.hasNonPushedChanges()) {
                composedTips += "Group data";
            }

            return composedTips;
        },
        navigateToExperience: function navigateToExperience(experienceId) {
            var sceneNumber = this.options.viewModel.get("sceneNumber");

            new NavigateToExperienceAction(sceneNumber).execute(experienceId);
        },


        // Add variant an abstract method, should be implemented in the sub-classes
        addVariant: function addVariant() {
            throw new Error("addVariant must be implemented in sub class");
        },
        addVariantFromOtherExperience: function addVariantFromOtherExperience() {
            throw new Error("addVariantFromOtherExperience must be implemented in sub class");
        },
        _onDeleteVariantClicked: function _onDeleteVariantClicked(event) {
            event.preventDefault();
            event.stopPropagation();

            var $deleteButton = $(event.currentTarget);

            if ($deleteButton.hasClass("disabled")) {
                return;
            }

            var experienceId = $deleteButton.attr("data-experience-id"),
                variantModel = this.model,
                currentExperience = this._currentExperience,
                project = this.project,
                experiences = this._experiences;

            $deleteButton.hide();

            var $spinnerEl = $("<div></div>").addClass("loading-spinner");
            $deleteButton.after($spinnerEl);

            var spinnerView = new SpinnerView({
                el: $spinnerEl,
                lines: 8,
                length: 2,
                width: 2,
                radius: 2
            });
            spinnerView.render();

            var onMessageFetched = function onMessageFetched() {
                spinnerView.destroy();
                $deleteButton.show();
            };

            WarningMessages.fetchDeleteExperienceMessage(variantModel, variantModel.get("type")).then(function (warningMessageText) {
                onMessageFetched();

                _.delay(function () {
                    if (confirm(warningMessageText)) {
                        new DeleteVariantAction(variantModel, experienceId, project).execute().done(function () {
                            // If deleting the current experience, navigate to the first variant
                            if (currentExperience.get("id") === experienceId) {
                                return new NavigateToExperienceAction().execute(variantModel.getFirstAsset(experiences));
                            }
                        });
                    }
                }, 50);
            }).fail(function () {
                onMessageFetched();
            });
        },
        _pushGroup: function _pushGroup() {
            var _this3 = this;

            Tooltip.remove(this.ui.pushGroupBtn);

            var settings = LoggedInUserState.get("companySettings");

            return this.model.push(true) // true = with assets
            .then(function () {
                var token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
                fetch(Configuration.creatorSettingApiBaseUrl + "/v1/buildSsr?companyId=" + _this3.model.get("companyId") + "&groupId=" + _this3.model.get("id"), {
                    headers: {
                        Authorization: "Bearer " + token
                    },
                    method: "GET"
                }).catch();
                var eventProperties = {
                    groupId: _this3.model.get("id"),
                    groupType: _this3.model.get("type"),
                    groupVersion: _this3.model.get("version"),
                    groupPushedVersion: _this3.model.get("pushedVersion"),
                    projectId: _this3.options.project && _this3.options.project.get("id"),
                    triggerOrigin: "PushGroupButton"
                };

                EditorEvents.trigger(EditorEvents.constants.PUSH_GROUP, eventProperties);

                return _this3.options.pushed && _this3.options.pushed.fetchPushedOnly();
            }).then(function () {
                return _this3._updatePushButtonAndArrangeTabs();
            }).then(function () {
                if (!settings.get("combinedGroupsSpeed")) {
                    return;
                }
                return ResourceCombined.syncGroup(_this3.model.get("id"), _this3.model.get("companyId"));
            }).then(function () {
                // Reload the experience model - this will eventually trigger a sync event
                // inside the PushPublishButtonView, keeping the experience push button in sync.
                // Set triggeredByServerUpdate to avoid a potential save of the experience
                // model - see EditorController
                return _this3._currentExperience.fetch({ triggeredByServerUpdate: true });
            });
        },
        _goToPublish: function _goToPublish() {
            if (typeof this.options.project === "undefined") {
                Backbone.history.navigate("publish", true);
            } else {
                Backbone.history.navigate("#project/" + this.options.project.get("id") + "/publish", true);
            }
        },
        onClose: function onClose() {
            this._resizeListener.off();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        template = __webpack_require__(2951);

    return Marionette.ItemView.extend({

        template: template,

        className: "locale-selector",

        templateHelpers: function templateHelpers() {
            return {
                locales: this.options.locales,
                firstVariant: this.options.firstVariant,
                addVariant: this.options.addVariant
            };
        },

        events: {
            "click .variant-action": function clickVariantAction(event) {
                this._triggerHandler(event.currentTarget.getAttribute("data-locale"));
            }
        },

        _triggerHandler: function _triggerHandler(localeString) {
            this.options.selectHandler(localeString);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Events; });
var Events = {
    SWITCH_VARIANT: "SWITCH_VARIANT",
    ADD_VARIANT: "ADD_VARIANT",
    DELETE_VARIANT: "DELETE_VARIANT"
};


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        EditorEvents = __webpack_require__(17),
        Marionette = __webpack_require__(10),
        Preconditions = __webpack_require__(14);

    return Marionette.ItemView.extend("AbstractGuidelineView", {
        _newPosition: null,
        _originalClientXY: null,
        _originalPosition: null,
        _scaledExperienceWidthHeight: null,
        _tooltipElement: null,
        _viewModel: null,
        _zoomModel: null,
        _outsideSceneThreshold: 30, // How many pixels a guideline can be dragged out of the scene before deletion

        initialize: function initialize(options) {
            this._viewModel = options.viewModel;
            this._zoomModel = this._viewModel.get("zoomModel");
            this._tooltipElement = options.tooltipElement;
            _.bindAll(this, "_onMouseMove", "_onMouseUp");
        },

        events: {
            "mousedown": "_onMouseDown"
        },

        guidelineAdded: function guidelineAdded(mouseDownEvent) {
            var cursorPosition = this._getClientXY(mouseDownEvent);
            var scenePosition = Math.round(this.parentView.el.getBoundingClientRect()[this._getTopLeft()]);
            var startPosition = Math.round((cursorPosition - scenePosition) / this._zoomModel.get("scale"));
            this.model.set("position", startPosition);

            // Render the guideline to move it to the position set on the line above.
            this.render();
            this._onMouseDown(mouseDownEvent);

            this._triggerEditorEvent(EditorEvents.constants.ADD_GUIDELINE, { triggerOrigin: "ruler" });
        },

        onRender: function onRender() {
            var position = this.model.get("position");
            this._placeGuideline(position);
        },

        // Used for registering mix panel events
        _triggerEditorEvent: function _triggerEditorEvent(name, eventProperties) {
            var experience = this._viewModel.get("experience");
            var project = this._viewModel.get("project");

            eventProperties = _.defaults(eventProperties, {
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                direction: this._getDirection(),
                triggerOrigin: eventProperties.triggerOrigin
            });

            if (project) {
                eventProperties.projectId = project.get("id");
            }

            EditorEvents.trigger(name, eventProperties);
        },

        _isOutsideScene: function _isOutsideScene(scaledExperienceWidthHeight, unscaledPosition) {
            var scaledPosition = unscaledPosition * this._zoomModel.get("scale");
            var scaledOffset = this.parentView.getViewPortOffset(this._getDirection());
            var isOutside = scaledPosition - scaledOffset < 0 || scaledPosition >= scaledExperienceWidthHeight;
            return isOutside;
        },

        _isOutsideSceneThreshold: function _isOutsideSceneThreshold(scaledExperienceWidthHeight, unscaledPosition) {
            var scaledPosition = unscaledPosition * this._zoomModel.get("scale");
            var threshold = this._outsideSceneThreshold * this._zoomModel.get("scale");
            return scaledPosition < threshold * -1 || scaledPosition > scaledExperienceWidthHeight + threshold;
        },

        _onMouseDown: function _onMouseDown(e) {
            e.preventDefault();
            this.$el.addClass("guideline-dragging");

            this._originalClientXY = this._getClientXY(e);
            this._originalPosition = this.model.get("position");

            // Make sure newPosition has a value in onMouseUp even if the cursor wasn't moved.
            // This happens when the user clicks on a guideline or a ruler, without dragging.
            this._newPosition = this._originalPosition;
            this._scaledExperienceWidthHeight = this._zoomModel.get("scale") * this._viewModel.get("experience").get(this._getWidthHeight());

            this._tooltipElement.removeClass("hidden");

            this._updateTooltip(e, this._newPosition, this._scaledExperienceWidthHeight);

            // Capture the mouse events globally, because when dragging a guideline we don't want to
            // interact with anything else in the meantime.
            document.body.addEventListener("mousemove", this._onMouseMove);
            document.body.addEventListener("mouseup", this._onMouseUp);
        },

        _onMouseMove: function _onMouseMove(e) {
            var cursorMovement = (this._getClientXY(e) - this._originalClientXY) / this._zoomModel.get("scale");
            this._newPosition = Math.round(this._originalPosition + cursorMovement);

            if (this._isOutsideScene(this._scaledExperienceWidthHeight, this._newPosition)) {
                this.$el.addClass("guideline-outside");
                if (this._isOutsideSceneThreshold(this._scaledExperienceWidthHeight, this._newPosition)) {
                    this._onMouseUp();
                }
            } else {
                this.$el.removeClass("guideline-outside");
            }

            this._placeGuideline(this._newPosition);
            this._updateTooltip(e, this._newPosition, this._scaledExperienceWidthHeight);
        },

        _onMouseUp: function _onMouseUp() {
            document.body.removeEventListener("mousemove", this._onMouseMove);
            document.body.removeEventListener("mouseup", this._onMouseUp);

            this.$el.removeClass("guideline-dragging");

            if (this._isOutsideScene(this._scaledExperienceWidthHeight, this._newPosition)) {
                this.model.collection.remove(this.model);
                this._triggerEditorEvent(EditorEvents.constants.DELETE_GUIDELINE, { triggerOrigin: "guideline" });
            } else {
                // Rounding a second time just to make sure we don't get a floating point error,
                // see http://stackoverflow.com/q/1458633/37147.
                var newPosition = Math.round(this._newPosition);
                this.model.set("position", newPosition);
            }

            this._tooltipElement.addClass("hidden");
            this.parentView.trigger("guideline:moved");
        },

        _placeGuideline: function _placeGuideline(position) {
            var css = {};
            css[this._getTopLeft()] = position + "px";
            this.$el.css(css);
        },

        _updateTooltip: function _updateTooltip(e, newPosition, scaledExperienceWidthHeight) {
            this._tooltipElement.toggleClass("hidden", this._isOutsideScene(scaledExperienceWidthHeight, newPosition));

            var parentOffset = this.parentView.$el.offset();
            var tipText = this._getTooltipLabel() + newPosition + " px";

            var position = {
                left: Math.round((e.clientX - parentOffset.left + 10) / this._zoomModel.get("scale")) + "px",
                top: Math.round((e.clientY - parentOffset.top + 10) / this._zoomModel.get("scale")) + "px"
            };

            this._tooltipElement.css(position).text(tipText);
        },

        /**
         * Return e.clientX or e.clientY, depending on this being a horizontal or a vertical
         * guideline.
         * @param {jQuery.Event} e
         */
        // eslint-disable-next-line no-unused-vars
        _getClientXY: function _getClientXY(e) {
            Preconditions.abstractMethodError();
        },

        /**
         * Returns "HORIZONTAL" or "VERTICAL", depending on this being a horizontal or a vertical
         * guideline.
         */
        _getDirection: function _getDirection() {
            Preconditions.abstractMethodError();
        },

        /**
         * Return the label to prefix the tooltop with, "x: ", or "y: ", depending on this being a
         * horizontal or vertical guideline.
         */
        _getTooltipLabel: function _getTooltipLabel() {
            Preconditions.abstractMethodError();
        },

        /**
         * Return "top" or "left", depending on this being a horizontal or a vertical guideline.
         */
        _getTopLeft: function _getTopLeft() {
            Preconditions.abstractMethodError();
        },

        /**
         * Return "width" or "height", depending on this being a horizontal or a vertical
         * guideline.
         */
        _getWidthHeight: function _getWidthHeight() {
            Preconditions.abstractMethodError();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var _ = __webpack_require__(1),
        $ = __webpack_require__(4),
        Marionette = __webpack_require__(10);

    /**
     * @param {HTMLElement} el html element container
     */
    return Marionette.View.extend({
        AMOUNT_OF_MICRO_INCREMENTS_PER_INCREMENT: 9,

        SPACING_CSS_PROPERTY: null,

        DISTANCE_CSS_PROPERTY: null,

        className: "",

        MAJOR_INCREMENT_CLASS_NAME: "ruler-increment",
        MAJOR_INCREMENT_SELECTOR: ".ruler-increment",

        SUB_INCREMENT_CLASS_NAME: "ruler-sub-increment",
        SUB_INCREMENT_SELECTOR: ".ruler-sub-increment",

        /**
         * Get the increment gap for a given scaleFactor.
         * See acceptance criteria for MOS-2553.
         * @static
         * @param {Number} scaleFactor example 1 for 100%, 0.67 for 67%
         * @returns {Number} unscaled gap between major increments. `1000` for scaleFactor of 0.25, `100` for any other scaleFactor
         */
        getMajorIncrementGapPx: function getMajorIncrementGapPx(scaleFactor) {
            if (scaleFactor === 0.25) {
                return 1000;
            }

            return 100;
        },

        getSubIncrementGapPx: function getSubIncrementGapPx(scaleFactor) {
            return this.getMajorIncrementGapPx(scaleFactor) / (this.AMOUNT_OF_MICRO_INCREMENTS_PER_INCREMENT + 1); // +1 as there will be 1 more gap than markers
        },

        getDefaultRenderOptions: function getDefaultRenderOptions() {
            return {
                scale: 1,
                marginAtStartPx: 0
            };
        },

        /**
         * Create a ruler element
         * @param {Number} rulerDimensionSize example 900 for 900px ruler
         * @param {Number} scaleFactor example 1 for 100%, 0.67 for 67%
         * @returns {JQuery} jQuery `div` element containing the ruler
         */
        _createRuler: function _createRuler(rulerDimensionSize, scaleFactor) {
            var $listHtmlElement = $("<ul></ul>").addClass("list-unstyled ruler-elements-list");

            var firstIncrementValue = 0,
                lastIncrementValue = Math.floor(rulerDimensionSize / this.getMajorIncrementGapPx(scaleFactor)) * this.getMajorIncrementGapPx(scaleFactor);

            // make the numbered (major) increments and append to $html
            this._appendMajorIncrements($listHtmlElement, firstIncrementValue, rulerDimensionSize, scaleFactor);

            // make the sub-increments between 2 major increments and append to the major increments
            var $rulerIncrements = $listHtmlElement.find(this.MAJOR_INCREMENT_SELECTOR);
            this._appendSubIncrements($rulerIncrements);

            // make the sub-increments after the last major increment and prepend to the last major increment
            this._appendSubIncrementsAfterLastIncrement($listHtmlElement, rulerDimensionSize, lastIncrementValue, scaleFactor);

            // apply scaled padding
            this._applyScaledPadding($listHtmlElement, scaleFactor);

            return $("<div></div>").addClass("ruler " + this.className).append($listHtmlElement);
        },

        /**
         *
         * @param {JQuery} $listHtmlElement
         * @param {Number} scaleFactor example 0.67
         */
        _applyScaledPadding: function _applyScaledPadding($listHtmlElement, scaleFactor) {
            var self = this,
                $incrementElements = $listHtmlElement.find(this.MAJOR_INCREMENT_SELECTOR + "," + this.SUB_INCREMENT_SELECTOR);

            $incrementElements.each(function (incrementNumberFromStartOfActiveExperience, incrementElement) {
                var realPixelsAlong = incrementNumberFromStartOfActiveExperience * self.getSubIncrementGapPx(scaleFactor),
                    currentIncrementPositionAlongRuler = self._getPositionAlongRuler(realPixelsAlong, scaleFactor);

                $(incrementElement).css(self.DISTANCE_CSS_PROPERTY, currentIncrementPositionAlongRuler);
            });
        },

        /**
         * Append sub increments after the last major increment
         * @param {JQuery} $listHtmlElement
         * @param {Number} rulerHighestBound how high the ruler goes. example 85
         * @param {Number} lastIncrementValue example 80
         * @param {Number} scaleFactor example 0.67 (67%)
         */
        _appendSubIncrementsAfterLastIncrement: function _appendSubIncrementsAfterLastIncrement($listHtmlElement, rulerHighestBound, lastIncrementValue, scaleFactor) {
            var amountOfSubIncrementsAfterLastIncrement = Math.ceil((Math.abs(rulerHighestBound) - Math.abs(lastIncrementValue)) / this.getSubIncrementGapPx(scaleFactor)),
                $lastLi = $listHtmlElement.find(this.MAJOR_INCREMENT_SELECTOR).last(),
                $newSubIncrementMarkers,
                self = this;

            if (amountOfSubIncrementsAfterLastIncrement !== 0) {
                $newSubIncrementMarkers = _.range(amountOfSubIncrementsAfterLastIncrement).map(function (number) {
                    var nextIncrementIsMinorIncrement = (number + 1) % (self.AMOUNT_OF_MICRO_INCREMENTS_PER_INCREMENT + 1);

                    if (nextIncrementIsMinorIncrement !== 0) {
                        return $("<li></li>").addClass(self.SUB_INCREMENT_CLASS_NAME);
                    }

                    var value = lastIncrementValue + self.getMajorIncrementGapPx(scaleFactor);
                    return self._createIncrementMarkerListItem(value);
                });
                $lastLi.after($newSubIncrementMarkers);
            }
        },

        _createIncrementMarkerListItem: function _createIncrementMarkerListItem(value) {
            var $incrementText = $("<li></li>").addClass("ruler-px-value").text(value),
                $incrementMarker = $("<li></li>").addClass("ruler-increment-marker");

            return $("<li></li>").addClass(this.MAJOR_INCREMENT_CLASS_NAME).append($incrementText).append($incrementMarker);
        },

        /**
         * Append major increments onto an Html Element
         * @param {JQuery} $listHtmlElement `<ul>` html element
         * @param {Number} firstIncrementValue example -100
         * @param {Number} rulerHighestBound example 4650
         * @param {Number} scaleFactor example 0.67 (67%), 1 (100%)
         */
        _appendMajorIncrements: function _appendMajorIncrements($listHtmlElement, firstIncrementValue, rulerHighestBound, scaleFactor) {
            for (var incrementValue = firstIncrementValue; incrementValue <= rulerHighestBound; incrementValue += this.getMajorIncrementGapPx(scaleFactor)) {
                $listHtmlElement.append(this._createIncrementMarkerListItem(incrementValue));
            }
        },

        /**
         * Append sub-increments in place (on the existing object)
         * @param {JQuery[]} $rulerIncrements major increments on the ruler
         */
        _appendSubIncrements: function _appendSubIncrements($rulerIncrements) {
            var self = this;

            $rulerIncrements.each(function (index, element) {
                // build the last part of the ruler (after the last major increment) later on
                if (index + 1 === $rulerIncrements.length) {
                    return;
                }

                var subIncrementMarkerElements = _.range(self.AMOUNT_OF_MICRO_INCREMENTS_PER_INCREMENT).map(function () {
                    return $("<li></li>").addClass(self.SUB_INCREMENT_CLASS_NAME);
                });

                $(element).after(subIncrementMarkerElements);
            });
        },

        /**
         *
         * @param {number} realPixelsAlong pixels along in the experience (example 300 would be at the end of a 300px experience, regardless of the scaleFactor)
         * @param {number} scaleFactor 0.67 (67%), 1 (100%), 3 (300%)
         * @returns {number} scaled down pixel value
         */
        _getPositionAlongRuler: function _getPositionAlongRuler(realPixelsAlong, scaleFactor) {
            return realPixelsAlong * scaleFactor;
        },

        /**
         * @param {number[]} offsets
         */
        setMarkers: function setMarkers(offsets) {
            var self = this;

            this.$el.find(".marker").remove();

            var $markers = _.map(offsets, function (offset) {
                var $element = $("<div></div>").addClass("marker").css(self.DISTANCE_CSS_PROPERTY, offset);

                return $element;
            });

            this.$el.children(".ruler").eq(0).append($markers);
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Control = __webpack_require__(1235);
    var Controls = __webpack_require__(3008);
    var TElement = __webpack_require__(3009);
    var TGroup = __webpack_require__(718);
    var Marionette = __webpack_require__(10);
    var Preconditions = __webpack_require__(14);
    var Mouse = __webpack_require__(3010);

    /**
     * FreeTransform class manages transforming dom elements and dispatches relevant events. This
     * class is the main API that interact with other components, use this class if you need to
     * access this FreeTransform component.
     *
     * @class FreeTransform
     */
    var FreeTransform = Marionette.Controller.extend({
        // A flag to indicate whether an element has been dragged during mouse events.
        dragged: false,
        reselect: false,
        _coordinatesOnMouseDown: null,

        /**
        * @type Layer
        */
        _layer: null,

        /**
        * @type Scene
        */
        _scene: null,

        viewModel: null,

        constructor: function constructor(attrs) {
            Preconditions.checkArguments(attrs.layer);
            Preconditions.checkArguments(attrs.scene);
            Preconditions.checkArguments(attrs.viewModel);

            this._layer = attrs.layer;
            this._scene = attrs.scene;
            this.viewModel = attrs.viewModel;

            // A list of elements can be transformed.
            this.transformables = [];
            this._bindHandlers();

            this.cid = _.uniqueId("c");
        },
        _bindHandlers: function _bindHandlers() {
            this.up = this.up.bind(this);
            this.down = this.down.bind(this);
            this.move = this.move.bind(this);
        },
        setContainer: function setContainer(container) {
            this.container = container.jquery ? container[0] : container;
            this.controlsContainer = document.createElement("div");

            // No-scale class indicates that the container should be counter scaled in zooming mode.
            this.controlsContainer.className = "controls-container no-scale";
            this.container.addEventListener(Mouse.START, this.down);
            this.container.appendChild(this.controlsContainer);

            if (!this.container) {
                throw new Error("Container must be set for the FreeTransform");
            }

            this.controls = new Controls(this.controlsContainer);
        },


        /**
        * Add a transformable element to the list, so it can be transformed.
        *
        * @param {Object} ele  The dom element.
        * @param {Object} data Any data that users want to pass in, it will be accessible from
        *                      the data property of elem.
        */
        add: function add(ele, data) {
            this.transformables.push(new TElement(ele, data));
        },


        /**
        * Remove the transformable element from the transformable list, call this when the
        * element is removed from the dom.
        *
        * @param {Object} ele The dom element to be removed.
        */
        remove: function remove(ele) {
            var _this = this;

            var t = null;
            this.transformables.forEach(function (t, i) {
                if (t.domElem === ele) {
                    t = _this.transformables.splice(i, 1);
                }
            });

            if (this.controls.targetIs(t)) {
                this.controls.removeTarget();
            }
        },


        /**
        * An event trigger portal.
        *
        * @param {Event} event The event name (@see events).
        */
        triggerEvent: function triggerEvent(event) {
            var mainTarget = this.controls.target;
            var targets = [];

            if (mainTarget instanceof TGroup) {
                targets = mainTarget.members;
            } else if (mainTarget instanceof TElement) {
                targets.push(mainTarget);
            }

            this.trigger(event, targets, this, mainTarget);
        },
        getTargetWidget: function getTargetWidget() {
            return this.controls.target && this.controls.target.data && this.controls.target.data.widget ? this.controls.target.data.widget : null;
        },


        /**
        * Do some initial work when mouse is down: selecting a target and add move event
        * listener etc.
        *
        * @param {Event} event
        */
        down: function down(event) {
            // TODO: replace this hack with something a bit more programatic.
            if (!this.viewModel.get("preventSelectionChange")) {
                // Classnames of Elements are not always strings. Occasionally they are an SVGAnimatedString.
                // This happens if the element is and SVGElement.
                // See Here: https://developer.mozilla.org/en-US/docs/Web/API/Element/className
                if (event.target instanceof SVGElement || event.target.className.indexOf("image-crop") === -1) {
                    Mouse.get(event, this.container);

                    var t = this._findTopMostElem(Mouse.x, Mouse.y, event);

                    var target = this.controls.target;
                    var modifier = event.shiftKey || event.ctrlKey || event.metaKey;

                    if (target instanceof TElement && t !== target) {
                        // We need to trigger this before updateTarget call, otherwise target will be null.
                        this.triggerEvent(FreeTransform.TARGET_DESELECTED);
                    }

                    this.controls.updateTarget(t, modifier);

                    if (t) {
                        document.addEventListener(Mouse.MOVE, this.move);
                        document.addEventListener(Mouse.END, this.up);

                        this.controls.start(Mouse.x, Mouse.y);
                        this.reselect = t === target;

                        if (!this.reselect) {
                            this.triggerEvent(FreeTransform.TARGET_SELECTED);
                        }
                    }

                    this.triggerEvent(FreeTransform.MOUSEDOWN);
                    this.dragged = false;
                    // Correct (compensate) the coordinates, if zoom is used
                    var zoom = this.viewModel.get("zoomModel");

                    this._coordinatesOnMouseDown = {
                        x: Mouse.x / zoom.get("scale"),
                        y: Mouse.y / zoom.get("scale")
                    };
                }
                var targetWidget = this.getTargetWidget();
                var textWidget = targetWidget && targetWidget.model.get("type") === "text-enhanced" ? targetWidget : null;
                // Don't move the widget if the mouse is dragging inside the widget to allow for text selection.
                if (textWidget) {
                    if (event.target && !event.target.classList.contains("drag-container")) {
                        if (targetWidget.model.get("isDraggable") === true) {
                            targetWidget.model.set("isDraggable", false);
                        }
                    }
                }
            }
        },
        move: function move(event) {
            // Don't move the widget if the mouse is moving too far away from the scene.
            if (this._isMouseOutsideBoundingBox(event.clientX, event.clientY)) {
                return;
            }

            var targetWidget = this.getTargetWidget();
            var isDragEvent = this.controls.control.type === "target" || this.controls.control.type === "edgeTranslate";
            // Dragging/Scaling/Rotating/Target are all considered "move" events.
            // "target" is a move event produced by beginning the drag inside the widget (selecting text) that we block if the widget isn't draggable.
            if (isDragEvent && targetWidget && targetWidget.model.get("isDraggable") === false) {
                return;
            }

            Mouse.get(event, this.container);

            // Don't trigger a move if the cursor wasn't moved from the position when mouse
            // down was triggered. This is a workaround for this bug in Chrome:
            // https://code.google.com/p/chromium/issues/detail?id=161464
            // See also TransformTextWidget.js.
            if (this._coordinatesOnMouseDown !== null && Mouse.x === this._coordinatesOnMouseDown.x && Mouse.y === this._coordinatesOnMouseDown.y) {
                // Don't check the coordiantes once the cursor has been moved. We still want
                // the move event if the cursor is moved back to the original position.
                this._coordinatesOnMouseDown = null;

                return;
            }

            this.controls.move(Mouse.x, Mouse.y);
            // Fire some events.
            switch (this.controls.control.type) {
                case Control.EDGE_TRANSLATE:
                case Control.TARGET:
                    this.triggerEvent(FreeTransform.TARGET_TRANSLATING);
                    break;

                case Control.ROTATE:
                    this.triggerEvent(FreeTransform.TARGET_ROTATING);
                    break;

                default:
                    this.triggerEvent(FreeTransform.TARGET_SCALING);
            }
            this.triggerEvent(FreeTransform.TARGET_TRANSFORMING);

            this.dragged = true;
            event.preventDefault();
        },
        setBoundingBoxProvider: function setBoundingBoxProvider(providerFunction) {
            Preconditions.isFunction(providerFunction);
            this._viewportBoundingBoxProvider = providerFunction;
        },


        /**
        * @private
        *
        * Whether the specified coordinates are outside the current bounding box.
        *
        * @param  {Number}  mouseX The horizontal coordinate within the application's client
        *                          area at which the event occurred.
        *
        * @param  {Number}  mouseY The vertical coordinate within the application's client
        *                          area at which the event occurred.
        *
        * @return {Boolean}        <tt>true</tt> if the specified coordinates are outside the
        *                          current bounding box, <tt>false</tt> if not.
        */
        _isMouseOutsideBoundingBox: function _isMouseOutsideBoundingBox(mouseX, mouseY) {
            if (!this._viewportBoundingBoxProvider) {
                return false;
            }

            var bounds = this._viewportBoundingBoxProvider();

            return mouseX < bounds.left || mouseX > bounds.right || mouseY < bounds.top || mouseY > bounds.bottom;
        },
        up: function up(event) {
            document.removeEventListener(Mouse.MOVE, this.move);
            document.removeEventListener(Mouse.END, this.up);

            if (this.dragged) {
                // Only the mouse has been moved, can we safely assume that the target has been transformed.
                this.triggerEvent(FreeTransform.TARGET_TRANSFORMING_END);
            } else if (this.reselect) {
                this.triggerEvent(FreeTransform.TARGET_RESELECTED);
            }

            if (this.controls.isTransformed()) {
                this.triggerEvent(FreeTransform.TARGET_TRANSFORMED);
            }

            var targetWidget = this.getTargetWidget();
            if (targetWidget && targetWidget.model.get("isDraggable") === false) {
                targetWidget.model.set("isDraggable", true);
            }

            this.controls.end();
            event.preventDefault();
        },


        /**
        * Select a/multiple element(s).
        *
        * @param {Object} elems transformable elements {@link TElement} or dom elements.
        */
        select: function select(elems) {
            var _this2 = this;

            elems = _.isArray(elems) ? elems : [elems];

            // map to transformable elements if they are raw dom elements, else return itself.
            var transformables = _.map(elems, function (elem) {
                if (_this2._isDomElement(elem)) {
                    elem = _this2._findByDomElem(elem);
                }

                return elem;
            });

            var newTarget = _.compact(transformables).length > 1 ? new TGroup(transformables) : transformables[0];
            if (newTarget) {
                this.controls.setTarget(newTarget);

                this.triggerEvent(FreeTransform.TARGET_SELECTED);
            }
        },


        /**
        * Find a transformable element by a dom element.
        *
        * @param {Object} elem
        * @returns {TElement} Transformable element if found, otherwise undefined
        */
        _findByDomElem: function _findByDomElem(elem) {
            return _.find(this.transformables, function (tran) {
                return tran.domElem === elem;
            });
        },


        /**
        * Find a transformable element by a widget uuid.
        *
        * @param {String} uuid
        * @returns {TElement} Transformable element if found, otherwise undefined
        */
        _findByUuid: function _findByUuid(uuid) {
            // check widgets in selecting layer for a uuid match and return the dom element from findByDomElem
            return _.find(this.transformables, function (tran) {
                return tran.data && tran.data.widget && tran.data.widget.model.get("uuid") === uuid;
            });
        },


        /**
        * Find the transformable element with highest z-index at point x and y.
        *
        * @param {Number} x X-coordinate relative to the scene.
        * @param {Number} y Y-coordinate relative to the scene.
        * @returns the {@link Transformable}transformable element
        */
        _findTopMostElem: function _findTopMostElem(x, y, event) {
            var _this3 = this;

            var currentlyChosenElement = null;
            var scale = this.controls.scale;
            var target = this.controls.target;

            if (this._layer !== this.viewModel.get("currentLayer")) {
                return null; // widget on different layer to active layer.
            }

            if (parseInt(this._scene.get("sceneNumber"), 10) !== parseInt(this.viewModel.get("sceneNumber"), 10)) {
                return null; // widget on different scene to active scene.
            }

            // If a non-translate control on the currently selected target is clicked, treat it
            // as topmost.
            if (target && this.controls.getControlAt(x, y)) {
                return target;
            }

            this.transformables
            // do not consider locked widgets as selectable elements
            .filter(function (element) {
                return !element.data.widget.model.get("isLocked");
            }).forEach(function (element) {
                var elementPositionMatrix = element.getMatrixWithParentOffset();
                elementPositionMatrix.x *= scale;
                elementPositionMatrix.y *= scale;

                if (elementPositionMatrix.containsPoint(x, y, element.getWidth() * scale, element.getHeight() * scale)) {
                    if (_this3._isTopmostElementOfGroup(currentlyChosenElement, element)) {
                        currentlyChosenElement = element;
                    }
                } else if (_this3._hasTab(element)) {
                    var _element$data$widget$ = element.data.widget.options.tabProperties,
                        yOffset = _element$data$widget$.yOffset,
                        width = _element$data$widget$.width,
                        height = _element$data$widget$.height;

                    if (elementPositionMatrix.containsPoint(x, y + yOffset, width, height)) {
                        if (_this3._isTopmostElementOfGroup(currentlyChosenElement, element)) {
                            currentlyChosenElement = element;
                        }
                    }
                } else if (!currentlyChosenElement) {
                    var targetElement = document.elementFromPoint(event.clientX, event.clientY);
                    if (targetElement.classList.contains("drag-container")) {
                        var containedElement = _this3._findByUuid(targetElement.dataset.containedWidgetUuid);
                        if (_this3._isTopmostElementOfGroup(currentlyChosenElement, containedElement)) {
                            currentlyChosenElement = containedElement;
                        }
                    }
                }
            });

            return currentlyChosenElement;
        },


        // Widgets have a property on them that answers if it has a tab or not
        _hasTab: function _hasTab(element) {
            return element.data.widget.options.hasTab;
        },
        _isTopmostElementOfGroup: function _isTopmostElementOfGroup(currentElement, element) {
            return !currentElement || currentElement.getZIndex() < element.getZIndex();
        },


        /**
        * Check if an element is a raw dom element.
        *
        * @param {Object }elem
        * @returns {Boolean} true if it is a dom element, false otherwise.
        */
        _isDomElement: function _isDomElement(elem) {
            return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === "object" ? elem instanceof HTMLElement : // DOM2.
            elem && (typeof elem === "undefined" ? "undefined" : _typeof(elem)) === "object" && elem !== null && elem.nodeType === 1 && typeof elem.nodeName === "string";
        },


        // Update controls to reflect any changes to the elements call this when the target is
        // transformed/modified externally.
        updateControls: function updateControls(scale) {
            if (this.controls) {
                this.controls.updateFromTarget(scale);
            }
        },


        // Hide all the controls
        hideControls: function hideControls() {
            this.controls.hide();
        },
        setClass: function setClass(value) {
            this.controls.setControlClass(value);
        },
        removeClass: function removeClass(value) {
            if (this.controls) {
                this.controls.removeControlClass(value);
            }
        },
        hasTarget: function hasTarget() {
            return this.controls.hasTarget();
        },
        deselect: function deselect() {
            this.triggerEvent(FreeTransform.TARGET_DESELECTED);
            this.controls.removeTarget();
        },


        /**
        * Move/translate the current target by x and y
        *
        * @param {Number} x
        * @param {Number} y
        */
        translate: function translate(x, y) {
            if (this.controls.target) {
                this.controls.translate(x, y);
                this.triggerEvent(FreeTransform.TARGET_TRANSFORMED);
            }
        }
    }, {
        TARGET_SELECTED: "select_target",
        TARGET_DESELECTED: "deselect_target",
        TARGET_RESELECTED: "reselect_target",
        TARGET_TRANSFORMED: "target_transformed",
        TARGET_TRANSFORMING: "transforming",
        TARGET_TRANSFORMING_END: "transforming_end",
        TARGET_TRANSLATING: "translating",
        TARGET_ROTATING: "rotating",
        TARGET_SCALING: "scaling",
        MOUSEDOWN: "mouse_down"
    });

    return FreeTransform;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var TGroup = __webpack_require__(718);

    var pointInsideRect = __webpack_require__(72).default.pointInsideRect;

    var _require = __webpack_require__(1),
        find = _require.find;

    /**
     * Control class used as a control point in transformation
     * the transformation handlers are made up several controls, @see{Controls} class
     *
     * @param type
     * @param u
     * @param v
     * @param offsetX
     * @param offsetY
     * @param cursor
     * @constructor
     */


    function Control(type, u, v, offsetX, offsetY, cursor) {
        this.element = null;
        this.type = type;

        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.matrix = null;

        this.offsetX = offsetX || 0;
        this.offsetY = offsetY || 0;

        this.size = 8;
        this.shape = null;

        this.cursor = cursor;

        this.u = u;
        this.v = v;

        this.id = Control.idPrefix + ++Control.idCounter;
        this.setDefaultShape();
    }

    Control.SCALE = "scale";
    Control.SCALE_X = "scaleX";
    Control.SCALE_Y = "scaleY";
    Control.ROTATE = "rotate";
    Control.SKEW_X = "skewX";
    Control.SKEW_Y = "skewY";
    Control.BORDER = "border";
    Control.TARGET = "target";
    Control.REGISTRATION = "registration";
    Control.SCALE_UNIFORM = "scaleUniform";
    Control.ROTATE_SCALE = "rotateScale";
    Control.EDGE_TRANSLATE = "edgeTranslate"; // Enables translation outside of the target area

    Control.SHAPE_CIRCLE = "circle";
    Control.SHAPE_SQUARE = "square";
    Control.SHAPE_BORDER = "border";
    Control.SHAPE_NONE = "none";

    Control.idCounter = 0;
    Control.idPrefix = "tran-control-";

    Control.prototype = {
        setDefaultShape: function setDefaultShape() {
            switch (this.type) {
                case Control.ROTATE:
                case Control.ROTATE_SCALE:
                    this.shape = Control.SHAPE_CIRCLE;
                    break;

                case Control.SCALE:
                case Control.SCALE_UNIFORM:
                case Control.SCALE_X:
                case Control.SCALE_Y:
                case Control.SKEW_X:
                case Control.SKEW_Y:
                    this.shape = Control.SHAPE_SQUARE;
                    break;

                case Control.EDGE_TRANSLATE:
                    this.shape = Control.SHAPE_NONE;
                    break;

                case Control.BORDER:
                    this.shape = Control.SHAPE_BORDER;
                    break;

                default:
                    break;
            }
        },


        /**
         * Update `this` control's position.
         *
         * @param {Matrix} matrix - The matrix of the target.
         * @param {Number} width - The width of the target.
         * @param {Number} height - The height of the target.
         */
        updatePosition: function updatePosition(matrix, width, height) {
            var _computePositionFromT = this.computePositionFromTargetMatrix(matrix, width, height),
                x = _computePositionFromT.x,
                y = _computePositionFromT.y;

            this.x = x;
            this.y = y;

            switch (this.shape) {
                case Control.SHAPE_CIRCLE:
                case Control.SHAPE_SQUARE:
                    {
                        this.element.style.left = this.x - this.size / 2 + "px";
                        this.element.style.top = this.y - this.size / 2 + "px";
                        this.element.style.transform = "rotate(" + matrix.getRotation() + "deg)";
                        break;
                    }

                case Control.SHAPE_BORDER:
                    {
                        var appliedMatrix = matrix.clone();
                        var leftTop = appliedMatrix.getGlobalCoordByLocalCoord(-1, -1);

                        appliedMatrix.x = leftTop.x;
                        appliedMatrix.y = leftTop.y;
                        this.width = width + 2;
                        this.height = height + 2;

                        this.element.style.width = this.width + "px";
                        this.element.style.height = this.height + "px";
                        this.element.style.transform = appliedMatrix.toString();
                        break;
                    }

                case Control.SHAPE_NONE:
                    {
                        this.width = width + Math.abs(this.offsetX * 2);
                        this.height = height + Math.abs(this.offsetY * 2);
                        this.element.style.left = this.x + "px";
                        this.element.style.top = this.y + "px";
                        this.element.style.width = this.width + "px";
                        this.element.style.height = this.height + "px";
                        this.element.style.transform = "rotate(" + matrix.getRotation() + "deg)";
                        break;
                    }

                default:
                    break;
            }

            this.updateCursor(matrix);
        },
        setDisplay: function setDisplay(value) {
            if (this.element) {
                this.element.style.display = value;
            }
        },
        setClass: function setClass(value) {
            if (this.element) {
                this.element.classList.add(value);
            }
        },
        removeClass: function removeClass(value) {
            if (this.element) {
                this.element.classList.remove(value);
            }
        },


        /**
         * Update cursor of this control when rotating
         * @param matrix
         */
        updateCursor: function updateCursor(matrix) {
            var tempRotate = matrix.getRotation();
            var rotate = tempRotate < 0 ? tempRotate + 360 : tempRotate;
            var indicators = ["nw", "n", "ne", "e", "se", "s", "sw", "w"]; // n is abbreviation of north, ne = north east, etc.
            var ranges = [22.5, 67.5, 112.5, 157.5, 202.5, 247.5, 292.5, 337.5];

            var index = 0;
            var n = void 0;
            var i = void 0;

            for (i = 0; i < 8; i++) {
                if (rotate < ranges[i]) {
                    index = i;
                    break;
                }
            }

            n = indicators.indexOf(this.cursor);

            if (n !== -1) {
                n = index + n;
                n = n > 7 ? n - 8 : n;
                this.element.style.cursor = indicators[n] + "-resize";
            }
        },
        draw: function draw(container) {
            if (container.getElementsByClassName(this.id)[0]) {
                // no need to draw again
                return;
            }

            if (this.type === Control.ROTATE_SCALE) {
                this.size = 10;
            }

            if (this.shape) {
                this.element = document.createElement("div");
                this.element.className = this.id + " " + this.shape + " " + this.toDashedName(this.type);
                this.element.style.width = this.size + "px";
                this.element.style.height = this.size + "px";
                this.element.style.display = "none";
                container.appendChild(this.element);
            }
        },
        undraw: function undraw() {
            var elem = this.element;
            if (elem && elem.parentNode) {
                elem.parentNode.removeChild(elem);
            }
        },
        toDashedName: function toDashedName(name) {
            return name.replace(/([A-Z])/g, function ($1) {
                return "-" + $1.toLowerCase();
            });
        },
        insideEdge: function insideEdge(collisionPoint, edgeRect, angle) {
            var innerRect = {
                width: edgeRect.width + this.offsetX * 2,
                height: edgeRect.height + this.offsetY * 2,
                x: edgeRect.x - this.offsetX,
                y: edgeRect.y - this.offsetY
            };

            var collidesWithEdgeRect = pointInsideRect(edgeRect, collisionPoint, angle);
            var collidesWithInnerRect = pointInsideRect(innerRect, collisionPoint, angle, { x: edgeRect.x, y: edgeRect.y });

            return collidesWithEdgeRect && !collidesWithInnerRect;
        },
        computePositionFromTargetMatrix: function computePositionFromTargetMatrix(matrix, width, height) {
            var w = width * this.u;
            var h = height * this.v;

            var x = matrix.x + matrix.a * w + matrix.c * h;
            var y = matrix.y + matrix.d * h + matrix.b * w;

            // offset
            var angle = void 0;

            if (this.offsetX) {
                angle = matrix.getRotationX();
                x += this.offsetX * Math.cos(angle);
                y += this.offsetX * Math.sin(angle);
            }
            if (this.offsetY) {
                angle = matrix.getRotationY();
                x += this.offsetY * Math.sin(angle);
                y += this.offsetY * Math.cos(angle);
            }

            return { x: x, y: y };
        },


        /**
         * @typedef {Object} TranslateBounds
         * @property {Number} x - The x coordinate.
         * @property {Number} y - The y coordinate.
         * @property {Number} width - The width.
         * @property {Number} height - The height.
         * @property {Number} angle - The angle, in degrees.
         */

        /**
         * From the current target, populates an array of rectangular bounds, representing the current selected widgets bounds.
         *
         * @param {TElement|TGroup} target The current target.
         * @return {TranslateBounds[]} Array of bounds.
         */
        parseEdgeTranslateTarget: function parseEdgeTranslateTarget(target) {
            var _this = this;

            var getAngle = function getAngle(element) {
                return element.getMatrix().getRotation() * -1;
            };

            if (target instanceof TGroup) {
                return target.members.map(function (element) {
                    var _computePositionFromT2 = _this.computePositionFromTargetMatrix(element.getMatrix(), _this.width, _this.height),
                        x = _computePositionFromT2.x,
                        y = _computePositionFromT2.y;

                    return {
                        width: element.width - _this.offsetX * 2,
                        height: element.height - _this.offsetY * 2,
                        x: x,
                        y: y,
                        angle: getAngle(element)
                    };
                });
            }
            return [{
                width: this.width,
                height: this.height,
                x: this.x,
                y: this.y,
                angle: getAngle(target)
            }];
        },


        /**
         * Check if the point(x, y) is within the range of this control area
         *
         * @param x
         * @param y
         * @returns {boolean} true if yes, false no
         */
        contains: function contains(x, y, target) {
            var _this2 = this;

            var visible = this.element && this.element.style.display !== "none";

            // Explicitly check for edge collision.
            if (this.type === Control.EDGE_TRANSLATE) {
                var collisionPoint = { x: x, y: y };
                var targetBounds = this.parseEdgeTranslateTarget(target);
                var inside = !!find(targetBounds, function (rect) {
                    return _this2.insideEdge(collisionPoint, rect, rect.angle);
                });

                return inside && visible;
            }

            var cx = Math.abs(this.x - x);
            var cy = Math.abs(this.y - y);
            var sr = this.size / 2;

            return cx < sr && cy < sr && visible;
        }
    };

    return Control;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Matrix = __webpack_require__(204);

    /**
     * A Transformable is an abstract class that defines a element can be transformed
     * @constructor
     */
    function Transformable() {
        this.matrix = new Matrix();
        this.startMatrix = new Matrix();
        this.endMatrix = new Matrix();
    }

    Transformable.prototype = {
        draw: function draw() {},
        getControlsConf: function getControlsConf() {},
        getWidth: function getWidth() {},
        getHeight: function getHeight() {},
        getMatrix: function getMatrix() {},
        setTransparency: function setTransparency() {},
        getCornerCoordinates: function getCornerCoordinates() {
            var m = this.matrix;
            return [{ x: m.x, y: m.y }, m.getGlobalCoordByLocalCoord(this.width, 0), m.getGlobalCoordByLocalCoord(this.width, this.height), m.getGlobalCoordByLocalCoord(0, this.height)];
        },
        transform: function transform(preMatrix, postMatrix, regU, regV) {
            // apply transforms (pre, post)
            this.endMatrix.identity();
            this.endMatrix.concat(preMatrix);
            this.endMatrix.concat(this.startMatrix);

            // next, the post transform is concatenated on top
            // of the previous result, but for the post transform,
            // translation (x,y) values are not transformed. They're
            // saved with the respective post transform offset, then
            // reassigned after concatenating the post transformation
            var x = this.endMatrix.x + postMatrix.x;
            var y = this.endMatrix.y + postMatrix.y;

            // finally, concatenate post transform on to final
            this.endMatrix.concat(postMatrix);

            // reassign saved tx and ty values with the
            // included registration offset
            this.endMatrix.x = x;
            this.endMatrix.y = y;

            if (regU !== 0 || regV !== 0) {
                // registration offset
                // local registration location
                x = regU * this.width;
                y = regV * this.height;
                // delta transform by start matrix
                var rx = this.startMatrix.a * x + this.startMatrix.c * y;
                var ry = this.startMatrix.d * y + this.startMatrix.b * x;
                // subtract delta transform end matrix
                rx -= this.endMatrix.a * x + this.endMatrix.c * y;
                ry -= this.endMatrix.d * y + this.endMatrix.b * x;
                // shift by remaining
                this.endMatrix.translate(rx, ry);
            }

            this.matrix.copyFrom(this.endMatrix);
            this.draw();
        },
        translate: function translate(x, y) {
            this.matrix.x += x;
            this.matrix.y += y;
            this.draw();
        },
        isTransformed: function isTransformed() {
            return !this.startMatrix.equals(this.matrix);
        },


        /**
         * This is to cope with that objects may be transformed outside FreeTransform
         * so we need to update the width, height and matrix whenever we start transforming
         */
        updateFromTarget: function updateFromTarget() {
            this.width = this.getWidth();
            this.height = this.getHeight();
            this.matrix = this.getMatrix();
        },
        commit: function commit() {
            this.startMatrix.copyFrom(this.matrix);
            this.sanitizeStartMatrix();
        },
        sanitizeStartMatrix: function sanitizeStartMatrix() {
            if (this.startMatrix.a === 0 && this.startMatrix.b === 0) {
                this.startMatrix.a = 1 / this.getWidth();
            }

            if (this.startMatrix.d === 0 && this.startMatrix.c === 0) {
                this.startMatrix.d = 1 / this.getHeight();
            }
        }
    };

    return Transformable;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Matrix = __webpack_require__(204);
    var $ = __webpack_require__(4);

    /** @typedef {{x: number, y: number}} Coordinate */

    var SnapUtils = function () {
        function SnapUtils() {
            _classCallCheck(this, SnapUtils);
        }

        _createClass(SnapUtils, null, [{
            key: "getRoundedCornerCoordinatesFromDom",

            /**
             * @static
             * Create an Array of 4 coordinates from a DOMElement
             * in this order top-left,top-right,bottom-left,bottom-right
             * @return {Array<Coordinate>}
             */
            value: function getRoundedCornerCoordinatesFromDom(el) {
                var $el = $(el);
                var matrix = Matrix.createFromDom($el[0]);
                var width = $el.outerWidth();
                var height = $el.outerHeight();
                var nonRoundedCoordinates = [matrix.getGlobalCoordByLocalCoord(0, 0), // top left
                matrix.getGlobalCoordByLocalCoord(width, 0), // top right
                matrix.getGlobalCoordByLocalCoord(0, height), // bottom left
                matrix.getGlobalCoordByLocalCoord(width, height) // bottom right
                ];
                return nonRoundedCoordinates.map(SnapUtils.roundCoordinate);
            }

            /**
             * @static
             * Round the values of an object
             * @param {Coordinate} coord
             * @return {Coordinate}
             */

        }, {
            key: "roundCoordinate",
            value: function roundCoordinate(coord) {
                return {
                    x: Math.round(coord.x),
                    y: Math.round(coord.y)
                };
            }
        }]);

        return SnapUtils;
    }();

    return SnapUtils;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var template = __webpack_require__(3019),
        EditorEvents = __webpack_require__(17),
        ImprovedView = __webpack_require__(6),
        Keyboard = __webpack_require__(243),
        _ = __webpack_require__(1),
        Storage = __webpack_require__(34);

    /**
     * The zoom control view.
     *
     * @class ZoomView
     * @constructor
     *
     * @cfg {ZoomModel} model The zoom model.
     */
    return ImprovedView.extend({

        template: template,

        _zoomModel: null,

        zoomBinding: {
            ".zoom-percent": {
                observe: "scale",
                onGet: function onGet(scale) {
                    var percentage = Math.round(scale * 100) + "%";

                    return percentage;
                }
            },
            ".zoom-in": {
                attributes: [{
                    name: "disabled",
                    observe: "scale",
                    onGet: function onGet() {
                        var disable = "";

                        if (this._zoomModel !== null && this._zoomModel.isMaxScale()) {
                            disable = "disabled";
                        }

                        return disable;
                    }
                }]
            },
            ".zoom-out": {
                attributes: [{
                    name: "disabled",
                    observe: "scale",
                    onGet: function onGet() {
                        var disable = "";

                        if (this._zoomModel !== null && this._zoomModel.isMinScale()) {
                            disable = "disabled";
                        }

                        return disable;
                    }
                }]
            },
            ".reset-zoom": {
                attributes: [{
                    name: "disabled",
                    observe: "scale",
                    onGet: function onGet() {
                        var disable = "";

                        if (this._zoomModel === null || this._zoomModel.get("scale") === 1) {
                            disable = "disable";
                        }

                        return disable;
                    }
                }]
            }
        },

        events: {
            "click .zoom-in": "_clickZoomInHandler",
            "click .zoom-out": "_clickZoomOutHandler",
            "click .reset-zoom": "_clickResetZoomHandler"
        },

        /**
         * Click handlers for the zoom buttons
         */
        _clickZoomInHandler: function _clickZoomInHandler() {
            this._zoomModel.scaleUp();
            EditorEvents.trigger(this.options.event, {
                zoomType: "in",
                triggerOrigin: "ZoomInButton"
            });
        },

        _clickZoomOutHandler: function _clickZoomOutHandler() {
            this._zoomModel.scaleDown();
            EditorEvents.trigger(this.options.event, {
                zoomType: "out",
                triggerOrigin: "ZoomOutButton"
            });
        },

        _clickResetZoomHandler: function _clickResetZoomHandler() {
            this._zoomModel.reset();
            EditorEvents.trigger(this.options.event, {
                zoomType: "reset",
                triggerOrigin: "ZoomResetButton"
            });
        },

        initialize: function initialize() {
            this._zoomModel = this.options.zoomModel;

            var experienceId = this.options.experienceId;

            _.bindAll(this, "_clickZoomInHandler", "_clickZoomOutHandler", "_clickResetZoomHandler");

            if (this.options.persistZoom) {
                // Keep track of the scale factor
                this.listenTo(this._zoomModel, "change:scale", function (model, value) {
                    Storage.Local.update(Storage.Keys.EDITOR, experienceId + "-scaleFactor", value);
                });
            }
        },

        onRender: function onRender() {
            this.stickit(this._zoomModel, this.zoomBinding);

            Keyboard.Shortcut.bind("+", this._clickZoomInHandler);
            Keyboard.Shortcut.bind("-", this._clickZoomOutHandler);
            Keyboard.Shortcut.bind("0", this._clickResetZoomHandler);
        },

        onClose: function onClose() {
            Keyboard.Shortcut.unbind("+", this._clickZoomInHandler);
            Keyboard.Shortcut.unbind("-", this._clickZoomOutHandler);
            Keyboard.Shortcut.unbind("0", this._clickResetZoomHandler);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB_ORDER_ENABLED", function() { return TAB_ORDER_ENABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TAB_ORDER_REMOVED", function() { return TAB_ORDER_REMOVED; });
//
var TAB_ORDER_ENABLED = "tabOrderEnabled";
var TAB_ORDER_REMOVED = "tabOrderRemoved";


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Backbone = __webpack_require__(7);

    /**
     * The model for keeping the zoom property for the preview and the editor.
     *
     * @author Jens Svensson
     * @class ZoomModel
     * @constructor
     */
    return Backbone.Model.extend({
        defaults: {
            scale: 1
        },

        // Scale factor which translates to zoom percentage, 0.25 = 25%, 0.33 = 33 % and so on.
        SCALE_RANGE: [0.25, 0.33, 0.5, 0.67, 0.75, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2, 3, 4],

        scaleUp: function scaleUp() {
            var index = _.indexOf(this.SCALE_RANGE, this.get("scale")),
                next = Math.min(this.SCALE_RANGE.length - 1, index + 1);

            this.set("scale", this.SCALE_RANGE[next]);
        },

        scaleDown: function scaleDown() {
            var index = _.indexOf(this.SCALE_RANGE, this.get("scale")),
                prev = Math.max(0, index - 1);

            this.set("scale", this.SCALE_RANGE[prev]);
        },

        reset: function reset() {
            this.set("scale", 1);
        },

        isMaxScale: function isMaxScale() {
            return this.get("scale") === _.last(this.SCALE_RANGE);
        },

        isMinScale: function isMinScale() {
            return this.get("scale") === _.first(this.SCALE_RANGE);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ExperienceURLProvider = __webpack_require__(168),
        NavBarView = __webpack_require__(461),
        ShareButton = __webpack_require__(1221),
        template = __webpack_require__(3039),
        EditorEvents = __webpack_require__(17),
        ZoomView = __webpack_require__(1238);

    /**
     * The nav bar view for experience preview.
     *
     * @class PreviewNavBarView
     * @constructor
     *
     * @cfg {ExperienceViewModel} model The experience view model.
     */
    return NavBarView.extend({

        template: template,

        _zoomModel: null,

        className: "nav-bar preview-nav-bar",

        keyboard: {
            escape: function escape() {
                var experienceURL = ExperienceURLProvider.provide(this.model.get("experienceId"), ExperienceURLProvider.ACTION.EDIT, this.model.get("currentScene"));
                Backbone.history.navigate(experienceURL, true);
            }
        },

        bindings: {
            ".return-to-editor": {
                attributes: [{
                    observe: "currentScene",
                    name: "href",
                    onGet: function onGet(sceneNumber) {
                        return "#" + ExperienceURLProvider.provide(this.model.get("experienceId"), ExperienceURLProvider.ACTION.EDIT, sceneNumber, this.model.get("editorCurrentLayer").value);
                    }
                }]
            }
        },

        regions: {
            zoomRegion: ".zoom-region"
        },

        ui: {
            shareButton: ".share-button"
        },

        templateHelpers: function templateHelpers() {
            return {
                variants: this.options.variants,
                currentId: this.model.get("experienceId")
            };
        },

        initialize: function initialize() {
            this._zoomModel = this.options.zoomModel;
        },

        onRender: function onRender() {
            this.zoomRegion.show(new ZoomView({
                zoomModel: this._zoomModel,
                persistZoom: false,
                experienceId: this.model.get("experience").get("id"),
                event: EditorEvents.constants.ZOOM_PREVIEW
            }));

            this.addRegions({ "shareButton": ".share-button" });
            this.shareButton.show(new ShareButton({
                experience: this.model.get("experience"),
                offset: {
                    align: "right",
                    elementWidth: 75
                },
                triggerOrigin: "viewer",
                route: null
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        listTemplate = __webpack_require__(3068),
        template = __webpack_require__(3069),
        Tooltip = __webpack_require__(35);

    return ImprovedView.extend({
        template: template,

        ui: {
            lockIcon: ".lock-icon"
        },

        tagName: "span",

        className: "custom-js-lock-container",

        onRender: function onRender() {
            var experiences = this.viewScope.experiences();

            Tooltip.add(this.ui.lockIcon, {
                trigger: "dropdown",
                placement: "top",
                container: this.$el,
                width: 250,
                html: true,
                classes: "custom-js-lock-list",
                duration: 0,
                content: listTemplate({
                    // Get experiences from ids
                    experiences: this.options.ids.map(experiences.get.bind(experiences))
                })
            });
        },

        onClose: function onClose() {
            Tooltip.remove(this.ui.lockIcon);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        ContentItemView = __webpack_require__(704),
        template = __webpack_require__(3082);

    /**
     * Abstract <tt>ContentItemView</tt> subclass for project dashboards.
     *
     * @see ProjectDashboardContentItemView
     * @see ProjectAttachContentItemView
     *
     * @class ProjectContentItemView
     */
    return ContentItemView.extend({

        template: template,

        viewOptions: {
            showExperienceActionsPanel: true,
            showSelectIndicator: false
        },

        templateHelpers: function templateHelpers() {
            // Pass the viewOptions to the template
            return _.extend(this.__super(), this.viewOptions);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showImageActionsPanel) { ;
__p += '\n    <div class="actions-panel">\n        ';
 if (isEditable && timesUsed > 0) { ;
__p += '\n            <span class="no-delete pull-right" data-content="The Image is in use and cannot be deleted"></span>\n        ';
 } else if (isEditable) { ;
__p += '\n            <span class="delete pull-right" data-content="Delete Image forever"></span>\n        ';
 } else { ;
__p += '\n            <span class="delete pull-right disabled" data-content="You do not have permission to delete Images"></span>\n        ';
 } ;
__p += '\n\n        ';
 if (isEditable && isLocked) { ;
__p += '\n            <span class="no-detach pull-right" data-content="The Image is in use in the current Project and cannot be detached"></span>\n        ';
 } else if (isEditable) { ;
__p += '\n            <span class="detach pull-right" data-content="Detach Image"></span>\n        ';
 } else { ;
__p += '\n            <span class="detach pull-right disabled" data-content="You do not have permission to detach Images"></span>\n        ';
 } ;
__p += '\n\n    </div>\n';
 } ;
__p += '\n\n<div class="image-thumb">\n    <span class="helper"></span>\n    ';
 if (uploading) { ;
__p += '\n        <div class="image-placeholder">\n            <div class="progress-bar"></div>\n        </div>\n    ';
 } else { ;
__p += '\n        <img src="' +
__e( absoluteThumbUrl ) +
'" class="image">\n    ';
 } ;
__p += '\n</div>\n\n<div class="image-info">\n    <div class="js-name-editable-container editable-container';
 if (!isEditable) { ;
__p += ' not-editable';
 } ;
__p += '">\n        <div class="name-and-times-used">\n            <div class="js-name title editable" contenteditable="' +
__e( isEditable ) +
'"/>\n            ';
 if (timesUsed > 0) { ;
__p += '\n                <span class="times-used" data-content="This image was used ' +
__e( timesUsed ) +
' times">(' +
__e( timesUsed ) +
')</span>\n            ';
 } ;
__p += '\n        </div>\n        ';
 if (isEditable) { ;
__p += '\n            <div class="editable-cell-img"><div class="editable-img"></div></div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="js-alt-text-editable-container editable-container';
 if (!isEditable) { ;
__p += ' not-editable';
 } ;
__p += '">\n        <div class="alt-text-label">Alt text:</div>\n        <div class="js-alt-text alt-text editable" contenteditable="' +
__e( isEditable ) +
'"></div>\n        ';
 if (isEditable) { ;
__p += '\n            <div class="editable-cell-img js-alt-text-icon"><div class="editable-img"></div></div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="description">\n        <ul>\n            <li>Size: ' +
__e( width ) +
' &times; ' +
__e( height ) +
' / ' +
__e( displaySize ) +
'</li>\n            <li>Type: ' +
__e( extension ) +
'</li>\n            <li>\n                <div class="imageTagsRegion"></div>\n            </li>\n        </ul>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span id="channel-' +
__e(id) +
'" class="slot-col">\n    <span class="slot-name"></span>\n    <div class="channel-tooltip" style="display:none">\n        <div><strong>CSS Selector</strong>: <span class="selector"></span></div>\n        <div><strong>Url</strong>: <span class="url"></span></div>\n        <div><strong>Potential domain match</strong>: <span class="matches"></span></div>\n        <div><strong>Last updated</strong>: <span class="editedat"></span></div>\n    </div>\n</span>\n<span class="live-now-col">\n    <span class="live"></span>\n</span>\n<span class="live-next-col">\n    <span class="next"></span>\n</span>\n<span class="live-date-col">\n    <span class="live-date"></span>\n</span>\n<span class="slot-options-col">\n    <div class="actions-panel">\n        ';
 if (showChannelActionsPanel) { ;
__p += '\n            ';
 if (!allowedToPublish) { ;
__p += '\n                <span class="delete pull-right disabled" data-content="You do not have permission to delete Slots"></span>\n            ';
 } else { ;
__p += '\n                <span class="delete pull-right" data-content="Delete Slot"></span>\n            ';
 } ;
__p += '\n\n            ';
 if (!allowedToPublish) { ;
__p += '\n                <span class="detach pull-right disabled" data-content="You do not have permission to detach Slots"></span>\n            ';
 } else if (isLocked) { ;
__p += '\n                <span class="no-detach pull-right" data-content="The Slot contains an Experience or Group from the current Project and cannot be detached"></span>\n            ';
 } else { ;
__p += '\n                <span class="detach pull-right" data-content="Detach Slot"></span>\n            ';
 } ;
__p += '\n        ';
 } ;
__p += '\n    </div>\n</span>\n';

}
return __p
}

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        EditorEvents = __webpack_require__(17),
        EventDispatcher = __webpack_require__(54),
        ProjectAsset = __webpack_require__(283),
        LoggedInUserState = __webpack_require__(19),
        Preconditions = __webpack_require__(14);

    // TODO Candidate to be deleted and handle logic in Project class.

    return EventDispatcher.extend("Project Context", {

        /**
         * The project associated to the context, never null.
         *
         * @type {ProjectModel}
         */
        project: null,

        /**
         * Constructor
         */
        constructor: function constructor(options) {
            Preconditions.checkArgument(options.project);

            _.extend(this, options);
        },

        /**
         * Attaches a model or collection of models into a project, by also adding them to the project collection.
         * FinalLy it re-fetches experiences because their projectId attribute may have changed.
         *
         * @param {ImprovedModel|ImprovedModel[]|Backbone.Collection} model - model or collection of models to be attached and added to the project.
         * @returns {Promise}
         */
        attach: function attach(model) {
            this._triggerEditorEvents(model, true);
            return this.project.attach(model);
        },

        /**
         * Detaches a model or collection of models into a project, by also removing them to the project collection.
         * FinalLy it re-fetches experiences because their projectId attribute may have changed.
         *
         * @param {ImprovedModel|ImprovedModel[]|Backbone.Collection} model - model or collection of models to be attached and added to the project.
         *
         * @returns {Promise}
         */
        detach: function detach(model) {
            this._triggerEditorEvents(model, false);
            return this.project.detach(model);
        },

        /**
         * Clears all assets from a project by type, i.e. <tt>ProjectAsset.Type.XXX</tt>.
         *
         * @param {String} type The asset type, as a <tt>ProjectAsset.Type.XXX</tt> constant value.
         */
        clear: function clear(type) {
            this.project.clear(type);
        },

        dispose: function dispose() {
            this.project = null;
            this.stopListening();
        },

        /**
         * Tracks Mix Panel events for attach and detach actions within a context of a project.
         * @param modelsOrAssets Set of models or assets.
         * @param isAttaching Whether we ara attaching or detaching a model or asset.
         * @private
         */
        _triggerEditorEvents: function _triggerEditorEvents(modelsOrAssets, isAttaching) {
            var _this = this;

            // Normalize to array.
            modelsOrAssets = ProjectAsset.toArray(modelsOrAssets);

            _.each(modelsOrAssets, function (modelOrAsset) {
                var assetType = modelOrAsset.get("type");

                // This is needed as images and channels do not pass assets when being attached, but Backbone models.
                if (!assetType) {
                    var asAsset = ProjectAsset.asAsset(modelOrAsset);
                    if (asAsset) {
                        assetType = asAsset.get("resourceType");
                    } else {
                        return; // it will continue the next iteration as a valid asset could not be found.
                    }
                }

                _this._trackEditorEvent(isAttaching, assetType, modelOrAsset);
            });
        },

        /**
         * Track editor event for the single asset being attached or detached.
         * @param {Boolean} isAttaching Whether we are attaching or detaching an asset to the project.
         * @param {String} assetType The type of asset.
         * @param {ProjectModel | ProjectAsset} modelOrAsset The project model or project asset to be attached / detached.
         * @private
         */
        _trackEditorEvent: function _trackEditorEvent(isAttaching, assetType, modelOrAsset) {
            var eventName = null,
                eventProperties = {},
                triggerOrigin = isAttaching ? "AttachButton" : "DetachButton";

            switch (assetType) {
                case ProjectAsset.Type.EXPERIENCE:
                    eventName = isAttaching ? EditorEvents.constants.ATTACH_EXPERIENCE : EditorEvents.constants.DETACH_EXPERIENCE;
                    eventProperties = {
                        experienceId: modelOrAsset.get("id"),
                        experienceVersion: modelOrAsset.get("version"),
                        experiencePushedVersion: modelOrAsset.get("pushedVersion")
                    };

                    break;

                case ProjectAsset.Type.IMAGE:
                    eventName = isAttaching ? EditorEvents.constants.ATTACH_IMAGE : EditorEvents.constants.DETACH_IMAGE;
                    eventProperties = {
                        imageId: modelOrAsset.get("id"),
                        imageName: modelOrAsset.get("name")
                    };

                    break;

                case ProjectAsset.Type.CHANNEL:
                    eventName = isAttaching ? EditorEvents.constants.ATTACH_CHANNEL : EditorEvents.constants.DETACH_CHANNEL;

                    eventProperties = {
                        channelId: modelOrAsset.get("id"),
                        channelName: modelOrAsset.get("name"),
                        channelSelector: modelOrAsset.get("selector"),
                        channelUrl: modelOrAsset.get("url") || ""
                    };

                    var experience = modelOrAsset.get("experience");

                    if (experience) {
                        eventProperties.channelExperienceId = experience.get("id");
                        eventProperties.channelExperienceVersion = experience.get("version");
                        eventProperties.channelExperiencePushedVersion = experience.get("pushedVersion");
                    }

                    break;

                case ProjectAsset.Type.LOCALIZATIONGROUP:
                case ProjectAsset.Type.BREAKPOINTGROUP:
                    eventName = isAttaching ? EditorEvents.constants.ATTACH_GROUP : EditorEvents.constants.DETACH_GROUP;
                    eventProperties = {
                        groupId: modelOrAsset.get("id"),
                        groupVersion: modelOrAsset.get("version"),
                        groupPushedVersion: modelOrAsset.get("pushedVersion"),
                        groupType: assetType
                    };
                    break;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Asset type '" + assetType + "' not recognized.");
                    break;
            }

            EditorEvents.trigger(eventName, _.extend(eventProperties, {
                triggerOrigin: triggerOrigin,
                projectId: this.project.get("id")
            }));
        }
    }, {
        mapContent: function mapContent() {
            var map = new Map();

            LoggedInUserState.get("projects").each(function (project) {
                var publishableAssets = project.publishables(),
                    projectID = project.get("id");

                // Iterate through the project content and add them to the map
                publishableAssets.forEach(function (publishable) {
                    map.set(publishable.get("resourceId"), projectID);
                });
            });

            return map;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        TweenMax = __webpack_require__(152),
        ProjectCollectionView = __webpack_require__(3099),
        LoggedIn = __webpack_require__(31),
        LoggedInUserState = __webpack_require__(19);

    var PROJECT_PANEL_EXPANDED = "projects-panel-expanded";

    var $html = $("html"),
        $mainOverlay = $(".main-overlay"),
        $projectsPanel = $(".projects-panel");

    /**
     * @class  ProjectSelector
     */
    var ProjectSelector = Marionette.Controller.extend({

        /**
         * @type {ProjectCollectionView}
         */
        _view: null,

        initialize: function initialize() {
            // Debounced to allow multiple calls during the same callstack. E.g. by default we close
            // the selector when the location/route changes, in some cases we might wanna keep the selector open.
            this.toggleProjectSelector = _.debounce(this.toggleProjectSelector, 150).bind(this);
        },


        /**
         * Initializes the ProjectSelector.
         *
         * @param  {Region} region The region to show the project selector.
         */
        start: function start(region) {
            var _this = this;

            this.listenTo(LoggedInUserState, "change:ready", function (model, ready) {
                if (ready) {
                    var projects = LoggedInUserState.get("projects");

                    this._view = new ProjectCollectionView({
                        collection: projects
                    });

                    region.show(this._view);
                }
            });

            this.listenTo(LoggedInUserState, "change:location", function () {
                this.toggleProjectSelector(false);
            });

            this.listenTo(LoggedIn, "change:login", function (principal) {
                if (principal) {
                    // signed in principal
                    if (principal.get("updated")) {
                        // re-signin to get normal role (no longer spectator)
                        this._view.render();
                    }
                } else {
                    // signed out
                    region.close();
                }
            });

            $mainOverlay.on("click", function () {
                return _this.toggleProjectSelector(false);
            });

            $projectsPanel.on("transitionend", function () {
                if (!$html.hasClass(PROJECT_PANEL_EXPANDED)) {
                    $projectsPanel.toggleClass("show", false);
                }
            });
        },


        /**
         * Toggles the project selector.
         *
         * @param {Boolean} toggle Optional, whether to show or hide the selector.
         */
        toggleProjectSelector: function toggleProjectSelector(toggle) {
            $html.toggleClass(PROJECT_PANEL_EXPANDED, toggle);

            if (toggle || $html.hasClass(PROJECT_PANEL_EXPANDED)) {
                $projectsPanel.toggleClass("show", true);
            }

            // Let TweenMax handle fade in/out of the main overlay - hiding it (display:none) when fully transparent
            if ($html.hasClass(PROJECT_PANEL_EXPANDED)) {
                $mainOverlay.show();
                TweenMax.to($mainOverlay, 0.5, {
                    opacity: 1
                });
            } else {
                TweenMax.to($mainOverlay, 0.5, {
                    opacity: 0,
                    onComplete: $mainOverlay.hide.bind($mainOverlay)
                });
            }
        }
    });

    // Singleton
    return new ProjectSelector();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Permissions = __webpack_require__(22),
        Preconditions = __webpack_require__(14);

    /**
     * Helper class for utility methods for Manage Users views.
     */
    return {
        /**
         * Map role list needed for adding additional text.
         * Note: SiteManager is filtered out of the list on purpose as it should only be assigned via Zelp.
         * @param {Array} roles, List of roles to be mapped with additional text.
         * @returns {Array}, A new List of roles with additional text displayed on the Role dropdown.
         */
        mapRoles: function mapRoles(roles) {
            var _this = this;

            return roles.filter(function (filterRole) {
                return filterRole !== Permissions.Roles.SITEMANAGER.name;
            }).map(function (role) {
                var label = _this.createRoleLabel(role);
                return { role: Permissions.Roles.of(role), roleLabel: label };
            });
        },

        /**
         * Creates a more meaningful role label.
         * @param {string} role, the user role from which a label will be created.
         * @returns {string} label, the role label displayed in the Role dropdown.
         * @throws {Error} If the role cannot be recognized.
         */
        createRoleLabel: function createRoleLabel(role) {
            // TODO: this should use the Role enum, not the string name!
            switch (role) {
                case "Manager":
                    return role + " (full access)";

                case "Creator":
                    return role + " (create/edit)";

                case "Spectator":
                    return role + " (share/comment)";

                case "Publisher":
                    return role + " (create/edit/publish)";

                case "SiteManager":
                    return role + " (full site access)";

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Role '" + role + "' not recognized.");
                    break;
            }
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addGlobalEventProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(56);


/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
    }
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function () {
                _this._scopeListeners.forEach(function (callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var processor = processors[index];
            // tslint:disable-next-line:strict-type-predicates
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event), hint);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["A" /* isThenable */])(result)) {
                    result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        this._contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._contexts, (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        var span = this.getSpan();
        if (span && span.spanRecorder && span.spanRecorder.spans[0]) {
            return span.spanRecorder.spans[0];
        }
        return undefined;
    };
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](scope._breadcrumbs);
            newScope._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._tags);
            newScope._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._extra);
            newScope._contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, captureContext._tags);
            this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, captureContext._extra);
            this._contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._contexts, captureContext._contexts);
            if (captureContext._user) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
        }
        else if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["x" /* isPlainObject */])(captureContext)) {
            // tslint:disable-next-line:no-parameter-reassignment
            captureContext = captureContext;
            this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, captureContext.tags);
            this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, captureContext.extra);
            this._contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._contexts, captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["J" /* timestampWithMs */])() }, breadcrumb);
        this._breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
                : __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](this._breadcrumbs, [mergedBreadcrumb]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._user, event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._contexts, event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relys on that.
        if (this._span) {
            event.contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ trace: this._span.getTraceContext() }, event.contexts);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */]((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    return Scope;
}());

/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["b"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Memo; });
// tslint:disable:no-unsafe-any
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        // tslint:disable-next-line
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());

//# sourceMappingURL=memo.js.map

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["b"] = fill;
/* harmony export (immutable) */ __webpack_exports__["e"] = urlEncode;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeToSize;
/* unused harmony export walk */
/* harmony export (immutable) */ __webpack_exports__["c"] = normalize;
/* harmony export (immutable) */ __webpack_exports__["a"] = extractExceptionKeysForMessage;
/* unused harmony export dropUndefinedKeys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__memo__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__string__ = __webpack_require__(724);





/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */
function fill(source, name, replacement) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacement(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    // tslint:disable-next-line:strict-type-predicates
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(
    // tslint:disable-next-line:no-unsafe-any
    function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all it's attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order to be usable by the serializer
 */
function getWalkSource(value) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["d" /* isError */])(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["f" /* isEvent */])(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = Object(__WEBPACK_IMPORTED_MODULE_1__is__["c" /* isElement */])(event_1.target)
                ? Object(__WEBPACK_IMPORTED_MODULE_3__misc__["h" /* htmlTreeAsString */])(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = Object(__WEBPACK_IMPORTED_MODULE_1__is__["c" /* isElement */])(event_1.currentTarget)
                ? Object(__WEBPACK_IMPORTED_MODULE_3__misc__["h" /* htmlTreeAsString */])(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        // tslint:disable-next-line:strict-type-predicates
        if (typeof CustomEvent !== 'undefined' && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var i in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
                source[i] = event_1;
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // tslint:disable-next-line:no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/** Transforms any input value into a string form, either primitive value or a type of the input */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return Object(__WEBPACK_IMPORTED_MODULE_1__is__["i" /* isPrimitive */])(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
// tslint:disable-next-line:cyclomatic-complexity
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["l" /* isSyntheticEvent */])(value)) {
        return '[SyntheticEvent]';
    }
    // tslint:disable-next-line:no-tautology-expression
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + Object(__WEBPACK_IMPORTED_MODULE_3__misc__["e" /* getFunctionName */])(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new __WEBPACK_IMPORTED_MODULE_2__memo__["a" /* Memo */](); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    // If value implements `toJSON` method, call it and return early
    // tslint:disable:no-unsafe-any
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    // tslint:enable:no-unsafe-any
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["i" /* isPrimitive */])(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
function normalize(input, depth) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    // tslint:disable:strict-type-predicates
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__string__["d" /* truncate */])(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_4__string__["d" /* truncate */])(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["h" /* isPlainObject */])(val)) {
        var obj = val;
        var rv = {};
        try {
            for (var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __values */](Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof obj[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(obj[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(287);

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["m" /* isThenable */])(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler.done) {
                    return;
                }
                if (_this._state === States.RESOLVED) {
                    if (handler.onfulfilled) {
                        handler.onfulfilled(_this._value);
                    }
                }
                if (_this._state === States.REJECTED) {
                    if (handler.onrejected) {
                        handler.onrejected(_this._value);
                    }
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return '[object SyncPromise]';
    };
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */
    SyncPromise.all = function (collection) {
        return new SyncPromise(function (resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function (item, index) {
                SyncPromise.resolve(item)
                    .then(function (value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) {
                        return;
                    }
                    resolve(resolvedCollection);
                })
                    .then(null, reject);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsErrorEvent */
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* harmony export (immutable) */ __webpack_exports__["a"] = supportsFetch;
/* harmony export (immutable) */ __webpack_exports__["c"] = supportsNativeFetch;
/* unused harmony export supportsReportingObserver */
/* harmony export (immutable) */ __webpack_exports__["d"] = supportsReferrerPolicy;
/* harmony export (immutable) */ __webpack_exports__["b"] = supportsHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc__ = __webpack_require__(344);


/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        // tslint:disable:no-unused-expression
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // It really needs 1 argument, not 0.
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore
        // tslint:disable:no-unused-expression
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        // tslint:disable:no-unused-expression
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["f" /* getGlobalObject */])())) {
        return false;
    }
    try {
        // tslint:disable-next-line:no-unused-expression
        new Headers();
        // tslint:disable-next-line:no-unused-expression
        new Request('');
        // tslint:disable-next-line:no-unused-expression
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["f" /* getGlobalObject */])();
    // Fast path to avoid DOM I/O
    // tslint:disable-next-line:no-unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // tslint:disable-next-line:no-unbound-method deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // tslint:disable-next-line:no-unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    // tslint:disable-next-line: no-unsafe-any
    return 'ReportingObserver' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["f" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        // tslint:disable:no-unused-expression
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["f" /* getGlobalObject */])();
    var chrome = global.chrome;
    // tslint:disable-next-line:no-unsafe-any
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(56);


/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Status */].Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].resolve(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__(3177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version__ = __webpack_require__(1260);






/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* BrowserBackend */], options) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        event.sdk = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event.sdk, { name: __WEBPACK_IMPORTED_MODULE_5__version__["a" /* SDK_NAME */], packages: __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](((event.sdk && event.sdk.packages) || []), [
                {
                    name: 'npm:@sentry/browser',
                    version: __WEBPACK_IMPORTED_MODULE_5__version__["b" /* SDK_VERSION */],
                },
            ]), version: __WEBPACK_IMPORTED_MODULE_5__version__["b" /* SDK_VERSION */] });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(__WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"]);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error('Trying to call showReportDialog with Sentry Client is disabled');
            return;
        }
        var dsn = options.dsn || this.getDsn();
        if (!options.eventId) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error('Missing `eventId` option in showReportDialog call');
            return;
        }
        if (!dsn) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error('Missing `Dsn` option in showReportDialog call');
            return;
        }
        var script = document.createElement('script');
        script.async = true;
        script.src = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getReportDialogEndpoint(options);
        if (options.onLoad) {
            script.onload = options.onLoad;
        }
        (document.head || document.body).appendChild(script);
    };
    return BrowserClient;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["c" /* BaseClient */]));

//# sourceMappingURL=client.js.map

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromUnknownInput;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsers__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracekit__ = __webpack_require__(726);



/** JSDoc */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["s" /* isErrorEvent */])(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        exception = errorEvent.error; // tslint:disable-line:no-parameter-reassignment
        event = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["p" /* isDOMError */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["q" /* isDOMException */])(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["p" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["f" /* addExceptionTypeValue */])(event, message);
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["r" /* isError */])(exception)) {
        // we have a real Error object, do nothing
        event = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["x" /* isPlainObject */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* isEvent */])(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["a" /* eventFromPlainObject */])(objectException, syntheticException, options.rejection);
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* addExceptionMechanism */])(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["f" /* addExceptionTypeValue */])(event, "" + exception, undefined);
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["e" /* addExceptionMechanism */])(event, {
        synthetic: true,
    });
    return event;
}
// this._options.attachStacktrace
/** JSDoc */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = Object(__WEBPACK_IMPORTED_MODULE_1__parsers__["d" /* prepareFramesForEvent */])(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 1258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = exceptionFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromPlainObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareFramesForEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(726);


var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    // tslint:disable-next-line:strict-type-predicates
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* isEvent */])(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["i" /* extractExceptionKeysForMessage */])(exception),
                },
            ],
        },
        extra: {
            __serialized__: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* normalizeToSize */])(exception),
        },
    };
    if (syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_1__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ({
        colno: frame.column === null ? undefined : frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line === null ? undefined : frame.line,
    }); })
        .reverse();
}
//# sourceMappingURL=parsers.js.map

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(727);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BaseTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__base__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(3178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FetchTransport", function() { return __WEBPACK_IMPORTED_MODULE_1__fetch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xhr__ = __webpack_require__(3179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "XHRTransport", function() { return __WEBPACK_IMPORTED_MODULE_2__xhr__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SDK_VERSION; });
var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '5.19.1';
//# sourceMappingURL=version.js.map

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1262);
module.exports = __webpack_require__(1263);


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// This file can be required in Browserify and Node.js for automatic polyfill
// To use it:  require('es6-promise/auto');

module.exports = __webpack_require__(472).polyfill();


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable global-require */
new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1264), __webpack_require__(763), __webpack_require__(1378), __webpack_require__(1380), __webpack_require__(1383), __webpack_require__(1388), __webpack_require__(1390), __webpack_require__(1391), __webpack_require__(1392), __webpack_require__(2749), __webpack_require__(2753), __webpack_require__(2760), __webpack_require__(2762), __webpack_require__(2775), __webpack_require__(2776), __webpack_require__(2777), __webpack_require__(2778), __webpack_require__(2779)]; (function () {
    "use strict";

    // Ensure the browser uses correct capabilities for the editor, not for the viewer...

    var Browser = __webpack_require__(39);
    var Capabilities = __webpack_require__(492);

    Browser.capabilities = Capabilities.detect(true); // editor

    new Promise(function(resolve) { resolve(); }).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(2780), __webpack_require__(27)]; (function (app, config) {
        return app.start(config);
    }.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);
}.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}).catch(__webpack_require__.oe);

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


new Promise(function(resolve) { resolve(); }).then(function() {[__webpack_require__(1265), __webpack_require__(1266), __webpack_require__(1267), __webpack_require__(1268), __webpack_require__(1270), __webpack_require__(1272), __webpack_require__(1375)];}).catch(__webpack_require__.oe);

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

(function (exports) {
  'use strict';
  //shared pointer

  var i;
  //shortcuts
  var defineProperty = Object.defineProperty,
      is = Object.is;

  //Polyfill global objects
  if (typeof WeakMap == 'undefined') {
    exports.WeakMap = createCollection({
      // WeakMap#delete(key:void*):boolean
      'delete': sharedDelete,
      // WeakMap#clear():
      clear: sharedClear,
      // WeakMap#get(key:void*):void*
      get: sharedGet,
      // WeakMap#has(key:void*):boolean
      has: mapHas,
      // WeakMap#set(key:void*, value:void*):void
      set: sharedSet
    }, true);
  }

  if (typeof Map == 'undefined') {
    exports.Map = createCollection({
      // WeakMap#delete(key:void*):boolean
      'delete': sharedDelete,
      //:was Map#get(key:void*[, d3fault:void*]):void*
      // Map#has(key:void*):boolean
      has: mapHas,
      // Map#get(key:void*):boolean
      get: sharedGet,
      // Map#set(key:void*, value:void*):void
      set: sharedSet,
      // Map#keys(void):Array === not in specs
      keys: sharedKeys,
      // Map#values(void):Array === not in specs
      values: sharedValues,
      // Map#forEach(callback:Function, context:void*):void ==> callback.call(context, key, value, mapObject) === not in specs`
      forEach: sharedForEach,
      // Map#clear():
      clear: sharedClear
    });
  }

  if (typeof Set == 'undefined') {
    exports.Set = createCollection({
      // Set#has(value:void*):boolean
      has: setHas,
      // Set#add(value:void*):boolean
      add: sharedAdd,
      // Set#delete(key:void*):boolean
      'delete': sharedDelete,
      // Set#clear():
      clear: sharedClear,
      // Set#values(void):Array === not in specs
      values: sharedValues,
      // Set#forEach(callback:Function, context:void*):void ==> callback.call(context, value, index) === not in specs
      forEach: sharedSetIterate
    });
  }

  if (typeof WeakSet == 'undefined') {
    exports.WeakSet = createCollection({
      // WeakSet#delete(key:void*):boolean
      'delete': sharedDelete,
      // WeakSet#add(value:void*):boolean
      add: sharedAdd,
      // WeakSet#clear():
      clear: sharedClear,
      // WeakSet#has(value:void*):boolean
      has: setHas
    }, true);
  }

  /**
   * ES6 collection constructor
   * @return {Function} a collection class
   */
  function createCollection(proto, objectOnly) {
    function Collection(a) {
      if (!this || this.constructor !== Collection) return new Collection(a);
      this._keys = [];
      this._values = [];
      this.objectOnly = objectOnly;

      //parse initial iterable argument passed
      if (a) init.call(this, a);
    }

    //define size for non object-only collections
    if (!objectOnly) {
      defineProperty(proto, 'size', {
        get: sharedSize
      });
    }

    //set prototype
    proto.constructor = Collection;
    Collection.prototype = proto;

    return Collection;
  }

  /** parse initial iterable argument passed */
  function init(a) {
    var i;
    //init Set argument, like `[1,2,3,{}]`
    if (this.add) a.forEach(this.add, this);
    //init Map argument like `[[1,2], [{}, 4]]`
    else a.forEach(function (a) {
        this.set(a[0], a[1]);
      }, this);
  }

  /** delete */
  function sharedDelete(key) {
    if (this.has(key)) {
      this._keys.splice(i, 1);
      this._values.splice(i, 1);
    }
    // Aurora here does it while Canary doesn't
    return -1 < i;
  };

  function sharedGet(key) {
    return this.has(key) ? this._values[i] : undefined;
  }

  function has(list, key) {
    if (this.objectOnly && key !== Object(key)) throw new TypeError("Invalid value used as weak collection key");
    //NaN or 0 passed
    if (key != key || key === 0) for (i = list.length; i-- && !is(list[i], key);) {} else i = list.indexOf(key);
    return -1 < i;
  }

  function setHas(value) {
    return has.call(this, this._values, value);
  }

  function mapHas(value) {
    return has.call(this, this._keys, value);
  }

  /** @chainable */
  function sharedSet(key, value) {
    this.has(key) ? this._values[i] = value : this._values[this._keys.push(key) - 1] = value;
    return this;
  }

  /** @chainable */
  function sharedAdd(value) {
    if (!this.has(value)) this._values.push(value);
    return this;
  }

  function sharedClear() {
    this._values.length = 0;
  }

  /** keys, values, and iterate related methods */
  function sharedValues() {
    return this._values.slice(0);
  }

  function sharedKeys() {
    return this._keys.slice(0);
  }

  function sharedSize() {
    return this._values.length;
  }

  function sharedForEach(callback, context) {
    var self = this;
    var values = self._values.slice(0);
    self._keys.slice(0).forEach(function (key, n) {
      callback.call(context, values[n], key, self);
    });
  }

  function sharedSetIterate(callback, context) {
    var self = this;
    self._values.slice(0).forEach(function (value) {
      callback.call(context, value, value, self);
    });
  }
})(typeof exports != 'undefined' && typeof global != 'undefined' ? global : window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Promise = __webpack_require__(472);

    var polyfillPromiseFunction = function polyfillPromiseFunction() {
        if (!window.Promise) {
            window.Promise = Promise;
        }
    };

    polyfillPromiseFunction();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var polyfillStringFunction = function polyfillStringFunction() {
        // Taken from MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
        if (!String.prototype.startsWith) {
            String.prototype.startsWith = function (searchString) {
                var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

                return this.substr(position, searchString.length) === searchString;
            };
        }

        // Taken from MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
        // Always polyfill since the perf are really poor for now.
        String.prototype.includes = function (search) {
            var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            if (start + search.length > this.length) {
                return false;
            }
            return this.indexOf(search, start) !== -1;
        };

        // This is ES2016+ So won't be implemented by a lot of browsers.
        // Only firefox has an implementation.
        if (!String.prototype.trimRight) {
            String.prototype.trimRight = function () {
                return this.replace(/ +$/g, "");
            };
        }
    };

    polyfillStringFunction();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    __webpack_require__(1269).polyfill();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */



function assign(target, firstSource) {
  if (target === undefined || target === null) {
    throw new TypeError('Cannot convert first argument to object');
  }

  var to = Object(target);
  for (var i = 1; i < arguments.length; i++) {
    var nextSource = arguments[i];
    if (nextSource === undefined || nextSource === null) {
      continue;
    }

    var keysArray = Object.keys(Object(nextSource));
    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
      var nextKey = keysArray[nextIndex];
      var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
      if (desc !== undefined && desc.enumerable) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }
  return to;
}

function polyfill() {
  if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: assign
    });
  }
}

module.exports = {
  assign: assign,
  polyfill: polyfill
};


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    __webpack_require__(1271);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1271 */
/***/ (function(module, exports) {

Array.prototype.includes||Object.defineProperty(Array.prototype,"includes",{value:function(r,e){if(null==this)throw new TypeError('"this" is null or not defined');var t=Object(this),n=t.length>>>0;if(0===n)return!1;for(var i=0|e,o=Math.max(i>=0?i:n-Math.abs(i),0);o<n;){if(function(r,e){return r===e||"number"==typeof r&&"number"==typeof e&&isNaN(r)&&isNaN(e)}(t[o],r))return!0;o++}return!1}});

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    __webpack_require__(1273).shim();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(345);
var ES = __webpack_require__(732);

var implementation = __webpack_require__(761);
var getPolyfill = __webpack_require__(762);
var shim = __webpack_require__(1374);

var slice = Array.prototype.slice;

var polyfill = getPolyfill();

var boundFindShim = function find(array, predicate) { // eslint-disable-line no-unused-vars
	ES.RequireObjectCoercible(array);
	var args = slice.call(arguments, 1);
	return polyfill.apply(array, args);
};

define(boundFindShim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundFindShim;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(730); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint global-require: 0 */
// https://ecma-international.org/ecma-262/6.0/#sec-abstract-operations
var ES6 = {
	'Abstract Equality Comparison': __webpack_require__(1277),
	'Abstract Relational Comparison': __webpack_require__(1281),
	'Strict Equality Comparison': __webpack_require__(1283),
	abs: __webpack_require__(292),
	AdvanceStringIndex: __webpack_require__(737),
	ArrayCreate: __webpack_require__(1286),
	ArraySetLength: __webpack_require__(1287),
	ArraySpeciesCreate: __webpack_require__(1294),
	Call: __webpack_require__(239),
	CanonicalNumericIndexString: __webpack_require__(746),
	CharacterRange: __webpack_require__(1297),
	CompletePropertyDescriptor: __webpack_require__(1298),
	CreateDataProperty: __webpack_require__(747),
	CreateDataPropertyOrThrow: __webpack_require__(1299),
	CreateHTML: __webpack_require__(1300),
	CreateIterResultObject: __webpack_require__(1302),
	CreateListFromArrayLike: __webpack_require__(1303),
	CreateMethodProperty: __webpack_require__(1310),
	DateFromTime: __webpack_require__(749),
	Day: __webpack_require__(349),
	DayFromYear: __webpack_require__(485),
	DaysInYear: __webpack_require__(750),
	DayWithinYear: __webpack_require__(484),
	DefinePropertyOrThrow: __webpack_require__(238),
	DeletePropertyOrThrow: __webpack_require__(1312),
	EnumerableOwnNames: __webpack_require__(1313),
	floor: __webpack_require__(115),
	FromPropertyDescriptor: __webpack_require__(237),
	Get: __webpack_require__(135),
	GetIterator: __webpack_require__(1314),
	GetMethod: __webpack_require__(351),
	GetOwnPropertyKeys: __webpack_require__(1316),
	GetPrototypeFromConstructor: __webpack_require__(751),
	GetSubstitution: __webpack_require__(1317),
	GetV: __webpack_require__(489),
	HasOwnProperty: __webpack_require__(1318),
	HasProperty: __webpack_require__(1319),
	HourFromTime: __webpack_require__(1320),
	InLeapYear: __webpack_require__(486),
	InstanceofOperator: __webpack_require__(1321),
	Invoke: __webpack_require__(753),
	IsAccessorDescriptor: __webpack_require__(169),
	IsArray: __webpack_require__(116),
	IsCallable: __webpack_require__(187),
	IsCompatiblePropertyDescriptor: __webpack_require__(1322),
	IsConcatSpreadable: __webpack_require__(1323),
	IsConstructor: __webpack_require__(347),
	IsDataDescriptor: __webpack_require__(117),
	IsExtensible: __webpack_require__(296),
	IsGenericDescriptor: __webpack_require__(480),
	IsInteger: __webpack_require__(185),
	IsPromise: __webpack_require__(1324),
	IsPropertyDescriptor: __webpack_require__(1325),
	IsPropertyKey: __webpack_require__(64),
	IsRegExp: __webpack_require__(743),
	IteratorClose: __webpack_require__(1326),
	IteratorComplete: __webpack_require__(754),
	IteratorNext: __webpack_require__(755),
	IteratorStep: __webpack_require__(1327),
	IteratorValue: __webpack_require__(1328),
	MakeDate: __webpack_require__(1329),
	MakeDay: __webpack_require__(1330),
	MakeTime: __webpack_require__(1331),
	MinFromTime: __webpack_require__(1332),
	modulo: __webpack_require__(118),
	MonthFromTime: __webpack_require__(487),
	msFromTime: __webpack_require__(1333),
	ObjectCreate: __webpack_require__(756),
	ObjectDefineProperties: __webpack_require__(1334),
	OrdinaryCreateFromConstructor: __webpack_require__(1335),
	OrdinaryDefineOwnProperty: __webpack_require__(742),
	OrdinaryGetOwnProperty: __webpack_require__(481),
	OrdinaryHasInstance: __webpack_require__(752),
	OrdinaryHasProperty: __webpack_require__(1336),
	QuoteJSONString: __webpack_require__(1337),
	RegExpCreate: __webpack_require__(1338),
	RegExpExec: __webpack_require__(1339),
	RequireObjectCoercible: __webpack_require__(482),
	SameValue: __webpack_require__(170),
	SameValueZero: __webpack_require__(1340),
	SecFromTime: __webpack_require__(1341),
	Set: __webpack_require__(1342),
	SetFunctionName: __webpack_require__(1343),
	SetIntegrityLevel: __webpack_require__(1346),
	SpeciesConstructor: __webpack_require__(1347),
	SplitMatch: __webpack_require__(1348),
	StringCreate: __webpack_require__(1349),
	StringGetIndexProperty: __webpack_require__(1351),
	SymbolDescriptiveString: __webpack_require__(1358),
	TestIntegrityLevel: __webpack_require__(1359),
	thisBooleanValue: __webpack_require__(1360),
	thisNumberValue: __webpack_require__(1361),
	thisStringValue: __webpack_require__(1362),
	thisTimeValue: __webpack_require__(1363),
	TimeClip: __webpack_require__(1364),
	TimeFromYear: __webpack_require__(1365),
	TimeWithinDay: __webpack_require__(1366),
	ToBoolean: __webpack_require__(236),
	ToDateString: __webpack_require__(1367),
	ToInt16: __webpack_require__(1368),
	ToInt32: __webpack_require__(1369),
	ToInt8: __webpack_require__(1370),
	ToInteger: __webpack_require__(348),
	ToLength: __webpack_require__(748),
	ToNumber: __webpack_require__(99),
	ToObject: __webpack_require__(490),
	ToPrimitive: __webpack_require__(290),
	ToPropertyDescriptor: __webpack_require__(186),
	ToPropertyKey: __webpack_require__(1371),
	ToString: __webpack_require__(188),
	ToUint16: __webpack_require__(759),
	ToUint32: __webpack_require__(744),
	ToUint8: __webpack_require__(760),
	ToUint8Clamp: __webpack_require__(1372),
	Type: __webpack_require__(23),
	ValidateAndApplyPropertyDescriptor: __webpack_require__(478),
	WeekDay: __webpack_require__(1373),
	YearFromTime: __webpack_require__(350)
};

module.exports = ES6;


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(99);
var ToPrimitive = __webpack_require__(290);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-abstract-equality-comparison

module.exports = function AbstractEqualityComparison(x, y) {
	var xType = Type(x);
	var yType = Type(y);
	if (xType === yType) {
		return x === y; // ES6+ specified this shortcut anyways.
	}
	if (x == null && y == null) {
		return true;
	}
	if (xType === 'Number' && yType === 'String') {
		return AbstractEqualityComparison(x, ToNumber(y));
	}
	if (xType === 'String' && yType === 'Number') {
		return AbstractEqualityComparison(ToNumber(x), y);
	}
	if (xType === 'Boolean') {
		return AbstractEqualityComparison(ToNumber(x), y);
	}
	if (yType === 'Boolean') {
		return AbstractEqualityComparison(x, ToNumber(y));
	}
	if ((xType === 'String' || xType === 'Number' || xType === 'Symbol') && yType === 'Object') {
		return AbstractEqualityComparison(x, ToPrimitive(y));
	}
	if (xType === 'Object' && (yType === 'String' || yType === 'Number' || yType === 'Symbol')) {
		return AbstractEqualityComparison(ToPrimitive(x), y);
	}
	return false;
};


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(735);
var isCallable = __webpack_require__(477);
var isDate = __webpack_require__(1279);
var isSymbol = __webpack_require__(736);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = __webpack_require__(291)();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://262.ecma-international.org/5.1/#sec-8

module.exports = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $Number = GetIntrinsic('%Number%');
var $TypeError = GetIntrinsic('%TypeError%');

var $isNaN = __webpack_require__(149);
var $isFinite = __webpack_require__(150);
var isPrefixOf = __webpack_require__(1282);

var ToNumber = __webpack_require__(99);
var ToPrimitive = __webpack_require__(290);
var Type = __webpack_require__(23);

// https://262.ecma-international.org/5.1/#sec-11.8.5

// eslint-disable-next-line max-statements
module.exports = function AbstractRelationalComparison(x, y, LeftFirst) {
	if (Type(LeftFirst) !== 'Boolean') {
		throw new $TypeError('Assertion failed: LeftFirst argument must be a Boolean');
	}
	var px;
	var py;
	if (LeftFirst) {
		px = ToPrimitive(x, $Number);
		py = ToPrimitive(y, $Number);
	} else {
		py = ToPrimitive(y, $Number);
		px = ToPrimitive(x, $Number);
	}
	var bothStrings = Type(px) === 'String' && Type(py) === 'String';
	if (!bothStrings) {
		var nx = ToNumber(px);
		var ny = ToNumber(py);
		if ($isNaN(nx) || $isNaN(ny)) {
			return undefined;
		}
		if ($isFinite(nx) && $isFinite(ny) && nx === ny) {
			return false;
		}
		if (nx === Infinity) {
			return false;
		}
		if (ny === Infinity) {
			return true;
		}
		if (ny === -Infinity) {
			return false;
		}
		if (nx === -Infinity) {
			return true;
		}
		return nx < ny; // by now, these are both nonzero, finite, and not equal
	}
	if (isPrefixOf(py, px)) {
		return false;
	}
	if (isPrefixOf(px, py)) {
		return true;
	}
	return px < py; // both strings, neither a prefix of the other. shortcut for steps c-f
};


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $strSlice = __webpack_require__(45)('String.prototype.slice');

module.exports = function isPrefixOf(prefix, string) {
	if (prefix === string) {
		return true;
	}
	if (prefix.length > string.length) {
		return false;
	}
	return $strSlice(string, 0, prefix.length) === prefix;
};


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(23);

// https://262.ecma-international.org/5.1/#sec-11.9.6

module.exports = function StrictEqualityComparison(x, y) {
	var xType = Type(x);
	var yType = Type(y);
	if (xType !== yType) {
		return false;
	}
	if (xType === 'Undefined' || xType === 'Null') {
		return true;
	}
	return x === y; // shortcut for steps 4-7
};


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isLeadingSurrogate(charCode) {
	return typeof charCode === 'number' && charCode >= 0xD800 && charCode <= 0xDBFF;
};


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isTrailingSurrogate(charCode) {
	return typeof charCode === 'number' && charCode >= 0xDC00 && charCode <= 0xDFFF;
};


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $ArrayPrototype = GetIntrinsic('%Array.prototype%');
var $RangeError = GetIntrinsic('%RangeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var IsInteger = __webpack_require__(185);

var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var $setProto = GetIntrinsic('%Object.setPrototypeOf%', true) || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayPrototype
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
);

// https://ecma-international.org/ecma-262/6.0/#sec-arraycreate

module.exports = function ArrayCreate(length) {
	if (!IsInteger(length) || length < 0) {
		throw new $TypeError('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new $RangeError('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 5 - 7, and 9
	if (proto !== $ArrayPrototype) { // step 8
		if (!$setProto) {
			throw new $SyntaxError('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 2
		A.length = length;
	}
	/* step 10, the above as a shortcut for the below
	OrdinaryDefineOwnProperty(A, 'length', {
		'[[Configurable]]': false,
		'[[Enumerable]]': false,
		'[[Value]]': length,
		'[[Writable]]': true
	});
	*/
	return A;
};


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $RangeError = GetIntrinsic('%RangeError%');
var $TypeError = GetIntrinsic('%TypeError%');

var assign = __webpack_require__(1288);

var isPropertyDescriptor = __webpack_require__(293);

var IsArray = __webpack_require__(116);
var IsAccessorDescriptor = __webpack_require__(169);
var IsDataDescriptor = __webpack_require__(117);
var OrdinaryDefineOwnProperty = __webpack_require__(742);
var OrdinaryGetOwnProperty = __webpack_require__(481);
var ToNumber = __webpack_require__(99);
var ToString = __webpack_require__(188);
var ToUint32 = __webpack_require__(744);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-arraysetlength

// eslint-disable-next-line max-statements, max-lines-per-function
module.exports = function ArraySetLength(A, Desc) {
	if (!IsArray(A)) {
		throw new $TypeError('Assertion failed: A must be an Array');
	}
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
	}
	if (!('[[Value]]' in Desc)) {
		return OrdinaryDefineOwnProperty(A, 'length', Desc);
	}
	var newLenDesc = assign({}, Desc);
	var newLen = ToUint32(Desc['[[Value]]']);
	var numberLen = ToNumber(Desc['[[Value]]']);
	if (newLen !== numberLen) {
		throw new $RangeError('Invalid array length');
	}
	newLenDesc['[[Value]]'] = newLen;
	var oldLenDesc = OrdinaryGetOwnProperty(A, 'length');
	if (!IsDataDescriptor(oldLenDesc)) {
		throw new $TypeError('Assertion failed: an array had a non-data descriptor on `length`');
	}
	var oldLen = oldLenDesc['[[Value]]'];
	if (newLen >= oldLen) {
		return OrdinaryDefineOwnProperty(A, 'length', newLenDesc);
	}
	if (!oldLenDesc['[[Writable]]']) {
		return false;
	}
	var newWritable;
	if (!('[[Writable]]' in newLenDesc) || newLenDesc['[[Writable]]']) {
		newWritable = true;
	} else {
		newWritable = false;
		newLenDesc['[[Writable]]'] = true;
	}
	var succeeded = OrdinaryDefineOwnProperty(A, 'length', newLenDesc);
	if (!succeeded) {
		return false;
	}
	while (newLen < oldLen) {
		oldLen -= 1;
		// eslint-disable-next-line no-param-reassign
		var deleteSucceeded = delete A[ToString(oldLen)];
		if (!deleteSucceeded) {
			newLenDesc['[[Value]]'] = oldLen + 1;
			if (!newWritable) {
				newLenDesc['[[Writable]]'] = false;
				OrdinaryDefineOwnProperty(A, 'length', newLenDesc);
				return false;
			}
		}
	}
	if (!newWritable) {
		return OrdinaryDefineOwnProperty(A, 'length', { '[[Writable]]': false });
	}
	return true;
};


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defineProperties = __webpack_require__(345);
var callBind = __webpack_require__(476);

var implementation = __webpack_require__(739);
var getPolyfill = __webpack_require__(740);
var shim = __webpack_require__(1289);

var polyfill = callBind.apply(getPolyfill());
// eslint-disable-next-line no-unused-vars
var bound = function assign(target, source1) {
	return polyfill(Object, arguments);
};

defineProperties(bound, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = bound;


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(345);
var getPolyfill = __webpack_require__(740);

module.exports = function shimAssign() {
	var polyfill = getPolyfill();
	define(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(114);

// https://262.ecma-international.org/13.0/#sec-match-records

module.exports = function isMatchRecord(record) {
	return (
		has(record, '[[StartIndex]]')
        && has(record, '[[EndIndex]]')
        && record['[[StartIndex]]'] >= 0
        && record['[[EndIndex]]'] >= record['[[StartIndex]]']
        && String(parseInt(record['[[StartIndex]]'], 10)) === String(record['[[StartIndex]]'])
        && String(parseInt(record['[[EndIndex]]'], 10)) === String(record['[[EndIndex]]'])
	);
};


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var every = __webpack_require__(479);

module.exports = function isSamePropertyDescriptor(ES, D1, D2) {
	var fields = [
		'[[Configurable]]',
		'[[Enumerable]]',
		'[[Get]]',
		'[[Set]]',
		'[[Value]]',
		'[[Writable]]'
	];
	return every(fields, function (field) {
		if ((field in D1) !== (field in D2)) {
			return false;
		}
		return ES.SameValue(D1[field], D2[field]);
	});
};


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function fromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}
	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = !!Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = !!Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = !!Desc['[[Configurable]]'];
	}
	return obj;
};


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(45);
var hasToStringTag = __webpack_require__(291)();
var has;
var $exec;
var isRegexMarker;
var badStringifier;

if (hasToStringTag) {
	has = callBound('Object.prototype.hasOwnProperty');
	$exec = callBound('RegExp.prototype.exec');
	isRegexMarker = {};

	var throwRegexMarker = function () {
		throw isRegexMarker;
	};
	badStringifier = {
		toString: throwRegexMarker,
		valueOf: throwRegexMarker
	};

	if (typeof Symbol.toPrimitive === 'symbol') {
		badStringifier[Symbol.toPrimitive] = throwRegexMarker;
	}
}

var $toString = callBound('Object.prototype.toString');
var gOPD = Object.getOwnPropertyDescriptor;
var regexClass = '[object RegExp]';

module.exports = hasToStringTag
	// eslint-disable-next-line consistent-return
	? function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}

		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}

		try {
			$exec(value, badStringifier);
		} catch (e) {
			return e === isRegexMarker;
		}
	}
	: function isRegex(value) {
		// In older browsers, typeof regex incorrectly returns 'function'
		if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
			return false;
		}

		return $toString(value) === regexClass;
	};


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $Array = GetIntrinsic('%Array%');
var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(135);
var IsArray = __webpack_require__(116);
var IsConstructor = __webpack_require__(347);
var IsInteger = __webpack_require__(185);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate

module.exports = function ArraySpeciesCreate(originalArray, length) {
	if (!IsInteger(length) || length < 0) {
		throw new $TypeError('Assertion failed: length must be an integer >= 0');
	}
	var len = length === 0 ? 0 : length;
	var C;
	var isArray = IsArray(originalArray);
	if (isArray) {
		C = Get(originalArray, 'constructor');
		// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
		// if (IsConstructor(C)) {
		// 	if C is another realm's Array, C = undefined
		// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
		// }
		if ($species && Type(C) === 'Object') {
			C = Get(C, $species);
			if (C === null) {
				C = void 0;
			}
		}
	}
	if (typeof C === 'undefined') {
		return $Array(len);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError('C must be a constructor');
	}
	return new C(len); // Construct(C, len);
};



/***/ }),
/* 1295 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO: remove, semver-major

module.exports = __webpack_require__(15);


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);
var callBound = __webpack_require__(45);

var $fromCharCode = GetIntrinsic('%String.fromCharCode%');
var $TypeError = GetIntrinsic('%TypeError%');
var $charCodeAt = callBound('%String.prototype.charCodeAt%');
var $push = callBound('%Array.prototype.push%');

module.exports = function CharacterRange(A, B) {
	if (A.length !== 1 || B.length !== 1) {
		throw new $TypeError('Assertion failed: CharSets A and B contain exactly one character');
	}

	var a = A[0];
	var b = B[0];

	var i = $charCodeAt(a, 0);
	var j = $charCodeAt(b, 0);

	if (!(i <= j)) {
		throw new $TypeError('Assertion failed: i is not <= j');
	}

	var arr = [];
	for (var k = i; k <= j; k += 1) {
		$push(arr, $fromCharCode(k));
	}
	return arr;
};


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(114);

var assertRecord = __webpack_require__(294);

var IsDataDescriptor = __webpack_require__(117);
var IsGenericDescriptor = __webpack_require__(480);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor

module.exports = function CompletePropertyDescriptor(Desc) {
	/* eslint no-param-reassign: 0 */
	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (IsGenericDescriptor(Desc) || IsDataDescriptor(Desc)) {
		if (!has(Desc, '[[Value]]')) {
			Desc['[[Value]]'] = void 0;
		}
		if (!has(Desc, '[[Writable]]')) {
			Desc['[[Writable]]'] = false;
		}
	} else {
		if (!has(Desc, '[[Get]]')) {
			Desc['[[Get]]'] = void 0;
		}
		if (!has(Desc, '[[Set]]')) {
			Desc['[[Set]]'] = void 0;
		}
	}
	if (!has(Desc, '[[Enumerable]]')) {
		Desc['[[Enumerable]]'] = false;
	}
	if (!has(Desc, '[[Configurable]]')) {
		Desc['[[Configurable]]'] = false;
	}
	return Desc;
};


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var CreateDataProperty = __webpack_require__(747);
var IsPropertyKey = __webpack_require__(64);
var Type = __webpack_require__(23);

// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

module.exports = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError('unable to create data property');
	}
	return success;
};


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(45);

var $replace = callBound('String.prototype.replace');

var RequireObjectCoercible = __webpack_require__(482);
var ToString = __webpack_require__(188);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-createhtml

module.exports = function CreateHTML(string, tag, attribute, value) {
	if (Type(tag) !== 'String' || Type(attribute) !== 'String') {
		throw new $TypeError('Assertion failed: `tag` and `attribute` must be strings');
	}
	var str = RequireObjectCoercible(string);
	var S = ToString(str);
	var p1 = '<' + tag;
	if (attribute !== '') {
		var V = ToString(value);
		var escapedV = $replace(V, /\x22/g, '&quot;');
		p1 += '\x20' + attribute + '\x3D\x22' + escapedV + '\x22';
	}
	return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

module.exports = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject

module.exports = function CreateIterResultObject(value, done) {
	if (Type(done) !== 'Boolean') {
		throw new $TypeError('Assertion failed: Type(done) is not Boolean');
	}
	return {
		value: value,
		done: done
	};
};


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var callBound = __webpack_require__(45);

var $TypeError = GetIntrinsic('%TypeError%');
var $indexOf = callBound('Array.prototype.indexOf', true) || callBound('String.prototype.indexOf');
var $push = callBound('Array.prototype.push');

var Get = __webpack_require__(135);
var IsArray = __webpack_require__(116);
var ToLength = __webpack_require__(748);
var ToString = __webpack_require__(188);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-createlistfromarraylike
module.exports = function CreateListFromArrayLike(obj) {
	var elementTypes = arguments.length > 1
		? arguments[1]
		: ['Undefined', 'Null', 'Boolean', 'String', 'Symbol', 'Number', 'Object'];

	if (Type(obj) !== 'Object') {
		throw new $TypeError('Assertion failed: `obj` must be an Object');
	}
	if (!IsArray(elementTypes)) {
		throw new $TypeError('Assertion failed: `elementTypes`, if provided, must be an array');
	}
	var len = ToLength(Get(obj, 'length'));
	var list = [];
	var index = 0;
	while (index < len) {
		var indexName = ToString(index);
		var next = Get(obj, indexName);
		var nextType = Type(next);
		if ($indexOf(elementTypes, nextType) < 0) {
			throw new $TypeError('item type ' + nextType + ' is not a valid elementType');
		}
		$push(list, next);
		index += 1;
	}
	return list;
};


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var abs = __webpack_require__(1305);
var floor = __webpack_require__(1306);
var ToNumber = __webpack_require__(1307);

var $isNaN = __webpack_require__(149);
var $isFinite = __webpack_require__(150);
var $sign = __webpack_require__(483);

// http://262.ecma-international.org/5.1/#sec-9.4

module.exports = function ToInteger(value) {
	var number = ToNumber(value);
	if ($isNaN(number)) { return 0; }
	if (number === 0 || !$isFinite(number)) { return number; }
	return $sign(number) * floor(abs(number));
};


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $abs = GetIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function abs(x) {
	return $abs(x);
};


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// var modulo = require('./modulo');
var $floor = Math.floor;

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function floor(x) {
	// return x - modulo(x, 1);
	return $floor(x);
};


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToPrimitive = __webpack_require__(1308);

// http://262.ecma-international.org/5.1/#sec-9.3

module.exports = function ToNumber(value) {
	var prim = ToPrimitive(value, Number);
	if (typeof prim !== 'string') {
		return +prim; // eslint-disable-line no-implicit-coercion
	}

	// eslint-disable-next-line no-control-regex
	var trimmed = prim.replace(/^[ \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u0085]+|[ \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u0085]+$/g, '');
	if ((/^0[ob]|^[+-]0x/).test(trimmed)) {
		return NaN;
	}

	return +trimmed; // eslint-disable-line no-implicit-coercion
};


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://262.ecma-international.org/5.1/#sec-9.1

module.exports = __webpack_require__(1309);


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

var isPrimitive = __webpack_require__(735);

var isCallable = __webpack_require__(477);

// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
var ES5internalSlots = {
	'[[DefaultValue]]': function (O) {
		var actualHint;
		if (arguments.length > 1) {
			actualHint = arguments[1];
		} else {
			actualHint = toStr.call(O) === '[object Date]' ? String : Number;
		}

		if (actualHint === String || actualHint === Number) {
			var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
			var value, i;
			for (i = 0; i < methods.length; ++i) {
				if (isCallable(O[methods[i]])) {
					value = O[methods[i]]();
					if (isPrimitive(value)) {
						return value;
					}
				}
			}
			throw new TypeError('No default value');
		}
		throw new TypeError('invalid [[DefaultValue]] hint supplied');
	}
};

// http://ecma-international.org/ecma-262/5.1/#sec-9.1
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	if (arguments.length > 1) {
		return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
	}
	return ES5internalSlots['[[DefaultValue]]'](input);
};


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var DefineOwnProperty = __webpack_require__(346);

var FromPropertyDescriptor = __webpack_require__(237);
var IsDataDescriptor = __webpack_require__(117);
var IsPropertyKey = __webpack_require__(64);
var SameValue = __webpack_require__(170);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-createmethodproperty

module.exports = function CreateMethodProperty(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	var newDesc = {
		'[[Configurable]]': true,
		'[[Enumerable]]': false,
		'[[Value]]': V,
		'[[Writable]]': true
	};
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		newDesc
	);
};


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $floor = Math.floor;

module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return $floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(64);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-deletepropertyorthrow

module.exports = function DeletePropertyOrThrow(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	// eslint-disable-next-line no-param-reassign
	var success = delete O[P];
	if (!success) {
		throw new $TypeError('Attempt to delete property failed.');
	}
	return success;
};


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var keys = __webpack_require__(288);

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-enumerableownnames

module.exports = function EnumerableOwnNames(O) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	return keys(O);
};


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var getIteratorMethod = __webpack_require__(1315);
var AdvanceStringIndex = __webpack_require__(737);
var Call = __webpack_require__(239);
var GetMethod = __webpack_require__(351);
var IsArray = __webpack_require__(116);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-getiterator

module.exports = function GetIterator(obj, method) {
	var actualMethod = method;
	if (arguments.length < 2) {
		actualMethod = getIteratorMethod(
			{
				AdvanceStringIndex: AdvanceStringIndex,
				GetMethod: GetMethod,
				IsArray: IsArray
			},
			obj
		);
	}
	var iterator = Call(actualMethod, obj);
	if (Type(iterator) !== 'Object') {
		throw new $TypeError('iterator must return an object');
	}

	return iterator;
};


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(289)();
var GetIntrinsic = __webpack_require__(15);
var callBound = __webpack_require__(45);
var isString = __webpack_require__(488);

var $iterator = GetIntrinsic('%Symbol.iterator%', true);
var $stringSlice = callBound('String.prototype.slice');
var $String = GetIntrinsic('%String%', true);

module.exports = function getIteratorMethod(ES, iterable) {
	var usingIterator;
	if (hasSymbols) {
		usingIterator = ES.GetMethod(iterable, $iterator);
	} else if (ES.IsArray(iterable)) {
		usingIterator = function () {
			var i = -1;
			var arr = this; // eslint-disable-line no-invalid-this
			return {
				next: function () {
					i += 1;
					return {
						done: i >= arr.length,
						value: arr[i]
					};
				}
			};
		};
	} else if (isString(iterable)) {
		usingIterator = function () {
			var i = 0;
			return {
				next: function () {
					var nextIndex = ES.AdvanceStringIndex($String(iterable), i, true);
					var value = $stringSlice(iterable, i, nextIndex);
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		};
	}
	return usingIterator;
};


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var hasSymbols = __webpack_require__(289)();

var $TypeError = GetIntrinsic('%TypeError%');

var $gOPN = GetIntrinsic('%Object.getOwnPropertyNames%', true);
var $gOPS = hasSymbols && GetIntrinsic('%Object.getOwnPropertySymbols%', true);
var keys = __webpack_require__(288);

var esType = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-getownpropertykeys

module.exports = function GetOwnPropertyKeys(O, Type) {
	if (esType(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (Type === 'Symbol') {
		return $gOPS ? $gOPS(O) : [];
	}
	if (Type === 'String') {
		if (!$gOPN) {
			return keys(O);
		}
		return $gOPN(O);
	}
	throw new $TypeError('Assertion failed: `Type` must be `"String"` or `"Symbol"`');
};


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');
var $parseInt = GetIntrinsic('%parseInt%');

var inspect = __webpack_require__(745);

var regexTester = __webpack_require__(733);
var callBound = __webpack_require__(45);
var every = __webpack_require__(479);

var isDigit = regexTester(/^[0-9]$/);

var $charAt = callBound('String.prototype.charAt');
var $strSlice = callBound('String.prototype.slice');

var IsArray = __webpack_require__(116);
var IsInteger = __webpack_require__(185);
var Type = __webpack_require__(23);

var canDistinguishSparseFromUndefined = 0 in [undefined]; // IE 6 - 8 have a bug where this returns false

var isStringOrHole = function (capture, index, arr) {
	return Type(capture) === 'String' || (canDistinguishSparseFromUndefined ? !(index in arr) : Type(capture) === 'Undefined');
};

// https://ecma-international.org/ecma-262/6.0/#sec-getsubstitution

// eslint-disable-next-line max-statements, max-params, max-lines-per-function
module.exports = function GetSubstitution(matched, str, position, captures, replacement) {
	if (Type(matched) !== 'String') {
		throw new $TypeError('Assertion failed: `matched` must be a String');
	}
	var matchLength = matched.length;

	if (Type(str) !== 'String') {
		throw new $TypeError('Assertion failed: `str` must be a String');
	}
	var stringLength = str.length;

	if (!IsInteger(position) || position < 0 || position > stringLength) {
		throw new $TypeError('Assertion failed: `position` must be a nonnegative integer, and less than or equal to the length of `string`, got ' + inspect(position));
	}

	if (!IsArray(captures) || !every(captures, isStringOrHole)) {
		throw new $TypeError('Assertion failed: `captures` must be a List of Strings, got ' + inspect(captures));
	}

	if (Type(replacement) !== 'String') {
		throw new $TypeError('Assertion failed: `replacement` must be a String');
	}

	var tailPos = position + matchLength;
	var m = captures.length;

	var result = '';
	for (var i = 0; i < replacement.length; i += 1) {
		// if this is a $, and it's not the end of the replacement
		var current = $charAt(replacement, i);
		var isLast = (i + 1) >= replacement.length;
		var nextIsLast = (i + 2) >= replacement.length;
		if (current === '$' && !isLast) {
			var next = $charAt(replacement, i + 1);
			if (next === '$') {
				result += '$';
				i += 1;
			} else if (next === '&') {
				result += matched;
				i += 1;
			} else if (next === '`') {
				result += position === 0 ? '' : $strSlice(str, 0, position - 1);
				i += 1;
			} else if (next === "'") {
				result += tailPos >= stringLength ? '' : $strSlice(str, tailPos);
				i += 1;
			} else {
				var nextNext = nextIsLast ? null : $charAt(replacement, i + 2);
				if (isDigit(next) && next !== '0' && (nextIsLast || !isDigit(nextNext))) {
					// $1 through $9, and not followed by a digit
					var n = $parseInt(next, 10);
					// if (n > m, impl-defined)
					result += n <= m && Type(captures[n - 1]) === 'Undefined' ? '' : captures[n - 1];
					i += 1;
				} else if (isDigit(next) && (nextIsLast || isDigit(nextNext))) {
					// $00 through $99
					var nn = next + nextNext;
					var nnI = $parseInt(nn, 10) - 1;
					// if nn === '00' or nn > m, impl-defined
					result += nn <= m && Type(captures[nnI]) === 'Undefined' ? '' : captures[nnI];
					i += 2;
				} else {
					result += '$';
				}
			}
		} else {
			// the final $, or else not a $
			result += $charAt(replacement, i);
		}
	}
	return result;
};


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var has = __webpack_require__(114);

var IsPropertyKey = __webpack_require__(64);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty

module.exports = function HasOwnProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	return has(O, P);
};


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(64);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

module.exports = function HasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var floor = __webpack_require__(115);
var modulo = __webpack_require__(118);

var timeConstants = __webpack_require__(151);
var msPerHour = timeConstants.msPerHour;
var HoursPerDay = timeConstants.HoursPerDay;

// https://262.ecma-international.org/5.1/#sec-15.9.1.10

module.exports = function HourFromTime(t) {
	return modulo(floor(t / msPerHour), HoursPerDay);
};


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var $hasInstance = GetIntrinsic('Symbol.hasInstance', true);

var Call = __webpack_require__(239);
var GetMethod = __webpack_require__(351);
var IsCallable = __webpack_require__(187);
var OrdinaryHasInstance = __webpack_require__(752);
var ToBoolean = __webpack_require__(236);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-instanceofoperator

module.exports = function InstanceofOperator(O, C) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	var instOfHandler = $hasInstance ? GetMethod(C, $hasInstance) : void 0;
	if (typeof instOfHandler !== 'undefined') {
		return ToBoolean(Call(instOfHandler, C, [O]));
	}
	if (!IsCallable(C)) {
		throw new $TypeError('`C` is not Callable');
	}
	return OrdinaryHasInstance(C, O);
};


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ValidateAndApplyPropertyDescriptor = __webpack_require__(478);

// https://262.ecma-international.org/6.0/#sec-iscompatiblepropertydescriptor

module.exports = function IsCompatiblePropertyDescriptor(Extensible, Desc, Current) {
	return ValidateAndApplyPropertyDescriptor(undefined, undefined, Extensible, Desc, Current);
};


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $isConcatSpreadable = GetIntrinsic('%Symbol.isConcatSpreadable%', true);

var Get = __webpack_require__(135);
var IsArray = __webpack_require__(116);
var ToBoolean = __webpack_require__(236);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable

module.exports = function IsConcatSpreadable(O) {
	if (Type(O) !== 'Object') {
		return false;
	}
	if ($isConcatSpreadable) {
		var spreadable = Get(O, $isConcatSpreadable);
		if (typeof spreadable !== 'undefined') {
			return ToBoolean(spreadable);
		}
	}
	return IsArray(O);
};


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(45);

var $PromiseThen = callBound('Promise.prototype.then', true);

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-ispromise

module.exports = function IsPromise(x) {
	if (Type(x) !== 'Object') {
		return false;
	}
	if (!$PromiseThen) { // Promises are not supported
		return false;
	}
	try {
		$PromiseThen(x); // throws if not a promise
	} catch (e) {
		return false;
	}
	return true;
};


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// TODO, semver-major: delete this

var isPropertyDescriptor = __webpack_require__(293);

var Type = __webpack_require__(23);
var IsDataDescriptor = __webpack_require__(117);
var IsAccessorDescriptor = __webpack_require__(169);

// https://262.ecma-international.org/6.0/#sec-property-descriptor-specification-type

module.exports = function IsPropertyDescriptor(Desc) {
	return isPropertyDescriptor({
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor,
		Type: Type
	}, Desc);
};


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var Call = __webpack_require__(239);
var GetMethod = __webpack_require__(351);
var IsCallable = __webpack_require__(187);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose

module.exports = function IteratorClose(iterator, completion) {
	if (Type(iterator) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(iterator) is not Object');
	}
	if (!IsCallable(completion)) {
		throw new $TypeError('Assertion failed: completion is not a thunk for a Completion Record');
	}
	var completionThunk = completion;

	var iteratorReturn = GetMethod(iterator, 'return');

	if (typeof iteratorReturn === 'undefined') {
		return completionThunk();
	}

	var completionRecord;
	try {
		var innerResult = Call(iteratorReturn, iterator, []);
	} catch (e) {
		// if we hit here, then "e" is the innerResult completion that needs re-throwing

		// if the completion is of type "throw", this will throw.
		completionThunk();
		completionThunk = null; // ensure it's not called twice.

		// if not, then return the innerResult completion
		throw e;
	}
	completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
	completionThunk = null; // ensure it's not called twice.

	if (Type(innerResult) !== 'Object') {
		throw new $TypeError('iterator .return must return an object');
	}

	return completionRecord;
};


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var IteratorComplete = __webpack_require__(754);
var IteratorNext = __webpack_require__(755);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep

module.exports = function IteratorStep(iterator) {
	var result = IteratorNext(iterator);
	var done = IteratorComplete(result);
	return done === true ? false : result;
};



/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(135);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue

module.exports = function IteratorValue(iterResult) {
	if (Type(iterResult) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
	}
	return Get(iterResult, 'value');
};



/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isFinite = __webpack_require__(150);
var msPerDay = __webpack_require__(151).msPerDay;

// https://262.ecma-international.org/5.1/#sec-15.9.1.13

module.exports = function MakeDate(day, time) {
	if (!$isFinite(day) || !$isFinite(time)) {
		return NaN;
	}
	return (day * msPerDay) + time;
};


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $DateUTC = GetIntrinsic('%Date.UTC%');

var $isFinite = __webpack_require__(150);

var DateFromTime = __webpack_require__(749);
var Day = __webpack_require__(349);
var floor = __webpack_require__(115);
var modulo = __webpack_require__(118);
var MonthFromTime = __webpack_require__(487);
var ToInteger = __webpack_require__(348);
var YearFromTime = __webpack_require__(350);

// https://262.ecma-international.org/5.1/#sec-15.9.1.12

module.exports = function MakeDay(year, month, date) {
	if (!$isFinite(year) || !$isFinite(month) || !$isFinite(date)) {
		return NaN;
	}
	var y = ToInteger(year);
	var m = ToInteger(month);
	var dt = ToInteger(date);
	var ym = y + floor(m / 12);
	var mn = modulo(m, 12);
	var t = $DateUTC(ym, mn, 1);
	if (YearFromTime(t) !== ym || MonthFromTime(t) !== mn || DateFromTime(t) !== 1) {
		return NaN;
	}
	return Day(t) + dt - 1;
};


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isFinite = __webpack_require__(150);
var timeConstants = __webpack_require__(151);
var msPerSecond = timeConstants.msPerSecond;
var msPerMinute = timeConstants.msPerMinute;
var msPerHour = timeConstants.msPerHour;

var ToInteger = __webpack_require__(348);

// https://262.ecma-international.org/5.1/#sec-15.9.1.11

module.exports = function MakeTime(hour, min, sec, ms) {
	if (!$isFinite(hour) || !$isFinite(min) || !$isFinite(sec) || !$isFinite(ms)) {
		return NaN;
	}
	var h = ToInteger(hour);
	var m = ToInteger(min);
	var s = ToInteger(sec);
	var milli = ToInteger(ms);
	var t = (h * msPerHour) + (m * msPerMinute) + (s * msPerSecond) + milli;
	return t;
};


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var floor = __webpack_require__(115);
var modulo = __webpack_require__(118);

var timeConstants = __webpack_require__(151);
var msPerMinute = timeConstants.msPerMinute;
var MinutesPerHour = timeConstants.MinutesPerHour;

// https://262.ecma-international.org/5.1/#sec-15.9.1.10

module.exports = function MinFromTime(t) {
	return modulo(floor(t / msPerMinute), MinutesPerHour);
};


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var modulo = __webpack_require__(118);

var msPerSecond = __webpack_require__(151).msPerSecond;

// https://262.ecma-international.org/5.1/#sec-15.9.1.10

module.exports = function msFromTime(t) {
	return modulo(t, msPerSecond);
};


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(45);

var DefinePropertyOrThrow = __webpack_require__(238);
var FromPropertyDescriptor = __webpack_require__(237);
var Get = __webpack_require__(135);
var ToObject = __webpack_require__(490);
var ToPropertyDescriptor = __webpack_require__(186);

var forEach = __webpack_require__(491);
var getOwnPropertyDescriptor = __webpack_require__(295);
var OwnPropertyKeys = __webpack_require__(757);

var $push = callBound('Array.prototype.push');

// https://262.ecma-international.org/6.0/#sec-objectdefineproperties
module.exports = function ObjectDefineProperties(O, Properties) {
	var props = ToObject(Properties); // step 1
	var keys = OwnPropertyKeys(props); // step 2
	var descriptors = []; // step 3

	forEach(keys, function (nextKey) { // step 4
		var propDesc = ToPropertyDescriptor(getOwnPropertyDescriptor(props, nextKey)); // step 4.a
		if (typeof propDesc !== 'undefined' && propDesc['[[Enumerable]]']) { // step 4.b
			var descObj = Get(props, nextKey); // step 4.b.i
			var desc = ToPropertyDescriptor(descObj); // step 4.b.ii
			$push(descriptors, [nextKey, desc]); // step 4.b.iii
		}
	});

	forEach(descriptors, function (pair) { // step 5
		var P = pair[0]; // step 5.a
		var desc = pair[1]; // step 5.b
		desc = FromPropertyDescriptor(desc); // TODO: remove this once DefinePropertyOrThrow is fixed
		DefinePropertyOrThrow(O, P, desc); // step 5.c
	});

	return O; // step 6
};


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);
var $TypeError = GetIntrinsic('%TypeError%');

var GetPrototypeFromConstructor = __webpack_require__(751);
var IsArray = __webpack_require__(116);
var ObjectCreate = __webpack_require__(756);

// https://ecma-international.org/ecma-262/6.0/#sec-ordinarycreatefromconstructor

module.exports = function OrdinaryCreateFromConstructor(constructor, intrinsicDefaultProto) {
	GetIntrinsic(intrinsicDefaultProto); // throws if not a valid intrinsic
	var proto = GetPrototypeFromConstructor(constructor, intrinsicDefaultProto);
	var slots = arguments.length < 3 ? [] : arguments[2];
	if (!IsArray(slots)) {
		throw new $TypeError('Assertion failed: if provided, `internalSlotsList` must be a List');
	}
	return ObjectCreate(proto, slots);
};


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(64);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-ordinaryhasproperty

module.exports = function OrdinaryHasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	return P in O;
};


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(45);
var forEach = __webpack_require__(491);

var $charCodeAt = callBound('String.prototype.charCodeAt');
var $numberToString = callBound('Number.prototype.toString');
var $toLowerCase = callBound('String.prototype.toLowerCase');
var $strSlice = callBound('String.prototype.slice');
var $strSplit = callBound('String.prototype.split');

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-quotejsonstring

var escapes = {
	'\u0008': 'b',
	'\u000C': 'f',
	'\u000A': 'n',
	'\u000D': 'r',
	'\u0009': 't'
};

module.exports = function QuoteJSONString(value) {
	if (Type(value) !== 'String') {
		throw new $TypeError('Assertion failed: `value` must be a String');
	}
	var product = '"';
	if (value) {
		forEach($strSplit(value), function (C) {
			if (C === '"' || C === '\\') {
				product += '\u005C' + C;
			} else if (C === '\u0008' || C === '\u000C' || C === '\u000A' || C === '\u000D' || C === '\u0009') {
				var abbrev = escapes[C];
				product += '\u005C' + abbrev;
			} else {
				var cCharCode = $charCodeAt(C, 0);
				if (cCharCode < 0x20) {
					product += '\u005Cu' + $toLowerCase($strSlice('0000' + $numberToString(cCharCode, 16), -4));
				} else {
					product += C;
				}
			}
		});
	}
	product += '"';
	return product;
};


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $RegExp = GetIntrinsic('%RegExp%');

// var RegExpAlloc = require('./RegExpAlloc');
// var RegExpInitialize = require('./RegExpInitialize');
var ToString = __webpack_require__(188);

// https://262.ecma-international.org/6.0/#sec-regexpcreate

module.exports = function RegExpCreate(P, F) {
	// var obj = RegExpAlloc($RegExp);
	// return RegExpInitialize(obj, P, F);

	// covers spec mechanics; bypass regex brand checking
	var pattern = typeof P === 'undefined' ? '' : ToString(P);
	var flags = typeof F === 'undefined' ? '' : ToString(F);
	return new $RegExp(pattern, flags);
};


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var regexExec = __webpack_require__(45)('RegExp.prototype.exec');

var Call = __webpack_require__(239);
var Get = __webpack_require__(135);
var IsCallable = __webpack_require__(187);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-regexpexec

module.exports = function RegExpExec(R, S) {
	if (Type(R) !== 'Object') {
		throw new $TypeError('Assertion failed: `R` must be an Object');
	}
	if (Type(S) !== 'String') {
		throw new $TypeError('Assertion failed: `S` must be a String');
	}
	var exec = Get(R, 'exec');
	if (IsCallable(exec)) {
		var result = Call(exec, R, [S]);
		if (result === null || Type(result) === 'Object') {
			return result;
		}
		throw new $TypeError('"exec" method must return `null` or an Object');
	}
	return regexExec(R, S);
};


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(149);

// https://ecma-international.org/ecma-262/6.0/#sec-samevaluezero

module.exports = function SameValueZero(x, y) {
	return (x === y) || ($isNaN(x) && $isNaN(y));
};


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var floor = __webpack_require__(115);
var modulo = __webpack_require__(118);

var timeConstants = __webpack_require__(151);
var msPerSecond = timeConstants.msPerSecond;
var SecondsPerMinute = timeConstants.SecondsPerMinute;

// https://262.ecma-international.org/5.1/#sec-15.9.1.10

module.exports = function SecFromTime(t) {
	return modulo(floor(t / msPerSecond), SecondsPerMinute);
};


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(64);
var SameValue = __webpack_require__(170);
var Type = __webpack_require__(23);

// IE 9 does not throw in strict mode when writability/configurability/extensibility is violated
var noThrowOnStrictViolation = (function () {
	try {
		delete [].length;
		return true;
	} catch (e) {
		return false;
	}
}());

// https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw

module.exports = function Set(O, P, V, Throw) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	if (Type(Throw) !== 'Boolean') {
		throw new $TypeError('Assertion failed: `Throw` must be a Boolean');
	}
	if (Throw) {
		O[P] = V; // eslint-disable-line no-param-reassign
		if (noThrowOnStrictViolation && !SameValue(O[P], V)) {
			throw new $TypeError('Attempted to assign to readonly property.');
		}
		return true;
	}
	try {
		O[P] = V; // eslint-disable-line no-param-reassign
		return noThrowOnStrictViolation ? SameValue(O[P], V) : true;
	} catch (e) {
		return false;
	}

};


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var has = __webpack_require__(114);

var $TypeError = GetIntrinsic('%TypeError%');

var getSymbolDescription = __webpack_require__(1344);

var DefinePropertyOrThrow = __webpack_require__(238);
var IsExtensible = __webpack_require__(296);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-setfunctionname

module.exports = function SetFunctionName(F, name) {
	if (typeof F !== 'function') {
		throw new $TypeError('Assertion failed: `F` must be a function');
	}
	if (!IsExtensible(F) || has(F, 'name')) {
		throw new $TypeError('Assertion failed: `F` must be extensible, and must not have a `name` own property');
	}
	var nameType = Type(name);
	if (nameType !== 'Symbol' && nameType !== 'String') {
		throw new $TypeError('Assertion failed: `name` must be a Symbol or a String');
	}
	if (nameType === 'Symbol') {
		var description = getSymbolDescription(name);
		// eslint-disable-next-line no-param-reassign
		name = typeof description === 'undefined' ? '' : '[' + description + ']';
	}
	if (arguments.length > 2) {
		var prefix = arguments[2];
		// eslint-disable-next-line no-param-reassign
		name = prefix + ' ' + name;
	}
	return DefinePropertyOrThrow(F, 'name', {
		'[[Value]]': name,
		'[[Writable]]': false,
		'[[Enumerable]]': false,
		'[[Configurable]]': true
	});
};


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var callBound = __webpack_require__(45);

var $SyntaxError = GetIntrinsic('%SyntaxError%');
var getGlobalSymbolDescription = GetIntrinsic('%Symbol.keyFor%', true);
var thisSymbolValue = callBound('%Symbol.prototype.valueOf%', true);
var symToStr = callBound('Symbol.prototype.toString', true);

var getInferredName = __webpack_require__(1345);

/* eslint-disable consistent-return */
module.exports = callBound('%Symbol.prototype.description%', true) || function getSymbolDescription(symbol) {
	if (!thisSymbolValue) {
		throw new $SyntaxError('Symbols are not supported in this environment');
	}

	// will throw if not a symbol primitive or wrapper object
	var sym = thisSymbolValue(symbol);

	if (getInferredName) {
		var name = getInferredName(sym);
		if (name === '') {
			return;
		}
		return name.slice(1, -1); // name.slice('['.length, -']'.length);
	}

	var desc;
	if (getGlobalSymbolDescription) {
		desc = getGlobalSymbolDescription(sym);
		if (typeof desc === 'string') {
			return desc;
		}
	}

	desc = symToStr(sym).slice(7, -1); // str.slice('Symbol('.length, -')'.length);
	if (desc) {
		return desc;
	}
};


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getInferredName;
try {
	// eslint-disable-next-line no-new-func
	getInferredName = Function('s', 'return { [s]() {} }[s].name;');
} catch (e) {}

var inferred = function () {};
module.exports = getInferredName && inferred.name === 'inferred' ? getInferredName : null;


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');
var $preventExtensions = GetIntrinsic('%Object.preventExtensions%', true);
var $gOPD = __webpack_require__(295);
var $gOPN = GetIntrinsic('%Object.getOwnPropertyNames%', true);

var forEach = __webpack_require__(491);

var DefinePropertyOrThrow = __webpack_require__(238);
var IsAccessorDescriptor = __webpack_require__(169);
var ToPropertyDescriptor = __webpack_require__(186);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-setintegritylevel

module.exports = function SetIntegrityLevel(O, level) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (level !== 'sealed' && level !== 'frozen') {
		throw new $TypeError('Assertion failed: `level` must be `"sealed"` or `"frozen"`');
	}
	if (!$preventExtensions) {
		throw new $SyntaxError('SetIntegrityLevel requires native `Object.preventExtensions` support');
	}
	var status = $preventExtensions(O);
	if (!status) {
		return false;
	}
	if (!$gOPN) {
		throw new $SyntaxError('SetIntegrityLevel requires native `Object.getOwnPropertyNames` support');
	}
	var theKeys = $gOPN(O);
	if (level === 'sealed') {
		forEach(theKeys, function (k) {
			DefinePropertyOrThrow(O, k, { configurable: false });
		});
	} else if (level === 'frozen') {
		forEach(theKeys, function (k) {
			var currentDesc = $gOPD(O, k);
			if (typeof currentDesc !== 'undefined') {
				var desc;
				if (IsAccessorDescriptor(ToPropertyDescriptor(currentDesc))) {
					desc = { configurable: false };
				} else {
					desc = { configurable: false, writable: false };
				}
				DefinePropertyOrThrow(O, k, desc);
			}
		});
	}
	return true;
};


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError = GetIntrinsic('%TypeError%');

var IsConstructor = __webpack_require__(347);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor

module.exports = function SpeciesConstructor(O, defaultConstructor) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	var C = O.constructor;
	if (typeof C === 'undefined') {
		return defaultConstructor;
	}
	if (Type(C) !== 'Object') {
		throw new $TypeError('O.constructor is not an Object');
	}
	var S = $species ? C[$species] : void 0;
	if (S == null) {
		return defaultConstructor;
	}
	if (IsConstructor(S)) {
		return S;
	}
	throw new $TypeError('no constructor found');
};


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);
var callBound = __webpack_require__(45);

var $TypeError = GetIntrinsic('%TypeError%');

var IsInteger = __webpack_require__(185);
var Type = __webpack_require__(23);

var $charAt = callBound('String.prototype.charAt');

// https://262.ecma-international.org/6.0/#sec-splitmatch

module.exports = function SplitMatch(S, q, R) {
	if (Type(S) !== 'String') {
		throw new $TypeError('Assertion failed: `S` must be a String');
	}
	if (!IsInteger(q)) {
		throw new $TypeError('Assertion failed: `q` must be an integer');
	}
	if (Type(R) !== 'String') {
		throw new $TypeError('Assertion failed: `R` must be a String');
	}
	var r = R.length;
	var s = S.length;
	if (q + r > s) {
		return false;
	}

	for (var i = 0; i < r; i += 1) {
		if ($charAt(S, q + i) !== $charAt(R, i)) {
			return false;
		}
	}

	return q + r;
};


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $Object = GetIntrinsic('%Object%');
var $StringPrototype = GetIntrinsic('%String.prototype%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var DefinePropertyOrThrow = __webpack_require__(238);
var Type = __webpack_require__(23);

var setProto = __webpack_require__(1350);

// https://262.ecma-international.org/6.0/#sec-stringcreate

module.exports = function StringCreate(value, prototype) {
	if (Type(value) !== 'String') {
		throw new $TypeError('Assertion failed: `S` must be a String');
	}

	var S = $Object(value);
	if (prototype !== $StringPrototype) {
		if (setProto) {
			setProto(S, prototype);
		} else {
			throw new $SyntaxError('StringCreate: a `proto` argument that is not `String.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
	}

	var length = value.length;
	DefinePropertyOrThrow(S, 'length', {
		'[[Configurable]]': false,
		'[[Enumerable]]': false,
		'[[Value]]': length,
		'[[Writable]]': false
	});

	return S;
};


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var originalSetProto = GetIntrinsic('%Object.setPrototypeOf%', true);
var $ArrayProto = GetIntrinsic('%Array.prototype%');

module.exports = originalSetProto || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayProto
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
);


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);
var callBound = __webpack_require__(45);

var $TypeError = GetIntrinsic('%TypeError%');

var $charAt = callBound('String.prototype.charAt');

var isString = __webpack_require__(488);
var isNegativeZero = __webpack_require__(1352);
var unbox = __webpack_require__(1353);

var CanonicalNumericIndexString = __webpack_require__(746);
var IsInteger = __webpack_require__(185);
var IsPropertyKey = __webpack_require__(64);
var Type = __webpack_require__(23);

// https://262.ecma-international.org/6.0/#sec-stringgetindexproperty

module.exports = function StringGetIndexProperty(S, P) {
	if (typeof S === 'string' || !isString(S)) {
		throw new $TypeError('Assertion failed: `S` must be a boxed String Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}

	if (Type(P) !== 'String') {
		return void undefined;
	}

	var index = CanonicalNumericIndexString(P);
	if (typeof index === 'undefined' || !IsInteger(index) || isNegativeZero(index)) {
		return void undefined;
	}

	var str = unbox(S);
	var len = str.length;
	if (index < 0 || len <= index) {
		return void undefined;
	}

	var resultStr = $charAt(str, index);

	return {
		'[[Configurable]]': false,
		'[[Enumerable]]': true,
		'[[Value]]': resultStr,
		'[[Writable]]': false
	};
};


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isNegativeZero(number) {
	return number === 0 && (1 / number) === -Infinity;
};



/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var whichBoxedPrimitive = __webpack_require__(1354);
var callBound = __webpack_require__(45);
var hasSymbols = __webpack_require__(289)();
var hasBigInts = __webpack_require__(758)();

var stringToString = callBound('String.prototype.toString');
var numberValueOf = callBound('Number.prototype.valueOf');
var booleanValueOf = callBound('Boolean.prototype.valueOf');
var symbolValueOf = hasSymbols && callBound('Symbol.prototype.valueOf');
var bigIntValueOf = hasBigInts && callBound('BigInt.prototype.valueOf');

module.exports = function unboxPrimitive(value) {
	var which = whichBoxedPrimitive(value);
	if (typeof which !== 'string') {
		throw new TypeError(which === null ? 'value is an unboxed primitive' : 'value is a non-boxed-primitive object');
	}

	if (which === 'String') {
		return stringToString(value);
	}
	if (which === 'Number') {
		return numberValueOf(value);
	}
	if (which === 'Boolean') {
		return booleanValueOf(value);
	}
	if (which === 'Symbol') {
		if (!hasSymbols) {
			throw new EvalError('somehow this environment does not have Symbols, but you have a boxed Symbol value. Please report this!');
		}
		return symbolValueOf(value);
	}
	if (which === 'BigInt') {
		return bigIntValueOf(value);
	}
	throw new RangeError('unknown boxed primitive found: ' + which);
};


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isString = __webpack_require__(488);
var isNumber = __webpack_require__(1355);
var isBoolean = __webpack_require__(1356);
var isSymbol = __webpack_require__(736);
var isBigInt = __webpack_require__(1357);

// eslint-disable-next-line consistent-return
module.exports = function whichBoxedPrimitive(value) {
	// eslint-disable-next-line eqeqeq
	if (value == null || (typeof value !== 'object' && typeof value !== 'function')) {
		return null;
	}
	if (isString(value)) {
		return 'String';
	}
	if (isNumber(value)) {
		return 'Number';
	}
	if (isBoolean(value)) {
		return 'Boolean';
	}
	if (isSymbol(value)) {
		return 'Symbol';
	}
	if (isBigInt(value)) {
		return 'BigInt';
	}
};


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var numToStr = Number.prototype.toString;
var tryNumberObject = function tryNumberObject(value) {
	try {
		numToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var numClass = '[object Number]';
var hasToStringTag = __webpack_require__(291)();

module.exports = function isNumberObject(value) {
	if (typeof value === 'number') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryNumberObject(value) : toStr.call(value) === numClass;
};


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(45);
var $boolToStr = callBound('Boolean.prototype.toString');
var $toString = callBound('Object.prototype.toString');

var tryBooleanObject = function booleanBrandCheck(value) {
	try {
		$boolToStr(value);
		return true;
	} catch (e) {
		return false;
	}
};
var boolClass = '[object Boolean]';
var hasToStringTag = __webpack_require__(291)();

module.exports = function isBoolean(value) {
	if (typeof value === 'boolean') {
		return true;
	}
	if (value === null || typeof value !== 'object') {
		return false;
	}
	return hasToStringTag && Symbol.toStringTag in value ? tryBooleanObject(value) : $toString(value) === boolClass;
};


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasBigInts = __webpack_require__(758)();

if (hasBigInts) {
	var bigIntValueOf = BigInt.prototype.valueOf;
	var tryBigInt = function tryBigIntObject(value) {
		try {
			bigIntValueOf.call(value);
			return true;
		} catch (e) {
		}
		return false;
	};

	module.exports = function isBigInt(value) {
		if (
			value === null
			|| typeof value === 'undefined'
			|| typeof value === 'boolean'
			|| typeof value === 'string'
			|| typeof value === 'number'
			|| typeof value === 'symbol'
			|| typeof value === 'function'
		) {
			return false;
		}
		if (typeof value === 'bigint') {
			return true;
		}

		return tryBigInt(value);
	};
} else {
	module.exports = function isBigInt(value) {
		return false && value;
	};
}


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(45);

var $SymbolToString = callBound('Symbol.prototype.toString', true);

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-symboldescriptivestring

module.exports = function SymbolDescriptiveString(sym) {
	if (Type(sym) !== 'Symbol') {
		throw new $TypeError('Assertion failed: `sym` must be a Symbol');
	}
	return $SymbolToString(sym);
};


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $gOPD = __webpack_require__(295);
var $TypeError = GetIntrinsic('%TypeError%');

var every = __webpack_require__(479);
var OwnPropertyKeys = __webpack_require__(757);

var IsDataDescriptor = __webpack_require__(117);
var IsExtensible = __webpack_require__(296);
var ToPropertyDescriptor = __webpack_require__(186);
var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-testintegritylevel

module.exports = function TestIntegrityLevel(O, level) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (level !== 'sealed' && level !== 'frozen') {
		throw new $TypeError('Assertion failed: `level` must be `"sealed"` or `"frozen"`');
	}
	var status = IsExtensible(O);
	if (status) {
		return false;
	}
	var theKeys = OwnPropertyKeys(O);
	return theKeys.length === 0 || every(theKeys, function (k) {
		var currentDesc = $gOPD(O, k);
		if (typeof currentDesc !== 'undefined') {
			if (currentDesc.configurable) {
				return false;
			}
			if (level === 'frozen' && IsDataDescriptor(ToPropertyDescriptor(currentDesc)) && currentDesc.writable) {
				return false;
			}
		}
		return true;
	});
};


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $BooleanValueOf = __webpack_require__(45)('Boolean.prototype.valueOf');

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-boolean-prototype-object

module.exports = function thisBooleanValue(value) {
	if (Type(value) === 'Boolean') {
		return value;
	}

	return $BooleanValueOf(value);
};


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(45);

var Type = __webpack_require__(23);

var $NumberValueOf = callBound('Number.prototype.valueOf');

// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-number-prototype-object

module.exports = function thisNumberValue(value) {
	if (Type(value) === 'Number') {
		return value;
	}

	return $NumberValueOf(value);
};



/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $StringValueOf = __webpack_require__(45)('String.prototype.valueOf');

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-string-prototype-object

module.exports = function thisStringValue(value) {
	if (Type(value) === 'String') {
		return value;
	}

	return $StringValueOf(value);
};


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $DateGetTime = __webpack_require__(45)('Date.prototype.getTime');

// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-date-prototype-object

module.exports = function thisTimeValue(value) {
	return $DateGetTime(value);
};


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $Date = GetIntrinsic('%Date%');
var $Number = GetIntrinsic('%Number%');

var $isFinite = __webpack_require__(150);

var abs = __webpack_require__(292);
var ToNumber = __webpack_require__(99);

// https://262.ecma-international.org/5.1/#sec-15.9.1.14

module.exports = function TimeClip(time) {
	if (!$isFinite(time) || abs(time) > 8.64e15) {
		return NaN;
	}
	return $Number(new $Date(ToNumber(time)));
};



/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var msPerDay = __webpack_require__(151).msPerDay;

var DayFromYear = __webpack_require__(485);

// https://262.ecma-international.org/5.1/#sec-15.9.1.3

module.exports = function TimeFromYear(y) {
	return msPerDay * DayFromYear(y);
};


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var modulo = __webpack_require__(118);

var msPerDay = __webpack_require__(151).msPerDay;

// https://262.ecma-international.org/5.1/#sec-15.9.1.2

module.exports = function TimeWithinDay(t) {
	return modulo(t, msPerDay);
};



/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $TypeError = GetIntrinsic('%TypeError%');
var $Date = GetIntrinsic('%Date%');

var $isNaN = __webpack_require__(149);

var Type = __webpack_require__(23);

// https://ecma-international.org/ecma-262/6.0/#sec-todatestring

module.exports = function ToDateString(tv) {
	if (Type(tv) !== 'Number') {
		throw new $TypeError('Assertion failed: `tv` must be a Number');
	}
	if ($isNaN(tv)) {
		return 'Invalid Date';
	}
	return $Date(tv);
};


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToUint16 = __webpack_require__(759);

// https://ecma-international.org/ecma-262/6.0/#sec-toint16

module.exports = function ToInt16(argument) {
	var int16bit = ToUint16(argument);
	return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
};


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(99);

// http://262.ecma-international.org/5.1/#sec-9.5

module.exports = function ToInt32(x) {
	return ToNumber(x) >> 0;
};


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToUint8 = __webpack_require__(760);

// https://ecma-international.org/ecma-262/6.0/#sec-toint8

module.exports = function ToInt8(argument) {
	var int8bit = ToUint8(argument);
	return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
};


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(15);

var $String = GetIntrinsic('%String%');

var ToPrimitive = __webpack_require__(290);
var ToString = __webpack_require__(188);

// https://ecma-international.org/ecma-262/6.0/#sec-topropertykey

module.exports = function ToPropertyKey(argument) {
	var key = ToPrimitive(argument, $String);
	return typeof key === 'symbol' ? key : ToString(key);
};


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(99);
var floor = __webpack_require__(115);

var $isNaN = __webpack_require__(149);

// https://ecma-international.org/ecma-262/6.0/#sec-touint8clamp

module.exports = function ToUint8Clamp(argument) {
	var number = ToNumber(argument);
	if ($isNaN(number) || number <= 0) { return 0; }
	if (number >= 0xFF) { return 0xFF; }
	var f = floor(argument);
	if (f + 0.5 < number) { return f + 1; }
	if (number < f + 0.5) { return f; }
	if (f % 2 !== 0) { return f + 1; }
	return f;
};


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Day = __webpack_require__(349);
var modulo = __webpack_require__(118);

// https://262.ecma-international.org/5.1/#sec-15.9.1.6

module.exports = function WeekDay(t) {
	return modulo(Day(t) + 4, 7);
};


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(345);
var getPolyfill = __webpack_require__(762);

module.exports = function shimArrayPrototypeFind() {
	var polyfill = getPolyfill();

	define(Array.prototype, { find: polyfill }, {
		find: function () {
			return Array.prototype.find !== polyfill;
		}
	});

	return polyfill;
};


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    __webpack_require__(1376);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

!function(e){var t=e.Element.prototype;"function"!=typeof t.matches&&(t.matches=t.msMatchesSelector||t.mozMatchesSelector||t.webkitMatchesSelector||function(e){for(var t=(o.document||o.ownerDocument).querySelectorAll(e),o=this,n=0;t[n]&&t[n]!==o;)++n;return Boolean(t[n])}),"function"!=typeof t.closest&&(t.closest=function(e){for(var t=this;t&&1===t.nodeType;){if(t.matches(e))return t;t=t.parentNode}return null})}(window);


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

//     Underscore.js 1.5.2
//     http://underscorejs.org
//     (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Establish the object that gets returned to break out of a loop iteration.
  var breaker = {};

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    concat           = ArrayProto.concat,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeForEach      = ArrayProto.forEach,
    nativeMap          = ArrayProto.map,
    nativeReduce       = ArrayProto.reduce,
    nativeReduceRight  = ArrayProto.reduceRight,
    nativeFilter       = ArrayProto.filter,
    nativeEvery        = ArrayProto.every,
    nativeSome         = ArrayProto.some,
    nativeIndexOf      = ArrayProto.indexOf,
    nativeLastIndexOf  = ArrayProto.lastIndexOf,
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind;

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object via a string identifier,
  // for Closure Compiler "advanced" mode.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.5.2';

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles objects with the built-in `forEach`, arrays, and raw objects.
  // Delegates to **ECMAScript 5**'s native `forEach` if available.
  var each = _.each = _.forEach = function(obj, iterator, context) {
    if (obj == null) return;
    if (nativeForEach && obj.forEach === nativeForEach) {
      obj.forEach(iterator, context);
    } else if (obj.length === +obj.length) {
      for (var i = 0, length = obj.length; i < length; i++) {
        if (iterator.call(context, obj[i], i, obj) === breaker) return;
      }
    } else {
      var keys = _.keys(obj);
      for (var i = 0, length = keys.length; i < length; i++) {
        if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker) return;
      }
    }
  };

  // Return the results of applying the iterator to each element.
  // Delegates to **ECMAScript 5**'s native `map` if available.
  _.map = _.collect = function(obj, iterator, context) {
    var results = [];
    if (obj == null) return results;
    if (nativeMap && obj.map === nativeMap) return obj.map(iterator, context);
    each(obj, function(value, index, list) {
      results.push(iterator.call(context, value, index, list));
    });
    return results;
  };

  var reduceError = 'Reduce of empty array with no initial value';

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`. Delegates to **ECMAScript 5**'s native `reduce` if available.
  _.reduce = _.foldl = _.inject = function(obj, iterator, memo, context) {
    var initial = arguments.length > 2;
    if (obj == null) obj = [];
    if (nativeReduce && obj.reduce === nativeReduce) {
      if (context) iterator = _.bind(iterator, context);
      return initial ? obj.reduce(iterator, memo) : obj.reduce(iterator);
    }
    each(obj, function(value, index, list) {
      if (!initial) {
        memo = value;
        initial = true;
      } else {
        memo = iterator.call(context, memo, value, index, list);
      }
    });
    if (!initial) throw new TypeError(reduceError);
    return memo;
  };

  // The right-associative version of reduce, also known as `foldr`.
  // Delegates to **ECMAScript 5**'s native `reduceRight` if available.
  _.reduceRight = _.foldr = function(obj, iterator, memo, context) {
    var initial = arguments.length > 2;
    if (obj == null) obj = [];
    if (nativeReduceRight && obj.reduceRight === nativeReduceRight) {
      if (context) iterator = _.bind(iterator, context);
      return initial ? obj.reduceRight(iterator, memo) : obj.reduceRight(iterator);
    }
    var length = obj.length;
    if (length !== +length) {
      var keys = _.keys(obj);
      length = keys.length;
    }
    each(obj, function(value, index, list) {
      index = keys ? keys[--length] : --length;
      if (!initial) {
        memo = obj[index];
        initial = true;
      } else {
        memo = iterator.call(context, memo, obj[index], index, list);
      }
    });
    if (!initial) throw new TypeError(reduceError);
    return memo;
  };

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, iterator, context) {
    var result;
    any(obj, function(value, index, list) {
      if (iterator.call(context, value, index, list)) {
        result = value;
        return true;
      }
    });
    return result;
  };

  // Return all the elements that pass a truth test.
  // Delegates to **ECMAScript 5**'s native `filter` if available.
  // Aliased as `select`.
  _.filter = _.select = function(obj, iterator, context) {
    var results = [];
    if (obj == null) return results;
    if (nativeFilter && obj.filter === nativeFilter) return obj.filter(iterator, context);
    each(obj, function(value, index, list) {
      if (iterator.call(context, value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, iterator, context) {
    return _.filter(obj, function(value, index, list) {
      return !iterator.call(context, value, index, list);
    }, context);
  };

  // Determine whether all of the elements match a truth test.
  // Delegates to **ECMAScript 5**'s native `every` if available.
  // Aliased as `all`.
  _.every = _.all = function(obj, iterator, context) {
    iterator || (iterator = _.identity);
    var result = true;
    if (obj == null) return result;
    if (nativeEvery && obj.every === nativeEvery) return obj.every(iterator, context);
    each(obj, function(value, index, list) {
      if (!(result = result && iterator.call(context, value, index, list))) return breaker;
    });
    return !!result;
  };

  // Determine if at least one element in the object matches a truth test.
  // Delegates to **ECMAScript 5**'s native `some` if available.
  // Aliased as `any`.
  var any = _.some = _.any = function(obj, iterator, context) {
    iterator || (iterator = _.identity);
    var result = false;
    if (obj == null) return result;
    if (nativeSome && obj.some === nativeSome) return obj.some(iterator, context);
    each(obj, function(value, index, list) {
      if (result || (result = iterator.call(context, value, index, list))) return breaker;
    });
    return !!result;
  };

  // Determine if the array or object contains a given value (using `===`).
  // Aliased as `include`.
  _.contains = _.include = function(obj, target) {
    if (obj == null) return false;
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) return obj.indexOf(target) != -1;
    return any(obj, function(value) {
      return value === target;
    });
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      return (isFunc ? method : value[method]).apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, function(value){ return value[key]; });
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs, first) {
    if (_.isEmpty(attrs)) return first ? void 0 : [];
    return _[first ? 'find' : 'filter'](obj, function(value) {
      for (var key in attrs) {
        if (attrs[key] !== value[key]) return false;
      }
      return true;
    });
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.where(obj, attrs, true);
  };

  // Return the maximum element or (element-based computation).
  // Can't optimize arrays of integers longer than 65,535 elements.
  // See [WebKit Bug 80797](https://bugs.webkit.org/show_bug.cgi?id=80797)
  _.max = function(obj, iterator, context) {
    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
      return Math.max.apply(Math, obj);
    }
    if (!iterator && _.isEmpty(obj)) return -Infinity;
    var result = {computed : -Infinity, value: -Infinity};
    each(obj, function(value, index, list) {
      var computed = iterator ? iterator.call(context, value, index, list) : value;
      computed > result.computed && (result = {value : value, computed : computed});
    });
    return result.value;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iterator, context) {
    if (!iterator && _.isArray(obj) && obj[0] === +obj[0] && obj.length < 65535) {
      return Math.min.apply(Math, obj);
    }
    if (!iterator && _.isEmpty(obj)) return Infinity;
    var result = {computed : Infinity, value: Infinity};
    each(obj, function(value, index, list) {
      var computed = iterator ? iterator.call(context, value, index, list) : value;
      computed < result.computed && (result = {value : value, computed : computed});
    });
    return result.value;
  };

  // Shuffle an array, using the modern version of the 
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var rand;
    var index = 0;
    var shuffled = [];
    each(obj, function(value) {
      rand = _.random(index++);
      shuffled[index - 1] = shuffled[rand];
      shuffled[rand] = value;
    });
    return shuffled;
  };

  // Sample **n** random values from an array.
  // If **n** is not specified, returns a single random element from the array.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (arguments.length < 2 || guard) {
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // An internal function to generate lookup iterators.
  var lookupIterator = function(value) {
    return _.isFunction(value) ? value : function(obj){ return obj[value]; };
  };

  // Sort the object's values by a criterion produced by an iterator.
  _.sortBy = function(obj, value, context) {
    var iterator = lookupIterator(value);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iterator.call(context, value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, value, context) {
      var result = {};
      var iterator = value == null ? _.identity : lookupIterator(value);
      each(obj, function(value, index) {
        var key = iterator.call(context, value, index, obj);
        behavior(result, key, value);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, key, value) {
    (_.has(result, key) ? result[key] : (result[key] = [])).push(value);
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, key, value) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, key) {
    _.has(result, key) ? result[key]++ : result[key] = 1;
  });

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iterator, context) {
    iterator = iterator == null ? _.identity : lookupIterator(iterator);
    var value = iterator.call(context, obj);
    var low = 0, high = array.length;
    while (low < high) {
      var mid = (low + high) >>> 1;
      iterator.call(context, array[mid]) < value ? low = mid + 1 : high = mid;
    }
    return low;
  };

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (obj.length === +obj.length) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return (obj.length === +obj.length) ? obj.length : _.keys(obj).length;
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    return (n == null) || guard ? array[0] : slice.call(array, 0, n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N. The **guard** check allows it to work with
  // `_.map`.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, array.length - ((n == null) || guard ? 1 : n));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array. The **guard** check allows it to work with `_.map`.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if ((n == null) || guard) {
      return array[array.length - 1];
    } else {
      return slice.call(array, Math.max(array.length - n, 0));
    }
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array. The **guard**
  // check allows it to work with `_.map`.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, (n == null) || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, output) {
    if (shallow && _.every(input, _.isArray)) {
      return concat.apply(output, input);
    }
    each(input, function(value) {
      if (_.isArray(value) || _.isArguments(value)) {
        shallow ? push.apply(output, value) : flatten(value, shallow, output);
      } else {
        output.push(value);
      }
    });
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, []);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iterator, context) {
    if (_.isFunction(isSorted)) {
      context = iterator;
      iterator = isSorted;
      isSorted = false;
    }
    var initial = iterator ? _.map(array, iterator, context) : array;
    var results = [];
    var seen = [];
    each(initial, function(value, index) {
      if (isSorted ? (!index || seen[seen.length - 1] !== value) : !_.contains(seen, value)) {
        seen.push(value);
        results.push(array[index]);
      }
    });
    return results;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(_.flatten(arguments, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var rest = slice.call(arguments, 1);
    return _.filter(_.uniq(array), function(item) {
      return _.every(rest, function(other) {
        return _.indexOf(other, item) >= 0;
      });
    });
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = concat.apply(ArrayProto, slice.call(arguments, 1));
    return _.filter(array, function(value){ return !_.contains(rest, value); });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    var length = _.max(_.pluck(arguments, "length").concat(0));
    var results = new Array(length);
    for (var i = 0; i < length; i++) {
      results[i] = _.pluck(arguments, '' + i);
    }
    return results;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    if (list == null) return {};
    var result = {};
    for (var i = 0, length = list.length; i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // If the browser doesn't supply us with indexOf (I'm looking at you, **MSIE**),
  // we need this function. Return the position of the first occurrence of an
  // item in an array, or -1 if the item is not included in the array.
  // Delegates to **ECMAScript 5**'s native `indexOf` if available.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = function(array, item, isSorted) {
    if (array == null) return -1;
    var i = 0, length = array.length;
    if (isSorted) {
      if (typeof isSorted == 'number') {
        i = (isSorted < 0 ? Math.max(0, length + isSorted) : isSorted);
      } else {
        i = _.sortedIndex(array, item);
        return array[i] === item ? i : -1;
      }
    }
    if (nativeIndexOf && array.indexOf === nativeIndexOf) return array.indexOf(item, isSorted);
    for (; i < length; i++) if (array[i] === item) return i;
    return -1;
  };

  // Delegates to **ECMAScript 5**'s native `lastIndexOf` if available.
  _.lastIndexOf = function(array, item, from) {
    if (array == null) return -1;
    var hasIndex = from != null;
    if (nativeLastIndexOf && array.lastIndexOf === nativeLastIndexOf) {
      return hasIndex ? array.lastIndexOf(item, from) : array.lastIndexOf(item);
    }
    var i = (hasIndex ? from : array.length);
    while (i--) if (array[i] === item) return i;
    return -1;
  };

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (arguments.length <= 1) {
      stop = start || 0;
      start = 0;
    }
    step = arguments[2] || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var idx = 0;
    var range = new Array(length);

    while(idx < length) {
      range[idx++] = start;
      start += step;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Reusable constructor function for prototype setting.
  var ctor = function(){};

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    var args, bound;
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError;
    args = slice.call(arguments, 2);
    return bound = function() {
      if (!(this instanceof bound)) return func.apply(context, args.concat(slice.call(arguments)));
      ctor.prototype = func.prototype;
      var self = new ctor;
      ctor.prototype = null;
      var result = func.apply(self, args.concat(slice.call(arguments)));
      if (Object(result) === result) return result;
      return self;
    };
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context.
  _.partial = function(func) {
    var args = slice.call(arguments, 1);
    return function() {
      return func.apply(this, args.concat(slice.call(arguments)));
    };
  };

  // Bind all of an object's methods to that object. Useful for ensuring that
  // all callbacks defined on an object belong to it.
  _.bindAll = function(obj) {
    var funcs = slice.call(arguments, 1);
    if (funcs.length === 0) throw new Error("bindAll must be passed function names");
    each(funcs, function(f) { obj[f] = _.bind(obj[f], obj); });
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memo = {};
    hasher || (hasher = _.identity);
    return function() {
      var key = hasher.apply(this, arguments);
      return _.has(memo, key) ? memo[key] : (memo[key] = func.apply(this, arguments));
    };
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){ return func.apply(null, args); }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = function(func) {
    return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
  };

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    options || (options = {});
    var later = function() {
      previous = options.leading === false ? 0 : new Date;
      timeout = null;
      result = func.apply(context, args);
    };
    return function() {
      var now = new Date;
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0) {
        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    return function() {
      context = this;
      args = arguments;
      timestamp = new Date();
      var later = function() {
        var last = (new Date()) - timestamp;
        if (last < wait) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          if (!immediate) result = func.apply(context, args);
        }
      };
      var callNow = immediate && !timeout;
      if (!timeout) {
        timeout = setTimeout(later, wait);
      }
      if (callNow) result = func.apply(context, args);
      return result;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = function(func) {
    var ran = false, memo;
    return function() {
      if (ran) return memo;
      ran = true;
      memo = func.apply(this, arguments);
      func = null;
      return memo;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return function() {
      var args = [func];
      push.apply(args, arguments);
      return wrapper.apply(this, args);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var funcs = arguments;
    return function() {
      var args = arguments;
      for (var i = funcs.length - 1; i >= 0; i--) {
        args = [funcs[i].apply(this, args)];
      }
      return args[0];
    };
  };

  // Returns a function that will only be executed after being called N times.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Object Functions
  // ----------------

  // Retrieve the names of an object's properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = nativeKeys || function(obj) {
    if (obj !== Object(obj)) throw new TypeError('Invalid object');
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = new Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = new Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = function(obj) {
    each(slice.call(arguments, 1), function(source) {
      if (source) {
        for (var prop in source) {
          obj[prop] = source[prop];
        }
      }
    });
    return obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(obj) {
    var copy = {};
    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
    each(keys, function(key) {
      if (key in obj) copy[key] = obj[key];
    });
    return copy;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj) {
    var copy = {};
    var keys = concat.apply(ArrayProto, slice.call(arguments, 1));
    for (var key in obj) {
      if (!_.contains(keys, key)) copy[key] = obj[key];
    }
    return copy;
  };

  // Fill in a given object with default properties.
  _.defaults = function(obj) {
    each(slice.call(arguments, 1), function(source) {
      if (source) {
        for (var prop in source) {
          if (obj[prop] === void 0) obj[prop] = source[prop];
        }
      }
    });
    return obj;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a == 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className != toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, dates, and booleans are compared by value.
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return a == String(b);
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive. An `egal` comparison is performed for
        // other numeric values.
        return a != +a ? b != +b : (a == 0 ? 1 / a == 1 / b : a == +b);
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a == +b;
      // RegExps are compared by their source patterns and flags.
      case '[object RegExp]':
        return a.source == b.source &&
               a.global == b.global &&
               a.multiline == b.multiline &&
               a.ignoreCase == b.ignoreCase;
    }
    if (typeof a != 'object' || typeof b != 'object') return false;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] == a) return bStack[length] == b;
    }
    // Objects with different constructors are not equivalent, but `Object`s
    // from different frames are.
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(_.isFunction(aCtor) && (aCtor instanceof aCtor) &&
                             _.isFunction(bCtor) && (bCtor instanceof bCtor))) {
      return false;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    var size = 0, result = true;
    // Recursively compare objects and arrays.
    if (className == '[object Array]') {
      // Compare array lengths to determine if a deep comparison is necessary.
      size = a.length;
      result = size == b.length;
      if (result) {
        // Deep compare the contents, ignoring non-numeric properties.
        while (size--) {
          if (!(result = eq(a[size], b[size], aStack, bStack))) break;
        }
      }
    } else {
      // Deep compare objects.
      for (var key in a) {
        if (_.has(a, key)) {
          // Count the expected number of properties.
          size++;
          // Deep compare each member.
          if (!(result = _.has(b, key) && eq(a[key], b[key], aStack, bStack))) break;
        }
      }
      // Ensure that both objects contain the same number of properties.
      if (result) {
        for (key in b) {
          if (_.has(b, key) && !(size--)) break;
        }
        result = !size;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return result;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b, [], []);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (_.isArray(obj) || _.isString(obj)) return obj.length === 0;
    for (var key in obj) if (_.has(obj, key)) return false;
    return true;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) == '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    return obj === Object(obj);
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp.
  each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) == '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return !!(obj && _.has(obj, 'callee'));
    };
  }

  // Optimize `isFunction` if appropriate.
  if (true) {
    _.isFunction = function(obj) {
      return typeof obj === 'function';
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj != +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) == '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iterators.
  _.identity = function(value) {
    return value;
  };

  // Run a function **n** times.
  _.times = function(n, iterator, context) {
    var accum = Array(Math.max(0, n));
    for (var i = 0; i < n; i++) accum[i] = iterator.call(context, i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // List of HTML entities for escaping.
  var entityMap = {
    escape: {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;'
    }
  };
  entityMap.unescape = _.invert(entityMap.escape);

  // Regexes containing the keys and values listed immediately above.
  var entityRegexes = {
    escape:   new RegExp('[' + _.keys(entityMap.escape).join('') + ']', 'g'),
    unescape: new RegExp('(' + _.keys(entityMap.unescape).join('|') + ')', 'g')
  };

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  _.each(['escape', 'unescape'], function(method) {
    _[method] = function(string) {
      if (string == null) return '';
      return ('' + string).replace(entityRegexes[method], function(match) {
        return entityMap[method][match];
      });
    };
  });

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property) {
    if (object == null) return void 0;
    var value = object[property];
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result.call(this, func.apply(_, args));
      };
    });
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\t':     't',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  _.template = function(text, data, settings) {
    var render;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = new RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset)
        .replace(escaper, function(match) { return '\\' + escapes[match]; });

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      }
      if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      }
      if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }
      index = offset + match.length;
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + "return __p;\n";

    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    if (data) return render(data, _);
    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled function source as a convenience for precompilation.
    template.source = 'function(' + (settings.variable || 'obj') + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function, which will delegate to the wrapper.
  _.chain = function(obj) {
    return _(obj).chain();
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(obj) {
    return this._chain ? _(obj).chain() : obj;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name == 'shift' || name == 'splice') && obj.length === 0) delete obj[0];
      return result.call(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result.call(this, method.apply(this._wrapped, arguments));
    };
  });

  _.extend(_.prototype, {

    // Start chaining a wrapped Underscore object.
    chain: function() {
      this._chain = true;
      return this;
    },

    // Extracts the result from a wrapped and chained object.
    value: function() {
      return this._wrapped;
    }

  });

}).call(this);


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var Injector = __webpack_require__(353);
    var Configuration = __webpack_require__(27);
    var EventDispatcher = __webpack_require__(54); // included here because of circular dependencies other way around

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var log = new Logger("Events");

    /*
     * Patches Backbone.Events.trigger to catch any unhandled errors, to allow the context (e.g. model) to continue
     * with with events propagation to avoid it leaving the context (model) in some state that will prevent further
     * event propagation (forever, until reload!). Instead, any unhandled error is raised with a timeout (of zero),
     * so the error(s) is (are) still raised, but in a manner that will allow "normal execution" afterwards. But,
     * since unhandled errors may still occur, the context may still be bogus, but at least we can prevent the
     * editor from not doing any more work, like not trying to save a model.
     *
     * For further discussion, see: https://github.com/jashkenas/backbone/issues/1527
     */

    var eventSplitter = /\s+/;
    var errorQueue = [];
    var firstError = null;
    var errorSequence = 1;
    var errorCount = 0;
    var timer = null;

    // Implement fancy features of the Events API such as multiple event
    // names `"change blur"` and jQuery-style event maps `{change: action}`
    // in terms of the existing API.
    function eventsApi(obj, action, name, rest) {
        // Copied and fixed for warnings from Backbone.Event
        if (!name) {
            return true;

            // Handle event maps.
        } else if ((typeof name === "undefined" ? "undefined" : _typeof(name)) === "object") {
            for (var key in name) {
                obj[action].apply(obj, _toConsumableArray([key, name[key]].concat(rest)));
            }
            return false;

            // Handle space separated event names.
        } else if (eventSplitter.test(name)) {
            var names = name.split(eventSplitter);
            var l = names.length;
            var i = void 0;

            for (i = 0; i < l; i++) {
                obj[action].apply(obj, _toConsumableArray([names[i]].concat(rest)));
            }
            return false;
        }

        return true;
    }

    /**
     * @private
     * Returns the configured error logger
     *
     * @returns {ErrorLogger} The configured error logger, or null if not available.
     */
    function errorLogger() {
        // This can potentially go sour if the error logger has not be registered yet, i.e. we have a unhandled
        // error as part of the Backbone app initialisation...
        if (!errorLogger.logger) {
            if (Injector.has("errorLogger")) {
                errorLogger.logger = Injector.get("errorLogger");
            }
        }
        return errorLogger.logger;
    }

    /**
     * @private
     * Reports the supplied error by logging it to the console and reporting it via the <tt>ErrorLogger</tt> used,
     * if any. <p>
     *
     * The first reported error is ignored by this, since it will be re-raised as unhandled later on, thus reported
     * there.
     *
     * @param {*} entry The (queued) entry <tt>{scope:*, errors:[]{error:Error|String, order:Number}}</tt>,
     *                  to report; never null.
     */
    function reportErrors(entry) {
        var i = void 0;
        var err = void 0;
        var errors = entry.errors;
        var logger = errorLogger();

        for (i = 0; i < errors.length; i++) {
            err = errors[i];
            // Already reported, since that is the first one and thus raised again as unhandled...
            if (err.order >= 1) {
                // if not, error.error === firstError!
                // Tag message with sequence for easier tracking in the frontend service error log, will also
                // be set on the first error re-thrown. If an error already, this can be a read-only property,
                // so we have to guard it with a try-catch...
                var resolved = void 0;
                try {
                    resolved = (err.error.message || "unknown error") + (errorCount > 1 ? " (#" + err.sequence + "." + err.order + ")" : "");
                    err.error.message = resolved;
                } catch (e) {} // e.g. TypeError, SecurityError
                // Fall-through...


                // Akin to unhandled exceptions being logged as errors by default by the browser...
                log.error("Uncaught " + err.error + ", " + (err.error.stack || err.error));
                // Mimics behaviour for unhandled errors in ErrorLogger, but with a bit more info...
                if (logger) {
                    logger.log({
                        unhandled: resolved || err.error.message, // since the try-catch can fail above!
                        trace: err.error.stack && err.error.stack.toString().split(/\s*\n+\s*/g),
                        sequence: err.sequence,
                        order: err.order
                    });
                }
            }
        }
    }

    /**
     * @private
     * Finds or creates a new queue for the supplied scope.
     *
     * @param   {*} scope The scope to find or create the error queue for; never null.
     *
     * @returns {{scope:*, errors:Error[]}} The (created) queue for the supplied scope; never null.
     */
    function queue(scope) {
        // To avoid re-queueing errors on "error:unhandled" events...
        if (!errorQueue) {
            return null;
        }
        var i = void 0;
        var entry = void 0;

        // Does an existing queue for the supplied scope exist?
        for (i = 0; i < errorQueue.length; i++) {
            entry = errorQueue[i];
            if (entry.scope === scope) {
                return entry;
            }
        }
        // Create...
        entry = { scope: scope, errors: [] };
        errorQueue.push(entry);
        return entry;
    }

    /**
     * @private
     * Notifies all queued (scope, error) pairs about the unhandled errors via the "error:unhandled" event,
     * without re-queuing errors again, and then raises the first queued unhandled error. <p>
     *
     * The existing error queue is cleared by this.
     */
    function raiseError() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        // Temporarily setting the error queue to null ensures that unhandled errors raised by "error:unhandled" will
        // not cause an infinite loop...
        var errors = errorQueue;
        var first = firstError;
        var entry = void 0;
        var i = void 0;

        errorQueue = null;
        firstError = null;

        // Notify each scope of the error. Even though we have disabled the error queueing, we will still catch
        // unhandled errors during this notification, but merely log the errors. We cannot bootstrap the reporting
        // of frontend errors to listen for "error:unhandled", since if the frontend error service raises an error,
        // we cannot report it via it self (infinite loop). We therefore have to call the frontend error service
        // explicitly here...
        for (i = 0; i < errors.length; i++) {
            entry = errors[i];
            entry.scope.trigger("error:unhandled", entry);
            // Report errors to the ErrorLogger...
            reportErrors(entry);
        }

        // May have increased during "error:unhandled"! We tag the message with sequence information for better
        // tracing in the frontend...
        if (errorCount > 1) {
            first.message += " (#" + errorSequence + ".1)";
        }

        // Ready to queue again!
        errorQueue = [];
        errorCount = 0;
        errorSequence++;

        // Browser will log this since unhandled...
        throw first;
    }

    /**
     * Queues the unhandled error for the supplied scope. <p>
     *
     * If this is the very first error queued since the last raised error (if any), the supplied error will be
     * raised again via a timeout, to allow all pending events to be triggered.
     *
     * @param {*}            scope The scope associated with the error; never null.
     * @param {Error|String} error The unhandled error; never null.
     */
    function queueError(scope, error) {
        var entry = queue(scope);
        var err = { error: error, sequence: errorSequence, order: ++errorCount };

        if (entry) {
            entry.errors.push(err);
            if (!timer) {
                firstError = error;
                timer = setTimeout(raiseError, 0);
            }
        } else {
            reportErrors({ scope: scope, errors: [err] });
        }
    }

    /**
     * Triggers the supplied events with the specified arguments. <p>
     *
     * Any error raised from a called event handler will be caught and queued for later reporting, allowing all
     * event handlers to be notified. This fundamentally changes Backbone behaviour, since normally uncaught
     * exceptions could/would break it, i.e. events not triggered henceforth (i.e. saving suddenly stops).
     *
     * @param {String[]} events Array of the events to fire, in order; never null, never empty.
     * @param {[]}       args   Arguments for each fired event, in order; never null, but can be empty.
     */
    function triggerEvents(events, args) {
        // Copied, patched (try-catch), and fixed for warnings from Backbone.Event
        var ev = void 0;
        var i = -1;
        var l = events.length;
        var a1 = args[0];
        var a2 = args[1];
        var a3 = args[2];

        switch (args.length) {
            case 0:
                while (++i < l) {
                    try {
                        (ev = events[i]).callback.call(ev.ctx);
                    } catch (e) {
                        queueError(ev.ctx, e);
                    }
                }return;
            case 1:
                while (++i < l) {
                    try {
                        (ev = events[i]).callback.call(ev.ctx, a1);
                    } catch (e) {
                        queueError(ev.ctx, e);
                    }
                }return;
            case 2:
                while (++i < l) {
                    try {
                        (ev = events[i]).callback.call(ev.ctx, a1, a2);
                    } catch (e) {
                        queueError(ev.ctx, e);
                    }
                }return;
            case 3:
                while (++i < l) {
                    try {
                        (ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
                    } catch (e) {
                        queueError(ev.ctx, e);
                    }
                }return;
            default:
                while (++i < l) {
                    try {
                        (ev = events[i]).callback.apply(ev.ctx, args);
                    } catch (e) {
                        queueError(ev.ctx, e);
                    }
                }}
    }

    /**
     * Triggers the specified event name for the current scope, ensuring that errors will not cause
     * the execution to stop. Errors are recorded, and once all handlers have been notified, the
     * first error will be re-raised. <p>
     *
     * Arguments 1-n will be supplied as arguments for the triggered event(s).
     *
     * @param {String|*} name Event name(s) to trigger, separated by space, or an object like {name: action, ..}.
     */
    var zmagsTrigger = function zmagsTrigger(name) {
        // Copied and fixed for warnings from Backbone.Event
        if (!this._events) {
            return this;
        }

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        if (!eventsApi(this, "trigger", name, args)) {
            return this;
        }
        var events = this._events[name];
        var allEvents = this._events.all;

        if (events) {
            triggerEvents(events, args);
        }
        if (allEvents) {
            var triggerArgs = [name].concat(args);
            triggerEvents(allEvents, triggerArgs);
        }
        return this;
    };

    // Allow safe mode to be turned off, i.e. use original Backbone functionality. This is basically a test feature
    // to allows us to ensure that the system will run - assuming no unhandled errors - the same with or without
    // this event patch!...
    var safeMode = function safeMode() {
        return Configuration.val({
            name: "zmagsSafeMode", configName: "safeMode", type: "number", defaultValue: 1
        });
    };

    /**
     * Patches the supplied named target recursively through its prototype chain with the patched trigger function. <p>
     *
     * Important: the scope for the trigger function is always correct, even when a given object is patched and not
     * its prototype, so we do not have to bind "zmagsTrigger" to the object it self.
     *
     * @param {*}      target The target to patch, i.e. replace its "trigger" function with the patched version.
     * @param {String} name   The user-friendly name of target, for logging purposes only; never null.
     */
    var patchTarget = function patchTarget(target, name) {
        var type = typeof target === "undefined" ? "undefined" : _typeof(target);
        // Object for prototypes and plain on {}, function for types...
        if (target && (type === "object" || type === "function")) {
            if (typeof target.trigger === "function" && target.trigger !== zmagsTrigger) {
                target.trigger = zmagsTrigger; // will have correct scope!
                log.verbose("Patched: " + name + ".trigger", target);
            }
            // Check prototype recursively...
            var proto = target.prototype;
            if (proto) {
                patchTarget(proto, name + ":proto"); // do not call "patch" here, since we would have to maintain a graph to avoid circular dependencies!
            }
        }
    };

    /**
     * Patches the supplied named target and any relevant property, all recursively through their prototype chains
     * with the patched trigger function. That is, if <tt>target</tt> declares or inherits a "trigger" function via
     * is prototype, it will be patched, and the same is true for any other declared property (expect "$", which is
     * ignored). Recursion does not apply to properties of properties, only first level ones. <p>
     *
     * Note: if the configuration property "zmagsSafeMode"/"safeMode" is set to 0, no patching is made! This is a
     * debug feature only, to ensure that the patch will not affect normal execution (i.e. when no errors).
     *
     * @param {*}      target The target to patch, i.e. replace its "trigger" function with the patched version.
     * @param {String} name   The user-friendly name of target, for logging purposes only; never null.
     *
     * @return {Function} This patch function for chaining; never null.
     */
    var patch = function patch(target, name) {
        if (safeMode()) {
            name = name || target.name || "?";
            // Try patching "target" itself, e.g. "target.trigger"...
            patchTarget(target, name);
            // Try patching each property recursively then...
            var key = void 0;
            for (key in target) {
                // Different kind of trigger... :)
                if (key !== "$") {
                    patchTarget(target[key], name + "." + key);
                }
            }
        } else {
            log.verbose("Non safe-mode, will not patch: " + name, target);
        }
        return patch;
    };

    // For objects who has yet to extend Backbone.Events *and* for objects that we know have assigned Backend.Events
    // to their prototype...
    return patch(Backbone, "Backbone")(EventDispatcher, "EventDispatcher"); // included here because of circular dependencies!
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable strict,prefer-template,no-var,object-shorthand */

const EnvironmentNames = {
    DOCKER_STAGE: "docker-stage",
    DOCKER_CLUSTER: "docker-cluster",
    BRANCH: "branch",
    DEV: "dev",
    LOCAL: "local",
    PROD: "prod",
    CNC: "cnc"
};

const PROD_CNC_VIEW_FULL_BASE_URL = "https://cnc-api.zmags.com/view/full/";
const PROD_CNC_VIEW_LITE_BASE_URL = "https://cnc-api.zmags.com/view/lite/";
const DEV_CNC_VIEW_FULL_BASE_URL = "http://nocache-cnc-api-dev.zmags.com/view/full/";
const DEV_CNC_VIEW_LITE_BASE_URL = "http://nocache-cnc-api-dev.zmags.com/view/lite/";
const DOCKER_STAGE_CNC_VIEW_FULL_BASE_URL = "http://localhost:8081/view/full/";
const DOCKER_STAGE_CNC_VIEW_LITE_BASE_URL = "http://localhost:8081/view/lite/";

const PROD_PSD_IMPORT_BASE_URL = "https://design-file-import.creator-prod.zmags.com";
const DEV_PSD_IMPORT_BASE_URL = "https://design-file-import.creator-stage.zmags.com";

const PROD_BEHAVIOR_UI_BASE_URL = "https://behaviors.zmags.com";
const DEV_BEHAVIOR_UI_BASE_URL = "https://staging.behaviors.zmags.com";

const PROD_CREATOR_SETTINGS_API_BASE_URL = "https://creator-settings.api.zmags.com";
const DEV_CREATOR_SETTINGS_API_BASE_URL = "https://creator-settings-stg.api.zmags.com";

const PROD_C3_API_BASE_URI="https://contentcontrol.api.zmags.com";
const STAGE_C3_API_BASE_URI="https://c3-api-stg.sandbox-dev.zmags.com";
const DEV_C3_API_BASE_URI="https://c3-api-dev.sandbox-dev.zmags.com";

const PROD_LIVE_API_BASE_URL = "https://creator-api.zmags.com";
const PROD_EDITOR_BASE_URL = "//creator.zmags.com";
const PROD_VIEWER_BASE_URL = "//c.zmags.com";
const PROD_VIEWER_ALIAS_BASE_URL = "//creator.zmags.com";

const DEV_LIVE_API_BASE_URL = "https://creator-dev-api.zmags.com";
const DEV_EDITOR_BASE_URL = "//creator-dev.zmags.com";

const DEV_VIEWER_BASE_URL = "//c-dev.zmags.com";
const DEV_CNC_SSR_API_BASE_URL = "//c-dev.zmags.com";
const DEV_VIEWER_ALIAS_BASE_URL = "//creator-dev.zmags.com";

const DEV_ERROR_QUEUE_URL = "https://c-dev.zmags.com/queue/error/";
const PROD_ERROR_QUEUE_URL = "https://c.zmags.com/queue/error/";

const DEV_CAS_URL = "https://cas-stage.zma.gs/";
const PROD_CAS_URL = "https://cas.zma.gs/";

const STATSD_URL = "https://statsd.zmags.com/stats";

const AUTH0_DOMAIN = "https://zmags.us.auth0.com";
const AUTH0_AUDIENCE = "https://api.zmags.com/";
const PROD_AUTH0_CLIENT_ID = "XGTeepJiX2c78VRgP8OFxN0Mf4kggvby";
const DEV_AUTH0_CLIENT_ID = "nLsZ7qxH6nRW5AuHXvDC7PeBeK67B7b5";

const LOCAL_LIVE_API_BASE_URL = "http://localhost:8080/experience-server";
const LOCAL_EDITOR_BASE_URL = "http://localhost:9009/mosaik"; // Local S3
const PROD_EDITOR_SEGMENT_IO_KEY = "20jbiv8frx";
const LOCAL_EDITOR_SEGMENT_IO_KEY = "tewkjvnii8";

const DOCKER_LIVE_API_BASE_URL = "http://localhost:8080/experience-server";
const DOCKER_EDITOR_BASE_URL = "http://localhost:9000/mosaik"; // Local S3

const DOCKER_STAGE_LIVE_API_BASE_URL = "http://localhost:8080/experience-server";
const DOCKER_STAGE_EDITOR_BASE_URL = "http://localhost:9000";

const BRANCH_EDITOR_SEGMENT_IO_KEY = "XEgfW02w90ZP4BgQWnZ6XeZYjUJZEOeR";

const COMMUNITY_BASE_URL = "https://creatorcommunity.zmags.com";
const SALES_EMAIL = "sales@zmags.com";
const SUPPORT_EMAIL = "support@zmags.com";
const CLOUDINARY_PROVIDER_BASE_URL = "//images.creator-stage.zmags.com/image/upload";
const CLOUDINARY_PROVIDER_PRODUCTION_URL = "https://images.creator-prod.zmags.com/image/upload";
const OMETRIA_API_STAGE_URL = "https://tst-ometria.api.zmags.com/v1/email/generate";
const OMETRIA_API_PRODUCTION_URL = "https://ometria.api.zmags.com/v1/email/generate";
const KLAVIYO_API_STAGE_URL= "https://tst-klaviyo.api.zmags.com/v1/email/generate";
const KLAVIYO_API_PRODUCTION_URL="https://klaviyo.api.zmags.com/v1/email/generate";
const SFMC_API_STAGE_URL= "https://tst-sfmc.api.zmags.com/v1/email/generate";
const SFMC_API_PRODUCTION_URL="https://sfmc.api.zmags.com/v1/email/generate";
const GOOGLE_WEBFONTS_API_BASE_URL = "https://www.googleapis.com/webfonts/v1/webfonts";
const GOOGLE_WEBFONTS_API_KEY  = "AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI";

const BRANCH_IMAGES_BASE_URL  = "https://s3-eu-west-1.amazonaws.com/zmags.mosaik.branch";

const SENTRY_DSN = "https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460";

const PROD_CONTENT_CONTROL_URL = "https://manage.creatorbyzmags.com/";
const DEV_CONTENT_CONTROL_URL = "https://staging.manage.creatorbyzmags.com/";
const LOCAL_CONTENT_CONTROL_URL = "https://development.manage.creatorbyzmags.com/";

// Docker Cluster
const dockerCluster = Object({"NODE_ENV":"production","APP_CONFIG":{"env":"PROD","cncViewFullBaseUrl":"https://cnc-api.zmags.com/view/full/","cncViewLiteBaseUrl":"https://cnc-api.zmags.com/view/lite/","psdImportBaseUrl":"https://design-file-import.creator-prod.zmags.com","behaviorUiBaseUrl":"https://behaviors.zmags.com","creatorSettingApiBaseUrl":"https://creator-settings.api.zmags.com","c3ApibaseUrl":"https://contentcontrol.api.zmags.com","adminApiBaseUrl":"https://creator-api.zmags.com","editorBaseUrl":"//creator.zmags.com","viewerBaseUrl":"//c.zmags.com","viewerApiBaseUrl":"//c.zmags.com","cncStaticAssetsBaseUrl":"//c.zmags.com/static/","cncStaticAssetsFiles":["client.js","manifest.js","vendor.js","styles.css"],"cncSsrApiBaseUrl":"//c.zmags.com","viewerAliasApiBaseUrl":"//creator.zmags.com","communityBaseUrl":"https://creatorcommunity.zmags.com","errorQueueUrl":"https://c.zmags.com/queue/error/","statsDUrl":"https://statsd.zmags.com/stats","auth0Domain":"https://zmags.us.auth0.com","auth0Audience":"https://api.zmags.com/","auth0ClientId":"XGTeepJiX2c78VRgP8OFxN0Mf4kggvby","ometriaApiUrl":"https://ometria.api.zmags.com/v1/email/generate","klaviyoApiUrl":"https://klaviyo.api.zmags.com/v1/email/generate","sfmcApiUrl":"https://sfmc.api.zmags.com/v1/email/generate","cloudinaryProviderUrl":"https://images.creator-prod.zmags.com/image/upload","salesEmail":"sales@zmags.com","supportEmail":"support@zmags.com","editorSegmentIOKey":"20jbiv8frx","matomoConfig":{"trackingScriptUrl":"//c.z-analytics.net/reporting/optimize/ztracker.js","trackerUrl":"","dashboardUrl":"//auth.reporting.creator-prod.zmags.com","segmentUrl":"//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php","siteID":1},"zsitesConfig":"//auth.reporting.creator-prod.zmags.com/","zsitesSecret":"zM4gzS3cr3t","inventoryUrl":"https://authproxy.creator-prod.zmags.com/inventory/v1/products/map","answerFileUrl":"https://static.inventory.creator-prod.zmags.com/dynamic_pricing/answer_files/","experienceUrl2PngBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/experience/signed/url2png/","experienceSharedEntityBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/sharedEntity/","msExperiencesUrl":"https://authproxy.creator-prod.zmags.com/experiences","microserviceCompanyUrl":"https://authproxy.creator-prod.zmags.com/company/","proxyUrl":"https://authproxy.creator-prod.zmags.com","forgotPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","resetPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","changePasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithTokenBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithSsoBaseUrl":"https://authproxy.creator-prod.zmags.com","loginActiveDirectoryBaseUrl":"https://creator-api.zmags.com","googleWebFontsApiBaseUrl":"https://www.googleapis.com/webfonts/v1/webfonts","googleWebFontsApiKey":"AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI","casUrl":"https://cas.zma.gs/","contentControlUrl":"https://manage.creatorbyzmags.com/","enableLogging":1,"logId":null,"trackErrors":true,"sentryEnabled":true,"sentryDSN":"https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460","experienceId":null,"groupId":null,"scene":null,"statsDBucket":"creator.prod","version":"livadug4","maxRetries":3},"VERSION_DATA":{"hash":"d470bd93f6","numCommits":32725,"buildDate":1686721411191,"dirty":false,"name":"creator"}}).DOCKER_CLUSTER_VAR;

const DOCKER_CLUSTER_PSD_IMPORT_BASE_URL = "http://" + dockerCluster + ".design-file-import.branch.creator-dev-act.zmags.com";
const DOCKER_CLUSTER_BEHAVIOR_UI_BASE_URL = "https://staging.behaviors.zmags.com/";
const DOCKER_CLUSTER_CREATOR_BASE_URL = "http://creator." + dockerCluster + ".branch.creator-dev-act.zmags.com";
const DOCKER_CLUSTER_CNC_BASE_URL = "http://" + dockerCluster + ".cnc-api.branch.creator-dev-act.zmags.com";
const DOCKER_CLUSTER_ERROR_QUEUE_URL = DOCKER_CLUSTER_CREATOR_BASE_URL + "/queue/error/";
const DOCKER_CLUSTER_LIVE_API_BASE_URL = "http://" + dockerCluster + ".creator-api.branch.creator-dev-act.zmags.com/experience-server";
// These non-branch-specific URLs direct through Akamai, which redirects to the appropriate cluster based on headers.
const CLOUDINARY_PROVIDER_DOCKER_CLUSTER_URL = "http://images.branch.creator-dev-act.zmags.com/image/upload";

const MATOMO_LOCAL_CONFIG = {
    trackingScriptUrl: "//c-dev.z-analytics.net/reporting/optimize/ztracker.js", // TODO: for heatmaps does it have to be per client?
    trackerUrl: "//localhost:8004/clients/perfumania/matomo/piwik.php", // this gets overridden by zelp
    dashboardUrl: "http://localhost:8001/modules/Auth/Auth.php",
    segmentUrl: "http://localhost:8001/modules/Onboarding/SegmentCreation.php",
    siteID: 1
};

const MATOMO_DOCKER_CLUSTER_CONFIG = {
    trackingScriptUrl: "//creator.branch.creator-dev-act.zmags.com/reporting/optimize/ztracker.js",
    trackerUrl: "",  // gets overriden by zelp
    dashboardUrl: "//auth.reporting.creator-stage.zmags.com", // TODO: needs staging url auth.reporting.creator-stage.zmags.com?
    segmentUrl: "//onboarding.reporting.creator-stage.zmags.com/SegmentCreation.php",
    siteID: 1
};

const MATOMO_DOCKER_CONFIG = {
    trackingScriptUrl: "//c-dev.z-analytics.net/reporting/optimize/ztracker.js", // TODO: for heatmaps does it have to be per client?
    trackerUrl: "//localhost:8004/clients/perfumania/matomo/piwik.php", // this gets overridden by zelp
    dashboardUrl: "http://localhost:8001/modules/Auth/Auth.php",
    segmentUrl: "http://localhost:8001/modules/Onboarding/SegmentCreation.php",
    siteID: 1
};

const MATOMO_BRANCH_CONFIG = {
    trackingScriptUrl: "//c-dev.z-analytics.net/reporting/optimize/ztracker.js",
    trackerUrl: "", // gets overriden by zelp
    dashboardUrl: "http://localhost:8001/modules/Auth/Auth.php",
    segmentUrl: "http://localhost:8001/modules/Onboarding/SegmentCreation.php",
    siteID: 1
};

const MATOMO_DEV_CONFIG = {
    trackingScriptUrl: "//c-dev.z-analytics.net/reporting/optimize/ztracker.js",
    trackerUrl: "",  // gets overriden by zelp
    dashboardUrl: "//auth.reporting.creator-stage.zmags.com", // TODO: needs staging url auth.reporting.creator-stage.zmags.com?
    segmentUrl: "//onboarding.reporting.creator-stage.zmags.com/SegmentCreation.php",
    siteID: 1
};

const MATOMO_PROD_CONFIG = {
    trackingScriptUrl: "//c.z-analytics.net/reporting/optimize/ztracker.js",
    trackerUrl: "", // gets overriden by zelp
    dashboardUrl: "//auth.reporting.creator-prod.zmags.com", // TODO: needs a prod url
    segmentUrl: "//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php",
    siteID: 1
};

const CNC_STATIC_ASSETS = [
    "client.js",
    "manifest.js",
    "vendor.js",
    "styles.css"
]

const ZSITES_LOCAL_URL = "http://localhost:8001/modules/Auth/Auth.php";
const ZSITES_DOCKER_URL = "http://localhost:8001/modules/Auth/Auth.php";
const ZSITES_BRANCH_URL = "http://localhost:8001/modules/Auth/Auth.php";
const ZSITES_DEV_URL = "//auth.reporting.creator-stage.zmags.com/"; // TODO: needs staging url auth.reporting.creator-stage.zmags.com?
const ZSITES_PROD_URL = "//auth.reporting.creator-prod.zmags.com/"; // TODO: needs a prod url
const ZSITES_SECRET = "zM4gzS3cr3t";
//const ZSITES_DOCKER_CLUSTER_URL = "//auth." + dockerCluster + ".branch.creator-dev-act.pvt.zmags.com/";

// NOTE: This is the proxy port number, that proxies over to inventory  (inventory's port is actually 9903)
const INVENTORY_LOCAL_BASE_URL = "http://localhost:9904";
const INVENTORY_DOCKER_BASE_URL = "http://localhost:9904";
const INVENTORY_STAGE_BASE_URL = "https://authproxy.creator-stage.zmags.com";
const INVENTORY_PROD_BASE_URL = "https://authproxy.creator-prod.zmags.com";
const INVENTORY_DOCKER_CLUSTER_BASE_URL = "http://authproxy." + dockerCluster + ".branch.creator-dev-act.zmags.com:9904";

const INVENTORY_PRODUCT_URL = "/inventory/v1/products/map";

// TODO: Create a way to run inventory answerfiles locally?
const ANSWERFILE_STAGE_BASE_URL = "https://static.inventory.creator-stage.zmags.com";
const ANSWERFILE_PROD_BASE_URL = "https://static.inventory.creator-prod.zmags.com";
const ANSWERFILE_DOCKER_CLUSTER_BASE_URL = "http://zmags.dev.branch." + dockerCluster + ".web.inventory.s3-website-us-east-1.amazonaws.com";

const ANSWERFILE_DYNAMIC_PRICING_URL = "/dynamic_pricing/answer_files/";

// MS-PROXY
const MS_PROXY_STAGE_BASE_URL = "https://authproxy.creator-stage.zmags.com";
const MS_PROXY_PROD_BASE_URL = "https://authproxy.creator-prod.zmags.com";
const MS_PROXY_LOCAL_BASE_URL = "http://localhost:9904";
const MS_PROXY_DOCKER_STAGE_BASE_URL = MS_PROXY_STAGE_BASE_URL; //docker talks to stage was the original value!  Not sure this was correct @eric?
const MS_PROXY_DOCKER_BASE_URL = MS_PROXY_STAGE_BASE_URL; //docker talks to stage was the original value!  Not sure this was correct @eric?
const MS_PROXY_BRANCH_BASE_URL = MS_PROXY_STAGE_BASE_URL; //not sure this is correct.  Old code defined to go here but experiences talks to stage in this context! @Eric (definition was in the const BRANCH_CONFIG setting)
const MS_PROXY_DOCKER_CLUSTER_BASE_URL = "http://authproxy." + dockerCluster + ".branch.creator-dev-act.zmags.com:9904"

// MS-EXPERIENCES
const MS_EXPERIENCES_LOCAL_BASE_URL = "http://localhost:9905"; //DIRECT to ms_experiences
const MS_EXPERIENCES_DOCKER_BASE_URL = "http://localhost:9905"; //DIRECT to ms_experiences
const MS_EXPERIENCES_BRANCH_BASE_URL = "http://internal.experiences.creator-stage.zmags.com:9905"; //DIRECT to ms_experiences
const MS_EXPERIENCES_STAGE_BASE_URL = MS_PROXY_STAGE_BASE_URL; //route through ms_proxy
const MS_EXPERIENCES_PROD_BASE_URL = MS_PROXY_PROD_BASE_URL; //route through ms_proxy
const MS_EXPERIENCES_DOCKER_CLUSTER_BASE_URL = MS_PROXY_DOCKER_CLUSTER_BASE_URL;

// PATH TO URL2PNG for experiences
const MS_PROXY_EXPERIENCES = "/experiences"; //additional path needed for routed calls through ms-proxy to reach it's defined ms-experiences endpoint.
const MS_PROXY_COMPANY = "/company/";
const MS_EXPERIENCES_URL2PNG_URL = "/v1/experience/signed/url2png/";
const MS_EXPERIENCES_SHARED_ENTITY_URL = "/v1/sharedEntity/";


/**
 * Production config
 *
 * adminApiBaseUrl:                 String      The API url where editor talks to(editor backend),
 * editorBaseUrl:                   String      The url where we open the editor page,
 * viewerBaseUrl:                   String      The url where we open the viewer page,
 * viewerApiBaseUrl:                String      The url where viewer requests assets and all other data(experiences, config etc),
 * viewerAliasApiBaseUrl:           String      The alias url of assets for parallel images downloading,
 * communityBaseUrl:                String      The url where we open the community page
 * salesEmail:                      String      The email address of sales team
 * supportEmail:                    String      The email address of customer support
 * editorSegmentIOKey:              String      The segmentIO key for editor
 * matomoConfig:                    Object      The configuration of the Matomo tracking used by the viewer.
 * errorQueueUrl:                   String      The url used to dump all front end errors from both editor and viewer
 * enableLogging:                   Number      The default logging level {@see util/Logger.js class}
 * logId:                           String      Optional postfix for all logger names when more than one channel injects a viewer on the same page {@see util/Logger.js class}
 * trackErrors:                     Boolean     Enable/disable error tracking. Errors will be reported to StatsD
 * sentryEnabled:                   Boolean     Enable/disable error tracking with Sentry.
 * sentryDSN:                       String      Data Source Name for Sentry.io analytics to be delivered to.
 * experienceId:                    String      The value of current experience id, used in the viewer
 * groupId:                         String      The value of current group id, used in the viewer
 * scene:                           Number      The initial scene to show, used in the viewer
 * statsDBucket:                    String      the statistics bucket name
 * version:                         String      The build version
 */
const PROD_CONFIG = {
    env: "PROD",
    cncViewFullBaseUrl: PROD_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: PROD_CNC_VIEW_LITE_BASE_URL,
    psdImportBaseUrl: PROD_PSD_IMPORT_BASE_URL,
    behaviorUiBaseUrl: PROD_BEHAVIOR_UI_BASE_URL,
    creatorSettingApiBaseUrl: PROD_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: PROD_C3_API_BASE_URI,
    adminApiBaseUrl: PROD_LIVE_API_BASE_URL,
    editorBaseUrl: PROD_EDITOR_BASE_URL,
    viewerBaseUrl: PROD_VIEWER_BASE_URL,
    viewerApiBaseUrl: PROD_VIEWER_BASE_URL,
    cncStaticAssetsBaseUrl: PROD_VIEWER_BASE_URL + "/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: PROD_VIEWER_BASE_URL,
    viewerAliasApiBaseUrl: PROD_VIEWER_ALIAS_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: PROD_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: PROD_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_PRODUCTION_URL,
    klaviyoApiUrl: KLAVIYO_API_PRODUCTION_URL,
    sfmcApiUrl: SFMC_API_PRODUCTION_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_PRODUCTION_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: PROD_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_PROD_CONFIG,
    zsitesConfig: ZSITES_PROD_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_PROD_BASE_URL + INVENTORY_PRODUCT_URL,
    answerFileUrl: ANSWERFILE_PROD_BASE_URL + ANSWERFILE_DYNAMIC_PRICING_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_PROD_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_PROD_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    msExperiencesUrl: MS_EXPERIENCES_PROD_BASE_URL + MS_PROXY_EXPERIENCES,
    microserviceCompanyUrl: MS_EXPERIENCES_PROD_BASE_URL + MS_PROXY_COMPANY,
    proxyUrl: MS_PROXY_PROD_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_PROD_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_PROD_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_PROD_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_PROD_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_PROD_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_PROD_BASE_URL,
    loginActiveDirectoryBaseUrl: PROD_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey:GOOGLE_WEBFONTS_API_KEY,
    casUrl:PROD_CAS_URL,
    contentControlUrl: PROD_CONTENT_CONTROL_URL,
    enableLogging: 1,
    logId: null,
    trackErrors: true,
    sentryEnabled: true,
    sentryDSN: SENTRY_DSN,
    experienceId: null,
    groupId: null,
    scene: null,
    statsDBucket: "creator.prod",
    version: null,
    maxRetries: 3
};

/**
 * Development config (only for creator-dev.zmags.com)
 */
const DEV_CONFIG = {
    env: "DEV",
    cncViewFullBaseUrl: DEV_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: DEV_CNC_VIEW_LITE_BASE_URL,
    psdImportBaseUrl: DEV_PSD_IMPORT_BASE_URL,
    behaviorUiBaseUrl: DEV_BEHAVIOR_UI_BASE_URL,
    creatorSettingApiBaseUrl: DEV_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: STAGE_C3_API_BASE_URI,
    adminApiBaseUrl: DEV_LIVE_API_BASE_URL,
    editorBaseUrl: DEV_EDITOR_BASE_URL,
    viewerBaseUrl: DEV_VIEWER_BASE_URL,
    viewerApiBaseUrl: DEV_VIEWER_BASE_URL,
    cncStaticAssetsBaseUrl: DEV_CNC_SSR_API_BASE_URL + "/static/", // "http://localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: DEV_CNC_SSR_API_BASE_URL,
    viewerAliasApiBaseUrl: DEV_VIEWER_ALIAS_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: LOCAL_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_DEV_CONFIG,
    zsitesConfig: ZSITES_DEV_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_STAGE_BASE_URL + INVENTORY_PRODUCT_URL,
    answerFileUrl: ANSWERFILE_STAGE_BASE_URL + ANSWERFILE_DYNAMIC_PRICING_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    msExperiencesUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES,
    microserviceCompanyUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_COMPANY,
    proxyUrl: MS_PROXY_STAGE_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_STAGE_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_STAGE_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_STAGE_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_STAGE_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_STAGE_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_STAGE_BASE_URL,
    loginActiveDirectoryBaseUrl: DEV_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey:GOOGLE_WEBFONTS_API_KEY,
    casUrl:DEV_CAS_URL,
    contentControlUrl: DEV_CONTENT_CONTROL_URL,
    enableLogging: 2,
    logId: null,
    trackErrors: true,
    sentryEnabled: true,
    sentryDSN: SENTRY_DSN,
    experienceId: null,
    groupId: null,
    scene: null,
    statsDBucket: "creator.dev",
    version: null,
    maxRetries: 3

};

/**
 * Branch config, running against their own backends and frontends (Cover master branch and all other dev branches).
 */
const BRANCH_CONFIG = {
    env: "BRANCH",
    // The baseUrls must be configured per branch. See configure-branch and build:branch task and injectBranchConfig function.
    // see Gruntfile.js
    // adminApiBaseUrl:
    // editorBaseUrl:
    // viewerBaseUrl:
    // viewerApiBaseUrl:
    // viewerAliasApiBaseUrl:
    cncViewFullBaseUrl: DEV_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: DEV_CNC_VIEW_LITE_BASE_URL,
    psdImportBaseUrl: DEV_PSD_IMPORT_BASE_URL,
    behaviorUiBaseUrl: DEV_BEHAVIOR_UI_BASE_URL,
    creatorSettingApiBaseUrl: DEV_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: DEV_C3_API_BASE_URI,
    cncStaticAssetsBaseUrl: "//localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: DEV_CNC_SSR_API_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: BRANCH_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_BRANCH_CONFIG,
    zsitesConfig: ZSITES_BRANCH_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_LOCAL_BASE_URL + INVENTORY_PRODUCT_URL,
    // This is direct to ms-experiences bypassing the proxy since branch proxy auth doesn't work
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_BRANCH_BASE_URL + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_BRANCH_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    msExperiencesUrl: MS_EXPERIENCES_BRANCH_BASE_URL + MS_PROXY_EXPERIENCES,
    microserviceCompanyUrl: MS_EXPERIENCES_BRANCH_BASE_URL + MS_PROXY_COMPANY,
    // experienceUrl2PngBaseUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_EXPERIENCES_URL2PNG_URL,
    proxyUrl: MS_PROXY_BRANCH_BASE_URL,
    // forgotPasswordBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // resetPasswordBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // changePasswordBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // loginWithTokenBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // loginWithPasswordBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // loginWithSsoBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    // loginActiveDirectoryBaseUrl: MS_PROXY_BRANCH_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey: GOOGLE_WEBFONTS_API_KEY,
    branchImagesBaseUrl: BRANCH_IMAGES_BASE_URL,
    contentControlUrl: LOCAL_CONTENT_CONTROL_URL,
    enableLogging: 1,
    logId: null,
    trackErrors: true,
    sentryEnabled: true,
    sentryDSN: SENTRY_DSN,
    experienceId: null,
    groupId: null,
    scene: null,
    version: null,
    maxRetries: 3
};

/**
 * Local config for running local backend
 */
const LOCAL_CONFIG = {
    env: "LOCAL",
    cncViewFullBaseUrl: "http://localhost:8081/view/full/",
    cncViewLiteBaseUrl: "http://localhost:8081/view/lite/",
    psdImportBaseUrl: "http://localhost:3000",
    behaviorUiBaseUrl: "http://localhost:3000",
    creatorSettingApiBaseUrl: DEV_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: DEV_C3_API_BASE_URI,
    adminApiBaseUrl: LOCAL_LIVE_API_BASE_URL,
    editorBaseUrl: LOCAL_EDITOR_BASE_URL,
    viewerBaseUrl: LOCAL_EDITOR_BASE_URL,
    viewerApiBaseUrl: LOCAL_EDITOR_BASE_URL,
    viewerAliasApiBaseUrl: LOCAL_EDITOR_BASE_URL,
    cncStaticAssetsBaseUrl: "http://localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    // This isn't really the API base URL so much so as the env base URL.
    cncSsrApiBaseUrl: "http://localhost:8081",
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: LOCAL_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_LOCAL_CONFIG,
    zsitesConfig: ZSITES_LOCAL_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_LOCAL_BASE_URL + INVENTORY_PRODUCT_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    microserviceCompanyUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_PROXY_COMPANY,
    msExperiencesUrl: MS_EXPERIENCES_LOCAL_BASE_URL + MS_PROXY_EXPERIENCES,
    proxyUrl: MS_PROXY_LOCAL_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_LOCAL_BASE_URL,
    loginActiveDirectoryBaseUrl: LOCAL_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey:GOOGLE_WEBFONTS_API_KEY,
    casUrl:DEV_CAS_URL,
    contentControlUrl: LOCAL_CONTENT_CONTROL_URL,
    enableLogging: 1,
    logId: null,
    trackErrors: false,
    sentryEnabled: false,
    sentryDSN: "", // confirm DSN before enabling above.
    experienceId: null,
    groupId: null,
    scene: null,
    version: null,
    maxRetries: 3
};

/**
 * Config for running docker images for experience-server, experience-client, zelp, and CNC within
 * docker and using staging (creator-dev.zmags.com) for other resources.
 */
const DOCKER_STAGE_CONFIG = {
    env: "DOCKER_STAGE",
    cncViewFullBaseUrl: DOCKER_STAGE_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: DOCKER_STAGE_CNC_VIEW_LITE_BASE_URL,
    psdImportBaseUrl: DEV_PSD_IMPORT_BASE_URL,
    behaviorUiBaseUrl: DEV_BEHAVIOR_UI_BASE_URL,
    creatorSettingApiBaseUrl: DEV_CREATOR_SETTINGS_API_BASE_URL,
    c3ApibaseUrl: DEV_C3_API_BASE_URI,
    adminApiBaseUrl: DOCKER_STAGE_LIVE_API_BASE_URL,
    viewerBaseUrl: DEV_VIEWER_BASE_URL, // Leave this at S3 for now
    viewerApiBaseUrl: DEV_VIEWER_BASE_URL,

//  this points to S3 via akamai.  Is this right?
    cncStaticAssetsBaseUrl: DEV_CNC_SSR_API_BASE_URL + "/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: DEV_CNC_SSR_API_BASE_URL,
    viewerAliasApiBaseUrl: DEV_VIEWER_ALIAS_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: LOCAL_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_DEV_CONFIG,
    zsitesConfig: ZSITES_DEV_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_STAGE_BASE_URL + INVENTORY_PRODUCT_URL,
    answerFileUrl: ANSWERFILE_STAGE_BASE_URL + ANSWERFILE_DYNAMIC_PRICING_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    microserviceCompanyUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_COMPANY,
    msExperiencesUrl: MS_EXPERIENCES_STAGE_BASE_URL + MS_PROXY_EXPERIENCES,
    proxyUrl: MS_PROXY_DOCKER_STAGE_BASE_URL, //docker talks to stage was the original value!  Not sure this was correct @eric?
    forgotPasswordBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_DOCKER_STAGE_BASE_URL,
    loginActiveDirectoryBaseUrl: DOCKER_STAGE_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey:GOOGLE_WEBFONTS_API_KEY,
    contentControlUrl: LOCAL_CONTENT_CONTROL_URL,
    enableLogging: 2,
    logId: null,
    trackErrors: true,
    sentryEnabled: true,
    sentryDSN: SENTRY_DSN,
    experienceId: null,
    groupId: null,
    scene: null,
    statsDBucket: "creator.dev",
    version: null,
    maxRetries: 3

};

/**
 *  Config for running docker-based experience-client against local services.
 * The work for this running mode is not completed.
 */
const DOCKER_CONFIG = {
    env: "DOCKER",
    cncViewFullBaseUrl: "http://localhost:8081/view/full/",
    cncViewLiteBaseUrl: "http://localhost:8081/view/lite/",
    psdImportBaseUrl: "http://localhost:3000",
    behaviorUiBaseUrl: "http://localhost:3000",
    adminApiBaseUrl: DOCKER_LIVE_API_BASE_URL,
    editorBaseUrl: DOCKER_EDITOR_BASE_URL,
    viewerBaseUrl: DOCKER_EDITOR_BASE_URL,
    viewerApiBaseUrl: DOCKER_EDITOR_BASE_URL,
    viewerAliasApiBaseUrl: DOCKER_EDITOR_BASE_URL,
    cncStaticAssetsBaseUrl: "http://localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    // This isn't really the API base URL so much so as the env base URL.
    cncSsrApiBaseUrl: "http://locahost:8081",
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DEV_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_BASE_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: LOCAL_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_DOCKER_CONFIG,
    zsitesConfig: ZSITES_DOCKER_URL,
    zsitesSecret: ZSITES_SECRET,
    inventoryUrl: INVENTORY_DOCKER_BASE_URL + INVENTORY_PRODUCT_URL,
    experienceUrl2PngBaseUrl: MS_EXPERIENCES_DOCKER_BASE_URL + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_EXPERIENCES_DOCKER_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    microserviceCompanyUrl: MS_EXPERIENCES_DOCKER_BASE_URL + MS_PROXY_COMPANY,
    msExperiencesUrl: MS_EXPERIENCES_DOCKER_BASE_URL + MS_PROXY_EXPERIENCES,
    proxyUrl: MS_PROXY_DOCKER_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_DOCKER_BASE_URL,
    loginActiveDirectoryBaseUrl: DOCKER_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey: GOOGLE_WEBFONTS_API_KEY,
    branchImagesBaseUrl: BRANCH_IMAGES_BASE_URL,
    enableLogging: 1,
    logId: null,
    trackErrors: false,
    sentryEnabled: false,
    sentryDSN: "", // confirm DSN before enabling above.
    experienceId: null,
    groupId: null,
    scene: null,
    version: null,
    maxRetries: 3
};

/**
 * Configuration for the docker cluster version running up in ECS
 */
const DOCKER_CLUSTER_CONFIG = {
    env: "DOCKER_CLUSTER",
	cncViewFullBaseUrl: DOCKER_CLUSTER_CNC_BASE_URL + "/view/full/",
	cncViewLiteBaseUrl: DOCKER_CLUSTER_CNC_BASE_URL + "/view/lite/",
    behaviorUiBaseUrl: DOCKER_CLUSTER_BEHAVIOR_UI_BASE_URL,
    psdImportBaseUrl: DOCKER_CLUSTER_PSD_IMPORT_BASE_URL,
    adminApiBaseUrl: DOCKER_CLUSTER_LIVE_API_BASE_URL,
    editorBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    viewerBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    viewerApiBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    cncStaticAssetsBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL + "/static/", // "http://localhost:8081/static/",
    cncStaticAssetsFiles: CNC_STATIC_ASSETS,
    cncSsrApiBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    viewerAliasApiBaseUrl: DOCKER_CLUSTER_CREATOR_BASE_URL,
    communityBaseUrl: COMMUNITY_BASE_URL,
    errorQueueUrl: DOCKER_CLUSTER_ERROR_QUEUE_URL,
    statsDUrl: STATSD_URL,
    auth0Domain: AUTH0_DOMAIN,
    auth0Audience: AUTH0_AUDIENCE,
    auth0ClientId: DEV_AUTH0_CLIENT_ID,
    ometriaApiUrl: OMETRIA_API_STAGE_URL,
    klaviyoApiUrl: KLAVIYO_API_STAGE_URL,
    sfmcApiUrl: SFMC_API_STAGE_URL,
    cloudinaryProviderUrl: CLOUDINARY_PROVIDER_DOCKER_CLUSTER_URL,
    salesEmail: SALES_EMAIL,
    supportEmail: SUPPORT_EMAIL,
    editorSegmentIOKey: BRANCH_EDITOR_SEGMENT_IO_KEY,
    matomoConfig: MATOMO_DOCKER_CLUSTER_CONFIG,
    //zsitesConfig: ZSITES_DOCKER_CLUSTER_URL,
    //zsitesSecret: ZSITES_SECRET,
    inventoryUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + INVENTORY_PRODUCT_URL,
    answerFileUrl: ANSWERFILE_DOCKER_CLUSTER_BASE_URL + ANSWERFILE_DYNAMIC_PRICING_URL,
    experienceUrl2PngBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_URL2PNG_URL,
    experienceSharedEntityBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + MS_PROXY_EXPERIENCES + MS_EXPERIENCES_SHARED_ENTITY_URL,
    msExperiencesUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + MS_PROXY_EXPERIENCES,
    microserviceCompanyUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL + MS_PROXY_COMPANY,
    proxyUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    forgotPasswordBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    resetPasswordBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    changePasswordBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    loginWithTokenBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    loginWithPasswordBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    loginWithSsoBaseUrl: MS_PROXY_DOCKER_CLUSTER_BASE_URL,
    loginActiveDirectoryBaseUrl: DOCKER_CLUSTER_LIVE_API_BASE_URL,
    googleWebFontsApiBaseUrl: GOOGLE_WEBFONTS_API_BASE_URL,
    googleWebFontsApiKey: GOOGLE_WEBFONTS_API_KEY,
    contentControlUrl: LOCAL_CONTENT_CONTROL_URL,
    enableLogging: 2,
    logId: null,
    trackErrors: true,
    experienceId: null,
    groupId: null,
    scene: null,
    statsDBucket: "creator.dev",
    version: null,
    maxRetries: 3
};

/**
 * CNC Development config. Made for developing locally against the DEV (c-dev.zmags.com) API.
 * These are the values used in CNC.
 *
 * To access unpushed experiences in DEV you may replace viewerApiBaseUrl's value with DEV_LIVE_API_BASE_URL but you
 * must provide a bearer token as its an auth protected end point. To provide a bearer token you must add the option
 * to the request in the following file experience-client/src/viewer-xp/api/index.ts.
 *
 * You may also replace it with http://localhost:8081. This is useful if you need to work offline or want to provide
 * your own custom data that isn't easily accessible.
 *
 * If you switch viewerApiBaseUrl to localhost the apiRouter will be used.
 * If you switch viewerBaseUrl to localhost the assetRouter will be used.
 */
const CNC_CONFIG = {
    cncViewFullBaseUrl: DEV_CNC_VIEW_FULL_BASE_URL,
    cncViewLiteBaseUrl: DEV_CNC_VIEW_LITE_BASE_URL,
    // The root for API requests. This will have "/api" appended to the URL.
    viewerApiBaseUrl: DEV_VIEWER_BASE_URL,
    // This gets prepended to relative URLs for image widgets.
    viewerBaseUrl: DEV_VIEWER_BASE_URL,
    // These should be added if you want to enable the corresponding tracker.
    matomoConfig: MATOMO_DEV_CONFIG,
    enableLogging: 3, // Highest level of logging -- VERBOSE
    cncStaticAssetsBaseUrl: "/static/" // Used to set public path in webpack output. Used to host client assets.
};

module.exports = {
    Names: EnvironmentNames,

    getConfiguration: function(type, buildVersion) {
        var configuration;

        switch (type) {
            case EnvironmentNames.LOCAL:
                configuration = LOCAL_CONFIG;
                break;

            case EnvironmentNames.DOCKER_STAGE:
                configuration = DOCKER_STAGE_CONFIG;
                break;

            case EnvironmentNames.DOCKER_CLUSTER:
                configuration = DOCKER_CLUSTER_CONFIG;
                break;

            case EnvironmentNames.DEV:
                configuration = DEV_CONFIG;
                break;

            case EnvironmentNames.PROD:
                configuration = PROD_CONFIG;
                break;

            case EnvironmentNames.BRANCH:
                configuration = BRANCH_CONFIG;
                break;

            case EnvironmentNames.CNC:
                configuration = CNC_CONFIG;
                break;

            default:
                throw new Error("Cannot find configuration for type: " + type);
        }

        configuration.version = buildVersion;

        return configuration;
    }
};


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Extends the `Marionette.Layout` to supporting the concept of a view scope.
 *
 * @see Region
 * @see ViewScope
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(10),
        Layout = _require.Layout;

    var superInitializeRegions = Layout.prototype._initializeRegions;

    Layout.prototype._initializeRegions = function (options) {
        var _this = this;

        // Store a reference to the parent/owning view directly on the region. This is part
        // of making the concept of view scope work.
        this.listenTo(this, "region:add", function (name, region) {
            region.parentView = _this;
        });

        superInitializeRegions.call(this, options);
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Backbone.Wreqr (Backbone.Marionette)
// ----------------------------------
// v1.4.0
//
// Copyright (c)2016 Derick Bailey, Muted Solutions, LLC.
// Distributed under MIT license
//
// http://github.com/marionettejs/backbone.wreqr


(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(Backbone, _) {
      return factory(Backbone, _);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    var Backbone = require('backbone');
    var _ = require('underscore');
    module.exports = factory(Backbone, _);
  } else {
    factory(root.Backbone, root._);
  }

}(this, function(Backbone, _) {
  "use strict";

  var previousWreqr = Backbone.Wreqr;

  var Wreqr = Backbone.Wreqr = {};

  Backbone.Wreqr.VERSION = '1.4.0';

  Backbone.Wreqr.noConflict = function () {
    Backbone.Wreqr = previousWreqr;
    return this;
  };

  // Handlers
  // --------
  // A registry of functions to call, given a name
  
  Wreqr.Handlers = (function(Backbone, _){
    "use strict";
    
    // Constructor
    // -----------
  
    var Handlers = function(options){
      this.options = options;
      this._wreqrHandlers = {};
      
      if (_.isFunction(this.initialize)){
        this.initialize(options);
      }
    };
  
    Handlers.extend = Backbone.Model.extend;
  
    // Instance Members
    // ----------------
  
    _.extend(Handlers.prototype, Backbone.Events, {
  
      // Add multiple handlers using an object literal configuration
      setHandlers: function(handlers){
        _.each(handlers, _.bind(function(handler, name){
          var context = null;
  
          if (_.isObject(handler) && !_.isFunction(handler)){
            context = handler.context;
            handler = handler.callback;
          }
  
          this.setHandler(name, handler, context);
        }, this));
      },
  
      // Add a handler for the given name, with an
      // optional context to run the handler within
      setHandler: function(name, handler, context){
        var config = {
          callback: handler,
          context: context
        };
  
        this._wreqrHandlers[name] = config;
  
        this.trigger("handler:add", name, handler, context);
      },
  
      // Determine whether or not a handler is registered
      hasHandler: function(name){
        return !! this._wreqrHandlers[name];
      },
  
      // Get the currently registered handler for
      // the specified name. Throws an exception if
      // no handler is found.
      getHandler: function(name){
        var config = this._wreqrHandlers[name];
  
        if (!config){
          return;
        }
  
        return function(){
          return config.callback.apply(config.context, arguments);
        };
      },
  
      // Remove a handler for the specified name
      removeHandler: function(name){
        delete this._wreqrHandlers[name];
      },
  
      // Remove all handlers from this registry
      removeAllHandlers: function(){
        this._wreqrHandlers = {};
      }
    });
  
    return Handlers;
  })(Backbone, _);
  
  // Wreqr.CommandStorage
  // --------------------
  //
  // Store and retrieve commands for execution.
  Wreqr.CommandStorage = (function(){
    "use strict";
  
    // Constructor function
    var CommandStorage = function(options){
      this.options = options;
      this._commands = {};
  
      if (_.isFunction(this.initialize)){
        this.initialize(options);
      }
    };
  
    // Instance methods
    _.extend(CommandStorage.prototype, Backbone.Events, {
  
      // Get an object literal by command name, that contains
      // the `commandName` and the `instances` of all commands
      // represented as an array of arguments to process
      getCommands: function(commandName){
        var commands = this._commands[commandName];
  
        // we don't have it, so add it
        if (!commands){
  
          // build the configuration
          commands = {
            command: commandName, 
            instances: []
          };
  
          // store it
          this._commands[commandName] = commands;
        }
  
        return commands;
      },
  
      // Add a command by name, to the storage and store the
      // args for the command
      addCommand: function(commandName, args){
        var command = this.getCommands(commandName);
        command.instances.push(args);
      },
  
      // Clear all commands for the given `commandName`
      clearCommands: function(commandName){
        var command = this.getCommands(commandName);
        command.instances = [];
      }
    });
  
    return CommandStorage;
  })();
  
  // Wreqr.Commands
  // --------------
  //
  // A simple command pattern implementation. Register a command
  // handler and execute it.
  Wreqr.Commands = (function(Wreqr, _){
    "use strict";
  
    return Wreqr.Handlers.extend({
      // default storage type
      storageType: Wreqr.CommandStorage,
  
      constructor: function(options){
        this.options = options || {};
  
        this._initializeStorage(this.options);
        this.on("handler:add", this._executeCommands, this);
  
        Wreqr.Handlers.prototype.constructor.apply(this, arguments);
      },
  
      // Execute a named command with the supplied args
      execute: function(name){
        name = arguments[0];
        var args = _.rest(arguments);
  
        if (this.hasHandler(name)){
          this.getHandler(name).apply(this, args);
        } else {
          this.storage.addCommand(name, args);
        }
  
      },
  
      // Internal method to handle bulk execution of stored commands
      _executeCommands: function(name, handler, context){
        var command = this.storage.getCommands(name);
  
        // loop through and execute all the stored command instances
        _.each(command.instances, function(args){
          handler.apply(context, args);
        });
  
        this.storage.clearCommands(name);
      },
  
      // Internal method to initialize storage either from the type's
      // `storageType` or the instance `options.storageType`.
      _initializeStorage: function(options){
        var storage;
  
        var StorageType = options.storageType || this.storageType;
        if (_.isFunction(StorageType)){
          storage = new StorageType();
        } else {
          storage = StorageType;
        }
  
        this.storage = storage;
      }
    });
  
  })(Wreqr, _);
  
  // Wreqr.RequestResponse
  // ---------------------
  //
  // A simple request/response implementation. Register a
  // request handler, and return a response from it
  Wreqr.RequestResponse = (function(Wreqr, _){
    "use strict";
  
    return Wreqr.Handlers.extend({
      request: function(name){
        if (this.hasHandler(name)) {
          return this.getHandler(name).apply(this, _.rest(arguments));
        }
      }
    });
  
  })(Wreqr, _);
  
  // Event Aggregator
  // ----------------
  // A pub-sub object that can be used to decouple various parts
  // of an application through event-driven architecture.
  
  Wreqr.EventAggregator = (function(Backbone, _){
    "use strict";
    var EA = function(){};
  
    // Copy the `extend` function used by Backbone's classes
    EA.extend = Backbone.Model.extend;
  
    // Copy the basic Backbone.Events on to the event aggregator
    _.extend(EA.prototype, Backbone.Events);
  
    return EA;
  })(Backbone, _);
  
  // Wreqr.Channel
  // --------------
  //
  // An object that wraps the three messaging systems:
  // EventAggregator, RequestResponse, Commands
  Wreqr.Channel = (function(Wreqr){
    "use strict";
  
    var Channel = function(channelName) {
      this.vent        = new Backbone.Wreqr.EventAggregator();
      this.reqres      = new Backbone.Wreqr.RequestResponse();
      this.commands    = new Backbone.Wreqr.Commands();
      this.channelName = channelName;
    };
  
    _.extend(Channel.prototype, {
  
      // Remove all handlers from the messaging systems of this channel
      reset: function() {
        this.vent.off();
        this.vent.stopListening();
        this.reqres.removeAllHandlers();
        this.commands.removeAllHandlers();
        return this;
      },
  
      // Connect a hash of events; one for each messaging system
      connectEvents: function(hash, context) {
        this._connect('vent', hash, context);
        return this;
      },
  
      connectCommands: function(hash, context) {
        this._connect('commands', hash, context);
        return this;
      },
  
      connectRequests: function(hash, context) {
        this._connect('reqres', hash, context);
        return this;
      },
  
      // Attach the handlers to a given message system `type`
      _connect: function(type, hash, context) {
        if (!hash) {
          return;
        }
  
        context = context || this;
        var method = (type === 'vent') ? 'on' : 'setHandler';
  
        _.each(hash, _.bind(function(fn, eventName) {
          this[type][method](eventName, _.bind(fn, context));
        }, this));
      }
    });
  
  
    return Channel;
  })(Wreqr);
  
  // Wreqr.Radio
  // --------------
  //
  // An object that lets you communicate with many channels.
  Wreqr.radio = (function(Wreqr, _){
    "use strict";
  
    var Radio = function() {
      this._channels = {};
      this.vent = {};
      this.commands = {};
      this.reqres = {};
      this._proxyMethods();
    };
  
    _.extend(Radio.prototype, {
  
      channel: function(channelName) {
        if (!channelName) {
          throw new Error('Channel must receive a name');
        }
  
        return this._getChannel( channelName );
      },
  
      _getChannel: function(channelName) {
        var channel = this._channels[channelName];
  
        if(!channel) {
          channel = new Wreqr.Channel(channelName);
          this._channels[channelName] = channel;
        }
  
        return channel;
      },
  
      _proxyMethods: function() {
        _.each(['vent', 'commands', 'reqres'], _.bind(function(system) {
          _.each( messageSystems[system], _.bind(function(method) {
            this[system][method] = proxyMethod(this, system, method);
          }, this));
        }, this));
      }
    });
  
  
    var messageSystems = {
      vent: [
        'on',
        'off',
        'trigger',
        'once',
        'stopListening',
        'listenTo',
        'listenToOnce'
      ],
  
      commands: [
        'execute',
        'setHandler',
        'setHandlers',
        'removeHandler',
        'removeAllHandlers'
      ],
  
      reqres: [
        'request',
        'setHandler',
        'setHandlers',
        'removeHandler',
        'removeAllHandlers'
      ]
    };
  
    var proxyMethod = function(radio, system, method) {
      return function(channelName) {
        var messageSystem = radio._getChannel(channelName)[system];
  
        return messageSystem[method].apply(messageSystem, _.rest(arguments));
      };
    };
  
    return new Radio();
  
  })(Wreqr, _);
  

  return Backbone.Wreqr;

}));


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Backbone.BabySitter
// -------------------
// v0.1.11
//
// Copyright (c)2016 Derick Bailey, Muted Solutions, LLC.
// Distributed under MIT license
//
// http://github.com/marionettejs/backbone.babysitter

(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(Backbone, _) {
      return factory(Backbone, _);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    var Backbone = require('backbone');
    var _ = require('underscore');
    module.exports = factory(Backbone, _);
  } else {
    factory(root.Backbone, root._);
  }

}(this, function(Backbone, _) {
  'use strict';

  var previousChildViewContainer = Backbone.ChildViewContainer;

  // BabySitter.ChildViewContainer
  // -----------------------------
  //
  // Provide a container to store, retrieve and
  // shut down child views.
  
  Backbone.ChildViewContainer = (function (Backbone, _) {
  
    // Container Constructor
    // ---------------------
  
    var Container = function(views){
      this._views = {};
      this._indexByModel = {};
      this._indexByCustom = {};
      this._updateLength();
  
      _.each(views, this.add, this);
    };
  
    // Container Methods
    // -----------------
  
    _.extend(Container.prototype, {
  
      // Add a view to this container. Stores the view
      // by `cid` and makes it searchable by the model
      // cid (and model itself). Optionally specify
      // a custom key to store an retrieve the view.
      add: function(view, customIndex){
        var viewCid = view.cid;
  
        // store the view
        this._views[viewCid] = view;
  
        // index it by model
        if (view.model){
          this._indexByModel[view.model.cid] = viewCid;
        }
  
        // index by custom
        if (customIndex){
          this._indexByCustom[customIndex] = viewCid;
        }
  
        this._updateLength();
        return this;
      },
  
      // Find a view by the model that was attached to
      // it. Uses the model's `cid` to find it.
      findByModel: function(model){
        return this.findByModelCid(model.cid);
      },
  
      // Find a view by the `cid` of the model that was attached to
      // it. Uses the model's `cid` to find the view `cid` and
      // retrieve the view using it.
      findByModelCid: function(modelCid){
        var viewCid = this._indexByModel[modelCid];
        return this.findByCid(viewCid);
      },
  
      // Find a view by a custom indexer.
      findByCustom: function(index){
        var viewCid = this._indexByCustom[index];
        return this.findByCid(viewCid);
      },
  
      // Find by index. This is not guaranteed to be a
      // stable index.
      findByIndex: function(index){
        return _.values(this._views)[index];
      },
  
      // retrieve a view by its `cid` directly
      findByCid: function(cid){
        return this._views[cid];
      },
  
      // Remove a view
      remove: function(view){
        var viewCid = view.cid;
  
        // delete model index
        if (view.model){
          delete this._indexByModel[view.model.cid];
        }
  
        // delete custom index
        _.any(this._indexByCustom, function(cid, key) {
          if (cid === viewCid) {
            delete this._indexByCustom[key];
            return true;
          }
        }, this);
  
        // remove the view from the container
        delete this._views[viewCid];
  
        // update the length
        this._updateLength();
        return this;
      },
  
      // Call a method on every view in the container,
      // passing parameters to the call method one at a
      // time, like `function.call`.
      call: function(method){
        this.apply(method, _.tail(arguments));
      },
  
      // Apply a method on every view in the container,
      // passing parameters to the call method one at a
      // time, like `function.apply`.
      apply: function(method, args){
        _.each(this._views, function(view){
          if (_.isFunction(view[method])){
            view[method].apply(view, args || []);
          }
        });
      },
  
      // Update the `.length` attribute on this container
      _updateLength: function(){
        this.length = _.size(this._views);
      }
    });
  
    // Borrowing this code from Backbone.Collection:
    // http://backbonejs.org/docs/backbone.html#section-106
    //
    // Mix in methods from Underscore, for iteration, and other
    // collection related features.
    var methods = ['forEach', 'each', 'map', 'find', 'detect', 'filter',
      'select', 'reject', 'every', 'all', 'some', 'any', 'include',
      'contains', 'invoke', 'toArray', 'first', 'initial', 'rest',
      'last', 'without', 'isEmpty', 'pluck', 'reduce'];
  
    _.each(methods, function(method) {
      Container.prototype[method] = function() {
        var views = _.values(this._views);
        var args = [views].concat(_.toArray(arguments));
        return _[method].apply(_, args);
      };
    });
  
    // return the public API
    return Container;
  })(Backbone, _);
  

  Backbone.ChildViewContainer.VERSION = '0.1.11';

  Backbone.ChildViewContainer.noConflict = function () {
    Backbone.ChildViewContainer = previousChildViewContainer;
    return this;
  };

  return Backbone.ChildViewContainer;

}));


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Marionette = __webpack_require__(10);
    var ViewScope = __webpack_require__(171);
    var Browser = __webpack_require__(39);

    /**
     * An enhancement for Marionette.Region that can animate the views placed inside it.
     * Automatically monkey-patched into Marionette.
     *
     * The region/view lifecycle is:
     * 1. New view is added via show().
     * 2. Old view is closed.
     * 3. New view is opened.
     *
     * @class Region
     * @author Bo Gotthardt (the class)
     * @author Kim
     * @author Younes (the package name)
     */

    /**
     * Modified version of Marionette.Region.prototype.close that handles our slightly different lifecycle.
     *
     * @param {Marionette.Region} region
     * @param {Marionette.View} view
     */
    var closeView = function closeView(region, view) {
        if (!view || view.isClosed) {
            return;
        }

        if (view.close) {
            view.close();
        } else if (view.remove) {
            view.remove();
        }

        Marionette.triggerMethod.call(region, "close");

        // Only delete the current view if it's the one being closed.
        if (region.currentView === view) {
            delete region.currentView;
        }

        // Remove the closed view's element as we no longer do that when opening the new one.
        // Note that this means that any foreign elements (i.e. not the opened or closed view) will *not* be
        // removed, unlike for the normal region that uses empty().
        view.$el.remove();
    };

    /**
     * Modified version of Marionette.Region.prototype.show that enables support for the concept of view scope.
     */
    Marionette.Region.prototype.show = function (view) {
        var _this = this;

        // Setup view scope
        ViewScope.register(this, view);

        // Following code is copied from Marionette, but since we're deferring the DOM append, the stuff that fires
        // events needed to be slightly restructured

        this.ensureEl();
        var isViewClosed = view.isClosed || _.isUndefined(view.$el);
        var isDifferentView = view !== this.currentView;
        if (isDifferentView) {
            this.close();
        }
        view.render();

        // Update state and fire events when the element is added to the DOM
        var viewOpened = function viewOpened() {
            _this.currentView = view;

            Marionette.triggerMethod.call(_this, "show", view);
            Marionette.triggerMethod.call(view, "show");
        };

        if (isDifferentView || isViewClosed) {
            this.open(view).done(viewOpened);
        } else {
            viewOpened();
        }
    };

    Marionette.Region.prototype.close = function () {
        var _this2 = this;

        var view = this.currentView;

        if (view) {
            // Make sure the view knows it is being closed, so it can avoid doing expensive operations like re-rendering
            view.isClosing = true;
            Marionette.triggerMethod.call(view, "closing");

            if (view.transitions && view.transitions.out) {
                _.defer(function () {
                    view.$el.addClass(view.transitions.out);
                    view.$el.addClass("tst-animating");
                });

                view.$el.one(Browser.animationEndEventName(), function () {
                    if (view.onTransitionedOut) {
                        view.onTransitionedOut.call(view);
                    }

                    closeView(_this2, view);
                });
            } else {
                closeView(this, view);
            }
        }

        _.each(this.children, function (view) {
            closeView(_this2, view);
        });
    };

    Marionette.Region.prototype.isClosed = function () {
        return !this.currentView || this.currentView.isClosed;
    };

    /**
     * Opens the given view.
     *
     * <p>The signature differs from Marionette, in that we return a promise that will resolve when the element is
     * actually appended to the DOM. We are deferring this when animations are used to improve the experience in
     * some browsers.</p>
     *
     * @param {View} view The view to open.
     * @returns {Promise} Promise that resolves when the view is added to the DOM.
     */
    Marionette.Region.prototype.open = function (view) {
        var _this3 = this;

        return $.Deferred(function (deferred) {
            // eslint-disable-next-line dot-notation
            if (view.transitions && view.transitions["in"]) {
                _.defer(function () {
                    // eslint-disable-next-line dot-notation
                    view.$el.addClass(view.transitions["in"]);
                    view.$el.addClass("tst-animating");
                    _this3.$el.append(view.el);
                    deferred.resolve();
                });

                view.$el.one(Browser.animationEndEventName(), function () {
                    // eslint-disable-next-line dot-notation
                    view.$el.removeClass(view.transitions["in"]);
                    view.$el.removeClass("tst-animating");
                    if (view.onTransitionedIn) {
                        view.onTransitionedIn.call(view);
                    }
                });
            } else {
                // Marionette uses this.$el.empty().append(view.el), but we don't want to remove the old view just yet.
                _this3.$el.append(view.el);
                deferred.resolve();
            }
        }).promise();
    };

    Marionette.Region.prototype.contains = function (view) {
        return this.children && this.children.indexOf(view) !== -1;
    };

    Marionette.Region.prototype.appendView = function (view) {
        ViewScope.register(this, view);

        if (_.isUndefined(this.children)) {
            this.children = [];
            this.close();
        }

        if (this.contains(view)) {
            return;
        }

        this.children.push(view);

        this.ensureEl();

        view.render();

        this.$el.append(view.el);

        Marionette.triggerMethod.call(this, "show", view);
        Marionette.triggerMethod.call(view, "show");
    };

    Marionette.Region.prototype.removeView = function (view) {
        if (this.contains(view)) {
            this.children.splice(this.children.indexOf(view), 1);

            if (view.close) {
                view.close();
            } else if (view.remove) {
                view.remove();
            }

            view.$el.remove();
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_CUSTOM_JAVASCRIPT_ACTIVATED", function() { return EVENT_CUSTOM_JAVASCRIPT_ACTIVATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_EXPERIENCE_VIEWED", function() { return EVENT_EXPERIENCE_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_EXTERNAL_LINK_CLICK", function() { return EVENT_EXTERNAL_LINK_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_JAVASCRIPT_ACTIVATED", function() { return EVENT_JAVASCRIPT_ACTIVATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_NAVIGATION", function() { return EVENT_NAVIGATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_OPEN_LIGHTBOX", function() { return EVENT_OPEN_LIGHTBOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_QUICKVIEW_ACTIVATED", function() { return EVENT_QUICKVIEW_ACTIVATED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_PRODUCT_WIDGET_CLICKED", function() { return EVENT_PRODUCT_WIDGET_CLICKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_SOCIAL_SHARED_LINK_CLICK", function() { return EVENT_SOCIAL_SHARED_LINK_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_IMAGE_VIEWED", function() { return EVENT_IMAGE_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_WIDGET_VIEWED", function() { return EVENT_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_BUTTON_WIDGET_VIEWED", function() { return EVENT_BUTTON_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_SFCC_WIDGET_VIEWED", function() { return EVENT_SFCC_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_EMBED_WIDGET_VIEWED", function() { return EVENT_EMBED_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_IMAGE_WIDGET_VIEWED", function() { return EVENT_IMAGE_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_LINE_WIDGET_VIEWED", function() { return EVENT_LINE_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_LINK_WIDGET_VIEWED", function() { return EVENT_LINK_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_NEXT_SCENE_WIDGET_VIEWED", function() { return EVENT_NEXT_SCENE_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_PREVIOUS_SCENE_WIDGET_VIEWED", function() { return EVENT_PREVIOUS_SCENE_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_SCENE_NAVIGATOR_WIDGET_VIEWED", function() { return EVENT_SCENE_NAVIGATOR_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_SHAPE_WIDGET_VIEWED", function() { return EVENT_SHAPE_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_SOCIAL_SHARING_WIDGET_VIEWED", function() { return EVENT_SOCIAL_SHARING_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_TEXT_WIDGET_VIEWED", function() { return EVENT_TEXT_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_YOUTUBE_WIDGET_VIEWED", function() { return EVENT_YOUTUBE_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_PRODUCT_WIDGET_VIEWED", function() { return EVENT_PRODUCT_WIDGET_VIEWED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHTBOX_OPEN", function() { return LIGHTBOX_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LIGHTBOX_CLOSE", function() { return LIGHTBOX_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LINK_VISIT", function() { return LINK_VISIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JAVASCRIPT_EXECUTE", function() { return JAVASCRIPT_EXECUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PRODUCT_VIEW", function() { return PRODUCT_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SCENE_NAVIGATE", function() { return SCENE_NAVIGATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SOCIAL_NETWORK_SHARE", function() { return SOCIAL_NETWORK_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMAGE_VIEW", function() { return IMAGE_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDGET_VIEW", function() { return WIDGET_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VIEWER_ERROR", function() { return VIEWER_ERROR; });
// Define viewer event constants
//
// TODO: We should really considering moving away from constants and model events as classes instead (MOS-3305)
// Moreover, changing the values would break backwards compatibility with our existing data.
// These strings are defined in Piwik, are saved in Google Analytics accounts and Omniture, so changing them requires changes to those backends and db.
var EVENT_CUSTOM_JAVASCRIPT_ACTIVATED = "Custom JavaScript action activated";
var EVENT_EXPERIENCE_VIEWED = "Experience viewed";
var EVENT_EXTERNAL_LINK_CLICK = "Click on link";
var EVENT_JAVASCRIPT_ACTIVATED = "JavaScript action activated";
var EVENT_NAVIGATION = "Navigation link clicked";
var EVENT_OPEN_LIGHTBOX = "Open lightbox";
var EVENT_QUICKVIEW_ACTIVATED = "Product Viewed";
var EVENT_PRODUCT_WIDGET_CLICKED = "Product widget clicked";
var EVENT_SOCIAL_SHARED_LINK_CLICK = "Click on social shared link";
var EVENT_IMAGE_VIEWED = "Image_viewed";
var EVENT_WIDGET_VIEWED = "Widget Viewed";
var EVENT_BUTTON_WIDGET_VIEWED = "Button Widget Viewed";
var EVENT_SFCC_WIDGET_VIEWED = "SFCC Widget Viewed";
var EVENT_EMBED_WIDGET_VIEWED = "Embed Widget Viewed";
var EVENT_IMAGE_WIDGET_VIEWED = "Image Widget Viewed";
var EVENT_LINE_WIDGET_VIEWED = "Line Widget Viewed";
var EVENT_LINK_WIDGET_VIEWED = "Link Widget Viewed";
var EVENT_NEXT_SCENE_WIDGET_VIEWED = "Next Scene Widget Viewed";
var EVENT_PREVIOUS_SCENE_WIDGET_VIEWED = "Previous Scene Widget Viewed";
var EVENT_SCENE_NAVIGATOR_WIDGET_VIEWED = "Scene Navigator Widget Viewed";
var EVENT_SHAPE_WIDGET_VIEWED = "Shape Widget Viewed";
var EVENT_SOCIAL_SHARING_WIDGET_VIEWED = "Social Sharing Widget Viewed";
var EVENT_TEXT_WIDGET_VIEWED = "Text Widget Viewed";
var EVENT_YOUTUBE_WIDGET_VIEWED = "Youtube Widget Viewed";
var EVENT_PRODUCT_WIDGET_VIEWED = "Product Widget Viewed";
var LIGHTBOX_OPEN = "viewer:lightbox:open";
var LIGHTBOX_CLOSE = "viewer:lightbox:close";
var LINK_VISIT = "viewer:link:visit";
var JAVASCRIPT_EXECUTE = "viewer:javascript:execute";
var PRODUCT_VIEW = "viewer:product:view";
var SCENE_NAVIGATE = "viewer:scene:navigate";
var SOCIAL_NETWORK_SHARE = "viewer:social:share";
var IMAGE_VIEW = "viewer:image:view";
var WIDGET_VIEW = "viewer:widget:view";
// E.g. on Action failing to be activated
var VIEWER_ERROR = "viewer:error";


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Preconditions = __webpack_require__(14);
    var Window = __webpack_require__(48);

    var log = new Logger("ViewerProxy");

    /**
     * @private
     * Finds options set on "viewer" for the specified child viewer or window to eventually pass on to the
     * child viewer.
     *
     * @param {ViewerProxy}             viewer The parent viewer proxy; never falsey.
     * @param {ViewerProxy|HMTLElement} iframe The child viewer proxy or iframe to eventually store the child viewer proxy;
     *                                         never falsey.
     *
     * @return {{options:*, parent:ViewerProxy}} The entry storing register options and ViewerProxy parent, if any;
     *                                           can be falsey.
     */
    var options = function options(viewer, iframe) {
        var options = viewer._options;
        var entry = void 0;
        var i = void 0;

        for (i = 0; i < options.length; i++) {
            entry = options[i];
            if (entry.iframe === iframe) {
                options.splice(i, 1);
                return entry;
            }
        }
    };

    /**
     * @class
     * Creates a viewer proxy, representing the viewer to be exposed for the channels app in the content window
     * of the iframe. In the channels.js app, the <tt>Viewer</tt> (proxy) type will invoke these functions
     * when applicable, but embedded Viewers on direct urls (on same origin) may also call each other, e.g.
     * to pause the outer Experiences while an embedded Experience has focus. <p>
     *
     * Viewer proxy interface, exported in the iframe window under <tt>viewer</tt> (also in the Editor in preview mode):
     * <pre>
     *    options:       *,                                                  // options to be used during Viewer initialisation for embedded Viewers/Experiences,
     *                                                                       // like the viewport size.
     *    win:           Function(): Window,                                 // returns the Window the Viewer lives in.
     *    iframe:        Function(): HTMLElement,                            // returns the dom iframe the Viewer lives in.
     *    parent:        ViewerProxy,                                        // the parent Viewer if this Viewer is embedded.
     *    register:      Function(win: Window, options:*),                   // registers options for a child viewer before it is available, to be set as
     *                                                                       // 'childViewer.options' once it becomes available.
     *    channel:       Function(): Channel,                                // returns the Channel when embedded via channels, falsey otherwise.
     *    contentLoaded: Function(data:JSON, type:String),                   // called by the channels app when an publishable (experience or json) has been preloaded or failed (no-arg)!
     *    state:         Function(name:String, value:T, recurse:Boolean): T, // If only <tt>name</tt> is supplied, the state is returned. The name
     *                                                                       // can be "autoPlay", "paused", "stalled", "active", "shown", and "closed".
     *                                                                       // If the <tt>value</tt> is also supplied, said state will be said, potentially
     *                                                                       // triggering cascading recursive changes. The <tt>recursive</tt> argument is
     *                                                                       // for internal use only.
     *    close:         Function(),                                         // Irreversibly closes the viewer, but the channel can
     *                                                                       // insert a new viewer again if restarted. If so, it will
     *                                                                       // be in a different iframe and this proxy is void. Same
     *                                                                       // as calling <tt>viewer.state({name: closed", value: true})</tt>.
     * </pre>
     *
     * @param {Function} state     The state function backing this ViewerProxy; cannot be falsey. Typically a
     *                             reference to ExperienceController.state(..) or GroupController.state(..), but
     *                             also used for ExperiencePreview in the editor.
     * @param {Channel}  [channel] The channel when embedded; can be falsey (will be on direct url or in the editor).
     */
    var ViewerProxy = function ViewerProxy(state, channel) {
        var _this = this;

        /**
         * @private @type {Boolean}
         * True if this ViewerProxy is an intermediate one, false otherwise.
         *
         * @see #root
         */
        this._intermediate = false; // determined differently via channels and direct urls... :/

        /**
         * @type {ViewerProxy}
         * The parent Viewer proxy of this Viewer proxy when embedded. <p>
         *
         * By default, this is the Viewer from the parent Window, but for Lightboxes it will be a different one as
         * Lightboxes live in the top most reachable Window always, but may logically have been created inside an
         * iframe window.
         */
        this.parent = function () {
            // In Channel mode, the top (parent) window may not store the actual parent viewer, so use
            // the Channel to fetch the parent...
            if (channel) {
                var parent = channel.embedded();
                var viewer = void 0;

                if (parent) {
                    viewer = parent.viewer();
                    _this._intermediate = viewer.win() !== Window.parent();
                }
                return viewer;
            }
            // Direct urls, intermediate handled elsewhere because of different Window structure...
            return Window.viewer("parent"); // default, may be overridden
        }();

        /**
         * @private @type {ViewerProxy[]}
         * Array of all embedded viewer proxies of this viewer proxies.
         */
        this._children = []; // to handle pausing of embedded experiences
        this._options = []; // entry: {iframe: HTMLElement, options: {}, parent: ViewerProxy}
        this._deferred = null; // for channel preloading

        /**
         * Viewer options passed by the parent, if any, automatically during setup of this proxy. <p>
         *
         * The options will be used by this Viewer during initialisation/initial rendering, e.g. use the available
         * size even if rendered on a hidden adjacent Scene, and whether or not initially active.
         */
        this.options = undefined;

        /**
         * Returns the window this Viewer Proxy lives in.
         *
         * @return {Window} The window this Viewer Proxy lives in; will be null if the window is closed.
         */
        this.win = function () {
            var win = Window.self();
            if (win && win.closed) {
                return null;
            }
            return win;
        };

        /**
         * Returns the iframe element of the Viewer.
         *
         * @return {HTMLElement} The iframe element of the Viewer; will be null if this ViewerProxy (i.e. its window)
         *                       is closed.
         */
        this.iframe = function () {
            var win = _this.win();
            return win ? win.frameElement : null;
        };

        /**
         * Returns the top most (intermediate) root Viewer from this Viewer, which might be itself. <p>
         *
         * An intermediate root Viewer is when a ViewerProxy lives in a window whose parent window stores a
         * different ViewerProxy that the parent ViewerProxy of the intermediate root, like a Viewer opened
         * in a Lightbox as Lightboxes always live in the global window/dom.
         *
         * @param  {Boolean} [intermediate] True to fetch the closest intermediate root, false to fetch the top
         *                                  most one (default). The closest intermediate root is the one
         *                                  where the ViewerProxy lives in a window whose parent window stores a
         *                                  different ViewerProxy that the parent ViewerProxy of the intermediate
         *                                  root, like a Viewer opened in a Lightbox as Lightboxes always live
         *                                  in the global window/dom. It may be this Viewer if it intermediate.
         * @return {ViewerProxy} The top most reachable Viewer from this Viewer; never null, can be this Viewer.
         */
        this.root = function (intermediate) {
            if (!_this.parent || intermediate && _this._intermediate) {
                return _this;
            }
            return _this.parent.root(intermediate);
        };

        /**
         * Returns the accessible (distinct) siblings Viewer Proxies of this Viewer Proxy, if any. <p>
         *
         * Any such sibling will share the same parent, or have no parent at all (i.e. all top level
         * Viewers).
         *
         * @param  {Boolean} [removeSelf] True to remove this Viewer Proxy from the array, false to include it (default).
         * @return {ViewerProxy[]} The siblings Viewer Proxies in a new array, if any; never falsey, but can be empty.
         *                         Modifying the returned array will not affect this proxy.
         */
        this.siblings = function (removeSelf) {
            // Parent can also be null in the editor...
            var parent = _this.parent;
            var siblings = void 0;

            // Non-top level means this Viewer is embedded within another Viewer that already keeps track of its
            // children, which of course are the siblings of this Viewer Proxy...
            if (parent) {
                siblings = _.clone(parent._children);

                // At top level, we have to traverse the dom to find other Viewers not related to this Viewer, e.g.
                // on a page with multiple distinct top level non embedded Experiences/Viewers. Note that we may have
                // a "false positive" on top level in the Editor, where the actual top most Viewer is off limits due
                // to cross domain issue between Editor and (embedded) Viewers. At top level, the document may be
                // the actual document to search on a direct url via as-is, but more likely the document to search is
                // the document embedding the Experiences, either via channels or via iframes with direct urls...
            } else {
                siblings = [];

                // Must have an *accessible* parent window to access the document to search for siblings. If we do not
                // have a parent, we cannot ever find siblings but we might want to return this viewer in the
                // case we are on a direct url not embedded in another document...
                parent = Window.parent(); // not ViewerProxy.parent!
                if (parent) {
                    // The first filter ("data-zmags-viewer") will find any Viewer embedded via Channels, EmbedWidget,
                    // and Lightbox, but cannot find Viewers embedded via a direct url hardcoded in the client dom
                    // (by the client), so we have to test for any iframe src storing "viewer.html#.." as well
                    // (rare case, I suspect) - which is why we first fetch all iframes, then filter... :/
                    var iframes = $("iframe", parent.document).filter("[data-zmags-viewer],[src*='viewer.html']");
                    var i = void 0;

                    // We may not have access to the iframe in question, e.g. hardcoded urls or when in the Editor
                    // preview mode, or we could potentially get false positives on "viewer.html" part...
                    for (i = 0; i < iframes.length; i++) {
                        try {
                            siblings.push(Window.viewer(iframes[i]));
                        } catch (e) {// e.g. SecurityError
                            // fall-through
                        }
                    }
                } else {
                    siblings.push(_this);
                }
            }

            if (removeSelf) {
                siblings.splice(_.indexOf(siblings, _this), 1);
            }

            return siblings;
        };

        /**
         * Registers options supplied as the second argument for the specified Viewer Proxy associated with
         * the (iframe) window supplied as the first argument. Once the Viewer in said window is ready and registers
         * itself with this (parent) Viewer Proxy, the embedded child viewer will have its <tt>options</tt> property
         * set with said options, to be used during its initialisation.
         *
         * @param {HTMLElement}            [iframe]  The child iframe (dom element, not content window as it may not
         *                                           be available yet) where the Viewer Proxy will eventually load;
         *                                           cannot be falsey.
         * @param {{state: *, options: *}} [options] The state and options for the child viewer to use during
         *                                           initialisation.
         * @param {ViewerProxy}            [parent]  The logical parent ViewerProxy, defaulting to the current one.
         *
         * @see   #state
         * @see   #options
         */
        this.register = function () {
            // note: only doc for public functionality, not for private use
            var i = arguments.length;
            var parent = void 0;

            if (i) {
                var viewer = arguments.length <= 0 ? undefined : arguments[0];
                Preconditions.checkArgument(viewer, "Viewer cannot be falsey");

                var register = i === 1;
                var iframe = register ? viewer.iframe() : viewer;
                var entry = options(_this, iframe) || {}; // find and remove!
                var opts = entry.options;

                parent = entry.parent || _this;

                // This viewer is called by an embedded child now available...
                if (register) {
                    // Special case: a Lightbox will always use the top most window to ensure the Lightbox overlay
                    // and Lightbox itself is relative to the overall window, and not some (embedded) Experience.
                    // Because of this, the logical parent viewer may not live in the parent window! We update the
                    // logical structure to ensure we have a proper tree structure, for example to test the depth
                    // of embedding...
                    if (viewer.parent !== parent) {
                        viewer.parent = parent;
                        viewer._intermediate = true;
                    }
                    parent._children.push(viewer);

                    // Find options for the child viewer, if any...
                    if (opts) {
                        viewer.options = opts;
                        log.verbose("Setting embedded Viewer options: " + viewer, opts);

                        // Set state on the *child* viewer, if specified...
                        if (opts.state) {
                            // Internally, the viewer might not be ready yet, e.g. on delegate controller usage,
                            // but eventually, the state will be used by the ExperienceViewer in question otherwise...
                            viewer.state(opts.state);
                        }
                    }

                    // This Viewer is a parent storing options for a given child/embedded Viewer that is not available
                    // yet, only the iframe window in question. Duplicate options will already have been removed above.
                } else {
                    _this._options.push({ iframe: iframe, options: arguments.length <= 1 ? undefined : arguments[1], parent: arguments.length <= 2 ? undefined : arguments[2] }); // "parent" can be undefined, will default
                }

                // A viewer proxy registering itself to the current window *and* at its parent, if any. The parent will be
                // null for the top most reachable Viewer...
            } else {
                // Export to "viewer", which will never conflict as we always have a single Viewer inside a single iframe!
                // On "close()", will be removed again...
                window.viewer = _this;

                // At this point, the parent Viewer is *always* the one in the parent window on direct urls, if any,
                // but it might not be the logical parent Viewer for Lightboxes; the parent register call will ensure
                // proper structure henceforth. In Channel mode, the parent Viewer is acquired from the Channel and
                // thus logically correct regardless of Window at this point...
                if (_this.parent) {
                    _this.parent.register(_this);
                }
            }
        };

        /**
         * @protected
         * Unregisters this Viewer proxy from its possible parent and clears the "viewer" reference for the associated
         * window. Any unused options for this viewer proxy will also be removed by this.
         */
        this._unregister = function () {
            // Called from child that wants to unregister itself from its parent
            if (arguments.length) {
                var viewer = arguments.length <= 0 ? undefined : arguments[0];
                var i = _this._children.length;

                while (i--) {
                    if (_this._children[i] === viewer) {
                        _this._children.splice(i, 1);

                        // Remove any unused options...
                        options(_this, viewer.iframe());
                    }
                }

                // Called by this viewer, e.g. on close...
            } else {
                // Unregister from parent, if any...
                if (_this.parent) {
                    _this.parent._unregister(_this);
                }
                // Unregister from window...
                delete window.viewer;
            }
        };

        /**
         * Returns the channel available to this Viewer Proxy, if any. <p>
         *
         * Will be null when the Experience/Group is viewed on a direct url (or in the Editor).
         *
         * @return {Channel} The channel, if any; can be falsey.
         *
         * @see    #contentLoaded
         */
        this.channel = function () {
            return channel;
        };

        /**
         * Channel callback when channel preloading is enabled and the preload has finished, notifying this viewer
         * about this. <p>
         *
         * Only relevant (called) when this Viewer Proxy is backend by a channel.
         *
         * @param {*}       data  The json data preloaded, e.g. an Experience; a falsey value means failure to load.
         * @param {String} [type] The type of json data preloaded, e.g. "experience" or "group".
         *
         * @see   ViewerBridge#contentLoaded
         */
        this.contentLoaded = function (data, type) {
            // called via channel.viewer().contentLoaded
            if (_this._deferred) {
                if (data) {
                    log.verbose("Content preloaded: ", type, data);
                    _this._deferred.resolve(data);
                } else {
                    log.error("Content preload failed: ", type);
                    _this._deferred.reject();
                }
                _this._deferred = null;
            }
        };

        /**
         * Gets or sets the state for this Viewer Proxy. <p>
         *
         * If a single string argument is supplied, the value of said viewer state attribute is returned. The value
         * can then be either "autoPlay", "paused", "stalled", "active", "shown", or "closed" (all Booleans). <p>
         *
         * If options like {name:String, value:Boolean, recursive:Boolean} are specified, where the <tt>name</tt>
         * attribute can be either of the aforementioned attributes with an associated Boolean <tt>value</tt>,
         * e.g. {name: "stalled", value: true, ..}, the specified option will be set. If the <tt>recursive</tt>
         * option is not set, it will default to true. <p>
         *
         * Depending on the type of state to set, this will recursively recurse into in embedded child viewers if
         * the <tt>recursive</tt> option is (defaulted) to true, setting the same state (if not already) on embedded
         * child viewers. For "autoPlay", recursion will always be disabled, and it cannot be re-enabled for
         * a given Experience if already disabled. <p>
         *
         * Setting the "closed" state to true will effectively close (and destroy) this Viewer Proxy (and Viewer) for
         * good, including any recursively embedded child Viewers.
         *
         * @param {*} options If a string, the name of the state property to return: "paused", "stalled", "active",
         *                    "shown", or "closed". If options, specified like {name:String, value:Boolean, recursive:Boolean},
         *                    where <tt>name</tt> is one the four aforementioned names,
         *                    e.g. {name: "active", value:false, recursive:true}.
         *
         * @return {Boolean} The state value if only a state attribute is supplied as argument, e.g. "stalled";
         *                   otherwise undefined.
         */
        this.state = function (options) {
            if (typeof options === "string") {
                return state ? state(options) : true; // "get", no state means closed, stalled, and paused!
            }

            var name = options.name;
            var recursive = typeof options.recursive === "undefined" || options.recursive;
            var i = void 0;

            // Special case: auto play is for current Experience only, i.e. on direct user interaction...
            if (name === "autoPlay") {
                recursive = false;
            }

            // The controller ExperienceViewModel will ensure we recursively call our parent when needed, like
            // for "paused",, i.e. the Viewer potentially embedding this Viewer, so we only need to handle
            // siblings at this point. We do not close here, we need to recurse into children and close them
            // first...
            if (name !== "closed") {
                state(name, options.value, recursive);
            }

            // On certain states, like "stalled", we need to visit all siblings as well, so we handle this
            // explicitly here as we know we will initially be triggered from the top most reachable Viewer...
            if (recursive) {
                for (i = 0; i < _this._children.length; i++) {
                    _this._children[i].state(options); // manually recurse!
                }
            }

            // Call ViewerProxy._close to clean all state...
            if (name === "closed") {
                _this._close();
            }
        };

        /**
         * Closes this Viewer Proxy, and thus the Viewer itself. <p>
         *
         * This is syntactic sugar for calling <tt>self.state({name: "closed", value: true})</tt>; it will thus
         * recursively close any embedded Viewers as well.
         */
        this.close = function () {
            _this.state({ name: "closed", value: true }); // ensures recursion!
        };

        // Closes *this* viewer...
        this._close = function () {
            if (state) {
                log.verbose("Closing viewer: " + _this);

                state("closed", true); // will typically destroy the main region, thus the viewer
                state = null;

                // If embedded via channels, notify channel so it can clean up, e.g. timers...
                if (channel) {
                    channel.callbacks.closed();
                    channel = null;
                }

                // Unregister this viewer, including from its potential parent...
                _this._unregister();
            }
        };

        this.toString = function () {
            var s = "ViewerProxy[";
            var win = _this.win();

            // A closed window where we still have a reference to this ViewerProxy is a severed (programmer) error,
            // so we log it like this to be able to spot such invalid states...
            if (!win) {
                s += "win: closed; ";
            }
            if (state) {
                // i.e. not closed?
                s += "type: ";
                if (_this.parent) {
                    if (_this._intermediate) {
                        s += "intermediate-";
                    }
                    s += _this._children.length ? "node" : "leaf";
                } else {
                    s += "root";
                }
                s += "; active: " + state("active") + "; stalled: " + state("stalled") + "; paused: " + state("paused");
                if (channel) {
                    s += "; channel: " + channel;
                }
            } else {
                s += "closed";
            }
            return s + "]";
        };

        // Register to its parent for communication, like pausing embedded Experiences, getting back potential options
        // for this Viewer set by the parent, like the initial embedding size...
        this.register();
    };

    return ViewerProxy;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    /**
     * Defines the states of the <tt>ChannelContent</tt>.
     *
     * @typedef {Object} ChannelContentState
     *
     * @see  ChannelContent
     * @see  Channel#content
     */

    return {
        // Not loaded (including if it cannot be (pre-)loaded because no jQuery available).
        NOT_LOADED: "notloaded",
        // A load is in progress, but has not completed yet.
        PENDING: "pending",
        // From in-memory cache.
        CACHE: "cache",
        // From session/local storage (and thus from the cache as well).
        LOCAL: "local",
        // loaded, and stored in <tt>content</tt>, including if embedded. Note that when groups are
        // store, the experience data may also be loaded (by the viewer), but such content is not
        // stored here, but may be cached.
        LOADED: "loaded",
        // Preload failed.
        FAILED: "failed"
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    return {
        detect: function detect(userAgent) {
            userAgent = userAgent || window.navigator.userAgent;

            var ANDROID_PATTERN = /Android/;
            var CHROME_PATTERN = /(?:Chrome|CriOS)\/([0-9.]+)/;

            /*
             * Apple devices remove Safari from user-agent when using the
             * apple-mobile-web-app-capable meta tag. If this happens we
             * fallback to detecting on iPad/iPhone presence.
             */
            var SAFARI_PATTERN = /Safari|(?:(?:iPad|iPhone).*AppleWebKit.*Mobile)/;
            var SAFARI_VERSION_PATTERN = /Version\/([0-9.]+)/;
            var FIREFOX_PATTERN = /Firefox\/([0-9.]+)/;
            var EDGE_PATTERN = /Edge/i;
            var EDGE_VERSION_PATTERN = /Edge\/([0-9.]+)/;
            var INTERNET_EXPLORER_PATTERN = /Trident|MSIE/;
            var INTERNET_EXPLORER_VERSION_PATTERN = /(?:MSIE |rv:)([0-9.]+)/;
            var GOOGLEBOT_PATTERN = /Googlebot\/([0-9.]+)/;
            var OPERA_PATTERN = /Opera.*Version\/([0-9.]+)|OPR\/([0-9.]+)/;

            // Currently vaguely expressed as Facebook, Twitter or Instagram specific UA's. See MOS-3042
            var WEB_VIEW_PATTERN = /FBAN|FB_IAB|FB4A|FBAV|Twitter|Instagram/;
            var MOBILE_PATTERN = /Mobile/; // used for smartphones.
            var TABLET_PATTERN = /Tablet/; // used for Tablets.
            var IPOD_PATTERN = /iPod/;
            var IPHONE_PATTERN = /iPhone/;
            var IPAD_PATTERN = /iPad/;
            var WEB_KIT_PATTERN = /AppleWebKit/;
            var DEFAULT_BROWSER_VERSION = [];
            var DEFAULT_OS_VERSION = [];

            /*
             * List of supported OS version patterns.
             */
            var ANDROID_VERSION_PATTERN = /Android ([._\d]+)/;
            var IOS_VERSION_PATTERN = /OS ([._\d]+)/;
            var MAC_VERSION_PATTERN = /Mac OS X ([._\d]+)/;
            var WINDOWS_VERSION_PATTERN = /Windows\s+NT\s+([\d.]+)/;

            /**
             * Tests for Android devices.
             *
             * @returns {Boolean} <code>true</code> if the current device is running
             *          on Android, <code>false</code> if not.
             */
            function isAndroid() {
                return ANDROID_PATTERN.exec(userAgent) !== null;
            }

            /**
             * Tests for MAC OS.
             *
             * @returns {Boolean} <code>true</code> if the current device is running
             *          on Mac, <code>false</code> if not.
             */
            function isMacOS() {
                return userAgent.indexOf("Mac OS X") !== -1;
            }

            /**
             * Tests for Windows OS.
             *
             * @returns {Boolean} <code>true</code> if the current device is running
             *          on Windows, <code>false</code> if not.
             */
            function isWindows() {
                return userAgent.indexOf("Windows") !== -1;
            }

            /**
             * Tests for iOS.
             *
             * @returns {Boolean} <code>true</code> if the current device is running
             *          on iOS, <code>false</code> if not.
             */
            function isIOS() {
                return isIPod() || isIPhone() || isIPad();
            }

            /**
             * Tests for iPod.
             *
             * @returns {Boolean} <code>true</code> if the device is an iPod Touch, <code>false</code> if not.
             */
            function isIPod() {
                return IPOD_PATTERN.exec(userAgent) !== null;
            }

            /**
             * Tests for iPad.
             *
             * @returns {Boolean} <code>true</code> if the device is an iPad, <code>false</code> if not.
             */
            function isIPad() {
                return IPAD_PATTERN.exec(userAgent) !== null;
            }

            /**
             * Tests for iPhone.
             *
             * @returns {Boolean} <code>true</code> if the device is an iPhone, <code>false</code> if not.
             */
            function isIPhone() {
                return IPHONE_PATTERN.exec(userAgent) !== null;
            }

            /**
             * Whether we believe we're inside a WebView, see <tt>WEB_VIEW_PATTERN</tt>.
             *
             * Currently we match Facebook, Twitter and Instagram.
             *
             * @returns {Boolean} <code>true</code> if we're inside a WebView.
             */
            function isWebView() {
                return WEB_VIEW_PATTERN.exec(userAgent) !== null;
            }

            /**
             * Tests for Microsoft Edge.
             *
             * @returns {Boolean} <code>true</code> if the current browser is Microsoft Edge, <code>false</code> if not.
             */
            function isEdge() {
                return EDGE_PATTERN.exec(userAgent) !== null;
            }

            /**
             * Tests for Chrome.
             *
             * @returns {Boolean} <code>true</code> if the current browser is using Chrome engine, <code>false</code> if not.
             */
            function isChrome() {
                return CHROME_PATTERN.exec(userAgent) !== null && !isEdge(); // Edge pretends to be Chrome
            }

            /**
             * Tests for Webkit.
             *
             * @returns {Boolean} <code>true</code> if the current browser is using Webkit engine, <code>false</code> if not.
             */
            function isWebkit() {
                return WEB_KIT_PATTERN.exec(userAgent) !== null && !isEdge(); // Edge pretends to be webkit
            }

            /**
             * Tests for mobile devices.
             *
             * @returns {Boolean} <code>true</code> if the current browser is a mobile one, <code>false</code> if not.
             */
            function isMobile() {
                return MOBILE_PATTERN.exec(userAgent) !== null;
            }

            /**
             * Tests for tablet devices.
             *
             * @returns {Boolean} <code>true</code> if the current device is a tablet, <code>false</code> if not.
             */
            function isTablet() {
                // Tablet on Android Chrome does not contain the Mobile in the user string.
                if (isAndroid() && isChrome()) {
                    return !isMobile();
                }

                // Some iOS devices do not contain the Tablet string.
                return TABLET_PATTERN.exec(userAgent) !== null || isIPad();
            }

            /**
             * Get the version of the currently detected browser. This method
             * returns an array of integers containing the browser version,
             * starting with the major version (e.g. version "12.5.2.67"
             * becomes [12,5,2,67]).
             *
             * Note that any letters contained in versions will be subject to
             * the parseInt method (e.g. "15.0a1"). Firefox has a history of
             * doing this for dev releases.
             *
             * @returns {number[]} The version as an array, or empty array if unable to determine
             */
            function getBrowserVersion(pattern, matchIndex) {
                if (!pattern) {
                    return DEFAULT_BROWSER_VERSION;
                } else if (!matchIndex) {
                    matchIndex = 1;
                }

                var match = pattern.exec(userAgent);
                if (match) {
                    var versions = match[matchIndex].split(".");
                    var idx = versions.length;

                    // Convert versions from string to int.
                    while (idx--) {
                        versions[idx] = parseInt(versions[idx], 10);
                    }
                    return versions;
                }
                return DEFAULT_BROWSER_VERSION;
            }

            /**
             * Get the Operative system version where the the currently detected browser is operating.
             * This method returns an array of integers containing the browser version,
             * starting with the major version (e.g. version "12.5.2.67" becomes [12,5,2,67]).
             * @returns {number[]} The version as an array, or empty array if unable to determine
             */
            function getOSVersion() {
                var operatingSystemInfo = null;
                if (isAndroid()) {
                    operatingSystemInfo = ANDROID_VERSION_PATTERN.exec(userAgent);
                } else if (isIOS()) {
                    operatingSystemInfo = IOS_VERSION_PATTERN.exec(userAgent);
                } else if (isWindows()) {
                    operatingSystemInfo = WINDOWS_VERSION_PATTERN.exec(userAgent);
                } else if (isMacOS()) {
                    operatingSystemInfo = MAC_VERSION_PATTERN.exec(userAgent);
                }

                // operatingSystemInfo is an array containing OS Name and OS version number, e.g. ["Android", "4.4"].
                if (operatingSystemInfo && operatingSystemInfo.length === 2) {
                    var versionArray = operatingSystemInfo[1].replace(/_/g, ".") // Normalize the array as some Android user agent contains _ instead of .
                    .split(".");
                    var i = 0;

                    for (i = 0; i < versionArray.length; i++) {
                        versionArray[i] = parseInt(versionArray[i], 10);
                    }

                    return versionArray;
                }

                return DEFAULT_OS_VERSION;
            }

            var result = {
                desktop: false,
                tablet: isTablet(),
                mobile: isMobile(),

                android: isAndroid(),
                iOS: isIOS(),
                macOS: isMacOS(),
                winOS: isWindows(),
                osVersion: getOSVersion(),

                // Being inside a WebView doesn't leave out browser detection, e.g. we could be inside a Chrome based WebView.
                webView: isWebView(),

                webkit: isWebkit(),
                ie: false,
                firefox: false,
                safari: false,
                chrome: false,
                googlebot: false,
                opera: false,
                edge: false,
                version: DEFAULT_BROWSER_VERSION
            };

            // Check mobile/desktop...
            result.desktop = !(result.iOS || result.android || result.mobile || result.tablet);

            /*
             * NOTE: The order of checks is important as opera 15+ will
             * disguise itself as chrome and safari. See the test spec
             * for example of opera user agent.
             */
            if (OPERA_PATTERN.exec(userAgent) !== null) {
                var match = OPERA_PATTERN.exec(userAgent);
                if (match[1]) {
                    result.version = getBrowserVersion(OPERA_PATTERN, 1);
                } else {
                    result.version = getBrowserVersion(OPERA_PATTERN, 2);
                }
                result.opera = true;
            } else if (isEdge()) {
                result.edge = true;
                result.version = getBrowserVersion(EDGE_VERSION_PATTERN);
            } else if (INTERNET_EXPLORER_PATTERN.exec(userAgent) !== null) {
                result.ie = true;
                result.version = getBrowserVersion(INTERNET_EXPLORER_VERSION_PATTERN);
            } else if (FIREFOX_PATTERN.exec(userAgent) !== null) {
                result.firefox = true;
                result.version = getBrowserVersion(FIREFOX_PATTERN);
            } else if (isChrome()) {
                result.chrome = true;
                result.version = getBrowserVersion(CHROME_PATTERN);
            } else if (GOOGLEBOT_PATTERN.exec(userAgent) !== null) {
                result.googlebot = true;
                result.version = getBrowserVersion(GOOGLEBOT_PATTERN);
                // Some android devices (e.g. Motorola Xoom with android 4.0) match the safari pattern, so we
                // test explicitly that it isn't android.
            } else if (!result.android && SAFARI_PATTERN.exec(userAgent) !== null) {
                result.safari = true;
                result.version = getBrowserVersion(SAFARI_VERSION_PATTERN);
            }

            return result;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        _ = __webpack_require__(1),
        Keyboard = __webpack_require__(243),
        Preconditions = __webpack_require__(14);

    var KEYBOARD_EVENT_REGEX = /((?:(?:ctrl|alt|shift)-)*)(\S+)(?: (.*))?/;

    /**
     * Extends the view to support keyboard configuration.
     */
    var viewConstructor = Marionette.View.prototype.constructor;
    Marionette.View.prototype.constructor = function () {
        // Invoke super constructor
        viewConstructor.apply(this, _.toArray(arguments));

        // Setup keyboard events.
        // The event string can be e.g. "escape", "escape #my-input" or "ctrl-shift-x .blarh tr.blah", which is
        // mapped to a callback similar to the events map.
        // Note that the selector is applied globally, not only in the view's scope!
        if (this.keyboard) {
            _.each(this.keyboard, function (callback, event) {
                var matches = KEYBOARD_EVENT_REGEX.exec(event);

                Preconditions.checkArgument(matches, "Unable to parse keyboard event specification", event);

                var modifier = matches[1] || "",
                    keyName = matches[2],
                    selector = matches[3] || "";

                var keyCode = Keyboard.KeyCode[keyName.toLocaleUpperCase()];

                Preconditions.checkArgument(keyCode, "Unknown key name", keyName);

                // Monkey the values into a string as listenTo() does not accept a list or object as the second of three parameters.
                this.listenTo(Keyboard.Down, keyCode + "/" + modifier + "/" + selector, function () {
                    callback = _.isString(callback) ? this[callback] : callback;
                    callback.apply(this, arguments);
                });
            }, this);
        }

        this.listenTo(this, "item:rendered collection:rendered", function () {
            // Automatically apply Stickit bindings.
            if (this.bindings) {
                this.stickit();
            }
        });

        // Setup any view controllers
        if (_.isFunction(this.controller)) {
            var Controller = this.controller;
            this.controller = new Controller({ view: this });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
/**
 * Copyright 2013 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.4.6
 * @url craig.is/killing/mice
 */
(function(window, document, undefined) {

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
            8: 'backspace',
            9: 'tab',
            13: 'enter',
            16: 'shift',
            17: 'ctrl',
            18: 'alt',
            20: 'capslock',
            27: 'esc',
            32: 'space',
            33: 'pageup',
            34: 'pagedown',
            35: 'end',
            36: 'home',
            37: 'left',
            38: 'up',
            39: 'right',
            40: 'down',
            45: 'ins',
            46: 'del',
            91: 'meta',
            93: 'meta',
            224: 'meta'
        },

        /**
         * mapping for special characters so they can support
         *
         * this dictionary is only used incase you want to bind a
         * keyup or keydown event to one of these keys
         *
         * @type {Object}
         */
        _KEYCODE_MAP = {
            106: '*',
            107: '+',
            109: '-',
            110: '.',
            111 : '/',
            186: ';',
            187: '=',
            188: ',',
            189: '-',
            190: '.',
            191: '/',
            192: '`',
            219: '[',
            220: '\\',
            221: ']',
            222: '\''
        },

        /**
         * this is a mapping of keys that require shift on a US keypad
         * back to the non shift equivelents
         *
         * this is so you can use keyup events with these keys
         *
         * note that this will only work reliably on US keyboards
         *
         * @type {Object}
         */
        _SHIFT_MAP = {
            '~': '`',
            '!': '1',
            '@': '2',
            '#': '3',
            '$': '4',
            '%': '5',
            '^': '6',
            '&': '7',
            '*': '8',
            '(': '9',
            ')': '0',
            '_': '-',
            '+': '=',
            ':': ';',
            '\"': '\'',
            '<': ',',
            '>': '.',
            '?': '/',
            '|': '\\'
        },

        /**
         * this is a list of special strings you can use to map
         * to modifier keys when you specify your keyboard shortcuts
         *
         * @type {Object}
         */
        _SPECIAL_ALIASES = {
            'option': 'alt',
            'command': 'meta',
            'return': 'enter',
            'escape': 'esc',
            'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
        },

        /**
         * variable to store the flipped version of _MAP from above
         * needed to check if we should use keypress or not when no action
         * is specified
         *
         * @type {Object|undefined}
         */
        _REVERSE_MAP,

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        _callbacks = {},

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        _directMap = {},

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        _sequenceLevels = {},

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        _resetTimer,

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        _ignoreNextKeyup = false,

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        _ignoreNextKeypress = false,

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        _nextExpectedAction = false;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {
        _MAP[i + 96] = i;
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * resets all sequence counters except for the ones passed in
     *
     * @param {Object} doNotReset
     * @returns void
     */
    function _resetSequences(doNotReset) {
        doNotReset = doNotReset || {};

        var activeSequences = false,
            key;

        for (key in _sequenceLevels) {
            if (doNotReset[key]) {
                activeSequences = true;
                continue;
            }
            _sequenceLevels[key] = 0;
        }

        if (!activeSequences) {
            _nextExpectedAction = false;
        }
    }

    /**
     * finds all callbacks that match based on the keycode, modifiers,
     * and action
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event|Object} e
     * @param {string=} sequenceName - name of the sequence we are looking for
     * @param {string=} combination
     * @param {number=} level
     * @returns {Array}
     */
    function _getMatches(character, modifiers, e, sequenceName, combination, level) {
        var i,
            callback,
            matches = [],
            action = e.type;

        // if there are no events related to this keycode
        if (!_callbacks[character]) {
            return [];
        }

        // if a modifier key is coming up on its own we should allow it
        if (action == 'keyup' && _isModifier(character)) {
            modifiers = [character];
        }

        // loop through all callbacks for the key that was pressed
        // and see if any of them match
        for (i = 0; i < _callbacks[character].length; ++i) {
            callback = _callbacks[character][i];

            // if a sequence name is not specified, but this is a sequence at
            // the wrong level then move onto the next match
            if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                continue;
            }

            // if the action we are looking for doesn't match the action we got
            // then we should keep going
            if (action != callback.action) {
                continue;
            }

            // if this is a keypress event and the meta key and control key
            // are not pressed that means that we need to only look at the
            // character, otherwise check the modifiers as well
            //
            // chrome will not fire a keypress if meta or control is down
            // safari will fire a keypress if meta or meta+shift is down
            // firefox will fire a keypress if meta or control is down
            if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {

                // when you bind a combination or sequence a second time it
                // should overwrite the first one.  if a sequenceName or
                // combination is specified in this call it does just that
                //
                // @todo make deleting its own method?
                var deleteCombo = !sequenceName && callback.combo == combination;
                var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                if (deleteCombo || deleteSequence) {
                    _callbacks[character].splice(i, 1);
                }

                matches.push(callback);
            }
        }

        return matches;
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * actually calls the callback function
     *
     * if your callback function returns false this will use the jquery
     * convention - prevent default and stop propogation on the event
     *
     * @param {Function} callback
     * @param {Event} e
     * @returns void
     */
    function _fireCallback(callback, e, combo, sequence) {

        // if this event should not happen stop here
        if (Mousetrap.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
            return;
        }

        if (callback(e, combo) === false) {
            _preventDefault(e);
            _stopPropagation(e);
        }
    }

    /**
     * handles a character key event
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event} e
     * @returns void
     */
    function _handleKey(character, modifiers, e) {
        var callbacks = _getMatches(character, modifiers, e),
            i,
            doNotReset = {},
            maxLevel = 0,
            processedSequenceCallback = false;

        // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
        for (i = 0; i < callbacks.length; ++i) {
            if (callbacks[i].seq) {
                maxLevel = Math.max(maxLevel, callbacks[i].level);
            }
        }

        // loop through matching callbacks for this key event
        for (i = 0; i < callbacks.length; ++i) {

            // fire for all sequence callbacks
            // this is because if for example you have multiple sequences
            // bound such as "g i" and "g t" they both need to fire the
            // callback for matching g cause otherwise you can only ever
            // match the first one
            if (callbacks[i].seq) {

                // only fire callbacks for the maxLevel to prevent
                // subsequences from also firing
                //
                // for example 'a option b' should not cause 'option b' to fire
                // even though 'option b' is part of the other sequence
                //
                // any sequences that do not match here will be discarded
                // below by the _resetSequences call
                if (callbacks[i].level != maxLevel) {
                    continue;
                }

                processedSequenceCallback = true;

                // keep a list of which sequences were matches for later
                doNotReset[callbacks[i].seq] = 1;
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                continue;
            }

            // if there were no sequence matches but we are still here
            // that means this is a regular match so we should fire that
            if (!processedSequenceCallback) {
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
        }

        // if the key you pressed matches the type of sequence without
        // being a modifier (ie "keyup" or "keypress") then we should
        // reset all sequences that were not matched by this event
        //
        // this is so, for example, if you have the sequence "h a t" and you
        // type "h e a r t" it does not match.  in this case the "e" will
        // cause the sequence to reset
        //
        // modifier keys are ignored because you can have a sequence
        // that contains modifiers such as "enter ctrl+space" and in most
        // cases the modifier key will be pressed before the next key
        //
        // also if you have a sequence such as "ctrl+b a" then pressing the
        // "b" key will trigger a "keypress" and a "keydown"
        //
        // the "keydown" is expected when there is a modifier, but the
        // "keypress" ends up matching the _nextExpectedAction since it occurs
        // after and that causes the sequence to reset
        //
        // we ignore keypresses in a sequence that directly follow a keydown
        // for the same character
        var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
        if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
            _resetSequences(doNotReset);
        }

        _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
    }

    /**
     * handles a keydown event
     *
     * @param {Event} e
     * @returns void
     */
    function _handleKeyEvent(e) {

        // normalize e.which for key events
        // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
        if (typeof e.which !== 'number') {
            e.which = e.keyCode;
        }

        var character = _characterFromEvent(e);

        // no character found then stop
        if (!character) {
            return;
        }

        // need to use === for the character check because the character can be 0
        if (e.type == 'keyup' && _ignoreNextKeyup === character) {
            _ignoreNextKeyup = false;
            return;
        }

        Mousetrap.handleKey(character, _eventModifiers(e), e);
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * called to set a 1 second timeout on the specified sequence
     *
     * this is so after each key press in the sequence you have 1 second
     * to press the next key before you have to start over
     *
     * @returns void
     */
    function _resetSequenceTimer() {
        clearTimeout(_resetTimer);
        _resetTimer = setTimeout(_resetSequences, 1000);
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * binds a key sequence to an event
     *
     * @param {string} combo - combo specified in bind call
     * @param {Array} keys
     * @param {Function} callback
     * @param {string=} action
     * @returns void
     */
    function _bindSequence(combo, keys, callback, action) {

        // start off by adding a sequence level record for this combination
        // and setting the level to 0
        _sequenceLevels[combo] = 0;

        /**
         * callback to increase the sequence level for this sequence and reset
         * all other sequences that were active
         *
         * @param {string} nextAction
         * @returns {Function}
         */
        function _increaseSequence(nextAction) {
            return function() {
                _nextExpectedAction = nextAction;
                ++_sequenceLevels[combo];
                _resetSequenceTimer();
            };
        }

        /**
         * wraps the specified callback inside of another function in order
         * to reset all sequence counters as soon as this sequence is done
         *
         * @param {Event} e
         * @returns void
         */
        function _callbackAndReset(e) {
            _fireCallback(callback, e, combo);

            // we should ignore the next key up if the action is key down
            // or keypress.  this is so if you finish a sequence and
            // release the key the final key will not trigger a keyup
            if (action !== 'keyup') {
                _ignoreNextKeyup = _characterFromEvent(e);
            }

            // weird race condition if a sequence ends with the key
            // another sequence begins with
            setTimeout(_resetSequences, 10);
        }

        // loop through keys one at a time and bind the appropriate callback
        // function.  for any key leading up to the final one it should
        // increase the sequence. after the final, it should reset all sequences
        //
        // if an action is specified in the original bind call then that will
        // be used throughout.  otherwise we will pass the action that the
        // next key in the sequence should match.  this allows a sequence
        // to mix and match keypress and keydown events depending on which
        // ones are better suited to the key provided
        for (var i = 0; i < keys.length; ++i) {
            var isFinal = i + 1 === keys.length;
            var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
            _bindSingle(keys[i], wrappedCallback, action, combo, i);
        }
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys,
            key,
            i,
            modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    /**
     * binds a single keyboard combination
     *
     * @param {string} combination
     * @param {Function} callback
     * @param {string=} action
     * @param {string=} sequenceName - name of sequence if part of sequence
     * @param {number=} level - what part of the sequence the command is
     * @returns void
     */
    function _bindSingle(combination, callback, action, sequenceName, level) {

        // store a direct mapped reference for use with Mousetrap.trigger
        _directMap[combination + ':' + action] = callback;

        // make sure multiple spaces in a row become a single space
        combination = combination.replace(/\s+/g, ' ');

        var sequence = combination.split(' '),
            info;

        // if this pattern is a sequence of keys then run through this method
        // to reprocess each pattern one key at a time
        if (sequence.length > 1) {
            _bindSequence(combination, sequence, callback, action);
            return;
        }

        info = _getKeyInfo(combination, action);

        // make sure to initialize array if this is the first time
        // a callback is added for this key
        _callbacks[info.key] = _callbacks[info.key] || [];

        // remove an existing match if there is one
        _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);

        // add this call back to the array
        // if it is a sequence put it at the beginning
        // if not put it at the end
        //
        // this is important because the way these are processed expects
        // the sequence ones to come first
        _callbacks[info.key][sequenceName ? 'unshift' : 'push']({
            callback: callback,
            modifiers: info.modifiers,
            action: info.action,
            seq: sequenceName,
            level: level,
            combo: combination
        });
    }

    /**
     * binds multiple combinations to the same callback
     *
     * @param {Array} combinations
     * @param {Function} callback
     * @param {string|undefined} action
     * @returns void
     */
    function _bindMultiple(combinations, callback, action) {
        for (var i = 0; i < combinations.length; ++i) {
            _bindSingle(combinations[i], callback, action);
        }
    }

    // start!
    _addEvent(document, 'keypress', _handleKeyEvent);
    _addEvent(document, 'keydown', _handleKeyEvent);
    _addEvent(document, 'keyup', _handleKeyEvent);

    var Mousetrap = {

        /**
         * binds an event to mousetrap
         *
         * can be a single key, a combination of keys separated with +,
         * an array of keys, or a sequence of keys separated by spaces
         *
         * be sure to list the modifier keys first to make sure that the
         * correct key ends up getting bound (the last key in the pattern)
         *
         * @param {string|Array} keys
         * @param {Function} callback
         * @param {string=} action - 'keypress', 'keydown', or 'keyup'
         * @returns void
         */
        bind: function(keys, callback, action) {
            keys = keys instanceof Array ? keys : [keys];
            _bindMultiple(keys, callback, action);
            return this;
        },

        /**
         * unbinds an event to mousetrap
         *
         * the unbinding sets the callback function of the specified key combo
         * to an empty function and deletes the corresponding key in the
         * _directMap dict.
         *
         * TODO: actually remove this from the _callbacks dictionary instead
         * of binding an empty function
         *
         * the keycombo+action has to be exactly the same as
         * it was defined in the bind method
         *
         * @param {string|Array} keys
         * @param {string} action
         * @returns void
         */
        unbind: function(keys, action) {
            return Mousetrap.bind(keys, function() {}, action);
        },

        /**
         * triggers an event that has already been bound
         *
         * @param {string} keys
         * @param {string=} action
         * @returns void
         */
        trigger: function(keys, action) {
            if (_directMap[keys + ':' + action]) {
                _directMap[keys + ':' + action]({}, keys);
            }
            return this;
        },

        /**
         * resets the library back to its initial state.  this is useful
         * if you want to clear out the current keyboard shortcuts and bind
         * new ones - for example if you switch to another page
         *
         * @returns void
         */
        reset: function() {
            _callbacks = {};
            _directMap = {};
            return this;
        },

       /**
        * should we stop this event before firing off callbacks
        *
        * @param {Event} e
        * @param {Element} element
        * @return {boolean}
        */
        stopCallback: function(e, element) {

            // if the element has the class "mousetrap" then no need to stop
            if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
                return false;
            }

            // stop for input, select, and textarea
            return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
        },

        /**
         * exposes _handleKey publicly so it can be overwritten by extensions
         */
        handleKey: _handleKey
    };

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (Mousetrap),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}) (window, document);


/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * The "shared" `CollectionView` extension for supporting the concept of a view scope within `CollectionView`'s.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(10),
        CollectionView = _require.CollectionView;

    var ViewScope = __webpack_require__(171);

    var superRenderItemView = CollectionView.prototype.renderItemView;

    CollectionView.prototype.renderItemView = function (view, index) {
        view.parentView = this;
        ViewScope.register(this, view);

        superRenderItemView.call(this, view, index);
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);

    // Marionette always append newly added view to the end, so we overwrite it here to respect the
    // index of newly added view. This implementation only works when the child item views in the
    // CollectionView all have the same class name.
    // https://github.com/marionettejs/backbone.marionette/blob/v2.0.0/src/marionette.collectionview.js#L371
    Marionette.CollectionView.prototype.appendHtml = function (collectionView, itemView, index) {
        var $elem = collectionView.$el;

        if (collectionView.isBuffering) {
            collectionView.elBuffer.appendChild(itemView.el);
        } else {
            var classFilter = itemView.className ? "." + itemView.className : "",
                children = $elem.children(classFilter);

            if (index >= 0 && children.length) {
                if (index === 0) {
                    children.eq(0).before(itemView.el);
                } else {
                    children.eq(Math.min(index - 1, children.length - 1)).after(itemView.el);
                }
            } else {
                $elem.append(itemView.el);
            }
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Include editor required mixin functionality. A mixin named "FooXxxMixin" will mix with the aptly named
// class "Foo" (Xxx could be "Sync", but it could also be empty).
new Promise(function(resolve) { resolve(); }).then(function() {[
// The order below matters! Possibly only if the mixins depend on each other like ImprovedModelSyncMixin and ExperienceModelEditorMixin. See MOS-2384.
__webpack_require__(1393), __webpack_require__(1397), __webpack_require__(1412), __webpack_require__(1473), __webpack_require__(1506), __webpack_require__(1507), __webpack_require__(2092), __webpack_require__(2096), __webpack_require__(2100), __webpack_require__(2101), __webpack_require__(2725), __webpack_require__(2729), __webpack_require__(2730), __webpack_require__(2731), __webpack_require__(2732), __webpack_require__(2733), __webpack_require__(2734), __webpack_require__(2738), __webpack_require__(2739), __webpack_require__(2740), __webpack_require__(2741), __webpack_require__(2742), __webpack_require__(2743), __webpack_require__(2744), __webpack_require__(2745), __webpack_require__(2746), __webpack_require__(2747), __webpack_require__(2748)];}).catch(__webpack_require__.oe);

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AssociatedModel = __webpack_require__(352);
    var Backbone = __webpack_require__(7);
    var ErrorHandler = __webpack_require__(119);
    var ImprovedModel = __webpack_require__(25);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Permissions = __webpack_require__(22);
    var Preconditions = __webpack_require__(14);
    var Promise = __webpack_require__(21);
    var Syncer = __webpack_require__(50);
    var SyncManager = __webpack_require__(44);

    // COLLECTIONS

    var _fetch = Backbone.Collection.prototype.fetch;

    var SEQUENCE = 1;

    // Mixin "fetch" for collections so the sync manager is used for consistency and to display spinner when
    // collections are loaded as well. We cannot use the standard "mixin" functionality here as it has not
    // been defined on Backbone types...
    Backbone.Collection.prototype.fetch = function (options) {
        // We really need a common super collection type like Class!
        var collection = this;

        return SyncManager.sync({
            method: "fetch",
            immutable: true,
            silent: options && options.silent,
            fn: function fn() {
                return _fetch.call(collection, options);
            }
        }, collection).promise();
    };
    // Mixin somewhat meaningful "toString" for collections...
    Backbone.Collection.prototype.toString = function () {
        // Generate unique id for *this* collection for easier debugging...
        if (!this.id) {
            this.id = SEQUENCE++;
        }

        var s = "Collection[id: " + this.id;

        if (this.model.__typeName) {
            s += "; model: " + this.model.__typeName;
        }

        return s + "; size: " + this.length + "]";
    };

    var log = new Logger("ImprovedModel");

    // UPDATE LOGIC
    //
    // Note: defined here, outside ImprovedModel, as it must work on both normal Backbone.Model and ImprovedModels alike!

    // Frontend field used to store the identity for non-persisted identifiable models. We have patched
    // Backbone.Model so no attribute named "cid" can be stored on any model!...
    var TEMP_ID = "cid";
    var UNIQUE_ID = "uuid";

    // Default fields to exclude on clone({duplicate:true}).
    var META_FIELDS_DUPLICATE = ["id", "version", "createdAt", "editedAt", UNIQUE_ID];

    // Default fields to exclude on clone({duplicate:true, duplicateExperienceWithUUID: true}). (PE-1461 for more details)
    var META_FIELDS_DUPLICATE_WITHOUT_UUID = ['id', 'version', 'createdAt', 'editedAt'];

    // Default fields to update for identifiable models on sync that will have performed some update,
    // e.g. "save" or even "push" for experiences, none of them silent! TEMP_ID not included as it will
    // only ever be present when saving to the server and not updated based on the response!...
    var META_FIELDS_UPDATE = ["id", { name: "version", silent: true }, "createdAt", "createdBy", "editedAt", "editedBy"];

    // Test if the supplied model/collection is considered identifiable: can be identified via the "id" property,
    // alternatively via the TEMP_ID property until created. This odd construct is for legacy purposes, so we do not
    // have to mark all our top level collections as identifiables...
    var identifiable = function identifiable(o) {
        return o && (typeof o.identifiable === "undefined" || o.identifiable);
    };

    /**
     * @private
     * Returns the (temp) id assigned to any Backbone.Model, need not be an ImprovedModel.
     *
     * @param {Backbone.Model} model The model to find the id for; never null.
     * @return {String} The id; never null.
     */
    var _identifier = function _identifier(model) {
        return model.get("id") || model[TEMP_ID]; // not an attribute, Backbone internal!
    };

    /**
     * @private
     * Returns the preferences for doing an update of the specified model after sync for the sync method specified
     * by the supplied options. <p>
     *
     * Implementation note: declared as a function like this it must also work for standard Backbone.Model
     * types, not just ImprovedModels. See _update(..) for usage!
     *
     * @param {Backbone.Model} model The Backbone.Model or ImprovedModel to use; never null.
     * @param {*} [options] The options optionally specifying the sync to be performed against the
     *                      server; can be falsey. The sync method tested is specified as {sync:String},
     *                      e.g. "sync:save" or "sync:fetch". If falsey, "update:all" is returned.
     *
     * @return {update:String, attributes: []} The update preferences, where <tt>update</tt> will be either
     *         "all", "no", or "attributes", and the <tt>attributes</tt> array will contain the attributes
     *         to update in case "update:attributes" (can be empty).
     */
    var updateOnSync = function updateOnSync(model, options) {
        // Common cases, the complex logic is only really for updates like "save", or even "push" for
        // experiences. Note that we will in fact always have "options" here when we are fetching via
        // http, as we (probably in the Syncer or is it Backbone ?) somewhere down the line mixes
        // incoming properties with http ones. This also means we cannot use reversed option names
        // like "method"...
        if (!options || !options.sync || options.sync === "fetch") {
            return { update: "all" };
        } else if (options.sync === "delete") {
            return { update: "no" };
        }

        // Specific attributes to update, or perhaps preferences to update as above...? This will work with
        // both Backbone.Model and ImprovedModel types...
        var preferences = _.isFunction(model.updateOnSync) ? model.updateOnSync(options) : model.updateOnSync;

        // No preferences is determined to be no relevant attributes for this model, though its
        // relations may be updated recursively...
        // eslint-disable-next-line eqeqeq
        if (preferences == null || Array.isArray(preferences)) {
            return { update: "attributes", attributes: preferences }; // undefined/null array means empty!
        }

        // Fancy short-cuts for models...
        var type = typeof preferences === "undefined" ? "undefined" : _typeof(preferences);
        if (type === "boolean") {
            return { update: preferences ? "all" : "no" };
        } else if (type === "string") {
            return { update: preferences };
        }
        // Assume preferences as-is...
        return preferences;
    };

    /**
     * @private
     * Updates the specified model recursively after a sync of the specified type, e.g. "save". We have to do this
     * always for the entire graph to handle meta data and newly assigned ids to objects even if they
     * have moved while the request was pending. <p>
     *
     * Due to the problems listed in "ImprovedModel.parse", we have to update the *existing* model graph with required
     * data to avoid loosing the existing graph/models.
     *
     * @param {Backbone.Model} root    The Backbone root model to start the update from ("this"); never falsey.
     * @param {*}              json    The json to update <tt>model</tt> with based on the attributes specified
     *                                 to be updated via <tt>model.updateOnSync</tt> preferences; can be falsey,
     *                                 e.g. no server response.
     * @param {*}              options The options used, where <tt>options.sync</tt> specifies the update to perform.
     *                                 Null will result in a full model update.
     */
    var updateModel = function updateModel(root, json, options) {
        // Implementation note: we loop here instead of calling this recursively on each model as we have a mix
        // between improved models *and* standard backbone models; the latter will not support this function,
        // but can still declare "updateOnSync". This is especially important here, as "_update" is a new
        // function, with no default implementation like "toJSON"...

        if (!json) {
            return;
        }

        // Pick changed attributes based on json "data" to update "model" in two maps: one for silent,
        // one for loud (triggering relevant change events). Changes to attributes that are relations
        // will be coerced into loud...
        var pick = function pick(model, data, attributes) {
            var result = { silent: null, loud: null, relations: null },
                relationType = function relationType(name) {
                var relation, i;

                if (model.relations) {
                    for (i = 0; i < model.relations.length; i++) {
                        relation = model.relations[i];
                        if (relation.key === name) {
                            return relation.type;
                        }
                    }
                }
                return null;
            },
                map = function map(name) {
                var map = result[name];
                if (!map) {
                    result[name] = map = {};
                }
                return map;
            },
                add = function add(silent, name, value) {
                var relation = relationType(name),
                    update = false,
                    oldValue;

                // If an attribute is in fact a relation, the entire relation will be updated based on the
                // data, meaning contained models will be updated fully recursively. We have to test for
                // this here as we must enforce it as loud...
                if (relation) {
                    map("relations")[name] = relation;
                    update = true;
                    silent = false; // always set entire relationships loudly...
                }

                // Do not bother trying to update non-changed values, so by testing this here, we get better
                // log messages and can perhaps avoid firing up heavy Backbone change logic whenever possible...
                // eslint-disable-next-line eqeqeq
                if (value != null) {
                    oldValue = model.get(name);
                    // Skip updating empty arrays...
                    // eslint-disable-next-line eqeqeq
                    update = Array.isArray(value) && !value.length && Array.isArray(oldValue) && !oldValue.length ? false : oldValue != value;
                }

                if (update) {
                    map(silent ? "silent" : "loud")[name] = value;
                }
            };

            var attribute, i;

            for (i = 0; i < attributes.length; i++) {
                attribute = attributes[i];
                // Handle attribute specified either as a string, e.g. "foo", which will be loud, or as
                // options like {name:String, silent:Boolean}, which may or may not be loud/silent...
                if (typeof attribute === "string") {
                    add(false, attribute, data[attribute]);
                } else {
                    add(attribute.silent, attribute.name, data[attribute.name]);
                }
            }
            return result;
        };

        var silentOptions = { silent: true, triggeredByServerUpdate: true },
            loudOptions = { triggeredByServerUpdate: true };

        // Pairs existing models in a non-empty Backbone.Collection with the returned json, taking temp ids into
        // account to ensure changes to the collection will still match the correct data...
        var updateCollection = function updateCollection(collection, data) {
            var map = {},
                model,
                id,
                i;

            // Index the json models from the response via their id *and* via the temp id we assigned to them...
            for (i = 0; i < data.length; i++) {
                // json array!
                model = data[i]; // json
                id = model.id;
                if (id) {
                    map[id] = model;
                }
                id = model[TEMP_ID];
                if (id) {
                    map[id] = model;
                }
            }

            // Now update each existing model, ignoring those where we have no match in the response, i.e. those
            // created on the frontend while the request was in flight...
            collection.each(function (collectionModel) {
                var model = map[_identifier(collectionModel)]; // may not be an ImprovedModel!
                if (model) {
                    update(collectionModel, model);
                }
            });
        };

        // This will never update the relationship itself, only contained models within such relationships. It will
        // also ensure that models moved around in Backbone.Many relations will still match...
        var internalUpdate = function internalUpdate(model, data) {
            // Will work for any Backbone.Model type, not just our ImprovedModel...
            var preferences = updateOnSync(model, options),
                attributes,
                values;

            // Do we need to update the entire model, or not at all? If so, we can return early...
            if (preferences.update !== "attributes") {
                return preferences;
            }

            // Get attributes then, can still be falsey though, i.e. no attributes to update for
            // "model", but we must still handle relations below...
            attributes = preferences.attributes;

            // If the model is identifiable, let's update the standard meta fields...
            if (identifiable(model)) {
                if (attributes) {
                    attributes = META_FIELDS_UPDATE.concat(attributes);
                } else {
                    attributes = META_FIELDS_UPDATE;
                }
            }

            // Find attributes and update "model"; the values may be the same as the existing ones, of course.
            // Even if we have no attributes, e.g. for non-identifiables types, we still want to traverse the
            // relations below...
            if (attributes) {
                values = pick(model, data, attributes);

                // Silent...
                if (values.silent) {
                    log.info("Updating silently: " + model, model, values.silent);
                    model.set(values.silent, silentOptions);
                }
                // Loud...
                if (values.loud) {
                    log.info("Updating: " + model, model, values.loud);
                    model.set(values.loud, loudOptions);
                }
            }

            // Recurse to ensure we update the graph recursively, *unless* the relation has already
            // been fully updated because it was specified as an attribute to update!
            if (model.relations) {
                var relation, existing, name, value, i;

                for (i = 0; i < model.relations.length; i++) {
                    relation = model.relations[i];
                    name = relation.key;

                    // Skip relation if already fully recursively updated because it was specified
                    // as (an always loud) attribute above. An example of this is ProjectModel.inferredAssets...
                    if (values && values.relations && values.relations[name]) {
                        continue;
                    }

                    existing = model.get(name);
                    value = data[name];

                    // Only update if we have a value; we never remove relationships as we do not know if
                    // they use a default or what not. It is fine to test on "if (value) { .. }" as we
                    // know "value" is a relationship, not a primitive falsey type like Boolean or Number...
                    if (value) {
                        if (existing) {
                            // For many relationships, ensure that we update correctly, even if the contained
                            // models have been shuffled around since we issued the server sync...
                            if (relation.type === Backbone.Many) {
                                if (existing.length) {
                                    updateCollection(existing, value);
                                } else if (value.length) {
                                    model.set(name, value, loudOptions);
                                }

                                // Single model (Backbone.One or Backbone.Self), so update in-place...
                            } else {
                                update(existing, value);
                            }

                            // Create relationship then, loudly...
                        } else {
                            model.set(name, value, loudOptions);
                        }
                    }
                }
            }
        };

        // Updates the specified model recursively based on the supplied data, stopping if the model is now
        // fully updated...
        var update = function update(model, data) {
            var preferences = internalUpdate(model, data);
            if (preferences && preferences.update === "all") {
                model.set(data, loudOptions);
            }
        };

        // Go!
        update(root, json);
    };

    //

    /**
     * Editor "sync mixin" functionality for <tt>ImprovedModel</tt>.
     *
     * @class ImprovedModel
     */
    return ImprovedModel.mixin("ImprovedModelSyncMixin", {

        /**
         * @private @type {Boolean}
         * Flag set to true if <tt>destroy()</tt> has successfully be invoked on this model, i.e. destroyed and
         * all future sync requests should be ignored silently.
         */
        _destroyed: false,

        /**
         * @type {[]|*}
         *
         * Preferences on how to update *this* model on any mutable server sync operation, like "save",
         * or even "push" for Experiences. Any relation will be traversed automatically and updated
         * recursively. <p>
         *
         * For versioned types, the attributes to update can only be those set by the Backend; all other
         * changes done externally will cause an optimistic locking error and can thus be considered
         * immutable on the frontend during sync. <p>
         *
         * The format on how to update can be either: <ul>
         *
         * <li> Array of attributes to update, either like {name:String, silent:Boolean} or just by a String
         *      name meaning {name:String, silent:false}. <p>
         *
         *      For any identifiable type, the "id", optional "version", "createdAt", "createdBy", "editedAt",
         *      "editedBy" attributes will be updated, all loudly. That is, do not specify these fields,
         *      already handled (added to the total list of attributes) <b>unless</b> a given identifiable
         *      type specifies a  preference like below to update entire the model. <p>
         *
         *      If a relation is specified as a attribute, it will be fully updated recursively. Also note
         *      that any model stored in a relation will be updated based on its preferences like here! <p>
         *
         *      The outcome of specifying a computed property is undefined. <p>
         *
         *      Only attributes having a non-null and different value will cause an update of this model.
         *      All such silent and loud attribute updates, respectively, will be updated in one go, thus
         *      at most two Backbone <tt>set(.., ..)</tt> calls, one for silent attributes, one for loud ones.
         *      During <tt>set</tt>, the options passed along will specify at least
         *      {triggeredByServerUpdate: true, [silent: true,] ..}. <p>
         *
         *
         * <li> {update:String}, where "update" can take the values "all" or "no". "all" means the entire model
         *      is recursively updated based on the response json, "no" means no update is performed at all,
         *      which is not allowed for identifiable types. A full update is always loud, never silent. <p>
         *
         *
         * <li> {update:"attributes", attributes:[]}, where the array of attributes is defined as the first
         *      bullet above. The attributes has the exact same semantics as described in the first
         *      bullet above. <p>
         *
         *
         * <li> A function like <tt>fn(options)</tt> that returns either of the above, where <tt>options.sync</tt>
         *      is a String specifying the sync in progress, e.g. "save" or even "push" for Experiences. Normally
         *      only needed in case different sync requests returns quite different response data, like
         *      Experience.push that expresses business logic regarding push state, purge time, etc.
         *
         * </ul>
         *
         * Note: for now, this is not used by "delete" and "fetch", but the logic supports it already! The rationale
         * is simply that we always update all on "fetch" and nothing on "delete", though we could express this via
         * these very semantics.
         */
        updateOnSync: null,

        /**
         * @type {Array}
         *
         * Array of transient property names that will not be persisted during sync.
         */
        transient: [],

        /**
         * Mixin constructor.
         */
        constructor: function constructor() {
            // Embedded models cannot be accessed individually, so never mind about the sync state...
            if (this.embedded) {
                return;
            }
            // Initialise sync state for each model, so bulk fetched models will have a default state upon creation
            // so we do not have to check for presence of "model.syncState" everywhere...
            Syncer.State.init(this, {
                unique: ["id", TEMP_ID, UNIQUE_ID],
                // To allow sub-types to override...
                permissions: {
                    save: Permissions.Privileges.CREATE,
                    destroy: Permissions.Privileges.CREATE
                },
                alias: {
                    destroy: "delete"
                }
            });
        },


        /**
         * Returns the identifier for this model.
         *
         * @return {String} The identifier; never null.
         */
        identifier: function identifier() {
            return _identifier(this);
        },
        isNew: function isNew() {
            // Models known to be identifiable embedded entities are not persistent, not those explicitly
            // tagged as immutable!...
            return this.embedded || this.syncState.immutable || AssociatedModel.prototype.isNew.call(this);
        },


        /**
         * Overrides the standard Backbone.Model <tt>parse</tt> method to handle updates of specific properties
         * instead of the entire model recursively.
         *
         * @param {*} response  The response to for this model, including all embedded data; never null.
         * @param {*} [options] The options, if any; will contain {sync:String}, e.g. {sync:"save"} on
         *                      backend save.
         *
         * @return {*} The (recursive) json for this model; never falsey.
         */
        parse: function parse(response, options) {
            // We know we do not have to do any parsing from the super model as no parsing is done by it. And
            // since we have overridden this exact method to do our bidding, this is the parse function called
            // and we know the response is valid for our use...

            // On "sync:method" for updates, e.g. "sync:save", we only return the id as the parse logic is
            // impossible (!) to hook into while maintaining model identity without a major rewrite of
            // Backbone.Model/Collection *and* support a partial update.
            if (updateOnSync(this, options).update === "all") {
                return response;
            }

            // Note that "response" is a top-level response at this point. Since we only return the id, we will
            // *never* recurse into relations reachable from this type, and this parse function will *not* be
            // called recursively. We do this because Backbone does not handle partial updates well on individual
            // nested attributes in an existing graph; Backbones matches on id attribute alone, not our temp
            // ids required to handle our use case, and even on match, it creates new relations as well, where we
            // want to update existing ones. It also mixes in default (and computed) attributes on match as well,
            // which is incompatible with partial updates as well. Because of this, we have to traverse the
            // relations after this update in our "doSave" function to perform the required updates then, taking
            // both id and our temp ids into account to ensure moved models in collections will still be matched...
            return {
                id: response.id
            };
        },


        /**
         * Overrides the standard backbone.model <tt>toJSON</tt> method to handle transient and computed properties
         * recursively, including support for specific properties to clear on clone.
         *
         * @param {*} [options] The options; will contain {duplicate: true} on clone used to duplicate models to
         *                      be persisted as new entities, {sync:String} on backend sync to update this model,
         *                      e.g. "save", "delete", or even other types like "push" for experiences.
         *
         * @return {*} The (recursive, possibly cloned) json for this model; never falsey.
         */
        toJSON: function toJSON(options, exclude) {
            options = options || {};
            exclude = exclude || [];

            // The AssociatedModel ensures relationships are traversed, i.e. this function will be called recursively
            // for relationships where relevant. It will not, however, clone arrays and objects not mapped as
            // relationships, which is a serious problem (shallow copy)...
            var json = AssociatedModel.prototype.toJSON.call(this, options),
                clear = _.isFunction(this.clearOnClone) && this.clearOnClone(options),
                transform,
                ignore = {},
                attribute,
                value,
                transient,
                tempId,
                i;

            if (Array.isArray(clear)) {
                exclude = exclude.concat(clear);
            }

            // Exclude common specified meta fields on duplication - we do include computed ones (should we?)...
            // When duplicateExperienceWithUUID is true, include the 'uuid' field. (PE-1461 for more details)
            if (options.duplicate) {
                var metaFieldsDuplicate = options.duplicateExperienceWithUUID ? META_FIELDS_DUPLICATE_WITHOUT_UUID : META_FIELDS_DUPLICATE;
                exclude = exclude.concat(metaFieldsDuplicate);

                // Exclude computed properties on saving to backend (say, instead of cloning to some frontend template),
                // and ensure any new identifiable model has a "tempId" so we can identify it upon server
                // return in case on intermediate structural changes. However, each computed property can specify it
                // as being not transient for properties that has been resolved to a Model instance based on for
                // example a reference...
            } else if (options.sync) {
                // we only use "sync" for updates with regards to marshalling *to* json!
                exclude = exclude.concat(this.transient); // always exclude transient properties...

                if (this.computed) {
                    for (attribute in this.computed) {
                        transient = this.computed[attribute].transient;
                        if (typeof transient === "undefined" || transient) {
                            exclude.push(attribute);
                        }
                    }
                }

                // Assign a temp id to any currently non-identifiable model sent to the server as part of a
                // Backbone.Many relationship, so we can find it afterwards even if moved in the collection
                // before we get a server response. A non-identifiable model is a new instance of any identifiable
                // model type as it has no id yet, or any non-identifiable type altogether (where the backend
                // never assigns an id to it). We *only* do this when individual attributes are updated, not if the
                // entire model is updated since no bookkeeping will be needed in that case - everything will be
                // overridden in that case based on the response. We test early on "id" since we expect that to be
                // set for the most cases, ensuring we can skip additional checks faster...
                if (!this.get("id") && options.relation && options.relation.type === Backbone.Many) {
                    // We manipulate the json, not the models, as the temp id will be excluded there...
                    tempId = this[TEMP_ID];
                    // Note: on full update on models, the TEMP_ID may be stored as an attribute based on the response!
                    // It seems excessive to fix this edge case, so we ignore it for now as it should not really
                    // matter with respect to correctness...
                    json[TEMP_ID] = tempId;
                    log.verbose("Assigned temp id: '" + tempId + "' -> " + this, this);
                }

                // Attributes to transform before sync, only in the json, not the actual models. E.g. collapsing a model
                // into a reference (again)...
                if (_.isFunction(this.transformBeforeSync)) {
                    transform = this.transformBeforeSync(options);
                }
            }

            // No need to deep copy attributes to exclude or already handled as relationships (most cases)...
            for (i = 0; i < exclude.length; i++) {
                ignore[exclude[i]] = 1;
            }

            if (this.relations) {
                for (i = 0; i < this.relations.length; i++) {
                    ignore[this.relations[i].key] = 2;
                }
            }

            // Make sure we make (semi-) deep copies of references that are objects or arrays *not* mapped as
            // relationships, as those are already handled. Otherwise the copy will potential shared state, bad for
            // so many reasons...
            for (attribute in this.attributes) {
                if (!ignore[attribute]) {
                    value = this.attributes[attribute];
                    if (Array.isArray(value) || _.isObject(value)) {
                        // Still not nested, we assume no unmapped nested relationships like this! We might want to
                        // revisit this if nested mappings like this becomes used...
                        json[attribute] = _.clone(value);
                    }
                }
            }

            // Only on sync...
            if (transform) {
                for (i = 0; i < transform.length; i++) {
                    attribute = transform[i];
                    if (!ignore[attribute.name]) {
                        // Note: because of the way Backbone.Model/Relation works, we may or may not supply
                        // a model or a json structure to the transform handler! Be sure it can handle both cases
                        // if applicable (depends on how the model type in question defines it relations)...
                        json[attribute.name] = attribute.transform(json[attribute.name]);
                    }
                }
            }

            // Implementation notes: do not use _.omit as it copies the json - we already have the json we need, so
            // simply modify it instead. Also, do not use forEach to loop, this is critical functionality and should
            // be as fast as possible!
            for (i = 0; i < exclude.length; i++) {
                delete json[exclude[i]];
            }

            return json;
        },


        /**
         * Clones this improved model recursively, with support for clearing fields such as internal ids (so the
         * clone can be persisted as a new object). <p>
         *
         * The options will be supplied to the <tt>clearOnClone(options)</tt> handler defined by this model, if
         * any, which can return an array of additional fields to clear in the returned clone. <p>
         *
         * On <tt>{duplicate: true}</tt>, the fields "id", "version", "tempId", "createdAt", and "editedAt" are cleared
         * recursively for any referenced model (so they do not need to be specified in the hook). In addition,
         * the "copyOf" property is set to the internal id of *this* model (defaulting to "copy") in the duplicate,
         * so we can trace the duplication.
         *
         * @param   {*} [options] Clone options, e.g. none to get an exact clone except transient properties;
         *                        <tt>{duplicate: true}</tt> to get a clone to be persisted (getting new ids);
         *                        <tt>{sync: String}</tt> will ignore any computed properties; etc. Can
         *                        be falsey, i.e. returns an exact clone except transient properties.
         * @returns {ImprovedModel} A deep (recursively cleared) clone of this model; never null.
         */
        clone: function clone(options) {
            // Make sure same options instance passed to both toJSON and hooks...
            options = options || {};
            // Cannot call super since it calls toJSON with no options...
            var clone = this.toJSON(options, [UNIQUE_ID]);

            // On duplicate, tag clone with origin id, if any, so we can trace the origins. We always set a value, both
            // to ensure we do not pass along an origin from another copy, but also to ensure that we can always trace
            // copies...
            if (options.duplicate) {
                clone.copyOf = _identifier(this) || "copy";
            }

            return new this.constructor(clone, options); // pass along options as they will be passed to fx initialize
        },


        /**
         * Overrides standard Backbone.Model.set to ensure that a meta data describable model in its meta data
         * form is immutable; trying to change it is a programmer fatal error except from server responses!
         */
        set: function set(key, val, options) {
            // Allow mutation from server responses from sync requests. We do not raise exceptions here, since we
            // want the SyncManager to raise a validation error on dequeue time so the user will be notified. By using
            // preconditions, we will still track this scenario as well...
            var valid = !_.isString(key) || // for now, we only support a single key check... :/
            this.get(key) === val || // has value not changed?
            !this.has("immutable") || // is this type not immutable?
            !this.get("immutable") || // is this instance not currently immutable?
            // eslint-disable-next-line no-mixed-operators
            options && options.computedProperty || this.transient.indexOf(key) !== -1 || // ignore computed/transient props
            this.embedded || !Syncer.State.complete(this); // allow changes while syncing...
            Preconditions.checkState(valid, "Change to immutable model: '" + key + "' = '" + val + "' != '" + this.get(key) + "' -> " + this); // will be logged by frontend error logger!

            return AssociatedModel.prototype.set.call(this, key, val, options);
        },


        /**
         * Forces a recomputation of any computed properties that depends on the specified array of property
         * names. This might be useful following a silent update of specific model properties, since computed
         * properties are only computed during regular model changes, i.e. "non silent".
         *
         * @param  {String|String[]} dependencies A single property or array of property names.
         * @param  {Boolean}         silent       Optional, whether the update of the computed property should
         *                                        be <i>silent</i> or not.
         */
        invalidateComputedProperties: function invalidateComputedProperties(dependencies, silent) {
            var _this = this;

            if (this.computed) {
                var deps = Array.isArray(dependencies) ? dependencies : [dependencies];

                _.each(this.computed, function (config, propertyName) {
                    config.silent = silent;

                    if (config.deps) {
                        _.each(config.deps, function (dependency) {
                            if (deps.indexOf(dependency) !== -1) {
                                _this._computeProperty(propertyName, config);
                            }
                        });
                    }
                });
            }
        },


        /**
         * @private
         * Sync method callback to determine if a sync request for this model is cancelable or not for the
         * specified sync method.
         *
         * @return {Boolean} True if cancelable, false otherwise.
         * @see    #_syncOptions
         */
        _cancelable: function _cancelable() {
            return !this.has("version");
        },


        /**
         * Sync method callback to handle the supplied error for the current sync method when a sync fails. <p>
         *
         * This will tag <tt>error.model</tt> with a reference to this (failing) model and resolve the error
         * message accordingly based on the model data, e.g. distinguishedName for ${name} placeholder in the
         * error message.
         *
         * @param  {*} error The incoming http error as {message:String, status:*, ..}; never null.
         *
         * @return {String} The string "alert"; never null.
         *
         * @see    #_syncOptions
         * @see    ErrorHandler#fail
         */
        _handleError: function _handleError(error) {
            var syncState = this.syncState,
                typeName = this.__typeName || "resource",
                method = syncState.current.method;

            // Make sure we use registered alias, e.g. "share" instead of "save" when sharing...
            method = syncState.alias[method] || method;

            // Make sure we only use DUPLICATE for experiences and not on destroy (delete)...
            if (error.action && (method === "destroy" || typeName !== "Experience")) {
                error.action = error.action.replace(ErrorHandler.Actions.DUPLICATE, "");
            }

            // Tag the error with this model as the failing model, which will then be used for defaults during
            // value injection before the error is presented...
            error.model = this;

            // This will force the error to be logged and it to be tracked. Note that calling the "url()" function
            // can raise the very same error we came here for, e.g. trying to sync without an url, so we must take
            // that into account...
            var url = "";

            if (this.url) {
                if (_.isFunction(this.url)) {
                    try {
                        this.url();
                    } catch (e) {
                        // In case of urlError raised by Backbone sync...
                    }
                } else {
                    url = this.url;
                }

                if (url) {
                    url = " -> " + url;
                }
            }

            Preconditions.fail(method + " failed with status " + error.status + " for the " + typeName + ": " + this + url);

            return "alert";
        },


        /**
         * @protected
         * Augments a copy of <tt>options</tt> with a standard set of sync options for the specified sync method
         * to be executed.
         *
         * @param  {String|*} options The (public) sync method as a string, e.g. "save", or options to use, merged
         *                            with a default set of applicable options. Example:
         *                            {method: "save", silent: true, delay: 2000}. Will not be changed by this method.
         * @return {*} A new set of sync options; never falsey.
         */
        _syncOptions: function _syncOptions(options) {
            if (typeof options === "string") {
                options = { method: options };
            }

            var immutable = options.method.indexOf("fetch") === 0,
                update;

            // All callbacks invoked with target scope. Note that we make a copy of "options" here!
            options = _.extend({
                sync: options.method, // for parse/toJSON callbacks, only used for responses!
                immutable: immutable, // to avoid fetching again while still an active one pending
                privilege: this.syncState.permissions[options.method], // can be undefined!
                cancelable: function cancelable() {
                    return immutable || this._cancelable();
                },
                errorHandler: this._handleError,
                validate: function validate() {
                    if (this._destroyed) {
                        return "destroyed";

                        // Never allow a mutable request for any model currently tagged as immutable...
                    } else if (update && this.has("immutable") && this.get("immutable")) {
                        return "immutable";
                    }
                    return null;
                }
            }, options);

            update = !options.immutable && options.method !== "destroy"; // E.g. "save"...

            // If no "fn" defined, private method, e.g. "_save" will be executed...
            if (!options.fn && options.method.charAt(0) !== "_") {
                options.method = "_" + options.method;
            }

            return options;
        },


        /**
         * @private
         * Calls the sync method from <tt>AssociatedModel</tt> prototype with the supplied options.
         *
         * @param {String}  method   The sync method to execute, e.g. "save", "fetch", etc.
         * @param {*}      [varArgs] The sync arguments, if any.
         * @return {Promise|Boolean} The promise from the <tt>AssociatedModel</tt> sync method, or false
         *                           if no server sync is deemed necessary by the <tt>AssociatedModel</tt>.
         */
        _superSync: function _superSync() {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var method = args.shift();
            return AssociatedModel.prototype[method].apply(this, args);
        },


        /**
         * Overrides the standard backbone.model save method. The default save method updates the model when the server
         * response is received, which is undesired behavior for the model. This implementation (in conjunction) with
         * the override of backbone.model.parse, makes sure that the models aren't updated when saving. <p>
         *
         * We never use <tt>key</tt> and <tt>val</tt> directly, but we must preserve the signature to ensure that
         * us being called by Backbone will not change the semantics.
         */
        save: function save(key, val, options) {
            return this._doSave(key, val, options);
        },


        /**
         * Same as #save, but with a pending delay of 6s. This ensures that a "sync:save:pending" event will
         * be triggered for this model, unless already syncing.
         *
         * @param {Number} [delay] The pending delay in ms, defaulting to 6s.
         */
        saveLater: function saveLater(delay, key, val, options) {
            return this._doSave(key, val, options, delay || 6000); // 6s delay by default
        },
        _doSave: function _doSave(key, val, options, delay) {
            if (this.embedded) {
                return this._superSync("save", key, val, options);
            }
            var opts = { method: "save", delay: delay, silent: options && options.silent };
            return SyncManager.sync(this._syncOptions(opts), this, key, val, options).promise();
        },


        /**
         * @private
         * Performs the actual remote save of this model, called via the sync manager. <p>
         *
         * We never explicitly use neither "key" or "val", but Backbone will pass along "key" = null explicitly
         * in certain cases (and thus "options" as the second argument), so we must respect that and act accordingly!
         * The general case is, however, only zero (default options) or a single argument, "options".
         */
        _save: function _save(key, val, options) {
            var _this2 = this;

            var generateOptions = function generateOptions(o) {
                var saveOptions = { sync: "save" };
                return o ? _.extend(o, saveOptions) : saveOptions;
            };

            // "options" can be supplied as the second or third argument, and "key" can be a string in which case
            // "val" is never options, or "key" can be an object in which case "val" is "options"...
            if (!key || (typeof key === "undefined" ? "undefined" : _typeof(key)) === "object") {
                val = generateOptions(val);
            } else {
                options = generateOptions(options);
            }

            // The marshalling to json will assign temp ids to new identifiables about to be created, which we can
            // already call now as the super sync functionality will have performed the marshalling already...
            return SyncManager.cancelable(this, this._superSync("save", key, val, options)).done(function (json) {
                _this2._update(json, val || options); // executed *before* "sync:state:synced" fires!
            });
        },


        /**
         * Updates this model recursively based on the supplied json representation, issuing all standard
         * "sync:state" events based on <tt>options.method</tt> for this model. Since the json representation
         * to update this model with is already available, this will be executed synchronously, issuing the
         * relevant "sync:state" events in rapid synchronous order. <p>
         *
         * This is typically done when a sync of some other model causes this model to be fetched/updated as auxiliary
         * data. No server round trip is done, so the "sync:state" events will come rapidly. <p>
         *
         * There is normally no need to call this method.
         *
         * @param {*} json    The json to update this model with based on the attributes specified to be updated
         *                    via <tt>model.updateOnSync</tt> preferences. Must defined an <tt>id</tt> property that
         *                    matches the id of this model.
         * @param {*} options The options used, where <tt>options.sync</tt> specifies the update to perform. Null
         *                    will result in a full model update.
         * @return {Promise} A promise that resolves once the update is done (which will resolve "now"); never falsey.
         * @throws Error If <tt>json</tt> does not defined an <tt>id</tt> property that is equal to the id of this
         *               model.
         */
        update: function update(json, options) {
            var self = this,
                id = self.get("id");

            Preconditions.checkState(id === json.id, new Error("Id mismatch: '" + id + "' != '" + json.id + "'"));

            options = this._syncOptions({
                method: options.sync || options.method, // prefer "options.sync" as that will never be a private method...
                silent: options.silent,
                immutable: options.immutable,
                privilege: options.privilege,
                promise: options.promise,
                fn: function fn() {
                    self._update(json, options);
                } // executed *before* ("now") "sync:state:synced" fires!
            });

            return SyncManager.sync(options, self).promise();
        },


        /**
         * @private
         * Updates this model recursively after a sync of the specified type, e.g. "save". We have to do this
         * always for the entire graph to handle meta data and newly assigned ids to objects even if they
         * have moved while the request was pending. <p>
         *
         * Due to the problems listed in "parse", we have to update the *existing* model graph with required
         * data to avoid loosing the existing graph/models. <p>
         *
         * There is normally no need to call this method; the update is handled automatically after a sync, but
         * it may be needed in certain cases where json updates are returned as a side effect of another operation,
         * like a push with assets for a group. <p>
         *
         * If <tt>json</tt> is an array, e.g. auxiliary models, this model is expected to have an id already. If not,
         * the correct json model to update based on cannot be found; we only support temp ids for relations
         *
         * @param {*|[]} json The json to update this model with based on the attributes specified to be updated
         *                    via <tt>model.updateOnSync</tt> preferences. It can be a single json object, i.e.
         *                    for this model, or an array of (auxiliary) models, also returned by the api, for
         *                    example because they have been updated (like a version bump). If so, the array
         *                    is searched to find the matching id, using that array entry for update if any. The
         *                    remaining auxiliary objects will be stored under <tt>options.auxiliary</tt> if non-empty.
         *                    If the id of this model cannot be found, no update of this model is performed.
         * @param {*} options The options used, where <tt>options.sync</tt> specifies the update to perform. Null
         *                    will result in a full model update.
         */
        _update: function _update(json, options) {
            if (Array.isArray(json)) {
                var data,
                    match = false,
                    i = json.length;

                while (i--) {
                    data = json[i];
                    if (data.id === this.get("id")) {
                        // TODO: eventually support TEMP_ID, but not so simple. Not relevant now, anyways...
                        match = true;
                        break;
                    }
                }

                // Store auxiliary array if it contains other models beside this target...
                if (options && (match && json.length > 1 || json.length)) {
                    options.auxiliary = json;
                }

                // On match, tag incoming array with target index; we cannot remove the target as other "done"
                // handlers may need to use the data somehow...
                if (match) {
                    json.target = i;
                    json = data;
                } else {
                    json.target = -1;
                    json = null;
                }
            }

            updateModel(this, json, options); // handles falsey (null) json!
        },


        /**
         * Overrides the standard backbone.model destroy method. The default destroy method does not send any
         * model data (json) with the DELETE request, but this is required here to ensure we do not delete
         * non-current versions for versioned entities.
         *
         * @param {Object} [options] The options object, optional.
         * @returns {Promise} The destroy promise; never null.
         */
        destroy: function destroy(options) {
            if (this.embedded) {
                return this._superSync("destroy", options);
            }
            return SyncManager.sync(this._syncOptions({ method: "destroy", silent: options && options.silent }), this, options).promise();
        },


        /**
         * @private
         * Performs the actual remote destroy of this model, called via the sync manager.
         */
        _destroy: function _destroy(options) {
            var _this3 = this;

            // Mark this model as destroyed henceforth...
            this._destroyed = true;

            options = _.extend({}, options);

            // Marshal this model to json for the delete; these are the default settings set by Backbone.sync
            // for sync methods expecting the model to be marshalled...
            options.contentType = "application/json";
            options.data = JSON.stringify(this.toJSON({ sync: "destroy" }));

            var syncResult = this._superSync("destroy", options);

            // We won't get a Promise if the model has not been synced. See `_superSync`.
            if (Promise.isPromise(syncResult)) {
                // Call Backbone.delete and get the promise. However, if "this.isNew()" is true, false will be
                // returned, since Backbone will not call the backend at all then. This is already handled
                // by the Sync Manager, and the returned promise will just resolved to this model if so...
                return SyncManager.cancelable(this, syncResult.fail(function () {
                    _this3._destroyed = false; // or a "fetch()" can never succeed again, e.g. for reload
                }));
            }

            return syncResult;
        },


        /**
         * Overrides fetch to use the URL from the "fetchNewUrl" property when fetching a new model, if it is defined.
         *
         * <p>This is useful if you want to load a model initially from a different path than would be used to create
         * or save the model. For example, we look up the settings models as subresources of the company, but once we
         * have the model, we can store and fetch it directly using its ID.</p>
         *
         * @param {Object} [options] The options object, optional.
         * @returns {Promise} The fetch promise; never null.
         */
        fetch: function fetch(options) {
            if (this.embedded) {
                return this._superSync("fetch", options);
            }
            return SyncManager.sync(this._syncOptions({ method: "fetch", silent: options && options.silent }), this, options).promise();
        },


        /**
         * @private
         * Performs the actual remote fetch of this model, called via the sync manager.
         */
        _fetch: function _fetch(options) {
            var parsedOptions = options;

            if (this.isNew()) {
                var url = _.result(this, "fetchNewUrl");

                if (url) {
                    parsedOptions = options ? _.clone(options) : {};

                    if (!parsedOptions.url) {
                        parsedOptions.url = url;
                    }
                }
            }

            // Fetch...
            return SyncManager.cancelable(this, this._superSync("fetch", parsedOptions));
        },


        /**
         * @protected
         * Executes a http sync request for this model, updating it according if a response is returned.
         *
         * @param {String|*} options The (logical) sync method as a string, e.g. "push", or a set of
         *                           sync options to be augmented with applicable defaults for this
         *                           model; cannot be falsey. Will not be modified by this function.
         * @param {*}        request The http options, must include "url", optional "type" (default POST),
         *                           optional "data" properties. "data" will default to the JSON represention
         *                           of this model at sync time.
         *
         * @return {{promise:Promise, options:*}} An object where the <tt>promise</tt> property stores the promise used
         *                                        for execution, and <tt>options</tt> the actual used options to do
         *                                        the syncing; never falsey.
         */
        _execute: function _execute(options, request) {
            options = this._syncOptions(options);

            var self = this;

            // This is a neat short-hand for issuing a http(s) ajax request...
            options.fn = _.extend({
                type: "POST",
                dataType: "json",
                contentType: "application/json; charset=utf-8",

                // Bypass Backbone.Model "parse" logic, which is fine since we have the data to potentially
                // update the graph by...
                success: function success(json) {
                    self._update(json, options); // executed *before* "sync:state:synced" fires!
                }
            }, request);
            return { promise: SyncManager.sync(options, self).promise(), options: options };
        }
    }, {

        /** -----------------------------------
         *  Static mixin methods
         *  ---------------------------------- */

        // TODO: all fetch on cache-misses should update the global cache!
        // TODO: nether of these works for embedded types, how can we avoid exposing them statically then?

        /**
         * Find the first model with the same attributes as the query argument.
         *
         * @param   {Object} query    The query to find the (first) model for; cannot be falsey.
         * @param   {*}     [options] Options to use for the fetch, like {silent: true}; can be falsey.
         *
         * @return {Promise} A promise for the model; never falsey.
         */
        findByQuery: function findByQuery(query, options) {
            var Type = this,
                constructorOptions;

            if (options && options.constructorOptions) {
                constructorOptions = options.constructorOptions;
                delete options.constructorOptions;
            }

            // Queue handles correct result (model), so we just return the promise from the "fetch()" as-is... :)
            return new Type(query, constructorOptions).fetch(options);
        },


        /**
         * Find the model with the specified id, taking advantage of the global cache if possible.
         *
         * @param   {String} id       The model id; cannot be falsey.
         * @param   {*}     [options] Options to use if a fetch is required, like {silent: true}; can be falsey.
         *
         * @return {Promise} A promise for the model; never falsey.
         */
        findById: function findById(id, options) {
            // Query backend...
            return this.findByQuery({ id: id }, options);
        },


        /**
         * Finds a model matching the given attributes, otherwise creates a new one and saves it. <p>
         *
         * A model is considered a match if it has an id matching the id property of the attributes.
         *
         * @param   {Object} attributes The model attributes.
         * @returns {Promise} A promise for the found (and perhaps created) model; never falsey.
         */
        findOrCreate: function findOrCreate(attributes) {
            var Type = this,
                constructorOptions = attributes.constructorOptions,
                model;

            delete attributes.constructorOptions;

            // Does not exist via id, so check if we can find it via the api, otherwise create...
            return Promise.deferred(function (deferred) {
                model = new Type(attributes, constructorOptions);
                // Since queued, we might get a different instance back ("result"), which is the one updated and
                // which must be returned...
                model.fetch().then(function (result) {
                    deferred.resolve(result);
                    // No such model, so we create and return the result...
                }, function () {
                    model.save().then(function (result) {
                        deferred.resolve(result); // again, use returned model result
                    }, deferred.reject);
                });
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Queue = __webpack_require__(493);
    var Preconditions = __webpack_require__(14);
    var Promise = __webpack_require__(21);

    // Safe guard to avoid most obvious queuing deadlocks...
    var MAX_NESTED_COUNT = 5;

    // Returns the (non-private) sync method name, e.g. "_save" -> "save" and "save" -> "save"...
    function syncName(method) {
        return method.charAt(0) === "_" ? method.substring(1) : method;
    }

    /**
     * @class {TargetQueue}
     * A <i>target queue</i> describes the queue for a given target entity over time regardless of sync method. It is
     * thus always a homogeneous queue with respect to target identity, though pending sync methods may be heterogeneous
     * over time. <p>
     *
     * A target queue can be blocked for one of two reasons: <ol>
     *
     * <li> It is used by a sequential queue that is busy with earlier requests in its queue, and the target queue will
     *      only be allowed to progress once the sequential queue has completed all prior queued sync methods; and/or
     *
     * <li> A sync method request is pending, e.g. on debounced save, and will not be allowed to be dequeued until
     *      the debounced timeout has been reached. Such pending sync method requests must still be queued, as they
     *      will affect the target in question, even though pending.
     *
     * </ol>
     *
     * A target queue will by default resolve to the target instance synced. <p>
     *
     * Implementation note: a target queue delegates the actual sync logic not related to queuing to a
     * <i>syncer</tt> - one type cannot really function without the other in a correct fashion.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     *
     * @see    Syncer
     * @see    SequentialQueue
     * @see    ParallelQueue
     */
    return Queue.extend("TargetQueue", {

        /**
         * @protected @type {Syncer}
         * The syncer wrapping the target synced by this queue; never falsey.
         */
        _syncer: null,
        /**
         * @protected @type {[]}
         * All identifiers used to globally identify the target synced by this queue. <p>
         *
         * The length may be larger than one on creation, e.g. the actual identifier not available until after
         * the model in question has been created. <p>
         *
         * The array is maintained by the sync manager using this target queue!
         *
         * @see QueueManager#_registerQueue
         * @see QueueManager#_unregisterQueue
         */
        _identifiers: null,

        /**
         * @constructor
         * Constructor, which creates this target queue.
         *
         * @param {SyncManager} manager        The sync manager that created this queue; never falsey.
         * @param {Syncer}      syncer         The syncer used to perform the actual sync for the target in question;
         *                                     never falsey.
         * @param {Function}   [resultHandler] Optional result handler to transform the result before resolved. If not
         *                                     supplied, the synced target will be resolved when this queue is empty.
         */
        constructor: function constructor(manager, syncer, resultHandler) {
            this._syncer = syncer; // assign first, so it will be shown in toString representation from super constructor
            // Call super...
            this.__super(manager, resultHandler || function () {
                return syncer.target;
            });
            this._identifiers = [];
        },


        /**
         * Returns a new sync request based on the supplied sync options and (var-) arguments for the target used
         * by this syncer. <p>
         *
         * The returned request has the following format:
         * <pre>
         *   {
         *      method:   String,                       // The logical sync method, e.g. "save" (never private like "_save"),
         *      args:     [],                           // Arguments for <tt>invoke</tt>, if any.
         *      queue:    Queue,                        // The owning queue (this one).
         *      match:    Function(request) -> Boolean, // Returns true if this request matches the supplied request, false otherwise.
         *      validate: Function()-> *,               // Optional validate function, invoked with target scope, to
         *                                              // return null/undefined on success, otherwise the result will
         *                                              // be used as the error and the invocation will fail.
         *      invoke:   Function(args) -> *,          // Invokes the actual sync function on the target used by this
         *                                              // syncer with <tt>args</tt>, returning a promise or a value/raises
         *                                              // an error that will be wrapped in a promise
         *      cancelable: Function() -> Boolean       // Optional method to determine if the request is cancelable or
         *                                              // not, invoked with target scope. A sync request can always be
         *                                              // cancelled, but the actual (remote) work performed by a syncing
         *                                              // request cannot be cancelled in all cases, for example of
         *                                              // versioned updates. A cancelable sync request will thus ignore
         *                                              // a server response altogether and fail on cancel, while a non
         *                                              // cancelable request will silently update the target in the
         *                                              // background on complete, if ever, but will in the meantime be
         *                                              // tagged as failed.
         *      errorHandler: Function(error:*, values:*) -> Object, // optional error handler to be used as argument
         *                                                           // for ErrorHandler.fail.
         *      resultHandler: Function(object:*) -> Object,         // optional result handler to transform a result into a different
         *                                                           // one/type.
         *      blockedHandler: Function(queue:Queue) -> *           // optional blocked handler to return truthy while the request
         *                                                           // should (at least) be blocked, falsey otherwise.
         *   }
         * </pre>
         *
         * @param {String|*}  options The actual sync function to invoke, e.g. "save", or options like
         *                            <tt>{method:String, fn:Function, ..}</tt>; cannot be falsey.
         * @param {[]}        [args]  Args, as an array, for the actual sync function at invocation time. Will default
         *                            to empty array if falsey.
         *
         * @return {*} A new request as described; never null.
         *
         * @throws Error If no actual sync function is specified/can be deduced from the target.
         */
        request: function request(options, args) {
            // Already a request?
            if (_.isFunction(options.invoke)) {
                return options; // request
            }

            var request = _.isString(options) ? { method: options } : _.extend({}, options);

            args = args || request.args || [];
            if (!_.isArray(args)) {
                args = [args];
            }

            var validate = request.validate;
            if (_.isBoolean(validate)) {
                var valid = validate ? null : "invalid";
                validate = function validate() {
                    return valid;
                };
            } else if (!_.isFunction(validate)) {
                validate = null;
            }

            var queue = this;
            var syncer = queue._syncer;
            var target = syncer.target;
            var syncState = target.syncState;
            var cancelable = _.isFunction(request.cancelable) && request.cancelable || function () {
                return true;
            };
            var http = typeof request.http === "undefined" ? true : request.http;

            var _deferred = null; // lazily created deferred backing this request, or inherited on nested requests!
            var name = syncName(request.method); // skip private method names, e.g. "_save" -> "save"
            var fn = request.fn; // actual sync function to invoke

            // On nested sync requests, we use the public deferred for the top level already active sync request, which
            // will be resolved once the nested sync requests completes...
            if (syncer._nested) {
                // Bail out early...
                Preconditions.checkState(syncer._nested <= MAX_NESTED_COUNT, new Error("Max nested count exceeded: " + MAX_NESTED_COUNT));
                _deferred = queue.active().request.deferred(); // this.active() never null on nested!
            }

            // Lookup (private) sync method if none is specified...
            if (!_.isFunction(fn)) {
                if (fn) {
                    // === request.fn
                    fn = function fn() {
                        // Http short cut?
                        if (http) {
                            var data = request.fn.data;
                            // Add json data but only if not already present to avoid superfluous marshalling. We cannot
                            // marshall before this point, i.e. sync time, since "target" and/or "data" may have changed
                            // since enqueue time, e.g. gotten a new version because of previous completed sync requests...
                            if (request.fn.dataType === "json") {
                                if (_.isFunction(data)) {
                                    // e.g. context defined callback
                                    data = data(request);
                                } else if (!data && _.isFunction(target.toJSON)) {
                                    // e.g. models...
                                    data = target.toJSON(options);
                                }
                                // GET requests already handled via ajax, but not others like POST...
                                if (request.fn.type && request.fn.type !== "GET" && !_.isString(data)) {
                                    data = JSON.stringify(data); // stringify(undefined) is undefined
                                }
                                request.fn.data = data;
                            }
                            return syncer.cancelable($.ajax(request.fn), request);
                        }
                        return request.fn;
                    };
                } else {
                    fn = target[request.method]; // can be private!
                }
            }

            // We must have a sync function by now, or we must raise an error - this is indeed a programmer error,
            // so do not continue if so...
            Preconditions.checkState(_.isFunction(fn), new Error("No sync method: <" + request.method + ">"));

            // Look up configured sync:state aliases, like "save" -> "share" for better notifications, e.g. we
            // can write stuff like ".. the share of ..." instead of ".. the save of .." to denote a sharing business
            // logic while we are in fact saving (a share, in this case)...
            name = syncState && syncState.alias[name] || name;

            // Create and return request, remembering context specific request properties...
            return _.extend(request, {
                method: name,
                args: args,
                queue: queue,
                validate: validate,
                cancelable: cancelable,
                http: http,

                errorHandler: _.isFunction(request.errorHandler) ? request.errorHandler.bind(target) : null, // callback to ErrorHandler, so must be bound explicitly
                undoHandler: _.isFunction(request.undoHandler) ? request.undoHandler.bind(target) : null,
                resultHandler: _.isFunction(request.resultHandler) ? request.resultHandler : null,
                blockedHandler: _.isFunction(request.blockedHandler) ? request.blockedHandler : function () {
                    return false;
                },

                deferred: function deferred() {
                    if (!_deferred) {
                        _deferred = syncer._deferred(request);
                    }
                    return _deferred;
                },
                invoke: function invoke() {
                    return fn.apply(target, args);
                },
                match: function match(r) {
                    return r && name === r.method && _.isEqual(args, r.args);
                },

                toString: function toString() {
                    return queue.id + ":" + queue.size() + "[" + name + "]";
                }
            });
        },


        /**
         * @private
         * Checks this queue to see if a corresponding request is already enqueued, returning the entry in question
         * if so. The is done via <tt>request.match(..)</tt>. <p>
         *
         * We allow any immutable matching queued request to be reused as long as we do not have mutable requests
         * after it; if so, we want the changes made by said mutable request to be reflected in the current immutable
         * queued request.
         *
         * @param {*} request The request to lookup, based on method name and arguments; never null.
         * @return {{i:Number, type:String, entry:*}} The meta data for enqueued entry for <tt>request</tt> for this
         *         queue, if any; or null if not found (or not applicable).
         */
        _enqueued: function _enqueued(request) {
            var n = this._queue.length;
            var i = n--;
            var entry = void 0;

            while (i--) {
                entry = this._queue[i];
                if (request.match(entry.request)) {
                    // "tail queued" allows us to drop successive mutable queued requests with the same sync method...
                    return { i: i, type: i === n ? "tail queued" : "queued", entry: entry };
                }
                // We have already covered the special case for allowing mutable requests at the end of the queue,
                // but if here and not immutable, we cannot reuse existing queued one as we have mutable ones
                // for this very target, and we want to make sure said changes are reflect on sync. That is, a "fetch",
                // then a "save", then a "fetch" again should make sure the latter "fetch" gets relevant (server)
                // changes from the intermediate save...
                if (!entry.request.immutable) {
                    return null;
                }
            }

            // Final check for immutable requests: check if the active one matches us and use it if so...
            if (request.immutable) {
                entry = this.active();
                if (entry && request.match(entry.request)) {
                    return { i: -1, type: "active", entry: entry };
                }
            }
            return null;
        },
        _enqueue: function _enqueue(enqueue, options, args, blockingQueue) {
            // Create an actual sync request...
            var queue = this;
            var request = queue.request(options, args);
            var immutable = queue._syncer.syncState().immutable;

            // Silently drop mutable requests for an immutable target...
            if (typeof immutable !== "undefined" && immutable && !request.immutable) {
                queue._log.verbose("Dropping mutable sync request for immutable target: " + request + " -> " + queue, request, queue);
                return null;
            }

            var nested = queue._syncer._nested;

            var entry = !nested && queue._enqueued(request);

            var delay = _.isNumber(options.delay) ? options.delay : null; // for debounced queuing, e.g. only "save" after no queuing activity in "delay" ms...

            // Make sure we do not have an existing (immutable or tailed) queue entry with a matching sync method; if
            // so, we do not queue a new request, and simply return an existing promise for contexts to use (i.e. for
            // an earlier immutable queued request). If no queue, but an active immutable one, e.g. "fetch", we can drop
            // the enqueuing as well. On nested enqueuing with the *same* sync method, we cannot drop the duplicate
            // request as that will typically be doing the actual work...
            if (entry && (request.immutable || entry.type.indexOf("tail") !== -1)) {
                queue._log.verbose("Dropping sync request, equivalent already " + entry.type + ": " + request + " -> " + queue, request, entry, queue);
                // Use actual queue entry, not the meta data about it...
                entry = entry.entry;
                // If already pending, make sure we are still pending within the original specified delay...
                if (entry._pending) {
                    entry._pending();
                }
                entry._addBlocker(blockingQueue);
                // Earlier given out promise we will reuse...
                return entry.promise();
            }

            // Obtain the public deferred from the sync request from which public promises are handed out. On
            // nested enqueuing, the deferred is actually that of the top level, not active, sync request. This
            // also means we will get a promise backed by the deferred from the top level request...
            var deferred = request.deferred();
            var _promise = void 0; // initialised below, when we have an entry to tag it with!

            // The syncer will internally use its own promise during invocation, i.e. the one returned by the
            // actual sync method or a fresh one created to wrap the result/error from said method. We therefore
            // obtain a freshly created deferred here and expose promises from it, not the internal promise from
            // the syncer. When the internal promise from the syncer completes (from the sync method execution),
            // we signal the exposed promises accordingly (those from the deferred obtained here). We have to do
            // it like this to ensure entries queued by this queue can hand out a promise the context can be
            // notified by once the specific queued request completes, and to handle timeout for sync method
            // promises...
            entry = {
                request: request, // to check for duplicates and for cancellation based on sync method name
                _queue: [], // to handle blocking, public so the sequential queue can remove it self as the blocker
                _pending: null,

                _addBlocker: function _addBlocker(queue) {
                    if (queue) {
                        var i = entry._queue.indexOf(queue);
                        if (i === -1) {
                            entry._queue.push(queue);
                        }
                    }
                },
                removeBlocker: function removeBlocker(queue) {
                    // public, since sequential queue will call it!
                    var i = entry._queue.indexOf(queue);
                    if (i !== -1) {
                        entry._queue.splice(i, 1);
                    }
                },


                // can be blocked by a sequential queue or because pending or because of a user defined blockade
                blocked: function blocked() {
                    if (entry._queue.length) {
                        return entry._queue[0].id || "queue"; // blocked by at least one queue, use the name of the first one
                    } else if (entry._pending) {
                        return "pending"; // blocked during pending timeout
                    }
                    return request.blockedHandler(queue); // context specific
                },
                promise: function promise() {
                    return _promise;
                },
                sync: function sync() {
                    // Sync...
                    queue._syncer.invoke(request);

                    // On creation, for example, the target identifier can change after sync, so we must make
                    // sure we use the same queue for logically equivalent, but different, identifiers, or
                    // we will end up using different target queues for the same target instance. We have to
                    // use a "done" handler here, to ensure any context defined handlers will fire first, e.g.
                    // model updates changing the identifier, before we try to check the new identifier...
                    _promise.done(function () {
                        queue.manager._registerQueue(queue);
                    });

                    return _promise;
                },
                cancel: function cancel(silent) {
                    if (entry._pending) {
                        delete entry._pending;
                    }
                    // Cancelling the deferred for *this* entry will reject all given out promises!...
                    return queue._syncer.cancel(request, silent);
                },

                toString: function toString() {
                    return request.toString();
                }
            };

            // Register blocking (sequential) queue, if any...
            entry._addBlocker(blockingQueue);

            // Create promise that is returned by the entry just created, unless we are nested and are using an
            // earlier obtained promise...
            _promise = Promise.create(deferred, { entry: entry });

            // Create debounced function to handle pending functionality...
            if (delay) {
                entry._pending = _.debounce(function () {
                    // This callback can be called sometime in the future, perhaps even after the queue has been
                    // stopped, including if cancelled, so we have to take this into account. On cancel, we will
                    // already have deleted "pending", so when this fires, we know we have been cancelled if no
                    // such property...
                    if (!queue._stop && entry._pending) {
                        // No longer pending...
                        delete entry._pending;
                        // Continue with syncing this queue - can still be blocked, though, either by this entry
                        // or some other entry...
                        queue.sync(); // will be ignored if already syncing another entry
                    }
                }, delay);

                // Make sure we trigger "sync:pending" state for the target unless a sync is already in progress;
                // that is, we only trigger a pending event if the sync state is currently complete, or it would
                // mess with the current execution flow (handled by the syncer)...
                queue._syncer._pending(request);

                // Call it to ensure we will dequeue even if no more pending queue requests arrive...!
                entry._pending();
            }

            //
            // If we have a nested count > 0, it means that this syncer while invoked is trying to enqueue
            // another request with what ever sync method for the same target - which can cause a deadlock
            // unless we handle said scenario explicitly. This scenario is typical if for example some external
            // context uses the sync manager to operate on some targets, invoking target methods that uses the
            // sync manager as well (for the same target(s), typically on the same sync method (name)). If so,
            // the nested sync method will typically return a queue promise, since that is what it does if called
            // normally (non tested) as well, but since nested in this case, the request cannot be dequeued before
            // the outer one (where nested = 0) is complete - but it will depend on the promise returned by the
            // nested enqueuing; hence, deadlock! For nested methods that do not return queue promises, this is
            // not the case; for normal promises, yes, but they will eventually be resolved/rejected when the
            // actual sync work is done or has timed out. Also, since the top level (non nested) request has
            // already given out promises, they should resolve only when the nested sync request has completed
            // and not before. This is why we have to handle this scenario at queue time, and not after the sync
            // request has been invoked (i.e. the one that does the nested queuing).
            //
            // Confused? You won't be after the this episode of SOAP!... :)
            //

            if (nested) {
                // TODO: what happens on cancel of nested sync? We do not want to sync here if already cancelled!
                queue._log.verbose("Nested sync depth #" + nested + ": " + entry + " (active: " + queue.active() + ") -> " + queue, entry);
                queue._sync(entry); // will return false when blocked...
                return _promise; // ...so always hand out the valid promise!
            }

            // Not nested, so lets enqueue for later syncing...
            return enqueue(queue._syncer.target, function () {
                return entry;
            });
        },
        _result: function _result(results) {
            return results[0]; // synced target
        },


        /**
         * Cancels the supplied entry and all entries queued after in in this target queue. <p>
         *
         * A "sync:" + method + ":cancel" event will only be triggered if <tt>entry</tt> is the active queue entry
         * or the first queued one (i.e. a pending one). If not, cancelled queue entries will just be dropped
         * silently, though their given out promises will of course be rejected with a value of <tt>CANCELLED</tt>.
         *
         * @param  {*} entry The queue entry, from this target queue, to cancel; cannot be falsey.
         * @return {Boolean} True if <tt>entry</tt>, and possible other entries, are cancelled, false otherwise.
         *
         * @see    #cancelMethod
         * @see    #cancel
         */
        cancelEntry: function cancelEntry(entry) {
            // Are we cancelling the active or first queued entry? If so, we are cancelling the entire queue...
            var i = this._queue.indexOf(entry);
            if (entry === this._active || i === 0) {
                return this.cancel();

                // Cancel entry and all after it, in a silent manner that will not trigger a sync:state change since
                // that depends on an earlier queued entry...
            } else if (i !== -1) {
                while (this._queue.length > i) {
                    this._queue[i].cancel(true); // silent, must not notify about change target sync state
                    this._queue.splice(i, 1);
                }
                return true;
            }
            return false;
        },


        /**
         * Finds the first active or queued sync request having the specified sync method, and cancels it and all
         * following queued entries, regardless of their sync method. <p>
         *
         * Sync requests queued before the first such found entry are not affected by this. <p>
         *
         * A "sync:" + method + ":cancel" event will only be triggered if the active queue entry or the first queued
         * one (i.e. a pending one) is cancelled by this. If not, cancelled queue entries will just be dropped
         * silently, though their given out promises will of course be rejected with a value of <tt>CANCELLED</tt> (also
         * for the active or first entry if they are cancelled).
         *
         * @param {String} method The sync method to find the first active or queued entry for, which will be
         *                        cancelled along side all following queue entries, regardless of sync method; cannot
         *                        be falsey.
         * @return {Boolean} True if at least one entry was cancelled, false otherwise.
         *
         * @see    #cancelEntry
         * @see    #cancel
         */
        cancelMethod: function cancelMethod(method) {
            // Look up first entry, including the active one, with the specified sync method and cancel it and
            // all following sync requests, if any...

            // Active?
            if (this._active && this._active.request.method === method) {
                return this.cancelEntry(this._active);
            }

            // Queue?
            var i = void 0;
            var entry = void 0;

            for (i = 0; i < this._queue.length; i++) {
                entry = this._queue[i];
                if (entry.request.method === method) {
                    return this.cancelEntry(entry);
                }
            }

            // None!
            return false;
        },


        /**
         * Returns the string representation of this queue.
         *
         * @return {String} The string representation of this queue; never falsey.
         */
        toString: function toString() {
            return this.__typeName + "[id: " + this.id + "; syncer: " + this._syncer + "; size: " + this.size() + "; age: " + ((this._stop || Date.now()) - this._start) + "ms]";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Queue = __webpack_require__(493);

    /**
     * @class {SequentialQueue}
     * A <i>sequential queue</i> describes the order of sync methods, e.g. "save()", with respect to a number
     * of target entities, 1-n, where the invocation of the i'th target sync method will complete before the sync
     * target i+1'th will commence. It is thus (normally) a heterogeneous queue with respect to target identity,
     * though the sync method is normally, but not required to, homogeneous. <p>
     *
     * In addition, each target referenced by a sequential queue may already have a "target queue", i.e. because of
     * currently pending sync requests for some sync method on the target instance. For each such target, say the i'th
     * one in the sequential queue, the current sync request will only commence after the target queue associated with
     * the target instance is empty; this may thus block the i+1'th to n sync requests in the current (and future)
     * sequential queue. <p>
     *
     * Unless a result handler is supplied at construction time, the queue will resolve to each target synced, in
     * queuing order.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     *
     * @see    ParallelQueue
     * @see    TargetQueue
     */
    return Queue.extend("SequentialQueue", {
        _enqueue: function _enqueue(enqueue, options, targets, args) {
            // We have to create target queues immediately for each queued request, for all indices, so future sync
            // requests can know which targets are currently being synced/queued. Each created request thus stores a
            // reference to the target queue used to sync the target in question, and each sync request for said
            // queue will be tagged with a reference to this sequential queue. This ensures the target queue will
            // block until allowed progress by this queue (or some other sequential queue also using the same
            // target queue before/after)...
            return enqueue(targets, function (queue, target) {
                // this queue!
                var tq = queue.manager.queue(target); // must create target queue at enqueue time for possible future requests!
                var _promise = tq.enqueue(options, args, queue); // "tq" blocked by this ("queue")

                return {
                    promise: function promise() {
                        return _promise;
                    },
                    sync: function sync() {
                        // Remove the reference to to this sequential queue from the pending request so it can
                        // be allowed to continue on dequeuing...
                        _promise.entry.removeBlocker(queue);
                        // Start sync for the target queue, if not already...
                        tq.sync();
                        return _promise;
                    },

                    // cancel from our entry and forward, since followers will depend on it...
                    cancel: function cancel() {
                        return tq.cancelEntry ? tq.cancelEntry(_promise.entry) : null;
                    },
                    toString: function toString() {
                        return queue.id + ":" + queue.size() + "[" + _promise.entry + "]";
                    }
                };
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Queue = __webpack_require__(493);

    /**
     * @class {ParallelQueue}
     * A <i>parallel queue</i> describes a number of (potentially) parallel sync requests, without any specific
     * correlation between synced targets (though the same target instance can be queued numerous times, thus blocking
     * itself). Unlike a <i>sequential queue</i>, each sync request will be started immediately, and the queue promise
     * will resolve once all (parallel) requests have completed. If all enqueued target entities are distinct, all
     * requests will execute in parallel. <p>
     *
     * Unless a result handler is supplied at construction time, the queue will resolve to each target synced, in
     * queuing order.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     *
     * @see    SequentialQueue
     * @see    TargetQueue
     */
    return Queue.extend("ParallelQueue", {
        _enqueue: function _enqueue(enqueue, options, targets, args) {
            // We create and start targets queues immediately for each queued entry, for all indices, so future sync
            // requests can know which targets are currently being synced/queued. Each created entry thus stores a
            // reference to the target queue used to sync the target in question...
            return enqueue(targets, function (queue, target) {
                // this queue!
                var tq = queue.manager.queue(target); // must create target queue at enqueue time for possible future requests!
                var _promise = tq.enqueue(options, args);

                // Start each target queue now, if not already!
                tq.sync();

                return {
                    promise: function promise() {
                        return _promise;
                    },
                    sync: function sync() {
                        tq.sync(); // for re-starts, needed?
                        return _promise;
                    },
                    cancel: function cancel() {
                        return tq.cancelEntry(_promise.entry);
                    },
                    // cancel from our entry and forward, since followers will depend on it...
                    toString: function toString() {
                        return queue.id + ":" + queue.size() + "[" + _promise.entry + "]";
                    }
                };
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractWidgetModel = __webpack_require__(62);
    var generate = __webpack_require__(767);
    var Size = __webpack_require__(84);
    var MathUtil = __webpack_require__(72).default;
    var EditorEventFilters = __webpack_require__(154).default;
    var uuidAlphabet = "0123456789abcdefghijklmnopqrstuvwxyz-";

    /**
     * Mixes in Editor related AbstractWidgetModel fields. <p>
     *
     *
     * @class WidgetTypes
     */
    return AbstractWidgetModel.mixin({
        computed: {
            uuidSet: {
                deps: [],
                computeDefault: true,
                silent: true,
                value: function value() {
                    var uuid = this.get("uuid");
                    var definedUUID = uuid && uuid.length > 0 ? uuid : generate(uuidAlphabet, 21);
                    this.set("uuid", definedUUID, { cause: EditorEventFilters.SUPERFICIAL });
                    return definedUUID;
                }
            }
        },

        defaults: {
            isVisible: true
        },

        transient: ["highlighted", "overlapped"],

        /**
         * Returns the largest possible size that fits inside a 100% x 100% box, while respecting
         * the aspect ratio of percentageSize. The width and/or the height of the returned size
         * will always be 100.
         * @param {Size} percentageSize Size in percentages relative to size of the scene.
         * @return {Size} Fitted size in percentages relatavive to the size of the scene.
         */
        _getFittedSize: function _getFittedSize(percentageSize) {
            var percentageAspectRatio = percentageSize.width / percentageSize.height;
            // Shrink a 100% x 100% box to fit respecting the widget's aspect ratio.
            var fittedSize = Size.from(100, 100).shrinkToAspectRatio(percentageAspectRatio);

            return fittedSize;
        },

        /**
         * Returns self description string
         * 1) if widget has `_getSelfDescription` method defined,
         * and it returns a value, use it
         * 2) Otherwise returns Basic description
         *
         * @return {string} The self description
         */
        _getBasicDescription: function _getBasicDescription() {
            var isHasSelfDescription = typeof this._getSelfDescription === "function" && this._getSelfDescription();

            return isHasSelfDescription ? this._getSelfDescription() : "" + this.get("type").charAt(0).toUpperCase() + this.get("type").slice(1) + ": ";
        },

        /**
         * Sets the rotation angle to zero degrees.
         */
        _resetRotation: function _resetRotation() {
            this.set({
                rotation: 0
            });
        },

        /**
         * Applies the specified size to the widget. With rounding to contain correct enough accuracy.
         * @param {Size} percentageSize Size of the widget in percentages relative to the size of the experience.
         */
        _setSize: function _setSize(percentageSize, experience) {
            this.set({
                width: MathUtil.roundToContain(percentageSize.width, experience.get("width")),
                height: MathUtil.roundToContain(percentageSize.height, experience.get("height"))
            });
        },

        /**
         * Set the widget position after fit. If the widget is larger than
         * the experience it has move back to fit.
         *
         */
        _setFittedWidgetPosition: function _setFittedWidgetPosition() {
            // Initial positioning of fitted side
            if (this.get("width") === 100) {
                this.set({ left: 0 });
            }
            if (this.get("height") === 100) {
                this.set({ top: 0 });
            }

            // Out of the experience boundaries bottom check
            if (this.get("height") + this.get("top") > 100) {
                // Back widget to the boundaries of canvas
                this.set({ top: 100 - this.get("height") });
            }

            // Out of the experience boundaries right check
            if (this.get("width") + this.get("left") > 100) {
                // Back widget to the boundaries of canvas
                this.set({ left: 100 - this.get("width") });
            }
            // Out of the experience boundaries top check
            if (this.get("top") < 0) {
                // Back widget to the boundaries of canvas
                this.set({ top: 0 });
            }

            // Out of the experience boundaries left check
            if (this.get("left") < 0) {
                // Back widget to the boundaries of canvas
                this.set({ left: 0 });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Actions = __webpack_require__(1399);
    var PolymorphicCollection = __webpack_require__(300);

    /**
     * A collection of actions.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ActionCollection
     * @constructor
     */
    return PolymorphicCollection.extend("ActionCollection", {
        modelTypes: Actions
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CustomJsAction = __webpack_require__(190);
    var SalesforceCommerceQuickViewAction = __webpack_require__(354);
    var Enum = __webpack_require__(77);
    var JsAction = __webpack_require__(494);
    var LightboxAction = __webpack_require__(356);
    var LinkAction = __webpack_require__(299);
    var ProductCustomJsAction = __webpack_require__(495);
    var ProductLightboxAction = __webpack_require__(497);
    var ProductLinkAction = __webpack_require__(498);
    var SceneNavigationAction = __webpack_require__(191);

    /**
     * A enum describing all modelled action types, where each type can have numerous instances. <p>
     *
     * The returned enum will index each action type via is static defined <tt>TYPE</tt> property, e.g.
     * {.., LinkAction.TYPE: LinkAction, ..}, where the described value of the key in this example is
     * "link".
     */
    return Enum.create("Action", "TYPE", [CustomJsAction, SalesforceCommerceQuickViewAction, JsAction, LightboxAction, LinkAction, ProductCustomJsAction, ProductLightboxAction, ProductLinkAction, SceneNavigationAction]);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var Window = __webpack_require__(48);

    var _require = __webpack_require__(30),
        trim = _require.trim,
        isBlank = _require.isBlank;

    var Preconditions = __webpack_require__(14);
    var SalesforceCommerceQuickViewSiteGenesisStrategy = __webpack_require__(355);
    var SalesforceCommerceQuickViewSiteGenesisStandardStrategy = __webpack_require__(1401);
    var SalesforceCommerceQuickViewSiteGenesisCustomStrategy = __webpack_require__(1402);
    var SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy = __webpack_require__(1403);

    var quickview = new SalesforceCommerceQuickViewSiteGenesisStrategy();

    /**
     * Exposes a SalesforceCommerce Quick View Service Class.
     * @class SalesforceCommerceQuickViewService
     */
    return Class.extend({}, {
        // TODO: move logic into SalesforceCommerceAction for consistency, remove this service and strategies thereafter

        /**
         * @private
         * Checks if the standard SalesforceCommerce QuickView function (app.quickView.show) exists on client site.
         *
         * @return {Boolean} Whether the function exists or not on the global Window object.
         */
        _standardQuickViewExists: function _standardQuickViewExists() {
            var app = Window.sandbox("app");
            return typeof Window.sandbox("quickView.show", app) === "function" && Window.sandbox(["urls", "URLs"], app);
        },


        /**
         * @private
         * Checks if the custom SalesforceCommerce QuickView function (__zmags.demandware.quickview.show)
         * exists on client site.
         *
         * @return {Boolean} Whether the function exists or not on the global Window object.
         */
        _customQuickViewExists: function _customQuickViewExists() {
            return typeof Window.sandbox("__zmags.demandware.quickview.show") === "function" && Window.sandbox("Urls");
        },


        /**
         * Verifies if the SalesforceCommerce QuickView function exists on the Client Web Page
         * and decides which strategy to apply.
         *
         * @return {SalesforceCommerceQuickViewSiteGenesisStrategy} The used strategy; never falsey.
         */
        demandwareQuickViewStrategy: function demandwareQuickViewStrategy() {
            if (this._standardQuickViewExists()) {
                quickview.setStrategy(new SalesforceCommerceQuickViewSiteGenesisStandardStrategy());
            } else if (this._customQuickViewExists()) {
                quickview.setStrategy(new SalesforceCommerceQuickViewSiteGenesisCustomStrategy());
            } else {
                quickview.setStrategy(new SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy());
            }

            return quickview;
        },


        /**
         * Opens the SalesforceCommerce QuickView function depending on the chosen strategy.
         *
         * @param {String} productID The SalesforceCommerce product/item identifier. If falsey (blank), this method
         *                           does nothing. Leading and trailing white space will be trimmed.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         *
         * @return {jQuery} A *client site jQuery* element for the root of the SalesforceCommerce QuickView, if available;
         *                  can be falsey. The jQuery version is probably quite old!
         */
        openSalesforceCommerceQuickView: function openSalesforceCommerceQuickView(productID, experienceName, currentScene) {
            Preconditions.checkArguments(experienceName, currentScene);

            // Trim product id to help customers having pasted in for example a leading space via the editor...
            productID = trim(productID || "");

            if (Preconditions.checkState(!isBlank(productID), "Missing SalesforceCommerce Product id")) {
                return this.demandwareQuickViewStrategy().open(productID, experienceName, currentScene);
            }
            // undefined -> falsey
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Window = __webpack_require__(48);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var SalesforceCommerceQuickViewSiteGenesisStrategy = __webpack_require__(355);

    var log = new Logger("SalesforceCommerceQuickViewSiteGenesisStandardStrategy");

    /**
     * Exposes a SalesforceCommerce QuickView Site Genesis Standard Strategy Class.
     * Available on Site Genesis version < 15.1 and on Site Genesis version >= 15.1 running in
     * compatibility mode with version < 15.1. No Zmags Creator cartridge needs to be installed on client side.
     *
     * @class SalesforceCommerceQuickViewSiteGenesisStandardStrategy
     */
    return SalesforceCommerceQuickViewSiteGenesisStrategy.extend({

        /**
         * Opens standard SalesforceCommerce QuickView function.
         * @param {String} productID - The product Id.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         */
        open: function open(productID, experienceName, currentScene) {
            var win = Window.topWindow();
            var url = Window.sandbox(["app.urls.getProductUrl", "app.URLs.getProductUrl"], win);
            var productURL = url + this.formatParameters(productID, experienceName, currentScene);

            Window.run({ code: "app.quickView.show({source:\"quickview\", url:\"" + productURL + "\"})", win: win });

            log.info("Standard SalesforceCommerce QuickView launched for product: " + productID + " on page: " + win.location.href);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Window = __webpack_require__(48);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var SalesforceCommerceQuickViewSiteGenesisStrategy = __webpack_require__(355);

    var log = new Logger("SalesforceCommerceQuickViewSiteGenesisCustomStrategy");

    /**
     * Exposes a SalesforceCommerce QuickView SiteGenesis Custom Strategy Class.
     * Available from Site Genesis version >= 15.1 and a Zmags Creator cartridge
     * needs to be installed on client side.
     *
     * @class SalesforceCommerceQuickViewSiteGenesisCustomStrategy
     */
    return SalesforceCommerceQuickViewSiteGenesisStrategy.extend({

        /**
         * Opens custom Zmags SalesforceCommerce QuickView function
         * @param {String} productID - The product Id.
         * @param {String} experienceName The experience name.
         * @param {Number} currentScene The current scene number.
         * @param {Function} [onClose] Function to be called on quickview close, if possible.
         * @return {Boolean} True if <tt>onClose</tt> was specified and successfully hooked into the QuickView close
         *                   cycle, false otherwise.
         */
        open: function open(productID, experienceName, currentScene) {
            var win = Window.topWindow();
            var url = Window.sandbox("Urls.getProductUrl", win);
            var productURL = url + this.formatParameters(productID, experienceName, currentScene);

            Window.run({ code: "__zmags.demandware.quickview.show({source:\"quickview\", url:\"" + productURL + "\"})", win: win });

            log.info("Custom SalesforceCommerce QuickView launched for product: " + productID + " for the Experience " + experienceName + " on page: " + win.location.href);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var SalesforceCommerceQuickViewSiteGenesisStrategy = __webpack_require__(355);
    var Action = __webpack_require__(100);

    var _require2 = __webpack_require__(30),
        trim = _require2.trim;

    var log = new Logger("SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy");

    /**
     * Exposes a SalesforceCommerce QuickView SiteGenesis No function Strategy Class,
     * which handles the scenario of when the quickview function does not exists
     * on client side.
     *
     * @class SalesforceCommerceQuickViewSiteGenesisNoFunctionStrategy
     */
    return SalesforceCommerceQuickViewSiteGenesisStrategy.extend({

        /**
         * Handles scenario when the QuickView does ont exists on client site,
         * so we just log the warning.
         */
        open: function open(id) {
            // Trim for consistency with actual strategy used to call SalesforceCommerceQuickviewService.open... which trims
            // the product id as well...
            var msg = "SalesforceCommerce Product Id: " + trim(id);
            log.info(msg);

            if (Action.NOT_EMBEDDED_MESSAGE) {
                // only in editor
                alert(msg + "\n\n" + Action.NOT_EMBEDDED_MESSAGE);
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Lightbox = __webpack_require__(101);
    var Icons = __webpack_require__(357);

    /**
     * Lightbox class used in the viewer only.
     */
    return Lightbox.extend({

        /**
         * We want the lightbox to be vertically centered at all times (in viewer context).
         *
         * @type {String}
         * @see  Lightbox#defaultPosition
         */
        defaultPosition: "fixed",

        /**
         * Close button shown on top of the top-right corner of the lightbox.
         * @returns {*|String}
         */
        createCloseButton: function createCloseButton() {
            return Icons.CLOSE.createElement().css({
                position: "absolute",
                top: -14,
                right: -14,
                width: 28,
                height: 28,
                cursor: "pointer",
                zIndex: 1000
            });
        },


        /**
         * Creates the root element for the lightbox. It ensures has a white background
         * TODO Kept to not break functionality, but needs to be checked!
         * @returns {*|String|jQuery}
         */
        createRootElement: function createRootElement(lightboxClassName) {
            var $zmagsLightbox = $("<div class='zmags-lightbox-viewer'></div>").css({
                backgroundColor: "#FFF"
            });

            if (lightboxClassName) {
                $zmagsLightbox.addClass(lightboxClassName);
            }

            return $zmagsLightbox;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);

    /**
     * This class is used to formalize a Mix Panel event naming convention.
     * When adding new events, the below structure must be followed, either re-using or defining new actions and targets.
     *
     * When modifying the below, update relative documentation on Confluence: https://confluence.zmags.com/display/MOS/Mix+Panel+Events.
     */

    var SEPARATOR = ":";

    /**
     * Object describing the action for the tracking event.
     */
    var Actions = {
        ACCESS: "access",
        ADD: "add",
        ATTACH: "attach",
        COPY: "copy",
        CLOSE: "close",
        CREATE: "create",
        DELETE: "delete",
        DETACH: "detach",
        DUPLICATE: "duplicate",
        EDIT: "edit",
        ERROR: "error",
        EXPORT: "export",
        GET: "get",
        GROUP: "group",
        INVITE: "invite",
        LIST: "list",
        MOVE: "move",
        OPEN: "open",
        PASTE: "paste",
        PUBLISH: "publish",
        PUSH: "push",
        REDO: "redo",
        REMOVE: "remove",
        SAVE: "save",
        SELECT: "select",
        SHARE: "share",
        SORT: "sort",
        SWITCH: "switch",
        TEST: "test",
        TOGGLE: "toggle",
        UNDO: "undo",
        UNGROUP: "ungroup",
        UPDATE: "update",
        UPLOAD: "upload",
        ZOOM: "zoom"
    };

    /**
     * Object describing the targets for the tracking event. Can be models or ui components.
     */
    var Targets = {
        Model: {
            ACTIVITY: "activity",
            BACKDROP: "backdrop",
            BREAKPOINT: "breakpoint",
            NATIVE_CODE: "native-code",
            CHANNEL: "channel",
            COMMENT: "comment",
            COMMENT_THREAD: "comment-thread",
            EXPORT: "export",
            FONT: "font",
            EXPERIENCE: "experience",
            GROUP: "group",
            GUIDELINE: "guideline",
            IMAGE: "image",
            IMAGE_TAG: "image-tag",
            INTEGRATION: "integration",
            PROJECT: "project",
            SCENE: "scene",
            SNAPPING: "snapping",
            SNIPPET: "snippet",
            TEMPLATE: "template",
            USER: "user",
            VARIANT: "variant",
            WIDGET: "widget"
        },
        Ui: {
            COLOR: "color",
            DASHBOARD: "dashboard",
            DIRECT_URL: "direct-url",
            DRAG_AND_DROP_PUBLISHING: "drag-and-drop-publish",
            EXPERIENCE_EDITOR: "experience-editor",
            EXPERIENCE_PREVIEW: "experience-preview",
            HELP_LINK: "help-link",
            PROJECT_SELECTOR: "project-selector",
            MASTER_LAYERS: "master-layers",
            MODAL_WINDOW: "modal-window",
            REGISTRATION_PAGE: "registration-page",
            RULERS_AND_GUIDELINES: "rulers-and-guidelines",
            SHARE_MENU: "share-menu",
            SHARE_EMAIL_RECIPIENT: "share-email-recipient",
            SOURCE_SELECTOR: "image-source-selector",
            TEMPLATE_PREVIEW: "template-preview",
            TOUR_GUIDE: "tour-guide"
        }
    };

    var EventNames = {
        ACCESS_USER: _buildEventName(Actions.ACCESS, Targets.Model.USER),
        ADD_BREAKPOINT: _buildEventName(Actions.ADD, Targets.Model.BREAKPOINT),
        ADD_CHANNEL: _buildEventName(Actions.ADD, Targets.Model.CHANNEL),
        ADD_GUIDELINE: _buildEventName(Actions.ADD, Targets.Model.GUIDELINE),
        ADD_IMAGE_TAG: _buildEventName(Actions.ADD, Targets.Model.IMAGE_TAG),
        ADD_SHARE_EMAIL_RECIPIENT: _buildEventName(Actions.ADD, Targets.Ui.SHARE_EMAIL_RECIPIENT),
        ADD_WIDGET: _buildEventName(Actions.ADD, Targets.Model.WIDGET),
        ATTACH_CHANNEL: _buildEventName(Actions.ATTACH, Targets.Model.CHANNEL),
        ATTACH_EXPERIENCE: _buildEventName(Actions.ATTACH, Targets.Model.EXPERIENCE),
        ATTACH_GROUP: _buildEventName(Actions.ATTACH, Targets.Model.GROUP),
        ATTACH_IMAGE: _buildEventName(Actions.ATTACH, Targets.Model.IMAGE),
        CLOSE_MODAL_WINDOW: _buildEventName(Actions.CLOSE, Targets.Ui.MODAL_WINDOW),
        COPY_CODE: _buildEventName(Actions.COPY, Targets.Model.NATIVE_CODE),
        COPY_SNIPPET: _buildEventName(Actions.COPY, Targets.Model.SNIPPET),
        COPY_TEMPLATE: _buildEventName(Actions.COPY, Targets.Model.TEMPLATE),
        COPY_WIDGET: _buildEventName(Actions.COPY, Targets.Model.WIDGET),
        CREATE_COMMENT: _buildEventName(Actions.CREATE, Targets.Model.COMMENT),
        CREATE_COMMENT_THREAD: _buildEventName(Actions.CREATE, Targets.Model.COMMENT_THREAD),
        CREATE_EXPERIENCE: _buildEventName(Actions.CREATE, Targets.Model.EXPERIENCE),
        CREATE_GROUP: _buildEventName(Actions.CREATE, Targets.Model.GROUP),
        CREATE_PROJECT: _buildEventName(Actions.CREATE, Targets.Model.PROJECT),
        CREATE_SCENE: _buildEventName(Actions.CREATE, Targets.Model.SCENE),
        CREATE_USER: _buildEventName(Actions.CREATE, Targets.Model.USER),
        CREATE_VARIANT: _buildEventName(Actions.CREATE, Targets.Model.VARIANT),
        DELETE_BREAKPOINT: _buildEventName(Actions.DELETE, Targets.Model.BREAKPOINT),
        DELETE_CHANNEL: _buildEventName(Actions.DELETE, Targets.Model.CHANNEL),
        DELETE_COMMENT_THREAD: _buildEventName(Actions.DELETE, Targets.Model.COMMENT_THREAD),
        DELETE_EXPERIENCE: _buildEventName(Actions.DELETE, Targets.Model.EXPERIENCE),
        DELETE_FONT: _buildEventName(Actions.DELETE, Targets.Model.FONT),
        DELETE_GUIDELINE: _buildEventName(Actions.DELETE, Targets.Model.GUIDELINE),
        DELETE_INTEGRATION: _buildEventName(Actions.DELETE, Targets.Model.INTEGRATION),
        DELETE_PROJECT: _buildEventName(Actions.DELETE, Targets.Model.PROJECT),
        DELETE_SCENE: _buildEventName(Actions.DELETE, Targets.Model.SCENE),
        DELETE_VARIANT: _buildEventName(Actions.DELETE, Targets.Model.VARIANT),
        DELETE_WIDGET: _buildEventName(Actions.DELETE, Targets.Model.WIDGET),
        DELETE_USER: _buildEventName(Actions.DELETE, Targets.Model.USER),
        DETACH_CHANNEL: _buildEventName(Actions.DETACH, Targets.Model.CHANNEL),
        DETACH_EXPERIENCE: _buildEventName(Actions.DETACH, Targets.Model.EXPERIENCE),
        DETACH_GROUP: _buildEventName(Actions.DETACH, Targets.Model.GROUP),
        DETACH_IMAGE: _buildEventName(Actions.DETACH, Targets.Model.IMAGE),
        DUPLICATE_EXPERIENCE: _buildEventName(Actions.DUPLICATE, Targets.Model.EXPERIENCE),
        DUPLICATE_GROUP: _buildEventName(Actions.DUPLICATE, Targets.Model.GROUP),
        DUPLICATE_SCENE: _buildEventName(Actions.DUPLICATE, Targets.Model.SCENE),
        EDIT_IMAGE_TAG: _buildEventName(Actions.EDIT, Targets.Model.IMAGE_TAG),
        ERROR: Actions.ERROR,
        EXPORT_EXPORT: _buildEventName(Actions.EXPORT, Targets.Model.EXPORT),
        GET_CODE: _buildEventName(Actions.GET, Targets.Model.NATIVE_CODE),
        GROUP_WIDGETS: _buildEventName(Actions.GROUP, Targets.Model.WIDGET),
        INVITE_USER: _buildEventName(Actions.INVITE, Targets.Model.USER),
        LIST_TEMPLATES: _buildEventName(Actions.LIST, Targets.Model.TEMPLATE),
        MOVE_SCENE: _buildEventName(Actions.MOVE, Targets.Model.SCENE),
        OPEN_DASHBOARD: _buildEventName(Actions.OPEN, Targets.Ui.DASHBOARD),
        OPEN_DIRECT_URL: _buildEventName(Actions.OPEN, Targets.Ui.DIRECT_URL),
        OPEN_DRAG_AND_DROP_PUBLISH: _buildEventName(Actions.OPEN, Targets.Ui.DRAG_AND_DROP_PUBLISHING),
        OPEN_EXPERIENCE_EDITOR: _buildEventName(Actions.OPEN, Targets.Ui.EXPERIENCE_EDITOR),
        OPEN_EXPERIENCE_PREVIEW: _buildEventName(Actions.OPEN, Targets.Ui.EXPERIENCE_PREVIEW),
        OPEN_TEMPLATE_PREVIEW: _buildEventName(Actions.OPEN, Targets.Ui.TEMPLATE_PREVIEW),
        OPEN_HELP_LINK: _buildEventName(Actions.OPEN, Targets.Ui.HELP_LINK),
        OPEN_MASTER_LAYERS: _buildEventName(Actions.OPEN, Targets.Ui.MASTER_LAYERS),
        OPEN_MODAL_WINDOW: _buildEventName(Actions.OPEN, Targets.Ui.MODAL_WINDOW),
        OPEN_PROJECT_SELECTOR: _buildEventName(Actions.OPEN, Targets.Ui.PROJECT_SELECTOR),
        OPEN_REGISTRATION_PAGE: _buildEventName(Actions.OPEN, Targets.Ui.REGISTRATION_PAGE),
        OPEN_SHARE_MENU: _buildEventName(Actions.OPEN, Targets.Ui.SHARE_MENU),
        PASTE_WIDGET: _buildEventName(Actions.PASTE, Targets.Model.WIDGET),
        PUBLISH_CHANNEL: _buildEventName(Actions.PUBLISH, Targets.Model.CHANNEL),
        PUSH_EXPERIENCE: _buildEventName(Actions.PUSH, Targets.Model.EXPERIENCE),
        PUSH_GROUP: _buildEventName(Actions.PUSH, Targets.Model.GROUP),
        REDO_ACTIVITY: _buildEventName(Actions.REDO, Targets.Model.ACTIVITY),
        REMOVE_IMAGE_TAG: _buildEventName(Actions.REMOVE, Targets.Model.IMAGE_TAG),
        SAVE_BACKDROP: _buildEventName(Actions.SAVE, Targets.Model.BACKDROP),
        SAVE_BREAKPOINT: _buildEventName(Actions.SAVE, Targets.Model.BREAKPOINT),
        SAVE_INTEGRATION: _buildEventName(Actions.SAVE, Targets.Model.INTEGRATION),
        SAVE_TEMPLATE: _buildEventName(Actions.SAVE, Targets.Model.TEMPLATE),
        SELECT_COLOR: _buildEventName(Actions.SELECT, Targets.Ui.COLOR),
        SELECT_IMAGE: _buildEventName(Actions.SELECT, Targets.Model.IMAGE),
        SELECT_SOURCE: _buildEventName(Actions.SELECT, Targets.Ui.SOURCE_SELECTOR),
        SHARE_EXPERIENCE: _buildEventName(Actions.SHARE, Targets.Model.EXPERIENCE),
        SORT_DASHBOARD: _buildEventName(Actions.SORT, Targets.Ui.DASHBOARD),
        SORT_TEMPLATE: _buildEventName(Actions.SORT, Targets.Model.TEMPLATE),
        SWITCH_VARIANT: _buildEventName(Actions.SWITCH, Targets.Model.VARIANT),
        TEST: Actions.TEST, // Used for frontend unit testing.
        TOGGLE_RULERS_AND_GUIDELINES: _buildEventName(Actions.TOGGLE, Targets.Ui.RULERS_AND_GUIDELINES),
        TOGGLE_SNAPPING: _buildEventName(Actions.TOGGLE, Targets.Model.SNAPPING),
        UNDO_ACTIVITY: _buildEventName(Actions.UNDO, Targets.Model.ACTIVITY),
        UNGROUP_WIDGETS: _buildEventName(Actions.UNGROUP, Targets.Model.WIDGET),
        UPDATE_BACKDROP: _buildEventName(Actions.UPDATE, Targets.Model.BACKDROP),
        UPDATE_BREAKPOINT: _buildEventName(Actions.UPDATE, Targets.Model.BREAKPOINT),
        UPDATE_CHANNEL: _buildEventName(Actions.UPDATE, Targets.Model.CHANNEL),
        UPDATE_EXPERIENCE: _buildEventName(Actions.UPDATE, Targets.Model.EXPERIENCE),
        UPDATE_GROUP: _buildEventName(Actions.UPDATE, Targets.Model.GROUP),
        UPDATE_IMAGE: _buildEventName(Actions.UPDATE, Targets.Model.IMAGE),
        UPDATE_PROJECT: _buildEventName(Actions.UPDATE, Targets.Model.PROJECT),
        UPDATE_USER: _buildEventName(Actions.UPDATE, Targets.Model.USER),
        UPDATE_VARIANT: _buildEventName(Actions.UPDATE, Targets.Model.VARIANT),
        UPDATE_WIDGET: _buildEventName(Actions.UPDATE, Targets.Model.WIDGET),
        UPLOAD_FONT: _buildEventName(Actions.UPLOAD, Targets.Model.FONT),
        UPLOAD_IMAGE: _buildEventName(Actions.UPLOAD, Targets.Model.IMAGE),
        ZOOM_SCENE: _buildEventName(Actions.ZOOM, Targets.Model.SCENE),
        ZOOM_PREVIEW: _buildEventName(Actions.ZOOM, Targets.Ui.EXPERIENCE_PREVIEW)
    };

    /**
     * Builds the event name to be sent to Mix Panel via Segment.
     * @param {String} action An action name as defined in the Actions object.
     * @param {String} target A target name as defined in the Targets object;
     * @returns {String} The colon-separated event name.
     * @private
     */
    function _buildEventName(action, target) {
        return action + SEPARATOR + target;
    }

    /**
     * Utility method to verify that the supplied event name exists in the EventNames list.
     * @param {String} eventName The name of the event.
     * @return {Boolean} True if event name exists in the EventNames object, false otherwise.
     */
    function checkEvent(eventName) {
        var values = _.values(EventNames);
        return _.contains(values, eventName);
    }

    return {
        EventNames: EventNames,
        checkEvent: checkEvent
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var AssociatedModel = __webpack_require__(352);

    /**
     * SVG content.
     *
     * Storing it as strings in the code has several advantages over external references:
     * - It works when injected into another window where a relative link would fail.
     * - It can be restyled directly, unlike with object or embed tags.
     * - It does not need one request per image to load.
     *
     * @author Bo Gotthardt
     * @class SVGContent
     * @constructor
     */
    return AssociatedModel.extend("SVG", {
        defaults: {
            content: "",
            className: "",
            // SVGs can of course be rescaled freely, but when actually exported as a file they have a particular
            // viewbox size that the element coordinates are relative to. Record this here so that the viewbox can be recreated.
            height: 100,
            width: 100
        },

        /**
         * Create an element for the SVG content.
         *
         * @returns {jQuery} The content as an SVG element wrapped in a div, as a jQuery object.
         */
        createElement: function createElement() {
            // preserveAspectRatio=none to ensure that the SVG can be rescaled freely, even if the square viewbox ends up in a non-square element.
            // Wrap in div and insert content directly as string since jQuery has problems handling SVG elements.
            var elem = $("<div><svg xmlns='http://www.w3.org/2000/svg' version='1.1' viewBox='0 0 " + this.get("width") + " " + this.get("height") + "' preserveAspectRatio='none'>" + this.get("content") + "</svg></div>");
            if (this.get("className")) {
                elem.addClass(this.get("className"));
            }
            return elem;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var AnimationModel = __webpack_require__(172);

    /**
     * A collection of animations.
     *
     * @class AnimationCollection
     * @constructor
     */
    return Backbone.Collection.extend({
        model: AnimationModel
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var PolymorphicCollection = __webpack_require__(300);
    var EffectModel = __webpack_require__(78);
    var EffectModels = __webpack_require__(1409);

    /**
     * A collection of <tt>EffectModel</tt>'s.
     *
     * @class EffectModelCollection
     */
    return PolymorphicCollection.extend("EffectModelCollection", {
        modelTypes: EffectModels,
        defaultModelType: EffectModel,

        hasTriggerType: function hasTriggerType(triggerType) {
            return this.find(function (effect) {
                return effect.get("triggerType") === triggerType;
            }) !== undefined;
        },
        removeByTriggerType: function removeByTriggerType(triggerType, options) {
            var models = this.where({ triggerType: triggerType });
            if (models.length) {
                this.remove(models, options);
            }
        },
        firstByTriggerType: function firstByTriggerType(triggerType) {
            return this.find(function (effect) {
                return effect.get("triggerType") === triggerType;
            });
        },
        classFromType: function classFromType(type) {
            return EffectModels.lookup(type);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Enum = __webpack_require__(77);
    var OpacityEffectModel = __webpack_require__(245);
    var ScaleEffectModel = __webpack_require__(499);
    var RotateEffectModel = __webpack_require__(359);
    var PulseEffectModel = __webpack_require__(500);
    var ImageToggleEffectModel = __webpack_require__(301);

    /**
     * A enum describing all effect model types, where each type can have numerous instances. <p>
     *
     * The returned enum will index each effect model via is static defined <tt>TYPE</tt> property, e.g.
     * {.., ScaleEffectModel.TYPE: ScaleEffectModel, ..}, where the described value of the key in this
     * example is "scale".
     */
    return Enum.create("EffectModel", "TYPE", [OpacityEffectModel, ScaleEffectModel, RotateEffectModel, PulseEffectModel, ImageToggleEffectModel]);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

var crypto = self.crypto || self.msCrypto

module.exports = function (bytes) {
  return crypto.getRandomValues(new Uint8Array(bytes))
}


/***/ }),
/* 1411 */
/***/ (function(module, exports) {

// This file replaces `format.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.

module.exports = function (random, alphabet, size) {
  // We can’t use bytes bigger than the alphabet. To make bytes values closer
  // to the alphabet, we apply bitmask on them. We look for the closest
  // `2 ** x - 1` number, which will be bigger than alphabet size. If we have
  // 30 symbols in the alphabet, we will take 31 (00011111).
  // We do not use faster Math.clz32, because it is not available in browsers.
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1
  // Bitmask is not a perfect solution (in our example it will pass 31 bytes,
  // which is bigger than the alphabet). As a result, we will need more bytes,
  // than ID size, because we will refuse bytes bigger than the alphabet.

  // Every hardware random generator call is costly,
  // because we need to wait for entropy collection. This is why often it will
  // be faster to ask for few extra bytes in advance, to avoid additional calls.

  // Here we calculate how many random bytes should we call in advance.
  // It depends on ID length, mask / alphabet size and magic number 1.6
  // (which was selected according benchmarks).

  // -~f => Math.ceil(f) if n is float number
  // -~i => i + 1 if n is integer number
  var step = -~(1.6 * mask * size / alphabet.length)
  var id = ''

  while (true) {
    var bytes = random(step)
    // Compact alternative for `for (var i = 0; i < step; i++)`
    var i = step
    while (i--) {
      // If random byte is bigger than alphabet even after bitmask,
      // we refuse it by `|| ''`.
      id += alphabet[bytes[i] & mask] || ''
      // More compact than `id.length + 1 === size`
      if (id.length === +size) return id
    }
  }
}


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var CompositeWidgetModel = __webpack_require__(173);
    var EditorActivities = __webpack_require__(361);
    var EditorActivityManager = __webpack_require__(197);
    var EditorConstants = __webpack_require__(522);
    var GuidelineCollection = __webpack_require__(1472);
    var Scene = __webpack_require__(253);
    /**
     * @class {Scene}
     * Scene Model Editor Mixin.
     *
     * @author Gorm Casper
     * @author Bo Gotthardt
     */
    return Scene.mixin("SceneEditorMixin", {

        embedded: true, // since it has an id and we do not want to call the server on sync!

        defaults: {
            lastCommentedAt: null,
            unread: null,
            guidelines: [],
            widgetTabOrderMetaData: [],
            widgetTabOrder: [],

            // Not sure if I want to maintain two different lists here, may just be easier to have a single list.
            removedWidgetTabOrderMetaData: [],
            removedWidgetTabOrder: []
        },

        computed: {
            // Transient property used for unread comment handling
            unread: {}
        },

        relations: (Scene.prototype.relations || []).concat([{
            type: Backbone.Many,
            key: "guidelines",
            collectionType: GuidelineCollection
        }]),

        transient: ["scale"],

        // Clear these fields on Model.clone({duplicate: true}) (also)...
        clearOnClone: function clearOnClone(options) {
            if (options.duplicate) {
                // will already ignore transient properties, i.e. experience
                return ["lastCommentedAt", "unread", "widgetTabOrder", "widgetTabOrderMetaData", "removedWidgetTabOrder", "removedWidgetTabOrderMetaData"];
            }
        },


        // Update these fields for any scene always after a mutable server sync request...
        updateOnSync: ["lastCommentedAt"], // id always updated!

        /**
         * Adds a new widget (model) to the scene.
         *
         * @param {AbstractWidgetModel} widget The widget model to add.
         * @param {Object} options Optional options object.
         */
        addWidget: function addWidget(widget, options) {
            var widgets = this.get("widgets");

            if (options && options.setLayerIndex) {
                widget.set("layerIndex", widgets.length);
            }

            widgets.push(widget, options);

            return widget;
        },


        /**
         * Gets the highest index from the widgets array.
         *
         * @param {Array} widgets The widgets array.
         */
        getHighestIndex: function getHighestIndex() {
            var widgets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.get("widgets").models;

            var highest = 0;

            _.each(widgets, function (w) {
                highest = w.get("layerIndex") > highest ? w.get("layerIndex") : highest;
            });

            return highest;
        },


        /**
         * Gets the lowest index from the widgets array.
         *
         * @param {Array} widgets The widgets array.
         */
        getLowestIndex: function getLowestIndex() {
            var widgets = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.get("widgets").models;

            var lowest = this.getHighestIndex(widgets);

            _.each(widgets, function (w) {
                lowest = w.get("layerIndex") < lowest ? w.get("layerIndex") : lowest;
            });

            return lowest;
        },
        addWidgets: function addWidgets(widgets, options) {
            _.each(widgets, function (widget) {
                this.addWidget(widget, options);
            }, this);

            if (!options.selectWidget) {
                this.trigger("addWidgets", widgets);
            }
        },


        /**
         * Deletes a widget from the experience.
         *
         * @param {widget}  The widget to delete.
         * @param {options}
         */
        deleteWidget: function deleteWidget(widget, options) {
            var widgets = this.get("widgets");
            widgets.remove(widget, options);
            widget.destroy();
            this.reindexLayers(widgets.models, 0, options);
        },

        deleteWidgetByID: function deleteWidgetByID(uuid, options) {
            var widget = this.getWidgetByID(uuid);

            if (widget) {
                var widgetsInScene = this.get("widgets");
                widgetsInScene.remove(widget, options);
                widget.destroy();
                this.reindexLayers(widgetsInScene.models, 0, options);
            }
        },
        getWidgetByID: function getWidgetByID(uuid) {
            var widgets = this.get("widgets");

            var output = void 0;

            widgets.models.forEach(function (widget) {
                if (widget.get("uuid") === uuid) {
                    output = widget;
                    return widget;
                }
            });

            return output;
        },


        deleteWidgets: function deleteWidgets(widgets, options) {
            _.each(widgets, function (widget) {
                this.deleteWidget(widget, options);
            }, this);
        },

        /**
         * reset all the layerIndex to its index of the collection
         */
        reindexLayers: function reindexLayers(widgets) {
            var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { render: true };

            widgets.forEach(function (widget, idx) {
                widget.set("layerIndex", idx + offset, options);
            });
        },


        /**
         * TODO: Remove this method. It already exists in Scene.js
        */
        widgetsByClass: function widgetsByClass(widgetClass) {
            var widgets = this.get("widgets");

            if (widgets) {
                return widgets.filter(function (widget) {
                    return widget instanceof widgetClass;
                });
            }

            return [];
        },


        /**
         * Send a widget to a specific layer
         *
         * Note: layering is completely relying on the order of widgets array,
         * each widget will render itself on the correct layer based on the layer index we give them
         * see {@link AbstractWidgetView#onRender}.
         *
         * access to the raw collection models, so we can bypass the Backbone events which we don't want
         *
         * @param widgetModel The widget to move
         * @param to The specific layer
         */
        orderWidget: function orderWidget(_ref) {
            var widgetModel = _ref.widgetModel,
                to = _ref.to,
                _ref$siblingWidgets = _ref.siblingWidgets,
                siblingWidgets = _ref$siblingWidgets === undefined ? null : _ref$siblingWidgets,
                newIndex = _ref.newIndex;

            var models = this.get("widgets").models;
            if (siblingWidgets) {
                models = siblingWidgets.models;
            }
            var index = models.indexOf(widgetModel),
                targetIndex = -1,
                lowestIndex = this.getLowestIndex(models),
                highestIndex = this.getHighestIndex(models);

            switch (to) {
                case EditorConstants.BRING_TO_FRONT.value:
                    targetIndex = highestIndex;
                    break;

                case EditorConstants.BRING_FORWARD.value:
                    targetIndex = Math.min(index + 1, highestIndex);
                    break;

                case EditorConstants.SEND_BACKWARD.value:
                    targetIndex = Math.max(index - 1, 0);
                    break;

                case EditorConstants.SEND_BACK.value:
                    targetIndex = 0;
                    break;

                case EditorConstants.BRING_TO_TARGET.value:
                    targetIndex = newIndex;
                    break;

                default:
                    // Will default to -1.
                    break;
            }

            if (index === targetIndex || targetIndex === -1) {
                return;
            }

            models.splice(targetIndex, 0, models.splice(index, 1)[0]); // TODO: this seems like an expensive way to swap two elements in an array!
            this.reindexLayers(models, lowestIndex);
        },


        /**
         * Group Widgets
         *
         * Generates a composite widget and moves the specified widgets from the scene widget collection to the composite widget.
         * The newly generated composite widget is then finally added to the scene.
         *
         * @param  {AbstractWidgetModel[]} widgets Array of <code>AbstractWidgetModel</code>s or <code>CompositeWidgetModel</code>s.
         * @param  {Object} options Options object (optional) where options.cause is specified on undo/redo to avoid re-registering the activity.
         * @param  {Function} cb Callback function (optional) that is triggered when the grouping process has been successfully completed.
         */
        groupWidgets: function groupWidgets(widgets, options, cb) {
            if (!this.canGroupWidgets(widgets)) {
                return;
            }

            var widgetsOfGroup = widgets.reduce(function (widgetsOfGroup, widget) {
                if (widget instanceof CompositeWidgetModel) {
                    widget.resetGroupPositionOffset();
                    return widgetsOfGroup.concat(widget.get("group").models.map(function (model) {
                        return model.clone();
                    }));
                }
                return [widget.clone()].concat(widgetsOfGroup);
            }, []);

            // Sort the widgets to make sure layerIndex is respected
            widgetsOfGroup.sort(function (a, b) {
                return a.get("layerIndex") - b.get("layerIndex");
            });

            // Deletes the old widgets
            this.deleteWidgets(widgets, { cause: "group" });

            // Generate a new composite widget and with the newly grouped widgets
            var compositeWidget = new CompositeWidgetModel({ "group": widgetsOfGroup });

            // Add the new composite widget to the current collection of widgets
            var highestWidgetIndex = this.getHighestIndex(widgetsOfGroup);
            this.addWidget(compositeWidget, {
                cause: "group",
                at: highestWidgetIndex - 1
            });

            var compositeWidgets = [compositeWidget];

            this.trigger("selectWidgets", compositeWidgets);

            if (options.cause === "undo" || options.cause === "redo") {
                options.activity.compositeWidgets = compositeWidgets;
                return;
            }
            this.reindexLayers(this.get("widgets").models);

            EditorActivityManager.add(new EditorActivities.WidgetsGroupedActivity(compositeWidgets, widgets, this));

            if (cb) {
                cb();
            }
        },


        /**
         * Ungroup Widgets
         *
         * Pulls out grouped widgets from a composite widget and adds them to the scene widget collection.
         * The specified composite widget(s) are then removed from the scene.
         *
         * @param  {CompositeWidgetModel[]} widgets Array of <code>CompositeWidgetModel</code>s.
         * @param  {Object} options Options object (optional) where options.cause is specified on undo/redo to avoid re-registering the activity.
         * @param  {Function} cb Callback function (optional) that is triggered when the ungrouping process has been successfully completed.
         */
        ungroupWidgets: function ungroupWidgets(widgets, options, cb) {
            var _this = this;

            if (!this.canUngroupWidgets(widgets)) {
                return;
            }

            var ungroupedWidgets = widgets.reduce(function (allWidgets, widget) {
                if (!(widget instanceof CompositeWidgetModel)) {
                    return allWidgets;
                }

                widget.resetGroupPositionOffset();

                var widgets = widget.get("group").models;
                widgets.sort(function (a, b) {
                    return a.get("layerIndex") - b.get("layerIndex");
                });

                var ungroupedWidgets = widgets.map(function (model) {
                    return model.clone();
                });
                ungroupedWidgets.forEach(function (widget, idx) {
                    _this.addWidget(widget, {
                        at: widget.get("layerIndex") + idx,
                        cause: "ungroup"
                    });
                });

                _this.deleteWidget(widget, { cause: "ungroup" });

                return allWidgets.concat(ungroupedWidgets);
            }, []);

            this.trigger("selectWidgets", widgets.filter(function (w) {
                return !(w instanceof CompositeWidgetModel);
            }).concat(ungroupedWidgets));

            if (options.cause === "undo" || options.cause === "redo") {
                options.activity.groupWidgets = ungroupedWidgets;
                return;
            }

            EditorActivityManager.add(new EditorActivities.WidgetsUngroupedActivity(widgets, ungroupedWidgets, this));

            if (cb) {
                cb();
            }
        },


        /**
         * Validate if the given widgets can be grouped or not
         *
         * @param widgets (models)
         */
        canGroupWidgets: function canGroupWidgets(widgets) {
            if (!_.isArray(widgets) || widgets.length < 2) {
                return false;
            }

            var isDynamicProductWidget = widgets.some(function (widget) {
                return widget.get("type") === "dynamicProductWidget";
            });

            return !isDynamicProductWidget;
        },


        /**
         * Validate if the given widgets can be ungrouped or not
         *
         * @param composite widgets (models)
         */
        canUngroupWidgets: function canUngroupWidgets(widgets) {
            if (!_.isArray(widgets) || widgets.length === 0) {
                return false;
            }

            var hasCompositeWidgets = widgets.some(function (widget) {
                return widget instanceof CompositeWidgetModel;
            });

            return hasCompositeWidgets;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorActivity = __webpack_require__(192),
        _ = __webpack_require__(1);

    /**
     * An activity representing the creation of a widget.
     *
     * @class WidgetCreatedActivity
     * @author Kim
     */
    return EditorActivity.extend({

        _sceneModel: null,

        _widgetModels: null,

        _widgetModelProperties: null,

        /**
         * Constructor.
         *
         * @param  {AbstractWidgetModel|Array}  widgetModels A single instance
         *                                      of a <tt>AbstractWidgetModel</tt> or an array
         *                                      of <tt>AbstractWidgetModel</tt>'s.
         *
         * @param  {Scene} sceneModel           The associated <tt>Scene</tt> model.
         */
        constructor: function constructor(widgetModels, sceneModel) {
            this._widgetModels = _.isArray(widgetModels) ? widgetModels : [widgetModels];
            this._sceneModel = sceneModel;
        },

        _onUndo: function _onUndo() {
            _.each(this._widgetModels, function (widgetModel) {
                // We want to delete the widget by UUID because that is a more robust system
                // than deleting by model which is rather fragile.
                // This assumes that in an experience widget UUID's are unique and consistent
                this._sceneModel.deleteWidget(widgetModel, { cause: "undo" });
                this._sceneModel.deleteWidgetByID(widgetModel.get("uuid"), { cause: "undo" });
            }, this);
        },

        _onRedo: function _onRedo() {
            _.each(this._widgetModels, function (widgetModel) {
                this._sceneModel.addWidget(widgetModel, { cause: "redo" });
            }, this);
        },

        dispose: function dispose() {
            this._widgetModels = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorActivity = __webpack_require__(192),
        Backbone = __webpack_require__(7),
        GeneralFunctions = __webpack_require__(193);

    /**
     * Takes an object of attributes and returns a new object where any model values are cloned
     * instead of just having a reference.
     *
     * Note, clone does not need to be called any deeper, as it already have this functionality
     * built into it. The only reason we need this function, is that we are working with Objects
     * instead of Models.
     *
     * @private
     * @stateless
     * @param {Object} attributes Object that we wish to clone
     * @returns {Object}          Object with model values cloned.
     */
    var cloneValues = GeneralFunctions.mapOverObj(function (value) {
        return value instanceof Backbone.Model ? value.clone({ duplicate: true }) : value;
    });

    /**
     * An activity representing a change in one or more widget properties.
     *
     * @class WidgetPropertiesChangedActivity
     * @author Kim
     */
    return EditorActivity.extend({

        _widgetModel: null,

        _changedAttributes: null,

        _previousAttributes: null,

        constructor: function constructor(widgetModel, changedAttributes, previousAttributes) {
            this._widgetModel = widgetModel;
            this._changedAttributes = changedAttributes;
            this._previousAttributes = previousAttributes;
        },

        _onUndo: function _onUndo() {
            // Add the 'cause' to signal that the change came from a undo action
            this._widgetModel.set(cloneValues(this._previousAttributes), { cause: "undo" });
        },

        _onRedo: function _onRedo() {
            // Add the 'cause' to signal that the change came from a redo action
            this._widgetModel.set(cloneValues(this._changedAttributes), { cause: "redo" });
        },

        dispose: function dispose() {
            this._widgetModel = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorActivity = __webpack_require__(192);

    /**
     * An activity representing the disposal of a <tt>Scene</tt> model.
     *
     * @class SceneDeletedActivity
     * @author Kim
     */
    return EditorActivity.extend({

        _sceneModel: null,

        _experienceModel: null,

        _index: null,

        constructor: function constructor(sceneModel, experienceModel, index) {
            this._sceneModel = sceneModel;
            this._experienceModel = experienceModel;
            this._index = index;
        },

        _onUndo: function _onUndo() {
            // Make sure the Scene model does not contain an ID when re-adding it to the
            // experience - it should represent a new scene, otherwise the backend will
            // start complaining...
            this._experienceModel.addScene(this._index + 1, this._sceneModel.clone({ duplicate: true }));
        },

        _onRedo: function _onRedo() {
            this._experienceModel.removeScene(this._sceneModel);
        },

        dispose: function dispose() {
            this._sceneModel = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorActivity = __webpack_require__(192),
        _ = __webpack_require__(1);

    /**
     * An activity representing the creation of a widget.
     *
     * @class WidgetDeletedActivity
     * @author Kim
     */
    return EditorActivity.extend({

        _sceneModel: null,

        /**
         *
         * @type {Array}
         */
        _widgetModels: null,

        /**
         *
         * @type {Array}
         */
        _widgetModelProperties: null,

        constructor: function constructor(widgetModels, sceneModel) {
            widgetModels = _.isArray(widgetModels) ? widgetModels : [widgetModels];
            this._widgetModels = _.invoke(widgetModels, "clone", { duplicate: true });
            this._sceneModel = sceneModel;
        },

        _onUndo: function _onUndo() {
            _.each(this._widgetModels, function (widgetModel) {
                this._sceneModel.addWidget(widgetModel, { cause: "undo" });
            }, this);
        },

        _onRedo: function _onRedo() {
            _.each(this._widgetModels, function (widgetModel) {
                this._sceneModel.deleteWidget(widgetModel, { cause: "redo" });
            }, this);
        },

        dispose: function dispose() {
            this._widgetModels = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorActivity = __webpack_require__(192);

    /**
     * An activity of grouping widgets.
     *
     * @class WidgetGroupedActivity
     */
    return EditorActivity.extend({

        widgetType: "composite",

        compositeWidgets: null,
        groupWidgets: null,
        sceneModel: null,

        constructor: function constructor(compositeWidgets, groupWidgets, sceneModel) {
            this.compositeWidgets = compositeWidgets;
            this.groupWidgets = groupWidgets;
            this.sceneModel = sceneModel;
        },

        _onUndo: function _onUndo() {
            this.sceneModel.ungroupWidgets(this.compositeWidgets, { cause: "undo", activity: this });
        },

        _onRedo: function _onRedo() {
            this.sceneModel.ungroupWidgets(this.groupWidgets, { cause: "redo", activity: this });
        },

        updateCompositeWidgetsReference: function updateCompositeWidgetsReference(compositeWidgets) {
            this.compositeWidgets = compositeWidgets;
        },

        dispose: function dispose() {
            this.compositeWidgets = null;
            this.groupWidgets = null;
            this.sceneModel = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorActivity = __webpack_require__(192);

    /**
     * An activity of ungrouping widgets.
     *
     * @class WidgetGroupedActivity
     */
    return EditorActivity.extend({

        widgetType: "composite",

        compositeWidgets: null,
        groupWidgets: null,
        sceneModel: null,

        constructor: function constructor(compositeWidgets, groupWidgets, sceneModel) {
            this.compositeWidgets = compositeWidgets;
            this.groupWidgets = groupWidgets;
            this.sceneModel = sceneModel;
        },

        _onUndo: function _onUndo() {
            this.sceneModel.groupWidgets(this.groupWidgets, { cause: "undo", activity: this });
        },

        _onRedo: function _onRedo() {
            this.sceneModel.ungroupWidgets(this.compositeWidgets, { cause: "redo", activity: this });
        },

        dispose: function dispose() {
            this.compositeWidgets = null;
            this.groupWidgets = null;
            this.sceneModel = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorActivity = __webpack_require__(192);
    var WidgetTypes = __webpack_require__(69);
    var ProductPropertiesModel = __webpack_require__(789);
    var EditorEventFilters = __webpack_require__(154).default;
    var CreateAndUpdateDynamicProductWidget = __webpack_require__(790);
    var AddWidgetsAction = __webpack_require__(370);

    /**
     * An activity of updating the DynamicProductWidget when a Product ID is entered in
     *
     * We previously marked all activity associated with entering a Product ID as superficial
     * and this activity replaces entering and updating the product ID
     *
     * @class DynamicProductWidgetCreatedActivity
     */
    return EditorActivity.extend({

        widgetType: WidgetTypes.DYNAMIC_PRODUCT.id,

        dynamicProductWidgetModel: null,
        previousDynamicProductWidgetModel: null,
        previousDynamicProductWidgetID: null,
        currentDynamicProductWidgetID: null,
        experience: null,
        _widgetModel: null,
        viewModel: null,
        scene: null,
        viewScope: null,

        model: null,

        constructor: function constructor(options) {
            this.dynamicProductWidgetModel = options.dynamicProductWidgetModel;
            this.previousDynamicProductWidgetModel = options.previousDynamicProductWidgetModel;

            this.previousDynamicProductWidgetID = options.previousID;
            this.currentDynamicProductWidgetID = options.currentID;

            this._widgetModel = options.dynamicProductWidgetModel;
            this.experience = options.experience;
            this.model = new ProductPropertiesModel();

            this.scene = options.scene;
            this.viewScope = options.viewScope;
        },

        _onUndo: function _onUndo() {
            var _this = this;

            // If there is a previous ProductID on the widget,
            // on an undo we change the dynamic Product Widget to show the previous Product ID
            if (this.previousDynamicProductWidgetID) {
                this.model.getProduct(this.previousDynamicProductWidgetID, this.experience.get("language"), this.experience.get("companyId")).then(function (product) {
                    var scene = _this.viewScope.viewModel.get("activeLayerSceneModel");
                    var uuid = _this.dynamicProductWidgetModel.get("uuid");
                    var correctCurrentWidget = scene.getWidgetByID(uuid);
                    CreateAndUpdateDynamicProductWidget.updateProductWidget(product, _this.experience, correctCurrentWidget);
                });
                // else we revert the Product Widget to it's initial single widget state
                // (we so this by replacing the current widget model with a previous model)
            } else {
                CreateAndUpdateDynamicProductWidget.replaceProductWidget(this.scene, this.dynamicProductWidgetModel, this.previousDynamicProductWidgetModel);
            }
        },

        _onRedo: function _onRedo() {
            var _this2 = this;

            // If there is a previous ProductID on the widget,
            // on a redo we change the dynamic Product Widget to show the current Product ID
            if (this.previousDynamicProductWidgetID) {
                this.model.getProduct(this.currentDynamicProductWidgetID, this.experience.get("language"), this.experience.get("companyId")).then(function (product) {
                    var scene = _this2.viewScope.viewModel.get("activeLayerSceneModel");
                    var uuid = _this2.dynamicProductWidgetModel.get("uuid");
                    var correctCurrentWidget = scene.getWidgetByID(uuid);
                    CreateAndUpdateDynamicProductWidget.updateProductWidget(product, _this2.experience, correctCurrentWidget);
                });
            } else {
                // else on a redo, we recreate the DynamicProductWidget with the productID
                this.model.getProduct(this.currentDynamicProductWidgetID, this.experience.get("language"), this.experience.get("companyId")).then(function (product) {
                    CreateAndUpdateDynamicProductWidget.createProductWidget(product, _this2.experience, _this2.previousDynamicProductWidgetModel).then(function (widgetModels) {
                        // We mark the AddWidgetsAction as SUPERFICIAL to make sure that the activity isn't added to the activity stack
                        new AddWidgetsAction(_this2.scene, widgetModels, _this2.viewScope.viewModel, true, { cause: EditorEventFilters.SUPERFICIAL }).execute().done(function () {
                            var scene = _this2.viewScope.viewModel.get("activeLayerSceneModel");
                            CreateAndUpdateDynamicProductWidget.updateProductWidgetOnScene(scene, _this2.previousDynamicProductWidgetModel, _this2.dynamicProductWidgetModel.get("productID"), widgetModels);
                        });
                    });
                });
            }
        },

        dispose: function dispose() {
            this.dynamicProductWidgetModel = null;
            this.previousDynamicProductWidgetModel = null;

            this.previousDynamicProductWidgetID = null;
            this.currentDynamicProductWidgetID = null;

            this._widgetModel = null;
            this.experience = null;
            this.model = null;

            this.scene = null;
            this.viewScope = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AnimationModel = __webpack_require__(172);

    /**
     * The model for a slide animation.
     *
     * @class SlideAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "slide",
            direction: "right"
        }, AnimationModel.prototype.defaults)
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AnimationModel = __webpack_require__(172);

    /**
     * The model for a slide animation.
     *
     * @class SlideOutAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "slideOut",
            direction: "right"
        }, AnimationModel.prototype.defaults)
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AnimationModel = __webpack_require__(172);

    /**
     * The model for a fade animation.
     *
     * @class FadeAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "fade"
        }, AnimationModel.prototype.defaults)
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AnimationModel = __webpack_require__(172);

    /**
     * The model for a fade out animation.
     *
     * @class FadeOutAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "fadeOut"
        }, AnimationModel.prototype.defaults)
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AnimationModel = __webpack_require__(172);

    /**
     * The model for a zoom in animation.
     *
     * @class ZoomInAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "zoomIn"
        }, AnimationModel.prototype.defaults)
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AnimationModel = __webpack_require__(172);

    /**
     * The model for a zoom out animation.
     *
     * @class ZoomOutAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "zoomOut"
        }, AnimationModel.prototype.defaults)
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AnimationModel = __webpack_require__(172);

    /**
     * The model for a Move animation.
     *
     * @class MoveAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "move",
            fromTop: null,
            fromLeft: null,
            verticalMove: null,
            horizontalMove: null
        }, AnimationModel.prototype.defaults)
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AnimationController = __webpack_require__(174);
    var Preconditions = __webpack_require__(14);

    /**
     * The animation controller for a slide animation.
     *
     * @class SlideAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.INTRO, // We're sliding in, hence "intro"

        descriptor: function descriptor() {
            var appearanceDescriptor = this.getAppearanceDescriptor();
            var scaledExperienceSize = this.unscaledExperienceSize.scale(appearanceDescriptor.scale);
            var stylingRect = appearanceDescriptor.styling;

            // Let's calculate "from" coordinates
            var fromPoint = appearanceDescriptor.position;
            var toPoint = _.clone(fromPoint);
            var direction = this.animationModel.get("direction");

            switch (direction) {
                case "top":
                    fromPoint.y = -this.elementBounds.height - appearanceDescriptor.positionOffset.y - Math.max(0, stylingRect.height + stylingRect.y);
                    break;

                case "left":
                    fromPoint.x = -this.elementBounds.width - appearanceDescriptor.positionOffset.x - Math.max(0, stylingRect.width + stylingRect.x) - Math.ceil((this.elementRect.width - this.elementBounds.width) / 2);
                    break;

                case "bottom":
                    fromPoint.y = scaledExperienceSize.height - appearanceDescriptor.positionOffset.y + appearanceDescriptor.pivotOffset.height + Math.max(0, stylingRect.height - stylingRect.y);
                    break;

                case "right":
                    fromPoint.x = scaledExperienceSize.width - appearanceDescriptor.positionOffset.x + Math.max(0, stylingRect.width - stylingRect.x) - Math.ceil((this.elementRect.width - this.elementBounds.width) / 2);
                    break;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Direction '" + direction + "' not recognized.");
                    break;
            }

            return {
                fromTo: [fromPoint, toPoint]
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 1.20.3
 * DATE: 2017-10-02
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("plugins.CSSPlugin",["plugins.TweenPlugin","TweenLite"],function(a,b){var c,d,e,f,g=function(){a.call(this,"css"),this._overwriteProps.length=0,this.setRatio=g.prototype.setRatio},h=_gsScope._gsDefine.globals,i={},j=g.prototype=new a("css");j.constructor=g,g.version="1.20.3",g.API=2,g.defaultTransformPerspective=0,g.defaultSkewType="compensated",g.defaultSmoothOrigin=!0,j="px",g.suffixMap={top:j,right:j,bottom:j,left:j,width:j,height:j,fontSize:j,padding:j,margin:j,perspective:j,lineHeight:""};var k,l,m,n,o,p,q,r,s=/(?:\-|\.|\b)(\d|\.|e\-)+/g,t=/(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,u=/(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,v=/(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,w=/(?:\d|\-|\+|=|#|\.)*/g,x=/opacity *= *([^)]*)/i,y=/opacity:([^;]*)/i,z=/alpha\(opacity *=.+?\)/i,A=/^(rgb|hsl)/,B=/([A-Z])/g,C=/-([a-z])/gi,D=/(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,E=function(a,b){return b.toUpperCase()},F=/(?:Left|Right|Width)/i,G=/(M11|M12|M21|M22)=[\d\-\.e]+/gi,H=/progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,I=/,(?=[^\)]*(?:\(|$))/gi,J=/[\s,\(]/i,K=Math.PI/180,L=180/Math.PI,M={},N={style:{}},O=_gsScope.document||{createElement:function(){return N}},P=function(a,b){return O.createElementNS?O.createElementNS(b||"http://www.w3.org/1999/xhtml",a):O.createElement(a)},Q=P("div"),R=P("img"),S=g._internals={_specialProps:i},T=(_gsScope.navigator||{}).userAgent||"",U=function(){var a=T.indexOf("Android"),b=P("a");return m=-1!==T.indexOf("Safari")&&-1===T.indexOf("Chrome")&&(-1===a||parseFloat(T.substr(a+8,2))>3),o=m&&parseFloat(T.substr(T.indexOf("Version/")+8,2))<6,n=-1!==T.indexOf("Firefox"),(/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(T)||/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(T))&&(p=parseFloat(RegExp.$1)),b?(b.style.cssText="top:1px;opacity:.55;",/^0.55/.test(b.style.opacity)):!1}(),V=function(a){return x.test("string"==typeof a?a:(a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?parseFloat(RegExp.$1)/100:1},W=function(a){_gsScope.console&&console.log(a)},X="",Y="",Z=function(a,b){b=b||Q;var c,d,e=b.style;if(void 0!==e[a])return a;for(a=a.charAt(0).toUpperCase()+a.substr(1),c=["O","Moz","ms","Ms","Webkit"],d=5;--d>-1&&void 0===e[c[d]+a];);return d>=0?(Y=3===d?"ms":c[d],X="-"+Y.toLowerCase()+"-",Y+a):null},$=O.defaultView?O.defaultView.getComputedStyle:function(){},_=g.getStyle=function(a,b,c,d,e){var f;return U||"opacity"!==b?(!d&&a.style[b]?f=a.style[b]:(c=c||$(a))?f=c[b]||c.getPropertyValue(b)||c.getPropertyValue(b.replace(B,"-$1").toLowerCase()):a.currentStyle&&(f=a.currentStyle[b]),null==e||f&&"none"!==f&&"auto"!==f&&"auto auto"!==f?f:e):V(a)},aa=S.convertToPixels=function(a,c,d,e,f){if("px"===e||!e&&"lineHeight"!==c)return d;if("auto"===e||!d)return 0;var h,i,j,k=F.test(c),l=a,m=Q.style,n=0>d,o=1===d;if(n&&(d=-d),o&&(d*=100),"lineHeight"!==c||e)if("%"===e&&-1!==c.indexOf("border"))h=d/100*(k?a.clientWidth:a.clientHeight);else{if(m.cssText="border:0 solid red;position:"+_(a,"position")+";line-height:0;","%"!==e&&l.appendChild&&"v"!==e.charAt(0)&&"rem"!==e)m[k?"borderLeftWidth":"borderTopWidth"]=d+e;else{if(l=a.parentNode||O.body,-1!==_(l,"display").indexOf("flex")&&(m.position="absolute"),i=l._gsCache,j=b.ticker.frame,i&&k&&i.time===j)return i.width*d/100;m[k?"width":"height"]=d+e}l.appendChild(Q),h=parseFloat(Q[k?"offsetWidth":"offsetHeight"]),l.removeChild(Q),k&&"%"===e&&g.cacheWidths!==!1&&(i=l._gsCache=l._gsCache||{},i.time=j,i.width=h/d*100),0!==h||f||(h=aa(a,c,d,e,!0))}else i=$(a).lineHeight,a.style.lineHeight=d,h=parseFloat($(a).lineHeight),a.style.lineHeight=i;return o&&(h/=100),n?-h:h},ba=S.calculateOffset=function(a,b,c){if("absolute"!==_(a,"position",c))return 0;var d="left"===b?"Left":"Top",e=_(a,"margin"+d,c);return a["offset"+d]-(aa(a,b,parseFloat(e),e.replace(w,""))||0)},ca=function(a,b){var c,d,e,f={};if(b=b||$(a,null))if(c=b.length)for(;--c>-1;)e=b[c],(-1===e.indexOf("-transform")||Da===e)&&(f[e.replace(C,E)]=b.getPropertyValue(e));else for(c in b)(-1===c.indexOf("Transform")||Ca===c)&&(f[c]=b[c]);else if(b=a.currentStyle||a.style)for(c in b)"string"==typeof c&&void 0===f[c]&&(f[c.replace(C,E)]=b[c]);return U||(f.opacity=V(a)),d=Ra(a,b,!1),f.rotation=d.rotation,f.skewX=d.skewX,f.scaleX=d.scaleX,f.scaleY=d.scaleY,f.x=d.x,f.y=d.y,Fa&&(f.z=d.z,f.rotationX=d.rotationX,f.rotationY=d.rotationY,f.scaleZ=d.scaleZ),f.filters&&delete f.filters,f},da=function(a,b,c,d,e){var f,g,h,i={},j=a.style;for(g in c)"cssText"!==g&&"length"!==g&&isNaN(g)&&(b[g]!==(f=c[g])||e&&e[g])&&-1===g.indexOf("Origin")&&("number"==typeof f||"string"==typeof f)&&(i[g]="auto"!==f||"left"!==g&&"top"!==g?""!==f&&"auto"!==f&&"none"!==f||"string"!=typeof b[g]||""===b[g].replace(v,"")?f:0:ba(a,g),void 0!==j[g]&&(h=new sa(j,g,j[g],h)));if(d)for(g in d)"className"!==g&&(i[g]=d[g]);return{difs:i,firstMPT:h}},ea={width:["Left","Right"],height:["Top","Bottom"]},fa=["marginLeft","marginRight","marginTop","marginBottom"],ga=function(a,b,c){if("svg"===(a.nodeName+"").toLowerCase())return(c||$(a))[b]||0;if(a.getCTM&&Oa(a))return a.getBBox()[b]||0;var d=parseFloat("width"===b?a.offsetWidth:a.offsetHeight),e=ea[b],f=e.length;for(c=c||$(a,null);--f>-1;)d-=parseFloat(_(a,"padding"+e[f],c,!0))||0,d-=parseFloat(_(a,"border"+e[f]+"Width",c,!0))||0;return d},ha=function(a,b){if("contain"===a||"auto"===a||"auto auto"===a)return a+" ";(null==a||""===a)&&(a="0 0");var c,d=a.split(" "),e=-1!==a.indexOf("left")?"0%":-1!==a.indexOf("right")?"100%":d[0],f=-1!==a.indexOf("top")?"0%":-1!==a.indexOf("bottom")?"100%":d[1];if(d.length>3&&!b){for(d=a.split(", ").join(",").split(","),a=[],c=0;c<d.length;c++)a.push(ha(d[c]));return a.join(",")}return null==f?f="center"===e?"50%":"0":"center"===f&&(f="50%"),("center"===e||isNaN(parseFloat(e))&&-1===(e+"").indexOf("="))&&(e="50%"),a=e+" "+f+(d.length>2?" "+d[2]:""),b&&(b.oxp=-1!==e.indexOf("%"),b.oyp=-1!==f.indexOf("%"),b.oxr="="===e.charAt(1),b.oyr="="===f.charAt(1),b.ox=parseFloat(e.replace(v,"")),b.oy=parseFloat(f.replace(v,"")),b.v=a),b||a},ia=function(a,b){return"function"==typeof a&&(a=a(r,q)),"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2)):parseFloat(a)-parseFloat(b)||0},ja=function(a,b){return"function"==typeof a&&(a=a(r,q)),null==a?b:"string"==typeof a&&"="===a.charAt(1)?parseInt(a.charAt(0)+"1",10)*parseFloat(a.substr(2))+b:parseFloat(a)||0},ka=function(a,b,c,d){var e,f,g,h,i,j=1e-6;return"function"==typeof a&&(a=a(r,q)),null==a?h=b:"number"==typeof a?h=a:(e=360,f=a.split("_"),i="="===a.charAt(1),g=(i?parseInt(a.charAt(0)+"1",10)*parseFloat(f[0].substr(2)):parseFloat(f[0]))*(-1===a.indexOf("rad")?1:L)-(i?0:b),f.length&&(d&&(d[c]=b+g),-1!==a.indexOf("short")&&(g%=e,g!==g%(e/2)&&(g=0>g?g+e:g-e)),-1!==a.indexOf("_cw")&&0>g?g=(g+9999999999*e)%e-(g/e|0)*e:-1!==a.indexOf("ccw")&&g>0&&(g=(g-9999999999*e)%e-(g/e|0)*e)),h=b+g),j>h&&h>-j&&(h=0),h},la={aqua:[0,255,255],lime:[0,255,0],silver:[192,192,192],black:[0,0,0],maroon:[128,0,0],teal:[0,128,128],blue:[0,0,255],navy:[0,0,128],white:[255,255,255],fuchsia:[255,0,255],olive:[128,128,0],yellow:[255,255,0],orange:[255,165,0],gray:[128,128,128],purple:[128,0,128],green:[0,128,0],red:[255,0,0],pink:[255,192,203],cyan:[0,255,255],transparent:[255,255,255,0]},ma=function(a,b,c){return a=0>a?a+1:a>1?a-1:a,255*(1>6*a?b+(c-b)*a*6:.5>a?c:2>3*a?b+(c-b)*(2/3-a)*6:b)+.5|0},na=g.parseColor=function(a,b){var c,d,e,f,g,h,i,j,k,l,m;if(a)if("number"==typeof a)c=[a>>16,a>>8&255,255&a];else{if(","===a.charAt(a.length-1)&&(a=a.substr(0,a.length-1)),la[a])c=la[a];else if("#"===a.charAt(0))4===a.length&&(d=a.charAt(1),e=a.charAt(2),f=a.charAt(3),a="#"+d+d+e+e+f+f),a=parseInt(a.substr(1),16),c=[a>>16,a>>8&255,255&a];else if("hsl"===a.substr(0,3))if(c=m=a.match(s),b){if(-1!==a.indexOf("="))return a.match(t)}else g=Number(c[0])%360/360,h=Number(c[1])/100,i=Number(c[2])/100,e=.5>=i?i*(h+1):i+h-i*h,d=2*i-e,c.length>3&&(c[3]=Number(c[3])),c[0]=ma(g+1/3,d,e),c[1]=ma(g,d,e),c[2]=ma(g-1/3,d,e);else c=a.match(s)||la.transparent;c[0]=Number(c[0]),c[1]=Number(c[1]),c[2]=Number(c[2]),c.length>3&&(c[3]=Number(c[3]))}else c=la.black;return b&&!m&&(d=c[0]/255,e=c[1]/255,f=c[2]/255,j=Math.max(d,e,f),k=Math.min(d,e,f),i=(j+k)/2,j===k?g=h=0:(l=j-k,h=i>.5?l/(2-j-k):l/(j+k),g=j===d?(e-f)/l+(f>e?6:0):j===e?(f-d)/l+2:(d-e)/l+4,g*=60),c[0]=g+.5|0,c[1]=100*h+.5|0,c[2]=100*i+.5|0),c},oa=function(a,b){var c,d,e,f=a.match(pa)||[],g=0,h="";if(!f.length)return a;for(c=0;c<f.length;c++)d=f[c],e=a.substr(g,a.indexOf(d,g)-g),g+=e.length+d.length,d=na(d,b),3===d.length&&d.push(1),h+=e+(b?"hsla("+d[0]+","+d[1]+"%,"+d[2]+"%,"+d[3]:"rgba("+d.join(","))+")";return h+a.substr(g)},pa="(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";for(j in la)pa+="|"+j+"\\b";pa=new RegExp(pa+")","gi"),g.colorStringFilter=function(a){var b,c=a[0]+" "+a[1];pa.test(c)&&(b=-1!==c.indexOf("hsl(")||-1!==c.indexOf("hsla("),a[0]=oa(a[0],b),a[1]=oa(a[1],b)),pa.lastIndex=0},b.defaultStringFilter||(b.defaultStringFilter=g.colorStringFilter);var qa=function(a,b,c,d){if(null==a)return function(a){return a};var e,f=b?(a.match(pa)||[""])[0]:"",g=a.split(f).join("").match(u)||[],h=a.substr(0,a.indexOf(g[0])),i=")"===a.charAt(a.length-1)?")":"",j=-1!==a.indexOf(" ")?" ":",",k=g.length,l=k>0?g[0].replace(s,""):"";return k?e=b?function(a){var b,m,n,o;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(o=a.replace(I,"|").split("|"),n=0;n<o.length;n++)o[n]=e(o[n]);return o.join(",")}if(b=(a.match(pa)||[f])[0],m=a.split(b).join("").match(u)||[],n=m.length,k>n--)for(;++n<k;)m[n]=c?m[(n-1)/2|0]:g[n];return h+m.join(j)+j+b+i+(-1!==a.indexOf("inset")?" inset":"")}:function(a){var b,f,m;if("number"==typeof a)a+=l;else if(d&&I.test(a)){for(f=a.replace(I,"|").split("|"),m=0;m<f.length;m++)f[m]=e(f[m]);return f.join(",")}if(b=a.match(u)||[],m=b.length,k>m--)for(;++m<k;)b[m]=c?b[(m-1)/2|0]:g[m];return h+b.join(j)+i}:function(a){return a}},ra=function(a){return a=a.split(","),function(b,c,d,e,f,g,h){var i,j=(c+"").split(" ");for(h={},i=0;4>i;i++)h[a[i]]=j[i]=j[i]||j[(i-1)/2>>0];return e.parse(b,h,f,g)}},sa=(S._setPluginRatio=function(a){this.plugin.setRatio(a);for(var b,c,d,e,f,g=this.data,h=g.proxy,i=g.firstMPT,j=1e-6;i;)b=h[i.v],i.r?b=Math.round(b):j>b&&b>-j&&(b=0),i.t[i.p]=b,i=i._next;if(g.autoRotate&&(g.autoRotate.rotation=g.mod?g.mod(h.rotation,this.t):h.rotation),1===a||0===a)for(i=g.firstMPT,f=1===a?"e":"b";i;){if(c=i.t,c.type){if(1===c.type){for(e=c.xs0+c.s+c.xs1,d=1;d<c.l;d++)e+=c["xn"+d]+c["xs"+(d+1)];c[f]=e}}else c[f]=c.s+c.xs0;i=i._next}},function(a,b,c,d,e){this.t=a,this.p=b,this.v=c,this.r=e,d&&(d._prev=this,this._next=d)}),ta=(S._parseToProxy=function(a,b,c,d,e,f){var g,h,i,j,k,l=d,m={},n={},o=c._transform,p=M;for(c._transform=null,M=b,d=k=c.parse(a,b,d,e),M=p,f&&(c._transform=o,l&&(l._prev=null,l._prev&&(l._prev._next=null)));d&&d!==l;){if(d.type<=1&&(h=d.p,n[h]=d.s+d.c,m[h]=d.s,f||(j=new sa(d,"s",h,j,d.r),d.c=0),1===d.type))for(g=d.l;--g>0;)i="xn"+g,h=d.p+"_"+i,n[h]=d.data[i],m[h]=d[i],f||(j=new sa(d,i,h,j,d.rxp[i]));d=d._next}return{proxy:m,end:n,firstMPT:j,pt:k}},S.CSSPropTween=function(a,b,d,e,g,h,i,j,k,l,m){this.t=a,this.p=b,this.s=d,this.c=e,this.n=i||b,a instanceof ta||f.push(this.n),this.r=j,this.type=h||0,k&&(this.pr=k,c=!0),this.b=void 0===l?d:l,this.e=void 0===m?d+e:m,g&&(this._next=g,g._prev=this)}),ua=function(a,b,c,d,e,f){var g=new ta(a,b,c,d-c,e,-1,f);return g.b=c,g.e=g.xs0=d,g},va=g.parseComplex=function(a,b,c,d,e,f,h,i,j,l){c=c||f||"","function"==typeof d&&(d=d(r,q)),h=new ta(a,b,0,0,h,l?2:1,null,!1,i,c,d),d+="",e&&pa.test(d+c)&&(d=[c,d],g.colorStringFilter(d),c=d[0],d=d[1]);var m,n,o,p,u,v,w,x,y,z,A,B,C,D=c.split(", ").join(",").split(" "),E=d.split(", ").join(",").split(" "),F=D.length,G=k!==!1;for((-1!==d.indexOf(",")||-1!==c.indexOf(","))&&(-1!==(d+c).indexOf("rgb")||-1!==(d+c).indexOf("hsl")?(D=D.join(" ").replace(I,", ").split(" "),E=E.join(" ").replace(I,", ").split(" ")):(D=D.join(" ").split(",").join(", ").split(" "),E=E.join(" ").split(",").join(", ").split(" ")),F=D.length),F!==E.length&&(D=(f||"").split(" "),F=D.length),h.plugin=j,h.setRatio=l,pa.lastIndex=0,m=0;F>m;m++)if(p=D[m],u=E[m],x=parseFloat(p),x||0===x)h.appendXtra("",x,ia(u,x),u.replace(t,""),G&&-1!==u.indexOf("px"),!0);else if(e&&pa.test(p))B=u.indexOf(")")+1,B=")"+(B?u.substr(B):""),C=-1!==u.indexOf("hsl")&&U,z=u,p=na(p,C),u=na(u,C),y=p.length+u.length>6,y&&!U&&0===u[3]?(h["xs"+h.l]+=h.l?" transparent":"transparent",h.e=h.e.split(E[m]).join("transparent")):(U||(y=!1),C?h.appendXtra(z.substr(0,z.indexOf("hsl"))+(y?"hsla(":"hsl("),p[0],ia(u[0],p[0]),",",!1,!0).appendXtra("",p[1],ia(u[1],p[1]),"%,",!1).appendXtra("",p[2],ia(u[2],p[2]),y?"%,":"%"+B,!1):h.appendXtra(z.substr(0,z.indexOf("rgb"))+(y?"rgba(":"rgb("),p[0],u[0]-p[0],",",!0,!0).appendXtra("",p[1],u[1]-p[1],",",!0).appendXtra("",p[2],u[2]-p[2],y?",":B,!0),y&&(p=p.length<4?1:p[3],h.appendXtra("",p,(u.length<4?1:u[3])-p,B,!1))),pa.lastIndex=0;else if(v=p.match(s)){if(w=u.match(t),!w||w.length!==v.length)return h;for(o=0,n=0;n<v.length;n++)A=v[n],z=p.indexOf(A,o),h.appendXtra(p.substr(o,z-o),Number(A),ia(w[n],A),"",G&&"px"===p.substr(z+A.length,2),0===n),o=z+A.length;h["xs"+h.l]+=p.substr(o)}else h["xs"+h.l]+=h.l||h["xs"+h.l]?" "+u:u;if(-1!==d.indexOf("=")&&h.data){for(B=h.xs0+h.data.s,m=1;m<h.l;m++)B+=h["xs"+m]+h.data["xn"+m];h.e=B+h["xs"+m]}return h.l||(h.type=-1,h.xs0=h.e),h.xfirst||h},wa=9;for(j=ta.prototype,j.l=j.pr=0;--wa>0;)j["xn"+wa]=0,j["xs"+wa]="";j.xs0="",j._next=j._prev=j.xfirst=j.data=j.plugin=j.setRatio=j.rxp=null,j.appendXtra=function(a,b,c,d,e,f){var g=this,h=g.l;return g["xs"+h]+=f&&(h||g["xs"+h])?" "+a:a||"",c||0===h||g.plugin?(g.l++,g.type=g.setRatio?2:1,g["xs"+g.l]=d||"",h>0?(g.data["xn"+h]=b+c,g.rxp["xn"+h]=e,g["xn"+h]=b,g.plugin||(g.xfirst=new ta(g,"xn"+h,b,c,g.xfirst||g,0,g.n,e,g.pr),g.xfirst.xs0=0),g):(g.data={s:b+c},g.rxp={},g.s=b,g.c=c,g.r=e,g)):(g["xs"+h]+=b+(d||""),g)};var xa=function(a,b){b=b||{},this.p=b.prefix?Z(a)||a:a,i[a]=i[this.p]=this,this.format=b.formatter||qa(b.defaultValue,b.color,b.collapsible,b.multi),b.parser&&(this.parse=b.parser),this.clrs=b.color,this.multi=b.multi,this.keyword=b.keyword,this.dflt=b.defaultValue,this.pr=b.priority||0},ya=S._registerComplexSpecialProp=function(a,b,c){"object"!=typeof b&&(b={parser:c});var d,e,f=a.split(","),g=b.defaultValue;for(c=c||[g],d=0;d<f.length;d++)b.prefix=0===d&&b.prefix,b.defaultValue=c[d]||g,e=new xa(f[d],b)},za=S._registerPluginProp=function(a){if(!i[a]){var b=a.charAt(0).toUpperCase()+a.substr(1)+"Plugin";ya(a,{parser:function(a,c,d,e,f,g,j){var k=h.com.greensock.plugins[b];return k?(k._cssRegister(),i[d].parse(a,c,d,e,f,g,j)):(W("Error: "+b+" js file not loaded."),f)}})}};j=xa.prototype,j.parseComplex=function(a,b,c,d,e,f){var g,h,i,j,k,l,m=this.keyword;if(this.multi&&(I.test(c)||I.test(b)?(h=b.replace(I,"|").split("|"),i=c.replace(I,"|").split("|")):m&&(h=[b],i=[c])),i){for(j=i.length>h.length?i.length:h.length,g=0;j>g;g++)b=h[g]=h[g]||this.dflt,c=i[g]=i[g]||this.dflt,m&&(k=b.indexOf(m),l=c.indexOf(m),k!==l&&(-1===l?h[g]=h[g].split(m).join(""):-1===k&&(h[g]+=" "+m)));b=h.join(", "),c=i.join(", ")}return va(a,this.p,b,c,this.clrs,this.dflt,d,this.pr,e,f)},j.parse=function(a,b,c,d,f,g,h){return this.parseComplex(a.style,this.format(_(a,this.p,e,!1,this.dflt)),this.format(b),f,g)},g.registerSpecialProp=function(a,b,c){ya(a,{parser:function(a,d,e,f,g,h,i){var j=new ta(a,e,0,0,g,2,e,!1,c);return j.plugin=h,j.setRatio=b(a,d,f._tween,e),j},priority:c})},g.useSVGTransformAttr=!0;var Aa,Ba="scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),Ca=Z("transform"),Da=X+"transform",Ea=Z("transformOrigin"),Fa=null!==Z("perspective"),Ga=S.Transform=function(){this.perspective=parseFloat(g.defaultTransformPerspective)||0,this.force3D=g.defaultForce3D!==!1&&Fa?g.defaultForce3D||"auto":!1},Ha=_gsScope.SVGElement,Ia=function(a,b,c){var d,e=O.createElementNS("http://www.w3.org/2000/svg",a),f=/([a-z])([A-Z])/g;for(d in c)e.setAttributeNS(null,d.replace(f,"$1-$2").toLowerCase(),c[d]);return b.appendChild(e),e},Ja=O.documentElement||{},Ka=function(){var a,b,c,d=p||/Android/i.test(T)&&!_gsScope.chrome;return O.createElementNS&&!d&&(a=Ia("svg",Ja),b=Ia("rect",a,{width:100,height:50,x:100}),c=b.getBoundingClientRect().width,b.style[Ea]="50% 50%",b.style[Ca]="scaleX(0.5)",d=c===b.getBoundingClientRect().width&&!(n&&Fa),Ja.removeChild(a)),d}(),La=function(a,b,c,d,e,f){var h,i,j,k,l,m,n,o,p,q,r,s,t,u,v=a._gsTransform,w=Qa(a,!0);v&&(t=v.xOrigin,u=v.yOrigin),(!d||(h=d.split(" ")).length<2)&&(n=a.getBBox(),0===n.x&&0===n.y&&n.width+n.height===0&&(n={x:parseFloat(a.hasAttribute("x")?a.getAttribute("x"):a.hasAttribute("cx")?a.getAttribute("cx"):0)||0,y:parseFloat(a.hasAttribute("y")?a.getAttribute("y"):a.hasAttribute("cy")?a.getAttribute("cy"):0)||0,width:0,height:0}),b=ha(b).split(" "),h=[(-1!==b[0].indexOf("%")?parseFloat(b[0])/100*n.width:parseFloat(b[0]))+n.x,(-1!==b[1].indexOf("%")?parseFloat(b[1])/100*n.height:parseFloat(b[1]))+n.y]),c.xOrigin=k=parseFloat(h[0]),c.yOrigin=l=parseFloat(h[1]),d&&w!==Pa&&(m=w[0],n=w[1],o=w[2],p=w[3],q=w[4],r=w[5],s=m*p-n*o,s&&(i=k*(p/s)+l*(-o/s)+(o*r-p*q)/s,j=k*(-n/s)+l*(m/s)-(m*r-n*q)/s,k=c.xOrigin=h[0]=i,l=c.yOrigin=h[1]=j)),v&&(f&&(c.xOffset=v.xOffset,c.yOffset=v.yOffset,v=c),e||e!==!1&&g.defaultSmoothOrigin!==!1?(i=k-t,j=l-u,v.xOffset+=i*w[0]+j*w[2]-i,v.yOffset+=i*w[1]+j*w[3]-j):v.xOffset=v.yOffset=0),f||a.setAttribute("data-svg-origin",h.join(" "))},Ma=function(a){var b,c=P("svg",this.ownerSVGElement&&this.ownerSVGElement.getAttribute("xmlns")||"http://www.w3.org/2000/svg"),d=this.parentNode,e=this.nextSibling,f=this.style.cssText;if(Ja.appendChild(c),c.appendChild(this),this.style.display="block",a)try{b=this.getBBox(),this._originalGetBBox=this.getBBox,this.getBBox=Ma}catch(g){}else this._originalGetBBox&&(b=this._originalGetBBox());return e?d.insertBefore(this,e):d.appendChild(this),Ja.removeChild(c),this.style.cssText=f,b},Na=function(a){try{return a.getBBox()}catch(b){return Ma.call(a,!0)}},Oa=function(a){return!(!Ha||!a.getCTM||a.parentNode&&!a.ownerSVGElement||!Na(a))},Pa=[1,0,0,1,0,0],Qa=function(a,b){var c,d,e,f,g,h,i=a._gsTransform||new Ga,j=1e5,k=a.style;if(Ca?d=_(a,Da,null,!0):a.currentStyle&&(d=a.currentStyle.filter.match(G),d=d&&4===d.length?[d[0].substr(4),Number(d[2].substr(4)),Number(d[1].substr(4)),d[3].substr(4),i.x||0,i.y||0].join(","):""),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,!Ca||!(h=!$(a)||"none"===$(a).display)&&a.parentNode||(h&&(f=k.display,k.display="block"),a.parentNode||(g=1,Ja.appendChild(a)),d=_(a,Da,null,!0),c=!d||"none"===d||"matrix(1, 0, 0, 1, 0, 0)"===d,f?k.display=f:h&&Va(k,"display"),g&&Ja.removeChild(a)),(i.svg||a.getCTM&&Oa(a))&&(c&&-1!==(k[Ca]+"").indexOf("matrix")&&(d=k[Ca],c=0),e=a.getAttribute("transform"),c&&e&&(-1!==e.indexOf("matrix")?(d=e,c=0):-1!==e.indexOf("translate")&&(d="matrix(1,0,0,1,"+e.match(/(?:\-|\b)[\d\-\.e]+\b/gi).join(",")+")",c=0))),c)return Pa;for(e=(d||"").match(s)||[],wa=e.length;--wa>-1;)f=Number(e[wa]),e[wa]=(g=f-(f|=0))?(g*j+(0>g?-.5:.5)|0)/j+f:f;return b&&e.length>6?[e[0],e[1],e[4],e[5],e[12],e[13]]:e},Ra=S.getTransform=function(a,c,d,e){if(a._gsTransform&&d&&!e)return a._gsTransform;var f,h,i,j,k,l,m=d?a._gsTransform||new Ga:new Ga,n=m.scaleX<0,o=2e-5,p=1e5,q=Fa?parseFloat(_(a,Ea,c,!1,"0 0 0").split(" ")[2])||m.zOrigin||0:0,r=parseFloat(g.defaultTransformPerspective)||0;if(m.svg=!(!a.getCTM||!Oa(a)),m.svg&&(La(a,_(a,Ea,c,!1,"50% 50%")+"",m,a.getAttribute("data-svg-origin")),Aa=g.useSVGTransformAttr||Ka),f=Qa(a),f!==Pa){if(16===f.length){var s,t,u,v,w,x=f[0],y=f[1],z=f[2],A=f[3],B=f[4],C=f[5],D=f[6],E=f[7],F=f[8],G=f[9],H=f[10],I=f[12],J=f[13],K=f[14],M=f[11],N=Math.atan2(D,H);m.zOrigin&&(K=-m.zOrigin,I=F*K-f[12],J=G*K-f[13],K=H*K+m.zOrigin-f[14]),m.rotationX=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=B*v+F*w,t=C*v+G*w,u=D*v+H*w,F=B*-w+F*v,G=C*-w+G*v,H=D*-w+H*v,M=E*-w+M*v,B=s,C=t,D=u),N=Math.atan2(-z,H),m.rotationY=N*L,N&&(v=Math.cos(-N),w=Math.sin(-N),s=x*v-F*w,t=y*v-G*w,u=z*v-H*w,G=y*w+G*v,H=z*w+H*v,M=A*w+M*v,x=s,y=t,z=u),N=Math.atan2(y,x),m.rotation=N*L,N&&(v=Math.cos(N),w=Math.sin(N),s=x*v+y*w,t=B*v+C*w,u=F*v+G*w,y=y*v-x*w,C=C*v-B*w,G=G*v-F*w,x=s,B=t,F=u),m.rotationX&&Math.abs(m.rotationX)+Math.abs(m.rotation)>359.9&&(m.rotationX=m.rotation=0,m.rotationY=180-m.rotationY),N=Math.atan2(B,C),m.scaleX=(Math.sqrt(x*x+y*y+z*z)*p+.5|0)/p,m.scaleY=(Math.sqrt(C*C+D*D)*p+.5|0)/p,m.scaleZ=(Math.sqrt(F*F+G*G+H*H)*p+.5|0)/p,x/=m.scaleX,B/=m.scaleY,y/=m.scaleX,C/=m.scaleY,Math.abs(N)>o?(m.skewX=N*L,B=0,"simple"!==m.skewType&&(m.scaleY*=1/Math.cos(N))):m.skewX=0,m.perspective=M?1/(0>M?-M:M):0,m.x=I,m.y=J,m.z=K,m.svg&&(m.x-=m.xOrigin-(m.xOrigin*x-m.yOrigin*B),m.y-=m.yOrigin-(m.yOrigin*y-m.xOrigin*C))}else if(!Fa||e||!f.length||m.x!==f[4]||m.y!==f[5]||!m.rotationX&&!m.rotationY){var O=f.length>=6,P=O?f[0]:1,Q=f[1]||0,R=f[2]||0,S=O?f[3]:1;m.x=f[4]||0,m.y=f[5]||0,i=Math.sqrt(P*P+Q*Q),j=Math.sqrt(S*S+R*R),k=P||Q?Math.atan2(Q,P)*L:m.rotation||0,l=R||S?Math.atan2(R,S)*L+k:m.skewX||0,m.scaleX=i,m.scaleY=j,m.rotation=k,m.skewX=l,Fa&&(m.rotationX=m.rotationY=m.z=0,m.perspective=r,m.scaleZ=1),m.svg&&(m.x-=m.xOrigin-(m.xOrigin*P+m.yOrigin*R),m.y-=m.yOrigin-(m.xOrigin*Q+m.yOrigin*S))}Math.abs(m.skewX)>90&&Math.abs(m.skewX)<270&&(n?(m.scaleX*=-1,m.skewX+=m.rotation<=0?180:-180,m.rotation+=m.rotation<=0?180:-180):(m.scaleY*=-1,m.skewX+=m.skewX<=0?180:-180)),m.zOrigin=q;for(h in m)m[h]<o&&m[h]>-o&&(m[h]=0)}return d&&(a._gsTransform=m,m.svg&&(Aa&&a.style[Ca]?b.delayedCall(.001,function(){Va(a.style,Ca)}):!Aa&&a.getAttribute("transform")&&b.delayedCall(.001,function(){a.removeAttribute("transform")}))),m},Sa=function(a){var b,c,d=this.data,e=-d.rotation*K,f=e+d.skewX*K,g=1e5,h=(Math.cos(e)*d.scaleX*g|0)/g,i=(Math.sin(e)*d.scaleX*g|0)/g,j=(Math.sin(f)*-d.scaleY*g|0)/g,k=(Math.cos(f)*d.scaleY*g|0)/g,l=this.t.style,m=this.t.currentStyle;if(m){c=i,i=-j,j=-c,b=m.filter,l.filter="";var n,o,q=this.t.offsetWidth,r=this.t.offsetHeight,s="absolute"!==m.position,t="progid:DXImageTransform.Microsoft.Matrix(M11="+h+", M12="+i+", M21="+j+", M22="+k,u=d.x+q*d.xPercent/100,v=d.y+r*d.yPercent/100;if(null!=d.ox&&(n=(d.oxp?q*d.ox*.01:d.ox)-q/2,o=(d.oyp?r*d.oy*.01:d.oy)-r/2,u+=n-(n*h+o*i),v+=o-(n*j+o*k)),s?(n=q/2,o=r/2,t+=", Dx="+(n-(n*h+o*i)+u)+", Dy="+(o-(n*j+o*k)+v)+")"):t+=", sizingMethod='auto expand')",-1!==b.indexOf("DXImageTransform.Microsoft.Matrix(")?l.filter=b.replace(H,t):l.filter=t+" "+b,(0===a||1===a)&&1===h&&0===i&&0===j&&1===k&&(s&&-1===t.indexOf("Dx=0, Dy=0")||x.test(b)&&100!==parseFloat(RegExp.$1)||-1===b.indexOf(b.indexOf("Alpha"))&&l.removeAttribute("filter")),!s){var y,z,A,B=8>p?1:-1;for(n=d.ieOffsetX||0,o=d.ieOffsetY||0,d.ieOffsetX=Math.round((q-((0>h?-h:h)*q+(0>i?-i:i)*r))/2+u),d.ieOffsetY=Math.round((r-((0>k?-k:k)*r+(0>j?-j:j)*q))/2+v),wa=0;4>wa;wa++)z=fa[wa],y=m[z],c=-1!==y.indexOf("px")?parseFloat(y):aa(this.t,z,parseFloat(y),y.replace(w,""))||0,A=c!==d[z]?2>wa?-d.ieOffsetX:-d.ieOffsetY:2>wa?n-d.ieOffsetX:o-d.ieOffsetY,l[z]=(d[z]=Math.round(c-A*(0===wa||2===wa?1:B)))+"px"}}},Ta=S.set3DTransformRatio=S.setTransformRatio=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,o,p,q,r,s,t,u,v,w,x,y,z=this.data,A=this.t.style,B=z.rotation,C=z.rotationX,D=z.rotationY,E=z.scaleX,F=z.scaleY,G=z.scaleZ,H=z.x,I=z.y,J=z.z,L=z.svg,M=z.perspective,N=z.force3D,O=z.skewY,P=z.skewX;if(O&&(P+=O,B+=O),((1===a||0===a)&&"auto"===N&&(this.tween._totalTime===this.tween._totalDuration||!this.tween._totalTime)||!N)&&!J&&!M&&!D&&!C&&1===G||Aa&&L||!Fa)return void(B||P||L?(B*=K,x=P*K,y=1e5,c=Math.cos(B)*E,f=Math.sin(B)*E,d=Math.sin(B-x)*-F,g=Math.cos(B-x)*F,x&&"simple"===z.skewType&&(b=Math.tan(x-O*K),b=Math.sqrt(1+b*b),d*=b,g*=b,O&&(b=Math.tan(O*K),b=Math.sqrt(1+b*b),c*=b,f*=b)),L&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset,Aa&&(z.xPercent||z.yPercent)&&(q=this.t.getBBox(),H+=.01*z.xPercent*q.width,I+=.01*z.yPercent*q.height),q=1e-6,q>H&&H>-q&&(H=0),q>I&&I>-q&&(I=0)),u=(c*y|0)/y+","+(f*y|0)/y+","+(d*y|0)/y+","+(g*y|0)/y+","+H+","+I+")",L&&Aa?this.t.setAttribute("transform","matrix("+u):A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+u):A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix(":"matrix(")+E+",0,0,"+F+","+H+","+I+")");if(n&&(q=1e-4,q>E&&E>-q&&(E=G=2e-5),q>F&&F>-q&&(F=G=2e-5),!M||z.z||z.rotationX||z.rotationY||(M=0)),B||P)B*=K,r=c=Math.cos(B),s=f=Math.sin(B),P&&(B-=P*K,r=Math.cos(B),s=Math.sin(B),"simple"===z.skewType&&(b=Math.tan((P-O)*K),b=Math.sqrt(1+b*b),r*=b,s*=b,z.skewY&&(b=Math.tan(O*K),b=Math.sqrt(1+b*b),c*=b,f*=b))),d=-s,g=r;else{if(!(D||C||1!==G||M||L))return void(A[Ca]=(z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) translate3d(":"translate3d(")+H+"px,"+I+"px,"+J+"px)"+(1!==E||1!==F?" scale("+E+","+F+")":""));c=g=1,d=f=0}k=1,e=h=i=j=l=m=0,o=M?-1/M:0,p=z.zOrigin,q=1e-6,v=",",w="0",B=D*K,B&&(r=Math.cos(B),s=Math.sin(B),i=-s,l=o*-s,e=c*s,h=f*s,k=r,o*=r,c*=r,f*=r),B=C*K,B&&(r=Math.cos(B),s=Math.sin(B),b=d*r+e*s,t=g*r+h*s,j=k*s,m=o*s,e=d*-s+e*r,h=g*-s+h*r,k*=r,o*=r,d=b,g=t),1!==G&&(e*=G,h*=G,k*=G,o*=G),1!==F&&(d*=F,g*=F,j*=F,m*=F),1!==E&&(c*=E,f*=E,i*=E,l*=E),(p||L)&&(p&&(H+=e*-p,I+=h*-p,J+=k*-p+p),L&&(H+=z.xOrigin-(z.xOrigin*c+z.yOrigin*d)+z.xOffset,I+=z.yOrigin-(z.xOrigin*f+z.yOrigin*g)+z.yOffset),q>H&&H>-q&&(H=w),q>I&&I>-q&&(I=w),q>J&&J>-q&&(J=0)),u=z.xPercent||z.yPercent?"translate("+z.xPercent+"%,"+z.yPercent+"%) matrix3d(":"matrix3d(",u+=(q>c&&c>-q?w:c)+v+(q>f&&f>-q?w:f)+v+(q>i&&i>-q?w:i),u+=v+(q>l&&l>-q?w:l)+v+(q>d&&d>-q?w:d)+v+(q>g&&g>-q?w:g),C||D||1!==G?(u+=v+(q>j&&j>-q?w:j)+v+(q>m&&m>-q?w:m)+v+(q>e&&e>-q?w:e),u+=v+(q>h&&h>-q?w:h)+v+(q>k&&k>-q?w:k)+v+(q>o&&o>-q?w:o)+v):u+=",0,0,0,0,1,0,",u+=H+v+I+v+J+v+(M?1+-J/M:1)+")",A[Ca]=u};j=Ga.prototype,j.x=j.y=j.z=j.skewX=j.skewY=j.rotation=j.rotationX=j.rotationY=j.zOrigin=j.xPercent=j.yPercent=j.xOffset=j.yOffset=0,j.scaleX=j.scaleY=j.scaleZ=1,ya("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin",{parser:function(a,b,c,d,f,h,i){if(d._lastParsedTransform===i)return f;d._lastParsedTransform=i;var j,k=i.scale&&"function"==typeof i.scale?i.scale:0;"function"==typeof i[c]&&(j=i[c],i[c]=b),k&&(i.scale=k(r,a));var l,m,n,o,p,s,t,u,v,w=a._gsTransform,x=a.style,y=1e-6,z=Ba.length,A=i,B={},C="transformOrigin",D=Ra(a,e,!0,A.parseTransform),E=A.transform&&("function"==typeof A.transform?A.transform(r,q):A.transform);if(D.skewType=A.skewType||D.skewType||g.defaultSkewType,d._transform=D,E&&"string"==typeof E&&Ca)m=Q.style,m[Ca]=E,m.display="block",m.position="absolute",O.body.appendChild(Q),l=Ra(Q,null,!1),"simple"===D.skewType&&(l.scaleY*=Math.cos(l.skewX*K)),D.svg&&(s=D.xOrigin,t=D.yOrigin,l.x-=D.xOffset,l.y-=D.yOffset,(A.transformOrigin||A.svgOrigin)&&(E={},La(a,ha(A.transformOrigin),E,A.svgOrigin,A.smoothOrigin,!0),s=E.xOrigin,t=E.yOrigin,l.x-=E.xOffset-D.xOffset,l.y-=E.yOffset-D.yOffset),(s||t)&&(u=Qa(Q,!0),l.x-=s-(s*u[0]+t*u[2]),l.y-=t-(s*u[1]+t*u[3]))),O.body.removeChild(Q),l.perspective||(l.perspective=D.perspective),null!=A.xPercent&&(l.xPercent=ja(A.xPercent,D.xPercent)),null!=A.yPercent&&(l.yPercent=ja(A.yPercent,D.yPercent));else if("object"==typeof A){if(l={scaleX:ja(null!=A.scaleX?A.scaleX:A.scale,D.scaleX),scaleY:ja(null!=A.scaleY?A.scaleY:A.scale,D.scaleY),scaleZ:ja(A.scaleZ,D.scaleZ),x:ja(A.x,D.x),y:ja(A.y,D.y),z:ja(A.z,D.z),xPercent:ja(A.xPercent,D.xPercent),yPercent:ja(A.yPercent,D.yPercent),perspective:ja(A.transformPerspective,D.perspective)},p=A.directionalRotation,null!=p)if("object"==typeof p)for(m in p)A[m]=p[m];else A.rotation=p;"string"==typeof A.x&&-1!==A.x.indexOf("%")&&(l.x=0,l.xPercent=ja(A.x,D.xPercent)),"string"==typeof A.y&&-1!==A.y.indexOf("%")&&(l.y=0,l.yPercent=ja(A.y,D.yPercent)),l.rotation=ka("rotation"in A?A.rotation:"shortRotation"in A?A.shortRotation+"_short":"rotationZ"in A?A.rotationZ:D.rotation,D.rotation,"rotation",B),Fa&&(l.rotationX=ka("rotationX"in A?A.rotationX:"shortRotationX"in A?A.shortRotationX+"_short":D.rotationX||0,D.rotationX,"rotationX",B),l.rotationY=ka("rotationY"in A?A.rotationY:"shortRotationY"in A?A.shortRotationY+"_short":D.rotationY||0,D.rotationY,"rotationY",B)),l.skewX=ka(A.skewX,D.skewX),l.skewY=ka(A.skewY,D.skewY)}for(Fa&&null!=A.force3D&&(D.force3D=A.force3D,o=!0),n=D.force3D||D.z||D.rotationX||D.rotationY||l.z||l.rotationX||l.rotationY||l.perspective,n||null==A.scale||(l.scaleZ=1);--z>-1;)v=Ba[z],E=l[v]-D[v],(E>y||-y>E||null!=A[v]||null!=M[v])&&(o=!0,f=new ta(D,v,D[v],E,f),v in B&&(f.e=B[v]),f.xs0=0,f.plugin=h,d._overwriteProps.push(f.n));return E=A.transformOrigin,D.svg&&(E||A.svgOrigin)&&(s=D.xOffset,t=D.yOffset,La(a,ha(E),l,A.svgOrigin,A.smoothOrigin),f=ua(D,"xOrigin",(w?D:l).xOrigin,l.xOrigin,f,C),f=ua(D,"yOrigin",(w?D:l).yOrigin,l.yOrigin,f,C),(s!==D.xOffset||t!==D.yOffset)&&(f=ua(D,"xOffset",w?s:D.xOffset,D.xOffset,f,C),f=ua(D,"yOffset",w?t:D.yOffset,D.yOffset,f,C)),E="0px 0px"),(E||Fa&&n&&D.zOrigin)&&(Ca?(o=!0,v=Ea,E=(E||_(a,v,e,!1,"50% 50%"))+"",f=new ta(x,v,0,0,f,-1,C),f.b=x[v],f.plugin=h,Fa?(m=D.zOrigin,E=E.split(" "),D.zOrigin=(E.length>2&&(0===m||"0px"!==E[2])?parseFloat(E[2]):m)||0,f.xs0=f.e=E[0]+" "+(E[1]||"50%")+" 0px",f=new ta(D,"zOrigin",0,0,f,-1,f.n),f.b=m,f.xs0=f.e=D.zOrigin):f.xs0=f.e=E):ha(E+"",D)),o&&(d._transformType=D.svg&&Aa||!n&&3!==this._transformType?2:3),j&&(i[c]=j),k&&(i.scale=k),f},prefix:!0}),ya("boxShadow",{defaultValue:"0px 0px 0px 0px #999",prefix:!0,color:!0,multi:!0,keyword:"inset"}),ya("borderRadius",{defaultValue:"0px",parser:function(a,b,c,f,g,h){b=this.format(b);var i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y=["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],z=a.style;for(q=parseFloat(a.offsetWidth),r=parseFloat(a.offsetHeight),i=b.split(" "),j=0;j<y.length;j++)this.p.indexOf("border")&&(y[j]=Z(y[j])),m=l=_(a,y[j],e,!1,"0px"),-1!==m.indexOf(" ")&&(l=m.split(" "),m=l[0],l=l[1]),n=k=i[j],o=parseFloat(m),t=m.substr((o+"").length),u="="===n.charAt(1),u?(p=parseInt(n.charAt(0)+"1",10),n=n.substr(2),p*=parseFloat(n),s=n.substr((p+"").length-(0>p?1:0))||""):(p=parseFloat(n),s=n.substr((p+"").length)),""===s&&(s=d[c]||t),s!==t&&(v=aa(a,"borderLeft",o,t),w=aa(a,"borderTop",o,t),"%"===s?(m=v/q*100+"%",l=w/r*100+"%"):"em"===s?(x=aa(a,"borderLeft",1,"em"),m=v/x+"em",l=w/x+"em"):(m=v+"px",l=w+"px"),u&&(n=parseFloat(m)+p+s,k=parseFloat(l)+p+s)),g=va(z,y[j],m+" "+l,n+" "+k,!1,"0px",g);return g},prefix:!0,formatter:qa("0px 0px 0px 0px",!1,!0)}),ya("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius",{defaultValue:"0px",parser:function(a,b,c,d,f,g){return va(a.style,c,this.format(_(a,c,e,!1,"0px 0px")),this.format(b),!1,"0px",f)},prefix:!0,formatter:qa("0px 0px",!1,!0)}),ya("backgroundPosition",{defaultValue:"0 0",parser:function(a,b,c,d,f,g){var h,i,j,k,l,m,n="background-position",o=e||$(a,null),q=this.format((o?p?o.getPropertyValue(n+"-x")+" "+o.getPropertyValue(n+"-y"):o.getPropertyValue(n):a.currentStyle.backgroundPositionX+" "+a.currentStyle.backgroundPositionY)||"0 0"),r=this.format(b);if(-1!==q.indexOf("%")!=(-1!==r.indexOf("%"))&&r.split(",").length<2&&(m=_(a,"backgroundImage").replace(D,""),m&&"none"!==m)){for(h=q.split(" "),i=r.split(" "),R.setAttribute("src",m),j=2;--j>-1;)q=h[j],k=-1!==q.indexOf("%"),k!==(-1!==i[j].indexOf("%"))&&(l=0===j?a.offsetWidth-R.width:a.offsetHeight-R.height,h[j]=k?parseFloat(q)/100*l+"px":parseFloat(q)/l*100+"%");q=h.join(" ")}return this.parseComplex(a.style,q,r,f,g)},formatter:ha}),ya("backgroundSize",{defaultValue:"0 0",formatter:function(a){return a+="",ha(-1===a.indexOf(" ")?a+" "+a:a)}}),ya("perspective",{
defaultValue:"0px",prefix:!0}),ya("perspectiveOrigin",{defaultValue:"50% 50%",prefix:!0}),ya("transformStyle",{prefix:!0}),ya("backfaceVisibility",{prefix:!0}),ya("userSelect",{prefix:!0}),ya("margin",{parser:ra("marginTop,marginRight,marginBottom,marginLeft")}),ya("padding",{parser:ra("paddingTop,paddingRight,paddingBottom,paddingLeft")}),ya("clip",{defaultValue:"rect(0px,0px,0px,0px)",parser:function(a,b,c,d,f,g){var h,i,j;return 9>p?(i=a.currentStyle,j=8>p?" ":",",h="rect("+i.clipTop+j+i.clipRight+j+i.clipBottom+j+i.clipLeft+")",b=this.format(b).split(",").join(j)):(h=this.format(_(a,this.p,e,!1,this.dflt)),b=this.format(b)),this.parseComplex(a.style,h,b,f,g)}}),ya("textShadow",{defaultValue:"0px 0px 0px #999",color:!0,multi:!0}),ya("autoRound,strictUnits",{parser:function(a,b,c,d,e){return e}}),ya("border",{defaultValue:"0px solid #000",parser:function(a,b,c,d,f,g){var h=_(a,"borderTopWidth",e,!1,"0px"),i=this.format(b).split(" "),j=i[0].replace(w,"");return"px"!==j&&(h=parseFloat(h)/aa(a,"borderTopWidth",1,j)+j),this.parseComplex(a.style,this.format(h+" "+_(a,"borderTopStyle",e,!1,"solid")+" "+_(a,"borderTopColor",e,!1,"#000")),i.join(" "),f,g)},color:!0,formatter:function(a){var b=a.split(" ");return b[0]+" "+(b[1]||"solid")+" "+(a.match(pa)||["#000"])[0]}}),ya("borderWidth",{parser:ra("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}),ya("float,cssFloat,styleFloat",{parser:function(a,b,c,d,e,f){var g=a.style,h="cssFloat"in g?"cssFloat":"styleFloat";return new ta(g,h,0,0,e,-1,c,!1,0,g[h],b)}});var Ua=function(a){var b,c=this.t,d=c.filter||_(this.data,"filter")||"",e=this.s+this.c*a|0;100===e&&(-1===d.indexOf("atrix(")&&-1===d.indexOf("radient(")&&-1===d.indexOf("oader(")?(c.removeAttribute("filter"),b=!_(this.data,"filter")):(c.filter=d.replace(z,""),b=!0)),b||(this.xn1&&(c.filter=d=d||"alpha(opacity="+e+")"),-1===d.indexOf("pacity")?0===e&&this.xn1||(c.filter=d+" alpha(opacity="+e+")"):c.filter=d.replace(x,"opacity="+e))};ya("opacity,alpha,autoAlpha",{defaultValue:"1",parser:function(a,b,c,d,f,g){var h=parseFloat(_(a,"opacity",e,!1,"1")),i=a.style,j="autoAlpha"===c;return"string"==typeof b&&"="===b.charAt(1)&&(b=("-"===b.charAt(0)?-1:1)*parseFloat(b.substr(2))+h),j&&1===h&&"hidden"===_(a,"visibility",e)&&0!==b&&(h=0),U?f=new ta(i,"opacity",h,b-h,f):(f=new ta(i,"opacity",100*h,100*(b-h),f),f.xn1=j?1:0,i.zoom=1,f.type=2,f.b="alpha(opacity="+f.s+")",f.e="alpha(opacity="+(f.s+f.c)+")",f.data=a,f.plugin=g,f.setRatio=Ua),j&&(f=new ta(i,"visibility",0,0,f,-1,null,!1,0,0!==h?"inherit":"hidden",0===b?"hidden":"inherit"),f.xs0="inherit",d._overwriteProps.push(f.n),d._overwriteProps.push(c)),f}});var Va=function(a,b){b&&(a.removeProperty?(("ms"===b.substr(0,2)||"webkit"===b.substr(0,6))&&(b="-"+b),a.removeProperty(b.replace(B,"-$1").toLowerCase())):a.removeAttribute(b))},Wa=function(a){if(this.t._gsClassPT=this,1===a||0===a){this.t.setAttribute("class",0===a?this.b:this.e);for(var b=this.data,c=this.t.style;b;)b.v?c[b.p]=b.v:Va(c,b.p),b=b._next;1===a&&this.t._gsClassPT===this&&(this.t._gsClassPT=null)}else this.t.getAttribute("class")!==this.e&&this.t.setAttribute("class",this.e)};ya("className",{parser:function(a,b,d,f,g,h,i){var j,k,l,m,n,o=a.getAttribute("class")||"",p=a.style.cssText;if(g=f._classNamePT=new ta(a,d,0,0,g,2),g.setRatio=Wa,g.pr=-11,c=!0,g.b=o,k=ca(a,e),l=a._gsClassPT){for(m={},n=l.data;n;)m[n.p]=1,n=n._next;l.setRatio(1)}return a._gsClassPT=g,g.e="="!==b.charAt(1)?b:o.replace(new RegExp("(?:\\s|^)"+b.substr(2)+"(?![\\w-])"),"")+("+"===b.charAt(0)?" "+b.substr(2):""),a.setAttribute("class",g.e),j=da(a,k,ca(a),i,m),a.setAttribute("class",o),g.data=j.firstMPT,a.style.cssText=p,g=g.xfirst=f.parse(a,j.difs,g,h)}});var Xa=function(a){if((1===a||0===a)&&this.data._totalTime===this.data._totalDuration&&"isFromStart"!==this.data.data){var b,c,d,e,f,g=this.t.style,h=i.transform.parse;if("all"===this.e)g.cssText="",e=!0;else for(b=this.e.split(" ").join("").split(","),d=b.length;--d>-1;)c=b[d],i[c]&&(i[c].parse===h?e=!0:c="transformOrigin"===c?Ea:i[c].p),Va(g,c);e&&(Va(g,Ca),f=this.t._gsTransform,f&&(f.svg&&(this.t.removeAttribute("data-svg-origin"),this.t.removeAttribute("transform")),delete this.t._gsTransform))}};for(ya("clearProps",{parser:function(a,b,d,e,f){return f=new ta(a,d,0,0,f,2),f.setRatio=Xa,f.e=b,f.pr=-10,f.data=e._tween,c=!0,f}}),j="bezier,throwProps,physicsProps,physics2D".split(","),wa=j.length;wa--;)za(j[wa]);j=g.prototype,j._firstPT=j._lastParsedTransform=j._transform=null,j._onInitTween=function(a,b,h,j){if(!a.nodeType)return!1;this._target=q=a,this._tween=h,this._vars=b,r=j,k=b.autoRound,c=!1,d=b.suffixMap||g.suffixMap,e=$(a,""),f=this._overwriteProps;var n,p,s,t,u,v,w,x,z,A=a.style;if(l&&""===A.zIndex&&(n=_(a,"zIndex",e),("auto"===n||""===n)&&this._addLazySet(A,"zIndex",0)),"string"==typeof b&&(t=A.cssText,n=ca(a,e),A.cssText=t+";"+b,n=da(a,n,ca(a)).difs,!U&&y.test(b)&&(n.opacity=parseFloat(RegExp.$1)),b=n,A.cssText=t),b.className?this._firstPT=p=i.className.parse(a,b.className,"className",this,null,null,b):this._firstPT=p=this.parse(a,b,null),this._transformType){for(z=3===this._transformType,Ca?m&&(l=!0,""===A.zIndex&&(w=_(a,"zIndex",e),("auto"===w||""===w)&&this._addLazySet(A,"zIndex",0)),o&&this._addLazySet(A,"WebkitBackfaceVisibility",this._vars.WebkitBackfaceVisibility||(z?"visible":"hidden"))):A.zoom=1,s=p;s&&s._next;)s=s._next;x=new ta(a,"transform",0,0,null,2),this._linkCSSP(x,null,s),x.setRatio=Ca?Ta:Sa,x.data=this._transform||Ra(a,e,!0),x.tween=h,x.pr=-1,f.pop()}if(c){for(;p;){for(v=p._next,s=t;s&&s.pr>p.pr;)s=s._next;(p._prev=s?s._prev:u)?p._prev._next=p:t=p,(p._next=s)?s._prev=p:u=p,p=v}this._firstPT=t}return!0},j.parse=function(a,b,c,f){var g,h,j,l,m,n,o,p,s,t,u=a.style;for(g in b){if(n=b[g],"function"==typeof n&&(n=n(r,q)),h=i[g])c=h.parse(a,n,g,this,c,f,b);else{if("--"===g.substr(0,2)){this._tween._propLookup[g]=this._addTween.call(this._tween,a.style,"setProperty",$(a).getPropertyValue(g)+"",n+"",g,!1,g);continue}m=_(a,g,e)+"",s="string"==typeof n,"color"===g||"fill"===g||"stroke"===g||-1!==g.indexOf("Color")||s&&A.test(n)?(s||(n=na(n),n=(n.length>3?"rgba(":"rgb(")+n.join(",")+")"),c=va(u,g,m,n,!0,"transparent",c,0,f)):s&&J.test(n)?c=va(u,g,m,n,!0,null,c,0,f):(j=parseFloat(m),o=j||0===j?m.substr((j+"").length):"",(""===m||"auto"===m)&&("width"===g||"height"===g?(j=ga(a,g,e),o="px"):"left"===g||"top"===g?(j=ba(a,g,e),o="px"):(j="opacity"!==g?0:1,o="")),t=s&&"="===n.charAt(1),t?(l=parseInt(n.charAt(0)+"1",10),n=n.substr(2),l*=parseFloat(n),p=n.replace(w,"")):(l=parseFloat(n),p=s?n.replace(w,""):""),""===p&&(p=g in d?d[g]:o),n=l||0===l?(t?l+j:l)+p:b[g],o!==p&&(""!==p||"lineHeight"===g)&&(l||0===l)&&j&&(j=aa(a,g,j,o),"%"===p?(j/=aa(a,g,100,"%")/100,b.strictUnits!==!0&&(m=j+"%")):"em"===p||"rem"===p||"vw"===p||"vh"===p?j/=aa(a,g,1,p):"px"!==p&&(l=aa(a,g,l,p),p="px"),t&&(l||0===l)&&(n=l+j+p)),t&&(l+=j),!j&&0!==j||!l&&0!==l?void 0!==u[g]&&(n||n+""!="NaN"&&null!=n)?(c=new ta(u,g,l||j||0,0,c,-1,g,!1,0,m,n),c.xs0="none"!==n||"display"!==g&&-1===g.indexOf("Style")?n:m):W("invalid "+g+" tween value: "+b[g]):(c=new ta(u,g,j,l-j,c,0,g,k!==!1&&("px"===p||"zIndex"===g),0,m,n),c.xs0=p))}f&&c&&!c.plugin&&(c.plugin=f)}return c},j.setRatio=function(a){var b,c,d,e=this._firstPT,f=1e-6;if(1!==a||this._tween._time!==this._tween._duration&&0!==this._tween._time)if(a||this._tween._time!==this._tween._duration&&0!==this._tween._time||this._tween._rawPrevTime===-1e-6)for(;e;){if(b=e.c*a+e.s,e.r?b=Math.round(b):f>b&&b>-f&&(b=0),e.type)if(1===e.type)if(d=e.l,2===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2;else if(3===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3;else if(4===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4;else if(5===d)e.t[e.p]=e.xs0+b+e.xs1+e.xn1+e.xs2+e.xn2+e.xs3+e.xn3+e.xs4+e.xn4+e.xs5;else{for(c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}else-1===e.type?e.t[e.p]=e.xs0:e.setRatio&&e.setRatio(a);else e.t[e.p]=b+e.xs0;e=e._next}else for(;e;)2!==e.type?e.t[e.p]=e.b:e.setRatio(a),e=e._next;else for(;e;){if(2!==e.type)if(e.r&&-1!==e.type)if(b=Math.round(e.s+e.c),e.type){if(1===e.type){for(d=e.l,c=e.xs0+b+e.xs1,d=1;d<e.l;d++)c+=e["xn"+d]+e["xs"+(d+1)];e.t[e.p]=c}}else e.t[e.p]=b+e.xs0;else e.t[e.p]=e.e;else e.setRatio(a);e=e._next}},j._enableTransforms=function(a){this._transform=this._transform||Ra(this._target,e,!0),this._transformType=this._transform.svg&&Aa||!a&&3!==this._transformType?2:3};var Ya=function(a){this.t[this.p]=this.e,this.data._linkCSSP(this,this._next,null,!0)};j._addLazySet=function(a,b,c){var d=this._firstPT=new ta(a,b,0,0,this._firstPT,2);d.e=c,d.setRatio=Ya,d.data=this},j._linkCSSP=function(a,b,c,d){return a&&(b&&(b._prev=a),a._next&&(a._next._prev=a._prev),a._prev?a._prev._next=a._next:this._firstPT===a&&(this._firstPT=a._next,d=!0),c?c._next=a:d||null!==this._firstPT||(this._firstPT=a),a._next=b,a._prev=c),a},j._mod=function(a){for(var b=this._firstPT;b;)"function"==typeof a[b.p]&&a[b.p]===Math.round&&(b.r=1),b=b._next},j._kill=function(b){var c,d,e,f=b;if(b.autoAlpha||b.alpha){f={};for(d in b)f[d]=b[d];f.opacity=1,f.autoAlpha&&(f.visibility=1)}for(b.className&&(c=this._classNamePT)&&(e=c.xfirst,e&&e._prev?this._linkCSSP(e._prev,c._next,e._prev._prev):e===this._firstPT&&(this._firstPT=c._next),c._next&&this._linkCSSP(c._next,c._next._next,e._prev),this._classNamePT=null),c=this._firstPT;c;)c.plugin&&c.plugin!==d&&c.plugin._kill&&(c.plugin._kill(b),d=c.plugin),c=c._next;return a.prototype._kill.call(this,f)};var Za=function(a,b,c){var d,e,f,g;if(a.slice)for(e=a.length;--e>-1;)Za(a[e],b,c);else for(d=a.childNodes,e=d.length;--e>-1;)f=d[e],g=f.type,f.style&&(b.push(ca(f)),c&&c.push(f)),1!==g&&9!==g&&11!==g||!f.childNodes.length||Za(f,b,c)};return g.cascadeTo=function(a,c,d){var e,f,g,h,i=b.to(a,c,d),j=[i],k=[],l=[],m=[],n=b._internals.reservedProps;for(a=i._targets||i.target,Za(a,k,m),i.render(c,!0,!0),Za(a,l),i.render(0,!0,!0),i._enabled(!0),e=m.length;--e>-1;)if(f=da(m[e],k[e],l[e]),f.firstMPT){f=f.difs;for(g in d)n[g]&&(f[g]=d[g]);h={};for(g in f)h[g]=k[e][g];j.push(b.fromTo(m[e],c,h,f))}return j},a.activate([g]),g},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(a){"use strict";var b=function(){return(_gsScope.GreenSockGlobals||_gsScope)[a]};"undefined"!=typeof module&&module.exports?(__webpack_require__(247),module.exports=b()):"function"=="function"&&__webpack_require__(240)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(247)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}("CSSPlugin");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 1.15.6
 * DATE: 2017-06-19
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("easing.Back",["easing.Ease"],function(a){var b,c,d,e=_gsScope.GreenSockGlobals||_gsScope,f=e.com.greensock,g=2*Math.PI,h=Math.PI/2,i=f._class,j=function(b,c){var d=i("easing."+b,function(){},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,d},k=a.register||function(){},l=function(a,b,c,d,e){var f=i("easing."+a,{easeOut:new b,easeIn:new c,easeInOut:new d},!0);return k(f,a),f},m=function(a,b,c){this.t=a,this.v=b,c&&(this.next=c,c.prev=this,this.c=c.v-b,this.gap=c.t-a)},n=function(b,c){var d=i("easing."+b,function(a){this._p1=a||0===a?a:1.70158,this._p2=1.525*this._p1},!0),e=d.prototype=new a;return e.constructor=d,e.getRatio=c,e.config=function(a){return new d(a)},d},o=l("Back",n("BackOut",function(a){return(a-=1)*a*((this._p1+1)*a+this._p1)+1}),n("BackIn",function(a){return a*a*((this._p1+1)*a-this._p1)}),n("BackInOut",function(a){return(a*=2)<1?.5*a*a*((this._p2+1)*a-this._p2):.5*((a-=2)*a*((this._p2+1)*a+this._p2)+2)})),p=i("easing.SlowMo",function(a,b,c){b=b||0===b?b:.7,null==a?a=.7:a>1&&(a=1),this._p=1!==a?b:0,this._p1=(1-a)/2,this._p2=a,this._p3=this._p1+this._p2,this._calcEnd=c===!0},!0),q=p.prototype=new a;return q.constructor=p,q.getRatio=function(a){var b=a+(.5-a)*this._p;return a<this._p1?this._calcEnd?1-(a=1-a/this._p1)*a:b-(a=1-a/this._p1)*a*a*a*b:a>this._p3?this._calcEnd?1===a?0:1-(a=(a-this._p3)/this._p1)*a:b+(a-b)*(a=(a-this._p3)/this._p1)*a*a*a:this._calcEnd?1:b},p.ease=new p(.7,.7),q.config=p.config=function(a,b,c){return new p(a,b,c)},b=i("easing.SteppedEase",function(a,b){a=a||1,this._p1=1/a,this._p2=a+(b?0:1),this._p3=b?1:0},!0),q=b.prototype=new a,q.constructor=b,q.getRatio=function(a){return 0>a?a=0:a>=1&&(a=.999999999),((this._p2*a|0)+this._p3)*this._p1},q.config=b.config=function(a,c){return new b(a,c)},c=i("easing.RoughEase",function(b){b=b||{};for(var c,d,e,f,g,h,i=b.taper||"none",j=[],k=0,l=0|(b.points||20),n=l,o=b.randomize!==!1,p=b.clamp===!0,q=b.template instanceof a?b.template:null,r="number"==typeof b.strength?.4*b.strength:.4;--n>-1;)c=o?Math.random():1/l*n,d=q?q.getRatio(c):c,"none"===i?e=r:"out"===i?(f=1-c,e=f*f*r):"in"===i?e=c*c*r:.5>c?(f=2*c,e=f*f*.5*r):(f=2*(1-c),e=f*f*.5*r),o?d+=Math.random()*e-.5*e:n%2?d+=.5*e:d-=.5*e,p&&(d>1?d=1:0>d&&(d=0)),j[k++]={x:c,y:d};for(j.sort(function(a,b){return a.x-b.x}),h=new m(1,1,null),n=l;--n>-1;)g=j[n],h=new m(g.x,g.y,h);this._prev=new m(0,0,0!==h.t?h:h.next)},!0),q=c.prototype=new a,q.constructor=c,q.getRatio=function(a){var b=this._prev;if(a>b.t){for(;b.next&&a>=b.t;)b=b.next;b=b.prev}else for(;b.prev&&a<=b.t;)b=b.prev;return this._prev=b,b.v+(a-b.t)/b.gap*b.c},q.config=function(a){return new c(a)},c.ease=new c,l("Bounce",j("BounceOut",function(a){return 1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375}),j("BounceIn",function(a){return(a=1-a)<1/2.75?1-7.5625*a*a:2/2.75>a?1-(7.5625*(a-=1.5/2.75)*a+.75):2.5/2.75>a?1-(7.5625*(a-=2.25/2.75)*a+.9375):1-(7.5625*(a-=2.625/2.75)*a+.984375)}),j("BounceInOut",function(a){var b=.5>a;return a=b?1-2*a:2*a-1,a=1/2.75>a?7.5625*a*a:2/2.75>a?7.5625*(a-=1.5/2.75)*a+.75:2.5/2.75>a?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375,b?.5*(1-a):.5*a+.5})),l("Circ",j("CircOut",function(a){return Math.sqrt(1-(a-=1)*a)}),j("CircIn",function(a){return-(Math.sqrt(1-a*a)-1)}),j("CircInOut",function(a){return(a*=2)<1?-.5*(Math.sqrt(1-a*a)-1):.5*(Math.sqrt(1-(a-=2)*a)+1)})),d=function(b,c,d){var e=i("easing."+b,function(a,b){this._p1=a>=1?a:1,this._p2=(b||d)/(1>a?a:1),this._p3=this._p2/g*(Math.asin(1/this._p1)||0),this._p2=g/this._p2},!0),f=e.prototype=new a;return f.constructor=e,f.getRatio=c,f.config=function(a,b){return new e(a,b)},e},l("Elastic",d("ElasticOut",function(a){return this._p1*Math.pow(2,-10*a)*Math.sin((a-this._p3)*this._p2)+1},.3),d("ElasticIn",function(a){return-(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2))},.3),d("ElasticInOut",function(a){return(a*=2)<1?-.5*(this._p1*Math.pow(2,10*(a-=1))*Math.sin((a-this._p3)*this._p2)):this._p1*Math.pow(2,-10*(a-=1))*Math.sin((a-this._p3)*this._p2)*.5+1},.45)),l("Expo",j("ExpoOut",function(a){return 1-Math.pow(2,-10*a)}),j("ExpoIn",function(a){return Math.pow(2,10*(a-1))-.001}),j("ExpoInOut",function(a){return(a*=2)<1?.5*Math.pow(2,10*(a-1)):.5*(2-Math.pow(2,-10*(a-1)))})),l("Sine",j("SineOut",function(a){return Math.sin(a*h)}),j("SineIn",function(a){return-Math.cos(a*h)+1}),j("SineInOut",function(a){return-.5*(Math.cos(Math.PI*a)-1)})),i("easing.EaseLookup",{find:function(b){return a.map[b]}},!0),k(e.SlowMo,"SlowMo","ease,"),k(c,"RoughEase","ease,"),k(b,"SteppedEase","ease,"),o},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(){"use strict";var a=function(){return _gsScope.GreenSockGlobals||_gsScope};"undefined"!=typeof module&&module.exports?(__webpack_require__(247),module.exports=a()):"function"=="function"&&__webpack_require__(240)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(247)], __WEBPACK_AMD_DEFINE_FACTORY__ = (a),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationController = __webpack_require__(174);
    var Preconditions = __webpack_require__(14);

    /**
     * The animation controller for a slide animation.
     *
     * @class SlideOutAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.OUTRO, // We're sliding out, hence "outro"

        descriptor: function descriptor() {
            var appearanceDescriptor = this.getAppearanceDescriptor();
            var scaledExperienceSize = this.unscaledExperienceSize.scale(appearanceDescriptor.scale);
            var stylingRect = appearanceDescriptor.styling;
            var toPoint = {};
            var direction = this.animationModel.get("direction");

            switch (direction) {
                case "top":
                    toPoint.y = -this.elementBounds.height - Math.max(0, stylingRect.height + stylingRect.y);
                    break;

                case "left":
                    toPoint.x = -this.elementBounds.width - Math.max(0, stylingRect.width + stylingRect.x);
                    break;

                case "bottom":
                    toPoint.y = scaledExperienceSize.height + appearanceDescriptor.pivotOffset.height + Math.max(0, stylingRect.height - stylingRect.y);
                    break;

                case "right":
                    toPoint.x = scaledExperienceSize.width + appearanceDescriptor.pivotOffset.width + Math.max(0, stylingRect.width - stylingRect.x);
                    break;

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Direction '" + direction + "' not recognized.");
                    break;
            }

            return {
                to: toPoint
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationController = __webpack_require__(174);

    /**
     * The animation controller for fade.
     *
     * @class FadeAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.INTRO, // We're fading from 0 to 1.0, hence "intro"

        descriptor: function descriptor() {
            // Describe the animation - fade from 0 to target opacity...
            return {
                fromTo: [{ opacity: 0 }, { opacity: this.widgetModel.get("opacity") || 1.0 }]
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationController = __webpack_require__(174);

    /**
     * The animation controller for fading out.
     *
     * @class FadeOutAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.OUTRO, // We're fading to 0.0, hence "outro"

        descriptor: function descriptor() {
            return {
                to: { opacity: 0 }
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationController = __webpack_require__(174);

    /**
     * The animation controller for zoom in.
     *
     * @class ZoomInAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.INTRO, // We're scaling from 0 to 1.0, hence "intro"

        descriptor: function descriptor() {
            return {
                fromTo: [{ scale: 0 }, { scale: 1 }]
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationController = __webpack_require__(174);

    /**
     * The animation controller for zoom in.
     *
     * @class ZoomInAnimationController
     * @constructor
     */
    return AnimationController.extend({

        /**
         * @inheritDoc
         */
        type: AnimationController.Type.OUTRO, // We're scaling to 0.0, hence "outro"

        descriptor: function descriptor() {
            return {
                to: { scale: 0 }
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationController = __webpack_require__(174);

    /**
     * The animation controller for a move animation.
     *
     * @class MoveAnimationController
     * @constructor
     */
    return AnimationController.extend({
        descriptor: function descriptor() {
            var appearanceDescriptor = this.getAppearanceDescriptor();
            var fromPoint = appearanceDescriptor.position;
            var horizontalMove = this.animationModel.get("horizontalMove") * appearanceDescriptor.scale.x;
            var verticalMove = this.animationModel.get("verticalMove") * appearanceDescriptor.scale.y;

            return {
                to: {
                    x: fromPoint.x + horizontalMove * this.unscaledExperienceSize.width / 100,
                    y: fromPoint.y + verticalMove * this.unscaledExperienceSize.height / 100
                }
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Marionette = __webpack_require__(10);
    var Browser = __webpack_require__(39);
    var EffectModel = __webpack_require__(78);
    var AnimationController = __webpack_require__(174);
    var Effects = __webpack_require__(1437);
    var _throttle = __webpack_require__(1446);

    var STATE = {
        Hover: "hover",
        Attention: "attention"
    };

    /**
     * Responsible for managing/controlling the effects associated with a widget view.
     *
     * Handles the <tt>mouseover</tt> and <tt>mouseout</tt> events, playing any needed effects.
     *
     * Only a single hover and/or a single attention effect is supported for now.
     *
     * @class EffectController
     */
    var EffectController = Marionette.Controller.extend({

        _active: false,

        _state: STATE.Attention,

        _mouseMoveEventHandler: null,
        /**
         * @type {AbstractWidgetView}
         */
        _widgetView: null,

        /**
         * @type {jQueryElement}
         */
        _element: null,

        _hoverEffect: null,

        _attentionEffect: null,

        _animationControllers: null,

        /**
         * Constructor.
         *
         * @param  {AbstractWidgetView} widgetView The associated widget view.
         *
         * @param  {AnimationController[]} animationControllers Array of possible associated animation
         *                                                      controllers - hover effects are not allowed while
         *                                                      transitions are considered active.
         */
        constructor: function constructor(widgetView, animationControllers) {
            var _this = this;

            this._widgetView = widgetView;
            this._element = widgetView.$el;

            var effectCollection = this._widgetView.model.get("effects");

            this._createEffects(effectCollection);
            this._animationControllers = animationControllers || [];

            _.bindAll(this, "_mouseOverHandler", "_mouseOutHandler");
            // Listen for hover related events if needed
            if (effectCollection.hasTriggerType(EffectModel.TRIGGER_TYPE_HOVER) && Browser.capabilities.isMouseEventsSupported) {
                this._mouseMoveEventHandler = document.getElementsByClassName("experience-viewer")[0].addEventListener("mousemove", _throttle(function (e) {
                    return _this._handleOnHover(e);
                }));
            }
        },
        _handleOnHover: function _handleOnHover(e) {
            var widgetCoords = this._element[0].getBoundingClientRect();
            var clientX = e.clientX,
                clientY = e.clientY;
            var x = widgetCoords.x,
                y = widgetCoords.y,
                width = widgetCoords.width,
                height = widgetCoords.height;

            if (clientX >= x && clientX <= x + width) {
                if (clientY >= y && clientY <= y + height) {
                    this._mouseOverHandler();

                    return;
                }
            }

            this._mouseOutHandler();
        },
        setActive: function setActive(value) {
            if (this._active === value) {
                return;
            }

            this._active = value;

            this._updateToActiveState();
        },
        dispose: function dispose() {
            if (this._mouseMoveEventHandler) {
                this._mouseMoveEventHandler.off("mousemove", this._handleOnHover);
            }

            if (this._hoverEffect) {
                this._hoverEffect.kill();
            }

            if (this._attentionEffect) {
                this._attentionEffect.kill();
            }
        },
        _mouseOverHandler: function _mouseOverHandler() {
            // Ignore the hover state if a transition is active or before an intro transition or after
            // an outro transition.
            if (this._hasActiveTransitions() || this._isPreIntroTransition() || this._isPostOutroTransition()) {
                return;
            }

            this._setState(STATE.Hover);
        },
        _mouseOutHandler: function _mouseOutHandler() {
            this._setState(STATE.Attention);
        },
        _createEffects: function _createEffects(effectCollection) {
            var hoverEffectModel = effectCollection.firstByTriggerType(EffectModel.TRIGGER_TYPE_HOVER);
            var attentionEffectModel = effectCollection.firstByTriggerType(EffectModel.TRIGGER_TYPE_ATTENTION);

            if (hoverEffectModel) {
                this._hoverEffect = Effects.createFromModel(this._widgetView, hoverEffectModel);
            }

            if (attentionEffectModel) {
                this._attentionEffect = Effects.createFromModel(this._widgetView, attentionEffectModel);
            }
        },


        /**
         * @private
         *
         * Whether any (widget) transitions are currently active.
         *
         * @return {Boolean} <tt>true</tt> if there's any active transitions.
         * @see  AnimationController#isActive
         */
        _hasActiveTransitions: function _hasActiveTransitions() {
            var i = this._animationControllers.length;
            var controller = void 0;

            while (i--) {
                controller = this._animationControllers[i];

                if (controller.isActive()) {
                    return true;
                }
            }

            return false;
        },


        /**
         * @private
         *
         * Whether the first transition in the list of transitions is currently in a delay state/phase
         * and is of type "intro", i.e. <tt>AnimationController.Type.INTRO</tt>.
         *
         * @return {Boolean} <tt>true</tt> if an "intro" transition is currently in a delay state/phase.
         *
         * @see  AnimationController#isRunning
         * @see  AnimationController#type
         */
        _isPreIntroTransition: function _isPreIntroTransition() {
            var introTransition = _.first(this._animationControllers);

            return introTransition && introTransition.isRunning() && introTransition.type === AnimationController.Type.INTRO && !introTransition.isActive();
        },


        /**
         * @private
         *
         * Whether the last transition in the list of transitions has completed
         * and is of type "outro", i.e. <tt>AnimationController.Type.OUTRO</tt>.
         *
         * @return {Boolean} <tt>true</tt> if an "outro" transition is has completed.
         *
         * @see  AnimationController#isComplete
         * @see  AnimationController#type
         */
        _isPostOutroTransition: function _isPostOutroTransition() {
            var outroTransition = _.last(this._animationControllers);

            return outroTransition && outroTransition.isComplete() && outroTransition.type === AnimationController.Type.OUTRO;
        },
        _setState: function _setState(value) {
            if (this._state === value) {
                return;
            }

            this._state = value;

            this._updateToState();
        },
        _getEffect: function _getEffect() {
            if (this._state === STATE.Attention) {
                return this._attentionEffect;
            }

            return this._hoverEffect;
        },
        _playEffect: function _playEffect() {
            this._currentEffect = this._getEffect();
            if (this._currentEffect) {
                this._currentEffect.play();
            }
        },
        _updateToState: function _updateToState() {
            var _this2 = this;

            if (this._currentEffect) {
                this._currentEffect.finish().done(function () {
                    _this2._playEffect();
                });
            } else {
                this._playEffect();
            }
        },
        _updateToActiveState: function _updateToActiveState() {
            if (this._active) {
                this._updateToState();
            } else {
                if (this._attentionEffect) {
                    this._attentionEffect.stop();
                }

                if (this._hoverEffect) {
                    this._hoverEffect.stop();
                }
            }
        }
    }, {
        STATE: STATE
    });

    return EffectController;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Enum = __webpack_require__(77);
    var OpacityEffect = __webpack_require__(770);
    var OpacityEffectModel = __webpack_require__(245);
    var ScaleEffect = __webpack_require__(1439);
    var ScaleEffectModel = __webpack_require__(499);
    var RotateEffect = __webpack_require__(1440);
    var RotateEffectModel = __webpack_require__(359);
    var PulseEffect = __webpack_require__(1441);
    var PulseEffectModel = __webpack_require__(500);
    var ImageToggleEffect = __webpack_require__(1442);
    var ImageToggleEffectModel = __webpack_require__(301);

    // Create the backing map like this because we reuse keys from the EffectModel enum...
    var map = {};

    map[OpacityEffectModel.TYPE] = OpacityEffect;
    map[ScaleEffectModel.TYPE] = ScaleEffect;
    map[RotateEffectModel.TYPE] = RotateEffect;
    map[PulseEffectModel.TYPE] = PulseEffect;
    map[ImageToggleEffectModel.TYPE] = ImageToggleEffect;

    /**
     * A enum describing all effect types, not effect models, where each type can have numerous instances. <p>
     *
     * The returned enum will index each effect type via the static defined <tt>TYPE</tt> property in the
     * corresponding <tt>EffectModel</tt> type, e.g. {.., ScaleEffectModel.TYPE: ScaleEffect, ..}, where the described
     * value of the key in this example is "scale". <p>
     *
     * To create a new effect based on an effect model, simply do:
     * <pre>
     *    ..
     *    var someEffectModel = ..; // effect model in question
     *    var element         = ..; // dom element in question
     *
     *    var effectInstance = Effects.createFromModel(someEffectModel, element);
     *    // Use effect, e.g. call "play" or whatever...
     *    effectInstance.play()
     *    ..
     * </pre>
     */
    var Effects = Enum.create("Effect", map, {

        /**
         * Returns a new effect instance backed by the supplied effect model and dom element.
         *
         * @param   {AbstractWidgetView} widgetView The associated widget view; cannot be falsey.
         * @param   {EffectModel} model   The effect model to back the created effect; cannot be falsey.
         *
         * @returns {Effect} The corresponding effect instance, backed by <tt>model</tt>; never falsey.
         * @throws  {Error}  If no such effect exist or it cannot be created for what ever reason.
         */
        createFromModel: function createFromModel(widgetView, model) {
            var EffectType = Effects.lookup(model.get("type"));
            return new EffectType(widgetView, model);
        }
    });

    return Effects;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * VERSION: 1.20.3
 * DATE: 2017-10-02
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 */
var _gsScope="undefined"!=typeof module&&module.exports&&"undefined"!=typeof global?global:this||window;(_gsScope._gsQueue||(_gsScope._gsQueue=[])).push(function(){"use strict";_gsScope._gsDefine("TimelineMax",["TimelineLite","TweenLite","easing.Ease"],function(a,b,c){var d=function(b){a.call(this,b),this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._cycle=0,this._yoyo=this.vars.yoyo===!0,this._dirty=!0},e=1e-10,f=b._internals,g=f.lazyTweens,h=f.lazyRender,i=_gsScope._gsDefine.globals,j=new c(null,null,1,0),k=d.prototype=new a;return k.constructor=d,k.kill()._gc=!1,d.version="1.20.3",k.invalidate=function(){return this._yoyo=this.vars.yoyo===!0,this._repeat=this.vars.repeat||0,this._repeatDelay=this.vars.repeatDelay||0,this._uncache(!0),a.prototype.invalidate.call(this)},k.addCallback=function(a,c,d,e){return this.add(b.delayedCall(0,a,d,e),c)},k.removeCallback=function(a,b){if(a)if(null==b)this._kill(null,a);else for(var c=this.getTweensOf(a,!1),d=c.length,e=this._parseTimeOrLabel(b);--d>-1;)c[d]._startTime===e&&c[d]._enabled(!1,!1);return this},k.removePause=function(b){return this.removeCallback(a._internals.pauseCallback,b)},k.tweenTo=function(a,c){c=c||{};var d,e,f,g={ease:j,useFrames:this.usesFrames(),immediateRender:!1},h=c.repeat&&i.TweenMax||b;for(e in c)g[e]=c[e];return g.time=this._parseTimeOrLabel(a),d=Math.abs(Number(g.time)-this._time)/this._timeScale||.001,f=new h(this,d,g),g.onStart=function(){f.target.paused(!0),f.vars.time!==f.target.time()&&d===f.duration()&&f.duration(Math.abs(f.vars.time-f.target.time())/f.target._timeScale),c.onStart&&c.onStart.apply(c.onStartScope||c.callbackScope||f,c.onStartParams||[])},f},k.tweenFromTo=function(a,b,c){c=c||{},a=this._parseTimeOrLabel(a),c.startAt={onComplete:this.seek,onCompleteParams:[a],callbackScope:this},c.immediateRender=c.immediateRender!==!1;var d=this.tweenTo(b,c);return d.duration(Math.abs(d.vars.time-a)/this._timeScale||.001)},k.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,i,j,k,l,m,n,o=this._time,p=this._dirty?this.totalDuration():this._totalDuration,q=this._duration,r=this._totalTime,s=this._startTime,t=this._timeScale,u=this._rawPrevTime,v=this._paused,w=this._cycle;if(o!==this._time&&(a+=this._time-o),a>=p-1e-7&&a>=0)this._locked||(this._totalTime=p,this._cycle=this._repeat),this._reversed||this._hasPausedChild()||(f=!0,j="onComplete",k=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||0>u||u===e)&&u!==a&&this._first&&(k=!0,u>e&&(j="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,this._yoyo&&0!==(1&this._cycle)?this._time=a=0:(this._time=q,a=q+1e-4);else if(1e-7>a)if(this._locked||(this._totalTime=this._cycle=0),this._time=0,(0!==o||0===q&&u!==e&&(u>0||0>a&&u>=0)&&!this._locked)&&(j="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(k=f=!0,j="onReverseComplete"):u>=0&&this._first&&(k=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=q||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(k=!0)}else if(0===q&&0>u&&(k=!0),this._time=this._rawPrevTime=a,this._locked||(this._totalTime=a,0!==this._repeat&&(l=q+this._repeatDelay,this._cycle=this._totalTime/l>>0,0!==this._cycle&&this._cycle===this._totalTime/l&&a>=r&&this._cycle--,this._time=this._totalTime-this._cycle*l,this._yoyo&&0!==(1&this._cycle)&&(this._time=q-this._time),this._time>q?(this._time=q,a=q+1e-4):this._time<0?this._time=a=0:a=this._time)),this._hasPause&&!this._forcingPlayhead&&!b){if(a=this._time,a>=o||this._repeat&&w!==this._cycle)for(d=this._first;d&&d._startTime<=a&&!m;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(m=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!m;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(m=d),d=d._prev;m&&m._startTime<q&&(this._time=a=m._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}if(this._cycle!==w&&!this._locked){var x=this._yoyo&&0!==(1&w),y=x===(this._yoyo&&0!==(1&this._cycle)),z=this._totalTime,A=this._cycle,B=this._rawPrevTime,C=this._time;if(this._totalTime=w*q,this._cycle<w?x=!x:this._totalTime+=q,this._time=o,this._rawPrevTime=0===q?u-1e-4:u,this._cycle=w,this._locked=!0,o=x?0:q,this.render(o,b,0===q),b||this._gc||this.vars.onRepeat&&(this._cycle=A,this._locked=!1,this._callback("onRepeat")),o!==this._time)return;if(y&&(this._cycle=w,this._locked=!0,o=x?q+1e-4:-1e-4,this.render(o,!0,!1)),this._locked=!1,this._paused&&!v)return;this._time=C,this._totalTime=z,this._cycle=A,this._rawPrevTime=B}if(!(this._time!==o&&this._first||c||k||m))return void(r!==this._totalTime&&this._onUpdate&&(b||this._callback("onUpdate")));if(this._initted||(this._initted=!0),this._active||!this._paused&&this._totalTime!==r&&a>0&&(this._active=!0),0===r&&this.vars.onStart&&(0===this._totalTime&&this._totalDuration||b||this._callback("onStart")),n=this._time,n>=o)for(d=this._first;d&&(i=d._next,n===this._time&&(!this._paused||v));)(d._active||d._startTime<=this._time&&!d._paused&&!d._gc)&&(m===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=i;else for(d=this._last;d&&(i=d._prev,n===this._time&&(!this._paused||v));){if(d._active||d._startTime<=o&&!d._paused&&!d._gc){if(m===d){for(m=d._prev;m&&m.endTime()>this._time;)m.render(m._reversed?m.totalDuration()-(a-m._startTime)*m._timeScale:(a-m._startTime)*m._timeScale,b,c),m=m._prev;m=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=i}this._onUpdate&&(b||(g.length&&h(),this._callback("onUpdate"))),j&&(this._locked||this._gc||(s===this._startTime||t!==this._timeScale)&&(0===this._time||p>=this.totalDuration())&&(f&&(g.length&&h(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[j]&&this._callback(j)))},k.getActive=function(a,b,c){null==a&&(a=!0),null==b&&(b=!0),null==c&&(c=!1);var d,e,f=[],g=this.getChildren(a,b,c),h=0,i=g.length;for(d=0;i>d;d++)e=g[d],e.isActive()&&(f[h++]=e);return f},k.getLabelAfter=function(a){a||0!==a&&(a=this._time);var b,c=this.getLabelsArray(),d=c.length;for(b=0;d>b;b++)if(c[b].time>a)return c[b].name;return null},k.getLabelBefore=function(a){null==a&&(a=this._time);for(var b=this.getLabelsArray(),c=b.length;--c>-1;)if(b[c].time<a)return b[c].name;return null},k.getLabelsArray=function(){var a,b=[],c=0;for(a in this._labels)b[c++]={time:this._labels[a],name:a};return b.sort(function(a,b){return a.time-b.time}),b},k.invalidate=function(){return this._locked=!1,a.prototype.invalidate.call(this)},k.progress=function(a,b){return arguments.length?this.totalTime(this.duration()*(this._yoyo&&0!==(1&this._cycle)?1-a:a)+this._cycle*(this._duration+this._repeatDelay),b):this._time/this.duration()||0},k.totalProgress=function(a,b){return arguments.length?this.totalTime(this.totalDuration()*a,b):this._totalTime/this.totalDuration()||0},k.totalDuration=function(b){return arguments.length?-1!==this._repeat&&b?this.timeScale(this.totalDuration()/b):this:(this._dirty&&(a.prototype.totalDuration.call(this),this._totalDuration=-1===this._repeat?999999999999:this._duration*(this._repeat+1)+this._repeatDelay*this._repeat),this._totalDuration)},k.time=function(a,b){return arguments.length?(this._dirty&&this.totalDuration(),a>this._duration&&(a=this._duration),this._yoyo&&0!==(1&this._cycle)?a=this._duration-a+this._cycle*(this._duration+this._repeatDelay):0!==this._repeat&&(a+=this._cycle*(this._duration+this._repeatDelay)),this.totalTime(a,b)):this._time},k.repeat=function(a){return arguments.length?(this._repeat=a,this._uncache(!0)):this._repeat},k.repeatDelay=function(a){return arguments.length?(this._repeatDelay=a,this._uncache(!0)):this._repeatDelay},k.yoyo=function(a){return arguments.length?(this._yoyo=a,this):this._yoyo},k.currentLabel=function(a){return arguments.length?this.seek(a,!0):this.getLabelBefore(this._time+1e-8)},d},!0),_gsScope._gsDefine("TimelineLite",["core.Animation","core.SimpleTimeline","TweenLite"],function(a,b,c){var d=function(a){b.call(this,a),this._labels={},this.autoRemoveChildren=this.vars.autoRemoveChildren===!0,this.smoothChildTiming=this.vars.smoothChildTiming===!0,this._sortChildren=!0,this._onUpdate=this.vars.onUpdate;var c,d,e=this.vars;for(d in e)c=e[d],i(c)&&-1!==c.join("").indexOf("{self}")&&(e[d]=this._swapSelfInParams(c));i(e.tweens)&&this.add(e.tweens,0,e.align,e.stagger)},e=1e-10,f=c._internals,g=d._internals={},h=f.isSelector,i=f.isArray,j=f.lazyTweens,k=f.lazyRender,l=_gsScope._gsDefine.globals,m=function(a){var b,c={};for(b in a)c[b]=a[b];return c},n=function(a,b,c){var d,e,f=a.cycle;for(d in f)e=f[d],a[d]="function"==typeof e?e(c,b[c]):e[c%e.length];delete a.cycle},o=g.pauseCallback=function(){},p=function(a){var b,c=[],d=a.length;for(b=0;b!==d;c.push(a[b++]));return c},q=d.prototype=new b;return d.version="1.20.3",q.constructor=d,q.kill()._gc=q._forcingPlayhead=q._hasPause=!1,q.to=function(a,b,d,e){var f=d.repeat&&l.TweenMax||c;return b?this.add(new f(a,b,d),e):this.set(a,d,e)},q.from=function(a,b,d,e){return this.add((d.repeat&&l.TweenMax||c).from(a,b,d),e)},q.fromTo=function(a,b,d,e,f){var g=e.repeat&&l.TweenMax||c;return b?this.add(g.fromTo(a,b,d,e),f):this.set(a,e,f)},q.staggerTo=function(a,b,e,f,g,i,j,k){var l,o,q=new d({onComplete:i,onCompleteParams:j,callbackScope:k,smoothChildTiming:this.smoothChildTiming}),r=e.cycle;for("string"==typeof a&&(a=c.selector(a)||a),a=a||[],h(a)&&(a=p(a)),f=f||0,0>f&&(a=p(a),a.reverse(),f*=-1),o=0;o<a.length;o++)l=m(e),l.startAt&&(l.startAt=m(l.startAt),l.startAt.cycle&&n(l.startAt,a,o)),r&&(n(l,a,o),null!=l.duration&&(b=l.duration,delete l.duration)),q.to(a[o],b,l,o*f);return this.add(q,g)},q.staggerFrom=function(a,b,c,d,e,f,g,h){return c.immediateRender=0!=c.immediateRender,c.runBackwards=!0,this.staggerTo(a,b,c,d,e,f,g,h)},q.staggerFromTo=function(a,b,c,d,e,f,g,h,i){return d.startAt=c,d.immediateRender=0!=d.immediateRender&&0!=c.immediateRender,this.staggerTo(a,b,d,e,f,g,h,i)},q.call=function(a,b,d,e){return this.add(c.delayedCall(0,a,b,d),e)},q.set=function(a,b,d){return d=this._parseTimeOrLabel(d,0,!0),null==b.immediateRender&&(b.immediateRender=d===this._time&&!this._paused),this.add(new c(a,0,b),d)},d.exportRoot=function(a,b){a=a||{},null==a.smoothChildTiming&&(a.smoothChildTiming=!0);var e,f,g,h,i=new d(a),j=i._timeline;for(null==b&&(b=!0),j._remove(i,!0),i._startTime=0,i._rawPrevTime=i._time=i._totalTime=j._time,g=j._first;g;)h=g._next,b&&g instanceof c&&g.target===g.vars.onComplete||(f=g._startTime-g._delay,0>f&&(e=1),i.add(g,f)),g=h;return j.add(i,0),e&&i.totalDuration(),i},q.add=function(e,f,g,h){var j,k,l,m,n,o;if("number"!=typeof f&&(f=this._parseTimeOrLabel(f,0,!0,e)),!(e instanceof a)){if(e instanceof Array||e&&e.push&&i(e)){for(g=g||"normal",h=h||0,j=f,k=e.length,l=0;k>l;l++)i(m=e[l])&&(m=new d({tweens:m})),this.add(m,j),"string"!=typeof m&&"function"!=typeof m&&("sequence"===g?j=m._startTime+m.totalDuration()/m._timeScale:"start"===g&&(m._startTime-=m.delay())),j+=h;return this._uncache(!0)}if("string"==typeof e)return this.addLabel(e,f);if("function"!=typeof e)throw"Cannot add "+e+" into the timeline; it is not a tween, timeline, function, or string.";e=c.delayedCall(0,e)}if(b.prototype.add.call(this,e,f),e._time&&e.render((this.rawTime()-e._startTime)*e._timeScale,!1,!1),(this._gc||this._time===this._duration)&&!this._paused&&this._duration<this.duration())for(n=this,o=n.rawTime()>e._startTime;n._timeline;)o&&n._timeline.smoothChildTiming?n.totalTime(n._totalTime,!0):n._gc&&n._enabled(!0,!1),n=n._timeline;return this},q.remove=function(b){if(b instanceof a){this._remove(b,!1);var c=b._timeline=b.vars.useFrames?a._rootFramesTimeline:a._rootTimeline;return b._startTime=(b._paused?b._pauseTime:c._time)-(b._reversed?b.totalDuration()-b._totalTime:b._totalTime)/b._timeScale,this}if(b instanceof Array||b&&b.push&&i(b)){for(var d=b.length;--d>-1;)this.remove(b[d]);return this}return"string"==typeof b?this.removeLabel(b):this.kill(null,b)},q._remove=function(a,c){b.prototype._remove.call(this,a,c);var d=this._last;return d?this._time>this.duration()&&(this._time=this._duration,this._totalTime=this._totalDuration):this._time=this._totalTime=this._duration=this._totalDuration=0,this},q.append=function(a,b){return this.add(a,this._parseTimeOrLabel(null,b,!0,a))},q.insert=q.insertMultiple=function(a,b,c,d){return this.add(a,b||0,c,d)},q.appendMultiple=function(a,b,c,d){return this.add(a,this._parseTimeOrLabel(null,b,!0,a),c,d)},q.addLabel=function(a,b){return this._labels[a]=this._parseTimeOrLabel(b),this},q.addPause=function(a,b,d,e){var f=c.delayedCall(0,o,d,e||this);return f.vars.onComplete=f.vars.onReverseComplete=b,f.data="isPause",this._hasPause=!0,this.add(f,a)},q.removeLabel=function(a){return delete this._labels[a],this},q.getLabelTime=function(a){return null!=this._labels[a]?this._labels[a]:-1},q._parseTimeOrLabel=function(b,c,d,e){var f,g;if(e instanceof a&&e.timeline===this)this.remove(e);else if(e&&(e instanceof Array||e.push&&i(e)))for(g=e.length;--g>-1;)e[g]instanceof a&&e[g].timeline===this&&this.remove(e[g]);if(f="number"!=typeof b||c?this.duration()>99999999999?this.recent().endTime(!1):this._duration:0,"string"==typeof c)return this._parseTimeOrLabel(c,d&&"number"==typeof b&&null==this._labels[c]?b-f:0,d);if(c=c||0,"string"!=typeof b||!isNaN(b)&&null==this._labels[b])null==b&&(b=f);else{if(g=b.indexOf("="),-1===g)return null==this._labels[b]?d?this._labels[b]=f+c:c:this._labels[b]+c;c=parseInt(b.charAt(g-1)+"1",10)*Number(b.substr(g+1)),b=g>1?this._parseTimeOrLabel(b.substr(0,g-1),0,d):f}return Number(b)+c},q.seek=function(a,b){return this.totalTime("number"==typeof a?a:this._parseTimeOrLabel(a),b!==!1)},q.stop=function(){return this.paused(!0)},q.gotoAndPlay=function(a,b){return this.play(a,b)},q.gotoAndStop=function(a,b){return this.pause(a,b)},q.render=function(a,b,c){this._gc&&this._enabled(!0,!1);var d,f,g,h,i,l,m,n=this._dirty?this.totalDuration():this._totalDuration,o=this._time,p=this._startTime,q=this._timeScale,r=this._paused;if(a>=n-1e-7&&a>=0)this._totalTime=this._time=n,this._reversed||this._hasPausedChild()||(f=!0,h="onComplete",i=!!this._timeline.autoRemoveChildren,0===this._duration&&(0>=a&&a>=-1e-7||this._rawPrevTime<0||this._rawPrevTime===e)&&this._rawPrevTime!==a&&this._first&&(i=!0,this._rawPrevTime>e&&(h="onReverseComplete"))),this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,a=n+1e-4;else if(1e-7>a)if(this._totalTime=this._time=0,(0!==o||0===this._duration&&this._rawPrevTime!==e&&(this._rawPrevTime>0||0>a&&this._rawPrevTime>=0))&&(h="onReverseComplete",f=this._reversed),0>a)this._active=!1,this._timeline.autoRemoveChildren&&this._reversed?(i=f=!0,h="onReverseComplete"):this._rawPrevTime>=0&&this._first&&(i=!0),this._rawPrevTime=a;else{if(this._rawPrevTime=this._duration||!b||a||this._rawPrevTime===a?a:e,0===a&&f)for(d=this._first;d&&0===d._startTime;)d._duration||(f=!1),d=d._next;a=0,this._initted||(i=!0)}else{if(this._hasPause&&!this._forcingPlayhead&&!b){if(a>=o)for(d=this._first;d&&d._startTime<=a&&!l;)d._duration||"isPause"!==d.data||d.ratio||0===d._startTime&&0===this._rawPrevTime||(l=d),d=d._next;else for(d=this._last;d&&d._startTime>=a&&!l;)d._duration||"isPause"===d.data&&d._rawPrevTime>0&&(l=d),d=d._prev;l&&(this._time=a=l._startTime,this._totalTime=a+this._cycle*(this._totalDuration+this._repeatDelay))}this._totalTime=this._time=this._rawPrevTime=a}if(this._time!==o&&this._first||c||i||l){if(this._initted||(this._initted=!0),this._active||!this._paused&&this._time!==o&&a>0&&(this._active=!0),0===o&&this.vars.onStart&&(0===this._time&&this._duration||b||this._callback("onStart")),m=this._time,m>=o)for(d=this._first;d&&(g=d._next,m===this._time&&(!this._paused||r));)(d._active||d._startTime<=m&&!d._paused&&!d._gc)&&(l===d&&this.pause(),d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)),d=g;else for(d=this._last;d&&(g=d._prev,m===this._time&&(!this._paused||r));){if(d._active||d._startTime<=o&&!d._paused&&!d._gc){if(l===d){for(l=d._prev;l&&l.endTime()>this._time;)l.render(l._reversed?l.totalDuration()-(a-l._startTime)*l._timeScale:(a-l._startTime)*l._timeScale,b,c),l=l._prev;l=null,this.pause()}d._reversed?d.render((d._dirty?d.totalDuration():d._totalDuration)-(a-d._startTime)*d._timeScale,b,c):d.render((a-d._startTime)*d._timeScale,b,c)}d=g}this._onUpdate&&(b||(j.length&&k(),this._callback("onUpdate"))),h&&(this._gc||(p===this._startTime||q!==this._timeScale)&&(0===this._time||n>=this.totalDuration())&&(f&&(j.length&&k(),this._timeline.autoRemoveChildren&&this._enabled(!1,!1),this._active=!1),!b&&this.vars[h]&&this._callback(h)))}},q._hasPausedChild=function(){for(var a=this._first;a;){if(a._paused||a instanceof d&&a._hasPausedChild())return!0;a=a._next}return!1},q.getChildren=function(a,b,d,e){e=e||-9999999999;for(var f=[],g=this._first,h=0;g;)g._startTime<e||(g instanceof c?b!==!1&&(f[h++]=g):(d!==!1&&(f[h++]=g),a!==!1&&(f=f.concat(g.getChildren(!0,b,d)),h=f.length))),g=g._next;return f},q.getTweensOf=function(a,b){var d,e,f=this._gc,g=[],h=0;for(f&&this._enabled(!0,!0),d=c.getTweensOf(a),e=d.length;--e>-1;)(d[e].timeline===this||b&&this._contains(d[e]))&&(g[h++]=d[e]);return f&&this._enabled(!1,!0),g},q.recent=function(){return this._recent},q._contains=function(a){for(var b=a.timeline;b;){if(b===this)return!0;b=b.timeline}return!1},q.shiftChildren=function(a,b,c){c=c||0;for(var d,e=this._first,f=this._labels;e;)e._startTime>=c&&(e._startTime+=a),e=e._next;if(b)for(d in f)f[d]>=c&&(f[d]+=a);return this._uncache(!0)},q._kill=function(a,b){if(!a&&!b)return this._enabled(!1,!1);for(var c=b?this.getTweensOf(b):this.getChildren(!0,!0,!1),d=c.length,e=!1;--d>-1;)c[d]._kill(a,b)&&(e=!0);return e},q.clear=function(a){var b=this.getChildren(!1,!0,!0),c=b.length;for(this._time=this._totalTime=0;--c>-1;)b[c]._enabled(!1,!1);return a!==!1&&(this._labels={}),this._uncache(!0)},q.invalidate=function(){for(var b=this._first;b;)b.invalidate(),b=b._next;return a.prototype.invalidate.call(this)},q._enabled=function(a,c){if(a===this._gc)for(var d=this._first;d;)d._enabled(a,!0),d=d._next;return b.prototype._enabled.call(this,a,c)},q.totalTime=function(b,c,d){this._forcingPlayhead=!0;var e=a.prototype.totalTime.apply(this,arguments);return this._forcingPlayhead=!1,e},q.duration=function(a){return arguments.length?(0!==this.duration()&&0!==a&&this.timeScale(this._duration/a),this):(this._dirty&&this.totalDuration(),this._duration)},q.totalDuration=function(a){if(!arguments.length){if(this._dirty){for(var b,c,d=0,e=this._last,f=999999999999;e;)b=e._prev,e._dirty&&e.totalDuration(),e._startTime>f&&this._sortChildren&&!e._paused&&!this._calculatingDuration?(this._calculatingDuration=1,this.add(e,e._startTime-e._delay),this._calculatingDuration=0):f=e._startTime,e._startTime<0&&!e._paused&&(d-=e._startTime,this._timeline.smoothChildTiming&&(this._startTime+=e._startTime/this._timeScale,this._time-=e._startTime,this._totalTime-=e._startTime,this._rawPrevTime-=e._startTime),this.shiftChildren(-e._startTime,!1,-9999999999),f=0),c=e._startTime+e._totalDuration/e._timeScale,c>d&&(d=c),e=b;this._duration=this._totalDuration=d,this._dirty=!1}return this._totalDuration}return a&&this.totalDuration()?this.timeScale(this._totalDuration/a):this},q.paused=function(b){if(!b)for(var c=this._first,d=this._time;c;)c._startTime===d&&"isPause"===c.data&&(c._rawPrevTime=0),c=c._next;return a.prototype.paused.apply(this,arguments)},q.usesFrames=function(){for(var b=this._timeline;b._timeline;)b=b._timeline;return b===a._rootFramesTimeline},q.rawTime=function(a){return a&&(this._paused||this._repeat&&this.time()>0&&this.totalProgress()<1)?this._totalTime%(this._duration+this._repeatDelay):this._paused?this._totalTime:(this._timeline.rawTime(a)-this._startTime)*this._timeScale},d},!0)}),_gsScope._gsDefine&&_gsScope._gsQueue.pop()(),function(a){"use strict";var b=function(){return(_gsScope.GreenSockGlobals||_gsScope)[a]};"undefined"!=typeof module&&module.exports?(__webpack_require__(247),module.exports=b()):"function"=="function"&&__webpack_require__(240)&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(247)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}("TimelineMax");
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Effect = __webpack_require__(302);

    return Effect.extend({
        config: function config() {
            return {
                scale: this.model.get("scale"),
                transformOrigin: "50% 50%"
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Effect = __webpack_require__(302);
    var Preconditions = __webpack_require__(14);
    var RotateEffectModel = __webpack_require__(359);

    return Effect.extend({
        config: function config() {
            var rotation = void 0;
            var yoyo = void 0;

            switch (this.model.get("attentionMode")) {
                case RotateEffectModel.MODE.Angle:
                    {
                        if (this.model.get("rotation") < 0) {
                            rotation = "-=" + this.model.get("rotation");
                        } else {
                            rotation = "+=" + this.model.get("rotation");
                        }

                        yoyo = true;
                        break;
                    }

                case RotateEffectModel.MODE.Infinite:
                    {
                        var isRotatingClockwise = this.model.get("rotationDirection") === RotateEffectModel.DIRECTION.Clockwise;
                        rotation = isRotatingClockwise ? "+=360" : "-=360";
                        yoyo = false;
                        break;
                    }

                default:
                    {
                        Preconditions.fail(this.model.get("attentionMode") + " is not a supported attentionMode.");
                    }
            }

            return {
                rotation: rotation,
                yoyo: yoyo,
                transformOrigin: "50% 50%",
                ease: Effect.Easing.Linear.easeNone
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Effect = __webpack_require__(302);
    var EffectModel = __webpack_require__(78);
    var TweenMax = __webpack_require__(152);
    var Preconditions = __webpack_require__(14);

    return Effect.extend({

        reversible: false,

        config: function config() {
            var modelValue = this.model.get("value");

            var scale = void 0;
            var duration = void 0;

            switch (modelValue) {
                case 1:
                    scale = 1.1;
                    duration = 1.0;
                    break;
                case 2:
                    scale = 1.2;
                    duration = 1.2;
                    break;
                case 3:
                    scale = 1.4;
                    duration = 1.0;
                    break;
                case 4:
                    scale = 1.6;
                    duration = 0.8;
                    break;
                case 5:
                    scale = 2;
                    duration = 0.6;
                    break;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Model scale '" + modelValue + "' not recognized.");
                    break;
            }

            return {
                scale: scale,
                duration: duration,
                transformOrigin: "50% 50%"
            };
        },
        repeats: function repeats() {
            return true;
        },
        finish: function finish() {
            var _this = this;

            // If we're finishing a hover effect, the default pausing behavior is not desired here.
            // We'll scale back to 1.0 and resetting (pause(0)) the underlying repeating pulse effect
            if (this.model.get("triggerType") === EffectModel.TRIGGER_TYPE_HOVER) {
                var duration = this.model.get("duration") / 1000;
                var element = this.element;

                return new $.Deferred(function (deferred) {
                    _this.pause();
                    TweenMax.to(element, duration, {
                        scale: 1.0,
                        onComplete: function onComplete() {
                            _this.pause(0);
                            deferred.resolve();
                        }
                    });
                }).promise();
            }

            return Effect.prototype.finish.call(this);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var Effect = __webpack_require__(302);
    var EffectModel = __webpack_require__(78);
    var OpacityEffect = __webpack_require__(770);
    var OpacityEffectModel = __webpack_require__(245);
    var ImageURLProvider = __webpack_require__(362);

    var HOVER_DURATION = 0.3;

    /**
     * Inner class, representing the toggle image effect, extending the OpacityEffect to get the proper duration.
     *
     * @class ToggleEffect
     */
    var ToggleEffect = OpacityEffect.extend({
        duration: function duration(triggerType) {
            return triggerType === EffectModel.TRIGGER_TYPE_HOVER ? HOVER_DURATION : null;
        }
    }, {
        create: function create(element, options) {
            return new ToggleEffect(element, new OpacityEffectModel(options));
        }
    });

    /**
     * View representing the toggle image.
     *
     * @class ToggleImageView
     */
    var ToggleImageView = Backbone.View.extend({

        tagName: "img",

        className: "toggle-effect-image",

        /**
         * The image base url of the third party image library integration
         *
         * @type {String}
         */
        _imageServingUrl: null,

        initialize: function initialize() {
            var imageWidgetView = this.options.imageWidgetView;


            if (this.model.get("sourceType")) {
                this._imageServingUrl = this._getImageServingUrl();
            }

            this.listenTo(imageWidgetView, "updated:rendering", this.render);
        },
        visible: function visible(value) {
            var visibility = value ? "visible" : "hidden";
            this.$el.css({ visibility: visibility });
        },
        _getImageServingUrl: function _getImageServingUrl() {
            var experienceModel = this.options.imageWidgetView.viewModel.get("experience");
            var imageIntegration = experienceModel.getIntegration(this.model.get("sourceType"));
            return imageIntegration && imageIntegration.imageServingUrl;
        },
        render: function render() {
            var _this = this;

            var imageWidgetView = this.options.imageWidgetView;

            var bounds = imageWidgetView.getRect();

            var provideOptions = { bounds: bounds };

            if (this.model.get("sourceType")) {
                provideOptions.imageServingUrl = this._imageServingUrl;
            }

            this.$el.off().attr("src", ImageURLProvider.provide(this.model, provideOptions)).attr("alt", this.model.get("altText") || "").one("error", function () {
                if (_this.model.get("sourceType") && !_this._imageServingUrl) {
                    // The integration is missing, no need to retry the request without a base url
                    return;
                }

                // Edge case - there's a slight change the image is not "ready" yet (not generated at that specific size on the backend)
                _this.$el.attr("src", ImageURLProvider.provide(_this.model));
            });

            return this;
        }
    });

    /**
     * An effect that will perform a fade (swap/toggle) transition between two images.
     *
     * @class ImageToggleEffect
     */
    return Effect.extend({

        /**
         * ToggleEffect used for tweening the toggle image.
         * @type {ToggleEffect}
         */
        _opacityEffect: null,

        _attentionTrigger: null,

        onInitialize: function onInitialize() {
            this.toggleImageView = new ToggleImageView({
                model: this.model,
                imageWidgetView: this.view
            });

            var toggleEffectOptions = _.extend({ opacity: 1.0 }, this.model.pick(["duration", "postDelay", "triggerType"]));
            this._opacityEffect = ToggleEffect.create(this.toggleImageView, toggleEffectOptions);

            // Grab a reference to the image element contained inside the image widget view.
            // This will be the element that *this* effect will tween, see #config.
            this._widgetImageElement = this.view.$el.find("img").get(0);

            // Place the toggle image inside the image widget (below the image element, hence `prepend`).
            this.view.$el.prepend(this.toggleImageView.render().el);
        },
        duration: function duration(triggerType) {
            return triggerType === EffectModel.TRIGGER_TYPE_HOVER ? HOVER_DURATION : null;
        },
        play: function play() {
            this.__super();
            // Make sure the toggle element is present when playing the effect...
            this.toggleImageView.visible(true);
            this._opacityEffect.play();
        },
        stop: function stop() {
            this._opacityEffect.stop();
            this.__super();
        },
        pause: function pause() {
            this._opacityEffect.pause();
            // Hide the clone when paused
            this.toggleImageView.visible(false);

            this.__super();
        },
        reverse: function reverse() {
            this._opacityEffect.reverse();

            return this.__super();
        },
        config: function config() {
            return {
                opacity: 0,
                ease: Effect.Easing.Linear.easeNone,
                // We'll tween opacity on the widget contained image element, and not the widget element itself.
                element: this._widgetImageElement
            };
        },
        kill: function kill() {
            this._opacityEffect.kill();
            // Clean up - remove toggle element
            this.toggleImageView.remove();

            this.__super();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BOX_SIZES", function() { return BOX_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAppropriateBoxSize", function() { return getAppropriateBoxSize; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__geom__ = __webpack_require__(1444);


/**
 *
 * Available box sizes. Uploaded images will be resized in order to fit into these boxes.
 * The same constant can pe found in the Lambda ImageResizer function.
 * IMPORTANT: Make sure to modify that constant as well when you're changing this one.
 */
var BOX_SIZES = [
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](3840, 3840),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](2560, 2560),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](2048, 2048),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](1536, 1536),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](1280, 1280),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](1080, 1080),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](960, 800),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](910, 448),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](720, 450),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](480, 320),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](300, 300),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](100, 100),
    new __WEBPACK_IMPORTED_MODULE_1__geom__["a" /* Size */](50, 50)
];
/**
 * Checks if the original image fits the passed box size.
 * @param imageBoxSize
 * @param availableBoxSize
 */
var isBoxSizeFitting = function (imageBoxSize, availableBoxSize) {
    return imageBoxSize.width <= availableBoxSize.width && imageBoxSize.height <= availableBoxSize.height;
};
/**
 * Returns the first appropriate box size in which the image would fit.<p>
 *
 * If will first filter out all box sizes in which the original
 * image already fit (the original image was smaller than the box size,
 * so no resize was necessary).
 *
 * Then it will iterate trough the available box sizes and will choose the smallest one
 * that is bigger than the bounds (so that we don't scale it down).
 *
 * @param imageBoxSize
 * @param bounds
 */
var getAppropriateBoxSize = function (imageBoxSize, bounds) {
    var availableBoxSizes = BOX_SIZES.filter(function (boxSize) { return !isBoxSizeFitting(imageBoxSize, boxSize); });
    return Object(__WEBPACK_IMPORTED_MODULE_0_underscore__["find"])(availableBoxSizes.sort(function (a, b) { return a.width - b.width; }), function (boxSize) { return isBoxSizeFitting(bounds, boxSize); });
};


/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rect__ = __webpack_require__(771);
/* unused harmony reexport Rect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Size__ = __webpack_require__(772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Size__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Point__ = __webpack_require__(773);
/* unused harmony reexport Point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pixelRect__ = __webpack_require__(1445);
/* unused harmony reexport pixelRect */






/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rect__ = __webpack_require__(771);

/* unused harmony default export */ var _unused_webpack_default_export = (function (widgetBounds, containerSize) { return new __WEBPACK_IMPORTED_MODULE_0__Rect__["a" /* default */](
// This appears to be the same calculations done in the editor on set/get.
(widgetBounds.left * containerSize.width / 100), (widgetBounds.top * containerSize.height / 100), (widgetBounds.width * containerSize.width / 100), (widgetBounds.height * containerSize.height / 100)); });


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(774),
    isObject = __webpack_require__(155);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(122);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(155),
    isSymbol = __webpack_require__(363);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(303);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Window = __webpack_require__(48);

    var domUtil = {
        /*
         * Load script
         *
         * @param {String} url - Url of the script
         * @param {windowElement} windowElement - Window Element. Optional. Defaults to current window.
         *
         * @returns {Element} return script DOM element
         */
        createScriptElement: function createScriptElement(url, windowElement) {
            windowElement = windowElement || Window.self();
            var scriptElement = windowElement.document.createElement("script");
            scriptElement.src = url;
            scriptElement.type = "text/javascript";

            return scriptElement;
        },


        /**
         * This function will take the innerDOM of an HTMLElement and encapsulate it.
         *
         * @param {HTMLElement} htmlElement     - The element where the innerDOM is going to be wrapped.
         * @param {HTMLElement} wrapperElement  - The element which encapsulate the innerDOM of the {@see htmlElement}
         */
        encapsulateInnerDom: function encapsulateInnerDom(htmlElement, wrapperElement) {
            while (htmlElement.firstChild) {
                wrapperElement.appendChild(htmlElement.firstChild);
            }

            htmlElement.appendChild(wrapperElement);
        }
    };

    return domUtil;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var Backbone = __webpack_require__(7);

  /**
   * Describes a font abstraction.
   *
   * @class FontDescriptor
   *
   * @see FontDescriptorCollection
   *
   * @author Kim
   */
  return Backbone.Model.extend({

    defaults: {

      /**
       * @type {String}
       */
      name: null,

      /**
       * @type {String}
       */
      family: null,

      /**
       * @type {String}
       */
      variations: null,

      /**
       * @type {FontProvider}
       */
      provider: null,

      /**
       * Object for storing specific font provider/vendor information.
       *
       * @type {Object}
       */
      data: null
    }

  });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        find = _require.find;

    var _require2 = __webpack_require__(30),
        trim = _require2.trim;

    /**
     * @constant
     * Array of all known Google Font (case sensitive) families.
     * @type {String[]}
     */


    var ALL = ["ABeeZee", "Abel", "Abril Fatface", "Aclonica", "Acme", "Actor", "Adamina", "Advent Pro", "Aguafina Script", "Akronim", "Aladin", "Aldrich", "Alef", "Alegreya", "Alegreya SC", "Alegreya Sans", "Alegreya Sans SC", "Alex Brush", "Alfa Slab One", "Alice", "Alike", "Alike Angular", "Allan", "Allerta", "Allerta Stencil", "Allura", "Almendra", "Almendra Display", "Almendra SC", "Amarante", "Amaranth", "Amatic SC", "Amethysta", "Anaheim", "Andada", "Andika", "Angkor", "Annie Use Your Telescope", "Anonymous Pro", "Antic", "Antic Didone", "Antic Slab", "Anton", "Arapey", "Arbutus", "Arbutus Slab", "Architects Daughter", "Archivo Black", "Archivo Narrow", "Arimo", "Arizonia", "Armata", "Artifika", "Arvo", "Asap", "Asset", "Astloch", "Asul", "Atomic Age", "Aubrey", "Audiowide", "Autour One", "Average", "Average Sans", "Averia Gruesa Libre", "Averia Libre", "Averia Sans Libre", "Averia Serif Libre", "Bad Script", "Balthazar", "Bangers", "Basic", "Battambang", "Baumans", "Bayon", "Belgrano", "Belleza", "BenchNine", "Bentham", "Berkshire Swash", "Bevan", "Bigelow Rules", "Bigshot One", "Bilbo", "Bilbo Swash Caps", "Bitter", "Black Ops One", "Bokor", "Bonbon", "Boogaloo", "Bowlby One", "Bowlby One SC", "Brawler", "Bree Serif", "Bubblegum Sans", "Bubbler One", "Buda", "Buenard", "Butcherman", "Butterfly Kids", "Cabin", "Cabin Condensed", "Cabin Sketch", "Caesar Dressing", "Cagliostro", "Calligraffitti", "Cambo", "Candal", "Cantarell", "Cantata One", "Cantora One", "Capriola", "Cardo", "Carme", "Carrois Gothic", "Carrois Gothic SC", "Carter One", "Caudex", "Cedarville Cursive", "Ceviche One", "Changa One", "Chango", "Chau Philomene One", "Chela One", "Chelsea Market", "Chenla", "Cherry Cream Soda", "Cherry Swash", "Chewy", "Chicle", "Chivo", "Cinzel", "Cinzel Decorative", "Clicker Script", "Coda", "Coda Caption", "Codystar", "Combo", "Comfortaa", "Coming Soon", "Concert One", "Condiment", "Content", "Contrail One", "Convergence", "Cookie", "Copse", "Corben", "Courgette", "Cousine", "Coustard", "Covered By Your Grace", "Crafty Girls", "Creepster", "Crete Round", "Crimson Text", "Croissant One", "Crushed", "Cuprum", "Cutive", "Cutive Mono", "Damion", "Dancing Script", "Dangrek", "Dawning of a New Day", "Days One", "Delius", "Delius Swash Caps", "Delius Unicase", "Della Respira", "Denk One", "Devonshire", "Dhurjati", "Didact Gothic", "Diplomata", "Diplomata SC", "Domine", "Donegal One", "Doppio One", "Dorsa", "Dosis", "Dr Sugiyama", "Droid Sans", "Droid Sans Mono", "Droid Serif", "Duru Sans", "Dynalight", "EB Garamond", "Eagle Lake", "Eater", "Economica", "Ek Mukta", "Electrolize", "Elsie", "Elsie Swash Caps", "Emblema One", "Emilys Candy", "Engagement", "Englebert", "Enriqueta", "Erica One", "Esteban", "Euphoria Script", "Ewert", "Exo", "Exo 2", "Expletus Sans", "Fanwood Text", "Fascinate", "Fascinate Inline", "Faster One", "Fasthand", "Fauna One", "Federant", "Federo", "Felipa", "Fenix", "Finger Paint", "Fira Mono", "Fira Sans", "Fjalla One", "Fjord One", "Flamenco", "Flavors", "Fondamento", "Fontdiner Swanky", "Forum", "Francois One", "Freckle Face", "Fredericka the Great", "Fredoka One", "Freehand", "Fresca", "Frijole", "Fruktur", "Fugaz One", "GFS Didot", "GFS Neohellenic", "Gabriela", "Gafata", "Galdeano", "Galindo", "Gentium Basic", "Gentium Book Basic", "Geo", "Geostar", "Geostar Fill", "Germania One", "Gidugu", "Gilda Display", "Give You Glory", "Glass Antiqua", "Glegoo", "Gloria Hallelujah", "Goblin One", "Gochi Hand", "Gorditas", "Goudy Bookletter 1911", "Graduate", "Grand Hotel", "Gravitas One", "Great Vibes", "Griffy", "Gruppo", "Gudea", "Habibi", "Halant", "Hammersmith One", "Hanalei", "Hanalei Fill", "Handlee", "Hanuman", "Happy Monkey", "Headland One", "Henny Penny", "Herr Von Muellerhoff", "Hind", "Holtwood One SC", "Homemade Apple", "Homenaje", "IM Fell DW Pica", "IM Fell DW Pica SC", "IM Fell Double Pica", "IM Fell Double Pica SC", "IM Fell English", "IM Fell English SC", "IM Fell French Canon", "IM Fell French Canon SC", "IM Fell Great Primer", "IM Fell Great Primer SC", "Iceberg", "Iceland", "Imprima", "Inconsolata", "Inder", "Indie Flower", "Inika", "Irish Grover", "Istok Web", "Italiana", "Italianno", "Jacques Francois", "Jacques Francois Shadow", "Jim Nightshade", "Jockey One", "Jolly Lodger", "Josefin Sans", "Josefin Slab", "Joti One", "Judson", "Julee", "Julius Sans One", "Junge", "Jura", "Just Another Hand", "Just Me Again Down Here", "Kalam", "Kameron", "Kantumruy", "Karla", "Karma", "Kaushan Script", "Kavoon", "Kdam Thmor", "Keania One", "Kelly Slab", "Kenia", "Khand", "Khmer", "Kite One", "Knewave", "Kotta One", "Koulen", "Kranky", "Kreon", "Kristi", "Krona One", "La Belle Aurore", "Laila", "Lancelot", "Lato", "League Script", "Leckerli One", "Ledger", "Lekton", "Lemon", "Libre Baskerville", "Life Savers", "Lilita One", "Lily Script One", "Limelight", "Linden Hill", "Lobster", "Lobster Two", "Londrina Outline", "Londrina Shadow", "Londrina Sketch", "Londrina Solid", "Lora", "Love Ya Like A Sister", "Loved by the King", "Lovers Quarrel", "Luckiest Guy", "Lusitana", "Lustria", "Macondo", "Macondo Swash Caps", "Magra", "Maiden Orange", "Mako", "Mallanna", "Mandali", "Marcellus", "Marcellus SC", "Marck Script", "Margarine", "Marko One", "Marmelad", "Marvel", "Mate", "Mate SC", "Maven Pro", "McLaren", "Meddon", "MedievalSharp", "Medula One", "Megrim", "Meie Script", "Merienda", "Merienda One", "Merriweather", "Merriweather Sans", "Metal", "Metal Mania", "Metamorphous", "Metrophobic", "Michroma", "Milonga", "Miltonian", "Miltonian Tattoo", "Miniver", "Miss Fajardose", "Modern Antiqua", "Molengo", "Molle", "Monda", "Monofett", "Monoton", "Monsieur La Doulaise", "Montaga", "Montez", "Montserrat", "Montserrat Alternates", "Montserrat Subrayada", "Moul", "Moulpali", "Mountains of Christmas", "Mouse Memoirs", "Mr Bedfort", "Mr Dafoe", "Mr De Haviland", "Mrs Saint Delafield", "Mrs Sheppards", "Muli", "Mystery Quest", "NTR", "Neucha", "Neuton", "New Rocker", "News Cycle", "Niconne", "Nixie One", "Nobile", "Nokora", "Norican", "Nosifer", "Nothing You Could Do", "Noticia Text", "Noto Sans", "Noto Serif", "Nova Cut", "Nova Flat", "Nova Mono", "Nova Oval", "Nova Round", "Nova Script", "Nova Slim", "Nova Square", "Numans", "Nunito", "Odor Mean Chey", "Offside", "Old Standard TT", "Oldenburg", "Oleo Script", "Oleo Script Swash Caps", "Open Sans", "Open Sans Condensed", "Oranienbaum", "Orbitron", "Oregano", "Orienta", "Original Surfer", "Oswald", "Over the Rainbow", "Overlock", "Overlock SC", "Ovo", "Oxygen", "Oxygen Mono", "PT Mono", "PT Sans", "PT Sans Caption", "PT Sans Narrow", "PT Serif", "PT Serif Caption", "Pacifico", "Paprika", "Parisienne", "Passero One", "Passion One", "Pathway Gothic One", "Patrick Hand", "Patrick Hand SC", "Patua One", "Paytone One", "Peralta", "Permanent Marker", "Petit Formal Script", "Petrona", "Philosopher", "Piedra", "Pinyon Script", "Pirata One", "Plaster", "Play", "Playball", "Playfair Display", "Playfair Display SC", "Podkova", "Poiret One", "Poller One", "Poly", "Pompiere", "Pontano Sans", "Port Lligat Sans", "Port Lligat Slab", "Prata", "Preahvihear", "Press Start 2P", "Princess Sofia", "Prociono", "Prosto One", "Puritan", "Purple Purse", "Quando", "Quantico", "Quattrocento", "Quattrocento Sans", "Questrial", "Quicksand", "Quintessential", "Qwigley", "Racing Sans One", "Radley", "Rajdhani", "Raleway", "Raleway Dots", "Ramabhadra", "Rambla", "Rammetto One", "Ranchers", "Rancho", "Rationale", "Redressed", "Reenie Beanie", "Revalia", "Ribeye", "Ribeye Marrow", "Righteous", "Risque", "Roboto", "Roboto Condensed", "Roboto Slab", "Rochester", "Rock Salt", "Rokkitt", "Romanesco", "Ropa Sans", "Rosario", "Rosarivo", "Rouge Script", "Rozha One", "Rubik Mono One", "Rubik One", "Ruda", "Rufina", "Ruge Boogie", "Ruluko", "Rum Raisin", "Ruslan Display", "Russo One", "Ruthie", "Rye", "Sacramento", "Sail", "Salsa", "Sanchez", "Sancreek", "Sansita One", "Sarina", "Sarpanch", "Satisfy", "Scada", "Schoolbell", "Seaweed Script", "Sevillana", "Seymour One", "Shadows Into Light", "Shadows Into Light Two", "Shanti", "Share", "Share Tech", "Share Tech Mono", "Shojumaru", "Short Stack", "Siemreap", "Sigmar One", "Signika", "Signika Negative", "Simonetta", "Sintony", "Sirin Stencil", "Six Caps", "Skranji", "Slabo 13px", "Slabo 27px", "Slackey", "Smokum", "Smythe", "Sniglet", "Snippet", "Snowburst One", "Sofadi One", "Sofia", "Sonsie One", "Sorts Mill Goudy", "Source Code Pro", "Source Sans Pro", "Source Serif Pro", "Special Elite", "Spicy Rice", "Spinnaker", "Spirax", "Squada One", "Stalemate", "Stalinist One", "Stardos Stencil", "Stint Ultra Condensed", "Stint Ultra Expanded", "Stoke", "Strait", "Sue Ellen Francisco", "Sunshiney", "Supermercado One", "Suwannaphum", "Swanky and Moo Moo", "Syncopate", "Tangerine", "Taprom", "Tauri", "Teko", "Telex", "Tenor Sans", "Text Me One", "The Girl Next Door", "Tienne", "Tinos", "Titan One", "Titillium Web", "Trade Winds", "Trocchi", "Trochut", "Trykker", "Tulpen One", "Ubuntu", "Ubuntu Condensed", "Ubuntu Mono", "Ultra", "Uncial Antiqua", "Underdog", "Unica One", "UnifrakturCook", "UnifrakturMaguntia", "Unkempt", "Unlock", "Unna", "VT323", "Vampiro One", "Varela", "Varela Round", "Vast Shadow", "Vesper Libre", "Vibur", "Vidaloka", "Viga", "Voces", "Volkhov", "Vollkorn", "Voltaire", "Waiting for the Sunrise", "Wallpoet", "Walter Turncoat", "Warnes", "Wellfleet", "Wendy One", "Wire One", "Yanone Kaffeesatz", "Yellowtail", "Yeseva One", "Yesteryear", "Zeyada"];

    /**
     * Static utility for ensuring correct casing when using Google Fonts.
     *
     * This was introduced to be backwards compatible post "custom fonts".
     *
     * @see fontFamily
     */
    return {

        /**
         * From the specified (case insensitive) font family value, returns the
         * correctly cased family name. If no match is found, the provided <tt>rawFontFamily</tt>
         * value is returned.
         *
         * @param  {String} rawFontFamily The raw (case insensitive) font family value.
         * @return {String}               Correctly cased family name, or the <tt>rawFontFamily</tt> value, if
         *                                no match is found.
         */
        fontFamily: function fontFamily(rawFontFamily) {
            if (ALL.indexOf(rawFontFamily) !== -1) {
                return rawFontFamily;
            }

            var rawFontFamilyLowerCase = trim(rawFontFamily).toLowerCase();
            var result = find(ALL, function (familyName) {
                return familyName.toLowerCase() === rawFontFamilyLowerCase;
            });

            return result || rawFontFamily;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var template = __webpack_require__(1455);

    return Marionette.Layout.extend({

        template: template,

        regions: {
            "groupOverlay": ".group-overlay",
            "group": ".group"
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="group-overlay"></div>\n<div class="group"></div>\n';

}
return __p
}

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/transparent-pixel.gif";

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/image_default_next_scene.svg";

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/image_default_previous_scene.svg";

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetModel = __webpack_require__(62);

    /**
     * Base model for widgets owned by a company.
     *
     * @class AbstractWonedWidgetModel
     * @constructor
     */
    return AbstractWidgetModel.extend("AbstractOwnedWidgetModel", {

        defaults: _.extend({}, AbstractWidgetModel.prototype.defaults, {
            hideOnBackgroundScene: true,
            icon: null,
            visible: true,
            widgetId: null
        })
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interfaces__ = __webpack_require__(1461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets__ = __webpack_require__(786);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "SocialSharingWidgetNetwork", function() { return __WEBPACK_IMPORTED_MODULE_1__widgets__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "SocialSharingWidgetStyleCategory", function() { return __WEBPACK_IMPORTED_MODULE_1__widgets__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "SocialSharingWidgetStyleName", function() { return __WEBPACK_IMPORTED_MODULE_1__widgets__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__integrations__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__integrations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__integrations__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__animation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__animation__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__effect__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__effect__);
/* unused harmony namespace reexport */








/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VariantEntityType */
/* unused harmony export IconPlacementTypes */
/* unused harmony export ButtonWidgetTypes */
/* unused harmony export SceneTransitionType */
var VariantEntityType;
(function (VariantEntityType) {
    VariantEntityType["BREAKPOINT"] = "Breakpoint";
    VariantEntityType["LOCALIZATION"] = "Localization";
})(VariantEntityType || (VariantEntityType = {}));
var IconPlacementTypes;
(function (IconPlacementTypes) {
    IconPlacementTypes["BEFORE"] = "before";
    IconPlacementTypes["AFTER"] = "after";
})(IconPlacementTypes || (IconPlacementTypes = {}));
var ButtonWidgetTypes;
(function (ButtonWidgetTypes) {
    ButtonWidgetTypes["TEXT_ONLY"] = "TEXT_ONLY";
    ButtonWidgetTypes["ICON_ONLY"] = "ICON_ONLY";
    ButtonWidgetTypes["TEXT_AND_ICON"] = "TEXT_AND_ICON";
})(ButtonWidgetTypes || (ButtonWidgetTypes = {}));
var SceneTransitionType;
(function (SceneTransitionType) {
    SceneTransitionType["NONE"] = "none";
    SceneTransitionType["SLIDE_FROM_TOP"] = "slide-from-top";
    SceneTransitionType["SLIDE_FROM_BOTTOM"] = "slide-from-bottom";
    SceneTransitionType["SLIDE_FROM_LEFT"] = "slide-from-left";
    SceneTransitionType["SLIDE_FROM_RIGHT"] = "slide-from-right";
    SceneTransitionType["FADE"] = "fade";
})(SceneTransitionType || (SceneTransitionType = {}));


/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scale; });
var Scale = /** @class */ (function () {
    function Scale(x, y) {
        if (x === void 0) { x = 1.0; }
        if (y === void 0) { y = 1.0; }
        this.x = x;
        this.y = y;
    }
    Scale.getFrom = function (origin, current) {
        return new Scale(current.width / origin.width, current.height / origin.height);
    };
    Object.defineProperty(Scale.prototype, "widthFactor", {
        get: function () {
            return this.x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "heightFactor", {
        get: function () {
            return this.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "avereage", {
        get: function () {
            return (this.x + this.y) / 2;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "min", {
        get: function () {
            return Math.min(this.x, this.y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Scale.prototype, "max", {
        get: function () {
            return Math.max(this.x, this.y);
        },
        enumerable: true,
        configurable: true
    });
    return Scale;
}());



/***/ }),
/* 1463 */
/***/ (function(module, exports) {



/***/ }),
/* 1464 */
/***/ (function(module, exports) {



/***/ }),
/* 1465 */
/***/ (function(module, exports) {



/***/ }),
/* 1466 */
/***/ (function(module, exports) {



/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Class = __webpack_require__(26);

    var BASE_URL = "https://www.youtube.com/iframe_api";

    /**
     * Gets the YouTube IFrame Player API.
     *
     * @see https://developers.google.com/youtube/iframe_api_reference?hl=en
     *
     * @class YouTubeIframeAPI
     * @author Jens Svensson
     */
    var YouTubeIframeAPI = Class.extend({

        _deferred: null,

        _loadPerformed: false,

        /**
         * Constructor.
         */
        constructor: function constructor() {
            this._deferred = new $.Deferred();
        },


        /**
         * Starts loading the YouTube IFrame Player API.
         *
         * @return {Promise} A promise that resolves with the YouTube IFrame Player API
         * instance.
         */
        load: function load() {
            if (!this._loadPerformed) {
                this._startFetching();
            }
            // Guard for future loads
            this._loadPerformed = true;
            // Return a promise
            return this._deferred.promise();
        },


        /**
         * @private
         *
         * Starts fetching the YouTube IFrame Player API, and resolves the deferred
         * object if the load was successful.
         */
        _startFetching: function _startFetching() {
            var _this = this;

            // Create callback in the global scope
            window.onYouTubeIframeAPIReady = function () {
                // Cleanup and resolve
                delete window.onYouTubeIframeAPIReady;
                _this._deferred.resolve(window.YT);
            };

            // Load the client library
            $.getScript(BASE_URL).fail(this._deferred.reject);
        }
    });

    return new YouTubeIframeAPI();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1468 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dynamic-widget-tab" id="rectangle">\n    <p class="dynamic-widget-tab-label" font-size="12px">Product</p>\n</div>\n<div class="group-overlay"></div>\n<div class="group"></div>\n\n';

}
return __p
}

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CompositeWidgetCollectionView = __webpack_require__(779);

    return CompositeWidgetCollectionView.extend({

        className: "widget-container-inner dynamic-product-collection"

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

// TODO: this file appears to be an exact duplicate of SceneDropHandler.js - DEV-4316 describes this effort.
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var WidgetTypes = __webpack_require__(69);
    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var GeneralFunctions = __webpack_require__(193);

    return {

        ADD_UPLOAD_BARS: "add:upload:bars",

        WIDGET_OPTIONS: {
            "previous-scene": {
                width: 50,
                height: 50
            },
            "next-scene": {
                width: 50,
                height: 50
            },
            "text-enhanced": {
                width: 250,
                disableCentering: true
            },
            "youtube": {
                width: 240,
                height: 135
            },
            "line": {
                height: 25
            },
            "link": {
                width: 128,
                height: 128
            },
            "html": {
                width: 128,
                height: 128
            },
            "shape": {
                width: 128,
                height: 128
            },
            "embed": {
                width: 128,
                height: 128
            },
            "dynamic-product": {
                width: 100,
                height: 100
            }
        },

        /**
         * Given a drop event, computes the offset coordinates for it.
         *
         * @param {Number} pageX - Position of the mouse pointer, relative to the left edge of the document
         * @param {Number} pageY - Position of the mouse pointer, relative to the top edge of the document.
         * @param {Object} offset - Scene Editor offset.
         * @param {Number} scale - Scene Editor scale factor.
         * @returns {Object} Coordinates, as an object with x and y properties.
         * @private
         */
        getOffsetCoordinates: function getOffsetCoordinates(pageX, pageY, offset, scale) {
            return {
                x: (pageX - offset.left) / scale,
                y: (pageY - offset.top) / scale
            };
        },

        getOffsetCoordinatesXY: function getOffsetCoordinatesXY(pageX, pageY, offset, scale) {
            return {
                x: (pageX - offset.left) / scale.x,
                y: (pageY - offset.top) / scale.y
            };
        },

        /**
         * Takes a widget type and some options and creates a new widget.
         *
         * @param {Object} experienceSize   The experience size.
         * @param {Object} widgetDescriptor The widget descriptor.
         * @param {Object} options          Set of options.
         * @return {AbstractWidgetModel}    The created Widget.
         * @private
         */
        createWidget: GeneralFunctions.curry(function (experienceSize, widgetDescriptor, options) {
            var widget = new widgetDescriptor.modelClass(options);

            if (_.isFunction(widgetDescriptor.initializer)) {
                widgetDescriptor.initializer(widget, experienceSize);
            }

            return widget;
        }),

        /**
         * Creates a function that takes a minimal options and extends it with a
         * position and updates its width and height if they exist.
         *
         * @param {Number} experienceSize
         * @param {Object} point
         * @return {Function}
         * @private
         */
        makeExtendOptions: function makeExtendOptions(experienceSize, point) {
            return function (opt) {
                if (!opt) {
                    opt = {};
                }
                var options = _.clone(opt);

                options.left = point.x / experienceSize.width * 100;
                options.top = point.y / experienceSize.height * 100;

                // convert width and height to percentage
                if (options.width) {
                    options.width = options.width / experienceSize.width * 100;

                    if (!opt.disableCentering) {
                        options.left -= options.width / 2;
                    }
                }

                if (options.height) {
                    options.height = options.height / experienceSize.height * 100;

                    if (!opt.disableCentering) {
                        options.top -= options.height / 2;
                    }
                }
                return options;
            };
        },
        /**
         * Creates an options object based on a imageModel
         *
         * @param {Object} imageModel
         * @return {Object}
         * @private
         */
        createImageOptions: function createImageOptions(imageModel) {
            var options = {
                altText: imageModel.get("altText"),
                imageId: imageModel.get("id"),
                height: imageModel.get("height"),
                width: imageModel.get("width"),
                originalImageHeight: imageModel.get("height"),
                originalImageWidth: imageModel.get("width"),
                src: imageModel.get("url"),
                supportsResize: imageModel.get("supportsResize")
            };

            if (imageModel.get("sourceType")) {
                options.sourceType = imageModel.get("sourceType");
            }

            return options;
        },

        /**
         * Takes an array of uploading ImageModels, and returns a promise that
         * resolves once all imageModels have finished.
         *
         * @param {Array} imageModels  - Array of <tt>ImageModel</tt>'s
         * @return {Promise}        - Promise that resolves with uploaded
         *                            ImageModels (failed uploads are
         *                            rejected)
         */
        allImagesUploaded: function allImagesUploaded(imageModels) {
            var numOfFinishedUploads = 0;

            var numOfImageModels = imageModels.length;
            var deferred = $.Deferred();

            var increaseNumberOfUploads = function increaseNumberOfUploads() {
                var uploadedModels = void 0;

                numOfFinishedUploads++;

                if (numOfFinishedUploads >= numOfImageModels) {
                    uploadedModels = _.reject(imageModels, function (model) {
                        return model.get("uploadFailed");
                    });

                    deferred.resolve(uploadedModels);
                }
            };

            _.each(imageModels, function (imageModel) {
                imageModel.once("change:uploading change:uploadfailed", increaseNumberOfUploads);
            });

            return deferred.promise();
        },

        getWidgetDescriptor: function getWidgetDescriptor(dataTransfer) {
            try {
                var data = JSON.parse(dataTransfer.getData("Text"));

                return {
                    data: data,
                    descriptor: WidgetTypes.lookup(data.type, true) // true = silent -> "descriptor" can be falsey.
                };
            } catch (e) {
                // only on parse errors
                return {};
            }
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    /**
     * Maps currency
     *
     * @class CurrencyMapper
     * @constructor
     */

    return {

        _currencyMap: new Map([["en-US", "$"]]),

        getCurrencyMapping: function getCurrencyMapping(language) {
            if (this._currencyMap.has(language)) {
                return this._currencyMap.get(language);
            }
            throw new Error("Unsupported Language for Product Widget");
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        GuidelineModel = __webpack_require__(252);

    return Backbone.Collection.extend("GuidelineCollection", {
        model: GuidelineModel
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorEvents = __webpack_require__(17),
        ExperienceModel = __webpack_require__(58),
        LoggedInUserState = __webpack_require__(19),
        Permissions = __webpack_require__(22),
        Promise = __webpack_require__(21),
        PublishableMixin = __webpack_require__(793),
        PublishableState = __webpack_require__(65),
        RestApi = __webpack_require__(29),
        Scene = __webpack_require__(253),
        Syncer = __webpack_require__(50),
        SyncManager = __webpack_require__(44),
        UrlUtil = __webpack_require__(46),
        _require = __webpack_require__(530),
        COPY_CODE_BUTTON_STATE = _require.COPY_CODE_BUTTON_STATE,
        BUTTON_STATUS = _require.BUTTON_STATUS;

    var UUIDGenerator = __webpack_require__(250);

    /**
     * The values for SCENE_PLACEHOLDER_ID is fixed and is set by the API backend
     * @type {string}
     */
    var SCENE_PLACEHOLDER_ID = "111111111111111111111111";
    /**
     * The values for USER_PLACEHOLDER_ID is fixed and is set by the API backend
     * @type {string}
     */
    var USER_PLACEHOLDER_ID = "222222222222222222222222";
    /**
     * Editor experience model mixin.
     *
     * @class ExperienceModel
     * @constructor
     */
    return ExperienceModel.mixin("ExperienceModelEditorMixin", {

        defaults: {
            type: "Experience",
            version: null,
            createdBy: null,
            createdAt: 0,
            lastCommentedAt: null,
            unread: null,
            metadata: false // set by the backend!
        },

        relations: ExperienceModel.prototype.relations,

        mixin: PublishableMixin,

        computed: {
            // Computed and transient property used for unread comment handling
            unread: {},
            cncOutput: ""
        },

        // Clear these fields on duplicate, i.e. when we duplicate to save a new copy...
        clearOnClone: function clearOnClone(options) {
            if (options.duplicate) {
                return ["lastCommentedAt"]; // PublishableMixin handles publish attributes
            }
        },

        // Update these fields after the specified sync method has been performed on this model; common meta data
        // fields will always be updated where applicable, e.g. "id", "version", "createdBy", etc...
        updateOnSync: function updateOnSync(options) {
            if (options.sync === "push") {
                this.getNativeCode("PushExperiencePostSync");
            }
            if (options.sync === "save" || options.sync.indexOf("push") !== -1) {
                return ["lastCommentedAt"]; // could be set silently. PushableMixin will add publish attributes
            }
            // nothing!
        },
        transient: ["scale", "cncOutput", "selectedWidgetId"],

        /**
         * Return a distinguished user-friendly name of this experience. <p>
         *
         * This will include version and variant or localisation information if present. <p>
         *
         * If no name has been set yet, the type name will be returned ("Experience").
         *
         * @return {String} The distinguished name as described; never null.
         */
        _distinguishedName: function _distinguishedName() {
            return this.get("name") || this.__typeName;
        },

        url: function url() {
            return this.isNew() ? RestApi.pathToCollection(RestApi.Collections.EXPERIENCES) : RestApi.pathToSpecificResource(RestApi.Collections.EXPERIENCES, this.get("id"));
        },

        /**
         * Pushes this experience only, not any of its variants. <p>
         *
         * This will raise an exception if this experience is currently unsaved to ensure we do not try and push
         * unsaved experiences. In addition, any server errors like conflicts (409) are also reported. <p>
         *
         * The push will raise "sync:state" during pending push requests: "sync:state" = "syncing"
         * is triggered just before the push request is sent, "sync:state" = "synced" on success, or
         * "sync:state" = "failed" on push error. <p>
         *
         * @return {Promise} The promise for the push request; never falsey.
         * @throws {Error} If this experience has unsaved changes because of an earlier save error.
         */
        push: function push() {
            // Any non pushed changes to push?
            if (!this.hasNonPushedChanges()) {
                return Promise.resolved();
            }

            // Create sync options...
            var options = {
                method: "push",
                immutable: true,
                // Make sure we only push non-erroneous, non-destroyed experiences...
                validate: function validate() {
                    // Invoked with this model (target) as scope
                    var error = null;

                    if (this._destroyed) {
                        error = "destroyed";
                    } else if (this.syncState.actual.state === Syncer.State.Failed) {
                        error = "unsaved";
                    }

                    if (error) {
                        return "Cannot push " + error + " experience";
                    }
                    // no error
                },
                // Make sure user can publish!
                privilege: Permissions.Privileges.PUBLISH
            };

            // Execute!
            return this._execute(options, {
                // Not really a collection on the resource, but it's modelled that way in the API
                url: RestApi.pathToCollectionOnResource(RestApi.Collections.EXPERIENCES, this.get("id"), "push"),
                type: "PUT"
            }).promise;
        },

        getNativeCode: function getNativeCode(triggerOrigin) {
            var _this = this;

            // Any non pushed changes to push?
            if (!this.hasAtLeastState(PublishableState.PUSHED) || !LoggedInUserState.get("integrations").isNativeContentIntegrationsEnabled()) {
                return Promise.resolved();
            }

            var url = RestApi.pathToSpecificResource(RestApi.Collections.EXPERIENCE_CODES, this.get("id"));

            var getOperationPromise = SyncManager.sync({
                method: "get",
                promise: true,
                silent: true,
                fn: {
                    url: url,
                    type: "GET"
                },
                resultHandler: function resultHandler(cncOutput) {
                    _this.set("cncOutput", cncOutput);
                }
            }).promise();

            return getOperationPromise.then(function () {
                var eventProperties = {
                    experienceId: _this.get("id"),
                    experienceVersion: _this.get("version"),
                    experiencePushedVersion: _this.get("pushedVersion"),
                    triggerOrigin: triggerOrigin
                };

                _this.set(COPY_CODE_BUTTON_STATE, BUTTON_STATUS.enabled);
                EditorEvents.trigger(EditorEvents.constants.GET_CODE, eventProperties);
            });
        },

        destroy: function destroy(options) {
            // Make sure we have our own private copy, of other logic will affect our url. We know that Backbone.sync
            // will respect the url passed in the options, so we can generate it here, without saving the options
            // as state...
            if (options) {
                options.url = UrlUtil.appendParamObject(this.url(), options);
            }
            // Need to stop listening to events before doing the deletion, as otherwise we'll start adding
            // required scenes again...
            this.stopListening();

            // Call super to perform the destroy!
            return this.__super();
        },

        /**
         * This code checks to see if the experience is fully loaded
         * or if it contains nothing more than a placeholder scene and widgets.
         * @returns {boolean}
         */
        isExperienceShell: function isExperienceShell() {
            return this.get("overlayScene").get("id") === SCENE_PLACEHOLDER_ID && this.get("backgroundScene").get("id") === SCENE_PLACEHOLDER_ID && this.get("overlayScene").get("createdBy") === USER_PLACEHOLDER_ID;
        },

        /**
         * Checks if this experience only contains immutable metadata or if the experience is empty,
         * if so, fetches the full experience model from the server.
         *
         * @return {Promise} A promise/deferred object that resolves when the data has been
         *                   fetched, and the experience no longer contains only metadata.
         */
        fetchAll: function fetchAll() {
            var isImmutable = this.get("immutable");

            return isImmutable || this.isExperienceShell() ? this.fetch() : Promise.resolved(this);
            // resolve to this instance for consistency
        },

        /**
         * Returns a display friendly version of the experience name to use in templates
         *
         * @return {String} A display friendly version of the experience name.
         */
        getDisplayName: function getDisplayName() {
            return this.get("name");
        },
        /**
         * Returns <tt>true</tt> if the experience is considered "empty"
         * (no changes have been made), <tt>false</tt> if not. <p>
         *
         * Duplicated experiences are not considered empty!
         *
         * @return {Boolean} <tt>true</tt> if the experience is considered "empty"
         *                  (no changes have been made), <tt>false</tt> if not.
         */
        isEmpty: function isEmpty() {
            // This matches the API logic with additional support for not-persisted and clones! That is, "version"
            // defaults to null and null <= 1 is true. "version" cannot default to zero (0), as Mongo has issues with
            // zero for versioning, which the API explicitly has to handle...
            return this.get("version") <= 1 && !this.has("copyOf");
        },

        reindexScene: function reindexScene() {
            this.get("scenes").each(function (scene, index) {
                scene.set("sceneNumber", index + 1);
            });
        },

        /**
         * Adds a scene to the experience.
         *
         * @param {Number} [position] The position at which to add the scene. If unspecified, defaults to the end.
         * @param {Scene} [scene] The scene to add. If unspecified, a new scene is created.
         */
        addScene: function addScene(position, scene) {
            var scenes = this.get("scenes"),
                isSceneDuplicated = Boolean(scene),
                eventName = null,
                eventOptions = null;

            if (!position || position < 1 || position > scenes.length) {
                position = scenes.length + 1;
            }

            if (!scene) {
                scene = new Scene();
            }

            scene.set({
                sceneNumber: position
            });

            // fixes scene id not being generated in c3 experiences
            // check if scene doesn't have any id associated with it 
            this.listenTo(scene, "all", function () {
                if (!scene.get("id") && (0, _C3Utils.isC3Experience)()) {
                    scene.set({
                        id: UUIDGenerator.createUUID()
                    });
                }
            });

            scenes.add(scene, { at: position - 1 });
            this.reindexScene();

            if (isSceneDuplicated) {
                eventName = EditorEvents.constants.DUPLICATE_SCENE;
                eventOptions = { triggerOrigin: "DuplicateSceneButton" };
            } else {
                eventName = EditorEvents.constants.CREATE_SCENE;
                eventOptions = { triggerOrigin: "AddNewSceneButton" };
            }
            this._triggerEditorEvent(eventName, eventOptions);
        },

        removeScene: function removeScene(scene) {
            var scenes = this.get("scenes");
            scenes.remove(scene); // TODO: why do we not call scene.destroy() for consistency? Because of undo? If so, should be called sometime, no?
            this.reindexScene();
            this._triggerEditorEvent(EditorEvents.constants.DELETE_SCENE, {
                triggerOrigin: "DeleteSceneButton"
            });
        },

        /**
         * Swaps the specified scenes in the internal scene collection.
         *
         * @param {Scene} sceneA The first scene to swap.
         * @param {Scene} sceneB The second scene to swap.
         */
        swapScenes: function swapScenes(sceneA, sceneB) {
            var collection = this.get("scenes"),
                array = collection.models,
                sceneAIndex = array.indexOf(sceneA),
                sceneBIndex = array.indexOf(sceneB);

            // Swap position
            array[sceneAIndex] = array.splice(sceneBIndex, 1, array[sceneAIndex])[0];

            var sceneNumberA = sceneA.get("sceneNumber"),
                sceneNumberB = sceneB.get("sceneNumber");

            // Swap scene numbers
            sceneB.set("sceneNumber", sceneNumberA);
            sceneA.set("sceneNumber", sceneNumberB);

            var swappedScenes = [];

            swappedScenes[0] = sceneAIndex > sceneBIndex ? sceneA : sceneB;
            swappedScenes[1] = sceneAIndex < sceneBIndex ? sceneA : sceneB;

            this.trigger("scenes:swapped", {
                scenes: swappedScenes,
                a: {
                    fromSceneNumber: sceneNumberA,
                    toSceneNumber: sceneNumberB
                },
                b: {
                    fromSceneNumber: sceneNumberB,
                    toSceneNumber: sceneNumberA
                }
            });

            this._triggerEditorEvent(EditorEvents.constants.MOVE_SCENE, {
                triggerOrigin: "SwapSceneButton"
            });
        },

        /**
         * Returns <tt>true</tt> if this experience was created by the specified user.
         *
         * @param  {User} user The user.
         * @return {Boolean} <tt>true</tt> if this experience belongs to the specified user, <tt>false</tt> if not.
         */
        createdBy: function createdBy(user) {
            return this.get("createdBy") === user.get("id");
        },

        /**
         * Tracks Mix Panel events
         * @param {String} eventName The name of the event.
         * @param [Object} options A set of additional event properties to be sent.
         * @private
         */
        _triggerEditorEvent: function _triggerEditorEvent(eventName, options) {
            var eventProperties = {
                experienceId: this.get("id"),
                experienceVersion: this.get("version"),
                experiencePushedVersion: this.get("pushedVersion"),
                triggerOrigin: options.triggerOrigin
            };

            EditorEvents.trigger(eventName, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Scene = __webpack_require__(253);

    /**
     * Model for the overlay scene.
     *
     * @class OverlayScene
     * @constructor
     */
    return Scene.extend({
        defaults: _.defaults({
            sceneNumber: "overlay"
        }, Scene.prototype.defaults)
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Scene = __webpack_require__(253);

    /**
     * Model for the background scene.
     *
     * @class BackgroundScene
     * @constructor
     */
    return Scene.extend({
        defaults: _.defaults({
            sceneNumber: "background"
        }, Scene.prototype.defaults)
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Collection = __webpack_require__(7).Collection;
    var Scene = __webpack_require__(253);

    /**
     * A collection for scenes.
     *
     * @see Scene
     * @class SceneCollection
     */
    return Collection.extend({
        model: Scene
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var GroupAsset = __webpack_require__(525);
    var GroupValueFactory = __webpack_require__(1479);

    /**
     * A collection of group <i>assets</i>.
     *
     * @see GroupAsset
     *
     * @class GroupAssetCollection
     */
    return Backbone.Collection.extend("Group Asset Collection", {
        model: function model(attributes, options) {
            // Overwrite the value with the concrete data type/value
            attributes.value = GroupValueFactory.create(attributes);
            attributes.asset = options.assetFactory(attributes);

            return new GroupAsset(attributes);
        },


        // TODO: Put attach/detach in a editor specific mixin?
        attach: function attach(asset, value, valueType) {
            return this.add(GroupAsset.asAsset(asset, value, valueType));
        },


        /**
         * Removes the entry (or entries) by the specified asset and/or value.<p>
         *
         * If no value is specified, all the entries represented by the asset are removed.
         *
         * @param  {ImprovedModel} asset The asset.
         * @param  {*}             value The optional value.
         *
         * @return {Boolean}       <tt>true</tt> if entries where removed.
         */
        detach: function detach(asset, value) {
            var entriesToRemove = this.filter(function (internalAsset) {
                var assetFound = internalAsset.get("asset").get("id") === asset.get("id");
                var valueFound = true;

                if (value) {
                    valueFound = internalAsset.get("value") === value;
                }

                return assetFound && valueFound;
            });

            if (entriesToRemove) {
                return !!this.remove(entriesToRemove);
            }

            return false;
        },
        findAssetById: function findAssetById(id) {
            return this.find(function (asset) {
                return asset.get("id") === id;
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Class = __webpack_require__(26);
    var Preconditions = __webpack_require__(14);
    var GroupsDescriptor = __webpack_require__(371);

    var Type = GroupsDescriptor.AssetReferenceType;

    /**
     * Map of supported reference types, class (constructor function) to type (string).
     *
     * @private @type {Map.<Function, String>}
     */
    var types = GroupsDescriptor.assetReferenceTypes;

    /**
     * All static utilities for working with group references.
     *
     * @class GroupReference
     */
    var GroupReference = Class.extend("GroupReference", {}, {

        /**
         * Whether the specified type is considered valid/supported as a group reference type.
         *
         * @param  {String} type The reference type.
         * @return {Boolean}     <tt>true</tt> if the specified type is considered valid/supported as a group reference type.
         *
         * @see GroupsDescriptor
         */
        validType: function validType(type) {
            return _.contains(Type, type);
        },


        /**
         * Whether the specified reference is considered valid/supported as a group reference.
         *
         * @param  {ImprovedModel} reference The reference model.
         * @return {Boolean}           <tt>true</tt> if the specified reference is considered valid/supported as a group reference.
         *
         * @see GroupsDescriptor
         */
        validReference: function validReference(reference) {
            return reference && types.has(reference.constructor);
        },


        /**
         * Returns the reference type, as a string, from the specified reference.
         *
         * @param  {ImprovedModel} reference The reference model.
         * @return {String}           The type.
         */
        typeFromReference: function typeFromReference(reference) {
            Preconditions.checkState(GroupReference.validReference(reference), "Invalid reference: " + reference);

            return types.get(reference.constructor);
        },


        /**
         * Returns the simple JSON representation of the reference - describing the id and type.<p>
         *
         * Example given an experience model:
         * <pre>
         * {
         *     resourceId: "564c4a8be4b0f586d5e23361",
         *     resourceType: "Experience"
         * }
         * </pre>
         *
         * @param  {ImprovedModel} reference The model to reference.
         * @return {Object}        Object containing <tt>resourceId</tt> and <tt>resourceType</tt>.
         */
        toJSON: function toJSON(reference) {
            Preconditions.checkState(GroupReference.validReference(reference), "Invalid reference: " + reference);

            return {
                resourceId: reference.identifier(),
                resourceType: GroupReference.typeFromReference(reference)
            };
        }
    });

    return GroupReference;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Preconditions = __webpack_require__(14);
    var valueFactories = __webpack_require__(371).valueFactories;

    /**
     * A factory for creating concrete group values given the raw JSON attributes.
     *
     * @module GroupAssetFactory
     * @see GroupAssetCollection
     * @see GroupsDescriptor
     */
    return {

        /**
         * Creates a concrete/typed value from the raw JSON attributes.<p>
         *
         * Example (for a raw breakpoint type):
         *
         * <pre>
         * {
         *   "type": "Breakpoint",
         *   "reference": {
         *     "resourceId": "564c4a8be4b0f586d5e23361",
         *     "resourceType": "Experience"
         *   },
         *   "value": {
         *     "threshold": 0
         *   }
         * }
         * </pre>
         *
         * @param  {Object} attributes The raw JSON.
         * @return {*}                 The concrete value.
         */
        create: function create(attributes) {
            var type = attributes.type;
            var value = attributes.value;

            Preconditions.checkState(valueFactories.has(type), "Invalid type: " + type);

            // Since 'value' is optional, bail out here if undefined...
            if (!value) {
                return null;
            }

            var factory = valueFactories.get(type);

            return factory(value);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1481);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1482);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(527);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1484),
    ListCache = __webpack_require__(376),
    Map = __webpack_require__(529);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1485),
    hashDelete = __webpack_require__(1490),
    hashGet = __webpack_require__(1491),
    hashHas = __webpack_require__(1492),
    hashSet = __webpack_require__(1493);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(375);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(797),
    isMasked = __webpack_require__(1487),
    isObject = __webpack_require__(155),
    toSource = __webpack_require__(798);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1488);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(122);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1489 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1490 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(375);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(375);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(375);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(377);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(377);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(377);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(377);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(378);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1500 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(378);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(378);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(378);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1505);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(303),
    arrayMap = __webpack_require__(799),
    isArray = __webpack_require__(123),
    isSymbol = __webpack_require__(363);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(100);

    /**
     * The <i>Editor action mixin</i> adds editor related functionality to Viewer Actions, such as ensuring that
     * for example Custom JS Actions will not try and execute the JS as that will never work when in the Editor, only
     * when embedded on the client site. <p>
     *
     * Note: this will only be applied to top level Experiences, not Experiences loaded embedded via a direct url
     * when shown in the Editor.
     *
     * @class ActionEditorMixin
     */
    return Action.mixin("ActionEditorMixin", {

        embedded: true, // since it has an id and we do not want to call the server on sync!

        activate: function activate() {
            if (this._clientSpace) {
                this._log(Action.NOT_EMBEDDED_MESSAGE);
                alert(Action.NOT_EMBEDDED_MESSAGE);
                return false;
            }
            return this.__super();
        },

        /**
         * Returns a JSON object that uniquely identifies this Action so it can be selected in the Editor
         * when editing.
         *
         * @return {type:String, actionId:String} Returns a json object with the Action "type" and optionally
         *         the prototypical "actionId"; never falsey.
         */
        getIdentifier: function getIdentifier() {
            var identifier = {
                type: this.get("type")
            };

            // A company might have more than one owned action of a specific type. These actions
            // are distinguished by their actionId, that is the ID of the prototype action.
            if (this.get("actionId")) {
                identifier.actionId = this.get("actionId");
            }

            return identifier;
        }

    }, {
        NOT_EMBEDDED_MESSAGE: "Please test the Action when your Experience is embedded on your website and/or via Drag'n Drop Publishing."
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        pick = _require.pick;

    var ButtonWidgetPropertiesView = __webpack_require__(1508);
    var CompositeWidgetPropertiesView = __webpack_require__(878);
    var EmbedWidgetPropertiesView = __webpack_require__(1784);
    var HtmlWidgetPropertiesView = __webpack_require__(1786);
    var ImageWidgetPropertiesView = __webpack_require__(1788);
    var MaterialIcons = __webpack_require__(874);
    var LineWidgetPropertiesView = __webpack_require__(2048);
    var LinkWidgetPropertiesView = __webpack_require__(2050);
    var ProductWidgetPropertiesView = __webpack_require__(2052);
    var SalesforceCommerceWidgetModel = __webpack_require__(368);
    var SalesforceCommerceWidgetPropertiesView = __webpack_require__(2054);
    var SalesforceCommerceConnect = __webpack_require__(206);
    var SceneNavigationAction = __webpack_require__(191);
    var SceneNavigatorWidgetPropertiesView = __webpack_require__(2063);
    var ShapeWidgetPropertiesView = __webpack_require__(2065);
    var Size = __webpack_require__(84);
    var SocialSharingWidgetPropertiesView = __webpack_require__(2067);
    var Storage = __webpack_require__(34);
    var TextEnhancedWidgetPropertiesView = __webpack_require__(2069);
    var TextWidgetPropertiesView = __webpack_require__(2071);
    var YoutubeWidgetPropertiesView = __webpack_require__(2073);
    var DynamicProductWidgetPropertiesView = __webpack_require__(2084);
    var WidgetTypes = __webpack_require__(69);
    var LoggedInUserState = __webpack_require__(19);

    function suspendForEmailMode(viewModel) {
        var isEmailMode = viewModel.get("experience").get("emailModeEnabled");
        this.suspendedTooltip = "This widget cannot be used in email(s)";
        this.suspended = isEmailMode;
    }

    /** Common initializer for widget types not requiring a specific initializer. */
    var centerModel = function centerModel(model) {
        if (model.has("width") && model.has("height")) {
            model.set({
                left: model.get("left") - model.get("width") / 2,
                top: model.get("top") - model.get("height") / 2
            });
        }
    };

    /**
     * Mixes in Editor related WidgetType state. <p>
     *
     * Each constant can define an optional <tt>initializer(model: WidgetModel, experienceSize: Size)</tt>
     * function to be called immediately after creation in the editor when the widget icon is dropped on a Scene. <p>
     *
     * For widgets that can be disabled, the <tt>enabled(): Boolean</tt> callback can be implemented. If not specified,
     * the widget is enabled by default. <p>
     *
     * The <tt>order</tt> property determines the visual ordering of the widget icons in the side bar when editing
     * an Experience. A null <tt>order</tt> can be used for any prototypical widget to make it come last.
     *
     * @class WidgetTypes
     */
    return WidgetTypes.mixin({
        COMPOSITE: {
            order: 150,
            propertiesViewClass: CompositeWidgetPropertiesView,
            tooltip: "Create a link of any size on top of anything on the scene.",
            freeTransformConfig: {
                rotate: false,
                scaleUniform: false,
                scaleX: false,
                scaleY: false
            },
            enabled: function enabled() {
                return false;
            }
        },
        DYNAMIC_PRODUCT: {
            order: 160,
            propertiesViewClass: DynamicProductWidgetPropertiesView,
            tooltip: "Creates an Enhanced Product Widget",
            freeTransformConfig: {
                rotate: false,
                scaleUniform: false,
                scaleX: false,
                scaleY: false
            },
            enabled: function enabled() {
                return LoggedInUserState.get("companySettings").get("dynamicProductWidgetEnabled");
            },

            initializer: centerModel,
            suspend: suspendForEmailMode
        },
        SALESFORCE_COMMERCE: {
            order: 120, // last
            propertiesViewClass: SalesforceCommerceWidgetPropertiesView,
            tooltip: "Create links to the products in your Salesforce Commerce Cloud Account.",
            hideOnBackgroundScene: true,
            initializer: function initializer(model, experienceSize) {
                // Transform the fixedSize to the equivalent percentage.
                model.set({
                    width: SalesforceCommerceWidgetModel.FIXED_SIZE.width * 100 / experienceSize.width,
                    height: SalesforceCommerceWidgetModel.FIXED_SIZE.height * 100 / experienceSize.height
                });
            },
            enabled: function enabled() {
                return SalesforceCommerceConnect.isWidgetEnabled();
            },

            suspend: suspendForEmailMode
        },
        EMBED: {
            order: 40,
            propertiesViewClass: EmbedWidgetPropertiesView,
            tooltip: "Embed a URL.",
            freeTransformConfig: {
                rotate: false
            },
            initializer: centerModel,
            suspend: suspendForEmailMode
        },
        HTML: {
            order: 41,
            propertiesViewClass: HtmlWidgetPropertiesView,
            tooltip: "Insert HTML.",
            freeTransformConfig: {
                rotate: false
            },
            initializer: centerModel,
            enabled: function enabled() {
                return LoggedInUserState.get("companySettings").get("htmlWidgetEnabled");
            },

            suspend: suspendForEmailMode
        },
        IMAGE: {
            order: 20,
            propertiesViewClass: ImageWidgetPropertiesView,
            tooltip: "Insert an image.",
            initializer: function initializer(model, experienceSize) {
                var isLargerWidth = model.get("width") > 100;
                var isLargerHeight = model.get("height") > 100;

                var size = {
                    width: 60 / experienceSize.width * 100,
                    height: 75 / experienceSize.height * 100
                };

                var position = void 0;

                if (model.get("src")) {
                    if (isLargerWidth || isLargerHeight) {
                        // make sure the size is not bigger than scene
                        size = new Size(100, 100);
                        size = size.shrinkToAspectRatio(model.get("width") / model.get("height"));
                    } else {
                        size = {
                            width: model.get("width"),
                            height: model.get("height")
                        };
                    }

                    position = {
                        left: model.get("left"),
                        top: model.get("top")
                    };
                } else {
                    position = {
                        left: model.get("left") - size.width / 2,
                        top: model.get("top") - size.height / 2
                    };
                }

                model.set({
                    width: size.width,
                    height: size.height,
                    left: Math.max(position.left, 0),
                    top: Math.max(position.top, 0)
                });
            }
        },
        LINE: {
            order: 110,
            propertiesViewClass: LineWidgetPropertiesView,
            tooltip: "Create a line.",
            freeTransformConfig: {
                rotate: false,
                rotateScale: true,
                scaleUniform: false,
                scaleX: false,
                scaleY: false
            },
            initializer: centerModel
        },
        LINK: {
            order: 30,
            propertiesViewClass: LinkWidgetPropertiesView,
            tooltip: "Create a link of any size on top of anything on the scene.",
            hideOnBackgroundScene: true,
            initializer: centerModel
        },
        NEXT_SCENE: {
            order: 80,
            tooltip: "Use the standard arrow or select an image, from your image library, for users to click on and move to the next scene.",
            hideOnBackgroundScene: true,
            initializer: function initializer(model) {
                model.set("action", new SceneNavigationAction({ target: "next" }));
            },

            suspend: suspendForEmailMode
        },
        PREVIOUS_SCENE: {
            order: 70,
            tooltip: "Use the standard arrow or select an image, from your image library, for users to click on and move to the previous scene.",
            hideOnBackgroundScene: true,
            initializer: function initializer(model) {
                model.set("action", new SceneNavigationAction({ target: "previous" }));
            },

            suspend: suspendForEmailMode
        },
        PRODUCT: {
            order: null, // not ordered, handle specifically because typically only a single product widget implementation at runtime
            propertiesViewClass: ProductWidgetPropertiesView,
            hideOnBackgroundScene: true,
            initializer: centerModel,
            suspend: suspendForEmailMode
        },
        SCENE_NAVIGATOR: {
            order: 90,
            propertiesViewClass: SceneNavigatorWidgetPropertiesView,
            icon: "scene-slider",
            tooltip: "Use this widget to navigate between scenes.",
            hideOnBackgroundScene: true,
            freeTransformConfig: {
                rotate: false,
                scaleUniform: false,
                scaleX: false,
                scaleY: false
            },
            initializer: function initializer(model) {
                model.set("centeredPivotPoint", true);
            },

            suspend: suspendForEmailMode
        },
        SHAPE: {
            order: 100,
            propertiesViewClass: ShapeWidgetPropertiesView,
            icon: "box",
            tooltip: "Create a shape.",
            initializer: centerModel
        },
        SOCIAL_SHARING: {
            order: 60,
            propertiesViewClass: SocialSharingWidgetPropertiesView,
            icon: "social",
            tooltip: "Use this widget to share Experiences.",
            hideOnBackgroundScene: true,
            freeTransformConfig: {
                rotate: false,
                scaleUniform: false,
                scaleX: false,
                scaleY: false
            },
            initializer: function initializer(model) {
                var lastUsed = Storage.Local.get(Storage.Keys.LAST_USED_SOCIAL_PROPERTIES);
                var picked = pick(lastUsed, "style", "networks");
                picked.centeredPivotPoint = true;
                model.set(picked);
            },

            suspend: suspendForEmailMode
        },
        TEXT: {
            order: 10, // first
            propertiesViewClass: TextWidgetPropertiesView,
            tooltip: "Type in your text and select a font, size, color and/or animation.",
            freeTransformConfig: {
                edgeTranslate: true,
                scaleUniform: false,
                scaleY: false
            },
            initializer: function initializer(model) {
                // Apply last used text properties, if any...
                var lastUsed = Storage.Local.get(Storage.Keys.LAST_USED_TEXT_PROPERTIES);
                var picked = pick(lastUsed, "fontProvider", "color", "fontSize", "fontStyle", "fontMetadata", "fontWeight", "fontFamily");
                model.set(picked);
            },
            enabled: function enabled() {
                return LoggedInUserState.get("companySettings").get("textWidgetEnabled");
            }
        },
        TEXT_ENHANCED: {
            order: 11,
            propertiesViewClass: TextEnhancedWidgetPropertiesView,
            tooltip: "Type in your text and select a font, size, color and/or animation.",
            freeTransformConfig: {
                edgeTranslate: true,
                scaleUniform: false,
                scaleY: false
            },
            initializer: function initializer() {},
            enabled: function enabled() {
                return LoggedInUserState.get("companySettings").get("enhancedTextWidgetEnabled");
            }
        },
        YOUTUBE: {
            order: 50,
            propertiesViewClass: YoutubeWidgetPropertiesView,
            tooltip: "Insert a YouTube video.",
            initializer: function initializer(model) {
                if (!model.get("videoID")) {
                    centerModel(model);
                }
            },

            suspend: suspendForEmailMode
        },
        BUTTON: {
            order: 65,
            propertiesViewClass: ButtonWidgetPropertiesView,
            expandPropertyView: "buttonExpanded",
            tooltip: "Create a button.",
            hideOnBackgroundScene: true,
            freeTransformConfig: {
                rotate: true,
                scaleUniform: false,
                rotateScale: false,
                scaleX: false,
                scaleY: false
            },
            initializer: function initializer(model) {
                // Apply last used text properties, if any...
                var props = Storage.Local.get(Storage.Keys.LAST_USED_BUTTON_PROPERTIES);

                if (!props.icon) {
                    props.icon = MaterialIcons.modelFromId("play_circle_filled");
                }

                model.set(props, { silent: true });

                centerModel(model);
            }
        }
    }, function (descriptor) {
        // called once each constant has been mixed
        // For some odd reason, some icons are named inconsistently... :/
        if (!descriptor.icon) {
            descriptor.icon = descriptor.id;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ButtonWidgetModel = __webpack_require__(305);
    var AbstractWidgetPropertiesView = __webpack_require__(63);
    var AnimationPropertiesView = __webpack_require__(125);
    var ActionPropertiesView = __webpack_require__(205);
    var ColorPicker = __webpack_require__(208);
    var SizeAndPositionPropertiesView = __webpack_require__(70);
    var StylePropertiesView = __webpack_require__(559);
    var ButtonType = __webpack_require__(364);
    var IconPropertiesView = __webpack_require__(1757);
    var Storage = __webpack_require__(34);
    var LabelPropertiesView = __webpack_require__(1763);
    var _ = __webpack_require__(1);
    var template = __webpack_require__(1782);

    var EXPAND_PROPERTY = "buttonPropertiesExpanded";
    /**
     *
     * @class ButtonWidgetPropertiesView
     * @constructor
     *
     * @cfg {ButtonWidgetModel} model The model for the button widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("ButtonWidgetPropertiesView", {

        className: "button-widget-properties-view",

        expandProperty: EXPAND_PROPERTY,

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                ButtonType: ButtonType
            };
        },


        _backgroundColorPicker: null,

        ui: {
            legend: "[data-target=\".button-properties-container\"]",
            buttonProperties: ".button-properties-container",
            buttonBackgroundColorInput: ".button-background-color-input",
            buttonBackgroundColorBox: ".button-background-color-box",
            buttonTypeSelect: ".button-type"
        },

        regions: {
            labelProperties: ".label-properties-region",
            iconProperties: ".icon-properties-region",
            sizeAndPositionProperties: ".size-and-position-properties",
            styleProperties: ".style-properties",
            analyticsProperties: ".analytics-properties",
            animationProperties: ".animation-properties",
            actionProperties: ".action-properties"
        },

        bindings: {
            ".button-type": "buttonType",
            ".button-background-color-input": {
                observe: "backgroundColor",
                onSet: function onSet(color) {
                    return this._backgroundColorPicker.hexOrDefault(color);
                }
            },
            ".padding": {
                observe: "padding",
                onSet: function onSet(value) {
                    return parseInt(value, 10);
                }
            }
        },

        modelEvents: {
            "change": "_changeHandler",
            "change:buttonType": "_buttonTypeSelectHandler"
        },

        onClose: function onClose() {
            this._backgroundColorPicker.dispose();
        },
        onRender: function onRender() {
            this.__super();

            this.iconProperties.show(new IconPropertiesView({ model: this.model }));
            this.labelProperties.show(new LabelPropertiesView({ model: this.model }));
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                hideSizeControls: true,
                widgetView: this.options.widgetView
            }));
            this.actionProperties.show(new ActionPropertiesView({ model: this.model, showEffects: true }));
            this.styleProperties.show(new StylePropertiesView({ model: this.model, hideRadiusControls: false }));
            this.analyticsProperties.show(this._setAnalyticsLabel({ model: this.model }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this._backgroundColorPicker = new ColorPicker({
                color: this.model.get("backgroundColor"),
                input: this.ui.buttonBackgroundColorInput,
                colorBox: this.ui.buttonBackgroundColorBox,
                includeTransparency: true
            });

            this._renderButtonTypeSpecific();
        },
        _renderButtonTypeSpecific: function _renderButtonTypeSpecific() {
            var buttonType = this.model.get("buttonType");

            switch (buttonType) {
                case ButtonType.TEXT_AND_ICON:
                    this.labelProperties.currentView.unhide();
                    this.iconProperties.currentView.unhideIconPositionSelect();
                    this.iconProperties.currentView.unhide();
                    break;
                case ButtonType.TEXT_ONLY:
                    this.labelProperties.currentView.unhide();
                    this.iconProperties.currentView.unhideIconPositionSelect();
                    this.iconProperties.currentView.hide();
                    break;
                case ButtonType.ICON_ONLY:
                    this.labelProperties.currentView.hide();
                    this.iconProperties.currentView.hideIconPositionSelect();
                    this.iconProperties.currentView.unhide();
                    break;
                default:
                    throw new Error("unexpected buttonType: " + buttonType);
            }
        },
        _buttonTypeSelectHandler: function _buttonTypeSelectHandler() {
            this.model.set("buttonType", this.ui.buttonTypeSelect.val());
            this._renderButtonTypeSpecific();
        },
        _changeHandler: function _changeHandler() {
            var props = this.model.pick(_.keys(ButtonWidgetModel.buttonDefaults));
            Storage.Local.update(Storage.Keys.LAST_USED_BUTTON_PROPERTIES, props);
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(73),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(73),q=__webpack_require__(800);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(120),
        DateUtil = _require.DateUtil;

    var Marionette = __webpack_require__(10);
    var template = __webpack_require__(1513);

    /**
     * The footer.
     *
     * @class DefaultFooterView
     * @constructor
     */
    return Marionette.Layout.extend({
        template: template,

        templateHelpers: function templateHelpers() {
            return {
                currentYear: DateUtil.currentYear()
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1513 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span>Copyright &copy; 2013-' +
__e( currentYear ) +
' Zmags</span>\n\n';
 if (typeof CONFIG !== "undefined" && CONFIG.debug) { ;
__p += '\n    <p/><p>\n    <b>Viewer url</b>: ' +
__e( CONFIG.viewerApiBaseUrl ) +
'<br>\n    <b>Admin url</b>: ' +
__e( CONFIG.adminApiBaseUrl ) +
'\n    </p>\n';
 } ;
__p += '\n';

}
return __p
}

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = AnalyticsPropertiesView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_ui_common_InputComponent__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_ui_experience_widgets_toolbox_PropertiesView__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertyContainerComponent__ = __webpack_require__(257);




function AnalyticsPropertiesView(_a) {
    var labelValue = _a.labelValue, onChange = _a.onChange, emailModeEnabled = _a.emailModeEnabled;
    var handleChange = function (event) {
        event.preventDefault();
        onChange(event.target.value);
    };
    var tippyMessage = "Enter your label here to help decipher your data within Google Analytics. If it’s a product, add the SKU or if it’s a URL add the page title.";
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__editor_ui_experience_widgets_toolbox_PropertyContainerComponent__["a" /* PropertyContainerComponent */], { widgetSelected: true, label: "Analytics", name: "analytics", animateExpandOnMount: false, isEnabled: !emailModeEnabled },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "event-label", label: "Custom Event Label", tip: tippyMessage, isColStretched: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_shared_ui_common_InputComponent__["a" /* default */], { classNames: "full-width", type: "text", value: labelValue, onChange: handleChange, placeholder: "Enter your label here\u2026" })))));
}


/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelGroup__ = __webpack_require__(811);





var Accordion =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Accordion, _React$Component);

  function Accordion() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Accordion.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PanelGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.props, {
      accordion: true
    }), this.props.children);
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1517);
module.exports = __webpack_require__(79).Object.assign;


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(89);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1519) });


/***/ }),
/* 1518 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(199);
var getKeys = __webpack_require__(383);
var gOPS = __webpack_require__(1523);
var pIE = __webpack_require__(537);
var toObject = __webpack_require__(386);
var IObject = __webpack_require__(804);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(310)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(311);
var toIObject = __webpack_require__(384);
var arrayIndexOf = __webpack_require__(1521)(false);
var IE_PROTO = __webpack_require__(536)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(384);
var toLength = __webpack_require__(805);
var toAbsoluteIndex = __webpack_require__(1522);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(535);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1523 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1525);

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1526);
var $Object = __webpack_require__(79).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(89);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(810) });


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(381);
var anObject = __webpack_require__(308);
var getKeys = __webpack_require__(383);

module.exports = __webpack_require__(199) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(254).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_set_prototype_of__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_set_prototype_of__);

function _setPrototypeOf(o, p) {
  _setPrototypeOf = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_set_prototype_of___default.a ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_set_prototype_of___default.a.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1531);

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1532);
module.exports = __webpack_require__(79).Object.setPrototypeOf;


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(89);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1533).set });


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(309);
var anObject = __webpack_require__(308);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(533)(Function.call, __webpack_require__(1534).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(537);
var createDesc = __webpack_require__(382);
var toIObject = __webpack_require__(384);
var toPrimitive = __webpack_require__(803);
var has = __webpack_require__(311);
var IE8_DOM_DEFINE = __webpack_require__(801);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(199) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1536);
module.exports = __webpack_require__(79).Object.keys;


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(386);
var $keys = __webpack_require__(383);

__webpack_require__(1537)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(89);
var core = __webpack_require__(79);
var fails = __webpack_require__(310);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1539);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.isProp = isProp;
exports.defaultKey = defaultKey;
exports.isReactComponent = isReactComponent;

var _invariant = _interopRequireDefault(__webpack_require__(138));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */


function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1542);
module.exports = __webpack_require__(79).Object.entries;


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(89);
var $entries = __webpack_require__(814)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CloseButton__ = __webpack_require__(538);










var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Alert, _React$Component);

  function Alert() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Alert.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        onDismiss = _this$props.onDismiss,
        closeLabel = _this$props.closeLabel,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onDismiss", "closeLabel", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "alert",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), dismissable && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CloseButton__["a" /* default */], {
      onClick: onDismiss,
      label: closeLabel
    }), children);
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */].INFO, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('alert', Alert)));

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1545);
module.exports = __webpack_require__(79).Object.values;


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(89);
var $values = __webpack_require__(814)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);






 // TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  pullRight: false
};

var Badge =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Badge, _React$Component);

  function Badge() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Badge.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        pullRight = _this$props.pullRight,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["pullRight", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'pull-right': pullRight,
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('badge', Badge));

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);








var Breadcrumb =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Breadcrumb, _React$Component);

  function Breadcrumb() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Breadcrumb.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ol", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "navigation",
      "aria-label": "breadcrumbs",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('breadcrumb', Breadcrumb));

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);







var ButtonToolbar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonToolbar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "toolbar",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('btn-toolbar', ButtonToolbar));

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CarouselCaption__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselItem__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Glyphicon__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SafeAnchor__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__ = __webpack_require__(85);












 // TODO: `slide` should be `animate`.
// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any, ?event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Glyphicon__["a" /* default */], {
    glyph: "chevron-left"
  }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Glyphicon__["a" /* default */], {
    glyph: "chevron-right"
  }),
  nextLabel: 'Next'
};

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Carousel, _React$Component);

  function Carousel(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleMouseOver = _this.handleMouseOver.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleMouseOut = _this.handleMouseOut.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handlePrev = _this.handlePrev.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleNext = _this.handleNext.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    var defaultActiveIndex = props.defaultActiveIndex;
    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);
      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  _proto.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  _proto.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  _proto.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  _proto.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  _proto.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  _proto.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }

      index = 0;
    }

    this.select(index, e, 'next');
  };

  _proto.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }

      index = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  }; // This might be a public API.


  _proto.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  }; // This might be a public API.


  _proto.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  _proto.select = function select(index, e, direction) {
    clearTimeout(this.timeout); // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.

    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);
    var onSelect = this.props.onSelect;

    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = {
            direction: direction
          };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  _proto.waitForNext = function waitForNext() {
    var _this$props = this.props,
        slide = _this$props.slide,
        interval = _this$props.interval,
        activeIndexProp = _this$props.activeIndex;

    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  _proto.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;
    var controlClassName = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(children);
    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "prev",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(controlClassName, 'left'),
      onClick: this.handlePrev
    }, prevIcon, prevLabel && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, prevLabel)), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "next",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(controlClassName, 'right'),
      onClick: this.handleNext
    }, nextIcon, nextLabel && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, nextLabel))];
  };

  _proto.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];
    __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }), // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("ol", {
      className: Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'indicators')
    }, indicators);
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props2 = this.props,
        slide = _this$props2.slide,
        indicators = _this$props2.indicators,
        controls = _this$props2.controls,
        wrap = _this$props2.wrap,
        prevIcon = _this$props2.prevIcon,
        prevLabel = _this$props2.prevLabel,
        nextIcon = _this$props2.nextIcon,
        nextLabel = _this$props2.nextLabel,
        className = _this$props2.className,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["slide", "indicators", "controls", "wrap", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children"]);

    var _this$state = this.state,
        previousActiveIndex = _this$state.previousActiveIndex,
        direction = _this$state.direction;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes),
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut
    }), indicators && this.renderIndicators(children, activeIndex, bsProps), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner')
    }, __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
      var active = index === activeIndex;
      var previousActive = slide && index === previousActiveIndex;
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        active: active,
        index: index,
        animateOut: previousActive,
        animateIn: active && previousActiveIndex != null && slide,
        direction: direction,
        onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
      });
    })), controls && this.renderControls({
      wrap: wrap,
      children: children,
      activeIndex: activeIndex,
      prevIcon: prevIcon,
      prevLabel: prevLabel,
      nextIcon: nextIcon,
      nextLabel: nextLabel,
      bsProps: bsProps
    }));
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;
Carousel.Caption = __WEBPACK_IMPORTED_MODULE_7__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_8__CarouselItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["a" /* bsClass */])('carousel', Carousel));

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(CarouselCaption, _React$Component);

  function CarouselCaption() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CarouselCaption.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('carousel-caption', CarouselCaption));

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _end = _interopRequireDefault(__webpack_require__(1553));

exports.end = _end.default;

var _properties = _interopRequireDefault(__webpack_require__(540));

exports.properties = _properties.default;
var _default = {
  end: _end.default,
  properties: _properties.default
};
exports.default = _default;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _properties = _interopRequireDefault(__webpack_require__(540));

var _style = _interopRequireDefault(__webpack_require__(818));

function onEnd(node, handler, duration) {
  var fakeEvent = {
    target: node,
    currentTarget: node
  },
      backup;
  if (!_properties.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;

  if (_properties.default.end) {
    node.addEventListener(_properties.default.end, done, false);
    backup = setTimeout(function () {
      return done(fakeEvent);
    }, (duration || 100) * 1.5);
  } else setTimeout(done.bind(null, fakeEvent), 0);

  function done(event) {
    if (event.target !== event.currentTarget) return;
    clearTimeout(backup);
    event.target.removeEventListener(_properties.default.end, done);
    handler.call(this);
  }
}

onEnd._parseDuration = parseDuration;
var _default = onEnd;
exports.default = _default;

function parseDuration(node) {
  var str = (0, _style.default)(node, _properties.default.duration),
      mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

module.exports = exports["default"];

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1556));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(819));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);




/* eslint-disable jsx-a11y/label-has-for */





var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Checkbox, _React$Component);

  function Checkbox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Checkbox.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      ref: inputRef,
      type: "checkbox",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('checkbox', Checkbox));

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(74);










var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  componentClass: 'div'
};

var Clearfix =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Clearfix, _React$Component);

  function Clearfix() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Clearfix.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = "visible" + Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size) + "Block";

      if (elementProps[propName]) {
        classes["visible-" + size + "-block"] = true;
      }

      delete elementProps[propName];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('clearfix', Clearfix));

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);








var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  srOnly: false
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var ControlLabel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ControlLabel, _React$Component);

  function ControlLabel() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ControlLabel.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _this$props = this.props,
        _this$props$htmlFor = _this$props.htmlFor,
        htmlFor = _this$props$htmlFor === void 0 ? controlId : _this$props$htmlFor,
        srOnly = _this$props.srOnly,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["htmlFor", "srOnly", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('control-label', ControlLabel));

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(74);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
};
var defaultProps = {
  componentClass: 'div'
};

var Col =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Col, _React$Component);

  function Col() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Col.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = "" + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, "" + size + modifier + "-" + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');
      var hiddenPropName = size + "Hidden";

      if (elementProps[hiddenPropName]) {
        classes.push("hidden-" + size);
      }

      delete elementProps[hiddenPropName];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('col', Col));

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1565);

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1566);
module.exports = __webpack_require__(79).parseInt;


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(89);
var $parseInt = __webpack_require__(1567);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(254).parseInt;
var $trim = __webpack_require__(1568).trim;
var ws = __webpack_require__(821);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(89);
var defined = __webpack_require__(385);
var fails = __webpack_require__(310);
var spaces = __webpack_require__(821);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(823));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(85);














var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['click', 'mousedown'])
};
var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleRootClose = _this.handleRootClose.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this);

    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  _proto.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);
    return {
      items: items,
      activeIndex: activeIndex
    };
  };

  _proto.focusNext = function focusNext() {
    var _this$getItemsAndActi = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi.items,
        activeIndex = _this$getItemsAndActi.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  _proto.focusPrevious = function focusPrevious() {
    var _this$getItemsAndActi2 = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi2.items,
        activeIndex = _this$getItemsAndActi2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.tab:
        this.props.onClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, {
      source: 'rootClose'
    });
  };

  _proto.render = function render() {
    var _extends2,
        _this2 = this;

    var _this$props = this.props,
        open = _this$props.open,
        pullRight = _this$props.pullRight,
        labelledBy = _this$props.labelledBy,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["open", "pullRight", "labelledBy", "onSelect", "className", "rootCloseEvent", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper___default.a, {
      disabled: !open,
      onRootClose: this.handleRootClose,
      event: rootCloseEvent
    }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "menu",
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
      "aria-labelledby": labelledBy
    }), __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(child, {
        onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
      });
    })));
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-menu', DropdownMenu));

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1574);

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1575);
__webpack_require__(1581);
module.exports = __webpack_require__(79).Array.from;


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1576)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(1577)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(535);
var defined = __webpack_require__(385);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(807);
var $export = __webpack_require__(89);
var redefine = __webpack_require__(1578);
var hide = __webpack_require__(380);
var Iterators = __webpack_require__(545);
var $iterCreate = __webpack_require__(1579);
var setToStringTag = __webpack_require__(824);
var getPrototypeOf = __webpack_require__(1580);
var ITERATOR = __webpack_require__(203)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(380);


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(810);
var descriptor = __webpack_require__(382);
var setToStringTag = __webpack_require__(824);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(380)(IteratorPrototype, __webpack_require__(203)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(311);
var toObject = __webpack_require__(386);
var IE_PROTO = __webpack_require__(536)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(533);
var $export = __webpack_require__(89);
var toObject = __webpack_require__(386);
var call = __webpack_require__(1582);
var isArrayIter = __webpack_require__(1583);
var toLength = __webpack_require__(805);
var createProperty = __webpack_require__(1584);
var getIterFn = __webpack_require__(1585);

$export($export.S + $export.F * !__webpack_require__(1587)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(308);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(545);
var ITERATOR = __webpack_require__(203)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(381);
var createDesc = __webpack_require__(382);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1586);
var ITERATOR = __webpack_require__(203)('iterator');
var Iterators = __webpack_require__(545);
module.exports = __webpack_require__(79).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(534);
var TAG = __webpack_require__(203)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(203)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(255));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(255));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dropdown__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_splitComponentProps__ = __webpack_require__(391);








var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
});

var DropdownButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DropdownButton, _React$Component);

  function DropdownButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsSize", "bsStyle", "title", "children"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].Toggle, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, toggleProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].Menu, null, children));
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DropdownButton.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (DropdownButton);

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);








var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Form, _React$Component);

  function Form() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Form.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        horizontal = _this$props.horizontal,
        inline = _this$props.inline,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["horizontal", "inline", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    if (horizontal) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'horizontal'));
    }

    if (inline) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('form', Form));

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormControlFeedback__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormControlStatic__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(74);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  componentClass: 'input'
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormControl, _React$Component);

  function FormControl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControl.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _this$props = this.props,
        Component = _this$props.componentClass,
        type = _this$props.type,
        _this$props$id = _this$props.id,
        id = _this$props$id === void 0 ? controlId : _this$props$id,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        bsSize = _this$props.bsSize,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "type", "id", "inputRef", "className", "bsSize"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0; // input[type="file"] should not have .form-control.

    var classes;

    if (type !== 'file') {
      classes = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    } // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm


    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* SIZE_MAP */][bsSize] || bsSize;
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])({
        bsClass: 'input'
      }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;
FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_8__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_9__FormControlStatic__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('form-control', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].LARGE], FormControl)));

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Glyphicon__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);








var defaultProps = {
  bsRole: 'feedback'
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var FormControlFeedback =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlFeedback.prototype;

  _proto.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';

      case 'warning':
        return 'warning-sign';

      case 'error':
        return 'remove';

      default:
        return null;
    }
  };

  _proto.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);

    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Glyphicon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormControlStatic, _React$Component);

  function FormControlStatic() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlStatic.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('form-control-static', FormControlStatic));

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(85);









var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};
var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var FormGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormGroup, _React$Component);

  function FormGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        controlId = _this$props.controlId,
        validationState = _this$props.validationState;
    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  _proto.hasFeedback = function hasFeedback(children) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this.hasFeedback(child.props.children);
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        validationState = _this$props2.validationState,
        className = _this$props2.className,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["validationState", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('form-group', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);







var HelpBlock =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(HelpBlock, _React$Component);

  function HelpBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = HelpBlock.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('help-block', HelpBlock));

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Image, _React$Component);

  function Image() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Image.prototype;

  _proto.render = function render() {
    var _classes;

    var _this$props = this.props,
        responsive = _this$props.responsive,
        rounded = _this$props.rounded,
        circle = _this$props.circle,
        thumbnail = _this$props.thumbnail,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["responsive", "rounded", "circle", "thumbnail", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')] = responsive, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'rounded')] = rounded, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'circle')] = circle, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'thumbnail')] = thumbnail, _classes);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('img', Image));

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputGroupAddon__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputGroupButton__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(74);










var InputGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(InputGroup, _React$Component);

  function InputGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_5__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_6__InputGroupButton__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('input-group', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);







var InputGroupAddon =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupAddon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('input-group-addon', InputGroupAddon));

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);







var InputGroupButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(InputGroupButton, _React$Component);

  function InputGroupButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('input-group-btn', InputGroupButton));

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Jumbotron =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Jumbotron, _React$Component);

  function Jumbotron() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Jumbotron.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('jumbotron', Jumbotron));

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(74);









var Label =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Label, _React$Component);

  function Label() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Label.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), children);
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('label', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].DEFAULT, Label)));

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(85);









var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ListGroup, _React$Component);

  function ListGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        _this$props$component = _this$props.componentClass,
        Component = _this$props$component === void 0 ? getDefaultComponent(children) : _this$props$component,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__["a" /* default */];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), useListItem ? __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, {
        listItem: true
      });
    }) : children);
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ListGroup.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('list-group', ListGroup));

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Media__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(18);









var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom']),
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var MediaBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaBody, _React$Component);

  function MediaBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        align = _this$props.align,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_7__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('media-body', MediaBody));

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaHeading, _React$Component);

  function MediaHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('media-heading', MediaHeading));

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Media__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);








var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaLeft, _React$Component);

  function MediaLeft() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaLeft.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_6__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaLeft.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-left', MediaLeft));

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);







var MediaList =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaList, _React$Component);

  function MediaList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('media-list', MediaList));

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);







var MediaListItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaListItem, _React$Component);

  function MediaListItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaListItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('media', MediaListItem));

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Media__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);








var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaRight, _React$Component);

  function MediaRight() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaRight.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_6__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaRight.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-right', MediaRight));

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(66);











var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MenuItem, _React$Component);

  function MenuItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        href = _this$props.href,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        active = _this$props2.active,
        disabled = _this$props2.disabled,
        divider = _this$props2.divider,
        header = _this$props2.header,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["active", "disabled", "divider", "header", "onClick", "className", "style"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
        role: "separator",
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
        role: "heading",
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      role: "presentation",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "menuitem",
      tabIndex: "-1",
      onClick: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
    })));
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', MenuItem));

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Fade__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalBody__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalDialog__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalFooter__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalHeader__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalTitle__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_splitComponentProps__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__ = __webpack_require__(74);


























var propTypes = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */].propTypes, {
  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
  })
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
    timeout: Modal.TRANSITION_DURATION
  }));
}

function BackdropTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
    timeout: Modal.BACKDROP_TRANSITION_DURATION
  }));
}
/* eslint-enable no-use-before-define */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Modal, _React$Component);

  function Modal(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEntering = _this.handleEntering.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleWindowResize = _this.handleWindowResize.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDialogClick = _this.handleDialogClick.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.setModalRef = _this.setModalRef.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      style: {}
    };
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  _proto.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  _proto.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  _proto.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  _proto.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  _proto.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  _proto.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();

    var dialogHeight = dialogNode.scrollHeight;
    var document = __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        backdrop = _this$props.backdrop,
        backdropClassName = _this$props.backdropClassName,
        animation = _this$props.animation,
        show = _this$props.show,
        Dialog = _this$props.dialogComponentClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        onEntering = _this$props.onEntering,
        onExited = _this$props.onExited,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["backdrop", "backdropClassName", "animation", "show", "dialogComponentClass", "className", "style", "children", "onEntering", "onExited"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_23__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, baseModalProps, {
      ref: this.setModalRef,
      show: show,
      containerClassName: Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["e" /* prefix */])(props, 'open'),
      transition: animation ? DialogTransition : undefined,
      backdrop: backdrop,
      backdropTransition: animation ? BackdropTransition : undefined,
      backdropClassName: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["e" /* prefix */])(props, 'backdrop'), backdropClassName, inClassName),
      onEntering: Object(__WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
      onExited: Object(__WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited)
    }), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Dialog, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dialogProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.state.style, style),
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, inClassName),
      onClick: backdrop === true ? this.handleDialogClick : null
    }), children));
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;
Modal.Body = __WEBPACK_IMPORTED_MODULE_16__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_19__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_20__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_18__ModalFooter__["a" /* default */];
Modal.Dialog = __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */];
Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__["c" /* Size */].SMALL], Modal)));

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(830));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(831));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(1613));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(1615));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(543));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(1614));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(202));

var _on = _interopRequireDefault(__webpack_require__(830));

var _off = _interopRequireDefault(__webpack_require__(831));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(202));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(1618);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(546);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(255);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(394);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(1619);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(51);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(105);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(1621);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(835);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(1635);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(826);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(1636);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(396);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(256);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType2.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType2.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.backdropTransition;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        {
          appear: true,
          'in': _this2.props.show
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(313));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(1620);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(1622);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(547);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(1632);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(834);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(1633);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(1623));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(1624));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(832));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(832));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1627));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(833));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(255));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(255));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(394);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(396);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(256);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Grid__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavbarBrand__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarCollapse__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarHeader__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarToggle__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_createChainedFunction__ = __webpack_require__(66);




// TODO: Remove this pragma once we upgrade eslint-config-airbnb.

/* eslint-disable react/no-multi-comp */













var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,

  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};
var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })
};

var Navbar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Navbar, _React$Component);

  function Navbar(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleCollapse = _this.handleCollapse.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Navbar.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        expanded = _this$props.expanded,
        onSelect = _this$props.onSelect,
        collapseOnSelect = _this$props.collapseOnSelect;
    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_16__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  _proto.handleCollapse = function handleCollapse() {
    var _this$props2 = this.props,
        onToggle = _this$props2.onToggle,
        expanded = _this$props2.expanded;

    if (expanded) {
      onToggle(false);
    }
  };

  _proto.handleToggle = function handleToggle() {
    var _this$props3 = this.props,
        onToggle = _this$props3.onToggle,
        expanded = _this$props3.expanded;
    onToggle(!expanded);
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props4 = this.props,
        Component = _this$props4.componentClass,
        fixedTop = _this$props4.fixedTop,
        fixedBottom = _this$props4.fixedBottom,
        staticTop = _this$props4.staticTop,
        inverse = _this$props4.inverse,
        fluid = _this$props4.fluid,
        className = _this$props4.className,
        children = _this$props4.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props4, ["componentClass", "fixedTop", "fixedBottom", "staticTop", "inverse", "fluid", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1]; // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].INVERSE;
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-top')] = fixedTop, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["a" /* default */], {
      fluid: fluid
    }, children));
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;
Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["a" /* bsClass */])('navbar', Navbar);
var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Navbar, {
  expanded: 'onToggle'
});

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["componentClass", "className", "pullRight", "pullLeft"]);

    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === void 0 ? {
      bsClass: 'navbar'
    } : _ref2$$bs_navbar;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, suffix), pullRight && Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right'), pullLeft && Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;
  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  };
  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };
  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
    })
  };
  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_10__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_12__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_13__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_11__NavbarCollapse__["a" /* default */];
UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink'); // Set bsStyles here so they can be overridden.

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["c" /* bsStyles */])([__WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  })
};

var NavbarCollapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarCollapse.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'collapse');
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      in: navbarProps.expanded
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: bsClassName
    }, children));
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var NavbarHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarHeader, _React$Component);

  function NavbarHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'header');
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(66);








var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};
var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarToggle, _React$Component);

  function NavbarToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onClick", "className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };

    var buttonProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      type: 'button'
    }, props, {
      onClick: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button", buttonProps, children);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button", buttonProps, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "sr-only"
    }, "Toggle navigation"), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }));
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_splitComponentProps__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(85);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  activeHref: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
});

var NavDropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavDropdown, _React$Component);

  function NavDropdown() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavDropdown.prototype;

  _proto.isActive = function isActive(_ref, activeKey, activeHref) {
    var _this = this;

    var props = _ref.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        title = _this$props.title,
        activeKey = _this$props.activeKey,
        activeHref = _this$props.activeHref,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["title", "activeKey", "activeHref", "className", "style", "children"]);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().

    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1]; // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dropdownProps, {
      componentClass: "li",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
        active: active
      }),
      style: style
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Toggle, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, toggleProps, {
      useAnchor: true
    }), title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Menu, null, __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
        active: _this2.isActive(child, activeKey, activeHref)
      });
    })));
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavDropdown.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (NavDropdown);

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(51);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(835);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(1643);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(825);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(16);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(394);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(1644);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(396);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(256);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(845);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(1645);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(847);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(256);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(846));

var _offset = _interopRequireDefault(__webpack_require__(845));

var _offsetParent = _interopRequireDefault(__webpack_require__(1646));

var _scrollTop = _interopRequireDefault(__webpack_require__(847));

var _scrollLeft = _interopRequireDefault(__webpack_require__(1647));

var _style = _interopRequireDefault(__webpack_require__(547));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(313));

var _style = _interopRequireDefault(__webpack_require__(547));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(395));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(66);












/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */

function isOneOf(one, of) {
  if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array___default()(of)) {
    return of.indexOf(one) >= 0;
  }

  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */].propTypes, {
  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  // FIXME: This should be `defaultShow`.

  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  // Overridden props from `<Overlay>`.

  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),

  /**
   * @private
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),

  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDelayedShow = _this.handleDelayedShow.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDelayedHide = _this.handleDelayedHide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleHide = _this.handleHide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };

    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;
    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  var _proto = OverlayTrigger.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;
    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  _proto.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;

      _this2.hide();
    }, delay);
  };

  _proto.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;

      _this3.show();
    }, delay);
  };

  _proto.handleHide = function handleHide() {
    this.hide();
  }; // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  _proto.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  _proto.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  _proto.hide = function hide() {
    this.setState({
      show: false
    });
  };

  _proto.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      show: this.state.show,
      onHide: this.handleHide,
      target: this
    }), overlay);
  };

  _proto.show = function show() {
    this.setState({
      show: true
    });
  };

  _proto.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        trigger = _this$props.trigger,
        overlay = _this$props.overlay,
        children = _this$props.children,
        onBlur = _this$props.onBlur,
        onClick = _this$props.onClick,
        onFocus = _this$props.onFocus,
        onMouseOut = _this$props.onMouseOut,
        onMouseOver = _this$props.onMouseOver,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["trigger", "overlay", "children", "onBlur", "onClick", "onFocus", "onMouseOut", "onMouseOver"]);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;
    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    } // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.


    triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
      triggerProps.onMouseOver = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);
    return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (OverlayTrigger);

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1650);

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1651);
module.exports = __webpack_require__(79).Array.isArray;


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(89);

$export($export.S, 'Array', { isArray: __webpack_require__(1652) });


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(534);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);







var PageHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PageHeader, _React$Component);

  function PageHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PageHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h1", null, children));
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('page-header', PageHeader));

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(1655);


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_warning__);


var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message;

  if (typeof oldname === 'object') {
    message = oldname.message;
  } else {
    message = oldname + " is deprecated. Use " + newname + " instead.";

    if (link) {
      message += "\nYou can read more about it at " + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DeprecatedComponent, _Component);

      function DeprecatedComponent() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = DeprecatedComponent.prototype;

      _proto.componentWillMount = function componentWillMount() {
        deprecationWarning.apply(void 0, args);

        if (_Component.prototype.componentWillMount) {
          var _Component$prototype$;

          for (var _len2 = arguments.length, methodArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            methodArgs[_key2] = arguments[_key2];
          }

          (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
        }
      };

      return DeprecatedComponent;
    }(Component)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);
function _resetWarned() {
  warned = {};
}

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PagerItem__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__ = __webpack_require__(85);










var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var Pager =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Pager, _React$Component);

  function Pager() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pager.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onSelect", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, {
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
      });
    }));
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Pager.propTypes = propTypes;
Pager.Item = __WEBPACK_IMPORTED_MODULE_6__PagerItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('pager', Pager));

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaginationItem__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);








var Pagination =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Pagination, _React$Component);

  function Pagination() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pagination.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('pagination', Pagination);
Pagination.First = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["b" /* First */];
Pagination.Prev = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["e" /* Prev */];
Pagination.Ellipsis = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["a" /* Ellipsis */];
Pagination.Item = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["f" /* default */];
Pagination.Next = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["d" /* Next */];
Pagination.Last = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["c" /* Last */];
/* unused harmony default export */ var _unused_webpack_default_export = (Pagination);

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = PaginationItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return First; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Last; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(124);




/* eslint-disable react/no-multi-comp */




var propTypes = {
  eventKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  activeLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};
var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};
function PaginationItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);

  var Component = active || disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
    style: style,
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
      active: active,
      disabled: disabled
    })
  }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
    disabled: disabled
  }, props), children, active && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
    className: "sr-only"
  }, activeLabel)));
}
PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;

function createButton(name, defaultValue, label) {
  var _class, _temp;

  if (label === void 0) {
    label = name;
  }

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(_class, _React$Component);

    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          children = _this$props.children,
          className = _this$props.className,
          props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["disabled", "children", "className"]);

      var Component = disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */];
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        "aria-label": label,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
          disabled: disabled
        })
      }, props), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, null, children || defaultValue));
    };

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.displayName = name, _class.propTypes = {
    disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  }, _temp;
}

var First = createButton('First', "\xAB");
var Prev = createButton('Prev', "\u2039");
var Ellipsis = createButton('Ellipsis', "\u2026", 'More');
var Next = createButton('Next', "\u203A");
var Last = createButton('Last', "\xBB");

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uncontrollable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PanelBody__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PanelHeading__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PanelTitle__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PanelFooter__ = __webpack_require__(1664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PanelToggle__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PanelCollapse__ = __webpack_require__(849);

















var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + "--" + type : null;
};

var propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
var contextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};
var childContextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
  })
};

var Panel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Panel, _React$Component);

  function Panel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    };

    return _this;
  }

  var _proto = Panel.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        id = _this$props.id;
    var idKey = eventKey == null ? id : eventKey;
    var ids;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;
      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  _proto.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? warning(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps))
    }), children);
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Panel.propTypes = propTypes;
Panel.contextTypes = contextTypes;
Panel.childContextTypes = childContextTypes;
var UncontrolledPanel = __WEBPACK_IMPORTED_MODULE_7_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('panel', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* Style */].DEFAULT, Panel)), {
  expanded: 'onToggle'
});

__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default()(UncontrolledPanel, {
  Heading: __WEBPACK_IMPORTED_MODULE_12__PanelHeading__["a" /* default */],
  Title: __WEBPACK_IMPORTED_MODULE_13__PanelTitle__["a" /* default */],
  Body: __WEBPACK_IMPORTED_MODULE_11__PanelBody__["a" /* default */],
  Footer: __WEBPACK_IMPORTED_MODULE_14__PanelFooter__["a" /* default */],
  Toggle: __WEBPACK_IMPORTED_MODULE_15__PanelToggle__["a" /* default */],
  Collapse: __WEBPACK_IMPORTED_MODULE_16__PanelCollapse__["a" /* default */]
});

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledPanel);

/***/ }),
/* 1660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelCollapse__ = __webpack_require__(849);







var propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
var defaultProps = {
  collapsible: false
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

var PanelBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelBody, _React$Component);

  function PanelBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        collapsible = _this$props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    var body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'body'))
    }), children);

    if (collapsible) {
      body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PanelCollapse__["a" /* default */], null, body);
    }

    return body;
  };

  return PanelBody;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelBody.propTypes = propTypes;
PanelBody.defaultProps = defaultProps;
PanelBody.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelBody));

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);








var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })
};

var PanelHeading =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelHeading, _React$Component);

  function PanelHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        Component = _this$props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "className", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading'))
    }), children);
  };

  return PanelHeading;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PanelHeading.propTypes = propTypes;
PanelHeading.defaultProps = defaultProps;
PanelHeading.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelHeading));

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PanelToggle__ = __webpack_require__(850);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a,

  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })
};
var defaultProps = {
  componentClass: 'div'
};

var PanelTitle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelTitle, _React$Component);

  function PanelTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        toggle = _this$props.toggle,
        Component = _this$props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "className", "toggle", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PanelToggle__["a" /* default */], null, children);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title'))
    }), children);
  };

  return PanelTitle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelTitle.propTypes = propTypes;
PanelTitle.defaultProps = defaultProps;
PanelTitle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelTitle));

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);






var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

var PanelFooter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelFooter, _React$Component);

  function PanelFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'footer'))
    }), children);
  };

  return PanelFooter;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelFooter.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelFooter));

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);








var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};
var defaultProps = {
  placement: 'right'
};

var Popover =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Popover, _React$Component);

  function Popover() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Popover.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        title = _this$props.title,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "title", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "tooltip",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: outerStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "arrow",
      style: arrowStyle
    }), title && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h3", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title')
    }, title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content')
    }, children));
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('popover', Popover));

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__ = __webpack_require__(85);










var ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */

function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];

  if (!children) {
    return null;
  }

  var error = null;
  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }
    /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */


    var element = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ProgressBar, null);
    if (child.type === element.type) return;
    var childIdentifier = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
  });
  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ProgressBar, _React$Component);

  function ProgressBar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ProgressBar.prototype;

  _proto.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["min", "now", "max", "label", "srOnly", "striped", "active", "className", "style"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "progressbar",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes),
      style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        width: getPercentage(now, min, max) + "%"
      }, style),
      "aria-valuenow": now,
      "aria-valuemin": min,
      "aria-valuemax": max
    }), srOnly ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, label) : label);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        isChild = _this$props.isChild,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["isChild"]);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["min", "now", "max", "label", "srOnly", "striped", "active", "bsClass", "bsStyle", "className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, wrapperProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'progress')
    }), children ? __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        isChild: true
      });
    }) : this.renderProgressBar({
      min: min,
      now: now,
      max: max,
      label: label,
      srOnly: srOnly,
      striped: striped,
      active: active,
      bsClass: bsClass,
      bsStyle: bsStyle
    }));
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('progress-bar', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), ProgressBar)));

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);




/* eslint-disable jsx-a11y/label-has-for */





var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Radio, _React$Component);

  function Radio() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      ref: inputRef,
      type: "radio",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('radio', Radio));

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);







 // TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element.isRequired,

  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ResponsiveEmbed.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        a16by9 = _this$props.a16by9,
        a4by3 = _this$props.a4by3,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["a16by9", "a4by3", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '16by9')] = a16by9, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(classes)
    }, Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'item'))
    })));
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Row =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Row, _React$Component);

  function Row() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('row', Row));

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SplitToggle__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(391);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,

  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
});

var SplitButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(SplitButton, _React$Component);

  function SplitButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        toggleLabel = _this$props.toggleLabel,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsSize", "bsStyle", "title", "toggleLabel", "children"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, buttonProps, {
      disabled: props.disabled,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SplitToggle__["a" /* default */], {
      "aria-label": toggleLabel || title,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Menu, null, children));
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SplitButton.propTypes = propTypes;
SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_7__SplitToggle__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (SplitButton);

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DropdownToggle__ = __webpack_require__(827);





var SplitToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(SplitToggle, _React$Component);

  function SplitToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitToggle.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DropdownToggle__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_3__DropdownToggle__["a" /* default */].defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabContainer__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TabContent__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabPane__ = __webpack_require__(851);








var propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */].propTypes, {
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
});

var Tab =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Tab, _React$Component);

  function Tab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.render = function render() {
    var props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.props); // These props are for the parent `<Tabs>` rather than the `<TabPane>`.


    delete props.title;
    delete props.disabled;
    delete props.tabClassName;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Tab.propTypes = propTypes;
Tab.Container = __WEBPACK_IMPORTED_MODULE_4__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_5__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Tab);

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(18);







var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Table, _React$Component);

  function Table() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Table.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        striped = _this$props.striped,
        bordered = _this$props.bordered,
        condensed = _this$props.condensed,
        hover = _this$props.hover,
        responsive = _this$props.responsive,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["striped", "bordered", "condensed", "hover", "responsive", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = striped, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'bordered')] = bordered, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'condensed')] = condensed, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("table", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')
      }, table);
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('table', Table));

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Nav__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavItem__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TabContainer__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContent__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(85);














var TabContainer = __WEBPACK_IMPORTED_MODULE_10__TabContainer__["a" /* default */].ControlledComponent;
var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['tabs', 'pills']),

  /**
   * Sets a default animation strategy. Use `false` to disable, `true`
   * to enable the default `<Fade>` animation, or a react-transition-group
   * v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey;
  __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Tabs, _React$Component);

  function Tabs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tabs.prototype;

  _proto.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__NavItem__["a" /* default */], {
      eventKey: eventKey,
      disabled: disabled,
      className: tabClassName
    }, title);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        onSelect = _this$props.onSelect,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        _this$props$activeKey = _this$props.activeKey,
        activeKey = _this$props$activeKey === void 0 ? getDefaultActiveKey(children) : _this$props$activeKey,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["id", "onSelect", "animation", "mountOnEnter", "unmountOnExit", "bsClass", "className", "style", "children", "activeKey"]);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TabContainer, {
      id: id,
      activeKey: activeKey,
      onSelect: onSelect,
      className: className,
      style: style
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Nav__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      role: "tablist"
    }), __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TabContent__["a" /* default */], {
      bsClass: bsClass,
      animation: animation,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit
    }, children)));
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('tab', Tabs);
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(Tabs, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);




/* eslint-disable jsx-a11y/alt-text */





var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * alt property that is passed down to the image inside this component
   */
  alt: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * href property that is passed down to the image inside this component
   */
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var Thumbnail =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Thumbnail, _React$Component);

  function Thumbnail() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Thumbnail.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        src = _this$props.src,
        alt = _this$props.alt,
        onError = _this$props.onError,
        onLoad = _this$props.onLoad,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["src", "alt", "onError", "onLoad", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */] : 'div';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
      src: src,
      alt: alt,
      onError: onError,
      onLoad: onLoad
    }), children && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "caption"
    }, children));
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Thumbnail.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('thumbnail', Thumbnail));

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonGroup__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ToggleButton__ = __webpack_require__(852);











var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['checkbox', 'radio']).isRequired
};
var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButtonGroup.prototype;

  _proto.getValues = function getValues() {
    var value = this.props.value;
    return value == null ? [] : [].concat(value);
  };

  _proto.handleToggle = function handleToggle(value) {
    var _this$props = this.props,
        type = _this$props.type,
        onChange = _this$props.onChange;
    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }

      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange(values.concat([value]));
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        type = _this$props2.type,
        name = _this$props2.name,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["children", "type", "name"]);

    var values = this.getValues();
    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_5_invariant___default()(false) : void 0;
    delete props.onChange;
    delete props.value; // the data attribute is required b/c twbs css uses it in the selector

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ButtonGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      "data-toggle": "buttons"
    }), __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      var _child$props = child.props,
          value = _child$props.value,
          onChange = _child$props.onChange;

      var handler = function handler() {
        return _this.handleToggle(value);
      };

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
        type: type,
        name: child.name || name,
        checked: values.indexOf(value) !== -1,
        onChange: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(onChange, handler)
      });
    }));
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;
var UncontrolledToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(ToggleButtonGroup, {
  value: 'onChange'
});
UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_10__ToggleButton__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledToggleButtonGroup);

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(18);








var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string])
};
var defaultProps = {
  placement: 'right'
};

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Tooltip, _React$Component);

  function Tooltip() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tooltip.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "tooltip",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: outerStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'arrow'),
      style: arrowStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner')
    }, children));
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('tooltip', Tooltip));

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__ = __webpack_require__(74);








var Well =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Well, _React$Component);

  function Well() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Well.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('well', Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__["c" /* Size */].SMALL], Well)));

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(18);
/* unused harmony reexport bootstrapUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(66);
/* unused harmony reexport createChainedFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(85);
/* unused harmony reexport ValidComponentChildren */







/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = OnLoadAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_select2_react_component__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_ui_common_InputComponent__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_underscore__);




var onloadActions = [];
var LoggedInUserState = __webpack_require__(19), Configuration = __webpack_require__(27), Storage = __webpack_require__(34);
function OnLoadAction(props) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.params || []), params = _a[0], setParams = _a[1];
    // If permissionFlag is false we don't render OnLoadAction component
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), permissionFlag = _b[0], setPermissionFlag = _b[1];
    var getOnloadSettings = function () {
        var companyId = LoggedInUserState.attributes.company.id, settingName = 'onloadActionEnabled', endpointUrl = Configuration.creatorSettingApiBaseUrl + "/v1/settings/" + companyId + "?name=" + settingName, token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"), bearerToken = "Bearer " + token;
        var options = {
            method: "GET",
            headers: {
                "Authorization": bearerToken
            }
        };
        fetch(endpointUrl, options)
            .then(function (res) { return res.json(); })
            .then(function (data) {
            Storage.Local.update(Storage.Keys.ONLOAD_ACTION_ENABLED, data);
            if (data.onloadActionEnabled)
                setPermissionFlag(data.onloadActionEnabled);
        })
            .catch(function (err) { return console.log(err); });
    };
    var isActionEnabled = function () {
        var initialLoadCount = Storage.Local.get(Storage.Keys.ONLOAD_ACTION_ENABLED, Storage.Keys.ONLOAD_COMPONENT_INIT_COUNT) || 0;
        Storage.Local.update(Storage.Keys.ONLOAD_ACTION_ENABLED, Storage.Keys.ONLOAD_COMPONENT_INIT_COUNT, ++initialLoadCount);
        if (initialLoadCount <= 1) {
            getOnloadSettings();
        }
        else {
            var isEnabled = Storage.Local.get(Storage.Keys.ONLOAD_ACTION_ENABLED, "onloadActionEnabled");
            setPermissionFlag(isEnabled);
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(isActionEnabled, [permissionFlag]);
    // Retrieve all the customJs action
    var getOnLoadActions = function () {
        var protoType = LoggedInUserState.get("prototypeActionCollection").filter(function (prototype) { return prototype.get("action").get("type") === "customJs" /* CUSTOM_JS */; });
        // onloadActions.length - 1 = Remove the default option and then compare with protoType.length
        if (protoType.length === onloadActions.length - 1) {
            return onloadActions;
        }
        onloadActions = [];
        // Default Option
        onloadActions.push({
            label: 'None',
            value: 'None',
            model: { name: '' },
        });
        // Take all the actions from prototype and push into onloadActions[]
        protoType.forEach(function (obj) {
            var attr = obj.attributes.action.attributes;
            onloadActions.push({
                label: attr.name,
                value: attr.name,
                model: {
                    type: "onloadJs" /* ONLOAD_JS */,
                    actionId: attr.actionId,
                    code: attr.code,
                    parameters: attr.parameters,
                    name: attr.name,
                },
            });
        });
        return onloadActions;
    };
    // Triggers when selection in dropdown changes
    var handleActionChange = function (value) {
        var currentAction = onloadActions.find(function (opt) { return opt.label === value; });
        // Sync state with props - onChange method return Array<OnLoadActionParameters>
        setParams(props.onChange(currentAction));
    };
    // Triggers when input field loses focus
    var handleParamInputChange = function (e) {
        e.preventDefault();
        var currentAction = onloadActions.find(function (act) { return act.model.name === props.name; });
        currentAction.model.parameters = params.reduce(function (obj, item) { return ((obj[item.paramLabel] = item.paramValue), obj); }, {});
        // Sync state with props - onChange method return Array<OnLoadActionParameters>
        setParams(props.onChange(currentAction));
    };
    // Triggers when there is a change in input field (keyup, keydown event)
    var updateParamState = function (e, index) {
        e.preventDefault();
        var label = e.target.placeholder;
        var value = e.target.value;
        setParams(function (params) {
            var temp = params.slice();
            temp[index] = { paramLabel: label, paramValue: value };
            return temp;
        });
    };
    var onloadActionsOptions = function () {
        var actions = getOnLoadActions();
        return actions.map(function (el) { return ({ label: el.label, value: el.value }); });
    };
    var styleClasses = {
        sectionHeading: "onload-label",
        inputDefault: "onload-input full-width",
        mainContainer: "onload-section",
        inputContainer: "zmags-input-control"
    };
    return (permissionFlag ?
        (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: styleClasses.mainContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: styleClasses.inputContainer },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", { className: styleClasses.sectionHeading }, "On load Action Type: "),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_select2_react_component__["a" /* Select2 */], { placeholder: "None", value: props.name, data: onloadActionsOptions(), update: function (value) { return handleActionChange(value); } }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { marginTop: "0.7rem" } }),
                !Object(__WEBPACK_IMPORTED_MODULE_3_underscore__["isEmpty"])(props.parameters) &&
                    params.map(function (_, index) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_ui_common_InputComponent__["a" /* default */], { classNames: styleClasses.inputDefault, type: "text", value: params[index].paramValue, placeholder: params[index].paramLabel, onChange: function (e) { return updateParamState(e, index); }, onBlur: function (e) { return handleParamInputChange(e); }, key: index })); })))) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null));
}


/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__select2__ = __webpack_require__(1683);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__select2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auto_complete__ = __webpack_require__(1685);
/* unused harmony namespace reexport */
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);






/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Select2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2_component__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);






/**
 * @public
 */
var Select2 = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(Select2, _super);
    function Select2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hoveringValue = null;
        _this.option = null;
        _this.isOpen = false;
        _this.innerSearchText = '';
        _this.lastScrollTopIndex = 0;
        _this.value = _this.props.value;
        _this.onChange = function (e) {
            _this.searchText = e.currentTarget.value;
            _this.setState({ searchText: _this.searchText });
        };
        return _this;
    }
    Object.defineProperty(Select2.prototype, "searchText", {
        get: function () {
            return this.innerSearchText;
        },
        set: function (text) {
            if (this.props.customSearchEnabled && this.props.search) {
                this.props.search(text);
            }
            this.innerSearchText = text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select2.prototype, "dropdownStyle", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3_select2_component__["b" /* getDropdownStyle */](this.isOpen);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select2.prototype, "containerStyle", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3_select2_component__["a" /* getContainerStyle */](this.props.disabled, this.isOpen);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select2.prototype, "selectionStyle", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3_select2_component__["l" /* getSelectionStyle */](this.props.multiple);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select2.prototype, "isSearchboxHidden", {
        get: function () {
            return this.props.customSearchEnabled
                ? false
                : __WEBPACK_IMPORTED_MODULE_3_select2_component__["m" /* isSearchboxHiddex */](this.props.data, this.props.minCountForSearch);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Select2.prototype, "searchStyle", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3_select2_component__["k" /* getSearchStyle */](this.isSearchboxHidden);
        },
        enumerable: false,
        configurable: true
    });
    Select2.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps.value !== this.value) {
            this.value = nextProps.value;
            this.setState({ value: nextProps.value }, function () {
                _this.updateOptionAndHoveringValue();
            });
        }
    };
    Select2.prototype.updateOptionAndHoveringValue = function () {
        var option = __WEBPACK_IMPORTED_MODULE_3_select2_component__["i" /* getOptionsByValue */](this.props.data, this.value, this.props.multiple);
        if (option !== null) {
            this.option = option;
            this.setState({ option: this.option });
        }
        if (!Array.isArray(option)) {
            this.hoveringValue = this.value;
        }
        this.setState({ hoveringValue: this.hoveringValue });
    };
    Select2.prototype.UNSAFE_componentWillMount = function () {
        this.updateOptionAndHoveringValue();
    };
    Select2.prototype.componentDidMount = function () {
        var theElement = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this);
        this.searchInputElement = theElement.childNodes[1].childNodes[0].childNodes[0].childNodes[0];
        this.resultsElement = theElement.childNodes[1].childNodes[0].childNodes[1].childNodes[0];
        this.mounted = true;
        this.value = this.props.value;
    };
    Select2.prototype.componentWillUnmount = function () {
        this.mounted = false;
        this.cancelFocusoutTimer();
    };
    Select2.prototype.render = function () {
        var _this = this;
        var results = this.renderResult();
        var selection = this.renderSelection();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this.containerStyle },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: 'selection', onClick: function () { return _this.toggleOpenAndClose(); } },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this.selectionStyle, role: 'combobox' }, selection)),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this.dropdownStyle },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: 'select2-dropdown select2-dropdown--below' },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this.searchStyle },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", { value: this.searchText, onChange: this.onChange, onKeyDown: function (e) { return _this.keyDown(e); }, onKeyUp: function (e) { return _this.keyUp(e); }, onKeyPress: function (e) { return _this.keyPress(e); }, onFocus: function () { return _this.cancelFocusoutTimer(); }, onBlur: function () { return _this.focusout(); }, className: 'select2-search__field', type: 'search', role: 'textbox', autoComplete: 'off', autoCorrect: 'off', autoCapitalize: 'off', maxLength: this.props.maximumInputLength, spellCheck: false })),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: 'select2-results' },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: 'select2-results__options', role: 'tree', tabIndex: -1, onKeyDown: function (e) { return _this.keyDown(e); }, onFocus: function () { return _this.cancelFocusoutTimer(); }, onBlur: function () { return _this.focusout(); } }, results))))));
    };
    Select2.prototype.renderSelection = function () {
        var _this = this;
        if (this.props.multiple) {
            var items = this.option.map(function (op, i) { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: 'select2-selection__choice', title: op.label, key: i },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { onClick: function (e) { return _this.removeSelection(e, op); }, className: 'select2-selection__choice__remove', role: 'presentation' }, "\u00D7"),
                op.label)); });
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: 'select2-selection__rendered' }, items));
        }
        else {
            var option = this.option;
            var label = option
                ? (option.component ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](option.component, { option: option }) : option.label)
                : __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: 'select2-selection__placeholder' }, this.props.placeholder);
            return [
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { key: 'label', className: 'select2-selection__rendered', title: option ? option.label : '' }, label),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { key: 'arrow', className: 'select2-selection__arrow', role: 'presentation' },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("b", { role: 'presentation' }))
            ];
        }
    };
    Select2.prototype.renderResult = function () {
        var _this = this;
        return this.getFilteredData(false).map(function (groupOrOption, i) {
            var options = groupOrOption.options;
            if (options) {
                var optionsElements = options.map(function (option, j) {
                    var optionElement = option.component
                        ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](option.component, { option: option })
                        : option.label;
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: _this.getOptionStyle(option), key: j, role: 'treeitem', "aria-selected": _this.isSelected(option), "aria-disabled": _this.isDisabled(option), onMouseEnter: function () { return _this.mouseenter(option); }, onClick: function () { return _this.click(option); } }, optionElement));
                });
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: 'select2-results__option', role: 'group', key: i },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", { className: 'select2-results__group' }, groupOrOption.label),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: 'select2-results__options select2-results__options--nested' }, optionsElements)));
            }
            else {
                var option_1 = groupOrOption;
                var optionElement = option_1.component
                    ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](option_1.component, { option: option_1 })
                    : option_1.label;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: _this.getOptionStyle(option_1), key: i, role: 'treeitem', "aria-selected": _this.isSelected(option_1), "aria-disabled": _this.isDisabled(option_1), onMouseEnter: function () { return _this.mouseenter(option_1); }, onClick: function () { return _this.click(option_1); } }, optionElement));
            }
        });
    };
    Select2.prototype.getFilteredData = function (canSetState) {
        var result = this.props.customSearchEnabled
            || (this.props.minimumInputLength && this.props.minimumInputLength > this.searchText.length)
            ? this.props.data
            : __WEBPACK_IMPORTED_MODULE_3_select2_component__["c" /* getFilteredData */](this.props.data, this.searchText);
        if (__WEBPACK_IMPORTED_MODULE_3_select2_component__["q" /* valueIsNotInFilteredData */](result, this.hoveringValue)) {
            this.hoveringValue = __WEBPACK_IMPORTED_MODULE_3_select2_component__["d" /* getFirstAvailableOption */](result);
            if (canSetState) {
                this.setState({ hoveringValue: this.hoveringValue });
            }
            if (this.resultsElement) {
                var lastScrollTopIndex = __WEBPACK_IMPORTED_MODULE_3_select2_component__["e" /* getLastScrollTopIndex */](this.hoveringValue, this.resultsElement, result, this.lastScrollTopIndex);
                if (lastScrollTopIndex !== null) {
                    this.lastScrollTopIndex = lastScrollTopIndex;
                    if (canSetState) {
                        this.setState({ lastScrollTopIndex: this.lastScrollTopIndex });
                    }
                }
            }
        }
        return result;
    };
    Select2.prototype.getOptionStyle = function (option) {
        return __WEBPACK_IMPORTED_MODULE_3_select2_component__["h" /* getOptionStyle */](option, this.hoveringValue);
    };
    Select2.prototype.mouseenter = function (option) {
        if (!option.disabled) {
            this.hoveringValue = option.value;
            this.setState({ hoveringValue: this.hoveringValue });
        }
    };
    Select2.prototype.click = function (option) {
        if (!option.disabled) {
            this.select(option);
        }
        if (this.focusoutTimer) {
            clearTimeout(this.focusoutTimer);
        }
    };
    Select2.prototype.toggleOpenAndClose = function () {
        var _this = this;
        if (this.props.disabled) {
            return;
        }
        this.isOpen = !this.isOpen;
        this.setState({ isOpen: this.isOpen });
        if (this.isOpen) {
            if (!this.props.keepSearchText) {
                this.innerSearchText = '';
            }
            this.setState({ searchText: this.searchText }, function () {
                _this.focusSearchboxOrResultsElement();
                if (_this.resultsElement) {
                    var lastScrollTopIndex = __WEBPACK_IMPORTED_MODULE_3_select2_component__["e" /* getLastScrollTopIndex */](_this.hoveringValue, _this.resultsElement, _this.props.data, _this.lastScrollTopIndex);
                    if (lastScrollTopIndex !== null) {
                        _this.lastScrollTopIndex = lastScrollTopIndex;
                    }
                }
            });
            if (this.props.open) {
                this.props.open();
            }
        }
        if (this.focusoutTimer) {
            clearTimeout(this.focusoutTimer);
        }
    };
    Select2.prototype.focusout = function () {
        var _this = this;
        this.focusoutTimer = setTimeout(function () {
            _this.isOpen = false;
            if (_this.mounted) {
                _this.setState({ isOpen: _this.isOpen });
            }
            _this.focusoutTimer = undefined;
        }, __WEBPACK_IMPORTED_MODULE_3_select2_component__["p" /* timeout */]);
    };
    Select2.prototype.moveUp = function () {
        this.hoveringValue = __WEBPACK_IMPORTED_MODULE_3_select2_component__["j" /* getPreviousOption */](this.getFilteredData(true), this.hoveringValue);
        this.setState({ hoveringValue: this.hoveringValue });
        if (this.resultsElement) {
            var lastScrollTopIndex = __WEBPACK_IMPORTED_MODULE_3_select2_component__["e" /* getLastScrollTopIndex */](this.hoveringValue, this.resultsElement, this.getFilteredData(true), this.lastScrollTopIndex);
            if (lastScrollTopIndex !== null) {
                this.lastScrollTopIndex = lastScrollTopIndex;
                this.setState({ lastScrollTopIndex: this.lastScrollTopIndex });
            }
        }
    };
    Select2.prototype.moveDown = function () {
        this.hoveringValue = __WEBPACK_IMPORTED_MODULE_3_select2_component__["f" /* getNextOption */](this.getFilteredData(true), this.hoveringValue);
        this.setState({ hoveringValue: this.hoveringValue });
        if (this.resultsElement) {
            var lastScrollTopIndex = __WEBPACK_IMPORTED_MODULE_3_select2_component__["e" /* getLastScrollTopIndex */](this.hoveringValue, this.resultsElement, this.getFilteredData(true), this.lastScrollTopIndex);
            if (lastScrollTopIndex !== null) {
                this.lastScrollTopIndex = lastScrollTopIndex;
                this.setState({ lastScrollTopIndex: this.lastScrollTopIndex });
            }
        }
    };
    Select2.prototype.selectByEnter = function () {
        if (this.hoveringValue) {
            var option = __WEBPACK_IMPORTED_MODULE_3_select2_component__["g" /* getOptionByValue */](this.props.data, this.hoveringValue);
            this.select(option);
        }
    };
    Select2.prototype.select = function (option) {
        if (option !== null) {
            if (this.props.multiple) {
                var options = this.option;
                var index = options.findIndex(function (op) { return op.value === option.value; });
                if (index === -1) {
                    options.push(option);
                }
                else {
                    options.splice(index, 1);
                }
                this.setState({
                    option: this.option
                });
            }
            else {
                this.option = option;
                this.isOpen = false;
                this.setState({
                    option: this.option,
                    isOpen: this.isOpen
                });
            }
        }
        if (this.props.update) {
            this.props.update(this.props.multiple ? this.option.map(function (op) { return op.value; }) : this.option.value);
        }
    };
    Select2.prototype.keyDown = function (e) {
        if (this.props.keydown) {
            this.props.keydown(e);
        }
        if (e.keyCode === 40) {
            this.moveDown();
            e.preventDefault();
        }
        else if (e.keyCode === 38) {
            this.moveUp();
            e.preventDefault();
        }
        else if (e.keyCode === 13) {
            this.selectByEnter();
            e.preventDefault();
        }
    };
    Select2.prototype.keyUp = function (e) {
        if (this.props.keyup) {
            this.props.keyup(e);
        }
    };
    Select2.prototype.keyPress = function (e) {
        if (this.props.keypress) {
            this.props.keypress(e);
        }
    };
    Select2.prototype.isSelected = function (option) {
        return __WEBPACK_IMPORTED_MODULE_3_select2_component__["n" /* isSelected */](this.option, option, this.props.multiple);
    };
    Select2.prototype.isDisabled = function (option) {
        return option.disabled ? 'true' : 'false';
    };
    Select2.prototype.focusSearchboxOrResultsElement = function () {
        if (!this.isSearchboxHidden) {
            if (this.searchInputElement) {
                this.searchInputElement.focus();
            }
        }
        else {
            if (this.resultsElement) {
                this.resultsElement.focus();
            }
        }
    };
    Select2.prototype.removeSelection = function (e, option) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_3_select2_component__["o" /* removeSelection */](this.option, option);
        if (this.props.update) {
            this.props.update(this.option.map(function (op) { return op.value; }));
        }
        e.preventDefault();
        e.stopPropagation();
        if (this.isOpen) {
            this.setState({ option: this.option }, function () {
                _this.focusSearchboxOrResultsElement();
            });
        }
        if (this.focusoutTimer) {
            clearTimeout(this.focusoutTimer);
        }
    };
    Select2.prototype.cancelFocusoutTimer = function () {
        if (this.focusoutTimer) {
            clearTimeout(this.focusoutTimer);
        }
    };
    return Select2;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));




/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["a"] = __values;
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}



/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AutoComplete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_select2_component__ = __webpack_require__(397);
/* unused harmony namespace reexport */
/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);






/**
 * @public
 */
var AutoComplete = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */])(AutoComplete, _super);
    function AutoComplete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hoveringValue = null;
        _this.option = null;
        _this.isOpen = false;
        _this.lastScrollTopIndex = 0;
        _this.onChange = function (e) {
            if (_this.props.search) {
                _this.props.search(e.currentTarget.value);
            }
            if (_this.props.update) {
                _this.props.update(e.currentTarget.value);
            }
        };
        return _this;
    }
    Object.defineProperty(AutoComplete.prototype, "dropdownStyle", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3_select2_component__["b" /* getDropdownStyle */](this.isOpen && this.props.data.length > 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoComplete.prototype, "containerStyle", {
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_3_select2_component__["a" /* getContainerStyle */](false, this.isOpen && this.props.data.length > 0);
        },
        enumerable: false,
        configurable: true
    });
    AutoComplete.prototype.UNSAFE_componentWillMount = function () {
        var option = __WEBPACK_IMPORTED_MODULE_3_select2_component__["i" /* getOptionsByValue */](this.props.data, this.props.value, false);
        if (option !== null) {
            this.option = option;
            this.setState({ option: this.option });
        }
        if (!Array.isArray(option)) {
            this.hoveringValue = this.props.value;
        }
        this.setState({ hoveringValue: this.hoveringValue });
    };
    AutoComplete.prototype.componentDidMount = function () {
        var theElement = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this);
        this.searchInputElement = theElement.childNodes[0].childNodes[0].childNodes[0].childNodes[0];
        this.resultsElement = theElement.childNodes[1].childNodes[0].childNodes[0].childNodes[0];
    };
    AutoComplete.prototype.render = function () {
        var _this = this;
        var results = this.renderResult();
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this.containerStyle },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: 'selection' },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: 'select2-search select2-search--dropdown' },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input", { value: this.props.value, onChange: this.onChange, onKeyDown: function (e) { return _this.keyDown(e); }, onKeyUp: function (e) { return _this.keyUp(e); }, onKeyPress: function (e) { return _this.keyPress(e); }, onBlur: function () { return _this.focusout(); }, onClick: function () { return _this.toggleOpenAndClose(); }, className: 'select2-search__field', type: 'search', role: 'textbox', autoComplete: 'off', autoCorrect: 'off', autoCapitalize: 'off', spellCheck: false }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: this.dropdownStyle },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: 'select2-dropdown' },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: 'select2-results' },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: 'select2-results__options', role: 'tree', tabIndex: -1, onKeyDown: function (e) { return _this.keyDown(e); } }, results))))));
    };
    AutoComplete.prototype.renderResult = function () {
        var _this = this;
        return this.getFilteredData(false).map(function (groupOrOption, i) {
            var options = groupOrOption.options;
            if (options) {
                var optionsElements = options.map(function (option, j) {
                    var optionElement = option.component
                        ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](option.component, { option: option })
                        : option.label;
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: _this.getOptionStyle(option), key: j, role: 'treeitem', "aria-selected": _this.isSelected(option), "aria-disabled": _this.isDisabled(option), onMouseEnter: function () { return _this.mouseenter(option); }, onClick: function () { return _this.click(option); } }, optionElement));
                });
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: 'select2-results__option', role: 'group', key: i },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("strong", { className: 'select2-results__group' }, groupOrOption.label),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("ul", { className: 'select2-results__options select2-results__options--nested' }, optionsElements)));
            }
            else {
                var option_1 = groupOrOption;
                var optionElement = option_1.component
                    ? __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](option_1.component, { option: option_1 })
                    : option_1.label;
                return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("li", { className: _this.getOptionStyle(option_1), key: i, role: 'treeitem', "aria-selected": _this.isSelected(option_1), "aria-disabled": _this.isDisabled(option_1), onMouseEnter: function () { return _this.mouseenter(option_1); }, onClick: function () { return _this.click(option_1); } }, optionElement));
            }
        });
    };
    AutoComplete.prototype.getFilteredData = function (canSetState) {
        var result = this.props.data;
        if (__WEBPACK_IMPORTED_MODULE_3_select2_component__["q" /* valueIsNotInFilteredData */](result, this.hoveringValue)) {
            this.hoveringValue = __WEBPACK_IMPORTED_MODULE_3_select2_component__["d" /* getFirstAvailableOption */](result);
            if (canSetState) {
                this.setState({ hoveringValue: this.hoveringValue });
            }
            if (this.resultsElement) {
                var lastScrollTopIndex = __WEBPACK_IMPORTED_MODULE_3_select2_component__["e" /* getLastScrollTopIndex */](this.hoveringValue, this.resultsElement, result, this.lastScrollTopIndex);
                if (lastScrollTopIndex !== null) {
                    this.lastScrollTopIndex = lastScrollTopIndex;
                    if (canSetState) {
                        this.setState({ lastScrollTopIndex: this.lastScrollTopIndex });
                    }
                }
            }
        }
        return result;
    };
    AutoComplete.prototype.getOptionStyle = function (option) {
        return __WEBPACK_IMPORTED_MODULE_3_select2_component__["h" /* getOptionStyle */](option, this.hoveringValue);
    };
    AutoComplete.prototype.mouseenter = function (option) {
        if (!option.disabled) {
            this.hoveringValue = option.value;
            this.setState({ hoveringValue: this.hoveringValue });
        }
    };
    AutoComplete.prototype.click = function (option) {
        if (!option.disabled) {
            this.select(option);
        }
        if (this.focusoutTimer) {
            clearTimeout(this.focusoutTimer);
        }
    };
    AutoComplete.prototype.toggleOpenAndClose = function () {
        this.isOpen = !this.isOpen;
        this.setState({ isOpen: this.isOpen });
        if (this.isOpen) {
            this.focusSearchboxOrResultsElement();
            if (this.resultsElement) {
                var lastScrollTopIndex = __WEBPACK_IMPORTED_MODULE_3_select2_component__["e" /* getLastScrollTopIndex */](this.hoveringValue, this.resultsElement, this.props.data, this.lastScrollTopIndex);
                if (lastScrollTopIndex !== null) {
                    this.lastScrollTopIndex = lastScrollTopIndex;
                }
            }
        }
        if (this.focusoutTimer) {
            clearTimeout(this.focusoutTimer);
        }
    };
    AutoComplete.prototype.focusout = function () {
        var _this = this;
        this.focusoutTimer = setTimeout(function () {
            _this.isOpen = false;
            _this.setState({ isOpen: _this.isOpen });
            _this.focusoutTimer = undefined;
        }, __WEBPACK_IMPORTED_MODULE_3_select2_component__["p" /* timeout */]);
    };
    AutoComplete.prototype.moveUp = function () {
        this.hoveringValue = __WEBPACK_IMPORTED_MODULE_3_select2_component__["j" /* getPreviousOption */](this.getFilteredData(true), this.hoveringValue);
        this.setState({ hoveringValue: this.hoveringValue });
        if (this.resultsElement) {
            var lastScrollTopIndex = __WEBPACK_IMPORTED_MODULE_3_select2_component__["e" /* getLastScrollTopIndex */](this.hoveringValue, this.resultsElement, this.getFilteredData(true), this.lastScrollTopIndex);
            if (lastScrollTopIndex !== null) {
                this.lastScrollTopIndex = lastScrollTopIndex;
                this.setState({ lastScrollTopIndex: this.lastScrollTopIndex });
            }
        }
    };
    AutoComplete.prototype.moveDown = function () {
        this.hoveringValue = __WEBPACK_IMPORTED_MODULE_3_select2_component__["f" /* getNextOption */](this.getFilteredData(true), this.hoveringValue);
        this.setState({ hoveringValue: this.hoveringValue });
        if (this.resultsElement) {
            var lastScrollTopIndex = __WEBPACK_IMPORTED_MODULE_3_select2_component__["e" /* getLastScrollTopIndex */](this.hoveringValue, this.resultsElement, this.getFilteredData(true), this.lastScrollTopIndex);
            if (lastScrollTopIndex !== null) {
                this.lastScrollTopIndex = lastScrollTopIndex;
                this.setState({ lastScrollTopIndex: this.lastScrollTopIndex });
            }
        }
    };
    AutoComplete.prototype.selectByEnter = function () {
        if (this.hoveringValue) {
            var option = __WEBPACK_IMPORTED_MODULE_3_select2_component__["g" /* getOptionByValue */](this.props.data, this.hoveringValue);
            this.select(option);
        }
    };
    AutoComplete.prototype.select = function (option) {
        if (option !== null) {
            this.option = option;
            this.isOpen = false;
            this.setState({
                option: this.option,
                isOpen: this.isOpen
            });
        }
        if (this.props.select) {
            this.props.select(this.option.value);
        }
        if (this.props.update) {
            this.props.update(this.option.value);
        }
    };
    AutoComplete.prototype.keyDown = function (e) {
        if (this.props.keydown) {
            this.props.keydown(e);
        }
        if (e.keyCode === 40) {
            this.moveDown();
            e.preventDefault();
        }
        else if (e.keyCode === 38) {
            this.moveUp();
            e.preventDefault();
        }
        else if (e.keyCode === 13) {
            this.selectByEnter();
            e.preventDefault();
        }
    };
    AutoComplete.prototype.keyUp = function (e) {
        if (this.props.keyup) {
            this.props.keyup(e);
        }
    };
    AutoComplete.prototype.keyPress = function (e) {
        if (this.props.keypress) {
            this.props.keypress(e);
        }
    };
    AutoComplete.prototype.isSelected = function (option) {
        return __WEBPACK_IMPORTED_MODULE_3_select2_component__["n" /* isSelected */](this.option, option, false);
    };
    AutoComplete.prototype.isDisabled = function (option) {
        return option.disabled ? 'true' : 'false';
    };
    AutoComplete.prototype.focusSearchboxOrResultsElement = function () {
        if (this.searchInputElement) {
            this.searchInputElement.focus();
        }
    };
    return AutoComplete;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));




/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = BehaviorSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__widgets_toolbox_PropertyContainerComponent__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BehaviorModal__ = __webpack_require__(1687);



var styleClasses = {
    behaviorCtrlBtn: "behavior-control-btn",
    behaviorCtrlContainer: "behavior-control-container",
};
var LoggedInUserState = __webpack_require__(19), Configuration = __webpack_require__(27), Storage = __webpack_require__(34);
function BehaviorSettings(props) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), modalOpen = _a[0], setModalOpen = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), permissionFlag = _b[0], setPermissionFlag = _b[1];
    var getConnectSettings = function () {
        var companyId = LoggedInUserState.attributes.company.id, settingName = "connect", endpointUrl = Configuration.creatorSettingApiBaseUrl + "/v1/settings/" + companyId + "?name=" + settingName, token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"), bearerToken = "Bearer " + token;
        var options = {
            method: "GET",
            headers: {
                Authorization: bearerToken,
            },
        };
        fetch(endpointUrl, options)
            .then(function (res) { return res.json(); })
            .then(function (data) {
            Storage.Local.update(Storage.Keys.CREATOR_CONNECT, data.connect);
            if (data.connect)
                setPermissionFlag(data.connect.enabled && data.connect.ipd.enabled);
        })
            .catch(function (err) { return console.log(err); });
    };
    var isActionEnabled = function () {
        var initialLoadCount = Storage.Local.get(Storage.Keys.CREATOR_CONNECT, Storage.Keys.BEHAVIOR_COMPONENT_INIT_COUNT) || 0;
        Storage.Local.update(Storage.Keys.CREATOR_CONNECT, Storage.Keys.BEHAVIOR_COMPONENT_INIT_COUNT, ++initialLoadCount);
        if (initialLoadCount <= 1) {
            getConnectSettings();
        }
        else {
            var connectSetting = Storage.Local.get(Storage.Keys.CREATOR_CONNECT);
            setPermissionFlag(connectSetting.enabled && connectSetting.ipd.enabled);
        }
    };
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(isActionEnabled, [permissionFlag]);
    var handleOpen = function () {
        setModalOpen(true);
    };
    var handleClose = function () {
        setModalOpen(false);
    };
    var workFlowModal = function () {
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BehaviorModal__["a" /* BehaviorModal */], { open: modalOpen, expJson: props.getExperience(), fonts: "", handleClose: handleClose, baseUrl: props.getBaseUrl(), notifyExpJson: props.notifyParent }));
    };
    return (permissionFlag ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__widgets_toolbox_PropertyContainerComponent__["a" /* PropertyContainerComponent */], { widgetSelected: false, label: "Behaviors", name: "behaviors", animateExpandOnMount: false },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { className: styleClasses.behaviorCtrlContainer },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", { className: styleClasses.behaviorCtrlBtn, onClick: handleOpen }, "Manage Behaviors")),
        modalOpen && workFlowModal())) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null));
}


/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = BehaviorModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(157);


var Storage = __webpack_require__(34);
function BehaviorModal(props) {
    var modalOpen = props.open || false;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""), behaviorName = _a[0], setBehaviorName = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false), shouldPrompt = _b[0], setShouldPrompt = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}), source = _c[0], setSource = _c[1];
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
        window.addEventListener("message", handleMessage, true);
        return function () {
            window.removeEventListener("message", handleMessage, true);
        };
    }, [window]);
    var handleInitialisation = function (src) {
        var token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
        var behaviorData = {
            expJson: props.expJson,
            token: token,
        };
        setSource(src);
        src.postMessage({ type: "behaviorData", behaviorData: JSON.stringify(behaviorData) }, props.baseUrl);
    };
    var handleMessage = function (event) {
        switch (event.data.type) {
            case "behaviorInit":
                handleInitialisation(event.source);
                break;
            case "shouldPrompt":
                setShouldPrompt(event.data.shouldPrompt);
                break;
            case "handleSave":
                closeModal();
                break;
            case "behaviorSaved": {
                setShouldPrompt(event.data.shouldPrompt);
                props.notifyExpJson(event.data.expJson, "saved");
                closeModal();
                break;
            }
            case "behaviorRemoved":
                props.notifyExpJson(event.data.expJson, "delete");
                break;
            case "behaviorName":
                setBehaviorName(event.data.behaviorName);
            default:
                break;
        }
    };
    var closeModal = function () {
        props.handleClose(false);
    };
    var confirmCloseModal = function () {
        if (shouldPrompt)
            source.postMessage({ type: "confirmCloseModal" }, props.baseUrl);
        else
            closeModal();
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */], { "aria-labelledby": "contained-modal-title-vcenter", show: modalOpen, fullscreen: "true", dialogClassName: "full-screen", onHide: confirmCloseModal, backdrop: "static", keyboard: false },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Header, { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Title, null,
                    "Manage Behaviors ",
                    behaviorName ? "[" + behaviorName + "]" : null)),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Body, { className: "iframe-container" },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", { id: "behaviorui", src: props.baseUrl, allow: "clipboard-read; clipboard-write" })))));
}


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    var baseUrl = {"env":"PROD","cncViewFullBaseUrl":"https://cnc-api.zmags.com/view/full/","cncViewLiteBaseUrl":"https://cnc-api.zmags.com/view/lite/","psdImportBaseUrl":"https://design-file-import.creator-prod.zmags.com","behaviorUiBaseUrl":"https://behaviors.zmags.com","creatorSettingApiBaseUrl":"https://creator-settings.api.zmags.com","c3ApibaseUrl":"https://contentcontrol.api.zmags.com","adminApiBaseUrl":"https://creator-api.zmags.com","editorBaseUrl":"//creator.zmags.com","viewerBaseUrl":"//c.zmags.com","viewerApiBaseUrl":"//c.zmags.com","cncStaticAssetsBaseUrl":"//c.zmags.com/static/","cncStaticAssetsFiles":["client.js","manifest.js","vendor.js","styles.css"],"cncSsrApiBaseUrl":"//c.zmags.com","viewerAliasApiBaseUrl":"//creator.zmags.com","communityBaseUrl":"https://creatorcommunity.zmags.com","errorQueueUrl":"https://c.zmags.com/queue/error/","statsDUrl":"https://statsd.zmags.com/stats","auth0Domain":"https://zmags.us.auth0.com","auth0Audience":"https://api.zmags.com/","auth0ClientId":"XGTeepJiX2c78VRgP8OFxN0Mf4kggvby","ometriaApiUrl":"https://ometria.api.zmags.com/v1/email/generate","klaviyoApiUrl":"https://klaviyo.api.zmags.com/v1/email/generate","sfmcApiUrl":"https://sfmc.api.zmags.com/v1/email/generate","cloudinaryProviderUrl":"https://images.creator-prod.zmags.com/image/upload","salesEmail":"sales@zmags.com","supportEmail":"support@zmags.com","editorSegmentIOKey":"20jbiv8frx","matomoConfig":{"trackingScriptUrl":"//c.z-analytics.net/reporting/optimize/ztracker.js","trackerUrl":"","dashboardUrl":"//auth.reporting.creator-prod.zmags.com","segmentUrl":"//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php","siteID":1},"zsitesConfig":"//auth.reporting.creator-prod.zmags.com/","zsitesSecret":"zM4gzS3cr3t","inventoryUrl":"https://authproxy.creator-prod.zmags.com/inventory/v1/products/map","answerFileUrl":"https://static.inventory.creator-prod.zmags.com/dynamic_pricing/answer_files/","experienceUrl2PngBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/experience/signed/url2png/","experienceSharedEntityBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/sharedEntity/","msExperiencesUrl":"https://authproxy.creator-prod.zmags.com/experiences","microserviceCompanyUrl":"https://authproxy.creator-prod.zmags.com/company/","proxyUrl":"https://authproxy.creator-prod.zmags.com","forgotPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","resetPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","changePasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithTokenBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithSsoBaseUrl":"https://authproxy.creator-prod.zmags.com","loginActiveDirectoryBaseUrl":"https://creator-api.zmags.com","googleWebFontsApiBaseUrl":"https://www.googleapis.com/webfonts/v1/webfonts","googleWebFontsApiKey":"AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI","casUrl":"https://cas.zma.gs/","contentControlUrl":"https://manage.creatorbyzmags.com/","enableLogging":1,"logId":null,"trackErrors":true,"sentryEnabled":true,"sentryDSN":"https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460","experienceId":null,"groupId":null,"scene":null,"statsDBucket":"creator.prod","version":"livadug4","maxRetries":3}.editorBaseUrl;

    var WIDGET_TYPE_ICONS = [{ "id": "big-commerce", "icon": "big-commerce-widget-icon.svg" }, { "id": "box", "icon": "box-widget-icon.svg" }, { "id": "button", "icon": "button-widget-icon.svg" }, { "id": "demandware", "icon": "commerce-cloud-widget-icon.svg" }, { "id": "dynamic-product", "icon": "dynamic-product-widget-icon.svg" }, { "id": "embed", "icon": "embed-widget-icon.svg" }, { "id": "generic-product", "icon": "generic-product-widget-icon.svg" }, { "id": "hybris", "icon": "hybris-widget-icon.svg" }, { "id": "html", "icon": "html-widget-icon.svg" }, { "id": "image", "icon": "image-widget-icon.svg" }, { "id": "line", "icon": "line-widget-icon.svg" }, { "id": "link", "icon": "link-widget-icon.svg" }, { "id": "magento", "icon": "magento-widget-icon.svg" }, { "id": "next-scene", "icon": "next-scene-widget-icon.svg" }, { "id": "oracle", "icon": "oracle-widget-icon.svg" }, { "id": "previous-scene", "icon": "previous-scene-widget-icon.svg" }, { "id": "scene-slider", "icon": "scene-slider-widget-icon.svg" }, { "id": "shopify", "icon": "shopify-widget-icon.svg" }, { "id": "social", "icon": "social-widget-icon.svg" }, { "id": "text", "icon": "text-widget-icon.svg" }, { "id": "text-enhanced", "icon": "text-widget-icon.svg" }, { "id": "websphere", "icon": "websphere-widget-icon.svg" }, { "id": "youtube", "icon": "youtube-widget-icon.svg" }].reduce(function (accum, wType) {
        accum[wType.id] = baseUrl + "/images/widget-icons/" + wType.icon;
        return accum;
    }, {});

    return {
        WIDGET_TYPE_ICONS: WIDGET_TYPE_ICONS
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        SlideAnimationPropertiesView = __webpack_require__(1690),
        SlideOutAnimationPropertiesView = __webpack_require__(1692),
        FadeAnimationPropertiesView = __webpack_require__(1694),
        FadeOutAnimationPropertiesView = __webpack_require__(1696),
        ZoomInAnimationPropertiesView = __webpack_require__(1698),
        ZoomOutAnimationPropertiesView = __webpack_require__(1700),
        MoveAnimationPropertiesView = __webpack_require__(1702);

    /**
     * The different types of animation and information needed by the editor about them.
     *
     * Intentionally split from {@link AnimationTypes} to avoid editor dependencies in the viewer.
     *
     * @class AnimationEditorTypes
     */
    return {
        "SLIDE": {
            id: "slide",
            propertiesViewClass: SlideAnimationPropertiesView
        },
        "SLIDE_OUT": {
            id: "slideOut",
            propertiesViewClass: SlideOutAnimationPropertiesView
        },
        "FADE": {
            id: "fade",
            propertiesViewClass: FadeAnimationPropertiesView
        },
        "FADE_OUT": {
            id: "fadeOut",
            propertiesViewClass: FadeOutAnimationPropertiesView
        },
        "ZOOM_IN": {
            id: "zoomIn",
            propertiesViewClass: ZoomInAnimationPropertiesView
        },
        "ZOOM_OUT": {
            id: "zoomOut",
            propertiesViewClass: ZoomOutAnimationPropertiesView
        },
        "MOVE": {
            id: "move",
            propertiesViewClass: MoveAnimationPropertiesView
        },

        /**
         * Gets the animation type for the given type string.
         *
         * @param {String} typeString The type string.
         * @returns {Object} The type descriptor matching the given type, or undefined if not found.
         */
        fromString: function fromString(typeString) {
            return _.find(this, function (type) {
                return type.id === typeString;
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        EasingTypes = __webpack_require__(175),
        template = __webpack_require__(1691);

    /**
     * The properties view for a slide animation.
     *
     * @class SlideAnimationPropertiesView
     * @constructor
     *
     * @cfg {SlideAnimationModel} model The slide animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#slideEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#direction": "direction",
            "#delay": {
                observe: "delay",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n\n    <label>\n        Direction\n        <select class="form-control" id="direction">\n            <option value="top">From top</option>\n            <option value="right">From right</option>\n            <option value="bottom">From bottom</option>\n            <option value="left">From left</option>\n        </select>\n    </label>\n\n    <label>Easing: <select class="form-control" id="slideEasing"></select></label>\n\n    <div class="zmags-input-control small columns">\n        <div class="pull-left">\n            <label data-unit="sec">Delay: <input type="number" step="0.1" min="0" name="delay"    id="delay"></label>\n        </div>\n        <div class="pull-right">\n            <label data-unit="sec">Time: <input type="number" step="0.1" min="0" name="duration" id="duration"></label>\n        </div>\n    </div>\n\n\n</div>\n';

}
return __p
}

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        EasingTypes = __webpack_require__(175),
        template = __webpack_require__(1693);

    /**
     * The properties view for a slide animation.
     *
     * @class SlideOutAnimationPropertiesView
     * @constructor
     *
     * @cfg {SlideOutAnimationModel} model The slide animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#slideOutEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#direction": "direction",
            "#delay": {
                observe: "delay",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1693 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n    <label>\n        Direction\n        <select class="form-control" id="direction">\n            <option value="top">To top</option>\n            <option value="right">To right</option>\n            <option value="bottom">To bottom</option>\n            <option value="left">To left</option>\n        </select>\n    </label>\n\n    <label>Easing: <select class="form-control" id="slideOutEasing"></select></label>\n\n    <div class="zmags-input-control small columns">\n        <div class="pull-left">\n            <label data-unit="sec">Delay: <input type="number" step="0.1" min="0" name="delay"    id="delay"></label>\n        </div>\n        <div class="pull-right">\n            <label data-unit="sec">Time: <input type="number" step="0.1" min="0" name="duration" id="duration"></label>\n        </div>\n    </div>\n</div>';

}
return __p
}

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EasingTypes = __webpack_require__(175),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(1695);

    /**
     * The properties view for a fade animation.
     *
     * @class FadeAnimationPropertiesView
     * @constructor
     *
     * @cfg {FadeAnimationModel} model The fade animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#fadeEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#delay": {
                observe: "delay",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n\n    <label>Easing: <select class="form-control" id="fadeEasing"></select></label>\n\n    <div class="zmags-input-control small columns">\n        <div class="pull-left">\n            <label data-unit="sec">Delay: <input type="number" step="0.1" min="0" name="delay" id="delay"></label>\n        </div>\n        <div class="pull-right">\n            <label data-unit="sec">Time: <input type="number" step="0.1" min="0" name="duration" id="duration"></label>\n        </div>\n    </div>\n\n</div>\n';

}
return __p
}

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EasingTypes = __webpack_require__(175),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(1697);

    /**
     * The properties view for a fade out animation.
     *
     * @class FadeOutAnimationPropertiesView
     * @constructor
     *
     * @cfg {FadeOutAnimationModel} model The fade out animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#fadeOutEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#delay": {
                observe: "delay",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1697 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n\n    <label>Easing: <select class="form-control" id="fadeOutEasing"></select></label>\n\n    <div class="zmags-input-control small columns">\n        <div class="pull-left">\n            <label data-unit="sec">Delay: <input type="number" step="0.1" min="0" name="delay"    id="delay"></label>\n        </div>\n        <div class="pull-right">\n            <label data-unit="sec">Time: <input type="number" step="0.1" min="0" name="duration" id="duration"></label>\n        </div>\n    </div>\n\n</div>\n';

}
return __p
}

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EasingTypes = __webpack_require__(175),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(1699);

    /**
     * The properties view for a zoom in animation.
     *
     * @class ZoomInAnimationPropertiesView
     * @constructor
     *
     * @cfg {ZoomInAnimationModel} model The zoom in animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#zoomInEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#delay": {
                observe: "delay",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1699 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n\n    <label>Easing: <select class="form-control" id="zoomInEasing"></select></label>\n\n    <div class="zmags-input-control small columns">\n        <div class="pull-left">\n            <label data-unit="sec">Delay: <input type="number" step="0.1" min="0" name="delay"    id="delay"></label>\n        </div>\n        <div class="pull-right">\n            <label data-unit="sec">Time: <input type="number" step="0.1" min="0" name="duration" id="duration"></label>\n        </div>\n    </div>\n\n</div>\n';

}
return __p
}

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EasingTypes = __webpack_require__(175),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(1701);

    /**
     * The properties view for a zoom out animation.
     *
     * @class ZoomOutAnimationPropertiesView
     * @constructor
     *
     * @cfg {ZoomOutAnimationModel} model The zoom out animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#zoomOutEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#delay": {
                observe: "delay",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1701 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n\n    <label>Easing: <select class="form-control" id="zoomOutEasing"></select></label>\n\n    <div class="zmags-input-control small columns">\n        <div class="pull-left">\n            <label data-unit="sec">Delay: <input type="number" step="0.1" min="0" name="delay"    id="delay"></label>\n        </div>\n        <div class="pull-right">\n            <label data-unit="sec">Time: <input type="number" step="0.1" min="0" name="duration" id="duration"></label>\n        </div>\n    </div>\n\n</div>\n';

}
return __p
}

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EasingTypes = __webpack_require__(175),
        ImprovedView = __webpack_require__(6),
        MoveAnimationRepresentation = __webpack_require__(1703),
        Preconditions = __webpack_require__(14),
        template = __webpack_require__(1704);

    var LEFT_ARROW = "&larr;",
        RIGHT_ARROW = "&rarr;",
        UPWARD_ARROW = "&uarr;",
        DOWNWARD_ARROW = "&darr;";

    /**
     * The properties view for a move animation.
     *
     * @class MoveAnimationPropertiesView
     *
     * @cfg {MoveAnimationModel} model The Move animation model being edited.
     */
    return ImprovedView.extend({

        template: template,

        _representation: null,

        bindings: {
            "#move-easing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#direction": "direction",
            "#delay": {
                observe: "delay",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function onGet(value) {
                    return value / 1000;
                },
                onSet: function onSet(value) {
                    return value * 1000;
                }
            },
            "#animation-move-horizontal": {
                observe: "horizontalMove",
                onGet: "onGet",
                onSet: "onSet"
            },
            "#animation-move-vertical": {
                observe: "verticalMove",
                onGet: "onGet",
                onSet: "onSet"
            }
        },

        templateHelpers: function templateHelpers() {
            var horizontalMoveValue = this.model.get("horizontalMove"),
                verticalMoveValue = this.model.get("verticalMove");

            return {
                horizontalMoveUnescaped: horizontalMoveValue < 0 ? LEFT_ARROW : RIGHT_ARROW,
                verticalMoveUnescaped: verticalMoveValue < 0 ? UPWARD_ARROW : DOWNWARD_ARROW
            };
        },

        ui: {
            horizontalInput: "#animation-move-horizontal",
            verticalInput: "#animation-move-vertical",
            horizontalArrow: "#animation-move-horizontal-arrow",
            verticalArrow: "#animation-move-vertical-arrow"
        },

        events: {
            "focus #animation-move-horizontal": function focusAnimationMoveHorizontal() {
                this._representation.addRepresentationToDom();
            },
            "focus #animation-move-vertical": function focusAnimationMoveVertical() {
                this._representation.addRepresentationToDom();
            },
            "blur #animation-move-horizontal": function blurAnimationMoveHorizontal() {
                this._representation.removeRepresentationToDom();
            },
            "blur #animation-move-vertical": function blurAnimationMoveVertical() {
                this._representation.removeRepresentationToDom();
            },
            "click #animation-move-horizontal-arrow": "_changeArrowDirection",
            "click #animation-move-vertical-arrow": "_changeArrowDirection"
        },

        initialize: function initialize() {
            var widgetModel = this.options.widgetModel,
                animationModel = this.model;

            function updatePositionFromModel() {
                animationModel.set({
                    fromTop: widgetModel.get("top"),
                    fromLeft: widgetModel.get("left")
                });
            }

            this.listenTo(widgetModel, "change:top change:left", updatePositionFromModel);

            // Perform initial update
            updatePositionFromModel();
        },

        _changeArrowDirection: function _changeArrowDirection(event) {
            var arrow = event.target,
                attribute = arrow.getAttribute("data-direction"),
                value = -this.model.get(attribute);

            this.model.set(attribute, value);

            switch (attribute) {
                case "verticalMove":
                    arrow.innerHTML = value < 0 ? UPWARD_ARROW : DOWNWARD_ARROW;
                    break;
                case "horizontalMove":
                    arrow.innerHTML = value < 0 ? LEFT_ARROW : RIGHT_ARROW;
                    break;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Attribute '" + attribute + "' not recognized.");
                    break;
            }
        },

        onGet: function onGet(value, options) {
            var experienceModel = this.viewScope.viewModel.get("experience"),
                pixelPosition = experienceModel.getPixelPosition({ left: value, top: value });

            switch (options.observe) {
                case "horizontalMove":
                    return Math.abs(Math.round(pixelPosition.left));
                case "verticalMove":
                    return Math.abs(Math.round(pixelPosition.top));
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Move '" + options.observe + "' not recognized.");
                    break;
            }
        },

        // don't use rounding here, otherwise the value will lost precision onGet.
        onSet: function onSet(value, options) {
            var experienceModel = this.viewScope.viewModel.get("experience"),
                percentagePosition = experienceModel.getPercentagePosition({
                left: Math.abs(value),
                top: Math.abs(value)
            }),
                oldValue = this.model.get(options.observe);

            switch (options.observe) {
                case "horizontalMove":
                    return oldValue >= 0 ? percentagePosition.left : -percentagePosition.left;
                case "verticalMove":
                    return oldValue >= 0 ? percentagePosition.top : -percentagePosition.top;
                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Move '" + options.observe + "' not recognized.");
                    break;
            }
        },

        onRender: function onRender() {
            var experience = this.viewScope.viewModel.get("experience");
            this._representation = new MoveAnimationRepresentation(experience, this.options.widgetView, this.model);
            this.listenTo(this.model, "change:horizontalMove change:verticalMove", this._representation.moveRepresentation.bind(this._representation));
        },

        onClose: function onClose() {
            this._representation.removeRepresentationToDom.call(this._representation);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var MathUtil = __webpack_require__(72).default;
    var Matrix = __webpack_require__(204);

    var DEFAULT_MOVE_VALUE = 20;

    return Class.extend({

        _canvas: null,
        _widgetRect: null,
        _animationModel: null,
        _experienceModel: null,
        _widgetMatrix: null,
        _representationMatrix: null,
        _widgetSize: {
            width: null,
            height: null
        },

        _ui: {
            box: $("<div>", { "class": "move-animation-representation" }),
            arrow: $("<div>", { "class": "move-animation-arrow" })
        },

        _insertDefaultValues: function _insertDefaultValues() {
            var currentTop = this._animationModel.get("verticalMove"),
                currentLeft = this._animationModel.get("horizontalMove"),
                position;

            if (currentTop === null || currentLeft === null) {
                position = this._experienceModel.getPercentagePosition({
                    top: DEFAULT_MOVE_VALUE,
                    left: DEFAULT_MOVE_VALUE
                });

                this._animationModel.set({
                    verticalMove: position.top,
                    horizontalMove: position.left
                });
            }
        },

        _getCssFromMatrix: function _getCssFromMatrix() {
            // Clone the size of the widget
            var css = _.clone(this._widgetSize);

            // Add the matrix to the clone
            css.transform = this._representationMatrix.toString();
            return css;
        },

        _updateWidgetMatrixAndSize: function _updateWidgetMatrixAndSize() {
            // Object with width, height, left, top, rotation
            var widgetRect = this._widgetView.getRect(),
                rect = {
                left: widgetRect.x,
                top: widgetRect.y,
                width: widgetRect.width,
                height: widgetRect.height,
                rotation: this._widgetModel.get("rotation")
            };

            // Build new matrix
            this._widgetMatrix = new Matrix();
            this._widgetMatrix.translate(rect.left, rect.top);
            this._widgetMatrix.rotateCenter(rect.rotation * Math.PI / 180);

            // Build size object (matrix doesn't contain size of element)
            this._widgetSize = {
                width: rect.width,
                height: rect.height
            };
        },

        _updateRepresentationMatrix: function _updateRepresentationMatrix() {
            var position = this._experienceModel.getPixelPosition({
                left: this._animationModel.get("horizontalMove"),
                top: this._animationModel.get("verticalMove")
            });

            // Should not be needed
            if (!this._widgetMatrix) {
                return;
            }

            // Create new temporary matrix based on the widget matrix
            this._representationMatrix = this._widgetMatrix.clone();

            // Offset the new matrix
            this._representationMatrix.translate(position.left, position.top);
        },

        _getArrowCss: function _getArrowCss() {
            var p1 = this._getCenterFromMatrix(this._widgetMatrix),
                p2 = this._getCenterFromMatrix(this._representationMatrix),
                width = MathUtil.getDistance(p1, p2),
                angle = MathUtil.getAngle(p1, p2),
                arrowCss = {
                width: width,
                left: p1.left,
                top: p1.top,
                transform: "rotate(" + angle + "deg)"
            };

            return arrowCss;
        },

        // Returns the center coordinate of (rotated) widget or representation
        _getCenterFromMatrix: function _getCenterFromMatrix(matrix) {
            // Top left corner of element
            var corner = {
                x: matrix.x,
                y: matrix.y
            },
                degrees = this._representationMatrix.getRotation(),

            // Center that ignores rotation of element
            center = {
                x: corner.x + this._ui.box.width() / 2,
                y: corner.y + this._ui.box.height() / 2
            },
                rotatedCenter = MathUtil.rotatePoint(center, corner, degrees);

            return {
                left: rotatedCenter.x,
                top: rotatedCenter.y
            };
        },

        constructor: function constructor(experienceModel, widgetView, animationModel) {
            this._canvas = widgetView.getParentContainer();
            this._animationModel = animationModel;
            this._widgetView = widgetView;
            this._widgetModel = widgetView.model;
            this._experienceModel = experienceModel;

            this._insertDefaultValues();
        },

        addRepresentationToDom: function addRepresentationToDom() {
            this._updateWidgetMatrixAndSize();
            this._canvas.append(this._ui.box, this._ui.arrow);
            this.moveRepresentation();
        },

        removeRepresentationToDom: function removeRepresentationToDom() {
            this._ui.box.remove();
            this._ui.arrow.remove();
        },

        moveRepresentation: function moveRepresentation() {
            this._updateRepresentationMatrix();
            if (this._representationMatrix) {
                this._ui.box.css(this._getCssFromMatrix());
                this._ui.arrow.css(this._getArrowCss());
            }
        }
    }, {
        DEFAULT_MOVE_VALUE: DEFAULT_MOVE_VALUE
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1704 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n\n    <div class="zmags-input-control small columns">\n        <label data-unit="px">\n            Horizontal move:\n            <input type="number" step="1" min="0" pattern="\\d*" name="animationMoveHorizontal" id="animation-move-horizontal">\n            <span id="animation-move-horizontal-arrow" class="input-prepend" data-direction="horizontalMove">' +
((__t = ( horizontalMoveUnescaped )) == null ? '' : __t) +
'</span>\n        </label>\n        <label data-unit="px">\n            Vertical move:\n            <input type="number" step="1" min="0" pattern="\\d*" name="animationMoveVertical" id="animation-move-vertical">\n            <span id="animation-move-vertical-arrow" class="input-prepend" data-direction="verticalMove"> ' +
((__t = ( verticalMoveUnescaped )) == null ? '' : __t) +
'</span>\n        </label>\n    </div>\n\n    <label class="animation-move-easing-label">Easing: <select class="form-control" id="move-easing"></select></label>\n\n    <div class="zmags-input-control small columns">\n        <div class="pull-left">\n            <label data-unit="sec">Delay: <input type="number" step="0.1" min="0" name="delay" id="delay"></label>\n        </div>\n        <div class="pull-right">\n            <label data-unit="sec">Time: <input type="number" step="0.1" min="0" name="duration" id="duration"></label>\n        </div>\n    </div>\n\n</div>\n';

}
return __p
}

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".animation-properties-accordion">Animations</legend>\n    <div class="animation-properties-accordion collapse collapse-target">\n        <div>\n            <label class="block">\n                <input type="checkbox" class="slide-animation-enabled">\n                <span class="custom-checkbox"></span>\n                Slide In\n            </label>\n            <div class="slide-animation-properties"></div>\n\n            <label class="block">\n                <input type="checkbox" class="slide-out-animation-enabled">\n                <span class="custom-checkbox"></span>\n                Slide Out\n            </label>\n            <div class="slide-out-animation-properties"></div>\n\n            <label class="block">\n                <input type="checkbox" class="fade-animation-enabled">\n                <span class="custom-checkbox"></span>\n                Fade In\n            </label>\n            <div class="fade-animation-properties"></div>\n\n            <label class="block">\n                <input type="checkbox" class="fade-out-animation-enabled">\n                <span class="custom-checkbox"></span>\n                Fade Out\n            </label>\n            <div class="fade-out-animation-properties"></div>\n\n            <label class="block">\n                <input type="checkbox" class="zoom-in-animation-enabled">\n                <span class="custom-checkbox"></span>\n                Zoom In\n            </label>\n            <div class="zoom-in-animation-properties"></div>\n\n            <label class="block">\n                <input type="checkbox" class="zoom-out-animation-enabled">\n                <span class="custom-checkbox"></span>\n                Zoom Out\n            </label>\n            <div class="zoom-out-animation-properties"></div>\n\n            <label class="block">\n                <input type="checkbox" class="move-animation-enabled">\n                <span class="custom-checkbox"></span>\n                Move\n            </label>\n            <div class="move-animation-properties"></div>\n        </div>\n    </div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var CustomJsAction = __webpack_require__(190);
    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(857);
    var Tooltip = __webpack_require__(35);

    /**
     * Properties view for a custom js action.
     *
     * @class CustomJsActionPropertiesView
     *
     * @cfg {CustomJsAction} model The action to display in the view.
     */
    return ImprovedView.extend({

        /**
         * @private @type {String}
         * The last validation error, if any, for an invalid parameter value for any parameter.
         */
        _displayedError: null,

        _errors: null,

        template: template,

        ui: {
            parameterInputs: ".parameter-inputs input"
        },

        events: {
            "blur  @ui.parameterInputs": "_handleParameterBlur",
            "focus @ui.parameterInputs": "_handleParameterChange",
            "keyup @ui.parameterInputs": "_handleParameterChange"
        },

        initialize: function initialize() {
            this._errors = new Map();
        },
        onShow: function onShow() {
            Tooltip.add(this.ui.parameterInputs, {
                content: function content() {
                    return _.escape(this._displayedError);
                },

                trigger: "manual", // Tooltips are toggled by adding/removing validation-error CSS class.
                width: 200,
                placement: "left"
            });
        },
        onClose: function onClose() {
            Tooltip.remove(this.ui.parameterInputs);
        },


        /**
         * Sets the actual parameters in the model as the users type them in in
         * the properties view.
         *
         * @param {Event} event - The keyup event.
         */
        _handleParameterChange: _.debounce(function (event) {
            var el = event.target;
            var label = el.getAttribute("data-label");
            var parameters = _.clone(this.model.get("parameters"));
            var oldValue = void 0;

            // Sanity check.
            if (!parameters.hasOwnProperty(label)) {
                return;
            }
            // Inserting the value and checking the code will actually run.
            oldValue = parameters[label];
            // Ignore non-changes.
            var newValue = oldValue !== el.value;
            // Set change.
            parameters[label] = el.value;

            var errorMessage = CustomJsAction.checkParameter(label, el.value);
            var hasError = !!errorMessage;

            if (hasError) {
                this._errors.set(label, errorMessage);
            } else {
                this._errors.delete(label);
            }

            // On no errors, we must still check the code to see if it can run.
            if (this._errors.size === 0) {
                // Never true if "newError" is true.
                errorMessage = this.model.checkCode();
            }

            // To avoid flickering tooltip on for example arrow key navigation.
            var sameError = errorMessage === this._displayedError;

            // Error to display.
            this._displayedError = errorMessage;

            // Revert error if invalid, including if the code cannot run.
            if (hasError) {
                parameters[label] = oldValue || "";

                // Only trigger model change if all parameters and code are valid and we have an actual
                // change.
            } else if (!this._errors.size && newValue) {
                var newParameters = {};
                this.$el.find(this.ui.parameterInputs).each(function (index, parameterInput) {
                    var label = parameterInput.dataset.label;
                    if (label) {
                        newParameters[label] = parameterInput.value;
                    }
                });

                this.model.set("parameters", newParameters);
            }

            if (!sameError) {
                $(el).toggleClass("validation-error", hasError).popover(hasError ? "show" : "hide");
            }
        }, 300),

        _hideError: function _hideError(event) {
            var el = event.target;
            var $el = $(el);

            this._displayedError = null;
            $el.popover("hide");
        },
        _handleParameterBlur: function _handleParameterBlur(e) {
            this._handleParameterChange(e);
            this._hideError(e);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        template = __webpack_require__(1708);

    /**
     * Properties view for a SalesforceCommerce QuickView action.
     *
     * @class SalesforceCommerceActionPropertiesView
     * @constructor
     *
     * @cfg {SalesforceCommerceQuickViewAction} model - The action to display in the view.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            ".productID": "productID"
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n    <span class="salesforce-commerce-label">\n        <input type="text" class="productID full-width" placeholder="Product / item ID here">\n    </span>\n    <span class="help-block">\n        Preview the QuickView at your website via the Drag\'n Drop Publishing Feature.\n    </span>\n</div>\n';

}
return __p
}

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        template = __webpack_require__(1710);

    /**
     * Properties view for a javascript action.
     *
     * @class JsActionPropertiesView
     * @constructor
     *
     * @cfg {JsAction} model The action to display in the view.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            ".code": "code"
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1710 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n    <input type="text" class="code full-width" placeholder="JavaScript code here">\n    <span class="help-block">The code is run on the embedding page when using channels.</span>\n</div>\n';

}
return __p
}

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        Backbone = __webpack_require__(7),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        LoggedIn = __webpack_require__(31),
        template = __webpack_require__(1712),
        UrlUtil = __webpack_require__(46);

    /**
     * Properties view for a lightbox action.
     *
     * @class LightboxActionPropertiesView
     * @constructor
     *
     * @cfg {LightboxAction} model The action to display in the view.
     */
    return ImprovedView.extend({

        template: template,

        // A bit of helper info for verbose and/or ad logins...
        templateHelpers: function templateHelpers() {
            return {
                descriptor: Logger.level() >= Logger.VERBOSE && LoggedIn.internal() ? UrlUtil.getUrlDescriptor(this.model.get("url")) : { type: "url" }
            };
        },

        events: {
            "click .help-block .embedded": function clickHelpBlockEmbedded() {
                // only present on valid embedded url descriptor
                var descriptor = UrlUtil.getUrlDescriptor(this.model.get("url"));
                Backbone.history.navigate("#" + descriptor.type + "/" + descriptor.id + "/edit/" + descriptor.scene, true);
            }
        },

        bindings: {
            ".lb-url": "url",
            ".lb-height": "height",
            ".lb-width": "width"
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1712 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<input type="text" class="lb-url full-width" placeholder="http://example.com"/>\n<div class="zmags-input-control small columns">\n    <div class="pull-left">\n        <label data-unit="px">Width:  <input type="number" step="any" class="lb-width"></label>\n    </div>\n    <div class="pull-right">\n        <label data-unit="px">Height: <input type="number" step="any" class="lb-height"></label>\n    </div>\n</div>\n';
 if (descriptor.type !== "url") { ;
__p += '\n<span class="help-block">\n    <em>Lightboxed ' +
__e( descriptor.type ) +
'</em>: <a class="embedded">' +
__e( descriptor.id );
 if (descriptor.scene > 1) { ;
__p += ', scene ' +
__e( descriptor.scene ) +
' ';
 } ;
__p += '</a>\n</span>\n';
 } ;
__p += '\n';

}
return __p
}

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        LinkAction = __webpack_require__(299),
        template = __webpack_require__(1714);

    /**
     * Properties view for the link action.
     *
     * @class LinkActionPropertiesView
     * @constructor
     *
     * @cfg {LinkAction} model The action to display in the view.
     */
    return ImprovedView.extend({
        template: template,

        regions: {
            linkProperties: ".link-action-properties"
        },

        bindings: {
            ".url": "url",
            ".alt-text": {
                observe: "emailAltText",
                onGet: function onGet(value) {
                    return value ? String(value).trim() : null;
                },
                onSet: function onSet(value) {
                    return value ? String(value).trim() : null;
                }
            },
            ".target": {
                observe: "target",
                selectOptions: {
                    collection: [{ label: "Current window/tab", value: LinkAction.CURRENT_WINDOW }, { label: "New window/tab", value: LinkAction.NEW_WINDOW }]
                }
            }
        },
        experienceModelBindings: {
            ".alt-text-region": {
                observe: "emailModeEnabled",
                updateModel: false,
                update: function update($el, isEmailMode) {
                    $el.toggle(isEmailMode);
                }
            }
        },

        onRender: function onRender() {
            this.stickit(this.viewScope.viewModel.get("experience"), this.experienceModelBindings);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1714 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<input type="text" class="url full-width" placeholder="http://example.com"/>\n<select class="target form-control"></select>\n<div class="alt-text-region">\n    <label>Alt text for email:</label>\n    <input type="text" class="alt-text full-width" placeholder=""/>\n</div>\n\n';

}
return __p
}

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var ImprovedView = __webpack_require__(6);
    var ParametersHelper = __webpack_require__(298);
    var template = __webpack_require__(857);

    /**
     * Properties view for both ProductLightboxAction and ProductLinkAction.
     *
     * @class ParametersPropertiesView
     * @constructor
     */
    return ImprovedView.extend("ProductActionPropertiesView", {
        template: template,

        ui: {
            parameterInputs: ".parameter-inputs input"
        },

        events: {
            "blur @ui.parameterInputs": "_handleParameterBlur",
            "focus @ui.parameterInputs": "_handleParameterChange",
            "keyup @ui.parameterInputs": "_handleParameterChange"
        },

        initialize: function initialize() {
            this._handleParameterChange = _.debounce(this._handleParameterChange, 300);
        },


        /**
         * Sets the actual parameters in the model as the users type them in in the properties
         * view.
         */
        _handleParameterChange: function _handleParameterChange(event) {
            var el = event.target;
            var label = el.getAttribute("data-label");
            var parameters = _.clone(this.model.get("parameters"));

            // Sanity check, verifying that the parameter exists in the parameters array.
            if (!parameters.hasOwnProperty(label)) {
                return;
            }

            var oldValue = parameters[label];
            parameters[label] = el.value;
            var hasNewValue = el.value !== oldValue;

            // Even though it probably does not make any sense semantically, we allow for empty parameter values
            // to be inject into urls, probably resulting in bogus urls, for legacy reasons. We should really
            // allow for a proper design of parameters, each specifying validators like "optional" or "mandatory"
            // etc. Then we would not have to guess, but letting the specific client decide... :/
            if (hasNewValue) {
                var newParameters = {};
                this.$el.find(this.ui.parameterInputs).each(function (index, parameterInput) {
                    var label = parameterInput.dataset.label;
                    if (label) {
                        newParameters[label] = parameterInput.value;
                    }
                });
                var url = ParametersHelper.inject(this.model.get("urlTemplate"), newParameters); // allow empty parameters!

                this.model.set({
                    parameters: newParameters,
                    url: url
                });
            }
        },
        _hideError: function _hideError(event) {
            var el = event.target;
            var $el = $(el);

            this._displayedError = null;
            $el.popover("hide");
        },
        _handleParameterBlur: function _handleParameterBlur(e) {
            this._handleParameterChange(e);
            this._hideError(e);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Backbone = __webpack_require__(7),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(1717);

    /**
     * UI model class used to bind with the UI form.
     */
    var UIModel = Backbone.Model.extend({
        defaults: {
            type: "next",
            sceneNumber: 1
        }
    });

    /**
     * Properties view for a scene navigation action.
     *
     * @class SceneNavigationActionPropertiesView
     * @constructor
     *
     * @cfg {SceneNavigationAction} model The action to display in the view.
     */
    return ImprovedView.extend({

        _uiModel: null,

        template: template,

        uiModelBindings: {
            ".js-scene-navigation-type": "type",
            ".scene-navigation-scene-number": {
                observe: "sceneNumber",
                selectOptions: {
                    collection: function collection() {
                        var options = [];
                        for (var i = 1; i <= this.options.experience.get("scenes").length; i++) {
                            options.push({ label: "Scene " + i, value: i });
                        }
                        return options;
                    }
                }
            }
        },

        onRender: function onRender() {
            // Initialize the UI model from the real model
            var uiModelOptions;
            if (_.isString(this.model.get("target"))) {
                uiModelOptions = {
                    type: this.model.get("target"),
                    sceneNumber: 1
                };
            } else {
                uiModelOptions = {
                    type: "fixed",
                    sceneNumber: this.model.get("target")
                };
            }
            this._uiModel = new UIModel(uiModelOptions);

            // When the UI model updates, update the real model
            this.listenTo(this._uiModel, "change", function () {
                if (this._uiModel.get("type") === "fixed") {
                    this.model.set("target", this._uiModel.get("sceneNumber"));
                } else {
                    this.model.set("target", this._uiModel.get("type"));
                }
            });

            this.stickit(this._uiModel, this.uiModelBindings);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="radio">\n    <label>\n        <input type="radio" class="js-scene-navigation-type" name="sceneNavigationType" value="next">\n        <span class="custom-radio"></span>\n        Go to next scene\n    </label>\n</div>\n<div class="radio">\n    <label>\n        <input type="radio" class="js-scene-navigation-type" name="sceneNavigationType" value="previous">\n        <span class="custom-radio"></span>\n        Go to previous scene\n    </label>\n</div>\n<div class="radio">\n    <label>\n        <input type="radio" class="js-scene-navigation-type" name="sceneNavigationType" value="fixed">\n        <span class="custom-radio"></span>\n        Go to scene:\n    </label>\n    <select class="scene-navigation-scene-number form-control"></select>\n</div>\n';

}
return __p
}

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Action = __webpack_require__(100),
        ActionFactory = __webpack_require__(358),
        ActionHelper = __webpack_require__(856),
        ActionsViewController = __webpack_require__(1719),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(1720);

    /**
     * Actions drop down menu and associated properties below, dependinging on the selected action.
     *
     * @cfg {AbstractWidgetModel} model The widget being edited.
     *
     * @class ActionsView
     * @author Kim
     */
    return ImprovedView.extend({

        template: template,

        controller: ActionsViewController,

        initialize: function initialize() {
            this.options = _.defaults(this.options, {
                onlyShowProductActions: false
            });

            if (this.model.get("type") === "text-enhanced") {
                this.listenTo(this.model, "change:text", this._handleETWTextChange);
            }
        },

        _handleETWTextChange: function _handleETWTextChange(model) {
            var firstChild = ActionHelper.convertStringToHtml(model.get("text"));
            var isEmailModeEnabled = this.viewScope.viewModel.get("experience").get("emailModeEnabled");
            this.ui.actionsSelect.prop("disabled", firstChild && firstChild.querySelector("a") && !isEmailModeEnabled);
        },


        ui: {
            actionsSelect: ".actions-select"
        },

        regions: {
            actionRegion: ".action-region"
        },

        experienceModelBindings: {
            ".actions-select": {
                observe: "emailModeEnabled",
                updateModel: false,
                update: function update($el, isEmailMode) {
                    var actionModel = this.model.get("action");
                    var actionIdentifier = actionModel ? actionModel.getIdentifier() : null;
                    if (isEmailMode && (!actionIdentifier || actionIdentifier.type !== "link")) {
                        this.model.set({ action: null });
                        $el.trigger({ type: "change.select2" });
                    }
                }
            }
        },

        bindings: {
            ".actions-select": {
                observe: "action",

                initialize: function initialize($el) {
                    $el.select2({
                        placeholder: "Select an Action",
                        dropdownAutoWidth: true,
                        dropdownCssClass: "actions-select",
                        formatResult: function formatResult(state) {
                            return ActionHelper.getFormattedOption(state);
                        }
                    });

                    if (this.model.get("type") === "text-enhanced") {
                        this._handleETWTextChange(this.model);
                    }
                },

                selectOptions: {
                    labelPath: "label",
                    valuePath: "value",
                    defaultOption: {
                        label: "None",
                        value: null
                    },
                    collection: function collection() {
                        var isEmailModeEnabled = this.viewScope.viewModel.get("experience").get("emailModeEnabled");
                        return ActionHelper.getActionSelectOptionCollection(this.options.onlyShowProductActions, isEmailModeEnabled);
                    }
                },

                onGet: function onGet() {
                    var actionModel = this.model.get("action");
                    return actionModel ? actionModel.getIdentifier() : null;
                },

                onSet: function onSet(actionIdentifier) {
                    if (!actionIdentifier) {
                        return null;
                    }

                    var options = ActionHelper.getActionOptions(actionIdentifier);
                    var actionModel = ActionFactory.newActionFromType(actionIdentifier.type, options);
                    return actionModel;
                }
            },

            ".action-region": {
                observe: "action",
                // Stay away from the model
                updateModel: false,
                // Show the appropriate properties view
                // Note: This seems to be invoked also when action properties
                // changes, e.g. LinkAction#url.
                update: function update(element, changedValue) {
                    if (changedValue instanceof Action) {
                        var type = changedValue.get("type");

                        if (type) {
                            var PropertiesView = ActionHelper.actionTypeToPropertiesViewMap.get(type);

                            // Ensure we update model and do not show the action region if SalesforceCommerce AddOn gets disabled.
                            if (ActionHelper.isActionEnabledForCompany(type)) {
                                this.actionRegion.show(new PropertiesView({
                                    model: this.model.get("action"),
                                    widget: this.model,
                                    experience: this.viewScope.viewModel.get("experience")
                                }));
                            } else {
                                this.model.set("action", null);
                            }
                        }
                    } else if (!this.model.has("action")) {
                        this.actionRegion.close();
                    }
                }
            }
        },
        onRender: function onRender() {
            this.stickit(this.viewScope.viewModel.get("experience"), this.experienceModelBindings);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ViewController = __webpack_require__(126);

    /**
     * A view controller for the <tt>ActionsView</tt>. For now, it's sole purpose is to handle legacy
     * 'actions', i.e. <tt>AbstractWidgetModel#actions</tt>, making sure they are replaced/updated/removed
     * onto the 'action' property.
     *
     * @see ActionsView
     * @class ActionsViewController
     */
    return ViewController.extend({

        onInitialize: function onInitialize() {
            var legacyActions = this.model.get("actions");
            // If the current widget model contains any legacy actions
            if (legacyActions.length > 0) {
                // Grab the first action and store it as the primary widget action (excluding the id - {duplicate: true})
                this.model.set("action", legacyActions.at(0).clone({ duplicate: true }));
                // Reset/empty the legacy action collection
                legacyActions.reset();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1720 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-input-control">\n    <label>On click Action Type:\n        <select class="actions-select" id="action-type"></select>\n    </label>\n</div>\n<div class="action-region"></div>\n';

}
return __p
}

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        Effect = __webpack_require__(78),
        ImageToggleEffectModel = __webpack_require__(301),
        OpacityEffectModel = __webpack_require__(245),
        EffectLibraryView = __webpack_require__(1722),
        template = __webpack_require__(1752);

    /**
     * @cfg {AbstractWidgetModel}
     */
    return ImprovedView.extend({

        _effects: null,

        _hoverEffectLibrary: null,

        _attentionEffectLibrary: null,

        template: template,

        initialize: function initialize() {
            this._effects = this.model.get("effects");
            this.listenTo(this._effects, "add remove reset", this._updateToModel);
            this.listenTo(this.options.viewModel.get("experience"), "change:emailModeEnabled", this.onShow);
        },

        regions: {
            hoverRegion: ".hover-region",
            attentionRegion: ".attention-region"
        },

        ui: {
            hoverEffectEnabled: ".hover-effect-enabled",
            attentionEffectEnabled: ".attention-effect-enabled",
            attentionEffectWrapper: ".attention-effect-wrapper",
            hoverRegion: ".hover-region",
            attentionRegion: ".attention-region"
        },

        events: {
            "change .hover-effect-enabled": function changeHoverEffectEnabled() {
                this._hoverEffectLibrary.enabled(this.ui.hoverEffectEnabled.is(":checked"));
            },

            "change .attention-effect-enabled": function changeAttentionEffectEnabled() {
                this._attentionEffectLibrary.enabled(this.ui.attentionEffectEnabled.is(":checked"));
            }
        },

        onRender: function onRender() {
            this._hoverEffectLibrary = new EffectLibraryView({
                model: this.model, viewModel: this.viewScope.viewModel, effects: this._effects, triggerType: Effect.TRIGGER_TYPE_HOVER
            });
            this._attentionEffectLibrary = new EffectLibraryView({
                model: this.model, viewModel: this.viewScope.viewModel, effects: this._effects, triggerType: Effect.TRIGGER_TYPE_ATTENTION
            });
        },

        _toggleAttentionEffectLibrary: function _toggleAttentionEffectLibrary() {
            var isEmailModeEnabled = this.options.viewModel.get("experience").get("emailModeEnabled");
            if (isEmailModeEnabled) {
                // Here we remove ALL "loop" effects for email mode
                this.ui.attentionEffectEnabled.prop("checked", false);
                this.ui.attentionEffectEnabled.change();

                // Here we check for incompatible "hover" effects.
                // Only opacity and image swapping allowed. Otherwise switch of hover effect
                var currentHoverEffects = this._hoverEffectLibrary.model.get("effects");
                var hasImageToggleEffect = currentHoverEffects.findWhere({ type: ImageToggleEffectModel.TYPE });
                var hasOpacityEffect = currentHoverEffects.findWhere({ type: OpacityEffectModel.TYPE });
                if (!hasOpacityEffect && !hasImageToggleEffect) {
                    this.ui.hoverEffectEnabled.prop("checked", false);
                    this.ui.hoverEffectEnabled.change();
                }
            }
            this.ui.attentionEffectEnabled.prop("disabled", isEmailModeEnabled);
            this.ui.attentionEffectWrapper.toggleClass("disabled", isEmailModeEnabled);
        },

        _updateToModel: function _updateToModel() {
            this.model.trigger("change:effects", this.model);

            var hasHoverEffect = this._effects.hasTriggerType(Effect.TRIGGER_TYPE_HOVER),
                hasAttentionEffect = this._effects.hasTriggerType(Effect.TRIGGER_TYPE_ATTENTION);

            this.ui.hoverEffectEnabled.prop("checked", hasHoverEffect);
            this.ui.hoverRegion.toggle(hasHoverEffect);

            this.ui.attentionEffectEnabled.prop("checked", hasAttentionEffect);
            this.ui.attentionRegion.toggle(hasAttentionEffect);
        },

        onShow: function onShow() {
            this.hoverRegion.show(this._hoverEffectLibrary);
            this.attentionRegion.show(this._attentionEffectLibrary);

            this._updateToModel();
            this._toggleAttentionEffectLibrary();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        EditorEvents = __webpack_require__(17),
        ImageToggleEffectModel = __webpack_require__(301),
        ImageToggleEffectPropertiesView = __webpack_require__(1723),
        ImprovedView = __webpack_require__(6),
        OpacityEffectModel = __webpack_require__(245),
        OpacityPropertiesView = __webpack_require__(871),
        PulseEffectModel = __webpack_require__(500),
        PulseEffectPropertiesView = __webpack_require__(1745),
        RotateEffectModel = __webpack_require__(359),
        RotateEffectPropertiesView = __webpack_require__(1747),
        ScaleEffectModel = __webpack_require__(499),
        ScaleEffectPropertiesView = __webpack_require__(1749),
        template = __webpack_require__(1751),
        Effect = __webpack_require__(78),
        WidgetTypes = __webpack_require__(69);

    /**
     * The set of default effects - supported by all widgets.
     *
     * @type {String[]}
     */
    var DEFAULT_EFFECTS = [OpacityEffectModel.TYPE, ScaleEffectModel.TYPE, PulseEffectModel.TYPE, RotateEffectModel.TYPE];

    var EMAIL_EFFECTS_MODE = [OpacityEffectModel.TYPE];

    var ACTIVE_EFFECTS_MODE = DEFAULT_EFFECTS;

    var effectTypeToPropertiesView = new Map();

    effectTypeToPropertiesView.set(OpacityEffectModel.TYPE, OpacityPropertiesView);
    effectTypeToPropertiesView.set(ImageToggleEffectModel.TYPE, ImageToggleEffectPropertiesView);
    effectTypeToPropertiesView.set(ScaleEffectModel.TYPE, ScaleEffectPropertiesView);
    effectTypeToPropertiesView.set(PulseEffectModel.TYPE, PulseEffectPropertiesView);
    effectTypeToPropertiesView.set(RotateEffectModel.TYPE, RotateEffectPropertiesView);

    // Specific effects for specific widgets
    var concreteWidgetEffects = new Map();

    concreteWidgetEffects.set(WidgetTypes.IMAGE.id, [ImageToggleEffectModel.TYPE]);

    /**
     * The effect library view, contains the subviews for different effect types.
     *
     * @class EffectLibraryView
     *
     * @cfg {AbstractWidgetModel} model The widget model being edited.
     */
    return ImprovedView.extend({

        _enabled: false,
        _currentEffect: null,
        isEmailModeEnabled: false,

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                triggerType: this.options.triggerType
            };
        },

        ui: {
            hoverProperties: ".hover-effect-properties",
            attentionProperties: ".attention-effect-properties",
            libraryEffect: ".effect-library .effect",
            effectConfiguration: ".effect-configuration",
            slider: ".slider",
            sliderValue: ".slider-value",
            timingEffectConfiguration: ".timing-effect-configuration"
        },

        regions: {
            effectConfigurationRegion: ".effect-configuration-region"
        },

        events: {
            "click .effect": "_effectClickHandler"
        },

        initialize: function initialize() {
            this._enabled = this.options.effects.hasTriggerType(this.options.triggerType);
            this._currentEffect = this._selectedEffect();
        },

        enabled: function enabled(flag) {
            if (this._enabled === flag) {
                return;
            }

            if (flag) {
                this._addSelectedEffect();
                this._showPropertiesView();
            } else {
                this.options.effects.removeByTriggerType(this.options.triggerType);
            }

            this._enabled = flag;
            if (this._enabled && this.options.viewModel.get("experience").get("emailModeEnabled")) {
                this._turnOnEffect(true);
            }
        },

        _selectedEffect: function _selectedEffect() {
            return this.options.effects.firstByTriggerType(this.options.triggerType);
        },

        _applyEffectsSet: function _applyEffectsSet() {
            this.isEmailModeEnabled = this.options.viewModel.get("experience").get("emailModeEnabled");
            ACTIVE_EFFECTS_MODE = this.isEmailModeEnabled && Effect.TRIGGER_TYPE_HOVER === this.options.triggerType ? EMAIL_EFFECTS_MODE : DEFAULT_EFFECTS;
        },


        _effectClickHandler: function _effectClickHandler(event, element) {
            var $element = element || $(event.target),
                effectType = $element.attr("data-target"),
                disabled = $element.hasClass("disabled"),
                uiEffectType;

            // If disabled or already selected - bail out
            if (disabled || !!this._selectedEffect() && effectType === this._selectedEffect().get("type")) {
                return;
            }

            this._selectEffectUI(effectType);
            this._addSelectedEffect();
            this._showPropertiesView();

            switch (effectType) {
                case "scale":
                    uiEffectType = "resize";
                    break;

                case "imageToggle":
                    uiEffectType = "imageSwap";
                    break;
                default:
                    uiEffectType = effectType;
            }

            var triggerType = this.options.triggerType === "attention" ? "loop" : this.options.triggerType,
                viewModel = this.viewScope.viewModel,
                experience = viewModel.get("experience"),
                eventProperties = {
                widgetType: this.model.get("type"),
                updatedProperty: "effect",
                updatedValue: triggerType + "-" + uiEffectType,
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                sceneNumber: viewModel.get("sceneNumber"),
                triggerOrigin: "WidgetMenuEffectCheckbox"
            };

            // Fire event for tracking Mix Panel events via Segment
            EditorEvents.trigger(EditorEvents.constants.UPDATE_WIDGET, eventProperties);
        },

        _addSelectedEffect: function _addSelectedEffect() {
            var effectType = this.$(".effect.selected").attr("data-target"),
                previousEffect = this._currentEffect;

            // We only allow a single effect per trigger type
            this.options.effects.removeByTriggerType(this.options.triggerType, { silent: true });

            // Lookup the effect class
            var EffectClass = this.options.effects.classFromType(effectType);

            this._currentEffect = new EffectClass({ triggerType: this.options.triggerType });
            // Add the selected effect to the collection
            this.options.effects.add(this._currentEffect);
            this._bindTimingToEffectModel(previousEffect);
        },

        _bindTimingToEffectModel: function _bindTimingToEffectModel(previousModel) {
            this.unstickit(previousModel);

            this.stickit(this._currentEffect, {
                ".duration": {
                    observe: "duration",
                    onGet: function onGet(value) {
                        return value / 1000;
                    },

                    onSet: function onSet(value) {
                        return value * 1000;
                    }
                },
                ".post-delay": {
                    observe: "postDelay",
                    onGet: function onGet(value) {
                        return value / 1000;
                    },

                    onSet: function onSet(value) {
                        return value * 1000;
                    }
                }
            });
        },

        /**
         * @private
         *
         * Renders the selected effect in the UI.
         *
         * @param  {String} effectType The effect type, e.g. <tt>opacity</tt>.
         */
        _selectEffectUI: function _selectEffectUI(effectType) {
            // Deselect all effects in library
            this.ui.libraryEffect.removeClass("selected");

            var target = this.$("[data-target='" + effectType + "']");

            // Select clicked effect in library
            target.addClass("selected");

            // Disable timing-panel on the attention-effect pulse
            this.ui.timingEffectConfiguration.toggleClass("show", effectType !== "pulse" && this.options.triggerType === "attention");
        },

        _showPropertiesView: function _showPropertiesView() {
            // Show config to selected effect
            var selectedEffect = this._selectedEffect();
            if (selectedEffect) {
                var PropertiesViewClass = effectTypeToPropertiesView.get(selectedEffect.get("type"));
                this.effectConfigurationRegion.show(new PropertiesViewClass({ model: selectedEffect }));
            }
        },

        _turnOnEffect: function _turnOnEffect() {
            var firstEnable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (this._enabled) {
                var selectedEffect = this._selectedEffect();
                var allAccessibleEffects = ACTIVE_EFFECTS_MODE.concat(concreteWidgetEffects.get(this.model.get("type")));
                var currentEffectType = selectedEffect && !firstEnable ? selectedEffect.get("type") : null;
                var accessibleEffect = allAccessibleEffects.find(function (type) {
                    return currentEffectType === type;
                });
                var currentAccessibleEffectType = accessibleEffect || allAccessibleEffects[0];
                this._selectEffectUI(currentAccessibleEffectType);
                if (!accessibleEffect && firstEnable) {
                    this._addSelectedEffect();
                }
                this._showPropertiesView();
                this._bindTimingToEffectModel();
            }
        },

        onRender: function onRender() {
            var _this = this;

            this._applyEffectsSet();
            this._turnOnEffect();

            // Only enable effects that are supported by the current widget
            this.$(".effect").each(function (i, element) {
                var effectElement = $(element),
                    effectType = effectElement.attr("data-target"),
                    effectEnabled = true;

                // If it's not a default effect - check to see if it's supported
                // by the current widget
                if (ACTIVE_EFFECTS_MODE.indexOf(effectType) === -1) {
                    var widgetEffects = concreteWidgetEffects.get(_this.model.get("type"));
                    effectEnabled = widgetEffects && widgetEffects.indexOf(effectType) !== -1;
                }

                // Apply the disabled class if not supported
                effectElement.toggleClass("disabled", !effectEnabled);
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var CompactImageLibraryView = __webpack_require__(552);
    var ImageCollection = __webpack_require__(314);
    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(1742);

    /**
     * A view representing the currently selected "swap image".
     *
     * @see MOS-2687
     */
    var SelectedImageView = ImprovedView.extend("SelectedImageView", {

        template: _.template("<label class='block'>Selected Image</label><div class='thumb-cover'></div>"),

        ui: {
            thumbCover: ".thumb-cover"
        },

        initialize: function initialize(options) {
            this._imageLibrary = options.imageLibrary;
        },
        onShow: function onShow() {
            var _this = this;

            // View stays hidden until we receive a "image:selected" event.
            this.$el.hide();

            this.listenTo(this._imageLibrary, "image:selected", function (imageModel) {
                _this._renderThumb(imageModel);
            });
        },
        _renderThumb: function _renderThumb(imageModel) {
            var url = imageModel.get("absoluteThumbUrl");

            this.ui.thumbCover.css("backgroundImage", "url(" + url + ")");

            this.$el.show();
        }
    });

    /**
     * A view representing the properties of the <tt>ImageToggleEffect</tt>.
     *
     * @cfg {ImageToggleEffectModel} model
     *
     * @class ImageToggleEffectPropertiesView
     */
    return ImprovedView.extend({

        className: "image-toggle-effect-properties-view",

        template: template,

        regions: {
            imageToggleLibraryRegion: ".image-toggle-library-region",
            selectedImageRegion: ".selected-image-region"
        },

        onShow: function onShow() {
            var _this2 = this;

            var imageLibrarySorting = this.viewScope.viewModel.get("imageLibrarySorting");
            var collection = new ImageCollection();
            var viewModel = this.viewScope.viewModel;

            var imageLibrary = new CompactImageLibraryView({
                collection: collection,
                selectedImage: this.model && this.model.get("imageId") ? this.model : null,
                project: viewModel.get("project"),
                // Enable 'autoSelection', i.e. ensures that the CompactImageLibraryView will select the first image model in the collection, if any, and if no 'selectedImageId' is found or defined.
                autoSelection: true,
                imageLibrarySorting: imageLibrarySorting,
                itemViewOptions: {
                    imageTaggingEnabled: viewModel.get("imageTaggingEnabled"),
                    inventoryEnabled: viewModel.get("inventoryEnabled")
                }
            });

            this.listenTo(imageLibrary, "image:selected", function (imageModel) {
                _this2._updateModelProperties(imageModel, _this2.model);
            });

            this.imageToggleLibraryRegion.show(imageLibrary);
            this.selectedImageRegion.show(new SelectedImageView({ imageLibrary: imageLibrary }));
        },


        /**
         * @private
         *
         * Updates the model properties.
         *
         * @param {ImageModel} sourceImage The source model to get the properties from.
         * @param {ImageWidgetModel} destinationImage The destination model to set the properties to.
         */
        _updateModelProperties: function _updateModelProperties(sourceImage, destinationImage) {
            destinationImage.set({
                altText: sourceImage.get("altText"),
                imageId: sourceImage.get("id"),
                originalImageHeight: sourceImage.get("height"),
                originalImageWidth: sourceImage.get("width"),
                supportsResize: sourceImage.get("supportsResize"),
                sourceType: sourceImage.get("sourceType"),
                src: sourceImage.get("url")
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImageModel = __webpack_require__(258);
    var RestApi = __webpack_require__(29);
    var UrlUtil = __webpack_require__(46);
    var AbstractFileStorage = __webpack_require__(861);
    var Configuration = __webpack_require__(27);

    // Supported image extensions and (way to large) image sizes, matching the constraints at the backend...
    var IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif"];

    /**
     * The file storage service.
     *
     * @class ImageFileStorage
     */
    var ImageFileStorage = AbstractFileStorage.extend({
        _modelInfo: function _modelInfo(file) {
            var expHasC3prefix = (0, _C3Utils.isC3Experience)();
            var url = UrlUtil.appendParamObject(RestApi.pathToCollection(RestApi.Collections.IMAGES), { filename: file.name });
            var c3ApiUpload = false;
            if (expHasC3prefix) {
                url = UrlUtil.appendParamObject(Configuration.c3ApibaseUrl + "/v1/images?folderPath=/", { filename: file.name });
                c3ApiUpload = true;
            }
            return {
                modelClass: ImageModel,
                url: url,
                supportedTypes: IMAGE_EXTENSIONS,
                errorMessages: {
                    // HttpStatusCodes.CONFLICT (409) has special meaning for image upload.
                    CONFLICT: "it is already in the process of being uploaded."
                },
                c3ApiUpload: c3ApiUpload // @boolean , indicate whether will upload to C3 or Legacy
            };
        }
    });

    return ImageFileStorage;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var ImageTagModel = __webpack_require__(554);

    var ImageTagCollection = Backbone.Collection.extend({

        model: ImageTagModel,

        /**
         * Used to maintain the collection in sorted order. Sorts by ``confidence``, ``ImageTagModel.Types.MANUAL`` and alphabetical.
         *
         * @see http://backbonejs.org/#Collection-comparator
         *
         * @param {ImageTagModel} tagA The "first" model.
         * @param {ImageTagModel} tagB The "second" model.
         * @returns {Boolean} ``false`` for the "first" model, ``true`` for the "second" model.
         */
        comparator: function comparator(tagA, tagB) {
            if (tagA.get("confidence") === tagB.get("confidence")) {
                if (tagA.get("type") !== tagB.get("type")) {
                    return tagA.get("type") !== ImageTagModel.Types.MANUAL ? 1 : -1;
                }
                return tagA.get("name") > tagB.get("name") ? 1 : -1;
            }

            return tagA.get("confidence") < tagB.get("confidence") ? 1 : -1;
        },
        newCopySortedByConfidence: function newCopySortedByConfidence(maxItems) {
            return new ImageTagCollection(this.first(maxItems));
        }
    });

    return ImageTagCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var HttpStatusCodes = __webpack_require__(189);

    var MAX_FILE_SIZE = 5242880; // 5 MB

    return {

        /**
         * Pre-validates the SyncManager when uploading files to Creator.
         * @param {File|Object}         File to be validated.
         * @param {Boolean}             Boolean indicating whether the same file is being uploaded.
         *
         * @return {HttpStatusCodes}    An http status code to be returned to the Sync Manager.
         */
        validate: function validate(file, isSameFileBeingUploaded, supportedTypes) {
            if (this._hasZeroSize(file)) {
                return HttpStatusCodes.LENGTH_REQUIRED;
            }

            if (this._hasExceededMaxSize(file)) {
                return HttpStatusCodes.REQUEST_ENTITY_TOO_LARGE;
            }

            if (!this._hasValidExtension(file, supportedTypes)) {
                return HttpStatusCodes.UNSUPPORTED_MEDIA_TYPE;
            }

            if (this._hasUploadAlreadyInProgress(file, isSameFileBeingUploaded)) {
                return HttpStatusCodes.CONFLICT;
            }

            return HttpStatusCodes.OK;
        },


        /**
         * Check for file size.
         *
         * @param {File|Object} File to be validated.
         * @returns {Boolean} True if file is null, undefined or has zero size.
         */
        _hasZeroSize: function _hasZeroSize(file) {
            return !file || file.size === 0;
        },


        /**
         * Checks for file max size.
         *
         * @param {File|Object} File to be validated.
         * @returns {Boolean} True if file is is exceeding maximum size.
         */
        _hasExceededMaxSize: function _hasExceededMaxSize(file) {
            return !this._hasZeroSize(file) && file.size > MAX_FILE_SIZE;
        },


        /**
         * Checks for file extension.
         *
         * @param {File|Object} File to be validated.
         * @returns {Boolean} True if file extension is supported.
         */
        _hasValidExtension: function _hasValidExtension(file, supportedTypes) {
            if (this._hasZeroSize(file)) {
                return false;
            }

            var name = file.name || "";
            var i = name.lastIndexOf(".");

            // Make sure extension is valid...
            if (i !== -1) {
                name = name.substring(i + 1).toLowerCase();

                if (supportedTypes.indexOf(name) === -1) {
                    return false;
                }
            }

            return true;
        },


        /**
         * Checks for conflicting concurrent uploads.
         *
         * @param {File|Object} File to be validated.
         * @param {Boolean}     Whether file is being uploaded from Sync Manager.
         *
         * @returns {Boolean}   True if same file is being uploaded in Creator..
         */
        _hasUploadAlreadyInProgress: function _hasUploadAlreadyInProgress(file, isSameFileBeingUploadedFunction) {
            if (this._hasZeroSize(file)) {
                return false;
            }

            return Boolean(isSameFileBeingUploadedFunction);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form class="drop-target">\n    <div class="drop-info-box">\n        <p class="drop-target-message"></p>\n        <div class="icon"></div>\n    </div>\n    <input type="file" class="upload" multiple title="click here to upload">\n</form>\n';

}
return __p
}

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var InfiniteScrollingCollectionView = __webpack_require__(259);
    var ImageLibrarySourceEnum = __webpack_require__(102);
    var NoResultsItemView = __webpack_require__(207);
    var ImageThumbnailView = __webpack_require__(556);

    /**
     * A <tt>InfiniteScrollingCollectionView</tt> subclass for displaying (and lazy loading) images, i.e. <tt>ImageThumbnailView</tt>'s.
     *
     * @cfg {ImageCollection} collection The <tt>ImageCollection</tt> to render.
     *
     * @see  ImageCollection
     * @see  ImageThumbnailView
     * @see  InfiniteScrollingCollectionView
     *
     * @class ImageCollectionView
     */
    return InfiniteScrollingCollectionView.extend("ImageCollectionView", {

        itemView: ImageThumbnailView,

        collectionEvents: {
            "source:changed": "_onSourceChange"
        },

        _onSourceChange: function _onSourceChange(source) {
            if (this._spinner) {
                this._spinner.$el.toggleClass("scene7", source === ImageLibrarySourceEnum.SCENE7);
            }
        },
        onEmpty: function onEmpty() {
            return new NoResultsItemView({ type: "Images" });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        ViewScope = __webpack_require__(171),
        Marionette = __webpack_require__(10),
        _ = __webpack_require__(1);

    /**
     *   collection view for rendering a <tt>ChunkingCollection</tt>.
     *
     * @see  ChunkingCollection
     *
     * @class ChunkingCollectionView
     */
    return ImprovedView.extend({

        /**
         * CSS class name to be applied to newly added children, defaults to <tt>fade-in</tt>.
         *
         * @type {String}
         */
        entryTransition: "fade-in",

        /**
         * The item views class/constructor function.
         * @type {Function}
         */
        itemView: null,

        /**
         * Factory function for providing additional options to the constructed item view.
         *
         * @type {Object|Function}
         */
        itemViewOptions: null,

        /**
         * Internal array of all views rendered by this collection view - including potential pseudo views (section headers etc) returned
         * by <tt>onAddingView</tt>.
         *
         * @type {ImprovedView[]}
         */
        _views: null,

        /**
         * Internal array of all item views rendered by this collection view, i.e. the actual views representing the
         * models contained in the associated collection, and not potential pseudo views (section headers etc).
         *
         * @type {ImprovedView[]}
         */
        _itemViews: null,

        /**
         * Constructor.
         *
         * @param {Object} options @cfg itemView {Function}
         */
        constructor: function constructor(options) {
            this.__super();

            this._views = [];
            this._itemViews = [];
            this.collection = this.options.collection;
            this.itemView = options.itemView || this.itemView;
            this.itemEvents = options.itemEvents || this.itemEvents;
            this.itemViewOptions = options.itemViewOptions || this.itemViewOptions;

            this.listenTo(this.collection, {
                "add": this._addHandler,

                "remove": this._removeHandler,

                "reset": function reset() {
                    this._closeAndRemoveChildren();
                },

                "sync": function sync() {
                    if (this.collection.isEmpty()) {
                        this._handleOnEmpty();
                    }
                }
            });
        },

        template: function template() {
            return "";
        },

        serializeData: function serializeData() {
            return {};
        },

        onShow: function onShow() {
            if (this.collection.isEmpty() && !this.collection.isPending()) {
                this._handleOnEmpty();
            } else {
                this._addHandler(this.collection.latest());
            }
        },

        onEmpty: function onEmpty() {},

        removeView: function removeView(view) {
            var i = this._views.indexOf(view);

            view.isClosing = true;

            this._views.splice(i, 1);

            i = this._itemViews.indexOf(view);

            if (i !== -1) {
                this._itemViews.splice(i, 1);
            }

            Marionette.triggerMethod.call(view, "closing");

            if (!view || view.isClosed) {
                return;
            }

            if (view.close) {
                view.close();
            } else if (view.remove) {
                view.remove();
            }

            view.$el.remove();
        },

        at: function at(index) {
            return this._views[index];
        },

        findById: function findById(id) {
            return _.find(this._itemViews, function (itemView) {
                return itemView.model.get("id") === id;
            });
        },

        numberOfViews: function numberOfViews() {
            return this._views.length;
        },

        _addView: function _addView(view, index) {
            var _this = this;

            var views = _.isArray(view) ? view : [view],
                usingIndex = index !== undefined;
            views.forEach(function (view) {
                _this._register(view);

                view.render();

                if (usingIndex) {
                    _this._views.splice(index, 0, view);

                    var previousView = _this.at(index - 1);

                    if (previousView) {
                        view.$el.insertAfter(previousView.el);
                    } else {
                        _this.$el.prepend(view.el);
                    }

                    index++;
                } else {
                    _this.$el.append(view.el);
                    _this._views.push(view);
                }

                Marionette.triggerMethod.call(view, "show");

                view.$el.addClass(_this.entryTransition);
            });
        },

        _handleOnEmpty: function _handleOnEmpty() {
            var children = this.onEmpty();

            if (children) {
                this._addView(children);
            }
        },

        _register: function _register(view) {
            view.parentView = this;
            ViewScope.register(this, view);
        },

        _listenForItemViewEvents: function _listenForItemViewEvents(view) {
            if (this.itemEvents) {
                var self = this;

                _.each(this.itemEvents, function (callback, event) {
                    self.listenTo(view, event, callback.bind(self));
                });
            }
        },

        /**
         * @private
         *
         * Invoked when a new model is added to the collection.
         *
         * Creates and renders the view representing said model, and adds it to the DOM.
         *
         * @param {Model|Model[]} models A model of array of models.
         * @param {Number} index  The position of the model in the collection.
         */
        _addHandler: function _addHandler(models, index) {
            var _this2 = this;

            this.onBeforeViewsAdded();

            // If theres already a view occupying the specified index, we assume that the view was
            // added manually, i.e. by calling <tt>collection.add(model, 0)</tt>. We need to determine
            // the proper index, taken potential pseudo views into account.
            var viewAtIndex = this.at(index);

            if (viewAtIndex) {
                // Get the item view currently at that position
                var itemView = this._itemViews[index];

                if (itemView) {
                    // Lookup the rendered index of the item view and set it as the starting index...
                    index = this._views.indexOf(itemView);
                }
            }

            models.forEach(function (model) {
                var viewOptions = _.extend(_this2._getItemViewOptions(), { model: model }),
                    view = new _this2.itemView(viewOptions),
                    i = index !== undefined ? index : _this2._views.length,
                    prependedView = _this2.onAddingView(view, i);

                if (prependedView) {
                    _this2._addView(prependedView, i);

                    i += _.isArray(prependedView) ? prependedView.length : 1;
                }

                _this2._listenForItemViewEvents(view);
                _this2._addView(view, i);
                _this2._itemViews.splice(i, 0, view);
            });

            this.onViewsAdded();
        },

        _getItemViewOptions: function _getItemViewOptions() {
            if (_.isFunction(this.itemViewOptions)) {
                return this.itemViewOptions.call(this);
            }

            return this.itemViewOptions || {};
        },

        _removeHandler: function _removeHandler(model) {
            var view = _.find(this._views, function (view) {
                return view.model.get("id") === model.get("id");
            });

            if (view) {
                this.removeView(view);
            }
        },

        _closeChildren: function _closeChildren() {
            _.invoke(this._views, "close");
        },

        _closeAndRemoveChildren: function _closeAndRemoveChildren() {
            this._views.forEach(function (view) {
                view.close();
                view.$el.remove();
            });

            this._views = [];
            this._itemViews = [];
        },

        onBeforeViewsAdded: function onBeforeViewsAdded() {},

        onAddingView: function onAddingView(index, model) {// eslint-disable-line no-unused-vars

        },

        onViewsAdded: function onViewsAdded() {},

        onClose: function onClose() {
            this._closeChildren();

            this._views = null;
            this._itemViews = null;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span class="message"></span>';

}
return __p
}

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        isString = _require.isString,
        defer = _require.defer,
        $ = __webpack_require__(4),
        _require2 = __webpack_require__(30),
        rtrim = _require2.rtrim;

    return {

        /**
         * Set focus in the end of the input field. It is used when the user click on
         * the pencil image.
         * @param {Jquery} $el Element that will be placed the focus
         */
        setCaretEndPosition: function setCaretEndPosition($el) {
            if ($el && $el.length > 0) {
                var el = $el.get(0),
                    maxScrollLeft = el.scrollWidth - el.clientWidth;

                // It is needed to be called after the click event.
                // Otherwise, It won't have effect.
                defer(function () {
                    el.focus();

                    $el.scrollLeft(maxScrollLeft);

                    if (typeof window.getSelection !== "undefined" && typeof document.createRange !== "undefined") {
                        var range = document.createRange();

                        range.selectNodeContents(el);

                        range.collapse(false);

                        var sel = window.getSelection();

                        sel.removeAllRanges();

                        sel.addRange(range);
                    } else if (typeof document.body.createTextRange !== "undefined") {
                        var textRange = document.body.createTextRange();

                        textRange.moveToElementText(el);

                        textRange.collapse(false);

                        textRange.select();
                    }
                });
            }
        },

        /**
         * Check if the text-overflow: ellipsis  is activated for the input field
         *
         * @param   {Object}    field object.
         *
         * @returns {Boolean}   Returns a boolean if the element needs the Ellipsis feature
         */
        isEllipsisActive: function isEllipsisActive(field) {
            var returnVal = false,
                text = field.val(),
                $input = field.input,
                css = $input.css(["fontSize", "fontWeight", "fontFamily"]),
                // TODO: broken! does not seem to properly take margin/padding/border into account!
            $tmp = $("<span>", { text: text, css: css }),
                input = $input.get(0);

            $("body").append($tmp);

            if ($input.is("input") && $input.width() < $tmp.width()) {
                returnVal = true;
            } else if (input.offsetWidth < input.scrollWidth) {
                returnVal = true;
            }

            $tmp.remove();

            return returnVal;
        },
        /**
         * Remove some &nbsp; or &amp; chars from the final string. It will
         * double check the $().text() function and be sure that any dirty html
         * will come in the middle.
         *
         *
         * OBS1: It can't use the underscore htmlUnescape function, because the underscore function
         * will remove all htmls tags.
         *
         * @param {String} val The value that will sanitized
         * @returns {*}
         */
        sanitize: function sanitize(val) {
            if (isString(val)) {
                val = rtrim(val);

                val = val.replace(/&nbsp;/g, " ");

                val = val.replace(/&amp;/g, "&");
            }

            return val;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="image-tag-container">\n  ';
 if (editable) { ;
__p += '\n      <div contenteditable="true" class="name"></div>\n      <button type="button" class="delete">\n          <span class="glyphicon glyphicon-remove"></span>\n      </button>\n  ';
 } else { ;
__p += '\n      <div class="name"></div>\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
}

/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EventDispatcher = __webpack_require__(54);
    var EditorEvents = __webpack_require__(17);
    var Preconditions = __webpack_require__(14);
    var _ = __webpack_require__(1);

    var _EditorEvents$constan = EditorEvents.constants,
        ADD_IMAGE_TAG = _EditorEvents$constan.ADD_IMAGE_TAG,
        REMOVE_IMAGE_TAG = _EditorEvents$constan.REMOVE_IMAGE_TAG,
        EDIT_IMAGE_TAG = _EditorEvents$constan.EDIT_IMAGE_TAG;

    /**
     * Custom behavior for tracking `ImageTagCollection` related changes.
     *
     * Intentionally not a `Marionette.Behavior` subclass due to lack of event support.
     *
     * @class ImageTagTrackingBehavior
     */

    return EventDispatcher.extend("ImageTagTrackingBehavior", {

        /**
         * Constructor.
         *
         * @param {Object} options The options defined for `this` behavior.
         * @param {Backbone.View} view The associated view instance.
         */
        constructor: function constructor(options, view) {
            this._view = view;
        },


        /**
         * Invoked via the Marionette behavior lifecycle.
         */
        onShow: function onShow() {
            var editable = this._view.options.editable;

            // Only enabled if the `editable` flag has been set.

            if (editable) {
                var collection = this._view.collection;


                this.listenTo(collection, "add remove", this._addRemoveTagsHandler);
                this.listenTo(collection, "change", this._changeTagsHandler);
            }
        },


        /**
         * Invoked via the Marionette behavior lifecycle.
         */
        onClose: function onClose() {
            this.stopListening();
        },
        _addRemoveTagsHandler: function _addRemoveTagsHandler(model, collection, _ref) {
            var add = _ref.add,
                triggerSource = _ref.triggerSource;

            // Only trigger event if the associated view caused the change.
            if (triggerSource === this._view) {
                var eventName = add ? ADD_IMAGE_TAG : REMOVE_IMAGE_TAG;
                this._trigger(eventName, model);
            }
        },
        _changeTagsHandler: function _changeTagsHandler(model, _ref2) {
            var stickitChange = _ref2.stickitChange,
                editBehaviorChange = _ref2.editBehaviorChange;

            // Determine the view/trigger source causing the change - based on either stickit or the EditBehavior
            var view = stickitChange && stickitChange.view || editBehaviorChange && editBehaviorChange.view;
            var triggerSource = view.options.triggerSource;

            // Ensure that the change origins from the associated view - we may have more than one view modifying the same model instance.

            if (triggerSource === this._view) {
                this._trigger(EDIT_IMAGE_TAG, model, {
                    previousTagName: model.previous("name"),
                    previousTagType: model.previous("type")
                });
            }
        },


        /**
         * Convenience for triggering the actual tracking event.
         *
         * Constructs the event properties based on the `ImageTagModel` and the current `ImageModel`.
         *
         * @param {String} eventName The event name.
         * @param {ImageTagModel} imageTagModel The current `ImageTagModel`.
         * @param {Object} [additionalEventProperties={}] Any additional event properties, optional.
         */
        _trigger: function _trigger(eventName, imageTagModel) {
            var additionalEventProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            var _view$options$trackin = this._view.options.trackingOptions,
                triggerOrigin = _view$options$trackin.triggerOrigin,
                imageModel = _view$options$trackin.imageModel;


            Preconditions.isModel(imageModel, "An image model must be defined.");

            var eventProperties = {
                triggerOrigin: triggerOrigin,
                imageId: imageModel.get("id"),
                imageName: imageModel.get("name"),
                tagName: imageTagModel.get("name"),
                tagType: imageTagModel.get("type")
            };

            _.extend(eventProperties, additionalEventProperties);

            EditorEvents.trigger(eventName, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1734 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span class="image-tags-label">\n    Tags:&nbsp;\n</span>\n';
 if (editable) { ;
__p += '\n    <div class="tag-input-container">\n        <form class="image-tag-new-form">\n            <div class="form-group">\n                <input type="text" class="tag-input" placeholder="New tag name" maxlength="' +
__e( maxNameLength ) +
'" />\n                <span class="tag-input-message"></span>\n            </div>\n        </form>\n    </div>\n';
 } ;
__p += '\n<ul class="tags-list"></ul>\n';

}
return __p
}

/***/ }),
/* 1735 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span class="inventory-tags-label">\n    Inventory ID:&nbsp;\n</span>\n';
 if (editable) { ;
__p += '\n    <div class="inventory-tag-input-container">\n        <form class="inventory-tag-new-form">\n            <div class="inventory-form-group">\n                <input type="text" class="inventory-tag-input" placeholder="New inventory ID" maxlength="' +
__e( maxNameLength ) +
'" />\n                <span class="inventory-tag-input-message"></span>\n            </div>\n        </form>\n    </div>\n';
 } ;
__p += '\n<ul class="inventory-tags-list"></ul>\n';

}
return __p
}

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var ImageTagCompositeView = __webpack_require__(557);
    var template = __webpack_require__(1737);

    return ImprovedView.extend({

        template: template,

        regions: {
            imageTagsRegion: ".imageTagsRegion"
        },

        templateHelpers: function templateHelpers() {
            var _options = this.options,
                showExtension = _options.showExtension,
                showTags = _options.showTags,
                isScene7 = _options.isScene7;

            return {
                altText: this.model.get("altText") || "",
                showTags: showTags,
                showExtension: showExtension,
                isScene7: isScene7
            };
        },
        onRender: function onRender() {
            var showTags = this.options.showTags;


            if (showTags) {
                this.imageTagsRegion.show(new ImageTagCompositeView({
                    collection: this.model.get("tags").newCopySortedByConfidence(5)
                }));
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1737 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="assetTooltip">\n    <div class="image-wrapper">\n        <div class="image-container">\n            ';
 if (isScene7) { ;
__p += ' <div class="adobe-logo"></div> ';
 } ;
__p += '\n            <img src="' +
__e( absoluteThumbUrl ) +
'" class="image" title="' +
__e( name ) +
'">\n        </div>\n    </div>\n\n    <div class="image-info">\n        <div class="title">' +
__e( name );
 if (timesUsed > 0) { ;
__p += ' <span class="times-used">(' +
__e( timesUsed ) +
')</span> ';
 } ;
__p += '</div>\n        <div>\n            Alt text: ' +
__e( altText ) +
'\n        </div>\n        <div class="description">\n            <ul>\n                <li>Size: ' +
__e( width ) +
' &times; ' +
__e( height ) +
' / ' +
__e( displaySize ) +
'</li>\n                ';
 if (showExtension) { ;
__p += '\n                    <li>Type: ' +
__e( extension ) +
'</li>\n                ';
 } ;
__p += '\n                ';
 if (showTags) { ;
__p += '\n                    <li>\n                        <div class="imageTagsRegion"></div>\n                    </li>\n                ';
 } ;
__p += '\n            </ul>\n        </div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (enableDeletion) { ;
__p += '\n    <div class="actions-panel">\n        ';
 if (isEditable && timesUsed > 0) { ;
__p += '\n            <span class="no-delete pull-right" data-content="The Image is in use and cannot be deleted"></span>\n        ';
 } else if (isEditable) { ;
__p += '\n            <span class="delete pull-right" data-content="Delete Image forever"></span>\n        ';
 } else { ;
__p += '\n            <span class="delete pull-right disabled" data-content="You do not have permission to delete Images"></span>\n        ';
 } ;
__p += '\n    </div>\n';
 } ;
__p += '\n\n<div class="image-thumb">\n    <span class="helper"></span>\n    ';
 if (uploading) { ;
__p += '\n        <div class="image-placeholder">\n            <div class="progress-bar"></div>\n        </div>\n    ';
 } else { ;
__p += '\n        <img src="' +
__e( absoluteThumbUrl ) +
'" class="image">\n    ';
 } ;
__p += '\n</div>\n\n<div class="image-info">\n    <div class="js-name-editable-container editable-container';
 if (!isEditable) {;
__p += ' not-editable';
 } ;
__p += '">\n        <div class="name-and-times-used">\n            <div class="js-name title editable" contenteditable="' +
__e( isEditable ) +
'"></div>\n            ';
 if (timesUsed > 0) { ;
__p += '\n                <span class="times-used" data-content="This image was used ' +
__e( timesUsed ) +
' times">(' +
__e( timesUsed ) +
')</span>\n            ';
 } ;
__p += '\n        </div>\n        ';
 if (isEditable) { ;
__p += '\n            <div class="editable-cell-img js-name-icon"><div class="editable-img"></div></div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="js-alt-text-editable-container editable-container';
 if (!isEditable) { ;
__p += ' not-editable';
 } ;
__p += '">\n        <div class="alt-text-label">Alt text: </div>\n        <div class="js-alt-text alt-text editable" contenteditable="' +
__e( isEditable ) +
'"></div>\n        ';
 if (isEditable) { ;
__p += '\n            <div class="editable-cell-img js-alt-text-icon"><div class="editable-img"></div></div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="description">\n        <ul>\n            <li>Size: ' +
__e( width ) +
' &times; ' +
__e( height ) +
' / ' +
__e( displaySize ) +
'</li>\n            <li>Type: ' +
__e( extension ) +
'</li>\n            ';
 if (inventoryEnabled) { ;
__p += '\n            <li>\n                <div class="inventoryTagsRegion"></div>\n            </li>\n            ';
 } ;
__p += '\n            ';
 if (imageTaggingEnabled) { ;
__p += '\n            <li>\n                <div class="imageTagsRegion"></div>\n            </li>\n            ';
 } ;
__p += '\n        </ul>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ChunkingCollectionQuery = __webpack_require__(868);

    var TYPE_AND = "And";
    var TYPE_OR = "Or";

    var FilterQuery = ChunkingCollectionQuery.extend("FilterQuery", {

        /**
         * Constructor.
         *
         * @param {String} [type=TYPE_AND] In case *this* filter query includes multiple expressions, this defines the root type.
         */
        constructor: function constructor() {
            var rootType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TYPE_AND;

            this.__super();

            this.rootType = rootType;

            this._expressions = [];
        },
        and: function and() {
            for (var _len = arguments.length, expressions = Array(_len), _key = 0; _key < _len; _key++) {
                expressions[_key] = arguments[_key];
            }

            return this._addExpressions(expressions, "And");
        },
        or: function or() {
            for (var _len2 = arguments.length, expressions = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                expressions[_key2] = arguments[_key2];
            }

            return this._addExpressions(expressions, "Or");
        },


        // Doesn't add any types to each expression. Useful to query with only the root type.
        useRoot: function useRoot() {
            var _this = this;

            for (var _len3 = arguments.length, expressions = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                expressions[_key3] = arguments[_key3];
            }

            expressions.forEach(function (expression) {
                _this._expressions.push(expression.toJSON());
            });

            return this;
        },
        querify: function querify() {
            var query = this._expressions[0];

            if (this._expressions.length > 1) {
                query = _defineProperty({}, this.rootType, this._expressions);
            }

            return {
                filter: JSON.stringify(query)
            };
        },
        clone: function clone() {
            var clone = new FilterQuery();

            clone._expressions = this._expressions.slice(0);

            return clone;
        },
        _addExpressions: function _addExpressions(expressions, type) {
            var json = expressions.map(function (expression) {
                return expression.toJSON();
            });

            this._expressions.push(_defineProperty({}, type, json));

            return this;
        }
    }, {

        TYPE_AND: TYPE_AND,
        TYPE_OR: TYPE_OR

    });

    return FilterQuery;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1740 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="sorting-panel-region"></div>\n<div class="content collection"></div>\n';

}
return __p
}

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (sources) { ;
__p += '\n    <div class="source-container">\n        <div class="library-source-container sorting-tabs">\n            ';
 sources.forEach(function(source) { ;
__p += '\n                <span data-source="' +
__e( source.name ) +
'">' +
__e( source.title ) +
'</span>\n            ';
 }) ;
__p += '\n            <div class="justify-empty-space"></div>\n        </div>\n    </div>\n';
 } ;
__p += '\n\n';
 if (filterAttributes) { ;
__p += '\n    <select class="filter-attribute form-control">\n        ';
 _.each(filterAttributes, function (text, value) { ;
__p += '\n            <option value="' +
__e( value ) +
'">' +
__e( text ) +
'</option>\n        ';
 }) ;
__p += '\n    </select>\n';
 } ;
__p += '\n\n<input class="content-filtering" type="search" placeholder="Search" maxlength="200">\n\n';
 if (sorting) { ;
__p += '\n    <div class="sorting-tabs">\n        ';
 sorting.forEach(function(sort) { ;
__p += '\n            <span data-sort="' +
__e( sort.name ) +
'">' +
__e( sort.title ) +
'</span>\n        ';
 }) ;
__p += '\n        ';
 if(isScene7) { ;
__p += '\n            <div class="justify-sorting-empty-space"></div>\n        ';
 } ;
__p += '\n    </div>\n';
 } ;
__p += '\n';

}
return __p
}

/***/ }),
/* 1742 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="effect-name">Image Swap</div>\n<div class="selected-image-region"></div>\n<div class="image-toggle-library-region images"></div>\n';

}
return __p
}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="zmags-input-control slider-control-container">\n    <label class="slider-control" ';
 if (unit) { ;
__p += ' data-unit="' +
__e( unit ) +
'" style="margin-right: 20px;"';
 } ;
__p += '>\n        ';
 if (staticVal) { ;
__p += '\n        <div class="static-value">\n            <div class="value">' +
__e( staticVal ) +
'</div>\n            <div class="value-indicator"></div>\n        </div>\n        ';
 } ;
__p += '\n\n        <div class="slider-background-color"></div>\n        <div class="slider-left-color"></div>\n        <div class="slider-value"></div>\n        <input class="slider" type="range" min="' +
__e( minVal ) +
'" max="' +
__e( maxVal ) +
'" step="' +
__e( step ) +
'">\n\n        ';
 if (minLabel && maxLabel) { ;
__p += '\n        <span class="min-label pull-left">' +
__e( minLabel ) +
'</span>\n        <span class="max-label pull-right">' +
__e( maxLabel ) +
'</span>\n        ';
 } ;
__p += '\n    </label>\n</div>';

}
return __p
}

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showName) { ;
__p += '\n<div class="effect-name">Opacity</div>\n';
 } ;
__p += '\n<div class="opacity-range-region"></div>';

}
return __p
}

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        RangeInput = __webpack_require__(558),
        template = __webpack_require__(1746);

    return ImprovedView.extend({

        template: template,

        regions: {
            pulseRangeRegion: ".pulse-range-region"
        },

        onRender: function onRender() {
            this.pulseRangeRegion.show(new RangeInput({
                model: this.model,
                modelAttribute: "value",
                step: 1,
                minVal: 1,
                maxVal: 5,
                minLabel: "Delicate",
                maxLabel: "Loud"
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="effect-name">Pulse</div>\n<div class="pulse-range-region"></div>';

}
return __p
}

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        EffectModel = __webpack_require__(78),
        template = __webpack_require__(1748);

    return ImprovedView.extend({

        template: template,

        bindings: {
            ".rotation": "rotation"
        },

        attentionBindings: {
            "input[name='attentionMode']": "attentionMode",
            ".rotation-direction-selection": "rotationDirection"
        },

        onRender: function onRender() {
            if (this.model.get("triggerType") === EffectModel.TRIGGER_TYPE_ATTENTION) {
                this.stickit(this.model, this.attentionBindings);
            }
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="rotate-panel">\n    <div class="effect-name">Rotate</div>\n    ';
 if(triggerType === "hover") { ;
__p += '\n    <div class="rotate-region zmags-input-control small">\n        <label data-unit="&deg;">Rotation Angle: <input type="number" step="any" class="rotation"></label>\n    </div>\n    ';
 } ;
__p += '\n    ';
 if(triggerType === "attention") { ;
__p += '\n    <div class="radio">\n        <label>\n            <input type="radio" class="rotation-angle" name="attentionMode" value="angle">\n            Rotation Angle:\n            <div class="rotate-region zmags-input-control small">\n                <label data-unit="&deg;"><input type="number" step="any" class="rotation"></label>\n            </div>\n        </label>\n    </div>\n    <div class="radio">\n        <label>\n            <input type="radio" class="rotation-direction" name="attentionMode" value="infinite">\n            Infinite Rotation:\n            <select class="rotation-direction-selection form-control">\n                <option value="cw">Right (CW)</option>\n                <option value="ccw">Left (CCW)</option>\n            </select>\n        </label>\n    </div>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        RangeInput = __webpack_require__(558),
        template = __webpack_require__(1750);

    return ImprovedView.extend({

        template: template,

        regions: {
            scaleRangeRegion: ".scale-range-region"
        },

        onRender: function onRender() {
            this.scaleRangeRegion.show(new RangeInput({
                model: this.model,
                modelAttribute: "scale",
                step: 10,
                minVal: 0,
                maxVal: 200,
                staticVal: 100,
                unit: "%",
                // Javascript polutes the calculation, hence the parseInt
                onGetConverter: function onGetConverter(x) {
                    return parseInt(x * 100, 10);
                },
                onSetConverter: function onSetConverter(x) {
                    return x / 100;
                }
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="effect-name">Resize</div>\n<div class="scale-range-region"></div>';

}
return __p
}

/***/ }),
/* 1751 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="effect-library">\n    <div class="row">\n        <div class="effect selected" data-target="scale">\n            <div class="effect-demo"></div>\n        </div>\n        <div class="effect" data-target="opacity">\n            <div class="effect-demo"></div>\n        </div>\n        <div class="effect" data-target="rotate">\n            <div class="effect-demo"></div>\n        </div>\n        <div class="effect" data-target="pulse">\n            <div class="effect-demo"></div>\n        </div>\n        <div class="effect" data-target="imageToggle">\n            <div class="effect-demo"></div>\n        </div>\n    </div>\n</div>\n\n<div class="effect-configuration-region"></div>\n\n<div class="timing-effect-configuration zmags-input-control small columns';
 if (triggerType == "attention") {;
__p += ' show';
};
__p += '">\n    <div class="pull-left">\n        <label data-unit="sec">Duration: <input type="number" step="0.1" class="duration"></label>\n    </div>\n    <div class="pull-right">\n        <label data-unit="sec">Pause: <input type="number" step="0.1" class="post-delay"></label>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<label class="block hover-effect-wrapper"><input class="hover-effect-enabled" type="checkbox"><span class="custom-checkbox"> </span>Mouseover Effect</label>\n<div class="hover-region"></div>\n\n<label class="block attention-effect-wrapper"><input class=" attention-effect-enabled" type="checkbox"><span class="custom-checkbox"></span>Loop Effect</label>\n<div class="attention-region"></div>';

}
return __p
}

/***/ }),
/* 1753 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".action-properties-accordion">' +
__e( panelName ) +
'</legend>\n    <div class="action-properties-accordion collapse collapse-target">\n        <div>\n            <div class="actions-region"></div>\n            ';
 if (showEffects) { ;
__p += '\n                <div class="effects-region"></div>\n            ';
 } ;
__p += '\n        </div>\n        <div>\n            <div class="onloads-region"></div>\n        </div>\n    </div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 1754 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".size-position-properties">Position</legend>\n    <div class="size-position-properties collapse collapse-target">\n        <div>\n\n            <div class="zmags-input-control small columns">\n                <div class="pull-left">\n                    <label data-unit="px">Left: <input type="number" step="any" class="left" tabindex="1"></label>\n                    ';
 if (showSizeControls || showWidthControls) { ;
__p += '\n                        <label data-unit="px">Width:  <input type="number" step="any" class="width" tabindex="3"></label>\n                    ';
 } ;
__p += '\n                    ';
 if (showLineControls) { ;
__p += '\n                        <label data-unit="px">Length:  <input type="number" step="any" class="width" tabindex="3"></label>\n                    ';
 } ;
__p += '\n                </div>\n\n                <div class="pull-right">\n                    <label data-unit="px">Top:  <input type="number" step="any" class="top" tabindex="2"></label>\n                    ';
 if (showSizeControls) { ;
__p += '\n                        <label data-unit="px">Height: <input type="number" step="any" class="height" tabindex="4"></label>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n\n            <div class="zmags-input-control small columns">\n                <div class="pull-left">\n                    ';
 if (showRotation) { ;
__p += '\n                        <div class="zmags-input-control rotate-controls">\n                            <label data-unit="&deg;">Rotate: <input type="number" class="rotation unit" step="any" tabindex="5"></label>\n                        </div>\n                    ';
 } ;
__p += '\n                </div>\n\n                <div class="pull-right">\n                    ';
 if (showSizeControls) { ;
__p += '\n                        <button class="btn btn-clear fit-to-scene" tabindex="6">Fit proportionally</button>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n\n            ';
 if (showGroupingControls) { ;
__p += '\n            <div class="grouping">\n                <button class="btn btn-white grouping__btn grouping__group">Group</button>\n                <button class="btn btn-white grouping__btn grouping__ungroup">Ungroup</button>\n            </div>\n            ';
 } ;
__p += '\n\n            <div class="arrange-container">\n                <select class="arrange-controls form-control">\n                    <option></option>\n                    <option value="' +
__e( editorConstants.BRING_TO_FRONT.value ) +
'" data-css-class="' +
__e( editorConstants.BRING_TO_FRONT.text ) +
'">To Front</option>\n                    <option value="' +
__e( editorConstants.SEND_BACK.value ) +
'" data-css-class="' +
__e( editorConstants.SEND_BACK.text ) +
'">To Back</option>\n                    <option value="' +
__e( editorConstants.BRING_FORWARD.value ) +
'" data-css-class="' +
__e( editorConstants.BRING_FORWARD.text ) +
'">Forward</option>\n                    <option value="' +
__e( editorConstants.SEND_BACKWARD.value ) +
'" data-css-class="' +
__e( editorConstants.SEND_BACKWARD.text ) +
'">Backward</option>\n                </select>\n            </div>\n\n            <div class="align-container">\n                <select class="align-controls form-control">\n                    <option></option>\n                    <option value="' +
__e( editorConstants.ALIGN_LEFT.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_LEFT.text ) +
'">Align Left</option>\n                    <option value="' +
__e( editorConstants.ALIGN_CENTER.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_CENTER.text ) +
'">Align Center</option>\n                    <option value="' +
__e( editorConstants.ALIGN_RIGHT.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_RIGHT.text ) +
'">Align Right</option>\n                    <option value="' +
__e( editorConstants.ALIGN_TOP.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_TOP.text ) +
'">Align Top</option>\n                    <option value="' +
__e( editorConstants.ALIGN_MIDDLE.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_MIDDLE.text ) +
'">Align Middle</option>\n                    <option value="' +
__e( editorConstants.ALIGN_BOTTOM.value ) +
'" data-css-class="' +
__e( editorConstants.ALIGN_BOTTOM.text ) +
'">Align Bottom</option>\n                    <option value="' +
__e( editorConstants.DISTRIBUTE_HORIZONTALLY.value ) +
'" data-css-class="' +
__e( editorConstants.DISTRIBUTE_HORIZONTALLY.text ) +
'">Distribute Horizontally</option>\n                    <option value="' +
__e( editorConstants.DISTRIBUTE_VERTICALLY.value ) +
'" data-css-class="' +
__e( editorConstants.DISTRIBUTE_VERTICALLY.text ) +
'">Distribute Vertically</option>\n                </select>\n            </div>\n\n            <label class="block align-to-scene-container">\n                <input type="checkbox" class="align-to-scene" checked>\n                <span class="custom-checkbox"></span>\n                Align to Scene\n            </label>\n        </div>\n    </div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

// @ts-check

// @ts-ignore
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Alignment = __webpack_require__(872);

    /**
     * @typedef ContainerPositionProperties
     * @type {Object}
     * @property {"top"|"left"} startContainer
     * @property {"bottom"|"right"} endContainer
     */

    /** @type {ContainerPositionProperties} */
    var CONTAINER_RELATIVE_PROP_HORIZONTAL = {
        startContainer: "left",
        endContainer: "right"
    };

    /** @type {ContainerPositionProperties} */
    var CONTAINER_RELATIVE_PROP_VERTICAL = {
        startContainer: "top",
        endContainer: "bottom"
    };

    /**
     * All of the values are in pixels.
     *
     * @typedef ContainerSize
     * @type {Object}
     * @property {Number} right
     * @property {Number} left
     * @property {Number} top
     * @property {Number} bottom
     * @property {Number} verticalCenter
     * @property {Number} horizontalCenter
     */

    /**
     * @typedef PositioningWidgetFunction
     * @type {Object}
     * @property {Function} getWidgetSizeFunction           - This function returns the size of the widget.
     * @property {Function} getWidgetOriginOffsetFunction   - This function get the offset in pixels if the object is rotated.
     * @property {Function} alignWidgetToStartContainer     - This align the widget at the start of the container.
     * @property {Function} alignWidgetToEndContainer       - This align the widget at the end of the container.
     * @property {Function} getPositionInPrc                - Get the position of a widget in percentage.
     */

    /**
     * @typedef PositioningContainerData
     * @type {Object}
     * @property {Object[]} widgets                 - The widgets sorted by the closest according to the start of the container.
     * @property {Number} containerStartPosition    - The position in pixel of the start of the container.
     * @property {Number} containerEndPosition      - The position in pixel of the end of the container.
     */

    /** ;
     * @typedef PositioningData
     * @type {Object}
     * @property {Number} spacing                           - The space between each widgets.
     * @property {Boolean} isSpacedToTheContainer           - If the widgets are overlapping the containerSize.
     * @property {Number} firstPosition                     - The position of the first widget.
     * @property {"left"|"top"} relativePositionProperty    - Property used to modify the widget position, can only be "left" or "top",
     *                                                        depending on the type of distribution.
     * @property {PositioningWidgetFunction} widgetFunctions - The functions related to the widget.
     */

    /**
     * @param {Object} left    - The left widget
     * @param {Object} right   - The right wiget
     * @returns {Object}       The widget with the highest right position value
     */
    var compareRightBoundingBox = function compareRightBoundingBox(left, right) {
        return left.boundingBox.right > right.boundingBox.right ? left : right;
    };

    /**
     * @param {Object} left    - The left widget
     * @param {Object} right   - The right wiget
     * @returns {Object}       The widget with the highest bottom position value
     */
    var compareBottomBoundingBox = function compareBottomBoundingBox(left, right) {
        return left.boundingBox.bottom > right.boundingBox.bottom ? left : right;
    };

    /**
     * Loop through the widget and check if the last widget is the one creating the containerEndSize boundary.
     *
     * In the case of overlapping widget the last widget isn't always the one creating the containerEndSize.
     * This function will check that and swap the widget if necessary, in order to keep the algorithm running
     * without special handling.
     *
     * The widgets in the containerData are already sorted.
     *
     * @param {(prev: Object,next: Object) => Object} compareFunction    - Function to compare the widgets
     * @param {Object[]} widgets            -
     *
     */
    function checkEndContainerWidgetAndSwap(compareFunction, widgets) {
        var lastIndex = widgets.length - 1;
        var endContainerWidget = widgets.reduce(compareFunction, widgets[0]);
        var lastWidget = widgets[lastIndex];

        if (endContainerWidget !== lastWidget) {
            var indexOfLastWidget = widgets.indexOf(endContainerWidget);

            // We simply swap the widget creating the container size in order to keep the flow of the algo going.
            widgets[indexOfLastWidget] = lastWidget;
            widgets[lastIndex] = endContainerWidget;
        }
    }

    /**
     * TLDR: notOverlapping     : (ContainerSpace - WUsedSpace) / Wn.length + 1 = Spacing
     *       notAlignedToScene  : (ContainerSpace - WUsedSpace) / Wn.length - 1 = Spacing
     *       overlapping        : (ContainerSpace - W1 - Wn) - (WAverageSize) / Wn.length - 1 = Spacing
     *
     * Compute the spacing for each widget depending if it's aligned to the scene or not.
     * Also takes into account if the size of the widgets is greater than the space available in the scene.
     *
     * If the widgets are overlapping the container size then, the first widget and last widget
     * creates the container boundaries. The average size of the widget inside of the container is used,
     * in order to compute the spacing (The spacing will be negative).
     *
     * @param {PositioningContainerData} containerData      - The data of the container
     * @param {PositioningWidgetFunction} widgetFunctions   - The function to interact with the widgets.
     * @param {Boolean} isAlignedToScene                    - Distribute according to the scene or the widgets
     *
     * @returns {{spacing: Number, isSpacedToTheContainer: Boolean, firstPosition: Number}}
     */
    function computeSpacingForDistribution(containerData, _ref, isAlignedToScene) {
        var getWidgetSizeFunction = _ref.getWidgetSizeFunction;
        var widgets = containerData.widgets,
            containerStartPosition = containerData.containerStartPosition,
            containerEndPosition = containerData.containerEndPosition;

        var widgetUsedSpace = widgets.map(function (_ref2) {
            var boundingBox = _ref2.boundingBox;
            return getWidgetSizeFunction(boundingBox);
        }).reduce(function (prev, next) {
            return prev + next;
        });
        var containerSize = containerEndPosition - containerStartPosition;
        var availableSpace = containerSize - widgetUsedSpace;
        var areWidgetsOverlapping = availableSpace < 0;
        var firstWidgetSize = getWidgetSizeFunction(widgets[0].boundingBox);
        var lastWidgetSize = getWidgetSizeFunction(widgets[widgets.length - 1].boundingBox);
        var averageWidgetSize = (widgetUsedSpace - firstWidgetSize - lastWidgetSize) / (widgets.length - 1);

        // If the widgets are overlapping then we remove the first and last widget, in order to
        // to calculate the space available between this two widgets.
        var containerSpace = areWidgetsOverlapping ? containerSize - firstWidgetSize - lastWidgetSize : availableSpace;

        // We only want the spacing  before the first widget and after the last widget,
        // if we are distributing to the scene and the widgets aren't overlapping.
        var numberOfSpacing = !areWidgetsOverlapping && isAlignedToScene ? widgets.length + 1 : widgets.length - 1;

        // if the widgets are overlapping, then there's a negative spacing between the widgets.
        var spacing = areWidgetsOverlapping ? containerSpace / numberOfSpacing - averageWidgetSize : containerSpace / numberOfSpacing;
        var firstPosition = spacing;

        if (!isAlignedToScene) {
            firstPosition += containerStartPosition;

            if (!areWidgetsOverlapping) {
                firstPosition += firstWidgetSize;
            }
        }

        if (areWidgetsOverlapping) {
            firstPosition += firstWidgetSize;
        }

        return {
            spacing: spacing,
            isSpacedToTheContainer: areWidgetsOverlapping || !isAlignedToScene,
            firstPosition: firstPosition
        };
    }

    /**
     * @param {{height: number, width: number}} experienceSize  - The experience size
     * @param {ContainerSize} containerSize                     - The size of the container
     *
     * @returns {PositioningWidgetFunction}
     */
    function createWidgetFunctionsHorizontally(experienceSize, containerSize) {
        return {
            getWidgetSizeFunction: function getWidgetSizeFunction(boundingBox) {
                return boundingBox.width;
            },
            getWidgetOriginOffsetFunction: function getWidgetOriginOffsetFunction(boundingBox, rect) {
                return rect.left - boundingBox.left;
            },
            alignWidgetToStartContainer: function alignWidgetToStartContainer(widget) {
                return Alignment.alignLeft([widget], containerSize.left, experienceSize);
            },
            alignWidgetToEndContainer: function alignWidgetToEndContainer(widget) {
                return Alignment.alignRight([widget], containerSize.right, experienceSize);
            },
            getPositionInPrc: function getPositionInPrc(position) {
                return position / experienceSize.width * 100;
            }
        };
    }

    /**
     *
     * @param {Object[]} widgets                                - The selected widgets to distribute
     * @param {ContainerSize} containerSize                     - The size of the container
     * @param {{height: number, width: number}} experienceSize  - The experience size
     * @param {Boolean} isAlignedToScene                        - Distribute according to the scene or the widgets
     *
     * @export
     */
    function distributeHorizontally(widgets, containerSize, experienceSize, isAlignedToScene) {
        var widgetFunctions = createWidgetFunctionsHorizontally(experienceSize, containerSize);

        widgets.sort(function (a, b) {
            return a.boundingBox.left - b.boundingBox.left;
        });

        checkEndContainerWidgetAndSwap(compareRightBoundingBox, widgets);

        prepareDataForDistribution(widgets, containerSize, experienceSize, isAlignedToScene, widgetFunctions, CONTAINER_RELATIVE_PROP_HORIZONTAL);
    }

    /**
     * @param {{height: number, width: number}} experienceSize  - The experience size
     * @param {ContainerSize} containerSize                     - The size of the container
     *
     * @returns {PositioningWidgetFunction}
     */
    function createWidgetFunctionsVertically(experienceSize, containerSize) {
        return {
            getWidgetSizeFunction: function getWidgetSizeFunction(boundingBox) {
                return boundingBox.height;
            },
            getWidgetOriginOffsetFunction: function getWidgetOriginOffsetFunction(boundingBox, rect) {
                return Math.abs(boundingBox.top - rect.top);
            },
            alignWidgetToStartContainer: function alignWidgetToStartContainer(widget) {
                return Alignment.alignTop([widget], containerSize.top, experienceSize);
            },
            alignWidgetToEndContainer: function alignWidgetToEndContainer(widget) {
                return Alignment.alignBottom([widget], containerSize.bottom, experienceSize);
            },
            getPositionInPrc: function getPositionInPrc(position) {
                return position / experienceSize.height * 100;
            }
        };
    }

    /**
     *
     * @param {Object[]} widgets                                - The selected widgets to distribute
     * @param {ContainerSize} containerSize                     - The size of the container
     * @param {{height: number, width: number}} experienceSize  - The experience size
     * @param {Boolean} isAlignedToScene                        - Distribute according to the scene or the widgets, scene references the container.
     *
     * @export
     */
    function distributeVertically(widgets, containerSize, experienceSize, isAlignedToScene) {
        /** @type {PositioningWidgetFunction} */
        var widgetFunctions = createWidgetFunctionsVertically(experienceSize, containerSize);

        widgets.sort(function (a, b) {
            return a.boundingBox.top - b.boundingBox.top;
        });

        checkEndContainerWidgetAndSwap(compareBottomBoundingBox, widgets);

        prepareDataForDistribution(widgets, containerSize, experienceSize, isAlignedToScene, widgetFunctions, CONTAINER_RELATIVE_PROP_VERTICAL);
    }

    /**
     *
     * @param {Object[]} widgets                                    - The selected widgets to distribute
     * @param {ContainerSize} containerSize                         - The size of the container
     * @param {{height: number, width: number}} experienceSize      - The experience size
     * @param {Boolean} isAlignedToScene                            - Distribute according to the scene or the widgets
     * @param {PositioningWidgetFunction} widgetFunctions            - The functions associated with the widget
     * @param {ContainerPositionProperties} containerRelativeProp   - The properties that determine the position to use
     *                                                              for the container size.
    */
    function prepareDataForDistribution(widgets, containerSize, experienceSize, isAlignedToScene, widgetFunctions, containerRelativeProp) {
        var startContainer = containerRelativeProp.startContainer,
            endContainer = containerRelativeProp.endContainer;

        var containerData = {
            containerStartPosition: containerSize[startContainer],
            containerEndPosition: containerSize[endContainer],
            widgets: widgets
        };
        var computedSpacing = computeSpacingForDistribution(containerData, widgetFunctions, isAlignedToScene);

        /** @type {PositioningData} */
        var positioningData = {
            widgetFunctions: widgetFunctions,
            relativePositionProperty: startContainer,
            firstPosition: computedSpacing.firstPosition,
            isSpacedToTheContainer: computedSpacing.isSpacedToTheContainer,
            spacing: computedSpacing.spacing
        };
        var startIndex = 0;
        var endIndex = containerData.widgets.length;

        if (positioningData.isSpacedToTheContainer || !isAlignedToScene) {
            var firstWidget = containerData.widgets[0];
            var lastWidget = containerData.widgets[containerData.widgets.length - 1];

            widgetFunctions.alignWidgetToStartContainer(firstWidget);
            widgetFunctions.alignWidgetToEndContainer(lastWidget);

            startIndex = 1;
            endIndex--;
        }

        distribute(positioningData, containerData, startIndex, endIndex);
    }

    /**
     * Distribute all of the object horizontally/vertically according to the scene or selection
     *
     * @param {PositioningData} positioningData         - The prepared data in order to distribute the widgets.
     * @param {PositioningContainerData} containerData  - The data related to the container.
     * @param {Number} startIndex                       - The start index.
     * @param {Number} endIndex                         - the end index.
     */
    function distribute(positioningData, containerData, startIndex, endIndex) {
        var widgetFunctions = positioningData.widgetFunctions;

        var position = positioningData.firstPosition;

        for (var index = startIndex; index < endIndex; index++) {
            var widget = containerData.widgets[index];
            var model = widget.model,
                boundingBox = widget.boundingBox,
                rect = widget.rect;

            var widgetSize = widgetFunctions.getWidgetSizeFunction(boundingBox);

            if (position < containerData.containerStartPosition) {
                widgetFunctions.alignWidgetToStartContainer(widget);
            } else if (widgetSize + position > containerData.containerEndPosition) {
                widgetFunctions.alignWidgetToEndContainer(widget);
            } else {
                var originOffset = widgetFunctions.getWidgetOriginOffsetFunction(boundingBox, rect);
                var percentagePosition = widgetFunctions.getPositionInPrc(position + originOffset);

                model.set(positioningData.relativePositionProperty, percentagePosition);
            }

            position += widgetSize + positioningData.spacing;
        }
    }

    return {
        distributeHorizontally: distributeHorizontally,
        distributeVertically: distributeVertically,
        computeSpacingForDistribution: computeSpacingForDistribution,
        distribute: distribute,
        createWidgetFunctionsHorizontally: createWidgetFunctionsHorizontally,
        createWidgetFunctionsVertically: createWidgetFunctionsVertically
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1756 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".style-properties-container">Style</legend>\n    <div class="style-properties-container collapse collapse-target">\n        <div>\n            ';
 if (showOpacityControls) { ;
__p += '\n            <label class="block">\n                <input type="checkbox" class="opacity">\n                <span class="custom-checkbox"></span>\n                Opacity\n            </label>\n            <div class="opacity-properties-region"></div>\n            ';
 } ;
__p += '\n            ';
 if (showRadiusControls) { ;
__p += '\n            <label class="block">\n                <input type="checkbox" class="radius">\n                <span class="custom-checkbox"></span>\n                Round Corners\n            </label>\n            <div class="radius-properties-region zmags-input-control">\n                <label data-unit="px">\n                    Radius:\n                    <input type="number" step="1" min="0" class="small border-radius-input">\n                </label>\n            </div>\n            ';
 } ;
__p += '\n            ';
 if (showBorderControls) { ;
__p += '\n            <label class="block">\n                <input type="checkbox" class="border">\n                <span class="custom-checkbox"></span>\n                Border\n            </label>\n            <div class="border-properties">\n                    <div class="zmags-input-control">\n                        <label>\n                            Width:\n                            <select class="border-width form-control"></select>\n                        </label>\n                        <label>\n                            Color:\n                            <div class="border-color-box color-box"></div>\n                            <input class="border-color-input" type="text">\n                        </label>\n                    </div>\n            </div>\n            ';
 } ;
__p += '\n\n            <label class="block">\n                <input class="shadow" type="checkbox">\n                <span class="custom-checkbox"></span>\n                Drop shadow\n            </label>\n        </div>\n    </div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(1758);
    var ButtonIconModel = __webpack_require__(304);
    var ColorPicker = __webpack_require__(208);
    var IconsSelectionView = __webpack_require__(1759);

    return ImprovedView.extend("IconPropertiesView", {

        className: "icon-properties",

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                Placement: ButtonIconModel.Placement
            };
        },


        regions: {
            iconsSelectionRegion: ".icons-selection-region"
        },

        ui: {
            iconCheckbox: ".icon-checkbox",
            contentContainer: ".content-container",
            iconColorInput: ".button-icon-color-input",
            iconColorBox: ".icon-color-box",
            placementSelect: ".placement-select"
        },

        modelEvents: {
            "change:icon": "_iconChangeHandler"
        },

        events: {
            "click @ui.iconCheckbox": "_iconCheckboxClickHandler"
        },

        iconBindings: {
            ".placement-select": "placement",
            ".button-icon-color-input": {
                observe: "color",
                onSet: function onSet(color) {
                    return this._iconColorPicker.hexOrDefault(color);
                }
            }
        },

        onRender: function onRender() {
            this.stickit(this.model.get("icon"), this.iconBindings);

            var iconColor = this.model.get("icon").get("color");

            this._iconColorPicker = new ColorPicker({
                color: iconColor,
                input: this.ui.iconColorInput,
                colorBox: this.ui.iconColorBox,
                includeTransparency: false
            });
        },
        onShow: function onShow() {
            this.iconsSelectionRegion.show(new IconsSelectionView({ model: this.model }));
        },
        onClose: function onClose() {
            this._iconColorPicker.dispose();
        },
        hide: function hide() {
            this.$el.addClass("hidden");
        },
        unhide: function unhide() {
            this.$el.removeClass("hidden");
        },
        hideIconPositionSelect: function hideIconPositionSelect() {
            this.ui.placementSelect.addClass("hidden");
        },
        unhideIconPositionSelect: function unhideIconPositionSelect() {
            this.ui.placementSelect.removeClass("hidden");
        },
        _iconChangeHandler: function _iconChangeHandler(model, icon) {
            if (!(icon instanceof ButtonIconModel)) {
                return;
            }

            // the previous icon bindings have to be unstuck and the new icon's bindings have to be stuck for the icon color picker.
            var previousIcon = model.previous("icon");

            if (previousIcon) {
                this.unstickit(previousIcon);
            }

            if (icon) {
                this.stickit(icon, this.iconBindings);
            }

            this.iconsSelectionRegion.currentView.updateSelectedIcon(icon);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1758 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div>\n    <div class="content-container">\n        <section class="row">\n            <div class="col-md-5">\n                <div class="icon-picker-label">\n                    Icon\n                </div>\n            </div>\n            <div class="col-md-7 properties-view-picker-container">\n                <div class="icons-selection-region"></div>\n                <div class="zmags-input-control placement-options-container">\n                    <select class="placement-select form-control">\n                        <option value="' +
__e( Placement.AFTER ) +
'">After</option>\n                        <option value="' +
__e( Placement.BEFORE ) +
'">Before</option>\n                    </select>\n                </div>\n            </div>\n        </section>\n\n        <div class="zmags-input-control">\n            <section class="row properties color-section">\n                <div class="col-md-5">\n                    Icon Color\n                </div>\n                <div class="col-md-7">\n                    <div class="color-info">\n                        <div class="icon-color-box color-box"></div>\n                        <input type="text" class="button-icon-color-input color-input-box" />\n                    </div>\n                </div>\n            </section>\n        </div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        debounce = _require.debounce;

    var Marionette = __webpack_require__(10);
    var Backbone = __webpack_require__(7);
    var ButtonIconCollectionView = __webpack_require__(1760);
    var ButtonIconCollection = __webpack_require__(873);
    var ButtonWidgetHelper = __webpack_require__(776);
    var MaterialIcons = __webpack_require__(874);
    var template = __webpack_require__(1762);

    var IconGroupModel = Backbone.Model.extend({

        defaults: {
            name: null,
            collection: null
        }

    });

    return Marionette.CompositeView.extend("IconsSelectionView", {

        className: "icons-selection-view",

        template: template,

        itemView: ButtonIconCollectionView,

        itemViewContainer: ".icons-group-container",

        _debouncedIconSearchInputChangeHandler: null, // set in initialize

        events: {
            "keypress @ui.iconSearchInput": "_debouncedIconSearchInputChangeHandler",
            "keyup @ui.iconSearchInput": "_debouncedIconSearchInputChangeHandler",
            "shown.bs.dropdown": "_iconDropdownShownHandler"
        },

        ui: {
            iconSearchInput: ".icon-search-input",
            dropdown: ".dropdown",
            allGroupsHiddenMessage: ".all-groups-hidden-message",
            selectedIconPreview: ".selected-icon-preview"
        },

        viewScope: {
            onButtonIconClick: function onButtonIconClick(icon) {
                var currentIcon = this.model.get("icon");
                var currentState = {};

                if (currentIcon) {
                    currentState = currentIcon.pick(["color", "placement", "size"]);
                }

                icon.set(currentState, { silent: true });
                this.model.set("icon", icon);
            }
        },

        initialize: function initialize() {
            this._debouncedIconSearchInputChangeHandler = debounce(this._iconSearchInputChangeHandler.bind(this), 100);

            var entireCollection = new ButtonIconCollection(MaterialIcons.icons);
            var collection = new Backbone.Collection();

            MaterialIcons.groups.forEach(function (group) {
                var icons = entireCollection.byGroup(group.data.id);
                var model = new IconGroupModel({
                    name: group.data.name,
                    collection: new ButtonIconCollection(icons)
                });

                collection.add(model);
            });

            this.collection = collection;
        },
        onShow: function onShow() {
            this.updateSelectedIcon(this.model.get("icon"));
        },
        _iconDropdownShownHandler: function _iconDropdownShownHandler() {
            this.ui.iconSearchInput.focus();
        },
        _iconSearchInputChangeHandler: function _iconSearchInputChangeHandler() {
            var upperCaseSearchTerm = this.ui.iconSearchInput.val().toUpperCase();
            var amountOfHiddenIconGroupViews = 0;

            this.children.forEach(function (iconGroupView) {
                var isHidden = iconGroupView.filterShownItemsAndReturnIsHidden(upperCaseSearchTerm);
                if (isHidden) {
                    amountOfHiddenIconGroupViews++;
                }
            });

            var areAnyGroupsShown = amountOfHiddenIconGroupViews !== this.children.length;
            // hide the "all groups hidden" message if any groups are shown
            this.ui.allGroupsHiddenMessage.toggleClass("hidden", areAnyGroupsShown);
        },
        updateSelectedIcon: function updateSelectedIcon(iconModel) {
            var _this = this;

            ButtonWidgetHelper.fetchIcon(iconModel).then(function (svg) {
                if (_this.ui.selectedIconPreview.attr) {
                    _this.ui.selectedIconPreview.attr("title", iconModel.get("name"));
                    _this.ui.selectedIconPreview.html(svg);
                }
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var _ = __webpack_require__(1);
    var ButtonIconCollection = __webpack_require__(873);
    var template = __webpack_require__(1761);

    var RENDER_CHUNK_SIZE = 1;

    var IconItemView = Marionette.ItemView.extend({
        tagName: "div",

        className: "icon",

        events: {
            "click": function click() {
                this.viewScope.onButtonIconClick(this.model);
            }
        },

        initialize: function initialize() {
            this.$el.attr("title", this.model.get("name"));
        },


        template: _.template("<i class='material-icons'><%- iconId %></i>"),

        showHideView: function showHideView(shouldBeShown) {
            this.$el.toggleClass("hidden", !shouldBeShown);
        }
    });

    return Marionette.CompositeView.extend("ButtonIconCollectionView", {

        className: "button-icon-collection-view",

        template: template,

        itemView: IconItemView,

        itemViewContainer: ".icons-container",

        _renderLoopId: null,

        _renderIndex: 0,

        initialize: function initialize() {
            this._renderNext = this._renderNext.bind(this);
            this._renderChunks = this._renderChunks.bind(this);
            this.collection = new ButtonIconCollection();
        },
        onShow: function onShow() {
            _.delay(this._renderNext, 500);
        },
        onClose: function onClose() {
            cancelAnimationFrame(this._renderLoopId);
        },
        _renderNext: function _renderNext() {
            this._renderLoopId = requestAnimationFrame(this._renderChunks);
        },
        _renderChunks: function _renderChunks() {
            var collection = this.options.model.get("collection");
            var icon = void 0;
            var t = this._renderIndex + RENDER_CHUNK_SIZE;

            for (; this._renderIndex < t; this._renderIndex++) {
                icon = collection.models[this._renderIndex];

                if (!icon) {
                    break;
                }

                this.collection.add(icon);
            }

            if (icon) {
                this._renderNext();
            } else {
                cancelAnimationFrame(this._renderLoopId);
            }
        },


        /**
         * Hide icons that are filtered out by the search term and name and return if all icons are hidden.
         * @param {String} upperCaseSearchTerm
         * @returns {Boolean} true if all icons are hidden
         */
        filterShownItemsAndReturnIsHidden: function filterShownItemsAndReturnIsHidden(upperCaseSearchTerm) {
            var amountOfHiddenItemViews = 0;
            this.children.forEach(function (child) {
                var shouldBeShown = upperCaseSearchTerm === "" || child.model.get("name").toUpperCase().indexOf(upperCaseSearchTerm) > -1;
                child.showHideView(shouldBeShown);
                if (!shouldBeShown) {
                    amountOfHiddenItemViews++;
                }
            });
            var shouldCollectionViewBeHidden = amountOfHiddenItemViews === this.children.length;
            this.$el.toggleClass("hidden", shouldCollectionViewBeHidden);

            return shouldCollectionViewBeHidden;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1761 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<p class="group-title">' +
__e( name ) +
'</p>\n<div class="icons-container"></div>';

}
return __p
}

/***/ }),
/* 1762 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dropdown">\n    <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">\n        <div class="selected-icon-preview pull-left"></div>\n        <span class="caret"></span>\n    </button>\n\n    <div class="dropdown-menu">\n        <div class="row">\n            <div class="col-md-12">\n                <input type="text" placeholder="Search..." class="icon-search-input" />\n            </div>\n        </div>\n        <div class="all-groups-hidden-message hidden row">\n            <div class="col-md-12">\n                No results\n            </div>\n        </div>\n        <div class="icons-group-container"></div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var LabelCharacterPropertiesView = __webpack_require__(1764);
    var template = __webpack_require__(1781);

    return ImprovedView.extend("LabelPropertiesView", {

        className: "label-properties",

        template: template,

        regions: {
            characterProperties: ".character-properties"
        },

        ui: {
            contentContainer: ".content-container",
            buttonLabelRow: ".button-label-row"
        },

        bindings: {
            ".button-label-input": "label"
        },

        onShow: function onShow() {
            this.characterProperties.show(new LabelCharacterPropertiesView({ model: this.model }));
        },
        hide: function hide() {
            this.ui.buttonLabelRow.addClass("hidden");
            this.characterProperties.currentView.hide();
        },
        unhide: function unhide() {
            this.ui.buttonLabelRow.removeClass("hidden");
            this.characterProperties.currentView.unhide();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var CharacterPropertiesView = __webpack_require__(402);
    var template = __webpack_require__(1780);

    return CharacterPropertiesView.extend("LabelCharacterPropertiesView", {

        template: template,

        hide: function hide() {
            this.$el.find(".row").each(function (i, element) {
                var $element = $(element);

                if (!$element.hasClass("font-size-box")) {
                    $element.addClass("hidden");
                }
            });
        },
        unhide: function unhide() {
            this.$el.find(".row").each(function (i, element) {
                return $(element).removeClass("hidden");
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        debounce = _require.debounce,
        pick = _require.pick,
        isEmpty = _require.isEmpty,
        uniq = _require.uniq,
        first = _require.first,
        contains = _require.contains,
        find = _require.find;

    var EditorWebFontController = __webpack_require__(176);
    var FontProvider = __webpack_require__(103);
    var GeneralFunctions = __webpack_require__(193);
    var Storage = __webpack_require__(34);
    var ViewController = __webpack_require__(126);
    var WebFontsUtil = __webpack_require__(136);
    var WebFontVariants = __webpack_require__(365).default;
    var CharacterPropertiesViewControllerHelpers = __webpack_require__(408);

    /**
     * For backwards compatibility, we need to set a font provider for legacy
     * text widgets.  It will be either a standard font or a Google Font. This
     * is a nop if the font provider is already present.
     *
     * @param  {TextWidgetModel} model  The <tt>TextWidgetModel</tt>.
     * @return {FontProvider}           The correct <tt>FontProvider</tt>.
     */
    var fontProviderFromModel = function fontProviderFromModel(model) {
        var family = model.get("fontFamily");
        var providerValue = model.get("fontProvider");

        return FontProvider.fromValue(providerValue) || WebFontsUtil.fontProvider(family);
    };

    /**
     * Controller for the <tt>CharacterPropertiesView</tt>. Responsible for
     * fetching and managing font data.
     *
     * @class CharacterPropertiesViewController
     * @author Kim
     */
    return ViewController.extend({

        /**
         * @type {FontDescriptorCollection}
         */
        _fontCollection: CharacterPropertiesViewControllerHelpers._fontCollection,

        onInitialize: function onInitialize() {
            var _this = this;

            EditorWebFontController.promise().then(function (collection) {
                // Grab a reference to the collection of fonts
                _this._fontCollection = collection;

                // Override the view's #fontSelectorQuery function to hook into the select control
                _this.view.fontSelectorQuery = _this._fontSelectorQuery.bind(_this);
                _this.view.fontSelectorInitSelection = _this._fontSelectorInitSelection.bind(_this);

                // Create a debounced version of #_preloadFontsFromSearchTerm
                _this._preloadFontsFromSearchTerm = debounce(_this._preloadFontsFromSearchTerm, 500).bind(_this);

                _this.listenTo(_this.model, "change", _this._modelChangeHandler);
            });
        },
        _modelChangeHandler: function _modelChangeHandler(model) {
            if (model.changed) {
                this._updateLastUsedProperties(model.changed);
            }

            if (model.changed.fontFamily) {
                this._updateFontVariants(model);
            }
        },
        _updateLastUsedProperties: function _updateLastUsedProperties(changed) {
            var selectedData = void 0;
            var fontDescriptor = void 0;
            var favoriteFonts = void 0;
            var lastUsedProperties = pick(changed, "fontProvider", "color", "fontSize", "fontStyle", "fontMetadata", "fontWeight", "fontFamily");

            if (isEmpty(lastUsedProperties)) {
                return;
            }

            if (!lastUsedProperties.fontFamily) {
                lastUsedProperties.fontProvider = lastUsedProperties.fontMetadata = null;
            }
            // Properties like font family can be null, we don't want to store those
            Storage.Local.update(Storage.Keys.LAST_USED_TEXT_PROPERTIES, GeneralFunctions.compactObject(lastUsedProperties));

            if (lastUsedProperties.fontFamily) {
                selectedData = this.view.getSelectedFontData();
                fontDescriptor = selectedData.fontDescriptor;

                favoriteFonts = Storage.Local.get(Storage.Keys.EDITOR, "favoriteFonts", []);

                favoriteFonts.unshift({
                    fontProvider: fontDescriptor.get("provider").value,
                    fontFamily: fontDescriptor.get("family")
                });

                // Remove duplicates
                favoriteFonts = uniq(favoriteFonts, false, function (value) {
                    return value.fontFamily + ":" + value.fontProvider;
                });

                // Store the (first 5) favorite fonts
                Storage.Local.update(Storage.Keys.EDITOR, "favoriteFonts", first(favoriteFonts, 5));
            }
        },


        /**
         * When the font selector (select2) changes its font family, we need
         * to update the font variants below it, so it only contains variants
         * that are valid with the current font family.
         *
         * If the font style is set to "regular 700" for the old font, then
         * we'd like to also pick the same font style by default for newly
         * selected font family if it's possible (the font may not have that
         * variation defined).
         *
         * The font variant select is updated by updating the editorModel's
         * fontWeight and fontStyle.
         *
         * @param {Object} font    A font object
         */
        _updateFontVariants: function _updateFontVariants(font) {
            // The new font.
            var fontFamily = font.get("fontFamily");

            // If multiple fonts are selected, this will be null. As will
            // fontWeight and fontStyle, so the select box should be blanked
            // out with no options.
            if (!fontFamily) {
                return;
            }

            // standard|typekit|google|fontsDotCom.
            var fontProviderValue = this.model.get("fontProvider");

            // fontProvider of the new font family.
            var fontProvider = FontProvider.fromValue(fontProviderValue);

            // Font variant describing fontStyle and fontWeight of the
            // selected font. (An object containing label, value, style,
            // and weight).
            // This is a a representation of the previously selected font
            // style and weight, based on the new font provider.
            var fontVariant = WebFontVariants.findVariant(fontProvider, this.model.get("fontStyle"), this.model.get("fontWeight"));

            // The value is the only needed thing. If the new font contains
            // a font variation with these weight and style, then the
            // variations dropdown should maintain its selection.
            var fontVariantValue = fontVariant && fontVariant.value;

            // Array of values of the different font variations belonging
            // to the selected font family.
            var fontVariations = this.getFontDescriptor(fontFamily, fontProvider).get("variations");

            // If our new font family can work with the previously selected
            // font variation, then we return without updating the model.
            if (contains(fontVariations, fontVariantValue)) {
                return;
            }

            // Failing that, we will attempt to select the "best" font
            // variation.
            var variants = WebFontVariants.fromValues(fontVariations, fontProvider);

            // Either select the first font variation in the list that has
            // a weight of 400, or, failing that, just select the first
            // font in the list (typically a very thin variation).
            var variant = find(variants, function (variant) {
                return variant.weight === "400";
            }) || variants[0];

            // Update the editor model so controls update correctly.
            this.model.set({
                fontStyle: variant.style,
                fontWeight: variant.weight
            });
        },


        /**
         * @private
         *
         * Invoked initially from select2.
         *
         * @param  {HTMLElement}   element  The element Select2 is attached to.
         * @param  {Function} callback      Callback function that should be called with the data which is either
         *                                  an object in case of a single select or an array of objects in case of
         *                                  multi-select.
         *
         * @see  http://ivaynberg.github.io/select2/
         */
        _fontSelectorInitSelection: function _fontSelectorInitSelection(element, callback) {
            var fontFamily = this.model.get("fontFamily");
            var fontDescriptor = void 0;

            if (!fontFamily) {
                return;
            }

            fontDescriptor = this._fontCollection.fromFamily(fontFamily, fontProviderFromModel(this.model));

            if (!fontDescriptor) {
                // Covering edge case where someone removed their Typekit API token, and selects a text widget
                // that still points to a Typekit font family - fall back on a standard font family
                fontDescriptor = first(this._fontCollection.fromProvider(FontProvider.STANDARD));
                this.model.set({
                    fontProvider: FontProvider.STANDARD.value,
                    fontFamily: fontDescriptor.get("family"),
                    fontStyle: "normal",
                    fontWeight: "400"
                });
            }

            callback({
                id: fontFamily,
                text: fontDescriptor.get("name"),
                fontFamily: fontFamily,
                fontDescriptor: fontDescriptor
            });
        },


        /**
         * getFontDescriptor
         *
         * @param {String} fontFamily
         * @param {Object} fontProvider
         * @return {Array} fontFamilyVariants
         */
        getFontDescriptor: function getFontDescriptor(fontFamily, fontProvider) {
            return this._fontCollection.fromFamily(fontFamily, fontProvider);
        },

        _fontSelectorQuery: CharacterPropertiesViewControllerHelpers._fontSelectorQuery,
        _populateResult: CharacterPropertiesViewControllerHelpers._populateResult,
        _preloadFontsFromSearchTerm: CharacterPropertiesViewControllerHelpers._preloadFontsFromSearchTerm,
        _createOptions: CharacterPropertiesViewControllerHelpers._createOptions
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!(module.exports = {
    /** Timeout in milliseconds to wait for fonts to load. */
    LOAD_FONTS_TIMEOUT: 3500
});

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["WebFont"] = __webpack_require__(1768);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.27 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.m=b||a;this.c=this.m.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
function z(a){if("string"===typeof a.f)return a.f;var b=a.m.location.protocol;"about:"==b&&(b=a.a.location.protocol);return"https:"==b?"https:":"http:"}function ea(a){return a.m.location.hostname||a.a.location.hostname}
function A(a,b,c){function d(){k&&e&&f&&(k(g),k=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,k=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
function B(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function C(){this.a=0;this.c=null}function D(a){a.a++;return function(){a.a--;E(a)}}function F(a,b){a.c=b;E(a)}function E(a){0==a.a&&a.c&&(a.c(),a.c=null)};function G(a){this.a=a||"-"}G.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function H(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return I(a)+" "+(a.f+"00")+" 300px "+J(a.c)}function J(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function K(a){return a.a+a.f}function I(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.m.document.documentElement;this.h=b;this.a=new G("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);L(a,"loading")}function M(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}L(a,"inactive")}function L(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,K(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function N(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function O(a){u(a.c,"body",a.a)}function P(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+J(a.c)+";"+("font-style:"+I(a)+";font-weight:"+(a.f+"00")+";")};function Q(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}Q.prototype.start=function(){var a=this.c.m.document,b=this,c=q(),d=new Promise(function(d,e){function k(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(k,25)},function(){e()})}k()}),e=new Promise(function(a,d){setTimeout(d,b.f)});Promise.race([e,d]).then(function(){b.g(b.a)},function(){b.j(b.a)})};function R(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.o=this.j=this.h=this.g=null;this.g=new N(this.c,this.s);this.h=new N(this.c,this.s);this.j=new N(this.c,this.s);this.o=new N(this.c,this.s);a=new H(this.a.c+",serif",K(this.a));a=P(a);this.g.a.style.cssText=a;a=new H(this.a.c+",sans-serif",K(this.a));a=P(a);this.h.a.style.cssText=a;a=new H("serif",K(this.a));a=P(a);this.j.a.style.cssText=a;a=new H("sans-serif",K(this.a));a=
P(a);this.o.a.style.cssText=a;O(this.g);O(this.h);O(this.j);O(this.o)}var S={D:"serif",C:"sans-serif"},T=null;function U(){if(null===T){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);T=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return T}R.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.o.a.offsetWidth;this.A=q();la(this)};
function ma(a,b,c){for(var d in S)if(S.hasOwnProperty(d)&&b===a.f[S[d]]&&c===a.f[S[d]])return!0;return!1}function la(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=U()&&ma(a,b,c));d?q()-a.A>=a.w?U()&&ma(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):na(a):V(a,a.v)}function na(a){setTimeout(p(function(){la(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.o.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.o=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,K(a).toString(),"active")],[b.a.c("wf",a.c,K(a).toString(),"loading"),b.a.c("wf",a.c,K(a).toString(),"inactive")]);L(b,"fontactive",a);this.o=!0;oa(this)};
W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,K(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,K(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,K(a).toString(),"inactive"));w(b.f,d,e)}L(b,"fontinactive",a);oa(this)};function oa(a){0==--a.f&&a.j&&(a.o?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),L(a,"active")):M(a.a))};function pa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}pa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;qa(this,new ha(this.c,a),a)};
function ra(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,k=d||null||{};if(0===c.length&&f)M(b.a);else{b.f+=c.length;f&&(b.j=f);var h,m=[];for(h=0;h<c.length;h++){var l=c[h],n=k[l.c],r=b.a,x=l;r.g&&w(r.f,[r.a.c("wf",x.c,K(x).toString(),"loading")]);L(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),ya=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
X=x?42<parseInt(x[1],10):ya?!1:!0}else X=!1;X?r=new Q(p(b.g,b),p(b.h,b),b.c,l,b.s,n):r=new R(p(b.g,b),p(b.h,b),b.c,l,b.s,a,n);m.push(r)}for(h=0;h<m.length;h++)m[h].start()}},0)}function qa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){ra(a,f,b,d,c)})};function sa(a,b){this.c=a;this.a=b}function ta(a,b,c){var d=z(a.c);a=(a.a.api||"fast.fonts.net/jsapi").replace(/^.*http(s?):(\/\/)?/,"");return d+"//"+a+"/"+b+".js"+(c?"?v="+c:"")}
sa.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var m=0;m<c.length;m++){var l=c[m].fontfamily;void 0!=c[m].fontStyle&&void 0!=c[m].fontWeight?(h=c[m].fontStyle+c[m].fontWeight,e.push(new H(l,h))):e.push(new H(l))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.m;B(this.c,ta(c,d,e),function(e){e?a([]):(f["__MonotypeConfiguration__"+d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+
d}else a([])};function ua(a,b){this.c=a;this.a=b}ua.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new C;b=0;for(c=d.length;b<c;b++)A(this.c,d[b],D(g));var k=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),m=0;m<h.length;m+=1)k.push(new H(d[0],h[m]));else k.push(new H(d[0]));F(g,function(){a(k,f)})};function va(a,b,c){a?this.c=a:this.c=b+wa;this.a=[];this.f=[];this.g=c||""}var wa="//fonts.googleapis.com/css";function xa(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
function za(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function Aa(a){this.f=a;this.a=[];this.c={}}
var Ba={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Ca={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Da={i:"i",italic:"i",n:"n",normal:"n"},
Ea=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
function Fa(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var k=d[1];g=[];if(k)for(var k=k.split(","),h=k.length,m=0;m<h;m++){var l;l=k[m];if(l.match(/^[\w-]+$/)){var n=Ea.exec(l.toLowerCase());if(null==n)l="";else{l=n[2];l=null==l||""==l?"n":Da[l];n=n[1];if(null==n||""==n)n="4";else var r=Ca[n],n=r?r:isNaN(n)?"4":n.substr(0,1);l=[l,n].join("")}}else l="";l&&g.push(l)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
g,0<d.length&&(d=Ba[d[0]])&&(a.c[e]=d))}a.c[e]||(d=Ba[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new H(e,f[d]))}};function Ga(a,b){this.c=a;this.a=b}var Ha={Arimo:!0,Cousine:!0,Tinos:!0};Ga.prototype.load=function(a){var b=new C,c=this.c,d=new va(this.a.api,z(c),this.a.text),e=this.a.families;xa(d,e);var f=new Aa(e);Fa(f);A(c,za(d),D(b));F(b,function(){a(f.a,f.c,Ha)})};function Ia(a,b){this.c=a;this.a=b}Ia.prototype.load=function(a){var b=this.a.id,c=this.c.m;b?B(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],k=b[f+1],h=0;h<k.length;h++)e.push(new H(g,k[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(m){}a(e)}},2E3):a([])};function Ja(a,b){this.c=a;this.f=b;this.a=[]}Ja.prototype.load=function(a){var b=this.f.id,c=this.c.m,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,k=c.fonts.length;g<k;++g){var h=c.fonts[g];d.a.push(new H(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},B(this.c,z(this.c)+(this.f.api||"//f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new pa(window);Y.a.c.custom=function(a,b){return new ua(b,a)};Y.a.c.fontdeck=function(a,b){return new Ja(b,a)};Y.a.c.monotype=function(a,b){return new sa(b,a)};Y.a.c.typekit=function(a,b){return new Ia(b,a)};Y.a.c.google=function(a,b){return new Ga(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return Z}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var $ = __webpack_require__(4);

    var _require = __webpack_require__(1),
        extend = _require.extend;

    var Configuration = __webpack_require__(27);

    /**
     * Represents the <a href="https://developers.google.com/fonts/docs/developer_api" target="_blank">Google Fonts API</a> - exposing the required endpoints.
     *
     * <pre>
     *     GoogleFontsApi.mostPopular().done(function () {
     *
     *     });
     * </pre>
     *
     * @class GoogleFontsApi
     * @author Kim
     */
    var GoogleFontsApi = Class.extend({

        /**
         * Fetches a list of fonts offered by the Google Fonts service.
         *
         * @return {Promise} A <tt>Promise</tt> that resolves with a list of fonts offered by the Google Fonts service.
         *
         * @see  https://developers.google.com/fonts/docs/developer_api
         */
        all: function all() {
            return this._get();
        },
        mostPopular: function mostPopular() {
            return this._get({ sort: "popularity" });
        },
        _get: function _get(options) {
            return $.getJSON(Configuration.googleWebFontsApiBaseUrl, extend({ key: Configuration.googleWebFontsApiKey }, options || {})).then(function (response) {
                return response;
            });
        },
        toString: function toString() {
            return "GoogleFontsApi[]";
        }
    });

    return new GoogleFontsApi();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25),
        Permissions = __webpack_require__(22),
        Backbone = __webpack_require__(7),
        User = __webpack_require__(261),
        CompanyState = __webpack_require__(242);

    /**
     * The principal model representing the privileges assigned to the current logged in (AD) user. <p>
     *
     * A principal is obtained during login. It cannot be synced with the API in any way but via login.
     * To get the principal actually logged in, use the <tt>LoggedIn.principal()</tt> function, or listen
     * to <tt>change:principal</tt> events on <tt>LoggedIn</tt>. <p>
     *
     * The check for access rights, i.e. roles and privileges, <b>must</b> always be done on a principal, not on
     * an actual user. Regardless, the API will always ensure the correct privileges are enforced, even if the
     * frontend "forgets" it. <p>
     *
     * To test if a principal has <b>at least</b> has a given role, simply do:
     * <pre>
     *    // Get logged in principal (if not null)...
     *    var principal = LoggedIn.principal();
     *
     *    if (principal.can(Permissions.Roles.MANAGER)) {
     *        // if here, principal has all the privileges of the manager role
     *    }
     *    ..
     *    if (principal.cannot(Permissions.Roles.PUBLISHER) {
     *        // if here, principal does not have all the privileges of the publisher role
     *    }
     * </pre>
     *
     * In addition, any entity model declaring a raw or Backbone <tt>role</tt> property storing a role name or
     * an actual role, a role name, a role, or a privilege can all be tested against the principal in the same
     * way, like:
     * <pre>
     *    var entity = {role: "Manager", ..};
     *    if (principal.can(entity)) {
     *        // principal has at least all the privileges of "entity"
     *    }
     *    ..
     *    var user = new User(..); // e.g. user.get("role")
     *    if (principal.cannot(user)) {
     *        // principal does not have "user" does not have the all the privileges granted to "user"...
     *    }
     *    ..
     *    var privilege = Permissions.Privileges.Publish;
     *    if (principal.can(privilege)) {
     *        // principal has the Publish privilege...
     *    }
     *    if (principal.cannot(privilege)) {
     *        // principal does not have the Publish privilege...
     *    }
     *
     *    // Note: neat short cut for checking specific privilege of the currently logged in principal:
     *    if (Permissions.Privileges.Publish.can()) { // or can(principal)
     *        // currently logged in principal has at least the publish privilege
     *    }
     *    ..
     * </pre>
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     *
     * @class Principal
     * @constructor
     */
    var Principal = ImprovedModel.extend("Principal", {

        defaults: {
            displayName: null,
            type: null,
            internal: null,
            user: null,
            updated: null, // true on relogin and role/status changed, false on relogin not change, null on first login
            persistent: null // not from the server
        },

        relations: [{
            type: Backbone.One,
            key: "user",
            relatedModel: User
        }],

        computed: {
            role: {
                deps: ["role"],
                value: function value(role) {
                    return Permissions.Roles.of(role);
                }
            },
            userId: { // for convenience
                deps: ["user"],
                value: function value(user) {
                    return user ? user.get("id") : null;
                }
            },
            companyId: { // for convenience
                deps: ["user"],
                value: function value(user) {
                    return user ? user.get("companyId") : null;
                }
            },
            state: {
                deps: ["state"],
                value: function value(state) {
                    return CompanyState.of(state);
                }
            }
        },

        /**
         * Returns true if this principal can be used for actual login, and thus access to the API, false otherwise. <p>
         *
         * A principal where this value is false will never be logged in via <tt>Login</tt>, i.e. never returned
         * from <tt>LoggedIn.principal()</tt>.
         *
         * @return {Boolean} True if this principal can login, false otherwise.
         */
        canLogin: function canLogin() {
            return this.get("token") !== null;
        },

        /**
         * Returns true if this principal has at least all the privileges granted to the supplied object, and thus
         * can perform the action(s) guarded by it, false if it does not.
         *
         * @param  {Role|Privilege|String|*} object The object to test; a falsey value will cause true
         *                                          to be returned. A string means a role name.
         *
         * @return {Boolean} True if this principal has at least all the privileges granted to the (defaulted) object,
         *                   false if it does not.
         * @see    #cannot
         */
        can: function can(object) {
            return Permissions.Roles.can(object, this);
        },

        /**
         * Returns true if this principal does not have all the privileges granted to the supplied object, and thus
         * cannot perform the action(s) guarded by it, false if it does.
         *
         * @param  {Role|Privilege|String|*} object The object to test; a falsey value will cause true
         *                                          to be returned. A string means a role name.
         *
         * @return {Boolean} True if this principal does not have all the privileges granted to the (defaulted) object,
         *                   false if does.
         * @see    #can
         */
        cannot: function cannot(object) {
            return Permissions.Roles.cannot(object, this);
        },

        /**
         * Returns true if this principal is for the supplied user or user id, false otherwise.
         *
         * @param {String|User} user The user or user id to test against the user associated with this principal;
         *                           a falsey value will return false.
         * @return {Boolean} True if the specified user is the user associated with this principal, false otherwise.
         */
        forUser: function forUser(user) {
            return user && this.get("userId") === (typeof user === "string" ? user : user.get("id"));
        },

        /**
         * Returns the string representation of this principal.
         *
         * @return {String} The string representation; never null.
         */
        toString: function toString() {
            var user = this.get("user");
            // A null user means a principal where the credentials were validated, but with company restrictions so
            // an actual login is not possible...
            if (!user) {
                return "Principal[]";
            }
            // Include *principal* display name if different from the *user* display name, e.g. on AD login...
            var s = user.get("displayName"),
                displayName = this.get("displayName");

            if (s.indexOf(displayName) === -1) {
                s += " (" + displayName + ")";
            }
            return "Principal[name: " + s + "; role: " + this.get("role").name + "]";
        }

    });

    return Principal;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        CONSTANTS = __webpack_require__(209),
        ImprovedView = __webpack_require__(6),
        RemoveIncompatibleWidgetsContentView = __webpack_require__(1772),
        template = __webpack_require__(1776),
        Tooltip = __webpack_require__(35);

    var OverlayView = Backbone.View.extend({

        className: "remove-widgets-overlay",

        events: {
            "activate": "_activateHandler"
        },

        render: function render() {
            return this;
        },
        _activateHandler: function _activateHandler() {
            this.model.set("state", CONSTANTS.CLOSE);
        }
    }, {

        instance: null,

        show: function show(options) {
            var overlayView = new OverlayView(options);
            overlayView.render().$el.appendTo(window.document.body);
            OverlayView.instance = overlayView;
        },
        remove: function remove() {
            if (OverlayView.instance) {
                OverlayView.instance.remove();
                OverlayView.instance = null;
            }
        }
    });

    /**
     * Component representing the Send Test Email button for the <tt>SendTestEmailButtonView</tt>.
     *
     *
     * @class RemoveIncompatibleWidgetsView
     *
     */
    return ImprovedView.extend({
        template: template,

        ui: {
            popup: ".popup"
        },

        initialize: function initialize() {
            this.__super();
            this.listenTo(this.model, "change:state", this._manageModalState);
        },
        _addPopup: function _addPopup(tooltipSettings) {
            Tooltip.add(this.ui.popup, tooltipSettings);
            Tooltip.show(this.ui.popup);
            OverlayView.show({ model: this.model });
        },
        _removePopup: function _removePopup() {
            Tooltip.remove(this.ui.popup);
            OverlayView.remove();
        },
        _manageModalState: function _manageModalState() {
            var tooltipSettings = {
                width: 408,
                animation: false,
                trigger: "manual",
                duration: 0,
                classes: "remove-widgets-container email modal-popover"
            };

            switch (this.model.get("state")) {
                case CONSTANTS.CLOSE:
                    this._removePopup();
                    break;

                case CONSTANTS.OPEN:
                    tooltipSettings.content = new RemoveIncompatibleWidgetsContentView({ model: this.model });
                    tooltipSettings.html = true;
                    this._addPopup(tooltipSettings);
                    break;

                default:
                    break;
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CONSTANTS = __webpack_require__(209),
        ImprovedView = __webpack_require__(6),
        PopupMessageView = __webpack_require__(1773),
        template = __webpack_require__(1775);

    /**
     * Component representing content for the <tt>RemoveIncompatibleWidgetsView</tt>.
     *
     *
     * @class RemoveIncompatibleWidgetsContentView
     *
     */
    return ImprovedView.extend({
        template: template,

        className: "remove-widgets",

        regions: {
            messageRegion: ".message-region"
        },

        events: {
            "click .remove-widgets-confirm": function clickRemoveWidgetsConfirm() {
                this.model.set("state", CONSTANTS.REMOVE_WIDGETS);
            },

            "click .remove-widgets-cancel": function clickRemoveWidgetsCancel() {
                this.model.set("state", CONSTANTS.CLOSE);
            }
        },

        onRender: function onRender() {
            this.messageRegion.show(new PopupMessageView({
                model: this.model
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        template = __webpack_require__(1774);

    /**
     * Component representing content for the <tt>RemoveIncompatibleWidgetsView</tt>.
     *
     *
     * @class RemoveIncompatibleWidgetsContentView
     *
     */
    return ImprovedView.extend({
        template: template,

        ui: {
            customBody: ".custom-body"
        },

        onRender: function onRender() {
            var content = "Widgets to be removed: " + this.model.get("widgetsName");
            this.ui.customBody.html(content);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1774 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="body-spacer"></div>\n    <p class="body">\n        Are you sure you want to delete all ineligible widgets from your experience to turn on Email mode? This action is permanent.\n    </p>\n<p class="custom-body"></p>';

}
return __p
}

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="header">Remove Incompatible Widgets</div>\n<div class="message-region">\n</div>\n<div class="footer">\n    <div class="remove-widgets-confirm"><button class="btn">Confirm</button></div>\n    <div class="remove-divider">|</div>\n    <div class="remove-widgets-cancel">Cancel</div>\n</div>';

}
return __p
}

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span class="popup"></span>';

}
return __p
}

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showCloseButton) { ;
__p += '\n<span class="close-icon"></span>\n';
 } ;
__p += '\n\n<a class="next-notification" title="Click for next notification..."></a>\n\n<div class="content">\n    <i class="glyphicon glyphicon-exclamation-sign important"></i>\n    <span class="message"></span>\n\n    ';
 if (action.indexOf("duplicate") !== -1) { ;
__p += '\n        <span class="duplicate"><a class="action">Make a copy</a> - will not affect this Experience.</span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("reload") !== -1) { ;
__p += '\n        <span class="reload"><a class="action">Refresh</a>';
 if (request !== "fetch" && request !== "destroy") {;
__p += ' - your changes will be lost.';
 } ;
__p += '</span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("retry") !== -1) { ;
__p += '\n        <span class="retry"><a class="action">Try again</a></span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("relogin") !== -1) { ;
__p += '\n        <span class="relogin"><a class="action">Refresh Sign In</a></span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("community") !== -1) { ;
__p += '\n        <span class="community"><a class="action">Visit the Community</a></span>\n    ';
 } ;
__p += '\n    ';
 if (action.indexOf("removeIncompatibleWidgets") !== -1) { ;
__p += '\n        <span class="removeIncompatibleWidgets"><a class="action">Click Here</a> to delete all ineligible widgets from your experience. </span>\n    ';
 } ;
__p += '\n\n</div>\n<div class="remove-incompatible-widgets-region"></div>';

}
return __p
}

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var Preconditions = __webpack_require__(14);
    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var Window = __webpack_require__(48);
    var Keyboard = __webpack_require__(243);
    var template = _.template("<div class=\"input-selection\"><% _.each(choices, function (choice) { %><span class=\"input-choice\"><%- choice.label %></span><% }) %></div>");

    var CLICK_EVENT = "click.input-selection";

    var $body = $("body");

    /**
     * Helps create a set of optional choices for the user when inserting data
     * in an input field. The data inputted are in no way limited to the
     * options provide -- they serve only as a guide for the user to quickly
     * click.
     *
     * Notice that this class listens to clicks on the body element to
     * determine when to close the set of options. If clicks on the body, for
     * some reason, are prevented (usually via stopPropagation), then it's
     * needed to call the `closeDropdown` method manually to close it.
     *
     * @class InputSelection
     * @author Gorm Casper
     */
    return ImprovedView.extend({

        /**
         * The input field that we apply our options/choices to.
         */
        $input: null,

        /**
         * The container of the choices. This will default to the body if none
         * is applied. The choices dropdown will be appended and the end of the
         * container.
         */
        $container: null,

        /**
         * Ordered array of objects with labels and values. Labels will always
         * be strings and are used in the dom.
         *
         * [{label: "18", value: 18}]
         */
        choices: null,

        /**
         * Object used for quickly looking up values based on their label.
         * {label: value}
         */
        lookup: null,

        constructor: function constructor(options) {
            this.$input = options.$input;
            this.choices = options.choices;
            this.$container = options.$container || $body;

            // Choices can be be given as a long list of choices if the label
            // does not differ from its value. If this is the case, then we
            // need to normalize the data.
            if (!_.isArray(options.choices[0])) {
                this.choices = options.choices.map(function (choice) {
                    return {
                        label: choice.toString(),
                        value: choice
                    };
                });
            }

            // Make lookup table which is basically an object with labels as
            // keys.
            this.lookup = this.choices.reduce(function (lookup, choice) {
                lookup[choice.label] = choice.value;

                return lookup;
            }, {});

            Preconditions.is$element(this.$input);
            Preconditions.is$element(this.$container);
            Preconditions.isArray(this.choices);

            this.$dropdown = $(template({ choices: this.choices }));

            _.bindAll(this, "_selectChoice", "_clickCloseHandler", "_showDropdown", "closeDropdown", "_positionDropdown");

            this.$input.on({
                focus: this._showDropdown,
                click: this._showDropdown,
                change: this.closeDropdown
            });

            this.$dropdown.on(CLICK_EVENT, this._selectChoice);

            this.resizeEvents = Window.on("resize", this._positionDropdown); // already bound to this above!
        },


        /**
         * Shows and positions the dropdown. Also sets up listeners to listen
         * for when to close it again.
         *
         * @private
         */
        _showDropdown: function _showDropdown() {
            this.$container.append(this.$dropdown.show());

            this._positionDropdown();

            $body.on(CLICK_EVENT, this._clickCloseHandler);
            this.listenTo(Keyboard.Down, Keyboard.KeyCode.TAB, this.closeDropdown);
        },


        /**
         * Places the dropdown below the input field and adjusts its width and
         * height.
         *
         * @private
         */
        _positionDropdown: function _positionDropdown() {
            // Quick sanity check. This is to prevent work when the function
            // is called from the resize event.
            if (!this.$input.is(":visible")) {
                return;
            }

            var $inputRect = this.$input.get(0).getBoundingClientRect();

            this.$dropdown.css({
                top: $inputRect.bottom + 1,
                left: $inputRect.left,
                width: $inputRect.width,
                bottom: "auto"
            });

            // If the choices box extends below the window, then we need to
            // push it up so it stops just before the end of the window.
            if (window.innerHeight - this.$dropdown.get(0).getBoundingClientRect().bottom < 2) {
                this.$dropdown.css({ bottom: 2 });
            }
        },


        /**
         * Handles clicks outside the dropdown.
         *
         * @private
         * @param event
         */
        _clickCloseHandler: function _clickCloseHandler(event) {
            if (event.target === this.$input.get(0)) {
                return;
            }

            this.closeDropdown();
        },


        /**
         * Closes the dropdown and unsibscribes from events that would
         * otherwise close it.
         */
        closeDropdown: function closeDropdown() {
            $body.off(CLICK_EVENT, this._clickCloseHandler);
            this.stopListening(Keyboard);
            this.$dropdown.hide();
        },
        _selectChoice: function _selectChoice(event) {
            var choiceValue = this.lookup[event.target.innerHTML];

            // This shouldn't really be possible unless the user tampers messes
            // with the dom.
            if (choiceValue === undefined) {
                return;
            }

            this.$input.val(choiceValue).trigger("change").blur();
        },
        dispose: function dispose() {
            // Unsubscribe from listeners.
            this.$input.off();
            this.$dropdown.off();
            this.resizeEvents.off();
            $body.off(CLICK_EVENT, this._clickCloseHandler);

            // Remove the dropdown from the dom.
            this.$dropdown.remove();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".character-properties-container.collapse-target">Text</legend>\n    <div class="character-properties-container collapse collapse-target zmags-input-control">\n        <section class="row font-info-section properties">\n          <div class="col-md-12">\n            <div class="font-info">\n                Font <span class="info-tooltip" data-content="Search all available fonts including Google Fonts not shown in the list"></span>\n            </div>\n            <input type="hidden" class="font-selector zmags-input-control">\n          </div>\n        </section>\n\n        <section class="row style-section properties">\n          <div class="col-md-4">Style</div>\n          <div class="col-md-8">\n            <select class="font-style form-control pull-left"></select>\n          </div>\n        </section>\n\n        <section class="row decoration-section properties">\n          <div class="col-md-4"></div>\n          <div class="col-md-8">\n            <input type="hidden" class="text-decoration">\n            <button class="change-text-decoration text-decoration button-switch" data-value="underline" title="Underline">\n                <span class="glyphicon glyphicon-text-color"></span>\n            </button>\n            <button class="change-text-decoration text-decoration button-switch" data-value="line-through" title="Line-Through">\n                <span class="glyphicon glyphicon-font"></span>\n            </button>\n            <input type="hidden" class="text-shadow">\n            <button class="change-text-shadow text-decoration button-switch">\n                <span class="glyphicon glyphicon-text-shadow"></span>\n            </button>\n          </div>\n        </section>\n\n        <section class="row style-section properties">\n          <div class="col-md-4">Case</div>\n          <div class="col-md-8">\n\n            <button class="change-text-case button-switch text-transform-uppercase" data-align="left" title="Capitalize" data-option="' +
__e( TextCaseOptions.UPPERCASE ) +
'">\n                <span style="text-transform: uppercase">ABC</span>\n            </button>\n            <button class="change-text-case button-switch font-variant-smallcaps" data-align="center" title="Small Caps" data-option="' +
__e( TextCaseOptions.SMALL_CAPS ) +
'">\n                <span style="font-variant: small-caps">abc</span>\n            </button>\n          </div>\n        </section>\n\n        <section class="row size-section properties">\n          <div class="col-md-4">Size</div>\n          <div class="col-md-8">\n            <label data-unit="px" class="pull-left">\n               <input type="number" step="any" class="font-size small">\n            </label>\n            <span class="glyphicon glyphicon-text-size icon-right"></span>\n          </div>\n        </section>\n\n        <section class="row color-section properties">\n          <div class="col-md-4">Color</div>\n          <div class="col-md-8">\n            <div class="color-info pull-left">\n              <div class="color-box font-color-box"></div>\n              <input type="text" class="color-input color-input-box" />\n            </div>\n          </div>\n        </section>\n\n        <section class="row line-height-section properties">\n          <div class="col-md-4">Line Height</div>\n          <div class="col-md-8">\n            <div class="line-height-info pull-left" title="percentage of the font size">\n               <input type="number" step=".1" class="line-height small">\n            </div>\n            <span class="glyphicon glyphicon-text-height icon-right"></span>\n          </div>\n        </section>\n\n        <section class="row letter-spacing-section properties">\n          <div class="col-md-5">Letter Spacing</div>\n          <div class="col-md-7 letter-spacing-info">\n            <label data-unit="px" class="pull-left">\n               <input type="number" step="any" class="font-letter-spacing small">\n            </label>\n            <span class="glyphicon glyphicon-text-width icon-right"></span>\n          </div>\n        </section>\n\n        <section class="row alignment-section properties">\n          <div class="col-md-4">Alignment</div>\n          <div class="col-md-8">\n            <input type="hidden" class="text-align">\n            <button class="change-text-align button-switch" data-align="left" title="Left">\n                <span class="glyphicon glyphicon-align-left"></span>\n            </button>\n            <button class="change-text-align button-switch" data-align="center" title="Center">\n                <span class="glyphicon glyphicon-align-center"></span>\n            </button>\n            <button class="change-text-align button-switch" data-align="right" title="Right">\n                <span class="glyphicon glyphicon-align-right"></span>\n            </button>\n          </div>\n        </section>\n\n        <section class="row node-name-section properties">\n          <div class="col-md-4">HTML Tag<span class="info-tooltip" data-content="Used for SEO purposes and won\'t affect the appearance"></span></div>\n          <div class="col-md-8">\n            <select class="node-name form-control pull-left"></select>\n          </div>\n        </section>\n    </div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div>\n    <div class="zmags-input-control">\n        <section class="row font-size-box properties">\n            <div class="col-md-5">\n                Size\n            </div>\n            <div class="col-md-7">\n                <label data-unit="px" class="pull-left">\n                    <input type="number" step="any" class="font-size small">\n                </label>\n                <span class="glyphicon glyphicon-text-size icon-right"></span>\n            </div>\n        </section>\n\n        <section class="row properties">\n            <div class="col-md-5">\n                Font\n            </div>\n            <div class="col-md-7">\n                <input type="hidden" class="font-selector zmags-input-control full-width">\n            </div>\n        </section>\n        \n        <section class="row font-style-box properties">\n            <div class="col-md-5">\n                Style\n            </div>\n            <div class="col-md-7">\n                <label>\n                    <select class="font-style form-control full-width"></select>\n                </label>\n            </div>\n        </section>\n\n        <section class="row properties color-section">\n            <div class="col-md-5">\n                Text Color\n            </div>\n            <div class="col-md-7">\n                <div class="color-info">\n                    <div class="color-box font-color-box"></div>\n                    <input type="text" class="color-input color-input-box" />\n                </div>\n            </div>\n        </section>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 1781 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div>\n    <div class="content-container">\n        <section class="row button-label-row properties">\n            <div class="col-md-5">\n                Text\n            </div>\n            <div class="col-md-7">\n                <input type="text" class="button-label-input full-width" placeholder="Label&#8230;">\n            </div>\n        </section>\n        <div class="character-properties"></div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '\n<fieldset class="button-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".button-properties-container">Button</legend>\n\n    <div class="button-properties-container collapse collapse-target zmags-input-control">\n        <section class="row properties">\n            <div class="col-md-5">\n                Type\n            </div>\n            <div class="col-md-7">\n                <select class="form-control button-type full-width">\n                    <option value="' +
__e( ButtonType.TEXT_AND_ICON ) +
'">Text And Icon</option>\n                    <option value="' +
__e( ButtonType.TEXT_ONLY ) +
'">Text Only</option>\n                    <option value="' +
__e( ButtonType.ICON_ONLY ) +
'">Icon Only</option>\n                </select>\n            </div>\n        </section>\n        <section class="row properties color-section">\n            <div class="col-md-5">\n                Button Color\n            </div>\n            <div class="col-md-7">\n                <div class="color-info">\n                    <div class="button-background-color-box color-box"></div>\n                    <input type="text" class="button-background-color-input color-input-box">\n                </div>\n            </div>\n        </section>\n        <section class="row properties">\n            <div class="col-md-5">\n                Padding\n            </div>\n            <div class="col-md-7">\n                <label data-unit="px" class="pull-left">\n                    <input type="number" step="any" class="padding small">\n                </label>\n            </div>\n        </section>\n        <section>\n            <div class="label-properties-region"></div>\n            <div class="icon-properties-region"></div>\n        </section>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="action-properties"></div>\n    <div class="analytics-properties"></div>\n    <div class="animation-properties"></div>\n    <div class="style-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 1783 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="size-and-position-properties"></div>\n';

}
return __p
}

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationPropertiesView = __webpack_require__(125),
        Backbone = __webpack_require__(7),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        LoggedIn = __webpack_require__(31),
        SizeAndPositionPropertiesView = __webpack_require__(70),
        template = __webpack_require__(1785),
        UrlUtil = __webpack_require__(46),
        AbstractWidgetPropertiesView = __webpack_require__(63);


    var EXPAND_PROPERTY = "embedExpanded";

    /**
     * The properties view for an embed widget.
     *
     * @class EmbedWidgetPropertiesView
     * @constructor
     *
     * @cfg {EmbedWidgetModel} model The model for the embed widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("EmbedWidgetPropertiesView", {

        expandProperty: EXPAND_PROPERTY,

        template: template,

        // A bit of helper info for verbose and/or ad logins...
        templateHelpers: function templateHelpers() {
            return {
                descriptor: Logger.level() >= Logger.VERBOSE && LoggedIn.internal() ? UrlUtil.getUrlDescriptor(this.model.get("url")) : { type: "url" }
            };
        },

        ui: {
            embedProperties: ".embed-properties-accordion"
        },

        events: {
            "click .help-block .embedded": function clickHelpBlockEmbedded() {
                // only present on valid embedded url descriptor
                var descriptor = UrlUtil.getUrlDescriptor(this.model.get("url"));
                Backbone.history.navigate("#" + descriptor.type + "/" + descriptor.id + "/edit/" + descriptor.scene, true);
            }
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            animationProperties: ".animation-properties"
        },

        bindings: {
            ".url": "url"
        },

        _shouldExpandOnRender: function _shouldExpandOnRender() {
            return this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] || !this.model.hasUrl();
        },


        onRender: function onRender() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({ model: this.model, hideRotation: true, widgetView: this.options.widgetView }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1785 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset class="embed-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".embed-properties-accordion">Embed</legend>\n    <div class="embed-properties-accordion collapse collapse-target">\n        <div>\n            <input type="text" class="url full-width" placeholder="Add your link here&#8230;">\n            <span class="help-block">\n                Enter the URL for the content you want to embed in your Experience.\n            </span>\n            ';
 if (descriptor.type !== "url") { ;
__p += '\n            <span class="help-block">\n                <em>Embedded ' +
__e( descriptor.type ) +
'</em>: <a class="embedded">' +
__e( descriptor.id );
 if (descriptor.scene > 1) { ;
__p += ', scene ' +
__e( descriptor.scene ) +
' ';
 } ;
__p += '</a>\n            </span>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n</fieldset>\n\n<div class="animation-properties"></div>\n<fieldset class="size-and-position-properties"></fieldset>\n';

}
return __p
}

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ActionPropertiesView = __webpack_require__(205);
    var AnimationPropertiesView = __webpack_require__(125);
    var CharacterPropertiesView = __webpack_require__(402);
    var ImprovedView = __webpack_require__(6);
    var SizeAndPositionPropertiesView = __webpack_require__(70);
    var template = __webpack_require__(1787);

    /**
     * The properties view for a html widget.
     *
     * @class HtmlWidgetPropertiesView
     * @constructor
     *
     * @cfg {HtmlWidgetModel} model The model for the html widget being edited.
     */
    return ImprovedView.extend({

        template: template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            analyticsProperties: ".analytics-properties",
            animationProperties: ".animation-properties",
            actionProperties: ".action-properties"
        },

        onRender: function onRender() {
            this.__super();

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                widgetView: this.options.widgetView,
                hideRotation: true
            }));
            this.analyticsProperties.show(this._setAnalyticsLabel({ model: this.model }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this.actionProperties.show(new ActionPropertiesView({ model: this.model }));
        }
    }, {
        EXPAND_PROPERTY: CharacterPropertiesView.EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1787 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset>\n    <div class="character-properties" id="character-properties"></div>\n    <div class="action-properties"></div>\n    <div class="analytics-properties"></div>\n    <div class="animation-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ReactBridge = __webpack_require__(137);
    var ActionPropertiesView = __webpack_require__(205);
    var AnimationPropertiesView = __webpack_require__(125);
    var CompactImageLibraryView = __webpack_require__(552);
    var EditorEvents = __webpack_require__(17);
    var ImageCollection = __webpack_require__(314);
    var SizeAndPositionPropertiesView = __webpack_require__(70);
    var StylePropertiesView = __webpack_require__(559);
    var template = __webpack_require__(1789);
    var AbstractWidgetPropertiesView = __webpack_require__(63);
    var EditorEventFilters = __webpack_require__(154).default;
    var C3ImageLibrary = __webpack_require__(879).default;

    var EXPAND_PROPERTY = "imageLibraryExpanded";
    var folderState = {
        folderPathDetails: "/",
        accordianTitleDetails: "Select folder"

        /**
         * The properties view for an image widget.
         *
         * @class ImageWidgetPropertiesView
         * @constructor
         *
         * @cfg {ImageWidgetModel} model The model for the image widget being edited.
         */
    };return AbstractWidgetPropertiesView.extend("ImageWidgetPropertiesView", {

        expandProperty: EXPAND_PROPERTY,

        template: template,

        ui: {
            container: ".image-properties-accordion",
            legend: "[data-target=\".image-properties-accordion\"]"
        },

        regions: {
            imageLibraryRegion: ".image-properties-accordion",
            sizeAndPositionProperties: ".size-and-position-properties",
            styleProperties: ".style-properties",
            analyticsProperties: ".analytics-properties",
            animationProperties: ".animation-properties",
            actionProperties: ".action-properties"
        },

        _handleImageClick: function _handleImageClick(imageModel) {
            console.log(imageModel);
            var properties = {
                altText: imageModel.altText,
                imageId: imageModel.imageId,
                originalImageHeight: imageModel.height,
                originalImageWidth: imageModel.width,
                src: imageModel.url
            };

            this.model.set(properties);

            var eventProperties = {
                triggerOrigin: "ImageLibrary",
                imageId: imageModel.imageId,
                imageName: imageModel.name,
                projectId: project && project.get("id")
            };

            var experience = this.viewScope.viewModel.get("experience");

            if (experience) {
                eventProperties.experienceId = experience.get("id");
                eventProperties.experienceVersion = experience.get("version");
                eventProperties.experiencePushedVersion = experience.get("pushedVersion");
            }
            // Make sure we log the event
            EditorEvents.trigger(EditorEvents.constants.SELECT_IMAGE, eventProperties);
        },
        _showCompactLibrary: function _showCompactLibrary() {
            var _this = this;

            var viewModel = this.viewScope.viewModel;

            var imageLibrarySorting = viewModel.get("imageLibrarySorting");
            var collection = new ImageCollection();
            var project = viewModel.get("project");

            var imageLibrary = new CompactImageLibraryView({
                collection: collection,
                selectedImage: this.model && this.model.get("imageId") ? this.model : null,
                imageLibrarySorting: imageLibrarySorting,
                project: project,
                itemViewOptions: {
                    imageTaggingEnabled: viewModel.get("imageTaggingEnabled"),
                    inventoryEnabled: viewModel.get("inventoryEnabled"),
                    draggable: true
                }
            });

            this.listenTo(imageLibrary, "image:selected", function (imageModel) {
                // Change content of imageWidget
                var properties = {
                    altText: imageModel.get("altText"),
                    imageId: imageModel.get("id"),
                    originalImageHeight: imageModel.get("height"),
                    originalImageWidth: imageModel.get("width"),
                    supportsResize: imageModel.get("supportsResize"),
                    src: imageModel.get("url")
                };

                _this.model.set(properties);

                var eventProperties = {
                    triggerOrigin: "ImageLibrary",
                    imageId: imageModel.get("id"),
                    imageName: imageModel.get("name"),
                    projectId: project && project.get("id"),
                    sourceType: imageModel.get("sourceType")
                };

                var experience = _this.viewScope.viewModel.get("experience");

                if (experience) {
                    eventProperties.experienceId = experience.get("id");
                    eventProperties.experienceVersion = experience.get("version");
                    eventProperties.experiencePushedVersion = experience.get("pushedVersion");
                }
                // Make sure we log the event
                EditorEvents.trigger(EditorEvents.constants.SELECT_IMAGE, eventProperties);
            });

            this.model.set("selectedWidgetId", this.model.get("uuid"), { cause: EditorEventFilters.SUPERFICIAL });
            this.imageLibraryRegion.show(imageLibrary);
        },
        _handleDragStart: function _handleDragStart(path, title) {
            folderState.folderPathDetails = path;
            folderState.accordianTitleDetails = title;
        },
        _showC3ImageLibrary: function _showC3ImageLibrary() {
            this.model.set("selectedWidgetId", this.model.get("uuid"), { cause: EditorEventFilters.SUPERFICIAL });

            this.imageLibraryRegion.show(ReactBridge.viewFromComponent(C3ImageLibrary, {
                props: { handleImageClick: this._handleImageClick.bind(this), handleDragStart: this._handleDragStart.bind(this), folderPath: folderState.folderPathDetails, accordianTitle: folderState.accordianTitleDetails }
            }));
        },
        onRender: function onRender() {
            this.__super();

            if ((0, _C3Utils.isC3Experience)()) this._showC3ImageLibrary();else this._showCompactLibrary();

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({ model: this.model, editorViewModel: this.viewScope.viewModel, widgetView: this.options.widgetView }));
            this.styleProperties.show(new StylePropertiesView({ model: this.model, hideOpacityControls: true, hideRadiusControls: true }));
            this.analyticsProperties.show(this._setAnalyticsLabel({ model: this.model }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this.actionProperties.show(new ActionPropertiesView({ model: this.model }));
        },
        _shouldExpandOnRender: function _shouldExpandOnRender() {
            return this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] || !this.model.hasImage();
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="image-properties">\n    <fieldset>\n        <legend class="collapsible collapsed" data-toggle="collapse" data-target=".image-properties-accordion">\n            Image Library\n        </legend>\n        <div class="image-properties-accordion collapse collapse-target images"></div>\n    </fieldset>\n</div>\n\n<div class="action-properties"></div>\n<div class="analytics-properties"></div>\n<div class="animation-properties"></div>\n<div class="style-properties"></div>\n<div class="size-and-position-properties"></div>\n';

}
return __p
}

/***/ }),
/* 1790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(880);
/* unused harmony reexport common */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__red__ = __webpack_require__(881);
/* unused harmony reexport red */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pink__ = __webpack_require__(882);
/* unused harmony reexport pink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__purple__ = __webpack_require__(1791);
/* unused harmony reexport purple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deepPurple__ = __webpack_require__(1792);
/* unused harmony reexport deepPurple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__indigo__ = __webpack_require__(883);
/* unused harmony reexport indigo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blue__ = __webpack_require__(884);
/* unused harmony reexport blue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lightBlue__ = __webpack_require__(1793);
/* unused harmony reexport lightBlue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cyan__ = __webpack_require__(1794);
/* unused harmony reexport cyan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__teal__ = __webpack_require__(1795);
/* unused harmony reexport teal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__green__ = __webpack_require__(885);
/* unused harmony reexport green */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lightGreen__ = __webpack_require__(1796);
/* unused harmony reexport lightGreen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lime__ = __webpack_require__(1797);
/* unused harmony reexport lime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__yellow__ = __webpack_require__(1798);
/* unused harmony reexport yellow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amber__ = __webpack_require__(1799);
/* unused harmony reexport amber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__orange__ = __webpack_require__(886);
/* unused harmony reexport orange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__deepOrange__ = __webpack_require__(1800);
/* unused harmony reexport deepOrange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__brown__ = __webpack_require__(1801);
/* unused harmony reexport brown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__grey__ = __webpack_require__(887);
/* unused harmony reexport grey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__blueGrey__ = __webpack_require__(1802);
/* unused harmony reexport blueGrey */





















/***/ }),
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
/* unused harmony default export */ var _unused_webpack_default_export = (purple);

/***/ }),
/* 1792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};
/* unused harmony default export */ var _unused_webpack_default_export = (deepPurple);

/***/ }),
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
/* unused harmony default export */ var _unused_webpack_default_export = (lightBlue);

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};
/* unused harmony default export */ var _unused_webpack_default_export = (cyan);

/***/ }),
/* 1795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};
/* unused harmony default export */ var _unused_webpack_default_export = (teal);

/***/ }),
/* 1796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};
/* unused harmony default export */ var _unused_webpack_default_export = (lightGreen);

/***/ }),
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (lime);

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};
/* unused harmony default export */ var _unused_webpack_default_export = (yellow);

/***/ }),
/* 1799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (amber);

/***/ }),
/* 1800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (deepOrange);

/***/ }),
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};
/* unused harmony default export */ var _unused_webpack_default_export = (brown);

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};
/* unused harmony default export */ var _unused_webpack_default_export = (blueGrey);

/***/ }),
/* 1803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorManipulator__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createTheme__ = __webpack_require__(564);
/* unused harmony reexport createTheme */
/* unused harmony reexport createMuiTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMuiStrictModeTheme__ = __webpack_require__(1825);
/* unused harmony reexport unstable_createMuiStrictModeTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createStyles__ = __webpack_require__(1826);
/* unused harmony reexport createStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__makeStyles__ = __webpack_require__(1851);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__makeStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__responsiveFontSizes__ = __webpack_require__(1852);
/* unused harmony reexport responsiveFontSizes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styled__ = __webpack_require__(917);
/* unused harmony reexport styled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transitions__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useTheme__ = __webpack_require__(67);
/* unused harmony reexport useTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withStyles__ = __webpack_require__(8);
/* unused harmony reexport withStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__withTheme__ = __webpack_require__(1854);
/* unused harmony reexport withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_styles__ = __webpack_require__(92);
/* unused harmony reexport createGenerateClassName */
/* unused harmony reexport jssPreset */
/* unused harmony reexport ServerStyleSheets */
/* unused harmony reexport StylesProvider */
/* unused harmony reexport MuiThemeProvider */
/* unused harmony reexport ThemeProvider */

 // eslint-disable-next-line camelcase












/***/ }),
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isPlainObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = deepmerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(140);


function isPlainObject(item) {
  return item && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, target) : target;

  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(563);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, acceptingRef);
elementAcceptingRef.isRequired = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element.isRequired, acceptingRef);
/* unused harmony default export */ var _unused_webpack_default_export = (elementAcceptingRef);

/***/ }),
/* 1806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(563);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://mui.com/r/caveat-with-refs-guide');
  }

  return null;
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"], elementTypeAcceptingRef));

/***/ }),
/* 1807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export specialProperty */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);


// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (true) {
    return propTypes;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, propTypes, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/***/ }),
/* 1808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://mui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

/***/ }),
/* 1809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFunctionName */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);

 // Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(Component) === 'object') {
    switch (Component.$$typeof) {
      case __WEBPACK_IMPORTED_MODULE_1_react_is__["ForwardRef"]:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case __WEBPACK_IMPORTED_MODULE_1_react_is__["Memo"]:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

/***/ }),
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function HTMLElementType(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  if (propValue && propValue.nodeType !== 1) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an HTMLElement.");
  }

  return null;
}

/***/ }),
/* 1811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
/* unused harmony default export */ var _unused_webpack_default_export = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());

/***/ }),
/* 1812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var refType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]);
/* unused harmony default export */ var _unused_webpack_default_export = (refType);

/***/ }),
/* 1813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMixins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 1814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export light */
/* unused harmony export dark */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPalette;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colors_common__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors_grey__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__colors_indigo__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__colors_pink__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colors_red__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__colors_orange__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__colors_blue__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__colors_green__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__colorManipulator__ = __webpack_require__(71);













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    default: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][800],
    default: '#303030'
  },
  action: {
    active: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["e" /* lighten */])(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["b" /* darken */])(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A200,
    main: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A400,
    dark: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_8__colors_orange__["a" /* default */][700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_9__colors_blue__["a" /* default */][700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_10__colors_green__["a" /* default */][700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = Object(__WEBPACK_IMPORTED_MODULE_11__colorManipulator__["d" /* getContrastRatio */])(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: The contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\nThe color object needs to have a `main` property or a `".concat(mainShade, "` property.") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error( false ? "Material-UI: The color provided to augmentColor(color) is invalid.\n`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead.\n\nDid you intend to use one of the following approaches?\n\nimport {\xA0green } from \"@material-ui/core/colors\";\n\nconst theme1 = createTheme({ palette: {\n  primary: green,\n} });\n\nconst theme2 = createTheme({ palette: {\n  primary: { main: green[500] },\n} });") : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  if (false) {
    if (!types[type]) {
      console.error("Material-UI: The palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // A collection of common colors.
    common: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */],
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */],
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

/***/ }),
/* 1815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTypography;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(20);




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var warnedOnce = false;

function roundWithDeprecationWarning(value) {
  if (false) {
    if (!warnedOnce) {
      console.warn(['Material-UI: The `theme.typography.round` helper is deprecated.', 'Head to https://mui.com/r/migration-v4/#theme for a migration path.'].join('\n'));
      warnedOnce = true;
    }
  }

  return round(value);
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {
    if (typeof fontSize !== 'number') {
      console.error('Material-UI: `fontSize` is required to be a number.');
    }

    if (typeof htmlFontSize !== 'number') {
      console.error('Material-UI: `htmlFontSize` is required to be a number.');
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 1816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ __webpack_exports__["a"] = (shadows);

/***/ }),
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shape = {
  borderRadius: 4
};
/* harmony default export */ __webpack_exports__["a"] = (shape);

/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSpacing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_system__ = __webpack_require__(889);

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["c" /* createUnarySpacing */])({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(892);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(arr);
}

/***/ }),
/* 1820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export displayPrint */
/* unused harmony export displayRaw */
/* unused harmony export overflow */
/* unused harmony export textOverflow */
/* unused harmony export visibility */
/* unused harmony export whiteSpace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(158);


var displayPrint = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'displayPrint',
  cssProperty: false,
  transform: function transform(value) {
    return {
      '@media print': {
        display: value
      }
    };
  }
});
var displayRaw = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'display'
});
var overflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'overflow'
});
var textOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textOverflow'
});
var visibility = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'visibility'
});
var whiteSpace = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'whiteSpace'
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace));

/***/ }),
/* 1822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(141);

var boxShadow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
/* harmony default export */ __webpack_exports__["a"] = (boxShadow);

/***/ }),
/* 1823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 1824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

/***/ }),
/* 1825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createTheme__ = __webpack_require__(564);


function createMuiStrictModeTheme(options) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_1__createTheme__["a" /* default */].apply(void 0, [Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["a" /* deepmerge */])({
    unstable_strictMode: true
  }, options)].concat(args));
}

/***/ }),
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(92);
 // let warnOnce = false;
// To remove in v5

function createStyles(styles) {
  // warning(
  //   warnOnce,
  //   [
  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
  //     'Please use @material-ui/styles/createStyles',
  //   ].join('\n'),
  // );
  // warnOnce = true;
  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["a" /* createStyles */])(styles);
}

/***/ }),
/* 1827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createGenerateClassName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__ = __webpack_require__(905);

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (false) {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[__WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__["a" /* default */]] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/***/ }),
/* 1828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStyles;
function createStyles(styles) {
  return styles;
}

/***/ }),
/* 1829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getThemeProps;
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

/***/ }),
/* 1830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jssPreset;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__ = __webpack_require__(1831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__ = __webpack_require__(1832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__ = __webpack_require__(1833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__ = __webpack_require__(1834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__ = __webpack_require__(1836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__ = __webpack_require__(1837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__ = __webpack_require__(1839);






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset() {
  return {
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__["a" /* default */])(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : Object(__WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__["a" /* default */])()]
  };
}

/***/ }),
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_warning__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(211);



var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = Object(__WEBPACK_IMPORTED_MODULE_1_jss__["d" /* createRule */])(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (false) {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (functionPlugin);


/***/ }),
/* 1832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(211);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new __WEBPACK_IMPORTED_MODULE_1_jss__["a" /* RuleList */](Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssGlobal);


/***/ }),
/* 1833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiny_warning__ = __webpack_require__(210);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssNested);


/***/ }),
/* 1834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(1835);


/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (camelCase);


/***/ }),
/* 1835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["a"] = (hyphenateStyleName);


/***/ }),
/* 1836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss__ = __webpack_require__(211);


var px = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.px : 'px';
var ms = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.ms : 'ms';
var percent = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (defaultUnit);


/***/ }),
/* 1837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_vendor__ = __webpack_require__(1838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(211);



/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["a" /* supportedKeyframes */])(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["b" /* supportedProperty */])(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(supportedProp, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" /* toCssValue */])(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(prop, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" /* toCssValue */])(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssVendorPrefixer);


/***/ }),
/* 1838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportedKeyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportedProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportedValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_in_browser__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = __WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */] && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ("production" !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ("production" !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}




/***/ }),
/* 1839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssPropsSort);


/***/ }),
/* 1840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeClasses__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StylesProvider__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__indexCounter__ = __webpack_require__(1844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getStylesCreator__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__ = __webpack_require__(910);












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = Object(__WEBPACK_IMPORTED_MODULE_3_jss__["e" /* getDynamicStyles */])(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__["a" /* default */] : _options$defaultTheme,
      stylesOptions2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = Object(__WEBPACK_IMPORTED_MODULE_9__getStylesCreator__["a" /* default */])(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: Object(__WEBPACK_IMPORTED_MODULE_8__indexCounter__["a" /* increment */])(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;

    var stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_7__StylesProvider__["a" /* StylesContext */]), stylesOptions2);

    var instance = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    var shouldUpdate = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (false) {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

/***/ }),
/* 1841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeClasses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(20);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, baseClasses);

  if (false) {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (false) {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (multiKeyStore);

/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThemeContext__ = __webpack_require__(908);


function useTheme() {
  var theme = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_1__ThemeContext__["a" /* default */]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue(theme);
  }

  return theme;
}

/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = increment;
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__ = __webpack_require__(1846);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__["a"]; });


/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStylesCreator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noopTheme__ = __webpack_require__(910);




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StylesProvider__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__ = __webpack_require__(411);








var ServerStyleSheets = /*#__PURE__*/function () {
  function ServerStyleSheets() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ServerStyleSheets);

    this.options = options;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(ServerStyleSheets, [{
    key: "collect",
    value: function collect(children) {
      // This is needed in order to deduplicate the injection of CSS in the page.
      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.

      this.sheetsRegistry = new __WEBPACK_IMPORTED_MODULE_4_jss__["b" /* SheetsRegistry */](); // A new class name generator

      var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__["a" /* default */])();
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StylesProvider__["b" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        sheetsManager: sheetsManager,
        serverGenerateClassName: generateClassName,
        sheetsRegistry: this.sheetsRegistry
      }, this.options), children);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
    }
  }, {
    key: "getStyleElement",
    value: function getStyleElement(props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: 'jss-server-side',
        key: 'jss-server-side',
        dangerouslySetInnerHTML: {
          __html: this.toString()
        }
      }, props));
    }
  }]);

  return ServerStyleSheets;
}();



/***/ }),
/* 1848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = styled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__makeStyles__ = __webpack_require__(413);









function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
} // styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.


function styled(Component) {
  var componentCreator = function componentCreator(style) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name"]);

    if (false) {
      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var stylesOrCreator = typeof style === 'function' ? function (theme) {
      return {
        root: function root(props) {
          return style(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
            theme: theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_7__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};

    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    /* eslint-disable react/forbid-foreign-prop-types */


    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    /* eslint-enable react/forbid-foreign-prop-types */


    var StyledComponent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StyledComponent(props, ref) {
      var children = props.children,
          classNameProp = props.className,
          clone = props.clone,
          ComponentProp = props.component,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "className", "clone", "component"]);

      var classes = useStyles(props);
      var className = Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(classes.root, classNameProp);
      var spread = other;

      if (filterProps) {
        spread = omit(spread, filterProps);
      }

      if (clone) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(children.props.className, className)
        }, spread));
      }

      if (typeof children === 'function') {
        return children(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: className
        }, spread));
      }

      var FinalComponent = ComponentProp || Component;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FinalComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: ref,
        className: className
      }, spread), children);
    });
     false ? StyledComponent.propTypes = _extends({
      /**
       * A render function or node.
       */
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

      /**
       * @ignore
       */
      className: PropTypes.string,

      /**
       * If `true`, the component will recycle it's children HTML element.
       * It's using `React.cloneElement` internally.
       *
       * This prop will be deprecated and removed in v5
       */
      clone: chainPropTypes(PropTypes.bool, function (props) {
        if (props.clone && props.component) {
          return new Error('You can not use the clone and component prop at the same time.');
        }

        return null;
      }),

      /**
       * The component used for the root node.
       * Either a string to use a HTML element or a component.
       */
      component: PropTypes
      /* @typescript-to-proptypes-ignore */
      .elementType
    }, propTypes) : void 0;

    if (false) {
      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
    }

    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(StyledComponent, Component);
    return StyledComponent;
  };

  return componentCreator;
}

/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useTheme__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nested__ = __webpack_require__(905);






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {
      if (!mergedTheme) {
        console.error(['Material-UI: You should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = Object(__WEBPACK_IMPORTED_MODULE_5__useTheme__["a" /* default */])();

  if (false) {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: You are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[__WEBPACK_IMPORTED_MODULE_6__nested__["a" /* default */]] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__["a" /* default */].Provider, {
    value: theme
  }, children);
}

 false ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

/* unused harmony default export */ var _unused_webpack_default_export = (ThemeProvider);

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__makeStyles__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getThemeProps__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useTheme__ = __webpack_require__(262);








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_6__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = Object(__WEBPACK_IMPORTED_MODULE_8__useTheme__["a" /* default */])() || defaultTheme;

        if (name) {
          more = Object(__WEBPACK_IMPORTED_MODULE_7__getThemeProps__["a" /* default */])({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: The `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0;

    if (false) {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 1851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(315);




function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["c" /* makeStyles */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
  }, options));
}

/* harmony default export */ __webpack_exports__["a"] = (makeStyles);

/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cssUtils__ = __webpack_require__(1853);



function responsiveFontSizes(themeInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$breakpoints = options.breakpoints,
      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
      _options$disableAlign = options.disableAlign,
      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
      _options$factor = options.factor,
      factor = _options$factor === void 0 ? 2 : _options$factor,
      _options$variants = options.variants,
      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;

  var theme = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, themeInput);

  theme.typography = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography);
  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).

  var convert = Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["b" /* convertLength */])(typography.htmlFontSize);
  var breakpointValues = breakpoints.map(function (x) {
    return theme.breakpoints.values[x];
  });
  variants.forEach(function (variant) {
    var style = typography[variant];
    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));

    if (remFontSize <= 1) {
      return;
    }

    var maxFontSize = remFontSize;
    var minFontSize = 1 + (maxFontSize - 1) / factor;
    var lineHeight = style.lineHeight;

    if (!Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["d" /* isUnitless */])(lineHeight) && !disableAlign) {
      throw new Error( false ? "Material-UI: Unsupported non-unitless line height with grid alignment.\nUse unitless line heights instead." : Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_utils__["b" /* formatMuiErrorMessage */])(6));
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["d" /* isUnitless */])(lineHeight)) {
      // make it unitless
      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
    }

    var transform = null;

    if (!disableAlign) {
      transform = function transform(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["a" /* alignProperty */])({
          size: value,
          grid: Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["c" /* fontGrid */])({
            pixels: 4,
            lineHeight: lineHeight,
            htmlFontSize: typography.htmlFontSize
          })
        });
      };
    }

    typography[variant] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["e" /* responsiveProperty */])({
      cssProperty: 'fontSize',
      min: minFontSize,
      max: maxFontSize,
      unit: 'rem',
      breakpoints: breakpointValues,
      transform: transform
    }));
  });
  return theme;
}

/***/ }),
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = isUnitless;
/* unused harmony export getUnit */
/* unused harmony export toUnitless */
/* harmony export (immutable) */ __webpack_exports__["b"] = convertLength;
/* harmony export (immutable) */ __webpack_exports__["a"] = alignProperty;
/* harmony export (immutable) */ __webpack_exports__["c"] = fontGrid;
/* harmony export (immutable) */ __webpack_exports__["e"] = responsiveProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);

function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
} // Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"

function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
} // Emulate the sass function "unitless"

function toUnitless(length) {
  return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length

function convertLength(baseFontSize) {
  return function (length, toUnit) {
    var fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.

    if (fromUnit === toUnit) {
      return length;
    } // Convert input length to pixels.


    var pxLength = toUnitless(length);

    if (fromUnit !== 'px') {
      if (fromUnit === 'em') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === 'rem') {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
        return length;
      }
    } // Convert length in pixels to the output unit


    var outputLength = pxLength;

    if (toUnit !== 'px') {
      if (toUnit === 'em') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === 'rem') {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }

    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty(_ref) {
  var size = _ref.size,
      grid = _ref.grid;
  var sizeBelow = size - size % grid;
  var sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height

function fontGrid(_ref2) {
  var lineHeight = _ref2.lineHeight,
      pixels = _ref2.pixels,
      htmlFontSize = _ref2.htmlFontSize;
  return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 *
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */

function responsiveProperty(_ref3) {
  var cssProperty = _ref3.cssProperty,
      min = _ref3.min,
      max = _ref3.max,
      _ref3$unit = _ref3.unit,
      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
      _ref3$breakpoints = _ref3.breakpoints,
      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
      _ref3$transform = _ref3.transform,
      transform = _ref3$transform === void 0 ? null : _ref3$transform;

  var output = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, "".concat(min).concat(unit));

  var factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(function (breakpoint) {
    var value = min + factor * breakpoint;

    if (transform !== null) {
      value = transform(value);
    }

    output["@media (min-width:".concat(breakpoint, "px)")] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
  });
  return output;
}

/***/ }),
/* 1854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultTheme__ = __webpack_require__(315);


var withTheme = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["h" /* withThemeCreator */])({
  defaultTheme: __WEBPACK_IMPORTED_MODULE_1__defaultTheme__["a" /* default */]
});
/* unused harmony default export */ var _unused_webpack_default_export = (withTheme);

/***/ }),
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(36);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("title", null, titleAccess) : null);
});
 false ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: chainPropTypes(PropTypes.oneOf(['default', 'inherit', 'large', 'medium', 'small']), function (props) {
    var fontSize = props.fontSize;

    if (fontSize === 'default') {
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    }

    return null;
  }),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon));

/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapse__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Paper__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AccordionContext__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useControlled__ = __webpack_require__(180);














var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var Accordion = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function Accordion(props, ref) {
  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_9__Collapse__["a" /* default */] : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useControlled__["a" /* default */])({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'Accordion',
    state: 'expanded'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var handleChange = __WEBPACK_IMPORTED_MODULE_4_react__["useCallback"](function (event) {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);

  var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_4_react__["Children"].toArray(childrenProp),
      _React$Children$toArr2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__["a" /* default */])(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__AccordionContext__["a" /* default */].Provider, {
    value: contextValue
  }, summary), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
 false ? Accordion.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion.
   */
  children: chainPropTypes(PropTypes.node.isRequired, function (props) {
    var summary = React.Children.toArray(props.children)[0];

    if (isFragment(summary)) {
      return new Error("Material-UI: The Accordion doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (! /*#__PURE__*/React.isValidElement(summary)) {
      return new Error('Material-UI: Expected the first child of Accordion to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, expands the accordion by default.
   */
  defaultExpanded: PropTypes.bool,

  /**
   * If `true`, the accordion will be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: PropTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The component used for the collapse effect.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAccordion'
})(Accordion));

/***/ }),
/* 1857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_transitions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_deprecatedPropType__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transitions_utils__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(570);














var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the root element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */
    hidden: {
      visibility: 'hidden'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Collapse = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Collapse(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      collapsedHeight = props.collapsedHeight,
      _props$collapsedSize = props.collapsedSize,
      collapsedSizeProp = _props$collapsedSize === void 0 ? '0px' : _props$collapsedSize,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? __WEBPACK_IMPORTED_MODULE_9__styles_transitions__["b" /* duration */].standard : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "collapsedHeight", "collapsedSize", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_12__styles_useTheme__["a" /* default */])();
  var timer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var wrapperRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var autoTransitionDuration = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === 'number' ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_13__utils__["useForkRef"])(ref, enableStrictModeCompat ? nodeRef : undefined);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = collapsedSize;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = "".concat(wrapperHeight, "px");

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(function (node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  var handleExit = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleExiting = normalizedTransitionCallback(function (node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps2 = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = collapsedSize;

    if (onExiting) {
      onExiting(node);
    }
  });

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.container, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedSize === '0px' && classes.hidden
      }[state]),
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        minHeight: collapsedSize
      }, style),
      ref: handleRef
    }, childProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
 false ? Collapse.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: chainPropTypes(PropTypes.object, function (props) {
    if (props.classes && props.classes.container) {
      throw new Error(['Material-UI: the classes.container key is deprecated.', 'Use `classes.root` instead', 'The name of the pseudo-class was changed for consistency.'].join('\n'));
    }

    return null;
  }),

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The height of the container when collapsed.
   * @deprecated The prop was renamed to support the addition of horizontal orientation, use `collapsedSize` instead.
   */
  collapsedHeight: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'The prop was renamed to support the vertical orientation, use `collapsedSize` instead'),

  /**
   * The height of the container when collapsed.
   */
  collapsedSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the passed `Component`.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Collapse.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCollapse'
})(Collapse));

/***/ }),
/* 1858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__ = __webpack_require__(1859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__ = __webpack_require__(1861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Transition__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_PropTypes__ = __webpack_require__(921);










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__["a" /* default */])(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__["a" /* default */])(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["classNames"]);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Transition__["d" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
/* harmony default export */ __webpack_exports__["a"] = (CSSTransition);

/***/ }),
/* 1859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasClass__ = __webpack_require__(1860);

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!Object(__WEBPACK_IMPORTED_MODULE_0__hasClass__["a" /* default */])(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),
/* 1860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasClass;
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),
/* 1861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClass;
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),
/* 1862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransitionGroup__ = __webpack_require__(922);






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);

    if (this.props[handler]) {
      var maybeNode = child.props.nodeRef ? undefined : __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);
      this.props[handler](maybeNode);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in"]);

    var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TransitionGroup__["a" /* default */], props, inProp ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ReplaceTransition.propTypes =  false ? {
  in: PropTypes.bool.isRequired,
  children: function children(props, propName) {
    if (React.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ReplaceTransition);

/***/ }),
/* 1863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getChildMapping;
/* unused harmony export mergeChildMappings */
/* harmony export (immutable) */ __webpack_exports__["b"] = getInitialChildMapping;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNextChildMapping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        in: false
      });
    } else if (hasNext && hasPrev && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Transition__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__ = __webpack_require__(573);


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(oldChildren) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */], null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child.
 *
 * **Note**: If you want the animation to happen simultaneously
 * (that is, to have the old child removed and a new child inserted **at the same time**),
 * you should use
 * [`TransitionGroup`](https://reactcommunity.org/react-transition-group/transition-group)
 * instead.
 *
 * ```jsx
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <CSSTransition
 *        key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade'
 *      >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </CSSTransition>
 *    </SwitchTransition>
 *  );
 * }
 * ```
 *
 * ```css
 * .fade-enter{
 *    opacity: 0;
 * }
 * .fade-exit{
 *    opacity: 1;
 * }
 * .fade-enter-active{
 *    opacity: 1;
 * }
 * .fade-exit-active{
 *    opacity: 0;
 * }
 * .fade-enter-active,
 * .fade-exit-active{
 *    transition: opacity 500ms;
 * }
 * ```
 */

var SwitchTransition = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */],
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */] && props.mode === modes.in) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]
      };
    }

    return {
      current: __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]:
        component = enterRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]:
        component = leaveRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */]:
        component = current;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__["a" /* default */].Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SwitchTransition.propTypes =  false ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out`: New element transitions in first, then when complete, the current element transitions out.
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component.
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* harmony default export */ __webpack_exports__["a"] = (SwitchTransition);

/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);







var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
 false ? Paper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: chainPropTypes(PropTypes.number, function (props) {
    var classes = props.classes,
        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning

    if (classes === undefined) {
      return null;
    }

    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
      return new Error("Material-UI: This elevation `".concat(elevation, "` is not implemented."));
    }

    return null;
  }),

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['elevation', 'outlined'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiPaper'
})(Paper));

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var AccordionActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function AccordionActions(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disableSpacing"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? AccordionActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAccordionActions'
})(AccordionActions));

/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var AccordionDetails = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function AccordionDetails(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? AccordionDetails.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion details.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAccordionDetails'
})(AccordionDetails));

/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconButton__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Accordion_AccordionContext__ = __webpack_require__(923);



/* eslint-disable jsx-a11y/aria-role */








var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused, &$focusVisible': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focused: {},

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var AccordionSummary = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function AccordionSummary(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$IconButtonProp = props.IconButtonProps,
      IconButtonProps = _props$IconButtonProp === void 0 ? {} : _props$IconButtonProp,
      onClick = props.onClick,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "expandIcon", "focusVisibleClassName", "IconButtonProps", "onClick"]);

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_9__Accordion_AccordionContext__["a" /* default */]),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, disabled && classes.disabled, expanded && classes.expanded),
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, classes.focused, focusVisibleClassName),
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? AccordionSummary.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the accordion summary.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: chainPropTypes(PropTypes.object, function (props) {
    // Guard against when generation of classes is disabled in the stylesheets (`disableGeneration`).
    // For `disableGeneration` we don't have an accurate warning but `disableGeneration` is an advanced use case anyway.
    if (props.classes.focused !== undefined && props.classes.focused.indexOf(' ') !== -1) {
      return new Error(['Material-UI: The `classes.focused` key is deprecated.', 'Use `classes.focusVisible` instead.', 'The name of the pseudo-class was changed for consistency.'].join('\n'));
    }

    return null;
  }),

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,

  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * Props applied to the `IconButton` element wrapping the expand icon.
   */
  IconButtonProps: PropTypes.object,

  /**
   * @ignore
   */
  onClick: PropTypes.func
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAccordionSummary'
})(AccordionSummary));

/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_deprecatedPropType__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useIsFocusVisible__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TouchRipple__ = __webpack_require__(1870);













var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  function getButtonNode() {
    // #StrictMode ready
    return __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](buttonRef.current);
  }

  var rippleRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useIsFocusVisible__["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](false);
  var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(buttonRefProp, ref);
  var handleOwnRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(focusVisibleRef, buttonRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(handleUserRef, handleOwnRef);

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (enableTouchRipple && !rippleRef.current) {
        console.error(['Material-UI: The `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
      }
    }, [enableTouchRipple]);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ComponentProp, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__TouchRipple__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
 false ? ButtonBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,

  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: deprecatedPropType(refType, 'Use `ref` instead.'),

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: PropTypes.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   */
  focusRipple: PropTypes.bool,

  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * @ignore
   */
  href: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,

  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,

  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButtonBase'
})(ButtonBase));

/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DELAY_RIPPLE */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Ripple__ = __webpack_require__(1871);









var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["center", "classes", "className"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](0);
  var rippleCallback = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var container = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(oldRipples), [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Ripple__["a" /* default */], {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react_transition_group__["TransitionGroup"], {
    component: null,
    exit: true
  }, ripples));
});
 false ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["memo"](TouchRipple)));

/***/ }),
/* 1871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__ = __webpack_require__(160);




var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"];
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = Object(__WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__["a" /* default */])(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span", {
    className: childClassName
  }));
}

 false ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,

  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Ripple);

/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(36);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(color))], disabled && classes.disabled, size === "small" && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.label
  }, children));
});
 false ? IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React.Children.toArray(props.children).some(function (child) {
      return /*#__PURE__*/React.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: You are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['start', 'end', false]),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(109);








var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0,
      '@media print': {
        // Prevent the app bar to be visible on each printed page.
        position: 'absolute'
      }
    },

    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      // ⚠️ sticky is not supported by IE 11.
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: 'static'
    },

    /* Styles applied to the root element if `position="relative"`. */
    positionRelative: {
      position: 'relative'
    },

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="transparent"`. */
    colorTransparent: {
      backgroundColor: 'transparent',
      color: 'inherit'
    }
  };
};
var AppBar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function AppBar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$position = props.position,
      position = _props$position === void 0 ? 'fixed' : _props$position,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "position"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    square: true,
    component: "header",
    elevation: 4,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["position".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(position))], classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], className, position === 'fixed' && 'mui-fixed'),
    ref: ref
  }, other));
});
 false ? AppBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),

  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAppBar'
})(AppBar));

/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_Person__ = __webpack_require__(1875);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      lineHeight: 1,
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },

    /* Styles applied to the root element if not `src` or `srcSet`. */
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `variant="circle"`. */
    circle: {},

    /* Styles applied to the root element if `variant="circular"`. */
    circular: {},

    /* Styles applied to the root element if `variant="rounded"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="square"`. */
    square: {
      borderRadius: 0
    },

    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE 11.
      objectFit: 'cover',
      // Hide alt text.
      color: 'transparent',
      // Hide the image broken icon, only works on Chrome.
      textIndent: 10000
    },

    /* Styles applied to the fallback icon */
    fallback: {
      width: '75%',
      height: '75%'
    }
  };
};

function useLoaded(_ref) {
  var src = _ref.src,
      srcSet = _ref.srcSet;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      loaded = _React$useState[0],
      setLoaded = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!src && !srcSet) {
      return undefined;
    }

    setLoaded(false);
    var active = true;
    var image = new Image();
    image.src = src;
    image.srcSet = srcSet;

    image.onload = function () {
      if (!active) {
        return;
      }

      setLoaded('loaded');
    };

    image.onerror = function () {
      if (!active) {
        return;
      }

      setLoaded('error');
    };

    return function () {
      active = false;
    };
  }, [src, srcSet]);
  return loaded;
}

var Avatar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Avatar(props, ref) {
  var alt = props.alt,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'circular' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);

  var children = null; // Use a hook instead of onError on the img element to support server-side rendering.

  var loaded = useLoaded({
    src: src,
    srcSet: srcSet
  });
  var hasImg = src || srcSet;
  var hasImgNotFailing = hasImg && loaded !== 'error';

  if (hasImgNotFailing) {
    children = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("img", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_Person__["a" /* default */], {
      className: classes.fallback
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
    ref: ref
  }, other), children);
});
 false ? Avatar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: PropTypes.string,

  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: chainPropTypes(PropTypes.object, function (props) {
    var classes = props.classes;

    if (classes == null) {
      return null;
    }

    if (classes.circle != null && // 2 classnames? one from withStyles the other must be custom
    classes.circle.split(' ').length > 1) {
      throw new Error("Material-UI: The `circle` class is deprecated. Use `circular` instead.");
    }

    return null;
  }),

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Attributes applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   */
  imgProps: PropTypes.object,

  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: PropTypes.string,

  /**
   * The `src` attribute for the `img` element.
   */
  src: PropTypes.string,

  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: PropTypes.string,

  /**
   * The shape of the avatar.
   */
  variant: chainPropTypes(PropTypes.oneOf(['circle', 'circular', 'rounded', 'square']), function (props) {
    var variant = props.variant;

    if (variant === 'circle') {
      throw new Error('Material-UI: `variant="circle"` is deprecated. Use `variant="circular"` instead.');
    }

    return null;
  })
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAvatar'
})(Avatar));

/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person'));

/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Fade__ = __webpack_require__(420);







var styles = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_6__Fade__["a" /* default */] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
 false ? Backdrop.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBackdrop'
})(Backdrop));

/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_transitions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transitions_utils__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(59);










var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5_react_transition_group__["Transition"] : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var foreignRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(children.ref, ref);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Fade.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(36);









var RADIUS_STANDARD = 10;
var RADIUS_DOT = 4;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      flexShrink: 0
    },

    /* Styles applied to the badge `span` element. */
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      boxSizing: 'border-box',
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      minWidth: RADIUS_STANDARD * 2,
      lineHeight: 1,
      padding: '0 6px',
      height: RADIUS_STANDARD * 2,
      borderRadius: RADIUS_STANDARD,
      zIndex: 1,
      // Render the badge on top of potential ripples.
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },

    /* Styles applied to the root element if `variant="dot"`. */
    dot: {
      borderRadius: RADIUS_DOT,
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
    anchorOriginTopRightRectangle: {
      top: 0,
      right: 0,
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangular"`. */
    anchorOriginTopRightRectangular: {
      top: 0,
      right: 0,
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
    anchorOriginBottomRightRectangle: {
      bottom: 0,
      right: 0,
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangular"`. */
    anchorOriginBottomRightRectangular: {
      bottom: 0,
      right: 0,
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
    anchorOriginTopLeftRectangle: {
      top: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangular"`. */
    anchorOriginTopLeftRectangular: {
      top: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
    anchorOriginBottomLeftRectangle: {
      bottom: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangular"`. */
    anchorOriginBottomLeftRectangular: {
      bottom: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
    anchorOriginTopRightCircle: {
      top: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circular"`. */
    anchorOriginTopRightCircular: {
      top: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
    anchorOriginBottomRightCircle: {
      bottom: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circular"`. */
    anchorOriginBottomRightCircular: {
      bottom: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
    anchorOriginTopLeftCircle: {
      top: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circular"`. */
    anchorOriginTopLeftCircular: {
      top: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
    anchorOriginBottomLeftCircle: {
      bottom: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circular"`. */
    anchorOriginBottomLeftCircular: {
      bottom: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
    invisible: {
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  };
};
var Badge = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Badge(props, ref) {
  var _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'right'
  } : _props$anchorOrigin,
      badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
      invisibleProp = props.invisible,
      _props$max = props.max,
      max = _props$max === void 0 ? 99 : _props$max,
      _props$overlap = props.overlap,
      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
      _props$showZero = props.showZero,
      showZero = _props$showZero === void 0 ? false : _props$showZero,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);

  var invisible = invisibleProp;

  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
    invisible = true;
  }

  var displayValue = '';

  if (variant !== 'dot') {
    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ComponentProp, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), children, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.badge, classes["".concat(anchorOrigin.horizontal).concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(anchorOrigin.vertical)).concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(anchorOrigin.horizontal)).concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(overlap))], color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
  }, displayValue));
});
 false ? Badge.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The anchor of the badge.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'right']).isRequired,
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes.node,

  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: chainPropTypes(PropTypes.object, function (props) {
    var classes = props.classes;

    if (classes == null) {
      return null;
    }

    [['anchorOriginTopRightRectangle', 'anchorOriginTopRightRectangular'], ['anchorOriginBottomRightRectangle', 'anchorOriginBottomRightRectangular'], ['anchorOriginTopLeftRectangle', 'anchorOriginTopLeftRectangular'], ['anchorOriginBottomLeftRectangle', 'anchorOriginBottomLeftRectangular'], ['anchorOriginTopRightCircle', 'anchorOriginTopRightCircular'], ['anchorOriginBottomRightCircle', 'anchorOriginBottomRightCircular'], ['anchorOriginTopLeftCircle', 'anchorOriginTopLeftCircular']].forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          deprecatedClassKey = _ref2[0],
          newClassKey = _ref2[1];

      if (classes[deprecatedClassKey] != null && // 2 classnames? one from withStyles the other must be custom
      classes[deprecatedClassKey].split(' ').length > 1) {
        throw new Error("Material-UI: The `".concat(deprecatedClassKey, "` class was deprecated. Use `").concat(newClassKey, "` instead."));
      }
    });
    return null;
  }),

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'error', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the badge will be invisible.
   */
  invisible: PropTypes.bool,

  /**
   * Max count to show.
   */
  max: PropTypes.number,

  /**
   * Wrapped shape the badge should overlap.
   */
  overlap: chainPropTypes(PropTypes.oneOf(['circle', 'rectangle', 'circular', 'rectangular']), function (props) {
    var _props$overlap2 = props.overlap,
        overlap = _props$overlap2 === void 0 ? 'rectangle' : _props$overlap2;

    if (overlap === 'rectangle') {
      throw new Error('Material-UI: `overlap="rectangle"` was deprecated. Use `overlap="rectangular"` instead.');
    }

    if (overlap === 'circle') {
      throw new Error('Material-UI: `overlap="circle"` was deprecated. Use `overlap="circular"` instead.');
    }

    return null;
  }),

  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   */
  showZero: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['dot', 'standard'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBadge'
})(Badge));

/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};
var BottomNavigation = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function BottomNavigation(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      onChange = props.onChange,
      _props$showLabels = props.showLabels,
      showLabels = _props$showLabels === void 0 ? false : _props$showLabels,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, childIndex) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  }));
});
 false ? BottomNavigation.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {any} value We default to the index of the child.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: PropTypes.bool,

  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBottomNavigation'
})(BottomNavigation));

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_unsupportedProp__ = __webpack_require__(417);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      padding: '6px 12px 8px',
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1',
      '&$iconOnly': {
        paddingTop: 16
      },
      '&$selected': {
        paddingTop: 6,
        color: theme.palette.primary.main
      }
    },

    /* Pseudo-class applied to the root element if selected. */
    selected: {},

    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
    iconOnly: {},

    /* Styles applied to the span element that wraps the icon and label. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label's span element. */
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      '&$iconOnly': {
        opacity: 0,
        transitionDelay: '0s'
      },
      '&$selected': {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
};
var BottomNavigationAction = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function BottomNavigationAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      icon = props.icon,
      label = props.label,
      onChange = props.onChange,
      onClick = props.onClick,
      selected = props.selected,
      showLabel = props.showLabel,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);

  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
    focusRipple: true,
    onClick: handleChange
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.wrapper
  }, icon, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
  }, label)));
});
 false ? BottomNavigationAction.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon element.
   */
  icon: PropTypes.node,

  /**
   * The label element.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   */
  showLabel: PropTypes.bool,

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBottomNavigationAction'
})(BottomNavigationAction));

/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styleFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_system__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_styled__ = __webpack_require__(917);


var styleFunction = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["l" /* styleFunctionSx */])(Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["a" /* borders */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["d" /* display */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["e" /* flexbox */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["f" /* grid */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["h" /* positions */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["g" /* palette */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["i" /* shadows */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["j" /* sizing */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["k" /* spacing */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["m" /* typography */]));
/**
 * @ignore - do not document.
 */

var Box = Object(__WEBPACK_IMPORTED_MODULE_1__styles_styled__["a" /* default */])('div')(styleFunction, {
  name: 'MuiBox'
});
/* harmony default export */ __webpack_exports__["a"] = (Box);

/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Typography__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BreadcrumbCollapsed__ = __webpack_require__(1884);










var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },

  /* Styles applied to the li element. */
  li: {},

  /* Styles applied to the separator element. */
  separator: {
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
  }
};

function insertSeparators(items, className, separator) {
  return items.reduce(function (acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("li", {
        "aria-hidden": true,
        key: "separator-".concat(index),
        className: className
      }, separator));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

var Breadcrumbs = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Breadcrumbs(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'nav' : _props$component,
      _props$expandText = props.expandText,
      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      expanded = _React$useState[0],
      setExpanded = _React$useState[1];

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
    var handleClickExpand = function handleClickExpand(event) {
      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
      // Let's keep the focus in the component after expanding.

      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');

      if (focusable) {
        focusable.focus();
      }
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {
        console.error(['Material-UI: You have provided an invalid combination of props to the Breadcrumbs.', "itemsAfterCollapse={".concat(itemsAfterCollapse, "} + itemsBeforeCollapse={").concat(itemsBeforeCollapse, "} >= maxItems={").concat(maxItems, "}")].join('\n'));
      }

      return allItems;
    }

    return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__BreadcrumbCollapsed__["a" /* default */], {
      "aria-label": expandText,
      key: "ellipsis",
      onClick: handleClickExpand
    })], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
  };

  var allItems = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].toArray(children).filter(function (child) {
    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](child);
  }).map(function (child, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    component: Component,
    color: "textSecondary",
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className)
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? Breadcrumbs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The breadcrumb children.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  expandText: PropTypes.string,

  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   */
  itemsAfterCollapse: PropTypes.number,

  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   */
  itemsBeforeCollapse: PropTypes.number,

  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   */
  maxItems: PropTypes.number,

  /**
   * Custom separator node.
   */
  separator: PropTypes.node
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBreadcrumbs'
})(Breadcrumbs));

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(36);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(align))], display !== 'initial' && classes["display".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(display))]),
    ref: ref
  }, other));
});
 false ? Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * Overrides the behavior of the `variantMapping` prop.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTypography'
})(Typography));

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_MoreHoriz__ = __webpack_require__(1885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(76);









var styles = function styles(theme) {
  return {
    root: {
      display: 'flex',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:active': {
        boxShadow: theme.shadows[0],
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_5__styles_colorManipulator__["c" /* emphasize */])(theme.palette.grey[200], 0.12)
      }
    },
    icon: {
      width: 24,
      height: 16
    }
  };
};
/**
 * @ignore - internal component.
 */


function BreadcrumbCollapsed(props) {
  var classes = props.classes,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "li",
    className: classes.root,
    focusRipple: true
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_MoreHoriz__["a" /* default */], {
    className: classes.icon
  }));
}

 false ? BreadcrumbCollapsed.propTypes = {
  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateBreadcrumbCollapsed'
})(BreadcrumbCollapsed));

/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(36);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["a" /* alpha */])(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.startIcon, classes["iconSize".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))])
  }, startIconProp);
  var endIcon = endIconProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.endIcon, classes["iconSize".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))])
  }, endIconProp);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))], classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
 false ? Button.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, no elevation is used.
   */
  disableElevation: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,

  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(['button', 'reset', 'submit']), PropTypes.string]),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButton'
})(Button));

/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(575);









 // Force a side effect so we don't have any override priority issue.
// eslint-disable-next-line no-unused-expressions

__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */].styles;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      boxShadow: theme.shadows[2]
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none'
    },

    /* Pseudo-class applied to child elements if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the children. */
    grouped: {
      minWidth: 40
    },

    /* Styles applied to the children if `orientation="horizontal"`. */
    groupedHorizontal: {
      '&:not(:first-child)': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },

    /* Styles applied to the children if `orientation="vertical"`. */
    groupedVertical: {
      '&:not(:first-child)': {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    },

    /* Styles applied to the children if `variant="text"`. */
    groupedText: {},

    /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */
    groupedTextHorizontal: {
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
      }
    },

    /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */
    groupedTextVertical: {
      '&:not(:last-child)': {
        borderBottom: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
      }
    },

    /* Styles applied to the children if `variant="text"` and `color="primary"`. */
    groupedTextPrimary: {
      '&:not(:last-child)': {
        borderColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, 0.5)
      }
    },

    /* Styles applied to the children if `variant="text"` and `color="secondary"`. */
    groupedTextSecondary: {
      '&:not(:last-child)': {
        borderColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, 0.5)
      }
    },

    /* Styles applied to the children if `variant="outlined"`. */
    groupedOutlined: {},

    /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */
    groupedOutlinedHorizontal: {
      '&:not(:first-child)': {
        marginLeft: -1
      },
      '&:not(:last-child)': {
        borderRightColor: 'transparent'
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */
    groupedOutlinedVertical: {
      '&:not(:first-child)': {
        marginTop: -1
      },
      '&:not(:last-child)': {
        borderBottomColor: 'transparent'
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */
    groupedOutlinedPrimary: {
      '&:hover': {
        borderColor: theme.palette.primary.main
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
    groupedOutlinedSecondary: {
      '&:hover': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the children if `variant="contained"`. */
    groupedContained: {
      boxShadow: 'none'
    },

    /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */
    groupedContainedHorizontal: {
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.grey[400]),
        '&$disabled': {
          borderRight: "1px solid ".concat(theme.palette.action.disabled)
        }
      }
    },

    /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */
    groupedContainedVertical: {
      '&:not(:last-child)': {
        borderBottom: "1px solid ".concat(theme.palette.grey[400]),
        '&$disabled': {
          borderBottom: "1px solid ".concat(theme.palette.action.disabled)
        }
      }
    },

    /* Styles applied to the children if `variant="contained"` and `color="primary"`. */
    groupedContainedPrimary: {
      '&:not(:last-child)': {
        borderColor: theme.palette.primary.dark
      }
    },

    /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */
    groupedContainedSecondary: {
      '&:not(:last-child)': {
        borderColor: theme.palette.secondary.dark
      }
    }
  };
};
var ButtonGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ButtonGroup(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"]);

  var buttonClassName = Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.grouped, classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(orientation))], classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant))], classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant)).concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(orientation))], classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant)).concat(color !== 'default' ? Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color) : '')], disabled && classes.disabled);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "group",
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, fullWidth && classes.fullWidth, disableElevation && classes.disableElevation, variant === 'contained' && classes.contained, orientation === 'vertical' && classes.vertical),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The ButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(buttonClassName, child.props.className),
      color: child.props.color || color,
      disabled: child.props.disabled || disabled,
      disableElevation: child.props.disableElevation || disableElevation,
      disableFocusRipple: disableFocusRipple,
      disableRipple: disableRipple,
      fullWidth: fullWidth,
      size: child.props.size || size,
      variant: child.props.variant || variant
    });
  }));
});
 false ? ButtonGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button group.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the buttons will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, no elevation is used.
   */
  disableElevation: PropTypes.bool,

  /**
   * If `true`, the button keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the button ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the buttons will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The group orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['contained', 'outlined', 'text'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButtonGroup'
})(ButtonGroup));

/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Paper__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);







var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
var Card = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Card(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$raised = props.raised,
      raised = _props$raised === void 0 ? false : _props$raised,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "raised"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    elevation: raised ? 8 : 1,
    ref: ref
  }, other));
});
 false ? Card.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the card will use raised styling.
   */
  raised: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCard'
})(Card));

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(76);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      textAlign: 'inherit',
      width: '100%',
      '&:hover $focusHighlight': {
        opacity: theme.palette.action.hoverOpacity
      },
      '&$focusVisible $focusHighlight': {
        opacity: 0.12
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
    focusHighlight: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit',
      opacity: 0,
      backgroundColor: 'currentcolor',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.short
      })
    }
  };
};
var CardActionArea = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardActionArea(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      focusVisibleClassName = props.focusVisibleClassName,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "focusVisibleClassName"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(focusVisibleClassName, classes.focusVisible),
    ref: ref
  }, other), children, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.focusHighlight
  }));
});
 false ? CardActionArea.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardActionArea'
})(CardActionArea));

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var CardActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? CardActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardActions'
})(CardActions));

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = {
  /* Styles applied to the root element. */
  root: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  }
};
var CardContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? CardContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardContent'
})(CardContent));

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(110);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 16
  },

  /* Styles applied to the avatar element. */
  avatar: {
    flex: '0 0 auto',
    marginRight: 16
  },

  /* Styles applied to the action element. */
  action: {
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -8,
    marginRight: -8
  },

  /* Styles applied to the content wrapper element. */
  content: {
    flex: '1 1 auto'
  },

  /* Styles applied to the title Typography element. */
  title: {},

  /* Styles applied to the subheader Typography element. */
  subheader: {}
};
var CardHeader = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardHeader(props, ref) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      subheaderProp = props.subheader,
      subheaderTypographyProps = props.subheaderTypographyProps,
      titleProp = props.title,
      titleTypographyProps = props.titleTypographyProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);

  var title = titleProp;

  if (title != null && title.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    title = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: avatar ? 'body2' : 'h5',
      className: classes.title,
      component: "span",
      display: "block"
    }, titleTypographyProps), title);
  }

  var subheader = subheaderProp;

  if (subheader != null && subheader.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    subheader = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: avatar ? 'body2' : 'body1',
      className: classes.subheader,
      color: "textSecondary",
      component: "span",
      display: "block"
    }, subheaderTypographyProps), subheader);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), avatar && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.avatar
  }, avatar), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.content
  }, title, subheader), action && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.action
  }, action));
});
 false ? CardHeader.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display in the card header.
   */
  action: PropTypes.node,

  /**
   * The Avatar for the Card Header.
   */
  avatar: PropTypes.node,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * The content of the component.
   */
  subheader: PropTypes.node,

  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: PropTypes.object,

  /**
   * The content of the Card Title.
   */
  title: PropTypes.node,

  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardHeader'
})(CardHeader));

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(20);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },

  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
  media: {
    width: '100%'
  },

  /* Styles applied to the root element if `component="picture or img"`. */
  img: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover'
  }
};
var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
var CardMedia = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CardMedia(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      image = props.image,
      src = props.src,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "image", "src", "style"]);

  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    backgroundImage: "url(\"".concat(image, "\")")
  }, style) : style;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, isMediaComponent && classes.media, "picture img".indexOf(Component) !== -1 && classes.img),
    ref: ref,
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined
  }, other), children);
});
 false ? CardMedia.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    if (!props.children && !props.image && !props.src && !props.component) {
      return new Error('Material-UI: Either `children`, `image`, `src` or `component` prop must be specified.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: PropTypes.string,

  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: PropTypes.string,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardMedia'
})(CardMedia));

/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_CheckBoxOutlineBlank__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_CheckBox__ = __webpack_require__(1896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_svg_icons_IndeterminateCheckBox__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_withStyles__ = __webpack_require__(8);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_CheckBox__["a" /* default */], null);
var defaultIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_CheckBoxOutlineBlank__["a" /* default */], null);
var defaultIndeterminateIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__internal_svg_icons_IndeterminateCheckBox__["a" /* default */], null);
var Checkbox = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Checkbox(props, ref) {
  var _props$checkedIcon = props.checkedIcon,
      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$icon = props.icon,
      iconProp = _props$icon === void 0 ? defaultIcon : _props$icon,
      _props$indeterminate = props.indeterminate,
      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
      _props$indeterminateI = props.indeterminateIcon,
      indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
      inputProps = props.inputProps,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);

  var icon = indeterminate ? indeterminateIconProp : iconProp;
  var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    type: "checkbox",
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_11__utils_capitalize__["a" /* default */])(color))], indeterminate && classes.indeterminate),
      checked: classes.checked,
      disabled: classes.disabled
    },
    color: color,
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](icon, {
      fontSize: icon.props.fontSize === undefined && size === "small" ? size : icon.props.fontSize
    }),
    checkedIcon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](indeterminateIcon, {
      fontSize: indeterminateIcon.props.fontSize === undefined && size === "small" ? size : indeterminateIcon.props.fontSize
    }),
    ref: ref
  }, other));
});
 false ? Checkbox.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * If `true`, the checkbox will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: PropTypes.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: PropTypes.node,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the checkbox.
   * `small` is equivalent to the dense checkbox styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_12__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCheckbox'
})(Checkbox));

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));

/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_Cancel__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_unsupportedProp__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonBase__ = __webpack_require__(76);












var styles = function styles(theme) {
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: 32 / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '& $avatar': {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      '& $avatarColorPrimary': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      '& $avatarColorSecondary': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      '& $avatarSmall': {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* emphasize */])(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1]
      }
    },

    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* emphasize */])(theme.palette.primary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* emphasize */])(theme.palette.secondary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* emphasize */])(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* emphasize */])(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* emphasize */])(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      '& $avatar': {
        marginLeft: 4
      },
      '& $avatarSmall': {
        marginLeft: 2
      },
      '& $icon': {
        marginLeft: 4
      },
      '& $iconSmall': {
        marginLeft: 2
      },
      '& $deleteIcon': {
        marginRight: 5
      },
      '& $deleteIconSmall': {
        marginRight: 3
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },
    // TODO v5: remove

    /* Styles applied to the `avatar` element. */
    avatar: {},

    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},

    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},

    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},

    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },

    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },

    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: 'inherit'
    },

    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: 'inherit'
    },

    /* Styles applied to the label `span` element. */
    label: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the label `span` element if `size="small"`. */
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      height: 22,
      width: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.main
      }
    }
  };
};

function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


var Chip = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Chip(props, ref) {
  var avatarProp = props.avatar,
      classes = props.classes,
      className = props.className,
      clickableProp = props.clickable,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      ComponentProp = props.component,
      deleteIconProp = props.deleteIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconProp = props.icon,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);

  var chipRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(chipRef, ref);

  var handleDeleteIconClick = function handleDeleteIconClick(event) {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === 'small';
  var Component = ComponentProp || (clickable ? __WEBPACK_IMPORTED_MODULE_11__ButtonBase__["a" /* default */] : 'div');
  var moreProps = Component === __WEBPACK_IMPORTED_MODULE_11__ButtonBase__["a" /* default */] ? {
    component: 'div'
  } : {};
  var deleteIcon = null;

  if (onDelete) {
    var customClasses = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))] : classes["deleteIconOutlinedColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](deleteIconProp) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](deleteIconProp, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_Cancel__["a" /* default */], {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  var avatar = null;

  if (avatarProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](avatarProp)) {
    avatar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](avatarProp, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))])
    });
  }

  var icon = null;

  if (iconProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](iconProp)) {
    icon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](iconProp, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))])
    });
  }

  if (false) {
    if (avatar && icon) {
      console.error('Material-UI: The Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: clickable || onDelete ? 'button' : undefined,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && [classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))], clickable && classes["clickableColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))], onDelete && classes["deletableColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))]], variant !== "default" && [classes.outlined, {
      'primary': classes.outlinedPrimary,
      'secondary': classes.outlinedSecondary
    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
    "aria-disabled": disabled ? true : undefined,
    tabIndex: clickable || onDelete ? 0 : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), avatar || icon, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, small && classes.labelSmall)
  }, label), deleteIcon);
});
 false ? Chip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Avatar element.
   */
  avatar: PropTypes.element,

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If false, the chip will not be clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   */
  clickable: PropTypes.bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,

  /**
   * If `true`, the chip should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * Icon element.
   */
  icon: PropTypes.element,

  /**
   * The content of the label.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The size of the chip.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['default', 'outlined'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiChip'
})(Chip));

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel'));

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(36);








var SIZE = 44;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("circle", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
 false ? CircularProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: You have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The thickness of the circle.
   */
  thickness: PropTypes.number,

  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: chainPropTypes(PropTypes.oneOf(['determinate', 'indeterminate', 'static']), function (props) {
    var variant = props.variant;

    if (variant === 'static') {
      throw new Error('Material-UI: `variant="static"` was deprecated. Use `variant="determinate"` instead.');
    }

    return null;
  })
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress));

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_useEventCallback__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(20);








function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event) {
  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */


function ClickAwayListener(props) {
  var children = props.children,
      _props$disableReactTr = props.disableReactTree,
      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
      _props$mouseEvent = props.mouseEvent,
      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
      onClickAway = props.onClickAway,
      _props$touchEvent = props.touchEvent,
      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
  var movedRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](false);
  var nodeRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var activatedRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](false);
  var syntheticEventRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](false);
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(function () {
      activatedRef.current = true;
    }, 0);
    return function () {
      activatedRef.current = false;
    };
  }, []); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    // #StrictMode ready
    nodeRef.current = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviours like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  var handleClickAway = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useEventCallback__["a" /* default */])(function (event) {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(nodeRef.current);
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
    return function (event) {
      syntheticEventRef.current = true;
      var childrenPropsHandler = children.props[handlerName];

      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };
  };

  var childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(nodeRef.current);

      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return function () {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, childrenProps));
}

 false ? ClickAwayListener.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The wrapped element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   */
  disableReactTree: PropTypes.bool,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: PropTypes.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: PropTypes.oneOf(['onTouchEnd', 'onTouchStart', false])
} : void 0;

if (false) {
  // eslint-disable-next-line
  ClickAwayListener['propTypes' + ''] = exactProp(ClickAwayListener.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (ClickAwayListener);

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(36);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: 'block'
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Container(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(String(maxWidth)))]),
    ref: ref
  }, other));
});
 false ? Container.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   */
  fixed: PropTypes.bool,

  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiContainer'
})(Container));

/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export html */
/* unused harmony export body */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(20);





var html = {
  WebkitFontSmoothing: 'antialiased',
  // Antialiasing.
  MozOsxFontSmoothing: 'grayscale',
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: 'border-box'
};
var body = function body(theme) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    color: theme.palette.text.primary
  }, theme.typography.body2, {
    backgroundColor: theme.palette.background.default,
    '@media print': {
      // Save printer ink.
      backgroundColor: theme.palette.common.white
    }
  });
};
var styles = function styles(theme) {
  return {
    '@global': {
      html: html,
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      'strong, b': {
        fontWeight: theme.typography.fontWeightBold
      },
      body: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        margin: 0
      }, body(theme), {
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        '&::backdrop': {
          backgroundColor: theme.palette.background.default
        }
      })
    }
  };
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

function CssBaseline(props) {
  /* eslint-disable no-unused-vars */
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      classes = props.classes;
  /* eslint-enable no-unused-vars */

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, children);
}

 false ? CssBaseline.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * You can wrap a node.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object
} : void 0;

if (false) {
  // eslint-disable-next-line
  CssBaseline['propTypes' + ''] = exactProp(CssBaseline.propTypes);
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_3__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCssBaseline'
})(CssBaseline));

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_deprecatedPropType__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Modal__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Backdrop__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Fade__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_transitions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Paper__ = __webpack_require__(109);














var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
      }
    },

    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE 11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE 11

    },

    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0,
        maxWidth: '100%'
      }
    }
  };
};
var defaultTransitionDuration = {
  enter: __WEBPACK_IMPORTED_MODULE_12__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_12__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

var Dialog = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Dialog(props, ref) {
  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_13__Paper__["a" /* default */] : _props$PaperComponent,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_11__Fade__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      ariaDescribedby = props['aria-describedby'],
      ariaLabelledby = props['aria-labelledby'],
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);

  var mouseDownTarget = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();

  var handleMouseDown = function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    if (event.target !== event.currentTarget) {
      return;
    } // Make sure the event starts and ends on the same DOM element.


    if (event.target !== mouseDownTarget.current) {
      return;
    }

    mouseDownTarget.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    BackdropComponent: __WEBPACK_IMPORTED_MODULE_10__Backdrop__["a" /* default */],
    BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      transitionDuration: transitionDuration
    }, BackdropProps),
    closeAfterTransition: true
  }, disableBackdropClick ? {
    disableBackdropClick: disableBackdropClick
  } : {}, {
    disableEscapeKeyDown: disableEscapeKeyDown,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    role: "none presentation"
  }, TransitionProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.container, classes["scroll".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(scroll))]),
    onMouseUp: handleBackdropClick,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](PaperComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.paper, classes["paperScroll".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(scroll))], classes["paperWidth".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
  }), children))));
});
 false ? Dialog.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  'aria-describedby': PropTypes.string,

  /**
   * The id(s) of the element(s) that label the dialog.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   * @deprecated Use the onClose prop with the `reason` argument to filter the `backdropClick` events.
   */
  disableBackdropClick: deprecatedPropType(PropTypes.bool, 'Use the onClose prop with the `reason` argument to filter the `backdropClick` events.'),

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: PropTypes.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: PropTypes.bool,

  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),

  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the onClose prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `backdropClick` events.'),

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the dialog enters.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the dialog has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the dialog is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   * @deprecated Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.
   */
  onEscapeKeyDown: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.'),

  /**
   * Callback fired before the dialog exits.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the dialog has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the dialog is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the Dialog is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: PropTypes.oneOf(['body', 'paper']),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialog'
})(Dialog));

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_deprecatedPropType__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Portal__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_useEventCallback__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_zIndex__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ModalManager__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Unstable_TrapFocus__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SimpleBackdrop__ = __webpack_require__(1908);


















function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return __WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"](container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new __WEBPACK_IMPORTED_MODULE_14__ModalManager__["b" /* default */]();
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Modal(inProps, ref) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["f" /* useTheme */])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["b" /* getThemeProps */])({
    name: 'MuiModal',
    props: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? __WEBPACK_IMPORTED_MODULE_16__SimpleBackdrop__["a" /* default */] : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({});
  var mountNodeRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var modalRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useForkRef__["a" /* default */])(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = Object(__WEBPACK_IMPORTED_MODULE_12__utils_useEventCallback__["a" /* default */])(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = Object(__WEBPACK_IMPORTED_MODULE_12__utils_useEventCallback__["a" /* default */])(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_14__ModalManager__["a" /* ariaHidden */])(modalRef.current, true);
    }
  });
  var handleClose = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    manager.remove(getModal());
  }, [manager]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  var inlineStyle = styles(theme || {
    zIndex: __WEBPACK_IMPORTED_MODULE_13__styles_zIndex__["a" /* default */]
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleEnter, children.props.onEnter);
    childProps.onExited = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleExited, children.props.onExited);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Portal__["a" /* default */], {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](BackdropComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Unstable_TrapFocus__["a" /* default */], {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](children, childProps))));
});
 false ? Modal.propTypes = {
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: PropTypes.object,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: PropTypes.bool,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, clicking the backdrop will not fire `onClose`.
   */
  disableBackdropClick: deprecatedPropType(PropTypes.bool, 'Use the onClose prop with the `reason` argument to filter the `backdropClick` events.'),

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire `onClose`.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Disable the scroll lock behavior.
   */
  disableScrollLock: PropTypes.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: PropTypes.bool,

  /**
   * @ignore
   */
  manager: PropTypes.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `backdropClick` events.'),

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: deprecatedPropType(PropTypes.func, 'Use the onClose prop with the `reason` argument to handle the `escapeKeyDown` events.'),

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` prop took effect.
   *
   * This prop will be removed in v5, the ref can be used instead.
   */
  onRendered: deprecatedPropType(PropTypes.func, 'Use the ref instead.'),

  /**
   * If `true`, the modal is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_deprecatedPropType__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_setRef__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useForkRef__ = __webpack_require__(59);








function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](container);
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_6__utils_useForkRef__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](children) ? children.ref : null, ref);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_setRef__["a" /* default */])(ref, mountNode);
      return function () {
        Object(__WEBPACK_IMPORTED_MODULE_5__utils_setRef__["a" /* default */])(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"](children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"](children, mountNode) : mountNode;
});
 false ? Portal.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be removed in v5, the ref can be used instead.
   * @deprecated Use the ref instead.
   */
  onRendered: deprecatedPropType(PropTypes.func, 'Use the ref instead.')
} : void 0;

if (false) {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */






/**
 * Utility component that locks focus inside the component.
 */

function Unstable_TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  var sentinelStart = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var sentinelEnd = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var nodeToRestore = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  var rootRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (instance) {
    // #StrictMode ready
    rootRef.current = __WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef);
  var prevOpenRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    prevOpenRef.current = open;
  }, [open]);

  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
    // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (!open) {
      return;
    }

    var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {
          console.error(['Material-UI: The modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](children, {
    ref: handleRef
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}

 false ? Unstable_TrapFocus.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.node,

  /**
   * If `true`, the trap focus will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any trap focus children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not prevent focus from leaving the trap focus while open.
   *
   * Generally this should never be set to `true` as it makes the trap focus less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, the trap focus will not restore focus to previously focused element once
   * trap focus is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Return the document to consider.
   * We use it to implement the restore focus between different browser documents.
   */
  getDoc: PropTypes.func.isRequired,

  /**
   * Do we still want to enforce the focus?
   * This prop helps nesting TrapFocus elements.
   */
  isEnabled: PropTypes.func.isRequired,

  /**
   * If `true`, focus will be locked.
   */
  open: PropTypes.bool.isRequired
} : void 0;

if (false) {
  // eslint-disable-next-line
  Unstable_TrapFocus['propTypes' + ''] = exactProp(Unstable_TrapFocus.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Unstable_TrapFocus);

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
/**
 * @ignore - internal component.
 */

var SimpleBackdrop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["invisible", "open"]);

  return open ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles.root, invisible ? styles.invisible : {}, other.style)
  })) : null;
});
 false ? SimpleBackdrop.propTypes = {
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (SimpleBackdrop);

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var DialogActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function DialogActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? DialogActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogActions'
})(DialogActions));

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      overflowY: 'auto',
      padding: '8px 24px',
      '&:first-child': {
        // dialog without title
        paddingTop: 20
      }
    },

    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: '16px 24px',
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
};
var DialogContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function DialogContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$dividers = props.dividers,
      dividers = _props$dividers === void 0 ? false : _props$dividers,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "dividers"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dividers && classes.dividers),
    ref: ref
  }, other));
});
 false ? DialogContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display the top and bottom dividers.
   */
  dividers: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogContent'
})(DialogContent));

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Typography__ = __webpack_require__(110);





var styles = {
  /* Styles applied to the root element. */
  root: {
    marginBottom: 12
  }
};
var DialogContentText = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"](function DialogContentText(props, ref) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref: ref
  }, props));
});
 false ? DialogContentText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_3__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogContentText'
})(DialogContentText));

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(110);







var styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '16px 24px',
    flex: '0 0 auto'
  }
};
var DialogTitle = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function DialogTitle(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "disableTypography"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), disableTypography ? children : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], {
    component: "h2",
    variant: "h6"
  }, children));
});
 false ? DialogTitle.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle));

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__ = __webpack_require__(71);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["a" /* alpha */])(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: '100%',
      width: 1
    },

    /* Styles applied to the root element if `flexItem={true}`. */
    flexItem: {
      alignSelf: 'stretch',
      height: 'auto'
    }
  };
};
var Divider = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Divider(props, ref) {
  var _props$absolute = props.absolute,
      absolute = _props$absolute === void 0 ? false : _props$absolute,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'hr' : _props$component,
      _props$flexItem = props.flexItem,
      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$role = props.role,
      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
    role: role,
    ref: ref
  }, other));
});
 false ? Divider.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Absolutely position the element.
   */
  absolute: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   */
  flexItem: PropTypes.bool,

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: PropTypes.bool,

  /**
   * The divider orientation.
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['fullWidth', 'inset', 'middle'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDivider'
})(Divider));

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setTranslateValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_debounce__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_transitions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transitions_utils__ = __webpack_require__(265);











 // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `none`.`

function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}

function setTranslateValue(direction, node) {
  var transform = getTranslateValue(direction, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Slide = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Slide(props, ref) {
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'down' : _props$direction,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_6_react_transition_group__["Transition"] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_9__styles_useTheme__["a" /* default */])();
  var childrenRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  /**
   * used in cloneElement(children, { ref: handleRef })
   */

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    childrenRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRefIntermediary = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(handleRefIntermediary, ref);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (isAppearing) {
      if (callback) {
        // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
        if (isAppearing === undefined) {
          callback(childrenRef.current);
        } else {
          callback(childrenRef.current, isAppearing);
        }
      }
    };
  };

  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    setTranslateValue(direction, node);
    Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["b" /* reflow */])(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function (node, isAppearing) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" /* getTransitionProps */])({
      timeout: timeout,
      style: style
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.transition = theme.transitions.create('transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" /* getTransitionProps */])({
      timeout: timeout,
      style: style
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    node.style.transition = theme.transitions.create('transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    setTranslateValue(direction, node);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(function (node) {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });
  var updatePosition = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current);
    }
  }, [direction]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_5__utils_debounce__["a" /* default */])(function () {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    appear: true,
    in: inProp,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: handleRef,
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, style, children.props.style)
    }, childProps));
  });
});
 false ? Slide.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: elementAcceptingRef,

  /**
   * Direction the child node will enter from.
   */
  direction: PropTypes.oneOf(['down', 'left', 'right', 'up']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Slide);

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapse__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Paper__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ExpansionPanelContext__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useControlled__ = __webpack_require__(180);














var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var warnedOnce = false;
/**
 * ⚠️ The ExpansionPanel component was renamed to Accordion to use a more common naming convention.
 *
 * You should use `import { Accordion } from '@material-ui/core'`
 * or `import Accordion from '@material-ui/core/Accordion'`.
 */

var ExpansionPanel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function ExpansionPanel(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanel component was renamed to Accordion to use a more common naming convention.', '', "You should use `import { Accordion } from '@material-ui/core'`", "or `import Accordion from '@material-ui/core/Accordion'`"].join('\n'));
    }
  }

  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_9__Collapse__["a" /* default */] : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useControlled__["a" /* default */])({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'ExpansionPanel',
    state: 'expanded'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var handleChange = __WEBPACK_IMPORTED_MODULE_4_react__["useCallback"](function (event) {
    setExpandedState(!expanded);

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);

  var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_4_react__["Children"].toArray(childrenProp),
      _React$Children$toArr2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__["a" /* default */])(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ExpansionPanelContext__["a" /* default */].Provider, {
    value: contextValue
  }, summary), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
 false ? ExpansionPanel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the expansion panel.
   */
  children: chainPropTypes(PropTypes.node.isRequired, function (props) {
    var summary = React.Children.toArray(props.children)[0];

    if (isFragment(summary)) {
      return new Error("Material-UI: The ExpansionPanel doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (! /*#__PURE__*/React.isValidElement(summary)) {
      return new Error('Material-UI: Expected the first child of ExpansionPanel to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: PropTypes.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: PropTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {boolean} expanded The `expanded` state of the panel.
   */
  onChange: PropTypes.func,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,

  /**
   * The component used for the collapse effect.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel));

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var warnedOnce = false;
/**
 * ⚠️ The ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.
 *
 * You should use `import { AccordionActions } from '@material-ui/core'`
 * or `import AccordionActions from '@material-ui/core/AccordionActions'`.
 */

var ExpansionPanelActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ExpansionPanelActions(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanelActions component was renamed to AccordionActions to use a more common naming convention.', '', "You should use `import { AccordionActions } from '@material-ui/core'`", "or `import AccordionActions from '@material-ui/core/AccordionActions'`"].join('\n'));
    }
  }

  var classes = props.classes,
      className = props.className,
      _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disableSpacing"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? ExpansionPanelActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanelActions'
})(ExpansionPanelActions));

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var warnedOnce = false;
/**
 * ⚠️ The ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.
 *
 * You should use `import { AccordionDetails } from '@material-ui/core'`
 * or `import AccordionDetails from '@material-ui/core/AccordionDetails'`.
 */

var ExpansionPanelDetails = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ExpansionPanelDetails(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanelDetails component was renamed to AccordionDetails to use a more common naming convention.', '', "You should use `import { AccordionDetails } from '@material-ui/core'`", "or `import AccordionDetails from '@material-ui/core/AccordionActions'`"].join('\n'));
    }
  }

  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? ExpansionPanelDetails.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the expansion panel details.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails));

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IconButton__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ExpansionPanel_ExpansionPanelContext__ = __webpack_require__(955);



/* eslint-disable jsx-a11y/aria-role */







var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: theme.spacing(0, 2),
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.action.focus
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var warnedOnce = false;
/**
 * ⚠️ The ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.
 *
 * You should use `import { AccordionSummary } from '@material-ui/core'`
 * or `import AccordionSummary from '@material-ui/core/AccordionSummary'`.
 */

var ExpansionPanelSummary = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ExpansionPanelSummary(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: the ExpansionPanelSummary component was renamed to AccordionSummary to use a more common naming convention.', '', "You should use `import { AccordionSummary } from '@material-ui/core'`", "or `import AccordionSummary from '@material-ui/core/AccordionSummary'`"].join('\n'));
    }
  }

  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      IconButtonProps = props.IconButtonProps,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocusVisible = props.onFocusVisible,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      focusedState = _React$useState[0],
      setFocusedState = _React$useState[1];

  var handleFocusVisible = function handleFocusVisible(event) {
    setFocusedState(true);

    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocusedState(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_8__ExpansionPanel_ExpansionPanelContext__["a" /* default */]),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? ExpansionPanelSummary.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the expansion panel summary.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,

  /**
   * Props applied to the `IconButton` element wrapping the expand icon.
   */
  IconButtonProps: PropTypes.object,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary));

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(36);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, {
      boxSizing: 'border-box',
      minHeight: 36,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      },
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        },
        textDecoration: 'none'
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    primary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    secondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="extended"`. */
    extended: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minHeight: 'auto',
      minWidth: 48,
      height: 48,
      '&$sizeSmall': {
        width: 'auto',
        padding: '0 8px',
        borderRadius: 34 / 2,
        minWidth: 34,
        height: 34
      },
      '&$sizeMedium': {
        width: 'auto',
        padding: '0 16px',
        borderRadius: 40 / 2,
        minWidth: 40,
        height: 40
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `size="small"``. */
    sizeSmall: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="medium"``. */
    sizeMedium: {
      width: 48,
      height: 48
    }
  };
};
var Fab = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Fab(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$size = props.size,
      size = _props$size === void 0 ? 'large' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'circular' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, size !== 'large' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))], disabled && classes.disabled, variant === 'extended' && classes.extended, {
      'primary': classes.primary,
      'secondary': classes.secondary,
      'inherit': classes.colorInherit
    }[color]),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.label
  }, children));
});
 false ? Fab.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button.
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The variant to use.
   * 'round' is deprecated, use 'circular' instead.
   */
  variant: chainPropTypes(PropTypes.oneOf(['extended', 'circular', 'round']), function (props) {
    if (props.variant === 'round') {
      throw new Error('Material-UI: variant="round" was renamed variant="circular" for consistency.');
    }

    return null;
  })
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFab'
})(Fab));

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      '&$marginDense': {
        paddingTop: 23,
        paddingBottom: 6
      }
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },

    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      '&$inputMarginDense': {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FilledInput(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? FilledInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
FilledInput.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFilledInput'
})(FilledInput));

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(582);




/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */











var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: '0 !important'
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    '@global': {
      '@keyframes mui-auto-fill': {},
      '@keyframes mui-auto-fill-cancel': {}
    },

    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      lineHeight: '1.1876em',
      // Reset (19px), match the native input line-height
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    }),

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      '&$marginDense': {
        paddingTop: 4 - 1
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      letterSpacing: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.1876em',
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: 'mui-auto-fill-cancel',
      animationDuration: '10ms',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: 'mui-auto-fill'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: 'auto',
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},

    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_3_react__["useLayoutEffect"];
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */

var InputBase = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function InputBase(props, ref) {
  var ariaDescribedby = props['aria-describedby'],
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      classes = props.classes,
      className = props.className,
      color = props.color,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      endAdornment = props.endAdornment,
      error = props.error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      id = props.id,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef,
      margin = props.margin,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      renderSuffix = props.renderSuffix,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMin = props.rowsMin,
      maxRows = props.maxRows,
      minRows = props.minRows,
      startAdornment = props.startAdornment,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]);

  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var handleInputRefWarning = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (instance) {
    if (false) {
      if (instance && instance.nodeName !== 'INPUT' && !instance.focus) {
        console.error(['Material-UI: You have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  var handleInputPropsRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputRef, handleInputRefProp);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["b" /* useFormControl */])();

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }

      return undefined;
    }, [muiFormControl]);
  }

  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* isFilled */])(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect(function () {
    if (isControlled) {
      checkDirty({
        value: value
      });
    }
  }, [value, checkDirty, isControlled]);

  var handleFocus = function handleFocus(event) {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;

      if (element == null) {
        throw new Error( false ? "Material-UI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["b" /* formatMuiErrorMessage */])(1));
      }

      checkDirty({
        value: element.value
      });
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    } // Perform in the willUpdate


    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    checkDirty(inputRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  var InputComponent = inputComponent;

  var inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inputPropsProp, {
    ref: handleInputRef
  });

  if (typeof InputComponent !== 'string') {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type: type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) {
      InputComponent = 'textarea';
    } else {
      inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        minRows: rows || minRows,
        rowsMax: rowsMax,
        maxRows: maxRows
      }, inputProps);
      InputComponent = __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__["a" /* default */];
    }
  } else {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: type
    }, inputProps);
  }

  var handleAutoFill = function handleAutoFill(event) {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["a" /* default */].Provider, {
    value: null
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fcs, {
    startAdornment: startAdornment
  })) : null);
});
 false ? InputBase.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  'aria-describedby': PropTypes.string,

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the input is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputBase'
})(InputBase));

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_debounce__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_deprecatedPropType__ = __webpack_require__(81);








function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"];
var styles = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMinProp = props.rowsMin,
      maxRowsProp = props.maxRows,
      _props$minRows = props.minRows,
      minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows,
      style = props.style,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]);

  var maxRows = maxRowsProp || rowsMax;
  var minRows = rows || rowsMinProp || minRowsProp;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__["a" /* default */])(ref, inputRef);
  var shadowRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var renders = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](0);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"]({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }

    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      if (false) {
        if (renders.current === 20) {
          console.error(['Material-UI: Too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
        }
      }

      return prevState;
    });
  }, [maxRows, minRows, props.placeholder]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_4__utils_debounce__["a" /* default */])(function () {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect(function () {
    syncHeight();
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    renders.current = 0;
  }, [value]);

  var handleChange = function handleChange(event) {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("textarea", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: minRows,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles.shadow, style)
  }));
});
 false ? TextareaAutosize.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  placeholder: PropTypes.string,

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rows: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `minRows` instead.'),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `maxRows` instead.'),

  /**
   * Minimum number of rows to display.
   * @deprecated Use `minRows` instead.
   */
  rowsMin: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `minRows` instead.'),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (TextareaAutosize);

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputBase_utils__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormControlContext__ = __webpack_require__(421);










var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */

var FormControl = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormControl(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      visuallyFocused = props.focused,
      _props$hiddenLabel = props.hiddenLabel,
      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 'none' : _props$margin,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      size = props.size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialAdornedStart = false;

    if (children) {
      __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Input', 'Select'])) {
          return;
        }

        var input = Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Select']) ? child.props.input : child;

        if (input && Object(__WEBPACK_IMPORTED_MODULE_5__InputBase_utils__["a" /* isAdornedStart */])(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  }),
      adornedStart = _React$useState[0],
      setAdornedStart = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialFilled = false;

    if (children) {
      __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Input', 'Select'])) {
          return;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_5__InputBase_utils__["b" /* isFilled */])(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  }),
      filled = _React$useState2[0],
      setFilled = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      _focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;

  if (disabled && focused) {
    setFocused(false);
  }

  var registerEffect;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var registeredInput = React.useRef(false);

    registerEffect = function registerEffect() {
      if (registeredInput.current) {
        console.error(['Material-UI: There are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
      }

      registeredInput.current = true;
      return function () {
        registeredInput.current = false;
      };
    };
  }

  var onFilled = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    setFilled(true);
  }, []);
  var onEmpty = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    setFilled(false);
  }, []);
  var childContext = {
    adornedStart: adornedStart,
    setAdornedStart: setAdornedStart,
    color: color,
    disabled: disabled,
    error: error,
    filled: filled,
    focused: focused,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    margin: (size === 'small' ? 'dense' : undefined) || margin,
    onBlur: function onBlur() {
      setFocused(false);
    },
    onEmpty: onEmpty,
    onFilled: onFilled,
    onFocus: function onFocus() {
      setFocused(true);
    },
    registerEffect: registerEffect,
    required: required,
    variant: variant
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__FormControlContext__["a" /* default */].Provider, {
    value: childContext
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, margin !== 'none' && classes["margin".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(margin))], fullWidth && classes.fullWidth),
    ref: ref
  }, other), children));
});
 false ? FormControl.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the form control.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the component will be displayed in focused state.
   */
  focused: PropTypes.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * If `true`, the label will be hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   */
  hiddenLabel: PropTypes.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * The size of the text field.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormControl'
})(FormControl));

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Typography__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(36);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

var FormControlLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormControlLabel(props, ref) {
  var checked = props.checked,
      classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl__["b" /* useFormControl */])();
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(labelPlacement))], disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](control, controlProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Typography__["a" /* default */], {
    component: "span",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, disabled && classes.disabled)
  }, label));
});
 false ? FormControlLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The text to be used in an enclosing label element.
   */
  label: PropTypes.node,

  /**
   * The position of the label.
   */
  labelPlacement: PropTypes.oneOf(['bottom', 'end', 'start', 'top']),

  /**
   * @ignore
   */
  name: PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel));

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },

  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

var FormGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormGroup(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$row = props.row,
      row = _props$row === void 0 ? false : _props$row,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "row"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, row && classes.row),
    ref: ref
  }, other));
});
 false ? FormGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display group of elements in a compact row.
   */
  row: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormGroup'
})(FormGroup));

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      color: theme.palette.text.secondary
    }, theme.typography.caption, {
      textAlign: 'left',
      marginTop: 3,
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 14,
      marginRight: 14
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
};
var FormHelperText = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormHelperText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'p' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      margin = props.margin,
      required = props.required,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), children === ' ' ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : children);
});
 false ? FormHelperText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormHelperText'
})(FormHelperText));

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(8);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      color: theme.palette.text.secondary
    }, theme.typography.body1, {
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused': {
        color: theme.palette.secondary.main
      }
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Styles applied to the asterisk element. */
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};
var FormLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function FormLabel(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'label' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      required = props.required,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
    ref: ref
  }, other), children, fcs.required && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    "aria-hidden": true,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.asterisk, fcs.error && classes.error)
  }, "\u2009", '*'));
});
 false ? FormLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormLabel'
})(FormLabel));

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requirePropFactory__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_deprecatedPropType__ = __webpack_require__(81);


// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/






var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  SPACINGS.forEach(function (spacing) {
    var themeSpacing = theme.spacing(spacing);

    if (themeSpacing === 0) {
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      '& > $item': {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="row-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justifyContent="center"`. */
    'justify-content-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justifyContent="flex-end"`. */
    'justify-content-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justifyContent="space-between"`. */
    'justify-content-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justifyContent="space-around"`. */
    'justify-content-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justifyContent="space-evenly"`. */
    'justify-content-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), theme.breakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};
var Grid = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Grid(props, ref) {
  var _props$alignContent = props.alignContent,
      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
      classes = props.classes,
      classNameProp = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$container = props.container,
      container = _props$container === void 0 ? false : _props$container,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'row' : _props$direction,
      _props$item = props.item,
      item = _props$item === void 0 ? false : _props$item,
      justify = props.justify,
      _props$justifyContent = props.justifyContent,
      justifyContent = _props$justifyContent === void 0 ? 'flex-start' : _props$justifyContent,
      _props$lg = props.lg,
      lg = _props$lg === void 0 ? false : _props$lg,
      _props$md = props.md,
      md = _props$md === void 0 ? false : _props$md,
      _props$sm = props.sm,
      sm = _props$sm === void 0 ? false : _props$sm,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
      _props$xl = props.xl,
      xl = _props$xl === void 0 ? false : _props$xl,
      _props$xs = props.xs,
      xs = _props$xs === void 0 ? false : _props$xs,
      _props$zeroMinWidth = props.zeroMinWidth,
      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "justifyContent", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);

  var className = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== 'flex-start' && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: className,
    ref: ref
  }, other));
});
 false ? Grid.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: PropTypes.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: PropTypes.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   * @deprecated Use `justifyContent` instead, the prop was renamed
   */
  justify: deprecatedPropType(PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']), 'Use `justifyContent` instead, the prop was renamed.'),

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justifyContent: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: PropTypes.oneOf(SPACINGS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: PropTypes.bool
} : void 0;
var StyledGrid = Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) {
  var requireProp = requirePropFactory('Grid');
  StyledGrid.propTypes = _extends({}, StyledGrid.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justifyContent: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('item')
  });
}

/* harmony default export */ __webpack_exports__["a"] = (StyledGrid);

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
var warnedOnce = false;
/**
 * ⚠️ The GridList component was renamed to ImageList to align with the current Material Design naming.
 *
 * You should use `import { ImageList } from '@material-ui/core'`
 * or `import ImageList from '@material-ui/core/ImageList'`.
 */

var GridList = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function GridList(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: The GridList component was renamed to ImageList to align with the current Material Design naming.', '', "You should use `import { ImageList } from '@material-ui/core'`", "or `import ImageList from '@material-ui/core/ImageList'`."].join('\n'));
    }
  }

  var _props$cellHeight = props.cellHeight,
      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 2 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      margin: -spacing / 2
    }, style)
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        width: "".concat(100 / cols * childCols, "%"),
        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
        padding: spacing / 2
      }, child.props.style)
    });
  }));
});
 false ? GridList.propTypes = {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]),

  /**
   * Grid Tiles that will be in Grid List.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Number of columns.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Number of px for the spacing between tiles.
   */
  spacing: PropTypes.number,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGridList'
})(GridList));

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debounce__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(264);









var styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },

  /* Styles applied to the `div` element that wraps the children. */
  tile: {
    position: 'relative',
    display: 'block',
    // In case it's not rendered with a div.
    height: '100%',
    overflow: 'hidden'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};

var fit = function fit(imgEl, classes) {
  if (!imgEl || !imgEl.complete) {
    return;
  }

  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
    var _imgEl$classList, _imgEl$classList2;

    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullWidth.split(' ')));

    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullHeight.split(' ')));
  } else {
    var _imgEl$classList3, _imgEl$classList4;

    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullHeight.split(' ')));

    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullWidth.split(' ')));
  }
};

function ensureImageCover(imgEl, classes) {
  if (!imgEl) {
    return;
  }

  if (imgEl.complete) {
    fit(imgEl, classes);
  } else {
    imgEl.addEventListener('load', function () {
      fit(imgEl, classes);
    });
  }
}

var warnedOnce = false;
/**
 * ⚠️ The GridList component was renamed to ImageList to align with the current Material Design naming.
 *
 * You should use `import { ImageListItem } from '@material-ui/core'`
 * or `import ImageListItem from '@material-ui/core/ImageListItem'`.
 */

var GridListTile = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function GridListTile(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: The GridListTile component was renamed to ImageListItem to align with the current Material Design naming.', '', "You should use `import { ImageListItem } from '@material-ui/core'`", "or `import ImageListItem from '@material-ui/core/ImageListItem'`."].join('\n'));
    }
  } // cols rows default values are for docs only


  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 1 : _props$rows,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "cols", "component", "rows"]);

  var imgRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    ensureImageCover(imgRef.current, classes);
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce__["a" /* default */])(function () {
      fit(imgRef.current, classes);
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [classes]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: classes.tile
  }, __WEBPACK_IMPORTED_MODULE_3_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](child)) {
      return null;
    }

    if (child.type === 'img' || Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Image'])) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](child, {
        ref: imgRef
      });
    }

    return child;
  })));
});
 false ? GridListTile.propTypes = {
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in which case GridListTile takes care of making the image "cover" available space
   * (similar to `background-size: cover` or to `object-fit: cover`).
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Width of the tile in number of grid cells.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Height of the tile in number of grid cells.
   */
  rows: PropTypes.number
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGridListTile'
})(GridListTile));

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },

    /* Styles applied to the root element if `titlePosition="bottom"`. */
    titlePositionBottom: {
      bottom: 0
    },

    /* Styles applied to the root element if `titlePosition="top"`. */
    titlePositionTop: {
      top: 0
    },

    /* Styles applied to the root element if a `subtitle` is provided. */
    rootSubtitle: {
      height: 68
    },

    /* Styles applied to the title and subtitle container element. */
    titleWrap: {
      flexGrow: 1,
      marginLeft: 16,
      marginRight: 16,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },

    /* Styles applied to the container element if `actionPosition="left"`. */
    titleWrapActionPosLeft: {
      marginLeft: 0
    },

    /* Styles applied to the container element if `actionPosition="right"`. */
    titleWrapActionPosRight: {
      marginRight: 0
    },

    /* Styles applied to the title container element. */
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the subtitle container element. */
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the actionIcon if supplied. */
    actionIcon: {},

    /* Styles applied to the actionIcon if `actionPosition="left"`. */
    actionIconActionPosLeft: {
      order: -1
    }
  };
};
var warnedOnce = false;
/**
 * ⚠️ The GridListTileBar component was renamed to ImageListItemBar to align with the current Material Design naming.
 *
 * You should use `import { ImageListItemBar } from '@material-ui/core'`
 * or `import ImageListItemBar from '@material-ui/core/ImageListItemBar'`.
 */

var GridListTileBar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function GridListTileBar(props, ref) {
  if (false) {
    if (!warnedOnce) {
      warnedOnce = true;
      console.error(['Material-UI: The GridListTileBar component was renamed to ImageListItemBar to align with the current Material Design naming.', '', "You should use `import { ImageListItemBar } from '@material-ui/core'`", "or `import ImageListItemBar from '@material-ui/core/ImageListItemBar'`."].join('\n'));
    }
  }

  var actionIcon = props.actionIcon,
      _props$actionPosition = props.actionPosition,
      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
      classes = props.classes,
      className = props.className,
      subtitle = props.subtitle,
      title = props.title,
      _props$titlePosition = props.titlePosition,
      titlePosition = _props$titlePosition === void 0 ? 'bottom' : _props$titlePosition,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);

  var actionPos = actionIcon && actionPosition;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, titlePosition === 'top' ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.titleWrap, {
      'left': classes.titleWrapActionPosLeft,
      'right': classes.titleWrapActionPosRight
    }[actionPos])
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.title
  }, title), subtitle ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.actionIcon, actionPos === 'left' && classes.actionIconActionPosLeft)
  }, actionIcon) : null);
});
 false ? GridListTileBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: PropTypes.node,

  /**
   * Position of secondary action IconButton.
   */
  actionPosition: PropTypes.oneOf(['left', 'right']),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: PropTypes.node,

  /**
   * Title to be displayed on tile.
   */
  title: PropTypes.node,

  /**
   * Position of the title bar.
   */
  titlePosition: PropTypes.oneOf(['bottom', 'top'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGridListTileBar'
})(GridListTileBar));

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transitions_utils__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(59);










function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5_react_transition_group__["Transition"] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var autoTimeout = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();
  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var foreignRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(children.ref, ref);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var _getTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Grow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
Grow.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["a"] = (Grow);

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HiddenJs__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HiddenCss__ = __webpack_require__(1936);






/**
 * Responsively hides children based on the selected implementation.
 */

function Hidden(props) {
  var _props$implementation = props.implementation,
      implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
      _props$lgDown = props.lgDown,
      lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
      _props$lgUp = props.lgUp,
      lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
      _props$mdDown = props.mdDown,
      mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
      _props$mdUp = props.mdUp,
      mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
      _props$smDown = props.smDown,
      smDown = _props$smDown === void 0 ? false : _props$smDown,
      _props$smUp = props.smUp,
      smUp = _props$smUp === void 0 ? false : _props$smUp,
      _props$xlDown = props.xlDown,
      xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
      _props$xlUp = props.xlUp,
      xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
      _props$xsDown = props.xsDown,
      xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
      _props$xsUp = props.xsUp,
      xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);

  if (implementation === 'js') {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__HiddenJs__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      lgDown: lgDown,
      lgUp: lgUp,
      mdDown: mdDown,
      mdUp: mdUp,
      smDown: smDown,
      smUp: smUp,
      xlDown: xlDown,
      xlUp: xlUp,
      xsDown: xsDown,
      xsUp: xsUp
    }, other));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__HiddenCss__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    lgDown: lgDown,
    lgUp: lgUp,
    mdDown: mdDown,
    mdUp: mdUp,
    smDown: smDown,
    smUp: smUp,
    xlDown: xlDown,
    xlUp: xlUp,
    xsDown: xsDown,
    xsUp: xsUp
  }, other));
}

 false ? Hidden.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Hidden);

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withWidth__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_useTheme__ = __webpack_require__(67);




/**
 * @ignore - internal component.
 */

function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var theme = Object(__WEBPACK_IMPORTED_MODULE_3__styles_useTheme__["a" /* default */])();
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
      var _breakpoint = theme.breakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && Object(__WEBPACK_IMPORTED_MODULE_2__withWidth__["c" /* isWidthUp */])(_breakpoint, width) || breakpointDown && Object(__WEBPACK_IMPORTED_MODULE_2__withWidth__["b" /* isWidthDown */])(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,

  /**
   * @ignore
   */
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

if (false) {
  HiddenJs.propTypes = exactProp(HiddenJs.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__withWidth__["a" /* default */])()(HiddenJs));

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useMediaQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_styles__ = __webpack_require__(92);



function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_styles__["f" /* useTheme */])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_styles__["b" /* getThemeProps */])({
    theme: theme,
    name: 'MuiUseMediaQuery',
    props: {}
  });

  if (false) {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['Material-UI: The `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }

  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
  // All the browsers Material-UI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  var _props$options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, options),
      _props$options$defaul = _props$options.defaultMatches,
      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
      _props$options$matchM = _props$options.matchMedia,
      matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM,
      _props$options$noSsr = _props$options.noSsr,
      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
      _props$options$ssrMat = _props$options.ssrMatchMedia,
      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react__["useState"](function () {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  }),
      match = _React$useState[0],
      setMatch = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"](function () {
    var active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    var queryList = matchMedia(query);

    var updateMatch = function updateMatch() {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useDebugValue({
      query: query,
      match: match
    });
  }

  return match;
}

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(67);








var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return theme.breakpoints.keys.reduce(function (acc, key) {
    acc["only".concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils_capitalize__["a" /* default */])(key))] = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      only = props.only,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "only"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();

  if (false) {
    var unknownProps = Object.keys(other).filter(function (propName) {
      var isUndeclaredBreakpoint = !theme.breakpoints.keys.some(function (breakpoint) {
        return "".concat(breakpoint, "Up") === propName || "".concat(breakpoint, "Down") === propName;
      });
      return isUndeclaredBreakpoint;
    });

    if (unknownProps.length > 0) {
      console.error("Material-UI: Unsupported props received by `<Hidden implementation=\"css\" />`: ".concat(unknownProps.join(', '), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
    }
  }

  var clsx = [];

  if (className) {
    clsx.push(className);
  }

  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
    var breakpoint = theme.breakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      clsx.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      clsx.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      clsx.push(classes["only".concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils_capitalize__["a" /* default */])(breakpoint))]);
    });
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: clsx.join(' ')
  }, children);
}

 false ? HiddenCss.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes.oneOf(['js', 'css']),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: PropTypes.bool,

  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateHiddenCss'
})(HiddenCss));

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(36);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      fontSize: theme.typography.pxToRem(24),
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden',
      flexShrink: 0
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(36)
    }
  };
};
var Icon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Icon(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "component", "fontSize"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(fontSize))]),
    "aria-hidden": true,
    ref: ref
  }, other));
});
 false ? Icon.propTypes = {
  /**
   * The name of the icon font ligature.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: chainPropTypes(PropTypes.oneOf(['default', 'inherit', 'large', 'medium', 'small']), function (props) {
    var fontSize = props.fontSize;

    if (fontSize === 'default') {
      throw new Error('Material-UI: `fontSize="default"` is deprecated. Use `fontSize="medium"` instead.');
    }

    return null;
  })
} : void 0;
Icon.muiName = 'Icon';
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiIcon'
})(Icon));

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_deprecatedPropType__ = __webpack_require__(81);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
var ImageList = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ImageList(props, ref) {
  var cellHeight = props.cellHeight,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 2 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$gap = props.gap,
      gapProp = _props$gap === void 0 ? 4 : _props$gap,
      _props$rowHeight = props.rowHeight,
      rowHeightProp = _props$rowHeight === void 0 ? 180 : _props$rowHeight,
      spacing = props.spacing,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["cellHeight", "children", "classes", "className", "cols", "component", "gap", "rowHeight", "spacing", "style"]);

  var gap = spacing || gapProp;
  var rowHeight = cellHeight || rowHeightProp;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      margin: -gap / 2
    }, style)
  }, other), __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The ImageList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        width: "".concat(100 / cols * childCols, "%"),
        height: rowHeight === 'auto' ? 'auto' : rowHeight * childRows + gap,
        padding: gap / 2
      }, child.props.style)
    });
  }));
});
 false ? ImageList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Cell height in `px`.
   * Set to `'auto'` to let the children determine the height.
   * @deprecated Use rowHeight instead.
   */
  cellHeight: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]), 'Use the `rowHeight` prop instead.'),

  /**
   * Items that will be in the image list.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Number of columns.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The gap between items in `px`.
   */
  gap: PropTypes.number,

  /**
   * The height of one row in `px`.
   */
  rowHeight: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),

  /**
   * The spacing between items in `px`.
   * @deprecated Use gap instead.
   */
  spacing: deprecatedPropType(PropTypes.number, 'Use the `gap` prop instead.'),

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiImageList'
})(ImageList));

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debounce__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(264);









var styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },

  /* Styles applied to the `div` element that wraps the children. */
  item: {
    position: 'relative',
    display: 'block',
    // In case it's not rendered with a div.
    height: '100%',
    overflow: 'hidden'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the item. */
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the item. */
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};

var fit = function fit(imgEl, classes) {
  if (!imgEl || !imgEl.complete) {
    return;
  }

  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
    var _imgEl$classList, _imgEl$classList2;

    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullWidth.split(' ')));

    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullHeight.split(' ')));
  } else {
    var _imgEl$classList3, _imgEl$classList4;

    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullHeight.split(' ')));

    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullWidth.split(' ')));
  }
};

function ensureImageCover(imgEl, classes) {
  if (!imgEl) {
    return;
  }

  if (imgEl.complete) {
    fit(imgEl, classes);
  } else {
    imgEl.addEventListener('load', function () {
      fit(imgEl, classes);
    });
  }
}

var ImageListItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function ImageListItem(props, ref) {
  // cols rows default values are for docs only
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 1 : _props$rows,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "cols", "component", "rows"]);

  var imgRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    ensureImageCover(imgRef.current, classes);
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce__["a" /* default */])(function () {
      fit(imgRef.current, classes);
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [classes]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: classes.item
  }, __WEBPACK_IMPORTED_MODULE_3_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](child)) {
      return null;
    }

    if (child.type === 'img' || Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Image'])) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](child, {
        ref: imgRef
      });
    }

    return child;
  })));
});
 false ? ImageListItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * While you can pass any node as children, the main use case is for an img.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Width of the item in number of grid columns.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Height of the item in number of grid rows.
   */
  rows: PropTypes.number
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiImageListItem'
})(ImageListItem));

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_deprecatedPropType__ = __webpack_require__(81);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },

    /* Styles applied to the root element if `position="bottom"`. */
    positionBottom: {
      bottom: 0
    },

    /* Styles applied to the root element if `position="top"`. */
    positionTop: {
      top: 0
    },

    /* Styles applied to the root element if a `subtitle` is provided. */
    rootSubtitle: {
      height: 68
    },

    /* Styles applied to the title and subtitle container element. */
    titleWrap: {
      flexGrow: 1,
      marginLeft: 16,
      marginRight: 16,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },

    /* Styles applied to the container element if `actionPosition="left"`. */
    titleWrapActionPosLeft: {
      marginLeft: 0
    },

    /* Styles applied to the container element if `actionPosition="right"`. */
    titleWrapActionPosRight: {
      marginRight: 0
    },

    /* Styles applied to the title container element. */
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the subtitle container element. */
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the actionIcon if supplied. */
    actionIcon: {},

    /* Styles applied to the actionIcon if `actionPosition="left"`. */
    actionIconActionPosLeft: {
      order: -1
    }
  };
};
var ImageListItemBar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ImageListItemBar(props, ref) {
  var actionIcon = props.actionIcon,
      _props$actionPosition = props.actionPosition,
      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
      classes = props.classes,
      className = props.className,
      subtitle = props.subtitle,
      title = props.title,
      _props$position = props.position,
      positionProp = _props$position === void 0 ? 'bottom' : _props$position,
      titlePosition = props.titlePosition,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "position", "titlePosition"]);

  var position = titlePosition || positionProp;
  var actionPos = actionIcon && actionPosition;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, subtitle && classes.rootSubtitle, {
      'bottom': classes.positionBottom,
      'top': classes.positionTop
    }[position]),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.titleWrap, {
      'left': classes.titleWrapActionPosLeft,
      'right': classes.titleWrapActionPosRight
    }[actionPos])
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.title
  }, title), subtitle ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.actionIcon, actionPos === 'left' && classes.actionIconActionPosLeft)
  }, actionIcon) : null);
});
 false ? ImageListItemBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the item itself).
   */
  actionIcon: PropTypes.node,

  /**
   * Position of secondary action IconButton.
   */
  actionPosition: PropTypes.oneOf(['left', 'right']),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Position of the title bar.
   */
  position: PropTypes.oneOf(['bottom', 'top']),

  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: PropTypes.node,

  /**
   * Title to be displayed on item.
   */
  title: PropTypes.node,

  /**
   * Position of the title bar.
   * @deprecated Use position instead.
   */
  titlePosition: deprecatedPropType(PropTypes.oneOf(['bottom', 'top']), 'Use the `position` prop instead.')
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiImageListItemBar'
})(ImageListItemBar));

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};
var Input = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Input(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? Input.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
Input.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInput'
})(Input));

/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Typography__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__ = __webpack_require__(421);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },

  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    '&$positionStart:not($hiddenLabel)': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },

  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: 'none'
  },

  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},

  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
};
var InputAdornment = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function InputAdornment(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disablePointer = props.disablePointerEvents,
      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      position = props.position,
      variantProp = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["b" /* useFormControl */])() || {};
  var variant = variantProp;

  if (variantProp && muiFormControl.variant) {
    if (false) {
      if (variantProp === muiFormControl.variant) {
        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["a" /* default */].Provider, {
    value: null
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Typography__["a" /* default */], {
    color: "textSecondary"
  }, children) : children));
});
 false ? InputAdornment.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: PropTypes.bool,

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * @ignore
   */
  muiFormControl: PropTypes.object,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(['start', 'end']).isRequired,

  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputAdornment'
})(InputAdornment));

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormLabel__ = __webpack_require__(585);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      transformOrigin: 'top left'
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 12px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};
var InputLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function InputLabel(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
      margin = props.margin,
      shrinkProp = props.shrink,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['margin', 'variant']
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__FormLabel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "data-shrink": shrink,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
      'filled': classes.filled,
      'outlined': classes.outlined
    }[fcs.variant]),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref: ref
  }, other));
});
 false ? InputLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The contents of the `InputLabel`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: PropTypes.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputLabel'
})(InputLabel));

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_useTheme__ = __webpack_require__(67);









var TRANSITION_DURATION = 4; // seconds

var styles = function styles(theme) {
  var getColor = function getColor(color) {
    return theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["e" /* lighten */])(color, 0.62) : Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* darken */])(color, 0.5);
  };

  var backgroundPrimary = getColor(theme.palette.primary.main);
  var backgroundSecondary = getColor(theme.palette.secondary.main);
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 4,
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
    colorPrimary: {
      backgroundColor: backgroundPrimary
    },

    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: backgroundSecondary
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {},

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: '$buffer 3s infinite linear'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0 -23px'
    },

    /* Styles applied to the layered bar1 and bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
    },

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0 -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0 -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var LinearProgress = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function LinearProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_8__styles_useTheme__["a" /* default */])();
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      var transform = value - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
    } else if (false) {
      console.error('Material-UI: You need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      var _transform = (valueBuffer || 0) - 100;

      if (theme.direction === 'rtl') {
        _transform = -_transform;
      }

      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
    } else if (false) {
      console.error('Material-UI: You need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))], className, {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'buffer': classes.buffer,
      'query': classes.query
    }[variant]),
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other), variant === 'buffer' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.dashed, classes["dashedColor".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))])
  }) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.bar, classes["barColor".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
      'determinate': classes.bar1Determinate,
      'buffer': classes.bar1Buffer
    }[variant]),
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))], classes.bar2Buffer] : classes["barColor".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))]),
    style: inlineStyles.bar2
  }));
});
 false ? LinearProgress.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: PropTypes.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress));

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useIsFocusVisible__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Typography__ = __webpack_require__(110);











var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: 'none'
  },

  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },

  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: 'underline'
  },
  // Same reset as ButtonBase.root

  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$focusVisible': {
      outline: 'auto'
    }
  },

  /* Pseudo-class applied to the root element if the link is keyboard focused. */
  focusVisible: {}
};
var Link = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Link(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'a' : _props$component,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      TypographyClasses = props.TypographyClasses,
      _props$underline = props.underline,
      underline = _props$underline === void 0 ? 'hover' : _props$underline,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useIsFocusVisible__["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  var handlerRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(ref, focusVisibleRef);

  var handleBlur = function handleBlur(event) {
    if (focusVisible) {
      onBlurVisible();
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["underline".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
    classes: TypographyClasses,
    color: color,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    variant: variant
  }, other));
});
 false ? Link.propTypes = {
  /**
   * The content of the link.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the link.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * `classes` prop applied to the [`Typography`](/api/typography/) element.
   */
  TypographyClasses: PropTypes.object,

  /**
   * Controls when the link should have an underline.
   */
  underline: PropTypes.oneOf(['none', 'hover', 'always']),

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiLink'
})(Link));

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListContext__ = __webpack_require__(321);







var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ListContext__["a" /* default */].Provider, {
    value: context
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
 false ? List.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: PropTypes.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiList'
})(List));

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__List_ListContext__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);












var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */]);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {
        console.error('Material-UI: Unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(childrenProp);
  var hasSecondaryAction = children.length && Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    listItemRef.current = __WEBPACK_IMPORTED_MODULE_11_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(handleOwnRef, ref);

  var componentProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName);
    Component = __WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */];
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */].Provider, {
      value: childContext
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ContainerComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, componentProps, children), children.pop()));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */].Provider, {
    value: childContext
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef
  }, componentProps), children));
});
 false ? ListItem.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center']),

  /**
   * If `true`, the list item will be focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   */
  button: PropTypes.bool,

  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: You used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: PropTypes.elementType,

  /**
   * Props applied to the container component if used.
   */
  ContainerProps: PropTypes.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * Use to apply selected styling.
   */
  selected: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItem'
})(ListItem));

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List_ListContext__ = __webpack_require__(321);







var styles = {
  /* Styles applied to the root element. */
  root: {
    minWidth: 56,
    flexShrink: 0
  },

  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
  alignItemsFlexStart: {
    marginTop: 8
  }
};
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */

var ListItemAvatar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemAvatar(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__List_ListContext__["a" /* default */]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? ListItemAvatar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component – normally `Avatar`.
   */
  children: PropTypes.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemAvatar'
})(ListItemAvatar));

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List_ListContext__ = __webpack_require__(321);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    },

    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */

var ListItemIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemIcon(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__List_ListContext__["a" /* default */]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? ListItemIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon));

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)'
  }
};
/**
 * Must be used as the last child of ListItem to function properly.
 */

var ListItemSecondaryAction = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemSecondaryAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? ListItemSecondaryAction.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemSecondaryAction'
})(ListItemSecondaryAction));

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List_ListContext__ = __webpack_require__(321);








var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },

  /* Styles applied to the `Typography` components if primary and secondary are set. */
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },

  /* Styles applied to the `Typography` components if dense. */
  dense: {},

  /* Styles applied to the root element if `inset={true}`. */
  inset: {
    paddingLeft: 56
  },

  /* Styles applied to the primary `Typography` component. */
  primary: {},

  /* Styles applied to the secondary `Typography` component. */
  secondary: {}
};
var ListItemText = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListItemText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_7__List_ListContext__["a" /* default */]),
      dense = _React$useContext.dense;

  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    primary = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: "span",
      display: "block"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    secondary = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: "body2",
      className: classes.secondary,
      color: "textSecondary",
      display: "block"
    }, secondaryTypographyProps), secondary);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
    ref: ref
  }, other), primary, secondary);
});
 false ? ListItemText.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Alias for the `primary` prop.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: PropTypes.bool,

  /**
   * The main content element.
   */
  primary: PropTypes.node,

  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: PropTypes.object,

  /**
   * The secondary content element.
   */
  secondary: PropTypes.node,

  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemText'
})(ListItemText));

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(36);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },

    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};
var ListSubheader = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function ListSubheader(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$disableSticky = props.disableSticky,
      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? ListSubheader.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: PropTypes.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListSubheader'
})(ListSubheader));

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOffsetTop */
/* unused harmony export getOffsetLeft */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debounce__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_deprecatedPropType__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Modal__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Grow__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Paper__ = __webpack_require__(109);
















function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Popover(props, ref) {
  var action = props.action,
      anchorEl = props.anchorEl,
      _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$anchorOrigin,
      anchorPosition = props.anchorPosition,
      _props$anchorReferenc = props.anchorReference,
      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
      children = props.children,
      classes = props.classes,
      className = props.className,
      containerProp = props.container,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
      getContentAnchorEl = props.getContentAnchorEl,
      _props$marginThreshol = props.marginThreshold,
      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$transformOrigi = props.transformOrigin,
      transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$transformOrigi,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_14__Grow__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps,
      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var paperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  var getAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (contentAnchorOffset) {
    if (anchorReference === 'anchorPosition') {
      if (false) {
        if (!anchorPosition) {
          console.error('Material-UI: You need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }

      return anchorPosition;
    }

    var resolvedAnchorEl = getAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();

    if (false) {
      var box = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }

    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided

  var getContentAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (element) {
    var contentAnchorOffset = 0;

    if (getContentAnchorEl && anchorReference === 'anchorEl') {
      var contentAnchorEl = getContentAnchorEl(element);

      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      } // != the default value


      if (false) {
        if (anchorOrigin.vertical !== 'top') {
          console.error(['Material-UI: You can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
        }
      }
    }

    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
  // and taking the content anchor offset into account if in use

  var getTransformOrigin = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (element) {
    // Check if the parent has requested anchoring on an inner content node
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of of the anchoring element


    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning

    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    var containerWindow = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__["a" /* default */])(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;

      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }

    if (false) {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['Material-UI: The popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    } // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;

      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;

      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }

    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    var element = paperRef.current;

    if (!element) {
      return;
    }

    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  var handlePaperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    paperRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](instance);
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (open) {
      setPositioningStyles();
    }
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](action, function () {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!open) {
      return undefined;
    }

    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce__["a" /* default */])(function () {
      setPositioningStyles();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  var container = containerProp || (anchorEl ? Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(getAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    container: container,
    open: open,
    ref: ref,
    BackdropProps: {
      invisible: true
    },
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.root, className)
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleEntering, TransitionProps.onEntering)
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.paper, PaperProps.className)
  }), children)));
});
 false ? Popover.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,

  /**
   * A HTML element, or a function that returns it.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), function (props) {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
      }
    }

    return null;
  }),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),

  /**
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * The elevation of the popover.
   */
  elevation: PropTypes.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: PropTypes.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired before the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the component is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * If `true`, the popover is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes
  /* @typescript-to-proptypes-ignore */
  .shape({
    component: elementTypeAcceptingRef
  }),

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(['center', 'left', 'right']), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(['bottom', 'center', 'top']), PropTypes.number]).isRequired
  }),

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiPopover'
})(Popover));

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_ownerDocument__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getScrollbarSize__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(59);











function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  var text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return;
    }
  }
}

var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"];
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */

var MenuList = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function MenuList(props, ref) {
  var actions = props.actions,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$autoFocusItem = props.autoFocusItem,
      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
      children = props.children,
      className = props.className,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      onKeyDown = props.onKeyDown,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);

  var listRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var textCriteriaRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;

        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_getScrollbarSize__["a" /* default */])(true), "px");
          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }

        return listRef.current;
      }
    };
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    var currentFocus = Object(__WEBPACK_IMPORTED_MODULE_6__utils_ownerDocument__["a" /* default */])(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    listRef.current = __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(handleOwnRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react__["Children"].forEach(children, function (child, index) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__List__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
 false ? MenuList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   */
  autoFocusItem: PropTypes.bool,

  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: PropTypes.bool,

  /**
   * If `true`, the menu items will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (MenuList);

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ListItem__ = __webpack_require__(590);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO v5: remove

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      ListItemClasses = props.ListItemClasses,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ListItem__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      dense: classes.dense
    }, ListItemClasses),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? MenuItem.propTypes = {
  /**
   * Menu item contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * @ignore
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
   */
  ListItemClasses: PropTypes.object,

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LinearProgress__ = __webpack_require__(588);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: 8
    },

    /* Styles applied to the root element if `position="bottom"`. */
    positionBottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="top"`. */
    positionTop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {},

    /* Styles applied to the dots container if `variant="dots"`. */
    dots: {
      display: 'flex',
      flexDirection: 'row'
    },

    /* Styles applied to each dot if `variant="dots"`. */
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: 8,
      height: 8,
      margin: '0 2px'
    },

    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the Linear Progress component if `variant="progress"`. */
    progress: {
      width: '50%'
    }
  };
};
var MobileStepper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function MobileStepper(props, ref) {
  var _props$activeStep = props.activeStep,
      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
      backButton = props.backButton,
      classes = props.classes,
      className = props.className,
      LinearProgressProps = props.LinearProgressProps,
      nextButton = props.nextButton,
      _props$position = props.position,
      position = _props$position === void 0 ? 'bottom' : _props$position,
      steps = props.steps,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'dots' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    square: true,
    elevation: 0,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["position".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(position))], className),
    ref: ref
  }, other), backButton, variant === 'text' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react__["Fragment"], null, activeStep + 1, " / ", steps), variant === 'dots' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: classes.dots
  }, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(new Array(steps)).map(function (_, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
      key: index,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.dot, index === activeStep && classes.dotActive)
    });
  })), variant === 'progress' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__LinearProgress__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: classes.progress,
    variant: "determinate",
    value: Math.ceil(activeStep / (steps - 1) * 100)
  }, LinearProgressProps)), nextButton);
});
 false ? MobileStepper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   */
  activeStep: PropTypes.number,

  /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */
  backButton: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Props applied to the `LinearProgress` element.
   */
  LinearProgressProps: PropTypes.object,

  /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */
  nextButton: PropTypes.node,

  /**
   * Set the positioning type.
   */
  position: PropTypes.oneOf(['bottom', 'static', 'top']),

  /**
   * The total steps.
   */
  steps: PropTypes.number.isRequired,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['dots', 'progress', 'text'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMobileStepper'
})(MobileStepper));

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(20);



var useEnhancedEffect = typeof window !== 'undefined' && "production" !== 'test' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */

function NoSsr(props) {
  var children = props.children,
      _props$defer = props.defer,
      defer = _props$defer === void 0 ? false : _props$defer,
      _props$fallback = props.fallback,
      fallback = _props$fallback === void 0 ? null : _props$fallback;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),
      mountedState = _React$useState[0],
      setMountedState = _React$useState[1];

  useEnhancedEffect(function () {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, mountedState ? children : fallback);
}

 false ? NoSsr.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * You can wrap a node.
   */
  children: PropTypes.node,

  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   */
  defer: PropTypes.bool,

  /**
   * The fallback content to display.
   */
  fallback: PropTypes.node
} : void 0;

if (false) {
  // eslint-disable-next-line
  NoSsr['propTypes' + ''] = exactProp(NoSsr.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (NoSsr);

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotchedOutline__ = __webpack_require__(1959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(8);









var styles = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: borderColor
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      label = props.label,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    renderSuffix: function renderSuffix(state) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__NotchedOutline__["a" /* default */], {
        className: classes.notchedOutline,
        label: label,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? OutlinedInput.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The label of the input. It is only used for layout. The actual labelling
   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
   */
  label: PropTypes.node,

  /**
   * The width of the label. Is ignored if `label` is provided. Prefer `label`
   * if the input label appears with a strike through.
   */
  labelWidth: PropTypes.number,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
OutlinedInput.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiOutlinedInput'
})(OutlinedInput));

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(36);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: '0 8px',
      pointerEvents: 'none',
      borderRadius: 'inherit',
      borderStyle: 'solid',
      borderWidth: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      // sync with `height` in `legend` styles
      transition: theme.transitions.create('width', {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legendLabelled: {
      display: 'block',
      width: 'auto',
      textAlign: 'left',
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: '0.75em',
      visibility: 'hidden',
      maxWidth: 0.01,
      transition: theme.transitions.create('max-width', {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      '& > span': {
        paddingLeft: 5,
        paddingRight: 5,
        display: 'inline-block'
      }
    },

    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1000,
      transition: theme.transitions.create('max-width', {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
};
/**
 * @ignore - internal component.
 */

var NotchedOutline = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function NotchedOutline(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      label = props.label,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
  var align = theme.direction === 'rtl' ? 'right' : 'left';

  if (label !== undefined) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("fieldset", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-hidden": true,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
      ref: ref,
      style: style
    }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("legend", {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", null, label) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
      dangerouslySetInnerHTML: {
        __html: '&#8203;'
      }
    })));
  }

  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("fieldset", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-hidden": true,
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "padding".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(align)), 8), style),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
});
 false ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The label.
   */
  label: PropTypes.node,

  /**
   * The width of the label.
   */
  labelWidth: PropTypes.number.isRequired,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateNotchedOutline'
})(NotchedOutline));

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_popper_js__ = __webpack_require__(1961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Portal__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_setRef__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(59);












function flipPlacement(placement, theme) {
  var direction = theme && theme.direction || 'ltr';

  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"];
var defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */

var Popper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Popper(props, ref) {
  var anchorEl = props.anchorEl,
      children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      modifiers = props.modifiers,
      open = props.open,
      _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$popperOptions = props.popperOptions,
      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
      popperRefProp = props.popperRef,
      style = props.style,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? false : _props$transition,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);

  var tooltipRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var ownRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(tooltipRef, ref);
  var popperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);
  var handlePopperRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(popperRef, popperRefProp);
  var handlePopperRefRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](handlePopperRef);
  useEnhancedEffect(function () {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useImperativeHandle"](popperRefProp, function () {
    return popperRef.current;
  }, []);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_styles__["f" /* useTheme */])();
  var rtlPlacement = flipPlacement(initialPlacement, theme);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](rtlPlacement),
      placement = _React$useState2[0],
      setPlacement = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var handleOpen = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function () {
    if (!tooltipRef.current || !anchorEl || !open) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      handlePopperRefRef.current(null);
    }

    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };

    var resolvedAnchorEl = getAnchorEl(anchorEl);

    if (false) {
      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }

    var popper = new __WEBPACK_IMPORTED_MODULE_4_popper_js__["a" /* default */](getAnchorEl(anchorEl), tooltipRef.current, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, disablePortal ? {} : {
        // It's using scrollParent by default, we can use the viewport when using a portal.
        preventOverflow: {
          boundariesElement: 'window'
        }
      }, modifiers, popperOptions.modifiers),
      // We could have been using a custom modifier like react-popper is doing.
      // But it seems this is the best public API for this use case.
      onCreate: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(handlePopperUpdate, popperOptions.onCreate),
      onUpdate: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(handlePopperUpdate, popperOptions.onUpdate)
    }));
    handlePopperRefRef.current(popper);
  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
  var handleRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (node) {
    Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(ownRef, node);
    handleOpen();
  }, [ownRef, handleOpen]);

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleClose = function handleClose() {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    handlePopperRefRef.current(null);
  };

  var handleExited = function handleExited() {
    setExited(true);
    handleClose();
  };

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    return function () {
      handleClose();
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!open && !transition) {
      // Otherwise handleExited will call this.
      handleClose();
    }
  }, [open, transition]);

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  var childProps = {
    placement: placement
  };

  if (transition) {
    childProps.TransitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Portal__["a" /* default */], {
    disablePortal: disablePortal,
    container: container
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    role: "tooltip"
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: 'fixed',
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !open && keepMounted && !transition ? 'none' : null
    }, style)
  }), typeof children === 'function' ? children(childProps) : children));
});
 false ? Popper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A HTML element, [referenceObject](https://popper.js.org/docs/v1/#referenceObject),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), function (props) {
    if (props.open) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);

      if (resolvedAnchorEl && resolvedAnchorEl.nodeType === 1) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
        return new Error(['Material-UI: The `anchorEl` prop provided to the component is invalid.', 'It should be an HTML element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
      }
    }

    return null;
  }),

  /**
   * Popper render function or node.
   */
  children: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([PropTypes.node, PropTypes.func]).isRequired,

  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes
  /* @typescript-to-proptypes-ignore */
  .oneOfType([HTMLElementType, PropTypes.instanceOf(React.Component), PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: PropTypes.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
   */
  modifiers: PropTypes.object,

  /**
   * If `true`, the popper is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
   */
  popperOptions: PropTypes.object,

  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RadioButtonIcon__ = __webpack_require__(1963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RadioGroup_useRadioGroup__ = __webpack_require__(986);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__RadioButtonIcon__["a" /* default */], {
  checked: true
});
var defaultIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__RadioButtonIcon__["a" /* default */], null);
var Radio = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Radio(props, ref) {
  var checkedProp = props.checked,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      nameProp = props.name,
      onChangeProp = props.onChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["checked", "classes", "color", "name", "onChange", "size"]);

  var radioGroup = Object(__WEBPACK_IMPORTED_MODULE_12__RadioGroup_useRadioGroup__["a" /* default */])();
  var checked = checkedProp;
  var onChange = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    color: color,
    type: "radio",
    icon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](defaultIcon, {
      fontSize: size === 'small' ? 'small' : 'medium'
    }),
    checkedIcon: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](defaultCheckedIcon, {
      fontSize: size === 'small' ? 'small' : 'medium'
    }),
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
 false ? Radio.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * If `true`, the radio will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the radio.
   * `small` is equivalent to the dense radio styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiRadio'
})(Radio));

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_RadioButtonUnchecked__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_RadioButtonChecked__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      '&$checked $layer': {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  var checked = props.checked,
      classes = props.classes,
      fontSize = props.fontSize;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.root, checked && classes.checked)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_RadioButtonUnchecked__["a" /* default */], {
    fontSize: fontSize
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_RadioButtonChecked__["a" /* default */], {
    fontSize: fontSize,
    className: classes.layer
  }));
}

 false ? RadioButtonIcon.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The size of the radio.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: PropTypes.oneOf(['small', 'medium'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateRadioButtonIcon'
})(RadioButtonIcon));

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked'));

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked'));

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormGroup__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useControlled__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RadioGroupContext__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_unstable_useId__ = __webpack_require__(418);










var RadioGroup = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function RadioGroup(props, ref) {
  var actions = props.actions,
      children = props.children,
      nameProp = props.name,
      valueProp = props.value,
      onChange = props.onChange,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actions", "children", "name", "value", "onChange"]);

  var rootRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useControlled__["a" /* default */])({
    controlled: valueProp,
    default: props.defaultValue,
    name: 'RadioGroup'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](actions, function () {
    return {
      focus: function focus() {
        var input = rootRef.current.querySelector('input:not(:disabled):checked');

        if (!input) {
          input = rootRef.current.querySelector('input:not(:disabled)');
        }

        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_6__utils_useForkRef__["a" /* default */])(ref, rootRef);

  var handleChange = function handleChange(event) {
    setValue(event.target.value);

    if (onChange) {
      onChange(event, event.target.value);
    }
  };

  var name = Object(__WEBPACK_IMPORTED_MODULE_9__utils_unstable_useId__["a" /* default */])(nameProp);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__RadioGroupContext__["a" /* default */].Provider, {
    value: {
      name: name,
      onChange: handleChange,
      value: value
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__FormGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "radiogroup",
    ref: handleRef
  }, other), children));
});
 false ? RadioGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string]),

  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: PropTypes.string,

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (RadioGroup);

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_setRef__ = __webpack_require__(214);






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var warnedOnce = false;
/**
 * ⚠️⚠️⚠️
 * If you want the DOM element of a Material-UI component check out
 * [FAQ: How can I access the DOM element?](/getting-started/faq/#how-can-i-access-the-dom-element)
 * first.
 *
 * This component uses `findDOMNode` which is deprecated in React.StrictMode.
 *
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * function MyComponent() {
 *   const domRef = React.useRef();
 *
 *   React.useEffect(() => {
 *     console.log(domRef.current); // DOM node
 *   }, []);
 *
 *   return (
 *     <RootRef rootRef={domRef}>
 *       <SomeChildComponent />
 *     </RootRef>
 *   );
 * }
 * ```
 *
 * @deprecated
 */

var RootRef = /*#__PURE__*/function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inherits__["a" /* default */])(RootRef, _React$Component);

  var _super = _createSuper(RootRef);

  function RootRef() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, RootRef);

    return _super.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = __WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"](this);
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = __WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"](this);

      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(prevProps.rootRef, null);
        }

        this.ref = ref;
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      if (false) {
        if (!warnedOnce) {
          warnedOnce = true;
          console.warn(['Material-UI: The RootRef component is deprecated.', 'The component relies on the ReactDOM.findDOMNode API which is deprecated in React.StrictMode.', 'Instead, you can get a reference to the underlying DOM node of the components via the `ref` prop.'].join('/n'));
        }
      }

      return this.props.children;
    }
  }]);

  return RootRef;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

 false ? RootRef.propTypes = {
  /**
   * The wrapped element.
   */
  children: PropTypes.element.isRequired,

  /**
   * A ref that points to the first DOM node of the wrapped element.
   */
  rootRef: refType.isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? RootRef.propTypes = exactProp(RootRef.propTypes) : void 0;
}

/* unused harmony default export */ var _unused_webpack_default_export = (RootRef);

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectInput__ = __webpack_require__(1969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Input__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FilledInput__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OutlinedInput__ = __webpack_require__(426);















var styles = __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__["a" /* styles */];

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Input__["a" /* default */], null);

var _ref2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__FilledInput__["a" /* default */], null);

var Select = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Select(props, ref) {
  var _props$autoWidth = props.autoWidth,
      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
      children = props.children,
      classes = props.classes,
      _props$displayEmpty = props.displayEmpty,
      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__["a" /* default */] : _props$IconComponent,
      id = props.id,
      input = props.input,
      inputProps = props.inputProps,
      label = props.label,
      labelId = props.labelId,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      MenuProps = props.MenuProps,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$native = props.native,
      native = _props$native === void 0 ? false : _props$native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      _props$variant = props.variant,
      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);

  var inputComponent = native ? __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_5__SelectInput__["a" /* default */];
  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: _ref,
    outlined: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__OutlinedInput__["a" /* default */], {
      label: label,
      labelWidth: labelWidth
    }),
    filled: _ref2
  }[variant];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      children: children,
      IconComponent: IconComponent,
      variant: variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {
      id: id
    } : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      labelId: labelId,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_styles__["d" /* mergeClasses */])({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? Select.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
   * You can only use it when the `native` prop is `false` (default).
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  label: PropTypes.node,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * See [OutlinedInput#label](/api/outlined-input/#props)
   */
  labelWidth: PropTypes.number,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: PropTypes.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * The input value. Providing an empty string will select no options.
   * This prop is required when the `native` prop is `false` (default).
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
Select.muiName = 'Select';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSelect'
})(Select));

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ownerDocument__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Menu_Menu__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__InputBase_utils__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_useControlled__ = __webpack_require__(180);

















function areEqualValues(a, b) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */


var SelectInput = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["forwardRef"](function SelectInput(props, ref) {
  var ariaLabel = props['aria-label'],
      autoFocus = props.autoFocus,
      autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      inputRefProp = props.inputRef,
      labelId = props.labelId,
      _props$MenuProps = props.MenuProps,
      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
      multiple = props.multiple,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onOpen = props.onOpen,
      openProp = props.open,
      readOnly = props.readOnly,
      renderValue = props.renderValue,
      _props$SelectDisplayP = props.SelectDisplayProps,
      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
      tabIndexProp = props.tabIndex,
      type = props.type,
      valueProp = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useControlled__["a" /* default */])({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var inputRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](null),
      displayNode = _React$useState[0],
      setDisplayNode = _React$useState[1];

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_5_react__["useRef"](openProp != null),
      isOpenControlled = _React$useRef.current;

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](),
      menuMinWidthState = _React$useState2[0],
      setMenuMinWidthState = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_5_react__["useState"](false),
      openState = _React$useState3[0],
      setOpenState = _React$useState3[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__["a" /* default */])(ref, inputRefProp);
  __WEBPACK_IMPORTED_MODULE_5_react__["useImperativeHandle"](handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: value
    };
  }, [displayNode, value]);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  __WEBPACK_IMPORTED_MODULE_5_react__["useEffect"](function () {
    if (displayNode) {
      var label = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerDocument__["a" /* default */])(displayNode).getElementById(labelId);

      if (label) {
        var handler = function handler() {
          if (getSelection().isCollapsed) {
            displayNode.focus();
          }
        };

        label.addEventListener('click', handler);
        return function () {
          label.removeEventListener('click', handler);
        };
      }
    }

    return undefined;
  }, [labelId, displayNode]);

  var update = function update(open, event) {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };

  var handleClose = function handleClose(event) {
    update(false, event);
  };

  var childrenArray = __WEBPACK_IMPORTED_MODULE_5_react__["Children"].toArray(children); // Support autofill.

  var handleChange = function handleChange(event) {
    var index = childrenArray.map(function (child) {
      return child.props.value;
    }).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    var child = childrenArray[index];
    setValue(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  var handleItemClick = function handleItemClick(child) {
    return function (event) {
      if (!multiple) {
        update(false, event);
      }

      var newValue;

      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];
        var itemIndex = value.indexOf(child.props.value);

        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }

      if (child.props.onClick) {
        child.props.onClick(event);
      }

      if (value === newValue) {
        return;
      }

      setValue(newValue);

      if (onChange) {
        event.persist(); // Preact support, target is read only property on a native event.

        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: newValue,
            name: name
          }
        });
        onChange(event, child);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  var open = displayNode !== null && (isOpenControlled ? openProp : openState);

  var handleBlur = function handleBlur(event) {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      event.persist(); // Preact support, target is read only property on a native event.

      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: value,
          name: name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;
  var foundMatch = false; // No need to display any value if the field is empty.

  if (Object(__WEBPACK_IMPORTED_MODULE_12__InputBase_utils__["b" /* isFilled */])({
    value: value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  var items = childrenArray.map(function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error( false ? "Material-UI: The `value` prop must be an array when using the `Select` component with `multiple`." : Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_utils__["b" /* formatMuiErrorMessage */])(2));
      }

      selected = value.some(function (v) {
        return areEqualValues(v, child.props.value);
      });

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    if (selected) {
      foundMatch = true;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"](child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: function onKeyUp(event) {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected: selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (!foundMatch && !multiple && value !== '') {
        var values = childrenArray.map(function (child) {
          return child.props.value;
        });
        console.warn(["Material-UI: You have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
          return x != null;
        }).map(function (x) {
          return "`".concat(x, "`");
        }).join(', ') || '""', ".")].join('\n'));
      }
    }, [foundMatch, childrenArray, multiple, name, value]);
  }

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  var menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  var tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-disabled": disabled ? 'true' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
    onKeyDown: handleKeyDown,
    onMouseDown: disabled || readOnly ? null : handleMouseDown,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  __WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"]("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    "aria-hidden": true,
    onChange: handleChange,
    tabIndex: -1,
    className: classes.nativeInput,
    autoFocus: autoFocus
  }, other)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(variant))], open && classes.iconOpen, disabled && classes.disabled)
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Menu_Menu__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: "menu-".concat(name || ''),
    anchorEl: displayNode,
    open: open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, MenuProps.PaperProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
 false ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  'aria-label': PropTypes.string,

  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,

  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   */
  open: PropTypes.bool,

  /**
   * @ignore
   */
  readOnly: PropTypes.bool,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  type: PropTypes.any,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (SelectInput);

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useIsFocusVisible__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_useControlled__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ValueLabel__ = __webpack_require__(1971);



















function asc(a, b) {
  return a - b;
}

function clamp(value, min, max) {
  return Math.min(Math.max(min, value), max);
}

function findClosest(values, currentValue) {
  var _values$reduce = values.reduce(function (acc, value, index) {
    var distance = Math.abs(currentValue - value);

    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance: distance,
        index: index
      };
    }

    return acc;
  }, null),
      closestIndex = _values$reduce.index;

  return closestIndex;
}

function trackFinger(event, touchId) {
  if (touchId.current !== undefined && event.changedTouches) {
    for (var i = 0; i < event.changedTouches.length; i += 1) {
      var touch = event.changedTouches[i];

      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }

    return false;
  }

  return {
    x: event.clientX,
    y: event.clientY
  };
}

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}

function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}

function getDecimalPrecision(num) {
  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
  if (Math.abs(num) < 1) {
    var parts = num.toExponential().split('e-');
    var matissaDecimalPart = parts[0].split('.')[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }

  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToStep(value, step, min) {
  var nearest = Math.round((value - min) / step) * step + min;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}

function setValueIndex(_ref) {
  var values = _ref.values,
      source = _ref.source,
      newValue = _ref.newValue,
      index = _ref.index;

  // Performance shortcut
  if (values[index] === newValue) {
    return source;
  }

  var output = values.slice();
  output[index] = newValue;
  return output;
}

function focusThumb(_ref2) {
  var sliderRef = _ref2.sliderRef,
      activeIndex = _ref2.activeIndex,
      setActive = _ref2.setActive;

  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
    sliderRef.current.querySelector("[role=\"slider\"][data-index=\"".concat(activeIndex, "\"]")).focus();
  }

  if (setActive) {
    setActive(activeIndex);
  }
}

var axisProps = {
  horizontal: {
    offset: function offset(percent) {
      return {
        left: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  'horizontal-reverse': {
    offset: function offset(percent) {
      return {
        right: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  vertical: {
    offset: function offset(percent) {
      return {
        bottom: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        height: "".concat(percent, "%")
      };
    }
  }
};

var Identity = function Identity(x) {
  return x;
};

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 2,
      width: '100%',
      boxSizing: 'content-box',
      padding: '13px 0',
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
      touchAction: 'none',
      color: theme.palette.primary.main,
      WebkitTapHighlightColor: 'transparent',
      '&$disabled': {
        pointerEvents: 'none',
        cursor: 'default',
        color: theme.palette.grey[400]
      },
      '&$vertical': {
        width: 2,
        height: '100%',
        padding: '0 13px'
      },
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      '@media (pointer: coarse)': {
        // Reach 42px touch target, about ~8mm on screen.
        padding: '20px 0',
        '&$vertical': {
          padding: '0 20px'
        }
      },
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {// TODO v5: move the style here
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `marks` is provided with at least one label. */
    marked: {
      marginBottom: 20,
      '&$vertical': {
        marginBottom: 'auto',
        marginRight: 20
      }
    },

    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
    vertical: {},

    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the rail element. */
    rail: {
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      opacity: 0.38,
      '$vertical &': {
        height: '100%',
        width: 2
      }
    },

    /* Styles applied to the track element. */
    track: {
      display: 'block',
      position: 'absolute',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      '$vertical &': {
        width: 2
      }
    },

    /* Styles applied to the track element if `track={false}`. */
    trackFalse: {
      '& $track': {
        display: 'none'
      }
    },

    /* Styles applied to the track element if `track="inverted"`. */
    trackInverted: {
      '& $track': {
        backgroundColor: // Same logic as the LinearProgress track color
        theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["e" /* lighten */])(theme.palette.primary.main, 0.62) : Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["b" /* darken */])(theme.palette.primary.main, 0.5)
      },
      '& $rail': {
        opacity: 1
      }
    },

    /* Styles applied to the thumb element. */
    thumb: {
      position: 'absolute',
      width: 12,
      height: 12,
      marginLeft: -6,
      marginTop: -5,
      boxSizing: 'border-box',
      borderRadius: '50%',
      outline: 0,
      backgroundColor: 'currentColor',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: theme.transitions.create(['box-shadow'], {
        duration: theme.transitions.duration.shortest
      }),
      '&::after': {
        position: 'absolute',
        content: '""',
        borderRadius: '50%',
        // reach 42px hit target (2 * 15 + thumb diameter)
        left: -15,
        top: -15,
        right: -15,
        bottom: -15
      },
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, 0.16)),
        '@media (hover: none)': {
          boxShadow: 'none'
        }
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, 0.16))
      },
      '&$disabled': {
        width: 8,
        height: 8,
        marginLeft: -4,
        marginTop: -3,
        '&:hover': {
          boxShadow: 'none'
        }
      },
      '$vertical &': {
        marginLeft: -5,
        marginBottom: -6
      },
      '$vertical &$disabled': {
        marginLeft: -3,
        marginBottom: -4
      }
    },

    /* Styles applied to the thumb element if `color="primary"`. */
    thumbColorPrimary: {// TODO v5: move the style here
    },

    /* Styles applied to the thumb element if `color="secondary"`. */
    thumbColorSecondary: {
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, 0.16))
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(Object(__WEBPACK_IMPORTED_MODULE_10__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, 0.16))
      }
    },

    /* Pseudo-class applied to the thumb element if it's active. */
    active: {},

    /* Pseudo-class applied to the thumb element if keyboard focused. */
    focusVisible: {},

    /* Styles applied to the thumb label element. */
    valueLabel: {
      // IE 11 centering bug, to remove from the customization demos once no longer supported
      left: 'calc(-50% - 4px)'
    },

    /* Styles applied to the mark element. */
    mark: {
      position: 'absolute',
      width: 2,
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the mark element if active (depending on the value). */
    markActive: {
      backgroundColor: theme.palette.background.paper,
      opacity: 0.8
    },

    /* Styles applied to the mark label element. */
    markLabel: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      color: theme.palette.text.secondary,
      position: 'absolute',
      top: 26,
      transform: 'translateX(-50%)',
      whiteSpace: 'nowrap',
      '$vertical &': {
        top: 'auto',
        left: 26,
        transform: 'translateY(50%)'
      },
      '@media (pointer: coarse)': {
        top: 40,
        '$vertical &': {
          left: 31
        }
      }
    }),

    /* Styles applied to the mark label element if active (depending on the value). */
    markLabelActive: {
      color: theme.palette.text.primary
    }
  };
};
var Slider = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function Slider(props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledby = props['aria-labelledby'],
      ariaValuetext = props['aria-valuetext'],
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      getAriaLabel = props.getAriaLabel,
      getAriaValueText = props.getAriaValueText,
      _props$marks = props.marks,
      marksProp = _props$marks === void 0 ? false : _props$marks,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      name = props.name,
      onChange = props.onChange,
      onChangeCommitted = props.onChangeCommitted,
      onMouseDown = props.onMouseDown,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$scale = props.scale,
      scale = _props$scale === void 0 ? Identity : _props$scale,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      _props$ThumbComponent = props.ThumbComponent,
      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
      _props$track = props.track,
      track = _props$track === void 0 ? 'normal' : _props$track,
      valueProp = props.value,
      _props$ValueLabelComp = props.ValueLabelComponent,
      ValueLabelComponent = _props$ValueLabelComp === void 0 ? __WEBPACK_IMPORTED_MODULE_17__ValueLabel__["a" /* default */] : _props$ValueLabelComp,
      _props$valueLabelDisp = props.valueLabelDisplay,
      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
      _props$valueLabelForm = props.valueLabelFormat,
      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_9__styles_useTheme__["a" /* default */])();
  var touchId = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"](); // We can't use the :active browser pseudo-classes.
  // - The active state isn't triggered when clicking on the rail.
  // - The active state isn't transfered when inversing a range slider.

  var _React$useState = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](-1),
      active = _React$useState[0],
      setActive = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](-1),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_16__utils_useControlled__["a" /* default */])({
    controlled: valueProp,
    default: defaultValue,
    name: 'Slider'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      valueDerived = _useControlled2[0],
      setValueState = _useControlled2[1];

  var range = Array.isArray(valueDerived);
  var values = range ? valueDerived.slice().sort(asc) : [valueDerived];
  values = values.map(function (value) {
    return clamp(value, min, max);
  });
  var marks = marksProp === true && step !== null ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
    return {
      value: min + step * index
    };
  }) : marksProp || [];

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useIsFocusVisible__["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](-1),
      focusVisible = _React$useState3[0],
      setFocusVisible = _React$useState3[1];

  var sliderRef = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var handleFocusRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(focusVisibleRef, sliderRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(ref, handleFocusRef);
  var handleFocus = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));

    if (isFocusVisible(event)) {
      setFocusVisible(index);
    }

    setOpen(index);
  });
  var handleBlur = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function () {
    if (focusVisible !== -1) {
      setFocusVisible(-1);
      onBlurVisible();
    }

    setOpen(-1);
  });
  var handleMouseOver = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    setOpen(index);
  });
  var handleMouseLeave = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function () {
    setOpen(-1);
  });
  var isRtl = theme.direction === 'rtl';
  var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    var value = values[index];
    var tenPercents = (max - min) / 10;
    var marksValues = marks.map(function (mark) {
      return mark.value;
    });
    var marksIndex = marksValues.indexOf(value);
    var newValue;
    var increaseKey = isRtl ? 'ArrowLeft' : 'ArrowRight';
    var decreaseKey = isRtl ? 'ArrowRight' : 'ArrowLeft';

    switch (event.key) {
      case 'Home':
        newValue = min;
        break;

      case 'End':
        newValue = max;
        break;

      case 'PageUp':
        if (step) {
          newValue = value + tenPercents;
        }

        break;

      case 'PageDown':
        if (step) {
          newValue = value - tenPercents;
        }

        break;

      case increaseKey:
      case 'ArrowUp':
        if (step) {
          newValue = value + step;
        } else {
          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
        }

        break;

      case decreaseKey:
      case 'ArrowDown':
        if (step) {
          newValue = value - step;
        } else {
          newValue = marksValues[marksIndex - 1] || marksValues[0];
        }

        break;

      default:
        return;
    } // Prevent scroll of the page


    event.preventDefault();

    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    }

    newValue = clamp(newValue, min, max);

    if (range) {
      var previousValue = newValue;
      newValue = setValueIndex({
        values: values,
        source: valueDerived,
        newValue: newValue,
        index: index
      }).sort(asc);
      focusThumb({
        sliderRef: sliderRef,
        activeIndex: newValue.indexOf(previousValue)
      });
    }

    setValueState(newValue);
    setFocusVisible(index);

    if (onChange) {
      onChange(event, newValue);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
  });
  var previousIndex = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var axis = orientation;

  if (isRtl && orientation !== "vertical") {
    axis += '-reverse';
  }

  var getFingerNewValue = function getFingerNewValue(_ref3) {
    var finger = _ref3.finger,
        _ref3$move = _ref3.move,
        move = _ref3$move === void 0 ? false : _ref3$move,
        values2 = _ref3.values,
        source = _ref3.source;
    var slider = sliderRef.current;

    var _slider$getBoundingCl = slider.getBoundingClientRect(),
        width = _slider$getBoundingCl.width,
        height = _slider$getBoundingCl.height,
        bottom = _slider$getBoundingCl.bottom,
        left = _slider$getBoundingCl.left;

    var percent;

    if (axis.indexOf('vertical') === 0) {
      percent = (bottom - finger.y) / height;
    } else {
      percent = (finger.x - left) / width;
    }

    if (axis.indexOf('-reverse') !== -1) {
      percent = 1 - percent;
    }

    var newValue;
    newValue = percentToValue(percent, min, max);

    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    } else {
      var marksValues = marks.map(function (mark) {
        return mark.value;
      });
      var closestIndex = findClosest(marksValues, newValue);
      newValue = marksValues[closestIndex];
    }

    newValue = clamp(newValue, min, max);
    var activeIndex = 0;

    if (range) {
      if (!move) {
        activeIndex = findClosest(values2, newValue);
      } else {
        activeIndex = previousIndex.current;
      }

      var previousValue = newValue;
      newValue = setValueIndex({
        values: values2,
        source: source,
        newValue: newValue,
        index: activeIndex
      }).sort(asc);
      activeIndex = newValue.indexOf(previousValue);
      previousIndex.current = activeIndex;
    }

    return {
      newValue: newValue,
      activeIndex: activeIndex
    };
  };

  var handleTouchMove = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue = getFingerNewValue({
      finger: finger,
      move: true,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue.newValue,
        activeIndex = _getFingerNewValue.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }
  });
  var handleTouchEnd = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue2 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue2.newValue;

    setActive(-1);

    if (event.type === 'touchend') {
      setOpen(-1);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }

    touchId.current = undefined;
    var doc = Object(__WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__["a" /* default */])(sliderRef.current);
    doc.removeEventListener('mousemove', handleTouchMove);
    doc.removeEventListener('mouseup', handleTouchEnd);
    doc.removeEventListener('touchmove', handleTouchMove);
    doc.removeEventListener('touchend', handleTouchEnd);
  });
  var handleTouchStart = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    // Workaround as Safari has partial support for touchAction: 'none'.
    event.preventDefault();
    var touch = event.changedTouches[0];

    if (touch != null) {
      // A number that uniquely identifies the current finger in the touch session.
      touchId.current = touch.identifier;
    }

    var finger = trackFinger(event, touchId);

    var _getFingerNewValue3 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue3.newValue,
        activeIndex = _getFingerNewValue3.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }

    var doc = Object(__WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__["a" /* default */])(sliderRef.current);
    doc.addEventListener('touchmove', handleTouchMove);
    doc.addEventListener('touchend', handleTouchEnd);
  });
  __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"](function () {
    var slider = sliderRef.current;
    slider.addEventListener('touchstart', handleTouchStart);
    var doc = Object(__WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__["a" /* default */])(slider);
    return function () {
      slider.removeEventListener('touchstart', handleTouchStart);
      doc.removeEventListener('mousemove', handleTouchMove);
      doc.removeEventListener('mouseup', handleTouchEnd);
      doc.removeEventListener('touchmove', handleTouchMove);
      doc.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
  var handleMouseDown = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useEventCallback__["a" /* default */])(function (event) {
    if (onMouseDown) {
      onMouseDown(event);
    }

    event.preventDefault();
    var finger = trackFinger(event, touchId);

    var _getFingerNewValue4 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue4.newValue,
        activeIndex = _getFingerNewValue4.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }

    var doc = Object(__WEBPACK_IMPORTED_MODULE_12__utils_ownerDocument__["a" /* default */])(sliderRef.current);
    doc.addEventListener('mousemove', handleTouchMove);
    doc.addEventListener('mouseup', handleTouchEnd);
  });
  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;

  var trackStyle = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_extends__["a" /* default */])({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap));

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_15__utils_capitalize__["a" /* default */])(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
      return mark.label;
    }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
    onMouseDown: handleMouseDown
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
    className: classes.rail
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
    className: classes.track,
    style: trackStyle
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("input", {
    value: values.join(','),
    name: name,
    type: "hidden"
  }), marks.map(function (mark, index) {
    var percent = valueToPercent(mark.value, min, max);
    var style = axisProps[axis].offset(percent);
    var markActive;

    if (track === false) {
      markActive = values.indexOf(mark.value) !== -1;
    } else {
      markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], {
      key: mark.value
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
      style: style,
      "data-index": index,
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.mark, markActive && classes.markActive)
    }), mark.label != null ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
      "aria-hidden": true,
      "data-index": index,
      style: style,
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.markLabel, markActive && classes.markLabelActive)
    }, mark.label) : null);
  }), values.map(function (value, index) {
    var percent = valueToPercent(value, min, max);
    var style = axisProps[axis].offset(percent);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](ValueLabelComponent, {
      key: index,
      valueLabelFormat: valueLabelFormat,
      valueLabelDisplay: valueLabelDisplay,
      className: classes.valueLabel,
      value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
      index: index,
      open: open === index || active === index || valueLabelDisplay === 'on',
      disabled: disabled
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](ThumbComponent, {
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.thumb, classes["thumbColor".concat(Object(__WEBPACK_IMPORTED_MODULE_15__utils_capitalize__["a" /* default */])(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
      tabIndex: disabled ? null : 0,
      role: "slider",
      style: style,
      "data-index": index,
      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
      "aria-labelledby": ariaLabelledby,
      "aria-orientation": orientation,
      "aria-valuemax": scale(max),
      "aria-valuemin": scale(min),
      "aria-valuenow": scale(value),
      "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave
    }));
  }));
});
 false ? Slider.propTypes = {
  /**
   * The label of the slider.
   */
  'aria-label': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-label'] != null) {
      return new Error('Material-UI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
    }

    return null;
  }),

  /**
   * The id of the element containing a label for the slider.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  'aria-valuetext': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-valuetext'] != null) {
      return new Error('Material-UI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * If `true`, the slider will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   *
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes.func,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   *
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes.func,

  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks will be spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   */
  marks: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),

  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   */
  max: PropTypes.number,

  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   */
  min: PropTypes.number,

  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */
  onChange: PropTypes.func,

  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {object} event The event source of the callback.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * The slider orientation.
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * A transformation function, to change the scale of the slider.
   */
  scale: PropTypes.func,

  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   */
  step: PropTypes.number,

  /**
   * The component used to display the value label.
   */
  ThumbComponent: PropTypes.elementType,

  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   */
  track: PropTypes.oneOf(['normal', false, 'inverted']),

  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * The value label component.
   */
  ValueLabelComponent: PropTypes.elementType,

  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   */
  valueLabelDisplay: PropTypes.oneOf(['on', 'auto', 'off']),

  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   */
  valueLabelFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSlider'
})(Slider));

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_withStyles__ = __webpack_require__(8);





var styles = function styles(theme) {
  return {
    thumb: {
      '&$open': {
        '& $offset': {
          transform: 'scale(1) translateY(-10px)'
        }
      }
    },
    open: {},
    offset: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      zIndex: 1
    }, theme.typography.body2, {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.2,
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.shortest
      }),
      top: -34,
      transformOrigin: 'bottom center',
      transform: 'scale(0)',
      position: 'absolute'
    }),
    circle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: 'currentColor',
      transform: 'rotate(-45deg)'
    },
    label: {
      color: theme.palette.primary.contrastText,
      transform: 'rotate(45deg)'
    }
  };
};
/**
 * @ignore - internal component.
 */


function ValueLabel(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      open = props.open,
      value = props.value,
      valueLabelDisplay = props.valueLabelDisplay;

  if (valueLabelDisplay === 'off') {
    return children;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](children, {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.offset, className)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: classes.circle
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", {
    className: classes.label
  }, value))));
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateValueLabel'
})(ValueLabel));

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_transitions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ClickAwayListener__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_deprecatedPropType__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Grow__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SnackbarContent__ = __webpack_require__(596);















var styles = function styles(theme) {
  var top1 = {
    top: 8
  };
  var bottom1 = {
    bottom: 8
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var top3 = {
    top: 24
  };
  var bottom3 = {
    bottom: 24
  };
  var right3 = {
    right: 24
  };
  var left3 = {
    left: 24
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 8,
      right: 8,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom3, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top1, right, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      left: 'auto'
    }, top3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom1, right, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      left: 'auto'
    }, bottom3, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top1, left, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      right: 'auto'
    }, top3, left3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom1, left, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      right: 'auto'
    }, bottom3, left3)))
  };
};
var Snackbar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Snackbar(props, ref) {
  var action = props.action,
      _props$anchorOrigin = props.anchorOrigin;
  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'bottom',
    horizontal: 'center'
  } : _props$anchorOrigin;

  var vertical = _props$anchorOrigin.vertical,
      horizontal = _props$anchorOrigin.horizontal,
      _props$autoHideDurati = props.autoHideDuration,
      autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
      children = props.children,
      classes = props.classes,
      className = props.className,
      ClickAwayListenerProps = props.ClickAwayListenerProps,
      ContentProps = props.ContentProps,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      message = props.message,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      open = props.open,
      resumeHideDuration = props.resumeHideDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_13__Grow__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? {
    enter: __WEBPACK_IMPORTED_MODULE_7__styles_transitions__["b" /* duration */].enteringScreen,
    exit: __WEBPACK_IMPORTED_MODULE_7__styles_transitions__["b" /* duration */].leavingScreen
  } : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var timerAutoHide = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"]();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var handleClose = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function () {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }

    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function () {
      handleClose(null, 'timeout');
    }, autoHideDurationParam);
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }

    return function () {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.

  var handlePause = function handlePause() {
    clearTimeout(timerAutoHide.current);
  }; // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.


  var handleResume = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function () {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    handleResume();
  };

  var handleClickAway = function handleClickAway(event) {
    if (onClose) {
      onClose(event, 'clickaway');
    }
  };

  var handleExited = function handleExited() {
    setExited(true);
  };

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.

  if (!open && exited) {
    return null;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ClickAwayListener__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["anchorOrigin".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(vertical)).concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(horizontal))], className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    onEnter: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(handleEnter, onEnter),
    onEntered: onEntered,
    onEntering: onEntering,
    onExit: onExit,
    onExited: Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(handleExited, onExited),
    onExiting: onExiting,
    timeout: transitionDuration,
    direction: vertical === 'top' ? 'down' : 'up'
  }, TransitionProps), children || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__SnackbarContent__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    message: message,
    action: action
  }, ContentProps)))));
});
 false ? Snackbar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['center', 'left', 'right']).isRequired,
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: PropTypes.number,

  /**
   * Replace the `SnackbarContent` component.
   */
  children: PropTypes.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: PropTypes.object,

  /**
   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
   */
  ContentProps: PropTypes.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: PropTypes.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: PropTypes.any,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the transition is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEnter: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the transition has entered.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntered: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the transition is entering.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onEntering: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired before the transition is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExit: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the transition has exited.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExited: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * Callback fired when the transition is exiting.
   * @deprecated Use the `TransitionProps` prop instead.
   */
  onExiting: deprecatedPropType(PropTypes.func, 'Use the `TransitionProps` prop instead.'),

  /**
   * @ignore
   */
  onMouseEnter: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * If `true`, `Snackbar` is open.
   */
  open: PropTypes.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: PropTypes.number,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar));

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__ = __webpack_require__(71);









var styles = function styles(theme) {
  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["c" /* emphasize */])(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      flexGrow: 1
    }, theme.breakpoints.up('sm'), {
      flexGrow: 'initial',
      minWidth: 288
    })),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var SnackbarContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function SnackbarContent(props, ref) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "classes", "className", "message", "role"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: role,
    square: true,
    elevation: 6,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: classes.message
  }, message), action ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: classes.action
  }, action) : null);
});
 false ? SnackbarContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent));

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);







var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    paddingLeft: 8,
    paddingRight: 8
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {},

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    flex: 1,
    position: 'relative'
  },

  /* Pseudo-class applied to the root element if `completed={true}`. */
  completed: {}
};
var Step = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Step(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      connectorProp = props.connector,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$expanded = props.expanded,
      expanded = _props$expanded === void 0 ? false : _props$expanded,
      index = props.index,
      last = props.last,
      orientation = props.orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "expanded", "index", "last", "orientation"]);

  var connector = connectorProp ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](connectorProp, {
    orientation: orientation,
    alternativeLabel: alternativeLabel,
    index: index,
    active: active,
    completed: completed,
    disabled: disabled
  }) : null;
  var newChildren = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
    ref: ref
  }, other), connector && alternativeLabel && index !== 0 ? connector : null, __WEBPACK_IMPORTED_MODULE_2_react__["Children"].map(children, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      active: active,
      alternativeLabel: alternativeLabel,
      completed: completed,
      disabled: disabled,
      expanded: expanded,
      last: last,
      icon: index + 1,
      orientation: orientation
    }, child.props));
  }));

  if (connector && !alternativeLabel && index !== 0) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, connector, newChildren);
  }

  return newChildren;
});
 false ? Step.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Sets the step as active. Is passed to child components.
   */
  active: PropTypes.bool,

  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: PropTypes.bool,

  /**
   * Expand the step.
   */
  expanded: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStep'
})(Step));

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepLabel__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(264);









var styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    padding: '24px 16px',
    margin: '-24px -16px',
    boxSizing: 'content-box'
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {},

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    justifyContent: 'flex-start',
    padding: '8px',
    margin: '-8px'
  },

  /* Styles applied to the `ButtonBase` touch-ripple. */
  touchRipple: {
    color: 'rgba(0, 0, 0, 0.3)'
  }
};
var StepButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function StepButton(props, ref) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      disabled = props.disabled,
      expanded = props.expanded,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "expanded", "icon", "last", "optional", "orientation"]);

  var childProps = {
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    icon: icon,
    optional: optional,
    orientation: orientation
  };
  var child = Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(children, ['StepLabel']) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](children, childProps) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__StepLabel__["a" /* default */], childProps, children);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: true,
    disabled: disabled,
    TouchRippleProps: {
      className: classes.touchRipple
    },
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className),
    ref: ref
  }, other), child);
});
 false ? StepButton.propTypes = {
  /**
   * @ignore
   * Passed in via `Step` - passed through to `StepLabel`.
   */
  active: PropTypes.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: PropTypes.bool,

  /**
   * @ignore
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: PropTypes.bool,

  /**
   * @ignore
   * potentially passed from parent `Step`
   */
  expanded: PropTypes.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   */
  last: PropTypes.bool,

  /**
   * The optional node to display.
   */
  optional: PropTypes.node,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepButton'
})(StepButton));

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepIcon__ = __webpack_require__(598);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      alignItems: 'center',
      '&$alternativeLabel': {
        flexDirection: 'column'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {},

    /* Styles applied to the `Typography` component which wraps `children`. */
    label: {
      color: theme.palette.text.secondary,
      '&$active': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$completed': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$alternativeLabel': {
        textAlign: 'center',
        marginTop: 16
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the `icon` container element. */
    iconContainer: {
      flexShrink: 0,
      // Fix IE 11 issue
      display: 'flex',
      paddingRight: 8,
      '&$alternativeLabel': {
        paddingRight: 0
      }
    },

    /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */
    alternativeLabel: {},

    /* Styles applied to the container element which wraps `Typography` and `optional`. */
    labelContainer: {
      width: '100%'
    }
  };
};
var StepLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function StepLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      expanded = props.expanded,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      StepIconComponentProp = props.StepIconComponent,
      StepIconProps = props.StepIconProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "expanded", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);

  var StepIconComponent = StepIconComponentProp;

  if (icon && !StepIconComponent) {
    StepIconComponent = __WEBPACK_IMPORTED_MODULE_7__StepIcon__["a" /* default */];
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
    ref: ref
  }, other), icon || StepIconComponent ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](StepIconComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    completed: completed,
    active: active,
    error: error,
    icon: icon
  }, StepIconProps))) : null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.labelContainer
  }, children ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], {
    variant: "body2",
    component: "span",
    display: "block",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error)
  }, children) : null, optional));
});
 false ? StepLabel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: PropTypes.bool,

  /**
   * Mark the step as failed.
   */
  error: PropTypes.bool,

  /**
   * Override the default label of the step icon.
   */
  icon: PropTypes.node,

  /**
   * The optional node to display.
   */
  optional: PropTypes.node,

  /**
   * The component to render in place of the [`StepIcon`](/api/step-icon/).
   */
  StepIconComponent: PropTypes.elementType,

  /**
   * Props applied to the [`StepIcon`](/api/step-icon/) element.
   */
  StepIconProps: PropTypes.object
} : void 0;
StepLabel.muiName = 'StepLabel';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepLabel'
})(StepLabel));

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_CheckCircle__ = __webpack_require__(1978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_Warning__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SvgIcon__ = __webpack_require__(415);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      color: theme.palette.text.disabled,
      '&$completed': {
        color: theme.palette.primary.main
      },
      '&$active': {
        color: theme.palette.primary.main
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the SVG text element. */
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {}
  };
};

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle", {
  cx: "12",
  cy: "12",
  r: "12"
});

var StepIcon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function StepIcon(props, ref) {
  var _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      icon = props.icon,
      _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      classes = props.classes;

  if (typeof icon === 'number' || typeof icon === 'string') {
    var className = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.root, active && classes.active, error && classes.error, completed && classes.completed);

    if (error) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_Warning__["a" /* default */], {
        className: className,
        ref: ref
      });
    }

    if (completed) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_CheckCircle__["a" /* default */], {
        className: className,
        ref: ref
      });
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__SvgIcon__["a" /* default */], {
      className: className,
      ref: ref
    }, _ref, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("text", {
      className: classes.text,
      x: "12",
      y: "16",
      textAnchor: "middle"
    }, icon));
  }

  return icon;
});
 false ? StepIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,

  /**
   * Mark the step as failed.
   */
  error: PropTypes.bool,

  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepIcon'
})(StepIcon));

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle'));

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning'));

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto'
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      marginLeft: 12,
      // half icon
      padding: '0 0 8px'
    },

    /* Styles applied to the root element if `alternativeLabel={true}`. */
    alternativeLabel: {
      position: 'absolute',
      top: 8 + 4,
      left: 'calc(-50% + 20px)',
      right: 'calc(50% + 20px)'
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the line element. */
    line: {
      display: 'block',
      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    lineHorizontal: {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    lineVertical: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: 24
    }
  };
};
var StepConnector = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function StepConnector(props, ref) {
  var active = props.active,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      disabled = props.disabled,
      index = props.index,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.line, {
      'horizontal': classes.lineHorizontal,
      'vertical': classes.lineVertical
    }[orientation])
  }));
});
 false ? StepConnector.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepConnector'
})(StepConnector));

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginTop: 8,
      marginLeft: 12,
      // half icon
      paddingLeft: 8 + 12,
      // margin + half icon
      paddingRight: 8,
      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    },

    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
    last: {
      borderLeft: 'none'
    },

    /* Styles applied to the Transition component. */
    transition: {}
  };
};
var StepContent = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function StepContent(props, ref) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      expanded = props.expanded,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "expanded", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  if (false) {
    if (orientation !== 'vertical') {
      console.error('Material-UI: <StepContent /> is only designed for use with the vertical stepper.');
    }
  }

  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, last && classes.last),
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: active || expanded,
    className: classes.transition,
    timeout: transitionDuration,
    unmountOnExit: true
  }, TransitionProps), children));
});
 false ? StepContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Step content.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Adjust the duration of the content expand transition.
   * Passed as a prop to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepContent'
})(StepContent));

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Paper__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepConnector__ = __webpack_require__(599);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: 24
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    flexDirection: 'column'
  },

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    alignItems: 'flex-start'
  }
};
var defaultConnector = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__StepConnector__["a" /* default */], null);
var Stepper = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Stepper(props, ref) {
  var _props$activeStep = props.activeStep,
      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$connector = props.connector,
      connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector,
      _props$nonLinear = props.nonLinear,
      nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);

  var connector = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["isValidElement"](connectorProp) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](connectorProp, {
    orientation: orientation
  }) : null;
  var childrenArray = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children);
  var steps = childrenArray.map(function (step, index) {
    var state = {
      index: index,
      active: false,
      completed: false,
      disabled: false
    };

    if (activeStep === index) {
      state.active = true;
    } else if (!nonLinear && activeStep > index) {
      state.completed = true;
    } else if (!nonLinear && activeStep < index) {
      state.disabled = true;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"](step, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      alternativeLabel: alternativeLabel,
      connector: connector,
      last: index + 1 === childrenArray.length,
      orientation: orientation
    }, state, step.props));
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    square: true,
    elevation: 0,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
    ref: ref
  }, other), steps);
});
 false ? Stepper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   */
  activeStep: PropTypes.number,

  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Two or more `<Step />` components.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * An element to be placed between each step.
   */
  connector: PropTypes.element,

  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: PropTypes.bool,

  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepper'
})(Stepper));

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_styles__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_transitions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transitions_utils__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NoSsr__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SwipeArea__ = __webpack_require__(1984);














 // This value is closed to what browsers are using internally to
// trigger a native scroll.

var UNCERTAINTY_THRESHOLD = 3; // px
// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.

var nodeThatClaimedTheSwipe = null; // Exported for test purposes.

function reset() {
  nodeThatClaimedTheSwipe = null;
}

function calculateCurrentX(anchor, touches) {
  return anchor === 'right' ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}

function calculateCurrentY(anchor, touches) {
  return anchor === 'bottom' ? window.innerHeight - touches[0].clientY : touches[0].clientY;
}

function getMaxTranslate(horizontalSwipe, paperInstance) {
  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}

function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}

function getDomTreeShapes(element, rootNode) {
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    var style = window.getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push(element);
    }

    element = element.parentElement;
  }

  return domTreeShapes;
}

function findNativeHandler(_ref) {
  var domTreeShapes = _ref.domTreeShapes,
      start = _ref.start,
      current = _ref.current,
      anchor = _ref.anchor;
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
  var axisProperties = {
    scrollPosition: {
      x: 'scrollLeft',
      y: 'scrollTop'
    },
    scrollLength: {
      x: 'scrollWidth',
      y: 'scrollHeight'
    },
    clientLength: {
      x: 'clientWidth',
      y: 'clientHeight'
    }
  };
  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = current >= start;

    if (anchor === 'top' || anchor === 'left') {
      goingForward = !goingForward;
    }

    var axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      return shape;
    }

    return null;
  });
}

var iOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
var transitionDurationDefault = {
  enter: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].leavingScreen
};
var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"];
var SwipeableDrawer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function SwipeableDrawer(inProps, ref) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_11__styles_useTheme__["a" /* default */])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_styles__["b" /* getThemeProps */])({
    name: 'MuiSwipeableDrawer',
    props: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inProps),
    theme: theme
  });
  var _props$anchor = props.anchor,
      anchor = _props$anchor === void 0 ? 'left' : _props$anchor,
      _props$disableBackdro = props.disableBackdropTransition,
      disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableDiscove = props.disableDiscovery,
      disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove,
      _props$disableSwipeTo = props.disableSwipeToOpen,
      disableSwipeToOpen = _props$disableSwipeTo === void 0 ? iOS : _props$disableSwipeTo,
      hideBackdrop = props.hideBackdrop,
      _props$hysteresis = props.hysteresis,
      hysteresis = _props$hysteresis === void 0 ? 0.52 : _props$hysteresis,
      _props$minFlingVeloci = props.minFlingVelocity,
      minFlingVelocity = _props$minFlingVeloci === void 0 ? 450 : _props$minFlingVeloci,
      _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

  var BackdropProps = _props$ModalProps.BackdropProps,
      ModalPropsProp = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ModalProps, ["BackdropProps"]),
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      SwipeAreaProps = props.SwipeAreaProps,
      _props$swipeAreaWidth = props.swipeAreaWidth,
      swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](false),
      maybeSwiping = _React$useState[0],
      setMaybeSwiping = _React$useState[1];

  var swipeInstance = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]({
    isSwiping: null
  });
  var swipeAreaRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();
  var backdropRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();
  var paperRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();
  var touchDetected = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](false); // Ref for transition duration based on / to match swipe speed

  var calculatedDurationRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](); // Use a ref so the open value used is always up to date inside useCallback.

  useEnhancedEffect(function () {
    calculatedDurationRef.current = null;
  }, [open]);
  var setPosition = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (translate) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$mode = options.mode,
        mode = _options$mode === void 0 ? null : _options$mode,
        _options$changeTransi = options.changeTransition,
        changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
    var horizontalSwipe = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
    var drawerStyle = paperRef.current.style;
    drawerStyle.webkitTransform = transform;
    drawerStyle.transform = transform;
    var transition = '';

    if (mode) {
      transition = theme.transitions.create('all', Object(__WEBPACK_IMPORTED_MODULE_12__transitions_utils__["a" /* getTransitionProps */])({
        timeout: transitionDuration
      }, {
        mode: mode
      }));
    }

    if (changeTransition) {
      drawerStyle.webkitTransition = transition;
      drawerStyle.transition = transition;
    }

    if (!disableBackdropTransition && !hideBackdrop) {
      var backdropStyle = backdropRef.current.style;
      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);

      if (changeTransition) {
        backdropStyle.webkitTransition = transition;
        backdropStyle.transition = transition;
      }
    }
  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
  var handleBodyTouchEnd = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function (event) {
    if (!touchDetected.current) {
      return;
    }

    nodeThatClaimedTheSwipe = null;
    touchDetected.current = false;
    setMaybeSwiping(false); // The swipe wasn't started.

    if (!swipeInstance.current.isSwiping) {
      swipeInstance.current.isSwiping = null;
      return;
    }

    swipeInstance.current.isSwiping = null;
    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var horizontal = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var current;

    if (horizontal) {
      current = calculateCurrentX(anchorRtl, event.changedTouches);
    } else {
      current = calculateCurrentY(anchorRtl, event.changedTouches);
    }

    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
    var currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
    var translateRatio = currentTranslate / maxTranslate;

    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
      // Calculate transition duration to match swipe speed
      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
    }

    if (open) {
      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
        onClose();
      } else {
        // Reset the position, the swipe was aborted.
        setPosition(0, {
          mode: 'exit'
        });
      }

      return;
    }

    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
      onOpen();
    } else {
      // Reset the position, the swipe was aborted.
      setPosition(getMaxTranslate(horizontal, paperRef.current), {
        mode: 'enter'
      });
    }
  });
  var handleBodyTouchMove = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function (event) {
    // the ref may be null when a parent component updates while swiping
    if (!paperRef.current || !touchDetected.current) {
      return;
    } // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer


    if (nodeThatClaimedTheSwipe != null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
      return;
    }

    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var horizontalSwipe = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);

    if (open && paperRef.current.contains(event.target) && nodeThatClaimedTheSwipe == null) {
      var domTreeShapes = getDomTreeShapes(event.target, paperRef.current);
      var nativeHandler = findNativeHandler({
        domTreeShapes: domTreeShapes,
        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
        current: horizontalSwipe ? currentX : currentY,
        anchor: anchor
      });

      if (nativeHandler) {
        nodeThatClaimedTheSwipe = nativeHandler;
        return;
      }

      nodeThatClaimedTheSwipe = swipeInstance.current;
    } // We don't know yet.


    if (swipeInstance.current.isSwiping == null) {
      var dx = Math.abs(currentX - swipeInstance.current.startX);
      var dy = Math.abs(currentY - swipeInstance.current.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.

      if (dx > dy) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }

      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;

      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
        swipeInstance.current.isSwiping = definitelySwiping;

        if (!definitelySwiping) {
          handleBodyTouchEnd(event);
          return;
        } // Shift the starting point.


        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.

        if (!disableDiscovery && !open) {
          if (horizontalSwipe) {
            swipeInstance.current.startX -= swipeAreaWidth;
          } else {
            swipeInstance.current.startY -= swipeAreaWidth;
          }
        }
      }
    }

    if (!swipeInstance.current.isSwiping) {
      return;
    }

    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;

    if (open && !swipeInstance.current.paperHit) {
      startLocation = Math.min(startLocation, maxTranslate);
    }

    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);

    if (open) {
      if (!swipeInstance.current.paperHit) {
        var paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;

        if (paperHit) {
          swipeInstance.current.paperHit = true;
          swipeInstance.current.startX = currentX;
          swipeInstance.current.startY = currentY;
        } else {
          return;
        }
      } else if (translate === 0) {
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
      }
    }

    if (swipeInstance.current.lastTranslate === null) {
      swipeInstance.current.lastTranslate = translate;
      swipeInstance.current.lastTime = performance.now() + 1;
    }

    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.

    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
    swipeInstance.current.lastTranslate = translate;
    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.

    if (event.cancelable) {
      event.preventDefault();
    }

    setPosition(translate);
  });
  var handleBodyTouchStart = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useEventCallback__["a" /* default */])(function (event) {
    // We are not supposed to handle this touch move.
    // Example of use case: ignore the event if there is a Slider.
    if (event.defaultPrevented) {
      return;
    } // We can only have one node at the time claiming ownership for handling the swipe.


    if (event.muiHandled) {
      return;
    } // At least one element clogs the drawer interaction zone.


    if (open && !backdropRef.current.contains(event.target) && !paperRef.current.contains(event.target)) {
      return;
    }

    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var horizontalSwipe = Object(__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);

    if (!open) {
      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
        return;
      }

      if (horizontalSwipe) {
        if (currentX > swipeAreaWidth) {
          return;
        }
      } else if (currentY > swipeAreaWidth) {
        return;
      }
    }

    event.muiHandled = true;
    nodeThatClaimedTheSwipe = null;
    swipeInstance.current.startX = currentX;
    swipeInstance.current.startY = currentY;
    setMaybeSwiping(true);

    if (!open && paperRef.current) {
      // The ref may be null when a parent component updates while swiping.
      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
        changeTransition: false
      });
    }

    swipeInstance.current.velocity = 0;
    swipeInstance.current.lastTime = null;
    swipeInstance.current.lastTranslate = null;
    swipeInstance.current.paperHit = false;
    touchDetected.current = true;
  });
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (variant === 'temporary') {
      var doc = Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(paperRef.current);
      doc.addEventListener('touchstart', handleBodyTouchStart);
      doc.addEventListener('touchmove', handleBodyTouchMove, {
        passive: false
      });
      doc.addEventListener('touchend', handleBodyTouchEnd);
      return function () {
        doc.removeEventListener('touchstart', handleBodyTouchStart);
        doc.removeEventListener('touchmove', handleBodyTouchMove, {
          passive: false
        });
        doc.removeEventListener('touchend', handleBodyTouchEnd);
      };
    }

    return undefined;
  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    return function () {
      // We need to release the lock.
      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
        nodeThatClaimedTheSwipe = null;
      }
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    if (!open) {
      setMaybeSwiping(false);
    }
  }, [open]);
  var handleBackdropRef = __WEBPACK_IMPORTED_MODULE_2_react__["useCallback"](function (instance) {
    // #StrictMode ready
    backdropRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"](instance);
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Drawer_Drawer__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    open: variant === 'temporary' && maybeSwiping ? true : open,
    variant: variant,
    ModalProps: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, BackdropProps, {
        ref: handleBackdropRef
      })
    }, ModalPropsProp),
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        pointerEvents: variant === 'temporary' && !open ? 'none' : ''
      }, PaperProps.style),
      ref: paperRef
    }),
    anchor: anchor,
    transitionDuration: calculatedDurationRef.current || transitionDuration,
    onClose: onClose,
    ref: ref
  }, other)), !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__NoSsr__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__SwipeArea__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    anchor: anchor,
    ref: swipeAreaRef,
    width: swipeAreaWidth
  }, SwipeAreaProps))));
});
 false ? SwipeableDrawer.propTypes = {
  /**
   * @ignore
   */
  anchor: PropTypes.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   */
  disableBackdropTransition: PropTypes.bool,

  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   */
  disableDiscovery: PropTypes.bool,

  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   */
  disableSwipeToOpen: PropTypes.bool,

  /**
   * @ignore
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Affects how far the drawer must be opened/closed to change his state.
   * Specified as percent (0-1) of the width of the drawer
   */
  hysteresis: PropTypes.number,

  /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   */
  minFlingVelocity: PropTypes.number,

  /**
   * @ignore
   */
  ModalProps: PropTypes.shape({
    BackdropProps: PropTypes.shape({
      component: elementTypeAcceptingRef
    })
  }),

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func.isRequired,

  /**
   * If `true`, the drawer is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef,
    style: PropTypes.object
  }),

  /**
   * The element is used to intercept the touch events on the edge.
   */
  SwipeAreaProps: PropTypes.object,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  swipeAreaWidth: PropTypes.number,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * @ignore
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (SwipeableDrawer);

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Drawer_Drawer__ = __webpack_require__(579);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      zIndex: theme.zIndex.drawer - 1
    },
    anchorLeft: {
      right: 'auto'
    },
    anchorRight: {
      left: 'auto',
      right: 0
    },
    anchorTop: {
      bottom: 'auto',
      right: 0
    },
    anchorBottom: {
      top: 'auto',
      bottom: 0,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */

var SwipeArea = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function SwipeArea(props, ref) {
  var anchor = props.anchor,
      classes = props.classes,
      className = props.className,
      width = props.width,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchor", "classes", "className", "width"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["anchor".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(anchor))], className),
    ref: ref,
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__Drawer_Drawer__["c" /* isHorizontal */])(anchor) ? 'width' : 'height', width)
  }, other));
});
 false ? SwipeArea.propTypes = {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: PropTypes.oneOf(['left', 'top', 'right', 'bottom']).isRequired,

  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  width: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateSwipeArea'
})(SwipeArea));

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_SwitchBase__ = __webpack_require__(576);


// @inheritedComponent IconButton








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: 'hidden',
      padding: 12,
      boxSizing: 'border-box',
      position: 'relative',
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: 'middle',
      // For correct alignment with the text.
      '@media print': {
        colorAdjust: 'exact'
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -8
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -8
    },

    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create(['left', 'transform'], {
        duration: theme.transitions.duration.shortest
      }),
      '&$checked': {
        transform: 'translateX(20px)'
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        opacity: 0.5
      },
      '&$disabled + $track': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.primary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.secondary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      width: 40,
      height: 24,
      padding: 7,
      '& $thumb': {
        width: 16,
        height: 16
      },
      '& $switchBase': {
        padding: 4,
        '&$checked': {
          transform: 'translateX(16px)'
        }
      }
    },

    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
    checked: {},

    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
    disabled: {},

    /* Styles applied to the internal SwitchBase component's input element. */
    input: {
      left: '-100%',
      width: '300%'
    },

    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
    thumb: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    /* Styles applied to the track element. */
    track: {
      height: '100%',
      width: '100%',
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};
var Switch = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Switch(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "edge", "size"]);

  var icon = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.thumb
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge], size === "small" && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))])
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__internal_SwitchBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    type: "checkbox",
    icon: icon,
    checkedIcon: icon,
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.switchBase, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(color))]),
      input: classes.input,
      checked: classes.checked,
      disabled: classes.disabled
    },
    ref: ref
  }, other)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", {
    className: classes.track
  }));
});
 false ? Switch.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['end', 'start', false]),

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the switch.
   * `small` is equivalent to the dense switch styling.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSwitch'
})(Switch));

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_unsupportedProp__ = __webpack_require__(417);










var styles = function styles(theme) {
  var _extends2;

  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, (_extends2 = {
      maxWidth: 264,
      minWidth: 72,
      position: 'relative',
      boxSizing: 'border-box',
      minHeight: 48,
      flexShrink: 0,
      padding: '6px 12px'
    }, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, theme.breakpoints.up('sm'), {
      padding: '6px 24px'
    }), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, "overflow", 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, "whiteSpace", 'normal'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, "textAlign", 'center'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, theme.breakpoints.up('sm'), {
      minWidth: 160
    }), _extends2)),

    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      minHeight: 72,
      paddingTop: 9,
      '& $wrapper > *:first-child': {
        marginBottom: 6
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
    textColorInherit: {
      color: 'inherit',
      opacity: 0.7,
      '&$selected': {
        opacity: 1
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
    textColorPrimary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
    textColorSecondary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},

    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: 'none'
    },

    /* Styles applied to the root element if `wrapped={true}`. */
    wrapped: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.5
    },

    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    }
  };
};
var Tab = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Tab(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      fullWidth = props.fullWidth,
      icon = props.icon,
      indicator = props.indicator,
      label = props.label,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      selected = props.selected,
      selectionFollowsFocus = props.selectionFollowsFocus,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
      value = props.value,
      _props$wrapped = props.wrapped,
      wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"]);

  var handleClick = function handleClick(event) {
    if (onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event, value);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: !disableFocusRipple,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["textColor".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
    ref: ref,
    role: "tab",
    "aria-selected": selected,
    disabled: disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    tabIndex: selected ? 0 : -1
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("span", {
    className: classes.wrapper
  }, icon, label), indicator);
});
 false ? Tab.propTypes = {
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the tab will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  fullWidth: PropTypes.bool,

  /**
   * The icon element.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   * For server-side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: PropTypes.node,

  /**
   * The label element.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  selectionFollowsFocus: PropTypes.bool,

  /**
   * @ignore
   */
  textColor: PropTypes.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any,

  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   */
  wrapped: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTab'
})(Tab));

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableContext__ = __webpack_require__(1000);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    },

    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: 'separate'
    }
  };
};
var defaultComponent = 'table';
var Table = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function Table(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 'normal' : _props$padding,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react__["useMemo"](function () {
    return {
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__TableContext__["a" /* default */].Provider, {
    value: table
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: Component === defaultComponent ? null : 'table',
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
 false ? Table.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Allows TableCells to inherit padding of the Table.
   * `default` is deprecated, use `normal` instead.
   */
  padding: chainPropTypes(PropTypes.oneOf(['normal', 'checkbox', 'none', 'default']), function (props) {
    if (props.padding === 'default') {
      return new Error('Material-UI: padding="default" was renamed to padding="normal" for consistency.');
    }

    return null;
  }),

  /**
   * Allows TableCells to inherit size of the Table.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE 11.
   */
  stickyHeader: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTable'
})(Table));

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(322);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
var tablelvl2 = {
  variant: 'body'
};
var defaultComponent = 'tbody';
var TableBody = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableBody(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableBody'
})(TableBody));

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table_TableContext__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Table_Tablelvl2Context__ = __webpack_require__(322);











var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["e" /* lighten */])(Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["a" /* alpha */])(theme.palette.divider, 1), 0.88) : Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["b" /* darken */])(Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["a" /* alpha */])(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }),

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '6px 24px 6px 16px',
      '&:last-child': {
        paddingRight: 16
      },
      '&$paddingCheckbox': {
        width: 24,
        // prevent the checkbox column from growing
        padding: '0 12px 0 16px',
        '&:last-child': {
          paddingLeft: 12,
          paddingRight: 16
        },
        '& > *': {
          padding: 0
        }
      }
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px',
      '&:last-child': {
        paddingLeft: 0,
        paddingRight: 4
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

var TableCell = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableCell(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      component = props.component,
      paddingProp = props.padding,
      scopeProp = props.scope,
      sizeProp = props.size,
      sortDirection = props.sortDirection,
      variantProp = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_9__Table_TableContext__["a" /* default */]);
  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_10__Table_Tablelvl2Context__["a" /* default */]);
  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  var role;
  var Component;

  if (component) {
    Component = component;
    role = isHeadCell ? 'columnheader' : 'cell';
  } else {
    Component = isHeadCell ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'normal');
  var size = sizeProp || (table && table.size ? table.size : 'medium');
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(align))], padding !== 'normal' && classes["padding".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(padding))], size !== 'medium' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
    "aria-sort": ariaSort,
    role: role,
    scope: scope
  }, other));
});
 false ? TableCell.propTypes = {
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: PropTypes.oneOf(['center', 'inherit', 'justify', 'left', 'right']),

  /**
   * The table cell contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (`normal`).
   * `default` is deprecated, use `normal` instead.
   */
  padding: chainPropTypes(PropTypes.oneOf(['normal', 'checkbox', 'none', 'default']), function (props) {
    if (props.padding === 'default') {
      return new Error('Material-UI: padding="default" was renamed to padding="normal" for consistency.');
    }

    return null;
  }),

  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,

  /**
   * Specify the size of the cell.
   * By default, the Table parent component set the value (`medium`).
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: PropTypes.oneOf(['body', 'footer', 'head'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableCell'
})(TableCell));

/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);






var styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    overflowX: 'auto'
  }
};
var TableContainer = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableContainer(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className)
  }, other));
});
 false ? TableContainer.propTypes = {
  /**
   * The table itself, normally `<Table />`
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableContainer'
})(TableContainer));

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(322);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-footer-group'
  }
};
var tablelvl2 = {
  variant: 'footer'
};
var defaultComponent = 'tfoot';
var TableFooter = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableFooter(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableFooter.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableFooter'
})(TableFooter));

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(322);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
var tablelvl2 = {
  variant: 'head'
};
var defaultComponent = 'thead';
var TableHead = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableHead(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: Component === defaultComponent ? null : 'rowgroup'
  }, other)));
});
 false ? TableHead.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableHead'
})(TableHead));

/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_deprecatedPropType__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputBase__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MenuItem__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Select__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableCell__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Toolbar__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Typography__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TablePaginationActions__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__ = __webpack_require__(418);
















var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      overflow: 'auto',
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the Toolbar component. */
    toolbar: {
      minHeight: 52,
      paddingRight: 2
    },

    /* Styles applied to the spacer element. */
    spacer: {
      flex: '1 1 100%'
    },

    /* Styles applied to the caption Typography components if `variant="caption"`. */
    caption: {
      flexShrink: 0
    },
    // TODO v5: `.selectRoot` should be merged with `.input`

    /* Styles applied to the Select component root element. */
    selectRoot: {
      marginRight: 32,
      marginLeft: 8
    },

    /* Styles applied to the Select component `select` class. */
    select: {
      paddingLeft: 8,
      paddingRight: 24,
      textAlign: 'right',
      textAlignLast: 'right' // Align <select> on Chrome.

    },
    // TODO v5: remove

    /* Styles applied to the Select component `icon` class. */
    selectIcon: {},

    /* Styles applied to the `InputBase` component. */
    input: {
      color: 'inherit',
      fontSize: 'inherit',
      flexShrink: 0
    },

    /* Styles applied to the MenuItem component. */
    menuItem: {},

    /* Styles applied to the internal `TablePaginationActions` component. */
    actions: {
      flexShrink: 0,
      marginLeft: 20
    }
  };
};

var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
  var from = _ref.from,
      to = _ref.to,
      count = _ref.count;
  return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
};

var defaultRowsPerPageOptions = [10, 25, 50, 100];
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */

var TablePagination = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TablePagination(props, ref) {
  var _props$ActionsCompone = props.ActionsComponent,
      ActionsComponent = _props$ActionsCompone === void 0 ? __WEBPACK_IMPORTED_MODULE_14__TablePaginationActions__["a" /* default */] : _props$ActionsCompone,
      backIconButtonProps = props.backIconButtonProps,
      _props$backIconButton = props.backIconButtonText,
      backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton,
      classes = props.classes,
      className = props.className,
      colSpanProp = props.colSpan,
      _props$component = props.component,
      Component = _props$component === void 0 ? __WEBPACK_IMPORTED_MODULE_11__TableCell__["a" /* default */] : _props$component,
      count = props.count,
      _props$labelDisplayed = props.labelDisplayedRows,
      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
      _props$labelRowsPerPa = props.labelRowsPerPage,
      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
      nextIconButtonProps = props.nextIconButtonProps,
      _props$nextIconButton = props.nextIconButtonText,
      nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton,
      onChangePage = props.onChangePage,
      onPageChange = props.onPageChange,
      onChangeRowsPerPageProp = props.onChangeRowsPerPage,
      onRowsPerPageChangeProp = props.onRowsPerPageChange,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      _props$rowsPerPageOpt = props.rowsPerPageOptions,
      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
      _props$SelectProps = props.SelectProps,
      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["ActionsComponent", "backIconButtonProps", "backIconButtonText", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "nextIconButtonText", "onChangePage", "onPageChange", "onChangeRowsPerPage", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);

  var onChangeRowsPerPage = onChangeRowsPerPageProp || onRowsPerPageChangeProp;
  var colSpan;

  if (Component === __WEBPACK_IMPORTED_MODULE_11__TableCell__["a" /* default */] || Component === 'td') {
    colSpan = colSpanProp || 1000; // col-span over everything
  }

  var selectId = Object(__WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__["a" /* default */])();
  var labelId = Object(__WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__["a" /* default */])();
  var MenuItemComponent = SelectProps.native ? 'option' : __WEBPACK_IMPORTED_MODULE_9__MenuItem__["a" /* default */];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    colSpan: colSpan,
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Toolbar__["a" /* default */], {
    className: classes.toolbar
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", {
    className: classes.spacer
  }), rowsPerPageOptions.length > 1 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Typography__["a" /* default */], {
    color: "inherit",
    variant: "body2",
    className: classes.caption,
    id: labelId
  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Select__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: {
      select: classes.select,
      icon: classes.selectIcon
    },
    input: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__InputBase__["a" /* default */], {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.input, classes.selectRoot)
    }),
    value: rowsPerPage,
    onChange: onChangeRowsPerPage,
    id: selectId,
    labelId: labelId
  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](MenuItemComponent, {
      className: classes.menuItem,
      key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Typography__["a" /* default */], {
    color: "inherit",
    variant: "body2",
    className: classes.caption
  }, labelDisplayedRows({
    from: count === 0 ? 0 : page * rowsPerPage + 1,
    to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
    count: count === -1 ? -1 : count,
    page: page
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](ActionsComponent, {
    className: classes.actions,
    backIconButtonProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      title: backIconButtonText,
      'aria-label': backIconButtonText
    }, backIconButtonProps),
    count: count,
    nextIconButtonProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      title: nextIconButtonText,
      'aria-label': nextIconButtonText
    }, nextIconButtonProps),
    onChangePage: onChangePage,
    onPageChange: onPageChange,
    page: page,
    rowsPerPage: rowsPerPage
  })));
});
 false ? TablePagination.propTypes = {
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   */
  ActionsComponent: PropTypes.elementType,

  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * Text label for the back arrow icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  backIconButtonText: PropTypes.string,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  colSpan: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: PropTypes.number.isRequired,

  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  labelDisplayedRows: PropTypes.func,

  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  labelRowsPerPage: PropTypes.node,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Text label for the next arrow icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  nextIconButtonText: PropTypes.string,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   * @deprecated Use the onPageChange prop instead.
   */
  onChangePage: deprecatedPropType(PropTypes.func, 'Use the `onPageChange` prop instead.'),

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback.
   * @deprecated Use the onRowsPerPageChange prop instead.
   */
  onChangeRowsPerPage: deprecatedPropType(PropTypes.func, 'Use the `onRowsPerPageChange` prop instead.'),

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: PropTypes.func.isRequired,

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback.
   */
  onRowsPerPageChange: PropTypes.func,

  /**
   * The zero-based index of the current page.
   */
  page: chainPropTypes(PropTypes.number.isRequired, function (props) {
    var count = props.count,
        page = props.page,
        rowsPerPage = props.rowsPerPage;

    if (count === -1) {
      return null;
    }

    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

    if (page < 0 || page > newLastPage) {
      return new Error('Material-UI: The page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
    }

    return null;
  }),

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired,

  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: PropTypes.array,

  /**
   * Props applied to the rows per page [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTablePagination'
})(TablePagination));

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Toolbar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "variant"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? Toolbar.propTypes = {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['regular', 'dense'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiToolbar'
})(Toolbar));

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconButton__ = __webpack_require__(266);








/**
 * @ignore - internal component.
 */

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__["a" /* default */], null);

var _ref2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], null);

var _ref3 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], null);

var _ref4 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__["a" /* default */], null);

var TablePaginationActions = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TablePaginationActions(props, ref) {
  var backIconButtonProps = props.backIconButtonProps,
      count = props.count,
      nextIconButtonProps = props.nextIconButtonProps,
      _props$onChangePage = props.onChangePage,
      onChangePage = _props$onChangePage === void 0 ? function () {} : _props$onChangePage,
      _props$onPageChange = props.onPageChange,
      onPageChange = _props$onPageChange === void 0 ? function () {} : _props$onPageChange,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "onPageChange", "page", "rowsPerPage"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();

  var handleBackButtonClick = function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
    onPageChange(event, page - 1);
  };

  var handleNextButtonClick = function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
    onPageChange(event, page + 1);
  };

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, other), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClick: handleBackButtonClick,
    disabled: page === 0,
    color: "inherit"
  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClick: handleNextButtonClick,
    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
    color: "inherit"
  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
});
 false ? TablePaginationActions.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * The total number of rows.
   */
  count: PropTypes.number.isRequired,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChangePage: PropTypes.func,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: PropTypes.func,

  /**
   * The zero-based index of the current page.
   */
  page: PropTypes.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (TablePaginationActions);

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(71);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      '&$hover:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '&$selected, &$selected:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* alpha */])(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant="head". */
    head: {},

    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
var defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

var TableRow = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableRow(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? defaultComponent : _props$component,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "hover", "selected"]);

  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react__["useContext"](__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, tablelvl2 && {
      'head': classes.head,
      'footer': classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
    role: Component === defaultComponent ? null : 'row'
  }, other));
});
 false ? TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: PropTypes.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableRow'
})(TableRow));

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_ArrowDownward__ = __webpack_require__(1998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(36);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:focus': {
        color: theme.palette.text.secondary
      },
      '&:hover': {
        color: theme.palette.text.secondary,
        '& $icon': {
          opacity: 0.5
        }
      },
      '&$active': {
        color: theme.palette.text.primary,
        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
        '&& $icon': {
          opacity: 1,
          color: theme.palette.text.secondary
        }
      }
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Styles applied to the icon component. */
    icon: {
      fontSize: 18,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none'
    },

    /* Styles applied to the icon component if `direction="desc"`. */
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },

    /* Styles applied to the icon component if `direction="asc"`. */
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */

var TableSortLabel = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TableSortLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'asc' : _props$direction,
      _props$hideSortIcon = props.hideSortIcon,
      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_ArrowDownward__["a" /* default */] : _props$IconComponent,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, active && classes.active),
    component: "span",
    disableRipple: true,
    ref: ref
  }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, classes["iconDirection".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(direction))])
  }));
});
 false ? TableSortLabel.propTypes = {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: PropTypes.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The current sort direction.
   */
  direction: PropTypes.oneOf(['asc', 'desc']),

  /**
   * Hide sort icon when active is false.
   */
  hideSortIcon: PropTypes.bool,

  /**
   * Sort icon to use.
   */
  IconComponent: PropTypes.elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel));

/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__ = __webpack_require__(80);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__utils_createSvgIcon__["a" /* default */])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward'));

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_debounce__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_scrollLeft__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__internal_animate__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ScrollbarSize__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TabIndicator__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TabScrollButton__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_useEventCallback__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_useTheme__ = __webpack_require__(67);


















var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      display: 'flex'
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the flex container element. */
    flexContainer: {
      display: 'flex'
    },

    /* Styles applied to the flex container element if `orientation="vertical"`. */
    flexContainerVertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
    centered: {
      justifyContent: 'center'
    },

    /* Styles applied to the tablist element. */
    scroller: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the tablist element if `!variant="scrollable"`. */
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },

    /* Styles applied to the tablist element if `variant="scrollable"`. */
    scrollable: {
      overflowX: 'scroll',
      // Hide dimensionless scrollbar on MacOS
      scrollbarWidth: 'none',
      // Firefox
      '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome

      }
    },

    /* Styles applied to the `ScrollButtonComponent` component. */
    scrollButtons: {},

    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
    scrollButtonsDesktop: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),

    /* Styles applied to the `TabIndicator` component. */
    indicator: {}
  };
};
var Tabs = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Tabs(props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      action = props.action,
      _props$centered = props.centered,
      centered = _props$centered === void 0 ? false : _props$centered,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$indicatorColor = props.indicatorColor,
      indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor,
      onChange = props.onChange,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$ScrollButtonCo = props.ScrollButtonComponent,
      ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? __WEBPACK_IMPORTED_MODULE_15__TabScrollButton__["a" /* default */] : _props$ScrollButtonCo,
      _props$scrollButtons = props.scrollButtons,
      scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons,
      selectionFollowsFocus = props.selectionFollowsFocus,
      _props$TabIndicatorPr = props.TabIndicatorProps,
      TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
      TabScrollButtonProps = props.TabScrollButtonProps,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-label", "aria-labelledby", "action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_17__styles_useTheme__["a" /* default */])();
  var scrollable = variant === 'scrollable';
  var isRtl = theme.direction === 'rtl';
  var vertical = orientation === 'vertical';
  var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
  var start = vertical ? 'top' : 'left';
  var end = vertical ? 'bottom' : 'right';
  var clientSize = vertical ? 'clientHeight' : 'clientWidth';
  var size = vertical ? 'height' : 'width';

  if (false) {
    if (centered && scrollable) {
      console.error('Material-UI: You can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
    }
  }

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react__["useState"](false),
      mounted = _React$useState[0],
      setMounted = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]({}),
      indicatorStyle = _React$useState2[0],
      setIndicatorStyle = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]({
    start: false,
    end: false
  }),
      displayScroll = _React$useState3[0],
      setDisplayScroll = _React$useState3[1];

  var _React$useState4 = __WEBPACK_IMPORTED_MODULE_3_react__["useState"]({
    overflow: 'hidden',
    marginBottom: null
  }),
      scrollerStyle = _React$useState4[0],
      setScrollerStyle = _React$useState4[1];

  var valueToIndex = new Map();
  var tabsRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var tabListRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);

  var getTabsMeta = function getTabsMeta() {
    var tabsNode = tabsRef.current;
    var tabsMeta;

    if (tabsNode) {
      var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft

      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollTop: tabsNode.scrollTop,
        scrollLeftNormalized: Object(__WEBPACK_IMPORTED_MODULE_10__utils_scrollLeft__["b" /* getNormalizedScrollLeft */])(tabsNode, theme.direction),
        scrollWidth: tabsNode.scrollWidth,
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
    }

    var tabMeta;

    if (tabsNode && value !== false) {
      var _children = tabListRef.current.children;

      if (_children.length > 0) {
        var tab = _children[valueToIndex.get(value)];

        if (false) {
          if (!tab) {
            console.error(["Material-UI: The value provided to the Tabs component is invalid.", "None of the Tabs' children match with `".concat(value, "`."), valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
          }
        }

        tabMeta = tab ? tab.getBoundingClientRect() : null;
      }
    }

    return {
      tabsMeta: tabsMeta,
      tabMeta: tabMeta
    };
  };

  var updateIndicatorState = Object(__WEBPACK_IMPORTED_MODULE_16__utils_useEventCallback__["a" /* default */])(function () {
    var _newIndicatorStyle;

    var _getTabsMeta = getTabsMeta(),
        tabsMeta = _getTabsMeta.tabsMeta,
        tabMeta = _getTabsMeta.tabMeta;

    var startValue = 0;

    if (tabMeta && tabsMeta) {
      if (vertical) {
        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
      } else {
        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        startValue = tabMeta.left - tabsMeta.left + correction;
      }
    }

    var newIndicatorStyle = (_newIndicatorStyle = {}, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_newIndicatorStyle, start, startValue), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);

    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
      setIndicatorStyle(newIndicatorStyle);
    } else {
      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);

      if (dStart >= 1 || dSize >= 1) {
        setIndicatorStyle(newIndicatorStyle);
      }
    }
  });

  var scroll = function scroll(scrollValue) {
    Object(__WEBPACK_IMPORTED_MODULE_11__internal_animate__["a" /* default */])(scrollStart, tabsRef.current, scrollValue);
  };

  var moveTabsScroll = function moveTabsScroll(delta) {
    var scrollValue = tabsRef.current[scrollStart];

    if (vertical) {
      scrollValue += delta;
    } else {
      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge

      scrollValue *= isRtl && Object(__WEBPACK_IMPORTED_MODULE_10__utils_scrollLeft__["a" /* detectScrollType */])() === 'reverse' ? -1 : 1;
    }

    scroll(scrollValue);
  };

  var handleStartScrollClick = function handleStartScrollClick() {
    moveTabsScroll(-tabsRef.current[clientSize]);
  };

  var handleEndScrollClick = function handleEndScrollClick() {
    moveTabsScroll(tabsRef.current[clientSize]);
  };

  var handleScrollbarSizeChange = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](function (scrollbarHeight) {
    setScrollerStyle({
      overflow: null,
      marginBottom: -scrollbarHeight
    });
  }, []);

  var getConditionalElements = function getConditionalElements() {
    var conditionalElements = {};
    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ScrollbarSize__["a" /* default */], {
      className: classes.scrollable,
      onChange: handleScrollbarSizeChange
    }) : null;
    var scrollButtonsActive = displayScroll.start || displayScroll.end;
    var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ScrollButtonComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      orientation: orientation,
      direction: isRtl ? 'right' : 'left',
      onClick: handleStartScrollClick,
      disabled: !displayScroll.start,
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
    }, TabScrollButtonProps)) : null;
    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](ScrollButtonComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      orientation: orientation,
      direction: isRtl ? 'left' : 'right',
      onClick: handleEndScrollClick,
      disabled: !displayScroll.end,
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
    }, TabScrollButtonProps)) : null;
    return conditionalElements;
  };

  var scrollSelectedIntoView = Object(__WEBPACK_IMPORTED_MODULE_16__utils_useEventCallback__["a" /* default */])(function () {
    var _getTabsMeta2 = getTabsMeta(),
        tabsMeta = _getTabsMeta2.tabsMeta,
        tabMeta = _getTabsMeta2.tabMeta;

    if (!tabMeta || !tabsMeta) {
      return;
    }

    if (tabMeta[start] < tabsMeta[start]) {
      // left side of button is out of view
      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
      scroll(nextScrollStart);
    } else if (tabMeta[end] > tabsMeta[end]) {
      // right side of button is out of view
      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);

      scroll(_nextScrollStart);
    }
  });
  var updateScrollButtonState = Object(__WEBPACK_IMPORTED_MODULE_16__utils_useEventCallback__["a" /* default */])(function () {
    if (scrollable && scrollButtons !== 'off') {
      var _tabsRef$current = tabsRef.current,
          scrollTop = _tabsRef$current.scrollTop,
          scrollHeight = _tabsRef$current.scrollHeight,
          clientHeight = _tabsRef$current.clientHeight,
          scrollWidth = _tabsRef$current.scrollWidth,
          clientWidth = _tabsRef$current.clientWidth;
      var showStartScroll;
      var showEndScroll;

      if (vertical) {
        showStartScroll = scrollTop > 1;
        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
      } else {
        var scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_10__utils_scrollLeft__["b" /* getNormalizedScrollLeft */])(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.

        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
      }

      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
        setDisplayScroll({
          start: showStartScroll,
          end: showEndScroll
        });
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_8__utils_debounce__["a" /* default */])(function () {
      updateIndicatorState();
      updateScrollButtonState();
    });
    var win = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__["a" /* default */])(tabsRef.current);
    win.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      win.removeEventListener('resize', handleResize);
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var handleTabsScroll = __WEBPACK_IMPORTED_MODULE_3_react__["useCallback"](Object(__WEBPACK_IMPORTED_MODULE_8__utils_debounce__["a" /* default */])(function () {
    updateScrollButtonState();
  }));
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    return function () {
      handleTabsScroll.clear();
    };
  }, [handleTabsScroll]);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    setMounted(true);
  }, []);
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    updateIndicatorState();
    updateScrollButtonState();
  });
  __WEBPACK_IMPORTED_MODULE_3_react__["useEffect"](function () {
    scrollSelectedIntoView();
  }, [scrollSelectedIntoView, indicatorStyle]);
  __WEBPACK_IMPORTED_MODULE_3_react__["useImperativeHandle"](action, function () {
    return {
      updateIndicator: updateIndicatorState,
      updateScrollButtons: updateScrollButtonState
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var indicator = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__TabIndicator__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: classes.indicator,
    orientation: orientation,
    color: indicatorColor
  }, TabIndicatorProps, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, indicatorStyle, TabIndicatorProps.style)
  }));
  var childIndex = 0;
  var children = __WEBPACK_IMPORTED_MODULE_3_react__["Children"].map(childrenProp, function (child) {
    if (! /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"](child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: The Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    valueToIndex.set(childValue, childIndex);
    var selected = childValue === value;
    childIndex += 1;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](child, {
      fullWidth: variant === 'fullWidth',
      indicator: selected && !mounted && indicator,
      selected: selected,
      selectionFollowsFocus: selectionFollowsFocus,
      onChange: onChange,
      textColor: textColor,
      value: childValue
    });
  });

  var handleKeyDown = function handleKeyDown(event) {
    var target = event.target; // Keyboard navigation assumes that [role="tab"] are siblings
    // though we might warn in the future about nested, interactive elements
    // as a a11y violation

    var role = target.getAttribute('role');

    if (role !== 'tab') {
      return;
    }

    var newFocusTarget = null;
    var previousItemKey = orientation !== "vertical" ? 'ArrowLeft' : 'ArrowUp';
    var nextItemKey = orientation !== "vertical" ? 'ArrowRight' : 'ArrowDown';

    if (orientation !== "vertical" && theme.direction === 'rtl') {
      // swap previousItemKey with nextItemKey
      previousItemKey = 'ArrowRight';
      nextItemKey = 'ArrowLeft';
    }

    switch (event.key) {
      case previousItemKey:
        newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
        break;

      case nextItemKey:
        newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
        break;

      case 'Home':
        newFocusTarget = tabListRef.current.firstChild;
        break;

      case 'End':
        newFocusTarget = tabListRef.current.lastChild;
        break;

      default:
        break;
    }

    if (newFocusTarget !== null) {
      newFocusTarget.focus();
      event.preventDefault();
    }
  };

  var conditionalElements = getConditionalElements();
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className, vertical && classes.vertical),
    ref: ref
  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
    style: scrollerStyle,
    ref: tabsRef,
    onScroll: handleTabsScroll
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"]("div", {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
    onKeyDown: handleKeyDown,
    ref: tabListRef,
    role: "tablist"
  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
});
 false ? Tabs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: refType,

  /**
   * The label for the Tabs as a string.
   */
  'aria-label': PropTypes.string,

  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * Determines the color of the indicator.
   */
  indicatorColor: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child (number)
   */
  onChange: PropTypes.func,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: PropTypes.elementType,

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `desktop` will only present them on medium and larger viewports.
   * - `on` will always present them.
   * - `off` will never present them.
   */
  scrollButtons: PropTypes.oneOf(['auto', 'desktop', 'off', 'on']),

  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: PropTypes.bool,

  /**
   * Props applied to the tab indicator element.
   */
  TabIndicatorProps: PropTypes.object,

  /**
   * Props applied to the [`TabScrollButton`](/api/tab-scroll-button/) element.
   */
  TabScrollButtonProps: PropTypes.object,

  /**
   * Determines the color of the `Tab`.
   */
  textColor: PropTypes.oneOf(['inherit', 'primary', 'secondary']),

  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: PropTypes.any,

  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  -`fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   */
  variant: PropTypes.oneOf(['fullWidth', 'scrollable', 'standard'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_13__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTabs'
})(Tabs));

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = detectScrollType;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNormalizedScrollLeft;
// Source from https://github.com/alitaheri/normalize-scroll-left
var cachedType;
/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE 11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */

function detectScrollType() {
  if (cachedType) {
    return cachedType;
  }

  var dummy = document.createElement('div');
  var container = document.createElement('div');
  container.style.width = '10px';
  container.style.height = '1px';
  dummy.appendChild(container);
  dummy.dir = 'rtl';
  dummy.style.fontSize = '14px';
  dummy.style.width = '4px';
  dummy.style.height = '1px';
  dummy.style.position = 'absolute';
  dummy.style.top = '-1000px';
  dummy.style.overflow = 'scroll';
  document.body.appendChild(dummy);
  cachedType = 'reverse';

  if (dummy.scrollLeft > 0) {
    cachedType = 'default';
  } else {
    dummy.scrollLeft = 1;

    if (dummy.scrollLeft === 0) {
      cachedType = 'negative';
    }
  }

  document.body.removeChild(dummy);
  return cachedType;
} // Based on https://stackoverflow.com/a/24394376

function getNormalizedScrollLeft(element, direction) {
  var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior

  if (direction !== 'rtl') {
    return scrollLeft;
  }

  var type = detectScrollType();

  switch (type) {
    case 'negative':
      return element.scrollWidth - element.clientWidth + scrollLeft;

    case 'reverse':
      return element.scrollWidth - element.clientWidth - scrollLeft;

    default:
      return scrollLeft;
  }
}

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = animate;
function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

function animate(property, element, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var _options$ease = options.ease,
      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 300 : _options$duration;
  var start = null;
  var from = element[property];
  var cancelled = false;

  var cancel = function cancel() {
    cancelled = true;
  };

  var step = function step(timestamp) {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    var time = Math.min(1, (timestamp - start) / duration);
    element[property] = ease(time) * (to - from) + from;

    if (time >= 1) {
      requestAnimationFrame(function () {
        cb(null);
      });
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
}

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrollbarSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_debounce__ = __webpack_require__(179);





var styles = {
  width: 99,
  height: 99,
  position: 'absolute',
  top: -9999,
  overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */

function ScrollbarSize(props) {
  var onChange = props.onChange,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["onChange"]);

  var scrollbarHeight = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();
  var nodeRef = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"](null);

  var setMeasurements = function setMeasurements() {
    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
  };

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_4__utils_debounce__["a" /* default */])(function () {
      var prevHeight = scrollbarHeight.current;
      setMeasurements();

      if (prevHeight !== scrollbarHeight.current) {
        onChange(scrollbarHeight.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [onChange]);
  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    setMeasurements();
    onChange(scrollbarHeight.current);
  }, [onChange]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    style: styles,
    ref: nodeRef
  }, other));
}
 false ? ScrollbarSize.propTypes = {
  onChange: PropTypes.func.isRequired
} : void 0;

/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(36);







var styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create()
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    vertical: {
      height: '100%',
      width: 2,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */

var TabIndicator = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TabIndicator(props, ref) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      orientation = props.orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "orientation"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"]("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], className, orientation === 'vertical' && classes.vertical),
    ref: ref
  }, other));
});
 false ? TabIndicator.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: PropTypes.oneOf(['primary', 'secondary']).isRequired,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateTabIndicator'
})(TabIndicator));

/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowLeft__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_KeyboardArrowRight__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonBase__ = __webpack_require__(76);



/* eslint-disable jsx-a11y/aria-role */







var styles = {
  /* Styles applied to the root element. */
  root: {
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    '&$disabled': {
      opacity: 0
    }
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    width: '100%',
    height: 40,
    '& svg': {
      transform: 'rotate(90deg)'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {}
};

var _ref = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], {
  fontSize: "small"
});

var _ref2 = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_KeyboardArrowRight__["a" /* default */], {
  fontSize: "small"
});

var TabScrollButton = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TabScrollButton(props, ref) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      orientation = props.orientation,
      disabled = props.disabled,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "direction", "orientation", "disabled"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "div",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classNameProp, disabled && classes.disabled, orientation === 'vertical' && classes.vertical),
    ref: ref,
    role: null,
    tabIndex: null
  }, other), direction === 'left' ? _ref : _ref2);
});
 false ? TabScrollButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Which direction should the button indicate?
   */
  direction: PropTypes.oneOf(['left', 'right']).isRequired,

  /**
   * If `true`, the element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTabScrollButton'
})(TabScrollButton));

/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_deprecatedPropType__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Input__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FilledInput__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OutlinedInput__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InputLabel__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormControl__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FormHelperText__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Select__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_withStyles__ = __webpack_require__(8);















var variantComponent = {
  standard: __WEBPACK_IMPORTED_MODULE_7__Input__["a" /* default */],
  filled: __WEBPACK_IMPORTED_MODULE_8__FilledInput__["a" /* default */],
  outlined: __WEBPACK_IMPORTED_MODULE_9__OutlinedInput__["a" /* default */]
};
var styles = {
  /* Styles applied to the root element. */
  root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

var TextField = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["forwardRef"](function TextField(props, ref) {
  var autoComplete = props.autoComplete,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      FormHelperTextProps = props.FormHelperTextProps,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      helperText = props.helperText,
      hiddenLabel = props.hiddenLabel,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      maxRows = props.maxRows,
      minRows = props.minRows,
      _props$select = props.select,
      select = _props$select === void 0 ? false : _props$select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "maxRows", "minRows", "select", "SelectProps", "type", "value", "variant"]);

  if (false) {
    if (select && !children) {
      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }

  var InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    if (label) {
      var _InputLabelProps$requ;

      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
      InputMore.label = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react__["Fragment"], null, label, displayRequired && "\xA0*");
    }
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var InputComponent = variantComponent[variant];
  var InputElement = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__FormControl__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant
  }, other), label && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__InputLabel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFor: id,
    id: inputLabelId
  }, InputLabelProps), label), select ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Select__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-describedby": helperTextId,
    id: id,
    labelId: inputLabelId,
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__FormHelperText__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});
 false ? TextField.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default value of the `input` element.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The helper text content.
   */
  helperText: PropTypes.node,

  /**
   * @ignore
   */
  hiddenLabel: PropTypes.bool,

  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,

  /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: PropTypes.object,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The label content.
   */
  label: PropTypes.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['dense', 'none', 'normal']),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Minimum number of rows to display.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   * @deprecated Use `minRows` instead.
   */
  rows: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `minRows` instead'),

  /**
   * Maximum number of rows to display.
   * @deprecated Use `maxRows` instead.
   */
  rowsMax: deprecatedPropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string]), 'Use `maxRows` instead'),

  /**
   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: PropTypes.bool,

  /**
   * Props applied to the [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object,

  /**
   * The size of the text field.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTextField'
})(TextField));

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* unused harmony export testReset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_withStyles__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_capitalize__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Grow__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Popper__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_setRef__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_useIsFocusVisible__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_useControlled__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__styles_useTheme__ = __webpack_require__(67);





















function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

function arrowGenerator() {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '0 100%'
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '100% 0'
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '100% 100%'
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '0 0'
      }
    }
  };
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none' // disable jss-rtl plugin

    },

    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: 'auto'
    },

    /* Styles applied to the Popper component if `arrow={true}`. */
    popperArrow: arrowGenerator(),

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["a" /* alpha */])(theme.palette.grey[700], 0.9),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(round(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: 'break-word',
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
    tooltipArrow: {
      position: 'relative',
      margin: '0'
    },

    /* Styles applied to the arrow element. */
    arrow: {
      overflow: 'hidden',
      position: 'absolute',
      width: '1em',
      height: '0.71em'
      /* = width / sqrt(2) = (length of the hypotenuse) */
      ,
      boxSizing: 'border-box',
      color: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["a" /* alpha */])(theme.palette.grey[700], 0.9),
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: 'currentColor',
        transform: 'rotate(45deg)'
      }
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(round(16 / 14), "em"),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};
var hystersisOpen = false;
var hystersisTimer = null;
function testReset() {
  hystersisOpen = false;
  clearTimeout(hystersisTimer);
}
var Tooltip = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["forwardRef"](function Tooltip(props, ref) {
  var _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      children = props.children,
      classes = props.classes,
      _props$disableFocusLi = props.disableFocusListener,
      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
      _props$disableHoverLi = props.disableHoverListener,
      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
      _props$disableTouchLi = props.disableTouchListener,
      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
      _props$enterDelay = props.enterDelay,
      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
      _props$enterNextDelay = props.enterNextDelay,
      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
      _props$enterTouchDela = props.enterTouchDelay,
      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
      idProp = props.id,
      _props$interactive = props.interactive,
      interactive = _props$interactive === void 0 ? false : _props$interactive,
      _props$leaveDelay = props.leaveDelay,
      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
      _props$leaveTouchDela = props.leaveTouchDelay,
      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
      onClose = props.onClose,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$PopperComponen = props.PopperComponent,
      PopperComponent = _props$PopperComponen === void 0 ? __WEBPACK_IMPORTED_MODULE_13__Popper__["a" /* default */] : _props$PopperComponen,
      PopperProps = props.PopperProps,
      title = props.title,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_12__Grow__["a" /* default */] : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_19__styles_useTheme__["a" /* default */])();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](),
      childNode = _React$useState[0],
      setChildNode = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](null),
      arrowRef = _React$useState2[0],
      setArrowRef = _React$useState2[1];

  var ignoreNonTouchEvents = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"](false);
  var closeTimer = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var enterTimer = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var leaveTimer = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();
  var touchTimer = __WEBPACK_IMPORTED_MODULE_4_react__["useRef"]();

  var _useControlled = Object(__WEBPACK_IMPORTED_MODULE_18__utils_useControlled__["a" /* default */])({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  }),
      _useControlled2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_useControlled, 2),
      openState = _useControlled2[0],
      setOpenState = _useControlled2[1];

  var open = openState;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _React$useRef = React.useRef(openProp !== undefined),
        isControlled = _React$useRef.current; // eslint-disable-next-line react-hooks/rules-of-hooks


    React.useEffect(function () {
      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
        console.error(['Material-UI: You are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
      }
    }, [title, childNode, isControlled]);
  }

  var id = Object(__WEBPACK_IMPORTED_MODULE_15__utils_unstable_useId__["a" /* default */])(idProp);
  __WEBPACK_IMPORTED_MODULE_4_react__["useEffect"](function () {
    return function () {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(touchTimer.current);
    };
  }, []);

  var handleOpen = function handleOpen(event) {
    clearTimeout(hystersisTimer);
    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleEnter = function handleEnter() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
        childrenProps.onMouseOver(event);
      }

      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      if (childNode) {
        childNode.removeAttribute('title');
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);

      if (enterDelay || hystersisOpen && enterNextDelay) {
        event.persist();
        enterTimer.current = setTimeout(function () {
          handleOpen(event);
        }, hystersisOpen ? enterNextDelay : enterDelay);
      } else {
        handleOpen(event);
      }
    };
  };

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_17__utils_useIsFocusVisible__["a" /* default */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_4_react__["useState"](false),
      childIsFocusVisible = _React$useState3[0],
      setChildIsFocusVisible = _React$useState3[1];

  var handleBlur = function handleBlur() {
    if (childIsFocusVisible) {
      setChildIsFocusVisible(false);
      onBlurVisible();
    }
  };

  var handleFocus = function handleFocus() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      // Workaround for https://github.com/facebook/react/issues/7769
      // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.
      if (!childNode) {
        setChildNode(event.currentTarget);
      }

      if (isFocusVisible(event)) {
        setChildIsFocusVisible(true);
        handleEnter()(event);
      }

      var childrenProps = children.props;

      if (childrenProps.onFocus && forward) {
        childrenProps.onFocus(event);
      }
    };
  };

  var handleClose = function handleClose(event) {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(function () {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);

    if (onClose) {
      onClose(event);
    }

    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(function () {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  };

  var handleLeave = function handleLeave() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'blur') {
        if (childrenProps.onBlur && forward) {
          childrenProps.onBlur(event);
        }

        handleBlur();
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      event.persist();
      leaveTimer.current = setTimeout(function () {
        handleClose(event);
      }, leaveDelay);
    };
  };

  var detectTouchStart = function detectTouchStart(event) {
    ignoreNonTouchEvents.current = true;
    var childrenProps = children.props;

    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };

  var handleTouchStart = function handleTouchStart(event) {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    clearTimeout(touchTimer.current);
    event.persist();
    touchTimer.current = setTimeout(function () {
      handleEnter()(event);
    }, enterTouchDelay);
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }

    clearTimeout(touchTimer.current);
    clearTimeout(leaveTimer.current);
    event.persist();
    leaveTimer.current = setTimeout(function () {
      handleClose(event);
    }, leaveTouchDelay);
  };

  var handleUseRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(setChildNode, ref);
  var handleFocusRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_4_react__["useCallback"](function (instance) {
    // #StrictMode ready
    Object(__WEBPACK_IMPORTED_MODULE_16__utils_setRef__["a" /* default */])(handleFocusRef, __WEBPACK_IMPORTED_MODULE_5_react_dom__["findDOMNode"](instance));
  }, [handleFocusRef]);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_14__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.

  if (title === '') {
    open = false;
  } // For accessibility and SEO concerns, we render the title to the DOM node when
  // the tooltip is hidden. However, we have made a tradeoff when
  // `disableHoverListener` is set. This title logic is disabled.
  // It's allowing us to keep the implementation size minimal.
  // We are open to change the tradeoff.


  var shouldShowNativeTitle = !open && !disableHoverListener;

  var childrenProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    'aria-describedby': open ? id : null,
    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
  }, other, children.props, {
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  });

  var interactiveWrapperListeners = {};

  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }

  if (!disableHoverListener) {
    childrenProps.onMouseOver = handleEnter();
    childrenProps.onMouseLeave = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onMouseOver = handleEnter(false);
      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
    }
  }

  if (!disableFocusListener) {
    childrenProps.onFocus = handleFocus();
    childrenProps.onBlur = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onFocus = handleFocus(false);
      interactiveWrapperListeners.onBlur = handleLeave(false);
    }
  }

  if (false) {
    if (children.props.title) {
      console.error(['Material-UI: You have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
    }
  }

  var mergedPopperProps = __WEBPACK_IMPORTED_MODULE_4_react__["useMemo"](function () {
    return Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_utils__["a" /* deepmerge */])({
      popperOptions: {
        modifiers: {
          arrow: {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    }, PopperProps);
  }, [arrowRef, PopperProps]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"](children, childrenProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](PopperComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
    placement: placement,
    anchorEl: childNode,
    open: childNode ? open : false,
    id: childrenProps['aria-describedby'],
    transition: true
  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
    var placementInner = _ref.placement,
        TransitionPropsInner = _ref.TransitionProps;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      timeout: theme.transitions.duration.shorter
    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])(classes.tooltip, classes["tooltipPlacement".concat(Object(__WEBPACK_IMPORTED_MODULE_11__utils_capitalize__["a" /* default */])(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
    }, title, arrow ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react__["createElement"]("span", {
      className: classes.arrow,
      ref: setArrowRef
    }) : null));
  }));
});
 false ? Tooltip.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, adds an arrow to the tooltip.
   */
  arrow: PropTypes.bool,

  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: PropTypes.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: PropTypes.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: PropTypes.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: PropTypes.number,

  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   */
  enterNextDelay: PropTypes.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: PropTypes.number,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: PropTypes.bool,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: PropTypes.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: PropTypes.bool,

  /**
   * Tooltip placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * The component used for the popper.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: PropTypes.object,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: PropTypes
  /* @typescript-to-proptypes-ignore */
  .node.isRequired,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTooltip',
  flip: false
})(Tooltip));

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




function defaultTrigger(store, options) {
  var _options$disableHyste = options.disableHysteresis,
      disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
      _options$threshold = options.threshold,
      threshold = _options$threshold === void 0 ? 100 : _options$threshold,
      target = options.target;
  var previous = store.current;

  if (target) {
    // Get vertical scroll
    store.current = target.pageYOffset !== undefined ? target.pageYOffset : target.scrollTop;
  }

  if (!disableHysteresis && previous !== undefined) {
    if (store.current < previous) {
      return false;
    }
  }

  return store.current > threshold;
}

var defaultTarget = typeof window !== 'undefined' ? window : null;
function useScrollTrigger() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$getTrigger = options.getTrigger,
      getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
      _options$target = options.target,
      target = _options$target === void 0 ? defaultTarget : _options$target,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["getTrigger", "target"]);

  var store = __WEBPACK_IMPORTED_MODULE_2_react__["useRef"]();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react__["useState"](function () {
    return getTrigger(store, other);
  }),
      trigger = _React$useState[0],
      setTrigger = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_2_react__["useEffect"](function () {
    var handleScroll = function handleScroll() {
      setTrigger(getTrigger(store, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        target: target
      }, other)));
    };

    handleScroll(); // Re-evaluate trigger when dependencies change

    target.addEventListener('scroll', handleScroll);
    return function () {
      target.removeEventListener('scroll', handleScroll);
    }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, getTrigger, JSON.stringify(other)]);
  return trigger;
}

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withWidth__ = __webpack_require__(425);




var warnedOnce = false;
/**
 * Dialog will responsively be full screen *at or below* the given breakpoint
 * (defaults to 'sm' for mobile devices).
 * Notice that this Higher-order Component is incompatible with server-side rendering.
 */

var withMobileDialog = function withMobileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    if (false) {
      if (!warnedOnce) {
        console.warn(['Material-UI: The `withMobileDialog` function is deprecated.', 'Head to https://mui.com/r/migration-v4/#dialog for a migration path.'].join('\n'));
        warnedOnce = true;
      }
    }

    var _options$breakpoint = options.breakpoint,
        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;

    function WithMobileDialog(props) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        fullScreen: Object(__WEBPACK_IMPORTED_MODULE_3__withWidth__["b" /* isWidthDown */])(breakpoint, props.width)
      }, props));
    }

     false ? WithMobileDialog.propTypes = {
      width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
    } : void 0;
    return Object(__WEBPACK_IMPORTED_MODULE_3__withWidth__["a" /* default */])()(WithMobileDialog);
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (withMobileDialog);

/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_transitions__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transitions_utils__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(59);










var styles = {
  entering: {
    transform: 'none'
  },
  entered: {
    transform: 'none'
  }
};
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_6__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/components/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Zoom = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"](function Zoom(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5_react_transition_group__["Transition"] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = __WEBPACK_IMPORTED_MODULE_3_react__["useRef"](null);
  var foreignRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(children.ref, ref);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["createElement"](TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"](children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        transform: 'scale(0)',
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Zoom.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * Enable this prop if you encounter 'Function components cannot be given refs',
   * use `unstable_createStrictModeTheme`,
   * and can't forward the ref in the child component.
   */
  disableStrictModeCompat: PropTypes.bool,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Zoom);

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

var _interopRequireWildcard = __webpack_require__(162);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(163));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

exports.default = _default;

/***/ }),
/* 2011 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

var _interopRequireWildcard = __webpack_require__(162);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(163));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M18.3 5.71a.9959.9959 0 00-1.41 0L12 10.59 7.11 5.7a.9959.9959 0 00-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
}), 'CloseRounded');

exports.default = _default;

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reach_combobox__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Search__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__C3ImageLibrary__ = __webpack_require__(879);
var _this = this;







var Configuration = __webpack_require__(27);
var Storage = __webpack_require__(34);
var fetchLimit = 20;
var useStyles = Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["s" /* makeStyles */])(function () { return ({
    searchBarContainer: {
        width: "100%",
    },
    searchBar: {
        display: "flex",
        background: "#FFFFFF",
        height: "32px",
        border: "1px solid #94A3B8",
        borderRadius: "4px",
        "&:focus-within": {
            outline: "-webkit-focus-ring-color auto 1px",
        }
    },
    imageSearchInput: {
        width: 392,
        height: 28,
        border: 0,
        outline: 0,
        backgroundColor: "#FFFFFF !important",
        color: "#000000 !important"
    },
    comboBoxMenu: {
        background: "#FFFFFF",
        zIndex: 2,
        borderRadius: "3px",
        boxShadow: "0px 3px 5px rgb(9 30 66 / 20%), 0px 0px 1px rgb(9 30 66 / 31%)",
    },
    comboBoxMenuList: {
        lineHeight: "3.65vh",
        fontSize: "0.8em",
        listStyle: "none",
        paddingLeft: "1.11vw",
        cursor: "pointer",
    },
}); });
var ImageLibrarySearchbar = function (_a) {
    var props = __WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __rest */](_a, []);
    var classes = useStyles();
    var _b = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])(""), searchTerm = _b[0], setSearchTerm = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useState"])([]), matchedImageTags = _c[0], setMatchedImageTags = _c[1];
    var searchCache = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])({});
    var isMenuWidthIncreased = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(false);
    var timeout = Object(__WEBPACK_IMPORTED_MODULE_2_react__["useRef"])(null);
    Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
        onSearchInputChange();
        // Adjust the widht of the search menu to cover the whole input box since adding close icon misaligns the menu
        if (!isMenuWidthIncreased.current
            && document.getElementById("combo-box-popover")
            && !document.getElementById("combo-box-popover").hidden) {
            var newWidth = parseInt(document.getElementById("combo-box-popover").style.width) + 64 + "px";
            document.getElementById("combo-box-popover").style.width = newWidth;
            isMenuWidthIncreased.current = true;
        }
    }, [searchTerm]);
    Object(__WEBPACK_IMPORTED_MODULE_2_react__["useEffect"])(function () {
        setTimeout(function () {
            // Align Search Menu with input box since adding custom search icon misaligns reachUI popover (Menu)
            var newLeft = parseInt(document.getElementById("combo-box-popover").style.left) - 25 + "px";
            document.getElementById("combo-box-popover").style.left = newLeft;
        });
    }, []);
    var searchHandler = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
        var res, matchedTags_1;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(searchTerm.trim() !== "")) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchMatchedImageTags(searchTerm)];
                case 1:
                    res = _a.sent();
                    if (res.imageDetailsList.length) {
                        matchedTags_1 = [];
                        res.imageDetailsList.forEach(function (image) {
                            image.matchedTag && matchedTags_1.push(image.matchedTag);
                        });
                        setMatchedImageTags(matchedTags_1);
                    }
                    else {
                        setMatchedImageTags([]);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var debounce = function (func, delay) {
        return function mainFunction() {
            var wait = function () {
                clearTimeout(timeout.current);
                func();
            };
            clearTimeout(timeout.current);
            timeout.current = setTimeout(wait, delay);
        };
    };
    var onSearchInputChange = debounce(searchHandler, 500);
    var fetchMatchedImageTags = function (value) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (searchCache.current[value]) {
                        return [2 /*return*/, searchCache.current[value]];
                    }
                    return [4 /*yield*/, getImages(value)];
                case 1:
                    res = _a.sent();
                    searchCache.current[value] = res;
                    return [2 /*return*/, res];
            }
        });
    }); };
    var getImages = function (searchPrefix) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
        var token, res, e_1;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
                    return [4 /*yield*/, fetch(Configuration.c3ApibaseUrl + "/v1/images?limit=" + fetchLimit + "&sortBy=" + props.sortBy + "&folderPath=" + props.folderPath + (searchPrefix ? "&searchPrefix=" + searchPrefix : ""), {
                            headers: {
                                Authorization: "Bearer " + token
                            },
                            method: "GET"
                        })];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getType = function (type) {
        switch (type) {
            case "IMGNAME":
                return "Image name";
            case "EXPNAME":
                return "Experience name";
            case "CNTSLOT":
                return "Content Slot";
            case "PGNAME":
                return "Page name";
            default:
                return "User Tag";
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* Grid */], { item: true, className: classes.searchBarContainer },
        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* Grid */], { container: true, style: { padding: "1vh 0vw", justifyContent: "space-between" } },
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["j" /* Grid */], { item: true, className: classes.searchBarContainer },
                __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__reach_combobox__["a" /* Combobox */], { "aria-label": "images", onSelect: function (value) {
                        setSearchTerm(value.split(" : ")[0]);
                        // hide search menu
                        document.getElementById("combo-box-popover").hidden = true;
                    } },
                    __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", { className: classes.searchBar },
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* IconButton */], { style: { paddingRight: "6px", paddingLeft: "6px" }, onClick: function () { return props.handleSearch(searchTerm); } },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Search___default.a, null)),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__reach_combobox__["b" /* ComboboxInput */], { value: searchTerm, className: classes.imageSearchInput, onChange: function (e) { return setSearchTerm(e.target.value); }, placeholder: props.placeholder, onKeyDown: function (e) {
                                if (e.key === "Enter") {
                                    props.handleSearch(searchTerm);
                                    e.currentTarget.blur();
                                    // hide search menu
                                    setTimeout(function () { return document.getElementById("combo-box-popover").hidden = true; });
                                }
                            } }),
                        __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* IconButton */], { style: { display: searchTerm ? "flex" : "none" }, onClick: function () {
                                setSearchTerm("");
                                props.handleSearch("");
                            } },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__C3ImageLibrary__["Cross"], null))),
                    matchedImageTags && (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__reach_combobox__["f" /* ComboboxPopover */], { id: "combo-box-popover", className: classes.comboBoxMenu }, matchedImageTags.length > 0 && (__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__reach_combobox__["c" /* ComboboxList */], { className: classes.comboBoxMenuList }, matchedImageTags.map(function (imageTag) {
                        var str = imageTag.tagText + " : " + getType(imageTag.tagType);
                        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__reach_combobox__["d" /* ComboboxOption */], { key: str, value: str },
                            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__reach_combobox__["e" /* ComboboxOptionText */], null),
                            " ");
                    }))))))))));
};
/* harmony default export */ __webpack_exports__["a"] = (ImageLibrarySearchbar);


/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Combobox; });
/* unused harmony export ComboboxButton */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ComboboxInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ComboboxList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ComboboxOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ComboboxOptionText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ComboboxPopover; });
/* unused harmony export escapeRegexp */
/* unused harmony export unstable_useKeyDown */
/* unused harmony export useComboboxContext */
/* unused harmony export useComboboxOptionContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reach_utils_use_isomorphic_layout_effect__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reach_utils_context__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reach_utils_type_check__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reach_utils_make_id__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reach_utils_noop__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reach_utils_dev_utils__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__reach_utils_compose_refs__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__reach_utils_use_update_effect__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__reach_utils_use_stateful_ref_value__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reach_descendants__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__reach_auto_id__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__reach_popover__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_tiny_warning__ = __webpack_require__(210);

















function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

// Forked from https://github.com/bvaughn/highlight-words-core

/**
 * Creates an array of chunk objects representing both higlightable and non
 * highlightable pieces of text that match each search word.
 *
 * @return Array of "chunk" objects
 */
function findAll(_ref) {
  var autoEscape = _ref.autoEscape,
      _ref$caseSensitive = _ref.caseSensitive,
      caseSensitive = _ref$caseSensitive === void 0 ? false : _ref$caseSensitive,
      _ref$findChunks = _ref.findChunks,
      findChunks = _ref$findChunks === void 0 ? defaultFindChunks : _ref$findChunks,
      sanitize = _ref.sanitize,
      searchWords = _ref.searchWords,
      textToHighlight = _ref.textToHighlight;
  return fillInChunks({
    chunksToHighlight: combineChunks({
      chunks: findChunks({
        autoEscape: autoEscape,
        caseSensitive: caseSensitive,
        sanitize: sanitize,
        searchWords: searchWords,
        textToHighlight: textToHighlight
      })
    }),
    totalLength: textToHighlight ? textToHighlight.length : 0
  });
}
/**
 * Takes an array of "chunk" objects and combines chunks that overlap into
 * single chunks.
 *
 * @return Array of "chunk" objects
 */


function combineChunks(_ref2) {
  var chunks = _ref2.chunks;
  return chunks.sort(function (first, second) {
    return first.start - second.start;
  }).reduce(function (processedChunks, nextChunk) {
    // First chunk just goes straight in the array...
    if (processedChunks.length === 0) {
      return [nextChunk];
    } else {
      // ... subsequent chunks get checked to see if they overlap...
      var prevChunk = processedChunks.pop();

      if (nextChunk.start <= prevChunk.end) {
        // It may be the case that prevChunk completely surrounds nextChunk, so take the
        // largest of the end indeces.
        var endIndex = Math.max(prevChunk.end, nextChunk.end);
        processedChunks.push({
          highlight: false,
          start: prevChunk.start,
          end: endIndex
        });
      } else {
        processedChunks.push(prevChunk, nextChunk);
      }

      return processedChunks;
    }
  }, []);
}
/**
 * Examine text for any matches. If we find matches, add them to the returned
 * array as a "chunk" object.
 *
 * @return Array of "chunk" objects
 */


function defaultFindChunks(_ref3) {
  var autoEscape = _ref3.autoEscape,
      caseSensitive = _ref3.caseSensitive,
      _ref3$sanitize = _ref3.sanitize,
      sanitize = _ref3$sanitize === void 0 ? defaultSanitize : _ref3$sanitize,
      searchWords = _ref3.searchWords,
      textToHighlight = _ref3.textToHighlight;
  textToHighlight = sanitize(textToHighlight || "");
  return searchWords.filter(function (searchWord) {
    return searchWord;
  }) // Remove empty words
  .reduce(function (chunks, searchWord) {
    searchWord = sanitize(searchWord);

    if (autoEscape) {
      searchWord = escapeRegExpFn(searchWord);
    }

    var regex = new RegExp(searchWord, caseSensitive ? "g" : "gi");
    var match;

    while (match = regex.exec(textToHighlight || "")) {
      var start = match.index;
      var end = regex.lastIndex; // We do not return zero-length matches

      if (end > start) {
        chunks.push({
          highlight: false,
          start: start,
          end: end
        });
      } // Prevent browsers like Firefox from getting stuck in an infinite loop
      // See http://www.regexguru.com/2008/04/watch-out-for-zero-length-matches/


      if (match.index === regex.lastIndex) {
        regex.lastIndex++;
      }
    }

    return chunks;
  }, []);
}
/**
 * Given a set of chunks to highlight, create an additional set of chunks
 * to represent the bits of text between the highlighted text.
 *
 * @return Array of "chunk" objects
 */


function fillInChunks(_ref4) {
  var chunksToHighlight = _ref4.chunksToHighlight,
      totalLength = _ref4.totalLength;
  var allChunks = [];

  if (chunksToHighlight.length === 0) {
    append(0, totalLength, false);
  } else {
    var lastIndex = 0;
    chunksToHighlight.forEach(function (chunk) {
      append(lastIndex, chunk.start, false);
      append(chunk.start, chunk.end, true);
      lastIndex = chunk.end;
    });
    append(lastIndex, totalLength, false);
  }

  return allChunks;

  function append(start, end, highlight) {
    if (end - start > 0) {
      allChunks.push({
        start: start,
        end: end,
        highlight: highlight
      });
    }
  }
}

function defaultSanitize(string) {
  return string;
}

function escapeRegExpFn(string) {
  return string.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
}

var HighlightWords = {
  combineChunks: combineChunks,
  fillInChunks: fillInChunks,
  findAll: findAll,
  findChunks: defaultFindChunks
};

var _excluded = ["onSelect", "openOnFocus", "children", "as", "aria-label", "aria-labelledby"],
    _excluded2 = ["as", "selectOnClick", "autocomplete", "onClick", "onChange", "onKeyDown", "onBlur", "onFocus", "value"],
    _excluded3 = ["as", "children", "portal", "onKeyDown", "onBlur", "position"],
    _excluded4 = ["persistSelection", "as"],
    _excluded5 = ["as", "children", "index", "value", "onClick"],
    _excluded6 = ["as", "onClick", "onKeyDown"];

var _on, _on2, _on3, _on4, _states;
// States
// Nothing going on, waiting for the user to type or use the arrow keys

var IDLE = "IDLE"; // The component is suggesting options as the user types

var SUGGESTING = "SUGGESTING"; // The user is using the keyboard to navigate the list, not typing

var NAVIGATING = "NAVIGATING"; // The user is interacting with arbitrary elements inside the popup that
// are not ComboboxInputs

var INTERACTING = "INTERACTING"; ////////////////////////////////////////////////////////////////////////////////
// Events
// User cleared the value w/ backspace, but input still has focus

var CLEAR = "CLEAR"; // User is typing

var CHANGE = "CHANGE"; // Initial input value change handler for syncing user state with state machine
// Prevents initial change from sending the user to the NAVIGATING state
// https://github.com/reach/reach-ui/issues/464

var INITIAL_CHANGE = "INITIAL_CHANGE"; // User is navigating w/ the keyboard

var NAVIGATE = "NAVIGATE"; // User can be navigating with keyboard and then click instead, we want the
// value from the click, not the current nav item

var SELECT_WITH_KEYBOARD = "SELECT_WITH_KEYBOARD";
var SELECT_WITH_CLICK = "SELECT_WITH_CLICK"; // Pretty self-explanatory, user can hit escape or blur to close the popover

var ESCAPE = "ESCAPE";
var BLUR = "BLUR"; // The user left the input to interact with arbitrary elements inside the popup

var INTERACT = "INTERACT";
var FOCUS = "FOCUS";
var OPEN_WITH_BUTTON = "OPEN_WITH_BUTTON";
var OPEN_WITH_INPUT_CLICK = "OPEN_WITH_INPUT_CLICK";
var CLOSE_WITH_BUTTON = "CLOSE_WITH_BUTTON"; ////////////////////////////////////////////////////////////////////////////////

var stateChart = {
  initial: IDLE,
  states: (_states = {}, _states[IDLE] = {
    on: (_on = {}, _on[BLUR] = IDLE, _on[CLEAR] = IDLE, _on[CHANGE] = SUGGESTING, _on[INITIAL_CHANGE] = IDLE, _on[FOCUS] = SUGGESTING, _on[NAVIGATE] = NAVIGATING, _on[OPEN_WITH_BUTTON] = SUGGESTING, _on[OPEN_WITH_INPUT_CLICK] = SUGGESTING, _on)
  }, _states[SUGGESTING] = {
    on: (_on2 = {}, _on2[CHANGE] = SUGGESTING, _on2[FOCUS] = SUGGESTING, _on2[NAVIGATE] = NAVIGATING, _on2[CLEAR] = IDLE, _on2[ESCAPE] = IDLE, _on2[BLUR] = IDLE, _on2[SELECT_WITH_CLICK] = IDLE, _on2[INTERACT] = INTERACTING, _on2[CLOSE_WITH_BUTTON] = IDLE, _on2)
  }, _states[NAVIGATING] = {
    on: (_on3 = {}, _on3[CHANGE] = SUGGESTING, _on3[FOCUS] = SUGGESTING, _on3[CLEAR] = IDLE, _on3[BLUR] = IDLE, _on3[ESCAPE] = IDLE, _on3[NAVIGATE] = NAVIGATING, _on3[SELECT_WITH_CLICK] = IDLE, _on3[SELECT_WITH_KEYBOARD] = IDLE, _on3[CLOSE_WITH_BUTTON] = IDLE, _on3[INTERACT] = INTERACTING, _on3)
  }, _states[INTERACTING] = {
    on: (_on4 = {}, _on4[CLEAR] = IDLE, _on4[CHANGE] = SUGGESTING, _on4[FOCUS] = SUGGESTING, _on4[BLUR] = IDLE, _on4[ESCAPE] = IDLE, _on4[NAVIGATE] = NAVIGATING, _on4[CLOSE_WITH_BUTTON] = IDLE, _on4[SELECT_WITH_CLICK] = IDLE, _on4)
  }, _states)
};

var reducer = function reducer(data, event) {
  var nextState = _extends({}, data, {
    lastEventType: event.type
  });

  switch (event.type) {
    case CHANGE:
    case INITIAL_CHANGE:
      return _extends({}, nextState, {
        navigationValue: null,
        value: event.value
      });

    case NAVIGATE:
    case OPEN_WITH_BUTTON:
    case OPEN_WITH_INPUT_CLICK:
      return _extends({}, nextState, {
        navigationValue: findNavigationValue(nextState, event)
      });

    case CLEAR:
      return _extends({}, nextState, {
        value: "",
        navigationValue: null
      });

    case BLUR:
    case ESCAPE:
      return _extends({}, nextState, {
        navigationValue: null
      });

    case SELECT_WITH_CLICK:
      return _extends({}, nextState, {
        // if controlled, "set" the input to what it already has, and let the
        // user do whatever they want
        value: event.isControlled ? data.value : event.value,
        navigationValue: null
      });

    case SELECT_WITH_KEYBOARD:
      return _extends({}, nextState, {
        // if controlled, "set" the input to what it already has, and let the
        // user do whatever they want
        value: event.isControlled ? data.value : data.navigationValue,
        navigationValue: null
      });

    case CLOSE_WITH_BUTTON:
      return _extends({}, nextState, {
        navigationValue: null
      });

    case INTERACT:
      return nextState;

    case FOCUS:
      return _extends({}, nextState, {
        navigationValue: findNavigationValue(nextState, event)
      });

    default:
      return nextState;
  }
};

function popoverIsExpanded(state) {
  return [SUGGESTING, NAVIGATING, INTERACTING].includes(state);
}
/**
 * When we open a list, set the navigation value to the value in the input, if
 * it's in the list, then it'll automatically be highlighted.
 *
 * @param stateData
 * @param event
 */


function findNavigationValue(stateData, event) {
  // @ts-ignore
  if (event.value) {
    // @ts-ignore
    return event.value; // @ts-ignore
  } else if (event.persistSelection) {
    return stateData.value;
  } else {
    return null;
  }
}

var ComboboxDescendantContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_12__reach_descendants__["b" /* createDescendantContext */])("ComboboxDescendantContext");
var ComboboxContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__reach_utils_context__["a" /* createNamedContext */])("ComboboxContext", {}); // Allows us to put the option's value on context so that ComboboxOptionText
// can work it's highlight text magic no matter what else is rendered around
// it.

var OptionContext = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__reach_utils_context__["a" /* createNamedContext */])("OptionContext", {}); ////////////////////////////////////////////////////////////////////////////////

/**
 * Combobox
 *
 * @see Docs https://reach.tech/combobox#combobox
 */

var Combobox = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_ref, forwardedRef) {
  var _data$navigationValue;

  var onSelect = _ref.onSelect,
      _ref$openOnFocus = _ref.openOnFocus,
      openOnFocus = _ref$openOnFocus === void 0 ? false : _ref$openOnFocus,
      children = _ref.children,
      _ref$as = _ref.as,
      Comp = _ref$as === void 0 ? "div" : _ref$as,
      ariaLabel = _ref["aria-label"],
      ariaLabelledby = _ref["aria-labelledby"],
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _useDescendantsInit = Object(__WEBPACK_IMPORTED_MODULE_12__reach_descendants__["e" /* useDescendantsInit */])(),
      options = _useDescendantsInit[0],
      setOptions = _useDescendantsInit[1]; // Need this to focus it


  var inputRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var popoverRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var buttonRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(); // When <ComboboxInput autocomplete={false} /> we don't want cycle back to
  // the user's value while navigating (because it's always the user's value),
  // but we need to know this in useKeyDown which is far away from the prop
  // here, so we do something sneaky and write it to this ref on context so we
  // can use it anywhere else 😛. Another new trick for me and I'm excited
  // about this one too!

  var autocompletePropRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var persistSelectionRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var defaultData = {
    // The value the user has typed. We derive this also when the developer is
    // controlling the value of ComboboxInput.
    value: "",
    // the value the user has navigated to with the keyboard
    navigationValue: null
  };

  var _useReducerMachine = useReducerMachine(stateChart, reducer, defaultData),
      state = _useReducerMachine[0],
      data = _useReducerMachine[1],
      transition = _useReducerMachine[2];

  useFocusManagement(data.lastEventType, inputRef);
  var id = Object(__WEBPACK_IMPORTED_MODULE_13__reach_auto_id__["a" /* useId */])(props.id);
  var listboxId = id ? Object(__WEBPACK_IMPORTED_MODULE_5__reach_utils_make_id__["a" /* makeId */])("listbox", id) : "listbox";
  var isControlledRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var isExpanded = popoverIsExpanded(state);
  var context = {
    ariaLabel: ariaLabel,
    ariaLabelledby: ariaLabelledby,
    autocompletePropRef: autocompletePropRef,
    buttonRef: buttonRef,
    comboboxId: id,
    data: data,
    inputRef: inputRef,
    isExpanded: isExpanded,
    listboxId: listboxId,
    onSelect: onSelect || __WEBPACK_IMPORTED_MODULE_6__reach_utils_noop__["a" /* noop */],
    openOnFocus: openOnFocus,
    persistSelectionRef: persistSelectionRef,
    popoverRef: popoverRef,
    state: state,
    transition: transition,
    isControlledRef: isControlledRef
  };
  Object(__WEBPACK_IMPORTED_MODULE_7__reach_utils_dev_utils__["a" /* useCheckStyles */])("combobox");
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_12__reach_descendants__["a" /* DescendantProvider */], {
    context: ComboboxDescendantContext,
    items: options,
    set: setOptions
  }, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ComboboxContext.Provider, {
    value: context
  }, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp, _extends({}, props, {
    "data-reach-combobox": "",
    "data-state": getDataState(state),
    "data-expanded": isExpanded || undefined,
    ref: forwardedRef
  }), Object(__WEBPACK_IMPORTED_MODULE_4__reach_utils_type_check__["b" /* isFunction */])(children) ? children({
    id: id,
    isExpanded: isExpanded,
    navigationValue: (_data$navigationValue = data.navigationValue) != null ? _data$navigationValue : null,
    state: state
  }) : children)));
});
/**
 * @see Docs https://reach.tech/combobox#combobox-props
 */

if (false) {
  Combobox.displayName = "Combobox";
  Combobox.propTypes = {
    as: PropTypes.any,
    onSelect: PropTypes.func,
    openOnFocus: PropTypes.bool
  };
} ////////////////////////////////////////////////////////////////////////////////

/**
 * ComboboxInput
 *
 * Wraps an `<input/>` with a couple extra props that work with the combobox.
 *
 * @see Docs https://reach.tech/combobox#comboboxinput
 */


var ComboboxInput = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_ref2, forwardedRef) {
  var _ref2$as = _ref2.as,
      Comp = _ref2$as === void 0 ? "input" : _ref2$as,
      _ref2$selectOnClick = _ref2.selectOnClick,
      selectOnClick = _ref2$selectOnClick === void 0 ? false : _ref2$selectOnClick,
      _ref2$autocomplete = _ref2.autocomplete,
      autocomplete = _ref2$autocomplete === void 0 ? true : _ref2$autocomplete,
      onClick = _ref2.onClick,
      onChange = _ref2.onChange,
      onKeyDown = _ref2.onKeyDown,
      onBlur = _ref2.onBlur,
      onFocus = _ref2.onFocus,
      controlledValue = _ref2.value,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  // https://github.com/reach/reach-ui/issues/464
  var _React$useRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(controlledValue),
      initialControlledValue = _React$useRef.current;

  var controlledValueChangedRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  Object(__WEBPACK_IMPORTED_MODULE_9__reach_utils_use_update_effect__["a" /* useUpdateEffect */])(function () {
    controlledValueChangedRef.current = true;
  }, [controlledValue]);

  var _React$useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ComboboxContext),
      _React$useContext$dat = _React$useContext.data,
      navigationValue = _React$useContext$dat.navigationValue,
      value = _React$useContext$dat.value,
      lastEventType = _React$useContext$dat.lastEventType,
      inputRef = _React$useContext.inputRef,
      state = _React$useContext.state,
      transition = _React$useContext.transition,
      listboxId = _React$useContext.listboxId,
      autocompletePropRef = _React$useContext.autocompletePropRef,
      openOnFocus = _React$useContext.openOnFocus,
      isExpanded = _React$useContext.isExpanded,
      ariaLabel = _React$useContext.ariaLabel,
      ariaLabelledby = _React$useContext.ariaLabelledby,
      persistSelectionRef = _React$useContext.persistSelectionRef,
      isControlledRef = _React$useContext.isControlledRef;

  var ref = Object(__WEBPACK_IMPORTED_MODULE_8__reach_utils_compose_refs__["a" /* useComposedRefs */])(inputRef, forwardedRef); // Because we close the List on blur, we need to track if the blur is
  // caused by clicking inside the list, and if so, don't close the List.

  var selectOnClickRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var handleKeyDown = useKeyDown();
  var handleBlur = useBlur();
  var isControlled = typeof controlledValue !== "undefined";
  var wasInitiallyControlled = typeof initialControlledValue !== "undefined";

  if (false) {
    process.env.NODE_ENV !== "production" ? warning(!(!isControlled && wasInitiallyControlled), "ComboboxInput is changing from controlled to uncontrolled. ComboboxInput should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled ComboboxInput for the lifetime of the component. Check the `value` prop being passed in.") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(isControlled && !wasInitiallyControlled), "ComboboxInput is changing from uncontrolled to controlled. ComboboxInput should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled ComboboxInput for the lifetime of the component. Check the `value` prop being passed in.") : void 0;
  }

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    isControlledRef.current = isControlled; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isControlled]); // Layout effect should be SSR-safe here because we don't actually do
  // anything with this ref that involves rendering until after we've
  // let the client hydrate in nested components.

  Object(__WEBPACK_IMPORTED_MODULE_2__reach_utils_use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    autocompletePropRef.current = autocomplete;
  }, [autocomplete, autocompletePropRef]);
  var handleValueChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (value) {
    if (value.trim() === "") {
      transition(CLEAR, {
        isControlled: isControlled
      });
    } else if (value === initialControlledValue && !controlledValueChangedRef.current) {
      transition(INITIAL_CHANGE, {
        value: value
      });
    } else {
      transition(CHANGE, {
        value: value
      });
    }
  }, [initialControlledValue, transition, isControlled]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    // If they are controlling the value we still need to do our transitions,
    // so  we have this derived state to emulate onChange of the input as we
    // receive new `value`s ...[*]
    if (isControlled && controlledValue !== value && ( // https://github.com/reach/reach-ui/issues/481
    controlledValue.trim() === "" ? (value || "").trim() !== "" : true)) {
      handleValueChange(controlledValue);
    }
  }, [controlledValue, handleValueChange, isControlled, value]); // [*]... and when controlled, we don't trigger handleValueChange as the
  // user types, instead the developer controls it with the normal input
  // onChange prop

  function handleChange(event) {
    var value = event.target.value;

    if (!isControlled) {
      handleValueChange(value);
    }
  }

  function handleFocus() {
    if (selectOnClick) {
      selectOnClickRef.current = true;
    } // If we select an option with click, useFocusManagement will focus the
    // input, in those cases we don't want to cause the menu to open back up,
    // so we guard behind these states.


    if (openOnFocus && lastEventType !== SELECT_WITH_CLICK) {
      transition(FOCUS, {
        persistSelection: persistSelectionRef.current
      });
    }
  }

  function handleClick() {
    if (selectOnClickRef.current) {
      var _inputRef$current;

      selectOnClickRef.current = false;
      (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.select();
    }

    if (openOnFocus && state === IDLE) {
      transition(OPEN_WITH_INPUT_CLICK);
    }
  }

  var inputValue = autocomplete && (state === NAVIGATING || state === INTERACTING) ? // When idle, we don't have a navigationValue on ArrowUp/Down
  navigationValue || controlledValue || value : controlledValue || value;
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp, _extends({
    "aria-activedescendant": navigationValue ? String(makeHash(navigationValue)) : undefined,
    "aria-autocomplete": "both",
    "aria-controls": listboxId,
    "aria-expanded": isExpanded,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabel ? undefined : ariaLabelledby,
    role: "combobox"
  }, props, {
    "data-reach-combobox-input": "",
    "data-state": getDataState(state),
    ref: ref,
    onBlur: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onBlur, handleBlur),
    onChange: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onChange, handleChange),
    onClick: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onClick, handleClick),
    onFocus: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onFocus, handleFocus),
    onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onKeyDown, handleKeyDown),
    value: inputValue || ""
  }));
});
/**
 * @see Docs https://reach.tech/combobox#comboboxinput-props
 */

if (false) {
  ComboboxInput.displayName = "ComboboxInput";
} ////////////////////////////////////////////////////////////////////////////////

/**
 * ComboboxPopover
 *
 * Contains the popup that renders the list. Because some UI needs to render
 * more than the list in the popup, you need to render one of these around the
 * list. For example, maybe you want to render the number of results suggested.
 *
 * @see Docs https://reach.tech/combobox#comboboxpopover
 */


var ComboboxPopover = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_ref3, forwardedRef) {
  var _ref3$as = _ref3.as,
      Comp = _ref3$as === void 0 ? "div" : _ref3$as,
      children = _ref3.children,
      _ref3$portal = _ref3.portal,
      portal = _ref3$portal === void 0 ? true : _ref3$portal,
      onKeyDown = _ref3.onKeyDown,
      onBlur = _ref3.onBlur,
      _ref3$position = _ref3.position,
      position = _ref3$position === void 0 ? __WEBPACK_IMPORTED_MODULE_14__reach_popover__["b" /* positionMatchWidth */] : _ref3$position,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded3);

  var _React$useContext2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ComboboxContext),
      popoverRef = _React$useContext2.popoverRef,
      inputRef = _React$useContext2.inputRef,
      isExpanded = _React$useContext2.isExpanded,
      state = _React$useContext2.state;

  var ref = Object(__WEBPACK_IMPORTED_MODULE_8__reach_utils_compose_refs__["a" /* useComposedRefs */])(popoverRef, forwardedRef);
  var handleKeyDown = useKeyDown();
  var handleBlur = useBlur();
  var sharedProps = {
    "data-reach-combobox-popover": "",
    "data-state": getDataState(state),
    onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onKeyDown, handleKeyDown),
    onBlur: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onBlur, handleBlur),
    // Instead of conditionally rendering the popover we use the `hidden` prop
    // because we don't want to unmount on close (from escape or onSelect).
    // However, the developer can conditionally render the ComboboxPopover if
    // they do want to cause mount/unmount based on the app's own data (like
    // results.length or whatever).
    hidden: !isExpanded,
    tabIndex: -1,
    children: children
  };
  return portal ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_14__reach_popover__["a" /* Popover */], _extends({
    as: Comp
  }, props, {
    ref: ref,
    "data-expanded": isExpanded || undefined,
    position: position,
    targetRef: inputRef,
    unstable_skipInitialPortalRender: true
  }, sharedProps)) : /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp, _extends({
    ref: ref
  }, props, sharedProps));
});

if (false) {
  ComboboxPopover.displayName = "ComboboxPopover";
}
/**
 * @see Docs https://reach.tech/combobox#comboboxpopover-props
 */


////////////////////////////////////////////////////////////////////////////////

/**
 * ComboboxList
 *
 * Contains the `ComboboxOption` elements and sets up the proper aria attributes
 * for the list.
 *
 * @see Docs https://reach.tech/combobox#comboboxlist
 */
var ComboboxList = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_ref4, forwardedRef) {
  var _ref4$persistSelectio = _ref4.persistSelection,
      persistSelection = _ref4$persistSelectio === void 0 ? false : _ref4$persistSelectio,
      _ref4$as = _ref4.as,
      Comp = _ref4$as === void 0 ? "ul" : _ref4$as,
      props = _objectWithoutPropertiesLoose(_ref4, _excluded4);

  var _React$useContext3 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ComboboxContext),
      persistSelectionRef = _React$useContext3.persistSelectionRef,
      listboxId = _React$useContext3.listboxId;

  if (persistSelection) {
    persistSelectionRef.current = true;
  }

  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp, _extends({
    role: "listbox"
  }, props, {
    ref: forwardedRef,
    "data-reach-combobox-list": "",
    id: listboxId
  }));
});
/**
 * @see Docs https://reach.tech/combobox#comboboxlist-props
 */

if (false) {
  ComboboxList.displayName = "ComboboxList";
} ////////////////////////////////////////////////////////////////////////////////

/**
 * ComboboxOption
 *
 * An option that is suggested to the user as they interact with the combobox.
 *
 * @see Docs https://reach.tech/combobox#comboboxoption
 */


var ComboboxOption = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_ref5, forwardedRef) {
  var _ref5$as = _ref5.as,
      Comp = _ref5$as === void 0 ? "li" : _ref5$as,
      children = _ref5.children,
      indexProp = _ref5.index,
      value = _ref5.value,
      onClick = _ref5.onClick,
      props = _objectWithoutPropertiesLoose(_ref5, _excluded5);

  var _React$useContext4 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ComboboxContext),
      onSelect = _React$useContext4.onSelect,
      navigationValue = _React$useContext4.data.navigationValue,
      transition = _React$useContext4.transition,
      isControlledRef = _React$useContext4.isControlledRef;

  var ownRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

  var _useStatefulRefValue = Object(__WEBPACK_IMPORTED_MODULE_10__reach_utils_use_stateful_ref_value__["a" /* useStatefulRefValue */])(ownRef, null),
      element = _useStatefulRefValue[0],
      handleRefSet = _useStatefulRefValue[1];

  var descendant = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return {
      element: element,
      value: value
    };
  }, [value, element]);
  var index = Object(__WEBPACK_IMPORTED_MODULE_12__reach_descendants__["c" /* useDescendant */])(descendant, ComboboxDescendantContext, indexProp);
  var ref = Object(__WEBPACK_IMPORTED_MODULE_8__reach_utils_compose_refs__["a" /* useComposedRefs */])(forwardedRef, handleRefSet);
  var isActive = navigationValue === value;

  var handleClick = function handleClick() {
    onSelect && onSelect(value);
    transition(SELECT_WITH_CLICK, {
      value: value,
      isControlled: isControlledRef.current
    });
  };

  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(OptionContext.Provider, {
    value: {
      value: value,
      index: index
    }
  }, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp, _extends({
    "aria-selected": isActive,
    role: "option"
  }, props, {
    "data-reach-combobox-option": "",
    ref: ref,
    id: String(makeHash(value)),
    "data-highlighted": isActive ? "" : undefined // Without this the menu will close from `onBlur`, but with it the
    // element can be `document.activeElement` and then our focus checks in
    // onBlur will work as intended
    ,
    tabIndex: -1,
    onClick: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onClick, handleClick)
  }), children ? Object(__WEBPACK_IMPORTED_MODULE_4__reach_utils_type_check__["b" /* isFunction */])(children) ? children({
    value: value,
    index: index
  }) : children : /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ComboboxOptionText, null)));
});
/**
 * @see Docs https://reach.tech/combobox#comboboxoption-props
 */

if (false) {
  ComboboxOption.displayName = "ComboboxOption";
} ////////////////////////////////////////////////////////////////////////////////

/**
 * ComboboxOptionText
 *
 * Renders the value of a `ComboboxOption` as text but with spans wrapping the
 * matching and non-matching segments of text.
 *
 * We don't forwardRef or spread props because we render multiple spans or null,
 * should be fine 🤙
 *
 * @example
 *   <ComboboxOption value="Seattle">
 *     🌧 <ComboboxOptionText />
 *   </ComboboxOption>
 *
 * @see Docs https://reach.tech/combobox#comboboxoptiontext
 */


function ComboboxOptionText() {
  var _React$useContext5 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(OptionContext),
      value = _React$useContext5.value;

  var _React$useContext6 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ComboboxContext),
      contextValue = _React$useContext6.data.value;

  var results = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return HighlightWords.findAll({
      searchWords: escapeRegexp(contextValue || "").split(/\s+/),
      textToHighlight: value
    });
  }, [contextValue, value]);
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, results.length ? results.map(function (result, index) {
    var str = value.slice(result.start, result.end);
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", {
      key: index,
      "data-reach-combobox-option-text": "",
      "data-user-value": result.highlight ? true : undefined,
      "data-suggested-value": result.highlight ? undefined : true
    }, str);
  }) : value);
}

if (false) {
  ComboboxOptionText.displayName = "ComboboxOptionText";
} ////////////////////////////////////////////////////////////////////////////////

/**
 * ComboboxButton
 */


var ComboboxButton = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_ref6, forwardedRef) {
  var _ref6$as = _ref6.as,
      Comp = _ref6$as === void 0 ? "button" : _ref6$as,
      onClick = _ref6.onClick,
      onKeyDown = _ref6.onKeyDown,
      props = _objectWithoutPropertiesLoose(_ref6, _excluded6);

  var _React$useContext7 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ComboboxContext),
      transition = _React$useContext7.transition,
      state = _React$useContext7.state,
      buttonRef = _React$useContext7.buttonRef,
      listboxId = _React$useContext7.listboxId,
      isExpanded = _React$useContext7.isExpanded;

  var ref = Object(__WEBPACK_IMPORTED_MODULE_8__reach_utils_compose_refs__["a" /* useComposedRefs */])(buttonRef, forwardedRef);
  var handleKeyDown = useKeyDown();

  var handleClick = function handleClick() {
    if (state === IDLE) {
      transition(OPEN_WITH_BUTTON);
    } else {
      transition(CLOSE_WITH_BUTTON);
    }
  };

  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp, _extends({
    "aria-controls": listboxId,
    "aria-haspopup": "listbox",
    "aria-expanded": isExpanded
  }, props, {
    "data-reach-combobox-button": "",
    ref: ref,
    onClick: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onClick, handleClick),
    onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_11__reach_utils_compose_event_handlers__["a" /* composeEventHandlers */])(onKeyDown, handleKeyDown)
  }));
});

if (false) {
  ComboboxButton.displayName = "ComboboxButton";
} ////////////////////////////////////////////////////////////////////////////////

/**
 * Move focus back to the input if we start navigating w/ the
 * keyboard after focus has moved to any focusable content in
 * the popup.
 *
 * @param lastEventType
 * @param inputRef
 */


function useFocusManagement(lastEventType, inputRef) {
  // useLayoutEffect so that the cursor goes to the end of the input instead
  // of awkwardly at the beginning, unclear to me why 🤷‍♂️
  //
  // Should be safe to use here since we're just focusing an input.
  Object(__WEBPACK_IMPORTED_MODULE_2__reach_utils_use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    if (lastEventType === NAVIGATE || lastEventType === ESCAPE || lastEventType === SELECT_WITH_CLICK || lastEventType === OPEN_WITH_BUTTON) {
      var _inputRef$current2;

      (_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.focus();
    }
  }, [inputRef, lastEventType]);
}
/**
 * We want the same events when the input or the popup have focus (HOW COOL ARE
 * HOOKS BTW?) This is probably the hairiest piece but it's not bad.
 */


function useKeyDown() {
  var _React$useContext8 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ComboboxContext),
      navigationValue = _React$useContext8.data.navigationValue,
      onSelect = _React$useContext8.onSelect,
      state = _React$useContext8.state,
      transition = _React$useContext8.transition,
      autocompletePropRef = _React$useContext8.autocompletePropRef,
      persistSelectionRef = _React$useContext8.persistSelectionRef,
      isControlledRef = _React$useContext8.isControlledRef;

  var options = Object(__WEBPACK_IMPORTED_MODULE_12__reach_descendants__["d" /* useDescendants */])(ComboboxDescendantContext);
  return function handleKeyDown(event) {
    var index = options.findIndex(function (_ref7) {
      var value = _ref7.value;
      return value === navigationValue;
    });

    function getNextOption() {
      var atBottom = index === options.length - 1;

      if (atBottom) {
        if (autocompletePropRef.current) {
          // Go back to the value the user has typed because we are
          // autocompleting and they need to be able to get back to what
          // they had typed w/o having to backspace out.
          return null;
        } else {
          // cycle through
          return getFirstOption();
        }
      } else {
        // Go to the next item in the list
        return options[(index + 1) % options.length];
      }
    }

    function getPreviousOption() {
      var atTop = index === 0;

      if (atTop) {
        if (autocompletePropRef.current) {
          // Go back to the value the user has typed because we are
          // autocompleting and they need to be able to get back to what
          // they had typed w/o having to backspace out.
          return null;
        } else {
          // cycle through
          return getLastOption();
        }
      } else if (index === -1) {
        // displaying the user's value, so go select the last one
        return getLastOption();
      } else {
        // normal case, select previous
        return options[(index - 1 + options.length) % options.length];
      }
    }

    function getFirstOption() {
      return options[0];
    }

    function getLastOption() {
      return options[options.length - 1];
    }

    switch (event.key) {
      case "ArrowDown":
        // Don't scroll the page
        event.preventDefault();

        if (!options || !options.length) {
          return;
        }

        if (state === IDLE) {
          // Opening a closed list
          transition(NAVIGATE, {
            persistSelection: persistSelectionRef.current
          });
        } else {
          var next = getNextOption();
          transition(NAVIGATE, {
            value: next ? next.value : null
          });
        }

        break;
      // A lot of duplicate code with ArrowDown up next, I'm already over it.

      case "ArrowUp":
        // Don't scroll the page
        event.preventDefault();

        if (!options || options.length === 0) {
          return;
        }

        if (state === IDLE) {
          transition(NAVIGATE);
        } else {
          var prev = getPreviousOption();
          transition(NAVIGATE, {
            value: prev ? prev.value : null
          });
        }

        break;

      case "Home":
      case "PageUp":
        // Don't scroll the page
        event.preventDefault();

        if (!options || options.length === 0) {
          return;
        }

        if (state === IDLE) {
          transition(NAVIGATE);
        } else {
          transition(NAVIGATE, {
            value: getFirstOption().value
          });
        }

        break;

      case "End":
      case "PageDown":
        // Don't scroll the page
        event.preventDefault();

        if (!options || options.length === 0) {
          return;
        }

        if (state === IDLE) {
          transition(NAVIGATE);
        } else {
          transition(NAVIGATE, {
            value: getLastOption().value
          });
        }

        break;

      case "Escape":
        if (state !== IDLE) {
          transition(ESCAPE);
        }

        break;

      case "Enter":
        if (state === NAVIGATING && navigationValue !== null) {
          // don't want to submit forms
          event.preventDefault();
          onSelect && onSelect(navigationValue);
          transition(SELECT_WITH_KEYBOARD, {
            isControlled: isControlledRef.current
          });
        }

        break;
    }
  };
}

function useBlur() {
  var _React$useContext9 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ComboboxContext),
      state = _React$useContext9.state,
      transition = _React$useContext9.transition,
      popoverRef = _React$useContext9.popoverRef,
      inputRef = _React$useContext9.inputRef,
      buttonRef = _React$useContext9.buttonRef;

  return function handleBlur(event) {
    var popover = popoverRef.current;
    var input = inputRef.current;
    var button = buttonRef.current;
    var activeElement = event.relatedTarget; // we on want to close only if focus propss outside the combobox

    if (activeElement !== input && activeElement !== button && popover) {
      if (popover.contains(activeElement)) {
        // focus landed inside the combobox, keep it open
        if (state !== INTERACTING) {
          transition(INTERACT);
        }
      } else {
        // focus landed outside the combobox, close it.
        transition(BLUR);
      }
    }
  };
}
/**
 * This manages transitions between states with a built in reducer to manage
 * the data that goes with those transitions.
 *
 * @param chart
 * @param reducer
 * @param initialData
 */


function useReducerMachine(chart, reducer, initialData) {
  var _React$useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(chart.initial),
      state = _React$useState[0],
      setState = _React$useState[1];

  var _React$useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(reducer, initialData),
      data = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var transition = function transition(event, payload) {
    if (payload === void 0) {
      payload = {};
    }

    var currentState = chart.states[state];
    var nextState = currentState && currentState.on[event];

    if (nextState) {
      dispatch(_extends({
        type: event,
        state: state,
        nextState: state
      }, payload));
      setState(nextState);
      return;
    }
  };

  return [state, data, transition];
}
/**
 * We don't want to track the active descendant with indexes because nothing is
 * more annoying in a combobox than having it change values RIGHT AS YOU HIT
 * ENTER. That only happens if you use the index as your data, rather than
 * *your data as your data*. We use this to generate a unique ID based on the
 * value of each item.  This function is short, sweet, and good enough™ (I also
 * don't know how it works, tbqh)
 *
 * @see https://stackoverflow.com/questions/6122571/simple-non-secure-hash-function-for-javascript
 * @param str
 */


function makeHash(str) {
  var hash = 0;

  if (str.length === 0) {
    return hash;
  }

  for (var i = 0; i < str.length; i++) {
    var _char = str.charCodeAt(i);

    hash = (hash << 5) - hash + _char;
    hash = hash & hash;
  }

  return hash;
} // function getActiveElement(node: Element | null | undefined) {
//   let activeElement: Element | null = null;
//   try {
//     // If Element.getRootNode is supported, we'll retrieve either the root
//     // Document or shadow root depending on where the component is rendered.
//     // https://github.com/reach/reach-ui/issues/787
//     activeElement = (node?.getRootNode() as ShadowRoot | Document)
//       .activeElement;
//   } finally {
//     return activeElement || (node?.ownerDocument || document).activeElement;
//   }
// }


function getDataState(state) {
  return state.toLowerCase();
}
/**
 * Escape regexp special characters in `str`
 *
 * @see https://github.com/component/escape-regexp/blob/5ce923c1510c9802b3da972c90b6861dd2829b6b/index.js
 * @param str
 */


function escapeRegexp(str) {
  return String(str).replace(/([.*+?=^!:${}()|[\]/\\])/g, "\\$1");
} //////////////////////////
//////////////////////////////////////////////////////

/**
 * A hook that exposes data for a given `Combobox` component to its descendants.
 *
 * @see Docs https://reach.tech/combobox#usecomboboxcontext
 */

function useComboboxContext() {
  var _React$useContext10 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ComboboxContext),
      isExpanded = _React$useContext10.isExpanded,
      comboboxId = _React$useContext10.comboboxId,
      data = _React$useContext10.data,
      state = _React$useContext10.state;

  var navigationValue = data.navigationValue;
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return {
      id: comboboxId,
      isExpanded: isExpanded,
      navigationValue: navigationValue != null ? navigationValue : null,
      state: state
    };
  }, [comboboxId, isExpanded, navigationValue, state]);
}
/**
 * A hook that exposes data for a given `ComboboxOption` component to its descendants.
 *
 * @see Docs https://reach.tech/combobox#usecomboboxcontext
 */

function useComboboxOptionContext() {
  var _React$useContext11 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(OptionContext),
      value = _React$useContext11.value,
      index = _React$useContext11.index;

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return {
      value: value,
      index: index
    };
  }, [value, index]);
} ////////////////////////////////////////////////////////////////////////////////
// Well alright, you made it all the way here to like 1100 lines of code (geez,
// what the heck?). Have a great day :D
////////////////////////////////////////////////////////////////////////////////
// Types




/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createNamedContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["children"];
/** @deprecated */

function createNamedContext(name, defaultValue) {
  var Ctx = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(defaultValue);

  if (false) {
    Ctx.displayName = name;
  }

  return Ctx;
} ////////////////////////////////////////////////////////////////////////////////

function createContext(rootName, defaultContext) {
  var Ctx = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(defaultContext);

  function Provider(props) {
    var children = props.children,
        context = _objectWithoutPropertiesLoose(props, _excluded);

    var value = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
      return context;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    Object.values(context));
    return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Ctx.Provider, {
      value: value
    }, children);
  }

  function useContext$1(childName) {
    var context = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(Ctx);

    if (context) {
      return context;
    }

    if (defaultContext) {
      return defaultContext;
    }

    throw Error(childName + " must be rendered inside of a " + rootName + " component.");
  }

  if (false) {
    Ctx.displayName = rootName + "Context";
    Provider.displayName = rootName + "Provider";
  }

  return [Provider, useContext$1];
}




/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeId; });
/**
 * Joins strings to format IDs for compound components.
 *
 * @param args
 */
function makeId() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.filter(function (val) {
    return val != null;
  }).join("--");
}




/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useCheckStyles; });
/* unused harmony export useControlledSwitchWarning */
/* unused harmony export useStateLogger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/* eslint-disable react-hooks/rules-of-hooks */
var checkedPkgs = {};
/**
 * Just a lil state logger
 *
 * @param state
 * @param DEBUG
 */

function useStateLogger(state, DEBUG) {
  if (DEBUG === void 0) {
    DEBUG = false;
  }

  if (false) {
    var debugRef = useRef(DEBUG);
    useEffect(function () {
      debugRef.current = DEBUG;
    }, [DEBUG]);
    useEffect(function () {
      if (debugRef.current) {
        console.group("State Updated");
        console.log("%c" + state, "font-weight: normal; font-size: 120%; font-style: italic;");
        console.groupEnd();
      }
    }, [state]);
  }
}
/**
 * When in dev mode, checks that styles for a given `@reach` package are loaded.
 *
 * @param packageName Name of the package to check.
 * @example checkStyles("dialog") will check for styles for @reach/dialog
 */

function checkStyles(packageName) {
  if (false) {
    // In CJS files, process.env.NODE_ENV is stripped from our build, but we
    // need it to prevent style checks from clogging up user logs while testing.
    // This is a workaround until we can tweak the build a bit to accommodate.
    var _ref = typeof process !== "undefined" ? process.env : {
      NODE_ENV: "development"
    },
        environment = _ref.NODE_ENV; // only check once per package


    if (checkedPkgs[packageName]) return;
    checkedPkgs[packageName] = true;

    if (environment === "development" && parseInt(window.getComputedStyle(document.body).getPropertyValue("--reach-" + packageName), 10) !== 1) {
      console.warn("@reach/" + packageName + " styles not found. If you are using a bundler like webpack or parcel include this in the entry file of your app before any of your own styles:\n  \n      import \"@reach/" + packageName + "/styles.css\";\n  \n    Otherwise you'll need to include them some other way:\n  \n      <link rel=\"stylesheet\" type=\"text/css\" href=\"node_modules/@reach/" + packageName + "/styles.css\" />\n  \n    For more information visit https://ui.reach.tech/styling.\n    ");
    }
  }
}
/**
 * When in dev mode, checks that styles for a given `@reach` package are loaded.
 *
 * @param packageName Name of the package to check.
 * @example useCheckStyles("dialog") will check for styles for @reach/dialog
 */

function useCheckStyles(packageName) {
  if (false) {
    var name = useRef(packageName);
    useEffect(function () {
      return void (name.current = packageName);
    }, [packageName]);
    useEffect(function () {
      return checkStyles(name.current);
    }, []);
  }
}
/**
 * Logs a warning in dev mode when a component switches from controlled to
 * uncontrolled, or vice versa
 *
 * A single prop should typically be used to determine whether or not a
 * component is controlled or not.
 *
 * @param controlledValue
 * @param controlledPropName
 * @param componentName
 */

function useControlledSwitchWarning(controlledValue, controlledPropName, componentName) {
  if (false) {
    var controlledRef = useRef(controlledValue != null);
    var nameCache = useRef({
      componentName: componentName,
      controlledPropName: controlledPropName
    });
    useEffect(function () {
      nameCache.current = {
        componentName: componentName,
        controlledPropName: controlledPropName
      };
    }, [componentName, controlledPropName]);
    useEffect(function () {
      var wasControlled = controlledRef.current;
      var _nameCache$current = nameCache.current,
          componentName = _nameCache$current.componentName,
          controlledPropName = _nameCache$current.controlledPropName;
      var isControlled = controlledValue != null;

      if (wasControlled !== isControlled) {
        console.error("A component is changing an " + (wasControlled ? "" : "un") + "controlled `" + controlledPropName + "` state of " + componentName + " to be " + (wasControlled ? "un" : "") + "controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled " + componentName + " element for the lifetime of the component.\n      More info: https://fb.me/react-controlled-components");
      }
    }, [controlledValue]);
  }
}




/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useUpdateEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/**
 * Call an effect after a component update, skipping the initial mount.
 *
 * @param effect Effect to call
 * @param deps Effect dependency list
 */
function useUpdateEffect(effect, deps) {
  var mounted = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (mounted.current) {
      effect();
    } else {
      mounted.current = true;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, deps);
}




/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useStatefulRefValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function useStatefulRefValue(ref, initialState) {
  var _useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialState),
      state = _useState[0],
      setState = _useState[1];

  var callbackRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (refValue) {
    ref.current = refValue;
    setState(refValue); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [state, callbackRef];
}




/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return composeEventHandlers; });
/**
 * Wraps a lib-defined event handler and a user-defined event handler, returning
 * a single handler that allows a user to prevent lib-defined handlers from
 * firing.
 *
 * @param theirHandler User-supplied event handler
 * @param ourHandler Library-supplied event handler
 */
function composeEventHandlers(theirHandler, ourHandler) {
  return function (event) {
    theirHandler && theirHandler(event);

    if (!event.defaultPrevented) {
      return ourHandler(event);
    }
  };
}




/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescendantProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createDescendantContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useDescendant; });
/* unused harmony export useDescendantKeyDown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return useDescendants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useDescendantsInit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reach_utils_use_force_update__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reach_utils_use_isomorphic_layout_effect__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reach_utils_noop__ = __webpack_require__(1017);





function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _excluded = ["element", "index"];

function createDescendantContext(name, initialValue) {
  if (initialValue === void 0) {
    initialValue = {};
  }

  var descendants = [];
  var ctx = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(_extends({
    descendants: descendants,
    registerDescendant: __WEBPACK_IMPORTED_MODULE_3__reach_utils_noop__["a" /* noop */],
    unregisterDescendant: __WEBPACK_IMPORTED_MODULE_3__reach_utils_noop__["a" /* noop */]
  }, initialValue));

  if (false) {
    ctx.displayName = name;
  }

  return ctx;
}
/**
 * This hook registers our descendant by passing it into an array. We can then
 * search that array by to find its index when registering it in the component.
 * We use this for focus management, keyboard navigation, and typeahead
 * functionality for some components.
 *
 * The hook accepts the element node and (optionally) a key. The key is useful
 * if multiple descendants have identical text values and we need to
 * differentiate siblings for some reason.
 *
 * Our main goals with this are:
 *   1) maximum composability,
 *   2) minimal API friction
 *   3) SSR compatibility*
 *   4) concurrent safe
 *   5) index always up-to-date with the tree despite changes
 *   6) works with memoization of any component in the tree (hopefully)
 *
 * As for SSR, the good news is that we don't actually need the index on the
 * server for most use-cases, as we are only using it to determine the order of
 * composed descendants for keyboard navigation. However, in the few cases where
 * this is not the case, we can require an explicit index from the app.
 */


function useDescendant(descendant, context, indexProp) {
  var forceUpdate = Object(__WEBPACK_IMPORTED_MODULE_1__reach_utils_use_force_update__["a" /* useForceUpdate */])();

  var _React$useContext = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context),
      registerDescendant = _React$useContext.registerDescendant,
      unregisterDescendant = _React$useContext.unregisterDescendant,
      descendants = _React$useContext.descendants; // This will initially return -1 because we haven't registered the descendant
  // on the first render. After we register, this will then return the correct
  // index on the following render and we will re-register descendants so that
  // everything is up-to-date before the user interacts with a collection.


  var index = indexProp != null ? indexProp : descendants.findIndex(function (item) {
    return item.element === descendant.element;
  }); // Prevent any flashing

  Object(__WEBPACK_IMPORTED_MODULE_2__reach_utils_use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    if (!descendant.element) forceUpdate();
    registerDescendant(_extends({}, descendant, {
      index: index
    }));
    return function () {
      unregisterDescendant(descendant.element);
    };
  }, [descendant, forceUpdate, index, registerDescendant, unregisterDescendant].concat(Object.values(descendant)));
  return index;
}

function useDescendantsInit() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]);
}

function useDescendants(ctx) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ctx).descendants;
}

function DescendantProvider(_ref) {
  var Ctx = _ref.context,
      children = _ref.children,
      items = _ref.items,
      set = _ref.set;
  var registerDescendant = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (_ref2) {
    var element = _ref2.element,
        explicitIndex = _ref2.index,
        rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

    if (!element) {
      return;
    }

    set(function (items) {
      var newItems;

      if (explicitIndex != null) {
        return [].concat(items, [_extends({}, rest, {
          element: element,
          index: explicitIndex
        })]).sort(function (a, b) {
          return a.index - b.index;
        });
      } else if (items.length === 0) {
        // If there are no items, register at index 0 and bail.
        newItems = [_extends({}, rest, {
          element: element,
          index: 0
        })];
      } else if (items.find(function (item) {
        return item.element === element;
      })) {
        // If the element is already registered, just use the same array
        newItems = items;
      } else {
        // When registering a descendant, we need to make sure we insert in
        // into the array in the same order that it appears in the DOM. So as
        // new descendants are added or maybe some are removed, we always know
        // that the array is up-to-date and correct.
        //
        // So here we look at our registered descendants and see if the new
        // element we are adding appears earlier than an existing descendant's
        // DOM node via `node.compareDocumentPosition`. If it does, we insert
        // the new element at this index. Because `registerDescendant` will be
        // called in an effect every time the descendants state value changes,
        // we should be sure that this index is accurate when descendent
        // elements come or go from our component.
        var index = items.findIndex(function (item) {
          if (!item.element || !element) {
            return false;
          } // Does this element's DOM node appear before another item in the
          // array in our DOM tree? If so, return true to grab the index at
          // this point in the array so we know where to insert the new
          // element.


          return Boolean(item.element.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING);
        });

        var newItem = _extends({}, rest, {
          element: element,
          index: index
        }); // If an index is not found we will push the element to the end.


        if (index === -1) {
          newItems = [].concat(items, [newItem]);
        } else {
          newItems = [].concat(items.slice(0, index), [newItem], items.slice(index));
        }
      }

      return newItems.map(function (item, index) {
        return _extends({}, item, {
          index: index
        });
      });
    });
  }, // set is a state setter initialized by the useDescendantsInit hook.
  // We can safely ignore the lint warning here because it will not change
  // between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  var unregisterDescendant = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (element) {
    if (!element) {
      return;
    }

    set(function (items) {
      return items.filter(function (item) {
        return element !== item.element;
      });
    });
  }, // set is a state setter initialized by the useDescendantsInit hook.
  // We can safely ignore the lint warning here because it will not change
  // between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Ctx.Provider, {
    value: Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
      return {
        descendants: items,
        registerDescendant: registerDescendant,
        unregisterDescendant: unregisterDescendant
      };
    }, [items, registerDescendant, unregisterDescendant])
  }, children);
}
/**
 * Testing this as an abstraction for compound components that use keyboard
 * navigation. Hoping this will help us prevent bugs and mismatched behavior
 * across various components, but it may also prove to be too messy of an
 * abstraction in the end.
 *
 * Currently used in:
 *   - Tabs
 *   - Accordion
 *
 * @param context
 * @param options
 */


function useDescendantKeyDown(context, options) {
  var _React$useContext2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context),
      descendants = _React$useContext2.descendants;

  var callback = options.callback,
      currentIndex = options.currentIndex,
      filter = options.filter,
      _options$key = options.key,
      key = _options$key === void 0 ? "index" : _options$key,
      _options$orientation = options.orientation,
      orientation = _options$orientation === void 0 ? "vertical" : _options$orientation,
      _options$rotate = options.rotate,
      rotate = _options$rotate === void 0 ? true : _options$rotate,
      _options$rtl = options.rtl,
      rtl = _options$rtl === void 0 ? false : _options$rtl;
  return function handleKeyDown(event) {
    if (!["ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight", "PageUp", "PageDown", "Home", "End"].includes(event.key)) {
      return;
    }

    var index = currentIndex != null ? currentIndex : -1; // If we use a filter function, we need to re-index our descendants array
    // so that filtered descendent elements aren't selected.

    var selectableDescendants = filter ? descendants.filter(filter) : descendants; // We need some options for any of this to work!

    if (!selectableDescendants.length) {
      return;
    }

    var selectableIndex = selectableDescendants.findIndex(function (descendant) {
      return descendant.index === currentIndex;
    });

    function getNextOption() {
      var atBottom = index === getLastOption().index;
      return atBottom ? rotate ? getFirstOption() : selectableDescendants[selectableIndex] : selectableDescendants[(selectableIndex + 1) % selectableDescendants.length];
    }

    function getPreviousOption() {
      var atTop = index === getFirstOption().index;
      return atTop ? rotate ? getLastOption() : selectableDescendants[selectableIndex] : selectableDescendants[(selectableIndex - 1 + selectableDescendants.length) % selectableDescendants.length];
    }

    function getFirstOption() {
      return selectableDescendants[0];
    }

    function getLastOption() {
      return selectableDescendants[selectableDescendants.length - 1];
    }

    switch (event.key) {
      case "ArrowDown":
        if (orientation === "vertical" || orientation === "both") {
          event.preventDefault();
          var next = getNextOption();
          callback(key === "option" ? next : next[key]);
        }

        break;

      case "ArrowUp":
        if (orientation === "vertical" || orientation === "both") {
          event.preventDefault();
          var prev = getPreviousOption();
          callback(key === "option" ? prev : prev[key]);
        }

        break;

      case "ArrowLeft":
        if (orientation === "horizontal" || orientation === "both") {
          event.preventDefault();
          var nextOrPrev = (rtl ? getNextOption : getPreviousOption)();
          callback(key === "option" ? nextOrPrev : nextOrPrev[key]);
        }

        break;

      case "ArrowRight":
        if (orientation === "horizontal" || orientation === "both") {
          event.preventDefault();
          var prevOrNext = (rtl ? getPreviousOption : getNextOption)();
          callback(key === "option" ? prevOrNext : prevOrNext[key]);
        }

        break;

      case "PageUp":
        event.preventDefault();
        var prevOrFirst = (event.ctrlKey ? getPreviousOption : getFirstOption)();
        callback(key === "option" ? prevOrFirst : prevOrFirst[key]);
        break;

      case "Home":
        event.preventDefault();
        var first = getFirstOption();
        callback(key === "option" ? first : first[key]);
        break;

      case "PageDown":
        event.preventDefault();
        var nextOrLast = (event.ctrlKey ? getNextOption : getLastOption)();
        callback(key === "option" ? nextOrLast : nextOrLast[key]);
        break;

      case "End":
        event.preventDefault();
        var last = getLastOption();
        callback(key === "option" ? last : last[key]);
        break;
    }
  };
} ////////////////////////////////////////////////////////////////////////////////




/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reach_utils_use_isomorphic_layout_effect__ = __webpack_require__(323);



/*
 * Welcome to @reach/auto-id!

 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */
var serverHandoffComplete = false;
var id = 0;

function genId() {
  return ++id;
}
/* eslint-disable react-hooks/rules-of-hooks */

/**
 * useId
 *
 * Autogenerate IDs to facilitate WAI-ARIA and server rendering.
 *
 * Note: The returned ID will initially be `null` and will update after a
 * component mounts. Users may need to supply their own ID if they need
 * consistent values for SSR.
 *
 * @see Docs https://reach.tech/auto-id
 */


function useId(providedId) {
  var _ref;

  // TODO: Remove error flag when updating internal deps to React 18. None of
  // our tricks will play well with concurrent rendering anyway.
  // @ts-expect-error
  if (typeof __WEBPACK_IMPORTED_MODULE_0_react__["useId"] === "function") {
    // @ts-expect-error
    var _id = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useId"])(providedId);

    return providedId != null ? providedId : _id;
  } // If this instance isn't part of the initial render, we don't have to do the
  // double render/patch-up dance. We can just generate the ID and return it.


  var initialId = providedId != null ? providedId : serverHandoffComplete ? genId() : null;

  var _React$useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(initialId),
      id = _React$useState[0],
      setId = _React$useState[1];

  Object(__WEBPACK_IMPORTED_MODULE_1__reach_utils_use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    if (id === null) {
      // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
      // rendering flicker, though it'll make the first render slower (unlikely
      // to matter, but you're welcome to measure your app and let us know if
      // it's a problem).
      setId(genId());
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (serverHandoffComplete === false) {
      // Flag all future uses of `useId` to skip the update dance. This is in
      // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
      // accidentally bail out of the patch-up dance prematurely.
      serverHandoffComplete = true;
    }
  }, []);
  return (_ref = providedId != null ? providedId : id) != null ? _ref : undefined;
}




/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popover; });
/* unused harmony export getCollisions */
/* unused harmony export positionDefault */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return positionMatchWidth; });
/* unused harmony export positionRight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reach_portal__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reach_rect__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reach_utils_owner_document__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reach_utils_compose_refs__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tabbable__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tabbable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_tabbable__);







function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["unstable_skipInitialPortalRender"],
    _excluded2 = ["as", "targetRef", "position", "unstable_observableRefs"];
////////////////////////////////////////////////////////////////////////////////

/**
 * Popover
 */
var Popover = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function Popover(_ref, ref) {
  var unstable_skipInitialPortalRender = _ref.unstable_skipInitialPortalRender,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1__reach_portal__["a" /* Portal */], {
    unstable_skipInitialRender: unstable_skipInitialPortalRender
  }, /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(PopoverImpl, _extends({
    ref: ref
  }, props)));
});

if (false) {
  Popover.displayName = "Popover";
} ////////////////////////////////////////////////////////////////////////////////

/**
 * PopoverImpl
 *
 * Popover is conditionally rendered so we can't start measuring until it shows
 * up, so useRect needs to live down here not up in Popover
 */


var PopoverImpl = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function PopoverImpl(_ref2, forwardedRef) {
  var _ref2$as = _ref2.as,
      Comp = _ref2$as === void 0 ? "div" : _ref2$as,
      targetRef = _ref2.targetRef,
      _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? positionDefault : _ref2$position,
      _ref2$unstable_observ = _ref2.unstable_observableRefs,
      unstable_observableRefs = _ref2$unstable_observ === void 0 ? [] : _ref2$unstable_observ,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var popoverRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var popoverRect = Object(__WEBPACK_IMPORTED_MODULE_2__reach_rect__["a" /* useRect */])(popoverRef, {
    observe: !props.hidden
  });
  var targetRect = Object(__WEBPACK_IMPORTED_MODULE_2__reach_rect__["a" /* useRect */])(targetRef, {
    observe: !props.hidden
  });
  var ref = Object(__WEBPACK_IMPORTED_MODULE_4__reach_utils_compose_refs__["a" /* useComposedRefs */])(popoverRef, forwardedRef);
  useSimulateTabNavigationForReactTree(targetRef, popoverRef);
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp, _extends({
    "data-reach-popover": "",
    ref: ref
  }, props, {
    style: _extends({
      position: "absolute"
    }, getStyles.apply(void 0, [position, targetRect, popoverRect].concat(unstable_observableRefs)), props.style)
  }));
});

if (false) {
  PopoverImpl.displayName = "PopoverImpl";
} ////////////////////////////////////////////////////////////////////////////////


function getStyles(position, targetRect, popoverRect) {
  for (var _len = arguments.length, unstable_observableRefs = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    unstable_observableRefs[_key - 3] = arguments[_key];
  }

  return popoverRect ? position.apply(void 0, [targetRect, popoverRect].concat(unstable_observableRefs.map(function (ref) {
    return ref.current;
  }))) : {
    visibility: "hidden"
  };
}

function getTopPosition(targetRect, popoverRect, isDirectionUp) {
  return {
    top: isDirectionUp ? targetRect.top - popoverRect.height + window.pageYOffset + "px" : targetRect.top + targetRect.height + window.pageYOffset + "px"
  };
}

var positionDefault = function positionDefault(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }

  var _getCollisions = getCollisions(targetRect, popoverRect),
      directionRight = _getCollisions.directionRight,
      directionUp = _getCollisions.directionUp;

  return _extends({
    left: directionRight ? targetRect.right - popoverRect.width + window.pageXOffset + "px" : targetRect.left + window.pageXOffset + "px"
  }, getTopPosition(targetRect, popoverRect, directionUp));
};

var positionRight = function positionRight(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }

  var _getCollisions2 = getCollisions(targetRect, popoverRect),
      directionLeft = _getCollisions2.directionLeft,
      directionUp = _getCollisions2.directionUp;

  return _extends({
    left: directionLeft ? targetRect.left + window.pageXOffset + "px" : targetRect.right - popoverRect.width + window.pageXOffset + "px"
  }, getTopPosition(targetRect, popoverRect, directionUp));
};

var positionMatchWidth = function positionMatchWidth(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }

  var _getCollisions3 = getCollisions(targetRect, popoverRect),
      directionUp = _getCollisions3.directionUp;

  return _extends({
    width: targetRect.width,
    left: targetRect.left
  }, getTopPosition(targetRect, popoverRect, directionUp));
};

function getCollisions(targetRect, popoverRect, offsetLeft, offsetBottom) {
  if (offsetLeft === void 0) {
    offsetLeft = 0;
  }

  if (offsetBottom === void 0) {
    offsetBottom = 0;
  }

  var collisions = {
    top: targetRect.top - popoverRect.height < 0,
    right: window.innerWidth < targetRect.left + popoverRect.width - offsetLeft,
    bottom: window.innerHeight < targetRect.bottom + popoverRect.height - offsetBottom,
    left: targetRect.left + targetRect.width - popoverRect.width < 0
  };
  var directionRight = collisions.right && !collisions.left;
  var directionLeft = collisions.left && !collisions.right;
  var directionUp = collisions.bottom && !collisions.top;
  var directionDown = collisions.top && !collisions.bottom;
  return {
    directionRight: directionRight,
    directionLeft: directionLeft,
    directionUp: directionUp,
    directionDown: directionDown
  };
} // Heads up, my jQuery past haunts this function. This hook scopes the tab
// order to the React element tree, instead of the DOM tree. This way, when the
// user navigates with tab from the targetRef, the tab order moves into the
// popup, and then out of the popup back to the rest of the document.
// (We call targetRef, triggerRef inside this function to avoid confusion with
// event.target)


function useSimulateTabNavigationForReactTree(triggerRef, popoverRef) {
  var ownerDocument = Object(__WEBPACK_IMPORTED_MODULE_3__reach_utils_owner_document__["a" /* getOwnerDocument */])(triggerRef.current);

  function handleKeyDown(event) {
    if (event.key === "Tab" && popoverRef.current && __WEBPACK_IMPORTED_MODULE_5_tabbable___default()(popoverRef.current).length === 0) {
      return;
    }

    if (event.key === "Tab" && event.shiftKey) {
      if (shiftTabbedFromElementAfterTrigger(event)) {
        focusLastTabbableInPopover(event);
      } else if (shiftTabbedOutOfPopover(event)) {
        focusTriggerRef(event);
      } else if (shiftTabbedToBrowserChrome(event)) {
        disableTabbablesInPopover();
      }
    } else if (event.key === "Tab") {
      if (tabbedFromTriggerToPopover()) {
        focusFirstPopoverTabbable(event);
      } else if (tabbedOutOfPopover()) {
        focusTabbableAfterTrigger(event);
      } else if (tabbedToBrowserChrome(event)) {
        disableTabbablesInPopover();
      }
    }
  }

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    ownerDocument.addEventListener("keydown", handleKeyDown);
    return function () {
      ownerDocument.removeEventListener("keydown", handleKeyDown);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getElementAfterTrigger() {
    var elements = __WEBPACK_IMPORTED_MODULE_5_tabbable___default()(ownerDocument);
    var targetIndex = elements && triggerRef.current ? elements.indexOf(triggerRef.current) : -1;
    var elementAfterTrigger = elements && elements[targetIndex + 1];
    return popoverRef.current && popoverRef.current.contains(elementAfterTrigger || null) ? false : elementAfterTrigger;
  }

  function tabbedFromTriggerToPopover() {
    return triggerRef.current ? triggerRef.current === ownerDocument.activeElement : false;
  }

  function focusFirstPopoverTabbable(event) {
    var elements = popoverRef.current && __WEBPACK_IMPORTED_MODULE_5_tabbable___default()(popoverRef.current);

    if (elements && elements[0]) {
      event.preventDefault();
      elements[0].focus();
    }
  }

  function tabbedOutOfPopover() {
    var inPopover = popoverRef.current ? popoverRef.current.contains(ownerDocument.activeElement || null) : false;

    if (inPopover) {
      var elements = popoverRef.current && __WEBPACK_IMPORTED_MODULE_5_tabbable___default()(popoverRef.current);
      return Boolean(elements && elements[elements.length - 1] === ownerDocument.activeElement);
    }

    return false;
  }

  function focusTabbableAfterTrigger(event) {
    var elementAfterTrigger = getElementAfterTrigger();

    if (elementAfterTrigger) {
      event.preventDefault();
      elementAfterTrigger.focus();
    }
  }

  function shiftTabbedFromElementAfterTrigger(event) {
    if (!event.shiftKey) return;
    var elementAfterTrigger = getElementAfterTrigger();
    return event.target === elementAfterTrigger;
  }

  function focusLastTabbableInPopover(event) {
    var elements = popoverRef.current && __WEBPACK_IMPORTED_MODULE_5_tabbable___default()(popoverRef.current);
    var last = elements && elements[elements.length - 1];

    if (last) {
      event.preventDefault();
      last.focus();
    }
  }

  function shiftTabbedOutOfPopover(event) {
    var elements = popoverRef.current && __WEBPACK_IMPORTED_MODULE_5_tabbable___default()(popoverRef.current);

    if (elements) {
      return elements.length === 0 ? false : event.target === elements[0];
    }

    return false;
  }

  function focusTriggerRef(event) {
    var _triggerRef$current;

    event.preventDefault();
    (_triggerRef$current = triggerRef.current) == null ? void 0 : _triggerRef$current.focus();
  }

  function tabbedToBrowserChrome(event) {
    var elements = popoverRef.current ? __WEBPACK_IMPORTED_MODULE_5_tabbable___default()(ownerDocument).filter(function (element) {
      return !popoverRef.current.contains(element);
    }) : null;
    return elements ? event.target === elements[elements.length - 1] : false;
  }

  function shiftTabbedToBrowserChrome(event) {
    // we're assuming the popover will never contain the first tabbable
    // element, and it better not, because the trigger needs to be tabbable!
    return event.target === __WEBPACK_IMPORTED_MODULE_5_tabbable___default()(ownerDocument)[0];
  }

  var restoreTabIndexTuplés = [];

  function disableTabbablesInPopover() {
    var elements = popoverRef.current && __WEBPACK_IMPORTED_MODULE_5_tabbable___default()(popoverRef.current);

    if (elements) {
      elements.forEach(function (element) {
        restoreTabIndexTuplés.push([element, element.tabIndex]);
        element.tabIndex = -1;
      });
      ownerDocument.addEventListener("focusin", enableTabbablesInPopover);
    }
  }

  function enableTabbablesInPopover() {
    ownerDocument.removeEventListener("focusin", enableTabbablesInPopover);
    restoreTabIndexTuplés.forEach(function (_ref3) {
      var element = _ref3[0],
          tabIndex = _ref3[1];
      element.tabIndex = tabIndex;
    });
  }
} ////////////////////////////////////////////////////////////////////////////////

/* unused harmony default export */ var _unused_webpack_default_export = (Popover);



/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reach_utils_use_isomorphic_layout_effect__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reach_utils_use_force_update__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(210);






function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["unstable_skipInitialRender"];
/**
 * Portal
 *
 * @see Docs https://reach.tech/portal#portal
 */

var PortalImpl = function PortalImpl(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "reach-portal" : _ref$type,
      containerRef = _ref.containerRef;
  var mountNode = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var portalNode = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var forceUpdate = Object(__WEBPACK_IMPORTED_MODULE_2__reach_utils_use_force_update__["a" /* useForceUpdate */])();

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      if (containerRef != null) {
        process.env.NODE_ENV !== "production" ? warning(typeof containerRef === "object" && "current" in containerRef, "@reach/portal: Invalid value passed to the `containerRef` of a " + "`Portal`. The portal will be appended to the document body, but if " + "you want to attach it to another DOM node you must pass a valid " + "React ref object to `containerRef`.") : void 0;
        process.env.NODE_ENV !== "production" ? warning(containerRef ? containerRef.current != null : true, "@reach/portal: A ref was passed to the `containerRef` prop of a " + "`Portal`, but no DOM node was attached to it. Be sure to pass the " + "ref to a DOM component.\n\nIf you are forwarding the ref from " + "another component, be sure to use the React.forwardRef API. " + "See https://reactjs.org/docs/forwarding-refs.html.") : void 0;
      }
    }, [containerRef]);
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__reach_utils_use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    // This ref may be null when a hot-loader replaces components on the page
    if (!mountNode.current) return; // It's possible that the content of the portal has, itself, been portaled.
    // In that case, it's important to append to the correct document element.

    var ownerDocument = mountNode.current.ownerDocument;
    var body = (containerRef == null ? void 0 : containerRef.current) || ownerDocument.body;
    portalNode.current = ownerDocument == null ? void 0 : ownerDocument.createElement(type);
    body.appendChild(portalNode.current);
    forceUpdate();
    return function () {
      if (portalNode.current && body) {
        body.removeChild(portalNode.current);
      }
    };
  }, [type, forceUpdate, containerRef]);
  return portalNode.current ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(children, portalNode.current) : /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("span", {
    ref: mountNode
  });
};

var Portal = function Portal(_ref2) {
  var unstable_skipInitialRender = _ref2.unstable_skipInitialRender,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var _React$useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      hydrated = _React$useState[0],
      setHydrated = _React$useState[1];

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (unstable_skipInitialRender) {
      setHydrated(true);
    }
  }, [unstable_skipInitialRender]);

  if (unstable_skipInitialRender && !hydrated) {
    return null;
  }

  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(PortalImpl, props);
};
/**
 * @see Docs https://reach.tech/portal#portal-props
 */


if (false) {
  Portal.displayName = "Portal";
} ////////////////////////////////////////////////////////////////////////////////

/* unused harmony default export */ var _unused_webpack_default_export = (Portal);



/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Rect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useRect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reach_observe_rect__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reach_utils_use_isomorphic_layout_effect__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reach_utils_type_check__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(210);







/**
 * Welcome to @reach/rect!
 *
 * Measures DOM elements (aka. bounding client rect).
 *
 * @see getBoundingClientRect https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
 * @see Docs                  https://reach.tech/rect
 * @see Source                https://github.com/reach/reach-ui/tree/main/packages/rect
 */

/**
 * Rect
 *
 * @param props
 */

var Rect = function Rect(_ref) {
  var onChange = _ref.onChange,
      _ref$observe = _ref.observe,
      observe = _ref$observe === void 0 ? true : _ref$observe,
      children = _ref.children;
  var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var rect = useRect(ref, {
    observe: observe,
    onChange: onChange
  });
  return children({
    ref: ref,
    rect: rect
  });
};
/**
 * @see Docs https://reach.tech/rect#rect-props
 */


if (false) {
  Rect.displayName = "Rect";
  Rect.propTypes = {
    children: PropTypes.func.isRequired,
    observe: PropTypes.bool,
    onChange: PropTypes.func
  };
} ////////////////////////////////////////////////////////////////////////////////


/**
 * useRect
 *
 * @param nodeRef
 * @param observe
 * @param onChange
 */
function useRect(nodeRef, observeOrOptions, deprecated_onChange) {
  var observe;
  var onChange;

  if (Object(__WEBPACK_IMPORTED_MODULE_4__reach_utils_type_check__["a" /* isBoolean */])(observeOrOptions)) {
    observe = observeOrOptions;
  } else {
    var _observeOrOptions$obs;

    observe = (_observeOrOptions$obs = observeOrOptions == null ? void 0 : observeOrOptions.observe) != null ? _observeOrOptions$obs : true;
    onChange = observeOrOptions == null ? void 0 : observeOrOptions.onChange;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_4__reach_utils_type_check__["b" /* isFunction */])(deprecated_onChange)) {
    onChange = deprecated_onChange;
  }

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      process.env.NODE_ENV !== "production" ? warning(!isBoolean(observeOrOptions), "Passing `observe` as the second argument to `useRect` is deprecated and will be removed in a future version of Reach UI. Instead, you can pass an object of options with an `observe` property as the second argument (`useRect(ref, { observe })`).\n" + "See https://reach.tech/rect#userect-observe") : void 0;
    }, [observeOrOptions]); // eslint-disable-next-line react-hooks/rules-of-hooks

    useEffect(function () {
      process.env.NODE_ENV !== "production" ? warning(!isFunction(deprecated_onChange), "Passing `onChange` as the third argument to `useRect` is deprecated and will be removed in a future version of Reach UI. Instead, you can pass an object of options with an `onChange` property as the second argument (`useRect(ref, { onChange })`).\n" + "See https://reach.tech/rect#userect-onchange") : void 0;
    }, [deprecated_onChange]);
  }

  var _React$useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(nodeRef.current),
      element = _React$useState[0],
      setElement = _React$useState[1];

  var initialRectIsSet = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var initialRefIsSet = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);

  var _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
      rect = _React$useState2[0],
      setRect = _React$useState2[1];

  var onChangeRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(onChange); // eslint-disable-next-line react-hooks/exhaustive-deps

  Object(__WEBPACK_IMPORTED_MODULE_3__reach_utils_use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    onChangeRef.current = onChange;

    if (nodeRef.current !== element) {
      setElement(nodeRef.current);
    }
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__reach_utils_use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    if (element && !initialRectIsSet.current) {
      initialRectIsSet.current = true;
      setRect(element.getBoundingClientRect());
    }
  }, [element]);
  Object(__WEBPACK_IMPORTED_MODULE_3__reach_utils_use_isomorphic_layout_effect__["a" /* useIsomorphicLayoutEffect */])(function () {
    if (!observe) {
      return;
    }

    var elem = element; // State initializes before refs are placed, meaning the element state will
    // be undefined on the first render. We still want the rect on the first
    // render, so initially we'll use the nodeRef that was passed instead of
    // state for our measurements.

    if (!initialRefIsSet.current) {
      initialRefIsSet.current = true;
      elem = nodeRef.current;
    }

    if (!elem) {
      if (false) {
        console.warn("You need to place the ref");
      }

      return;
    }

    var observer = Object(__WEBPACK_IMPORTED_MODULE_2__reach_observe_rect__["a" /* default */])(elem, function (rect) {
      onChangeRef.current == null ? void 0 : onChangeRef.current(rect);
      setRect(rect);
    });
    observer.observe();
    return function () {
      observer.unobserve();
    };
  }, [observe, element, nodeRef]);
  return rect;
}

/* unused harmony default export */ var _unused_webpack_default_export = (Rect);



/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var props = ["bottom", "height", "left", "right", "top", "width"];

var rectChanged = function rectChanged(a, b) {
  if (a === void 0) {
    a = {};
  }

  if (b === void 0) {
    b = {};
  }

  return props.some(function (prop) {
    return a[prop] !== b[prop];
  });
};

var observedNodes = /*#__PURE__*/new Map();
var rafId;

var run = function run() {
  var changedStates = [];
  observedNodes.forEach(function (state, node) {
    var newRect = node.getBoundingClientRect();

    if (rectChanged(newRect, state.rect)) {
      state.rect = newRect;
      changedStates.push(state);
    }
  });
  changedStates.forEach(function (state) {
    state.callbacks.forEach(function (cb) {
      return cb(state.rect);
    });
  });
  rafId = window.requestAnimationFrame(run);
};

function observeRect(node, cb) {
  return {
    observe: function observe() {
      var wasEmpty = observedNodes.size === 0;

      if (observedNodes.has(node)) {
        observedNodes.get(node).callbacks.push(cb);
      } else {
        observedNodes.set(node, {
          rect: undefined,
          hasRectChanged: false,
          callbacks: [cb]
        });
      }

      if (wasEmpty) run();
    },
    unobserve: function unobserve() {
      var state = observedNodes.get(node);

      if (state) {
        // Remove the callback
        var index = state.callbacks.indexOf(cb);
        if (index >= 0) state.callbacks.splice(index, 1); // Remove the node reference

        if (!state.callbacks.length) observedNodes["delete"](node); // Stop the loop

        if (!observedNodes.size) cancelAnimationFrame(rafId);
      }
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (observeRect);
//# sourceMappingURL=observe-rect.esm.js.map


/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOwnerDocument; });
/* unused harmony export getOwnerWindow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__can_use_dom_dist_reach_utils_can_use_dom_esm_js__ = __webpack_require__(1016);


/**
 * Get an element's owner document. Useful when components are used in iframes
 * or other environments like dev tools.
 *
 * @param element
 */

function getOwnerDocument(element) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__can_use_dom_dist_reach_utils_can_use_dom_esm_js__["a" /* canUseDOM */])() ? element ? element.ownerDocument : document : null;
}
/**
 * TODO: Remove in 1.0
 */

function getOwnerWindow(element) {
  var ownerDocument = getOwnerDocument(element);
  return ownerDocument ? ownerDocument.defaultView || window : null;
}




/***/ }),
/* 2028 */
/***/ (function(module, exports) {

var candidateSelectors = [
  'input',
  'select',
  'textarea',
  'a[href]',
  'button',
  '[tabindex]',
  'audio[controls]',
  'video[controls]',
  '[contenteditable]:not([contenteditable="false"])',
];
var candidateSelector = candidateSelectors.join(',');

var matches = typeof Element === 'undefined'
  ? function () {}
  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;

function tabbable(el, options) {
  options = options || {};

  var regularTabbables = [];
  var orderedTabbables = [];

  var candidates = el.querySelectorAll(candidateSelector);

  if (options.includeContainer) {
    if (matches.call(el, candidateSelector)) {
      candidates = Array.prototype.slice.apply(candidates);
      candidates.unshift(el);
    }
  }

  var i, candidate, candidateTabindex;
  for (i = 0; i < candidates.length; i++) {
    candidate = candidates[i];

    if (!isNodeMatchingSelectorTabbable(candidate)) continue;

    candidateTabindex = getTabindex(candidate);
    if (candidateTabindex === 0) {
      regularTabbables.push(candidate);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        node: candidate,
      });
    }
  }

  var tabbableNodes = orderedTabbables
    .sort(sortOrderedTabbables)
    .map(function(a) { return a.node })
    .concat(regularTabbables);

  return tabbableNodes;
}

tabbable.isTabbable = isTabbable;
tabbable.isFocusable = isFocusable;

function isNodeMatchingSelectorTabbable(node) {
  if (
    !isNodeMatchingSelectorFocusable(node)
    || isNonTabbableRadio(node)
    || getTabindex(node) < 0
  ) {
    return false;
  }
  return true;
}

function isTabbable(node) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, candidateSelector) === false) return false;
  return isNodeMatchingSelectorTabbable(node);
}

function isNodeMatchingSelectorFocusable(node) {
  if (
    node.disabled
    || isHiddenInput(node)
    || isHidden(node)
  ) {
    return false;
  }
  return true;
}

var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
function isFocusable(node) {
  if (!node) throw new Error('No node provided');
  if (matches.call(node, focusableCandidateSelector) === false) return false;
  return isNodeMatchingSelectorFocusable(node);
}

function getTabindex(node) {
  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
  if (!isNaN(tabindexAttr)) return tabindexAttr;
  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  if (isContentEditable(node)) return 0;
  return node.tabIndex;
}

function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
}

function isContentEditable(node) {
  return node.contentEditable === 'true';
}

function isInput(node) {
  return node.tagName === 'INPUT';
}

function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
}

function isRadio(node) {
  return isInput(node) && node.type === 'radio';
}

function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
}

function getCheckedRadio(nodes) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked) {
      return nodes[i];
    }
  }
}

function isTabbableRadio(node) {
  if (!node.name) return true;
  // This won't account for the edge case where you have radio groups with the same
  // in separate forms on the same page.
  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
  var checked = getCheckedRadio(radioSet);
  return !checked || checked === node;
}

function isHidden(node) {
  // offsetParent being null will allow detecting cases where an element is invisible or inside an invisible element,
  // as long as the element does not use position: fixed. For them, their visibility has to be checked directly as well.
  return node.offsetParent === null || getComputedStyle(node).visibility === 'hidden';
}

module.exports = tabbable;


/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

var _interopRequireWildcard = __webpack_require__(162);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(163));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

exports.default = _default;

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core_Accordion__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_AccordionSummary__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_ArrowForwardIos__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_ArrowForwardIos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_ArrowForwardIos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Folder__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Folder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Folder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(108);






var useStyles = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["s" /* makeStyles */])(function () { return ({
    header: {
        fontSize: "1.2rem",
        fontWeight: 500,
        color: "#475569",
        fontFamily: "'Quicksand', sans-serif",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",
        lineHeight: 'normal',
    },
    accordion: {
        paddingLeft: "0.35vw",
        '&.MuiAccordion-root.Mui-expanded': {
            margin: 0,
        },
        '&.MuiPaper-elevation1': {
            boxShadow: "none",
        },
        '&:before': {
            content: "none",
        },
    },
    accordionSummary: {
        backgroundColor: "#FFFFFF",
        flexDirection: "row-reverse",
        paddingLeft: "0.8vw",
        minHeight: "3vh",
        '&.MuiAccordionSummary-root.Mui-expanded': {
            minHeight: "3vh",
        },
        '& .MuiIconButton-root': {
            padding: 0
        },
        "& .MuiButtonBase-root.Mui-expanded": {
            transform: "rotate(90deg)",
        },
        "& .MuiAccordionSummary-content": {
            margin: 0,
            alignItems: "center",
            marginLeft: '1.2vw',
        },
    },
    accordionDetails: {
        fontWeight: 500,
        color: "#475569",
        fontFamily: "'Quicksand', sans-serif",
        "&.MuiAccordionDetails-root": {
            padding: "0.5vh 0 0.5vh 1vw",
        },
    },
    menuItem: {
        "&.MuiMenuItem-root": {
            padding: "0 0 0 1.7vw",
        },
        "&:hover": {
            backgroundColor: "white",
        },
        fontSize: "0.9vw",
        marginBottom: "1.4vh",
    },
}); });
var FolderComp = function (props) {
    var folderList = props.folderList, parentFolderId = props.parentFolderId, handleOnFolderClick = props.handleOnFolderClick;
    var classes = useStyles();
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, folderList.map(function (data) { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core_Accordion__["a" /* default */], { key: data.folderId, TransitionProps: { unmountOnExit: true }, className: classes.accordion },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_AccordionSummary__["a" /* default */], { className: classes.accordionSummary, expandIcon: data.subfolders.length > 0 ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_ArrowForwardIos___default.a, { htmlColor: "#64748B", fontSize: 'small' })) : null },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { style: { display: 'flex', marginRight: '0.4vw' } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Folder___default.a, { htmlColor: "#64748B" })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onClick: function () {
                    return handleOnFolderClick(data);
                }, className: classes.header }, data.name)),
        data.subfolders.length > 0 ?
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FolderComp, { folderList: data.subfolders, parentFolderId: (parentFolderId ? parentFolderId : "") + "/" + data.folderId, handleOnFolderClick: handleOnFolderClick })
            : null)); })));
};
/* harmony default export */ __webpack_exports__["a"] = (FolderComp);


/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

var _interopRequireWildcard = __webpack_require__(162);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(163));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
}), 'ArrowForwardIos');

exports.default = _default;

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

var _interopRequireWildcard = __webpack_require__(162);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(163));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
}), 'Folder');

exports.default = _default;

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Waypoint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_consolidated_events__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);





function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }

  return undefined;
}

/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  }

  if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }

  return undefined;
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */

function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = parseOffsetAsPixels(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = parseOffsetAsPercentage(offset);

  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }

  return undefined;
}

var ABOVE = 'above';
var INSIDE = 'inside';
var BELOW = 'below';
var INVISIBLE = 'invisible';

function debugLog() {
  if (false) {
    var _console;

    (_console = console).log.apply(_console, arguments); // eslint-disable-line no-console

  }
}

/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component) {
  return typeof Component.type === 'string';
}

var errorMessage = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';
/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */

function ensureRefIsProvidedByChild(children, ref) {
  if (children && !isDOMElement(children) && !ref) {
    throw new Error(errorMessage);
  }
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of the constants `ABOVE`,
 *   `BELOW`, `INSIDE` or `INVISIBLE`.
 */

function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return INVISIBLE;
  } // top is within the viewport


  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return INSIDE;
  } // bottom is within the viewport


  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return INSIDE;
  } // top is above the viewport and bottom is below the viewport


  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return INSIDE;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return BELOW;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return ABOVE;
  }

  return INVISIBLE;
}

var timeout;
var timeoutQueue = [];
function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null; // Drain the timeoutQueue

      var item; // eslint-disable-next-line no-cond-assign

      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;
  return function unsubscribe() {
    if (!isSubscribed) {
      return;
    }

    isSubscribed = false;
    var index = timeoutQueue.indexOf(cb);

    if (index === -1) {
      return;
    }

    timeoutQueue.splice(index, 1);

    if (!timeoutQueue.length && timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
}

function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}

var defaultProps = {
  debug: false,
  scrollableAncestor: undefined,
  children: undefined,
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function onEnter() {},
  onLeave: function onLeave() {},
  onPositionChange: function onPositionChange() {},
  fireOnRapidScroll: true
}; // Calls a function when you scroll to the element.

var Waypoint =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Waypoint, _React$PureComponent);

  function Waypoint(props) {
    var _this;

    _classCallCheck(this, Waypoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Waypoint).call(this, props));

    _this.refElement = function (e) {
      _this._ref = e;
    };

    return _this;
  }

  _createClass(Waypoint, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (!Waypoint.getWindow()) {
        return;
      } // this._ref may occasionally not be set at this time. To help ensure that
      // this works smoothly and to avoid layout thrashing, we want to delay the
      // initial execution until the next tick.


      this.cancelOnNextTick = onNextTick(function () {
        _this2.cancelOnNextTick = null;
        var _this2$props = _this2.props,
            children = _this2$props.children,
            debug = _this2$props.debug; // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint

        ensureRefIsProvidedByChild(children, _this2._ref);
        _this2._handleScroll = _this2._handleScroll.bind(_this2);
        _this2.scrollableAncestor = _this2._findScrollableAncestor();

        if (false) {
          debugLog('scrollableAncestor', _this2.scrollableAncestor);
        }

        _this2.scrollEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_0_consolidated_events__["a" /* addEventListener */])(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, {
          passive: true
        });
        _this2.resizeEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_0_consolidated_events__["a" /* addEventListener */])(window, 'resize', _this2._handleScroll, {
          passive: true
        });

        _this2._handleScroll(null);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;

      if (!Waypoint.getWindow()) {
        return;
      }

      if (!this.scrollableAncestor) {
        // The Waypoint has not yet initialized.
        return;
      } // The element may have moved, so we need to recompute its position on the
      // page. This happens via handleScroll in a way that forces layout to be
      // computed.
      //
      // We want this to be deferred to avoid forcing layout during render, which
      // causes layout thrashing. And, if we already have this work enqueued, we
      // can just wait for that to happen instead of enqueueing again.


      if (this.cancelOnNextTick) {
        return;
      }

      this.cancelOnNextTick = onNextTick(function () {
        _this3.cancelOnNextTick = null;

        _this3._handleScroll(null);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!Waypoint.getWindow()) {
        return;
      }

      if (this.scrollEventListenerUnsubscribe) {
        this.scrollEventListenerUnsubscribe();
      }

      if (this.resizeEventListenerUnsubscribe) {
        this.resizeEventListenerUnsubscribe();
      }

      if (this.cancelOnNextTick) {
        this.cancelOnNextTick();
      }
    }
    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: "_findScrollableAncestor",
    value: function _findScrollableAncestor() {
      var _this$props = this.props,
          horizontal = _this$props.horizontal,
          scrollableAncestor = _this$props.scrollableAncestor;

      if (scrollableAncestor) {
        return resolveScrollableAncestorProp(scrollableAncestor);
      }

      var node = this._ref;

      while (node.parentNode) {
        node = node.parentNode;

        if (node === document.body) {
          // We've reached all the way to the root node.
          return window;
        }

        var style = window.getComputedStyle(node);
        var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
        var overflow = overflowDirec || style.getPropertyValue('overflow');

        if (overflow === 'auto' || overflow === 'scroll') {
          return node;
        }
      } // A scrollable ancestor element was not found, which means that we need to
      // do stuff on window.


      return window;
    }
    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: "_handleScroll",
    value: function _handleScroll(event) {
      if (!this._ref) {
        // There's a chance we end up here after the component has been unmounted.
        return;
      }

      var bounds = this._getBounds();

      var currentPosition = getCurrentPosition(bounds);
      var previousPosition = this._previousPosition;
      var _this$props2 = this.props,
          debug = _this$props2.debug,
          onPositionChange = _this$props2.onPositionChange,
          onEnter = _this$props2.onEnter,
          onLeave = _this$props2.onLeave,
          fireOnRapidScroll = _this$props2.fireOnRapidScroll;

      if (false) {
        debugLog('currentPosition', currentPosition);
        debugLog('previousPosition', previousPosition);
      } // Save previous position as early as possible to prevent cycles


      this._previousPosition = currentPosition;

      if (previousPosition === currentPosition) {
        // No change since last trigger
        return;
      }

      var callbackArg = {
        currentPosition: currentPosition,
        previousPosition: previousPosition,
        event: event,
        waypointTop: bounds.waypointTop,
        waypointBottom: bounds.waypointBottom,
        viewportTop: bounds.viewportTop,
        viewportBottom: bounds.viewportBottom
      };
      onPositionChange.call(this, callbackArg);

      if (currentPosition === INSIDE) {
        onEnter.call(this, callbackArg);
      } else if (previousPosition === INSIDE) {
        onLeave.call(this, callbackArg);
      }

      var isRapidScrollDown = previousPosition === BELOW && currentPosition === ABOVE;
      var isRapidScrollUp = previousPosition === ABOVE && currentPosition === BELOW;

      if (fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
        // If the scroll event isn't fired often enough to occur while the
        // waypoint was visible, we trigger both callbacks anyway.
        onEnter.call(this, {
          currentPosition: INSIDE,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        });
        onLeave.call(this, {
          currentPosition: currentPosition,
          previousPosition: INSIDE,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        });
      }
    }
  }, {
    key: "_getBounds",
    value: function _getBounds() {
      var _this$props3 = this.props,
          horizontal = _this$props3.horizontal,
          debug = _this$props3.debug;

      var _this$_ref$getBoundin = this._ref.getBoundingClientRect(),
          left = _this$_ref$getBoundin.left,
          top = _this$_ref$getBoundin.top,
          right = _this$_ref$getBoundin.right,
          bottom = _this$_ref$getBoundin.bottom;

      var waypointTop = horizontal ? left : top;
      var waypointBottom = horizontal ? right : bottom;
      var contextHeight;
      var contextScrollTop;

      if (this.scrollableAncestor === window) {
        contextHeight = horizontal ? window.innerWidth : window.innerHeight;
        contextScrollTop = 0;
      } else {
        contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
        contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
      }

      if (false) {
        debugLog('waypoint top', waypointTop);
        debugLog('waypoint bottom', waypointBottom);
        debugLog('scrollableAncestor height', contextHeight);
        debugLog('scrollableAncestor scrollTop', contextScrollTop);
      }

      var _this$props4 = this.props,
          bottomOffset = _this$props4.bottomOffset,
          topOffset = _this$props4.topOffset;
      var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
      var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
      var contextBottom = contextScrollTop + contextHeight;
      return {
        waypointTop: waypointTop,
        waypointBottom: waypointBottom,
        viewportTop: contextScrollTop + topOffsetPx,
        viewportBottom: contextBottom - bottomOffsetPx
      };
    }
    /**
     * @return {Object}
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var children = this.props.children;

      if (!children) {
        // We need an element that we can locate in the DOM to determine where it is
        // rendered relative to the top of its context.
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
          ref: this.refElement,
          style: {
            fontSize: 0
          }
        });
      }

      if (isDOMElement(children) || Object(__WEBPACK_IMPORTED_MODULE_3_react_is__["isForwardRef"])(children)) {
        var ref = function ref(node) {
          _this4.refElement(node);

          if (children.ref) {
            if (typeof children.ref === 'function') {
              children.ref(node);
            } else {
              children.ref.current = node;
            }
          }
        };

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, {
          ref: ref
        });
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, {
        innerRef: this.refElement
      });
    }
  }]);

  return Waypoint;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.PureComponent);

if (false) {
  Waypoint.propTypes = {
    children: PropTypes.element,
    debug: PropTypes.bool,
    onEnter: PropTypes.func,
    onLeave: PropTypes.func,
    onPositionChange: PropTypes.func,
    fireOnRapidScroll: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    scrollableAncestor: PropTypes.any,
    horizontal: PropTypes.bool,
    // `topOffset` can either be a number, in which case its a distance from the
    // top of the container in pixels, or a string value. Valid string values are
    // of the form "20px", which is parsed as pixels, or "20%", which is parsed
    // as a percentage of the height of the containing element.
    // For instance, if you pass "-20%", and the containing element is 100px tall,
    // then the waypoint will be triggered when it has been scrolled 20px beyond
    // the top of the containing element.
    topOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    // `bottomOffset` is like `topOffset`, but for the bottom of the container.
    bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  };
}

Waypoint.above = ABOVE;
Waypoint.below = BELOW;
Waypoint.inside = INSIDE;
Waypoint.invisible = INVISIBLE;

Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }

  return undefined;
};

Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(42)))

/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}




/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* unused harmony export uploadImages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dropzone__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WarningComponent__ = __webpack_require__(2046);
var _this = this;






var Configuration = __webpack_require__(27);
var Storage = __webpack_require__(34);
var useStyles = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["s" /* makeStyles */])(function () { return ({
    uploadBtn: {
        textTransform: 'none',
        color: '#475569',
        fontSize: '1.2rem',
        fontWeight: 500,
        backgroundColor: '#FFFFFF',
        padding: 0,
    }
}); });
var uploadImages = function (binaryData, imageName, folderPath) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
    var token, res, e_1;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
        switch (_a.label) {
            case 0:
                token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(Configuration.c3ApibaseUrl + "/v1/images?filename=" + imageName + "&folderPath=" + folderPath, {
                        body: binaryData,
                        headers: {
                            Authorization: "Bearer " + token,
                            "Content-Type": "application/octet-stream",
                        },
                        method: "POST",
                    })];
            case 2:
                res = _a.sent();
                if (res.status !== 200 && res.status !== 409)
                    return [2 /*return*/, false];
                return [4 /*yield*/, res.json()];
            case 3: return [2 /*return*/, _a.sent()];
            case 4:
                e_1 = _a.sent();
                return [2 /*return*/, false];
            case 5: return [2 /*return*/];
        }
    });
}); };
var renderLoader = function () { return (
/* @ts-ignore */
__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["c" /* Box */], { style: { display: "flex", justifyContent: "center", marginBottom: "2px", marginTop: "2px" } },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["e" /* CircularProgress */], { size: 15, color: "inherit" }))); };
var getFolderDetails = function (folderId) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
    var token, res, e_2;
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
        switch (_a.label) {
            case 0:
                token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
                _a.label = 1;
            case 1:
                _a.trys.push([1, 4, , 5]);
                return [4 /*yield*/, fetch(Configuration.c3ApibaseUrl + "/v1/imageFolders/" + folderId, {
                        headers: {
                            Authorization: "Bearer " + token,
                        },
                        method: "GET",
                    })];
            case 2:
                res = _a.sent();
                console.log(res, 'Response');
                if (res.status !== 200)
                    return [2 /*return*/, false];
                return [4 /*yield*/, res.json()];
            case 3: return [2 /*return*/, _a.sent()];
            case 4:
                e_2 = _a.sent();
                console.error(e_2);
                return [2 /*return*/, false];
            case 5: return [2 /*return*/];
        }
    });
}); };
var isValidImageOrFolderName = function (name) {
    var format = /[#%&{}/|:?<>*"@'!$+`=]+/;
    // OR condition has a special case for backslash which is an escape sequence
    if (format.test(name) || name.includes("\\") || name.trim().length === 0) {
        return false;
    }
    else {
        return true;
    }
};
var UploadImageButton = function (props) {
    var setImageList = props.setImageList, folderPath = props.folderPath;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({
        show: false,
        heading: 'Warning',
        subHeading: 'Duplicate Images',
        primaryButtonClick: function () { setWarningData(function (prev) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, prev, { show: false })); }); },
    }), warningData = _a[0], setWarningData = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), loader = _b[0], setLoader = _b[1];
    var classes = useStyles();
    var getFolderName = function (folderPath) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
        var folderName, folderIdArr, res;
        var _this = this;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    folderName = ["Images"];
                    if (folderPath === "/")
                        return [2 /*return*/, folderName];
                    folderIdArr = folderPath.split("/").filter(function (el) { return el !== ""; });
                    return [4 /*yield*/, Promise.all(folderIdArr.map(function (el) { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, getFolderDetails(el)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); }))];
                case 1:
                    res = _a.sent();
                    folderName.push.apply(folderName, res.map(function (el) { return el.folderDetails.name; }));
                    return [2 /*return*/, folderName];
            }
        });
    }); };
    var onDrop = function (files) {
        files.forEach(function (file) {
            var reader = new FileReader();
            reader.readAsArrayBuffer(file);
            console.log(file, 'FIle');
            reader.onload = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
                var binaryData, res, folderName_1;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // Check name for invalid characters
                            if (!isValidImageOrFolderName(file.name)) {
                                setWarningData(function (prev) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, prev, { show: true, subHeading: "Unable to upload " +
                                        file.name +
                                        ". The file name contains a character (#%&{}/|&#92;:?<>*\"@'!$+`= or cannot be blank) which are not supported." })); });
                                return [2 /*return*/];
                            }
                            binaryData = Buffer.from(reader.result, "binary");
                            setLoader(true);
                            return [4 /*yield*/, uploadImages(binaryData, file.name, folderPath)];
                        case 1:
                            res = _a.sent();
                            if (!res.imageDetails) return [3 /*break*/, 2];
                            // on successful upload
                            setImageList(function (prev) { return [res.imageDetails].concat(prev); });
                            return [3 /*break*/, 4];
                        case 2:
                            if (!res.imageId) return [3 /*break*/, 4];
                            return [4 /*yield*/, getFolderName(res.folderPath)];
                        case 3:
                            folderName_1 = _a.sent();
                            setWarningData(function (prev) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, prev, { show: true, subHeading: "The file already exists in " + folderName_1.join("/") })); });
                            _a.label = 4;
                        case 4:
                            setLoader(false);
                            return [2 /*return*/];
                    }
                });
            }); };
        });
    };
    var _c = Object(__WEBPACK_IMPORTED_MODULE_3_react_dropzone__["a" /* useDropzone */])({
        onDrop: onDrop,
        // Our API supports all image formats, Legacy Editor only supports jpg, jpeg, png, gif
        // accept: ["image/jpeg", "image/png", "image/gif"],
        minSize: 0,
        maxSize: 5242880,
        onDropRejected: function (err) {
            var errorCode = err[0].errors[0].code;
            if (errorCode === "file-too-large") {
                setWarningData(function (prev) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, prev, { show: true, subHeading: "This file exceeds the maximum size limit of 5 MB." })); });
            }
        },
    }), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps;
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__WarningComponent__["a" /* default */], { data: warningData }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, getRootProps()),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("input", __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, getInputProps())),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["d" /* Button */], { className: classes.uploadBtn, variant: "outlined" }, loader ? renderLoader() : "Upload"))));
};
/* harmony default export */ __webpack_exports__["a"] = (UploadImageButton);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2036).Buffer))

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(2037)
var ieee754 = __webpack_require__(2038)
var isArray = __webpack_require__(2039)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 2038 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 2039 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useDropzone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_selector__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_index__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1020);
/* unused harmony reexport ErrorCode */
var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint prefer-template: 0 */




/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: __WEBPACK_IMPORTED_MODULE_2_file_selector__["a" /* fromEvent */],
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
/* unused harmony default export */ var _unused_webpack_default_export = (Dropzone);
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["b" /* acceptPropAsAcceptAttr */])(accept);
  }, [accept]);
  var pickerTypes = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["n" /* pickerOptionsFromAccept */])(accept);
  }, [accept]);
  var onFileDialogOpenCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var inputRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);

  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["d" /* canUseFileSystemAccessAPI */])()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", __WEBPACK_IMPORTED_MODULE_3__utils_index__["m" /* onDocumentDragOver */], false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", __WEBPACK_IMPORTED_MODULE_3__utils_index__["m" /* onDocumentDragOver */]);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* isEvtWithFiles */])(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["k" /* isPropagationStopped */])(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["c" /* allFilesAccepted */])({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* isEvtWithFiles */])(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* isEvtWithFiles */])(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["f" /* fileAccepted */])(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["g" /* fileMatchSize */])(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [__WEBPACK_IMPORTED_MODULE_3__utils_index__["a" /* TOO_MANY_FILES_REJECTION */]]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["i" /* isEvtWithFiles */])(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["k" /* isPropagationStopped */])(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["h" /* isAbort */])(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["l" /* isSecurityError */])(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["j" /* isIeOrEdge */])()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onBlur, onBlurCb)),
        onClick: composeHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onClick, onClickCb)),
        onDragEnter: composeDragHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onChange, onDropCb)),
        onClick: composeHandler(Object(__WEBPACK_IMPORTED_MODULE_3__utils_index__["e" /* composeEventHandlers */])(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}



/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_selector__ = __webpack_require__(2042);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__file_selector__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__file__ = __webpack_require__(2044);


var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        var files;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        var items, files;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArray */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __read */])(acc), false), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __read */])((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(_this, void 0, void 0, function () {
                var files, err_1, items;
                return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */])(this, void 0, void 0, function () {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __generator */])(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = Object(__WEBPACK_IMPORTED_MODULE_1__file__["a" /* toFileWithPath */])(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}
//# sourceMappingURL=file-selector.js.map

/***/ }),
/* 2043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["a"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["b"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* harmony export (immutable) */ __webpack_exports__["c"] = __read;
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* harmony export (immutable) */ __webpack_exports__["d"] = __spreadArray;
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/* unused harmony export __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export COMMON_MIME_TYPES */
/* harmony export (immutable) */ __webpack_exports__["a"] = toFileWithPath;
var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
//# sourceMappingURL=file.js.map

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Warning__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Warning__);



var useStyles = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["s" /* makeStyles */])(function () { return ({
    container: {
        paddingBottom: "16px",
        paddingRight: "16px",
        width: "30vw",
    },
    title: {
        "& .MuiTypography-h6": {
            display: "flex",
            alignItems: "center",
            fontSize: "2rem",
        },
    },
    errorMsg: {
        fontSize: "2rem",
        fontWeight: "bold",
    },
    subHeading: {
        fontWeight: 500,
        fontSize: "2rem",
    },
    caption: {
        fontSize: "1.4rem",
        fontWeight: 400,
    },
    marginTop12: {
        marginTop: "12px",
    },
    primaryBtn: {
        background: "#FFAB00",
        color: "#172B4D",
        fontSize: "1.4rem",
    },
}); });
var Warning = function (_a) {
    var data = _a.data;
    var show = data.show, heading = data.heading, subHeading = data.subHeading, primaryButtonLabel = data.primaryButtonLabel, primaryButtonClick = data.primaryButtonClick, handleClickOnSubheading = data.handleClickOnSubheading;
    var classes = useStyles();
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["f" /* Dialog */], { open: show, classes: { paper: classes.container }, maxWidth: "sm" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["i" /* DialogTitle */], { className: classes.title },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Warning___default.a, { style: { marginRight: "12px" }, htmlColor: "#FFAB00", fontSize: "medium" }),
            heading),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["h" /* DialogContent */], null, subHeading && (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["r" /* Typography */], { variant: "h6", className: classes.subHeading, component: "span", onClick: function (e) {
                if (typeof handleClickOnSubheading === "function") {
                    e.stopPropagation();
                    handleClickOnSubheading(e.target.id);
                }
            } }, subHeading))),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["g" /* DialogActions */], null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0__material_ui_core__["d" /* Button */], { variant: "contained", className: classes.primaryBtn, onClick: function () {
                    if (typeof primaryButtonClick === "function") {
                        primaryButtonClick();
                    }
                } }, primaryButtonLabel || "OK"))));
};
/* harmony default export */ __webpack_exports__["a"] = (Warning);


/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

var _interopRequireWildcard = __webpack_require__(162);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(163));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');

exports.default = _default;

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var AnimationPropertiesView = __webpack_require__(125);
    var ColorPicker = __webpack_require__(208);
    var SizeAndPositionPropertiesView = __webpack_require__(70);
    var template = __webpack_require__(2049);
    var AbstractWidgetPropertiesView = __webpack_require__(63);

    var EXPAND_PROPERTY = "lineExpanded";

    /**
     * The properties view for a line widget.
     *
     * @class LineWidgetPropertiesView
     * @constructor
     *
     * @cfg {LineWidgetModel} model The model for the line widget being edited.
     */
    return AbstractWidgetPropertiesView.extend({
        expandProperty: EXPAND_PROPERTY,

        template: template,

        _backgroundColorPicker: null,

        ui: {
            legend: "[data-target=\".line-properties-container\"]",
            lineProperties: ".line-properties-container",
            lineBackgroundColorInput: ".line-background-color-input",
            lineBackgroundColorBox: ".line-background-color-box",
            lineWeightInput: ".line-weight",
            lineWeightOptions: ".line-weight-options"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            animationProperties: ".animation-properties"
        },

        events: {
            "click .line-weight-options a": "_clickedLineWeightOptions",
            "change .line-background-color-input": "_lineBackgroundColorInput"
        },

        _clickedLineWeightOptions: function _clickedLineWeightOptions(event) {
            event.preventDefault();
            this.ui.lineWeightInput.val(event.target.getAttribute("data-weight")).trigger("change");
            this.ui.lineWeightOptions.find("a").removeClass("selected");
            $(event.target).addClass("selected");
            this.model.set("lineHeight", event.target.getAttribute("data-weight"));
        },
        _lineBackgroundColorInput: function _lineBackgroundColorInput(event) {
            this.model.set("lineColor", event.currentTarget.value);
        },
        _setStrokeWeightSelection: function _setStrokeWeightSelection(weight) {
            this.ui.lineWeightOptions.find("[data-weight=\"" + weight + "\"]").addClass("selected");
        },
        onRender: function onRender() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model, hideSizeControls: true, showLineControls: true, widgetView: this.options.widgetView
            }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this._backgroundColorPicker = new ColorPicker({
                color: this.model.get("lineColor"),
                input: this.ui.lineBackgroundColorInput,
                colorBox: this.ui.lineBackgroundColorBox
            });

            this.ui.lineBackgroundColorInput.val(this.model.get("lineColor"));
            this._setStrokeWeightSelection(this.model.get("lineHeight"));
        },
        onClose: function onClose() {
            this._backgroundColorPicker.dispose();
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2049 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset class="line-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".line-properties-container">Line</legend>\n    <div class="line-properties-container collapse collapse-target">\n        <div class="zmags-input-control">\n            <label class="line-weight-container">\n                <div class="line-weight-options">\n                    <input type="hidden" class="line-weight">\n                    <a href="#" data-weight="1">1 px</a>\n                    <a href="#" data-weight="2">2 px</a>\n                    <a href="#" data-weight="3">3 px</a>\n                    <a href="#" data-weight="5">5 px</a>\n                    <a href="#" data-weight="10">10 px</a>\n                </div>\n            </label>\n            <label class="color-library-custom">\n                Color:\n                <div class="line-background-color-box color-box pull-right"></div>\n                <input type="text" class="line-background-color-input color-input pull-right">\n            </label>\n        </div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="animation-properties"></div>\n    <div class="style-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ActionPropertiesView = __webpack_require__(205),
        ImprovedView = __webpack_require__(6),
        SizeAndPositionPropertiesView = __webpack_require__(70),
        template = __webpack_require__(2051);

    var EXPAND_PROPERTY = "actionExpanded";

    /**
     * The properties view for a link widget.
     *
     * @class LinkWidgetPropertiesView
     * @constructor
     *
     * @cfg {LinkWidgetModel} model The model for the link widget being edited.
     */
    return ImprovedView.extend("LinkWidgetPropertiesView", {
        expandProperty: EXPAND_PROPERTY,

        template: template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            actionProperties: ".action-properties",
            analyticsProperties: ".analytics-properties"
        },

        onRender: function onRender() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                widgetView: this.options.widgetView
            }));
            this.actionProperties.show(new ActionPropertiesView({ model: this.model, showEffects: false }));
            this.analyticsProperties.show(this._setAnalyticsLabel({ model: this.model }));
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2051 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="action-properties"></div>\n<div class="analytics-properties"></div>\n<div class="size-and-position-properties"></div>';

}
return __p
}

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ActionPropertiesView = __webpack_require__(205),
        SizeAndPositionPropertiesView = __webpack_require__(70),
        template = __webpack_require__(2053),
        AbstractWidgetPropertiesView = __webpack_require__(63);

    var EXPAND_PROPERTY = "productActionExpanded";

    /**
     * The collapsible panels for a product widget, i.e. Product Actions and Position.
     *
     * @class ProductWidgetPropertiesView
     * @constructor
     *
     * @cfg {ProductWidgetModel} model The model for the link widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("ProductWidgetPropertiesView", {
        expandProperty: EXPAND_PROPERTY,

        template: template,

        regions: {
            actionProperties: ".action-properties",
            sizeAndPositionProperties: ".size-and-position-properties"
        },

        onRender: function onRender() {
            this.__super();
            this.actionProperties.show(new ActionPropertiesView({
                model: this.model,
                showEffects: false,
                onlyShowProductActions: true
            }));

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                widgetView: this.options.widgetView
            }));
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="action-properties"></div>\n<div class="size-and-position-properties"></div>\n';

}
return __p
}

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        isEmpty = _require.isEmpty,
        debounce = _require.debounce,
        Preconditions = __webpack_require__(14),
        Promise = __webpack_require__(21),
        SizeAndPositionPropertiesView = __webpack_require__(70),
        _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank,
        SalesforceCommerce = __webpack_require__(206),
        SalesforceCommerceOCAPIServiceFactory = __webpack_require__(1021),
        SalesforceCommerceProductCollectionView = __webpack_require__(2060),
        template = __webpack_require__(2062),
        AbstractWidgetPropertiesView = __webpack_require__(63);

    var EXPAND_PROPERTY = "demandwareExpanded";

    /**
     * The properties view for an SalesforceCommerce widget.
     *
     * @class SalesforceCommerceWidgetPropertiesView
     * @cfg {SalesforceCommerceWidgetModel} model The model for the SalesforceCommerce widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("DemandwareWidgetPropertiesView", {

        expandProperty: EXPAND_PROPERTY,

        template: template,

        /**
         * A flag indicating if the user has interacted with the <tt>search params</tt>.
         */
        _userHasInteracted: false,

        templateHelpers: function templateHelpers() {
            var siteCollection = SalesforceCommerce.getSettings().get("sites");

            return {
                sites: siteCollection.models
            };
        },

        ui: {
            connect: ".connect",
            salesforceCommercePropertiesAccordion: ".salesforce-commerce-properties-accordion",
            salesforceCommerceItem: ".salesforce-commerce-item",
            legend: "legend",
            sites: ".sites",
            search: ".search-products",
            searchInput: ".search",
            connectionError: ".connection-error"
        },

        regions: {
            accountViewRegion: ".account-view-region",
            salesforceCommerceResults: ".salesforce-commerce-results",
            sizeAndPositionProperties: ".size-and-position-properties",
            salesforceCommerceSettingsProperties: ".salesforce-commerce-settings-properties"
        },

        events: {
            "keyup @ui.search": "_searchParamChangeHandler",
            "change @ui.sites": "_siteChangeHandler",
            "select @ui.salesforceCommerceItem": "_itemSelectedHandler"
        },

        /*
         * When an item is selected, we set that item to the widget and highlight that item view
         */
        _itemSelectedHandler: function _itemSelectedHandler(event, model) {
            this._updateModel(model.get("productID"), this.ui.sites.val());
            this.salesforceCommerceProductCollectionView.highlightSelectedProduct(this.model.get("productID"));
        },

        initialize: function initialize() {
            this.__super();
            this.salesforceCommerceSetting = SalesforceCommerce.getSettings();
        },

        _siteChangeHandler: function _siteChangeHandler() {
            this._verifyConnection();
            this._searchParamChangeHandler();

            // Always make sure that the site Id is set on the model when the site Id changes
            this._updateModel(null, this.ui.sites.val());
        },

        /**
         * @private
         * Updates the model with the product ID and site ID if they are set.
         * The model won't be updated if the passed values are undefined.
         *
         * @param productID the ID of the product.
         * @param siteID the ID of the site
         */
        _updateModel: function _updateModel(productID, siteID) {
            var values = {};

            if (productID) {
                values.productID = productID;
            }

            if (siteID) {
                values.siteId = siteID;
            }

            if (!isEmpty(values)) {
                this.model.set(values);
            }
        },

        _verifyConnection: function _verifyConnection() {
            var self = this,
                site = null,
                siteId = this.ui.sites.val(),

            // SalesforceCommerce settings
            settings = this.salesforceCommerceSetting;

            if (siteId) {
                site = settings.get("sites").get(siteId).get("siteId");
            }

            self.ui.connectionError.html("");
            // Test the connection to see if we can query product from the selected site, shows the error if it fails
            SalesforceCommerce.inferAddress(settings.get("userUrl"), settings.get("clientId"), site).fail(function () {
                self.salesforceCommerceResults.reset();
                self.ui.connectionError.html("We cannot connect to the site <b>" + site + "</b>. No search results will be shown.");
            });
        },

        /**
         * Handler the user inputs and change of site selection. We save the last query for usability.
         * This function is debounced to avoid too many calls
         */
        _searchParamChangeHandler: debounce(function () {
            var query = this.ui.searchInput.val(),
                siteId = this.ui.sites.val(),
                propertyState = this.viewScope.viewModel.get("widgetPropertyViewsState");

            if (query !== propertyState.lastQuery || siteId !== propertyState.lastSiteId) {
                // In fact, the user has interacted with some different input
                this._userHasInteracted = true;
            }

            if (isBlank(query)) {
                this.salesforceCommerceResults.close();
            } else {
                this._getProducts();
            }

            propertyState.lastQuery = query;
            propertyState.lastSiteId = siteId;
        }, 400),

        /**
         * If the user has changed something, then try to get products, either query from server or use the cache.
         *
         * @private
         */
        _getProducts: function _getProducts() {
            var siteCollection = this.salesforceCommerceSetting.get("sites"),
                query = this.ui.searchInput.val(),
                siteId = this.ui.sites.val(),
                site = null;

            if (siteId) {
                site = siteCollection.get(siteId).get("siteId");
            }

            this._search(query, site).done(this._showProductCollection.bind(this));
        },

        /**
         * Search products using user selected query and sites from the <i>SalesforceCommerce Open Commerce Api</i>.
         *
         * @param {String} query    The search query.
         * @param {String} site     The site name to be searched from
         * @private
         */
        _search: function _search(query, site) {
            var self = this,
                searchPromise = SalesforceCommerceOCAPIServiceFactory.getService().search(query, site);

            return Promise.predicate(searchPromise, this._viewActive).done(function (productCollection) {
                // If the user hasn't interacted and the productCollection has no results, It means that
                // the OCAPI server wasn't able to find the productId. In this case, we will log an exception
                // to check how often it happens.
                Preconditions.checkState(self._userHasInteracted || !!productCollection, "The user has selected a Product ('" + query + "'), but the OCAPI didn't bring any results.");
            });
        },

        /**
         * Shows the <tt>SalesforceCommerceProductCollection</tt> to the view.
         *
         * @param {SalesforceCommerceProductCollection} productCollection   The collection to be shown
         */
        _showProductCollection: function _showProductCollection(productCollection) {
            if (this.isClosed) {
                return;
            }

            this.salesforceCommerceProductCollectionView = new SalesforceCommerceProductCollectionView({
                collection: productCollection,
                itemViewOptions: {
                    showTooltips: true,
                    showImageInfo: true,
                    dropTargetSize: "large",
                    draggable: true
                }
            });

            this.salesforceCommerceResults.show(this.salesforceCommerceProductCollectionView);
            this.salesforceCommerceProductCollectionView.highlightSelectedProduct(this.model.get("productID"));
        },

        /**
         * Validate if the user has already entered some settings. This method doesn't
         * performs a server side validations, however, check if the clientId and the userUrl are valid.
         *
         * @private
         */
        _validateServerSettings: function _validateServerSettings() {
            var self = this,
                isSettingsOk = SalesforceCommerce.validateServerSettings(this.salesforceCommerceSetting);

            self.ui.connect.toggle(!isSettingsOk);
            self.ui.search.toggle(isSettingsOk);
        },

        onRender: function onRender() {
            this.__super();
            // Let's check if the user, at least, has some valid settings in the client side.
            this._validateServerSettings();

            var propertyState = this.viewScope.viewModel.get("widgetPropertyViewsState"),
                searchValue = this.model.get("productID") || propertyState.lastQuery,
                searchSite = this.model.get("siteId") || propertyState.lastSiteId;

            if (searchSite) {
                this.ui.sites.val(searchSite);
            }

            if (searchValue) {
                this.ui.searchInput.val(searchValue);
                this._getProducts();
            }

            if (!this.salesforceCommerceSetting.get("userUrl") || !this.salesforceCommerceSetting.get("clientId")) {
                this.ui.connect.toggle(true);
                this.ui.search.toggle(false);
            }

            this._verifyConnection();
        },

        onShow: function onShow() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
        },

        _shouldExpandOnRender: function _shouldExpandOnRender() {
            return this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] || this.model.has("productID");
        },


        _viewActive: function _viewActive() {
            return !this.isClosed;
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        isUndefined = _require.isUndefined,
        isArray = _require.isArray,
        isEmpty = _require.isEmpty;

    var Class = __webpack_require__(26);
    var SalesforceCommerce = __webpack_require__(206);
    var SalesforceCommerceDataAdapter = __webpack_require__(2056);

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var Preconditions = __webpack_require__(14);
    var Promise = __webpack_require__(21);

    var _require3 = __webpack_require__(30),
        trim = _require3.trim;

    var UrlUtil = __webpack_require__(46);

    /**
     * The full documentation of all endpoints can be find in https://info.salesforcecommerce.com/DOC1/index.jsp. <p>
     * Terms used:<p>
     * <ul>
     *  <li>OCAPI - SalesforceCommerce Open Commerce Api.
     * </ul>
     */

    var /**
         * Endpoint responsible to allow the user to search product in OCAPI, but only partial information.
         * @type {String}
         */
    PRODUCTS_SEARCH = "product_search",
        log = new Logger("SalesforceCommerceService"),


    /**
     * Endpoint responsible to allow the user to retrieve the full information of the Product in the OCAPI.
     * @type {String}
     */
    PRODUCT_SEARCH_BY_ID = "products";

    /**
     *  @class {SalesforceCommerceOCAPIService}
     *  A <i>SalesforceCommerce service</i> will be responsible to communicate with the OCAPI.
     *
     *  @author Pedro Augusto / <a href="http://www.zmags.com">Zmags</a>
     */
    var SalesforceCommerceOCAPIService = Class.extend("SalesforceCommerceOCAPIService", {

        /**
         * Search SalesforceCommerce products using the SalesforceCommerce web service.
         * <ol>
         *  <li> Call the product_search endpoint to look for products matching the <tt>query</tt> criteria.
         *  <li> Once this function has the productIDs matching the <tt>query</tt>, It must to retrieve the product
         *   information like image, description, price and brand. For do it, we call the endpoint products.
         * </ol>
         *
         * @param  {String} query word that will be searched in the SalesforceCommerce service.
         * @param  {String} siteId the Id of the SalesforceCommerce site in which the products are searched.
         *
         * @return {Object} The search results.
         */
        search: function search(query, siteId) {
            Preconditions.checkArgument(query);

            // We only left and right trim the query.
            query = trim(query);

            var self = this,
                deferred = Promise.deferred(),
                standardQuery = query,
                wildcardQuery = "*" + query + "*";

            /**
             * Returns promise with products full descriptions.
             * @param {Object} data Products found by the getProductsHits function.
             * @param {String} siteId The SalesforceCommerce Site ID.
             * @returns {Promise} A promise with the product information results.
             * @private
             */
            function _getProductInfoPromise(data, siteId) {
                var ids = SalesforceCommerceDataAdapter.searchHits(data);

                log.info("Products found: " + ids.length);

                // Time to retrieve the product full information, taking the siteId into account.
                return self.getProductByIds(ids, siteId).done(function (data) {
                    // finally, we have a result.
                    // Let's return it using the resolve from the begin.
                    return deferred.resolve(data);
                }).fail(deferred.reject);
            }

            /*
               The following strategy is a bit greedy but solves a search edge case (MOS-2415).
               If wildcard query approach does not find any hit, we will try with the standard query approach.
               The reason is because product search can be configured on SalesforceCommerce backend, and product search
               on our sandbox on specific products(e.g: canon-powershot-sd990-is) did not return any result
               with the wildcard approach.
            */
            log.info("Searching the word", wildcardQuery);
            return this._getProductsHits(wildcardQuery, siteId).then(function (data) {
                return _getProductInfoPromise(data, siteId);
            }).then(function (data) {
                // we found a result, so we stop the chain and return the result set.
                if (data && data.length) {
                    return deferred.resolve(data);
                }

                log.info("No results found, instead searching the word", standardQuery);
                return self._getProductsHits(standardQuery, siteId).then(function (data) {
                    return _getProductInfoPromise(data, siteId);
                }).fail(deferred.reject);
            }).fail(deferred.reject);
        },

        /**
         * Get products full descriptions according with them ids. If the
         * user pass one string with an id it will return a SalesforceCommerceProductView else
         * it will return an SalesforceCommerceProductCollectionView.
         *
         * @param {String[]} ids
         * @param {String} siteId the Id of the SalesforceCommerce site in which the products are searched.
         * @return {Promise} A promise that will resolve with the product ids.
         */
        getProductByIds: function getProductByIds(ids, siteId) {
            var isCollection = isArray(ids);

            if (isUndefined(ids) || isCollection && isEmpty(ids)) {
                return Promise.deferred().resolve();
            }

            var idsCriteria = isCollection ? "(" + ids.join(",") + ")" : ids;

            return SalesforceCommerce.callRestApi({
                method: "product-by-id",
                args: ids,
                siteId: siteId,
                // Safely concat the ids with the search criteria.
                url: UrlUtil.concat(PRODUCT_SEARCH_BY_ID, idsCriteria),
                resultHandler: function resultHandler(data) {
                    if (isCollection) {
                        return SalesforceCommerceDataAdapter.productsToCollection(data, SalesforceCommerce.getSettings());
                    }

                    return SalesforceCommerceDataAdapter.productToModel(data, SalesforceCommerce.getSettings());
                }
            });
        },

        /**
         * @private
         *
         * Search for a word in the SalesforceCommerce OCAPI.
         *
         * @param {String} query Parameter with the word criteria.
         * @param {String} siteId the Id of the SalesforceCommerce site in which the products are searched.
         * @return {Promise} A promise that will resolve with the product hits.
         */
        _getProductsHits: function _getProductsHits(query, siteId) {
            return SalesforceCommerce.callRestApi({
                method: "search",
                args: query,
                url: PRODUCTS_SEARCH,
                siteId: siteId,
                data: { q: query },
                resultHandler: function resultHandler(data) {
                    return data;
                }
            });
        }

    });

    return new SalesforceCommerceOCAPIService();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var SalesforceCommerceAbstractDataAdapter = __webpack_require__(2057),
        _require = __webpack_require__(30),
        trim = _require.trim;

    /**
     * @class {SalesforceCommerceDataAdapter}
     *
     * A <i>SalesforceCommerceDataAdapter</i> proves the mapping between the external and internal formats.
     *
     * @author Pedro Augusto / <a href="http://www.zmags.com">Zmags</a>
     *
     */
    var SalesforceCommerceDataAdapter = SalesforceCommerceAbstractDataAdapter.extend({

        /**
         *  Maps a product from OCAPI into a <tt>SalesforceCommerceProductModel</tt>.
         *  @override
         *  @example
         *  <pre>{
         *       "brand" : "Creative",
         *       "id" : "creative-zen-v",
         *       "image_groups" : [
         *         {
         *           "images" : [ {
         *             "alt" : "Creative ZEN V Digital Media Player, , small",
         *             "link" : "http://localhost/on/salesforcecommerce.static/Sites-SiteGe..",
         *             "title" : "Creative ZEN V Digital Media Player, "
         *           } ],
         *           "view_type" : "small"
         *         } ],
         *       "name" : "Creative ZEN V Digital Media Player",
         *       "page_description" : "The ZEN V player was designed for people ...",
         *       "page_keywords" : "Creative",
         *       "page_title" : "Creative ZEN V Digital Media Player",
         *       "primary_category_id" : "electronics-digital-media-players",
         *       "short_description" : "The ZEN V player was designed for people...",
         *       "type" : {
         *         "item" : true
         *       },
         *       ...
         *       "c_mediaFormat" : [ "0010", "0020", "0030", "0040" ],
         *       "c_memorySize" : "1GB",
         *       "c_tabDescription" : "The ZEN V player was designed for people ..."
         *   }
         *   </pre>
         *   @return {Object} return the Map for the OCAPI.
         */
        getMaps: function getMaps() {
            return {
                name: { value: "name" },

                productID: { value: "id" },

                brand: { defaultValue: "(none)", value: "brand" },

                availability: { defaultValue: "(none)", value: "orderable" },

                price: {
                    value: function value() {
                        return this.currency + " " + this.price;
                    }
                },

                image: {
                    value: this._getProductImage
                },

                description: {
                    defaultValue: "No description",
                    value: "short_description"
                }
            };
        },

        /**
         * Filter the target object according with the settings values. If the corresponding parameter is setted to
         * false the property value will setted to null.
         *
         * @override
         * @param {Object} target already tranformed.
         * @param {Object} settings informed by the user.
         */
        filter: function filter(target, settings) {
            var filters = settings.get("filters"),
                key;

            for (key in target) {
                if (filters.get(key) === false) {
                    target[key] = null;
                }
            }
        },

        /**
         * Try to find a image inside of the OCAPI Product object.
         *
         * @example
         * <pre>
         * {...
         *
         * "image_groups" : [
         *    {
         *        {
         *         "images" : [ {
         *            "alt" : "Creative ZEN V Digital Media Player, , small",
         *            "link" : "http://localhost/on/salesforcecommerce.static/Sites-SiteG....jpg",
         *            "title" : "Creative ZEN V Digital Media Player, "
         *          } ],
         *          "view_type" : "small"
         *        } ]
         *     }
         *     ...
         *
         * }
         * </pre>
         * @param {Object} product object
         * @return {String} The image address; never null/undefined, but will be empty if no image.
         * @private
         */
        _getProductImage: function _getProductImage() {
            var imageAddress = null;

            if (this.image_groups && this.image_groups.length > 0 && this.image_groups[0].images && this.image_groups[0].images.length > 0) {
                imageAddress = this.image_groups[0].images[0].link;
            }

            // Trim surrounding whitespace...
            return trim(imageAddress || "");
        }

    });

    return new SalesforceCommerceDataAdapter();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Class = __webpack_require__(26),
        Preconditions = __webpack_require__(14),
        AdapterUtil = __webpack_require__(2058),
        SalesforceCommerceProductCollection = __webpack_require__(2059),
        SalesforceCommerceProductModel = __webpack_require__(604);

    /**
     * @class {SalesforceCommerceAbstractDataAdapter}
     *
     * A <i>SalesforceCommerceAbstractDataAdapter</i>  will translate a OCAPI Product model in a <tt>SalesforceCommerceProductModel</tt>.
     * The full documentation of the SalesforceCommerce model can be acquire on this address.
     * (https://info.salesforcecommerce.com/DOC1/index.jsp
     *
     * @author Pedro Augusto / <a href="http://www.zmags.com">Zmags</a>
     *
     */
    var SalesforceCommerceAbstractDataAdapter = Class.extend("SalesforceCommerceAbstractDataAdapter", {

        /**
         * Filter a product based on his settings.
         * @abstract
         * @param {Object} target already transformed.
         * @param {Object} settings
         */
        // eslint-disable-next-line no-unused-vars
        filter: function filter(target, settings) {
            Preconditions.abstractMethodError();
        },

        _mapCache: null,

        /**
         * Singleton to avoid creating several instances of the mapping.
         *
         * @return {Object} Returns the cached maps.
         * @private
         */
        _getMapsInstance: function _getMapsInstance() {
            if (!this._mapCache) {
                this._mapCache = this.getMaps();
            }

            return this._mapCache;
        },

        /**
         * Map a Product from the SalesforceCommerceWebServer in a SalesforceCommerceProductModel in creator.
         * @abstract
         */
        getMaps: function getMaps() {
            Preconditions.abstractMethodError();
        },

        /**
         * Transform the products hits into an array of Ids.
         *
         * @param {Object} products SalesforceCommerce product_search endpoint result.
         * @return {String[]} The matching product ids.
         */
        searchHits: function searchHits(products) {
            var ids = [];

            _.each(products.hits, function (hit) {
                ids.push(hit.product_id);
            });

            return ids;
        },

        /**
         * Transform a product into SalesforceCommerceProductModel.<p>
         *  @example
         *  <pre>
         *  {
         *       "brand" : "Creative",
         *       "id" : "creative-zen-v",
         *       "image_groups" : [
         *         {
         *           "images" : [ {
         *             "alt" : "Creative ZEN V Digital Media Player, , small",
         *             "link" : "http://localhost/on/salesforcecommerce.static/Sites-SiteGe..",
         *             "title" : "Creative ZEN V Digital Media Player, "
         *           } ],
         *           "view_type" : "small"
         *         } ],
         *       "name" : "Creative ZEN V Digital Media Player",
         *       "page_description" : "The ZEN V player was designed for people ...",
         *       "page_keywords" : "Creative",
         *       "page_title" : "Creative ZEN V Digital Media Player",
         *       "primary_category_id" : "electronics-digital-media-players",
         *       "short_description" : "The ZEN V player was designed for people...",
         *       "type" : {
         *         "item" : true
         *       },
         *       ...
         *       "c_mediaFormat" : [ "0010", "0020", "0030", "0040" ],
         *       "c_memorySize" : "1GB",
         *       "c_tabDescription" : "The ZEN V player was designed for people ..."
         *   }
         * </pre>
         * @param {Object} product from the SalesforceCommerceWebService.
         * @param {SalesforceCommerceSettingsModel} settings The SalesforceCommerce settings.
         * @return {SalesforceCommerceProductModel} The resulting model.
         */
        productToModel: function productToModel(product, settings) {
            Preconditions.checkArgument(product, settings);

            var target = AdapterUtil.map(this._getMapsInstance()).transform(product);

            this.filter(target, settings);

            return new SalesforceCommerceProductModel(target);
        },

        /**
         * Transform an array of products into <tt>SalesforceCommerceProductCollection</tt>.
         * @example
         * <pre>
         * {.. , data:[ {
         *       "brand" : "Creative",
         *       "id" : "creative-zen-v",
         *       "image_groups" : [
         *         {
         *           "images" : [ {
         *             "alt" : "Creative ZEN V Digital Media Player, , small",
         *             "link" : "http://localhost/on/salesforcecommerce.static/Sites-SiteGe..",
         *             "title" : "Creative ZEN V Digital Media Player, "
         *           } ],
         *           "view_type" : "small"
         *         } ],
         *       "name" : "Creative ZEN V Digital Media Player",
         *       "page_description" : "The ZEN V player was designed for people ...",
         *       "page_keywords" : "Creative",
         *       "page_title" : "Creative ZEN V Digital Media Player",
         *       "primary_category_id" : "electronics-digital-media-players",
         *       "short_description" : "The ZEN V player was designed for people...",
         *       "type" : {
         *         "item" : true
         *       },
         *       ...
         *       "c_mediaFormat" : [ "0010", "0020", "0030", "0040" ],
         *       "c_memorySize" : "1GB",
         *       "c_tabDescription" : "The ZEN V player was designed for people ..."
         *   }] ...}
         * </pre>
         * @param {Object} products SalesforceCommerceProducts coming from the SalesforceCommerceService.
         * @param {SalesforceCommerceSettingsModel} settings The SalesforceCommerce settings.
         * @return {SalesforceCommerceProductCollection} The resulting product collection.
         */
        productsToCollection: function productsToCollection(products, settings) {
            var self = this,
                collection = new SalesforceCommerceProductCollection();

            _.each(products.data, function (product) {
                collection.push(self.productToModel(product, settings));
            });

            return collection;
        }
    });

    return SalesforceCommerceAbstractDataAdapter;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        isFunction = _require.isFunction;

    var Preconditions = __webpack_require__(14);

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var log = new Logger("Adapter Util");

    /**
     * Generic data adapter will be used to external communication with system like SalesforceCommerce or
     * other integrations.
     *
     * @class AdapterUtil
     * @constructor
     */
    return {

        _source: null,

        /**
         * Set the map property.<p>
         * @example
         * <pre>
         *  {
         *    name: {
         *     defaultValue: "No name",        // "No name" defaultValue in case of the use don't pass a value; optional
         *     type: "string",                 // type of the object, if is passed the value will be checked; optional
         *     value: "name"                   // Value field of the object.
         *    },
         *    minAge: {
         *      type: "number",
         *      value:  function(){
         *        return  this.age > 18 ? 25 : 13;
         *      }
         *    }
         *  }
         * </pre>
         * @returns {AdapterUtil} returns the chain object
         */
        map: function map(_map) {
            Preconditions.checkArgument(_map);

            this._map = _map;

            return this;
        },


        /**
         * @private
         * Map object.
         */
        _map: null,

        /**
         * Transform the source in a new object.
         *
         * @param {Object} source that will be the object transformed.
         * @returns {Object}
         */
        transform: function transform(source) {
            var target = {};
            var attrProperties = void 0;
            var value = void 0;

            this._source = source;

            // Run each property of the map.
            for (var propertyName in this._map) {
                // Take the description of the field like "name" or age"
                attrProperties = this._map[propertyName];

                value = this._getProp(attrProperties, "value") || this._getProp(attrProperties, "defaultValue");

                this._setNewProp(attrProperties, target, propertyName, value);
            }

            return target;
        },


        /**
         * Set a property in the newObject, it may validate the type of the object
         * in case of the type is present inside of meta.
         *
         * @param {Object} meta properties of the item.
         * @param {Object} newObject newObject being created in execution time.
         * @param {String} propName PropertyName of the object.
         * @param {Object} propValue PropertyValue of the object.
         * @private
         */
        _setNewProp: function _setNewProp(meta, newObject, propName, propValue) {
            // eslint-disable-next-line dot-notation, valid-typeof
            if (meta["type"] && (typeof propValue === "undefined" ? "undefined" : _typeof(propValue)) !== meta["type"]) {
                var errorMsg = "The type is different of the informed for the map.";

                log.error(errorMsg);
            }

            newObject[propName] = propValue;
        },
        _getProp: function _getProp(attrProperties, propertyKey) {
            var output = null;

            try {
                var prop = attrProperties[propertyKey];

                if (isFunction(prop)) {
                    output = prop.call(this._source);
                } else {
                    /* eslint-disable no-lonely-if */
                    if (propertyKey !== "value") {
                        // Get the prop through a function or itself.
                        output = prop;
                    } else {
                        // Get the prop through a function or an associated field.
                        output = this._source[prop];
                    }
                }
            } catch (e) {
                log.error("Error trying to map an attribute ", propertyKey, attrProperties, e);
            }

            return output;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        SalesforceCommerceProductModel = __webpack_require__(604);

    /**
     * A collection of Products.
     *
     * @author Pedro Augusto
     * @class SalesforceCommerceProductCollection
     * @constructor
     */
    return Backbone.Collection.extend("SalesforceCommerceProductCollection", {
        /**
         * @type SalesforceCommerceProductModel
         */
        model: SalesforceCommerceProductModel
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        SalesforceCommerceProductView = __webpack_require__(2061),
        template = __webpack_require__(1022);

    /**
     * The collection view of <tt>SalesforceCommerceProductView</tt>.
     *
     * @author Pedro Augusto
     * @class SalesforceCommerceProductCollectionView
     * @constructor
     */
    return Marionette.CollectionView.extend({

        template: template,

        itemView: SalesforceCommerceProductView,

        /**
         * Add the state active for the item view that matches the <tt>productID</tt>.
         *
         * @param {String} productId
         */
        highlightSelectedProduct: function highlightSelectedProduct(productId) {
            // iterate over all of the views and process them
            this.children.each(function (view) {
                // Set the current element as active.
                view.$el.toggleClass("active", view.model.get("productID") === productId);
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Browser = __webpack_require__(39);
    var SalesforceCommerceWidgetModel = __webpack_require__(368);
    var Marionette = __webpack_require__(10);
    var template = __webpack_require__(1022);

    /**
     * ItemView containing a SalesforceCommerce product.
     *
     * @class SalesforceCommerceProductView
     * @constructor
     */
    return Marionette.ItemView.extend({

        template: template,

        className: "salesforce-commerce-item fade-in",

        modelEvents: {
            "change:isUsed": "render"
        },

        ui: {
            image: "img"
        },

        events: {
            "click": function click() {
                // Trigger a "select" event on the 'this' element, this will allow the parent
                // view to easily setup a "select" listener, like <tt>events: {"select .salesforce-commerce-image": function...}</tt>
                this.$el.trigger("select", this.model);
            },

            "dragstart": "_dragHandler"
        },

        _dragHandler: function _dragHandler(event) {
            if (this.options.draggable) {
                this.ui.image.attr("draggable", "true");
            }

            // Firefox has a bug that causes it to offset the dragged image when displayed in a lightbox. Workaround is
            // to explicitly set the drag image to the dragged element.
            if (Browser.type.firefox) {
                event.originalEvent.dataTransfer.setDragImage(this.el, this.$el.width() / 2, this.$el.height() / 2);
            }

            var data = {
                type: "demandware",
                options: {
                    productID: this.model.get("productID"),
                    width: SalesforceCommerceWidgetModel.FIXED_SIZE.width,
                    height: SalesforceCommerceWidgetModel.FIXED_SIZE.height
                }
            };

            // The setData method will work across all browsers. Unfortunately only supports
            // string as data rather than JSON objects, so we need to split the result.
            event.originalEvent.dataTransfer.setData("Text", JSON.stringify(data));
        },
        onRender: function onRender() {
            var _this = this;

            // No deferred here, the error event can already have happened...

            // Add img error handler function.
            this.ui.image.on("error", function () {
                _this.ui.image.hide();

                _this.$(".no-image").toggleClass("hide");
            });
        },


        // Reverts the error handler from img.
        onClose: function onClose() {
            this.ui.image.off("error");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset class="salesforce-commerce-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".salesforce-commerce-properties-accordion">\n        Product Widget\n    </legend>\n    <div class="salesforce-commerce-properties-accordion collapse collapse-target">\n        <div class="connect">\n            <a href="#integrations-salesforce-commerce" class="btn btn-small btn-grey">Connect with SFCC Account</a>\n        </div>\n\n        <div class="search-products">\n            ';
 if (sites.length === 1) { ;
__p += '\n                <label>Selected site: <b class="site">' +
__e( sites[0].get("siteId")) +
'</b> </label>\n                <input class="sites hidden" value="' +
__e( sites[0].id) +
'"/>\n            ';
 } else if (sites.length > 1) { ;
__p += '\n                Select a site:\n                <select class="sites form-control">\n                    <option value="">Select site</option>\n                    ';
 _.each(sites, function (site) { ;
__p += '\n                    <option value="' +
__e( site.id ) +
'">' +
__e( site.get("siteId") ) +
'</option>\n                ';
 }) ;
__p += '\n                </select>\n            ';
 } ;
__p += '\n            <input class="search header" type="search" placeholder="Search">\n\n            <small class="connection-error error"></small>\n            <div class="salesforce-commerce-results"></div>\n        </div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationPropertiesView = __webpack_require__(125),
        SizeAndPositionPropertiesView = __webpack_require__(70),
        template = __webpack_require__(2064),
        AbstractWidgetPropertiesView = __webpack_require__(63);

    var EXPAND_PROPERTY = "navigatorWidgetExpanded";

    /**
     * @class SceneNavigatorWidgetPropertiesView
     * @constructor
     *
     * @cfg {SceneNavigatorWidgetModel}
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        className: "scene-navigator-widget-properties-view",

        template: template,

        ui: {
            container: ".navigator-widget-properties",
            legend: "[data-target=\".navigator-widget-properties\"]",
            optionsContainer: ".options"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            animationProperties: ".animation-properties"
        },

        bindings: {
            ".direction-select": "direction"
        },

        events: {
            "click .options a": function clickOptionsA(event) {
                event.preventDefault();

                // Parse the selected theme
                var theme = event.currentTarget.getAttribute("data-theme");

                // Update the model
                this.model.set("theme", theme);
            }
        },

        modelEvents: {
            "change:theme": "_updateToCurrentTheme"
        },

        /**
         * Updates the UI by reflecting the current selected theme.
         */
        _updateToCurrentTheme: function _updateToCurrentTheme() {
            // Reset 'selected' state
            this.ui.optionsContainer.find("a").removeClass("selected");
            this.ui.optionsContainer.find("a ul :first-child").removeClass("active");

            var selectedTarget = this.ui.optionsContainer.find("[data-theme='" + this.model.get("theme") + "']");
            selectedTarget.addClass("selected");
            selectedTarget.find("ul :first-child").addClass("active");
        },

        onRender: function onRender() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                hideSizeControls: true,
                hideRotation: true,
                widgetView: this.options.widgetView
            }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));

            this._updateToCurrentTheme();
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2064 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".navigator-widget-properties">\n        Scene Slider\n    </legend>\n    <div class="navigator-widget-properties collapse collapse-target">\n        <div class="zmags-input-control">\n            <label>\n                <div class="options">\n                    <a href="#" data-theme="white-1">\n                    1.\n                    <ul class="scene-navigator-container white-1" data-direction="horizontal">\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                    </ul>\n                    </a>\n                    <a href="#" data-theme="white-2">\n                    2.\n                    <ul class="scene-navigator-container white-2" data-direction="horizontal">\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                    </ul>\n                    </a>\n                    <a href="#" data-theme="white-3">\n                    3.\n                    <ul class="scene-navigator-container white-3" data-direction="horizontal">\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                    </ul>\n                    </a>\n                    <a href="#" data-theme="white-4">\n                    4.\n                    <ul class="scene-navigator-container white-4" data-direction="horizontal">\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                    </ul>\n                    </a>\n                    <a href="#" data-theme="white-5">\n                    5.\n                    <ul class="scene-navigator-container white-5" data-direction="horizontal">\n                        <li class="square"></li>\n                        <li class="square"></li>\n                        <li class="square"></li>\n                        <li class="square"></li>\n                        <li class="square"></li>\n                    </ul>\n                    </a>\n                    <a href="#" data-theme="black-1">\n                    6.\n                    <ul class="scene-navigator-container black-1" data-direction="horizontal">\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                    </ul>\n                    </a>\n                    <a href="#" data-theme="black-2">\n                    7.\n                    <ul class="scene-navigator-container black-2" data-direction="horizontal">\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                    </ul>\n                    </a>\n                    <a href="#" data-theme="black-3">\n                    8.\n                    <ul class="scene-navigator-container black-3" data-direction="horizontal">\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                    </ul>\n                    </a>\n                    <a href="#" data-theme="black-4">\n                    9.\n                    <ul class="scene-navigator-container black-4" data-direction="horizontal">\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                        <li class="circle"></li>\n                    </ul>\n                    </a>\n                    <a href="#" data-theme="black-5">\n                    10.\n                    <ul class="scene-navigator-container black-5" data-direction="horizontal">\n                        <li class="square"></li>\n                        <li class="square"></li>\n                        <li class="square"></li>\n                        <li class="square"></li>\n                        <li class="square"></li>\n                    </ul>\n                    </a>\n                </div>\n            </label>\n            <label class="direction-options">\n                Direction:\n                <select class="direction-select form-control">\n                    <option value="horizontal">Horizontal</option>\n                    <option value="vertical">Vertical</option>\n                </select>\n            </label>\n        </div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="animation-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationPropertiesView = __webpack_require__(125),
        ColorPicker = __webpack_require__(208),
        SizeAndPositionPropertiesView = __webpack_require__(70),
        StylePropertiesView = __webpack_require__(559),
        template = __webpack_require__(2066),
        AbstractWidgetPropertiesView = __webpack_require__(63);

    var EXPAND_PROPERTY = "shapeExpanded";

    /**
     * The properties view for a shape widget.
     *
     * @class ShapeWidgetPropertiesView
     * @constructor
     *
     * @cfg {ShapeWidgetModel} model The model for the shape widget being edited.
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        template: template,

        _backgroundColorPicker: null,

        ui: {
            legend: "[data-target=\".shape-properties-container\"]",
            shapeProperties: ".shape-properties-container",
            shapeBackgroundColorInput: ".shape-background-color-input",
            shapeBackgroundColorBox: ".shape-background-color-box",
            shapeColorLibrary: ".shape-background-color-library"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            styleProperties: ".style-properties",
            animationProperties: ".animation-properties"
        },

        bindings: {
            ".shape-background-color-input": {
                observe: "backgroundColor",
                onSet: function onSet(color) {
                    return this._backgroundColorPicker.hexOrDefault(color);
                }
            }
        },

        onClose: function onClose() {
            this._backgroundColorPicker.dispose();
        },

        onRender: function onRender() {
            this.__super();

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                widgetView: this.options.widgetView
            }));
            this.styleProperties.show(new StylePropertiesView({ model: this.model, hideOpacityControls: false, hideRadiusControls: false }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this._backgroundColorPicker = new ColorPicker({
                color: this.model.get("backgroundColor"),
                input: this.ui.shapeBackgroundColorInput,
                colorBox: this.ui.shapeBackgroundColorBox,
                library: this.ui.shapeColorLibrary,
                includeTransparency: true,
                tracking: "colorpicker:box"
            });
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2066 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '\n<fieldset class="shape-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".shape-properties-container">Box</legend>\n    <div class="shape-properties-container collapse collapse-target">\n        <div class="zmags-input-control">\n            <div class="shape-background-color-library color-library"></div>\n            <label class="color-library-custom">\n                Custom Color:\n                <div class="shape-background-color-box color-box"></div>\n                <input type="text" class="shape-background-color-input color-input">\n            </label>\n        </div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="animation-properties"></div>\n    <div class="style-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnimationPropertiesView = __webpack_require__(125);

    var _require = __webpack_require__(517),
        STYLES = _require.STYLES;

    var SizeAndPositionPropertiesView = __webpack_require__(70);
    var template = __webpack_require__(2068);
    var AbstractWidgetPropertiesView = __webpack_require__(63);

    var EXPAND_PROPERTY = "socialSharingWidgetExpanded";

    /**
     * @class SocialSharingWidgetPropertiesView
     * @constructor
     *
     * @cfg {SocialSharingWidgetModel}
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        className: "social-sharing-widget-properties-view",

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                styles: STYLES
            };
        },


        ui: {
            container: ".social-sharing-widget-properties",
            legend: "[data-target=\".social-sharing-widget-properties\"]",
            optionsContainer: ".options"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            actionProperties: ".action-properties",
            animationProperties: ".animation-properties",
            networkSettingsProperties: ".network-settings-properties"
        },

        bindings: {
            ".share-url": "url"
        },

        events: {
            "click .options a": "_selectStyleHandler"
        },

        modelEvents: {
            "change:style": "_updateToCurrentStyle"
        },

        _selectStyleHandler: function _selectStyleHandler(event) {
            event.preventDefault();

            // Parse the selected style
            var style = event.currentTarget.getAttribute("data-style");

            // Update the model
            this.model.set("style", style);
        },


        /**
         * Updates the UI by reflecting the current selected theme.
         */
        _updateToCurrentStyle: function _updateToCurrentStyle() {
            var optionsContainer = this.ui.optionsContainer;
            // Reset 'selected' state

            optionsContainer.find("a").removeClass("selected");
            optionsContainer.find("a .style-sharing-container :first-child").removeClass("active");

            var selectedTarget = optionsContainer.find("[data-style='" + this.model.get("style") + "']");
            selectedTarget.addClass("selected");
            selectedTarget.find(".style-sharing-container :first-child").addClass("active");
        },
        onRender: function onRender() {
            this.__super();
            var hasGoogleplusNetwork = this.model.get("networks").some(function (network) {
                return network === "googleplus";
            });
            if (hasGoogleplusNetwork) {
                this.ui.optionsContainer.find(".category").addClass("has-googleplus");
            }
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                hideSizeControls: true,
                hideRotation: true,
                widgetView: this.options.widgetView
            }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this._updateToCurrentStyle();
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2068 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".social-sharing-widget-properties">\n        Social Sharing Widget\n    </legend>\n    <div class="social-sharing-widget-properties collapse collapse-target">\n        <div class="style-settings-container zmags-input-control">\n            <legend class="social-legend">Style</legend>\n            <label>\n                <div class="options">\n                    ';
 styles.forEach(function (style) { ;
__p += '\n                        <a href="#" data-style="' +
__e( style.category ) +
'">\n                            <div class="style-sharing-container">\n                                <span class="name">' +
__e( style.name ) +
'</span>\n                                <div class="category ' +
__e( style.category ) +
'"></div>\n                            </div>\n                        </a>\n                    ';
 }); ;
__p += '\n                </div>\n            </label>\n        </div>\n        <div class="share-url-settings-container">\n            <legend class="social-legend">Url</legend>\n            <label class="share-url-container">\n                <span class="share-url-label">\n                    <input type="text" class="share-url full-width" placeholder="Optional Share Url">\n                </span>\n                <span class="help-block">\n                    Optional Share Url, by default it will use the Url where the Experience is shown.\n                </span>\n            </label>\n        </div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="animation-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ActionPropertiesView = __webpack_require__(205);
    var AnimationPropertiesView = __webpack_require__(125);
    var CharacterPropertiesView = __webpack_require__(402);
    var ImprovedView = __webpack_require__(6);
    var SizeAndPositionPropertiesView = __webpack_require__(70);
    var template = __webpack_require__(2070);

    /**
     * The properties view for a text widget.
     *
     * @class TextEnhancedWidgetPropertiesView
     * @constructor
     *
     * @cfg {TextWidgetModel} model The model for the text widget being edited.
     */
    return ImprovedView.extend({

        template: template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            analyticsProperties: ".analytics-properties",
            animationProperties: ".animation-properties",
            actionProperties: ".action-properties"
        },

        onRender: function onRender() {
            this.__super();

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                showWidthControls: true,
                hideSizeControls: true,
                widgetView: this.options.widgetView
            }));
            this.analyticsProperties.show(this._setAnalyticsLabel({ model: this.model }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this.actionProperties.show(new ActionPropertiesView({ model: this.model }));
        }
    }, {
        EXPAND_PROPERTY: CharacterPropertiesView.EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2070 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset>\n    <div class="character-properties" id="character-properties"></div>\n    <div class="action-properties"></div>\n    <div class="analytics-properties"></div>\n    <div class="animation-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ActionPropertiesView = __webpack_require__(205),
        AnimationPropertiesView = __webpack_require__(125),
        CharacterPropertiesView = __webpack_require__(402),
        ImprovedView = __webpack_require__(6),
        SizeAndPositionPropertiesView = __webpack_require__(70),
        template = __webpack_require__(2072);

    /**
     * The properties view for a text widget.
     *
     * @class TextWidgetPropertiesView
     * @constructor
     *
     * @cfg {TextWidgetModel} model The model for the text widget being edited.
     */
    return ImprovedView.extend({

        template: template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            analyticsProperties: ".analytics-properties",
            animationProperties: ".animation-properties",
            characterProperties: ".character-properties",
            actionProperties: ".action-properties"
        },

        onRender: function onRender() {
            this.__super();

            this.analyticsProperties.show(this._setAnalyticsLabel({ model: this.model }));
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                showWidthControls: true,
                hideSizeControls: true,
                widgetView: this.options.widgetView
            }));
            this.characterProperties.show(new CharacterPropertiesView({ model: this.model.get("editorModel"), widgetView: this.options.widgetView }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this.actionProperties.show(new ActionPropertiesView({ model: this.model }));
        }
    }, {
        EXPAND_PROPERTY: CharacterPropertiesView.EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2072 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset>\n    <div class="character-properties"></div>\n    <div class="action-properties"></div>\n    <div class="analytics-properties"></div>\n    <div class="animation-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>';

}
return __p
}

/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        AnimationPropertiesView = __webpack_require__(125),
        SizeAndPositionPropertiesView = __webpack_require__(70),
        template = __webpack_require__(2074),
        YouTubeAccountView = __webpack_require__(2075),
        YouTubeSettingsPropertiesView = __webpack_require__(2082),
        YouTubeService = __webpack_require__(1023),
        YouTubeUtil = __webpack_require__(1024),
        AbstractWidgetPropertiesView = __webpack_require__(63);

    var EXPAND_PROPERTY = "youTubeExpanded";

    /**
     * The properties view for an Youtube widget.
     *
     * @class YoutubeWidgetPropertiesView
     *
     * @cfg {YoutubeWidgetModel} model The model for the Youtube widget being edited.
     */
    return AbstractWidgetPropertiesView.extend("YouTubeWidgetPropertiesView", {

        expandProperty: EXPAND_PROPERTY,

        template: template,

        ui: {
            searchInput: ".search",
            youtubeResults: ".youtube-results",
            youtubePropertiesAccordion: ".youtube-properties-accordion",
            legend: "legend"
        },

        regions: {
            youtubeResults: ".youtube-results",
            sizeAndPositionProperties: ".size-and-position-properties",
            animationProperties: ".animation-properties",
            accountViewRegion: ".account-view-region",
            youtubeSettingsProperties: ".youtube-settings-properties"
        },

        events: {
            "keyup .search": "_searchInputChangeHandler",
            "select .youtube-image": function selectYoutubeImage(event, model) {
                this.model.set("videoID", model.get("videoID"));
            }
        },

        _clearSearch: function _clearSearch() {
            this.ui.searchInput.val("");
            this.youtubeResults.close();
            this.ui.youtubeResults.hide();
        },

        _search: function _search(query) {
            var _this = this;

            YouTubeService.search(query).done(function (response) {
                // Theres a chance the view might have been closed during search
                if (_this.isClosed) {
                    return;
                }

                var collectionView = YouTubeUtil.toCollectionView(response.items);
                _this.youtubeResults.show(collectionView);
                _this.ui.youtubeResults.show();
            });
        },

        initialize: function initialize() {
            this.__super();

            // Debounce 'search'
            this._search = _.debounce(this._search, 300);
        },

        _searchMostPopularVideos: function _searchMostPopularVideos() {
            this._search("");
        },

        _searchInputChangeHandler: function _searchInputChangeHandler() {
            var query = this.ui.searchInput.val();
            this._search(query);
        },

        onRender: function onRender() {
            this.__super();
            if (this.model.has("videoID")) {
                this._clearSearch();
            } else {
                // Add dummy placeholder
                this.ui.searchInput.val("Most popular");
                // Start initial search (the empty string will return the most popular videos)
                this._searchMostPopularVideos();
            }

            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this.youtubeSettingsProperties.show(new YouTubeSettingsPropertiesView({ model: this.model, hideRotation: true }));
            this.animationProperties.show(new AnimationPropertiesView({ model: this.model, widgetView: this.options.widgetView }));
            this.accountViewRegion.show(new YouTubeAccountView({ widgetModel: this.model }));
        },

        _shouldExpandOnRender: function _shouldExpandOnRender() {
            return this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] || !this.model.has("videoID");
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2074 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset class="youtube-properties">\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".youtube-properties-accordion">\n        <div class="youtube-menu-icon" />&nbsp;YouTube Widget\n    </legend>\n    <div class="youtube-properties-accordion collapse collapse-target">\n        <div>\n            <input class="search header" type="search" placeholder="Search" maxlength="40">\n            <div class="youtube-results"></div>\n        </div>\n        <div class="account-view-region"></div>\n        <div class="youtube-settings-properties"></div>\n    </div>\n</fieldset>\n\n<fieldset>\n    <div class="animation-properties"></div>\n    <div class="size-and-position-properties"></div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Backbone = __webpack_require__(7),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(2076),
        YouTubeService = __webpack_require__(1023),
        YouTubeUtil = __webpack_require__(1024);

    var YouTubeAccountViewModel = Backbone.Model.extend({

        defaults: {
            title: "",
            avatarUrl: "about:blank",
            connecting: true,
            noChannel: false,
            authorized: false,
            videos: []
        },

        hasVideos: function hasVideos() {
            return this.has("videos") && this.get("videos").length > 0;
        }

    });

    return ImprovedView.extend({

        template: template,

        model: new YouTubeAccountViewModel(), /* Careful, this will make it a singleton */

        events: {
            "click .connect": "_promtAuthorized",
            "click .list-icon": "_promtAuthorized",
            "click .refresh-icon": "_authorize"
        },

        modelEvents: {
            "all": "render"
        },

        regions: {
            accountVideosRegion: ".account-videos-region"
        },

        ui: {
            listIcon: ".list-icon",
            refreshIcon: ".refresh-icon",
            accountVideosRegion: ".account-videos-region"
        },

        initialize: function initialize() {
            _.bindAll(this, "_authorizedHandler");

            // If no data has been feched yet
            if (!this.model.hasVideos()) {
                this._authorize();
            }
        },

        onRender: function onRender() {
            if (this.model.hasVideos()) {
                var collectionView = YouTubeUtil.toCollectionView(this.model.get("videos"));
                this.accountVideosRegion.show(collectionView);
            }
        },

        _authorize: function _authorize() {
            var _this = this;

            // Signal that we're communicating with YouTube
            this.model.set("connecting", true);

            YouTubeService.authorize().then(this._authorizedHandler).fail(function () {
                _this.model.set({
                    authorized: false,
                    connecting: false
                });
            });
        },

        _promtAuthorized: function _promtAuthorized() {
            YouTubeService.authorize(false).done(this._authorizedHandler);
        },

        _authorizedHandler: function _authorizedHandler() {
            var self = this;

            // Signal that we're communicating with YouTube
            this.model.set("connecting", true);

            YouTubeService.getUserData().done(function (userData) {
                if (userData !== "NoChannelConnected") {
                    YouTubeService.getVideoMetadata().done(function (videoMetadata) {
                        self.model.set({
                            authorized: true,
                            title: userData.title || "YouTube Account",
                            avatarUrl: userData.thumbnails.medium.url,
                            connecting: false,
                            videos: videoMetadata.items
                        });

                        // No need to show the video container if user has no videos
                        var showOrHide = self.model.hasVideos() ? "show" : "hide";
                        self.ui.accountVideosRegion[showOrHide]();
                    });
                } else {
                    self.model.set({
                        authorized: true,
                        noChannel: true,
                        connecting: false
                    });
                }
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2076 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="youtube-account-view">\n    ';
 if (connecting) {  ;
__p += '\n        <p class="message">Communicating with YouTube&hellip;</p>\n    ';
 } else if (noChannel) {  ;
__p += '\n        <p class="message">No channel connected to your account.</p>\n    ';
 } else if (authorized) {  ;
__p += '\n        <div class="account-container">\n            <header>\n                <img class="youtube-avatar" src="' +
__e( avatarUrl ) +
'" />\n                <span class="title">' +
__e( title ) +
'</span>\n                <span class="glyphicon glyphicon-list list-icon" data-content="Open account list"></span>\n                <span class="glyphicon glyphicon-refresh refresh-icon" data-content="Reload your videos"></span>\n            </header>\n\n            <div class="account-videos-region"></div>\n        </div>\n    ';
 } else {  ;
__p += '\n        <button class="btn btn-small btn-grey connect">Connect with YouTube account</button>\n    ';
 }  ;
__p += '\n</div>';

}
return __p
}

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var $ = __webpack_require__(4);

    var BASE_URL = "https://apis.google.com/js/client.js";

    /**
     * Wraps the <a href="https://developers.google.com/api-client-library/javascript/start/start-js">Google APIs Client Library for JavaScript</a>.
     *
     * @see https://developers.google.com/api-client-library/javascript/start/start-js
     *
     * @class GoogleAPIClient
     * @author Kim
     */
    var GoogleAPIClient = Class.extend({

        _deferred: null,

        _loadPerformed: false,

        /**
         * Constructor.
         */
        constructor: function constructor() {
            this._deferred = new $.Deferred();
        },


        /**
         * Starts loading the Google client library.
         *
         * <pre>
         * GoogleAPIClient.load().then(function (GoogleAPI) {
         *     var request = GoogleAPI.client.youtube.videos.list({});
         *     request.execute();
         * });
         * </pre>
         *
         * @return {Promise} A promise that resolves with the Google Client API
         * instance.
         */
        load: function load() {
            if (!this._loadPerformed) {
                this._startFetching();
            }
            // Guard for future loads
            this._loadPerformed = true;
            // Return a promise
            return this._deferred.promise();
        },


        /**
         * @private
         *
         * Starts fetching the Google client library, and resolves the deferred
         * object if the load was successful.
         */
        _startFetching: function _startFetching() {
            var _this = this;

            // Create callback in the global scope
            window.__gapiOnloadHandler = function () {
                // Cleanup and resolve
                delete window.__gapiOnloadHandler;
                _this._deferred.resolve(window.gapi);
            };

            // Load the client library - specifying the onload callback
            $.getScript(BASE_URL + "?onload=__gapiOnloadHandler").fail(this._deferred.reject);
        }
    });

    return new GoogleAPIClient();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        template = __webpack_require__(1025),
        YouTubeImageView = __webpack_require__(2079);

    /**
     * The collection view of share recipients.
     *
     * @author Antonio Lagrotteria
     * @class YouTubeCollectionView
     * @constructor
     */
    return Marionette.CollectionView.extend({
        template: template,
        itemView: YouTubeImageView
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Marionette = __webpack_require__(10),
        Browser = __webpack_require__(39),
        template = __webpack_require__(1025),
        Tooltip = __webpack_require__(35),
        tooltipTemplate = __webpack_require__(2080);

    var YOUTUBE = {
        fixedSize: {
            width: 480,
            height: 290
        }
    };

    /**
     * Item view for an image in the image library.
     *
     * @class ImageView
     * @constructor
     *
     * @cfg {Boolean} [enableDeletion] Whether to allow deletion of an image via the view.
     * @cfg {Boolean} [showImageInfo] Whether to display info about the image in the view.
     * @cfg {Boolean} [draggable] Whether the image view should be draggable.
     * @cfg {Boolean} [showTooltips] Whether to show a tooltip with image info when the view is hovered.
     */
    return Marionette.ItemView.extend({

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                displayDuration: this.model.formatDuration()
            };
        },

        tooltipTemplate: tooltipTemplate,

        className: "youtube-image fade-in",

        modelEvents: {
            "change:isUsed": "render"
        },

        ui: {
            image: "img"
        },

        events: {
            "click": function click() {
                // Trigger a "select" event on the 'this' element, this will allow the parent
                // view to easily setup a "select" listener, like <tt>events: {"select .youtube-image": function...}</tt>
                this.$el.trigger("select", this.model);
            },

            "dragstart": "_dragHandler"
        },

        _dragHandler: function _dragHandler(event) {
            // Firefox has a bug that causes it to offset the dragged image when displayed in a lightbox. Workaround is
            // to explicitly set the drag image to the dragged element.
            if (Browser.type.firefox) {
                event.originalEvent.dataTransfer.setDragImage(this.el, this.$el.width() / 2, this.$el.height() / 2);
            }

            var data = {
                type: "youtube",
                options: {
                    videoID: this.model.get("videoID"),
                    width: YOUTUBE.fixedSize.width,
                    height: YOUTUBE.fixedSize.height
                }
            };

            event.originalEvent.dataTransfer.setData("Text", JSON.stringify(data));

            // Cancel showing the bootstrap popover
            if (this.options.showTooltips) {
                this.ui.image.trigger("mouseout");
            }
        },

        initialize: function initialize() {},

        onRender: function onRender() {
            if (this.options.draggable) {
                this.ui.image.attr("draggable", "true");
            }

            if (this.options.showTooltips) {
                Tooltip.add(this.ui.image, {
                    content: this.createTooltipHtml(),
                    container: "body",
                    width: 200,
                    offset: {
                        align: "right",
                        elementWidth: 50
                    },
                    delay: {
                        show: 1000,
                        hide: 0
                    },
                    html: true
                });
            }
        },

        createTooltipHtml: function createTooltipHtml() {
            return tooltipTemplate(_.extend({ type: this.model.get("name").split(".").pop().toLowerCase() }, this.model.toJSON()));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2080 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="assetTooltip">\n    <div class="image-wrapper">\n        <img src="' +
__e( thumbnailUrl ) +
'" class="image" title="' +
__e( name ) +
'">\n    </div>\n\n    <div class="image-info">\n        <div class="title">' +
__e( name ) +
'</div>\n        <div class="description">' +
__e( description ) +
'</div>\n    </div>\n</div>';

}
return __p
}

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        YouTubeImageModel = __webpack_require__(1026);

    /**
     * A collection of images.
     *
     * @author Antonio Lagrotteria
     * @class YouTubeImageCollection
     * @constructor
     */
    return Backbone.Collection.extend({
        model: YouTubeImageModel
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        ImprovedView = __webpack_require__(6),
        template = __webpack_require__(2083),
        Tooltip = __webpack_require__(35);

    /**
     * The properties view for size and position information.
     *
     * @class YouTubeSettingsPropertiesView
     * @constructor
     */
    return ImprovedView.extend({

        template: template,

        ui: {
            legend: "[data-target=\"#youtube-settings-properties\"]",
            controls: "#controls",
            loop: "#loop",
            autoplay: "#autoplay",
            autoplayExclamationSign: ".glyphicon-exclamation-sign.autoplay",
            mute: "#mute"
        },

        _changeModel: function _changeModel(ev) {
            var target = $(ev.target);
            this.model.set(target.attr("id"), target.is(":checked"));
        },

        events: {
            "click #loop": "_changeModel",
            "click #autoplay": "_changeModel",
            "click #controls": "_changeModel",
            "click #mute": "_changeModel"
        },

        onRender: function onRender() {
            this.ui.controls.prop("checked", this.model.get("controls"));
            this.ui.autoplay.prop("checked", this.model.get("autoplay"));
            this.ui.loop.prop("checked", this.model.get("loop"));
            this.ui.mute.prop("checked", this.model.get("mute"));

            Tooltip.add(this.ui.autoplayExclamationSign, {
                delay: { show: 500, hide: 0 }
            });
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2083 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<fieldset class="youtube-settings-container">\n    <legend data-target="#youtube-settings-properties">YouTube Settings</legend>\n        <div class="checkbox-grid">\n            <label>\n                <input type="checkbox" id="controls">\n                <span class="custom-checkbox"></span>\n                Enable controls\n            </label>\n            <label>\n                <input type="checkbox" id="autoplay">\n                <span class="custom-checkbox"></span>\n                Autoplay\n                <i class="glyphicon glyphicon-exclamation-sign autoplay" data-content="Autoplay is not supported on tablets and mobile devices"></i>\n            </label>\n            <label>\n                <input type="checkbox" id="loop">\n                <span class="custom-checkbox"></span>\n                Loop\n            </label>\n            <label>\n                <input type="checkbox" id="mute">\n                <span class="custom-checkbox"></span>\n                Mute\n            </label>\n        </div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CompositeWidgetPropertiesView = __webpack_require__(878);
    var template = __webpack_require__(2085);
    var SizeAndPositionPropertiesView = __webpack_require__(70);
    var ProductPropertiesView = __webpack_require__(2086);

    var EXPAND_PROPERTY = "dynamicProductExpanded";

    /**
     * The properties view for a dynamic product widget which extends a composite widget.
     *
     * @class DynamicWidgetPropertiesView
     * @constructor
     *
     * @cfg {DynamicProductWidgetModel} model The model for the composite widget being edited.
     */
    return CompositeWidgetPropertiesView.extend("DynamicWidgetPropertiesView", {
        template: template,

        ui: {
            container: ".dynamic-widget-properties-accordion"
        },

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties",
            productProperties: ".product-properties"
        },

        onRender: function onRender() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                hideSizeControls: true,
                hideRotation: true,
                hideGrouping: true,
                widgetView: this.options.widgetView
            }));
            this.productProperties.show(new ProductPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                widgetView: this.options.widgetView
            }));
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2085 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="product-properties"></div>\n<div class="size-and-position-properties"></div>\n';

}
return __p
}

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var template = __webpack_require__(2087),
        ShowWidgetsView = __webpack_require__(2088),
        ProductPropertiesModel = __webpack_require__(789),
        CreateAndUpdateDynamicProductWidget = __webpack_require__(790),
        Promise = __webpack_require__(21),
        AddWidgetsAction = __webpack_require__(370),
        AbstractWidgetPropertiesView = __webpack_require__(63),
        EditorActivities = __webpack_require__(361),
        EditorActivityManager = __webpack_require__(197),
        EditorEventFilters = __webpack_require__(154).default,
        Configuration = __webpack_require__(27);

    var EXPAND_PROPERTY = "productExpanded";

    return AbstractWidgetPropertiesView.extend({

        template: template,

        model: null,

        templateHelpers: function templateHelpers() {
            var normalizedInputID = this.model.has("inputProductID") ? this.model.get("inputProductID").toUpperCase() : null;
            var normalizedProductID = this.model.has("productID") ? this.model.get("productID").toUpperCase() : null;

            return {
                hasInput: this.model.has("inputProductID"),
                isValidInput: normalizedInputID === normalizedProductID,
                productID: this.model.get("productID"),
                panelName: "Product"
            };
        },

        ui: {
            productIDInput: "#dynamic-product-id-input",
            searchButton: "#search-button"
        },

        regions: {
            actionsRegion: ".toggle-subwidgets-region",
            inputRegion: ".inputRegion"
        },

        events: {
            "keydown @ui.productIDInput": "_enterProductID",
            "click @ui.searchButton": "_pressSearchButton"
        },

        _shouldExpandOnRender: function _shouldExpandOnRender() {
            return true;
        },
        onRender: function onRender() {
            var _this = this;

            this._$accordionControl = this.$el.find(".collapsible[data-target]");

            if (this._accordionControlsExist()) {
                this._$accordionTarget = this.$el.find(this._$accordionControl.data("target"));
            }
            if (!this._accordionControlsExist()) {
                return;
            }
            this._$accordionTarget.on("show.bs.collapse", function () {
                _this._$accordionControl.toggleClass("collapsed", false);
            });

            this._$accordionTarget.on("hide.bs.collapse", function () {
                _this._$accordionControl.toggleClass("collapsed", true);
            });

            if (this._shouldExpandOnRender()) {
                this._$accordionTarget.collapse("show");
            }
        },


        onShow: function onShow() {
            this.__super();

            this.actionsRegion.show(new ShowWidgetsView({
                model: this.model,
                groupWidgetView: this.options.widgetView
            }));
        },

        _pressSearchButton: function _pressSearchButton() {
            var model = new ProductPropertiesModel();
            var experience = this.viewScope.viewModel.get("experience");

            var self = this;
            self._processInput(experience, model);
        },
        _enterProductID: function _enterProductID(event) {
            var model = new ProductPropertiesModel();
            var experience = this.viewScope.viewModel.get("experience");

            var self = this;
            if (event.keyCode === 13) {
                self._processInput(experience, model, 0);
            }
        },
        _processInput: function _processInput(experience, propertiesModel, retry) {
            var _this2 = this;

            var productID = this.ui.productIDInput[0].value;
            propertiesModel.getProduct(productID, experience.get("language"), experience.get("companyId")).then(function (product) {
                _this2._processAnswerFile(product, experience);
            }).fail(function (error) {
                return _this2._processInputWithRetry(error, experience, productID, propertiesModel, retry + 1);
            });
        },
        _processInputWithRetry: function _processInputWithRetry(error, experience, productID, propertiesModel, retry) {
            var self = this;
            if (!error.responseJSON && retry <= Configuration.maxRetries) {
                setTimeout(function () {
                    self._processInput(experience, propertiesModel, retry);
                }, 500);
            } else {
                this.model.setInputProductID(productID);
                this.render();
            }
        },
        _sleep: function _sleep(time) {
            return new Promise(function (resolve) {
                return setTimeout(resolve, time);
            });
        },
        _processAnswerFile: function _processAnswerFile(product, experience) {
            var productWidget = this.viewScope.viewModel.selection.isSingle() ? this.viewScope.viewModel.selection.get("widgets")[0] : undefined;
            var self = this;
            var scene = self.viewScope.viewModel.get("scene");

            var keys = Object.keys(product.get("products"));
            if (keys.length > 0) {
                // We assume that the answer file either has 0 or 1 product
                var correctProductID = keys[0];
                var currentProduct = product.get("products")[keys[0]];
                if (currentProduct) {
                    if (self.model.has("group") && self.model.get("group").length > 0) {
                        var previousProductWidgetID = self.model.get("productID");
                        var dynamicProductWidgetModel = CreateAndUpdateDynamicProductWidget.updateProductWidget(product, experience, self.model);
                        var currentDynamicProductWidgetID = dynamicProductWidgetModel.get("productID");
                        EditorActivityManager.add(new EditorActivities.DynamicProductWidgetCreatedActivity({
                            dynamicProductWidgetModel: self.model,
                            experience: experience,
                            previousID: previousProductWidgetID,
                            currentID: currentDynamicProductWidgetID,
                            viewScope: self.viewScope
                        }));
                    } else {
                        var previousProductWidget = productWidget.model.clone();
                        CreateAndUpdateDynamicProductWidget.createProductWidget(product, experience, productWidget.model).then(function (widgetModels) {
                            new AddWidgetsAction(scene, widgetModels, self.viewScope.viewModel, true, { cause: EditorEventFilters.SUPERFICIAL }).execute().done(function () {
                                var scene = self.viewScope.viewModel.get("activeLayerSceneModel");
                                var newProductWidget = CreateAndUpdateDynamicProductWidget.updateProductWidgetOnScene(scene, self.model, correctProductID, widgetModels);
                                var productID = newProductWidget.get("productID");
                                EditorActivityManager.add(new EditorActivities.DynamicProductWidgetCreatedActivity({
                                    dynamicProductWidgetModel: newProductWidget,
                                    currentID: productID,
                                    previousDynamicProductWidgetModel: previousProductWidget,
                                    experience: experience,
                                    scene: scene,
                                    viewScope: self.viewScope
                                }));
                            });
                        });
                    }
                    if (!experience.get("experienceMetadata").dynamicProductIds.includes(correctProductID)) {
                        experience.get("experienceMetadata").dynamicProductIds.push(correctProductID);
                    }
                }
            }
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<fieldset>\n    <legend class="collapsible collapsed" data-toggle="collapse" data-target=".product-properties-accordion">Product\n    </legend>\n    <div class="product-properties-accordion collapse collapse-target">\n        <div>\n            <div class="product-region">\n                <div id="input-region">\n                    <input type="text" id="dynamic-product-id-input" class="full-width" value= "' +
((__t = (productID)) == null ? '' : __t) +
'" autocomplete="off" placeholder="Type your Product ID here&#8230;">\n                    <button id="search-button" class= "search-button">\n                    ';
 if (hasInput && isValidInput) { ;
__p += '\n                    <span id="correct-product-id" class="glyphicon glyphicon-ok"></span>\n                    ';
 } ;
__p += '\n                    ';
 if (hasInput && !isValidInput) { ;
__p += '\n                    <span id="incorrect-product-id" class="glyphicon glyphicon-remove"></span>\n                    ';
 } ;
__p += '\n                </div>\n                <div class="toggle-subwidgets-region"></div>\n            </div>\n        </div>\n    </div>\n</fieldset>\n';

}
return __p
}

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        ShowSubWidgetView = __webpack_require__(2089),
        DynamicProductWidgetSubtypes = __webpack_require__(791).default,
        template = __webpack_require__(2091);

    return ImprovedView.extend({

        template: template,

        model: null,

        regions: {
            toggleImageSubwidgets: ".toggle-image-region",
            togglePriceSubwidgets: ".toggle-price-region",
            toggleTitleSubwidgets: ".toggle-title-region",
            toggleDescriptionSubwidgets: ".toggle-description-region"
        },

        templateHelpers: function templateHelpers() {
            return {
                productIDEntered: typeof this.model.get("group") !== "undefined"
            };
        },

        onShow: function onShow() {
            var _this = this;

            this.__super();
            var widgetMap = new Map();

            var mapTypes = [[DynamicProductWidgetSubtypes.Image, this.toggleImageSubwidgets], [DynamicProductWidgetSubtypes.Price, this.togglePriceSubwidgets], [DynamicProductWidgetSubtypes.Title, this.toggleTitleSubwidgets], [DynamicProductWidgetSubtypes.Description, this.toggleDescriptionSubwidgets]];

            mapTypes.forEach(function (type) {
                widgetMap.set(type[0], type[1]);
            });

            if (this.model.get("group")) {
                this.model.get("group").forEach(function (widget) {
                    var type = widget.get("subtype");
                    widgetMap.get(type).show(new ShowSubWidgetView({
                        subWidgetModels: _this.model.get("group").models,
                        model: widget,
                        type: widget.get("subtype"),
                        groupWidgetView: _this.options.groupWidgetView
                    }));
                });
            }
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        template = __webpack_require__(2090);

    return ImprovedView.extend({

        template: template,

        model: null,

        ui: {
            toggleSubwidgetRegion: ".toggle-subwidget-region"
        },

        events: {
            "change .toggle-subwidget-region": function changeToggleSubwidgetRegion() {
                this._toggleSubwidget(this.ui.toggleSubwidgetRegion.is(":checked"));
            }
        },

        templateHelpers: function templateHelpers() {
            return {
                type: this.options.type
            };
        },

        onShow: function onShow() {
            this.__super();

            this.ui.toggleSubwidgetRegion.prop("checked", this.model.get("isVisible"));
        },

        onRender: function onRender() {
            this.__super();

            this.ui.toggleSubwidgetRegion.prop("checked", this.model.get("isVisible"));
        },

        _toggleSubwidget: function _toggleSubwidget(isChecked) {
            var relatedSubwidgets = this.options.subWidgetModels;
            var visibleSubwidgets = 0;

            relatedSubwidgets.forEach(function (widget) {
                if (widget.get("isVisible")) {
                    visibleSubwidgets += 1;
                }
            });
            if (visibleSubwidgets !== 1 || !this.model.get("isVisible")) {
                this.model.set("isVisible", isChecked);
                this.model.trigger("transformed");
                return;
            }
            this.render();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2090 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<label class="block">\n <input type="checkbox" class="toggle-subwidget-region">\n <span class="custom-checkbox"></span>\n  ' +
__e( type ) +
'\n  </label>\n<div class="toggle-subwidget-region"></div>\n';

}
return __p
}

/***/ }),
/* 2091 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (productIDEntered) { ;
__p += '\n<fieldset>\n    <div>Show:</div>\n    <div class="toggle-image-region">\n    <div class="toggle-price-region">\n    <div class="toggle-title-region">\n    <div class="toggle-description-region">\n    </div>\n</fieldset>\n';
 } ;
__p += '\n\n';

}
return __p
}

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var BundleStrategy = __webpack_require__(2093);
    var CompanySettings = __webpack_require__(1027);
    var SalesforceCommerceSettingsModel = __webpack_require__(2095);
    var Permissions = __webpack_require__(22);
    var Syncer = __webpack_require__(50);

    /**
     * Company Settings Editor Mixin functionality.
     *
     * @constructor
     */
    return CompanySettings.mixin("CompanySettingsEditorMixin", {

        relations: [{
            key: "demandware",
            type: Backbone.One,
            relatedModel: SalesforceCommerceSettingsModel
        }],

        defaults: {
            version: null,
            purgeTime: null,
            bundleStrategy: BundleStrategy.STANDARD.name,
            imageViewedEventsEnabled: false,

            /**
             * @type {SalesforceCommerceSettingsModel}
             * SalesforceCommerce Settings for the company in question.
             */
            demandware: null // can be null if no settings available at all, use "demandware()" function to always get non-null settings
        },

        computed: {
            bundleStrategy: {
                deps: ["bundleStrategy"],
                value: function value(bundleStrategyValue) {
                    return BundleStrategy.fromValue(bundleStrategyValue);
                }
            }
        },

        updateOnSync: ["state", "purgeTime"],

        constructor: function constructor() {
            this.__super();
            Syncer.State.init(this, {
                // Settings require ADMIN privilege to change, and destroy not even supported...
                permissions: {
                    save: Permissions.Privileges.ADMIN,
                    destroy: Permissions.Privileges.UNOBTAINABLE
                }
            });
        },


        /**
         *
         * @see {WidgetTypes.SALESFORCE_COMMERCE}
         *
         * Returns the SalesforceCommerce Settings for the company in question.
         *
         * @return {SalesforceCommerceSettingsModel} The SalesforceCommerce settings; never null.
         */
        demandware: function demandware() {
            // Can be null if the company does not have any SalesforceCommerce settings at all. If null, it can never be
            // enabled anyways, so fine to return a new dummy model with disabled salesforceCommerce...
            return this.get("demandware") || new SalesforceCommerceSettingsModel();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        find = _require.find;

    var BundleStrategies = {
        Standard: {
            name: "Standard",
            isBundled: false,
            description: "Standard bundle strategy. This is the default bundling strategy for all customers."
        },
        Channels: {
            name: "Channels",
            isBundled: true,
            description: "Channels bundle strategy - will bundle the channel configuration together with the channels.js code"
        },
        ChannelsAndLibs: {
            name: "ChannelsAndLibs",
            isBundled: true,
            description: "Channels and preloaded libs bundle strategy - will bundle the channel configuration together\nwith any external libs available (for now, only Piwik) and channels js.code"
        }
    };

    /**
     * Enumeration representing the bundle strategies <tt>value</tt> is equal
     * to <tt>companySettings.get("bundleStrategy")</tt>.
     *
     * @author avi
     */
    return {
        STANDARD: BundleStrategies.Standard,
        CHANNELS: BundleStrategies.Channels,
        CHANNELS_AND_LIBS: BundleStrategies.ChannelsAndLibs,

        all: [BundleStrategies.Standard, BundleStrategies.Channels, BundleStrategies.ChannelsAndLibs],

        fromValue: function fromValue(name) {
            return find(this.all, function (item) {
                return item.name === name;
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var Breakpoint = __webpack_require__(372);

    var SMALL = "Small";
    var MEDIUM = "Medium";
    var LARGE = "Large";

    /**
     * Collection of <tt>Breakpoint</tt>'s.
     *
     * @class BreakpointCollection
     */
    return Backbone.Collection.extend({

        model: Breakpoint,

        comparator: function comparator(breakpoint) {
            return breakpoint.get("threshold");
        },


        /**
         * Whether the specified threshold matches any of the contained breakpoints.
         *
         * @param  {Number} threshold The threshold value.
         * @return {Boolean}          <tt>true</tt> if the specified threshold matches any of the contained breakpoints.
         */
        containsThreshold: function containsThreshold(threshold) {
            return !!this.findWhere({ threshold: threshold });
        },
        getThresholds: function getThresholds() {
            return this.map(function (breakpoint) {
                return breakpoint.get("threshold");
            });
        },


        /**
         * Get all lower bounds of the configured breakpoints.
         * @returns {Breakpoint[]}  An array of breakpoints including the 0 threshold
         */
        getLowerBounds: function getLowerBounds() {
            return [new Breakpoint({ threshold: 0 })].concat(this.models);
        },


        /**
         * Generate naming for breakpoint intervals. Support unlimited number of breakpoints.
         *
         * 1 breakpoint / 2 intervals: [Small, Large]
         * 2 breakpoints / 3 intervals: [Small, Medium, Large]          <-- Default
         * 3 breakpoints / 4 intervals: [XSmall, Small, Medium, Large]
         * 4 breakpoints / 5 intervals: [XSmall, Small, Medium, Large, XLarge]
         * 5 breakpoints / 6 intervals: [XXSmall, XSmall, Small, Medium, Large, XLarge]
         * etc.
         *
         * @param {Number} length The total number of breakpoints.
         * @returns {String[]} naming Array of denotations for each interval.
         */
        generateNaming: function generateNaming(length) {
            var breakpointCount = length || this.length;
            var naming = [];

            switch (breakpointCount) {
                case 0:
                    {
                        naming = [];
                        break;
                    }

                case 1:
                    {
                        naming = [SMALL, LARGE];
                        break;
                    }

                default:
                    {
                        naming = [SMALL, MEDIUM, LARGE];

                        var prefix = "X";
                        var remainCount = breakpointCount - 2;

                        for (var i = 0; i < remainCount; i += 2) {
                            naming.unshift(prefix + "S");

                            if (i + 1 < remainCount) {
                                naming.push(prefix + "L");
                            }

                            prefix = "X" + prefix;
                        }

                        break;
                    }
            }

            return naming;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ImprovedModel = __webpack_require__(25);

    var SalesforceCommerceFiltersModel = ImprovedModel.extend("SalesforceCommerceFiltersModel", {
        defaults: {
            name: true,
            productID: true,
            price: true,
            availability: false,
            brand: true,
            description: false
        }
    }),
        SalesforceCommerceSiteModel = ImprovedModel.extend("SalesforceCommerceSiteModel", {
        embedded: true,

        defaults: {
            siteId: ""
        },

        updateOnSync: function updateOnSync(options) {
            if (options.sync === "save") {
                return ["id"];
            }
        }
    }),
        SalesforceCommerceSitesCollection = Backbone.Collection.extend("SalesforceCommerceSitesCollection", {
        model: SalesforceCommerceSiteModel,

        deepClone: function deepClone() {
            return new SalesforceCommerceSitesCollection(this.toJSON());
        }
    });

    /**
     * Model representing metadata about the SalesforceCommerce settings.
     *
     * @class SalesforceCommerceSettingsModel
     * @constructor
     */
    return ImprovedModel.extend("SalesforceCommerceSettingsModel", {

        /**
         * @type {SalesforceCommerceFiltersModel}
         * Filters are an object that determines whatever the user will be able to see or not in the SalesforceCommerce widget.
         */
        relations: [{
            type: Backbone.One,
            key: "filters",
            relatedModel: SalesforceCommerceFiltersModel
        }, {
            type: Backbone.Many,
            key: "sites",
            collectionType: SalesforceCommerceSitesCollection
        }],

        defaults: {

            /**
             * Enables or disables the SalesforceCommerce widget/QuickView.
             *
             * @type {boolean}
             */
            enabled: false,

            /**
             * The absolute address for the SalesforceCommerce API.
             *
             * @example http://salesforcecommerce.zmags.com/dw/shop/v15_1/
             * @type {String}
             */
            webApiUrl: "",

            /**
             * The friendly url provided by the user.
             *
             * @example salesforcecommerce.zmags.com
             * @type {String}
             */
            userUrl: "",

            /**
             * The SalesforceCommerce clientId code.
             *
             * @type {String}
             */
            clientId: "",

            /**
             * All the SalesforceCommerce sites that customers can set up in SalesforceCommerce.
             *
             * @type {String[]}
             */
            sites: [],

            /**
             * The filters of the SalesforceCommerce widget.
             *
             * @type {SalesforceCommerceFiltersModel}
             */
            filters: new SalesforceCommerceFiltersModel()
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);

    var _require = __webpack_require__(1),
        bindAll = _require.bindAll;

    var formatResultTemplate = __webpack_require__(2097);
    var formatSelectionTemplate = __webpack_require__(2098);
    var SocialSharingWidgetViewController = __webpack_require__(2099);
    var SocialSharingWidgetView = __webpack_require__(516);

    var _require2 = __webpack_require__(517),
        ACTUAL_NETWORKS = _require2.ACTUAL_NETWORKS;

    var KeyCode = __webpack_require__(88);

    var CONTAINER_WIDTH = 205;

    /**
     * The Mixin rendering a social sharing widget when in the Editor.
     *
     * @class SocialSharingWidgetView
     *
     * @cfg {SocialSharingWidgetModel} model The model of the social sharing icon being rendered.
     */
    return SocialSharingWidgetView.mixin({

        _containerShare: null,

        controller: SocialSharingWidgetViewController,

        events: {
            "change": "_changeEditorSelectionHandler",
            "dragstart": "_dragStartHandler"
        },

        initialize: function initialize() {
            bindAll(this, "_keyUpHandler", "_select2OpenHandler");
        },
        updateRendering: function updateRendering(element, bounds, active, edited) {
            if (!edited) {
                // For preview we want to call the Viewer logic
                return this.__super();
            }

            element.empty();

            element.append(this._buildDropdown());
        },
        _changeEditorSelectionHandler: function _changeEditorSelectionHandler(event) {
            this.trigger("changeEditorSelect", event);
        },


        /**
         *  This is needed because otherwise social icons images would be draggable in the Editor.
         * @returns {boolean}
         * @private
         */
        _dragStartHandler: function _dragStartHandler() {
            return false;
        },


        /**
         * Builds the Select2 dropdown for the Editor.
         * @returns {JQuery} JQuery object containing select2 container
         * @private
         */
        _buildDropdown: function _buildDropdown() {
            var _this = this;

            var networksModel = this.model.get("networks");
            var networks = networksModel.join();
            var containerWidth = networksModel.length < 5 ? CONTAINER_WIDTH - 38 : CONTAINER_WIDTH;

            var $input = $("<input>", {
                type: "hidden",
                "class": "select2-field",
                value: networks
            });
            var $containerShare = $("<div>", {
                "class": "container-share",
                html: $input
            });

            $input.select2({
                width: containerWidth,
                tags: ACTUAL_NETWORKS,

                // Prevents inserting characters in the select component.
                maximumInputLength: 0,

                formatResult: function formatResult(state) {
                    return formatResultTemplate({
                        style: _this.model.get("style"),
                        state: state
                    });
                },

                formatSelection: function formatSelection(state) {
                    return formatSelectionTemplate({
                        style: _this.model.get("style"),
                        state: state
                    });
                },

                // Prevents on creating new tags.
                createSearchChoice: function createSearchChoice() {
                    return null;
                }
            });

            // Handles the deletion of the widget, including when the drop-down in the Editor is open.
            $containerShare.on("keyup", this._keyUpHandler);

            // Removes the search field when all networks have already been selected
            $containerShare.on("select2-open", this._select2OpenHandler);

            this._containerShare = $containerShare;

            return $containerShare;
        },
        onClose: function onClose() {
            if (this._containerShare) {
                this._containerShare.off("keyup", this._keyUpHandler);
                this._containerShare.off("select2-open", this._select2OpenHandler);
            }
        },
        _keyUpHandler: function _keyUpHandler(event) {
            if (event.keyCode === KeyCode.DELETE || event.keyCode === KeyCode.BACK_SPACE) {
                var $mask = $("#select2-drop-mask");

                if ($mask.length) {
                    $mask.trigger("click");
                }
            }
        },
        _select2OpenHandler: function _select2OpenHandler() {
            var $drop = $(".select2-drop");
            var unselectedItems = $drop.find("li:not(.select2-selected)");

            if ($drop.length) {
                var currentLayerAndSceneWidgets = this.options.viewModel.get("activeLayerSceneModel");

                var isInActiveSceneAndLayer = Boolean(currentLayerAndSceneWidgets.get(this.model));

                var socialWidgetHasAllIconsSelectedAlready = !unselectedItems.length;
                var shouldNotShowDropdown = socialWidgetHasAllIconsSelectedAlready || !isInActiveSceneAndLayer;
                if (shouldNotShowDropdown) {
                    $drop.hide();
                    $(".select2-search-field").hide();
                }
            }
        },


        /**
         * This method is extends and changes the highlight
         * of the widget astract method `_updateHightlight`
         */
        applyWidgetSpecificHighlight: function applyWidgetSpecificHighlight() {
            // Highlight widget if required
            if (this.model.get("highlighted")) {
                this.$el.css({
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "inset 0px 0px 0px 3px #8c01ff"
                });
            } else if (!this.model.get("boxShadow")) {
                this.$el.css({
                    boxShadow: "inset 0px 0px 0px 0px transparent"
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2097 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class=\'network-container\'>\n    <img class=\'network-editor-icon sharing ' +
__e( style ) +
' ' +
__e( state.id ) +
'\'>\n    <span class=\'network-label\'>' +
__e( state.text ) +
'</span>\n</span>\n';

}
return __p
}

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span class=\'network-container\'>\n    <div class=\'network-editor-icon sharing ' +
__e( style ) +
' ' +
__e( state.id ) +
'\'></div>\n</span>\n';

}
return __p
}

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ViewController = __webpack_require__(126),
        Storage = __webpack_require__(34),
        GeneralFunctions = __webpack_require__(193),
        _ = __webpack_require__(1);

    /**
     * The view rendering a social sharing widget.
     *
     * @class SocialSharingWidgetView
     *
     * @cfg {SocialSharingWidgetModel} model The model of the social sharing icon being rendered.
     */
    return ViewController.extend({

        onInitialize: function onInitialize() {
            this.listenTo(this.model, "change:style change:networks", function (model) {
                this._updateLastUsedProperties(model);
            });
        },

        /**
         * Updates the last used properties in relation to order choice (networks) and selected style.
         * @param {Object} model - The changed model.
         */
        _updateLastUsedProperties: function _updateLastUsedProperties(model) {
            if (model.changed) {
                var lastUsedProperties = _.pick(model.changed, "style", "networks");

                if (_.isEmpty(lastUsedProperties)) {
                    return;
                }

                Storage.Local.update(Storage.Keys.LAST_USED_SOCIAL_PROPERTIES, GeneralFunctions.compactObject(lastUsedProperties));
            }
        },

        /**
         * Handles add and removes of social networks from the Editor.
         * @param {object} event - the current event.
         */
        onViewChangeEditorSelect: function onViewChangeEditorSelect(event) {
            var networks;

            if (event.added) {
                networks = _.clone(this.model.get("networks"));
                networks.push(event.added.id);

                this.model.set("networks", networks);
            } else if (event.removed) {
                networks = this.model.get("networks");
                var id = event.removed.id;

                if (_.contains(networks, id)) {
                    // _.without returns a clone networks.
                    this.model.set("networks", _.without(networks, id));
                }
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetView = __webpack_require__(61);
    var TextWidgetView = __webpack_require__(369);
    var WebFontsUtil = __webpack_require__(136);

    /**
     * Mixin the editor related logic for the <tt>TextWidgetView</tt>.
     *
     * @see  TextWidgetView
     */
    return TextWidgetView.mixin("TextWidgetViewEditorMixin", {

        modelEvents: {
            // renders are being prevented (see TextEditorController#saveModel) when editing a text
            // widget, however for text widget views (say, a representation of the an overlay on
            // another scene) it does need to update.
            // TODO: Method should be defined as a class method and called by a string to follow the style guide and for better readability,
            // but this causes the scope to be removed, possibly related to using mixins
            "content:updated": function contentUpdated() {
                var isBeingEdited = this.$el.attr("contenteditable") === "true";

                if (!isBeingEdited) {
                    this.render();
                }
            }
        },

        initialize: function initialize() {
            var _this = this;

            this.__super();
            this.listenTo(this, "update", function () {
                _this.ieFontHack();
            });
        },
        updateRendering: function updateRendering() {
            this.__super();
            this.ieFontHack();
        },
        onRender: function onRender() {
            this.contentCompatibilityCheck();
            WebFontsUtil.fontCompatibilityCheck(this.model);

            var onRender = AbstractWidgetView.prototype.onRender;

            if (onRender) {
                onRender.apply(this, _.toArray(arguments));
            }
        },
        onShow: function onShow() {
            var _this2 = this;

            this.__super();

            // Since abstractView defers, we also need to defer this in order to get correct width
            _.defer(function () {
                // Runs after showView, so that we can get correct width
                _this2.widthCompatibilityCheck();
            });
        },


        /**
         * Old widgets uses \n to break line, whereas new widgets need <br>
         */
        contentCompatibilityCheck: function contentCompatibilityCheck() {
            this.model.set("text", this.model.get("text").replace("\n", "<br/>"));
        },
        widthCompatibilityCheck: function widthCompatibilityCheck() {
            // Add width for the old experiences
            if (!this.model.has("width")) {
                var unscaledExperienceSize = this._experienceSize();

                var width = this.$el.width();

                if (width) {
                    // Legacy text widgets are rendered using different CSS
                    // settings and different fonts have different widths in
                    // different browsers. For this reason we give it some
                    // buffering to work with.
                    width += 10;

                    // Silently update the width (avoid re-rendering) and make sure to recompute any
                    // affected computed properties (hint: scaledWidth)
                    this.model.set({ width: width / unscaledExperienceSize.width * 100 }, { silent: true });
                    this.model.invalidateComputedProperties("width", true);
                }
            }
        },


        /**
         * This method is extends and changes the highlight
         * of the widget astract method `_updateHightlight`
         */
        applyWidgetSpecificHighlight: function applyWidgetSpecificHighlight() {
            // Highlight widget if required
            if (this.model.get("highlighted")) {
                this.$el.css({
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "inset 0px 0px 0px 3px #8c01ff"
                });
            } else if (!this.model.get("boxShadow")) {
                this.$el.css({
                    boxShadow: "inset 0px 0px 0px 0px transparent"
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetView = __webpack_require__(61);
    var TextWidgetView = __webpack_require__(518);
    var Marionette = __webpack_require__(10);
    var ReactBridge = __webpack_require__(137);
    var TextEnhancedWidget = __webpack_require__(2102).default;

    var _require = __webpack_require__(504),
        ETW_IS_READY = _require.ETW_IS_READY;

    var EditorWebFontController = __webpack_require__(176);
    var CharacterPropertiesViewControllerHelpers = __webpack_require__(408);
    var NotificationBar = __webpack_require__(53);

    var EnhancedTextWidgetLayout = Marionette.Layout.extend({

        template: function template() {
            return "<div class=\"text\"></div>";
        },

        regions: {
            "text": ".text"
        }

    });

    /**
     * Mixin the editor related logic for the <tt>TextWidgetView</tt>.
     *
     * @see  TextWidgetView
     */
    return TextWidgetView.mixin("TextWidgetViewEditorMixin", {
        initialize: function initialize() {
            var _this = this;

            // this is kind of hack
            // for some reason ReactBridge observer do not listen changes from experience model
            // so just trigger change
            this.listenTo(this.options.viewModel.get("experience"), "change:emailModeEnabled", function () {
                _this.model.trigger("forceWidgetUpdate");
            });
        },


        _layout: null,

        className: AbstractWidgetView.prototype.className + " text-enhanced",

        // This gives us access to the proper this context
        getPropsFromView: function getPropsFromView(self) {
            return {
                onChange: function onChange(data, fontFamilies, rawText) {
                    // Using self as an argument is the only way we can access the proper context.
                    self.textEditorController._textWidgetModel.set({
                        text: data,
                        fontFamilies: fontFamilies,
                        rawText: rawText
                    }, { render: false, shouldUpdateTabOrder: false });
                },
                onSelect: function onSelect(event) {
                    var options = self.options;
                    // For some reason the selection is not updated to reflect the state of the editor surface.

                    var selectedWidgets = options.viewModel.selection.get("widgets");
                    var singleSelection = selectedWidgets.length < 2; // Not a group selection
                    var modifierKeyDown = event.shiftKey || event.ctrlKey || event.metaKey; // Same keys as in FreeTransform.js#down

                    if (singleSelection) {
                        if (modifierKeyDown) {
                            var newSelectedWidgets = _.uniq([self].concat(selectedWidgets));
                            options.viewModel.selection.select(newSelectedWidgets);
                        } else {
                            options.viewModel.selection.select([self]);
                        }

                        self.model.trigger("forceWidgetUpdate");
                    }
                },
                onDeselect: function onDeselect(hasText) {
                    if (!hasText) {
                        self.options.model.destroy();
                    }
                },
                onReady: function onReady() {
                    self.options.viewModel.trigger(ETW_IS_READY);
                },
                onShowNotification: function onShowNotification(msg) {
                    var closeDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;

                    NotificationBar.open(msg, { closeDelay: closeDelay });
                }
            };
        },

        modelEvents: {
            // renders are being prevented (see TextEditorController#saveModel) when editing a text
            // widget, however for text widget views (say, a representation of the an overlay on
            // another scene) it does need to update.
            // TODO: Method should be defined as a class method and called by a string to follow the style guide and for better readability,
            // but this causes the scope to be removed, possibly related to using mixins
            "content:updated": function contentUpdated() {
                var isBeingEdited = this.$el.attr("contenteditable") === "true";

                if (!isBeingEdited) {
                    this.render();
                }
            }
        },

        onRender: function onRender() {
            this.contentCompatibilityCheck();

            var onRender = AbstractWidgetView.prototype.onRender;

            if (onRender) {
                onRender.apply(this, _.toArray(arguments));
            }
        },
        onShow: function onShow() {
            var _this2 = this;

            this.__super();

            // Since abstractView defers, we also need to defer this in order to get correct width
            _.defer(function () {
                // Runs after showView, so that we can get correct width
                _this2.widthCompatibilityCheck();
            });
        },


        /**
         * Old widgets uses \n to break line, whereas new widgets need <br>
         */
        contentCompatibilityCheck: function contentCompatibilityCheck() {
            this.model.set("text", this.model.get("text").replace("\n", "<br/>"));
        },
        widthCompatibilityCheck: function widthCompatibilityCheck() {
            // Add width for the old experiences
            if (!this.model.has("width")) {
                var unscaledExperienceSize = this._experienceSize();

                var width = this.$el.width();

                if (width) {
                    // Legacy text widgets are rendered using different CSS
                    // settings and different fonts have different widths in
                    // different browsers. For this reason we give it some
                    // buffering to work with.
                    width += 10;

                    // Silently update the width (avoid re-rendering) and make sure to recompute any
                    // affected computed properties (hint: scaledWidth)
                    this.model.set({ width: width / unscaledExperienceSize.width * 100 }, { silent: true });
                    this.model.invalidateComputedProperties("width", true);
                }
            }
        },
        showView: function showView() {
            var _this3 = this;

            var rect = this.el.getBoundingClientRect();
            var invalidElement = rect.height === 0 && rect.width === 0;
            if (invalidElement) {
                // The Dynamic Product Widget is creating extra DOM nodes that can cause problems here.
                // The unwanted nodes have 0 for all properties in boundingClientRect.
                // Given that, we may reject the view if the element is invalid.
                return;
            }
            this.__super();
            EditorWebFontController.promise().then(function (results) {
                CharacterPropertiesViewControllerHelpers._fontCollection = results;
                CharacterPropertiesViewControllerHelpers._fontSelectorQuery({
                    callback: function callback(fonts) {
                        _this3._layout = new EnhancedTextWidgetLayout({ el: _this3.$el });
                        _this3._layout.render();

                        var scopedGetProps = function scopedGetProps(_ref) {
                            var model = _ref.model,
                                selection = _ref.selection,
                                viewModel = _ref.viewModel,
                                parentScene = _ref.parentScene;

                            var selectionWidgets = selection && selection.get("widgets");
                            var viewModelSceneNumber = viewModel && viewModel.get("sceneNumber");
                            var parentSceneNumber = parentScene && parentScene.get("sceneNumber");
                            var isEmailMode = viewModel && viewModel.get("experience").get("emailModeEnabled");
                            var isWidgetInActiveScene = viewModelSceneNumber === parentSceneNumber;
                            return {
                                text: model.get("text"),
                                isSelected: isWidgetInActiveScene && selectionWidgets.some(function (widget) {
                                    return widget.model === model;
                                }),
                                readOnly: selection.isMultiple() || !isWidgetInActiveScene || model.get("isLocked"),
                                isTransforming: model.get("isTransforming"),
                                fonts: fonts,
                                uuid: model.get("uuid"),
                                hasAction: Boolean(model.get("action")),
                                isEmailMode: Boolean(isEmailMode)
                            };
                        };

                        var textEnhancedWidgetView = ReactBridge.viewFromComponent(TextEnhancedWidget, {
                            model: _this3.model,

                            viewModel: _this3.options.viewModel,

                            selection: _this3.options.viewModel.selection,

                            parentScene: _this3.parentView.scene || _this3.parentView.model.get("scene"),

                            observe: {
                                model: "change forceWidgetUpdate",
                                viewModel: "change",
                                selection: "change",
                                parentScene: "change"
                            },

                            // Passing in this so I have a reference to the backbone class.
                            props: _this3.getPropsFromView(_this3),

                            // The arguments here are from ReactBridge and NOT specifically our code.
                            // This is the model specified in the config object.
                            getProps: scopedGetProps
                        });

                        _this3._layout.text.show(textEnhancedWidgetView);
                    }
                });
            });
        },
        onClose: function onClose() {
            if (this._layout) {
                this._layout.close();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextEnhancedWidget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextEnhancedWidget", function() { return TextEnhancedWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_portal__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_util_Color__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_util_Color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_shared_util_Color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utility__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TextEditorControls__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TextEditor__ = __webpack_require__(2724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_draft_js_utils__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__editor_ui_experience_widgets_CharacterPropertiesViewControllerHelpers__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__editor_ui_experience_widgets_CharacterPropertiesViewControllerHelpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__editor_ui_experience_widgets_CharacterPropertiesViewControllerHelpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fonts_WebFontsUtil__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fonts_WebFontsUtil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__fonts_WebFontsUtil__);















// Valid font-family values can only contain letters and spaces unless they are quoted.
// For reference https://developer.mozilla.org/en-US/docs/Web/CSS/font-family and search for the heading
// "Valid family names".  So we are quoting font families, normalizing names and trimming from unnecessary whitespaces.
// Example: input font family name "Lucida Sans Unicode, Lucida Grande,sans-serif"
// output: ""lucida sans unicode","lucida grande","sans-serif""
var getNormalizedFontFamiliesName = function (rawFontFamily) {
    var fontFamilies = rawFontFamily
        .replace("\"", "")
        .replace("\"", "")
        .toLowerCase()
        .split(",");
    var normalizedFontFamilies = "";
    for (var index = 0; index < fontFamilies.length; index++) {
        var familyName = fontFamilies[index];
        var doubleQuotedName = "";
        if (/^\s/.test(familyName)) {
            var whiteSpacesStartsWith = familyName.match(/\s+/);
            doubleQuotedName = doubleQuotedName.concat("\"", familyName.replace(whiteSpacesStartsWith[0], ""), "\"");
        }
        else {
            doubleQuotedName = doubleQuotedName.concat("\"", familyName, "\"");
        }
        if (index === 0) {
            normalizedFontFamilies = normalizedFontFamilies.concat(doubleQuotedName);
        }
        else {
            normalizedFontFamilies = normalizedFontFamilies.concat(",", doubleQuotedName);
        }
    }
    return normalizedFontFamilies;
};
var getSelectionFontFamily = function (editorState, fontFamily) {
    if (fontFamily === void 0) { fontFamily = "arial"; }
    var rawFontFamily = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontFamily.current(editorState);
    // There is some strange behavior with fonts that have spaces in their family name. The string value contains
    // quotes like this '"Times New Roman"'
    return rawFontFamily && rawFontFamily.length ?
        rawFontFamily.split("\"").join("") : fontFamily;
};
var getFontFamilyOption = function (targetFontFamily, fontFamilyOptions) {
    var normalizedTargetFontFamily = getNormalizedFontFamiliesName(targetFontFamily);
    var targetFontOption = undefined;
    fontFamilyOptions.filter(function (item) { return !!item; }).forEach(function (fontGroup) {
        if (!targetFontOption) {
            targetFontOption = fontGroup.options.find(function (fontOptionItem) {
                // We should also support already created experiences, with ETW inside,
                // where fontFamilyName has been used instead of cssFamilyNames
                var normalizedFontFamily = getNormalizedFontFamiliesName(fontOptionItem.value);
                var normalizedCssFamily = getNormalizedFontFamiliesName(fontOptionItem.fontDescriptor.get("cssFamily"));
                return (normalizedCssFamily === normalizedTargetFontFamily)
                    || (normalizedFontFamily === normalizedTargetFontFamily);
            });
        }
    });
    return targetFontOption;
};
var getFontFamilyData = function (selectedFontOption, fontStyle, fontWeight) {
    return __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].getFontFamilyProviderMetaData(selectedFontOption, fontStyle, fontWeight);
};
var findFontDescriptorData = function (fontFamily) { return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_13__editor_ui_experience_widgets_CharacterPropertiesViewControllerHelpers__["_fontSelectorQuery"]({
        term: fontFamily,
        callback: function (fontResults) {
            var currentOption = null;
            var fontResultsLength = fontResults.results.length;
            for (var i = 0; i < fontResultsLength; i++) {
                var currentFontFamilyOption = fontResults.results[i].children.find(function (fontProviderItem) {
                    return fontProviderItem.text.toLocaleLowerCase() === fontFamily.toLocaleLowerCase();
                });
                if (currentFontFamilyOption) {
                    currentOption = currentFontFamilyOption;
                    break;
                }
            }
            resolve(currentOption);
        }
    });
}); };
var findFontsDescriptors = function (fontFamilies) {
    return Promise.all(fontFamilies.map(findFontDescriptorData));
};
function findLinkEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        if (entityKey !== null) {
            var entity = contentState.getEntity(entityKey);
            return entity.getType() === __WEBPACK_IMPORTED_MODULE_8__models__["d" /* FONT_METADATA */] && !!entity.getData().url;
        }
        return false;
    }, callback);
}
var linkDecorator = new __WEBPACK_IMPORTED_MODULE_3_draft_js__["CompositeDecorator"]([
    {
        strategy: findLinkEntities,
        component: function (props) {
            var _a = props.contentState.getEntity(props.entityKey).getData(), url = _a.url, target = _a.target;
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: url, target: target, className: "zmgs-anchor", style: __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].link, rel: "noopener noreferrer" }, props.children));
        },
    },
]);
// This is used with require syntax so usage is not detected.
// noinspection JSUnusedGlobalSymbols
var TextEnhancedWidget = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TextEnhancedWidget, _super);
    function TextEnhancedWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.setRef = function (ref) {
            _this.editorRef = ref;
        };
        _this.deriveStyleOverrides = function (_a) {
            var fontSize = _a.fontSize, fontColor = _a.fontColor, fontFamilyData = _a.fontFamilyData, fontStyle = _a.fontStyle, fontWeight = _a.fontWeight;
            var dummyEditorState = __WEBPACK_IMPORTED_MODULE_3_draft_js__["EditorState"].createEmpty();
            var cssFamilyNames = fontFamilyData.cssFamilyNames;
            var parsedFontSize = fontSize + "px";
            dummyEditorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontSize.add(dummyEditorState, parsedFontSize);
            dummyEditorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].color.add(dummyEditorState, __WEBPACK_IMPORTED_MODULE_5_shared_util_Color__["formatRgbaToStyle"](fontColor));
            dummyEditorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontWeight.add(dummyEditorState, fontWeight);
            // We have to manually set fontVariantLigatures to 'none' value
            // for browser correctly handling font-variant
            dummyEditorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontVariantLigatures.add(dummyEditorState, __WEBPACK_IMPORTED_MODULE_8__models__["b" /* DEFAULT_FONT_VARIANT_LIGATURES */]);
            if (fontStyle === "italic" /* ITALIC */) {
                dummyEditorState = __WEBPACK_IMPORTED_MODULE_3_draft_js__["RichUtils"].toggleInlineStyle(dummyEditorState, __WEBPACK_IMPORTED_MODULE_8__models__["c" /* DraftStyles */].ITALIC);
            }
            dummyEditorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontFamily
                .add(dummyEditorState, "" + getNormalizedFontFamiliesName(cssFamilyNames));
            return dummyEditorState.getCurrentInlineStyle();
        };
        _this.applyDraftStyle = function (style, editorState) {
            return __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].applyInlineStyle(editorState, style);
        };
        _this.removeDraftStyle = function (style, editorState) {
            return __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].removeInlineStyle(editorState, style);
        };
        // TODO: Add support for a selection range.
        _this.getSelectionFontWeight = function (editorState) {
            return __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontWeight.current(editorState) || _this.state.fontWeight;
        };
        // TODO: Add support for a selection range.
        _this.getSelectionFontStyle = function (editorState) {
            var hasText = editorState.getCurrentContent().hasText();
            var targetFontStyle = _this.state.fontStyle;
            if (hasText) {
                var currentStyle = editorState.getCurrentInlineStyle();
                targetFontStyle = currentStyle.has(__WEBPACK_IMPORTED_MODULE_8__models__["c" /* DraftStyles */].ITALIC) ? "italic" /* ITALIC */ : "normal" /* NORMAL */;
            }
            return targetFontStyle;
        };
        _this.getUsedFonts = function (editorState) {
            var currentContent = editorState.getCurrentContent();
            var editorStateStyles = Object(__WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["h" /* exporter */])(editorState);
            var entities = [];
            currentContent.getBlockMap().forEach(function (block) {
                var charMetaList = block.getCharacterList();
                var entityPieces = Object(__WEBPACK_IMPORTED_MODULE_12_draft_js_utils__["getEntityRanges"])(block.getText(), charMetaList);
                entityPieces.map(function (_a) {
                    var entityKey = _a[0], stylePieces = _a[1];
                    var entity = entityKey ? currentContent.getEntity(entityKey) : undefined;
                    var entityType = entity ? entity.getType() : undefined;
                    if (entityType === __WEBPACK_IMPORTED_MODULE_8__models__["d" /* FONT_METADATA */]) {
                        var font = entity.getData();
                        if (font.fontFamily) {
                            entities.push(font.fontFamily);
                        }
                        else if (font.url) {
                            stylePieces.forEach(function (_a) {
                                var _text = _a[0], styleList = _a[1];
                                var fontFamilyStyle = styleList
                                    .toJS()
                                    .find(function (entityStyle) { return entityStyle.startsWith(__WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["a" /* CUSTOM_FONT_STRING */]); });
                                if (fontFamilyStyle && editorStateStyles[fontFamilyStyle]) {
                                    var fontFamily = editorStateStyles[fontFamilyStyle].style.fontFamily.split(",")[0];
                                    entities.push(fontFamily);
                                }
                            });
                        }
                    }
                });
            });
            return entities;
        };
        _this.getAllFontsAndMetadata = function (editorState) {
            var fontFamilyOptions = _this.state.fontFamilyOptions;
            var editorStateStyles = Object(__WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["h" /* exporter */])(editorState);
            var currentFont = fontFamilyOptions.find(function (_a) {
                var label = _a.label;
                return label === "current";
            });
            var currentContent = editorState.getCurrentContent();
            var entities = [];
            currentContent.getBlockMap().forEach(function (block) {
                var charMetaList = block.getCharacterList();
                var entityPieces = Object(__WEBPACK_IMPORTED_MODULE_12_draft_js_utils__["getEntityRanges"])(block.getText(), charMetaList);
                entityPieces.map(function (_a) {
                    var entityKey = _a[0], stylePieces = _a[1];
                    var entity = entityKey ? currentContent.getEntity(entityKey) : null;
                    var entityType = entity == null ? null : entity.getType();
                    if (entityType === __WEBPACK_IMPORTED_MODULE_8__models__["d" /* FONT_METADATA */]) {
                        var font = entity.getData();
                        if (font.fontFamily) {
                            entities.push(__WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].getFontFamilyFromFontMetadataEntity(font));
                        }
                        else if (font.url) {
                            stylePieces.forEach(function (_a) {
                                var _text = _a[0], styleListData = _a[1];
                                var styleList = styleListData.toJS();
                                var fontFamilyStyle = styleList.find(function (entityStyle) { return entityStyle.startsWith(__WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["a" /* CUSTOM_FONT_STRING */]); });
                                var fontWeightStyle = styleList.find(function (entityStyle) { return entityStyle.startsWith(__WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["b" /* CUSTOM_FONT_WEIGHT_STRING */]); });
                                var fontStyleItalic = styleList.find(function (entityStyle) { return entityStyle.toLocaleLowerCase() === "italic"; });
                                var fontFamilyValue = editorStateStyles[fontFamilyStyle] && editorStateStyles[fontFamilyStyle].style.fontFamily.split(",")[0];
                                var fontOption = fontFamilyValue && currentFont.options.find(function (_a) {
                                    var value = _a.value;
                                    return value.toLowerCase() === fontFamilyValue.toLowerCase();
                                });
                                var fontStyle = fontStyleItalic ? "italic" : "normal";
                                var fontWeight = editorStateStyles[fontWeightStyle] && editorStateStyles[fontWeightStyle].style.fontWeight;
                                if (fontOption && fontWeight) {
                                    var font_1 = getFontFamilyData(fontOption, fontStyle, fontWeight);
                                    entities.push(__WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].getFontFamilyFromFontMetadataEntity(font_1));
                                }
                            });
                        }
                    }
                });
            });
            return entities;
        };
        _this.getUniqueFonts = function (editorState) {
            return _this.getUsedFonts(editorState)
                .filter(function (value, index, self) { return self.findIndex(function (item) { return item === value; }) === index; });
        };
        _this.onToggleFontFamily = function (targetFontFamily) {
            var _a = _this.state, fontWeight = _a.fontWeight, fontStyle = _a.fontStyle, editorState = _a.editorState;
            var hasSelectedText = _this.hasSelectedText();
            var updatedEditorState = !hasSelectedText
                ? __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceSelectAll(_this.state.editorState)
                : editorState;
            var targetFontOption = getFontFamilyOption(targetFontFamily, _this.state.fontFamilyOptions);
            var fontStyleOptions = __WEBPACK_IMPORTED_MODULE_14__fonts_WebFontsUtil__["variantsFromFontDescriptor"](targetFontOption.fontDescriptor);
            var currentFontStyleOption = fontStyleOptions.find(function (_a) {
                var weight = _a.weight, style = _a.style;
                return weight === fontWeight && style === fontStyle;
            }) || fontStyleOptions[0];
            var fontFamilyData = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].getFontFamilyProviderMetaData(targetFontOption, currentFontStyleOption.style, currentFontStyleOption.weight);
            var rawFontFamily = fontFamilyData.cssFamilyNames ? fontFamilyData.cssFamilyNames : fontFamilyData.fontFamily;
            var normalizedFontFamily = getNormalizedFontFamiliesName(rawFontFamily);
            updatedEditorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontFamily.add(updatedEditorState, "" + normalizedFontFamily);
            __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.update(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.LAST_USED_TEXT_PROPERTIES, "fontFamily", fontFamilyData.fontFamily);
            if (fontFamilyData) {
                updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].setFontMetaData(updatedEditorState, fontFamilyData);
                var favoriteFonts = __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.get(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.EDITOR, "favoriteFonts", []);
                // Removing the currently selected font from the list.
                favoriteFonts = favoriteFonts.filter(function (item) { return item.fontFamily !== fontFamilyData.fontFamily; });
                // Put the newly selected font towards the beginning.
                favoriteFonts.unshift({
                    fontProvider: fontFamilyData.fontProvider,
                    fontFamily: fontFamilyData.fontFamily
                });
                // Leaving only 5 elements
                favoriteFonts = favoriteFonts.slice(0, 5);
                __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.update(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.EDITOR, "favoriteFonts", favoriteFonts);
                // update style options for a new font
                updatedEditorState = _this.applyFontStyleOptions({
                    editorState: updatedEditorState,
                    fontStyle: fontFamilyData.fontStyle,
                    fontWeight: fontFamilyData.fontWeight
                });
                _this.handleFontFamilyInputChange("");
                _this.setState({
                    fontFamilyData: fontFamilyData,
                    fontStyleOptions: fontStyleOptions,
                    fontWeight: fontFamilyData.fontWeight,
                    fontStyle: fontFamilyData.fontStyle
                }, function () { return _this.onChange({ updatedEditorState: updatedEditorState, blur: !hasSelectedText, targetFontOption: targetFontOption }); });
            }
            if (!hasSelectedText) {
                updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceUnselectAll(updatedEditorState);
            }
        };
        _this.toggleColor = function (color) {
            var cssFormatted = "rgb(" + color.r + "," + color.g + "," + color.b + ")";
            var updatedEditorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].color.add(_this.state.editorState, cssFormatted);
            __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.update(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.LAST_USED_TEXT_PROPERTIES, "color", __WEBPACK_IMPORTED_MODULE_5_shared_util_Color__["formatRgbaToHex"](color));
            return _this.onChange({ updatedEditorState: updatedEditorState });
        };
        _this.applyFontStyleOptions = function (_a) {
            var editorState = _a.editorState, fontStyle = _a.fontStyle, fontWeight = _a.fontWeight;
            var _b = _this.state, currentFontWeight = _b.fontWeight, currentFontStyle = _b.fontStyle;
            if (_this.hasSelectedText()) {
                if (currentFontWeight !== fontWeight) {
                    // We might need to remove the existing font weight
                    editorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontWeight.add(editorState, fontWeight);
                    __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.update(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.LAST_USED_TEXT_PROPERTIES, "fontWeight", fontWeight);
                }
                if (currentFontStyle !== fontStyle) {
                    editorState = __WEBPACK_IMPORTED_MODULE_3_draft_js__["RichUtils"].toggleInlineStyle(editorState, __WEBPACK_IMPORTED_MODULE_8__models__["c" /* DraftStyles */].ITALIC);
                    __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.update(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.LAST_USED_TEXT_PROPERTIES, "fontStyle", fontStyle);
                }
            }
            else {
                editorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontWeight.add(editorState, fontWeight);
                __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.update(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.LAST_USED_TEXT_PROPERTIES, "fontWeight", fontWeight);
                editorState = fontStyle === "italic"
                    ? _this.applyDraftStyle(__WEBPACK_IMPORTED_MODULE_8__models__["c" /* DraftStyles */].ITALIC, editorState)
                    : _this.removeDraftStyle(__WEBPACK_IMPORTED_MODULE_8__models__["c" /* DraftStyles */].ITALIC, editorState);
                __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.update(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.LAST_USED_TEXT_PROPERTIES, "fontStyle", fontStyle);
            }
            return editorState;
        };
        _this.toggleFontStyle = function (fontStyle, fontWeight) {
            // what logic should be if font doesn't have font-style?
            var _a = _this.state, editorState = _a.editorState, currentFontFamilyData = _a.fontFamilyData;
            var hasSelectedText = _this.hasSelectedText();
            var shouldCallOnChange = true;
            var updatedEditorState = !hasSelectedText
                ? __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceSelectAll(editorState)
                : editorState;
            updatedEditorState = _this.applyFontStyleOptions({
                editorState: updatedEditorState,
                fontStyle: fontStyle,
                fontWeight: fontWeight
            });
            var targetFontOption = _this.state.fontFamilyOptions.find(function (item) { return item.label === "current"; });
            if (targetFontOption) {
                var currentFontOption = targetFontOption.options.find(function (_a) {
                    var value = _a.value;
                    return value.toLowerCase() === currentFontFamilyData.fontFamily.toLowerCase();
                });
                var fontFamilyData = getFontFamilyData(currentFontOption, fontStyle, fontWeight);
                if (fontFamilyData) {
                    updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].setFontMetaData(updatedEditorState, fontFamilyData);
                    _this.setState({
                        fontFamilyData: fontFamilyData,
                        fontWeight: fontFamilyData.fontWeight,
                        fontStyle: fontFamilyData.fontStyle
                    }, function () { return _this.onChange({ updatedEditorState: updatedEditorState, blur: !hasSelectedText }); });
                    shouldCallOnChange = false;
                }
            }
            if (!hasSelectedText) {
                updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceUnselectAll(updatedEditorState);
            }
            if (shouldCallOnChange) {
                _this.onChange({ updatedEditorState: updatedEditorState, blur: !hasSelectedText });
            }
        };
        _this.toggleLetterSpacing = function (letterSpacing) {
            var parsedLetterSpacing = letterSpacing.indexOf("px") === -1 ? letterSpacing + "px" : letterSpacing;
            var updatedEditorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].letterSpacing.add(_this.state.editorState, parsedLetterSpacing);
            return _this.onChange({ updatedEditorState: updatedEditorState });
        };
        _this.toggleFontSize = function (fontSize) {
            var updatedEditorState = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontSize.add(_this.state.editorState, fontSize + "px");
            __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.update(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.LAST_USED_TEXT_PROPERTIES, "fontSize", fontSize);
            return _this.onChange({ updatedEditorState: updatedEditorState });
        };
        _this.toggleBlockType = function (draftBlockType) {
            var updatedEditorState = __WEBPACK_IMPORTED_MODULE_3_draft_js__["RichUtils"].toggleBlockType(_this.state.editorState, draftBlockType);
            return _this.onChange({ updatedEditorState: updatedEditorState });
        };
        _this.toggleAlign = function (alignment) {
            var _a;
            var updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].mergeBlockData(_this.state.editorState, (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["d" /* customBlockStyleDataKeys */].textAlign] = alignment,
                _a));
            __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.update(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.LAST_USED_TEXT_PROPERTIES, "textAlign", alignment);
            _this.onChange({ updatedEditorState: updatedEditorState });
        };
        _this.toggleLineHeight = function (lineHeight) {
            var _a;
            var updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].mergeBlockData(_this.state.editorState, (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["d" /* customBlockStyleDataKeys */].lineHeight] = lineHeight,
                _a));
            _this.onChange({ updatedEditorState: updatedEditorState });
        };
        _this.handleFocus = function () {
            if (_this.state.hasFakeHighlight) {
                _this.setState({ hasFakeHighlight: false });
            }
        };
        _this.hasSelectedText = function () { return __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].getSelectionText(_this.state.editorState); };
        _this.handleDeselect = function () {
            _this.handleFontFamilyInputChange("");
            var hasText = _this.state.editorState.getCurrentContent().hasText();
            // we need to unselect all editorState, because when we select ETW next time via drag-to-select,
            // editorState will keep selected text (before unselecting) without highlighting it
            _this.setState(function (_a) {
                var editorState = _a.editorState;
                return ({ editorState: __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceUnselectAll(editorState) });
            }, function () { return _this.editorRef.blur(); });
            _this.props.onDeselect(hasText);
        };
        _this.handleDragContainerMouseDown = function (event) {
            _this.props.onSelect(event);
        };
        _this.handleMouseDown = function () {
            _this.handleFocus();
            var _a = _this.state, editorState = _a.editorState, hasFakeHighlight = _a.hasFakeHighlight;
            // Unfortunately, react-js editor won't fire onChange event
            // at the click in already selected block. So this resets
            // current selection, and call onChange for apply it.
            // Same time, we don't have to reset selection, in case it has fake highlight
            if (!hasFakeHighlight) {
                _this.onChange({ updatedEditorState: __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceFocusBeginning(editorState) });
            }
        };
        _this.handleMouseUp = function (event) {
            var editorState = _this.state.editorState;
            var eventTarget = event.target;
            var hasFocus = eventTarget.tagName.toLowerCase() === "span";
            if (!hasFocus) {
                if (_this.props.isTransforming) {
                    _this.onChange({ updatedEditorState: __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forcePreviousFocus(editorState) });
                }
                else {
                    _this.onChange({ updatedEditorState: __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceFocusEnding(editorState) });
                }
            }
        };
        _this.getLinkState = function (editorState) {
            var contentState = editorState.getCurrentContent();
            var selectionState = editorState.getSelection();
            // no text means no link data
            if (!contentState.hasText())
                return {
                    anchorUrl: "",
                    anchorTarget: __WEBPACK_IMPORTED_MODULE_8__models__["a" /* AnchorTarget */].self,
                    hasSelection: false,
                    selectionHasLink: false
                };
            // identify the start and end points within the selected blocks/paragraphs
            var selectionStartBlockKey = selectionState.getStartKey();
            var selectionEndBlockKey = selectionState.getEndKey();
            var selectionStartOffset = selectionState.getStartOffset();
            var selectionEndOffset = selectionState.getEndOffset();
            var linkEntities = [];
            var currentBlockKey = selectionStartBlockKey;
            var _loop_1 = function () {
                var contentBlock = contentState.getBlockForKey(currentBlockKey);
                contentBlock.findEntityRanges(function (character) {
                    var charEntityKey = character.getEntity();
                    if (charEntityKey) {
                        var entity = contentState.getEntity(charEntityKey);
                        return entity.getType() === __WEBPACK_IMPORTED_MODULE_8__models__["d" /* FONT_METADATA */] && !!entity.getData().url;
                    }
                    return false;
                }, function (start, end) {
                    // filter for link entities overlapping with the selection
                    if (!(currentBlockKey === selectionStartBlockKey && end < selectionStartOffset) &&
                        !(currentBlockKey === selectionEndBlockKey && start > selectionEndOffset)) {
                        linkEntities.push(contentBlock.getEntityAt(start));
                    }
                });
                currentBlockKey = currentBlockKey === selectionEndBlockKey ? null : contentState.getKeyAfter(currentBlockKey);
            };
            // iterate through selected blocks/paragraphs to find links
            while (currentBlockKey) {
                _loop_1();
            }
            // if there are no existing links, use the defaults
            // if there are one or more existing links, load the data from the first link
            var selectionHasLink = linkEntities.length > 0;
            var _a = selectionHasLink ? contentState.getEntity(linkEntities[0]).getData() : {}, _b = _a.url, anchorUrl = _b === void 0 ? "" : _b, _c = _a.target, anchorTarget = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_8__models__["a" /* AnchorTarget */].self : _c;
            return {
                anchorUrl: anchorUrl,
                anchorTarget: anchorTarget,
                hasSelection: !selectionState.isCollapsed(),
                selectionHasLink: selectionHasLink
            };
        };
        _this.onChange = function (_a) {
            var updatedEditorState = _a.updatedEditorState, _b = _a.forceChange, forceChange = _b === void 0 ? false : _b, _c = _a.blur, blur = _c === void 0 ? false : _c, _d = _a.targetFontOption, targetFontOption = _d === void 0 ? null : _d;
            var fontFamilyOptions = _this.state.fontFamilyOptions;
            var currentStyle = updatedEditorState.getCurrentInlineStyle();
            var textDecorations = __WEBPACK_IMPORTED_MODULE_8__models__["e" /* exportedInlineStyleTypes */]
                .filter(function (inlineStyleTypeItem) { return currentStyle.has(inlineStyleTypeItem.draftStyle); })
                .map(function (inlineStyleTypeItem) { return inlineStyleTypeItem.draftStyle; });
            var fontWeight = _this.getSelectionFontWeight(updatedEditorState);
            var fontStyle = _this.getSelectionFontStyle(updatedEditorState);
            var currentFontColor = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].color.current(updatedEditorState);
            var fontColor = !!currentFontColor ? __WEBPACK_IMPORTED_MODULE_5_shared_util_Color__["parseRgba"](currentFontColor) : _this.state.fontColor;
            var fontFamily = getSelectionFontFamily(updatedEditorState, _this.state.fontFamilyData.fontFamily);
            var selectedFontOption = getFontFamilyOption(fontFamily, _this.state.fontFamilyOptions);
            var fontFamilyData = getFontFamilyData(selectedFontOption, fontStyle, fontWeight);
            var fontStyleOptions = __WEBPACK_IMPORTED_MODULE_14__fonts_WebFontsUtil__["variantsFromFontDescriptor"](selectedFontOption.fontDescriptor);
            var linkState = _this.getLinkState(updatedEditorState);
            var currentFontFamilyOption = {
                label: "current",
                options: [selectedFontOption]
            };
            var currentFontFamilyOptions = fontFamilyOptions.find(function (_a) {
                var label = _a.label;
                return label === "current";
            }).options;
            var uniqueFontFamilies = _this.getUniqueFonts(updatedEditorState);
            // in the case when fontFamily was changed, we must add new fontFamily to current font options
            if (targetFontOption) {
                if (uniqueFontFamilies.length > 0) {
                    currentFontFamilyOptions.push(targetFontOption);
                }
                else {
                    currentFontFamilyOptions = [targetFontOption];
                }
            }
            var updatedCurrentFontFamilyOption = {
                label: "current",
                options: uniqueFontFamilies.length > 0
                    ? currentFontFamilyOptions.filter(function (_a) {
                        var value = _a.value;
                        return uniqueFontFamilies.find(function (item) { return item.toLocaleLowerCase() === value.toLowerCase(); });
                    })
                    // when ETW is empty, take only first font option from current fonts
                    : [currentFontFamilyOptions[0]]
            };
            // we need to update "current" fontFamilyOption and its style options due to caret position
            fontFamilyOptions = fontFamilyOptions.filter(function (item) { return !!item; }).map(function (option) { return option.label === "current" ? updatedCurrentFontFamilyOption : option; });
            if (!fontFamilyOptions.find(function (option) { return option.label === "current"; })) {
                fontFamilyOptions = [currentFontFamilyOption].concat(fontFamilyOptions);
            }
            var fontFamilies = _this.getAllFontsAndMetadata(updatedEditorState);
            var fontSizeStyle = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].fontSize.current(updatedEditorState);
            var fontSizeValue = fontSizeStyle && fontSizeStyle.indexOf("px") ? fontSizeStyle.slice(0, -2) : fontSizeStyle;
            var fontSizeNumber = parseInt(fontSizeValue, 10);
            var fontSize = isNaN(fontSizeNumber) ? _this.state.fontSize : fontSizeNumber;
            var currentContent = _this.state.editorState.getCurrentContent();
            var hasMaterialChange = currentContent !== updatedEditorState.getCurrentContent();
            var selectedAlignments = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].getSelectionStylePropertyValues(updatedEditorState, __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["d" /* customBlockStyleDataKeys */].textAlign);
            var selectedLineHeights = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].getSelectionStylePropertyValues(updatedEditorState, __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["d" /* customBlockStyleDataKeys */].lineHeight);
            var rawText = currentContent.getPlainText();
            var currentHtml = _this.state.rawText;
            // TODO: Improve change detection. Specifically filter out the HIGHLIGHT style change.
            if (hasMaterialChange || forceChange) {
                // Only emit html change when we have a change in content
                currentHtml = Object(__WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["i" /* htmlFromEditorState */])(updatedEditorState);
                // Emit the exported HTML and raw text for use in labels
                _this.props.onChange(currentHtml, fontFamilies, rawText);
            }
            _this.setState(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ fontWeight: fontWeight,
                fontStyle: fontStyle,
                fontColor: fontColor,
                fontSize: fontSize, editorState: updatedEditorState, selectedLineHeight: selectedLineHeights[0], selectedAlignment: selectedAlignments[0], textDecorations: textDecorations, rawText: currentHtml, fontFamilyData: fontFamilyData,
                fontFamilyOptions: fontFamilyOptions,
                fontStyleOptions: fontStyleOptions }, linkState), function () {
                if (blur) {
                    _this.editorRef.blur();
                }
            });
        };
        _this.handleToolboxMouseDown = function () {
            if (!_this.state.hasFakeHighlight) {
                _this.setState({ hasFakeHighlight: true });
            }
        };
        _this.updateDraftStyles = function (textDecorators) {
            var previousTextDecorators = _this.state.textDecorations;
            var updatedEditorState = _this.state.editorState;
            // Removing each style one by one then reapplying. May be able to do this in batch
            previousTextDecorators.forEach(function (style) {
                return updatedEditorState = _this.removeDraftStyle(style, updatedEditorState);
            });
            textDecorators.forEach(function (style) { return updatedEditorState = _this.applyDraftStyle(style, updatedEditorState); });
            _this.onChange({ updatedEditorState: updatedEditorState });
        };
        _this.ControlChangeHandler = function (propsDelta, changeSource) {
            switch (changeSource) {
                case 2 /* Alignment */:
                    _this.toggleAlign(propsDelta.alignment);
                    break;
                case 7 /* BlockType */:
                    _this.toggleBlockType(propsDelta.blockType);
                    break;
                case 1 /* Color */:
                    _this.toggleColor(propsDelta.fontColor);
                    break;
                case 0 /* Decoration */:
                    _this.updateDraftStyles(propsDelta.textDecorations);
                    break;
                case 4 /* FontSize */:
                    _this.toggleFontSize(propsDelta.fontSize);
                    break;
                case 5 /* FontStyle */:
                    _this.toggleFontStyle(propsDelta.fontStyle, propsDelta.fontWeight);
                    break;
                case 3 /* LetterSpacing */:
                    _this.toggleLetterSpacing(propsDelta.letterSpacing.toString(10));
                    break;
                case 6 /* LineHeight */:
                    _this.toggleLineHeight(propsDelta.lineHeight.toString(10));
                    break;
                default:
                    break;
            }
        };
        _this.handleFontFamilyInputChange = function (term) {
            __WEBPACK_IMPORTED_MODULE_13__editor_ui_experience_widgets_CharacterPropertiesViewControllerHelpers__["_fontSelectorQuery"]({
                term: term,
                callback: function (fonts) {
                    var fontFamilyOptions = fonts.results.map(function (provider) { return ({
                        label: provider.text,
                        options: provider.children.map(function (fontProvider) { return ({
                            label: fontProvider.text,
                            value: fontProvider.text,
                            fontDescriptor: fontProvider.fontDescriptor
                        }); }),
                    }); });
                    var currentFontFamilyOption = _this.state.fontFamilyOptions.filter(function (item) { return !!item; }).find(function (_a) {
                        var label = _a.label;
                        return label === "current";
                    });
                    if (currentFontFamilyOption) {
                        var nextFontFamilyOptions = [currentFontFamilyOption].concat(fontFamilyOptions).filter(function (item) { return !!item; });
                        _this.setState({ fontFamilyOptions: nextFontFamilyOptions.slice() });
                    }
                }
            });
        };
        _this.calculateState = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
            var _a, text, fonts, updatedEditorState, lastUsed, _b, color, _c, fontSize, _d, fontWeight, _e, fontStyle, _f, textAlign, fontFamily, contentState, fontColor, fontFamilyOptions, currentFontFamily, inlineStyle, isUnformattedText, uniqueFonts, usedFonts, formattedFonts, fontsDescriptors, currentFontFamilyOptions, selectedFontOption, fontStyleOptions, fontFamilyData, selectedLineHeights, currentLineHeight, hasFakeHighlight, selection;
            var _this = this;
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _a = this.props, text = _a.text, fonts = _a.fonts;
                        lastUsed = __WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Local.get(__WEBPACK_IMPORTED_MODULE_11_shared_services_Storage___default.a.Keys.LAST_USED_TEXT_PROPERTIES);
                        _b = lastUsed.color, color = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_9__TextEditorControls__["b" /* textEditorDefaults */].fontColor : _b, _c = lastUsed.fontSize, fontSize = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_9__TextEditorControls__["b" /* textEditorDefaults */].fontSize : _c, _d = lastUsed.fontWeight, fontWeight = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_9__TextEditorControls__["b" /* textEditorDefaults */].fontWeight : _d, _e = lastUsed.fontStyle, fontStyle = _e === void 0 ? __WEBPACK_IMPORTED_MODULE_9__TextEditorControls__["b" /* textEditorDefaults */].fontStyle : _e, _f = lastUsed.textAlign, textAlign = _f === void 0 ? __WEBPACK_IMPORTED_MODULE_9__TextEditorControls__["b" /* textEditorDefaults */].alignment : _f, fontFamily = lastUsed.fontFamily;
                        if (!text || text.length === 0) {
                            updatedEditorState = __WEBPACK_IMPORTED_MODULE_3_draft_js__["EditorState"].createEmpty();
                            updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].setDefaultBlockStyles({ editorState: updatedEditorState, textAlign: textAlign });
                        }
                        else {
                            contentState = Object(__WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["g" /* editorStateFromHtml */])(text).contentState;
                            updatedEditorState = __WEBPACK_IMPORTED_MODULE_3_draft_js__["EditorState"].createWithContent(contentState, linkDecorator);
                        }
                        fontColor = typeof color === "string" ? __WEBPACK_IMPORTED_MODULE_5_shared_util_Color__["parseRgba"](__WEBPACK_IMPORTED_MODULE_5_shared_util_Color__["hexToRgba"](color, "1")) : color;
                        fontFamilyOptions = fonts.results.map(function (provider) { return ({
                            label: provider.text,
                            options: provider.children.map(function (fontProviderItem) { return ({
                                label: fontProviderItem.text,
                                value: fontProviderItem.text,
                                fontDescriptor: fontProviderItem.fontDescriptor,
                            }); })
                        }); }).filter(function (item) { return !!item; });
                        currentFontFamily = getSelectionFontFamily(updatedEditorState, fontFamily);
                        inlineStyle = updatedEditorState.getCurrentInlineStyle();
                        isUnformattedText = updatedEditorState.getCurrentContent().hasText() && inlineStyle.size === 0;
                        if (isUnformattedText) {
                            updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].applyDefaultStyles({
                                editorState: updatedEditorState,
                                fontSize: fontSize,
                                fontColor: fontColor,
                                fontWeight: fontWeight,
                                currentFontFamily: currentFontFamily
                            });
                        }
                        uniqueFonts = this.getUniqueFonts(updatedEditorState);
                        usedFonts = uniqueFonts.length > 0 ? uniqueFonts : [currentFontFamily];
                        formattedFonts = usedFonts.map(function (font) { return font.split(',')[0].replace(/\"/g, ''); });
                        return [4 /*yield*/, findFontsDescriptors(formattedFonts)];
                    case 1:
                        fontsDescriptors = _g.sent();
                        currentFontFamilyOptions = [{
                                label: "current",
                                options: fontsDescriptors.map(function (option) { return ({
                                    label: option.text,
                                    value: option.text,
                                    fontDescriptor: option.fontDescriptor
                                }); }),
                            }];
                        if (currentFontFamilyOptions) {
                            fontFamilyOptions = currentFontFamilyOptions.concat(fontFamilyOptions);
                        }
                        selectedFontOption = getFontFamilyOption(currentFontFamily, fontFamilyOptions);
                        fontStyleOptions = selectedFontOption
                            ? __WEBPACK_IMPORTED_MODULE_14__fonts_WebFontsUtil__["variantsFromFontDescriptor"](selectedFontOption.fontDescriptor)
                            : [];
                        fontFamilyData = getFontFamilyData(selectedFontOption, fontStyle, fontWeight);
                        selectedLineHeights = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].getSelectionStylePropertyValues(updatedEditorState, __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["d" /* customBlockStyleDataKeys */].lineHeight);
                        currentLineHeight = selectedLineHeights && selectedLineHeights.length > 0
                            ? selectedLineHeights[0]
                            : __WEBPACK_IMPORTED_MODULE_9__TextEditorControls__["b" /* textEditorDefaults */].lineHeight;
                        hasFakeHighlight = this.state.isReady ? this.state.hasFakeHighlight : false;
                        if (isUnformattedText) {
                            selection = updatedEditorState.getSelection();
                            // 1) Select value <text>
                            updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceSelectAll(updatedEditorState);
                            // 2) Apply fontProvider Entity
                            updatedEditorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].setFontMetaData(updatedEditorState, fontFamilyData);
                            // 3) Revert back initial selection and focus cursor
                            updatedEditorState = __WEBPACK_IMPORTED_MODULE_3_draft_js__["EditorState"].forceSelection(updatedEditorState, selection);
                        }
                        this.setState({
                            editorState: updatedEditorState,
                            rawText: text,
                            // Setting default values for our state, we'll respond to cursor location change or toolbox change.
                            fontWeight: fontWeight,
                            fontStyle: fontStyle,
                            fontColor: fontColor,
                            fontSize: fontSize,
                            selectedAlignment: "left" /* LEFT */,
                            selectedLineHeight: currentLineHeight,
                            hasFakeHighlight: hasFakeHighlight,
                            textDecorations: [],
                            fontStyleOptions: fontStyleOptions,
                            fontFamilyOptions: fontFamilyOptions,
                            fontFamilyData: fontFamilyData,
                            isReady: true
                        }, function () {
                            if (isUnformattedText) {
                                _this.onChange({ updatedEditorState: updatedEditorState, forceChange: true });
                            }
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onTextEditorChange = function (updatedEditorState) {
            _this.onChange({ updatedEditorState: updatedEditorState });
        };
        _this.handleAnchorUrlChange = function (anchorUrl) {
            _this.setState({ anchorUrl: anchorUrl });
        };
        _this.handleAnchorTargetChange = function (anchorTarget) {
            _this.setState({ anchorTarget: anchorTarget });
        };
        _this.onAnchorAttrsReset = function () {
            var editorState = _this.state.editorState;
            editorState = __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceSelectAll(editorState);
            var selectionHasLink = _this.getLinkState(editorState).selectionHasLink;
            if (selectionHasLink) {
                _this.setState({ editorState: __WEBPACK_IMPORTED_MODULE_3_draft_js__["EditorState"].forceSelection(__WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].setFontMetaData(editorState, { url: '', target: '_self' }, linkDecorator), editorState.getSelection()) }, function () {
                    _this.props.onShowNotification('We have removed actions/animations that are not compatible with email mode from your widgets where applicable');
                    _this.onChange({ updatedEditorState: _this.state.editorState, forceChange: true });
                });
            }
        };
        _this.onAnchorAttrsApply = function (url, target) {
            var editorState = _this.state.editorState;
            _this.setState({ editorState: __WEBPACK_IMPORTED_MODULE_3_draft_js__["EditorState"].forceSelection(__WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].setFontMetaData(editorState, { url: url, target: target }, linkDecorator), editorState.getSelection()) });
        };
        _this.getAppliedUniqueFontStyles = function (editorState, fontOption) {
            return Object(__WEBPACK_IMPORTED_MODULE_4_lodash__["uniqBy"])(_this.getAllFontsAndMetadata(editorState), function (fontItem) { return fontItem[fontOption]; });
        };
        _this.state = {
            rawText: null,
            editorState: null,
            hasFakeHighlight: false,
            textDecorations: null,
            fontWeight: null,
            fontStyle: null,
            fontSize: null,
            fontColor: null,
            fontStyleOptions: null,
            fontFamilyOptions: null,
            fontFamilyData: null,
            isReady: false,
            anchorUrl: "",
            anchorTarget: __WEBPACK_IMPORTED_MODULE_8__models__["a" /* AnchorTarget */].self,
            hasSelection: false,
            selectionHasLink: false
        };
        return _this;
    }
    TextEnhancedWidget.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _this = this;
        var _a = this.props, isSelected = _a.isSelected, text = _a.text, isEmailMode = _a.isEmailMode;
        var _b = this.state, editorState = _b.editorState, rawText = _b.rawText;
        if (isSelected && editorState && prevProps.isSelected !== isSelected && !editorState.getCurrentContent().hasText()) {
            this.setState({
                editorState: __WEBPACK_IMPORTED_MODULE_6__utility__["a" /* DraftJSUtils */].forceFocusBeginning(this.state.editorState),
            });
        }
        if (!isSelected && prevProps.isSelected === true) {
            this.handleDeselect();
        }
        // Update widget state a if raw text state has been changed outside
        if (text && text.length !== 0 && !this.props.isSelected && text !== rawText) {
            this.calculateState();
        }
        if (!prevState.isReady && this.state.isReady) {
            this.props.onReady();
        }
        if (isEmailMode && isEmailMode !== prevProps.isEmailMode) {
            // need to apply all styles before resetting
            this.calculateState().then(function () { return _this.onAnchorAttrsReset(); });
        }
    };
    TextEnhancedWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.calculateState().then(function () {
            if (_this.props.isEmailMode) {
                _this.onAnchorAttrsReset();
            }
        });
    };
    TextEnhancedWidget.prototype.render = function () {
        // for the first render there is no needed data, because we need to accomplish async operation
        // (search for a "current" font)
        if (!this.state.isReady) {
            return null;
        }
        var _a = this.state, editorState = _a.editorState, fontColor = _a.fontColor, fontSize = _a.fontSize, selectedLineHeight = _a.selectedLineHeight, selectedAlignment = _a.selectedAlignment, textDecorations = _a.textDecorations, hasFakeHighlight = _a.hasFakeHighlight, fontFamilyOptions = _a.fontFamilyOptions, anchorUrl = _a.anchorUrl, anchorTarget = _a.anchorTarget, hasSelection = _a.hasSelection, selectionHasLink = _a.selectionHasLink;
        var _b = this.state, fontFamilyData = _b.fontFamilyData, fontStyle = _b.fontStyle, fontWeight = _b.fontWeight, fontStyleOptions = _b.fontStyleOptions;
        var _c = this.props, isEmailMode = _c.isEmailMode, isSelected = _c.isSelected, readOnly = _c.readOnly, uuid = _c.uuid, hasAction = _c.hasAction;
        var styleOverrides = this.deriveStyleOverrides({ fontFamilyData: fontFamilyData, fontColor: fontColor, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight });
        var currentBlockType = __WEBPACK_IMPORTED_MODULE_3_draft_js__["RichUtils"].getCurrentBlockType(editorState);
        var currentLetterSpacing = __WEBPACK_IMPORTED_MODULE_7__editorStateConverters__["j" /* styles */].letterSpacing.current(editorState);
        var portalTarget = document && document.getElementById("character-properties");
        var moveContainerStyles = {
            position: "absolute",
            top: "-10px",
            right: "-10px",
            bottom: "-10px",
            left: "-10px",
            zIndex: -1,
            cursor: "move",
        };
        if (!editorState.getSelection().get("hasFocus") && !this.hasSelectedText()) {
            var uniqueFontFamilies = this.getAppliedUniqueFontStyles(editorState, "fontFamily");
            if (uniqueFontFamilies.length > 1) {
                fontFamilyData = null;
                fontStyle = null;
                fontWeight = null;
                fontStyleOptions = [];
            }
            else {
                var uniqueFontWeights = this.getAppliedUniqueFontStyles(editorState, "fontWeight");
                var uniqueFontStyles = this.getAppliedUniqueFontStyles(editorState, "fontStyle");
                if (uniqueFontWeights.length > 1) {
                    fontWeight = null;
                }
                if (uniqueFontStyles.length > 1) {
                    fontStyle = null;
                }
            }
        }
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            isSelected && portalTarget &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_portal__["a" /* Portal */], { node: portalTarget },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onMouseDown: this.handleToolboxMouseDown },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__TextEditorControls__["a" /* TextEditorControls */], { onChange: this.ControlChangeHandler, textDecorations: textDecorations, alignment: selectedAlignment, blockType: currentBlockType, fontColor: fontColor, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, hasAction: hasAction, letterSpacing: currentLetterSpacing, lineHeight: selectedLineHeight, onMouseDown: this.handleToolboxMouseDown, fontStyleOptions: fontStyleOptions, fontFamilyOptions: fontFamilyOptions, fontProvider: fontFamilyData, anchorUrl: anchorUrl, anchorTarget: anchorTarget, hasSelection: hasSelection, selectionHasLink: selectionHasLink, onFontFamilyInputChange: this.handleFontFamilyInputChange, onToggleFontFamily: this.onToggleFontFamily, onAnchorAttrsApply: this.onAnchorAttrsApply, handleAnchorUrlChange: this.handleAnchorUrlChange, handleAnchorTargetChange: this.handleAnchorTargetChange, isEmailMode: isEmailMode }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onMouseDown: this.handleMouseDown, onMouseUp: this.handleMouseUp, className: "editor-container" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__TextEditor__["a" /* TextEditor */], { readOnly: readOnly, onEditorChange: this.onTextEditorChange, editorState: editorState, hasFakeHighlight: hasFakeHighlight, isSelected: isSelected, styleOverrides: styleOverrides, fontProvider: fontFamilyData, setRef: this.setRef })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "drag-container", "data-contained-widget-uuid": uuid, style: moveContainerStyles, onMouseDown: this.handleDragContainerMouseDown })));
    };
    return TextEnhancedWidget;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
// noinspection JSUnusedGlobalSymbols



/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2104);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* canUseDOM */]) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any
};

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 2104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return canUseDOM; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This file is a fallback for a consumer who is not yet on React 16
// as createPortal was introduced in React 16





var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(this.defaultNode || this.props.node);
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children);
      }

      this.portal = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Portal);


Portal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  node: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PortalCompat__ = __webpack_require__(1029);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var KEYCODES = {
  ESCAPE: 27
};

var PortalWithState = function (_React$Component) {
  _inherits(PortalWithState, _React$Component);

  function PortalWithState(props) {
    _classCallCheck(this, PortalWithState);

    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));

    _this.portalNode = null;
    _this.state = { active: !!props.defaultOpen };
    _this.openPortal = _this.openPortal.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    return _this;
  }

  _createClass(PortalWithState, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.addEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }
      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('click', this.handleOutsideMouseClick);
      }
    }
  }, {
    key: 'openPortal',
    value: function openPortal(e) {
      if (this.state.active) {
        return;
      }
      if (e && e.nativeEvent) {
        e.nativeEvent.stopImmediatePropagation();
      }
      this.setState({ active: true }, this.props.onOpen);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (!this.state.active) {
        return;
      }
      this.setState({ active: false }, this.props.onClose);
    }
  }, {
    key: 'wrapWithPortal',
    value: function wrapWithPortal(children) {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2__PortalCompat__["a" /* default */],
        {
          node: this.props.node,
          key: 'react-portal',
          ref: function ref(portalNode) {
            return _this2.portalNode = portalNode;
          }
        },
        children
      );
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }
      var root = this.portalNode.props.node || this.portalNode.defaultNode;
      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]);

  return PortalWithState;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

PortalWithState.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  node: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  closeOnEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  closeOnOutsideClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

PortalWithState.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};

/* unused harmony default export */ var _unused_webpack_default_export = (PortalWithState);

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AtomicBlockUtils
 * @format
 * 
 */



var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var BlockMapBuilder = __webpack_require__(324);
var CharacterMetadata = __webpack_require__(93);
var ContentBlock = __webpack_require__(217);
var ContentBlockNode = __webpack_require__(111);
var DraftFeatureFlags = __webpack_require__(181);
var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);
var Immutable = __webpack_require__(40);
var SelectionState = __webpack_require__(271);

var generateRandomKey = __webpack_require__(164);
var moveBlockInContentState = __webpack_require__(2122);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');

    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();

    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');

    var charData = CharacterMetadata.create({ entity: entityKey });

    var atomicBlockConfig = {
      key: generateRandomKey(),
      type: 'atomic',
      text: character,
      characterList: List(Repeat(charData, character.length))
    };

    var atomicDividerBlockConfig = {
      key: generateRandomKey(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport) {
      atomicBlockConfig = _extends({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];

    var fragment = BlockMapBuilder.createFromArray(fragmentArray);

    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);

    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'insert-fragment');
  },

  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();

    var withMovedAtomicBlock = void 0;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());

      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');

      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);

        var selectionAfterSplit = afterSplit.getSelectionAfter();
        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });

    return EditorState.push(editorState, newContent, 'move-block');
  }
};

module.exports = AtomicBlockUtils;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftFeatureFlags-core
 * @format
 * 
 */



var DraftFeatureFlags = {
  draft_killswitch_allow_nontextnodes: false,
  draft_segmented_entities_behavior: false,
  draft_handlebeforeinput_composed_text: false,
  draft_tree_data_support: false
};

module.exports = DraftFeatureFlags;

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ContentStateInlineStyle
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(93);

var _require = __webpack_require__(40),
    Map = _require.Map;

var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },

  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;
    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = ContentStateInlineStyle;

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(40);

var applyEntityToContentBlock = __webpack_require__(2111);

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = applyEntityToContentState;

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule applyEntityToContentBlock
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(93);

function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
  var characterList = contentBlock.getCharacterList();
  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
    start++;
  }
  return contentBlock.set('characterList', characterList);
}

module.exports = applyEntityToContentBlock;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getCharacterRemovalRange
 * @format
 * 
 */



var DraftEntitySegments = __webpack_require__(2113);

var getRangesForDraftEntity = __webpack_require__(2114);
var invariant = __webpack_require__(47);

/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */
function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);
  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }
  var newSelectionState = selectionState;
  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }
  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var entity = entityMap.__get(entityKey);
  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end;

  // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.
  if (mutability === 'MUTABLE') {
    return selectionState;
  }

  // Find the entity range that overlaps with our removal range.
  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });

  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;

  var entityRange = entityRanges[0];

  // For `IMMUTABLE` entity types, we will remove the entire entity range.
  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  }

  // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.
  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);

  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

module.exports = getCharacterRemovalRange;

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEntitySegments
 * @format
 * 
 */



/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }
      return segment;
    });

    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length;

      // Our selection overlaps this segment.
      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};

module.exports = DraftEntitySegments;

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangesForDraftEntity
 * @format
 * 
 */



var invariant = __webpack_require__(47);

/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */
function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({ start: start, end: end });
  });

  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;

  return ranges;
}

module.exports = getRangesForDraftEntity;

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertFragmentIntoContentState
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(324);
var ContentBlockNode = __webpack_require__(111);
var Immutable = __webpack_require__(40);

var insertIntoList = __webpack_require__(1032);
var invariant = __webpack_require__(47);
var randomizeBlockMapKeys = __webpack_require__(1030);

var List = Immutable.List;


var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
    data: fragmentBlock.getData()
  });

  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */
var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();

  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};

/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */
var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList();

  // Modify head portion of block.
  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();

  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = [];

  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block
  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    }

    // update the last root block fragment
    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);

    // update the original target next block
    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    }

    // update fragment parent links
    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    });

    // update targetBlock parent child links
    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();

      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;

      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();

      // insert fragment children
      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));

      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());

  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    }

    // Insert fragment blocks after the head and before the tail.
    fragment
    // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    });

    // update tail
    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });

  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();

  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode) {
    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
  }

  // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block
  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

module.exports = insertFragmentIntoContentState;

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule insertTextIntoContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(40);

var insertIntoList = __webpack_require__(1032);
var invariant = __webpack_require__(47);

var Repeat = Immutable.Repeat;


function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;

  var len = text.length;
  if (!len) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();

  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
  });

  var newOffset = offset + len;

  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

module.exports = insertTextIntoContentState;

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule modifyBlockForContentState
 * @format
 * 
 */



var Immutable = __webpack_require__(40);

var Map = Immutable.Map;


function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);

  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = modifyBlockForContentState;

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule removeRangeFromContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(111);
var Immutable = __webpack_require__(40);

var getNextDelimiterBlockKey = __webpack_require__(1033);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */
var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);
  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();
    if (parentKey) {
      parents.push(parentKey);
    }
    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};

/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */
var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);
    nextDelimiters.push(nextDelimiter);

    // we do not need to keep checking all root node siblings, just the first occurance
    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  }

  // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations
  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update endblock if its retained
    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update start block parent ancestors
    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update start block next - can only happen if startBlock == endBlock
    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    });

    // update start block prev
    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
      });
    });

    // update end block next
    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
      });
    });

    // update end block prev
    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    });

    // update end block parent ancestors
    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });

    // update next delimiters all the way to a root delimiter
    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    });
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();

  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey);

  // we assume that ContentBlockNode and ContentBlocks are not mixed together
  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode;

  // used to retain blocks that should not be deleted to avoid orphan children
  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);

    // endBlock has unselected sibblings so we can not remove its ancestors parents
    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    }

    // endBlock has children so can not remove this block or any of its ancestors
    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    }

    // we need to retain all ancestors of the next delimiter block
    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
  }

  var characterList = void 0;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  });

  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });

  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  });

  if (isExperimentalTreeBlock) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};

/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */
var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }
  return targetList;
};

module.exports = removeRangeFromContentState;

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(111);
var Immutable = __webpack_require__(40);

var generateRandomKey = __webpack_require__(164);
var invariant = __webpack_require__(47);

var List = Immutable.List,
    Map = Immutable.Map;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey();

    // update block parent
    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();

      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update original next block
    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    });

    // update original block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    });

    // update below block
    transformBlock(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;

  var key = selectionState.getAnchorKey();
  var offset = selectionState.getAnchorOffset();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;

  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map()
  });

  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;

    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

module.exports = splitBlockInContentState;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EditorBidiService
 * @format
 * 
 */



var Immutable = __webpack_require__(40);
var UnicodeBidiService = __webpack_require__(2121);

var nullthrows = __webpack_require__(130);

var OrderedMap = Immutable.OrderedMap;


var bidiService;

var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};

module.exports = EditorBidiService;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Stateful API for text direction detection
 *
 * This class can be used in applications where you need to detect the
 * direction of a sequence of text blocks, where each direction shall be used
 * as the fallback direction for the next one.
 *
 * NOTE: A default direction, if not provided, is set based on the global
 *       direction, as defined by `UnicodeBidiDirection`.
 *
 * == Example ==
 * ```
 * var UnicodeBidiService = require('UnicodeBidiService');
 *
 * var bidiService = new UnicodeBidiService();
 *
 * ...
 *
 * bidiService.reset();
 * for (var para in paragraphs) {
 *   var dir = bidiService.getDirection(para);
 *   ...
 * }
 * ```
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UnicodeBidi = __webpack_require__(1036);
var UnicodeBidiDirection = __webpack_require__(608);

var invariant = __webpack_require__(47);

var UnicodeBidiService = function () {

  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _classCallCheck(this, UnicodeBidiService);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection.getGlobalDir();
    } else {
      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
    }
    this._defaultDir = defaultDir;
    this.reset();
  }

  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  UnicodeBidiService.prototype.reset = function reset() {
    this._lastDir = this._defaultDir;
  };

  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

module.exports = UnicodeBidiService;

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule moveBlockInContentState
 * @format
 * 
 */



var ContentBlockNode = __webpack_require__(111);
var Immutable = __webpack_require__(40);

var getNextDelimiterBlockKey = __webpack_require__(1033);
var invariant = __webpack_require__(47);

var OrderedMap = Immutable.OrderedMap,
    List = Immutable.List;


var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  }
  // possible values of 'insertionMode' are: 'after', 'before'
  var isInsertedAfterTarget = insertionMode === 'after';

  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();

  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
      });
    });

    // update old prev
    transformBlock(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    });

    // update old next
    transformBlock(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    });

    // update new next
    transformBlock(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });

    // update new prev
    transformBlock(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    });

    // update new parent
    transformBlock(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);

      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;

      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);

      return block.merge({
        children: List(newChildrenArray)
      });
    });

    // update block
    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;

  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();

  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;

  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);

      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);

        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks['delete'](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });

  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);

  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });

  var newBlocks = OrderedMap();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);

    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);

    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;

    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

module.exports = moveBlockInContentState;

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CompositeDraftDecorator
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Immutable = __webpack_require__(40);

var List = Immutable.List;


var DELIMITER = '.';

/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = function () {
  function CompositeDraftDecorator(decorators) {
    _classCallCheck(this, CompositeDraftDecorator);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
      var counter = 0;
      var strategy = decorator.strategy;
      var callback = function callback( /*number*/start, /*number*/end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };
      strategy(block, callback, contentState);
    });

    return List(decorations);
  };

  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();

/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }
  return true;
}

/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */
function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

module.exports = CompositeDraftDecorator;

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditor.react
 * @format
 * 
 * @preventMunge
 */



var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultDraftBlockRenderMap = __webpack_require__(609);
var DefaultDraftInlineStyle = __webpack_require__(1037);
var DraftEditorCompositionHandler = __webpack_require__(2125);
var DraftEditorContents = __webpack_require__(2126);
var DraftEditorDragHandler = __webpack_require__(2148);
var DraftEditorEditHandler = __webpack_require__(2151);
var DraftEditorPlaceholder = __webpack_require__(2184);
var EditorState = __webpack_require__(52);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(28);
var Scroll = __webpack_require__(1041);
var Style = __webpack_require__(613);
var UserAgent = __webpack_require__(145);

var cx = __webpack_require__(272);
var emptyFunction = __webpack_require__(605);
var generateRandomKey = __webpack_require__(164);
var getDefaultKeyBinding = __webpack_require__(1054);
var getScrollPosition = __webpack_require__(614);
var invariant = __webpack_require__(47);
var nullthrows = __webpack_require__(130);

var isIE = UserAgent.isBrowser('IE');

// IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.
var allowSpellCheck = !isIE;

// Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.
var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};

/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */
var DraftEditor = function (_React$Component) {
  _inherits(DraftEditor, _React$Component);

  function DraftEditor(props) {
    _classCallCheck(this, DraftEditor);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.focus = function (scrollPosition) {
      var editorState = _this.props.editorState;

      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = ReactDOM.findDOMNode(_this.editor);

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.focus();

      // Restore scroll position
      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      }

      // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.
      if (!alreadyHasFocus) {
        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
      }
    };

    _this.blur = function () {
      var editorNode = ReactDOM.findDOMNode(_this.editor);
      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.blur();
    };

    _this.setMode = function (mode) {
      _this._handler = handlerMap[mode];
    };

    _this.exitCurrentMode = function () {
      _this.setMode('edit');
    };

    _this.restoreEditorDOM = function (scrollPosition) {
      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
        _this.focus(scrollPosition);
      });
    };

    _this.setClipboard = function (clipboard) {
      _this._clipboard = clipboard;
    };

    _this.getClipboard = function () {
      return _this._clipboard;
    };

    _this.update = function (editorState) {
      _this._latestEditorState = editorState;
      _this.props.onChange(editorState);
    };

    _this.onDragEnter = function () {
      _this._dragCount++;
    };

    _this.onDragLeave = function () {
      _this._dragCount--;
      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    };

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;

    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    // See `restoreEditorDOM()`.
    _this.state = { contentsKey: 0 };
    return _this;
  }

  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  /**
   * Define proxies that can route events to the current handler.
   */


  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];
        method && method(_this2, e);
      }
    };
  };

  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };

      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
    }
    return null;
  };

  DraftEditor.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleFn = _props.customStyleFn,
        customStyleMap = _props.customStyleMap,
        editorState = _props.editorState,
        readOnly = _props.readOnly,
        textAlignment = _props.textAlignment,
        textDirectionality = _props.textDirectionality;


    var rootClass = cx({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });

    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    };

    // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.
    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;

    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      key: 'contents' + this.state.contentsKey,
      textDirectionality: textDirectionality
    };

    return React.createElement(
      'div',
      { className: rootClass },
      this._renderPlaceholder(),
      React.createElement(
        'div',
        {
          className: cx('DraftEditor/editorContainer'),
          ref: function ref(_ref3) {
            return _this3.editorContainer = _ref3;
          } },
        React.createElement(
          'div',
          {
            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
            'aria-controls': readOnly ? null : this.props.ariaControls,
            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
            'aria-expanded': readOnly ? null : ariaExpanded,
            'aria-label': this.props.ariaLabel,
            'aria-labelledby': this.props.ariaLabelledBy,
            'aria-multiline': this.props.ariaMultiline,
            autoCapitalize: this.props.autoCapitalize,
            autoComplete: this.props.autoComplete,
            autoCorrect: this.props.autoCorrect,
            className: cx({
              // Chrome's built-in translation feature mutates the DOM in ways
              // that Draft doesn't expect (ex: adding <font> tags inside
              // DraftEditorLeaf spans) and causes problems. We add notranslate
              // here which makes its autotranslation skip over this subtree.
              notranslate: !readOnly,
              'public/DraftEditor/content': true
            }),
            contentEditable: !readOnly,
            'data-testid': this.props.webDriverTestID,
            onBeforeInput: this._onBeforeInput,
            onBlur: this._onBlur,
            onCompositionEnd: this._onCompositionEnd,
            onCompositionStart: this._onCompositionStart,
            onCopy: this._onCopy,
            onCut: this._onCut,
            onDragEnd: this._onDragEnd,
            onDragEnter: this.onDragEnter,
            onDragLeave: this.onDragLeave,
            onDragOver: this._onDragOver,
            onDragStart: this._onDragStart,
            onDrop: this._onDrop,
            onFocus: this._onFocus,
            onInput: this._onInput,
            onKeyDown: this._onKeyDown,
            onKeyPress: this._onKeyPress,
            onKeyUp: this._onKeyUp,
            onMouseUp: this._onMouseUp,
            onPaste: this._onPaste,
            onSelect: this._onSelect,
            ref: function ref(_ref2) {
              return _this3.editor = _ref2;
            },
            role: readOnly ? null : ariaRole,
            spellCheck: allowSpellCheck && this.props.spellCheck,
            style: contentStyle,
            suppressContentEditableWarning: true,
            tabIndex: this.props.tabIndex },
          React.createElement(DraftEditorContents, editorContentsProps)
        )
      )
    );
  };

  DraftEditor.prototype.componentDidMount = function componentDidMount() {
    this.setMode('edit');

    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */
    if (isIE) {
      document.execCommand('AutoUrlDetect', false, false);
    }
  };

  /**
   * Prevent selection events from affecting the current editor state. This
   * is mostly intended to defend against IE, which fires off `selectionchange`
   * events regardless of whether the selection is set via the browser or
   * programmatically. We only care about selection events that occur because
   * of browser interaction, not re-renders and forced selections.
   */


  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    this._blockSelectEvents = true;
    this._latestEditorState = nextProps.editorState;
  };

  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestCommittedEditorState = this.props.editorState;
  };

  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */


  /**
   * Used via `this.setMode(...)`.
   *
   * Set the behavior mode for the editor component. This switches the current
   * handler module to ensure that DOM events are managed appropriately for
   * the active mode.
   */


  /**
   * Used via `this.restoreEditorDOM()`.
   *
   * Force a complete re-render of the DraftEditorContents based on the current
   * EditorState. This is useful when we know we are going to lose control of
   * the DOM state (cut command, IME) and we want to make sure that
   * reconciliation occurs on a version of the DOM that is synchronized with
   * our EditorState.
   */


  /**
   * Used via `this.setClipboard(...)`.
   *
   * Set the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.getClipboard()`.
   *
   * Retrieve the clipboard state for a cut/copy event.
   */


  /**
   * Used via `this.update(...)`.
   *
   * Propagate a new `EditorState` object to higher-level components. This is
   * the method by which event handlers inform the `DraftEditor` component of
   * state changes. A component that composes a `DraftEditor` **must** provide
   * an `onChange` prop to receive state updates passed along from this
   * function.
   */


  /**
   * Used in conjunction with `onDragLeave()`, by counting the number of times
   * a dragged element enters and leaves the editor (or any of its children),
   * to determine when the dragged element absolutely leaves the editor.
   */


  /**
   * See `onDragEnter()`.
   */


  return DraftEditor;
}(React.Component);

DraftEditor.defaultProps = {
  blockRenderMap: DefaultDraftBlockRenderMap,
  blockRendererFn: emptyFunction.thatReturnsNull,
  blockStyleFn: emptyFunction.thatReturns(''),
  keyBindingFn: getDefaultKeyBinding,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
};


module.exports = DraftEditor;

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorCompositionHandler
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(181);
var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);
var Keys = __webpack_require__(610);

var getEntityKeyForSelection = __webpack_require__(611);
var isEventHandled = __webpack_require__(326);
var isSelectionAtLeafStart = __webpack_require__(1038);

/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */
var RESOLVE_DELAY = 20;

/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */
var resolved = false;
var stillComposing = false;
var textInputData = '';

var DraftEditorCompositionHandler = {
  onBeforeInput: function onBeforeInput(editor, e) {
    textInputData = (textInputData || '') + e.data;
  },

  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);
      editor._onKeyDown(e);
      return;
    }
    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    resolved = true;
    var composedChars = textInputData;
    textInputData = '';

    var editorState = EditorState.set(editor._latestEditorState, {
      inCompositionMode: false
    });

    var currentStyle = editorState.getCurrentInlineStyle();
    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());

    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;

    if (mustReset) {
      editor.restoreEditorDOM();
    }

    editor.exitCurrentMode();

    if (composedChars) {
      if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
        return;
      }
      // If characters have been composed, re-rendering with the update
      // is sufficient to reset the editor.
      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
      return;
    }

    if (mustReset) {
      editor.update(EditorState.set(editorState, {
        nativelyRenderedContent: null,
        forceSelection: true
      }));
    }
  }
};

module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents.react
 * @format
 * 
 */



var DraftEditorContents = __webpack_require__(2127);

module.exports = DraftEditorContents;

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorContents-core.react
 * @format
 * 
 */



var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorBlock = __webpack_require__(1039);
var DraftOffsetKey = __webpack_require__(430);
var EditorState = __webpack_require__(52);
var React = __webpack_require__(0);

var cx = __webpack_require__(272);
var joinClasses = __webpack_require__(2147);
var nullthrows = __webpack_require__(130);

/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth === 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */

var DraftEditorContents = function (_React$Component) {
  _inherits(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    _classCallCheck(this, DraftEditorContents);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;

    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap();

    // Text direction has changed for one or more blocks. We must re-render.
    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();

    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode();

    // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.
    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  DraftEditorContents.prototype.render = function render() {
    var _props = this.props,
        blockRenderMap = _props.blockRenderMap,
        blockRendererFn = _props.blockRendererFn,
        blockStyleFn = _props.blockStyleFn,
        customStyleMap = _props.customStyleMap,
        customStyleFn = _props.customStyleFn,
        editorState = _props.editorState,
        editorKey = _props.editorKey,
        textDirectionality = _props.textDirectionality;


    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());

    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];

    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];
      var key = _block.getKey();
      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;
      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        key: key,
        offsetKey: offsetKey,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };

      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;

      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();
      var className = '';
      if (blockStyleFn) {
        className = blockStyleFn(_block);
      }

      // List items are special snowflakes, since we handle nesting and
      // counters manually.
      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock;
      var childProps = {
        className: className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };
      if (customEditable !== undefined) {
        childProps = _extends({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));

      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }
      lastWrapperTemplate = wrapperTemplate;
    }

    // Group contiguous runs of blocks that have the same wrapperTemplate
    var outputBlocks = [];
    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];
      if (info.wrapperTemplate) {
        var blocks = [];
        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React.createElement(
      'div',
      { 'data-contents': 'true' },
      outputBlocks
    );
  };

  return DraftEditorContents;
}(React.Component);

module.exports = DraftEditorContents;

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorLeaf.react
 * @format
 * 
 */



var _assign = __webpack_require__(73);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftEditorTextNode = __webpack_require__(2129);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(28);

var invariant = __webpack_require__(47);
var setDraftEditorSelection = __webpack_require__(2135);

/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf = function (_React$Component) {
  _inherits(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    _classCallCheck(this, DraftEditorLeaf);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
    var selection = this.props.selection;

    // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _props = this.props,
        block = _props.block,
        start = _props.start,
        text = _props.text;

    var blockKey = block.getKey();
    var end = start + text.length;
    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    }

    // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.
    var node = ReactDOM.findDOMNode(this);
    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
    var child = node.firstChild;
    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
    var targetNode = void 0;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (child.tagName === 'BR') {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
    }

    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };
  /**
   * By making individual leaf instances aware of their context within
   * the text of the editor, we can set our selection range more
   * easily than we could in the non-React world.
   *
   * Note that this depends on our maintaining tight control over the
   * DOM structure of the DraftEditor component. If leaves had multiple
   * text nodes, this would be harder.
   */

  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = ReactDOM.findDOMNode(this.leaf);
    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
  };

  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  DraftEditorLeaf.prototype.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text;

    // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _props2 = this.props,
        customStyleMap = _props2.customStyleMap,
        customStyleFn = _props2.customStyleFn,
        offsetKey = _props2.offsetKey,
        styleSet = _props2.styleSet;

    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return _assign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign(styleObj, newStyles);
    }

    return React.createElement(
      'span',
      {
        'data-offset-key': offsetKey,
        ref: function ref(_ref) {
          return _this2.leaf = _ref;
        },
        style: styleObj },
      React.createElement(
        DraftEditorTextNode,
        null,
        text
      )
    );
  };

  return DraftEditorLeaf;
}(React.Component);

module.exports = DraftEditorLeaf;

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorTextNode.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(28);
var UserAgent = __webpack_require__(145);

var invariant = __webpack_require__(47);

// In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.
var useNewlineChar = UserAgent.isBrowser('IE <= 11');

/**
 * Check whether the node should be considered a newline.
 */
function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}

/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */
var NEWLINE_A = useNewlineChar ? React.createElement(
  'span',
  { key: 'A', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'A', 'data-text': 'true' });

var NEWLINE_B = useNewlineChar ? React.createElement(
  'span',
  { key: 'B', 'data-text': 'true' },
  '\n'
) : React.createElement('br', { key: 'B', 'data-text': 'true' });

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode = function (_React$Component) {
  _inherits(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    _classCallCheck(this, DraftEditorTextNode);

    // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this._forceFlag = false;
    return _this;
  }

  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = ReactDOM.findDOMNode(this);
    var shouldBeNewline = nextProps.children === '';
    !(node instanceof Element) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
    if (shouldBeNewline) {
      return !isNewline(node);
    }
    return node.textContent !== nextProps.children;
  };

  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  DraftEditorTextNode.prototype.render = function render() {
    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
    }
    return React.createElement(
      'span',
      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
      this.props.children
    );
  };

  return DraftEditorTextNode;
}(React.Component);

module.exports = DraftEditorTextNode;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Usage note:
 * This module makes a best effort to export the same data we would internally.
 * At Facebook we use a server-generated module that does the parsing and
 * exports the data for the client to use. We can't rely on a server-side
 * implementation in open source so instead we make use of an open source
 * library to do the heavy lifting and then make some adjustments as necessary.
 * It's likely there will be some differences. Some we can smooth over.
 * Others are going to be harder.
 */



var UAParser = __webpack_require__(2131);

var UNKNOWN = 'Unknown';

var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};

/**
 * Convert from UAParser platform name to what we expect.
 */
function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}

/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */
function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }
  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}

/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */
var parser = new UAParser();
var results = parser.getResult();

// Do some conversion first.
var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};

module.exports = uaData;

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.31
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.31',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 255;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK   = 'Facebook';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /\bqbcore\/([\w\.]+)/i                                              // WeChat Desktop for Windows Built-in Browser
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i                                                      // LieBao Browser
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i                        // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w\.]+) .*(mobile ?safari|safari)/i                     // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2)?)/i                                                     // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i              // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86)/i                              // Android-x86
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(240)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var invariant = __webpack_require__(47);

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;

/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}

/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);

  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];

    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;

    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}

/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */
function checkSimpleExpression(range, version) {
  range = range.trim();
  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);
    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);
    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);
    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);
    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}

/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}

/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}

/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}

/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}

/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}

/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */
function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }
  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);
  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}

/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */
function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;

  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}

/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */
function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}

/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */
function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}

/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */
function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}

/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */
function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();

  zeroPad(a, b.length);

  // mark "x" and "*" components as equal
  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);
    if (matches) {
      b[i] = a[i] = '0';

      // final "*" greedily zeros all remaining components
      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);

  return [a, b];
}

/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}

/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compare(a, b) {
  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}

/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */
function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);
    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};

module.exports = VersionRange;

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */
function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }
  var result = {};
  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }
  return result;
}

module.exports = mapObject;

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setDraftEditorSelection
 * @format
 * 
 */



var DraftJsDebugLogging = __webpack_require__(2136);

var containsNode = __webpack_require__(612);
var getActiveElement = __webpack_require__(1040);
var invariant = __webpack_require__(47);

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);
  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !(anonymized instanceof Element) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
  return anonymized.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();
  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }
  var childNodes = node.childNodes;
  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node;
  while (currentNode) {
    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */
function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  if (!containsNode(document.documentElement, node)) {
    return;
  }

  var selection = global.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward();

  // IE doesn't support backward selection. Swap key/offset pairs.
  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;

  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;

  // If the selection is entirely bound within this node, set the selection
  // and be done.
  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    }

    // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.
    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }

    // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.
    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;

      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}

/**
 * Extend selection towards focus point.
 */
function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement();
  if (selection.extend && containsNode(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.

    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({ offset: offset }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    // logging to catch bug that is being reported in t18110632
    var nodeWasFocus = node === selection.focusNode;
    try {
      selection.extend(node, offset);
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];
          if (n === activeElement) {
            labels.push('active element');
          }
          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }
          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }
          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      });
      // allow the error to be thrown -
      // better than continuing in a broken state
      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    var range = selection.getRangeAt(0);
    range.setEnd(node, offset);
    selection.addRange(range.cloneRange());
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = document.createRange();
  // logging to catch bug that is being reported in t16250795
  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({ offset: offset }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
  }
  range.setStart(node, offset);
  selection.addRange(range);
}

module.exports = setDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftJsDebugLogging
 */



module.exports = {
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(2138);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var camelize = __webpack_require__(2140);
var hyphenate = __webpack_require__(2141);

function asString(value) /*?string*/{
  return value == null ? value : String(value);
}

function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
  var computedStyle = void 0;

  // W3C Standard
  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
  }
  // Safari
  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null);
    // A Safari bug causes this to return null for `display: none` elements.
    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
    if (name === 'display') {
      return 'none';
    }
  }
  // Internet Explorer
  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }
    return asString(node.currentStyle[camelize(name)]);
  }
  return asString(node.style && node.style[camelize(name)]);
}

module.exports = getStyleProperty;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var getElementRect = __webpack_require__(2143);

/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */
function getElementPosition(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

module.exports = getElementPosition;

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var containsNode = __webpack_require__(612);

/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */
function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement;

  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.
  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  }

  // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode
  var rect = elem.getBoundingClientRect();

  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

module.exports = getElementRect;

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;

/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getDocumentScrollElement(doc) {
  doc = doc || document;
  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }
  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

module.exports = getDocumentScrollElement;

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getViewportWidth() {
  var width = void 0;
  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
} /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *
   * 
   * @typechecks
   */

function getViewportHeight() {
  var height = void 0;
  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}

/**
 * Gets the viewport dimensions including any scrollbars.
 */
function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}

/**
 * Gets the viewport dimensions excluding any scrollbars.
 */
getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

module.exports = getViewportDimensions;

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */



/**
 * Combines multiple className strings into one.
 * http://jsperf.com/joinclasses-args-vs-array
 *
 * @param {...?string} className
 * @return {string}
 */

function joinClasses(className /*, ... */) {
  if (!className) {
    className = '';
  }
  var nextClass = void 0;
  var argLength = arguments.length;
  if (argLength > 1) {
    for (var ii = 1; ii < argLength; ii++) {
      nextClass = arguments[ii];
      if (nextClass) {
        className = (className ? className + ' ' : '') + nextClass;
      }
    }
  }
  return className;
}

module.exports = joinClasses;

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorDragHandler
 * @format
 * 
 */



var DataTransfer = __webpack_require__(1042);
var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);

var findAncestorOffsetKey = __webpack_require__(615);
var getTextContentFromFiles = __webpack_require__(1044);
var getUpdatedSelectionState = __webpack_require__(1045);
var isEventHandled = __webpack_require__(326);
var nullthrows = __webpack_require__(130);

/**
 * Get a SelectionState for the supplied mouse event.
 */
function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;

  if (typeof document.caretRangeFromPoint === 'function') {
    var dropRange = document.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows(node);
  offset = nullthrows(offset);
  var offsetKey = nullthrows(findAncestorOffsetKey(node));

  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer(e.nativeEvent.dataTransfer);

    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);

    e.preventDefault();
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();
    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }

      getTextContentFromFiles(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';
    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
      return;
    }

    if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
      return;
    }

    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
  }
};

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

/**
 * Insert text at a specified selection.
 */
function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

module.exports = DraftEditorDragHandler;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && (
    // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

module.exports = PhotosMimeType;

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(47);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorEditHandler
 * @format
 * 
 */



var onBeforeInput = __webpack_require__(2152);
var onBlur = __webpack_require__(2155);
var onCompositionStart = __webpack_require__(2156);
var onCopy = __webpack_require__(2157);
var onCut = __webpack_require__(2158);
var onDragOver = __webpack_require__(2159);
var onDragStart = __webpack_require__(2160);
var onFocus = __webpack_require__(2161);
var onInput = __webpack_require__(2162);
var onKeyDown = __webpack_require__(2163);
var onPaste = __webpack_require__(2177);
var onSelect = __webpack_require__(2182);

var DraftEditorEditHandler = {
  onBeforeInput: onBeforeInput,
  onBlur: onBlur,
  onCompositionStart: onCompositionStart,
  onCopy: onCopy,
  onCut: onCut,
  onDragOver: onDragOver,
  onDragStart: onDragStart,
  onFocus: onFocus,
  onInput: onInput,
  onKeyDown: onKeyDown,
  onPaste: onPaste,
  onSelect: onSelect
};

module.exports = DraftEditorEditHandler;

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBeforeInput
 * @format
 * 
 */



var BlockTree = __webpack_require__(1034);
var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);
var UserAgent = __webpack_require__(145);

var getEntityKeyForSelection = __webpack_require__(611);
var isEventHandled = __webpack_require__(326);
var isSelectionAtLeafStart = __webpack_require__(1038);
var nullthrows = __webpack_require__(130);
var setImmediate = __webpack_require__(2153);

// When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.
var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}

/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */
function replaceText(editorState, text, inlineStyle, entityKey) {
  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState.push(editorState, contentState, 'insert-characters');
}

/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */
function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;

  var chars = e.data;

  // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.
  if (!chars) {
    return;
  }

  // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.
  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
    e.preventDefault();
    return;
  }

  // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.
  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var selectionEnd = selection.getEndOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();

    // If the currently selected text matches what the user is trying to
    // replace it with, let's just update the `SelectionState`. If not, update
    // the `ContentState` with the new text.
    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
    if (chars === currentlySelectedChars) {
      editor.update(EditorState.forceSelection(editorState, selection.merge({
        focusOffset: selectionEnd
      })));
    } else {
      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
    }
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));

  // Bunch of different cases follow where we need to prevent native insertion.
  var mustPreventNative = false;
  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }
  if (!mustPreventNative) {
    // Chrome will also split up a node into two pieces if it contains a Tab
    // char, for no explicable reason. Seemingly caused by this commit:
    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
    var nativeSelection = global.getSelection();
    // Selection is necessarily collapsed at this point due to earlier check.
    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
      var parentNode = nativeSelection.anchorNode.parentNode;
      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
    }
  }
  if (!mustPreventNative) {
    // Check the old and new "fingerprints" of the current block to determine
    // whether this insertion requires any addition or removal of text nodes,
    // in which case we would prevent the native character insertion.
    var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
    var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
    mustPreventNative = originalFingerprint !== newFingerprint;
  }
  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }
  if (!mustPreventNative) {
    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    editor.update(newEditorState);
    return;
  }

  // We made it all the way! Let the browser do its thing and insert the char.
  newEditorState = EditorState.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  });
  // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.
  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

module.exports = editOnBeforeInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



// setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.

__webpack_require__(2154);
module.exports = global.setImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(473)))

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnBlur
 * @format
 * 
 */



var EditorState = __webpack_require__(52);

var containsNode = __webpack_require__(612);
var getActiveElement = __webpack_require__(1040);

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  if (getActiveElement() === document.body) {
    var _selection = global.getSelection();
    var editorNode = editor.editor;
    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState.acceptSelection(editorState, selection));
}

module.exports = editOnBlur;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCompositionStart
 * @format
 * 
 */



var EditorState = __webpack_require__(52);

/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */
function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState.set(editor._latestEditorState, { inCompositionMode: true }));
  // Allow composition handler to interpret the compositionstart event
  editor._onCompositionStart(e);
}

module.exports = editOnCompositionStart;

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCopy
 * @format
 * 
 */



var getFragmentFromSelection = __webpack_require__(1046);

/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */
function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();

  // No selection, so there's nothing to copy.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
}

module.exports = editOnCopy;

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnCut
 * @format
 * 
 */



var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);
var Style = __webpack_require__(613);

var getFragmentFromSelection = __webpack_require__(1046);
var getScrollPosition = __webpack_require__(614);

/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */
function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition = void 0;

  // No selection, so there's nothing to cut.
  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.
  if (element instanceof Node) {
    scrollPosition = getScrollPosition(Style.getScrollParent(element));
  }

  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment);

  // Set `cut` mode to disable all event handling temporarily.
  editor.setMode('cut');

  // Let native `cut` behavior occur, then recover control.
  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState.push(editorState, newContent, 'remove-range');
}

module.exports = editOnCut;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragOver
 * @format
 * 
 */



/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor._internalDrag = false;
  editor.setMode('drag');
  e.preventDefault();
}

module.exports = editOnDragOver;

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnDragStart
 * @format
 * 
 */



/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

module.exports = editOnDragStart;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnFocus
 * @format
 * 
 */



var EditorState = __webpack_require__(52);
var UserAgent = __webpack_require__(145);

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();
  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e);

  // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.
  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState.acceptSelection(editorState, selection));
  }
}

module.exports = editOnFocus;

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnInput
 * @format
 * 
 */



var DraftFeatureFlags = __webpack_require__(181);
var DraftModifier = __webpack_require__(87);
var DraftOffsetKey = __webpack_require__(430);
var EditorState = __webpack_require__(52);
var UserAgent = __webpack_require__(145);

var findAncestorOffsetKey = __webpack_require__(615);
var nullthrows = __webpack_require__(130);

var isGecko = UserAgent.isEngine('Gecko');

var DOUBLE_NEWLINE = '\n\n';

/**
 * This function is intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */
function editOnInput(editor) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var domSelection = global.getSelection();

  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;

  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;

  if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
    if (isNotTextNode) {
      return;
    }
  } else {
    if (isNotTextOrElementNode) {
      // TODO: (t16149272) figure out context for this change
      return;
    }
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;
    anchorNode.nodeValue = span.textContent;
    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end);

  // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.
  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  }

  // No change -- the DOM is up to date. Nothing to do here.
  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly
    return;
  }

  var selection = editorState.getSelection();

  // We'll replace the entire leaf with the text content of the target.
  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });

  var entityKey = block.getEntityAt(start);
  var entity = entityKey && content.getEntity(entityKey);
  var entityType = entity && entity.getMutability();
  var preserveEntity = entityType === 'MUTABLE';

  // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.
  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';

  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);

  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();

    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  }

  // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.
  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
  });

  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

module.exports = editOnInput;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnKeyDown
 * @format
 * 
 */



var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);
var KeyBindingUtil = __webpack_require__(616);
var Keys = __webpack_require__(610);
var SecondaryClipboard = __webpack_require__(2164);
var UserAgent = __webpack_require__(145);

var isEventHandled = __webpack_require__(326);
var keyCommandBackspaceToStartOfLine = __webpack_require__(2165);
var keyCommandBackspaceWord = __webpack_require__(2167);
var keyCommandDeleteWord = __webpack_require__(2169);
var keyCommandInsertNewline = __webpack_require__(2170);
var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(2171);
var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(2172);
var keyCommandPlainBackspace = __webpack_require__(2173);
var keyCommandPlainDelete = __webpack_require__(2174);
var keyCommandTransposeCharacters = __webpack_require__(2175);
var keyCommandUndo = __webpack_require__(2176);

var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;

var isChrome = UserAgent.isBrowser('Chrome');

/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */
function onKeyCommand(command, editorState) {
  switch (command) {
    case 'redo':
      return EditorState.redo(editorState);
    case 'delete':
      return keyCommandPlainDelete(editorState);
    case 'delete-word':
      return keyCommandDeleteWord(editorState);
    case 'backspace':
      return keyCommandPlainBackspace(editorState);
    case 'backspace-word':
      return keyCommandBackspaceWord(editorState);
    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine(editorState);
    case 'split-block':
      return keyCommandInsertNewline(editorState);
    case 'transpose-characters':
      return keyCommandTransposeCharacters(editorState);
    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock(editorState);
    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock(editorState);
    case 'secondary-cut':
      return SecondaryClipboard.cut(editorState);
    case 'secondary-paste':
      return SecondaryClipboard.paste(editorState);
    default:
      return editorState;
  }
}

/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */
function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault();
      // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.
      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
        return;
      }
      break;
    case Keys.ESC:
      e.preventDefault();
      editor.props.onEscape && editor.props.onEscape(e);
      return;
    case Keys.TAB:
      editor.props.onTab && editor.props.onTab(e);
      return;
    case Keys.UP:
      editor.props.onUpArrow && editor.props.onUpArrow(e);
      return;
    case Keys.RIGHT:
      editor.props.onRightArrow && editor.props.onRightArrow(e);
      return;
    case Keys.DOWN:
      editor.props.onDownArrow && editor.props.onDownArrow(e);
      return;
    case Keys.LEFT:
      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
      return;
    case Keys.SPACE:
      // Handling for OSX where option + space scrolls.
      if (isChrome && isOptionKeyCommand(e)) {
        e.preventDefault();
        // Insert a nbsp into the editor.
        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
        editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
        return;
      }
  }

  var command = editor.props.keyBindingFn(e);

  // If no command is specified, allow keydown event to continue.
  if (!command) {
    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo(e, editorState, editor.update);
    return;
  }

  // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.
  e.preventDefault();

  // Allow components higher up the tree to handle the command first.
  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
    return;
  }

  var newState = onKeyCommand(command, editorState);
  if (newState !== editorState) {
    editor.update(newState);
  }
}

module.exports = editOnKeyDown;

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SecondaryClipboard
 * @format
 * 
 */



var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);

var getContentStateFragment = __webpack_require__(428);
var nullthrows = __webpack_require__(130);

var clipboard = null;

/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */
var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        return editorState;
      }

      targetRange = selection.set('focusOffset', blockEnd);
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows(targetRange);
    clipboard = getContentStateFragment(content, targetRange);

    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState.push(editorState, afterRemoval, 'remove-range');
  },

  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);

    return EditorState.push(editorState, newContent, 'insert-fragment');
  }
};

module.exports = SecondaryClipboard;

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceToStartOfLine
 * @format
 * 
 */



var EditorState = __webpack_require__(52);

var expandRangeToStartOfLine = __webpack_require__(2166);
var getDraftEditorSelectionWithNodes = __webpack_require__(1048);
var moveSelectionBackward = __webpack_require__(617);
var removeTextWithStrategy = __webpack_require__(327);

function keyCommandBackspaceToStartOfLine(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var domSelection = global.getSelection();
    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);

    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceToStartOfLine;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule expandRangeToStartOfLine
 * @format
 * 
 */

var UnicodeUtils = __webpack_require__(218);

var getRangeClientRects = __webpack_require__(1047);
var invariant = __webpack_require__(47);

/**
 * Return the computed line height, in pixels, for the provided element.
 */
function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var div = document.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';

  var documentBody = document.body;
  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0;

  // forced layout here
  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);

  return rect.height;
}

/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */
function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];
    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }
    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}

/**
 * Return the length of a node, as used by Range offsets.
 */
function getNodeLength(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;
    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;
    default:
      return node.childNodes.length;
  }
}

/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */
function expandRangeToStartOfLine(range) {
  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
  range = range.cloneRange();

  var containingElement = range.startContainer;
  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }
  var lineHeight = getLineHeightPx(containingElement);

  // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
    range.setStartBefore(bestContainer);
    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  }

  // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.

  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.
  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;

    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);
      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

module.exports = expandRangeToStartOfLine;

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandBackspaceWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(1049);
var EditorState = __webpack_require__(52);

var moveSelectionBackward = __webpack_require__(617);
var removeTextWithStrategy = __webpack_require__(327);

/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */
function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    // If there are no words before the cursor, remove the preceding newline.
    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceWord;

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */



// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';

module.exports = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandDeleteWord
 * @format
 * 
 */



var DraftRemovableWord = __webpack_require__(1049);
var EditorState = __webpack_require__(52);

var moveSelectionForward = __webpack_require__(1050);
var removeTextWithStrategy = __webpack_require__(327);

/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */
function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text);

    // If there are no words in front of the cursor, remove the newline.
    return moveSelectionForward(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandDeleteWord;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandInsertNewline
 * @format
 * 
 */



var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState.push(editorState, contentState, 'split-block');
}

module.exports = keyCommandInsertNewline;

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToEndOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(52);

/**
 * See comment for `moveSelectionToStartOfBlock`.
 */
function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandMoveSelectionToStartOfBlock
 * @format
 * 
 */



var EditorState = __webpack_require__(52);

/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */
function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainBackspace
 * @format
 * 
 */



var EditorState = __webpack_require__(52);
var UnicodeUtils = __webpack_require__(218);

var moveSelectionBackward = __webpack_require__(617);
var removeTextWithStrategy = __webpack_require__(327);

/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

module.exports = keyCommandPlainBackspace;

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandPlainDelete
 * @format
 * 
 */



var EditorState = __webpack_require__(52);
var UnicodeUtils = __webpack_require__(218);

var moveSelectionForward = __webpack_require__(1050);
var removeTextWithStrategy = __webpack_require__(327);

/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */
function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();

  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

module.exports = keyCommandPlainDelete;

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandTransposeCharacters
 * @format
 * 
 */



var DraftModifier = __webpack_require__(87);
var EditorState = __webpack_require__(52);

var getContentStateFragment = __webpack_require__(428);

/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */
function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();
  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();
  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength();

  // Nothing to transpose if there aren't two characters.
  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  }

  // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.
  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');

  // After the removal, the insertion target is one character back.
  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });

  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);

  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');

  return EditorState.acceptSelection(newEditorState, finalSelection);
}

module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule keyCommandUndo
 * @format
 * 
 */



var EditorState = __webpack_require__(52);

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState.undo(editorState);

  // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.
  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
    return;
  }

  // Otheriwse, manage the undo behavior manually.
  e.preventDefault();
  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  }

  // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.
  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));

  // Wait to ensure that the re-render has occurred before performing
  // the undo action.
  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

module.exports = keyCommandUndo;

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnPaste
 * @format
 * 
 */



var BlockMapBuilder = __webpack_require__(324);
var CharacterMetadata = __webpack_require__(93);
var DataTransfer = __webpack_require__(1042);
var DraftModifier = __webpack_require__(87);
var DraftPasteProcessor = __webpack_require__(2178);
var EditorState = __webpack_require__(52);
var RichTextEditorUtil = __webpack_require__(1053);

var getEntityKeyForSelection = __webpack_require__(611);
var getTextContentFromFiles = __webpack_require__(1044);
var isEventHandled = __webpack_require__(326);
var splitTextIntoTextBlocks = __webpack_require__(2181);

/**
 * Paste content.
 */
function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData);

  // Get files, unless this is likely to be a string the user wants inline.
  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();
    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
        return;
      }

      getTextContentFromFiles(files, function ( /*string*/fileText) {
        fileText = fileText || defaultFileText;
        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character = CharacterMetadata.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder.createFromArray(text);

        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);

        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
      });

      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();
    if (data.isRichText() && internalClipboard) {
      if (
      // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      html.indexOf(editor.getEditorKey()) !== -1 ||
      // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    }

    // If there is html paste data, try to parse that.
    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    }

    // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.
    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });

    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);

    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);

    var textMap = BlockMapBuilder.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}

function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
  // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

module.exports = editOnPaste;

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftPasteProcessor
 * @format
 * 
 */



var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var CharacterMetadata = __webpack_require__(93);
var ContentBlock = __webpack_require__(217);
var ContentBlockNode = __webpack_require__(111);
var DraftFeatureFlags = __webpack_require__(181);
var Immutable = __webpack_require__(40);

var convertFromHTMLtoContentBlocks = __webpack_require__(1051);
var generateRandomKey = __webpack_require__(164);
var getSafeBodyFromHTML = __webpack_require__(1052);
var sanitizeDraftText = __webpack_require__(607);

var List = Immutable.List,
    Repeat = Immutable.Repeat;


var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;

var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey();

      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List(Repeat(character, textLine.length))
      };

      // next block updates previous block
      if (experimentalTreeDataSupport && index !== 0) {
        var prevSiblingIndex = index - 1;
        // update previous block
        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _extends({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));

      return acc;
    }, []);
  }
};

module.exports = DraftPasteProcessor;

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URI = function () {
  function URI(uri) {
    _classCallCheck(this, URI);

    this._uri = uri;
  }

  URI.prototype.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

module.exports = URI;

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adjustBlockDepthForContentState
 * @format
 * 
 */



function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });

  blockMap = blockMap.merge(blocks);

  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule splitTextIntoTextBlocks
 * @format
 * 
 */



var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule editOnSelect
 * @format
 * 
 */



var EditorState = __webpack_require__(52);
var ReactDOM = __webpack_require__(28);

var getDraftEditorSelection = __webpack_require__(2183);
var invariant = __webpack_require__(47);

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    return;
  }

  var editorState = editor.props.editorState;
  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
  !(editorNode.firstChild instanceof HTMLElement) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
  var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
    }
    editor.update(editorState);
  }
}

module.exports = editOnSelect;

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getDraftEditorSelection
 * @format
 * 
 */



var getDraftEditorSelectionWithNodes = __webpack_require__(1048);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelection(editorState, root) {
  var selection = global.getSelection();

  // No active selection.
  if (selection.rangeCount === 0) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
}

module.exports = getDraftEditorSelection;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftEditorPlaceholder.react
 * @format
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var cx = __webpack_require__(272);

/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder = function (_React$Component) {
  _inherits(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    _classCallCheck(this, DraftEditorPlaceholder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  DraftEditorPlaceholder.prototype.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();

    var className = cx({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });

    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };

    return React.createElement(
      'div',
      { className: className },
      React.createElement(
        'div',
        {
          className: cx('public/DraftEditorPlaceholder/inner'),
          id: this.props.accessibilityID,
          style: contentStyle },
        this.props.text
      )
    );
  };

  return DraftEditorPlaceholder;
}(React.Component);

module.exports = DraftEditorPlaceholder;

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromDraftStateToRaw
 * @format
 * 
 */



var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(217);
var ContentBlockNode = __webpack_require__(111);
var DraftStringKey = __webpack_require__(1055);

var encodeEntityRanges = __webpack_require__(2186);
var encodeInlineStyleRanges = __webpack_require__(2187);
var invariant = __webpack_require__(47);

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;

  var parentKey = block.getParentKey();
  var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;


  var rawBlocks = [];

  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;

  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start);
      // Stringify to maintain order of otherwise numeric keys.
      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
      // This makes this function resilient to two entities
      // erroneously having the same key
      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }
      entityCacheRef[stringifiedEntityKey] = entityKey;
      // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode
      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
      entityStorageKey++;
    });

    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });

  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
};

// Flip storage map so that our storage keys map to global
// DraftEntity keys.
var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;


  var rawEntityMap = {};

  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });

  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  };

  // add blocks
  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);

  // add entities
  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);

  return rawDraftContentState;
};

module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeEntityRanges
 * @format
 * 
 */



var DraftStringKey = __webpack_require__(1055);
var UnicodeUtils = __webpack_require__(218);

var strlen = UnicodeUtils.strlen;

/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function ( /*number*/start, /*number*/end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey.stringify(key)])
    });
  });
  return encoded;
}

module.exports = encodeEntityRanges;

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule encodeInlineStyleRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(218);

var findRangesImmutable = __webpack_require__(325);

var areEqual = function areEqual(a, b) {
  return a === b;
};
var isTruthy = function isTruthy(a) {
  return !!a;
};
var EMPTY_ARRAY = [];

/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */
function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = [];

  // Obtain an array with ranges for only the specified style.
  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();

  findRangesImmutable(filteredInlines, areEqual,
  // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils.strlen(text.slice(0, start)),
      length: UnicodeUtils.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });

  return ranges;
}

/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */
function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });

  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

module.exports = encodeInlineStyleRanges;

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule convertFromRawToDraftState
 * @format
 * 
 */



var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ContentBlock = __webpack_require__(217);
var ContentBlockNode = __webpack_require__(111);
var ContentState = __webpack_require__(606);
var DraftEntity = __webpack_require__(429);
var DraftFeatureFlags = __webpack_require__(181);
var DraftTreeAdapter = __webpack_require__(2189);
var Immutable = __webpack_require__(40);
var SelectionState = __webpack_require__(271);

var createCharacterList = __webpack_require__(2190);
var decodeEntityRanges = __webpack_require__(2191);
var decodeInlineStyleRanges = __webpack_require__(2192);
var generateRandomKey = __webpack_require__(164);
var invariant = __webpack_require__(47);

var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;


var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;


  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey(),
    data: Map(data),
    characterList: decodeCharacterList(block, entityMap)
  };

  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;


  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || [];

  // Translate entity range keys to the DraftEntity map.
  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _extends({}, range, { key: entityMap[range.key] });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _extends({}, block, {
    key: block.key || generateRandomKey()
  });
};

/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */
var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _extends({}, block, {
      parentRef: parentRef
    });
  });

  // since we pop nodes from the stack we need to insert them in reverse
  return stack.concat(nodesWithParentRef.reverse());
};

/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */
var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks
  // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;

    // ensure children have valid keys to enable sibling links
    var children = block.children.map(addKeyIfMissing);

    // root level nodes
    var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List(children.map(function (child) {
        return child.key;
      }))
    }));

    // push root node to blockMap
    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);

    // this stack is used to ensure we visit all nodes respecting depth ordering
    var stack = updateNodeStack([], children, contentBlockNode);

    // start computing children nodes
    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop();

      // parentRef already points to a converted ContentBlockNode
      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();
      var _index = siblings.indexOf(node.key);
      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
        break;
      }

      // ensure children have valid keys to enable sibling links
      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      }));

      // push node to blockMap
      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);

      // this stack is used to ensure we visit all nodes respecting depth ordering
      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap(blocks.map(function (block) {
    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  return decodeContentBlockNodes(rawBlocks, entityMap);
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;

  var entityMap = {};

  // TODO: Update this once we completely remove DraftEntity
  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data;

    // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
  });

  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0;

  // decode entities
  var entityMap = decodeRawEntityMap(rawState);

  // decode blockMap
  var blockMap = decodeRawBlocks(rawState, entityMap);

  // create initial selection
  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());

  return new ContentState({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

module.exports = convertFromRawToDraftState;

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(73);

var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DraftTreeAdapter
 * @format
 * 
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */

var invariant = __webpack_require__(47);

var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();
  while (stack.length) {
    var _block = stack.pop();

    fn(_block);

    var children = _block.children;

    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;

    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }
  var type = block.type;

  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _extends({}, child, { depth: (block.depth || 0) + 1 }) : child;
    });
  }
};

/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */
var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to  draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;

    var transformedBlocks = [];

    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _extends({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block);
      }

      delete newBlock.children;

      transformedBlocks.push(newBlock);
    });

    draftTreeState.blocks = transformedBlocks;

    return _extends({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },


  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var lastListDepthCacheRef = {};
    var transformedBlocks = [];

    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;
      var treeBlock = _extends({}, block, {
        children: []
      });

      if (!isList) {
        // reset the cache path
        lastListDepthCacheRef = {};
        transformedBlocks.push(treeBlock);
        return;
      }

      // update our depth cache reference path
      lastListDepthCacheRef[depth] = treeBlock;

      // if we are greater than zero we must have seen a parent already
      if (depth > 0) {
        var parent = lastListDepthCacheRef[depth - 1];

        !parent ?  false ? invariant(false, 'Invalid depth for RawDraftContentBlock') : invariant(false) : void 0;

        // push nested list blocks
        parent.children.push(treeBlock);
        return;
      }

      // push root list blocks
      transformedBlocks.push(treeBlock);
    });

    return _extends({}, draftState, {
      blocks: transformedBlocks
    });
  }
};

module.exports = DraftTreeAdapter;

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createCharacterList
 * @format
 * 
 */



var CharacterMetadata = __webpack_require__(93);
var Immutable = __webpack_require__(40);

var List = Immutable.List;


function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata.create({ style: style, entity: entity });
  });
  return List(characterArray);
}

module.exports = createCharacterList;

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeEntityRanges
 * @format
 * 
 */



var UnicodeUtils = __webpack_require__(218);

var substr = UnicodeUtils.substr;

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);
  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr(text, 0, range.offset).length;
      var end = start + substr(text, range.offset, range.length).length;
      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }
  return entities;
}

module.exports = decodeEntityRanges;

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule decodeInlineStyleRanges
 * @format
 * 
 */



var _require = __webpack_require__(40),
    OrderedSet = _require.OrderedSet;

var UnicodeUtils = __webpack_require__(218);

var substr = UnicodeUtils.substr;


var EMPTY_SET = OrderedSet();

/**
 * Convert to native JavaScript string lengths to determine ranges.
 */
function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET);
  if (ranges) {
    ranges.forEach(function ( /*object*/range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;
      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }
  return styles;
}

module.exports = decodeInlineStyleRanges;

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getVisibleSelectionRect
 * @format
 * 
 */



var getRangeBoundingClientRect = __webpack_require__(2194);

/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 */
function getVisibleSelectionRect(global) {
  var selection = global.getSelection();
  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left;

  // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

module.exports = getVisibleSelectionRect;

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getRangeBoundingClientRect
 * @format
 * 
 */



var getRangeClientRects = __webpack_require__(1047);

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];
      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

module.exports = getRangeBoundingClientRect;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(144),__webpack_require__(40)):"function"==typeof define&&define.amd?define(["draft-js","immutable"],t):"object"==typeof exports?exports.draftjsUtils=t(require("draft-js"),require("immutable")):e.draftjsUtils=t(e["draft-js"],e.immutable)}("undefined"!=typeof self?self:this,function(e,t){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=3)}([function(t,n){t.exports=e},function(e,t,n){"use strict";function r(e){var t=e.getSelection(),n=e.getCurrentContent(),r=t.getStartKey(),o=t.getEndKey(),i=n.getBlockMap();return i.toSeq().skipUntil(function(e,t){return t===r}).takeUntil(function(e,t){return t===o}).concat([[o,i.get(o)]])}function o(e){return r(e).toList()}function i(e){if(e)return o(e).get(0)}function l(e){if(e){var t=i(e),n=e.getCurrentContent(),r=n.getBlockMap().toSeq().toList(),o=0;if(r.forEach(function(e,n){e.get("key")===t.get("key")&&(o=n-1)}),o>-1)return r.get(o)}}function c(e){return e?e.getCurrentContent().getBlockMap().toList():new v.List}function a(e){var t=o(e);if(!t.some(function(e){return e.type!==t.get(0).type}))return t.get(0).type}function f(e){var t=p.RichUtils.tryToRemoveBlockStyle(e);return t?p.EditorState.push(e,t,"change-block-type"):e}function u(e){var t="",n=e.getSelection(),r=n.getAnchorOffset(),i=n.getFocusOffset(),l=o(e);if(l.size>0){if(n.getIsBackward()){var c=r;r=i,i=c}for(var a=0;a<l.size;a+=1){var f=0===a?r:0,u=a===l.size-1?i:l.get(a).getText().length;t+=l.get(a).getText().slice(f,u)}}return t}function s(e){var t=e.getCurrentContent(),n=e.getSelection(),r=p.Modifier.removeRange(t,n,"forward"),o=r.getSelectionAfter(),i=r.getBlockForKey(o.getStartKey());return r=p.Modifier.insertText(r,o,"\n",i.getInlineStyleAt(o.getStartOffset()),null),p.EditorState.push(e,r,"insert-fragment")}function g(e){var t=p.Modifier.splitBlock(e.getCurrentContent(),e.getSelection());return f(p.EditorState.push(e,t,"split-block"))}function d(e){var t=e.getCurrentContent().getBlockMap().toList(),n=e.getSelection().merge({anchorKey:t.first().get("key"),anchorOffset:0,focusKey:t.last().get("key"),focusOffset:t.last().getLength()}),r=p.Modifier.removeRange(e.getCurrentContent(),n,"forward");return p.EditorState.push(e,r,"remove-range")}function S(e,t){var n=p.Modifier.setBlockData(e.getCurrentContent(),e.getSelection(),t);return p.EditorState.push(e,n,"change-block-data")}function y(e){var t=new v.Map({}),n=o(e);if(n&&n.size>0)for(var r=0;r<n.size;r+=1){var i=function(e){var r=n.get(e).getData();if(!r||0===r.size)return t=t.clear(),"break";if(0===e)t=r;else if(t.forEach(function(e,n){r.get(n)&&r.get(n)===e||(t=t.delete(n))}),0===t.size)return t=t.clear(),"break"}(r);if("break"===i)break}return t}Object.defineProperty(t,"__esModule",{value:!0}),t.blockRenderMap=void 0,t.getSelectedBlocksMap=r,t.getSelectedBlocksList=o,t.getSelectedBlock=i,t.getBlockBeforeSelectedBlock=l,t.getAllBlocks=c,t.getSelectedBlocksType=a,t.removeSelectedBlocksStyle=f,t.getSelectionText=u,t.addLineBreakRemovingSelection=s,t.insertNewUnstyledBlock=g,t.clearEditorContent=d,t.setBlockData=S,t.getSelectedBlocksMetadata=y;var p=n(0),v=n(6),k=(0,v.Map)({code:{element:"pre"}});t.blockRenderMap=p.DefaultDraftBlockRenderMap.merge(k)},function(e,t,n){"use strict";function r(e){if(e){var t=e.getType();return"unordered-list-item"===t||"ordered-list-item"===t}return!1}function o(e,t,n){var r=e.getSelection(),o=e.getCurrentContent(),i=o.getBlockMap(),l=(0,c.getSelectedBlocksMap)(e).map(function(e){var r=e.getDepth()+t;return r=Math.max(0,Math.min(r,n)),e.set("depth",r)});return i=i.merge(l),o.merge({blockMap:i,selectionBefore:r,selectionAfter:r})}function i(e,t,n){var r=e.getSelection(),i=void 0;i=r.getIsBackward()?r.getFocusKey():r.getAnchorKey();var c=e.getCurrentContent(),a=c.getBlockForKey(i),f=a.getType();if("unordered-list-item"!==f&&"ordered-list-item"!==f)return e;var u=c.getBlockBefore(i);if(!u)return e;if(u.getType()!==f)return e;var s=a.getDepth();if(1===t&&s===n)return e;var g=Math.min(u.getDepth()+1,n),d=o(e,t,g);return l.EditorState.push(e,d,"adjust-depth")}Object.defineProperty(t,"__esModule",{value:!0}),t.isListBlock=r,t.changeDepth=i;var l=n(0),c=n(1)},function(e,t,n){e.exports=n(4)},function(e,t,n){"use strict";var r=n(5),o=n(1),i=n(7),l=function(e){return e&&e.__esModule?e:{default:e}}(i),c=n(2);e.exports={getSelectedBlocksMap:o.getSelectedBlocksMap,getSelectedBlocksList:o.getSelectedBlocksList,getSelectedBlock:o.getSelectedBlock,getBlockBeforeSelectedBlock:o.getBlockBeforeSelectedBlock,getAllBlocks:o.getAllBlocks,getSelectedBlocksType:o.getSelectedBlocksType,removeSelectedBlocksStyle:o.removeSelectedBlocksStyle,getSelectionText:o.getSelectionText,addLineBreakRemovingSelection:o.addLineBreakRemovingSelection,insertNewUnstyledBlock:o.insertNewUnstyledBlock,clearEditorContent:o.clearEditorContent,setBlockData:o.setBlockData,getSelectedBlocksMetadata:o.getSelectedBlocksMetadata,blockRenderMap:o.blockRenderMap,getEntityRange:r.getEntityRange,getCustomStyleMap:r.getCustomStyleMap,toggleCustomInlineStyle:r.toggleCustomInlineStyle,getSelectionEntity:r.getSelectionEntity,extractInlineStyle:r.extractInlineStyle,removeAllInlineStyles:r.removeAllInlineStyles,getSelectionInlineStyle:r.getSelectionInlineStyle,getSelectionCustomInlineStyle:r.getSelectionCustomInlineStyle,handleNewLine:l.default,isListBlock:c.isListBlock,changeDepth:c.changeDepth}},function(e,t,n){"use strict";function r(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function o(e){var t=e.getSelection();if(t.isCollapsed()){var n={},r=e.getCurrentInlineStyle().toList().toJS();if(r)return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(e){n[e]=r.indexOf(e)>=0}),n}var o=t.getStartOffset(),i=t.getEndOffset(),l=(0,p.getSelectedBlocksList)(e);if(l.size>0){var c=function(){for(var e={BOLD:!0,ITALIC:!0,UNDERLINE:!0,STRIKETHROUGH:!0,CODE:!0,SUPERSCRIPT:!0,SUBSCRIPT:!0},t=0;t<l.size;t+=1){var n=0===t?o:0,r=t===l.size-1?i:l.get(t).getText().length;n===r&&0===n?(n=1,r=2):n===r&&(n-=1);for(var c=n;c<r;c+=1)!function(n){var r=l.get(t).getInlineStyleAt(n);["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){e[t]=e[t]&&r.get(t)===t})}(c)}return{v:e}}();if("object"===(void 0===c?"undefined":S(c)))return c.v}return{}}function i(e){var t=void 0,n=e.getSelection(),r=n.getStartOffset(),o=n.getEndOffset();r===o&&0===r?o=1:r===o&&(r-=1);for(var i=(0,p.getSelectedBlock)(e),l=r;l<o;l+=1){var c=i.getEntityAt(l);if(!c){t=void 0;break}if(l===r)t=c;else if(t!==c){t=void 0;break}}return t}function l(e,t){var n=(0,p.getSelectedBlock)(e),r=void 0;return n.findEntityRanges(function(e){return e.get("entity")===t},function(e,t){r={start:e,end:t,text:n.get("text").slice(e,t)}}),r}function c(e,t,n){var r=e.getSelection(),o=Object.keys(v[t]).reduce(function(e,t){return y.Modifier.removeInlineStyle(e,r,t)},e.getCurrentContent()),i=y.EditorState.push(e,o,"changeinline-style"),l=e.getCurrentInlineStyle();if(r.isCollapsed()&&(i=l.reduce(function(e,t){return y.RichUtils.toggleInlineStyle(e,t)},i)),"SUPERSCRIPT"===t||"SUBSCRIPT"==t)l.has(n)||(i=y.RichUtils.toggleInlineStyle(i,n));else{var c="bgcolor"===t?"backgroundColor":t;l.has(c+"-"+n)||(i=y.RichUtils.toggleInlineStyle(i,t.toLowerCase()+"-"+n),k(t,c,n))}return i}function a(e){if(e){e.getCurrentContent().getBlockMap().map(function(e){return e.get("characterList")}).toList().flatten().forEach(function(e){e&&0===e.indexOf("color-")?k("color","color",e.substr(6)):e&&0===e.indexOf("bgcolor-")?k("bgcolor","backgroundColor",e.substr(8)):e&&0===e.indexOf("fontsize-")?k("fontSize","fontSize",+e.substr(9)):e&&0===e.indexOf("fontfamily-")&&k("fontFamily","fontFamily",e.substr(11))})}}function f(e,t,n){var r=e.getInlineStyleAt(n).toList(),o=r.filter(function(e){return e.startsWith(t.toLowerCase())});if(o&&o.size>0)return o.get(0)}function u(e,t){var n=e.getCurrentInlineStyle().toList(),r=n.filter(function(e){return e.startsWith(t.toLowerCase())});if(r&&r.size>0)return r.get(0)}function s(e,t){if(e&&t&&t.length>0){var n=function(){var n=e.getSelection(),r={};if(n.isCollapsed())return t.forEach(function(t){r[t]=u(e,t)}),{v:r};var o=n.getStartOffset(),i=n.getEndOffset(),l=(0,p.getSelectedBlocksList)(e);if(l.size>0){for(var c=0;c<l.size;c+=1)!function(e){var n=0===e?o:0,c=e===l.size-1?i:l.get(e).getText().length;n===c&&0===n?(n=1,c=2):n===c&&(n-=1);for(var a=n;a<c;a+=1)!function(o){o===n?t.forEach(function(t){r[t]=f(l.get(e),t,o)}):t.forEach(function(t){r[t]&&r[t]!==f(l.get(e),t,o)&&(r[t]=void 0)})}(a)}(c);return{v:r}}}();if("object"===(void 0===n?"undefined":S(n)))return n.v}return{}}function g(e){var t=e.getCurrentInlineStyle(),n=e.getCurrentContent();return t.forEach(function(t){n=y.Modifier.removeInlineStyle(n,e.getSelection(),t)}),y.EditorState.push(e,n,"change-inline-style")}Object.defineProperty(t,"__esModule",{value:!0}),t.getCustomStyleMap=void 0;var d=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},S="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.getSelectionInlineStyle=o,t.getSelectionEntity=i,t.getEntityRange=l,t.toggleCustomInlineStyle=c,t.extractInlineStyle=a,t.getSelectionCustomInlineStyle=s,t.removeAllInlineStyles=g;var y=n(0),p=n(1),v={color:{},bgcolor:{},fontSize:{},fontFamily:{},CODE:{fontFamily:"monospace",wordWrap:"break-word",background:"#f1f1f1",borderRadius:3,padding:"1px 3px"},SUPERSCRIPT:{fontSize:11,position:"relative",top:-8,display:"inline-flex"},SUBSCRIPT:{fontSize:11,position:"relative",bottom:-8,display:"inline-flex"}},k=function(e,t,n){v[e][e.toLowerCase()+"-"+n]=r({},""+t,n)};t.getCustomStyleMap=function(){return d({},v.color,v.bgcolor,v.fontSize,v.fontFamily,{CODE:v.CODE,SUPERSCRIPT:v.SUPERSCRIPT,SUBSCRIPT:v.SUBSCRIPT})}},function(e,n){e.exports=t},function(e,t,n){"use strict";function r(e){var t=e.getSelection();if(t.isCollapsed()){var n=e.getCurrentContent(),r=t.getStartKey(),o=n.getBlockForKey(r);if(!(0,a.isListBlock)(o)&&"unstyled"!==o.getType()&&o.getLength()===t.getStartOffset())return(0,c.insertNewUnstyledBlock)(e);if((0,a.isListBlock)(o)&&0===o.getLength()){var i=o.getDepth();if(0===i)return(0,c.removeSelectedBlocksStyle)(e);if(i>0)return(0,a.changeDepth)(e,-1,i)}}}function o(e){return 13===e.which&&(e.getModifierState("Shift")||e.getModifierState("Alt")||e.getModifierState("Control"))}function i(e,t){if(o(t)){return e.getSelection().isCollapsed()?l.RichUtils.insertSoftNewline(e):(0,c.addLineBreakRemovingSelection)(e)}return r(e)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=i;var l=n(0),c=n(1),a=n(2)}])});

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ToastContainer = __webpack_require__(1056);

Object.defineProperty(exports, 'DefaultToastContainer', {
  enumerable: true,
  get: function get() {
    return _ToastContainer.ToastContainer;
  }
});

var _ToastElement = __webpack_require__(622);

Object.defineProperty(exports, 'DefaultToast', {
  enumerable: true,
  get: function get() {
    return _ToastElement.DefaultToast;
  }
});

var _ToastProvider = __webpack_require__(2204);

Object.defineProperty(exports, 'ToastConsumer', {
  enumerable: true,
  get: function get() {
    return _ToastProvider.ToastConsumer;
  }
});
Object.defineProperty(exports, 'ToastProvider', {
  enumerable: true,
  get: function get() {
    return _ToastProvider.ToastProvider;
  }
});
Object.defineProperty(exports, 'withToastManager', {
  enumerable: true,
  get: function get() {
    return _ToastProvider.withToastManager;
  }
});
Object.defineProperty(exports, 'useToasts', {
  enumerable: true,
  get: function get() {
    return _ToastProvider.useToasts;
  }
});

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(2198);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2198 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmur2);


/***/ }),
/* 2201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseIcon = exports.InfoIcon = exports.FlameIcon = exports.CheckIcon = exports.AlertIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDefaultProps(width) {
  return {
    'aria-hidden': true,
    height: 16,
    width: width,
    viewBox: '0 0 ' + width + ' 16',
    style: {
      display: 'inline-block',
      verticalAlign: 'text-top',
      fill: 'currentColor'
    }
  };
}

var AlertIcon = exports.AlertIcon = function AlertIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(16), props),
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M8.893 1.5c-.183-.31-.52-.5-.887-.5s-.703.19-.886.5L.138 13.499a.98.98 0 0 0 0 1.001c.193.31.53.501.886.501h13.964c.367 0 .704-.19.877-.5a1.03 1.03 0 0 0 .01-1.002L8.893 1.5zm.133 11.497H6.987v-2.003h2.039v2.003zm0-3.004H6.987V5.987h2.039v4.006z'
    })
  );
};
var CheckIcon = exports.CheckIcon = function CheckIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(12), props),
    _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M12 5.5l-8 8-4-4L1.5 8 4 10.5 10.5 4 12 5.5z' })
  );
};
var FlameIcon = exports.FlameIcon = function FlameIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(12), props),
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M5.05.01c.81 2.17.41 3.38-.52 4.31C3.55 5.37 1.98 6.15.9 7.68c-1.45 2.05-1.7 6.53 3.53 7.7-2.2-1.16-2.67-4.52-.3-6.61-.61 2.03.53 3.33 1.94 2.86 1.39-.47 2.3.53 2.27 1.67-.02.78-.31 1.44-1.13 1.81 3.42-.59 4.78-3.42 4.78-5.56 0-2.84-2.53-3.22-1.25-5.61-1.52.13-2.03 1.13-1.89 2.75.09 1.08-1.02 1.8-1.86 1.33-.67-.41-.66-1.19-.06-1.78C8.18 5.01 8.68 2.15 5.05.02L5.03 0l.02.01z'
    })
  );
};
var InfoIcon = exports.InfoIcon = function InfoIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(14), props),
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M6.3 5.71a.942.942 0 0 1-.28-.7c0-.28.09-.52.28-.7.19-.18.42-.28.7-.28.28 0 .52.09.7.28.18.19.28.42.28.7 0 .28-.09.52-.28.7a1 1 0 0 1-.7.3c-.28 0-.52-.11-.7-.3zM8 8.01c-.02-.25-.11-.48-.31-.69-.2-.19-.42-.3-.69-.31H6c-.27.02-.48.13-.69.31-.2.2-.3.44-.31.69h1v3c.02.27.11.5.31.69.2.2.42.31.69.31h1c.27 0 .48-.11.69-.31.2-.19.3-.42.31-.69H8V8v.01zM7 2.32C3.86 2.32 1.3 4.86 1.3 8c0 3.14 2.56 5.7 5.7 5.7s5.7-2.55 5.7-5.7c0-3.15-2.56-5.69-5.7-5.69v.01zM7 1c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.12-7-7 3.14-7 7-7z'
    })
  );
};
var CloseIcon = exports.CloseIcon = function CloseIcon(props) {
  return _react2.default.createElement(
    'svg',
    _extends({}, getDefaultProps(14), props),
    _react2.default.createElement('path', {
      fillRule: 'evenodd',
      d: 'M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z'
    })
  );
};

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Reds
var R50 = exports.R50 = '#FFEBE6';
var R75 = exports.R75 = '#FFBDAD';
var R100 = exports.R100 = '#FF8F73';
var R200 = exports.R200 = '#FF7452';
var R300 = exports.R300 = '#FF5630';
var R400 = exports.R400 = '#DE350B';
var R500 = exports.R500 = '#BF2600';

// Yellows
var Y50 = exports.Y50 = '#FFFAE6';
var Y75 = exports.Y75 = '#FFF0B3';
var Y100 = exports.Y100 = '#FFE380';
var Y200 = exports.Y200 = '#FFC400';
var Y300 = exports.Y300 = '#FFAB00';
var Y400 = exports.Y400 = '#FF991F';
var Y500 = exports.Y500 = '#FF8B00';

// Greens
var G50 = exports.G50 = '#E3FCEF';
var G75 = exports.G75 = '#ABF5D1';
var G100 = exports.G100 = '#79F2C0';
var G200 = exports.G200 = '#57D9A3';
var G300 = exports.G300 = '#36B37E';
var G400 = exports.G400 = '#00875A';
var G500 = exports.G500 = '#006644';

// Blues
var B50 = exports.B50 = '#DEEBFF';
var B75 = exports.B75 = '#B3D4FF';
var B100 = exports.B100 = '#4C9AFF';
var B200 = exports.B200 = '#2684FF';
var B300 = exports.B300 = '#0065FF';
var B400 = exports.B400 = '#0052CC';
var B500 = exports.B500 = '#0747A6';

// Purples
var P50 = exports.P50 = '#EAE6FF';
var P75 = exports.P75 = '#C0B6F2';
var P100 = exports.P100 = '#998DD9';
var P200 = exports.P200 = '#8777D9';
var P300 = exports.P300 = '#6554C0';
var P400 = exports.P400 = '#5243AA';
var P500 = exports.P500 = '#403294';

// Teals
var T50 = exports.T50 = '#E6FCFF';
var T75 = exports.T75 = '#B3F5FF';
var T100 = exports.T100 = '#79E2F2';
var T200 = exports.T200 = '#00C7E6';
var T300 = exports.T300 = '#00B8D9';
var T400 = exports.T400 = '#00A3BF';
var T500 = exports.T500 = '#008DA6';

// Neutrals
var N0 = exports.N0 = '#FFFFFF';
var N10 = exports.N10 = '#FAFBFC';
var N20 = exports.N20 = '#F4F5F7';
var N30 = exports.N30 = '#EBECF0';
var N40 = exports.N40 = '#DFE1E6';
var N50 = exports.N50 = '#C1C7D0';
var N60 = exports.N60 = '#B3BAC5';
var N70 = exports.N70 = '#A5ADBA';
var N80 = exports.N80 = '#97A0AF';
var N90 = exports.N90 = '#8993A4';
var N100 = exports.N100 = '#7A869A';
var N200 = exports.N200 = '#6B778C';
var N300 = exports.N300 = '#5E6C84';
var N400 = exports.N400 = '#505F79';
var N500 = exports.N500 = '#42526E';
var N600 = exports.N600 = '#344563';
var N700 = exports.N700 = '#253858';
var N800 = exports.N800 = '#172B4D';

// ATTENTION: update the tints if you update this
var N900 = exports.N900 = '#091E42';

// Each tint is made of N900 and an alpha channel
var N10A = exports.N10A = 'rgba(9, 30, 66, 0.02)';
var N20A = exports.N20A = 'rgba(9, 30, 66, 0.04)';
var N30A = exports.N30A = 'rgba(9, 30, 66, 0.08)';
var N40A = exports.N40A = 'rgba(9, 30, 66, 0.13)';
var N50A = exports.N50A = 'rgba(9, 30, 66, 0.25)';
var N60A = exports.N60A = 'rgba(9, 30, 66, 0.31)';
var N70A = exports.N70A = 'rgba(9, 30, 66, 0.36)';
var N80A = exports.N80A = 'rgba(9, 30, 66, 0.42)';
var N90A = exports.N90A = 'rgba(9, 30, 66, 0.48)';
var N100A = exports.N100A = 'rgba(9, 30, 66, 0.54)';
var N200A = exports.N200A = 'rgba(9, 30, 66, 0.60)';
var N300A = exports.N300A = 'rgba(9, 30, 66, 0.66)';
var N400A = exports.N400A = 'rgba(9, 30, 66, 0.71)';
var N500A = exports.N500A = 'rgba(9, 30, 66, 0.77)';
var N600A = exports.N600A = 'rgba(9, 30, 66, 0.82)';
var N700A = exports.N700A = 'rgba(9, 30, 66, 0.89)';
var N800A = exports.N800A = 'rgba(9, 30, 66, 0.95)';

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToasts = exports.withToastManager = exports.ToastConsumer = exports.ToastProvider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(28);

var _reactTransitionGroup = __webpack_require__(161);

var _ToastController = __webpack_require__(2205);

var _ToastContainer = __webpack_require__(1056);

var _ToastElement = __webpack_require__(622);

var _utils = __webpack_require__(623);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultComponents = { Toast: _ToastElement.DefaultToast, ToastContainer: _ToastContainer.ToastContainer };

// $FlowFixMe `createContext`
var ToastContext = _react2.default.createContext();
var Consumer = ToastContext.Consumer,
    Provider = ToastContext.Provider;


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Provider
// ==============================

var ToastProvider = exports.ToastProvider = function (_Component) {
  _inherits(ToastProvider, _Component);

  function ToastProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToastProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToastProvider.__proto__ || Object.getPrototypeOf(ToastProvider)).call.apply(_ref, [this].concat(args))), _this), _this.state = { toasts: [] }, _this.has = function (id) {
      if (!_this.state.toasts.length) {
        return false;
      }

      return Boolean(_this.state.toasts.filter(function (t) {
        return t.id === id;
      }).length);
    }, _this.onDismiss = function (id) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils.NOOP;
      return function () {
        cb(id);
        _this.remove(id);
      };
    }, _this.add = function (content) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.NOOP;

      var id = options.id || (0, _utils.generateUEID)();
      var callback = function callback() {
        return cb(id);
      };

      // bail if a toast exists with this ID
      if (_this.has(id)) {
        return;
      }

      // update the toast stack
      _this.setState(function (state) {
        var newToast = _extends({ content: content, id: id }, options);
        var toasts = [].concat(_toConsumableArray(state.toasts), [newToast]);

        return { toasts: toasts };
      }, callback);

      // consumer may want to do something with the generated ID (and not use the callback)
      return id;
    }, _this.remove = function (id) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils.NOOP;

      var callback = function callback() {
        return cb(id);
      };

      // bail if NO toasts exists with this ID
      if (!_this.has(id)) {
        return;
      }

      _this.setState(function (state) {
        var toasts = state.toasts.filter(function (t) {
          return t.id !== id;
        });
        return { toasts: toasts };
      }, callback);
    }, _this.removeAll = function () {
      if (!_this.state.toasts.length) {
        return;
      }

      _this.state.toasts.forEach(function (t) {
        return _this.remove(t.id);
      });
    }, _this.update = function (id) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _utils.NOOP;

      var callback = function callback() {
        return cb(id);
      };

      // bail if NO toasts exists with this ID
      if (!_this.has(id)) {
        return;
      }

      // update the toast stack
      _this.setState(function (state) {
        var old = state.toasts;
        var i = old.findIndex(function (t) {
          return t.id === id;
        });
        var updatedToast = _extends({}, old[i], options);
        var toasts = [].concat(_toConsumableArray(old.slice(0, i)), [updatedToast], _toConsumableArray(old.slice(i + 1)));

        return { toasts: toasts };
      }, callback);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // Internal Helpers
  // ------------------------------

  // Public API
  // ------------------------------

  _createClass(ToastProvider, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          inheritedAutoDismiss = _props.autoDismiss,
          autoDismissTimeout = _props.autoDismissTimeout,
          children = _props.children,
          components = _props.components,
          placement = _props.placement,
          transitionDuration = _props.transitionDuration;

      var _defaultComponents$co = _extends({}, defaultComponents, components),
          Toast = _defaultComponents$co.Toast,
          ToastContainer = _defaultComponents$co.ToastContainer;

      var add = this.add,
          remove = this.remove,
          removeAll = this.removeAll,
          update = this.update;

      var toasts = Object.freeze(this.state.toasts);

      var hasToasts = Boolean(toasts.length);
      var portalTarget = canUseDOM ? document.body : null; // appease flow

      return _react2.default.createElement(
        Provider,
        { value: { add: add, remove: remove, removeAll: removeAll, update: update, toasts: toasts } },
        children,
        portalTarget ? (0, _reactDom.createPortal)(_react2.default.createElement(
          ToastContainer,
          { placement: placement, hasToasts: hasToasts },
          _react2.default.createElement(
            _reactTransitionGroup.TransitionGroup,
            { component: null },
            toasts.map(function (_ref2) {
              var appearance = _ref2.appearance,
                  autoDismiss = _ref2.autoDismiss,
                  content = _ref2.content,
                  id = _ref2.id,
                  onDismiss = _ref2.onDismiss,
                  unknownConsumerProps = _objectWithoutProperties(_ref2, ['appearance', 'autoDismiss', 'content', 'id', 'onDismiss']);

              return _react2.default.createElement(
                _reactTransitionGroup.Transition,
                {
                  appear: true,
                  key: id,
                  mountOnEnter: true,
                  timeout: transitionDuration,
                  unmountOnExit: true
                },
                function (transitionState) {
                  return _react2.default.createElement(
                    _ToastController.ToastController,
                    _extends({
                      appearance: appearance,
                      autoDismiss: autoDismiss !== undefined ? autoDismiss : inheritedAutoDismiss,
                      autoDismissTimeout: autoDismissTimeout,
                      component: Toast,
                      key: id,
                      onDismiss: _this2.onDismiss(id, onDismiss),
                      placement: placement,
                      transitionDuration: transitionDuration,
                      transitionState: transitionState
                    }, unknownConsumerProps),
                    content
                  );
                }
              );
            })
          )
        ), portalTarget) : _react2.default.createElement(ToastContainer, { placement: placement, hasToasts: hasToasts }) // keep ReactDOM.hydrate happy

      );
    }
  }]);

  return ToastProvider;
}(_react.Component);

ToastProvider.defaultProps = {
  autoDismiss: false,
  autoDismissTimeout: 5000,
  components: defaultComponents,
  placement: 'top-right',
  transitionDuration: 220
};
var ToastConsumer = exports.ToastConsumer = function ToastConsumer(_ref3) {
  var children = _ref3.children;
  return _react2.default.createElement(
    Consumer,
    null,
    function (context) {
      return children(context);
    }
  );
};

var withToastManager = exports.withToastManager = function withToastManager(Comp
// $FlowFixMe `forwardRef`
) {
  return _react2.default.forwardRef(function (props, ref) {
    return _react2.default.createElement(
      ToastConsumer,
      null,
      function (context) {
        return _react2.default.createElement(Comp, _extends({ toastManager: context }, props, { ref: ref }));
      }
    );
  });
};

var useToasts = exports.useToasts = function useToasts() {
  var ctx = (0, _react.useContext)(ToastContext);

  if (!ctx) {
    throw Error('The `useToasts` hook must be called from a descendent of the `ToastProvider`.');
  }

  return {
    addToast: ctx.add,
    removeToast: ctx.remove,
    removeAllToasts: ctx.removeAll,
    updateToast: ctx.update,
    toastStack: ctx.toasts
  };
};

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastController = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTransitionGroup = __webpack_require__(161);

var _utils = __webpack_require__(623);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultAutoDismissTimeout = 5000;

var TimerType = {
  clear: _utils.NOOP,
  pause: _utils.NOOP,
  resume: _utils.NOOP
};

function Timer(callback, delay) {
  var timerId = void 0;
  var start = delay;
  var remaining = delay;

  this.clear = function () {
    clearTimeout(timerId);
  };

  this.pause = function () {
    clearTimeout(timerId);
    remaining -= Date.now() - start;
  };

  this.resume = function () {
    start = Date.now();
    clearTimeout(timerId);
    timerId = setTimeout(callback, remaining);
  };

  this.resume();
}

var ToastController = exports.ToastController = function (_Component) {
  _inherits(ToastController, _Component);

  function ToastController() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToastController);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToastController.__proto__ || Object.getPrototypeOf(ToastController)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isRunning: Boolean(_this.props.autoDismiss)
    }, _this.startTimer = function () {
      var _this$props = _this.props,
          autoDismiss = _this$props.autoDismiss,
          autoDismissTimeout = _this$props.autoDismissTimeout,
          onDismiss = _this$props.onDismiss;


      if (!autoDismiss) return;

      _this.setState({ isRunning: true });
      _this.timeout = new Timer(onDismiss, autoDismissTimeout);
    }, _this.clearTimer = function () {
      if (_this.timeout) _this.timeout.clear();
    }, _this.onMouseEnter = function () {
      _this.setState({ isRunning: false }, function () {
        if (_this.timeout) _this.timeout.pause();
      });
    }, _this.onMouseLeave = function () {
      _this.setState({ isRunning: true }, function () {
        if (_this.timeout) _this.timeout.resume();
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToastController, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startTimer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.autoDismiss !== this.props.autoDismiss) {
        var startOrClear = this.props.autoDismiss ? this.startTimer : this.clearTimer;

        startOrClear();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          autoDismiss = _props.autoDismiss,
          autoDismissTimeout = _props.autoDismissTimeout,
          Toast = _props.component,
          props = _objectWithoutProperties(_props, ['autoDismiss', 'autoDismissTimeout', 'component']);

      var isRunning = this.state.isRunning;

      // NOTE: conditions here so methods can be clean

      var handleMouseEnter = autoDismiss ? this.onMouseEnter : _utils.NOOP;
      var handleMouseLeave = autoDismiss ? this.onMouseLeave : _utils.NOOP;

      return _react2.default.createElement(Toast, _extends({
        autoDismiss: autoDismiss,
        autoDismissTimeout: autoDismissTimeout,
        isRunning: isRunning,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
      }, props));
    }
  }]);

  return ToastController;
}(_react.Component);

ToastController.defaultProps = {
  autoDismiss: false
};

/***/ }),
/* 2206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ErrorMessage; });
/* unused harmony export FastField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Field; });
/* unused harmony export FieldArray */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Form; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Formik; });
/* unused harmony export FormikConsumer */
/* unused harmony export FormikContext */
/* unused harmony export FormikProvider */
/* unused harmony export connect */
/* unused harmony export getActiveElement */
/* unused harmony export getIn */
/* unused harmony export insert */
/* unused harmony export isEmptyArray */
/* unused harmony export isEmptyChildren */
/* unused harmony export isFunction */
/* unused harmony export isInputEvent */
/* unused harmony export isInteger */
/* unused harmony export isNaN */
/* unused harmony export isObject */
/* unused harmony export isPromise */
/* unused harmony export isString */
/* unused harmony export move */
/* unused harmony export prepareDataForValidation */
/* unused harmony export replace */
/* unused harmony export setIn */
/* unused harmony export setNestedObjectValues */
/* unused harmony export swap */
/* unused harmony export useField */
/* unused harmony export useFormik */
/* unused harmony export useFormikContext */
/* unused harmony export validateYupSchema */
/* unused harmony export withFormik */
/* unused harmony export yupToFormErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fast_compare__ = __webpack_require__(2207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_deepmerge__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__ = __webpack_require__(2209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_clone__ = __webpack_require__(2212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_toPath__ = __webpack_require__(2272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_warning__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scheduler__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scheduler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_scheduler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_es_cloneDeep__ = __webpack_require__(2276);











function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/** @private is the value an empty array? */

var isEmptyArray = function isEmptyArray(value) {
  return Array.isArray(value) && value.length === 0;
};
/** @private is the given object a Function? */

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private is the given object a NaN? */
// eslint-disable-next-line no-self-compare

var isNaN$1 = function isNaN(obj) {
  return obj !== obj;
};
/** @private Does a React component have exactly 0 children? */

var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return isObject(value) && isFunction(value.then);
};
/** @private is the given object/value a type of synthetic event? */

var isInputEvent = function isInputEvent(value) {
  return value && isObject(value) && isObject(value.target);
};
/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?Document} doc Defaults to current document.
 * @return {Element | null}
 * @see https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/dom/getActiveElement.js
 */

function getActiveElement(doc) {
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_toPath__["a" /* default */])(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_clone__["a" /* default */])(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_toPath__["a" /* default */])(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = Object(__WEBPACK_IMPORTED_MODULE_4_lodash_es_clone__["a" /* default */])(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext =
/*#__PURE__*/
Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(undefined);
var FormikProvider = FormikContext.Provider;
var FormikConsumer = FormikContext.Consumer;
function useFormikContext() {
  var formik = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(FormikContext);
  !!!formik ?  false ? invariant(false, "Formik context is undefined, please verify you are calling useFormikContext() as child of a <Formik> component.") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(state.errors, msg.payload)) {
        return state;
      }

      return _extends({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends({}, state, {}, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.initialValues);
  var initialErrors = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.initialErrors || emptyErrors);
  var initialTouched = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.initialTouched || emptyTouched);
  var initialStatus = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(props.initialStatus);
  var isMounted = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);
  var fieldRegistry = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])({});

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !(typeof isInitialValid === 'undefined') ? process.env.NODE_ENV !== "production" ? invariant(false, 'isInitialValid has been deprecated and will be removed in future versions of Formik. Please use initialErrors or validateOnMount instead.') : invariant(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {
          if (false) {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validate />", actualException);
          }

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {
          // We throw any other errors
          if (false) {
            console.warn("Warning: An unhandled error was caught during validation in <Formik validationSchema />", err);
          }

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = __WEBPACK_IMPORTED_MODULE_2_deepmerge__["a" /* default */].all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run validations and dispatching the result as low-priority via rAF.
  //
  // The thinking is that validation as a result of onChange and onBlur
  // should never block user input. Note: This method should never be called
  // during the submission phase because validation prior to submission
  // is actaully high-priority since we absolutely need to guarantee the
  // form is valid before executing props.onSubmit.

  var validateFormWithLowPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_7_scheduler__["unstable_runWithPriority"])(__WEBPACK_IMPORTED_MODULE_7_scheduler__["unstable_LowPriority"], function () {
      return runAllValidations(values).then(function (combinedErrors) {
        if (!!isMounted.current) {
          dispatch({
            type: 'SET_ERRORS',
            payload: combinedErrors
          });
        }

        return combinedErrors;
      })["catch"](function (actualException) {
        if (false) {
          // Users can throw during validate, however they have no way of handling their error on touch / blur. In low priority, we need to handle it
          console.warn("Warning: An unhandled error was caught during low priority validation in <Formik validate />", actualException);
        }
      });
    });
  }); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });

        if (!__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(state.errors, combinedErrors)) {
          dispatch({
            type: 'SET_ERRORS',
            payload: combinedErrors
          });
        }
      }

      return combinedErrors;
    });
  });
  var resetForm = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialValues.current, props.initialValues)) {
      initialValues.current = props.initialValues;

      if (enableReinitialize) {
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithLowPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithLowPriority]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (enableReinitialize && isMounted.current === true && !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithLowPriority(state.values) : Promise.resolve();
  });
  var setErrors = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    dispatch({
      type: 'SET_VALUES',
      payload: values
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithLowPriority(values) : Promise.resolve();
  });
  var setFieldError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithLowPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && "production" !== "production") {
        warnAboutMissingIdentifier({
          htmlContent: outerHTML,
          documentationAnchorLink: 'handlechange-e-reactchangeeventany--void',
          handlerName: 'handleChange'
        });
      }

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : !!multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithLowPriority(state.values) : Promise.resolve();
  });
  var executeBlur = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && "production" !== "production") {
      warnAboutMissingIdentifier({
        htmlContent: outerHTML,
        documentationAnchorLink: 'handleblur-e-any--void',
        handlerName: 'handleBlur'
      });
    }

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a
    // specified `type` attribute during development. This mitigates
    // a common gotcha in forms with both reset and submit buttons,
    // where the dev forgets to add type="button" to the reset button.


    if (false) {
      // Safely get the active element (works with IE)
      var activeElement = getActiveElement();

      if (activeElement !== null && activeElement instanceof HTMLButtonElement) {
        !(activeElement.attributes && activeElement.attributes.getNamedItem('type')) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You submitted a Formik form using a button with an unspecified `type` attribute.  Most browsers default button elements to `type="submit"`. If this is not a submit button, please add `type="button"`.') : invariant(false) : void 0;
      }
    }

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (nameOrOptions) {
    var isAnObject = isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return !__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useImperativeHandle"])(innerRef, function () {
    return formikbag;
  });

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!props.render ? process.env.NODE_ENV !== "production" ? invariant(false, "<Formik render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Formik render={(props) => ...} /> with <Formik>{(props) => ...}</Formik>") : invariant(false) : void 0; // eslint-disable-next-line
    }, []);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FormikProvider, {
    value: formikbag
  }, component ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */])(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */])(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function (e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? Object(__WEBPACK_IMPORTED_MODULE_2_deepmerge__["a" /* default */])(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = Object(__WEBPACK_IMPORTED_MODULE_2_deepmerge__["a" /* default */])(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

function useEventCallback(fn) {
  var ref = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

function useField(propsOrFieldName) {
  var formik = useFormikContext();
  var getFieldProps = formik.getFieldProps,
      getFieldMeta = formik.getFieldMeta,
      getFieldHelpers = formik.getFieldHelpers,
      registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>

  var props = isAnObject ? propsOrFieldName : {
    name: propsOrFieldName
  };
  var fieldName = props.name,
      validateFn = props.validate;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (fieldName) {
      registerField(fieldName, {
        validate: validateFn
      });
    }

    return function () {
      if (fieldName) {
        unregisterField(fieldName);
      }
    };
  }, [registerField, unregisterField, fieldName, validateFn]);

  if (false) {
    !formik ? process.env.NODE_ENV !== "production" ? invariant(false, 'useField() / <Field /> must be used underneath a <Formik> component or withFormik() higher order component') : invariant(false) : void 0;
  }

  !fieldName ?  false ? invariant(false, 'Invalid field name. Either pass `useField` a string or an object containing a `name` key.') : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
  return [getFieldProps(props), getFieldMeta(fieldName), getFieldHelpers(fieldName)];
}
function Field(_ref) {
  var validate = _ref.validate,
      name = _ref.name,
      render = _ref.render,
      children = _ref.children,
      is = _ref.as,
      component = _ref.component,
      props = _objectWithoutPropertiesLoose(_ref, ["validate", "name", "render", "children", "as", "component"]);

  var _useFormikContext = useFormikContext(),
      formik = _objectWithoutPropertiesLoose(_useFormikContext, ["validate", "validationSchema"]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(function () {
      !!render ? process.env.NODE_ENV !== "production" ? invariant(false, "<Field render> has been deprecated and will be removed in future versions of Formik. Please use a child callback function instead. To get rid of this warning, replace <Field name=\"" + name + "\" render={({field, form}) => ...} /> with <Field name=\"" + name + "\">{({field, form, meta}) => ...}</Field>") : invariant(false) : void 0;
      !!(is && children && isFunction(children)) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You should not use <Field as> and <Field children> as a function in the same <Field> component; <Field as> will be ignored.') : invariant(false) : void 0;
      !!(component && children && isFunction(children)) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You should not use <Field component> and <Field children> as a function in the same <Field> component; <Field component> will be ignored.') : invariant(false) : void 0;
      !!(render && children && !isEmptyChildren(children)) ? process.env.NODE_ENV !== "production" ? invariant(false, 'You should not use <Field render> and <Field children> in the same <Field> component; <Field children> will be ignored') : invariant(false) : void 0; // eslint-disable-next-line
    }, []);
  } // Register field and field-level validation with parent <Formik>


  var registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    registerField(name, {
      validate: validate
    });
    return function () {
      unregisterField(name);
    };
  }, [registerField, unregisterField, name, validate]);
  var field = formik.getFieldProps(_extends({
    name: name
  }, props));
  var meta = formik.getFieldMeta(name);
  var legacyBag = {
    field: field,
    form: formik
  };

  if (render) {
    return render(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (isFunction(children)) {
    return children(_extends({}, legacyBag, {
      meta: meta
    }));
  }

  if (component) {
    // This behavior is backwards compat with earlier Formik 0.9 to 1.x
    if (typeof component === 'string') {
      var innerRef = props.innerRef,
          rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({
        ref: innerRef
      }, field, {}, rest), children);
    } // We don't pass `meta` for backwards compat


    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({
      field: field,
      form: formik
    }, props), children);
  } // default to input here so we can check for both `as` and `children` above


  var asElement = is || 'input';

  if (typeof asElement === 'string') {
    var _innerRef = props.innerRef,
        _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(asElement, _extends({
      ref: _innerRef
    }, field, {}, _rest), children);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(asElement, _extends({}, field, {}, props), children);
}

var Form =
/*#__PURE__*/
Object(__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"])(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action || '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';

/**
 * A public higher-order component to access the imperative API
 */

function withFormik(_ref) {
  var _ref$mapPropsToValues = _ref.mapPropsToValues,
      mapPropsToValues = _ref$mapPropsToValues === void 0 ? function (vanillaProps) {
    var val = {};

    for (var k in vanillaProps) {
      if (vanillaProps.hasOwnProperty(k) && typeof vanillaProps[k] !== 'function') {
        // @todo TypeScript fix
        val[k] = vanillaProps[k];
      }
    }

    return val;
  } : _ref$mapPropsToValues,
      config = _objectWithoutPropertiesLoose(_ref, ["mapPropsToValues"]);

  return function createFormik(Component$1) {
    var componentDisplayName = Component$1.displayName || Component$1.name || Component$1.constructor && Component$1.constructor.name || 'Component';
    /**
     * We need to use closures here for to provide the wrapped component's props to
     * the respective withFormik config methods.
     */

    var C =
    /*#__PURE__*/
    function (_React$Component) {
      _inheritsLoose(C, _React$Component);

      function C() {
        var _this;

        _this = _React$Component.apply(this, arguments) || this;

        _this.validate = function (values) {
          return config.validate(values, _this.props);
        };

        _this.validationSchema = function () {
          return isFunction(config.validationSchema) ? config.validationSchema(_this.props) : config.validationSchema;
        };

        _this.handleSubmit = function (values, actions) {
          return config.handleSubmit(values, _extends({}, actions, {
            props: _this.props
          }));
        };
        /**
         * Just avoiding a render callback for perf here
         */


        _this.renderFormComponent = function (formikProps) {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Component$1, Object.assign({}, _this.props, formikProps));
        };

        return _this;
      }

      var _proto = C.prototype;

      _proto.render = function render() {
        var _this$props = this.props,
            props = _objectWithoutPropertiesLoose(_this$props, ["children"]);

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Formik, Object.assign({}, props, config, {
          validate: config.validate && this.validate,
          validationSchema: config.validationSchema && this.validationSchema,
          initialValues: mapPropsToValues(this.props),
          initialStatus: config.mapPropsToStatus && config.mapPropsToStatus(this.props),
          initialErrors: config.mapPropsToErrors && config.mapPropsToErrors(this.props),
          initialTouched: config.mapPropsToTouched && config.mapPropsToTouched(this.props),
          onSubmit: this.handleSubmit,
          children: this.renderFormComponent
        }));
      };

      return C;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    C.displayName = "WithFormik(" + componentDisplayName + ")";
    return __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default()(C, Component$1 // cast type to ComponentClass (even if SFC)
    );
  };
}

/**
 * Connect any component to Formik context, and inject as a prop called `formik`;
 * @param Comp React Component
 */

function connect(Comp) {
  var C = function C(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(FormikConsumer, null, function (formik) {
      !!!formik ?  false ? invariant(false, "Formik context is undefined, please verify you are rendering <Form>, <Field>, <FastField>, <FieldArray>, or your custom context-using component as a child of a <Formik> component. Component name: " + Comp.name) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(Comp, Object.assign({}, props, {
        formik: formik
      }));
    });
  };

  var componentDisplayName = Comp.displayName || Comp.name || Comp.constructor && Comp.constructor.name || 'Component'; // Assign Comp to C.WrappedComponent so we can access the inner component in tests
  // For example, <Field.WrappedComponent /> gets us <FieldInner/>

  C.WrappedComponent = Comp;
  C.displayName = "FormikConnect(" + componentDisplayName + ")";
  return __WEBPACK_IMPORTED_MODULE_8_hoist_non_react_statics___default()(C, Comp // cast type to ComponentClass (even if SFC)
  );
}

/**
 * Some array helpers!
 */

var move = function move(array, from, to) {
  var copy = copyArrayLike(array);
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function swap(arrayLike, indexA, indexB) {
  var copy = copyArrayLike(arrayLike);
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function insert(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy.splice(index, 0, value);
  return copy;
};
var replace = function replace(arrayLike, index, value) {
  var copy = copyArrayLike(arrayLike);
  copy[index] = value;
  return copy;
};

var copyArrayLike = function copyArrayLike(arrayLike) {
  if (!arrayLike) {
    return [];
  } else if (Array.isArray(arrayLike)) {
    return [].concat(arrayLike);
  } else {
    var maxIndex = Object.keys(arrayLike).map(function (key) {
      return parseInt(key);
    }).reduce(function (max, el) {
      return el > max ? el : max;
    }, 0);
    return Array.from(_extends({}, arrayLike, {
      length: maxIndex + 1
    }));
  }
};

var FieldArrayInner =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FieldArrayInner, _React$Component);

  function FieldArrayInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.updateArrayField = function (fn, alterTouched, alterErrors) {
      var _this$props = _this.props,
          name = _this$props.name,
          setFormikState = _this$props.formik.setFormikState;
      setFormikState(function (prevState) {
        var updateErrors = typeof alterErrors === 'function' ? alterErrors : fn;
        var updateTouched = typeof alterTouched === 'function' ? alterTouched : fn; // values fn should be executed before updateErrors and updateTouched,
        // otherwise it causes an error with unshift.

        var values = setIn(prevState.values, name, fn(getIn(prevState.values, name)));
        var fieldError = alterErrors ? updateErrors(getIn(prevState.errors, name)) : undefined;
        var fieldTouched = alterTouched ? updateTouched(getIn(prevState.touched, name)) : undefined;

        if (isEmptyArray(fieldError)) {
          fieldError = undefined;
        }

        if (isEmptyArray(fieldTouched)) {
          fieldTouched = undefined;
        }

        return _extends({}, prevState, {
          values: values,
          errors: alterErrors ? setIn(prevState.errors, name, fieldError) : prevState.errors,
          touched: alterTouched ? setIn(prevState.touched, name, fieldTouched) : prevState.touched
        });
      });
    };

    _this.push = function (value) {
      return _this.updateArrayField(function (arrayLike) {
        return [].concat(copyArrayLike(arrayLike), [Object(__WEBPACK_IMPORTED_MODULE_9_lodash_es_cloneDeep__["a" /* default */])(value)]);
      }, false, false);
    };

    _this.handlePush = function (value) {
      return function () {
        return _this.push(value);
      };
    };

    _this.swap = function (indexA, indexB) {
      return _this.updateArrayField(function (array) {
        return swap(array, indexA, indexB);
      }, true, true);
    };

    _this.handleSwap = function (indexA, indexB) {
      return function () {
        return _this.swap(indexA, indexB);
      };
    };

    _this.move = function (from, to) {
      return _this.updateArrayField(function (array) {
        return move(array, from, to);
      }, true, true);
    };

    _this.handleMove = function (from, to) {
      return function () {
        return _this.move(from, to);
      };
    };

    _this.insert = function (index, value) {
      return _this.updateArrayField(function (array) {
        return insert(array, index, value);
      }, function (array) {
        return insert(array, index, null);
      }, function (array) {
        return insert(array, index, null);
      });
    };

    _this.handleInsert = function (index, value) {
      return function () {
        return _this.insert(index, value);
      };
    };

    _this.replace = function (index, value) {
      return _this.updateArrayField(function (array) {
        return replace(array, index, value);
      }, false, false);
    };

    _this.handleReplace = function (index, value) {
      return function () {
        return _this.replace(index, value);
      };
    };

    _this.unshift = function (value) {
      var length = -1;

      _this.updateArrayField(function (array) {
        var arr = array ? [value].concat(array) : [value];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      }, function (array) {
        var arr = array ? [null].concat(array) : [null];

        if (length < 0) {
          length = arr.length;
        }

        return arr;
      });

      return length;
    };

    _this.handleUnshift = function (value) {
      return function () {
        return _this.unshift(value);
      };
    };

    _this.handleRemove = function (index) {
      return function () {
        return _this.remove(index);
      };
    };

    _this.handlePop = function () {
      return function () {
        return _this.pop();
      };
    }; // We need TypeScript generics on these, so we'll bind them in the constructor
    // @todo Fix TS 3.2.1


    _this.remove = _this.remove.bind(_assertThisInitialized(_this));
    _this.pop = _this.pop.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = FieldArrayInner.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!__WEBPACK_IMPORTED_MODULE_1_react_fast_compare___default()(getIn(prevProps.formik.values, prevProps.name), getIn(this.props.formik.values, this.props.name)) && this.props.formik.validateOnChange) {
      this.props.formik.validateForm(this.props.formik.values);
    }
  };

  _proto.remove = function remove(index) {
    // We need to make sure we also remove relevant pieces of `touched` and `errors`
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var copy = array ? copyArrayLike(array) : [];

      if (!result) {
        result = copy[index];
      }

      if (isFunction(copy.splice)) {
        copy.splice(index, 1);
      }

      return copy;
    }, true, true);
    return result;
  };

  _proto.pop = function pop() {
    // Remove relevant pieces of `touched` and `errors` too!
    var result;
    this.updateArrayField( // so this gets call 3 times
    function (array) {
      var tmp = array;

      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }

      return tmp;
    }, true, true);
    return result;
  };

  _proto.render = function render() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };

    var _this$props2 = this.props,
        component = _this$props2.component,
        render = _this$props2.render,
        children = _this$props2.children,
        name = _this$props2.name,
        _this$props2$formik = _this$props2.formik,
        restOfFormik = _objectWithoutPropertiesLoose(_this$props2$formik, ["validate", "validationSchema"]);

    var props = _extends({}, arrayHelpers, {
      form: restOfFormik,
      name: name
    });

    return component ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, props) : render ? render(props) : children // children come last, always called
    ? typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children) : null : null;
  };

  return FieldArrayInner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FieldArrayInner.defaultProps = {
  validateOnChange: true
};
var FieldArray =
/*#__PURE__*/
connect(FieldArrayInner);

var ErrorMessageImpl =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ErrorMessageImpl, _React$Component);

  function ErrorMessageImpl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ErrorMessageImpl.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (getIn(this.props.formik.errors, this.props.name) !== getIn(props.formik.errors, this.props.name) || getIn(this.props.formik.touched, this.props.name) !== getIn(props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length) {
      return true;
    } else {
      return false;
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        component = _this$props.component,
        formik = _this$props.formik,
        render = _this$props.render,
        children = _this$props.children,
        name = _this$props.name,
        rest = _objectWithoutPropertiesLoose(_this$props, ["component", "formik", "render", "children", "name"]);

    var touch = getIn(formik.touched, name);
    var error = getIn(formik.errors, name);
    return !!touch && !!error ? render ? isFunction(render) ? render(error) : null : children ? isFunction(children) ? children(error) : null : component ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, rest, error) : error : null;
  };

  return ErrorMessageImpl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var ErrorMessage =
/*#__PURE__*/
connect(ErrorMessageImpl);

/**
 * Custom Field component for quickly hooking into Formik
 * context and wiring up forms.
 */

var FastFieldInner =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FastFieldInner, _React$Component);

  function FastFieldInner(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    var render = props.render,
        children = props.children,
        component = props.component,
        is = props.as,
        name = props.name;
    !!render ?  false ? invariant(false, "<FastField render> has been deprecated. Please use a child callback function instead: <FastField name={" + name + "}>{props => ...}</FastField> instead.") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    !!(component && render) ?  false ? invariant(false, 'You should not use <FastField component> and <FastField render> in the same <FastField> component; <FastField component> will be ignored') : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    !!(is && children && isFunction(children)) ?  false ? invariant(false, 'You should not use <FastField as> and <FastField children> as a function in the same <FastField> component; <FastField as> will be ignored.') : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    !!(component && children && isFunction(children)) ?  false ? invariant(false, 'You should not use <FastField component> and <FastField children> as a function in the same <FastField> component; <FastField component> will be ignored.') : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    !!(render && children && !isEmptyChildren(children)) ?  false ? invariant(false, 'You should not use <FastField render> and <FastField children> in the same <FastField> component; <FastField children> will be ignored') : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_warning__["a" /* default */])(false) : void 0;
    return _this;
  }

  var _proto = FastFieldInner.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(props) {
    if (this.props.shouldUpdate) {
      return this.props.shouldUpdate(props, this.props);
    } else if (props.name !== this.props.name || getIn(props.formik.values, this.props.name) !== getIn(this.props.formik.values, this.props.name) || getIn(props.formik.errors, this.props.name) !== getIn(this.props.formik.errors, this.props.name) || getIn(props.formik.touched, this.props.name) !== getIn(this.props.formik.touched, this.props.name) || Object.keys(this.props).length !== Object.keys(props).length || props.formik.isSubmitting !== this.props.formik.isSubmitting) {
      return true;
    } else {
      return false;
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    // Register the Field with the parent Formik. Parent will cycle through
    // registered Field's validate fns right prior to submit
    this.props.formik.registerField(this.props.name, {
      validate: this.props.validate
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }

    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.formik.unregisterField(this.props.name);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        name = _this$props.name,
        render = _this$props.render,
        is = _this$props.as,
        children = _this$props.children,
        component = _this$props.component,
        formik = _this$props.formik,
        props = _objectWithoutPropertiesLoose(_this$props, ["validate", "name", "render", "as", "children", "component", "shouldUpdate", "formik"]);

    var restOfFormik = _objectWithoutPropertiesLoose(formik, ["validate", "validationSchema"]);

    var field = {
      value: props.type === 'radio' || props.type === 'checkbox' ? props.value // React uses checked={} for these inputs
      : getIn(formik.values, name),
      name: name,
      onChange: formik.handleChange,
      onBlur: formik.handleBlur
    };
    var meta = {
      value: getIn(formik.values, name),
      error: getIn(formik.errors, name),
      touched: !!getIn(formik.touched, name),
      initialValue: getIn(formik.initialValues, name),
      initialTouched: !!getIn(formik.initialTouched, name),
      initialError: getIn(formik.initialErrors, name)
    };
    var bag = {
      field: field,
      meta: meta,
      form: restOfFormik
    };

    if (render) {
      return render(bag);
    }

    if (isFunction(children)) {
      return children(bag);
    }

    if (component) {
      // This behavior is backwards compat with earlier Formik 0.9 to 1.x
      if (typeof component === 'string') {
        var innerRef = props.innerRef,
            rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({
          ref: innerRef
        }, field, {}, rest), children);
      } // We don't pass `meta` for backwards compat


      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({
        field: field,
        form: formik
      }, props), children);
    } // default to input here so we can check for both `as` and `children` above


    var asElement = is || 'input';

    if (typeof asElement === 'string') {
      var _innerRef = props.innerRef,
          _rest = _objectWithoutPropertiesLoose(props, ["innerRef"]);

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(asElement, _extends({
        ref: _innerRef
      }, field, {}, _rest), children);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(asElement, _extends({}, field, {}, props), children);
  };

  return FastFieldInner;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var FastField =
/*#__PURE__*/
connect(FastFieldInner);


//# sourceMappingURL=formik.esm.js.map


/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["a"] = (deepmerge_1);


/***/ }),
/* 2209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(166);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(275);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 2211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(625);


/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ __webpack_exports__["a"] = (clone);


/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 2214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(432);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(432);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 2216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(432);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(432);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 2218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(431);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 2221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 2222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(629);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(1065);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(2225);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 2225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(147);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 2226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 2227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(2228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(628);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 2228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(2229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(2230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(2231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(2233);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(433);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 2230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(433);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(433);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 2233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(433);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(434);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(434);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(434);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(434);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEach);


/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(220);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(277);



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssign);


/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 2245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(166);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(2247);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 2247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1063);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 2248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(636);



/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignIn);


/***/ }),
/* 2249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(2250);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 2250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(147);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(437)(module)))

/***/ }),
/* 2252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(638);



/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbols);


/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 2254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(1072);



/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(source, Object(__WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */])(source), object);
}

/* harmony default export */ __webpack_exports__["a"] = (copySymbolsIn);


/***/ }),
/* 2255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(636);




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeysIn);


/***/ }),
/* 2256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(147);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 2257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(147);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 2258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(147);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 2259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(147);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 2260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneArray);


/***/ }),
/* 2261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__ = __webpack_require__(2262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__ = __webpack_require__(2263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__ = __webpack_require__(2264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__ = __webpack_require__(2265);






/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return Object(__WEBPACK_IMPORTED_MODULE_1__cloneDataView_js__["a" /* default */])(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return Object(__WEBPACK_IMPORTED_MODULE_4__cloneTypedArray_js__["a" /* default */])(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return Object(__WEBPACK_IMPORTED_MODULE_2__cloneRegExp_js__["a" /* default */])(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return Object(__WEBPACK_IMPORTED_MODULE_3__cloneSymbol_js__["a" /* default */])(object);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneByTag);


/***/ }),
/* 2262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(639);


/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDataView);


/***/ }),
/* 2263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneRegExp);


/***/ }),
/* 2264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(275);


/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/* harmony default export */ __webpack_exports__["a"] = (cloneSymbol);


/***/ }),
/* 2265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(639);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 2266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(2267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(634);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 2267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(276);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 2268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__ = __webpack_require__(2269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(633);




/* Node.js helper references. */
var nodeIsMap = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsMap) : __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isMap);


/***/ }),
/* 2269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == mapTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMap);


/***/ }),
/* 2270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__ = __webpack_require__(2271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(633);




/* Node.js helper references. */
var nodeIsSet = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsSet) : __WEBPACK_IMPORTED_MODULE_0__baseIsSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isSet);


/***/ }),
/* 2271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(166);



/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == setTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsSet);


/***/ }),
/* 2272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(278);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 2273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(2274);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 2274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(629);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 2275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(438);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 2276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(625);


/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDeep);


/***/ }),
/* 2277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ThemeProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useTheme; });
/* unused harmony export withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(2278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_core__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_extends__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);







function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var getTheme = function getTheme(outerTheme, theme) {
  if (typeof theme === 'function') {
    var mergedTheme = theme(outerTheme);

    if (false) {
      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
    }

    return mergedTheme;
  }

  if (false) {
    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
  }

  return _objectSpread({}, outerTheme, {}, theme);
};

var createCacheWithTheme = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (outerTheme) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__emotion_weak_memoize__["a" /* default */])(function (theme) {
    return getTheme(outerTheme, theme);
  });
});

var ThemeProvider = function ThemeProvider(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["ThemeContext"].Consumer, null, function (theme) {
    if (props.theme !== theme) {
      theme = createCacheWithTheme(theme)(props.theme);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["ThemeContext"].Provider, {
      value: theme
    }, props.children);
  });
};

// should we change this to be forwardRef/withCSSContext style so it doesn't merge with props?
function withTheme(Component) {
  var componentName = Component.displayName || Component.name || 'Component';

  var render = function render(props, ref) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["ThemeContext"].Consumer, null, function (theme) {
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Component, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_extends___default()({
        theme: theme,
        ref: ref
      }, props));
    });
  }; // $FlowFixMe


  var WithTheme = Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(render);
  WithTheme.displayName = "WithTheme(" + componentName + ")";
  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component);
}

function useTheme() {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_2__emotion_core__["ThemeContext"]);
}




/***/ }),
/* 2278 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 2279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__ = __webpack_require__(2280);


var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = __WEBPACK_IMPORTED_MODULE_0__emotion_styled_base__["a" /* default */].bind();
tags.forEach(function (tagName) {
  newStyled[tagName] = newStyled(tagName);
});

/* harmony default export */ __webpack_exports__["a"] = (newStyled);


/***/ }),
/* 2280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_is_prop_valid__ = __webpack_require__(2281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_core__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__emotion_utils__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__emotion_serialize__ = __webpack_require__(621);







var testOmitPropsOnStringTag = __WEBPACK_IMPORTED_MODULE_2__emotion_is_prop_valid__["a" /* default */];

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme' && key !== 'innerRef';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";

var Noop = function Noop() {
  return null;
};

var createStyled = function createStyled(tag, options) {
  if (false) {
    if (tag === undefined) {
      throw new Error('You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.');
    }
  }

  var identifierName;
  var shouldForwardProp;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && // $FlowFixMe
      options.shouldForwardProp(propName);
    } : options.shouldForwardProp;
  }

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {
      if (false) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {
        if (false) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = Object(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["withEmotionCache"])(function (props, context, ref) {
      return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_3__emotion_core__["ThemeContext"].Consumer, null, function (theme) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = theme;
        }

        if (typeof props.className === 'string') {
          className = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["a" /* getRegisteredStyles */])(context.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = Object(__WEBPACK_IMPORTED_MODULE_5__emotion_serialize__["a" /* serializeStyles */])(styles.concat(classInterpolations), context.registered, mergedProps);
        var rules = Object(__WEBPACK_IMPORTED_MODULE_4__emotion_utils__["b" /* insertStyles */])(context, serialized, typeof finalTag === 'string');
        className += context.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if ( // $FlowFixMe
          finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;
        newProps.ref = ref || props.innerRef;

        if (false) {
          console.error('`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead' + (identifierName === undefined ? '' : " in the usage of `" + identifierName + "`"));
        }

        var ele = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(finalTag, newProps);
        var possiblyStyleElement = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Noop, null);


        return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null, possiblyStyleElement, ele);
      });
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {
          return 'NO_COMPONENT_SELECTOR';
        } // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, nextOptions !== undefined ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
    };

    return Styled;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createStyled);


/***/ }),
/* 2281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(1061);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && objectToString.call(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(57);

var _AlphaPointer = __webpack_require__(2446);

var _AlphaPointer2 = _interopRequireDefault(_AlphaPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPicker = exports.AlphaPicker = function AlphaPicker(_ref) {
  var rgb = _ref.rgb,
      hsl = _ref.hsl,
      width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      direction = _ref.direction,
      style = _ref.style,
      renderers = _ref.renderers,
      pointer = _ref.pointer,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      alpha: {
        radius: '2px',
        style: style
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'alpha-picker ' + className },
    _react2.default.createElement(_common.Alpha, _extends({}, styles.alpha, {
      rgb: rgb,
      hsl: hsl,
      pointer: pointer,
      renderers: renderers,
      onChange: onChange,
      direction: direction
    }))
  );
};

AlphaPicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _AlphaPointer2.default
};

exports.default = (0, _common.ColorWrap)(AlphaPicker);

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flattenNames = undefined;

var _isString2 = __webpack_require__(2286);

var _isString3 = _interopRequireDefault(_isString2);

var _forOwn2 = __webpack_require__(641);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _isPlainObject2 = __webpack_require__(2298);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _map2 = __webpack_require__(2299);

var _map3 = _interopRequireDefault(_map2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = exports.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

exports.default = flattenNames;

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isArray = __webpack_require__(123),
    isObjectLike = __webpack_require__(196);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(2288);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 2288 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 2289 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isObjectLike = __webpack_require__(196);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 2291 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    isLength = __webpack_require__(643),
    isObjectLike = __webpack_require__(196);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 2293 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(775);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(644),
    nativeKeys = __webpack_require__(2296);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1084);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(1085);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(195),
    getPrototype = __webpack_require__(645),
    isObjectLike = __webpack_require__(196);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(799),
    baseIteratee = __webpack_require__(2300),
    baseMap = __webpack_require__(2329),
    isArray = __webpack_require__(123);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(2301),
    baseMatchesProperty = __webpack_require__(2322),
    identity = __webpack_require__(1085),
    isArray = __webpack_require__(123),
    property = __webpack_require__(2326);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2302),
    getMatchData = __webpack_require__(2321),
    matchesStrictComparable = __webpack_require__(1097);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(646),
    baseIsEqual = __webpack_require__(1086);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(376);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 2304 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 2305 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 2306 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(376),
    Map = __webpack_require__(529),
    MapCache = __webpack_require__(527);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(646),
    equalArrays = __webpack_require__(1087),
    equalByTag = __webpack_require__(2314),
    equalObjects = __webpack_require__(2315),
    getTag = __webpack_require__(1095),
    isArray = __webpack_require__(123),
    isBuffer = __webpack_require__(642),
    isTypedArray = __webpack_require__(1083);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(527),
    setCacheAdd = __webpack_require__(2310),
    setCacheHas = __webpack_require__(2311);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 2310 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 2311 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 2312 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 2313 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(303),
    Uint8Array = __webpack_require__(1088),
    eq = __webpack_require__(528),
    equalArrays = __webpack_require__(1087),
    mapToArray = __webpack_require__(1089),
    setToArray = __webpack_require__(1090);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(1091);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 2316 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(198),
    root = __webpack_require__(122);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(198),
    root = __webpack_require__(122);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(198),
    root = __webpack_require__(122);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(198),
    root = __webpack_require__(122);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(1096),
    keys = __webpack_require__(331);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1086),
    get = __webpack_require__(794),
    hasIn = __webpack_require__(2323),
    isKey = __webpack_require__(526),
    isStrictComparable = __webpack_require__(1096),
    matchesStrictComparable = __webpack_require__(1097),
    toKey = __webpack_require__(379);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(2324),
    hasPath = __webpack_require__(2325);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 2324 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(796),
    isArguments = __webpack_require__(1081),
    isArray = __webpack_require__(123),
    isIndex = __webpack_require__(1082),
    isLength = __webpack_require__(643),
    toKey = __webpack_require__(379);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(2327),
    basePropertyDeep = __webpack_require__(2328),
    isKey = __webpack_require__(526),
    toKey = __webpack_require__(379);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 2327 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(795);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(2330),
    isArrayLike = __webpack_require__(439);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1079),
    createBaseEach = __webpack_require__(2331);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(439);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeClasses = undefined;

var _forOwn2 = __webpack_require__(641);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _cloneDeep2 = __webpack_require__(2333);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = exports.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

exports.default = mergeClasses;

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(2334);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(646),
    arrayEach = __webpack_require__(2335),
    assignValue = __webpack_require__(1098),
    baseAssign = __webpack_require__(2337),
    baseAssignIn = __webpack_require__(2338),
    cloneBuffer = __webpack_require__(2341),
    copyArray = __webpack_require__(2342),
    copySymbols = __webpack_require__(2343),
    copySymbolsIn = __webpack_require__(2344),
    getAllKeys = __webpack_require__(1091),
    getAllKeysIn = __webpack_require__(2345),
    getTag = __webpack_require__(1095),
    initCloneArray = __webpack_require__(2346),
    initCloneByTag = __webpack_require__(2347),
    initCloneObject = __webpack_require__(2356),
    isArray = __webpack_require__(123),
    isBuffer = __webpack_require__(642),
    isObject = __webpack_require__(155),
    keys = __webpack_require__(331);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 2335 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(198);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(440),
    keys = __webpack_require__(331);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(440),
    keysIn = __webpack_require__(1100);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(155),
    isPrototype = __webpack_require__(644),
    nativeKeysIn = __webpack_require__(2340);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 2340 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(122);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 2342 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(440),
    getSymbols = __webpack_require__(647);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(440),
    getSymbolsIn = __webpack_require__(1101);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(1092),
    getSymbolsIn = __webpack_require__(1101),
    keysIn = __webpack_require__(1100);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 2346 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(648),
    cloneDataView = __webpack_require__(2348),
    cloneMap = __webpack_require__(2349),
    cloneRegExp = __webpack_require__(2351),
    cloneSet = __webpack_require__(2352),
    cloneSymbol = __webpack_require__(2354),
    cloneTypedArray = __webpack_require__(2355);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(648);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(2350),
    arrayReduce = __webpack_require__(1102),
    mapToArray = __webpack_require__(1089);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 2350 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 2351 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(2353),
    arrayReduce = __webpack_require__(1102),
    setToArray = __webpack_require__(1090);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 2353 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(303);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(648);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(2357),
    getPrototype = __webpack_require__(645),
    isPrototype = __webpack_require__(644);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(155);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autoprefix = undefined;

var _forOwn2 = __webpack_require__(641);

var _forOwn3 = _interopRequireDefault(_forOwn2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = exports.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

exports.default = autoprefix;

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = exports.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Hover;
  }(_react2.default.Component);
};

exports.default = hover;

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.active = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = exports.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2.default.createElement(Component, _extends({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    return Active;
  }(_react2.default.Component);
};

exports.default = active;

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

exports.default = loopable;

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alpha = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _alpha = __webpack_require__(2363);

var alpha = _interopRequireWildcard(_alpha);

var _Checkboard = __webpack_require__(649);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = exports.Alpha = function (_ref) {
  _inherits(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2.default.createElement(
        'div',
        { style: styles.alpha },
        _react2.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2.default.createElement(_Checkboard2.default, { renderers: this.props.renderers })
        ),
        _react2.default.createElement('div', { style: styles.gradient }),
        _react2.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(_react.PureComponent || _react.Component);

exports.default = Alpha;

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var checkboardCache = {};

var render = exports.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

var get = exports.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditableInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var EditableInput = exports.EditableInput = function (_ref) {
  _inherits(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck(this, EditableInput);

    var _this = _possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };
    return _this;
  }

  _createClass(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2.default.createElement(
        'div',
        { style: styles.wrap },
        _react2.default.createElement('input', {
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? _react2.default.createElement(
          'span',
          { style: styles.label, onMouseDown: this.handleMouseDown },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(_react.PureComponent || _react.Component);

exports.default = EditableInput;

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hue = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _hue = __webpack_require__(2367);

var hue = _interopRequireWildcard(_hue);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = exports.Hue = function (_ref) {
  _inherits(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2.default.createElement(
        'div',
        { style: styles.hue },
        _react2.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(_react.PureComponent || _react.Component);

exports.default = Hue;

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }
  return null;
};

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Raised = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = exports.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return _react2.default.createElement(
    'div',
    { style: styles.wrap },
    _react2.default.createElement('div', { style: styles.bg }),
    _react2.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2.default.string,
  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2.default.number,
  styles: _propTypes2.default.object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

exports.default = Raised;

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(650),
    assignMergeValue = __webpack_require__(1105),
    baseFor = __webpack_require__(1107),
    baseMergeDeep = __webpack_require__(2399),
    isObject = __webpack_require__(133),
    keysIn = __webpack_require__(1112),
    safeGet = __webpack_require__(1111);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 2370 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(442);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(442);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(442);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(442);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(441);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 2376 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 2377 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 2378 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(441),
    Map = __webpack_require__(651),
    MapCache = __webpack_require__(653);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(652),
    isMasked = __webpack_require__(2383),
    isObject = __webpack_require__(133),
    toSource = __webpack_require__(1104);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(443);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 2382 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(2384);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(132);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 2385 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(2387),
    ListCache = __webpack_require__(441),
    Map = __webpack_require__(651);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(2388),
    hashDelete = __webpack_require__(2389),
    hashGet = __webpack_require__(2390),
    hashHas = __webpack_require__(2391),
    hashSet = __webpack_require__(2392);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(444);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 2389 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(444);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(444);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(444);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(445);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 2394 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(445);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(445);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(445);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 2398 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(1105),
    cloneBuffer = __webpack_require__(2400),
    cloneTypedArray = __webpack_require__(2401),
    copyArray = __webpack_require__(2403),
    initCloneObject = __webpack_require__(2404),
    isArguments = __webpack_require__(656),
    isArray = __webpack_require__(134),
    isArrayLikeObject = __webpack_require__(2407),
    isBuffer = __webpack_require__(658),
    isFunction = __webpack_require__(652),
    isObject = __webpack_require__(133),
    isPlainObject = __webpack_require__(2409),
    isTypedArray = __webpack_require__(659),
    safeGet = __webpack_require__(1111),
    toPlainObject = __webpack_require__(2413);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(132);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(2402);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(1108);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 2403 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(2405),
    getPrototype = __webpack_require__(1109),
    isPrototype = __webpack_require__(655);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(133);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(279),
    isObjectLike = __webpack_require__(222);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(280),
    isObjectLike = __webpack_require__(222);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 2408 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(279),
    getPrototype = __webpack_require__(1109),
    isObjectLike = __webpack_require__(222);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(279),
    isLength = __webpack_require__(657),
    isObjectLike = __webpack_require__(222);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 2411 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(1103);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(2414),
    keysIn = __webpack_require__(1112);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(2415),
    baseAssignValue = __webpack_require__(654);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(654),
    eq = __webpack_require__(332);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 2416 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(133),
    isPrototype = __webpack_require__(655),
    nativeKeysIn = __webpack_require__(2418);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 2418 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(2420),
    isIterateeCall = __webpack_require__(2427);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(446),
    overRest = __webpack_require__(2421),
    setToString = __webpack_require__(2423);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(2422);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 2422 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(2424),
    shortOut = __webpack_require__(2426);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(2425),
    defineProperty = __webpack_require__(1106),
    identity = __webpack_require__(446);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 2425 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 2426 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(332),
    isArrayLike = __webpack_require__(280),
    isIndex = __webpack_require__(660),
    isObject = __webpack_require__(133);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Saturation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _throttle = __webpack_require__(2429);

var _throttle2 = _interopRequireDefault(_throttle);

var _saturation = __webpack_require__(2434);

var saturation = _interopRequireWildcard(_saturation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = exports.Saturation = function (_ref) {
  _inherits(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck(this, Saturation);

    var _this = _possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation.calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2.default.createElement(this.props.pointer, this.props) : _react2.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(_react.PureComponent || _react.Component);

exports.default = Saturation;

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(1114),
    isObject = __webpack_require__(133);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(132);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(2432),
    isObject = __webpack_require__(133),
    isSymbol = __webpack_require__(447);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(2433);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 2433 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculateChange = exports.calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2436);


/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(2437),
    baseEach = __webpack_require__(1116),
    castFunction = __webpack_require__(2442),
    isArray = __webpack_require__(134);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 2437 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1107),
    keys = __webpack_require__(661);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(655),
    nativeKeys = __webpack_require__(2440);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1110);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(280);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(446);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);


/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _interaction = __webpack_require__(2445);

var _Checkboard = __webpack_require__(649);

var _Checkboard2 = _interopRequireDefault(_Checkboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = exports.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2.default)({
    default: {
      swatch: _extends({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2.default.createElement(
    'div',
    _extends({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2.default.createElement(_Checkboard2.default, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

exports.default = (0, _interaction.handleFocus)(Swatch);

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFocus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


var handleFocus = exports.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Focus, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          _react2.default.createElement(Component, _extends({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(_react2.default.Component);
};

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlphaPointer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlphaPointer = exports.AlphaPointer = function AlphaPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = AlphaPointer;

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Block = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(57);

var _BlockSwatches = __webpack_require__(2448);

var _BlockSwatches2 = _interopRequireDefault(_BlockSwatches);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Block = exports.Block = function Block(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var transparent = hex === 'transparent';
  var handleChange = function handleChange(hexCode, e) {
    _color2.default.isValidHex(hexCode) && onChange({
      hex: hexCode,
      source: 'hex'
    }, e);
  };

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        boxShadow: '0 1px rgba(0,0,0,.1)',
        borderRadius: '6px',
        position: 'relative'
      },
      head: {
        height: '110px',
        background: hex,
        borderRadius: '6px 6px 0 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative'
      },
      body: {
        padding: '10px'
      },
      label: {
        fontSize: '18px',
        color: _color2.default.getContrastingColor(hex),
        position: 'relative'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 10px 10px 10px',
        borderColor: 'transparent transparent ' + hex + ' transparent',
        position: 'absolute',
        top: '-10px',
        left: '50%',
        marginLeft: '-10px'
      },
      input: {
        width: '100%',
        fontSize: '12px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '22px',
        boxShadow: 'inset 0 0 0 1px #ddd',
        borderRadius: '4px',
        padding: '0 7px',
        boxSizing: 'border-box'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      }
    }
  }, passedStyles), { 'hide-triangle': triangle === 'hide' });

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'block-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.head },
      transparent && _react2.default.createElement(_common.Checkboard, { borderRadius: '6px 6px 0 0' }),
      _react2.default.createElement(
        'div',
        { style: styles.label },
        hex
      )
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(_BlockSwatches2.default, { colors: colors, onClick: handleChange, onSwatchHover: onSwatchHover }),
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input },
        value: hex,
        onChange: handleChange
      })
    )
  );
};

Block.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['top', 'hide']),
  styles: _propTypes2.default.object
};

Block.defaultProps = {
  width: 170,
  colors: ['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8'],
  triangle: 'top',
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Block);

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockSwatches = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(223);

var _map2 = _interopRequireDefault(_map);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BlockSwatches = exports.BlockSwatches = function BlockSwatches(_ref) {
  var colors = _ref.colors,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginRight: '-10px'
      },
      swatch: {
        width: '22px',
        height: '22px',
        float: 'left',
        marginRight: '10px',
        marginBottom: '10px',
        borderRadius: '4px'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_common.Swatch, {
        key: c,
        color: c,
        style: styles.swatch,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
          boxShadow: '0 0 4px ' + c
        }
      });
    }),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = BlockSwatches;

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(2450),
    baseMatchesProperty = __webpack_require__(2474),
    identity = __webpack_require__(446),
    isArray = __webpack_require__(134),
    property = __webpack_require__(2484);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2451),
    getMatchData = __webpack_require__(2473),
    matchesStrictComparable = __webpack_require__(1121);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(650),
    baseIsEqual = __webpack_require__(1118);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(650),
    equalArrays = __webpack_require__(1119),
    equalByTag = __webpack_require__(2458),
    equalObjects = __webpack_require__(2461),
    getTag = __webpack_require__(2468),
    isArray = __webpack_require__(134),
    isBuffer = __webpack_require__(658),
    isTypedArray = __webpack_require__(659);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(653),
    setCacheAdd = __webpack_require__(2454),
    setCacheHas = __webpack_require__(2455);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 2454 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 2455 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 2456 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 2457 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(443),
    Uint8Array = __webpack_require__(1108),
    eq = __webpack_require__(332),
    equalArrays = __webpack_require__(1119),
    mapToArray = __webpack_require__(2459),
    setToArray = __webpack_require__(2460);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 2459 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 2460 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(2462);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(2463),
    getSymbols = __webpack_require__(2465),
    keys = __webpack_require__(661);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(2464),
    isArray = __webpack_require__(134);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 2464 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(2466),
    stubArray = __webpack_require__(2467);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 2466 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 2467 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(2469),
    Map = __webpack_require__(651),
    Promise = __webpack_require__(2470),
    Set = __webpack_require__(2471),
    WeakMap = __webpack_require__(2472),
    baseGetTag = __webpack_require__(279),
    toSource = __webpack_require__(1104);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(132);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(132);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(132);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(221),
    root = __webpack_require__(132);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(1120),
    keys = __webpack_require__(661);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(1118),
    get = __webpack_require__(2475),
    hasIn = __webpack_require__(2481),
    isKey = __webpack_require__(662),
    isStrictComparable = __webpack_require__(1120),
    matchesStrictComparable = __webpack_require__(1121),
    toKey = __webpack_require__(448);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1122);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(2477);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(2478);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(653);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(2480);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(443),
    arrayMap = __webpack_require__(1117),
    isArray = __webpack_require__(134),
    isSymbol = __webpack_require__(447);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(2482),
    hasPath = __webpack_require__(2483);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 2482 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(1123),
    isArguments = __webpack_require__(656),
    isArray = __webpack_require__(134),
    isIndex = __webpack_require__(660),
    isLength = __webpack_require__(657),
    toKey = __webpack_require__(448);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(2485),
    basePropertyDeep = __webpack_require__(2486),
    isKey = __webpack_require__(662),
    toKey = __webpack_require__(448);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 2485 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1122);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1116),
    isArrayLike = __webpack_require__(280);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Circle = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(223);

var _map2 = _interopRequireDefault(_map);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _materialColors = __webpack_require__(1124);

var material = _interopRequireWildcard(_materialColors);

var _common = __webpack_require__(57);

var _CircleSwatch = __webpack_require__(2489);

var _CircleSwatch2 = _interopRequireDefault(_CircleSwatch);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Circle = exports.Circle = function Circle(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      circleSize = _ref.circleSize,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      circleSpacing = _ref.circleSpacing,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        display: 'flex',
        flexWrap: 'wrap',
        marginRight: -circleSpacing,
        marginBottom: -circleSpacing
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(hexCode, e) {
    return onChange({ hex: hexCode, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'circle-picker ' + className },
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_CircleSwatch2.default, {
        key: c,
        color: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover,
        active: hex === c.toLowerCase(),
        circleSize: circleSize,
        circleSpacing: circleSpacing
      });
    })
  );
};

Circle.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  circleSize: _propTypes2.default.number,
  circleSpacing: _propTypes2.default.number,
  styles: _propTypes2.default.object
};

Circle.defaultProps = {
  width: 252,
  circleSize: 28,
  circleSpacing: 14,
  colors: [material.red['500'], material.pink['500'], material.purple['500'], material.deepPurple['500'], material.indigo['500'], material.blue['500'], material.lightBlue['500'], material.cyan['500'], material.teal['500'], material.green['500'], material.lightGreen['500'], material.lime['500'], material.yellow['500'], material.amber['500'], material.orange['500'], material.deepOrange['500'], material.brown['500'], material.blueGrey['500']],
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Circle);

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleSwatch = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CircleSwatch = exports.CircleSwatch = function CircleSwatch(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      hover = _ref.hover,
      active = _ref.active,
      circleSize = _ref.circleSize,
      circleSpacing = _ref.circleSpacing;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: circleSize,
        height: circleSize,
        marginRight: circleSpacing,
        marginBottom: circleSpacing,
        transform: 'scale(1)',
        transition: '100ms transform ease'
      },
      Swatch: {
        borderRadius: '50%',
        background: 'transparent',
        boxShadow: 'inset 0 0 0 ' + (circleSize / 2 + 1) + 'px ' + color,
        transition: '100ms box-shadow ease'
      }
    },
    'hover': {
      swatch: {
        transform: 'scale(1.2)'
      }
    },
    'active': {
      Swatch: {
        boxShadow: 'inset 0 0 0 3px ' + color
      }
    }
  }, { hover: hover, active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      style: styles.Swatch,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: styles.Swatch.boxShadow + ', 0 0 5px ' + color }
    })
  );
};

CircleSwatch.defaultProps = {
  circleSize: 28,
  circleSpacing: 14
};

exports.default = (0, _reactcss.handleHover)(CircleSwatch);

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chrome = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _common = __webpack_require__(57);

var _ChromeFields = __webpack_require__(2491);

var _ChromeFields2 = _interopRequireDefault(_ChromeFields);

var _ChromePointer = __webpack_require__(2494);

var _ChromePointer2 = _interopRequireDefault(_ChromePointer);

var _ChromePointerCircle = __webpack_require__(2495);

var _ChromePointerCircle2 = _interopRequireDefault(_ChromePointerCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chrome = exports.Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: _ChromePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      _react2.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.color },
          _react2.default.createElement(
            'div',
            { style: styles.swatch },
            _react2.default.createElement('div', { style: styles.active }),
            _react2.default.createElement(_common.Checkboard, { renderers: renderers })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: styles.toggles },
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              onChange: onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      _react2.default.createElement(_ChromeFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  disableAlpha: _propTypes2.default.bool,
  styles: _propTypes2.default.object,
  defaultView: _propTypes2.default.oneOf(["hex", "rgb", "hsl"])
};

Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Chrome);

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromeFields = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

var _isUndefined = __webpack_require__(2492);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _common = __webpack_require__(57);

var _UnfoldMoreHorizontalIcon = __webpack_require__(2493);

var _UnfoldMoreHorizontalIcon2 = _interopRequireDefault(_UnfoldMoreHorizontalIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */

var ChromeFields = exports.ChromeFields = function (_React$Component) {
  _inherits(ChromeFields, _React$Component);

  function ChromeFields(props) {
    _classCallCheck(this, ChromeFields);

    var _this = _possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        _color2.default.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }
        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        }

        // We store HSL as a unit interval so we need to override the 1 input to 0.01
        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!(0, _isUndefined2.default)(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!(0, _isUndefined2.default)(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }

  _createClass(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2.default)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = _react2.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.field },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2.default.createElement(_common.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        _react2.default.createElement(
          'div',
          { style: styles.toggle },
          _react2.default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            _react2.default.createElement(_UnfoldMoreHorizontalIcon2.default, {
              style: styles.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return { view: 'rgb' };
      }
      return null;
    }
  }]);

  return ChromeFields;
}(_react2.default.Component);

ChromeFields.defaultProps = {
  view: "hex"
};

exports.default = ChromeFields;

/***/ }),
/* 2492 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
  );
};

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointer = exports.ChromePointer = function ChromePointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointer;

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChromePointerCircle = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointerCircle = exports.ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = ChromePointerCircle;

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compact = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(223);

var _map2 = _interopRequireDefault(_map);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(57);

var _CompactColor = __webpack_require__(2497);

var _CompactColor2 = _interopRequireDefault(_CompactColor);

var _CompactFields = __webpack_require__(2498);

var _CompactFields2 = _interopRequireDefault(_CompactFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Compact = exports.Compact = function Compact(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      Compact: {
        background: '#f6f6f6',
        radius: '4px'
      },
      compact: {
        paddingTop: '5px',
        paddingLeft: '5px',
        boxSizing: 'initial',
        width: '240px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else {
      onChange(data, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    { style: styles.Compact, styles: passedStyles },
    _react2.default.createElement(
      'div',
      { style: styles.compact, className: 'compact-picker ' + className },
      _react2.default.createElement(
        'div',
        null,
        (0, _map2.default)(colors, function (c) {
          return _react2.default.createElement(_CompactColor2.default, {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
          });
        }),
        _react2.default.createElement('div', { style: styles.clear })
      ),
      _react2.default.createElement(_CompactFields2.default, { hex: hex, rgb: rgb, onChange: handleChange })
    )
  );
};

Compact.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  styles: _propTypes2.default.object
};

Compact.defaultProps = {
  colors: ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'],
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Compact);

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactColor = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactColor = exports.CompactColor = function CompactColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        background: color,
        width: '15px',
        height: '15px',
        float: 'left',
        marginRight: '5px',
        marginBottom: '5px',
        position: 'relative',
        cursor: 'pointer'
      },
      dot: {
        absolute: '5px 5px 5px 5px',
        background: _color2.default.getContrastingColor(color),
        borderRadius: '50%',
        opacity: '0'
      }
    },
    'active': {
      dot: {
        opacity: '1'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      dot: {
        background: '#000'
      }
    },
    'transparent': {
      dot: {
        background: '#000'
      }
    }
  }, { active: active, 'color-#FFFFFF': color === '#FFFFFF', 'transparent': color === 'transparent' });

  return _react2.default.createElement(
    _common.Swatch,
    {
      style: styles.color,
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement('div', { style: styles.dot })
  );
};

exports.default = CompactColor;

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompactFields = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompactFields = exports.CompactFields = function CompactFields(_ref) {
  var hex = _ref.hex,
      rgb = _ref.rgb,
      onChange = _ref.onChange;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingBottom: '6px',
        paddingRight: '5px',
        position: 'relative'
      },
      active: {
        position: 'absolute',
        top: '6px',
        left: '5px',
        height: '9px',
        width: '9px',
        background: hex
      },
      HEXwrap: {
        flex: '6',
        position: 'relative'
      },
      HEXinput: {
        width: '80%',
        padding: '0px',
        paddingLeft: '20%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      HEXlabel: {
        display: 'none'
      },
      RGBwrap: {
        flex: '3',
        position: 'relative'
      },
      RGBinput: {
        width: '70%',
        padding: '0px',
        paddingLeft: '30%',
        border: 'none',
        outline: 'none',
        background: 'none',
        fontSize: '12px',
        color: '#333',
        height: '16px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '3px',
        left: '0px',
        lineHeight: '16px',
        textTransform: 'uppercase',
        fontSize: '12px',
        color: '#999'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else {
      onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement('div', { style: styles.active }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: 'hex',
      value: hex,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    })
  );
};

exports.default = CompactFields;

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Github = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(223);

var _map2 = _interopRequireDefault(_map);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _common = __webpack_require__(57);

var _GithubSwatch = __webpack_require__(2500);

var _GithubSwatch2 = _interopRequireDefault(_GithubSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Github = exports.Github = function Github(_ref) {
  var width = _ref.width,
      colors = _ref.colors,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '1px solid rgba(0,0,0,0.2)',
        boxShadow: '0 3px 12px rgba(0,0,0,0.15)',
        borderRadius: '4px',
        position: 'relative',
        padding: '5px',
        display: 'flex',
        flexWrap: 'wrap'
      },
      triangle: {
        position: 'absolute',
        border: '7px solid transparent',
        borderBottomColor: '#fff'
      },
      triangleShadow: {
        position: 'absolute',
        border: '8px solid transparent',
        borderBottomColor: 'rgba(0,0,0,0.15)'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-14px',
        left: '10px'
      },
      triangleShadow: {
        top: '-16px',
        left: '9px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-14px',
        right: '10px'
      },
      triangleShadow: {
        top: '-16px',
        right: '9px'
      }
    },
    'bottom-left-triangle': {
      triangle: {
        top: '35px',
        left: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        left: '9px',
        transform: 'rotate(180deg)'
      }
    },
    'bottom-right-triangle': {
      triangle: {
        top: '35px',
        right: '10px',
        transform: 'rotate(180deg)'
      },
      triangleShadow: {
        top: '37px',
        right: '9px',
        transform: 'rotate(180deg)'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right',
    'bottom-left-triangle': triangle === 'bottom-left',
    'bottom-right-triangle': triangle === 'bottom-right'
  });

  var handleChange = function handleChange(hex, e) {
    return onChange({ hex: hex, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'github-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    (0, _map2.default)(colors, function (c) {
      return _react2.default.createElement(_GithubSwatch2.default, {
        color: c,
        key: c,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

Github.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right', 'bottom-left', 'bottom-right']),
  styles: _propTypes2.default.object
};

Github.defaultProps = {
  width: 200,
  colors: ['#B80000', '#DB3E00', '#FCCB00', '#008B02', '#006B76', '#1273DE', '#004DCF', '#5300EB', '#EB9694', '#FAD0C3', '#FEF3BD', '#C1E1C5', '#BEDADC', '#C4DEF6', '#BED3F3', '#D4C4FB'],
  triangle: 'top-left',
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Github);

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GithubSwatch = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GithubSwatch = exports.GithubSwatch = function GithubSwatch(_ref) {
  var hover = _ref.hover,
      color = _ref.color,
      onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover;

  var hoverSwatch = {
    position: 'relative',
    zIndex: '2',
    outline: '2px solid #fff',
    boxShadow: '0 0 5px 2px rgba(0,0,0,0.25)'
  };

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        width: '25px',
        height: '25px',
        fontSize: '0'
      }
    },
    'hover': {
      swatch: hoverSwatch
    }
  }, { hover: hover });

  return _react2.default.createElement(
    'div',
    { style: styles.swatch },
    _react2.default.createElement(_common.Swatch, {
      color: color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: hoverSwatch
    })
  );
};

exports.default = (0, _reactcss.handleHover)(GithubSwatch);

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HuePicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _common = __webpack_require__(57);

var _HuePointer = __webpack_require__(2502);

var _HuePointer2 = _interopRequireDefault(_HuePointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HuePicker = exports.HuePicker = function HuePicker(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      hsl = _ref.hsl,
      direction = _ref.direction,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        position: 'relative',
        width: width,
        height: height
      },
      hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  // Overwrite to provide pure hue color
  var handleChange = function handleChange(data) {
    return onChange({ a: 1, h: data.h, l: 0.5, s: 1 });
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'hue-picker ' + className },
    _react2.default.createElement(_common.Hue, _extends({}, styles.hue, {
      hsl: hsl,
      pointer: pointer,
      onChange: handleChange,
      direction: direction
    }))
  );
};

HuePicker.propTypes = {
  styles: _propTypes2.default.object
};
HuePicker.defaultProps = {
  width: '316px',
  height: '16px',
  direction: 'horizontal',
  pointer: _HuePointer2.default,
  styles: {}
};

exports.default = (0, _common.ColorWrap)(HuePicker);

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer(_ref) {
  var direction = _ref.direction;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    },
    'vertical': {
      picker: {
        transform: 'translate(-3px, -9px)'
      }
    }
  }, { vertical: direction === 'vertical' });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Material = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Material = exports.Material = function Material(_ref) {
  var onChange = _ref.onChange,
      hex = _ref.hex,
      rgb = _ref.rgb,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      material: {
        width: '98px',
        height: '98px',
        padding: '16px',
        fontFamily: 'Roboto'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '2px solid ' + hex,
        outline: 'none',
        height: '30px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      Hex: {
        style: {}
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        width: '100%',
        marginTop: '12px',
        fontSize: '15px',
        color: '#333',
        padding: '0px',
        border: '0px',
        borderBottom: '1px solid #eee',
        outline: 'none',
        height: '30px'
      },
      RGBlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        fontSize: '11px',
        color: '#999999',
        textTransform: 'capitalize'
      },
      split: {
        display: 'flex',
        marginRight: '-10px',
        paddingTop: '11px'
      },
      third: {
        flex: '1',
        paddingRight: '10px'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    _common.Raised,
    { styles: passedStyles },
    _react2.default.createElement(
      'div',
      { style: styles.material, className: 'material-picker ' + className },
      _react2.default.createElement(_common.EditableInput, {
        style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
        label: 'hex',
        value: hex,
        onChange: handleChange
      }),
      _react2.default.createElement(
        'div',
        { style: styles.split, className: 'flexbox-fix' },
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'r', value: rgb.r,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'g',
            value: rgb.g,
            onChange: handleChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.third },
          _react2.default.createElement(_common.EditableInput, {
            style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
            label: 'b',
            value: rgb.b,
            onChange: handleChange
          })
        )
      )
    )
  );
};

exports.default = (0, _common.ColorWrap)(Material);

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Photoshop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _common = __webpack_require__(57);

var _PhotoshopFields = __webpack_require__(2505);

var _PhotoshopFields2 = _interopRequireDefault(_PhotoshopFields);

var _PhotoshopPointerCircle = __webpack_require__(2506);

var _PhotoshopPointerCircle2 = _interopRequireDefault(_PhotoshopPointerCircle);

var _PhotoshopPointer = __webpack_require__(2507);

var _PhotoshopPointer2 = _interopRequireDefault(_PhotoshopPointer);

var _PhotoshopButton = __webpack_require__(2508);

var _PhotoshopButton2 = _interopRequireDefault(_PhotoshopButton);

var _PhotoshopPreviews = __webpack_require__(2509);

var _PhotoshopPreviews2 = _interopRequireDefault(_PhotoshopPreviews);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Photoshop = exports.Photoshop = function (_React$Component) {
  _inherits(Photoshop, _React$Component);

  function Photoshop(props) {
    _classCallCheck(this, Photoshop);

    var _this = _possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));

    _this.state = {
      currentColor: props.hex
    };
    return _this;
  }

  _createClass(Photoshop, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$styles = _props.styles,
          passedStyles = _props$styles === undefined ? {} : _props$styles,
          _props$className = _props.className,
          className = _props$className === undefined ? '' : _props$className;

      var styles = (0, _reactcss2.default)((0, _merge2.default)({
        'default': {
          picker: {
            background: '#DCDCDC',
            borderRadius: '4px',
            boxShadow: '0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)',
            boxSizing: 'initial',
            width: '513px'
          },
          head: {
            backgroundImage: 'linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)',
            borderBottom: '1px solid #B1B1B1',
            boxShadow: 'inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)',
            height: '23px',
            lineHeight: '24px',
            borderRadius: '4px 4px 0 0',
            fontSize: '13px',
            color: '#4D4D4D',
            textAlign: 'center'
          },
          body: {
            padding: '15px 15px 0',
            display: 'flex'
          },
          saturation: {
            width: '256px',
            height: '256px',
            position: 'relative',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0',
            overflow: 'hidden'
          },
          hue: {
            position: 'relative',
            height: '256px',
            width: '19px',
            marginLeft: '10px',
            border: '2px solid #B3B3B3',
            borderBottom: '2px solid #F0F0F0'
          },
          controls: {
            width: '180px',
            marginLeft: '10px'
          },
          top: {
            display: 'flex'
          },
          previews: {
            width: '60px'
          },
          actions: {
            flex: '1',
            marginLeft: '20px'
          }
        }
      }, passedStyles));

      return _react2.default.createElement(
        'div',
        { style: styles.picker, className: 'photoshop-picker ' + className },
        _react2.default.createElement(
          'div',
          { style: styles.head },
          this.props.header
        ),
        _react2.default.createElement(
          'div',
          { style: styles.body, className: 'flexbox-fix' },
          _react2.default.createElement(
            'div',
            { style: styles.saturation },
            _react2.default.createElement(_common.Saturation, {
              hsl: this.props.hsl,
              hsv: this.props.hsv,
              pointer: _PhotoshopPointerCircle2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.hue },
            _react2.default.createElement(_common.Hue, {
              direction: 'vertical',
              hsl: this.props.hsl,
              pointer: _PhotoshopPointer2.default,
              onChange: this.props.onChange
            })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.controls },
            _react2.default.createElement(
              'div',
              { style: styles.top, className: 'flexbox-fix' },
              _react2.default.createElement(
                'div',
                { style: styles.previews },
                _react2.default.createElement(_PhotoshopPreviews2.default, {
                  rgb: this.props.rgb,
                  currentColor: this.state.currentColor
                })
              ),
              _react2.default.createElement(
                'div',
                { style: styles.actions },
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'OK', onClick: this.props.onAccept, active: true }),
                _react2.default.createElement(_PhotoshopButton2.default, { label: 'Cancel', onClick: this.props.onCancel }),
                _react2.default.createElement(_PhotoshopFields2.default, {
                  onChange: this.props.onChange,
                  rgb: this.props.rgb,
                  hsv: this.props.hsv,
                  hex: this.props.hex
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Photoshop;
}(_react2.default.Component);

Photoshop.propTypes = {
  header: _propTypes2.default.string,
  styles: _propTypes2.default.object
};

Photoshop.defaultProps = {
  header: 'Color Picker',
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Photoshop);

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPicker = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPicker = exports.PhotoshopPicker = function PhotoshopPicker(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsv = _ref.hsv,
      hex = _ref.hex;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        paddingTop: '5px',
        paddingBottom: '9px',
        width: '80px',
        position: 'relative'
      },
      divider: {
        height: '5px'
      },
      RGBwrap: {
        position: 'relative'
      },
      RGBinput: {
        marginLeft: '40%',
        width: '40%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '5px',
        fontSize: '13px',
        paddingLeft: '3px',
        marginRight: '10px'
      },
      RGBlabel: {
        left: '0px',
        width: '34px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px',
        position: 'absolute'
      },
      HEXwrap: {
        position: 'relative'
      },
      HEXinput: {
        marginLeft: '20%',
        width: '80%',
        height: '18px',
        border: '1px solid #888888',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC',
        marginBottom: '6px',
        fontSize: '13px',
        paddingLeft: '3px'
      },
      HEXlabel: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: '14px',
        textTransform: 'uppercase',
        fontSize: '13px',
        height: '18px',
        lineHeight: '22px'
      },
      fieldSymbols: {
        position: 'absolute',
        top: '5px',
        right: '-7px',
        fontSize: '13px'
      },
      symbol: {
        height: '20px',
        lineHeight: '22px',
        paddingBottom: '7px'
      }
    }
  });

  var handleChange = function handleChange(data, e) {
    if (data['#']) {
      _color2.default.isValidHex(data['#']) && onChange({
        hex: data['#'],
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        source: 'rgb'
      }, e);
    } else if (data.h || data.s || data.v) {
      onChange({
        h: data.h || hsv.h,
        s: data.s || hsv.s,
        v: data.v || hsv.v,
        source: 'hsv'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields },
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'h',
      value: Math.round(hsv.h),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 's',
      value: Math.round(hsv.s * 100),
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'v',
      value: Math.round(hsv.v * 100),
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'r',
      value: rgb.r,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'g',
      value: rgb.g,
      onChange: handleChange
    }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.RGBwrap, input: styles.RGBinput, label: styles.RGBlabel },
      label: 'b',
      value: rgb.b,
      onChange: handleChange
    }),
    _react2.default.createElement('div', { style: styles.divider }),
    _react2.default.createElement(_common.EditableInput, {
      style: { wrap: styles.HEXwrap, input: styles.HEXinput, label: styles.HEXlabel },
      label: '#',
      value: hex.replace('#', ''),
      onChange: handleChange
    }),
    _react2.default.createElement(
      'div',
      { style: styles.fieldSymbols },
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '\xB0'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      ),
      _react2.default.createElement(
        'div',
        { style: styles.symbol },
        '%'
      )
    )
  );
};

exports.default = PhotoshopPicker;

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle(_ref) {
  var hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    },
    'black-outline': {
      picker: {
        boxShadow: 'inset 0 0 0 1px #000'
      }
    }
  }, { 'black-outline': hsl.l > 0.5 });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPointerCircle = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPointerCircle = exports.PhotoshopPointerCircle = function PhotoshopPointerCircle() {
  var styles = (0, _reactcss2.default)({
    'default': {
      triangle: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '4px 0 4px 6px',
        borderColor: 'transparent transparent transparent #fff',
        position: 'absolute',
        top: '1px',
        left: '1px'
      },
      triangleBorder: {
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 8px',
        borderColor: 'transparent transparent transparent #555'
      },

      left: {
        Extend: 'triangleBorder',
        transform: 'translate(-13px, -4px)'
      },
      leftInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      },

      right: {
        Extend: 'triangleBorder',
        transform: 'translate(20px, -14px) rotate(180deg)'
      },
      rightInside: {
        Extend: 'triangle',
        transform: 'translate(-8px, -5px)'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.pointer },
    _react2.default.createElement(
      'div',
      { style: styles.left },
      _react2.default.createElement('div', { style: styles.leftInside })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.right },
      _react2.default.createElement('div', { style: styles.rightInside })
    )
  );
};

exports.default = PhotoshopPointerCircle;

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopButton = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopButton = exports.PhotoshopButton = function PhotoshopButton(_ref) {
  var onClick = _ref.onClick,
      label = _ref.label,
      children = _ref.children,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      button: {
        backgroundImage: 'linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)',
        border: '1px solid #878787',
        borderRadius: '2px',
        height: '20px',
        boxShadow: '0 1px 0 0 #EAEAEA',
        fontSize: '14px',
        color: '#000',
        lineHeight: '20px',
        textAlign: 'center',
        marginBottom: '10px',
        cursor: 'pointer'
      }
    },
    'active': {
      button: {
        boxShadow: '0 0 0 1px #878787'
      }
    }
  }, { active: active });

  return _react2.default.createElement(
    'div',
    { style: styles.button, onClick: onClick },
    label || children
  );
};

exports.default = PhotoshopButton;

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoshopPreviews = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhotoshopPreviews = exports.PhotoshopPreviews = function PhotoshopPreviews(_ref) {
  var rgb = _ref.rgb,
      currentColor = _ref.currentColor;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        border: '1px solid #B3B3B3',
        borderBottom: '1px solid #F0F0F0',
        marginBottom: '2px',
        marginTop: '1px'
      },
      new: {
        height: '34px',
        background: 'rgb(' + rgb.r + ',' + rgb.g + ', ' + rgb.b + ')',
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000'
      },
      current: {
        height: '34px',
        background: currentColor,
        boxShadow: 'inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000'
      },
      label: {
        fontSize: '14px',
        color: '#000',
        textAlign: 'center'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'new'
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement('div', { style: styles.new }),
      _react2.default.createElement('div', { style: styles.current })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.label },
      'current'
    )
  );
};

exports.default = PhotoshopPreviews;

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sketch = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _common = __webpack_require__(57);

var _SketchFields = __webpack_require__(2511);

var _SketchFields2 = _interopRequireDefault(_SketchFields);

var _SketchPresetColors = __webpack_require__(2512);

var _SketchPresetColors2 = _interopRequireDefault(_SketchPresetColors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sketch = exports.Sketch = function Sketch(_ref) {
  var width = _ref.width,
      rgb = _ref.rgb,
      hex = _ref.hex,
      hsv = _ref.hsv,
      hsl = _ref.hsl,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      disableAlpha = _ref.disableAlpha,
      presetColors = _ref.presetColors,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': _extends({
      picker: {
        width: width,
        padding: '10px 10px 0',
        boxSizing: 'initial',
        background: '#fff',
        borderRadius: '4px',
        boxShadow: '0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)'
      },
      saturation: {
        width: '100%',
        paddingBottom: '75%',
        position: 'relative',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '3px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      controls: {
        display: 'flex'
      },
      sliders: {
        padding: '4px 0',
        flex: '1'
      },
      color: {
        width: '24px',
        height: '24px',
        position: 'relative',
        marginTop: '4px',
        marginLeft: '4px',
        borderRadius: '3px'
      },
      activeColor: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '2px',
        background: 'rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ',' + rgb.a + ')',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },
      hue: {
        position: 'relative',
        height: '10px',
        overflow: 'hidden'
      },
      Hue: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      },

      alpha: {
        position: 'relative',
        height: '10px',
        marginTop: '4px',
        overflow: 'hidden'
      },
      Alpha: {
        radius: '2px',
        shadow: 'inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)'
      }
    }, passedStyles),
    'disableAlpha': {
      color: {
        height: '10px'
      },
      hue: {
        height: '10px'
      },
      alpha: {
        display: 'none'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'sketch-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.controls, className: 'flexbox-fix' },
      _react2.default.createElement(
        'div',
        { style: styles.sliders },
        _react2.default.createElement(
          'div',
          { style: styles.hue },
          _react2.default.createElement(_common.Hue, {
            style: styles.Hue,
            hsl: hsl,
            onChange: onChange
          })
        ),
        _react2.default.createElement(
          'div',
          { style: styles.alpha },
          _react2.default.createElement(_common.Alpha, {
            style: styles.Alpha,
            rgb: rgb,
            hsl: hsl,
            renderers: renderers,
            onChange: onChange
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { style: styles.color },
        _react2.default.createElement(_common.Checkboard, null),
        _react2.default.createElement('div', { style: styles.activeColor })
      )
    ),
    _react2.default.createElement(_SketchFields2.default, {
      rgb: rgb,
      hsl: hsl,
      hex: hex,
      onChange: onChange,
      disableAlpha: disableAlpha
    }),
    _react2.default.createElement(_SketchPresetColors2.default, {
      colors: presetColors,
      onClick: onChange,
      onSwatchHover: onSwatchHover
    })
  );
};

Sketch.propTypes = {
  disableAlpha: _propTypes2.default.bool,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  styles: _propTypes2.default.object
};

Sketch.defaultProps = {
  disableAlpha: false,
  width: 200,
  styles: {},
  presetColors: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF']
};

exports.default = (0, _common.ColorWrap)(Sketch);

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchFields = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-param-reassign */

var SketchFields = exports.SketchFields = function SketchFields(_ref) {
  var onChange = _ref.onChange,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hex = _ref.hex,
      disableAlpha = _ref.disableAlpha;

  var styles = (0, _reactcss2.default)({
    'default': {
      fields: {
        display: 'flex',
        paddingTop: '4px'
      },
      single: {
        flex: '1',
        paddingLeft: '6px'
      },
      alpha: {
        flex: '1',
        paddingLeft: '6px'
      },
      double: {
        flex: '2'
      },
      input: {
        width: '80%',
        padding: '4px 10% 3px',
        border: 'none',
        boxShadow: 'inset 0 0 0 1px #ccc',
        fontSize: '11px'
      },
      label: {
        display: 'block',
        textAlign: 'center',
        fontSize: '11px',
        color: '#222',
        paddingTop: '3px',
        paddingBottom: '4px',
        textTransform: 'capitalize'
      }
    },
    'disableAlpha': {
      alpha: {
        display: 'none'
      }
    }
  }, { disableAlpha: disableAlpha });

  var handleChange = function handleChange(data, e) {
    if (data.hex) {
      _color2.default.isValidHex(data.hex) && onChange({
        hex: data.hex,
        source: 'hex'
      }, e);
    } else if (data.r || data.g || data.b) {
      onChange({
        r: data.r || rgb.r,
        g: data.g || rgb.g,
        b: data.b || rgb.b,
        a: rgb.a,
        source: 'rgb'
      }, e);
    } else if (data.a) {
      if (data.a < 0) {
        data.a = 0;
      } else if (data.a > 100) {
        data.a = 100;
      }

      data.a /= 100;
      onChange({
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: data.a,
        source: 'rgb'
      }, e);
    }
  };

  return _react2.default.createElement(
    'div',
    { style: styles.fields, className: 'flexbox-fix' },
    _react2.default.createElement(
      'div',
      { style: styles.double },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'hex',
        value: hex.replace('#', ''),
        onChange: handleChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'r',
        value: rgb.r,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'g',
        value: rgb.g,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.single },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'b',
        value: rgb.b,
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '255'
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.alpha },
      _react2.default.createElement(_common.EditableInput, {
        style: { input: styles.input, label: styles.label },
        label: 'a',
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: 'true',
        dragMax: '100'
      })
    )
  );
};

exports.default = SketchFields;

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SketchPresetColors = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SketchPresetColors = exports.SketchPresetColors = function SketchPresetColors(_ref) {
  var colors = _ref.colors,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover;

  var styles = (0, _reactcss2.default)({
    'default': {
      colors: {
        margin: '0 -10px',
        padding: '10px 0 0 10px',
        borderTop: '1px solid #eee',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative'
      },
      swatchWrap: {
        width: '16px',
        height: '16px',
        margin: '0 10px 10px 0'
      },
      swatch: {
        borderRadius: '3px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15)'
      }
    },
    'no-presets': {
      colors: {
        display: 'none'
      }
    }
  }, {
    'no-presets': !colors || !colors.length
  });

  var handleClick = function handleClick(hex, e) {
    onClick({
      hex: hex,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.colors, className: 'flexbox-fix' },
    colors.map(function (colorObjOrString) {
      var c = typeof colorObjOrString === 'string' ? { color: colorObjOrString } : colorObjOrString;
      var key = '' + c.color + (c.title || '');
      return _react2.default.createElement(
        'div',
        { key: key, style: styles.swatchWrap },
        _react2.default.createElement(_common.Swatch, _extends({}, c, {
          style: styles.swatch,
          onClick: handleClick,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px ' + c.color
          }
        }))
      );
    })
  );
};

SketchPresetColors.propTypes = {
  colors: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    color: _propTypes2.default.string,
    title: _propTypes2.default.string
  })])).isRequired
};

exports.default = SketchPresetColors;

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _common = __webpack_require__(57);

var _SliderSwatches = __webpack_require__(2514);

var _SliderSwatches2 = _interopRequireDefault(_SliderSwatches);

var _SliderPointer = __webpack_require__(2516);

var _SliderPointer2 = _interopRequireDefault(_SliderPointer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = exports.Slider = function Slider(_ref) {
  var hsl = _ref.hsl,
      onChange = _ref.onChange,
      pointer = _ref.pointer,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      hue: {
        height: '12px',
        position: 'relative'
      },
      Hue: {
        radius: '2px'
      }
    }
  }, passedStyles));

  return _react2.default.createElement(
    'div',
    { style: styles.wrap || {}, className: 'slider-picker ' + className },
    _react2.default.createElement(
      'div',
      { style: styles.hue },
      _react2.default.createElement(_common.Hue, {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatches },
      _react2.default.createElement(_SliderSwatches2.default, { hsl: hsl, onClick: onChange })
    )
  );
};

Slider.propTypes = {
  styles: _propTypes2.default.object
};
Slider.defaultProps = {
  pointer: _SliderPointer2.default,
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Slider);

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatches = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _SliderSwatch = __webpack_require__(2515);

var _SliderSwatch2 = _interopRequireDefault(_SliderSwatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatches = exports.SliderSwatches = function SliderSwatches(_ref) {
  var onClick = _ref.onClick,
      hsl = _ref.hsl;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatches: {
        marginTop: '20px'
      },
      swatch: {
        boxSizing: 'border-box',
        width: '20%',
        paddingRight: '1px',
        float: 'left'
      },
      clear: {
        clear: 'both'
      }
    }
  });

  // Acceptible difference in floating point equality
  var epsilon = 0.1;

  return _react2.default.createElement(
    'div',
    { style: styles.swatches },
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.80',
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.65',
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.50',
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.35',
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
      })
    ),
    _react2.default.createElement(
      'div',
      { style: styles.swatch },
      _react2.default.createElement(_SliderSwatch2.default, {
        hsl: hsl,
        offset: '.20',
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
      })
    ),
    _react2.default.createElement('div', { style: styles.clear })
  );
};

exports.default = SliderSwatches;

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderSwatch = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderSwatch = exports.SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
      offset = _ref.offset,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      active = _ref.active,
      first = _ref.first,
      last = _ref.last;

  var styles = (0, _reactcss2.default)({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, { active: active, first: first, last: last });

  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };

  return _react2.default.createElement('div', { style: styles.swatch, onClick: handleClick });
};

exports.default = SliderSwatch;

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderPointer = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SliderPointer = exports.SliderPointer = function SliderPointer() {
  var styles = (0, _reactcss2.default)({
    'default': {
      picker: {
        width: '14px',
        height: '14px',
        borderRadius: '6px',
        transform: 'translate(-7px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2.default.createElement('div', { style: styles.picker });
};

exports.default = SliderPointer;

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Swatches = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(223);

var _map2 = _interopRequireDefault(_map);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _materialColors = __webpack_require__(1124);

var material = _interopRequireWildcard(_materialColors);

var _common = __webpack_require__(57);

var _SwatchesGroup = __webpack_require__(2518);

var _SwatchesGroup2 = _interopRequireDefault(_SwatchesGroup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Swatches = exports.Swatches = function Swatches(_ref) {
  var width = _ref.width,
      height = _ref.height,
      onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      colors = _ref.colors,
      hex = _ref.hex,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        width: width,
        height: height
      },
      overflow: {
        height: height,
        overflowY: 'scroll'
      },
      body: {
        padding: '16px 0 6px 16px'
      },
      clear: {
        clear: 'both'
      }
    }
  }, passedStyles));

  var handleChange = function handleChange(data, e) {
    return onChange({ hex: data, source: 'hex' }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.picker, className: 'swatches-picker ' + className },
    _react2.default.createElement(
      _common.Raised,
      null,
      _react2.default.createElement(
        'div',
        { style: styles.overflow },
        _react2.default.createElement(
          'div',
          { style: styles.body },
          (0, _map2.default)(colors, function (group) {
            return _react2.default.createElement(_SwatchesGroup2.default, {
              key: group.toString(),
              group: group,
              active: hex,
              onClick: handleChange,
              onSwatchHover: onSwatchHover
            });
          }),
          _react2.default.createElement('div', { style: styles.clear })
        )
      )
    )
  );
};

Swatches.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)),
  styles: _propTypes2.default.object

  /* eslint-disable max-len */
};Swatches.defaultProps = {
  width: 320,
  height: 240,
  colors: [[material.red['900'], material.red['700'], material.red['500'], material.red['300'], material.red['100']], [material.pink['900'], material.pink['700'], material.pink['500'], material.pink['300'], material.pink['100']], [material.purple['900'], material.purple['700'], material.purple['500'], material.purple['300'], material.purple['100']], [material.deepPurple['900'], material.deepPurple['700'], material.deepPurple['500'], material.deepPurple['300'], material.deepPurple['100']], [material.indigo['900'], material.indigo['700'], material.indigo['500'], material.indigo['300'], material.indigo['100']], [material.blue['900'], material.blue['700'], material.blue['500'], material.blue['300'], material.blue['100']], [material.lightBlue['900'], material.lightBlue['700'], material.lightBlue['500'], material.lightBlue['300'], material.lightBlue['100']], [material.cyan['900'], material.cyan['700'], material.cyan['500'], material.cyan['300'], material.cyan['100']], [material.teal['900'], material.teal['700'], material.teal['500'], material.teal['300'], material.teal['100']], ['#194D33', material.green['700'], material.green['500'], material.green['300'], material.green['100']], [material.lightGreen['900'], material.lightGreen['700'], material.lightGreen['500'], material.lightGreen['300'], material.lightGreen['100']], [material.lime['900'], material.lime['700'], material.lime['500'], material.lime['300'], material.lime['100']], [material.yellow['900'], material.yellow['700'], material.yellow['500'], material.yellow['300'], material.yellow['100']], [material.amber['900'], material.amber['700'], material.amber['500'], material.amber['300'], material.amber['100']], [material.orange['900'], material.orange['700'], material.orange['500'], material.orange['300'], material.orange['100']], [material.deepOrange['900'], material.deepOrange['700'], material.deepOrange['500'], material.deepOrange['300'], material.deepOrange['100']], [material.brown['900'], material.brown['700'], material.brown['500'], material.brown['300'], material.brown['100']], [material.blueGrey['900'], material.blueGrey['700'], material.blueGrey['500'], material.blueGrey['300'], material.blueGrey['100']], ['#000000', '#525252', '#969696', '#D9D9D9', '#FFFFFF']],
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Swatches);

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesGroup = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(223);

var _map2 = _interopRequireDefault(_map);

var _SwatchesColor = __webpack_require__(2519);

var _SwatchesColor2 = _interopRequireDefault(_SwatchesColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesGroup = exports.SwatchesGroup = function SwatchesGroup(_ref) {
  var onClick = _ref.onClick,
      onSwatchHover = _ref.onSwatchHover,
      group = _ref.group,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      group: {
        paddingBottom: '10px',
        width: '40px',
        float: 'left',
        marginRight: '10px'
      }
    }
  });

  return _react2.default.createElement(
    'div',
    { style: styles.group },
    (0, _map2.default)(group, function (color, i) {
      return _react2.default.createElement(_SwatchesColor2.default, {
        key: color,
        color: color,
        active: color.toLowerCase() === active,
        first: i === 0,
        last: i === group.length - 1,
        onClick: onClick,
        onSwatchHover: onSwatchHover
      });
    })
  );
};

exports.default = SwatchesGroup;

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwatchesColor = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(57);

var _CheckIcon = __webpack_require__(2520);

var _CheckIcon2 = _interopRequireDefault(_CheckIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwatchesColor = exports.SwatchesColor = function SwatchesColor(_ref) {
  var color = _ref.color,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onSwatchHover = _ref.onSwatchHover,
      first = _ref.first,
      last = _ref.last,
      active = _ref.active;

  var styles = (0, _reactcss2.default)({
    'default': {
      color: {
        width: '40px',
        height: '24px',
        cursor: 'pointer',
        background: color,
        marginBottom: '1px'
      },
      check: {
        color: _color2.default.getContrastingColor(color),
        marginLeft: '8px',
        display: 'none'
      }
    },
    'first': {
      color: {
        overflow: 'hidden',
        borderRadius: '2px 2px 0 0'
      }
    },
    'last': {
      color: {
        overflow: 'hidden',
        borderRadius: '0 0 2px 2px'
      }
    },
    'active': {
      check: {
        display: 'block'
      }
    },
    'color-#FFFFFF': {
      color: {
        boxShadow: 'inset 0 0 0 1px #ddd'
      },
      check: {
        color: '#333'
      }
    },
    'transparent': {
      check: {
        color: '#333'
      }
    }
  }, {
    first: first,
    last: last,
    active: active,
    'color-#FFFFFF': color === '#FFFFFF',
    'transparent': color === 'transparent'
  });

  return _react2.default.createElement(
    _common.Swatch,
    {
      color: color,
      style: styles.color,
      onClick: onClick,
      onHover: onSwatchHover,
      focusStyle: { boxShadow: '0 0 4px ' + color }
    },
    _react2.default.createElement(
      'div',
      { style: styles.check },
      _react2.default.createElement(_CheckIcon2.default, null)
    )
  );
};

exports.default = SwatchesColor;

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

exports.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties(_ref, ['fill', 'width', 'height', 'style']);

  return _react2.default.createElement(
    'svg',
    _extends({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2.default.createElement('path', { d: 'M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z' })
  );
};

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Twitter = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactcss = __webpack_require__(32);

var _reactcss2 = _interopRequireDefault(_reactcss);

var _map = __webpack_require__(223);

var _map2 = _interopRequireDefault(_map);

var _merge = __webpack_require__(94);

var _merge2 = _interopRequireDefault(_merge);

var _color = __webpack_require__(148);

var _color2 = _interopRequireDefault(_color);

var _common = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Twitter = exports.Twitter = function Twitter(_ref) {
  var onChange = _ref.onChange,
      onSwatchHover = _ref.onSwatchHover,
      hex = _ref.hex,
      colors = _ref.colors,
      width = _ref.width,
      triangle = _ref.triangle,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      card: {
        width: width,
        background: '#fff',
        border: '0 solid rgba(0,0,0,0.25)',
        boxShadow: '0 1px 4px rgba(0,0,0,0.25)',
        borderRadius: '4px',
        position: 'relative'
      },
      body: {
        padding: '15px 9px 9px 15px'
      },
      label: {
        fontSize: '18px',
        color: '#fff'
      },
      triangle: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent #fff transparent',
        position: 'absolute'
      },
      triangleShadow: {
        width: '0px',
        height: '0px',
        borderStyle: 'solid',
        borderWidth: '0 9px 10px 9px',
        borderColor: 'transparent transparent rgba(0,0,0,.1) transparent',
        position: 'absolute'
      },
      hash: {
        background: '#F0F0F0',
        height: '30px',
        width: '30px',
        borderRadius: '4px 0 0 4px',
        float: 'left',
        color: '#98A1A4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      input: {
        width: '100px',
        fontSize: '14px',
        color: '#666',
        border: '0px',
        outline: 'none',
        height: '28px',
        boxShadow: 'inset 0 0 0 1px #F0F0F0',
        boxSizing: 'content-box',
        borderRadius: '0 4px 4px 0',
        float: 'left',
        paddingLeft: '8px'
      },
      swatch: {
        width: '30px',
        height: '30px',
        float: 'left',
        borderRadius: '4px',
        margin: '0 6px 6px 0'
      },
      clear: {
        clear: 'both'
      }
    },
    'hide-triangle': {
      triangle: {
        display: 'none'
      },
      triangleShadow: {
        display: 'none'
      }
    },
    'top-left-triangle': {
      triangle: {
        top: '-10px',
        left: '12px'
      },
      triangleShadow: {
        top: '-11px',
        left: '12px'
      }
    },
    'top-right-triangle': {
      triangle: {
        top: '-10px',
        right: '12px'
      },
      triangleShadow: {
        top: '-11px',
        right: '12px'
      }
    }
  }, passedStyles), {
    'hide-triangle': triangle === 'hide',
    'top-left-triangle': triangle === 'top-left',
    'top-right-triangle': triangle === 'top-right'
  });

  var handleChange = function handleChange(hexcode, e) {
    _color2.default.isValidHex(hexcode) && onChange({
      hex: hexcode,
      source: 'hex'
    }, e);
  };

  return _react2.default.createElement(
    'div',
    { style: styles.card, className: 'twitter-picker ' + className },
    _react2.default.createElement('div', { style: styles.triangleShadow }),
    _react2.default.createElement('div', { style: styles.triangle }),
    _react2.default.createElement(
      'div',
      { style: styles.body },
      (0, _map2.default)(colors, function (c, i) {
        return _react2.default.createElement(_common.Swatch, {
          key: i,
          color: c,
          hex: c,
          style: styles.swatch,
          onClick: handleChange,
          onHover: onSwatchHover,
          focusStyle: {
            boxShadow: '0 0 4px ' + c
          }
        });
      }),
      _react2.default.createElement(
        'div',
        { style: styles.hash },
        '#'
      ),
      _react2.default.createElement(_common.EditableInput, {
        label: null,
        style: { input: styles.input },
        value: hex.replace('#', ''),
        onChange: handleChange
      }),
      _react2.default.createElement('div', { style: styles.clear })
    )
  );
};

Twitter.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  triangle: _propTypes2.default.oneOf(['hide', 'top-left', 'top-right']),
  colors: _propTypes2.default.arrayOf(_propTypes2.default.string),
  styles: _propTypes2.default.object
};

Twitter.defaultProps = {
  width: 276,
  colors: ['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'],
  triangle: 'top-left',
  styles: {}
};

exports.default = (0, _common.ColorWrap)(Twitter);

/***/ }),
/* 2522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adjustHue */
/* unused harmony export animation */
/* unused harmony export backgroundImages */
/* unused harmony export backgrounds */
/* unused harmony export between */
/* unused harmony export border */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* unused harmony export borderStyle */
/* unused harmony export borderWidth */
/* unused harmony export buttons */
/* unused harmony export clearFix */
/* unused harmony export complement */
/* unused harmony export cover */
/* unused harmony export cssVar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curriedDarken; });
/* unused harmony export desaturate */
/* unused harmony export directionalProperty */
/* unused harmony export ellipsis */
/* unused harmony export em */
/* unused harmony export fluidRange */
/* unused harmony export fontFace */
/* unused harmony export getContrast */
/* unused harmony export getLuminance */
/* unused harmony export getValueAndUnit */
/* unused harmony export grayscale */
/* unused harmony export hiDPI */
/* unused harmony export hideText */
/* unused harmony export hideVisually */
/* unused harmony export hsl */
/* unused harmony export hslToColorString */
/* unused harmony export hsla */
/* unused harmony export invert */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return curriedLighten; });
/* unused harmony export linearGradient */
/* unused harmony export margin */
/* unused harmony export math */
/* unused harmony export meetsContrastGuidelines */
/* unused harmony export mix */
/* unused harmony export modularScale */
/* unused harmony export normalize */
/* unused harmony export opacify */
/* unused harmony export padding */
/* unused harmony export parseToHsl */
/* unused harmony export parseToRgb */
/* unused harmony export position */
/* unused harmony export radialGradient */
/* unused harmony export readableColor */
/* unused harmony export rem */
/* unused harmony export retinaImage */
/* unused harmony export rgb */
/* unused harmony export rgbToColorString */
/* unused harmony export rgba */
/* unused harmony export saturate */
/* unused harmony export setHue */
/* unused harmony export setLightness */
/* unused harmony export setSaturation */
/* unused harmony export shade */
/* unused harmony export size */
/* unused harmony export stripUnit */
/* unused harmony export textInputs */
/* unused harmony export timingFunctions */
/* unused harmony export tint */
/* unused harmony export toColorString */
/* unused harmony export transitions */
/* unused harmony export transparentize */
/* unused harmony export triangle */
/* unused harmony export wordWrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_wrapNativeSuper__ = __webpack_require__(2523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__ = __webpack_require__(663);






function last() {
  var _ref;

  return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}

function negation(a) {
  return -a;
}

function addition(a, b) {
  return a + b;
}

function subtraction(a, b) {
  return a - b;
}

function multiplication(a, b) {
  return a * b;
}

function division(a, b) {
  return a / b;
}

function factorial(a) {
  if (a % 1 || !(+a >= 0)) return NaN;
  if (a > 170) return Infinity;else if (a === 0) return 1;else {
    return a * factorial(a - 1);
  }
}

function power(a, b) {
  return Math.pow(a, b);
}

function sqrt(a) {
  return Math.sqrt(a);
}

function max() {
  return Math.max.apply(Math, arguments);
}

function min() {
  return Math.min.apply(Math, arguments);
}

function comma() {
  return Array.of.apply(Array, arguments);
}

var defaultMathSymbols = {
  symbols: {
    '!': {
      postfix: {
        symbol: '!',
        f: factorial,
        notation: 'postfix',
        precedence: 6,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '!',
      regSymbol: '!'
    },
    '^': {
      infix: {
        symbol: '^',
        f: power,
        notation: 'infix',
        precedence: 5,
        rightToLeft: 1,
        argCount: 2
      },
      symbol: '^',
      regSymbol: '\\^'
    },
    '*': {
      infix: {
        symbol: '*',
        f: multiplication,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '*',
      regSymbol: '\\*'
    },
    '/': {
      infix: {
        symbol: '/',
        f: division,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '/',
      regSymbol: '/'
    },
    '+': {
      infix: {
        symbol: '+',
        f: addition,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '+',
        f: last,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '+',
      regSymbol: '\\+'
    },
    '-': {
      infix: {
        symbol: '-',
        f: subtraction,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '-',
        f: negation,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '-',
      regSymbol: '-'
    },
    ',': {
      infix: {
        symbol: ',',
        f: comma,
        notation: 'infix',
        precedence: 1,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: ',',
      regSymbol: ','
    },
    '(': {
      prefix: {
        symbol: '(',
        f: last,
        notation: 'prefix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '(',
      regSymbol: '\\('
    },
    ')': {
      postfix: {
        symbol: ')',
        f: undefined,
        notation: 'postfix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: ')',
      regSymbol: '\\)'
    },
    min: {
      func: {
        symbol: 'min',
        f: min,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'min',
      regSymbol: 'min\\b'
    },
    max: {
      func: {
        symbol: 'max',
        f: max,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'max',
      regSymbol: 'max\\b'
    },
    sqrt: {
      func: {
        symbol: 'sqrt',
        f: sqrt,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'sqrt',
      regSymbol: 'sqrt\\b'
    }
  }
};

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js

/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found.\n"
};
/**
 * super basic version of sprintf
 * @private
 */

function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */


var PolishedError = /*#__PURE__*/function (_Error) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(PolishedError, _Error);

  function PolishedError(code) {
    var _this;

    if (true) {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/master/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this);
  }

  return PolishedError;
}( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_wrapNativeSuper__["a" /* default */])(Error));

var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g; // Merges additional math functionality into the defaults.

function mergeSymbolMaps(additionalSymbols) {
  var symbolMap = {};
  symbolMap.symbols = additionalSymbols ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultMathSymbols.symbols, {}, additionalSymbols.symbols) : Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultMathSymbols.symbols);
  return symbolMap;
}

function exec(operators, values) {
  var _ref;

  var op = operators.pop();
  values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
  return op.precedence;
}

function calculate(expression, additionalSymbols) {
  var symbolMap = mergeSymbolMaps(additionalSymbols);
  var match;
  var operators = [symbolMap.symbols['('].prefix];
  var values = [];
  var pattern = new RegExp( // Pattern for numbers
  "\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
  Object.keys(symbolMap.symbols).map(function (key) {
    return symbolMap.symbols[key];
  }) // longer symbols should be listed first
  // $FlowFixMe
  .sort(function (a, b) {
    return b.symbol.length - a.symbol.length;
  }) // $FlowFixMe
  .map(function (val) {
    return val.regSymbol;
  }).join('|') + "|(\\S)", 'g');
  pattern.lastIndex = 0; // Reset regular expression object

  var afterValue = false;

  do {
    match = pattern.exec(expression);

    var _ref2 = match || [')', undefined],
        token = _ref2[0],
        bad = _ref2[1];

    var notNumber = symbolMap.symbols[token];
    var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
    var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix; // Check for syntax errors:

    if (bad || (afterValue ? notAfterValue : notNewValue)) {
      throw new PolishedError(37, match ? match.index : expression.length, expression);
    }

    if (afterValue) {
      // We either have an infix or postfix operator (they should be mutually exclusive)
      var curr = notNumber.postfix || notNumber.infix;

      do {
        var prev = operators[operators.length - 1];
        if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break; // Apply previous operator, since it has precedence over current one
      } while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function


      afterValue = curr.notation === 'postfix';

      if (curr.symbol !== ')') {
        operators.push(curr); // Postfix always has precedence over any operator that follows after it

        if (afterValue) exec(operators, values);
      }
    } else if (notNumber) {
      // prefix operator or function
      operators.push(notNumber.prefix || notNumber.func);

      if (notNumber.func) {
        // Require an opening parenthesis
        match = pattern.exec(expression);

        if (!match || match[0] !== '(') {
          throw new PolishedError(38, match ? match.index : expression.length, expression);
        }
      }
    } else {
      // number
      values.push(+token);
      afterValue = true;
    }
  } while (match && operators.length);

  if (operators.length) {
    throw new PolishedError(39, match ? match.index : expression.length, expression);
  } else if (match) {
    throw new PolishedError(40, match ? match.index : expression.length, expression);
  } else {
    return values.pop();
  }
}

function reverseString(str) {
  return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */


function math(formula, additionalSymbols) {
  var reversedFormula = reverseString(formula);
  var formulaMatch = reversedFormula.match(unitRegExp); // Check that all units are the same

  if (formulaMatch && !formulaMatch.every(function (unit) {
    return unit === formulaMatch[0];
  })) {
    throw new PolishedError(41);
  }

  var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
  return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
}

var cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable.
 *
 * Passthrough can be enabled (off by default) for when you are unsure of the input and want non-variable values to be returned instead of an error.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */

function cssVar(cssVariable, passThrough) {
  if (!cssVariable || !cssVariable.match(cssVariableRegex)) {
    if (passThrough) return cssVariable;
    throw new PolishedError(73);
  }

  var variableValue;
  /* eslint-disable */

  /* istanbul ignore next */

  if (typeof document !== 'undefined' && document.documentElement !== null) {
    variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
  }
  /* eslint-enable */


  if (variableValue) {
    return variableValue.trim();
  } else {
    throw new PolishedError(74);
  }
}

// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');

  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return "" + acc + capitalizeString(val);
    });
  }

  var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
  return property === joinedProperty ? "" + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};

  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }

  return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */


function directionalProperty(property) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === void 0 ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === void 0 ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === void 0 ? secondValue : _values$3;
  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

/**
 * Check if a string ends with something
 * @private
 */
function endsWith (string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @deprecated - stripUnit's unitReturn functionality has been marked for deprecation in polished 4.0. It's functionality has been been moved to getValueAndUnit.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */

function stripUnit(value, unitReturn) {
  if (typeof value !== 'string') return unitReturn ? [value, undefined] : value;
  var matchedValue = value.match(cssRegex);

  if (unitReturn) {
    // eslint-disable-next-line no-console
    console.warn("stripUnit's unitReturn functionality has been marked for deprecation in polished 4.0. It's functionality has been been moved to getValueAndUnit.");
    if (matchedValue) return [parseFloat(value), matchedValue[2]];
    return [value, undefined];
  }

  if (matchedValue) return parseFloat(value);
  return value;
}

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */

var pxtoFactory = function pxtoFactory(to) {
  return function (pxval, base) {
    if (base === void 0) {
      base = '16px';
    }

    var newPxval = pxval;
    var newBase = base;

    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new PolishedError(69, to, pxval);
      }

      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new PolishedError(70, to, base);
      }

      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new PolishedError(71, pxval, to);
    }

    if (typeof newBase === 'string') {
      throw new PolishedError(72, base, to);
    }

    return "" + newPxval / newBase + to;
  };
};

/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */

var em = /*#__PURE__*/pxtoFactory('em');

var cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */

function getValueAndUnit(value) {
  if (typeof value !== 'string') return [value, ''];
  var matchedValue = value.match(cssRegex$1);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};

function getRatio(ratioName) {
  return ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */


function modularScale(steps, base, ratio) {
  if (base === void 0) {
    base = '1em';
  }

  if (ratio === void 0) {
    ratio = 1.333;
  }

  if (typeof steps !== 'number') {
    throw new PolishedError(42);
  }

  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new PolishedError(43);
  }

  var _ref = typeof base === 'string' ? getValueAndUnit(base) : [base, ''],
      realBase = _ref[0],
      unit = _ref[1];

  var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;

  if (typeof realBase === 'string') {
    throw new PolishedError(44, base);
  }

  return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */

var rem = /*#__PURE__*/pxtoFactory('rem');

/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */

function between(fromSize, toSize, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  var _getValueAndUnit = getValueAndUnit(fromSize),
      unitlessFromSize = _getValueAndUnit[0],
      fromSizeUnit = _getValueAndUnit[1];

  var _getValueAndUnit2 = getValueAndUnit(toSize),
      unitlessToSize = _getValueAndUnit2[0],
      toSizeUnit = _getValueAndUnit2[1];

  var _getValueAndUnit3 = getValueAndUnit(minScreen),
      unitlessMinScreen = _getValueAndUnit3[0],
      minScreenUnit = _getValueAndUnit3[1];

  var _getValueAndUnit4 = getValueAndUnit(maxScreen),
      unitlessMaxScreen = _getValueAndUnit4[0],
      maxScreenUnit = _getValueAndUnit4[1];

  if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) {
    throw new PolishedError(47);
  }

  if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) {
    throw new PolishedError(48);
  }

  var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
  var base = unitlessToSize - slope * unitlessMaxScreen;
  return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */
function clearFix(parent) {
  var _ref;

  if (parent === void 0) {
    parent = '&';
  }

  var pseudoSelector = parent + "::after";
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */
function cover(offset) {
  if (offset === void 0) {
    offset = 0;
  }

  return {
    position: 'absolute',
    top: offset,
    right: offset,
    bottom: offset,
    left: offset
  };
}

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */
function ellipsis(width) {
  if (width === void 0) {
    width = '100%';
  }

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

function _createForOfIteratorHelperLoose(o) { var i = 0; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } i = o[Symbol.iterator](); return i.next.bind(i); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */
function fluidRange(cssProp, minScreen, maxScreen) {
  if (minScreen === void 0) {
    minScreen = '320px';
  }

  if (maxScreen === void 0) {
    maxScreen = '1200px';
  }

  if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) {
    throw new PolishedError(49);
  }

  if (Array.isArray(cssProp)) {
    var mediaQueries = {};
    var fallbacks = {};

    for (var _iterator = _createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;) {
      var _extends2, _extends3;

      var obj = _step.value;

      if (!obj.prop || !obj.fromSize || !obj.toSize) {
        throw new PolishedError(50);
      }

      fallbacks[obj.prop] = obj.fromSize;
      mediaQueries["@media (min-width: " + minScreen + ")"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = between(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
      mediaQueries["@media (min-width: " + maxScreen + ")"] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fallbacks, {}, mediaQueries);
  } else {
    var _ref, _ref2, _ref3;

    if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) {
      throw new PolishedError(51);
    }

    return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = between(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
  }
}

var dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var formatHintMap = {
  woff: 'woff',
  woff2: 'woff2',
  ttf: 'truetype',
  otf: 'opentype',
  eot: 'embedded-opentype',
  svg: 'svg',
  svgz: 'svg'
};

function generateFormatHint(format, formatHint) {
  if (!formatHint) return '';
  return " format(\"" + formatHintMap[format] + "\")";
}

function isDataURI(fontFilePath) {
  return !!fontFilePath.match(dataURIRegex);
}

function generateFileReferences(fontFilePath, fileFormats, formatHint) {
  if (isDataURI(fontFilePath)) {
    return "url(\"" + fontFilePath + "\")" + generateFormatHint(fileFormats[0], formatHint);
  }

  var fileFontReferences = fileFormats.map(function (format) {
    return "url(\"" + fontFilePath + "." + format + "\")" + generateFormatHint(format, formatHint);
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return "local(\"" + font + "\")";
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));

  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats, formatHint));
  }

  return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */


function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === void 0 ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      _ref$formatHint = _ref.formatHint,
      formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange,
      fontDisplay = _ref.fontDisplay,
      fontVariationSettings = _ref.fontVariationSettings,
      fontFeatureSettings = _ref.fontFeatureSettings;
  // Error Handling
  if (!fontFamily) throw new PolishedError(55);

  if (!fontFilePath && !localFonts) {
    throw new PolishedError(52);
  }

  if (localFonts && !Array.isArray(localFonts)) {
    throw new PolishedError(53);
  }

  if (!Array.isArray(fileFormats)) {
    throw new PolishedError(54);
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats, formatHint),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight,
      fontDisplay: fontDisplay,
      fontVariationSettings: fontVariationSettings,
      fontFeatureSettings: fontFeatureSettings
    }
  }; // Removes undefined fields for cleaner css object.

  return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */
function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */
function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */
function hiDPI(ratio) {
  if (ratio === void 0) {
    ratio = 1.3;
  }

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

function constructGradientValue(literals) {
  var template = '';

  for (var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    substitutions[_key - 1] = arguments[_key];
  }

  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];

    if (i === substitutions.length - 1 && substitutions[i]) {
      var definedValues = substitutions.filter(function (substitute) {
        return !!substitute;
      }); // Adds leading coma if properties preceed color-stops

      if (definedValues.length > 1) {
        template = template.slice(0, -1);
        template += ", " + substitutions[i]; // No trailing space if color-stops is the only param provided
      } else if (definedValues.length === 1) {
        template += "" + substitutions[i];
      }
    } else if (substitutions[i]) {
      template += substitutions[i] + " ";
    }
  }

  return template.trim();
}

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["linear-gradient(", "", ")"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function linearGradient(_ref) {
  var colorStops = _ref.colorStops,
      fallback = _ref.fallback,
      _ref$toDirection = _ref.toDirection,
      toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;

  if (!colorStops || colorStops.length < 2) {
    throw new PolishedError(56);
  }

  return {
    backgroundColor: fallback || colorStops[0].split(' ')[0],
    backgroundImage: constructGradientValue(_templateObject(), toDirection, colorStops.join(', '))
  };
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize() {
  var _ref;

  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },
    body: {
      margin: '0'
    },
    main: {
      display: 'block'
    },
    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },
    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },
    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },
    a: {
      backgroundColor: 'transparent'
    },
    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }
  }, _ref["b,\n    strong"] = {
    fontWeight: 'bolder'
  }, _ref["code,\n    kbd,\n    samp"] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref["sub,\n    sup"] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref["button,\n    input"] = {
    overflow: 'visible'
  }, _ref["button,\n    select"] = {
    textTransform: 'none'
  }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
    WebkitAppearance: 'button'
  }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}

function _templateObject$1() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["radial-gradient(", "", "", "", ")"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      _ref$extent = _ref.extent,
      extent = _ref$extent === void 0 ? '' : _ref$extent,
      fallback = _ref.fallback,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? '' : _ref$position,
      _ref$shape = _ref.shape,
      shape = _ref$shape === void 0 ? '' : _ref$shape;

  if (!colorStops || colorStops.length < 2) {
    throw new PolishedError(57);
  }

  return {
    backgroundColor: fallback || colorStops[0].split(' ')[0],
    backgroundImage: constructGradientValue(_templateObject$1(), position, shape, extent, colorStops.join(', '))
  };
}

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
  var _ref;

  if (extension === void 0) {
    extension = 'png';
  }

  if (retinaSuffix === void 0) {
    retinaSuffix = '_2x';
  }

  if (!filename) {
    throw new PolishedError(58);
  } // Replace the dot at the beginning of the passed extension if one exists


  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
  return _ref = {
    backgroundImage: "url(" + filename + "." + ext + ")"
  }, _ref[hiDPI()] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    backgroundImage: "url(" + rFilename + ")"
  }, backgroundSize ? {
    backgroundSize: backgroundSize
  } : {}), _ref;
}

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */

function getTimingFunction(functionName) {
  return functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */


function timingFunctions(timingFunction) {
  return getTimingFunction(timingFunction);
}

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  var fullWidth = "" + width[0] + (width[1] || '');
  var halfWidth = "" + width[0] / 2 + (width[1] || '');
  var fullHeight = "" + height[0] + (height[1] || '');
  var halfHeight = "" + height[0] / 2 + (height[1] || '');

  switch (pointingDirection) {
    case 'top':
      return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;

    case 'topLeft':
      return fullWidth + " " + fullHeight + " 0 0";

    case 'left':
      return halfHeight + " " + fullWidth + " " + halfHeight + " 0";

    case 'bottomLeft':
      return fullWidth + " 0 0 " + fullHeight;

    case 'bottom':
      return fullHeight + " " + halfWidth + " 0 " + halfWidth;

    case 'bottomRight':
      return "0 0 " + fullWidth + " " + fullHeight;

    case 'right':
      return halfHeight + " 0 " + halfHeight + " " + fullWidth;

    case 'topRight':
    default:
      return "0 " + fullWidth + " " + fullHeight + " 0";
  }
};

var getBorderColor = function getBorderColor(pointingDirection, foregroundColor, backgroundColor) {
  switch (pointingDirection) {
    case 'top':
    case 'bottomRight':
      return backgroundColor + " " + backgroundColor + " " + foregroundColor + " " + backgroundColor;

    case 'right':
    case 'bottomLeft':
      return backgroundColor + " " + backgroundColor + " " + backgroundColor + " " + foregroundColor;

    case 'bottom':
    case 'topLeft':
      return foregroundColor + " " + backgroundColor + " " + backgroundColor + " " + backgroundColor;

    case 'left':
    case 'topRight':
      return backgroundColor + " " + foregroundColor + " " + backgroundColor + " " + backgroundColor;

    default:
      throw new PolishedError(59);
  }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */


function triangle(_ref) {
  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
  var widthAndUnit = getValueAndUnit(width);
  var heightAndUnit = getValueAndUnit(height);

  if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) {
    throw new PolishedError(60);
  }

  return {
    width: '0',
    height: '0',
    borderColor: getBorderColor(pointingDirection, foregroundColor, backgroundColor),
    borderStyle: 'solid',
    borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
  };
}

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */
function wordWrap(wrap) {
  if (wrap === void 0) {
    wrap = 'break-word';
  }

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  } // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV


  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */

function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*(\d{1,3}[.]?[0-9]?)%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */

function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }

  var normalizedColor = nameToHex(color);

  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }

  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }

  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }

  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));

    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }

  var rgbMatched = rgbRegex.exec(normalizedColor);

  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }

  var rgbaMatched = rgbaRegex.exec(normalizedColor);

  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }

  var hslMatched = hslRegex.exec(normalizedColor);

  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);

    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }

    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }

  var hslaMatched = hslaRegex.exec(normalizedColor);

  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);

    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;

    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;

    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";

    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);

    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }

    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }

  throw new PolishedError(5);
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }

  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);

  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;

    case green:
      hue = (blue - red) / delta + 2;
      break;

    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;

  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }

  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }

  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }

  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }

  throw new PolishedError(7);
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */


function toColorString(color) {
  if (typeof color !== 'object') throw new PolishedError(8);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new PolishedError(8);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
} // eslint-disable-next-line no-redeclare


function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */

function adjustHue(degree, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    hue: hslColor.hue + parseFloat(degree)
  }));
} // prettier-ignore


var curriedAdjustHue = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(adjustHue);

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function complement(color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */

function darken(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDarken = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(darken);

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */

function desaturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
} // prettier-ignore


var curriedDesaturate = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(desaturate);

/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */

function getLuminance(color) {
  if (color === 'transparent') return 0;
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */

function getContrast(color1, color2) {
  var luminance1 = getLuminance(color1);
  var luminance2 = getLuminance(color2);
  return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */

function grayscale(color) {
  if (color === 'transparent') return color;
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    saturation: 0
  }));
}

/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */
function hslToColorString(color) {
  if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
    if (color.alpha && typeof color.alpha === 'number') {
      return hsla({
        hue: color.hue,
        saturation: color.saturation,
        lightness: color.lightness,
        alpha: color.alpha
      });
    }

    return hsl({
      hue: color.hue,
      saturation: color.saturation,
      lightness: color.lightness
    });
  }

  throw new PolishedError(45);
}

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */

function invert(color) {
  if (color === 'transparent') return color; // parse color string to rgb

  var value = parseToRgb(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */

function lighten(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
} // prettier-ignore


var curriedLighten = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(lighten);

/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */
function meetsContrastGuidelines(color1, color2) {
  var contrastRatio = getContrast(color1, color2);
  return {
    AA: contrastRatio >= 4.5,
    AALarge: contrastRatio >= 3,
    AAA: contrastRatio >= 7,
    AAALarge: contrastRatio >= 4.5
  };
}

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */

function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = parseToRgb(color);

  var color1 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);

  var color2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  }); // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method


  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * (parseFloat(weight) / 1.0) + color2.alpha * (1 - parseFloat(weight) / 1.0)
  };
  return rgba(mixedColor);
} // prettier-ignore


var curriedMix = /*#__PURE__*/curry
/* ::<number | string, string, string, string> */
(mix);

/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */

function opacify(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedOpacify = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(opacify);

var defaultLightReturnColor = '#000';
var defaultDarkReturnColor = '#fff';
/**
 * Returns black or white (or optional light and dark return colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, set `strict` to `true` to ensure that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */

function readableColor(color, lightReturnColor, darkReturnColor, strict) {
  if (lightReturnColor === void 0) {
    lightReturnColor = defaultLightReturnColor;
  }

  if (darkReturnColor === void 0) {
    darkReturnColor = defaultDarkReturnColor;
  }

  if (strict === void 0) {
    strict = false;
  }

  var isLightColor = getLuminance(color) > 0.179;
  var preferredReturnColor = isLightColor ? lightReturnColor : darkReturnColor; // TODO: Make `strict` the default behaviour in the next major release.
  // Without `strict`, this may return a color that does not meet WCAG AA.

  if (!strict || getContrast(color, preferredReturnColor) >= 4.5) {
    return preferredReturnColor;
  }

  return isLightColor ? defaultLightReturnColor : defaultDarkReturnColor;
}

/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */
function rgbToColorString(color) {
  if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
    if (typeof color.alpha === 'number') {
      return rgba({
        red: color.red,
        green: color.green,
        blue: color.blue,
        alpha: color.alpha
      });
    }

    return rgb({
      red: color.red,
      green: color.green,
      blue: color.blue
    });
  }

  throw new PolishedError(46);
}

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */

function saturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
} // prettier-ignore


var curriedSaturate = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(saturate);

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */

function setHue(hue, color) {
  if (color === 'transparent') return color;
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
} // prettier-ignore


var curriedSetHue = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(setHue);

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */

function setLightness(lightness, color) {
  if (color === 'transparent') return color;
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
} // prettier-ignore


var curriedSetLightness = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(setLightness);

/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */

function setSaturation(saturation, color) {
  if (color === 'transparent') return color;
  return toColorString(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
} // prettier-ignore


var curriedSetSaturation = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(setSaturation);

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (color === 'transparent') return color;
  return curriedMix(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore


var curriedShade = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(shade);

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (color === 'transparent') return color;
  return curriedMix(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore


var curriedTint = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(tint);

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */

function transparentize(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;

  var colorWithAlpha = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
  });

  return rgba(colorWithAlpha);
} // prettier-ignore


var curriedTransparentize = /*#__PURE__*/curry
/* ::<number | string, string, string> */
(transparentize);

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);

  if (!multiMode && args.length > 8) {
    throw new PolishedError(64);
  }

  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new PolishedError(65);
    }

    if (Array.isArray(arg) && arg.length > 8) {
      throw new PolishedError(66);
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');
  return {
    animation: code
  };
}

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */
function backgroundImages() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

var sideMap = ['top', 'right', 'bottom', 'left'];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */

function border(sideKeyword) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
    var _ref;

    return _ref = {}, _ref["border" + capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
  } else {
    values.unshift(sideKeyword);
    return {
      borderWidth: values[0],
      borderStyle: values[1],
      borderColor: values[2]
    };
  }
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */
function borderColor() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderColor'].concat(values));
}

/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */
function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);

  if (!radius && radius !== 0) {
    throw new PolishedError(62);
  }

  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
  }

  throw new PolishedError(63);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */
function borderStyle() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderStyle'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['borderWidth'].concat(values));
}

function generateSelectors(template, state) {
  var stateSuffix = state ? ":" + state : '';
  return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */


function statefulSelectors(states, template, stateMap) {
  if (!template) throw new PolishedError(67);
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];

  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new PolishedError(68);
    }

    selectors.push(generateSelectors(template, states[i]));
  }

  selectors = selectors.join(',');
  return selectors;
}

var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */


function buttons() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */
function margin() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['margin'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function padding() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(void 0, ['padding'].concat(values));
}

var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */

function position(firstValue) {
  for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(firstValue) >= 0 && firstValue) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, directionalProperty.apply(void 0, [''].concat(values)), {
      position: firstValue
    });
  } else {
    return directionalProperty.apply(void 0, ['', firstValue].concat(values));
  }
}

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */
function size(height, width) {
  if (width === void 0) {
    width = height;
  }

  return {
    height: height,
    width: width
  };
}

var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */


function textInputs() {
  for (var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */

function transitions() {
  for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  if (Array.isArray(properties[0]) && properties.length === 2) {
    var value = properties[1];

    if (typeof value !== 'string') {
      throw new PolishedError(61);
    }

    var transitionsString = properties[0].map(function (property) {
      return property + " " + value;
    }).join(', ');
    return {
      transition: transitionsString
    };
  } else {
    return {
      transition: properties.join(', ')
    };
  }
}




/***/ }),
/* 2523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _wrapNativeSuper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isNativeFunction_js__ = __webpack_require__(2524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__construct_js__ = __webpack_require__(2525);




function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !Object(__WEBPACK_IMPORTED_MODULE_2__isNativeFunction_js__["a" /* default */])(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__construct_js__["a" /* default */])(Class, arguments, Object(__WEBPACK_IMPORTED_MODULE_0__getPrototypeOf_js__["a" /* default */])(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1__setPrototypeOf_js__["a" /* default */])(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

/***/ }),
/* 2524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeFunction;
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

/***/ }),
/* 2525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _construct;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__ = __webpack_require__(2526);


function _construct(Parent, args, Class) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__isNativeReflectConstruct_js__["a" /* default */])()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

/***/ }),
/* 2526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _isNativeReflectConstruct;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {/**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice,
    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeMax = Math.max,
    nativeNow = Date.now;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = merge;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42), __webpack_require__(146)(module)))

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var ReactKonvaCore = __webpack_require__(2529);
// import full konva to enable all nodes
var Konva = __webpack_require__(2543);

module.exports = _extends({}, ReactKonvaCore);

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Based on ReactArt.js
 * Copyright (c) 2017-present Lavrenov Anton.
 * All rights reserved.
 *
 * MIT
 */


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Konva = __webpack_require__(1125);
var ReactFiberReconciler = __webpack_require__(2533);
var ReactDOMComponentTree = __webpack_require__(2537);
var HostConfig = __webpack_require__(2538);

var _require = __webpack_require__(1130),
    applyNodeProps = _require.applyNodeProps,
    toggleStrictMode = _require.toggleStrictMode;

// export for testing
// const REACT_VERSION = '16.8.3';
// const __matchRectVersion = React.version === REACT_VERSION;
// skip version testing for now


var __matchRectVersion = true;

// That warning is useful, but I am not sure we really need it
// if (!__matchRectVersion) {
//   console.warn(
//     `Version mismatch detected for react-konva and react. react-konva expects to have react version ${REACT_VERSION}, but it has version ${
//       React.version
//     }. Make sure versions are matched, otherwise, react-konva work is not guaranteed. For releases information take a look here: https://github.com/konvajs/react-konva/releases`
//   );
// }

var Stage = function (_React$Component) {
  _inherits(Stage, _React$Component);

  function Stage() {
    _classCallCheck(this, Stage);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Stage.prototype.componentDidMount = function componentDidMount() {
    if (!Konva.isBrowser) {
      return;
    }
    this._stage = new Konva.Stage({
      width: this.props.width,
      height: this.props.height,
      container: this._tagRef
    });

    this._setRef(this._stage);

    applyNodeProps(this._stage, this.props);

    this._mountNode = KonvaRenderer.createContainer(this._stage);
    KonvaRenderer.updateContainer(this.props.children, this._mountNode, this);
  };

  Stage.prototype._setRef = function _setRef(value) {
    var forwardedRef = this.props.forwardedRef;

    if (!forwardedRef) {
      return;
    }
    if (typeof forwardedRef === 'function') {
      forwardedRef(value);
    } else {
      forwardedRef.current = value;
    }
  };

  Stage.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!Konva.isBrowser) {
      return;
    }
    this._setRef(this._stage);
    applyNodeProps(this._stage, this.props, prevProps);

    KonvaRenderer.updateContainer(this.props.children, this._mountNode, this);
  };

  Stage.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!Konva.isBrowser) {
      return;
    }
    this._setRef(null);
    KonvaRenderer.updateContainer(null, this._mountNode, this);
    this._stage.destroy();
  };

  Stage.prototype.getStage = function getStage() {
    return this._stage;
  };

  Stage.prototype.render = function render() {
    var _this2 = this;

    var props = this.props;

    return React.createElement('div', {
      ref: function ref(_ref) {
        return _this2._tagRef = _ref;
      },
      accessKey: props.accessKey,
      className: props.className,
      role: props.role,
      style: props.style,
      tabIndex: props.tabIndex,
      title: props.title
    });
  };

  return Stage;
}(React.Component);

var KONVA_NODES = ['Layer', 'FastLayer', 'Group', 'Label', 'Rect', 'Circle', 'Ellipse', 'Wedge', 'Line', 'Sprite', 'Image', 'Text', 'TextPath', 'Star', 'Ring', 'Arc', 'Tag', 'Path', 'RegularPolygon', 'Arrow', 'Shape', 'Transformer'];

var TYPES = {};

KONVA_NODES.forEach(function (nodeName) {
  TYPES[nodeName] = nodeName;
});

var KonvaRenderer = ReactFiberReconciler(HostConfig);

KonvaRenderer.injectIntoDevTools({
  findFiberByHostInstance: ReactDOMComponentTree.getClosestInstanceFromNode,
  bundleType:  false ? 1 : 0,
  version: React.version,
  rendererPackageName: 'react-konva',
  getInspectorDataForViewTag: function getInspectorDataForViewTag() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    console.log(args);
  }
});

/** API */

var StageWrap = React.forwardRef(function (props, ref) {
  return React.createElement(Stage, _extends({}, props, { forwardedRef: ref }));
});

module.exports = _extends({}, TYPES, {
  __matchRectVersion: __matchRectVersion,
  Stage: StageWrap,
  useStrictMode: toggleStrictMode
});

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Container_1 = __webpack_require__(450);
var Global_1 = __webpack_require__(38);
var Canvas_1 = __webpack_require__(449);
var DragAndDrop_1 = __webpack_require__(664);
var Global_2 = __webpack_require__(38);
var PointerEvents = __webpack_require__(1128);
var STAGE = 'Stage', STRING = 'string', PX = 'px', MOUSEOUT = 'mouseout', MOUSELEAVE = 'mouseleave', MOUSEOVER = 'mouseover', MOUSEENTER = 'mouseenter', MOUSEMOVE = 'mousemove', MOUSEDOWN = 'mousedown', MOUSEUP = 'mouseup', POINTERMOVE = 'pointermove', POINTERDOWN = 'pointerdown', POINTERUP = 'pointerup', POINTERCANCEL = 'pointercancel', LOSTPOINTERCAPTURE = 'lostpointercapture', CONTEXTMENU = 'contextmenu', CLICK = 'click', DBL_CLICK = 'dblclick', TOUCHSTART = 'touchstart', TOUCHEND = 'touchend', TAP = 'tap', DBL_TAP = 'dbltap', TOUCHMOVE = 'touchmove', WHEEL = 'wheel', CONTENT_MOUSEOUT = 'contentMouseout', CONTENT_MOUSEOVER = 'contentMouseover', CONTENT_MOUSEMOVE = 'contentMousemove', CONTENT_MOUSEDOWN = 'contentMousedown', CONTENT_MOUSEUP = 'contentMouseup', CONTENT_CONTEXTMENU = 'contentContextmenu', CONTENT_CLICK = 'contentClick', CONTENT_DBL_CLICK = 'contentDblclick', CONTENT_TOUCHSTART = 'contentTouchstart', CONTENT_TOUCHEND = 'contentTouchend', CONTENT_DBL_TAP = 'contentDbltap', CONTENT_TAP = 'contentTap', CONTENT_TOUCHMOVE = 'contentTouchmove', CONTENT_POINTERMOVE = 'contentPointermove', CONTENT_POINTERDOWN = 'contentPointerdown', CONTENT_POINTERUP = 'contentPointerup', CONTENT_WHEEL = 'contentWheel', RELATIVE = 'relative', KONVA_CONTENT = 'konvajs-content', SPACE = ' ', UNDERSCORE = '_', CONTAINER = 'container', MAX_LAYERS_NUMBER = 5, EMPTY_STRING = '', EVENTS = [
    MOUSEENTER,
    MOUSEDOWN,
    MOUSEMOVE,
    MOUSEUP,
    MOUSEOUT,
    TOUCHSTART,
    TOUCHMOVE,
    TOUCHEND,
    MOUSEOVER,
    WHEEL,
    CONTEXTMENU,
    POINTERDOWN,
    POINTERMOVE,
    POINTERUP,
    POINTERCANCEL,
    LOSTPOINTERCAPTURE,
], eventsLength = EVENTS.length;
function addEvent(ctx, eventName) {
    ctx.content.addEventListener(eventName, function (evt) {
        ctx[UNDERSCORE + eventName](evt);
    }, false);
}
var NO_POINTERS_MESSAGE = "Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);";
exports.stages = [];
function checkNoClip(attrs) {
    if (attrs === void 0) { attrs = {}; }
    if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) {
        Util_1.Util.warn('Stage does not support clipping. Please use clip for Layers or Groups.');
    }
    return attrs;
}
var Stage = (function (_super) {
    __extends(Stage, _super);
    function Stage(config) {
        var _this = _super.call(this, checkNoClip(config)) || this;
        _this._pointerPositions = [];
        _this._changedPointerPositions = [];
        _this._buildDOM();
        _this._bindContentEvents();
        exports.stages.push(_this);
        _this.on('widthChange.konva heightChange.konva', _this._resizeDOM);
        _this.on('visibleChange.konva', _this._checkVisibility);
        _this.on('clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva', function () {
            checkNoClip(_this.attrs);
        });
        _this._checkVisibility();
        return _this;
    }
    Stage.prototype._validateAdd = function (child) {
        var isLayer = child.getType() === 'Layer';
        var isFastLayer = child.getType() === 'FastLayer';
        var valid = isLayer || isFastLayer;
        if (!valid) {
            Util_1.Util.throw('You may only add layers to the stage.');
        }
    };
    Stage.prototype._checkVisibility = function () {
        if (!this.content) {
            return;
        }
        var style = this.visible() ? '' : 'none';
        this.content.style.display = style;
    };
    Stage.prototype.setContainer = function (container) {
        if (typeof container === STRING) {
            if (container.charAt(0) === '.') {
                var className = container.slice(1);
                container = document.getElementsByClassName(className)[0];
            }
            else {
                var id;
                if (container.charAt(0) !== '#') {
                    id = container;
                }
                else {
                    id = container.slice(1);
                }
                container = document.getElementById(id);
            }
            if (!container) {
                throw 'Can not find container in document with id ' + id;
            }
        }
        this._setAttr(CONTAINER, container);
        if (this.content) {
            if (this.content.parentElement) {
                this.content.parentElement.removeChild(this.content);
            }
            container.appendChild(this.content);
        }
        return this;
    };
    Stage.prototype.shouldDrawHit = function () {
        return true;
    };
    Stage.prototype.clear = function () {
        var layers = this.children, len = layers.length, n;
        for (n = 0; n < len; n++) {
            layers[n].clear();
        }
        return this;
    };
    Stage.prototype.clone = function (obj) {
        if (!obj) {
            obj = {};
        }
        obj.container = document.createElement('div');
        return Container_1.Container.prototype.clone.call(this, obj);
    };
    Stage.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        var content = this.content;
        if (content && Util_1.Util._isInDocument(content)) {
            this.container().removeChild(content);
        }
        var index = exports.stages.indexOf(this);
        if (index > -1) {
            exports.stages.splice(index, 1);
        }
        return this;
    };
    Stage.prototype.getPointerPosition = function () {
        var pos = this._pointerPositions[0] || this._changedPointerPositions[0];
        if (!pos) {
            Util_1.Util.warn(NO_POINTERS_MESSAGE);
            return null;
        }
        return {
            x: pos.x,
            y: pos.y,
        };
    };
    Stage.prototype._getPointerById = function (id) {
        return this._pointerPositions.find(function (p) { return p.id === id; });
    };
    Stage.prototype.getPointersPositions = function () {
        return this._pointerPositions;
    };
    Stage.prototype.getStage = function () {
        return this;
    };
    Stage.prototype.getContent = function () {
        return this.content;
    };
    Stage.prototype._toKonvaCanvas = function (config) {
        config = config || {};
        var x = config.x || 0, y = config.y || 0, canvas = new Canvas_1.SceneCanvas({
            width: config.width || this.width(),
            height: config.height || this.height(),
            pixelRatio: config.pixelRatio || 1,
        }), _context = canvas.getContext()._context, layers = this.children;
        if (x || y) {
            _context.translate(-1 * x, -1 * y);
        }
        layers.each(function (layer) {
            if (!layer.isVisible()) {
                return;
            }
            var layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, x, y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
        });
        return canvas;
    };
    Stage.prototype.getIntersection = function (pos, selector) {
        if (!pos) {
            return null;
        }
        var layers = this.children, len = layers.length, end = len - 1, n, shape;
        for (n = end; n >= 0; n--) {
            shape = layers[n].getIntersection(pos, selector);
            if (shape) {
                return shape;
            }
        }
        return null;
    };
    Stage.prototype._resizeDOM = function () {
        var width = this.width();
        var height = this.height();
        if (this.content) {
            this.content.style.width = width + PX;
            this.content.style.height = height + PX;
        }
        this.bufferCanvas.setSize(width, height);
        this.bufferHitCanvas.setSize(width, height);
        this.children.each(function (layer) {
            layer.setSize({ width: width, height: height });
            layer.draw();
        });
    };
    Stage.prototype.add = function (layer) {
        if (arguments.length > 1) {
            for (var i = 0; i < arguments.length; i++) {
                this.add(arguments[i]);
            }
            return this;
        }
        _super.prototype.add.call(this, layer);
        var length = this.children.length;
        if (length > MAX_LAYERS_NUMBER) {
            Util_1.Util.warn('The stage has ' +
                length +
                ' layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.');
        }
        layer.setSize({ width: this.width(), height: this.height() });
        layer.draw();
        if (Global_1.Konva.isBrowser) {
            this.content.appendChild(layer.canvas._canvas);
        }
        return this;
    };
    Stage.prototype.getParent = function () {
        return null;
    };
    Stage.prototype.getLayer = function () {
        return null;
    };
    Stage.prototype.hasPointerCapture = function (pointerId) {
        return PointerEvents.hasPointerCapture(pointerId, this);
    };
    Stage.prototype.setPointerCapture = function (pointerId) {
        PointerEvents.setPointerCapture(pointerId, this);
    };
    Stage.prototype.releaseCapture = function (pointerId) {
        PointerEvents.releaseCapture(pointerId, this);
    };
    Stage.prototype.getLayers = function () {
        return this.getChildren();
    };
    Stage.prototype._bindContentEvents = function () {
        if (!Global_1.Konva.isBrowser) {
            return;
        }
        for (var n = 0; n < eventsLength; n++) {
            addEvent(this, EVENTS[n]);
        }
    };
    Stage.prototype._mouseenter = function (evt) {
        this.setPointersPositions(evt);
        this._fire(MOUSEENTER, { evt: evt, target: this, currentTarget: this });
    };
    Stage.prototype._mouseover = function (evt) {
        this.setPointersPositions(evt);
        this._fire(CONTENT_MOUSEOVER, { evt: evt });
        this._fire(MOUSEOVER, { evt: evt, target: this, currentTarget: this });
    };
    Stage.prototype._mouseout = function (evt) {
        var _a;
        this.setPointersPositions(evt);
        var targetShape = ((_a = this.targetShape) === null || _a === void 0 ? void 0 : _a.getStage()) ? this.targetShape : null;
        var eventsEnabled = !DragAndDrop_1.DD.isDragging || Global_1.Konva.hitOnDragEnabled;
        if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(MOUSEOUT, { evt: evt });
            targetShape._fireAndBubble(MOUSELEAVE, { evt: evt });
            this._fire(MOUSELEAVE, { evt: evt, target: this, currentTarget: this });
            this.targetShape = null;
        }
        else if (eventsEnabled) {
            this._fire(MOUSELEAVE, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
            this._fire(MOUSEOUT, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
        }
        this.pointerPos = undefined;
        this._pointerPositions = [];
        this._fire(CONTENT_MOUSEOUT, { evt: evt });
    };
    Stage.prototype._mousemove = function (evt) {
        var _a;
        if (Global_1.Konva.UA.ieMobile) {
            return this._touchmove(evt);
        }
        this.setPointersPositions(evt);
        var pointerId = Util_1.Util._getFirstPointerId(evt);
        var shape;
        var targetShape = ((_a = this.targetShape) === null || _a === void 0 ? void 0 : _a.getStage()) ? this.targetShape : null;
        var eventsEnabled = !DragAndDrop_1.DD.isDragging || Global_1.Konva.hitOnDragEnabled;
        if (eventsEnabled) {
            shape = this.getIntersection(this.getPointerPosition());
            if (shape && shape.isListening()) {
                var differentTarget = targetShape !== shape;
                if (eventsEnabled && differentTarget) {
                    if (targetShape) {
                        targetShape._fireAndBubble(MOUSEOUT, { evt: evt, pointerId: pointerId }, shape);
                        targetShape._fireAndBubble(MOUSELEAVE, { evt: evt, pointerId: pointerId }, shape);
                    }
                    shape._fireAndBubble(MOUSEOVER, { evt: evt, pointerId: pointerId }, targetShape);
                    shape._fireAndBubble(MOUSEENTER, { evt: evt, pointerId: pointerId }, targetShape);
                    shape._fireAndBubble(MOUSEMOVE, { evt: evt, pointerId: pointerId });
                    this.targetShape = shape;
                }
                else {
                    shape._fireAndBubble(MOUSEMOVE, { evt: evt, pointerId: pointerId });
                }
            }
            else {
                if (targetShape && eventsEnabled) {
                    targetShape._fireAndBubble(MOUSEOUT, { evt: evt, pointerId: pointerId });
                    targetShape._fireAndBubble(MOUSELEAVE, { evt: evt, pointerId: pointerId });
                    this._fire(MOUSEOVER, {
                        evt: evt,
                        target: this,
                        currentTarget: this,
                        pointerId: pointerId,
                    });
                    this.targetShape = null;
                }
                this._fire(MOUSEMOVE, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId,
                });
            }
            this._fire(CONTENT_MOUSEMOVE, { evt: evt });
        }
        if (evt.cancelable) {
            evt.preventDefault();
        }
    };
    Stage.prototype._mousedown = function (evt) {
        if (Global_1.Konva.UA.ieMobile) {
            return this._touchstart(evt);
        }
        this.setPointersPositions(evt);
        var pointerId = Util_1.Util._getFirstPointerId(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        DragAndDrop_1.DD.justDragged = false;
        Global_1.Konva.listenClickTap = true;
        if (shape && shape.isListening()) {
            this.clickStartShape = shape;
            shape._fireAndBubble(MOUSEDOWN, { evt: evt, pointerId: pointerId });
        }
        else {
            this._fire(MOUSEDOWN, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: pointerId,
            });
        }
        this._fire(CONTENT_MOUSEDOWN, { evt: evt });
    };
    Stage.prototype._mouseup = function (evt) {
        if (Global_1.Konva.UA.ieMobile) {
            return this._touchend(evt);
        }
        this.setPointersPositions(evt);
        var pointerId = Util_1.Util._getFirstPointerId(evt);
        var shape = this.getIntersection(this.getPointerPosition()), clickStartShape = this.clickStartShape, clickEndShape = this.clickEndShape, fireDblClick = false;
        if (Global_1.Konva.inDblClickWindow) {
            fireDblClick = true;
            clearTimeout(this.dblTimeout);
        }
        else if (!DragAndDrop_1.DD.justDragged) {
            Global_1.Konva.inDblClickWindow = true;
            clearTimeout(this.dblTimeout);
        }
        this.dblTimeout = setTimeout(function () {
            Global_1.Konva.inDblClickWindow = false;
        }, Global_1.Konva.dblClickWindow);
        if (shape && shape.isListening()) {
            this.clickEndShape = shape;
            shape._fireAndBubble(MOUSEUP, { evt: evt, pointerId: pointerId });
            if (Global_1.Konva.listenClickTap &&
                clickStartShape &&
                clickStartShape._id === shape._id) {
                shape._fireAndBubble(CLICK, { evt: evt, pointerId: pointerId });
                if (fireDblClick && clickEndShape && clickEndShape === shape) {
                    shape._fireAndBubble(DBL_CLICK, { evt: evt, pointerId: pointerId });
                }
            }
        }
        else {
            this.clickEndShape = null;
            this._fire(MOUSEUP, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: pointerId,
            });
            if (Global_1.Konva.listenClickTap) {
                this._fire(CLICK, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId,
                });
            }
            if (fireDblClick) {
                this._fire(DBL_CLICK, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: pointerId,
                });
            }
        }
        this._fire(CONTENT_MOUSEUP, { evt: evt });
        if (Global_1.Konva.listenClickTap) {
            this._fire(CONTENT_CLICK, { evt: evt });
            if (fireDblClick) {
                this._fire(CONTENT_DBL_CLICK, { evt: evt });
            }
        }
        Global_1.Konva.listenClickTap = false;
        if (evt.cancelable) {
            evt.preventDefault();
        }
    };
    Stage.prototype._contextmenu = function (evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) {
            shape._fireAndBubble(CONTEXTMENU, { evt: evt });
        }
        else {
            this._fire(CONTEXTMENU, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
        }
        this._fire(CONTENT_CONTEXTMENU, { evt: evt });
    };
    Stage.prototype._touchstart = function (evt) {
        var _this = this;
        this.setPointersPositions(evt);
        var triggeredOnShape = false;
        this._changedPointerPositions.forEach(function (pos) {
            var shape = _this.getIntersection(pos);
            Global_1.Konva.listenClickTap = true;
            DragAndDrop_1.DD.justDragged = false;
            var hasShape = shape && shape.isListening();
            if (!hasShape) {
                return;
            }
            if (Global_1.Konva.captureTouchEventsEnabled) {
                shape.setPointerCapture(pos.id);
            }
            _this.tapStartShape = shape;
            shape._fireAndBubble(TOUCHSTART, { evt: evt, pointerId: pos.id }, _this);
            triggeredOnShape = true;
            if (shape.isListening() && shape.preventDefault() && evt.cancelable) {
                evt.preventDefault();
            }
        });
        if (!triggeredOnShape) {
            this._fire(TOUCHSTART, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: this._changedPointerPositions[0].id,
            });
        }
        this._fire(CONTENT_TOUCHSTART, { evt: evt });
    };
    Stage.prototype._touchmove = function (evt) {
        var _this = this;
        this.setPointersPositions(evt);
        var eventsEnabled = !DragAndDrop_1.DD.isDragging || Global_1.Konva.hitOnDragEnabled;
        if (eventsEnabled) {
            var triggeredOnShape = false;
            var processedShapesIds = {};
            this._changedPointerPositions.forEach(function (pos) {
                var shape = PointerEvents.getCapturedShape(pos.id) || _this.getIntersection(pos);
                var hasShape = shape && shape.isListening();
                if (!hasShape) {
                    return;
                }
                if (processedShapesIds[shape._id]) {
                    return;
                }
                processedShapesIds[shape._id] = true;
                shape._fireAndBubble(TOUCHMOVE, { evt: evt, pointerId: pos.id });
                triggeredOnShape = true;
                if (shape.isListening() && shape.preventDefault() && evt.cancelable) {
                    evt.preventDefault();
                }
            });
            if (!triggeredOnShape) {
                this._fire(TOUCHMOVE, {
                    evt: evt,
                    target: this,
                    currentTarget: this,
                    pointerId: this._changedPointerPositions[0].id,
                });
            }
            this._fire(CONTENT_TOUCHMOVE, { evt: evt });
        }
        if (DragAndDrop_1.DD.isDragging && DragAndDrop_1.DD.node.preventDefault() && evt.cancelable) {
            evt.preventDefault();
        }
    };
    Stage.prototype._touchend = function (evt) {
        var _this = this;
        this.setPointersPositions(evt);
        var tapEndShape = this.tapEndShape, fireDblClick = false;
        if (Global_1.Konva.inDblClickWindow) {
            fireDblClick = true;
            clearTimeout(this.dblTimeout);
        }
        else if (!DragAndDrop_1.DD.justDragged) {
            Global_1.Konva.inDblClickWindow = true;
            clearTimeout(this.dblTimeout);
        }
        this.dblTimeout = setTimeout(function () {
            Global_1.Konva.inDblClickWindow = false;
        }, Global_1.Konva.dblClickWindow);
        var triggeredOnShape = false;
        var processedShapesIds = {};
        var tapTriggered = false;
        var dblTapTriggered = false;
        this._changedPointerPositions.forEach(function (pos) {
            var shape = PointerEvents.getCapturedShape(pos.id) ||
                _this.getIntersection(pos);
            if (shape) {
                shape.releaseCapture(pos.id);
            }
            var hasShape = shape && shape.isListening();
            if (!hasShape) {
                return;
            }
            if (processedShapesIds[shape._id]) {
                return;
            }
            processedShapesIds[shape._id] = true;
            _this.tapEndShape = shape;
            shape._fireAndBubble(TOUCHEND, { evt: evt, pointerId: pos.id });
            triggeredOnShape = true;
            if (Global_1.Konva.listenClickTap && shape === _this.tapStartShape) {
                tapTriggered = true;
                shape._fireAndBubble(TAP, { evt: evt, pointerId: pos.id });
                if (fireDblClick && tapEndShape && tapEndShape === shape) {
                    dblTapTriggered = true;
                    shape._fireAndBubble(DBL_TAP, { evt: evt, pointerId: pos.id });
                }
            }
            if (shape.isListening() && shape.preventDefault() && evt.cancelable) {
                evt.preventDefault();
            }
        });
        if (!triggeredOnShape) {
            this._fire(TOUCHEND, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: this._changedPointerPositions[0].id,
            });
        }
        if (Global_1.Konva.listenClickTap && !tapTriggered) {
            this.tapEndShape = null;
            this._fire(TAP, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: this._changedPointerPositions[0].id,
            });
        }
        if (fireDblClick && !dblTapTriggered) {
            this._fire(DBL_TAP, {
                evt: evt,
                target: this,
                currentTarget: this,
                pointerId: this._changedPointerPositions[0].id,
            });
        }
        this._fire(CONTENT_TOUCHEND, { evt: evt });
        if (Global_1.Konva.listenClickTap) {
            this._fire(CONTENT_TAP, { evt: evt });
            if (fireDblClick) {
                this._fire(CONTENT_DBL_TAP, { evt: evt });
            }
        }
        if (this.preventDefault() && evt.cancelable) {
            evt.preventDefault();
        }
        Global_1.Konva.listenClickTap = false;
    };
    Stage.prototype._wheel = function (evt) {
        this.setPointersPositions(evt);
        var shape = this.getIntersection(this.getPointerPosition());
        if (shape && shape.isListening()) {
            shape._fireAndBubble(WHEEL, { evt: evt });
        }
        else {
            this._fire(WHEEL, {
                evt: evt,
                target: this,
                currentTarget: this,
            });
        }
        this._fire(CONTENT_WHEEL, { evt: evt });
    };
    Stage.prototype._pointerdown = function (evt) {
        if (!Global_1.Konva._pointerEventsEnabled) {
            return;
        }
        this.setPointersPositions(evt);
        var shape = PointerEvents.getCapturedShape(evt.pointerId) ||
            this.getIntersection(this.getPointerPosition());
        if (shape) {
            shape._fireAndBubble(POINTERDOWN, PointerEvents.createEvent(evt));
        }
    };
    Stage.prototype._pointermove = function (evt) {
        if (!Global_1.Konva._pointerEventsEnabled) {
            return;
        }
        this.setPointersPositions(evt);
        var shape = PointerEvents.getCapturedShape(evt.pointerId) ||
            this.getIntersection(this.getPointerPosition());
        if (shape) {
            shape._fireAndBubble(POINTERMOVE, PointerEvents.createEvent(evt));
        }
    };
    Stage.prototype._pointerup = function (evt) {
        if (!Global_1.Konva._pointerEventsEnabled) {
            return;
        }
        this.setPointersPositions(evt);
        var shape = PointerEvents.getCapturedShape(evt.pointerId) ||
            this.getIntersection(this.getPointerPosition());
        if (shape) {
            shape._fireAndBubble(POINTERUP, PointerEvents.createEvent(evt));
        }
        PointerEvents.releaseCapture(evt.pointerId);
    };
    Stage.prototype._pointercancel = function (evt) {
        if (!Global_1.Konva._pointerEventsEnabled) {
            return;
        }
        this.setPointersPositions(evt);
        var shape = PointerEvents.getCapturedShape(evt.pointerId) ||
            this.getIntersection(this.getPointerPosition());
        if (shape) {
            shape._fireAndBubble(POINTERUP, PointerEvents.createEvent(evt));
        }
        PointerEvents.releaseCapture(evt.pointerId);
    };
    Stage.prototype._lostpointercapture = function (evt) {
        PointerEvents.releaseCapture(evt.pointerId);
    };
    Stage.prototype.setPointersPositions = function (evt) {
        var _this = this;
        var contentPosition = this._getContentPosition(), x = null, y = null;
        evt = evt ? evt : window.event;
        if (evt.touches !== undefined) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Util_1.Collection.prototype.each.call(evt.touches, function (touch) {
                _this._pointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY,
                });
            });
            Util_1.Collection.prototype.each.call(evt.changedTouches || evt.touches, function (touch) {
                _this._changedPointerPositions.push({
                    id: touch.identifier,
                    x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                    y: (touch.clientY - contentPosition.top) / contentPosition.scaleY,
                });
            });
        }
        else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
                x: x,
                y: y,
            };
            this._pointerPositions = [{ x: x, y: y, id: Util_1.Util._getFirstPointerId(evt) }];
            this._changedPointerPositions = [
                { x: x, y: y, id: Util_1.Util._getFirstPointerId(evt) },
            ];
        }
    };
    Stage.prototype._setPointerPosition = function (evt) {
        Util_1.Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
        this.setPointersPositions(evt);
    };
    Stage.prototype._getContentPosition = function () {
        if (!this.content || !this.content.getBoundingClientRect) {
            return {
                top: 0,
                left: 0,
                scaleX: 1,
                scaleY: 1,
            };
        }
        var rect = this.content.getBoundingClientRect();
        return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1,
        };
    };
    Stage.prototype._buildDOM = function () {
        this.bufferCanvas = new Canvas_1.SceneCanvas({
            width: this.width(),
            height: this.height(),
        });
        this.bufferHitCanvas = new Canvas_1.HitCanvas({
            pixelRatio: 1,
            width: this.width(),
            height: this.height(),
        });
        if (!Global_1.Konva.isBrowser) {
            return;
        }
        var container = this.container();
        if (!container) {
            throw 'Stage has no container. A container is required.';
        }
        container.innerHTML = EMPTY_STRING;
        this.content = document.createElement('div');
        this.content.style.position = RELATIVE;
        this.content.style.userSelect = 'none';
        this.content.className = KONVA_CONTENT;
        this.content.setAttribute('role', 'presentation');
        container.appendChild(this.content);
        this._resizeDOM();
    };
    Stage.prototype.cache = function () {
        Util_1.Util.warn('Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.');
        return this;
    };
    Stage.prototype.clearCache = function () {
        return this;
    };
    Stage.prototype.batchDraw = function () {
        this.children.each(function (layer) {
            layer.batchDraw();
        });
        return this;
    };
    return Stage;
}(Container_1.Container));
exports.Stage = Stage;
Stage.prototype.nodeType = STAGE;
Global_2._registerNode(Stage);
Factory_1.Factory.addGetterSetter(Stage, 'container');


/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Layer_1 = __webpack_require__(1129);
var Global_1 = __webpack_require__(38);
var FastLayer = (function (_super) {
    __extends(FastLayer, _super);
    function FastLayer(attrs) {
        var _this = _super.call(this, attrs) || this;
        _this.listening(false);
        Util_1.Util.warn('Konva.Fast layer is deprecated. Please use "new Konva.Layer({ listening: false })" instead.');
        return _this;
    }
    return FastLayer;
}(Layer_1.Layer));
exports.FastLayer = FastLayer;
FastLayer.prototype.nodeType = 'FastLayer';
Global_1._registerNode(FastLayer);
Util_1.Collection.mapMethods(FastLayer);


/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Animation_1 = __webpack_require__(666);
var Node_1 = __webpack_require__(60);
var Global_1 = __webpack_require__(38);
var blacklist = {
    node: 1,
    duration: 1,
    easing: 1,
    onFinish: 1,
    yoyo: 1,
}, PAUSED = 1, PLAYING = 2, REVERSING = 3, idCounter = 0, colorAttrs = ['fill', 'stroke', 'shadowColor'];
var TweenEngine = (function () {
    function TweenEngine(prop, propFunc, func, begin, finish, duration, yoyo) {
        this.prop = prop;
        this.propFunc = propFunc;
        this.begin = begin;
        this._pos = begin;
        this.duration = duration;
        this._change = 0;
        this.prevPos = 0;
        this.yoyo = yoyo;
        this._time = 0;
        this._position = 0;
        this._startTime = 0;
        this._finish = 0;
        this.func = func;
        this._change = finish - this.begin;
        this.pause();
    }
    TweenEngine.prototype.fire = function (str) {
        var handler = this[str];
        if (handler) {
            handler();
        }
    };
    TweenEngine.prototype.setTime = function (t) {
        if (t > this.duration) {
            if (this.yoyo) {
                this._time = this.duration;
                this.reverse();
            }
            else {
                this.finish();
            }
        }
        else if (t < 0) {
            if (this.yoyo) {
                this._time = 0;
                this.play();
            }
            else {
                this.reset();
            }
        }
        else {
            this._time = t;
            this.update();
        }
    };
    TweenEngine.prototype.getTime = function () {
        return this._time;
    };
    TweenEngine.prototype.setPosition = function (p) {
        this.prevPos = this._pos;
        this.propFunc(p);
        this._pos = p;
    };
    TweenEngine.prototype.getPosition = function (t) {
        if (t === undefined) {
            t = this._time;
        }
        return this.func(t, this.begin, this._change, this.duration);
    };
    TweenEngine.prototype.play = function () {
        this.state = PLAYING;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onPlay');
    };
    TweenEngine.prototype.reverse = function () {
        this.state = REVERSING;
        this._time = this.duration - this._time;
        this._startTime = this.getTimer() - this._time;
        this.onEnterFrame();
        this.fire('onReverse');
    };
    TweenEngine.prototype.seek = function (t) {
        this.pause();
        this._time = t;
        this.update();
        this.fire('onSeek');
    };
    TweenEngine.prototype.reset = function () {
        this.pause();
        this._time = 0;
        this.update();
        this.fire('onReset');
    };
    TweenEngine.prototype.finish = function () {
        this.pause();
        this._time = this.duration;
        this.update();
        this.fire('onFinish');
    };
    TweenEngine.prototype.update = function () {
        this.setPosition(this.getPosition(this._time));
        this.fire('onUpdate');
    };
    TweenEngine.prototype.onEnterFrame = function () {
        var t = this.getTimer() - this._startTime;
        if (this.state === PLAYING) {
            this.setTime(t);
        }
        else if (this.state === REVERSING) {
            this.setTime(this.duration - t);
        }
    };
    TweenEngine.prototype.pause = function () {
        this.state = PAUSED;
        this.fire('onPause');
    };
    TweenEngine.prototype.getTimer = function () {
        return new Date().getTime();
    };
    return TweenEngine;
}());
var Tween = (function () {
    function Tween(config) {
        var that = this, node = config.node, nodeId = node._id, duration, easing = config.easing || exports.Easings.Linear, yoyo = !!config.yoyo, key;
        if (typeof config.duration === 'undefined') {
            duration = 0.3;
        }
        else if (config.duration === 0) {
            duration = 0.001;
        }
        else {
            duration = config.duration;
        }
        this.node = node;
        this._id = idCounter++;
        var layers = node.getLayer() ||
            (node instanceof Global_1.Konva['Stage'] ? node.getLayers() : null);
        if (!layers) {
            Util_1.Util.error('Tween constructor have `node` that is not in a layer. Please add node into layer first.');
        }
        this.anim = new Animation_1.Animation(function () {
            that.tween.onEnterFrame();
        }, layers);
        this.tween = new TweenEngine(key, function (i) {
            that._tweenFunc(i);
        }, easing, 0, 1, duration * 1000, yoyo);
        this._addListeners();
        if (!Tween.attrs[nodeId]) {
            Tween.attrs[nodeId] = {};
        }
        if (!Tween.attrs[nodeId][this._id]) {
            Tween.attrs[nodeId][this._id] = {};
        }
        if (!Tween.tweens[nodeId]) {
            Tween.tweens[nodeId] = {};
        }
        for (key in config) {
            if (blacklist[key] === undefined) {
                this._addAttr(key, config[key]);
            }
        }
        this.reset();
        this.onFinish = config.onFinish;
        this.onReset = config.onReset;
        this.onUpdate = config.onUpdate;
    }
    Tween.prototype._addAttr = function (key, end) {
        var node = this.node, nodeId = node._id, start, diff, tweenId, n, len, trueEnd, trueStart, endRGBA;
        tweenId = Tween.tweens[nodeId][key];
        if (tweenId) {
            delete Tween.attrs[nodeId][tweenId][key];
        }
        start = node.getAttr(key);
        if (Util_1.Util._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === 'points' && end.length !== start.length) {
                if (end.length > start.length) {
                    trueStart = start;
                    start = Util_1.Util._prepareArrayForTween(start, end, node.closed());
                }
                else {
                    trueEnd = end;
                    end = Util_1.Util._prepareArrayForTween(end, start, node.closed());
                }
            }
            if (key.indexOf('fill') === 0) {
                for (n = 0; n < len; n++) {
                    if (n % 2 === 0) {
                        diff.push(end[n] - start[n]);
                    }
                    else {
                        var startRGBA = Util_1.Util.colorToRGBA(start[n]);
                        endRGBA = Util_1.Util.colorToRGBA(end[n]);
                        start[n] = startRGBA;
                        diff.push({
                            r: endRGBA.r - startRGBA.r,
                            g: endRGBA.g - startRGBA.g,
                            b: endRGBA.b - startRGBA.b,
                            a: endRGBA.a - startRGBA.a,
                        });
                    }
                }
            }
            else {
                for (n = 0; n < len; n++) {
                    diff.push(end[n] - start[n]);
                }
            }
        }
        else if (colorAttrs.indexOf(key) !== -1) {
            start = Util_1.Util.colorToRGBA(start);
            endRGBA = Util_1.Util.colorToRGBA(end);
            diff = {
                r: endRGBA.r - start.r,
                g: endRGBA.g - start.g,
                b: endRGBA.b - start.b,
                a: endRGBA.a - start.a,
            };
        }
        else {
            diff = end - start;
        }
        Tween.attrs[nodeId][this._id][key] = {
            start: start,
            diff: diff,
            end: end,
            trueEnd: trueEnd,
            trueStart: trueStart,
        };
        Tween.tweens[nodeId][key] = this._id;
    };
    Tween.prototype._tweenFunc = function (i) {
        var node = this.node, attrs = Tween.attrs[node._id][this._id], key, attr, start, diff, newVal, n, len, end;
        for (key in attrs) {
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if (Util_1.Util._isArray(start)) {
                newVal = [];
                len = Math.max(start.length, end.length);
                if (key.indexOf('fill') === 0) {
                    for (n = 0; n < len; n++) {
                        if (n % 2 === 0) {
                            newVal.push((start[n] || 0) + diff[n] * i);
                        }
                        else {
                            newVal.push('rgba(' +
                                Math.round(start[n].r + diff[n].r * i) +
                                ',' +
                                Math.round(start[n].g + diff[n].g * i) +
                                ',' +
                                Math.round(start[n].b + diff[n].b * i) +
                                ',' +
                                (start[n].a + diff[n].a * i) +
                                ')');
                        }
                    }
                }
                else {
                    for (n = 0; n < len; n++) {
                        newVal.push((start[n] || 0) + diff[n] * i);
                    }
                }
            }
            else if (colorAttrs.indexOf(key) !== -1) {
                newVal =
                    'rgba(' +
                        Math.round(start.r + diff.r * i) +
                        ',' +
                        Math.round(start.g + diff.g * i) +
                        ',' +
                        Math.round(start.b + diff.b * i) +
                        ',' +
                        (start.a + diff.a * i) +
                        ')';
            }
            else {
                newVal = start + diff * i;
            }
            node.setAttr(key, newVal);
        }
    };
    Tween.prototype._addListeners = function () {
        var _this = this;
        this.tween.onPlay = function () {
            _this.anim.start();
        };
        this.tween.onReverse = function () {
            _this.anim.start();
        };
        this.tween.onPause = function () {
            _this.anim.stop();
        };
        this.tween.onFinish = function () {
            var node = _this.node;
            var attrs = Tween.attrs[node._id][_this._id];
            if (attrs.points && attrs.points.trueEnd) {
                node.setAttr('points', attrs.points.trueEnd);
            }
            if (_this.onFinish) {
                _this.onFinish.call(_this);
            }
        };
        this.tween.onReset = function () {
            var node = _this.node;
            var attrs = Tween.attrs[node._id][_this._id];
            if (attrs.points && attrs.points.trueStart) {
                node.points(attrs.points.trueStart);
            }
            if (_this.onReset) {
                _this.onReset();
            }
        };
        this.tween.onUpdate = function () {
            if (_this.onUpdate) {
                _this.onUpdate.call(_this);
            }
        };
    };
    Tween.prototype.play = function () {
        this.tween.play();
        return this;
    };
    Tween.prototype.reverse = function () {
        this.tween.reverse();
        return this;
    };
    Tween.prototype.reset = function () {
        this.tween.reset();
        return this;
    };
    Tween.prototype.seek = function (t) {
        this.tween.seek(t * 1000);
        return this;
    };
    Tween.prototype.pause = function () {
        this.tween.pause();
        return this;
    };
    Tween.prototype.finish = function () {
        this.tween.finish();
        return this;
    };
    Tween.prototype.destroy = function () {
        var nodeId = this.node._id, thisId = this._id, attrs = Tween.tweens[nodeId], key;
        this.pause();
        for (key in attrs) {
            delete Tween.tweens[nodeId][key];
        }
        delete Tween.attrs[nodeId][thisId];
    };
    Tween.attrs = {};
    Tween.tweens = {};
    return Tween;
}());
exports.Tween = Tween;
Node_1.Node.prototype.to = function (params) {
    var onFinish = params.onFinish;
    params.node = this;
    params.onFinish = function () {
        this.destroy();
        if (onFinish) {
            onFinish();
        }
    };
    var tween = new Tween(params);
    tween.play();
};
exports.Easings = {
    BackEaseIn: function (t, b, c, d) {
        var s = 1.70158;
        return c * (t /= d) * t * ((s + 1) * t - s) + b;
    },
    BackEaseOut: function (t, b, c, d) {
        var s = 1.70158;
        return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
    },
    BackEaseInOut: function (t, b, c, d) {
        var s = 1.70158;
        if ((t /= d / 2) < 1) {
            return (c / 2) * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
        }
        return (c / 2) * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
    },
    ElasticEaseIn: function (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) {
            return b;
        }
        if ((t /= d) === 1) {
            return b + c;
        }
        if (!p) {
            p = d * 0.3;
        }
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        }
        else {
            s = (p / (2 * Math.PI)) * Math.asin(c / a);
        }
        return (-(a *
            Math.pow(2, 10 * (t -= 1)) *
            Math.sin(((t * d - s) * (2 * Math.PI)) / p)) + b);
    },
    ElasticEaseOut: function (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) {
            return b;
        }
        if ((t /= d) === 1) {
            return b + c;
        }
        if (!p) {
            p = d * 0.3;
        }
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        }
        else {
            s = (p / (2 * Math.PI)) * Math.asin(c / a);
        }
        return (a * Math.pow(2, -10 * t) * Math.sin(((t * d - s) * (2 * Math.PI)) / p) +
            c +
            b);
    },
    ElasticEaseInOut: function (t, b, c, d, a, p) {
        var s = 0;
        if (t === 0) {
            return b;
        }
        if ((t /= d / 2) === 2) {
            return b + c;
        }
        if (!p) {
            p = d * (0.3 * 1.5);
        }
        if (!a || a < Math.abs(c)) {
            a = c;
            s = p / 4;
        }
        else {
            s = (p / (2 * Math.PI)) * Math.asin(c / a);
        }
        if (t < 1) {
            return (-0.5 *
                (a *
                    Math.pow(2, 10 * (t -= 1)) *
                    Math.sin(((t * d - s) * (2 * Math.PI)) / p)) +
                b);
        }
        return (a *
            Math.pow(2, -10 * (t -= 1)) *
            Math.sin(((t * d - s) * (2 * Math.PI)) / p) *
            0.5 +
            c +
            b);
    },
    BounceEaseOut: function (t, b, c, d) {
        if ((t /= d) < 1 / 2.75) {
            return c * (7.5625 * t * t) + b;
        }
        else if (t < 2 / 2.75) {
            return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
        }
        else if (t < 2.5 / 2.75) {
            return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
        }
        else {
            return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
        }
    },
    BounceEaseIn: function (t, b, c, d) {
        return c - exports.Easings.BounceEaseOut(d - t, 0, c, d) + b;
    },
    BounceEaseInOut: function (t, b, c, d) {
        if (t < d / 2) {
            return exports.Easings.BounceEaseIn(t * 2, 0, c, d) * 0.5 + b;
        }
        else {
            return exports.Easings.BounceEaseOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
        }
    },
    EaseIn: function (t, b, c, d) {
        return c * (t /= d) * t + b;
    },
    EaseOut: function (t, b, c, d) {
        return -c * (t /= d) * (t - 2) + b;
    },
    EaseInOut: function (t, b, c, d) {
        if ((t /= d / 2) < 1) {
            return (c / 2) * t * t + b;
        }
        return (-c / 2) * (--t * (t - 2) - 1) + b;
    },
    StrongEaseIn: function (t, b, c, d) {
        return c * (t /= d) * t * t * t * t + b;
    },
    StrongEaseOut: function (t, b, c, d) {
        return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
    },
    StrongEaseInOut: function (t, b, c, d) {
        if ((t /= d / 2) < 1) {
            return (c / 2) * t * t * t * t * t + b;
        }
        return (c / 2) * ((t -= 2) * t * t * t * t + 2) + b;
    },
    Linear: function (t, b, c, d) {
        return (c * t) / d + b;
    },
};


/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2534);
} else {
  module.exports = require('./cjs/react-reconciler.development.js');
}


/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/** @license React v0.25.1
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
module.exports = function $$$reconciler($$$hostConfig) {
'use strict';var aa=__webpack_require__(73),ba=__webpack_require__(0),m=__webpack_require__(2535);function n(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var p=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
p.hasOwnProperty("ReactCurrentDispatcher")||(p.ReactCurrentDispatcher={current:null});p.hasOwnProperty("ReactCurrentBatchConfig")||(p.ReactCurrentBatchConfig={suspense:null});
var u="function"===typeof Symbol&&Symbol.for,ca=u?Symbol.for("react.element"):60103,da=u?Symbol.for("react.portal"):60106,ea=u?Symbol.for("react.fragment"):60107,fa=u?Symbol.for("react.strict_mode"):60108,ha=u?Symbol.for("react.profiler"):60114,ia=u?Symbol.for("react.provider"):60109,ja=u?Symbol.for("react.context"):60110,ka=u?Symbol.for("react.concurrent_mode"):60111,la=u?Symbol.for("react.forward_ref"):60112,ma=u?Symbol.for("react.suspense"):60113,na=u?Symbol.for("react.suspense_list"):60120,oa=
u?Symbol.for("react.memo"):60115,pa=u?Symbol.for("react.lazy"):60116,qa=u?Symbol.for("react.block"):60121,ra="function"===typeof Symbol&&Symbol.iterator;function sa(a){if(null===a||"object"!==typeof a)return null;a=ra&&a[ra]||a["@@iterator"];return"function"===typeof a?a:null}function ta(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function ua(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ea:return"Fragment";case da:return"Portal";case ha:return"Profiler";case fa:return"StrictMode";case ma:return"Suspense";case na:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ja:return"Context.Consumer";case ia:return"Context.Provider";case la:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case oa:return ua(a.type);case qa:return ua(a.render);case pa:if(a=1===a._status?a._result:null)return ua(a)}return null}function va(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function wa(a){if(va(a)!==a)throw Error(n(188));}
function xa(a){var b=a.alternate;if(!b){b=va(a);if(null===b)throw Error(n(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return wa(e),a;if(f===d)return wa(e),b;f=f.sibling}throw Error(n(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(n(189));}}if(c.alternate!==d)throw Error(n(190));}if(3!==c.tag)throw Error(n(188));return c.stateNode.current===c?a:b}function ya(a){a=xa(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function za(a){a=xa(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var Aa=$$$hostConfig.getPublicInstance,Ba=$$$hostConfig.getRootHostContext,Ca=$$$hostConfig.getChildHostContext,Da=$$$hostConfig.prepareForCommit,Ea=$$$hostConfig.resetAfterCommit,Fa=$$$hostConfig.createInstance,Ga=$$$hostConfig.appendInitialChild,Ha=$$$hostConfig.finalizeInitialChildren,Ia=$$$hostConfig.prepareUpdate,Ja=$$$hostConfig.shouldSetTextContent,Ka=$$$hostConfig.shouldDeprioritizeSubtree,La=$$$hostConfig.createTextInstance,Ma=$$$hostConfig.setTimeout,Na=$$$hostConfig.clearTimeout,Oa=$$$hostConfig.noTimeout,
Pa=$$$hostConfig.isPrimaryRenderer,Qa=$$$hostConfig.supportsMutation,Ra=$$$hostConfig.supportsPersistence,Sa=$$$hostConfig.supportsHydration,Ta=$$$hostConfig.appendChild,Ua=$$$hostConfig.appendChildToContainer,Va=$$$hostConfig.commitTextUpdate,Wa=$$$hostConfig.commitMount,Xa=$$$hostConfig.commitUpdate,Ya=$$$hostConfig.insertBefore,Za=$$$hostConfig.insertInContainerBefore,$a=$$$hostConfig.removeChild,ab=$$$hostConfig.removeChildFromContainer,bb=$$$hostConfig.resetTextContent,cb=$$$hostConfig.hideInstance,
db=$$$hostConfig.hideTextInstance,eb=$$$hostConfig.unhideInstance,fb=$$$hostConfig.unhideTextInstance,gb=$$$hostConfig.cloneInstance,hb=$$$hostConfig.createContainerChildSet,ib=$$$hostConfig.appendChildToContainerChildSet,jb=$$$hostConfig.finalizeContainerChildren,kb=$$$hostConfig.replaceContainerChildren,lb=$$$hostConfig.cloneHiddenInstance,mb=$$$hostConfig.cloneHiddenTextInstance,nb=$$$hostConfig.canHydrateInstance,ob=$$$hostConfig.canHydrateTextInstance,pb=$$$hostConfig.isSuspenseInstancePending,
qb=$$$hostConfig.isSuspenseInstanceFallback,rb=$$$hostConfig.getNextHydratableSibling,sb=$$$hostConfig.getFirstHydratableChild,tb=$$$hostConfig.hydrateInstance,ub=$$$hostConfig.hydrateTextInstance,vb=$$$hostConfig.getNextHydratableInstanceAfterSuspenseInstance,wb=$$$hostConfig.commitHydratedContainer,xb=$$$hostConfig.commitHydratedSuspenseInstance,yb=/^(.*)[\\\/]/;
function zb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=ua(a.type);c=null;d&&(c=ua(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}var Ab=[],Bb=-1;function B(a){0>Bb||(a.current=Ab[Bb],Ab[Bb]=null,Bb--)}function C(a,b){Bb++;Ab[Bb]=a.current;a.current=b}
var Cb={},D={current:Cb},E={current:!1},Db=Cb;function Eb(a,b){var c=a.type.contextTypes;if(!c)return Cb;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function F(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Fb(){B(E);B(D)}
function Gb(a,b,c){if(D.current!==Cb)throw Error(n(168));C(D,b);C(E,c)}function Hb(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(n(108,ua(b)||"Unknown",e));return aa({},c,{},d)}function Ib(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cb;Db=D.current;C(D,a);C(E,E.current);return!0}
function Jb(a,b,c){var d=a.stateNode;if(!d)throw Error(n(169));c?(a=Hb(a,b,Db),d.__reactInternalMemoizedMergedChildContext=a,B(E),B(D),C(D,a)):B(E);C(E,c)}
var Kb=m.unstable_runWithPriority,Lb=m.unstable_scheduleCallback,Mb=m.unstable_cancelCallback,Nb=m.unstable_requestPaint,Ob=m.unstable_now,Pb=m.unstable_getCurrentPriorityLevel,Qb=m.unstable_ImmediatePriority,Rb=m.unstable_UserBlockingPriority,Sb=m.unstable_NormalPriority,Tb=m.unstable_LowPriority,Ub=m.unstable_IdlePriority,Vb={},Wb=m.unstable_shouldYield,Xb=void 0!==Nb?Nb:function(){},Yb=null,Zb=null,$b=!1,ac=Ob(),G=1E4>ac?Ob:function(){return Ob()-ac};
function bc(){switch(Pb()){case Qb:return 99;case Rb:return 98;case Sb:return 97;case Tb:return 96;case Ub:return 95;default:throw Error(n(332));}}function cc(a){switch(a){case 99:return Qb;case 98:return Rb;case 97:return Sb;case 96:return Tb;case 95:return Ub;default:throw Error(n(332));}}function dc(a,b){a=cc(a);return Kb(a,b)}function ec(a,b,c){a=cc(a);return Lb(a,b,c)}function fc(a){null===Yb?(Yb=[a],Zb=Lb(Qb,gc)):Yb.push(a);return Vb}function H(){if(null!==Zb){var a=Zb;Zb=null;Mb(a)}gc()}
function gc(){if(!$b&&null!==Yb){$b=!0;var a=0;try{var b=Yb;dc(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Yb=null}catch(c){throw null!==Yb&&(Yb=Yb.slice(a+1)),Lb(Qb,H),c;}finally{$b=!1}}}function hc(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ic(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var jc="function"===typeof Object.is?Object.is:ic,kc=Object.prototype.hasOwnProperty;
function lc(a,b){if(jc(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!kc.call(b,c[d])||!jc(a[c[d]],b[c[d]]))return!1;return!0}function mc(a,b){if(a&&a.defaultProps){b=aa({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var nc={current:null},oc=null,pc=null,qc=null;function rc(){qc=pc=oc=null}
function sc(a,b){a=a.type._context;Pa?(C(nc,a._currentValue),a._currentValue=b):(C(nc,a._currentValue2),a._currentValue2=b)}function tc(a){var b=nc.current;B(nc);a=a.type._context;Pa?a._currentValue=b:a._currentValue2=b}function uc(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vc(a,b){oc=a;qc=pc=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wc=!0),a.firstContext=null)}function I(a,b){if(qc!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qc=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pc){if(null===oc)throw Error(n(308));pc=b;oc.dependencies={expirationTime:0,firstContext:b,responders:null}}else pc=pc.next=b}return Pa?a._currentValue:a._currentValue2}var xc=!1;
function yc(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}function zc(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function Ac(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function Bc(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function Cc(a,b){var c=a.alternate;null!==c&&zc(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function Dc(a,b,c,d){var e=a.updateQueue;xc=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,q=null,r=null,w=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var Q={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===w?(r=w=Q,
q=k):w=w.next=Q;g>l&&(l=g)}else{null!==w&&(w=w.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ec(g,z.suspenseConfig);a:{var A=a,v=z;g=b;Q=c;switch(v.tag){case 1:A=v.payload;if("function"===typeof A){k=A.call(Q,k,g);break a}k=A;break a;case 3:A.effectTag=A.effectTag&-4097|64;case 0:A=v.payload;g="function"===typeof A?A.call(Q,k,g):A;if(null===g||void 0===g)break a;k=aa({},k,g);break a;case 2:xc=!0}}null!==z.callback&&(a.effectTag|=
32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===w?q=k:w.next=r;e.baseState=q;e.baseQueue=w;Gc(l);a.expirationTime=l;a.memoizedState=k}}function Hc(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(n(191,d));d.call(e)}}}
var Ic=p.ReactCurrentBatchConfig,Jc=(new ba.Component).refs;function Kc(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:aa({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Oc={isMounted:function(a){return(a=a._reactInternalFiber)?va(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Lc(),e=Ic.suspense;d=Mc(d,a,e);e=Ac(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Bc(a,e);Nc(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Lc(),e=Ic.suspense;d=Mc(d,a,e);e=Ac(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Bc(a,e);Nc(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Lc(),d=Ic.suspense;
c=Mc(c,a,d);d=Ac(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Bc(a,d);Nc(a,c)}};function Pc(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!lc(c,d)||!lc(e,f):!0}
function Qc(a,b,c){var d=!1,e=Cb;var f=b.contextType;"object"===typeof f&&null!==f?f=I(f):(e=F(b)?Db:D.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Eb(a,e):Cb);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Oc;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Rc(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Oc.enqueueReplaceState(b,b.state,null)}
function Sc(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Jc;yc(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=I(f):(f=F(b)?Db:D.current,e.context=Eb(a,f));Dc(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Kc(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Oc.enqueueReplaceState(e,e.state,null),Dc(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Tc=Array.isArray;
function Uc(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(n(309));var d=c.stateNode}if(!d)throw Error(n(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Jc&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(n(284));if(!c._owner)throw Error(n(290,a));}return a}
function Vc(a,b){if("textarea"!==a.type)throw Error(n(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Wc(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(b,a){for(b=new Map;null!==a;)null!==a.key?b.set(a.key,a):b.set(a.index,a),a=a.sibling;return b}function e(a,b){a=Xc(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(b,a,c,d){if(null===a||6!==a.tag)return a=Yc(c,b.mode,d),a.return=b,a;a=e(a,c);a.return=b;return a}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Uc(a,b,c),d.return=a,d;d=Zc(c.type,c.key,c.props,null,a.mode,d);d.ref=Uc(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=$c(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function q(b,a,c,d,f){if(null===a||7!==a.tag)return a=ad(c,b.mode,d,f),a.return=b,a;a=e(a,c);a.return=b;return a}function r(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Yc(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case ca:return c=Zc(b.type,b.key,b.props,null,a.mode,c),c.ref=Uc(a,null,b),c.return=a,c;case da:return b=$c(b,a.mode,c),b.return=a,b}if(Tc(b)||
sa(b))return b=ad(b,a.mode,c,null),b.return=a,b;Vc(a,b)}return null}function w(b,a,c,d){var e=null!==a?a.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(b,a,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case ca:return c.key===e?c.type===ea?q(b,a,c.props.children,d,e):k(b,a,c,d):null;case da:return c.key===e?l(b,a,c,d):null}if(Tc(c)||sa(c))return null!==e?null:q(b,a,c,d,null);Vc(b,c)}return null}function z(b,a,c,d,e){if("string"===typeof d||"number"===typeof d)return b=
b.get(c)||null,h(a,b,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case ca:return b=b.get(null===d.key?c:d.key)||null,d.type===ea?q(a,b,d.props.children,e,d.key):k(a,b,d,e);case da:return b=b.get(null===d.key?c:d.key)||null,l(a,b,d,e)}if(Tc(d)||sa(d))return b=b.get(c)||null,q(a,b,d,e,null);Vc(a,d)}return null}function Q(e,g,h,k){for(var l=null,v=null,t=g,x=g=0,q=null;null!==t&&x<h.length;x++){t.index>x?(q=t,t=null):q=t.sibling;var y=w(e,t,h[x],k);if(null===y){null===t&&(t=q);break}a&&
t&&null===y.alternate&&b(e,t);g=f(y,g,x);null===v?l=y:v.sibling=y;v=y;t=q}if(x===h.length)return c(e,t),l;if(null===t){for(;x<h.length;x++)t=r(e,h[x],k),null!==t&&(g=f(t,g,x),null===v?l=t:v.sibling=t,v=t);return l}for(t=d(e,t);x<h.length;x++)q=z(t,e,x,h[x],k),null!==q&&(a&&null!==q.alternate&&t.delete(null===q.key?x:q.key),g=f(q,g,x),null===v?l=q:v.sibling=q,v=q);a&&t.forEach(function(a){return b(e,a)});return l}function A(e,g,h,k){var t=sa(h);if("function"!==typeof t)throw Error(n(150));h=t.call(h);
if(null==h)throw Error(n(151));for(var l=t=null,v=g,x=g=0,q=null,y=h.next();null!==v&&!y.done;x++,y=h.next()){v.index>x?(q=v,v=null):q=v.sibling;var A=w(e,v,y.value,k);if(null===A){null===v&&(v=q);break}a&&v&&null===A.alternate&&b(e,v);g=f(A,g,x);null===l?t=A:l.sibling=A;l=A;v=q}if(y.done)return c(e,v),t;if(null===v){for(;!y.done;x++,y=h.next())y=r(e,y.value,k),null!==y&&(g=f(y,g,x),null===l?t=y:l.sibling=y,l=y);return t}for(v=d(e,v);!y.done;x++,y=h.next())y=z(v,e,x,y.value,k),null!==y&&(a&&null!==
y.alternate&&v.delete(null===y.key?x:y.key),g=f(y,g,x),null===l?t=y:l.sibling=y,l=y);a&&v.forEach(function(a){return b(e,a)});return t}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ea&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case ca:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ea){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Uc(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ea?(d=ad(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Zc(f.type,f.key,f.props,null,a.mode,h),h.ref=Uc(a,d,f),h.return=a,a=h)}return g(a);case da:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=$c(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Yc(f,a.mode,h),d.return=a,a=d),g(a);if(Tc(f))return Q(a,d,f,h);if(sa(f))return A(a,d,f,h);l&&Vc(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(n(152,a.displayName||a.name||"Component"));}return c(a,d)}}var bd=Wc(!0),cd=Wc(!1),dd={},J={current:dd},ed={current:dd},fd={current:dd};
function gd(a){if(a===dd)throw Error(n(174));return a}function hd(a,b){C(fd,b);C(ed,a);C(J,dd);a=Ba(b);B(J);C(J,a)}function id(){B(J);B(ed);B(fd)}function jd(a){var b=gd(fd.current),c=gd(J.current);b=Ca(c,a.type,b);c!==b&&(C(ed,a),C(J,b))}function kd(a){ed.current===a&&(B(J),B(ed))}var K={current:0};
function ld(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||pb(c)||qb(c)))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function md(a,b){return{responder:a,props:b}}
var nd=p.ReactCurrentDispatcher,L=p.ReactCurrentBatchConfig,od=0,M=null,N=null,O=null,pd=!1;function P(){throw Error(n(321));}function qd(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!jc(a[c],b[c]))return!1;return!0}
function rd(a,b,c,d,e,f){od=f;M=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;nd.current=null===a||null===a.memoizedState?sd:td;a=c(d,e);if(b.expirationTime===od){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(n(301));f+=1;O=N=null;b.updateQueue=null;nd.current=ud;a=c(d,e)}while(b.expirationTime===od)}nd.current=vd;b=null!==N&&null!==N.next;od=0;O=N=M=null;pd=!1;if(b)throw Error(n(300));return a}
function wd(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===O?M.memoizedState=O=a:O=O.next=a;return O}function xd(){if(null===N){var a=M.alternate;a=null!==a?a.memoizedState:null}else a=N.next;var b=null===O?M.memoizedState:O.next;if(null!==b)O=b,N=a;else{if(null===a)throw Error(n(310));N=a;a={memoizedState:N.memoizedState,baseState:N.baseState,baseQueue:N.baseQueue,queue:N.queue,next:null};null===O?M.memoizedState=O=a:O=O.next=a}return O}
function yd(a,b){return"function"===typeof b?b(a):b}
function zd(a){var b=xd(),c=b.queue;if(null===c)throw Error(n(311));c.lastRenderedReducer=a;var d=N,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<od){var q={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=q,f=d):h=h.next=q;l>M.expirationTime&&
(M.expirationTime=l,Gc(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ec(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;jc(d,b.memoizedState)||(wc=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function Ad(a){var b=xd(),c=b.queue;if(null===c)throw Error(n(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);jc(f,b.memoizedState)||(wc=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function Bd(a){var b=wd();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:yd,lastRenderedState:a};a=a.dispatch=Cd.bind(null,M,a);return[b.memoizedState,a]}function Dd(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=M.updateQueue;null===b?(b={lastEffect:null},M.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Ed(){return xd().memoizedState}function Fd(a,b,c,d){var e=wd();M.effectTag|=a;e.memoizedState=Dd(1|b,c,void 0,void 0===d?null:d)}function Gd(a,b,c,d){var e=xd();d=void 0===d?null:d;var f=void 0;if(null!==N){var g=N.memoizedState;f=g.destroy;if(null!==d&&qd(d,g.deps)){Dd(b,c,f,d);return}}M.effectTag|=a;e.memoizedState=Dd(1|b,c,f,d)}function Hd(a,b){return Fd(516,4,a,b)}function Id(a,b){return Gd(516,4,a,b)}function Jd(a,b){return Gd(4,2,a,b)}
function Kd(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ld(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Gd(4,2,Kd.bind(null,b,a),c)}function Md(){}function Nd(a,b){wd().memoizedState=[a,void 0===b?null:b];return a}function Od(a,b){var c=xd();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&qd(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Pd(a,b){var c=xd();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&qd(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Qd(a,b,c){var d=bc();dc(98>d?98:d,function(){a(!0)});dc(97<d?97:d,function(){var d=L.suspense;L.suspense=void 0===b?null:b;try{a(!1),c()}finally{L.suspense=d}})}
function Cd(a,b,c){var d=Lc(),e=Ic.suspense;d=Mc(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===M||null!==f&&f===M)pd=!0,e.expirationTime=od,M.expirationTime=od;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if(jc(h,g))return}catch(k){}finally{}Nc(a,
d)}}
var vd={readContext:I,useCallback:P,useContext:P,useEffect:P,useImperativeHandle:P,useLayoutEffect:P,useMemo:P,useReducer:P,useRef:P,useState:P,useDebugValue:P,useResponder:P,useDeferredValue:P,useTransition:P},sd={readContext:I,useCallback:Nd,useContext:I,useEffect:Hd,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Fd(4,2,Kd.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Fd(4,2,a,b)},useMemo:function(a,b){var c=wd();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=wd();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Cd.bind(null,M,a);return[d.memoizedState,a]},useRef:function(a){var b=wd();a={current:a};return b.memoizedState=a},useState:Bd,useDebugValue:Md,useResponder:md,useDeferredValue:function(a,b){var c=Bd(a),d=c[0],e=c[1];Hd(function(){var c=L.suspense;L.suspense=void 0===b?null:b;try{e(a)}finally{L.suspense=c}},
[a,b]);return d},useTransition:function(a){var b=Bd(!1),c=b[0];b=b[1];return[Nd(Qd.bind(null,b,a),[b,a]),c]}},td={readContext:I,useCallback:Od,useContext:I,useEffect:Id,useImperativeHandle:Ld,useLayoutEffect:Jd,useMemo:Pd,useReducer:zd,useRef:Ed,useState:function(){return zd(yd)},useDebugValue:Md,useResponder:md,useDeferredValue:function(a,b){var c=zd(yd),d=c[0],e=c[1];Id(function(){var c=L.suspense;L.suspense=void 0===b?null:b;try{e(a)}finally{L.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
zd(yd),c=b[0];b=b[1];return[Od(Qd.bind(null,b,a),[b,a]),c]}},ud={readContext:I,useCallback:Od,useContext:I,useEffect:Id,useImperativeHandle:Ld,useLayoutEffect:Jd,useMemo:Pd,useReducer:Ad,useRef:Ed,useState:function(){return Ad(yd)},useDebugValue:Md,useResponder:md,useDeferredValue:function(a,b){var c=Ad(yd),d=c[0],e=c[1];Id(function(){var c=L.suspense;L.suspense=void 0===b?null:b;try{e(a)}finally{L.suspense=c}},[a,b]);return d},useTransition:function(a){var b=Ad(yd),c=b[0];b=b[1];return[Od(Qd.bind(null,
b,a),[b,a]),c]}},Rd=null,Sd=null,Td=!1;function Ud(a,b){var c=Vd(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Wd(a,b){switch(a.tag){case 5:return b=nb(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=ob(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Xd(a){if(Td){var b=Sd;if(b){var c=b;if(!Wd(a,b)){b=rb(c);if(!b||!Wd(a,b)){a.effectTag=a.effectTag&-1025|2;Td=!1;Rd=a;return}Ud(Rd,c)}Rd=a;Sd=sb(b)}else a.effectTag=a.effectTag&-1025|2,Td=!1,Rd=a}}function Yd(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Rd=a}
function Zd(a){if(!Sa||a!==Rd)return!1;if(!Td)return Yd(a),Td=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ja(b,a.memoizedProps))for(b=Sd;b;)Ud(a,b),b=rb(b);Yd(a);if(13===a.tag){if(!Sa)throw Error(n(316));a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(n(317));Sd=vb(a)}else Sd=Rd?rb(a.stateNode):null;return!0}function $d(){Sa&&(Sd=Rd=null,Td=!1)}var ae=p.ReactCurrentOwner,wc=!1;function R(a,b,c,d){b.child=null===a?cd(b,null,c,d):bd(b,a.child,c,d)}
function be(a,b,c,d,e){c=c.render;var f=b.ref;vc(b,e);d=rd(a,b,c,d,f,e);if(null!==a&&!wc)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),ce(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function de(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ee(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,fe(a,b,g,d,e,f);a=Zc(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:lc,c(e,d)&&a.ref===b.ref))return ce(a,b,f);b.effectTag|=1;a=Xc(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function fe(a,b,c,d,e,f){return null!==a&&lc(a.memoizedProps,d)&&a.ref===b.ref&&(wc=!1,e<f)?(b.expirationTime=a.expirationTime,ce(a,b,f)):ge(a,b,c,d,f)}function he(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function ge(a,b,c,d,e){var f=F(c)?Db:D.current;f=Eb(b,f);vc(b,e);c=rd(a,b,c,d,f,e);if(null!==a&&!wc)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),ce(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ie(a,b,c,d,e){if(F(c)){var f=!0;Ib(b)}else f=!1;vc(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Qc(b,c,d),Sc(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=I(l):(l=F(c)?Db:D.current,l=Eb(b,l));var q=c.getDerivedStateFromProps,r="function"===typeof q||"function"===typeof g.getSnapshotBeforeUpdate;r||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Rc(b,g,d,l);xc=!1;var w=b.memoizedState;g.state=w;Dc(b,d,g,e);k=b.memoizedState;h!==d||w!==k||E.current||xc?("function"===typeof q&&(Kc(b,c,q,d),k=b.memoizedState),(h=xc||Pc(b,c,h,d,w,k,l))?(r||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,zc(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:mc(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=I(l):(l=F(c)?Db:D.current,l=Eb(b,l)),q=c.getDerivedStateFromProps,(r="function"===typeof q||"function"===typeof g.getSnapshotBeforeUpdate)||
"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Rc(b,g,d,l),xc=!1,k=b.memoizedState,g.state=k,Dc(b,d,g,e),w=b.memoizedState,h!==d||k!==w||E.current||xc?("function"===typeof q&&(Kc(b,c,q,d),w=b.memoizedState),(q=xc||Pc(b,c,h,d,k,w,l))?(r||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,w,l),"function"===typeof g.UNSAFE_componentWillUpdate&&
g.UNSAFE_componentWillUpdate(d,w,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=w),g.props=d,g.state=w,g.context=l,d=q):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&
k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return je(a,b,c,d,f,e)}
function je(a,b,c,d,e,f){he(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Jb(b,c,!1),ce(a,b,f);d=b.stateNode;ae.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=bd(b,a.child,null,f),b.child=bd(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Jb(b,c,!0);return b.child}function le(a){var b=a.stateNode;b.pendingContext?Gb(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Gb(a,b.context,!1);hd(a,b.containerInfo)}
var me={dehydrated:null,retryTime:0};
function ne(a,b,c){var d=b.mode,e=b.pendingProps,f=K.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);C(K,f&1);if(null===a){void 0!==e.fallback&&Xd(b);if(g){g=e.fallback;e=ad(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=ad(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=me;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=cd(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Xc(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Xc(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=me;b.child=c;return d}c=bd(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=ad(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=ad(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=me;b.child=e;return c}b.memoizedState=null;return b.child=bd(b,a,e.children,c)}
function oe(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);uc(a.return,b)}function pe(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function qe(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=K.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&oe(a,c);else if(19===a.tag)oe(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}C(K,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ld(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);pe(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ld(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}pe(b,!0,c,null,f,b.lastEffect);break;case "together":pe(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function ce(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Gc(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(n(153));if(null!==b.child){a=b.child;c=Xc(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Xc(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}function re(a){a.effectTag|=4}var se,te,ue,ve;
if(Qa)se=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)Ga(a,c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}},te=function(){},ue=function(a,b,c,d,e){a=a.memoizedProps;if(a!==d){var f=b.stateNode,g=gd(J.current);c=Ia(f,c,a,d,e,g);(b.updateQueue=c)&&re(b)}},ve=function(a,b,c,d){c!==d&&re(b)};else if(Ra){se=function(a,
b,c,d){for(var e=b.child;null!==e;){if(5===e.tag){var f=e.stateNode;c&&d&&(f=lb(f,e.type,e.memoizedProps,e));Ga(a,f)}else if(6===e.tag)f=e.stateNode,c&&d&&(f=mb(f,e.memoizedProps,e)),Ga(a,f);else if(4!==e.tag){if(13===e.tag&&0!==(e.effectTag&4)&&(f=null!==e.memoizedState)){var g=e.child;if(null!==g&&(null!==g.child&&(g.child.return=g,se(a,g,!0,f)),f=g.sibling,null!==f)){f.return=e;e=f;continue}}if(null!==e.child){e.child.return=e;e=e.child;continue}}if(e===b)break;for(;null===e.sibling;){if(null===
e.return||e.return===b)return;e=e.return}e.sibling.return=e.return;e=e.sibling}};var we=function(a,b,c,d){for(var e=b.child;null!==e;){if(5===e.tag){var f=e.stateNode;c&&d&&(f=lb(f,e.type,e.memoizedProps,e));ib(a,f)}else if(6===e.tag)f=e.stateNode,c&&d&&(f=mb(f,e.memoizedProps,e)),ib(a,f);else if(4!==e.tag){if(13===e.tag&&0!==(e.effectTag&4)&&(f=null!==e.memoizedState)){var g=e.child;if(null!==g&&(null!==g.child&&(g.child.return=g,we(a,g,!0,f)),f=g.sibling,null!==f)){f.return=e;e=f;continue}}if(null!==
e.child){e.child.return=e;e=e.child;continue}}if(e===b)break;for(;null===e.sibling;){if(null===e.return||e.return===b)return;e=e.return}e.sibling.return=e.return;e=e.sibling}};te=function(a){var b=a.stateNode;if(null!==a.firstEffect){var c=b.containerInfo,d=hb(c);we(d,a,!1,!1);b.pendingChildren=d;re(a);jb(c,d)}};ue=function(a,b,c,d,e){var f=a.stateNode,g=a.memoizedProps;if((a=null===b.firstEffect)&&g===d)b.stateNode=f;else{var h=b.stateNode,k=gd(J.current),l=null;g!==d&&(l=Ia(h,c,g,d,e,k));a&&null===
l?b.stateNode=f:(f=gb(f,l,c,g,d,b,a,h),Ha(f,c,d,e,k)&&re(b),b.stateNode=f,a?re(b):se(f,b,!1,!1))}};ve=function(a,b,c,d){c!==d?(a=gd(fd.current),c=gd(J.current),b.stateNode=La(d,a,c,b),re(b)):b.stateNode=a.stateNode}}else te=function(){},ue=function(){},ve=function(){};
function xe(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function ye(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return F(b.type)&&Fb(),null;case 3:return id(),B(E),B(D),d=b.stateNode,d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null),(null===a||null===a.child)&&Zd(b)&&re(b),te(b),null;case 5:kd(b);var e=gd(fd.current);c=b.type;if(null!==a&&null!=b.stateNode)ue(a,b,c,d,e),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(n(166));
return null}a=gd(J.current);if(Zd(b)){if(!Sa)throw Error(n(175));a=tb(b.stateNode,b.type,b.memoizedProps,e,a,b);b.updateQueue=a;null!==a&&re(b)}else{var f=Fa(c,d,e,a,b);se(f,b,!1,!1);b.stateNode=f;Ha(f,c,d,e,a)&&re(b)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)ve(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(n(166));a=gd(fd.current);e=gd(J.current);if(Zd(b)){if(!Sa)throw Error(n(176));ub(b.stateNode,b.memoizedProps,b)&&re(b)}else b.stateNode=
La(d,a,e,b)}return null;case 13:B(K);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;d=null!==d;e=!1;null===a?void 0!==b.memoizedProps.fallback&&Zd(b):(c=a.memoizedState,e=null!==c,d||null===c||(c=a.child.sibling,null!==c&&(f=b.firstEffect,null!==f?(b.firstEffect=c,c.nextEffect=f):(b.firstEffect=b.lastEffect=c,c.nextEffect=null),c.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(K.current&1))S===ze&&(S=Ae);else{if(S===
ze||S===Ae)S=Be;0!==Ce&&null!==T&&(De(T,U),Ee(T,Ce))}Ra&&d&&(b.effectTag|=4);Qa&&(d||e)&&(b.effectTag|=4);return null;case 4:return id(),te(b),null;case 10:return tc(b),null;case 17:return F(b.type)&&Fb(),null;case 19:B(K);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)xe(d,!1);else{if(S!==ze||null!==a&&0!==(a.effectTag&64))for(a=b.child;null!==a;){f=ld(a);if(null!==f){b.effectTag|=64;xe(d,!1);a=f.updateQueue;null!==a&&(b.updateQueue=a,b.effectTag|=
4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;a=c;for(d=b.child;null!==d;)e=d,c=a,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,f=e.alternate,null===f?(e.childExpirationTime=0,e.expirationTime=c,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=f.childExpirationTime,e.expirationTime=f.expirationTime,e.child=f.child,e.memoizedProps=f.memoizedProps,e.memoizedState=f.memoizedState,e.updateQueue=
f.updateQueue,c=f.dependencies,e.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),d=d.sibling;C(K,K.current&1|2);return b.child}a=a.sibling}}else{if(!e)if(a=ld(f),null!==a){if(b.effectTag|=64,e=!0,a=a.updateQueue,null!==a&&(b.updateQueue=a,b.effectTag|=4),xe(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*G()-d.renderingStartTime>d.tailExpiration&&
1<c&&(b.effectTag|=64,e=!0,xe(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(a=d.last,null!==a?a.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=G()+500),a=d.tail,d.rendering=a,d.tail=a.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=G(),a.sibling=null,b=K.current,C(K,e?b&1|2:b&1),a):null}throw Error(n(156,b.tag));}
function Fe(a){switch(a.tag){case 1:F(a.type)&&Fb();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:id();B(E);B(D);b=a.effectTag;if(0!==(b&64))throw Error(n(285));a.effectTag=b&-4097|64;return a;case 5:return kd(a),null;case 13:return B(K),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return B(K),null;case 4:return id(),null;case 10:return tc(a),null;default:return null}}function Ge(a,b){return{value:a,source:b,stack:zb(b)}}
var He="function"===typeof WeakSet?WeakSet:Set;function Ie(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=zb(c));null!==c&&ua(c.type);b=b.value;null!==a&&1===a.tag&&ua(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Je(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ke(a,c)}}function Le(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ke(a,c)}else b.current=null}
function Me(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mc(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(n(163));}
function Ne(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Oe(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Pe(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Oe(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:mc(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Hc(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=Aa(c.child.stateNode);break;case 1:a=c.child.stateNode}Hc(c,b,
a)}return;case 5:a=c.stateNode;null===b&&c.effectTag&4&&Wa(a,c.type,c.memoizedProps,c);return;case 6:return;case 4:return;case 12:return;case 13:Sa&&null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&xb(c))));return;case 19:case 17:case 20:case 21:return}throw Error(n(163));}
function Qe(a,b,c){"function"===typeof Re&&Re(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;dc(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ke(g,h)}}a=a.next}while(a!==d)})}break;case 1:Le(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Je(b,c);break;case 5:Le(b);break;case 4:Qa?Se(a,b,c):Ra&&Te(b)}}
function Ue(a,b,c){for(var d=b;;)if(Qe(a,d,c),null===d.child||Qa&&4===d.tag){if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return}d.sibling.return=d.return;d=d.sibling}else d.child.return=d,d=d.child}function Ve(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ve(b)}
function Te(a){if(Ra){a=a.stateNode.containerInfo;var b=hb(a);kb(a,b)}}function We(a){return 5===a.tag||3===a.tag||4===a.tag}
function Xe(a){if(Qa){a:{for(var b=a.return;null!==b;){if(We(b)){var c=b;break a}b=b.return}throw Error(n(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(n(161));}c.effectTag&16&&(bb(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||We(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Ye(a,c,b):Ze(a,c,b)}}function Ye(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?Za(c,a,b):Ua(c,a);else if(4!==d&&(a=a.child,null!==a))for(Ye(a,b,c),a=a.sibling;null!==a;)Ye(a,b,c),a=a.sibling}
function Ze(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?Ya(c,a,b):Ta(c,a);else if(4!==d&&(a=a.child,null!==a))for(Ze(a,b,c),a=a.sibling;null!==a;)Ze(a,b,c),a=a.sibling}
function Se(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(n(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag)Ue(a,d,c),g?ab(f,d.stateNode):$a(f,d.stateNode);else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Qe(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;
for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function $e(a,b){if(Qa){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Ne(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Xa(c,f,e,a,d,b)}return;case 6:if(null===b.stateNode)throw Error(n(162));c=b.memoizedProps;Va(b.stateNode,null!==a?a.memoizedProps:c,c);return;case 3:Sa&&(b=b.stateNode,b.hydrate&&(b.hydrate=!1,wb(b.containerInfo)));return;case 12:return;case 13:af(b);
bf(b);return;case 19:bf(b);return;case 17:return}throw Error(n(163));}switch(b.tag){case 0:case 11:case 14:case 15:case 22:Ne(3,b);return;case 12:return;case 13:af(b);bf(b);return;case 19:bf(b);return;case 3:Sa&&(c=b.stateNode,c.hydrate&&(c.hydrate=!1,wb(c.containerInfo)))}a:if(Ra){switch(b.tag){case 1:case 5:case 6:case 20:break a;case 3:case 4:b=b.stateNode;kb(b.containerInfo,b.pendingChildren);break a}throw Error(n(163));}}
function af(a){var b=a;if(null===a.memoizedState)var c=!1;else c=!0,b=a.child,cf=G();if(Qa&&null!==b)a:if(a=b,Qa)for(b=a;;){if(5===b.tag){var d=b.stateNode;c?cb(d):eb(b.stateNode,b.memoizedProps)}else if(6===b.tag)d=b.stateNode,c?db(d):fb(d,b.memoizedProps);else if(13===b.tag&&null!==b.memoizedState&&null===b.memoizedState.dehydrated){d=b.child.sibling;d.return=b;b=d;continue}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break a;for(;null===b.sibling;){if(null===b.return||b.return===
a)break a;b=b.return}b.sibling.return=b.return;b=b.sibling}}function bf(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new He);b.forEach(function(b){var d=df.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ef="function"===typeof WeakMap?WeakMap:Map;function ff(a,b,c){c=Ac(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gf||(gf=!0,hf=d);Ie(a,b)};return c}
function jf(a,b,c){c=Ac(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ie(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===kf?kf=new Set([this]):kf.add(this),Ie(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var lf=Math.ceil,mf=p.ReactCurrentDispatcher,nf=p.ReactCurrentOwner,V=0,of=8,pf=16,qf=32,ze=0,rf=1,sf=2,Ae=3,Be=4,tf=5,W=V,T=null,X=null,U=0,S=ze,uf=null,vf=1073741823,wf=1073741823,xf=null,Ce=0,yf=!1,cf=0,zf=500,Y=null,gf=!1,hf=null,kf=null,Af=!1,Bf=null,Cf=90,Df=null,Ef=0,Ff=null,Gf=0;function Lc(){return(W&(pf|qf))!==V?1073741821-(G()/10|0):0!==Gf?Gf:Gf=1073741821-(G()/10|0)}
function Mc(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=bc();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&pf)!==V)return U;if(null!==c)a=hc(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hc(a,150,100);break;case 97:case 96:a=hc(a,5E3,250);break;case 95:a=2;break;default:throw Error(n(326));}null!==T&&a===U&&--a;return a}
function Nc(a,b){if(50<Ef)throw Ef=0,Ff=null,Error(n(185));a=Hf(a,b);if(null!==a){var c=bc();1073741823===b?(W&of)!==V&&(W&(pf|qf))===V?If(a):(Z(a),W===V&&H()):Z(a);(W&4)===V||98!==c&&99!==c||(null===Df?Df=new Map([[a,b]]):(c=Df.get(a),(void 0===c||c>b)&&Df.set(a,b)))}}
function Hf(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Gc(b),S===Be&&De(e,U)),Ee(e,b));return e}
function Jf(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Kf(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=fc(If.bind(null,a));else{var b=Jf(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Lc();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Vb&&Mb(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?fc(If.bind(null,a)):ec(d,Lf.bind(null,a),{timeout:10*(1073741821-b)-G()});a.callbackNode=b}}}
function Lf(a,b){Gf=0;if(b)return b=Lc(),Mf(a,b),Z(a),null;var c=Jf(a);if(0!==c){b=a.callbackNode;if((W&(pf|qf))!==V)throw Error(n(327));Nf();a===T&&c===U||Of(a,c);if(null!==X){var d=W;W|=pf;var e=Pf();do try{Qf();break}catch(h){Rf(a,h)}while(1);rc();W=d;mf.current=e;if(S===rf)throw b=uf,Of(a,c),De(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ze:case rf:throw Error(n(345));case sf:Mf(a,2<c?2:c);break;case Ae:De(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Sf(e));if(1073741823===vf&&(e=cf+zf-G(),10<e)){if(yf){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Of(a,c);break}}f=Jf(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Ma(Tf.bind(null,a),e);break}Tf(a);break;case Be:De(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Sf(e));if(yf&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Of(a,c);break}e=Jf(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==wf?d=10*(1073741821-wf)-G():1073741823===vf?d=0:(d=10*(1073741821-vf)-5E3,e=G(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*lf(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Ma(Tf.bind(null,a),d);break}Tf(a);break;case tf:if(1073741823!==vf&&null!==xf){f=vf;var g=xf;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=G()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){De(a,c);a.timeoutHandle=
Ma(Tf.bind(null,a),d);break}}Tf(a);break;default:throw Error(n(329));}Z(a);if(a.callbackNode===b)return Lf.bind(null,a)}}return null}
function If(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(pf|qf))!==V)throw Error(n(327));Nf();a===T&&b===U||Of(a,b);if(null!==X){var c=W;W|=pf;var d=Pf();do try{Uf();break}catch(e){Rf(a,e)}while(1);rc();W=c;mf.current=d;if(S===rf)throw c=uf,Of(a,b),De(a,b),Z(a),c;if(null!==X)throw Error(n(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Tf(a);Z(a)}return null}function Vf(a,b){Mf(a,b);Z(a);(W&(pf|qf))===V&&H()}
function Wf(){if(null!==Df){var a=Df;Df=null;a.forEach(function(a,c){Mf(c,a);Z(c)});H()}}function Xf(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&H()}}function Yf(a,b){if((W&(pf|qf))!==V)throw Error(n(187));var c=W;W|=1;try{return dc(99,a.bind(null,b))}finally{W=c,H()}}
function Of(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;c!==Oa&&(a.timeoutHandle=Oa,Na(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Fb();break;case 3:id();B(E);B(D);break;case 5:kd(d);break;case 4:id();break;case 13:B(K);break;case 19:B(K);break;case 10:tc(d)}c=c.return}T=a;X=Xc(a.current,null);U=b;S=ze;uf=null;wf=vf=1073741823;xf=null;Ce=0;yf=!1}
function Rf(a,b){do{try{rc();nd.current=vd;if(pd)for(var c=M.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}od=0;O=N=M=null;pd=!1;if(null===X||null===X.return)return S=rf,uf=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var q=0!==(K.current&1),r=f;do{var w;if(w=13===r.tag){var z=r.memoizedState;if(null!==z)w=null!==z.dehydrated?!0:!1;else{var Q=r.memoizedProps;w=void 0===Q.fallback?!1:!0!==Q.unstable_avoidThisFallback?!0:q?!1:!0}}if(w){var A=r.updateQueue;if(null===A){var v=new Set;v.add(k);r.updateQueue=v}else A.add(k);if(0===(r.mode&2)){r.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var t=Ac(1073741823,null);t.tag=2;Bc(g,t)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var x=e.pingCache;null===x?(x=e.pingCache=new ef,h=new Set,x.set(k,h)):(h=x.get(k),void 0===h&&(h=new Set,x.set(k,h)));if(!h.has(g)){h.add(g);var ke=cg.bind(null,e,k,g);k.then(ke,ke)}r.effectTag|=4096;r.expirationTime=b;break a}r=r.return}while(null!==r);h=Error((ua(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
zb(g))}S!==tf&&(S=sf);h=Ge(h,g);r=f;do{switch(r.tag){case 3:k=h;r.effectTag|=4096;r.expirationTime=b;var Zf=ff(r,k,b);Cc(r,Zf);break a;case 1:k=h;var $f=r.type,Fc=r.stateNode;if(0===(r.effectTag&64)&&("function"===typeof $f.getDerivedStateFromError||null!==Fc&&"function"===typeof Fc.componentDidCatch&&(null===kf||!kf.has(Fc)))){r.effectTag|=4096;r.expirationTime=b;var ag=jf(r,k,b);Cc(r,ag);break a}}r=r.return}while(null!==r)}X=dg(X)}catch(bg){b=bg;continue}break}while(1)}
function Pf(){var a=mf.current;mf.current=vd;return null===a?vd:a}function Ec(a,b){a<vf&&2<a&&(vf=a);null!==b&&a<wf&&2<a&&(wf=a,xf=b)}function Gc(a){a>Ce&&(Ce=a)}function Uf(){for(;null!==X;)X=eg(X)}function Qf(){for(;null!==X&&!Wb();)X=eg(X)}function eg(a){var b=fg(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=dg(a));nf.current=null;return b}
function dg(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=ye(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=Fe(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ze&&(S=tf);return null}function Sf(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Tf(a){var b=bc();dc(99,gg.bind(null,a,b));return null}
function gg(a,b){do Nf();while(null!==Bf);if((W&(pf|qf))!==V)throw Error(n(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(n(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Sf(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=qf;nf.current=null;Da(a.containerInfo);Y=e;do try{hg()}catch(t){if(null===Y)throw Error(n(330));Ke(Y,t);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(var g=a,h=b;null!==Y;){var k=Y.effectTag;k&16&&Qa&&bb(Y.stateNode);if(k&128){var l=Y.alternate;if(null!==l){var q=l.ref;
null!==q&&("function"===typeof q?q(null):q.current=null)}}switch(k&1038){case 2:Xe(Y);Y.effectTag&=-3;break;case 6:Xe(Y);Y.effectTag&=-3;$e(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;$e(Y.alternate,Y);break;case 4:$e(Y.alternate,Y);break;case 8:var r=g,w=Y,z=h;Qa?Se(r,w,z):Ue(r,w,z);Ve(w)}Y=Y.nextEffect}}catch(t){if(null===Y)throw Error(n(330));Ke(Y,t);Y=Y.nextEffect}while(null!==Y);Ea(a.containerInfo);a.current=c;Y=e;do try{for(k=a;null!==Y;){var Q=Y.effectTag;
Q&36&&Pe(k,Y.alternate,Y);if(Q&128){l=void 0;var A=Y.ref;if(null!==A){var v=Y.stateNode;switch(Y.tag){case 5:l=Aa(v);break;default:l=v}"function"===typeof A?A(l):A.current=l}}Y=Y.nextEffect}}catch(t){if(null===Y)throw Error(n(330));Ke(Y,t);Y=Y.nextEffect}while(null!==Y);Y=null;Xb();W=f}else a.current=c;if(Af)Af=!1,Bf=a,Cf=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(kf=null);1073741823===b?a===Ff?Ef++:(Ef=0,Ff=a):Ef=0;"function"===typeof ig&&ig(c.stateNode,
d);Z(a);if(gf)throw gf=!1,a=hf,hf=null,a;if((W&of)!==V)return null;H();return null}function hg(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Me(Y.alternate,Y);0===(a&512)||Af||(Af=!0,ec(97,function(){Nf();return null}));Y=Y.nextEffect}}function Nf(){if(90!==Cf){var a=97<Cf?97:Cf;Cf=90;return dc(a,jg)}}
function jg(){if(null===Bf)return!1;var a=Bf;Bf=null;if((W&(pf|qf))!==V)throw Error(n(331));var b=W;W|=qf;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Ne(5,c),Oe(5,c)}}catch(d){if(null===a)throw Error(n(330));Ke(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;H();return!0}function kg(a,b,c){b=Ge(c,b);b=ff(a,b,1073741823);Bc(a,b);a=Hf(a,1073741823);null!==a&&Z(a)}
function Ke(a,b){if(3===a.tag)kg(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){kg(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===kf||!kf.has(d))){a=Ge(b,a);a=jf(c,a,1073741823);Bc(c,a);c=Hf(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function cg(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===Be||S===Ae&&1073741823===vf&&G()-cf<zf?Of(a,U):yf=!0:Kf(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function df(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Lc(),b=Mc(b,a,null));a=Hf(a,b);null!==a&&Z(a)}var fg;
fg=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||E.current)wc=!0;else{if(d<c){wc=!1;switch(b.tag){case 3:le(b);$d();break;case 5:jd(b);if(b.mode&4&&1!==c&&Ka(b.type,e))return b.expirationTime=b.childExpirationTime=1,null;break;case 1:F(b.type)&&Ib(b);break;case 4:hd(b,b.stateNode.containerInfo);break;case 10:sc(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return ne(a,b,c);C(K,K.current&
1);b=ce(a,b,c);return null!==b?b.sibling:null}C(K,K.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return qe(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);C(K,K.current);if(!d)return null}return ce(a,b,c)}wc=!1}}else wc=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Eb(b,D.current);vc(b,c);e=rd(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&
null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(F(d)){var f=!0;Ib(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;yc(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Kc(b,d,g,a);e.updater=Oc;b.stateNode=e;e._reactInternalFiber=b;Sc(b,d,a,c);b=je(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;
ta(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=lg(e);a=mc(e,a);switch(f){case 0:b=ge(null,b,e,a,c);break a;case 1:b=ie(null,b,e,a,c);break a;case 11:b=be(null,b,e,a,c);break a;case 14:b=de(null,b,e,mc(e.type,a),d,c);break a}throw Error(n(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mc(d,e),ge(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mc(d,e),ie(a,b,d,e,c);case 3:le(b);d=b.updateQueue;if(null===a||null===d)throw Error(n(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;zc(a,b);Dc(b,d,null,c);d=b.memoizedState.element;if(d===e)$d(),b=ce(a,b,c);else{if(e=b.stateNode.hydrate)Sa?(Sd=sb(b.stateNode.containerInfo),Rd=b,e=Td=!0):e=!1;if(e)for(c=cd(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),$d();b=b.child}return b;case 5:return jd(b),null===a&&Xd(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,Ja(d,e)?g=null:null!==f&&Ja(d,f)&&(b.effectTag|=16),
he(a,b),b.mode&4&&1!==c&&Ka(d,e)?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Xd(b),null;case 13:return ne(a,b,c);case 4:return hd(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=bd(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mc(d,e),be(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,
c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;sc(b,f);if(null!==g){var h=g.value;f=jc(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!E.current){b=ce(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Ac(c,null),l.tag=2,Bc(h,
l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);uc(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vc(b,c),e=I(e,f.unstable_observedBits),
d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=mc(e,b.pendingProps),f=mc(e.type,f),de(a,b,e,f,d,c);case 15:return fe(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mc(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,F(d)?(a=!0,Ib(b)):a=!1,vc(b,c),Qc(b,d,e),Sc(b,d,e,c),je(null,b,d,!0,a,c);case 19:return qe(a,b,c)}throw Error(n(156,b.tag));};var mg={current:!1},ig=null,Re=null;
function ng(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);ig=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Re=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function og(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Vd(a,b,c,d){return new og(a,b,c,d)}
function ee(a){a=a.prototype;return!(!a||!a.isReactComponent)}function lg(a){if("function"===typeof a)return ee(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===la)return 11;if(a===oa)return 14}return 2}
function Xc(a,b){var c=a.alternate;null===c?(c=Vd(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Zc(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ee(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ea:return ad(c.children,e,f,b);case ka:g=8;e|=7;break;case fa:g=8;e|=1;break;case ha:return a=Vd(12,c,b,e|8),a.elementType=ha,a.type=ha,a.expirationTime=f,a;case ma:return a=Vd(13,c,b,e),a.type=ma,a.elementType=ma,a.expirationTime=f,a;case na:return a=Vd(19,c,b,e),a.elementType=na,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case ia:g=
10;break a;case ja:g=9;break a;case la:g=11;break a;case oa:g=14;break a;case pa:g=16;d=null;break a;case qa:g=22;break a}throw Error(n(130,null==a?a:typeof a,""));}b=Vd(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function ad(a,b,c,d){a=Vd(7,a,d,b);a.expirationTime=c;return a}function Yc(a,b,c){a=Vd(6,a,null,b);a.expirationTime=c;return a}
function $c(a,b,c){b=Vd(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function pg(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=Oa;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Kf(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function De(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Ee(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Mf(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}var qg=null;
function rg(a){if(null===qg)try{var b=("require"+Math.random()).slice(0,7);qg=(module&&module[b])("timers").setImmediate}catch(c){qg=function(a){var b=new MessageChannel;b.port1.onmessage=a;b.port2.postMessage(void 0)}}return qg(a)}function sg(a){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(n(188));throw Error(n(268,Object.keys(a)));}a=ya(b);return null===a?null:a.stateNode}
function tg(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ug(a,b){tg(a,b);(a=a.alternate)&&tg(a,b)}var vg=p.IsSomeRendererActing,wg="function"===typeof m.unstable_flushAllWithoutAsserting,xg=m.unstable_flushAllWithoutAsserting||function(){for(var a=!1;Nf();)a=!0;return a};function yg(a){try{xg(),rg(function(){xg()?yg(a):a()})}catch(b){a(b)}}
var zg=0,Ag=!1,Bg={__proto__:null,createContainer:function(a,b,c){a=new pg(a,b,c);b=Vd(3,null,null,2===b?7:1===b?3:0);a.current=b;b.stateNode=a;yc(b);return a},updateContainer:function(a,b,c,d){var e=b.current,f=Lc(),g=Ic.suspense;f=Mc(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(va(c)!==c||1!==c.tag)throw Error(n(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(F(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(n(171));
}if(1===c.tag){var k=c.type;if(F(k)){c=Hb(c,k,h);break a}}c=h}else c=Cb;null===b.context?b.context=c:b.pendingContext=c;b=Ac(f,g);b.payload={element:a};d=void 0===d?null:d;null!==d&&(b.callback=d);Bc(e,b);Nc(e,f);return f},batchedEventUpdates:function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&H()}},batchedUpdates:Xf,unbatchedUpdates:function(a,b){var c=W;W&=-2;W|=of;try{return a(b)}finally{W=c,W===V&&H()}},deferredUpdates:function(a){return dc(97,a)},syncUpdates:function(a,b,c,d){return dc(99,
a.bind(null,b,c,d))},discreteUpdates:function(a,b,c,d,e){var f=W;W|=4;try{return dc(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&H()}},flushDiscreteUpdates:function(){(W&(1|pf|qf))===V&&(Wf(),Nf())},flushControlled:function(a){var b=W;W|=1;try{dc(99,a)}finally{W=b,W===V&&H()}},flushSync:Yf,flushPassiveEffects:Nf,IsThisRendererActing:mg,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return Aa(a.child.stateNode);default:return a.child.stateNode}},attemptSynchronousHydration:function(a){switch(a.tag){case 3:var b=
a.stateNode;b.hydrate&&Vf(b,b.firstPendingTime);break;case 13:Yf(function(){return Nc(a,1073741823)}),b=hc(Lc(),150,100),ug(a,b)}},attemptUserBlockingHydration:function(a){if(13===a.tag){var b=hc(Lc(),150,100);Nc(a,b);ug(a,b)}},attemptContinuousHydration:function(a){13===a.tag&&(Nc(a,3),ug(a,3))},attemptHydrationAtCurrentPriority:function(a){if(13===a.tag){var b=Lc();b=Mc(b,a,null);Nc(a,b);ug(a,b)}},findHostInstance:sg,findHostInstanceWithWarning:function(a){return sg(a)},findHostInstanceWithNoPortals:function(a){a=
za(a);return null===a?null:20===a.tag?a.stateNode.instance:a.stateNode},shouldSuspend:function(){return!1},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return ng(aa({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:p.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ya(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,
scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))},act:function(a){function b(){zg--;vg.current=c;mg.current=d}!1===Ag&&(Ag=!0,console.error("act(...) is not supported in production builds of React, and might not behave as expected."));zg++;var c=vg.current;var d=mg.current;vg.current=!0;mg.current=!0;try{var e=Xf(a)}catch(f){throw b(),f;}if(null!==e&&"object"===typeof e&&"function"===typeof e.then)return{then:function(a,d){e.then(function(){1<zg||!0===wg&&!0===c?(b(),a()):yg(function(c){b();
c?d(c):a()})},function(a){b();d(a)})}};try{1!==zg||!1!==wg&&!1!==c||xg(),b()}catch(f){throw b(),f;}return{then:function(a){a()}}}},Cg=Bg&&Bg["default"]||Bg;module.exports=Cg.default||Cg;

    var $$$renderer = module.exports;
    module.exports = $$$reconciler;
    return $$$renderer;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2536);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getClosestInstanceFromNode = getClosestInstanceFromNode;
// from https://github.com/facebook/react/blob/87ae211ccd8d61796cfdef138d1e12fb7a74f85d/packages/shared/ReactTypeOfWork.js
var HostComponent = 5;
var HostText = 6;

// adapted FROM: https://github.com/facebook/react/blob/master/packages/react-dom/src/client/ReactDOMComponentTree.js

var randomKey = Math.random().toString(36).slice(2);
var internalInstanceKey = '__reactInternalInstance$' + randomKey;

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  while (!node[internalInstanceKey]) {
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var inst = node[internalInstanceKey];
  if (inst.tag === HostComponent || inst.tag === HostText) {
    // In Fiber, this will always be the deepest root.
    return inst;
  }

  return null;
}

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.supportsMutation = exports.isPrimaryRenderer = exports.cancelPassiveEffects = exports.schedulePassiveEffects = exports.noTimeout = exports.cancelTimeout = exports.scheduleTimeout = exports.cancelDeferredCallback = exports.shouldYield = exports.scheduleDeferredCallback = exports.now = undefined;

var _HostConfigWithNoPersistence = __webpack_require__(2539);

Object.keys(_HostConfigWithNoPersistence).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HostConfigWithNoPersistence[key];
    }
  });
});

var _HostConfigWithNoHydration = __webpack_require__(2540);

Object.keys(_HostConfigWithNoHydration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HostConfigWithNoHydration[key];
    }
  });
});

var _scheduler = __webpack_require__(2541);

Object.defineProperty(exports, 'now', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_now;
  }
});
Object.defineProperty(exports, 'scheduleDeferredCallback', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_scheduleCallback;
  }
});
Object.defineProperty(exports, 'shouldYield', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_shouldYield;
  }
});
Object.defineProperty(exports, 'cancelDeferredCallback', {
  enumerable: true,
  get: function get() {
    return _scheduler.unstable_cancelCallback;
  }
});
exports.appendInitialChild = appendInitialChild;
exports.createInstance = createInstance;
exports.createTextInstance = createTextInstance;
exports.finalizeInitialChildren = finalizeInitialChildren;
exports.getPublicInstance = getPublicInstance;
exports.prepareForCommit = prepareForCommit;
exports.prepareUpdate = prepareUpdate;
exports.resetAfterCommit = resetAfterCommit;
exports.resetTextContent = resetTextContent;
exports.shouldDeprioritizeSubtree = shouldDeprioritizeSubtree;
exports.getRootHostContext = getRootHostContext;
exports.getChildHostContext = getChildHostContext;
exports.shouldSetTextContent = shouldSetTextContent;
exports.appendChild = appendChild;
exports.appendChildToContainer = appendChildToContainer;
exports.insertBefore = insertBefore;
exports.insertInContainerBefore = insertInContainerBefore;
exports.removeChild = removeChild;
exports.removeChildFromContainer = removeChildFromContainer;
exports.commitTextUpdate = commitTextUpdate;
exports.commitMount = commitMount;
exports.commitUpdate = commitUpdate;
exports.hideInstance = hideInstance;
exports.hideTextInstance = hideTextInstance;
exports.unhideInstance = unhideInstance;
exports.unhideTextInstance = unhideTextInstance;

var _Core = __webpack_require__(1125);

var _Core2 = _interopRequireDefault(_Core);

var _makeUpdates = __webpack_require__(1130);

var _invariant = __webpack_require__(667);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NO_CONTEXT = {};
var UPDATE_SIGNAL = {};

// for react-spring capability
_Core2.default.Node.prototype._applyProps = _makeUpdates.applyNodeProps;

function appendInitialChild(parentInstance, child) {
  if (typeof child === 'string') {
    // Noop for string children of Text (eg <Text>foo</Text>)
    (0, _invariant2.default)(false, 'Don not use plain text as child of Konva.Node. You are using text: "%s"', child);
    return;
  }

  parentInstance.add(child);

  (0, _makeUpdates.updatePicture)(parentInstance);
}

function createInstance(type, props, internalInstanceHandle) {
  var NodeClass = _Core2.default[type];
  if (!NodeClass) {
    (0, _invariant2.default)(instance, 'Konva has no node with the type "%s". If you use minimal version of react-konva, just import required nodes into Konva: `import "konva/lib/shapes/%s"`  If you want to render DOM elements as part of canvas tree take a look into this demo: https://konvajs.github.io/docs/react/DOM_Portal.html', type, type);
    return;
  }

  // we need to split props into events and non events
  // we we can pass non events into constructor directly
  // that way the performance should be better
  // we we apply change "applyNodeProps"
  // then it will trigger change events on first run
  // but we don't need them!
  var propsWithoutEvents = {};
  var propsWithOnlyEvents = {};

  for (var key in props) {
    var isEvent = key.slice(0, 2) === 'on';
    if (isEvent) {
      propsWithOnlyEvents[key] = props[key];
    } else {
      propsWithoutEvents[key] = props[key];
    }
  }

  var instance = new NodeClass(propsWithoutEvents);

  (0, _makeUpdates.applyNodeProps)(instance, propsWithOnlyEvents);

  return instance;
}

function createTextInstance(text, rootContainerInstance, internalInstanceHandle) {
  (0, _invariant2.default)(false, 'Text components are not supported for now in ReactKonva. You text is: "' + text + '"');
}

function finalizeInitialChildren(domElement, type, props) {
  return false;
}

function getPublicInstance(instance) {
  return instance;
}

function prepareForCommit() {
  // Noop
}

function prepareUpdate(domElement, type, oldProps, newProps) {
  return UPDATE_SIGNAL;
}

function resetAfterCommit() {
  // Noop
}

function resetTextContent(domElement) {
  // Noop
}

function shouldDeprioritizeSubtree(type, props) {
  return false;
}

function getRootHostContext() {
  return NO_CONTEXT;
}

function getChildHostContext() {
  return NO_CONTEXT;
}

var scheduleTimeout = exports.scheduleTimeout = setTimeout;
var cancelTimeout = exports.cancelTimeout = clearTimeout;
var noTimeout = exports.noTimeout = -1;
var schedulePassiveEffects = exports.schedulePassiveEffects = _scheduler.unstable_scheduleCallback;
var cancelPassiveEffects = exports.cancelPassiveEffects = _scheduler.unstable_cancelCallback;

function shouldSetTextContent(type, props) {
  return false;
}

// The Konva renderer is secondary to the React DOM renderer.
var isPrimaryRenderer = exports.isPrimaryRenderer = false;

var supportsMutation = exports.supportsMutation = true;

function appendChild(parentInstance, child) {
  if (child.parent === parentInstance) {
    child.moveToTop();
  } else {
    parentInstance.add(child);
  }

  (0, _makeUpdates.updatePicture)(parentInstance);
}

function appendChildToContainer(parentInstance, child) {
  if (child.parent === parentInstance) {
    child.moveToTop();
  } else {
    parentInstance.add(child);
  }
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function insertBefore(parentInstance, child, beforeChild) {
  (0, _invariant2.default)(child !== beforeChild, 'ReactKonva: Can not insert node before itself');
  // child._remove() will not stop dragging
  // but child.remove() will stop it, but we don't need it
  // removing will reset zIndexes
  child._remove();
  parentInstance.add(child);
  child.setZIndex(beforeChild.getZIndex());
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function insertInContainerBefore(parentInstance, child, beforeChild) {
  insertBefore(parentInstance, child, beforeChild);
}

function removeChild(parentInstance, child) {
  child.destroy();
  child.off(_makeUpdates.EVENTS_NAMESPACE);
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function removeChildFromContainer(parentInstance, child) {
  child.destroy();
  child.off(_makeUpdates.EVENTS_NAMESPACE);
  (0, _makeUpdates.updatePicture)(parentInstance);
}

function commitTextUpdate(textInstance, oldText, newText) {
  (0, _invariant2.default)(false, 'Text components are not yet supported in ReactKonva. You text is: "' + newText + '"');
}

function commitMount(instance, type, newProps) {
  // Noop
}

function commitUpdate(instance, updatePayload, type, oldProps, newProps) {
  (0, _makeUpdates.applyNodeProps)(instance, newProps, oldProps);
}

function hideInstance(instance) {
  instance.hide();
  (0, _makeUpdates.updatePicture)(instance);
}

function hideTextInstance(textInstance) {
  // Noop
}

function unhideInstance(instance, props) {
  if (props.visible == null || props.visible) {
    instance.show();
  }
}

function unhideTextInstance(textInstance, text) {
  // Noop
}

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createHiddenTextInstance = exports.cloneUnhiddenInstance = exports.cloneHiddenInstance = exports.replaceContainerChildren = exports.finalizeContainerChildren = exports.appendChildToContainerChildSet = exports.createContainerChildSet = exports.cloneInstance = exports.supportsPersistence = undefined;

var _invariant = __webpack_require__(667);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Renderers that don't support persistence
// can re-export everything from this module.

function shim() {
  (0, _invariant2.default)(false, 'The current renderer does not support persistence. ' + 'This error is likely caused by a bug in React. ' + 'Please file an issue.');
}

// Persistence (when unsupported)
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var supportsPersistence = exports.supportsPersistence = false;
var cloneInstance = exports.cloneInstance = shim;
var createContainerChildSet = exports.createContainerChildSet = shim;
var appendChildToContainerChildSet = exports.appendChildToContainerChildSet = shim;
var finalizeContainerChildren = exports.finalizeContainerChildren = shim;
var replaceContainerChildren = exports.replaceContainerChildren = shim;
var cloneHiddenInstance = exports.cloneHiddenInstance = shim;
var cloneUnhiddenInstance = exports.cloneUnhiddenInstance = shim;
var createHiddenTextInstance = exports.createHiddenTextInstance = shim;

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.didNotFindHydratableTextInstance = exports.didNotFindHydratableInstance = exports.didNotFindHydratableContainerTextInstance = exports.didNotFindHydratableContainerInstance = exports.didNotHydrateInstance = exports.didNotHydrateContainerInstance = exports.didNotMatchHydratedTextInstance = exports.didNotMatchHydratedContainerTextInstance = exports.hydrateTextInstance = exports.hydrateInstance = exports.getFirstHydratableChild = exports.getNextHydratableSibling = exports.canHydrateTextInstance = exports.canHydrateInstance = exports.supportsHydration = undefined;

var _invariant = __webpack_require__(667);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Renderers that don't support hydration
// can re-export everything from this module.

function shim() {
  (0, _invariant2.default)(false, 'The current renderer does not support hyration. ' + 'This error is likely caused by a bug in React. ' + 'Please file an issue.');
}

// Hydration (when unsupported)
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var supportsHydration = exports.supportsHydration = false;
var canHydrateInstance = exports.canHydrateInstance = shim;
var canHydrateTextInstance = exports.canHydrateTextInstance = shim;
var getNextHydratableSibling = exports.getNextHydratableSibling = shim;
var getFirstHydratableChild = exports.getFirstHydratableChild = shim;
var hydrateInstance = exports.hydrateInstance = shim;
var hydrateTextInstance = exports.hydrateTextInstance = shim;
var didNotMatchHydratedContainerTextInstance = exports.didNotMatchHydratedContainerTextInstance = shim;
var didNotMatchHydratedTextInstance = exports.didNotMatchHydratedTextInstance = shim;
var didNotHydrateContainerInstance = exports.didNotHydrateContainerInstance = shim;
var didNotHydrateInstance = exports.didNotHydrateInstance = shim;
var didNotFindHydratableContainerInstance = exports.didNotFindHydratableContainerInstance = shim;
var didNotFindHydratableContainerTextInstance = exports.didNotFindHydratableContainerTextInstance = shim;
var didNotFindHydratableInstance = exports.didNotFindHydratableInstance = shim;
var didNotFindHydratableTextInstance = exports.didNotFindHydratableTextInstance = shim;

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2542);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

var Konva = __webpack_require__(2544).Konva;
Konva._injectGlobal(Konva);
exports['default'] = Konva;
module.exports = exports['default'];


/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _CoreInternals_1 = __webpack_require__(1126);
var Arc_1 = __webpack_require__(2545);
var Arrow_1 = __webpack_require__(2546);
var Circle_1 = __webpack_require__(2547);
var Ellipse_1 = __webpack_require__(2548);
var Image_1 = __webpack_require__(2549);
var Label_1 = __webpack_require__(2550);
var Line_1 = __webpack_require__(1131);
var Path_1 = __webpack_require__(1132);
var Rect_1 = __webpack_require__(1133);
var RegularPolygon_1 = __webpack_require__(2551);
var Ring_1 = __webpack_require__(2552);
var Sprite_1 = __webpack_require__(2553);
var Star_1 = __webpack_require__(2554);
var Text_1 = __webpack_require__(1134);
var TextPath_1 = __webpack_require__(2555);
var Transformer_1 = __webpack_require__(2556);
var Wedge_1 = __webpack_require__(2557);
var Blur_1 = __webpack_require__(2558);
var Brighten_1 = __webpack_require__(2559);
var Contrast_1 = __webpack_require__(2560);
var Emboss_1 = __webpack_require__(2561);
var Enhance_1 = __webpack_require__(2562);
var Grayscale_1 = __webpack_require__(2563);
var HSL_1 = __webpack_require__(2564);
var HSV_1 = __webpack_require__(2565);
var Invert_1 = __webpack_require__(2566);
var Kaleidoscope_1 = __webpack_require__(2567);
var Mask_1 = __webpack_require__(2568);
var Noise_1 = __webpack_require__(2569);
var Pixelate_1 = __webpack_require__(2570);
var Posterize_1 = __webpack_require__(2571);
var RGB_1 = __webpack_require__(2572);
var RGBA_1 = __webpack_require__(2573);
var Sepia_1 = __webpack_require__(2574);
var Solarize_1 = __webpack_require__(2575);
var Threshold_1 = __webpack_require__(2576);
exports.Konva = _CoreInternals_1.Konva.Util._assign(_CoreInternals_1.Konva, {
    Arc: Arc_1.Arc,
    Arrow: Arrow_1.Arrow,
    Circle: Circle_1.Circle,
    Ellipse: Ellipse_1.Ellipse,
    Image: Image_1.Image,
    Label: Label_1.Label,
    Tag: Label_1.Tag,
    Line: Line_1.Line,
    Path: Path_1.Path,
    Rect: Rect_1.Rect,
    RegularPolygon: RegularPolygon_1.RegularPolygon,
    Ring: Ring_1.Ring,
    Sprite: Sprite_1.Sprite,
    Star: Star_1.Star,
    Text: Text_1.Text,
    TextPath: TextPath_1.TextPath,
    Transformer: Transformer_1.Transformer,
    Wedge: Wedge_1.Wedge,
    Filters: {
        Blur: Blur_1.Blur,
        Brighten: Brighten_1.Brighten,
        Contrast: Contrast_1.Contrast,
        Emboss: Emboss_1.Emboss,
        Enhance: Enhance_1.Enhance,
        Grayscale: Grayscale_1.Grayscale,
        HSL: HSL_1.HSL,
        HSV: HSV_1.HSV,
        Invert: Invert_1.Invert,
        Kaleidoscope: Kaleidoscope_1.Kaleidoscope,
        Mask: Mask_1.Mask,
        Noise: Noise_1.Noise,
        Pixelate: Pixelate_1.Pixelate,
        Posterize: Posterize_1.Posterize,
        RGB: RGB_1.RGB,
        RGBA: RGBA_1.RGBA,
        Sepia: Sepia_1.Sepia,
        Solarize: Solarize_1.Solarize,
        Threshold: Threshold_1.Threshold
    }
});


/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Global_1 = __webpack_require__(38);
var Validators_1 = __webpack_require__(41);
var Global_2 = __webpack_require__(38);
var Arc = (function (_super) {
    __extends(Arc, _super);
    function Arc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Arc.prototype._sceneFunc = function (context) {
        var angle = Global_1.Konva.getAngle(this.angle()), clockwise = this.clockwise();
        context.beginPath();
        context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
        context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
        context.closePath();
        context.fillStrokeShape(this);
    };
    Arc.prototype.getWidth = function () {
        return this.outerRadius() * 2;
    };
    Arc.prototype.getHeight = function () {
        return this.outerRadius() * 2;
    };
    Arc.prototype.setWidth = function (width) {
        this.outerRadius(width / 2);
    };
    Arc.prototype.setHeight = function (height) {
        this.outerRadius(height / 2);
    };
    return Arc;
}(Shape_1.Shape));
exports.Arc = Arc;
Arc.prototype._centroid = true;
Arc.prototype.className = 'Arc';
Arc.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
Global_2._registerNode(Arc);
Factory_1.Factory.addGetterSetter(Arc, 'innerRadius', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Arc, 'outerRadius', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Arc, 'angle', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Arc, 'clockwise', false, Validators_1.getBooleanValidator());
Util_1.Collection.mapMethods(Arc);


/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Line_1 = __webpack_require__(1131);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var Arrow = (function (_super) {
    __extends(Arrow, _super);
    function Arrow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Arrow.prototype._sceneFunc = function (ctx) {
        _super.prototype._sceneFunc.call(this, ctx);
        var PI2 = Math.PI * 2;
        var points = this.points();
        var tp = points;
        var fromTension = this.tension() !== 0 && points.length > 4;
        if (fromTension) {
            tp = this.getTensionPoints();
        }
        var n = points.length;
        var dx, dy;
        if (fromTension) {
            dx = points[n - 2] - (tp[tp.length - 2] + tp[tp.length - 4]) / 2;
            dy = points[n - 1] - (tp[tp.length - 1] + tp[tp.length - 3]) / 2;
        }
        else {
            dx = points[n - 2] - points[n - 4];
            dy = points[n - 1] - points[n - 3];
        }
        var radians = (Math.atan2(dy, dx) + PI2) % PI2;
        var length = this.pointerLength();
        var width = this.pointerWidth();
        ctx.save();
        ctx.beginPath();
        ctx.translate(points[n - 2], points[n - 1]);
        ctx.rotate(radians);
        ctx.moveTo(0, 0);
        ctx.lineTo(-length, width / 2);
        ctx.lineTo(-length, -width / 2);
        ctx.closePath();
        ctx.restore();
        if (this.pointerAtBeginning()) {
            ctx.save();
            ctx.translate(points[0], points[1]);
            if (fromTension) {
                dx = (tp[0] + tp[2]) / 2 - points[0];
                dy = (tp[1] + tp[3]) / 2 - points[1];
            }
            else {
                dx = points[2] - points[0];
                dy = points[3] - points[1];
            }
            ctx.rotate((Math.atan2(-dy, -dx) + PI2) % PI2);
            ctx.moveTo(0, 0);
            ctx.lineTo(-length, width / 2);
            ctx.lineTo(-length, -width / 2);
            ctx.closePath();
            ctx.restore();
        }
        var isDashEnabled = this.dashEnabled();
        if (isDashEnabled) {
            this.attrs.dashEnabled = false;
            ctx.setLineDash([]);
        }
        ctx.fillStrokeShape(this);
        if (isDashEnabled) {
            this.attrs.dashEnabled = true;
        }
    };
    Arrow.prototype.getSelfRect = function () {
        var lineRect = _super.prototype.getSelfRect.call(this);
        var offset = this.pointerWidth() / 2;
        return {
            x: lineRect.x - offset,
            y: lineRect.y - offset,
            width: lineRect.width + offset * 2,
            height: lineRect.height + offset * 2
        };
    };
    return Arrow;
}(Line_1.Line));
exports.Arrow = Arrow;
Arrow.prototype.className = 'Arrow';
Global_1._registerNode(Arrow);
Factory_1.Factory.addGetterSetter(Arrow, 'pointerLength', 10, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Arrow, 'pointerWidth', 10, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Arrow, 'pointerAtBeginning', false);
Util_1.Collection.mapMethods(Arrow);


/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var Circle = (function (_super) {
    __extends(Circle, _super);
    function Circle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Circle.prototype._sceneFunc = function (context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, Math.PI * 2, false);
        context.closePath();
        context.fillStrokeShape(this);
    };
    Circle.prototype.getWidth = function () {
        return this.radius() * 2;
    };
    Circle.prototype.getHeight = function () {
        return this.radius() * 2;
    };
    Circle.prototype.setWidth = function (width) {
        if (this.radius() !== width / 2) {
            this.radius(width / 2);
        }
    };
    Circle.prototype.setHeight = function (height) {
        if (this.radius() !== height / 2) {
            this.radius(height / 2);
        }
    };
    return Circle;
}(Shape_1.Shape));
exports.Circle = Circle;
Circle.prototype._centroid = true;
Circle.prototype.className = 'Circle';
Circle.prototype._attrsAffectingSize = ['radius'];
Global_1._registerNode(Circle);
Factory_1.Factory.addGetterSetter(Circle, 'radius', 0, Validators_1.getNumberValidator());
Util_1.Collection.mapMethods(Circle);


/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var Ellipse = (function (_super) {
    __extends(Ellipse, _super);
    function Ellipse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ellipse.prototype._sceneFunc = function (context) {
        var rx = this.radiusX(), ry = this.radiusY();
        context.beginPath();
        context.save();
        if (rx !== ry) {
            context.scale(1, ry / rx);
        }
        context.arc(0, 0, rx, 0, Math.PI * 2, false);
        context.restore();
        context.closePath();
        context.fillStrokeShape(this);
    };
    Ellipse.prototype.getWidth = function () {
        return this.radiusX() * 2;
    };
    Ellipse.prototype.getHeight = function () {
        return this.radiusY() * 2;
    };
    Ellipse.prototype.setWidth = function (width) {
        this.radiusX(width / 2);
    };
    Ellipse.prototype.setHeight = function (height) {
        this.radiusY(height / 2);
    };
    return Ellipse;
}(Shape_1.Shape));
exports.Ellipse = Ellipse;
Ellipse.prototype.className = 'Ellipse';
Ellipse.prototype._centroid = true;
Ellipse.prototype._attrsAffectingSize = ['radiusX', 'radiusY'];
Global_1._registerNode(Ellipse);
Factory_1.Factory.addComponentsGetterSetter(Ellipse, 'radius', ['x', 'y']);
Factory_1.Factory.addGetterSetter(Ellipse, 'radiusX', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Ellipse, 'radiusY', 0, Validators_1.getNumberValidator());
Util_1.Collection.mapMethods(Ellipse);


/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var Image = (function (_super) {
    __extends(Image, _super);
    function Image() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Image.prototype._useBufferCanvas = function () {
        return _super.prototype._useBufferCanvas.call(this, true);
    };
    Image.prototype._sceneFunc = function (context) {
        var width = this.getWidth(), height = this.getHeight(), image = this.attrs.image, cropWidth, cropHeight, params;
        if (image) {
            cropWidth = this.attrs.cropWidth;
            cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) {
                params = [
                    image,
                    this.cropX(),
                    this.cropY(),
                    cropWidth,
                    cropHeight,
                    0,
                    0,
                    width,
                    height,
                ];
            }
            else {
                params = [image, 0, 0, width, height];
            }
        }
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            context.drawImage.apply(context, params);
        }
    };
    Image.prototype._hitFunc = function (context) {
        var width = this.width(), height = this.height();
        context.beginPath();
        context.rect(0, 0, width, height);
        context.closePath();
        context.fillStrokeShape(this);
    };
    Image.prototype.getWidth = function () {
        var _a, _b;
        return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (((_b = this.image()) === null || _b === void 0 ? void 0 : _b.width) || 0);
    };
    Image.prototype.getHeight = function () {
        var _a, _b;
        return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (((_b = this.image()) === null || _b === void 0 ? void 0 : _b.height) || 0);
    };
    Image.fromURL = function (url, callback) {
        var img = Util_1.Util.createImageElement();
        img.onload = function () {
            var image = new Image({
                image: img,
            });
            callback(image);
        };
        img.crossOrigin = 'Anonymous';
        img.src = url;
    };
    return Image;
}(Shape_1.Shape));
exports.Image = Image;
Image.prototype.className = 'Image';
Global_1._registerNode(Image);
Factory_1.Factory.addGetterSetter(Image, 'image');
Factory_1.Factory.addComponentsGetterSetter(Image, 'crop', ['x', 'y', 'width', 'height']);
Factory_1.Factory.addGetterSetter(Image, 'cropX', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Image, 'cropY', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Image, 'cropWidth', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Image, 'cropHeight', 0, Validators_1.getNumberValidator());
Util_1.Collection.mapMethods(Image);


/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Group_1 = __webpack_require__(665);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var ATTR_CHANGE_LIST = [
    'fontFamily',
    'fontSize',
    'fontStyle',
    'padding',
    'lineHeight',
    'text',
    'width'
], CHANGE_KONVA = 'Change.konva', NONE = 'none', UP = 'up', RIGHT = 'right', DOWN = 'down', LEFT = 'left', attrChangeListLen = ATTR_CHANGE_LIST.length;
var Label = (function (_super) {
    __extends(Label, _super);
    function Label(config) {
        var _this = _super.call(this, config) || this;
        _this.on('add.konva', function (evt) {
            this._addListeners(evt.child);
            this._sync();
        });
        return _this;
    }
    Label.prototype.getText = function () {
        return this.find('Text')[0];
    };
    Label.prototype.getTag = function () {
        return this.find('Tag')[0];
    };
    Label.prototype._addListeners = function (text) {
        var that = this, n;
        var func = function () {
            that._sync();
        };
        for (n = 0; n < attrChangeListLen; n++) {
            text.on(ATTR_CHANGE_LIST[n] + CHANGE_KONVA, func);
        }
    };
    Label.prototype.getWidth = function () {
        return this.getText().width();
    };
    Label.prototype.getHeight = function () {
        return this.getText().height();
    };
    Label.prototype._sync = function () {
        var text = this.getText(), tag = this.getTag(), width, height, pointerDirection, pointerWidth, x, y, pointerHeight;
        if (text && tag) {
            width = text.width();
            height = text.height();
            pointerDirection = tag.pointerDirection();
            pointerWidth = tag.pointerWidth();
            pointerHeight = tag.pointerHeight();
            x = 0;
            y = 0;
            switch (pointerDirection) {
                case UP:
                    x = width / 2;
                    y = -1 * pointerHeight;
                    break;
                case RIGHT:
                    x = width + pointerWidth;
                    y = height / 2;
                    break;
                case DOWN:
                    x = width / 2;
                    y = height + pointerHeight;
                    break;
                case LEFT:
                    x = -1 * pointerWidth;
                    y = height / 2;
                    break;
            }
            tag.setAttrs({
                x: -1 * x,
                y: -1 * y,
                width: width,
                height: height
            });
            text.setAttrs({
                x: -1 * x,
                y: -1 * y
            });
        }
    };
    return Label;
}(Group_1.Group));
exports.Label = Label;
Label.prototype.className = 'Label';
Global_1._registerNode(Label);
Util_1.Collection.mapMethods(Label);
var Tag = (function (_super) {
    __extends(Tag, _super);
    function Tag() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tag.prototype._sceneFunc = function (context) {
        var width = this.width(), height = this.height(), pointerDirection = this.pointerDirection(), pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), cornerRadius = Math.min(this.cornerRadius(), width / 2, height / 2);
        context.beginPath();
        if (!cornerRadius) {
            context.moveTo(0, 0);
        }
        else {
            context.moveTo(cornerRadius, 0);
        }
        if (pointerDirection === UP) {
            context.lineTo((width - pointerWidth) / 2, 0);
            context.lineTo(width / 2, -1 * pointerHeight);
            context.lineTo((width + pointerWidth) / 2, 0);
        }
        if (!cornerRadius) {
            context.lineTo(width, 0);
        }
        else {
            context.lineTo(width - cornerRadius, 0);
            context.arc(width - cornerRadius, cornerRadius, cornerRadius, (Math.PI * 3) / 2, 0, false);
        }
        if (pointerDirection === RIGHT) {
            context.lineTo(width, (height - pointerHeight) / 2);
            context.lineTo(width + pointerWidth, height / 2);
            context.lineTo(width, (height + pointerHeight) / 2);
        }
        if (!cornerRadius) {
            context.lineTo(width, height);
        }
        else {
            context.lineTo(width, height - cornerRadius);
            context.arc(width - cornerRadius, height - cornerRadius, cornerRadius, 0, Math.PI / 2, false);
        }
        if (pointerDirection === DOWN) {
            context.lineTo((width + pointerWidth) / 2, height);
            context.lineTo(width / 2, height + pointerHeight);
            context.lineTo((width - pointerWidth) / 2, height);
        }
        if (!cornerRadius) {
            context.lineTo(0, height);
        }
        else {
            context.lineTo(cornerRadius, height);
            context.arc(cornerRadius, height - cornerRadius, cornerRadius, Math.PI / 2, Math.PI, false);
        }
        if (pointerDirection === LEFT) {
            context.lineTo(0, (height + pointerHeight) / 2);
            context.lineTo(-1 * pointerWidth, height / 2);
            context.lineTo(0, (height - pointerHeight) / 2);
        }
        if (cornerRadius) {
            context.lineTo(0, cornerRadius);
            context.arc(cornerRadius, cornerRadius, cornerRadius, Math.PI, (Math.PI * 3) / 2, false);
        }
        context.closePath();
        context.fillStrokeShape(this);
    };
    Tag.prototype.getSelfRect = function () {
        var x = 0, y = 0, pointerWidth = this.pointerWidth(), pointerHeight = this.pointerHeight(), direction = this.pointerDirection(), width = this.width(), height = this.height();
        if (direction === UP) {
            y -= pointerHeight;
            height += pointerHeight;
        }
        else if (direction === DOWN) {
            height += pointerHeight;
        }
        else if (direction === LEFT) {
            x -= pointerWidth * 1.5;
            width += pointerWidth;
        }
        else if (direction === RIGHT) {
            width += pointerWidth * 1.5;
        }
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    return Tag;
}(Shape_1.Shape));
exports.Tag = Tag;
Tag.prototype.className = 'Tag';
Global_1._registerNode(Tag);
Factory_1.Factory.addGetterSetter(Tag, 'pointerDirection', NONE);
Factory_1.Factory.addGetterSetter(Tag, 'pointerWidth', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Tag, 'pointerHeight', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Tag, 'cornerRadius', 0, Validators_1.getNumberValidator());
Util_1.Collection.mapMethods(Tag);


/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var RegularPolygon = (function (_super) {
    __extends(RegularPolygon, _super);
    function RegularPolygon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RegularPolygon.prototype._sceneFunc = function (context) {
        var sides = this.sides(), radius = this.radius(), n, x, y;
        context.beginPath();
        context.moveTo(0, 0 - radius);
        for (n = 1; n < sides; n++) {
            x = radius * Math.sin((n * 2 * Math.PI) / sides);
            y = -1 * radius * Math.cos((n * 2 * Math.PI) / sides);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    };
    RegularPolygon.prototype.getWidth = function () {
        return this.radius() * 2;
    };
    RegularPolygon.prototype.getHeight = function () {
        return this.radius() * 2;
    };
    RegularPolygon.prototype.setWidth = function (width) {
        this.radius(width / 2);
    };
    RegularPolygon.prototype.setHeight = function (height) {
        this.radius(height / 2);
    };
    return RegularPolygon;
}(Shape_1.Shape));
exports.RegularPolygon = RegularPolygon;
RegularPolygon.prototype.className = 'RegularPolygon';
RegularPolygon.prototype._centroid = true;
RegularPolygon.prototype._attrsAffectingSize = ['radius'];
Global_1._registerNode(RegularPolygon);
Factory_1.Factory.addGetterSetter(RegularPolygon, 'radius', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(RegularPolygon, 'sides', 0, Validators_1.getNumberValidator());
Util_1.Collection.mapMethods(RegularPolygon);


/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var PIx2 = Math.PI * 2;
var Ring = (function (_super) {
    __extends(Ring, _super);
    function Ring() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ring.prototype._sceneFunc = function (context) {
        context.beginPath();
        context.arc(0, 0, this.innerRadius(), 0, PIx2, false);
        context.moveTo(this.outerRadius(), 0);
        context.arc(0, 0, this.outerRadius(), PIx2, 0, true);
        context.closePath();
        context.fillStrokeShape(this);
    };
    Ring.prototype.getWidth = function () {
        return this.outerRadius() * 2;
    };
    Ring.prototype.getHeight = function () {
        return this.outerRadius() * 2;
    };
    Ring.prototype.setWidth = function (width) {
        this.outerRadius(width / 2);
    };
    Ring.prototype.setHeight = function (height) {
        this.outerRadius(height / 2);
    };
    return Ring;
}(Shape_1.Shape));
exports.Ring = Ring;
Ring.prototype.className = 'Ring';
Ring.prototype._centroid = true;
Ring.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
Global_1._registerNode(Ring);
Factory_1.Factory.addGetterSetter(Ring, 'innerRadius', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Ring, 'outerRadius', 0, Validators_1.getNumberValidator());
Util_1.Collection.mapMethods(Ring);


/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Animation_1 = __webpack_require__(666);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var Sprite = (function (_super) {
    __extends(Sprite, _super);
    function Sprite(config) {
        var _this = _super.call(this, config) || this;
        _this._updated = true;
        _this.anim = new Animation_1.Animation(function () {
            var updated = _this._updated;
            _this._updated = false;
            return updated;
        });
        _this.on('animationChange.konva', function () {
            this.frameIndex(0);
        });
        _this.on('frameIndexChange.konva', function () {
            this._updated = true;
        });
        _this.on('frameRateChange.konva', function () {
            if (!this.anim.isRunning()) {
                return;
            }
            clearInterval(this.interval);
            this._setInterval();
        });
        return _this;
    }
    Sprite.prototype._sceneFunc = function (context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), x = set[ix4 + 0], y = set[ix4 + 1], width = set[ix4 + 2], height = set[ix4 + 3], image = this.image();
        if (this.hasFill() || this.hasStroke()) {
            context.beginPath();
            context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
        }
        if (image) {
            if (offsets) {
                var offset = offsets[anim], ix2 = index * 2;
                context.drawImage(image, x, y, width, height, offset[ix2 + 0], offset[ix2 + 1], width, height);
            }
            else {
                context.drawImage(image, x, y, width, height, 0, 0, width, height);
            }
        }
    };
    Sprite.prototype._hitFunc = function (context) {
        var anim = this.animation(), index = this.frameIndex(), ix4 = index * 4, set = this.animations()[anim], offsets = this.frameOffsets(), width = set[ix4 + 2], height = set[ix4 + 3];
        context.beginPath();
        if (offsets) {
            var offset = offsets[anim];
            var ix2 = index * 2;
            context.rect(offset[ix2 + 0], offset[ix2 + 1], width, height);
        }
        else {
            context.rect(0, 0, width, height);
        }
        context.closePath();
        context.fillShape(this);
    };
    Sprite.prototype._useBufferCanvas = function () {
        return _super.prototype._useBufferCanvas.call(this, true);
    };
    Sprite.prototype._setInterval = function () {
        var that = this;
        this.interval = setInterval(function () {
            that._updateIndex();
        }, 1000 / this.frameRate());
    };
    Sprite.prototype.start = function () {
        if (this.isRunning()) {
            return;
        }
        var layer = this.getLayer();
        this.anim.setLayers(layer);
        this._setInterval();
        this.anim.start();
    };
    Sprite.prototype.stop = function () {
        this.anim.stop();
        clearInterval(this.interval);
    };
    Sprite.prototype.isRunning = function () {
        return this.anim.isRunning();
    };
    Sprite.prototype._updateIndex = function () {
        var index = this.frameIndex(), animation = this.animation(), animations = this.animations(), anim = animations[animation], len = anim.length / 4;
        if (index < len - 1) {
            this.frameIndex(index + 1);
        }
        else {
            this.frameIndex(0);
        }
    };
    return Sprite;
}(Shape_1.Shape));
exports.Sprite = Sprite;
Sprite.prototype.className = 'Sprite';
Global_1._registerNode(Sprite);
Factory_1.Factory.addGetterSetter(Sprite, 'animation');
Factory_1.Factory.addGetterSetter(Sprite, 'animations');
Factory_1.Factory.addGetterSetter(Sprite, 'frameOffsets');
Factory_1.Factory.addGetterSetter(Sprite, 'image');
Factory_1.Factory.addGetterSetter(Sprite, 'frameIndex', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Sprite, 'frameRate', 17, Validators_1.getNumberValidator());
Factory_1.Factory.backCompat(Sprite, {
    index: 'frameIndex',
    getIndex: 'getFrameIndex',
    setIndex: 'setFrameIndex',
});
Util_1.Collection.mapMethods(Sprite);


/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var Star = (function (_super) {
    __extends(Star, _super);
    function Star() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Star.prototype._sceneFunc = function (context) {
        var innerRadius = this.innerRadius(), outerRadius = this.outerRadius(), numPoints = this.numPoints();
        context.beginPath();
        context.moveTo(0, 0 - outerRadius);
        for (var n = 1; n < numPoints * 2; n++) {
            var radius = n % 2 === 0 ? outerRadius : innerRadius;
            var x = radius * Math.sin((n * Math.PI) / numPoints);
            var y = -1 * radius * Math.cos((n * Math.PI) / numPoints);
            context.lineTo(x, y);
        }
        context.closePath();
        context.fillStrokeShape(this);
    };
    Star.prototype.getWidth = function () {
        return this.outerRadius() * 2;
    };
    Star.prototype.getHeight = function () {
        return this.outerRadius() * 2;
    };
    Star.prototype.setWidth = function (width) {
        this.outerRadius(width / 2);
    };
    Star.prototype.setHeight = function (height) {
        this.outerRadius(height / 2);
    };
    return Star;
}(Shape_1.Shape));
exports.Star = Star;
Star.prototype.className = 'Star';
Star.prototype._centroid = true;
Star.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
Global_1._registerNode(Star);
Factory_1.Factory.addGetterSetter(Star, 'numPoints', 5, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Star, 'innerRadius', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Star, 'outerRadius', 0, Validators_1.getNumberValidator());
Util_1.Collection.mapMethods(Star);


/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Path_1 = __webpack_require__(1132);
var Text_1 = __webpack_require__(1134);
var Validators_1 = __webpack_require__(41);
var Global_1 = __webpack_require__(38);
var EMPTY_STRING = '', NORMAL = 'normal';
function _fillFunc(context) {
    context.fillText(this.partialText, 0, 0);
}
function _strokeFunc(context) {
    context.strokeText(this.partialText, 0, 0);
}
var TextPath = (function (_super) {
    __extends(TextPath, _super);
    function TextPath(config) {
        var _this = _super.call(this, config) || this;
        _this.dummyCanvas = Util_1.Util.createCanvasElement();
        _this.dataArray = [];
        _this.dataArray = Path_1.Path.parsePathData(_this.attrs.data);
        _this.on('dataChange.konva', function () {
            this.dataArray = Path_1.Path.parsePathData(this.attrs.data);
            this._setTextData();
        });
        _this.on('textChange.konva alignChange.konva letterSpacingChange.konva kerningFuncChange.konva', _this._setTextData);
        if (config && config['getKerning']) {
            Util_1.Util.warn('getKerning TextPath API is deprecated. Please use "kerningFunc" instead.');
            _this.kerningFunc(config['getKerning']);
        }
        _this._setTextData();
        return _this;
    }
    TextPath.prototype._sceneFunc = function (context) {
        context.setAttr('font', this._getContextFont());
        context.setAttr('textBaseline', this.textBaseline());
        context.setAttr('textAlign', 'left');
        context.save();
        var textDecoration = this.textDecoration();
        var fill = this.fill();
        var fontSize = this.fontSize();
        var glyphInfo = this.glyphInfo;
        if (textDecoration === 'underline') {
            context.beginPath();
        }
        for (var i = 0; i < glyphInfo.length; i++) {
            context.save();
            var p0 = glyphInfo[i].p0;
            context.translate(p0.x, p0.y);
            context.rotate(glyphInfo[i].rotation);
            this.partialText = glyphInfo[i].text;
            context.fillStrokeShape(this);
            if (textDecoration === 'underline') {
                if (i === 0) {
                    context.moveTo(0, fontSize / 2 + 1);
                }
                context.lineTo(fontSize, fontSize / 2 + 1);
            }
            context.restore();
        }
        if (textDecoration === 'underline') {
            context.strokeStyle = fill;
            context.lineWidth = fontSize / 20;
            context.stroke();
        }
        context.restore();
    };
    TextPath.prototype._hitFunc = function (context) {
        context.beginPath();
        var glyphInfo = this.glyphInfo;
        if (glyphInfo.length >= 1) {
            var p0 = glyphInfo[0].p0;
            context.moveTo(p0.x, p0.y);
        }
        for (var i = 0; i < glyphInfo.length; i++) {
            var p1 = glyphInfo[i].p1;
            context.lineTo(p1.x, p1.y);
        }
        context.setAttr('lineWidth', this.fontSize());
        context.setAttr('strokeStyle', this.colorKey);
        context.stroke();
    };
    TextPath.prototype.getTextWidth = function () {
        return this.textWidth;
    };
    TextPath.prototype.getTextHeight = function () {
        Util_1.Util.warn('text.getTextHeight() method is deprecated. Use text.height() - for full height and text.fontSize() - for one line height.');
        return this.textHeight;
    };
    TextPath.prototype.setText = function (text) {
        return Text_1.Text.prototype.setText.call(this, text);
    };
    TextPath.prototype._getContextFont = function () {
        return Text_1.Text.prototype._getContextFont.call(this);
    };
    TextPath.prototype._getTextSize = function (text) {
        var dummyCanvas = this.dummyCanvas;
        var _context = dummyCanvas.getContext('2d');
        _context.save();
        _context.font = this._getContextFont();
        var metrics = _context.measureText(text);
        _context.restore();
        return {
            width: metrics.width,
            height: parseInt(this.attrs.fontSize, 10)
        };
    };
    TextPath.prototype._setTextData = function () {
        var that = this;
        var size = this._getTextSize(this.attrs.text);
        var letterSpacing = this.letterSpacing();
        var align = this.align();
        var kerningFunc = this.kerningFunc();
        this.textWidth = size.width;
        this.textHeight = size.height;
        var textFullWidth = Math.max(this.textWidth + ((this.attrs.text || '').length - 1) * letterSpacing, 0);
        this.glyphInfo = [];
        var fullPathWidth = 0;
        for (var l = 0; l < that.dataArray.length; l++) {
            if (that.dataArray[l].pathLength > 0) {
                fullPathWidth += that.dataArray[l].pathLength;
            }
        }
        var offset = 0;
        if (align === 'center') {
            offset = Math.max(0, fullPathWidth / 2 - textFullWidth / 2);
        }
        if (align === 'right') {
            offset = Math.max(0, fullPathWidth - textFullWidth);
        }
        var charArr = this.text().split('');
        var spacesNumber = this.text().split(' ').length - 1;
        var p0, p1, pathCmd;
        var pIndex = -1;
        var currentT = 0;
        var getNextPathSegment = function () {
            currentT = 0;
            var pathData = that.dataArray;
            for (var j = pIndex + 1; j < pathData.length; j++) {
                if (pathData[j].pathLength > 0) {
                    pIndex = j;
                    return pathData[j];
                }
                else if (pathData[j].command === 'M') {
                    p0 = {
                        x: pathData[j].points[0],
                        y: pathData[j].points[1]
                    };
                }
            }
            return {};
        };
        var findSegmentToFitCharacter = function (c) {
            var glyphWidth = that._getTextSize(c).width + letterSpacing;
            if (c === ' ' && align === 'justify') {
                glyphWidth += (fullPathWidth - textFullWidth) / spacesNumber;
            }
            var currLen = 0;
            var attempts = 0;
            p1 = undefined;
            while (Math.abs(glyphWidth - currLen) / glyphWidth > 0.01 &&
                attempts < 25) {
                attempts++;
                var cumulativePathLength = currLen;
                while (pathCmd === undefined) {
                    pathCmd = getNextPathSegment();
                    if (pathCmd &&
                        cumulativePathLength + pathCmd.pathLength < glyphWidth) {
                        cumulativePathLength += pathCmd.pathLength;
                        pathCmd = undefined;
                    }
                }
                if (pathCmd === {} || p0 === undefined) {
                    return undefined;
                }
                var needNewSegment = false;
                switch (pathCmd.command) {
                    case 'L':
                        if (Path_1.Path.getLineLength(p0.x, p0.y, pathCmd.points[0], pathCmd.points[1]) > glyphWidth) {
                            p1 = Path_1.Path.getPointOnLine(glyphWidth, p0.x, p0.y, pathCmd.points[0], pathCmd.points[1], p0.x, p0.y);
                        }
                        else {
                            pathCmd = undefined;
                        }
                        break;
                    case 'A':
                        var start = pathCmd.points[4];
                        var dTheta = pathCmd.points[5];
                        var end = pathCmd.points[4] + dTheta;
                        if (currentT === 0) {
                            currentT = start + 0.00000001;
                        }
                        else if (glyphWidth > currLen) {
                            currentT += ((Math.PI / 180.0) * dTheta) / Math.abs(dTheta);
                        }
                        else {
                            currentT -= ((Math.PI / 360.0) * dTheta) / Math.abs(dTheta);
                        }
                        if ((dTheta < 0 && currentT < end) ||
                            (dTheta >= 0 && currentT > end)) {
                            currentT = end;
                            needNewSegment = true;
                        }
                        p1 = Path_1.Path.getPointOnEllipticalArc(pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], currentT, pathCmd.points[6]);
                        break;
                    case 'C':
                        if (currentT === 0) {
                            if (glyphWidth > pathCmd.pathLength) {
                                currentT = 0.00000001;
                            }
                            else {
                                currentT = glyphWidth / pathCmd.pathLength;
                            }
                        }
                        else if (glyphWidth > currLen) {
                            currentT += (glyphWidth - currLen) / pathCmd.pathLength;
                        }
                        else {
                            currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
                        }
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = Path_1.Path.getPointOnCubicBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3], pathCmd.points[4], pathCmd.points[5]);
                        break;
                    case 'Q':
                        if (currentT === 0) {
                            currentT = glyphWidth / pathCmd.pathLength;
                        }
                        else if (glyphWidth > currLen) {
                            currentT += (glyphWidth - currLen) / pathCmd.pathLength;
                        }
                        else {
                            currentT -= (currLen - glyphWidth) / pathCmd.pathLength;
                        }
                        if (currentT > 1.0) {
                            currentT = 1.0;
                            needNewSegment = true;
                        }
                        p1 = Path_1.Path.getPointOnQuadraticBezier(currentT, pathCmd.start.x, pathCmd.start.y, pathCmd.points[0], pathCmd.points[1], pathCmd.points[2], pathCmd.points[3]);
                        break;
                }
                if (p1 !== undefined) {
                    currLen = Path_1.Path.getLineLength(p0.x, p0.y, p1.x, p1.y);
                }
                if (needNewSegment) {
                    needNewSegment = false;
                    pathCmd = undefined;
                }
            }
        };
        var testChar = 'C';
        var glyphWidth = that._getTextSize(testChar).width + letterSpacing;
        var lettersInOffset = offset / glyphWidth - 1;
        for (var k = 0; k < lettersInOffset; k++) {
            findSegmentToFitCharacter(testChar);
            if (p0 === undefined || p1 === undefined) {
                break;
            }
            p0 = p1;
        }
        for (var i = 0; i < charArr.length; i++) {
            findSegmentToFitCharacter(charArr[i]);
            if (p0 === undefined || p1 === undefined) {
                break;
            }
            var width = Path_1.Path.getLineLength(p0.x, p0.y, p1.x, p1.y);
            var kern = 0;
            if (kerningFunc) {
                try {
                    kern = kerningFunc(charArr[i - 1], charArr[i]) * this.fontSize();
                }
                catch (e) {
                    kern = 0;
                }
            }
            p0.x += kern;
            p1.x += kern;
            this.textWidth += kern;
            var midpoint = Path_1.Path.getPointOnLine(kern + width / 2.0, p0.x, p0.y, p1.x, p1.y);
            var rotation = Math.atan2(p1.y - p0.y, p1.x - p0.x);
            this.glyphInfo.push({
                transposeX: midpoint.x,
                transposeY: midpoint.y,
                text: charArr[i],
                rotation: rotation,
                p0: p0,
                p1: p1
            });
            p0 = p1;
        }
    };
    TextPath.prototype.getSelfRect = function () {
        if (!this.glyphInfo.length) {
            return {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
        }
        var points = [];
        this.glyphInfo.forEach(function (info) {
            points.push(info.p0.x);
            points.push(info.p0.y);
            points.push(info.p1.x);
            points.push(info.p1.y);
        });
        var minX = points[0] || 0;
        var maxX = points[0] || 0;
        var minY = points[1] || 0;
        var maxY = points[1] || 0;
        var x, y;
        for (var i = 0; i < points.length / 2; i++) {
            x = points[i * 2];
            y = points[i * 2 + 1];
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        }
        var fontSize = this.fontSize();
        return {
            x: minX - fontSize / 2,
            y: minY - fontSize / 2,
            width: maxX - minX + fontSize,
            height: maxY - minY + fontSize
        };
    };
    return TextPath;
}(Shape_1.Shape));
exports.TextPath = TextPath;
TextPath.prototype._fillFunc = _fillFunc;
TextPath.prototype._strokeFunc = _strokeFunc;
TextPath.prototype._fillFuncHit = _fillFunc;
TextPath.prototype._strokeFuncHit = _strokeFunc;
TextPath.prototype.className = 'TextPath';
TextPath.prototype._attrsAffectingSize = ['text', 'fontSize', 'data'];
Global_1._registerNode(TextPath);
Factory_1.Factory.addGetterSetter(TextPath, 'data');
Factory_1.Factory.addGetterSetter(TextPath, 'fontFamily', 'Arial');
Factory_1.Factory.addGetterSetter(TextPath, 'fontSize', 12, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(TextPath, 'fontStyle', NORMAL);
Factory_1.Factory.addGetterSetter(TextPath, 'align', 'left');
Factory_1.Factory.addGetterSetter(TextPath, 'letterSpacing', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(TextPath, 'textBaseline', 'middle');
Factory_1.Factory.addGetterSetter(TextPath, 'fontVariant', NORMAL);
Factory_1.Factory.addGetterSetter(TextPath, 'text', EMPTY_STRING);
Factory_1.Factory.addGetterSetter(TextPath, 'textDecoration', null);
Factory_1.Factory.addGetterSetter(TextPath, 'kerningFunc', null);
Util_1.Collection.mapMethods(TextPath);


/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Shape_1 = __webpack_require__(68);
var Rect_1 = __webpack_require__(1133);
var Group_1 = __webpack_require__(665);
var Global_1 = __webpack_require__(38);
var Validators_1 = __webpack_require__(41);
var Global_2 = __webpack_require__(38);
var EVENTS_NAME = 'tr-konva';
var ATTR_CHANGE_LIST = [
    'resizeEnabledChange',
    'rotateAnchorOffsetChange',
    'rotateEnabledChange',
    'enabledAnchorsChange',
    'anchorSizeChange',
    'borderEnabledChange',
    'borderStrokeChange',
    'borderStrokeWidthChange',
    'borderDashChange',
    'anchorStrokeChange',
    'anchorStrokeWidthChange',
    'anchorFillChange',
    'anchorCornerRadiusChange',
    'ignoreStrokeChange',
]
    .map(function (e) { return e + ("." + EVENTS_NAME); })
    .join(' ');
var NODES_RECT = 'nodesRect';
var TRANSFORM_CHANGE_STR = [
    'widthChange',
    'heightChange',
    'scaleXChange',
    'scaleYChange',
    'skewXChange',
    'skewYChange',
    'rotationChange',
    'offsetXChange',
    'offsetYChange',
    'transformsEnabledChange',
    'strokeWidthChange',
]
    .map(function (e) { return e + ("." + EVENTS_NAME); })
    .join(' ');
var ANGLES = {
    'top-left': -45,
    'top-center': 0,
    'top-right': 45,
    'middle-right': -90,
    'middle-left': 90,
    'bottom-left': -135,
    'bottom-center': 180,
    'bottom-right': 135,
};
var TOUCH_DEVICE = 'ontouchstart' in Global_1.Konva._global;
function getCursor(anchorName, rad) {
    if (anchorName === 'rotater') {
        return 'crosshair';
    }
    rad += Util_1.Util._degToRad(ANGLES[anchorName] || 0);
    var angle = ((Util_1.Util._radToDeg(rad) % 360) + 360) % 360;
    if (Util_1.Util._inRange(angle, 315 + 22.5, 360) || Util_1.Util._inRange(angle, 0, 22.5)) {
        return 'ns-resize';
    }
    else if (Util_1.Util._inRange(angle, 45 - 22.5, 45 + 22.5)) {
        return 'nesw-resize';
    }
    else if (Util_1.Util._inRange(angle, 90 - 22.5, 90 + 22.5)) {
        return 'ew-resize';
    }
    else if (Util_1.Util._inRange(angle, 135 - 22.5, 135 + 22.5)) {
        return 'nwse-resize';
    }
    else if (Util_1.Util._inRange(angle, 180 - 22.5, 180 + 22.5)) {
        return 'ns-resize';
    }
    else if (Util_1.Util._inRange(angle, 225 - 22.5, 225 + 22.5)) {
        return 'nesw-resize';
    }
    else if (Util_1.Util._inRange(angle, 270 - 22.5, 270 + 22.5)) {
        return 'ew-resize';
    }
    else if (Util_1.Util._inRange(angle, 315 - 22.5, 315 + 22.5)) {
        return 'nwse-resize';
    }
    else {
        Util_1.Util.error('Transformer has unknown angle for cursor detection: ' + angle);
        return 'pointer';
    }
}
var ANCHORS_NAMES = [
    'top-left',
    'top-center',
    'top-right',
    'middle-right',
    'middle-left',
    'bottom-left',
    'bottom-center',
    'bottom-right',
];
var MAX_SAFE_INTEGER = 100000000;
function getCenter(shape) {
    return {
        x: shape.x +
            (shape.width / 2) * Math.cos(shape.rotation) +
            (shape.height / 2) * Math.sin(-shape.rotation),
        y: shape.y +
            (shape.height / 2) * Math.cos(shape.rotation) +
            (shape.width / 2) * Math.sin(shape.rotation),
    };
}
function rotateAroundPoint(shape, angleRad, point) {
    var x = point.x +
        (shape.x - point.x) * Math.cos(angleRad) -
        (shape.y - point.y) * Math.sin(angleRad);
    var y = point.y +
        (shape.x - point.x) * Math.sin(angleRad) +
        (shape.y - point.y) * Math.cos(angleRad);
    return __assign(__assign({}, shape), { rotation: shape.rotation + angleRad, x: x,
        y: y });
}
function rotateAroundCenter(shape, deltaRad) {
    var center = getCenter(shape);
    return rotateAroundPoint(shape, deltaRad, center);
}
function getSnap(snaps, newRotationRad, tol) {
    var snapped = newRotationRad;
    for (var i = 0; i < snaps.length; i++) {
        var angle = Global_1.Konva.getAngle(snaps[i]);
        var absDiff = Math.abs(angle - newRotationRad) % (Math.PI * 2);
        var dif = Math.min(absDiff, Math.PI * 2 - absDiff);
        if (dif < tol) {
            snapped = angle;
        }
    }
    return snapped;
}
var Transformer = (function (_super) {
    __extends(Transformer, _super);
    function Transformer(config) {
        var _this = _super.call(this, config) || this;
        _this._transforming = false;
        _this._createElements();
        _this._handleMouseMove = _this._handleMouseMove.bind(_this);
        _this._handleMouseUp = _this._handleMouseUp.bind(_this);
        _this.update = _this.update.bind(_this);
        _this.on(ATTR_CHANGE_LIST, _this.update);
        if (_this.getNode()) {
            _this.update();
        }
        return _this;
    }
    Transformer.prototype.attachTo = function (node) {
        this.setNode(node);
        return this;
    };
    Transformer.prototype.setNode = function (node) {
        Util_1.Util.warn('tr.setNode(shape), tr.node(shape) and tr.attachTo(shape) methods are deprecated. Please use tr.nodes(nodesArray) instead.');
        return this.setNodes([node]);
    };
    Transformer.prototype.getNode = function () {
        return this._nodes && this._nodes[0];
    };
    Transformer.prototype.setNodes = function (nodes) {
        var _this = this;
        if (nodes === void 0) { nodes = []; }
        if (this._nodes && this._nodes.length) {
            this.detach();
        }
        this._nodes = nodes;
        if (nodes.length === 1) {
            this.rotation(nodes[0].rotation());
        }
        else {
            this.rotation(0);
        }
        this._nodes.forEach(function (node) {
            var additionalEvents = node._attrsAffectingSize
                .map(function (prop) { return prop + 'Change.' + EVENTS_NAME; })
                .join(' ');
            var onChange = function () {
                _this._resetTransformCache();
                if (!_this._transforming) {
                    _this.update();
                }
            };
            node.on(additionalEvents, onChange);
            node.on(TRANSFORM_CHANGE_STR, onChange);
            node.on("_clearTransformCache." + EVENTS_NAME, onChange);
            node.on("xChange." + EVENTS_NAME + " yChange." + EVENTS_NAME, onChange);
            _this._proxyDrag(node);
        });
        this._resetTransformCache();
        var elementsCreated = !!this.findOne('.top-left');
        if (elementsCreated) {
            this.update();
        }
        return this;
    };
    Transformer.prototype._proxyDrag = function (node) {
        var _this = this;
        var lastPos;
        node.on("dragstart." + EVENTS_NAME, function (e) {
            lastPos = node.getAbsolutePosition();
            if (!_this.isDragging() && node !== _this.findOne('.back')) {
                _this.startDrag();
            }
        });
        node.on("dragmove." + EVENTS_NAME, function (e) {
            if (!lastPos) {
                return;
            }
            var abs = node.getAbsolutePosition();
            var dx = abs.x - lastPos.x;
            var dy = abs.y - lastPos.y;
            _this.nodes().forEach(function (otherNode) {
                if (otherNode === node) {
                    return;
                }
                if (otherNode.isDragging()) {
                    return;
                }
                var otherAbs = otherNode.getAbsolutePosition();
                otherNode.setAbsolutePosition({
                    x: otherAbs.x + dx,
                    y: otherAbs.y + dy,
                });
                otherNode.startDrag();
            });
            lastPos = null;
        });
    };
    Transformer.prototype.getNodes = function () {
        return this._nodes;
    };
    Transformer.prototype.getActiveAnchor = function () {
        return this._movingAnchorName;
    };
    Transformer.prototype.detach = function () {
        if (this._nodes) {
            this._nodes.forEach(function (node) {
                node.off('.' + EVENTS_NAME);
            });
        }
        this._nodes = [];
        this._resetTransformCache();
    };
    Transformer.prototype._resetTransformCache = function () {
        this._clearCache(NODES_RECT);
        this._clearCache('transform');
        this._clearSelfAndDescendantCache('absoluteTransform');
    };
    Transformer.prototype._getNodeRect = function () {
        return this._getCache(NODES_RECT, this.__getNodeRect);
    };
    Transformer.prototype.__getNodeShape = function (node, rot, relative) {
        if (rot === void 0) { rot = this.rotation(); }
        var rect = node.getClientRect({
            skipTransform: true,
            skipShadow: true,
            skipStroke: this.ignoreStroke(),
        });
        var absScale = node.getAbsoluteScale(relative);
        var absPos = node.getAbsolutePosition(relative);
        var dx = rect.x * absScale.x - node.offsetX() * absScale.x;
        var dy = rect.y * absScale.y - node.offsetY() * absScale.y;
        var rotation = (Global_1.Konva.getAngle(node.getAbsoluteRotation()) + Math.PI * 2) %
            (Math.PI * 2);
        var box = {
            x: absPos.x + dx * Math.cos(rotation) + dy * Math.sin(-rotation),
            y: absPos.y + dy * Math.cos(rotation) + dx * Math.sin(rotation),
            width: rect.width * absScale.x,
            height: rect.height * absScale.y,
            rotation: rotation,
        };
        return rotateAroundPoint(box, -Global_1.Konva.getAngle(rot), {
            x: 0,
            y: 0,
        });
    };
    Transformer.prototype.__getNodeRect = function () {
        var _this = this;
        var node = this.getNode();
        if (!node) {
            return {
                x: -MAX_SAFE_INTEGER,
                y: -MAX_SAFE_INTEGER,
                width: 0,
                height: 0,
                rotation: 0,
            };
        }
        var totalPoints = [];
        this.nodes().map(function (node) {
            var box = node.getClientRect({
                skipTransform: true,
                skipShadow: true,
                skipStroke: _this.ignoreStroke(),
            });
            var points = [
                { x: box.x, y: box.y },
                { x: box.x + box.width, y: box.y },
                { x: box.x + box.width, y: box.y + box.height },
                { x: box.x, y: box.y + box.height },
            ];
            var trans = node.getAbsoluteTransform();
            points.forEach(function (point) {
                var transformed = trans.point(point);
                totalPoints.push(transformed);
            });
        });
        var tr = new Util_1.Transform();
        tr.rotate(-Global_1.Konva.getAngle(this.rotation()));
        var minX, minY, maxX, maxY;
        totalPoints.forEach(function (point) {
            var transformed = tr.point(point);
            if (minX === undefined) {
                minX = maxX = transformed.x;
                minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
        });
        tr.invert();
        var p = tr.point({ x: minX, y: minY });
        return {
            x: p.x,
            y: p.y,
            width: maxX - minX,
            height: maxY - minY,
            rotation: Global_1.Konva.getAngle(this.rotation()),
        };
    };
    Transformer.prototype.getX = function () {
        return this._getNodeRect().x;
    };
    Transformer.prototype.getY = function () {
        return this._getNodeRect().y;
    };
    Transformer.prototype.getWidth = function () {
        return this._getNodeRect().width;
    };
    Transformer.prototype.getHeight = function () {
        return this._getNodeRect().height;
    };
    Transformer.prototype._createElements = function () {
        this._createBack();
        ANCHORS_NAMES.forEach(function (name) {
            this._createAnchor(name);
        }.bind(this));
        this._createAnchor('rotater');
    };
    Transformer.prototype._createAnchor = function (name) {
        var _this = this;
        var anchor = new Rect_1.Rect({
            stroke: 'rgb(0, 161, 255)',
            fill: 'white',
            strokeWidth: 1,
            name: name + ' _anchor',
            dragDistance: 0,
            draggable: true,
            hitStrokeWidth: TOUCH_DEVICE ? 10 : 'auto',
        });
        var self = this;
        anchor.on('mousedown touchstart', function (e) {
            self._handleMouseDown(e);
        });
        anchor.on('dragstart', function (e) {
            anchor.stopDrag();
            e.cancelBubble = true;
        });
        anchor.on('dragend', function (e) {
            e.cancelBubble = true;
        });
        anchor.on('mouseenter', function () {
            var rad = Global_1.Konva.getAngle(_this.rotation());
            var cursor = getCursor(name, rad);
            anchor.getStage().content.style.cursor = cursor;
            _this._cursorChange = true;
        });
        anchor.on('mouseout', function () {
            anchor.getStage().content.style.cursor = '';
            _this._cursorChange = false;
        });
        this.add(anchor);
    };
    Transformer.prototype._createBack = function () {
        var _this = this;
        var back = new Shape_1.Shape({
            name: 'back',
            width: 0,
            height: 0,
            draggable: true,
            sceneFunc: function (ctx) {
                var tr = this.getParent();
                var padding = tr.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, this.width() + padding * 2, this.height() + padding * 2);
                ctx.moveTo(this.width() / 2, -padding);
                if (tr.rotateEnabled()) {
                    ctx.lineTo(this.width() / 2, -tr.rotateAnchorOffset() * Util_1.Util._sign(this.height()) - padding);
                }
                ctx.fillStrokeShape(this);
            },
            hitFunc: function (ctx, shape) {
                if (!_this.shouldOverdrawWholeArea()) {
                    return;
                }
                var padding = _this.padding();
                ctx.beginPath();
                ctx.rect(-padding, -padding, shape.width() + padding * 2, shape.height() + padding * 2);
                ctx.fillStrokeShape(shape);
            },
        });
        this.add(back);
        this._proxyDrag(back);
    };
    Transformer.prototype._handleMouseDown = function (e) {
        this._movingAnchorName = e.target.name().split(' ')[0];
        var attrs = this._getNodeRect();
        var width = attrs.width;
        var height = attrs.height;
        var hypotenuse = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2));
        this.sin = Math.abs(height / hypotenuse);
        this.cos = Math.abs(width / hypotenuse);
        window.addEventListener('mousemove', this._handleMouseMove);
        window.addEventListener('touchmove', this._handleMouseMove);
        window.addEventListener('mouseup', this._handleMouseUp, true);
        window.addEventListener('touchend', this._handleMouseUp, true);
        this._transforming = true;
        var ap = e.target.getAbsolutePosition();
        var pos = e.target.getStage().getPointerPosition();
        this._anchorDragOffset = {
            x: pos.x - ap.x,
            y: pos.y - ap.y,
        };
        this._fire('transformstart', { evt: e, target: this.getNode() });
        this.getNode()._fire('transformstart', { evt: e, target: this.getNode() });
    };
    Transformer.prototype._handleMouseMove = function (e) {
        var x, y, newHypotenuse;
        var anchorNode = this.findOne('.' + this._movingAnchorName);
        var stage = anchorNode.getStage();
        stage.setPointersPositions(e);
        var pp = stage.getPointerPosition();
        var newNodePos = {
            x: pp.x - this._anchorDragOffset.x,
            y: pp.y - this._anchorDragOffset.y,
        };
        var oldAbs = anchorNode.getAbsolutePosition();
        anchorNode.setAbsolutePosition(newNodePos);
        var newAbs = anchorNode.getAbsolutePosition();
        if (oldAbs.x === newAbs.x && oldAbs.y === newAbs.y) {
            return;
        }
        if (this._movingAnchorName === 'rotater') {
            var attrs = this._getNodeRect();
            x = anchorNode.x() - attrs.width / 2;
            y = -anchorNode.y() + attrs.height / 2;
            var delta = Math.atan2(-y, x) + Math.PI / 2;
            if (attrs.height < 0) {
                delta -= Math.PI;
            }
            var oldRotation = Global_1.Konva.getAngle(this.rotation());
            var newRotation = oldRotation + delta;
            var tol = Global_1.Konva.getAngle(this.rotationSnapTolerance());
            var snappedRot = getSnap(this.rotationSnaps(), newRotation, tol);
            var diff = snappedRot - attrs.rotation;
            var shape = rotateAroundCenter(attrs, diff);
            this._fitNodesInto(shape, e);
            return;
        }
        var keepProportion = this.keepRatio() || e.shiftKey;
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (this._movingAnchorName === 'top-left') {
            if (keepProportion) {
                var comparePoint = centeredScaling
                    ? {
                        x: this.width() / 2,
                        y: this.height() / 2,
                    }
                    : {
                        x: this.findOne('.bottom-right').x(),
                        y: this.findOne('.bottom-right').y(),
                    };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) +
                    Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne('.top-left').x() > comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.top-left').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-left').x(comparePoint.x - x);
                this.findOne('.top-left').y(comparePoint.y - y);
            }
        }
        else if (this._movingAnchorName === 'top-center') {
            this.findOne('.top-left').y(anchorNode.y());
        }
        else if (this._movingAnchorName === 'top-right') {
            if (keepProportion) {
                var comparePoint = centeredScaling
                    ? {
                        x: this.width() / 2,
                        y: this.height() / 2,
                    }
                    : {
                        x: this.findOne('.bottom-left').x(),
                        y: this.findOne('.bottom-left').y(),
                    };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) +
                    Math.pow(comparePoint.y - anchorNode.y(), 2));
                var reverseX = this.findOne('.top-right').x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.top-right').y() > comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.top-right').x(comparePoint.x + x);
                this.findOne('.top-right').y(comparePoint.y - y);
            }
            var pos = anchorNode.position();
            this.findOne('.top-left').y(pos.y);
            this.findOne('.bottom-right').x(pos.x);
        }
        else if (this._movingAnchorName === 'middle-left') {
            this.findOne('.top-left').x(anchorNode.x());
        }
        else if (this._movingAnchorName === 'middle-right') {
            this.findOne('.bottom-right').x(anchorNode.x());
        }
        else if (this._movingAnchorName === 'bottom-left') {
            if (keepProportion) {
                var comparePoint = centeredScaling
                    ? {
                        x: this.width() / 2,
                        y: this.height() / 2,
                    }
                    : {
                        x: this.findOne('.top-right').x(),
                        y: this.findOne('.top-right').y(),
                    };
                newHypotenuse = Math.sqrt(Math.pow(comparePoint.x - anchorNode.x(), 2) +
                    Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = comparePoint.x < anchorNode.x() ? -1 : 1;
                var reverseY = anchorNode.y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                anchorNode.x(comparePoint.x - x);
                anchorNode.y(comparePoint.y + y);
            }
            pos = anchorNode.position();
            this.findOne('.top-left').x(pos.x);
            this.findOne('.bottom-right').y(pos.y);
        }
        else if (this._movingAnchorName === 'bottom-center') {
            this.findOne('.bottom-right').y(anchorNode.y());
        }
        else if (this._movingAnchorName === 'bottom-right') {
            if (keepProportion) {
                var comparePoint = centeredScaling
                    ? {
                        x: this.width() / 2,
                        y: this.height() / 2,
                    }
                    : {
                        x: this.findOne('.top-left').x(),
                        y: this.findOne('.top-left').y(),
                    };
                newHypotenuse = Math.sqrt(Math.pow(anchorNode.x() - comparePoint.x, 2) +
                    Math.pow(anchorNode.y() - comparePoint.y, 2));
                var reverseX = this.findOne('.bottom-right').x() < comparePoint.x ? -1 : 1;
                var reverseY = this.findOne('.bottom-right').y() < comparePoint.y ? -1 : 1;
                x = newHypotenuse * this.cos * reverseX;
                y = newHypotenuse * this.sin * reverseY;
                this.findOne('.bottom-right').x(comparePoint.x + x);
                this.findOne('.bottom-right').y(comparePoint.y + y);
            }
        }
        else {
            console.error(new Error('Wrong position argument of selection resizer: ' +
                this._movingAnchorName));
        }
        var centeredScaling = this.centeredScaling() || e.altKey;
        if (centeredScaling) {
            var topLeft = this.findOne('.top-left');
            var bottomRight = this.findOne('.bottom-right');
            var topOffsetX = topLeft.x();
            var topOffsetY = topLeft.y();
            var bottomOffsetX = this.getWidth() - bottomRight.x();
            var bottomOffsetY = this.getHeight() - bottomRight.y();
            bottomRight.move({
                x: -topOffsetX,
                y: -topOffsetY,
            });
            topLeft.move({
                x: bottomOffsetX,
                y: bottomOffsetY,
            });
        }
        var absPos = this.findOne('.top-left').getAbsolutePosition();
        x = absPos.x;
        y = absPos.y;
        var width = this.findOne('.bottom-right').x() - this.findOne('.top-left').x();
        var height = this.findOne('.bottom-right').y() - this.findOne('.top-left').y();
        this._fitNodesInto({
            x: x,
            y: y,
            width: width,
            height: height,
            rotation: Global_1.Konva.getAngle(this.rotation()),
        }, e);
    };
    Transformer.prototype._handleMouseUp = function (e) {
        this._removeEvents(e);
    };
    Transformer.prototype.getAbsoluteTransform = function () {
        return this.getTransform();
    };
    Transformer.prototype._removeEvents = function (e) {
        if (this._transforming) {
            this._transforming = false;
            window.removeEventListener('mousemove', this._handleMouseMove);
            window.removeEventListener('touchmove', this._handleMouseMove);
            window.removeEventListener('mouseup', this._handleMouseUp, true);
            window.removeEventListener('touchend', this._handleMouseUp, true);
            var node = this.getNode();
            this._fire('transformend', { evt: e, target: node });
            if (node) {
                node.fire('transformend', { evt: e, target: node });
            }
            this._movingAnchorName = null;
        }
    };
    Transformer.prototype._fitNodesInto = function (newAttrs, evt) {
        var _this = this;
        var oldAttrs = this._getNodeRect();
        var minSize = 1;
        if (Util_1.Util._inRange(newAttrs.width, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        if (Util_1.Util._inRange(newAttrs.height, -this.padding() * 2 - minSize, minSize)) {
            this.update();
            return;
        }
        var allowNegativeScale = true;
        var t = new Util_1.Transform();
        t.rotate(Global_1.Konva.getAngle(this.rotation()));
        if (this._movingAnchorName &&
            newAttrs.width < 0 &&
            this._movingAnchorName.indexOf('left') >= 0) {
            var offset = t.point({
                x: -this.padding() * 2,
                y: 0,
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            newAttrs.width += this.padding() * 2;
            this._movingAnchorName = this._movingAnchorName.replace('left', 'right');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        else if (this._movingAnchorName &&
            newAttrs.width < 0 &&
            this._movingAnchorName.indexOf('right') >= 0) {
            var offset = t.point({
                x: this.padding() * 2,
                y: 0,
            });
            this._movingAnchorName = this._movingAnchorName.replace('right', 'left');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.width += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this._movingAnchorName &&
            newAttrs.height < 0 &&
            this._movingAnchorName.indexOf('top') >= 0) {
            var offset = t.point({
                x: 0,
                y: -this.padding() * 2,
            });
            newAttrs.x += offset.x;
            newAttrs.y += offset.y;
            this._movingAnchorName = this._movingAnchorName.replace('top', 'bottom');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        else if (this._movingAnchorName &&
            newAttrs.height < 0 &&
            this._movingAnchorName.indexOf('bottom') >= 0) {
            var offset = t.point({
                x: 0,
                y: this.padding() * 2,
            });
            this._movingAnchorName = this._movingAnchorName.replace('bottom', 'top');
            this._anchorDragOffset.x -= offset.x;
            this._anchorDragOffset.y -= offset.y;
            newAttrs.height += this.padding() * 2;
            if (!allowNegativeScale) {
                this.update();
                return;
            }
        }
        if (this.boundBoxFunc()) {
            var bounded = this.boundBoxFunc()(oldAttrs, newAttrs);
            if (bounded) {
                newAttrs = bounded;
            }
            else {
                Util_1.Util.warn('boundBoxFunc returned falsy. You should return new bound rect from it!');
            }
        }
        var baseSize = 10000000;
        var oldTr = new Util_1.Transform();
        oldTr.translate(oldAttrs.x, oldAttrs.y);
        oldTr.rotate(oldAttrs.rotation);
        oldTr.scale(oldAttrs.width / baseSize, oldAttrs.height / baseSize);
        var newTr = new Util_1.Transform();
        newTr.translate(newAttrs.x, newAttrs.y);
        newTr.rotate(newAttrs.rotation);
        newTr.scale(newAttrs.width / baseSize, newAttrs.height / baseSize);
        var delta = newTr.multiply(oldTr.invert());
        this._nodes.forEach(function (node) {
            var parentTransform = node.getParent().getAbsoluteTransform();
            var localTransform = node.getTransform().copy();
            localTransform.translate(node.offsetX(), node.offsetY());
            var newLocalTransform = new Util_1.Transform();
            newLocalTransform
                .multiply(parentTransform.copy().invert())
                .multiply(delta)
                .multiply(parentTransform)
                .multiply(localTransform);
            var attrs = newLocalTransform.decompose();
            node.setAttrs(attrs);
            _this._fire('transform', { evt: evt, target: node });
            node._fire('transform', { evt: evt, target: node });
        });
        this.rotation(Util_1.Util._getRotation(newAttrs.rotation));
        this._resetTransformCache();
        this.update();
        this.getLayer().batchDraw();
    };
    Transformer.prototype.forceUpdate = function () {
        this._resetTransformCache();
        this.update();
    };
    Transformer.prototype._batchChangeChild = function (selector, attrs) {
        var anchor = this.findOne(selector);
        anchor.setAttrs(attrs);
    };
    Transformer.prototype.update = function () {
        var _this = this;
        var attrs = this._getNodeRect();
        this.rotation(Util_1.Util._getRotation(attrs.rotation));
        var width = attrs.width;
        var height = attrs.height;
        var enabledAnchors = this.enabledAnchors();
        var resizeEnabled = this.resizeEnabled();
        var padding = this.padding();
        var anchorSize = this.anchorSize();
        this.find('._anchor').each(function (node) {
            node.setAttrs({
                width: anchorSize,
                height: anchorSize,
                offsetX: anchorSize / 2,
                offsetY: anchorSize / 2,
                stroke: _this.anchorStroke(),
                strokeWidth: _this.anchorStrokeWidth(),
                fill: _this.anchorFill(),
                cornerRadius: _this.anchorCornerRadius(),
            });
        });
        this._batchChangeChild('.top-left', {
            x: 0,
            y: 0,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-left') >= 0,
        });
        this._batchChangeChild('.top-center', {
            x: width / 2,
            y: 0,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-center') >= 0,
        });
        this._batchChangeChild('.top-right', {
            x: width,
            y: 0,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('top-right') >= 0,
        });
        this._batchChangeChild('.middle-left', {
            x: 0,
            y: height / 2,
            offsetX: anchorSize / 2 + padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-left') >= 0,
        });
        this._batchChangeChild('.middle-right', {
            x: width,
            y: height / 2,
            offsetX: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('middle-right') >= 0,
        });
        this._batchChangeChild('.bottom-left', {
            x: 0,
            y: height,
            offsetX: anchorSize / 2 + padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-left') >= 0,
        });
        this._batchChangeChild('.bottom-center', {
            x: width / 2,
            y: height,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-center') >= 0,
        });
        this._batchChangeChild('.bottom-right', {
            x: width,
            y: height,
            offsetX: anchorSize / 2 - padding,
            offsetY: anchorSize / 2 - padding,
            visible: resizeEnabled && enabledAnchors.indexOf('bottom-right') >= 0,
        });
        this._batchChangeChild('.rotater', {
            x: width / 2,
            y: -this.rotateAnchorOffset() * Util_1.Util._sign(height) - padding,
            visible: this.rotateEnabled(),
        });
        this._batchChangeChild('.back', {
            width: width,
            height: height,
            visible: this.borderEnabled(),
            stroke: this.borderStroke(),
            strokeWidth: this.borderStrokeWidth(),
            dash: this.borderDash(),
            x: 0,
            y: 0,
        });
    };
    Transformer.prototype.isTransforming = function () {
        return this._transforming;
    };
    Transformer.prototype.stopTransform = function () {
        if (this._transforming) {
            this._removeEvents();
            var anchorNode = this.findOne('.' + this._movingAnchorName);
            if (anchorNode) {
                anchorNode.stopDrag();
            }
        }
    };
    Transformer.prototype.destroy = function () {
        if (this.getStage() && this._cursorChange) {
            this.getStage().content.style.cursor = '';
        }
        Group_1.Group.prototype.destroy.call(this);
        this.detach();
        this._removeEvents();
        return this;
    };
    Transformer.prototype.toObject = function () {
        return Node_1.Node.prototype.toObject.call(this);
    };
    return Transformer;
}(Group_1.Group));
exports.Transformer = Transformer;
function validateAnchors(val) {
    if (!(val instanceof Array)) {
        Util_1.Util.warn('enabledAnchors value should be an array');
    }
    if (val instanceof Array) {
        val.forEach(function (name) {
            if (ANCHORS_NAMES.indexOf(name) === -1) {
                Util_1.Util.warn('Unknown anchor name: ' +
                    name +
                    '. Available names are: ' +
                    ANCHORS_NAMES.join(', '));
            }
        });
    }
    return val || [];
}
Transformer.prototype.className = 'Transformer';
Global_2._registerNode(Transformer);
Factory_1.Factory.addGetterSetter(Transformer, 'enabledAnchors', ANCHORS_NAMES, validateAnchors);
Factory_1.Factory.addGetterSetter(Transformer, 'resizeEnabled', true);
Factory_1.Factory.addGetterSetter(Transformer, 'anchorSize', 10, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Transformer, 'rotateEnabled', true);
Factory_1.Factory.addGetterSetter(Transformer, 'rotationSnaps', []);
Factory_1.Factory.addGetterSetter(Transformer, 'rotateAnchorOffset', 50, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Transformer, 'rotationSnapTolerance', 5, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Transformer, 'borderEnabled', true);
Factory_1.Factory.addGetterSetter(Transformer, 'anchorStroke', 'rgb(0, 161, 255)');
Factory_1.Factory.addGetterSetter(Transformer, 'anchorStrokeWidth', 1, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Transformer, 'anchorFill', 'white');
Factory_1.Factory.addGetterSetter(Transformer, 'anchorCornerRadius', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Transformer, 'borderStroke', 'rgb(0, 161, 255)');
Factory_1.Factory.addGetterSetter(Transformer, 'borderStrokeWidth', 1, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Transformer, 'borderDash');
Factory_1.Factory.addGetterSetter(Transformer, 'keepRatio', true);
Factory_1.Factory.addGetterSetter(Transformer, 'centeredScaling', false);
Factory_1.Factory.addGetterSetter(Transformer, 'ignoreStroke', false);
Factory_1.Factory.addGetterSetter(Transformer, 'padding', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Transformer, 'node');
Factory_1.Factory.addGetterSetter(Transformer, 'nodes');
Factory_1.Factory.addGetterSetter(Transformer, 'boundBoxFunc');
Factory_1.Factory.addGetterSetter(Transformer, 'shouldOverdrawWholeArea', false);
Factory_1.Factory.backCompat(Transformer, {
    lineEnabled: 'borderEnabled',
    rotateHandlerOffset: 'rotateAnchorOffset',
    enabledHandlers: 'enabledAnchors',
});
Util_1.Collection.mapMethods(Transformer);


/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Util_1 = __webpack_require__(43);
var Factory_1 = __webpack_require__(37);
var Shape_1 = __webpack_require__(68);
var Global_1 = __webpack_require__(38);
var Validators_1 = __webpack_require__(41);
var Global_2 = __webpack_require__(38);
var Wedge = (function (_super) {
    __extends(Wedge, _super);
    function Wedge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Wedge.prototype._sceneFunc = function (context) {
        context.beginPath();
        context.arc(0, 0, this.radius(), 0, Global_1.Konva.getAngle(this.angle()), this.clockwise());
        context.lineTo(0, 0);
        context.closePath();
        context.fillStrokeShape(this);
    };
    Wedge.prototype.getWidth = function () {
        return this.radius() * 2;
    };
    Wedge.prototype.getHeight = function () {
        return this.radius() * 2;
    };
    Wedge.prototype.setWidth = function (width) {
        this.radius(width / 2);
    };
    Wedge.prototype.setHeight = function (height) {
        this.radius(height / 2);
    };
    return Wedge;
}(Shape_1.Shape));
exports.Wedge = Wedge;
Wedge.prototype.className = 'Wedge';
Wedge.prototype._centroid = true;
Wedge.prototype._attrsAffectingSize = ['radius'];
Global_2._registerNode(Wedge);
Factory_1.Factory.addGetterSetter(Wedge, 'radius', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Wedge, 'angle', 0, Validators_1.getNumberValidator());
Factory_1.Factory.addGetterSetter(Wedge, 'clockwise', false);
Factory_1.Factory.backCompat(Wedge, {
    angleDeg: 'angle',
    getAngleDeg: 'getAngle',
    setAngleDeg: 'setAngle'
});
Util_1.Collection.mapMethods(Wedge);


/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
function BlurStack() {
    this.r = 0;
    this.g = 0;
    this.b = 0;
    this.a = 0;
    this.next = null;
}
var mul_table = [
    512,
    512,
    456,
    512,
    328,
    456,
    335,
    512,
    405,
    328,
    271,
    456,
    388,
    335,
    292,
    512,
    454,
    405,
    364,
    328,
    298,
    271,
    496,
    456,
    420,
    388,
    360,
    335,
    312,
    292,
    273,
    512,
    482,
    454,
    428,
    405,
    383,
    364,
    345,
    328,
    312,
    298,
    284,
    271,
    259,
    496,
    475,
    456,
    437,
    420,
    404,
    388,
    374,
    360,
    347,
    335,
    323,
    312,
    302,
    292,
    282,
    273,
    265,
    512,
    497,
    482,
    468,
    454,
    441,
    428,
    417,
    405,
    394,
    383,
    373,
    364,
    354,
    345,
    337,
    328,
    320,
    312,
    305,
    298,
    291,
    284,
    278,
    271,
    265,
    259,
    507,
    496,
    485,
    475,
    465,
    456,
    446,
    437,
    428,
    420,
    412,
    404,
    396,
    388,
    381,
    374,
    367,
    360,
    354,
    347,
    341,
    335,
    329,
    323,
    318,
    312,
    307,
    302,
    297,
    292,
    287,
    282,
    278,
    273,
    269,
    265,
    261,
    512,
    505,
    497,
    489,
    482,
    475,
    468,
    461,
    454,
    447,
    441,
    435,
    428,
    422,
    417,
    411,
    405,
    399,
    394,
    389,
    383,
    378,
    373,
    368,
    364,
    359,
    354,
    350,
    345,
    341,
    337,
    332,
    328,
    324,
    320,
    316,
    312,
    309,
    305,
    301,
    298,
    294,
    291,
    287,
    284,
    281,
    278,
    274,
    271,
    268,
    265,
    262,
    259,
    257,
    507,
    501,
    496,
    491,
    485,
    480,
    475,
    470,
    465,
    460,
    456,
    451,
    446,
    442,
    437,
    433,
    428,
    424,
    420,
    416,
    412,
    408,
    404,
    400,
    396,
    392,
    388,
    385,
    381,
    377,
    374,
    370,
    367,
    363,
    360,
    357,
    354,
    350,
    347,
    344,
    341,
    338,
    335,
    332,
    329,
    326,
    323,
    320,
    318,
    315,
    312,
    310,
    307,
    304,
    302,
    299,
    297,
    294,
    292,
    289,
    287,
    285,
    282,
    280,
    278,
    275,
    273,
    271,
    269,
    267,
    265,
    263,
    261,
    259
];
var shg_table = [
    9,
    11,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24
];
function filterGaussBlurRGBA(imageData, radius) {
    var pixels = imageData.data, width = imageData.width, height = imageData.height;
    var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;
    var div = radius + radius + 1, widthMinus1 = width - 1, heightMinus1 = height - 1, radiusPlus1 = radius + 1, sumFactor = (radiusPlus1 * (radiusPlus1 + 1)) / 2, stackStart = new BlurStack(), stackEnd = null, stack = stackStart, stackIn = null, stackOut = null, mul_sum = mul_table[radius], shg_sum = shg_table[radius];
    for (i = 1; i < div; i++) {
        stack = stack.next = new BlurStack();
        if (i === radiusPlus1) {
            stackEnd = stack;
        }
    }
    stack.next = stackStart;
    yw = yi = 0;
    for (y = 0; y < height; y++) {
        r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for (i = 0; i < radiusPlus1; i++) {
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        for (i = 1; i < radiusPlus1; i++) {
            p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
            r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[p + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
        }
        stackIn = stackStart;
        stackOut = stackEnd;
        for (x = 0; x < width; x++) {
            pixels[yi + 3] = pa = (a_sum * mul_sum) >> shg_sum;
            if (pa !== 0) {
                pa = 255 / pa;
                pixels[yi] = ((r_sum * mul_sum) >> shg_sum) * pa;
                pixels[yi + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
                pixels[yi + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
            }
            else {
                pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
            }
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;
            r_in_sum += stackIn.r = pixels[p];
            g_in_sum += stackIn.g = pixels[p + 1];
            b_in_sum += stackIn.b = pixels[p + 2];
            a_in_sum += stackIn.a = pixels[p + 3];
            r_sum += r_in_sum;
            g_sum += g_in_sum;
            b_sum += b_in_sum;
            a_sum += a_in_sum;
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += 4;
        }
        yw += width;
    }
    for (x = 0; x < width; x++) {
        g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;
        yi = x << 2;
        r_out_sum = radiusPlus1 * (pr = pixels[yi]);
        g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
        b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
        a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);
        r_sum += sumFactor * pr;
        g_sum += sumFactor * pg;
        b_sum += sumFactor * pb;
        a_sum += sumFactor * pa;
        stack = stackStart;
        for (i = 0; i < radiusPlus1; i++) {
            stack.r = pr;
            stack.g = pg;
            stack.b = pb;
            stack.a = pa;
            stack = stack.next;
        }
        yp = width;
        for (i = 1; i <= radius; i++) {
            yi = (yp + x) << 2;
            r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
            g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
            b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
            a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;
            r_in_sum += pr;
            g_in_sum += pg;
            b_in_sum += pb;
            a_in_sum += pa;
            stack = stack.next;
            if (i < heightMinus1) {
                yp += width;
            }
        }
        yi = x;
        stackIn = stackStart;
        stackOut = stackEnd;
        for (y = 0; y < height; y++) {
            p = yi << 2;
            pixels[p + 3] = pa = (a_sum * mul_sum) >> shg_sum;
            if (pa > 0) {
                pa = 255 / pa;
                pixels[p] = ((r_sum * mul_sum) >> shg_sum) * pa;
                pixels[p + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
                pixels[p + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
            }
            else {
                pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
            }
            r_sum -= r_out_sum;
            g_sum -= g_out_sum;
            b_sum -= b_out_sum;
            a_sum -= a_out_sum;
            r_out_sum -= stackIn.r;
            g_out_sum -= stackIn.g;
            b_out_sum -= stackIn.b;
            a_out_sum -= stackIn.a;
            p =
                (x +
                    ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width) <<
                    2;
            r_sum += r_in_sum += stackIn.r = pixels[p];
            g_sum += g_in_sum += stackIn.g = pixels[p + 1];
            b_sum += b_in_sum += stackIn.b = pixels[p + 2];
            a_sum += a_in_sum += stackIn.a = pixels[p + 3];
            stackIn = stackIn.next;
            r_out_sum += pr = stackOut.r;
            g_out_sum += pg = stackOut.g;
            b_out_sum += pb = stackOut.b;
            a_out_sum += pa = stackOut.a;
            r_in_sum -= pr;
            g_in_sum -= pg;
            b_in_sum -= pb;
            a_in_sum -= pa;
            stackOut = stackOut.next;
            yi += width;
        }
    }
}
exports.Blur = function Blur(imageData) {
    var radius = Math.round(this.blurRadius());
    if (radius > 0) {
        filterGaussBlurRGBA(imageData, radius);
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'blurRadius', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
exports.Brighten = function (imageData) {
    var brightness = this.brightness() * 255, data = imageData.data, len = data.length, i;
    for (i = 0; i < len; i += 4) {
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'brightness', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
exports.Contrast = function (imageData) {
    var adjust = Math.pow((this.contrast() + 100) / 100, 2);
    var data = imageData.data, nPixels = data.length, red = 150, green = 150, blue = 150, i;
    for (i = 0; i < nPixels; i += 4) {
        red = data[i];
        green = data[i + 1];
        blue = data[i + 2];
        red /= 255;
        red -= 0.5;
        red *= adjust;
        red += 0.5;
        red *= 255;
        green /= 255;
        green -= 0.5;
        green *= adjust;
        green += 0.5;
        green *= 255;
        blue /= 255;
        blue -= 0.5;
        blue *= adjust;
        blue += 0.5;
        blue *= 255;
        red = red < 0 ? 0 : red > 255 ? 255 : red;
        green = green < 0 ? 0 : green > 255 ? 255 : green;
        blue = blue < 0 ? 0 : blue > 255 ? 255 : blue;
        data[i] = red;
        data[i + 1] = green;
        data[i + 2] = blue;
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'contrast', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Util_1 = __webpack_require__(43);
var Validators_1 = __webpack_require__(41);
exports.Emboss = function (imageData) {
    var strength = this.embossStrength() * 10, greyLevel = this.embossWhiteLevel() * 255, direction = this.embossDirection(), blend = this.embossBlend(), dirY = 0, dirX = 0, data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    switch (direction) {
        case 'top-left':
            dirY = -1;
            dirX = -1;
            break;
        case 'top':
            dirY = -1;
            dirX = 0;
            break;
        case 'top-right':
            dirY = -1;
            dirX = 1;
            break;
        case 'right':
            dirY = 0;
            dirX = 1;
            break;
        case 'bottom-right':
            dirY = 1;
            dirX = 1;
            break;
        case 'bottom':
            dirY = 1;
            dirX = 0;
            break;
        case 'bottom-left':
            dirY = 1;
            dirX = -1;
            break;
        case 'left':
            dirY = 0;
            dirX = -1;
            break;
        default:
            Util_1.Util.error('Unknown emboss direction: ' + direction);
    }
    do {
        var offsetY = (y - 1) * w4;
        var otherY = dirY;
        if (y + otherY < 1) {
            otherY = 0;
        }
        if (y + otherY > h) {
            otherY = 0;
        }
        var offsetYOther = (y - 1 + otherY) * w * 4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var otherX = dirX;
            if (x + otherX < 1) {
                otherX = 0;
            }
            if (x + otherX > w) {
                otherX = 0;
            }
            var offsetOther = offsetYOther + (x - 1 + otherX) * 4;
            var dR = data[offset] - data[offsetOther];
            var dG = data[offset + 1] - data[offsetOther + 1];
            var dB = data[offset + 2] - data[offsetOther + 2];
            var dif = dR;
            var absDif = dif > 0 ? dif : -dif;
            var absG = dG > 0 ? dG : -dG;
            var absB = dB > 0 ? dB : -dB;
            if (absG > absDif) {
                dif = dG;
            }
            if (absB > absDif) {
                dif = dB;
            }
            dif *= strength;
            if (blend) {
                var r = data[offset] + dif;
                var g = data[offset + 1] + dif;
                var b = data[offset + 2] + dif;
                data[offset] = r > 255 ? 255 : r < 0 ? 0 : r;
                data[offset + 1] = g > 255 ? 255 : g < 0 ? 0 : g;
                data[offset + 2] = b > 255 ? 255 : b < 0 ? 0 : b;
            }
            else {
                var grey = greyLevel - dif;
                if (grey < 0) {
                    grey = 0;
                }
                else if (grey > 255) {
                    grey = 255;
                }
                data[offset] = data[offset + 1] = data[offset + 2] = grey;
            }
        } while (--x);
    } while (--y);
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'embossStrength', 0.5, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'embossWhiteLevel', 0.5, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'embossDirection', 'top-left', null, Factory_1.Factory.afterSetFilter);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'embossBlend', false, null, Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
function remap(fromValue, fromMin, fromMax, toMin, toMax) {
    var fromRange = fromMax - fromMin, toRange = toMax - toMin, toValue;
    if (fromRange === 0) {
        return toMin + toRange / 2;
    }
    if (toRange === 0) {
        return toMin;
    }
    toValue = (fromValue - fromMin) / fromRange;
    toValue = toRange * toValue + toMin;
    return toValue;
}
exports.Enhance = function (imageData) {
    var data = imageData.data, nSubPixels = data.length, rMin = data[0], rMax = rMin, r, gMin = data[1], gMax = gMin, g, bMin = data[2], bMax = bMin, b, i;
    var enhanceAmount = this.enhance();
    if (enhanceAmount === 0) {
        return;
    }
    for (i = 0; i < nSubPixels; i += 4) {
        r = data[i + 0];
        if (r < rMin) {
            rMin = r;
        }
        else if (r > rMax) {
            rMax = r;
        }
        g = data[i + 1];
        if (g < gMin) {
            gMin = g;
        }
        else if (g > gMax) {
            gMax = g;
        }
        b = data[i + 2];
        if (b < bMin) {
            bMin = b;
        }
        else if (b > bMax) {
            bMax = b;
        }
    }
    if (rMax === rMin) {
        rMax = 255;
        rMin = 0;
    }
    if (gMax === gMin) {
        gMax = 255;
        gMin = 0;
    }
    if (bMax === bMin) {
        bMax = 255;
        bMin = 0;
    }
    var rMid, rGoalMax, rGoalMin, gMid, gGoalMax, gGoalMin, bMid, bGoalMax, bGoalMin;
    if (enhanceAmount > 0) {
        rGoalMax = rMax + enhanceAmount * (255 - rMax);
        rGoalMin = rMin - enhanceAmount * (rMin - 0);
        gGoalMax = gMax + enhanceAmount * (255 - gMax);
        gGoalMin = gMin - enhanceAmount * (gMin - 0);
        bGoalMax = bMax + enhanceAmount * (255 - bMax);
        bGoalMin = bMin - enhanceAmount * (bMin - 0);
    }
    else {
        rMid = (rMax + rMin) * 0.5;
        rGoalMax = rMax + enhanceAmount * (rMax - rMid);
        rGoalMin = rMin + enhanceAmount * (rMin - rMid);
        gMid = (gMax + gMin) * 0.5;
        gGoalMax = gMax + enhanceAmount * (gMax - gMid);
        gGoalMin = gMin + enhanceAmount * (gMin - gMid);
        bMid = (bMax + bMin) * 0.5;
        bGoalMax = bMax + enhanceAmount * (bMax - bMid);
        bGoalMin = bMin + enhanceAmount * (bMin - bMid);
    }
    for (i = 0; i < nSubPixels; i += 4) {
        data[i + 0] = remap(data[i + 0], rMin, rMax, rGoalMin, rGoalMax);
        data[i + 1] = remap(data[i + 1], gMin, gMax, gGoalMin, gGoalMax);
        data[i + 2] = remap(data[i + 2], bMin, bMax, bGoalMin, bGoalMax);
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'enhance', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Grayscale = function (imageData) {
    var data = imageData.data, len = data.length, i, brightness;
    for (i = 0; i < len; i += 4) {
        brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
        data[i] = brightness;
        data[i + 1] = brightness;
        data[i + 2] = brightness;
    }
};


/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'hue', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'saturation', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'luminance', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
exports.HSL = function (imageData) {
    var data = imageData.data, nPixels = data.length, v = 1, s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, l = this.luminance() * 127, i;
    var vsu = v * s * Math.cos((h * Math.PI) / 180), vsw = v * s * Math.sin((h * Math.PI) / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for (i = 0; i < nPixels; i += 4) {
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b + l;
        data[i + 1] = gr * r + gg * g + gb * b + l;
        data[i + 2] = br * r + bg * g + bb * b + l;
        data[i + 3] = a;
    }
};


/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
exports.HSV = function (imageData) {
    var data = imageData.data, nPixels = data.length, v = Math.pow(2, this.value()), s = Math.pow(2, this.saturation()), h = Math.abs(this.hue() + 360) % 360, i;
    var vsu = v * s * Math.cos((h * Math.PI) / 180), vsw = v * s * Math.sin((h * Math.PI) / 180);
    var rr = 0.299 * v + 0.701 * vsu + 0.167 * vsw, rg = 0.587 * v - 0.587 * vsu + 0.33 * vsw, rb = 0.114 * v - 0.114 * vsu - 0.497 * vsw;
    var gr = 0.299 * v - 0.299 * vsu - 0.328 * vsw, gg = 0.587 * v + 0.413 * vsu + 0.035 * vsw, gb = 0.114 * v - 0.114 * vsu + 0.293 * vsw;
    var br = 0.299 * v - 0.3 * vsu + 1.25 * vsw, bg = 0.587 * v - 0.586 * vsu - 1.05 * vsw, bb = 0.114 * v + 0.886 * vsu - 0.2 * vsw;
    var r, g, b, a;
    for (i = 0; i < nPixels; i += 4) {
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        a = data[i + 3];
        data[i + 0] = rr * r + rg * g + rb * b;
        data[i + 1] = gr * r + gg * g + gb * b;
        data[i + 2] = br * r + bg * g + bb * b;
        data[i + 3] = a;
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'hue', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'saturation', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'value', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Invert = function (imageData) {
    var data = imageData.data, len = data.length, i;
    for (i = 0; i < len; i += 4) {
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
    }
};


/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Util_1 = __webpack_require__(43);
var Validators_1 = __webpack_require__(41);
var ToPolar = function (src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta;
    var conversion = ((360 / tSize) * Math.PI) / 180, sin, cos;
    for (theta = 0; theta < tSize; theta += 1) {
        sin = Math.sin(theta * conversion);
        cos = Math.cos(theta * conversion);
        for (radius = 0; radius < rSize; radius += 1) {
            x = Math.floor(xMid + ((rMax * radius) / rSize) * cos);
            y = Math.floor(yMid + ((rMax * radius) / rSize) * sin);
            i = (y * xSize + x) * 4;
            r = srcPixels[i + 0];
            g = srcPixels[i + 1];
            b = srcPixels[i + 2];
            a = srcPixels[i + 3];
            i = (theta + radius * xSize) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
var FromPolar = function (src, dst, opt) {
    var srcPixels = src.data, dstPixels = dst.data, xSize = src.width, ySize = src.height, xMid = opt.polarCenterX || xSize / 2, yMid = opt.polarCenterY || ySize / 2, i, x, y, dx, dy, r = 0, g = 0, b = 0, a = 0;
    var rad, rMax = Math.sqrt(xMid * xMid + yMid * yMid);
    x = xSize - xMid;
    y = ySize - yMid;
    rad = Math.sqrt(x * x + y * y);
    rMax = rad > rMax ? rad : rMax;
    var rSize = ySize, tSize = xSize, radius, theta, phaseShift = opt.polarRotation || 0;
    var x1, y1;
    for (x = 0; x < xSize; x += 1) {
        for (y = 0; y < ySize; y += 1) {
            dx = x - xMid;
            dy = y - yMid;
            radius = (Math.sqrt(dx * dx + dy * dy) * rSize) / rMax;
            theta = ((Math.atan2(dy, dx) * 180) / Math.PI + 360 + phaseShift) % 360;
            theta = (theta * tSize) / 360;
            x1 = Math.floor(theta);
            y1 = Math.floor(radius);
            i = (y1 * xSize + x1) * 4;
            r = srcPixels[i + 0];
            g = srcPixels[i + 1];
            b = srcPixels[i + 2];
            a = srcPixels[i + 3];
            i = (y * xSize + x) * 4;
            dstPixels[i + 0] = r;
            dstPixels[i + 1] = g;
            dstPixels[i + 2] = b;
            dstPixels[i + 3] = a;
        }
    }
};
exports.Kaleidoscope = function (imageData) {
    var xSize = imageData.width, ySize = imageData.height;
    var x, y, xoff, i, r, g, b, a, srcPos, dstPos;
    var power = Math.round(this.kaleidoscopePower());
    var angle = Math.round(this.kaleidoscopeAngle());
    var offset = Math.floor((xSize * (angle % 360)) / 360);
    if (power < 1) {
        return;
    }
    var tempCanvas = Util_1.Util.createCanvasElement();
    tempCanvas.width = xSize;
    tempCanvas.height = ySize;
    var scratchData = tempCanvas
        .getContext('2d')
        .getImageData(0, 0, xSize, ySize);
    ToPolar(imageData, scratchData, {
        polarCenterX: xSize / 2,
        polarCenterY: ySize / 2
    });
    var minSectionSize = xSize / Math.pow(2, power);
    while (minSectionSize <= 8) {
        minSectionSize = minSectionSize * 2;
        power -= 1;
    }
    minSectionSize = Math.ceil(minSectionSize);
    var sectionSize = minSectionSize;
    var xStart = 0, xEnd = sectionSize, xDelta = 1;
    if (offset + minSectionSize > xSize) {
        xStart = sectionSize;
        xEnd = 0;
        xDelta = -1;
    }
    for (y = 0; y < ySize; y += 1) {
        for (x = xStart; x !== xEnd; x += xDelta) {
            xoff = Math.round(x + offset) % xSize;
            srcPos = (xSize * y + xoff) * 4;
            r = scratchData.data[srcPos + 0];
            g = scratchData.data[srcPos + 1];
            b = scratchData.data[srcPos + 2];
            a = scratchData.data[srcPos + 3];
            dstPos = (xSize * y + x) * 4;
            scratchData.data[dstPos + 0] = r;
            scratchData.data[dstPos + 1] = g;
            scratchData.data[dstPos + 2] = b;
            scratchData.data[dstPos + 3] = a;
        }
    }
    for (y = 0; y < ySize; y += 1) {
        sectionSize = Math.floor(minSectionSize);
        for (i = 0; i < power; i += 1) {
            for (x = 0; x < sectionSize + 1; x += 1) {
                srcPos = (xSize * y + x) * 4;
                r = scratchData.data[srcPos + 0];
                g = scratchData.data[srcPos + 1];
                b = scratchData.data[srcPos + 2];
                a = scratchData.data[srcPos + 3];
                dstPos = (xSize * y + sectionSize * 2 - x - 1) * 4;
                scratchData.data[dstPos + 0] = r;
                scratchData.data[dstPos + 1] = g;
                scratchData.data[dstPos + 2] = b;
                scratchData.data[dstPos + 3] = a;
            }
            sectionSize *= 2;
        }
    }
    FromPolar(scratchData, imageData, { polarRotation: 0 });
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'kaleidoscopePower', 2, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'kaleidoscopeAngle', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
function pixelAt(idata, x, y) {
    var idx = (y * idata.width + x) * 4;
    var d = [];
    d.push(idata.data[idx++], idata.data[idx++], idata.data[idx++], idata.data[idx++]);
    return d;
}
function rgbDistance(p1, p2) {
    return Math.sqrt(Math.pow(p1[0] - p2[0], 2) +
        Math.pow(p1[1] - p2[1], 2) +
        Math.pow(p1[2] - p2[2], 2));
}
function rgbMean(pTab) {
    var m = [0, 0, 0];
    for (var i = 0; i < pTab.length; i++) {
        m[0] += pTab[i][0];
        m[1] += pTab[i][1];
        m[2] += pTab[i][2];
    }
    m[0] /= pTab.length;
    m[1] /= pTab.length;
    m[2] /= pTab.length;
    return m;
}
function backgroundMask(idata, threshold) {
    var rgbv_no = pixelAt(idata, 0, 0);
    var rgbv_ne = pixelAt(idata, idata.width - 1, 0);
    var rgbv_so = pixelAt(idata, 0, idata.height - 1);
    var rgbv_se = pixelAt(idata, idata.width - 1, idata.height - 1);
    var thres = threshold || 10;
    if (rgbDistance(rgbv_no, rgbv_ne) < thres &&
        rgbDistance(rgbv_ne, rgbv_se) < thres &&
        rgbDistance(rgbv_se, rgbv_so) < thres &&
        rgbDistance(rgbv_so, rgbv_no) < thres) {
        var mean = rgbMean([rgbv_ne, rgbv_no, rgbv_se, rgbv_so]);
        var mask = [];
        for (var i = 0; i < idata.width * idata.height; i++) {
            var d = rgbDistance(mean, [
                idata.data[i * 4],
                idata.data[i * 4 + 1],
                idata.data[i * 4 + 2]
            ]);
            mask[i] = d < thres ? 0 : 255;
        }
        return mask;
    }
}
function applyMask(idata, mask) {
    for (var i = 0; i < idata.width * idata.height; i++) {
        idata.data[4 * i + 3] = mask[i];
    }
}
function erodeMask(mask, sw, sh) {
    var weights = [1, 1, 1, 1, 0, 1, 1, 1, 1];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for (var y = 0; y < sh; y++) {
        for (var x = 0; x < sw; x++) {
            var so = y * sw + x;
            var a = 0;
            for (var cy = 0; cy < side; cy++) {
                for (var cx = 0; cx < side; cx++) {
                    var scy = y + cy - halfSide;
                    var scx = x + cx - halfSide;
                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                        var srcOff = scy * sw + scx;
                        var wt = weights[cy * side + cx];
                        a += mask[srcOff] * wt;
                    }
                }
            }
            maskResult[so] = a === 255 * 8 ? 255 : 0;
        }
    }
    return maskResult;
}
function dilateMask(mask, sw, sh) {
    var weights = [1, 1, 1, 1, 1, 1, 1, 1, 1];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for (var y = 0; y < sh; y++) {
        for (var x = 0; x < sw; x++) {
            var so = y * sw + x;
            var a = 0;
            for (var cy = 0; cy < side; cy++) {
                for (var cx = 0; cx < side; cx++) {
                    var scy = y + cy - halfSide;
                    var scx = x + cx - halfSide;
                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                        var srcOff = scy * sw + scx;
                        var wt = weights[cy * side + cx];
                        a += mask[srcOff] * wt;
                    }
                }
            }
            maskResult[so] = a >= 255 * 4 ? 255 : 0;
        }
    }
    return maskResult;
}
function smoothEdgeMask(mask, sw, sh) {
    var weights = [1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9, 1 / 9];
    var side = Math.round(Math.sqrt(weights.length));
    var halfSide = Math.floor(side / 2);
    var maskResult = [];
    for (var y = 0; y < sh; y++) {
        for (var x = 0; x < sw; x++) {
            var so = y * sw + x;
            var a = 0;
            for (var cy = 0; cy < side; cy++) {
                for (var cx = 0; cx < side; cx++) {
                    var scy = y + cy - halfSide;
                    var scx = x + cx - halfSide;
                    if (scy >= 0 && scy < sh && scx >= 0 && scx < sw) {
                        var srcOff = scy * sw + scx;
                        var wt = weights[cy * side + cx];
                        a += mask[srcOff] * wt;
                    }
                }
            }
            maskResult[so] = a;
        }
    }
    return maskResult;
}
exports.Mask = function (imageData) {
    var threshold = this.threshold(), mask = backgroundMask(imageData, threshold);
    if (mask) {
        mask = erodeMask(mask, imageData.width, imageData.height);
        mask = dilateMask(mask, imageData.width, imageData.height);
        mask = smoothEdgeMask(mask, imageData.width, imageData.height);
        applyMask(imageData, mask);
    }
    return imageData;
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'threshold', 0, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
exports.Noise = function (imageData) {
    var amount = this.noise() * 255, data = imageData.data, nPixels = data.length, half = amount / 2, i;
    for (i = 0; i < nPixels; i += 4) {
        data[i + 0] += half - 2 * half * Math.random();
        data[i + 1] += half - 2 * half * Math.random();
        data[i + 2] += half - 2 * half * Math.random();
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'noise', 0.2, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Util_1 = __webpack_require__(43);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
exports.Pixelate = function (imageData) {
    var pixelSize = Math.ceil(this.pixelSize()), width = imageData.width, height = imageData.height, x, y, i, red, green, blue, alpha, nBinsX = Math.ceil(width / pixelSize), nBinsY = Math.ceil(height / pixelSize), xBinStart, xBinEnd, yBinStart, yBinEnd, xBin, yBin, pixelsInBin, data = imageData.data;
    if (pixelSize <= 0) {
        Util_1.Util.error('pixelSize value can not be <= 0');
        return;
    }
    for (xBin = 0; xBin < nBinsX; xBin += 1) {
        for (yBin = 0; yBin < nBinsY; yBin += 1) {
            red = 0;
            green = 0;
            blue = 0;
            alpha = 0;
            xBinStart = xBin * pixelSize;
            xBinEnd = xBinStart + pixelSize;
            yBinStart = yBin * pixelSize;
            yBinEnd = yBinStart + pixelSize;
            pixelsInBin = 0;
            for (x = xBinStart; x < xBinEnd; x += 1) {
                if (x >= width) {
                    continue;
                }
                for (y = yBinStart; y < yBinEnd; y += 1) {
                    if (y >= height) {
                        continue;
                    }
                    i = (width * y + x) * 4;
                    red += data[i + 0];
                    green += data[i + 1];
                    blue += data[i + 2];
                    alpha += data[i + 3];
                    pixelsInBin += 1;
                }
            }
            red = red / pixelsInBin;
            green = green / pixelsInBin;
            blue = blue / pixelsInBin;
            alpha = alpha / pixelsInBin;
            for (x = xBinStart; x < xBinEnd; x += 1) {
                if (x >= width) {
                    continue;
                }
                for (y = yBinStart; y < yBinEnd; y += 1) {
                    if (y >= height) {
                        continue;
                    }
                    i = (width * y + x) * 4;
                    data[i + 0] = red;
                    data[i + 1] = green;
                    data[i + 2] = blue;
                    data[i + 3] = alpha;
                }
            }
        }
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'pixelSize', 8, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
exports.Posterize = function (imageData) {
    var levels = Math.round(this.levels() * 254) + 1, data = imageData.data, len = data.length, scale = 255 / levels, i;
    for (i = 0; i < len; i += 1) {
        data[i] = Math.floor(data[i] / scale) * scale;
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'levels', 0.5, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
exports.RGB = function (imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), i, brightness;
    for (i = 0; i < nPixels; i += 4) {
        brightness =
            (0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2]) / 255;
        data[i] = brightness * red;
        data[i + 1] = brightness * green;
        data[i + 2] = brightness * blue;
        data[i + 3] = data[i + 3];
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'red', 0, function (val) {
    this._filterUpToDate = false;
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return Math.round(val);
    }
});
Factory_1.Factory.addGetterSetter(Node_1.Node, 'green', 0, function (val) {
    this._filterUpToDate = false;
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return Math.round(val);
    }
});
Factory_1.Factory.addGetterSetter(Node_1.Node, 'blue', 0, Validators_1.RGBComponent, Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
exports.RGBA = function (imageData) {
    var data = imageData.data, nPixels = data.length, red = this.red(), green = this.green(), blue = this.blue(), alpha = this.alpha(), i, ia;
    for (i = 0; i < nPixels; i += 4) {
        ia = 1 - alpha;
        data[i] = red * alpha + data[i] * ia;
        data[i + 1] = green * alpha + data[i + 1] * ia;
        data[i + 2] = blue * alpha + data[i + 2] * ia;
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'red', 0, function (val) {
    this._filterUpToDate = false;
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return Math.round(val);
    }
});
Factory_1.Factory.addGetterSetter(Node_1.Node, 'green', 0, function (val) {
    this._filterUpToDate = false;
    if (val > 255) {
        return 255;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return Math.round(val);
    }
});
Factory_1.Factory.addGetterSetter(Node_1.Node, 'blue', 0, Validators_1.RGBComponent, Factory_1.Factory.afterSetFilter);
Factory_1.Factory.addGetterSetter(Node_1.Node, 'alpha', 1, function (val) {
    this._filterUpToDate = false;
    if (val > 1) {
        return 1;
    }
    else if (val < 0) {
        return 0;
    }
    else {
        return val;
    }
});


/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Sepia = function (imageData) {
    var data = imageData.data, nPixels = data.length, i, r, g, b;
    for (i = 0; i < nPixels; i += 4) {
        r = data[i + 0];
        g = data[i + 1];
        b = data[i + 2];
        data[i + 0] = Math.min(255, r * 0.393 + g * 0.769 + b * 0.189);
        data[i + 1] = Math.min(255, r * 0.349 + g * 0.686 + b * 0.168);
        data[i + 2] = Math.min(255, r * 0.272 + g * 0.534 + b * 0.131);
    }
};


/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Solarize = function (imageData) {
    var data = imageData.data, w = imageData.width, h = imageData.height, w4 = w * 4, y = h;
    do {
        var offsetY = (y - 1) * w4;
        var x = w;
        do {
            var offset = offsetY + (x - 1) * 4;
            var r = data[offset];
            var g = data[offset + 1];
            var b = data[offset + 2];
            if (r > 127) {
                r = 255 - r;
            }
            if (g > 127) {
                g = 255 - g;
            }
            if (b > 127) {
                b = 255 - b;
            }
            data[offset] = r;
            data[offset + 1] = g;
            data[offset + 2] = b;
        } while (--x);
    } while (--y);
};


/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Factory_1 = __webpack_require__(37);
var Node_1 = __webpack_require__(60);
var Validators_1 = __webpack_require__(41);
exports.Threshold = function (imageData) {
    var level = this.threshold() * 255, data = imageData.data, len = data.length, i;
    for (i = 0; i < len; i += 1) {
        data[i] = data[i] < level ? 0 : 255;
    }
};
Factory_1.Factory.addGetterSetter(Node_1.Node, 'threshold', 0.5, Validators_1.getNumberValidator(), Factory_1.Factory.afterSetFilter);


/***/ }),
/* 2577 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array ? array.length : 0;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = chunk;


/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

// This file replaces `index.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.

if (false) {
  // All bundlers will remove this block in production bundle
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    throw new Error(
      'React Native does not have a built-in secure random generator. ' +
      'If you don’t need unpredictable IDs, you can use `nanoid/non-secure`. ' +
      'For secure ID install `expo-random` locally and use `nanoid/async`.'
    )
  }
  if (typeof self === 'undefined' || (!self.crypto && !self.msCrypto)) {
    throw new Error(
      'Your browser does not have secure random generator. ' +
      'If you don’t need unpredictable IDs, you can use nanoid/non-secure.'
    )
  }
}

var crypto = self.crypto || self.msCrypto

// This alphabet uses a-z A-Z 0-9 _- symbols.
// Symbols are generated for smaller size.
// -_zyxwvutsrqponmlkjihgfedcba9876543210ZYXWVUTSRQPONMLKJIHGFEDCBA
var url = '-_'
// Loop from 36 to 0 (from z to a and 9 to 0 in Base36).
var i = 36
while (i--) {
  // 36 is radix. Number.prototype.toString(36) returns number
  // in Base36 representation. Base36 is like hex, but it uses 0–9 and a-z.
  url += i.toString(36)
}
// Loop from 36 to 10 (from Z to A in Base36).
i = 36
while (i-- - 10) {
  url += i.toString(36).toUpperCase()
}

module.exports = function (size) {
  var id = ''
  var bytes = crypto.getRandomValues(new Uint8Array(size || 21))
  i = size || 21

  // Compact alternative for `for (var i = 0; i < size; i++)`
  while (i--) {
    // We can’t use bytes bigger than the alphabet. 63 is 00111111 bitmask.
    // This mask reduces random byte 0-255 to 0-63 values.
    // There is no need in `|| ''` and `* 1.6` hacks in here,
    // because bitmask trim bytes exact to alphabet size.
    id += url[bytes[i] & 63]
  }
  return id
}


/***/ }),
/* 2579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useSingleton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tippy_js__ = __webpack_require__(1137);
/* unused harmony reexport tippy */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);





function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
function preserveRef(ref, node) {
  if (ref) {
    if (typeof ref === 'function') {
      ref(node);
    }

    if ({}.hasOwnProperty.call(ref, 'current')) {
      ref.current = node;
    }
  }
}
function ssrSafeCreateDiv() {
  return isBrowser && document.createElement('div');
}
function toDataAttributes(attrs) {
  var dataAttrs = {
    'data-placement': attrs.placement
  };

  if (attrs.referenceHidden) {
    dataAttrs['data-reference-hidden'] = '';
  }

  if (attrs.escaped) {
    dataAttrs['data-escaped'] = '';
  }

  return dataAttrs;
}
function deepPreserveProps(instanceProps, componentProps) {
  var _instanceProps$popper, _componentProps$poppe;

  return Object.assign({}, componentProps, {
    popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
      modifiers: [].concat((((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || []).filter(function (modifier) {
        return modifier.name.indexOf('tippy') >= 0;
      }), ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || [])
    })
  });
}

var useIsomorphicLayoutEffect = isBrowser ? __WEBPACK_IMPORTED_MODULE_1_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_1_react__["useEffect"];
function useMutableBox(initialValue) {
  // Using refs instead of state as it's recommended to not store imperative
  // values in state due to memory problems in React(?)
  var ref = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useRef"])();

  if (!ref.current) {
    ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
  }

  return ref.current;
}

function updateClassName(box, action, classNames) {
  classNames.split(/\s+/).forEach(function (name) {
    if (name) {
      box.classList[action](name);
    }
  });
}

var classNamePlugin = {
  name: 'className',
  defaultValue: '',
  fn: function fn(instance) {
    var box = instance.popper.firstElementChild;

    var isDefaultRenderFn = function isDefaultRenderFn() {
      var _instance$props$rende;

      return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
    };

    function add() {
      if (instance.props.className && !isDefaultRenderFn()) {
        if (false) {
          console.warn(['@tippyjs/react: Cannot use `className` prop in conjunction with', '`render` prop. Place the className on the element you are', 'rendering.'].join(' '));
        }

        return;
      }

      updateClassName(box, 'add', instance.props.className);
    }

    function remove() {
      if (isDefaultRenderFn()) {
        updateClassName(box, 'remove', instance.props.className);
      }
    }

    return {
      onCreate: add,
      onBeforeUpdate: remove,
      onAfterUpdate: add
    };
  }
};

function TippyGenerator(tippy) {
  function Tippy(_ref) {
    var children = _ref.children,
        content = _ref.content,
        visible = _ref.visible,
        singleton = _ref.singleton,
        render = _ref.render,
        reference = _ref.reference,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$ignoreAttributes = _ref.ignoreAttributes,
        ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes,
        __source = _ref.__source,
        __self = _ref.__self,
        restOfNativeProps = _objectWithoutPropertiesLoose(_ref, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]);

    var isControlledMode = visible !== undefined;
    var isSingletonMode = singleton !== undefined;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        mounted = _useState[0],
        setMounted = _useState[1];

    var _useState2 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}),
        attrs = _useState2[0],
        setAttrs = _useState2[1];

    var _useState3 = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(),
        singletonContent = _useState3[0],
        setSingletonContent = _useState3[1];

    var mutableBox = useMutableBox(function () {
      return {
        container: ssrSafeCreateDiv(),
        renders: 1
      };
    });
    var props = Object.assign({
      ignoreAttributes: ignoreAttributes
    }, restOfNativeProps, {
      content: mutableBox.container
    });

    if (isControlledMode) {
      if (false) {
        ['trigger', 'hideOnClick', 'showOnCreate'].forEach(function (nativeStateProp) {
          if (props[nativeStateProp] !== undefined) {
            console.warn(["@tippyjs/react: Cannot specify `" + nativeStateProp + "` prop in", "controlled mode (`visible` prop)"].join(' '));
          }
        });
      }

      props.trigger = 'manual';
      props.hideOnClick = false;
    }

    if (isSingletonMode) {
      disabled = true;
    }

    var computedProps = props;
    var plugins = props.plugins || [];

    if (render) {
      computedProps = Object.assign({}, props, {
        plugins: isSingletonMode ? [].concat(plugins, [{
          fn: function fn() {
            return {
              onTrigger: function onTrigger(_, event) {
                var _singleton$data$child = singleton.data.children.find(function (_ref2) {
                  var instance = _ref2.instance;
                  return instance.reference === event.currentTarget;
                }),
                    content = _singleton$data$child.content;

                setSingletonContent(content);
              }
            };
          }
        }]) : plugins,
        render: function render() {
          return {
            popper: mutableBox.container
          };
        }
      });
    }

    var deps = [reference].concat(children ? [children.type] : []); // CREATE

    useIsomorphicLayoutEffect(function () {
      var element = reference;

      if (reference && reference.hasOwnProperty('current')) {
        element = reference.current;
      }

      var instance = tippy(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
        plugins: [classNamePlugin].concat(props.plugins || [])
      }));
      mutableBox.instance = instance;

      if (disabled) {
        instance.disable();
      }

      if (visible) {
        instance.show();
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps
        });
      }

      setMounted(true);
      return function () {
        instance.destroy();
        singleton == null ? void 0 : singleton.cleanup(instance);
      };
    }, deps); // UPDATE

    useIsomorphicLayoutEffect(function () {
      // Prevent this effect from running on 1st render
      if (mutableBox.renders === 1) {
        mutableBox.renders++;
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps(deepPreserveProps(instance.props, computedProps));

      if (disabled) {
        instance.disable();
      } else {
        instance.enable();
      }

      if (isControlledMode) {
        if (visible) {
          instance.show();
        } else {
          instance.hide();
        }
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps
        });
      }
    });
    useIsomorphicLayoutEffect(function () {
      var _instance$props$poppe;

      if (!render) {
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps({
        popperOptions: Object.assign({}, instance.props.popperOptions, {
          modifiers: [].concat(((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || [], [{
            name: '$$tippyReact',
            enabled: true,
            phase: 'beforeWrite',
            requires: ['computeStyles'],
            fn: function fn(_ref3) {
              var _state$modifiersData;

              var state = _ref3.state;
              var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
              // loop. This expression _must_ evaluate to false when required

              if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) {
                setAttrs({
                  placement: state.placement,
                  referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                  escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                });
              }

              state.attributes.popper = {};
            }
          }])
        })
      });
    }, [attrs.placement, attrs.referenceHidden, attrs.escaped].concat(deps));
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, children ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(children, {
      ref: function ref(node) {
        mutableBox.ref = node;
        preserveRef(children.ref, node);
      }
    }) : null, mounted && /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(render ? render(toDataAttributes(attrs), singletonContent) : content, mutableBox.container));
  }

  return Tippy;
}

function useSingletonGenerator(createSingleton) {
  return function useSingleton(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$overrides = _ref.overrides,
        overrides = _ref$overrides === void 0 ? [] : _ref$overrides;

    var _useState = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),
        mounted = _useState[0],
        setMounted = _useState[1];

    var mutableBox = useMutableBox({
      children: [],
      renders: 1
    });
    useIsomorphicLayoutEffect(function () {
      if (!mounted) {
        setMounted(true);
        return;
      }

      var children = mutableBox.children,
          sourceData = mutableBox.sourceData;

      if (!sourceData) {
        if (false) {
          console.error(['@tippyjs/react: The `source` variable from `useSingleton()` has', 'not been passed to a <Tippy /> component.'].join(' '));
        }

        return;
      }

      var instance = createSingleton(children.map(function (child) {
        return child.instance;
      }), Object.assign({}, sourceData.props, {
        popperOptions: sourceData.instance.props.popperOptions,
        overrides: overrides,
        plugins: [classNamePlugin].concat(sourceData.props.plugins || [])
      }));
      mutableBox.instance = instance;

      if (disabled) {
        instance.disable();
      }

      return function () {
        instance.destroy();
        mutableBox.children = children.filter(function (_ref2) {
          var instance = _ref2.instance;
          return !instance.state.isDestroyed;
        });
      };
    }, [mounted]);
    useIsomorphicLayoutEffect(function () {
      if (!mounted) {
        return;
      }

      if (mutableBox.renders === 1) {
        mutableBox.renders++;
        return;
      }

      var children = mutableBox.children,
          instance = mutableBox.instance,
          sourceData = mutableBox.sourceData;

      if (!(instance && sourceData)) {
        return;
      }

      var _sourceData$props = sourceData.props,
          content = _sourceData$props.content,
          props = _objectWithoutPropertiesLoose(_sourceData$props, ["content"]);

      instance.setProps(deepPreserveProps(instance, Object.assign({}, props, {
        overrides: overrides
      })));
      instance.setInstances(children.map(function (child) {
        return child.instance;
      }));

      if (disabled) {
        instance.disable();
      } else {
        instance.enable();
      }
    });
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function () {
      var source = {
        data: mutableBox,
        hook: function hook(data) {
          mutableBox.sourceData = data;
        },
        cleanup: function cleanup() {
          mutableBox.sourceData = null;
        }
      };
      var target = {
        hook: function hook(data) {
          if (!mutableBox.children.find(function (_ref3) {
            var instance = _ref3.instance;
            return data.instance === instance;
          })) {
            mutableBox.children.push(data);
          }
        },
        cleanup: function cleanup(instance) {
          mutableBox.children = mutableBox.children.filter(function (data) {
            return data.instance !== instance;
          });
        }
      };
      return [source, target];
    }, []);
  };
}

var forwardRef = (function (Tippy, defaultProps) {
  return /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(function TippyWrapper(_ref, _ref2) {
    var children = _ref.children,
        props = _objectWithoutPropertiesLoose(_ref, ["children"]);

    return (
      /*#__PURE__*/
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(children, {
        ref: function ref(node) {
          preserveRef(_ref2, node);
          preserveRef(children.ref, node);
        }
      }) : null)
    );
  });
});

var useSingleton = /*#__PURE__*/useSingletonGenerator(__WEBPACK_IMPORTED_MODULE_0_tippy_js__["a" /* createSingleton */]);
var index = /*#__PURE__*/forwardRef( /*#__PURE__*/TippyGenerator(__WEBPACK_IMPORTED_MODULE_0_tippy_js__["b" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (index);

//# sourceMappingURL=tippy-react.esm.js.map


/***/ }),
/* 2580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(82);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_index_js__ = __webpack_require__(1138);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__modifiers_index_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPopper_js__ = __webpack_require__(681);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */
/* unused harmony reexport createPopperBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popper_js__ = __webpack_require__(2599);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__popper_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popper_lite_js__ = __webpack_require__(1152);
/* unused harmony reexport createPopperLite */

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 2581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTableElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNodeName_js__ = __webpack_require__(224);

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_0__getNodeName_js__["a" /* default */])(element)) >= 0;
}

/***/ }),
/* 2582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOppositePlacement;
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),
/* 2583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOppositeVariationPlacement;
var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),
/* 2584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getClippingRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getViewportRect_js__ = __webpack_require__(2585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDocumentRect_js__ = __webpack_require__(2586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listScrollParents_js__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getOffsetParent_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getComputedStyle_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__instanceOf_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getBoundingClientRect_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getParentNode_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contains_js__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getNodeName_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_math_js__ = __webpack_require__(225);















function getInnerBoundingClientRect(element) {
  var rect = Object(__WEBPACK_IMPORTED_MODULE_8__getBoundingClientRect_js__["a" /* default */])(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === __WEBPACK_IMPORTED_MODULE_0__enums_js__["o" /* viewport */] ? Object(__WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getViewportRect_js__["a" /* default */])(element)) : Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clippingParent) ? getInnerBoundingClientRect(clippingParent) : Object(__WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__getDocumentRect_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__["a" /* default */])(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = Object(__WEBPACK_IMPORTED_MODULE_3__listScrollParents_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__getParentNode_js__["a" /* default */])(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_6__getComputedStyle_js__["a" /* default */])(element).position) >= 0;
  var clipperElement = canEscapeClipping && Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["b" /* isHTMLElement */])(element) ? Object(__WEBPACK_IMPORTED_MODULE_4__getOffsetParent_js__["a" /* default */])(element) : element;

  if (!Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return Object(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clippingParent) && Object(__WEBPACK_IMPORTED_MODULE_10__contains_js__["a" /* default */])(clippingParent, clipperElement) && Object(__WEBPACK_IMPORTED_MODULE_11__getNodeName_js__["a" /* default */])(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["a" /* max */])(rect.top, accRect.top);
    accRect.right = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["b" /* min */])(rect.right, accRect.right);
    accRect.bottom = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["b" /* min */])(rect.bottom, accRect.bottom);
    accRect.left = Object(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["a" /* max */])(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

/***/ }),
/* 2585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getViewportRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__ = __webpack_require__(677);



function getViewportRect(element) {
  var win = Object(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element);
  var html = Object(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + Object(__WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__["a" /* default */])(element),
    y: y
  };
}

/***/ }),
/* 2586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getDocumentElement_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getComputedStyle_js__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getWindowScroll_js__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math_js__ = __webpack_require__(225);




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = Object(__WEBPACK_IMPORTED_MODULE_0__getDocumentElement_js__["a" /* default */])(element);
  var winScroll = Object(__WEBPACK_IMPORTED_MODULE_3__getWindowScroll_js__["a" /* default */])(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = Object(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["a" /* max */])(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = Object(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["a" /* max */])(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + Object(__WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__["a" /* default */])(element);
  var y = -winScroll.scrollTop;

  if (Object(__WEBPACK_IMPORTED_MODULE_1__getComputedStyle_js__["a" /* default */])(body || html).direction === 'rtl') {
    x += Object(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["a" /* max */])(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

/***/ }),
/* 2587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getParentNode_js__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isScrollParent_js__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNodeName_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(95);




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(Object(__WEBPACK_IMPORTED_MODULE_2__getNodeName_js__["a" /* default */])(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(node) && Object(__WEBPACK_IMPORTED_MODULE_1__isScrollParent_js__["a" /* default */])(node)) {
    return node;
  }

  return getScrollParent(Object(__WEBPACK_IMPORTED_MODULE_0__getParentNode_js__["a" /* default */])(node));
}

/***/ }),
/* 2588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeAutoPlacement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getVariation_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detectOverflow_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getBasePlacement_js__ = __webpack_require__(182);




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? __WEBPACK_IMPORTED_MODULE_1__enums_js__["h" /* placements */] : _options$allowedAutoP;
  var variation = Object(__WEBPACK_IMPORTED_MODULE_0__getVariation_js__["a" /* default */])(placement);
  var placements = variation ? flipVariations ? __WEBPACK_IMPORTED_MODULE_1__enums_js__["n" /* variationPlacements */] : __WEBPACK_IMPORTED_MODULE_1__enums_js__["n" /* variationPlacements */].filter(function (placement) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getVariation_js__["a" /* default */])(placement) === variation;
  }) : __WEBPACK_IMPORTED_MODULE_1__enums_js__["b" /* basePlacements */];
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = Object(__WEBPACK_IMPORTED_MODULE_2__detectOverflow_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[Object(__WEBPACK_IMPORTED_MODULE_3__getBasePlacement_js__["a" /* default */])(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

/***/ }),
/* 2589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAltAxis;
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

/***/ }),
/* 2590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCompositeRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNodeScroll_js__ = __webpack_require__(2591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNodeName_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getWindowScrollBarX_js__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isScrollParent_js__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math_js__ = __webpack_require__(225);









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(rect.width) / element.offsetWidth || 1;
  var scaleY = Object(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["c" /* round */])(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent);
  var offsetParentIsScaled = Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent) && isElementScaled(offsetParent);
  var documentElement = Object(__WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__["a" /* default */])(offsetParent);
  var rect = Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__getNodeName_js__["a" /* default */])(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    Object(__WEBPACK_IMPORTED_MODULE_6__isScrollParent_js__["a" /* default */])(documentElement)) {
      scroll = Object(__WEBPACK_IMPORTED_MODULE_1__getNodeScroll_js__["a" /* default */])(offsetParent);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent)) {
      offsets = Object(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = Object(__WEBPACK_IMPORTED_MODULE_4__getWindowScrollBarX_js__["a" /* default */])(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

/***/ }),
/* 2591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindowScroll_js__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getWindow_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instanceOf_js__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getHTMLElementScroll_js__ = __webpack_require__(2592);




function getNodeScroll(node) {
  if (node === Object(__WEBPACK_IMPORTED_MODULE_1__getWindow_js__["a" /* default */])(node) || !Object(__WEBPACK_IMPORTED_MODULE_2__instanceOf_js__["b" /* isHTMLElement */])(node)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getWindowScroll_js__["a" /* default */])(node);
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_3__getHTMLElementScroll_js__["a" /* default */])(node);
  }
}

/***/ }),
/* 2592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHTMLElementScroll;
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

/***/ }),
/* 2593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = orderModifiers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(82);
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return __WEBPACK_IMPORTED_MODULE_0__enums_js__["g" /* modifierPhases */].reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

/***/ }),
/* 2594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

/***/ }),
/* 2595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__format_js__ = __webpack_require__(2596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(82);


var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (__WEBPACK_IMPORTED_MODULE_1__enums_js__["g" /* modifierPhases */].indexOf(modifier.phase) < 0) {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + __WEBPACK_IMPORTED_MODULE_1__enums_js__["g" /* modifierPhases */].join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(Object(__WEBPACK_IMPORTED_MODULE_0__format_js__["a" /* default */])(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

/***/ }),
/* 2596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = format;
function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

/***/ }),
/* 2597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

/***/ }),
/* 2598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeByName;
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

/***/ }),
/* 2599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPopper; });
/* unused harmony export defaultModifiers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPopper_js__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modifiers_offset_js__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modifiers_flip_js__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modifiers_preventOverflow_js__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modifiers_arrow_js__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modifiers_hide_js__ = __webpack_require__(1149);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__popper_lite_js__ = __webpack_require__(1152);
/* unused harmony reexport createPopperLite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modifiers_index_js__ = __webpack_require__(1138);
/* unused harmony namespace reexport */










var defaultModifiers = [__WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modifiers_offset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modifiers_flip_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modifiers_preventOverflow_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__modifiers_arrow_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__modifiers_hide_js__["a" /* default */]];
var createPopper = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_0__createPopper_js__["a" /* popperGenerator */])({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 2600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useCallback; });
/* unused harmony export useCallbackOne */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useMemo; });
/* unused harmony export useMemoOne */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function areInputsEqual(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne(getResult, inputs) {
  var initial = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(true);
  var committed = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne(function () {
    return callback;
  }, inputs);
}
var useMemo = useMemoOne;
var useCallback = useCallbackOne;




/***/ }),
/* 2601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __DO_NOT_USE__ActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bindActionCreators; });
/* unused harmony export combineReducers */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createStore; });
/* unused harmony export legacy_createStore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(2602);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = createStore;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}




/***/ }),
/* 2602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(55);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

/***/ }),
/* 2603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exports__ = __webpack_require__(2604);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__exports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__exports__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_reactBatchedUpdates__ = __webpack_require__(2618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_batch__ = __webpack_require__(1154);
/* unused harmony reexport batch */


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

Object(__WEBPACK_IMPORTED_MODULE_2__utils_batch__["b" /* setBatch */])(__WEBPACK_IMPORTED_MODULE_1__utils_reactBatchedUpdates__["a" /* unstable_batchedUpdates */]);


/***/ }),
/* 2604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(2605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Context__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__connect_connect__ = __webpack_require__(2608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hooks_useDispatch__ = __webpack_require__(2616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hooks_useSelector__ = __webpack_require__(2617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_useStore__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_shallowEqual__ = __webpack_require__(1156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport connectAdvanced */
/* unused harmony reexport ReactReduxContext */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__connect_connect__["a"]; });
/* unused harmony reexport useDispatch */
/* unused harmony reexport createDispatchHook */
/* unused harmony reexport useSelector */
/* unused harmony reexport createSelectorHook */
/* unused harmony reexport useStore */
/* unused harmony reexport createStoreHook */
/* unused harmony reexport shallowEqual */










/***/ }),
/* 2605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Context__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useIsomorphicLayoutEffect__ = __webpack_require__(684);






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    var subscription = Object(__WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* createSubscription */])(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return store.getState();
  }, [store]);
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || __WEBPACK_IMPORTED_MODULE_2__Context__["a" /* ReactReduxContext */];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {
  Provider.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Provider);

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(2607);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;exports.ContextConsumer=h;exports.ContextProvider=z;exports.Element=A;exports.ForwardRef=B;exports.Fragment=C;exports.Lazy=D;exports.Memo=E;exports.Portal=F;exports.Profiler=G;exports.StrictMode=H;
exports.Suspense=I;exports.isAsyncMode=function(){return!1};exports.isConcurrentMode=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};exports.isContextProvider=function(a){return y(a)===g};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};exports.isForwardRef=function(a){return y(a)===k};exports.isFragment=function(a){return y(a)===d};exports.isLazy=function(a){return y(a)===p};exports.isMemo=function(a){return y(a)===n};
exports.isPortal=function(a){return y(a)===c};exports.isProfiler=function(a){return y(a)===f};exports.isStrictMode=function(a){return y(a)===e};exports.isSuspense=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),
/* 2608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(2609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(2612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(2613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(2614);


var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, _excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 2609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_bindActionCreators__ = __webpack_require__(2610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(1157);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_bindActionCreators__["a" /* default */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 2610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}

/***/ }),
/* 2611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 2612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(1157);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 2613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(1158);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 2614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(2615);

var _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, _excluded);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 2615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(1159);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 2616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createDispatchHook */
/* unused harmony export useDispatch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Context__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useStore__ = __webpack_require__(1160);


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */];
  }

  var useStore = context === __WEBPACK_IMPORTED_MODULE_0__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useStore__["b" /* useStore */] : Object(__WEBPACK_IMPORTED_MODULE_1__useStore__["a" /* createStoreHook */])(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/createDispatchHook();

/***/ }),
/* 2617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createSelectorHook */
/* unused harmony export useSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useReduxContext__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Subscription__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Context__ = __webpack_require__(226);






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return Object(__WEBPACK_IMPORTED_MODULE_2__utils_Subscription__["a" /* createSubscription */])(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelector = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestStoreState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var latestSelectedState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_useIsomorphicLayoutEffect__["a" /* useIsomorphicLayoutEffect */])(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */];
  }

  var useReduxContext = context === __WEBPACK_IMPORTED_MODULE_4__components_Context__["a" /* ReactReduxContext */] ? __WEBPACK_IMPORTED_MODULE_1__useReduxContext__["a" /* useReduxContext */] : function () {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {
      if (!selector) {
        throw new Error("You must pass a selector to useSelector");
      }

      if (typeof selector !== 'function') {
        throw new Error("You must pass a function as a selector to useSelector");
      }

      if (typeof equalityFn !== 'function') {
        throw new Error("You must pass a function as an equality function to useSelector");
      }
    }

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    Object(__WEBPACK_IMPORTED_MODULE_0_react__["useDebugValue"])(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/createSelectorHook();

/***/ }),
/* 2618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_dom__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_react_dom__, "unstable_batchedUpdates")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_dom__["unstable_batchedUpdates"]; });
/* eslint-disable import/no-unresolved */


/***/ }),
/* 2619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return expand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return offset; });
/* unused harmony export shrink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return withScroll; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tiny_invariant__ = __webpack_require__(1153);


var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
  var marginBox = getRect(expand(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ?  false ? invariant(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : Object(__WEBPACK_IMPORTED_MODULE_0_tiny_invariant__["a" /* default */])(false) : void 0;
  return result;
};

var getWindowScroll = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse(styles.marginTop),
    right: parse(styles.marginRight),
    bottom: parse(styles.marginBottom),
    left: parse(styles.marginLeft)
  };
  var padding = {
    top: parse(styles.paddingTop),
    right: parse(styles.paddingRight),
    bottom: parse(styles.paddingBottom),
    left: parse(styles.paddingLeft)
  };
  var border = {
    top: parse(styles.borderTopWidth),
    right: parse(styles.borderRightWidth),
    bottom: parse(styles.borderBottomWidth),
    left: parse(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};




/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2621);

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2622);
module.exports = __webpack_require__(79).Date.now;


/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(89);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 2623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

/* harmony default export */ __webpack_exports__["a"] = (rafSchd);


/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2625);

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2626);
module.exports = __webpack_require__(79).Number.isInteger;


/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(89);

$export($export.S, 'Number', { isInteger: __webpack_require__(2627) });


/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(309);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 2628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultProps */
/* unused harmony export makeCreatableSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_memoize_one__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__emotion_core__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__babel_runtime_helpers_esm_typeof__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__dist_chunk_39d3fda8_browser_esm_js__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__dist_chunk_80640036_browser_esm_js__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dist_base_dist_react_select_cac0a5ae_browser_esm_js__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__emotion_css__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__babel_runtime_helpers_esm_taggedTemplateLiteral__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_input_autosize__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__dist_chunk_b36baf1a_browser_esm_js__ = __webpack_require__(1136);

























var compareOption = function compareOption() {
  var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var option = arguments.length > 1 ? arguments[1] : undefined;
  var candidate = String(inputValue).toLowerCase();
  var optionValue = String(option.value).toLowerCase();
  var optionLabel = String(option.label).toLowerCase();
  return optionValue === candidate || optionLabel === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return "Create \"".concat(inputValue, "\"");
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};
var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectSpread__["a" /* default */])({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);
var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_inherits__["a" /* default */])(Creatable, _Component);

    function Creatable(props) {
      var _this;

      Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Creatable);

      _this = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Creatable).call(this, props));

      Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "select", void 0);

      Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_9__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), "onChange", function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value,
            name = _this$props.name;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }

        var newOption = _this.state.newOption;
        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = {
              action: 'create-option',
              name: name
            };

            if (isMulti) {
              onChange([].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_17__dist_chunk_39d3fda8_browser_esm_js__["f"])(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }

        onChange(newValue, actionMeta);
      });

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_createClass__["a" /* default */])(Creatable, [{
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;
        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, Object(__WEBPACK_IMPORTED_MODULE_17__dist_chunk_39d3fda8_browser_esm_js__["f"])(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }

        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(options)) : [].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(options), [newOption]) : options
        });
      }
    }, {
      key: "focus",
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var options = this.state.options;
        return __WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(SelectComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);

    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_11_react__["Component"]), Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_class, "defaultProps", defaultProps), _temp;
}; // TODO: do this in package entrypoint

var SelectCreatable = makeCreatableSelect(__WEBPACK_IMPORTED_MODULE_19__dist_base_dist_react_select_cac0a5ae_browser_esm_js__["a" /* S */]);
var Creatable = Object(__WEBPACK_IMPORTED_MODULE_23__dist_chunk_b36baf1a_browser_esm_js__["a" /* m */])(SelectCreatable);

/* harmony default export */ __webpack_exports__["a"] = (Creatable);



/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

var defaultState = { image: undefined, status: 'loading' };

module.exports = function useImage(url, crossOrigin) {
  var res = React.useState(defaultState);
  var image = res[0].image;
  var status = res[0].status;

  var setState = res[1];

  React.useEffect(
    function () {
      if (!url) return;
      var img = document.createElement('img');

      function onload() {
        setState({ image: img, status: 'loaded' });
      }

      function onerror() {
        setState({ image: undefined, status: 'failed' });
      }

      img.addEventListener('load', onload);
      img.addEventListener('error', onerror);
      crossOrigin && (img.crossOrigin = crossOrigin);
      img.src = url;

      return function cleanup() {
        img.removeEventListener('load', onload);
        img.removeEventListener('error', onerror);
        setState(defaultState);
      };
    },
    [url, crossOrigin]
  );

  // return array because it it better to use in case of several useImage hooks
  // const [background, backgroundStatus] = useImage(url1);
  // const [patter] = useImage(url2);
  return [image, status];
};


/***/ }),
/* 2630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export boolean */
/* unused harmony export ref */
/* unused harmony export lazy */
/* unused harmony export addMethod */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixed__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boolean__ = __webpack_require__(2664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__string__ = __webpack_require__(2665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__number__ = __webpack_require__(2666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date__ = __webpack_require__(2667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(2669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__array__ = __webpack_require__(2689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Reference__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Lazy__ = __webpack_require__(2690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ValidationError__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_reach__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_isSchema__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__setLocale__ = __webpack_require__(2691);
/* unused harmony reexport mixed */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__string__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__number__["a"]; });
/* unused harmony reexport bool */
/* unused harmony reexport date */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__object__["a"]; });
/* unused harmony reexport array */
/* unused harmony reexport reach */
/* unused harmony reexport isSchema */
/* unused harmony reexport setLocale */
/* unused harmony reexport ValidationError */













var boolean = __WEBPACK_IMPORTED_MODULE_1__boolean__["a" /* default */];

var ref = function ref(key, options) {
  return new __WEBPACK_IMPORTED_MODULE_7__Reference__["a" /* default */](key, options);
};

var lazy = function lazy(fn) {
  return new __WEBPACK_IMPORTED_MODULE_8__Lazy__["a" /* default */](fn);
};

function addMethod(schemaType, name, fn) {
  if (!schemaType || !Object(__WEBPACK_IMPORTED_MODULE_11__util_isSchema__["a" /* default */])(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
  if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
  if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
  schemaType.prototype[name] = fn;
}



/***/ }),
/* 2631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHas);


/***/ }),
/* 2632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClone_js__ = __webpack_require__(625);


/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.cloneWith` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @param {Function} [customizer] The function to customize cloning.
 * @returns {*} Returns the deep cloned value.
 * @see _.cloneWith
 * @example
 *
 * function customizer(value) {
 *   if (_.isElement(value)) {
 *     return value.cloneNode(true);
 *   }
 * }
 *
 * var el = _.cloneDeepWith(document.body, customizer);
 *
 * console.log(el === document.body);
 * // => false
 * console.log(el.nodeName);
 * // => 'BODY'
 * console.log(el.childNodes.length);
 * // => 20
 */
function cloneDeepWith(value, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseClone_js__["a" /* default */])(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneDeepWith);


/***/ }),
/* 2633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getTag_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isString_js__ = __webpack_require__(2634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__iteratorToArray_js__ = __webpack_require__(2635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mapToArray_js__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setToArray_js__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stringToArray_js__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__values_js__ = __webpack_require__(2638);











/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Built-in value references. */
var symIterator = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].iterator : undefined;

/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */
function toArray(value) {
  if (!value) {
    return [];
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isArrayLike_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__isString_js__["a" /* default */])(value) ? Object(__WEBPACK_IMPORTED_MODULE_8__stringToArray_js__["a" /* default */])(value) : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(value);
  }
  if (symIterator && value[symIterator]) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__iteratorToArray_js__["a" /* default */])(value[symIterator]());
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_2__getTag_js__["a" /* default */])(value),
      func = tag == mapTag ? __WEBPACK_IMPORTED_MODULE_6__mapToArray_js__["a" /* default */] : (tag == setTag ? __WEBPACK_IMPORTED_MODULE_7__setToArray_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_9__values_js__["a" /* default */]);

  return func(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toArray);


/***/ }),
/* 2634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(166);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isString);


/***/ }),
/* 2635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */
function iteratorToArray(iterator) {
  var data,
      result = [];

  while (!(data = iterator.next()).done) {
    result.push(data.value);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (iteratorToArray);


/***/ }),
/* 2636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/* harmony default export */ __webpack_exports__["a"] = (asciiToArray);


/***/ }),
/* 2637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeToArray);


/***/ }),
/* 2638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseValues_js__ = __webpack_require__(2639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(277);



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : Object(__WEBPACK_IMPORTED_MODULE_0__baseValues_js__["a" /* default */])(object, Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (values);


/***/ }),
/* 2639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(640);


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseValues);


/***/ }),
/* 2640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_has__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isSchema__ = __webpack_require__(229);



var Condition = /*#__PURE__*/function () {
  function Condition(refs, options) {
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_has__["a" /* default */])(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    var is = options.is,
        then = options.then,
        otherwise = options.otherwise;
    var check = typeof is === 'function' ? is : function () {
      for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
        values[_key] = arguments[_key];
      }

      return values.every(function (value) {
        return value === is;
      });
    };

    this.fn = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var options = args.pop();
      var schema = args.pop();
      var branch = check.apply(void 0, args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  var _proto = Condition.prototype;

  _proto.resolve = function resolve(base, options) {
    var values = this.refs.map(function (ref) {
      return ref.getValue(options);
    });
    var schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__util_isSchema__["a" /* default */])(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  };

  return Condition;
}();

/* harmony default export */ __webpack_exports__["a"] = (Condition);

/***/ }),
/* 2641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prependDeep;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_has__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSchema__ = __webpack_require__(229);



var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

function prependDeep(target, source) {
  for (var key in source) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_has__["a" /* default */])(source, key)) {
      var sourceVal = source[key],
          targetVal = target[key];

      if (targetVal === undefined) {
        target[key] = sourceVal;
      } else if (targetVal === sourceVal) {
        continue;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_1__isSchema__["a" /* default */])(targetVal)) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__isSchema__["a" /* default */])(sourceVal)) target[key] = sourceVal.concat(targetVal);
      } else if (isObject(targetVal)) {
        if (isObject(sourceVal)) target[key] = prependDeep(targetVal, sourceVal);
      } else if (Array.isArray(targetVal)) {
        if (Array.isArray(sourceVal)) target[key] = sourceVal.concat(targetVal);
      }
    }
  }

  return target;
}

/***/ }),
/* 2642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createErrorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = createValidation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_mapValues__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ValidationError__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Reference__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_synchronous_promise__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_synchronous_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_synchronous_promise__);






var formatError = __WEBPACK_IMPORTED_MODULE_3__ValidationError__["a" /* default */].formatError;

var thenable = function thenable(p) {
  return p && typeof p.then === 'function' && typeof p.catch === 'function';
};

function runTest(testFn, ctx, value, sync) {
  var result = testFn.call(ctx, value);
  if (!sync) return Promise.resolve(result);

  if (thenable(result)) {
    throw new Error("Validation test of type: \"" + ctx.type + "\" returned a Promise during a synchronous validate. " + "This test will finish after the validate call has returned");
  }

  return __WEBPACK_IMPORTED_MODULE_5_synchronous_promise__["SynchronousPromise"].resolve(result);
}

function resolveParams(oldParams, newParams, resolve) {
  return Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_mapValues__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, oldParams, newParams), resolve);
}

function createErrorFactory(_ref) {
  var value = _ref.value,
      label = _ref.label,
      resolve = _ref.resolve,
      originalValue = _ref.originalValue,
      opts = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["value", "label", "resolve", "originalValue"]);

  return function createError(_temp) {
    var _ref2 = _temp === void 0 ? {} : _temp,
        _ref2$path = _ref2.path,
        path = _ref2$path === void 0 ? opts.path : _ref2$path,
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? opts.message : _ref2$message,
        _ref2$type = _ref2.type,
        type = _ref2$type === void 0 ? opts.name : _ref2$type,
        params = _ref2.params;

    params = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      path: path,
      value: value,
      originalValue: originalValue,
      label: label
    }, resolveParams(opts.params, params, resolve));
    return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(new __WEBPACK_IMPORTED_MODULE_3__ValidationError__["a" /* default */](formatError(message, params), value, path, type), {
      params: params
    });
  };
}
function createValidation(options) {
  var name = options.name,
      message = options.message,
      test = options.test,
      params = options.params;

  function validate(_ref3) {
    var value = _ref3.value,
        path = _ref3.path,
        label = _ref3.label,
        options = _ref3.options,
        originalValue = _ref3.originalValue,
        sync = _ref3.sync,
        rest = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["value", "path", "label", "options", "originalValue", "sync"]);

    var parent = options.parent;

    var resolve = function resolve(item) {
      return __WEBPACK_IMPORTED_MODULE_4__Reference__["a" /* default */].isRef(item) ? item.getValue({
        value: value,
        parent: parent,
        context: options.context
      }) : item;
    };

    var createError = createErrorFactory({
      message: message,
      path: path,
      value: value,
      originalValue: originalValue,
      params: params,
      label: label,
      resolve: resolve,
      name: name
    });

    var ctx = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      path: path,
      parent: parent,
      type: name,
      createError: createError,
      resolve: resolve,
      options: options
    }, rest);

    return runTest(test, ctx, value, sync).then(function (validOrError) {
      if (__WEBPACK_IMPORTED_MODULE_3__ValidationError__["a" /* default */].isError(validOrError)) throw validOrError;else if (!validOrError) throw createError();
    });
  }

  validate.OPTIONS = options;
  return validate;
}

/***/ }),
/* 2643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(2644);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 2644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 2645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(2646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(2655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(1174);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 2646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(1171);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 2647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(2653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(2654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(1070);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 2648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(2649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(2650);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 2649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 2650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 2651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 2652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 2653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(1165);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 2654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(1074);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 2655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(277);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 2656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(2657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(2658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(330);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 2657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(1175);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 2658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(2659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(1162);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 2659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 2660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 2661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(2662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(2663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(330);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 2662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 2663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(1175);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 2664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_inherits__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixed__ = __webpack_require__(227);


/* harmony default export */ __webpack_exports__["a"] = (BooleanSchema);

function BooleanSchema() {
  var _this = this;

  if (!(this instanceof BooleanSchema)) return new BooleanSchema();
  __WEBPACK_IMPORTED_MODULE_1__mixed__["a" /* default */].call(this, {
    type: 'boolean'
  });
  this.withMutation(function () {
    _this.transform(function (value) {
      if (!this.isType(value)) {
        if (/^(true|1)$/i.test(value)) return true;
        if (/^(false|0)$/i.test(value)) return false;
      }

      return value;
    });
  });
}

Object(__WEBPACK_IMPORTED_MODULE_0__util_inherits__["a" /* default */])(BooleanSchema, __WEBPACK_IMPORTED_MODULE_1__mixed__["a" /* default */], {
  _typeCheck: function _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }
});

/***/ }),
/* 2665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = StringSchema;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_inherits__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixed__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isAbsent__ = __webpack_require__(457);



 // eslint-disable-next-line

var rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

var rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

var rUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

var isTrimmed = function isTrimmed(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value === value.trim();
};

function StringSchema() {
  var _this = this;

  if (!(this instanceof StringSchema)) return new StringSchema();
  __WEBPACK_IMPORTED_MODULE_1__mixed__["a" /* default */].call(this, {
    type: 'string'
  });
  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      return value != null && value.toString ? value.toString() : value;
    });
  });
}
Object(__WEBPACK_IMPORTED_MODULE_0__util_inherits__["a" /* default */])(StringSchema, __WEBPACK_IMPORTED_MODULE_1__mixed__["a" /* default */], {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  },
  _isPresent: function _isPresent(value) {
    return __WEBPACK_IMPORTED_MODULE_1__mixed__["a" /* default */].prototype._isPresent.call(this, value) && value.length > 0;
  },
  length: function length(_length, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].length;
    }

    return this.test({
      message: message,
      name: 'length',
      exclusive: true,
      params: {
        length: _length
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value.length === this.resolve(_length);
      }
    });
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].max;
    }

    return this.test({
      name: 'max',
      exclusive: true,
      message: message,
      params: {
        max: _max
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value.length <= this.resolve(_max);
      }
    });
  },
  matches: function matches(regex, options) {
    var excludeEmptyString = false;
    var message;
    var name;

    if (options) {
      if (typeof options === 'object') {
        excludeEmptyString = options.excludeEmptyString;
        message = options.message;
        name = options.name;
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].matches,
      params: {
        regex: regex
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value === '' && excludeEmptyString || value.search(regex) !== -1;
      }
    });
  },
  email: function email(message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].email;
    }

    return this.matches(rEmail, {
      name: 'email',
      message: message,
      excludeEmptyString: true
    });
  },
  url: function url(message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].url;
    }

    return this.matches(rUrl, {
      name: 'url',
      message: message,
      excludeEmptyString: true
    });
  },
  uuid: function uuid(message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].uuid;
    }

    return this.matches(rUUID, {
      name: 'uuid',
      message: message,
      excludeEmptyString: false
    });
  },
  //-- transforms --
  ensure: function ensure() {
    return this.default('').transform(function (val) {
      return val === null ? '' : val;
    });
  },
  trim: function trim(message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].trim;
    }

    return this.transform(function (val) {
      return val != null ? val.trim() : val;
    }).test({
      message: message,
      name: 'trim',
      test: isTrimmed
    });
  },
  lowercase: function lowercase(message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].lowercase;
    }

    return this.transform(function (value) {
      return !Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) ? value.toLowerCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value === value.toLowerCase();
      }
    });
  },
  uppercase: function uppercase(message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["g" /* string */].uppercase;
    }

    return this.transform(function (value) {
      return !Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) ? value.toUpperCase() : value;
    }).test({
      message: message,
      name: 'string_case',
      exclusive: true,
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value === value.toUpperCase();
      }
    });
  }
});

/***/ }),
/* 2666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NumberSchema;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_inherits__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixed__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isAbsent__ = __webpack_require__(457);





var isNaN = function isNaN(value) {
  return value != +value;
};

function NumberSchema() {
  var _this = this;

  if (!(this instanceof NumberSchema)) return new NumberSchema();
  __WEBPACK_IMPORTED_MODULE_1__mixed__["a" /* default */].call(this, {
    type: 'number'
  });
  this.withMutation(function () {
    _this.transform(function (value) {
      var parsed = value;

      if (typeof parsed === 'string') {
        parsed = parsed.replace(/\s/g, '');
        if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

        parsed = +parsed;
      }

      if (this.isType(parsed)) return parsed;
      return parseFloat(parsed);
    });
  });
}
Object(__WEBPACK_IMPORTED_MODULE_0__util_inherits__["a" /* default */])(NumberSchema, __WEBPACK_IMPORTED_MODULE_1__mixed__["a" /* default */], {
  _typeCheck: function _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !isNaN(value);
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["e" /* number */].min;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["e" /* number */].max;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value <= this.resolve(_max);
      }
    });
  },
  lessThan: function lessThan(less, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["e" /* number */].lessThan;
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        less: less
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value < this.resolve(less);
      }
    });
  },
  moreThan: function moreThan(more, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["e" /* number */].moreThan;
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        more: more
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value > this.resolve(more);
      }
    });
  },
  positive: function positive(msg) {
    if (msg === void 0) {
      msg = __WEBPACK_IMPORTED_MODULE_2__locale__["e" /* number */].positive;
    }

    return this.moreThan(0, msg);
  },
  negative: function negative(msg) {
    if (msg === void 0) {
      msg = __WEBPACK_IMPORTED_MODULE_2__locale__["e" /* number */].negative;
    }

    return this.lessThan(0, msg);
  },
  integer: function integer(message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_2__locale__["e" /* number */].integer;
    }

    return this.test({
      name: 'integer',
      message: message,
      test: function test(val) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(val) || Number.isInteger(val);
      }
    });
  },
  truncate: function truncate() {
    return this.transform(function (value) {
      return !Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) ? value | 0 : value;
    });
  },
  round: function round(method) {
    var avail = ['ceil', 'floor', 'round', 'trunc'];
    method = method && method.toLowerCase() || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(function (value) {
      return !Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) ? Math[method](value) : value;
    });
  }
});

/***/ }),
/* 2667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixed__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_inherits__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isodate__ = __webpack_require__(2668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isAbsent__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Reference__ = __webpack_require__(338);






var invalidDate = new Date('');

var isDate = function isDate(obj) {
  return Object.prototype.toString.call(obj) === '[object Date]';
};

/* unused harmony default export */ var _unused_webpack_default_export = (DateSchema);

function DateSchema() {
  var _this = this;

  if (!(this instanceof DateSchema)) return new DateSchema();
  __WEBPACK_IMPORTED_MODULE_0__mixed__["a" /* default */].call(this, {
    type: 'date'
  });
  this.withMutation(function () {
    _this.transform(function (value) {
      if (this.isType(value)) return value;
      value = Object(__WEBPACK_IMPORTED_MODULE_2__util_isodate__["a" /* default */])(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

      return !isNaN(value) ? new Date(value) : invalidDate;
    });
  });
}

Object(__WEBPACK_IMPORTED_MODULE_1__util_inherits__["a" /* default */])(DateSchema, __WEBPACK_IMPORTED_MODULE_0__mixed__["a" /* default */], {
  _typeCheck: function _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  },
  min: function min(_min, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_3__locale__["b" /* date */].min;
    }

    var limit = _min;

    if (!__WEBPACK_IMPORTED_MODULE_5__Reference__["a" /* default */].isRef(limit)) {
      limit = this.cast(_min);
      if (!this._typeCheck(limit)) throw new TypeError('`min` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util_isAbsent__["a" /* default */])(value) || value >= this.resolve(limit);
      }
    });
  },
  max: function max(_max, message) {
    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_3__locale__["b" /* date */].max;
    }

    var limit = _max;

    if (!__WEBPACK_IMPORTED_MODULE_5__Reference__["a" /* default */].isRef(limit)) {
      limit = this.cast(_max);
      if (!this._typeCheck(limit)) throw new TypeError('`max` must be a Date or a value that can be `cast()` to a Date');
    }

    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util_isAbsent__["a" /* default */])(value) || value <= this.resolve(limit);
      }
    });
  }
});

/***/ }),
/* 2668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseIsoDate;
/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) {
      struct[k] = +struct[k] || 0;
    } // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

/***/ }),
/* 2669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ObjectSchema;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_has__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_snakeCase__ = __webpack_require__(2670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_camelCase__ = __webpack_require__(2679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_mapKeys__ = __webpack_require__(2685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_mapValues__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_property_expr__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_property_expr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_property_expr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixed__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__locale_js__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_sortFields__ = __webpack_require__(2686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_sortByKeyOrder__ = __webpack_require__(2688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_inherits__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_makePath__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_runValidations__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_synchronous_promise__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_synchronous_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_synchronous_promise__);



function _templateObject3() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["", "[\"", "\"]"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["", ".", ""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["", ".", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
















var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

var promise = function promise(sync) {
  return sync ? __WEBPACK_IMPORTED_MODULE_15_synchronous_promise__["SynchronousPromise"] : Promise;
};

function unknown(ctx, value) {
  var known = Object.keys(ctx.fields);
  return Object.keys(value).filter(function (key) {
    return known.indexOf(key) === -1;
  });
}

function ObjectSchema(spec) {
  var _this2 = this;

  if (!(this instanceof ObjectSchema)) return new ObjectSchema(spec);
  __WEBPACK_IMPORTED_MODULE_8__mixed__["a" /* default */].call(this, {
    type: 'object',
    default: function _default() {
      var _this = this;

      if (!this._nodes.length) return undefined;
      var dft = {};

      this._nodes.forEach(function (key) {
        dft[key] = _this.fields[key].default ? _this.fields[key].default() : undefined;
      });

      return dft;
    }
  });
  this.fields = Object.create(null);
  this._nodes = [];
  this._excludedEdges = [];
  this.withMutation(function () {
    _this2.transform(function coerce(value) {
      if (typeof value === 'string') {
        try {
          value = JSON.parse(value);
        } catch (err) {
          value = null;
        }
      }

      if (this.isType(value)) return value;
      return null;
    });

    if (spec) {
      _this2.shape(spec);
    }
  });
}
Object(__WEBPACK_IMPORTED_MODULE_12__util_inherits__["a" /* default */])(ObjectSchema, __WEBPACK_IMPORTED_MODULE_8__mixed__["a" /* default */], {
  _typeCheck: function _typeCheck(value) {
    return isObject(value) || typeof value === 'function';
  },
  _cast: function _cast(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var value = __WEBPACK_IMPORTED_MODULE_8__mixed__["a" /* default */].prototype._cast.call(this, _value, options); //should ignore nulls here


    if (value === undefined) return this.default();
    if (!this._typeCheck(value)) return value;
    var fields = this.fields;
    var strip = this._option('stripUnknown', options) === true;

    var props = this._nodes.concat(Object.keys(value).filter(function (v) {
      return _this3._nodes.indexOf(v) === -1;
    }));

    var intermediateValue = {}; // is filled during the transform below

    var innerOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });

    var isChanged = false;
    props.forEach(function (prop) {
      var field = fields[prop];
      var exists = Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_has__["a" /* default */])(value, prop);

      if (field) {
        var fieldValue;
        var strict = field._options && field._options.strict; // safe to mutate since this is fired in sequence

        innerOptions.path = Object(__WEBPACK_IMPORTED_MODULE_13__util_makePath__["a" /* default */])(_templateObject(), options.path, prop);
        innerOptions.value = value[prop];
        field = field.resolve(innerOptions);

        if (field._strip === true) {
          isChanged = isChanged || prop in value;
          return;
        }

        fieldValue = !options.__validating || !strict ? field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
      } else if (exists && !strip) intermediateValue[prop] = value[prop];

      if (intermediateValue[prop] !== value[prop]) isChanged = true;
    });
    return isChanged ? intermediateValue : value;
  },
  _validate: function _validate(_value, opts) {
    var _this4 = this;

    if (opts === void 0) {
      opts = {};
    }

    var endEarly, recursive;
    var sync = opts.sync;
    var errors = [];
    var originalValue = opts.originalValue != null ? opts.originalValue : _value;
    var from = [{
      schema: this,
      value: originalValue
    }].concat(opts.from || []);
    endEarly = this._option('abortEarly', opts);
    recursive = this._option('recursive', opts);
    opts = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, opts, {
      __validating: true,
      originalValue: originalValue,
      from: from
    });
    return __WEBPACK_IMPORTED_MODULE_8__mixed__["a" /* default */].prototype._validate.call(this, _value, opts).catch(Object(__WEBPACK_IMPORTED_MODULE_14__util_runValidations__["b" /* propagateErrors */])(endEarly, errors)).then(function (value) {
      if (!recursive || !isObject(value)) {
        // only iterate though actual objects
        if (errors.length) throw errors[0];
        return value;
      }

      from = originalValue ? [].concat(from) : [{
        schema: _this4,
        value: originalValue || value
      }].concat(opts.from || []);
      originalValue = originalValue || value;

      var validations = _this4._nodes.map(function (key) {
        var path = key.indexOf('.') === -1 ? Object(__WEBPACK_IMPORTED_MODULE_13__util_makePath__["a" /* default */])(_templateObject2(), opts.path, key) : Object(__WEBPACK_IMPORTED_MODULE_13__util_makePath__["a" /* default */])(_templateObject3(), opts.path, key);
        var field = _this4.fields[key];

        var innerOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, opts, {
          path: path,
          from: from,
          parent: value,
          originalValue: originalValue[key]
        });

        if (field && field.validate) {
          // inner fields are always strict:
          // 1. this isn't strict so the casting will also have cast inner values
          // 2. this is strict in which case the nested values weren't cast either
          innerOptions.strict = true;
          return field.validate(value[key], innerOptions);
        }

        return promise(sync).resolve(true);
      });

      return Object(__WEBPACK_IMPORTED_MODULE_14__util_runValidations__["a" /* default */])({
        sync: sync,
        validations: validations,
        value: value,
        errors: errors,
        endEarly: endEarly,
        path: opts.path,
        sort: Object(__WEBPACK_IMPORTED_MODULE_11__util_sortByKeyOrder__["a" /* default */])(_this4.fields)
      });
    });
  },
  concat: function concat(schema) {
    var next = __WEBPACK_IMPORTED_MODULE_8__mixed__["a" /* default */].prototype.concat.call(this, schema);
    next._nodes = Object(__WEBPACK_IMPORTED_MODULE_10__util_sortFields__["a" /* default */])(next.fields, next._excludedEdges);
    return next;
  },
  shape: function shape(schema, excludes) {
    if (excludes === void 0) {
      excludes = [];
    }

    var next = this.clone();

    var fields = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(next.fields, schema);

    next.fields = fields;

    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      var keys = excludes.map(function (_ref) {
        var first = _ref[0],
            second = _ref[1];
        return first + "-" + second;
      });
      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = Object(__WEBPACK_IMPORTED_MODULE_10__util_sortFields__["a" /* default */])(fields, next._excludedEdges);
    return next;
  },
  from: function from(_from, to, alias) {
    var fromGetter = Object(__WEBPACK_IMPORTED_MODULE_7_property_expr__["getter"])(_from, true);
    return this.transform(function (obj) {
      if (obj == null) return obj;
      var newObj = obj;

      if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_has__["a" /* default */])(obj, _from)) {
        newObj = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, obj);
        if (!alias) delete newObj[_from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  },
  noUnknown: function noUnknown(noAllow, message) {
    if (noAllow === void 0) {
      noAllow = true;
    }

    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_9__locale_js__["f" /* object */].noUnknown;
    }

    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    var next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test: function test(value) {
        if (value == null) return true;
        var unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }
    });
    next._options.stripUnknown = noAllow;
    return next;
  },
  unknown: function unknown(allow, message) {
    if (allow === void 0) {
      allow = true;
    }

    if (message === void 0) {
      message = __WEBPACK_IMPORTED_MODULE_9__locale_js__["f" /* object */].noUnknown;
    }

    return this.noUnknown(!allow, message);
  },
  transformKeys: function transformKeys(fn) {
    return this.transform(function (obj) {
      return obj && Object(__WEBPACK_IMPORTED_MODULE_5_lodash_es_mapKeys__["a" /* default */])(obj, function (_, key) {
        return fn(key);
      });
    });
  },
  camelCase: function camelCase() {
    return this.transformKeys(__WEBPACK_IMPORTED_MODULE_4_lodash_es_camelCase__["a" /* default */]);
  },
  snakeCase: function snakeCase() {
    return this.transformKeys(__WEBPACK_IMPORTED_MODULE_3_lodash_es_snakeCase__["a" /* default */]);
  },
  constantCase: function constantCase() {
    return this.transformKeys(function (key) {
      return Object(__WEBPACK_IMPORTED_MODULE_3_lodash_es_snakeCase__["a" /* default */])(key).toUpperCase();
    });
  },
  describe: function describe() {
    var base = __WEBPACK_IMPORTED_MODULE_8__mixed__["a" /* default */].prototype.describe.call(this);
    base.fields = Object(__WEBPACK_IMPORTED_MODULE_6_lodash_es_mapValues__["a" /* default */])(this.fields, function (value) {
      return value.describe();
    });
    return base;
  }
});

/***/ }),
/* 2670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCompounder_js__ = __webpack_require__(1177);


/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = Object(__WEBPACK_IMPORTED_MODULE_0__createCompounder_js__["a" /* default */])(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

/* harmony default export */ __webpack_exports__["a"] = (snakeCase);


/***/ }),
/* 2671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayReduce);


/***/ }),
/* 2672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deburrLetter_js__ = __webpack_require__(2673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toString_js__ = __webpack_require__(278);



/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = Object(__WEBPACK_IMPORTED_MODULE_1__toString_js__["a" /* default */])(string);
  return string && string.replace(reLatin, __WEBPACK_IMPORTED_MODULE_0__deburrLetter_js__["a" /* default */]).replace(reComboMark, '');
}

/* harmony default export */ __webpack_exports__["a"] = (deburr);


/***/ }),
/* 2673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__ = __webpack_require__(2674);


/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = Object(__WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__["a" /* default */])(deburredLetters);

/* harmony default export */ __webpack_exports__["a"] = (deburrLetter);


/***/ }),
/* 2674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyOf);


/***/ }),
/* 2675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiWords_js__ = __webpack_require__(2676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicodeWord_js__ = __webpack_require__(2677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toString_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__unicodeWords_js__ = __webpack_require__(2678);





/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = Object(__WEBPACK_IMPORTED_MODULE_2__toString_js__["a" /* default */])(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicodeWord_js__["a" /* default */])(string) ? Object(__WEBPACK_IMPORTED_MODULE_3__unicodeWords_js__["a" /* default */])(string) : Object(__WEBPACK_IMPORTED_MODULE_0__asciiWords_js__["a" /* default */])(string);
  }
  return string.match(pattern) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (words);


/***/ }),
/* 2676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (asciiWords);


/***/ }),
/* 2677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/* harmony default export */ __webpack_exports__["a"] = (hasUnicodeWord);


/***/ }),
/* 2678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeWords);


/***/ }),
/* 2679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capitalize_js__ = __webpack_require__(2680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createCompounder_js__ = __webpack_require__(1177);



/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = Object(__WEBPACK_IMPORTED_MODULE_1__createCompounder_js__["a" /* default */])(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? Object(__WEBPACK_IMPORTED_MODULE_0__capitalize_js__["a" /* default */])(word) : word);
});

/* harmony default export */ __webpack_exports__["a"] = (camelCase);


/***/ }),
/* 2680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upperFirst_js__ = __webpack_require__(2681);



/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__upperFirst_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__toString_js__["a" /* default */])(string).toLowerCase());
}

/* harmony default export */ __webpack_exports__["a"] = (capitalize);


/***/ }),
/* 2681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__ = __webpack_require__(2682);


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = Object(__WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__["a" /* default */])('toUpperCase');

/* harmony default export */ __webpack_exports__["a"] = (upperFirst);


/***/ }),
/* 2682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castSlice_js__ = __webpack_require__(2683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToArray_js__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(278);





/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string);

    var strSymbols = Object(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__stringToArray_js__["a" /* default */])(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? Object(__WEBPACK_IMPORTED_MODULE_0__castSlice_js__["a" /* default */])(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCaseFirst);


/***/ }),
/* 2683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(2684);


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : Object(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (castSlice);


/***/ }),
/* 2684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSlice);


/***/ }),
/* 2685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(1170);




/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, iteratee(value, key, object), value);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapKeys);


/***/ }),
/* 2686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortFields;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_has__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toposort__ = __webpack_require__(2687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_toposort___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_toposort__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_property_expr__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_property_expr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_property_expr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Reference__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isSchema__ = __webpack_require__(229);





function sortFields(fields, excludes) {
  if (excludes === void 0) {
    excludes = [];
  }

  var edges = [],
      nodes = [];

  function addNode(depPath, key) {
    var node = Object(__WEBPACK_IMPORTED_MODULE_2_property_expr__["split"])(depPath)[0];
    if (!~nodes.indexOf(node)) nodes.push(node);
    if (!~excludes.indexOf(key + "-" + node)) edges.push([key, node]);
  }

  for (var key in fields) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_has__["a" /* default */])(fields, key)) {
      var value = fields[key];
      if (!~nodes.indexOf(key)) nodes.push(key);
      if (__WEBPACK_IMPORTED_MODULE_3__Reference__["a" /* default */].isRef(value) && value.isSibling) addNode(value.path, key);else if (Object(__WEBPACK_IMPORTED_MODULE_4__isSchema__["a" /* default */])(value) && value._deps) value._deps.forEach(function (path) {
        return addNode(path, key);
      });
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_toposort___default.a.array(nodes, edges).reverse();
}

/***/ }),
/* 2687 */
/***/ (function(module, exports) {


/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

module.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
}

module.exports.array = toposort

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes)

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  })

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set())
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep
      try {
        nodeRep = ", node was:" + JSON.stringify(node)
      } catch(e) {
        nodeRep = ""
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true

    var outgoing = outgoingEdges.get(node) || new Set()
    outgoing = Array.from(outgoing)

    if (i = outgoing.length) {
      predecessors.add(node)
      do {
        var child = outgoing[--i]
        visit(child, nodesHash.get(child), predecessors)
      } while (i)
      predecessors.delete(node)
    }

    sorted[--cursor] = node
  }
}

function uniqueNodes(arr){
  var res = new Set()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    res.add(edge[0])
    res.add(edge[1])
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i]
    if (!edges.has(edge[0])) edges.set(edge[0], new Set())
    if (!edges.has(edge[1])) edges.set(edge[1], new Set())
    edges.get(edge[0]).add(edge[1])
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map()
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i)
  }
  return res
}


/***/ }),
/* 2688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sortByKeyOrder;
function findIndex(arr, err) {
  var idx = Infinity;
  arr.some(function (key, ii) {
    if (err.path.indexOf(key) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(fields) {
  var keys = Object.keys(fields);
  return function (a, b) {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

/***/ }),
/* 2689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_inherits__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isAbsent__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isSchema__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_makePath__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_printValue__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixed__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__locale__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_runValidations__ = __webpack_require__(686);



function _templateObject2() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["", "[", "]"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_taggedTemplateLiteralLoose__["a" /* default */])(["", "[", "]"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}









/* unused harmony default export */ var _unused_webpack_default_export = (ArraySchema);

function ArraySchema(type) {
  var _this = this;

  if (!(this instanceof ArraySchema)) return new ArraySchema(type);
  __WEBPACK_IMPORTED_MODULE_7__mixed__["a" /* default */].call(this, {
    type: 'array'
  }); // `undefined` specifically means uninitialized, as opposed to
  // "no subtype"

  this._subType = undefined;
  this.innerType = undefined;
  this.withMutation(function () {
    _this.transform(function (values) {
      if (typeof values === 'string') try {
        values = JSON.parse(values);
      } catch (err) {
        values = null;
      }
      return this.isType(values) ? values : null;
    });

    if (type) _this.of(type);
  });
}

Object(__WEBPACK_IMPORTED_MODULE_2__util_inherits__["a" /* default */])(ArraySchema, __WEBPACK_IMPORTED_MODULE_7__mixed__["a" /* default */], {
  _typeCheck: function _typeCheck(v) {
    return Array.isArray(v);
  },
  _cast: function _cast(_value, _opts) {
    var _this2 = this;

    var value = __WEBPACK_IMPORTED_MODULE_7__mixed__["a" /* default */].prototype._cast.call(this, _value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this.innerType) return value;
    var isChanged = false;
    var castArray = value.map(function (v, idx) {
      var castElement = _this2.innerType.cast(v, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _opts, {
        path: Object(__WEBPACK_IMPORTED_MODULE_5__util_makePath__["a" /* default */])(_templateObject(), _opts.path, idx)
      }));

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  },
  _validate: function _validate(_value, options) {
    var _this3 = this;

    if (options === void 0) {
      options = {};
    }

    var errors = [];
    var sync = options.sync;
    var path = options.path;
    var innerType = this.innerType;

    var endEarly = this._option('abortEarly', options);

    var recursive = this._option('recursive', options);

    var originalValue = options.originalValue != null ? options.originalValue : _value;
    return __WEBPACK_IMPORTED_MODULE_7__mixed__["a" /* default */].prototype._validate.call(this, _value, options).catch(Object(__WEBPACK_IMPORTED_MODULE_9__util_runValidations__["b" /* propagateErrors */])(endEarly, errors)).then(function (value) {
      if (!recursive || !innerType || !_this3._typeCheck(value)) {
        if (errors.length) throw errors[0];
        return value;
      }

      originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

      var validations = new Array(value.length);

      for (var idx = 0; idx < value.length; idx++) {
        var item = value[idx];

        var _path = Object(__WEBPACK_IMPORTED_MODULE_5__util_makePath__["a" /* default */])(_templateObject2(), options.path, idx); // object._validate note for isStrict explanation


        var innerOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
          path: _path,
          strict: true,
          parent: value,
          index: idx,
          originalValue: originalValue[idx]
        });

        validations[idx] = innerType.validate ? innerType.validate(item, innerOptions) : true;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_9__util_runValidations__["a" /* default */])({
        sync: sync,
        path: path,
        value: value,
        errors: errors,
        endEarly: endEarly,
        validations: validations
      });
    });
  },
  _isPresent: function _isPresent(value) {
    return __WEBPACK_IMPORTED_MODULE_7__mixed__["a" /* default */].prototype._isPresent.call(this, value) && value.length > 0;
  },
  of: function of(schema) {
    var next = this.clone();
    if (schema !== false && !Object(__WEBPACK_IMPORTED_MODULE_4__util_isSchema__["a" /* default */])(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema, or `false` to negate a current sub-schema. ' + 'not: ' + Object(__WEBPACK_IMPORTED_MODULE_6__util_printValue__["a" /* default */])(schema));
    next._subType = schema;
    next.innerType = schema;
    return next;
  },
  min: function min(_min, message) {
    message = message || __WEBPACK_IMPORTED_MODULE_8__locale__["a" /* array */].min;
    return this.test({
      message: message,
      name: 'min',
      exclusive: true,
      params: {
        min: _min
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value.length >= this.resolve(_min);
      }
    });
  },
  max: function max(_max, message) {
    message = message || __WEBPACK_IMPORTED_MODULE_8__locale__["a" /* array */].max;
    return this.test({
      message: message,
      name: 'max',
      exclusive: true,
      params: {
        max: _max
      },
      test: function test(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isAbsent__["a" /* default */])(value) || value.length <= this.resolve(_max);
      }
    });
  },
  ensure: function ensure() {
    var _this4 = this;

    return this.default(function () {
      return [];
    }).transform(function (val, original) {
      // We don't want to return `null` for nullable schema
      if (_this4._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  },
  compact: function compact(rejector) {
    var reject = !rejector ? function (v) {
      return !!v;
    } : function (v, i, a) {
      return !rejector(v, i, a);
    };
    return this.transform(function (values) {
      return values != null ? values.filter(reject) : values;
    });
  },
  describe: function describe() {
    var base = __WEBPACK_IMPORTED_MODULE_7__mixed__["a" /* default */].prototype.describe.call(this);
    if (this.innerType) base.innerType = this.innerType.describe();
    return base;
  }
});

/***/ }),
/* 2690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_isSchema__ = __webpack_require__(229);


var Lazy = /*#__PURE__*/function () {
  function Lazy(mapFn) {
    this._resolve = function (value, options) {
      var schema = mapFn(value, options);
      if (!Object(__WEBPACK_IMPORTED_MODULE_0__util_isSchema__["a" /* default */])(schema)) throw new TypeError('lazy() functions must return a valid schema');
      return schema.resolve(options);
    };
  }

  var _proto = Lazy.prototype;

  _proto.resolve = function resolve(options) {
    return this._resolve(options.value, options);
  };

  _proto.cast = function cast(value, options) {
    return this._resolve(value, options).cast(value, options);
  };

  _proto.validate = function validate(value, options) {
    return this._resolve(value, options).validate(value, options);
  };

  _proto.validateSync = function validateSync(value, options) {
    return this._resolve(value, options).validateSync(value, options);
  };

  _proto.validateAt = function validateAt(path, value, options) {
    return this._resolve(value, options).validateAt(path, value, options);
  };

  _proto.validateSyncAt = function validateSyncAt(path, value, options) {
    return this._resolve(value, options).validateSyncAt(path, value, options);
  };

  return Lazy;
}();

Lazy.prototype.__isYupSchema__ = true;
/* harmony default export */ __webpack_exports__["a"] = (Lazy);

/***/ }),
/* 2691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(228);

function setLocale(custom) {
  Object.keys(custom).forEach(function (type) {
    Object.keys(custom[type]).forEach(function (method) {
      __WEBPACK_IMPORTED_MODULE_0__locale__["c" /* default */][type][method] = custom[type][method];
    });
  });
}

/***/ }),
/* 2692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColorPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_color__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_color__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_color_lib_components_common__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_color_lib_components_common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_color_lib_components_common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_util_Color__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_util_Color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_shared_util_Color__);






var ColorPicker = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ColorPicker, _super);
    function ColorPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function () {
            _this.setState({ isPickerVisible: !_this.state.isPickerVisible });
        };
        _this.handleClose = function () {
            _this.setState({ isPickerVisible: false });
        };
        _this.handleInputChange = function (color) {
            if (__WEBPACK_IMPORTED_MODULE_4_shared_util_Color__["isValidHex"](color, true)) {
                var rgbaStyle = __WEBPACK_IMPORTED_MODULE_4_shared_util_Color__["hexToRgba"](color, "1");
                var rgbaObject = __WEBPACK_IMPORTED_MODULE_4_shared_util_Color__["parseRgba"](rgbaStyle);
                _this.props.onChange(rgbaObject);
            }
        };
        _this.handlePickerChange = function (color) {
            _this.props.onChange(color.rgb);
        };
        _this.state = {
            isPickerVisible: false,
        };
        return _this;
    }
    ColorPicker.prototype.render = function () {
        var _a = this.props, color = _a.color, showInput = _a.showInput;
        var isPickerVisible = this.state.isPickerVisible;
        var hexColor = __WEBPACK_IMPORTED_MODULE_4_shared_util_Color__["formatRgbaToHex"](color).toUpperCase();
        var swatchInnerStyle = {
            width: "36px",
            height: "14px",
            borderRadius: "2px",
            background: __WEBPACK_IMPORTED_MODULE_4_shared_util_Color__["formatRgbaToStyle"](color),
        };
        var swatchOuterStyle = {
            padding: "5px",
            background: "#fff",
            borderRadius: "1px",
            boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
            display: "inline-block",
            cursor: "pointer",
        };
        var pickerPopoverStyle = {
            position: "absolute",
            left: "-20px",
            top: "30px",
            zIndex: 2,
            // zmags style overrides
            lineHeight: 1,
        };
        var pickerPopoverCoverStyle = {
            position: "fixed",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px",
        };
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", { className: "pull-left" },
                    !!showInput &&
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_color_lib_components_common__["EditableInput"], { value: hexColor, onChange: this.handleInputChange }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { onClick: this.handleClick },
                        !showInput && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { style: { padding: "0 5px", verticalAlign: "top" } }, hexColor)),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: swatchOuterStyle },
                            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: swatchInnerStyle }))))),
            isPickerVisible &&
                (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: pickerPopoverStyle },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: pickerPopoverCoverStyle, onClick: this.handleClose }),
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_color__["SketchPicker"], { color: color, onChange: this.handlePickerChange, disableAlpha: true, presetColors: [] })))));
    };
    return ColorPicker;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatePrefix = exports.inlineStyleExporter = exports.createInlineStyleExportObject = exports.getInlineStyles = exports.customStyleFns = exports.createCustomStyles = exports.mapSelectedCharacters = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _draftJs = __webpack_require__(144);

var _immutable = __webpack_require__(40);

var _lodash = __webpack_require__(2694);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(2695);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_PREFIX = 'CUSTOM_';

// This functionality has been taken from draft-js and modified for re-usability purposes.
// Maps over the selected characters, and applies a function to each character.
// Characters are of type CharacterMetadata.
var mapSelectedCharacters = exports.mapSelectedCharacters = function mapSelectedCharacters(callback) {
  return function (editorState) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var blockMap = contentState.getBlockMap();
    var startKey = selectionState.getStartKey();
    var startOffset = selectionState.getStartOffset();
    var endKey = selectionState.getEndKey();
    var endOffset = selectionState.getEndOffset();

    var newBlocks = blockMap.skipUntil(function (_, k) {
      return k === startKey;
    }).takeUntil(function (_, k) {
      return k === endKey;
    }).concat((0, _immutable.Map)([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
      var sliceStart = void 0;
      var sliceEnd = void 0;

      // sliceStart -> where the selection starts
      // endSlice -> Where the selection ends

      // Only 1 block selected
      if (startKey === endKey) {
        sliceStart = startOffset;
        sliceEnd = endOffset;
        // Gets the selected characters of the block when multiple blocks are selected.
      } else {
        sliceStart = blockKey === startKey ? startOffset : 0;
        sliceEnd = blockKey === endKey ? endOffset : block.getLength();
      }

      // Get the characters of the current block
      var chars = block.getCharacterList();
      var current = void 0;
      while (sliceStart < sliceEnd) {
        current = chars.get(sliceStart);
        var newChar = callback(current);
        chars = chars.set(sliceStart, newChar);
        sliceStart++;
      }

      return block.set('characterList', chars);
    });

    return contentState.merge({
      blockMap: blockMap.merge(newBlocks),
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };
};

var getContentStateWithoutStyle = function getContentStateWithoutStyle(prefix, editorState) {
  return mapSelectedCharacters(filterDynamicStyle(prefix))(editorState);
};

var filterDynamicStyle = function filterDynamicStyle(prefix) {
  return function (char) {
    var charStyles = char.get('style');
    var filteredStyles = charStyles.filter(function (style) {
      return !style.startsWith(prefix);
    });
    return char.set('style', filteredStyles);
  };
};

var addStyle = function addStyle(prefix) {
  return function (editorState, value) {
    var style = prefix + value;
    var newContentState = _draftJs.Modifier.applyInlineStyle(getContentStateWithoutStyle(prefix, editorState), editorState.getSelection(), style);

    var isCollapsed = editorState.getSelection().isCollapsed();
    if (isCollapsed) {
      return addInlineStyleOverride(prefix, style, editorState);
    }

    return _draftJs.EditorState.push(editorState, newContentState, 'change-inline-style');
  };
};

var removeStyle = function removeStyle(prefix) {
  return function (editorState) {
    return _draftJs.EditorState.push(editorState, getContentStateWithoutStyle(prefix, editorState), 'change-inline-style');
  };
};

var filterOverrideStyles = function filterOverrideStyles(prefix, styles) {
  return styles.filter(function (style) {
    return !style.startsWith(prefix);
  });
};

var addInlineStyleOverride = function addInlineStyleOverride(prefix, style, editorState) {
  var currentStyle = editorState.getCurrentInlineStyle();

  // We remove styles with the prefix from the OrderedSet to avoid having
  // variants of the same prefix.
  var newStyles = filterOverrideStyles(prefix, currentStyle);

  return _draftJs.EditorState.setInlineStyleOverride(editorState, newStyles.add(style));
};

var toggleInlineStyleOverride = function toggleInlineStyleOverride(prefix, style, editorState) {
  var currentStyle = editorState.getCurrentInlineStyle();

  // We remove styles with the prefix from the OrderedSet to avoid having
  // variants of the same prefix.
  var newStyles = filterOverrideStyles(prefix, currentStyle);

  var styleOverride = currentStyle.has(style) ? newStyles.remove(style) : newStyles.add(style);

  return _draftJs.EditorState.setInlineStyleOverride(editorState, styleOverride);
};

var toggleStyle = function toggleStyle(prefix) {
  return function (editorState, value) {
    var style = prefix + value;
    var currentStyle = editorState.getCurrentInlineStyle();
    var isCollapsed = editorState.getSelection().isCollapsed();

    if (isCollapsed) {
      return toggleInlineStyleOverride(prefix, style, editorState);
    }

    if (!currentStyle.has(style)) {
      return addStyle(prefix)(editorState, value);
    }

    var editorStateWithoutCustomStyles = _draftJs.EditorState.push(editorState, getContentStateWithoutStyle(prefix, editorState), 'change-inline-style');
    return _draftJs.EditorState.forceSelection(editorStateWithoutCustomStyles, editorState.getSelection());
  };
};

/**
 *  style is an OrderedSet type
 */
var styleFn = function styleFn(prefix, cssProp) {
  return function (style) {
    if (!style.size) {
      return {};
    }
    var value = style.filter(function (val) {
      return val.startsWith(prefix);
    }).first();
    if (value) {
      var newVal = value.replace(prefix, '');
      return _defineProperty({}, (0, _lodash2.default)(cssProp), newVal);
    }
    return {};
  };
};

var currentStyle = function currentStyle(prefix) {
  return function (editorState) {
    var selectionStyles = editorState.getCurrentInlineStyle();
    if (!selectionStyles.size) {
      return '';
    }

    var result = selectionStyles.filter(function (style) {
      return style.startsWith(prefix);
    }).first();

    return result ? result.replace(prefix, '') : result;
  };
};

var createCustomStyles = exports.createCustomStyles = function createCustomStyles(prefix, conf) {
  return conf.reduce(function (acc, prop) {
    var camelCased = (0, _lodash2.default)(prop);
    var newPrefix = '' + prefix + (0, _lodash4.default)(prop).toUpperCase() + '_';
    var copy = _extends({}, acc);
    copy[camelCased] = {
      add: addStyle(newPrefix),
      remove: removeStyle(newPrefix),
      toggle: toggleStyle(newPrefix),
      current: currentStyle(newPrefix),
      styleFn: styleFn(newPrefix, prop)
    };

    return copy;
  }, {});
};

// customStyleFns
var customStyleFns = exports.customStyleFns = function customStyleFns(fnList) {
  return function (prefixedStyle) {
    return fnList.reduce(function (css, fn) {
      return _extends({}, css, fn(prefixedStyle));
    }, {});
  };
};

// exporter
var getInlineStyles = exports.getInlineStyles = function getInlineStyles(acc, block) {
  var styleRanges = block.inlineStyleRanges;
  if (styleRanges && styleRanges.length) {
    var result = styleRanges.map(function (style) {
      return style.style;
    });

    return acc.concat(result);
  }
  return acc;
};

var createInlineStyleExportObject = exports.createInlineStyleExportObject = function createInlineStyleExportObject(prefix, customStyleMap) {
  return function (acc, style) {
    // default inline styles
    if (_draftJs.DefaultDraftInlineStyle[style]) {
      return Object.assign({}, acc, _defineProperty({}, style, {
        style: _draftJs.DefaultDraftInlineStyle[style]
      }));
    }

    // custom styleMap styles
    if (customStyleMap[style]) {
      return Object.assign({}, acc, _defineProperty({}, style, {
        style: customStyleMap[style]
      }));
    }

    var regex = new RegExp(prefix + '(.+)_(.+)');
    var match = style.match(regex);

    // no matches
    if (!match || !match[1] || !match[2]) {
      return acc;
    }

    // custom styles
    var css = match[1].toLowerCase();
    var value = match[2];
    var inlineStyle = _defineProperty({}, style, {
      style: _defineProperty({}, (0, _lodash2.default)(css), value)
    });

    return Object.assign({}, acc, inlineStyle);
  };
};

var inlineStyleExporter = exports.inlineStyleExporter = function inlineStyleExporter(prefix, customStyleMap) {
  return function (editorState) {
    var inlineStyles = (0, _draftJs.convertToRaw)(editorState.getCurrentContent()).blocks.reduce(getInlineStyles, []);
    if (!inlineStyles.length) return {};
    return inlineStyles.reduce(createInlineStyleExportObject(prefix, customStyleMap), {});
  };
};

var validatePrefix = exports.validatePrefix = function validatePrefix(prefix) {
  if (typeof prefix !== 'string' || !prefix.length) {
    return DEFAULT_PREFIX;
  }

  if (prefix.match(/.+_$/)) {
    return prefix;
  }

  return prefix + '_';
};

exports.default = function (conf) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PREFIX;
  var customStyleMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!conf) {
    console.log('Expecting an array with css properties');
    return { styles: {} };
  }

  if (!Array.isArray(conf) || !conf.length) {
    console.log('createStyles expects first parameter to be an array with css properties');
    return { styles: {} };
  }

  var checkedPrefix = validatePrefix(prefix);
  var styles = createCustomStyles(checkedPrefix, conf);
  var fnList = Object.keys(styles).map(function (style) {
    return styles[style].styleFn;
  });
  var customStyleFn = customStyleFns(fnList);
  var exporter = inlineStyleExporter(checkedPrefix, customStyleMap);

  return {
    styles: styles,
    customStyleFn: customStyleFn,
    exporter: exporter
  };
};

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboMarksRange + rsComboSymbolsRange + rsVarRange + ']');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = camelCase;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = snakeCase;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseHTML = exports.convertFromHTML = exports.convertToHTML = undefined;

var _convertToHTML = __webpack_require__(2697);

var _convertToHTML2 = _interopRequireDefault(_convertToHTML);

var _convertFromHTML = __webpack_require__(2709);

var _convertFromHTML2 = _interopRequireDefault(_convertFromHTML);

var _parseHTML = __webpack_require__(1183);

var _parseHTML2 = _interopRequireDefault(_parseHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.convertToHTML = _convertToHTML2.default;
exports.convertFromHTML = _convertFromHTML2.default;
exports.parseHTML = _parseHTML2.default;

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__(138);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(458);

var _server2 = _interopRequireDefault(_server);

var _draftJs = __webpack_require__(144);

var _encodeBlock = __webpack_require__(2699);

var _encodeBlock2 = _interopRequireDefault(_encodeBlock);

var _blockEntities = __webpack_require__(2700);

var _blockEntities2 = _interopRequireDefault(_blockEntities);

var _blockInlineStyles = __webpack_require__(2702);

var _blockInlineStyles2 = _interopRequireDefault(_blockInlineStyles);

var _accumulateFunction = __webpack_require__(1182);

var _accumulateFunction2 = _interopRequireDefault(_accumulateFunction);

var _blockTypeObjectFunction = __webpack_require__(2705);

var _blockTypeObjectFunction2 = _interopRequireDefault(_blockTypeObjectFunction);

var _getBlockTags = __webpack_require__(2706);

var _getBlockTags2 = _interopRequireDefault(_getBlockTags);

var _getNestedBlockTags = __webpack_require__(2707);

var _getNestedBlockTags2 = _interopRequireDefault(_getNestedBlockTags);

var _defaultBlockHTML = __webpack_require__(2708);

var _defaultBlockHTML2 = _interopRequireDefault(_defaultBlockHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Immutable from 'immutable'; // eslint-disable-line no-unused-vars
var defaultEntityToHTML = function defaultEntityToHTML(entity, originalText) {
  return originalText;
};

var convertToHTML = function convertToHTML(_ref) {
  var _ref$styleToHTML = _ref.styleToHTML,
      styleToHTML = _ref$styleToHTML === undefined ? {} : _ref$styleToHTML,
      _ref$blockToHTML = _ref.blockToHTML,
      blockToHTML = _ref$blockToHTML === undefined ? {} : _ref$blockToHTML,
      _ref$entityToHTML = _ref.entityToHTML,
      entityToHTML = _ref$entityToHTML === undefined ? defaultEntityToHTML : _ref$entityToHTML;
  return function (contentState) {
    (0, _invariant2.default)(contentState !== null && contentState !== undefined, 'Expected contentState to be non-null');

    var getBlockHTML = void 0;
    if (blockToHTML.__isMiddleware === true) {
      getBlockHTML = blockToHTML((0, _blockTypeObjectFunction2.default)(_defaultBlockHTML2.default));
    } else {
      getBlockHTML = (0, _accumulateFunction2.default)((0, _blockTypeObjectFunction2.default)(blockToHTML), (0, _blockTypeObjectFunction2.default)(_defaultBlockHTML2.default));
    }

    var rawState = (0, _draftJs.convertToRaw)(contentState);

    var listStack = [];

    var result = rawState.blocks.map(function (block) {
      var type = block.type,
          depth = block.depth;


      var closeNestTags = '';
      var openNestTags = '';

      var blockHTMLResult = getBlockHTML(block);
      if (!blockHTMLResult) {
        throw new Error('convertToHTML: missing HTML definition for block with type ' + block.type);
      }

      if (!blockHTMLResult.nest) {
        // this block can't be nested, so reset all nesting if necessary
        closeNestTags = listStack.reduceRight(function (string, nestedBlock) {
          return string + (0, _getNestedBlockTags2.default)(getBlockHTML(nestedBlock)).nestEnd;
        }, '');
        listStack = [];
      } else {
        while (depth + 1 !== listStack.length || type !== listStack[depth].type) {
          if (depth + 1 === listStack.length) {
            // depth is right but doesn't match type
            var blockToClose = listStack[depth];
            closeNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(blockToClose)).nestEnd;
            openNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(block)).nestStart;
            listStack[depth] = block;
          } else if (depth + 1 < listStack.length) {
            var _blockToClose = listStack[listStack.length - 1];
            closeNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(_blockToClose)).nestEnd;
            listStack = listStack.slice(0, -1);
          } else {
            openNestTags += (0, _getNestedBlockTags2.default)(getBlockHTML(block)).nestStart;
            listStack.push(block);
          }
        }
      }

      var innerHTML = (0, _blockInlineStyles2.default)((0, _blockEntities2.default)((0, _encodeBlock2.default)(block), rawState.entityMap, entityToHTML), styleToHTML);

      var blockHTML = (0, _getBlockTags2.default)(getBlockHTML(block));

      var html = void 0;

      if (typeof blockHTML === 'string') {
        html = blockHTML;
      } else {
        html = blockHTML.start + innerHTML + blockHTML.end;
      }

      if (innerHTML.length === 0 && Object.prototype.hasOwnProperty.call(blockHTML, 'empty')) {
        if (_react2.default.isValidElement(blockHTML.empty)) {
          html = _server2.default.renderToStaticMarkup(blockHTML.empty);
        } else {
          html = blockHTML.empty;
        }
      }

      return closeNestTags + openNestTags + html;
    }).join('');

    result = listStack.reduce(function (res, nestBlock) {
      return res + (0, _getNestedBlockTags2.default)(getBlockHTML(nestBlock)).nestEnd;
    }, result);

    return result;
  };
};

exports.default = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args.length === 1 && Object.prototype.hasOwnProperty.call(args[0], '_map') && args[0].getBlockMap != null) {
    // skip higher-order function and use defaults
    return convertToHTML({}).apply(undefined, args);
  }

  return convertToHTML.apply(undefined, args);
};

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(73),l=__webpack_require__(0);function q(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var t="function"===typeof Symbol&&Symbol.for,aa=t?Symbol.for("react.portal"):60106,u=t?Symbol.for("react.fragment"):60107,ba=t?Symbol.for("react.strict_mode"):60108,ca=t?Symbol.for("react.profiler"):60114,w=t?Symbol.for("react.provider"):60109,da=t?Symbol.for("react.context"):60110,ea=t?Symbol.for("react.concurrent_mode"):60111,fa=t?Symbol.for("react.forward_ref"):60112,B=t?Symbol.for("react.suspense"):60113,ha=t?Symbol.for("react.suspense_list"):60120,ia=t?Symbol.for("react.memo"):60115,ja=t?Symbol.for("react.lazy"):
60116,ka=t?Symbol.for("react.fundamental"):60117,la=t?Symbol.for("react.scope"):60119,C=l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;C.hasOwnProperty("ReactCurrentDispatcher")||(C.ReactCurrentDispatcher={current:null});C.hasOwnProperty("ReactCurrentBatchConfig")||(C.ReactCurrentBatchConfig={suspense:null});
function ma(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(c){0===a._status&&(c=c.default,a._status=1,a._result=c)},function(c){0===a._status&&(a._status=2,a._result=c)})}}
function D(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case u:return"Fragment";case aa:return"Portal";case ca:return"Profiler";case ba:return"StrictMode";case B:return"Suspense";case ha:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case da:return"Context.Consumer";case w:return"Context.Provider";case fa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");
case ia:return D(a.type);case ja:if(a=1===a._status?a._result:null)return D(a)}return null}var na={};function E(a,b){for(var c=a._threadCount|0;c<=b;c++)a[c]=a._currentValue2,a._threadCount=c+1}function oa(a,b,c,d){if(d&&(d=a.contextType,"object"===typeof d&&null!==d))return E(d,c),d[c];if(a=a.contextTypes){c={};for(var f in a)c[f]=b[f];b=c}else b=na;return b}for(var F=new Uint16Array(16),H=0;15>H;H++)F[H]=H+1;F[15]=0;
var pa=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,qa=Object.prototype.hasOwnProperty,ra={},sa={};
function ta(a){if(qa.call(sa,a))return!0;if(qa.call(ra,a))return!1;if(pa.test(a))return sa[a]=!0;ra[a]=!0;return!1}function ua(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function va(a,b,c,d){if(null===b||"undefined"===typeof b||ua(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function J(a,b,c,d,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=f;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=g}var K={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){K[a]=new J(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];K[b]=new J(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){K[a]=new J(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){K[a]=new J(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){K[a]=new J(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){K[a]=new J(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){K[a]=new J(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){K[a]=new J(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){K[a]=new J(a,5,!1,a.toLowerCase(),null,!1)});var L=/[\-:]([a-z])/g;function M(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(L,
M);K[b]=new J(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(L,M);K[b]=new J(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!1)});
K.xlinkHref=new J("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){K[a]=new J(a,1,!1,a.toLowerCase(),null,!0)});var wa=/["'&<>]/;
function N(a){if("boolean"===typeof a||"number"===typeof a)return""+a;a=""+a;var b=wa.exec(a);if(b){var c="",d,f=0;for(d=b.index;d<a.length;d++){switch(a.charCodeAt(d)){case 34:b="&quot;";break;case 38:b="&amp;";break;case 39:b="&#x27;";break;case 60:b="&lt;";break;case 62:b="&gt;";break;default:continue}f!==d&&(c+=a.substring(f,d));f=d+1;c+=b}a=f!==d?c+a.substring(f,d):c}return a}
function xa(a,b){var c=K.hasOwnProperty(a)?K[a]:null;var d;if(d="style"!==a)d=null!==c?0===c.type:!(2<a.length)||"o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]?!1:!0;if(d||va(a,b,c,!1))return"";if(null!==c){a=c.attributeName;d=c.type;if(3===d||4===d&&!0===b)return a+'=""';c.sanitizeURL&&(b=""+b);return a+"="+('"'+N(b)+'"')}return ta(a)?a+"="+('"'+N(b)+'"'):""}function ya(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}
var za="function"===typeof Object.is?Object.is:ya,O=null,P=null,Q=null,R=!1,S=!1,U=null,V=0;function W(){if(null===O)throw Error(q(321));return O}function Aa(){if(0<V)throw Error(q(312));return{memoizedState:null,queue:null,next:null}}function Ba(){null===Q?null===P?(R=!1,P=Q=Aa()):(R=!0,Q=P):null===Q.next?(R=!1,Q=Q.next=Aa()):(R=!0,Q=Q.next);return Q}function Ca(a,b,c,d){for(;S;)S=!1,V+=1,Q=null,c=a(b,d);P=O=null;V=0;Q=U=null;return c}function Da(a,b){return"function"===typeof b?b(a):b}
function Ea(a,b,c){O=W();Q=Ba();if(R){var d=Q.queue;b=d.dispatch;if(null!==U&&(c=U.get(d),void 0!==c)){U.delete(d);d=Q.memoizedState;do d=a(d,c.action),c=c.next;while(null!==c);Q.memoizedState=d;return[d,b]}return[Q.memoizedState,b]}a=a===Da?"function"===typeof b?b():b:void 0!==c?c(b):b;Q.memoizedState=a;a=Q.queue={last:null,dispatch:null};a=a.dispatch=Fa.bind(null,O,a);return[Q.memoizedState,a]}
function Fa(a,b,c){if(!(25>V))throw Error(q(301));if(a===O)if(S=!0,a={action:c,next:null},null===U&&(U=new Map),c=U.get(b),void 0===c)U.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}}function Ga(){}
var X=0,Ha={readContext:function(a){var b=X;E(a,b);return a[b]},useContext:function(a){W();var b=X;E(a,b);return a[b]},useMemo:function(a,b){O=W();Q=Ba();b=void 0===b?null:b;if(null!==Q){var c=Q.memoizedState;if(null!==c&&null!==b){a:{var d=c[1];if(null===d)d=!1;else{for(var f=0;f<d.length&&f<b.length;f++)if(!za(b[f],d[f])){d=!1;break a}d=!0}}if(d)return c[0]}}a=a();Q.memoizedState=[a,b];return a},useReducer:Ea,useRef:function(a){O=W();Q=Ba();var b=Q.memoizedState;return null===b?(a={current:a},Q.memoizedState=
a):b},useState:function(a){return Ea(Da,a)},useLayoutEffect:function(){},useCallback:function(a){return a},useImperativeHandle:Ga,useEffect:Ga,useDebugValue:Ga,useResponder:function(a,b){return{props:b,responder:a}},useDeferredValue:function(a){W();return a},useTransition:function(){W();return[function(a){a()},!1]}},Ia={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var Ka={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},La=k({menuitem:!0},Ka),Y={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,
gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ma=["Webkit","ms","Moz","O"];Object.keys(Y).forEach(function(a){Ma.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Y[b]=Y[a]})});
var Na=/([A-Z])/g,Oa=/^ms-/,Z=l.Children.toArray,Pa=C.ReactCurrentDispatcher,Qa={listing:!0,pre:!0,textarea:!0},Ra=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Sa={},Ta={};function Ua(a){if(void 0===a||null===a)return a;var b="";l.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}var Va=Object.prototype.hasOwnProperty,Wa={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null,suppressHydrationWarning:null};function Xa(a,b){if(void 0===a)throw Error(q(152,D(b)||"Component"));}
function Ya(a,b,c){function d(d,g){var e=g.prototype&&g.prototype.isReactComponent,f=oa(g,b,c,e),x=[],h=!1,m={isMounted:function(){return!1},enqueueForceUpdate:function(){if(null===x)return null},enqueueReplaceState:function(a,c){h=!0;x=[c]},enqueueSetState:function(a,c){if(null===x)return null;x.push(c)}};if(e){if(e=new g(d.props,f,m),"function"===typeof g.getDerivedStateFromProps){var v=g.getDerivedStateFromProps.call(null,d.props,e.state);null!=v&&(e.state=k({},e.state,v))}}else if(O={},e=g(d.props,
f,m),e=Ca(g,d.props,e,f),null==e||null==e.render){a=e;Xa(a,g);return}e.props=d.props;e.context=f;e.updater=m;m=e.state;void 0===m&&(e.state=m=null);if("function"===typeof e.UNSAFE_componentWillMount||"function"===typeof e.componentWillMount)if("function"===typeof e.componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&"function"!==typeof g.getDerivedStateFromProps&&e.UNSAFE_componentWillMount(),x.length){m=x;var r=
h;x=null;h=!1;if(r&&1===m.length)e.state=m[0];else{v=r?m[0]:e.state;var y=!0;for(r=r?1:0;r<m.length;r++){var p=m[r];p="function"===typeof p?p.call(e,v,d.props,f):p;null!=p&&(y?(y=!1,v=k({},v,p)):k(v,p))}e.state=v}}else x=null;a=e.render();Xa(a,g);if("function"===typeof e.getChildContext&&(d=g.childContextTypes,"object"===typeof d)){var A=e.getChildContext();for(var T in A)if(!(T in d))throw Error(q(108,D(g)||"Unknown",T));}A&&(b=k({},b,A))}for(;l.isValidElement(a);){var f=a,g=f.type;if("function"!==
typeof g)break;d(f,g)}return{child:a,context:b}}
var Za=function(){function a(a,b){l.isValidElement(a)?a.type!==u?a=[a]:(a=a.props.children,a=l.isValidElement(a)?[a]:Z(a)):a=Z(a);a={type:null,domNamespace:Ia.html,children:a,childIndex:0,context:na,footer:""};var c=F[0];if(0===c){var g=F;c=g.length;var d=2*c;if(!(65536>=d))throw Error(q(304));var h=new Uint16Array(d);h.set(g);F=h;F[0]=c+1;for(g=c;g<d-1;g++)F[g]=g+1;F[d-1]=0}else F[0]=F[c];this.threadID=c;this.stack=[a];this.exhausted=!1;this.currentSelectValue=null;this.previousWasTextNode=!1;this.makeStaticMarkup=
b;this.suspenseDepth=0;this.contextIndex=-1;this.contextStack=[];this.contextValueStack=[]}var b=a.prototype;b.destroy=function(){if(!this.exhausted){this.exhausted=!0;this.clearProviders();var a=this.threadID;F[a]=F[0];F[0]=a}};b.pushProvider=function(a){var c=++this.contextIndex,b=a.type._context,g=this.threadID;E(b,g);var x=b[g];this.contextStack[c]=b;this.contextValueStack[c]=x;b[g]=a.props.value};b.popProvider=function(){var a=this.contextIndex,b=this.contextStack[a],f=this.contextValueStack[a];
this.contextStack[a]=null;this.contextValueStack[a]=null;this.contextIndex--;b[this.threadID]=f};b.clearProviders=function(){for(var a=this.contextIndex;0<=a;a--)this.contextStack[a][this.threadID]=this.contextValueStack[a]};b.read=function(a){if(this.exhausted)return null;var b=X;X=this.threadID;var c=Pa.current;Pa.current=Ha;try{for(var g=[""],x=!1;g[0].length<a;){if(0===this.stack.length){this.exhausted=!0;var h=this.threadID;F[h]=F[0];F[0]=h;break}var e=this.stack[this.stack.length-1];if(x||e.childIndex>=
e.children.length){var I=e.footer;""!==I&&(this.previousWasTextNode=!1);this.stack.pop();if("select"===e.type)this.currentSelectValue=null;else if(null!=e.type&&null!=e.type.type&&e.type.type.$$typeof===w)this.popProvider(e.type);else if(e.type===B){this.suspenseDepth--;var G=g.pop();if(x){x=!1;var n=e.fallbackFrame;if(!n)throw Error(q(303));this.stack.push(n);g[this.suspenseDepth]+="\x3c!--$!--\x3e";continue}else g[this.suspenseDepth]+=G}g[this.suspenseDepth]+=I}else{var m=e.children[e.childIndex++],
v="";try{v+=this.render(m,e.context,e.domNamespace)}catch(r){if(null!=r&&"function"===typeof r.then)throw Error(q(294));throw r;}finally{}g.length<=this.suspenseDepth&&g.push("");g[this.suspenseDepth]+=v}}return g[0]}finally{Pa.current=c,X=b}};b.render=function(a,b,f){if("string"===typeof a||"number"===typeof a){f=""+a;if(""===f)return"";if(this.makeStaticMarkup)return N(f);if(this.previousWasTextNode)return"\x3c!-- --\x3e"+N(f);this.previousWasTextNode=!0;return N(f)}b=Ya(a,b,this.threadID);a=b.child;
b=b.context;if(null===a||!1===a)return"";if(!l.isValidElement(a)){if(null!=a&&null!=a.$$typeof){f=a.$$typeof;if(f===aa)throw Error(q(257));throw Error(q(258,f.toString()));}a=Z(a);this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""});return""}var c=a.type;if("string"===typeof c)return this.renderDOM(a,b,f);switch(c){case ba:case ea:case ca:case ha:case u:return a=Z(a.props.children),this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),
"";case B:throw Error(q(294));}if("object"===typeof c&&null!==c)switch(c.$$typeof){case fa:O={};var d=c.render(a.props,a.ref);d=Ca(c.render,a.props,d,a.ref);d=Z(d);this.stack.push({type:null,domNamespace:f,children:d,childIndex:0,context:b,footer:""});return"";case ia:return a=[l.createElement(c.type,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case w:return c=Z(a.props.children),f={type:a,domNamespace:f,children:c,childIndex:0,
context:b,footer:""},this.pushProvider(a),this.stack.push(f),"";case da:c=a.type;d=a.props;var h=this.threadID;E(c,h);c=Z(d.children(c[h]));this.stack.push({type:a,domNamespace:f,children:c,childIndex:0,context:b,footer:""});return"";case ka:throw Error(q(338));case ja:switch(c=a.type,ma(c),c._status){case 1:return a=[l.createElement(c._result,k({ref:a.ref},a.props))],this.stack.push({type:null,domNamespace:f,children:a,childIndex:0,context:b,footer:""}),"";case 2:throw c._result;default:throw Error(q(295));
}case la:throw Error(q(343));}throw Error(q(130,null==c?c:typeof c,""));};b.renderDOM=function(a,b,f){var c=a.type.toLowerCase();f===Ia.html&&Ja(c);if(!Sa.hasOwnProperty(c)){if(!Ra.test(c))throw Error(q(65,c));Sa[c]=!0}var d=a.props;if("input"===c)d=k({type:void 0},d,{defaultChecked:void 0,defaultValue:void 0,value:null!=d.value?d.value:d.defaultValue,checked:null!=d.checked?d.checked:d.defaultChecked});else if("textarea"===c){var h=d.value;if(null==h){h=d.defaultValue;var e=d.children;if(null!=e){if(null!=
h)throw Error(q(92));if(Array.isArray(e)){if(!(1>=e.length))throw Error(q(93));e=e[0]}h=""+e}null==h&&(h="")}d=k({},d,{value:void 0,children:""+h})}else if("select"===c)this.currentSelectValue=null!=d.value?d.value:d.defaultValue,d=k({},d,{value:void 0});else if("option"===c){e=this.currentSelectValue;var I=Ua(d.children);if(null!=e){var G=null!=d.value?d.value+"":I;h=!1;if(Array.isArray(e))for(var n=0;n<e.length;n++){if(""+e[n]===G){h=!0;break}}else h=""+e===G;d=k({selected:void 0,children:void 0},
d,{selected:h,children:I})}}if(h=d){if(La[c]&&(null!=h.children||null!=h.dangerouslySetInnerHTML))throw Error(q(137,c,""));if(null!=h.dangerouslySetInnerHTML){if(null!=h.children)throw Error(q(60));if(!("object"===typeof h.dangerouslySetInnerHTML&&"__html"in h.dangerouslySetInnerHTML))throw Error(q(61));}if(null!=h.style&&"object"!==typeof h.style)throw Error(q(62,""));}h=d;e=this.makeStaticMarkup;I=1===this.stack.length;G="<"+a.type;for(z in h)if(Va.call(h,z)){var m=h[z];if(null!=m){if("style"===
z){n=void 0;var v="",r="";for(n in m)if(m.hasOwnProperty(n)){var y=0===n.indexOf("--"),p=m[n];if(null!=p){if(y)var A=n;else if(A=n,Ta.hasOwnProperty(A))A=Ta[A];else{var T=A.replace(Na,"-$1").toLowerCase().replace(Oa,"-ms-");A=Ta[A]=T}v+=r+A+":";r=n;y=null==p||"boolean"===typeof p||""===p?"":y||"number"!==typeof p||0===p||Y.hasOwnProperty(r)&&Y[r]?(""+p).trim():p+"px";v+=y;r=";"}}m=v||null}n=null;b:if(y=c,p=h,-1===y.indexOf("-"))y="string"===typeof p.is;else switch(y){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":y=
!1;break b;default:y=!0}y?Wa.hasOwnProperty(z)||(n=z,n=ta(n)&&null!=m?n+"="+('"'+N(m)+'"'):""):n=xa(z,m);n&&(G+=" "+n)}}e||I&&(G+=' data-reactroot=""');var z=G;h="";Ka.hasOwnProperty(c)?z+="/>":(z+=">",h="</"+a.type+">");a:{e=d.dangerouslySetInnerHTML;if(null!=e){if(null!=e.__html){e=e.__html;break a}}else if(e=d.children,"string"===typeof e||"number"===typeof e){e=N(e);break a}e=null}null!=e?(d=[],Qa[c]&&"\n"===e.charAt(0)&&(z+="\n"),z+=e):d=Z(d.children);a=a.type;f=null==f||"http://www.w3.org/1999/xhtml"===
f?Ja(a):"http://www.w3.org/2000/svg"===f&&"foreignObject"===a?"http://www.w3.org/1999/xhtml":f;this.stack.push({domNamespace:f,type:c,children:d,childIndex:0,context:b,footer:h});this.previousWasTextNode=!1;return z};return a}(),$a={renderToString:function(a){a=new Za(a,!1);try{return a.read(Infinity)}finally{a.destroy()}},renderToStaticMarkup:function(a){a=new Za(a,!0);try{return a.read(Infinity)}finally{a.destroy()}},renderToNodeStream:function(){throw Error(q(207));},renderToStaticNodeStream:function(){throw Error(q(208));
},version:"16.12.0"},ab={default:$a},bb=ab&&$a||ab;module.exports=bb.default||bb;


/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _updateMutation = __webpack_require__(1180);

var _updateMutation2 = _interopRequireDefault(_updateMutation);

var _rangeSort = __webpack_require__(459);

var _rangeSort2 = _interopRequireDefault(_rangeSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var ENTITY_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '\n': '<br/>'
};

exports.default = function (block) {
  var blockText = [].concat(_toConsumableArray(block.text));

  var entities = block.entityRanges.sort(_rangeSort2.default);
  var styles = block.inlineStyleRanges.sort(_rangeSort2.default);
  var resultText = '';

  var _loop = function _loop(index) {
    var char = blockText[index];

    if (ENTITY_MAP[char] !== undefined) {
      (function () {
        var encoded = ENTITY_MAP[char];
        var resultIndex = [].concat(_toConsumableArray(resultText)).length;
        resultText += encoded;

        var updateForChar = function updateForChar(mutation) {
          return (0, _updateMutation2.default)(mutation, resultIndex, char.length, encoded.length, 0, 0);
        };

        entities = entities.map(updateForChar);
        styles = styles.map(updateForChar);
      })();
    } else {
      resultText += char;
    }
  };

  for (var index = 0; index < blockText.length; index++) {
    _loop(index);
  }

  return Object.assign({}, block, {
    text: resultText,
    inlineStyleRanges: styles,
    entityRanges: entities
  });
};

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _updateMutation = __webpack_require__(1180);

var _updateMutation2 = _interopRequireDefault(_updateMutation);

var _rangeSort = __webpack_require__(459);

var _rangeSort2 = _interopRequireDefault(_rangeSort);

var _getElementHTML = __webpack_require__(1181);

var _getElementHTML2 = _interopRequireDefault(_getElementHTML);

var _getElementTagLength = __webpack_require__(2701);

var _getElementTagLength2 = _interopRequireDefault(_getElementTagLength);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var converter = function converter() {
  var entity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var originalText = arguments[1];

  return originalText;
};

exports.default = function (block, entityMap) {
  var entityConverter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : converter;

  var resultText = [].concat(_toConsumableArray(block.text));

  var getEntityHTML = entityConverter;

  if (entityConverter.__isMiddleware) {
    getEntityHTML = entityConverter(converter);
  }

  if (Object.prototype.hasOwnProperty.call(block, 'entityRanges') && block.entityRanges.length > 0) {
    var entities = block.entityRanges.sort(_rangeSort2.default);

    var styles = block.inlineStyleRanges;

    var _loop = function _loop(index) {
      var entityRange = entities[index];
      var entity = entityMap[entityRange.key];

      var originalText = resultText.slice(entityRange.offset, entityRange.offset + entityRange.length).join('');

      var entityHTML = getEntityHTML(entity, originalText);
      var converted = [].concat(_toConsumableArray((0, _getElementHTML2.default)(entityHTML, originalText) || originalText));

      var prefixLength = (0, _getElementTagLength2.default)(entityHTML, 'start');
      var suffixLength = (0, _getElementTagLength2.default)(entityHTML, 'end');

      var updateLaterMutation = function updateLaterMutation(mutation, mutationIndex) {
        if (mutationIndex > index || Object.prototype.hasOwnProperty.call(mutation, 'style')) {
          return (0, _updateMutation2.default)(mutation, entityRange.offset, entityRange.length, converted.length, prefixLength, suffixLength);
        }
        return mutation;
      };

      var updateLaterMutations = function updateLaterMutations(mutationList) {
        return mutationList.reduce(function (acc, mutation, mutationIndex) {
          var updatedMutation = updateLaterMutation(mutation, mutationIndex);
          if (Array.isArray(updatedMutation)) {
            return acc.concat(updatedMutation);
          }

          return acc.concat([updatedMutation]);
        }, []);
      };

      entities = updateLaterMutations(entities);
      styles = updateLaterMutations(styles);

      resultText = [].concat(_toConsumableArray(resultText.slice(0, entityRange.offset)), _toConsumableArray(converted), _toConsumableArray(resultText.slice(entityRange.offset + entityRange.length)));
    };

    for (var index = 0; index < entities.length; index++) {
      _loop(index);
    }

    return Object.assign({}, block, {
      text: resultText.join(''),
      inlineStyleRanges: styles,
      entityRanges: entities
    });
  }

  return block;
};

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _splitReactElement = __webpack_require__(460);

var _splitReactElement2 = _interopRequireDefault(_splitReactElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getElementTagLength = function getElementTagLength(element) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';

  if (_react2.default.isValidElement(element)) {
    var splitElement = (0, _splitReactElement2.default)(element);
    if (typeof splitElement === 'string') {
      return 0;
    }

    var length = splitElement[type].length;

    var child = _react2.default.Children.toArray(element.props.children)[0];
    return length + (child && _react2.default.isValidElement(child) ? getElementTagLength(child, type) : 0);
  }

  if ((typeof element === 'undefined' ? 'undefined' : _typeof(element)) === 'object') {
    return element[type] ? element[type].length : 0;
  }

  return 0;
};

exports.default = getElementTagLength;

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = __webpack_require__(138);

var _invariant2 = _interopRequireDefault(_invariant);

var _styleObjectFunction = __webpack_require__(2703);

var _styleObjectFunction2 = _interopRequireDefault(_styleObjectFunction);

var _accumulateFunction = __webpack_require__(1182);

var _accumulateFunction2 = _interopRequireDefault(_accumulateFunction);

var _getElementHTML = __webpack_require__(1181);

var _getElementHTML2 = _interopRequireDefault(_getElementHTML);

var _rangeSort = __webpack_require__(459);

var _rangeSort2 = _interopRequireDefault(_rangeSort);

var _defaultInlineHTML = __webpack_require__(2704);

var _defaultInlineHTML2 = _interopRequireDefault(_defaultInlineHTML);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var subtractStyles = function subtractStyles(original, toRemove) {
  return original.filter(function (el) {
    return !toRemove.some(function (elToRemove) {
      return elToRemove.style === el.style;
    });
  });
};

var popEndingStyles = function popEndingStyles(styleStack, endingStyles) {
  return endingStyles.reduceRight(function (stack, style) {
    var styleToRemove = stack[stack.length - 1];

    (0, _invariant2.default)(styleToRemove.style === style.style, 'Style ' + styleToRemove.style + ' to be removed doesn\'t match expected ' + style.style);

    return stack.slice(0, -1);
  }, styleStack);
};

var characterStyles = function characterStyles(offset, ranges) {
  return ranges.filter(function (range) {
    return offset >= range.offset && offset < range.offset + range.length;
  });
};

var rangeIsSubset = function rangeIsSubset(firstRange, secondRange) {
  // returns true if the second range is a subset of the first
  var secondStartWithinFirst = firstRange.offset <= secondRange.offset;
  var secondEndWithinFirst = firstRange.offset + firstRange.length >= secondRange.offset + secondRange.length;

  return secondStartWithinFirst && secondEndWithinFirst;
};

var latestStyleLast = function latestStyleLast(s1, s2) {
  // make sure longer-lasting styles are added first
  var s2endIndex = s2.offset + s2.length;
  var s1endIndex = s1.offset + s1.length;
  return s2endIndex - s1endIndex;
};

var getStylesToReset = function getStylesToReset(remainingStyles, newStyles) {
  var i = 0;
  while (i < remainingStyles.length) {
    if (newStyles.every(rangeIsSubset.bind(null, remainingStyles[i]))) {
      i++;
    } else {
      return remainingStyles.slice(i);
    }
  }
  return [];
};

var appendStartMarkup = function appendStartMarkup(inlineHTML, string, styleRange) {
  return string + (0, _getElementHTML2.default)(inlineHTML(styleRange.style)).start;
};

var prependEndMarkup = function prependEndMarkup(inlineHTML, string, styleRange) {
  return (0, _getElementHTML2.default)(inlineHTML(styleRange.style)).end + string;
};

var defaultCustomInlineHTML = function defaultCustomInlineHTML(next) {
  return function (style) {
    return next(style);
  };
};
defaultCustomInlineHTML.__isMiddleware = true;

exports.default = function (rawBlock) {
  var customInlineHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCustomInlineHTML;

  (0, _invariant2.default)(rawBlock !== null && rawBlock !== undefined, 'Expected raw block to be non-null');

  var inlineHTML = void 0;
  if (customInlineHTML.__isMiddleware === true) {
    inlineHTML = customInlineHTML(_defaultInlineHTML2.default);
  } else {
    inlineHTML = (0, _accumulateFunction2.default)((0, _styleObjectFunction2.default)(customInlineHTML), (0, _styleObjectFunction2.default)(_defaultInlineHTML2.default));
  }

  var result = '';
  var styleStack = [];

  var sortedRanges = rawBlock.inlineStyleRanges.sort(_rangeSort2.default);

  var originalTextArray = [].concat(_toConsumableArray(rawBlock.text));

  for (var i = 0; i < originalTextArray.length; i++) {
    var styles = characterStyles(i, sortedRanges);

    var endingStyles = subtractStyles(styleStack, styles);
    var newStyles = subtractStyles(styles, styleStack);
    var remainingStyles = subtractStyles(styleStack, endingStyles);

    // reset styles: look for any already existing styles that will need to
    // end before styles that are being added on this character. to solve this
    // close out those current tags and all nested children,
    // then open new ones nested within the new styles.
    var resetStyles = getStylesToReset(remainingStyles, newStyles);

    var openingStyles = resetStyles.concat(newStyles).sort(latestStyleLast);

    var openingStyleTags = openingStyles.reduce(appendStartMarkup.bind(null, inlineHTML), '');
    var endingStyleTags = endingStyles.concat(resetStyles).reduce(prependEndMarkup.bind(null, inlineHTML), '');

    result += endingStyleTags + openingStyleTags + originalTextArray[i];

    styleStack = popEndingStyles(styleStack, resetStyles.concat(endingStyles));
    styleStack = styleStack.concat(openingStyles);

    (0, _invariant2.default)(styleStack.length === styles.length, 'Character ' + i + ': ' + (styleStack.length - styles.length) + ' styles left on stack that should no longer be there');
  }

  result = styleStack.reduceRight(function (res, openStyle) {
    return res + (0, _getElementHTML2.default)(inlineHTML(openStyle.style)).end;
  }, result);

  return result;
};

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (object) {
  return function (style) {
    if (typeof object === 'function') {
      return object(style);
    }

    return object[style];
  };
};

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defaultInlineHTML;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultInlineHTML(style) {
  switch (style) {
    case 'BOLD':
      return _react2.default.createElement('strong', null);
    case 'ITALIC':
      return _react2.default.createElement('em', null);
    case 'UNDERLINE':
      return _react2.default.createElement('u', null);
    case 'CODE':
      return _react2.default.createElement('code', null);
    default:
      return {
        start: '',
        end: ''
      };
  }
}

/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (typeObject) {
  return function (block) {
    if (typeof typeObject === 'function') {
      // handle case where typeObject is already a function
      return typeObject(block);
    }

    return typeObject[block.type];
  };
};

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getBlockTags;

var _invariant = __webpack_require__(138);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(458);

var _server2 = _interopRequireDefault(_server);

var _splitReactElement = __webpack_require__(460);

var _splitReactElement2 = _interopRequireDefault(_splitReactElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hasChildren(element) {
  return _react2.default.isValidElement(element) && _react2.default.Children.count(element.props.children) > 0;
}

function getBlockTags(blockHTML) {
  (0, _invariant2.default)(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (typeof blockHTML === 'string') {
    return blockHTML;
  }

  if (_react2.default.isValidElement(blockHTML)) {
    if (hasChildren(blockHTML)) {
      return _server2.default.renderToStaticMarkup(blockHTML);
    }

    return (0, _splitReactElement2.default)(blockHTML);
  }

  if (Object.prototype.hasOwnProperty.call(blockHTML, 'element') && _react2.default.isValidElement(blockHTML.element)) {
    return Object.assign({}, blockHTML, (0, _splitReactElement2.default)(blockHTML.element));
  }

  (0, _invariant2.default)(Object.prototype.hasOwnProperty.call(blockHTML, 'start') && Object.prototype.hasOwnProperty.call(blockHTML, 'end'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');

  return blockHTML;
}

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getNestedBlockTags;

var _invariant = __webpack_require__(138);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _splitReactElement2 = __webpack_require__(460);

var _splitReactElement3 = _interopRequireDefault(_splitReactElement2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getNestedBlockTags(blockHTML) {
  (0, _invariant2.default)(blockHTML !== null && blockHTML !== undefined, 'Expected block HTML value to be non-null');

  if (_react2.default.isValidElement(blockHTML.nest)) {
    var _splitReactElement = (0, _splitReactElement3.default)(blockHTML.nest),
        start = _splitReactElement.start,
        end = _splitReactElement.end;

    return Object.assign({}, blockHTML, {
      nestStart: start,
      nestEnd: end
    });
  }

  (0, _invariant2.default)(Object.prototype.hasOwnProperty.call(blockHTML, 'nestStart') && Object.prototype.hasOwnProperty.call(blockHTML, 'nestEnd'), 'convertToHTML: received block information without either a ReactElement or an object with start/end tags');

  return blockHTML;
}

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  unstyled: _react2.default.createElement('p', null),
  paragraph: _react2.default.createElement('p', null),
  'header-one': _react2.default.createElement('h1', null),
  'header-two': _react2.default.createElement('h2', null),
  'header-three': _react2.default.createElement('h3', null),
  'header-four': _react2.default.createElement('h4', null),
  'header-five': _react2.default.createElement('h5', null),
  'header-six': _react2.default.createElement('h6', null),
  blockquote: _react2.default.createElement('blockquote', null),
  'unordered-list-item': {
    element: _react2.default.createElement('li', null),
    nest: _react2.default.createElement('ul', null)
  },
  'ordered-list-item': {
    element: _react2.default.createElement('li', null),
    nest: _react2.default.createElement('ol', null)
  },
  media: _react2.default.createElement('figure', null),
  atomic: _react2.default.createElement('figure', null)
};

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Copyright (c) 2013-present, Facebook, Inc.
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * Copyright (c) 2013-present, Facebook, Inc.
                                                                                                                                                                                                                                                                               * All rights reserved.
                                                                                                                                                                                                                                                                               *
                                                                                                                                                                                                                                                                               * This source code is licensed under the BSD-style license found in the
                                                                                                                                                                                                                                                                               * LICENSE file in the /src directory of this source tree. An additional grant
                                                                                                                                                                                                                                                                               * of patent rights can be found in the PATENTS file in the same directory.
                                                                                                                                                                                                                                                                               */

var _immutable = __webpack_require__(40);

var _draftJs = __webpack_require__(144);

var _parseHTML = __webpack_require__(1183);

var _parseHTML2 = _interopRequireDefault(_parseHTML);

var _rangeSort = __webpack_require__(459);

var _rangeSort2 = _interopRequireDefault(_rangeSort);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NBSP = '&nbsp;';
var SPACE = ' ';

// Arbitrary max indent
var MAX_DEPTH = 4;

// used for replacing characters in HTML
/* eslint-disable no-control-regex */
var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
/* eslint-enable no-control-regex */

// Block tag flow is different because LIs do not have
// a deterministic style ;_;
var blockTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'blockquote', 'pre'];
var inlineTags = {
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE'
};

var handleMiddleware = function handleMiddleware(maybeMiddleware, base) {
  if (maybeMiddleware && maybeMiddleware.__isMiddleware === true) {
    return maybeMiddleware(base);
  }

  return maybeMiddleware;
};

var defaultHTMLToBlock = function defaultHTMLToBlock(nodeName, node, lastList) {
  return undefined;
};

var defaultHTMLToStyle = function defaultHTMLToStyle(nodeName, node, currentStyle) {
  return currentStyle;
};

var defaultHTMLToEntity = function defaultHTMLToEntity(nodeName, node) {
  return undefined;
};

var defaultTextToEntity = function defaultTextToEntity(text) {
  return [];
};

var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }
  throw new Error('Got unexpected null or undefined');
};

var sanitizeDraftText = function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
};

function getEmptyChunk() {
  return {
    text: '',
    inlines: [],
    entities: [],
    blocks: []
  };
}

function getWhitespaceChunk(inEntity) {
  var entities = new Array(1);
  if (inEntity) {
    entities[0] = inEntity;
  }
  return {
    text: SPACE,
    inlines: [(0, _immutable.OrderedSet)()],
    entities: entities,
    blocks: []
  };
}

function getSoftNewlineChunk(block, depth) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (0, _immutable.Map)();

  if (flat === true) {
    return {
      text: '\r',
      inlines: [(0, _immutable.OrderedSet)()],
      entities: new Array(1),
      blocks: [{
        type: block,
        data: data,
        depth: Math.max(0, Math.min(MAX_DEPTH, depth))
      }],
      isNewline: true
    };
  }

  return {
    text: '\n',
    inlines: [(0, _immutable.OrderedSet)()],
    entities: new Array(1),
    blocks: []
  };
}

function getBlockDividerChunk(block, depth) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _immutable.Map)();

  return {
    text: '\r',
    inlines: [(0, _immutable.OrderedSet)()],
    entities: new Array(1),
    blocks: [{
      type: block,
      data: data,
      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
    }]
  };
}

function getBlockTypeForTag(tag, lastList) {
  switch (tag) {
    case 'h1':
      return 'header-one';
    case 'h2':
      return 'header-two';
    case 'h3':
      return 'header-three';
    case 'h4':
      return 'header-four';
    case 'h5':
      return 'header-five';
    case 'h6':
      return 'header-six';
    case 'li':
      if (lastList === 'ol') {
        return 'ordered-list-item';
      }
      return 'unordered-list-item';
    case 'blockquote':
      return 'blockquote';
    case 'pre':
      return 'code-block';
    case 'div':
    case 'p':
      return 'unstyled';
    default:
      return null;
  }
}

function baseCheckBlockType(nodeName, node, lastList) {
  return getBlockTypeForTag(nodeName, lastList);
}

function processInlineTag(tag, node, currentStyle) {
  var styleToCheck = inlineTags[tag];
  if (styleToCheck) {
    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
  } else if (node instanceof HTMLElement) {
    (function () {
      var htmlElement = node;
      currentStyle = currentStyle.withMutations(function (style) {
        if (htmlElement.style.fontWeight === 'bold') {
          style.add('BOLD');
        }

        if (htmlElement.style.fontStyle === 'italic') {
          style.add('ITALIC');
        }

        if (htmlElement.style.textDecoration === 'underline') {
          style.add('UNDERLINE');
        }

        if (htmlElement.style.textDecoration === 'line-through') {
          style.add('STRIKETHROUGH');
        }
      }).toOrderedSet();
    })();
  }
  return currentStyle;
}

function baseProcessInlineTag(tag, node) {
  return processInlineTag(tag, node, (0, _immutable.OrderedSet)());
}

function joinChunks(A, B) {
  var flat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  // Sometimes two blocks will touch in the DOM and we need to strip the
  // extra delimiter to preserve niceness.
  var firstInB = B.text.slice(0, 1);
  var lastInA = A.text.slice(-1);

  var adjacentDividers = lastInA === '\r' && firstInB === '\r';
  var isJoiningBlocks = A.text !== '\r' && B.text !== '\r'; // when joining two full blocks like this we want to pop one divider
  var addingNewlineToEmptyBlock = A.text === '\r' && !A.isNewline && B.isNewline; // when joining a newline to an empty block we want to remove the newline

  if (adjacentDividers && (isJoiningBlocks || addingNewlineToEmptyBlock)) {
    A.text = A.text.slice(0, -1);
    A.inlines.pop();
    A.entities.pop();
    A.blocks.pop();
  }

  // Kill whitespace after blocks if flat mode is on
  if (A.text.slice(-1) === '\r' && flat === true) {
    if (B.text === SPACE || B.text === '\n') {
      return A;
    } else if (firstInB === SPACE || firstInB === '\n') {
      B.text = B.text.slice(1);
      B.inlines.shift();
      B.entities.shift();
    }
  }

  var isNewline = A.text.length === 0 && B.isNewline;

  return {
    text: A.text + B.text,
    inlines: A.inlines.concat(B.inlines),
    entities: A.entities.concat(B.entities),
    blocks: A.blocks.concat(B.blocks),
    isNewline: isNewline
  };
}

/*
 * Check to see if we have anything like <p> <blockquote> <h1>... to create
 * block tags from. If we do, we can use those and ignore <div> tags. If we
 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
 */
function containsSemanticBlockMarkup(html) {
  return blockTags.some(function (tag) {
    return html.indexOf('<' + tag) !== -1;
  });
}

function genFragment(node, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, inEntity) {
  var nodeName = node.nodeName.toLowerCase();
  var newBlock = false;
  var nextBlockType = 'unstyled';

  // Base Case
  if (nodeName === '#text') {
    var _ret2 = function () {
      var text = node.textContent;
      if (text.trim() === '' && inBlock === null) {
        return {
          v: getEmptyChunk()
        };
      }

      if (text.trim() === '' && inBlock !== 'code-block') {
        return {
          v: getWhitespaceChunk(inEntity)
        };
      }
      if (inBlock !== 'code-block') {
        // Can't use empty string because MSWord
        text = text.replace(REGEX_LF, SPACE);
      }

      var entities = Array(text.length).fill(inEntity);

      var offsetChange = 0;
      var textEntities = checkEntityText(text, createEntity, getEntity, mergeEntityData, replaceEntityData).sort(_rangeSort2.default);

      textEntities.forEach(function (_ref) {
        var entity = _ref.entity,
            offset = _ref.offset,
            length = _ref.length,
            result = _ref.result;

        var adjustedOffset = offset + offsetChange;

        if (result === null || result === undefined) {
          result = text.substr(adjustedOffset, length);
        }

        var textArray = text.split('');
        textArray.splice.bind(textArray, adjustedOffset, length).apply(textArray, result.split(''));
        text = textArray.join('');

        entities.splice.bind(entities, adjustedOffset, length).apply(entities, Array(result.length).fill(entity));
        offsetChange += result.length - length;
      });

      return {
        v: {
          text: text,
          inlines: Array(text.length).fill(inlineStyle),
          entities: entities,
          blocks: []
        }
      };
    }();

    if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
  }

  // BR tags
  if (nodeName === 'br') {
    var _blockType = inBlock;

    if (_blockType === null) {
      //  BR tag is at top level, treat it as an unstyled block
      return getSoftNewlineChunk('unstyled', depth, true);
    }

    return getSoftNewlineChunk(_blockType || 'unstyled', depth, options.flat);
  }

  var chunk = getEmptyChunk();
  var newChunk = null;

  // Inline tags
  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
  inlineStyle = processCustomInlineStyles(nodeName, node, inlineStyle);

  // Handle lists
  if (nodeName === 'ul' || nodeName === 'ol') {
    if (lastList) {
      depth += 1;
    }
    lastList = nodeName;
    inBlock = null;
  }

  // Block Tags
  var blockInfo = checkBlockType(nodeName, node, lastList, inBlock);
  var blockType = void 0;
  var blockDataMap = void 0;

  if (blockInfo === false) {
    return getEmptyChunk();
  }

  blockInfo = blockInfo || {};

  if (typeof blockInfo === 'string') {
    blockType = blockInfo;
    blockDataMap = (0, _immutable.Map)();
  } else {
    blockType = typeof blockInfo === 'string' ? blockInfo : blockInfo.type;
    blockDataMap = blockInfo.data ? (0, _immutable.Map)(blockInfo.data) : (0, _immutable.Map)();
  }
  if (!inBlock && (fragmentBlockTags.indexOf(nodeName) !== -1 || blockType)) {
    chunk = getBlockDividerChunk(blockType || getBlockTypeForTag(nodeName, lastList), depth, blockDataMap);
    inBlock = blockType || getBlockTypeForTag(nodeName, lastList);
    newBlock = true;
  } else if (lastList && (inBlock === 'ordered-list-item' || inBlock === 'unordered-list-item') && nodeName === 'li') {
    var listItemBlockType = getBlockTypeForTag(nodeName, lastList);
    chunk = getBlockDividerChunk(listItemBlockType, depth);
    inBlock = listItemBlockType;
    newBlock = true;
    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
  } else if (inBlock && inBlock !== 'atomic' && blockType === 'atomic') {
    inBlock = blockType;
    newBlock = true;
    chunk = getSoftNewlineChunk(blockType, depth, true, // atomic blocks within non-atomic blocks must always be split out
    blockDataMap);
  }

  // Recurse through children
  var child = node.firstChild;

  // hack to allow conversion of atomic blocks from HTML (e.g. <figure><img
  // src="..." /></figure>). since metadata must be stored on an entity text
  // must exist for the entity to apply to. the way chunks are joined strips
  // whitespace at the end so it cannot be a space character.

  if (child == null && inEntity && (blockType === 'atomic' || inBlock === 'atomic')) {
    child = document.createTextNode('a');
  }

  if (child != null) {
    nodeName = child.nodeName.toLowerCase();
  }

  var entityId = null;

  while (child) {
    entityId = checkEntityNode(nodeName, child, createEntity, getEntity, mergeEntityData, replaceEntityData);

    newChunk = genFragment(child, inlineStyle, lastList, inBlock, fragmentBlockTags, depth, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, entityId || inEntity);

    chunk = joinChunks(chunk, newChunk, options.flat);
    var sibling = child.nextSibling;

    // Put in a newline to break up blocks inside blocks
    if (sibling && fragmentBlockTags.indexOf(nodeName) >= 0 && inBlock) {
      var newBlockInfo = checkBlockType(nodeName, child, lastList, inBlock);

      var newBlockType = void 0;
      var newBlockData = void 0;

      if (newBlockInfo !== false) {
        newBlockInfo = newBlockInfo || {};

        if (typeof newBlockInfo === 'string') {
          newBlockType = newBlockInfo;
          newBlockData = (0, _immutable.Map)();
        } else {
          newBlockType = newBlockInfo.type || getBlockTypeForTag(nodeName, lastList);
          newBlockData = newBlockInfo.data ? (0, _immutable.Map)(newBlockInfo.data) : (0, _immutable.Map)();
        }

        chunk = joinChunks(chunk, getSoftNewlineChunk(newBlockType, depth, options.flat, newBlockData), options.flat);
      }
    }
    if (sibling) {
      nodeName = sibling.nodeName.toLowerCase();
    }
    child = sibling;
  }

  if (newBlock) {
    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, (0, _immutable.Map)()), options.flat);
  }

  return chunk;
}

function getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder) {
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE);

  var safeBody = DOMBuilder(html);
  if (!safeBody) {
    return null;
  }

  // Sometimes we aren't dealing with content that contains nice semantic
  // tags. In this case, use divs to separate everything out into paragraphs
  // and hope for the best.
  var workingBlocks = containsSemanticBlockMarkup(html) ? blockTags.concat(['div']) : ['div'];

  // Start with -1 block depth to offset the fact that we are passing in a fake
  // UL block to sta rt with.
  var chunk = genFragment(safeBody, (0, _immutable.OrderedSet)(), 'ul', null, workingBlocks, -1, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options);

  // join with previous block to prevent weirdness on paste
  if (chunk.text.indexOf('\r') === 0) {
    chunk = {
      text: chunk.text.slice(1),
      inlines: chunk.inlines.slice(1),
      entities: chunk.entities.slice(1),
      blocks: chunk.blocks
    };
  }

  // Kill block delimiter at the end
  if (chunk.text.slice(-1) === '\r') {
    chunk.text = chunk.text.slice(0, -1);
    chunk.inlines = chunk.inlines.slice(0, -1);
    chunk.entities = chunk.entities.slice(0, -1);
    chunk.blocks.pop();
  }

  // If we saw no block tags, put an unstyled one in
  if (chunk.blocks.length === 0) {
    chunk.blocks.push({ type: 'unstyled', data: (0, _immutable.Map)(), depth: 0 });
  }

  // Sometimes we start with text that isn't in a block, which is then
  // followed by blocks. Need to fix up the blocks to add in
  // an unstyled block for this content
  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
    chunk.blocks.unshift({ type: 'unstyled', data: (0, _immutable.Map)(), depth: 0 });
  }

  return chunk;
}

function convertFromHTMLtoContentBlocks(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder, generateKey) {
  // Be ABSOLUTELY SURE that the dom builder you pass hare won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.

  var chunk = getChunkForHTML(html, processCustomInlineStyles, checkEntityNode, checkEntityText, checkBlockType, createEntity, getEntity, mergeEntityData, replaceEntityData, options, DOMBuilder, generateKey);
  if (chunk == null) {
    return [];
  }
  var start = 0;
  return chunk.text.split('\r').map(function (textBlock, blockIndex) {
    // Make absolutely certain that our text is acceptable.
    textBlock = sanitizeDraftText(textBlock);
    var end = start + textBlock.length;
    var inlines = nullthrows(chunk).inlines.slice(start, end);
    var entities = nullthrows(chunk).entities.slice(start, end);
    var characterList = (0, _immutable.List)(inlines.map(function (style, entityIndex) {
      var data = { style: style, entity: null };
      if (entities[entityIndex]) {
        data.entity = entities[entityIndex];
      }
      return _draftJs.CharacterMetadata.create(data);
    }));
    start = end + 1;

    return new _draftJs.ContentBlock({
      key: generateKey(),
      type: nullthrows(chunk).blocks[blockIndex].type,
      data: nullthrows(chunk).blocks[blockIndex].data,
      depth: nullthrows(chunk).blocks[blockIndex].depth,
      text: textBlock,
      characterList: characterList
    });
  });
}

var convertFromHTML = function convertFromHTML(_ref2) {
  var _ref2$htmlToStyle = _ref2.htmlToStyle,
      htmlToStyle = _ref2$htmlToStyle === undefined ? defaultHTMLToStyle : _ref2$htmlToStyle,
      _ref2$htmlToEntity = _ref2.htmlToEntity,
      htmlToEntity = _ref2$htmlToEntity === undefined ? defaultHTMLToEntity : _ref2$htmlToEntity,
      _ref2$textToEntity = _ref2.textToEntity,
      textToEntity = _ref2$textToEntity === undefined ? defaultTextToEntity : _ref2$textToEntity,
      _ref2$htmlToBlock = _ref2.htmlToBlock,
      htmlToBlock = _ref2$htmlToBlock === undefined ? defaultHTMLToBlock : _ref2$htmlToBlock;
  return function (html) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      flat: false
    };
    var DOMBuilder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _parseHTML2.default;
    var generateKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _draftJs.genKey;

    var contentState = _draftJs.ContentState.createFromText('');
    var createEntityWithContentState = function createEntityWithContentState() {
      if (contentState.createEntity) {
        var _contentState;

        contentState = (_contentState = contentState).createEntity.apply(_contentState, arguments);
        return contentState.getLastCreatedEntityKey();
      }

      return _draftJs.Entity.create.apply(_draftJs.Entity, arguments);
    };

    var getEntityWithContentState = function getEntityWithContentState() {
      if (contentState.getEntity) {
        var _contentState2;

        return (_contentState2 = contentState).getEntity.apply(_contentState2, arguments);
      }

      return _draftJs.Entity.get.apply(_draftJs.Entity, arguments);
    };

    var mergeEntityDataWithContentState = function mergeEntityDataWithContentState() {
      if (contentState.mergeEntityData) {
        var _contentState3;

        contentState = (_contentState3 = contentState).mergeEntityData.apply(_contentState3, arguments);
        return;
      }

      _draftJs.Entity.mergeData.apply(_draftJs.Entity, arguments);
    };

    var replaceEntityDataWithContentState = function replaceEntityDataWithContentState() {
      if (contentState.replaceEntityData) {
        var _contentState4;

        contentState = (_contentState4 = contentState).replaceEntityData.apply(_contentState4, arguments);
        return;
      }

      _draftJs.Entity.replaceData.apply(_draftJs.Entity, arguments);
    };

    var contentBlocks = convertFromHTMLtoContentBlocks(html, handleMiddleware(htmlToStyle, baseProcessInlineTag), handleMiddleware(htmlToEntity, defaultHTMLToEntity), handleMiddleware(textToEntity, defaultTextToEntity), handleMiddleware(htmlToBlock, baseCheckBlockType), createEntityWithContentState, getEntityWithContentState, mergeEntityDataWithContentState, replaceEntityDataWithContentState, options, DOMBuilder, generateKey);

    var blockMap = _draftJs.BlockMapBuilder.createFromArray(contentBlocks);
    var firstBlockKey = contentBlocks[0].getKey();
    return contentState.merge({
      blockMap: blockMap,
      selectionBefore: _draftJs.SelectionState.createEmpty(firstBlockKey),
      selectionAfter: _draftJs.SelectionState.createEmpty(firstBlockKey)
    });
  };
};

exports.default = function () {
  if (arguments.length >= 1 && typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
    return convertFromHTML({}).apply(undefined, arguments);
  }
  return convertFromHTML.apply(undefined, arguments);
};

/***/ }),
/* 2710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stateFromElement__ = __webpack_require__(2711);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__stateFromElement__["a"]; });


/***/ }),
/* 2711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stateFromElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_replaceTextWithMeta__ = __webpack_require__(2712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_synthetic_dom__ = __webpack_require__(2716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_Constants__ = __webpack_require__(2718);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var DATA_URL = /^data:/i;
var NO_STYLE = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedSet"])();
var NO_ENTITY = null;
var EMPTY_BLOCK = new __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentBlock"]({
  key: Object(__WEBPACK_IMPORTED_MODULE_1_draft_js__["genKey"])(),
  text: '',
  type: __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].UNSTYLED,
  characterList: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(),
  depth: 0
});
var LINE_BREAKS = /(\r\n|\r|\n)/g; // We use `\r` because that character is always stripped from source (normalized
// to `\n`), so it's safe to assume it will only appear in the text content when
// we put it there as a placeholder.

var SOFT_BREAK_PLACEHOLDER = '\r';
var ZERO_WIDTH_SPACE = "\u200B";
var DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/; // Map element attributes to entity data.

var ELEM_ATTR_MAP = {
  a: {
    href: 'url',
    rel: 'rel',
    target: 'target',
    title: 'title'
  },
  img: {
    src: 'src',
    alt: 'alt',
    width: 'width',
    height: 'height'
  }
};

var getEntityData = function getEntityData(tagName, element) {
  var data = {};

  if (ELEM_ATTR_MAP.hasOwnProperty(tagName)) {
    var attrMap = ELEM_ATTR_MAP[tagName];

    for (var i = 0; i < element.attributes.length; i++) {
      var _element$attributes$i = element.attributes[i],
          name = _element$attributes$i.name,
          value = _element$attributes$i.value;

      if (typeof value === 'string') {
        var strVal = value;

        if (attrMap.hasOwnProperty(name)) {
          var newName = attrMap[name];
          data[newName] = strVal;
        } else if (DATA_ATTRIBUTE.test(name)) {
          data[name] = strVal;
        }
      }
    }
  }

  return data;
}; // Functions to create entities from elements.


var ElementToEntity = {
  a: function a(generator, tagName, element) {
    var data = getEntityData(tagName, element); // Don't add `<a>` elements with invalid href.

    if (isAllowedHref(data.url)) {
      return generator.createEntity(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["ENTITY_TYPE"].LINK, data);
    }
  },
  img: function img(generator, tagName, element) {
    var data = getEntityData(tagName, element); // Don't add `<img>` elements with no src.

    if (data.src != null) {
      return generator.createEntity(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["ENTITY_TYPE"].IMAGE, data);
    }
  }
};

var ContentGenerator =
/*#__PURE__*/
function () {
  // This will be passed to the customInlineFn to allow it
  // to return a Style() or Entity().
  function ContentGenerator() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ContentGenerator);

    _defineProperty(this, "contentStateForEntities", void 0);

    _defineProperty(this, "blockStack", void 0);

    _defineProperty(this, "blockList", void 0);

    _defineProperty(this, "depth", void 0);

    _defineProperty(this, "options", void 0);

    _defineProperty(this, "inlineCreators", {
      Style: function (_Style) {
        function Style(_x) {
          return _Style.apply(this, arguments);
        }

        Style.toString = function () {
          return _Style.toString();
        };

        return Style;
      }(function (style) {
        return {
          type: 'STYLE',
          style: style
        };
      }),
      Entity: function Entity(type, data) {
        var mutability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'MUTABLE';
        return {
          type: 'ENTITY',
          entityKey: _this.createEntity(type, toStringMap(data), mutability)
        };
      }
    });

    this.options = options;
    this.contentStateForEntities = __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentState"].createFromBlockArray([]); // This represents the hierarchy as we traverse nested elements; for
    // example [body, ul, li] where we must know li's parent type (ul or ol).

    this.blockStack = []; // This is a linear list of blocks that will form the output; for example
    // [p, li, li, blockquote].

    this.blockList = [];
    this.depth = 0;
  }

  _createClass(ContentGenerator, [{
    key: "process",
    value: function process(element) {
      this.processBlockElement(element);
      var contentBlocks = [];
      this.blockList.forEach(function (block) {
        var _concatFragments = concatFragments(block.textFragments),
            text = _concatFragments.text,
            characterMeta = _concatFragments.characterMeta;

        var includeEmptyBlock = false; // If the block contains only a soft break then don't discard the block,
        // but discard the soft break.

        if (text === SOFT_BREAK_PLACEHOLDER) {
          includeEmptyBlock = true;
          text = '';
        }

        if (block.tagName === 'pre') {
          var _trimLeadingNewline = trimLeadingNewline(text, characterMeta);

          text = _trimLeadingNewline.text;
          characterMeta = _trimLeadingNewline.characterMeta;
        } else {
          var _collapseWhiteSpace = collapseWhiteSpace(text, characterMeta);

          text = _collapseWhiteSpace.text;
          characterMeta = _collapseWhiteSpace.characterMeta;
        } // Previously we were using a placeholder for soft breaks. Now that we
        // have collapsed whitespace we can change it back to normal line breaks.


        text = text.split(SOFT_BREAK_PLACEHOLDER).join('\n'); // Discard empty blocks (unless otherwise specified).

        if (text.length || includeEmptyBlock) {
          contentBlocks.push(new __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentBlock"]({
            key: Object(__WEBPACK_IMPORTED_MODULE_1_draft_js__["genKey"])(),
            text: text,
            type: block.type,
            characterList: characterMeta.toList(),
            depth: block.depth,
            data: block.data ? Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(block.data) : Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()
          }));
        }
      });

      if (!contentBlocks.length) {
        contentBlocks = [EMPTY_BLOCK];
      }

      return __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentState"].createFromBlockArray(contentBlocks, this.contentStateForEntities.getEntityMap());
    }
  }, {
    key: "getBlockTypeFromTagName",
    value: function getBlockTypeFromTagName(tagName) {
      var blockTypes = this.options.blockTypes;

      if (blockTypes && blockTypes[tagName]) {
        return blockTypes[tagName];
      }

      switch (tagName) {
        case 'li':
          {
            var parent = this.blockStack.slice(-1)[0];
            return parent.tagName === 'ol' ? __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].ORDERED_LIST_ITEM : __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].UNORDERED_LIST_ITEM;
          }

        case 'blockquote':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].BLOCKQUOTE;
          }

        case 'h1':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].HEADER_ONE;
          }

        case 'h2':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].HEADER_TWO;
          }

        case 'h3':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].HEADER_THREE;
          }

        case 'h4':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].HEADER_FOUR;
          }

        case 'h5':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].HEADER_FIVE;
          }

        case 'h6':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].HEADER_SIX;
          }

        case 'pre':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].CODE;
          }

        case 'figure':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].ATOMIC;
          }

        default:
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].UNSTYLED;
          }
      }
    }
  }, {
    key: "processBlockElement",
    value: function processBlockElement(element) {
      if (!element) {
        return;
      }

      var customBlockFn = this.options.customBlockFn;
      var tagName = element.nodeName.toLowerCase();
      var type;
      var data;

      if (customBlockFn) {
        var customBlock = customBlockFn(element);

        if (customBlock != null) {
          type = customBlock.type;
          data = customBlock.data;
        }
      }

      var isCustomType = true;

      if (type == null) {
        isCustomType = false;
        type = this.getBlockTypeFromTagName(tagName);
      }

      if (type === __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].CODE) {
        var language = element.getAttribute('data-language');

        if (language) {
          data = _objectSpread({}, data, {
            language: language
          });
        }
      }

      var hasDepth = canHaveDepth(type);
      var allowRender = !__WEBPACK_IMPORTED_MODULE_5__lib_Constants__["c" /* SPECIAL_ELEMENTS */].hasOwnProperty(tagName);

      if (!isCustomType && !hasSemanticMeaning(type)) {
        var parent = this.blockStack.slice(-1)[0];

        if (parent) {
          type = parent.type;
        }
      }

      var block = {
        tagName: tagName,
        textFragments: [],
        type: type,
        styleStack: [NO_STYLE],
        entityStack: [NO_ENTITY],
        depth: hasDepth ? this.depth : 0,
        data: data
      };

      if (allowRender) {
        this.blockList.push(block);

        if (hasDepth) {
          this.depth += 1;
        }
      }

      this.blockStack.push(block);

      if (element.childNodes != null) {
        Array.from(element.childNodes).forEach(this.processNode, this);
      }

      this.blockStack.pop();

      if (allowRender && hasDepth) {
        this.depth -= 1;
      }
    }
  }, {
    key: "processInlineElement",
    value: function processInlineElement(element) {
      var tagName = element.nodeName.toLowerCase();

      if (tagName === 'br') {
        this.processText(SOFT_BREAK_PLACEHOLDER);
        return;
      }

      var block = this.blockStack.slice(-1)[0];
      var style = block.styleStack.slice(-1)[0];
      var entityKey = block.entityStack.slice(-1)[0];
      var customInlineFn = this.options.customInlineFn;
      var customInline = customInlineFn ? customInlineFn(element, this.inlineCreators) : null;

      if (customInline != null) {
        switch (customInline.type) {
          case 'STYLE':
            {
              style = style.add(customInline.style);
              break;
            }

          case 'ENTITY':
            {
              entityKey = customInline.entityKey;
              break;
            }
        }
      } else {
        style = addStyleFromTagName(style, tagName, this.options.elementStyles);

        if (ElementToEntity.hasOwnProperty(tagName)) {
          // If the to-entity function returns nothing, use the existing entity.
          entityKey = ElementToEntity[tagName](this, tagName, element) || entityKey;
        }
      }

      block.styleStack.push(style);
      block.entityStack.push(entityKey);

      if (element.childNodes != null) {
        Array.from(element.childNodes).forEach(this.processNode, this);
      }

      if (__WEBPACK_IMPORTED_MODULE_5__lib_Constants__["b" /* SELF_CLOSING_ELEMENTS */].hasOwnProperty(tagName)) {
        this.processText("\xA0");
      }

      block.entityStack.pop();
      block.styleStack.pop();
    }
  }, {
    key: "processTextNode",
    value: function processTextNode(node) {
      var text = node.nodeValue; // This is important because we will use \r as a placeholder for a soft break.

      text = text.replace(LINE_BREAKS, '\n'); // Replace zero-width space (we use it as a placeholder in markdown) with a
      // soft break.
      // TODO: The import-markdown package should correctly turn breaks into <br>
      // elements so we don't need to include this hack.

      text = text.split(ZERO_WIDTH_SPACE).join(SOFT_BREAK_PLACEHOLDER);
      this.processText(text);
    }
  }, {
    key: "processText",
    value: function processText(text) {
      var block = this.blockStack.slice(-1)[0];
      var style = block.styleStack.slice(-1)[0];
      var entity = block.entityStack.slice(-1)[0];
      var charMetadata = __WEBPACK_IMPORTED_MODULE_1_draft_js__["CharacterMetadata"].create({
        style: style,
        entity: entity
      });
      var seq = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Repeat"])(charMetadata, text.length);
      block.textFragments.push({
        text: text,
        characterMeta: seq
      });
    }
  }, {
    key: "processNode",
    value: function processNode(node) {
      if (node.nodeType === __WEBPACK_IMPORTED_MODULE_4_synthetic_dom__["a" /* NODE_TYPE_ELEMENT */]) {
        // $FlowIssue
        var _element = node;

        var _tagName = _element.nodeName.toLowerCase();

        if (__WEBPACK_IMPORTED_MODULE_5__lib_Constants__["a" /* INLINE_ELEMENTS */].hasOwnProperty(_tagName)) {
          this.processInlineElement(_element);
        } else {
          this.processBlockElement(_element);
        }
      } else if (node.nodeType === __WEBPACK_IMPORTED_MODULE_4_synthetic_dom__["b" /* NODE_TYPE_TEXT */]) {
        this.processTextNode(node);
      }
    }
  }, {
    key: "createEntity",
    value: function createEntity(type, data) {
      var mutability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'MUTABLE';
      this.contentStateForEntities = this.contentStateForEntities.createEntity(type, mutability, data);
      return this.contentStateForEntities.getLastCreatedEntityKey();
    }
  }]);

  return ContentGenerator;
}();

function trimLeadingNewline(text, characterMeta) {
  if (text.charAt(0) === '\n') {
    text = text.slice(1);
    characterMeta = characterMeta.slice(1);
  }

  return {
    text: text,
    characterMeta: characterMeta
  };
}

function trimLeadingSpace(text, characterMeta) {
  while (text.charAt(0) === ' ') {
    text = text.slice(1);
    characterMeta = characterMeta.slice(1);
  }

  return {
    text: text,
    characterMeta: characterMeta
  };
}

function trimTrailingSpace(text, characterMeta) {
  while (text.slice(-1) === ' ') {
    text = text.slice(0, -1);
    characterMeta = characterMeta.slice(0, -1);
  }

  return {
    text: text,
    characterMeta: characterMeta
  };
}

function collapseWhiteSpace(text, characterMeta) {
  text = text.replace(/[ \t\n]/g, ' ');

  var _trimLeadingSpace = trimLeadingSpace(text, characterMeta);

  text = _trimLeadingSpace.text;
  characterMeta = _trimLeadingSpace.characterMeta;

  var _trimTrailingSpace = trimTrailingSpace(text, characterMeta);

  text = _trimTrailingSpace.text;
  characterMeta = _trimTrailingSpace.characterMeta;
  var i = text.length;

  while (i--) {
    if (text.charAt(i) === ' ' && text.charAt(i - 1) === ' ') {
      text = text.slice(0, i) + text.slice(i + 1);
      characterMeta = characterMeta.slice(0, i).concat(characterMeta.slice(i + 1));
    }
  } // There could still be one space on either side of a softbreak.


  var _replaceTextWithMeta = Object(__WEBPACK_IMPORTED_MODULE_0__lib_replaceTextWithMeta__["a" /* default */])({
    text: text,
    characterMeta: characterMeta
  }, SOFT_BREAK_PLACEHOLDER + ' ', SOFT_BREAK_PLACEHOLDER);

  text = _replaceTextWithMeta.text;
  characterMeta = _replaceTextWithMeta.characterMeta;

  var _replaceTextWithMeta2 = Object(__WEBPACK_IMPORTED_MODULE_0__lib_replaceTextWithMeta__["a" /* default */])({
    text: text,
    characterMeta: characterMeta
  }, ' ' + SOFT_BREAK_PLACEHOLDER, SOFT_BREAK_PLACEHOLDER);

  text = _replaceTextWithMeta2.text;
  characterMeta = _replaceTextWithMeta2.characterMeta;
  return {
    text: text,
    characterMeta: characterMeta
  };
}

function canHaveDepth(blockType) {
  switch (blockType) {
    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].UNORDERED_LIST_ITEM:
    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].ORDERED_LIST_ITEM:
      {
        return true;
      }

    default:
      {
        return false;
      }
  }
}

function concatFragments(fragments) {
  var text = '';
  var characterMeta = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Seq"])();
  fragments.forEach(function (textFragment) {
    text = text + textFragment.text;
    characterMeta = characterMeta.concat(textFragment.characterMeta);
  });
  return {
    text: text,
    characterMeta: characterMeta
  };
}

function addStyleFromTagName(styleSet, tagName, elementStyles) {
  switch (tagName) {
    case 'b':
    case 'strong':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["INLINE_STYLE"].BOLD);
      }

    case 'i':
    case 'em':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["INLINE_STYLE"].ITALIC);
      }

    case 'u':
    case 'ins':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["INLINE_STYLE"].UNDERLINE);
      }

    case 'code':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["INLINE_STYLE"].CODE);
      }

    case 's':
    case 'del':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["INLINE_STYLE"].STRIKETHROUGH);
      }

    default:
      {
        // Allow custom styles to be provided.
        if (elementStyles && elementStyles[tagName]) {
          return styleSet.add(elementStyles[tagName]);
        }

        return styleSet;
      }
  }
}

function hasSemanticMeaning(blockType) {
  return blockType !== __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["BLOCK_TYPE"].UNSTYLED;
}

function toStringMap(input) {
  var result = {};

  if (input !== null && _typeof(input) === 'object' && !Array.isArray(input)) {
    var obj = input;

    for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
      var _key = _Object$keys[_i];
      var value = obj[_key];

      if (typeof value === 'string') {
        result[_key] = value;
      }
    }
  }

  return result;
}

function isAllowedHref(input) {
  if (input == null || input.match(DATA_URL)) {
    return false;
  } else {
    return true;
  }
}

function stateFromElement(element, options) {
  return new ContentGenerator(options).process(element);
}
/* unused harmony default export */ var _unused_webpack_default_export = (stateFromElement);

/***/ }),
/* 2712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = replaceTextWithMeta;
function replaceTextWithMeta(subject, searchText, replaceText) {
  var text = subject.text,
      characterMeta = subject.characterMeta;
  var searchTextLength = searchText.length;
  var replaceTextLength = replaceText.length;
  var resultTextParts = []; // Get empty set of same kind as characterMeta.

  var resultCharMeta = characterMeta.slice(0, 0);
  var lastEndIndex = 0;
  var index = text.indexOf(searchText);

  while (index !== -1) {
    resultTextParts.push(text.slice(lastEndIndex, index) + replaceText);
    resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex, index), // Use the metadata of the first char we are replacing.
    repeatSeq(characterMeta.slice(index, index + 1), replaceTextLength));
    lastEndIndex = index + searchTextLength;
    index = text.indexOf(searchText, lastEndIndex);
  }

  resultTextParts.push(text.slice(lastEndIndex));
  resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex));
  return {
    text: resultTextParts.join(''),
    characterMeta: resultCharMeta
  };
}

function repeatSeq(seq, count) {
  var result = seq.slice(0, 0);

  while (count-- > 0) {
    result = result.concat(seq);
  }

  return result;
}

/***/ }),
/* 2713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMPTY_SET */
/* harmony export (immutable) */ __webpack_exports__["a"] = getEntityRanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);

var EMPTY_SET = new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"]();
function getEntityRanges(text, charMetaList) {
  var charEntity = null;
  var prevCharEntity = null;
  var ranges = [];
  var rangeStart = 0;

  for (var i = 0, len = text.length; i < len; i++) {
    prevCharEntity = charEntity;
    var meta = charMetaList.get(i);
    charEntity = meta ? meta.getEntity() : null;

    if (i > 0 && charEntity !== prevCharEntity) {
      ranges.push([prevCharEntity, getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i))]);
      rangeStart = i;
    }
  }

  ranges.push([charEntity, getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart))]);
  return ranges;
}

function getStyleRanges(text, charMetaList) {
  var charStyle = EMPTY_SET;
  var prevCharStyle = EMPTY_SET;
  var ranges = [];
  var rangeStart = 0;

  for (var i = 0, len = text.length; i < len; i++) {
    prevCharStyle = charStyle;
    var meta = charMetaList.get(i);
    charStyle = meta ? meta.getStyle() : EMPTY_SET;

    if (i > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["is"])(charStyle, prevCharStyle)) {
      ranges.push([text.slice(rangeStart, i), prevCharStyle]);
      rangeStart = i;
    }
  }

  ranges.push([text.slice(rangeStart), charStyle]);
  return ranges;
}

/***/ }),
/* 2714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getSelectedBlocks__ = __webpack_require__(691);

/* harmony default export */ __webpack_exports__["a"] = (function (strategy) {
  return function (editorState, selection) {
    var contentState = editorState.getCurrentContent();
    var currentSelection = selection || editorState.getSelection();
    var startKey = currentSelection.getStartKey();
    var endKey = currentSelection.getEndKey();
    var startOffset = currentSelection.getStartOffset();
    var endOffset = currentSelection.getEndOffset();
    var isSameBlock = startKey === endKey;
    var selectedBlocks = Object(__WEBPACK_IMPORTED_MODULE_0__getSelectedBlocks__["a" /* default */])(contentState, startKey, endKey);
    var entityFound = false; // We have to shift the offset to not get false positives when selecting
    // a character just before or after an entity

    var finalStartOffset = startOffset + 1;
    var finalEndOffset = endOffset - 1;
    selectedBlocks.forEach(function (block) {
      strategy(block, function (start, end) {
        if (entityFound) {
          return;
        }

        var blockKey = block.getKey();

        if (isSameBlock && (end < finalStartOffset || start > finalEndOffset)) {
          return;
        } else if (blockKey === startKey && end < finalStartOffset) {
          return;
        } else if (blockKey === endKey && start > finalEndOffset) {
          return;
        }

        entityFound = true;
      }, contentState);
    });
    return entityFound;
  };
});

/***/ }),
/* 2715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSelectedBlocks__ = __webpack_require__(691);


/**
 * Calls a provided `modifier` function with a selection for each
 * selected block in the current editor selection. Passes through additional
 * arguments to the modifier.
 *
 * Note: At the moment it will retain the original selection and override
 * possible selection changes from modifiers
 *
 * @param  {object} editorState The current draft.js editor state object
 *
 * @param  {function} modifier  A modifier function to be executed.
 *                              Must have the signature (editorState, selection, ...)
 *
 * @param  {mixed} ...args      Additional arguments to be passed through to the modifier
 *
 * @return {object} The new editor state
 */

/* harmony default export */ __webpack_exports__["a"] = (function (editorState, modifier) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var contentState = editorState.getCurrentContent();
  var currentSelection = editorState.getSelection();
  var startKey = currentSelection.getStartKey();
  var endKey = currentSelection.getEndKey();
  var startOffset = currentSelection.getStartOffset();
  var endOffset = currentSelection.getEndOffset();
  var isSameBlock = startKey === endKey;
  var selectedBlocks = Object(__WEBPACK_IMPORTED_MODULE_1__getSelectedBlocks__["a" /* default */])(contentState, startKey, endKey);
  var finalEditorState = editorState;
  selectedBlocks.forEach(function (block) {
    var currentBlockKey = block.getKey();
    var selectionStart = startOffset;
    var selectionEnd = endOffset;

    if (currentBlockKey === startKey) {
      selectionStart = startOffset;
      selectionEnd = isSameBlock ? endOffset : block.getText().length;
    } else if (currentBlockKey === endKey) {
      selectionStart = isSameBlock ? startOffset : 0;
      selectionEnd = endOffset;
    } else {
      selectionStart = 0;
      selectionEnd = block.getText().length;
    }

    var selection = new __WEBPACK_IMPORTED_MODULE_0_draft_js__["SelectionState"]({
      anchorKey: currentBlockKey,
      anchorOffset: selectionStart,
      focusKey: currentBlockKey,
      focusOffset: selectionEnd
    });
    finalEditorState = modifier.apply(void 0, [finalEditorState, selection].concat(args));
  });
  return __WEBPACK_IMPORTED_MODULE_0_draft_js__["EditorState"].forceSelection(finalEditorState, currentSelection);
});

/***/ }),
/* 2716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SyntheticDOM__ = __webpack_require__(2717);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SyntheticDOM__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__SyntheticDOM__["b"]; });


/***/ }),
/* 2717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NODE_TYPE_ELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NODE_TYPE_TEXT; });
/* unused harmony export NODE_TYPE_FRAGMENT */
/* unused harmony export SELF_CLOSING */
/* unused harmony export Node */
/* unused harmony export TextNode */
/* unused harmony export ElementNode */
/* unused harmony export FragmentNode */
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EMPTY_ATTR_LIST = [];
var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_FRAGMENT = 11;
var SELF_CLOSING = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
};
var Node =
/*#__PURE__*/
function () {
  function Node() {
    _classCallCheck(this, Node);

    _defineProperty(this, "nodeType", void 0);

    _defineProperty(this, "nodeName", void 0);

    _defineProperty(this, "nodeValue", void 0);

    _defineProperty(this, "childNodes", void 0);
  }

  _createClass(Node, [{
    key: "toString",
    value: function toString(isXHTML) {
      return isXHTML ? '' : '';
    }
  }]);

  return Node;
}();
var TextNode =
/*#__PURE__*/
function (_Node) {
  _inherits(TextNode, _Node);

  function TextNode(value) {
    var _this;

    _classCallCheck(this, TextNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextNode).apply(this, arguments));
    _this.nodeType = NODE_TYPE_TEXT;
    _this.nodeName = '#text';
    _this.nodeValue = value;
    return _this;
  } // eslint-disable-next-line no-unused-vars


  _createClass(TextNode, [{
    key: "toString",
    value: function toString(isXHTML) {
      return escape(this.nodeValue);
    }
  }]);

  return TextNode;
}(Node);
var ElementNode =
/*#__PURE__*/
function (_Node2) {
  _inherits(ElementNode, _Node2);

  function ElementNode(name, attributes, childNodes) {
    var _this2;

    _classCallCheck(this, ElementNode);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ElementNode).apply(this, arguments));

    _defineProperty(_assertThisInitialized(_this2), "_name", void 0);

    _defineProperty(_assertThisInitialized(_this2), "_attrMap", void 0);

    _defineProperty(_assertThisInitialized(_this2), "_isSelfClosing", void 0);

    _defineProperty(_assertThisInitialized(_this2), "childNodes", void 0);

    _defineProperty(_assertThisInitialized(_this2), "attributes", void 0);

    if (attributes == null) {
      attributes = EMPTY_ATTR_LIST;
    }

    var isSelfClosing = SELF_CLOSING[name] === true;
    _this2.nodeType = NODE_TYPE_ELEMENT;
    _this2._name = name.toLowerCase();
    _this2.attributes = attributes;
    _this2._attrMap = new Map(attributes.map(function (attr) {
      return [attr.name, attr];
    }));
    _this2.nodeName = name.toUpperCase();
    _this2.childNodes = [];
    _this2._isSelfClosing = isSelfClosing;

    if (!isSelfClosing && childNodes) {
      childNodes.forEach(_this2.appendChild, _assertThisInitialized(_this2));
    }

    return _this2;
  }

  _createClass(ElementNode, [{
    key: "appendChild",
    value: function appendChild(node) {
      if (node.nodeType === NODE_TYPE_FRAGMENT && node.childNodes) {
        var _this$childNodes;

        this.childNodes && (_this$childNodes = this.childNodes).push.apply(_this$childNodes, _toConsumableArray(node.childNodes));
      } else {
        this.childNodes && this.childNodes.push(node);
      }
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(name) {
      var attr = this._attrMap.get(name);

      if (attr) {
        return attr.value;
      }
    }
  }, {
    key: "toString",
    value: function toString(isXHTML) {
      var attributes = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _step.value,
              name = _step$value.name,
              value = _step$value.value;
          attributes.push(name + (value ? '="' + escapeAttr(value) + '"' : ''));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var attrString = attributes.length ? ' ' + attributes.join(' ') : '';

      if (this._isSelfClosing) {
        return '<' + this._name + attrString + (isXHTML ? '/>' : '>');
      }

      var childNodes = this.childNodes ? this.childNodes.map(function (node) {
        return node.toString(isXHTML);
      }).join('') : '';
      return '<' + this._name + attrString + '>' + childNodes + '</' + this._name + '>';
    }
  }, {
    key: "tagName",
    get: function get() {
      return this.nodeName;
    }
  }, {
    key: "className",
    get: function get() {
      return this.getAttribute('class') || '';
    }
  }]);

  return ElementNode;
}(Node);
var FragmentNode =
/*#__PURE__*/
function (_Node3) {
  _inherits(FragmentNode, _Node3);

  function FragmentNode(childNodes) {
    var _this3;

    _classCallCheck(this, FragmentNode);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(FragmentNode).apply(this, arguments));

    _defineProperty(_assertThisInitialized(_this3), "childNodes", void 0);

    _this3.nodeType = NODE_TYPE_FRAGMENT;
    _this3.childNodes = [];

    if (childNodes) {
      childNodes.forEach(_this3.appendChild, _assertThisInitialized(_this3));
    }

    return _this3;
  }

  _createClass(FragmentNode, [{
    key: "appendChild",
    value: function appendChild(node) {
      if (node.nodeType === NODE_TYPE_FRAGMENT && node.childNodes) {
        var _this$childNodes2;

        this.childNodes && (_this$childNodes2 = this.childNodes).push.apply(_this$childNodes2, _toConsumableArray(node.childNodes));
      } else {
        this.childNodes && this.childNodes.push(node);
      }
    }
  }, {
    key: "toString",
    value: function toString(isXHTML) {
      var childNodes = this.childNodes;
      return childNodes ? childNodes.map(function (node) {
        return node.toString(isXHTML);
      }).join('') : '';
    }
  }]);

  return FragmentNode;
}(Node);

function escape(html) {
  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeAttr(html) {
  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/***/ }),
/* 2718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INLINE_ELEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SPECIAL_ELEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELF_CLOSING_ELEMENTS; });
var INLINE_ELEMENTS = {
  a: 1,
  abbr: 1,
  area: 1,
  audio: 1,
  b: 1,
  bdi: 1,
  bdo: 1,
  br: 1,
  button: 1,
  canvas: 1,
  cite: 1,
  code: 1,
  command: 1,
  datalist: 1,
  del: 1,
  dfn: 1,
  em: 1,
  embed: 1,
  i: 1,
  iframe: 1,
  img: 1,
  input: 1,
  ins: 1,
  kbd: 1,
  keygen: 1,
  label: 1,
  map: 1,
  mark: 1,
  meter: 1,
  noscript: 1,
  object: 1,
  output: 1,
  progress: 1,
  q: 1,
  ruby: 1,
  s: 1,
  samp: 1,
  script: 1,
  select: 1,
  small: 1,
  span: 1,
  strong: 1,
  sub: 1,
  sup: 1,
  textarea: 1,
  time: 1,
  u: 1,
  "var": 1,
  video: 1,
  wbr: 1,
  acronym: 1,
  applet: 1,
  basefont: 1,
  big: 1,
  font: 1,
  isindex: 1,
  strike: 1,
  style: 1,
  tt: 1
}; // These elements are special because they cannot contain text as a direct
// child (some cannot contain childNodes at all).

var SPECIAL_ELEMENTS = {
  area: 1,
  base: 1,
  br: 1,
  col: 1,
  colgroup: 1,
  command: 1,
  dl: 1,
  embed: 1,
  head: 1,
  hgroup: 1,
  hr: 1,
  iframe: 1,
  img: 1,
  input: 1,
  keygen: 1,
  link: 1,
  meta: 1,
  ol: 1,
  optgroup: 1,
  option: 1,
  param: 1,
  script: 1,
  select: 1,
  source: 1,
  style: 1,
  table: 1,
  tbody: 1,
  textarea: 1,
  tfoot: 1,
  thead: 1,
  title: 1,
  tr: 1,
  track: 1,
  ul: 1,
  wbr: 1,
  basefont: 1,
  dialog: 1,
  dir: 1,
  isindex: 1
}; // These elements are special because they cannot contain childNodes.
// TODO: This is not an exhaustive list.

var SELF_CLOSING_ELEMENTS = {
  img: 1
};

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stateToHTML = __webpack_require__(2720);

Object.defineProperty(exports, 'stateToHTML', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stateToHTML).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DEFAULT_STYLE_MAP, _ENTITY_ATTR_MAP, _DATA_TO_ATTR;

exports.default = stateToHTML;

var _combineOrderedStyles3 = __webpack_require__(2721);

var _combineOrderedStyles4 = _interopRequireDefault(_combineOrderedStyles3);

var _normalizeAttributes = __webpack_require__(2722);

var _normalizeAttributes2 = _interopRequireDefault(_normalizeAttributes);

var _styleToCSS = __webpack_require__(2723);

var _styleToCSS2 = _interopRequireDefault(_styleToCSS);

var _draftJsUtils = __webpack_require__(690);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BOLD = _draftJsUtils.INLINE_STYLE.BOLD,
    CODE = _draftJsUtils.INLINE_STYLE.CODE,
    ITALIC = _draftJsUtils.INLINE_STYLE.ITALIC,
    STRIKETHROUGH = _draftJsUtils.INLINE_STYLE.STRIKETHROUGH,
    UNDERLINE = _draftJsUtils.INLINE_STYLE.UNDERLINE;


var INDENT = '  ';
var BREAK = '<br>';
var DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/;

var DEFAULT_STYLE_MAP = (_DEFAULT_STYLE_MAP = {}, _defineProperty(_DEFAULT_STYLE_MAP, BOLD, { element: 'strong' }), _defineProperty(_DEFAULT_STYLE_MAP, CODE, { element: 'code' }), _defineProperty(_DEFAULT_STYLE_MAP, ITALIC, { element: 'em' }), _defineProperty(_DEFAULT_STYLE_MAP, STRIKETHROUGH, { element: 'del' }), _defineProperty(_DEFAULT_STYLE_MAP, UNDERLINE, { element: 'u' }), _DEFAULT_STYLE_MAP);

// Order: inner-most style to outer-most.
// Examle: <em><strong>foo</strong></em>
var DEFAULT_STYLE_ORDER = [BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE];

// Map entity data to element attributes.
var ENTITY_ATTR_MAP = (_ENTITY_ATTR_MAP = {}, _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.LINK, {
  url: 'href',
  href: 'href',
  rel: 'rel',
  target: 'target',
  title: 'title',
  className: 'class'
}), _defineProperty(_ENTITY_ATTR_MAP, _draftJsUtils.ENTITY_TYPE.IMAGE, {
  src: 'src',
  height: 'height',
  width: 'width',
  alt: 'alt',
  className: 'class'
}), _ENTITY_ATTR_MAP);

// Map entity data to element attributes.
var DATA_TO_ATTR = (_DATA_TO_ATTR = {}, _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.LINK, function (entityType, entity) {
  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
  var data = entity.getData();
  var attrs = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(data)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var dataKey = _step.value;

      var dataValue = data[dataKey];
      if (attrMap.hasOwnProperty(dataKey)) {
        var attrKey = attrMap[dataKey];
        attrs[attrKey] = dataValue;
      } else if (DATA_ATTRIBUTE.test(dataKey)) {
        attrs[dataKey] = dataValue;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return attrs;
}), _defineProperty(_DATA_TO_ATTR, _draftJsUtils.ENTITY_TYPE.IMAGE, function (entityType, entity) {
  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
  var data = entity.getData();
  var attrs = {};
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = Object.keys(data)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var dataKey = _step2.value;

      var dataValue = data[dataKey];
      if (attrMap.hasOwnProperty(dataKey)) {
        var attrKey = attrMap[dataKey];
        attrs[attrKey] = dataValue;
      } else if (DATA_ATTRIBUTE.test(dataKey)) {
        attrs[dataKey] = dataValue;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return attrs;
}), _DATA_TO_ATTR);

// The reason this returns an array is because a single block might get wrapped
// in two tags.
function getTags(blockType, defaultBlockTag) {
  switch (blockType) {
    case _draftJsUtils.BLOCK_TYPE.HEADER_ONE:
      return ['h1'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_TWO:
      return ['h2'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_THREE:
      return ['h3'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_FOUR:
      return ['h4'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_FIVE:
      return ['h5'];
    case _draftJsUtils.BLOCK_TYPE.HEADER_SIX:
      return ['h6'];
    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
      return ['li'];
    case _draftJsUtils.BLOCK_TYPE.BLOCKQUOTE:
      return ['blockquote'];
    case _draftJsUtils.BLOCK_TYPE.CODE:
      return ['pre', 'code'];
    case _draftJsUtils.BLOCK_TYPE.ATOMIC:
      return ['figure'];
    default:
      if (defaultBlockTag === null) {
        return [];
      }
      return [defaultBlockTag || 'p'];
  }
}

function getWrapperTag(blockType) {
  switch (blockType) {
    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
      return 'ul';
    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
      return 'ol';
    default:
      return null;
  }
}

var MarkupGenerator = function () {
  // These are related to user-defined options.
  function MarkupGenerator(contentState, options) {
    _classCallCheck(this, MarkupGenerator);

    if (options == null) {
      options = {};
    }
    this.contentState = contentState;
    this.options = options;

    var _combineOrderedStyles = (0, _combineOrderedStyles4.default)(options.inlineStyles, [DEFAULT_STYLE_MAP, DEFAULT_STYLE_ORDER]),
        _combineOrderedStyles2 = _slicedToArray(_combineOrderedStyles, 2),
        inlineStyles = _combineOrderedStyles2[0],
        styleOrder = _combineOrderedStyles2[1];

    this.inlineStyles = inlineStyles;
    this.inlineStyleFn = options.inlineStyleFn;
    this.styleOrder = styleOrder;
  }
  // These are related to state.


  _createClass(MarkupGenerator, [{
    key: 'generate',
    value: function generate() {
      this.output = [];
      this.blocks = this.contentState.getBlocksAsArray();
      this.totalBlocks = this.blocks.length;
      this.currentBlock = 0;
      this.indentLevel = 0;
      this.wrapperTag = null;
      while (this.currentBlock < this.totalBlocks) {
        this.processBlock();
      }
      this.closeWrapperTag();
      return this.output.join('').trim();
    }
  }, {
    key: 'processBlock',
    value: function processBlock() {
      var _options = this.options,
          blockRenderers = _options.blockRenderers,
          defaultBlockTag = _options.defaultBlockTag;

      var block = this.blocks[this.currentBlock];
      var blockType = block.getType();
      var newWrapperTag = getWrapperTag(blockType);
      if (this.wrapperTag !== newWrapperTag) {
        if (this.wrapperTag) {
          this.closeWrapperTag();
        }
        if (newWrapperTag) {
          this.openWrapperTag(newWrapperTag);
        }
      }
      this.indent();
      // Allow blocks to be rendered using a custom renderer.
      var customRenderer = blockRenderers != null && blockRenderers.hasOwnProperty(blockType) ? blockRenderers[blockType] : null;
      var customRendererOutput = customRenderer ? customRenderer(block) : null;
      // Renderer can return null, which will cause processing to continue as normal.
      if (customRendererOutput != null) {
        this.output.push(customRendererOutput);
        this.output.push('\n');
        this.currentBlock += 1;
        return;
      }
      this.writeStartTag(block, defaultBlockTag);
      this.output.push(this.renderBlockContent(block));
      // Look ahead and see if we will nest list.
      var nextBlock = this.getNextBlock();
      if (canHaveDepth(blockType) && nextBlock && nextBlock.getDepth() === block.getDepth() + 1) {
        this.output.push('\n');
        // This is a litle hacky: temporarily stash our current wrapperTag and
        // render child list(s).
        var thisWrapperTag = this.wrapperTag;
        this.wrapperTag = null;
        this.indentLevel += 1;
        this.currentBlock += 1;
        this.processBlocksAtDepth(nextBlock.getDepth());
        this.wrapperTag = thisWrapperTag;
        this.indentLevel -= 1;
        this.indent();
      } else {
        this.currentBlock += 1;
      }
      this.writeEndTag(block, defaultBlockTag);
    }
  }, {
    key: 'processBlocksAtDepth',
    value: function processBlocksAtDepth(depth) {
      var block = this.blocks[this.currentBlock];
      while (block && block.getDepth() === depth) {
        this.processBlock();
        block = this.blocks[this.currentBlock];
      }
      this.closeWrapperTag();
    }
  }, {
    key: 'getNextBlock',
    value: function getNextBlock() {
      return this.blocks[this.currentBlock + 1];
    }
  }, {
    key: 'writeStartTag',
    value: function writeStartTag(block, defaultBlockTag) {
      var tags = getTags(block.getType(), defaultBlockTag);

      var attrString = void 0;
      if (this.options.blockStyleFn) {
        var _ref = this.options.blockStyleFn(block) || {},
            _attributes = _ref.attributes,
            _style = _ref.style;
        // Normalize `className` -> `class`, etc.


        _attributes = (0, _normalizeAttributes2.default)(_attributes);
        if (_style != null) {
          var styleAttr = (0, _styleToCSS2.default)(_style);
          _attributes = _attributes == null ? { style: styleAttr } : _extends({}, _attributes, { style: styleAttr });
        }
        attrString = stringifyAttrs(_attributes);
      } else {
        attrString = '';
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = tags[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var tag = _step3.value;

          this.output.push('<' + tag + attrString + '>');
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  }, {
    key: 'writeEndTag',
    value: function writeEndTag(block, defaultBlockTag) {
      var tags = getTags(block.getType(), defaultBlockTag);
      if (tags.length === 1) {
        this.output.push('</' + tags[0] + '>\n');
      } else {
        var output = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = tags[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var tag = _step4.value;

            output.unshift('</' + tag + '>');
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        this.output.push(output.join('') + '\n');
      }
    }
  }, {
    key: 'openWrapperTag',
    value: function openWrapperTag(wrapperTag) {
      this.wrapperTag = wrapperTag;
      this.indent();
      this.output.push('<' + wrapperTag + '>\n');
      this.indentLevel += 1;
    }
  }, {
    key: 'closeWrapperTag',
    value: function closeWrapperTag() {
      var wrapperTag = this.wrapperTag;

      if (wrapperTag) {
        this.indentLevel -= 1;
        this.indent();
        this.output.push('</' + wrapperTag + '>\n');
        this.wrapperTag = null;
      }
    }
  }, {
    key: 'indent',
    value: function indent() {
      this.output.push(INDENT.repeat(this.indentLevel));
    }
  }, {
    key: 'withCustomInlineStyles',
    value: function withCustomInlineStyles(content, styleSet) {
      if (!this.inlineStyleFn) {
        return content;
      }

      var renderConfig = this.inlineStyleFn(styleSet);
      if (!renderConfig) {
        return content;
      }

      var _renderConfig$element = renderConfig.element,
          element = _renderConfig$element === undefined ? 'span' : _renderConfig$element,
          attributes = renderConfig.attributes,
          style = renderConfig.style;

      var attrString = stringifyAttrs(_extends({}, attributes, {
        style: style && (0, _styleToCSS2.default)(style)
      }));

      return '<' + element + attrString + '>' + content + '</' + element + '>';
    }
  }, {
    key: 'renderBlockContent',
    value: function renderBlockContent(block) {
      var _this = this;

      var blockType = block.getType();
      var text = block.getText();
      if (text === '') {
        // Prevent element collapse if completely empty.
        return BREAK;
      }
      text = this.preserveWhitespace(text);
      var charMetaList = block.getCharacterList();
      var entityPieces = (0, _draftJsUtils.getEntityRanges)(text, charMetaList);
      return entityPieces.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            entityKey = _ref3[0],
            stylePieces = _ref3[1];

        var content = stylePieces.map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              text = _ref5[0],
              styleSet = _ref5[1];

          var content = encodeContent(text);
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = _this.styleOrder[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var _styleName = _step5.value;

              // If our block type is CODE then don't wrap inline code elements.
              if (_styleName === CODE && blockType === _draftJsUtils.BLOCK_TYPE.CODE) {
                continue;
              }
              if (styleSet.has(_styleName)) {
                var _inlineStyles$_styleN = _this.inlineStyles[_styleName],
                    _element = _inlineStyles$_styleN.element,
                    _attributes2 = _inlineStyles$_styleN.attributes,
                    _style2 = _inlineStyles$_styleN.style;

                if (_element == null) {
                  _element = 'span';
                }
                // Normalize `className` -> `class`, etc.
                _attributes2 = (0, _normalizeAttributes2.default)(_attributes2);
                if (_style2 != null) {
                  var styleAttr = (0, _styleToCSS2.default)(_style2);
                  _attributes2 = _attributes2 == null ? { style: styleAttr } : _extends({}, _attributes2, { style: styleAttr });
                }
                var attrString = stringifyAttrs(_attributes2);
                content = '<' + _element + attrString + '>' + content + '</' + _element + '>';
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }

          return _this.withCustomInlineStyles(content, styleSet);
        }).join('');
        var entity = entityKey ? _this.contentState.getEntity(entityKey) : null;
        // Note: The `toUpperCase` below is for compatability with some libraries that use lower-case for image blocks.
        var entityType = entity == null ? null : entity.getType().toUpperCase();
        var entityStyle = void 0;
        if (entity != null && _this.options.entityStyleFn && (entityStyle = _this.options.entityStyleFn(entity))) {
          var _entityStyle = entityStyle,
              _element2 = _entityStyle.element,
              _attributes3 = _entityStyle.attributes,
              _style3 = _entityStyle.style;

          if (_element2 == null) {
            _element2 = 'span';
          }
          // Normalize `className` -> `class`, etc.
          _attributes3 = (0, _normalizeAttributes2.default)(_attributes3);
          if (_style3 != null) {
            var styleAttr = (0, _styleToCSS2.default)(_style3);
            _attributes3 = _attributes3 == null ? { style: styleAttr } : _extends({}, _attributes3, { style: styleAttr });
          }
          var attrString = stringifyAttrs(_attributes3);
          return '<' + _element2 + attrString + '>' + content + '</' + _element2 + '>';
        } else if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.LINK) {
          var attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
          var _attrString = stringifyAttrs(attrs);
          return '<a' + _attrString + '>' + content + '</a>';
        } else if (entityType != null && entityType === _draftJsUtils.ENTITY_TYPE.IMAGE) {
          var _attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;
          var _attrString2 = stringifyAttrs(_attrs);
          return '<img' + _attrString2 + '/>';
        } else {
          return content;
        }
      }).join('');
    }
  }, {
    key: 'preserveWhitespace',
    value: function preserveWhitespace(text) {
      var length = text.length;
      // Prevent leading/trailing/consecutive whitespace collapse.
      var newText = new Array(length);
      for (var i = 0; i < length; i++) {
        if (text[i] === ' ' && (i === 0 || i === length - 1 || text[i - 1] === ' ')) {
          newText[i] = '\xA0';
        } else {
          newText[i] = text[i];
        }
      }
      return newText.join('');
    }
  }]);

  return MarkupGenerator;
}();

function stringifyAttrs(attrs) {
  if (attrs == null) {
    return '';
  }
  var parts = [];
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = Object.keys(attrs)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var name = _step6.value;

      var value = attrs[name];
      if (value != null) {
        parts.push(' ' + name + '="' + encodeAttr(value + '') + '"');
      }
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return parts.join('');
}

function canHaveDepth(blockType) {
  switch (blockType) {
    case _draftJsUtils.BLOCK_TYPE.UNORDERED_LIST_ITEM:
    case _draftJsUtils.BLOCK_TYPE.ORDERED_LIST_ITEM:
      return true;
    default:
      return false;
  }
}

function encodeContent(text) {
  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join(BREAK + '\n');
}

function encodeAttr(text) {
  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
}

function stateToHTML(content, options) {
  return new MarkupGenerator(content, options).generate();
}

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function combineOrderedStyles(customMap, defaults) {
  if (customMap == null) {
    return defaults;
  }

  var _defaults = _slicedToArray(defaults, 2),
      defaultStyleMap = _defaults[0],
      defaultStyleOrder = _defaults[1];

  var styleMap = _extends({}, defaultStyleMap);
  var styleOrder = [].concat(_toConsumableArray(defaultStyleOrder));
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(customMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _styleName = _step.value;

      if (defaultStyleMap.hasOwnProperty(_styleName)) {
        var defaultStyles = defaultStyleMap[_styleName];
        styleMap[_styleName] = _extends({}, defaultStyles, customMap[_styleName]);
      } else {
        styleMap[_styleName] = customMap[_styleName];
        styleOrder.push(_styleName);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return [styleMap, styleOrder];
}

exports.default = combineOrderedStyles;

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
var ATTR_NAME_MAP = {
  acceptCharset: 'accept-charset',
  className: 'class',
  htmlFor: 'for',
  httpEquiv: 'http-equiv'
};

function normalizeAttributes(attributes) {
  if (attributes == null) {
    return attributes;
  }
  var normalized = {};
  var didNormalize = false;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(attributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var name = _step.value;

      var newName = name;
      if (ATTR_NAME_MAP.hasOwnProperty(name)) {
        newName = ATTR_NAME_MAP[name];
        didNormalize = true;
      }
      normalized[newName] = attributes[name];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return didNormalize ? normalized : attributes;
}

exports.default = normalizeAttributes;

/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var VENDOR_PREFIX = /^(moz|ms|o|webkit)-/;

var NUMERIC_STRING = /^\d+$/;
var UPPERCASE_PATTERN = /([A-Z])/g;

// Lifted from:
// https://github.com/facebook/react/blob/ab4ddf64939aebbbc8d31be1022efd56e834c95c/src/renderers/dom/shared/CSSProperty.js
var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js
function processStyleName(name) {
  return name.replace(UPPERCASE_PATTERN, '-$1').toLowerCase().replace(VENDOR_PREFIX, '-$1-');
}

// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js
function processStyleValue(name, value) {
  var isNumeric = void 0;
  if (typeof value === 'string') {
    isNumeric = NUMERIC_STRING.test(value);
  } else {
    isNumeric = true;
    value = String(value);
  }
  if (!isNumeric || value === '0' || isUnitlessNumber[name] === true) {
    return value;
  } else {
    return value + 'px';
  }
}

function styleToCSS(styleDescr) {
  return Object.keys(styleDescr).map(function (name) {
    var styleValue = processStyleValue(name, styleDescr[name]);
    var styleName = processStyleName(name);
    return styleName + ': ' + styleValue;
  }).join('; ');
}

exports.default = styleToCSS;

/***/ }),
/* 2724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextEditor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__editorStateConverters__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utility__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models__ = __webpack_require__(328);






var deleteKeyCommands = ["delete", "delete-word", "backspace", "backspace-word", "backspace-to-start-of-line"];
var TextEditor = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TextEditor, _super);
    function TextEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (updatedEditorState) { return _this.props.onEditorChange(updatedEditorState); };
        _this.handleKeyCommand = function (command, editorState) {
            var selection = editorState.getSelection();
            if (selection.isCollapsed() && deleteKeyCommands.indexOf(command) !== -1) {
                var content = editorState.getCurrentContent();
                var block = content.getBlockForKey(selection.getAnchorKey());
                var blockText = block.getText();
                if (blockText === __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].emptyBlockValue) {
                    // There should be a better way to get this.
                    var previousBlockKey = editorState.getCurrentContent().getBlockBefore(editorState.getSelection().getAnchorKey()).getKey();
                    var blockMap = content.getBlockMap().delete(block.getKey());
                    var withoutPseudoEmptyBlock = content.merge({
                        blockMap: blockMap,
                        selectionAfter: selection,
                    });
                    if (withoutPseudoEmptyBlock !== content) {
                        var nextEditorState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["EditorState"].push(editorState, withoutPseudoEmptyBlock, "remove-range");
                        var nextContent = nextEditorState.getCurrentContent();
                        var nextContentBlock = nextContent.getBlockForKey(previousBlockKey);
                        nextEditorState = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].forceFocusBlockEnding(nextEditorState, nextContentBlock);
                        _this.onChange(nextEditorState);
                        return "handled";
                    }
                }
            }
            // TODO: See which keyboard commands are built in and which we want to block.
            var newState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["RichUtils"].handleKeyCommand(editorState, command);
            if (newState) {
                _this.onChange(newState);
                return "handled";
            }
            return "not-handled";
        };
        _this.handleBeforeInput = function (chars, editorState) {
            var nextEditorState = _this.setEditorStateTextForSelection(editorState, chars);
            _this.onChange(nextEditorState);
            return "handled";
        };
        _this.setEditorStateTextForSelection = function (editorState, chars) {
            var selection = editorState.getSelection();
            var content = editorState.getCurrentContent();
            var block = content.getBlockForKey(selection.getAnchorKey());
            var blockHasText = block.getText().length > 0;
            var style = blockHasText ? editorState.getCurrentInlineStyle() : _this.props.styleOverrides;
            var offset = selection.getStartOffset();
            var character = block.getCharacterList().get(selection.isCollapsed() ? offset : offset - 1);
            var entityKey = null;
            if (blockHasText && character) {
                entityKey = character.getEntity();
            }
            var textMethod = selection.isCollapsed() ? __WEBPACK_IMPORTED_MODULE_2_draft_js__["Modifier"].insertText : __WEBPACK_IMPORTED_MODULE_2_draft_js__["Modifier"].replaceText;
            var newContent = textMethod(content, selection, chars, style, entityKey);
            var nextEditorState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["EditorState"].push(editorState, newContent, "insert-characters");
            // This must happen AFTER we insert characters.
            if (!blockHasText) {
                var fontProvider = _this.props.fontProvider;
                // This is newly created empty(!) content block.
                // with inserted text a few lines code above (please see Modifier.insertText)
                // but selection state, is from empty content block, so it has no seletions
                // Draft.js Entity should be applied to some selection. It can't be applied to empty selection
                // So we do the next:
                // 1) Select all newly inserted text charter(s)
                var currentContent = nextEditorState.getCurrentContent();
                var lastBlock = currentContent.getBlockMap().last();
                var lastBlockKey = lastBlock.getKey();
                var selection_1 = new __WEBPACK_IMPORTED_MODULE_2_draft_js__["SelectionState"]({
                    anchorKey: lastBlockKey,
                    anchorOffset: 0,
                    focusKey: lastBlockKey,
                    focusOffset: 0,
                });
                nextEditorState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["EditorState"].forceSelection(nextEditorState, selection_1);
                // 2) Apply fontProvider entity to the selection
                nextEditorState = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].setFontMetaData(nextEditorState, fontProvider);
                var nextContent = nextEditorState.getCurrentContent();
                var nextContentBlock = nextContent.getBlockForKey(selection_1.getAnchorKey());
                // 3) Reset (or revert back) <Select all> selection from step 1, and move cursor and focus selection back
                nextEditorState = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].forceFocusBlockEnding(nextEditorState, nextContentBlock);
            }
            return nextEditorState;
        };
        _this.handleReturn = function (_event, editorState) {
            var nextEditorState = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].splitBlockWithData(editorState);
            var currentBlock = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].getSelectedBlock(nextEditorState);
            var previousBlock = nextEditorState.getCurrentContent().getBlockBefore(currentBlock.getKey());
            if (currentBlock.getText().length === 0) {
                nextEditorState =
                    _this.setEditorStateTextForSelection(nextEditorState, __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].emptyBlockValue);
            }
            if (previousBlock.getText().length === 0) {
                var selection = new __WEBPACK_IMPORTED_MODULE_2_draft_js__["SelectionState"]({
                    anchorKey: previousBlock.getKey(),
                    anchorOffset: 0,
                    focusKey: previousBlock.getKey(),
                    focusOffset: 0,
                });
                var newContent = __WEBPACK_IMPORTED_MODULE_2_draft_js__["Modifier"].insertText(nextEditorState.getCurrentContent(), selection, __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].emptyBlockValue, currentBlock.getInlineStyleAt(0));
                nextEditorState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["EditorState"].push(nextEditorState, newContent, "insert-characters");
                nextEditorState = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].forceFocusBeginningOfSelectionState(nextEditorState, currentBlock.getKey());
            }
            if (nextEditorState) {
                _this.onChange(nextEditorState);
                return "handled";
            }
            return "not-handled";
        };
        _this.handleDrop = function () {
            // Considering all drops onto editor handled to prevent the insertion of text when a new
            // widget is dropped on top of an existing ETW
            return "handled";
        };
        // The documentation says that html may be undefined but we can't have options params before required.
        _this.handlePastedText = function (text, _html, editorState) {
            if (_html === void 0) { _html = ""; }
            // We need to handle pasted input just like regular user input.
            // In the future we'll need to parse styles and apply them to editor state.
            var _a = _this.props, fontProvider = _a.fontProvider, styleOverrides = _a.styleOverrides;
            // Content Block where pasting of text was happening
            var currentBlock = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].getSelectedBlock(editorState);
            var santizedBlocks = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].sanitizeTextToBlockMap(text);
            var nextEditorState = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].insertBlockMapFragmet(editorState, santizedBlocks);
            // 1) Save active selection for usage after applying styles
            var selectionStateBeforeInsert = editorState.getSelection();
            // 2) Selection state after insert of fragment
            var selectionStateAfterInsert = nextEditorState.getSelection();
            var selectionOfInsertedText = new __WEBPACK_IMPORTED_MODULE_2_draft_js__["SelectionState"]({
                anchorKey: selectionStateBeforeInsert.getAnchorKey(),
                anchorOffset: selectionStateBeforeInsert.getAnchorOffset(),
                focusKey: selectionStateAfterInsert.getFocusKey(),
                focusOffset: selectionStateAfterInsert.getFocusOffset(),
            });
            // 3) Select inserted fragment blocks for the style applying to the current selection of EditorState
            nextEditorState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["EditorState"].acceptSelection(nextEditorState, selectionOfInsertedText);
            // 4) Apply fontMetadata to the inserted content blocks
            nextEditorState = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].setFontMetaData(nextEditorState, fontProvider);
            // 5) Line height and text-align style props applying to the inserted content blocks 
            // from content state selection state BEFORE insert
            var currentBlockDataStyles = __WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].getSelectedBlock(editorState).getData();
            var nextContentState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["Modifier"].setBlockData(nextEditorState.getCurrentContent(), selectionOfInsertedText, currentBlockDataStyles);
            // 6) Apply inline styles (font size, color and etc) to the inserted content blocks from pasted cursor position block
            var blockHasText = currentBlock.getText().length > 0;
            var currentInlineStyles = blockHasText ? currentBlock.getInlineStyleAt(selectionStateBeforeInsert.getAnchorOffset() - 1) : styleOverrides;
            currentInlineStyles.toArray().forEach(function (style) {
                nextContentState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["Modifier"].applyInlineStyle(nextContentState, selectionOfInsertedText, style);
            });
            nextEditorState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["EditorState"].push(nextEditorState, nextContentState, 'change-block-data');
            // 7) Revert back selection
            nextEditorState = __WEBPACK_IMPORTED_MODULE_2_draft_js__["EditorState"].acceptSelection(nextEditorState, selectionStateAfterInsert);
            _this.onChange(nextEditorState);
            return "handled";
        };
        return _this;
    }
    TextEditor.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, isSelected = _a.isSelected, hasFakeHighlight = _a.hasFakeHighlight, editorState = _a.editorState;
        var isSelectedChanged = isSelected !== prevProps.isSelected;
        var hasFakeHighlightChanged = hasFakeHighlight !== prevProps.hasFakeHighlight;
        if ((!isSelected && isSelectedChanged) || (!hasFakeHighlight && hasFakeHighlightChanged)) {
            this.onChange(__WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].removeInlineStyle(editorState, __WEBPACK_IMPORTED_MODULE_5__models__["c" /* DraftStyles */].HIGHLIGHT));
        }
        if (isSelected && hasFakeHighlight && hasFakeHighlightChanged) {
            this.onChange(__WEBPACK_IMPORTED_MODULE_4__utility__["a" /* DraftJSUtils */].applyInlineStyle(editorState, __WEBPACK_IMPORTED_MODULE_5__models__["c" /* DraftStyles */].HIGHLIGHT));
        }
    };
    TextEditor.prototype.render = function () {
        var _a = this.props, editorState = _a.editorState, readOnly = _a.readOnly, setRef = _a.setRef;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_draft_js__["Editor"], { editorState: editorState, onChange: this.onChange, handleKeyCommand: this.handleKeyCommand, handleDrop: this.handleDrop, customStyleFn: __WEBPACK_IMPORTED_MODULE_3__editorStateConverters__["f" /* customStyleFn */], customStyleMap: __WEBPACK_IMPORTED_MODULE_3__editorStateConverters__["e" /* customInlineStyleMap */], blockStyleFn: __WEBPACK_IMPORTED_MODULE_3__editorStateConverters__["c" /* blockStyleFn */], placeholder: "Your text here...", handleReturn: this.handleReturn, handleBeforeInput: this.handleBeforeInput, readOnly: readOnly, handlePastedText: this.handlePastedText, stripPastedStyles: true, ref: setRef }));
    };
    return TextEditor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
// noinspection JSUnusedGlobalSymbols



/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var AbstractWidgetView = __webpack_require__(61);
    var HtmlWidgetView = __webpack_require__(506);
    var Marionette = __webpack_require__(10);
    var ReactBridge = __webpack_require__(137);
    var HtmlWidget = __webpack_require__(2726).default;
    var HtmlWidgetLayout = Marionette.Layout.extend({

        template: function template() {
            return "<div class=\"html-widget placeholder\"></div>";
        },

        regions: {
            "html-widget": ".html-widget"
        }

    });

    /**
     * Mixin the editor related logic for the HtmlWidgetView
     *
     * @see  HtmlWidgetView
     */
    return HtmlWidgetView.mixin("HtmlWidgetViewEditorMixin", {

        _layout: null,

        className: AbstractWidgetView.prototype.className + " html-widget",

        // This gives us access to the proper this context
        getPropsFromView: function getPropsFromView(self) {
            return {
                onChange: function onChange(text) {
                    self.model.set("htmlText", text);
                },
                onSelect: function onSelect(event) {
                    var options = self.options;
                    // For some reason the selection is not updated to reflect the state of the editor surface.

                    var selectedWidgets = options.viewModel.selection.get("widgets");
                    var singleSelection = selectedWidgets.length < 2; // Not a group selection
                    var modifierKeyDown = event.shiftKey || event.ctrlKey || event.metaKey; // Same keys as in FreeTransform.js#down

                    if (singleSelection) {
                        if (modifierKeyDown) {
                            var newSelectedWidgets = _.uniq([self].concat(selectedWidgets));
                            options.viewModel.selection.select(newSelectedWidgets);
                        } else {
                            options.viewModel.selection.select([self]);
                        }
                    }
                },
                onDeselect: function onDeselect() {},
                onMount: function onMount() {}
            };
        },

        modelEvents: {},

        onRender: function onRender() {
            var onRender = AbstractWidgetView.prototype.onRender;

            if (onRender) {
                onRender.apply(this, _.toArray(arguments));
            }
        },
        onShow: function onShow() {
            this.__super();
        },
        showView: function showView() {
            this.__super();
            this._layout = new HtmlWidgetLayout({ el: this.$el });
            this._layout.render();

            var scopedGetProps = function scopedGetProps(_ref) {
                var model = _ref.model,
                    selection = _ref.selection,
                    viewModel = _ref.viewModel,
                    parentScene = _ref.parentScene;

                var selectionWidgets = selection && selection.get("widgets");
                var viewModelSceneNumber = viewModel && viewModel.get("sceneNumber");
                var parentSceneNumber = parentScene && parentScene.get("sceneNumber");
                var isWidgetInActiveScene = viewModelSceneNumber === parentSceneNumber;

                return {
                    isSelected: isWidgetInActiveScene && selectionWidgets.some(function (widget) {
                        return widget.model === model;
                    }),
                    readOnly: selection.isMultiple() || !isWidgetInActiveScene,
                    isTransforming: model.get("isTransforming"),
                    htmlText: model.get("htmlText")
                };
            };

            var htmlWidgetView = ReactBridge.viewFromComponent(HtmlWidget, {
                model: this.model,

                viewModel: this.options.viewModel,

                selection: this.options.viewModel.selection,

                parentScene: this.parentView.scene || this.parentView.model.get("scene"),

                observe: {
                    model: "change",
                    viewModel: "change",
                    selection: "change",
                    parentScene: "change"
                },

                // Passing in this so I have a reference to the backbone class.
                props: this.getPropsFromView(this),

                // The arguments here are from ReactBridge and NOT specifically our code.
                // This is the model specified in the config object.
                getProps: scopedGetProps
            });

            this._layout["html-widget"].show(htmlWidgetView);
        },
        onClose: function onClose() {
            if (this._layout) {
                this._layout.close();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HtmlWidget; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HtmlWidget", function() { return HtmlWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_portal__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HTMLWidgetControls__ = __webpack_require__(2727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_ui_common_styles__ = __webpack_require__(2728);





var HtmlWidget = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](HtmlWidget, _super);
    function HtmlWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDragContainerMouseDown = function (event) {
            _this.props.onSelect(event);
        };
        _this.onChange = function (event) {
            _this.props.onChange(event.target.textContent);
        };
        return _this;
    }
    HtmlWidget.prototype.render = function () {
        var isSelected = this.props.isSelected;
        var portalTarget = document && document.getElementById("character-properties");
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
            isSelected && portalTarget && (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_portal__["a" /* Portal */], { node: portalTarget },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null,
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__HTMLWidgetControls__["a" /* default */], { onChange: this.onChange, htmlText: this.props.htmlText })))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "drag-container", style: __WEBPACK_IMPORTED_MODULE_4_shared_ui_common_styles__["a" /* moveContainerStyles */], onMouseDown: this.handleDragContainerMouseDown })));
    };
    return HtmlWidget;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
// noinspection JSUnusedGlobalSymbols



/***/ }),
/* 2727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HtmlWidgetControls; });
/* unused harmony export HtmlWidgetControls */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__editor_ui_experience_widgets_toolbox_PropertiesView__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__editor_ui_experience_widgets_toolbox_PropertyContainerComponent__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zmags_zmags_ui_library__ = __webpack_require__(273);




var HtmlWidgetControls = function (_a) {
    var onChange = _a.onChange, htmlText = _a.htmlText;
    return (__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__editor_ui_experience_widgets_toolbox_PropertyContainerComponent__["a" /* PropertyContainerComponent */], { widgetSelected: true, label: "Html", name: "character", animateExpandOnMount: true },
            __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__editor_ui_experience_widgets_toolbox_PropertiesView__["c" /* PropertyRowComponent */], { name: "html", label: "HTML", tip: "Enter markup here", isColStretched: true },
                __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__zmags_zmags_ui_library__["TextArea"], { wrap: "off", style: { width: "100%" }, resize: false, contentChangeHandler: onChange, initialValue: htmlText })))));
};



/***/ }),
/* 2728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return moveContainerStyles; });
var moveContainerStyles = {
    position: "absolute",
    top: "-10px",
    right: "-10px",
    bottom: "-10px",
    left: "-10px",
    zIndex: -1,
    cursor: "move",
};



/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var GroupModel = __webpack_require__(104),
        Preconditions = __webpack_require__(14),
        RestApi = __webpack_require__(29),
        Syncer = __webpack_require__(50),
        SyncManager = __webpack_require__(44),
        Permissions = __webpack_require__(22),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        SystemMessages = __webpack_require__(107),
        PublishableMixin = __webpack_require__(793);


    var log = new Logger("GroupModel");

    return GroupModel.mixin("GroupModelEditorMixin", {

        mixin: PublishableMixin,

        relations: GroupModel.prototype.relations,

        transient: ["resolvedAssets"],

        constructor: function constructor(attributes, options) {
            this.__super();

            if (options && options.pushedOnly) {
                // To avoid ending up in the same SyncManager queue (when using multiple
                // instances of *this* group) create a unique id for this synced target.
                Syncer.State.init(this, {
                    unique: function () {
                        return ["pushed_only_" + this.id];
                    }.bind(this)
                });
            }
        },

        /**
         * A configuration which specify which fields of the model needs to be updated on model sync event.
         * This is called by the ImprovedModel. We should not call this method anywhere.
         *
         * @param {Object} options Passed in by the improvedModel
         * @returns {String[]}  An array of properties needs updating
         */
        // Update on sync, and PublishableMixin will ensure publish related attributes are updated...
        updateOnSync: function updateOnSync(options) {
            if (options.sync === "save") {
                return ["companyId"];
            }
        },

        /**
         * Attaches the specified asset and it's reference.
         *
         * @param {*} asset The asset, e.g. <tt>ExperienceModel</tt>.
         * @param {*} value The (optional) value associated with the asset in this group.
         *
         * @return {*|Promise}
         */
        attach: function attach(asset, value) {
            Preconditions.instanceOf(asset, this._assetClass);

            if (value) {
                Preconditions.instanceOf(value, this._valueClass);
            }

            this.get("entries").attach(asset, value, this._valueType);

            return this.save();
        },

        /**
         * Removes the entry (or entries) by the specified asset and/or value.<p>
         *
         * If no value is specified, all the entries represented by the asset are removed.
         *
         * @param  {ImprovedModel} asset The asset.
         * @param  {*}             value The optional value.
         *
         * @return {Promise}       A promise representing the save operation.
         */
        detach: function detach(asset, value) {
            Preconditions.instanceOf(asset, this._assetClass);

            this.get("entries").detach(asset, value);

            return this.save();
        },

        destroyWithAssets: function destroyWithAssets() {
            return this.destroy({ url: this.url() + "/assets" });
        },

        fetchPushedOnly: function fetchPushedOnly() {
            var url = this.url();
            if (url) {
                return this.fetch({ url: url + "/pushed" });
            }

            return Promise.resolve(false);
        },

        /**
         * Pushes this group model, optionally including all its assets (e.g. Experiences) with non-pushed
         * changes. <p>
         *
         * If <tt>withAssets</tt> is true, all updated assets (Experiences) already cached on the frontend
         * will be manually updated based on the returned json.
         *
         * @param {Boolean} [withAssets] True to push this group and its assets with non pushed changes,
         *                               false to only push this group it self (default).
         * @return {Promise} A promise that resolves once the push has completed; never falsey.
         */
        push: function push(withAssets) {
            // Create sync options...
            var options = {
                immutable: true,
                method: withAssets ? "push-with-assets" : "push", // different name, different semantics

                // Make sure we only push non-erroneous, non-destroyed experiences...
                validate: function validate() {
                    // Invoked with this model (target) as scope
                    var error = null;

                    if (this._destroyed) {
                        error = "destroyed";
                    } else if (this.syncState.actual.state === Syncer.State.Failed) {
                        error = "unsaved";
                    }

                    if (error) {
                        return "Cannot push " + error + " group";
                    }
                    // no error
                },
                // Make sure user can publish!
                privilege: Permissions.Privileges.PUBLISH,
                promise: true
            };

            // Assets need special handling...
            if (withAssets) {
                return this._pushWithAssets(options);
            }

            // Group only...
            return this._execute(options, {
                url: RestApi.pathToCollectionOnResource(RestApi.Collections.GROUPS, this.get("id"), "push"),
                type: "PUT"
            }).promise;
        },

        _pushWithAssets: function _pushWithAssets(options) {
            // If we are pushing with assets, we get an array back of all pushed assets, including the group it self
            // if pushed, and not just the group itself. If we are just pushing the group, we only get the group
            // back, always even if not pushed. In either case, the model group model will already have been updated
            // accordingly (via syncer) when our result handler is called, so we only need to handle the additional
            // assets (for now Experiences) returned as well.
            //
            // Since we only submit the group alone, we have to block all its assets (Experiences) at the frontend
            // while the push is pending, and we cannot start the push with assets while the assets have pending
            // sync requests or we can get concurrent modification errors. This way, concurrent sync requests for an
            // asset will be queued until we have our response which may include auxiliary assets to update. Each
            // asset is stored as a reference, and we only need to block if we have globally cached version of the
            // asset (only Experiences for now)...

            var updatedAssets = {},
                // since invoked on group result for different queue, we need to keep a reference to it...
            groupUpdated = 0,
                assetsUpdated = 0,
                experiences = [],
                maxPurgeTime = null,
                wait;

            // For now, we assume all assets are experiences, but this may have to change in the future...
            this.getAssets().forEach(function (experience) {
                experiences.push(experience);
            });

            // "done" hook to update the maximum purge time for any Group/Experience (asset)...
            var purgeTime = function purgeTime(model) {
                maxPurgeTime = model.getPurgeTime(maxPurgeTime);
            };

            // Do we need to block at least one?
            if (experiences.length) {
                // Invariant: called before a "sync:state:synced" is raised for the group and before the "unblock"
                // function is called...
                options.resultHandler = function (assets) {
                    // (empty) array of json data
                    var asset,
                        n = assets.length,
                        i;

                    for (i = 0; i < n; i++) {
                        asset = assets[i];
                        updatedAssets[asset.id] = asset; // json
                    }
                    groupUpdated = updatedAssets[this.id] ? 1 : 0; // this Group
                    assetsUpdated = groupUpdated ? n - 1 : n;

                    // A sync result handler is always scoped for its target, here Group, so make sure we return our
                    // Group to get the purge time...
                    return this;
                };

                // Block the target queue for this group while there are pending sync requests for each Experience
                // used as an asset, then do the push with asset for the group, and only then unblock the experiences.
                // The actual push with asset for this group is enqueued below, and only after that do we call the
                // "wait function" to start the overall waiting/flow...
                wait = SyncManager.await(this, experiences, {
                    method: options.method,
                    fn: function fn() {
                        // "this" is the current experience, so we can easily update it now via a nested sync
                        // request if it was updated. If the push with asset did not return the specific experience
                        // as an asset, it was not updated because of the push and we simply do nothing...
                        var json = updatedAssets[this.get("id")];

                        if (json) {
                            log.info("Updating Experience pushed as asset:", this, json);

                            // Note: "options" will have been updated at call time to reflect the actual sync options
                            // used (copied, not reused as is)! Also, the update is a nested sync request, so it will
                            // be allowed to execute immediately...
                            this.update(json, options).done(purgeTime);
                        } else {
                            log.info("Experience not updated as asset:", this);
                        }
                    }
                });
            }

            // Enqueue request to do the push with assets of this group...
            var request = this._execute(options, {
                url: RestApi.pathToCollectionOnResource(RestApi.Collections.GROUPS, this.get("id"), "assets/push"),
                type: "PUT"
            });

            // Remember that the group it self will also have a purge time...
            request.promise = request.promise.done(purgeTime);

            // Make sure we use the (defaulted) options when updating assets, e.g. with proper "sync" property...
            options = request.options;

            // Since target queue for this group is now primed with the actual push with asset request - after the block
            // request added via "SyncManager.await" above - we are ready to start the overall waiting logic...
            var promise = wait ? wait() : request.promise;

            // "promise" is now the promise that will resolve once this overall push-with-asset operation resolves,
            // either only for the group itself (i.e. no assets), but most like after the group has been updated *and*
            // all auxiliary assets as well. That means that on done we are ready to notify the user about the purge
            // time!...
            return promise.done(function () {
                if (maxPurgeTime !== null) {
                    var text = groupUpdated ? "Group" : "";
                    if (assetsUpdated) {
                        if (groupUpdated) {
                            text += " and ";
                        }
                        if (assetsUpdated > 1) {
                            text += assetsUpdated + " Experiences";
                        } else {
                            text += "Experience";
                        }
                    }
                    SystemMessages.notifyPurge(text, "pushed", maxPurgeTime, false);
                }
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var SceneNavigatorWidgetModel = __webpack_require__(512);

    /**
     * @class {SceneNavigatorWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return SceneNavigatorWidgetModel.mixin("SceneNavigatorWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return "Scene Selector";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ButtonWidgetModel = __webpack_require__(305);

    /**
     * @class {ButtonWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return ButtonWidgetModel.mixin("ButtonWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return this.get("label") ? "Button: " + this.get("label") : null;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EmbedWidgetModel = __webpack_require__(505);

    /**
     * @class {EmbedWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return EmbedWidgetModel.mixin("EmbedWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return this.get("url") ? "Embed: " + this.get("url") : null;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImageWidgetModel = __webpack_require__(249);
    var Size = __webpack_require__(84);
    var NavigationWidgetTargets = __webpack_require__(855).default;

    /**
     * @class {ImageWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return ImageWidgetModel.mixin("ImageWidgetModelEditorMixin", {
        // A list of properties that are not meant to be persisted;
        transient: ["selectedWidgetId", "cropEnabled", "isDragAvailable", "isCurrentWidgetCroppingUnavailable",
        // I believe the above options has pretty much been eliminated.
        "canCrop", "isCroppable"],

        /**
         * 1) Resize (both grow or shrink) the image to fit it inside an experience,
         * 2) reset the rotation of the image,
         * 3) move the image back inside the scene boundaries, if needed
         *
         * This method is called when clicking the 'fit to scene' button.
         * @param {ExperienceModel} experience The experience the images is to be fitted in to.
         */
        fitToScene: function fitToScene(experience) {
            var percentageSize = this._getOriginalPercentageSize(experience);

            if (percentageSize === null) {
                return;
            }

            this._setSize(this._getFittedSize(percentageSize), experience);
            this._resetRotation();
            this._setFittedWidgetPosition();
        },


        /**
         * Set the size of the image relative to the size of the scene. If the image is larger than
         * the experience it is shunk to fit. The method is called when a new image is dragged on
         * to the scene or an image is assigned to an empty image placeholder.
         *
         * @param {ExperienceModel} experience The experience the images is placed in.
         */
        initializeSizeOfImage: function initializeSizeOfImage(experience) {
            var percentageSize = this._getOriginalPercentageSize(experience);

            if (percentageSize === null) {
                return;
            }

            var imageIsLargerThanExperience = percentageSize.width > 100 || percentageSize.height > 100;

            if (imageIsLargerThanExperience) {
                this._setSize(this._getFittedSize(percentageSize), experience);
            } else {
                this._setSize(percentageSize, experience);
            }
        },
        setSizeOfImage: function setSizeOfImage(experience, width, height, imageWidth, imageHeight) {
            var size = new Size(width * imageWidth, height * imageHeight);

            if (size === null) {
                return;
            }
            this._setSize(size, experience);
        },


        /**
         * Set the position of the cropped image to the same as before crop.
         * This method prevents crop part of image jumping to the start of original image.
         * The method is called when a crop action has been applied to the image.
         *
         * @param {Crop} crop The crop object properties of the image.
         * @param {number} prevWidth The image width before crop
         * @param {number} prevHeight The image height before crop
         */
        setPositionOfCroppedImage: function setPositionOfCroppedImage(crop, prevWidth, prevHeight, imageSizes, experience, fullImageOffsetX, fullImageOffsetY) {
            var top = this.get("top");
            var left = this.get("left");
            // Calculate new position
            // of the cropped image piece
            var cropLeft = void 0;
            var cropTop = void 0;
            if (imageSizes) {
                // Recalculate cropped image position in canvas
                var fullImagePercentWidth = imageSizes.width / 100; // Percent image width size in pixels
                var fullImagePercentHeight = imageSizes.height / 100; // Percent image height size in pixels
                var imageOffsetXSceneRelative = fullImageOffsetX / (experience.get("width") / 100); // Image X offset relative relative to scene
                var imageOffsetYSceneRelative = fullImageOffsetY / (experience.get("height") / 100); // Image Y offset relative relative to scene
                // Calculate cropped image position
                var croppedAreaOffsetXSceneRelative = fullImagePercentWidth * crop.x * 100 / (experience.get("width") / 100);
                var croppedAreaOffsetYSceneRelative = fullImagePercentHeight * crop.y * 100 / (experience.get("height") / 100);
                // Set positions
                cropLeft = imageOffsetXSceneRelative + croppedAreaOffsetXSceneRelative;
                cropTop = imageOffsetYSceneRelative + croppedAreaOffsetYSceneRelative;
            } else {
                cropLeft = left + prevWidth * crop.x;
                cropTop = top + prevHeight * crop.y;
            }
            this.set("left", cropLeft);
            this.set("top", cropTop);
        },
        _scaleImage: function _scaleImage() {
            var maxWidth = this.get("unscaledWidgetWidth");
            var maxHeight = this.get("unscaledWidgetHeight");

            var originalImageWidth = this.get("originalImageWidth");
            var originalImageHeight = this.get("originalImageHeight");

            var scaledSize = this._calculateAspectRatioFit(originalImageWidth, originalImageHeight, maxWidth, maxHeight);
            return scaledSize;
        },
        _calculateAspectRatioFit: function _calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
            var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
            return { width: srcWidth * ratio, height: srcHeight * ratio };
        },


        /**
         * Returns the size of the ORIGINAL image source in percentages of the size of the experience.
         *
         * @param {ExperienceModel} experience The experience that the image is sized relative to.
         * @return {Size} The size of the image in percentages of the size of the scene.
         */
        _getOriginalPercentageSize: function _getOriginalPercentageSize(experience) {
            return experience.getPercentageSize(this._getOriginalImageSize());
        },


        /**
         * Returns the size of the image in percentages of the size of the experience.
         *
         * @param {ExperienceModel} experience The experience that the image is sized relative to.
         * @return {Size} The size of the image in percentages of the size of the scene.
         */
        _getPercentageSize: function _getPercentageSize(experience, width, height) {
            return experience.getPercentageSize(this._getImageSize(width, height));
        },


        /**
         * Returns the original size of the associated image.
         *
         * @return {Size} The original size of the associated image, potentially falling back
         *                on the widget size to be backwards compatible with older image widget, i.e. no
         *                <tt>originalImageWidth</tt> or <tt>originalImageHeight</tt> defined.
         */

        _getOriginalImageSize: function _getOriginalImageSize() {
            // Scales the widget down to a fixed size while also preserving the aspect ratio
            var isImageLargerThanWidget = this.get("originalImageWidth") > this.get("unscaledWidgetWidth") || this.get("originalImageHeight") > this.get("unscaledWidgetHeight");
            if (this.get("scaleOnInitialize") && isImageLargerThanWidget) {
                var scaledSize = this._scaleImage();
                return Size.from(scaledSize);
            }

            if (this.containsImageSize()) {
                return Size.from(this.get("originalImageWidth"), this.get("originalImageHeight"));
            }

            return Size.from(this.get("width"), this.get("height"));
        },
        _getImageSize: function _getImageSize(width, height) {
            return Size.from(width, height);
        },


        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            // First - to check if this is previous or next scene navigation arrow
            var isNavigationArrows = this.get("action") && this.get("action").get("type") === "sceneNavigation" && !this.get("src");
            if (isNavigationArrows) {
                // Previous/Next scene navigation
                var actionTarget = this.get("action").get("target");
                if (actionTarget === NavigationWidgetTargets.PREVIOUS_SCENE || actionTarget === NavigationWidgetTargets.NEXT_SCENE) {
                    return "" + this.get("action").get("target").charAt(0).toUpperCase() + this.get("action").get("target").slice(1) + " Scene";
                }
                return "Go To Scene " + this.get("action").get("target");
            }
            // Image
            return this.get("altText") && this.get("altText").length > 0 ? "Image: " + this.get("altText") : null;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImageWidgetModel = __webpack_require__(249);
    var ImageWidgetView = __webpack_require__(507);
    var ReactBridge = __webpack_require__(137);
    var ImageWidgetComponent = __webpack_require__(2735).default;
    var ImageWidgetSizeCalculations = __webpack_require__(2737);
    var Marionette = __webpack_require__(10);
    var ImageURLProvider = __webpack_require__(362);
    var LoggedInUserState = __webpack_require__(19);
    var ImageLibrarySourceEnum = __webpack_require__(102);
    var EditorEventFilters = __webpack_require__(154).default;
    var UUIDGenerator = __webpack_require__(250);
    var EditorActivityManager = __webpack_require__(197);

    /**
     * @class {ImageWidgetViewEditorMixin}
     *
     * The Image widget view Editor Mixin rendering an image widget.
     *
     * @cfg {ImageWidgetModel} model The model of the image widget being rendered.
     */
    var EnhancedImageWidgetLayout = Marionette.Layout.extend({

        template: function template() {
            return "<div class=\"image-widget-layout-container\"></div>";
        },

        regions: {
            "imageWidget": ".image-widget-layout-container"
        }
    });

    return ImageWidgetView.mixin("ImageWidgetViewEditorMixin", {

        targetTransformer: null,

        widgetSelectedListener: null,

        imageSizes: null,

        imageCoords: null,

        _reactImageComponent: null,

        // This gives us access to the proper this context
        getPropsFromView: function getPropsFromView(self) {
            return {
                onCropStart: function onCropStart() {
                    EditorActivityManager.setBatchActivityId(UUIDGenerator.createUUID());
                    self.setDragDisplay.call(self, false);
                },
                onCropEnd: function onCropEnd() {
                    self.setDragDisplay.call(self, true);
                    EditorActivityManager.setBatchActivityId(null);
                    // We may actually need to store a reference to the previously selected widgets. Not sure how we'll
                    // want to detect this just yet though.
                    self.targetTransformer.trigger("setSelectedWidgets", [self]);
                },
                onSave: function onSave(cropCoords) {
                    return self.onCropCoordsSave.call(self, cropCoords);
                }
            };
        },

        getSelectedWidgets: function getSelectedWidgets(widgets) {
            var isSingleSelection = widgets.length === 1;
            var isCroppable = false;
            if (isSingleSelection) {
                var selectedWidget = widgets[0].model;
                var isSceneNavigationWidget = selectedWidget.has("action") && selectedWidget.get("action").get("type") === "sceneNavigation";
                var selectedWidgetUUID = selectedWidget.get("uuid");
                var isSelected = this.model.get("uuid") === selectedWidgetUUID;

                isCroppable = isSelected && !isSceneNavigationWidget;
            }

            this.model.set("isCroppable", isCroppable, { cause: EditorEventFilters.SUPERFICIAL });
        },
        onShow: function onShow() {
            if (!this.widgetSelectedListener && this.parentView) {
                var targetView = this.parentView.options.parentCollectionView || this.parentView;
                this.targetTransformer = targetView.transformer;
                if (this.targetTransformer) {
                    this.widgetSelectedListener = this.listenTo(this.targetTransformer, "setSelectedWidgets", this.getSelectedWidgets);
                }
            }

            this.__super();
            // Creating container element to append image to it
            this._layout = new EnhancedImageWidgetLayout({ el: this.$el });
            this._layout.render();
            // Creating React Component
            var ImageWidgetReactComponent = ReactBridge.viewFromComponent(ImageWidgetComponent, {
                model: this.model,
                viewModel: this.viewModel,
                observe: {
                    model: "change"
                },
                props: this.getPropsFromView(this),
                getProps: function getProps(_ref) {
                    var model = _ref.model,
                        viewModel = _ref.viewModel;

                    var src = null;
                    // Check if crop enabled
                    if (model.get("src") && model.get("isDragAvailable") === false) {
                        src = ImageURLProvider.getOriginalImageUrl(model.get("src"), ImageLibrarySourceEnum.CREATOR);
                    } else {
                        src = ImageURLProvider.provide(model);
                    }

                    var imageCroppingEnabled = LoggedInUserState.get("companySettings").get("isImageCroppingEnabled");
                    // Calculate original image size according to scene (in percents)
                    var originalImageSceneRelativeSizes = ImageWidgetSizeCalculations.calculateOriginalImageSceneRelativeSize(model, viewModel.get("experience"));
                    var isDefaultImage = src === ImageWidgetModel.DEFAULT_IMAGE_URL;
                    var crop = model.get("crop");
                    return {
                        src: src,
                        originalImageSceneRelativeSizes: originalImageSceneRelativeSizes,
                        crop: crop,
                        canCrop: model.get("isCroppable") && imageCroppingEnabled && !isDefaultImage
                    };
                }
            });

            this._reactImageComponent = ImageWidgetReactComponent;
            // Appending React component to backbone view
            this._layout.imageWidget.show(ImageWidgetReactComponent);
        },
        setDragDisplay: function setDragDisplay(dragEnabled) {
            var display = dragEnabled ? "initial" : "none";
            var controlsContainerList = document.getElementsByClassName("controls-container");
            for (var i = 0; i < controlsContainerList.length; i++) {
                controlsContainerList[i].style.display = display;
            }
            this.model.set("isDragAvailable", dragEnabled);

            if (!dragEnabled && this.model.has("crop")) {
                this.viewModel.set("preventSelectionChange", true);
                this.imageSizes = ImageWidgetSizeCalculations.calculateOriginalImageSceneRelativeSize(this.model, this.viewModel.get("experience"));
                this.imageCoords = ImageWidgetSizeCalculations.calculateWidgetCoords(this.model, this.imageSizes.width, this.imageSizes.height);
                // Increase image widget size to initial image
                // But do not change image sizes in model
                this.el.style.width = this.imageSizes.width + "px";
                this.el.style.height = this.imageSizes.height + "px";
                this.el.style.top = "-" + this.imageCoords.y + "px";
                this.el.style.left = "-" + this.imageCoords.x + "px";
            } else {
                this.viewModel.set("preventSelectionChange", false);
                this.el.style.top = "initial";
                this.el.style.left = "initial";
            }
        },


        /* global WebKitCSSMatrix */
        onCropCoordsSave: function onCropCoordsSave(cropCoords) {
            var widthFixCropCoords = cropCoords;
            var prevCropCoords = this.model.get("crop");
            var imageWidth = this.model.get("width");
            var imageHeight = this.model.get("height");

            // Cloudinary width and height 1 fix
            // https://jira.zmags.com/browse/DEV-2211?focusedCommentId=67856&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-67856
            if (widthFixCropCoords.width >= 1) {
                widthFixCropCoords.width = Number(1).toFixed(1);
            }

            if (widthFixCropCoords.height >= 1) {
                widthFixCropCoords.height = Number(1).toFixed(1);
            }

            if (prevCropCoords) {
                var originalImageWidth = imageWidth / prevCropCoords.width;
                var originalImageHeight = imageHeight / prevCropCoords.height;
                // Crop of the already cropped image
                // Adapting crop coords of cropped piece to the original image, which is used to crop
                this.model.setSizeOfImage(this.options.viewModel.get("experience"), widthFixCropCoords.width, widthFixCropCoords.height, originalImageWidth, originalImageHeight);
                /* Get full image position on canvas */
                var fullImageOffsetX = new WebKitCSSMatrix(this.el.style.transform).m41 - this.imageCoords.x;
                var fullImageOffsetY = new WebKitCSSMatrix(this.el.style.transform).m42 - this.imageCoords.y;
                this.model.setPositionOfCroppedImage(widthFixCropCoords, null, null, this.imageSizes, this.options.viewModel.get("experience"), fullImageOffsetX, fullImageOffsetY);
            } else {
                // First image crop
                this.model.setSizeOfImage(this.options.viewModel.get("experience"), widthFixCropCoords.width, widthFixCropCoords.height, imageWidth, imageHeight);
                this.model.setPositionOfCroppedImage(widthFixCropCoords, imageWidth, imageHeight);
            }
            this.model.set("crop", widthFixCropCoords, imageWidth, imageHeight);
            this.viewModel.set("preventSelectionChange", false);
            this.el.style.top = "initial";
            this.el.style.left = "initial";
        },
        updateRendering: function updateRendering(element, bounds, active, edited, changedProperties) {
            if (edited && changedProperties && this._source === ImageWidgetModel.DEFAULT_IMAGE_URL) {
                if (changedProperties.imageUrl) {
                    this.model.initializeSizeOfImage(this.options.viewModel.get("experience"));
                    if (this.model.get("scaleOnInitialize")) {
                        this.model.set("left", this.model.get("scaledWidgetWidth") / 2 - this.model.get("scaledWidth") / 2);
                        this.model.set("top", this.model.get("scaledWidgetHeight") / 2 - this.model.get("scaledHeight") / 2);
                    }
                }
            }

            if (this.model.get("sourceType")) {
                this._imageServingUrl = this._getImageServingUrl();
            }

            var resource = this.model.get("imageUrl");
            var sizeChanged = changedProperties && (changedProperties.scaledWidth || changedProperties.scaledHeight);

            if (this._source !== resource || sizeChanged) {
                var provideOptions = { bounds: bounds };

                if (this.model.get("sourceType")) {
                    provideOptions.imageServingUrl = this._imageServingUrl;
                }
                // Update image url in model
                this.model.set("imageUrl", resource);
                // Create full link of the image
                this._currentUrl = ImageURLProvider.provide(this.model, provideOptions);
                this._source = this._currentUrl;
            }

            this.__super();
        },
        _renderOriginalImage: function _renderOriginalImage() {
            // Killing this method since we'll always want the imageUrl from the model when rendering.
        },


        /**
         * This method is extends and changes the highlight
         * of the widget astract method `_updateHightlight`
         */
        applyWidgetSpecificHighlight: function applyWidgetSpecificHighlight() {
            // Specific highlight only for navigation arrows
            if (this.model.get("action") && this.model.get("action").get("type") === "sceneNavigation" && !this.model.get("src")) {
                // Highlight widget if required
                if (this.model.get("highlighted")) {
                    this.$el.css({
                        background: "rgba(255,255,255,0.75)",
                        boxShadow: "inset 0px 0px 0px 3px #8c01ff"
                    });
                } else if (!this.model.get("boxShadow")) {
                    this.$el.css({
                        boxShadow: "inset 0px 0px 0px 0px transparent"
                    });
                }
            }
        },
        onClose: function onClose() {
            if (this._reactImageComponent) {
                this._reactImageComponent.close();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ImageWidgetComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageWidgetComponent", function() { return ImageWidgetComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_image_crop__ = __webpack_require__(2736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_image_crop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_image_crop__);



var LoadingIndicator = function () { return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "loader" }, "Loading...")); };
var ImageWidgetComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ImageWidgetComponent, _super);
    function ImageWidgetComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.reactCropRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        _this.calculateCropCoords = function () {
            var prevX = 0;
            var prevY = 0;
            var _a = _this.props, originalImageSceneRelativeSizes = _a.originalImageSceneRelativeSizes, crop = _a.crop;
            if (originalImageSceneRelativeSizes) {
                var onePercentOriginalImageWidth = (originalImageSceneRelativeSizes.width / 100);
                var onePercentOriginalImageHeight = (originalImageSceneRelativeSizes.height / 100);
                prevX = onePercentOriginalImageWidth * (crop.x * 100);
                prevY = onePercentOriginalImageHeight * (crop.y * 100);
            }
            return { prevX: prevX, prevY: prevY };
        };
        _this.handleCropStart = function () {
            var imageRef = _this.reactCropRef.current.imageRef;
            // Calculate select position of cropper
            var _a = _this.calculateCropCoords(), prevX = _a.prevX, prevY = _a.prevY;
            _this.setState({
                isCropping: true,
                cropState: {
                    x: prevX,
                    y: prevY,
                    width: imageRef.width,
                    height: imageRef.height,
                },
                image: {
                    width: imageRef.width,
                    height: imageRef.height
                }
            });
            _this.props.onCropStart();
        };
        _this.handleCropStop = function () {
            var onCropEnd = _this.props.onCropEnd;
            _this.setState({ isCropping: false });
            onCropEnd();
        };
        _this.handleChange = function (cropState) {
            // Sometimes the *react-image-crop* returns
            // an exponential value instead a decimal
            // ex: 5.684341886080802e-14
            // Will prevent errors, by converting them
            // to correct decimal values
            var x = cropState.x, y = cropState.y, width = cropState.width, height = cropState.height;
            _this.setState({
                cropState: {
                    x: parseFloat(x.toFixed(3)),
                    y: parseFloat(y.toFixed(3)),
                    height: parseFloat(height.toFixed(3)),
                    width: parseFloat(width.toFixed(3)),
                }
            });
        };
        _this.handleSave = function () {
            var _a = _this.props, onSave = _a.onSave, canCrop = _a.canCrop, crop = _a.crop;
            // Double checking to make sure we're allowed to crop and in turn save.
            if (canCrop) {
                var _b = _this.state, image = _b.image, cropState = _b.cropState;
                var imageRef = _this.reactCropRef.current.imageRef;
                var x = cropState.x, y = cropState.y, width = cropState.width, height = cropState.height;
                var percentageCrop = {
                    x: x / imageRef.width,
                    y: y / imageRef.height,
                    width: width / (crop ? imageRef.width : image.width),
                    height: height / (crop ? imageRef.height : image.height)
                };
                var hasChanges = percentageCrop.x >= 0 || percentageCrop.y >= 0 ||
                    percentageCrop.width <= 1 || percentageCrop.height <= 1;
                var isValid = width !== 0 || height !== 0;
                if (hasChanges && isValid) {
                    onSave(percentageCrop);
                    _this.setState({ isLoading: true });
                }
            }
            _this.handleCropStop();
        };
        _this.onImageLoaded = function () {
            _this.setState({ isLoading: false });
        };
        _this.onKeyPress = function (event) {
            if (event.keyCode === 27) {
                // Handle esc key
                _this.handleCropStop();
            }
            else if (event.keyCode === 13) {
                // Handle enter key
                _this.handleSave();
            }
        };
        _this.renderImage = function () {
            var _a = _this.props, src = _a.src, canCrop = _a.canCrop;
            var _b = _this.state, cropState = _b.cropState, isCropping = _b.isCropping, isLoading = _b.isLoading;
            // Feeding an invalid value for crop when we're not cropping.
            var targetCrop = isCropping ? cropState : {};
            var style = !isCropping ? { cursor: "inherit" } : {};
            style.display = isLoading ? "none" : "";
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                isLoading && __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LoadingIndicator, null),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_image_crop___default.a, { ref: _this.reactCropRef, src: src, disabled: !canCrop, locked: !canCrop, 
                    // On change is required as we must track the cropping state.
                    onChange: _this.handleChange, crop: targetCrop, onImageLoaded: _this.onImageLoaded, style: style })));
        };
        _this.renderCropIcons = function () {
            var canCrop = _this.props.canCrop;
            var _a = _this.state, isCropping = _a.isCropping, isLoading = _a.isLoading;
            if (canCrop && !isLoading) {
                if (isCropping) {
                    return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"], null,
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("i", { className: "image-crop image-save-crop glyphicon glyphicon-ok", onClick: _this.handleSave }),
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("i", { className: "image-crop image-disable-crop glyphicon glyphicon-remove", onClick: _this.handleCropStop })));
                }
                return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "image-crop-button", onClick: _this.handleCropStart });
            }
        };
        _this.state = {
            cropState: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            },
            isCropping: false,
            isLoading: true,
        };
        _this.reactCropRef = __WEBPACK_IMPORTED_MODULE_1_react__["createRef"]();
        return _this;
    }
    ImageWidgetComponent.prototype.render = function () {
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "image-widget-component-container", onKeyDown: this.onKeyPress },
            this.renderImage(),
            this.renderCropIcons()));
    };
    return ImageWidgetComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["ReactCrop"] = factory(require("react"));
	else
		root["ReactCrop"] = factory(root["React"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.containCrop = exports.makeAspectCrop = exports.Component = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* globals document, window */


var _react = __webpack_require__(3);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(4);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Feature detection
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Improving_scrolling_performance_with_passive_listeners
var passiveSupported = false;

try {
  window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveSupported = true;return true;
    }
  }));
} catch (err) {} // eslint-disable-line no-empty

var EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

function getClientPos(e) {
  var pageX = void 0;
  var pageY = void 0;

  if (e.touches) {
    var _e$touches = _slicedToArray(e.touches, 1);

    var _e$touches$ = _e$touches[0];
    pageX = _e$touches$.pageX;
    pageY = _e$touches$.pageY;
  } else {
    pageX = e.pageX;
    pageY = e.pageY;
  }

  return {
    x: pageX,
    y: pageY
  };
}

function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

function isCropValid(crop) {
  return crop && crop.width && crop.height && !isNaN(crop.width) && !isNaN(crop.height);
}

function inverseOrd(ord) {
  var inversedOrd = void 0;

  if (ord === 'n') inversedOrd = 's';else if (ord === 'ne') inversedOrd = 'sw';else if (ord === 'e') inversedOrd = 'w';else if (ord === 'se') inversedOrd = 'nw';else if (ord === 's') inversedOrd = 'n';else if (ord === 'sw') inversedOrd = 'ne';else if (ord === 'w') inversedOrd = 'e';else if (ord === 'nw') inversedOrd = 'se';

  return inversedOrd;
}

function makeAspectCrop(crop, image) {
  if (isNaN(crop.aspect)) {
    console.warn('`crop.aspect` should be a number in order to make an aspect crop', crop);
    return crop;
  }

  var completeCrop = _extends({
    x: 0,
    y: 0
  }, crop);

  if (crop.width) {
    completeCrop.height = completeCrop.width / crop.aspect;
  }
  if (crop.height) {
    completeCrop.width = completeCrop.height * crop.aspect;
  }

  if (completeCrop.y + completeCrop.height > image.height) {
    completeCrop.height = image.height - completeCrop.y;
    completeCrop.width = completeCrop.height * crop.aspect;
  }

  if (completeCrop.x + completeCrop.width > image.width) {
    completeCrop.width = image.width - completeCrop.x;
    completeCrop.height = completeCrop.width / crop.aspect;
  }

  return completeCrop;
}

function isAspectInvalid(crop, image) {
  if (!crop.width && crop.height || crop.width && !crop.height) {
    return true;
  }

  return crop.width / crop.aspect !== crop.height || crop.height * crop.aspect !== crop.width || crop.y + crop.height > image.height || crop.x + crop.width > image.width;
}

function resolveCrop(crop, image) {
  if (crop && crop.aspect && isAspectInvalid(crop, image)) {
    return makeAspectCrop(crop, image);
  }

  return crop;
}

function containCrop(prevCrop, crop, image) {
  var contained = _extends({}, crop);

  // Non-aspects are simple
  if (!crop.aspect) {
    if (crop.x < 0) {
      contained.x = 0;
      contained.width += crop.x;
    } else if (crop.x + crop.width > image.width) {
      contained.width = image.width - crop.x;
    }

    if (crop.y + crop.height > image.height) {
      contained.height = image.height - crop.y;
    }

    return contained;
  }

  var widthAdjusted = false;

  if (crop.x < 0) {
    contained.x = 0;
    contained.width += crop.x;
    contained.height = contained.width / crop.aspect;
    widthAdjusted = true;
  } else if (crop.x + crop.width > image.width) {
    contained.width = image.width - crop.x;
    contained.height = contained.width / crop.aspect;
    widthAdjusted = true;
  }

  // If sizing in up direction we need to pin Y at the point it
  // would be at the boundary.
  if (widthAdjusted && prevCrop.y > contained.y) {
    contained.y = crop.y + (crop.height - contained.height);
  }

  var heightAdjusted = false;

  if (contained.y + contained.height > image.height) {
    contained.height = image.height - contained.y;
    contained.width = contained.height * contained.aspect;
    heightAdjusted = true;
  }

  // If sizing in left direction we need to pin X at the point it
  // would be at the boundary.
  if (heightAdjusted && prevCrop.x > contained.x) {
    contained.x = crop.x + (crop.width - contained.width);
  }

  return contained;
}

var ReactCrop = function (_PureComponent) {
  _inherits(ReactCrop, _PureComponent);

  function ReactCrop() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactCrop);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactCrop.__proto__ || Object.getPrototypeOf(ReactCrop)).call.apply(_ref, [this].concat(args))), _this), _this.window = window, _this.document = document, _this.state = {}, _this.onCropMouseTouchDown = function (e) {
      var _this$props = _this.props,
          crop = _this$props.crop,
          disabled = _this$props.disabled;


      if (disabled) {
        return;
      }

      e.preventDefault(); // Stop drag selection.

      var clientPos = getClientPos(e);

      // Focus for detecting keypress.
      _this.componentRef.focus({ preventScroll: true });

      var ord = e.target.dataset.ord;

      var xInversed = ord === 'nw' || ord === 'w' || ord === 'sw';
      var yInversed = ord === 'nw' || ord === 'n' || ord === 'ne';

      var cropOffset = void 0;

      if (crop.aspect) {
        cropOffset = _this.getElementOffset(_this.cropSelectRef);
      }

      _this.evData = {
        clientStartX: clientPos.x,
        clientStartY: clientPos.y,
        cropStartWidth: crop.width,
        cropStartHeight: crop.height,
        cropStartX: xInversed ? crop.x + crop.width : crop.x,
        cropStartY: yInversed ? crop.y + crop.height : crop.y,
        xInversed: xInversed,
        yInversed: yInversed,
        xCrossOver: xInversed,
        yCrossOver: yInversed,
        startXCrossOver: xInversed,
        startYCrossOver: yInversed,
        isResize: e.target.dataset.ord,
        ord: ord,
        cropOffset: cropOffset
      };

      _this.mouseDownOnCrop = true;
      _this.setState({ cropIsActive: true });
    }, _this.onComponentMouseTouchDown = function (e) {
      var _this$props2 = _this.props,
          crop = _this$props2.crop,
          disabled = _this$props2.disabled,
          locked = _this$props2.locked,
          keepSelection = _this$props2.keepSelection,
          onChange = _this$props2.onChange;


      if (e.target !== _this.imageRef) {
        return;
      }

      if (disabled || locked || keepSelection && isCropValid(crop)) {
        return;
      }

      e.preventDefault(); // Stop drag selection.

      var clientPos = getClientPos(e);

      // Focus for detecting keypress.
      _this.componentRef.focus({ preventScroll: true });

      var imageOffset = _this.getElementOffset(_this.imageRef);
      var x = clientPos.x - imageOffset.left;
      var y = clientPos.y - imageOffset.top;

      var nextCrop = {
        aspect: crop ? crop.aspect : undefined,
        x: x,
        y: y,
        width: 0,
        height: 0
      };

      _this.evData = {
        clientStartX: clientPos.x,
        clientStartY: clientPos.y,
        cropStartWidth: nextCrop.width,
        cropStartHeight: nextCrop.height,
        cropStartX: nextCrop.x,
        cropStartY: nextCrop.y,
        xInversed: false,
        yInversed: false,
        xCrossOver: false,
        yCrossOver: false,
        startXCrossOver: false,
        startYCrossOver: false,
        isResize: true,
        ord: 'nw'
      };

      _this.mouseDownOnCrop = true;
      onChange(nextCrop);
      _this.setState({ cropIsActive: true });
    }, _this.onDocMouseTouchMove = function (e) {
      var _this$props3 = _this.props,
          crop = _this$props3.crop,
          disabled = _this$props3.disabled,
          onChange = _this$props3.onChange,
          onDragStart = _this$props3.onDragStart;


      if (disabled) {
        return;
      }

      if (!_this.mouseDownOnCrop) {
        return;
      }

      e.preventDefault(); // Stop drag selection.

      if (!_this.dragStarted) {
        _this.dragStarted = true;
        onDragStart(e);
      }

      var _this2 = _this,
          evData = _this2.evData;

      var clientPos = getClientPos(e);

      if (evData.isResize && crop.aspect && evData.cropOffset) {
        clientPos.y = _this.straightenYPath(clientPos.x);
      }

      evData.xDiff = clientPos.x - evData.clientStartX;
      evData.yDiff = clientPos.y - evData.clientStartY;

      var nextCrop = void 0;

      if (evData.isResize) {
        nextCrop = _this.resizeCrop();
      } else {
        nextCrop = _this.dragCrop();
      }

      if (nextCrop !== crop) {
        onChange(nextCrop);
      }
    }, _this.onComponentKeyDown = function (e) {
      var _this$props4 = _this.props,
          crop = _this$props4.crop,
          disabled = _this$props4.disabled,
          onChange = _this$props4.onChange,
          onComplete = _this$props4.onComplete;


      if (disabled) {
        return;
      }

      var keyCode = e.which;
      var nudged = false;

      if (!isCropValid(crop)) {
        return;
      }

      var nextCrop = _this.makeNewCrop();

      if (keyCode === ReactCrop.arrowKey.left) {
        nextCrop.x -= ReactCrop.nudgeStep;
        nudged = true;
      } else if (keyCode === ReactCrop.arrowKey.right) {
        nextCrop.x += ReactCrop.nudgeStep;
        nudged = true;
      } else if (keyCode === ReactCrop.arrowKey.up) {
        nextCrop.y -= ReactCrop.nudgeStep;
        nudged = true;
      } else if (keyCode === ReactCrop.arrowKey.down) {
        nextCrop.y += ReactCrop.nudgeStep;
        nudged = true;
      }

      if (nudged) {
        e.preventDefault(); // Stop drag selection.
        nextCrop.x = clamp(nextCrop.x, 0, _this.imageRef.width - nextCrop.width);
        nextCrop.y = clamp(nextCrop.y, 0, _this.imageRef.height - nextCrop.height);

        onChange(nextCrop);
        onComplete(nextCrop);
      }
    }, _this.onDocMouseTouchEnd = function (e) {
      var _this$props5 = _this.props,
          crop = _this$props5.crop,
          disabled = _this$props5.disabled,
          onComplete = _this$props5.onComplete,
          onDragEnd = _this$props5.onDragEnd;


      if (disabled) {
        return;
      }

      if (_this.mouseDownOnCrop) {
        _this.mouseDownOnCrop = false;
        _this.dragStarted = false;
        onDragEnd(e);
        onComplete(crop);
        _this.setState({ cropIsActive: false });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactCrop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = passiveSupported ? { passive: false } : false;

      this.document.addEventListener('mousemove', this.onDocMouseTouchMove, options);
      this.document.addEventListener('touchmove', this.onDocMouseTouchMove, options);

      this.document.addEventListener('mouseup', this.onDocMouseTouchEnd, options);
      this.document.addEventListener('touchend', this.onDocMouseTouchEnd, options);
      this.document.addEventListener('touchcancel', this.onDocMouseTouchEnd, options);

      if (this.imageRef.complete || this.imageRef.readyState) {
        if (this.imageRef.naturalWidth === 0) {
          // Broken load on iOS, PR #51
          // https://css-tricks.com/snippets/jquery/fixing-load-in-ie-for-cached-images/
          // http://stackoverflow.com/questions/821516/browser-independent-way-to-detect-when-image-has-been-loaded
          var src = this.imageRef.src;

          this.imageRef.src = EMPTY_GIF;
          this.imageRef.src = src;
        } else {
          this.onImageLoad(this.imageRef);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.document.removeEventListener('mousemove', this.onDocMouseTouchMove);
      this.document.removeEventListener('touchmove', this.onDocMouseTouchMove);

      this.document.removeEventListener('mouseup', this.onDocMouseTouchEnd);
      this.document.removeEventListener('touchend', this.onDocMouseTouchEnd);
      this.document.removeEventListener('touchcancel', this.onDocMouseTouchEnd);
    }
  }, {
    key: 'onImageLoad',
    value: function onImageLoad(image) {
      var _props = this.props,
          crop = _props.crop,
          onComplete = _props.onComplete,
          onChange = _props.onChange,
          onImageLoaded = _props.onImageLoaded;


      var resolvedCrop = resolveCrop(crop, image);

      // Return false from onImageLoaded if you set the crop with setState in there as otherwise the subsequent
      // onChange + onComplete will not have your updated crop.
      var res = onImageLoaded(image);

      if (res !== false && resolvedCrop !== crop) {
        onChange(resolvedCrop);
        onComplete(resolvedCrop);
      }
    }
  }, {
    key: 'getElementOffset',
    value: function getElementOffset(el) {
      var rect = el.getBoundingClientRect();
      var docEl = this.document.documentElement;

      var rectTop = rect.top + this.window.pageYOffset - docEl.clientTop;
      var rectLeft = rect.left + this.window.pageXOffset - docEl.clientLeft;

      return {
        top: rectTop,
        left: rectLeft
      };
    }
  }, {
    key: 'getCropStyle',
    value: function getCropStyle() {
      var crop = this.props.crop;

      return {
        top: crop.y + 'px',
        left: crop.x + 'px',
        width: crop.width + 'px',
        height: crop.height + 'px'
      };
    }
  }, {
    key: 'getNewSize',
    value: function getNewSize() {
      var _props2 = this.props,
          crop = _props2.crop,
          minWidth = _props2.minWidth,
          maxWidth = _props2.maxWidth,
          minHeight = _props2.minHeight,
          maxHeight = _props2.maxHeight;
      var evData = this.evData,
          imageRef = this.imageRef;

      // New width.

      var newWidth = evData.cropStartWidth + evData.xDiff;

      if (evData.xCrossOver) {
        newWidth = Math.abs(newWidth);
      }

      newWidth = clamp(newWidth, minWidth, maxWidth || imageRef.width);

      // New height.
      var newHeight = void 0;

      if (crop.aspect) {
        newHeight = newWidth / crop.aspect;
      } else {
        newHeight = evData.cropStartHeight + evData.yDiff;
      }

      if (evData.yCrossOver) {
        // Cap if polarity is inversed and the height fills the y space.
        newHeight = Math.min(Math.abs(newHeight), evData.cropStartY);
      }

      newHeight = clamp(newHeight, minHeight, maxHeight || imageRef.height);

      if (crop.aspect) {
        newWidth = clamp(newHeight * crop.aspect, 0, this.imageRef.width);
      }

      return {
        width: newWidth,
        height: newHeight
      };
    }
  }, {
    key: 'dragCrop',
    value: function dragCrop() {
      var nextCrop = this.makeNewCrop();
      var evData = this.evData;

      nextCrop.x = clamp(evData.cropStartX + evData.xDiff, 0, this.imageRef.width - nextCrop.width);
      nextCrop.y = clamp(evData.cropStartY + evData.yDiff, 0, this.imageRef.height - nextCrop.height);
      return nextCrop;
    }
  }, {
    key: 'resizeCrop',
    value: function resizeCrop() {
      var nextCrop = this.makeNewCrop();
      var evData = this.evData;
      var _props3 = this.props,
          crop = _props3.crop,
          minWidth = _props3.minWidth,
          minHeight = _props3.minHeight;
      var ord = evData.ord;

      // On the inverse change the diff so it's the same and
      // the same algo applies.

      if (evData.xInversed) {
        evData.xDiff -= evData.cropStartWidth * 2;
      }
      if (evData.yInversed) {
        evData.yDiff -= evData.cropStartHeight * 2;
      }

      // New size.
      var newSize = this.getNewSize();

      // Adjust x/y to give illusion of 'staticness' as width/height is increased
      // when polarity is inversed.
      var newX = evData.cropStartX;
      var newY = evData.cropStartY;

      if (evData.xCrossOver) {
        newX = nextCrop.x + (nextCrop.width - newSize.width);
      }

      if (evData.yCrossOver) {
        // This not only removes the little "shake" when inverting at a diagonal, but for some
        // reason y was way off at fast speeds moving sw->ne with fixed aspect only, I couldn't
        // figure out why.
        if (evData.lastYCrossover === false) {
          newY = nextCrop.y - newSize.height;
        } else {
          newY = nextCrop.y + (nextCrop.height - newSize.height);
        }
      }

      var containedCrop = containCrop(this.props.crop, {
        x: newX,
        y: newY,
        width: newSize.width,
        height: newSize.height,
        aspect: nextCrop.aspect
      }, this.imageRef);

      // Apply x/y/width/height changes depending on ordinate (fixed aspect always applies both).
      if (nextCrop.aspect || ReactCrop.xyOrds.indexOf(ord) > -1) {
        nextCrop.x = containedCrop.x;
        nextCrop.y = containedCrop.y;
        nextCrop.width = containedCrop.width;
        nextCrop.height = containedCrop.height;
      } else if (ReactCrop.xOrds.indexOf(ord) > -1) {
        nextCrop.x = containedCrop.x;
        nextCrop.width = containedCrop.width;
      } else if (ReactCrop.yOrds.indexOf(ord) > -1) {
        nextCrop.y = containedCrop.y;
        nextCrop.height = containedCrop.height;
      }

      evData.lastYCrossover = evData.yCrossOver;
      this.crossOverCheck();

      // Ensure new dimensions aren't less than min dimensions.
      if (minWidth && nextCrop.width < minWidth) {
        return crop;
      }

      if (minHeight && nextCrop.height < minHeight) {
        return crop;
      }

      return nextCrop;
    }
  }, {
    key: 'straightenYPath',
    value: function straightenYPath(clientX) {
      var evData = this.evData;
      var ord = evData.ord;
      var cropOffset = evData.cropOffset,
          cropStartWidth = evData.cropStartWidth,
          cropStartHeight = evData.cropStartHeight;

      var k = void 0;
      var d = void 0;

      if (ord === 'nw' || ord === 'se') {
        k = cropStartHeight / cropStartWidth;
        d = cropOffset.top - cropOffset.left * k;
      } else {
        k = -cropStartHeight / cropStartWidth;
        d = cropOffset.top + (cropStartHeight - cropOffset.left * k);
      }

      return k * clientX + d;
    }
  }, {
    key: 'createCropSelection',
    value: function createCropSelection() {
      var _this3 = this;

      var _props4 = this.props,
          disabled = _props4.disabled,
          locked = _props4.locked,
          renderSelectionAddon = _props4.renderSelectionAddon;

      var style = this.getCropStyle();

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(n) {
            _this3.cropSelectRef = n;
          },
          style: style,
          className: 'ReactCrop__crop-selection',
          onMouseDown: this.onCropMouseTouchDown,
          onTouchStart: this.onCropMouseTouchDown,
          role: 'presentation'
        },
        !disabled && !locked && _react2.default.createElement(
          'div',
          { className: 'ReactCrop__drag-elements' },
          _react2.default.createElement('div', { className: 'ReactCrop__drag-bar ord-n', 'data-ord': 'n' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-bar ord-e', 'data-ord': 'e' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-bar ord-s', 'data-ord': 's' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-bar ord-w', 'data-ord': 'w' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-nw', 'data-ord': 'nw' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-n', 'data-ord': 'n' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-ne', 'data-ord': 'ne' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-e', 'data-ord': 'e' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-se', 'data-ord': 'se' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-s', 'data-ord': 's' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-sw', 'data-ord': 'sw' }),
          _react2.default.createElement('div', { className: 'ReactCrop__drag-handle ord-w', 'data-ord': 'w' })
        ),
        renderSelectionAddon && renderSelectionAddon(this.state)
      );
    }
  }, {
    key: 'makeNewCrop',
    value: function makeNewCrop() {
      return _extends({}, ReactCrop.defaultCrop, this.props.crop);
    }
  }, {
    key: 'crossOverCheck',
    value: function crossOverCheck() {
      var evData = this.evData;


      if (!evData.xCrossOver && -Math.abs(evData.cropStartWidth) - evData.xDiff >= 0 || evData.xCrossOver && -Math.abs(evData.cropStartWidth) - evData.xDiff <= 0) {
        evData.xCrossOver = !evData.xCrossOver;
      }

      if (!evData.yCrossOver && -Math.abs(evData.cropStartHeight) - evData.yDiff >= 0 || evData.yCrossOver && -Math.abs(evData.cropStartHeight) - evData.yDiff <= 0) {
        evData.yCrossOver = !evData.yCrossOver;
      }

      var swapXOrd = evData.xCrossOver !== evData.startXCrossOver;
      var swapYOrd = evData.yCrossOver !== evData.startYCrossOver;

      evData.inversedXOrd = swapXOrd ? inverseOrd(evData.ord) : false;
      evData.inversedYOrd = swapYOrd ? inverseOrd(evData.ord) : false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props5 = this.props,
          children = _props5.children,
          className = _props5.className,
          crossorigin = _props5.crossorigin,
          crop = _props5.crop,
          disabled = _props5.disabled,
          locked = _props5.locked,
          imageAlt = _props5.imageAlt,
          onImageError = _props5.onImageError,
          src = _props5.src,
          style = _props5.style,
          imageStyle = _props5.imageStyle;
      var cropIsActive = this.state.cropIsActive;

      var cropSelection = void 0;

      if (isCropValid(crop)) {
        cropSelection = this.createCropSelection();
      }

      var componentClasses = ['ReactCrop'];

      if (cropIsActive) {
        componentClasses.push('ReactCrop--active');
      }

      if (crop) {
        if (crop.aspect) {
          componentClasses.push('ReactCrop--fixed-aspect');
        }

        // In this case we have to shadow the image, since the box-shadow
        // on the crop won't work.
        if (cropIsActive && (!crop.width || !crop.height)) {
          componentClasses.push('ReactCrop--crop-invisible');
        }
      }

      if (disabled) {
        componentClasses.push('ReactCrop--disabled');
      }

      if (locked) {
        componentClasses.push('ReactCrop--locked');
      }

      if (className) {
        componentClasses.push.apply(componentClasses, _toConsumableArray(className.split(' ')));
      }

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(n) {
            _this4.componentRef = n;
          },
          className: componentClasses.join(' '),
          style: style,
          onTouchStart: this.onComponentMouseTouchDown,
          onMouseDown: this.onComponentMouseTouchDown,
          role: 'presentation',
          tabIndex: 1,
          onKeyDown: this.onComponentKeyDown
        },
        _react2.default.createElement('img', {
          ref: function ref(n) {
            _this4.imageRef = n;
          },
          crossOrigin: crossorigin,
          className: 'ReactCrop__image',
          style: imageStyle,
          src: src,
          onLoad: function onLoad(e) {
            return _this4.onImageLoad(e.target);
          },
          onError: onImageError,
          alt: imageAlt
        }),
        children,
        cropSelection
      );
    }
  }]);

  return ReactCrop;
}(_react.PureComponent);

ReactCrop.xOrds = ['e', 'w'];
ReactCrop.yOrds = ['n', 's'];
ReactCrop.xyOrds = ['nw', 'ne', 'se', 'sw'];

ReactCrop.arrowKey = {
  left: 37,
  up: 38,
  right: 39,
  down: 40
};

ReactCrop.nudgeStep = 0.2;

ReactCrop.defaultCrop = {
  x: 0,
  y: 0,
  width: 0,
  height: 0
};

ReactCrop.propTypes = {
  className: _propTypes2.default.string,
  crossorigin: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  crop: _propTypes2.default.shape({
    aspect: _propTypes2.default.number,
    x: _propTypes2.default.number,
    y: _propTypes2.default.number,
    width: _propTypes2.default.number,
    height: _propTypes2.default.number
  }),
  disabled: _propTypes2.default.bool,
  locked: _propTypes2.default.bool,
  imageAlt: _propTypes2.default.string,
  imageStyle: _propTypes2.default.shape({}),
  keepSelection: _propTypes2.default.bool,
  minWidth: _propTypes2.default.number,
  minHeight: _propTypes2.default.number,
  maxWidth: _propTypes2.default.number,
  maxHeight: _propTypes2.default.number,
  onChange: _propTypes2.default.func.isRequired,
  onImageError: _propTypes2.default.func,
  onComplete: _propTypes2.default.func,
  onImageLoaded: _propTypes2.default.func,
  onDragStart: _propTypes2.default.func,
  onDragEnd: _propTypes2.default.func,
  src: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.shape({}),
  renderSelectionAddon: _propTypes2.default.func
};

ReactCrop.defaultProps = {
  className: undefined,
  crop: undefined,
  crossorigin: undefined,
  disabled: false,
  locked: false,
  imageAlt: '',
  maxWidth: undefined,
  maxHeight: undefined,
  minWidth: 0,
  minHeight: 0,
  keepSelection: false,
  onComplete: function onComplete() {},
  onImageError: function onImageError() {},
  onImageLoaded: function onImageLoaded() {},
  onDragStart: function onDragStart() {},
  onDragEnd: function onDragEnd() {},
  children: undefined,
  style: undefined,
  imageStyle: undefined,
  renderSelectionAddon: undefined
};

exports.default = ReactCrop;
exports.Component = ReactCrop;
exports.makeAspectCrop = makeAspectCrop;
exports.containCrop = containCrop;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(5)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(8)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var assign = __webpack_require__(6);

var ReactPropTypesSecret = __webpack_require__(1);
var checkPropTypes = __webpack_require__(7);

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = __webpack_require__(1);
  var loggedTypeFailures = {};

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          )

        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ })
/******/ ]);
});

/***/ }),
/* 2737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateOriginalImageSceneRelativeSize", function() { return calculateOriginalImageSceneRelativeSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateWidgetCoords", function() { return calculateWidgetCoords; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_util_Size__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_util_Size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_shared_util_Size__);

var calculateOriginalImageSceneRelativeSize = function (model, experience) {
    var crop = model.get("crop");
    if (crop) {
        var width = crop.width, height = crop.height;
        var percentageWidth = model.get("width") / width;
        var percentageHeight = model.get("height") / height;
        var widthPercent = experience.get("width") / 100;
        var heightPercent = experience.get("height") / 100;
        return new __WEBPACK_IMPORTED_MODULE_0_shared_util_Size___default.a(widthPercent * percentageWidth, heightPercent * percentageHeight);
    }
    return null;
};
var calculateWidgetCoords = function (model, width, height) {
    var crop = model.get("crop");
    return {
        x: width * crop.x,
        y: height * crop.y
    };
};



/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var LineWidgetModel = __webpack_require__(508);

    /**
     * @class {LineWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return LineWidgetModel.mixin("LineWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return "Line: " + this.get("lineColor");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var LineWidgetView = __webpack_require__(509);
    /**
     * Mixin the editor related logic for the <tt>LineWidgetView</tt>.
     *
     * @see  LineWidgetView
     */
    return LineWidgetView.mixin("LineWidgetViewEditorMixin", {
        /**
         * This method is extends and changes the highlight
         * of the widget astract method `_updateHightlight`
         */
        applyWidgetSpecificHighlight: function applyWidgetSpecificHighlight() {
            // Highlight widget if required
            if (this.model.get("highlighted")) {
                this.$el.css({
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "inset 0px 0px 0px 3px #8c01ff"
                });
            } else if (!this.model.get("boxShadow")) {
                this.$el.css({
                    boxShadow: "inset 0px 0px 0px 0px transparent"
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var LinkWidgetModel = __webpack_require__(510);

    /**
     * @class {LinkWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return LinkWidgetModel.mixin("LinkWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return this.get("action") && this.get("action").get("url") ? "Link: " + this.get("action").get("url") : null;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var SceneNavigatorWidgetView = __webpack_require__(513);
    /**
     * Mixin the editor related logic for the <tt>SceneNavigatorWidgetView</tt>.
     *
     * @see  SceneNavigatorWidgetView
     */
    return SceneNavigatorWidgetView.mixin("SceneNavigatorWidgetViewEditorMixin", {
        /**
         * This method is extends and changes the highlight
         * of the widget astract method `_updateHightlight`
         */
        applyWidgetSpecificHighlight: function applyWidgetSpecificHighlight() {
            // Highlight widget if required
            if (this.model.get("highlighted")) {
                this.$el.css({
                    background: "rgba(255,255,255,0.75)",
                    boxShadow: "inset 0px 0px 0px 3px #8c01ff"
                });
            } else if (!this.model.get("boxShadow")) {
                this.$el.css({
                    boxShadow: "inset 0px 0px 0px 0px transparent"
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ShapeWidgetModel = __webpack_require__(514);

    /**
     * @class {ShapeWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return ShapeWidgetModel.mixin("ShapeWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return "Shape: " + this.get("backgroundColor");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var SocialSharingWidgetModel = __webpack_require__(515);

    /**
     * @class {SocialSharingWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return SocialSharingWidgetModel.mixin("SocialSharingWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return this.get("networks") && this.get("networks").length ? "Social: " + this.get("networks").join(", ") : null;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var TextWidgetModel = __webpack_require__(367);

    /**
     * @class {TextWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return TextWidgetModel.mixin("TextWidgetModelEditorMixin", {
        /**
         * Returns the text value without html attributes
         *
         * @return {string} The stripped text value
         */
        _stripHtmlText: function _stripHtmlText() {
            var tmp = document.createElement("DIV");
            tmp.innerHTML = this.get("text");
            return tmp.textContent || tmp.innerText || "";
        },


        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            if (this.isValid() && this.hasText()) {
                // rawText is a transient property that will update on text changes to speed up label retrieval while editing.
                if (this.has("rawText")) {
                    return this.get("rawText");
                }
                var rawText = this._stripHtmlText();
                this.set("rawText", rawText);
                return rawText;
            }
            return null;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var TextWidgetModel = __webpack_require__(366);

    /**
     * @class {TextWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return TextWidgetModel.mixin("TextWidgetModelEditorMixin", {
        /**
         * Returns the text value without html attributes
         *
         * @return {string} The stripped text value
         */
        _stripHtmlText: function _stripHtmlText() {
            var tmp = document.createElement("DIV");
            tmp.innerHTML = this.get("text");
            return tmp.textContent || tmp.innerText || "";
        },


        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return this.isValid() && this.hasText() ? "Text: " + this._stripHtmlText() : null;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var YouTubeWidgetModel = __webpack_require__(519),
        Size = __webpack_require__(84);

    /**
     * @class {YouTubeWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return YouTubeWidgetModel.mixin("YouTubeWidgetModelEditorMixin", {
        /**
         * 1) Resize (both grow or shrink) the widget to fit it inside an experience,
         * 2) reset the rotation of the widget,
         * 3) move the widget back inside the scene boundaries, if needed
         *
         * This method is called when clicking the 'fit to scene' button.
         */
        fitToScene: function fitToScene(experience) {
            var percentageSize = this._getWidgetSize();

            if (percentageSize === null) {
                return;
            }

            this._setSize(this._getFittedSize(percentageSize), experience);
            this._resetRotation();
            this._setFittedWidgetPosition();
        },

        /**
         * Get the size of the widget.
         *
         * @return {Size} The size of the widget
         */
        _getWidgetSize: function _getWidgetSize() {
            return Size.from(this.get("width"), this.get("height"));
        },

        /**
         * Returns self description string
         *
         * @return {string|null} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return this.get("videoID") ? "YouTube: " + this.get("videoID") : "YouTube:";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var DynamicProductWidgetView = __webpack_require__(521);
    var DynamicProductWidgetLayout = __webpack_require__(788);
    var Matrix = __webpack_require__(204);
    var _ = __webpack_require__(1);

    /**
     * Mixin the editor related logic for the <tt>TextWidgetView</tt>.
     *
     * @see  TextWidgetView
     */
    return DynamicProductWidgetView.mixin("DynamicProductWidgetViewEditorMixin", {
        _renderLayout: function _renderLayout() {
            this._layout = new DynamicProductWidgetLayout({ el: this.$el });
            this._layout.render();
            this._showGroupedWidgetCollectionView();
        },
        showView: function showView() {
            var _this = this;

            if (this.groupCollection) {
                this._layout = new DynamicProductWidgetLayout({ el: this.$el });
                this._layout.render();

                this._setGroupedWidgetCollectionView();

                // Add each widget in the group to the widget transformer
                // so they can be selected individually.
                this.listenTo(this.groupCollectionView, "collection:rendered", function () {
                    _.defer(function () {
                        _this.groupCollectionView.children.each(function (itemView) {
                            var parentTransform = Matrix.createFromString(_this.$el.css("transform"));
                            if (_this.options && _this.options.addChildWidgetToTransformer) {
                                _this.options.addChildWidgetToTransformer(itemView, parentTransform);
                            }
                        });
                    });
                });

                this._showGroupedWidgetCollectionView();

                // Update the controls when the height/width are manually
                // changed in the sidebar controls. Debounce the update as there
                // will otherwise be multiple events fired when a number is
                // typed in manually.
                this.groupCollectionView.children.forEach(function (widget) {
                    _this.listenTo(widget, "updated:rendering", _.debounce(function () {
                        if (_this.options && _this.options.hasOwnProperty("updateControls")) {
                            _this.options.updateControls();
                        }
                    }, 100));
                });

                // When the widget is moved, remove and re-add the children to the
                // transformer so their position is updated.
                this.listenTo(this.model, "change:left change:top", function () {
                    // When a subwidget is dragged and forces the group's bounding box to adjust,
                    // the DOM element's transform CSS property needs to be recalculated based on the
                    // widget model's properties.
                    var unscaledExperienceSize = _this._experienceSize();
                    var rect = {
                        x: _this.model.get("scaledLeft") / 100 * unscaledExperienceSize.width,
                        y: _this.model.get("scaledTop") / 100 * unscaledExperienceSize.height
                    };
                    var newMatrix = Matrix.createFromString(_this.$el.css("transform"));
                    newMatrix.x = rect.x;
                    newMatrix.y = rect.y;

                    var selectedUuids = _this.viewModel.selection.get("widgets").map(function (e) {
                        return e.model.get("uuid");
                    });
                    _this.groupCollectionView.children.each(function (itemView) {
                        // Determine whether this widget is currently selected by
                        // checking whether its UUID is included in selectedUuids
                        var widgetUuid = itemView.model.get("uuid");
                        var widgetSelected = selectedUuids.indexOf(widgetUuid) > -1;

                        var parentTransform = newMatrix;
                        if (_this.options) {
                            // If this widget was selected, unselect the removed instance
                            // before removing it and reselect it after it's been re-added.
                            if (widgetSelected) {
                                _this.viewModel.selection.remove(itemView);
                            }
                            _this.options.removeChildWidgetFromTransformer(itemView);
                            _this.options.addChildWidgetToTransformer(itemView, parentTransform);
                            if (widgetSelected) {
                                _this.viewModel.selection.append(itemView);
                            }
                        }
                    });
                });
            }

            this.__super();

            if (!this.options.edited) {
                _.defer(this._makeElementUnreachable.bind(this));
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CompositeWidgetModel = __webpack_require__(173);

    /**
     * @class {CompositeWidgetModelEditorMixin}
     *
     * Extra classes used by the editor, but not needed by the viewer.
     */
    return CompositeWidgetModel.mixin("CompositeWidgetModelEditorMixin", {
        /**
         * Returns self description string
         *
         * @return {string} The self description
         */
        _getSelfDescription: function _getSelfDescription() {
            return "Group";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Contains/loads the jQuery plugins shared by both the editor and viewer applications.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    __webpack_require__(4);
    __webpack_require__(2750);
    __webpack_require__(2751);
    __webpack_require__(2752);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/*! http://mths.be/visibility v1.0.7 by @mathias | MIT license */
;(function(window, document, $, undefined) {

	var prefix;
	var property;
	// In Opera, `'onfocusin' in document == true`, hence the extra `hasFocus` check to detect IE-like behavior
	var eventName = 'onfocusin' in document && 'hasFocus' in document
		? 'focusin focusout'
		: 'focus blur';
	var prefixes = ['webkit', 'o', 'ms', 'moz', ''];
	var $support = $.support;
	var $event = $.event;

	while ((prefix = prefixes.pop()) != undefined) {
		property = (prefix ? prefix + 'H': 'h') + 'idden';
		if ($support.pageVisibility = typeof document[property] == 'boolean') {
			eventName = prefix + 'visibilitychange';
			break;
		}
	}

	$(/blur$/.test(eventName) ? window : document).on(eventName, function(event) {
		var type = event.type;
		var originalEvent = event.originalEvent;

		// Avoid errors from triggered native events for which `originalEvent` is
		// not available.
		if (!originalEvent) {
			return;
		}

		var toElement = originalEvent.toElement;

		// If it’s a `{focusin,focusout}` event (IE), `fromElement` and `toElement`
		// should both be `null` or `undefined`; else, the page visibility hasn’t
		// changed, but the user just clicked somewhere in the doc. In IE9, we need
		// to check the `relatedTarget` property instead.
		if (
			!/^focus./.test(type) || (
				toElement == undefined &&
				originalEvent.fromElement == undefined &&
				originalEvent.relatedTarget == undefined
			)
		) {
			$event.trigger(
				(
					property && document[property] || /^(?:blur|focusout)$/.test(type)
						? 'hide'
						: 'show'
				) + '.visibility'
			);
		}
	});

}(this, document, jQuery));



/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/*
* @fileOverview TouchSwipe - jQuery Plugin
* @version 1.6.3
*
* @author Matt Bryson http://www.github.com/mattbryson
* @see https://github.com/mattbryson/TouchSwipe-Jquery-Plugin
* @see http://labs.skinkers.com/touchSwipe/
* @see http://plugins.jquery.com/project/touchSwipe
*
* Copyright (c) 2010 Matt Bryson
* Dual licensed under the MIT or GPL Version 2 licenses.
*
*
* Changelog
* $Date: 2010-12-12 (Wed, 12 Dec 2010) $
* $version: 1.0.0
* $version: 1.0.1 - removed multibyte comments
*
* $Date: 2011-21-02 (Mon, 21 Feb 2011) $
* $version: 1.1.0 	- added allowPageScroll property to allow swiping and scrolling of page
*					- changed handler signatures so one handler can be used for multiple events
* $Date: 2011-23-02 (Wed, 23 Feb 2011) $
* $version: 1.2.0 	- added click handler. This is fired if the user simply clicks and does not swipe. The event object and click target are passed to handler.
*					- If you use the http://code.google.com/p/jquery-ui-for-ipad-and-iphone/ plugin, you can also assign jQuery mouse events to children of a touchSwipe object.
* $version: 1.2.1 	- removed console log!
*
* $version: 1.2.2 	- Fixed bug where scope was not preserved in callback methods.
*
* $Date: 2011-28-04 (Thurs, 28 April 2011) $
* $version: 1.2.4 	- Changed licence terms to be MIT or GPL inline with jQuery. Added check for support of touch events to stop non compatible browsers erroring.
*
* $Date: 2011-27-09 (Tues, 27 September 2011) $
* $version: 1.2.5 	- Added support for testing swipes with mouse on desktop browser (thanks to https://github.com/joelhy)
*
* $Date: 2012-14-05 (Mon, 14 May 2012) $
* $version: 1.2.6 	- Added timeThreshold between start and end touch, so user can ignore slow swipes (thanks to Mark Chase). Default is null, all swipes are detected
*
* $Date: 2012-05-06 (Tues, 05 June 2012) $
* $version: 1.2.7 	- Changed time threshold to have null default for backwards compatibility. Added duration param passed back in events, and refactored how time is handled.
*
* $Date: 2012-05-06 (Tues, 05 June 2012) $
* $version: 1.2.8 	- Added the possibility to return a value like null or false in the trigger callback. In that way we can control when the touch start/move should take effect or not (simply by returning in some cases return null; or return false;) This effects the ontouchstart/ontouchmove event.
*
* $Date: 2012-06-06 (Wed, 06 June 2012) $
* $version: 1.3.0 	- Refactored whole plugin to allow for methods to be executed, as well as exposed defaults for user override. Added 'enable', 'disable', and 'destroy' methods
*
* $Date: 2012-05-06 (Fri, 05 June 2012) $
* $version: 1.3.1 	- Bug fixes  - bind() with false as last argument is no longer supported in jQuery 1.6, also, if you just click, the duration is now returned correctly.
*
* $Date: 2012-29-07 (Sun, 29 July 2012) $
* $version: 1.3.2	- Added fallbackToMouseEvents option to NOT capture mouse events on non touch devices.
* 			- Added "all" fingers value to the fingers property, so any combinatin of fingers triggers the swipe, allowing event handlers to check the finger count
*
* $Date: 2012-09-08 (Thurs, 9 Aug 2012) $
* $version: 1.3.3	- Code tidy prep for minified version
*
* $Date: 2012-04-10 (wed, 4 Oct 2012) $
* $version: 1.4.0	- Added pinch support, pinchIn and pinchOut
*
* $Date: 2012-11-10 (Thurs, 11 Oct 2012) $
* $version: 1.5.0	- Added excludedElements, a jquery selector that specifies child elements that do NOT trigger swipes. By default, this is one select that removes all form, input select, button and anchor elements.
*
* $Date: 2012-22-10 (Mon, 22 Oct 2012) $
* $version: 1.5.1	- Fixed bug with jQuery 1.8 and trailing comma in excludedElements
*					- Fixed bug with IE and eventPreventDefault()
* $Date: 2013-01-12 (Fri, 12 Jan 2013) $
* $version: 1.6.0	- Fixed bugs with pinching, mainly when both pinch and swipe enabled, as well as adding time threshold for multifinger gestures, so releasing one finger beofre the other doesnt trigger as single finger gesture.
*					- made the demo site all static local HTML pages so they can be run locally by a developer
*					- added jsDoc comments and added documentation for the plugin	
*					- code tidy
*					- added triggerOnTouchLeave property that will end the event when the user swipes off the element.
* $Date: 2013-03-23 (Sat, 23 Mar 2013) $
* $version: 1.6.1	- Added support for ie8 touch events
* $version: 1.6.2	- Added support for events binding with on / off / bind in jQ for all callback names.
*                   - Deprecated the 'click' handler in favour of tap.
*                   - added cancelThreshold property
*                   - added option method to update init options at runtime
*
* $version 1.6.3    - added doubletap, longtap events and longTapThreshold, doubleTapThreshold property
* $Date: 2013-04-04 (Thurs, 04 April 2013) $
* $version 1.6.4    - Fixed bug with cancelThreshold introduced in 1.6.3, where swipe status no longer fired start event, and stopped once swiping back.
*/

/**
 * See (http://jquery.com/).
 * @name $
 * @class 
 * See the jQuery Library  (http://jquery.com/) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 */
 
/**
 * See (http://jquery.com/)
 * @name fn
 * @class 
 * See the jQuery Library  (http://jquery.com/) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 * @memberOf $
 */
 
 
 
(function ($) {
	"use strict";

	//Constants
	var LEFT = "left",
		RIGHT = "right",
		UP = "up",
		DOWN = "down",
		IN = "in",
		OUT = "out",

		NONE = "none",
		AUTO = "auto",
		
		SWIPE = "swipe",
		PINCH = "pinch",
		TAP = "tap",
		DOUBLE_TAP = "doubletap",
		LONG_TAP = "longtap",
		
		HORIZONTAL = "horizontal",
		VERTICAL = "vertical",

		ALL_FINGERS = "all",
		
		DOUBLE_TAP_THRESHOLD = 10,

		PHASE_START = "start",
		PHASE_MOVE = "move",
		PHASE_END = "end",
		PHASE_CANCEL = "cancel",

		SUPPORTS_TOUCH = 'ontouchstart' in window,

		PLUGIN_NS = 'TouchSwipe';



	/**
	* The default configuration, and available options to configure touch swipe with.
	* You can set the default values by updating any of the properties prior to instantiation.
	* @name $.fn.swipe.defaults
	* @namespace
	* @property {int} [fingers=1] The number of fingers to detect in a swipe. Any swipes that do not meet this requirement will NOT trigger swipe handlers.
	* @property {int} [threshold=75] The number of pixels that the user must move their finger by before it is considered a swipe. 
	* @property {int} [cancelThreshold=null] The number of pixels that the user must move their finger back from the original swipe direction to cancel the gesture.
	* @property {int} [pinchThreshold=20] The number of pixels that the user must pinch their finger by before it is considered a pinch. 
	* @property {int} [maxTimeThreshold=null] Time, in milliseconds, between touchStart and touchEnd must NOT exceed in order to be considered a swipe. 
	* @property {int} [fingerReleaseThreshold=250] Time in milliseconds between releasing multiple fingers.  If 2 fingers are down, and are released one after the other, if they are within this threshold, it counts as a simultaneous release. 
	* @property {int} [longTapThreshold=500] Time in milliseconds between tap and release for a long tap
    * @property {int} [doubleTapThreshold=200] Time in milliseconds between 2 taps to count as a doubletap
	* @property {function} [swipe=null] A handler to catch all swipes. See {@link $.fn.swipe#event:swipe}
	* @property {function} [swipeLeft=null] A handler that is triggered for "left" swipes. See {@link $.fn.swipe#event:swipeLeft}
	* @property {function} [swipeRight=null] A handler that is triggered for "right" swipes. See {@link $.fn.swipe#event:swipeRight}
	* @property {function} [swipeUp=null] A handler that is triggered for "up" swipes. See {@link $.fn.swipe#event:swipeUp}
	* @property {function} [swipeDown=null] A handler that is triggered for "down" swipes. See {@link $.fn.swipe#event:swipeDown}
	* @property {function} [swipeStatus=null] A handler triggered for every phase of the swipe. See {@link $.fn.swipe#event:swipeStatus}
	* @property {function} [pinchIn=null] A handler triggered for pinch in events. See {@link $.fn.swipe#event:pinchIn}
	* @property {function} [pinchOut=null] A handler triggered for pinch out events. See {@link $.fn.swipe#event:pinchOut}
	* @property {function} [pinchStatus=null] A handler triggered for every phase of a pinch. See {@link $.fn.swipe#event:pinchStatus}
	* @property {function} [tap=null] A handler triggered when a user just taps on the item, rather than swipes it. If they do not move, tap is triggered, if they do move, it is not. 
	* @property {function} [doubleTap=null] A handler triggered when a user double taps on the item. The delay between taps can be set with the doubleTapThreshold property. See {@link $.fn.swipe.defaults#doubleTapThreshold}
	* @property {function} [longTap=null] A handler triggered when a user long taps on the item. The delay between start and end can be set with the longTapThreshold property. See {@link $.fn.swipe.defaults#doubleTapThreshold}
	* @property {boolean} [triggerOnTouchEnd=true] If true, the swipe events are triggered when the touch end event is received (user releases finger).  If false, it will be triggered on reaching the threshold, and then cancel the touch event automatically. 
	* @property {boolean} [triggerOnTouchLeave=false] If true, then when the user leaves the swipe object, the swipe will end and trigger appropriate handlers. 
	* @property {string} [allowPageScroll='auto'] How the browser handles page scrolls when the user is swiping on a touchSwipe object. See {@link $.fn.swipe.pageScroll}.  <br/><br/>
										<code>"auto"</code> : all undefined swipes will cause the page to scroll in that direction. <br/>
										<code>"none"</code> : the page will not scroll when user swipes. <br/>
										<code>"horizontal"</code> : will force page to scroll on horizontal swipes. <br/>
										<code>"vertical"</code> : will force page to scroll on vertical swipes. <br/>
	* @property {boolean} [fallbackToMouseEvents=true] If true mouse events are used when run on a non touch device, false will stop swipes being triggered by mouse events on non tocuh devices. 
	* @property {string} [excludedElements="button, input, select, textarea, a, .noSwipe"] A jquery selector that specifies child elements that do NOT trigger swipes. By default this excludes all form, input, select, button, anchor and .noSwipe elements. 
	
	*/
	var defaults = {
		fingers: 1, 		
		threshold: 75, 	
		cancelThreshold:null,	
		pinchThreshold:20,
		maxTimeThreshold: null, 
		fingerReleaseThreshold:250, 
		longTapThreshold:500,
		doubleTapThreshold:200,
		swipe: null, 		
		swipeLeft: null, 	
		swipeRight: null, 	
		swipeUp: null, 		
		swipeDown: null, 	
		swipeStatus: null, 	
		pinchIn:null,		
		pinchOut:null,		
		pinchStatus:null,	
		click:null, //Deprecated since 1.6.2
		tap:null,
		doubleTap:null,
		longTap:null, 		
		triggerOnTouchEnd: true, 
		triggerOnTouchLeave:false, 
		allowPageScroll: "auto", 
		fallbackToMouseEvents: true,	
		excludedElements:"button, input, select, textarea, a, .noSwipe"
	};



	/**
	* Applies TouchSwipe behaviour to one or more jQuery objects.
	* The TouchSwipe plugin can be instantiated via this method, or methods within 
	* TouchSwipe can be executed via this method as per jQuery plugin architecture.
	* @see TouchSwipe
	* @class
	* @param {Mixed} method If the current DOMNode is a TouchSwipe object, and <code>method</code> is a TouchSwipe method, then
	* the <code>method</code> is executed, and any following arguments are passed to the TouchSwipe method.
	* If <code>method</code> is an object, then the TouchSwipe class is instantiated on the current DOMNode, passing the 
	* configuration properties defined in the object. See TouchSwipe
	*
	*/
	$.fn.swipe = function (method) {
		var $this = $(this),
			plugin = $this.data(PLUGIN_NS);

		//Check if we are already instantiated and trying to execute a method	
		if (plugin && typeof method === 'string') {
			if (plugin[method]) {
				return plugin[method].apply(this, Array.prototype.slice.call(arguments, 1));
			} else {
				$.error('Method ' + method + ' does not exist on jQuery.swipe');
			}
		}
		//Else not instantiated and trying to pass init object (or nothing)
		else if (!plugin && (typeof method === 'object' || !method)) {
			return init.apply(this, arguments);
		}

		return $this;
	};

	//Expose our defaults so a user could override the plugin defaults
	$.fn.swipe.defaults = defaults;

	/**
	* The phases that a touch event goes through.  The <code>phase</code> is passed to the event handlers. 
	* These properties are read only, attempting to change them will not alter the values passed to the event handlers.
	* @namespace
	* @readonly
	* @property {string} PHASE_START Constant indicating the start phase of the touch event. Value is <code>"start"</code>.
	* @property {string} PHASE_MOVE Constant indicating the move phase of the touch event. Value is <code>"move"</code>.
	* @property {string} PHASE_END Constant indicating the end phase of the touch event. Value is <code>"end"</code>.
	* @property {string} PHASE_CANCEL Constant indicating the cancel phase of the touch event. Value is <code>"cancel"</code>.
	*/
	$.fn.swipe.phases = {
		PHASE_START: PHASE_START,
		PHASE_MOVE: PHASE_MOVE,
		PHASE_END: PHASE_END,
		PHASE_CANCEL: PHASE_CANCEL
	};

	/**
	* The direction constants that are passed to the event handlers. 
	* These properties are read only, attempting to change them will not alter the values passed to the event handlers.
	* @namespace
	* @readonly
	* @property {string} LEFT Constant indicating the left direction. Value is <code>"left"</code>.
	* @property {string} RIGHT Constant indicating the right direction. Value is <code>"right"</code>.
	* @property {string} UP Constant indicating the up direction. Value is <code>"up"</code>.
	* @property {string} DOWN Constant indicating the down direction. Value is <code>"cancel"</code>.
	* @property {string} IN Constant indicating the in direction. Value is <code>"in"</code>.
	* @property {string} OUT Constant indicating the out direction. Value is <code>"out"</code>.
	*/
	$.fn.swipe.directions = {
		LEFT: LEFT,
		RIGHT: RIGHT,
		UP: UP,
		DOWN: DOWN,
		IN : IN,
		OUT: OUT
	};
	
	/**
	* The page scroll constants that can be used to set the value of <code>allowPageScroll</code> option
	* These properties are read only
	* @namespace
	* @readonly
	* @see $.fn.swipe.defaults#allowPageScroll
	* @property {string} NONE Constant indicating no page scrolling is allowed. Value is <code>"none"</code>.
	* @property {string} HORIZONTAL Constant indicating horizontal page scrolling is allowed. Value is <code>"horizontal"</code>.
	* @property {string} VERTICAL Constant indicating vertical page scrolling is allowed. Value is <code>"vertical"</code>.
	* @property {string} AUTO Constant indicating either horizontal or vertical will be allowed, depending on the swipe handlers registered. Value is <code>"auto"</code>.
	*/
	$.fn.swipe.pageScroll = {
		NONE: NONE,
		HORIZONTAL: HORIZONTAL,
		VERTICAL: VERTICAL,
		AUTO: AUTO
	};

	/**
	* Constants representing the number of fingers used in a swipe.  These are used to set both the value of <code>fingers</code> in the 
	* options object, as well as the value of the <code>fingers</code> event property.
	* These properties are read only, attempting to change them will not alter the values passed to the event handlers.
	* @namespace
	* @readonly
	* @see $.fn.swipe.defaults#fingers
	* @property {string} ONE Constant indicating 1 finger is to be detected / was detected. Value is <code>1</code>.
	* @property {string} TWO Constant indicating 2 fingers are to be detected / were detected. Value is <code>1</code>.
	* @property {string} THREE Constant indicating 3 finger are to be detected / were detected. Value is <code>1</code>.
	* @property {string} ALL Constant indicating any combination of finger are to be detected.  Value is <code>"all"</code>.
	*/
	$.fn.swipe.fingers = {
		ONE: 1,
		TWO: 2,
		THREE: 3,
		ALL: ALL_FINGERS
	};

	/**
	* Initialise the plugin for each DOM element matched
	* This creates a new instance of the main TouchSwipe class for each DOM element, and then
	* saves a reference to that instance in the elements data property.
	* @internal
	*/
	function init(options) {
		//Prep and extend the options
		if (options && (options.allowPageScroll === undefined && (options.swipe !== undefined || options.swipeStatus !== undefined))) {
			options.allowPageScroll = NONE;
		}
		
        //Check for deprecated options
		//Ensure that any old click handlers are assigned to the new tap, unless we have a tap
		if(options.click!==undefined && options.tap===undefined) {
		    options.tap = options.click;
		}

		if (!options) {
			options = {};
		}
		
        //pass empty object so we dont modify the defaults
		options = $.extend({}, $.fn.swipe.defaults, options);

		//For each element instantiate the plugin
		return this.each(function () {
			var $this = $(this);

			//Check we havent already initialised the plugin
			var plugin = $this.data(PLUGIN_NS);

			if (!plugin) {
				plugin = new TouchSwipe(this, options);
				$this.data(PLUGIN_NS, plugin);
			}
		});
	}

	/**
	* Main TouchSwipe Plugin Class.
	* Do not use this to construct your TouchSwipe object, use the jQuery plugin method $.fn.swipe(); {@link $.fn.swipe}
	* @private
	* @name TouchSwipe
	* @param {DOMNode} element The HTML DOM object to apply to plugin to
	* @param {Object} options The options to configure the plugin with.  @link {$.fn.swipe.defaults}
	* @see $.fh.swipe.defaults
	* @see $.fh.swipe
    * @class
	*/
	function TouchSwipe(element, options) {
		var useTouchEvents = (SUPPORTS_TOUCH || !options.fallbackToMouseEvents),
			START_EV = useTouchEvents ? 'touchstart' : 'mousedown',
			MOVE_EV = useTouchEvents ? 'touchmove' : 'mousemove',
			END_EV = useTouchEvents ? 'touchend' : 'mouseup',
			LEAVE_EV = useTouchEvents ? null : 'mouseleave', //we manually detect leave on touch devices, so null event here
			CANCEL_EV = 'touchcancel';



		//touch properties
		var distance = 0,
			direction = null,
			duration = 0,
			startTouchesDistance = 0,
			endTouchesDistance = 0,
			pinchZoom = 1,
			pinchDistance = 0,
			pinchDirection = 0,
			maximumsMap=null;

		
		
		//jQuery wrapped element for this instance
		var $element = $(element);
		
		//Current phase of th touch cycle
		var phase = "start";

		// the current number of fingers being used.
		var fingerCount = 0; 			

		//track mouse points / delta
		var fingerData=null;

		//track times
		var startTime = 0,
			endTime = 0,
			previousTouchEndTime=0,
			previousTouchFingerCount=0,
			doubleTapStartTime=0;

        //Timeouts
        var singleTapTimeout=null;
        
		// Add gestures to all swipable areas if supported
		try {
			$element.bind(START_EV, touchStart);
			$element.bind(CANCEL_EV, touchCancel);
		}
		catch (e) {
			$.error('events not supported ' + START_EV + ',' + CANCEL_EV + ' on jQuery.swipe');
		}

		//
		//Public methods
		//
		
		/**
		* re-enables the swipe plugin with the previous configuration
		* @function
		* @name $.fn.swipe#enable
		* @return {DOMNode} The Dom element that was registered with TouchSwipe 
		* @example $("#element").swipe("enable");
		*/
		this.enable = function () {
			$element.bind(START_EV, touchStart);
			$element.bind(CANCEL_EV, touchCancel);
			return $element;
		};

		/**
		* disables the swipe plugin
		* @function
		* @name $.fn.swipe#disable
		* @return {DOMNode} The Dom element that is now registered with TouchSwipe
	    * @example $("#element").swipe("disable");
		*/
		this.disable = function () {
			removeListeners();
			return $element;
		};

		/**
		* Destroy the swipe plugin completely. To use any swipe methods, you must re initialise the plugin.
		* @function
		* @name $.fn.swipe#destroy
		* @return {DOMNode} The Dom element that was registered with TouchSwipe 
		* @example $("#element").swipe("destroy");
		*/
		this.destroy = function () {
			removeListeners();
			$element.data(PLUGIN_NS, null);
			return $element;
		};


        /**
         * Allows run time updating of the swipe configuration options.
         * @function
    	 * @name $.fn.swipe#option
    	 * @param {String} property The option property to get or set
         * @param {Object} [value] The value to set the property to
		 * @return {Object} If only a property name is passed, then that property value is returned.
		 * @example $("#element").swipe("option", "threshold"); // return the threshold
         * @example $("#element").swipe("option", "threshold", 100); // set the threshold after init
         * @see $.fn.swipe.defaults
         *
         */
        this.option = function (property, value) {
            if(options[property]!==undefined) {
                if(value===undefined) {
                    return options[property];
                } else {
                    options[property] = value;
                }
            } else {
                $.error('Option ' + property + ' does not exist on jQuery.swipe.options');
            }
        }

		//
		// Private methods
		//
		
		//
		// EVENTS
		//
		/**
		* Event handler for a touch start event.
		* Stops the default click event from triggering and stores where we touched
		* @inner
		* @param {object} jqEvent The normalised jQuery event object.
		*/
		function touchStart(jqEvent) {
			//If we already in a touch event (a finger already in use) then ignore subsequent ones..
			if( getTouchInProgress() )
				return;
			
			//Check if this element matches any in the excluded elements selectors,  or its parent is excluded, if so, DONT swipe
			if( $(jqEvent.target).closest( options.excludedElements, $element ).length>0 ) 
				return;
				
			//As we use Jquery bind for events, we need to target the original event object
			//If these events are being programatically triggered, we dont have an orignal event object, so use the Jq one.
			var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
			
			var ret,
				evt = SUPPORTS_TOUCH ? event.touches[0] : event;

			phase = PHASE_START;

			//If we support touches, get the finger count
			if (SUPPORTS_TOUCH) {
				// get the total number of fingers touching the screen
				fingerCount = event.touches.length;
			}
			//Else this is the desktop, so stop the browser from dragging the image
			else {
				jqEvent.preventDefault(); //call this on jq event so we are cross browser
			}

			//clear vars..
			distance = 0;
			direction = null;
			pinchDirection=null;
			duration = 0;
			startTouchesDistance=0;
			endTouchesDistance=0;
			pinchZoom = 1;
			pinchDistance = 0;
			fingerData=createAllFingerData();
			maximumsMap=createMaximumsData();
			cancelMultiFingerRelease();

			
			// check the number of fingers is what we are looking for, or we are capturing pinches
			if (!SUPPORTS_TOUCH || (fingerCount === options.fingers || options.fingers === ALL_FINGERS) || hasPinches()) {
				// get the coordinates of the touch
				createFingerData( 0, evt );
				startTime = getTimeStamp();
				
				if(fingerCount==2) {
					//Keep track of the initial pinch distance, so we can calculate the diff later
					//Store second finger data as start
					createFingerData( 1, event.touches[1] );
					startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
				}
				
				if (options.swipeStatus || options.pinchStatus) {
					ret = triggerHandler(event, phase);
				}
			}
			else {
				//A touch with more or less than the fingers we are looking for, so cancel
				ret = false; 
			}

			//If we have a return value from the users handler, then return and cancel
			if (ret === false) {
				phase = PHASE_CANCEL;
				triggerHandler(event, phase);
				return ret;
			}
			else {
				setTouchInProgress(true);
			}
		};
		
		
		
		/**
		* Event handler for a touch move event. 
		* If we change fingers during move, then cancel the event
		* @inner
		* @param {object} jqEvent The normalised jQuery event object.
		*/
		function touchMove(jqEvent) {
			
			//As we use Jquery bind for events, we need to target the original event object
			//If these events are being programatically triggered, we dont have an orignal event object, so use the Jq one.
			var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;
			
			//If we are ending, cancelling, or within the threshold of 2 fingers being released, dont track anything..
			if (phase === PHASE_END || phase === PHASE_CANCEL || inMultiFingerRelease())
				return;

			var ret,
				evt = SUPPORTS_TOUCH ? event.touches[0] : event;
			

			//Update the  finger data 
			var currentFinger = updateFingerData(evt);
			endTime = getTimeStamp();
			
			if (SUPPORTS_TOUCH) {
				fingerCount = event.touches.length;
			}

			phase = PHASE_MOVE;

			//If we have 2 fingers get Touches distance as well
			if(fingerCount==2) {
				
				//Keep track of the initial pinch distance, so we can calculate the diff later
				//We do this here as well as the start event, incase they start with 1 finger, and the press 2 fingers
				if(startTouchesDistance==0) {
					//Create second finger if this is the first time...
					createFingerData( 1, event.touches[1] );
					
					startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
				} else {
					//Else just update the second finger
					updateFingerData(event.touches[1]);
				
					endTouchesDistance = calculateTouchesDistance(fingerData[0].end, fingerData[1].end);
					pinchDirection = calculatePinchDirection(fingerData[0].end, fingerData[1].end);
				}
				
				
				pinchZoom = calculatePinchZoom(startTouchesDistance, endTouchesDistance);
				pinchDistance = Math.abs(startTouchesDistance - endTouchesDistance);
			}
			
			
			if ( (fingerCount === options.fingers || options.fingers === ALL_FINGERS) || !SUPPORTS_TOUCH || hasPinches() ) {
				
				direction = calculateDirection(currentFinger.start, currentFinger.end);
				
				//Check if we need to prevent default evnet (page scroll / pinch zoom) or not
				validateDefaultEvent(jqEvent, direction);

				//Distance and duration are all off the main finger
				distance = calculateDistance(currentFinger.start, currentFinger.end);
				duration = calculateDuration();

                //Cache the maximum distance we made in this direction
                setMaxDistance(direction, distance);


				if (options.swipeStatus || options.pinchStatus) {
					ret = triggerHandler(event, phase);
				}
				
				
				//If we trigger end events when threshold are met, or trigger events when touch leves element
				if(!options.triggerOnTouchEnd || options.triggerOnTouchLeave) {
					
					var inBounds = true;
					
					//If checking if we leave the element, run the bounds check (we can use touchleave as its not supported on webkit)
					if(options.triggerOnTouchLeave) {
						var bounds = getbounds( this );
						inBounds = isInBounds( currentFinger.end, bounds );
					}
					
					//Trigger end handles as we swipe if thresholds met or if we have left the element if the user has asked to check these..
					if(!options.triggerOnTouchEnd && inBounds) {
						phase = getNextPhase( PHASE_MOVE );
					} 
					//We end if out of bounds here, so set current phase to END, and check if its modified 
					else if(options.triggerOnTouchLeave && !inBounds ) {
						phase = getNextPhase( PHASE_END );
					}
						
					if(phase==PHASE_CANCEL || phase==PHASE_END)	{
						triggerHandler(event, phase);
					}				
				}
			}
			else {
				phase = PHASE_CANCEL;
				triggerHandler(event, phase);
			}

			if (ret === false) {
				phase = PHASE_CANCEL;
				triggerHandler(event, phase);
			}
		}



		/**
		* Event handler for a touch end event. 
		* Calculate the direction and trigger events
		* @inner
		* @param {object} jqEvent The normalised jQuery event object.
		*/
		function touchEnd(jqEvent) {
			//As we use Jquery bind for events, we need to target the original event object
			var event = jqEvent.originalEvent;
				

			//If we are still in a touch with another finger return
			//This allows us to wait a fraction and see if the other finger comes up, if it does within the threshold, then we treat it as a multi release, not a single release.
			if (SUPPORTS_TOUCH) {
				if(event.touches.length>0) {
					startMultiFingerRelease();
					return true;
				}
			}
			
			//If a previous finger has been released, check how long ago, if within the threshold, then assume it was a multifinger release.
			//This is used to allow 2 fingers to release fractionally after each other, whilst maintainig the event as containg 2 fingers, not 1
			if(inMultiFingerRelease()) {	
				fingerCount=previousTouchFingerCount;
			}	
				 
			//call this on jq event so we are cross browser 
			jqEvent.preventDefault(); 
			
			//Set end of swipe
			endTime = getTimeStamp();
			
			//Get duration incase move was never fired
			duration = calculateDuration();
			
			//If we trigger handlers at end of swipe OR, we trigger during, but they didnt trigger and we are still in the move phase
			if(didSwipeBackToCancel()) {
			    phase = PHASE_CANCEL;
                triggerHandler(event, phase);
			} else if (options.triggerOnTouchEnd || (options.triggerOnTouchEnd == false && phase === PHASE_MOVE)) {
				phase = PHASE_END;
                triggerHandler(event, phase);
			}
			//Special cases - A tap should always fire on touch end regardless,
			//So here we manually trigger the tap end handler by itself
			//We dont run trigger handler as it will re-trigger events that may have fired already
			else if (!options.triggerOnTouchEnd && hasTap()) {
                //Trigger the pinch events...
			    phase = PHASE_END;
			    triggerHandlerForGesture(event, phase, TAP);
			}
			else if (phase === PHASE_MOVE) {
				phase = PHASE_CANCEL;
				triggerHandler(event, phase);
			}

			setTouchInProgress(false);
		}



		/**
		* Event handler for a touch cancel event. 
		* Clears current vars
		* @inner
		*/
		function touchCancel() {
			// reset the variables back to default values
			fingerCount = 0;
			endTime = 0;
			startTime = 0;
			startTouchesDistance=0;
			endTouchesDistance=0;
			pinchZoom=1;
			
			//If we were in progress of tracking a possible multi touch end, then re set it.
			cancelMultiFingerRelease();
			
			setTouchInProgress(false);
		}
		
		
		/**
		* Event handler for a touch leave event. 
		* This is only triggered on desktops, in touch we work this out manually
		* as the touchleave event is not supported in webkit
		* @inner
		*/
		function touchLeave(jqEvent) {
			var event = jqEvent.originalEvent;
			
			//If we have the trigger on leve property set....
			if(options.triggerOnTouchLeave) {
				phase = getNextPhase( PHASE_END );
				triggerHandler(event, phase);
			}
		}
		
		/**
		* Removes all listeners that were associated with the plugin
		* @inner
		*/
		function removeListeners() {
			$element.unbind(START_EV, touchStart);
			$element.unbind(CANCEL_EV, touchCancel);
			$element.unbind(MOVE_EV, touchMove);
			$element.unbind(END_EV, touchEnd);
			
			//we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
			if(LEAVE_EV) { 
				$element.unbind(LEAVE_EV, touchLeave);
			}
			
			setTouchInProgress(false);
		}

		
		/**
		 * Checks if the time and distance thresholds have been met, and if so then the appropriate handlers are fired.
		 */
		function getNextPhase(currentPhase) {
			
			var nextPhase = currentPhase;
			
			// Ensure we have valid swipe (under time and over distance  and check if we are out of bound...)
			var validTime = validateSwipeTime();
			var validDistance = validateSwipeDistance();
			var didCancel = didSwipeBackToCancel();
						
			//If we have exceeded our time, then cancel	
			if(!validTime || didCancel) {
				nextPhase = PHASE_CANCEL;
			}
			//Else if we are moving, and have reached distance then end
			else if (validDistance && currentPhase == PHASE_MOVE && (!options.triggerOnTouchEnd || options.triggerOnTouchLeave) ) {
				nextPhase = PHASE_END;
			} 
			//Else if we have ended by leaving and didnt reach distance, then cancel
			else if (!validDistance && currentPhase==PHASE_END && options.triggerOnTouchLeave) {
				nextPhase = PHASE_CANCEL;
			}
			
			return nextPhase;
		}
		
		
		/**
		* Trigger the relevant event handler
		* The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
		* @param {object} event the original event object
		* @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
		* @inner
		*/
		function triggerHandler(event, phase) {
			
			var ret = undefined;
			
			// SWIPE GESTURES
			if(didSwipe() || hasSwipes()) { //hasSwipes as status needs to fire even if swipe is invalid
				//Trigger the swipe events...
				ret = triggerHandlerForGesture(event, phase, SWIPE);
			} 
			
			// PINCH GESTURES (if the above didnt cancel)
			else if((didPinch() || hasPinches()) && ret!==false) {
				//Trigger the pinch events...
				ret = triggerHandlerForGesture(event, phase, PINCH);
			}
			
			// CLICK / TAP (if the above didnt cancel)
			if(didDoubleTap() && ret!==false) {
				//Trigger the tap events...
				ret = triggerHandlerForGesture(event, phase, DOUBLE_TAP);
			}
			
			// CLICK / TAP (if the above didnt cancel)
			else if(didLongTap() && ret!==false) {
				//Trigger the tap events...
				ret = triggerHandlerForGesture(event, phase, LONG_TAP);
			}

			// CLICK / TAP (if the above didnt cancel)
			else if(didTap() && ret!==false) {
				//Trigger the tap event..
				ret = triggerHandlerForGesture(event, phase, TAP);
	    	}
			
			
			
			// If we are cancelling the gesture, then manually trigger the reset handler
			if (phase === PHASE_CANCEL) {
				touchCancel(event);
			}
			
			// If we are ending the gesture, then manually trigger the reset handler IF all fingers are off
			if(phase === PHASE_END) {
				//If we support touch, then check that all fingers are off before we cancel
				if (SUPPORTS_TOUCH) {
					if(event.touches.length==0) {
						touchCancel(event);	
					}
				} 
				else {
					touchCancel(event);
				}
			}
					
			return ret;
		}
		
		
		
		/**
		* Trigger the relevant event handler
		* The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
		* @param {object} event the original event object
		* @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
		* @param {string} gesture the gesture to triger a handler for : PINCH or SWIPE {@link $.fn.swipe.gestures}
		* @return Boolean False, to indicate that the event should stop propagation, or void.
		* @inner
		*/
		function triggerHandlerForGesture(event, phase, gesture) {	
			
			var ret=undefined;
			
			//SWIPES....
			if(gesture==SWIPE) {
				//Trigger status every time..
				
				//Trigger the event...
				$element.trigger('swipeStatus', [phase, direction || null, distance || 0, duration || 0, fingerCount]);
				
				//Fire the callback
				if (options.swipeStatus) {
					ret = options.swipeStatus.call($element, event, phase, direction || null, distance || 0, duration || 0, fingerCount);
					//If the status cancels, then dont run the subsequent event handlers..
					if(ret===false) return false;
				}
				
				
				
				
				if (phase == PHASE_END && validateSwipe()) {
					//Fire the catch all event
					$element.trigger('swipe', [direction, distance, duration, fingerCount]);
					
					//Fire catch all callback
					if (options.swipe) {
						ret = options.swipe.call($element, event, direction, distance, duration, fingerCount);
						//If the status cancels, then dont run the subsequent event handlers..
						if(ret===false) return false;
					}
					
					//trigger direction specific event handlers	
					switch (direction) {
						case LEFT:
							//Trigger the event
							$element.trigger('swipeLeft', [direction, distance, duration, fingerCount]);
					
					        //Fire the callback
							if (options.swipeLeft) {
								ret = options.swipeLeft.call($element, event, direction, distance, duration, fingerCount);
							}
							break;
	
						case RIGHT:
							//Trigger the event
					        $element.trigger('swipeRight', [direction, distance, duration, fingerCount]);
					
					        //Fire the callback
							if (options.swipeRight) {
								ret = options.swipeRight.call($element, event, direction, distance, duration, fingerCount);
							}
							break;
	
						case UP:
							//Trigger the event
					        $element.trigger('swipeUp', [direction, distance, duration, fingerCount]);
					
					        //Fire the callback
							if (options.swipeUp) {
								ret = options.swipeUp.call($element, event, direction, distance, duration, fingerCount);
							}
							break;
	
						case DOWN:
							//Trigger the event
					        $element.trigger('swipeDown', [direction, distance, duration, fingerCount]);
					
					        //Fire the callback
							if (options.swipeDown) {
								ret = options.swipeDown.call($element, event, direction, distance, duration, fingerCount);
							}
							break;
					}
				}
			}
			
			
			//PINCHES....
			if(gesture==PINCH) {
				//Trigger the event
			     $element.trigger('pinchStatus', [phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom]);
					
                //Fire the callback
				if (options.pinchStatus) {
					ret = options.pinchStatus.call($element, event, phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom);
					//If the status cancels, then dont run the subsequent event handlers..
					if(ret===false) return false;
				}
				
				if(phase==PHASE_END && validatePinch()) {
					
					switch (pinchDirection) {
						case IN:
							//Trigger the event
                            $element.trigger('pinchIn', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom]);
                    
                            //Fire the callback
                            if (options.pinchIn) {
								ret = options.pinchIn.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom);
							}
							break;
						
						case OUT:
							//Trigger the event
                            $element.trigger('pinchOut', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom]);
                    
                            //Fire the callback
                            if (options.pinchOut) {
								ret = options.pinchOut.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom);
							}
							break;	
					}
				}
			}
			


                
	    		
			if(gesture==TAP) {
				if(phase === PHASE_CANCEL || phase === PHASE_END) {
					
    			    
    			    //Cancel any existing double tap
				    clearTimeout(singleTapTimeout);
				           
					//If we are also looking for doubelTaps, wait incase this is one...
				    if(hasDoubleTap() && !inDoubleTap()) {
				        //Cache the time of this tap
                        doubleTapStartTime = getTimeStamp();
                       
				        //Now wait for the double tap timeout, and trigger this single tap
				        //if its not cancelled by a double tap
				        singleTapTimeout = setTimeout($.proxy(function() {
        			        doubleTapStartTime=null;
        			        //Trigger the event
                            $element.trigger('tap', [event.target]);

                        
                            //Fire the callback
                            if(options.tap) {
                                ret = options.tap.call($element, event, event.target);
                            }
    			        }, this), options.doubleTapThreshold );
    			    	
    			    } else {
                        doubleTapStartTime=null;
                        
                        //Trigger the event
                        $element.trigger('tap', [event.target]);

                        
                        //Fire the callback
                        if(options.tap) {
                            ret = options.tap.call($element, event, event.target);
                        }
	    		    }
	    		}
			}
			
			else if (gesture==DOUBLE_TAP) {
				if(phase === PHASE_CANCEL || phase === PHASE_END) {
					//Cancel any pending singletap 
				    clearTimeout(singleTapTimeout);
				    doubleTapStartTime=null;
				        
                    //Trigger the event
                    $element.trigger('doubletap', [event.target]);
                
                    //Fire the callback
                    if(options.doubleTap) {
                        ret = options.doubleTap.call($element, event, event.target);
                    }
	    		}
			}
			
			else if (gesture==LONG_TAP) {
				if(phase === PHASE_CANCEL || phase === PHASE_END) {
					//Cancel any pending singletap (shouldnt be one)
				    clearTimeout(singleTapTimeout);
				    doubleTapStartTime=null;
				        
                    //Trigger the event
                    $element.trigger('longtap', [event.target]);
                
                    //Fire the callback
                    if(options.longTap) {
                        ret = options.longTap.call($element, event, event.target);
                    }
	    		}
			}				
				
			return ret;
		}



		
		//
		// GESTURE VALIDATION
		//
		
		/**
		* Checks the user has swipe far enough
		* @return Boolean if <code>threshold</code> has been set, return true if the threshold was met, else false.
		* If no threshold was set, then we return true.
		* @inner
		*/
		function validateSwipeDistance() {
			var valid = true;
			//If we made it past the min swipe distance..
			if (options.threshold !== null) {
				valid = distance >= options.threshold;
			}
			
            return valid;
		}
		
		/**
		* Checks the user has swiped back to cancel.
		* @return Boolean if <code>cancelThreshold</code> has been set, return true if the cancelThreshold was met, else false.
		* If no cancelThreshold was set, then we return true.
		* @inner
		*/
		function didSwipeBackToCancel() {
            var cancelled = false;
    		if(options.cancelThreshold !== null && direction !==null)  {
    		    cancelled =  (getMaxDistance( direction ) - distance) >= options.cancelThreshold;
			}
			
			return cancelled;
		}

		/**
		* Checks the user has pinched far enough
		* @return Boolean if <code>pinchThreshold</code> has been set, return true if the threshold was met, else false.
		* If no threshold was set, then we return true.
		* @inner
		*/
		function validatePinchDistance() {
			if (options.pinchThreshold !== null) {
				return pinchDistance >= options.pinchThreshold;
			}
			return true;
		}

		/**
		* Checks that the time taken to swipe meets the minimum / maximum requirements
		* @return Boolean
		* @inner
		*/
		function validateSwipeTime() {
			var result;
			//If no time set, then return true

			if (options.maxTimeThreshold) {
				if (duration >= options.maxTimeThreshold) {
					result = false;
				} else {
					result = true;
				}
			}
			else {
				result = true;
			}

			return result;
		}


		/**
		* Checks direction of the swipe and the value allowPageScroll to see if we should allow or prevent the default behaviour from occurring.
		* This will essentially allow page scrolling or not when the user is swiping on a touchSwipe object.
		* @param {object} jqEvent The normalised jQuery representation of the event object.
		* @param {string} direction The direction of the event. See {@link $.fn.swipe.directions}
		* @see $.fn.swipe.directions
		* @inner
		*/
		function validateDefaultEvent(jqEvent, direction) {
			if (options.allowPageScroll === NONE || hasPinches()) {
				jqEvent.preventDefault();
			} else {
				var auto = options.allowPageScroll === AUTO;

				switch (direction) {
					case LEFT:
						if ((options.swipeLeft && auto) || (!auto && options.allowPageScroll != HORIZONTAL)) {
							jqEvent.preventDefault();
						}
						break;

					case RIGHT:
						if ((options.swipeRight && auto) || (!auto && options.allowPageScroll != HORIZONTAL)) {
							jqEvent.preventDefault();
						}
						break;

					case UP:
						if ((options.swipeUp && auto) || (!auto && options.allowPageScroll != VERTICAL)) {
							jqEvent.preventDefault();
						}
						break;

					case DOWN:
						if ((options.swipeDown && auto) || (!auto && options.allowPageScroll != VERTICAL)) {
							jqEvent.preventDefault();
						}
						break;
				}
			}

		}


		// PINCHES
		/**
		 * Returns true of the current pinch meets the thresholds
		 * @return Boolean
		 * @inner
		*/
		function validatePinch() {
		    var hasCorrectFingerCount = validateFingers();
		    var hasEndPoint = validateEndPoint();
			var hasCorrectDistance = validatePinchDistance();
			return hasCorrectFingerCount && hasEndPoint && hasCorrectDistance;
			
		}
		
		/**
		 * Returns true if any Pinch events have been registered
		 * @return Boolean
		 * @inner
		*/
		function hasPinches() {
			//Enure we dont return 0 or null for false values
			return !!(options.pinchStatus || options.pinchIn || options.pinchOut);
		}
		
		/**
		 * Returns true if we are detecting pinches, and have one
		 * @return Boolean
		 * @inner
		 */
		function didPinch() {
			//Enure we dont return 0 or null for false values
			return !!(validatePinch() && hasPinches());
		}




		// SWIPES
		/**
		 * Returns true if the current swipe meets the thresholds
		 * @return Boolean
		 * @inner
		*/
		function validateSwipe() {
			//Check validity of swipe
			var hasValidTime = validateSwipeTime();
			var hasValidDistance = validateSwipeDistance();	
			var hasCorrectFingerCount = validateFingers();
		    var hasEndPoint = validateEndPoint();
		    var didCancel = didSwipeBackToCancel();	
		    
			// if the user swiped more than the minimum length, perform the appropriate action
			// hasValidDistance is null when no distance is set 
			var valid =  !didCancel && hasEndPoint && hasCorrectFingerCount && hasValidDistance && hasValidTime;
			
			return valid;
		}
		
		/**
		 * Returns true if any Swipe events have been registered
		 * @return Boolean
		 * @inner
		*/
		function hasSwipes() {
			//Enure we dont return 0 or null for false values
			return !!(options.swipe || options.swipeStatus || options.swipeLeft || options.swipeRight || options.swipeUp || options.swipeDown);
		}
		
		
		/**
		 * Returns true if we are detecting swipes and have one
		 * @return Boolean
		 * @inner
		*/
		function didSwipe() {
			//Enure we dont return 0 or null for false values
			return !!(validateSwipe() && hasSwipes());
		}

        /**
		 * Returns true if we have matched the number of fingers we are looking for
		 * @return Boolean
		 * @inner
		*/
        function validateFingers() {
            //The number of fingers we want were matched, or on desktop we ignore
    		return ((fingerCount === options.fingers || options.fingers === ALL_FINGERS) || !SUPPORTS_TOUCH);
    	}
        
        /**
		 * Returns true if we have an end point for the swipe
		 * @return Boolean
		 * @inner
		*/
        function validateEndPoint() {
            //We have an end value for the finger
		    return fingerData[0].end.x !== 0;
        }

		// TAP / CLICK
		/**
		 * Returns true if a click / tap events have been registered
		 * @return Boolean
		 * @inner
		*/
		function hasTap() {
			//Enure we dont return 0 or null for false values
			return !!(options.tap) ;
		}
		
		/**
		 * Returns true if a double tap events have been registered
		 * @return Boolean
		 * @inner
		*/
		function hasDoubleTap() {
			//Enure we dont return 0 or null for false values
			return !!(options.doubleTap) ;
		}
		
		/**
		 * Returns true if any long tap events have been registered
		 * @return Boolean
		 * @inner
		*/
		function hasLongTap() {
			//Enure we dont return 0 or null for false values
			return !!(options.longTap) ;
		}
		
		/**
		 * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
		 * @return Boolean
		 * @inner
		*/
		function validateDoubleTap() {
		    if(doubleTapStartTime==null){
		        return false;
		    }
		    var now = getTimeStamp();
		    return (hasDoubleTap() && ((now-doubleTapStartTime) <= options.doubleTapThreshold));
		}
		
		/**
		 * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
		 * @return Boolean
		 * @inner
		*/
		function inDoubleTap() {
		    return validateDoubleTap();
		}
		
		
		/**
		 * Returns true if we have a valid tap
		 * @return Boolean
		 * @inner
		*/
		function validateTap() {
		    return ((fingerCount === 1 || !SUPPORTS_TOUCH) && (isNaN(distance) || distance === 0));
		}
		
		/**
		 * Returns true if we have a valid long tap
		 * @return Boolean
		 * @inner
		*/
		function validateLongTap() {
		    //slight threshold on moving finger
            return ((duration > options.longTapThreshold) && (distance < DOUBLE_TAP_THRESHOLD)); 
		}
		
		/**
		 * Returns true if we are detecting taps and have one
		 * @return Boolean
		 * @inner
		*/
		function didTap() {
		    //Enure we dont return 0 or null for false values
			return !!(validateTap() && hasTap());
		}
		
		
		/**
		 * Returns true if we are detecting double taps and have one
		 * @return Boolean
		 * @inner
		*/
		function didDoubleTap() {
		    //Enure we dont return 0 or null for false values
			return !!(validateDoubleTap() && hasDoubleTap());
		}
		
		/**
		 * Returns true if we are detecting long taps and have one
		 * @return Boolean
		 * @inner
		*/
		function didLongTap() {
		    //Enure we dont return 0 or null for false values
			return !!(validateLongTap() && hasLongTap());
		}
		
		
		
		
		// MULTI FINGER TOUCH
		/**
		 * Starts tracking the time between 2 finger releases, and keeps track of how many fingers we initially had up
		 * @inner
		*/
		function startMultiFingerRelease() {
			previousTouchEndTime = getTimeStamp();
			previousTouchFingerCount = event.touches.length+1;
		}
		
		/**
		 * Cancels the tracking of time between 2 finger releases, and resets counters
		 * @inner
		*/
		function cancelMultiFingerRelease() {
			previousTouchEndTime = 0;
			previousTouchFingerCount = 0;
		}
		
		/**
		 * Checks if we are in the threshold between 2 fingers being released 
		 * @return Boolean
		 * @inner
		*/
		function inMultiFingerRelease() {
			
			var withinThreshold = false;
			
			if(previousTouchEndTime) {	
				var diff = getTimeStamp() - previousTouchEndTime	
				if( diff<=options.fingerReleaseThreshold ) {
					withinThreshold = true;
				}
			}
			
			return withinThreshold;	
		}
		

		/**
		* gets a data flag to indicate that a touch is in progress
		* @return Boolean
		* @inner
		*/
		function getTouchInProgress() {
			//strict equality to ensure only true and false are returned
			return !!($element.data(PLUGIN_NS+'_intouch') === true);
		}
		
		/**
		* Sets a data flag to indicate that a touch is in progress
		* @param {boolean} val The value to set the property to
		* @inner
		*/
		function setTouchInProgress(val) {
			
			//Add or remove event listeners depending on touch status
			if(val===true) {
				$element.bind(MOVE_EV, touchMove);
				$element.bind(END_EV, touchEnd);
				
				//we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
				if(LEAVE_EV) { 
					$element.bind(LEAVE_EV, touchLeave);
				}
			} else {
				$element.unbind(MOVE_EV, touchMove, false);
				$element.unbind(END_EV, touchEnd, false);
			
				//we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
				if(LEAVE_EV) { 
					$element.unbind(LEAVE_EV, touchLeave, false);
				}
			}
			
		
			//strict equality to ensure only true and false can update the value
			$element.data(PLUGIN_NS+'_intouch', val === true);
		}
		
		
		/**
		 * Creates the finger data for the touch/finger in the event object.
		 * @param {int} index The index in the array to store the finger data (usually the order the fingers were pressed)
		 * @param {object} evt The event object containing finger data
		 * @return finger data object
		 * @inner
		*/
		function createFingerData( index, evt ) {
			var id = evt.identifier!==undefined ? evt.identifier : 0; 
			
			fingerData[index].identifier = id;
			fingerData[index].start.x = fingerData[index].end.x = evt.pageX||evt.clientX;
			fingerData[index].start.y = fingerData[index].end.y = evt.pageY||evt.clientY;
			
			return fingerData[index];
		}
		
		/**
		 * Updates the finger data for a particular event object
		 * @param {object} evt The event object containing the touch/finger data to upadte
		 * @return a finger data object.
		 * @inner
		*/
		function updateFingerData(evt) {
			
			var id = evt.identifier!==undefined ? evt.identifier : 0; 
			var f = getFingerData( id );
			
			f.end.x = evt.pageX||evt.clientX;
			f.end.y = evt.pageY||evt.clientY;
			
			return f;
		}
		
		/**
		 * Returns a finger data object by its event ID.
		 * Each touch event has an identifier property, which is used 
		 * to track repeat touches
		 * @param {int} id The unique id of the finger in the sequence of touch events.
		 * @return a finger data object.
		 * @inner
		*/
		function getFingerData( id ) {
			for(var i=0; i<fingerData.length; i++) {
				if(fingerData[i].identifier == id) {
					return fingerData[i];	
				}
			}
		}
		
		/**
		 * Creats all the finger onjects and returns an array of finger data
		 * @return Array of finger objects
		 * @inner
		*/
		function createAllFingerData() {
			var fingerData=[];
			for (var i=0; i<=5; i++) {
				fingerData.push({
					start:{ x: 0, y: 0 },
					end:{ x: 0, y: 0 },
					identifier:0
				});
			}
			
			return fingerData;
		}
		
		/**
		 * Sets the maximum distance swiped in the given direction. 
		 * If the new value is lower than the current value, the max value is not changed.
		 * @param {string}  direction The direction of the swipe
		 * @param {int}  distance The distance of the swipe
		 * @inner
		*/
		function setMaxDistance(direction, distance) {
    		distance = Math.max(distance, getMaxDistance(direction) );
    		maximumsMap[direction].distance = distance;
		}
        
        /**
		 * gets the maximum distance swiped in the given direction. 
		 * @param {string}  direction The direction of the swipe
		 * @return int  The distance of the swipe
		 * @inner
		*/        
        function getMaxDistance(direction) {
            return maximumsMap[direction].distance;
        }
		
		/**
		 * Creats a map of directions to maximum swiped values.
		 * @return Object A dictionary of maximum values, indexed by direction.
		 * @inner
		*/
		function createMaximumsData() {
			var maxData={};
			maxData[LEFT]=createMaximumVO(LEFT);
			maxData[RIGHT]=createMaximumVO(RIGHT);
			maxData[UP]=createMaximumVO(UP);
			maxData[DOWN]=createMaximumVO(DOWN);
			
			return maxData;
		}
		
		/**
		 * Creates a map maximum swiped values for a given swipe direction
		 * @param {string} The direction that these values will be associated with
		 * @return Object Maximum values
		 * @inner
		*/
		function createMaximumVO(dir) {
		    return { 
		        direction:dir, 
		        distance:0
		    }
		}
		
		
		//
		// MATHS / UTILS
		//

		/**
		* Calculate the duration of the swipe
		* @return int
		* @inner
		*/
		function calculateDuration() {
			return endTime - startTime;
		}
		
		/**
		* Calculate the distance between 2 touches (pinch)
		* @param {point} startPoint A point object containing x and y co-ordinates
	    * @param {point} endPoint A point object containing x and y co-ordinates
	    * @return int;
		* @inner
		*/
		function calculateTouchesDistance(startPoint, endPoint) {
			var diffX = Math.abs(startPoint.x - endPoint.x);
			var diffY = Math.abs(startPoint.y - endPoint.y);
				
			return Math.round(Math.sqrt(diffX*diffX+diffY*diffY));
		}
		
		/**
		* Calculate the zoom factor between the start and end distances
		* @param {int} startDistance Distance (between 2 fingers) the user started pinching at
	    * @param {int} endDistance Distance (between 2 fingers) the user ended pinching at
	    * @return float The zoom value from 0 to 1.
		* @inner
		*/
		function calculatePinchZoom(startDistance, endDistance) {
			var percent = (endDistance/startDistance) * 1;
			return percent.toFixed(2);
		}
		
		
		/**
		* Returns the pinch direction, either IN or OUT for the given points
		* @return string Either {@link $.fn.swipe.directions.IN} or {@link $.fn.swipe.directions.OUT}
		* @see $.fn.swipe.directions
		* @inner
		*/
		function calculatePinchDirection() {
			if(pinchZoom<1) {
				return OUT;
			}
			else {
				return IN;
			}
		}
		
		
		/**
		* Calculate the length / distance of the swipe
		* @param {point} startPoint A point object containing x and y co-ordinates
	    * @param {point} endPoint A point object containing x and y co-ordinates
	    * @return int
		* @inner
		*/
		function calculateDistance(startPoint, endPoint) {
			return Math.round(Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2)));
		}

		/**
		* Calculate the angle of the swipe
		* @param {point} startPoint A point object containing x and y co-ordinates
	    * @param {point} endPoint A point object containing x and y co-ordinates
	    * @return int
		* @inner
		*/
		function calculateAngle(startPoint, endPoint) {
			var x = startPoint.x - endPoint.x;
			var y = endPoint.y - startPoint.y;
			var r = Math.atan2(y, x); //radians
			var angle = Math.round(r * 180 / Math.PI); //degrees

			//ensure value is positive
			if (angle < 0) {
				angle = 360 - Math.abs(angle);
			}

			return angle;
		}

		/**
		* Calculate the direction of the swipe
		* This will also call calculateAngle to get the latest angle of swipe
		* @param {point} startPoint A point object containing x and y co-ordinates
	    * @param {point} endPoint A point object containing x and y co-ordinates
	    * @return string Either {@link $.fn.swipe.directions.LEFT} / {@link $.fn.swipe.directions.RIGHT} / {@link $.fn.swipe.directions.DOWN} / {@link $.fn.swipe.directions.UP}
		* @see $.fn.swipe.directions
		* @inner
		*/
		function calculateDirection(startPoint, endPoint ) {
			var angle = calculateAngle(startPoint, endPoint);

			if ((angle <= 45) && (angle >= 0)) {
				return LEFT;
			} else if ((angle <= 360) && (angle >= 315)) {
				return LEFT;
			} else if ((angle >= 135) && (angle <= 225)) {
				return RIGHT;
			} else if ((angle > 45) && (angle < 135)) {
				return DOWN;
			} else {
				return UP;
			}
		}
		

		/**
		* Returns a MS time stamp of the current time
		* @return int
		* @inner
		*/
		function getTimeStamp() {
			var now = new Date();
			return now.getTime();
		}
		
		
		
		/**
		 * Returns a bounds object with left, right, top and bottom properties for the element specified.
		 * @param {DomNode} The DOM node to get the bounds for.
		 */
		function getbounds( el ) {
			el = $(el);
			var offset = el.offset();
			
			var bounds = {	
					left:offset.left,
					right:offset.left+el.outerWidth(),
					top:offset.top,
					bottom:offset.top+el.outerHeight()
					}
			
			return bounds;	
		}
		
		
		/**
		 * Checks if the point object is in the bounds object.
		 * @param {object} point A point object.
		 * @param {int} point.x The x value of the point.
		 * @param {int} point.y The x value of the point.
		 * @param {object} bounds The bounds object to test
		 * @param {int} bounds.left The leftmost value
		 * @param {int} bounds.right The righttmost value
		 * @param {int} bounds.top The topmost value
		* @param {int} bounds.bottom The bottommost value
		 */
		function isInBounds(point, bounds) {
			return (point.x > bounds.left && point.x < bounds.right && point.y > bounds.top && point.y < bounds.bottom);
		};
	
	
	}
	
	


/**
 * A catch all handler that is triggered for all swipe directions. 
 * @name $.fn.swipe#swipe
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
 * @param {int} distance The distance the user swiped
 * @param {int} duration The duration of the swipe in milliseconds
 * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
 */
 



/**
 * A handler that is triggered for "left" swipes.
 * @name $.fn.swipe#swipeLeft
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
 * @param {int} distance The distance the user swiped
 * @param {int} duration The duration of the swipe in milliseconds
 * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
 */
 
/**
 * A handler that is triggered for "right" swipes.
 * @name $.fn.swipe#swipeRight
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
 * @param {int} distance The distance the user swiped
 * @param {int} duration The duration of the swipe in milliseconds
 * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
 */

/**
 * A handler that is triggered for "up" swipes.
 * @name $.fn.swipe#swipeUp
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
 * @param {int} distance The distance the user swiped
 * @param {int} duration The duration of the swipe in milliseconds
 * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
 */
 
/**
 * A handler that is triggered for "down" swipes.
 * @name $.fn.swipe#swipeDown
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {int} direction The direction the user swiped in. See {@link $.fn.swipe.directions}
 * @param {int} distance The distance the user swiped
 * @param {int} duration The duration of the swipe in milliseconds
 * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
 */
 
/**
 * A handler triggered for every phase of the swipe. This handler is constantly fired for the duration of the pinch.
 * This is triggered regardless of swipe thresholds.
 * @name $.fn.swipe#swipeStatus
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {string} phase The phase of the swipe event. See {@link $.fn.swipe.phases}
 * @param {string} direction The direction the user swiped in. This is null if the user has yet to move. See {@link $.fn.swipe.directions}
 * @param {int} distance The distance the user swiped. This is 0 if the user has yet to move.
 * @param {int} duration The duration of the swipe in milliseconds
 * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
 */
 
/**
 * A handler triggered for pinch in events.
 * @name $.fn.swipe#pinchIn
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {int} direction The direction the user pinched in. See {@link $.fn.swipe.directions}
 * @param {int} distance The distance the user pinched
 * @param {int} duration The duration of the swipe in milliseconds
 * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
 * @param {int} zoom The zoom/scale level the user pinched too, 0-1.
 */

/**
 * A handler triggered for pinch out events.
 * @name $.fn.swipe#pinchOut
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {int} direction The direction the user pinched in. See {@link $.fn.swipe.directions}
 * @param {int} distance The distance the user pinched
 * @param {int} duration The duration of the swipe in milliseconds
 * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
 * @param {int} zoom The zoom/scale level the user pinched too, 0-1.
 */ 

/**
 * A handler triggered for all pinch events. This handler is constantly fired for the duration of the pinch. This is triggered regardless of thresholds.
 * @name $.fn.swipe#pinchStatus
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {int} direction The direction the user pinched in. See {@link $.fn.swipe.directions}
 * @param {int} distance The distance the user pinched
 * @param {int} duration The duration of the swipe in milliseconds
 * @param {int} fingerCount The number of fingers used. See {@link $.fn.swipe.fingers}
 * @param {int} zoom The zoom/scale level the user pinched too, 0-1.
 */

/**
 * A click handler triggered when a user simply clicks, rather than swipes on an element.
 * This is deprecated since version 1.6.2, any assignment to click will be assigned to the tap handler.
 * You cannot use <code>on</code> to bind to this event as the default jQ <code>click</code> event will be triggered.
 * Use the <code>tap</code> event instead.
 * @name $.fn.swipe#click
 * @event
 * @deprecated since version 1.6.2, please use {@link $.fn.swipe#tap} instead 
 * @default null
 * @param {EventObject} event The original event object
 * @param {DomObject} target The element clicked on.
 */
 
 /**
 * A click / tap handler triggered when a user simply clicks or taps, rather than swipes on an element.
 * @name $.fn.swipe#tap
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {DomObject} target The element clicked on.
 */
 
/**
 * A double tap handler triggered when a user double clicks or taps on an element.
 * You can set the time delay for a double tap with the {@link $.fn.swipe.defaults#doubleTapThreshold} property. 
 * Note: If you set both <code>doubleTap</code> and <code>tap</code> handlers, the <code>tap</code> event will be delayed by the <code>doubleTapThreshold</code>
 * as the script needs to check if its a double tap.
 * @name $.fn.swipe#doubleTap
 * @see  $.fn.swipe.defaults#doubleTapThreshold
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {DomObject} target The element clicked on.
 */
 
 /**
 * A long tap handler triggered when a user long clicks or taps on an element.
 * You can set the time delay for a long tap with the {@link $.fn.swipe.defaults#longTapThreshold} property. 
 * @name $.fn.swipe#longTap
 * @see  $.fn.swipe.defaults#longTapThreshold
 * @event
 * @default null
 * @param {EventObject} event The original event object
 * @param {DomObject} target The element clicked on.
 */

})(jQuery);


/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Browser = __webpack_require__(39),
        $ = __webpack_require__(4);

    // Constants
    var MAX_POSITION_DELTA = 10,
        // Maximum distance between start and end touches for it to be a tap, in pixels
    MAX_TIME_DELTA = 400,
        // Maximum time between start and end touches for it to be a tap, in milliseconds
    EVENT_NAME = "activate";

    /**
     * Extends jQuery to support a "tap" event. A tap is a touch that is quick and doesn't swipe beyond a certain
     * threshold.
     *
     * The name "activate" represents either a click event on desktop or a tap event on mobile. this is to avoid
     * both tap and click are triggered sometimes in IOS8. see bug MOS-1671.
     *
     *@example
     * $("selector").on("activate", function () {
     *      // handle me...
     * });
     *
     * @class Activate
     * @author Bruce Mackenzie Nielsen
     * @author Yijie Li
     */
    $.event.special[EVENT_NAME] = {

        setup: function setup() {
            var $this = $(this);

            // Setup click detection if needed
            if (Browser.capabilities.isClicksSupported) {
                $this.on("click." + EVENT_NAME, function (event) {
                    // Some devices fire both touch and mouse events, in order to avoid triggering
                    // "activate" twice, we enforce that a click event cannot occur less than 500
                    // milliseconds from a tap event
                    var timeSinceLastTap = Date.now() - this.tapTimestamp;

                    if (timeSinceLastTap < 500) {
                        return;
                    }

                    event.type = EVENT_NAME;
                    ($.event.dispatch || $.event.handle).call(this, event);
                });
            }

            // Setup tap detection if needed
            if (Browser.capabilities.isTouchSupported) {
                $this.on("touchstart." + EVENT_NAME, function (event) {
                    // Multiple touches are not considered a tap
                    if (event.originalEvent.touches.length > 1) {
                        this.currentTouch = null;

                        return;
                    }

                    // Don't bother if there's already a touch in progress
                    if (this.currentTouch) {
                        return;
                    }

                    // Grab the initial values and store
                    var touch = event.originalEvent.touches[0];

                    this.currentTouch = {
                        startTime: Date.now(),
                        target: event.target,
                        x: touch.screenX,
                        y: touch.screenY
                    };
                });

                $this.on("touchend." + EVENT_NAME, function (event) {
                    // Reset state for next tap
                    var startValues = this.currentTouch;
                    this.currentTouch = null;

                    // Cancelled touch
                    if (!startValues) {
                        return;
                    }

                    // Check the time delta
                    if (Date.now() - startValues.startTime > MAX_TIME_DELTA) {
                        return;
                    }

                    // Check the position deltas
                    var touch = event.originalEvent.changedTouches[0],
                        xDelta = Math.abs(touch.screenX - startValues.x),
                        yDelta = Math.abs(touch.screenY - startValues.y);

                    if (xDelta > MAX_POSITION_DELTA || yDelta > MAX_POSITION_DELTA) {
                        return;
                    }

                    event.type = EVENT_NAME;

                    // Keep track of when a tap occurred (used for sanity checking the click handler)
                    this.tapTimestamp = Date.now();

                    ($.event.dispatch || $.event.handle).call(this, event);
                    event.preventDefault();
                });

                $this.on("touchcancel." + EVENT_NAME, function () {
                    // Reset state for next tap
                    this.currentTouch = null;
                });
            }
        },

        teardown: function teardown() {
            $(this).unbind("." + EVENT_NAME);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/**
 * Contains/loads the jQuery plugins used only by the editor application.
 */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);

    var _require = __webpack_require__(1),
        debounce = _require.debounce;

    /**
     * Third party jquery extensions.
     */


    __webpack_require__(2754);
    __webpack_require__(2755);
    __webpack_require__(2756);
    __webpack_require__(2757);
    __webpack_require__(2758);
    __webpack_require__(2759);

    /**
     * Addding destroyed event to support handling callbacks
     * when an element is removed from the DOM.
     */
    if (typeof $.event.special.destroyed === "undefined") {
        $.event.special.destroyed = {
            remove: function remove(o) {
                if (o.handler) {
                    o.handler();
                }
            }
        };
    }

    /**
     * Scroll it into view, when a collapsible element is shown.
     */
    $(document).on("shown.bs.collapse", function (e) {
        return $(e.target).scrollintoview();
    });

    /**
     * Select the inputs elements in the first click and in the second click allow the cursor to be in the right character.
     */
    var lastSelectedElement = null;
    $(document).on("mouseup", "input", function (event) {
        var type = event.target.type;

        // check if the element selected has changed
        if (event.target !== lastSelectedElement && type !== "range") {
            // Select the element
            event.target.select();
            // Save the last element
            lastSelectedElement = event.target;
            // The prevent default is important to assure the focus on the click action.
            // Otherwise, some times it will not select everything.
            event.preventDefault();
        }
    });

    /**
     * Enables adding functionality to the draghover event.
     *
     * @param  {Function} dragenterCallback Callback to be invoked when the element triggers
     *                                      the <tt>dragenter</tt> event.
     *
     * @param  {Function} dragleaveCallback Callback to be invoked on <tt>dragover</tt>.
     * @return {jQuery} The jQuery object, by convention, to make it chainable.
     */
    $.fn.draghover = function (dragenterCallback, dragleaveCallback) {
        return this.each(function () {
            var $this = $(this);
            var isEntered = false;

            $this.on("dragenter", function () {
                if (!isEntered) {
                    isEntered = true;
                    dragenterCallback();
                }
            });

            $this.on("dragover", debounce(function () {
                isEntered = false;
                dragleaveCallback();
            }, 100));
        });
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/*!
 * jQuery scrollintoview() plugin and :scrollable selector filter
 *
 * Version 1.9.4 (06 April 2016)
 * Requires jQuery 1.4 or newer
 *
 * Copyright (c) 2011 Robert Koritnik
 * Licensed under the terms of the MIT license
 * http://www.opensource.org/licenses/mit-license.php
 */

!function(root, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        factory(require('jquery'));
    } else {
        factory(root.jQuery);
    }
}
(this, function($) {
    var converter = {
        vertical: { x: false, y: true },
        horizontal: { x: true, y: false },
        both: { x: true, y: true },
        x: { x: true, y: false },
        y: { x: false, y: true }
    };

    var settings = {
        duration: "fast",
        direction: "both",
        viewPadding: 0
    };

    var rootrx = /^(?:html)$/i;

    // gets border dimensions
    var borders = function(domElement, styles) {
        styles = styles || (document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(domElement, null) : domElement.currentStyle);
        var px = document.defaultView && document.defaultView.getComputedStyle ? true : false;
        var b = {
            top: (parseFloat(px ? styles.borderTopWidth : $.css(domElement, "borderTopWidth")) || 0),
            left: (parseFloat(px ? styles.borderLeftWidth : $.css(domElement, "borderLeftWidth")) || 0),
            bottom: (parseFloat(px ? styles.borderBottomWidth : $.css(domElement, "borderBottomWidth")) || 0),
            right: (parseFloat(px ? styles.borderRightWidth : $.css(domElement, "borderRightWidth")) || 0)
        };
        return {
            top: b.top,
            left: b.left,
            bottom: b.bottom,
            right: b.right,
            vertical: b.top + b.bottom,
            horizontal: b.left + b.right
        };
    };

    var dimensions = function($element) {
        var elem = $element[0],
            isRoot = rootrx.test(elem.nodeName),
            $elem = isRoot ? $(window) : $element;
        return {
            border: isRoot ? { top: 0, left: 0, bottom: 0, right: 0 } : borders(elem),
            scroll: {
                top: $elem.scrollTop(),
                left: $elem.scrollLeft(),
                maxtop: elem.scrollHeight - elem.clientHeight,
                maxleft: elem.scrollWidth - elem.clientWidth
            },
            scrollbar: isRoot
                ? { right: 0, bottom: 0 }
                : {
                    right: $elem.innerWidth() - elem.clientWidth,
                    bottom: $elem.innerHeight() - elem.clientHeight
                },
            rect: isRoot ? { top: 0, left: 0, bottom: elem.clientHeight, right: elem.clientWidth } : elem.getBoundingClientRect()
        };
    };

    $.fn.extend({
        scrollintoview: function(options) {
            /// <summary>Scrolls the first element in the set into view by scrolling its closest scrollable parent.</summary>
            /// <param name="options" type="Object">Additional options that can configure scrolling:
            ///        duration (default: "fast") - jQuery animation speed (can be a duration string or number of milliseconds)
            ///        direction (default: "both") - select possible scrollings ("vertical" or "y", "horizontal" or "x", "both")
            ///        complete (default: none) - a function to call when scrolling completes (called in context of the DOM element being scrolled)
            /// </param>
            /// <return type="jQuery">Returns the same jQuery set that this function was run on.</return>

            options = $.extend({}, settings, options);
            options.direction = converter[typeof (options.direction) === "string" && options.direction.toLowerCase()] || converter.both;

            if (typeof options.viewPadding == "number") {
                options.viewPadding = { x: options.viewPadding, y: options.viewPadding };
            } else if (typeof options.viewPadding == "object") {
                if (options.viewPadding.x == undefined) {
                    options.viewPadding.x = 0;
                }
                if (options.viewPadding.y == undefined) {
                    options.viewPadding.y = 0;
                }
            }

            var dirStr = "";
            if (options.direction.x === true) dirStr = "horizontal";
            if (options.direction.y === true) dirStr = dirStr ? "both" : "vertical";

            var el = this.eq(0);
            var scroller = el.parent().closest(":scrollable(" + dirStr + ")");

            // check if there's anything to scroll in the first place
            if (scroller.length > 0) {
                scroller = scroller.eq(0);

                var dim = {
                    e: dimensions(el),
                    s: dimensions(scroller)
                };

                var rel = {
                    top: dim.e.rect.top - (dim.s.rect.top + dim.s.border.top),
                    bottom: dim.s.rect.bottom - dim.s.border.bottom - dim.s.scrollbar.bottom - dim.e.rect.bottom,
                    left: dim.e.rect.left - (dim.s.rect.left + dim.s.border.left),
                    right: dim.s.rect.right - dim.s.border.right - dim.s.scrollbar.right - dim.e.rect.right
                };

                var animProperties = {};

                // vertical scroll
                if (options.direction.y === true) {
                    if (rel.top < 0) {
                        animProperties.scrollTop = Math.max(0, dim.s.scroll.top + rel.top - options.viewPadding.y);
                    } else if (rel.top > 0 && rel.bottom < 0) {
                        animProperties.scrollTop = Math.min(dim.s.scroll.top + Math.min(rel.top, -rel.bottom) + options.viewPadding.y, dim.s.scroll.maxtop);
                    }
                }

                // horizontal scroll
                if (options.direction.x === true) {
                    if (rel.left < 0) {
                        animProperties.scrollLeft = Math.max(0, dim.s.scroll.left + rel.left - options.viewPadding.x);
                    } else if (rel.left > 0 && rel.right < 0) {
                        animProperties.scrollLeft = Math.min(dim.s.scroll.left + Math.min(rel.left, -rel.right) + options.viewPadding.x, dim.s.scroll.maxleft);
                    }
                }

                // scroll if needed
                if (!$.isEmptyObject(animProperties)) {
                    var scrollExpect = {},
                        scrollListener = scroller;

                    if (rootrx.test(scroller[0].nodeName)) {
                        scroller = $("html,body");
                        scrollListener = $(window);
                    }

                    function animateStep(now, tween) {
                        scrollExpect[tween.prop] = Math.floor(now);
                    };

                    function onscroll(event) {
                        $.each(scrollExpect, function(key, value) {
                            if (Math.floor(scrollListener[key]()) != Math.floor(value)) {
                                options.complete = null; // don't run complete function if the scrolling was interrupted
                                scroller.stop('scrollintoview');
                            }
                        });
                    }

                    scrollListener.on('scroll', onscroll);

                    scroller
                        .stop('scrollintoview')
                        .animate(animProperties, { duration: options.duration, step: animateStep, queue: 'scrollintoview' })
                        .eq(0) // we want function to be called just once (ref. "html,body")
                        .queue('scrollintoview', function(next) {
                            scrollListener.off('scroll', onscroll);
                            $.isFunction(options.complete) && options.complete.call(scroller[0]);
                            next();
                        })

                    scroller.dequeue('scrollintoview');
                } else {
                    // when there's nothing to scroll, just call the "complete" function
                    $.isFunction(options.complete) && options.complete.call(scroller[0]);
                }
            }

            // return set back
            return this;
        }
    });

    var scrollValue = {
        auto: true,
        scroll: true,
        visible: false,
        hidden: false
    };

    var scroll = function(element, direction) {
        direction = converter[typeof (direction) === "string" && direction.toLowerCase()] || converter.both;
        var styles = (document.defaultView && document.defaultView.getComputedStyle ? document.defaultView.getComputedStyle(element, null) : element.currentStyle);
        var overflow = {
            x: scrollValue[styles.overflowX.toLowerCase()] || false,
            y: scrollValue[styles.overflowY.toLowerCase()] || false,
            isRoot: rootrx.test(element.nodeName)
        };

        // check if completely unscrollable (exclude HTML element because it's special)
        if (!overflow.x && !overflow.y && !overflow.isRoot) {
            return false;
        }

        var size = {
            height: {
                scroll: element.scrollHeight,
                client: element.clientHeight
            },
            width: {
                scroll: element.scrollWidth,
                client: element.clientWidth
            },
            // check overflow.x/y because iPad (and possibly other tablets) don't dislay scrollbars
            scrollableX: function() {
                return (overflow.x || overflow.isRoot) && this.width.scroll > this.width.client;
            },
            scrollableY: function() {
                return (overflow.y || overflow.isRoot) && this.height.scroll > this.height.client;
            }
        };
        return direction.y && size.scrollableY() || direction.x && size.scrollableX();
    };

    $.expr[":"].scrollable = $.expr.createPseudo(function(direction) {
        return function(element) {
            return scroll(element, direction);
        };
    });
});



/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * jQuery contextMenu v2.5.0 - Plugin for simple contextMenu handling
 *
 * Version: v2.5.0
 *
 * Authors: Björn Brala (SWIS.nl), Rodney Rehm, Addy Osmani (patches for FF)
 * Web: http://swisnl.github.io/jQuery-contextMenu/
 *
 * Copyright (c) 2011-2017 SWIS BV and contributors
 *
 * Licensed under
 *   MIT License http://www.opensource.org/licenses/mit-license
 *
 * Date: 2017-05-25T11:30:28.900Z
 */

// jscs:disable
/* jshint ignore:start */
(function (factory) {
    if (true) {
        // AMD. Register as anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node / CommonJS
        factory(require('jquery'));
    } else {
        // Browser globals.
        factory(jQuery);
    }
})(function ($) {

    'use strict';

    // TODO: -
    // ARIA stuff: menuitem, menuitemcheckbox und menuitemradio
    // create <menu> structure if $.support[htmlCommand || htmlMenuitem] and !opt.disableNative

    // determine html5 compatibility
    $.support.htmlMenuitem = ('HTMLMenuItemElement' in window);
    $.support.htmlCommand = ('HTMLCommandElement' in window);
    $.support.eventSelectstart = ('onselectstart' in document.documentElement);
    /* // should the need arise, test for css user-select
     $.support.cssUserSelect = (function(){
     var t = false,
     e = document.createElement('div');

     $.each('Moz|Webkit|Khtml|O|ms|Icab|'.split('|'), function(i, prefix) {
     var propCC = prefix + (prefix ? 'U' : 'u') + 'serSelect',
     prop = (prefix ? ('-' + prefix.toLowerCase() + '-') : '') + 'user-select';

     e.style.cssText = prop + ': text;';
     if (e.style[propCC] == 'text') {
     t = true;
     return false;
     }

     return true;
     });

     return t;
     })();
     */


    if (!$.ui || !$.widget) {
        // duck punch $.cleanData like jQueryUI does to get that remove event
        $.cleanData = (function (orig) {
            return function (elems) {
                var events, elem, i;
                for (i = 0; elems[i] != null; i++) {
                    elem = elems[i];
                    try {
                        // Only trigger remove when necessary to save time
                        events = $._data(elem, 'events');
                        if (events && events.remove) {
                            $(elem).triggerHandler('remove');
                        }

                        // Http://bugs.jquery.com/ticket/8235
                    } catch (e) {
                    }
                }
                orig(elems);
            };
        })($.cleanData);
    }
    /* jshint ignore:end */
    // jscs:enable

    var // currently active contextMenu trigger
        $currentTrigger = null,
        // is contextMenu initialized with at least one menu?
        initialized = false,
        // window handle
        $win = $(window),
        // number of registered menus
        counter = 0,
        // mapping selector to namespace
        namespaces = {},
        // mapping namespace to options
        menus = {},
        // custom command type handlers
        types = {},
        // default values
        defaults = {
            // selector of contextMenu trigger
            selector: null,
            // where to append the menu to
            appendTo: null,
            // method to trigger context menu ["right", "left", "hover"]
            trigger: 'right',
            // hide menu when mouse leaves trigger / menu elements
            autoHide: false,
            // ms to wait before showing a hover-triggered context menu
            delay: 200,
            // flag denoting if a second trigger should simply move (true) or rebuild (false) an open menu
            // as long as the trigger happened on one of the trigger-element's child nodes
            reposition: true,

            //ability to select submenu
            selectableSubMenu: false,

            // Default classname configuration to be able avoid conflicts in frameworks
            classNames: {
                hover: 'context-menu-hover', // Item hover
                disabled: 'context-menu-disabled', // Item disabled
                visible: 'context-menu-visible', // Item visible
                notSelectable: 'context-menu-not-selectable', // Item not selectable

                icon: 'context-menu-icon',
                iconEdit: 'context-menu-icon-edit',
                iconCut: 'context-menu-icon-cut',
                iconCopy: 'context-menu-icon-copy',
                iconPaste: 'context-menu-icon-paste',
                iconDelete: 'context-menu-icon-delete',
                iconAdd: 'context-menu-icon-add',
                iconQuit: 'context-menu-icon-quit',
                iconLoadingClass: 'context-menu-icon-loading'
            },

            // determine position to show menu at
            determinePosition: function ($menu) {
                // position to the lower middle of the trigger element
                if ($.ui && $.ui.position) {
                    // .position() is provided as a jQuery UI utility
                    // (...and it won't work on hidden elements)
                    $menu.css('display', 'block').position({
                        my: 'center top',
                        at: 'center bottom',
                        of: this,
                        offset: '0 5',
                        collision: 'fit'
                    }).css('display', 'none');
                } else {
                    // determine contextMenu position
                    var offset = this.offset();
                    offset.top += this.outerHeight();
                    offset.left += this.outerWidth() / 2 - $menu.outerWidth() / 2;
                    $menu.css(offset);
                }
            },
            // position menu
            position: function (opt, x, y) {
                var offset;
                // determine contextMenu position
                if (!x && !y) {
                    opt.determinePosition.call(this, opt.$menu);
                    return;
                } else if (x === 'maintain' && y === 'maintain') {
                    // x and y must not be changed (after re-show on command click)
                    offset = opt.$menu.position();
                } else {
                    // x and y are given (by mouse event)
                    var offsetParentOffset = opt.$menu.offsetParent().offset();
                    offset = {top: y - offsetParentOffset.top, left: x -offsetParentOffset.left};
                }

                // correct offset if viewport demands it
                var bottom = $win.scrollTop() + $win.height(),
                    right = $win.scrollLeft() + $win.width(),
                    height = opt.$menu.outerHeight(),
                    width = opt.$menu.outerWidth();

                if (offset.top + height > bottom) {
                    offset.top -= height;
                }

                if (offset.top < 0) {
                    offset.top = 0;
                }

                if (offset.left + width > right) {
                    offset.left -= width;
                }

                if (offset.left < 0) {
                    offset.left = 0;
                }

                opt.$menu.css(offset);
            },
            // position the sub-menu
            positionSubmenu: function ($menu) {
                if (typeof $menu === 'undefined') {
                    // When user hovers over item (which has sub items) handle.focusItem will call this.
                    // but the submenu does not exist yet if opt.items is a promise. just return, will
                    // call positionSubmenu after promise is completed.
                    return;
                }
                if ($.ui && $.ui.position) {
                    // .position() is provided as a jQuery UI utility
                    // (...and it won't work on hidden elements)
                    $menu.css('display', 'block').position({
                        my: 'left top-5',
                        at: 'right top',
                        of: this,
                        collision: 'flipfit fit'
                    }).css('display', '');
                } else {
                    // determine contextMenu position
                    var offset = {
                        top: -9,
                        left: this.outerWidth() - 5
                    };
                    $menu.css(offset);
                }
            },
            // offset to add to zIndex
            zIndex: 1,
            // show hide animation settings
            animation: {
                duration: 50,
                show: 'slideDown',
                hide: 'slideUp'
            },
            // events
            events: {
                show: $.noop,
                hide: $.noop
            },
            // default callback
            callback: null,
            // list of contextMenu items
            items: {}
        },
        // mouse position for hover activation
        hoveract = {
            timer: null,
            pageX: null,
            pageY: null
        },
        // determine zIndex
        zindex = function ($t) {
            var zin = 0,
                $tt = $t;

            while (true) {
                zin = Math.max(zin, parseInt($tt.css('z-index'), 10) || 0);
                $tt = $tt.parent();
                if (!$tt || !$tt.length || 'html body'.indexOf($tt.prop('nodeName').toLowerCase()) > -1) {
                    break;
                }
            }
            return zin;
        },
        // event handlers
        handle = {
            // abort anything
            abortevent: function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
            },
            // contextmenu show dispatcher
            contextmenu: function (e) {
                var $this = $(this);

                // disable actual context-menu if we are using the right mouse button as the trigger
                if (e.data.trigger === 'right') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }

                // abort native-triggered events unless we're triggering on right click
                if ((e.data.trigger !== 'right' && e.data.trigger !== 'demand') && e.originalEvent) {
                    return;
                }

                // Let the current contextmenu decide if it should show or not based on its own trigger settings
                if (typeof e.mouseButton !== 'undefined' && e.data) {
                    if (!(e.data.trigger === 'left' && e.mouseButton === 0) && !(e.data.trigger === 'right' && e.mouseButton === 2)) {
                        // Mouse click is not valid.
                        return;
                    }
                }

                // abort event if menu is visible for this trigger
                if ($this.hasClass('context-menu-active')) {
                    return;
                }

                if (!$this.hasClass('context-menu-disabled')) {
                    // theoretically need to fire a show event at <menu>
                    // http://www.whatwg.org/specs/web-apps/current-work/multipage/interactive-elements.html#context-menus
                    // var evt = jQuery.Event("show", { data: data, pageX: e.pageX, pageY: e.pageY, relatedTarget: this });
                    // e.data.$menu.trigger(evt);

                    $currentTrigger = $this;
                    if (e.data.build) {
                        var built = e.data.build($currentTrigger, e);
                        // abort if build() returned false
                        if (built === false) {
                            return;
                        }

                        // dynamically build menu on invocation
                        e.data = $.extend(true, {}, defaults, e.data, built || {});

                        // abort if there are no items to display
                        if (!e.data.items || $.isEmptyObject(e.data.items)) {
                            // Note: jQuery captures and ignores errors from event handlers
                            if (window.console) {
                                (console.error || console.log).call(console, 'No items specified to show in contextMenu');
                            }

                            throw new Error('No Items specified');
                        }

                        // backreference for custom command type creation
                        e.data.$trigger = $currentTrigger;

                        op.create(e.data);
                    }
                    var showMenu = false;
                    for (var item in e.data.items) {
                        if (e.data.items.hasOwnProperty(item)) {
                            var visible;
                            if ($.isFunction(e.data.items[item].visible)) {
                                visible = e.data.items[item].visible.call($(e.currentTarget), item, e.data);
                            } else if (typeof e.data.items[item] !== 'undefined' && e.data.items[item].visible) {
                                visible = e.data.items[item].visible === true;
                            } else {
                                visible = true;
                            }
                            if (visible) {
                                showMenu = true;
                            }
                        }
                    }
                    if (showMenu) {
                        // show menu
                        op.show.call($this, e.data, e.pageX, e.pageY);
                    }
                }
            },
            // contextMenu left-click trigger
            click: function (e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                $(this).trigger($.Event('contextmenu', {data: e.data, pageX: e.pageX, pageY: e.pageY}));
            },
            // contextMenu right-click trigger
            mousedown: function (e) {
                // register mouse down
                var $this = $(this);

                // hide any previous menus
                if ($currentTrigger && $currentTrigger.length && !$currentTrigger.is($this)) {
                    $currentTrigger.data('contextMenu').$menu.trigger('contextmenu:hide');
                }

                // activate on right click
                if (e.button === 2) {
                    $currentTrigger = $this.data('contextMenuActive', true);
                }
            },
            // contextMenu right-click trigger
            mouseup: function (e) {
                // show menu
                var $this = $(this);
                if ($this.data('contextMenuActive') && $currentTrigger && $currentTrigger.length && $currentTrigger.is($this) && !$this.hasClass('context-menu-disabled')) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $currentTrigger = $this;
                    $this.trigger($.Event('contextmenu', {data: e.data, pageX: e.pageX, pageY: e.pageY}));
                }

                $this.removeData('contextMenuActive');
            },
            // contextMenu hover trigger
            mouseenter: function (e) {
                var $this = $(this),
                    $related = $(e.relatedTarget),
                    $document = $(document);

                // abort if we're coming from a menu
                if ($related.is('.context-menu-list') || $related.closest('.context-menu-list').length) {
                    return;
                }

                // abort if a menu is shown
                if ($currentTrigger && $currentTrigger.length) {
                    return;
                }

                hoveract.pageX = e.pageX;
                hoveract.pageY = e.pageY;
                hoveract.data = e.data;
                $document.on('mousemove.contextMenuShow', handle.mousemove);
                hoveract.timer = setTimeout(function () {
                    hoveract.timer = null;
                    $document.off('mousemove.contextMenuShow');
                    $currentTrigger = $this;
                    $this.trigger($.Event('contextmenu', {
                        data: hoveract.data,
                        pageX: hoveract.pageX,
                        pageY: hoveract.pageY
                    }));
                }, e.data.delay);
            },
            // contextMenu hover trigger
            mousemove: function (e) {
                hoveract.pageX = e.pageX;
                hoveract.pageY = e.pageY;
            },
            // contextMenu hover trigger
            mouseleave: function (e) {
                // abort if we're leaving for a menu
                var $related = $(e.relatedTarget);
                if ($related.is('.context-menu-list') || $related.closest('.context-menu-list').length) {
                    return;
                }

                try {
                    clearTimeout(hoveract.timer);
                } catch (e) {
                }

                hoveract.timer = null;
            },
            // click on layer to hide contextMenu
            layerClick: function (e) {
                var $this = $(this),
                    root = $this.data('contextMenuRoot'),
                    button = e.button,
                    x = e.pageX,
                    y = e.pageY,
                    target,
                    offset;

                e.preventDefault();

                setTimeout(function () {
                    var $window;
                    var triggerAction = ((root.trigger === 'left' && button === 0) || (root.trigger === 'right' && button === 2));

                    // find the element that would've been clicked, wasn't the layer in the way
                    if (document.elementFromPoint && root.$layer) {
                        root.$layer.hide();
                        target = document.elementFromPoint(x - $win.scrollLeft(), y - $win.scrollTop());

                        // also need to try and focus this element if we're in a contenteditable area,
                        // as the layer will prevent the browser mouse action we want
                        if (target.isContentEditable) {
                            var range = document.createRange(),
                                sel = window.getSelection();
                            range.selectNode(target);
                            range.collapse(true);
                            sel.removeAllRanges();
                            sel.addRange(range);
                        }
                        $(target).trigger(e);
                        root.$layer.show();
                    }

                    if (root.reposition && triggerAction) {
                        if (document.elementFromPoint) {
                            if (root.$trigger.is(target)) {
                                root.position.call(root.$trigger, root, x, y);
                                return;
                            }
                        } else {
                            offset = root.$trigger.offset();
                            $window = $(window);
                            // while this looks kinda awful, it's the best way to avoid
                            // unnecessarily calculating any positions
                            offset.top += $window.scrollTop();
                            if (offset.top <= e.pageY) {
                                offset.left += $window.scrollLeft();
                                if (offset.left <= e.pageX) {
                                    offset.bottom = offset.top + root.$trigger.outerHeight();
                                    if (offset.bottom >= e.pageY) {
                                        offset.right = offset.left + root.$trigger.outerWidth();
                                        if (offset.right >= e.pageX) {
                                            // reposition
                                            root.position.call(root.$trigger, root, x, y);
                                            return;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (target && triggerAction) {
                        root.$trigger.one('contextmenu:hidden', function () {
                            $(target).contextMenu({x: x, y: y, button: button});
                        });
                    }

                    if (root !== null && typeof root !== 'undefined' && root.$menu !== null  && typeof root.$menu !== 'undefined') {
                        root.$menu.trigger('contextmenu:hide');
                    }
                }, 50);
            },
            // key handled :hover
            keyStop: function (e, opt) {
                if (!opt.isInput) {
                    e.preventDefault();
                }

                e.stopPropagation();
            },
            key: function (e) {

                var opt = {};

                // Only get the data from $currentTrigger if it exists
                if ($currentTrigger) {
                    opt = $currentTrigger.data('contextMenu') || {};
                }
                // If the trigger happen on a element that are above the contextmenu do this
                if (typeof opt.zIndex === 'undefined') {
                    opt.zIndex = 0;
                }
                var targetZIndex = 0;
                var getZIndexOfTriggerTarget = function (target) {
                    if (target.style.zIndex !== '') {
                        targetZIndex = target.style.zIndex;
                    } else {
                        if (target.offsetParent !== null && typeof target.offsetParent !== 'undefined') {
                            getZIndexOfTriggerTarget(target.offsetParent);
                        }
                        else if (target.parentElement !== null && typeof target.parentElement !== 'undefined') {
                            getZIndexOfTriggerTarget(target.parentElement);
                        }
                    }
                };
                getZIndexOfTriggerTarget(e.target);
                // If targetZIndex is heigher then opt.zIndex dont progress any futher.
                // This is used to make sure that if you are using a dialog with a input / textarea / contenteditable div
                // and its above the contextmenu it wont steal keys events
                if (opt.$menu && parseInt(targetZIndex,10) > parseInt(opt.$menu.css("zIndex"),10)) {
                    return;
                }
                switch (e.keyCode) {
                    case 9:
                    case 38: // up
                        handle.keyStop(e, opt);
                        // if keyCode is [38 (up)] or [9 (tab) with shift]
                        if (opt.isInput) {
                            if (e.keyCode === 9 && e.shiftKey) {
                                e.preventDefault();
                                if (opt.$selected) {
                                    opt.$selected.find('input, textarea, select').blur();
                                }
                                if (opt.$menu !== null && typeof opt.$menu !== 'undefined') {
                                    opt.$menu.trigger('prevcommand');
                                }
                                return;
                            } else if (e.keyCode === 38 && opt.$selected.find('input, textarea, select').prop('type') === 'checkbox') {
                                // checkboxes don't capture this key
                                e.preventDefault();
                                return;
                            }
                        } else if (e.keyCode !== 9 || e.shiftKey) {
                            if (opt.$menu !== null && typeof opt.$menu !== 'undefined') {
                                opt.$menu.trigger('prevcommand');
                            }
                            return;
                        }
                        break;
                    // omitting break;
                    // case 9: // tab - reached through omitted break;
                    case 40: // down
                        handle.keyStop(e, opt);
                        if (opt.isInput) {
                            if (e.keyCode === 9) {
                                e.preventDefault();
                                if (opt.$selected) {
                                    opt.$selected.find('input, textarea, select').blur();
                                }
                                if (opt.$menu !== null && typeof opt.$menu !== 'undefined') {
                                    opt.$menu.trigger('nextcommand');
                                }
                                return;
                            } else if (e.keyCode === 40 && opt.$selected.find('input, textarea, select').prop('type') === 'checkbox') {
                                // checkboxes don't capture this key
                                e.preventDefault();
                                return;
                            }
                        } else {
                            if (opt.$menu !== null && typeof opt.$menu !== 'undefined') {
                                opt.$menu.trigger('nextcommand');
                            }
                            return;
                        }
                        break;

                    case 37: // left
                        handle.keyStop(e, opt);
                        if (opt.isInput || !opt.$selected || !opt.$selected.length) {
                            break;
                        }

                        if (!opt.$selected.parent().hasClass('context-menu-root')) {
                            var $parent = opt.$selected.parent().parent();
                            opt.$selected.trigger('contextmenu:blur');
                            opt.$selected = $parent;
                            return;
                        }
                        break;

                    case 39: // right
                        handle.keyStop(e, opt);
                        if (opt.isInput || !opt.$selected || !opt.$selected.length) {
                            break;
                        }

                        var itemdata = opt.$selected.data('contextMenu') || {};
                        if (itemdata.$menu && opt.$selected.hasClass('context-menu-submenu')) {
                            opt.$selected = null;
                            itemdata.$selected = null;
                            itemdata.$menu.trigger('nextcommand');
                            return;
                        }
                        break;

                    case 35: // end
                    case 36: // home
                        if (opt.$selected && opt.$selected.find('input, textarea, select').length) {
                            return;
                        } else {
                            (opt.$selected && opt.$selected.parent() || opt.$menu)
                                .children(':not(.' + opt.classNames.disabled + ', .' + opt.classNames.notSelectable + ')')[e.keyCode === 36 ? 'first' : 'last']()
                                .trigger('contextmenu:focus');
                            e.preventDefault();
                            return;
                        }
                        break;

                    case 13: // enter
                        handle.keyStop(e, opt);
                        if (opt.isInput) {
                            if (opt.$selected && !opt.$selected.is('textarea, select')) {
                                e.preventDefault();
                                return;
                            }
                            break;
                        }
                        if (typeof opt.$selected !== 'undefined' && opt.$selected !== null) {
                            opt.$selected.trigger('mouseup');
                        }
                        return;

                    case 32: // space
                    case 33: // page up
                    case 34: // page down
                        // prevent browser from scrolling down while menu is visible
                        handle.keyStop(e, opt);
                        return;

                    case 27: // esc
                        handle.keyStop(e, opt);
                        if (opt.$menu !== null && typeof opt.$menu !== 'undefined') {
                            opt.$menu.trigger('contextmenu:hide');
                        }
                        return;

                    default: // 0-9, a-z
                        var k = (String.fromCharCode(e.keyCode)).toUpperCase();
                        if (opt.accesskeys && opt.accesskeys[k]) {
                            // according to the specs accesskeys must be invoked immediately
                            opt.accesskeys[k].$node.trigger(opt.accesskeys[k].$menu ? 'contextmenu:focus' : 'mouseup');
                            return;
                        }
                        break;
                }
                // pass event to selected item,
                // stop propagation to avoid endless recursion
                e.stopPropagation();
                if (typeof opt.$selected !== 'undefined' && opt.$selected !== null) {
                    opt.$selected.trigger(e);
                }
            },
            // select previous possible command in menu
            prevItem: function (e) {
                e.stopPropagation();
                var opt = $(this).data('contextMenu') || {};
                var root = $(this).data('contextMenuRoot') || {};

                // obtain currently selected menu
                if (opt.$selected) {
                    var $s = opt.$selected;
                    opt = opt.$selected.parent().data('contextMenu') || {};
                    opt.$selected = $s;
                }

                var $children = opt.$menu.children(),
                    $prev = !opt.$selected || !opt.$selected.prev().length ? $children.last() : opt.$selected.prev(),
                    $round = $prev;

                // skip disabled or hidden elements
                while ($prev.hasClass(root.classNames.disabled) || $prev.hasClass(root.classNames.notSelectable) || $prev.is(':hidden')) {
                    if ($prev.prev().length) {
                        $prev = $prev.prev();
                    } else {
                        $prev = $children.last();
                    }
                    if ($prev.is($round)) {
                        // break endless loop
                        return;
                    }
                }

                // leave current
                if (opt.$selected) {
                    handle.itemMouseleave.call(opt.$selected.get(0), e);
                }

                // activate next
                handle.itemMouseenter.call($prev.get(0), e);

                // focus input
                var $input = $prev.find('input, textarea, select');
                if ($input.length) {
                    $input.focus();
                }
            },
            // select next possible command in menu
            nextItem: function (e) {
                e.stopPropagation();
                var opt = $(this).data('contextMenu') || {};
                var root = $(this).data('contextMenuRoot') || {};

                // obtain currently selected menu
                if (opt.$selected) {
                    var $s = opt.$selected;
                    opt = opt.$selected.parent().data('contextMenu') || {};
                    opt.$selected = $s;
                }

                var $children = opt.$menu.children(),
                    $next = !opt.$selected || !opt.$selected.next().length ? $children.first() : opt.$selected.next(),
                    $round = $next;

                // skip disabled
                while ($next.hasClass(root.classNames.disabled) || $next.hasClass(root.classNames.notSelectable) || $next.is(':hidden')) {
                    if ($next.next().length) {
                        $next = $next.next();
                    } else {
                        $next = $children.first();
                    }
                    if ($next.is($round)) {
                        // break endless loop
                        return;
                    }
                }

                // leave current
                if (opt.$selected) {
                    handle.itemMouseleave.call(opt.$selected.get(0), e);
                }

                // activate next
                handle.itemMouseenter.call($next.get(0), e);

                // focus input
                var $input = $next.find('input, textarea, select');
                if ($input.length) {
                    $input.focus();
                }
            },
            // flag that we're inside an input so the key handler can act accordingly
            focusInput: function () {
                var $this = $(this).closest('.context-menu-item'),
                    data = $this.data(),
                    opt = data.contextMenu,
                    root = data.contextMenuRoot;

                root.$selected = opt.$selected = $this;
                root.isInput = opt.isInput = true;
            },
            // flag that we're inside an input so the key handler can act accordingly
            blurInput: function () {
                var $this = $(this).closest('.context-menu-item'),
                    data = $this.data(),
                    opt = data.contextMenu,
                    root = data.contextMenuRoot;

                root.isInput = opt.isInput = false;
            },
            // :hover on menu
            menuMouseenter: function () {
                var root = $(this).data().contextMenuRoot;
                root.hovering = true;
            },
            // :hover on menu
            menuMouseleave: function (e) {
                var root = $(this).data().contextMenuRoot;
                if (root.$layer && root.$layer.is(e.relatedTarget)) {
                    root.hovering = false;
                }
            },
            // :hover done manually so key handling is possible
            itemMouseenter: function (e) {
                var $this = $(this),
                    data = $this.data(),
                    opt = data.contextMenu,
                    root = data.contextMenuRoot;

                root.hovering = true;

                // abort if we're re-entering
                if (e && root.$layer && root.$layer.is(e.relatedTarget)) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }

                // make sure only one item is selected
                (opt.$menu ? opt : root).$menu
                    .children('.' + root.classNames.hover).trigger('contextmenu:blur')
                    .children('.hover').trigger('contextmenu:blur');

                if ($this.hasClass(root.classNames.disabled) || $this.hasClass(root.classNames.notSelectable)) {
                    opt.$selected = null;
                    return;
                }


                $this.trigger('contextmenu:focus');
            },
            // :hover done manually so key handling is possible
            itemMouseleave: function (e) {
                var $this = $(this),
                    data = $this.data(),
                    opt = data.contextMenu,
                    root = data.contextMenuRoot;

                if (root !== opt && root.$layer && root.$layer.is(e.relatedTarget)) {
                    if (typeof root.$selected !== 'undefined' && root.$selected !== null) {
                        root.$selected.trigger('contextmenu:blur');
                    }
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    root.$selected = opt.$selected = opt.$node;
                    return;
                }

                if(opt && opt.$menu && opt.$menu.hasClass('context-menu-visible')){
                    return;
                }

                $this.trigger('contextmenu:blur');
            },
            // contextMenu item click
            itemClick: function (e) {
                var $this = $(this),
                    data = $this.data(),
                    opt = data.contextMenu,
                    root = data.contextMenuRoot,
                    key = data.contextMenuKey,
                    callback;

                // abort if the key is unknown or disabled or is a menu
                if (!opt.items[key] || $this.is('.' + root.classNames.disabled + ', .context-menu-separator, .' + root.classNames.notSelectable) || ($this.is('.context-menu-submenu') && root.selectableSubMenu === false )) {
                    return;
                }

                e.preventDefault();
                e.stopImmediatePropagation();

                if ($.isFunction(opt.callbacks[key]) && Object.prototype.hasOwnProperty.call(opt.callbacks, key)) {
                    // item-specific callback
                    callback = opt.callbacks[key];
                } else if ($.isFunction(root.callback)) {
                    // default callback
                    callback = root.callback;
                } else {
                    // no callback, no action
                    return;
                }

                // hide menu if callback doesn't stop that
                if (callback.call(root.$trigger, key, root, e) !== false) {
                    root.$menu.trigger('contextmenu:hide');
                } else if (root.$menu.parent().length) {
                    op.update.call(root.$trigger, root);
                }
            },
            // ignore click events on input elements
            inputClick: function (e) {
                e.stopImmediatePropagation();
            },
            // hide <menu>
            hideMenu: function (e, data) {
                var root = $(this).data('contextMenuRoot');
                op.hide.call(root.$trigger, root, data && data.force);
            },
            // focus <command>
            focusItem: function (e) {
                e.stopPropagation();
                var $this = $(this),
                    data = $this.data(),
                    opt = data.contextMenu,
                    root = data.contextMenuRoot;

                if ($this.hasClass(root.classNames.disabled) || $this.hasClass(root.classNames.notSelectable)) {
                    return;
                }

                $this
                    .addClass([root.classNames.hover, root.classNames.visible].join(' '))
                    // select other items and included items
                    .parent().find('.context-menu-item').not($this)
                    .removeClass(root.classNames.visible)
                    .filter('.' + root.classNames.hover)
                    .trigger('contextmenu:blur');

                // remember selected
                opt.$selected = root.$selected = $this;


                if(opt && opt.$node && opt.$node.hasClass('context-menu-submenu')){
                    opt.$node.addClass(root.classNames.hover);
                }

                // position sub-menu - do after show so dumb $.ui.position can keep up
                if (opt.$node) {
                    root.positionSubmenu.call(opt.$node, opt.$menu);
                }
            },
            // blur <command>
            blurItem: function (e) {
                e.stopPropagation();
                var $this = $(this),
                    data = $this.data(),
                    opt = data.contextMenu,
                    root = data.contextMenuRoot;

                if (opt.autoHide) { // for tablets and touch screens this needs to remain
                    $this.removeClass(root.classNames.visible);
                }
                $this.removeClass(root.classNames.hover);
                opt.$selected = null;
            }
        },
        // operations
        op = {
            show: function (opt, x, y) {
                var $trigger = $(this),
                    css = {};

                // hide any open menus
                $('#context-menu-layer').trigger('mousedown');

                // backreference for callbacks
                opt.$trigger = $trigger;

                // show event
                if (opt.events.show.call($trigger, opt) === false) {
                    $currentTrigger = null;
                    return;
                }

                // create or update context menu
                op.update.call($trigger, opt);

                // position menu
                opt.position.call($trigger, opt, x, y);

                // make sure we're in front
                if (opt.zIndex) {
                    var additionalZValue = opt.zIndex;
                    // If opt.zIndex is a function, call the function to get the right zIndex.
                    if (typeof opt.zIndex === 'function') {
                        additionalZValue = opt.zIndex.call($trigger, opt);
                    }
                    css.zIndex = zindex($trigger) + additionalZValue;
                }

                // add layer
                op.layer.call(opt.$menu, opt, css.zIndex);

                // adjust sub-menu zIndexes
                opt.$menu.find('ul').css('zIndex', css.zIndex + 1);

                // position and show context menu
                opt.$menu.css(css)[opt.animation.show](opt.animation.duration, function () {
                    $trigger.trigger('contextmenu:visible');
                });
                // make options available and set state
                $trigger
                    .data('contextMenu', opt)
                    .addClass('context-menu-active');

                // register key handler
                $(document).off('keydown.contextMenu').on('keydown.contextMenu', handle.key);
                // register autoHide handler
                if (opt.autoHide) {
                    // mouse position handler
                    $(document).on('mousemove.contextMenuAutoHide', function (e) {
                        // need to capture the offset on mousemove,
                        // since the page might've been scrolled since activation
                        var pos = $trigger.offset();
                        pos.right = pos.left + $trigger.outerWidth();
                        pos.bottom = pos.top + $trigger.outerHeight();

                        if (opt.$layer && !opt.hovering && (!(e.pageX >= pos.left && e.pageX <= pos.right) || !(e.pageY >= pos.top && e.pageY <= pos.bottom))) {
                            /* Additional hover check after short time, you might just miss the edge of the menu */
                            setTimeout(function () {
                                if (!opt.hovering && opt.$menu !== null && typeof opt.$menu !== 'undefined') {
                                    opt.$menu.trigger('contextmenu:hide');
                                }
                            }, 50);
                        }
                    });
                }
            },
            hide: function (opt, force) {
                var $trigger = $(this);
                if (!opt) {
                    opt = $trigger.data('contextMenu') || {};
                }

                // hide event
                if (!force && opt.events && opt.events.hide.call($trigger, opt) === false) {
                    return;
                }

                // remove options and revert state
                $trigger
                    .removeData('contextMenu')
                    .removeClass('context-menu-active');

                if (opt.$layer) {
                    // keep layer for a bit so the contextmenu event can be aborted properly by opera
                    setTimeout((function ($layer) {
                        return function () {
                            $layer.remove();
                        };
                    })(opt.$layer), 10);

                    try {
                        delete opt.$layer;
                    } catch (e) {
                        opt.$layer = null;
                    }
                }

                // remove handle
                $currentTrigger = null;
                // remove selected
                opt.$menu.find('.' + opt.classNames.hover).trigger('contextmenu:blur');
                opt.$selected = null;
                // collapse all submenus
                opt.$menu.find('.' + opt.classNames.visible).removeClass(opt.classNames.visible);
                // unregister key and mouse handlers
                // $(document).off('.contextMenuAutoHide keydown.contextMenu'); // http://bugs.jquery.com/ticket/10705
                $(document).off('.contextMenuAutoHide').off('keydown.contextMenu');
                // hide menu
                if (opt.$menu) {
                    opt.$menu[opt.animation.hide](opt.animation.duration, function () {
                        // tear down dynamically built menu after animation is completed.
                        if (opt.build) {
                            opt.$menu.remove();
                            $.each(opt, function (key) {
                                switch (key) {
                                    case 'ns':
                                    case 'selector':
                                    case 'build':
                                    case 'trigger':
                                        return true;

                                    default:
                                        opt[key] = undefined;
                                        try {
                                            delete opt[key];
                                        } catch (e) {
                                        }
                                        return true;
                                }
                            });
                        }

                        setTimeout(function () {
                            $trigger.trigger('contextmenu:hidden');
                        }, 10);
                    });
                }
            },
            create: function (opt, root) {
                if (typeof root === 'undefined') {
                    root = opt;
                }

                // create contextMenu
                opt.$menu = $('<ul class="context-menu-list"></ul>').addClass(opt.className || '').data({
                    'contextMenu': opt,
                    'contextMenuRoot': root
                });

                $.each(['callbacks', 'commands', 'inputs'], function (i, k) {
                    opt[k] = {};
                    if (!root[k]) {
                        root[k] = {};
                    }
                });

                if (!root.accesskeys) {
                    root.accesskeys = {};
                }

                function createNameNode(item) {
                    var $name = $('<span></span>');
                    if (item._accesskey) {
                        if (item._beforeAccesskey) {
                            $name.append(document.createTextNode(item._beforeAccesskey));
                        }
                        $('<span></span>')
                            .addClass('context-menu-accesskey')
                            .text(item._accesskey)
                            .appendTo($name);
                        if (item._afterAccesskey) {
                            $name.append(document.createTextNode(item._afterAccesskey));
                        }
                    } else {
                        if (item.isHtmlName) {
                            // restrict use with access keys
                            if (typeof item.accesskey !== 'undefined') {
                                throw new Error('accesskeys are not compatible with HTML names and cannot be used together in the same item');
                            }
                            $name.html(item.name);
                        } else {
                            $name.text(item.name);
                        }
                    }
                    return $name;
                }

                // create contextMenu items
                $.each(opt.items, function (key, item) {
                    var $t = $('<li class="context-menu-item"></li>').addClass(item.className || ''),
                        $label = null,
                        $input = null;

                    // iOS needs to see a click-event bound to an element to actually
                    // have the TouchEvents infrastructure trigger the click event
                    $t.on('click', $.noop);

                    // Make old school string seperator a real item so checks wont be
                    // akward later.
                    // And normalize 'cm_separator' into 'cm_seperator'.
                    if (typeof item === 'string' || item.type === 'cm_separator') {
                        item = {type: 'cm_seperator'};
                    }

                    item.$node = $t.data({
                        'contextMenu': opt,
                        'contextMenuRoot': root,
                        'contextMenuKey': key
                    });

                    // register accesskey
                    // NOTE: the accesskey attribute should be applicable to any element, but Safari5 and Chrome13 still can't do that
                    if (typeof item.accesskey !== 'undefined') {
                        var aks = splitAccesskey(item.accesskey);
                        for (var i = 0, ak; ak = aks[i]; i++) {
                            if (!root.accesskeys[ak]) {
                                root.accesskeys[ak] = item;
                                var matched = item.name.match(new RegExp('^(.*?)(' + ak + ')(.*)$', 'i'));
                                if (matched) {
                                    item._beforeAccesskey = matched[1];
                                    item._accesskey = matched[2];
                                    item._afterAccesskey = matched[3];
                                }
                                break;
                            }
                        }
                    }

                    if (item.type && types[item.type]) {
                        // run custom type handler
                        types[item.type].call($t, item, opt, root);
                        // register commands
                        $.each([opt, root], function (i, k) {
                            k.commands[key] = item;
                            // Overwrite only if undefined or the item is appended to the root. This so it
                            // doesn't overwrite callbacks of root elements if the name is the same.
                            if ($.isFunction(item.callback) && (typeof k.callbacks[key] === 'undefined' || typeof opt.type === 'undefined')) {
                                k.callbacks[key] = item.callback;
                            }
                        });
                    } else {
                        // add label for input
                        if (item.type === 'cm_seperator') {
                            $t.addClass('context-menu-separator ' + root.classNames.notSelectable);
                        } else if (item.type === 'html') {
                            $t.addClass('context-menu-html ' + root.classNames.notSelectable);
                        } else if (item.type === 'sub') {
                            // We don't want to execute the next else-if if it is a sub.
                        } else if (item.type) {
                            $label = $('<label></label>').appendTo($t);
                            createNameNode(item).appendTo($label);

                            $t.addClass('context-menu-input');
                            opt.hasTypes = true;
                            $.each([opt, root], function (i, k) {
                                k.commands[key] = item;
                                k.inputs[key] = item;
                            });
                        } else if (item.items) {
                            item.type = 'sub';
                        }

                        switch (item.type) {
                            case 'cm_seperator':
                                break;

                            case 'text':
                                $input = $('<input type="text" value="1" name="" />')
                                    .attr('name', 'context-menu-input-' + key)
                                    .val(item.value || '')
                                    .appendTo($label);
                                break;

                            case 'textarea':
                                $input = $('<textarea name=""></textarea>')
                                    .attr('name', 'context-menu-input-' + key)
                                    .val(item.value || '')
                                    .appendTo($label);

                                if (item.height) {
                                    $input.height(item.height);
                                }
                                break;

                            case 'checkbox':
                                $input = $('<input type="checkbox" value="1" name="" />')
                                    .attr('name', 'context-menu-input-' + key)
                                    .val(item.value || '')
                                    .prop('checked', !!item.selected)
                                    .prependTo($label);
                                break;

                            case 'radio':
                                $input = $('<input type="radio" value="1" name="" />')
                                    .attr('name', 'context-menu-input-' + item.radio)
                                    .val(item.value || '')
                                    .prop('checked', !!item.selected)
                                    .prependTo($label);
                                break;

                            case 'select':
                                $input = $('<select name=""></select>')
                                    .attr('name', 'context-menu-input-' + key)
                                    .appendTo($label);
                                if (item.options) {
                                    $.each(item.options, function (value, text) {
                                        $('<option></option>').val(value).text(text).appendTo($input);
                                    });
                                    $input.val(item.selected);
                                }
                                break;

                            case 'sub':
                                createNameNode(item).appendTo($t);
                                item.appendTo = item.$node;
                                $t.data('contextMenu', item).addClass('context-menu-submenu');
                                item.callback = null;

                                // If item contains items, and this is a promise, we should create it later
                                // check if subitems is of type promise. If it is a promise we need to create
                                // it later, after promise has been resolved.
                                if ('function' === typeof item.items.then) {
                                    // probably a promise, process it, when completed it will create the sub menu's.
                                    op.processPromises(item, root, item.items);
                                } else {
                                    // normal submenu.
                                    op.create(item, root);
                                }
                                break;

                            case 'html':
                                $(item.html).appendTo($t);
                                break;

                            default:
                                $.each([opt, root], function (i, k) {
                                    k.commands[key] = item;
                                    // Overwrite only if undefined or the item is appended to the root. This so it
                                    // doesn't overwrite callbacks of root elements if the name is the same.
                                    if ($.isFunction(item.callback) && (typeof k.callbacks[key] === 'undefined' || typeof opt.type === 'undefined')) {
                                        k.callbacks[key] = item.callback;
                                    }
                                });
                                createNameNode(item).appendTo($t);
                                break;
                        }

                        // disable key listener in <input>
                        if (item.type && item.type !== 'sub' && item.type !== 'html' && item.type !== 'cm_seperator') {
                            $input
                                .on('focus', handle.focusInput)
                                .on('blur', handle.blurInput);

                            if (item.events) {
                                $input.on(item.events, opt);
                            }
                        }

                        // add icons
                        if (item.icon) {
                            if ($.isFunction(item.icon)) {
                                item._icon = item.icon.call(this, this, $t, key, item);
                            } else {
                                if (typeof(item.icon) === 'string' && item.icon.substring(0, 3) === 'fa-') {
                                    // to enable font awesome
                                    item._icon = root.classNames.icon + ' ' + root.classNames.icon + '--fa fa ' + item.icon;
                                } else {
                                    item._icon = root.classNames.icon + ' ' + root.classNames.icon + '-' + item.icon;
                                }
                            }
                            $t.addClass(item._icon);
                        }
                    }

                    // cache contained elements
                    item.$input = $input;
                    item.$label = $label;

                    // attach item to menu
                    $t.appendTo(opt.$menu);

                    // Disable text selection
                    if (!opt.hasTypes && $.support.eventSelectstart) {
                        // browsers support user-select: none,
                        // IE has a special event for text-selection
                        // browsers supporting neither will not be preventing text-selection
                        $t.on('selectstart.disableTextSelect', handle.abortevent);
                    }
                });
                // attach contextMenu to <body> (to bypass any possible overflow:hidden issues on parents of the trigger element)
                if (!opt.$node) {
                    opt.$menu.css('display', 'none').addClass('context-menu-root');
                }
                opt.$menu.appendTo(opt.appendTo || document.body);
            },
            resize: function ($menu, nested) {
                var domMenu;
                // determine widths of submenus, as CSS won't grow them automatically
                // position:absolute within position:absolute; min-width:100; max-width:200; results in width: 100;
                // kinda sucks hard...

                // determine width of absolutely positioned element
                $menu.css({position: 'absolute', display: 'block'});
                // don't apply yet, because that would break nested elements' widths
                $menu.data('width',
                    (domMenu = $menu.get(0)).getBoundingClientRect ?
                        Math.ceil(domMenu.getBoundingClientRect().width) :
                        $menu.outerWidth() + 1); // outerWidth() returns rounded pixels
                // reset styles so they allow nested elements to grow/shrink naturally
                $menu.css({
                    position: 'static',
                    minWidth: '0px',
                    maxWidth: '100000px'
                });
                // identify width of nested menus
                $menu.find('> li > ul').each(function () {
                    op.resize($(this), true);
                });
                // reset and apply changes in the end because nested
                // elements' widths wouldn't be calculatable otherwise
                if (!nested) {
                    $menu.find('ul').addBack().css({
                        position: '',
                        display: '',
                        minWidth: '',
                        maxWidth: ''
                    }).outerWidth(function () {
                        return $(this).data('width');
                    });
                }
            },
            update: function (opt, root) {
                var $trigger = this;
                if (typeof root === 'undefined') {
                    root = opt;
                    op.resize(opt.$menu);
                }
                // re-check disabled for each item
                opt.$menu.children().each(function () {
                    var $item = $(this),
                        key = $item.data('contextMenuKey'),
                        item = opt.items[key],
                        disabled = ($.isFunction(item.disabled) && item.disabled.call($trigger, key, root)) || item.disabled === true,
                        visible;
                    if ($.isFunction(item.visible)) {
                        visible = item.visible.call($trigger, key, root);
                    } else if (typeof item.visible !== 'undefined') {
                        visible = item.visible === true;
                    } else {
                        visible = true;
                    }
                    $item[visible ? 'show' : 'hide']();

                    // dis- / enable item
                    $item[disabled ? 'addClass' : 'removeClass'](root.classNames.disabled);

                    if ($.isFunction(item.icon)) {
                        $item.removeClass(item._icon);
                        item._icon = item.icon.call(this, $trigger, $item, key, item);
                        $item.addClass(item._icon);
                    }

                    if (item.type) {
                        // dis- / enable input elements
                        $item.find('input, select, textarea').prop('disabled', disabled);

                        // update input states
                        switch (item.type) {
                            case 'text':
                            case 'textarea':
                                item.$input.val(item.value || '');
                                break;

                            case 'checkbox':
                            case 'radio':
                                item.$input.val(item.value || '').prop('checked', !!item.selected);
                                break;

                            case 'select':
                                item.$input.val((item.selected === 0 ? "0" : item.selected) || '');
                                break;
                        }
                    }

                    if (item.$menu) {
                        // update sub-menu
                        op.update.call($trigger, item, root);
                    }
                });
            },
            layer: function (opt, zIndex) {
                // add transparent layer for click area
                // filter and background for Internet Explorer, Issue #23
                var $layer = opt.$layer = $('<div id="context-menu-layer"></div>')
                    .css({
                        height: $win.height(),
                        width: $win.width(),
                        display: 'block',
                        position: 'fixed',
                        'z-index': zIndex,
                        top: 0,
                        left: 0,
                        opacity: 0,
                        filter: 'alpha(opacity=0)',
                        'background-color': '#000'
                    })
                    .data('contextMenuRoot', opt)
                    .insertBefore(this)
                    .on('contextmenu', handle.abortevent)
                    .on('mousedown', handle.layerClick);

                // IE6 doesn't know position:fixed;
                if (typeof document.body.style.maxWidth === 'undefined') { // IE6 doesn't support maxWidth
                    $layer.css({
                        'position': 'absolute',
                        'height': $(document).height()
                    });
                }

                return $layer;
            },
            processPromises: function (opt, root, promise) {
                // Start
                opt.$node.addClass(root.classNames.iconLoadingClass);

                function completedPromise(opt, root, items) {
                    // Completed promise (dev called promise.resolve). We now have a list of items which can
                    // be used to create the rest of the context menu.
                    if (typeof items === 'undefined') {
                        // Null result, dev should have checked
                        errorPromise(undefined);//own error object
                    }
                    finishPromiseProcess(opt, root, items);
                }

                function errorPromise(opt, root, errorItem) {
                    // User called promise.reject() with an error item, if not, provide own error item.
                    if (typeof errorItem === 'undefined') {
                        errorItem = {
                            "error": {
                                name: "No items and no error item",
                                icon: "context-menu-icon context-menu-icon-quit"
                            }
                        };
                        if (window.console) {
                            (console.error || console.log).call(console, 'When you reject a promise, provide an "items" object, equal to normal sub-menu items');
                        }
                    } else if (typeof errorItem === 'string') {
                        errorItem = {"error": {name: errorItem}};
                    }
                    finishPromiseProcess(opt, root, errorItem);
                }

                function finishPromiseProcess(opt, root, items) {
                    if (typeof root.$menu === 'undefined' || !root.$menu.is(':visible')) {
                        return;
                    }
                    opt.$node.removeClass(root.classNames.iconLoadingClass);
                    opt.items = items;
                    op.create(opt, root, true); // Create submenu
                    op.update(opt, root); // Correctly update position if user is already hovered over menu item
                    root.positionSubmenu.call(opt.$node, opt.$menu); // positionSubmenu, will only do anything if user already hovered over menu item that just got new subitems.
                }

                // Wait for promise completion. .then(success, error, notify) (we don't track notify). Bind the opt
                // and root to avoid scope problems
                promise.then(completedPromise.bind(this, opt, root), errorPromise.bind(this, opt, root));
            }
        };

    // split accesskey according to http://www.whatwg.org/specs/web-apps/current-work/multipage/editing.html#assigned-access-key
    function splitAccesskey(val) {
        var t = val.split(/\s+/);
        var keys = [];

        for (var i = 0, k; k = t[i]; i++) {
            k = k.charAt(0).toUpperCase(); // first character only
            // theoretically non-accessible characters should be ignored, but different systems, different keyboard layouts, ... screw it.
            // a map to look up already used access keys would be nice
            keys.push(k);
        }

        return keys;
    }

// handle contextMenu triggers
    $.fn.contextMenu = function (operation) {
        var $t = this, $o = operation;
        if (this.length > 0) {  // this is not a build on demand menu
            if (typeof operation === 'undefined') {
                this.first().trigger('contextmenu');
            } else if (typeof operation.x !== 'undefined' && typeof operation.y !== 'undefined') {
                this.first().trigger($.Event('contextmenu', {
                    pageX: operation.x,
                    pageY: operation.y,
                    mouseButton: operation.button
                }));
            } else if (operation === 'hide') {
                var $menu = this.first().data('contextMenu') ? this.first().data('contextMenu').$menu : null;
                if ($menu) {
                    $menu.trigger('contextmenu:hide');
                }
            } else if (operation === 'destroy') {
                $.contextMenu('destroy', {context: this});
            } else if ($.isPlainObject(operation)) {
                operation.context = this;
                $.contextMenu('create', operation);
            } else if (operation) {
                this.removeClass('context-menu-disabled');
            } else if (!operation) {
                this.addClass('context-menu-disabled');
            }
        } else {
            $.each(menus, function () {
                if (this.selector === $t.selector) {
                    $o.data = this;

                    $.extend($o.data, {trigger: 'demand'});
                }
            });

            handle.contextmenu.call($o.target, $o);
        }

        return this;
    };

    // manage contextMenu instances
    $.contextMenu = function (operation, options) {
        if (typeof operation !== 'string') {
            options = operation;
            operation = 'create';
        }

        if (typeof options === 'string') {
            options = {selector: options};
        } else if (typeof options === 'undefined') {
            options = {};
        }

        // merge with default options
        var o = $.extend(true, {}, defaults, options || {});
        var $document = $(document);
        var $context = $document;
        var _hasContext = false;

        if (!o.context || !o.context.length) {
            o.context = document;
        } else {
            // you never know what they throw at you...
            $context = $(o.context).first();
            o.context = $context.get(0);
            _hasContext = !$(o.context).is(document);
        }

        switch (operation) {
            case 'create':
                // no selector no joy
                if (!o.selector) {
                    throw new Error('No selector specified');
                }
                // make sure internal classes are not bound to
                if (o.selector.match(/.context-menu-(list|item|input)($|\s)/)) {
                    throw new Error('Cannot bind to selector "' + o.selector + '" as it contains a reserved className');
                }
                if (!o.build && (!o.items || $.isEmptyObject(o.items))) {
                    throw new Error('No Items specified');
                }
                counter++;
                o.ns = '.contextMenu' + counter;
                if (!_hasContext) {
                    namespaces[o.selector] = o.ns;
                }
                menus[o.ns] = o;

                // default to right click
                if (!o.trigger) {
                    o.trigger = 'right';
                }

                if (!initialized) {
                    var itemClick = o.itemClickEvent === 'click' ? 'click.contextMenu' : 'mouseup.contextMenu';
                    var contextMenuItemObj = {
                        // 'mouseup.contextMenu': handle.itemClick,
                        // 'click.contextMenu': handle.itemClick,
                        'contextmenu:focus.contextMenu': handle.focusItem,
                        'contextmenu:blur.contextMenu': handle.blurItem,
                        'contextmenu.contextMenu': handle.abortevent,
                        'mouseenter.contextMenu': handle.itemMouseenter,
                        'mouseleave.contextMenu': handle.itemMouseleave
                    };
                    contextMenuItemObj[itemClick] = handle.itemClick;
                    // make sure item click is registered first
                    $document
                        .on({
                            'contextmenu:hide.contextMenu': handle.hideMenu,
                            'prevcommand.contextMenu': handle.prevItem,
                            'nextcommand.contextMenu': handle.nextItem,
                            'contextmenu.contextMenu': handle.abortevent,
                            'mouseenter.contextMenu': handle.menuMouseenter,
                            'mouseleave.contextMenu': handle.menuMouseleave
                        }, '.context-menu-list')
                        .on('mouseup.contextMenu', '.context-menu-input', handle.inputClick)
                        .on(contextMenuItemObj, '.context-menu-item');

                    initialized = true;
                }

                // engage native contextmenu event
                $context
                    .on('contextmenu' + o.ns, o.selector, o, handle.contextmenu);

                if (_hasContext) {
                    // add remove hook, just in case
                    $context.on('remove' + o.ns, function () {
                        $(this).contextMenu('destroy');
                    });
                }

                switch (o.trigger) {
                    case 'hover':
                        $context
                            .on('mouseenter' + o.ns, o.selector, o, handle.mouseenter)
                            .on('mouseleave' + o.ns, o.selector, o, handle.mouseleave);
                        break;

                    case 'left':
                        $context.on('click' + o.ns, o.selector, o, handle.click);
                        break;
                    /*
                     default:
                     // http://www.quirksmode.org/dom/events/contextmenu.html
                     $document
                     .on('mousedown' + o.ns, o.selector, o, handle.mousedown)
                     .on('mouseup' + o.ns, o.selector, o, handle.mouseup);
                     break;
                     */
                }

                // create menu
                if (!o.build) {
                    op.create(o);
                }
                break;

            case 'destroy':
                var $visibleMenu;
                if (_hasContext) {
                    // get proper options
                    var context = o.context;
                    $.each(menus, function (ns, o) {

                        if (!o) {
                            return true;
                        }

                        // Is this menu equest to the context called from
                        if (!$(context).is(o.selector)) {
                            return true;
                        }

                        $visibleMenu = $('.context-menu-list').filter(':visible');
                        if ($visibleMenu.length && $visibleMenu.data().contextMenuRoot.$trigger.is($(o.context).find(o.selector))) {
                            $visibleMenu.trigger('contextmenu:hide', {force: true});
                        }

                        try {
                            if (menus[o.ns].$menu) {
                                menus[o.ns].$menu.remove();
                            }

                            delete menus[o.ns];
                        } catch (e) {
                            menus[o.ns] = null;
                        }

                        $(o.context).off(o.ns);

                        return true;
                    });
                } else if (!o.selector) {
                    $document.off('.contextMenu .contextMenuAutoHide');
                    $.each(menus, function (ns, o) {
                        $(o.context).off(o.ns);
                    });

                    namespaces = {};
                    menus = {};
                    counter = 0;
                    initialized = false;

                    $('#context-menu-layer, .context-menu-list').remove();
                } else if (namespaces[o.selector]) {
                    $visibleMenu = $('.context-menu-list').filter(':visible');
                    if ($visibleMenu.length && $visibleMenu.data().contextMenuRoot.$trigger.is(o.selector)) {
                        $visibleMenu.trigger('contextmenu:hide', {force: true});
                    }

                    try {
                        if (menus[namespaces[o.selector]].$menu) {
                            menus[namespaces[o.selector]].$menu.remove();
                        }

                        delete menus[namespaces[o.selector]];
                    } catch (e) {
                        menus[namespaces[o.selector]] = null;
                    }

                    $document.off(namespaces[o.selector]);
                }
                break;

            case 'html5':
                // if <command> or <menuitem> are not handled by the browser,
                // or options was a bool true,
                // initialize $.contextMenu for them
                if ((!$.support.htmlCommand && !$.support.htmlMenuitem) || (typeof options === 'boolean' && options)) {
                    $('menu[type="context"]').each(function () {
                        if (this.id) {
                            $.contextMenu({
                                selector: '[contextmenu=' + this.id + ']',
                                items: $.contextMenu.fromMenu(this)
                            });
                        }
                    }).css('display', 'none');
                }
                break;

            default:
                throw new Error('Unknown operation "' + operation + '"');
        }

        return this;
    };

// import values into <input> commands
    $.contextMenu.setInputValues = function (opt, data) {
        if (typeof data === 'undefined') {
            data = {};
        }

        $.each(opt.inputs, function (key, item) {
            switch (item.type) {
                case 'text':
                case 'textarea':
                    item.value = data[key] || '';
                    break;

                case 'checkbox':
                    item.selected = data[key] ? true : false;
                    break;

                case 'radio':
                    item.selected = (data[item.radio] || '') === item.value;
                    break;

                case 'select':
                    item.selected = data[key] || '';
                    break;
            }
        });
    };

// export values from <input> commands
    $.contextMenu.getInputValues = function (opt, data) {
        if (typeof data === 'undefined') {
            data = {};
        }

        $.each(opt.inputs, function (key, item) {
            switch (item.type) {
                case 'text':
                case 'textarea':
                case 'select':
                    data[key] = item.$input.val();
                    break;

                case 'checkbox':
                    data[key] = item.$input.prop('checked');
                    break;

                case 'radio':
                    if (item.$input.prop('checked')) {
                        data[item.radio] = item.value;
                    }
                    break;
            }
        });

        return data;
    };

// find <label for="xyz">
    function inputLabel(node) {
        return (node.id && $('label[for="' + node.id + '"]').val()) || node.name;
    }

// convert <menu> to items object
    function menuChildren(items, $children, counter) {
        if (!counter) {
            counter = 0;
        }

        $children.each(function () {
            var $node = $(this),
                node = this,
                nodeName = this.nodeName.toLowerCase(),
                label,
                item;

            // extract <label><input>
            if (nodeName === 'label' && $node.find('input, textarea, select').length) {
                label = $node.text();
                $node = $node.children().first();
                node = $node.get(0);
                nodeName = node.nodeName.toLowerCase();
            }

            /*
             * <menu> accepts flow-content as children. that means <embed>, <canvas> and such are valid menu items.
             * Not being the sadistic kind, $.contextMenu only accepts:
             * <command>, <menuitem>, <hr>, <span>, <p> <input [text, radio, checkbox]>, <textarea>, <select> and of course <menu>.
             * Everything else will be imported as an html node, which is not interfaced with contextMenu.
             */

            // http://www.whatwg.org/specs/web-apps/current-work/multipage/commands.html#concept-command
            switch (nodeName) {
                // http://www.whatwg.org/specs/web-apps/current-work/multipage/interactive-elements.html#the-menu-element
                case 'menu':
                    item = {name: $node.attr('label'), items: {}};
                    counter = menuChildren(item.items, $node.children(), counter);
                    break;

                // http://www.whatwg.org/specs/web-apps/current-work/multipage/commands.html#using-the-a-element-to-define-a-command
                case 'a':
                // http://www.whatwg.org/specs/web-apps/current-work/multipage/commands.html#using-the-button-element-to-define-a-command
                case 'button':
                    item = {
                        name: $node.text(),
                        disabled: !!$node.attr('disabled'),
                        callback: (function () {
                            return function () {
                                $node.get(0).click()
                            };
                        })()
                    };
                    break;

                // http://www.whatwg.org/specs/web-apps/current-work/multipage/commands.html#using-the-command-element-to-define-a-command
                case 'menuitem':
                case 'command':
                    switch ($node.attr('type')) {
                        case undefined:
                        case 'command':
                        case 'menuitem':
                            item = {
                                name: $node.attr('label'),
                                disabled: !!$node.attr('disabled'),
                                icon: $node.attr('icon'),
                                callback: (function () {
                                    return function () {
                                        $node.get(0).click()
                                    };
                                })()
                            };
                            break;

                        case 'checkbox':
                            item = {
                                type: 'checkbox',
                                disabled: !!$node.attr('disabled'),
                                name: $node.attr('label'),
                                selected: !!$node.attr('checked')
                            };
                            break;
                        case 'radio':
                            item = {
                                type: 'radio',
                                disabled: !!$node.attr('disabled'),
                                name: $node.attr('label'),
                                radio: $node.attr('radiogroup'),
                                value: $node.attr('id'),
                                selected: !!$node.attr('checked')
                            };
                            break;

                        default:
                            item = undefined;
                    }
                    break;

                case 'hr':
                    item = '-------';
                    break;

                case 'input':
                    switch ($node.attr('type')) {
                        case 'text':
                            item = {
                                type: 'text',
                                name: label || inputLabel(node),
                                disabled: !!$node.attr('disabled'),
                                value: $node.val()
                            };
                            break;

                        case 'checkbox':
                            item = {
                                type: 'checkbox',
                                name: label || inputLabel(node),
                                disabled: !!$node.attr('disabled'),
                                selected: !!$node.attr('checked')
                            };
                            break;

                        case 'radio':
                            item = {
                                type: 'radio',
                                name: label || inputLabel(node),
                                disabled: !!$node.attr('disabled'),
                                radio: !!$node.attr('name'),
                                value: $node.val(),
                                selected: !!$node.attr('checked')
                            };
                            break;

                        default:
                            item = undefined;
                            break;
                    }
                    break;

                case 'select':
                    item = {
                        type: 'select',
                        name: label || inputLabel(node),
                        disabled: !!$node.attr('disabled'),
                        selected: $node.val(),
                        options: {}
                    };
                    $node.children().each(function () {
                        item.options[this.value] = $(this).text();
                    });
                    break;

                case 'textarea':
                    item = {
                        type: 'textarea',
                        name: label || inputLabel(node),
                        disabled: !!$node.attr('disabled'),
                        value: $node.val()
                    };
                    break;

                case 'label':
                    break;

                default:
                    item = {type: 'html', html: $node.clone(true)};
                    break;
            }

            if (item) {
                counter++;
                items['key' + counter] = item;
            }
        });

        return counter;
    }

// convert html5 menu
    $.contextMenu.fromMenu = function (element) {
        var $this = $(element),
            items = {};

        menuChildren(items, $this.children());

        return items;
    };

// make defaults accessible
    $.contextMenu.defaults = defaults;
    $.contextMenu.types = types;
// export internal functions - undocumented, for hacking only!
    $.contextMenu.handle = handle;
    $.contextMenu.op = op;
    $.contextMenu.menus = menus;
});


/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Expanding Textareas
// https://github.com/bgrins/ExpandingTextareas

(function(factory) {
    // Add jQuery via AMD registration or browser globals
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(4) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    else {
        factory(jQuery);
    }
}(function ($) {
    $.expandingTextarea = $.extend({
        autoInitialize: true,
        initialSelector: "textarea.expanding",
        opts: {
            resize: function() { }
        }
    }, $.expandingTextarea || {});

    var cloneCSSProperties = [
        'lineHeight', 'textDecoration', 'letterSpacing',
        'fontSize', 'fontFamily', 'fontStyle',
        'fontWeight', 'textTransform', 'textAlign',
        'direction', 'wordSpacing', 'fontSizeAdjust',
        'wordWrap', 'word-break',
        'borderLeftWidth', 'borderRightWidth',
        'borderTopWidth','borderBottomWidth',
        'paddingLeft', 'paddingRight',
        'paddingTop','paddingBottom',
        'marginLeft', 'marginRight',
        'marginTop','marginBottom',
        'boxSizing', 'webkitBoxSizing', 'mozBoxSizing', 'msBoxSizing'
    ];

    var textareaCSS = {
        position: "absolute",
        height: "100%",
        resize: "none"
    };

    var preCSS = {
        visibility: "hidden",
        border: "0 solid"
    };

    var containerCSS = {
        position: "relative"
    };

    function resize() {
        $(this).closest('.expandingText').find("div").text(this.value.replace(/\r\n/g, "\n") + ' ');
        $(this).trigger("resize.expanding");
    }

    $.fn.expandingTextarea = function(o) {

        var opts = $.extend({ }, $.expandingTextarea.opts, o);

        if (o === "resize") {
            return this.trigger("input.expanding");
        }

        if (o === "destroy") {
            this.filter(".expanding-init").each(function() {
                var textarea = $(this).removeClass('expanding-init');
                var container = textarea.closest('.expandingText');

                container.before(textarea).remove();
                textarea
                    .attr('style', textarea.data('expanding-styles') || '')
                    .removeData('expanding-styles');
            });

            return this;
        }

        this.filter("textarea").not(".expanding-init").addClass("expanding-init").each(function() {
            var textarea = $(this);

            textarea.wrap("<div class='expandingText'></div>");
            textarea.after("<pre class='textareaClone'><div></div></pre>");

            var container = textarea.parent().css(containerCSS);
            var pre = container.find("pre").css(preCSS);

            pre.css(textarea.attr("wrap") === "off" ? {overflowX: "scroll"} : {whiteSpace: "pre"});
            // original line below -- fixed for MOS-567
            // pre.css(textarea.attr("wrap") === "off" ? {overflowX: "scroll"} : {whiteSpace: "pre-wrap"});

            // Store the original styles in case of destroying.
            textarea.data('expanding-styles', textarea.attr('style'));
            textarea.css(textareaCSS);

            $.each(cloneCSSProperties, function(i, p) {
                var val = textarea.css(p);

                // Only set if different to prevent overriding percentage css values.
                if (pre.css(p) !== val) {
                    pre.css(p, val);
                }
            });
            container.css({"min-height": textarea.outerHeight(true)});

            textarea.bind("input.expanding propertychange.expanding keyup.expanding change.expanding", resize);
            resize.apply(this);

            if (opts.resize) {
                textarea.bind("resize.expanding", opts.resize);
            }
        });

        return this;
    };

    $(function () {
        if ($.expandingTextarea.autoInitialize) {
            $($.expandingTextarea.initialSelector).expandingTextarea();
        }
    });

}));


/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;// Largely modified version of jquery.tinyscrollbar
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $       = __webpack_require__(4),
        KeyCode = __webpack_require__(88),
        Browser = __webpack_require__(39);

    var pluginName      = "tinyscrollbar",
        $document       = $(document),
        wheelEvent      = ("onwheel" in document || document.documentMode >= 9) ? "wheel" :
                            (document.onmousewheel !== undefined ? "mousewheel" : "DOMMouseScroll"),

        defaults   = {
            axis            : "y",    // Vertical or horizontal scrollbar? ( x || y ).
            wheel           : true,   // Enable or disable the mousewheel;
            wheelLock       : true,   // Lock default scrolling window when there is no more content.
            scrollInvert    : false,  // Enable invert style scrolling
            trackSize       : false,  // Set the size of the scrollbar to auto or a fixed number.
            extraContentSize: 0,       // any extra content size that isn't positioned within the layout, but we should take into account when calculating the content size. Example: absolutely positioned content
            contentPosition : 0,
            contentOffset   : 0
        };

    // Constructor
    function TinyScrollbar ($viewport, options) {

        this.options   = $.extend({}, defaults, options);
        this.disable   = false;

        var self          = this,
            $scrollbar    = this.options.scrollbar,
            $overview     = $viewport.find(".overview"),
            $scrollTarget = $overview.find(".scroll-target"),
            $track        = $scrollbar.find(".track"),
            $bar          = $scrollbar.find(".bar"),

            isSpacePressed = false,
            isBarDragged   = false,
            isDragged      = false,
            isHorizontal   = this.options.axis === "x",
            sizeLabel      = isHorizontal ? "width" : "height",
            positionLabel  = isHorizontal ? "left" : "top",
            sizeLabelCap   = isHorizontal ? "Width" : "Height",

            startPosition   = 0,
            prevPosition    = 0,
            contentPosition = 0,
            viewportSize    = 0,
            contentSize     = 0,
            contentRatio    = 0,
            trackRatio      = 0,
            barSize         = 0,
            trackSize       = this.options.trackSize,

            maxContentPosition = contentSize - viewportSize;

        function initialize () {
            attachEventListeners();
            compute();

            // Normalize the position to beginning for all browsers, fix for Firefox
            $overview.css(positionLabel, 0);

            // Initialize scroll bar
            $scrollbar.css(sizeLabel, trackSize);
            $track.css(sizeLabel, trackSize);

            return self;
        }

        // limit the position within the range 0~max, max should not be negative
        // This is to ensure that content should always be set in a valid position
        function limit(position) {
            return Math.round(Math.min(Math.max(0, maxContentPosition), Math.max(0, position)));
        }

        // Need recompute after resize of content or window (getBoundingClientRect takes scale into account)
        function compute () {
            viewportSize = $viewport[0]["offset"+ sizeLabelCap];
            contentSize  = $scrollTarget[0].getBoundingClientRect()[sizeLabel] + self.options.extraContentSize;
            contentRatio = viewportSize / contentSize;
            barSize      = trackSize * contentRatio;
            trackRatio   = contentSize / trackSize;
            maxContentPosition = contentSize - viewportSize;

            $bar.css(sizeLabel, barSize);
            self.disable = contentRatio >= 1;
            $scrollbar.toggleClass("disable", self.disable);
        }

        function attachEventListeners () {
            $bar.bind("mousedown", start);
            $track.bind("mousedown", click);
            $scrollTarget.bind("mousedown", start);

            // Jquery resize event name has been changed to cresize, because with "resize" name, when the event is
            // triggered on element, it will propagate and invoke the window resize, which is not necessary.
            $scrollTarget.on("cresize", self.update);
            $(window).resize(self.update);

            // scroll events
            if (self.options.wheel) {
                if(window.addEventListener) {
                    $viewport[0].addEventListener(wheelEvent, wheel, false);
                } else {
                    $viewport[0].onmousewheel = wheel;
                }
            }

            // Add pannable css
            $document.keydown(function(evt) {
                if (evt.which === KeyCode.SPACE && !isSpacePressed && !$(document.activeElement).is("input, textarea")) {
                    $scrollTarget.addClass("pannable");
                    isSpacePressed = true;
                }
            });

            $document.keyup(function(evt) {
                if (evt.which === KeyCode.SPACE) {
                    $scrollTarget.removeClass("pannable");
                    isSpacePressed = false;
                }
            });
        }

        // Start dragging event
        function start(event) {
            startPosition = isHorizontal ? event.pageX : event.pageY;
            isBarDragged  = $(event.target).is($bar);
            isDragged     = false;

            $document.bind("mousemove", drag);
            $document.bind("mouseup", end);

            // We can not just prevent default here without condition, because the textWidget needs
            // mouse event to blur editing mode
            if (isSpacePressed || isBarDragged) {
                event.preventDefault();
            }
        }

        function setPosition (position, shouldAnimate) {
            // Event triggered at the end of the position move.
            // Triggered on the scrollbar element. (MOS-2553)
            var onCompletedMovePosition = function(){
                $bar.trigger("move");
            };

            // Event triggered at the start of a position move.
            // Only fires if previous position is different to new position
            var onStartMoving = function (){
                $bar.trigger("startMove");
            };

            position = limit(position);

            self.options.contentOffset = position;

            $overview.stop(true, true);

            if(prevPosition !== position){
                onStartMoving();
            }

            if (shouldAnimate) {
                var animateParam = {};
                animateParam[positionLabel] = "-=" + (position - prevPosition);
                $overview.animate(animateParam, {
                    duration: 200,
                    complete: onCompletedMovePosition
                });
            } else {
                $overview.css(positionLabel, -position);
                onCompletedMovePosition();
            }

            // update bar position
            $bar.css(positionLabel, position / trackRatio);

            // store the position to compute offset for animation
            prevPosition = position;
        }

        this.update = function () {
            compute();

            // Only when position is invalid, we need to update the position
            if (contentPosition !== limit(contentPosition)) {
                contentPosition = limit(contentPosition);
                setPosition(contentPosition);
            }

            return self;
        };

        /**
         * Scroll to a position
         * @param scrollTo
         * @param value
         * @param shouldUpdate   should the scroll bar be recomputed before scroll
         * @param shouldAnimate  should scroll with animation
         */
        this.scrollTo = function (scrollTo, value, shouldUpdate, shouldAnimate) {
            if (shouldUpdate) {
                compute();
            }

            switch (scrollTo) {
            case "beginning":
                contentPosition = 0;
                break;

            case "absolute":
                contentPosition = parseInt(value, 10) || 0;
                break;

            case "offset":
                contentPosition -= value;
                break;

            case "center":
                contentPosition = value - viewportSize / 2;
                break;

            case "relative":
                break;
            case "visible":
                const scrollBarSizeOffset = 60;
                const scrollBottom = viewportSize + contentPosition - scrollBarSizeOffset;
                if (value > scrollBottom) {
                    const scrollDelta = value - scrollBottom + scrollBarSizeOffset;
                    contentPosition = scrollDelta + contentPosition;
                }
                break;
            default:
                // contentPosition = scrollTo;
                break;
            }

            contentPosition = limit(contentPosition);
            setPosition(contentPosition, shouldAnimate);
        };

        // Mouse wheel or touchpad scroll event
        function wheel (event) {
            if (event.shiftKey) {
                $scrollTarget.trigger("scrollToZoom", event);
                event.preventDefault();
                return;
            }

            if (self.disable) {
                return;
            }

            var scallbarV      = $viewport.data("tinyscrollbar").y,
                isScollbarVOn  = scallbarV && !scallbarV.disable,
                _axis      = self.options.axis.toUpperCase(),
                evntObj    = event || window.event,
                deltaDir   = "delta" + _axis,
                deltaY     = "deltaY",
                deltaSpeed = 0;

            // If we don't have a vertical scroll bar and users scroll vertically on touchpad,
            // we fall it back to horizontal scroll action
            if (evntObj[deltaDir] !== undefined) {
                deltaSpeed = evntObj[deltaDir] || (_axis === "X" && !isScollbarVOn && evntObj[deltaY]);
            } else if (evntObj.wheelDelta !== undefined) {
                deltaDir = "wheelDelta" + _axis;
                deltaY   = "wheelDeltaY";
                deltaSpeed = evntObj[deltaDir] || (_axis === "X" && !isScollbarVOn && evntObj[deltaY]);
                deltaSpeed = deltaSpeed / 3;
            } else if (evntObj.detail) {
                deltaSpeed = evntObj.detail;
            }

            // FF in windows need to compensate the speed.
            if (navigator.platform.indexOf("Win")!== -1 && Browser.capabilities.browser.firefox) {
                deltaSpeed *= 7;
            }

            self.scrollTo("offset", -deltaSpeed, false, false);
            event.preventDefault();
        }

        // Dragging bar or content event
        function drag (event) {
            if (!isBarDragged && !isSpacePressed) {
                return;
            }

            isDragged = true;
            var mousePositionNew   = isHorizontal ? event.pageX : event.pageY,
                moveDelta = mousePositionNew - startPosition,
                barPositionNew,
                contentPositionNew;

            if(isBarDragged) {
                barPositionNew     = contentPosition / trackRatio + moveDelta;
                contentPositionNew = barPositionNew * trackRatio;
            } else {
                contentPositionNew = contentPosition - moveDelta;
            }

            setPosition(contentPositionNew, false);
            event.preventDefault();
        }

        // Click on track event
        function click (event) {
            if (!($(event.target).is($track))) {
                return;
            }

            var posX = $track.offset().left,
                posY = $track.offset().top,
                barPosition = (isHorizontal ? event.pageX - posX : event.pageY - posY) - barSize / 2;

            contentPosition = barPosition * trackRatio;
            self.scrollTo("absolute", contentPosition, false, false);
        }

        function end () {
            $document.unbind("mousemove", drag);
            $document.unbind("mouseup", end);

            if (isDragged) {
                // Update the final position after dragging
                contentPosition = -parseInt($overview.css(positionLabel), 10) || 0;
            }
        }

        return initialize();
    }

    // Plugin definition
    $.fn[pluginName] = function(options) {
        return this.each(function() {
            var scrollbars = $.data(this, pluginName) || {};
            scrollbars.x = options.x && new TinyScrollbar($(this), $.extend({axis: "x"}, options.x));
            scrollbars.y = options.y && new TinyScrollbar($(this), $.extend({axis: "y"}, options.y));
            $.data(this, pluginName, scrollbars);
        });
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/*!
 * jQuery resize event - v1.1 - 3/14/2010
 * http://benalman.com/projects/jquery-resize-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery resize event
//
// *Version: 1.1, Last updated: 3/14/2010*
//
// Project Home - http://benalman.com/projects/jquery-resize-plugin/
// GitHub       - http://github.com/cowboy/jquery-resize/
// Source       - http://github.com/cowboy/jquery-resize/raw/master/jquery.ba-resize.js
// (Minified)   - http://github.com/cowboy/jquery-resize/raw/master/jquery.ba-resize.min.js (1.0kb)
//
// About: License
//
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
//
// About: Examples
//
// This working example, complete with fully commented code, illustrates a few
// ways in which this plugin can be used.
//
// resize event - http://benalman.com/code/projects/jquery-resize/examples/resize/
//
// About: Support and Testing
//
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
//
// jQuery Versions - 1.3.2, 1.4.1, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-resize/unit/
//
// About: Release History
//
// 1.1 - (3/14/2010) Fixed a minor bug that was causing the event to trigger
//       immediately after bind in some circumstances. Also changed $.fn.data
//       to $.data to improve performance.
// 1.0 - (2/10/2010) Initial release

(function($,window,undefined){
    "use strict";

    // A jQuery object containing all non-window elements to which the resize
    // event is bound.
    var elems = $([]),

    // Extend $.resize if it already exists, otherwise create it.
        jq_resize = $.resize = $.extend( $.resize, {} ),

        timeout_id,

    // Reused strings.
        str_setTimeout = 'setTimeout',
        str_resize = 'cresize',
        str_data = str_resize + '-special-event',
        str_delay = 'delay',
        str_throttle = 'throttleWindow';

    // Property: jQuery.resize.delay
    //
    // The numeric interval (in milliseconds) at which the resize event polling
    // loop executes. Defaults to 50.

    jq_resize[ str_delay ] = 50;

    // Property: jQuery.resize.throttleWindow
    //
    // Throttle the native window object resize event to fire no more than once
    // every <jQuery.resize.delay> milliseconds. Defaults to true.
    //
    // Because the window object has its own resize event, it doesn't need to be
    // provided by this plugin, and its execution can be left entirely up to the
    // browser. However, since certain browsers fire the resize event continuously
    // while others do not, enabling this will throttle the window resize event,
    // making event behavior consistent across all elements in all browsers.
    //
    // While setting this property to false will disable window object resize
    // event throttling, please note that this property must be changed before any
    // window object resize event callbacks are bound.

    jq_resize[ str_throttle ] = true;

    // Event: resize event
    //
    // Fired when an element's width or height changes. Because browsers only
    // provide this event for the window element, for other elements a polling
    // loop is initialized, running every <jQuery.resize.delay> milliseconds
    // to see if elements' dimensions have changed. You may bind with either
    // .resize( fn ) or .bind( "resize", fn ), and unbind with .unbind( "resize" ).
    //
    // Usage:
    //
    // > jQuery('selector').bind( 'resize', function(e) {
    // >   // element's width or height has changed!
    // >   ...
    // > });
    //
    // Additional Notes:
    //
    // * The polling loop is not created until at least one callback is actually
    //   bound to the 'resize' event, and this single polling loop is shared
    //   across all elements.
    //
    // Double firing issue in jQuery 1.3.2:
    //
    // While this plugin works in jQuery 1.3.2, if an element's event callbacks
    // are manually triggered via .trigger( 'resize' ) or .resize() those
    // callbacks may double-fire, due to limitations in the jQuery 1.3.2 special
    // events system. This is not an issue when using jQuery 1.4+.
    //
    // > // While this works in jQuery 1.4+
    // > $(elem).css({ width: new_w, height: new_h }).resize();
    // >
    // > // In jQuery 1.3.2, you need to do this:
    // > var elem = $(elem);
    // > elem.css({ width: new_w, height: new_h });
    // > elem.data( 'resize-special-event', { width: elem.width(), height: elem.height() } );
    // > elem.resize();

    $.event.special[ str_resize ] = {

        // Called only when the first 'resize' event callback is bound per element.
        setup: function() {
            // Since window has its own native 'resize' event, return false so that
            // jQuery will bind the event using DOM methods. Since only 'window'
            // objects have a .setTimeout method, this should be a sufficient test.
            // Unless, of course, we're throttling the 'resize' event for window.
            if ( !jq_resize[ str_throttle ] && this[ str_setTimeout ] ) { return false; }

            var elem = $(this),
                size = this.getBoundingClientRect();

            // Add this element to the list of internal elements to monitor.
            elems = elems.add( elem );

            // Initialize data store on the element.
            $.data( this, str_data, { w: size.width, h: size.height } );

            // If this is the first element added, start the polling loop.
            if ( elems.length === 1 ) {
                loopy();
            }
        },

        // Called only when the last 'resize' event callback is unbound per element.
        teardown: function() {
            // Since window has its own native 'resize' event, return false so that
            // jQuery will unbind the event using DOM methods. Since only 'window'
            // objects have a .setTimeout method, this should be a sufficient test.
            // Unless, of course, we're throttling the 'resize' event for window.
            if ( !jq_resize[ str_throttle ] && this[ str_setTimeout ] ) { return false; }

            var elem = $(this);

            // Remove this element from the list of internal elements to monitor.
            elems = elems.not( elem );

            // Remove any data stored on the element.
            elem.removeData( str_data );

            // If this is the last element removed, stop the polling loop.
            if ( !elems.length ) {
                clearTimeout( timeout_id );
            }
        },

        // Called every time a 'resize' event callback is bound per element (new in
        // jQuery 1.4).
        add: function( handleObj ) {
            // Since window has its own native 'resize' event, return false so that
            // jQuery doesn't modify the event object. Unless, of course, we're
            // throttling the 'resize' event for window.
            if ( !jq_resize[ str_throttle ] && this[ str_setTimeout ] ) { return false; }

            var old_handler;

            // The new_handler function is executed every time the event is triggered.
            // This is used to update the internal element data store with the width
            // and height when the event is triggered manually, to avoid double-firing
            // of the event callback. See the "Double firing issue in jQuery 1.3.2"
            // comments above for more information.

            function new_handler( e, w, h ) {
                var elem = $(this),
                    size = this.getBoundingClientRect(),
                    data = $.data( this, str_data );

                // If called from the polling loop, w and h will be passed in as
                // arguments. If called manually, via .trigger( 'resize' ) or .resize(),
                // those values will need to be computed.
                data.w = w !== undefined ? w : size.width;
                data.h = h !== undefined ? h : size.height;

                old_handler.apply( this, arguments );
            }

            // This may seem a little complicated, but it normalizes the special event
            // .add method between jQuery 1.4/1.4.1 and 1.4.2+
            if ( $.isFunction( handleObj ) ) {
                // 1.4, 1.4.1
                old_handler = handleObj;
                return new_handler;
            } else {
                // 1.4.2+
                old_handler = handleObj.handler;
                handleObj.handler = new_handler;
            }
        }

    };

    function loopy() {

        // Start the polling loop, asynchronously.
        timeout_id = window[ str_setTimeout ](function(){

            // Iterate over all elements to which the 'resize' event is bound.
            elems.each(function(){
                var elem = $(this),
                    size = this.getBoundingClientRect(),
                    width = size.width,
                    height = size.height,
                    data = $.data( this, str_data );

                // If element size has changed since the last time, update the element
                // data store and trigger the 'resize' event.
                if (data && (width !== data.w || height !== data.h)) {
                    elem.trigger( str_resize, [ data.w = width, data.h = height ] );
                }

            });

            // Loop.
            loopy();

        }, jq_resize[ str_delay ] );

    }

})(jQuery,window);



/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/*
Copyright 2012 Igor Vaynberg

Version: 3.5.2 Timestamp: Sat Nov  1 14:43:36 EDT 2014

This software is licensed under the Apache License, Version 2.0 (the "Apache License") or the GNU
General Public License version 2 (the "GPL License"). You may choose either license to govern your
use of this software only upon the condition that you accept all of the terms of either the Apache
License or the GPL License.

You may obtain a copy of the Apache License and the GPL License at:

    http://www.apache.org/licenses/LICENSE-2.0
    http://www.gnu.org/licenses/gpl-2.0.html

Unless required by applicable law or agreed to in writing, software distributed under the
Apache License or the GPL License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
CONDITIONS OF ANY KIND, either express or implied. See the Apache License and the GPL License for
the specific language governing permissions and limitations under the Apache License and the GPL License.
*/
(function ($) {
    if(typeof $.fn.each2 == "undefined") {
        $.extend($.fn, {
            /*
            * 4-10 times faster .each replacement
            * use it carefully, as it overrides jQuery context of element on each iteration
            */
            each2 : function (c) {
                var j = $([0]), i = -1, l = this.length;
                while (
                    ++i < l
                    && (j.context = j[0] = this[i])
                    && c.call(j[0], i, j) !== false //"this"=DOM, i=index, j=jQuery object
                );
                return this;
            }
        });
    }
})(jQuery);

(function ($, undefined) {
    "use strict";
    /*global document, window, jQuery, console */

    if (window.Select2 !== undefined) {
        return;
    }

    var AbstractSelect2, SingleSelect2, MultiSelect2, nextUid, sizer,
        lastMousePosition={x:0,y:0}, $document, scrollBarDimensions,

    KEY = {
        TAB: 9,
        ENTER: 13,
        ESC: 27,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40,
        SHIFT: 16,
        CTRL: 17,
        ALT: 18,
        PAGE_UP: 33,
        PAGE_DOWN: 34,
        HOME: 36,
        END: 35,
        BACKSPACE: 8,
        DELETE: 46,
        isArrow: function (k) {
            k = k.which ? k.which : k;
            switch (k) {
            case KEY.LEFT:
            case KEY.RIGHT:
            case KEY.UP:
            case KEY.DOWN:
                return true;
            }
            return false;
        },
        isControl: function (e) {
            var k = e.which;
            switch (k) {
            case KEY.SHIFT:
            case KEY.CTRL:
            case KEY.ALT:
                return true;
            }

            if (e.metaKey) return true;

            return false;
        },
        isFunctionKey: function (k) {
            k = k.which ? k.which : k;
            return k >= 112 && k <= 123;
        }
    },
    MEASURE_SCROLLBAR_TEMPLATE = "<div class='select2-measure-scrollbar'></div>",

    DIACRITICS = {"\u24B6":"A","\uFF21":"A","\u00C0":"A","\u00C1":"A","\u00C2":"A","\u1EA6":"A","\u1EA4":"A","\u1EAA":"A","\u1EA8":"A","\u00C3":"A","\u0100":"A","\u0102":"A","\u1EB0":"A","\u1EAE":"A","\u1EB4":"A","\u1EB2":"A","\u0226":"A","\u01E0":"A","\u00C4":"A","\u01DE":"A","\u1EA2":"A","\u00C5":"A","\u01FA":"A","\u01CD":"A","\u0200":"A","\u0202":"A","\u1EA0":"A","\u1EAC":"A","\u1EB6":"A","\u1E00":"A","\u0104":"A","\u023A":"A","\u2C6F":"A","\uA732":"AA","\u00C6":"AE","\u01FC":"AE","\u01E2":"AE","\uA734":"AO","\uA736":"AU","\uA738":"AV","\uA73A":"AV","\uA73C":"AY","\u24B7":"B","\uFF22":"B","\u1E02":"B","\u1E04":"B","\u1E06":"B","\u0243":"B","\u0182":"B","\u0181":"B","\u24B8":"C","\uFF23":"C","\u0106":"C","\u0108":"C","\u010A":"C","\u010C":"C","\u00C7":"C","\u1E08":"C","\u0187":"C","\u023B":"C","\uA73E":"C","\u24B9":"D","\uFF24":"D","\u1E0A":"D","\u010E":"D","\u1E0C":"D","\u1E10":"D","\u1E12":"D","\u1E0E":"D","\u0110":"D","\u018B":"D","\u018A":"D","\u0189":"D","\uA779":"D","\u01F1":"DZ","\u01C4":"DZ","\u01F2":"Dz","\u01C5":"Dz","\u24BA":"E","\uFF25":"E","\u00C8":"E","\u00C9":"E","\u00CA":"E","\u1EC0":"E","\u1EBE":"E","\u1EC4":"E","\u1EC2":"E","\u1EBC":"E","\u0112":"E","\u1E14":"E","\u1E16":"E","\u0114":"E","\u0116":"E","\u00CB":"E","\u1EBA":"E","\u011A":"E","\u0204":"E","\u0206":"E","\u1EB8":"E","\u1EC6":"E","\u0228":"E","\u1E1C":"E","\u0118":"E","\u1E18":"E","\u1E1A":"E","\u0190":"E","\u018E":"E","\u24BB":"F","\uFF26":"F","\u1E1E":"F","\u0191":"F","\uA77B":"F","\u24BC":"G","\uFF27":"G","\u01F4":"G","\u011C":"G","\u1E20":"G","\u011E":"G","\u0120":"G","\u01E6":"G","\u0122":"G","\u01E4":"G","\u0193":"G","\uA7A0":"G","\uA77D":"G","\uA77E":"G","\u24BD":"H","\uFF28":"H","\u0124":"H","\u1E22":"H","\u1E26":"H","\u021E":"H","\u1E24":"H","\u1E28":"H","\u1E2A":"H","\u0126":"H","\u2C67":"H","\u2C75":"H","\uA78D":"H","\u24BE":"I","\uFF29":"I","\u00CC":"I","\u00CD":"I","\u00CE":"I","\u0128":"I","\u012A":"I","\u012C":"I","\u0130":"I","\u00CF":"I","\u1E2E":"I","\u1EC8":"I","\u01CF":"I","\u0208":"I","\u020A":"I","\u1ECA":"I","\u012E":"I","\u1E2C":"I","\u0197":"I","\u24BF":"J","\uFF2A":"J","\u0134":"J","\u0248":"J","\u24C0":"K","\uFF2B":"K","\u1E30":"K","\u01E8":"K","\u1E32":"K","\u0136":"K","\u1E34":"K","\u0198":"K","\u2C69":"K","\uA740":"K","\uA742":"K","\uA744":"K","\uA7A2":"K","\u24C1":"L","\uFF2C":"L","\u013F":"L","\u0139":"L","\u013D":"L","\u1E36":"L","\u1E38":"L","\u013B":"L","\u1E3C":"L","\u1E3A":"L","\u0141":"L","\u023D":"L","\u2C62":"L","\u2C60":"L","\uA748":"L","\uA746":"L","\uA780":"L","\u01C7":"LJ","\u01C8":"Lj","\u24C2":"M","\uFF2D":"M","\u1E3E":"M","\u1E40":"M","\u1E42":"M","\u2C6E":"M","\u019C":"M","\u24C3":"N","\uFF2E":"N","\u01F8":"N","\u0143":"N","\u00D1":"N","\u1E44":"N","\u0147":"N","\u1E46":"N","\u0145":"N","\u1E4A":"N","\u1E48":"N","\u0220":"N","\u019D":"N","\uA790":"N","\uA7A4":"N","\u01CA":"NJ","\u01CB":"Nj","\u24C4":"O","\uFF2F":"O","\u00D2":"O","\u00D3":"O","\u00D4":"O","\u1ED2":"O","\u1ED0":"O","\u1ED6":"O","\u1ED4":"O","\u00D5":"O","\u1E4C":"O","\u022C":"O","\u1E4E":"O","\u014C":"O","\u1E50":"O","\u1E52":"O","\u014E":"O","\u022E":"O","\u0230":"O","\u00D6":"O","\u022A":"O","\u1ECE":"O","\u0150":"O","\u01D1":"O","\u020C":"O","\u020E":"O","\u01A0":"O","\u1EDC":"O","\u1EDA":"O","\u1EE0":"O","\u1EDE":"O","\u1EE2":"O","\u1ECC":"O","\u1ED8":"O","\u01EA":"O","\u01EC":"O","\u00D8":"O","\u01FE":"O","\u0186":"O","\u019F":"O","\uA74A":"O","\uA74C":"O","\u01A2":"OI","\uA74E":"OO","\u0222":"OU","\u24C5":"P","\uFF30":"P","\u1E54":"P","\u1E56":"P","\u01A4":"P","\u2C63":"P","\uA750":"P","\uA752":"P","\uA754":"P","\u24C6":"Q","\uFF31":"Q","\uA756":"Q","\uA758":"Q","\u024A":"Q","\u24C7":"R","\uFF32":"R","\u0154":"R","\u1E58":"R","\u0158":"R","\u0210":"R","\u0212":"R","\u1E5A":"R","\u1E5C":"R","\u0156":"R","\u1E5E":"R","\u024C":"R","\u2C64":"R","\uA75A":"R","\uA7A6":"R","\uA782":"R","\u24C8":"S","\uFF33":"S","\u1E9E":"S","\u015A":"S","\u1E64":"S","\u015C":"S","\u1E60":"S","\u0160":"S","\u1E66":"S","\u1E62":"S","\u1E68":"S","\u0218":"S","\u015E":"S","\u2C7E":"S","\uA7A8":"S","\uA784":"S","\u24C9":"T","\uFF34":"T","\u1E6A":"T","\u0164":"T","\u1E6C":"T","\u021A":"T","\u0162":"T","\u1E70":"T","\u1E6E":"T","\u0166":"T","\u01AC":"T","\u01AE":"T","\u023E":"T","\uA786":"T","\uA728":"TZ","\u24CA":"U","\uFF35":"U","\u00D9":"U","\u00DA":"U","\u00DB":"U","\u0168":"U","\u1E78":"U","\u016A":"U","\u1E7A":"U","\u016C":"U","\u00DC":"U","\u01DB":"U","\u01D7":"U","\u01D5":"U","\u01D9":"U","\u1EE6":"U","\u016E":"U","\u0170":"U","\u01D3":"U","\u0214":"U","\u0216":"U","\u01AF":"U","\u1EEA":"U","\u1EE8":"U","\u1EEE":"U","\u1EEC":"U","\u1EF0":"U","\u1EE4":"U","\u1E72":"U","\u0172":"U","\u1E76":"U","\u1E74":"U","\u0244":"U","\u24CB":"V","\uFF36":"V","\u1E7C":"V","\u1E7E":"V","\u01B2":"V","\uA75E":"V","\u0245":"V","\uA760":"VY","\u24CC":"W","\uFF37":"W","\u1E80":"W","\u1E82":"W","\u0174":"W","\u1E86":"W","\u1E84":"W","\u1E88":"W","\u2C72":"W","\u24CD":"X","\uFF38":"X","\u1E8A":"X","\u1E8C":"X","\u24CE":"Y","\uFF39":"Y","\u1EF2":"Y","\u00DD":"Y","\u0176":"Y","\u1EF8":"Y","\u0232":"Y","\u1E8E":"Y","\u0178":"Y","\u1EF6":"Y","\u1EF4":"Y","\u01B3":"Y","\u024E":"Y","\u1EFE":"Y","\u24CF":"Z","\uFF3A":"Z","\u0179":"Z","\u1E90":"Z","\u017B":"Z","\u017D":"Z","\u1E92":"Z","\u1E94":"Z","\u01B5":"Z","\u0224":"Z","\u2C7F":"Z","\u2C6B":"Z","\uA762":"Z","\u24D0":"a","\uFF41":"a","\u1E9A":"a","\u00E0":"a","\u00E1":"a","\u00E2":"a","\u1EA7":"a","\u1EA5":"a","\u1EAB":"a","\u1EA9":"a","\u00E3":"a","\u0101":"a","\u0103":"a","\u1EB1":"a","\u1EAF":"a","\u1EB5":"a","\u1EB3":"a","\u0227":"a","\u01E1":"a","\u00E4":"a","\u01DF":"a","\u1EA3":"a","\u00E5":"a","\u01FB":"a","\u01CE":"a","\u0201":"a","\u0203":"a","\u1EA1":"a","\u1EAD":"a","\u1EB7":"a","\u1E01":"a","\u0105":"a","\u2C65":"a","\u0250":"a","\uA733":"aa","\u00E6":"ae","\u01FD":"ae","\u01E3":"ae","\uA735":"ao","\uA737":"au","\uA739":"av","\uA73B":"av","\uA73D":"ay","\u24D1":"b","\uFF42":"b","\u1E03":"b","\u1E05":"b","\u1E07":"b","\u0180":"b","\u0183":"b","\u0253":"b","\u24D2":"c","\uFF43":"c","\u0107":"c","\u0109":"c","\u010B":"c","\u010D":"c","\u00E7":"c","\u1E09":"c","\u0188":"c","\u023C":"c","\uA73F":"c","\u2184":"c","\u24D3":"d","\uFF44":"d","\u1E0B":"d","\u010F":"d","\u1E0D":"d","\u1E11":"d","\u1E13":"d","\u1E0F":"d","\u0111":"d","\u018C":"d","\u0256":"d","\u0257":"d","\uA77A":"d","\u01F3":"dz","\u01C6":"dz","\u24D4":"e","\uFF45":"e","\u00E8":"e","\u00E9":"e","\u00EA":"e","\u1EC1":"e","\u1EBF":"e","\u1EC5":"e","\u1EC3":"e","\u1EBD":"e","\u0113":"e","\u1E15":"e","\u1E17":"e","\u0115":"e","\u0117":"e","\u00EB":"e","\u1EBB":"e","\u011B":"e","\u0205":"e","\u0207":"e","\u1EB9":"e","\u1EC7":"e","\u0229":"e","\u1E1D":"e","\u0119":"e","\u1E19":"e","\u1E1B":"e","\u0247":"e","\u025B":"e","\u01DD":"e","\u24D5":"f","\uFF46":"f","\u1E1F":"f","\u0192":"f","\uA77C":"f","\u24D6":"g","\uFF47":"g","\u01F5":"g","\u011D":"g","\u1E21":"g","\u011F":"g","\u0121":"g","\u01E7":"g","\u0123":"g","\u01E5":"g","\u0260":"g","\uA7A1":"g","\u1D79":"g","\uA77F":"g","\u24D7":"h","\uFF48":"h","\u0125":"h","\u1E23":"h","\u1E27":"h","\u021F":"h","\u1E25":"h","\u1E29":"h","\u1E2B":"h","\u1E96":"h","\u0127":"h","\u2C68":"h","\u2C76":"h","\u0265":"h","\u0195":"hv","\u24D8":"i","\uFF49":"i","\u00EC":"i","\u00ED":"i","\u00EE":"i","\u0129":"i","\u012B":"i","\u012D":"i","\u00EF":"i","\u1E2F":"i","\u1EC9":"i","\u01D0":"i","\u0209":"i","\u020B":"i","\u1ECB":"i","\u012F":"i","\u1E2D":"i","\u0268":"i","\u0131":"i","\u24D9":"j","\uFF4A":"j","\u0135":"j","\u01F0":"j","\u0249":"j","\u24DA":"k","\uFF4B":"k","\u1E31":"k","\u01E9":"k","\u1E33":"k","\u0137":"k","\u1E35":"k","\u0199":"k","\u2C6A":"k","\uA741":"k","\uA743":"k","\uA745":"k","\uA7A3":"k","\u24DB":"l","\uFF4C":"l","\u0140":"l","\u013A":"l","\u013E":"l","\u1E37":"l","\u1E39":"l","\u013C":"l","\u1E3D":"l","\u1E3B":"l","\u017F":"l","\u0142":"l","\u019A":"l","\u026B":"l","\u2C61":"l","\uA749":"l","\uA781":"l","\uA747":"l","\u01C9":"lj","\u24DC":"m","\uFF4D":"m","\u1E3F":"m","\u1E41":"m","\u1E43":"m","\u0271":"m","\u026F":"m","\u24DD":"n","\uFF4E":"n","\u01F9":"n","\u0144":"n","\u00F1":"n","\u1E45":"n","\u0148":"n","\u1E47":"n","\u0146":"n","\u1E4B":"n","\u1E49":"n","\u019E":"n","\u0272":"n","\u0149":"n","\uA791":"n","\uA7A5":"n","\u01CC":"nj","\u24DE":"o","\uFF4F":"o","\u00F2":"o","\u00F3":"o","\u00F4":"o","\u1ED3":"o","\u1ED1":"o","\u1ED7":"o","\u1ED5":"o","\u00F5":"o","\u1E4D":"o","\u022D":"o","\u1E4F":"o","\u014D":"o","\u1E51":"o","\u1E53":"o","\u014F":"o","\u022F":"o","\u0231":"o","\u00F6":"o","\u022B":"o","\u1ECF":"o","\u0151":"o","\u01D2":"o","\u020D":"o","\u020F":"o","\u01A1":"o","\u1EDD":"o","\u1EDB":"o","\u1EE1":"o","\u1EDF":"o","\u1EE3":"o","\u1ECD":"o","\u1ED9":"o","\u01EB":"o","\u01ED":"o","\u00F8":"o","\u01FF":"o","\u0254":"o","\uA74B":"o","\uA74D":"o","\u0275":"o","\u01A3":"oi","\u0223":"ou","\uA74F":"oo","\u24DF":"p","\uFF50":"p","\u1E55":"p","\u1E57":"p","\u01A5":"p","\u1D7D":"p","\uA751":"p","\uA753":"p","\uA755":"p","\u24E0":"q","\uFF51":"q","\u024B":"q","\uA757":"q","\uA759":"q","\u24E1":"r","\uFF52":"r","\u0155":"r","\u1E59":"r","\u0159":"r","\u0211":"r","\u0213":"r","\u1E5B":"r","\u1E5D":"r","\u0157":"r","\u1E5F":"r","\u024D":"r","\u027D":"r","\uA75B":"r","\uA7A7":"r","\uA783":"r","\u24E2":"s","\uFF53":"s","\u00DF":"s","\u015B":"s","\u1E65":"s","\u015D":"s","\u1E61":"s","\u0161":"s","\u1E67":"s","\u1E63":"s","\u1E69":"s","\u0219":"s","\u015F":"s","\u023F":"s","\uA7A9":"s","\uA785":"s","\u1E9B":"s","\u24E3":"t","\uFF54":"t","\u1E6B":"t","\u1E97":"t","\u0165":"t","\u1E6D":"t","\u021B":"t","\u0163":"t","\u1E71":"t","\u1E6F":"t","\u0167":"t","\u01AD":"t","\u0288":"t","\u2C66":"t","\uA787":"t","\uA729":"tz","\u24E4":"u","\uFF55":"u","\u00F9":"u","\u00FA":"u","\u00FB":"u","\u0169":"u","\u1E79":"u","\u016B":"u","\u1E7B":"u","\u016D":"u","\u00FC":"u","\u01DC":"u","\u01D8":"u","\u01D6":"u","\u01DA":"u","\u1EE7":"u","\u016F":"u","\u0171":"u","\u01D4":"u","\u0215":"u","\u0217":"u","\u01B0":"u","\u1EEB":"u","\u1EE9":"u","\u1EEF":"u","\u1EED":"u","\u1EF1":"u","\u1EE5":"u","\u1E73":"u","\u0173":"u","\u1E77":"u","\u1E75":"u","\u0289":"u","\u24E5":"v","\uFF56":"v","\u1E7D":"v","\u1E7F":"v","\u028B":"v","\uA75F":"v","\u028C":"v","\uA761":"vy","\u24E6":"w","\uFF57":"w","\u1E81":"w","\u1E83":"w","\u0175":"w","\u1E87":"w","\u1E85":"w","\u1E98":"w","\u1E89":"w","\u2C73":"w","\u24E7":"x","\uFF58":"x","\u1E8B":"x","\u1E8D":"x","\u24E8":"y","\uFF59":"y","\u1EF3":"y","\u00FD":"y","\u0177":"y","\u1EF9":"y","\u0233":"y","\u1E8F":"y","\u00FF":"y","\u1EF7":"y","\u1E99":"y","\u1EF5":"y","\u01B4":"y","\u024F":"y","\u1EFF":"y","\u24E9":"z","\uFF5A":"z","\u017A":"z","\u1E91":"z","\u017C":"z","\u017E":"z","\u1E93":"z","\u1E95":"z","\u01B6":"z","\u0225":"z","\u0240":"z","\u2C6C":"z","\uA763":"z","\u0386":"\u0391","\u0388":"\u0395","\u0389":"\u0397","\u038A":"\u0399","\u03AA":"\u0399","\u038C":"\u039F","\u038E":"\u03A5","\u03AB":"\u03A5","\u038F":"\u03A9","\u03AC":"\u03B1","\u03AD":"\u03B5","\u03AE":"\u03B7","\u03AF":"\u03B9","\u03CA":"\u03B9","\u0390":"\u03B9","\u03CC":"\u03BF","\u03CD":"\u03C5","\u03CB":"\u03C5","\u03B0":"\u03C5","\u03C9":"\u03C9","\u03C2":"\u03C3"};

    $document = $(document);

    nextUid=(function() { var counter=1; return function() { return counter++; }; }());


    function reinsertElement(element) {
        var placeholder = $(document.createTextNode(''));

        element.before(placeholder);
        placeholder.before(element);
        placeholder.remove();
    }

    function stripDiacritics(str) {
        // Used 'uni range + named function' from http://jsperf.com/diacritics/18
        function match(a) {
            return DIACRITICS[a] || a;
        }

        return str.replace(/[^\u0000-\u007E]/g, match);
    }

    function indexOf(value, array) {
        var i = 0, l = array.length;
        for (; i < l; i = i + 1) {
            if (equal(value, array[i])) return i;
        }
        return -1;
    }

    function measureScrollbar () {
        var $template = $( MEASURE_SCROLLBAR_TEMPLATE );
        $template.appendTo(document.body);

        var dim = {
            width: $template.width() - $template[0].clientWidth,
            height: $template.height() - $template[0].clientHeight
        };
        $template.remove();

        return dim;
    }

    /**
     * Compares equality of a and b
     * @param a
     * @param b
     */
    function equal(a, b) {
        if (a === b) return true;
        if (a === undefined || b === undefined) return false;
        if (a === null || b === null) return false;
        // Check whether 'a' or 'b' is a string (primitive or object).
        // The concatenation of an empty string (+'') converts its argument to a string's primitive.
        if (a.constructor === String) return a+'' === b+''; // a+'' - in case 'a' is a String object
        if (b.constructor === String) return b+'' === a+''; // b+'' - in case 'b' is a String object
        return false;
    }

    /**
     * Splits the string into an array of values, transforming each value. An empty array is returned for nulls or empty
     * strings
     * @param string
     * @param separator
     */
    function splitVal(string, separator, transform) {
        var val, i, l;
        if (string === null || string.length < 1) return [];
        val = string.split(separator);
        for (i = 0, l = val.length; i < l; i = i + 1) val[i] = transform(val[i]);
        return val;
    }

    function getSideBorderPadding(element) {
        return element.outerWidth(false) - element.width();
    }

    function installKeyUpChangeEvent(element) {
        var key="keyup-change-value";
        element.on("keydown", function () {
            if ($.data(element, key) === undefined) {
                $.data(element, key, element.val());
            }
        });
        element.on("keyup", function () {
            var val= $.data(element, key);
            if (val !== undefined && element.val() !== val) {
                $.removeData(element, key);
                element.trigger("keyup-change");
            }
        });
    }


    /**
     * filters mouse events so an event is fired only if the mouse moved.
     *
     * filters out mouse events that occur when mouse is stationary but
     * the elements under the pointer are scrolled.
     */
    function installFilteredMouseMove(element) {
        element.on("mousemove", function (e) {
            var lastpos = lastMousePosition;
            if (lastpos === undefined || lastpos.x !== e.pageX || lastpos.y !== e.pageY) {
                $(e.target).trigger("mousemove-filtered", e);
            }
        });
    }

    /**
     * Debounces a function. Returns a function that calls the original fn function only if no invocations have been made
     * within the last quietMillis milliseconds.
     *
     * @param quietMillis number of milliseconds to wait before invoking fn
     * @param fn function to be debounced
     * @param ctx object to be used as this reference within fn
     * @return debounced version of fn
     */
    function debounce(quietMillis, fn, ctx) {
        ctx = ctx || undefined;
        var timeout;
        return function () {
            var args = arguments;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function() {
                fn.apply(ctx, args);
            }, quietMillis);
        };
    }

    function installDebouncedScroll(threshold, element) {
        var notify = debounce(threshold, function (e) { element.trigger("scroll-debounced", e);});
        element.on("scroll", function (e) {
            if (indexOf(e.target, element.get()) >= 0) notify(e);
        });
    }

    function focus($el) {
        if ($el[0] === document.activeElement) return;

        /* set the focus in a 0 timeout - that way the focus is set after the processing
            of the current event has finished - which seems like the only reliable way
            to set focus */
        window.setTimeout(function() {
            var el=$el[0], pos=$el.val().length, range;

            $el.focus();

            /* make sure el received focus so we do not error out when trying to manipulate the caret.
                sometimes modals or others listeners may steal it after its set */
            var isVisible = (el.offsetWidth > 0 || el.offsetHeight > 0);
            if (isVisible && el === document.activeElement) {

                /* after the focus is set move the caret to the end, necessary when we val()
                    just before setting focus */
                if(el.setSelectionRange)
                {
                    el.setSelectionRange(pos, pos);
                }
                else if (el.createTextRange) {
                    range = el.createTextRange();
                    range.collapse(false);
                    range.select();
                }
            }
        }, 0);
    }

    function getCursorInfo(el) {
        el = $(el)[0];
        var offset = 0;
        var length = 0;
        if ('selectionStart' in el) {
            offset = el.selectionStart;
            length = el.selectionEnd - offset;
        } else if ('selection' in document) {
            el.focus();
            var sel = document.selection.createRange();
            length = document.selection.createRange().text.length;
            sel.moveStart('character', -el.value.length);
            offset = sel.text.length - length;
        }
        return { offset: offset, length: length };
    }

    function killEvent(event) {
        event.preventDefault();
        event.stopPropagation();
    }
    function killEventImmediately(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
    }

    function measureTextWidth(e) {
        if (!sizer){
            var style = e[0].currentStyle || window.getComputedStyle(e[0], null);
            sizer = $(document.createElement("div")).css({
                position: "absolute",
                left: "-10000px",
                top: "-10000px",
                display: "none",
                fontSize: style.fontSize,
                fontFamily: style.fontFamily,
                fontStyle: style.fontStyle,
                fontWeight: style.fontWeight,
                letterSpacing: style.letterSpacing,
                textTransform: style.textTransform,
                whiteSpace: "nowrap"
            });
            sizer.attr("class","select2-sizer");
            $(document.body).append(sizer);
        }
        sizer.text(e.val());
        return sizer.width();
    }

    function syncCssClasses(dest, src, adapter) {
        var classes, replacements = [], adapted;

        classes = $.trim(dest.attr("class"));

        if (classes) {
            classes = '' + classes; // for IE which returns object

            $(classes.split(/\s+/)).each2(function() {
                if (this.indexOf("select2-") === 0) {
                    replacements.push(this);
                }
            });
        }

        classes = $.trim(src.attr("class"));

        if (classes) {
            classes = '' + classes; // for IE which returns object

            $(classes.split(/\s+/)).each2(function() {
                if (this.indexOf("select2-") !== 0) {
                    adapted = adapter(this);

                    if (adapted) {
                        replacements.push(adapted);
                    }
                }
            });
        }

        dest.attr("class", replacements.join(" "));
    }


    function markMatch(text, term, markup, escapeMarkup) {
        var match=stripDiacritics(text.toUpperCase()).indexOf(stripDiacritics(term.toUpperCase())),
            tl=term.length;

        if (match<0) {
            markup.push(escapeMarkup(text));
            return;
        }

        markup.push(escapeMarkup(text.substring(0, match)));
        markup.push("<span class='select2-match'>");
        markup.push(escapeMarkup(text.substring(match, match + tl)));
        markup.push("</span>");
        markup.push(escapeMarkup(text.substring(match + tl, text.length)));
    }

    function defaultEscapeMarkup(markup) {
        var replace_map = {
            '\\': '&#92;',
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;',
            "/": '&#47;'
        };

        return String(markup).replace(/[&<>"'\/\\]/g, function (match) {
            return replace_map[match];
        });
    }

    /**
     * Produces an ajax-based query function
     *
     * @param options object containing configuration parameters
     * @param options.params parameter map for the transport ajax call, can contain such options as cache, jsonpCallback, etc. see $.ajax
     * @param options.transport function that will be used to execute the ajax request. must be compatible with parameters supported by $.ajax
     * @param options.url url for the data
     * @param options.data a function(searchTerm, pageNumber, context) that should return an object containing query string parameters for the above url.
     * @param options.dataType request data type: ajax, jsonp, other datatypes supported by jQuery's $.ajax function or the transport function if specified
     * @param options.quietMillis (optional) milliseconds to wait before making the ajaxRequest, helps debounce the ajax function if invoked too often
     * @param options.results a function(remoteData, pageNumber, query) that converts data returned form the remote request to the format expected by Select2.
     *      The expected format is an object containing the following keys:
     *      results array of objects that will be used as choices
     *      more (optional) boolean indicating whether there are more results available
     *      Example: {results:[{id:1, text:'Red'},{id:2, text:'Blue'}], more:true}
     */
    function ajax(options) {
        var timeout, // current scheduled but not yet executed request
            handler = null,
            quietMillis = options.quietMillis || 100,
            ajaxUrl = options.url,
            self = this;

        return function (query) {
            window.clearTimeout(timeout);
            timeout = window.setTimeout(function () {
                var data = options.data, // ajax data function
                    url = ajaxUrl, // ajax url string or function
                    transport = options.transport || $.fn.select2.ajaxDefaults.transport,
                    // deprecated - to be removed in 4.0  - use params instead
                    deprecated = {
                        type: options.type || 'GET', // set type of request (GET or POST)
                        cache: options.cache || false,
                        jsonpCallback: options.jsonpCallback||undefined,
                        dataType: options.dataType||"json"
                    },
                    params = $.extend({}, $.fn.select2.ajaxDefaults.params, deprecated);

                data = data ? data.call(self, query.term, query.page, query.context) : null;
                url = (typeof url === 'function') ? url.call(self, query.term, query.page, query.context) : url;

                if (handler && typeof handler.abort === "function") { handler.abort(); }

                if (options.params) {
                    if ($.isFunction(options.params)) {
                        $.extend(params, options.params.call(self));
                    } else {
                        $.extend(params, options.params);
                    }
                }

                $.extend(params, {
                    url: url,
                    dataType: options.dataType,
                    data: data,
                    success: function (data) {
                        // TODO - replace query.page with query so users have access to term, page, etc.
                        // added query as third paramter to keep backwards compatibility
                        var results = options.results(data, query.page, query);
                        query.callback(results);
                    },
                    error: function(jqXHR, textStatus, errorThrown){
                        var results = {
                            hasError: true,
                            jqXHR: jqXHR,
                            textStatus: textStatus,
                            errorThrown: errorThrown
                        };

                        query.callback(results);
                    }
                });
                handler = transport.call(self, params);
            }, quietMillis);
        };
    }

    /**
     * Produces a query function that works with a local array
     *
     * @param options object containing configuration parameters. The options parameter can either be an array or an
     * object.
     *
     * If the array form is used it is assumed that it contains objects with 'id' and 'text' keys.
     *
     * If the object form is used it is assumed that it contains 'data' and 'text' keys. The 'data' key should contain
     * an array of objects that will be used as choices. These objects must contain at least an 'id' key. The 'text'
     * key can either be a String in which case it is expected that each element in the 'data' array has a key with the
     * value of 'text' which will be used to match choices. Alternatively, text can be a function(item) that can extract
     * the text.
     */
    function local(options) {
        var data = options, // data elements
            dataText,
            tmp,
            text = function (item) { return ""+item.text; }; // function used to retrieve the text portion of a data item that is matched against the search

         if ($.isArray(data)) {
            tmp = data;
            data = { results: tmp };
        }

         if ($.isFunction(data) === false) {
            tmp = data;
            data = function() { return tmp; };
        }

        var dataItem = data();
        if (dataItem.text) {
            text = dataItem.text;
            // if text is not a function we assume it to be a key name
            if (!$.isFunction(text)) {
                dataText = dataItem.text; // we need to store this in a separate variable because in the next step data gets reset and data.text is no longer available
                text = function (item) { return item[dataText]; };
            }
        }

        return function (query) {
            var t = query.term, filtered = { results: [] }, process;
            if (t === "") {
                query.callback(data());
                return;
            }

            process = function(datum, collection) {
                var group, attr;
                datum = datum[0];
                if (datum.children) {
                    group = {};
                    for (attr in datum) {
                        if (datum.hasOwnProperty(attr)) group[attr]=datum[attr];
                    }
                    group.children=[];
                    $(datum.children).each2(function(i, childDatum) { process(childDatum, group.children); });
                    if (group.children.length || query.matcher(t, text(group), datum)) {
                        collection.push(group);
                    }
                } else {
                    if (query.matcher(t, text(datum), datum)) {
                        collection.push(datum);
                    }
                }
            };

            $(data().results).each2(function(i, datum) { process(datum, filtered.results); });
            query.callback(filtered);
        };
    }

    // TODO javadoc
    function tags(data) {
        var isFunc = $.isFunction(data);
        return function (query) {
            var t = query.term, filtered = {results: []};
            var result = isFunc ? data(query) : data;
            if ($.isArray(result)) {
                $(result).each(function () {
                    var isObject = this.text !== undefined,
                        text = isObject ? this.text : this;
                    if (t === "" || query.matcher(t, text)) {
                        filtered.results.push(isObject ? this : {id: this, text: this});
                    }
                });
                query.callback(filtered);
            }
        };
    }

    /**
     * Checks if the formatter function should be used.
     *
     * Throws an error if it is not a function. Returns true if it should be used,
     * false if no formatting should be performed.
     *
     * @param formatter
     */
    function checkFormatter(formatter, formatterName) {
        if ($.isFunction(formatter)) return true;
        if (!formatter) return false;
        if (typeof(formatter) === 'string') return true;
        throw new Error(formatterName +" must be a string, function, or falsy value");
    }

  /**
   * Returns a given value
   * If given a function, returns its output
   *
   * @param val string|function
   * @param context value of "this" to be passed to function
   * @returns {*}
   */
    function evaluate(val, context) {
        if ($.isFunction(val)) {
            var args = Array.prototype.slice.call(arguments, 2);
            return val.apply(context, args);
        }
        return val;
    }

    function countResults(results) {
        var count = 0;
        $.each(results, function(i, item) {
            if (item.children) {
                count += countResults(item.children);
            } else {
                count++;
            }
        });
        return count;
    }

    /**
     * Default tokenizer. This function uses breaks the input on substring match of any string from the
     * opts.tokenSeparators array and uses opts.createSearchChoice to create the choice object. Both of those
     * two options have to be defined in order for the tokenizer to work.
     *
     * @param input text user has typed so far or pasted into the search field
     * @param selection currently selected choices
     * @param selectCallback function(choice) callback tho add the choice to selection
     * @param opts select2's opts
     * @return undefined/null to leave the current input unchanged, or a string to change the input to the returned value
     */
    function defaultTokenizer(input, selection, selectCallback, opts) {
        var original = input, // store the original so we can compare and know if we need to tell the search to update its text
            dupe = false, // check for whether a token we extracted represents a duplicate selected choice
            token, // token
            index, // position at which the separator was found
            i, l, // looping variables
            separator; // the matched separator

        if (!opts.createSearchChoice || !opts.tokenSeparators || opts.tokenSeparators.length < 1) return undefined;

        while (true) {
            index = -1;

            for (i = 0, l = opts.tokenSeparators.length; i < l; i++) {
                separator = opts.tokenSeparators[i];
                index = input.indexOf(separator);
                if (index >= 0) break;
            }

            if (index < 0) break; // did not find any token separator in the input string, bail

            token = input.substring(0, index);
            input = input.substring(index + separator.length);

            if (token.length > 0) {
                token = opts.createSearchChoice.call(this, token, selection);
                if (token !== undefined && token !== null && opts.id(token) !== undefined && opts.id(token) !== null) {
                    dupe = false;
                    for (i = 0, l = selection.length; i < l; i++) {
                        if (equal(opts.id(token), opts.id(selection[i]))) {
                            dupe = true; break;
                        }
                    }

                    if (!dupe) selectCallback(token);
                }
            }
        }

        if (original!==input) return input;
    }

    function cleanupJQueryElements() {
        var self = this;

        $.each(arguments, function (i, element) {
            self[element].remove();
            self[element] = null;
        });
    }

    /**
     * Creates a new class
     *
     * @param superClass
     * @param methods
     */
    function clazz(SuperClass, methods) {
        var constructor = function () {};
        constructor.prototype = new SuperClass;
        constructor.prototype.constructor = constructor;
        constructor.prototype.parent = SuperClass.prototype;
        constructor.prototype = $.extend(constructor.prototype, methods);
        return constructor;
    }

    AbstractSelect2 = clazz(Object, {

        // abstract
        bind: function (func) {
            var self = this;
            return function () {
                func.apply(self, arguments);
            };
        },

        // abstract
        init: function (opts) {
            var results, search, resultsSelector = ".select2-results";

            // prepare options
            this.opts = opts = this.prepareOpts(opts);

            this.id=opts.id;

            // destroy if called on an existing component
            if (opts.element.data("select2") !== undefined &&
                opts.element.data("select2") !== null) {
                opts.element.data("select2").destroy();
            }

            this.container = this.createContainer();

            this.liveRegion = $('.select2-hidden-accessible');
            if (this.liveRegion.length == 0) {
                this.liveRegion = $("<span>", {
                        role: "status",
                        "aria-live": "polite"
                    })
                    .addClass("select2-hidden-accessible")
                    .appendTo(document.body);
            }

            this.containerId="s2id_"+(opts.element.attr("id") || "autogen"+nextUid());
            this.containerEventName= this.containerId
                .replace(/([.])/g, '_')
                .replace(/([;&,\-\.\+\*\~':"\!\^#$%@\[\]\(\)=>\|])/g, '\\$1');
            this.container.attr("id", this.containerId);

            this.container.attr("title", opts.element.attr("title"));

            this.body = $(document.body);

            syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);

            this.container.attr("style", opts.element.attr("style"));
            this.container.css(evaluate(opts.containerCss, this.opts.element));
            this.container.addClass(evaluate(opts.containerCssClass, this.opts.element));

            this.elementTabIndex = this.opts.element.attr("tabindex");

            // swap container for the element
            this.opts.element
                .data("select2", this)
                .attr("tabindex", "-1")
                .before(this.container)
                .on("click.select2", killEvent); // do not leak click events

            this.container.data("select2", this);

            this.dropdown = this.container.find(".select2-drop");

            syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);

            this.dropdown.addClass(evaluate(opts.dropdownCssClass, this.opts.element));
            this.dropdown.data("select2", this);
            this.dropdown.on("click", killEvent);

            this.results = results = this.container.find(resultsSelector);
            this.search = search = this.container.find("input.select2-input");

            this.queryCount = 0;
            this.resultsPage = 0;
            this.context = null;

            // initialize the container
            this.initContainer();

            this.container.on("click", killEvent);

            installFilteredMouseMove(this.results);

            this.dropdown.on("mousemove-filtered", resultsSelector, this.bind(this.highlightUnderEvent));
            this.dropdown.on("touchstart touchmove touchend", resultsSelector, this.bind(function (event) {
                this._touchEvent = true;
                this.highlightUnderEvent(event);
            }));
            this.dropdown.on("touchmove", resultsSelector, this.bind(this.touchMoved));
            this.dropdown.on("touchstart touchend", resultsSelector, this.bind(this.clearTouchMoved));

            // Waiting for a click event on touch devices to select option and hide dropdown
            // otherwise click will be triggered on an underlying element
            this.dropdown.on('click', this.bind(function (event) {
                if (this._touchEvent) {
                    this._touchEvent = false;
                    this.selectHighlighted();
                }
            }));

            installDebouncedScroll(80, this.results);
            this.dropdown.on("scroll-debounced", resultsSelector, this.bind(this.loadMoreIfNeeded));

            // do not propagate change event from the search field out of the component
            $(this.container).on("change", ".select2-input", function(e) {e.stopPropagation();});
            $(this.dropdown).on("change", ".select2-input", function(e) {e.stopPropagation();});

            // if jquery.mousewheel plugin is installed we can prevent out-of-bounds scrolling of results via mousewheel
            if ($.fn.mousewheel) {
                results.mousewheel(function (e, delta, deltaX, deltaY) {
                    var top = results.scrollTop();
                    if (deltaY > 0 && top - deltaY <= 0) {
                        results.scrollTop(0);
                        killEvent(e);
                    } else if (deltaY < 0 && results.get(0).scrollHeight - results.scrollTop() + deltaY <= results.height()) {
                        results.scrollTop(results.get(0).scrollHeight - results.height());
                        killEvent(e);
                    }
                });
            }

            installKeyUpChangeEvent(search);
            search.on("keyup-change input paste", this.bind(this.updateResults));
            search.on("focus", function () { search.addClass("select2-focused"); });
            search.on("blur", function () { search.removeClass("select2-focused");});

            this.dropdown.on("mouseup", resultsSelector, this.bind(function (e) {
                if ($(e.target).closest(".select2-result-selectable").length > 0) {
                    this.highlightUnderEvent(e);
                    this.selectHighlighted(e);
                }
            }));

            // trap all mouse events from leaving the dropdown. sometimes there may be a modal that is listening
            // for mouse events outside of itself so it can close itself. since the dropdown is now outside the select2's
            // dom it will trigger the popup close, which is not what we want
            // focusin can cause focus wars between modals and select2 since the dropdown is outside the modal.
            this.dropdown.on("click mouseup mousedown touchstart touchend focusin", function (e) { e.stopPropagation(); });

            this.nextSearchTerm = undefined;

            if ($.isFunction(this.opts.initSelection)) {
                // initialize selection based on the current value of the source element
                this.initSelection();

                // if the user has provided a function that can set selection based on the value of the source element
                // we monitor the change event on the element and trigger it, allowing for two way synchronization
                this.monitorSource();
            }

            if (opts.maximumInputLength !== null) {
                this.search.attr("maxlength", opts.maximumInputLength);
            }

            var disabled = opts.element.prop("disabled");
            if (disabled === undefined) disabled = false;
            this.enable(!disabled);

            var readonly = opts.element.prop("readonly");
            if (readonly === undefined) readonly = false;
            this.readonly(readonly);

            // Calculate size of scrollbar
            scrollBarDimensions = scrollBarDimensions || measureScrollbar();

            this.autofocus = opts.element.prop("autofocus");
            opts.element.prop("autofocus", false);
            if (this.autofocus) this.focus();

            this.search.attr("placeholder", opts.searchInputPlaceholder);
        },

        // abstract
        destroy: function () {
            var element=this.opts.element, select2 = element.data("select2"), self = this;

            this.close();

            if (element.length && element[0].detachEvent && self._sync) {
                element.each(function () {
                    if (self._sync) {
                        this.detachEvent("onpropertychange", self._sync);
                    }
                });
            }
            if (this.propertyObserver) {
                this.propertyObserver.disconnect();
                this.propertyObserver = null;
            }
            this._sync = null;

            if (select2 !== undefined) {
                select2.container.remove();
                select2.liveRegion.remove();
                select2.dropdown.remove();
                element
                    .show()
                    .removeData("select2")
                    .off(".select2")
                    .prop("autofocus", this.autofocus || false);
                if (this.elementTabIndex) {
                    element.attr({tabindex: this.elementTabIndex});
                } else {
                    element.removeAttr("tabindex");
                }
                element.show();
            }

            cleanupJQueryElements.call(this,
                "container",
                "liveRegion",
                "dropdown",
                "results",
                "search"
            );
        },

        // abstract
        optionToData: function(element) {
            if (element.is("option")) {
                return {
                    id:element.prop("value"),
                    text:element.text(),
                    element: element.get(),
                    css: element.attr("class"),
                    disabled: element.prop("disabled"),
                    locked: equal(element.attr("locked"), "locked") || equal(element.data("locked"), true)
                };
            } else if (element.is("optgroup")) {
                return {
                    text:element.attr("label"),
                    children:[],
                    element: element.get(),
                    css: element.attr("class")
                };
            }
        },

        // abstract
        prepareOpts: function (opts) {
            var element, select, idKey, ajaxUrl, self = this;

            element = opts.element;

            if (element.get(0).tagName.toLowerCase() === "select") {
                this.select = select = opts.element;
            }

            if (select) {
                // these options are not allowed when attached to a select because they are picked up off the element itself
                $.each(["id", "multiple", "ajax", "query", "createSearchChoice", "initSelection", "data", "tags"], function () {
                    if (this in opts) {
                        throw new Error("Option '" + this + "' is not allowed for Select2 when attached to a <select> element.");
                    }
                });
            }

            opts = $.extend({}, {
                populateResults: function(container, results, query) {
                    var populate, id=this.opts.id, liveRegion=this.liveRegion;

                    populate=function(results, container, depth) {

                        var i, l, result, selectable, disabled, compound, node, label, innerContainer, formatted;

                        results = opts.sortResults(results, container, query);

                        // collect the created nodes for bulk append
                        var nodes = [];
                        for (i = 0, l = results.length; i < l; i = i + 1) {

                            result=results[i];

                            disabled = (result.disabled === true);
                            selectable = (!disabled) && (id(result) !== undefined);

                            compound=result.children && result.children.length > 0;

                            node=$("<li></li>");
                            node.addClass("select2-results-dept-"+depth);
                            node.addClass("select2-result");
                            node.addClass(selectable ? "select2-result-selectable" : "select2-result-unselectable");
                            if (disabled) { node.addClass("select2-disabled"); }
                            if (compound) { node.addClass("select2-result-with-children"); }
                            node.addClass(self.opts.formatResultCssClass(result));
                            node.attr("role", "presentation");

                            label=$(document.createElement("div"));
                            label.addClass("select2-result-label");
                            label.attr("id", "select2-result-label-" + nextUid());
                            label.attr("role", "option");

                            formatted=opts.formatResult(result, label, query, self.opts.escapeMarkup);
                            if (formatted!==undefined) {
                                label.html(formatted);
                                node.append(label);
                            }


                            if (compound) {

                                innerContainer=$("<ul></ul>");
                                innerContainer.addClass("select2-result-sub");
                                populate(result.children, innerContainer, depth+1);
                                node.append(innerContainer);
                            }

                            node.data("select2-data", result);
                            nodes.push(node[0]);
                        }

                        // bulk append the created nodes
                        container.append(nodes);
                        liveRegion.text(opts.formatMatches(results.length));
                    };

                    populate(results, container, 0);
                }
            }, $.fn.select2.defaults, opts);

            if (typeof(opts.id) !== "function") {
                idKey = opts.id;
                opts.id = function (e) { return e[idKey]; };
            }

            if ($.isArray(opts.element.data("select2Tags"))) {
                if ("tags" in opts) {
                    throw "tags specified as both an attribute 'data-select2-tags' and in options of Select2 " + opts.element.attr("id");
                }
                opts.tags=opts.element.data("select2Tags");
            }

            if (select) {
                opts.query = this.bind(function (query) {
                    var data = { results: [], more: false },
                        term = query.term,
                        children, placeholderOption, process;

                    process=function(element, collection) {
                        var group;
                        if (element.is("option")) {
                            if (query.matcher(term, element.text(), element)) {
                                collection.push(self.optionToData(element));
                            }
                        } else if (element.is("optgroup")) {
                            group=self.optionToData(element);
                            element.children().each2(function(i, elm) { process(elm, group.children); });
                            if (group.children.length>0) {
                                collection.push(group);
                            }
                        }
                    };

                    children=element.children();

                    // ignore the placeholder option if there is one
                    if (this.getPlaceholder() !== undefined && children.length > 0) {
                        placeholderOption = this.getPlaceholderOption();
                        if (placeholderOption) {
                            children=children.not(placeholderOption);
                        }
                    }

                    children.each2(function(i, elm) { process(elm, data.results); });

                    query.callback(data);
                });
                // this is needed because inside val() we construct choices from options and their id is hardcoded
                opts.id=function(e) { return e.id; };
            } else {
                if (!("query" in opts)) {

                    if ("ajax" in opts) {
                        ajaxUrl = opts.element.data("ajax-url");
                        if (ajaxUrl && ajaxUrl.length > 0) {
                            opts.ajax.url = ajaxUrl;
                        }
                        opts.query = ajax.call(opts.element, opts.ajax);
                    } else if ("data" in opts) {
                        opts.query = local(opts.data);
                    } else if ("tags" in opts) {
                        opts.query = tags(opts.tags);
                        if (opts.createSearchChoice === undefined) {
                            opts.createSearchChoice = function (term) { return {id: $.trim(term), text: $.trim(term)}; };
                        }
                        if (opts.initSelection === undefined) {
                            opts.initSelection = function (element, callback) {
                                var data = [];
                                $(splitVal(element.val(), opts.separator, opts.transformVal)).each(function () {
                                    var obj = { id: this, text: this },
                                        tags = opts.tags;
                                    if ($.isFunction(tags)) tags=tags();
                                    $(tags).each(function() { if (equal(this.id, obj.id)) { obj = this; return false; } });
                                    data.push(obj);
                                });

                                callback(data);
                            };
                        }
                    }
                }
            }
            if (typeof(opts.query) !== "function") {
                throw "query function not defined for Select2 " + opts.element.attr("id");
            }

            if (opts.createSearchChoicePosition === 'top') {
                opts.createSearchChoicePosition = function(list, item) { list.unshift(item); };
            }
            else if (opts.createSearchChoicePosition === 'bottom') {
                opts.createSearchChoicePosition = function(list, item) { list.push(item); };
            }
            else if (typeof(opts.createSearchChoicePosition) !== "function")  {
                throw "invalid createSearchChoicePosition option must be 'top', 'bottom' or a custom function";
            }

            return opts;
        },

        /**
         * Monitor the original element for changes and update select2 accordingly
         */
        // abstract
        monitorSource: function () {
            var el = this.opts.element, observer, self = this;

            el.on("change.select2", this.bind(function (e) {
                if (this.opts.element.data("select2-change-triggered") !== true) {
                    this.initSelection();
                }
            }));

            this._sync = this.bind(function () {

                // sync enabled state
                var disabled = el.prop("disabled");
                if (disabled === undefined) disabled = false;
                this.enable(!disabled);

                var readonly = el.prop("readonly");
                if (readonly === undefined) readonly = false;
                this.readonly(readonly);

                if (this.container) {
                    syncCssClasses(this.container, this.opts.element, this.opts.adaptContainerCssClass);
                    this.container.addClass(evaluate(this.opts.containerCssClass, this.opts.element));
                }

                if (this.dropdown) {
                    syncCssClasses(this.dropdown, this.opts.element, this.opts.adaptDropdownCssClass);
                    this.dropdown.addClass(evaluate(this.opts.dropdownCssClass, this.opts.element));
                }

            });

            // IE8-10 (IE9/10 won't fire propertyChange via attachEventListener)
            if (el.length && el[0].attachEvent) {
                el.each(function() {
                    this.attachEvent("onpropertychange", self._sync);
                });
            }

            // safari, chrome, firefox, IE11
            observer = window.MutationObserver || window.WebKitMutationObserver|| window.MozMutationObserver;
            if (observer !== undefined) {
                if (this.propertyObserver) { delete this.propertyObserver; this.propertyObserver = null; }
                this.propertyObserver = new observer(function (mutations) {
                    $.each(mutations, self._sync);
                });
                this.propertyObserver.observe(el.get(0), { attributes:true, subtree:false });
            }
        },

        // abstract
        triggerSelect: function(data) {
            var evt = $.Event("select2-selecting", { val: this.id(data), object: data, choice: data });
            this.opts.element.trigger(evt);
            return !evt.isDefaultPrevented();
        },

        /**
         * Triggers the change event on the source element
         */
        // abstract
        triggerChange: function (details) {

            details = details || {};
            details= $.extend({}, details, { type: "change", val: this.val() });
            // prevents recursive triggering
            this.opts.element.data("select2-change-triggered", true);
            this.opts.element.trigger(details);
            this.opts.element.data("select2-change-triggered", false);

            // some validation frameworks ignore the change event and listen instead to keyup, click for selects
            // so here we trigger the click event manually
            this.opts.element.click();

            // ValidationEngine ignores the change event and listens instead to blur
            // so here we trigger the blur event manually if so desired
            if (this.opts.blurOnChange)
                this.opts.element.blur();
        },

        //abstract
        isInterfaceEnabled: function()
        {
            return this.enabledInterface === true;
        },

        // abstract
        enableInterface: function() {
            var enabled = this._enabled && !this._readonly,
                disabled = !enabled;

            if (enabled === this.enabledInterface) return false;

            this.container.toggleClass("select2-container-disabled", disabled);
            this.close();
            this.enabledInterface = enabled;

            return true;
        },

        // abstract
        enable: function(enabled) {
            if (enabled === undefined) enabled = true;
            if (this._enabled === enabled) return;
            this._enabled = enabled;

            this.opts.element.prop("disabled", !enabled);
            this.enableInterface();
        },

        // abstract
        disable: function() {
            this.enable(false);
        },

        // abstract
        readonly: function(enabled) {
            if (enabled === undefined) enabled = false;
            if (this._readonly === enabled) return;
            this._readonly = enabled;

            this.opts.element.prop("readonly", enabled);
            this.enableInterface();
        },

        // abstract
        opened: function () {
            return (this.container) ? this.container.hasClass("select2-dropdown-open") : false;
        },

        // abstract
        positionDropdown: function() {
            var $dropdown = this.dropdown,
                container = this.container,
                offset = container.offset(),
                height = container.outerHeight(false),
                width = container.outerWidth(false),
                dropHeight = $dropdown.outerHeight(false),
                $window = $(window),
                windowWidth = $window.width(),
                windowHeight = $window.height(),
                viewPortRight = $window.scrollLeft() + windowWidth,
                viewportBottom = $window.scrollTop() + windowHeight,
                dropTop = offset.top + height,
                dropLeft = offset.left,
                enoughRoomBelow = dropTop + dropHeight <= viewportBottom,
                enoughRoomAbove = (offset.top - dropHeight) >= $window.scrollTop(),
                dropWidth = $dropdown.outerWidth(false),
                enoughRoomOnRight = function() {
                    return dropLeft + dropWidth <= viewPortRight;
                },
                enoughRoomOnLeft = function() {
                    return offset.left + viewPortRight + container.outerWidth(false)  > dropWidth;
                },
                aboveNow = $dropdown.hasClass("select2-drop-above"),
                bodyOffset,
                above,
                changeDirection,
                css,
                resultsListNode;

            // always prefer the current above/below alignment, unless there is not enough room
            if (aboveNow) {
                above = true;
                if (!enoughRoomAbove && enoughRoomBelow) {
                    changeDirection = true;
                    above = false;
                }
            } else {
                above = false;
                if (!enoughRoomBelow && enoughRoomAbove) {
                    changeDirection = true;
                    above = true;
                }
            }

            //if we are changing direction we need to get positions when dropdown is hidden;
            if (changeDirection) {
                $dropdown.hide();
                offset = this.container.offset();
                height = this.container.outerHeight(false);
                width = this.container.outerWidth(false);
                dropHeight = $dropdown.outerHeight(false);
                viewPortRight = $window.scrollLeft() + windowWidth;
                viewportBottom = $window.scrollTop() + windowHeight;
                dropTop = offset.top + height;
                dropLeft = offset.left;
                dropWidth = $dropdown.outerWidth(false);
                $dropdown.show();

                // fix so the cursor does not move to the left within the search-textbox in IE
                this.focusSearch();
            }

            if (this.opts.dropdownAutoWidth) {
                resultsListNode = $('.select2-results', $dropdown)[0];
                $dropdown.addClass('select2-drop-auto-width');
                $dropdown.css('width', '');
                // Add scrollbar width to dropdown if vertical scrollbar is present
                dropWidth = $dropdown.outerWidth(false) + (resultsListNode.scrollHeight === resultsListNode.clientHeight ? 0 : scrollBarDimensions.width);
                dropWidth > width ? width = dropWidth : dropWidth = width;
                dropHeight = $dropdown.outerHeight(false);
            }
            else {
                this.container.removeClass('select2-drop-auto-width');
            }

            //console.log("below/ droptop:", dropTop, "dropHeight", dropHeight, "sum", (dropTop+dropHeight)+" viewport bottom", viewportBottom, "enough?", enoughRoomBelow);
            //console.log("above/ offset.top", offset.top, "dropHeight", dropHeight, "top", (offset.top-dropHeight), "scrollTop", this.body.scrollTop(), "enough?", enoughRoomAbove);

            // fix positioning when body has an offset and is not position: static
            if (this.body.css('position') !== 'static') {
                bodyOffset = this.body.offset();
                dropTop -= bodyOffset.top;
                dropLeft -= bodyOffset.left;
            }

            if (!enoughRoomOnRight() && enoughRoomOnLeft()) {
                dropLeft = offset.left + this.container.outerWidth(false) - dropWidth;
            }

            css =  {
                left: dropLeft,
                width: width
            };

            if (above) {
                css.top = offset.top - dropHeight;
                css.bottom = 'auto';
                this.container.addClass("select2-drop-above");
                $dropdown.addClass("select2-drop-above");
            }
            else {
                css.top = dropTop;
                css.bottom = 'auto';
                this.container.removeClass("select2-drop-above");
                $dropdown.removeClass("select2-drop-above");
            }
            css = $.extend(css, evaluate(this.opts.dropdownCss, this.opts.element));

            $dropdown.css(css);
        },

        // abstract
        shouldOpen: function() {
            var event;

            if (this.opened()) return false;

            if (this._enabled === false || this._readonly === true) return false;

            event = $.Event("select2-opening");
            this.opts.element.trigger(event);
            return !event.isDefaultPrevented();
        },

        // abstract
        clearDropdownAlignmentPreference: function() {
            // clear the classes used to figure out the preference of where the dropdown should be opened
            this.container.removeClass("select2-drop-above");
            this.dropdown.removeClass("select2-drop-above");
        },

        /**
         * Opens the dropdown
         *
         * @return {Boolean} whether or not dropdown was opened. This method will return false if, for example,
         * the dropdown is already open, or if the 'open' event listener on the element called preventDefault().
         */
        // abstract
        open: function () {

            if (!this.shouldOpen()) return false;

            this.opening();

            // Only bind the document mousemove when the dropdown is visible
            $document.on("mousemove.select2Event", function (e) {
                lastMousePosition.x = e.pageX;
                lastMousePosition.y = e.pageY;
            });

            return true;
        },

        /**
         * Performs the opening of the dropdown
         */
        // abstract
        opening: function() {
            var cid = this.containerEventName,
                scroll = "scroll." + cid,
                resize = "resize."+cid,
                orient = "orientationchange."+cid,
                mask;

            this.container.addClass("select2-dropdown-open").addClass("select2-container-active");

            this.clearDropdownAlignmentPreference();

            if(this.dropdown[0] !== this.body.children().last()[0]) {
                this.dropdown.detach().appendTo(this.body);
            }

            // create the dropdown mask if doesn't already exist
            mask = $("#select2-drop-mask");
            if (mask.length === 0) {
                mask = $(document.createElement("div"));
                mask.attr("id","select2-drop-mask").attr("class","select2-drop-mask");
                mask.hide();
                mask.appendTo(this.body);
                mask.on("mousedown touchstart click", function (e) {
                    // Prevent IE from generating a click event on the body
                    reinsertElement(mask);

                    var dropdown = $("#select2-drop"), self;
                    if (dropdown.length > 0) {
                        self=dropdown.data("select2");
                        if (self.opts.selectOnBlur) {
                            self.selectHighlighted({noFocus: true});
                        }
                        self.close();
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            }

            // ensure the mask is always right before the dropdown
            if (this.dropdown.prev()[0] !== mask[0]) {
                this.dropdown.before(mask);
            }

            // move the global id to the correct dropdown
            $("#select2-drop").removeAttr("id");
            this.dropdown.attr("id", "select2-drop");

            // show the elements
            mask.show();

            this.positionDropdown();
            this.dropdown.show();
            this.positionDropdown();

            this.dropdown.addClass("select2-drop-active");

            // attach listeners to events that can change the position of the container and thus require
            // the position of the dropdown to be updated as well so it does not come unglued from the container
            var that = this;
            this.container.parents().add(window).each(function () {
                $(this).on(resize+" "+scroll+" "+orient, function (e) {
                    if (that.opened()) that.positionDropdown();
                });
            });


        },

        // abstract
        close: function () {
            if (!this.opened()) return;

            var cid = this.containerEventName,
                scroll = "scroll." + cid,
                resize = "resize."+cid,
                orient = "orientationchange."+cid;

            // unbind event listeners
            this.container.parents().add(window).each(function () { $(this).off(scroll).off(resize).off(orient); });

            this.clearDropdownAlignmentPreference();

            $("#select2-drop-mask").hide();
            this.dropdown.removeAttr("id"); // only the active dropdown has the select2-drop id
            this.dropdown.hide();
            this.container.removeClass("select2-dropdown-open").removeClass("select2-container-active");
            this.results.empty();

            // Now that the dropdown is closed, unbind the global document mousemove event
            $document.off("mousemove.select2Event");

            this.clearSearch();
            this.search.removeClass("select2-active");
            this.opts.element.trigger($.Event("select2-close"));
        },

        /**
         * Opens control, sets input value, and updates results.
         */
        // abstract
        externalSearch: function (term) {
            this.open();
            this.search.val(term);
            this.updateResults(false);
        },

        // abstract
        clearSearch: function () {

        },

        //abstract
        getMaximumSelectionSize: function() {
            return evaluate(this.opts.maximumSelectionSize, this.opts.element);
        },

        // abstract
        ensureHighlightVisible: function () {
            var results = this.results, children, index, child, hb, rb, y, more, topOffset;

            index = this.highlight();

            if (index < 0) return;

            if (index == 0) {

                // if the first element is highlighted scroll all the way to the top,
                // that way any unselectable headers above it will also be scrolled
                // into view

                results.scrollTop(0);
                return;
            }

            children = this.findHighlightableChoices().find('.select2-result-label');

            child = $(children[index]);

            topOffset = (child.offset() || {}).top || 0;

            hb = topOffset + child.outerHeight(true);

            // if this is the last child lets also make sure select2-more-results is visible
            if (index === children.length - 1) {
                more = results.find("li.select2-more-results");
                if (more.length > 0) {
                    hb = more.offset().top + more.outerHeight(true);
                }
            }

            rb = results.offset().top + results.outerHeight(false);
            if (hb > rb) {
                results.scrollTop(results.scrollTop() + (hb - rb));
            }
            y = topOffset - results.offset().top;

            // make sure the top of the element is visible
            if (y < 0 && child.css('display') != 'none' ) {
                results.scrollTop(results.scrollTop() + y); // y is negative
            }
        },

        // abstract
        findHighlightableChoices: function() {
            return this.results.find(".select2-result-selectable:not(.select2-disabled):not(.select2-selected)");
        },

        // abstract
        moveHighlight: function (delta) {
            var choices = this.findHighlightableChoices(),
                index = this.highlight();

            while (index > -1 && index < choices.length) {
                index += delta;
                var choice = $(choices[index]);
                if (choice.hasClass("select2-result-selectable") && !choice.hasClass("select2-disabled") && !choice.hasClass("select2-selected")) {
                    this.highlight(index);
                    break;
                }
            }
        },

        // abstract
        highlight: function (index) {
            var choices = this.findHighlightableChoices(),
                choice,
                data;

            if (arguments.length === 0) {
                return indexOf(choices.filter(".select2-highlighted")[0], choices.get());
            }

            if (index >= choices.length) index = choices.length - 1;
            if (index < 0) index = 0;

            this.removeHighlight();

            choice = $(choices[index]);
            choice.addClass("select2-highlighted");

            // ensure assistive technology can determine the active choice
            this.search.attr("aria-activedescendant", choice.find(".select2-result-label").attr("id"));

            this.ensureHighlightVisible();

            this.liveRegion.text(choice.text());

            data = choice.data("select2-data");
            if (data) {
                this.opts.element.trigger({ type: "select2-highlight", val: this.id(data), choice: data });
            }
        },

        removeHighlight: function() {
            this.results.find(".select2-highlighted").removeClass("select2-highlighted");
        },

        touchMoved: function() {
            this._touchMoved = true;
        },

        clearTouchMoved: function() {
          this._touchMoved = false;
        },

        // abstract
        countSelectableResults: function() {
            return this.findHighlightableChoices().length;
        },

        // abstract
        highlightUnderEvent: function (event) {
            var el = $(event.target).closest(".select2-result-selectable");
            if (el.length > 0 && !el.is(".select2-highlighted")) {
                var choices = this.findHighlightableChoices();
                this.highlight(choices.index(el));
            } else if (el.length == 0) {
                // if we are over an unselectable item remove all highlights
                this.removeHighlight();
            }
        },

        // abstract
        loadMoreIfNeeded: function () {
            var results = this.results,
                more = results.find("li.select2-more-results"),
                below, // pixels the element is below the scroll fold, below==0 is when the element is starting to be visible
                page = this.resultsPage + 1,
                self=this,
                term=this.search.val(),
                context=this.context;

            if (more.length === 0) return;
            below = more.offset().top - results.offset().top - results.height();

            if (below <= this.opts.loadMorePadding) {
                more.addClass("select2-active");
                this.opts.query({
                        element: this.opts.element,
                        term: term,
                        page: page,
                        context: context,
                        matcher: this.opts.matcher,
                        callback: this.bind(function (data) {

                    // ignore a response if the select2 has been closed before it was received
                    if (!self.opened()) return;


                    self.opts.populateResults.call(this, results, data.results, {term: term, page: page, context:context});
                    self.postprocessResults(data, false, false);

                    if (data.more===true) {
                        more.detach().appendTo(results).html(self.opts.escapeMarkup(evaluate(self.opts.formatLoadMore, self.opts.element, page+1)));
                        window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
                    } else {
                        more.remove();
                    }
                    self.positionDropdown();
                    self.resultsPage = page;
                    self.context = data.context;
                    this.opts.element.trigger({ type: "select2-loaded", items: data });
                })});
            }
        },

        /**
         * Default tokenizer function which does nothing
         */
        tokenize: function() {

        },

        /**
         * @param initial whether or not this is the call to this method right after the dropdown has been opened
         */
        // abstract
        updateResults: function (initial) {
            var search = this.search,
                results = this.results,
                opts = this.opts,
                data,
                self = this,
                input,
                term = search.val(),
                lastTerm = $.data(this.container, "select2-last-term"),
                // sequence number used to drop out-of-order responses
                queryNumber;

            // prevent duplicate queries against the same term
            if (initial !== true && lastTerm && equal(term, lastTerm)) return;

            $.data(this.container, "select2-last-term", term);

            // if the search is currently hidden we do not alter the results
            if (initial !== true && (this.showSearchInput === false || !this.opened())) {
                return;
            }

            function postRender() {
                search.removeClass("select2-active");
                self.positionDropdown();
                if (results.find('.select2-no-results,.select2-selection-limit,.select2-searching').length) {
                    self.liveRegion.text(results.text());
                }
                else {
                    self.liveRegion.text(self.opts.formatMatches(results.find('.select2-result-selectable:not(".select2-selected")').length));
                }
            }

            function render(html) {
                results.html(html);
                postRender();
            }

            queryNumber = ++this.queryCount;

            var maxSelSize = this.getMaximumSelectionSize();
            if (maxSelSize >=1) {
                data = this.data();
                if ($.isArray(data) && data.length >= maxSelSize && checkFormatter(opts.formatSelectionTooBig, "formatSelectionTooBig")) {
                    render("<li class='select2-selection-limit'>" + evaluate(opts.formatSelectionTooBig, opts.element, maxSelSize) + "</li>");
                    return;
                }
            }

            if (search.val().length < opts.minimumInputLength) {
                if (checkFormatter(opts.formatInputTooShort, "formatInputTooShort")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooShort, opts.element, search.val(), opts.minimumInputLength) + "</li>");
                } else {
                    render("");
                }
                if (initial && this.showSearch) this.showSearch(true);
                return;
            }

            if (opts.maximumInputLength && search.val().length > opts.maximumInputLength) {
                if (checkFormatter(opts.formatInputTooLong, "formatInputTooLong")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatInputTooLong, opts.element, search.val(), opts.maximumInputLength) + "</li>");
                } else {
                    render("");
                }
                return;
            }

            if (opts.formatSearching && this.findHighlightableChoices().length === 0) {
                render("<li class='select2-searching'>" + evaluate(opts.formatSearching, opts.element) + "</li>");
            }

            search.addClass("select2-active");

            this.removeHighlight();

            // give the tokenizer a chance to pre-process the input
            input = this.tokenize();
            if (input != undefined && input != null) {
                search.val(input);
            }

            this.resultsPage = 1;

            opts.query({
                element: opts.element,
                    term: search.val(),
                    page: this.resultsPage,
                    context: null,
                    matcher: opts.matcher,
                    callback: this.bind(function (data) {
                var def; // default choice

                // ignore old responses
                if (queryNumber != this.queryCount) {
                  return;
                }

                // ignore a response if the select2 has been closed before it was received
                if (!this.opened()) {
                    this.search.removeClass("select2-active");
                    return;
                }

                // handle ajax error
                if(data.hasError !== undefined && checkFormatter(opts.formatAjaxError, "formatAjaxError")) {
                    render("<li class='select2-ajax-error'>" + evaluate(opts.formatAjaxError, opts.element, data.jqXHR, data.textStatus, data.errorThrown) + "</li>");
                    return;
                }

                // save context, if any
                this.context = (data.context===undefined) ? null : data.context;
                // create a default choice and prepend it to the list
                if (this.opts.createSearchChoice && search.val() !== "") {
                    def = this.opts.createSearchChoice.call(self, search.val(), data.results);
                    if (def !== undefined && def !== null && self.id(def) !== undefined && self.id(def) !== null) {
                        if ($(data.results).filter(
                            function () {
                                return equal(self.id(this), self.id(def));
                            }).length === 0) {
                            this.opts.createSearchChoicePosition(data.results, def);
                        }
                    }
                }

                if (data.results.length === 0 && checkFormatter(opts.formatNoMatches, "formatNoMatches")) {
                    render("<li class='select2-no-results'>" + evaluate(opts.formatNoMatches, opts.element, search.val()) + "</li>");
                    return;
                }

                results.empty();
                self.opts.populateResults.call(this, results, data.results, {term: search.val(), page: this.resultsPage, context:null});

                if (data.more === true && checkFormatter(opts.formatLoadMore, "formatLoadMore")) {
                    results.append("<li class='select2-more-results'>" + opts.escapeMarkup(evaluate(opts.formatLoadMore, opts.element, this.resultsPage)) + "</li>");
                    window.setTimeout(function() { self.loadMoreIfNeeded(); }, 10);
                }

                this.postprocessResults(data, initial);

                postRender();

                this.opts.element.trigger({ type: "select2-loaded", items: data });
            })});
        },

        // abstract
        cancel: function () {
            this.close();
        },

        // abstract
        blur: function () {
            // if selectOnBlur == true, select the currently highlighted option
            if (this.opts.selectOnBlur)
                this.selectHighlighted({noFocus: true});

            this.close();
            this.container.removeClass("select2-container-active");
            // synonymous to .is(':focus'), which is available in jquery >= 1.6
            if (this.search[0] === document.activeElement) { this.search.blur(); }
            this.clearSearch();
            this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
        },

        // abstract
        focusSearch: function () {
            focus(this.search);
        },

        // abstract
        selectHighlighted: function (options) {
            if (this._touchMoved) {
              this.clearTouchMoved();
              return;
            }
            var index=this.highlight(),
                highlighted=this.results.find(".select2-highlighted"),
                data = highlighted.closest('.select2-result').data("select2-data");

            if (data) {
                this.highlight(index);
                this.onSelect(data, options);
            } else if (options && options.noFocus) {
                this.close();
            }
        },

        // abstract
        getPlaceholder: function () {
            var placeholderOption;
            return this.opts.element.attr("placeholder") ||
                this.opts.element.attr("data-placeholder") || // jquery 1.4 compat
                this.opts.element.data("placeholder") ||
                this.opts.placeholder ||
                ((placeholderOption = this.getPlaceholderOption()) !== undefined ? placeholderOption.text() : undefined);
        },

        // abstract
        getPlaceholderOption: function() {
            if (this.select) {
                var firstOption = this.select.children('option').first();
                if (this.opts.placeholderOption !== undefined ) {
                    //Determine the placeholder option based on the specified placeholderOption setting
                    return (this.opts.placeholderOption === "first" && firstOption) ||
                           (typeof this.opts.placeholderOption === "function" && this.opts.placeholderOption(this.select));
                } else if ($.trim(firstOption.text()) === "" && firstOption.val() === "") {
                    //No explicit placeholder option specified, use the first if it's blank
                    return firstOption;
                }
            }
        },

        /**
         * Get the desired width for the container element.  This is
         * derived first from option `width` passed to select2, then
         * the inline 'style' on the original element, and finally
         * falls back to the jQuery calculated element width.
         */
        // abstract
        initContainerWidth: function () {
            function resolveContainerWidth() {
                var style, attrs, matches, i, l, attr;

                if (this.opts.width === "off") {
                    return null;
                } else if (this.opts.width === "element"){
                    return this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px';
                } else if (this.opts.width === "copy" || this.opts.width === "resolve") {
                    // check if there is inline style on the element that contains width
                    style = this.opts.element.attr('style');
                    if (style !== undefined) {
                        attrs = style.split(';');
                        for (i = 0, l = attrs.length; i < l; i = i + 1) {
                            attr = attrs[i].replace(/\s/g, '');
                            matches = attr.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
                            if (matches !== null && matches.length >= 1)
                                return matches[1];
                        }
                    }

                    if (this.opts.width === "resolve") {
                        // next check if css('width') can resolve a width that is percent based, this is sometimes possible
                        // when attached to input type=hidden or elements hidden via css
                        style = this.opts.element.css('width');
                        if (style.indexOf("%") > 0) return style;

                        // finally, fallback on the calculated width of the element
                        return (this.opts.element.outerWidth(false) === 0 ? 'auto' : this.opts.element.outerWidth(false) + 'px');
                    }

                    return null;
                } else if ($.isFunction(this.opts.width)) {
                    return this.opts.width();
                } else {
                    return this.opts.width;
               }
            };

            var width = resolveContainerWidth.call(this);
            if (width !== null) {
                this.container.css("width", width);
            }
        }
    });

    SingleSelect2 = clazz(AbstractSelect2, {

        // single

        createContainer: function () {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container"
            }).html([
                "<a href='javascript:void(0)' class='select2-choice' tabindex='-1'>",
                "   <span class='select2-chosen'>&#160;</span><abbr class='select2-search-choice-close'></abbr>",
                "   <span class='select2-arrow' role='presentation'><b role='presentation'></b></span>",
                "</a>",
                "<label for='' class='select2-offscreen'></label>",
                "<input class='select2-focusser select2-offscreen' type='text' aria-haspopup='true' role='button' />",
                "<div class='select2-drop select2-display-none'>",
                "   <div class='select2-search'>",
                "       <label for='' class='select2-offscreen'></label>",
                "       <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input' role='combobox' aria-expanded='true'",
                "       aria-autocomplete='list' />",
                "   </div>",
                "   <ul class='select2-results' role='listbox'>",
                "   </ul>",
                "</div>"].join(""));
            return container;
        },

        // single
        enableInterface: function() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.focusser.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // single
        opening: function () {
            var el, range, len;

            if (this.opts.minimumResultsForSearch >= 0) {
                this.showSearch(true);
            }

            this.parent.opening.apply(this, arguments);

            if (this.showSearchInput !== false) {
                // IE appends focusser.val() at the end of field :/ so we manually insert it at the beginning using a range
                // all other browsers handle this just fine

                this.search.val(this.focusser.val());
            }
            if (this.opts.shouldFocusInput(this)) {
                this.search.focus();
                // move the cursor to the end after focussing, otherwise it will be at the beginning and
                // new text will appear *before* focusser.val()
                el = this.search.get(0);
                if (el.createTextRange) {
                    range = el.createTextRange();
                    range.collapse(false);
                    range.select();
                } else if (el.setSelectionRange) {
                    len = this.search.val().length;
                    el.setSelectionRange(len, len);
                }
            }

            // initializes search's value with nextSearchTerm (if defined by user)
            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
            if(this.search.val() === "") {
                if(this.nextSearchTerm != undefined){
                    this.search.val(this.nextSearchTerm);
                    this.search.select();
                }
            }

            this.focusser.prop("disabled", true).val("");
            this.updateResults(true);
            this.opts.element.trigger($.Event("select2-open"));
        },

        // single
        close: function () {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);

            this.focusser.prop("disabled", false);

            if (this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }
        },

        // single
        focus: function () {
            if (this.opened()) {
                this.close();
            } else {
                this.focusser.prop("disabled", false);
                if (this.opts.shouldFocusInput(this)) {
                    this.focusser.focus();
                }
            }
        },

        // single
        isFocused: function () {
            return this.container.hasClass("select2-container-active");
        },

        // single
        cancel: function () {
            this.parent.cancel.apply(this, arguments);
            this.focusser.prop("disabled", false);

            if (this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }
        },

        // single
        destroy: function() {
            $("label[for='" + this.focusser.attr('id') + "']")
                .attr('for', this.opts.element.attr("id"));
            this.parent.destroy.apply(this, arguments);

            cleanupJQueryElements.call(this,
                "selection",
                "focusser"
            );
        },

        // single
        initContainer: function () {

            var selection,
                container = this.container,
                dropdown = this.dropdown,
                idSuffix = nextUid(),
                elementLabel;

            if (this.opts.minimumResultsForSearch < 0) {
                this.showSearch(false);
            } else {
                this.showSearch(true);
            }

            this.selection = selection = container.find(".select2-choice");

            this.focusser = container.find(".select2-focusser");

            // add aria associations
            selection.find(".select2-chosen").attr("id", "select2-chosen-"+idSuffix);
            this.focusser.attr("aria-labelledby", "select2-chosen-"+idSuffix);
            this.results.attr("id", "select2-results-"+idSuffix);
            this.search.attr("aria-owns", "select2-results-"+idSuffix);

            // rewrite labels from original element to focusser
            this.focusser.attr("id", "s2id_autogen"+idSuffix);

            elementLabel = $("label[for='" + this.opts.element.attr("id") + "']");
            this.opts.element.focus(this.bind(function () { this.focus(); }));

            this.focusser.prev()
                .text(elementLabel.text())
                .attr('for', this.focusser.attr('id'));

            // Ensure the original element retains an accessible name
            var originalTitle = this.opts.element.attr("title");
            this.opts.element.attr("title", (originalTitle || elementLabel.text()));

            this.focusser.attr("tabindex", this.elementTabIndex);

            // write label for search field using the label from the focusser element
            this.search.attr("id", this.focusser.attr('id') + '_search');

            this.search.prev()
                .text($("label[for='" + this.focusser.attr('id') + "']").text())
                .attr('for', this.search.attr('id'));

            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                // filter 229 keyCodes (input method editor is processing key input)
                if (229 == e.keyCode) return;

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                    return;
                }

                switch (e.which) {
                    case KEY.UP:
                    case KEY.DOWN:
                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
                        killEvent(e);
                        return;
                    case KEY.ENTER:
                        this.selectHighlighted();
                        killEvent(e);
                        return;
                    case KEY.TAB:
                        this.selectHighlighted({noFocus: true});
                        return;
                    case KEY.ESC:
                        this.cancel(e);
                        killEvent(e);
                        return;
                }
            }));

            this.search.on("blur", this.bind(function(e) {
                // a workaround for chrome to keep the search field focussed when the scroll bar is used to scroll the dropdown.
                // without this the search field loses focus which is annoying
                if (document.activeElement === this.body.get(0)) {
                    window.setTimeout(this.bind(function() {
                        if (this.opened()) {
                            this.search.focus();
                        }
                    }), 0);
                }
            }));

            this.focusser.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
                    return;
                }

                if (this.opts.openOnEnter === false && e.which === KEY.ENTER) {
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DOWN || e.which == KEY.UP
                    || (e.which == KEY.ENTER && this.opts.openOnEnter)) {

                    if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) return;

                    this.open();
                    killEvent(e);
                    return;
                }

                if (e.which == KEY.DELETE || e.which == KEY.BACKSPACE) {
                    if (this.opts.allowClear) {
                        this.clear();
                    }
                    killEvent(e);
                    return;
                }
            }));


            installKeyUpChangeEvent(this.focusser);
            this.focusser.on("keyup-change input", this.bind(function(e) {
                if (this.opts.minimumResultsForSearch >= 0) {
                    e.stopPropagation();
                    if (this.opened()) return;
                    this.open();
                }
            }));

            selection.on("mousedown touchstart", "abbr", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) {
                    return;
                }

                this.clear();
                killEventImmediately(e);
                this.close();

                if (this.selection) {
                    this.selection.focus();
                }
            }));

            selection.on("mousedown touchstart", this.bind(function (e) {
                // Prevent IE from generating a click event on the body
                reinsertElement(selection);

                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }

                if (this.opened()) {
                    this.close();
                } else if (this.isInterfaceEnabled()) {
                    this.open();
                }

                killEvent(e);
            }));

            dropdown.on("mousedown touchstart", this.bind(function() {
                if (this.opts.shouldFocusInput(this)) {
                    this.search.focus();
                }
            }));

            selection.on("focus", this.bind(function(e) {
                killEvent(e);
            }));

            this.focusser.on("focus", this.bind(function(){
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            })).on("blur", this.bind(function() {
                if (!this.opened()) {
                    this.container.removeClass("select2-container-active");
                    this.opts.element.trigger($.Event("select2-blur"));
                }
            }));
            this.search.on("focus", this.bind(function(){
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
            }));

            this.initContainerWidth();
            this.opts.element.hide();
            this.setPlaceholder();

        },

        // single
        clear: function(triggerChange) {
            var data=this.selection.data("select2-data");
            if (data) { // guard against queued quick consecutive clicks
                var evt = $.Event("select2-clearing");
                this.opts.element.trigger(evt);
                if (evt.isDefaultPrevented()) {
                    return;
                }
                var placeholderOption = this.getPlaceholderOption();
                this.opts.element.val(placeholderOption ? placeholderOption.val() : "");
                this.selection.find(".select2-chosen").empty();
                this.selection.removeData("select2-data");
                this.setPlaceholder();

                if (triggerChange !== false){
                    this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
                    this.triggerChange({removed:data});
                }
            }
        },

        /**
         * Sets selection based on source element's value
         */
        // single
        initSelection: function () {
            var selected;
            if (this.isPlaceholderOptionSelected()) {
                this.updateSelection(null);
                this.close();
                this.setPlaceholder();
            } else {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function(selected){
                    if (selected !== undefined && selected !== null) {
                        self.updateSelection(selected);
                        self.close();
                        self.setPlaceholder();
                        self.nextSearchTerm = self.opts.nextSearchTerm(selected, self.search.val());
                    }
                });
            }
        },

        isPlaceholderOptionSelected: function() {
            var placeholderOption;
            if (this.getPlaceholder() === undefined) return false; // no placeholder specified so no option should be considered
            return ((placeholderOption = this.getPlaceholderOption()) !== undefined && placeholderOption.prop("selected"))
                || (this.opts.element.val() === "")
                || (this.opts.element.val() === undefined)
                || (this.opts.element.val() === null);
        },

        // single
        prepareOpts: function () {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self=this;

            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install the selection initializer
                opts.initSelection = function (element, callback) {
                    var selected = element.find("option").filter(function() { return this.selected && !this.disabled });
                    // a single select box always has a value, no need to null check 'selected'
                    callback(self.optionToData(selected));
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var id = element.val();
                    //search in data by id, storing the actual matching item
                    var match = null;
                    opts.query({
                        matcher: function(term, text, el){
                            var is_match = equal(id, opts.id(el));
                            if (is_match) {
                                match = el;
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function() {
                            callback(match);
                        }
                    });
                };
            }

            return opts;
        },

        // single
        getPlaceholder: function() {
            // if a placeholder is specified on a single select without a valid placeholder option ignore it
            if (this.select) {
                if (this.getPlaceholderOption() === undefined) {
                    return undefined;
                }
            }

            return this.parent.getPlaceholder.apply(this, arguments);
        },

        // single
        setPlaceholder: function () {
            var placeholder = this.getPlaceholder();

            if (this.isPlaceholderOptionSelected() && placeholder !== undefined) {

                // check for a placeholder option if attached to a select
                if (this.select && this.getPlaceholderOption() === undefined) return;

                this.selection.find(".select2-chosen").html(this.opts.escapeMarkup(placeholder));

                this.selection.addClass("select2-default");

                this.container.removeClass("select2-allowclear");
            }
        },

        // single
        postprocessResults: function (data, initial, noHighlightUpdate) {
            var selected = 0, self = this, showSearchInput = true;

            // find the selected element in the result list

            this.findHighlightableChoices().each2(function (i, elm) {
                if (equal(self.id(elm.data("select2-data")), self.opts.element.val())) {
                    selected = i;
                    return false;
                }
            });

            // and highlight it
            if (noHighlightUpdate !== false) {
                if (initial === true && selected >= 0) {
                    this.highlight(selected);
                } else {
                    this.highlight(0);
                }
            }

            // hide the search box if this is the first we got the results and there are enough of them for search

            if (initial === true) {
                var min = this.opts.minimumResultsForSearch;
                if (min >= 0) {
                    this.showSearch(countResults(data.results) >= min);
                }
            }
        },

        // single
        showSearch: function(showSearchInput) {
            if (this.showSearchInput === showSearchInput) return;

            this.showSearchInput = showSearchInput;

            this.dropdown.find(".select2-search").toggleClass("select2-search-hidden", !showSearchInput);
            this.dropdown.find(".select2-search").toggleClass("select2-offscreen", !showSearchInput);
            //add "select2-with-searchbox" to the container if search box is shown
            $(this.dropdown, this.container).toggleClass("select2-with-searchbox", showSearchInput);
        },

        // single
        onSelect: function (data, options) {

            if (!this.triggerSelect(data)) { return; }

            var old = this.opts.element.val(),
                oldData = this.data();

            this.opts.element.val(this.id(data));
            this.updateSelection(data);

            this.opts.element.trigger({ type: "select2-selected", val: this.id(data), choice: data });

            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());
            this.close();

            if ((!options || !options.noFocus) && this.opts.shouldFocusInput(this)) {
                this.focusser.focus();
            }

            if (!equal(old, this.id(data))) {
                this.triggerChange({ added: data, removed: oldData });
            }
        },

        // single
        updateSelection: function (data) {

            var container=this.selection.find(".select2-chosen"), formatted, cssClass;

            this.selection.data("select2-data", data);

            container.empty();
            if (data !== null) {
                formatted=this.opts.formatSelection(data, container, this.opts.escapeMarkup);
            }
            if (formatted !== undefined) {
                container.append(formatted);
            }
            cssClass=this.opts.formatSelectionCssClass(data, container);
            if (cssClass !== undefined) {
                container.addClass(cssClass);
            }

            this.selection.removeClass("select2-default");

            if (this.opts.allowClear && this.getPlaceholder() !== undefined) {
                this.container.addClass("select2-allowclear");
            }
        },

        // single
        val: function () {
            var val,
                triggerChange = false,
                data = null,
                self = this,
                oldData = this.data();

            if (arguments.length === 0) {
                return this.opts.element.val();
            }

            val = arguments[0];

            if (arguments.length > 1) {
                triggerChange = arguments[1];
            }

            if (this.select) {
                this.select
                    .val(val)
                    .find("option").filter(function() { return this.selected }).each2(function (i, elm) {
                        data = self.optionToData(elm);
                        return false;
                    });
                this.updateSelection(data);
                this.setPlaceholder();
                if (triggerChange) {
                    this.triggerChange({added: data, removed:oldData});
                }
            } else {
                // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
                if (!val && val !== 0) {
                    this.clear(triggerChange);
                    return;
                }
                if (this.opts.initSelection === undefined) {
                    throw new Error("cannot call val() if initSelection() is not defined");
                }
                this.opts.element.val(val);
                this.opts.initSelection(this.opts.element, function(data){
                    self.opts.element.val(!data ? "" : self.id(data));
                    self.updateSelection(data);
                    self.setPlaceholder();
                    if (triggerChange) {
                        self.triggerChange({added: data, removed:oldData});
                    }
                });
            }
        },

        // single
        clearSearch: function () {
            this.search.val("");
            this.focusser.val("");
        },

        // single
        data: function(value) {
            var data,
                triggerChange = false;

            if (arguments.length === 0) {
                data = this.selection.data("select2-data");
                if (data == undefined) data = null;
                return data;
            } else {
                if (arguments.length > 1) {
                    triggerChange = arguments[1];
                }
                if (!value) {
                    this.clear(triggerChange);
                } else {
                    data = this.data();
                    this.opts.element.val(!value ? "" : this.id(value));
                    this.updateSelection(value);
                    if (triggerChange) {
                        this.triggerChange({added: value, removed:data});
                    }
                }
            }
        }
    });

    MultiSelect2 = clazz(AbstractSelect2, {

        // multi
        createContainer: function () {
            var container = $(document.createElement("div")).attr({
                "class": "select2-container select2-container-multi"
            }).html([
                "<ul class='select2-choices'>",
                "  <li class='select2-search-field'>",
                "    <label for='' class='select2-offscreen'></label>",
                "    <input type='text' autocomplete='off' autocorrect='off' autocapitalize='off' spellcheck='false' class='select2-input'>",
                "  </li>",
                "</ul>",
                "<div class='select2-drop select2-drop-multi select2-display-none'>",
                "   <ul class='select2-results'>",
                "   </ul>",
                "</div>"].join(""));
            return container;
        },

        // multi
        prepareOpts: function () {
            var opts = this.parent.prepareOpts.apply(this, arguments),
                self=this;

            // TODO validate placeholder is a string if specified
            if (opts.element.get(0).tagName.toLowerCase() === "select") {
                // install the selection initializer
                opts.initSelection = function (element, callback) {

                    var data = [];

                    element.find("option").filter(function() { return this.selected && !this.disabled }).each2(function (i, elm) {
                        data.push(self.optionToData(elm));
                    });
                    callback(data);
                };
            } else if ("data" in opts) {
                // install default initSelection when applied to hidden input and data is local
                opts.initSelection = opts.initSelection || function (element, callback) {
                    var ids = splitVal(element.val(), opts.separator, opts.transformVal);
                    //search in data by array of ids, storing matching items in a list
                    var matches = [];
                    opts.query({
                        matcher: function(term, text, el){
                            var is_match = $.grep(ids, function(id) {
                                return equal(id, opts.id(el));
                            }).length;
                            if (is_match) {
                                matches.push(el);
                            }
                            return is_match;
                        },
                        callback: !$.isFunction(callback) ? $.noop : function() {
                            // reorder matches based on the order they appear in the ids array because right now
                            // they are in the order in which they appear in data array
                            var ordered = [];
                            for (var i = 0; i < ids.length; i++) {
                                var id = ids[i];
                                for (var j = 0; j < matches.length; j++) {
                                    var match = matches[j];
                                    if (equal(id, opts.id(match))) {
                                        ordered.push(match);
                                        matches.splice(j, 1);
                                        break;
                                    }
                                }
                            }
                            callback(ordered);
                        }
                    });
                };
            }

            return opts;
        },

        // multi
        selectChoice: function (choice) {

            var selected = this.container.find(".select2-search-choice-focus");
            if (selected.length && choice && choice[0] == selected[0]) {

            } else {
                if (selected.length) {
                    this.opts.element.trigger("choice-deselected", selected);
                }
                selected.removeClass("select2-search-choice-focus");
                if (choice && choice.length) {
                    this.close();
                    choice.addClass("select2-search-choice-focus");
                    this.opts.element.trigger("choice-selected", choice);
                }
            }
        },

        // multi
        destroy: function() {
            $("label[for='" + this.search.attr('id') + "']")
                .attr('for', this.opts.element.attr("id"));
            this.parent.destroy.apply(this, arguments);

            cleanupJQueryElements.call(this,
                "searchContainer",
                "selection"
            );
        },

        // multi
        initContainer: function () {

            var selector = ".select2-choices", selection;

            this.searchContainer = this.container.find(".select2-search-field");
            this.selection = selection = this.container.find(selector);

            var _this = this;
            this.selection.on("click", ".select2-container:not(.select2-container-disabled) .select2-search-choice:not(.select2-locked)", function (e) {
                _this.search[0].focus();
                _this.selectChoice($(this));
            });

            // rewrite labels from original element to focusser
            this.search.attr("id", "s2id_autogen"+nextUid());

            this.search.prev()
                .text($("label[for='" + this.opts.element.attr("id") + "']").text())
                .attr('for', this.search.attr('id'));
            this.opts.element.focus(this.bind(function () { this.focus(); }));

            this.search.on("input paste", this.bind(function() {
                if (this.search.attr('placeholder') && this.search.val().length == 0) return;
                if (!this.isInterfaceEnabled()) return;
                if (!this.opened()) {
                    this.open();
                }
            }));

            this.search.attr("tabindex", this.elementTabIndex);

            this.keydowns = 0;
            this.search.on("keydown", this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;

                ++this.keydowns;
                var selected = selection.find(".select2-search-choice-focus");
                var prev = selected.prev(".select2-search-choice:not(.select2-locked)");
                var next = selected.next(".select2-search-choice:not(.select2-locked)");
                var pos = getCursorInfo(this.search);

                if (selected.length &&
                    (e.which == KEY.LEFT || e.which == KEY.RIGHT || e.which == KEY.BACKSPACE || e.which == KEY.DELETE || e.which == KEY.ENTER)) {
                    var selectedChoice = selected;
                    if (e.which == KEY.LEFT && prev.length) {
                        selectedChoice = prev;
                    }
                    else if (e.which == KEY.RIGHT) {
                        selectedChoice = next.length ? next : null;
                    }
                    else if (e.which === KEY.BACKSPACE) {
                        if (this.unselect(selected.first())) {
                            this.search.width(10);
                            selectedChoice = prev.length ? prev : next;
                        }
                    } else if (e.which == KEY.DELETE) {
                        if (this.unselect(selected.first())) {
                            this.search.width(10);
                            selectedChoice = next.length ? next : null;
                        }
                    } else if (e.which == KEY.ENTER) {
                        selectedChoice = null;
                    }

                    this.selectChoice(selectedChoice);
                    killEvent(e);
                    if (!selectedChoice || !selectedChoice.length) {
                        this.open();
                    }
                    return;
                } else if (((e.which === KEY.BACKSPACE && this.keydowns == 1)
                    || e.which == KEY.LEFT) && (pos.offset == 0 && !pos.length)) {

                    this.selectChoice(selection.find(".select2-search-choice:not(.select2-locked)").last());
                    killEvent(e);
                    return;
                } else {
                    this.selectChoice(null);
                }

                if (this.opened()) {
                    switch (e.which) {
                    case KEY.UP:
                    case KEY.DOWN:
                        this.moveHighlight((e.which === KEY.UP) ? -1 : 1);
                        killEvent(e);
                        return;
                    case KEY.ENTER:
                        this.selectHighlighted();
                        killEvent(e);
                        return;
                    case KEY.TAB:
                        this.selectHighlighted({noFocus:true});
                        this.close();
                        return;
                    case KEY.ESC:
                        this.cancel(e);
                        killEvent(e);
                        return;
                    }
                }

                if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e)
                 || e.which === KEY.BACKSPACE || e.which === KEY.ESC) {
                    return;
                }

                if (e.which === KEY.ENTER) {
                    if (this.opts.openOnEnter === false) {
                        return;
                    } else if (e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
                        return;
                    }
                }

                this.open();

                if (e.which === KEY.PAGE_UP || e.which === KEY.PAGE_DOWN) {
                    // prevent the page from scrolling
                    killEvent(e);
                }

                if (e.which === KEY.ENTER) {
                    // prevent form from being submitted
                    killEvent(e);
                }

            }));

            this.search.on("keyup", this.bind(function (e) {
                this.keydowns = 0;
                this.resizeSearch();
            })
            );

            this.search.on("blur", this.bind(function(e) {
                this.container.removeClass("select2-container-active");
                this.search.removeClass("select2-focused");
                this.selectChoice(null);
                if (!this.opened()) this.clearSearch();
                e.stopImmediatePropagation();
                this.opts.element.trigger($.Event("select2-blur"));
            }));

            this.container.on("click", selector, this.bind(function (e) {
                if (!this.isInterfaceEnabled()) return;
                if ($(e.target).closest(".select2-search-choice").length > 0) {
                    // clicked inside a select2 search choice, do not open
                    return;
                }
                this.selectChoice(null);
                this.clearPlaceholder();
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.open();
                this.focusSearch();
                e.preventDefault();
            }));

            this.container.on("focus", selector, this.bind(function () {
                if (!this.isInterfaceEnabled()) return;
                if (!this.container.hasClass("select2-container-active")) {
                    this.opts.element.trigger($.Event("select2-focus"));
                }
                this.container.addClass("select2-container-active");
                this.dropdown.addClass("select2-drop-active");
                this.clearPlaceholder();
            }));

            this.initContainerWidth();
            this.opts.element.hide();

            // set the placeholder if necessary
            this.clearSearch();
        },

        // multi
        enableInterface: function() {
            if (this.parent.enableInterface.apply(this, arguments)) {
                this.search.prop("disabled", !this.isInterfaceEnabled());
            }
        },

        // multi
        initSelection: function () {
            var data;
            if (this.opts.element.val() === "" && this.opts.element.text() === "") {
                this.updateSelection([]);
                this.close();
                // set the placeholder if necessary
                this.clearSearch();
            }
            if (this.select || this.opts.element.val() !== "") {
                var self = this;
                this.opts.initSelection.call(null, this.opts.element, function(data){
                    if (data !== undefined && data !== null) {
                        self.updateSelection(data);
                        self.close();
                        // set the placeholder if necessary
                        self.clearSearch();
                    }
                });
            }
        },

        // multi
        clearSearch: function () {
            var placeholder = this.getPlaceholder(),
                maxWidth = this.getMaxSearchWidth();

            if (placeholder !== undefined  && this.getVal().length === 0 && this.search.hasClass("select2-focused") === false) {
                this.search.val(placeholder).addClass("select2-default");
                // stretch the search box to full width of the container so as much of the placeholder is visible as possible
                // we could call this.resizeSearch(), but we do not because that requires a sizer and we do not want to create one so early because of a firefox bug, see #944
                this.search.width(maxWidth > 0 ? maxWidth : this.container.css("width"));
            } else {
                this.search.val("").width(10);
            }
        },

        // multi
        clearPlaceholder: function () {
            if (this.search.hasClass("select2-default")) {
                this.search.val("").removeClass("select2-default");
            }
        },

        // multi
        opening: function () {
            this.clearPlaceholder(); // should be done before super so placeholder is not used to search
            this.resizeSearch();

            this.parent.opening.apply(this, arguments);

            this.focusSearch();

            // initializes search's value with nextSearchTerm (if defined by user)
            // ignore nextSearchTerm if the dropdown is opened by the user pressing a letter
            if(this.search.val() === "") {
                if(this.nextSearchTerm != undefined){
                    this.search.val(this.nextSearchTerm);
                    this.search.select();
                }
            }

            this.updateResults(true);
            if (this.opts.shouldFocusInput(this)) {
                this.search.focus();
            }
            this.opts.element.trigger($.Event("select2-open"));
        },

        // multi
        close: function () {
            if (!this.opened()) return;
            this.parent.close.apply(this, arguments);
        },

        // multi
        focus: function () {
            this.close();
            this.search.focus();
        },

        // multi
        isFocused: function () {
            return this.search.hasClass("select2-focused");
        },

        // multi
        updateSelection: function (data) {
            var ids = [], filtered = [], self = this;

            // filter out duplicates
            $(data).each(function () {
                if (indexOf(self.id(this), ids) < 0) {
                    ids.push(self.id(this));
                    filtered.push(this);
                }
            });
            data = filtered;

            this.selection.find(".select2-search-choice").remove();
            $(data).each(function () {
                self.addSelectedChoice(this);
            });
            self.postprocessResults();
        },

        // multi
        tokenize: function() {
            var input = this.search.val();
            input = this.opts.tokenizer.call(this, input, this.data(), this.bind(this.onSelect), this.opts);
            if (input != null && input != undefined) {
                this.search.val(input);
                if (input.length > 0) {
                    this.open();
                }
            }

        },

        // multi
        onSelect: function (data, options) {

            if (!this.triggerSelect(data) || data.text === "") { return; }

            this.addSelectedChoice(data);

            this.opts.element.trigger({ type: "selected", val: this.id(data), choice: data });

            // keep track of the search's value before it gets cleared
            this.nextSearchTerm = this.opts.nextSearchTerm(data, this.search.val());

            this.clearSearch();
            this.updateResults();

            if (this.select || !this.opts.closeOnSelect) this.postprocessResults(data, false, this.opts.closeOnSelect===true);

            if (this.opts.closeOnSelect) {
                this.close();
                this.search.width(10);
            } else {
                if (this.countSelectableResults()>0) {
                    this.search.width(10);
                    this.resizeSearch();
                    if (this.getMaximumSelectionSize() > 0 && this.val().length >= this.getMaximumSelectionSize()) {
                        // if we reached max selection size repaint the results so choices
                        // are replaced with the max selection reached message
                        this.updateResults(true);
                    } else {
                        // initializes search's value with nextSearchTerm and update search result
                        if(this.nextSearchTerm != undefined){
                            this.search.val(this.nextSearchTerm);
                            this.updateResults();
                            this.search.select();
                        }
                    }
                    this.positionDropdown();
                } else {
                    // if nothing left to select close
                    this.close();
                    this.search.width(10);
                }
            }

            // since its not possible to select an element that has already been
            // added we do not need to check if this is a new element before firing change
            this.triggerChange({ added: data });

            if (!options || !options.noFocus)
                this.focusSearch();
        },

        // multi
        cancel: function () {
            this.close();
            this.focusSearch();
        },

        addSelectedChoice: function (data) {
            var enableChoice = !data.locked,
                enabledItem = $(
                    "<li class='select2-search-choice'>" +
                    "    <div></div>" +
                    "    <a href='#' class='select2-search-choice-close' tabindex='-1'></a>" +
                    "</li>"),
                disabledItem = $(
                    "<li class='select2-search-choice select2-locked'>" +
                    "<div></div>" +
                    "</li>");
            var choice = enableChoice ? enabledItem : disabledItem,
                id = this.id(data),
                val = this.getVal(),
                formatted,
                cssClass;

            formatted=this.opts.formatSelection(data, choice.find("div"), this.opts.escapeMarkup);
            if (formatted != undefined) {
                choice.find("div").replaceWith($("<div></div>").html(formatted));
            }
            cssClass=this.opts.formatSelectionCssClass(data, choice.find("div"));
            if (cssClass != undefined) {
                choice.addClass(cssClass);
            }

            if(enableChoice){
              choice.find(".select2-search-choice-close")
                  .on("mousedown", killEvent)
                  .on("click dblclick", this.bind(function (e) {
                  if (!this.isInterfaceEnabled()) return;

                  this.unselect($(e.target));
                  this.selection.find(".select2-search-choice-focus").removeClass("select2-search-choice-focus");
                  killEvent(e);
                  this.close();
                  this.focusSearch();
              })).on("focus", this.bind(function () {
                  if (!this.isInterfaceEnabled()) return;
                  this.container.addClass("select2-container-active");
                  this.dropdown.addClass("select2-drop-active");
              }));
            }

            choice.data("select2-data", data);
            choice.insertBefore(this.searchContainer);

            val.push(id);
            this.setVal(val);
        },

        // multi
        unselect: function (selected) {
            var val = this.getVal(),
                data,
                index;
            selected = selected.closest(".select2-search-choice");

            if (selected.length === 0) {
                throw "Invalid argument: " + selected + ". Must be .select2-search-choice";
            }

            data = selected.data("select2-data");

            if (!data) {
                // prevent a race condition when the 'x' is clicked really fast repeatedly the event can be queued
                // and invoked on an element already removed
                return;
            }

            var evt = $.Event("select2-removing");
            evt.val = this.id(data);
            evt.choice = data;
            this.opts.element.trigger(evt);

            if (evt.isDefaultPrevented()) {
                return false;
            }

            while((index = indexOf(this.id(data), val)) >= 0) {
                val.splice(index, 1);
                this.setVal(val);
                if (this.select) this.postprocessResults();
            }

            selected.remove();

            this.opts.element.trigger({ type: "select2-removed", val: this.id(data), choice: data });
            this.triggerChange({ removed: data });

            return true;
        },

        // multi
        postprocessResults: function (data, initial, noHighlightUpdate) {
            var val = this.getVal(),
                choices = this.results.find(".select2-result"),
                compound = this.results.find(".select2-result-with-children"),
                self = this;

            choices.each2(function (i, choice) {
                var id = self.id(choice.data("select2-data"));
                if (indexOf(id, val) >= 0) {
                    choice.addClass("select2-selected");
                    // mark all children of the selected parent as selected
                    choice.find(".select2-result-selectable").addClass("select2-selected");
                }
            });

            compound.each2(function(i, choice) {
                // hide an optgroup if it doesn't have any selectable children
                if (!choice.is('.select2-result-selectable')
                    && choice.find(".select2-result-selectable:not(.select2-selected)").length === 0) {
                    choice.addClass("select2-selected");
                }
            });

            if (this.highlight() == -1 && noHighlightUpdate !== false && this.opts.closeOnSelect === true){
                self.highlight(0);
            }

            //If all results are chosen render formatNoMatches
            if(!this.opts.createSearchChoice && !choices.filter('.select2-result:not(.select2-selected)').length > 0){
                if(!data || data && !data.more && this.results.find(".select2-no-results").length === 0) {
                    if (checkFormatter(self.opts.formatNoMatches, "formatNoMatches")) {
                        this.results.append("<li class='select2-no-results'>" + evaluate(self.opts.formatNoMatches, self.opts.element, self.search.val()) + "</li>");
                    }
                }
            }

        },

        // multi
        getMaxSearchWidth: function() {
            return this.selection.width() - getSideBorderPadding(this.search);
        },

        // multi
        resizeSearch: function () {
            var minimumWidth, left, maxWidth, containerLeft, searchWidth,
                sideBorderPadding = getSideBorderPadding(this.search);

            minimumWidth = measureTextWidth(this.search) + 10;

            left = this.search.offset().left;

            maxWidth = this.selection.width();
            containerLeft = this.selection.offset().left;

            searchWidth = maxWidth - (left - containerLeft) - sideBorderPadding;

            if (searchWidth < minimumWidth) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth < 40) {
                searchWidth = maxWidth - sideBorderPadding;
            }

            if (searchWidth <= 0) {
              searchWidth = minimumWidth;
            }

            this.search.width(Math.floor(searchWidth));
        },

        // multi
        getVal: function () {
            var val;
            if (this.select) {
                val = this.select.val();
                return val === null ? [] : val;
            } else {
                val = this.opts.element.val();
                return splitVal(val, this.opts.separator, this.opts.transformVal);
            }
        },

        // multi
        setVal: function (val) {
            var unique;
            if (this.select) {
                this.select.val(val);
            } else {
                unique = [];
                // filter out duplicates
                $(val).each(function () {
                    if (indexOf(this, unique) < 0) unique.push(this);
                });
                this.opts.element.val(unique.length === 0 ? "" : unique.join(this.opts.separator));
            }
        },

        // multi
        buildChangeDetails: function (old, current) {
            var current = current.slice(0),
                old = old.slice(0);

            // remove intersection from each array
            for (var i = 0; i < current.length; i++) {
                for (var j = 0; j < old.length; j++) {
                    if (equal(this.opts.id(current[i]), this.opts.id(old[j]))) {
                        current.splice(i, 1);
                        if(i>0){
                            i--;
                        }
                        old.splice(j, 1);
                        j--;
                    }
                }
            }

            return {added: current, removed: old};
        },


        // multi
        val: function (val, triggerChange) {
            var oldData, self=this;

            if (arguments.length === 0) {
                return this.getVal();
            }

            oldData=this.data();
            if (!oldData.length) oldData=[];

            // val is an id. !val is true for [undefined,null,'',0] - 0 is legal
            if (!val && val !== 0) {
                this.opts.element.val("");
                this.updateSelection([]);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange({added: this.data(), removed: oldData});
                }
                return;
            }

            // val is a list of ids
            this.setVal(val);

            if (this.select) {
                this.opts.initSelection(this.select, this.bind(this.updateSelection));
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(oldData, this.data()));
                }
            } else {
                if (this.opts.initSelection === undefined) {
                    throw new Error("val() cannot be called if initSelection() is not defined");
                }

                this.opts.initSelection(this.opts.element, function(data){
                    var ids=$.map(data, self.id);
                    self.setVal(ids);
                    self.updateSelection(data);
                    self.clearSearch();
                    if (triggerChange) {
                        self.triggerChange(self.buildChangeDetails(oldData, self.data()));
                    }
                });
            }
            this.clearSearch();
        },

        // multi
        onSortStart: function() {
            if (this.select) {
                throw new Error("Sorting of elements is not supported when attached to <select>. Attach to <input type='hidden'/> instead.");
            }

            // collapse search field into 0 width so its container can be collapsed as well
            this.search.width(0);
            // hide the container
            this.searchContainer.hide();
        },

        // multi
        onSortEnd:function() {

            var val=[], self=this;

            // show search and move it to the end of the list
            this.searchContainer.show();
            // make sure the search container is the last item in the list
            this.searchContainer.appendTo(this.searchContainer.parent());
            // since we collapsed the width in dragStarted, we resize it here
            this.resizeSearch();

            // update selection
            this.selection.find(".select2-search-choice").each(function() {
                val.push(self.opts.id($(this).data("select2-data")));
            });
            this.setVal(val);
            this.triggerChange();
        },

        // multi
        data: function(values, triggerChange) {
            var self=this, ids, old;
            if (arguments.length === 0) {
                 return this.selection
                     .children(".select2-search-choice")
                     .map(function() { return $(this).data("select2-data"); })
                     .get();
            } else {
                old = this.data();
                if (!values) { values = []; }
                ids = $.map(values, function(e) { return self.opts.id(e); });
                this.setVal(ids);
                this.updateSelection(values);
                this.clearSearch();
                if (triggerChange) {
                    this.triggerChange(this.buildChangeDetails(old, this.data()));
                }
            }
        }
    });

    $.fn.select2 = function () {

        var args = Array.prototype.slice.call(arguments, 0),
            opts,
            select2,
            method, value, multiple,
            allowedMethods = ["val", "destroy", "opened", "open", "close", "focus", "isFocused", "container", "dropdown", "onSortStart", "onSortEnd", "enable", "disable", "readonly", "positionDropdown", "data", "search"],
            valueMethods = ["opened", "isFocused", "container", "dropdown"],
            propertyMethods = ["val", "data"],
            methodsMap = { search: "externalSearch" };

        this.each(function () {
            if (args.length === 0 || typeof(args[0]) === "object") {
                opts = args.length === 0 ? {} : $.extend({}, args[0]);
                opts.element = $(this);

                if (opts.element.get(0).tagName.toLowerCase() === "select") {
                    multiple = opts.element.prop("multiple");
                } else {
                    multiple = opts.multiple || false;
                    if ("tags" in opts) {opts.multiple = multiple = true;}
                }

                select2 = multiple ? new window.Select2["class"].multi() : new window.Select2["class"].single();
                select2.init(opts);
            } else if (typeof(args[0]) === "string") {

                if (indexOf(args[0], allowedMethods) < 0) {
                    throw "Unknown method: " + args[0];
                }

                value = undefined;
                select2 = $(this).data("select2");
                if (select2 === undefined) return;

                method=args[0];

                if (method === "container") {
                    value = select2.container;
                } else if (method === "dropdown") {
                    value = select2.dropdown;
                } else {
                    if (methodsMap[method]) method = methodsMap[method];

                    value = select2[method].apply(select2, args.slice(1));
                }
                if (indexOf(args[0], valueMethods) >= 0
                    || (indexOf(args[0], propertyMethods) >= 0 && args.length == 1)) {
                    return false; // abort the iteration, ready to return first matched value
                }
            } else {
                throw "Invalid arguments to select2 plugin: " + args;
            }
        });
        return (value === undefined) ? this : value;
    };

    // plugin defaults, accessible to users
    $.fn.select2.defaults = {
        width: "copy",
        loadMorePadding: 0,
        closeOnSelect: true,
        openOnEnter: true,
        containerCss: {},
        dropdownCss: {},
        containerCssClass: "",
        dropdownCssClass: "",
        formatResult: function(result, container, query, escapeMarkup) {
            var markup=[];
            markMatch(this.text(result), query.term, markup, escapeMarkup);
            return markup.join("");
        },
        transformVal: function(val) {
            return $.trim(val);
        },
        formatSelection: function (data, container, escapeMarkup) {
            return data ? escapeMarkup(this.text(data)) : undefined;
        },
        sortResults: function (results, container, query) {
            return results;
        },
        formatResultCssClass: function(data) {return data.css;},
        formatSelectionCssClass: function(data, container) {return undefined;},
        minimumResultsForSearch: 0,
        minimumInputLength: 0,
        maximumInputLength: null,
        maximumSelectionSize: 0,
        id: function (e) { return e == undefined ? null : e.id; },
        text: function (e) {
          if (e && this.data && this.data.text) {
            if ($.isFunction(this.data.text)) {
              return this.data.text(e);
            } else {
              return e[this.data.text];
            }
          } else {
            return e.text;
          }
        },
        matcher: function(term, text) {
            return stripDiacritics(''+text).toUpperCase().indexOf(stripDiacritics(''+term).toUpperCase()) >= 0;
        },
        separator: ",",
        tokenSeparators: [],
        tokenizer: defaultTokenizer,
        escapeMarkup: defaultEscapeMarkup,
        blurOnChange: false,
        selectOnBlur: false,
        adaptContainerCssClass: function(c) { return c; },
        adaptDropdownCssClass: function(c) { return null; },
        nextSearchTerm: function(selectedObject, currentSearchTerm) { return undefined; },
        searchInputPlaceholder: '',
        createSearchChoicePosition: 'top',
        shouldFocusInput: function (instance) {
            // Attempt to detect touch devices
            var supportsTouchEvents = (('ontouchstart' in window) ||
                                       (navigator.msMaxTouchPoints > 0));

            // Only devices which support touch events should be special cased
            if (!supportsTouchEvents) {
                return true;
            }

            // Never focus the input if search is disabled
            if (instance.opts.minimumResultsForSearch < 0) {
                return false;
            }

            return true;
        }
    };

    $.fn.select2.locales = [];

    $.fn.select2.locales['en'] = {
         formatMatches: function (matches) { if (matches === 1) { return "One result is available, press enter to select it."; } return matches + " results are available, use up and down arrow keys to navigate."; },
         formatNoMatches: function () { return "No matches found"; },
         formatAjaxError: function (jqXHR, textStatus, errorThrown) { return "Loading failed"; },
         formatInputTooShort: function (input, min) { var n = min - input.length; return "Please enter " + n + " or more character" + (n == 1 ? "" : "s"); },
         formatInputTooLong: function (input, max) { var n = input.length - max; return "Please delete " + n + " character" + (n == 1 ? "" : "s"); },
         formatSelectionTooBig: function (limit) { return "You can only select " + limit + " item" + (limit == 1 ? "" : "s"); },
         formatLoadMore: function (pageNumber) { return "Loading more results…"; },
         formatSearching: function () { return "Searching…"; }
    };

    $.extend($.fn.select2.defaults, $.fn.select2.locales['en']);

    $.fn.select2.ajaxDefaults = {
        transport: $.ajax,
        params: {
            type: "GET",
            cache: false,
            dataType: "json"
        }
    };

    // exports
    window.Select2 = {
        query: {
            ajax: ajax,
            local: local,
            tags: tags
        }, util: {
            debounce: debounce,
            markMatch: markMatch,
            escapeMarkup: defaultEscapeMarkup,
            stripDiacritics: stripDiacritics
        }, "class": {
            "abstract": AbstractSelect2,
            "single": SingleSelect2,
            "multi": MultiSelect2
        }
    };

}(jQuery));



/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Backbone = __webpack_require__(7);
    var Marionette = __webpack_require__(10);
    var XDomainRequestTransport = __webpack_require__(2761);

    // For now, force/hack Backbone and Marionette to use our version of jQuery (the current versions still rely on jQuery being globally exposed on the Window object).
    // FIXME: Once we update the below dependencies...
    Backbone.$ = $;
    Marionette.$ = $;

    // For IE browsers not supporting CORS via XMLHttpRequest, add a jQuery transport that uses XDomainRequest
    if (window.XDomainRequest && !("withCredentials" in new XMLHttpRequest())) {
        Backbone.$.ajaxTransport("json", XDomainRequestTransport);
    }

    return Backbone;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Configuration = __webpack_require__(27);
    var noop = function noop() {};

    /**
     * jQuery AJAX transport for IE9 cross-domain requests.
     *
     * <p>IE9 requires cross-domain requests to use the XDomainRequest object. See
     * http://blogs.msdn.com/b/ieinternals/archive/2010/05/13/xdomainrequest-restrictions-limitations-and-workarounds.aspx
     * for its many limitations.</p>
     *
     * <p><b>CAVEAT:</b>: for this hook to be called, there must be additional Ajax options specified such as content
     * type, data type, etc. Simply supplying an url for a GET request, for example, will result in a "No Transport"
     * error before this hook is called. </p>
     *
     * <p>Loosely based on https://github.com/jaubourg/ajaxHooks/blob/master/src/xdr.js, but with extensions to support
     * all of our required functionality.</p>
     *
     * @author Bruce Mackenzie Nielsen
     * @class XDomainRequestTransport
     */
    return function (options) {
        // Don't return anything if we shouldn't handle this request
        if (!options.crossDomain || !options.async) {
            return undefined;
        }

        // Set the timeout
        if (options.timeout) {
            options.xdrTimeout = options.timeout;
            delete options.timeout;
        }

        var xdr = void 0;
        return {
            send: function send(headers, complete) {
                var method = options.type;
                var data = options.hasContent ? options.data : null;

                // XDomainRequest only supports GET and POST, and we can't set custom headers. So for requests to our
                // API, we convert everything to POST and send some metadata along with the request payload.
                if (options.url.indexOf(Configuration.adminApiBaseUrl) === 0) {
                    method = "POST";

                    // Wrap the data with the metadata
                    var wrappedData = {
                        metadata: {
                            contentType: options.contentType,
                            method: options.type,
                            headers: headers
                        }
                    };

                    // The data is effectively double-stringified, which is on purpose: it's easiest to peel off the
                    // metadata layer first on the backend, then treat the payload as a raw JSON string
                    if (data) {
                        wrappedData.data = data;
                    }

                    data = JSON.stringify(wrappedData);
                }

                // Completion callback
                function callback(status, statusText, responses, responseHeaders) {
                    xdr.onload = xdr.onerror = xdr.ontimeout = noop;
                    xdr = undefined;
                    complete(status, statusText, responses, responseHeaders);
                }

                xdr = new XDomainRequest();

                // Attach event handlers
                xdr.onload = function () {
                    callback(200, "OK", { text: xdr.responseText }, "Content-Type: " + xdr.contentType);
                };
                xdr.onerror = function () {
                    callback(404, "Not Found");
                };
                xdr.onprogress = function () {};
                xdr.ontimeout = function () {
                    callback(0, "timeout");
                };
                xdr.timeout = options.xdrTimeout || Number.MAX_VALUE;

                // Send the request
                xdr.open(method, options.url);
                xdr.timeout = options.xdrTimeout || Number.MAX_VALUE; // Seems sometimes IE9 removes the timeout after open
                xdr.send(data);
            },
            abort: function abort() {
                if (xdr) {
                    xdr.onerror = noop;
                    xdr.abort();
                }
            }
        };
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
__webpack_require__(2763)
__webpack_require__(2764)
__webpack_require__(2765)
__webpack_require__(2766)
__webpack_require__(2767)
__webpack_require__(2768)
__webpack_require__(2769)
__webpack_require__(2770)
__webpack_require__(2771)
__webpack_require__(2772)
__webpack_require__(2773)
__webpack_require__(2774)

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);



/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);



/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);



/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);



/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);



/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);



/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);



/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);



/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);



/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);



/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);



/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);



/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/* =========================================================
 * bootstrap-colorpicker.js
 * http://www.eyecon.ro/bootstrap-colorpicker
 * =========================================================
 * Copyright 2012 Stefan Petre
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * ========================================================= */

// Zmags patch: Added #dispose method and replaced `window.jQuery` with `jQuery` to circumvent global jQuery dependency.
!function( $ ) {

	// Color object

	var Color = function(val) {
		this.value = {
			h: 1,
			s: 1,
			b: 1,
			a: 1
		};
		this.setColor(val);
	};

	Color.prototype = {
		constructor: Color,

		//parse a string to HSB
		setColor: function(val){
			val = val.toLowerCase();
			var that = this;
			$.each( CPGlobal.stringParsers, function( i, parser ) {
				var match = parser.re.exec( val ),
					values = match && parser.parse( match ),
					space = parser.space||'rgba';
				if ( values ) {
					if (space === 'hsla') {
						that.value = CPGlobal.RGBtoHSB.apply(null, CPGlobal.HSLtoRGB.apply(null, values));
					} else {
						that.value = CPGlobal.RGBtoHSB.apply(null, values);
					}
					return false;
				}
			});
		},

		setHue: function(h) {
			this.value.h = 1- h;
		},

		setSaturation: function(s) {
			this.value.s = s;
		},

		setLightness: function(b) {
			this.value.b = 1- b;
		},

		setAlpha: function(a) {
			this.value.a = parseInt((1 - a)*100, 10)/100;
		},

		// HSBtoRGB from RaphaelJS
		// https://github.com/DmitryBaranovskiy/raphael/
		toRGB: function(h, s, b, a) {
			if (!h) {
				h = this.value.h;
				s = this.value.s;
				b = this.value.b;
			}
			h *= 360;
			var R, G, B, X, C;
			h = (h % 360) / 60;
			C = b * s;
			X = C * (1 - Math.abs(h % 2 - 1));
			R = G = B = b - C;

			h = ~~h;
			R += [C, X, 0, 0, X, C][h];
			G += [X, C, C, X, 0, 0][h];
			B += [0, 0, X, C, C, X][h];
			return {
				r: Math.round(R*255),
				g: Math.round(G*255),
				b: Math.round(B*255),
				a: a||this.value.a
			};
		},

		toHex: function(h, s, b, a){
			var rgb = this.toRGB(h, s, b, a);
			return '#'+((1 << 24) | (parseInt(rgb.r) << 16) | (parseInt(rgb.g) << 8) | parseInt(rgb.b)).toString(16).substr(1);
		},

		toHSL: function(h, s, b, a){
			if (!h) {
				h = this.value.h;
				s = this.value.s;
				b = this.value.b;
			}
			var H = h,
				L = (2 - s) * b,
				S = s * b;
			if (L > 0 && L <= 1) {
				S /= L;
			} else {
				S /= 2 - L;
			}
			L /= 2;
			if (S > 1) {
				S = 1;
			}
			return {
				h: H,
				s: S,
				l: L,
				a: a||this.value.a
			};
		}
	};

	// Picker object

	var Colorpicker = function(element, options){
		this.element = $(element);
		var format = options.format||this.element.data('color-format')||'hex';
		this.format = CPGlobal.translateFormats[format];
		this.isInput = this.element.is('input');
		this.component = this.element.is('.color') ? this.element.find('.add-on') : false;

		this.picker = $(CPGlobal.template)
							.appendTo('body')
							.on('mousedown', $.proxy(this.mousedown, this));

		if (this.isInput) {
			this.element.on({
				'focus': $.proxy(this.show, this),
				'keyup': $.proxy(this.update, this)
			});
		} else if (this.component){
			this.component.on({
				'click': $.proxy(this.show, this)
			});
		} else {
			this.element.on({
				'click': $.proxy(this.show, this)
			});
		}
		if (format === 'rgba' || format === 'hsla') {
			this.picker.addClass('alpha');
			this.alpha = this.picker.find('.colorpicker-alpha')[0].style;
		}

		if (this.component){
			this.picker.find('.colorpicker-color').hide();
			this.preview = this.element.find('i')[0].style;
		} else {
			this.preview = this.picker.find('div:last')[0].style;
		}

		this.base = this.picker.find('div:first')[0].style;
		this.update();
	};

	Colorpicker.prototype = {
		constructor: Colorpicker,

		show: function(e) {
			this.picker.show();
			this.height = this.component ? this.component.outerHeight() : this.element.outerHeight();
			this.place();
			$(window).on('resize', $.proxy(this.place, this));
			if (!this.isInput) {
				if (e) {
					e.stopPropagation();
					e.preventDefault();
				}
			}
			$(document).on({
				'mousedown': $.proxy(this.hide, this)
			});
			this.element.trigger({
				type: 'show',
				color: this.color
			});
		},

		update: function(){
			this.color = new Color(this.isInput ? this.element.prop('value') : this.element.data('color'));
			this.picker.find('i')
				.eq(0).css({left: this.color.value.s*100, top: 100 - this.color.value.b*100}).end()
				.eq(1).css('top', 100 * (1 - this.color.value.h)).end()
				.eq(2).css('top', 100 * (1 - this.color.value.a));
			this.previewColor();
		},

		setValue: function(newColor) {
			this.color = new Color(newColor);
			this.picker.find('i')
				.eq(0).css({left: this.color.value.s*100, top: 100 - this.color.value.b*100}).end()
				.eq(1).css('top', 100 * (1 - this.color.value.h)).end()
				.eq(2).css('top', 100 * (1 - this.color.value.a));
			this.previewColor();
			this.element.trigger({
				type: 'changeColor',
				color: this.color
			});
		},

		dispose: function () {
			this.hide();

			$(document).off({
				mousemove: this.mousemove,
				mouseup: this.mouseup
			});

			this.picker.off();
			this.picker.remove();
		},

		hide: function(){
			this.picker.hide();
			$(window).off('resize', this.place);
			if (!this.isInput) {
				$(document).off({
					'mousedown': this.hide
				});
				if (this.component){
					this.element.find('input').prop('value', this.format.call(this));
				}
				this.element.data('color', this.format.call(this));
			} else {
				this.element.prop('value', this.format.call(this));
			}
			this.element.trigger({
				type: 'hide',
				color: this.color
			});
		},

		place: function(){
			var offset = this.component ? this.component.offset() : this.element.offset();
			this.picker.css({
				top: offset.top + this.height,
				left: offset.left
			});
		},

		//preview color change
		previewColor: function(){
			try {
				this.preview.backgroundColor = this.format.call(this);
			} catch(e) {
				this.preview.backgroundColor = this.color.toHex();
			}
			//set the color for brightness/saturation slider
			this.base.backgroundColor = this.color.toHex(this.color.value.h, 1, 1, 1);
			//set te color for alpha slider
			if (this.alpha) {
				this.alpha.backgroundColor = this.color.toHex();
			}
		},

		pointer: null,

		slider: null,

		mousedown: function(e){
			e.stopPropagation();
			e.preventDefault();

			var target = $(e.target);

			//detect the slider and set the limits and callbacks
			var zone = target.closest('div');
			if (!zone.is('.colorpicker')) {
				if (zone.is('.colorpicker-saturation')) {
					this.slider = $.extend({}, CPGlobal.sliders.saturation);
				}
				else if (zone.is('.colorpicker-hue')) {
					this.slider = $.extend({}, CPGlobal.sliders.hue);
				}
				else if (zone.is('.colorpicker-alpha')) {
					this.slider = $.extend({}, CPGlobal.sliders.alpha);
				} else {
					return false;
				}
				var offset = zone.offset();
				//reference to knob's style
				this.slider.knob = zone.find('i')[0].style;
				this.slider.left = e.pageX - offset.left;
				this.slider.top = e.pageY - offset.top;
				this.pointer = {
					left: e.pageX,
					top: e.pageY
				};
				//trigger mousemove to move the knob to the current position
				$(document).on({
					mousemove: $.proxy(this.mousemove, this),
					mouseup: $.proxy(this.mouseup, this)
				}).trigger('mousemove');
			}
			return false;
		},

		mousemove: function(e){
			e.stopPropagation();
			e.preventDefault();
			var left = Math.max(
				0,
				Math.min(
					this.slider.maxLeft,
					this.slider.left + ((e.pageX||this.pointer.left) - this.pointer.left)
				)
			);
			var top = Math.max(
				0,
				Math.min(
					this.slider.maxTop,
					this.slider.top + ((e.pageY||this.pointer.top) - this.pointer.top)
				)
			);
			this.slider.knob.left = left + 'px';
			this.slider.knob.top = top + 'px';
			if (this.slider.callLeft) {
				this.color[this.slider.callLeft].call(this.color, left/100);
			}
			if (this.slider.callTop) {
				this.color[this.slider.callTop].call(this.color, top/100);
			}
			this.previewColor();
			this.element.trigger({
				type: 'changeColor',
				color: this.color
			});
			return false;
		},

		mouseup: function(e){
			e.stopPropagation();
			e.preventDefault();
			$(document).off({
				mousemove: this.mousemove,
				mouseup: this.mouseup
			});
			return false;
		}
	}

	$.fn.colorpicker = function ( option, val ) {
		return this.each(function () {
			var $this = $(this),
				data = $this.data('colorpicker'),
				options = typeof option === 'object' && option;
			if (!data) {
				$this.data('colorpicker', (data = new Colorpicker(this, $.extend({}, $.fn.colorpicker.defaults,options))));
			}
			if (typeof option === 'string') data[option](val);
		});
	};

	$.fn.colorpicker.defaults = {
	};

	$.fn.colorpicker.Constructor = Colorpicker;

	var CPGlobal = {

		// translate a format from Color object to a string
		translateFormats: {
			'rgb': function(){
				var rgb = this.color.toRGB();
				return 'rgb('+rgb.r+','+rgb.g+','+rgb.b+')';
			},

			'rgba': function(){
				var rgb = this.color.toRGB();
				return 'rgba('+rgb.r+','+rgb.g+','+rgb.b+','+rgb.a+')';
			},

			'hsl': function(){
				var hsl = this.color.toHSL();
				return 'hsl('+Math.round(hsl.h*360)+','+Math.round(hsl.s*100)+'%,'+Math.round(hsl.l*100)+'%)';
			},

			'hsla': function(){
				var hsl = this.color.toHSL();
				return 'hsla('+Math.round(hsl.h*360)+','+Math.round(hsl.s*100)+'%,'+Math.round(hsl.l*100)+'%,'+hsl.a+')';
			},

			'hex': function(){
				return  this.color.toHex();
			}
		},

		sliders: {
			saturation: {
				maxLeft: 100,
				maxTop: 100,
				callLeft: 'setSaturation',
				callTop: 'setLightness'
			},

			hue: {
				maxLeft: 0,
				maxTop: 100,
				callLeft: false,
				callTop: 'setHue'
			},

			alpha: {
				maxLeft: 0,
				maxTop: 100,
				callLeft: false,
				callTop: 'setAlpha'
			}
		},

		// HSBtoRGB from RaphaelJS
		// https://github.com/DmitryBaranovskiy/raphael/
		RGBtoHSB: function (r, g, b, a){
			r /= 255;
			g /= 255;
			b /= 255;

			var H, S, V, C;
			V = Math.max(r, g, b);
			C = V - Math.min(r, g, b);
			H = (C === 0 ? null :
				V == r ? (g - b) / C :
				V == g ? (b - r) / C + 2 :
					(r - g) / C + 4
				);
			H = ((H + 360) % 6) * 60 / 360;
			S = C === 0 ? 0 : C / V;
			return {h: H||1, s: S, b: V, a: a||1};
		},

		HueToRGB: function (p, q, h) {
			if (h < 0)
				h += 1;
			else if (h > 1)
				h -= 1;

			if ((h * 6) < 1)
				return p + (q - p) * h * 6;
			else if ((h * 2) < 1)
				return q;
			else if ((h * 3) < 2)
				return p + (q - p) * ((2 / 3) - h) * 6;
			else
				return p;
		},

		HSLtoRGB: function (h, s, l, a)
		{
			if (s < 0) {
				s = 0;
			}
			var q;
			if (l <= 0.5) {
				q = l * (1 + s);
			} else {
				q = l + s - (l * s);
			}

			var p = 2 * l - q;

			var tr = h + (1 / 3);
			var tg = h;
			var tb = h - (1 / 3);

			var r = Math.round(CPGlobal.HueToRGB(p, q, tr) * 255);
			var g = Math.round(CPGlobal.HueToRGB(p, q, tg) * 255);
			var b = Math.round(CPGlobal.HueToRGB(p, q, tb) * 255);
			return [r, g, b, a||1];
		},

		// a set of RE's that can match strings and generate color tuples.
		// from John Resig color plugin
		// https://github.com/jquery/jquery-color/
		stringParsers: [
			{
				re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						execResult[ 1 ],
						execResult[ 2 ],
						execResult[ 3 ],
						execResult[ 4 ]
					];
				}
			}, {
				re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
				parse: function( execResult ) {
					return [
						2.55 * execResult[1],
						2.55 * execResult[2],
						2.55 * execResult[3],
						execResult[ 4 ]
					];
				}
			}, {
				re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ], 16 )
					];
				}
			}, {
				re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])/,
				parse: function( execResult ) {
					return [
						parseInt( execResult[ 1 ] + execResult[ 1 ], 16 ),
						parseInt( execResult[ 2 ] + execResult[ 2 ], 16 ),
						parseInt( execResult[ 3 ] + execResult[ 3 ], 16 )
					];
				}
			}, {
				re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
				space: 'hsla',
				parse: function( execResult ) {
					return [
						execResult[1]/360,
						execResult[2] / 100,
						execResult[3] / 100,
						execResult[4]
					];
				}
			}
		],
		template: '<div class="colorpicker dropdown-menu">'+
							'<div class="colorpicker-saturation"><i><b></b></i></div>'+
							'<div class="colorpicker-hue"><i></i></div>'+
							'<div class="colorpicker-alpha"><i></i></div>'+
							'<div class="colorpicker-color"><div /></div>'+
						'</div>'
	};

}(jQuery)



/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

/*** IMPORTS FROM imports-loader ***/
var jQuery = __webpack_require__(4);

/**
 * version 1.0.5
 * @license
 * =========================================================
 * bootstrap-datetimepicker.js
 * http://www.eyecon.ro/bootstrap-datepicker
 * =========================================================
 * Copyright 2012 Stefan Petre
 *
 * Contributions:
 *  - Andrew Rowls
 *  - Thiago de Arruda
 *  - updated for Bootstrap v3 by Jonathan Peterson @Eonasdan
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =========================================================
 */

// Zmags patch: Replaced `window.jQuery` with `jQuery` to circumvent global jQuery dependency.

(function ($) {

    // Picker object
    var smartPhone = (window.orientation !== undefined);
    var DateTimePicker = function (element, options) {
        this.id = dpgId++;
        this.init(element, options);
    };

    var dateToDate = function (dt) {
        if (typeof dt === 'string') {
            return new Date(dt);
        }
        return dt;
    };

    DateTimePicker.prototype = {
        constructor: DateTimePicker,

        init: function (element, options) {
            var icon = false;
			this.useMoment = (typeof moment != "undefined");
            if (!(options.pickTime || options.pickDate))
                throw new Error('Must choose at least one picker');
            this.options = options;
            this.$element = $(element);
            this.language = options.language in dates ? options.language : 'en';
            this.pickDate = options.pickDate;
            this.pickTime = options.pickTime;
            this.isInput = this.$element.is('input');
            this.component = false;
            if (this.$element.hasClass('input-group'))
                this.component = this.$element.find('.input-group-addon');
            this.format = options.format;
            if (!this.format) {
				if (dates[this.language].format != null)  this.format = dates[this.language].format;
                else if (this.isInput) this.format = this.$element.data('format');
                else this.format = this.$element.find('input').data('format');
                if (!this.format) this.format = (this.pickDate ? 'MM/dd/yyyy' : '')
				this.format += (this.pickTime ? ' hh:mm' : '') + (this.pickSeconds ? ':ss' : '');
            }
            this._compileFormat();
            if (this.component) icon = this.component.find('span');

            if (this.pickTime) {
                if (icon && icon.length) {
                  this.timeIcon = icon.data('time-icon');
                  this.upIcon = icon.data('up-icon');
                  this.downIcon = icon.data('down-icon');
                }
                if (!this.timeIcon) this.timeIcon = 'glyphicon glyphicon-time';
                if (!this.upIcon) this.upIcon = 'glyphicon glyphicon-chevron-up';
                if (!this.downIcon) this.downIcon = 'glyphicon glyphicon-chevron-down';
				if (icon) icon.addClass(this.timeIcon);
            }
            if (this.pickDate) {
                if (icon && icon.length) this.dateIcon = icon.data('date-icon');
                if (!this.dateIcon) this.dateIcon = 'glyphicon glyphicon-calendar';
				if (icon) {
					icon.removeClass(this.timeIcon);
					icon.addClass(this.dateIcon);
				}
            }
            this.widget = $(getTemplate(this.timeIcon, this.upIcon, this.downIcon, options.pickDate, options.pickTime,
                                        options.pick12HourFormat, options.pickSeconds, options.collapse)).appendTo('body');
            this.minViewMode = options.minViewMode || this.$element.data('date-minviewmode') || 0;
            if (typeof this.minViewMode === 'string') {
                switch (this.minViewMode) {
                    case 'months':
                        this.minViewMode = 1;
                        break;
                    case 'years':
                        this.minViewMode = 2;
                        break;
                    default:
                        this.minViewMode = 0;
                        break;
                }
            }
            this.viewMode = options.viewMode || this.$element.data('date-viewmode') || 0;
            if (typeof this.viewMode === 'string') {
                switch (this.viewMode) {
                    case 'months':
                        this.viewMode = 1;
                        break;
                    case 'years':
                        this.viewMode = 2;
                        break;
                    default:
                        this.viewMode = 0;
                        break;
                }
            }
			if (options.defaultDate !== "") this.setValue(options.defaultDate);
			this.startViewMode = this.viewMode;
            this.weekStart = options.weekStart || this.$element.data('date-weekstart') || 0;
            this.weekEnd = this.weekStart === 0 ? 6 : this.weekStart - 1;
            this.setStartDate(options.startDate || this.$element.data('date-startdate'));
            this.setEndDate(options.endDate || this.$element.data('date-enddate'));
            this.fillDow();
            this.fillMonths();
            this.fillHours();
            this.fillMinutes();
            this.fillSeconds();
            this.update();
            this.showMode();
            this._attachDatePickerEvents();
        },

        show: function (e) {
            this.widget.show();
            this.height = this.component ? this.component.outerHeight() : this.$element.outerHeight();
            this.place();
            this.$element.trigger({
                type: 'show',
                date: this._date
            });
            this._attachDatePickerGlobalEvents();
            if (e) {
                e.stopPropagation();
                e.preventDefault();
            }
        },

        disable: function () {
            this.$element.find('input').prop('disabled', true);
            this._detachDatePickerEvents();
        },
        enable: function () {
            this.$element.find('input').prop('disabled', false);
            this._attachDatePickerEvents();
        },

        hide: function () {
            // Ignore event if in the middle of a picker transition
            var collapse = this.widget.find('.collapse');
            for (var i = 0; i < collapse.length; i++) {
                var collapseData = collapse.eq(i).data('collapse');
                if (collapseData && collapseData.transitioning)
                    return;
            }
            this.widget.hide();
            this.viewMode = this.startViewMode;
            this.showMode();
            this.$element.trigger({
                type: 'hide',
                date: this._date
            });
            this._detachDatePickerGlobalEvents();
        },

        set: function () {
            var formatted = '';
            if (!this._unset) {
				if (this.useMoment) {
					formatted = moment(this._date).format(this.format);
				}
				else {
					formatted = this.formatDate(this._date);
				}
			}
            if (!this.isInput) {
                if (this.component) {
                    var input = this.$element.find('input');
                    input.val(formatted);
                    this._resetMaskPos(input);
                }
                this.$element.data('date', formatted);
            } else {
                this.$element.val(formatted);
                this._resetMaskPos(this.$element);
            }
            if (!this.pickTime) this.hide();
        },

        setValue: function (newDate) {
            if (!newDate) {
                this._unset = true;
            } else {
                this._unset = false;
            }
            if (typeof newDate === 'string') {
                this._date = this.parseDate(newDate);
            } else if (newDate) {
                this._date = new Date(newDate);
            }
            this.set();
            this.viewDate = new UTCDate(this._date.getUTCFullYear(), this._date.getUTCMonth(), 1, 0, 0, 0, 0);
            this.fillDate();
            this.fillTime();
        },

        getDate: function () {
            if (this._unset) return null;
            return new Date(this._date.valueOf());
        },

        setDate: function (date) {
            if (!date) this.setValue(null);
            else this.setValue(date.valueOf());
        },

        setStartDate: function (date) {
            if (date instanceof Date) {
                this.startDate = date;
            } else if (typeof date === 'string') {
                this.startDate = new UTCDate(date);
                if (!this.startDate.getUTCFullYear()) {
                    this.startDate = -Infinity;
                }
            } else {
                this.startDate = -Infinity;
            }
            if (this.viewDate) {
                this.update();
            }
        },

        setEndDate: function (date) {
            if (date instanceof Date) {
                this.endDate = date;
            } else if (typeof date === 'string') {
                this.endDate = new UTCDate(date);
                if (!this.endDate.getUTCFullYear()) {
                    this.endDate = Infinity;
                }
            } else {
                this.endDate = Infinity;
            }
            if (this.viewDate) {
                this.update();
            }
        },

        getLocalDate: function () {
            if (this._unset) return null;
            var d = this._date;
            return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate(),
                            d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
        },

        setLocalDate: function (localDate) {
            if (!localDate) this.setValue(null);
            else
                this.setValue(Date.UTC(
                  localDate.getFullYear(),
                  localDate.getMonth(),
                  localDate.getDate(),
                  localDate.getHours(),
                  localDate.getMinutes(),
                  localDate.getSeconds(),
                  localDate.getMilliseconds()));
        },

        place: function () {
            var position = 'absolute';
            var offset = this.component ? this.component.offset() : this.$element.offset();
            this.width = this.component ? this.component.outerWidth() : this.$element.outerWidth();
            offset.top = offset.top + this.$element.outerHeight();

            var $window = $(window);

            if (this.options.width !== undefined) {
                this.widget.width(this.options.width);
            }

            if (this.options.orientation === 'left') {
                this.widget.addClass('left-oriented');
                offset.left = offset.left - this.widget.width() + 20;
            }

            if (this._isInFixed()) {
                position = 'fixed';
                offset.top -= $window.scrollTop();
                offset.left -= $window.scrollLeft();
            }

            if ($window.width() < offset.left + this.widget.outerWidth()) {
                offset.right = $window.width() - offset.left - this.width;
                offset.left = 'auto';
                this.widget.addClass('pull-right');
            } else {
                offset.right = 'auto';
                this.widget.removeClass('pull-right');
            }

            this.widget.css({
                position: position,
                top: offset.top,
                left: offset.left,
                right: offset.right
            });
        },

        notifyChange: function () {
            this.$element.trigger({
                type: 'changeDate',
                date: this.getDate(),
                localDate: this.getLocalDate()
            });
        },

        update: function (newDate) {
            var dateStr = newDate;
            if (!dateStr) {
                if (this.isInput) {
                    dateStr = this.$element.val();
                } else {
                    dateStr = this.$element.find('input').val();
                }
                if (dateStr) {
                    this._date = this.parseDate(dateStr);
                }
                if (!this._date) {
                    var tmp = new Date();
                    this._date = new UTCDate(tmp.getFullYear(),
                                        tmp.getMonth(),
                                        tmp.getDate(),
                                        tmp.getHours(),
                                        tmp.getMinutes(),
                                        tmp.getSeconds(),
                                        tmp.getMilliseconds());
                }
            }
            this.viewDate = new UTCDate(this._date.getUTCFullYear(), this._date.getUTCMonth(), 1, 0, 0, 0, 0);
            this.fillDate();
            this.fillTime();
        },

        fillDow: function () {
            var dowCnt = this.weekStart;
            var html = $('<tr>');
            while (dowCnt < this.weekStart + 7) {
                html.append('<th class="dow">' + dates[this.language].daysMin[(dowCnt++) % 7] + '</th>');
            }
            this.widget.find('.datepicker-days thead').append(html);
        },

        fillMonths: function () {
            var html = '';
            var i = 0;
            while (i < 12) {
                html += '<span class="month">' + dates[this.language].monthsShort[i++] + '</span>';
            }
            this.widget.find('.datepicker-months td').append(html);
        },

        fillDate: function () {
            var year = this.viewDate.getUTCFullYear();
            var month = this.viewDate.getUTCMonth();
            var currentDate = UTCDate(
              this._date.getUTCFullYear(),
              this._date.getUTCMonth(),
              this._date.getUTCDate(),
              0, 0, 0, 0
            );
            var startYear = typeof this.startDate === 'object' ? this.startDate.getUTCFullYear() : -Infinity;
            var startMonth = typeof this.startDate === 'object' ? this.startDate.getUTCMonth() : -1;
            var endYear = typeof this.endDate === 'object' ? this.endDate.getUTCFullYear() : Infinity;
            var endMonth = typeof this.endDate === 'object' ? this.endDate.getUTCMonth() : 12;

            this.widget.find('.datepicker-days').find('.disabled').removeClass('disabled');
            this.widget.find('.datepicker-months').find('.disabled').removeClass('disabled');
            this.widget.find('.datepicker-years').find('.disabled').removeClass('disabled');

            this.widget.find('.datepicker-days th:eq(1)').text(
              dates[this.language].months[month] + ' ' + year);

            var prevMonth = UTCDate(year, month - 1, 28, 0, 0, 0, 0);
            var day = DPGlobal.getDaysInMonth(
              prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
            prevMonth.setUTCDate(day);
            prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.weekStart + 7) % 7);
            if ((year == startYear && month <= startMonth) || year < startYear) {
                this.widget.find('.datepicker-days th:eq(0)').addClass('disabled');
            }
            if ((year == endYear && month >= endMonth) || year > endYear) {
                this.widget.find('.datepicker-days th:eq(2)').addClass('disabled');
            }

            var nextMonth = new Date(prevMonth.valueOf());
            nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
            nextMonth = nextMonth.valueOf();
            var html = [];
            var row;
            var clsName;
            while (prevMonth.valueOf() < nextMonth) {
                if (prevMonth.getUTCDay() === this.weekStart) {
                    row = $('<tr>');
                    html.push(row);
                }
                clsName = '';
                if (prevMonth.getUTCFullYear() < year ||
                    (prevMonth.getUTCFullYear() == year &&
                     prevMonth.getUTCMonth() < month)) {
                    clsName += ' old';
                } else if (prevMonth.getUTCFullYear() > year ||
                           (prevMonth.getUTCFullYear() == year &&
                            prevMonth.getUTCMonth() > month)) {
                    clsName += ' new';
                }
                if (prevMonth.valueOf() === currentDate.valueOf()) {
                    clsName += ' active';
                }
                if ((prevMonth.valueOf() + 86400000) <= this.startDate) {
                    clsName += ' disabled';
                }
                if (prevMonth.valueOf() > this.endDate) {
                    clsName += ' disabled';
                }
                row.append('<td class="day' + clsName + '">' + prevMonth.getUTCDate() + '</td>');
                prevMonth.setUTCDate(prevMonth.getUTCDate() + 1);
            }
            this.widget.find('.datepicker-days tbody').empty().append(html);
            var currentYear = this._date.getUTCFullYear();

            var months = this.widget.find('.datepicker-months').find(
              'th:eq(1)').text(year).end().find('span').removeClass('active');
            if (currentYear === year) {
                months.eq(this._date.getUTCMonth()).addClass('active');
            }
            if (currentYear - 1 < startYear) {
                this.widget.find('.datepicker-months th:eq(0)').addClass('disabled');
            }
            if (currentYear + 1 > endYear) {
                this.widget.find('.datepicker-months th:eq(2)').addClass('disabled');
            }
            for (var i = 0; i < 12; i++) {
                if ((year == startYear && startMonth > i) || (year < startYear)) {
                    $(months[i]).addClass('disabled');
                } else if ((year == endYear && endMonth < i) || (year > endYear)) {
                    $(months[i]).addClass('disabled');
                }
            }

            html = '';
            year = parseInt(year / 10, 10) * 10;
            var yearCont = this.widget.find('.datepicker-years').find(
              'th:eq(1)').text(year + '-' + (year + 9)).end().find('td');
            this.widget.find('.datepicker-years').find('th').removeClass('disabled');
            if (startYear > year) {
                this.widget.find('.datepicker-years').find('th:eq(0)').addClass('disabled');
            }
            if (endYear < year + 9) {
                this.widget.find('.datepicker-years').find('th:eq(2)').addClass('disabled');
            }
            year -= 1;
            for (var i = -1; i < 11; i++) {
                html += '<span class="year' + (i === -1 || i === 10 ? ' old' : '') + (currentYear === year ? ' active' : '') + ((year < startYear || year > endYear) ? ' disabled' : '') + '">' + year + '</span>';
                year += 1;
            }
            yearCont.html(html);
        },

        fillHours: function () {
            var table = this.widget.find(
              '.timepicker .timepicker-hours table');
            table.parent().hide();
            var html = '';
            if (this.options.pick12HourFormat) {
                var current = 1;
                for (var i = 0; i < 3; i += 1) {
                    html += '<tr>';
                    for (var j = 0; j < 4; j += 1) {
                        var c = current.toString();
                        html += '<td class="hour">' + padLeft(c, 2, '0') + '</td>';
                        current++;
                    }
                    html += '</tr>';
                }
            } else {
                var current = 0;
                for (var i = 0; i < 6; i += 1) {
                    html += '<tr>';
                    for (var j = 0; j < 4; j += 1) {
                        var c = current.toString();
                        html += '<td class="hour">' + padLeft(c, 2, '0') + '</td>';
                        current++;
                    }
                    html += '</tr>';
                }
            }
            table.html(html);
        },

        fillMinutes: function () {
            var table = this.widget.find(
              '.timepicker .timepicker-minutes table');
            table.parent().hide();
            var html = '';
            var current = 0;
            for (var i = 0; i < 5; i++) {
                html += '<tr>';
                for (var j = 0; j < 4; j += 1) {
                    var c = current.toString();
                    html += '<td class="minute">' + padLeft(c, 2, '0') + '</td>';
                    current += 3;
                }
                html += '</tr>';
            }
            table.html(html);
        },

        fillSeconds: function () {
            var table = this.widget.find(
              '.timepicker .timepicker-seconds table');
            table.parent().hide();
            var html = '';
            var current = 0;
            for (var i = 0; i < 5; i++) {
                html += '<tr>';
                for (var j = 0; j < 4; j += 1) {
                    var c = current.toString();
                    html += '<td class="second">' + padLeft(c, 2, '0') + '</td>';
                    current += 3;
                }
                html += '</tr>';
            }
            table.html(html);
        },

        fillTime: function () {
            if (!this._date)
                return;
            var timeComponents = this.widget.find('.timepicker span[data-time-component]');
            var table = timeComponents.closest('table');
            var is12HourFormat = this.options.pick12HourFormat;
            var hour = this._date.getUTCHours();
            var period = 'AM';
            if (is12HourFormat) {
                if (hour >= 12) period = 'PM';
                if (hour === 0) hour = 12;
                else if (hour != 12) hour = hour % 12;
                this.widget.find(
                  '.timepicker [data-action=togglePeriod]').text(period);
            }
            hour = padLeft(hour.toString(), 2, '0');
            var minute = padLeft(this._date.getUTCMinutes().toString(), 2, '0');
            var second = padLeft(this._date.getUTCSeconds().toString(), 2, '0');
            timeComponents.filter('[data-time-component=hours]').text(hour);
            timeComponents.filter('[data-time-component=minutes]').text(minute);
            timeComponents.filter('[data-time-component=seconds]').text(second);
        },

        click: function (e) {
            e.stopPropagation();
            e.preventDefault();
            this._unset = false;
            var target = $(e.target).closest('span, td, th');
            if (target.length === 1) {
                if (!target.is('.disabled')) {
                    switch (target[0].nodeName.toLowerCase()) {
                        case 'th':
                            switch (target[0].className) {
                                case 'switch':
                                    this.showMode(1);
                                    break;
                                case 'prev':
                                case 'next':
                                    var vd = this.viewDate;
                                    var navFnc = DPGlobal.modes[this.viewMode].navFnc;
                                    var step = DPGlobal.modes[this.viewMode].navStep;
                                    if (target[0].className === 'prev') step = step * -1;
                                    vd['set' + navFnc](vd['get' + navFnc]() + step);
                                    this.fillDate();
                                    break;
                            }
                            break;
                        case 'span':
                            if (target.is('.month')) {
                                var month = target.parent().find('span').index(target);
                                this.viewDate.setUTCMonth(month);
                            } else {
                                var year = parseInt(target.text(), 10) || 0;
                                this.viewDate.setUTCFullYear(year);
                            }
                            if (this.viewMode !== 0) {
                                this._date = UTCDate(
                                  this.viewDate.getUTCFullYear(),
                                  this.viewDate.getUTCMonth(),
                                  this.viewDate.getUTCDate(),
                                  this._date.getUTCHours(),
                                  this._date.getUTCMinutes(),
                                  this._date.getUTCSeconds(),
                                  this._date.getUTCMilliseconds()
                                );
                                this.notifyChange();
                            }
                            this.showMode(-1);
                            this.fillDate();
                            break;
                        case 'td':
                            if (target.is('.day')) {
                                var day = parseInt(target.text(), 10) || 1;
                                var month = this.viewDate.getUTCMonth();
                                var year = this.viewDate.getUTCFullYear();
                                if (target.is('.old')) {
                                    if (month === 0) {
                                        month = 11;
                                        year -= 1;
                                    } else {
                                        month -= 1;
                                    }
                                } else if (target.is('.new')) {
                                    if (month == 11) {
                                        month = 0;
                                        year += 1;
                                    } else {
                                        month += 1;
                                    }
                                }
                                this._date = UTCDate(
                                  year, month, day,
                                  this._date.getUTCHours(),
                                  this._date.getUTCMinutes(),
                                  this._date.getUTCSeconds(),
                                  this._date.getUTCMilliseconds()
                                );
                                this.viewDate = UTCDate(
                                  year, month, Math.min(28, day), 0, 0, 0, 0);
                                this.fillDate();
                                this.set();
                                this.notifyChange();
                            }
                            break;
                    }
                }
            }
        },

        actions: {
            incrementHours: function (e) {
                this._date.setUTCHours(this._date.getUTCHours() + 1);
            },

            incrementMinutes: function (e) {
                this._date.setUTCMinutes(this._date.getUTCMinutes() + 1);
            },

            incrementSeconds: function (e) {
                this._date.setUTCSeconds(this._date.getUTCSeconds() + 1);
            },

            decrementHours: function (e) {
                this._date.setUTCHours(this._date.getUTCHours() - 1);
            },

            decrementMinutes: function (e) {
                this._date.setUTCMinutes(this._date.getUTCMinutes() - 1);
            },

            decrementSeconds: function (e) {
                this._date.setUTCSeconds(this._date.getUTCSeconds() - 1);
            },

            togglePeriod: function (e) {
                var hour = this._date.getUTCHours();
                if (hour >= 12) hour -= 12;
                else hour += 12;
                this._date.setUTCHours(hour);
            },

            showPicker: function () {
                this.widget.find('.timepicker > div:not(.timepicker-picker)').hide();
                this.widget.find('.timepicker .timepicker-picker').show();
            },

            showHours: function () {
                this.widget.find('.timepicker .timepicker-picker').hide();
                this.widget.find('.timepicker .timepicker-hours').show();
            },

            showMinutes: function () {
                this.widget.find('.timepicker .timepicker-picker').hide();
                this.widget.find('.timepicker .timepicker-minutes').show();
            },

            showSeconds: function () {
                this.widget.find('.timepicker .timepicker-picker').hide();
                this.widget.find('.timepicker .timepicker-seconds').show();
            },

            selectHour: function (e) {
                var tgt = $(e.target);
                var value = parseInt(tgt.text(), 10);
                if (this.options.pick12HourFormat) {
                    var current = this._date.getUTCHours();
                    if (current >= 12) {
                        if (value != 12) value = (value + 12) % 24;
                    } else {
                        if (value === 12) value = 0;
                        else value = value % 12;
                    }
                }
                this._date.setUTCHours(value);
                this.actions.showPicker.call(this);
            },

            selectMinute: function (e) {
                var tgt = $(e.target);
                var value = parseInt(tgt.text(), 10);
                this._date.setUTCMinutes(value);
                this.actions.showPicker.call(this);
            },

            selectSecond: function (e) {
                var tgt = $(e.target);
                var value = parseInt(tgt.text(), 10);
                this._date.setUTCSeconds(value);
                this.actions.showPicker.call(this);
            }
        },

        doAction: function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!this._date) this._date = UTCDate(1970, 0, 0, 0, 0, 0, 0);
            var action = $(e.currentTarget).data('action');
            var rv = this.actions[action].apply(this, arguments);
            this.set();
            this.fillTime();
            this.notifyChange();
            return rv;
        },

        stopEvent: function (e) {
            e.stopPropagation();
            e.preventDefault();
        },

        // part of the following code was taken from
        // http://cloud.github.com/downloads/digitalBush/jquery.maskedinput/jquery.maskedinput-1.3.js
        keydown: function (e) {
            var self = this, k = e.which, input = $(e.target);
            if (k == 8 || k == 46) {
                // backspace and delete cause the maskPosition
                // to be recalculated
                setTimeout(function () {
                    self._resetMaskPos(input);
                });
            }
        },

        keypress: function (e) {
            var k = e.which;
            if (k == 8 || k == 46) {
                // For those browsers which will trigger
                // keypress on backspace/delete
                return;
            }
            var input = $(e.target);
            var c = String.fromCharCode(k);
            var val = input.val() || '';
            val += c;
            var mask = this._mask[this._maskPos];
            if (!mask) {
                return false;
            }
            if (mask.end != val.length) {
                return;
            }
            if (!mask.pattern.test(val.slice(mask.start))) {
                val = val.slice(0, val.length - 1);
                while ((mask = this._mask[this._maskPos]) && mask.character) {
                    val += mask.character;
                    // advance mask position past static
                    // part
                    this._maskPos++;
                }
                val += c;
                if (mask.end != val.length) {
                    input.val(val);
                    return false;
                } else {
                    if (!mask.pattern.test(val.slice(mask.start))) {
                        input.val(val.slice(0, mask.start));
                        return false;
                    } else {
                        input.val(val);
                        this._maskPos++;
                        return false;
                    }
                }
            } else {
                this._maskPos++;
            }
        },

        change: function (e) {
            var input = $(e.target);
            var val = input.val();
            if (this._formatPattern.test(val)) {
                this.update();
                this.setValue(this._date.getTime());
                this.notifyChange();
                this.set();
            } else if (val && val.trim()) {
                this.setValue(this._date.getTime());
                if (this._date) this.set();
                else input.val('');
            } else {
                if (this._date) {
                    this.setValue(null);
                    // unset the date when the input is
                    // erased
                    this.notifyChange();
                    this._unset = true;
                }
            }
            this._resetMaskPos(input);
        },

        showMode: function (dir) {
            if (dir) {
                this.viewMode = Math.max(this.minViewMode, Math.min(
                  2, this.viewMode + dir));
            }
            this.widget.find('.datepicker > div').hide().filter(
              '.datepicker-' + DPGlobal.modes[this.viewMode].clsName).show();
        },

        destroy: function () {
            this._detachDatePickerEvents();
            this._detachDatePickerGlobalEvents();
            this.widget.remove();
            this.$element.removeData('datetimepicker');
            this.component.removeData('datetimepicker');
        },

        formatDate: function (d) {
            return this.format.replace(formatReplacer, function (match) {
                var methodName, property, rv, len = match.length;
                if (match === 'ms')
                    len = 1;
                property = dateFormatComponents[match].property;
                if (property === 'Hours12') {
                    rv = d.getUTCHours();
                    if (rv === 0) rv = 12;
                    else if (rv !== 12) rv = rv % 12;
                } else if (property === 'Period12') {
                    if (d.getUTCHours() >= 12) return 'PM';
                    else return 'AM';
                } else {
                    methodName = 'get' + property;
                    rv = d[methodName]();
                }
                if (methodName === 'getUTCMonth') rv = rv + 1;
                if (methodName === 'getUTCYear') rv = rv + 1900 - 2000;
                return padLeft(rv.toString(), len, '0');
            });
        },

        parseDate: function (str) {
			if (this.useMoment) {
                var f = moment(str);
                return f;
            }
            var match, i, property, methodName, value, parsed = {};
            if (!(match = this._formatPattern.exec(str)))
                return null;
            for (i = 1; i < match.length; i++) {
                property = this._propertiesByIndex[i];
                if (!property)
                    continue;
                value = match[i];
                if (/^\d+$/.test(value))
                    value = parseInt(value, 10);
                parsed[property] = value;
            }
            return this._finishParsingDate(parsed);
        },

        _resetMaskPos: function (input) {
            var val = input.val();
            for (var i = 0; i < this._mask.length; i++) {
                if (this._mask[i].end > val.length) {
                    // If the mask has ended then jump to
                    // the next
                    this._maskPos = i;
                    break;
                } else if (this._mask[i].end === val.length) {
                    this._maskPos = i + 1;
                    break;
                }
            }
        },

        _finishParsingDate: function (parsed) {
            var year, month, date, hours, minutes, seconds, milliseconds;
            year = parsed.UTCFullYear;
            if (parsed.UTCYear) year = 2000 + parsed.UTCYear;
            if (!year) year = 1970;
            if (parsed.UTCMonth) month = parsed.UTCMonth - 1;
            else month = 0;
            date = parsed.UTCDate || 1;
            hours = parsed.UTCHours || 0;
            minutes = parsed.UTCMinutes || 0;
            seconds = parsed.UTCSeconds || 0;
            milliseconds = parsed.UTCMilliseconds || 0;
            if (parsed.Hours12) {
                hours = parsed.Hours12;
            }
            if (parsed.Period12) {
                if (/pm/i.test(parsed.Period12)) {
                    if (hours != 12) hours = (hours + 12) % 24;
                } else {
                    hours = hours % 12;
                }
            }
            return UTCDate(year, month, date, hours, minutes, seconds, milliseconds);
        },

        _compileFormat: function () {
            var match, component, components = [], mask = [],
            str = this.format, propertiesByIndex = {}, i = 0, pos = 0;
            while (match = formatComponent.exec(str)) {
                component = match[0];
                if (component in dateFormatComponents) {
                    i++;
                    propertiesByIndex[i] = dateFormatComponents[component].property;
                    components.push('\\s*' + dateFormatComponents[component].getPattern(
                      this) + '\\s*');
                    mask.push({
                        pattern: new RegExp(dateFormatComponents[component].getPattern(
                          this)),
                        property: dateFormatComponents[component].property,
                        start: pos,
                        end: pos += component.length
                    });
                }
                else {
                    components.push(escapeRegExp(component));
                    mask.push({
                        pattern: new RegExp(escapeRegExp(component)),
                        character: component,
                        start: pos,
                        end: ++pos
                    });
                }
                str = str.slice(component.length);
            }
            this._mask = mask;
            this._maskPos = 0;
            this._formatPattern = new RegExp(
              '^\\s*' + components.join('') + '\\s*$');
            this._propertiesByIndex = propertiesByIndex;
        },

        _attachDatePickerEvents: function () {
            var self = this;
            // this handles date picker clicks
            this.widget.on('click', '.datepicker *', $.proxy(this.click, this));
            // this handles time picker clicks
            this.widget.on('click', '[data-action]', $.proxy(this.doAction, this));
            this.widget.on('mousedown', $.proxy(this.stopEvent, this));
            if (this.pickDate && this.pickTime) {
                this.widget.on('click.togglePicker', '.accordion-toggle', function (e) {
                    e.stopPropagation();
                    var $this = $(this);
                    var $parent = $this.closest('ul');
                    var expanded = $parent.find('.in');
                    var closed = $parent.find('.collapse:not(.in)');

                    if (expanded && expanded.length) {
                        var collapseData = expanded.data('collapse');
                        if (collapseData && collapseData.transitioning) return;
                        expanded.collapse('hide');
                        closed.collapse('show');
                        $this.find('span').toggleClass(self.timeIcon + ' ' + self.dateIcon);
                        self.$element.find('.input-group-addon span').toggleClass(self.timeIcon + ' ' + self.dateIcon);
                    }
                });
            }
            if (this.isInput) {
                this.$element.on({
                    'focus': $.proxy(this.show, this),
                    'change': $.proxy(this.change, this),
                    'blur': $.proxy(this.hide, this)
                });
                if (this.options.maskInput) {
                    this.$element.on({
                        'keydown': $.proxy(this.keydown, this),
                        'keypress': $.proxy(this.keypress, this)
                    });
                }
            } else {
                this.$element.on({
                    'change': $.proxy(this.change, this)
                }, 'input');
                if (this.options.maskInput) {
                    this.$element.on({
                        'keydown': $.proxy(this.keydown, this),
                        'keypress': $.proxy(this.keypress, this)
                    }, 'input');
                }
                if (this.component) {
                    this.component.on('click', $.proxy(this.show, this));
                } else {
                    this.$element.on('click', $.proxy(this.show, this));
                }
            }
        },

        _attachDatePickerGlobalEvents: function () {
            $(window).on(
              'resize.datetimepicker' + this.id, $.proxy(this.place, this));
            if (!this.isInput) {
                $(document).on(
                  'mousedown.datetimepicker' + this.id, $.proxy(this.hide, this));
            }
        },

        _detachDatePickerEvents: function () {
            this.widget.off('click', '.datepicker *', this.click);
            this.widget.off('click', '[data-action]');
            this.widget.off('mousedown', this.stopEvent);
            if (this.pickDate && this.pickTime) {
                this.widget.off('click.togglePicker');
            }
            if (this.isInput) {
                this.$element.off({
                    'focus': this.show,
                    'change': this.change
                });
                if (this.options.maskInput) {
                    this.$element.off({
                        'keydown': this.keydown,
                        'keypress': this.keypress
                    });
                }
            } else {
                this.$element.off({
                    'change': this.change
                }, 'input');
                if (this.options.maskInput) {
                    this.$element.off({
                        'keydown': this.keydown,
                        'keypress': this.keypress
                    }, 'input');
                }
                if (this.component) {
                    this.component.off('click', this.show);
                } else {
                    this.$element.off('click', this.show);
                }
            }
        },

        _detachDatePickerGlobalEvents: function () {
            $(window).off('resize.datetimepicker' + this.id);
            if (!this.isInput) {
                $(document).off('mousedown.datetimepicker' + this.id);
            }
        },

        _isInFixed: function () {
            if (this.$element) {
                var parents = this.$element.parents();
                var inFixed = false;
                for (var i = 0; i < parents.length; i++) {
                    if ($(parents[i]).css('position') == 'fixed') {
                        inFixed = true;
                        break;
                    }
                };
                return inFixed;
            } else {
                return false;
            }
        }
    };

    $.fn.datetimepicker = function (option, val) {
        return this.each(function () {
            var $this = $(this),
            data = $this.data('datetimepicker'),
            options = typeof option === 'object' && option;
            if (!data) {
                $this.data('datetimepicker', (data = new DateTimePicker(
                  this, $.extend({}, $.fn.datetimepicker.defaults, options))));
            }
            if (typeof option === 'string') data[option](val);
        });
    };

    $.fn.datetimepicker.defaults = {
        maskInput: false,
        pickDate: true,
        pickTime: true,
        pick12HourFormat: false,
        pickSeconds: true,
        startDate: -Infinity,
        endDate: Infinity,
        collapse: true,
		defaultDate: ""
    };
    $.fn.datetimepicker.Constructor = DateTimePicker;
    var dpgId = 0;
    var dates = $.fn.datetimepicker.dates = {
        en: {
            days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday",
              "Friday", "Saturday", "Sunday"],
            daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
            daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
            months: ["January", "February", "March", "April", "May", "June",
              "July", "August", "September", "October", "November", "December"],
            monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul",
              "Aug", "Sep", "Oct", "Nov", "Dec"]
        }
    };

    var dateFormatComponents = {
        dd: { property: 'UTCDate', getPattern: function () { return '(0?[1-9]|[1-2][0-9]|3[0-1])\\b'; } },
        MM: { property: 'UTCMonth', getPattern: function () { return '(0?[1-9]|1[0-2])\\b'; } },
        yy: { property: 'UTCYear', getPattern: function () { return '(\\d{2})\\b'; } },
        yyyy: { property: 'UTCFullYear', getPattern: function () { return '(\\d{4})\\b'; } },
        hh: { property: 'UTCHours', getPattern: function () { return '(0?[0-9]|1[0-9]|2[0-3])\\b'; } },
        mm: { property: 'UTCMinutes', getPattern: function () { return '(0?[0-9]|[1-5][0-9])\\b'; } },
        ss: { property: 'UTCSeconds', getPattern: function () { return '(0?[0-9]|[1-5][0-9])\\b'; } },
        ms: { property: 'UTCMilliseconds', getPattern: function () { return '([0-9]{1,3})\\b'; } },
        HH: { property: 'Hours12', getPattern: function () { return '(0?[1-9]|1[0-2])\\b'; } },
        PP: { property: 'Period12', getPattern: function () { return '(AM|PM|am|pm|Am|aM|Pm|pM)\\b'; } }
    };

    var keys = [];
    for (var k in dateFormatComponents) keys.push(k);
    keys[keys.length - 1] += '\\b';
    keys.push('.');

    var formatComponent = new RegExp(keys.join('\\b|'));
    keys.pop();
    var formatReplacer = new RegExp(keys.join('\\b|'), 'g');

    function escapeRegExp(str) {
        // http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }

    function padLeft(s, l, c) {
        if (l < s.length) return s;
        else return Array(l - s.length + 1).join(c || ' ') + s;
    }

    function getTemplate(timeIcon, upIcon, downIcon, pickDate, pickTime, is12Hours, showSeconds, collapse) {
        if (pickDate && pickTime) {
            return (
              '<div class="bootstrap-datetimepicker-widget dropdown-menu" style="z-index:9999 !important;">' +
                '<ul class="list-unstyled">' +
                  '<li' + (collapse ? ' class="collapse in"' : '') + '>' +
                    '<div class="datepicker">' +
                      DPGlobal.template +
                    '</div>' +
                  '</li>' +
                  '<li class="picker-switch accordion-toggle"><a class="btn" style="width:100%"><span class="' + timeIcon + '"></span></a></li>' +
                  '<li' + (collapse ? ' class="collapse"' : '') + '>' +
                    '<div class="timepicker">' +
                      TPGlobal.getTemplate(is12Hours, showSeconds, upIcon, downIcon) +
                    '</div>' +
                  '</li>' +
                '</ul>' +
              '</div>'
            );
        } else if (pickTime) {
            return (
              '<div class="bootstrap-datetimepicker-widget dropdown-menu">' +
                '<div class="timepicker">' +
                  TPGlobal.getTemplate(is12Hours, showSeconds, upIcon, downIcon) +
                '</div>' +
              '</div>'
            );
        } else {
            return (
              '<div class="bootstrap-datetimepicker-widget dropdown-menu">' +
                '<div class="datepicker">' +
                  DPGlobal.template +
                '</div>' +
              '</div>'
            );
        }
    }

    function UTCDate() {
        return new Date(Date.UTC.apply(Date, arguments));
    }

    var DPGlobal = {
        modes: [
          {
              clsName: 'days',
              navFnc: 'UTCMonth',
              navStep: 1
          },
        {
            clsName: 'months',
            navFnc: 'UTCFullYear',
            navStep: 1
        },
        {
            clsName: 'years',
            navFnc: 'UTCFullYear',
            navStep: 10
        }],
        isLeapYear: function (year) {
            return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
        },
        getDaysInMonth: function (year, month) {
            return [31, (DPGlobal.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
        },
        headTemplate:
          '<thead>' +
            '<tr>' +
              '<th class="prev">&lsaquo;</th>' +
              '<th colspan="5" class="switch"></th>' +
              '<th class="next">&rsaquo;</th>' +
            '</tr>' +
          '</thead>',
        contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>'
    };
    DPGlobal.template =
      '<div class="datepicker-days">' +
        '<table class="table-condensed">' +
          DPGlobal.headTemplate +
          '<tbody></tbody>' +
        '</table>' +
      '</div>' +
      '<div class="datepicker-months">' +
        '<table class="table-condensed">' +
          DPGlobal.headTemplate +
          DPGlobal.contTemplate +
        '</table>' +
      '</div>' +
      '<div class="datepicker-years">' +
        '<table class="table-condensed">' +
          DPGlobal.headTemplate +
          DPGlobal.contTemplate +
        '</table>' +
      '</div>';
    var TPGlobal = {
        hourTemplate: '<span data-action="showHours" data-time-component="hours" class="timepicker-hour"></span>',
        minuteTemplate: '<span data-action="showMinutes" data-time-component="minutes" class="timepicker-minute"></span>',
        secondTemplate: '<span data-action="showSeconds" data-time-component="seconds" class="timepicker-second"></span>'
    };
    TPGlobal.getTemplate = function (is12Hours, showSeconds, upIcon, downIcon) {
        return (
        '<div class="timepicker-picker">' +
          '<table class="table-condensed"' +
            (is12Hours ? ' data-hour-format="12"' : '') +
            '>' +
            '<tr>' +
              '<td><a href="#" class="btn" data-action="incrementHours"><span class="' + upIcon + '"></span></a></td>' +
              '<td class="separator"></td>' +
              '<td><a href="#" class="btn" data-action="incrementMinutes"><span class="' + upIcon + '"></span></a></td>' +
              (showSeconds ?
              '<td class="separator"></td>' +
              '<td><a href="#" class="btn" data-action="incrementSeconds"><span class="' + upIcon + '"></span></a></td>' : '') +
              (is12Hours ? '<td class="separator"></td>' : '') +
            '</tr>' +
            '<tr>' +
              '<td>' + TPGlobal.hourTemplate + '</td> ' +
              '<td class="separator">:</td>' +
              '<td>' + TPGlobal.minuteTemplate + '</td> ' +
              (showSeconds ?
              '<td class="separator">:</td>' +
              '<td>' + TPGlobal.secondTemplate + '</td>' : '') +
              (is12Hours ?
              '<td class="separator"></td>' +
              '<td>' +
              '<button type="button" class="btn btn-primary" data-action="togglePeriod"></button>' +
              '</td>' : '') +
            '</tr>' +
            '<tr>' +
              '<td><a href="#" class="btn" data-action="decrementHours"><span class="' + downIcon + '"></span></a></td>' +
              '<td class="separator"></td>' +
              '<td><a href="#" class="btn" data-action="decrementMinutes"><span class="' + downIcon + '"></span></a></td>' +
              (showSeconds ?
              '<td class="separator"></td>' +
              '<td><a href="#" class="btn" data-action="decrementSeconds"><span class="' + downIcon + '"></span></a></td>' : '') +
              (is12Hours ? '<td class="separator"></td>' : '') +
            '</tr>' +
          '</table>' +
        '</div>' +
        '<div class="timepicker-hours" data-action="selectHour">' +
          '<table class="table-condensed">' +
          '</table>' +
        '</div>' +
        '<div class="timepicker-minutes" data-action="selectMinute">' +
          '<table class="table-condensed">' +
          '</table>' +
        '</div>' +
        (showSeconds ?
        '<div class="timepicker-seconds" data-action="selectSecond">' +
          '<table class="table-condensed">' +
          '</table>' +
        '</div>' : '')
        );
    };
})(jQuery)



/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
  * bootstrap-switch - Turn checkboxes and radio buttons into toggle switches.
  *
  * @version v3.3.4
  * @homepage https://bttstrp.github.io/bootstrap-switch
  * @author Mattia Larentis <mattia@larentis.eu> (http://larentis.eu)
  * @license Apache-2.0
  */

(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(4)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(require('jquery'));
  } else {
    var mod = {
      exports: {}
    };
    factory(global.jquery);
    global.bootstrapSwitch = mod.exports;
  }
})(this, function (_jquery) {
  'use strict';

  var _jquery2 = _interopRequireDefault(_jquery);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var $ = _jquery2.default || window.jQuery || window.$;

  var BootstrapSwitch = function () {
    function BootstrapSwitch(element) {
      var _this = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, BootstrapSwitch);

      this.$element = $(element);
      this.options = $.extend({}, $.fn.bootstrapSwitch.defaults, this._getElementOptions(), options);
      this.prevOptions = {};
      this.$wrapper = $('<div>', {
        class: function _class() {
          var classes = [];
          classes.push(_this.options.state ? 'on' : 'off');
          if (_this.options.size) {
            classes.push(_this.options.size);
          }
          if (_this.options.disabled) {
            classes.push('disabled');
          }
          if (_this.options.readonly) {
            classes.push('readonly');
          }
          if (_this.options.indeterminate) {
            classes.push('indeterminate');
          }
          if (_this.options.inverse) {
            classes.push('inverse');
          }
          if (_this.$element.attr('id')) {
            classes.push('id-' + _this.$element.attr('id'));
          }
          return classes.map(_this._getClass.bind(_this)).concat([_this.options.baseClass], _this._getClasses(_this.options.wrapperClass)).join(' ');
        }
      });
      this.$container = $('<div>', { class: this._getClass('container') });
      this.$on = $('<span>', {
        html: this.options.onText,
        class: this._getClass('handle-on') + ' ' + this._getClass(this.options.onColor)
      });
      this.$off = $('<span>', {
        html: this.options.offText,
        class: this._getClass('handle-off') + ' ' + this._getClass(this.options.offColor)
      });
      this.$label = $('<span>', {
        html: this.options.labelText,
        class: this._getClass('label')
      });

      this.$element.on('init.bootstrapSwitch', this.options.onInit.bind(this, element));
      this.$element.on('switchChange.bootstrapSwitch', function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (_this.options.onSwitchChange.apply(element, args) === false) {
          if (_this.$element.is(':radio')) {
            $('[name="' + _this.$element.attr('name') + '"]').trigger('previousState.bootstrapSwitch', true);
          } else {
            _this.$element.trigger('previousState.bootstrapSwitch', true);
          }
        }
      });

      this.$container = this.$element.wrap(this.$container).parent();
      this.$wrapper = this.$container.wrap(this.$wrapper).parent();
      this.$element.before(this.options.inverse ? this.$off : this.$on).before(this.$label).before(this.options.inverse ? this.$on : this.$off);

      if (this.options.indeterminate) {
        this.$element.prop('indeterminate', true);
      }

      this._init();
      this._elementHandlers();
      this._handleHandlers();
      this._labelHandlers();
      this._formHandler();
      this._externalLabelHandler();
      this.$element.trigger('init.bootstrapSwitch', this.options.state);
    }

    _createClass(BootstrapSwitch, [{
      key: 'setPrevOptions',
      value: function setPrevOptions() {
        this.prevOptions = _extends({}, this.options);
      }
    }, {
      key: 'state',
      value: function state(value, skip) {
        if (typeof value === 'undefined') {
          return this.options.state;
        }
        if (this.options.disabled || this.options.readonly || this.options.state && !this.options.radioAllOff && this.$element.is(':radio')) {
          return this.$element;
        }
        if (this.$element.is(':radio')) {
          $('[name="' + this.$element.attr('name') + '"]').trigger('setPreviousOptions.bootstrapSwitch');
        } else {
          this.$element.trigger('setPreviousOptions.bootstrapSwitch');
        }
        if (this.options.indeterminate) {
          this.indeterminate(false);
        }
        this.$element.prop('checked', Boolean(value)).trigger('change.bootstrapSwitch', skip);
        return this.$element;
      }
    }, {
      key: 'toggleState',
      value: function toggleState(skip) {
        if (this.options.disabled || this.options.readonly) {
          return this.$element;
        }
        if (this.options.indeterminate) {
          this.indeterminate(false);
          return this.state(true);
        } else {
          return this.$element.prop('checked', !this.options.state).trigger('change.bootstrapSwitch', skip);
        }
      }
    }, {
      key: 'size',
      value: function size(value) {
        if (typeof value === 'undefined') {
          return this.options.size;
        }
        if (this.options.size != null) {
          this.$wrapper.removeClass(this._getClass(this.options.size));
        }
        if (value) {
          this.$wrapper.addClass(this._getClass(value));
        }
        this._width();
        this._containerPosition();
        this.options.size = value;
        return this.$element;
      }
    }, {
      key: 'animate',
      value: function animate(value) {
        if (typeof value === 'undefined') {
          return this.options.animate;
        }
        if (this.options.animate === Boolean(value)) {
          return this.$element;
        }
        return this.toggleAnimate();
      }
    }, {
      key: 'toggleAnimate',
      value: function toggleAnimate() {
        this.options.animate = !this.options.animate;
        this.$wrapper.toggleClass(this._getClass('animate'));
        return this.$element;
      }
    }, {
      key: 'disabled',
      value: function disabled(value) {
        if (typeof value === 'undefined') {
          return this.options.disabled;
        }
        if (this.options.disabled === Boolean(value)) {
          return this.$element;
        }
        return this.toggleDisabled();
      }
    }, {
      key: 'toggleDisabled',
      value: function toggleDisabled() {
        this.options.disabled = !this.options.disabled;
        this.$element.prop('disabled', this.options.disabled);
        this.$wrapper.toggleClass(this._getClass('disabled'));
        return this.$element;
      }
    }, {
      key: 'readonly',
      value: function readonly(value) {
        if (typeof value === 'undefined') {
          return this.options.readonly;
        }
        if (this.options.readonly === Boolean(value)) {
          return this.$element;
        }
        return this.toggleReadonly();
      }
    }, {
      key: 'toggleReadonly',
      value: function toggleReadonly() {
        this.options.readonly = !this.options.readonly;
        this.$element.prop('readonly', this.options.readonly);
        this.$wrapper.toggleClass(this._getClass('readonly'));
        return this.$element;
      }
    }, {
      key: 'indeterminate',
      value: function indeterminate(value) {
        if (typeof value === 'undefined') {
          return this.options.indeterminate;
        }
        if (this.options.indeterminate === Boolean(value)) {
          return this.$element;
        }
        return this.toggleIndeterminate();
      }
    }, {
      key: 'toggleIndeterminate',
      value: function toggleIndeterminate() {
        this.options.indeterminate = !this.options.indeterminate;
        this.$element.prop('indeterminate', this.options.indeterminate);
        this.$wrapper.toggleClass(this._getClass('indeterminate'));
        this._containerPosition();
        return this.$element;
      }
    }, {
      key: 'inverse',
      value: function inverse(value) {
        if (typeof value === 'undefined') {
          return this.options.inverse;
        }
        if (this.options.inverse === Boolean(value)) {
          return this.$element;
        }
        return this.toggleInverse();
      }
    }, {
      key: 'toggleInverse',
      value: function toggleInverse() {
        this.$wrapper.toggleClass(this._getClass('inverse'));
        var $on = this.$on.clone(true);
        var $off = this.$off.clone(true);
        this.$on.replaceWith($off);
        this.$off.replaceWith($on);
        this.$on = $off;
        this.$off = $on;
        this.options.inverse = !this.options.inverse;
        return this.$element;
      }
    }, {
      key: 'onColor',
      value: function onColor(value) {
        if (typeof value === 'undefined') {
          return this.options.onColor;
        }
        if (this.options.onColor) {
          this.$on.removeClass(this._getClass(this.options.onColor));
        }
        this.$on.addClass(this._getClass(value));
        this.options.onColor = value;
        return this.$element;
      }
    }, {
      key: 'offColor',
      value: function offColor(value) {
        if (typeof value === 'undefined') {
          return this.options.offColor;
        }
        if (this.options.offColor) {
          this.$off.removeClass(this._getClass(this.options.offColor));
        }
        this.$off.addClass(this._getClass(value));
        this.options.offColor = value;
        return this.$element;
      }
    }, {
      key: 'onText',
      value: function onText(value) {
        if (typeof value === 'undefined') {
          return this.options.onText;
        }
        this.$on.html(value);
        this._width();
        this._containerPosition();
        this.options.onText = value;
        return this.$element;
      }
    }, {
      key: 'offText',
      value: function offText(value) {
        if (typeof value === 'undefined') {
          return this.options.offText;
        }
        this.$off.html(value);
        this._width();
        this._containerPosition();
        this.options.offText = value;
        return this.$element;
      }
    }, {
      key: 'labelText',
      value: function labelText(value) {
        if (typeof value === 'undefined') {
          return this.options.labelText;
        }
        this.$label.html(value);
        this._width();
        this.options.labelText = value;
        return this.$element;
      }
    }, {
      key: 'handleWidth',
      value: function handleWidth(value) {
        if (typeof value === 'undefined') {
          return this.options.handleWidth;
        }
        this.options.handleWidth = value;
        this._width();
        this._containerPosition();
        return this.$element;
      }
    }, {
      key: 'labelWidth',
      value: function labelWidth(value) {
        if (typeof value === 'undefined') {
          return this.options.labelWidth;
        }
        this.options.labelWidth = value;
        this._width();
        this._containerPosition();
        return this.$element;
      }
    }, {
      key: 'baseClass',
      value: function baseClass(value) {
        return this.options.baseClass;
      }
    }, {
      key: 'wrapperClass',
      value: function wrapperClass(value) {
        if (typeof value === 'undefined') {
          return this.options.wrapperClass;
        }
        if (!value) {
          value = $.fn.bootstrapSwitch.defaults.wrapperClass;
        }
        this.$wrapper.removeClass(this._getClasses(this.options.wrapperClass).join(' '));
        this.$wrapper.addClass(this._getClasses(value).join(' '));
        this.options.wrapperClass = value;
        return this.$element;
      }
    }, {
      key: 'radioAllOff',
      value: function radioAllOff(value) {
        if (typeof value === 'undefined') {
          return this.options.radioAllOff;
        }
        var val = Boolean(value);
        if (this.options.radioAllOff === val) {
          return this.$element;
        }
        this.options.radioAllOff = val;
        return this.$element;
      }
    }, {
      key: 'onInit',
      value: function onInit(value) {
        if (typeof value === 'undefined') {
          return this.options.onInit;
        }
        if (!value) {
          value = $.fn.bootstrapSwitch.defaults.onInit;
        }
        this.options.onInit = value;
        return this.$element;
      }
    }, {
      key: 'onSwitchChange',
      value: function onSwitchChange(value) {
        if (typeof value === 'undefined') {
          return this.options.onSwitchChange;
        }
        if (!value) {
          value = $.fn.bootstrapSwitch.defaults.onSwitchChange;
        }
        this.options.onSwitchChange = value;
        return this.$element;
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        var $form = this.$element.closest('form');
        if ($form.length) {
          $form.off('reset.bootstrapSwitch').removeData('bootstrap-switch');
        }
        this.$container.children().not(this.$element).remove();
        this.$element.unwrap().unwrap().off('.bootstrapSwitch').removeData('bootstrap-switch');
        return this.$element;
      }
    }, {
      key: '_getElementOptions',
      value: function _getElementOptions() {
        return {
          state: this.$element.is(':checked'),
          size: this.$element.data('size'),
          animate: this.$element.data('animate'),
          disabled: this.$element.is(':disabled'),
          readonly: this.$element.is('[readonly]'),
          indeterminate: this.$element.data('indeterminate'),
          inverse: this.$element.data('inverse'),
          radioAllOff: this.$element.data('radio-all-off'),
          onColor: this.$element.data('on-color'),
          offColor: this.$element.data('off-color'),
          onText: this.$element.data('on-text'),
          offText: this.$element.data('off-text'),
          labelText: this.$element.data('label-text'),
          handleWidth: this.$element.data('handle-width'),
          labelWidth: this.$element.data('label-width'),
          baseClass: this.$element.data('base-class'),
          wrapperClass: this.$element.data('wrapper-class')
        };
      }
    }, {
      key: '_width',
      value: function _width() {
        var _this2 = this;

        var $handles = this.$on.add(this.$off).add(this.$label).css('width', '');
        var handleWidth = this.options.handleWidth === 'auto' ? Math.round(Math.max(this.$on.width(), this.$off.width())) : this.options.handleWidth;
        $handles.width(handleWidth);
        this.$label.width(function (index, width) {
          if (_this2.options.labelWidth !== 'auto') {
            return _this2.options.labelWidth;
          }
          if (width < handleWidth) {
            return handleWidth;
          }
          return width;
        });
        this._handleWidth = this.$on.outerWidth();
        this._labelWidth = this.$label.outerWidth();
        this.$container.width(this._handleWidth * 2 + this._labelWidth);
        return this.$wrapper.width(this._handleWidth + this._labelWidth);
      }
    }, {
      key: '_containerPosition',
      value: function _containerPosition() {
        var _this3 = this;

        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.state;
        var callback = arguments[1];

        this.$container.css('margin-left', function () {
          var values = [0, '-' + _this3._handleWidth + 'px'];
          if (_this3.options.indeterminate) {
            return '-' + _this3._handleWidth / 2 + 'px';
          }
          if (state) {
            if (_this3.options.inverse) {
              return values[1];
            } else {
              return values[0];
            }
          } else {
            if (_this3.options.inverse) {
              return values[0];
            } else {
              return values[1];
            }
          }
        });
      }
    }, {
      key: '_init',
      value: function _init() {
        var _this4 = this;

        var init = function init() {
          _this4.setPrevOptions();
          _this4._width();
          _this4._containerPosition();
          setTimeout(function () {
            if (_this4.options.animate) {
              return _this4.$wrapper.addClass(_this4._getClass('animate'));
            }
          }, 50);
        };
        if (this.$wrapper.is(':visible')) {
          init();
          return;
        }
        var initInterval = window.setInterval(function () {
          if (_this4.$wrapper.is(':visible')) {
            init();
            return window.clearInterval(initInterval);
          }
        }, 50);
      }
    }, {
      key: '_elementHandlers',
      value: function _elementHandlers() {
        var _this5 = this;

        return this.$element.on({
          'setPreviousOptions.bootstrapSwitch': this.setPrevOptions.bind(this),

          'previousState.bootstrapSwitch': function previousStateBootstrapSwitch() {
            _this5.options = _this5.prevOptions;
            if (_this5.options.indeterminate) {
              _this5.$wrapper.addClass(_this5._getClass('indeterminate'));
            }
            _this5.$element.prop('checked', _this5.options.state).trigger('change.bootstrapSwitch', true);
          },

          'change.bootstrapSwitch': function changeBootstrapSwitch(event, skip) {
            event.preventDefault();
            event.stopImmediatePropagation();
            var state = _this5.$element.is(':checked');
            _this5._containerPosition(state);
            if (state === _this5.options.state) {
              return;
            }
            _this5.options.state = state;
            _this5.$wrapper.toggleClass(_this5._getClass('off')).toggleClass(_this5._getClass('on'));
            if (!skip) {
              if (_this5.$element.is(':radio')) {
                $('[name="' + _this5.$element.attr('name') + '"]').not(_this5.$element).prop('checked', false).trigger('change.bootstrapSwitch', true);
              }
              _this5.$element.trigger('switchChange.bootstrapSwitch', [state]);
            }
          },

          'focus.bootstrapSwitch': function focusBootstrapSwitch(event) {
            event.preventDefault();
            _this5.$wrapper.addClass(_this5._getClass('focused'));
          },

          'blur.bootstrapSwitch': function blurBootstrapSwitch(event) {
            event.preventDefault();
            _this5.$wrapper.removeClass(_this5._getClass('focused'));
          },

          'keydown.bootstrapSwitch': function keydownBootstrapSwitch(event) {
            if (!event.which || _this5.options.disabled || _this5.options.readonly) {
              return;
            }
            if (event.which === 37 || event.which === 39) {
              event.preventDefault();
              event.stopImmediatePropagation();
              _this5.state(event.which === 39);
            }
          }
        });
      }
    }, {
      key: '_handleHandlers',
      value: function _handleHandlers() {
        var _this6 = this;

        this.$on.on('click.bootstrapSwitch', function (event) {
          event.preventDefault();
          event.stopPropagation();
          _this6.state(false);
          return _this6.$element.trigger('focus.bootstrapSwitch');
        });
        return this.$off.on('click.bootstrapSwitch', function (event) {
          event.preventDefault();
          event.stopPropagation();
          _this6.state(true);
          return _this6.$element.trigger('focus.bootstrapSwitch');
        });
      }
    }, {
      key: '_labelHandlers',
      value: function _labelHandlers() {
        var _this7 = this;

        var handlers = {
          click: function click(event) {
            event.stopPropagation();
          },


          'mousedown.bootstrapSwitch touchstart.bootstrapSwitch': function mousedownBootstrapSwitchTouchstartBootstrapSwitch(event) {
            if (_this7._dragStart || _this7.options.disabled || _this7.options.readonly) {
              return;
            }
            event.preventDefault();
            event.stopPropagation();
            _this7._dragStart = (event.pageX || event.originalEvent.touches[0].pageX) - parseInt(_this7.$container.css('margin-left'), 10);
            if (_this7.options.animate) {
              _this7.$wrapper.removeClass(_this7._getClass('animate'));
            }
            _this7.$element.trigger('focus.bootstrapSwitch');
          },

          'mousemove.bootstrapSwitch touchmove.bootstrapSwitch': function mousemoveBootstrapSwitchTouchmoveBootstrapSwitch(event) {
            if (_this7._dragStart == null) {
              return;
            }
            var difference = (event.pageX || event.originalEvent.touches[0].pageX) - _this7._dragStart;
            event.preventDefault();
            if (difference < -_this7._handleWidth || difference > 0) {
              return;
            }
            _this7._dragEnd = difference;
            _this7.$container.css('margin-left', _this7._dragEnd + 'px');
          },

          'mouseup.bootstrapSwitch touchend.bootstrapSwitch': function mouseupBootstrapSwitchTouchendBootstrapSwitch(event) {
            if (!_this7._dragStart) {
              return;
            }
            event.preventDefault();
            if (_this7.options.animate) {
              _this7.$wrapper.addClass(_this7._getClass('animate'));
            }
            if (_this7._dragEnd) {
              var state = _this7._dragEnd > -(_this7._handleWidth / 2);
              _this7._dragEnd = false;
              _this7.state(_this7.options.inverse ? !state : state);
            } else {
              _this7.state(!_this7.options.state);
            }
            _this7._dragStart = false;
          },

          'mouseleave.bootstrapSwitch': function mouseleaveBootstrapSwitch() {
            _this7.$label.trigger('mouseup.bootstrapSwitch');
          }
        };
        this.$label.on(handlers);
      }
    }, {
      key: '_externalLabelHandler',
      value: function _externalLabelHandler() {
        var _this8 = this;

        var $externalLabel = this.$element.closest('label');
        $externalLabel.on('click', function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (event.target === $externalLabel[0]) {
            _this8.toggleState();
          }
        });
      }
    }, {
      key: '_formHandler',
      value: function _formHandler() {
        var $form = this.$element.closest('form');
        if ($form.data('bootstrap-switch')) {
          return;
        }
        $form.on('reset.bootstrapSwitch', function () {
          window.setTimeout(function () {
            $form.find('input').filter(function () {
              return $(this).data('bootstrap-switch');
            }).each(function () {
              return $(this).bootstrapSwitch('state', this.checked);
            });
          }, 1);
        }).data('bootstrap-switch', true);
      }
    }, {
      key: '_getClass',
      value: function _getClass(name) {
        return this.options.baseClass + '-' + name;
      }
    }, {
      key: '_getClasses',
      value: function _getClasses(classes) {
        if (!$.isArray(classes)) {
          return [this._getClass(classes)];
        }
        return classes.map(this._getClass.bind(this));
      }
    }]);

    return BootstrapSwitch;
  }();

  $.fn.bootstrapSwitch = function (option) {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    function reducer(ret, next) {
      var $this = $(next);
      var existingData = $this.data('bootstrap-switch');
      var data = existingData || new BootstrapSwitch(next, option);
      if (!existingData) {
        $this.data('bootstrap-switch', data);
      }
      if (typeof option === 'string') {
        return data[option].apply(data, args);
      }
      return ret;
    }
    return Array.prototype.reduce.call(this, reducer, this);
  };
  $.fn.bootstrapSwitch.Constructor = BootstrapSwitch;
  $.fn.bootstrapSwitch.defaults = {
    state: true,
    size: null,
    animate: true,
    disabled: false,
    readonly: false,
    indeterminate: false,
    inverse: false,
    radioAllOff: false,
    onColor: 'primary',
    offColor: 'default',
    onText: 'ON',
    offText: 'OFF',
    labelText: '&nbsp',
    handleWidth: 'auto',
    labelWidth: 'auto',
    baseClass: 'bootstrap-switch',
    wrapperClass: 'wrapper',
    onInit: function onInit() {},
    onSwitchChange: function onSwitchChange() {}
  };
});


/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*** IMPORTS FROM imports-loader ***/
var backbone = __webpack_require__(7);

// Backbone.Stickit v0.8.0, MIT Licensed
// Copyright (c) 2012 The New York Times, CMS Group, Matthew DeLambo <delambo@gmail.com>

(function (factory) {

  // Set up Stickit appropriately for the environment. Start with AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(7), exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }

  // Next for Node.js or CommonJS.
  else if (typeof exports === 'object') {
    factory(require('underscore'), require('backbone'), exports);
  }

  // Finally, as a browser global.
  else {
    factory(_, Backbone, {});
  }

}(function (_, Backbone, Stickit) {

  // Stickit Namespace
  // --------------------------

  Stickit._handlers = [];

  Stickit.addHandler = function(handlers) {
    // Fill-in default values.
    handlers = _.map(_.flatten([handlers]), function(handler) {
      return _.extend({
        updateModel: true,
        updateView: true,
        updateMethod: 'text'
      }, handler);
    });
    this._handlers = this._handlers.concat(handlers);
  };

  // Backbone.View Mixins
  // --------------------

  Stickit.ViewMixin = {

    // Collection of model event bindings.
    //   [{model,event,fn,config}, ...]
    _modelBindings: null,

    // Unbind the model and event bindings from `this._modelBindings` and
    // `this.$el`. If the optional `model` parameter is defined, then only
    // delete bindings for the given `model` and its corresponding view events.
    unstickit: function(model, bindingSelector) {
      // Support bindings hash in place of selector.
      if (_.isObject(bindingSelector)) {
        _.each(_.keys(bindingSelector), function(selector) {
          this.unstickit(model, selector);
        }, this);
        return;
      }

      var models = [], destroyFns = [];
      _.each(this._modelBindings, function(binding, i) {
        if (model && binding.model !== model) { return; }
        if (bindingSelector && binding.config.selector != bindingSelector) return;
        destroyFns.push(binding.config._destroy);
        binding.model.off(binding.event, binding.fn);
        models.push(binding.model);
        delete this._modelBindings[i];
      }, this);

      // Trigger an event for each model that was unbound.
      _.invoke(_.uniq(models), 'trigger', 'stickit:unstuck', this.cid);
      // Call `_destroy` on a unique list of the binding callbacks.
      _.each(_.uniq(destroyFns), function(fn) { fn.call(this); }, this);
      // Cleanup the null values.
      this._modelBindings = _.compact(this._modelBindings);

      this.$el.off('.stickit' + (model ? '.' + model.cid : ''), bindingSelector);
    },

    // Using `this.bindings` configuration or the `optionalBindingsConfig`, binds `this.model`
    // or the `optionalModel` to elements in the view.
    stickit: function(optionalModel, optionalBindingsConfig) {
      var model = optionalModel || this.model,
          bindings = optionalBindingsConfig || _.result(this, "bindings") || {};

      this._modelBindings || (this._modelBindings = []);

      // Iterate through the selectors in the bindings configuration and configure
      // the various options for each field.
      this.addBinding(model, bindings);

      // Wrap `view.remove` to unbind stickit model and dom events.
      var remove = this.remove;
      if (!remove.stickitWrapped) {
        this.remove = function() {
          var ret = this;
          this.unstickit();
          if (remove) ret = remove.apply(this, arguments);
          return ret;
        };
      }
      this.remove.stickitWrapped = true;
    },

    // Add a single model binding to the view
    addBinding: function(optionalModel, second, _binding) {
      var $el, options, modelAttr, config, selector,
        model = optionalModel || this.model,
        namespace = '.stickit.' + model.cid,
        binding = _binding || {},
        bindId = _.uniqueId();

      // Allow jQuery-style {key: val} event maps
      if (_.isString(second)) {
        selector = second;
      } else {
        var bindings = second;
        _.each(bindings, function(v, selector) {
          this.addBinding(model, selector, bindings[selector]);
        }, this);
        return;
      }

      // Support ':el' selector - special case selector for the view managed delegate.
      $el = selector === ':el' ? this.$el : this.$(selector);

      this.unstickit(model, selector);

      // Fail fast if the selector didn't match an element.
      if (!$el.length) return;

      // Allow shorthand setting of model attributes - `'selector':'observe'`.
      if (_.isString(binding)) binding = {observe:binding};

      // Handle case where `observe` is in the form of a function.
      if (_.isFunction(binding.observe)) binding.observe = binding.observe.call(this);

      config = getConfiguration($el, binding);
      config.selector = selector;
      modelAttr = config.observe;

      // Create the model set options with a unique `bindId` so that we
      // can avoid double-binding in the `change:attribute` event handler.
      config.bindId = bindId;

      // Add a reference to the view for handlers of stickitChange events
      config.view = this;
      options = _.extend({stickitChange:config}, config.setOptions);

      // Add a `_destroy` callback to the configuration, in case `destroy`
      // is a named function and we need a unique function when unsticking.
      config._destroy = function() {
        applyViewFn(this, config.destroy, $el, model, config);
      };

      initializeAttributes(this, $el, config, model, modelAttr);

      initializeVisible(this, $el, config, model, modelAttr);

      if (modelAttr) {
        // Setup one-way, form element to model, bindings.
        _.each(config.events, function(type) {
          var event = type + namespace;
          var method = function(event) {
            var val = config.getVal.call(this, $el, event, config, _.rest(arguments));
            // Don't update the model if false is returned from the `updateModel` configuration.
            if (evaluateBoolean(this, config.updateModel, val, event, config))
              setAttr(model, modelAttr, val, options, this, config);
          };
          method = _.bind(method, this);
          if (selector === ':el') this.$el.on(event, method);
          else this.$el.on(event, selector, method);
        }, this);

        // Setup a `change:modelAttr` observer to keep the view element in sync.
        // `modelAttr` may be an array of attributes or a single string value.
        _.each(_.flatten([modelAttr]), function(attr) {
          observeModelEvent(model, this, 'change:'+attr, config, function(model, val, options) {
            var changeId = options && options.stickitChange && options.stickitChange.bindId || null;
            if (changeId !== bindId)
              updateViewBindEl(this, $el, config, getAttr(model, modelAttr, config, this), model);
          });
        }, this);

        updateViewBindEl(this, $el, config, getAttr(model, modelAttr, config, this), model, true);
      }

      // After each binding is setup, call the `initialize` callback.
      applyViewFn(this, config.initialize, $el, model, config);
    }
  };

  _.extend(Backbone.View.prototype, Stickit.ViewMixin);

  // Helpers
  // -------

  // Evaluates the given `path` (in object/dot-notation) relative to the given
  // `obj`. If the path is null/undefined, then the given `obj` is returned.
  var evaluatePath = function(obj, path) {
    var parts = (path || '').split('.');
    var result = _.reduce(parts, function(memo, i) { return memo[i]; }, obj);
    return result == null ? obj : result;
  };

  // If the given `fn` is a string, then view[fn] is called, otherwise it is
  // a function that should be executed.
  var applyViewFn = function(view, fn) {
    if (fn) return (_.isString(fn) ? evaluatePath(view,fn) : fn).apply(view, _.rest(arguments, 2));
  };

  var getSelectedOption = function($select) { return $select.find('option').not(function(){ return !this.selected; }); };

  // Given a function, string (view function reference), or a boolean
  // value, returns the truthy result. Any other types evaluate as false.
  var evaluateBoolean = function(view, reference) {
    if (_.isBoolean(reference)) return reference;
    else if (_.isFunction(reference) || _.isString(reference))
      return applyViewFn.apply(this, arguments);
    return false;
  };

  // Setup a model event binding with the given function, and track the event
  // in the view's _modelBindings.
  var observeModelEvent = function(model, view, event, config, fn) {
    model.on(event, fn, view);
    view._modelBindings.push({model:model, event:event, fn:fn, config:config});
  };

  // Prepares the given `val`ue and sets it into the `model`.
  var setAttr = function(model, attr, val, options, context, config) {
    var value = {};
    if (config.onSet)
      val = applyViewFn(context, config.onSet, val, config);

    if (config.set)
      applyViewFn(context, config.set, attr, val, options, config);
    else {
      value[attr] = val;
      // If `observe` is defined as an array and `onSet` returned
      // an array, then map attributes to their values.
      if (_.isArray(attr) && _.isArray(val)) {
        value = _.reduce(attr, function(memo, attribute, index) {
          memo[attribute] = _.has(val, index) ? val[index] : null;
          return memo;
        }, {});
      }
      model.set(value, options);
    }
  };

  // Returns the given `attr`'s value from the `model`, escaping and
  // formatting if necessary. If `attr` is an array, then an array of
  // respective values will be returned.
  var getAttr = function(model, attr, config, context) {
    var val,
      retrieveVal = function(field) {
        return model[config.escape ? 'escape' : 'get'](field);
      },
      sanitizeVal = function(val) {
        return val == null ? '' : val;
      };
    val = _.isArray(attr) ? _.map(attr, retrieveVal) : retrieveVal(attr);
    if (config.onGet) val = applyViewFn(context, config.onGet, val, config);
    return _.isArray(val) ? _.map(val, sanitizeVal) : sanitizeVal(val);
  };

  // Find handlers in `Backbone.Stickit._handlers` with selectors that match
  // `$el` and generate a configuration by mixing them in the order that they
  // were found with the given `binding`.
  var getConfiguration = Stickit.getConfiguration = function($el, binding) {
    var handlers = [{
      updateModel: false,
      updateMethod: 'text',
      update: function($el, val, m, opts) { if ($el[opts.updateMethod]) $el[opts.updateMethod](val); },
      getVal: function($el, e, opts) { return $el[opts.updateMethod](); }
    }];
    handlers = handlers.concat(_.filter(Stickit._handlers, function(handler) {
      return $el.is(handler.selector);
    }));
    handlers.push(binding);
    var config = _.extend.apply(_, handlers);
    // `updateView` is defaulted to false for configutrations with
    // `visible`; otherwise, `updateView` is defaulted to true.
    if (config.visible && !_.has(config, 'updateView')) config.updateView = false;
    else if (!_.has(config, 'updateView')) config.updateView = true;
    return config;
  };

  // Setup the attributes configuration - a list that maps an attribute or
  // property `name`, to an `observe`d model attribute, using an optional
  // `onGet` formatter.
  //
  //     attributes: [{
  //       name: 'attributeOrPropertyName',
  //       observe: 'modelAttrName'
  //       onGet: function(modelAttrVal, modelAttrName) { ... }
  //     }, ...]
  //
  var initializeAttributes = function(view, $el, config, model, modelAttr) {
    var props = ['autofocus', 'autoplay', 'async', 'checked', 'controls', 'defer', 'disabled', 'hidden', 'indeterminate', 'loop', 'multiple', 'open', 'readonly', 'required', 'scoped', 'selected'];

    _.each(config.attributes || [], function(attrConfig) {
      var lastClass = '', observed, updateAttr;
      attrConfig = _.clone(attrConfig);
      observed = attrConfig.observe || (attrConfig.observe = modelAttr),
      updateAttr = function() {
        var updateType = _.indexOf(props, attrConfig.name, true) > -1 ? 'prop' : 'attr',
          val = getAttr(model, observed, attrConfig, view);
        // If it is a class then we need to remove the last value and add the new.
        if (attrConfig.name === 'class') {
          $el.removeClass(lastClass).addClass(val);
          lastClass = val;
        }
        else $el[updateType](attrConfig.name, val);
      };
      _.each(_.flatten([observed]), function(attr) {
        observeModelEvent(model, view, 'change:' + attr, config, updateAttr);
      });
      updateAttr();
    });
  };

  // If `visible` is configured, then the view element will be shown/hidden
  // based on the truthiness of the modelattr's value or the result of the
  // given callback. If a `visibleFn` is also supplied, then that callback
  // will be executed to manually handle showing/hiding the view element.
  //
  //     observe: 'isRight',
  //     visible: true, // or function(val, options) {}
  //     visibleFn: function($el, isVisible, options) {} // optional handler
  //
  var initializeVisible = function(view, $el, config, model, modelAttr) {
    if (config.visible == null) return;
    var visibleCb = function() {
      var visible = config.visible,
          visibleFn = config.visibleFn,
          val = getAttr(model, modelAttr, config, view),
          isVisible = !!val;
      // If `visible` is a function then it should return a boolean result to show/hide.
      if (_.isFunction(visible) || _.isString(visible)) isVisible = !!applyViewFn(view, visible, val, config);
      // Either use the custom `visibleFn`, if provided, or execute the standard show/hide.
      if (visibleFn) applyViewFn(view, visibleFn, $el, isVisible, config);
      else {
        $el.toggle(isVisible);
      }
    };
    _.each(_.flatten([modelAttr]), function(attr) {
      observeModelEvent(model, view, 'change:' + attr, config, visibleCb);
    });
    visibleCb();
  };

  // Update the value of `$el` using the given configuration and trigger the
  // `afterUpdate` callback. This action may be blocked by `config.updateView`.
  //
  //     update: function($el, val, model, options) {},  // handler for updating
  //     updateView: true, // defaults to true
  //     afterUpdate: function($el, val, options) {} // optional callback
  //
  var updateViewBindEl = function(view, $el, config, val, model, isInitializing) {
    if (!evaluateBoolean(view, config.updateView, val, config)) return;
    applyViewFn(view, config.update, $el, val, model, config);
    if (!isInitializing) applyViewFn(view, config.afterUpdate, $el, val, config);
  };

  // Default Handlers
  // ----------------

  Stickit.addHandler([{
    selector: '[contenteditable="true"]',
    updateMethod: 'html',
    events: ['input', 'change']
  }, {
    selector: 'input',
    events: ['propertychange', 'input', 'change'],
    update: function($el, val) { $el.val(val); },
    getVal: function($el) {
      return $el.val();
    }
  }, {
    selector: 'textarea',
    events: ['propertychange', 'input', 'change'],
    update: function($el, val) { $el.val(val); },
    getVal: function($el) { return $el.val(); }
  }, {
    selector: 'input[type="radio"]',
    events: ['change'],
    update: function($el, val) {
      $el.filter('[value="'+val+'"]').prop('checked', true);
    },
    getVal: function($el) {
      return $el.filter(':checked').val();
    }
  }, {
    selector: 'input[type="checkbox"]',
    events: ['change'],
    update: function($el, val, model, options) {
      if ($el.length > 1) {
        // There are multiple checkboxes so we need to go through them and check
        // any that have value attributes that match what's in the array of `val`s.
        val || (val = []);
        $el.each(function(i, el) {
          var checkbox = Backbone.$(el);
          var checked = _.contains(val, checkbox.val());
          checkbox.prop('checked', checked);
        });
      } else {
        var checked = _.isBoolean(val) ? val : val === $el.val();
        $el.prop('checked', checked);
      }
    },
    getVal: function($el) {
      var val;
      if ($el.length > 1) {
        val = _.reduce($el, function(memo, el) {
          var checkbox = Backbone.$(el);
          if (checkbox.prop('checked')) memo.push(checkbox.val());
          return memo;
        }, []);
      } else {
        val = $el.prop('checked');
        // If the checkbox has a value attribute defined, then
        // use that value. Most browsers use "on" as a default.
        var boxval = $el.val();
        if (boxval !== 'on' && boxval != null) {
          val = val ? $el.val() : null;
        }
      }
      return val;
    }
  }, {
    selector: 'select',
    events: ['change'],
    update: function($el, val, model, options) {
      var optList,
        selectConfig = options.selectOptions,
        list = selectConfig && selectConfig.collection || undefined,
        isMultiple = $el.prop('multiple');

      // If there are no `selectOptions` then we assume that the `<select>`
      // is pre-rendered and that we need to generate the collection.
      if (!selectConfig) {
        selectConfig = {};
        var getList = function($el) {
          return $el.map(function() {
            return {value:this.value, label:this.text};
          }).get();
        };
        if ($el.find('optgroup').length) {
          list = {opt_labels:[]};
          // Search for options without optgroup
          if ($el.find('> option').length) {
            list.opt_labels.push(undefined);
            _.each($el.find('> option'), function(el) {
              list[undefined] = getList(Backbone.$(el));
            });
          }
          _.each($el.find('optgroup'), function(el) {
            var label = Backbone.$(el).attr('label');
            list.opt_labels.push(label);
            list[label] = getList(Backbone.$(el).find('option'));
          });
        } else {
          list = getList($el.find('option'));
        }
      }

      // Fill in default label and path values.
      selectConfig.valuePath = selectConfig.valuePath || 'value';
      selectConfig.labelPath = selectConfig.labelPath || 'label';

      var addSelectOptions = function(optList, $el, fieldVal) {
        _.each(optList, function(obj) {
          var option = Backbone.$('<option/>'), optionVal = obj;

          var fillOption = function(text, val) {
            option.text(text);
            optionVal = val;
            // Save the option value as data so that we can reference it later.
            option.data('stickit_bind_val', optionVal);
            if (!_.isArray(optionVal) && !_.isObject(optionVal)) option.val(optionVal);
          };

          if (obj === '__default__')
            fillOption(selectConfig.defaultOption.label, selectConfig.defaultOption.value);
          else
            fillOption(evaluatePath(obj, selectConfig.labelPath), evaluatePath(obj, selectConfig.valuePath));

          // Determine if this option is selected.
          if (!isMultiple && optionVal != null && fieldVal != null && optionVal === fieldVal || (_.isObject(fieldVal) && _.isEqual(optionVal, fieldVal)))
            option.prop('selected', true);
          else if (isMultiple && _.isArray(fieldVal)) {
            _.each(fieldVal, function(val) {
              if (_.isObject(val)) val = evaluatePath(val, selectConfig.valuePath);
              if (val === optionVal || (_.isObject(val) && _.isEqual(optionVal, val)))
                option.prop('selected', true);
            });
          }

          $el.append(option);
        });
      };

      $el.find('*').remove();

      // The `list` configuration is a function that returns the options list or a string
      // which represents the path to the list relative to `window` or the view/`this`.
      var evaluate = function(view, list) {
        var context = window;
        if (list.indexOf('this.') === 0) context = view;
        list = list.replace(/^[a-z]*\.(.+)$/, '$1');
        return evaluatePath(context, list);
      };
      if (_.isString(list)) optList = evaluate(this, list);
      else if (_.isFunction(list)) optList = applyViewFn(this, list, $el, options);
      else optList = list;

      // Support Backbone.Collection and deserialize.
      if (optList instanceof Backbone.Collection) optList = optList.toJSON();

      if (selectConfig.defaultOption) {
        addSelectOptions(["__default__"], $el);
      }

      if (_.isArray(optList)) {
        addSelectOptions(optList, $el, val);
      } else if (optList.opt_labels) {
        // To define a select with optgroups, format selectOptions.collection as an object
        // with an 'opt_labels' property, as in the following:
        //
        //     {
        //       'opt_labels': ['Looney Tunes', 'Three Stooges'],
        //       'Looney Tunes': [{id: 1, name: 'Bugs Bunny'}, {id: 2, name: 'Donald Duck'}],
        //       'Three Stooges': [{id: 3, name : 'moe'}, {id: 4, name : 'larry'}, {id: 5, name : 'curly'}]
        //     }
        //
        _.each(optList.opt_labels, function(label) {
          var $group = Backbone.$('<optgroup/>').attr('label', label);
          addSelectOptions(optList[label], $group, val);
          $el.append($group);
        });
        // With no 'opt_labels' parameter, the object is assumed to be a simple value-label map.
        // Pass a selectOptions.comparator to override the default order of alphabetical by label.
      } else {
        var opts = [], opt;
        for (var i in optList) {
          opt = {};
          opt[selectConfig.valuePath] = i;
          opt[selectConfig.labelPath] = optList[i];
          opts.push(opt);
        }
        addSelectOptions(_.sortBy(opts, selectConfig.comparator || selectConfig.labelPath), $el, val);
      }
    },
    getVal: function($el) {
      var val;
      if ($el.prop('multiple')) {
        val = Backbone.$(getSelectedOption($el).map(function() {
          return Backbone.$(this).data('stickit_bind_val');
        })).get();
      } else {
        val = getSelectedOption($el).data('stickit_bind_val');
      }
      return val;
    }
  }]);


  // Export onto Backbone object
  Backbone.Stickit = Stickit;

  return Backbone.Stickit;

}));



/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var LoggedIn = __webpack_require__(31),
        Permissions = __webpack_require__(22),
        CompanyState = __webpack_require__(242),
        ConfirmationManager = __webpack_require__(339),
        Cookie = __webpack_require__(406),
        ErrorHandler = __webpack_require__(119),
        NotificationBar = __webpack_require__(53);

    var TAG = "restricted_";

    var timer = null;

    /**
     * @private
     * Return the notification options for notifications about principal restrictions.
     *
     * @param  {String}            tag The notification tag to postfix TAG; never null.
     * @param  {Number} closeDelay the delay introduced before closing the notification bar
     * @return {*} The notification options for notifications about user restrictions; never null.
     */
    function options(tag, closeDelay) {
        return {
            tag: TAG + tag,
            queue: false,
            closeDelay: closeDelay || null,
            flash: { duplicate: false }
        };
    }

    /**
     * @private
     * Closes a specific or all notifications regarding login restrictions...
     *
     * @param  {String} [tag] The specific notification tag to postfix TAG, if any; if falsey, all notifications
     *                        prefixed with TAG will be closed.
     */
    function close(tag) {
        NotificationBar.close({ tag: TAG + (tag || ":") });
    }

    /**
     * @private
     * Notify the user about company restrictions, such as login restricted (AD login only) or about content
     * restrictions. <p>
     *
     * This function will not prevent <tt>principal</tt> from logging in (will already be prevented, if so).
     *
     * @param  {Principal} principal The principal to check and notify for company restrictions; never null.
     * @return {Boolean} True if not notified, false otherwise.
     */
    function handleCompanyRestrictions(principal) {
        var state = principal.get("state"),
            updated = principal.get("updated");

        if (state === CompanyState.LOGIN_RESTRICTED || state === CompanyState.SUSPENDED) {
            // From login page, or via AD login...
            NotificationBar.error("You cannot currently sign in because your company account appears to be suspended. Please reach out to your Account Manager to regain access.", options("login"));
            return false;

            // Only relevant for non-Spectator users backed by the logged in principal...
        } else if (state === CompanyState.CONTENT_RESTRICTED && Permissions.Roles.SPECTATOR.not(principal.get("user"))) {
            // user role!
            var action = [ErrorHandler.Actions.COMMUNITY, ErrorHandler.Actions.SUPPORT]; //  "community support";
            // Only show this one time, not on updated principal because of relogin...
            if (updated === null) {
                action.push(ErrorHandler.Actions.RELOGIN);
            }

            NotificationBar.open({ message: "You are currently in Spectator mode because your company account appears to be suspended. Please reach out to your Account Manager to regain access.", action: action.join(" ") }, options("content"));
            return false;

            // If (now) active, close all restrictions. This is fine to do here, since we have not checked for read only
            // tokens yet, i.e. may be notified again...
        } else if (state === CompanyState.ACTIVE) {
            close();
        }

        // Notify the user on role and/or status change, e.g. via re-login...
        if (updated !== null) {
            var msg = "Your active access level ";

            msg += updated ? "is now " + principal.get("role") : "has not changed";
            msg += ".";

            NotificationBar.open(msg, options("relogin", 7500));

            return false;
        }

        return true;
    }

    /**
     * @private
     * Notify the principal that the token is currently read only since old token, so a soft re-login will be
     * possible. However, we only bother doing this in case the *user* is not a Spectator, i.e. then no difference
     * between Normal and ReadOnly tokens. <p>
     *
     * This function will not prevent <tt>principal</tt> from logging in!
     *
     * @param  {Principal} principal The principal to check and notify for read only token; never null.
     * @return {Boolean} True if not notified, false otherwise.
     */
    function handleReadOnly(principal) {
        // Ignore this message if the user is not confirmed, since that is handled by the ConfirmationManager: as long
        // as unconfirmed, we do not care what type of token, as the user cannot do anything (but Spectator stuff)
        // until confirmed...
        var user = principal.get("user"),
            role = user.get("role"); // granted - but perhaps not applicable - user role!

        if (principal.get("type") === "ReadOnly" && user.get("confirmedAt") && Permissions.Roles.SPECTATOR.not(role) && !Cookie.get("lockout:" + user.get("username"))) {
            NotificationBar.open("You are currently in Spectator mode, and you need to sign in again to use your " + role.name + " role.&nbsp;&nbsp;&nbsp;<a href='#login'>Sign In Again</a>&nbsp;&nbsp;&nbsp;<a href='#user/forgotpassword'>Forgot password?</a>", options("read_only"));
            return false;
        }

        close("read_only");

        return true;
    }

    /**
     * @private
     * Silently sends a confirmation email to the principal if the associated user has not had one sent yet.
     *
     * @param  {Principal} principal The principal to send a confirmation email if applicable; never null.
     * @return {Boolean} True if no email sent, false otherwise.
     */
    function handleUnconfirmed(principal) {
        // Silently request confirm email from server if needed...
        var user = principal.get("user"); // testing of a user is akin to asking principal.canLogin()

        // Do not send a confirmation info request if this is an AD login
        if (principal.get("type") === "AD") {
            return true;
        }

        if (user && !user.get("lastConfirmationEmailSent") && ConfirmationManager.confirmationRequired(user)) {
            ConfirmationManager.requestConfirmationInfo(false); // false = silent

            return false;
        }

        return true;
    }

    // Make sure we are notified on changes when the principal changes...
    LoggedIn.on("change:login error:login_restricted", function (principal) {
        if (principal) {
            // Make sure we send a confirmation email to the associated user, if none has been set yet...
            handleUnconfirmed(principal);
            // Make sure the principal (user) is notified about any company restrictions. If applicable here, since we
            // have a token, we know we can login, so it must be the published content that is restricted. If we notify
            // the user about company restrictions, do not bother notify her about a potential read only token...
            if (handleCompanyRestrictions(principal)) {
                // Make sure the principal (user) gets an option to login again softly on old read-only tokens by a nice
                // login presented via a notification message. In addition, the settings menu will also reflect this, so
                // even if the notification is closed, the user still has an easy option to sign in again to upgrade to
                // a normal token...
                handleReadOnly(principal);
            }
        } else {
            close();
        }
    });

    // Make sure we are notified on changes on too many attempts to log in, either first time, or on re-login when
    // trying to upgrade a principal read only token to a normal one...
    LoggedIn.on("login:tooManyAttempts", function (principal, lockout) {
        // lockout in seconds!
        if (principal && principal.get("type") === "ReadOnly") {
            close("read_only");

            if (timer) {
                clearTimeout(timer);
            }

            timer = setTimeout(function () {
                timer = null;
                // Must be same principal logged in for this to make sense...
                if (LoggedIn.principal() === principal) {
                    handleReadOnly(principal);
                }
            }, lockout * 1000);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var Backbone = __webpack_require__(7);
    var Browser = __webpack_require__(39);
    var channelBridge = __webpack_require__(241);
    var CSSHistoryManager = __webpack_require__(2781);
    var EditorRouter = __webpack_require__(2782);
    var EditorStatsDAnalytics = __webpack_require__(3150);
    var ErrorAction = __webpack_require__(560);
    var EditorErrorLogger = __webpack_require__(3152);
    var ErrorHandler = __webpack_require__(119);
    var FontLoader = __webpack_require__(260);
    var Injector = __webpack_require__(353);
    var LoggedIn = __webpack_require__(31);
    var Marionette = __webpack_require__(10);
    var NotificationBar = __webpack_require__(53);
    var Preconditions = __webpack_require__(14);
    var ProjectSelector = __webpack_require__(1247);
    var RestApi = __webpack_require__(29);
    var TipManager = __webpack_require__(3186);
    var ViewScope = __webpack_require__(171);
    var Window = __webpack_require__(48);
    var WidgetTypes = __webpack_require__(69);

    // Require less file used by this application.
    __webpack_require__(3190);

    /**
     * The editor application.
     *
     * @class EditorApplication
     */
    var EditorApplication = Marionette.Application.extend({

        /**
         * Start the application.
         *
         * Loads the default font kit from Typekit before proceeding.
         *
         * @param  {Object} config The raw configuration object.
         */
        start: function start(config) {
            var _this = this;

            FontLoader.typekit("eka2gcy").always(function () {
                Marionette.Application.prototype.start.call(_this, config);
            });
        }
    });

    var app = new EditorApplication(),
        statsDName = "statsD";

    app.addRegions({
        navBarRegion: ".navigation-bar",
        projectsRegion: ".projects-panel",
        mainRegion: ".main"
    });

    app.addInitializer(function (_ref) {
        var statsDBucket = _ref.statsDBucket;

        Injector.register(statsDName, new EditorStatsDAnalytics(statsDBucket));
    });

    /**
    * Circumvent circular dependency issues in require.js
    * required in composite widgets by allowing injection of the necessary classes.
    */
    app.addInitializer(function () {
        Injector.register("WidgetTypes", WidgetTypes);
    });

    /**
     * Setup error logger and handler as the first thing.
     */
    app.addInitializer(function (config) {
        // Ensure the error handler to report via the NotificationBar...
        ErrorHandler.notify = {
            show: function show(error, options) {
                return NotificationBar.error(error, options);
            },

            discard: function discard(options) {
                if (typeof options === "string") {
                    options = { id: options, clear: "self" };
                }

                NotificationBar.close(options);
            }
        };
        // Create the error logger. We will associate our statsD instance once it is initialised later on...
        var errorLogger = new EditorErrorLogger(config);
        // Determine if it should be enabled
        errorLogger.enabled = config.trackErrors;

        // Hook in statsD to relevant error classes...
        var statsD = Injector.get(statsDName);
        errorLogger.statsD(statsD);
        ErrorAction.statsD(statsD);

        // Pass the logger to the Preconditions instance
        Preconditions.setErrorLogger(errorLogger);
        Injector.register("errorLogger", errorLogger);
    });

    /**
     * Initialize the database layer.
     */
    app.addInitializer(function (config) {
        RestApi.init(config.adminApiBaseUrl, config.proxyUrl);
    });

    app.addInitializer(function () {
        app.tipManager = new TipManager();
    });

    app.addInitializer(function () {
        // Disable the spell check for IE, see bug report MOS-2185
        if (Browser.type.ie) {
            Browser.disableNativeSpellChecker();
        }
    });

    app.addInitializer(function () {
        Injector.register("mainRegion", app.mainRegion);
        Injector.register("navBarRegion", app.navBarRegion);
        Injector.register("history", Backbone.history);

        // Set up re-render on regions in case the logged in principal changes the active role or state, to ensure
        // that all UI elements testing on privileges will reflect the update. We do not bother to test for logout,
        // i.e. no principal, since that is already handled (and displaying the sign in page again)...
        LoggedIn.on("change:login", function (principal) {
            var updated = principal && principal.get("updated");

            if (updated) {
                // Main View is not ready when coming from confirm link, but gets instantiated anyway by the Application,
                // thus we will show it here only if current view is available.
                if (app.mainRegion.currentView) {
                    app.mainRegion.show(app.mainRegion.currentView);
                }

                app.navBarRegion.show(app.navBarRegion.currentView);
            }
        });
        // Re-render top nav bar if the backing user changes...
        LoggedIn.on("change:user", function () {
            app.navBarRegion.show(app.navBarRegion.currentView);
        });
    });

    /**
     * Start the router, which will cause the initial page to load.
     */
    app.addInitializer(function () {
        new EditorRouter().start();

        Backbone.history.start();

        var manager = new CSSHistoryManager(); // Google canary does not like new Foo().something() - seems like an anonymous instance is sometimes troublesome (optimised away?)... :/
        manager.start();
    });

    /**
     * Set up editor analytics.
     */
    app.addInitializer(function () {
        var statsD = Injector.get(statsDName);

        statsD.trackPageView();
        statsD.trackInitTime(Date.now() - window.startTime); // TODO: bad global state, move under "__zmags" or something
    });

    /**
     * Ensure the channel bridge is *not* available in the editor for viewer preview for embedded
     * Experiences and Groups (to avoid loading channels.js in the Editor); the publishable embed
     * widget will simply use the direct url when in preview mode.
     */
    app.addInitializer(function () {
        var init = channelBridge();

        // Disable channel bridge for good while in the editor!
        init(); // no Controller!
    });

    app.addInitializer(function () {
        // As Projects have been deprecated for C3 experiences, we need to disable this logic.
        if (!(0, _C3Utils.isC3Experience)()) ProjectSelector.start(app.projectsRegion);
    });

    /**
     * Setup top level view scope.
     */
    app.addInitializer(function (config) {
        ViewScope.setTopLevelViewScope({

            showNotification: function showNotification(content, options) {
                NotificationBar.open(content, options);
            },

            hideNotification: function hideNotification(force) {
                NotificationBar.close(force);
            },

            toggleProjectSelector: function toggleProjectSelector(toggle) {
                ProjectSelector.toggleProjectSelector(toggle);
            }

        });

        // Have to set statsD this awkward way because the NotificationBar is a singleton already constructed on load...
        var statsD = Injector.get(statsDName);
        NotificationBar.options.statsD = statsD;

        // Notify the user if the browser is not supported...
        if (!Browser.capabilities.isSupported) {
            var options = {
                tag: "unsupported_browser",
                closeable: true,
                ignoreDuplicates: true,
                flash: { duplicate: false },
                events: {
                    "click #browsersupport": function clickBrowsersupport(event) {
                        // Go to the community when logged in to avoid breaking the normal work flow...
                        if (LoggedIn.principal()) {
                            event.preventDefault();
                            Window.open(config.communityBaseUrl + "/hc/en-us/articles/200588918", "zmags_creator_community");
                        }

                        statsD.track("notificationbar.click.browsersupport");
                    }
                }
            };
            // Tag this as an error merely to get the desired styling...
            NotificationBar.error("You are using an unsupported browser - performance and correctness may suffer!&nbsp;&nbsp;&nbsp;" + "See <a id='browsersupport' href='#browsersupport'>Browser Support</a> for further information.", options);
        }
    });

    return app;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var EventDispatcher = __webpack_require__(54);

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank;

    var LoggedIn = __webpack_require__(31);
    var LoggedInUserState = __webpack_require__(19);

    var REPLACE_REG_EXP = new RegExp("/", "g");
    var DEFAULT_CLASS_NAMES = "dashboard";
    var LOGGED_IN = " logged-in";
    var LOGGED_OUT = " logged-out";

    /**
     * Contains logic for adding the current route name as a CSS class name to the
     * &#60;html&#62; root element, replacing "/" with a whitespace.
     *
     * @class CSSHistoryManager
     */
    return EventDispatcher.extend({

        _history: null,

        _classNames: DEFAULT_CLASS_NAMES,

        _htmlRootElement: null,

        /**
         * Constructor.
         *
         * @constructor
         * @param {Backbone.history} history The Backbone history instance.
         */
        constructor: function constructor(history) {
            this._history = history;
            this._htmlRootElement = $("html");
        },


        /**
         * Invoked when the route changes.
         */
        _routeChangedHandler: function CSSHistoryManagerStartRouteChangedHandler() {
            this._updateToHistoryState();
        },

        /**
         * Updates the CSS class name of the &#60;html&#62; root element.
         */
        _updateToHistoryState: function CSSHistoryManagerUpdateToHistoryState() {
            this._htmlRootElement.removeClass(this._classNames);
            this._classNames = this._history.fragment.replace(REPLACE_REG_EXP, " ");

            // Special handing when we're at the dashboard (no route name)
            if (isBlank(this._classNames)) {
                this._classNames = DEFAULT_CLASS_NAMES;
            }

            this._classNames += LoggedIn.principal() ? LOGGED_IN : LOGGED_OUT;

            this._htmlRootElement.addClass(this._classNames);
        },

        /**
         * Starts listening for route changes.
         */
        start: function CSSHistoryManagerStart() {
            this.listenTo(this._history, "route", this._routeChangedHandler);
            this.listenTo(LoggedInUserState, "change:ready", this._routeChangedHandler);

            this._updateToHistoryState();
        }

    }, {
        injection: ["history"]
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        contains = _require.contains,
        extend = _require.extend;

    var AnalyticsController = __webpack_require__(2783);
    var AuthenticationController = __webpack_require__(2786);
    var Backbone = __webpack_require__(7);
    var BreakpointController = __webpack_require__(2830);
    var ConfirmationManager = __webpack_require__(339);
    var DashboardConfiguration = __webpack_require__(1190);
    var DashboardController = __webpack_require__(1215);
    var EditorController = __webpack_require__(2902);
    var EditorPreviewController = __webpack_require__(3034);
    var ExperienceURLProvider = __webpack_require__(168);
    var ExportController = __webpack_require__(3043);
    var FilteringRouter = __webpack_require__(3048);
    var IntegrationsController = __webpack_require__(3049);
    var LoggedIn = __webpack_require__(31);
    var NavBarView = __webpack_require__(461);
    var NotificationBar = __webpack_require__(53);
    var ProjectDashboardConfiguration = __webpack_require__(720);
    var ProjectDashboardController = __webpack_require__(3089);
    var ManageAccountController = __webpack_require__(3104);
    var PSDImportController = __webpack_require__(3115);
    var ManageFontsController = __webpack_require__(3119);
    var LoggedInUserState = __webpack_require__(19);

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var PublishController = __webpack_require__(3133);
    var Share = __webpack_require__(1224);
    var StringUtils = __webpack_require__(30);
    var Window = __webpack_require__(48);
    var ZendeskErrorView = __webpack_require__(3147);
    var ZendeskUtil = __webpack_require__(3149);
    var Configuration = __webpack_require__(27);
    var Storage = __webpack_require__(34);

    var AUTH0_DOMAIN = Configuration.auth0Domain;
    var AUTH0_CLIENT_ID = Configuration.auth0ClientId;
    var CONTENT_CONTROL_URL = Configuration.contentControlUrl;

    var logger = new Logger("EditorRouter");

    /**
     * Get a (default) prompt message to alert to user on before navigate, if any.
     *
     * @param {Boolean|String} prompt    The message to prompt the user for if a string, or a true value for the
     *                                   string "You are leaving a page with unsaved changes.". An empty string or
     *                                   a falsey value will return undefined.
     * @param {String}         [postfix] Optional postfix string to append to (the default) <tt>prompt</tt>, if not
     *                                   already.
     * @return {String|undefined} The message to prompt to the user; or undefined. Note that if the prompt is used as part of
     *                  <tt>Window.unload(..)</tt>, it will be alerted in a special user prompt managed by the
     *                  browser (nothing to do about this).
     */
    function getPrompt(prompt, postfix) {
        if (prompt) {
            if (typeof prompt !== "string") {
                prompt = "You are leaving a page with unsaved changes.";
            }

            if (postfix && prompt.indexOf(postfix) !== 0) {
                prompt += "\n\n" + postfix;
            }

            return prompt;
        }

        return undefined;
    }

    /**
     * Top-level router for the Creator Editor app.
     *
     * @author Bo Gotthardt
     * @class EditorRouter
     */
    return FilteringRouter.extend({
        /**
         * Keeps track of whether we are showing the default nav bar view to avoid reconstructing it.
         */
        _showingDefaultNavBarView: false,

        _navBarView: null,

        /**
         * Routes that skip the login check.
         */
        _skipLoginRoutes: ["adLogin*params", "communityLogin", "user/password/forgot", "user/password/:resetToken", "browsersupport"],

        /**
         * @private
         *
         * Shows the default nav bar view in the nav bar. If the nav bar is already showing the default nav bar view,
         * has no effect.
         *
         * @param {Object} [options] Optional. The default navigation bar options.
         *
         * @cfg {Boolean} [withoutPrincipal] True to show the default nav bar view without the principal
         *                                   information, false to include it (default).
         * @cfg {ProjectModel} [project]     The current project, if any.
         */
        _showDefaultNavBarView: function _showDefaultNavBarView(options) {
            // Clear cache...
            this._navBarRegion.close();

            if (!this._showingDefaultNavBarView) {
                options = options || {};

                var principal = options.withoutPrincipal ? {} : LoggedIn.principal();

                this._navBarView = new NavBarView({
                    principal: principal,
                    project: options.project,
                    experience: options.experience,
                    viewModel: options.viewModel
                });

                this._navBarRegion.show(this._navBarView);
            }
        },
        initialize: function initialize(options) {
            this.options = options;
        },
        start: function start() {
            var _this = this;

            this._mainRegion = this.options.mainRegion;
            this._navBarRegion = this.options.navBarRegion;

            this._navBarView = new NavBarView({
                principal: LoggedIn.principal()
            });

            this._editorPreviewController = new EditorPreviewController({
                region: this._mainRegion,
                navBarRegion: this._navBarRegion
            });

            this._projectController = new ProjectDashboardController({
                region: this._mainRegion
            });

            // Not nice, but currently the publish toolbar view is just a view like any other view, though it is
            // in effect its own application, running by itself, needing special loading of pushed experiences
            // and what not!
            var hash = window.location.hash;
            var publishToolbar = hash.indexOf("publishtoolbar") !== -1;

            var loaderOptions = void 0;

            if (publishToolbar) {
                var hasProjectContext = !!hash.match(/project\/\w+\/publishtoolbar/);

                loaderOptions = {
                    experiences: {
                        includeMeasureData: false,
                        pushedOnly: true
                    },
                    groups: {
                        pushedOnly: true
                    },
                    loadProjects: hasProjectContext
                };
            } else {
                loaderOptions = {
                    experiences: {
                        includeMeasureData: true
                    }
                };
            }

            this._authController = new AuthenticationController({
                region: this._mainRegion,
                navBarRegion: this._navBarRegion,
                loader: loaderOptions
            });

            this._dashboardController = new DashboardController({
                region: this._mainRegion
            });

            this._manageAccountController = new ManageAccountController({
                region: this._mainRegion
            });

            this._psdImportController = new PSDImportController({
                region: this._mainRegion
            });

            this._exportController = new ExportController({
                region: this._mainRegion
            });

            this._analyticsController = new AnalyticsController({
                region: this._mainRegion
            });

            this._manageFontsController = new ManageFontsController({
                region: this._mainRegion
            });

            this._integrationsController = new IntegrationsController({
                region: this._mainRegion
            });

            this._breakpointController = new BreakpointController({
                region: this._mainRegion
            });

            this._publishController = new PublishController({
                region: this._mainRegion
            });

            // Keep track of whether the nav bar is showing the default view
            this.listenTo(this._navBarRegion, "show", function (view) {
                this._showingDefaultNavBarView = view instanceof NavBarView;
            });

            this.listenTo(this._navBarRegion, "close", function () {
                this._showingDefaultNavBarView = false;
            });

            // Hook up our beforeNavigate view logic to window unload. We cannot control the entire message, nor
            // button text being, shown here...
            Window.unload(function (e) {
                var currentView = _this._mainRegion.currentView;

                if (currentView && currentView.beforeNavigate) {
                    var prompt = getPrompt(currentView.beforeNavigate());

                    if (prompt) {
                        e.originalEvent.returnValue = prompt;
                        return prompt;
                    }
                }
                // Undefined
            });
        },


        routes: {
            "": function _() {
                this._showDefaultNavBarView();

                LoggedInUserState.set("location", LoggedInUserState.Location.DASHBOARD_EXPERIENCES);
                this._dashboardController.show({ tab: DashboardConfiguration.EXPERIENCES });

                return this._dashboardController;
            },

            "images/details/:id/experiences": function imagesDetailsIdExperiences(id) {
                this._showDefaultNavBarView();

                LoggedInUserState.set("location", LoggedInUserState.Location.DASHBOARD_IMAGES);
                this._dashboardController.show({
                    tab: DashboardConfiguration.IMAGES,
                    partialViewOptions: { id: id, showExperiences: true }
                });

                return this._dashboardController;
            },

            "images/details/:id": function imagesDetailsId(id) {
                this._showDefaultNavBarView();

                LoggedInUserState.set("location", LoggedInUserState.Location.DASHBOARD_IMAGES);
                this._dashboardController.show({
                    tab: DashboardConfiguration.IMAGES,
                    partialViewOptions: { id: id }
                });

                return this._dashboardController;
            },

            "images": function images() {
                this._showDefaultNavBarView();

                LoggedInUserState.set("location", LoggedInUserState.Location.DASHBOARD_IMAGES);
                this._dashboardController.show({ tab: DashboardConfiguration.IMAGES });

                return this._dashboardController;
            },

            "templates": function templates() {
                this._showDefaultNavBarView();

                LoggedInUserState.set("location", LoggedInUserState.Location.DASHBOARD_TEMPLATES);
                this._dashboardController.show({ tab: DashboardConfiguration.TEMPLATES });

                return this._dashboardController;
            },

            "publish": function publish() {
                this._showDefaultNavBarView();

                LoggedInUserState.set("location", LoggedInUserState.Location.DASHBOARD_PUBLISH);
                this._dashboardController.show({ tab: DashboardConfiguration.PUBLISH });

                return this._dashboardController;
            },
            "reporting": function reporting() {
                this._showDefaultNavBarView();

                LoggedInUserState.set("location", LoggedInUserState.Location.REPORTING);
                this._dashboardController.show({
                    tab: DashboardConfiguration.REPORTING,
                    partialViewOptions: { matomoPage: LoggedInUserState.Location.REPORTING }
                });

                return this._dashboardController;
            },
            "reporting/segment/:segmentDimension": function reportingSegmentSegmentDimension(segmentDimension) {
                this._showDefaultNavBarView();

                LoggedInUserState.set("location", LoggedInUserState.Location.REPORTING_SEGMENT);
                this._dashboardController.show({
                    tab: DashboardConfiguration.REPORTING,
                    partialViewOptions: { matomoPage: LoggedInUserState.Location.REPORTING_SEGMENT, segmentDimension: segmentDimension }
                });

                return this._dashboardController;
            },
            "user/password/forgot": function userPasswordForgot() {
                this._authController.showForgotPasswordForm();
            },

            "user/password/:resetToken": function userPasswordResetToken(resetToken) {
                this._authController.loginAfterPasswordReset(resetToken);
            },

            "user/confirm/:confirmToken": function userConfirmConfirmToken(confirmToken) {
                ConfirmationManager.confirm(confirmToken);
                // Navigate to main page, confirmation manager will handle the action...
                FilteringRouter.navigate("", true);
            },

            "user/requestConfirmEmail": function userRequestConfirmEmail() {
                ConfirmationManager.requestConfirmationInfo(true);
                FilteringRouter.navigate("", true);
            },

            "user/zmags/:token": function userZmagsToken(token) {
                this._authController.loginFromZmagsRequest(token);
            },

            "newuser/:token/share/:share_id": function newuserTokenShareShare_id(token, shareId) {
                Share.findById(shareId).then(function (share) {
                    // Check if this is in fact the invited user that is currently logged in
                    var userIds = share.get("to").map(function (rawUser) {
                        return rawUser.id;
                    });

                    if (contains(userIds, LoggedIn.principal().get("userId"))) {
                        FilteringRouter.navigate(share.get("link"), { trigger: true, replace: true });
                    } else {
                        // Logged in with a different user (highly unlikely that we get to this point)
                        // Log out and re-navigate to the same route to trigger the "newuser" logic in the "before" hook
                        FilteringRouter.navigate("logout", { trigger: true, replace: true });
                        FilteringRouter.navigate("newuser/" + token + "/share/" + shareId, { trigger: true, replace: true });
                    }
                }).fail(function () {
                    FilteringRouter.navigate("", true);
                });
            },

            "newuser/:token": function newuserToken(token) {
                FilteringRouter.navigate("newuser/" + token, { trigger: true, replace: true });
            },

            "browsersupport": function browsersupport() {
                this._authController.showBrowserSupport();
            },

            "experience/create": "_createExperience",
            "experience/create/project/:id": "_createExperience",

            // Project Routes
            "project/create": function projectCreate() {
                this._projectController.createProject();
                LoggedInUserState.set("location", LoggedInUserState.Location.PROJECT_CREATE);

                return this._projectController;
            },

            "project/:id": "_projectDashboard",

            "project/:id/images/details/:imageId/experiences": function projectIdImagesDetailsImageIdExperiences(id, imageId) {
                return this._projectDashboard(id, "images", {
                    partialViewOptions: { id: imageId, showExperiences: true }
                });
            },

            "project/:id/images/details/:imageId": function projectIdImagesDetailsImageId(id, imageId) {
                return this._projectDashboard(id, "images", {
                    partialViewOptions: { id: imageId }
                });
            },

            "project/:id/:tab": "_projectDashboard",

            // Experience Routes
            "experience/:id/edit": function experienceIdEdit(id) {
                var experienceURL = ExperienceURLProvider.provide(id, ExperienceURLProvider.ACTION.EDIT);
                // FIXME: Use 'navigateLater' so that the controller returned by the "experience/:id/edit/:scene" route is not closed immediately...
                FilteringRouter.navigateLater(experienceURL, { trigger: true, replace: true });
            },

            "experience/:id/edit/:scene": function experienceIdEditScene(id, scene) {
                this._openEditorAtSceneAndLayer(id, scene);
            },

            "experience/:id/edit/:scene/:layer": function experienceIdEditSceneLayer(id, scene, layerName) {
                var redirectURL = ExperienceURLProvider.provide(id, ExperienceURLProvider.ACTION.EDIT, scene);
                Backbone.history.navigate(redirectURL, false);
                this._openEditorAtSceneAndLayer(id, scene, layerName);
            },

            "experience/:id/preview": function experienceIdPreview(id) {
                this._editorPreviewController.previewExperience(id);
                LoggedInUserState.set("location", LoggedInUserState.Location.PREVIEW);
            },

            "experience/:id/preview/:scene": function experienceIdPreviewScene(id, scene) {
                this._openPreviewAtScene(id, scene);
            },

            "experience/:id/preview/:scene/:layer": function experienceIdPreviewSceneLayer(id, scene, layerName) {
                var redirectURL = ExperienceURLProvider.provide(id, ExperienceURLProvider.ACTION.PREVIEW, scene);
                Backbone.history.navigate(redirectURL, false);
                this._openPreviewAtScene(id, scene, layerName);
            },

            "template/:id/preview": function templateIdPreview(id) {
                this._openTemplatePreview(id);
            },

            "template/:id/preview/:scene": function templateIdPreviewScene(id, scene) {
                this._openTemplatePreview(id, scene);
            },

            "template/:id/preview/:scene/:layer": function templateIdPreviewSceneLayer(id, scene, layerName) {
                this._openTemplatePreview(id, scene, layerName);
            },

            "manageAccount": function manageAccount() {
                this._showDefaultNavBarView();
                this._manageAccountController.showManageAccount();
                LoggedInUserState.set("location", LoggedInUserState.Location.MANAGE_ACCOUNT);
            },

            "psdImport": function psdImport() {
                window.location.href = "#designtransform";
            },

            "designtransform": function designtransform() {
                this._showDefaultNavBarView();
                this._psdImportController.showPSDImport();
                LoggedInUserState.set("location", LoggedInUserState.Location.PSD_IMPORT);
            },

            "export": function _export() {
                this._showDefaultNavBarView();
                this._exportController.showExport();
                LoggedInUserState.set("location", LoggedInUserState.Location.EXPORT);

                return this._exportController;
            },

            "analytics": function analytics() {
                this._showDefaultNavBarView();
                this._analyticsController.showAnalytics();
                LoggedInUserState.set("location", LoggedInUserState.Location.ANALYTICS);

                return this._analyticsController;
            },

            "integrations": function integrations() {
                this._showDefaultNavBarView();
                this._integrationsController.showIntegrations();
                LoggedInUserState.set("location", LoggedInUserState.Location.INTEGRATIONS);

                return this._integrationsController;
            },

            "breakpoints": function breakpoints() {
                this._showDefaultNavBarView();
                this._breakpointController.showBreakpointSettingsView();
                LoggedInUserState.set("location", LoggedInUserState.Location.BREAKPOINT);

                return this._breakpointController;
            },

            "integrations-salesforce-commerce": function integrationsSalesforceCommerce() {
                this._showDefaultNavBarView();
                this._integrationsController.showIntegrations("add-ons");
                LoggedInUserState.set("location", LoggedInUserState.Location.INTEGRATIONS);

                return this._integrationsController;
            },

            "fonts": function fonts() {
                // Temp sanity check
                var integrations = LoggedInUserState.get("integrations");

                if (!integrations.fontIntegrationsEnabled()) {
                    return FilteringRouter.navigate("");
                }

                this._showDefaultNavBarView();

                this._manageFontsController.showManageFonts(integrations.fontIntegrations());

                LoggedInUserState.set("location", LoggedInUserState.Location.FONTS);

                return this._manageFontsController;
            },

            // Note: The followings are loaded in a different url, defacto as a standalone app!
            "project/:id/publishtoolbar/:url": function projectIdPublishtoolbarUrl(id, url) {
                this._publishController.showToolbarView(url, id);
            },

            "project/:id/publishtoolbar/framed/:url": function projectIdPublishtoolbarFramedUrl(id, url) {
                this._publishController.showFramedToolbarView(url, id);
            },

            "publishtoolbar/:url": function publishtoolbarUrl(url) {
                this._publishController.showToolbarView(url);
            },

            "publishtoolbar/framed/:url": function publishtoolbarFramedUrl(url) {
                this._publishController.showFramedToolbarView(url);
            },
            // End of Note

            "logout": function logout() {
                var signInURL = window.location.origin;
                var newDashboardExp = Storage.Local.get(Storage.Keys.NEW_DASHBOARD_EXP, Storage.Keys.NEW_DASHBOARD_EXP);
                NotificationBar.close({ clear: "all" }); // remove *all* notifications on logout
                this._authController.logout();
                if (newDashboardExp) {
                    window.location.href = CONTENT_CONTROL_URL + "#logout";
                    return;
                }
                // Redirect to Auth0 for logout in case the user signed in with SSO
                // This will redirect back to the origin once the Auth0 session is cleared
                // If there is no session in Auth0, it will just redirect back immediately
                window.location.href = AUTH0_DOMAIN + "/v2/logout?client_id=" + AUTH0_CLIENT_ID + "&returnTo=" + signInURL;
            },

            "login": function login() {
                this._showDefaultNavBarView();
                LoggedInUserState.set("location", LoggedInUserState.Location.LOGIN);
                this._authController.loginWithLoginForm(false, this.previousRoute || "" /* dashboard */);
            },

            "adLogin*params": function adLoginParams() {
                this._authController.logout();
                this._authController.loginWithLoginForm(true);
            },

            "communityLogin": function communityLogin() {
                ZendeskUtil.login(this._authController);
            },

            "zendesk/error": function zendeskError() {
                logger.error("Zendesk Error: User with id: " + LoggedIn.principal().get("userId") + " cannot access community portal, please contact Support");
                this._showDefaultNavBarView({ withoutPrincipal: true }); // true: no principal info
                var zendeskErrorView = new ZendeskErrorView();
                this._mainRegion.show(zendeskErrorView);
            },

            "*path": function path(_path) {
                logger.warn("Unmatched route '" + _path + "', redirecting to root.");
                FilteringRouter.navigate("", true);
            }
        },

        /**
         * Handles the "create experience" routes.
         *
         * @param  {String} projectId Optional, if the experience is to be created inside a specific project.
         * @return {EditorController} The <tt>EditorController</tt> instance.
         */
        _createExperience: function _createExperience(projectId) {
            EditorController.editNewExperience(projectId);

            return this._editorController;
        },


        /**
         * Handles the project dashboard routes.
         *
         * @param  {String} id   The project model id.
         * @param  {String} slug The URL slug part, if any.
         * @param {object} [options] The options passed to the projects controller.
         * @return {ProjectDashboardController} The <tt>ProjectDashboardController</tt> instance.
         */
        _projectDashboard: function _projectDashboard(id, slug) {
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var projectModel = LoggedInUserState.get("projects").get(id);

            var tab = ProjectDashboardConfiguration.fromSlug(slug);

            this._showDefaultNavBarView({ project: projectModel });

            var showOptions = extend({ project: projectModel, tab: tab }, options);

            this._projectController.show(showOptions);

            switch (tab) {
                case ProjectDashboardConfiguration.IMAGES:
                    LoggedInUserState.set("location", LoggedInUserState.Location.PROJECT_DASHBOARD_IMAGES);
                    break;

                case ProjectDashboardConfiguration.PUBLISH:
                    LoggedInUserState.set("location", LoggedInUserState.Location.PROJECT_DASHBOARD_PUBLISH);
                    break;

                default:
                    LoggedInUserState.set("location", LoggedInUserState.Location.PROJECT_DASHBOARD_EXPERIENCES);
            }

            return this._projectController;
        },
        _skipLoginRoute: function _skipLoginRoute(route) {
            return contains(this._skipLoginRoutes, route);
        },
        before: function before(route) {
            // Most routes require the principal to be logged in, so show the login form instead if they are not
            // and block the route. Once they log in the route will be reloaded and this check will let them through
            // to the route.
            if (!LoggedIn.principal() && !this._skipLoginRoute(route)) {
                // TODO: this used to check for entire state
                // Handle new users separately, i.e. based on token...
                if (StringUtils.startsWith(route, "newuser/:token")) {
                    return this._authController.loginWithNewUserTokenOrLoginForm(arguments.length <= 1 ? undefined : arguments[1], StringUtils.contains(route, "share"));
                }

                if (StringUtils.startsWith(route, "experience/:id/edit/:scene")) {
                    var query = new URLSearchParams(window.location.search);
                    var ztoken = query.get('ztoken');
                    if (ztoken) {
                        query.delete('ztoken');
                        var urlWithoutZtoken = "?" + query.toString() + window.location.hash;
                        return this._authController.loginWithToken(ztoken, urlWithoutZtoken, CONTENT_CONTROL_URL);
                    }
                }
                return this._authController.loginWithPersistedUserOrLoginForm();
            }

            var currentView = this._mainRegion.currentView;

            // Check if the current view wants to prompt the user before navigating away from it
            // The result is cached, since routing might otherwise prompt the user multiple times before the view is closed
            if (currentView && currentView.beforeNavigate) {
                var promptMessage = getPrompt(currentView.beforeNavigate(), "Are you sure you want to leave this page?");

                if (promptMessage) {
                    if (confirm(promptMessage)) {
                        // TODO: Refactor this, Why do we call restoreChannelList here, this goes against the least knowledge principle?
                        if (currentView.restoreChannelList) {
                            currentView.restoreChannelList();
                        }
                    } else if (this.lastSuccessfulRoute) {
                        FilteringRouter.navigate(this.lastSuccessfulRoute);

                        return false;
                    }
                }
            }

            return true;
        },


        /**
         * @param {String} experienceId
         * @param {number} sceneNumber
         * @param {String} [layerName] `name` property of the layer. See LayerEnum.
         */
        _openEditorAtSceneAndLayer: function _openEditorAtSceneAndLayer(experienceId, sceneNumber, layerName) {
            if (LoggedInUserState.get("ready")) {
                this._setEditorDataToUser(experienceId, sceneNumber, layerName);
            } else {
                this.listenTo(LoggedInUserState, "change:ready", this._setEditorDataToUser.bind(this, experienceId, sceneNumber, layerName));
            }
        },
        _setEditorDataToUser: function _setEditorDataToUser(experienceId, sceneNumber, layerName) {
            var editorController = new EditorController({
                region: this._mainRegion,
                navBarRegion: this._navBarRegion
            });

            editorController.editExperience(experienceId, sceneNumber, layerName).done(function (options) {
                LoggedInUserState.set("currentExperience", options.experience);
                LoggedInUserState.set("location", LoggedInUserState.Location.EDIT);
            });
        },


        /**
         * @param {String} [id] The experience ID
         * @param {number|string} [scene] The scene number
         * @param {String} [layerName] `name` property of the layer. See LayerEnum.
         */
        _openPreviewAtScene: function _openPreviewAtScene(id, scene, layerName) {
            this._editorPreviewController.previewExperience(id, parseInt(scene, 10) || undefined, layerName);
            LoggedInUserState.set("location", LoggedInUserState.Location.PREVIEW);
        },


        /**
         * @param {String} [id] The template ID
         * @param {number|string} [scene] - The scene number
         * @param {String} [layerName] `name` property of the layer. See LayerEnum.
         */
        _openTemplatePreview: function _openTemplatePreview(id, scene, layerName) {
            this._editorPreviewController.previewTemplate(id, parseInt(scene, 10) || undefined, layerName);
            LoggedInUserState.set("location", LoggedInUserState.Location.PREVIEW_TEMPLATE);
        }
    }, {
        injection: {
            parameters: ["mainRegion", "navBarRegion"],
            asOptions: true
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AnalyticsView = __webpack_require__(2784),
        EditorEvents = __webpack_require__(17),
        LoggedInUserState = __webpack_require__(19),
        Marionette = __webpack_require__(10),
        SystemMessages = __webpack_require__(107),
        _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        Syncer = __webpack_require__(50),
        SyncManager = __webpack_require__(44);


    return Marionette.Controller.extend({

        showAnalytics: function showAnalytics() {
            var settings = LoggedInUserState.get("companySettings"),
                view = new AnalyticsView({ model: settings }),
                changed = null,
                operation = null,
                analyticsName = null;

            this.options.region.show(view);

            // Listen to validated changes on the *view*, not the model. This ensures we only sync when a valid
            // analytics key has been entered, not on every keystroke. However, we know the settings model is still
            // bound to view, so the relevant attribute will have changed as well, we just know that it is a valid
            // change here. When ever a sync is about to start, we disable the *other* analytics settings field to
            // avoid cascading saves if the user flips tabs while a pending is pending; once the save completes,
            // the input of the switched to tab becomes active again...

            this.listenTo(view, "change", function () {
                changed = null;
                analyticsName = null;
                operation = "saved";

                var key = settings.changed.googleAnalyticsId;

                if (typeof key !== "undefined") {
                    changed = "Your Google Analytics Tracking ID";
                    analyticsName = "GoogleAnalytics";
                    if (isBlank(key)) {
                        operation = "removed";
                    } else {
                        changed += " &quot;" + key + "&quot;";
                    }

                    view.ui.segmentIoApiKey.attr("disabled", true); // input in other tab!
                } else {
                    key = settings.changed.segmentIoApiKey;

                    if (typeof key !== "undefined") {
                        changed = "Your Segment.io Write Key";
                        analyticsName = "Segment.com";
                        if (isBlank(key)) {
                            operation = "removed";
                        } else {
                            changed += " &quot;" + key + "&quot;";
                        }

                        view.ui.googleAnalyticsId.attr("disabled", true); // input in other tab!
                    }
                }

                if (changed) {
                    settings.saveLater();
                }
            });

            // Listen for sync changes on the settings *model* to notify the user about CDN information...
            SyncManager.onSync({
                context: this,
                target: settings,
                method: "save",
                state: null, // any "save" state
                callback: function callback(state) {
                    if (changed) {
                        if (state === Syncer.State.Synced) {
                            var purgeTime = settings.get("purgeTime");
                            // Only open the notification bar if the purgeTime is not null
                            if (purgeTime !== null) {
                                SystemMessages.notifyPurge(changed, operation, purgeTime, false);

                                var eventName = EditorEvents.constants.SAVE_INTEGRATION;

                                if (operation === "removed") {
                                    eventName = EditorEvents.constants.DELETE_INTEGRATION;
                                }

                                var eventProperties = {
                                    category: "Analytics",
                                    integrationType: analyticsName,
                                    triggerOrigin: "AnalyticsInputField"
                                };

                                EditorEvents.trigger(eventName, eventProperties);
                            }
                        }

                        if (Syncer.State.complete(settings)) {
                            if (!view.isClosed) {
                                view.ui.googleAnalyticsId.attr("disabled", false);
                                view.ui.segmentIoApiKey.attr("disabled", false);
                            }

                            changed = null;
                        }
                    }
                }
            });
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Permissions = __webpack_require__(22),
        SettingsView = __webpack_require__(230),
        _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        template = __webpack_require__(2785),
        ValidateBehavior = __webpack_require__(96);


    return SettingsView.extend({

        className: SettingsView.prototype.className + " analytics-view",

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                permissionToManage: Permissions.Privileges.ADMIN.can()
            };
        },

        ui: {
            tabMenuItem: ".tab",
            googleAnalytics: ".google-analytics",
            segmentIo: ".segment-io",
            googleAnalyticsId: ".ga-key",
            segmentIoApiKey: ".segment-key"
        },

        bindings: {
            ".ga-key": "googleAnalyticsId",
            ".segment-key": "segmentIoApiKey",
            ".notification-box": {
                observe: ["googleAnalyticsId", "segmentIoApiKey"],
                updateView: false,
                visible: function visible(values) {
                    return values[0] && values[0].length >= 0 && values[1] && values[1].length >= 0;
                }
            }
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    ".ga-key": {
                        validateAfter: "beforeSubmit",
                        model: true, // mark as bound to model, so make sure we cancel pending save requests on error!
                        validator: function validator(key) {
                            return isBlank(key) || /^UA-\d{4,}-\d+$/.test(key); // GA tracking ids can have slightly different formats, found this online somewhere... :)
                        },
                        errorText: function errorText() {
                            return "Not a valid Google Analytics Tracking ID";
                        }
                    },
                    ".segment-key": {
                        validateAfter: "beforeSubmit",
                        model: true, // mark as bound to model, so make sure we cancel pending save requests on error!
                        validator: function validator(key) {
                            return isBlank(key) || /^\w{10,}$/.test(key); // at least 10 word characters (upper/lowercase letters + digits)
                        },
                        errorText: function errorText() {
                            return "Not a valid Segment.io Write Key";
                        }
                    }
                }
            }
        },

        events: {
            "click @ui.tabMenuItem": "_tabSelectionHandler"
        },

        onRender: function onRender() {
            this._defaultAnalyticsSelection();
        },

        /**
         * @private
         * Handles tab clicks and calls to select the tab.
         * @param  {Event} event The click event.
         */
        _tabSelectionHandler: function _tabSelectionHandler(event) {
            var tabName;

            if (event.target.classList.contains("segment-io")) {
                tabName = "segmentIo";
            } else if (event.target.classList.contains("google-analytics")) {
                tabName = "googleAnalytics";
            }

            this._selectTab(tabName);
        },

        /**
         * @private
         * Checks if/which analytics the company uses, and activates the tab accordingly.
         */
        _defaultAnalyticsSelection: function _defaultAnalyticsSelection() {
            var hasGoogleId = this.model.get("googleAnalyticsId"),
                hasSegmentIoKey = this.model.get("segmentIoApiKey");

            if (hasSegmentIoKey && !hasGoogleId) {
                this._selectTab("segmentIo");
            } else {
                this._selectTab("googleAnalytics");
            }
        },

        /**
         * @private
         * Toggles active class on tabs and content.
         *
         * @param {String} tabName The tabName that should be activated.
         */
        _selectTab: function _selectTab(tabName) {
            this.ui.segmentIo.toggleClass("active", tabName === "segmentIo");
            this.ui.googleAnalytics.toggleClass("active", tabName === "googleAnalytics");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2785 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Set Up Analytics</h1>\n    </header>\n\n    <div class="tabs">\n        <span class="tab google-analytics">Google Analytics</span>\n        <span class="tab segment-io">Segment</span>\n    </div>\n    <div class="tab-pane google-analytics">\n        <div class="row">\n            <section class="col-xs-4">\n                <p class="intro">With Creator’s Google Analytics integration you are able to track clicks, scene navigation, opening\n                of light boxes and more with your Google Analytics account.</p>\n                <p>This will allow you to track and follow the entire stream of user behavior through your web site and analyze\n                how your Creator Experiences contribute to the overall success of your site.</p>\n            </section>\n            <section class="col-xs-4">\n                <h4>1. Copy your Tracking ID</h4>\n                <p>Copy the Google Tracking ID under Admin / Tracking Info / Tracking Code on your Google Universal Analytics account and paste it in the field below.</p>\n                <div class="analytics-input">\n                    <label>Tracking ID:</label>\n                    <input class="ga-key" type="text" class="tracking" placeholder="UA-xxxxxxxx-x" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += '>\n                </div>\n                <span class="help-block">You can find your Tracking ID here: <a href="http://www.google.com/analytics/" target="_blank">http://www.google.com/analytics/</a></span>\n            </section>\n            <section class="col-xs-4">\n                <h4>2. Set up Google Account</h4>\n                <p>Make sure that your Google Account is set up as a <a href="https://support.google.com/analytics/answer/2790010?hl=en"\n                target="_blank">Universal Analytics</a> web property.</p>\n            </section>\n        </div>\n        <div class="row">\n            <section class="col-xs-4">\n                <div class="notification-box">\n                    <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">You have enabled both Google Analytics and Segment</span>\n                    <p>We recommend setting up Google Analytics on your Segment account instead and use only Segment with Creator.</p>\n                </div>\n            </section>\n            <section class="col-xs-4">\n                <div class="illustration google-id"></div>\n            </section>\n            <section class="col-xs-4">\n                <div class="illustration google-ua"></div>\n            </section>\n        </div>\n    </div>\n    <div class="tab-pane segment-io">\n        <div class="row">\n            <section class="col-xs-4">\n                <p class="intro">Segment is a third-party tool that enables integration with a wide variety of analytics systems such as Omniture and Marketo,\n                allowing you to integrate your analytics system with Creator with no coding required.</p>\n                <p>With Segment you can track events from Creator\n                directly in your analytics platform of choice, provided that it is <a href="http://segment.io/integrations" target="_blank">supported by Segment</a>.</p>\n            </section>\n            <section class="col-xs-4">\n                <h4>1. Copy your Write Key</h4>\n                <p>Copy​ your Write Key under Project Settings / API Keys on your Segment account and paste it in the field below.</p>\n                <div class="analytics-input">\n                    <label>Write key:</label>\n                    <input class="segment-key" type="text" class="tracking" placeholder="xxxxxxxxxx" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += '>\n                </div>\n                <span class="help-block">You can find your Write Key here: <a href="https://segment.com" target="_blank">https://segment.com</a></span>\n            </section>\n        </div>\n        <div class="row">\n            <section class="col-xs-4">\n                <div class="notification-box">\n                    <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">You have enabled both Google Analytics and Segment</span>\n                    <p>We recommend setting up Google Analytics on your Segment account instead and use only Segment with Creator.</p>\n                </div>\n            </section>\n            <section class="col-xs-4">\n                <div class="illustration segment-api-key"></div>\n            </section>\n        </div>\n    </div>\n</div>\n<footer class="default-footer"></footer>\n';

}
return __p
}

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        Marionette = __webpack_require__(10),
        _ = __webpack_require__(1),
        $ = __webpack_require__(4),
        SignInView = __webpack_require__(2787),
        RegistrationView = __webpack_require__(2793),
        ResetPasswordView = __webpack_require__(2796),
        ForgotPasswordView = __webpack_require__(2798),
        BrowserSupportView = __webpack_require__(2800),
        SignInNavBarView = __webpack_require__(2802),
        Login = __webpack_require__(177),
        LoggedIn = __webpack_require__(31),
        LoggedInUserState = __webpack_require__(19),
        LoggedInUserStateLoader = __webpack_require__(2810),
        ExperienceURLProvider = __webpack_require__(168),
        NotificationBar = __webpack_require__(53);

    function getUsername() {
        // not the display name, actual username (email)
        var user = LoggedIn.user();
        return user && user.get("username");
    }

    /**
     * Controller for authentication and the sign in view.
     *
     * @author Bo Gotthardt
     * @class AuthenticationController
     */
    return Marionette.Controller.extend({

        /**
         * @private
         * Loads all data for the user described by the now logged in principal, using the loader options
         * set for this authentication controller.
         *
         * @param {Principal} principal The principal just logged in; never null.
         * @return {Promise} The promise that will resolve once all user relevant (as configured) has loaded; never falsey.
         */
        _load: function _load(principal) {
            return LoggedInUserStateLoader.load(principal, this.options.loader);
        },

        /**
         * Show the login form.
         *
         * @param   {Boolean} [adLogin] Whether to show the Active Directory version of the login form immediately.
         * @returns {Promise} Promise that resolves when the principal has logged in and all the global data for
         *                    the associated user has been loaded, with two parameters: the principal, and optionally
         *                    the AD login model.
         */
        showLoginForm: function showLoginForm(adLogin) {
            var deferred = $.Deferred(),
                username = getUsername();

            this.options.region.show(new SignInView({
                loginDeferred: deferred,
                username: username,
                adLogin: !!adLogin
            }));

            // If we have a username, it is because we have a read-only token and want to upgrade to a normal
            // token again, which is why we keep the nav bar region as is, e.g. to allow the user to click "back", etc...
            if (!username) {
                this.options.navBarRegion.show(new SignInNavBarView());
            }

            return deferred.promise();
        },

        /**
         * Show the forgot password form.
         */
        showForgotPasswordForm: function showForgotPasswordForm() {
            var username = getUsername();

            this.options.region.show(new ForgotPasswordView({ username: username }));

            // If we have a username, it is because we have a read-only token and want to upgrade to a normal
            // token again, which is why we keep the nav bar region as is, e.g. to allow the user to click "back", etc...
            if (!username) {
                this.options.navBarRegion.show(new SignInNavBarView());
            }
        },

        /**
         * Show the reset password form for the supplied reset token (from a link clicked in an email).
         *
         * @param   {String}  resetToken The rest token (from the reset url).
         * @returns {Promise} Promise that resolves when the password has successfully been reset and the principal has
         *                    logged in and all the global data for the associated user has been loaded.
         */
        showResetPasswordForm: function showResetPasswordForm(resetToken) {
            var deferred = $.Deferred();

            this.options.region.show(new ResetPasswordView({
                loginDeferred: deferred,
                resetToken: resetToken
            }));

            this.options.navBarRegion.show(new SignInNavBarView());

            return deferred.promise();
        },

        /**
         * Show the browser support form.
         */
        showBrowserSupport: function showBrowserSupport() {
            this.options.region.show(new BrowserSupportView()); // TODO: why is this on the authentication controller?
        },

        /**
         * Attempts a login using the login form.
         *
         * @param {Boolean} [adLogin]  Whether to show the Active Directory version of the login form immediately.
         * @param {String}  [fragment] Optional fragment to navigate to once the user has successfully signed in. If
         *                             not specified, the current route will be reloaded.
         *
         * @returns {Promise} Promise that resolves when the principal is logged in and all global data for the
         *                    associated user has been loaded; never null.
         */
        loginWithLoginForm: function loginWithLoginForm(adLogin, fragment) {
            var _this = this;

            return this.showLoginForm(adLogin).then(function (principal, adLoginModel) {
                return _this._load(principal).done(function () {
                    if (adLoginModel) {
                        // Navigate to the experience if defined
                        var experienceId = adLoginModel.get("experienceId");
                        if (Backbone.history.fragment.indexOf("adLogin") === 0) {
                            Backbone.history.navigate("", true);
                        } else if (experienceId && Backbone.history.fragment.indexOf("experience/") === -1) {
                            Backbone.history.navigate(ExperienceURLProvider.provide(experienceId, ExperienceURLProvider.ACTION.EDIT), true);

                            // Reload, which will trigger the logic that reads the token from the cookie.
                        } else {
                            Backbone.history.loadUrl(Backbone.history.fragment);
                        }
                    } else if (_.isString(fragment)) {
                        Backbone.history.navigate(fragment, { trigger: true, replace: true }); // TODO: Make the "replace" optional?
                    } else {
                        // Reload the current route
                        Backbone.history.loadUrl(Backbone.history.fragment);
                    }
                });
            });
        },

        /**
         * Attempts to sign in with a potential persisted principal, i.e. the user has previously signed in, with
         * the "Keep me signed in" option checked. If this fails, the login form is used.
         *
         * @return {Promise} A promise for the principal having logged in and loaded all global data for the associated
         *                   user successfully.
         */
        loginWithPersistedUserOrLoginForm: function loginWithPersistedUserOrLoginForm() {
            var _this2 = this;

            return Login.loginPersistedUser().fail(function () {
                _this2.loginWithLoginForm(false);
            }).then(function (principal) {
                return _this2._load(principal);
            });
        },

        /**
         * Attempts to log in a principal on behalf of an entirely new Creator user using a token supplied in the link,
         * defaulting to the persisted user. <p>
         *
         * If this fails, the login form is used.
         *
         * @param {String} token   The access token for the new Creator user; cannot be null.
         * @param {String} isShare Whether the request comes from a share action or just a new user action.
         *
         * @return {Promise} A promise for the principal having logged in and loaded all global data for the associated
         *                   new user successfully.
         */
        loginWithNewUserTokenOrLoginForm: function loginWithNewUserTokenOrLoginForm(token, isShare) {
            var scope = this;
            // Try and log in with user from token ...
            return Login.loginNewUser(token).fail(function () {
                // The token is only valid the first time used, so try and see if the principal has a persistent
                // login in to use, otherwise go to the login form...
                return Login.loginPersistedUser().then(function (principal) {
                    return scope._load(principal).then(function () {
                        // Navigate to the dashboard once done...
                        Backbone.history.navigate("#", true);
                    });
                }).fail(function () {
                    return scope.loginWithLoginForm(false, "#"); // go to dashboard...
                });
            }).then(function (principal) {
                // Show the new user overlay...
                $("body").append(new RegistrationView({ model: principal.get("user"), isShare: isShare }).render().$el); // TODO: this is ugly, most be a better way to show an overlay in a generic fashion?!
                // Resolve the promise once the user information is completely loaded...
                return scope._load(principal);
            });
        },

        /**
         * Attempts a login after a successful password reset based on a reset token.
         *
         * @param   {String}  resetToken The rest token (from the reset url).
         *
         * @returns {Promise} Promise that resolves when the password has been successfully reset and the principal
         *                    is logged in and all global data for the associated user has been loaded; never null.
         */
        loginAfterPasswordReset: function loginAfterPasswordReset(resetToken) {
            var _this3 = this;

            return this.showResetPasswordForm(resetToken).then(function (principal) {
                return _this3._load(principal).done(function () {
                    // Navigate to the dashboard once reset successfully...
                    Backbone.history.navigate("#", true);
                    NotificationBar.open("Your password has successfully been reset.", { closeDelay: 7500 });
                });
            });
        },

        /**
         * Attempts to log in a principal on behalf of a user who tries to login from the Zmags website. <p>
         *
         * The login request contains the user token.
         *
         * If the login via token fails, the login form is used.
         *
         * @param {String} token The token to login with; cannot be null.
         * @return {Promise} A promise for the principal having logged in and loaded all global data for the associated
         *                   new user successfully, then navigated to the dashboard.
         */
        loginFromZmagsRequest: function loginFromZmagsRequest(token) {
            var _this4 = this;

            return Login.loginNewUser(token).fail(function () {
                _this4.loginWithLoginForm(false);
            }).then(function (principal) {
                return _this4._load(principal).done(function () {
                    // Navigate to the dashboard once done...
                    Backbone.history.navigate("#", true);
                });
            });
        },

        /**
         * This method attempts to log in a principal on behalf of a user and redirect to experience/:id/edit/:scene 
         * when user tries to edit experiece who is redirected from Content Control UI (Preview Page).
         * 
         * In case if the login via token fails, user will redirected to Content Control UI Dashboard.
         * 
         * @param  {String} token, User token which used to do  login.
         * @param  {String} redirectUrl
         * @param  {String} contentCtrlDashboard, dashboard url in case if login fail will redirect to this url.
         */
        loginWithToken: function loginWithToken(token, redirectUrl, contentCtrlDashboard) {
            var _this5 = this;

            return Login.loginNewUser(token).fail(function () {
                window.open(contentCtrlDashboard, '_self');
            }).then(function (principal) {
                return _this5._load(principal).done(function () {
                    // Navigate to the Edit experience once done...
                    window.open(redirectUrl, '_self');
                });
            });
        },

        /**
         * Logs the current principal out and clears all global cached state for the associated user. <p>
         *
         * This will trigger a change event for <tt>LoggedInUserState.ready</tt> with a false value.
         */
        logout: function logout() {
            Login.logout();
            LoggedInUserState.clear();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        delay = _require.delay;

    var ADSignInView = __webpack_require__(2788);
    var Browser = __webpack_require__(39);
    var EmailUtil = __webpack_require__(231);
    var ImprovedView = __webpack_require__(6);
    var SignInViewController = __webpack_require__(2790);

    var _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank;

    var template = __webpack_require__(2792);
    var ValidateBehavior = __webpack_require__(96);
    var Configuration = __webpack_require__(27);

    var AUTH0_DOMAIN = Configuration.auth0Domain;
    var AUTH0_CLIENT_ID = Configuration.auth0ClientId;
    var AUTH0_AUDIENCE = Configuration.auth0Audience;

    var SHAKE_EFFECT_CLASS_NAME = "shake",
        TERMS_OF_USE_URL = "http://community.zmags.com/articles/Knowledgebase/Creator-Product-Terms-of-Use";

    // View->Controller events...
    var Events = {
        SUBMIT: "submit"
    };

    /**
     * The sign in view.
     *
     * @class SignInView
     * @constructor
     *
     * @cfg {Deferred} loginDeferred Deferred to resolve when the user has successfully logged in.
     * @cfg {boolean} [adLogin] Whether to show the Active Directory login form immediately.
     */
    return ImprovedView.extend({

        /**
         * @private @type {Boolean}
         * Flag to toggle AD login on/off.
         */
        _adView: false,

        template: template,

        templateHelpers: {
            browser: Browser,
            termsOfUseURL: TERMS_OF_USE_URL
        },

        controller: SignInViewController,

        className: "sign-in-page pt-page",

        transitions: {
            out: "pt-page-scaleDown"
        },

        ui: {
            signInView: ".sign-in-view",
            logo: ".sign-in-logo",
            form: ".login-form",
            emailInput: ".email-input",
            passwordInput: ".password-input",
            signInButton: ".sign-in-button",
            signInError: ".sign-in-error",
            ssoButton: ".sso-button",
            innerContainer: ".inner-container",
            persistentInput: ".persistent-input",
            termsOfUse: ".terms-of-use"
        },

        events: {
            "submit @ui.form": "_loginSubmitHandler",
            "click .sso-button": "_ssoRedirect"
        },

        regions: {
            activeDirectory: ".active-directory",
            throttleRegion: ".throttle-region",
            defaultFooterRegion: ".default-footer"
        },

        keyboard: {
            "alt-shift-y": "_toggleAdSignInView"
        },
        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    ".email-input": {
                        validator: function validator(email) {
                            return this._adView || EmailUtil.validateEmail(email);
                        },
                        errorText: function errorText(email) {
                            if (!email) {
                                return "Email required";
                            } else if (!EmailUtil.validateEmail(email)) {
                                return "Not a valid email";
                            }

                            return "";
                        }
                    },
                    ".password-input": {
                        validator: function validator(password) {
                            return this._adView || !isBlank(password);
                        },

                        errorText: "Password required"
                    }
                }
            }
        },

        _loginSubmitHandler: function _loginSubmitHandler(event) {
            // Stop form from submitting normally
            event.preventDefault();

            // Signal controller that form was submitted...
            this.trigger(Events.SUBMIT);

            return false;
        },
        _ssoRedirect: function _ssoRedirect() {
            var redirectUri = window.location.origin; // redirect back to the origin after sign-in with Auth0

            /*
            This /authorize URL initiates login to the ZMags Auth0 tenant for the specified app, and has these params:
              - response_type: indicates whether the response should be a JWT (value = token) or an authorization code
              - client_id: corresponds to the application configuration in Auth0 that should be used for sign-in
              - redirect_uri: where the user should be redirected after login (to handle the JWT)
              - audience: identifies the expected aud claim in the JWT, and uses the corresponding signing config in Auth0
            */
            window.location.href = AUTH0_DOMAIN + "/authorize?response_type=token&client_id=" + AUTH0_CLIENT_ID + "&redirect_uri=" + redirectUri + "&audience=" + AUTH0_AUDIENCE + "&prompt=login";
        },
        _toggleAdSignInView: function _toggleAdSignInView() {
            if (this._adView) {
                this.ui.form.show();
                this.activeDirectory.reset();
            } else {
                this.ui.form.hide(); // throttle view inside this form!
                this.activeDirectory.show(new ADSignInView({
                    username: this.ui.emailInput.val(),
                    loginDeferred: this.options.loginDeferred
                }));
            }
            this._adView = !this._adView;
        },


        /**
         * Applies the "shake" effect to this view.
         *
         * @param {Boolean} [enable] Optional boolean value, if <tt>false</tt> the effect will be removed.
         */
        shake: function shake(enable) {
            if (typeof enable === "undefined" || enable === true) {
                this.ui.form.addClass(SHAKE_EFFECT_CLASS_NAME);
            } else {
                this.ui.form.removeClass(SHAKE_EFFECT_CLASS_NAME);
            }
        },


        /**
         * Show/hides terms-of-use from this view. <p>
         *
         * @param {Boolean} show True to show (if not already), false to hide.
         */
        showTermsOfUse: function showTermsOfUse(show) {
            if (show) {
                this.ui.termsOfUse.show();
            } else {
                this.ui.termsOfUse.hide();
            }
        },


        /**
         * Show/hide a message with sign-in error details and remediation steps. <p>
         *
         * @param {Boolean} show True to show (if not already), false to hide.
         */
        showErrorMessage: function showErrorMessage(message) {
            if (message) {
                this.ui.signInError.html(message);
                this.ui.signInError.show();
            } else {
                this.ui.signInError.hide();
            }
        },


        /**
         * Fade in logo and login form.
         */
        _fadeElementsIn: function _fadeElementsIn() {
            var _this = this;

            /**
             * The elements are born with the "show" class (ie. faded in), just so users
             * don't get a blank page in case this function fails. First we remove .show
             * to hide them...
             */
            this.ui.logo.removeClass("show");
            this.ui.innerContainer.removeClass("show");

            /**
             * ... then we fade them back in at different intervals (and speed, see css).
             */
            delay(function () {
                _this.ui.logo.addClass("show");
            }, 1);

            delay(function () {
                if (_this.ui.innerContainer) {
                    _this.ui.innerContainer.addClass("show");
                    // Give password focus if we already have a username, i.e. on soft login for read only tokens...
                    if (_this.ui.emailInput.val()) {
                        _this.ui.passwordInput.focus();
                    } else {
                        _this.ui.emailInput.focus();
                    }
                }
            }, 1000);
        },
        onRender: function onRender() {
            if (this.options.adLogin) {
                this._toggleAdSignInView();
            }
            // If we have a username set, make it fixed, e.g. for re-login. Does not make sense to allow the
            // user to enter a new username (even though the frontend supports it)...
            if (this.options.username) {
                this.ui.emailInput.val(this.options.username);
                this.ui.emailInput.attr("disabled", true);
            }
            this._fadeElementsIn();
        }
    }, {
        Events: Events
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        EmailUtil = __webpack_require__(231),
        IdValidator = __webpack_require__(869),
        ImprovedView = __webpack_require__(6),
        Login = __webpack_require__(177),
        SequentialButton = __webpack_require__(112),
        _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        ValidateBehavior = __webpack_require__(96),
        template = __webpack_require__(2789);


    var SHAKE_EFFECT_CLASS_NAME = "shake";

    /**
     * Form for logging into accounts using Zmags Active Directory credentials.
     *
     * @author Bo Gotthardt
     * @class ADSignInView
     *
     * @cfg {String} [username] Default value for the username field.
     */
    return ImprovedView.extend({

        _action: null,

        template: template,

        model: new Backbone.Model(),

        ui: {
            form: "#ad-form",
            signInButton: "#ad-sign-in-button",
            publicatorId: "#ad-publicator-id", // to test if both email, pub id, and exp id are all empty...
            experienceId: "#ad-exp-id"
        },

        events: {
            "submit #ad-form": function submitAdForm(event) {
                event.preventDefault();
                this._action();
                return false;
            }
        },

        bindings: {
            "#ad-email": "username",
            "#ad-publicator-id": "publicatorUserId",
            "#ad-exp-id": "experienceId",
            "#ad-username": "ldapUsername",
            "#ad-password": "ldapPassword"
        },
        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    "#ad-email": {
                        validator: function validator(email, type) {
                            // On submit, we must have at least one identifier for the user to log in as...
                            var blank = isBlank(email);

                            if (type === "submit") {
                                if (blank && isBlank(this.ui.publicatorId.val()) && isBlank(this.ui.experienceId.val())) {
                                    return false;
                                }
                            }
                            return blank || EmailUtil.validateEmail(email);
                        },
                        errorText: function errorText(email, type) {
                            if (type === "submit" && isBlank(email)) {
                                return "Creator username, Publicator id, or Experience id required";
                            }
                            return "Not a valid email";
                        }
                    },
                    "#ad-exp-id": {
                        validator: function validator(id) {
                            return IdValidator.isValid(id);
                        },
                        errorText: "Not a valid experience id"
                    },
                    "#ad-username": {
                        validator: function validator(username) {
                            return !isBlank(username);
                        },
                        errorText: "AD username required"
                    },
                    "#ad-password": {
                        validator: function validator(password) {
                            return !isBlank(password);
                        },
                        errorText: "AD password required"
                    }
                }
            }
        },

        /**
         * Applies the "shake" effect to this view.
         *
         * @param {Boolean} [enable] Optional boolean value, if <tt>false</tt> the effect will be removed.
         */
        shake: function shake(enable) {
            if (typeof enable === "undefined" || enable === true) {
                this.$el.addClass(SHAKE_EFFECT_CLASS_NAME);
            } else {
                this.$el.removeClass(SHAKE_EFFECT_CLASS_NAME);
            }
        },

        /**
         * @private
         * Tries to perform an ad login. <p>
         *
         * Note: the ad login is actually throttled on the backend on the ad username, but that is deemed such a
         * special case we do not want to add logic for it here in the frontend.
         */
        _login: function _login() {
            var _this = this;

            if (!this.inputValidation()) {
                return false;
            }

            this.shake(false);

            return Login.loginActiveDirectory(this.model).done(function (principal) {
                return _this.options.loginDeferred.resolve(principal, _this.model);
            }).fail(function () {
                _this.shake(true);
            });
        },

        onRender: function onRender() {
            var currentFragment = Backbone.history.fragment;
            // Add default values to fields where applicable...
            var index = currentFragment.indexOf("experience/");
            if (index !== -1) {
                this.model.set("experienceId", currentFragment.substring(index + 11, index + 35));
            }

            index = currentFragment.indexOf("publicatorUser/");
            if (index !== -1) {
                this.model.set("publicatorUserId", currentFragment.substring(index + 15, index + 23));
            }

            if (this.options.username) {
                this.model.set("username", this.options.username);
            } else {
                index = currentFragment.indexOf("username/");
                if (index !== -1) {
                    this.model.set("username", currentFragment.substring(index + 9));
                }
            }

            this._action = SequentialButton.add(this.ui.signInButton, this._login.bind(this));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2789 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<form id="ad-form">\n    <div class="control-group">\n        <p>Enter either Creator username, Publicator user id, or Experience id</p>\n        <input type="text" class="login-field" placeholder="Creator username" id="ad-email" autocapitalize="off" autofocus>\n    </div>\n    <div class="control-group">\n        <input type="text" class="login-field" placeholder="Publicator user id" id="ad-publicator-id" autocapitalize="off">\n    </div>\n    <div class="control-group">\n        <input type="text" class="login-field" placeholder="Experience id" id="ad-exp-id" autocapitalize="off">\n    </div>\n    <br/>\n    <div class="control-group">\n        <input type="text" class="login-field" placeholder="Active Directory username" id="ad-username" autocapitalize="off">\n    </div>\n    <div class="control-group">\n        <input type="password" class="login-field" placeholder="Active Directory password" id="ad-password" autocapitalize="off">\n    </div>\n    <br/>\n    <button id="ad-sign-in-button" class="sign-in-button btn btn-large btn-block btn-login ladda-button" data-size="26" data-style="expand-right"><span class="ladda-label">Sign in</span></button>\n</form>';

}
return __p
}

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EmailUtil = __webpack_require__(231),
        Cookie = __webpack_require__(406),
        Login = __webpack_require__(177),
        SequentialButton = __webpack_require__(112),
        ThrottleView = __webpack_require__(692),
        ViewController = __webpack_require__(126);

    // Cookie names...
    var TERMS_OF_USE_SHOWN = "termsOfUseShown";

    function getUrlHashParam(key) {
        var hash = window.location.hash;
        if (hash.indexOf(key) !== -1) {
            return hash.split("&").find(function (fragment) {
                return fragment.indexOf(key) !== -1;
            }).split("=")[1];
        }
    }

    /**
     * <tt>ViewController</tt> for the SignInView. Handles the actual sign in process.
     *
     * @class SignInViewController
     * @see  SignInView
     *
     * @author Kim
     */
    return ViewController.extend({

        /**
         * @private @type {SequentialButton}
         * The sequential button used to submit the login form.
         */
        _action: null,
        /**
         * @private @type {ThrottleView}
         * The throttle view handling lockout and displaying lockout messages for too many login attempts.
         */
        _throttleView: null,
        /**
         * @private
         * @type {Promise}
         * The promise to resolve on successful sign in.
         */
        _loginDeferred: null,
        /**
         * @private
         * @type {Promise}
         * The message that should be displayed if there is a sign-in error.
         */
        _errorMessage: null,

        /**
         * @private
         * Performs a login with the current entered credentials, returning a promise that on success will resolve
         * to the logged in principal. <p>
         *
         * On too many failed password attempts within a given time frame, specified by the backend, the user will be
         * locked out from submitting more login requests. After the lockout time expires, she will be allowed to
         * try again.
         *
         * @return {Promise|Boolean} A promise the will resolve to the logged in user; never null, or false if no
         *                           login was attempted because of missing username/password.
         */
        _login: function _login() {
            var _this = this;

            // Make sure the form is valid, i.e. valid email and non-blank password...
            if (!this.view.inputValidation()) {
                return false;
            }

            // Remove shake effect for any previous submitted request...
            this.view.shake(false);

            var email = this.view.ui.emailInput.val();

            // Do the login...
            var promise = Login.loginWithPassword(email, this.view.ui.passwordInput.val(), this.view.ui.persistentInput.prop("checked")).done(function (principal) {
                Cookie.set(TERMS_OF_USE_SHOWN, true);
                _this._loginDeferred.resolve(principal);
            }).fail(function () {
                _this.view.shake(); // Shake it baby...
            });

            // Check the response for throttling status code...
            return this._throttleView.checkPromise(email, promise);
        },

        /**
         * @private
         * Performs a login using the JWT response from Auth0 (if available), returning a promise that on success will resolve
         * to the logged in principal. <p>
         *
         * @return {Promise|Boolean} A promise that will resolve to the logged in user; never null, or false if no
         *                           login was attempted because of missing username/password.
         */
        _handleSsoResponse: function _handleSsoResponse() {
            var _this2 = this;

            var jsonWebToken = getUrlHashParam("access_token");
            if (jsonWebToken) {
                return Login.loginWithSSO(jsonWebToken).done(function (principal) {
                    _this2._loginDeferred.resolve(principal);
                }).fail(function () {
                    _this2.view.showErrorMessage("User account is not registered<br />Please reach out to support@zmags.com");
                    history.pushState(null, null, " ");
                });
            }

            // Handle SSO error from Auth0 (from URL hash)
            var errorStatus = getUrlHashParam("error");
            if (errorStatus) {
                var errorDescription = getUrlHashParam("error_description");

                var decodedErrorStatus = decodeURIComponent(errorStatus);
                var decodedErrorDescription = errorDescription ? decodeURIComponent(errorDescription) : "";

                this._errorMessage = "SSO Error - " + decodedErrorStatus + "<br />" + decodedErrorDescription + "<br />Please reach out to support@zmags.com";
            }
        },

        onInitialize: function onInitialize() {
            this._loginDeferred = this.options.loginDeferred;

            this._handleSsoResponse();
        },

        onViewRender: function onViewRender() {
            // Construct the login callback using the SequentialButton...
            this._action = SequentialButton.add(this.view.ui.signInButton, this._login.bind(this), true, true);

            // Throttle view...
            this._throttleView = new ThrottleView({
                name: "login",
                lockout: "You have entered invalid credentials too many times!",
                target: this.view.ui.emailInput, // entered email = target
                validate: EmailUtil.validateEmail, // make sure we only throttle for valid emails, will not submit otherwise
                button: this._action // disable button during lockout
            });
            this.view.throttleRegion.show(this._throttleView);

            // Hide terms of use if already shown on successful login...
            if (Cookie.get(TERMS_OF_USE_SHOWN)) {
                this.view.showTermsOfUse(false);

                // Hide terms of use if not already shown and lockout is in progress - not much room on the page...
            } else {
                this.listenTo(this._throttleView, "lockout", function (lockout) {
                    this.view.showTermsOfUse(!lockout);
                });
            }

            // check if there was a sign-in error and render it
            if (this._errorMessage) {
                this.view.showErrorMessage(this._errorMessage);
            }
        },

        onViewSubmit: function onViewSubmit() {
            // from SignInView SUBMIT event
            this._action();
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2791 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="throttle"><span class="lockout"></span><span class="retry-after"></span></div>\n';

}
return __p
}

/***/ }),
/* 2792 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="sign-in-view">\n    <div class="sign-in-view-inner">\n        <div class="main-logo sign-in-logo show"></div>\n        <div class="inner-container show">\n            <h6 class="sign-in-error" />\n            <form class="login-form">\n\n                <input type="text" name="email" class="email-input login-field" placeholder="Email address" autocapitalize="off" autofocus>\n\n                <input type="password" class="login-field password-input" placeholder="Password" autocapitalize="off">\n\n                <a href="#user/password/forgot" class="forgot-link" tabindex="-1">Forgot?</a>\n\n                <label class="remember">\n                    <input type="checkbox" class="persistent-input" value="yes" checked="checked" tabindex="-1">\n                    <span class="remember-label">Keep me signed in</span>\n                </label>\n\n                <button class="sign-in-button btn btn-large btn-block btn-login ladda-button" data-size="26" data-style="expand-right"><span class="ladda-label">Sign in</span></button>\n\n                <small class="terms-of-use">By clicking this button, you agree<br>to Zmags\' <a href="' +
__e(  termsOfUseURL ) +
'" target="_blank">Terms of Use</a>.</small>\n                <div class="throttle-region"></div>\n            </form>\n\n            <div class="active-directory"></div>\n\n            <h2 class="sign-in-option-separator"><span>OR</span></h2>\n            <button class="sso-button btn btn-large btn-block btn-login ladda-button" data-size="26" data-style="expand-right"><span class="ladda-label">Single Sign-On</span></button>\n\n            <div class="sign-in-footer">\n                ';
 if (!browser.capabilities.isSupported) { ;
__p += '\n                    <div class="unsupported-browser">\n                        <h2>You are using an unsupported browser!</h2>\n                        <p>See <a href=\'#browsersupport\'>Browser Support</a> for further information.</p>\n                    </div>\n                ';
 } ;
__p += '\n\n                ';
 if (config.supportEmail) { ;
__p += '\n                    <a class="support-link" href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>\n                ';
 } ;
__p += '\n\n                <div class="default-footer"></div>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        EditorEvents = __webpack_require__(17),
        ImprovedModel = __webpack_require__(25),
        ImprovedView = __webpack_require__(6),
        Ladda = __webpack_require__(340),
        Login = __webpack_require__(177),
        PasswordQualityValidator = __webpack_require__(693),
        PasswordQualityView = __webpack_require__(1185),
        _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        template = __webpack_require__(2795),
        Tooltip = __webpack_require__(35);

    /**
     * The view model for the registration view.
     *
     * <p>This model assists in binding form elements that aren't present on the actual user model (password confirm,
     * keep signed in) and handles validation of inputs.</p>
     *
     * @class RegistrationViewModel
     * @constructor
     */
    var RegistrationViewModel = ImprovedModel.extend({
        defaults: {
            name: "",
            email: "",
            password: "",
            passwordConfirm: "",
            keepSignedIn: true
        },

        computed: {
            nameValid: {
                deps: ["name"],
                value: function value(name) {
                    return this._validateName(name);
                }
            },
            passwordValid: {
                deps: ["password"],
                value: function value(password) {
                    return this._validatePassword(password);
                }
            },
            passwordConfirmValid: {
                deps: ["passwordConfirm"],
                value: function value(passwordConfirm) {
                    return this._validatePassword(passwordConfirm);
                }
            },
            passwordsMatch: {
                deps: ["password", "passwordConfirm"],
                value: function value(password, passwordConfirm) {
                    return this._passwordsMatch(password, passwordConfirm);
                }
            },
            valid: {
                deps: ["name", "password", "passwordConfirm"],
                value: function value(email, password, passwordConfirm) {
                    return this._validateName(email) && this._validatePassword(password) && this._validatePassword(passwordConfirm) && this._passwordsMatch(password, passwordConfirm);
                }
            }
        },

        _validateName: function _validateName(name) {
            return !isBlank(name);
        },

        _validatePassword: function _validatePassword(password) {
            return PasswordQualityValidator.isValid(password);
        },

        _passwordsMatch: function _passwordsMatch(password, passwordConfirm) {
            return password === passwordConfirm;
        }
    });

    /**
     * The registration overlay view, shown when a new user is being registered.
     *
     * @author Bruce Mackenzie Nielsen
     * @class RegistrationView
     * @constructor
     */
    return ImprovedView.extend({

        _viewModel: null,
        _progressIndicator: null,

        template: template,
        className: "registration-overlay",

        viewModelBindings: {
            ".name-input": "name",
            ".email-input": "email",
            ".password-input": "password",
            ".retype-password-input": "passwordConfirm",
            ".persistent-input": "keepSignedIn"
        },

        ui: {
            name: ".name-input",
            password: ".password-input",
            passwordConfirm: ".retype-password-input",
            logInButton: "button"
        },

        events: {
            "submit form": function submitForm(event) {
                // Stop form from submitting normally
                event.preventDefault();

                // Update the display of validation errors and break out if the form is invalid
                this._updateValidationDisplay(true);
                if (!this._viewModel.get("valid")) {
                    return false;
                }

                var eventProperties = {
                    username: this.model.get("username"),
                    isNewUser: true,
                    triggerOrigin: "RegistrationLogInButton"
                };

                EditorEvents.trigger(EditorEvents.constants.ACCESS_USER, eventProperties);

                // Start showing the progress indicator
                this._progressIndicator.start();

                // Update user model with new name (before set password to ensure username exist for any mail actions when password is set)
                this.model.set({
                    name: this._viewModel.get("name")
                });

                var self = this;

                this.model.save().then(function () {
                    // Change the password
                    return Login.changePassword(self._viewModel.get("password"), self._viewModel.get("keepSignedIn"));
                }).done(function () {
                    // Close the view
                    self.remove();
                    // Navigate to the dashboard only if this is not coming from a share action. If if comes from a share option we already have the experience in the background.
                    if (!self.options.isShare) {
                        Backbone.history.navigate("", true);
                    }
                }).always(function () {
                    self._progressIndicator.stop();
                });
                return false;
            }
        },

        /**
         * Updates the display of validation errors on the form.
         *
         * @param {boolean} formSubmit Whether the form is being submitted.
         * @private
         */
        _updateValidationDisplay: function _updateValidationDisplay(formSubmit) {
            // Name field
            if (this._viewModel.get("nameValid")) {
                this.ui.name.parent().removeClass("validation-error");
            } else if (formSubmit) {
                this.ui.name.parent().addClass("validation-error");
            }

            // Password field
            this.ui.password.attr("placeholder", "Choose a password");
            if (this._viewModel.get("passwordValid")) {
                this.ui.password.parent().removeClass("validation-error");
                this.ui.passwordConfirm.parent().removeClass("validation-error");
            } else if (formSubmit) {
                this.ui.password.parent().addClass("validation-error");
            }

            // Password confirm field
            this.ui.passwordConfirm.attr("placeholder", "Retype password");
            if (this._viewModel.get("passwordConfirmValid")) {
                this.ui.password.parent().removeClass("validation-error");
                this.ui.passwordConfirm.parent().removeClass("validation-error");
            } else if (formSubmit) {
                this.ui.passwordConfirm.parent().addClass("validation-error");
            }

            // Password mismatch (only considered on form submit, and if passwords are otherwise valid)
            if (formSubmit && !this._viewModel.get("passwordsMatch") && this._viewModel.get("passwordValid") && this._viewModel.get("passwordConfirmValid")) {
                this.ui.password.parent().addClass("validation-error");
                this.ui.password.attr("placeholder", "Password mismatch");
                this.ui.password.val("");
                this.ui.passwordConfirm.parent().addClass("validation-error");
                this.ui.passwordConfirm.attr("placeholder", "Password mismatch");
                this.ui.passwordConfirm.val("");
                this._viewModel.set({
                    password: "",
                    passwordValid: false,
                    passwordConfirm: "",
                    passwordConfirmValid: false
                });
            }

            // Form valid
            if (this._viewModel.get("valid")) {
                this.ui.logInButton.addClass("valid");
                this.ui.logInButton.removeClass("validation-error");
            } else {
                this.ui.logInButton.removeClass("valid");
                if (formSubmit) {
                    this.ui.logInButton.addClass("validation-error");
                }
            }
        },

        onRender: function onRender() {
            // Bind the form to a registration view model
            this._viewModel = new RegistrationViewModel({
                name: this.model.get("name"),
                email: this.model.get("username")
            });
            this.stickit(this._viewModel, this.viewModelBindings);

            // When a field changes state to valid, ensure the validation error class is removed
            this.listenTo(this._viewModel, "change:nameValid change:passwordValid change:passwordConfirmValid change:valid", function () {
                this._updateValidationDisplay(false);
            });

            // Create the "Ladda" instance - https://github.com/hakimel/Ladda
            this._progressIndicator = Ladda.create(this.ui.logInButton.get(0));

            // Add tooltip for password quality
            Tooltip.add(this.ui.password, {
                width: 230,
                height: 210,
                placement: "right",
                trigger: "focus",
                offset: { align: "right" },
                delay: { hide: 0 },
                html: true,
                duration: -1,
                classes: "password-quality-tooltip",
                content: new PasswordQualityView({ model: this._viewModel })
            });

            this.ui.password.focus();

            var eventProperties = {
                username: this.model.get("username"),
                triggerOrigin: "RegistrationEmailLink"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_REGISTRATION_PAGE, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2794 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h4>A secure password must include:</h4>\n\n<ul>\n    <li class="upper-case">One upper case letter.</li>\n    <li class="lower-case">One lower case letter.</li>\n    <li class="digit">One number.</li>\n    <li class="special-character">One special character.</li>\n    <li class="length">Minimum 8 characters.</li>\n</ul>';

}
return __p
}

/***/ }),
/* 2795 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="registration-view-header">\n    <h1>Welcome to Zmags Creator.</h1><br>\n    <h2>Before we let you in, please set a personal password below. <br>Also, if your name is incorrect, you can change it.</h2>\n</div>\n<div class="registration-view-body">\n    <div class="inner-container">\n        <form id="registration-form">\n            <div class="control-group">\n                <label class="required"><input type="text" class="login-field name-input" placeholder="Write your full name"></label>\n            </div>\n            <div class="control-group">\n                <label class="disabled"><input type="text" class="login-field email-input" readonly></label>\n            </div>\n            <div class="control-group">\n                <label class="required"><input type="password" class="login-field password-input" placeholder="Choose a password" autocapitalize="off"></label>\n            </div>\n            <div class="control-group">\n                <label class="required"><input type="password" class="login-field retype-password-input" placeholder="Retype password" autocapitalize="off"></label>\n            </div>\n            <div class="control-group">\n                <div class="required-label">* Required</div>\n                <label class="remember">\n                    <input type="checkbox" class="persistent-input" value="yes" checked="checked">\n                    <span class="remember-label">Keep me signed in</span>\n                </label>\n            </div>\n            <button class="btn btn-large btn-block btn-login ladda-button" data-size="26" data-style="expand-right"><span class="ladda-label">Log in</span></button>\n        </form>\n    </div>\n</div>\n<div class="registration-view-footer">\n    ';
 if (config.supportEmail) { ;
__p += '\n    <a href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defer = _require.defer;

    var EmailUtil = __webpack_require__(231);
    var ImprovedView = __webpack_require__(6);
    var Login = __webpack_require__(177);
    var PasswordQualityValidator = __webpack_require__(693);
    var PasswordQualityView = __webpack_require__(1185);
    var SequentialButton = __webpack_require__(112);

    var _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank;

    var template = __webpack_require__(2797);
    var ThrottleView = __webpack_require__(692);
    var Tooltip = __webpack_require__(35);
    var ValidateBehavior = __webpack_require__(96);

    var SHAKE_EFFECT_CLASS_NAME = "shake";

    /**
     *
     * @constructor
     *
     * @cfg {String}  resetToken    The reset token.
     * @cfg {Promise} loginDeferred The promise to resolve with logged in princiapl on successful reset.
     */
    return ImprovedView.extend({

        /**
         * @private @type {SequentialButton}
         * The sequential button guarding (throttled) access submitting reset password requests.
         */
        _action: null,
        /**
         * @private @type {ThrottleView}
         * The throttle view handling lockout and displaying lockout messages.
         */
        _throttleView: null,
        /**
         * @private
         * @type {Promise}
         * The promise to resolve on successful reset / sign in.
         */
        _loginDeferred: null,

        template: template,

        className: "reset-password-page pt-page",

        regions: {
            throttleRegion: ".throttle-region",
            defaultFooterRegion: ".default-footer"
        },

        ui: {
            emailInput: ".email-input",
            passwordInput: ".password-input",
            persistent: ".persistent-input",
            resetButton: "button",
            innerContainer: ".inner-container"
        },

        events: {
            "submit form": "_formSubmitHandler"
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                buttonSubmit: "button",
                inputValidation: {
                    ".email-input": {
                        validator: function validator(email) {
                            return EmailUtil.validateEmail(email);
                        },
                        errorText: function errorText(email) {
                            if (this.ui.passwordInput.is(":focus")) {
                                return "";
                            }
                            return email ? "Not a valid email" : "Email required";
                        }
                    },
                    ".password-input": {
                        validator: function validator(password) {
                            return PasswordQualityValidator.isValid(password);
                        },
                        errorText: function errorText(password) {
                            if (this.ui.passwordInput.is(":focus")) {
                                return "";
                            }
                            return password ? "Password is not secure" : "Password required";
                        }
                    },
                    ".retype-password-input": {
                        validator: function validator(password) {
                            return !isBlank(password) && password === this.ui.passwordInput.val(); // passwords must match!
                        },
                        errorText: function errorText(password) {
                            if (this.ui.passwordInput.is(":focus")) {
                                return "";
                            }
                            return !isBlank(password) ? "Passwords do not match" : "Password confirmation required";
                        }
                    }
                }
            }
        },

        transitions: {
            "in": "pt-page-scaleUp",
            out: "pt-page-scaleDown"
        },

        _formSubmitHandler: function _formSubmitHandler(event) {
            // Stop form submitting normally...
            event.preventDefault();
            this._action();
            return false;
        },
        _reset: function _reset() {
            var _this = this;

            // Update the display of validation errors and break out if the form is invalid...
            if (!this.inputValidation()) {
                return false;
            }

            var _ui = this.ui,
                innerContainer = _ui.innerContainer,
                emailInput = _ui.emailInput,
                passwordInput = _ui.passwordInput,
                persistent = _ui.persistent;


            innerContainer.removeClass(SHAKE_EFFECT_CLASS_NAME);

            // Reset password...
            var promise = Login.resetPassword(this.options.resetToken, emailInput.val(), passwordInput.val(), persistent.val()).done(function (principal) {
                _this._loginDeferred.resolve(principal);
            }).fail(function () {
                innerContainer.addClass(SHAKE_EFFECT_CLASS_NAME);
            });

            // Check the response for throttling status code...
            return this._throttleView.checkPromise(emailInput.val(), promise);
        },
        initialize: function initialize() {
            this._loginDeferred = this.options.loginDeferred;
        },
        onRender: function onRender() {
            var _ui2 = this.ui,
                resetButton = _ui2.resetButton,
                passwordInput = _ui2.passwordInput,
                emailInput = _ui2.emailInput;


            this._action = SequentialButton.add(resetButton, this._reset.bind(this), true, true);

            // Add tooltip for password quality. We do a manual trigger to ensure we only bother the user with the
            // tooltip while writing and while invalid...
            var tooltip = Tooltip.add(passwordInput, {
                width: 230,
                height: 210,
                placement: "right",
                trigger: "manual",
                offset: { align: "right" },
                delay: { hide: 0 },
                html: true,
                duration: -1,
                classes: "password-quality-tooltip",
                title: false, // to avoid conflict with input validation that uses the title...
                content: new PasswordQualityView({ element: passwordInput })
            });
            var shown = false;

            // Show password quality tooltip on focus or key up if and only if the password is valid...
            passwordInput.on("focus keyup", function () {
                if (!shown && !PasswordQualityValidator.isValid(passwordInput.val())) {
                    Tooltip.show(tooltip);
                    shown = true;
                }
            });

            // Hide password quality tooltip on blur...
            passwordInput.on("blur", function () {
                Tooltip.hide(tooltip);
                shown = false;
            });

            // Throttle view...
            this._throttleView = new ThrottleView({
                name: "forgot",
                target: emailInput, // entered email = target
                validate: EmailUtil.validateEmail, // make sure we only throttle for valid emails, will not submit otherwise
                button: this._action // disable button during lockout
            });
            this.throttleRegion.show(this._throttleView);

            // Need to defer in order for dom to be ready
            defer(function () {
                emailInput.focus();
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2797 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="reset-password-view">\n    <div class="reset-password-view-inner">\n        <div class="main-logo"></div>\n        <hr>\n        <h4>Please enter your email and new password</h4>\n\n        <div class="inner-container">\n            <form id="reset-form">\n                <input type="text" class="login-field email-input" placeholder="Email address" autocapitalize="off" autofocus>\n                <input type="password" class="login-field password-input" placeholder="New password" autocapitalize="off">\n                <input type="password" class="login-field retype-password-input" placeholder="Retype new password" autocapitalize="off">\n\n                <a href="#" class="sign-in-link" tabindex="-1">To sign in page &gt;</a>\n\n                <label class="remember">\n                    <input type="checkbox" class="persistent-input" value="yes" checked="checked" tabindex="-1">\n                    <span class="remember-label">Keep me signed in</span>\n                </label>\n\n                <button class="reset-password-button btn btn-large btn-block btn-login ladda-button" data-size="26" data-style="expand-right"><span class="ladda-label">Log in</span></button>\n            </form>\n\n            <div class="throttle-region"></div>\n\n        </div>\n\n        <footer>\n            <p>If you did not initiate a request for resetting your Zmags Creator password<br>simply ignore this page and nothing will happen. If you need help, or if you<br>suspect misuse or foul play, please contact Zmags.</p>\n            ';
 if (config.supportEmail) { ;
__p += '\n                <a class="support-link" href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>\n            ';
 } ;
__p += '\n\n            <div class="default-footer"></div>\n        </footer>\n    </div>\n</section>\n';

}
return __p
}

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var EmailUtil = __webpack_require__(231);
    var ImprovedView = __webpack_require__(6);
    var Login = __webpack_require__(177);
    var template = __webpack_require__(2799);
    var SequentialButton = __webpack_require__(112);
    var ThrottleView = __webpack_require__(692);
    var ValidateBehavior = __webpack_require__(96);

    var SHAKE_EFFECT_CLASS_NAME = "shake";

    /**
     * The sign in view.
     *
     * @class SignInView
     * @constructor
     *
     * @cfg {String} email The (read-only) username/email possibly entered in the login view.
     */
    return ImprovedView.extend({

        /**
         * @private @type {SequentialButton}
         * The sequential button guarding (throttled) access submitting forgot password requests.
         */
        _action: null,
        /**
         * @private @type {ThrottleView}
         * The throttle view handling lockout and displaying lockout messages.
         */
        _throttleView: null,

        template: template,

        className: "forgot-password-page pt-page",

        regions: {
            throttleRegion: ".throttle-region",
            defaultFooterRegion: ".default-footer"
        },

        ui: {
            emailInput: ".email-input",
            forgotForm: ".forgot-form",
            signInButton: ".sign-in-button",
            innerContainer: ".inner-container",
            sendSuccess: ".send-success",
            backLink: ".back-home"
        },

        events: {
            "submit @ui.forgotForm": "_forgotFormSubmitHandler",
            "focus @ui.emailInput": "_emailHandler",
            "keydown @ui.emailInput": "_emailHandler",
            "click @ui.backLink": "_backLinkClickHandler"
        },

        transitions: {
            "in": "pt-page-scaleUp",
            out: "pt-page-scaleDown"
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                buttonSubmit: ".sign-in-button",
                inputValidation: {
                    ".email-input": {
                        validator: function validator(email) {
                            return EmailUtil.validateEmail(email);
                        },
                        errorText: function errorText(email) {
                            if (!email) {
                                return "Email required";
                            } else if (!EmailUtil.validateEmail(email)) {
                                return "Not a valid email";
                            }

                            return "";
                        }
                    }
                }
            }
        },

        _backLinkClickHandler: function _backLinkClickHandler(event) {
            event.preventDefault();
            Backbone.history.history.back();
        },
        _forgotFormSubmitHandler: function _forgotFormSubmitHandler(event) {
            // Stop form from submitting normally
            event.preventDefault();
            this._action();
            return false;
        },
        _emailHandler: function _emailHandler() {
            this.ui.sendSuccess.hide();
        },


        /**
         * @private
         * Submits the forgot password request if and only if the currently entered email is valid.
         *
         * @return {Promise|Boolean} A promise that will resolve in a success message; false will be returned
         *                           immediately if the current email is not valid.
         */
        _forgot: function _forgot() {
            // Sanity check - bail out early...
            if (!this.inputValidation()) {
                return false;
            }

            var _ui = this.ui,
                sendSuccess = _ui.sendSuccess,
                innerContainer = _ui.innerContainer,
                emailInput = _ui.emailInput;


            sendSuccess.hide();
            innerContainer.removeClass(SHAKE_EFFECT_CLASS_NAME);

            var email = emailInput.val();

            // Request forgot password mail...
            var promise = Login.forgotPassword(email).done(function () {
                sendSuccess.show();
            }).fail(function () {
                innerContainer.addClass(SHAKE_EFFECT_CLASS_NAME);
            });

            // Check the response for throttling status code...
            return this._throttleView.checkPromise(email, promise);
        },
        onRender: function onRender() {
            var _ui2 = this.ui,
                signInButton = _ui2.signInButton,
                emailInput = _ui2.emailInput;


            this._action = SequentialButton.add(signInButton, this._forgot.bind(this), true, true);

            // If we have a username set, make it fixed, e.g. for a user already logged in. Does not make sense to
            // allow the user to enter a new username (even though the frontend supports it)...
            if (this.options.username) {
                emailInput.val(this.options.username);
                emailInput.attr("disabled", true);
            }

            // Throttle view...
            this._throttleView = new ThrottleView({
                name: "forgot",
                target: emailInput, // entered email = target
                validate: EmailUtil.validateEmail, // make sure we only throttle for valid emails, will not submit otherwise
                button: this._action // disable button during lockout
            });
            this.throttleRegion.show(this._throttleView);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2799 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="forgot-password-view">\n    <div class="forgot-password-view-inner">\n        <div class="main-logo"></div>\n        <h4>Forgot your password?</h4>\n        <h6>No problem! Enter the email address that you use for Creator and<br>\n            we will send you instructions on how to reset your password.</h6>\n\n        <div class="inner-container">\n            <form class="forgot-form">\n                <div class="control-group">\n                    <input type="text" name="email" class="login-field email-input" placeholder="Email address" autocapitalize="off" autofocus> </br>\n                    <a href="#" class="back-home" tabindex="-1">&lt; Back to sign in page</a>\n                </div>\n                <button class="sign-in-button btn btn-large btn-block btn-login ladda-button" data-size="26" data-style="expand-right">\n                    <span class="ladda-label">Send</span>\n                </button>\n\n                <div class="throttle-region"></div>\n\n                <h6 class="send-success">\n                    <strong>Instructions have been sent.</strong><br>\n                    If you don’t receive an email from us it is most likely because we could not match your email address\n                    with an active Creator user account.\n                    ';
 if (config.supportEmail) { ;
__p += '\n                    If so, please contact <a class="support-link" href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a> for help.\n                    ';
 } ;
__p += '\n                </h6>\n            </form>\n        </div>\n\n        <footer>\n            ';
 if (config.supportEmail) { ;
__p += '\n            <a class="support-link" href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>\n            ';
 } ;
__p += '\n\n            <div class="default-footer"></div>\n        </footer>\n    </div>\n</section>\n';

}
return __p
}

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        template = __webpack_require__(2801);

    return ImprovedView.extend({
        className: "supported-browsers zmags-section",

        transitions: {
            "in": "pt-page-scaleUp",
            out: "pt-page-scaleDown"
        },

        template: template
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2801 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="supported-browsers-inner">\n    <div class="main-logo"></div>\n\n    <h2>Browser Support</h2>\n\n    <div class="supported-browsers-list">\n\n        <h3>You are using an unsupported browser - performance and correctness may suffer!</h3>\n        <p>We recommend the following browsers in order of priority:<br><br></p>\n\n        <div class="pull-left">\n            <b><u>Windows</u>:</b>\n            <b>Microsoft Internet Explorer 11</b>\n            <p>(Drag\'n Drop Bookmarklet not supported)</p>\n            <b>Chrome, latest version</b>\n            <p>(See Creator Community on how to use Drag\'n Drop Bookmarklet)</p>\n            <b>Firefox, <span>latest version</span></b>\n        </div>\n\n        <div class="pull-right">\n            <b><u>Mac OS X</u>:</b>\n            <b>Safari, <span>latest version</span></b>\n            <p>(Drag\'n Drop Bookmarklet not supported)</p>\n            <b>Chrome, latest version</b>\n            <p>(Drag\'n Drop Bookmarklet not supported)</p>\n            <b>Firefox, <span>latest version</span></b>\n        </div>\n    </div>\n\n    <a href="#" class="back-to-sign-in">&lt; Back to Login Page</a>\n\n    ';
 if (config.supportEmail) { ;
__p += '\n        <div class="support-link">\n            <a href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>\n        </div>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var NavBarView = __webpack_require__(461),
        template = __webpack_require__(2809);

    /**
     * The nav bar view for the sign in page: an empty space, void of information.
     *
     * @class SignInNavBarView
     * @constructor
     */
    return NavBarView.extend({

        template: template,

        className: "sign-in-nav-bar"

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        Configuration = __webpack_require__(27),
        CompanyState = __webpack_require__(242),
        ConfirmationManager = __webpack_require__(339),
        EditorEvents = __webpack_require__(17),
        ImprovedView = __webpack_require__(6),
        LoggedInUserState = __webpack_require__(19),
        template = __webpack_require__(2804),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        Permissions = __webpack_require__(22),
        Tooltip = __webpack_require__(35),
        tooltipTemplate = __webpack_require__(2805),
        LoggedIn = __webpack_require__(31),
        MD5 = __webpack_require__(694);

    Storage = __webpack_require__(34);

    var log = new Logger("CurrentPrincipal");
    var zsitesHTML = "Manage Microsites";
    var experienceExportHTML = "Experience Export";

    /**
     * The nav bar subview for the options relating to the current principal.
     *
     * @class NavBarCurrentPrincipalView
     * @constructor
     *
     * @cfg {Principal} The principal to display the view for.
     */
    return ImprovedView.extend({

        className: "nav-bar-current-principal-view",

        template: template,

        zsitesHTML: "Manage Microsites",

        experienceExportHTML: "Experience Export",

        templateHelpers: function templateHelpers() {
            // On AD login, the principal role is the AD role, but the user may still be coerced into Spectator on
            // inactive company. This is only to display the roles visually, nothing to do with the actual permission checks...
            var user = this.model.get("user");
            var type = this.model.get("type");
            var integrations = LoggedInUserState.get("integrations");
            var settings = LoggedInUserState.get("companySettings");
            var userRole = type === "AD" && (this.model.get("state") !== CompanyState.ACTIVE || !user.isConfirmed()) ? Permissions.Roles.SPECTATOR : user.get("role");

            return {
                principalName: this.model.get("displayName"), // principal display name
                principalRole: this.model.get("role").name, // principal role, i.e. active role!
                type: type, // AD, ReadOnly, or Normal
                userName: user.get("displayName"), // user display name
                userRole: userRole.name, // (coerced) user role
                unconfirmed: !user.isConfirmed(), // true for unconfirmed user
                fontsIntegrationEnabled: integrations.fontIntegrationsEnabled(),
                zsitesEnabled: integrations.isZSitesEnabled(),
                zsitesHTML: zsitesHTML,
                experienceExportHTML: experienceExportHTML,
                experienceExportEnabled: settings.get("exportingExperiencesEnabled") && (userRole === Permissions.Roles.SITEMANAGER || type === "LDAP"),
                designFileUIEnabled: settings.get("designFileUIEnabled"),
                newDashboardExperience: (0, _C3Utils.isC3Experience)()
            };
        },

        ui: {
            helpLink: ".help-link",
            guidedTourNavIcon: ".guided-tour-nav-icon",
            resendConfirmation: ".resend-confirmation",
            username: ".mini-profile .name",
            navigationLinks: ".nav-dropdown a",
            zsitesLink: ".icon-microsites"
        },

        events: {
            "click @ui.helpLink": function clickUiHelpLink() {
                var eventProperties = {
                    projectId: this.options.project && this.options.project.get("id"),
                    triggerOrigin: "HelpLinkButton"
                };

                EditorEvents.trigger(EditorEvents.constants.OPEN_HELP_LINK, eventProperties);
            },

            "click @ui.resendConfirmation": function clickUiResendConfirmation(event) {
                event.preventDefault();
                ConfirmationManager.requestConfirmationInfo(true);
            },

            "click @ui.navigationLinks": function clickUiNavigationLinks(event) {
                if (!event.currentTarget.innerHTML.includes(zsitesHTML)) {
                    this.trigger("navigation", event);
                }
            },

            "click @ui.zsitesLink": "_postZSites"
        },

        _postZSites: function _postZSites() {
            // We rename this clientId because it's clientId in the matomo code and it makes debugging md5 hashes easier
            var clientId = LoggedIn.principal().get("companyId");
            var email = LoggedIn.principal().get("user.username");
            var clientName = LoggedIn.principal().get("user.name");
            var secret = Configuration.zsitesSecret;
            var zsites = "zsites";
            var list = "list";
            var settings = LoggedInUserState.get("companySettings");
            var zsiteVanityUrlsEnabled = settings.get("zsiteVanityUrlsEnabled");
            var zsiteVanityUrlMaxCount = settings.get("zsiteVanityUrlMaxCount");
            var zsiteNonVanityUrlMaxCount = settings.get("zsiteNonVanityUrlMaxCount");

            var experienceId = "";
            if (this.options.experienceId) {
                experienceId = this.options.experienceId;
            }
            $.post(Configuration.zsitesConfig, {
                mode: zsites,
                action: list,
                companyId: clientId,
                email: email,
                clientName: clientName,
                experienceId: experienceId,
                key: MD5(zsites + list + clientId + clientName + email + experienceId + secret),
                a: zsiteVanityUrlsEnabled,
                b: zsiteVanityUrlMaxCount,
                c: zsiteNonVanityUrlMaxCount
            }, function (data) {
                window.open(data, "_blank");
            });
        },

        onRender: function onRender() {
            this.ui.guidedTourNavIcon.css("display", "inline-block");

            this.stickit(LoggedInUserState, this.supportLinkBinding);

            // Show company info tooltip on AD/internal login so we can easily get company id, name, etc.
            var principal = this.model;

            if (principal.get("type") === "AD" || principal.get("internal")) {
                var company = LoggedInUserState.get("company"),
                    settings = LoggedInUserState.get("companySettings"),
                    integrations = LoggedInUserState.get("integrations"),
                    user = LoggedInUserState.get("user"),
                    flip = false;

                Tooltip.add(this.ui.username, {
                    html: true,
                    content: function content() {
                        // This is because the tooltip plugin calls the function twice: to determine if it has any
                        // content, then to get the content... :/
                        flip = !flip;

                        if (flip) {
                            log.info("Principal:", principal.toString(), "->", user.toString(), principal);
                            log.info("Company:  ", company.toString(), company);
                            log.info("Settings: ", settings.toString(), settings);
                        }

                        return tooltipTemplate({
                            company: company.toJSON(),
                            settings: settings.toJSON(),
                            userId: user.get("id"),
                            fontIntegrationsEnabled: integrations.fontIntegrationsEnabled(),
                            zsitesEnabled: integrations.isZSitesEnabled()
                        });
                    },

                    placement: "left",
                    duration: 0,
                    delay: { show: 1000, hide: 0 }
                });
            }
        },

        onClose: function onClose() {
            if (this.model.get("type") === "AD") {
                Tooltip.remove(this.ui.username);
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2804 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- Dropdown -->\n<div class="nav-dropdown-container';
 if (userRole !== 'Spectator' && (unconfirmed || type === 'ReadOnly')) {;
__p += ' action';
};
__p += '">\n    <span class="action-indicator">&excl;</span>\n    <div class="nav-dropdown">\n        <div class="mini-profile">\n            <div class="name">' +
__e( userName ) +
'\n                ';
 if (userName !== principalName) {;
__p += '<span class="principal"> (' +
__e(principalName) +
')</span>';
 } ;
__p += '\n            </div>\n            <div class="role">\n                ';
 if (userRole === principalRole) {;
__p +=
__e( userRole );
 } else {;
__p += '<span class="inactive">' +
__e( userRole ) +
'</span>';
 };
__p += '\n                ';
 if (userRole !== principalRole || type === "AD") {;
__p += '<span class="principal"> (' +
__e(principalRole) +
')</span>';
 } ;
__p += '\n            </div>\n            ';
 if (unconfirmed) {;
__p += '\n            <a class="settings-item icon-sign-in resend-confirmation ' +
__e( userRole ) +
'" href="#user/requestConfirmEmail">Confirm Your Identity</a>\n            ';
 } else if (type === "ReadOnly") {;
__p += '\n            <a class="settings-item icon-sign-in sign-in-again ' +
__e( userRole ) +
'" href="#login">Sign In Again</a>\n            ';
 } ;
__p += '\n            <a class="settings-item icon-log-out" href="#logout">Sign Out</a>\n            <hr>\n        </div>\n        <a class="settings-item icon-stats" href="#analytics">Set Up Analytics</a>\n        ';
 if (fontsIntegrationEnabled) { ;
__p += '\n        <a class="settings-item icon-fonts" href="#fonts">Set Up Fonts</a>\n        ';
 } ;
__p += '\n        <a class="settings-item icon-integrations" href="#integrations">Set Up Integrations</a>\n        ';
 if (designFileUIEnabled && !newDashboardExperience) { ;
__p += '\n        <a class="settings-item icon-psd-import" href="#designtransform">Transform Design File</a>\n        ';
 } ;
__p += '\n        <a class="settings-item icon-breakpoints" href="#breakpoints">Set Up Breakpoints</a>\n        ';
 if (zsitesEnabled) { ;
__p += '\n        <a class="settings-item icon-microsites">' +
((__t = ( zsitesHTML )) == null ? '' : __t) +
'</a>\n        ';
 } ;
__p += '\n        ';
 if (experienceExportEnabled) { ;
__p += '\n        <a class="settings-item icon-stats" href="#export" >' +
((__t = ( experienceExportHTML )) == null ? '' : __t) +
'</a>\n        ';
 } ;
__p += '\n        <a class="settings-item icon-manage-account" href="#manageAccount">Manage Account</a>\n\n    </div>\n</div>\n<!-- / Dropdown -->\n\n<a class="help-link" href="' +
__e( config.communityBaseUrl ) +
'/hc/en-us/requests/new" target="_blank" class="nav-item-settings">Help</a>\n\n<div class="guided-tour-nav">\n    <span class="guided-tour-nav-icon">Guide</span>\n</div>\n\n';

}
return __p
}

/***/ }),
/* 2805 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<strong>User id</strong>: ' +
__e( userId ) +
'\n<br><strong>Company id</strong>: ' +
__e( company.id ) +
'\n';
 if (company.id !== settings.id) { ;
__p += '\n    <br><strong>Settings id</strong>: ' +
__e( settings.id ) +
';\n';
 } ;
__p += '\n\n<br><strong>Company</strong>: ' +
__e( company.name ) +
'\n<br><strong>SalesForceId</strong>: ' +
__e( company.salesForceId ) +
'\n<br><strong>Internal</strong>: ' +
__e( company.internal ) +
'\n<br><strong>State</strong>: ' +
__e( company.state ) +
'\n<br><strong>Bundle strategy</strong>: ' +
__e( settings.bundleStrategy && settings.bundleStrategy.name || "Standard" ) +
'\n<br><strong>Font integrations enabled</strong>: ' +
__e( fontIntegrationsEnabled ? "Enabled" : "Disabled" );

}
return __p
}

/***/ }),
/* 2806 */
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),
/* 2807 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 2808 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="nav-bar">\n    <div class="' +
__e( newDashboardExperience ? "fastr-frontend-logo-container" : "logo-container" ) +
'">\n        <a href="' +
__e( newDashboardExperience ? config.contentControlUrl : "#" ) +
'" class="logo"></a>\n    </div>\n    ';
 if (!newDashboardExperience) { ;
__p += '\n    <div class="project-buttons-container">\n        <div class="project-selector-btn';
 if (currentProject) { ;
__p += ' in-project-context';
 } ;
__p += '">\n            <div class="project-btn-icon"></div>\n            <div class="project-btn-txt">Projects</div>\n        </div>\n        ';
 if (currentProject) { ;
__p += '\n            <a class="project-context-btn" href="#project/' +
__e( currentProjectId ) +
'">' +
__e( currentProjectName ) +
'</a>\n        ';
 } ;
__p += '\n    </div>\n    ';
 } ;
__p += '\n    <div class="spacer"></div>\n    <div class="spinner" data-spinner-color="#000" data-spinner-size="20">\n        <div class="ladda-label"></div>\n    </div>\n    <div class="current-principal"></div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2809 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="icon"></div>';

}
return __p
}

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CompanyModel = __webpack_require__(2811),
        CompanySettings = __webpack_require__(1027),
        IntegrationCollection = __webpack_require__(2812),
        LoggedInUserState = __webpack_require__(19),
        ProjectMetadataCollection = __webpack_require__(2821),
        Promise = __webpack_require__(21),
        PrototypeActionCollection = __webpack_require__(2826),
        PrototypeWidgetCollection = __webpack_require__(2827),
        Time = __webpack_require__(121);

    /**
     * A <i>loader</i> for all global data to be loaded/cached before the user logs in the first time. <p>
     *
     * Based on the options supplied to <tt>loginUserFromPrincipal(principal, options)</tt>, relevant data will be
     * fetched, and the returned promise will resolve once all such data has loaded. <p>
     *
     * Do no use this class directly, already called where it needs to be called! Simply use <tt>LoggedInUserState</tt>
     * to listen for/use the data instead.
     *
     * @class LoggedInUserStateLoader
     */
    return {

        /**
         * Loads all data for the user associated with the specified principal, returning a promise that resolves
         * when all data is loaded. <p>
         *
         * Options have the following format:
         * <pre>
         *     {
         *         // Options to load the ExperienceMetadataCollection by, defaulting to {includeMeasureData: true}
         *         experiences:  {
         *              includeMeasureData: Boolean, // include measure data    (default false)
         *              pushedOnly:         Boolean  // only pushed experiences (default false)
         *         },
         *         images: Boolean, // load global image collection (default false)
         *     }
         * </pre>
         *
         * @param   {Principal} principal The principal for the user in question; never null.
         * @param   {*}         [options] The options describing what user state to load here; will default.
         * @returns {Promise} A promise that resolves when all user data is loaded.
         */
        load: function load(principal, options) {
            // Set the user, but don't set the ready flag yet if different user...
            var user = principal.get("user"),
                companyId = user.get("companyId");

            // Already ready, i.e. data has already been fetched? Same company means data is ready...
            if (LoggedInUserState.get("ready")) {
                if (LoggedInUserState.get("user").get("companyId") !== companyId) {
                    LoggedInUserState.clear();
                } else {
                    LoggedInUserState.setUser(user);

                    return Promise.resolved(); // do not fire ready again, since only user changed...
                }
            }

            // First time, or different company...
            LoggedInUserState.setUser(user);

            options = options || {};

            // Fetch company model and global collections
            var company = new CompanyModel({ id: companyId }),
                companySettings = new CompanySettings({ companyId: companyId }),
                projectMetadataCollection = new ProjectMetadataCollection(),
                // optionally loaded
            prototypeActionCollection = new PrototypeActionCollection([], { companyId: companyId }),
                prototypeWidgetCollection = new PrototypeWidgetCollection([], { companyId: companyId }),
                integrations = new IntegrationCollection([], { companyId: companyId });

            var promises = [company.fetch(), companySettings.fetch(), integrations.fetch(), prototypeActionCollection.fetch(), prototypeWidgetCollection.fetch()];

            // Update server time in the background, no need to wait for it...
            Time.update();

            // When global collections are done loading, set them with the logged in flag
            return Promise.all(promises).done(function () {
                LoggedInUserState.set({
                    company: company,
                    companySettings: companySettings,
                    integrations: integrations,
                    prototypeActionCollection: prototypeActionCollection,
                    prototypeWidgetCollection: prototypeWidgetCollection
                });

                if ((typeof options.projects === "undefined" || options.projects) && !(0, _C3Utils.isC3Experience)()) {
                    promises.push(projectMetadataCollection.fetch().then(function () {
                        var projects = projectMetadataCollection.projects();
                        LoggedInUserState.set({
                            projects: projects,
                            ready: true
                        });
                    }));
                } else {
                    LoggedInUserState.set({
                        ready: true
                    });
                }

                var loggedInUser = LoggedInUserState.get("user");

                var pendoData = {
                    visitor: {
                        id: principal.get("userId"),
                        // We call the field username even though it is their email
                        username: loggedInUser.get("username"),
                        role: loggedInUser.get("role").name,
                        lastAccessed: new Date(loggedInUser.get("accessedAt")).toISOString(),
                        acctCreated: new Date(loggedInUser.get("createdAt")).toISOString(),
                        platform: "creator"
                    },

                    account: {
                        id: principal.get("user").get("companyId"),
                        companyName: LoggedInUserState.get("company").get("name")
                    }
                };

                if (window.pendo) {
                    window.pendo.initialize(pendoData);
                }
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(7),
        Model = _require.Model;

    var LoggedInUserState = __webpack_require__(19);
    var CompanyState = __webpack_require__(242);
    var RestApi = __webpack_require__(29);

    /**
     * Company model.
     *
     * @class CompanyModel
     * @constructor
     */
    var CompanyModel = Model.extend({ // TODO: why is the state not mapped?

        defaults: {
            name: null
        },

        url: function url() {
            var id = this.get("id") || LoggedInUserState.get("principal").get("companyId");
            return RestApi.pathToSpecificResource(RestApi.Collections.COMPANIES, id);
        },
        toString: function toString() {
            return "Company[id: " + this.get("id") + "; name: " + this.get("name") + "]";
        }
    }, {
        State: CompanyState
    });

    return CompanyModel;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var PolymorphicCollection = __webpack_require__(300);
    var IntegrationModel = __webpack_require__(127);
    var Preconditions = __webpack_require__(14);
    var AmazonRekognitionIntegrationModel = __webpack_require__(2813);
    var NativeContentIntegrationModel = __webpack_require__(2814);
    var ThumbnailsNativeContentIntegrationModel = __webpack_require__(2815);
    var ThumbnailsImageDashboardIntegrationModel = __webpack_require__(2816);
    var MatomoReportingDashboardLinkVisibleModel = __webpack_require__(2817);
    var EventCollectionUsesMatomoModel = __webpack_require__(2818);
    var FontIntegrationModel = __webpack_require__(404);
    var CustomFontIntegrationModel = __webpack_require__(562);
    var TypekitIntegrationModel = __webpack_require__(407);
    var FontsDotComIntegrationModel = __webpack_require__(403);
    var Scene7IntegrationModel = __webpack_require__(1187);
    var InventoryTaggingModel = __webpack_require__(2819);
    var ZSitesModel = __webpack_require__(2820);
    var RestApi = __webpack_require__(29);

    /**
     * A collection of IntegrationModels.
     *
     * @see IntegrationModel
     *
     * @class IntegrationCollection
     */
    var IntegrationCollection = PolymorphicCollection.extend("IntegrationCollection", {

        companyId: null,
        defaultModelType: IntegrationModel,

        constructor: function constructor(attrs, options) {
            this.__super(attrs, options);

            if (!(options && options.companyId)) {
                Preconditions.fail("options.companyId has to be defined.");
            }
            this.companyId = options.companyId;
            this.options = options;
        },


        modelTypes: function modelTypes() {
            var _ref;

            return _ref = {}, _defineProperty(_ref, CustomFontIntegrationModel.type, CustomFontIntegrationModel), _defineProperty(_ref, TypekitIntegrationModel.type, TypekitIntegrationModel), _defineProperty(_ref, FontsDotComIntegrationModel.type, FontsDotComIntegrationModel), _defineProperty(_ref, AmazonRekognitionIntegrationModel.type, AmazonRekognitionIntegrationModel), _defineProperty(_ref, Scene7IntegrationModel.type, Scene7IntegrationModel), _defineProperty(_ref, NativeContentIntegrationModel.type, NativeContentIntegrationModel), _defineProperty(_ref, ThumbnailsNativeContentIntegrationModel.type, ThumbnailsNativeContentIntegrationModel), _defineProperty(_ref, ThumbnailsImageDashboardIntegrationModel.type, ThumbnailsImageDashboardIntegrationModel), _defineProperty(_ref, MatomoReportingDashboardLinkVisibleModel.type, MatomoReportingDashboardLinkVisibleModel), _defineProperty(_ref, EventCollectionUsesMatomoModel.type, EventCollectionUsesMatomoModel), _defineProperty(_ref, InventoryTaggingModel.type, InventoryTaggingModel), _defineProperty(_ref, ZSitesModel.type, ZSitesModel), _ref;
        },

        url: function url() {
            // "/api/companies/{companyId}/integrations"
            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, this.companyId, RestApi.Collections.INTEGRATIONS);
        },
        byClass: function byClass(integrationClass) {
            return this.filter(function (integration) {
                return integration instanceof integrationClass;
            });
        },
        getIntegration: function getIntegration(integrationClass) {
            return this.byClass(integrationClass)[0];
        },
        fontIntegrationsEnabled: function fontIntegrationsEnabled() {
            return !!this.fontIntegrations().length;
        },
        imageRekognitionIntegrationsEnabled: function imageRekognitionIntegrationsEnabled() {
            return this.getIntegration(AmazonRekognitionIntegrationModel) !== undefined;
        },
        isNativeContentIntegrationsEnabled: function isNativeContentIntegrationsEnabled() {
            return this.getIntegration(NativeContentIntegrationModel) !== undefined;
        },
        isThumbnailsImageIntegrationsEnabled: function isThumbnailsImageIntegrationsEnabled() {
            return this.getIntegration(ThumbnailsImageDashboardIntegrationModel) !== undefined;
        },
        isThumbnailsNativeContentIntegrationsEnabled: function isThumbnailsNativeContentIntegrationsEnabled() {
            return this.getIntegration(ThumbnailsNativeContentIntegrationModel) !== undefined;
        },
        isMatomoReportingDashboardLinkVisibleIntegrationsEnabled: function isMatomoReportingDashboardLinkVisibleIntegrationsEnabled() {
            return this.getIntegration(MatomoReportingDashboardLinkVisibleModel) !== undefined;
        },
        isEventCollectionUsesMatomoIntegrationsEnabled: function isEventCollectionUsesMatomoIntegrationsEnabled() {
            return this.getIntegration(EventCollectionUsesMatomoModel) !== undefined;
        },
        isInventoryEnabled: function isInventoryEnabled() {
            return this.getIntegration(InventoryTaggingModel) !== undefined;
        },
        isZSitesEnabled: function isZSitesEnabled() {
            return this.getIntegration(ZSitesModel) !== undefined;
        },


        /**
         * Checks if the integration is authorized, meaning that client entered correct credentials in the settings.
         * We only check username because the backend API does not return a password, but we know that a username is set only if credentials were correct.
         *
         * @returns {boolean} True if the integration is authorized.
         */
        isScene7IntegrationAuthorized: function isScene7IntegrationAuthorized() {
            var scene7Integration = this.getIntegration(Scene7IntegrationModel);
            return Boolean(scene7Integration && scene7Integration.get("username"));
        },


        /**
         * Checks if the integration has been enabled for the client. Currently is only possible from Zelp.
         *
         * @returns {boolean} True if the integration is enabled.
         */
        isScene7IntegrationEnabled: function isScene7IntegrationEnabled() {
            return this.getIntegration(Scene7IntegrationModel) !== undefined;
        },
        getImageSourceTypeServingUrl: function getImageSourceTypeServingUrl(sourceTypeName) {
            var sourceTypeIntegration = this.modelTypes()[sourceTypeName];
            var sourceTypeModel = sourceTypeIntegration && this.find(function (model) {
                return model instanceof sourceTypeIntegration;
            });
            return sourceTypeModel && sourceTypeModel.get("imageServingUrl");
        },


        /**
         * @return {FontIntegrationModel[]}
         */
        fontIntegrations: function fontIntegrations() {
            return this.byClass(FontIntegrationModel);
        }
    });

    return IntegrationCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var IntegrationModel = __webpack_require__(127);

    /**
     * Amazon Rekognition integration model.
     *
     * @class AmazonRekognitionIntegrationModel
     */
    return IntegrationModel.extend("AmazonRekognitionIntegration", {

        defaults: {
            minConfidence: null
        }

    }, {
        type: "AmazonRekognitionIntegration"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var IntegrationModel = __webpack_require__(127);

    /**
     * Marker class for CNC integrations.
     *
     * @class NativeContentIntegration
     */
    return IntegrationModel.extend("NativeContentIntegration", {}, {
        type: "NativeContentIntegration"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var IntegrationModel = __webpack_require__(127);

    /**
     * Marker class for Thumbnails genereated via CNC integration.
     *
     * @class ThumbnailsNativeContentIntegration
     */
    return IntegrationModel.extend("ThumbnailsNativeContentIntegration", {}, {
        type: "ThumbnailsNativeContentIntegration"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var IntegrationModel = __webpack_require__(127);

    /**
     * Marker class for Thumbnails generated third party image service.
     *
     * @class ThumbnailsImageDashboardIntegration
     */
    return IntegrationModel.extend("ThumbnailsImageDashboardIntegration", {}, {
        type: "ThumbnailsImageDashboardIntegration"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var IntegrationModel = __webpack_require__(127);

    /**
     * Marker class for Matomo Reporting Dashboard Link Visible.
     *
     * @class MatomoReportingDashboardLinkVisibleIntegration
     */
    return IntegrationModel.extend("MatomoReportingDashboardLinkVisibleIntegration", {}, {
        type: "MatomoReportingDashboardLinkVisibleIntegration"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var IntegrationModel = __webpack_require__(127);

    /**
     * Marker class for Event Collection Uses Matomo.
     *
     * @class EventCollectionUsesMatomoIntegration
     */
    return IntegrationModel.extend("EventCollectionUsesMatomoIntegration", {}, {
        type: "EventCollectionUsesMatomoIntegration"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var IntegrationModel = __webpack_require__(127);

    /**
     * Marker class for Enabling Inventory.
     *
     * @class InventoryIntegration
     */
    return IntegrationModel.extend("InventoryIntegration", {}, {
        type: "InventoryTagging"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var IntegrationModel = __webpack_require__(127);

    /**
     * Marker class for Enabling ZSites.
     *
     * @class ZSites
     */
    return IntegrationModel.extend("ZSitesEnabled", {}, {
        type: "ZSitesEnabled"
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ProjectMetadata = __webpack_require__(2822),
        ProjectCollection = __webpack_require__(2825),
        UrlUtil = __webpack_require__(46),
        RestApi = __webpack_require__(29),
        Configuration = __webpack_require__(27),
        LoggedInUserState = __webpack_require__(19);

    /**
     * A collection of project meta data.
     *
     * @class ProjectMetadataCollection
     * @constructor
     * @author Poul Henriksen
     */
    return Backbone.Collection.extend({

        model: function model(attrs) {
            return new ProjectMetadata(attrs);
        },

        options: null,

        initialize: function initialize(attrs, options) {
            this.options = options;
        },

        url: function url() {
            var isUserPermissionsEnabled = LoggedInUserState.get("companySettings").get("userPermissionsEnabled");
            var baseURL = isUserPermissionsEnabled ? Configuration.msExperiencesUrl + "/api/projects/meta/" : RestApi.pathToCollection(RestApi.Collections.PROJECTS_META);
            return this.options ? UrlUtil.appendParamObject(baseURL, this.options) : baseURL;
        },

        projects: function projects() {
            return new ProjectCollection(this.map(function (projectMetadata) {
                return projectMetadata.get("model");
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ImprovedModel = __webpack_require__(25),
        ProjectModel = __webpack_require__(695);

    /**
     * The project meta data.
     *
     * @class ProjectMetadata
     * @constructor
     * @author Poul Henriksen
     */
    return ImprovedModel.extend("Project Metadata", { // Still uses the project distinguished name!

        defaults: {
            project: null
        },

        relations: [{
            type: Backbone.One,
            key: "project",
            relatedModel: ProjectModel
        }],

        _distinguishedName: function _distinguishedName() {
            var project = this.get("project");

            return project && project._distinguishedName();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ContentCollection = __webpack_require__(463);
    var RestApi = __webpack_require__(29);
    var UrlUtil = __webpack_require__(46);
    var SyncManager = __webpack_require__(44);

    /**
     * Represents a content collection of publishables (experiences and/or groups), supporting "lazy loading".
     *
     * @see  ContentCollection
     * @class PublishableCollection
     */
    return ContentCollection.extend("PublishableCollection", {
        url: function url() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var project = options.project;
            var maxScenes = options.maxScenes;

            var baseUrl = RestApi.pathToCollection(RestApi.Collections.PUBLISHABLES);

            if (project) {
                baseUrl = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.PUBLISHABLES);
            }

            // maxScenes null means fetching all scenes.
            if (maxScenes !== undefined && maxScenes !== null) {
                return UrlUtil.appendParamObject(baseUrl, { maxScenes: maxScenes });
            }

            return baseUrl;
        }
    }, {
        count: function count() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var project = options.project;
            var target = SyncManager.target("PublishableCollection.count");
            var url = void 0;

            if (project) {
                url = RestApi.pathToCollectionOnResource(RestApi.Collections.PROJECTS, project.get("id"), RestApi.Collections.PUBLISHABLES_COUNT);
            } else {
                url = RestApi.pathToCollection(RestApi.Collections.PUBLISHABLES_COUNT);
            }

            return SyncManager.get(url, target);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ProjectAsset = __webpack_require__(283);

    /**
     * A collection of project assets.
     *
     * @see ProjectAsset
     *
     * @class ProjectAssetCollection
     */
    return Backbone.Collection.extend({

        model: ProjectAsset,

        /**
         * Adds a project asset describing the supplied model to this collection. <p>
         *
         * If <tt>model</tt> cannot be described as an asset, this will be a no-op.
         *
         * @param {*} model The Backbone model to add as an asset to this collection; cannot be falsey.
         * @return {Boolean} True if an asset was added, false otherwise.
         *
         * @see    #removeModel
         * @see    #addResource
         */
        addModel: function addModel(model) {
            var asset = ProjectAsset.asAsset(model);

            if (asset) {
                return this.add(asset);
            }

            return false;
        },

        /**
         * Remove the project asset describing the supplied model from this collection, if contained. <p>
         *
         * If <tt>model</tt> cannot be described as an asset, this will be a no-op.
         *
         * @param {*} model The Backbone model to remove the existing asset from this collection, if any; cannot
         *                  be falsey.
         * @return {Boolean} True if an asset was remove, false otherwise.
         *
         * @see    #addModel
         * @see    #removeResource
         */
        removeModel: function removeModel(model) {
            var asset = ProjectAsset.asAsset(model);

            if (asset) {
                return this.remove(asset); // TODO: does this work?
            }

            return false;
        },

        addResource: function addResource(id, type) {
            this.add(new ProjectAsset({ resourceId: id, resourceType: type }));
        },

        removeResource: function removeResource(id, type) {
            return this.remove(this.findWhere({
                resourceId: id,
                resourceType: type
            }));
        },

        byType: function byType(type) {
            return this.filter(function (asset) {
                return asset.get("resourceType") === type;
            });
        },

        /**
         * Given an image id, check whether it is contained in this collection
         *
         * @param {String} resourceId   The id of an image model
         * @returns {Boolean}   True if it is in the collection, false otherwise
         */
        containsImage: function containsImage(resourceId) {
            return this._containsResource(resourceId);
        },

        /**
         * Given an experience id, check whether it is contained in this collection
         *
         * @param {String} resourceId   The id of an experience model
         * @returns {Boolean}   True if it is in the collection, false otherwise
         */
        containsExperience: function containsExperience(resourceId) {
            return this._containsResource(resourceId);
        },

        /**
         * Given a group id, check whether it is contained in this collection
         *
         * @param {String} resourceId   The id of an group model
         * @returns {Boolean} True if it is in the collection, false otherwise
         */
        containsGroup: function containsGroup(resourceId) {
            return this._containsResource(resourceId);
        },

        /**
         * Given an channel id, check whether it is contained in this collection
         *
         * @param {String} resourceId   The id of an channel model
         * @returns {Boolean}   True if it is in the collection, false otherwise
         */
        containsChannel: function containsChannel(resourceId) {
            return this._containsResource(resourceId);
        },

        // Check a resource is contained in the collection
        _containsResource: function _containsResource(resourceId) {
            return !!this.find(function (asset) {
                return asset.get("resourceId") === resourceId;
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ProjectModel = __webpack_require__(695),
        RestApi = __webpack_require__(29);

    /**
     * A collection of <tt>ProjectModel</tt>'s.
     *
     * @see ProjectModel
     *
     * @class ProjectCollection
     */
    return Backbone.Collection.extend({

        model: ProjectModel,

        url: function url() {
            return RestApi.pathToCollection(RestApi.Collections.PROJECTS);
        },

        byExperienceId: function byExperienceId(experienceId) {
            return this.find(function (project) {
                return project.containsExperience(experienceId);
            });
        },

        /**
         * @return {ProjectModel}
         */
        byExperience: function byExperience(experience) {
            return this.byExperienceId(experience.get("id"));
        },

        /**
         * @return {ProjectModel}
         */
        byGroupId: function byGroupId(groupId) {
            return this.find(function (project) {
                return project.containsGroup(groupId);
            });
        },

        byGroup: function byGroup(group) {
            return this.byGroupId(group.get("id"));
        },

        /**
         * @return {ProjectModel[]}
         */
        byImage: function byImage(image) {
            return this.filter(function (project) {
                return project.containsImage(image.get("id"));
            });
        },

        containsExperience: function containsExperience(experience) {
            return this.byExperience(experience) !== undefined;
        },

        byChannel: function byChannel(channel) {
            return this.filter(function (project) {
                return project.containsChannel(channel.get("id"));
            });
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        PrototypeAction = __webpack_require__(1189),
        RestApi = __webpack_require__(29);

    /**
     * Collection of PrototypeActions.
     */
    var PrototypeActionCollection = Backbone.Collection.extend("PrototypeActionCollection", {

        companyId: null,

        model: PrototypeAction,

        constructor: function constructor(models, options) {
            this.__super();

            if (options) {
                this.companyId = options.companyId;
            }
        },

        comparator: function comparator(prototypeAction) {
            // Not including the edit date when sorting, since this would make the actions move to
            // the top of list when they are edited.
            return -prototypeAction.get("createdAt");
        },

        /**
         * Returns the action prototypes where the embedded action have the specified type.
         *
         * @param {String} type - The type of the action, e.g. CustomJsAction.TYPE.
         * @return {PrototypeActionCollection}
         */
        filterByType: function filterByType(type) {
            var matchingPrototypeActions = this.filter(function (prototypeAction) {
                return prototypeAction.get("action").get("type") === type;
            });

            // This is potentially dangerous because we're reusing the models in multiple
            // collections. So if you experience weird behaviour, try cloning the matching
            // prototypes.
            return new PrototypeActionCollection(matchingPrototypeActions);
        },

        /**
         * Returns the REST API URL for the company's actions, i.e.
         * "/api/companies/{companyId}/actions".
         *
         * @returns {String}
         */
        url: function url() {
            // I does not make sense to call fetch on a filtered collection. We use the presense of
            // companyId to detect that.
            if (!this.companyId) {
                return null;
            }

            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, this.companyId, RestApi.Collections.ACTIONS);
        }
    });

    return PrototypeActionCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        Preconditions = __webpack_require__(14),
        PrototypeWidget = __webpack_require__(2828),
        RestApi = __webpack_require__(29);

    return Backbone.Collection.extend("PrototypeWidgetCollection", {

        companyId: null,

        model: PrototypeWidget,

        constructor: function constructor(models, options) {
            this.__super();

            if (!(options && options.companyId)) {
                Preconditions.fail("options.companyId has to be defined.");
            }
            this.companyId = options.companyId;
        },

        /**
         * Returns the REST API URL for the company's widgets.
         *
         * @returns {String}
         */
        url: function url() {
            // "/api/companies/{companyId}/widgets"
            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, this.companyId, RestApi.Collections.WIDGETS);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ImprovedModel = __webpack_require__(25),
        Permissions = __webpack_require__(22),
        RestApi = __webpack_require__(29),
        Syncer = __webpack_require__(50),
        Widget = __webpack_require__(2829);

    /**
     * A widget prototype acts as a template that allows widget instances to be created based on
     * it, initialised with its prototypical data and a reference to the prototype it was created
     * from (id). Such widget instances (data) will then be embedded in Experiences, where they can
     * be primed with Experience specific data to activate, such as a product id for an associated
     * widget action to activate.
     * */
    return ImprovedModel.extend("PrototypeWidget", {

        defaults: {
            action: null,
            companyId: null
        },

        relations: [{
            key: "widget",
            relatedModel: Widget,
            type: Backbone.One
        }],

        constructor: function constructor() {
            this.__super();

            Syncer.State.init(this, {
                permissions: {
                    destroy: Permissions.Privileges.ADMIN,
                    save: Permissions.Privileges.ADMIN
                }
            });
        },

        /**
         * Returns the REST API URL for a PrototypeWidget. Used internally by the synchronization
         * mechanism.
         *
         * @returns {String} REST API URL
         */
        url: function url() {
            var id = this.get("id");

            if (id) {
                // URL for GET, PUT and DELETE, i.e. "api/widgets/{widgetId}"
                return RestApi.pathToSpecificResource(RestApi.Collections.WIDGETS, id);
            }

            // URL for POST, i.e. "api/widgets"
            return RestApi.pathToCollection(RestApi.Collections.WIDGETS);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);

    /**
     * A widget object is both the icon in the widget library and the element on the scene in an
     * experience.
     *
     * @class Widget
     * @constructor
     */
    return ImprovedModel.extend("Widget", {

        embedded: true, // since it has an id and we do not want to call the server on sync.

        defaults: {
            type: null
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        LoggedInUserState = __webpack_require__(19),
        BreakpointSettingsView = __webpack_require__(2831);

    return Marionette.Controller.extend({

        showBreakpointSettingsView: function showBreakpointSettingsView() {
            var companySettings = LoggedInUserState.get("companySettings"),
                breakpoints = companySettings.get("breakpoints");

            this.options.region.show(new BreakpointSettingsView({
                collection: breakpoints
            }));

            this.listenTo(breakpoints, "add remove change", function () {
                companySettings.saveLater();
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* global confirm */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        AddBreakpointView = __webpack_require__(2832),
        EditorEvents = __webpack_require__(17),
        Lightbox = __webpack_require__(101),
        Permissions = __webpack_require__(22),
        SettingsView = __webpack_require__(230),
        template = __webpack_require__(2834);

    /**
     * View for defining company breakpoints.
     *
     * @cfg {BreakpointCollection} collection The collection of <tt>Breakpoints</tt>'s.
     *
     * @class BreakpointSettingsView
     */
    return SettingsView.extend("BreakpointSettingsView", {

        className: SettingsView.prototype.className + " breakpoint-setup-view",

        template: template,

        templateHelpers: function templateHelpers() {
            // Make sure the collection of breakpoints are sorted - we don't need to call this under
            // normal circumstances, as a collection with a comparator will sort itself whenever a model is added.
            // But when we change a threshold value, we need to make sure the collection is sorted...
            this.collection.sort();

            return {
                permissionToManage: Permissions.Privileges.ADMIN.can(),
                breakpoints: this.collection,
                naming: this.collection.generateNaming()
            };
        },

        events: {
            "click .add": "openAddBreakpointBox",

            "blur .breakpoint-input": function blurBreakpointInput(event) {
                var $target = $(event.target),
                    threshold = parseInt($target.val(), 10),
                    index = parseInt($target.data("index"), 10),
                    breakpoint = this.collection.at(index);

                if (threshold > 1) {
                    this.updateThreshold(index, threshold);
                } else {
                    $target.val(breakpoint.get("threshold"));
                }
            },

            "click .delete-breakpoint": function clickDeleteBreakpoint(event) {
                var index = parseInt($(event.target).data("index"), 10),
                    breakpoint = this.collection.at(index);

                if (confirm("Are you sure you want to delete the " + breakpoint.get("threshold") + " px Breakpoint?")) {
                    this.deleteBreakpoint(index);
                }
            },

            "keyup .variant": function keyupVariant(event) {
                var $target = $(event.target);

                if ($target.val().length > 4) {
                    $target.val($target.val().slice(0, 4));
                }
            }
        },

        collectionEvents: {
            "add remove change": "render"
        },

        /**
         * Open a light box where users input the new breakpoint.
         */
        openAddBreakpointBox: function openAddBreakpointBox() {
            var addBreakpointView = new AddBreakpointView({
                collection: this.collection
            }),
                box = new Lightbox(addBreakpointView, {
                win: false,
                css: { width: 440 },
                editorEventProperties: {
                    modalType: "AddBreakpoint",
                    triggerOrigin: "AddBreakpointModal"
                }
            });

            box.open();
        },

        /**
         * Updates the threshold value of the breakpoint at the specified index.
         *
         * @param {Number} index The index of the breakpoint to update.
         * @param {Number} threshold The new threshold value.
         */
        updateThreshold: function updateThreshold(index, threshold) {
            this.collection.at(index).set("threshold", threshold);

            var eventProperties = {
                groupType: "BreakpointGroup",
                updatedProperty: "threshold",
                updatedValue: threshold,
                triggerOrigin: "UpdateBreakpointThresholdButton"
            };

            EditorEvents.trigger(EditorEvents.constants.UPDATE_BREAKPOINT, eventProperties);
        },

        /**
         * Delete a breakpoint by index.
         *
         * @param {Number} index The index of breakpoint to be deleted
         */
        deleteBreakpoint: function deleteBreakpoint(index) {
            var collection = this.collection,
                breakpoint = collection.at(index);

            collection.remove(breakpoint);

            var eventProperties = {
                threshold: breakpoint.get("threshold"),
                triggerOrigin: "DeleteBreakpointButton"
            };

            EditorEvents.trigger(EditorEvents.constants.DELETE_BREAKPOINT, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorEvents = __webpack_require__(17),
        Marionette = __webpack_require__(10),
        template = __webpack_require__(2833);

    /**
     * View for adding new breakpoints.
     *
     * @class AddBreakpointView
     *
     * @cfg {BreakpointCollection} collection The collection of <tt>Breakpoints</tt>'s.
     */
    return Marionette.ItemView.extend("AddBreakpointView", {

        template: template,

        className: "add-breakpoint-view",

        ui: {
            input: ".new-breakpoint",
            ok: ".ok",
            cancel: ".cancel"
        },

        events: {
            "click @ui.ok": "confirmAddBreakpoint",
            "click @ui.cancel": "close",
            "keyup @ui.input": "updateInputState"
        },

        updateInputState: function updateInputState() {
            var value = this.ui.input.val();

            if (parseInt(value, 10) > 0) {
                this.ui.ok.attr("disabled", false);

                if (value.length > 4) {
                    this.ui.input.val(value.slice(0, 4));
                }
            } else {
                this.ui.ok.attr("disabled", true);
            }
        },

        confirmAddBreakpoint: function confirmAddBreakpoint() {
            var threshold = parseInt(this.ui.input.val(), 10);

            if (threshold > 0 && !this.collection.containsThreshold(threshold)) {
                this.collection.add({ threshold: threshold });
            }

            var eventProperties = {
                threshold: threshold,
                triggerOrigin: "AddBreakpointModalOkButton"
            };

            EditorEvents.trigger(EditorEvents.constants.ADD_BREAKPOINT, eventProperties);
            this.close();
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2833 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="form-controls add-breakpoint-lightbox settings">\n    <h2 class="header">Add Breakpoint</h2>\n    <p>Add a new Breakpoint to your Settings.</p>\n    <label data-unit="px">\n        <input type="number" min="1" step="1" class="new-breakpoint">\n    </label>\n    <div class="actions">\n        <button class="btn btn-primary pull-right ok" data-spinner-size="28" data-style="expand-right" disabled>OK</button>\n        <button class="btn btn-secondary pull-right cancel">Cancel</button>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2834 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Set Up Breakpoints</h1>\n    </header>\n\n    <div class="tabs">\n        <span class="tab active">Responsive Breakpoints</span>\n    </div>\n    <div class="tab-pane active">\n        <div class="row">\n            <div class="col-xs-4">\n                <p class="intro">With Creator\'s Breakpoint Settings you can set up the Breakpoints that correspond with your website.</p>\n                <p>The Breakpoints will define intervals to which you can assign different Breakpoint Variants in the Editor.</p>\n\n                <div class="notification-box">\n                    <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">Changes to Breakpoint Settings</span>\n                    <p>Changes to your Breakpoint Settings will not affect existing Breakpoint Groups. To modify these, open "Assign Breakpoint Variants" in the Editor and accept the new Breakpoint Settings.</p>\n                </div>\n            </div>\n\n            <div class="col-xs-8">\n                <ul class="breakpoints-flex-section list-unstyled">\n                ';
 _.each(naming, function(name, index){ ;
__p += '\n                    <li class="breakpoint-flex-item">\n                        <div class="interval-indicator ' +
__e( name ) +
'">' +
__e( name ) +
'</div>\n\n                    ';
 if (index > 0) { ;
__p += '\n                        <button class="delete-breakpoint" data-index="' +
__e( index - 1 ) +
'" ' +
__e( (permissionToManage && naming.length > 2) ? "" : "disabled" ) +
'></button>\n                        <label class="breakpoint-value" data-unit="px">\n                            <input class="breakpoint-input" type="number" min="1" step="1" value="' +
__e( breakpoints.at(index - 1).get('threshold') ) +
'" data-index="' +
__e( index - 1 ) +
'" ' +
__e( permissionToManage || "disabled" ) +
'>\n                        </label>\n                    ';
 } ;
__p += '\n                    </li>\n                ';
 }); ;
__p += '\n                    <li class="add-breakpoint">\n                        ';
 if(permissionToManage && naming.length < 6) { ;
__p += '\n                        <button class="add btn btn-secondary">\n                            &#43; Add ';
 if(naming.length < 4) { ;
__p += '\n                                Breakpoint\n                            ';
 } ;
__p += '\n                        </button>\n                        ';
 } ;
__p += '\n                    </li>\n                </ul>\n            </div>\n        </div>\n    </div>\n</div>\n<footer class="default-footer"></footer>\n';

}
return __p
}

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var PublishUtil = __webpack_require__(234);
    var template = __webpack_require__(2836);

    var VERSION = 2;

    return {
        fromId: function fromId(id) {
            var mosaikHost = window.location.host;

            return template({
                id: id,
                // The absolute channel url is comprised on the *client* protocol + "mosaikHost" + pathname +
                // "channel.js" (see ChannelBookmarklet.tpl). This ensures that if the client site uses https,
                // the channel snippet will be loaded via https as well. creator.zmags.com works on both
                // https and http, so this should ensure that the channel snippet is loaded using the correct
                // protocol. However, this will *not* work locally or on development with a client site using
                // https, since we use only http there. Trying to embed the channel snippet code via http from
                // a https site will thus fail.
                channelUrl: PublishUtil.SNIPPET,
                mosaikHost: mosaikHost,
                warning: "Please click the button you added to the toolbar in your website window.",
                version: VERSION // to ensure the user will be notified if we ever change the bookmarklet drastically!
            });
        },


        // The current version of the channel bookmarklet, used to ensure that clients will get notified if we
        // ever need to update the bookmarklet, i.e. re-drag it on the browser toolbar. Only change this value when the
        // bookmarklet code itself has changed in a manner that requires clients to upgrade it!
        VERSION: VERSION
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2836 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += 'javascript:(function() {\n\nif (window.location.host === \'' +
__e( mosaikHost ) +
'\') {\nalert(\'' +
__e( warning ) +
'\');\nreturn;\n}\n\nvar script = document.createElement(\'script\');\nscript.setAttribute(\'src\', window.location.protocol + \'//' +
__e( mosaikHost ) +
'' +
__e( channelUrl ) +
'\');\nscript.setAttribute(\'data-channel\', \'' +
__e( id ) +
'\');\nscript.setAttribute(\'data-preview\', \'' +
__e( version ) +
'\');\n\ndocument.head.appendChild(script);\n\n})();';

}
return __p
}

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ViewController = __webpack_require__(126);
    var ChannelPropertiesView = __webpack_require__(1195);
    var Channel = __webpack_require__(233);
    var Lightbox = __webpack_require__(101);
    var LoggedIn = __webpack_require__(31);
    var Time = __webpack_require__(121);
    var Preconditions = __webpack_require__(14);

    /**
     * View Controller of the manual channel setup view.
     *
     */
    return ViewController.extend({

        /**
         * Triggered when the user has clicked on an row for a given channel to edit. <p>
         *
         * <tt>field</tt> will be the class name of the target element clicked in the row, e.g. "next-experience"
         * if the title of the Experience scheduled to go live next was clicked.
         *
         * @param {String}  property The channel property the user clicked on to gain focus now, if any, e.g.
         *                           "name", or "experience". Can be falsey, i.e. just open view without focus.
         */
        onViewCreateNewSlotOpened: function onViewCreateNewSlotOpened() {
            var _this = this;

            var principal = LoggedIn.principal();
            var _options = this.options,
                projectContext = _options.projectContext,
                allowedToPublish = _options.allowedToPublish,
                publishableDescriptors = _options.publishableDescriptors,
                publishableCollection = _options.publishableCollection,
                channelCollection = _options.channelCollection;

            var newChannel = new Channel({
                companyId: principal.get("companyId"),
                createdBy: principal.get("userId"),
                createdAt: Time.server(),
                manual: true
            }),
                channelPropertiesView = new ChannelPropertiesView({
                model: newChannel,
                isNewSlot: true,
                focus: "name",
                channelCollection: channelCollection,
                publishableDescriptors: publishableDescriptors,
                publishableCollection: publishableCollection,
                projectContext: projectContext,
                allowedToPublish: allowedToPublish
            });

            var options = {
                css: {
                    width: 830
                },
                editorEventProperties: {
                    modalType: "ChannelSlotProperties",
                    triggerOrigin: "CreateNewChannelSlotModal",
                    isNewSlot: true
                }
            };
            new Lightbox(channelPropertiesView, options).open();

            channelPropertiesView.once("done", function (channel) {
                _this.view.trigger("handleChanges", "add", channel);
            });
        },
        onViewHandleChanges: function onViewHandleChanges(type, channel) {
            Preconditions.checkArgument(type);

            if (type === "add") {
                this.view.channelChangesInfo.handleAdd(channel);
                this.view.collection.add(channel, 0);
            }

            if (type === "update") {
                this.view.channelChangesInfo.handleUpdate(channel);
            }

            if (type === "delete") {
                this.view.channelChangesInfo.handleDelete(channel);
                this.view.collection.remove(channel);
            }

            this.view.shouldButtonChange();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var global = __webpack_require__(2839),
        util = __webpack_require__(284),
        format = __webpack_require__(464),
        state = __webpack_require__(1197),
        MathUtil = __webpack_require__(72).default,
        Log = __webpack_require__(2842);

    var SEQUENCE = 1; // to keep track of number of docs for easy debugging.

    /**
     * @class {Dom}
     *
     * Defines a "mini dom" used to manipulate the dom, only exposing the minimum set of channel
     * required dom methods. <p>
     *
     * Multiple doms can exist, one per channel, to support channels embedding other channels on
     * the fly (i.e. store the dom for the iframe in question). <p>
     *
     * Several dom methods are static, i.e. all those not requiring direct access to the current
     * document/window, like <tt>Dom.data</tt>.
     *
     * @param {Window|HTMLIframeElement} win The window owning the document in question; cannot be falsey.
     *
     * @author Gunni Rode  / <a href="http://www.zmags.com">Zmags</a>
     * @author Kim Knudsen / <a href="http://www.zmags.com">Zmags</a>
     */
    function Dom(win) {
        // Handle iframe...
        if (win.contentWindow) {
            win = win.contentWindow;
        }

        var dom = this;

        /**
         * @private @type {Number}
         * Dom sequence number, used only for easy debugging.
         */
        this._id = SEQUENCE++;

        /** @type {Window} The window containing this dom; never null. */
        this.win = win;

        /** @type {Document} The document/dom, where the body may/will change. */
        this.doc = win.document; // ok now, since "win" is a window type!

        /**
         * Returns true if this dom represents a document in a non-top level window, false otherwise. <p>
         *
         * Note that an embedded channel can still use the top level dom, if for example opened in a lightbox
         * attached to the top level document.
         *
         * @return {Boolean} True if embedded, false otherwise.
         *
         * @see    Channel#embedded
         */
        this.embedded = function () {
            return win !== global.win;
        };

        /**
         * Returns the 'head' element for the specified document, defaulting to the
         * global document.
         *
         * @return {HTMLElement} The 'head' element; never falsey.
         */
        this.head = function () {
            // The head will never change, even for single page apps, but legacy browsers have no "head" property...
            return dom.doc.head || dom.doc.getElementsByTagName("head")[0];
        };

        /**
         * Returns a reference to the body element, or falsey if the body has not been initialized.
         *
         * @return {HTMLElement} A reference to the body element, or falsey if the body
         *                       has not been initialized.
         */
        this.body = function () {
            return dom.doc && (dom.doc.body || dom.doc.getElementsByTagName("body")[0]);
        };

        /**
         * Returns true if the document for this dom contains the specified element, false otherwise.
         *
         * @param {HTMLElement} element The element to test; can be falsey, in which case this
         *                              function returns false.
         *
         * @return {Boolean} True if <tt>element</tt> is contained, false otherwise.
         */
        this.contains = function (element) {
            // IE trouble for iframe documents
            var body = dom.body(),
                i;

            if (body && element) {
                if (body.contains) {
                    return body.contains(element);
                } else if (body.all) {
                    // IE iframe docs...
                    i = body.all.length;
                    while (i--) {
                        if (body.all[i] === element) {
                            return true;
                        }
                    }
                    // Fall-through
                }
            }
            return false;
        };

        /**
         * Returns the current executing script at invocation time. <p>
         *
         * Caveat: this <b>only</b> works when the document is loading and called in inline script tags, but
         * <b>not</b> if called after the document has finished loading; in the latter case, the returned script
         * will always be the last script in the dom.
         *
         * @return {HTMLElement} The current executing script at invocation time while the document is loading,
         *                       otherwise falsey.
         *
         * @see #currentElement
         * @see Channel#inPlace
         */
        this.currentScript = function () {
            // If "currentScript" not supported and document has already loaded, we return falsey instead of some
            // random script...
            return dom.doc.currentScript || !dom.docLoaded && function () {
                var scripts = dom.doc.getElementsByTagName("script");
                return scripts[scripts.length - 1];
            }();
        };

        /**
         * Returns the current element deduced from the script calling this method while the document is loading.
         * More precisely, it is the parent element of the current script executing. <p>
         *
         * Caveat: this <b>only</b> works when the document is loading and called in inline script tags, but
         * <b>not</b> if called after the document has finished loading; in the latter case, the returned element
         * will always be the parent element of the last script in the dom.
         *
         * @return {HTMLElement} The current element as described above, if any; can be null.
         *
         * @see #currentScript
         * @see Channel#inPlace
         */
        this.currentElement = function () {
            var script = dom.currentScript();
            return script ? script.parentElement : null;
        };

        /**
         * Adds the specified callback to be invoked once the dom is ready; do NOT use this for non-document elements.
         * The callback will only be invoked one time. <p>
         *
         * Options format:
         * <pre>
         * {
         *     name:     String,    // the function called.
         *     scope:    Log        // calling scope, also potentially doubling as a logger (or defaulting to global log).
         *     callback: Function,  // the no-arg callback to invoked on dom ready
         *     args:     *|[]       // single argument for "callback", if any (can be an array).
         * }
         * </pre>
         *
         * If the dom is ready at invocation time, <tt>options.callback</tt> is invoked immediately.
         *
         * @param {*} options The on-ready options; cannot be null.
         *
         * @see   #ready
         */
        this.docReady = function (options) {
            var scope = options.scope,
                log = scope && scope.verbose ? scope : Log.global(),
                callback = function callback() {
                log.verbose("Dom ready callback: ", format.val(options.name), dom);
                options.callback(options.args); // already scoped
                // Since we know the dom is ready, we can call the callback directly henceforth if such
                // a callback is defined for the scope, e.g. "populateChannels"...
                if (scope && scope[options.name]) {
                    scope[options.name] = options.callback;
                }
            };

            // If we know for sure the document is ready, we do not bother with event handlers...
            if (dom.docLoaded) {
                callback();
                return;
            }

            // Make sure the callback is only invoked once, we assign it to multiple events...
            var invoke = util.one(log, options.name, callback);

            // Use the handy event callback, or fallback to window that will always work (slower). We will assign both
            // unless already ready...
            if (Dom.on(log, dom.doc, dom.doc.addEventListener ? "DOMContentLoaded" : "readystatechange", invoke)) {
                Dom.on(log, win, "load", invoke);
            }
        };

        /**
         * Returns the elements matched by the passed CSS selector from the document associated with this dom. <p>
         *
         * <tt>selector</tt> is <b>not</b> a jQuery selector, but a native one, so we use <tt>querySelectorAll</tt>
         * (for non-legacy browsers). Otherwise we default to our custom Sizzle, expected to be ready in the sandbox
         * at the time of invocation.
         *
         * @param   {String} selector The native CSS selector used; never falsey.
         * @returns {NodeList} All matched elements; can be empty.
         * @throws  {Error} If <tt>selector</tt> is invalid, or if legacy browser and Sizzle is not loaded yet.
         */
        this.selectElements = function (selector) {
            selector = Dom.escapeSelector(selector);

            // Custom Sizzle is (already) loaded when no native CSS selector support...
            return global.capabilities.isQuerySelectorSupported ? dom.doc.querySelectorAll(selector) : global.sandbox().sizzle(selector, dom.doc);
        };

        /**
         * Returns a new iframe with src "about:blank" with a display style of "none", attached to the current
         * body if already loaded, otherwise unattached.
         *
         * @return {HTMLIFrameElement} The created iframe, possibly attached; never null. To test if the iframe is
         *                             attached, query for its "contentDocument" property (will be available if
         *                             attached).
         */
        this.iframe = function () {
            var iframe = dom.createElement("iframe", { src: "about:blank" });
            iframe.style.display = "none";

            var body = dom.body();
            if (body) {
                body.appendChild(iframe);
            }

            return iframe;
        };

        /**
         * Constructs an <tt>HTMLStyleElement</tt> containing the specified CSS string.
         * The element is appended to the head of the current context.
         *
         * @param  {String} css A valid CSS string. E.g. <tt>.zmags-node {opacity: 0;}</tt>.
         */
        this.css = function (css) {
            var style = dom.doc.createElement("style");
            style.type = "text/css";

            if (style.styleSheet) {
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(dom.doc.createTextNode(css));
            }

            dom.head().appendChild(style);
        };

        /**
         * Creates a new detached dom element with the specified tag, using the document associated with this dom.
         *
         * @param  {String}      tag          The tag name of the element to create, e.g. "div", "iframe", etc.
         * @param  {*}           [attributes] Optional attributes to set on the created element, where those with a
         *                                    falsey value will be ignored.
         * @param  {String}      [className]  Optional class name to append to the element's class list; can be falsey.
         * @return {HTMLElement} The created element; never falsey.
         */
        this.createElement = function (tag, attributes, className) {
            var element = dom.doc.createElement(tag),
                name,
                value;

            if (attributes) {
                for (name in attributes) {
                    value = attributes[name];
                    if (value) {
                        element.setAttribute(name, value);
                    }
                }
            }

            if (className) {
                Dom.addClass(element, className);
            }

            return element;
        };

        /**
         * Returns the bounds for the specified element, if supplied, or the bounds for the browsers viewport. <p>
         *
         * Different browsers may give different results! Also note that properties such as "left" can be negative,
         * e.g. if currently positioned outside the actual browser viewport and thus not visible to the end user.
         *
         * @param  {HTMLElement} [element] The element to get the bounds for; can be falsey, in which case the bounds
         *                                 for the browsers viewport is returned.
         * @return {{width:Number, height:Number, left:Number, top:Number, right:Number, bottom:Number}} The bounds;
         *         never null, but individual properties may be undefined, i.e. not available.
         */
        this.bounds = function (element) {
            var bounds = {};
            // Element...
            if (element) {
                if (element.getBoundingClientRect) {
                    bounds = element.getBoundingClientRect() || {};
                }
                // Legacy IE returns a client rect, but without width and height, and it cannot be updated
                // so we have to make a copy with width and height... :/
                if (typeof bounds.width === "undefined" || typeof bounds.height === "undefined") {
                    bounds = {
                        width: element.offsetWidth || bounds.right - bounds.left, // also works for negative values
                        height: element.offsetHeight || bounds.bottom - bounds.top,
                        top: bounds.top,
                        left: bounds.left,
                        bottom: bounds.bottom,
                        right: bounds.right
                    };
                }

                // Browser (window) viewport...
            } else {
                bounds = { top: 0, left: 0 };
                // Prefer jQuery calculation if available since it should take everything into account...
                var $ = global.$(),
                    win,
                    width,
                    height;

                if ($) {
                    win = $(global.win);
                    width = win.width(); // jQuery defines these!
                    height = win.height();
                }
                bounds.width = bounds.right = width || global.win.innerWidth;
                bounds.height = bounds.bottom = height || global.win.innerHeight;
            }
            return bounds;
        };

        /**
         * Computes the visible (vertical) viewport for the specified target, relative to *this* DOM.
         *
         * @param  {HTMLElement} target The target element.
         * @return {VerticalBounds}     The <tt>VerticalBounds</tt>.
         *
         * @see  MathUtil#computeVerticalBounds
         */
        this.calculateVerticalBounds = function (target) {
            var viewportBounds = this.bounds(),
                targetBounds = this.bounds(target);

            viewportBounds.top = this.body().scrollTop;

            return MathUtil.computeVerticalBounds(targetBounds, viewportBounds);
        };

        this.toString = function () {
            return "Dom[#" + dom._id + "; ready: " + dom.docLoaded + "]";
        };

        /**
         * @type {Boolean}
         * Constant set to true when the document has loaded, false until then.
         */
        this.docLoaded = false;

        // Update our handy constant when document is ready...
        dom.docReady({ name: "docLoaded", callback: function callback() {
                dom.docLoaded = true;
            } });
    }

    // STATIC

    /**
     * Factory method that returns a dom backed by the supplied window, defaulting to the current window.
     *
     * @param {Window|HTMLIframeElement} [win] The window owning the dom (document) in question; will default to
     *                                         the current window.
     * @return {Dom} The corresponding dom instance; never falsey.
     */
    Dom.of = function (win) {
        win = win || window;
        return win === (state.dom && state.dom.win) ? state.dom : new Dom(win);
    };

    /**
     * @static
     * Gets, sets, or clears the named "data" attribute from the specified dom element.
     *
     * @param {HTMLElement} element  The dom element to get/set/clear the "data" attribute for; cannot be null.
     * @param {String}      name     The attribute name, <b>excluding</b> prefixed "data-"; cannot be null.
     * @param {*}           [value]  The value to set the string value of, if any; null means clear, any other value
     *                               will be set. If no supplied at all, the data will be returned.
     * @return {String} The "data" attribute for the specified dom element (will be <tt>value</tt> if supplied);
     *                  never null.
     */
    Dom.data = function (element, name, value) {
        name = "data-" + name;
        if (arguments.length === 2) {
            value = element.getAttribute(name) || "";
        } else if (value === null) {
            element.removeAttribute(name);
        } else {
            element.setAttribute(name, "" + value);
        }
        return value;
    };

    /**
     * Returns the computed style property for the specified dom element.
     *
     * @param  {HTMLElement} element  The dom element to find the property for; cannot be null.
     * @param  {String}      property The property name; cannot be null.
     * @return {String} The specified property value as a string, or falsey if no such property.
     */
    Dom.style = function (element, property) {
        var value = null;
        // IE will throw an error if the passed element can't have styles (such as a text node)
        try {
            value = global.win.getComputedStyle(element).getPropertyValue(property);
        } catch (e) {
            // Fall-through - value will be null...
        }
        return value;
    };

    /**
     * @static
     * Sets the visibility for the supplied dom element.
     *
     * @param {HTMLElement} [element]    The element to set the visibility for; this function does nothing if falsey.
     * @param {String}      [visibility] The visibility to set for "element" as "visible", "hidden", "inherit",
     *                                   "none" or "block". The latter two will set the "display" property, the
     *                                   former the "visibility" property. This function does nothing if falsey.
     */
    Dom.visibility = function (element, visibility) {
        if (element && visibility) {
            // This also applies to legacy browsers...
            var prop = visibility === "none" || visibility === "block" ? "display" : "visibility";
            element.style.cssText += "; " + prop + ": " + visibility + " !important";
        }
    };

    /**
     * Returns the elements matched by the passed CSS selector from the dom associated with the specified
     * window, defaulting to the current window. <p>
     *
     * <tt>selector</tt> is <b>not</b> a jQuery selector, but a native one, so we use <tt>querySelectorAll</tt>
     * (for non-legacy browsers). Otherwise we default to our custom Sizzle, expected to be ready in the sandbox
     * at the time of invocation.
     *
     * @param   {String}                   selector The native CSS selector used; cannot be falsey.
     * @param   {Window|HTMLIframeElement} [win]    The window owning the dom (document) in question; will default to
     *                                              the current window.
     * @returns {NodeList} All matched elements from the dom associated with the (defaulted) window; can be empty.
     * @throws  {Error} If <tt>selector</tt> is invalid, or if legacy browser and Sizzle is not loaded yet.
     */
    Dom.selectElements = function (selector, win) {
        return Dom.of(win).selectElements(selector);
    };

    /**
     * @static
     * Removes the specified element from it's parent, if any.
     *
     * @param  {HTMLElement} element The element to remove; if falsey, this function does nothing.
     */
    Dom.removeElement = function (element) {
        var parent = element && element.parentNode;
        if (parent) {
            // This can cause trouble if we are removing the Viewer container while it is still loading in admin
            // mode, since the script(s) will fail hard when their context (iframe) window is destroyed. Because
            // of this this, the admin code is cautious when it will populate channels to avoid such scenarios...
            parent.removeChild(element);
        }
    };

    /**
     * @static
     * Adds the specified class name to the given element.
     *
     * @param {HTMLElement} element   The target element.
     * @param {String}      className The class name to append to the element's class list.
     */
    Dom.addClass = function (element, className) {
        if (element.classList) {
            element.classList.add(className);
        } else {
            element.className += " " + className;
        }
    };

    /**
     * @static
     * Takes any native selector and escapes it properly in case it contains numbers in reserved positions,
     * e.g. at the start of any individual selector. <p>
     *
     * Handles:
     * <ul>
     * <li> Single id or class (#foo)
     * <li> Combined (#foo.bar)
     * <li> Descendant (#foo .bar)
     * <li> Immediate child (#foo>.bar)
     * </ul><p>
     *
     * This function is really dom agnostic ("static"); <tt>element</tt> does not have to belong to this dom.
     *
     * @param {String} selector The selector to be escaped; cannot be null/undefined.
     * @return {String} The escaped selector; never null/undefined.
     * @throws {Error} If <tt>selector</tt> is null/undefined.
     */
    Dom.escapeSelector = function (selector) {
        // The function supplied for each match takes 3 arguments: "all" = entire match, e.g. ".12foo" (not used),
        // "escaped" = the selector id or class prefix, e.g. ".", and "digits" = the digits (string!) immediately
        // following the class or id selector, e.g. "12"...
        return selector.replace(/([#.])(\d+)/g, function (all, escaped, digits) {
            for (var i = 0; i < digits.length; i++) {
                escaped += "\\3" + digits[i];
            }
            return escaped + " "; // escaping ends with a space!
        });
    };

    /**
     * @static
     * Returns true if <tt>descendant</tt> is actually a descendant of <tt>element</tt>, including if
     * <tt>element</tt> itself, otherwise false.
     *
     * @param {HTMLElement} element    The root element; can be falsey, in which case false is returned.
     * @param {HTMLElement} descendant The descendant to check; can be falsey, in which case false is returned.
     * @return {Boolean} True if <tt>descendant</tt> is a descendant of or <tt>element</tt> itself, false otherwise.
     */
    Dom.descendant = function (element, descendant) {
        var node = descendant;
        while (node) {
            if (element === node) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    };

    /**
     * @static
     * Adds <tt>fn</tt> as a <b>one-time</b> event handler on <tt>element</tt> for the <tt>name</tt>d event.
     *
     * @param  {Log}                  log     The log to use; cannot be falsey.
     * @param  {HTMLElement|Window|*} element The html element, document, or window to add the handler to; cannot be null.
     * @param  {String}               name    The event name, minus "on" prefix; cannot be null.
     * @param  {Function}             fn      The function to call at most one time when <tt>element</tt> is ready;
     *                                        cannot be null. The function is assumed to be scoped and will be called
     *                                        without the <tt>Event</tt> argument only, or no args if already ready.
     *
     * @return {Boolean} False if <tt>element</tt> is already ready and <tt>fn</tt> has been called once this
     *                   function returns, true otherwise.
     */
    Dom.on = function (log, element, name, fn) {
        // Already ready? Works for "document" in all major browsers, also for elements in IE...
        var state = element.readyState; // ignored for "window" object!
        if (state === "complete") {
            fn();
            return false;
        }

        var _callback2;
        // Modern browsers, e.g. Chrome...
        if (element.addEventListener) {
            _callback2 = function callback(event) {
                element.removeEventListener(name, _callback2, false);
                fn(event);
            };
            element.addEventListener(name, _callback2, false);

            // Legacy browsers, i.e. old Explorer. We add more logging here, since old legacy browsers are
            // way less stable...
        } else if (element.attachEvent) {
            // Windows does not support readyState, so we have to determine if a window! And of course iframe windows
            // in IE are not a proper Window type, so we have to do it like this... :/
            var win = element.toString() === "[object Window]";
            name = "on" + name;
            _callback2 = function _callback(event) {
                state = element.readyState; // undefined for windows
                if (state === "loaded" || state === "complete" || win) {
                    // "complete" when cached content!
                    element.detachEvent(name, _callback2);
                    if (win) {
                        log.verbose("Window ready");
                    } else {
                        log.verbose("<" + element.tagName || element.nodeName + "> ready: ", format.val(state), element);
                    }
                    fn(event || element.event); // element.event = window.event
                }
            };
            element.attachEvent(name, _callback2);
        } else {
            log.error("Cannot add callback: ", format.val(element.tagName + "." + name), element);
        }
        return true;
    };

    /**
     * @static
     * Adds the specified callback to be invoked once the specified "loadable" element is ready; do NOT use this
     * for the global dom, only for specific dom elements that can load content like <script> and <image> (after
     * the dom is known to be ready). The callback will only be invoked one time. <p>
     *
     * Options format:
     * <pre>
     * {
     *     element:  HTMLElement, // the dom element; never document, but can be script or image.
     *     name:     String,      // the function called.
     *     scope:    Log          // calling scope, also potentially doubling as a logger (or defaulting to global log).
     *     callback: Function,    // the callback to invoked on ready (see "args" below).
     *     args:     *|[],        // single argument for "callback", if any (can be an array); will default to
     *                            // the <tt>Event</tt> in question.
     *     errback:  Function     // optional handler to be called on error with the <tt>Event</tt> as the single
     *                            // argument, not "args"!
     * }
     * </pre>
     *
     * If the element is ready at invocation time, <tt>options.callback</tt> is invoked immediately. <p>
     *
     * This function is really dom agnostic ("static"); <tt>element</tt> does not have to belong to this dom.
     *
     * @param {*} options The on-ready options; cannot be null.
     *
     * @see   #docReady
     */
    Dom.ready = function (options) {
        // Make sure the callback is only invoked once, we assign it to multiple events...
        var log = options.scope.verbose ? options.scope : Log.global(),
            invoke = util.one(log, options.name, function (event) {
            log.verbose("<" + options.element.tagName + "> ready callback: ", format.val(options.name));
            if (options.callback) {
                options.callback(options.args || event); // already scoped
            }
        });

        // Add ready handler, and optional errback, but only if the content is not already ready...
        if (Dom.on(log, options.element, options.element.addEventListener ? "load" : "readystatechange", invoke) && options.errback) {
            // IE11 and forward now uses "onload" as well!
            Dom.on(log, options.element, "error", function (event) {
                invoke.clear(); // clear timer, we have an errback to handle this, i.e. we know it is erroneous...
                options.errback(event);
            });
        }
    };

    return Dom;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var BrowserCapabilitiesDetector = __webpack_require__(492);
    var Store = __webpack_require__(1196);
    var Storage = __webpack_require__(2840);
    var Cookie = __webpack_require__(2841);
    var state = __webpack_require__(1197);
    var util = __webpack_require__(284);
    var config = __webpack_require__(297).default;

    /** Configuration, setup during build process for each relevant environment. */
    var CONFIG = config;

    /** Query/config parameters, always the same values regardless of environment. */
    var QUERY = {
        adminModeIdentifier: "zmagsCreatorAdminMode",
        logModeIdentifier: "zmagsLog" // 0-3, see Log.Levels
    };

    /**
     * Returns a new object describing the location the channel script (thinks) it is running at. <p>
     *
     * The returned location has the following format:
     * <pre>
     * {
     *    href:      String   // The current url, excluding search terms. This is the url that will be tested against
     *                        // channel urls in a case-sensitive manner. The url will never change for the page loaded,
     *                        // not even for single page apps, i.e. anchors and query parameters are ignored.
     *    real:      String,  // The real url channels is running on; only different from <tt>href</tt> if viewed
     *                        // vie e.g. Google Cache ("type" is then "cache").
     *    type:      String,  // The type of url we are running on "real", "cache", or "translate".
     *    secure:    Boolean, // True if really on https, false otherwise.
     *    query:     *        // Map of specified query parameters and their (empty) values, e.g. {"zmagsLog": "2"}.
     * }
     * </pre>
     *
     * @param  {String}  url   The fully qualified url; never falsey.
     * @param  {String} [real] The real url when <tt>url</tt> is an alternate (fake) url, like from Google Cache,
     *                         falsey otherwise (default).
     * @param  {String} [type] The short-hand type of the real url, e.g. "translate" or "cache", if <tt>real</tt> is
     *                         not falsey.
     *
     * @return {*} The location as documented; never falsey.
     */
    var location = function location(url, real, type) {
        var href = url.split("?", 2),
            // find query params
        query = href[1];

        href = href[0].split("#", 2)[0]; // drop anchor, if any
        real = real || href;

        return {

            /**
             * @type {String}
             * The current url, excluding search terms. <p>
             *
             * This is the url that will be tested against channel urls in a case-sensitive manner, but it might
             * not be the actual url, e.g. if the page is viewed via Google Cache. <p>
             *
             * The url will never change for the page loaded, not even for single page apps, i.e. anchors and
             * query parameters are ignored.
             */
            href: href,
            /**
             * @type {String}
             * The real url, defaulting to <tt>href</tt> if <tt>href</tt> is the real url. Like <tt>href</tt>,
             * it does not include any query parameters or anchor. <p>
             *
             * Only different if the page embedding channels is viewed via e.g. Google Cache.
             */
            real: real,
            /**
             * @type {String}
             * The short-hand type for the alternate url, e.g. "translate", (Google Translate), "webcache" (Google or
             * Bing Cache), or "real" when no alternative url is used (standard use case).
             */
            type: type || "real",
            /**
             * @type {Boolean}
             * True for top-level https, false otherwise. <p>
             *
             * This is relative to the actual location, not to some fake cache url like Google cache.
             */
            secure: /^https:/i.test(real),
            /**
             * @type {*}
             * Map of parsed query string parameters, all strings but can be empty. <p>
             *
             * Channel defined query parameters, i.e. those in <tt>QUERY</tt>, will reflect the top level ones
             * to ensure we for example can turn logging on even when running on an alternative url. <p>
             *
             * Never null.
             */
            query: util.options(query, "&"),

            toString: function toString() {
                return this.type === "real" ? this.href : this.href + " (" + this.type + ": " + this.real + ")"; // defined here because of cyclic dependencies for Format module
            }
        };
    };

    // Short-cuts...
    var win = window,
        userAgent = win.navigator.userAgent,
        loc = function () {
        var regex = /(\w+)\.(?:googleusercontent|bingj)\.com|\d+\.\d+\.\d+\.\d+\/proxy.ashx?/,
            // Microsoft translate uses some ip proxy in an iframe... :/
        paramRegex = /^cache:(?:([^:]+):)?/,
            // match either ["cache:", undefined] or ["cache:", "something_not_colon:"]
        loc = location(win.location.href),
            match = regex.exec(loc.href);

        if (match) {
            var type = match[1],
                // "type" here: undefined (MS translate), "translate", "webcache", "cc"
            param = "q",
                multiplier = 3;

            switch (type) {
                case undefined:
                    param = "a";
                    type = "translate";
                    multiplier = 10; // slooow :/
                    break;

                case "translate":
                    param = "u";
                    break;

                case "cc":
                    type = "webcache";
                    multiplier = 5;
                    break;

                default:
                    // No need to log here.
                    break;
            }

            // Invariant: "type" now either "translate" or "webcache", or some unknown thing (e.g. some other
            // not yet handled Google user service)...

            try {
                var url = win.decodeURIComponent(loc.query[param] || "unknown_url"),
                    prefix,
                    j = url.length - 1,
                    i;

                // Check for odd parameter prefixes we need to remove to make sure the channels have a better
                // chance of matching, e.g. remove something like "cache:p550z3TSSDMJ:" for some Goggle cache
                // urls. I think it is some kind of id or timestamp Google uses to show the cached content from,
                // but it is not always there (but an invalid cannot be supplied)...
                if (type === "webcache") {
                    match = paramRegex.exec(url);
                    if (match) {
                        prefix = match[1]; // no prefix also for protocol agnostic urls...
                        if (!prefix || util.idx(prefix, "http") === 0) {
                            i = 6; // only drop "cache:"
                        } else {
                            i = match[0].length; // e.g. drop "cache:p550z3TSSDMJ:"
                        }
                        // For some reason, Google cache often appends a "+" at the very end of the url,
                        // which we have to remove if we ever want to match any of the channel urls. This
                        // assumes normal urls do not end with a "+" in the general case, but that seems
                        // like a fair assumption...
                        if (url.charAt(j) !== "+") {
                            j++; // nothing to drop at the end
                        }
                        url = url.substring(i, j);
                    }
                }

                // Remember log level, admin mode does not make sense...
                var level = loc.query[QUERY.logModeIdentifier];

                // If we do not have an "url" here, we hit some unexpected Google User Content service not
                // using "q" as the query parameter and we will simply default to the bogus url "unknown_url"
                // above - we will never be match in any case, but we can trace it...
                loc = location(url, loc.href, type);

                if (level) {
                    loc.query[QUERY.logModeIdentifier] = level;
                }

                // Will eventually also reflect whether we are on mobile devices or not...
                util.deferMultiplier(multiplier);
            } catch (e) {
                // Fall-through to silently ignore unexpected errors, but still ensuring we log alternative urls...
                loc.error = e;
                loc.type = type;
            }
        }
        return loc;
    }();

    /**
     * Defines a (singleton) global reference for the main window and relevant functionality (but not dom related or
     * utility functions), such as <tt>global.win</tt> for the main window, <tt>global.session</tt> for the
     * session storage, etc.
     *
     * @author Gunni Rode  / <a href="http://www.zmags.com">Zmags</a>
     * @author Kim Knudsen / <a href="http://www.zmags.com">Zmags</a>
     */
    var global = {

        CONFIG: CONFIG,
        QUERY: QUERY,

        /**
         * @type {Window}
         * The main window context.
         */
        win: win,
        /**
         * @type {{href:String, real:String, type:String, secure:Boolean, query:*}}
         * The location this channel script (thinks it) is running at.
         */
        loc: loc,
        /**
         * @type {*}
         * Detected browser capabilities.
         */
        capabilities: BrowserCapabilitiesDetector.detect(userAgent),

        /** @type {Store} A store backed by session storage, if supported and enabled on an app level. */
        session: new Store(new Storage(win.sessionStorage)), // we do not use local storage currently!
        /** @type {Store} A store backed by cookies, if supported and enabled on an app level. */
        cookie: new Store(new Cookie(win.document, loc.secure)),

        /**
         * Returns the client site jQuery/Zepto, if available. <p>
         *
         * Will be tried used to (pre)load json and select dom elements to avoid loading custom Sizzle in legacy
         * browsers if at all possible. <p>
         *
         * Note: even though a non falsey value is returned here, it might not actually be jQuery, i.e. clients
         * can have overridden "$" to mean something else.
         *
         * @return {jQuery} The client side included jQuery/Zepto, if available; can be falsey.
         */
        $: function $() {
            var jq = win.jQuery || win.$;

            return jq && jq.fn && jq.fn.jquery ? jq : null;
        },

        /** @type {String} The user agent. */
        userAgent: userAgent,

        /**
         * Returns the JSON object if available for the current browser, otherwise falsey.
         *
         * @return {JSON} The JSON object, with <tt>parse</tt> and <tt>stringify</tt> methods, if available; can be falsey.
         */
        json: function json() {
            return typeof JSON !== "undefined" && typeof JSON.parse === "function" && typeof JSON.stringify === "function" && JSON;
        },

        /**
         * Simply forwards to <tt>util.sandbox(path, global.win)</tt>; see documentation there.
         */
        sandbox: function sandbox(path) {
            return util.sandbox(path, win);
        },

        /**
         * Gets, and optionally sets, the configuration value for the specified key. Configuration values are
         * always strings, the calling context must always ensure to convert the value into the proper type
         * as needed. <p>
         *
         * When getting the key, the value will be looked up first in mem; if that fails, the query parameter
         * is looked up; if that fails, session storage is looked up; and if that fails, the empty string is
         * returned.
         *
         * @param {String} key     The configuration (query or storage) key; never null.
         * @param {*}      [value] The value to set, if any; can be falsey. The string representation will be stored.
         *                         If empty, the existing value will be removed from session storage.
         *
         * @return {String} The configured value (as a string), or the empty string.
         */
        config: function config(key, value) {
            var v = value && value.toString() || "",
                timeout = 1000 * 60 * 60 * 4; // 4 hours, plenty of time to navigate between pages in admin mode...

            if (arguments.length > 1) {
                state.config[key] = v;
                global.session.put({ key: key, value: v === "" ? undefined : v, timeout: timeout });
            } else {
                v = state.config[key];
                if (typeof v === "undefined") {
                    v = global.loc.query[key] || global.session.get({ key: key, timeout: timeout }) || "";
                    state.config[key] = v;
                }
            }
            return v;
        },

        /**
         * Returns the default log level used (as a string), defaulting to <tt>Log.Levels.ERROR</tt>, only after
         * the channels app has been initialised.
         *
         * @return {String} The default log level after initialization as a string; can be falsey (the log setup
         *                  can handle string values).
         */
        defaultLogLevel: function defaultLogLevel() {
            return global.config(global.QUERY.logModeIdentifier);
        } // has to be defined here, and not in Log, because of cyclic dependencies!

    };

    // Multiply by 2 when on mobile devices to account for presumably slower connections...
    if (!global.capabilities.browser.desktop) {
        util.deferMultiplier(2);
    }

    return global;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(42)))

/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var util = __webpack_require__(284);

    var MARKER = "::::"; // for timestamp

    /**
     * @class
     * The <i>Storage</i> type describes the channel interaction with session and/or local storage when
     * wrapped by the <tt>Store</tt> type, ensuring a separate name space and option for timeout for values
     * in local storage (e.g. cached raw experience json).
     *
     * @param {*} storage The backing HTML5 storage, e.g. <tt>window.localStorage</tt> or <tt>window.sessionStorage</tt>.
     */
    return function (storage) {
        this.size = function () {
            return storage ? storage.length : 0;
        };

        this.key = function (index) {
            return storage ? storage.key(index) : null;
        };

        this.get = function (key, timeout) {
            var value, timestamp, i;

            if (storage) {
                value = storage.getItem(key);

                // Remove timestamp, if we we do not use it here, or the returned value is bogus...
                if (value && util.idx(value, MARKER) === 0) {
                    i = util.idx(value, MARKER, MARKER.length);
                    timestamp = util.int(value.substring(MARKER.length, i));
                    value = value.substring(i + MARKER.length);
                }

                // Remove on timeout...
                if (timestamp && timeout && util.now() - timestamp >= timeout) {
                    storage.removeItem(key);
                    value = undefined;
                }
            }
            return value;
        };

        this.put = function (key, value, timeout) {
            if (storage) {
                // Storage does not support timeout, so we have to enforce this ourselves...
                if (timeout) {
                    // Checked on "get"...
                    value = MARKER + util.now() + MARKER + value;
                }
                storage.setItem(key, value);
            }
        };

        this.remove = function (key) {
            return storage && storage.removeItem(key);
        };
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Store = __webpack_require__(1196),
        // for key prefix only
    util = __webpack_require__(284);

    // Parses the cookies into a map...
    var parse = function parse(cookie) {
        var data = { index: util.options(cookie), keys: [], external: {} },
            // external: for stuff like opt out of cookie usage... :)
        key;

        for (key in data.index) {
            // Filter out all values we know are not channel related...
            if (util.idx(key, Store.KEY_PREFIX) === 0) {
                data.keys.push(key);
            } else {
                data.external[key] = data.index[key];
                delete data.index[key];
            }
        }

        return data;
    };

    /**
     * @class
     * The <i>Cookie</i> type describes the channel interaction with (secure) cookie storage when
     * wrapped by the <tt>Store</tt> type. <p>
     *
     * Cookie storage is not well suited for storing large json date; prefer <tt>Storage</tt> for
     * that. It usage here is mainly to allow our test suites to be configured with different
     * snippet configurations as the test suite only supports cookies, not session/local storage. <p>
     *
     * The <tt>get(..)</tt> function is augmented with an optional third boolean argument that on <tt>true</tt>
     * will look up an external cookie name, for example to read an opt-out cookie name not having our
     * <tt>Store.KEY_PREFIX</tt>; the second <tt>timeout</tt> argument on get is always ignored by a
     * cookie storage as this is built-in to the cookie itself.
     *
     * @param {HTMLDocument} doc      The document defining the backing HTML5 cookie, e.g.
     *                                <tt>window.document.cookie</tt> under the document <tt>window.document</tt>.
     * @param {Boolean}      secure   True if secure (https), false otherwise (http, default).
     *
     * @return {Function} A constructor <tt>ctor(doc:Document, secure:Boolean)</tt> to create the Cookie storage
     *                    for the Cookie Store;  never falsey. The returned store can also index external cookie
     *                    keys using <tt>this.get(key, ignoredTimeout, true)</tt>, e.g. to read cookies like
     *                    opt-out cookies.
     */
    return function (doc, secure) {
        var scope = this,
            storage = function storage() {
            if (!_storage) {
                _storage = parse(doc.cookie);
            }
            return _storage;
        },
            _storage = null;

        this.size = function () {
            return storage().keys.length;
        };

        this.key = function (index) {
            return storage().keys[index];
        };

        // timeout (second argument) never used on get, set on put as per standard cookie behaviour,
        // but supplied by default from Store...
        this.get = function (key) {
            return storage()[arguments[2] ? "external" : "index"][key];
        };

        this.put = function (key, value, timeout) {
            var expires = "",
                postfix = "; path=/";

            if (timeout) {
                var date = util.now();
                date.setTime(date.getTime() + timeout);
                expires = "; expires=" + date.toGMTString();
            }
            if (secure) {
                postfix += "; secure";
            }
            doc.cookie = key + "=" + value + expires + postfix;
            _storage = null; // force re-parse when needed
        };

        this.remove = function (key) {
            scope.put(key, "", -1);
            _storage = null; // force re-parse when needed
        };
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var format = __webpack_require__(464),
        util = __webpack_require__(284);

    /** Log levels, mimics verbose Logger levels. */
    var Levels = {
        OFF: 0,
        ERROR: 1,
        LOG: 2,
        VERBOSE: 3
    };

    /**
     * @constructor
     * Instantiable and configurable log, backed by the actual global logger implementation.
     *
     * @param {String} [name]  The log name; will default to "Channels".
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    function Log(name) {
        /**
         * @type {String}
         * The logical id of this log.
         */
        this.id = name || "Channels"; // also used for backing "Timer" log!
        /**
         * @private @type {Number}
         * The log level for *this* snippet.
         */
        this._level = Levels.ERROR;
        /**
         * @type {{info:Function, error:Function}}
         * The console used to write log messages to the log for this snippet, if any. <p>
         *
         * Can be undefined, and will only be called if logging is explicitly enabled (not OFF).
         */
        this._out = window.console;

        var scope = this;

        /**
         * Sets and/or gets the log level for this snippet.
         *
         * @param {Number|String} level The optional level to set; can be undefined.
         * @return {Number} The current log level (just set); defaults to <tt>Levels.ERROR</tt>.
         */
        this.level = function (level) {
            if (arguments.length) {
                if (typeof level !== "number") {
                    level = util.int(level);
                }
                var old = scope._level;
                scope._level = Math.min(Levels.VERBOSE, Math.abs(level) || Levels.OFF); // on NaN
                if (old !== scope._level) {
                    scope.info("Set new log level: ", format.val(scope.id), " -> ", scope._level);
                }
            }
            return scope._level;
        };

        // Signature matches verbose Logger implementation used by viewer and editor
        this.error = function () {
            Logger.print(scope, Levels.ERROR, arguments);return scope;
        };
        this.info = function () {
            Logger.print(scope, Levels.LOG, arguments);return scope;
        };
        this.verbose = function () {
            Logger.print(scope, Levels.VERBOSE, arguments);return scope;
        };

        /**
         * Returns the queued log messages for this logger, either as raw entries or formatted strings.
         *
         * @param {Boolean} [raw] True for "raw" entries, false for formatted strings; default false.
         * @return {String[]|*} The array of (formatted/raw) entries; never null, but can be empty.
         */
        this.queue = function (raw) {
            // for Viewer
            var queue = Logger._queue[scope.id] || [];
            if (raw) {
                return queue;
            }
            var formatted = [],
                entry,
                i;

            for (i = 0; i < queue.length; i++) {
                entry = queue[i];
                // We do not want to change the "entry.printed" property when the queue is requested, since that will
                // change the behaviour of the channel logging if enabled later on...
                if (!entry.formatted) {
                    Logger._format(scope.id, entry); // will update "entry.formatted", but not "entry.printed"!
                }
                formatted.push(entry.formatted);
            }
            return formatted;
        };
    }

    /**
     * A simple *internal* logger implementation that will queue all logged messages, even if logging is turned off,
     * and can log to the console or to the dom. The public interface is the (small) public <tt>Log</tt> type, thus
     * backed by this implementation. <p>
     *
     * Queued messages can be picked up by the Viewer and sent to the Frontend Error Service on error, for easier
     * debugging.
     */
    var Logger = {

        /**
         * @private @type {*}
         * Queue of all logged messages, regardless if logging is turned off or not, indexed by their snippet
         * config id. <p>
         *
         * Each queue is an array of messages declared as:
         * <pre>
         * {
         *     level:   Number,  // the log level from "Levels"
         *     msg[]:   Object,  // the log message / data
         *     time:    Date,    // the timestamp for the log message in ms since the epoch
         *     printed: Boolean, // true if actually printed (logged), false if merely enqueued
         * }
         * </pre>
         *
         * Queue will be purged on success or on failure by the Viewer, in which case it will be sent to the
         * Frontend Error Service. For this reason, this array is global.
         */
        _queue: {},

        /**
         * @private
         * Global log for log messages not specifically related to a given snippet, e.g. script loading.
         */
        _global: null, // cannot create yet, cyclic dependencies

        /**
         * Setups the supplied log by creating its "out" ("console") to log messages to. <p>
         *
         * @param {Log} log               The log to setup; cannot be null. Setting up the same log twice will
         *                                override its existing "out" ("console").
         * @param {String|Number} [level] The initial log level for <tt>log</tt>, defaults to <tt>Levels.ERROR</tt>.
         * @return {Log} <tt>log</tt>, now setup (if not already).
         */
        setup: function setup(log, level) {
            var old = log._level;
            // Ensure the log has the initial level, so it can be changed later on...
            level = log.level(level);

            // Lower or same level -> nothing to do. Note that this can "leave holes" in the log if for example
            // original log level was 1, then enabled with 2 - all 3 (VERBOSE) will not be logged then, only next
            // time when, and if ever, the log level is set to 3. This is normal behaviour. But, since all below
            // 3 has already been printed, only the missing messages with 3 will be printed then, thus causing
            // "holes" where all messages with a lower level should be (already haven been) printed.
            if (level > old) {
                Logger._dequeue(log);
            }
            return log;
        },

        /**
         * @private
         * Enqueues the specified log message for the supplied log.
         *
         * @param {Log}       log    The log to enqueue the log message for; never null.
         * @param {Number}    level  The log level from <tt>Levels</tt>.
         * @param {Arguments} msg    The log message/data to log; never falsey.
         */
        _enqueue: function _enqueue(log, level, msg) {
            var entry = {
                level: level, msg: msg, formatted: null, time: new Date(), printed: false
            },
                queue = Logger._queue[log.id]; // we need a Date, not ms, for easy formatting
            if (!queue) {
                queue = [];
                Logger._queue[log.id] = queue;
            }
            queue.push(entry);
            return entry;
        },

        /**
         * @private
         * Dequeues all logged messages for the supplied log. <p>
         *
         * A dequeued message will only be logged if its log level confirms to the log level of the supplied log. <p>
         *
         * This will not remove log messages from the queue!
         *
         * @param {Log} log The log to dequeue log messages for; never null.
         */
        _dequeue: function _dequeue(log) {
            // Will print each queued message so far that has not already been logged. It will not clear the queue,
            // since the viewer will potentially use the queue...
            var queue = Logger._queue[log.id] || [],
                i;

            for (i = 0; i < queue.length; i++) {
                Logger._out(log, queue[i]);
            }
        },

        /**
         * @private
         * Prints the specified log entry, tagging it as printed if it has a log level that matches the
         * logs configured level. <p>
         *
         * The logged message will be prefixed with the id of the log like "[Channels:" + log.id + "]", if more
         * than one snippet is currently found. If the log does not have an id, specified at construction time,
         * or only a single snippet, the prefix is simply "[Channels]".
         *
         * @param {Log} log   The log to log the entry for; never null.
         * @param {*}   entry The log entry to print; never null.
         */
        _out: function _out(log, entry) {
            // Only do the actual logging if so configured. The snippet log can be undefined if for example console
            // logging is enabled, but the developer tools are disabled...
            var out = log._out;
            if (typeof out !== "undefined" && entry.level <= log.level() && !entry.printed) {
                // Will update "entry.formatted" with formatted log message and return all data to log as data objects...
                var data = Logger._format(log.id, entry);
                // Log formatted message...
                out[entry.level === Levels.ERROR ? "error" : "info"](entry.formatted);
                // Log data object(s), if any...
                if (data.length === 1) {
                    out.info(data[0]);
                } else if (data.length > 1) {
                    out.info(data);
                }
                entry.printed = true;
            }
        },

        /**
         * Formats the specified entry (again) into a string, storing it under <tt>entry.formatted</tt>, and returns
         * all data objects to log as well. <p>
         *
         * The formatted string will reflect the current value of each data object included in the formatting.
         *
         * @param {String} id    The log id; never null.
         * @param {*}      entry The log entry to format; never null.
         * @return {[]} The data to log as objects (non formatted); never null, but can be empty.
         */
        _format: function _format(id, entry) {
            var data = [],
                sepA = ":",
                sepB = " ->",
                i;

            var flip = function flip() {
                var tmp = sepA;
                sepA = sepB;sepB = tmp;
            };

            var formatter = function formatter(value, recursive) {
                var type = typeof value === "undefined" ? "undefined" : _typeof(value);
                if (type === "undefined") {
                    value = "undefined";
                } else if (type === "string") {
                    if (util.idx(value, sepA) !== -1) {
                        flip();
                    }
                } else if (type === "object") {
                    // Handle null...
                    if (value === null) {
                        value = "null";

                        // Handle arrays recursively...
                    } else if (typeof value.length === "number") {
                        var j,
                            v = sepA + " [";

                        for (j = 0; j < value.length; j++) {
                            if (j) {
                                v += ", ";
                            }
                            v += formatter(value[j], true);
                        }
                        value = v + "]";

                        // Handle object...
                    } else {
                        // Some data value to log as-is, but perhaps also as formatted...
                        data.push(value);
                        // Lookup formatter and format value accordingly, will default to "format.str"...
                        value = format(value);

                        if (!recursive) {
                            value = sepA + " " + value;
                            flip();
                        }
                    }
                }
                return value;
            };

            entry.formatted = "[" + id + "] " + entry.time.getHours() + ":" + entry.time.getMinutes() + ":" + entry.time.getSeconds() + ":" + entry.time.getMilliseconds() + " ";
            for (i = 0; i < entry.msg.length; i++) {
                entry.formatted += formatter(entry.msg[i]);
            }
            return data;
        },

        /**
         * Prints the supplied message and optional data object for the specified log and level. <p>
         *
         * If both <tt>msg</tt> and <tt>object</tt> are falsey, nothing will be printed, nor enqueued.
         *
         * @param {Log}          log    The log in question; cannot be null.
         * @param {Number}       level  The log level from <tt>Levels</tt>; defaults to <tt>Levels.OFF</tt>.
         * @param {Arguments|[]} msg    The log message/data to log; can be falsey
         */
        print: function print(log, level, msg) {
            if (msg && msg.length) {
                Logger._out(log, Logger._enqueue(log, level, msg));
            }
        }
    };

    // Create default global and timer loggers, not initialised until the channels app is initialised before start...
    Logger._global = new Log();
    Logger._timer = new Log("Timer");

    // Expose log levels and global log!
    Log.Levels = Levels;
    Log.setup = Logger.setup;

    Log.global = function () {
        return Logger._global;
    };
    Log.timer = function () {
        return Logger._timer;
    };

    return Log;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2843 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="form-controls create-slot-lightbox">\n    <div class="row slot-name">\n        <div class="col-xs-12 editable-container">\n            <h4>\n                <div contenteditable="' +
__e( !notAllowedToPublish) +
'" class="editable name';
if(notAllowedToPublish){;
__p += ' disabled';
};
__p += '" ';
if(notAllowedToPublish){;
__p += 'disabled';
};
__p += '>' +
__e( slotName ) +
'</div>\n            </h4>\n        </div>\n    </div>\n    <div class="row slot-info-container">\n        <div class="col-xs-4">\n            <div class="title">CSS Selector</div>\n            <input type="text" class="selector';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' placeholder="Enter CSS Selector">\n        </div>\n        <div class="col-xs-4">\n            <div class="title">URL</div>\n            <input type="text" class="url';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' placeholder="URL (optional)">\n        </div>\n    </div>\n    <div class="row experience-info-container">\n        <div class="col-xs-4">\n            <div class="channel-numeric-icon title" data-icon-number="1">Live</div>\n            <input type="hidden" class="live-select';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '>\n        </div>\n        <div class="col-xs-4">\n            <div class="channel-numeric-icon title" data-icon-number="2">Scheduled</div>\n            <input type="hidden" class="next-select';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '>\n        </div>\n        <div class="col-xs-4">\n            <div class="form-group">\n                <div class="title">Scheduled Date</div>\n                <div class="empty-schedule-date"> - </div>\n                <div class=\'input-group date next-start-time-picker\'>\n                    <input type=\'text\' class="form-control next-start-time';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' data-format="yyyy-MM-dd"/>\n                    ';
 if (!notAllowedToPublish) { ;
__p += '\n                        <span class="input-group-addon"><span class="glyphicon glyphicon-calendar"></span>\n                    ';
 } ;
__p += '\n                    </span>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="actions">\n        <span class="slot-schedule-notification">Scheduling \'No Experience\' will take down the Live Experience from your Slot.</span>\n        <button class="btn-ok btn btn-primary pull-right';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '>OK</button>\n        <button class="btn-cancel btn btn-secondary pull-right">Cancel</button>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        first = _require.first;

    var ViewController = __webpack_require__(126);
    var Publishables = __webpack_require__(462);
    var PublishUtil = __webpack_require__(234);

    var _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank;

    var ImprovedModel = __webpack_require__(25);

    /**
     * Fetches publishable models (experiences/groups)
     *
     * @param {String} term           The search term used to match and filter publishables.
     * @param {ProjectModel} project  The project model.
     * @returns {Promise}             Promise holding information about publishables.
     */
    var getPublishables = function getPublishables(term, project) {
        return Publishables.fetch({ project: project, term: term });
    };

    /**
     * View Controller of a channel property view, handling logic to lazy load manual slot dropdowns, both Live and Scheduled.
     *
     */
    return ViewController.extend({

        _currentPublishableCollection: null,

        _areProjectSlotsLoaded: false,

        _areAllSlotsBeingLoaded: false,

        _limit: 20,

        /**
         * Initializes the dropdown values when lightbox is opened.
         *
         * @param {Function}                    callback  Select2 callback function to be used to set the data.
         * @param {ExperienceModel|GroupModel}  model     The model to be set as value to the dropdown.
         */
        onViewInitSelection: function onViewInitSelection(callback, model) {
            if (model) {
                var text = null;

                if (model instanceof ImprovedModel) {
                    text = model.publishableDisplayName();
                } else {
                    text = model.name;
                }
                callback({ id: model, text: text });
            }
        },


        /**
         * Populates the dropdowns in the manual publishing lightbox implementing lazy loading.
         *
         * @param {Object} options        Select2 options contaning info such as searched term, callback function and current page.
         * @param {ProjectModel} project  The project model.
         * @param {Boolean} schedule      Whether scheduling should be taken into account or not.
         */
        onViewFetchResults: function onViewFetchResults(options, project, schedule) {
            var _this = this;

            var callback = options.callback,
                page = options.page,
                term = options.term;

            // We want to make sure we clear previous/pending searches

            if (page === 1 && this._currentPublishableCollection) {
                this._reset();
            }

            if (page === 1) {
                if (isBlank(term)) {
                    var publishableOptions = this.options;
                    if (project && this._currentPublishableCollection) {
                        var publishableCollection = this._currentPublishableCollection;
                        var publishableDescriptors = Publishables.descriptors(publishableCollection.models());

                        this._currentPublishableCollection.options.project = project;
                        this._currentPublishableCollection.options.term = term;

                        publishableOptions = { publishableCollection: publishableCollection, publishableDescriptors: publishableDescriptors };
                    }
                    this._populateSlots(publishableOptions, options, project, schedule);
                } else {
                    // Refetch results when already searching or on scrolled pages.
                    getPublishables(term, project).then(function (publishables) {
                        _this._populateSlots(publishables, options, project, schedule);
                    });
                }
            } else if (!this._currentPublishableCollection.isPending() && this._currentPublishableCollection.hasMore()) {
                this._currentPublishableCollection.next().then(function (publishableCollection) {
                    var results = [];

                    if (publishableCollection.length) {
                        results.push({
                            text: PublishUtil.PENDING_OPT_GROUP_RESULT,
                            children: publishableCollection.map(function (content) {
                                return {
                                    text: content.publishableDisplayName(),
                                    id: content
                                };
                            })
                        });
                    }

                    var more = _this._currentPublishableCollection && _this._currentPublishableCollection.hasMore();
                    _this._areProjectSlotsLoaded = project && !more;

                    // if all Project Slots have been loaded and not "All" slots have been loaded yet...
                    if (_this._areProjectSlotsLoaded && !_this._areAllSlotsBeingLoaded) {
                        _this._populateNextSlots({
                            callback: callback, results: results, more: more, term: term
                        });
                    } else {
                        _this._callbackAndCleanup({ callback: callback, results: results, more: more });
                    }
                });
            }
        },
        _populateSlots: function _populateSlots(publishables, options, project, schedule) {
            var callback = options.callback,
                term = options.term;
            var publishableCollection = publishables.publishableCollection,
                publishableDescriptors = publishables.publishableDescriptors;


            var results = term ? [] : [PublishUtil.EMPTY_SLOT];

            if (schedule && isBlank(term)) {
                results.push(PublishUtil.EMPTY_SCHEDULED_SLOT);
            }

            if (!publishableCollection.isEmpty()) {
                results.push(this._buildResult(project, publishableDescriptors));
            }

            var more = publishableCollection && publishableCollection.hasMore();

            this._areProjectSlotsLoaded = project && !more;
            this._areAllSlotsBeingLoaded = !project;
            this._currentPublishableCollection = publishableCollection;

            // if all Project Slots have been loaded, then we need to start fetch "All"
            if (this._areProjectSlotsLoaded) {
                this._populateNextSlots({
                    callback: callback, results: results, more: more, term: term
                });
            } else {
                this._callbackAndCleanup({ callback: callback, results: results, more: more });
            }
        },
        _populateNextSlots: function _populateNextSlots(_ref) {
            var _this2 = this;

            var callback = _ref.callback,
                results = _ref.results,
                more = _ref.more,
                term = _ref.term;

            getPublishables(term).then(function (allPublishables) {
                var publishableCollection = allPublishables.publishableCollection,
                    publishableDescriptors = allPublishables.publishableDescriptors;


                if (!publishableCollection.isEmpty()) {
                    results.push(_this2._buildResult(null, publishableDescriptors));
                }

                _this2._areAllSlotsBeingLoaded = true;
                _this2._currentPublishableCollection = publishableCollection;

                more = publishableCollection.hasMore();
                _this2._callbackAndCleanup({ callback: callback, results: results, more: more });
            });
        },
        _reset: function _reset() {
            this._currentPublishableCollection.reset(first(this.options.publishableCollection.models(), this._limit));
            this._areAllSlotsBeingLoaded = false;
        },
        _buildResult: function _buildResult(project, publishableDescriptors) {
            return {
                text: project ? "This Project" : "All",
                children: publishableDescriptors.map(function (content) {
                    return { id: content.model, text: content.name };
                })
            };
        },
        _callbackAndCleanup: function _callbackAndCleanup(_ref2) {
            var callback = _ref2.callback,
                results = _ref2.results,
                more = _ref2.more;

            if (!this.view.isClosed) {
                callback({
                    results: results,
                    more: more
                });

                this.view.removeEmptyOptGroups();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2845 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (showPublishButton || showAttachButton) { ;
__p += '\n    <div class="buttons-container">\n        ';
 if (showPublishButton) { ;
__p += '\n            <button id="publish-channels" class="btn pull-right ladda-button';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' data-spinner-size="28" data-style="expand-right"></button>\n        ';
 } ;
__p += '\n        ';
 if (showAttachButton) { ;
__p += '\n            <button id="attach-channels" class="attach-button btn btn-grey pull-right ';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '" ';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '>Attach</button>\n        ';
 } ;
__p += '\n    </div>\n';
 } ;
__p += '\n\n';
 if (showAttachHeader) { ;
__p += '\n    <h4 class="attach-header">' +
__e( attachHeader ) +
' <span class="count thin">(' +
__e( itemCount ) +
')</span></h4>\n';
 } ;
__p += '\n\n\n<div class="channels-header">\n    <span class="head-slot-col slot-col">Slot</span>\n    <span class="live-now-col channel-numeric-icon" data-icon-number="1">Live</span>\n    <span class="live-next-col channel-numeric-icon" data-icon-number="2">Scheduled</span>\n    <span class="live-date-col">Scheduled Date</span>\n    <span class="action-column slot-options-col"></span>\n</div>\n';
 if (allowedToPublish && showCreateSlotField) { ;
__p += '\n    <div class="slot-divider"><td colspan="5"></div>\n    <div class="create-new-slot">&#43; <span id="create-new-slot">Create New Slot';
 if (showCreateSlotInProjectLabel) { ;
__p += ' In Project';
 } ;
__p += '</span></div>\n    <div class="slot-divider no-border"><td colspan="5"></div>\n';
 } ;
__p += '\n\n<div class="content collection channel-items"></div>\n';
 if (showAttachActions) { ;
__p += '\n    <div class="actions">\n        <button class="btn-ok-attach attach-button btn btn-primary pull-right ladda-button';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (!allowedToPublish) { ;
__p += ' disabled';
 } ;
__p += ' data-spinner-size="28" data-style="expand-right">Attach</button>\n        <button class="btn-cancel-attach btn btn-secondary pull-right">Cancel</button>\n    </div>\n';
 } ;
__p += '\n\n';

}
return __p
}

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Promise = __webpack_require__(21);
    /**
     * @class {ChannelChangesInfo}
     *
     * Class handling channel changes in Publish Tab.
     */

    var ChannelChangesInfo = function () {
        function ChannelChangesInfo() {
            _classCallCheck(this, ChannelChangesInfo);

            this.addedChannels = new Set();
            this.updatedChannels = new Map();
            this.deletedChannels = new Map();
        }

        _createClass(ChannelChangesInfo, [{
            key: "handleAdd",
            value: function handleAdd(channel) {
                this.addedChannels.add(channel);
            }
        }, {
            key: "handleUpdate",
            value: function handleUpdate(channel) {
                var channelId = channel.get("id");
                if (channelId && !this.updatedChannels.has(channelId)) {
                    this.updatedChannels.set(channelId, channel);
                }
            }
        }, {
            key: "handleDelete",
            value: function handleDelete(channel) {
                // if channel already exists
                var channelId = channel.get("id");
                if (channelId) {
                    if (this.updatedChannels.has(channelId)) {
                        this.updatedChannels.delete(channelId);
                    }
                    this.deletedChannels.set(channelId, channel);

                    // if channel was newly added and not saved yet
                } else {
                    this.addedChannels.delete(channel);
                }
            }
        }, {
            key: "clear",
            value: function clear() {
                this.addedChannels.clear();
                this.updatedChannels.clear();
                this.deletedChannels.clear();
            }
        }, {
            key: "hasAny",
            value: function hasAny() {
                return this.addedChannels.size > 0 || this.updatedChannels.size > 0 || this.deletedChannels.size > 0;
            }

            /**
             * Returns current modified channels as a list.
             *
             * @returns {Array} Array of {@link Channel}s.
             */

        }, {
            key: "asList",
            value: function asList() {
                var _convertToLists2 = this._convertToLists(),
                    addedChannelsList = _convertToLists2.addedChannelsList,
                    updatedChannelsList = _convertToLists2.updatedChannelsList,
                    deletedChannelsList = _convertToLists2.deletedChannelsList;

                return addedChannelsList.concat(updatedChannelsList, deletedChannelsList);
            }

            /**
             * Returns a promise with all actions that should be performed on channels, including creation , deletion and updates.
             *
             * @returns {Promise} promise resolving with information about the channels taht need to be read or modified by the backend.
             */

        }, {
            key: "applyChanges",
            value: function applyChanges() {
                var _convertToLists3 = this._convertToLists(),
                    addedChannelsList = _convertToLists3.addedChannelsList,
                    updatedChannelsList = _convertToLists3.updatedChannelsList,
                    deletedChannelsList = _convertToLists3.deletedChannelsList;

                var addedAndUpdatedChannels = addedChannelsList.concat(updatedChannelsList);
                var promises = [];

                addedAndUpdatedChannels.forEach(function (channel) {
                    promises.push(function () {
                        return channel.save();
                    });
                });

                deletedChannelsList.forEach(function (channel) {
                    promises.push(function () {
                        return channel.destroy();
                    });
                });

                return this._executeChannelActions(promises);
            }

            /**
             * Converts Sets and Maps to List, in absence of support of spread operator in IE11.
             *
             * @returns {Object} object containing information about added, updated and deleted channels as arrays.
             */

        }, {
            key: "_convertToLists",
            value: function _convertToLists() {
                var addedChannelsList = [];
                var updatedChannelsList = [];
                var deletedChannelsList = [];

                // Cannot use [...this.addedChannels} because of IE11...
                this.addedChannels.forEach(function (addedChannel) {
                    addedChannelsList.push(addedChannel);
                });

                this.updatedChannels.forEach(function (updatedChannel) {
                    updatedChannelsList.push(updatedChannel);
                });

                this.deletedChannels.forEach(function (deletedChannel) {
                    deletedChannelsList.push(deletedChannel);
                });

                return {
                    addedChannelsList: addedChannelsList,
                    updatedChannelsList: updatedChannelsList,
                    deletedChannelsList: deletedChannelsList
                };
            }

            /**
             * Executes all sequential requests regardless of success of failure.
             *
             * @returns {Promise} promise resolving with information about the channels being executed sequentially.
             */

        }, {
            key: "_executeChannelActions",
            value: function _executeChannelActions(promiseFactories) {
                var _this = this;

                var task = promiseFactories.shift();
                if (task) {
                    return task().then(function () {
                        return _this._executeChannelActions(promiseFactories);
                    }).fail(function () {
                        return _this._executeChannelActions(promiseFactories);
                    });
                }

                return Promise.resolved();
            }
        }]);

        return ChannelChangesInfo;
    }();

    return ChannelChangesInfo;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var InfiniteScrollingCollectionView = __webpack_require__(259);
    var NoResultsItemView = __webpack_require__(207);
    var ChannelSetupItemView = __webpack_require__(701);

    /**
     * A <tt>InfiniteScrollingCollectionView</tt> subclass for displaying (and lazy loading) channels in Manual Publishing.
     *
     * @see  ChannelCollection
     * @see  InfiniteScrollingCollectionView
     *
     * @class ChannelCollectionView
     */
    return InfiniteScrollingCollectionView.extend("ChannelCollectionView", {

        itemView: ChannelSetupItemView,

        onEmpty: function onEmpty() {
            return new NoResultsItemView({ type: "Slots" });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        extend = _require.extend,
        map = _require.map,
        clone = _require.clone;

    var ViewController = __webpack_require__(126);
    var ChannelPropertiesView = __webpack_require__(1195);
    var Channel = __webpack_require__(233);
    var Lightbox = __webpack_require__(101);
    var LoggedIn = __webpack_require__(31);
    var Time = __webpack_require__(121);
    var PublishUtil = __webpack_require__(234);

    /**
     * View Controller of a channel item view.
     *
     */
    return ViewController.extend({
        /**
         * Triggered when the user has clicked on an row for a given channel to edit. <p>
         *
         * <tt>field</tt> will be the class name of the target element clicked in the row, e.g. "next-experience"
         * if the title of the Experience scheduled to go live next was clicked.
         *
         * @param {String}  property The channel property the user clicked on to gain focus now, if any, e.g.
         *                           "name", or "experience". Can be falsey, i.e. just open view without focus.
         */
        onViewEditOpened: function onViewEditOpened(property) {
            var realChannel = this.model;
            var tmpChannelOptions = realChannel.pick("name", "selector", "url", "id", "experience", "group", "publishable");

            extend(tmpChannelOptions, {
                schedules: map(realChannel.get("schedules"), clone)
            });

            var tmpChannel = new Channel(tmpChannelOptions);

            var selectedLiveModel = void 0;
            var selectedScheduledModel = void 0;

            if (realChannel.hasLive()) {
                selectedLiveModel = realChannel.get("publishable");
            }

            if (realChannel.hasSchedule()) {
                var schedule = realChannel.getFirstSchedule();
                if (schedule.takeDownCurrent) {
                    selectedScheduledModel = PublishUtil.NO_EXPERIENCE_SCHEDULED;
                } else {
                    selectedScheduledModel = schedule.publishable;
                }
            }

            this._openChannelSlotLightbox(realChannel, tmpChannel, property, selectedLiveModel, selectedScheduledModel);
        },
        _openChannelSlotLightbox: function _openChannelSlotLightbox(realChannel, tmpChannel, property, selectedLiveModel, selectedScheduledModel) {
            var _this = this;

            var _options = this.options,
                publishableDescriptors = _options.publishableDescriptors,
                publishableCollection = _options.publishableCollection,
                projectContext = _options.projectContext;

            var channelPropertiesView = new ChannelPropertiesView({
                parentView: this.view,
                model: tmpChannel,
                isNewSlot: false,
                focus: property,
                selectedLiveModel: selectedLiveModel,
                selectedScheduledModel: selectedScheduledModel,
                publishableDescriptors: publishableDescriptors,
                publishableCollection: publishableCollection,
                projectContext: projectContext,
                allowedToPublish: this.view._allowedToPublish

            });

            channelPropertiesView.once("done", function (channel) {
                var principal = LoggedIn.principal();
                channel.set({
                    editedBy: principal.get("userId"),
                    companyId: principal.get("companyId"),
                    editedAt: Time.server(),
                    version: realChannel.get("version")
                });

                realChannel.set(channel.attributes);

                // Can still be dnd...
                var manual = !!realChannel.get("manual");
                var attribute = void 0;

                if (!manual) {
                    // Ignore "editedAt" and "editedBy"...
                    for (attribute in realChannel.changed) {
                        if (attribute !== "editedAt" && attribute !== "editedBy") {
                            realChannel.set("manual", true);
                            break;
                        }
                    }
                }

                _this.options.parentView.trigger("handleChanges", "update", realChannel);
            });

            var options = {
                css: {
                    width: 830
                },
                editorEventProperties: {
                    modalType: "ChannelSlotProperties",
                    triggerOrigin: "ExistingChannelSlotModal",
                    isNewSlot: false
                }
            };

            var box = new Lightbox(channelPropertiesView, options);

            box.open();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2849 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span id="channel-' +
__e(id) +
'" class="slot-col">\n    <span class="slot-name"></span>\n    <div class="channel-tooltip" style="display:none">\n        <div><strong>CSS Selector</strong>: <span class="selector"></span></div>\n        <div><strong>Url</strong>: <span class="url"></span></div>\n        <div><strong>Last updated</strong>: <span class="editedat"></span></div>\n    </div>\n</span>\n<span class="live-now-col">\n    <span class="live"></span>\n</span>\n<span class="live-next-col">\n    <span class="next"></span>\n</span>\n<span class="live-date-col">\n    <span class="live-date"></span>\n</span>\n<span class="slot-options-col">\n    <div class="actions-panel">\n        ';
 if (!allowedToPublish) { ;
__p += '\n            <span class="delete pull-right disabled" data-content="You do not have permission to delete Slots"></span>\n        ';
 } else { ;
__p += '\n            <span class="delete pull-right" data-content="Delete Slot"></span>\n        ';
 } ;
__p += '\n    </div>\n</span>\n';

}
return __p
}

/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var NotificationBar = __webpack_require__(53);
    var CONSTANTS = __webpack_require__(209);

    /**
     * The view model for removing incompatible widgets.
     *
     * @class IncompatibleWidgetsPopupModel
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            state: CONSTANTS.CLOSE
        },
        experienceModel: null,
        allIncompatibleWidgets: [],
        notificationId: null,
        systemMessage: null,

        initialize: function initialize() {
            this.allIncompatibleWidgets = this.get("allIncompatibleWidgets");
            this.viewModel = this.get("viewModel");
            this.systemMessage = this.get("systemMessage");
            this.listenTo(this, "change:state", this._stateChangeHandler);
        },

        _stateChangeHandler: function _stateChangeHandler() {
            if (this.get("state") === CONSTANTS.OPEN_NOTIFICATION) {
                this.systemMessage = this.systemMessage.replace(": ", ": " + this.get("widgetsName"));
                this.notificationId = NotificationBar.open({ message: this.systemMessage, action: "removeIncompatibleWidgets" }, {
                    closeable: false,
                    popupModel: this
                });
            }
            if (this.get("state") === CONSTANTS.REMOVE_WIDGETS) {
                // close the popup and then delete the invalid widgets
                this.set("state", CONSTANTS.CLOSE);
                var scene = this.viewModel.get("activeLayerSceneModel");
                scene.deleteWidgets(this.allIncompatibleWidgets, { cause: "GROUP" });
                this.allIncompatibleWidgets = [];
                NotificationBar.close({ id: this.notificationId });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2851 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="zmags-section wide">\n    <div class="dnd-publish-panel">\n        <div class="row">\n            <div class="col-xs-4">\n                <h4>Drag\'n Drop Publishing</h4>\n            </div>\n            <div class="col-xs-8">\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-xs-4">\n                <p>See how your Experiences look on your site';
 if (allowedToPublish) { ;
__p += ', publish them right away or schedule them to go live later';
 } ;
__p += '.\n                Enter the URL for the website you want to ';
 if (allowedToPublish) { ;
__p += 'publish';
 } else { ;
__p += 'see';
 } ;
__p += ' and/or preview Experiences on.</p>\n            </div>\n            <div class="col-xs-4">\n                <label class="url-label">Enter website URL:</label>\n                <form class="js-go-to-address-form go-to-address-form">\n                    <div class="flexible">\n                        <input id="url-input" class="url-box" type="text" placeholder="Enter your website URL and click Go"/>\n                    </div>\n                    <button type="submit" class="js-go-address-button btn btn-primary go-button">Go</button>\n                </form>\n            </div>\n            <div class="col-xs-4">\n                <div class="snippet-container">\n                    <div class="title">\n                        <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">Prepare Your Site For Publishing</span>\n                    </div>\n                    <p class="description">To publish Experiences, you have to add this snippet to the header of your site.</p>\n                    <a id="publish-prepare-link">Snippet</a>\n                    <div id="publish-details" data-toggle="popover" data-placement="top" data-trigger="hover" data-content="Click and press ' +
__e(button) +
'+C to copy.">\n                        ' +
__e(snippet) +
'\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="manual-publish-panel">\n        <h4><span id="manual-publishing">Manual Publishing</span></h4>\n        <p>Manually manage slots and schedule Experiences to publish.</p>\n        <section id="channel-setup-region"></section>\n    </div>\n</section>\n';

}
return __p
}

/***/ }),
/* 2852 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="zmags-section wide">\n    <div class="image-library-region"></div>\n</section>\n';

}
return __p
}

/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var ContentQuery = __webpack_require__(139);
    var EditBehavior = __webpack_require__(106);
    var ImageTagCompositeView = __webpack_require__(557);
    var InventoryTagCompositeView = __webpack_require__(867);
    var ImageDetailsTrackingBehavior = __webpack_require__(863);
    var ImageExperienceCompositeView = __webpack_require__(2854);
    var template = __webpack_require__(2858);

    /**
     * Represents the image quick view contents, containing detailed information about a specific image.
     *
     * @cfg {ImageModel} model the image model.
     *
     * @see DetailedImageLibraryCollectionView
     *
     * @class ImageDetailsView
     */
    return ImprovedView.extend("ImageDetailsView", {

        template: template,

        templateHelpers: function templateHelpers() {
            var _options = this.options,
                imageTaggingEnabled = _options.imageTaggingEnabled,
                inventoryEnabled = _options.inventoryEnabled,
                spectatorMode = _options.spectatorMode,
                experienceCount = _options.experienceCount,
                partialViewOptions = _options.partialViewOptions;


            return {
                editable: !spectatorMode,
                showTags: imageTaggingEnabled,
                showInventory: inventoryEnabled,
                showExperiences: partialViewOptions && partialViewOptions.showExperiences,
                experienceCount: experienceCount
            };
        },


        className: "image-details-view",

        ui: {
            "addTagInput": ".add-tag-input",
            "toggleExperiencesButton": ".toggle-experiences-button",
            "experiencesAccordion": ".image-experiences-collection-region"
        },

        regions: {
            "tagsCollectionRegion": ".tags-collection-region",
            "inventoryTagsCollectionRegion": ".inventory-collection-region",
            "experiencesRegion": ".image-experiences-collection-region"
        },

        events: {
            "click @ui.toggleExperiencesButton": "_toggleExperiences"
        },

        behaviors: {
            nameEditBehavior: {
                behaviorClass: EditBehavior,
                container: ".image-name",
                editFields: [{
                    input: ".edit-name",
                    model: "name",
                    save: function save() {
                        this.model.saveLater();
                    }
                }]
            },
            altTextEditBehavior: {
                behaviorClass: EditBehavior,
                container: ".js-alt-text-editable-container",
                editFields: [{
                    input: ".js-alt-text",
                    icon: ".js-alt-text-icon",
                    model: "altText",
                    save: function save() {
                        this.model.saveLater();
                    }
                }]
            },
            imageEditingTracking: {
                behaviorClass: ImageDetailsTrackingBehavior,
                tracking: {
                    name: "EditImageNameInputFieldQuickView",
                    altText: "EditImageAltTextInputFieldQuickView"
                }
            }
        },

        bindings: {
            ".edit-name": {
                observe: "name",
                updateMethod: "html",
                escape: true
            },
            ".js-alt-text": {
                observe: "altText",
                updateMethod: "html",
                escape: true
            }
        },

        modelEvents: {
            "change:tags[*]": "_changeTagsHandler"
        },

        _tagsCollection: null,
        _inventoryTagsCollection: null,
        _imageTagsCollection: null,
        _experienceCollection: null,
        _togglingExperiences: false, // True if toggling is in progress

        _changeTagsHandler: function _changeTagsHandler(changedTagModel) {
            var value = changedTagModel.get("name");
            var nameExists = this._tagsCollection.models.find(function (tagModel) {
                if (tagModel === changedTagModel) {
                    return false;
                }
                return tagModel.get("name").toUpperCase() === value.toUpperCase();
            });

            if (nameExists) {
                changedTagModel.destroy();
            }

            this.model.saveLater();
        },
        initialize: function initialize() {
            var _this = this;

            this._tagsCollection = this.model.get("tags");
            this._imageTagsCollection = this.model.get("imageTags");
            this._inventoryTagsCollection = this.model.get("inventoryTags");
            this._experienceCollection = this.options.experienceCollection;

            this.listenTo(this._imageTagsCollection, "add remove", function () {
                _this._imageTagsCollection.sort();
                _this.model.saveLater();
            });

            this.listenTo(this._inventoryTagsCollection, "add remove", function () {
                _this._inventoryTagsCollection.sort();
                _this.model.saveLater();
            });
        },
        onShow: function onShow() {
            var _this2 = this;

            var imageTagCompositeView = new ImageTagCompositeView({
                collection: this._imageTagsCollection,
                tagCollection: this._tagsCollection,
                editable: !this.options.spectatorMode,
                trackingOptions: {
                    triggerOrigin: "ImageQuickView",
                    imageModel: this.model
                }
            });

            this.tagsCollectionRegion.show(imageTagCompositeView);

            /**
             * You have to pss both the filtered and unfiltered tags because we need to save to both
             * */
            var inventoryTagCompositeView = new InventoryTagCompositeView({
                collection: this._inventoryTagsCollection,
                tagCollection: this._tagsCollection,
                editable: !this.options.spectatorMode,
                trackingOptions: {
                    triggerOrigin: "ImageQuickView",
                    imageModel: this.model
                }
            });

            this.inventoryTagsCollectionRegion.show(inventoryTagCompositeView);

            var imageExperienceCompositeView = new ImageExperienceCompositeView({
                collection: this._experienceCollection,
                horizontalBuffer: 220,
                scrollTarget: this.ui.experiencesAccordion,
                itemEvents: {
                    "clicked:experience:item": this._clickedExperienceItem.bind(this)
                }
            });

            this.experiencesRegion.show(imageExperienceCompositeView);

            // Preload first chunk of data
            this._loadExperiencesChunk();

            // Follow toggling animation progress and save the state
            this.ui.experiencesAccordion.on("show.bs.collapse hide.bs.collapse", function () {
                _this2._togglingExperiences = true;
            });
            this.ui.experiencesAccordion.on("shown.bs.collapse hidden.bs.collapse", function () {
                _this2._togglingExperiences = false;
            });
        },
        _clickedExperienceItem: function _clickedExperienceItem() {
            this.trigger("edit:experience");
        },
        _loadExperiencesChunk: function _loadExperiencesChunk() {
            this._experienceCollection.query(ContentQuery.sort().field("createdAt"));
        },
        _toggleExperiences: function _toggleExperiences() {
            // Do not allow toggling while toggling is in progress
            if (this._togglingExperiences) {
                return;
            }

            var isOpen = this.ui.experiencesAccordion.hasClass("in");
            this.ui.toggleExperiencesButton.toggleClass("open", !isOpen);

            this.trigger("toggled:experiences", this.model, isOpen);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var InfiniteScrollingCollectionView = __webpack_require__(259);
    var NoResultsItemView = __webpack_require__(207);
    var ImageExperienceItemView = __webpack_require__(2855);
    var template = __webpack_require__(2857);

    /**
     * A <tt>InfiniteScrollingCollectionView</tt> subclass for displaying (and lazy loading) image experiences, i.e. <tt>ImageExperienceItemView</tt>'s.
     *
     * @cfg {ImageExperienceCollection} collection The <tt>ImageExperienceCollection</tt> to render.
     *
     * @see  ImageDetailsView
     * @see  ImageExperienceItemView
     * @see  InfiniteScrollingCollectionView
     *
     * @class ImageExperienceCompositeView
     */
    return InfiniteScrollingCollectionView.extend("ImageExperienceCompositeView", {

        tagName: "table",

        className: "infinite-container experiences-list table",

        template: template,

        itemViewContainer: "tbody",

        itemView: ImageExperienceItemView,

        spinnerContainer: ".experiences-loading",

        onEmpty: function onEmpty() {
            return new NoResultsItemView({ type: "Experiences" });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(120),
        DateUtil = _require.DateUtil;

    var GroupModel = __webpack_require__(104);
    var GroupUtil = __webpack_require__(306);
    var Marionette = __webpack_require__(10);
    var template = __webpack_require__(2856);

    /**
     * Item view for an image experience item
     *
     * @class ImageExperienceItemView
     */
    return Marionette.ItemView.extend({
        tagName: "tr",

        template: template,

        className: "image-experience-item-view",

        templateHelpers: function templateHelpers() {
            return {
                lastUpdated: DateUtil.formatMMDDYYY(this.model.get("editedAt")),
                experienceName: this.model.get("name"),
                url: this._getUrl()
            };
        },
        _getUrl: function _getUrl() {
            var id = this.model.id;

            if (this.model instanceof GroupModel) {
                id = GroupUtil.firstGroupExperience(this.model, this.model.get("entries")).id;
            }

            return "experience/" + id + "/edit";
        },


        events: {
            "click": "_experienceItemClicked"
        },

        _experienceItemClicked: function _experienceItemClicked() {
            this.trigger("clicked:experience:item");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2856 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<td><a href="#' +
__e(url) +
'">' +
__e( experienceName ) +
'</a></td><td>' +
__e( lastUpdated ) +
'</td>\n';

}
return __p
}

/***/ }),
/* 2857 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<thead>\n    <th>Experience</th>\n    <th>Last Updated</th>\n</thead>\n<tbody></tbody>\n<tfoot>\n    <tr>\n        <td colspan="2" class="experiences-loading" style="position:relative;"></td>\n    </tr>\n</tfoot>\n';

}
return __p
}

/***/ }),
/* 2858 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="image-container">\n    <img src="' +
__e( absoluteThumbUrl ) +
'" />\n</div>\n<div class="image-name editable-container">\n    <div contenteditable="' +
__e( editable ) +
'" class="editable edit-name';
 if (!editable) { ;
__p += ' disabled';
 } ;
__p += '" ';
 if (!editable)
        { ;
__p += 'disabled\n        ';
 } ;
__p += '>\n    </div>\n</div>\n<div class="details">\n    <div class="js-alt-text-editable-container editable-container';
 if (!editable) { ;
__p += ' not-editable';
 } ;
__p += '">\n        <div class="alt-text-label">Alt text:&nbsp;</div>\n        <div class="js-alt-text alt-text editable" contenteditable="' +
__e( editable ) +
'"></div>\n        ';
 if (editable) { ;
__p += '\n            <div class="editable-cell-img js-alt-text-icon">\n                <div class="editable-img"></div>\n            </div>\n        ';
 } ;
__p += '\n    </div>\n    <ul>\n        <li>Size: <i>' +
__e( width ) +
' &times; ' +
__e( height ) +
' / ' +
__e( displaySize ) +
'</i></li>\n        <li>Type: <i>' +
__e( extension ) +
'</i></li>\n        <li>Times used: <i>' +
__e( timesUsed ) +
'</i></li>\n    </ul>\n</div>\n<div class="image-experiences">\n    ';
 if (experienceCount > 0) { ;
__p += '\n        <button class="btn btn-link toggle-experiences-button collapsible ' +
__e( showExperiences ? "open" : "" ) +
'" data-toggle="collapse" data-target=".image-experiences-collection-region">\n            Used in ' +
__e( experienceCount ) +
' experience' +
__e( experienceCount > 1 ? "s" : "" ) +
'</span>\n        </button>\n    ';
 } else { ;
__p += '\n        <i class="no-experiences">The image is currently not used</i>\n    ';
 } ;
__p += '\n    <div class="image-experiences-collection-region ' +
__e( showExperiences ? "" : "collapse" ) +
'"></div>\n</div>\n';
 if (showTags) { ;
__p += '\n    <div class="tags">\n        <div class="tags-collection-region"></div>\n    </div>\n';
 } ;
__p += '\n';
 if (showInventory) { ;
__p += '\n<div class="inventory">\n    <div class="inventory-collection-region"></div>\n</div>\n';
 } ;
__p += '\n';

}
return __p
}

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ContentCollection = __webpack_require__(463);
    var RestApi = __webpack_require__(29);
    var SyncManager = __webpack_require__(44);

    /**
     * A collection of experiences associated to an image model
     *
     * @class ImageExperienceCollection
     * @constructor
     *
     * @param {Object} options
     * @property {id} imageId - The image id this collection is associated with (required)
     */

    var ImageExperienceCollection = ContentCollection.extend({

        /**
         * @type {String}
         */
        imageId: null,

        constructor: function constructor(_ref) {
            var imageId = _ref.imageId;

            this.imageId = imageId;
            this.__super();
        },
        url: function url() {
            return RestApi.pathToCollectionOnResource(RestApi.Collections.IMAGES, this.imageId, RestApi.Collections.CONTENTS);
        },


        /**
         * Counts the number of experiences associated to an image.
         *
         * @param  {ImageModel} imageModel The <tt>ImageModel</tt> instance to count the experiences for.
         *
         * @return {Promise}        A <tt>Promise</tt> that resolves with the count/number.
         */
        count: function count() {
            var resource = RestApi.pathToCollectionOnResource(RestApi.Collections.IMAGES, this.imageId, RestApi.Collections.CONTENTS_COUNT);
            return SyncManager.get(resource, SyncManager.target("ImageExperienceCollection.count"));
        }
    });

    return ImageExperienceCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var Lightbox = __webpack_require__(101);

  /**
   * Lightbox class used in the viewer only.
   */
  return Lightbox.extend({
    /**
     * The lightbox should be positioned differently than default
     *
     * @type {String}
     * @see  Lightbox#defaultTop
     */
    defaultTop: "40%"
  });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Configuration = __webpack_require__(27);

    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(706);
    var ImprovedModel = __webpack_require__(25);
    var $ = __webpack_require__(4);
    var ExperienceThumbnailViewer = __webpack_require__(705);
    var UUIDGenerator = __webpack_require__(250);
    /**
     * View model for the scene thumbnail.
     *
     * @class ExperienceThumbnailImageViewModel
     * @constructor
     */
    var ExperienceThumbnailImageViewModel = ImprovedModel.extend("ExperienceThumbnailImageViewModel", {

        _experience: null,
        _maxDimensions: null,
        _isPushed: null,
        content: null,

        url: function url() {
            var constructedUrl = ""; // default to nothing!  This will cause a fail on the fetch
            // which is what we will want if we can't form a url.

            var isPushed = this.get("_isPushed");

            // For some reason if we didn't push the pushedAt value comes back as zero even
            // if it doesn't exist in mongo! $
            if (isPushed) {
                var experience = this.get("_experience");
                var pushedAtEpochTimeMs = experience.get("pushedAt");
                var pushedAtEpochTime = (pushedAtEpochTimeMs / 1000).toFixed(0);
                var experienceId = experience.get("id");

                var experienceWidth = experience.get("width");
                var experienceHeight = experience.get("height");

                var scaledDimensions = experience.getDimensions(this.get("_maxDimensions"));
                var thumbnailWidth = scaledDimensions.width;
                var thumbnailHeight = scaledDimensions.height;
                var snapshotDelaySeconds = 0;

                var traceUUID = UUIDGenerator.createUUID();

                constructedUrl = Configuration.experienceUrl2PngBaseUrl + "?";
                constructedUrl += "&experienceId=" + experienceId;
                constructedUrl += "&pushedAtEpochTime=" + pushedAtEpochTime;
                constructedUrl += "&experienceWidth=" + experienceWidth;
                constructedUrl += "&experienceHeight=" + experienceHeight;
                constructedUrl += "&thumbnailWidth=" + thumbnailWidth;
                constructedUrl += "&thumbnailHeight=" + thumbnailHeight;
                constructedUrl += "&maintainAspectRatio=true";
                constructedUrl += "&traceUUID=" + traceUUID;

                // TODO: The snapshot delay needs to have to things to work properly.
                // (1) Cloudinary needs to figure out the proper way to set this value
                //     in the Java sdk.  The usage in ms-experiences server does not work
                //     like they say.  Passing in this value does create a param but its wrong (but harmless)
                // (2) Somewhere in the experience we need to find a timing for an animation to complete
                //     and use that value to calc the number of seconds for url2png to wait before
                //     snapping an image!
                if (snapshotDelaySeconds > 0) {
                    constructedUrl += "&snapshotDelaySeconds=" + snapshotDelaySeconds;
                }
            }

            return constructedUrl;
        },

        // call original Backbone.Model#fetch with `dataType` equal `text` for $.ajax
        // this is a stack exchange special for dealing with raw text return objects
        // The only difference is the added "return" below because the result from our
        // overridden method is supposed to be a promise object.
        // https://stackoverflow.com/questions/22567027/backbone-model-is-plain-text-file-how-to-fetch
        fetch: function fetch(options) {
            // eslint-disable-next-line no-undef
            options = _.extend(options || {}, {
                dataType: "text"
            });
            return this.constructor.__super__.fetch.call(this, options);
        },

        // store response in content attribute
        parse: function parse(response) {
            return { content: response };
        },

        defaults: {
            id: "",
            content: ""
        }
    });

    /**
     * A scene thumbnail "viewer". Renders a scene with some defined maximum size.
     *
     * @class ExperienceThumbnailImageViewer
     * @constructor
     *
     * @cfg {ExperienceModel} experience The parent experience.
     * @cfg {Object} [maxDimensions] Optional max dimensions to scale the viewer to. If specified, must contain width, height, or both.
     */
    return ImprovedView.extend({

        className: "scene-thumbnail experience-container",

        template: template,

        ui: {
            sceneWrapper: ".scene-wrapper-inner",
            sceneWrapperOuter: ".scene-wrapper-outer"
        },

        _experience: null,
        _sceneZeroModel: null, // used to pass to the experienceThumbnailViewer should this viewer fail
        _isPushed: false,
        _showStaticScenes: null, // used to pass to the experienceThumbnailViewer should this viewer fail
        _maxDimensions: null,
        _isThumbnailsNativeContentIntegrationsEnabled: null, // if enabled and we fail to then use this viewer

        initialize: function initialize() {
            this._experience = this.options.experience;
            this._isPushed = this._experience.get("pushedAt") > 0;
            this._sceneZeroModel = this.options.model;
            this._showStaticScenes = this.options.showStaticScenes;
            this._maxDimensions = this.options.maxDimensions;
            this._isThumbnailsNativeContentIntegrationsEnabled = this.options.isThumbnailsNativeContentIntegrationsEnabled;
        },


        /**
         * Used only when we fail for some reason talking to ms-experiences to get a singed url2png url.
         * This viewer generates static html from an experience using cnc if the experience was pushed AND
         * the integration type "" is enabled for this company.  If it wasn't
         * pushed then we fall back further to putting a message of "Thumbnail Unavailable" in place of the thumbnail.
         * @private
         */
        _fallbackThumbnail: function _fallbackThumbnail() {
            if (this._isPushed && this._isThumbnailsNativeContentIntegrationsEnabled) {
                var experienceThumbnailViewer = new ExperienceThumbnailViewer({
                    model: this._sceneZeroModel,
                    experience: this._experience,
                    maxDimensions: this._maxDimensions,
                    showStaticScenes: this._showStaticScenes
                });

                this.$el.find(this.ui.sceneWrapper).append(experienceThumbnailViewer.render().$el);
            } else {
                // old default thumbnail code.
                var defaultThumbnail = document.createElement("DIV");
                defaultThumbnail.innerHTML += "Thumbnail <br> Unavailable";
                defaultThumbnail.style.cssText = "border: none;text-align: center;color: @grey04;font-size: 18px;font-weight: 800; cursor: default";
                this.$el.find(this.ui.sceneWrapper).append(defaultThumbnail);
            }
        },
        onRender: function onRender() {
            if (this.isClosed) {
                return;
            }

            var self = this;

            // only attempt to render an image if the experience was pushed!
            if (self._isPushed) {
                var model = new ExperienceThumbnailImageViewModel({
                    _experience: self._experience,
                    _maxDimensions: self._maxDimensions,
                    _isPushed: self._isPushed
                });

                model.fetch({ silent: true }).then(function () {
                    var content = model.get("content");

                    if (content === "") {
                        self._fallbackThumbnail();
                    } else {
                        var sceneWrapperOuterElement = self.$el.find(self.ui.sceneWrapperOuter);
                        $(sceneWrapperOuterElement).css({
                            overflow: "hidden"
                        });

                        var scenewrapperElement = self.$el.find(self.ui.sceneWrapper);

                        scenewrapperElement.append("<img src=" + content + " class=\"scene-dashboard-thumbnail\"/>");
                    }
                }).fail(function () {
                    self._fallbackThumbnail();
                });
            } else {
                self._fallbackThumbnail();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ButtonWidgetView = __webpack_require__(768);
    var ButtonWidgetModel = __webpack_require__(305);
    var CompositeWidgetModel = __webpack_require__(173);
    var CompositeWidgetView = __webpack_require__(503);
    var SalesforceCommerceWidgetModel = __webpack_require__(368);
    var SalesforceCommerceWidgetView = __webpack_require__(780);
    var EmbedWidgetModel = __webpack_require__(505);
    var EmbedWidgetView = __webpack_require__(781);
    var HTMLWidgetView = __webpack_require__(506);
    var HTMLWidgetModel = __webpack_require__(782);
    var Enum = __webpack_require__(77);
    var ImageWidgetModel = __webpack_require__(249);
    var ImageWidgetView = __webpack_require__(507);
    var LineWidgetModel = __webpack_require__(508);
    var LineWidgetView = __webpack_require__(509);
    var LinkWidgetModel = __webpack_require__(510);
    var LinkWidgetView = __webpack_require__(783);
    var ProductWidgetModel = __webpack_require__(511);
    var ProductWidgetView = __webpack_require__(784);
    var SceneNavigatorWidgetModel = __webpack_require__(512);
    var SceneNavigatorWidgetView = __webpack_require__(513);
    var ShapeWidgetModel = __webpack_require__(514);
    var ShapeWidgetView = __webpack_require__(785);
    var SocialSharingWidgetModel = __webpack_require__(515);
    var SocialSharingWidgetView = __webpack_require__(516);
    var TextEnhancedWidgetModel = __webpack_require__(367);
    var TextWidgetModel = __webpack_require__(366);
    var TextWidgetView = __webpack_require__(369);
    var YoutubeWidgetModel = __webpack_require__(519);
    var YoutubeWidgetView = __webpack_require__(787);
    var DynamicProductWidgetModel = __webpack_require__(520);
    var DynamicProductWidgetView = __webpack_require__(521);

    /**
     * An enumeration declaring all supported Widget types for the Viewer. There is another class filling the same role
     * for the editor. When adding a new widget to this enum also add it to the WidgetTypes enum.
     *
     * @class {ViewerWidgetTypes}
     */
    return Enum.create("ViewerWidgetTypes", "id", {
        BUTTON: {
            id: "button",
            viewClass: ButtonWidgetView,
            modelClass: ButtonWidgetModel
        },
        COMPOSITE: {
            id: "composite",
            viewClass: CompositeWidgetView,
            modelClass: CompositeWidgetModel
        },
        SALESFORCE_COMMERCE: {
            // Demandware is the old name for Salesforce Commerce Cloud.
            // The Api still returns the 'demandware' object and it would fail if this is refactored to salesforce-commerce.
            // AS long as the DB name is 'demandware' the id has to be same.
            id: "demandware",
            viewClass: SalesforceCommerceWidgetView,
            modelClass: SalesforceCommerceWidgetModel
        },
        EMBED: {
            id: "embed",
            viewClass: EmbedWidgetView,
            modelClass: EmbedWidgetModel
        },
        HTML: {
            id: "html",
            viewClass: HTMLWidgetView,
            modelClass: HTMLWidgetModel
        },
        IMAGE: {
            id: "image",
            viewClass: ImageWidgetView,
            modelClass: ImageWidgetModel
        },
        LINE: {
            id: "line",
            viewClass: LineWidgetView,
            modelClass: LineWidgetModel
        },
        LINK: {
            id: "link",
            viewClass: LinkWidgetView,
            modelClass: LinkWidgetModel
        },
        NEXT_SCENE: {
            id: "next-scene",
            viewClass: ImageWidgetView,
            modelClass: ImageWidgetModel
        },
        PREVIOUS_SCENE: {
            id: "previous-scene",
            viewClass: ImageWidgetView,
            modelClass: ImageWidgetModel
        },
        PRODUCT: {
            id: ProductWidgetModel.TYPE,
            viewClass: ProductWidgetView,
            modelClass: ProductWidgetModel
        },
        SCENE_NAVIGATOR: {
            id: "scene-navigator",
            viewClass: SceneNavigatorWidgetView,
            modelClass: SceneNavigatorWidgetModel
        },
        SHAPE: {
            id: "shape",
            viewClass: ShapeWidgetView,
            modelClass: ShapeWidgetModel
        },
        SOCIAL_SHARING: {
            id: "social-sharing",
            viewClass: SocialSharingWidgetView,
            modelClass: SocialSharingWidgetModel
        },
        TEXT: {
            id: "text",
            viewClass: TextWidgetView,
            modelClass: TextWidgetModel
        },
        // The view and model class for this widget is different then the editor.
        TEXT_ENHANCED: {
            id: "text-enhanced",
            viewClass: TextWidgetView,
            modelClass: TextEnhancedWidgetModel
        },
        YOUTUBE: {
            id: "youtube",
            viewClass: YoutubeWidgetView,
            modelClass: YoutubeWidgetModel
        },
        DYNAMIC_PRODUCT: {
            id: "dynamic-product",
            viewClass: DynamicProductWidgetView,
            modelClass: DynamicProductWidgetModel
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2863 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="experience-thumb-wrapper">\n    <div class="actions-panel">\n        ';
 if (canDelete) {;
__p += '\n            <span class="delete pull-right" data-content="Delete ' +
__e(itemLabel) +
' forever"></span>\n        ';
} else if (spectatorMode) {;
__p += '\n            <span class="delete pull-right disabled" data-content="You do not have permission to delete ' +
__e(itemLabel) +
's"></span>\n        ';
} else {;
__p += '\n            <span class="delete pull-right disabled" data-content="You do not have permission to delete pushed ' +
__e(itemLabel) +
's"></span>\n        ';
};
__p += '\n        ';
 if (spectatorMode) { ;
__p += '\n            <span class="duplicate pull-right disabled" data-content="You do not have permission to duplicate ' +
__e(itemLabel) +
's"></span>\n        ';
} else {;
__p += '\n            <span class="duplicate pull-right" data-content="Duplicate ' +
__e( itemLabel ) +
'"></span>\n        ';
};
__p += '\n        ';
 if (hasMatomoReporting) { ;
__p += '\n            <span class="report pull-right" data-content="Experience Analytics"></span>\n        ';
};
__p += '\n    </div>\n\n    ';
 if (group) { ;
__p += '\n        <div class="group-thumb-container">\n            <div class="variant-thumbs-wrapper">\n                ';
 _.each(thumbs, function (thumb) { ;
__p += '\n                    <div class="variant-outline" style="width:' +
__e( thumb.width ) +
'px; height:' +
__e( thumb.height ) +
'px; left:' +
__e( thumb.x ) +
'px;"></div>\n                ';
 }); ;
__p += '\n                <div class="experience-thumb-container"></div>\n            </div>\n        </div>\n    ';
 } else { ;
__p += '\n        <div class="experience-thumb-container"></div>\n    ';
 } ;
__p += '\n\n    <div class="experience-meta-data">\n        <div class="title-wrapper">\n            <span class="title-container" data-content="' +
__e( name ) +
'">\n                <span class="title">' +
__e( name ) +
'</span>\n            </span>\n            ';
 if (group) { ;
__p += '\n                <span class="group-count">(' +
__e( entries.length ) +
')</span>\n            ';
 } ;
__p += '\n            ';
 if (hasComments) { ;
__p += '\n                <span class="comments-indicator"></span>\n            ';
 } ;
__p += '\n        </div>\n\n        ';
 if (group) { ;
__p += '\n            <ul class="group-variants ' +
__e(groupType ) +
'">\n                ';
 _.each(entries, function (entry, index) {
                    var identifier = entry[1] ? entry[1].getIdentifier() : "";
                ;
__p += '\n                    ';
 if (index < 8) { ;
__p += '\n                        <li class="variant-icon ' +
__e(identifier ) +
' small">#' +
__e( index + 1 ) +
'</li>\n                    ';
 } else if (index === 8) { ;
__p += '\n                        <li class="ellipsis">&#133;</li>\n                    ';
 } ;
__p += '\n                ';
 }); ;
__p += '\n            </ul>\n        ';
 } else { ;
__p += '\n            <div class="state">Status: ' +
__e( readableState ) +
'</div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="spinner-region"></div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var DashboardSorting = __webpack_require__(341),
        DeleteExperienceAction = __webpack_require__(2865),
        DeleteGroupAction = __webpack_require__(1203),
        DuplicateExperienceAction = __webpack_require__(405),
        DuplicateExperiencePermissionsAction = __webpack_require__(2866),
        DuplicateGroupAction = __webpack_require__(1208),
        GroupModel = __webpack_require__(104),
        Preconditions = __webpack_require__(14),
        Promise = __webpack_require__(21),
        SystemMessages = __webpack_require__(107),
        ViewController = __webpack_require__(126);

    /**
     *
     * @class DashboardContentCollectionViewController
     * @see  DashboardContentCollectionView
     */
    return ViewController.extend({

        /**
         * Invoked when the user activates the quick view.
         *
         * Creates the options object passed to the <tt>QuickView</tt> and starts fetching the experience
         * data. A <tt>promise</tt> property is exposed that will be resolved once
         * all data has been fetched.
         *
         * @param  {ExperienceModel|GroupModel} model The associated experience model.
         */
        onViewQuickViewOpen: function onViewQuickViewOpen(model) {
            var options = {
                model: model,
                spectatorMode: this.options.spectatorMode,
                isEditable: !this.options.spectatorMode,
                projectContext: this.options.projectContext,
                promise: Promise.resolved()
            };

            var initialExperience = model;

            // TODO: Re-write quickview to proper support both groups and experiences...
            if (model instanceof GroupModel) {
                options.group = model;
                options.model = model.getUniqueEntries()[0][0];

                initialExperience = options.model;
            }

            options.promise = initialExperience.fetchAll();

            this.view.openQuickView(options);
        },

        onViewDuplicate: function onViewDuplicate(model) {
            var view = this.view,
                ActionClass = model instanceof GroupModel ? DuplicateGroupAction : DuplicateExperienceAction,
                action = new ActionClass(model, { postfix: "new", projectContext: this.options.projectContext });

            if (!action.executable()) {
                return;
            }

            action.execute().then(function (clone) {
                var experiencePermissionsAction = new DuplicateExperiencePermissionsAction(model, clone);
                if (experiencePermissionsAction.executable()) {
                    return experiencePermissionsAction.execute();
                }
            }).then(function () {
                // HACK: Since the client no longer knows the sorting layout algorithm, we need to refresh the
                // dashboard by setting the sorting to "Last Updated" - this also ensures that the user will always
                // see the newly duplicated experience/group...
                view.refresh(DashboardSorting.MONTH);
            });
        },

        onViewDelete: function onViewDelete(model) {
            var ActionClass = model instanceof GroupModel ? DeleteGroupAction : DeleteExperienceAction,
                projectContext = this.options.projectContext,
                project = this.options.projectContext && this.options.projectContext.project,
                action = new ActionClass(model, project),
                collection = this.view.collection,
                modelTypeText = model.get("type") !== "Experience" ? "Group" : "Experience"; // Simplify type for user messages. See MOS-1994.

            if (!action.executable()) {
                Preconditions.warn("tried to delete '" + model.get("name") + "' (" + model.id + "), but the action is not executable");
                return;
            }

            action.execute().then(function (model) {
                // If removal/destruction was successful - remove it from the current collection (this will also remove it from the view)
                collection.remove(model);

                // Notify user on successful delete
                SystemMessages.notifyPurge(modelTypeText, "deleted", null, false);

                // Sync project model, if any...
                if (projectContext) {
                    return project.fetch();
                }
            });
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(156),
        EditorEvents = __webpack_require__(17),
        Permissions = __webpack_require__(22),
        PublishableState = __webpack_require__(65);

    /**
     * Action that will delete an experience, and all of it's potential variants.
     *
     * @class DeleteExperienceAction
     */
    return Action.extend({

        /**
         * Constructor.
         *
         * @param  {ExperienceModel} model The experience model representing the experience to delete.
         * @param  {ProjectModel} project The project model, used here for tracking purposes.
         */
        constructor: function constructor(model, project) {
            this.__super();

            this._model = model;
            this._project = project;
        },

        executable: function executable() {
            return Permissions.Privileges.CREATE.can() && (!this._model.hasAtLeastState(PublishableState.PUSHED) || Permissions.Privileges.PUBLISH.can());
        },

        _performExecution: function _performExecution() {
            var model = this._model,
                project = this._project;

            return model.destroy().then(function () {
                var eventProperties = {
                    projectId: project && project.get("id"),
                    experienceId: model.get("id"),
                    experienceVersion: model.get("version"),
                    experiencePushedVersion: model.get("pushedVersion"),
                    triggerOrigin: "DeleteExperienceButton"
                };

                EditorEvents.trigger(EditorEvents.constants.DELETE_EXPERIENCE, eventProperties);

                return model;
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(156),
        Permissions = __webpack_require__(22),
        MsSharedEntityModel = __webpack_require__(708),
        SharedEntityType = __webpack_require__(285),
        ProjectAsset = __webpack_require__(283),
        LoggedInUserState = __webpack_require__(19),
        PublishableState = __webpack_require__(65);

    /**
     * Action that will duplicate the permission data associated with a group or experience
     *
     * @class DuplicateExperiencePermissionsAction
     */
    return Action.extend({

        /**
         * Constructor.
         *
         * @param  {ExperienceModel} previousModel The previous experience model
         * @param  {ExperienceModel} clone The cloned experience model
         */
        constructor: function constructor(previousModel, clone) {
            this.__super();

            this._previousModel = previousModel;
            this._cloneModel = clone;
        },

        executable: function executable() {
            var canCreatePushPublishExperience = Permissions.Privileges.CREATE.can() && (!this._previousModel.hasAtLeastState(PublishableState.PUSHED) || Permissions.Privileges.PUBLISH.can());
            var isPermissioningEnabled = LoggedInUserState.get("companySettings").get("userPermissionsEnabled");
            return canCreatePushPublishExperience && isPermissioningEnabled;
        },

        _performExecution: function _performExecution() {
            var _this = this;

            var previousModel = this._previousModel;

            var sharedEntityType = void 0;
            if (previousModel.get("type") === ProjectAsset.Type.EXPERIENCE) {
                sharedEntityType = SharedEntityType.EXPERIENCE;
            } else if (previousModel.get("type") === ProjectAsset.Type.BREAKPOINTGROUP || previousModel.get("type") === ProjectAsset.Type.LOCALIZATIONGROUP) {
                sharedEntityType = SharedEntityType.GROUP;
            } else {
                // If it's not a group and experience do not copy
                return;
            }

            var sharedEntity = new MsSharedEntityModel({
                entityId: previousModel.get("id"),
                entityType: sharedEntityType
            });

            return sharedEntity.fetch().then(function (sharedEntityResponse) {
                _this._duplicateAndSaveSharedEntity(sharedEntityResponse);
            });
        },

        _duplicateAndSaveSharedEntity: function _duplicateAndSaveSharedEntity(sharedEntity) {
            var clone = sharedEntity.clone({ duplicate: true });
            clone.set("entityId", this._cloneModel.get("id"));

            return clone.save({}, { url: clone.postURL() }).then(function () {
                return clone;
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var DashboardSorting = __webpack_require__(341),
        EditorEvents = __webpack_require__(17),
        ImprovedView = __webpack_require__(6),
        _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        trim = _require.trim,
        template = __webpack_require__(2868);

    /**
     * View displaying the sorting options and the search input for the dashboard.
     *
     * @class DashboardSortingPanel
     */
    return ImprovedView.extend({

        template: template,

        className: "sorting-panel",

        events: {
            "click @ui.sortingElements": "_sortClickHandler",

            "keyup @ui.searchInput": "_searchKeyupHandler"
        },

        ui: {
            sortingElements: "[data-sort]",
            searchInput: ".content-filtering"
        },

        /**
         * @type {DashboardSorting}
         */
        _sorting: null,

        _searching: false,

        _searchPhase: "",

        initialize: function initialize() {
            this._sorting = DashboardSorting.current();
        },

        getSorting: function getSorting() {
            return this._sorting;
        },

        setSorting: function setSorting(sorting) {
            this.ui.sortingElements.removeClass("active");
            this.$el.find("[data-sort='" + sorting.value + "']").addClass("active");

            this._sorting = sorting;

            DashboardSorting.set(sorting);

            if (this._searching) {
                this.trigger("search", this._searchPhase, sorting);
            } else {
                this.trigger("sort", sorting);
            }
        },

        isSearching: function isSearching() {
            return this._searching;
        },

        getSearchPhase: function getSearchPhase() {
            return this._searchPhase;
        },

        disable: function disable(value) {
            this.$el.toggleClass("disabled", value === true || value === undefined);
        },

        onRender: function onRender() {
            this.setSorting(this._sorting);
        },

        _triggerSearch: function _triggerSearch(searchPhase) {
            if (searchPhase === this._searchPhase) {
                return;
            }
            // If user clears the input field, reset to current sorting.
            if (isBlank(searchPhase)) {
                this._resetSearchState();
                this.setSorting(this._sorting);
                return;
            }

            this._searchPhase = searchPhase;
            this._searching = true;

            // Signal that we're searching...
            this.trigger("search", searchPhase, this._sorting);
        },

        _searchKeyupHandler: function _searchKeyupHandler(event) {
            var searchPhase = trim(event.target.value);

            this._triggerSearch(searchPhase);
        },

        _sortClickHandler: function _sortClickHandler(event) {
            var sorting = event.target.getAttribute("data-sort");

            if (sorting === this._sorting && !this._searching) {
                return;
            }

            this.setSorting(DashboardSorting.fromValue(sorting));

            var eventProperties = {
                sortBy: sorting,
                triggerOrigin: "SortingPanel"
            };

            EditorEvents.trigger(EditorEvents.constants.SORT_DASHBOARD, eventProperties);
        },

        _resetSearchState: function _resetSearchState() {
            this.ui.searchInput.val("");
            this._searching = false;
            this._searchPhase = "";
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2868 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="sorting-tabs">\n    <span data-sort="month">Last Updated</span>\n    <span data-sort="alphabetical">Alphabetical</span>\n    <span data-sort="person">Created By</span>\n    <span data-sort="state">Status</span>\n</div>\n<input class="content-filtering" type="search" placeholder="Search">\n';

}
return __p
}

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        EditBehavior = __webpack_require__(106),
        EditorEvents = __webpack_require__(17),
        ImprovedView = __webpack_require__(6),
        LoggedInUserState = __webpack_require__(19),
        Promise = __webpack_require__(21),
        QuickViewExperienceDetailsView = __webpack_require__(2870),
        QuickViewGroupDetailsView = __webpack_require__(2878),
        UserSharingPermissionsView = __webpack_require__(2880),
        MsSharedEntityModel = __webpack_require__(708),
        SharedEntityType = __webpack_require__(285),
        QuickViewConstants = __webpack_require__(1213),
        template = __webpack_require__(2886);

    /**
     * The <tt>QuickView</tt> is used to display experience details inside a <tt>LightBox</tt>.
     *
     * @cfg {ExperienceModel} model The current <tt>ExperienceModel</tt>.
     *
     * @see LightBox
     *
     * @class QuickView
     */
    return ImprovedView.extend({

        template: template,

        _entries: null,

        _group: null,

        _experienceView: null,

        templateHelpers: function templateHelpers() {
            var projectContext = this.options.projectContext,
                project = this._getProject(),
                isInProject = !_.isUndefined(project),
                projectId = isInProject ? project.get("id") : "",
                projectName = isInProject ? project.get("name") : "",
                projectDashboardUrl = "#/project/" + projectId;

            return {
                spectatorMode: this.options.spectatorMode,
                isInProject: isInProject,
                projectContext: projectContext,
                projectDashboardUrl: projectDashboardUrl,
                projectName: projectName,
                isGroup: !!this._group,
                entries: this._entries,
                groupType: this._group && this._group.getDashedType()
            };
        },

        ui: {
            variantTab: ".variant-tab",
            projectLink: ".project-url"
        },

        events: {
            "click @ui.variantTab": function clickUiVariantTab(event) {
                var $target = $(event.currentTarget),
                    experienceId = $target.data("experience"),
                    experienceModel = _.findWhere(this._assets, { id: experienceId });

                if (!$target.hasClass("selected")) {
                    this._showSelectedExperienceByModel(experienceModel);
                    this.ui.variantTab.removeClass("selected");
                    $target.addClass("selected");
                }
            },
            // Let's close the quick view when navigating to the project page.
            "click @ui.projectLink": "close"
        },

        groupBindings: {
            ".edit-group-name": {
                // We need to use updateMethod "html" and escape true, because we are using a tag contenteditable
                observe: "name",
                updateMethod: "html",
                escape: true,
                // The dashboard items will be refreshed only when this field is blurred
                events: ["blur"]
            }
        },

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,
                container: ".editable-group-container",
                viewModel: function viewModel() {
                    // Use the breakpoint group model if present...
                    return this._group || this.model;
                },

                editFields: [{
                    input: ".edit-group-name",
                    model: "name",
                    save: function save() {
                        var _this = this;

                        if (this._group) {
                            return this._group.saveLater().done(function () {
                                var eventProperties = {
                                    groupId: _this._group.get("id"),
                                    groupType: _this._group.get("type"),
                                    groupVersion: _this._group.get("version"),
                                    groupPushedVersion: _this._group.get("pushedVersion"),
                                    projectId: _this.options.projectContext && _this.options.projectContext.project.get("id"),
                                    triggerOrigin: "EditGroupNameInputField",
                                    quickView: true,
                                    updateProperty: "name",
                                    updatedValue: _this._group.get("name")
                                };

                                EditorEvents.trigger(EditorEvents.constants.UPDATE_GROUP, eventProperties);
                            });
                        }
                    }
                }]
            }
        },

        regions: {
            experienceDetailsRegion: ".experience-details-region",
            groupDetailsRegion: ".group-details-region",
            sharingArea: ".sharing-area"
        },

        initialize: function initialize() {
            if (this.options.group) {
                this._group = this.options.group;

                this._assets = this._group.getAssets();
                this._entries = this._group.getUniqueEntries();
            }
        },

        onShow: function onShow() {
            this._showExperienceDetailsView();

            if (this._group) {
                // TODO: Until we handle a real group on the dashboard, this.model is a fake 'master Experience'
                // and hence we need to hook the group-name to the correct model for breakpoint groups.
                this.stickit(this._group, this.groupBindings);
                this.ui.variantTab.first().addClass("selected");
                this._showGroupDetailsView();
            }
            this._initializeDropdownComponent();
        },

        _initializeDropdownComponent: function _initializeDropdownComponent() {
            if (LoggedInUserState.get("companySettings").get("userPermissionsEnabled")) {
                var entityId = this._group ? this._group.get("id") : this.model.get("id");
                var companyId = this._group ? this._group.get("companyId") : this.model.get("companyId");
                var entityType = this._group ? SharedEntityType.GROUP : SharedEntityType.EXPERIENCE;
                var sharedEntity = new MsSharedEntityModel({
                    entityId: entityId,
                    companyId: companyId,
                    entityType: entityType
                });

                this.sharingArea.show(new UserSharingPermissionsView({
                    model: sharedEntity,
                    group: this._group
                }));
            }
        },


        /**
         * @private
         * Returns the project model, if the experience is part of a project. Groups are handled differently in this.
         *
         * @returns {ProjectModel} projectModel - the project model, if the experience is part of a project.
         */
        _getProject: function _getProject() {
            var projectsCollection = LoggedInUserState.get("projects");
            // FIXME: localized experiences should act the same as groups - this special case should not be here.
            switch (true) {
                case !!this._group:
                    return projectsCollection.byGroupId(this._group.get("id"));
                default:
                    return projectsCollection.byExperience(this.model);
            }
        },

        _showExperienceDetailsView: function _showExperienceDetailsView(model) {
            var _this2 = this;

            var promise = Promise.resolved();

            if (this._experienceView) {
                promise = this._experienceView.fadeOut();
            }

            promise.done(function () {
                // Wait until the promise is done before creating the _experienceView, otherwise it will not be cleaned
                // up properly if users switch tabs quickly.
                _this2._experienceView = new QuickViewExperienceDetailsView(_.extend(_this2.options, {
                    // If given a model, use that. If there are variants, use the first. Otherwise it is a regular Experience, use that.
                    model: model || _this2._entries && _this2._entries[0][0] || _this2.model
                }));

                _this2.experienceDetailsRegion.show(_this2._experienceView);

                _this2._experienceView.fadeIn().done(function () {
                    _this2._experienceView.model.trigger(QuickViewConstants.EventNames.QUICK_VIEW_SHOWN);
                });

                _this2.listenToOnce(_this2._experienceView, "closeQuickView", _this2.close);
            });
        },

        _showGroupDetailsView: function _showGroupDetailsView() {
            var view = new QuickViewGroupDetailsView(_.extend(this.options, {
                model: this.model,
                entries: this._entries,
                group: this._group,
                project: this.options.projectContext && this.options.projectContext.project
            }));

            this.groupDetailsRegion.show(view);
        },

        _showSelectedExperienceByModel: function _showSelectedExperienceByModel(selectedModel) {
            // Make sure all data is fetched for the selected variant, before showing the preview
            selectedModel.fetchAll().done(this._showExperienceDetailsView.bind(this));
        },

        _viewActive: function _viewActive() {
            return !this.isClosed;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        CommentCollection = __webpack_require__(710),
        _require = __webpack_require__(120),
        DateUtil = _require.DateUtil,
        EditorEvents = __webpack_require__(17),
        EditBehavior = __webpack_require__(106),
        ExperienceViewer = __webpack_require__(1211),
        ExperienceCncViewer = __webpack_require__(1212),
        ExperienceViewModel = __webpack_require__(343),
        ImprovedView = __webpack_require__(6),
        LoggedInUserState = __webpack_require__(19),
        Preconditions = __webpack_require__(14),
        Promise = __webpack_require__(21),
        PublishableState = __webpack_require__(65),
        QuickViewConstants = __webpack_require__(1213),
        Size = __webpack_require__(84),
        SpinnerView = __webpack_require__(244),
        template = __webpack_require__(2876),
        Tooltip = __webpack_require__(35),
        TweenMax = __webpack_require__(152),
        UrlUtil = __webpack_require__(46),
        URLBox = __webpack_require__(1214),
        UserCollection = __webpack_require__(184);


    var EXPERIENCE_PREVIEW_WIDTH = 498,
        EXPERIENCE_PREVIEW_HEIGHT = 250;

    /**
     * Sub view used by the <tt>QuickView</tt> for displaying experience details, statistics etc.
     *
     * @cfg {ExperienceModel} model The experience model.
     *
     * @class QuickViewExperienceDetailsView
     */
    return ImprovedView.extend({
        _experienceViewer: null,

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                hasValidURL: this._hasValidURL(),
                humanDate: DateUtil.formatMMDDYYY.bind(DateUtil),
                editedAt: this.model.getEditedAt(),
                spectatorMode: this.options.spectatorMode
            };
        },

        bindings: {
            ".edit-name": {
                // We need to use updateMethod "html" and escape true, because we are using a tag contenteditable
                observe: "name",
                updateMethod: "html",
                escape: true,
                // The dashboard items will be refreshed only when this field is blurred
                events: ["blur"]
            }
        },

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,
                container: ".editable-container",
                editFields: [{
                    input: ".edit-name",
                    model: "name",
                    save: function save(val) {
                        var _this = this;

                        this.model.set("name", val);

                        return this.model.saveLater().done(function () {
                            var eventProperties = {
                                experienceId: _this.model.get("id"),
                                experienceVersion: _this.model.get("version"),
                                experiencePushedVersion: _this.model.get("pushedVersion"),
                                triggerOrigin: "EditExperienceNameInputField",
                                projectId: _this.options.projectContext && _this.options.projectContext.project.get("id"),
                                updatedProperty: "name",
                                quickView: true,
                                updatedValue: val
                            };

                            EditorEvents.trigger(EditorEvents.constants.UPDATE_EXPERIENCE, eventProperties);
                        });
                    }
                }]
            }
        },

        regions: {
            experiencePreview: ".experience-preview"
        },

        ui: {
            currentExperienceStatus: ".current-experience-status",
            notPushedChangesWarning: ".not-pushed-changes-warning",
            pushedCheckMark: ".pushed-check-mark",
            readableState: ".readable-state",
            toggleExperienceURL: ".toggle-experience-url",
            urlContainer: ".experience-url-container",
            commentsIndicatorContainer: ".comments-current",
            newCommentsIndicatorWrapper: ".unread-comments-indicator-wrapper",
            newCommentsIndicator: ".unread-comments-indicator",
            authorName: ".author-name",
            editorName: ".editor-name",
            experienceIdCopy: ".experience-id-copy"
        },

        events: {
            "click .edit-experience, .view-experience": "_trackAndClose",
            "click @ui.toggleExperienceURL": "_toggleExperienceUrl",
            "click @ui.experienceIdCopy": "_copyExperienceId"
        },

        initialize: function initialize() {
            // We need to update the UI of push state after the name is changed on the quick view.
            // Simply listen on the change:name won't work
            this.listenTo(this.model, "sync:state", function () {
                var _this2 = this;

                // Make sure the view is not closed when the promise is done
                Promise.predicate(this.options.promise, this._viewActive.bind(this)).done(function () {
                    _this2._updateState();
                });
            });
        },

        /**
         * Performs a fade in animation.
         *
         * @return {Promise} A Promise that resolves when the transition completes.
         */
        fadeIn: function fadeIn() {
            var _this3 = this;

            return new Promise.deferred(function (deferred) {
                TweenMax.to(_this3.$el, 0.5, { opacity: 1.0, onComplete: deferred.resolve });
            });
        },

        /**
         * Performs a fade out animation.
         *
         * @return {Promise} A Promise that resolves when the transition completes.
         */
        fadeOut: function fadeOut() {
            var element = this.el;

            return new Promise.deferred(function (deferred) {
                TweenMax.to(element, 0.5, { opacity: 0.0, onComplete: deferred.resolve });
            });
        },

        onRender: function onRender() {
            this._initializeURL();
            this._initializeExperienceId();
            this._showComments();
            this._updateState();
            this._updateWorkBy();

            Tooltip.add(this.ui.toggleExperienceURL, { width: 200, placement: "top" });
        },

        onShow: function onShow() {
            var _this4 = this;

            var promise = this.options.promise,
                pendingState = Promise.isPending(promise);

            // Display the notorious spinner if data is currently pending
            if (pendingState) {
                this.experiencePreview.show(new SpinnerView());

                // Make sure the view is not closed when the promise is done
                Promise.predicate(promise, this._viewActive.bind(this)).done(function () {
                    _this4._createPreview();
                });
            } else {
                this._createPreview();
            }
        },

        _viewActive: function _viewActive() {
            return !this.isClosed;
        },

        _updateState: function _updateState() {
            var pushed = this.model.hasAtLeastState(PublishableState.PUSHED),
                nonPushedChanges = this.model.isChangedAfterPush();

            this.ui.currentExperienceStatus.toggleClass("changes", nonPushedChanges);
            this.ui.notPushedChangesWarning.toggle(nonPushedChanges);
            this.ui.pushedCheckMark.toggle(pushed && !nonPushedChanges);

            if (nonPushedChanges) {
                Tooltip.add(this.ui.notPushedChangesWarning, { width: 170, placement: "top" });
            }

            this.ui.readableState.html(this.model.getState().displayName);
        },

        /**
         * @private
         *
         * Creates the <tt>ExperienceViewer</tt> representing the preview.
         */
        _createPreview: function _createPreview() {
            Preconditions.isModel(this.model);
            var previewSize = new Size(EXPERIENCE_PREVIEW_WIDTH, EXPERIENCE_PREVIEW_HEIGHT);
            var integrations = LoggedInUserState.get("integrations");

            if (integrations.isNativeContentIntegrationsEnabled()) {
                this._experienceViewer = new ExperienceCncViewer({
                    model: new ExperienceViewModel({
                        experience: this.model,
                        fixedSize: previewSize
                    }),
                    startEvent: QuickViewConstants.EventNames.QUICK_VIEW_SHOWN,
                    groupsDisable: true,
                    fitInHeight: true
                });
            } else {
                this._experienceViewer = new ExperienceViewer({
                    // Pass a clone of the experience model as the ExperienceViewer might 'scale' (previewSize) the experience
                    model: new ExperienceViewModel({ experience: this.model.clone() }),
                    fixedSize: previewSize,
                    verticalAlign: "top",
                    horizontalAlign: "left"
                });
            }
            this.experiencePreview.show(this._experienceViewer);
        },

        _initializeURL: function _initializeURL() {
            var urlBox = new URLBox({
                urlProvider: this._urlProvider.bind(this),
                helpText: "View your Experience directly with this link.",
                project: this.options.projectContext && this.options.projectContext.project,
                triggerOrigin: "OpenExperienceUrlButton"
            }).render();

            this.ui.urlContainer.html(urlBox.el);
        },

        _urlProvider: function _urlProvider() {
            return UrlUtil.getAbsoluteExperienceUrl(this.model.get("id"));
        },

        _toggleExperienceUrl: function _toggleExperienceUrl(event) {
            if (this._hasValidURL()) {
                event.preventDefault();

                var open = !this.ui.urlContainer.is(":visible");

                this.ui.urlContainer.slideToggle(open);
                this.ui.toggleExperienceURL.toggleClass("open", open);
            }
        },

        _initializeExperienceId: function _initializeExperienceId() {
            this.ui.experienceIdCopy.popover();
        },

        _copyExperienceId: function _copyExperienceId(event) {
            window.getSelection().selectAllChildren(event.target);
            document.execCommand("copy");
        },

        _hasValidURL: function _hasValidURL() {
            return this.model.hasAtLeastState(PublishableState.PUSHED);
        },

        _showComments: function _showComments() {
            var _this5 = this;

            if (this.model.get("lastCommentedAt")) {
                var lastVisit = LoggedInUserState.get("lastVisit")[this.model.get("id")];
                lastVisit = lastVisit && lastVisit.visit || 0;

                // The view might be closed when the promise is resolved - using Promise.predicate to
                // ensure that the promise is rejected if the view is closed.
                Promise.predicate(CommentCollection.countCommentsSince(this.model.get("id"), lastVisit), this._updatable.bind(this)).done(function (numberOfComments) {
                    Preconditions.isNumber(numberOfComments);
                    _this5.ui.commentsIndicatorContainer.show();

                    if (numberOfComments) {
                        _this5.ui.newCommentsIndicatorWrapper.show();
                        _this5.ui.newCommentsIndicator.html(numberOfComments);
                    }
                });
            }
        },

        /**
         * @private
         *
         * Whether the view can be updated, i.e. the view is not considered closed.
         *
         * @return {Boolean} <tt>true</tt> if the view can be updated, <tt>false</tt> if not.
         */
        _updatable: function _updatable() {
            return !this.isClosed;
        },

        /**
         * @private
         *
         * Fetches the user collection to determine who created the experience and who was
         * the last one to edit it - updating the work-by UI accordingly.
         */
        _updateWorkBy: function _updateWorkBy() {
            var _this6 = this;

            // The view might be closed when the promise is resolved - using Promise.predicate to
            // ensure that the promise is rejected if the view is closed.
            Promise.predicate(LoggedInUserState.fetchGlobalCollection(UserCollection), this._updatable.bind(this)).done(function (userCollection) {
                var editedByExperienceModel = _this6.model.get("editedBy"),
                    editedByModel = editedByExperienceModel ? userCollection.findWhere({ id: editedByExperienceModel }) : null,
                    userModel = userCollection.findWhere({ id: _this6.model.get("createdBy") }),
                    authorName = userModel ? userModel.get("name") : "Unknown";

                _this6.ui.editorName.html(editedByModel ? editedByModel.get("name") : authorName);
                _this6.ui.authorName.html(authorName);
            });
        },

        _trackAndClose: function _trackAndClose(event) {
            var target = $(event.target),
                experience = this.model,
                eventProperties = {
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                projectId: this.options.projectContext && this.options.projectContext.project.get("id"),
                quickView: true
            };

            if (target.hasClass("edit-experience")) {
                eventProperties.spectator = false;
                eventProperties.triggerOrigin = "EditExperienceButton";
                EditorEvents.trigger(EditorEvents.constants.OPEN_EXPERIENCE_EDITOR, eventProperties);
            }

            if (target.hasClass("view-experience")) {
                eventProperties.spectator = true;
                eventProperties.triggerOrigin = "ViewExperienceButton";
                EditorEvents.trigger(EditorEvents.constants.OPEN_EXPERIENCE_EDITOR, eventProperties);
            }

            this.trigger("closeQuickView", true);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Marionette = __webpack_require__(10);
    var ImageWidgetModel = __webpack_require__(249);
    var Promise = __webpack_require__(21);
    var Rectangle = __webpack_require__(248);
    var Class = __webpack_require__(26);

    function getWidgetRectFromModel(widget, experience) {
        var position = experience.getPixelPosition(widget.pick(["top", "left"]));
        var size = experience.getPixelSize(widget.pick(["width", "height"]));

        return new Rectangle(_.extend(position, size));
    }

    var ImageWidgetProcessStrategy = Class.extend("ImageWidgetProcessStrategy", {

        /**
         * The current experience.
         *
         * @type {ExperienceModel}
         */
        _experience: null,

        /**
         * The initial viewport.
         *
         * @type {Rectangle}
         */
        _viewportVisibility: null,

        /**
         * Convenience map.
         *
         * @type {Map.<ImageWidgetModel, SceneViewer>}
         */
        _imageToSceneMap: null,

        constructor: function constructor(experienceViewModel) {
            this._experience = experienceViewModel.get("experience");
            this._viewportVisibility = experienceViewModel.get("viewportVisibility");
            this._imageToSceneMap = new Map();
        },
        execute: function execute(initialScenes) {
            var _this = this;

            var sceneViewers = _.isArray(initialScenes) ? initialScenes : [initialScenes];
            var images = [];

            // Collect all images (widgets) from the specified initial scenes.
            // All other widgets are immediately added to their respective scene viewers.
            sceneViewers.forEach(function (scene) {
                scene.model.get("widgets").each(function (widget) {
                    if (widget instanceof ImageWidgetModel) {
                        // Store the images widgets...
                        images.push(widget);
                        _this._imageToSceneMap.set(widget, scene);
                    } else {
                        // This will render "other" widgets immediately...
                        scene.collection.add(widget);
                    }
                });
            });

            var biggestIntersectionArea = 0;

            var imagesInViewport = [];
            var viewportVisibilityArea = this._viewportVisibility.area();

            var heroImage = void 0;
            var i = images.length;

            // Iterate the collected images...
            while (i--) {
                var imageWidget = images[i];
                var widgetRectangle = getWidgetRectFromModel(imageWidget, this._experience);
                var widgetIsVisible = this._viewportVisibility.intersects(widgetRectangle);

                // Prioritize those that are currently within the viewport.
                if (widgetIsVisible) {
                    // Pull them out of the overall list of images...
                    images.splice(i, 1);
                    // Keep track of the visible images...
                    imagesInViewport.push(imageWidget);

                    var intersectionArea = this._viewportVisibility.intersectionArea(widgetRectangle);

                    // If we have an image that takes up more than 50% of the viewport, find the biggest, so that we can load that "alone".
                    if (intersectionArea / viewportVisibilityArea >= 0.5 && intersectionArea > biggestIntersectionArea) {
                        heroImage = imageWidget;
                        biggestIntersectionArea = intersectionArea;
                    }
                }
            }

            return {
                heroImage: heroImage,
                imagesInViewport: imagesInViewport,
                imagesOutsideViewport: images
            };
        },
        sceneViewerFromModel: function sceneViewerFromModel(model) {
            return this._imageToSceneMap.get(model);
        }
    });

    /**
     * Responsible for prioritizing load of image widgets within the initial visible viewport. This concept is
     * only applied to the initial scenes.
     *
     * @see  ExperienceViewer
     *
     * @class InitialScenesController
     */
    var InitialScenesController = Marionette.Controller.extend("InitialScenesController", {

        /**
         * Constructor.
         *
         * @param  {ExperienceViewModel} experienceViewModel The current <tt>ExperienceViewModel</tt>.
         */
        constructor: function constructor(experienceViewModel) {
            this.__super();

            this._strategy = new ImageWidgetProcessStrategy(experienceViewModel);
        },


        /**
         * Processes the specified scenes' widgets, prioritizing image widgets that are
         * currently in the visible viewport. All other widgets are immediately added.
         *
         * The provided <tt>SceneViewer</tt>'s, must have <tt>extractCollection</tt> set to
         * false, otherwise they will render all widgets immediately.
         *
         * @param  {...SceneViewer} scenes The <tt>SceneViewer</tt>'s to process widgets for.
         * @return {Promise}               A promise that resolves when the images contained in
         *                                 the visible viewport has been loaded.
         */
        process: function process() {
            var _this2 = this;

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var executionStrategy = this._strategy.execute(args);

            var heroPromise = executionStrategy.heroImage ? this._loadImage(executionStrategy.heroImage) : Promise.resolved();

            // First, load the hero image, if any...
            return heroPromise
            // Load the rest of the images in viewport in parallel. Returning the combined promise.
            .then(function () {
                return _this2._loadImage(executionStrategy.imagesInViewport);
            }).then(function () {
                // Add the rest of the images.
                _this2._loadImage(executionStrategy.imagesOutsideViewport);
            });
        },


        /**
         * Adds the image widget (or array of image widgets) to their respective scene
         * viewer, returning a <tt>Promise</tt> that resolves once the images has loaded.
         *
         * @param  {ImageWidgetModel|ImageWidgetMode[]} The <tt>ImageWidgetModel</tt> (or array of <tt>ImageWidgetModel</tt>'s) to "load".
         * @return {Promise}                            A <tt>Promise</tt> that resolves once the images has loaded.
         */
        _loadImage: function _loadImage(imageWidgetModel) {
            var _this3 = this;

            var imageModels = _.isArray(imageWidgetModel) ? imageWidgetModel : [imageWidgetModel];
            var promises = _.map(imageModels, function (model) {
                var sceneViewer = _this3._strategy.sceneViewerFromModel(model);
                sceneViewer.collection.add(model);

                var widgetView = sceneViewer.widgetViewFromModel(model);

                return Promise.deferred(function (deferred) {
                    // Proceed even on image load failure - hence 'always'.
                    widgetView.promise().always(deferred.resolve);
                });
            });

            return Promise.all(promises);
        }
    });

    return {

        /**
         * Static convenience method delegating to the instance's <tt>process</tt> function.
         *
         * @param  {ExperienceViewModel} experienceViewModel The current <tt>ExperienceViewModel</tt>.
         * @param  {...SceneViewer} experienceViewModel The <tt>SceneViewer</tt>'s to process widgets for.
         *
         * @return {Promise}               A promise that resolves when ALL images belonging to
         *                                 the specified scenes have been loaded.
         *
         * @see  InitialScenesController#process
         */
        process: function process(experienceViewModel) {
            var controller = new InitialScenesController(experienceViewModel);

            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
            }

            return controller.process.apply(controller, _toConsumableArray(args));
        },


        ImageWidgetProcessStrategy: ImageWidgetProcessStrategy

    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Class = __webpack_require__(26);
    var Marionette = __webpack_require__(10);
    var Size = __webpack_require__(84);
    var Rectangle = __webpack_require__(248);
    var Scale = __webpack_require__(360);
    var Browser = __webpack_require__(39);
    var Window = __webpack_require__(48);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Promise = __webpack_require__(21);
    var Preconditions = __webpack_require__(14);
    var MathUtil = __webpack_require__(72).default;
    var channelBridge = __webpack_require__(241);

    /**
     * The maximum period of time that the timer will run before timeout.
     *
     * @type {Number}
     */
    var INVALIDATE_VIEWPORT_SIZE_TIMEOUT = 5000;

    /**
     * The polling interval for checking the viewport size.
     *
     * @type {Number}
     */
    var INVALIDATE_VIEWPORT_SIZE_INTERVAL = 500;

    var log = new Logger("ResponsiveViewerController");

    /**
     * Internal convenience class used for checking the parent viewport size. <p>
     *
     * This mostly makes sense for embedded experiences, where the viewport size may
     * not be ready at initialization time.
     *
     * The timer will timeout after <tt>INVALIDATE_VIEWPORT_SIZE_TIMEOUT</tt>
     * milliseconds, *resolving* the internal deferred instance with a value of "timeout".
     * On success, the resolved value will be "valid" and if forcefully stopped the
     * resolved value is "stopped".
     *
     * @class ValidSizeTimer
     */
    var ValidSizeTimer = Class.extend({

        /**
         * @type {Function}
         */
        _predicate: null,

        /**
         * @type {Deferred}
         */
        _deferred: null,

        /**
         * @type {Number}
         */
        _interval: null,

        /**
         * @type {Number}
         */
        _timeout: null,

        /**
         * Constructor.
         *
         * @param  {Function} predicate A predicate function to check for every
         *                              interval. If the function returns <tt>true</tt>,
         *                              the internal deferred object will be resolved.
         *
         * @see #promise
         */
        constructor: function constructor(predicate) {
            this._predicate = predicate;
            this._deferred = Promise.deferred();
        },


        /**
         * Starts the timer if not already started, returning a promise that will resolve on a valid size, but
         * rejected after the timeout in case no valid size could be detected. <p>
         *
         * This timer can be restarted if not currently running, e.g. after it has been stopped. If so, a new deferred
         * will be used internally, returning fresh promises.
         *
         * @return {Promise} A promise to be resolved (now) when a valid size is obtained, or rejected after the
         *                   configured timeout otherwise. The promise may already have been resolved, i.e. if the
         *                   size is already valid at the point in time this is called (no need to start the timer).
         * @see    #running
         * @see    #stop
         */
        start: function start() {
            this._timeout = setTimeout(this._end.bind(this, true), INVALIDATE_VIEWPORT_SIZE_TIMEOUT);
            this._interval = setInterval(this._tick.bind(this), INVALIDATE_VIEWPORT_SIZE_INTERVAL);

            log.warn("Invalid viewport size at start time - starting size invalidation timer");
            return this._deferred.promise();
        },


        /**
         *
         */
        stop: function stop(cause) {
            if (this._interval) {
                clearInterval(this._interval);
                clearTimeout(this._timeout);
                this._interval = null;
                this._timeout = null;

                this._deferred.resolve(cause || "stopped"); // not necessarily an error, so notify listeners about this!
            }
        },
        _tick: function _tick() {
            if (this._predicate()) {
                this._end();
            }
        },


        /**
         * @private
         * Called when this timer has end-of-life, either because a valid size has been detected or because of a
         * timeout.
         *
         * @param {Boolean} [timeout] True on time out, falsey on (earlier) success.
         */
        _end: function _end(timeout) {
            // TODO: Consider using Promise.timeout(..)/Promise.time(..) to handle timeout
            if (timeout === true) {
                log.warn("Timed out, after " + INVALIDATE_VIEWPORT_SIZE_TIMEOUT + " milliseconds, due to invalid viewport size");
                this.stop("timeout");
            } else {
                log.info("Got a valid viewport size - continuing rendering");
                this.stop("valid");
            }
        }
    });

    /**
     * Class for managing the viewer size (e.g. scale), when embedded in a responsive environment.
     *
     * <pre>
     *
     * var controller = new ResponsiveViewerController({
     *     viewer: viewer
     * });
     *
     * // Call #ready to start the responsive behavior...
     * controller.ready()
     *     .done(function () {
     *         console.info("Successful rendering");
     *     })
     *     .fail(function () {
     *         console.error("Viewport size invalid");
     *     });
     *
     * </pre>
     *
     * @author Kim
     * @class ResponsiveViewerController
     *
     * @cfg {ExperienceViewer} viewer The current <tt>ExperienceViewer</tt> instance.
     */
    var ResponsiveViewerController = Marionette.Controller.extend({

        _experienceSize: null,

        /**
         * @type {ExperienceViewer}
         */
        _viewer: null,

        /**
         * @type {ExperienceModel}
         */
        _experience: null,

        _window: $(window),

        _topWindow: null,

        _embedContainer: null,

        /**
         * @private @type {Size}
         * The fixed view port size, e.g. the size of the QuickView in the editor. Will never change.
         */
        _viewportSize: null,

        /**
         * @private @type {Size}
         * The initial view port size, used when this Viewer/Experience is rendered on an adjacent Scene, with
         * display: none and thus (0,0) viewport. By setting the initial viewport size, the initial rendering
         * will be scaled correct and updated normally on for example resize.
         */
        _viewportInitialSize: null,

        _validSizeTimer: null,

        _viewModel: null,

        _scrollableContainer: null,

        initialize: function initialize() {
            // If we have a channel bridge here, we are embedded via channels in an iframe loaded via channels...
            var bridge = channelBridge();

            this._viewModel = this.options.viewer.model;
            this._experience = this._viewModel.get("experience");
            this._viewportSize = this.options.viewportSize;
            this._viewportInitialSize = this.options.viewportInitialSize;
            this._viewer = this.options.viewer;
            // can still be true for embedded experiences via a widget even if no channel bridge
            this._embeddedInIframe = window !== window.top;
            this._experienceSize = this._experience.getSize();
            this._scrollableContainer = this.options.scrollableContainer;
            this._containerSizeProvider = this.options.containerSizeProvider || this._containerSizeProvider;

            // TODO: for embedded experiences (recursively), should most of these statements not reference the parent
            //       window instead of the top most, e.g. for scrolling and viewport.

            // Grab a reference to the top level window - some browsers (hint: mobile
            // Safari does not fire resize and orientation change events on framed windows)
            this._topWindow = this._embeddedInIframe ? $(Window.topWindow()) : this._window;

            // Determine whether we need to fetch the viewport size from the parent container
            // (if we're embedded via channels) - we do this to circumvent an issue with iframes not being
            // responsive in mobile Safari (aka. 'isResponsiveIframesSupported'). An embed container
            // supplied via options is used for preview in the editor.
            this._embedContainer = this.options.embedContainer || (bridge && !Browser.capabilities.isResponsiveIframesSupported ? bridge.matchedElement() : null);

            // Only defined if we're embedded via channels...
            this._viewportVisibilityContainer = bridge && bridge.iframeElement();

            // Only defined if we are in the editor preview
            if (this._scrollableContainer) {
                this._scrollableContainer.on("scroll", this.updateIfValid.bind(this));
            }

            // Make sure this controller is not actively checking sizes while the Viewer is for example rendered
            // on the next scene embedded. Notice the "active" property thus in effect applies to the entire
            // Experience, since all Scenes are then inactive, while at most one can be active on true, i.e. the
            // current one. The cause of the "change:active" will be some other Experience calling this embedded
            // one, either directly or indirectly, via is ViewerProxy.state({active: true|false, ..}) method...
            this.listenTo(this._viewModel, "change:active", this.updateIfValid.bind(this));

            // Listen for future required updates, but only when active like described above for "change:active", but
            // this is already handled elsewhere, i.e. these listeners will be inactive when the view model
            // becomes inactive by design...
            this._layoutListener = Window.on({
                event: "resize orientationchange",
                callback: this.updateIfValid,
                scope: this,
                win: this._topWindow,
                debounce: 300
            });
            this._scrollListener = Window.on({
                event: "scroll",
                callback: this.updateIfValid,
                scope: this,
                win: this._topWindow,
                throttle: 100
            });
        },


        /**
         * Returns the size of the specified (jQuery wrapped) container.
         *
         * This may be "overridden" if a <tt>containerSizeProvider</tt> is specified in the passed options.
         *
         * @param  {jQueryElement} $container The container to measure.
         * @return {Size}                     The size of the container.
         *
         * @see PreviewExperienceViewer
         */
        _containerSizeProvider: function _containerSizeProvider($container) {
            return Size.from($container.width(), $container.height());
        },
        _getViewportSize: function _getViewportSize() {
            // If we're embedded, check to see if the size of the iframe is different from it's parent.
            // In theory, they should be the same (size the iframe is sized 100%x100%), but it seems
            // some browsers get it wrong (hint: Mobile Safari, MOS-1489). In that case we return the
            // parent size always, even if identical...
            if (this._embedContainer) {
                return new Size(this._embedContainer.innerWidth(), this._embedContainer.innerHeight());
            }
            // viewport size is fixed, but the initial viewport size is for embedding Experiences, say on
            // adjacent Scenes where the window (iframe) viewport at initialisation time will be (0,0) because
            // the iframe has to be hidden via display:none because of a Webkit bug regarding src=about:blank...
            return this._viewportSize || this._viewportInitialSize || new Size(this._window.width(), this._window.height());
        },


        /**
         * @private
         *
         * Returns <tt>true</tt> if a valid (<tt>width > 0 && height > 0</tt>)
         * viewport size is detected, <tt>false</tt> if not.
         *
         * @return {Boolean} <tt>true</tt> if a valid (<tt>width > 0 && height > 0</tt>)
         * viewport size is detected, <tt>false</tt> if not.
         */
        _validViewportSize: function _validViewportSize() {
            var size = this._getViewportSize();
            return size.width > 0 && size.height > 0;
        },


        /**
         * @private
         * Updates the size if and only if the view port size is valid.
         */
        updateIfValid: function updateIfValid() {
            // If we have a valid view port size at the time of change, make sure we update...
            var valid = this._validViewportSize();
            if (valid) {
                this._update();
            }

            // Done with the initial size...
            if (this._viewModel.get("active")) {
                this._viewportInitialSize = null;
            }
            return valid;
        },


        // Note: this is still relevant when paused or stalled, but must be ignored when not active...
        _update: function _update() {
            var size = this._getViewportSize();
            var newExperienceSize = this._experienceSize;

            // We need a valid size in order to render correctly
            Preconditions.checkState(size.width > 0 && size.height > 0, "Invalid viewport size: " + size.width + "x" + size.height);

            // We don't want to scale up when experiences are viewed in browser via URL
            if (this._embeddedInIframe || size.width < this._experienceSize.width || size.height < this._experienceSize.height) {
                newExperienceSize = size.shrinkToAspectRatio(this._experienceSize.getAspectRatio());
            }

            // Perform the transformation
            var scaleX = newExperienceSize.width / this._experienceSize.width;
            var scaleY = newExperienceSize.height / this._experienceSize.height;
            var left = this._getCoordinate("x", size, newExperienceSize);
            var top = this._getCoordinate("y", size, newExperienceSize);

            // Position and scale the experience
            this._viewer.position(left, top);
            this._experience.set("scale", Scale.from(scaleX, scaleY));
            var experienceOffset = {
                left: left,
                top: top
            };
            this._updateViewportVisibility(experienceOffset);
        },
        _updateViewportVisibility: function _updateViewportVisibility(experienceOffset) {
            var visiblePartOfExperience = void 0;
            var containerSize = void 0;
            var containerOffset = void 0;

            if (this._viewportVisibilityContainer) {
                // TODO: should this not reference the parent window only?
                containerSize = this._containerSizeProvider(this._viewportVisibilityContainer);
                containerOffset = Window.offset(this._viewportVisibilityContainer);

                visiblePartOfExperience = ResponsiveViewerController._getVisiblePartOfExperience(containerSize, containerOffset, experienceOffset, this._topWindow);
            } else if (this._scrollableContainer) {
                containerSize = this._containerSizeProvider(this._embedContainer);
                // Means that we are in the preview and have no offset.
                containerOffset = { left: 0, top: 0 };

                visiblePartOfExperience = ResponsiveViewerController._getVisiblePartOfExperience(containerSize, containerOffset, experienceOffset, this._scrollableContainer);
            } else {
                visiblePartOfExperience = new Rectangle(0, 0, this._experienceSize.width, this._experienceSize.height);
            }

            this._viewModel.set("viewportVisibility", visiblePartOfExperience);
        },
        _getCoordinate: function _getCoordinate(axis, size, experienceSize) {
            var side = void 0;
            var alignment = void 0;

            if (axis === "x") {
                side = "width";
                alignment = this.options.horizontalAlign || "center";
            } else {
                side = "height";
                alignment = this.options.verticalAlign || "middle";
            }

            switch (alignment) {
                case "left":
                case "top":
                    return 0;

                case "center":
                case "middle":
                    return Math.round(size[side] * 0.5 - experienceSize[side] * 0.5);

                case "right":
                case "bottom":
                    return Math.round(size[side] - experienceSize[side]);

                default:
                    // Candidate for refactoring during MOS-2934.
                    Preconditions.fail("DefaultSwitchWarn - The alignment '" + alignment + "' is not recognized.");
                    break;
            }
        },
        start: function start() {
            var _this = this;

            // Set the initial active state as dictated by the view model, which will trigger an update
            // if the viewport is valid...
            var valid = this.updateIfValid();
            var promise = void 0;

            // Start time on invalid view port...
            if (!valid) {
                if (this._validSizeTimer) {
                    this._validSizeTimer.stop();
                }
                this._validSizeTimer = new ValidSizeTimer(this._validViewportSize.bind(this));

                // Once the size becomes valid, start listening for responsive changes...
                promise = this._validSizeTimer.start().then(function (state) {
                    _this._validSizeTimer = null;
                    _this.updateIfValid();
                    return state === "valid"; // or "timeout" or "stopped"
                });
            }

            if (!promise) {
                return Promise.resolved(valid);
            }

            return promise;
        },
        onClose: function onClose() {
            if (this._layoutListener) {
                this._layoutListener.off();
            }
            if (this._scrollListener) {
                this._scrollListener.off();
            }
            if (this._validSizeTimer) {
                this._validSizeTimer.stop();
                this._validSizeTimer = null;
            }

            // Restore original scale...
            this._experience.set("scale", new Scale());
        }
    }, {
        /**
         * Returns a rectangle specifying the visible part of the experience. If the experience
         * outside the window, and thus invisible an empty rectangle is returned, i.e.
         * rectangle.isEmpty() === true.
         *
         * TODO MOS-2620: The size of the experience is not taken into account, so the rectangle
         * might exceed the right and the bottom part of the experience. This is currently
         * acceptable since the returned value is only used to determine what widgets are currently
         * visible.
         *
         * @param {Size} containerSize The size of the current container.
         * the container. If the experience is embedded this is the iframe. If it's running it full
         * screen this is the web page.
         * @param {Offset} containerOffset The position of the container relative to the web page.
         * @param {Offset} experienceOffset The position of the experience relative to the
         * container.
         * @param {jQuery} topWindow The browser window.
         * @returns {Rectangle}
         */
        _getVisiblePartOfExperience: function _getVisiblePartOfExperience(containerSize, containerOffset, experienceOffset, topWindow) {
            var viewportHeight = topWindow.height();
            var viewportTop = topWindow.scrollTop();
            var viewportBottom = viewportTop + viewportHeight;
            var containerHeight = containerSize.height;
            var containerTop = containerOffset ? containerOffset.top + experienceOffset.top : 0;
            var containerBottom = containerTop + containerHeight;
            var verticalOverlapFraction = MathUtil.overlapFraction(containerTop, containerBottom, viewportTop, viewportBottom);

            var top = MathUtil.between(viewportTop - containerTop, 0, containerHeight);
            var height = MathUtil.between(verticalOverlapFraction * viewportHeight, 0, viewportHeight);

            var viewportWidth = topWindow.width();
            var viewportLeft = topWindow.scrollLeft();
            var viewportRight = viewportLeft + viewportWidth;
            var containerWidth = containerSize.width;
            var containerLeft = containerOffset ? containerOffset.left + experienceOffset.left : 0;
            var containerRight = containerLeft + containerWidth;
            var horizontalOverlapFraction = MathUtil.overlapFraction(containerLeft, containerRight, viewportLeft, viewportRight);

            var left = MathUtil.between(viewportLeft - containerLeft, 0, containerWidth);
            var width = MathUtil.between(horizontalOverlapFraction * viewportWidth, 0, viewportWidth);

            var visiblePartOfExperience = new Rectangle(top, left, width, height);
            return visiblePartOfExperience;
        }
    });

    return ResponsiveViewerController;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var Browser = __webpack_require__(39);
    var Class = __webpack_require__(26);
    var ExperienceViewModel = __webpack_require__(343);
    var Preconditions = __webpack_require__(14);
    var Promise = __webpack_require__(21);
    var SceneTransition = __webpack_require__(792).default;
    var SceneTransitionTypes = __webpack_require__(524).default;
    var TweenMax = __webpack_require__(152);

    var DEFAULT_TRANSITION_DURATION = 0.5; // 500 milliseconds

    /**
     * Handles the various transitions between scenes.
     *
     * @author Kim
     * @class SceneTransitionController
     * @constructor
     *
     * @param {ExperienceViewModel} experienceViewModel The view model for the experience.
     */
    return Class.extend({

        _experienceViewModel: null,

        _currentSceneViewer: null,

        _previousViewer: null,

        _deferreds: null,

        constructor: function constructor(experienceViewModel) {
            this._experienceViewModel = experienceViewModel;
            this._deferreds = [];
        },
        _scaledExperienceSize: function _scaledExperienceSize() {
            return this._experienceViewModel.get("experience").getSize(true);
        },
        _playTransition: function _playTransition(sceneViewer, transition, duration) {
            var options = {
                force3D: Browser.capabilities.is3dAnimationsSupported
            };
            var size = this._scaledExperienceSize();

            var from = true;
            var out = false;

            // For simplicity, all transitions start at 0,0
            TweenMax.set(sceneViewer.el, { x: 0, y: 0 });

            switch (transition) {
                // Horizontal
                case SceneTransition.MOVE_FROM_RIGHT:
                    options.x = size.width;
                    break;

                case SceneTransition.MOVE_FROM_LEFT:
                    options.x = -size.width;
                    break;

                case SceneTransition.MOVE_TO_LEFT:
                    from = false;
                    out = true;
                    options.x = -size.width;
                    break;

                case SceneTransition.MOVE_TO_RIGHT:
                    from = false;
                    out = true;
                    options.x = size.width;
                    break;

                // Fade
                case SceneTransition.FADE_IN:
                    TweenMax.set(sceneViewer.el, { opacity: 0 });
                    from = false;
                    options.opacity = 1;
                    break;

                case SceneTransition.FADE_OUT:
                    from = false;
                    out = true;
                    options.opacity = 0;
                    break;

                // Vertical
                case SceneTransition.MOVE_FROM_TOP:
                    options.y = -size.height;
                    break;

                case SceneTransition.MOVE_TO_BOTTOM:
                    from = false;
                    out = true;
                    options.y = size.height;
                    break;

                case SceneTransition.MOVE_FROM_BOTTOM:
                    options.y = size.height;
                    break;

                case SceneTransition.MOVE_TO_TOP:
                    from = false;
                    out = true;
                    options.y = -size.height;
                    break;

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - The transition '" + transition + "' is not recognized.");
                    break;
            }

            return $.Deferred(function (deferred) {
                options.onComplete = function () {
                    deferred.resolve();

                    // Hide scenes after they are transitioned out
                    if (out) {
                        sceneViewer.hide();
                    }
                };

                options.onStart = function () {
                    // Let's make sure the target element is always shown
                    sceneViewer.show();
                };

                var tweenFunction = from ? TweenMax.from : TweenMax.to;
                var tweenDuration = _.isNumber(duration) ? duration : DEFAULT_TRANSITION_DURATION;

                if (tweenDuration === 0) {
                    // Manually invoke onStart if the duration is 0, i.e. a 'NONE' scene transition.
                    // Note that onComplete will be trigged...
                    options.onStart();
                    // No need to pass it on...
                    delete options.onStart;
                }

                tweenFunction.call(TweenMax, sceneViewer.el, tweenDuration, options);
            }).promise();
        },
        _removeDeferred: function _removeDeferred(deferred) {
            var descriptor = _.findWhere(this._deferreds, { deferred: deferred });
            var i = this._deferreds.indexOf(descriptor);

            if (i !== -1) {
                this._deferreds.splice(i, 1);
            }
        },
        _isAnimating: function _isAnimating() {
            return this._deferreds.length > 0;
        },


        /**
         * Registers the initial scenes, making sure to show the current
         * scene and apply any (initial) CSS properties.
         *
         * This method should only be called once/initially.
         *
         * @param {SceneViewer} currentSceneViewer The initial scene viewer.
         * @param {SceneViewer} overlaySceneViewer The overlay scene viewer.
         * @param {SceneViewer} backgroundSceneViewer The background scene viewer.
         */
        registerInitialSceneViewers: function registerInitialSceneViewers(currentSceneViewer, overlaySceneViewer, backgroundSceneViewer) {
            this._currentSceneViewer = currentSceneViewer;

            // Apply default properties, making sure that the initial scenes
            // gets the proper CSS properties applied. E.g. Desktop Safari needs
            // translate3d to be applied in order to render consistently (see MOS-1532)
            TweenMax.set([currentSceneViewer.el, overlaySceneViewer.el, backgroundSceneViewer.el], {
                x: 0,
                y: 0,
                force3D: Browser.capabilities.is3dAnimationsSupported
            });

            // Show the current scene
            currentSceneViewer.show();
        },


        /**
         * Performs a transition that animates the specified <tt>sceneViewer</tt> "in"
         * and animates any previous specified scene viewer "out".
         *
         * @param  {SceneViewer} sceneViewer The scene viewer to animate in.
         *
         * @return {Deferred} A Deferred instance that will be resolved when the
         * transition completes or a new one begins.
         */
        transitionTo: function transitionTo(sceneViewer) {
            var _this = this;

            if (sceneViewer === this._currentSceneViewer) {
                return Promise.resolved(this._currentSceneViewer, null);
            }

            var transition = this.getTransition();

            // Handle any ongoing transitions
            if (this._isAnimating()) {
                TweenMax.killTweensOf(this._currentSceneViewer.el);
                TweenMax.killTweensOf(this._previousViewer.el);

                // Resolve any pending promises
                _.invoke(this._deferreds, "resolve");
            }

            // Animate the current view "out"
            if (this._currentSceneViewer) {
                this._previousViewer = this._currentSceneViewer;
                this._playTransition(this._previousViewer, transition.out, transition.duration);
            }

            // The passed sceneViewer is now considered the current view
            this._currentSceneViewer = sceneViewer;

            var deferred = $.Deferred(function (deferred) {
                _this._playTransition(sceneViewer, transition.in, transition.duration).done(function () {
                    _this._removeDeferred(deferred);
                    deferred.resolve(_this._currentSceneViewer, _this._previousViewer);
                });
            });

            // Create and store a descriptor object
            var deferredDescriptor = {
                deferred: deferred,
                resolve: function resolve() {
                    deferred.resolve(_this._currentSceneViewer, _this._previousViewer);
                }
            };

            this._deferreds.push(deferredDescriptor);

            return deferred;
        },
        getTransitionType: function getTransitionType() {
            var experience = this._experienceViewModel.get("experience");
            var transitionKey = Object.keys(SceneTransitionTypes).filter(function (key) {
                return SceneTransitionTypes[key].value.id === experience.get("transition");
            })[0];
            return transitionKey === undefined ? SceneTransitionTypes.NONE.value : SceneTransitionTypes[transitionKey].value;
        },
        getTransition: function getTransition() {
            var transitionType = this.getTransitionType();
            return this._experienceViewModel.get("direction") === ExperienceViewModel.DIRECTION_FORWARD ? transitionType.forwardTransition : transitionType.reverseTransition;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2874 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="background-region"></div>\n<div class="overlay-region"></div>\n';

}
return __p
}

/***/ }),
/* 2875 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<div class="cnc-inner-container">\n    ';
 if (templateId) { ;
__p += '\n        <div class="zmags-viewer-container event-start" style="' +
__e( viewerStyle ) +
'" data-template="' +
__e( templateId ) +
'"></div>\n    ';
 } else { ;
__p += '\n    <div class="zmags-viewer-container event-start" style="' +
__e( viewerStyle ) +
'"\n        data-experience="' +
__e( experienceId ) +
'" \n        data-fit-in-height="' +
__e( fitInHeight ) +
'" \n        data-group-disable="' +
__e( groupsDisable ) +
'"\n        ></div>\n    ';
 } ;
__p += '\n</div> ';

}
return __p
}

/***/ }),
/* 2876 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="experience-name editable-container">\n    <div contenteditable="' +
__e(!spectatorMode) +
'" class="editable edit-name';
if(spectatorMode){;
__p += ' disabled';
};
__p += '" ';
if(spectatorMode){;
__p += 'disabled';
};
__p += '>\n    </div>\n</div>\n\n<div class="comments-current current-meta">\n    <div class="comments-indicator">\n        <div class="unread-comments-indicator-wrapper">\n            <div class="unread-comments-indicator"></div>\n        </div>\n    </div>\n</div>\n\n<div class="current-experience-status">\n    <i class="glyphicon glyphicon-exclamation-sign important not-pushed-changes-warning" data-content="The current version of this Experience is Not Pushed."></i>\n    <span class="pushed-check-mark">&#10003;</span>\n    <span class="readable-state"><span>\n</div>\n\n<div class="experience-preview-container">\n    <div class="experience-preview experience-container"></div>\n</div>\n\n';
 if (spectatorMode) { ;
__p += '\n<a href="#experience/' +
__e( id ) +
'/edit" class="view-experience pull-right btn btn-primary">View</a>\n';
 } else { ;
__p += '\n<a href="#experience/' +
__e( id ) +
'/edit" class="edit-experience pull-right btn btn-primary">Edit</a>\n';
 } ;
__p += '\n\n<a href="#" class="toggle-experience-url toggle-title\n    ';
 if (spectatorMode && !hasValidURL) { ;
__p += '\n    disabled" data-content="The direct Experience URL has not been enabled.\n    ';
 } else if (!hasValidURL) { ;
__p += '\n    disabled" data-content="To get a direct URL open your Experience and click Push.\n    ';
 } ;
__p += '\n    ">Experience URL</a>\n<div class="experience-url-container url-container"></div>\n<div class="experience-id-container">\n    <dl><dt>Experience ID</dt>\n        <dd class="experience-id-copy"\n            data-toggle     = "popover"\n            data-placement  = "bottom"\n            data-trigger    = "hover"\n            data-content    = "Click to copy.">' +
__e( id ) +
'</dd>\n    </dl>\n</div>\n<div class="work-by row">\n    <div class="col col-xs-6 created-by">\n        <label>Created by:</label>\n        <div>\n            <span class="author-name">' +
__e( createdBy ) +
'</span>\n            <span class="date">(' +
__e( humanDate(createdAt) ) +
')</span>\n        </div>\n    </div>\n    <div class="col col-xs-6 edited-by">\n        <label>Last Updated by:</label>\n        <div>\n            <span class="editor-name">' +
__e( editedBy ) +
'</span>\n            <span class="date">(' +
__e( humanDate(editedAt) ) +
')</span>\n        </div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2877 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="row">\n    <div class="col-xs-2 col btn-container">\n        <a class="open-button btn" target="_blank">Open</a>\n    </div>\n    <div class="col-xs-10 col">\n        <input\n            id="url-input"\n            class="url-box"\n            type="text"\n            value="' +
__e(url) +
'"\n            data-toggle     = "popover"\n            data-placement  = "bottom"\n            data-trigger    = "hover"\n            data-content    = "Press ' +
__e(button) +
'-C to copy."\n            onMouseOver="this.select();"\n            onMouseOut="this.select();"\n            onClick="this.select();"\n            readonly\n        />\n    </div>\n</div>\n<span class="help-block">' +
__e( helpText ) +
'</span>\n';

}
return __p
}

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        ImprovedView = __webpack_require__(6),
        LoggedInUserState = __webpack_require__(19),
        PublishableState = __webpack_require__(65),
        template = __webpack_require__(2879),
        Tooltip = __webpack_require__(35),
        URLBox = __webpack_require__(1214),
        UrlUtil = __webpack_require__(46);

    /**
     * Sub view used by the <tt>QuickView</tt> for displaying experience details, statistics etc.
     *
     * @cfg {ExperienceModel} model The experience model.
     *
     * @class QuickViewExperienceDetailsView
     */
    return ImprovedView.extend({

        _group: null,

        _isGroupPushed: null,

        template: template,

        regions: {},

        templateHelpers: function templateHelpers() {
            var isOneUnit = this._group.isOneUnit();

            return {
                isOneUnit: isOneUnit,
                spectatorMode: this.options.spectatorMode,
                isGroupPushed: this._isGroupPushed,
                // A hack to get the assigned assets for breakpoint group by checking isOneUnit, which is not the right way.
                // But right now we only have two type of groups, so it works fine.
                // This should be refactored if we have more then two group types later.
                assets: isOneUnit && this._getAssignedAssets(),
                groupType: this._group.getDashedType()
            };
        },

        ui: {
            toggleGroupData: ".toggle-group-data",
            assignedBreakpoints: ".assigned-breakpoints-container",
            toggleGroupURL: ".toggle-group-url",
            urlContainer: ".group-url-container",
            readableState: ".readable-state",
            currentGroupStatus: ".current-group-status",
            notPushedChangesWarning: ".not-pushed-changes-warning",
            pushedCheckMark: ".pushed-check-mark"
        },

        events: {
            "click @ui.toggleGroupData": "_toggleGroupData",
            "click @ui.toggleGroupURL": "_toggleGroupUrl"
        },

        initialize: function initialize() {
            this._group = this.options.group;

            if (this._group) {
                this._isGroupPushed = this._group.hasAtLeastState(PublishableState.PUSHED);

                this.listenTo(this._group, "sync:state", function () {
                    this._updateState();
                });
            }
        },

        onRender: function onRender() {
            if (this._group) {
                this._updateState();
                this._initializeURL();
            }

            Tooltip.add(this.ui.toggleGroupURL, {
                width: 230,
                placement: "top",
                html: true
            });
        },

        _getAssignedAssets: function _getAssignedAssets() {
            var self = this,
                lowerBounds = this._getLowerBounds(),
                breakpointCollection = LoggedInUserState.get("companySettings").get("breakpoints"),
                naming = breakpointCollection.generateNaming(lowerBounds.length - 1);

            return _.map(lowerBounds, function (breakpoint, index) {
                var experience = self._group.getAssetByThreshold(breakpoint.get("threshold"));

                return [naming[index], breakpoint, experience];
            });
        },

        _getLowerBounds: function _getLowerBounds() {
            var breakpoints = this._group && this._group.getValues();

            if (!breakpoints.length) {
                breakpoints = this.lowerBoundsInSetting;
            }

            return _.sortBy(breakpoints, function (breakpoint) {
                return breakpoint.get("threshold");
            });
        },

        _updateState: function _updateState() {
            var pushed = this._group.hasAtLeastState(PublishableState.PUSHED),
                nonPushedChanges = this._group.isChangedAfterPush();

            this.ui.currentGroupStatus.toggleClass("changes", nonPushedChanges);
            this.ui.notPushedChangesWarning.toggle(nonPushedChanges);
            this.ui.pushedCheckMark.toggle(pushed && !nonPushedChanges);

            if (nonPushedChanges) {
                Tooltip.add(this.ui.notPushedChangesWarning, {
                    width: 170,
                    placement: "top",
                    html: true
                });
            }

            this.ui.readableState.html(this._group.getState().displayName);
        },

        _toggleGroupData: function _toggleGroupData() {
            if (this._isGroupPushed) {
                var open = !this.ui.assignedBreakpoints.is(":visible");

                this.ui.assignedBreakpoints.slideToggle(open);
                this.ui.toggleGroupData.toggleClass("open", open);
            }
        },

        _toggleGroupUrl: function _toggleGroupUrl(event) {
            if (this._isGroupPushed) {
                event.preventDefault();

                var open = !this.ui.urlContainer.is(":visible");

                this.ui.urlContainer.slideToggle(open);
                this.ui.toggleGroupURL.toggleClass("open", open);
            }
        },

        _initializeURL: function _initializeURL() {
            var urlBox = new URLBox({
                urlProvider: this._urlProvider.bind(this),
                helpText: "View your Group directly with this link.",
                project: this.options.project,
                triggerOrigin: "OpenGroupUrlButton"
            }).render();

            this.ui.urlContainer.html(urlBox.el);
        },

        _urlProvider: function _urlProvider() {
            return UrlUtil.getAbsoluteExperienceUrl(this.model.get("id"));
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2879 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isGroupPushed) { ;
__p += '\n    <span class="current-group-status">\n        <i class="glyphicon glyphicon-exclamation-sign important not-pushed-changes-warning" data-content="The current version of this Group is Not Pushed."></i>\n        <span class="pushed-check-mark">&#10003;</span>\n        <span class="readable-state"></span>\n    </span>\n';
 } ;
__p += '\n\n';
 if (isOneUnit) { ;
__p += '\n<div class="group-data-section ' +
__e(groupType ) +
'">\n    <div class="toggle-group-data';
 if (isGroupPushed) { ;
__p += ' toggle-title open';
};
__p += '">Group Data</div>\n    <div class="assigned-breakpoints-container">\n        <ul class="breakpoints-flex-section list-unstyled">\n            ';
 _.each(assets, function(asset, index) { ;
__p += '\n                <li class="breakpoint-flex-item">\n                    <div class="interval-indicator ' +
__e( asset[0] ) +
'">' +
__e( asset[0] ) +
'</div>\n                    <div class="variant-name">' +
__e( asset[2].get("name") ) +
'</div>\n                    <div class="breakpoint-value">' +
__e( asset[1].get('threshold') ) +
' px</div>\n                </li>\n            ';
 }); ;
__p += '\n        </ul>\n    </div>\n</div>\n';
 } ;
__p += '\n\n';
 if (isGroupPushed && isOneUnit) { ;
__p += '\n    <div class="group-url-section">\n        <a href="#" class="toggle-group-url toggle-title\n            ';
 if (spectatorMode && !isGroupPushed) { ;
__p += '\n            disabled" data-content="The direct Group URL has not been enabled.\n            ';
 } else if (!isGroupPushed) { ;
__p += '\n            disabled" data-content="To get a direct Group URL open your Experience and click Push Group.\n            ';
 } ;
__p += '\n            ">Group URL</a>\n        <div class="group-url-container url-container"></div>\n    </div>\n';
 } ;
__p += '\n\n';

}
return __p
}

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        ReactBridge = __webpack_require__(137),
        ZmagsUiLibrary = __webpack_require__(273),
        MsCompanyCollection = __webpack_require__(2881),
        DropdownValueMapper = __webpack_require__(2883),
        DropdownOnChangeHandlers = __webpack_require__(2884),
        Permissions = __webpack_require__(22),
        LoggedIn = __webpack_require__(31),
        SharedEntityType = __webpack_require__(285),
        LoggedInUserState = __webpack_require__(19),
        template = __webpack_require__(2885);

    /**
     * Sub view used by the <tt>QuickView</tt> for displaying experience permissions.
     *
     * @class UserSharingPermissionsView
     */
    return ImprovedView.extend({

        template: template,

        regions: {
            dropdown: ".dropdown",
            checkboxRegion: ".checkbox-region"
        },

        group: null,

        templateHelpers: function templateHelpers() {
            return {
                userPermissionsEnabled: LoggedInUserState.get("companySettings").get("userPermissionsEnabled")
            };
        },

        initialize: function initialize() {
            this.group = this.options.group;
            this.model = this.options.model;
        },
        onShow: function onShow() {
            var _this = this;

            this.buildDropdown().then(function (dropdownComponent) {
                _this.dropdown.show(dropdownComponent);
            }).then(function () {
                return _this.buildCheckbox();
            }).then(function (checkboxComponent) {
                _this.checkboxRegion.show(checkboxComponent);
            });
        },
        _resolveCheckboxData: function _resolveCheckboxData(sharedEntityResponse) {
            return sharedEntityResponse.get("sharedWithAll");
        },


        buildCheckbox: function buildCheckbox() {
            var _this2 = this;

            var model = this.model;

            return model.fetch().then(function (sharedEntityResponse) {
                var sharedWithAll = _this2._resolveCheckboxData(sharedEntityResponse);
                model.set("sharedWithAll", sharedWithAll);
                var sharedEntityOnChangeSharedWithAllHandler = model.onChangeSharedWithAllHandler.bind(model);
                return _this2._createCheckbox(sharedWithAll, sharedEntityOnChangeSharedWithAllHandler);
            });
        },

        _createCheckbox: function _createCheckbox(sharedWithAll, onChangeSharedWithAllHandler) {
            var role = LoggedIn.principal().get("user").get("role").name;
            var isNotManager = role !== Permissions.Roles.MANAGER.name;
            return ReactBridge.viewFromComponent(ZmagsUiLibrary.CheckBox, {
                props: {
                    label: "Share experiences with all?",
                    checked: sharedWithAll,
                    disabled: isNotManager,
                    onChange: onChangeSharedWithAllHandler
                }
            });
        },

        buildDropdown: function buildDropdown() {
            var _this3 = this;

            var model = this.model;


            var companyCollection = new MsCompanyCollection(null, {
                companyId: model.get("companyId")
            });

            return companyCollection.fetch().then(function () {
                return _this3._getSharedEntity().then(function (sharedEntity) {
                    var fixedUsers = DropdownValueMapper.mapUsersToFixedDropdownValues(companyCollection.models, model.get("createdBy"));
                    var dropdownUsers = _this3._getDropdownValues(companyCollection, sharedEntity, fixedUsers);
                    return _this3._createDropdownComponent(fixedUsers, dropdownUsers);
                });
            });
        },

        _createDropdownComponent: function _createDropdownComponent(fixedUsers, dropdownUsers) {
            var dropdownHandler = new DropdownOnChangeHandlers({
                fixedValues: fixedUsers,
                model: this.model
            });

            var scopedGetProps = function scopedGetProps(_ref) {
                var model = _ref.model;

                var role = LoggedIn.principal().get("user").get("role").name;
                var isNotManager = role !== Permissions.Roles.MANAGER.name;
                return {
                    isDisabled: isNotManager || model.get("sharedWithAll")
                };
            };

            var dropdownComponent = ReactBridge.viewFromComponent(ZmagsUiLibrary.Dropdown, {
                model: this.model,
                observe: {
                    model: "change:sharedWithAll"
                },
                props: {
                    values: dropdownUsers,
                    fixedValues: fixedUsers,
                    onChange: dropdownHandler.onChangeHandler.bind(dropdownHandler)
                },
                getProps: scopedGetProps
            });
            return dropdownComponent;
        },

        _getSharedEntity: function _getSharedEntity() {
            var model = this.model;

            return model.fetch({}, { url: model.getURL() });
        },

        _getDropdownValues: function _getDropdownValues(companyCollection, model, fixedUsers) {
            var isNew = !model.get("version") && !model.get("editedBy");
            if (isNew) {
                this._createAndSaveSharedEntity(companyCollection, fixedUsers);
            }
            return DropdownValueMapper.mapUsersToDropdownValues({
                usersInCompany: companyCollection.models,
                entitySharedUsers: model.get("usersSharedWith"),
                entityCreator: model.get("createdBy")
            });
        },

        _getNoneFixedUsers: function _getNoneFixedUsers(users, fixedUsers) {
            var notFixedUsers = users.filter(function (user) {
                return fixedUsers.some(function (fixedUser) {
                    return !(fixedUser.value === user.get("id"));
                });
            }).map(function (user) {
                return user.get("id");
            });
            return notFixedUsers;
        },
        _createAndSaveSharedEntity: function _createAndSaveSharedEntity(companyCollection, fixedUsers) {
            var model = this.model,
                group = this.group;

            var entityID = model.get("entityId");
            var isGroup = group ? SharedEntityType.GROUP : SharedEntityType.EXPERIENCE;

            model.set("entityId", entityID);
            model.set("entityType", isGroup);
            // TODO: update to check Company level data
            model.set("sharedWithAll", true);
            var usersSharedWith = this._getNoneFixedUsers(companyCollection.models, fixedUsers);
            model.set("usersSharedWith", usersSharedWith);

            return model.save({}, { url: model.postURL() });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var Configuration = __webpack_require__(27);
    var MsCompanyModel = __webpack_require__(2882);

    /**
     * An company collection using microservices.
     *
     * @class MsCompanyCollection
     * @constructor
     */
    return Backbone.Collection.extend("MsCompanyCollection", {

        model: MsCompanyModel,

        initialize: function initialize(models, options) {
            this.companyId = options.companyId;
        },
        url: function url() {
            return "" + Configuration.microserviceCompanyUrl + this.companyId + "/users";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var Configuration = __webpack_require__(27);

    /**
     * An experience model using microservices.
     *
     * @class MsCompanyModel
     * @constructor
     */
    return ImprovedModel.extend("MsCompanyModel", {

        _api: "msCompany",

        url: function url() {
            return "" + Configuration.microserviceCompanyUrl + this.companyId + "/users";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Permissions = __webpack_require__(22);

    return {
        _isFixedUser: function _isFixedUser(user, entityCreator) {
            var isManager = user.get("role") === Permissions.Roles.MANAGER.name;
            var isEntityCreator = user.get("id") === entityCreator;
            return isManager || isEntityCreator;
        },
        mapUsersToFixedDropdownValues: function mapUsersToFixedDropdownValues(users, entityCreator) {
            var _this = this;

            var fixedDropdownValues = users.filter(function (user) {
                return _this._isFixedUser(user, entityCreator);
            }).map(function (user) {
                return {
                    value: user.get("id"),
                    label: user.get("name"),
                    isSelected: true
                };
            });
            return fixedDropdownValues;
        },
        mapUsersToDropdownValues: function mapUsersToDropdownValues(_ref) {
            var _this2 = this;

            var usersInCompany = _ref.usersInCompany,
                entitySharedUsers = _ref.entitySharedUsers,
                entityCreator = _ref.entityCreator;

            var dropdownValues = usersInCompany.filter(function (user) {
                return !_this2._isFixedUser(user, entityCreator);
            }).map(function (user) {
                var isEntitySharedWithUser = entitySharedUsers.indexOf(user.get("id")) !== -1;
                return {
                    value: user.get("id"),
                    label: user.get("name"),
                    isSelected: isEntitySharedWithUser
                };
            });
            return dropdownValues;
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    return function () {
        function DropdownOnChangeHandlers(options) {
            _classCallCheck(this, DropdownOnChangeHandlers);

            this.fixedValues = options.fixedValues;
            this.model = options.model;
        }

        _createClass(DropdownOnChangeHandlers, [{
            key: "_getChangedUser",
            value: function _getChangedUser(newValues, previousValues) {
                var _this = this;

                var changedUser = newValues.find(function (user) {
                    var isNotPreviousUsers = !previousValues.some(function (previousValue) {
                        return previousValue.value === user.value;
                    });
                    var isNotFixedValue = isNotPreviousUsers && !_this.fixedValues.some(function (fixedValue) {
                        return fixedValue.value === user.value;
                    });
                    return isNotFixedValue;
                });
                return changedUser.value;
            }
        }, {
            key: "onChangeHandler",
            value: function onChangeHandler(newValues, previousValues) {
                if (newValues.length > previousValues.length) {
                    var addUser = this._getChangedUser(newValues, previousValues);
                    this.model.addSharedUser(addUser);
                } else {
                    var removeUser = this._getChangedUser(previousValues, newValues);
                    this.model.removeSharedUser(removeUser);
                }
            }
        }]);

        return DropdownOnChangeHandlers;
    }();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2885 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="dropdown-region">\n    ';
 if (userPermissionsEnabled) { ;
__p += '\n    <label>Shared with:</label>\n    ';
 } ;
__p += '\n    <div class="checkbox-region"></div>\n    <div class="dropdown">\n    </div>\n    <div class="warning-note"\n    ';
 if (userPermissionsEnabled) { ;
__p += '\n    <label>Please note: Managers have access to all experiences.</label>\n    ';
 } ;
__p += '\n</div>\n\n';

}
return __p
}

/***/ }),
/* 2886 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="quick-view';
if(isGroup){;
__p += ' group';
};
__p += '">\n    <div class="project-container">\n        ';
 if (isInProject) { ;
__p += '\n            <label>Project:</label>\n            ';
 if (projectContext) { ;
__p += '\n                <span>' +
__e( projectName ) +
'</span>\n            ';
 } else { ;
__p += '\n                <a href="' +
__e( projectDashboardUrl ) +
'" class="project-url">' +
__e( projectName ) +
'</a>\n            ';
 } ;
__p += '\n        ';
 } ;
__p += '\n    </div>\n\n    ';
 if (isGroup) { ;
__p += '\n        <div class="group-name editable-group-container">\n            <div contenteditable="' +
__e(!spectatorMode) +
'" class="editable edit-group-name';
if(spectatorMode){;
__p += ' disabled';
};
__p += '" ';
if(spectatorMode){;
__p += 'disabled';
};
__p += '>\n            </div>\n        </div>\n\n        <div class="select-experience-variant">\n            <ul class="variant-tabs tab-menu';
 if (entries.length > 7) {;
__p += ' small';
};
__p += ' ' +
__e(groupType ) +
'">\n            ';
 _.each(entries, function (entry, index) {
                var identifier = entry[1] ? entry[1].getIdentifier() : "";
                ;
__p += '\n                <li class="variant-tab" data-experience="' +
__e( entry[0].id ) +
'">\n                    <div class="variant-icon ' +
__e(identifier);
 if (entries.length > 7) {;
__p += ' small';
};
__p += '">#' +
__e( index + 1 ) +
'</div>\n                </li>\n            ';
 }); ;
__p += '\n            </ul>\n        </div>\n    ';
 } ;
__p += '\n<div class="experience-details-region"></div>\n<div class="group-details-region"></div>\n<div class="sharing-area"></div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var LoggedIn = __webpack_require__(31);
    var Permissions = __webpack_require__(22);
    var QuickViewAddExperienceViewTemplate = __webpack_require__(2888);
    var TemplateCollection = __webpack_require__(2889);
    var TemplateSorting = __webpack_require__(709);

    var TemplateContentCollectionViewProxy = function TemplateContentCollectionViewProxy(options) {
        // Due to a circular dependency somewhere we need to use a dynamic require.
        var TemplateContentCollectionView = __webpack_require__(2890);
        return new TemplateContentCollectionView(options);
    };
    /**
     * The <tt>QuickViewAddExperienceView</tt> is used to display add experience details inside a <tt>LightBox</tt>.
     *
     * @class QuickViewAddExperienceView
     */
    var QuickViewAddExperienceView = ImprovedView.extend({

        template: QuickViewAddExperienceViewTemplate,

        regions: {
            templates: ".templates"
        },

        onShow: function onShow() {
            var _this = this;

            var collection = new TemplateCollection();

            return collection.query(TemplateSorting.current().query).then(function () {
                return {
                    collection: collection,
                    showCreateDisclaimer: true,
                    principal: LoggedIn.principal(),
                    spectatorMode: Permissions.Privileges.CREATE.cannot(),
                    closeQuickView: function closeQuickView() {
                        return _this.close();
                    },
                    scrollTarget: _this.$el
                };
            }).then(function (options) {
                var view = TemplateContentCollectionViewProxy(options);
                _this.templates.show(view);
            });
        }
    });

    return QuickViewAddExperienceView;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2888 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="quick-view">\n    <div class="templates"></div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ChunkingCollection = __webpack_require__(400);
    var RestApi = __webpack_require__(29);
    var SyncManager = __webpack_require__(44);
    var TemplateModel = __webpack_require__(468);

    // Defined supported (polymorphic) types/models.
    var contentTypes = new Map();

    // This is most likely not the right model.
    contentTypes.set(TemplateModel.type, TemplateModel);

    /**
     *
     * @class TemplateCollection
     *
     * @type {*|void}
     */
    var TemplateCollection = ChunkingCollection.extend({

        model: contentTypes,

        url: function url() {
            return RestApi.pathToCollection(RestApi.Collections.TEMPLATES);
        }
    }, {

        /**
         * Counts the entire template collection.
         *
         * @return {Promise}        A <tt>Promise</tt> that resolves with the count/number.
         */
        count: function count() {
            return SyncManager.get(RestApi.pathToCollection(RestApi.Collections.TEMPLATES_COUNT), SyncManager.target("TemplateCollection.count"));
        }
    });

    return TemplateCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backbone = __webpack_require__(7);
    var TemplateItemView = __webpack_require__(2891);
    var ContentQuery = __webpack_require__(139);
    var CreateNewExperienceView = __webpack_require__(1207);
    var TemplateSortingPanel = __webpack_require__(2893);
    var DashboardHeaderFactory = __webpack_require__(1210);
    var ImprovedView = __webpack_require__(6);
    var InfiniteScrollingCollectionView = __webpack_require__(259);
    var NoResultsItemView = __webpack_require__(207);
    var Privileges = __webpack_require__(22).Privileges;
    var Syncer = __webpack_require__(50);
    var TemplateContentCollectionViewTemplate = __webpack_require__(2895);

    /**
     *
     * @class TemplateContentCollectionView
     *
     */
    return ImprovedView.extend({

        className: "content-collection-view",

        template: TemplateContentCollectionViewTemplate,

        itemView: TemplateItemView,

        itemViewOptions: {},

        createLabelOptions: function createLabelOptions() {
            var _this = this;

            return {
                label: "Create<br> New Blank Experience<br> &#43",
                onClick: function onClick() {
                    Backbone.history.navigate("experience/create", { trigger: true });
                    _this.options.closeQuickView();
                },
                additionalClassName: "create-template-content-item"
            };
        },

        _collectionView: null,

        _sortingPanel: null,

        _showCreateDisclaimer: true,

        regions: {
            sortingPanelRegion: ".sorting-panel-region",
            content: ".content"
        },

        ui: {
            content: ".content"
        },

        initialize: function initialize() {
            this.collection = this.options.collection;
            this.itemViewOptions = this.options.itemViewOptions || this.itemViewOptions;
            this.itemViewOptions.closeQuickView = this.options.closeQuickView;
            this._showCreateDisclaimer = this.options.showCreateDisclaimer !== false && Privileges.CREATE.can();

            var dashboardHeaderFactoryOptions = _.pick(this.options, "users", "principal");
            this.dashboardHeaderFactory = new DashboardHeaderFactory(dashboardHeaderFactoryOptions);
        },

        /**
         * Exposes the event source (most likely a collection) associated with the number of
         * items represented by  *this* dashboard sub view. The dashboard will use this for updating
         * the counting labels, by listening for relevant events.
         *
         * @return {Collection} The main collection for this dashboard sub view.
         *
         * @see DashboardView#showTab
         */
        getCountableEventSource: function getCountableEventSource() {
            return this.collection;
        },

        /**
         * @override
         *
         * We don't need Marionette's serialization here.
         */
        serializeData: function serializeData() {
            return {};
        },

        onShow: function onShow() {
            this._sortingPanel = new TemplateSortingPanel();
            this.sortingPanelRegion.show(this._sortingPanel);

            this._collectionView = new InfiniteScrollingCollectionView({
                itemView: this.itemView,
                itemViewOptions: this.itemViewOptions,
                itemEvents: this._bindItemEvents(),
                collection: this.collection,
                horizontalBuffer: 220,
                scrollTarget: _.result(this.options, "scrollTarget")
            });

            this.listenTo(this.collection, {
                "sync:state": function syncState() {
                    // only used for fetch
                    this._sortingPanel.disable(!Syncer.State.complete(this.collection));
                },

                "remove": function remove() {
                    // Edge case: If we're in "search mode" and deletes the last experience/group, call
                    // refresh to update the view, eventually displaying "No content found" (since we're still in "search mode")...
                    if (this.collection.length() === 0 && this._sortingPanel.isSearching()) {
                        this.refresh();
                    }
                },

                "reset": function reset() {
                    this.dashboardHeaderFactory.reset();
                }
            });

            this.listenTo(this._sortingPanel, {
                "sort": function sort(sorting) {
                    this.collection.query(sorting.query);
                },

                "search": function search(searchPhrase, sorting) {
                    this.collection.query(ContentQuery.search(searchPhrase, sorting.query));
                }
            });

            this._collectionView.onAddingView = this.onAddingView.bind(this);

            this._collectionView.onEmpty = function () {
                if (this._sortingPanel.isSearching()) {
                    return new NoResultsItemView({ type: "template" });
                }

                return this._createDisclaimer();
            }.bind(this);

            this.content.show(this._collectionView);
        },

        refresh: function refresh(sorting) {
            this.dashboardHeaderFactory.reset();

            this._sortingPanel.setSorting(sorting || this.getSorting());
        },

        /**
         * Invoked from the dashboard view when the tab representing this view become active/deactive.
         *
         * @param  {Boolean} active The active state.
         */
        active: function active(_active) {
            // Delegate active state to the InfiniteScrollingCollectionView
            // instance - this will enable/disable the scroll listener.
            this._collectionView.active(_active);

            if (_active) {
                this.refresh();
            }
        },

        setSorting: function setSorting(sorting) {
            this._sortingPanel.setSorting(sorting);
        },

        getSorting: function getSorting() {
            return this._sortingPanel.getSorting();
        },

        onAddingView: function onAddingView(view, index) {
            if (this._collectionView.at(index)) {
                return;
            }

            var header = this.dashboardHeaderFactory.create(this._sortingPanel.getSorting(), index, view.model);

            if (index === 0) {
                var createItem = this._createDisclaimer();

                return createItem ? [header, createItem] : header;
            }

            return header;
        },

        _createDisclaimer: function _createDisclaimer() {
            if (this._showCreateDisclaimer) {
                return new CreateNewExperienceView(this.createLabelOptions());
            }
            // undefined...
        },

        _bindItemEvents: function _bindItemEvents() {
            var self = this,
                itemEvents = {};

            if (itemEvents) {
                _.each(this.itemEvents, function (callback, event) {
                    itemEvents[event] = callback.bind(self);
                });
            }

            return itemEvents;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var EditorEvents = __webpack_require__(17);
    var ExperienceURLProvider = __webpack_require__(168);
    var Marionette = __webpack_require__(10);
    var SceneThumbnailViewer = __webpack_require__(466);
    var template = __webpack_require__(2892);
    var TemplateItemViewController = __webpack_require__(712);

    var MAX_THUMB_DIMENSION = { width: 215, height: 140 };

    /**
     *
     * @class TemplateItemView
     *
     */
    return Marionette.Layout.extend({
        _pending: false,

        /**
         * @type {SceneThumbnailViewer}
         */
        _sceneThumbnailViewer: null,

        className: "content-item experience-item",

        controller: TemplateItemViewController,

        template: template,

        /**
         * Whether the view has been through it's rendering cycle.
         *
         * @type {Boolean}
         */
        rendered: false,

        templateHelpers: function templateHelpers() {
            return {
                // Overwriting the name from the model to avoid js-injection
                name: this.model.get("name"),
                description: this.model.get("description")
            };
        },

        ui: {
            thumbContainer: ".experience-thumb-container",
            preview: "#preview",
            create: "#create"
        },

        events: {
            "click @ui.preview": function clickUiPreview(event) {
                event.preventDefault();
                event.stopPropagation();

                var templateId = this.model.get("id");
                var templateExperienceId = this.model.get("content").get("id");

                var eventProperties = {
                    triggerOrigin: "TemplateItemViewPreviewButton",
                    templateExperienceId: templateExperienceId
                };
                EditorEvents.trigger(EditorEvents.constants.OPEN_TEMPLATE_PREVIEW, eventProperties);

                var route = ExperienceURLProvider.provide(templateId, ExperienceURLProvider.ACTION.PREVIEW, 1, undefined, ExperienceURLProvider.TYPES.TEMPLATE);
                Backbone.history.navigate(route, { trigger: true });
                this.options.closeQuickView();
            },

            "click @ui.create": function clickUiCreate(event) {
                event.preventDefault();
                event.stopPropagation();

                this.trigger("duplicate", this.model.get("content"), "TemplateItemViewCreateButton");
                this.options.closeQuickView();
            }
        },

        onRender: function onRender() {
            this._renderThumbnail(this.model.get("content"));
            this.rendered = true;
        },

        _renderThumbnail: function _renderThumbnail(experienceModel) {
            this._sceneThumbnailViewer = new SceneThumbnailViewer({
                model: experienceModel.get("scenes").at(0),
                experience: experienceModel,
                maxDimensions: MAX_THUMB_DIMENSION,
                showStaticScenes: true
            });

            this.ui.thumbContainer.prepend(this._sceneThumbnailViewer.render().$el);
            this.$el.addClass(this.model.get("id"));
        },

        onClose: function onClose() {
            // Make sure to properly close the viewer instance - it was added
            // to the DOM outside of the normal (Marionette) lifecycle - see #onRender
            this._sceneThumbnailViewer.close();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2892 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="experience-thumb-wrapper template-thumb-wrapper">\n    <div class="experience-thumb-container" style="cursor: default"></div>\n    <div class="actions-panel">\n        <a id="preview" class="edit-experience btn btn-primary" >Preview</a>\n        <a id="create" class="edit-experience btn btn-primary">Create</a>\n    </div>\n    <div class="experience-meta-data">\n        <div class="title-wrapper">\n            <span class="title-container" data-content="' +
__e( name ) +
'">\n                <span class="title">' +
__e( name ) +
'</span>\n            </span>\n        </div>\n\n        <div class="state">' +
__e( description ) +
'</div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var TemplateSorting = __webpack_require__(709);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        trim = _require.trim;

    var template = __webpack_require__(2894);

    /**
     * View displaying the sorting options and the search input for the dashboard.
     *
     * @class TemplateSortingPanel
     */
    return ImprovedView.extend({

        template: template,

        className: "sorting-panel",

        events: {
            "click @ui.sortingElements": "_sortClickHandler",

            "keyup @ui.searchInput": "_searchKeyupHandler"
        },

        ui: {
            sortingElements: "[data-sort]",
            searchInput: ".content-filtering"
        },

        /**
         * @type {TemplateSorting}
         */
        _sorting: null,

        _searching: false,

        _searchPhase: "",

        initialize: function initialize() {
            this._sorting = TemplateSorting.current();
        },

        getSorting: function getSorting() {
            return this._sorting;
        },

        setSorting: function setSorting(sorting) {
            this.ui.sortingElements.hide();
            this.ui.sortingElements.removeClass("active");
            this.$el.find("[data-sort='" + sorting.value + "']").addClass("active");

            this._sorting = sorting;

            TemplateSorting.set(sorting);

            if (this._searching) {
                this.trigger("search", this._searchPhase, sorting);
            } else {
                this.trigger("sort", sorting);
            }
        },

        isSearching: function isSearching() {
            return this._searching;
        },

        getSearchPhase: function getSearchPhase() {
            return this._searchPhase;
        },

        disable: function disable(value) {
            this.$el.toggleClass("disabled", value === true || value === undefined);
        },

        onRender: function onRender() {
            this.setSorting(this._sorting);
        },

        _triggerSearch: function _triggerSearch(searchPhase) {
            if (searchPhase === this._searchPhase) {
                return;
            }
            // If user clears the input field, reset to current sorting.
            if (isBlank(searchPhase)) {
                this._resetSearchState();
                this.setSorting(this._sorting);
                return;
            }

            this._searchPhase = searchPhase;
            this._searching = true;

            // Signal that we're searching...
            this.trigger("search", searchPhase, this._sorting);
        },

        _searchKeyupHandler: function _searchKeyupHandler(event) {
            var searchPhase = trim(event.target.value);

            this._triggerSearch(searchPhase);
        },

        _sortClickHandler: function _sortClickHandler(event) {
            var sorting = event.target.getAttribute("data-sort");

            if (sorting === this._sorting.value && !this._searching) {
                return;
            }

            this.setSorting(TemplateSorting.fromValue(sorting));

            var eventProperties = {
                sortBy: sorting,
                triggerOrigin: "SortingPanel"
            };

            EditorEvents.trigger(EditorEvents.constants.SORT_TEMPLATE, eventProperties);
        },

        _resetSearchState: function _resetSearchState() {
            this.ui.searchInput.val("");
            this._searching = false;
            this._searchPhase = "";
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2894 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="sorting-tabs">\n    <span data-sort="alphabetical">Alphabetical</span>\n    <span data-sort="created">Created Date</span>\n</div>\n<input class="content-filtering" type="search" placeholder="Search">\n';

}
return __p
}

/***/ }),
/* 2895 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="zmags-section wide">\n    <div class="sorting-panel-region"></div>\n</section>\n\n<section class="zmags-section wide">\n    <div class="content experience-thumbnails"></div>\n</section>\n';

}
return __p
}

/***/ }),
/* 2896 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="zmags-section wide">\n    <div class="sorting-panel-region"></div>\n</section>\n\n<section class="zmags-section wide">\n    <div class="content experience-thumbnails"></div>\n</section>\n';

}
return __p
}

/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(2898);
    var LoggedInUserState = __webpack_require__(19);
    var $ = __webpack_require__(4);

    return ImprovedView.extend("ReportingView", {

        className: "dashboard-reporting-view",

        template: template,

        _segmentDimension: null,

        ui: {
            matomoRegion: ".matomo-region"
        },
        /**
        * This is an empty filler class that is necessary
        *
        * @see DashboardView#showTab
        */
        getCountableEventSource: function getCountableEventSource() {
            var empty = [];
            return empty;
        },

        /**
         *
         * What we return if reporting is not enabled.
         * @private
         */
        _reportingNotEnabled: function _reportingNotEnabled() {
            var defaultThumbnail = document.createElement("DIV");
            defaultThumbnail.innerHTML += "Reporting Not Enabled <p> Contact Your Account Manager to Gain Access";
            defaultThumbnail.style.cssText = "text-align: center;color: @grey04;font-size: 18px;font-weight: 800; cursor: default; margin:100px";
            this.append(defaultThumbnail);
        },

        /**
        *
        * Renders a message if reporting is not enabled.
        *
        * If reporting is enabled we use the MatomoReporting model to send a call to
        * the matomo auth wrapper which then returns html that we render in an iframe.
        *
        */
        onRender: function onRender() {
            var self = this;
            if (LoggedInUserState.get("integrations").isMatomoReportingDashboardLinkVisibleIntegrationsEnabled()) {
                self.ui.matomoRegion.append(self.options.get("html"));
                // We know that there is a single matomo region and node because we've set it the line before
                var iframe = self.ui.matomoRegion[0].childNodes[0];
                // Adding class for .less file
                $(iframe).addClass("matomo-iframe");
                $(iframe).attr("scrolling", "auto");
            } else {
                self._reportingNotEnabled();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2898 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="zmags-section wide">\n    <div class="matomo-region"></div>\n</section>\n';

}
return __p
}

/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        template = __webpack_require__(2900);

    return ImprovedView.extend({

        className: "dashboard-navigation tabs tabs-no-border tabs-no-margin",

        template: template,

        _tab: null,

        _disabled: false,

        ui: {
            tabs: "a"
        },

        events: {
            "click .tab": function clickTab(event) {
                // Just in case (for browsers not supporting pointer-events: none)
                if (this._disabled) {
                    event.stopPropagation();
                    event.preventDefault();
                }
            }
        },

        initialize: function initialize() {
            var self = this;

            // TODO: Consider collection view...?
            this.options.tabs.each(function (tab) {
                self.listenTo(tab, "change:length", function () {
                    self.render();
                    self.setActiveTab(self._tab);
                });
            });
        },

        templateHelpers: function templateHelpers() {
            return {
                tabs: this.options.tabs
            };
        },

        /**
         * Disables the tabs by applying the <tt>.disabled</tt> class (see tabs.less).
         *
         * @param  {Boolean} value Boolean to toggle the disabled state.
         */
        disable: function disable(value) {
            this._disabled = value;

            this.$el.toggleClass("disabled", value);
        },

        /**
         * Convenience for disabling during the lifetime of the provided <tt>Promise</tt> instance.
         *
         * @param  {Promise} promise A <tt>Promise</tt> that once "completed" (resolved or failed) will
         *                           reset the disabled state.
         */
        disableUntil: function disableUntil(promise) {
            this.disable(true);
            promise.always(this.disable.bind(this, false));
        },

        setActiveTab: function setActiveTab(tab) {
            if (tab) {
                this._tab = tab;
                this.ui.tabs.removeClass("active");
                this.$el.find("[data-tab='" + tab.get("slug") + "']").addClass("active");
            }
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2900 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 _.each(tabs, function (tab) { ;
__p += '\n\n        ';
 if (tab.get('name') === "Reporting") { ;
__p += '\n            ';
 if (window._zmags_reporting_tab) { ;
__p += '\n                <a id="zmags-reporting-tab" class="tab ' +
__e( tab.get('slug') ) +
'-tab" data-tab="' +
__e( tab.get('slug') ) +
'" href="#' +
__e( tab.get('href') ) +
'" style="display:inline-block;">\n                    ' +
__e( tab.get('name') ) +
' <sup>' +
__e( tab.get('callout') ) +
'</sup>\n                </a>\n             ';
 } else { ;
__p += '\n                <a id="zmags-reporting-tab" class="tab ' +
__e( tab.get('slug') ) +
'-tab" data-tab="' +
__e( tab.get('slug') ) +
'" href="#' +
__e( tab.get('href') ) +
'" style="display:none;">\n                    ' +
__e( tab.get('name') ) +
' <sup>' +
__e( tab.get('callout') ) +
'</sup>\n                </a>\n             ';
 } ;
__p += '\n        ';
 } else { ;
__p += '\n            <a class="tab ' +
__e( tab.get('slug') ) +
'-tab" data-tab="' +
__e( tab.get('slug') ) +
'" href="#' +
__e( tab.get('href') ) +
'">\n                ' +
__e( tab.get('name') ) +
' <span class="count thin">&#40;' +
__e( tab.get('length') ) +
'&#41;</span>\n            </a>\n        ';
 } ;
__p += '\n\n';
 }) ;
__p += '\n';

}
return __p
}

/***/ }),
/* 2901 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="dashboard zmags-section wide">\n    <header class="title-field">\n        ' +
((__t = ( headerContentUnescaped )) == null ? '' : __t) +
'\n    </header>\n    <div class="dashboard-navigation-region"></div>\n</section>\n\n<div class="progress-indicator-region"></div>\n\n<footer class="default-footer"></footer>\n';

}
return __p
}

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Backbone = __webpack_require__(7);
    var BreakpointGroup = __webpack_require__(97);
    var Configuration = __webpack_require__(27);
    var CommentCollection = __webpack_require__(710);
    var EditorControllerMixin = __webpack_require__(1217);
    var EditorEvents = __webpack_require__(17);
    var EditorNavBarView = __webpack_require__(2903);
    var EditorView = __webpack_require__(2963);
    var EditorViewModel = __webpack_require__(3032);
    var ExperienceModel = __webpack_require__(58);
    var ExperienceURLProvider = __webpack_require__(168);
    var GroupCollection = __webpack_require__(719);
    var LayerEnum = __webpack_require__(251);
    var LoggedIn = __webpack_require__(31);
    var LoggedInUserState = __webpack_require__(19);
    var ImageLibrarySortingEnum = __webpack_require__(399);
    var ImageLibrarySortingProvider = __webpack_require__(698);
    var ImageLibrarySourceEnum = __webpack_require__(102);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Marionette = __webpack_require__(10);
    var NotificationBar = __webpack_require__(53);
    var Promise = __webpack_require__(21);
    var PublishableState = __webpack_require__(65);
    var Scene = __webpack_require__(253);
    var Storage = __webpack_require__(34);
    var TemplateModel = __webpack_require__(468);

    var logger = new Logger("EditorController");

    var DEFAULT_WIDTH = 900;
    var DEFAULT_HEIGHT = 400;

    /**
     * Controller for the editor.
     *
     * @author Bo Gotthardt
     * @class EditorController
     * @constructor
     *
     * @cfg {Region} region The main view region, where the editor view should be rendered.
     */
    var EditorController = Marionette.Controller.extend({

        mixin: EditorControllerMixin,

        currentExperience: null,

        currentProject: null,

        viewModel: null,

        _editorView: null,

        /**
         * Show the top nav bar view for editor page.
         *
         * @param {GroupCollectiom} groups The current collection of groups.
         *
         * @private
         */
        _showNavBarView: function _showNavBarView(groups) {
            var self = this;
            var newDashboardExperience = (0, _C3Utils.isC3Experience)();
            // PE-1216: New C3-API doesn't have endpoints for groups, hence we define the group as undefined instead of fetching it
            var group = newDashboardExperience ? undefined : groups.findByAssetId(this.currentExperience.get("id"));

            var promise = Promise.resolved();
            var pushed = null;

            if (group && group instanceof BreakpointGroup) {
                pushed = new BreakpointGroup({ id: group.id }, { pushedOnly: true });

                if (group.hasAtLeastState(PublishableState.PUSHED)) {
                    promise = pushed.fetchPushedOnly();
                }
            }

            promise.then(function () {
                var navBarOptions = {
                    model: self.currentExperience,
                    project: self.currentProject,
                    companySettings: LoggedInUserState.get("companySettings"),
                    viewModel: self.viewModel,
                    principal: LoggedIn.principal(),
                    group: group,
                    pushed: pushed,
                    integrationsCollection: LoggedInUserState.get("integrations")
                };

                self.options.navBarRegion.show(new EditorNavBarView(navBarOptions));
            });
        },


        /**
         * @private
         * Will set the current project model. In case the current experience is part of any group, it will check if the group is part of the project.
         * Otherwise, it will check if the individual experience is part of the project.
         * Make sure that this.currentExperience is set before calling this method, otherwise it will blow up.
         * @returns {ProjectModel} the project model, if the current experience is part of any project or if it's part of a group that's part of the project, undefined otherwise.
         */
        _setProject: function _setProject(experienceModel, groups) {
            var experienceId = experienceModel.get("id");
            var newDashboardExperience = (0, _C3Utils.isC3Experience)();
            Storage.Local.update(Storage.Keys.NEW_DASHBOARD_EXP, Storage.Keys.NEW_DASHBOARD_EXP, newDashboardExperience);
            // PE-1482: New C3-API doesn't support projects, hence no need to set projects for the same
            if (newDashboardExperience) {
                var link = document.querySelector("link[rel~='icon']");
                if (!link) {
                    link = document.createElement('link');
                    link.rel = 'icon';
                    document.head.appendChild(link);
                }
                link.href = '/images/icons/favicon.png';
                document.title = "Fastr Frontend";
                return;
            }
            var group = newDashboardExperience ? undefined : groups.findByAssetId(experienceId);
            var projectsCollection = LoggedInUserState.get("projects");

            if (group) {
                var projectFromGroup = projectsCollection.byGroupId(group.get("id"));
                if (projectFromGroup) {
                    this.currentProject = projectFromGroup;
                } else {
                    this.currentProject = projectsCollection.byExperienceId(experienceId);
                }
            } else {
                this.currentProject = projectsCollection.byExperienceId(experienceId);
            }
        },


        /**
         * When editing a group of variants, each variant can have different number of scenes,
         * Switching between variants can result in accessing invalid scene number.
         *
         * @param sceneNumber   The current scene number being edited
         * @returns {*}     The scene number if valid, otherwise a new scene number
         */
        validateSceneNumber: function validateSceneNumber(sceneNumber) {
            var total = this.currentExperience.getNumberOfScenes();

            if (total < sceneNumber || sceneNumber < 1) {
                EditorController._navigateToExperienceEditURL(this.currentExperience, total, false);
                return total;
            }

            return sceneNumber;
        },


        // When an experience is resized we need to run through every widget and update its
        // size and position to counter the resizing (to avoid them growing/shrinking together
        // with the experience.
        updateWidgetsSizeAndPosition: function updateWidgetsSizeAndPosition() {
            var experience = this.currentExperience;
            var widgets = experience.getAllWidgets();
            var scaleX = experience._previousAttributes.width / experience.get("width");
            var scaleY = experience._previousAttributes.height / experience.get("height");

            _.each(widgets, function (widget) {
                var bounds = {
                    left: widget.get("left") * scaleX,
                    top: widget.get("top") * scaleY
                };

                if (widget.has("width")) {
                    bounds.width = widget.get("width") * scaleX;
                }

                if (widget.has("height")) {
                    bounds.height = widget.get("height") * scaleY;
                }

                widget.set(bounds);
            });
        },
        _getContentControlBetaFlag: function _getContentControlBetaFlag() {
            try {
                var companyId = LoggedInUserState.attributes.company.id,
                    settingName = "contentControlBeta",
                    endpointUrl = Configuration.creatorSettingApiBaseUrl + "/v1/settings/" + companyId + "?name=" + settingName,
                    token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"),
                    bearerToken = "Bearer " + token;
                var options = {
                    method: "GET",
                    url: endpointUrl,
                    headers: {
                        "Authorization": bearerToken
                    },
                    success: "success",
                    dataType: "json",
                    async: false
                };

                var requestObject = $.ajax(options);
                var response = requestObject.responseJSON || null;

                Storage.Local.update(Storage.Keys.CONTENT_CONTROL_BETA, Storage.Keys.CONTENT_CONTROL_BETA, response.contentControlBeta);

                return response.contentControlBeta;
            } catch (error) {
                return false;
            }
        },


        /**
         * Edit an existing experience with the specified id at the given scene index.
         *
         * @param {String} id The experience id.
         * @param {Number|String} sceneNumber The scene number or special scene name.
         * @param {String} [layerName=LayerEnum.SCENE.name] The value of the Layer Enum to select for the user.
         *
         * @return {Promise} A promise that resolves with the fetched <tt>ExperienceModel</tt>.
         */
        editExperience: function editExperience(id, sceneNumber, layerName) {
            var deferred = new $.Deferred();
            var self = this;
            var experienceCommentsJSON = void 0;
            var groupCollection = void 0;
            var newDashboardExperience = (0, _C3Utils.isC3Experience)();
            var contentControlBetaFlagEnabled = this._getContentControlBetaFlag();

            this._fetchExperienceAndFonts(id).then(function (model) {

                // PE-1212: IF the user has contentControlBeta flag disabled
                // AND they try to access a C3 experience, redirect to root with error
                if (!contentControlBetaFlagEnabled && newDashboardExperience) {
                    window.location.href = "#";
                    NotificationBar.error("Unable to load the experience. Please try again.");
                    return;
                }

                // Let the model attempt to get its native code payload.
                model.getNativeCode("EditorLoad");
                self.currentExperience = model;

                // The experience might be part of a group, we need to lookup any potential
                // group in order to render group specific UI for navigation bar and editor.
                // PE-1216: New C3-API doesn't have endpoints for groups, hence we define the group as undefined instead of fetching it
                var groupCollectionResult = newDashboardExperience ? [] : GroupCollection.byAssetId(id);
                return groupCollectionResult;
            }).then(function (groups) {
                groupCollection = groups;
                self._setProject(self.currentExperience, groups);
                // PE-1216: New C3-API doesn't have endpoints for comments, hence we define the group as undefined instead of fetching it
                var commentCollectionResult = newDashboardExperience ? [] : CommentCollection.fetchCommentsFor(id);
                return commentCollectionResult;
            }).then(function (commentsJSON) {
                experienceCommentsJSON = commentsJSON;
                // Fetch template model, if needed...
                return LoggedInUserState.get("companySettings").get("templateSharingEnabled") ? TemplateModel.fromExperience(id) : Promise.resolved(null);
            }).then(function (templateModel) {
                // Enable save logic
                self._listenForChanges(self.currentExperience);

                sceneNumber = self.validateSceneNumber(sceneNumber);

                var imageViewedEventsEnabled = LoggedInUserState.get("companySettings").get("imageViewedEventsEnabled");

                var creatorSortingFilter = !imageViewedEventsEnabled ? ImageLibrarySortingEnum.MOST_VIEWED : ImageLibrarySortingEnum.ALPHABETICAL;

                var providerOptions = {
                    sources: [{ source: ImageLibrarySourceEnum.CREATOR, sorting: ImageLibrarySortingEnum.without(creatorSortingFilter) }]
                };

                if (LoggedInUserState.get("integrations").isScene7IntegrationAuthorized()) {
                    providerOptions.sources.push({
                        source: ImageLibrarySourceEnum.SCENE7,
                        sorting: ImageLibrarySortingEnum.without(ImageLibrarySortingEnum.MOST_VIEWED, ImageLibrarySortingEnum.MOST_USED)
                    });
                }

                var imageLibrarySorting = ImageLibrarySortingProvider.provide(providerOptions);

                self.viewModel = new EditorViewModel({
                    experience: self.currentExperience,
                    sceneNumber: sceneNumber,
                    project: self.currentProject,
                    templateModel: templateModel,
                    experienceCommentsJSON: experienceCommentsJSON,
                    imageLibrarySorting: imageLibrarySorting,
                    imageTaggingEnabled: LoggedInUserState.get("integrations").imageRekognitionIntegrationsEnabled(),
                    inventoryEnabled: LoggedInUserState.get("integrations").isInventoryEnabled(),
                    imageViewedEventsEnabled: imageViewedEventsEnabled,
                    currentLayer: LayerEnum.lookup(layerName, LayerEnum.SCENE)
                });

                self._editorView = new EditorView({
                    model: self.viewModel,
                    project: self.currentProject,
                    groups: groupCollection,
                    prototypeWidgetCollection: LoggedInUserState.get("prototypeWidgetCollection")
                });

                deferred.resolve({ experience: self.currentExperience, viewModel: self.viewModel });

                self._showNavBarView(groupCollection);

                self.listenTo(self.currentExperience, "change:height change:width", self.updateWidgetsSizeAndPosition);
                self.listenTo(self.viewModel, "change:sceneNumber", function () {
                    var experienceEditURL = ExperienceURLProvider.provide(self.viewModel.get("experience").get("id"), ExperienceURLProvider.ACTION.EDIT, self.viewModel.get("sceneNumber"));
                    Backbone.history.navigate(experienceEditURL, { replace: true });
                });

                // Display the editor view
                self.options.region.show(self._editorView);
            }).fail(function (msg) {
                deferred.reject(msg);
                logger.error(msg);
                Backbone.history.navigate("", true);
            });

            return deferred;
        },
        _listenForChanges: function _listenForChanges(experience) {
            var save = function save(delay) {
                return function () {
                    // Ensure the change wasn't triggered by a server update or a computed property. We always loop
                    // backwards in the arguments, since options like {triggeredByServerUpdate: true, ..} will
                    // one of the last arguments (always last?)...
                    var i = arguments.length,
                        arg = void 0;

                    while (i--) {
                        arg = arguments[i];

                        if (arg.triggeredByServerUpdate || arg.computedProperty) {
                            return;
                        }
                    }

                    experience.saveLater(delay);
                };
            };

            // Defer saving until a bit later since more simple changes may come in the very near future...
            this.listenTo(experience, "change nested-change", save()); // 2s delay
            this.listenTo(experience, "behaviorSaved", function () {
                NotificationBar.open("Behavior saved successfully", { closeDelay: 5000 });
            });

            // On structural changes, save now (still queued), as the logic to handle variants will wait until
            // stable variants, i.e. no need to wait the default delay. We use 1ms delay only, to ensure
            // scene indexes have be recomputed at the frontend before submit or the backend will complain!
            this.listenTo(experience, "add:scenes remove:scenes", save(1));
        },
        onClose: function onClose() {
            this.stopListening();

            // Clear all notifications about possible concurrent modification...
            NotificationBar.close({ tag: "concurrent:", clear: "tag" });
        }
    }, {
        injection: {
            parameters: ["errorLogger"],
            asOptions: true
        },

        /**
         * Create a new experience and start editing it. Because this method does not hold any state,
         * we use it as a static method.
         *
         * @param {String} [projectId] - Optional. The project id in which to add the newly
         *                                  created experience.
         */
        editNewExperience: function editNewExperience(projectId) {
            var project = projectId ? LoggedInUserState.get("projects").get(projectId) : null;
            var size = Storage.Local.get(Storage.Keys.EDITOR, "experienceSize", {
                width: DEFAULT_WIDTH,
                height: DEFAULT_HEIGHT
            });

            var principal = LoggedIn.principal(),
                model = new ExperienceModel({
                createdBy: principal.get("userId"),
                companyId: principal.get("companyId"),
                width: size.width,
                height: size.height,
                // This is currently part of the contract with the backend - an experience needs at least 1 scene...
                scenes: [new Scene({ sceneNumber: 1 })]
            });

            return model.save().then(function () {
                var eventProperties = {
                    experienceId: model.get("id"),
                    experienceVersion: model.get("version"),
                    experiencePushedVersion: model.get("pushedVersion"),
                    projectId: project && project.get("id"),
                    triggerOrigin: project ? "CreateNewExperienceInProjectArea" : "CreateNewExperienceArea"
                };

                var eventName = EditorEvents.constants.CREATE_EXPERIENCE;
                // Attach the experience to the project
                if (project) {
                    return project.attach(model).then(function () {
                        EditorEvents.trigger(eventName, eventProperties);
                        EditorController._navigateToExperienceEditURL(model);
                    });
                }

                EditorEvents.trigger(eventName, eventProperties);
                EditorController._navigateToExperienceEditURL(model);
            });
        },


        /**
         * @private
         *
         * Navigates to experience Edit URL.
         *
         * @param {ExperienceModel} model - Experience model.
         * @param {Number} sceneNumber - Optional, the scene number to navigate to
         * @param {Boolean} trigger - Optional - if it should call the route function.
         */
        _navigateToExperienceEditURL: function _navigateToExperienceEditURL(model, sceneNumber, trigger) {
            var experienceURL = ExperienceURLProvider.provide(model.get("id"), ExperienceURLProvider.ACTION.EDIT, sceneNumber);

            trigger = trigger !== false;
            Backbone.history.navigate(experienceURL, { trigger: trigger, replace: true });
        }
    });

    return EditorController;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        extend = _require.extend,
        defaults = _require.defaults,
        isBoolean = _require.isBoolean;

    var ActionSequence = __webpack_require__(467);
    var AddBreakpointAction = __webpack_require__(1218);
    var AddLocaleAction = __webpack_require__(1220);
    var Backbone = __webpack_require__(7);
    var EditBehavior = __webpack_require__(106);
    var EditorEvents = __webpack_require__(17);
    var ExperienceOptionsView = __webpack_require__(2904);
    var GroupNavViewFactory = __webpack_require__(2947);
    var LocaleCollection = __webpack_require__(374);
    var LocaleSelectorControl = __webpack_require__(1230);
    var NavBarView = __webpack_require__(461);
    var NavigateToExperienceAction = __webpack_require__(469);
    var PublishableState = __webpack_require__(65);
    var Syncer = __webpack_require__(50);
    var template = __webpack_require__(2955);
    var Tooltip = __webpack_require__(35);
    var ReactBridge = __webpack_require__(137);
    var VariantComponent = __webpack_require__(2956).default;

    var TOOLTIPS = {
        "sync": {
            content: "Breakpoint Variants cannot be created when an Experience is being saved.",
            width: 250,
            placement: "right"
        },
        "breakpointEmailDisabled": {
            content: "Email mode does not support breakpoint variants. Disable Email Mode to create a breakpoint.",
            width: 300,
            placement: "right"
        }
    };

    return NavBarView.extend({

        template: template,
        templateHelpers: function templateHelpers() {
            return extend(this.__super(), {
                group: this._group,
                canConvertToGroup: this._canConvertToGroup,
                newDashboardExperience: this.model.get("id").startsWith("C3_")
            });
        },


        regions: function regions() {
            return defaults({
                c3CollectionsRegion: ".c3collection-region",
                groupNavViewRegion: ".variants-region",
                localeSelectorRegion: ".create-new-locale-variant",
                experienceOptionsPanel: ".experience-options-panel"
            }, NavBarView.prototype.regions);
        },

        ui: function ui() {
            return defaults({
                navBar: ".nav-bar",
                c3CollectionsRegion: ".c3collection-region",
                experienceNav: ".experience-options-panel",
                variantsRegion: ".variants-region",
                createNewVariant: ".create-new-variant",
                createBreakpointGroup: ".add-breakpoint-variant",
                editorNavBar: ".editor-nav-bar"
            }, NavBarView.prototype.ui);
        },

        events: function events() {
            return defaults({
                "click @ui.createNewVariantOpen": "_preventDefault",
                "click @ui.createBreakpointGroup": "_createBreakpointGroupClickHandler"
            }, NavBarView.prototype.events);
        },

        bindings: {
            ".experience-name": {
                observe: "name",
                updateMethod: "text",
                escape: false,
                events: ["blur"]
            }
        },

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,
                container: ".name-container",
                editFields: [{
                    input: ".experience-name",
                    save: function save(value) {
                        this.model.set("name", value);

                        var eventProperties = {
                            experienceId: this.model.get("id"),
                            experienceVersion: this.model.get("version"),
                            experiencePushedVersion: this.model.get("pushedVersion"),
                            projectId: this.options.project && this.options.project.get("id"),
                            triggerOrigin: "EditExperienceNameInputField",
                            quickView: false,
                            updatedProperty: "name",
                            updatedValue: value
                        };

                        EditorEvents.trigger(EditorEvents.constants.UPDATE_EXPERIENCE, eventProperties);
                    }
                }]
            }
        },

        _group: null,
        _canConvertToGroup: null,

        _preventDefault: function _preventDefault(event) {
            event.preventDefault();
        },
        initialize: function initialize() {
            var _this = this;

            this.__super();
            this._registerGroup(this.options.group);

            this._canCreateGroup();
            this.listenTo(this._currentPrincipalView, "navigation", function (event) {
                event.preventDefault();
                _this._navigateTo(event.target.getAttribute("href"));
            });

            this.listenTo(this.model, "sync:state", function (state, method) {
                if (method !== "destroy") {
                    _this._syncing = state === Syncer.State.Pending || state === Syncer.State.Syncing;
                    _this.ui.createNewVariant.toggleClass("disabled", _this._syncing);
                    _this.ui.createBreakpointGroup.toggleClass("disabled", _this._syncing);
                    _this._updateTooltip(_this.ui.createBreakpointGroup);
                }
            });
        },
        _disableBreakpointOnEmail: function _disableBreakpointOnEmail() {
            var isEmailModeEnabled = this.viewScope.viewModel.get("experience").get("emailModeEnabled");
            this.ui.createBreakpointGroup.toggleClass("emailDisabled", isEmailModeEnabled);
            this._updateTooltip(this.ui.createBreakpointGroup);
        },
        _updateTooltip: function _updateTooltip(ref) {
            var isEmailModeEnabled = this.viewScope.viewModel.get("experience").get("emailModeEnabled");
            var tooltipOptions = void 0;

            if (isEmailModeEnabled) {
                tooltipOptions = TOOLTIPS.breakpointEmailDisabled;
            } else if (this._syncing) {
                tooltipOptions = TOOLTIPS.sync;
            } else {
                Tooltip.remove(ref);
                return;
            }
            Tooltip.add(ref, tooltipOptions);
        },
        _registerGroup: function _registerGroup(group) {
            var _this2 = this;

            if (!group) {
                return;
            }

            this._group = group;

            this.listenToOnce(group, "destroy", function () {
                _this2._group = null;
                _this2._canCreateGroup();
                _this2.render();
                _this2.renderComponents();
            });
        },
        _canCreateGroup: function _canCreateGroup() {
            this._canConvertToGroup = !this._group && !this.model.hasAtLeastState(PublishableState.SCHEDULED); // SCHEDULED and PUBLISHED
        },
        onRender: function onRender() {
            this.__super();
            this._toggleExperienceNav({ visible: true });
            this.listenTo(this.viewScope.viewModel.get("experience"), "change:emailModeEnabled", this._disableBreakpointOnEmail);
        },
        onShow: function onShow() {
            this.__super();
            this.renderComponents();
            this._disableBreakpointOnEmail();

            if (!this._canConvertToGroup) {
                Tooltip.add(this.ui.createBreakpointGroup, {
                    content: "Breakpoint Variants cannot be created when an Experience is " + this.model.get("state") + ".",
                    width: 200,
                    placement: "right"
                });
            }
        },


        // Renders sub
        renderComponents: function renderComponents() {
            this._renderGroupNavbar();
            this.experienceOptionsPanel.show(new ExperienceOptionsView({
                model: this.model,
                group: this._group,
                project: this.options.project,
                companySettings: this.options.companySettings,
                viewModel: this.options.viewModel,
                integrationsCollection: this.options.integrationsCollection
            }));
        },
        _handleSave: function _handleSave() {
            // trigger a save
            this.model.set({ state: Syncer.State.Pending });
            this.model.trigger("sync:state");
        },
        _handleCreateVariant: function _handleCreateVariant(experienceCollection) {
            new ActionSequence().add(new AddBreakpointAction(this._group, this.model, this.options.project, experienceCollection)).add(new NavigateToExperienceAction(this.model.get("sceneNumber"))).execute();
        },
        navigateToExperience: function navigateToExperience(experienceId) {
            var sceneNumber = this.options.viewModel.get("sceneNumber");
            new NavigateToExperienceAction(sceneNumber).execute(experienceId);
        },
        _handleChangeVariant: function _handleChangeVariant(experienceId) {
            var eventProperties = {
                experienceId: experienceId,
                triggerOrigin: "VariantIcon",
                groupType: "BreakpointGroup"
            };
            EditorEvents.trigger(EditorEvents.constants.SWITCH_VARIANT, eventProperties);
            this.navigateToExperience(experienceId);
        },
        _renderGroupNavbar: function _renderGroupNavbar() {
            if (this._group) {
                // Render group controller
                this.ui.createNewVariant.hide();
                this.ui.navBar.toggleClass("narrow", this._group.getNumOfAssets() > 7);

                this.groupNavViewRegion.show(GroupNavViewFactory.create({
                    model: this._group,
                    experience: this.model,
                    viewModel: this.viewScope.viewModel,
                    project: this.options.project,
                    editorNavBarElement: this.ui.editorNavBar,
                    pushed: this.options.pushed,
                    channelConfig: this.options.channelConfig
                }));
            } else {

                if (this.model.get("id").startsWith("C3_")) {
                    this.c3CollectionsRegion.show(ReactBridge.viewFromComponent(VariantComponent, {
                        props: {
                            handleCreateVariant: this._handleCreateVariant.bind(this),
                            experience: this.model,
                            handleChangeVariant: this._handleChangeVariant.bind(this),
                            handleSave: this._handleSave.bind(this)
                        }
                    }));

                    // logic to disable the user to switch between variants/create variants while an experience
                    // is being saved to prevent multiple saves and maintain version consistency.
                    this.listenTo(this.model, "sync:state", function (state) {
                        if (state === Syncer.State.Synced) {
                            window.dispatchEvent(new Event("experienceSaved"));
                            document.getElementById("c3collections").style.pointerEvents = 'auto';
                            document.getElementById("c3CollectionsWrapper").style.cursor = 'auto';
                        } else {
                            document.getElementById("c3collections").style.pointerEvents = 'none';
                            document.getElementById("c3CollectionsWrapper").style.cursor = 'not-allowed';
                        }
                    });
                }

                // show locale selector
                this.localeSelectorRegion.show(new LocaleSelectorControl({
                    locales: LocaleCollection.models,
                    firstVariant: true,
                    selectHandler: this._createLocaleGroup.bind(this)
                }));
            }
        },
        _createBreakpointGroupClickHandler: function _createBreakpointGroupClickHandler(event) {
            if (this.model.hasAtLeastState(PublishableState.SCHEDULED) || this._syncing || this.ui.createBreakpointGroup.hasClass("emailDisabled")) {
                // SCHEDULED and PUBLISHED and not EmailMode
                event.stopPropagation();
                event.preventDefault();
            } else {
                this._createBreakpointGroup();
            }
        },
        _isExperienceBarVisible: function _isExperienceBarVisible() {
            return this.ui.experienceNav.hasClass("visible");
        },
        _toggleExperienceNav: function _toggleExperienceNav(options) {
            var isVisible = isBoolean(options.visible) ? options.visible : !this._isExperienceBarVisible();
            this.ui.experienceNav.toggleClass("visible", isVisible);
            this.ui.variantsRegion.toggleClass("visible", isVisible);
        },
        _navigateTo: function _navigateTo(path) {
            Backbone.history.navigate(path, true);
        },
        toggleProjectPanel: function toggleProjectPanel() {
            this.__super();
            this._toggleExperienceNav({ visible: !this._isExperienceBarVisible() });
        },
        _createLocaleGroup: function _createLocaleGroup(language) {
            var _this3 = this;

            // We stay the same page when creating a localization group, but re-render the nav bar
            new AddLocaleAction(this._group, this.model, this.options.project, language).execute().done(function (group) {
                _this3._registerGroup(group);
                _this3.render();
                _this3.renderComponents();
            });
        },
        _createBreakpointGroup: function _createBreakpointGroup() {
            // We are always navigating to another variant, so no need to re-render anything
            new ActionSequence().add(new AddBreakpointAction(this._group, this.model, this.options.project)).add(new NavigateToExperienceAction(this.model.get("sceneNumber"))).execute();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Backdrop = __webpack_require__(523);
    var EditorEvents = __webpack_require__(17);
    var Lightbox = __webpack_require__(101);
    var EditorPreviewMenu = __webpack_require__(2905);
    var ExperienceSyncStateView = __webpack_require__(2936);
    var ImprovedView = __webpack_require__(6);
    var Permissions = __webpack_require__(22);
    var SaveTemplateModalView = __webpack_require__(2942);
    var ExperienceTemplateOptionsView = __webpack_require__(2944);
    var template = __webpack_require__(2946);
    var Tooltip = __webpack_require__(35);
    var UrlUtil = __webpack_require__(46);
    var Storage = __webpack_require__(34);

    // https://en.wikipedia.org/wiki/Language_localisation suggests that you use a combination of ISO 639-1 AND ISO 3166-2
    // pattern is language_code-COUNTRY_CODE
    // language codes: https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
    // country codes: https://en.wikipedia.org/wiki/ISO_3166-2   or https://www.nationsonline.org/oneworld/country_code_list.htm

    /**
     *
     * @class ExperienceOptionsView
     *
     */
    return ImprovedView.extend({

        className: "experience-options-container",

        template: template,

        _isNewDashboardExperience: false,

        templateHelpers: function templateHelpers() {
            return {
                spectator: this._isSpectator,
                inGroup: !!this.options.group,
                isNewDashboardExperience: this._isNewDashboardExperience
            };
        },


        ui: {
            showBackdrop: ".show-backdrop",
            backdropIconContainer: ".show-backdrop .img-container",
            backdropIcon: ".show-backdrop .img-container img",
            autoPlayDelay: ".auto-play-delay-input",
            autorunUnits: ".autorun-units",
            autoPlayTransition: ".auto-play-transition",
            backdropPreviewImage: ".backdrop-preview-image",
            backdropContainer: ".backdrop-container",
            multiSceneOptions: ".multi-scene-options",
            languageSelect: ".language-select"
        },

        regions: {
            leftInfo: ".left-info",
            rightInfo: ".right-info",
            templateOptions: ".template-options"
        },

        bindings: {
            ".name-input": {
                observe: "name",
                updateMethod: "text",
                escape: false,
                events: ["blur"],
                onSet: function onSet(value) {
                    var payload = {
                        triggerOrigin: "EditExperienceVariantNameInputField",
                        updatedProperty: "name",
                        updatedValue: value
                    };

                    this._trackEditorEvent(EditorEvents.constants.UPDATE_VARIANT, payload);

                    return value;
                }
            }

        },

        modelEvents: {
            "change:backdrop": "_updateBackdropImageIcon",
            "add:scenes remove:scenes": "_toggleMultiSceneOptions"
        },

        _isSpectator: null,

        _backdropViewer: null,

        initialize: function initialize() {
            this._isSpectator = Permissions.Privileges.CREATE.cannot();
            this._isNewDashboardExperience = Storage.Local.get(Storage.Keys.NEW_DASHBOARD_EXP, Storage.Keys.NEW_DASHBOARD_EXP);
        },
        onRender: function onRender() {
            if (this.options.group) {
                this.$el.addClass("group");
            }
        },
        onShow: function onShow() {
            this.leftInfo.show(new EditorPreviewMenu({
                model: this.model,
                project: this.options.project,
                group: this.options.group,
                viewModel: this.options.viewModel
            }));

            this.rightInfo.show(new ExperienceSyncStateView({
                model: this.model,
                group: this.options.group,
                showTooltip: true,
                viewModel: this.options.viewModel,
                notifyConcurrentModification: { defaultValue: 1000 * 60 * 15 // 15 min!token
                } }));

            this._setupTemplateOptionsView();
            this._toggleMultiSceneOptions();
            this._updateBackdropImageIcon();
        },
        _setupTemplateOptionsView: function _setupTemplateOptionsView() {
            if (!this._isSpectator && this.options.companySettings.get("templateSharingEnabled")) {
                var viewModel = this.options.viewModel;

                var templateModel = viewModel.get("templateModel");
                var experience = viewModel.get("experience");

                var experienceTemplateOptionsView = new ExperienceTemplateOptionsView({ model: templateModel, experience: experience });

                this.listenTo(experienceTemplateOptionsView, "clickTemplateSave", this._onClickTemplatesSave);
                this.templateOptions.show(experienceTemplateOptionsView);
            }
        },
        _updateBackdropImageIcon: function _updateBackdropImageIcon() {
            var backdropModel = this.model.get("backdrop");
            var backdropType = backdropModel.get("type");

            switch (backdropType) {
                case Backdrop.TYPE.IMAGE:
                    this.ui.backdropPreviewImage.attr("src", UrlUtil.getAbsoluteViewerApiUrl(backdropModel.get("image").url));
                    this.ui.backdropPreviewImage.removeClass("hidden");
                    this.ui.backdropContainer.css("background-color", "transparent");
                    this.ui.backdropContainer.addClass("no-border");
                    break;
                case Backdrop.TYPE.COLOR:
                    this.ui.backdropPreviewImage.addClass("hidden");
                    this.ui.backdropContainer.css("background-color", backdropModel.get("color"));
                    this.ui.backdropContainer.removeClass("no-border");
                    break;
                default:
                    throw new Error("Expected the type to be either Image or Color, but it was '" + backdropType.toString() + "'");
            }

            if (this._isSpectator) {
                Tooltip.add(this.ui.showBackdrop, {
                    content: "Your access level (Spectator) doesn't permit you to edit the backdrop",
                    placement: "bottom",
                    alignCenter: true,
                    offset: {
                        align: "center"
                    },
                    width: "auto",
                    delay: { show: 1, hide: 0 }
                });
            }
        },
        _onClickTemplatesSave: function _onClickTemplatesSave() {
            var experience = this.viewScope.viewModel.get("experience");

            this._showLightbox({
                view: new SaveTemplateModalView({
                    model: this.options.viewModel.get("templateModel"),
                    experience: experience
                }),
                css: { width: 520 },
                experience: experience,
                props: {
                    modalType: "SaveTemplate",
                    triggerOrigin: "SaveTemplateModal",
                    sceneNumber: this.viewScope.viewModel.get("sceneNumber")
                }
            });
        },
        _showLightbox: function _showLightbox(_ref) {
            var view = _ref.view,
                css = _ref.css,
                experience = _ref.experience,
                props = _ref.props;

            var lightboxOptions = {
                win: false,
                css: css,
                editorEventProperties: _.extend({
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion")
                }, props)
            };

            new Lightbox(view, lightboxOptions, this).open();
        },
        _getFallbackUrl: function _getFallbackUrl() {
            var url = this.model && this.model.get("fallbackImageURL");
            return url ? UrlUtil.getAbsoluteViewerApiUrl(url) : "";
        },


        /**
         * Sends editor event to Mix Panel via Segment.
         * @param {String} eventName The name of the event to be sent.
         * @param {Object} payload An object containing mandatory properties to be sent.
         * @private
         */
        _trackEditorEvent: function _trackEditorEvent(eventName, payload) {
            var eventProperties = {
                experienceId: this.model.get("id"),
                experienceVersion: this.model.get("version"),
                experiencePushedVersion: this.model.get("pushedVersion"),
                triggerOrigin: payload.triggerOrigin,
                projectId: this.options.project && this.options.project.get("id"),
                updatedProperty: payload.updatedProperty,
                updatedValue: payload.updatedValue
            };

            if (this.options.group) {
                eventProperties.groupId = this.options.group.get("id");
                eventProperties.groupType = this.options.group.get("type");
                eventProperties.groupVersion = this.options.group.get("version");
                eventProperties.groupPushedVersion = this.options.group.get("pushedVersion");
            }

            EditorEvents.trigger(eventName, eventProperties);
        },
        _toggleMultiSceneOptions: function _toggleMultiSceneOptions() {
            this.ui.multiSceneOptions.toggleClass("hidden", this.model.getNumberOfScenes() === 1);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _require = __webpack_require__(1),
    omit = _require.omit;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var ImprovedView = __webpack_require__(6);
    var ExperienceURLProvider = __webpack_require__(168);
    var EditorMoreMenu = __webpack_require__(2906);
    var EditorEvents = __webpack_require__(17);
    var PushPublishButtonView = __webpack_require__(2918);
    var ToggleEmailMode = __webpack_require__(2920);
    var SendTestEmailButtonView = __webpack_require__(2922);
    var LoggedInUserState = __webpack_require__(19);
    var Syncer = __webpack_require__(50);
    var template = __webpack_require__(2935);
    var Storage = __webpack_require__(34);
    var Configuration = __webpack_require__(27);
    var SystemMessages = __webpack_require__(107);

    var CONTENT_CONTROL_URL = Configuration.contentControlUrl;

    /**
     * @cfg {EditorViewModel} model
     *
     * @class EditorPreviewMenu
     */
    return ImprovedView.extend({

        className: "editor-preview-menu",

        template: template,

        /**
         * @private @type {Boolean}
         * True if the experience is currently being synced (saved).
         */
        _syncing: false,

        _isEmailInCreatorEnabled: false,

        _isNewDashboardExperience: false,

        ui: {
            previewBtn: ".preview-btn",
            previewPublishBtn: ".preview-publish-btn"
        },

        events: {
            "click @ui.previewBtn": "_showPreview",
            "click @ui.previewPublishBtn": "_showPreviewInContentControl"
        },

        regions: {
            pushPublishButtonRegion: ".push-publish-btn-region",
            toggleEmailModeRegion: ".toggle-email-mode-region",
            sendTestEmailButtonRegion: ".send-test-email-btn-region",
            editorMoreMenu: ".editor-more-menu"
        },

        initialize: function initialize() {
            var _this = this;

            this._isEmailInCreatorEnabled = LoggedInUserState.get("companySettings").get("isCreatorInEmailEnabled");
            this._isNewDashboardExperience = Storage.Local.get(Storage.Keys.NEW_DASHBOARD_EXP, Storage.Keys.NEW_DASHBOARD_EXP);
            this._syncEmailMode();
            this.listenTo(this.model, "sync:state", function (state, method) {
                if (method !== "destroy") {
                    _this._syncing = state === Syncer.State.Pending || state === Syncer.State.Syncing;
                    _this.ui.previewBtn.toggleClass("disabled", _this._syncing);
                }
            });
        },


        templateHelpers: function templateHelpers() {
            return {
                isEmailInCreatorEnabled: this._isEmailInCreatorEnabled,
                isNewDashboardExperience: this._isNewDashboardExperience
            };
        },

        onShow: function onShow() {
            var isGroup = this.options.group;

            this.pushPublishButtonRegion.show(new PushPublishButtonView({
                model: this.model,
                project: this.options.project,
                hidePublish: this._isNewDashboardExperience || !!isGroup,
                hidePushBtn: this._isNewDashboardExperience
            }));

            this.toggleEmailModeRegion.show(new ToggleEmailMode({
                model: this.model,
                group: this.options.group
            }));

            this.editorMoreMenu.show(new EditorMoreMenu({
                model: this.options.viewModel,
                experience: this.model
            }));

            if (this._isEmailInCreatorEnabled) {
                this.sendTestEmailButtonRegion.show(new SendTestEmailButtonView({
                    viewModel: this.options.viewModel,
                    experienceModel: this.model
                }));
            }
        },

        _syncEmailMode: function _syncEmailMode() {
            if (!this._isEmailInCreatorEnabled && this.model.get("emailModeEnabled")) {
                this.model.set({ emailModeEnabled: false });
            }
        },

        _showPreview: function _showPreview() {
            if (!this._syncing) {
                var experience = this.model;
                var experienceId = experience.get("id");
                var sceneNumber = this.model.get("sceneNumber");
                var experiencePreviewURL = ExperienceURLProvider.provide(experienceId, ExperienceURLProvider.ACTION.PREVIEW, sceneNumber, this.viewScope.viewModel.get("currentLayer").value);

                Backbone.history.navigate(experiencePreviewURL, true);
                EditorEvents.trigger(EditorEvents.constants.OPEN_EXPERIENCE_PREVIEW, {
                    experienceId: experienceId,
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    sceneNumber: sceneNumber,
                    projectId: this.options.project && this.options.project.get("id"),
                    triggerOrigin: "EditorPreviewButton"
                });
            }
        },

        _showPreviewInContentControl: function _showPreviewInContentControl() {
            var experience = this.model;
            if (Object.keys(experience.changed).length === 1) {
                experience.set({ state: Syncer.State.Synced });
                var query = new URLSearchParams(window.location.search);
                var containerId = query.get("containerId");
                var collectionId = query.get("collectionId");
                var experienceId = experience.get("id");
                window.location.href = CONTENT_CONTROL_URL + "?containerId=" + containerId + "&collectionId=" + collectionId + "&experienceId=" + experienceId + "#preview";
            } else {
                // Set state and trigger a save
                experience.set({ state: Syncer.State.Pending });
                experience.trigger("sync:state");

                // here state variable indicates currentstate ie.- Syncer.State.current(this.model);
                this.listenTo(experience, "sync:state", function (state) {
                    // once experienced is saved redirect to Content Control Preview Page
                    if (state == Syncer.State.Synced) {
                        var _query = new URLSearchParams(window.location.search);
                        var _containerId = _query.get("containerId");
                        var _collectionId = _query.get("collectionId");
                        var _experienceId = experience.get("id");
                        window.location.href = CONTENT_CONTROL_URL + "?containerId=" + _containerId + "&collectionId=" + _collectionId + "&experienceId=" + _experienceId + "#preview";
                    }
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorMoreMenuViewController = __webpack_require__(2907),
        ImprovedView = __webpack_require__(6),
        LoggedInUserState = __webpack_require__(19),
        ShareButton = __webpack_require__(1221),
        template = __webpack_require__(2917);

    return ImprovedView.extend({

        controller: EditorMoreMenuViewController,

        template: template,

        experienceBindings: {
            ".unread-comments-indicator": {
                observe: "unread",
                updateView: true,
                visible: function visible(value) {
                    return value > 0;
                }
            }
        },

        bindings: {
            ".toggle-comments": {
                attributes: [{
                    name: "class",
                    observe: "showComments",
                    onGet: function onGet(showComments) {
                        return "toggle-comments" + (showComments ? " comments-shown" : "");
                    }
                }]
            },
            ".add-comment": {
                attributes: [{
                    name: "class",
                    observe: "showComments",
                    onGet: function onGet(showComments) {
                        return "add-comment" + (showComments ? " comments-shown" : "");
                    }
                }]
            }
        },

        triggers: {
            "click @ui.toggleComments": "toggleComments", // See EditorMoreMenuViewController
            "click @ui.addComment": "addComment" // See EditorMoreMenuViewController
        },

        ui: {
            dropdown: ".dropdown.more",
            dropdownLinks: ".more .dropdown-menu li",
            shareMenu: ".share.menu-item",
            toggleComments: ".toggle-comments",
            addComment: ".add-comment"
        },

        regions: {
            shareMenu: ".share.menu-item"
        },

        templateHelpers: function templateHelpers() {
            return {
                isEmailInCreatorEnabled: LoggedInUserState.get("companySettings").get("isCreatorInEmailEnabled")
            };
        },

        onRender: function onRender() {
            this.stickit(this.options.experience, this.experienceBindings);
        },

        onShow: function onShow() {
            this.shareMenu.show(new ShareButton({
                experience: this.options.experience,
                route: null,
                modal: true,
                hideTooltip: true
            }));
        },

        hide: function hide() {
            this.ui.dropdown.toggleClass("open", false);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ViewController = __webpack_require__(126),
        EditorEvents = __webpack_require__(17);

    return ViewController.extend({
        onViewToggleEmailMode: function onViewToggleEmailMode() {
            this.model.set("emailModeEnabled", !this.model.get("emailModeEnabled"));
        },

        onViewToggleComments: function onViewToggleComments() {
            this.model.set("showComments", !this.model.get("showComments"));
        },

        onViewAddComment: function onViewAddComment() {
            this.view.hide();

            this.model.get("commentsRenderer").addComment();

            var experience = this.options.experience,
                eventProperties = {
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                triggerOrigin: "EditorMoreMenu"
            };
            EditorEvents.trigger(EditorEvents.constants.CREATE_COMMENT_THREAD, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);

    /**
     * A virtual Backbone collection containing all of the models of a backing collection that meet a filter test.
     *
     * <p>This collection is only suitable for use as a view of the underlying models/collections. Avoid calling
     * functions that manipulate the collection, as this has undefined behaviour.</p>
     *
     * <p>When changes are made to the backing collection, a reset is fired from this collection.</p>
     *
     * @author Bruce Mackenzie Nielsen
     * @class FilteredCollection
     *
     * @param {Collection} collection The backing collection to filter.
     * @param {Function} filter The filter function. Should return true for models that pass the filter.
     */
    return Backbone.Collection.extend({

        _backingCollection: null,
        _filterFunction: null,

        _getModelArray: function _getModelArray() {
            return this._backingCollection.filter(this._filterFunction);
        },

        constructor: function constructor(collection, filter) {
            this._backingCollection = collection;
            this._filterFunction = filter;

            // Initialize the virtual collection
            Backbone.Collection.call(this, this._getModelArray());

            // Register event handlers
            this.listenTo(collection, "change add remove reset sort", function () {
                this.reset(this._getModelArray());
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        ShareRecipientDisplayView = __webpack_require__(2910);

    /**
     * The collection view of share recipients for display purposes.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientDisplayCollectionView
     * @constructor
     */
    return Marionette.CompositeView.extend({
        template: function template() {
            return "";
        },
        itemView: ShareRecipientDisplayView
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        ShareRecipientToLabel = __webpack_require__(1223),
        template = __webpack_require__(2911);

    /**
     * Display item view for a share recipient.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientDisplayView
     * @constructor
     */
    return Marionette.ItemView.extend({
        template: template,
        className: "recipients-list-item-wrapper",

        ui: {
            removeButton: ".recipients-list-item-remove-button"
        },

        bindings: {
            ".recipients-list-item": "displayName"
        },

        events: {
            "click": function click() {
                this.model.set("selected", !this.model.get("selected"));
            }
        },

        onRender: function onRender() {
            this.stickit();
            if (this.model instanceof ShareRecipientToLabel) {
                this.$el.addClass("to-label");
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2911 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="recipients-list-item"></div>\n<div class="recipients-list-item-remove-button">&#x00d7;</div>\n';

}
return __p
}

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        ShareRecipientView = __webpack_require__(2913);

    /**
     * The collection view of share recipients.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientCollectionView
     * @constructor
     */
    return Marionette.CompositeView.extend({
        template: function template() {
            return "";
        },
        itemView: ShareRecipientView
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        Icons = __webpack_require__(357),
        template = __webpack_require__(2914);

    /**
     * Item view for a share recipient.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientView
     * @constructor
     */
    return Marionette.ItemView.extend({
        template: template,
        className: "choose-recipients-list-item-wrapper",

        ui: {
            removeButton: ".choose-recipients-list-item-remove-button"
        },

        bindings: {
            ".choose-recipients-list-item": "displayName"
        },

        modelEvents: {
            "change:selected": "_updateSelectedState"
        },

        events: {
            "click": function click() {
                this.model.set("selected", !this.model.get("selected"));
            }
        },

        _updateSelectedState: function _updateSelectedState() {
            if (this.model.get("selected")) {
                this.$el.addClass("selected");
            } else {
                this.$el.removeClass("selected");
            }
        },

        onRender: function onRender() {
            this.ui.removeButton.append(Icons.X_BUTTON.createElement());

            this._updateSelectedState();
            this.stickit();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2914 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="choose-recipients-list-item"></div>\n<div class="choose-recipients-list-item-remove-button"></div>\n';

}
return __p
}

/***/ }),
/* 2915 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="header">Share this:</div>\n<div class="choose-recipients">\n    <button type="button" class="choose-recipients-header collapsible" data-toggle="collapse" data-target="#choose-recipients-body-container">Add people from list:</button>\n    <div id="choose-recipients-body-container" class="collapse-target collapse">\n        <div class="choose-recipients-body">\n            <div class="choose-recipients-list-region"></div>\n            <div class="choose-recipients-add">\n                <button class="choose-recipients-add-button btn">Invite</button>\n                <div class="choose-recipients-add-input-container">\n                    <div class="choose-recipients-add-input-wrapper">\n                        <input type="text" placeholder="Type email address"/>\n                        <div class="choose-recipients-add-ok"></div>\n                    </div>\n                </div>\n                <div class="choose-recipients-add-disclaimer">\n                    Invited users will receive spectator access only.\n                </div>\n            </div>\n            <div class="footer">\n                <div class="choose-recipients-ok">OK</div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="message">\n    <div class="recipients-list"></div>\n    <div class="body-spacer"></div>\n    <textarea class="body" placeholder="Type message here"></textarea>\n</div>\n<div class="footer">\n    <div class="share-send"><button class="btn">Send</button></div>\n    <div class="share-divider">|</div>\n    <div class="share-cancel">Cancel</div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        Backbone = __webpack_require__(7),
        EditorEvents = __webpack_require__(17),
        ImprovedModel = __webpack_require__(25),
        LoggedIn = __webpack_require__(31),
        LoggedInUserState = __webpack_require__(19),
        RestApi = __webpack_require__(29),
        Share = __webpack_require__(1224),
        ShareRecipientCollection = __webpack_require__(1225),
        SyncManager = __webpack_require__(44),
        User = __webpack_require__(261),
        UserCollection = __webpack_require__(184);

    /**
     * The view model for the share button and menu.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareViewModel
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            /**
             * Simple state machine with following states:
             * 0 = No share in progress. Button shows tooltip on hover and goes to state 1 on click.
             * 1 = Share in progress. Share menu is open. Goes to state 2 on share, goes to state 0 on cancel.
             * 2 = Share completed. Button shows "thanks for sharing" tooltip and goes to state 1 on click, state 0 after timeout.
             */
            state: 0,
            recipients: null,
            message: "",
            route: ""
        },

        initialize: function initialize() {
            this._reset();
            this.listenTo(this, "change:state", this._stateChangeHandler);
        },

        _reset: function _reset() {
            // Resets the view model so that it is ready for a new share from the same location
            this.set({
                recipients: new ShareRecipientCollection(),
                message: ""
            });
        },

        /**
         * Returns the appropriate share link.
         * <p>Right now the user can share an experience from the viewer, editor or the quickview.
         * The quickview is the only view that sets the route since it's not known when opening it. </p>
         * <p>If no route property was defined, then the URL fragment is used.<p>
         *
         * @returns {String} the route to use.
         */
        _getRoute: function _getRoute() {
            var route = this.get("route");

            if (!route) {
                return Backbone.history.fragment;
            }

            return route;
        },

        _stateChangeHandler: function _stateChangeHandler() {
            // Share is being sent
            if (this.get("state") === 2) {
                // Create the share
                var share = new Share({
                    to: [],
                    message: this.get("message"),
                    link: this._getRoute()
                });

                // Add all of the selected registered users as recipients
                this.get("recipients").each(function (recipient) {
                    if (recipient.get("selected") && recipient.get("user")) {
                        share.addRecipient(recipient.get("user"));
                    }
                });

                // Create new users
                var experience = this.get("experience"),
                    newUserRecipients = this.get("recipients").filter(function (recipient) {
                    return !recipient.get("user") && recipient.get("email");
                });
                if (newUserRecipients.length > 0) {
                    var newUserEmails = _.map(newUserRecipients, function (recipient) {
                        return recipient.get("email");
                    });

                    // Only track new recipients
                    SyncManager.onSync({
                        target: share,
                        once: true,
                        callback: function callback() {
                            var eventProperties = {
                                createdBy: LoggedIn.principal().get("userId"),
                                toUserEmails: newUserEmails,
                                experienceId: experience.get("id"),
                                experienceVersion: experience.get("version"),
                                experiencePushedVersion: experience.get("pushedVersion"),
                                triggerOrigin: "SendShareExperienceButton"
                            };

                            EditorEvents.trigger(EditorEvents.constants.INVITE_USER, eventProperties);
                        }
                    });

                    $.ajax({ // TODO: use SyncManager for this!
                        type: "POST",
                        url: RestApi.pathToCollection(RestApi.Collections.USERS),
                        data: JSON.stringify(newUserEmails),
                        dataType: "json",
                        contentType: "application/json"
                    }).fail(function () {
                        // We don't have any failure handling right now, so just send the share with whatever users we do have
                        share.save();
                    }).then(function (data) {
                        LoggedInUserState.invalidateGlobalCollection(UserCollection);
                        _.each(data, function (rawUser) {
                            share.addRecipient(new User(rawUser));
                        });
                        share.save();
                    });
                } else {
                    share.save();
                }

                this._reset();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2917 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dropdown more">\n    <a href="#" class="dropdown-toggle" data-toggle="dropdown"><span class="unread-comments-indicator"></span></a>\n\n    <ul class="dropdown-menu more-dropdown-menu">\n        <li><a href="#" class="share menu-item">Share</a></li>\n        <li><a href="#" class="toggle-comments menu-item"><span class="unread-comments-indicator"></span>Show/hide Comments</a></li>\n        <li><a href="#" class="add-comment menu-item">Add Comment</a></li>\n    </ul>\n</div>\n\n';

}
return __p
}

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);
    var Permissions = __webpack_require__(22);
    var PublishableState = __webpack_require__(65);
    var Syncer = __webpack_require__(50);
    var SystemMessages = __webpack_require__(107);
    var Tooltip = __webpack_require__(35);
    var template = __webpack_require__(2919);
    var LoggedInUserState = __webpack_require__(19);
    var ResourceCombined = __webpack_require__(1226);

    var _require = __webpack_require__(530),
        COPY_CODE_BUTTON_STATE = _require.COPY_CODE_BUTTON_STATE,
        BUTTON_STATUS = _require.BUTTON_STATUS;

    var Configuration = __webpack_require__(27);
    var Storage = __webpack_require__(34);

    var PUSH_TOOLTIP_TEXT = {
        SPECTATOR_MODE: "You do not have permission to push.",
        DEFAULT: "Pushing your Experience will make it available for Drag'n Drop Publishing. Changes made to your Experience will only go live after you Push again.",
        EMPTY: ""
    };
    var PUBLISH_TOOLTIP_HTML = {
        EXPERIENCE_NOT_PUSHED: "<i class=\"glyphicon glyphicon-exclamation-sign\"></i> This Experience is not Pushed",
        VARIANT_NOT_PUSHED: "<i class=\"glyphicon glyphicon-exclamation-sign important\"></i> The current version is not Pushed",
        EMPTY: ""
    };

    /**
     * Component representing the Push and Publish buttons for the <tt>EditorPreviewMenu</tt>.
     *
     * @cfg {ExperienceModel} model The current experience model.
     *
     * @see EditorPreviewMenu
     *
     * @class PushPublishButtonView
     */
    return ImprovedView.extend({

        className: "push-button-container",

        template: template,

        ui: {
            pushBtn: ".push-btn",
            publishBtn: ".publish-btn"
        },

        events: {
            "click @ui.pushBtn": "_push",
            "click @ui.publishBtn": "_gotoPublish"
        },

        initialize: function initialize() {
            var _this = this;

            this.listenTo(this.model, "sync:state", function (state, method) {
                if (method !== "destroy") {
                    if (state === Syncer.State.Synced || state === Syncer.State.Failed) {
                        _this._updatePushPublishState();
                    }
                }
            });
        },
        onRender: function onRender() {
            this._updatePushPublishState();

            if (this.options.hidePublish) {
                this.ui.publishBtn.hide();
            }
            if (this.options.hidePushBtn) {
                this.ui.pushBtn.hide();
            }
        },
        onClose: function onClose() {
            // Chance for "hanging" tooltips - make sure they are removed...
            var _ui = this.ui,
                pushBtn = _ui.pushBtn,
                publishBtn = _ui.publishBtn;


            Tooltip.remove(pushBtn);
            Tooltip.remove(publishBtn);
        },
        _push: function _push() {
            var _this2 = this;

            var isCombinedGroupEnabled = LoggedInUserState.get("companySettings").get("combinedGroupsSpeed");
            var isGroupType = !!this.model.get("group");
            var isGroupPushed = isGroupType && this.model.get("state") === "Pushed";
            var cannotPush = isCombinedGroupEnabled && isGroupType && !isGroupPushed;

            // Has privilege to push?
            if (Permissions.Privileges.PUBLISH.cannot() || cannotPush) {
                return;
            }
            // Notify the user that a save is in progress and the Push will occur next
            if (Syncer.State.current(this.model) === Syncer.State.Pending) {
                SystemMessages.notify("Push will occur once save completes.", 2000);
            }
            this.model.set(COPY_CODE_BUTTON_STATE, BUTTON_STATUS.disabled);
            // Push the experience
            this.model.push().then(function () {
                var token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
                fetch(Configuration.creatorSettingApiBaseUrl + "/v1/buildSsr?companyId=" + _this2.model.get("companyId") + "&experienceId=" + _this2.model.get("id"), {
                    headers: {
                        Authorization: "Bearer " + token
                    },
                    method: "GET"
                }).catch();
                var purgeTime = _this2.model.get("purgeTime");

                // Only open the notification bar if the purgeTime is not null.
                if (purgeTime !== null) {
                    SystemMessages.notifyPurge("Experience", "pushed", purgeTime, false);
                }

                var eventProperties = {
                    experienceId: _this2.model.get("id"),
                    experienceVersion: _this2.model.get("version"),
                    experiencePushedVersion: _this2.model.get("pushedVersion"),
                    projectId: _this2.options.project && _this2.options.project.get("id"),
                    triggerOrigin: "PushExperienceButton"
                };

                EditorEvents.trigger(EditorEvents.constants.PUSH_EXPERIENCE, eventProperties);
                _this2.model.getNativeCode(eventProperties.triggerOrigin);
            }).then(function () {
                if (!isCombinedGroupEnabled) {
                    return;
                }
                return ResourceCombined.syncExperience(_this2.model.get("id"), _this2.model.get("companyId"));
            });
        },
        _gotoPublish: function _gotoPublish() {
            var project = this.options.project;


            if (typeof project === "undefined") {
                Backbone.history.navigate("publish", true);
            } else {
                Backbone.history.navigate("#project/" + project.get("id") + "/publish", true);
            }

            var eventProperties = {
                experienceId: this.model.get("id"),
                experienceVersion: this.model.get("version"),
                experiencePushedVersion: this.model.get("pushedVersion"),
                dashboardType: "Publish",
                projectId: this.options.project && this.options.project.get("id"),
                triggerOrigin: "PublishButton"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_DASHBOARD, eventProperties);
            // Hide the tooltip once the button is clicked, otherwise the tooltip may stick around while page transition out.
            Tooltip.hide(this.ui.publishBtn);
        },


        /**
         * @private
         * Handler called to update push and publish buttons.
         */
        _updatePushPublishState: function _updatePushPublishState() {
            // No permission, so the push button can never be active...
            if (Permissions.Privileges.PUBLISH.cannot()) {
                return this.toggleButtons(true, PUSH_TOOLTIP_TEXT.EMPTY, PUBLISH_TOOLTIP_HTML.EMPTY);
            }

            // Default tooltip...
            var pushTooltip = PUSH_TOOLTIP_TEXT.DEFAULT;
            var publishTooltip = PUBLISH_TOOLTIP_HTML.EMPTY;

            if (!this.model.hasAtLeastState(PublishableState.PUSHED)) {
                publishTooltip = PUBLISH_TOOLTIP_HTML.EXPERIENCE_NOT_PUSHED;
            } else if (this.model.isChangedAfterPush()) {
                publishTooltip = PUBLISH_TOOLTIP_HTML.VARIANT_NOT_PUSHED;
            }

            // Push button enabled/disabled? We will make push button disabled if it is all pushed
            var disabled = !this.model.hasNonPushedChanges() && this.model.syncState.actual.state !== Syncer.State.Failed;

            // Push button should be disabled if current version of the experience is pushed
            this.toggleButtons(disabled, pushTooltip, publishTooltip);
        },


        /**
         * Toggles the state of the push button and sets the tooltips for the push and publish buttons.
         *
         * @param {Boolean} disabled         True if the push button is disabled, false otherwise.
         * @param {String}  [pushTooltip]    The tooltip for the push button; can be falsey (removed).
         * @param {String}  [publishTooltip] The tooltip for the publish button; can be falsey (removed).
         */
        toggleButtons: function toggleButtons(disabled, pushTooltip, publishTooltip) {
            // also called by controller!
            this.ui.pushBtn.toggleClass("disabled", disabled);
            this.ui.pushBtn.attr("disabled", disabled);

            this._updateButtonTooltip(this.ui.pushBtn, pushTooltip);
            this._updateButtonTooltip(this.ui.publishBtn, publishTooltip, 230);
        },


        /**
         * @private
         * Updates the tooltip for the supplied button with the specified content and width, or removes it if
         * no content.
         *
         * @param {jQuery} button  The push or publish button; never falsey.
         * @param {String} content The content for the tooltip; can be falsey, which will remove the tooltip.
         * @param {Number} [width] The tooltip width; defaults to standard tooltip width.
         */
        _updateButtonTooltip: function _updateButtonTooltip(button, content, width) {
            if (content) {
                var tooltipConfig = {
                    content: content,
                    width: width || 300,
                    html: true
                };

                if (button === this.ui.pushBtn) {
                    tooltipConfig.offset = {
                        align: "left",
                        elementWidth: 100
                    };
                }

                Tooltip.create(button, tooltipConfig);
            } else {
                Tooltip.remove(button);
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2919 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<button class="push-btn btn btn-grey">Push</button>\n<button class="publish-btn btn btn-white">Publish</button>\n\n';

}
return __p
}

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(2921);
    var Tooltip = __webpack_require__(35);

    /**
     * Component representing the Toggle email mode button for the <tt>EditorPreviewMenu</tt>.
     *
     * @cfg {ExperienceModel} model The current experience model.
     *
     * @see EditorPreviewMenu
     *
     * @class ToggleEmailModeView
     */
    return ImprovedView.extend({

        className: "toggle-email-mode-button-container",

        template: template,

        ui: {
            toggleEmailModeBtn: ".toggle-email-mode"
        },

        events: {
            "click @ui.toggleEmailModeBtn": "toggleEmailMode"
        },

        bindings: {
            ".toggle-email-mode": {
                observe: "emailModeEnabled",
                update: function update($el, isEnabled) {
                    var statusText = isEnabled ? "Disable" : "Enable";
                    $el.text(statusText + " Email Mode");
                }
            }
        },

        getUniqueEntries: function getUniqueEntries(group) {
            if (group) {
                return group.attributes.entries.chain().reduce(function (assetsMap, internalAsset) {
                    var asset = internalAsset.get("asset");

                    if (asset) {
                        var id = asset.get("id");
                        assetsMap[id] = [asset, internalAsset.get("value")];
                    }

                    return assetsMap;
                }, {}).values().value();
            }
            return [];
        },
        _toggleDisableEmailButton: function _toggleDisableEmailButton() {
            var entriesLength = this.getUniqueEntries(this.options.group).length;

            if (entriesLength > 1) {
                this.ui.toggleEmailModeBtn.addClass("disabled");
                Tooltip.create(this.ui.toggleEmailModeBtn, {
                    content: "Email Mode is not available for group of experiences. Please, reduce your experience to a single variant to enable email mode.",
                    width: 380,
                    placement: "bottom"
                });
                return true;
            }
            this.ui.toggleEmailModeBtn.removeClass("disabled");
            Tooltip.remove(this.ui.toggleEmailModeBtn);
            return false;
        },
        onShow: function onShow() {
            this._toggleDisableEmailButton();
        },
        toggleEmailMode: function toggleEmailMode() {
            var isEmailModeEnabled = this.model.get("emailModeEnabled");

            var buttonDisabled = this._toggleDisableEmailButton();
            if (buttonDisabled) return;

            this.model.set("emailModeEnabled", !isEmailModeEnabled);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2921 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<button class="toggle-email-mode btn btn-grey">Enable Email Mode</button>';

}
return __p
}

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var Tooltip = __webpack_require__(35);
    var template = __webpack_require__(2923);
    var AbstractEmailButtonView = __webpack_require__(1227);
    var RecipientsPopupModel = __webpack_require__(2931);
    var SendTestEmailContentView = __webpack_require__(2933);
    var NotificationBar = __webpack_require__(53);
    var EMAIL_STATES = __webpack_require__(209);

    var OverlayView = Backbone.View.extend({

        className: "share-overlay",

        events: {
            "activate": "_activateHandler"
        },

        render: function render() {
            return this;
        },
        _activateHandler: function _activateHandler() {
            this.model.set("state", EMAIL_STATES.CLOSE);
        }
    }, {

        instance: null,

        show: function show(options) {
            var overlayView = new OverlayView(options);
            overlayView.render().$el.appendTo(window.document.body);
            OverlayView.instance = overlayView;
        },
        remove: function remove() {
            if (OverlayView.instance) {
                OverlayView.instance.remove();
                OverlayView.instance = null;
            }
        }
    });

    /**
     * Component representing the Send Test Email button for the <tt>EditorPreviewMenu</tt>.
     *
     * @cfg {experienceModel} model The current experience model.
     * @cfg {viewModel} model The current view model.
     *
     * @see EditorPreviewMenu
     *
     * @class SendTestEmailButtonView
     */
    return AbstractEmailButtonView.extend({
        className: "email-button-container",

        template: template,

        events: {
            "click @ui.emailBtn": "_openRecipientsModal"
        },

        initialize: function initialize() {
            this.__super();
            this.recipientsPopupModel = new RecipientsPopupModel({
                emailSliceModel: this.model,
                experienceModel: this.experienceModel
            });

            this.listenTo(this.recipientsPopupModel, "change:state", this._manageModalState);
        },
        _openRecipientsModal: function _openRecipientsModal(event) {
            if (this.ui.emailBtn.hasClass("disabled")) {
                return;
            }
            var state = this.recipientsPopupModel.get("state") === EMAIL_STATES.OPEN ? EMAIL_STATES.CLOSE : EMAIL_STATES.OPEN;
            // If a open - close, and vice versa
            this.recipientsPopupModel.set({ state: state });
            event.preventDefault();
        },
        _addPopup: function _addPopup(tooltipSettings) {
            Tooltip.add(this.ui.popup, tooltipSettings);
            Tooltip.show(this.ui.popup);
            OverlayView.show({ model: this.recipientsPopupModel });
        },
        _removePopup: function _removePopup() {
            Tooltip.remove(this.ui.popup);
            OverlayView.remove();
        },
        _manageModalState: function _manageModalState() {
            var notificationId = null;
            NotificationBar.close();
            var tooltipSettings = {
                width: 408,
                animation: false,
                trigger: "manual",
                duration: 0,
                classes: "share-menu-container email modal-popover"
            };
            switch (this.recipientsPopupModel.get("state")) {
                case EMAIL_STATES.OPEN:
                    tooltipSettings.content = new SendTestEmailContentView({ model: this.recipientsPopupModel });
                    tooltipSettings.html = true;
                    this._addPopup(tooltipSettings);
                    break;
                case EMAIL_STATES.CLOSE:
                    this._removePopup();
                    this._updateButtonState();
                    break;
                case EMAIL_STATES.PROCESSING_EMAIL:
                    this._removePopup();
                    notificationId = NotificationBar.open("Please wait... Preparing email for sending");
                    break;
                case EMAIL_STATES.SENT_EMAIL:
                    this._removePopup();
                    NotificationBar.close({ id: notificationId, clear: "self" });
                    NotificationBar.open("You have successfully sent test email", { closeDelay: 5000 });
                    break;
                case EMAIL_STATES.SENT_EMAIL_WITH_SIZE_WARNING:
                    this._removePopup();
                    NotificationBar.close({ id: notificationId, clear: "self" });
                    NotificationBar.error("Warning: You have successfully sent test email but your email is larger than 102KB so it will not render properly in Gmail client.");
                    break;
                case EMAIL_STATES.ERROR_EMAIL:
                    this._removePopup();
                    NotificationBar.close({ id: notificationId, clear: "self" });
                    NotificationBar.error("Some error occurred while sending email. Please try again", { closeDelay: 5000 });
                    break;
                default:
                    break;
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2923 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span class="popup"></span>\n<button class="email-btn send-test btn btn-grey">Send Test Email</button>\n';

}
return __p
}

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Configuration = __webpack_require__(27);
    var ImprovedModel = __webpack_require__(25);
    var UUIDGenerator = __webpack_require__(250);
    var ImageSlicer = __webpack_require__(2925).ImageSlicer;
    var EmailRenderer = __webpack_require__(2926);
    var Promise = __webpack_require__(21);
    var $ = __webpack_require__(4);
    var Storage = __webpack_require__(34);

    // It is known Gmail restriction for email size
    var MAX_GMAIL_ALLOWED_SIZE = 102; // (Kb)

    /**
     * View model for the experience slicing.
     *
     * @class EmailSliceModel
     * @constructor
     */
    var EmailSliceModel = ImprovedModel.extend("EmailSliceModel", {

        _experience: null,
        _viewModel: null,

        url: function url() {
            var experience = this.get("_experience");
            var pushedAtEpochTimeMs = experience.get("pushedAt");
            var pushedAtEpochTime = (pushedAtEpochTimeMs / 1000).toFixed(0);
            var experienceId = experience.get("id");
            var experienceWidth = experience.get("width");
            var experienceHeight = experience.get("height");
            var traceUUID = UUIDGenerator.createUUID();

            var constructedUrl = new URL(Configuration.experienceUrl2PngBaseUrl);
            constructedUrl.search = new URLSearchParams([["experienceId", experienceId], ["pushedAtEpochTime", pushedAtEpochTime], ["experienceWidth", experienceWidth], ["experienceHeight", experienceHeight], ["quality", "auto:best"], ["url2PngSettings", "viewport=" + experienceWidth + "x" + experienceHeight + "|fullpage=false"], ["traceUUID", traceUUID]]).toString();
            return constructedUrl.href;
        },


        /**
         * Call original Backbone.Model#fetch with `dataType` equal `text` for $.ajax.
         * This is a stack exchange special for dealing with raw text return objects.
         * https://stackoverflow.com/questions/22567027/backbone-model-is-plain-text-file-how-to-fetch
         *
         * Also after we get screenshot we need to preload it somehow to be able use "cropped" version of this URL
         * F.E. we got url like:
         * https://thumbnail.creator-stage.zmags.com/.../c_fill,g_north,h_400,w_500/v1612258825/https://cnc-api-dev....
         * But before we can use cropped version:
         * https://thumbnail.creator-stage.zmags.com/c_fill,g_north,h_400,w_500/c_crop,h_31,w_83,x_304,y_165/...
         * we need to preload original image, otherwise - 401 error. It is because Cloudinary specification.
         *
         * So, created own promise which resolved after we load(preload) original URL
         */
        fetch: function fetch(options) {
            var _this = this;

            // eslint-disable-next-line no-undef
            options = _.extend(options || {}, {
                dataType: "text"
            });
            var viewModel = this.get("_viewModel");
            viewModel.set({ isProcessingEmail: true });
            return this.constructor.__super__.fetch.call(this, options).then(function (model) {
                var screenshotURL = model.get("screenshotURL");
                var loadImage = function loadImage(deferred) {
                    var image = new Image();
                    var loaded = function loaded() {
                        var tableJSON = _this._generateJson(screenshotURL, options.widgets);
                        var tableHTML = _this._generateHtml(screenshotURL, tableJSON, options.espName, options.userHTML);
                        var sizeCalcHTML = tableHTML;
                        if (options.espName === "klaviyo" || options.espName === "sfmc") {
                            sizeCalcHTML = sizeCalcHTML.html_code;
                        }
                        var sizeWarning = _this._kByteSize(sizeCalcHTML) >= MAX_GMAIL_ALLOWED_SIZE;
                        model.set({
                            tableJSON: tableJSON, tableHTML: tableHTML, sizeWarning: sizeWarning, emailSize: _this._kByteSize(sizeCalcHTML)
                        });
                        model.set({ tableJSON: tableJSON, tableHTML: tableHTML, sizeWarning: sizeWarning });
                        deferred.resolve(model);
                    };
                    var errored = function errored() {
                        deferred.reject();
                    };
                    deferred.always(function () {
                        image.onload = null;
                        image.onerror = null;
                        image.onabort = null;
                        viewModel.set({ isProcessingEmail: false });
                    });
                    image.onload = loaded;
                    image.onerror = errored;
                    image.onabort = errored;
                    image.src = screenshotURL;
                };
                return Promise.deferred(loadImage);
            }).fail(function (e) {
                return Promise.reject(e);
            });
        },
        parse: function parse(screenshotURL) {
            return { screenshotURL: screenshotURL };
        },
        _kByteSize: function _kByteSize(str) {
            // Get kilobytes. In decimal, not in binary
            return new Blob([str]).size / 1000;
        },
        _generateHtml: function _generateHtml(screenshotURL, tableJSON) {
            var espName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "default";
            var userHTML = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "default";

            var experience = this.get("_experience");
            if (espName === "ometria") {
                var token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
                var bearerToken = "Bearer " + token;
                var payload = {
                    screenshotURL: screenshotURL,
                    tableJSON: tableJSON,
                    width: experience.get("width"),
                    height: experience.get("height")
                };
                var OMETRIA_API_ENDPOINT = Configuration.ometriaApiUrl;
                var options = {
                    type: "POST",
                    url: OMETRIA_API_ENDPOINT,
                    headers: {
                        "authorization": bearerToken
                    },
                    data: JSON.stringify(payload),
                    success: "success",
                    dataType: "json",
                    async: false
                };
                var requestTableHTML = $.ajax(options);
                var response = requestTableHTML.responseJSON || null;
                var _minifiedHTML = response ? response.html_code : null;
                this._pasteCodeToHiddenTextarea(_minifiedHTML);
                return _minifiedHTML;
            } else if (espName === "klaviyo") {
                var _token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
                var _bearerToken = "Bearer " + _token;
                var _payload = {
                    tableHelper: {
                        screenshotURL: screenshotURL,
                        tableJSON: tableJSON,
                        width: experience.get("width"),
                        height: experience.get("height")
                    },
                    userHTML: userHTML
                };
                var KLAVIYO_API_ENDPOINT = Configuration.klaviyoApiUrl;
                var _options = {
                    type: "POST",
                    url: KLAVIYO_API_ENDPOINT,
                    headers: {
                        "authorization": _bearerToken
                    },
                    data: JSON.stringify(_payload),
                    success: "success",
                    dataType: "json",
                    async: false
                };
                var _requestTableHTML = $.ajax(_options);
                var _minifiedHTML2 = _requestTableHTML.responseJSON || null;
                this._pasteCodeToHiddenTextarea(_minifiedHTML2);
                return _minifiedHTML2;
            } else if (espName === "sfmc") {
                var _token2 = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token");
                var _bearerToken2 = "Bearer " + _token2;
                var _payload2 = {
                    tableHelper: {
                        screenshotURL: screenshotURL,
                        tableJSON: tableJSON,
                        width: experience.get("width"),
                        height: experience.get("height")
                    },
                    userHTML: userHTML
                };
                var SFMC_API_ENDPOINT = Configuration.sfmcApiUrl;
                var _options2 = {
                    type: "POST",
                    url: SFMC_API_ENDPOINT,
                    headers: {
                        "authorization": _bearerToken2
                    },
                    data: JSON.stringify(_payload2),
                    success: "success",
                    dataType: "json",
                    async: false
                };
                var _requestTableHTML2 = $.ajax(_options2);
                var _minifiedHTML3 = _requestTableHTML2.responseJSON || null;
                this._pasteCodeToHiddenTextarea(_minifiedHTML3);
                return _minifiedHTML3;
            }

            var tableHTML = new EmailRenderer({
                screenshotURL: screenshotURL,
                tableJSON: tableJSON,
                width: experience.get("width"),
                height: experience.get("height")
            }).render();
            var minifiedHTML = "<!DOCTYPE html PUBLIC \"-//W3C//DTD XHTML 1.0 Transitional//EN\" \"http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd\">" + this._minifyCode(tableHTML.el.outerHTML);
            this._pasteCodeToHiddenTextarea(minifiedHTML);
            return minifiedHTML;
        },
        _minifyCode: function _minifyCode(code) {
            return String(code).replace(/>[\r\n ]+</g, "><").replace(/(<.*?>)|\s+/g, function (m, $1) {
                return $1 || " ";
            }).trim();
        },

        /**
         * Need this for QA purposes
         * @param code
         * @private
         */
        _pasteCodeToHiddenTextarea: function _pasteCodeToHiddenTextarea(code) {
            var input = document.getElementById("emailHtmlSourceCode");
            if (!input) {
                input = document.createElement("TEXTAREA");
                input.setAttribute("id", "emailHtmlSourceCode");
                input.setAttribute("style", "position:absolute; bottom:0; left: -9999px; max-width:300px;");
                document.getElementsByTagName("body")[0].appendChild(input);
            }
            input.value = code;
        },
        _generateJson: function _generateJson(screenshotURL, widgets) {
            var _this2 = this;

            var experience = this.get("_experience");
            var imageSlicer = ImageSlicer(widgets, experience.get("height"), experience.get("width"), true);
            var tableJSON = imageSlicer.slice();
            tableJSON.forEach(function (tr) {
                tr.forEach(function (td) {
                    var top = td.top,
                        left = td.left,
                        width = td.width,
                        height = td.height,
                        isSpacer = td.isSpacer;

                    if (!isSpacer) {
                        td.img = _this2._crop({
                            top: top, left: left, width: width, height: height, originalURL: screenshotURL
                        });
                    }
                });
            });
            return tableJSON;
        },
        _crop: function _crop(_ref) {
            var top = _ref.top,
                left = _ref.left,
                width = _ref.width,
                height = _ref.height,
                originalURL = _ref.originalURL;

            var url = new URL(originalURL);

            var _url$pathname$split = url.pathname.split("/"),
                _url$pathname$split2 = _toArray(_url$pathname$split),
                startString = _url$pathname$split2[0],
                type = _url$pathname$split2[1],
                method = _url$pathname$split2[2],
                signature = _url$pathname$split2[3],
                fillParams = _url$pathname$split2[4],
                rest = _url$pathname$split2.slice(5);

            var cropParams = "c_crop,x_" + left + ",y_" + top + ",w_" + width + ",h_" + height;
            url.pathname = [startString, type, method, signature, fillParams, cropParams].concat(_toConsumableArray(rest)).join("/");
            return url.href;
        },


        defaults: {
            screenshotURL: null,
            tableJSON: [],
            tableHTML: null,
            sizeWarning: false
        }
    });

    return EmailSliceModel;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @see https://confluence.zmags.com/display/EN/Image+slicing+script
 *
 * @param widgets - array of objects: {
 *     top,left,width,height
 * }
 * @param imageHeight - image canvas height
 * @param imageWidth - image canvas width
 * @param addSpacer - add extra cell for each column and row. We need it for rendering email HTML properly
 * @returns {{slice: (function(): [])}}
 */



function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

module.exports = {
    ImageSlicer: ImageSlicer
};

function ImageSlicer(widgets, imageHeight, imageWidth, addSpacer) {
    return function () {
        var PAGE_TOP_Y = 0;
        var PAGE_TOP_X = 0;
        var filteredWidgets = _filterInappropriateWidgets(widgets);
        var sortedWidgetsByY = [].concat(_toConsumableArray(filteredWidgets)).sort(function (a, b) {
            return a.top - b.top;
        });
        var sortedWidgetsByX = [].concat(_toConsumableArray(filteredWidgets)).sort(function (a, b) {
            return a.left - b.left;
        });

        function _filterInappropriateWidgets(allWidgets) {
            var outWidgets = allWidgets.map(function (widget) {
                widget.left = Math.max(widget.left, 0);
                widget.top = Math.max(widget.top, 0);
                widget.width = widget.left + widget.width < imageWidth ? widget.width : Math.max(imageWidth - widget.left, 0);
                widget.height = widget.top + widget.height < imageHeight ? widget.height : Math.max(imageHeight - widget.top, 0);
                return widget;
            });

            return outWidgets.filter(function (w) {
                return w.height > 0 && w.width > 0;
            });
        }

        function _createBasicGrid() {
            function getCells(widgets, max, min, coordinate, measure) {
                var cells = [];
                var lines = new Set();
                lines.add(min).add(max);
                widgets.forEach(function (w) {
                    return lines.add(w[coordinate]).add(w[coordinate] + w[measure]);
                });
                var linesArr = Array.from(lines).sort(function (a, b) {
                    return a - b;
                });
                for (var i = 0; i < linesArr.length - 1; i++) {
                    var _cells$push;

                    cells.push((_cells$push = {}, _defineProperty(_cells$push, coordinate, linesArr[i]), _defineProperty(_cells$push, measure, linesArr[i + 1] - linesArr[i]), _cells$push));
                }
                return cells;
            }
            var rows = getCells(sortedWidgetsByY, imageHeight, PAGE_TOP_Y, "top", "height");
            var cols = getCells(sortedWidgetsByY, imageWidth, PAGE_TOP_X, "left", "width");
            return { rows: rows, cols: cols };
        }

        function _range(start, count) {
            return Array.apply(0, Array(count)).map(function (element, index) {
                return index + start;
            });
        }
        function _isSpanned(table, td, rowIndex, colIndex) {
            var cellSpannedAbove = !!table.find(function (row) {
                return row.find(function (_ref) {
                    var _ref$rowspanIndexes = _ref.rowspanIndexes,
                        rowspanIndexes = _ref$rowspanIndexes === undefined ? [] : _ref$rowspanIndexes,
                        _ref$colspanIndexes = _ref.colspanIndexes,
                        colspanIndexes = _ref$colspanIndexes === undefined ? [] : _ref$colspanIndexes;

                    return rowspanIndexes.includes(rowIndex) && colspanIndexes.includes(colIndex);
                });
            });
            var cellSpannedSameRow = !!td.find(function (_ref2) {
                var _ref2$colspanIndexes = _ref2.colspanIndexes,
                    colspanIndexes = _ref2$colspanIndexes === undefined ? [] : _ref2$colspanIndexes;
                return colspanIndexes.includes(colIndex);
            });
            return cellSpannedAbove || cellSpannedSameRow;
        }

        function slice() {
            var _createBasicGrid2 = _createBasicGrid(),
                rows = _createBasicGrid2.rows,
                cols = _createBasicGrid2.cols;

            var table = [];
            var widgetsByY = sortedWidgetsByY;
            var widgetsByX = sortedWidgetsByX;
            if (addSpacer) {
                var td = [];
                td.push({
                    width: 1,
                    height: 1,
                    isSpacer: true
                });
                cols.forEach(function (_ref3) {
                    var width = _ref3.width;

                    td.push({
                        width: width,
                        height: 1,
                        isSpacer: true
                    });
                });
                table.push(td);
            }
            rows.forEach(function (_ref4, rowIndex) {
                var rowTop = _ref4.top,
                    rowHeight = _ref4.height;

                var td = [];
                var colSpan = 0;
                var rowSpan = 0;
                var colspanIndexes = [];
                var rowspanIndexes = [];
                if (addSpacer) {
                    td.push({
                        width: 1,
                        height: rowHeight,
                        isSpacer: true
                    });
                }
                cols.forEach(function (_ref5, colIndex) {
                    var colLeft = _ref5.left;

                    var cellProps = {};
                    var isCellCollapsed = _isSpanned(table, td, rowIndex, colIndex);
                    if (isCellCollapsed) return;

                    var widget = widgetsByY.find(function (w) {
                        return w.left === colLeft && w.top === rowTop;
                    });
                    if (widget) {
                        var colSpanIndexTo = cols.findIndex(function (col) {
                            return col.left === widget.left + widget.width;
                        });
                        var rowSpanIndexTo = rows.findIndex(function (row) {
                            return row.top === widget.top + widget.height;
                        });
                        colSpanIndexTo = colSpanIndexTo > -1 ? colSpanIndexTo : cols.length;
                        rowSpanIndexTo = rowSpanIndexTo > -1 ? rowSpanIndexTo : rows.length;
                        colSpan = colSpanIndexTo - colIndex;
                        rowSpan = rowSpanIndexTo - rowIndex;
                        colspanIndexes = _range(colIndex, colSpan);
                        rowspanIndexes = _range(rowIndex, rowSpan);
                        cellProps = widget;
                    } else {
                        // #### Right extreme
                        var colIsWidget = false;
                        var colIsCollapsed = false;

                        var _loop = function _loop(j) {
                            var left = cols[j].left;

                            colIsWidget = !!widgetsByX.find(function (w) {
                                return w.left === left && w.top === rowTop;
                            });
                            colIsCollapsed = _isSpanned(table, td, rowIndex, j);
                            if (!colIsWidget && !colIsCollapsed) {
                                colspanIndexes.push(j);
                            } else {
                                return "break";
                            }
                        };

                        for (var j = colIndex; j <= cols.length - 1; j++) {
                            var _ret = _loop(j);

                            if (_ret === "break") break;
                        }

                        // #### Bottom extreme
                        var rightBreakpoint = Math.max.apply(Math, _toConsumableArray(colspanIndexes));
                        var localRightExtreme = cols[rightBreakpoint].left + cols[rightBreakpoint].width;
                        var closestBottomWidget = widgetsByY.find(function (w) {
                            return w.top >= rowTop + rowHeight && (w.left > colLeft && w.left < localRightExtreme || w.left + w.width > colLeft && w.left + w.width < localRightExtreme || w.left <= colLeft && w.left + w.width >= localRightExtreme);
                        });
                        var _rowSpanIndexTo = closestBottomWidget ? rows.findIndex(function (row) {
                            return row.top === closestBottomWidget.top;
                        }) : rows.length;

                        rowSpan = _rowSpanIndexTo - rowIndex;
                        rowspanIndexes = _range(rowIndex, rowSpan);
                        cellProps = {
                            top: rowTop,
                            left: colLeft,
                            height: rows[_rowSpanIndexTo - 1].top + rows[_rowSpanIndexTo - 1].height - rowTop,
                            width: cols[rightBreakpoint].left + cols[rightBreakpoint].width - colLeft
                        };
                    }

                    td.push(Object.assign({
                        isWidget: !!widget,
                        rowSpan: rowspanIndexes.length,
                        colSpan: colspanIndexes.length,
                        rowspanIndexes: rowspanIndexes,
                        colspanIndexes: colspanIndexes
                    }, cellProps));
                    colspanIndexes = [];
                    rowspanIndexes = [];
                });

                table.push(td);
            });

            return table;
        }
        return { slice: slice };
    }(widgets, imageHeight, imageWidth);
}

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        template = __webpack_require__(2927),
        MetaData = __webpack_require__(2928),
        configuration = __webpack_require__(27),
        util = __webpack_require__(46),
        _require = __webpack_require__(2930),
        arrayFlat = _require.arrayFlat,
        getOpacityCssClass = _require.getOpacityCssClass;


    var TRANSPARENT_IMG_URL = "https://creator.zmags.com/images/transparent.png";

    return ImprovedView.extend({
        tagName: "html",
        attributes: {
            "xmlns": "http://www.w3.org/1999/xhtml",
            "xmlns:o": "urn:schemas-microsoft-com:office:office"
        },
        template: template,

        templateHelpers: function templateHelpers() {
            return Object.assign({
                getOpacityCssClass: getOpacityCssClass,
                cloudinaryUrl: this._getCloudinaryUrl(),
                util: util,
                transparentImg: TRANSPARENT_IMG_URL
            }, this.options);
        },


        regions: {
            head: "head"
        },

        onRender: function onRender() {
            this.head.show(new MetaData(this.renderStyles(this.options.tableJSON)));
        },
        renderStyles: function renderStyles(data) {
            var styles = new Set();
            var gmailStyles = new Set();
            var flatData = arrayFlat(data);
            flatData.filter(function (td) {
                return td.hoverOpacity;
            }).forEach(function (_ref) {
                var hoverOpacity = _ref.hoverOpacity;

                gmailStyles.add("u~div table.gmail_w td." + getOpacityCssClass(hoverOpacity) + ":hover{opacity:" + hoverOpacity + ";}");
                styles.add("td." + getOpacityCssClass(hoverOpacity) + ":hover{filter: contrast(" + hoverOpacity / (2 - hoverOpacity) + ") brightness(" + (2 - hoverOpacity) + ");}");
            });

            var _ref2 = flatData.find(function (td) {
                return td.hoverToggleImage;
            }) || {},
                _ref2$hoverToggleImag = _ref2.hoverToggleImage,
                hoverToggleImage = _ref2$hoverToggleImag === undefined ? null : _ref2$hoverToggleImag;

            if (hoverToggleImage) {
                styles.add(".rollover:hover img {display:block !important;}");
            }
            return {
                styles: Array.from(styles).join(""),
                gmailStyles: Array.from(gmailStyles).join("")
            };
        },
        _getCloudinaryUrl: function _getCloudinaryUrl() {
            var pattern = new RegExp("^(http|https)://", "i");
            return pattern.test(configuration.cloudinaryProviderUrl) ? configuration.cloudinaryProviderUrl : "https:" + configuration.cloudinaryProviderUrl;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2927 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<body>\n<table role="presentation" class="zmags_w" width="100%">\n    <tr>\n        <td>\n            <img src="' +
((__t = (transparentImg)) == null ? '' : __t) +
'" width="1" height="1" style="width: 1px; height: 1px;">\n            <table role="presentation" align="center" class="gmail_w" background="' +
((__t = (screenshotURL)) == null ? '' : __t) +
'" style="width:' +
((__t = (width+1)) == null ? '' : __t) +
'px;height:' +
((__t = (height+1)) == null ? '' : __t) +
'px;border:0;border-collapse:collapse; background-image: url(\'' +
((__t = (screenshotURL)) == null ? '' : __t) +
'\');background-size: 100% 100%;" cellpadding="0" cellspacing="0" border="0">\n                <tbody>\n                ';
 _.each(tableJSON, function(row) {
                        ;
__p += '<tr>';
 _.each(row, function(td, i) {
                                ;

 var opacity = getOpacityCssClass(td.hoverOpacity);
__p += '\n                                    <td\n                                        width="' +
((__t = (td.width)) == null ? '' : __t) +
'"\n                                        height="' +
((__t = (td.height)) == null ? '' : __t) +
'"\n                                        valign="top"\n                                        ';
 if (td.img) {
                                        ;
__p += 'background="' +
((__t = (td.img)) == null ? '' : __t) +
'"';
};
__p += '\n                                        ';
 if (td.rowSpan>1) {
                                        ;
__p += 'rowspan="' +
((__t = (td.rowSpan)) == null ? '' : __t) +
'"';
};
__p += '\n                                        ';
 if (td.colSpan>1) {
                                            ;
__p += 'colspan="' +
((__t = (td.colSpan)) == null ? '' : __t) +
'"';
};
__p += '\n                                        ';
 if (opacity) {
                                            ;
__p += 'class="' +
((__t = (opacity)) == null ? '' : __t) +
'"';
};
__p += '\n                                        style="background-size: 100% 100%;';
 if (td.width) { ;
__p += 'width:' +
((__t = (td.width)) == null ? '' : __t) +
'px;';
};
__p += ' ';
 if (td.height) { ;
__p += 'height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;';
};
__p += 'border-collapse:collapse;mso-line-height-rule:exactly;line-height:25%;"\n                                    >\n                                    ';
 if (td.img) {
                                        ;
__p += '<!--[if mso]>\n                                        ';
if(td.actionUrl){;
__p += '\n                                               <table width="' +
((__t = (td.width)) == null ? '' : __t) +
'" style="border-collapse:collapse;" cellpadding="0" cellspacing="0" border="0">\n                                                   <tr style="display:grid;max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;float:left;">\n                                                       <td><a\n                                                            ';
if(td.type==="button"){;
__p += ' role="button" ';
};
__p += '\n                                                            ';
if(td.altText){;
__p += ' aria-label="' +
((__t = (td.altText)) == null ? '' : __t) +
'"';
};
__p += '\n                                                            ';
if(td.label){;
__p += ' title="' +
((__t = (td.label)) == null ? '' : __t) +
'"';
};
__p += '\n                                                            href="' +
((__t = (td.actionUrl)) == null ? '' : __t) +
'" target="_blank">\n                                                                <img width="100%" alt src="' +
((__t = (td.img)) == null ? '' : __t) +
'" />\n                                                            </a>\n                                                       </td>\n                                                   </tr>\n                                               </table>\n                                        ';
}else{;
__p += '\n                                           <v:image xmlns:v="urn:schemas-microsoft-com:vml" style="behavior:url(#default#VML);display:block;position:absolute;width:' +
((__t = (td.width+0.13)) == null ? '' : __t) +
'px;height:' +
((__t = (td.height+0.13)) == null ? '' : __t) +
'px;top:0;left:0;" src="' +
((__t = (td.img)) == null ? '' : __t) +
'"/>\n                                        ';
};
__p += '\n                                        <![endif]-->';
}
                                    ;
__p += '\n                                    <!--[if !mso]><!-- -->\n                                    ';
if(td.actionUrl){;
__p += '\n                                        <a\n                                        ';
if(td.type==="button"){;
__p += ' role="button" ';
};
__p += '\n                                        ';
if(td.altText){;
__p += ' aria-label="' +
((__t = (td.altText)) == null ? '' : __t) +
'"';
};
__p += '\n                                        ';
if(td.label){;
__p += ' title="' +
((__t = (td.label)) == null ? '' : __t) +
'"';
};
__p += '\n                                        style="display:block;width:' +
((__t = (td.width)) == null ? '' : __t) +
'px; height:' +
((__t = (td.height)) == null ? '' : __t) +
'px; max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;" ';
if(td.hoverToggleImage){;
__p += 'class="rollover"';
};
__p += ' href="' +
((__t = (td.actionUrl)) == null ? '' : __t) +
'">\n                                        ';
}
                                            else if(td.hoverToggleImage){;
__p += '<span style="display:block;width:' +
((__t = (td.width)) == null ? '' : __t) +
'px; height:' +
((__t = (td.height)) == null ? '' : __t) +
'px; max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;" class="rollover">';
};
__p += '\n                                            <div style="width:' +
((__t = (td.width)) == null ? '' : __t) +
'px; height:' +
((__t = (td.height)) == null ? '' : __t) +
'px; max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;">\n                                                ';
if(td.hoverToggleImage){;
__p += '\n                                                    <img style="max-height:' +
((__t = (td.height)) == null ? '' : __t) +
'px; display:none; width:' +
((__t = (td.width+0.15)) == null ? '' : __t) +
'px;height:' +
((__t = (td.height)) == null ? '' : __t) +
'px;border:0;"\n                                                        src="' +
((__t = (cloudinaryUrl)) == null ? '' : __t) +
'/f_auto,q_auto/' +
((__t = (util.getFileNameWithExtension(td.hoverToggleImage))) == null ? '' : __t) +
'"\n                                                        alt=""\n                                                    />\n                                                ';
};
__p += '\n                                            </div>\n                                        ';
if(td.actionUrl){;
__p += '</a>';
}
                                        else if(td.hoverToggleImage){;
__p += '</span>';
};
__p += '\n                                    <![endif]-->\n                                    </td>';
});
                        ;
__p += '</tr>';
});
                ;
__p += '</tbody>\n            </table>\n        </td>\n    </tr>\n</table>\n</body>\n';

}
return __p
}

/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        template = __webpack_require__(2929);

    return Backbone.View.extend({
        template: template,
        render: function render() {
            this.el = this.template({
                styles: this.options.styles,
                gmailStyles: this.options.gmailStyles
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2929 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<head>\n<title></title>\n<meta charset="UTF-8">\n<meta content=\'width=device-width; initial-scale=1.0;\' name=\'viewport\' />\n<meta name="x-apple-disable-message-reformatting">\n<meta http-equiv="X-UA-Compatible" content="IE=edge">\n<meta content="telephone=no" name="format-detection">\n<style type="text/css">\ntable,td{background-size: 100% 100%;}\nu~div table.gmail_w {background-image:none!important;}\ndiv.templateContainerInner > table, div.templateContainerInner .zmags_w{width:auto;}\n' +
((__t = (gmailStyles)) == null ? '' : __t) +
'\n' +
((__t = (styles)) == null ? '' : __t) +
'\n</style>\n<!--[if gte mso 9]>\n<xml>\n    <o:OfficeDocumentSettings>\n        <o:AllowPNG/>\n        <o:PixelsPerInch>96</o:PixelsPerInch>\n    </o:OfficeDocumentSettings>\n</xml>\n<![endif]-->\n</head>\n';

}
return __p
}

/***/ }),
/* 2930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOpacityCssClass", function() { return getOpacityCssClass; });
/* harmony export (immutable) */ __webpack_exports__["arrayFlat"] = arrayFlat;
var getOpacityCssClass = function (opacity) {
    return opacity ? "opacity-" + opacity.toString().split('.').join('') : null;
};
function arrayFlat(arr) {
    if (arr.every(function (val) { return !Array.isArray(val); })) {
        return arr.slice();
    }
    return arr
        .reduce(function (acc, val) { return acc
        .concat(Array.isArray(val) ? arrayFlat(val) : val); }, []);
}


/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var ShareRecipientCollection = __webpack_require__(1225);
    var SendEmail = __webpack_require__(2932);
    var EMAIL_STATES = __webpack_require__(209);

    /**
     * The view model for sending test emails.
     *
     * @class RecipientsPopupModel
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            state: EMAIL_STATES.CLOSE,
            recipients: null
        },

        initialize: function initialize() {
            this._reset();
            this.listenTo(this, "change:state", this._stateChangeHandler);
        },

        _reset: function _reset() {
            this.set({
                recipients: new ShareRecipientCollection()
            });
        },

        _onGetActionWidgetsBoundingBoxes: function _onGetActionWidgetsBoundingBoxes(widgetBoxes) {
            var _this = this;

            this.set({ state: EMAIL_STATES.PROCESSING_EMAIL });
            this.get("emailSliceModel").fetch({ widgets: widgetBoxes }).then(function (model) {
                var toAddresses = new Set();
                _this.get("recipients").each(function (recipient) {
                    if (recipient.get("email") && recipient.get("selected")) {
                        toAddresses.add(recipient.get("email"));
                    }
                });
                var sender = new SendEmail({
                    companyId: _this.get("experienceModel").get("companyId"),
                    htmlBody: model.get("tableHTML"),
                    toAddresses: Array.from(toAddresses).join(","),
                    subjectLine: _this.get("subjectLine")
                });
                sender.save().then(function () {
                    return model.get("sizeWarning") ? _this.set({ state: EMAIL_STATES.SENT_EMAIL_WITH_SIZE_WARNING }) : _this.set({ state: EMAIL_STATES.SENT_EMAIL });
                }, function () {
                    return _this.set({ state: EMAIL_STATES.ERROR_EMAIL });
                });
            }, function () {
                return _this.set({ state: EMAIL_STATES.ERROR_EMAIL });
            });
        },


        _stateChangeHandler: function _stateChangeHandler() {
            if (this.get("state") === EMAIL_STATES.SEND_EMAIL) {
                var scenes = this.get("experienceModel").get("scenes");
                scenes.trigger("getEmailActionWidgetsBoundingBoxes", this._onGetActionWidgetsBoundingBoxes.bind(this));
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);
    var RestApi = __webpack_require__(29);
    var SyncManager = __webpack_require__(44);

    /**
     *
     * @class SendEmail
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            companyId: 0,
            toAddresses: "",
            htmlBody: "",
            fromPrettyName: "Zmags",
            subjectLine: undefined
        },

        url: function url() {
            var companyId = this.get("companyId");
            var fromPrettyName = this.get("fromPrettyName");
            var toAddresses = this.get("toAddresses");
            var subjectLine = this.get("subjectLine") ? this.get("subjectLine").trim() : "Zmags - Test shoppable Email";

            var constructedUrl = new URL(RestApi.PROXY_URL + "/" + RestApi.Collections.EXPERIENCE_EMAIL_SEND);
            constructedUrl.search = new URLSearchParams([["companyId", companyId], ["fromPrettyName", fromPrettyName], ["toAddresses", toAddresses], ["subjectLine", subjectLine]]).toString();
            return constructedUrl.href;
        },


        /**
         * Normally we do not need override Backbone save method, but here is something specific:
         * 1) all model attrs except tableHTML should be passed by query params
         * 2) tableHTML should be passed as text/html directly to the request body
         *
         * @returns {Promise}
         */
        save: function save() {
            return SyncManager.sync({
                method: "post",
                promise: true,
                fn: {
                    url: this.url(),
                    type: "POST",
                    contentType: "text/html",
                    data: this.get("htmlBody")
                },
                resultHandler: function resultHandler(response) {
                    return response;
                },
                errorHandler: function errorHandler(err) {
                    return err;
                }
            }).promise();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var template = __webpack_require__(2934),
        ShareMenu = __webpack_require__(1222),
        ShareRecipient = __webpack_require__(715),
        LoggedInUserState = __webpack_require__(19);

    /**
     * Component representing the Send Test Email button for the <tt>SendTestEmailButtonView</tt>.
     *
     * @see SendTestEmailButtonView
     *
     * @class TestEmailRecipientsView
     *
     * @extends ShareMenu
     */
    var TestEmailRecipientsView = ShareMenu.extend({
        template: template,

        modelEvents: {
            "change:recipients": "_updateValidationStates"
        },
        bindings: {
            "textarea": "subjectLine"
        },

        onRender: function onRender() {
            this.__super();
            this._addCurrentUserToRecipients();
        },


        _addCurrentUserToRecipients: function _addCurrentUserToRecipients() {
            var currentUserEmail = LoggedInUserState.get("user").get("username");
            if (!this._getExistingRecipient(currentUserEmail)) {
                this.model.get("recipients").add(new ShareRecipient({
                    user: LoggedInUserState.get("user"),
                    email: currentUserEmail,
                    selected: true
                }));
            }
        },

        _updateValidationStates: function _updateValidationStates() {
            // OK button on choose recipients
            // Send button on main view
            if (this._getSelectedRecipientNames()) {
                this.ui.recipientsOkButton.addClass("enabled");
                this.ui.sendButton.addClass("enabled");
            } else {
                this.ui.recipientsOkButton.removeClass("enabled");
                this.ui.sendButton.removeClass("enabled");
            }
        },

        _getExistingRecipient: function _getExistingRecipient(email) {
            return this.model.get("recipients").find(function (recipient) {
                return recipient.get("email") === email || recipient.get("user") && recipient.get("user").get("username") === email;
            });
        },

        /**
         * @override
         * @protected
         *
         * TODO take a look more detailed. Probably make sense to split parent function...
         */
        _addRecipient: function _addRecipient() {
            var email = this._validateInviteEmail();
            if (!email) {
                return;
            }

            // Add the recipient, unless it already exists
            var existingRecipient = this._getExistingRecipient(email);

            if (existingRecipient) {
                existingRecipient.set("selected", true);
            } else {
                this.model.get("recipients").add(new ShareRecipient({ email: email, selected: true }));
                this.ui.recipientsList.scrollTop(this.ui.recipientsList.prop("scrollHeight"));
            }

            // Reset the button
            this.ui.recipientsAddButton.show();
            this.ui.recipientsAddInputContainer.css("visibility", "hidden");
            this.ui.recipientsAddInput.val("");
        },

        /**
         * @override
         * @protected
         */
        _send: function _send() {
            var recipientNames = this._getSelectedRecipientNames();
            if (recipientNames) {
                this.model.set("state", 2);
            }
        }
    });
    return TestEmailRecipientsView;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2934 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="header">Send test email to:</div>\n<div class="choose-recipients">\n    <button type="button" class="choose-recipients-header collapsible" data-toggle="collapse" data-target="#choose-recipients-body-container">Add people from list:</button>\n    <div id="choose-recipients-body-container" class="collapse-target collapse">\n        <div class="choose-recipients-body">\n            <div class="choose-recipients-list-region"></div>\n            <div class="choose-recipients-add">\n                <button class="choose-recipients-add-button btn">Add other emails</button>\n                <div class="choose-recipients-add-input-container">\n                    <div class="choose-recipients-add-input-wrapper">\n                        <input type="text" placeholder="Type email address"/>\n                        <div class="choose-recipients-add-ok"></div>\n                    </div>\n                </div>\n                <div class="choose-recipients-add-disclaimer">\n                    Add any valid email address\n                </div>\n            </div>\n            <div class="footer">\n                <div class="choose-recipients-ok">OK</div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="message">\n    <div class="recipients-list"></div>\n    <div class="body-spacer"></div>\n    <textarea class="body" placeholder="Type the subject"></textarea>\n</div>\n<div class="footer">\n    <div class="share-send"><button class="btn">Send</button></div>\n    <div class="share-divider">|</div>\n    <div class="share-cancel">Cancel</div>\n</div>\n';

}
return __p
}

/***/ }),
/* 2935 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isNewDashboardExperience) {;
__p += '\n    <button class="preview-publish-btn btn btn-primary ">Preview & Publish</button>\n';
} else { ;
__p += ' \n    <button class="preview-btn btn btn-primary">Preview</button>\n';
 } ;
__p += '\n<div class="push-publish-btn-region"></div>\n';
 if (isEmailInCreatorEnabled) { ;
__p += '\n    <div class="toggle-email-mode-region"></div>\n    <div class="send-test-email-btn-region"></div>\n';
 } ;
__p += '\n<div class="editor-more-menu"></div>\n';

}
return __p
}

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Configuration = __webpack_require__(27);

    var _require = __webpack_require__(120),
        DateUtil = _require.DateUtil;

    var EditorEvents = __webpack_require__(17);
    var ErrorAction = __webpack_require__(560);
    var ErrorHandler = __webpack_require__(119);
    var GroupUtil = __webpack_require__(306);
    var ImprovedView = __webpack_require__(6);
    var Ladda = __webpack_require__(340); // for spinner
    var LoggedIn = __webpack_require__(31);
    var LoggedInUserState = __webpack_require__(19);

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var NotificationBar = __webpack_require__(53);
    var Promise = __webpack_require__(21);
    var PublishableState = __webpack_require__(65);
    var Syncer = __webpack_require__(50);
    var template = __webpack_require__(2937);
    var Time = __webpack_require__(121);
    var Tooltip = __webpack_require__(35);
    var User = __webpack_require__(261);
    var UserCollection = __webpack_require__(184);
    var Window = __webpack_require__(48);
    var CopyEmailButtonView = __webpack_require__(2938);

    var _require3 = __webpack_require__(530),
        COPY_CODE_BUTTON_STATE = _require3.COPY_CODE_BUTTON_STATE,
        BUTTON_STATUS = _require3.BUTTON_STATUS;

    var Storage = __webpack_require__(34);
    var $ = __webpack_require__(4);

    // Short-cut...
    var Actions = ErrorHandler.Actions;

    /**
     * View for the experience sync state in the editor. <p>
     *
     * The view consists of the sync state as text that will change according to the experience sync (save) state,
     * e.g. "Unsaved", "Saving" and "Saved".
     *
     * The view also has a tooltip with additional information, such as the actual timestamp for last edited at
     * and optional last push date if published. <p>
     *
     * The view is clickable on certain types of errors: to reload or to manually try and save the experience again.
     * Reload will be an option on for example versioning conflicts since the experience can never be saved in that
     * case. Retry is an option if we got an error deemed temporary in nature, though that may not be the case, and
     * the user can thus try a manual save. Such clicks will be tracked via StatsD as "experience.user.reload" and
     * "experience.user.save", respectively. <p>
     *
     * This view will listen for unhandled global errors and update this view accordingly based on the current
     * state of the experience; it will not report them elsewhere. <p>
     *
     * The view is the same regardless of user role, since an experience can only be saved with
     * a proper role; if not, the last edited time is merely presented.
     *
     * @class ExperienceSyncStateView
     * @constructor
     *
     * @cfg {ExperienceModel} model The experience model for the editor.
     *
     * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
     */
    return ImprovedView.extend({

        template: template,
        _isEmailInCreatorEnabled: false,
        _isEnhancedCopyCodeEnabled: false,

        /**
         * @private @type {{off:Function}}
         * Hook to remove global error handler on close.
         */
        _errorHandler: null,
        /**
         * @private @type {Number}
         * Timer to update last sync time so it "ticks".
         */
        _syncStateTimer: null,
        /**
         * @private @type {Boolean}
         * True if the experience is currently being synced (saved).
         */
        _syncing: null,
        /**
         * @private @type {String}
         * The last sync state read by this view.
         */
        _lastSyncState: null,
        /**
         * @private @type {Number}
         * Server time for last edit time in ms since the epoch.
         */
        _editedAt: null, // server time
        /**
         * @private @type {Ladda}
         * Spinner activated while a sync is pending. <p>
         *
         * By default activated, but can be disabled by setting <tt>options.spinner</tt> to false.
         */
        _spinner: null,

        modelEvents: {
            "sync:state": "_syncState" // update this view when "sync:state" is triggered
        },

        events: {
            "click @ui.getCode": "_handleGetCodeClick",
            "click @ui.syncState": "_handleSyncStateClick",
            "click @ui.getEnhancedCode": "_handleGetEnhancedCodeClick"
        },

        ui: {
            spinner: ".spinner",
            glyphicon: ".glyphicon",
            syncState: ".sync-state",
            getCode: ".get-code-btn",
            copyCodeBtn: ".copy-code-btn",
            getEnhancedCode: ".get-enhanced-code",
            getCodeIndicator: ".indicator",
            getCodePayload: ".get-code-container input[type=text]"
        },

        regions: {
            copyEmailButtonRegion: ".copy-email-btn-region"
        },

        templateHelpers: function templateHelpers() {
            return {
                isEmailInCreatorEnabled: this._isEmailInCreatorEnabled,
                isEnhancedCopyCodeEnabled: this._isEnhancedCopyCodeEnabled,
                isNewDashboardExperience: this.model.get("id").startsWith('C3_')
            };
        },

        /**
         * @private
         * Clears the timer used to update this view, i.e. make the "last edited" time tick.
         */
        _clearSyncTimer: function _clearSyncTimer() {
            if (this._syncStateTimer) {
                clearTimeout(this._syncStateTimer);
                this._syncStateTimer = null;
            }
        },
        _getEnhancedCopyCodeFlag: function _getEnhancedCopyCodeFlag() {
            try {
                var companyId = LoggedInUserState.attributes.company.id,
                    settingName = "isEnhancedCopyCodeEnabled",
                    endpointUrl = Configuration.creatorSettingApiBaseUrl + "/v1/settings/" + companyId + "?name=" + settingName,
                    token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"),
                    bearerToken = "Bearer " + token;
                var options = {
                    method: "GET",
                    url: endpointUrl,
                    headers: {
                        "Authorization": bearerToken
                    },
                    success: "success",
                    dataType: "json",
                    async: false
                };

                var requestTableHTML = $.ajax(options);
                var response = requestTableHTML.responseJSON || null;
                return response.isEnhancedCopyCodeEnabled;
            } catch (error) {
                return false;
            }
        },
        _getIsCopyCodeButtonEnabled: function _getIsCopyCodeButtonEnabled() {
            var isReflowPreventionEnabled = LoggedInUserState.get("companySettings").get("enableCNCReflowPreventionOutput");
            var copyCodeButtonState = this.model.get(COPY_CODE_BUTTON_STATE);
            if (!isReflowPreventionEnabled || !copyCodeButtonState) return true;
            return copyCodeButtonState === BUTTON_STATUS.enabled;
        },
        _getCodeIsEnabled: function _getCodeIsEnabled() {
            return this._getIsCopyCodeButtonEnabled() && this.model.hasAtLeastState(PublishableState.PUSHED) && !!this.model.get("cncOutput") && LoggedInUserState.get("integrations").isNativeContentIntegrationsEnabled() && !(this.model.syncState.current.method === "push" && this._syncing);
        },
        _handleGetCodeClick: function _handleGetCodeClick() {
            if (this._getCodeIsEnabled()) {
                this.ui.getCodePayload[0].value = this.model.get("cncOutput");
                // We can use the library select for this job.
                var copyText = document.querySelector(this.ui.getCodePayload.selector);
                copyText.select();
                document.execCommand("copy");
                NotificationBar.open("You have successfully copied this Experience snippet.");

                var eventProperties = {
                    experienceId: this.model.get("id"),
                    experienceVersion: this.model.get("version"),
                    experiencePushedVersion: this.model.get("pushedVersion"),
                    triggerOrigin: "CopyCodeButton"
                };

                EditorEvents.trigger(EditorEvents.constants.COPY_CODE, eventProperties);
            }
        },
        _handleGetEnhancedCodeClick: function _handleGetEnhancedCodeClick() {
            if (this._getCodeIsEnabled()) {
                var experienceType = LoggedInUserState.get("currentExperience").get("group") ? "groups" : "experiences";
                var id = experienceType === "groups" ? LoggedInUserState.get("currentExperience").get("group").resourceId : LoggedInUserState.get("currentExperience").get("id");
                this.ui.getCodePayload[0].value = "<script type=\"text/javascript\" src=\"" + {"env":"PROD","cncViewFullBaseUrl":"https://cnc-api.zmags.com/view/full/","cncViewLiteBaseUrl":"https://cnc-api.zmags.com/view/lite/","psdImportBaseUrl":"https://design-file-import.creator-prod.zmags.com","behaviorUiBaseUrl":"https://behaviors.zmags.com","creatorSettingApiBaseUrl":"https://creator-settings.api.zmags.com","c3ApibaseUrl":"https://contentcontrol.api.zmags.com","adminApiBaseUrl":"https://creator-api.zmags.com","editorBaseUrl":"//creator.zmags.com","viewerBaseUrl":"//c.zmags.com","viewerApiBaseUrl":"//c.zmags.com","cncStaticAssetsBaseUrl":"//c.zmags.com/static/","cncStaticAssetsFiles":["client.js","manifest.js","vendor.js","styles.css"],"cncSsrApiBaseUrl":"//c.zmags.com","viewerAliasApiBaseUrl":"//creator.zmags.com","communityBaseUrl":"https://creatorcommunity.zmags.com","errorQueueUrl":"https://c.zmags.com/queue/error/","statsDUrl":"https://statsd.zmags.com/stats","auth0Domain":"https://zmags.us.auth0.com","auth0Audience":"https://api.zmags.com/","auth0ClientId":"XGTeepJiX2c78VRgP8OFxN0Mf4kggvby","ometriaApiUrl":"https://ometria.api.zmags.com/v1/email/generate","klaviyoApiUrl":"https://klaviyo.api.zmags.com/v1/email/generate","sfmcApiUrl":"https://sfmc.api.zmags.com/v1/email/generate","cloudinaryProviderUrl":"https://images.creator-prod.zmags.com/image/upload","salesEmail":"sales@zmags.com","supportEmail":"support@zmags.com","editorSegmentIOKey":"20jbiv8frx","matomoConfig":{"trackingScriptUrl":"//c.z-analytics.net/reporting/optimize/ztracker.js","trackerUrl":"","dashboardUrl":"//auth.reporting.creator-prod.zmags.com","segmentUrl":"//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php","siteID":1},"zsitesConfig":"//auth.reporting.creator-prod.zmags.com/","zsitesSecret":"zM4gzS3cr3t","inventoryUrl":"https://authproxy.creator-prod.zmags.com/inventory/v1/products/map","answerFileUrl":"https://static.inventory.creator-prod.zmags.com/dynamic_pricing/answer_files/","experienceUrl2PngBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/experience/signed/url2png/","experienceSharedEntityBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/sharedEntity/","msExperiencesUrl":"https://authproxy.creator-prod.zmags.com/experiences","microserviceCompanyUrl":"https://authproxy.creator-prod.zmags.com/company/","proxyUrl":"https://authproxy.creator-prod.zmags.com","forgotPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","resetPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","changePasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithTokenBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithSsoBaseUrl":"https://authproxy.creator-prod.zmags.com","loginActiveDirectoryBaseUrl":"https://creator-api.zmags.com","googleWebFontsApiBaseUrl":"https://www.googleapis.com/webfonts/v1/webfonts","googleWebFontsApiKey":"AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI","casUrl":"https://cas.zma.gs/","contentControlUrl":"https://manage.creatorbyzmags.com/","enableLogging":1,"logId":null,"trackErrors":true,"sentryEnabled":true,"sentryDSN":"https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460","experienceId":null,"groupId":null,"scene":null,"statsDBucket":"creator.prod","version":"livadug4","maxRetries":3}.casUrl + LoggedInUserState.get("companySettings").get("companyId") + "/ssr/" + experienceType + "/" + id + "/init.js\"></script>";
                // We can use the library select for this job.
                var copyText = document.querySelector(this.ui.getCodePayload.selector);
                copyText.select();
                document.execCommand("copy");
                NotificationBar.open("You have successfully copied this Experience snippet.");

                var eventProperties = {
                    experienceId: this.model.get("id"),
                    experienceVersion: this.model.get("version"),
                    experiencePushedVersion: this.model.get("pushedVersion"),
                    triggerOrigin: "CopyCodeButton"
                };

                EditorEvents.trigger(EditorEvents.constants.COPY_CODE, eventProperties);
            }
        },
        _handleSyncStateClick: function _handleSyncStateClick() {
            // It is too confusing with many actions activated from here, so find one and use it...
            var action = this._action();
            if (action.indexOf(Actions.RELOAD) !== -1) {
                action = Actions.RELOAD;
            } else if (action.indexOf(Actions.RETRY) !== -1) {
                action = Actions.RETRY;
            } else if (action.indexOf(Actions.COMMUNITY) !== -1) {
                action = Actions.COMMUNITY;
            }
            ErrorAction.forModel(this.model, action)("experience");
            // Making sure the element does not act like an action element
            // as soon the action has started
            this.ui.syncState.removeClass("action");
        },


        /**
         * @private
         * Updates the sync state for this view, notified when the experience is synced *and* on uncaught errors. <p>
         *
         * Also updates this view accordingly if not closed.
         */
        _syncState: function _syncState() {
            this._clearSyncTimer();
            this.ui.glyphicon.hide();

            var text = "";
            var syncing = false;
            var spinner = void 0;
            var serverTime = void 0;
            var current = this.model.syncState.current;
            var state = current.state;
            var method = current.method;

            // Ignore "block" requests...
            if (method === "block") {
                return;
            }

            try {
                serverTime = Time.server();
            } catch (e) {
                NotificationBar.error({ message: e.message, action: "reload" }, { closeable: false, showCloseButton: false, alert: true });
                return;
            }

            switch (state) {// current: the save going on right now, if any
                case Syncer.State.Pending:
                case Syncer.State.Syncing:
                    spinner = true;
                    this.ui.syncState.addClass("spinning");
                    syncing = true;
                    // Since we know we do not delete from the editor where this view is used...
                    text = method.indexOf("fetch") === 0 ? "Loading" : "Saving"; // also "fetchAll"
                    break;

                case Syncer.State.Unsynced:
                case Syncer.State.Synced:
                    spinner = false;
                    this.ui.syncState.removeClass("spinning");
                    text = "Saved";
                    break;

                default:
                    spinner = false;
                    this.ui.glyphicon.show();
                    this.ui.syncState.removeClass("spinning");
                    text = "Unsaved";
                    break;
            }

            this._syncing = syncing;

            this._updateGetCodeState();

            // Update every minute henceforth, assuming not saved in the meantime, meaning we get a nice
            // "Last update X minutes ago" tick effect...
            if (this._updateSyncState(state, text, spinner, serverTime)) {
                this._syncStateTimer = setTimeout(this._syncState.bind(this), 1000 * 10); // every 10 seconds fine
            }

            // Save the sync state to avoid updating tooltip again and again on same unchanged state...
            this._lastSyncState = state;
        },


        /**
         * @private
         * Updates this view based on the calculated state, reflected in the supplied text. <p>
         *
         * The text supports the tokens ${editedAt} and ${timePassed}, which will be replaced with
         * the last edited time in server time; and the time passed user friendly formatted since last update.
         *
         * @param  {String}  state       The current sync state; never null.
         * @param  {String}  text        The text to update this view with; never null.
         * @param  {Boolean} [spinner]   True to start spinner, false to stop it, undefined do leave it as-is.
         * @param  {Date}    serverTime  The server's time in milliseconds, containing information from the a call to Time.server() method
         *
         * @return {Boolean} True if the sync state is updated (if view is not closed), false otherwise.
         */
        _updateSyncState: function _updateSyncState(state, text, spinner, serverTime) {
            // Only relevant when not closed, this is also called on error...
            if (this.isClosed) {
                return false;
            }

            // Make sure the user can see the view can be clicked if available for reload or manual save, but only
            // on failure state and if we have an action...
            if (state === Syncer.State.Failed && this._action()) {
                this.ui.syncState.addClass("action");
            } else {
                this.ui.syncState.removeClass("action");
            }

            var editedAt = this.model.getEditedAt(); // server time
            if (this._editedAt) {
                editedAt = this._editedAt; // server time
            }
            var timePassed = DateUtil.timeDifference(serverTime, editedAt);
            text = text.replace(/\${editedAt}/g, DateUtil.formatMMDDYYY(editedAt)).replace(/\${timePassed}/g, timePassed);

            this.ui.syncState.html(text);

            // Start/stop spinner?
            if (this._spinner && typeof spinner !== "undefined") {
                if (spinner) {
                    this._spinner.start();
                } else {
                    this._spinner.stop(0);
                }
            }

            // If the tooltip is currently open, we must update the contents if the state changed...
            if (state !== this._lastSyncState && Tooltip.shown(this.ui.syncState)) {
                Tooltip.show(this.ui.syncState);
            }

            return true;
        },


        /**
         * @private
         * Returns a state that dictates if it is meaningful for the user to try and do a manual save, a reload and
         * potentially lose data, or contact support (do nothing when clicking on this view).
         *
         * @return {String} The state, e.g. "reload", "retry", "community", or "support"; never null, but
         *                  will be empty on no error. Defined by <tt>ErrorHandler.Actions</tt>.
         */
        _action: function _action() {
            // Current error can be undefined if a request is pending, though an actual error may still be there...
            var error = this.model.syncState.current.error || this.model.syncState.actual.error;
            return error && error.action || "";
        },
        _updateGetCodeState: function _updateGetCodeState() {
            this.ui.copyCodeBtn.toggleClass("disabled", !this._getCodeIsEnabled());
            if (this.model.isChangedAfterPush()) {
                this.ui.getCodeIndicator.show();
            } else {
                this.ui.getCodeIndicator.hide();
            }
        },
        _updateGetCodeTooltip: function _updateGetCodeTooltip() {
            var copyCodeButtonState = this._getIsCopyCodeButtonEnabled();
            this.ui.copyCodeBtn.toggleClass("disabled", !this._getCodeIsEnabled());

            var messages = {
                pushedMessage: "Click this button to copy Experience code and paste it into your eCommerce platform to publish. Remember to Push all of your changes before copying your code!",
                notPushedMessage: "Please push your Experience at least once to copy your code.",
                pushInProgressMessage: "We are still pushing your latest changes, please wait a few seconds before copying your code to get the latest version"
            };

            var messageToShow = this.model.hasAtLeastState(PublishableState.PUSHED) ? messages.pushedMessage : messages.notPushedMessage;

            if (!copyCodeButtonState) {
                messageToShow = messages.pushInProgressMessage;
            }

            return "<span>" + messageToShow + "</span>";
        },


        /**
         * @private
         * Updates the tooltip for this view, automatically called after the state has changed. <p>
         *
         * Only called (via <tt>Tooltip</tt>) if <tt>this.options.showTooltip</tt> is true for this view instance.
         *
         * @return {String} The tooltip html.
         */
        _updateSyncStateTooltip: function _updateSyncStateTooltip() {
            var actual = this.model.syncState.actual; // we show the first error/action!
            var error = actual.error;
            var action = error && error.action || "";
            var pushDate = this.model.get("pushedAt");
            var html = "";

            // Add retry/reload/support information...
            if (action.indexOf(Actions.RELOAD) !== -1) {
                html += "<p><b>Click to refresh and get the saved version</b> - your changes will be lost.</p>";
            } else if (action.indexOf(Actions.RETRY) !== -1) {
                html += "<p><b>Click to try to " + actual.method + " again.</b></p>";
            }

            // Support?
            if (action.indexOf(Actions.SUPPORT) !== -1 && Configuration.supportEmail) {
                html += "<p>Contact " + Configuration.supportEmail + " for assistance.</p>";
            }

            // Add version in debug mode...
            if (Logger.level() === Logger.VERBOSE || LoggedIn.ad()) {
                html += "<p>Version: #" + Math.abs(this.model.get("version")) + "</p>";
                if (pushDate) {
                    html += "<p>Pushed version: #" + this.model.get("pushedVersion") + "</p>";
                }
            }

            // Add detailed timestamps...
            html += "<p>Last save: " + DateUtil.formatYYYYMMDDHHmm(this._editedAt || this.model.getEditedAt()) + "</p>";
            if (pushDate) {
                html += "<p>Last push: " + DateUtil.formatYYYYMMDDHHmm(pushDate) + "</p>";
            }
            return html;
        },


        /**
         * @private
         * Shows a notification to the user about potential concurrent modification of the experience and/or one
         * of its variants, unless no interval for doing so is specified as an option or can be read from the
         * configuration based on an option. <p>
         *
         * Only called on rendering, so <tt>editedAt</tt> is server time from last refresh, unless already in
         * an unsaved state because of some earlier error. <p>
         *
         * Only shown if <tt>this.options.notifyConcurrentModification</tt> is set to a number of ms or
         * as a configuration options object returning said interval in ms ("number"), corresponding to the interval
         * passed since <tt>editedAt</tt> before the notification should *not* be shown.
         */
        _notifyConcurrentModification: function _notifyConcurrentModification() {
            // Do not show if an error is already reported, or if the model is new...
            if (this.model.syncState.actual.error || this.model.isNew()) {
                return;
            }
            var interval = this.options.notifyConcurrentModification;
            // Allow the value to be configured...
            if (typeof interval !== "number") {
                interval = Configuration.val(interval, { configName: "notifyConcurrentModification", type: "number" });
            }
            // No interval (now)? Then do nothing...
            if (!interval) {
                return;
            }

            var now = Time.server();
            var updated = GroupUtil.isUpdatedWithin(this.model, this.options.group, LoggedIn.principal().get("userId"), interval, now);

            // We can stop if no concurrent updates...
            if (!updated.count) {
                return;
            }

            // See if this experience has been updated, since we want to present this as the *first* notification,
            // i.e. most relevant...
            var id = this.model.get("id");
            var queue = false;
            var experience = updated.variants[id];
            var tag = "concurrent:" + id;

            if (experience) {
                delete updated.variants[id];
                updated.count--;
                this._notifyForVariant(this.model, false, false, now, tag);
                queue = true;
            }
            // Go through all variants, then...
            if (updated.count) {
                for (id in updated.variants) {
                    this._notifyForVariant(updated.variants[id], true, queue, now, tag);
                    queue = true;
                }
            }
        },


        /**
         * @private
         * Adds a notification message for the supplied experience, which can be a variant of the actual experience
         * edited by this view.
         *
         * @param {ExperienceModel} experience The experience (variant) that could be concurrently updated; never null.
         * @param {Boolean}         variant    True if <tt>experience</tt> is a variant.
         * @param {Boolean}         queue      True to enqueue the notification message, false to show now.
         * @param {Number}          now        "Now", in ms server time since the epoch.
         */
        _notifyForVariant: function _notifyForVariant(experience, variant, queue, now, tag) {
            var _this = this;

            // Resolve the mysterious other editor, then, if any...
            var userId = experience.get("editedBy");
            if (!userId) {
                return;
            }
            this._fetchUser(userId, function (name) {
                // User friendly formatting of time passed...
                var timePassed = DateUtil.timeDifference(now, experience.getEditedAt());
                // eslint-disable-next-line no-template-curly-in-string
                var message = "${name} updated";

                if (variant) {
                    message += " the Experience variant \"" + experience.get("name") + "\"";
                } else {
                    message += " this Experience";
                }
                // eslint-disable-next-line no-template-curly-in-string
                message += " ${timePassed} ago, and <b>could</b> be editing it concurrently.";

                // Save id for message so we can remove it on successful update, since then no longer relevant. The
                // id will still be removed if the notification closes because of the delay, just not until the next
                // sync...
                var id = NotificationBar.open(message.replace(/\${name}/g, name).replace(/\${timePassed}/g, timePassed), {
                    queue: queue,
                    closeDelay: 30000,
                    statsD: "concurrent." + (variant ? "variant" : "experience"), // e.g. track "notificationbar.open.concurrent.variant"
                    tag: tag, // remove all, including for variants...
                    flash: { queue: false },
                    clearOnClose: {
                        global: "tag", manual: "tag", delay: "tag", flip: "self"
                    }
                });

                // Make sure we listen for variant saves, e.g. remove notifications on push (of all variants). Errors
                // will be caught in any case, so we do not bother about those here...
                var callback = function callback(state, method) {
                    // If a variant is synced, it is probably a push or a save because of a scene, but it could
                    // also be fetched. For the current exception, we are only interested in fetch, since other
                    // syncing already handled explicitly...
                    if (state === Syncer.State.Synced) {
                        // Saved, so stop listening...
                        _this.stopListening(experience, "sync:state", callback);
                        // Remove the notification...
                        NotificationBar.close({ id: id, clear: "self" });
                        // Re-notify on fetch (if applicable)...
                        if (method.indexOf("fetch") === 0) {
                            _this._notifyConcurrentModification();
                        }
                    }
                };

                // Add listener to be invoked on synced, then no more...
                _this.listenTo(experience, "sync:state", callback);
            });
        },


        /**
         * Resolves the specified user id to a user-friendly name of said user, calling <tt>notify(resolvedName)</tt>
         * when resolving is done, erroneous or not.
         *
         * @param  {String}   id     The id of the user to fetch; never null.
         * @param  {Function} notify The function to notify the user with the massage using
         *                           the resolved user name; never null.
         */
        _fetchUser: function _fetchUser(id, notify) {
            LoggedInUserState.fetchGlobalCollection(UserCollection).then(function (users) {
                // Can be null if deleted, or if added to the company after the user collection was loaded...
                var user = users.findWhere({ id: id });
                return user ? Promise.resolved(user) : User.findById(id);
            }).done(function (user) {
                var displayName = user.get("displayName");
                var email = user.get("username");
                var name = void 0;

                if (displayName) {
                    if (email) {
                        name = "<a href=\"mailto:" + email + "\">" + displayName + "</a>";
                    } else {
                        name = displayName;
                    }
                } else {
                    name = "Somebody (user " + id + ")";
                }
                notify(name);
            }).fail(function () {
                // do not report errors here, not really relevant...
                notify("Somebody (user " + id + ")");
            });
        },


        // Life cycle callbacks...

        onRender: function onRender() {
            // Add tooltip if so specified...
            if (this.options.showTooltip) {
                Tooltip.add(this.ui.syncState, {
                    content: this._updateSyncStateTooltip.bind(this),
                    html: true,
                    placement: "left",
                    trigger: "hover",
                    width: 200,
                    duration: 0 // no timeout
                });
            }

            // Always hide the button
            this.ui.copyCodeBtn.hide();

            if (LoggedInUserState.get("integrations").isNativeContentIntegrationsEnabled()) {
                this.ui.copyCodeBtn.show();

                Tooltip.add(this.ui.copyCodeBtn, {
                    content: this._updateGetCodeTooltip.bind(this),
                    html: true,
                    placement: "left",
                    trigger: "hover",
                    width: 200,
                    duration: 0 // no timeout
                });
            }

            // Create spinner for dom element, not jQuery element...
            this._spinner = typeof this.options.spinner === "undefined" || this.options.spinner ? Ladda.create(this.ui.spinner[0]) : null;

            // Update sync state...
            this._syncState();

            // Notify the user that someone else is potentially modifying this experience concurrently within
            // the specified interval in ms?
            this._notifyConcurrentModification();
        },
        initialize: function initialize() {
            // Global error handler which will ensure we update this view on some global unhandled error. We do not
            // report the error elsewhere, we merely update this view!
            this._errorHandler = Window.error(this._syncState.bind(this));
            this._isEmailInCreatorEnabled = LoggedInUserState.get("companySettings").get("isCreatorInEmailEnabled");
            this._isEnhancedCopyCodeEnabled = this._getEnhancedCopyCodeFlag();
        },


        onShow: function onShow() {
            if (this._isEmailInCreatorEnabled) {
                this.copyEmailButtonRegion.show(new CopyEmailButtonView({
                    viewModel: this.options.viewModel,
                    experienceModel: this.model
                }));
            }
        },

        onClose: function onClose() {
            this._clearSyncTimer();

            if (this.options.showTooltip) {
                Tooltip.remove(this.ui.syncState);
            }
            if (this._spinner) {
                this._spinner.stop();
            }
            // Close all notification messages about concurrent modification for the experience or any of
            // its variants, if not already. Note that the EditorController will probably have removed
            // them already, but we have to make sure we clean up there in case this view is used elsewhere!
            NotificationBar.close({ tag: "concurrent:" + this.model.get("id"), clear: "tag" });

            if (this._errorHandler) {
                this._errorHandler.off();
                this._errorHandler = null;
            }
        }
    }, {
        injection: {
            parameters: ["statsD"],
            asOptions: true
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2937 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div>\n    <div class="spinner" data-spinner-color="#000" data-spinner-size="20">\n        <div class="ladda-label sync-state"></div>\n        <i class="glyphicon glyphicon-exclamation-sign important"></i>\n    </div>\n    <div class="dropdown spinner get-code-container">\n        <input type="text" style="position: absolute;left: -9999px;" />\n        ';
 if (isEnhancedCopyCodeEnabled && !isNewDashboardExperience) { ;
__p += '\n            <button class="dropdown-toggle copy-code-btn btn btn-white" data-toggle="dropdown">Copy Code<span class="indicator">* </span><span class="caret"></span></button>\n            <ul class="dropdown-menu more-dropdown-menu copyCodeDropDown">\n                <li><a class="menu-item get-enhanced-code">Enhanced</a></li>\n                ';
 if(!isNewDashboardExperience) { ;
__p += '\n                    <li><a class="menu-item get-code-btn">Legacy</a></li>\n                ';
 } ;
__p += '\n            </ul>\n        ';
 } ;
__p += '\n        ';
 if (!isEnhancedCopyCodeEnabled && !isNewDashboardExperience) { ;
__p += '\n            <button class="get-code-btn btn btn-white copy-code-btn">Copy Code<span class="indicator">*</span></button>\n        ';
 } ;
__p += '\n    </div>\n\n   ';
 if (isEmailInCreatorEnabled) { ;
__p += '\n       <div class="copy-email-btn-region"></div>\n   ';
 } ;
__p += '\n</div>\n';

}
return __p
}

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ReactBridge = __webpack_require__(137);
    var template = __webpack_require__(2939);
    var AbstractEmailButtonView = __webpack_require__(1227);
    var NotificationBar = __webpack_require__(53);
    var CopyKlaviyoEmail = __webpack_require__(2940).default;
    var CopySfmcEmail = __webpack_require__(2941).default;

    /**
     * Component representing the Copy Email button for the <tt>EditorPreviewMenu</tt>.
     *
     * @cfg {experienceModel} model The current experience model.
     * @cfg {viewModel} model The current view model.
     *
     * @see EditorPreviewMenu
     *
     * @class CopyEmailButtonView
     */
    return AbstractEmailButtonView.extend({
        className: "email-button-container",

        template: template,

        events: {
            "click @ui.emailBtnDefault": "_processCopyEmailCodeDefault",
            "click @ui.emailBtnOmetria": "_processCopyEmailCodeOmetria",
            "click @ui.emailBtnKlaviyo": "_displayKlaviyoPopup",
            "click @ui.emailBtnSFMC": "_displaySfmcPopup"
        },
        regions: {
            popupContainer: ".email-client-popup"
        },

        initialize: function initialize() {
            this.__super();
            this.tooltips.DEFAULT = "Click this button to copy Email code and paste it into your ESP.\n\nTo insure you get the most up to date version of your email, remember to <b>push all your changes</b> before hitting \"Copy Email Code\"";
            this.tooltips.OVERLAPPED_WIDGETS = "You have overlapping interactive elements on your experience (highlighted on the canvas for you). Please separate them to be able to Copy Email Code.";
            this.tooltips.NOT_PUSHED = "Push your experience to be able to copy your email code";
        },
        _processCopyEmailCode: function _processCopyEmailCode(espName) {
            var _this = this;

            var userHTML = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            if (this.ui.emailBtn.hasClass("disabled")) {
                return;
            }
            NotificationBar.close();
            var id = NotificationBar.open("Building email... Please wait");
            var scenes = this.experienceModel.get("scenes");
            scenes.trigger("getEmailActionWidgetsBoundingBoxes", function (widgetBoxes) {
                _this.model.fetch({ widgets: widgetBoxes, espName: espName, userHTML: userHTML }).then(function (model) {
                    var errFallback = function errFallback() {
                        NotificationBar.close({ id: id, clear: "self" });
                        NotificationBar.error("We couldn't copy email code. Please try again.");
                    };
                    try {
                        var tableHTML = model.get("tableHTML");
                        if ((espName === "klaviyo" || espName === "sfmc") && !tableHTML.html_code && tableHTML.detail.message) {
                            NotificationBar.close({ id: id, clear: "self" });
                            NotificationBar.error(tableHTML.detail.message);
                            return;
                        } else if ((espName === "klaviyo" || espName === "sfmc") && tableHTML.html_code) {
                            tableHTML = tableHTML.html_code;
                        }
                        if (!tableHTML) {
                            errFallback();
                            return;
                        }
                        navigator.clipboard.writeText(tableHTML).then(function () {
                            NotificationBar.close({ id: id, clear: "self" });
                            return model.get("sizeWarning") ? NotificationBar.error("Warning: You have successfully copied email code to your clipboard but your email is larger than 102KB so it will not render properly in Gmail client.") : NotificationBar.open("You have successfully copied email code to your clipboard. Email Size: " + model.get("emailSize") + "KB", { closeDelay: 5000 });
                        }).catch(errFallback);
                    } catch (e) {
                        errFallback();
                    }
                });
            });
        },
        _displayKlaviyoPopup: function _displayKlaviyoPopup() {
            var copyemailKlaviyo = ReactBridge.viewFromComponent(CopyKlaviyoEmail, {
                props: { show: true, submitCallback: this._processCopyEmailCodeKlaviyo.bind(this) }
            });
            this.popupContainer.show(copyemailKlaviyo);
        },
        _displaySfmcPopup: function _displaySfmcPopup() {
            var copyemailSfmc = ReactBridge.viewFromComponent(CopySfmcEmail, {
                props: { show: true, submitCallback: this._processCopyEmailCodeSFMC.bind(this) }
            });
            this.popupContainer.show(copyemailSfmc);
        },
        _processCopyEmailCodeKlaviyo: function _processCopyEmailCodeKlaviyo(userHTML) {
            this._processCopyEmailCode("klaviyo", userHTML);
        },
        _processCopyEmailCodeOmetria: function _processCopyEmailCodeOmetria() {
            this._processCopyEmailCode("ometria");
        },
        _processCopyEmailCodeSFMC: function _processCopyEmailCodeSFMC(userHTML) {
            this._processCopyEmailCode("sfmc", userHTML);
        },
        _processCopyEmailCodeDefault: function _processCopyEmailCodeDefault() {
            this._processCopyEmailCode();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2939 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dropdown email-btn-wrapper email-btn">\n    <a href="#" class="dropdown-toggle copy btn email-btn" data-toggle="dropdown">Copy Email Code&nbsp;<span class="caret"></span></a>\n\n    <ul class="dropdown-menu more-dropdown-menu">\n        <li><a class="menu-item email-btn-default">Default</a></li>\n        <li><a class="menu-item email-btn-ometria">Ometria</a></li>\n        <li><a class="menu-item email-btn-klaviyo">Klaviyo</a></li>\n        <li><a class="menu-item email-btn-sfmc">SFMC</a></li>\n    </ul>\n</div>\n<div class="email-client-popup"></div>';

}
return __p
}

/***/ }),
/* 2940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = CopyKlaviyoEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__);



function CopyKlaviyoEmail(props) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true), show = _a[0], setShow = _a[1];
    var handleClose = function () { return setShow(false); };
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""), value = _b[0], setValue = _b[1];
    var textAreaRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    var handleSubmit = function () {
        var textRef = textAreaRef.current || null;
        props.submitCallback(textRef.value);
        handleClose();
        textRef.innerHTML = "";
    };
    var onchange = function (e) {
        setValue(e.target.value);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */], { show: show, onHide: handleClose },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Header, { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Title, null, "Merge your Creator experience with your Klaviyo template")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Body, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                    "1. Prepare your Klaviyo template by adding a text block with the content ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, " <creator/> "),
                    " to it where you want your Creator experience to be visible. ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null,
                        "(Note: only one ",
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, " <creator/> "),
                        " tag can be added to your template)"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    "2. Export your finished template from Klaviyo and paste the HTML from it in the open space below.",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    "3. Paste the copied HTML into Klaviyo as a new template or email campaign."),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", { className: "html-body", value: value, placeholder: "Paste the HTML code from your Klaviyo template", id: "copyhtml", onChange: onchange, cols: 75, rows: 8, ref: textAreaRef, style: { resize: "vertical", minHeight: "100px", maxHeight: "400px", width: "100%" } })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Footer, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */], { variant: "secondary", onClick: handleClose }, "Close"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style", { type: "text/css" }, "\n                            .btn.disabled, .btn[disabled]:not([data-loading]){\n                                background-color: #e16dff;\n                                color: white;\n                            }\n\n                            .klaviyo-submit{\n                                background-color: #8C01FF;\n                                color: white;\n                            }\n                           \n                            .klaviyo-submit:hover{\n                                background-color: #CD00FF;\n                                color: white;\n                            }\n                            "),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */], { variant: "primary", className: "klaviyo-submit", disabled: (value.length < 1) || !(/\S/.test(value)), onClick: handleSubmit }, "Merge and Copy")))));
}


/***/ }),
/* 2941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = CopySfmcEmail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_bootstrap__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_bootstrap_dist_css_bootstrap_min_css__);



function CopySfmcEmail(props) {
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true), show = _a[0], setShow = _a[1];
    var handleClose = function () { return setShow(false); };
    var _b = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(""), value = _b[0], setValue = _b[1];
    var textAreaRef = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
    var handleSubmit = function () {
        var textRef = textAreaRef.current || null;
        props.submitCallback(textRef.value);
        handleClose();
        textRef.innerHTML = "";
    };
    var onchange = function (e) {
        setValue(e.target.value);
    };
    return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */], { show: show, onHide: handleClose },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Header, { closeButton: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Title, null, "Merge your Creator experience with your SFMC template")),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Body, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null,
                    "1. Prepare your SFMC template by adding a HTML block with the content ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, " <creator></creator> "),
                    " to it where you want your Creator experience to be visible. ",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", null,
                        "(Note: only one ",
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b", null, "  <creator></creator> "),
                        " tag can be added to your template)"),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    "2. Export your finished template from SFMC and paste the HTML from it in the open space below.",
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
                    "3. Paste the copied HTML into SFMC as a new template or email campaign."),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", { className: "html-body", value: value, placeholder: "Paste the HTML code from your SFMC template", id: "copyhtml", onChange: onchange, cols: 75, rows: 8, ref: textAreaRef, style: { resize: "vertical", minHeight: "100px", maxHeight: "400px", width: "100%" } })),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["d" /* Modal */].Footer, null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */], { variant: "secondary", onClick: handleClose }, "Close"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style", { type: "text/css" }, "\n                            .btn.disabled, .btn[disabled]:not([data-loading]){\n                                background-color: #e16dff;\n                                color: white;\n                            }\n\n                            .sfmc-submit{\n                                background-color: #8C01FF;\n                                color: white;\n                            }\n                           \n                            .sfmc-submit:hover{\n                                background-color: #CD00FF;\n                                color: white;\n                            }\n                            "),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_bootstrap__["a" /* Button */], { variant: "primary", className: "sfmc-submit", disabled: (value.length < 1) || !(/\S/.test(value)), onClick: handleSubmit }, "Merge and Copy")))));
}


/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Ladda = __webpack_require__(340);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);
    var TemplateModel = __webpack_require__(468);
    var NotificationBar = __webpack_require__(53);
    var template = __webpack_require__(2943);

    var TEMPLATE_SAVED_TEXT = "This experience has been saved as a Template";
    var TEMPLATE_NOTIFICATION_CLOSE_DELAY = 7500;

    /**
     * View for saving the Template.
     * @author Yarolsav Ilin <@yil>
     */
    return ImprovedView.extend("SaveTemplateModalViewModel", {

        className: "save-template-modal",

        template: template,
        templateHelpers: function templateHelpers() {
            return {
                descriptionPlaceholder: TemplateModel.DEFAULT_DESCRIPTION
            };
        },


        bindings: {
            ".description": "description"
        },

        ui: {
            description: ".description",
            buttonOk: ".ok",
            buttonCancel: ".cancel",
            overlay: ".overlay"
        },

        events: {
            "click @ui.buttonCancel": "close",
            "click @ui.buttonOk": "_onOkClick"
        },

        modelEvents: {
            "change": "_onChanged",
            "request": "_onSyncStarted",
            "error sync": "_onSyncDone"
        },

        _buttonLadda: null,

        onRender: function onRender() {
            this._onChanged();
            this._buttonLadda = Ladda.create(this.ui.buttonOk.get(0));
        },
        _onOkClick: function _onOkClick() {
            var _this = this;

            this._buttonLadda.start();

            var experienceJSON = this.options.experience.toJSON();
            var id = experienceJSON.id,
                version = experienceJSON.version,
                pushedVersion = experienceJSON.pushedVersion,
                name = experienceJSON.name;


            this.model.save({ name: name, content: experienceJSON }).then(function () {
                NotificationBar.open({ message: TEMPLATE_SAVED_TEXT }, { tag: "template", closeDelay: TEMPLATE_NOTIFICATION_CLOSE_DELAY });

                EditorEvents.trigger(EditorEvents.constants.SAVE_TEMPLATE, {
                    description: _this.model.get("description"),
                    experienceId: id,
                    experienceVersion: version,
                    experiencePushedVersion: pushedVersion,
                    triggerOrigin: "SaveTemplateModalOkButton"
                });
            }).always(function () {
                _this._buttonLadda.stop();
                _this.close();
            });
        },
        _onChanged: function _onChanged() {
            var buttonOk = this.ui.buttonOk;


            if (this.model.isNew()) {
                buttonOk.removeClass("btn-danger");
                buttonOk.addClass("btn-warning");
                buttonOk.text("Create template");
            } else {
                buttonOk.removeClass("btn-warning");
                buttonOk.addClass("btn-danger");
                buttonOk.text("Update template");
            }
        },
        _onSyncStarted: function _onSyncStarted() {
            this.ui.overlay.removeClass("hidden");
        },
        _onSyncDone: function _onSyncDone() {
            this.ui.overlay.addClass("hidden");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2943 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h2>Template</h2>\n<div class="row">\n    <p class="intro danger">\n        Warning!\n    </p>\n    <p class="intro danger">\n        This action will expose your changes made to the experience to the clients.\n    </p>\n</div>\n<div class="row">\n    <div class="control-group">\n        <label class="required description-label">\n            Description of the Template:\n            <input type="text" class="description" placeholder="' +
__e( descriptionPlaceholder ) +
'" autofocus="autofocus" />\n        </label>\n    </div>\n</div>\n\n<div class="actions">\n    <button class="cancel btn btn-secondary">Cancel</button>\n    <button class="ok btn btn-danger ladda-button" data-style="expand-left"></button>\n</div>\n\n<div class="overlay hidden"></div>\n';

}
return __p
}

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(2945);

    /**
     * @class ExperienceTemplateOptionsView
     */
    return ImprovedView.extend({

        className: "wrap",

        template: template,

        ui: {
            button: ".button"
        },

        triggers: {
            "click @ui.button": "clickTemplateSave"
        },

        initialize: function initialize() {
            this.listenTo(this.options.experience, "sync:state", this.render);
        },


        modelEvents: {
            "change": "render"
        },

        onRender: function onRender() {
            var button = this.ui.button;


            if (this.model.isNew()) {
                button.removeClass("btn-danger");
                button.addClass("btn-warning");
                button.text("Create template");
            } else {
                var text = "Update template";
                if (this._hasUnsavedChanges()) {
                    text += "*";
                }
                button.removeClass("btn-warning");
                button.addClass("btn-danger");
                button.text(text);
            }
        },
        _hasUnsavedChanges: function _hasUnsavedChanges() {
            return this.model.get("content").version !== this.options.experience.get("version");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2945 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '    <div class="vertical-line"></div>\n    <button href="#" class="button btn"></button>\n';

}
return __p
}

/***/ }),
/* 2946 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="left-info"></div>\n<div class="center-info">\n    ';
 if (inGroup) { ;
__p += '\n    <div class="vertical-line"></div>\n    <label>Title: <input type="text" class="name-input tour-experience-name" ' +
__e( spectator ? "disabled" : "" ) +
'></label>\n    ';
 } ;
__p += '\n\n    <div class="multi-scene-options hidden"></div>\n\n    <div class="template-options"></div>\n\n</div>\n\n<div class="right-info experience-sync-state-region">\n';
 if(isNewDashboardExperience) { ;
__p += '\n    <span class= "new-dashboard-note" > <strong> Note: </strong> To Publish/copy code please click on Preview and Publish </span>\n';
 } ;
__p += '\n\n</div>\n';

}
return __p
}

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Preconditions = __webpack_require__(14),
        BreakpointGroup = __webpack_require__(97),
        LocalizationGroup = __webpack_require__(232),
        GroupLocaleNavView = __webpack_require__(2948),
        GroupBreakpointNavView = __webpack_require__(2952);

    /**
     * A factory for creating specific/concrete <tt>GroupNavView</tt>'s.
     *
     * @class GroupNavViewFactory
     */
    return {

        create: function create(options) {
            var group = options.model,
                ViewClass = null;

            Preconditions.checkArgument(group, "A model of group instance must be passed in as an option property");

            switch (group.get("type")) {
                case LocalizationGroup.type:
                    options.identifierInFront = false;
                    ViewClass = GroupLocaleNavView;
                    break;

                case BreakpointGroup.type:
                    options.identifierInFront = true;
                    ViewClass = GroupBreakpointNavView;
                    break;

                default:
                    break;
            }

            return new ViewClass(options);
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        GroupNavView = __webpack_require__(1229),
        LocaleSelectorControl = __webpack_require__(1230),
        LocaleCollection = __webpack_require__(374),
        ActionSequence = __webpack_require__(467),
        AddLocaleAction = __webpack_require__(1220),
        NavigateToExperienceAction = __webpack_require__(469);

    /**
     * A view that represents all variants for a specific Localization group.
     *
     * @cfg {LocalizationGroup} model
     */
    return GroupNavView.extend({

        regions: {
            localeSelectorRegion: ".add-variant-icon"
        },

        events: _.defaults({
            "click @ui.addVariantIcon": function clickUiAddVariantIcon() {
                // Overwrites parent method, do nothing.
            }
        }, GroupNavView.prototype.events),

        onRender: function onRender() {
            this.__super();

            // Remove the plus icon and insert the new Plus icon with dropdown menu
            this.ui.addVariantIcon.empty();
            this.localeSelectorRegion.show(new LocaleSelectorControl({
                locales: LocaleCollection.remainingItems(this.model.getValues()),
                addVariant: true,
                selectHandler: this.addVariant.bind(this)
            }));
        },

        addVariant: function addVariant(localString) {
            new ActionSequence().add(new AddLocaleAction(this.model, this._currentExperience, this.options.project, localString)).add(new NavigateToExperienceAction(this.model.get("sceneNumber"))).execute();
        },

        /**
         * Check which assets need to be pushed when push group button is clicked
         *
         * @returns {Object}    An object where indexes map to the actual asset
         * @private
         */
        toBePushedAssets: function toBePushedAssets() {
            return _.reduce(this.model.getUniqueEntries(), function (assets, asset) {
                if (asset[0].hasNonPushedChanges()) {
                    assets[asset[1].getCountry()] = asset[0];
                }

                return assets;
            }, {});
        },

        // Locales are always deletable
        isDeletable: function isDeletable() {
            return true;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Action = __webpack_require__(156),
        BreakpointGroup = __webpack_require__(97),
        EditorEvents = __webpack_require__(17),
        SharedEntityType = __webpack_require__(285),
        SharedEntityHelper = __webpack_require__(713);
    /**
     * Detaching from a breakpoint group differs from the default <tt>detach</tt> implementation. We cannot
     * delete the whole entry but instead, we need to reassign the experience.
     *
     * @param  {BreakpointGroup} breakpointGroup The group.
     * @param  {ExperienceModel} asset           The asset.
     * @return {Promise}                         Promise resulting when the group has been successfully saved.
     */
    function detachFromBreakpointGroup(breakpointGroup, asset) {
        var entries = breakpointGroup.get("entries"),
            identifier = asset.identifier();

        var first = entries.find(function (entry) {
            var internalAsset = entry.get("asset");

            return internalAsset && internalAsset.get("id") !== identifier;
        });

        entries.each(function (entry) {
            var internalAsset = entry.get("asset"),
                found = internalAsset && internalAsset.get("id") === identifier;

            if (found) {
                if (entry.get("value")) {
                    entry.set("asset", first.get("asset"));
                    entry.get("reference").resourceId = first.get("asset").get("id");
                } else {
                    entries.remove(entry);
                }
            }
        });

        return breakpointGroup.save();
    }

    /**
     * An action that deletes a variant from a group. If the
     * second last variant is deleted, we remove the whole group.
     *
     * @class DeleteVariantAction
     */
    return Action.extend({

        constructor: function constructor(group, experienceId, project, updatedCollection) {
            this.__super();

            this._group = group;
            this._experienceId = experienceId;
            this._project = project;
            this._updatedCollection = updatedCollection;
        },

        _performExecution: function _performExecution() {

            var self = this,
                group = this._group;
            var promise = null;
            var experience = this._group.findAssetById(this._experienceId);

            // If this is the last asset, we remove this group, but keep the experience
            if (group.getNumOfAssets() === 1) {
                promise = group.destroy();
                SharedEntityHelper.movePermissions({
                    sourceID: group.get("id"),
                    sourceType: SharedEntityType.GROUP,
                    companyId: group.get("companyId"),
                    destID: experience.get("id"),
                    destType: SharedEntityType.EXPERIENCE
                });
            } else {
                // Breakpoint groups needs special attention...
                if (group instanceof BreakpointGroup) {
                    promise = detachFromBreakpointGroup(group, experience);
                } else {
                    promise = group.detach(experience);
                }

                promise.then(function () {
                    // Refresh the detached experience to stay in sync with the server.
                    experience.fetch().then(function () {
                        return experience.destroy();
                    });
                });
            }

            return promise.then(function () {
                self._trackVariant(experience);

                return experience;
            });
        },

        /**
         * Sends Mix Panel event for the variant.
         * @param {Experience} experience The deleted experience.
         * @private
         */
        _trackVariant: function _trackVariant(experience) {
            var eventProperties = {
                projectId: this._project && this._project.get("id"),
                groupId: this._group.get("id"),
                groupType: this._group.get("type"),
                groupVersion: this._group.get("version"),
                groupPushedVersion: this._group.get("pushedVersion"),
                triggerOrigin: "Delete" + this._group.get("type") + "Icon",
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion")
            };

            EditorEvents.trigger(EditorEvents.constants.DELETE_VARIANT, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2950 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="first-line">\n     ';
 if(!isNewDashboardExperience) { ;
__p += '\n        <div  class="name-container">\n            <span class="name-input group-name-input" contenteditable="' +
__e( spectator ? "false" : "true" ) +
'"></span>\n        </div>\n    ';
 } ;
__p += '\n\n	<ul class="group-variants ' +
__e(groupType ) +
'">\n        ';
 _.each(entries, function (entry, index) {
            var identifier = entry[1] ? entry[1].getIdentifier() : "";
        ;
__p += '\n            <li class="variant-icon ' +
__e(identifier) +
'' +
__e( currentVariant.id === entry[0].id ? " selected" : "" ) +
'" data-experience-id="' +
__e( entry[0].id ) +
'">\n                #' +
__e( index + 1 ) +
'\n                <span class="delete-btn" data-experience-id="' +
__e( entry[0].id ) +
'">&#215;</span>\n            </li>\n        ';
 }); ;
__p += '\n		';
 if (!spectator && !hasMaxVariants) { ;
__p += '\n		    <li class="add-variant-icon"><i class="icon-plus"></i></li>\n		';
 } ;
__p += '\n	</ul>\n\n    ';
 if(!isNewDashboardExperience) { ;
__p += '\n        <div class="vertical-line"></div>\n        <button class="push-btn push-group-btn btn btn-grey"></button>\n        <button class="publish-btn btn btn-white">Publish</button>\n            ';
 if (designFileUIEnabled) { ;
__p += '\n                    <div class="move-experience-input">\n                        <button class="move-to-experience-btn btn btn-white btn-import-action">Move Here</button>\n                        <input class="import-key input-field" type="text" placeholder="5xxxxxxxxxxxxxxxxxxxxxxx" data-original-title="" title="">\n                    </div>\n            ';
 } ;
__p += '\n    ';
 } ;
__p += '\n</div>\n\n<div class="second-line">\n    <ul class="group-variants ' +
__e(groupType ) +
'">\n        ';
 _.each(entries, function (entry, index) {
        var identifier = entry[1] ? entry[1].getIdentifier() : "";
        ;
__p += '\n        <li class="variant-icon ' +
__e(identifier) +
'' +
__e( currentVariant.id === entry[0].id ? " selected" : "" ) +
'" data-experience-id="' +
__e( entry[0].id ) +
'">\n        #' +
__e( index + 1 ) +
'\n        <span class="delete-btn" data-experience-id="' +
__e( entry[0].id ) +
'">&#215;</span>\n        </li>\n        ';
 }); ;
__p += '\n        ';
 if (!spectator && !hasMaxVariants) { ;
__p += '\n        <li class="add-variant-icon"><i class="icon-plus"></i></li>\n        ';
 } ;
__p += '\n    </ul>\n</div>\n\n\n';

}
return __p
}

/***/ }),
/* 2951 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (addVariant) {;
__p += '\n    <span class="dropdown-toggle" data-toggle="dropdown"><i class="icon-plus"></i></span>\n';
} else if (firstVariant) {;
__p += '\n    <span class="create-locale">Language Variant</span>\n';
 } ;
__p += '\n\n<ul class="dropdown-menu">\n    ';
 _.each(locales, function (locale) {;
__p += '\n        <li>\n            <div class="variant-action" data-locale="' +
__e( locale.getLocaleString() ) +
'">\n                <span class="flag small ' +
__e( locale.getIdentifier() ) +
'"></span>' +
__e( locale.getVariantName() ) +
'\n            </div>\n        </li>\n    ';
 }); ;
__p += '\n</ul>\n\n';

}
return __p
}

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        $ = __webpack_require__(4),
        BreakpointAssignView = __webpack_require__(2953),
        ActionSequence = __webpack_require__(467),
        LoggedInUserState = __webpack_require__(19),
        Tooltip = __webpack_require__(35),
        Lightbox = __webpack_require__(101),
        Permissions = __webpack_require__(22),
        PublishableState = __webpack_require__(65),
        AddBreakpointAction = __webpack_require__(1218),
        NavigateToExperienceAction = __webpack_require__(469),
        GroupNavView = __webpack_require__(1229);

    var NO_PERMISSION_MESSAGE = "You do not have permission to delete Experiences.",
        NOT_ALLOWED_MESSAGE = "This Experience cannot be deleted because it is pushed and assigned to a Breakpoint. " + "Unassign it from the Breakpoint and push the Group again if you want to delete the Experience.";

    /**
     * @class GroupBreakpointNavView
     *
     * A view that represents all variant tabs for a specific breakpoint group.
     *
     * @cfg {BreakpointGroup} model The BreakpointGroup model
     */
    return GroupNavView.extend({

        _breakpointsChanged: null,

        ui: _.defaults({
            assignBreakpoints: ".assign-breakpoints"
        }, GroupNavView.prototype.ui),

        templateHelpers: function templateHelpers() {
            return _.extend(this.__super(), {
                breakpointsChanged: this._breakpointsChanged
            });
        },

        events: _.defaults({
            "click .assign-breakpoints": "openAssignModal"
        }, GroupNavView.prototype.events),

        initialize: function initialize() {
            this.__super();

            var breakpointCollection = LoggedInUserState.get("companySettings").get("breakpoints");

            this.lowerBoundsInSetting = breakpointCollection.getLowerBounds();
        },

        onBeforeRender: function onBeforeRender() {
            this.__super();

            // Checks if the breakpoint setting has been updated by comparing the breakpoints in company setting
            // against the ones in the breakpoint group model
            this._breakpointsChanged = !this.model.compareThresholds(this.lowerBoundsInSetting);
        },

        onRender: function onRender() {
            this.__super();

            this._updateDeleteIcons();
            this.ui.firstLine.after(this.getAssignIconHtml());
        },

        // Kind of a hack to inject the assign icon html to the template, since there is no better way to
        // inherit a template view with backbone
        getAssignIconHtml: function getAssignIconHtml() {
            var assignIconHtml = "<div class='vertical-line'></div><div class='assign-breakpoints'>";

            if (this._breakpointsChanged) {
                assignIconHtml += "<i class='glyphicon glyphicon-exclamation-sign'></i>";
            }

            return assignIconHtml + "</div>";
        },

        onShow: function onShow() {
            this.__super();

            var tip = {
                content: "Assign Breakpoint Variants.",
                width: 180
            };

            if (this._isSpectator) {
                tip = {
                    content: "Assigned Breakpoint Variants",
                    width: 190
                };
            } else if (this._breakpointsChanged) {
                tip = {
                    content: "The Breakpoint Settings have been changed.</br>" + "Update to the new Breakpoints or assign Breakpoint Variants.",
                    width: 200
                };
            }

            Tooltip.create(this.ui.assignBreakpoints, tip);
        },

        /**
         * Calls the general push logic in the super class, and update delete icons afterwards.
         *
         * @override
         * @private
         */
        _pushGroup: function _pushGroup() {
            this.__super().done(this._updateDeleteIcons.bind(this));
        },

        /**
         * Check which assets need to be pushed when push group button is clicked
         *
         * @returns {Object}    An object where indexes map to the actual asset
         * @private
         */
        toBePushedAssets: function toBePushedAssets() {
            return _.reduce(this.model.getSortedAssets(), function (assets, asset, index) {
                if (asset.hasNonPushedChanges()) {
                    assets["#" + (index + 1)] = asset;
                }

                return assets;
            }, {});
        },

        /**
         * Used to update delete icons after push. if we call render instead, it will result in an
         * flashing rendering effect in IE. See bug report MOS-2284 for more info.
         */
        _updateDeleteIcons: function _updateDeleteIcons() {
            var deleteButtons = this.ui.deleteBtn,
                self = this,
                width = self._isSpectator ? 300 : 400,
                isDeletable = false,
                experience = null;

            if (self._isSpectator) {
                deleteButtons.toggleClass("disabled", true);
                Tooltip.create(deleteButtons, { width: width, content: NO_PERMISSION_MESSAGE });

                return;
            }

            deleteButtons.each(function () {
                var $this = $(this),
                    experienceId = $this.data("experience-id");

                experience = self.model.findAssetById(experienceId);
                isDeletable = self.isDeletable(experience);

                $this.toggleClass("delete", isDeletable);
                $this.toggleClass("disabled", !isDeletable);

                if (isDeletable) {
                    Tooltip.remove($this);
                } else {
                    Tooltip.create($this, { width: width, content: NOT_ALLOWED_MESSAGE });
                }
            });
        },

        /**
         * Check if the current role has permission to delete an experience. If an experience is assigned to a breakpoint
         * and it is pushed, it is not allowed to delete. Note: also checking both the spectator and publisher role.
         *
         * @param asset       The asset/experience to be checked
         * @returns {boolean} True the current user is allowed to delete the asset, otherwise not allowed
         */
        isDeletable: function isDeletable(asset) {
            var entries = this.options.pushed.entries(),
                spectator = Permissions.Privileges.CREATE.cannot(),
                publisher = Permissions.Privileges.PUBLISH.can(),
                pushed = asset.hasAtLeastState(PublishableState.PUSHED),
                deletable = pushed && publisher || !pushed && !spectator;

            // If an asset is pushed and is assigned to a breakpoint, then it is not deletable
            var isPushedAndAssigned = _.find(entries, function (entry) {
                return entry[0] && entry[0].get("id") === asset.id && entry[1];
            });

            return deletable && !isPushedAndAssigned;
        },

        /**
         * Open a modal where experience variants can be assigned to breakpoints
         */
        openAssignModal: function openAssignModal() {
            var breakpointAssignView = new BreakpointAssignView({
                model: this.model
            });

            var lightboxOptions = {
                win: false,
                css: {
                    width: 700
                },
                editorEventProperties: {
                    groupId: this.model.get("id"),
                    groupType: this.model.get("type"),
                    groupVersion: this.model.get("version"),
                    groupPushedVersion: this.model.get("pushedVersion"),
                    modalType: "BreakpointAssign",
                    triggerOrigin: "BreakpointAssignModal"
                }
            };

            var box = new Lightbox(breakpointAssignView, lightboxOptions);
            box.open();
        },
        addVariantFromOtherExperience: function addVariantFromOtherExperience(currentExperience) {
            new ActionSequence().add(new AddBreakpointAction(this.model, currentExperience, this.options.project)).add(new NavigateToExperienceAction()).execute();
        },
        addVariant: function addVariant() {
            new ActionSequence().add(new AddBreakpointAction(this.model, this._currentExperience, this.options.project)).add(new NavigateToExperienceAction()).execute();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        EditorEvents = __webpack_require__(17),
        GroupAsset = __webpack_require__(525),
        GroupDescriptor = __webpack_require__(371),
        LoggedInUserState = __webpack_require__(19),
        Marionette = __webpack_require__(10),
        Permissions = __webpack_require__(22),
        template = __webpack_require__(2954),
        Tooltip = __webpack_require__(35);

    /**
     * View for assigning the experiences to breakpoints.
     *
     * @class BreakpointAssignView
     * @constructor
     *
     * @cfg {GroupAssetCollection} collection The GroupAssetCollection.
     */
    return Marionette.ItemView.extend({

        template: template,

        useNewBreakpoints: false,

        ui: {
            ok: ".ok-btn",
            cancel: ".cancel-btn",
            selects: ".select-experience",
            update: ".update-btn"
        },

        events: {
            "click @ui.ok": "saveBreakpoints",
            "click @ui.cancel": "close",
            "click @ui.update": "applyNewBreakpoints"
        },

        templateHelpers: function templateHelpers() {
            return {
                permissionToManage: Permissions.Privileges.CREATE.can(),
                assets: this.assets,
                experiences: this.experiences,
                breakpointModified: this.isBreakpointModified()
            };
        },

        initialize: function initialize() {
            this.breakpointCollection = LoggedInUserState.get("companySettings").get("breakpoints");

            this.lowerBoundsInSetting = this.breakpointCollection.getLowerBounds();
            this.experiences = this.model.getSortedAssets();
        },

        onBeforeRender: function onBeforeRender() {
            this.assets = this._getAssets();
        },

        onRender: function onRender() {
            var thresholds = this.breakpointCollection.getThresholds();

            // There is no "and" if we only have one breakpoint.
            var thresholdsText = thresholds.length === 1 ? thresholds + "px" : _.initial(thresholds).join("px, ") + "px and " + _.last(thresholds) + "px";

            Tooltip.create(this.ui.update, {
                content: "The Breakpoint Settings have been changed to " + thresholdsText + ".",
                width: 200,
                placement: "top"
            });
        },

        // Update the flag of whether we should use the new breakpoint settings and rerender
        applyNewBreakpoints: function applyNewBreakpoints() {
            this.useNewBreakpoints = true;
            this.render();

            var eventProperties = {
                groupId: this.model.get("id"),
                groupType: this.model.get("type"),
                groupVersion: this.model.get("version"),
                groupPushedVersion: this.model.get("pushedVersion"),
                triggerOrigin: "BreakpointAssignModalUpdateButton"
            };

            EditorEvents.trigger(EditorEvents.constants.UPDATE_BREAKPOINT, eventProperties);
        },

        isBreakpointModified: function isBreakpointModified() {
            if (this.useNewBreakpoints) {
                return false;
            }

            return !this.model.compareThresholds(this.lowerBoundsInSetting);
        },

        getLowerBounds: function getLowerBounds() {
            var breakpoints = this.model.getValues();

            if (!breakpoints.length || this.useNewBreakpoints) {
                breakpoints = this.lowerBoundsInSetting;
            }

            return _.sortBy(breakpoints, function (breakpoint) {
                return breakpoint.get("threshold");
            });
        },

        _getAssets: function _getAssets() {
            var self = this,
                lowerBounds = this.getLowerBounds(),
                naming = this.breakpointCollection.generateNaming(lowerBounds.length - 1);

            return _.map(lowerBounds, function (breakpoint, index) {
                //  As a fallback, each breakpoint is associated with the first experience
                var experience = self.model.getAssetByThreshold(breakpoint.get("threshold")) || self.experiences[0];

                return [naming[index], breakpoint, experience];
            });
        },

        saveBreakpoints: function saveBreakpoints() {
            var self = this,
                updated = false,
                reassigned = false,
                assignedIds = _.pluck(self.ui.selects, "value"),
                assets = this.model.getAssets();

            _.each(assignedIds, function (id, index) {
                if (id !== self.assets[index][2].id) {
                    updated = true;
                }
            });

            // Don't do anything if there is no changes, so we don't bump up the model version
            if (updated || this.useNewBreakpoints) {
                var entries = _.map(this.getLowerBounds(), function (breakpoint, index) {
                    var experienceId = self.ui.selects[index].value,
                        experience = _.findWhere(self.experiences, { id: experienceId });

                    var l = assets.length;

                    while (l--) {
                        var asset = assets[l];
                        if (asset.get("id") === experienceId) {
                            assets.splice(l, 1);
                            break;
                        }
                    }

                    // Need a breakpoint clone, otherwise we can not detect breakpoint changes due to the same reference
                    return GroupAsset.asAsset(experience, breakpoint.clone(), GroupDescriptor.ValueType.BREAKPOINT);
                });

                // Make sure we remember all assets (experiences) not chosen by the user for a breakpoint...
                _.each(assets, function (asset) {
                    entries.push(GroupAsset.asAsset(asset, null, GroupDescriptor.ValueType.BREAKPOINT));
                });

                reassigned = true;

                self.model.get("entries").reset(entries);
                self.model.save();
            }

            var eventProperties = {
                groupId: self.model.get("id"),
                groupType: self.model.get("type"),
                groupVersion: self.model.get("version"),
                groupPushedVersion: self.model.get("pushedVersion"),
                triggerOrigin: "BreakpointAssignModalOkButton",
                reassigned: reassigned
            };

            EditorEvents.trigger(EditorEvents.constants.SAVE_BREAKPOINT, eventProperties);

            this.close();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2954 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="breakpoints-assign-lightbox">\n    <h2>Assign Breakpoint Variants</h2>\n    <p class="intro">Assign your Breakpoint Variants to the intervals in which you want them to be shown.</p>\n\n    <ul class="breakpoints-flex-section list-unstyled">\n        ';
 _.each(assets, function(asset, index) { ;
__p += '\n            <li class="breakpoint-flex-item">\n                <div class="interval-indicator ' +
__e( asset[0] ) +
'">' +
__e( asset[0] ) +
'</div>\n                <select class="select-experience" ' +
__e( permissionToManage ? "" : "disabled" ) +
'>\n                    ';
 _.each(experiences, function(experience, index) { ;
__p += '\n                    <option value="' +
__e( experience.id ) +
'" ' +
__e( experience.id === asset[2].id ? "selected" : "" ) +
'>#' +
__e( index + 1 ) +
' ' +
__e( experience.get("name") ) +
'</option>\n                    ';
 }); ;
__p += '\n                </select>\n                <div class="breakpoint-value">' +
__e( asset[1].get('threshold') ) +
' px</div>\n            </li>\n        ';
 }); ;
__p += '\n    </ul>\n\n    <div class="actions">\n        ';
 if (breakpointModified) { ;
__p += '\n        <button class="update-btn btn btn-secondary pull-left" ' +
__e( permissionToManage ? "" : "disabled" ) +
'><span class="glyphicon glyphicon-exclamation-sign"></span> Update Breakpoints</button>\n        ';
 } ;
__p += '\n        <button class="ok-btn btn btn-primary pull-right ladda-button" ' +
__e( permissionToManage ? "" : "disabled" ) +
'>OK</button>\n        <button class="cancel-btn btn btn-secondary pull-right">Cancel</button>\n    </div>\n</section>\n';

}
return __p
}

/***/ }),
/* 2955 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="nav-bar">\n    <div class="' +
__e( newDashboardExperience ? "fastr-frontend-logo-container" : "logo-container" ) +
'">\n        <a href="' +
__e( newDashboardExperience ? config.contentControlUrl : "#" ) +
'" class="logo"></a>\n    </div>\n    ';
 if (!newDashboardExperience) { ;
__p += '\n        <div class="project-buttons-container">\n            <div class="project-selector-btn';
 if (currentProject) { ;
__p += ' in-project-context';
 } ;
__p += '">\n                <div class="project-btn-icon"></div>\n                <div class="project-btn-txt">Projects</div>\n            </div>\n            ';
 if (currentProject) { ;
__p += '\n                <a class="project-context-btn" href="#project/' +
__e( currentProjectId ) +
'" title="' +
__e( currentProjectName ) +
'">' +
__e( currentProjectName ) +
'</a>\n            ';
 } ;
__p += '\n        </div>\n    ';
 } ;
__p += '\n    <div class="editor-nav-bar">\n        ';
 if (!group) { ;
__p += '\n        <span class="name-container">\n            <span class="experience-name name-input tour-experience-name" contenteditable="' +
__e( spectator ? "false" : "true" ) +
'"></span>\n        </span>\n        ';
 } ;
__p += '\n            <div class="variants-region"></div>\n            <div id ="c3CollectionsWrapper">\n                <div id="c3collections" class ="c3collection-region"></div>\n            </div>\n        ';
 if(!newDashboardExperience) { ;
__p += '\n            <div class="create-new-variant dropdown ' +
__e( spectator ? " disabled" : "" ) +
'">\n                <a href="#" class="dropdown-toggle' +
__e( spectator ? " disabled" : "" ) +
'" data-toggle="dropdown" ' +
__e( spectator ? " disabled" : "" ) +
'>Variants</a>\n                <ul class="new-variant-ul">\n                    <li class="create-new-locale-variant"></li>\n                    <li class="add-breakpoint-variant' +
__e( canConvertToGroup ? "": " disabled" ) +
'">Breakpoint Variant</li>\n                </ul>\n            </div>\n        ';
 } ;
__p += '\n    </div>\n    <div class="spacer"></div>\n    <div class="spinner" data-spinner-color="#000" data-spinner-size="20">\n        <div class="ladda-label"></div>\n    </div>\n    <div class="current-principal"></div>\n</div>\n\n<div class="experience-options-panel"></div>\n';

}
return __p
}

/***/ }),
/* 2956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = VariantComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SwitchVariant__ = __webpack_require__(2957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AssignBreakpoint__ = __webpack_require__(2959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MoveExperience__ = __webpack_require__(2962);









var LoggedInUserState = __webpack_require__(19);
var useStyles = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["s" /* makeStyles */])(function () { return ({
    placeholder: {
        color: "#ffffff",
    },
    boxStyles: {
        display: "flex",
        justifyContent: "center",
        marginBottom: "4px",
    },
    menuItemStyles: {
        color: "#000",
        backgroundColor: "#ffffff",
        width: "150px",
        height: "24px",
        cursor: "pointer",
        fontSize: "14px",
        "&:first-child": {
            backgroundColor: "#ffffff",
            "&:hover": {
                backgroundColor: "#ebf0f1",
            }
        }
    },
    selectStyles: {
        color: "#fff",
        backgroundColor: "#000",
        fontSize: "14px",
        width: "100px",
        height: "25px",
        border: "1px",
        borderStyle: "solid",
        borderColor: "#c6c6c6",
        borderRadius: "5px",
        "& .MuiSelect-icon": {
            top: "4px",
            color: "#ffffff",
            right: "10px",
            position: "absolute",
        },
        loaderStyle: {
            color: "#ffffff",
            top: "4px",
        }
    }
}); });
function VariantComponent(props) {
    var experience = props.experience, handleChangeVariant = props.handleChangeVariant, handleCreateVariant = props.handleCreateVariant, handleSave = props.handleSave;
    var classes = useStyles();
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), loading = _a[0], setLoading = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(), collectionDetails = _b[0], setCollectionDetails = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]), currentLanguageExperiences = _c[0], setCurrentLanguageExperiences = _c[1]; //Contain experienceDetails { expID, thershold, lang }[]
    var _d = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(), allExperienceJSON = _d[0], setAllExperienceJSON = _d[1]; //contain ExperienceJson all experinces in the collection.
    var _e = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]), currentLangUniqueExperiences = _e[0], setCurrentLangUniqueExperiences = _e[1]; //unique experienceId of current Language.
    var _f = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), render = _f[0], toggleRender = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), isBaseExperience = _g[0], setIsBaseExperience = _g[1];
    var _h = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""), baseExpId = _h[0], setBaseExpId = _h[1];
    var _j = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), isMultiLanguageExperience = _j[0], setIsMultiLanguageExperience = _j[1];
    var _k = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), createBreakpointAfterSave = _k[0], setCreateBreakpointAfterSave = _k[1];
    var _l = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), isBreakpointAlreadyCreated = _l[0], setIsBreakpointAlreadyCreated = _l[1];
    var _m = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), switchVariantAfterSave = _m[0], setswitchVariantAfterSave = _m[1];
    var _o = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""), experienceIdToSwitch = _o[0], setExperienceIdToSwitch = _o[1];
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        getCollection();
    }, [render]);
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        var executeExperienceSaved = function (event) {
            if (createBreakpointAfterSave) {
                event.stopImmediatePropagation();
                setCreateBreakpointAfterSave(false);
                addVariant(isBreakpointAlreadyCreated);
            }
        };
        var executeSwitchExperienceSaved = function (event) {
            if (switchVariantAfterSave) {
                event.stopImmediatePropagation();
                setswitchVariantAfterSave(false);
                setExperienceIdToSwitch("");
                handleChangeVariant(experienceIdToSwitch);
            }
        };
        if (createBreakpointAfterSave) {
            window.addEventListener("experienceSaved", executeExperienceSaved);
            return function () {
                window.removeEventListener("experienceSaved", executeExperienceSaved);
            };
        }
        if (switchVariantAfterSave) {
            window.addEventListener("experienceSaved", executeSwitchExperienceSaved);
            return function () {
                window.removeEventListener("experienceSaved", executeSwitchExperienceSaved);
            };
        }
    }, [createBreakpointAfterSave, switchVariantAfterSave]);
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        if (collectionDetails) {
            var currentLanguage_1 = experience.get("language");
            var currentLanguageExperience = collectionDetails.experiences.filter(function (exp) { return exp.language === currentLanguage_1; });
            setCurrentLanguageExperiences(currentLanguageExperience);
        }
    }, [collectionDetails]);
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        var experienceList = currentLanguageExperiences.map(function (exp) { return exp.experienceId; });
        var unique_experiences = Array.from(new Set(experienceList));
        // As one experience can be assigned to multiple threshold
        // So we have show only unique experience for switching in Nav Bar.
        setCurrentLangUniqueExperiences(unique_experiences);
    }, [currentLanguageExperiences]);
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        if (allExperienceJSON && isBaseExperience) {
            currentLangUniqueExperiences.forEach(function (experienceId) {
                var experience = allExperienceJSON[experienceId];
                if (experience) {
                    var parentExperienceId = experience.parentExperienceId, id = experience.id;
                    if (!parentExperienceId)
                        setBaseExpId(id);
                }
            });
        }
    }, [allExperienceJSON]);
    /**
     * This method return child experienceId of experienceId passed.
     * @param expId , experienceID for which we have to find child ExperienceId.
     * @param language, Language in which have to find ChildExperience.
     * @returns{string} child experienceId of expId.
     */
    var getChildExpIdForLang = function (expId, language) {
        var childExperienceId = collectionDetails.experiences
            .filter(function (expDetail) { return expDetail.language === language; })
            .map(function (expDetail) { return expDetail.experienceId; })
            .find(function (experienceId) { return allExperienceJSON[experienceId].parentExperienceId === expId; });
        return childExperienceId;
    };
    var handleLastBreakpoint = function (updatedCollectionDetails, currentLangauge) {
        // if only one breakpoint is remaining delete all the breakpoints and assign threshold zero
        var experienceList = [];
        updatedCollectionDetails.experiences.forEach(function (_a) {
            var experienceId = _a.experienceId, language = _a.language;
            if (language == currentLangauge) {
                experienceList.push(experienceId);
            }
        });
        var unique_experiences = Array.from(new Set(experienceList));
        if (unique_experiences.length == 1) {
            Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["remove"])(updatedCollectionDetails.experiences, function (_a) {
                var experienceId = _a.experienceId;
                return unique_experiences[0] == experienceId;
            });
            updatedCollectionDetails.experiences.unshift({
                experienceId: unique_experiences[0],
                threshold: 0,
                language: currentLangauge
            });
        }
        return updatedCollectionDetails;
    };
    var getAllChildExperiencesForDeletion = function (expId, language) {
        //first get list of all the experiences in which we have to search for parentExpID
        var listToSearch = [];
        // get all expIds of non-base experience
        collectionDetails.experiences.forEach(function (item) {
            if (item.language !== language) {
                listToSearch.push(item.experienceId);
            }
        });
        var uniqueList = Array.from(new Set(listToSearch));
        var childExpIds = [];
        uniqueList.forEach(function (item) {
            if (allExperienceJSON[item].parentExperienceId == expId) {
                childExpIds.push(item);
            }
        });
        return childExpIds;
    };
    var handleMultipleThreshold = function (currentLangExperiences, variantId, updatedCollectionDetails, allVariants) {
        var newExperienceDetails = currentLangExperiences.find(function (item) {
            return item.experienceId !== variantId && item.threshold != null;
        });
        // for case where we don't have a non-null threshold experience id we'll just fetch the first one to replace
        if (!newExperienceDetails) {
            newExperienceDetails = currentLangExperiences.find(function (item) {
                if (item.experienceId !== variantId) {
                    var mainindex = updatedCollectionDetails.experiences.findIndex(function (variant) { return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(variant, item); });
                    //remove the record as we'll assign this id to a threshold ahead
                    updatedCollectionDetails.experiences.splice(mainindex, 1);
                    return item;
                }
            });
        }
        var expIdsToReplaceIndex = [];
        allVariants.forEach(function (variantDetail) {
            expIdsToReplaceIndex.push(updatedCollectionDetails.experiences.findIndex(function (item) { return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(item, variantDetail); }));
        });
        if (newExperienceDetails) {
            expIdsToReplaceIndex.forEach(function (index) {
                updatedCollectionDetails.experiences[index].experienceId = newExperienceDetails.experienceId;
            });
        }
        return updatedCollectionDetails;
    };
    //handling of breakpoints if user deletes a variant
    var getUpdatedCollectionDetails = function (variantId, language, collectionDetails) {
        var currentLangExperiences = collectionDetails.experiences.filter(function (exp) { return exp.language === language; });
        var allVariants = currentLangExperiences.filter(function (item) { return item.experienceId === variantId; });
        var updatedCollectionDetails = structuredClone(collectionDetails);
        //if experience is assigned to 1 threshold
        if (allVariants.length == 1) {
            var expToDelete_1 = allVariants[0];
            if (allVariants[0].threshold == null) {
                // find the index in experience collection for this one
                var mainIndex = collectionDetails.experiences.findIndex(function (item) { return item.experienceId == expToDelete_1.experienceId; });
                updatedCollectionDetails.experiences.splice(mainIndex, 1);
            }
            else { //handle if null is not assigned to it
                //find any experience id other than current one and assign it to that breakpoint also              
                var newExperienceDetails = currentLangExperiences.find(function (item) {
                    return item.experienceId !== expToDelete_1.experienceId && item.threshold != null;
                });
                // for case where we don't have a non-null threshold experience id we'll just fetch the first one to replace
                if (!newExperienceDetails) {
                    newExperienceDetails = currentLangExperiences.find(function (item) {
                        if (item.experienceId !== variantId) {
                            var mainindex = updatedCollectionDetails.experiences.findIndex(function (variant) { return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(variant, item); });
                            //remove the record as we'll assign this id to a threshold ahead
                            updatedCollectionDetails.experiences.splice(mainindex, 1);
                            return item;
                        }
                    });
                }
                var mainIndex = updatedCollectionDetails.experiences.findIndex(function (item) { return Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["isEqual"])(item, expToDelete_1); });
                if (newExperienceDetails) {
                    updatedCollectionDetails.experiences[mainIndex].experienceId = newExperienceDetails.experienceId;
                }
            }
        }
        else {
            // if experience is assigned to multiple thresholds
            // find any experience id other than current one and assign it to that breakpoint also
            updatedCollectionDetails = handleMultipleThreshold(currentLangExperiences, variantId, updatedCollectionDetails, allVariants);
        }
        updatedCollectionDetails = handleLastBreakpoint(updatedCollectionDetails, language);
        return updatedCollectionDetails;
    };
    var handleChildChange = function (userEvent) {
        if (userEvent.event === __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* Events */].SWITCH_VARIANT) {
            if (Object.keys(experience.changed).length === 1) {
                handleChangeVariant(userEvent.variantExperienceId);
            }
            else { // in case something on the editor isn't saved we save again and then switch variant
                setExperienceIdToSwitch(userEvent.variantExperienceId);
                setswitchVariantAfterSave(true);
                handleSave();
            }
        }
        else if (userEvent.event === __WEBPACK_IMPORTED_MODULE_5__Constants__["a" /* Events */].ADD_VARIANT) {
            handleCreateVariant(collectionDetails);
        }
        else { //for delete handle here
            if (window.confirm("Are you sure you want to Delete this Variant ?")) {
                var updatedCollectionDetails_1 = getUpdatedCollectionDetails(userEvent.variantExperienceId, allExperienceJSON[userEvent.variantExperienceId].language, collectionDetails);
                var childexps = getAllChildExperiencesForDeletion(userEvent.variantExperienceId, experience.get("language"));
                // handle cases for all childexps in different languages if any
                if (childexps.length) {
                    childexps.forEach(function (expId) {
                        updatedCollectionDetails_1 = getUpdatedCollectionDetails(expId, allExperienceJSON[expId].language, updatedCollectionDetails_1);
                    });
                }
                // if user chooses to delete an experience he's not currently on/ delete a experience not on canvas
                // update and render
                if (userEvent.variantExperienceId !== userEvent.currentExperienceId) {
                    Object(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__["updateC3ExpCollection"])(updatedCollectionDetails_1).then(function () {
                        toggleRender(function (prev) { return !prev; });
                    });
                }
                else {
                    // if user chooses to delete an experience he's currently on we get the unique experience and navigate to #1 as in legacy
                    //navigate to #1 and thus rerender
                    var currentLangExperiences = updatedCollectionDetails_1.experiences.filter(function (exp) { return exp.language === experience.get("language"); });
                    var experienceList = currentLangExperiences.map(function (exp) { return exp.experienceId; });
                    var unique_experiences_1 = Array.from(new Set(experienceList));
                    Object(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__["updateC3ExpCollection"])(updatedCollectionDetails_1).then(function () {
                        handleChangeVariant(unique_experiences_1[0]);
                    });
                }
            }
        }
    };
    var addVariant = function (isBreakpointAlreadyCreated) {
        var currentLangauge = experience.get("language");
        var _collections = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["cloneDeep"])(collectionDetails);
        var defaultLanguage = _collections.defaultLanguage, experiences = _collections.experiences;
        var allExpLanguages = experiences.map(function (exp) { return exp.language; });
        var uniqueLanguages = Array.from(new Set(allExpLanguages));
        var existingThreshold = _collections.experiences[0].threshold;
        var mappedLangEperienceId;
        var parentExperienceId;
        if (currentLangauge === defaultLanguage) { //In Case of Base Experiences => Adding Breakpoint Variant to Current and all other languages according to Breakpoints.
            mappedLangEperienceId = _collections.experiences.reduce(function (acc, exp) {
                acc[exp.language] = exp.experienceId;
                return acc;
            }, {});
        }
        else { // In Case of Non - Base Experiences => Adding Breakpoint Variant to Current language according to Breakpoints.
            mappedLangEperienceId = _collections.experiences.reduce(function (acc, exp) {
                if (exp.language === currentLangauge) {
                    acc[exp.language] = exp.experienceId;
                }
                return acc;
            }, {});
            uniqueLanguages = [currentLangauge];
            existingThreshold = currentLanguageExperiences[0].threshold;
            parentExperienceId = currentLanguageExperiences[0].experienceId;
        }
        var newExpCollectionToAdd = [];
        if (!isBreakpointAlreadyCreated) {
            var thresholdToAssign_1 = LoggedInUserState.get("companySettings").get("breakpoints")
                .getLowerBounds()
                .map(function (breakpoint) {
                var threshold = breakpoint.get("threshold");
                if (existingThreshold !== threshold) {
                    return threshold;
                }
            })
                .filter(function (threshold) { return threshold; });
            // Create Device variant according to Threshold
            uniqueLanguages.forEach(function (language) {
                var experienceId = mappedLangEperienceId[language];
                thresholdToAssign_1.forEach(function (threshold) {
                    newExpCollectionToAdd.push({
                        experienceId: experienceId,
                        threshold: threshold,
                        language: language
                    });
                });
            });
        }
        //Now Create one Experience for all the languages in {uniqueLanguages};
        Object(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__["getC3ExperienceById"])(experience.get("id"))
            .then(function (experienceJson) {
            setAllExperienceJSON(function (prev) {
                var _a;
                return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, prev, (_a = {}, _a[experienceJson.id] = experienceJson, _a)));
            });
            return experienceJson;
        }).then(function (experienceJson) {
            return Promise.all(uniqueLanguages.map(function (language) {
                // let experienceId = mappedLangEperienceId[language];
                var clone;
                if (language === currentLangauge) {
                    clone = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["omit"])(experienceJson, ["id", "version"]);
                }
                else {
                    var nonBaseExpId = getChildExpIdForLang(experience.get("id"), language);
                    clone = Object(__WEBPACK_IMPORTED_MODULE_6_lodash__["omit"])(allExperienceJSON[nonBaseExpId], ["id", "version"]);
                }
                clone.name = clone.name + " (new)";
                clone.version = 1;
                return Object(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__["createC3Experience"])(clone);
            }));
        }).then(function (experienceJsonArr) {
            var newBaseExpId;
            experienceJsonArr.forEach(function (_a) {
                var id = _a.id, language = _a.language;
                if (language === defaultLanguage) {
                    newBaseExpId = id;
                }
                newExpCollectionToAdd.push({
                    experienceId: id,
                    threshold: null,
                    language: language
                });
            });
            experienceJsonArr.forEach(function (_a) {
                var id = _a.id, language = _a.language;
                // for base experience i.e exp with default language , parent will be exp with threshold 0.
                if (language === defaultLanguage) {
                    parentExperienceId = experiences.find(function (_a) {
                        var language = _a.language, threshold = _a.threshold;
                        return (language === defaultLanguage) && (threshold === 0);
                    }).experienceId;
                    Object(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__["c3CreateVariantFromParent"])(parentExperienceId, id)
                        .then(function () {
                        handleChangeVariant(newBaseExpId);
                    });
                }
                else {
                    Object(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__["c3CreateVariantFromParent"])(newBaseExpId, id);
                }
            });
        }).then(function () {
            var _a;
            (_a = _collections.experiences).push.apply(_a, newExpCollectionToAdd);
            Object(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__["updateC3ExpCollection"])(_collections);
        });
    };
    // This method is used to create/add device variant.
    var createDeviceVariant = function (isBreakpointAlreadyCreated) {
        if (isBreakpointAlreadyCreated === void 0) { isBreakpointAlreadyCreated = false; }
        // if everything is already saved we create a variant without triggering save again
        if (Object.keys(experience.changed).length === 1) {
            addVariant(isBreakpointAlreadyCreated);
        }
        else { // in case something on the editor isn't saved we save again and then create variant
            setCreateBreakpointAfterSave(true);
            setIsBreakpointAlreadyCreated(isBreakpointAlreadyCreated);
            handleSave();
        }
    };
    var getCollection = function () {
        try {
            var query = new URLSearchParams(window.location.search), expCollectionId = query.get("collectionId");
            setLoading(true);
            var a = Object(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__["getC3ExpCollectionById"])(expCollectionId);
            a.then(function (data) {
                //here data represents collection
                setCollectionDetails(data);
                var currentLanguage = experience.get("language");
                var experiences = data.experiences, defaultLanguage = data.defaultLanguage;
                if (currentLanguage === defaultLanguage) {
                    setIsBaseExperience(true);
                }
                else {
                    setIsBaseExperience(false);
                }
                ;
                setLoading(false);
                var allUniqueExperiences = Array.from(new Set(experiences.map(function (_a) {
                    var experienceId = _a.experienceId;
                    return experienceId;
                })));
                var allLanguages = Array.from(new Set(experiences.map(function (_a) {
                    var language = _a.language;
                    return language;
                })));
                allLanguages.length > 1 ? setIsMultiLanguageExperience(true) : setIsMultiLanguageExperience(false);
                return allUniqueExperiences;
            })
                .then(function (allUniqueExperiences) {
                if (!allUniqueExperiences.length)
                    return;
                //Fetch all the experienceJson of current language
                Promise.all(allUniqueExperiences.map(function (experienceId) { return Object(__WEBPACK_IMPORTED_MODULE_7__C3Services_contentControl__["getC3ExperienceById"])(experienceId); }) // Fetch all Exp.
                ).then(function (experienceJsonArr) {
                    setAllExperienceJSON(experienceJsonArr.reduce(function (obj, experienceJSON) {
                        obj[experienceJSON.id] = experienceJSON;
                        return obj;
                    }, {}));
                });
            });
        }
        catch (error) {
            console.log(error);
        }
    };
    var renderLoader = function () { return (
    /* @ts-ignore */
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["c" /* Box */], { style: { display: "flex", justifyContent: "center", alignItems: "center" } },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["e" /* CircularProgress */], { size: 25, classes: {
                colorPrimary: classes.loaderStyle
            } }))); };
    var DropdownLabel = function (_a) {
        var children = _a.children;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: classes.placeholder }, children);
    };
    var renderDropdown = function () {
        return (
        /* @ts-ignore */
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["c" /* Box */], { className: classes.boxStyles },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["o" /* Select */], { className: classes.selectStyles, disableUnderline: true, MenuProps: {
                    anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                    },
                    getContentAnchorEl: null
                }, id: "breakpoint-variant-dropdown", value: "Variants", onChange: function () { return createDeviceVariant(false); }, renderValue: function () { return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DropdownLabel, null, "Variants"); } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["n" /* MenuItem */], { className: classes.menuItemStyles }, "Breakpoint Variant"))));
    };
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, loading ? renderLoader() : (currentLangUniqueExperiences.length > 1 ? (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["j" /* Grid */], { container: true, direction: "row", alignItems: "center" },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SwitchVariant__["a" /* default */], { uniqueExperiences: currentLangUniqueExperiences, handleChildEvent: handleChildChange, currentExperienceId: experience.id, createDeviceVariant: createDeviceVariant, baseExperience: isBaseExperience, baseExperienceId: baseExpId }),
        isBaseExperience &&
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__AssignBreakpoint__["a" /* default */], { currentLanguageExperiences: currentLanguageExperiences, currentLanguageExpJSON: allExperienceJSON, uniqueExperiences: currentLangUniqueExperiences, collectionDetails: collectionDetails, setCollectionDetails: setCollectionDetails, getChildExpIdForLang: getChildExpIdForLang }),
        " ",
        !isMultiLanguageExperience &&
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MoveExperience__["a" /* default */], { handleChangeVariant: handleChangeVariant, collectionDetails: collectionDetails, baseExperienceId: baseExpId, setAllExperienceJSON: setAllExperienceJSON }))) : (isBaseExperience && renderDropdown()))));
}


/***/ }),
/* 2957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SwitchVariant;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Add__ = __webpack_require__(2958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Constants__ = __webpack_require__(1231);





var useStyles = Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["s" /* makeStyles */])(function () { return ({
    boxStyles: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "row"
    },
    plusIcon: {
        color: "#868686",
        cursor: "pointer",
        '&:hover': {
            color: '#ffffff'
        }
    },
    variantIcon: {
        display: "flex",
        position: "relative",
        width: "26px",
        height: "26px",
        cursor: "pointer",
        padding: "2px",
        textAlign: "center",
        border: "1px",
        borderStyle: "solid",
        borderColor: "#868686",
        justifyContent: "center",
        alignItems: "center",
        color: "#868686",
        margin: "4px",
        '&:hover': {
            borderColor: '#ffffff',
            color: '#ffffff'
        }
    },
    selected: {
        borderColor: '#ffffff',
        color: '#ffffff'
    },
    tooltipPopper: {
        width: "200px !important",
        borderRadius: '1px',
        backgroundColor: '#fff',
        top: "5px !important"
    },
    tooltipLabel: {
        backgroundColor: '#fff',
        height: "54px",
        fontSize: "1rem",
        fontWeight: 500,
        color: 'black',
        margin: "0px",
        "& .MuiTooltip-arrow": {
            color: "#fff",
            "&:before": {
                border: "1px solid #343e43"
            },
        }
    }
}); });
var BaseExpTooltipText = function () { return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", { style: {
        textAlign: "center",
    } }, "Changes made to this experience would be automatically reflected in all other variants and breakpoints combinations.")); };
function SwitchVariant(props) {
    var uniqueExperiences = props.uniqueExperiences, currentExperienceId = props.currentExperienceId, handleChildEvent = props.handleChildEvent, createDeviceVariant = props.createDeviceVariant, baseExperience = props.baseExperience, baseExperienceId = props.baseExperienceId;
    var classes = useStyles();
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined), hoveredIndex = _a[0], setHoveredIndex = _a[1];
    var changeVariant = function (mouseEvent) {
        var userEvent = {
            event: __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Events */].SWITCH_VARIANT,
            variantExperienceId: mouseEvent.currentTarget.getAttribute("data-experience-id")
        };
        handleChildEvent(userEvent);
    };
    var deleteVariant = function (mouseEvent, experienceId) {
        var userEvent = {
            event: __WEBPACK_IMPORTED_MODULE_3__Constants__["a" /* Events */].DELETE_VARIANT,
            variantExperienceId: experienceId,
            currentExperienceId: currentExperienceId
        };
        mouseEvent.stopPropagation();
        handleChildEvent(userEvent);
    };
    var generateVariantIcon = function (experienceId, index) {
        var favIconStyle = {
            position: "absolute",
            width: "1.4rem",
            height: "1.4rem",
            top: "-0.7rem",
            left: "-0.7rem",
        };
        var favIcon = false;
        if (experienceId === baseExperienceId)
            favIcon = true;
        return (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["q" /* Tooltip */], { classes: {
                popper: classes.tooltipPopper,
                tooltip: classes.tooltipLabel,
            }, arrow: true, title: favIcon ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BaseExpTooltipText, null) : "", TransitionProps: { timeout: 0 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", { onClick: function (e) { return changeVariant(e); }, "data-experience-id": experienceId, className: experienceId === currentExperienceId
                    ? classes.variantIcon + " " + classes.selected
                    : classes.variantIcon, key: index, onMouseEnter: function () { return setHoveredIndex(index); }, onMouseLeave: function () { return setHoveredIndex(undefined); } },
                favIcon && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", { src: "../../../../images/icons/star.png", style: favIconStyle }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", { onClick: function (e) { return deleteVariant(e, experienceId); }, style: {
                        display: baseExperience ? (hoveredIndex === index ? "block" : "none") : "none",
                        position: "absolute",
                        top: "-7px",
                        right: "-7px",
                        lineHeight: "14px",
                        width: "14px",
                        fontSize: "19px",
                        textAlign: "center",
                        color: "white",
                        borderRadius: "50%",
                        backgroundColor: "#808080",
                    } }, "\u00D7"),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null,
                    "#",
                    index + 1))));
    };
    return (
    /* @ts-ignore */
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["c" /* Box */], { className: classes.boxStyles },
        uniqueExperiences.map(function (experienceId, index) {
            return generateVariantIcon(experienceId, index);
        }),
        baseExperience ? (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Add___default.a, { fontSize: "large", onClick: function () { return createDeviceVariant(true); }, className: classes.plusIcon })) : ("")));
}


/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

var _interopRequireWildcard = __webpack_require__(162);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(163));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');

exports.default = _default;

/***/ }),
/* 2959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AssignBreakpoint;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Close__ = __webpack_require__(2960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Error__ = __webpack_require__(2961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__C3Services_contentControl__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__C3Services_contentControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__C3Services_contentControl__);







var LoggedInUserState = __webpack_require__(19);
var useStyles = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["s" /* makeStyles */])({
    breakpointSection: {
        position: "relative",
        display: "flex",
        flexFlow: "row nowrap",
        margin: "0",
        paddingBottom: "25px",
        color: "#343E43",
    },
    breakpointContainer: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1,
        height: "170px",
        padding: "0px 12px",
        flexFlow: "column nowrap",
        borderLeft: "1px dashed #343E43",
        minWidth: "1px",
        "&:first-child": {
            border: "none",
            "& div#threshold-value": {
                display: "none",
            },
        },
    },
    intervalIndicator: {
        backgroundPosition: "center top",
        height: "35px",
        width: "44px",
        '&[id*="S"]': {
            backgroundImage: "url(../../../../images/settings/icon_bpvariant_mobile.png)",
        },
        '&[id*="Medium"]': {
            backgroundImage: "url(../../../../images/settings/icon_bpvariant_tablet.png)",
        },
        '&[id*="L"]': {
            backgroundImage: "url(../../../../images/settings/icon_bpvariant_desktop.png)",
        },
    },
    breakpointValue: {
        position: "absolute",
        bottom: "-30px",
        left: "-12px",
        width: "70px",
        color: "#343E43",
    },
    assignBreakpointIcon: {
        position: "relative",
        cursor: "pointer",
        backgroundImage: "url(../../../../images/breakpoint_group_ko.png)",
        height: "17px",
        width: "28px",
        margin: "0px 10px",
        opacity: "0.7",
        transition: "0.25s",
        "&:hover": {
            opacity: "1",
        },
    },
    iconWrapper: {
        border: "1px solid #fff",
        borderTop: "none",
        borderBottom: "none",
        margin: "0px 15px",
        padding: '4px',
    },
    breakpointLabel: {
        display: "inlineBlock",
        marginTop: "10px",
    },
    selectBreakpoint: {
        marginTop: "15px",
        width: "95%",
        fontSize: "14px",
    },
    exclamationIcon: {
        position: "absolute",
        top: "-8px",
        right: "-4px",
        color: "#626262",
        backgroundColor: "#fff",
    },
    circularProgress: {
        '&.MuiCircularProgress-colorPrimary': {
            color: "#fff"
        }
    },
    dialog: {
        width: "700px",
        maxWidth: "700px",
        height: "402px",
    },
    dialogHeader: {
        color: "#343E43",
        backgroundColor: "#FFFFFF",
    },
    dialogTitle: {
        padding: "20px",
        flex: 1,
        "& .MuiTypography-root": {
            fontSize: "26px",
            lineHeight: "18px",
            fontWeight: "300",
        },
    },
    subHeading: {
        fontSize: "14px",
        lineHeight: "18px",
        fontWeight: 500,
        fontFamily: "Helvetica Neue,Helvetica,Arial,sans-serif",
        marginBottom: "10px",
        color: "#343e43",
    },
    tooltipPopper: {
        width: "200px",
        borderRadius: '1px',
        backgroundColor: '#fff',
        top: "-10px !important",
    },
    tooltipLabel: {
        backgroundColor: '#fff',
        height: "80px",
        fontSize: "14px",
        fontWeight: 300,
        color: 'black',
        border: '1px solid #343e43',
        margin: "0px",
        "& .MuiTooltip-arrow": {
            color: "#fff",
            "&:before": {
                border: "1px solid #343e43"
            },
        }
    },
    btn: {
        textTransform: "none",
        margin: "0px 12px 12px",
        fontSize: "15px",
        padding: "0 18px",
        height: "32px",
        lineHeight: "32px",
        borderRadius: "0",
        transition: "0.25s",
        "&.MuiButton-contained": {
            color: "#fff",
            backgroundColor: "#8C01FF",
            "&:hover": {
                backgroundColor: "#cd00ff",
                borderColor: "#204d74",
            },
        },
        "&.MuiButton-outlined": {
            border: "1px solid",
            borderColor: "#757575",
            color: "#757575",
            backgroundColor: "#fff",
            "&:hover": {
                backgroundColor: "#fff",
                color: "#8C01FF",
                borderColor: "#8C01FF",
            },
        },
    },
});
function AssignBreakpoint(props) {
    var _this = this;
    var expCollections = props.currentLanguageExperiences, currentLanguageExpJSON = props.currentLanguageExpJSON, uniqueExperiences = props.uniqueExperiences, collectionDetails = props.collectionDetails, setCollectionDetails = props.setCollectionDetails, getChildExpIdForLang = props.getChildExpIdForLang;
    var classes = useStyles();
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), open = _a[0], setOpen = _a[1];
    var defaultLanguage = collectionDetails.defaultLanguage; // represent base language.
    var currentLanguage = expCollections[0].language; // represent language of current exp opened in editor.
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(expCollections), updatedExpCollections = _b[0], setUpdatedExpCollections = _b[1];
    var _c = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]), existingThresholds = _c[0], setExistingThresholds = _c[1];
    var _d = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), breakpointsUpdated = _d[0], setBreakpointsUpdated = _d[1];
    var _e = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])([]), breakpointNames = _e[0], setBreakpointNames = _e[1];
    var breakpointCollection = LoggedInUserState.get("companySettings").get("breakpoints");
    var lowerBounds = breakpointCollection.getLowerBounds();
    var thresholdValues = lowerBounds.map(function (breakpoint) { return breakpoint.get("threshold"); }); // [0,768,992]
    var _f = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])({}), experienceCount = _f[0], setExperienceCount = _f[1];
    var _g = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), updatingBreakpoints = _g[0], setUpdatingBreakpoints = _g[1];
    var _h = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""), tooltipText = _h[0], setTooltipText = _h[1];
    var _j = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), updateBreakpointsClicked = _j[0], setUpdateBreakpointsClicked = _j[1];
    var _k = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(collectionDetails.experiences), allExpDetails = _k[0], setAllExpDetails = _k[1];
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        var experienceList = allExpDetails.map(function (exp) { return exp.experienceId; });
        var expCount = experienceList.reduce(function (obj, expId) {
            if (obj[expId])
                obj[expId] += 1;
            else
                obj[expId] = 1;
            return obj;
        }, {});
        setExperienceCount(expCount);
    }, [expCollections, allExpDetails]);
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        var thresholdsList = setupInitialBreakpointView();
        setBreakpointsUpdated(isBreakpintsUpdated(thresholdsList, thresholdValues));
        generateToolTipText();
    }, [expCollections]);
    var generateToolTipText = function () {
        var str = "The breakpoint settings have been changed to";
        var length = thresholdValues.length;
        thresholdValues.slice(1, length - 1).forEach(function (value) { return str += " " + value + ","; });
        str += " and " + thresholdValues[length - 1] + ".";
        setTooltipText(str);
    };
    var handleCancel = function () {
        setOpen(false);
        setupInitialBreakpointView();
        setAllExpDetails(collectionDetails.experiences);
        if (updateBreakpointsClicked) {
            setBreakpointsUpdated(true);
            setUpdateBreakpointsClicked(false);
        }
    };
    var setupInitialBreakpointView = function () {
        setUpdatedExpCollections(expCollections);
        var thresholdsList = expCollections.filter(function (exp) { return exp.threshold !== null; }).map(function (exp) { return exp.threshold; });
        thresholdsList.sort(function (a, b) { return a - b; });
        setExistingThresholds(thresholdsList);
        setBreakpointNames(breakpointCollection.generateNaming(thresholdsList.length - 1));
        return thresholdsList;
    };
    /**
     * This method check if user has actually updated threshold for experiences or not.
     */
    var isExperiencesThresholdUpdated = function (updatedExpCollections) {
        if (updateBreakpointsClicked)
            return true;
        var _loop_1 = function (i) {
            var expId1 = updatedExpCollections.find(function (_a) {
                var threshold = _a.threshold;
                return threshold === existingThresholds[i];
            }).experienceId;
            var expId2 = expCollections.find(function (_a) {
                var threshold = _a.threshold;
                return threshold === existingThresholds[i];
            }).experienceId;
            if (expId1 !== expId2) {
                return { value: true };
            }
        };
        for (var i = 0; i < existingThresholds.length; i++) {
            var state_1 = _loop_1(i);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return false;
    };
    var getTotalLanguages = function () { return Array.from(new Set(collectionDetails.experiences
        .map(function (expDetail) { return expDetail.language; }))); };
    var handleDropdownChange = function (e, thresholdValueToAssign) {
        var currentExperienceId = e.target.value;
        var totalLanguages = getTotalLanguages();
        //Handling the experience to which onChange => thresholdValueToAssign was used.
        var prevExperience = updatedExpCollections.find(function (experience) { return experience.threshold === thresholdValueToAssign; });
        var prevExperienceId = prevExperience.experienceId, prevThreshold = prevExperience.threshold;
        var newExpCollections = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"])(allExpDetails);
        totalLanguages.forEach(function (language) {
            if (language === defaultLanguage) {
                handleThresholdChange(newExpCollections, language, prevExperienceId, prevThreshold, currentExperienceId, thresholdValueToAssign);
            }
            else {
                var childOfPrevExp = getChildExpIdForLang(prevExperienceId, language);
                var childOfNewAssignedExp = getChildExpIdForLang(currentExperienceId, language);
                handleThresholdChange(newExpCollections, language, childOfPrevExp, prevThreshold, childOfNewAssignedExp, thresholdValueToAssign);
            }
        });
        setAllExpDetails(newExpCollections);
    };
    var handleThresholdChange = function (newExpCollections, currentLang, prevExperienceId, prevThreshold, currentExperienceId, thresholdValueToAssign) {
        if (experienceCount[prevExperienceId] > 1) {
            Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["remove"])(newExpCollections, function (_a) {
                var threshold = _a.threshold, language = _a.language;
                return (currentLang === language && threshold === prevThreshold);
            });
            setExperienceCount(function (prev) {
                var _a;
                return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, prev, (_a = {}, _a[prevExperienceId] = prev[prevExperienceId] - 1, _a)));
            });
        }
        else {
            newExpCollections.forEach(function (expDetails) {
                if (expDetails.experienceId === prevExperienceId && expDetails.threshold === prevThreshold) {
                    expDetails.threshold = null;
                    return;
                }
            });
        }
        //Handle the experience which was selected from dropdown.
        var unAssignedExperience = newExpCollections
            .find(function (_a) {
            var experienceId = _a.experienceId, threshold = _a.threshold;
            return (experienceId === currentExperienceId && threshold === null);
        });
        if (unAssignedExperience !== undefined) {
            unAssignedExperience.threshold = thresholdValueToAssign;
        }
        else {
            newExpCollections.push({
                experienceId: currentExperienceId,
                threshold: thresholdValueToAssign,
                language: currentLang,
            });
            setExperienceCount(function (prev) {
                var _a;
                return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, prev, (_a = {}, _a[currentExperienceId] = prev[currentExperienceId] + 1, _a)));
            });
        }
        if (currentLang === currentLanguage) {
            setUpdatedExpCollections(newExpCollections.filter(function (_a) {
                var language = _a.language;
                return language === currentLanguage;
            }));
        }
    };
    /**
     * This method check if user has updated his breakpoint settings
     * @param currentThreshold: Threshold with respect to current experience which is open in editor
     * @param thresholdFromSettings: Threshold value according to the settings
     * @return boolean. true have been updated from settings
     */
    var isBreakpintsUpdated = function (currentThreshold, thresholdFromSettings) {
        var length1 = currentThreshold.length;
        var length2 = thresholdFromSettings.length;
        if (length1 !== length2)
            return true;
        currentThreshold.sort(function (a, b) { return a - b; });
        thresholdFromSettings.sort(function (a, b) { return a - b; });
        while (--length1 >= 0) {
            if (thresholdFromSettings[length1] !== currentThreshold[length1]) {
                return true;
            }
        }
        return false;
    };
    var updateExperienceCollections = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
        var updatedExpCollectionDetails, updatedAllExpDetails, unAssignedExperiences, baseLangExperiences, experiencesInOrder;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
            updatedExpCollectionDetails = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"])(collectionDetails);
            updatedAllExpDetails = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"])(allExpDetails);
            unAssignedExperiences = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["remove"])(updatedAllExpDetails, function (_a) {
                var threshold = _a.threshold;
                return threshold === null;
            });
            baseLangExperiences = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["remove"])(updatedAllExpDetails, function (_a) {
                var language = _a.language;
                return language === defaultLanguage;
            });
            updatedAllExpDetails.sort(function (a, b) { return a.threshold - b.threshold; });
            baseLangExperiences.sort(function (a, b) { return a.threshold - b.threshold; });
            experiencesInOrder = baseLangExperiences.concat(updatedAllExpDetails, unAssignedExperiences);
            if (!isExperiencesThresholdUpdated(experiencesInOrder)) {
                setOpen(false);
                return [2 /*return*/];
            }
            updatedExpCollectionDetails.experiences = experiencesInOrder;
            setUpdatingBreakpoints(true);
            setAllExpDetails(experiencesInOrder);
            setCollectionDetails(updatedExpCollectionDetails);
            Object(__WEBPACK_IMPORTED_MODULE_6__C3Services_contentControl__["updateC3ExpCollection"])(updatedExpCollectionDetails)
                .then(function (response) {
                if (response) {
                    setUpdatingBreakpoints(false);
                    setOpen(false);
                    setUpdateBreakpointsClicked(false);
                }
            });
            return [2 /*return*/];
        });
    }); };
    var updateNonBaseExpCollection = function (nonBaseExpCollections, expDetail, action) {
        var totalLanguages = getTotalLanguages().filter(function (lang) { return lang !== defaultLanguage; });
        var experienceId = expDetail.experienceId;
        var targetExpDetail;
        totalLanguages.forEach(function (language) {
            var childExp = getChildExpIdForLang(experienceId, language);
            targetExpDetail = nonBaseExpCollections
                .find(function (_a) {
                var experienceId = _a.experienceId, threshold = _a.threshold;
                return experienceId === childExp && threshold === expDetail.threshold;
            });
            if (action === 'DELETE') { // In case of multiple entry of same ExperienceId delete the entry.
                Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["remove"])(nonBaseExpCollections, function (_a) {
                    var experienceId = _a.experienceId, threshold = _a.threshold;
                    return (experienceId === targetExpDetail.experienceId) && (threshold === targetExpDetail.threshold);
                });
            }
            else if (action === 'UPDATE') { // In case of only one entry of ExperienceId will assign nulll to threshold.
                targetExpDetail.threshold = null;
            }
            else if (action === 'ADD') { // In case we have to add new threshold to ExperienceId and other entry of experienceId is already assigned
                nonBaseExpCollections.push({
                    experienceId: childExp,
                    threshold: expDetail.threshold,
                    language: language,
                });
            }
        });
    };
    // This function will update the breakpoint assign view when user click on 'Update Breakpoints'
    var handleOnClickUpdate = function () {
        setUpdateBreakpointsClicked(true);
        var newExpCollections = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"])(updatedExpCollections);
        var nonBaseExpCollections = Object(__WEBPACK_IMPORTED_MODULE_5_lodash__["cloneDeep"])(allExpDetails.filter(function (_a) {
            var language = _a.language;
            return language !== defaultLanguage;
        }));
        var allExperienceCount = newExpCollections
            .map(function (exp) { return exp.experienceId; })
            .reduce(function (obj, expId) {
            if (obj[expId])
                obj[expId] += 1;
            else
                obj[expId] = 1;
            return obj;
        }, {});
        // If previously breakpoints are deleted, we need to handle the experiences which are assigned to that breakpoint.
        newExpCollections = newExpCollections.map(function (expDetail) {
            var threshold = expDetail.threshold;
            if (!thresholdValues.includes(threshold)) {
                if (allExperienceCount[expDetail.experienceId] === 1) {
                    updateNonBaseExpCollection(nonBaseExpCollections, expDetail, "UPDATE");
                    expDetail.threshold = null;
                    return expDetail;
                }
                else {
                    allExperienceCount[expDetail.experienceId] -= 1;
                    updateNonBaseExpCollection(nonBaseExpCollections, expDetail, "DELETE");
                    return undefined;
                }
            }
            return expDetail;
        }).filter(function (expDetail) { return expDetail; });
        var _a = updatedExpCollections.find(function (_a) {
            var threshold = _a.threshold;
            return threshold === 0;
        }), baseExpId = _a.experienceId, currentLanguage = _a.language;
        thresholdValues.forEach(function (value) {
            if (existingThresholds.indexOf(value) === -1) {
                var newExpCollectionEntry = {
                    experienceId: baseExpId,
                    threshold: value,
                    language: currentLanguage
                };
                newExpCollections.push(newExpCollectionEntry);
                updateNonBaseExpCollection(nonBaseExpCollections, newExpCollectionEntry, "ADD");
            }
        });
        setUpdatedExpCollections(newExpCollections);
        setAllExpDetails(newExpCollections.concat(nonBaseExpCollections));
        setBreakpointsUpdated(false);
        setExistingThresholds(thresholdValues);
        setBreakpointNames(breakpointCollection.generateNaming(thresholdValues.length - 1));
    };
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["f" /* Dialog */], { classes: { paper: classes.dialog }, open: open, onClose: handleCancel, className: "breakpoints-assign-lightbox" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["j" /* Grid */], { container: true, direction: "row", wrap: "nowrap", className: classes.dialogHeader },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["i" /* DialogTitle */], { className: classes.dialogTitle }, "Assign Breakpoint Variants"),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["k" /* IconButton */], { onClick: handleCancel, id: "closeIcon", style: { marginRight: "10px", marginTop: "5px", height: "40px" } },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Close___default.a, null))),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["h" /* DialogContent */], { style: { padding: "0px 24px" } },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["r" /* Typography */], { className: classes.subHeading, variant: "body2" }, "Assign your Breakpoint Variants to the intervals in which you want them to be shown."),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["j" /* Grid */], { container: true, className: classes.breakpointSection }, breakpointNames.map(function (name, i) {
                    var selectedExperience = updatedExpCollections.find(function (_a) {
                        var threshold = _a.threshold;
                        return threshold === existingThresholds[i];
                    });
                    var value = selectedExperience ? selectedExperience.experienceId : "";
                    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["j" /* Grid */], { item: true, className: classes.breakpointContainer, key: existingThresholds[i] },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: classes.intervalIndicator, id: name }),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", { className: classes.breakpointLabel }, name),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("select", { className: classes.selectBreakpoint, value: value, onChange: function (e) { return handleDropdownChange(e, existingThresholds[i]); } }, uniqueExperiences.map(function (experienceId, index) {
                            // initially currentLanguageExpJSON will be empty object.
                            var experienceName = currentLanguageExpJSON
                                ? currentLanguageExpJSON[experienceId].name
                                : "";
                            return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("option", { key: experienceId, value: experienceId }, "#" + (index + 1) + " " + experienceName));
                        })),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { id: "threshold-value", className: classes.breakpointValue }, existingThresholds[i])));
                })),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("hr", null)),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["g" /* DialogActions */], null,
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["j" /* Grid */], { container: true, justifyContent: "space-between" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["j" /* Grid */], { item: true }, breakpointsUpdated ? (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["q" /* Tooltip */], { classes: {
                            popper: classes.tooltipPopper,
                            tooltip: classes.tooltipLabel,
                        }, arrow: true, title: tooltipText, placement: "top", onClick: handleOnClickUpdate },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["d" /* Button */], { className: classes.btn, startIcon: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Error___default.a, null), variant: "outlined" }, "Update Breakpoints"))) : null),
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["j" /* Grid */], { item: true },
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["d" /* Button */], { className: classes.btn, variant: "outlined", onClick: handleCancel }, "Cancel"),
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["d" /* Button */], { className: classes.btn, variant: "contained", onClick: updateExperienceCollections, type: "submit" }, updatingBreakpoints ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["e" /* CircularProgress */], { className: classes.circularProgress, size: 24 }) : "OK"))))),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: classes.iconWrapper },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: classes.assignBreakpointIcon, onClick: function () { return setOpen(true); } }, breakpointsUpdated ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Error___default.a, { className: classes.exclamationIcon }) : null))));
}


/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

var _interopRequireWildcard = __webpack_require__(162);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(163));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.default = _default;

/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(33);

var _interopRequireWildcard = __webpack_require__(162);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(163));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
}), 'Error');

exports.default = _default;

/***/ }),
/* 2962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MoveExperience;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__C3Services_contentControl__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__C3Services_contentControl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__C3Services_contentControl__);




//import ErrorIcon from '@material-ui/icons/Error';
var NotificationBar = __webpack_require__(53);
var config = __webpack_require__(297).default;
var useStyles = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["s" /* makeStyles */])(function () { return ({
    textField: {
        marginLeft: "5px",
        width: "210px",
        background: "#fff",
        "& .MuiOutlinedInput-adornedEnd": {
            paddingRight: "0px"
        },
        "& .MuiInputBase-input.MuiOutlinedInput-input": {
            paddingLeft: "0px",
            height: "20px !important",
            border: "none !important"
        },
        "& .MuiIconButton-root": {
            padding: "0px"
        },
        "& .MuiOutlinedInput-root": {
            borderRadius: "0px !important",
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'white',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'grey',
            }
        },
    },
    tooltipPopper: {
        width: "300px !important",
        borderRadius: '1px',
        backgroundColor: '#fff',
        top: "5px !important",
        textAlign: "center"
    },
    tooltipLabel: {
        backgroundColor: '#fff',
        height: "25px",
        fontSize: "1.2rem",
        fontWeight: 500,
        color: 'grey',
        margin: "0px",
        "& .MuiTooltip-arrow": {
            color: "#fff",
            "&:before": {
                border: "1px solid #343e43"
            },
        }
    },
    errorIconTooltip: {
        width: "160px !important",
        borderRadius: '1px',
        backgroundColor: '#fff',
        top: "5px !important",
        textAlign: "center"
    },
    errorIcon: {
        alignItems: "center",
        height: "20px",
        width: "17px",
        backgroundImage: "url(../../../../images/error-icon.png)",
        backgroundRepeat: "no-repeat"
    }
}); });
function MoveExperience(props) {
    var _this = this;
    var classes = useStyles();
    var baseExperienceId = props.baseExperienceId, collectionDetails = props.collectionDetails, setAllExperienceJSON = props.setAllExperienceJSON, handleChangeVariant = props.handleChangeVariant;
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""), experienceIdToMove = _a[0], setExperienceIdToMove = _a[1];
    var _b = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(true), isValidC3Experience = _b[0], setIsValidC3Experience = _b[1];
    var handleChange = function (e) {
        if (e.target.value == "") {
            setExperienceIdToMove("");
            setIsValidC3Experience(true);
        }
        else {
            setExperienceIdToMove(e.target.value);
            setIsValidC3Experience(validateExperienceId(e.target.value));
        }
    };
    var validateExperienceId = function (experienceId) {
        // regex for a valid c3 experienceid
        return (/\C3_[a-z0-9]{21}$/).test(experienceId);
    };
    var handleMoveExperience = function () { return __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __awaiter */](_this, void 0, void 0, function () {
        var copyExperienceJSON, response_1, url;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(experienceIdToMove && isValidC3Experience)) return [3 /*break*/, 2];
                    copyExperienceJSON = {
                        "experienceId": experienceIdToMove,
                        "collectionId": collectionDetails.id,
                        "parentExperienceId": baseExperienceId
                    };
                    return [4 /*yield*/, Object(__WEBPACK_IMPORTED_MODULE_3__C3Services_contentControl__["copyExperienceAsVariant"])(copyExperienceJSON)];
                case 1:
                    response_1 = _a.sent();
                    if (response_1.mergedExperience) {
                        setAllExperienceJSON(function (prev) {
                            var _a;
                            return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, prev, (_a = {}, _a[response_1.mergedExperience.id] = response_1.mergedExperience, _a)));
                        });
                        handleChangeVariant(response_1.mergedExperience.id);
                    }
                    else if (response_1.languageMismatch) {
                        NotificationBar.open("Language of the experience that you are trying to import should be the same as base language of current experience.", { closeDelay: 5000 });
                    }
                    else if (response_1.message.includes("Invalid request")) {
                        NotificationBar.open({ message: 'You cannot move a multi-scene experience into a single-scene experience. ', action: "support community" }, { closeDelay: 5000 });
                    }
                    else {
                        url = config.communityBaseUrl + "/hc/en-us/articles/201545079";
                        NotificationBar.open("No such experience could be found. <a href=" + url + ">Visit The Community</a>", { closeDelay: 5000 });
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["q" /* Tooltip */], { classes: {
                popper: classes.tooltipPopper,
                tooltip: classes.tooltipLabel,
            }, arrow: true, title: "Copies the Selected Experience into this Collection", TransitionProps: { timeout: 0 } },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { onClick: handleMoveExperience, className: "move-to-experience-btn btn btn-white btn-import-action", "data-original-title": "", title: "" }, "Move Here")),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["p" /* TextField */], { className: classes.textField, placeholder: "C3_5xxxxxxxxxxxxxxxxxxxxxxx", onChange: function (e) { return handleChange(e); }, variant: "outlined", InputProps: {
                endAdornment: (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["l" /* InputAdornment */], { style: { display: isValidC3Experience ? "none" : "flex" }, position: "start" },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["k" /* IconButton */], null,
                        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["q" /* Tooltip */], { classes: {
                                popper: classes.errorIconTooltip,
                                tooltip: classes.tooltipLabel,
                            }, arrow: true, TransitionProps: { timeout: 0 }, title: "Not a valid Experience Id" },
                            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: classes.errorIcon }))))),
            } })));
}


/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorContextMenu = __webpack_require__(2964);
    var ExperiencesEditor = __webpack_require__(2965);
    var ImprovedView = __webpack_require__(6);
    var Permissions = __webpack_require__(22);
    var template = __webpack_require__(3020);
    var WidgetToolboxView = __webpack_require__(3021);
    var WidgetTypes = __webpack_require__(69);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var EditorWebFontController = __webpack_require__(176);

    var logger = new Logger("EditorView");

    /**
     * An editor view that supports editing multiple experiences.
     *
     * @class EditorView
     * @author Kim
     */
    return ImprovedView.extend({

        className: "editor-view pt-page",

        template: template,

        _contextMenu: null,

        _cursorWidgetType: null,

        $body: null,

        transitions: {
            "in": "pt-page-scaleUp",
            out: "pt-page-scaleDown"
        },

        regions: {
            widgetToolbox: ".widget-toolbox",
            editorsRegion: ".editor-region"
        },

        events: {
            /**
             * Listening on the general drag event(text or anything draggable) within editor so that
             * we don't show the unwanted Drop hotspot area.
             *
             * @see how the drop hotspot area is applied in {@Link DropAreaHotspot}
             */
            "dragstart": "_dragStartHandler",
            "dragend": "_dragEndHandler",
            "click": "_widgetTypeClearedHandler"
        },

        experiencesEditor: null,

        initialize: function initialize() {
            EditorWebFontController.start();
            this._contextMenu = new EditorContextMenu(this);
        },
        onTransitionedIn: function onTransitionedIn() {
            this.viewScope.viewModel.trigger("editorView:TransitionedIn");
        },


        /**
         * Add class internal-drag so we know that the drag is initiated within the editor page,
         * This is to tell apart from the drags outside the page, for example files.
         * @private
         */
        _dragStartHandler: function _dragStartHandler() {
            this.$body.addClass("internal-drag");
        },
        _dragEndHandler: function _dragEndHandler() {
            this.$body.removeClass("internal-drag");
        },
        _widgetTypeSelectedHandler: function _widgetTypeSelectedHandler(widgetType, icon) {
            this._cursorWidgetType = widgetType;
            this.$body.addClass("cursor-" + icon);
        },
        _widgetTypeClearedHandler: function _widgetTypeClearedHandler(event) {
            // When the widget is either created or user cancels,
            // remove any 'cursor-***' classes added to the body
            // to return the cursor to default pointer.
            if (!event || !event.target.classList.contains("cursor-loading-widget")) {
                this._cursorWidgetType = null;
                this.$body.removeClass(function (index, classNames) {
                    return classNames.split(/\s+/).filter(function (className) {
                        return className.includes("cursor-");
                    }).join(" ");
                });
            }
        },


        /**
         * The viewScope is the backbone of editor view, it is auto inherited to all its subviews.
         *
         * @returns {{inherit: boolean, viewModel: *, getExperienceSize: Function}}
         */
        viewScope: function viewScope() {
            return {
                inherit: false,

                viewModel: this.model,

                spectatorMode: Permissions.Privileges.CREATE.cannot(),

                clearCursorWidgetType: function clearCursorWidgetType() {
                    this._widgetTypeClearedHandler();
                },
                getCursorWidgetType: function getCursorWidgetType() {
                    return this._cursorWidgetType;
                },
                setCursorWidgetType: function setCursorWidgetType(widgetType, icon) {
                    if (!WidgetTypes.lookup(widgetType)) {
                        logger.warn("Invalid widget type: " + widgetType);
                    } else {
                        this._widgetTypeSelectedHandler(widgetType, icon);
                    }
                },
                getExperienceSize: function getExperienceSize() {
                    return this.model.get("experience").getSize();
                },


                // Returns the viewport element
                getViewportElement: function getViewportElement() {
                    return this.experiencesEditor.getViewportElement();
                },
                getCurrentSceneBounds: function getCurrentSceneBounds() {
                    var element = this.$(".scene-editor.current"),
                        offset = element.offset();

                    return {
                        top: offset.top,
                        left: offset.left,
                        width: element.width(),
                        height: element.height()
                    };
                },
                getSceneBounds: function getSceneBounds(sceneID) {
                    var element = this.$(".scene-editor." + sceneID),
                        offset = element.offset();

                    return {
                        top: offset.top,
                        left: offset.left,
                        width: element.width(),
                        height: element.height()
                    };
                }
            };
        },


        /**
         * When the editor view is in DOM, show all regions
         */
        onShow: function onShow() {
            var _options = this.options,
                project = _options.project,
                groups = _options.groups,
                prototypeWidgetCollection = _options.prototypeWidgetCollection;


            this.$body = this.$el.parents("body");
            this.experiencesEditor = new ExperiencesEditor({
                model: this.model,
                project: project,
                groups: groups
            });

            this.editorsRegion.show(this.experiencesEditor);

            this.widgetToolbox.show(new WidgetToolboxView({
                model: this.model,
                prototypeWidgetCollection: prototypeWidgetCollection
            }));

            /* when user clicks on a widget, which goes beyond the canvas,
            ".editor-region" element (because it contains "overflow: hidden") is scrolled
            and changes its "scrollTop" property. To avoid this behavior (especially in Safari)
            we need to overwrite ".editor-region" onscroll function */
            this.editorsRegion.$el[0].onscroll = function () {
                this.scrollTo(0, 0);
            };
        },
        onClose: function onClose() {
            this._contextMenu.close();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Browser = __webpack_require__(39);
    var Clipboard = __webpack_require__(702);
    var EditorActivityManager = __webpack_require__(197);
    var LoggedIn = __webpack_require__(31);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Marionette = __webpack_require__(10);
    var WidgetGroup = __webpack_require__(401);

    var menuItemTpl = _.template("<%- label %> <span class=\"shortcut\"><%- shortcut %></span>");

    var SELECTORS = [".widgets-container", // scene context menu
    ".border" // widget context menu (only when a widget is selected)
    ];

    // change to any of the following model's attribute must rebuild the context menu
    var VIEW_MODEL_CHANGES = "change:rulersShown change:snappingEnabled change:showMasterLayers";

    var log = new Logger("EditorContextMenu");

    /**
     * Context Menu for each scene
     */
    return Marionette.Controller.extend({

        // the scene to which this context menu applies
        _editorView: null,

        initialize: function initialize(editorView) {
            this._editorView = editorView;

            this.listenTo(this._editorView, "render", this.create);
        },
        create: function create() {
            var _this = this;

            var menu = this.getMenuCollection();
            var viewModel = this._editorView.viewScope.viewModel;

            /*
             * scene context menu
             */
            SELECTORS.forEach(function (selector) {
                return _this._editorView.$el.contextMenu({
                    selector: selector,
                    items: menu,
                    reposition: false
                });
            });

            // The context menu has to be rebuild when one of these properties are toggled because
            // the text changes.
            this.listenToOnce(viewModel, VIEW_MODEL_CHANGES, this.rebuild);
        },
        rebuild: function rebuild() {
            var viewModel = this._editorView.viewScope.viewModel;
            // Remove old listeners
            this.stopListening(viewModel, VIEW_MODEL_CHANGES);

            // Remove previously configured menus
            // jQuery ContextMenu's `destroy` command has to be called in
            // context of selectors menu was created (see `create()` method above for these selectors)
            this._editorView.$(SELECTORS.join(",")).contextMenu("destroy");

            this.create();
        },


        /**
         * Returns an object containing all content for the context menu.
         * Every item-key has an object-value with a name {String}, callback {Function call}
         * and disabled {Boolean} (disabled is optional).
         *
         * @return {Object} Object containing all items for the context menu.
         */
        getMenuCollection: function getMenuCollection() {
            var viewModel = this._editorView.viewScope.viewModel;
            var zoomModel = viewModel.get("zoomModel");
            var key = Browser.os.macOS ? "\u2318" : "Ctrl";
            var shift = "\u21E7";
            var dump = Logger.level() >= Logger.LOG && (LoggedIn.internal() || LoggedIn.ad());

            var menu = {
                "copy": {
                    name: menuItemTpl({ label: "Copy", shortcut: key + "+C" }),
                    isHtmlName: true,
                    callback: function callback() {
                        Clipboard.copy();
                    },
                    disabled: function disabled() {
                        return viewModel.selection.isEmpty();
                    }
                },
                "paste": {
                    name: menuItemTpl({ label: "Paste", shortcut: key + "+V" }),
                    isHtmlName: true,
                    callback: function callback(key, options) {
                        var scene = options.$trigger;
                        var containerPosition = scene.offset();
                        var menuPosition = options.$menu.offset();

                        Clipboard.paste({
                            left: menuPosition.left - containerPosition.left,
                            top: menuPosition.top - containerPosition.top
                        });
                    },
                    disabled: function disabled() {
                        var data = Clipboard.getData();
                        return !data || data.type !== Clipboard.DataTypes.WIDGET;
                    }
                },
                "delete": {
                    name: "Delete",
                    callback: function callback() {
                        viewModel.deleteSelection({
                            triggerOrigin: "DeleteChoiceMasterLayersMenu"
                        });
                    },
                    disabled: function disabled() {
                        return viewModel.selection.isEmpty();
                    }
                },
                "undo": {
                    name: menuItemTpl({ label: "Undo", shortcut: key + "+Z" }),
                    isHtmlName: true,
                    callback: function callback() {
                        EditorActivityManager.undo();
                    },
                    disabled: function disabled() {
                        return !EditorActivityManager.canUndo();
                    }
                },
                "redo": {
                    name: menuItemTpl({ label: "Redo", shortcut: key + "+Y" }),
                    isHtmlName: true,
                    callback: function callback() {
                        EditorActivityManager.redo();
                    },
                    disabled: function disabled() {
                        return !EditorActivityManager.canRedo();
                    }
                },

                "separator1": "",

                "group": {
                    name: menuItemTpl({ label: "Group", shortcut: key + "+G" }),
                    isHtmlName: true,
                    callback: function callback() {
                        WidgetGroup.group({ eventProperties: { triggerOrigin: "EditorContextMenu" } });
                    },
                    disabled: function disabled() {
                        return !viewModel.get("scene").canGroupWidgets(viewModel.selection.get("models"));
                    }
                },

                "ungroup": {
                    name: menuItemTpl({ label: "Ungroup", shortcut: shift + "+" + key + "+G" }),
                    isHtmlName: true,
                    callback: function callback() {
                        WidgetGroup.ungroup({ eventProperties: { triggerOrigin: "EditorContextMenu" } });
                    },
                    disabled: function disabled() {
                        return !viewModel.get("scene").canUngroupWidgets(viewModel.selection.get("models"));
                    }
                },

                "separator2": "",

                "zoomIn": {
                    name: menuItemTpl({ label: "Zoom In", shortcut: "+" }),
                    isHtmlName: true,
                    callback: function callback() {
                        zoomModel.scaleUp();
                    },
                    disabled: function disabled() {
                        return zoomModel.isMaxScale();
                    }
                },
                "zoomOut": {
                    name: menuItemTpl({ label: "Zoom Out", shortcut: "-" }),
                    isHtmlName: true,
                    callback: function callback() {
                        zoomModel.scaleDown();
                    },
                    disabled: function disabled() {
                        return zoomModel.isMinScale();
                    }
                },
                "resetZoom": {
                    name: menuItemTpl({ label: "Reset Zoom", shortcut: "0" }),
                    isHtmlName: true,
                    callback: function callback() {
                        zoomModel.reset();
                    },
                    disabled: function disabled() {
                        return zoomModel.get("scale") === 1;
                    }
                },

                "separator3": "",

                "toggleMasterLayers": {
                    name: menuItemTpl({
                        label: viewModel.get("showMasterLayers") ? "Show Active Layer Only" : "Show All Layers",
                        shortcut: "M"
                    }),
                    isHtmlName: true,
                    callback: function callback() {
                        viewModel.set("showMasterLayers", !viewModel.get("showMasterLayers"), { triggerOrigin: "EditorContextMenu" });
                    }
                },

                "toggleRulers": {
                    name: (viewModel.get("rulersShown") ? "Hide" : "Show") + " Rulers and Guidelines",
                    callback: function callback() {
                        viewModel.set("rulersShown", !viewModel.get("rulersShown"), "EditorContextMenu");
                    }
                },

                "toggleSnapping": {
                    name: "Turn " + (viewModel.get("snappingEnabled") ? "Off" : "On") + " Snapping",
                    callback: function callback() {
                        viewModel.set("snappingEnabled", !viewModel.get("snappingEnabled"), "EditorContextMenu");
                    }
                }
            };

            // On request from JSB, add option to dump experience json from internal network to
            // console for easy debugging...
            if (dump) {
                _.extend(menu, {
                    "separator4": "",

                    "dump": {
                        name: "Dump Experience",
                        callback: function callback() {
                            var experience = viewModel.get("experience");
                            var clone = experience.clone({ duplicate: true });

                            log.info("Experience model:      ", experience);
                            log.info("Experience json:       ", experience.toJSON());
                            log.info("Experience clone model:", clone);
                            log.info("Experience clone json: ", clone.toJSON());
                        }
                    }
                });
            }

            return menu;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var AddWidgetsAction = __webpack_require__(370);
    var Backbone = __webpack_require__(7);
    var Clipboard = __webpack_require__(702);
    var EditorActivities = __webpack_require__(361);
    var EditorActivityManager = __webpack_require__(197);
    var EditorEvents = __webpack_require__(17);
    var ExperienceEditor = __webpack_require__(2966);
    var EditorEventFilters = __webpack_require__(154).default;
    var ExperiencesEditorZoom = __webpack_require__(3017);
    var ImprovedView = __webpack_require__(6);
    var Keycode = __webpack_require__(88);
    var LayerEnum = __webpack_require__(251);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Marionette = __webpack_require__(10);
    var SceneEditor = __webpack_require__(717);
    var template = __webpack_require__(3018);
    var WidgetGroup = __webpack_require__(401);
    var WidgetTypes = __webpack_require__(69);
    var ZoomView = __webpack_require__(1238);
    var MathUtil = __webpack_require__(72).default;

    var log = new Logger("ExperiencesEditor");

    var ExperienceEditorCollectionView = Marionette.CollectionView.extend({
        itemView: ExperienceEditor
    });

    var UNICODE_EMPTY_CIRCLE = "&#9675;";
    var UNICODE_FILLED_CIRCLE = "&#9679;";
    var LAYER_SELECTED_ICON_SELECTOR = ".layer-selected-icon";

    var SCENE_MARGIN_TOP_PX = 75;
    var BOTTOM_BAR_HEIGHT_PX = 50;
    var VERTICAL_RULER_WIDTH_PX = 16;
    var EXPERIENCE_REGION_PADDING_RIGHT_PX = 50;

    var UNDO = "undo";
    var REDO = "redo";
    var GROUP = "group";
    var UNGROUP = "ungroup";
    // Superficial editor activity events are those produced by widgets that should not be added for Undo/Redo
    // in these cases, we handle their Undo/Redo functionality with a custom EditorActivity
    var SUPERFICIAL = "superficial";

    var ignoredActivitiesList = ["isSelected", "isTransforming"];
    /**
     * Experiences Editor is container for the collection of experience editors.
     *
     * @class ExperiencesEditor
     * @cfg {EditorViewModel} model The view model for the editor view.
     */
    return ImprovedView.extend({

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                spectatorMode: this.viewScope.spectatorMode,
                LayerEnum: LayerEnum
            };
        },


        // the active experience(s) within the editor
        activeExperience: null,

        // scrollbar handler
        scrollbars: null,

        _experienceCollectionView: null,

        _zoomController: null,

        _viewModel: null,

        _zoomModel: null,

        isRulerVisible: null,

        horizontalRuler: null,

        verticalRuler: null,

        verticalRulerMask: null,

        activeWidgetElement: null,

        events: {
            "click .add-new-scene": "addScene",
            "click @ui.changeLayerLinks": "_changeLayer",
            "click @ui.undo": UNDO,
            "click @ui.redo": REDO
        },

        keyboard: {
            "delete": "_deleteSelection",
            "back_space": "_deleteSelection",
            "m": "_toggleMasterLayers",
            "down": "_arrowKeyHandler",
            "up": "_arrowKeyHandler",
            "left": "_arrowKeyHandler",
            "right": "_arrowKeyHandler"
        },

        ui: {
            editAreaContainer: ".editor-area-container",
            viewport: ".viewport",
            overview: ".overview",
            rulersSwitch: ".rulers-switch",
            otherSwitch: ".other-switch",
            scrollTarget: ".scroll-target",
            scrollbarV: ".vertical",
            scrollbarH: ".horizontal",
            snappingSwitch: ".snapping-switch",
            layerLabel: ".layer-label",
            changeLayerLinks: ".change-layer",
            addNewSceneBtn: ".add-new-scene",
            undo: ".editor-undo",
            redo: ".editor-redo"
        },

        regions: {
            experienceRegion: "#experiences-region",
            experienceSyncStateRegion: ".experience-sync-state-region",
            zoomRegion: ".zoom-region"
        },

        modelEvents: {
            "change:sceneNumber": "_scrollToScene"
        },

        viewScope: {
            getScrollbarH: function getScrollbarH() {
                return this.ui.scrollbarH;
            },
            getScrollbarV: function getScrollbarV() {
                return this.ui.scrollbarV;
            },


            /**
             * Invoked when a <tt>SceneEditor</tt> is clicked.
             *
             * Updates the view model with the current scene number and
             * navigates/scrolls to the current scene in the editor.
             *
             * @param  {Scene} scene The scene model.
             */
            onSceneEditorClick: function onSceneEditorClick(scene) {
                this._updateCurrentScene(scene);
            },
            onWidgetsAdded: function onWidgetsAdded(widgets) {
                this._viewModel.selection.select(widgets);
                this._updateCurrentScene(this._viewModel.get("scene"));
            }
        },

        _toggleAddNewSceneEnabled: function _toggleAddNewSceneEnabled() {
            this.ui.addNewSceneBtn.attr("disabled", this.activeExperience.get("emailModeEnabled"));
        },
        initialize: function initialize() {
            this.activeExperience = this.model.get("experience");

            this.listenTo(Clipboard, "copy", this._copyHandler);
            this.listenTo(Clipboard, "paste", this._pasteHandler);

            this._setupActivityManager();

            // Add Zooming feature
            this._zoomController = new ExperiencesEditorZoom(this);

            // Widget group event listeners
            this.listenTo(WidgetGroup, "group", this._widgetGroupHandler);
            this.listenTo(WidgetGroup, "ungroup", this._widgetUngroupHandler);

            this.listenTo(this.model, "change:currentLayer", this._setActiveLayerIconAndLabel);
        },
        _updateClipboarData: function _updateClipboarData() {
            var data = Clipboard.getData();
            Clipboard.setData(Object.assign({}, data, { isEmailModeEnabled: this.model.get("experience").get("emailModeEnabled") }));
        },
        onRender: function onRender() {
            var _this = this;

            this._viewModel = this.viewScope.viewModel;

            this._zoomModel = this._viewModel.get("zoomModel");

            this.zoomRegion.show(new ZoomView({
                zoomModel: this._zoomModel,
                persistZoom: true,
                experienceId: this._viewModel.get("experience").get("id"),
                event: EditorEvents.constants.ZOOM_SCENE
            }));

            this.listenTo(this._viewModel, "change:showMasterLayers", function (model, value, options) {
                if (options.triggerOrigin) {
                    _this._triggerEditorEvent(EditorEvents.constants.OPEN_MASTER_LAYERS, {
                        triggerOrigin: options.triggerOrigin,
                        toggle: value ? "on" : "off"
                    });
                }
            });

            this.listenTo(this.activeExperience, "change:emailModeEnabled", this._toggleAddNewSceneEnabled);
            this.listenTo(this._viewModel, "change:rulersShown", this._toggleRulersAndGuidelines);

            this.ui.rulersSwitch.on("switchChange.bootstrapSwitch", function (event, state) {
                _this._viewModel.set("rulersShown", state, "rulersSwitch");
            });

            this.listenTo(this._viewModel, "change:snappingEnabled", this._toggleSnapping);

            this.ui.snappingSwitch.on("switchChange.bootstrapSwitch", function (event, state) {
                _this._viewModel.set("snappingEnabled", state, "snappingSwitch");
            });

            this.listenTo(this._zoomModel, "change:scale", this._setOverviewWidth.bind(this));
            this.listenTo(this.model.get("experience"), "change:width", this._setOverviewWidth.bind(this));
            this.listenTo(this.model.get("experience").get("scenes"), "add remove", this._setOverviewWidth.bind(this));
        },
        onShow: function onShow() {
            var _this2 = this;

            this._experienceCollectionView = new ExperienceEditorCollectionView({
                collection: new Backbone.Collection(this.activeExperience)
            });

            this.listenTo(this.model.get("experience"), "change:emailModeEnabled", this._updateClipboarData);

            this.experienceRegion.show(this._experienceCollectionView);

            // Enable the jquery tiny scroll bar
            this.ui.viewport.tinyscrollbar({
                x: { trackSize: 400, scrollbar: this.ui.scrollbarH },
                y: { trackSize: 300, scrollbar: this.ui.scrollbarV, extraContentSize: SCENE_MARGIN_TOP_PX + BOTTOM_BAR_HEIGHT_PX }
            });

            this.scrollbars = this.ui.viewport.data("tinyscrollbar");

            // Get the contentOffsetfor Y axis from the tinyscrollbar.
            this.ui.viewport.bind("move", function () {
                _this2._viewModel.set("contentOffsetY", _this2.scrollbars.y.options.contentOffset);
            });
            var self = this;
            // Using event delegation to capture clicks from all elements except things inside the editor surface.
            this.ui.viewport.bind("click", function (event) {
                // Being safe even thought most non-IE browsers support this method.
                if (event.target.closest && !event.target.closest(".scene-editor") && !self._viewModel.get("isSelectingElements")) {
                    _this2._viewModel.selection.clear();
                }

                self._viewModel.set("isSelectingElements", false);
            });

            // Scroll to the current scene, whatever it is...
            // For some certain size of experience, in the beginning, it does not scroll to the center, timeout is a fix.
            setTimeout(function () {
                _this2._scrollToScene(_this2.model.getCurrentSceneIndex());
            }, 700);

            // "cresize" is our custom jQuery.resize event.
            this.ui.viewport.on("cresize", function () {
                _this2.scrollbars.x.update();
                _this2.scrollbars.y.update();
            });

            // On load load the current snapping and rulers state
            this._toggleRulersAndGuidelines(this._viewModel, this._viewModel.get("rulersShown"));

            this.ui.rulersSwitch.bootstrapSwitch("state", this._viewModel.get("rulersShown"));
            this.ui.snappingSwitch.bootstrapSwitch("state", this._viewModel.get("snappingEnabled"));
            this._setOverviewWidth();
            this._setActiveLayerIconAndLabel();
            this._toggleAddNewSceneEnabled();
        },
        _setOverviewWidth: function _setOverviewWidth() {
            var scale = this._zoomModel.get("scale");

            var oneSceneWidth = SceneEditor.SCENE_MARGIN + VERTICAL_RULER_WIDTH_PX + this.model.get("experience").get("width") + SceneEditor.SCENE_MARGIN;
            var experiencesRegionWidth = oneSceneWidth * this.model.get("experience").get("scenes").length + EXPERIENCE_REGION_PADDING_RIGHT_PX;

            this.ui.overview.width(experiencesRegionWidth * scale);
        },
        _toggleSnapping: function _toggleSnapping(viewModel, state, triggerOrigin) {
            // Make sure the switch state is in sync in case this was triggered by the context menu
            this.ui.snappingSwitch.bootstrapSwitch("state", state, true);

            if (triggerOrigin) {
                var eventProperties = this._getEventProperties({
                    toggle: state ? "on" : "off",
                    triggerOrigin: triggerOrigin
                });
                this._triggerEditorEvent(EditorEvents.constants.TOGGLE_SNAPPING, eventProperties);
            }
        },
        _toggleRulersAndGuidelines: function _toggleRulersAndGuidelines(viewModel, state, triggerOrigin) {
            // Make sure the switch state is in sync in case this was triggered by the context menu
            this.ui.rulersSwitch.bootstrapSwitch("state", state, true);
            this.ui.editAreaContainer.toggleClass("hide-rulers-and-guidelines", !state);

            if (triggerOrigin) {
                var eventProperties = this._getEventProperties({
                    toggle: state ? "on" : "off",
                    triggerOrigin: triggerOrigin
                });
                this._triggerEditorEvent(EditorEvents.constants.TOGGLE_RULERS_AND_GUIDELINES, eventProperties);
            }
        },


        /**
         * Sends Mix Panel event for the variant.
         * @param eventName The name of the event.
         * @param options additional options for the tracking method.
         * @private
         */
        _triggerEditorEvent: function _triggerEditorEvent(eventName, options) {
            var experience = this._viewModel.get("experience");
            var eventProperties = {
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                sceneNumber: this._viewModel.get("sceneNumber"),
                projectId: this.options.project && this.options.project.get("id"),
                triggerOrigin: options.triggerOrigin,
                toggle: options.toggle ? options.toggle : null,
                zoomType: options.zoomType ? options.zoomType : null
            };

            EditorEvents.trigger(eventName, eventProperties);
        },
        _updateCurrentScene: function _updateCurrentScene(scene) {
            var sceneNumber = scene.get("sceneNumber");

            // Eventually invoking scrollToScene - see #modelEvents
            this._viewModel.set("sceneNumber", sceneNumber);
        },


        /**
        * Handle widget grouping
        */
        _widgetGroupHandler: function _widgetGroupHandler() {
            var _this3 = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var scene = this._viewModel.get("activeLayerSceneModel");
            var widgetModels = this._viewModel.selection.get("models");

            scene.groupWidgets(widgetModels, options, function () {
                if (options.eventProperties) {
                    var eventProperties = _this3._getGroupEventProperties(options.eventProperties, widgetModels);
                    EditorEvents.trigger(EditorEvents.constants.GROUP_WIDGETS, eventProperties);
                }
            });
        },


        /**
        * Handle widget ungrouping
        */
        _widgetUngroupHandler: function _widgetUngroupHandler() {
            var _this4 = this;

            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var scene = this._viewModel.get("activeLayerSceneModel");
            var widgetModels = this._viewModel.selection.get("models");

            scene.ungroupWidgets(widgetModels, options, function () {
                if (options.eventProperties) {
                    var eventProperties = _this4._getGroupEventProperties(options.eventProperties, widgetModels);
                    EditorEvents.trigger(EditorEvents.constants.UNGROUP_WIDGETS, eventProperties);
                }
            });
        },


        /**
        * Set default event properties
        */
        _getEventProperties: function _getEventProperties(eventProperties) {
            var experience = this._viewModel.get("experience");
            var project = this._viewModel.get("project");

            eventProperties = _.defaults(eventProperties, {
                experienceId: experience.get("id"),
                experienceVersion: experience.get("version"),
                experiencePushedVersion: experience.get("pushedVersion"),
                triggerOrigin: eventProperties.triggerOrigin
            });

            if (project) {
                eventProperties.projectId = project.get("id");
            }

            return eventProperties;
        },


        /**
        * Return group event properties for Mixpanel Events
        */
        _getGroupEventProperties: function _getGroupEventProperties(eventProperties, widgetModels) {
            eventProperties = this._getEventProperties(eventProperties);

            if (widgetModels) {
                var widgetTypes = _.map(widgetModels, function (widgetModel) {
                    return widgetModel.get("type");
                });
                eventProperties.numberOfWidgetSelected = widgetModels.length;
                eventProperties.widgetTypes = widgetTypes.join();
            }

            return eventProperties;
        },


        /**
         * Add a new scene to the experience, cascading to all variants as well. <p>
         *
         * Will wait for all variants to be stable, i.e. no pending sync request, before adding a new scene. If we
         * do not do this, we can get structural changes that differs across variants more easily!
         */
        addScene: function addScene() {
            var experience = this.model.get("experience");
            var newScenePosition = this.model.getCurrentSceneIndex() + 1;

            this._viewModel.selection.clear();
            log.info("Adding scene at index " + newScenePosition + ": " + experience, experience);
            experience.addScene(newScenePosition); // fire!
        },


        /**
         * Scrolls to the specified scene.
         *
         * @param  {Scene|String|Number} scene The <tt>Scene</tt> instance or the raw scene number.
         */
        _scrollToScene: function _scrollToScene(scene) {
            var sceneNumberValue = _.isNumber(scene) || _.isString(scene) ? scene : scene.get("sceneNumber");
            var sceneNumber = parseInt(sceneNumberValue, 10);

            sceneNumber = sceneNumber > 0 ? sceneNumber : 0;

            var margin = SceneEditor.SCENE_MARGIN * 2 * sceneNumber;
            var scale = this._zoomModel.get("scale");
            var position = this.activeExperience.get("width") * scale * (sceneNumber - 0.5) + margin;

            this.scrollbars.x.update().scrollTo("center", position, false, true);
        },


        /**
         * Returns the viewport element
         */
        getViewportElement: function getViewportElement() {
            return this.ui.viewport;
        },


        /**
         * @private
         *
         * Initializes the <tt>EditorActivityManager</tt>, enabling undo/redo support.
         */
        _setupActivityManager: function _setupActivityManager() {
            var sceneCollection = this.activeExperience.get("scenes");

            this.listenTo(sceneCollection, "add", this._undoRedoEnabler);
            this.listenTo(sceneCollection, "remove", this._undoRedoDisabler);

            sceneCollection.each(this._undoRedoEnabler.bind(this));

            this._undoRedoEnabler(this.activeExperience.get("overlayScene"));
            this._undoRedoEnabler(this.activeExperience.get("backgroundScene"));
        },


        /**
         * @private
         *
         * Registers a change to widget model if change meets criteria for undo/redo eligibility.
         *
         * @param  {WidgetModel} widgetModel The widget model.
         * @param  {Options} options The change options.
         */
        _registerChangeOnModel: function _registerChangeOnModel(widgetModel, options) {
            // Bail out if the change was caused by a selection, undo, redo, group or ungroup action
            var changedAttributes = widgetModel.changedAttributes();
            var isIgnordAttribute = Object.keys(changedAttributes).some(function (attr) {
                return ignoredActivitiesList.includes(attr);
            });
            if (isIgnordAttribute) {
                return;
            }

            var cause = options.cause;

            if (cause) {
                var _cause = options.cause;

                if (_cause === UNDO || _cause === REDO || _cause === GROUP || _cause === UNGROUP || _cause === SUPERFICIAL) {
                    return;
                }
            }

            // Register the change to enable undo/redo
            EditorActivityManager.add(new EditorActivities.WidgetPropertiesChangedActivity(widgetModel, widgetModel.changedAttributes(), widgetModel.previousAttributes()));
        },


        /**
         * @private
         *
         * Registers listeners to enable undo/redo.
         *
         * @param  {Scene} sceneModel The scene model.
         */
        _undoRedoEnabler: function _undoRedoEnabler(sceneModel) {
            var _this5 = this;

            var widgetCollection = sceneModel.get("widgets");
            // Listen for any changes in the widget model to enable undo/redo for widget changes
            this.listenTo(widgetCollection, "change", function (widgetModel, options) {
                _this5._registerChangeOnModel(widgetModel, options);
            });

            var isDynamicProduct = function isDynamicProduct(widgetModel) {
                var attributes = widgetModel.attributes;

                return attributes && attributes.type === WidgetTypes.DYNAMIC_PRODUCT.id && attributes.group;
            };
            // Listen for any changes in widget models nested under a Dynamic Product widget
            widgetCollection.models.forEach(function (model) {
                var attributes = model.attributes;

                if (isDynamicProduct(model)) {
                    _this5.listenTo(attributes.group, "change", function (widgetModel, options) {
                        _this5._registerChangeOnModel(widgetModel, options);
                    });
                }
            });

            // We would like to know when a widget is added or removed
            this.listenTo(widgetCollection, "add remove", function (widgetModel, collection, options) {
                // Bail out if the change was caused by a undo, redo, group or ungroup action
                if (options && options.cause) {
                    var cause = options.cause;

                    if (cause === UNDO || cause === REDO || cause === GROUP || cause === UNGROUP || cause === SUPERFICIAL) {
                        return;
                    }
                }

                // If the widget was added
                if (options.add) {
                    EditorActivityManager.add(new EditorActivities.WidgetCreatedActivity(widgetModel, sceneModel));
                    if (isDynamicProduct(widgetModel)) {
                        var attributes = widgetModel.attributes;

                        options.cause = EditorEventFilters.SUPERFICIAL;
                        _this5.listenTo(attributes.group, "change", function (widgetModel, options) {
                            _this5._registerChangeOnModel(widgetModel, options);
                        });
                    }
                    // Widget was removed
                } else {
                    EditorActivityManager.add(new EditorActivities.WidgetDeletedActivity(widgetModel, sceneModel));
                }
            });
        },


        /**
         * @private
         *
         * Cleans up listeners used to perform undo/redo.
         *
         * @param  {Scene} sceneModel The scene model removed from the experience.
         */
        _undoRedoDisabler: function _undoRedoDisabler(sceneModel) {
            this.stopListening(sceneModel.get("widgets"));
        },


        /**
         * Delete currently selected widgets
         */
        _deleteSelection: function _deleteSelection(event) {
            if (!$(document.activeElement).is("input, textarea") && document.activeElement.getAttribute("contenteditable") !== "true") {
                event.preventDefault();
                this.model.deleteSelection({
                    triggerOrigin: "CancelOrDeleteKey"
                });
            }
        },


        /**
         * Handles arrow key event, which moves selected widgets
         * @param {Event} event The key event
         * @private
         */
        _arrowKeyHandler: function _arrowKeyHandler(event) {
            var amount = event.shiftKey ? 10 : 1;
            var tagname = event.target.tagName.toUpperCase();
            var isHighlighted = this.model.get("activeLayerSceneModel").get("widgets").models.some(function (widget) {
                return widget.get("highlighted");
            });

            if (tagname === "INPUT" || tagname === "TEXTAREA" || !!document.activeElement && document.activeElement.getAttribute("contenteditable") === "true" ||
            // don't move selected widgets if one of them is highlighted
            isHighlighted) {
                return;
            }

            switch (event.keyCode) {
                case Keycode.LEFT:
                    this.model.selection.moveBy("x", -amount);
                    break;

                case Keycode.RIGHT:
                    this.model.selection.moveBy("x", amount);
                    break;

                case Keycode.UP:
                    this.model.selection.moveBy("y", -amount);
                    break;

                case Keycode.DOWN:
                    this.model.selection.moveBy("y", amount);
                    break;

                default: // No need to propagate here.
            }
        },


        /**
         * Copy a widget(s)
         * @private
         */
        _copyHandler: function _copyHandler() {
            var selectedWidgets = this.model.selection.get("widgets");
            var currentScene = this._viewModel.get("scene");

            if (selectedWidgets) {
                // the order of widgets is the order of selection,
                // so we need to reserve the order of selected widgets
                selectedWidgets = _.sortBy(selectedWidgets, function (widget) {
                    return widget.model.get("layerIndex");
                });

                var experienceSize = this.activeExperience.getSize();

                Clipboard.setData({
                    type: Clipboard.DataTypes.WIDGET,
                    experience: this.activeExperience,
                    sceneId: currentScene.cid,
                    models: _.map(selectedWidgets, function (w) {
                        return w.model.clone({ duplicate: true });
                    }), // since it can be pasted in and persisted
                    experienceWidth: experienceSize.width,
                    experienceHeight: experienceSize.height,
                    isEmailModeEnabled: this.activeExperience.get("emailModeEnabled")
                });
            }
        },


        /**
         * paste a widget(s) from previous copied data
         * @param {Object} copyData The copied data.
         * @param {Object} metadata The options for the paste.
         * @private
         */
        _pasteHandler: function _pasteHandler(copyData, metadata) {
            var _this6 = this;

            var currentScene = this._viewModel.get("scene");
            var experience = this._viewModel.get("experience");
            var models = _.invoke(copyData.models, "clone");
            var pasteCounts = metadata.pasteCounts[currentScene.cid] || 0;
            var contextMenuUsed = metadata.position;
            var defaultOffset = experience.getPercentagePosition({
                left: pasteCounts * 10,
                top: pasteCounts * 10
            });

            if (currentScene && copyData.type === Clipboard.DataTypes.WIDGET) {
                metadata.pasteCounts[currentScene.cid] = contextMenuUsed ? pasteCounts : pasteCounts + 1;

                if (contextMenuUsed) {
                    metadata.position = experience.getPercentagePosition(metadata.position);
                }

                var topMostWidgetPosition = this._getTopLeftPosition(models);

                _.each(models, function (model) {
                    var widgetPosition = _this6._getWidgetPosition(model, contextMenuUsed, topMostWidgetPosition, metadata.position, defaultOffset);
                    model.set({
                        left: widgetPosition.left,
                        top: widgetPosition.top
                    });

                    var currentExperienceSize = experience.getSize();

                    if (model.has("width")) {
                        var widgetWidth = MathUtil.round(model.get("scaledWidth") / currentExperienceSize.width * copyData.experienceWidth, 1);
                        model.set({
                            scaledWidth: widgetWidth,
                            width: widgetWidth
                        });
                    }

                    if (model.has("height")) {
                        var widgetHeight = MathUtil.round(model.get("scaledHeight") / currentExperienceSize.height * copyData.experienceHeight, 1);
                        model.set({
                            scaledHeight: widgetHeight,
                            height: widgetHeight
                        });
                    }
                });

                new AddWidgetsAction(currentScene, models, this.model).execute();
            }
        },
        _getTopLeftPosition: function _getTopLeftPosition(widgets) {
            if (_.isNull(widgets) || _.isEmpty(widgets)) {
                return {};
            }

            var topMostPosition = _.chain(widgets).sortBy(function (widget) {
                return widget.get("top");
            }).first().value().get("top");

            var leftMostPosition = _.chain(widgets).sortBy(function (widget) {
                return widget.get("left");
            }).first().value().get("left");

            return { top: topMostPosition, left: leftMostPosition };
        },
        _getWidgetPosition: function _getWidgetPosition(widget, contextMenuUsed, topMostWidgetPosition, clickPosition, defaultOffset) {
            if (contextMenuUsed) {
                // Calculate the offset between this widget and the topmost widget
                var widgetOffset = {
                    left: topMostWidgetPosition.left - widget.get("left"),
                    top: topMostWidgetPosition.top - widget.get("top")
                };
                // Update the widget position taking into account the above calculated widget offset
                return {
                    left: clickPosition.left - widgetOffset.left,
                    top: clickPosition.top - widgetOffset.top
                };
            }

            // add a default offset so they don't overlay each other
            return {
                left: widget.get("left") + defaultOffset.left,
                top: widget.get("top") + defaultOffset.top
            };
        },
        _toggleMasterLayers: function _toggleMasterLayers(event) {
            var tagname = event.target.tagName.toLowerCase();
            var showMasterLayers = !this._viewModel.get("showMasterLayers");

            if (tagname === "input" || tagname === "textarea" || !!event.target.getAttribute("contentEditable")) {
                return;
            }

            this._viewModel.set("showMasterLayers", showMasterLayers, { triggerOrigin: "KeyPress" });
        },
        _changeLayer: function _changeLayer(event) {
            event.preventDefault();

            var layerValue = $(event.currentTarget).attr("data-layer");
            var layer = LayerEnum.lookup(layerValue);

            this.model.set("currentLayer", layer);
        },
        _setActiveLayerIconAndLabel: function _setActiveLayerIconAndLabel() {
            var activeLayer = this.model.get("currentLayer");

            this.ui.changeLayerLinks.each(function (i, element) {
                var layer = $(element).attr("data-layer");

                if (LayerEnum.lookup(layer) === activeLayer) {
                    $(element).find(LAYER_SELECTED_ICON_SELECTOR).html(UNICODE_FILLED_CIRCLE);
                } else {
                    $(element).find(LAYER_SELECTED_ICON_SELECTOR).html(UNICODE_EMPTY_CIRCLE);
                }
            });

            this.ui.layerLabel.text(this.model.get("currentLayer").name);
        },
        onClose: function onClose() {
            // Clear the history of the activity manager
            EditorActivityManager.clear();

            this._zoomController.close();
            this.ui.snappingSwitch.bootstrapSwitch("destroy", true);
        },
        undo: function undo() {
            if (EditorActivityManager.canUndo()) {
                EditorActivityManager.undo();
            }
        },
        redo: function redo() {
            if (EditorActivityManager.canRedo()) {
                EditorActivityManager.redo();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Browser = __webpack_require__(39),
        EditorCommentsRenderer = __webpack_require__(2967),
        ExperienceEditorSizeController = __webpack_require__(2974),
        ImprovedView = __webpack_require__(6),
        Marionette = __webpack_require__(10),
        Preconditions = __webpack_require__(14),
        SceneEditor = __webpack_require__(717),
        template = __webpack_require__(3016),
        _debounce = __webpack_require__(774);
    /**
     * SceneCollection view class
     * @type {*}
     */
    var SceneCollectionView = Marionette.CollectionView.extend({

        itemViewOptions: function itemViewOptions() {
            return {
                experienceModel: this.options.experienceModel,
                viewScope: this.options.viewScope
            };
        },

        attributes: {
            "data-dragselectable": true
        },

        itemView: SceneEditor,

        itemEvents: {
            "moveScene": "_moveScene"
        },

        _moving: false,

        _moveScene: function _moveScene(event, sceneView, direction) {
            var _this = this;

            if (this._moving) {
                return;
            }

            this._moving = true;

            var sceneNumber = sceneView.model.getSceneIndex(),
                newSceneNumber = direction === "forwards" ? sceneNumber + 1 : sceneNumber - 1,
                adjacentSceneModel = this.collection.at(newSceneNumber - 1),
                adjacentSceneView = this.children.findByModel(adjacentSceneModel),
                el = sceneView.$el,
                el2 = adjacentSceneView.$el,
                scale = this.viewScope.viewModel.get("zoomModel").get("scale"),
                distance = (el2.position().left - el.position().left) / scale,
                primaryDirection = distance > 0 ? "moving-right" : "moving-left",
                secondayDirection = distance > 0 ? "moving-left" : "moving-right";

            el.addClass("moving primary " + primaryDirection).css("transform", "translateX(" + distance + "px)");
            el2.addClass("moving " + secondayDirection).css("transform", "translateX(" + -distance + "px)");

            // Reordering the scenes in the experience model forces a rerendering which ruins
            // the animation, so we wait for the animation to finish first (1s).
            el.one(Browser.animationEndEventName(), function () {
                _this.viewScope.experienceModel.swapScenes(sceneView.model, adjacentSceneModel);
                _this.render();

                // TODO: Find a solution that does not require us to manually trigger 'show'
                // Trigger 'show' here to invoke 'onShow' for widget views
                _this.trigger("show");

                _this._moving = false;
            });
        },

        getWidgetBoundingBox: function getWidgetBoundingBox(widgetModel) {
            Preconditions.isModel(widgetModel);

            var sceneEditor = this.children.find(function (sceneEditor) {
                return sceneEditor.sceneWidgetCollectionView.widgetCollectionViews().some(function (widgetCollectionView) {
                    return widgetCollectionView.collection.get(widgetModel);
                });
            }),
                widgetView;

            sceneEditor.sceneWidgetCollectionView.widgetCollectionViews().some(function (widgetCollectionView) {
                var found = widgetCollectionView.children.findByModel(widgetModel);
                if (found) {
                    widgetView = found;
                    return true; // signal that we have found the widgetView and no more looping through widget collection views is needed
                }
                return false;
            });

            return widgetView.getBoundingBox(true);
        }

    });

    /**
     * ExperienceEditor class
     */
    return ImprovedView.extend({

        className: "experience-editor",

        attributes: {
            "data-dragselectable": true
        },

        template: template,

        _commentsRenderer: null,
        _sceneCollectionView: null,

        templateHelpers: function templateHelpers() {
            return {
                spectatorMode: this.viewScope.spectatorMode
            };
        },

        regions: {
            scenesRegion: ".scenes-region"
        },

        ui: {
            scenesRegion: ".scenes-region"
        },

        modelEvents: {
            "change:selectedWidgetId": "_widgetHighlight"
        },

        viewScope: function viewScope() {
            return {
                experienceModel: this.model
            };
        },

        onRender: function onRender() {
            var _this2 = this;

            var viewModel = this.viewScope.viewModel;
            this.$el.addClass(this.model.get("id"));

            // Initialize the comments renderer
            this._commentsRenderer = new EditorCommentsRenderer(this.$el, this.viewScope);
            viewModel.set("commentsRenderer", this._commentsRenderer);
            this.ui.scenesRegion[0].addEventListener("mousemove", _debounce(function (event) {
                return _this2._trackMousePosition(event);
            }, 50, {
                maxWait: 200
            }));
        },

        _trackMousePosition: function _trackMousePosition(event) {
            window.mouseCoords = {
                clientX: event.clientX,
                clientY: event.clientY
            };
        },
        _widgetHighlight: function _widgetHighlight() {
            // Clear previous highlights, if exists
            this.viewScope.viewModel.getCurrentScene().get("widgets").models.forEach(function (widget) {
                if (widget.get("highlighted")) {
                    widget.set("highlighted", null);
                }
            });
            this.model.get("backgroundScene").get("widgets").models.forEach(function (widget) {
                if (widget.get("highlighted")) {
                    widget.set("highlighted", null);
                }
            });
            this.model.get("overlayScene").get("widgets").models.forEach(function (widget) {
                if (widget.get("highlighted")) {
                    widget.set("highlighted", null);
                }
            });

            if (this.model.has("selectedWidgetId")) {
                // Add shadow to the Experience editor
                this.$el.addClass("shadowed");

                var selectedId = this.model.get("selectedWidgetId");
                if (this.viewScope.viewModel.getCurrentScene().getWidgetByID(selectedId)) {
                    // current scene widget
                    this.viewScope.viewModel.getCurrentScene().getWidgetByID(selectedId).set("highlighted", true);
                } else if (this.model.get("backgroundScene").getWidgetByID(selectedId)) {
                    // background scene widget
                    this.model.get("backgroundScene").getWidgetByID(selectedId).set("highlighted", true);
                } else {
                    // overlay scene widget
                    this.model.get("overlayScene").getWidgetByID(selectedId).set("highlighted", true);
                }
            } else {
                // Remove shadow from Experience editor
                this.$el.removeClass("shadowed");
                this.viewScope.viewModel.trigger("nestedWidgetTabOrderMetaDataChange");
            }
        },


        onShow: function onShow() {
            this._sceneCollectionView = new SceneCollectionView({
                collection: this.model.get("scenes"),
                experienceModel: this.model,
                viewScope: this.viewScope
            });

            this.scenesRegion.show(this._sceneCollectionView);

            this._experienceEditorSizeController = new ExperienceEditorSizeController({
                container: this.$el,
                experience: this.model,
                commentBoundsProvider: this.getCommentBoundsProvider.bind(this),
                getWidgetBoundsProvider: this.getWidgetBoundsProvider.bind(this),
                viewModel: this.viewScope.viewModel
            });
            this._experienceEditorSizeController.start();
        },

        onClose: function onClose() {
            // Dispose the comment renderer
            this.ui.scenesRegion[0].removeEventListener("mousemove", this._trackMousePosition);
            this._commentsRenderer.dispose();
            this._experienceEditorSizeController.close();
        },

        getWidgetBoundsProvider: function getWidgetBoundsProvider(widgetModel) {
            return this._sceneCollectionView.getWidgetBoundingBox(widgetModel);
        },

        getCommentBoundsProvider: function getCommentBoundsProvider(comment) {
            return this._commentsRenderer.getCommentBoundingBoxes(comment);
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        EventDispatcher = __webpack_require__(54),
        EditorCommentView = __webpack_require__(2968),
        _ = __webpack_require__(1),
        Preconditions = __webpack_require__(14),
        Comment = __webpack_require__(711);

    var NEW_COMMENT_WIDTH = 213,
        SCENE_PADDING = 40;

    /**
     * The collection view of comments.
     *
     * @author Bruce Mackenzie Nielsen
     * @class CommentsView
     * @constructor
     *
     * @cfg {CommentCollection} collection The collection of comments to render.
     * @cfg {EditorViewModel} viewModel The editor view model.
     */
    var CommentsView = Marionette.CompositeView.extend({

        template: function template() {
            return "";
        },

        className: "editor-comments-container no-scale",

        itemView: EditorCommentView,

        _currentSceneID: null,

        itemEvents: {
            "commentViewClicked": "commentViewClickedHandler"
        },

        initialize: function initialize() {
            this.itemViewOptions = {
                viewModel: this.options.viewModel,
                editorCommentsRenderer: this.options.editorCommentsRenderer
            };
        },

        /**
         * Called every time a comment is clicked. Will unselect all widgets (to bring the comment view into focus).
         *
         * @param commentModel
         * @param value
         */
        // eslint-disable-next-line no-unused-vars
        commentViewClickedHandler: function commentViewClickedHandler(commentModel, value) {
            var viewModel = this.options.viewModel;
            // Get the scene ID from the comment

            var sceneId = value.model.sceneID;
            // Get the actual scene from the model
            var scene = viewModel.get("experience").getSceneById(sceneId);
            viewModel.set("sceneNumber", scene.get("sceneNumber"));
            viewModel.selection.clear();
        },


        setCurrentSceneID: function setCurrentSceneID(sceneID) {
            var _this = this;

            this._currentSceneID = sceneID;
            this.children.each(function (view) {
                var isOnCurrentScene = view.getSceneID() === _this._currentSceneID;
                view.$el.toggleClass("current-scene", isOnCurrentScene);
            });
        }

    });

    /**
     * Manages the rendering of comments in the editor.
     *
     * <p>Because comments float above the canvas, and can be placed outside the canvas, they can't be rendered inside
     * a container region. Instead, we need to handle the DOM attachment manually. To reduce the complexity of
     * EditorView, this class will handle all of this DOM manipulation.</p>
     *
     * @class EditorCommentsRenderer
     * @constructor
     *
     * @param {jQuery} container The jQuery element to contain the comments.
     * @param {EditorViewModel} viewModel The editor view model.
     */
    return EventDispatcher.extend({

        _container: null,

        _viewScope: null,

        _viewModel: null,

        /**
         * Collection view containing the rendered comments.
         * @type {CommentsView}
         */
        _commentsView: null,

        /**
         * A number that is greater than or equal to the largest z-index of the currently-rendered comments.
         * @type {number}
         */
        _highestCommentZIndex: 0,

        /**
         * How many unpositioned new comments have been added since the collection was reset.
         * @type {number}
         */
        _unpositionedNewCommentsSinceReset: 0,

        constructor: function constructor(container, viewScope) {
            var _this2 = this;

            this._container = container;
            this._viewScope = viewScope;
            this._viewModel = viewScope.viewModel;

            var commentCollection = this._viewModel.get("comments");

            this._highestCommentZIndex = this._getHighestIndex(commentCollection);

            // Create the comments view and display it when showComments is active
            this._commentsView = new CommentsView({
                collection: commentCollection,
                viewModel: this._viewModel,
                editorCommentsRenderer: this
            });

            this._commentsView.render();
            this._updateCommentsDisplay();

            this.listenTo(this._viewModel, "change:showComments", this._updateCommentsDisplay);
            this.listenTo(this._viewModel.get("zoomModel"), "change:scale", this._updateToCurrentScaleFactor);

            // Add the comments view to the container
            container.prepend(this._commentsView.$el);

            this._commentsView.trigger("show");

            // Fade the comments layer when a widget is selected
            this.listenTo(this._viewModel.selection, "change:widgets", function () {
                _this2._commentsView.$el.toggleClass("editor-comments-container-fade", !_this2._viewModel.selection.isEmpty());
            });

            // Fade comments that are not on the current scene
            this.listenTo(this._viewModel, "change:sceneNumber", function () {
                this._unpositionedNewCommentsSinceReset = 0;
                this._updateToCurrentScene();
            });
            this.listenTo(this._viewModel, "change:currentLayer", function () {
                _this2._unpositionedNewCommentsSinceReset = 0;
                _this2._updateToCurrentScene();
            });

            var experience = this._viewModel.get("experience");

            // Listen for experience size changes - making sure comments stick to their scenes
            this.listenTo(experience, "change:width", this._handleExperienceWidthChanges);
            this.listenTo(experience, "change:height", this._handleExperienceHeightChanges);
            // Comments should follow their scenes when scenes are moved
            this.listenTo(experience, "scenes:swapped", this._scenesSwappedHandler);
            // Update view after a comment has been moved/dragged, ensuring potential scrollbars are added/updated
            this.listenTo(this._commentsView, "itemview:moved", this._updateCommentsDisplay);

            this.listenTo(experience, "add:scenes", this._handleSceneAdded);
            this.listenTo(experience, "remove:scenes", this._handleSceneRemoved);

            // Update to current scale when a comment is added
            this.listenTo(commentCollection, "add", this._updateToCurrentScaleFactor);

            this._updateToCurrentScene();
        },

        _getHighestIndex: function _getHighestIndex(commentCollection) {
            return _.max(commentCollection.map(function (comment) {
                return comment.get("zIndex");
            }));
        },

        _updateToCurrentScaleFactor: function _updateToCurrentScaleFactor() {
            var scale = this._viewModel.get("zoomModel").get("scale");

            this._viewModel.get("comments").each(function (comment) {
                comment.set("scaleFactor", scale);
            });

            this._updateCommentsDisplay();
        },

        /**
         * @private
         *
         * Makes sure that all adjacent comments are moved forward when a new scene is added.
         *
         * @param  {Scene} scene The added scene instance.
         */
        _handleSceneAdded: function _handleSceneAdded(scene) {
            var experience = this._viewModel.get("experience"),
                sceneNumber,
                numberOfScenes = experience.getNumberOfScenes();

            for (sceneNumber = scene.get("sceneNumber") + 1; sceneNumber <= numberOfScenes; sceneNumber++) {
                this._moveComments(experience.getSceneBySceneNumber(sceneNumber), "forward");
            }
        },

        /**
         * @private
         *
         * Makes sure that all adjacent comments are moved backwards when a scene is removed.
         *
         * Also, all comments associated with the deleted scene are removed/deleted.
         *
         * @param  {Scene} scene The removed scene instance.
         */
        _handleSceneRemoved: function _handleSceneRemoved(scene) {
            var experience = this._viewModel.get("experience"),
                sceneNumber,
                numberOfScenes = experience.getNumberOfScenes();

            for (sceneNumber = scene.get("sceneNumber"); sceneNumber <= numberOfScenes; sceneNumber++) {
                this._moveComments(experience.getSceneBySceneNumber(sceneNumber), "back");
            }

            // Clean up (delete) associated comments
            var comments = this._viewModel.get("comments").getCommentsForScene(scene.get("id"));
            _.invoke(comments, "destroy");
        },

        _handleExperienceWidthChanges: function _handleExperienceWidthChanges(experienceModel, width) {
            var previousWidth = experienceModel.previous("width");

            this._viewModel.get("comments").each(function (comment) {
                var scene = experienceModel.getSceneById(comment.sceneID),
                    scenePosition = parseInt(scene.get("sceneNumber"), 10),
                    totalPadding = scenePosition * SCENE_PADDING,
                    previousSceneLeft = scenePosition * previousWidth + totalPadding,
                    newSceneLeft = scenePosition * width + totalPadding,
                    relativeCommentLeft = comment.get("left") - previousSceneLeft,
                    leftFactor = relativeCommentLeft / previousWidth,
                    newCommentLeft = newSceneLeft + width * leftFactor;

                comment.set("left", newCommentLeft);
            });
        },


        _handleExperienceHeightChanges: function _handleExperienceHeightChanges(experienceModel, height) {
            var previousHeight = experienceModel.previous("height");

            this._viewModel.get("comments").each(function (comment) {
                var topFactor = comment.get("top") / previousHeight;

                comment.set("top", height * topFactor);
            });
        },

        _moveComments: function _moveComments(scene, direction) {
            var comments = this._viewModel.get("comments").getCommentsForScene(scene.get("id")),
                experienceWidth = this._viewModel.get("experience").get("width"),
                amount = experienceWidth + SCENE_PADDING;

            _.each(comments, function (comment) {
                var commentLeft = comment.get("left");

                comment.set("left", direction === "forward" ? commentLeft + amount : commentLeft - amount, {
                    animate: true
                });
            });
        },

        _scenesSwappedHandler: function _scenesSwappedHandler(options) {
            var scenes = options.scenes;
            // Scenes sorted by lowest index, i.e. first scene was moved back
            this._moveComments(scenes[0], "back");
            this._moveComments(scenes[1], "forward");
        },

        _updateToCurrentScene: function _updateToCurrentScene() {
            var currentScene = this._viewModel.get("scene");

            // Make sure we have a persisted scene ID
            if (currentScene.has("id")) {
                this._commentsView.setCurrentSceneID(currentScene.get("id"));
            } else {
                this.listenToOnce(currentScene, "change:id", function () {
                    this._commentsView.setCurrentSceneID(currentScene.get("id"));
                });
            }
        },

        _updateCommentsDisplay: function _updateCommentsDisplay() {
            // Show the comments container if needed
            this._commentsView.$el.toggleClass("editor-comments-container-hide", !this._viewModel.get("showComments"));

            this._updateToCurrentScene();
        },

        getCommentBoundingBoxes: function getCommentBoundingBoxes(commentModel) {
            Preconditions.isModel(commentModel);
            return this._commentsView.children.findByModel(commentModel).getBoundingRect();
        },

        /**
         * Moves the given comment to the top, by setting its z-index higher than the current highest index.
         * @param {Comment} comment The comment.
         * @returns {number} The new z-index of the comment.
         */
        moveCommentToTop: function moveCommentToTop(comment) {
            this._highestCommentZIndex++;
            comment.set("zIndex", this._highestCommentZIndex);
            return this._highestCommentZIndex;
        },

        /**
         * Adds a new comment.
         */
        addComment: function addComment() {
            var options = {},
                containerOffset = this._container.offset(),
                sceneBounds = this._viewScope.getCurrentSceneBounds(),
                scale = this._viewModel.get("zoomModel").get("scale"),
                startLeft = -containerOffset.left + sceneBounds.left + this._unpositionedNewCommentsSinceReset * 15;

            // Position the comment at the top center of the current scene
            options.top = this._unpositionedNewCommentsSinceReset * 15;
            options.left = startLeft / scale + (sceneBounds.width * 0.5 - NEW_COMMENT_WIDTH * 0.5);

            this._unpositionedNewCommentsSinceReset++;

            var comment = new Comment(options);

            // Apply correct depth (z-index)
            this.moveCommentToTop(comment);

            this._viewModel.addComment(comment);
        },

        dispose: function dispose() {
            // Clean up
            this.stopListening();
            this._commentsView.close();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _ = __webpack_require__(1),
        Marionette = __webpack_require__(10),
        TweenMax = __webpack_require__(152),
        CommentView = __webpack_require__(2969);

    var doc = $("html");

    /**
     * Wrapper around a comment view for display in the editor. Manages positioning of the comment.
     *
     * @author Bruce Mackenzie Nielsen
     * @class EditorCommentView
     * @constructor
     *
     * @cfg {Comment} model The comment to render.
     * @cfg {EditorViewModel} viewModel The editor view model.
     */
    return Marionette.ItemView.extend({
        tagName: "div",

        className: "editor-comment",

        template: function template() {
            return "";
        },

        commentView: null,

        moveStartPosition: null,

        viewModel: null,

        events: {
            "mousedown": "_mouseDownHandler",
            "click": "_moveToTop"
        },

        initialize: function initialize() {
            this.viewModel = this.options.viewModel;
            this.listenTo(this.model, "destroy", this.close);
            this.listenTo(this.model, "change:top change:left change:scaleFactor", function (commentModel, value, options) {
                // Update comment position and save the model
                this._setPosition(null, options && options.animate);
            });
        },

        _moveToTop: function _moveToTop() {
            this.$el.css("zIndex", this.options.editorCommentsRenderer.moveCommentToTop(this.model));
            // Trigger a comment view click event
            this.trigger("commentViewClicked");
        },

        _mouseDownHandler: function _mouseDownHandler(event) {
            // Only consider the left mouse button
            if (event.which !== 1) {
                return;
            }

            // Ignore clicks on scroll bars
            if (event.target.className.indexOf("comment-collection-region") !== -1) {
                return;
            }

            // Make this the topmost comment
            this._moveToTop();

            // Store the initial mouse coordinates
            this.moveStartPosition = {
                left: event.pageX,
                top: event.pageY
            };

            // Add move and up handlers to the container
            doc.on("mousemove", this._mouseMoveHandler.bind(this));
            doc.on("mouseup", this._mouseUpHandler.bind(this));

            event.preventDefault();
        },

        _mouseMoveHandler: function _mouseMoveHandler(event) {
            if (this.moveStartPosition) {
                var left = event.pageX - this.moveStartPosition.left,
                    top = event.pageY - this.moveStartPosition.top;

                this._setPosition({
                    left: left,
                    top: top
                });

                event.preventDefault();
            }
        },

        _mouseUpHandler: function _mouseUpHandler(event) {
            if (this.moveStartPosition) {
                // Did we move? No need to burden the backend with a save otherwise...
                var deltaX = event.pageX - this.moveStartPosition.left,
                    deltaY = event.pageY - this.moveStartPosition.top;

                if (deltaX !== 0 || deltaY !== 0) {
                    var scaleFactor = this.viewModel.get("zoomModel").get("scale");
                    // Apply the offset to the model. If negative, set to 0.
                    this.model.set({
                        left: Math.max(Math.floor(this.model.get("left") + deltaX / scaleFactor), 0),
                        top: Math.max(Math.floor(this.model.get("top") + deltaY / scaleFactor), 0)
                    });

                    event.preventDefault();

                    this.trigger("moved");
                }
            }

            // Clean up
            this.moveStartPosition = null;
            doc.off("mousemove");
            doc.off("mouseup");
        },

        /**
         * Sets the position of the comment.
         *
         * @param {Object} [offset] If specified, offsets the position. Should be an object with both left and top properties.
         * @private
         */
        _setPosition: function _setPosition(offset, animate) {
            var scaleFactor = this.viewModel.get("zoomModel").get("scale");
            var position = this.model.getScaledPosition(scaleFactor);

            if (offset) {
                position.left += offset.left;
                position.top += offset.top;
            }

            position.left = Math.max(0, position.left);
            position.top = Math.max(0, position.top);

            if (animate) {
                TweenMax.to(this.el, 0.5, { x: position.left, y: position.top });
            } else {
                TweenMax.set(this.el, { x: position.left, y: position.top });
            }

            var changedAttributes = this.model.changedAttributes();

            // Save non-empty comment position if "top" of "left" has been changed
            if ((_.has(changedAttributes, "top") || _.has(changedAttributes, "left")) && this.model.get("content")) {
                this.model.saveLater();
            }
        },

        /**
         * Gets the bounds of the comment, in pixels, relative to the center of the scene.
         * @returns {{left: number, right: number, top: number, bottom: number}}
         */
        getBounds: function getBounds() {
            var scaleFactor = this.viewModel.get("zoomModel").get("scale");
            var position = this.model.getScaledPosition(scaleFactor);

            return {
                left: position.left,
                right: position.left + this.$el.width(),
                top: position.top,
                bottom: position.top + this.$el.height()
            };
        },

        getSceneID: function getSceneID() {
            return this.model.sceneID || this.model.scene;
        },

        onRender: function onRender() {
            // Render the actual comment view inside the container
            this.commentView = new CommentView({ model: this.model, viewModel: this.options.viewModel });
            this.$el.append(this.commentView.render().$el);

            // Position the comment
            this._setPosition();
            this.$el.css("zIndex", this.model.get("zIndex") || 0);
        },

        onShow: function onShow() {
            this.commentView.addedToDOM();
        },

        getBoundingRect: function getBoundingRect() {
            return this.el.getBoundingClientRect();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* global confirm */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Comment = __webpack_require__(711);
    var CommentCollectionView = __webpack_require__(2970);
    var ConcatenatedCollection = __webpack_require__(714);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);
    var LoggedIn = __webpack_require__(31);
    var Promise = __webpack_require__(21);
    var template = __webpack_require__(2973);
    var Time = __webpack_require__(121);

    /**
     * Simple jQuery event handler to stop propagation of the event.
     * @param {jQuery.Event} event The jQuery event.
     */
    var stopPropagation = function stopPropagation(event) {
        return event.stopPropagation();
    };

    /**
     * View of a comment.
     *
     * @author Bruce Mackenzie Nielsen
     * @class CommentView
     * @constructor
     *
     * @cfg {Comment} model The comment model.
     * @cfg {EditorViewModel} viewModel The editor view model.
     */
    return ImprovedView.extend({

        template: template,

        className: "comment",

        regions: {
            commentCollection: ".comment-collection-region"
        },

        ui: {
            header: ".comment-header",
            commentCollection: ".comment-collection-region",
            replyWrapper: ".comment-reply",
            reply: "textarea",
            replySizer: ".comment-reply-sizer",
            replyIcon: ".comment-reply-icon"
        },

        bindings: {
            ".unread-comments-indicator": "unread",
            ".unread-comments-indicator-wrapper": {
                observe: "unread",
                updateView: false,
                visible: function visible(value) {
                    return value > 0;
                }
            }
        },

        events: {
            // Prevent clicks on some elements from dragging the comment
            "mousedown textarea": stopPropagation,
            "mousedown .comment-delete": stopPropagation,
            "mousedown .comment-reply-icon": stopPropagation,

            // Submit comment on enter key, unless control or shift are also pressed
            "keydown textarea": "_textareaKeydownHandler",

            "click .comment-reply-icon": "_submitReply",

            "keyup textarea": "_updateReplySizer",

            "click .comment-delete": "_commentDeleteClickHandler"
        },

        modelEvents: {
            "change:isNew": "_updateNewClass"
        },

        _commentDeleteClickHandler: function _commentDeleteClickHandler(event) {
            event.preventDefault();

            var isNew = this.model.get("isNew");

            if (isNew) {
                // Empty comment...
                return this.model.destroy();
            }

            if (confirm("Are you sure you want to delete this comment thread?")) {
                // Delete comment thread
                var viewModel = this.options.viewModel;

                var experience = viewModel.get("experience");
                var eventProperties = {
                    commentThreadId: this.model.get("id"),
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    sceneNumber: viewModel.get("sceneNumber"),
                    triggerOrigin: "CommentMenuDeleteButton",
                    numberOfComments: this.model.get("replies").length + 1 /* +1 for counting the comment model 'content' property */
                };

                viewModel.commentDeleted(this.model, this.model.destroy({ silent: true }));

                // Trigger only if the comment thread contains comments
                EditorEvents.trigger(EditorEvents.constants.DELETE_COMMENT_THREAD, eventProperties);
            }
        },
        _textareaKeydownHandler: function _textareaKeydownHandler(event) {
            if (event.keyCode === 13) {
                if (event.ctrlKey || event.shiftKey) {
                    // REVIEW: Consider simulating an enter if ctrl was pressed, browser appears to ignore it
                    return;
                }

                event.preventDefault();
                this._submitReply();
            }
        },
        _submitReply: function _submitReply() {
            var _this = this;

            var _ui = this.ui,
                reply = _ui.reply,
                commentCollection = _ui.commentCollection;


            var message = reply.val().trim();

            if (message) {
                var promise = void 0;
                var model = this.model;

                var isNew = model.get("isNew");
                var viewModel = this.options.viewModel;

                var experience = viewModel.get("experience");
                var commentData = {
                    createdAt: Time.server(),
                    createdBy: LoggedIn.principal().get("userId"),
                    content: message
                };

                // Save differently depending on whether or not this is a reply
                if (isNew) {
                    model.set(commentData);
                    promise = model.save();
                } else {
                    var comment = new Comment(commentData);
                    // Make sure the parent comment has been saved...
                    if (model.has("id")) {
                        comment.set("parentId", model.get("id"), { silent: true });
                        promise = comment.save();
                    } else {
                        promise = Promise.deferred(function (deferred) {
                            _this.listenToOnce(model, "change:id", function () {
                                comment.set("parentId", model.get("id"), { silent: true });
                                deferred.resolve();
                            });
                        });
                    }

                    model.get("replies").add(comment);
                }

                // Signal that a new comment was created
                promise.then(function () {
                    var eventProperties = {
                        commentThreadId: model.get("id"),
                        experienceId: experience.get("id"),
                        experienceVersion: experience.get("version"),
                        experiencePushedVersion: experience.get("pushedVersion"),
                        sceneNumber: viewModel.get("sceneNumber"),
                        messageLength: message.length,
                        isAddedToNewCommentThread: isNew,
                        triggerOrigin: "EditorCommentPlusButton"
                    };

                    EditorEvents.trigger(EditorEvents.constants.CREATE_COMMENT, eventProperties);
                });

                reply.val("");
                this._updateReplySizer();

                viewModel.commentPosted(model, promise);

                commentCollection.scrollTop(commentCollection[0].scrollHeight);
            }
        },
        _sizeCollectionView: function _sizeCollectionView() {
            // Sets the max height of the collection view to the max height of the entire comment (300) minus the height
            // of the reply area, minus the height of the header, minus the borders (2).
            this.ui.commentCollection.css("max-height", 300 - this.ui.replyWrapper.outerHeight(true) - this.ui.header.outerHeight(true) - 2);
        },
        _updateReplySizer: function _updateReplySizer() {
            var _ui2 = this.ui,
                reply = _ui2.reply,
                replySizer = _ui2.replySizer,
                replyIcon = _ui2.replyIcon;
            // Copy the textarea text to the hidden div that ensures the sizing
            // Divs render trailing line breaks differently than textareas, so add an extra line break if needed

            var message = reply.val();

            if (!message) {
                message = "\n";
            } else if (message.charAt(message.length - 1) === "\n") {
                message += "\n";
            }

            replySizer.text(message);

            // Detect scroll bar width to set the right position of the icon
            var iconRightPosition = 5 + replySizer.outerWidth() - replySizer.innerWidth();

            replyIcon.css("right", iconRightPosition);
            reply.css("background-position", "bottom 5px right " + iconRightPosition + " px");

            // Update the collection view sizing, since it might now be different
            this._sizeCollectionView();
        },
        _updateNewClass: function _updateNewClass() {
            if (this.model.get("isNew")) {
                this.$el.addClass("comment-new");
            } else {
                this.$el.removeClass("comment-new");
            }
        },
        onRender: function onRender() {
            this.commentCollection.show(new CommentCollectionView({
                collection: new ConcatenatedCollection(this.model, this.model.get("replies")),
                viewModel: this.options.viewModel
            }));

            this._updateNewClass();
        },


        /**
         * Invoked when the comment view is added to the DOM.
         */
        addedToDOM: function addedToDOM() {
            this._updateReplySizer();
            this.ui.commentCollection.scrollTop(this.ui.commentCollection[0].scrollHeight);
            this.ui.reply.focus();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        CommentItemView = __webpack_require__(2971);

    /**
     * The collection view of comments.
     *
     * @author Bruce Mackenzie Nielsen
     * @class CommentCollectionView
     * @constructor
     */
    return Marionette.CompositeView.extend({
        template: function template() {
            return "";
        },
        className: "comment-collection-view",
        itemView: CommentItemView,
        initialize: function initialize() {
            this.itemViewOptions = {
                viewModel: this.options.viewModel
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        LoggedIn = __webpack_require__(31),
        template = __webpack_require__(2972);

    /**
     * Item view for a comment.
     *
     * @author Bruce Mackenzie Nielsen
     * @class CommentItemView
     * @constructor
     */
    return ImprovedView.extend({
        template: template,
        className: "comment-item-view",

        bindings: {
            ".comment-date": {
                observe: "createdAt",
                onGet: function onGet(createdAt) {
                    return new Date(createdAt).toLocaleString();
                }
            },
            ".comment-author": {
                observe: "user",
                onGet: function onGet(user) {
                    if (user) {
                        return LoggedIn.principal().forUser(user) ? "You: " : user.get("displayName") + ": ";
                    }
                    return "";
                }
            },
            ".comment-message": "content",
            ".comment-item-wrapper": {
                attributes: [{
                    name: "style",
                    observe: "user",
                    onGet: function onGet(user) {
                        var colorCode = "#c6c6c6";
                        if (user) {
                            colorCode = user.get("backgroundColor");
                        }
                        return "background-color: " + colorCode;
                    }
                }, {
                    name: "class",
                    observe: "isUnread",
                    onGet: function onGet(isUnread) {
                        if (isUnread) {
                            return "comment-item-wrapper comment-unread";
                        }

                        return "comment-item-wrapper";
                    }
                }]
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2972 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="comment-item-wrapper">\n    <div class="comment-content">\n        <div class="comment-date"></div>\n        <div class="comment-body">\n            <div class="comment-author"></div>\n            <div class="comment-message"></div>\n        </div>\n    </div>\n    <div class="comment-color-indicator"></div>\n    <div class="comment-spacer"></div>\n</div>';

}
return __p
}

/***/ }),
/* 2973 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="comment-header">\n    <div class="comment-icon">\n        <div class="unread-comments-indicator-wrapper"><div class="unread-comments-indicator"></div></div>\n    </div>\n    <a href="#" class="comment-delete"></a>\n</div>\n<div class="comment-collection-region"></div>\n<div class="comment-reply-wrapper">\n    <div class="comment-reply">\n        <textarea placeholder="Write comment"></textarea>\n        <div class="comment-reply-sizer"></div>\n        <div class="comment-reply-icon"></div>\n    </div>\n</div>';

}
return __p
}

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        Preconditions = __webpack_require__(14),
        _ = __webpack_require__(1);

    var SCROLLBAR_MARGIN = 15,
        BOUNDARY_MARGIN = 5,
        DEFAULT_CONTAINER_SIZE = { right: 0, bottom: 0 },
        WIDGET_EVENTS = "change:width change:height change:top change:left remove";

    return Marionette.Controller.extend({

        _viewModel: null,
        _comments: null,
        _experienceModel: null,
        _scenes: null,
        _overlayScene: null,
        _backgroundScene: null,

        initialize: function initialize() {
            Preconditions.isModel(this.options.viewModel);
            Preconditions.isModel(this.options.experience);

            this._viewModel = this.options.viewModel;
            this._comments = this.options.viewModel.get("comments");
            this._experienceModel = this.options.experience;
            this._scenes = this.options.experience.get("scenes");
            this._overlayScene = this.options.experience.get("overlayScene");
            this._backgroundScene = this.options.experience.get("backgroundScene");
        },

        /**
         * Registers listeners and updates the size initially
         */
        start: function start() {
            this.listenTo(this._viewModel, "change:scene", this._updateContainerSize);
            this.listenTo(this._comments, "change:left change:top add:replies remove", this._updateContainerSize);
            this._scenes.each(function (scene) {
                this.listenTo(scene.get("widgets"), WIDGET_EVENTS, this._deferredUpdateContainerSize);
            }, this);
            this.listenTo(this._overlayScene.get("widgets"), WIDGET_EVENTS, this._deferredUpdateContainerSize);
            this.listenTo(this._backgroundScene.get("widgets"), WIDGET_EVENTS, this._deferredUpdateContainerSize);

            this.listenTo(this._viewModel, "editorView:TransitionedIn", this._updateContainerSize);
        },

        /**
         * Wait for the widget element to be rendered before we check its new position.
         * Otherwise the container will update based on the old widget position (if it's
         * changed from the input fields).
         */
        _deferredUpdateContainerSize: function _deferredUpdateContainerSize() {
            _.defer(this._updateContainerSize.bind(this));
        },

        /**
         * Updates the container size, so it's large enough to include all widgets
         * and all comments (to get the scrollbars)
         */
        _updateContainerSize: function _updateContainerSize() {
            var offset = this.options.container.offset(),
                widgets = this._viewModel.get("scene").get("widgets"),
                // Widgets on "current scene" (collection)
            comments = this._viewModel.get("comments"),
                // Comments Collection
            showComments = this._viewModel.get("showComments"),
                // Whether comments are shown at all
            scale = this._viewModel.get("zoomModel").get("scale"),
                widgetsBounds = this._getElementsBounds(this.options.getWidgetBoundsProvider, widgets),
                commentsBounds = showComments ? this._getElementsBounds(this.options.commentBoundsProvider, comments) : DEFAULT_CONTAINER_SIZE;

            this.options.container.css(this._getMinWidthHeightCss(offset, scale, widgetsBounds, commentsBounds));

            this._correctOutOfBoundsWidgets(offset, this.options.getWidgetBoundsProvider, widgets);

            this._viewModel.trigger("editorView:updateContainerSize");
        },

        /**
         * Run through every widget and correct the position if it is above or to the left of the container (so
         * it is invisible and unreachable).
         */
        _correctOutOfBoundsWidgets: function _correctOutOfBoundsWidgets(offset, boundsProvider, widgets) {
            Preconditions.isObject(offset);
            Preconditions.isFunction(boundsProvider);
            Preconditions.isCollection(widgets);

            widgets.each(function (widget) {
                var bounds = boundsProvider(widget),
                    correctionInPx,
                    correctionInPercent;

                // Moving widget back into the view from left
                if (widget.get("width") > 0 && bounds.right - offset.left - BOUNDARY_MARGIN < 0) {
                    correctionInPx = bounds.right - offset.left - BOUNDARY_MARGIN;
                    correctionInPercent = this._experienceModel.getPercentageSize({ width: correctionInPx }).width;

                    widget.set("left", widget.get("left") - correctionInPercent);
                }

                // Moving widget back into the view from top
                if (widget.get("height") > 0 && bounds.bottom - offset.top - BOUNDARY_MARGIN < 0) {
                    correctionInPx = bounds.bottom - offset.top - BOUNDARY_MARGIN;
                    correctionInPercent = this._experienceModel.getPercentageSize({ height: correctionInPx }).height;

                    widget.set("top", widget.get("top") - correctionInPercent);
                }
            }, this);
        },

        _getMinWidthHeightCss: function _getMinWidthHeightCss(offset, scale, widgetsBounds, commentsBounds) {
            var minWidth = Math.max(widgetsBounds.right, commentsBounds.right),
                minHeight = Math.max(widgetsBounds.bottom, commentsBounds.bottom);

            return {
                minWidth: (minWidth - offset.left) / scale + SCROLLBAR_MARGIN,
                minHeight: (minHeight - offset.top) / scale + SCROLLBAR_MARGIN
            };
        },

        /**
         * Returns and object containing the maximum right and bottom
         * of all models from a collection
         */
        _getElementsBounds: function _getElementsBounds(boundsProvider, collection) {
            Preconditions.isFunction(boundsProvider);
            Preconditions.isCollection(collection);

            // Running through each child in the collection and returns
            // the furthermost right and bottom
            return collection.reduce(function (memo, model) {
                var elementBoundingBox = boundsProvider(model);

                return {
                    right: Math.max(memo.right, elementBoundingBox.right),
                    bottom: Math.max(memo.bottom, elementBoundingBox.bottom)
                };
            }, DEFAULT_CONTAINER_SIZE);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_RESULT__;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// v 1.12.2
// @ts-check

/* 
    ____                   _____      __          __ 
   / __ \_________ _____ _/ ___/___  / /__  _____/ /_
  / / / / ___/ __ `/ __ `/\__ \/ _ \/ / _ \/ ___/ __/
 / /_/ / /  / /_/ / /_/ /___/ /  __/ /  __/ /__/ /_  
/_____/_/   \__,_/\__, //____/\___/_/\___/\___/\__/  
                 /____/                              

 {*} {*} STAR THIS PLUGIN ON GITHUB: {*} {*}

 https://github.com/ThibaultJanBeyer/DragSelect
 Please give it a like, this is what makes me happy :-)
 Thanks You

 {*} {*} STAR THIS PLUGIN ON GITHUB: {*} {*}

 ******************************************
 ********* The MIT License (MIT) **********
 ******************************************
 Copyright (c) 2017 ThibaultJanBeyer
 web: http://www.thibaultjanbeyer.com/
 github: https://github.com/ThibaultJanBeyer/DragSelect
 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:
 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.
 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 --- Notes ---
 Checking types using JS-Docs inspired by this post:
 https://medium.com/@trukrs/type-safe-javascript-with-jsdoc-7a2a63209b76
 ---
*/
// Setup
//////////////////////////////////////////////////////////////////////////////////////
var DragSelect =
/*#__PURE__*/
function () {
  /** @type {boolean} */

  /** @type {{x: number, y: number}} */

  /** @type {{x: number, y: number}} */

  /** @type {{x: number, y: number}} */

  /** @type {{x: number, y: number}} */

  /** @type {Array.<(SVGElement|HTMLElement)>} */

  /** @type {Array.<(SVGElement|HTMLElement)>} */
  // memory to fix #9

  /**
   * @constructor
   * @param {object} options - The options object.
   * @param {HTMLElement | SVGElement | Document} [options.area=document] area in which you can drag. If not provided it will be the whole document
   * @param {number} [options.autoScrollSpeed=1] Speed in which the area scrolls while selecting (if available). Unit is pixel per movement. Default = 1
   * @param {number} [options.zoom=1] Zoom scale factor (in case of using CSS style transform: scale() which messes with real positions). Unit scale zoom. Default = 1
   * @param {Function} [options.callback=(selected, event) => {}] a callback function that gets fired when the element is dropped. This callback gets a property which is an array that holds all selected nodes. The second property passed is the event object.
   * @param {boolean} [options.customStyles=false] if set to true, no styles (except for position absolute) will be applied by default
   * @param {string} [options.hoverClass=ds-hover] the class assigned to the mouse hovered items
   * @param {boolean} [options.multiSelectMode=false] Add newly selected elements to the selection instead of replacing them. Default = false
   * @param {Function} [options.onDragMove=()=>{}] It is fired when the user drags. This callback gets the event object. Executed before DragSelect function code ran, after getting the current mouse position.
   * @param {Function} [options.onDragStartBegin=()=>{}] Is fired when the user clicks in the area. This callback gets the event object. Executed *before* DragSelect function code ran.
   * @param {Function} [options.onDragStart=()=>{}] It is fired when the user clicks in the area. This callback gets the event object. Executed after DragSelect function code ran, before the setup of event listeners.
   * @param {Function} [options.onElementSelect=()=>{}] It is fired every time an element is selected. This callback gets a property which is the just selected node
   * @param {Function} [options.onElementUnselect=()=>{}] It is fired every time an element is de-selected. This callback gets a property which is the just de-selected node
   * @param {string} [options.selectableClass=ds-selectable] the class assigned to the elements that can be selected
   * @param {HTMLElement[] | SVGElement[] | HTMLElement | SVGElement} [options.selectables=[]] the elements that can be selected
   * @param {string} [options.selectedClass=ds-selected] the class assigned to the selected items
   * @param {HTMLElement} [options.selector=HTMLElement] the square that will draw the selection
   * @param {string} [options.selectorClass=ds-selector] the class assigned to the square selector helper
   * @param {string[]} [options.multiSelectKeys=['ctrlKey', 'shiftKey', 'metaKey']] An array of keys that allows switching to the multi-select mode (see the @multiSelectMode option). The only possible values are keys that are provided via the event object. So far: <kbd>ctrlKey</kbd>, <kbd>shiftKey</kbd>, <kbd>metaKey</kbd> and <kbd>altKey</kbd>. Provide an empty array `[]` if you want to turn off the functionality.
   */
  function DragSelect(_ref) {
    var _this = this;

    var _ref$area = _ref.area,
        area = _ref$area === void 0 ? document : _ref$area,
        _ref$autoScrollSpeed = _ref.autoScrollSpeed,
        autoScrollSpeed = _ref$autoScrollSpeed === void 0 ? 1 : _ref$autoScrollSpeed,
        _ref$callback = _ref.callback,
        callback = _ref$callback === void 0 ? function () {} : _ref$callback,
        _ref$customStyles = _ref.customStyles,
        customStyles = _ref$customStyles === void 0 ? false : _ref$customStyles,
        _ref$hoverClass = _ref.hoverClass,
        hoverClass = _ref$hoverClass === void 0 ? 'ds-hover' : _ref$hoverClass,
        _ref$multiSelectKeys = _ref.multiSelectKeys,
        multiSelectKeys = _ref$multiSelectKeys === void 0 ? ['ctrlKey', 'shiftKey', 'metaKey'] : _ref$multiSelectKeys,
        _ref$multiSelectMode = _ref.multiSelectMode,
        multiSelectMode = _ref$multiSelectMode === void 0 ? false : _ref$multiSelectMode,
        _ref$onDragMove = _ref.onDragMove,
        onDragMove = _ref$onDragMove === void 0 ? function () {} : _ref$onDragMove,
        _ref$onDragStart = _ref.onDragStart,
        onDragStart = _ref$onDragStart === void 0 ? function () {} : _ref$onDragStart,
        _ref$onDragStartBegin = _ref.onDragStartBegin,
        onDragStartBegin = _ref$onDragStartBegin === void 0 ? function () {} : _ref$onDragStartBegin,
        _ref$onElementSelect = _ref.onElementSelect,
        onElementSelect = _ref$onElementSelect === void 0 ? function () {} : _ref$onElementSelect,
        _ref$onElementUnselec = _ref.onElementUnselect,
        onElementUnselect = _ref$onElementUnselec === void 0 ? function () {} : _ref$onElementUnselec,
        _ref$selectableClass = _ref.selectableClass,
        selectableClass = _ref$selectableClass === void 0 ? 'ds-selectable' : _ref$selectableClass,
        _ref$selectables = _ref.selectables,
        selectables = _ref$selectables === void 0 ? [] : _ref$selectables,
        _ref$selectedClass = _ref.selectedClass,
        selectedClass = _ref$selectedClass === void 0 ? 'ds-selected' : _ref$selectedClass,
        _ref$selector = _ref.selector,
        selector = _ref$selector === void 0 ? undefined : _ref$selector,
        _ref$selectorClass = _ref.selectorClass,
        selectorClass = _ref$selectorClass === void 0 ? 'ds-selector' : _ref$selectorClass,
        _ref$zoom = _ref.zoom,
        zoom = _ref$zoom === void 0 ? 1 : _ref$zoom;

    _classCallCheck(this, DragSelect);

    _defineProperty(this, "_multiSelectKeyPressed", false);

    _defineProperty(this, "_initialCursorPos", {
      x: 0,
      y: 0
    });

    _defineProperty(this, "_newCursorPos", {
      x: 0,
      y: 0
    });

    _defineProperty(this, "_previousCursorPos", {
      x: 0,
      y: 0
    });

    _defineProperty(this, "_initialScroll", {
      x: 0,
      y: 0
    });

    _defineProperty(this, "_selected", []);

    _defineProperty(this, "_prevSelected", []);

    _defineProperty(this, "_lastTouch", void 0);

    _defineProperty(this, "_onClick", function (event) {
      return _this.handleClick(event);
    });

    _defineProperty(this, "_startUp", function (event) {
      return _this.startUp(event);
    });

    _defineProperty(this, "_handleMove", function (event) {
      return _this.handleMove(event);
    });

    _defineProperty(this, "_end", function (event) {
      return _this.reset(event, true);
    });

    this.selectedClass = selectedClass;
    this.hoverClass = hoverClass;
    this.selectorClass = selectorClass;
    this.selectableClass = selectableClass;
    this.selectables = [];
    this._initialSelectables = this._toArray(selectables);
    this.multiSelectKeys = multiSelectKeys;
    this.multiSelectMode = multiSelectMode;
    this.autoScrollSpeed = autoScrollSpeed === 0 ? 0 : autoScrollSpeed;
    this.selectCallback = onElementSelect;
    this.unselectCallback = onElementUnselect;
    this.onDragStartBegin = onDragStartBegin;
    this.moveStartCallback = onDragStart;
    this.moveCallback = onDragMove;
    this.callback = callback;
    this.area = this._handleArea(area);
    this.customStyles = customStyles;
    this.zoom = zoom; // Selector

    this.selector = selector || this._createSelector();
    this.selector.classList.add(this.selectorClass);
    this.start();
  }
  /**
   * @param {(HTMLElement|SVGElement|any)} area
   * @private
   */


  _createClass(DragSelect, [{
    key: "_handleArea",
    value: function _handleArea(area) {
      if (area === document) return area; // Area has to have a special position attribute for calculations

      var computedStyles = getComputedStyle(area);
      area.computedBorder = parseInt(computedStyles.borderWidth);
      var position = computedStyles.position;
      var isPositioned = position === 'absolute' || position === 'relative' || position === 'fixed';

      if (!isPositioned) {
        area.style.position = 'relative';
      }

      return area;
    }
    /**
     * Add/Remove Selectables also handles css classes and event listeners.
     * @param {HTMLElement[]|SVGElement[]} selectables - selectable elements.
     * @param {boolean} [remove] - if elements should be removed.
     * @param {boolean} [fromSelection] - if elements should also be added/removed to the selection.
     * @private
     */

  }, {
    key: "_handleSelectables",
    value: function _handleSelectables(selectables, remove, fromSelection) {
      for (var index = 0; index < selectables.length; index++) {
        var selectable = selectables[index];
        var indexOf = this.selectables.indexOf(selectable);

        if (indexOf < 0 && !remove) {
          this._addSelectable(selectable, fromSelection);
        } else if (indexOf > -1 && remove) {
          this._removeSelectable(selectable, indexOf, fromSelection);
        }
      }
    }
    /**
     * @param {(HTMLElement|SVGElement)} selectable
     * @param {boolean} toSelection also adds it to the current selection
     * @private
     */

  }, {
    key: "_addSelectable",
    value: function _addSelectable(selectable, toSelection) {
      selectable.classList.add(this.selectableClass);
      selectable.addEventListener('click', this._onClick);
      this.selectables.push(selectable); // also add to current selection

      if (toSelection && this._selected.indexOf(selectable) < 0) {
        selectable.classList.add(this.selectedClass);

        this._selected.push(selectable);
      }
    }
    /**
     * @param {(HTMLElement|SVGElement)} selectable
     * @param {number} indexOf
     * @param {boolean} [fromSelection] also adds it to the current selection
     * @private
     */

  }, {
    key: "_removeSelectable",
    value: function _removeSelectable(selectable, indexOf, fromSelection) {
      selectable.classList.remove(this.hoverClass);
      selectable.classList.remove(this.selectableClass);
      selectable.removeEventListener('click', this._onClick);
      this.selectables.splice(indexOf, 1); // also remove from current selection

      if (fromSelection && this._selected.indexOf(selectable) > -1) {
        selectable.classList.remove(this.selectedClass);

        this._selected.splice(this._selected.indexOf(selectable), 1);
      }
    }
    /**
     * @param {MouseEvent} event
     * @private
     */

  }, {
    key: "handleClick",

    /**
     * Triggers when a node is actively selected.
     *
     * This might be an "onClick" method but it also triggers when
     * <button> nodes are pressed via the keyboard.
     * Making DragSelect accessible for everyone!
     *
     * @param {MouseEvent} event
     * @private
     */
    value: function handleClick(event) {
      if (this.mouseInteraction) {
        return;
      } // fix firefox doubleclick issue


      if (this._isRightClick(event)) {
        return;
      }
      /** @type {any} */


      var node = event.target;

      if (this._isMultiSelectKeyPressed(event)) {
        this._prevSelected = this._selected.slice();
      } // #9
      else {
          this._prevSelected = [];
        } // #9


      this.checkIfInsideSelection(true); // reset selection if no multiselectionkeypressed

      if (this.selectables.indexOf(node) > -1) {
        this.toggle(node);
      }

      this._end(event);
    }
    /**
     * Create the selector node when not provided by options object.
     * @return {HTMLElement}
     * @private
     */

  }, {
    key: "_createSelector",
    value: function _createSelector() {
      var selector = document.createElement('div');
      selector.style.position = 'absolute';

      if (!this.customStyles) {
        selector.style.background = 'rgba(0, 0, 255, 0.1)';
        selector.style.border = '1px solid rgba(0, 0, 255, 0.45)';
        selector.style.display = 'none';
        selector.style.pointerEvents = 'none'; // fix for issue #8 (ie11+)
      }

      var _area = this.area === document ? document.body : this.area;

      _area.appendChild(selector);

      return selector;
    } // Start
    //////////////////////////////////////////////////////////////////////////////////////

    /**
     * Starts the functionality. Automatically triggered when created.
     * Also, reset the functionality after a teardown
     */

  }, {
    key: "start",
    value: function start() {
      this._handleSelectables(this._initialSelectables);

      this.area.addEventListener('mousedown', this._startUp);
      this.area.addEventListener('touchstart', this._startUp, {
        passive: false
      });
    }
    /**
     * @param {Object} event - The event object.
     * @private
     */

  }, {
    key: "startUp",

    /**
     * Startup when the area is clicked.
     * @param {Object} event - The event object.
     * @private
     */
    value: function startUp(event) {
      // touchmove handler
      if (event.type === 'touchstart') // Call preventDefault() to prevent double click issue, see https://github.com/ThibaultJanBeyer/DragSelect/pull/29 & https://developer.mozilla.org/vi/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent
        event.preventDefault();
      if (this._isRightClick(event)) return;
      if (this._isScrollbarClick(event, this.area)) return; // callback

      this.onDragStartBegin(event);
      if (this._breaked) return false;
      this.mouseInteraction = true;
      this.selector.style.display = 'block';
      if (this._isMultiSelectKeyPressed(event)) this._prevSelected = this._selected.slice(); // #9
      else this._prevSelected = []; // #9
      // move element on location

      this._getStartingPositions(event);

      this.checkIfInsideSelection(true);
      this.selector.style.display = 'none'; // hidden unless moved, fix for issue #8
      // callback

      this.moveStartCallback(event);
      if (this._breaked) return false; // event listeners

      this.area.removeEventListener('mousedown', this._startUp);
      this.area.removeEventListener('touchstart', this._startUp, {
        passive: false
      });
      this.area.addEventListener('mousemove', this._handleMove);
      this.area.addEventListener('touchmove', this._handleMove, {
        passive: false
      });
      document.addEventListener('mouseup', this._end);
      document.addEventListener('touchend', this._end);
    }
    /**
     * Check if some multiselection modifier key is pressed
     * @param {Object} event - The event object.
     * @return {boolean} this._isMultiSelectKeyPressed
     * @private
     */

  }, {
    key: "_isMultiSelectKeyPressed",
    value: function _isMultiSelectKeyPressed(event) {
      this._multiSelectKeyPressed = false;

      if (this.multiSelectMode) {
        this._multiSelectKeyPressed = true;
      } else {
        for (var index = 0; index < this.multiSelectKeys.length; index++) {
          var mKey = this.multiSelectKeys[index];

          if (event[mKey]) {
            this._multiSelectKeyPressed = true;
          }
        }
      }

      return this._multiSelectKeyPressed;
    }
    /**
     * Grabs the starting position of all needed elements
     * @param {Object} event - The event object.
     * @private
     */

  }, {
    key: "_getStartingPositions",
    value: function _getStartingPositions(event) {
      this._initialCursorPos = this._newCursorPos = this._getCursorPos(event, this.area);
      this._initialScroll = this.getScroll(this.area);
      var selectorPos = {};
      selectorPos.x = this._initialCursorPos.x + this._initialScroll.x;
      selectorPos.y = this._initialCursorPos.y + this._initialScroll.y;
      selectorPos.w = 0;
      selectorPos.h = 0;

      this._updatePos(this.selector, selectorPos);
    } // Movements/Sizing of selection
    //////////////////////////////////////////////////////////////////////////////////////

    /**
     * @param {Object} event - The event object.
     * @private
     */

  }, {
    key: "handleMove",

    /**
     * Handles what happens while the mouse is moved
     * @param {Object} event - The event object.
     * @private
     */
    value: function handleMove(event) {
      var selectorPos = this._getPosition(event); // callback


      this.moveCallback(event);
      if (this._breaked) return false;
      this.selector.style.display = 'block'; // hidden unless moved, fix for issue #8
      // move element on location

      this._updatePos(this.selector, selectorPos);

      this.checkIfInsideSelection(null); // scroll area if area is scrollable

      this._autoScroll(event);
    }
    /**
     * Calculates and returns the exact x,y,w,h positions of the selector element
     * @param {object} [event] - The event object.
     * @returns {{x:number,y:number,w:number,h:number}}
     * @private
     */

  }, {
    key: "_getPosition",
    value: function _getPosition(event) {
      var cursorPosNew = this._getCursorPos(event, this.area);

      var scrollNew = this.getScroll(this.area); // save for later retrieval

      this._newCursorPos = cursorPosNew; // if area or document is scrolled those values have to be included aswell

      var scrollAmount = {
        x: scrollNew.x - this._initialScroll.x,
        y: scrollNew.y - this._initialScroll.y
      };
      /** check for direction
       *
       * This is quite complicated math, so also quite complicated to explain. Lemme’ try:
       *
       * Problem #1:
       * Sadly in HTML we can not have negative sizes.
       * so if we want to scale our element 10px to the right then it is easy,
       * we just have to add +10px to the width. But if we want to scale the element
       * -10px to the left then things become more complicated, we have to move
       * the element -10px to the left on the x axis and also scale the element
       * by +10px width to fake a negative sizing.
       *
       * One solution to this problem is using css-transforms scale() with
       * transform-origin of top left. BUT we can’t use this since it will size
       * everything, then when your element has a border for example, the border will
       * get inanely huge. Also transforms are not widely supported in IE.
       *
       * Example #1:
       * Unfortunately, things get even more complicated when we are inside a scrollable
       * DIV. Then, let’s say we scoll to the right by 10px and move the cursor right by 5px in our
       * checks we have to substract 10px from the initialcursor position in our check
       * (since the inital position is moved to the left by 10px) so in our example:
       * 1. cursorPosNew.x (5) > initialCursorPos.x (0) - scrollAmount.x (10) === 5 > -10 === true
       * then reset the x position to its initial position (since we might have changed that
       * position when scrolling to the left before going right) in our example:
       * 2. selectorPos.x = initialCursorPos.x (0) + initialScroll.x (0) === 0;
       * then we cann calculate the elements width, which is
       * the new cursor position minus the initial one plus the scroll amount, so in our example:
       * 3. selectorPos.w = cursorPosNew.x (5) - initialCursorPos.x (0) + scrollAmount.x (10) === 15;
       *
       * let’s say after that movement we now scroll 20px to the left and move our cursor by 30px to the left:
       * 1b. cursorPosNew.x (-30) > initialCursorPos.x (0) - scrollAmount.x (-20) === -30 > -20 === false;
       * 2b. selectorPos.x = cursorPosNew.x (-30) + scrollNew.x (-20)
       *                   === -50;  // move left position to cursor (for more info see Problem #1)
       * 3b. selectorPos.w = initialCursorPos.x (0) - cursorPosNew.x (-30) - scrollAmount.x (-20)
       *                   === 0--30--20 === 0+30+20 === 50;  // scale width to original left position (for more info see Problem #1)
       *
       * same thing has to be done for top/bottom
       *
       * I hope that makes sence, try stuff out and play around with variables to get a hang of it.
       */

      var selectorPos = {}; // right

      if (cursorPosNew.x > this._initialCursorPos.x - scrollAmount.x) {
        // 1.
        selectorPos.x = this._initialCursorPos.x + this._initialScroll.x; // 2.

        selectorPos.w = cursorPosNew.x - this._initialCursorPos.x + scrollAmount.x; // 3.
        // left
      } else {
        // 1b.
        selectorPos.x = cursorPosNew.x + scrollNew.x; // 2b.

        selectorPos.w = this._initialCursorPos.x - cursorPosNew.x - scrollAmount.x; // 3b.
      } // bottom


      if (cursorPosNew.y > this._initialCursorPos.y - scrollAmount.y) {
        selectorPos.y = this._initialCursorPos.y + this._initialScroll.y;
        selectorPos.h = cursorPosNew.y - this._initialCursorPos.y + scrollAmount.y; // top
      } else {
        selectorPos.y = cursorPosNew.y + scrollNew.y;
        selectorPos.h = this._initialCursorPos.y - cursorPosNew.y - scrollAmount.y;
      }

      return selectorPos;
    } // Colision detection
    //////////////////////////////////////////////////////////////////////////////////////

    /**
     * Checks if any selectable element is inside selection.
     * @param {boolean} [force] forces through. Handles first clicks and accessibility. Here is user is clicking directly onto some element at start, (contrary to later hovers) we can assume that he really wants to select/deselect that item.
     * @return {boolean}
     */

  }, {
    key: "checkIfInsideSelection",
    value: function checkIfInsideSelection(force) {
      var anyInside = false;

      for (var i = 0, il = this.selectables.length; i < il; i++) {
        var selectable = this.selectables[i];
        var scroll = this.getScroll(this.area);
        var selectionRect = {
          y: this.selector.getBoundingClientRect().top / this.zoom + scroll.y,
          x: this.selector.getBoundingClientRect().left / this.zoom + scroll.x,
          h: this.selector.offsetHeight,
          w: this.selector.offsetWidth
        };

        if (this._isElementTouching(selectable, selectionRect, scroll)) {
          this._handleSelection(selectable, force);

          anyInside = true;
        } else {
          this._handleUnselection(selectable, force);
        }
      }

      return anyInside;
    }
    /**
     * Logic when an item is selected
     * @param {(HTMLElement|SVGElement)} item selected item.
     * @param {boolean} [force] forces through.
     * @private
     */

  }, {
    key: "_handleSelection",
    value: function _handleSelection(item, force) {
      if (item.classList.contains(this.hoverClass) && !force) {
        return false;
      }

      var posInSelectedArray = this._selected.indexOf(item);

      if (posInSelectedArray < 0) {
        this.select(item);
      } else if (posInSelectedArray > -1 && this._multiSelectKeyPressed) {
        this.unselect(item);
      }

      item.classList.add(this.hoverClass);
    }
    /**
     * Logic when an item is de-selected
     * @param {(HTMLElement|SVGElement)} item selected item.
     * @param {boolean} [force] forces through.
     * @private
     */

  }, {
    key: "_handleUnselection",
    value: function _handleUnselection(item, force) {
      if (!item.classList.contains(this.hoverClass) && !force) {
        return false;
      }

      var posInSelectedArray = this._selected.indexOf(item);

      var isInPrevSelection = this._prevSelected.indexOf(item); // #9

      /**
       * Special algorithm for issue #9.
       * if a multiselectkey is pressed, ds 'remembers' the last selection and reverts
       * to that state if the selection is not kept, to mimic the natural OS behaviour
       * = if item was selected and is not in selection anymore, reselect it
       * = if item was not selected and is not in selection anymore, unselect it
       */


      if (posInSelectedArray > -1 && isInPrevSelection < 0) {
        this.unselect(item);
      } else if (posInSelectedArray < 0 && isInPrevSelection > -1) {
        this.select(item);
      }

      item.classList.remove(this.hoverClass);
    }
    /**
     * Adds an item to the selection.
     * @param {(HTMLElement|SVGElement)} item selected item.
     * @return {(HTMLElement|SVGElement|false)} item
     */

  }, {
    key: "select",
    value: function select(item) {
      if (this._selected.indexOf(item) > -1) return false;

      this._selected.push(item);

      item.classList.add(this.selectedClass);
      this.selectCallback(item);
      if (this._breaked) return false;
      return item;
    }
    /**
     * Removes an item from the selection.
     * @param {(HTMLElement|SVGElement)} item selected item.
     * @return {(HTMLElement|SVGElement|false)} item
     */

  }, {
    key: "unselect",
    value: function unselect(item) {
      if (this._selected.indexOf(item) < 0) return false;

      this._selected.splice(this._selected.indexOf(item), 1);

      item.classList.remove(this.selectedClass);
      this.unselectCallback(item);
      if (this._breaked) return false;
      return item;
    }
    /**
     * Adds/Removes an item to the selection.
     * If it is already selected = remove, if not = add.
     * @param {(HTMLElement|SVGElement)} item – item to select.
     * @return {(HTMLElement|SVGElement)} item
     */

  }, {
    key: "toggle",
    value: function toggle(item) {
      if (this._selected.indexOf(item) > -1) {
        this.unselect(item);
      } else {
        this.select(item);
      }

      return item;
    }
    /**
     * Checks if element is touched by the selector (and vice-versa)
     * @param {(HTMLElement|SVGElement)} element – item.
     * @param {Object} selectionRect – Container bounds:
       Example: {
        y: this.selector.getBoundingClientRect().top + scroll.y,
        x: this.selector.getBoundingClientRect().left + scroll.x,
        h: this.selector.offsetHeight,
        w: this.selector.offsetWidth
      };
     * @param {Object} scroll – Scroll x, y values.
     * @return {boolean}
     * @private
     */

  }, {
    key: "_isElementTouching",
    value: function _isElementTouching(element, selectionRect, scroll) {
      var rect = element.getBoundingClientRect();
      var elementRect = {
        y: rect.top / this.zoom + scroll.y,
        x: rect.left / this.zoom + scroll.x,
        h: rect.height / this.zoom,
        w: rect.width / this.zoom
      }; // Axis-Aligned Bounding Box Colision Detection.
      // Imagine following Example:
      //    b01
      // a01[1]a02
      //    b02      b11
      //          a11[2]a12
      //             b12
      // to check if those two boxes collide we do this AABB calculation:
      //& a01 < a12 (left border pos box1 smaller than right border pos box2)
      //& a02 > a11 (right border pos box1 larger than left border pos box2)
      //& b01 < b12 (top border pos box1 smaller than bottom border pos box2)
      //& b02 > b11 (bottom border pos box1 larger than top border pos box2)
      // See: https://en.wikipedia.org/wiki/Minimum_bounding_box#Axis-aligned_minimum_bounding_box and https://developer.mozilla.org/en-US/docs/Games/Techniques/2D_collision_detection

      if (selectionRect.x < elementRect.x + elementRect.w && selectionRect.x + selectionRect.w > elementRect.x && selectionRect.y < elementRect.y + elementRect.h && selectionRect.h + selectionRect.y > elementRect.y) {
        return true; // collision detected!
      } else {
        return false;
      }
    } // Autoscroll
    //////////////////////////////////////////////////////////////////////////////////////

    /**
     * Automatically Scroll the area by selecting
     * @param {Object} event – event object.
     * @private
     */

  }, {
    key: "_autoScroll",
    value: function _autoScroll(event) {
      var edge = this.isCursorNearEdge(event, this.area);
      var docEl = document && document.documentElement && document.documentElement.scrollTop && document.documentElement;

      var _area = this.area === document ? docEl || document.body : this.area;

      if (edge === 'top' && _area.scrollTop > 0) {
        _area.scrollTop -= 1 * this.autoScrollSpeed;
      } else if (edge === 'bottom') {
        _area.scrollTop += 1 * this.autoScrollSpeed;
      } else if (edge === 'left' && _area.scrollLeft > 0) {
        _area.scrollLeft -= 1 * this.autoScrollSpeed;
      } else if (edge === 'right') {
        _area.scrollLeft += 1 * this.autoScrollSpeed;
      }
    }
    /**
     * Check if the selector is near an edge of the area
     * @param {Object} [event] event object.
     * @param {(HTMLElement|SVGElement)} area the area.
     * @return {('top'|'bottom'|'left'|'right'|false)}
     */

  }, {
    key: "isCursorNearEdge",
    value: function isCursorNearEdge(event, area) {
      var cursorPosition = this._getCursorPos(event, area);

      var areaRect = this.getAreaRect(area);
      var tolerance = {
        x: Math.max(areaRect.width / 10, 30),
        y: Math.max(areaRect.height / 10, 30)
      };

      if (cursorPosition.y < tolerance.y) {
        return 'top';
      } else if (areaRect.height - cursorPosition.y < tolerance.y) {
        return 'bottom';
      } else if (areaRect.width - cursorPosition.x < tolerance.x) {
        return 'right';
      } else if (cursorPosition.x < tolerance.x) {
        return 'left';
      }

      return false;
    } // Ending
    //////////////////////////////////////////////////////////////////////////////////////

    /**
     * Triggered on mouse click release (end of dragging a selection).
     * Calls the callback method & unbind functions.
     * @param {Object} event - The event object.
     * @private
     */

  }, {
    key: "reset",

    /**
     * Unbind functions i.e. when mouse click is released
     * @param {Object} [event] - The event object.
     * @param {boolean} [withCallback] - whether or not the callback should be called
     */
    value: function reset(event, withCallback) {
      var _this2 = this;

      this._previousCursorPos = this._getCursorPos(event, this.area);
      document.removeEventListener('mouseup', this._end);
      document.removeEventListener('touchend', this._end);
      this.area.removeEventListener('mousemove', this._handleMove);
      this.area.removeEventListener('touchmove', this._handleMove, {
        passive: false
      });
      this.area.addEventListener('mousedown', this._startUp);
      this.area.addEventListener('touchstart', this._startUp, {
        passive: false
      });
      if (withCallback) this.callback(this.getSelection(), event);
      if (this._breaked) return false;
      this.selector.style.width = '0';
      this.selector.style.height = '0';
      this.selector.style.display = 'none';
      setTimeout(function () {
        return (// debounce in order "onClick" to work
          _this2.mouseInteraction = false
        );
      }, 100);
    }
    /**
     * Function break: used in callbacks to disable the execution of the upcoming code at the specific moment
     * In contrary to stop():
     * - Event listeners, callback calls and calculation will continue working
     * - Selector won’t display and will not select
     */

  }, {
    key: "break",
    value: function _break() {
      var _this3 = this;

      this._breaked = true;
      setTimeout( // debounce the break should only break once instantly after call
      function () {
        return _this3._breaked = false;
      }, 100);
    }
    /**
     * Complete function teardown
     * Will teardown/stop the whole functionality
     * @param {boolean} [remove=true] - if elements should be removed.
     * @param {boolean} [fromSelection=true] - if elements should also be added/removed to the selection.
     * @param {boolean} [withCallback] - if elements should also be added/removed to the selection.
     */

  }, {
    key: "stop",
    value: function stop() {
      var remove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var fromSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var withCallback = arguments.length > 2 ? arguments[2] : undefined;
      this.reset(false, withCallback);
      this.area.removeEventListener('mousedown', this._startUp);
      this.area.removeEventListener('touchstart', this._startUp, {
        passive: false
      });
      document.removeEventListener('mouseup', this._end);
      document.removeEventListener('touchend', this._end);

      this._handleSelectables(_toConsumableArray(this.selectables), remove, fromSelection);
    } // Usefull methods for user
    //////////////////////////////////////////////////////////////////////////////////////

    /**
     * Returns the current selected nodes
     * @return {Array.<(HTMLElement|SVGElement)>}
     */

  }, {
    key: "getSelection",
    value: function getSelection() {
      return _toConsumableArray(this._selected);
    }
    /**
     * Returns cursor x, y position based on event object
     * Will be relative to an area including the scroll unless advised otherwise
     * @param {Object} [event]
     * @param {(HTMLElement|SVGElement|false)} [_area] containing area / this.area if === undefined / document if === false
     * @param {boolean} [ignoreScroll] if true, the scroll will be ignored
     * @return {{x:number,y:number}} cursor { x/y }
     */

  }, {
    key: "getCursorPos",
    value: function getCursorPos(event, _area, ignoreScroll) {
      if (!event) return {
        x: 0,
        y: 0
      };
      var area = _area || _area !== false && this.area;

      var pos = this._getCursorPos(event, area);

      var scroll = ignoreScroll ? {
        x: 0,
        y: 0
      } : this.getScroll(area);
      return {
        x: pos.x + scroll.x,
        y: pos.y + scroll.y
      };
    }
    /**
     * Adds several items to the selection list
     * also adds the specific classes and take into account all calculations.
     * Does not clear the selection, in contrary to .setSelection
     * Can add multiple nodes at once, in contrary to .select
     * @param {Array.<(HTMLElement|SVGElement)>} _nodes one or multiple nodes
     * @param {boolean} [triggerCallback] - if callback should be called
     * @param {boolean} [dontAddToSelectables] - if element should not be added to the list of selectable nodes
     * @return {Array.<(HTMLElement|SVGElement)>} all selected nodes
     */

  }, {
    key: "addSelection",
    value: function addSelection(_nodes, triggerCallback, dontAddToSelectables) {
      var nodes = this._toArray(_nodes);

      for (var index = 0, il = nodes.length; index < il; index++) {
        var node = nodes[index];
        this.select(node);
      }

      if (!dontAddToSelectables) {
        this.addSelectables(nodes);
      }

      if (triggerCallback) {
        this.callback(this._selected, false);
      }

      return this._selected;
    }
    /**
     * Removes specific nodes from the selection
     * Multiple nodes can be given at once, in contrary to unselect
     * @param {Array.<(HTMLElement|SVGElement)>} _nodes one or multiple nodes
     * @param {boolean} [triggerCallback] - if callback should be called
     * @param {boolean} [removeFromSelectables] - if element should be removed from the list of selectable nodes
     * @return {Array} all selected nodes
     */

  }, {
    key: "removeSelection",
    value: function removeSelection(_nodes, triggerCallback, removeFromSelectables) {
      var nodes = this._toArray(_nodes);

      for (var index = 0, il = nodes.length; index < il; index++) {
        var node = nodes[index];
        this.unselect(node);
      }

      if (removeFromSelectables) {
        this.removeSelectables(nodes);
      }

      if (triggerCallback) {
        this.callback(this._selected, false);
      }

      return this._selected;
    }
    /**
     * Toggles specific nodes from the selection:
     * If element is not in selection it will be added, if it is already selected, it will be removed.
     * Multiple nodes can be given at once.
     * @param {Array.<(HTMLElement|SVGElement)>} _nodes one or multiple nodes
     * @param {boolean} [triggerCallback] - if callback should be called
     * @param {boolean} [special] - if true, it also removes selected elements from possible selectable nodes & don’t add them to selectables if they are not
     * @return {Array} all selected nodes
     */

  }, {
    key: "toggleSelection",
    value: function toggleSelection(_nodes, triggerCallback, special) {
      var nodes = this._toArray(_nodes);

      for (var index = 0, il = nodes.length; index < il; index++) {
        var node = nodes[index];

        if (this._selected.indexOf(node) < 0) {
          this.addSelection(node, triggerCallback, special);
        } else {
          this.removeSelection(node, triggerCallback, special);
        }
      }

      return this._selected;
    }
    /**
     * Sets the current selected nodes and optionally run the callback
     * By default, adds new elements also to the list of selectables
     * @param {Array.<(HTMLElement|SVGElement)>} _nodes – dom nodes
     * @param {boolean} [triggerCallback] - if callback should be called
     * @param {boolean} [dontAddToSelectables] - if element should not be added to the list of selectable nodes
     * @return {Array.<(HTMLElement|SVGElement)>}
     */

  }, {
    key: "setSelection",
    value: function setSelection(_nodes, triggerCallback, dontAddToSelectables) {
      this.clearSelection();
      this.addSelection(_nodes, triggerCallback, dontAddToSelectables);
      return this._selected;
    }
    /**
     * Unselect / Deselect all current selected Nodes
     * @param {boolean} [triggerCallback] - if callback should be called
     * @return {Array.<(HTMLElement|SVGElement)>} this.selected, should be empty
     */

  }, {
    key: "clearSelection",
    value: function clearSelection(triggerCallback) {
      var selection = this._selected.slice();

      for (var index = 0, il = selection.length; index < il; index++) {
        var node = selection[index];
        this.unselect(node);
      }

      if (triggerCallback) {
        this.callback(this._selected, false);
      }

      return this._selected;
    }
    /**
     * Add nodes that can be selected.
     * The algorithm makes sure that no node is added twice
     * @param {Array.<(HTMLElement|SVGElement)>} _nodes dom nodes
     * @param {boolean} [addToSelection] if elements should also be added to current selection
     * @return {Array.<(HTMLElement|SVGElement)>} _nodes the added node(s)
     */

  }, {
    key: "addSelectables",
    value: function addSelectables(_nodes, addToSelection) {
      var nodes = this._toArray(_nodes);

      this._handleSelectables(nodes, false, addToSelection);

      return _nodes;
    }
    /**
     * Gets all nodes that can be selected
     * @return {Array.<(HTMLElement|SVGElement)>} this.selectables
     */

  }, {
    key: "getSelectables",
    value: function getSelectables() {
      return this.selectables;
    }
    /**
     * Sets all elements that can be selected.
     * Removes all current selectables (& their respective classes).
     * Adds the new set to the selectables set, thus replacing the original set.
     * @param {Array.<(HTMLElement|SVGElement)>} nodes – dom nodes
     * @param {boolean} [removeFromSelection] if elements should also be removed from current selection
     * @param {boolean} [addToSelection] if elements should also be added to current selection
     * @return {Array.<(HTMLElement|SVGElement)>} nodes – the added node(s)
     */

  }, {
    key: "setSelectables",
    value: function setSelectables(nodes, removeFromSelection, addToSelection) {
      this.removeSelectables(this.getSelectables(), removeFromSelection);
      return this.addSelectables(nodes, addToSelection);
    }
    /**
     * Remove nodes from the nodes that can be selected.
     * @param {Array.<(HTMLElement|SVGElement)>} _nodes – dom nodes
     * @param {boolean} [removeFromSelection] if elements should also be removed from current selection
     * @return {Array.<(HTMLElement|SVGElement)>} _nodes – the removed node(s)
     */

  }, {
    key: "removeSelectables",
    value: function removeSelectables(_nodes, removeFromSelection) {
      var nodes = this._toArray(_nodes);

      this._handleSelectables(nodes, true, removeFromSelection);

      return _nodes;
    } // Helpers
    //////////////////////////////////////////////////////////////////////////////////////

    /**
     * Based on a click event object,
     * checks if the right mouse button was pressed.
     * (found @ https://stackoverflow.com/a/2405835)
     * @param {object} event
     * @return {boolean}
     * @private
     */

  }, {
    key: "_isRightClick",
    value: function _isRightClick(event) {
      var isRightMB = false;

      if ('which' in event) {
        // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
        isRightMB = event.which === 3;
      } else if ('button' in event) {
        // IE, Opera
        isRightMB = event.button === 2;
      }

      return isRightMB;
    }
    /**
     * Based on a click event object in an area,
     * checks if the click was triggered onto a scrollbar.
     * @param {object} event – the event object
     * @param {(HTMLElement|SVGElement|any)} area – containing area / document if none
     * @return {boolean}
     * @private
     */

  }, {
    key: "_isScrollbarClick",
    value: function _isScrollbarClick(event, area) {
      var cPos = this._getCursorPos(event, area);

      var areaRect = this.getAreaRect(area);
      var border = area.computedBorder || 0;
      if (areaRect.width + border <= cPos.x) return true;
      if (areaRect.height + border <= cPos.y) return true;
      return false;
    }
    /**
     * Transforms a nodelist or single node to an array
     * so user doesn’t have to care.
     * @param {any} nodes
     * @return {array}
     * @private
     */

  }, {
    key: "_toArray",
    value: function _toArray(nodes) {
      if (!nodes) return [];
      if (!nodes.length && this._isElement(nodes)) return [nodes];
      var array = [];

      for (var i = nodes.length - 1; i >= 0; i--) {
        array[i] = nodes[i];
      }

      return array;
    }
    /**
     * Checks if a node is of type element
     * all credits to vikynandha: https://gist.github.com/vikynandha/6539809
     * @param {HTMLElement|SVGElement} node
     * @return {boolean}
     * @private
     */

  }, {
    key: "_isElement",
    value: function _isElement(node) {
      try {
        // Using W3 DOM2 (works for FF, Opera and Chrome), also checking for SVGs
        return node instanceof HTMLElement || node instanceof SVGElement;
      } catch (e) {
        // Browsers not supporting W3 DOM2 don't have HTMLElement and
        // an exception is thrown and we end up here. Testing some
        // properties that all elements have. (works even on IE7)
        return _typeof(node) === 'object' && node.nodeType === 1 && _typeof(node.style) === 'object' && _typeof(node.ownerDocument) === 'object';
      }
    }
    /**
     * Returns cursor x, y position based on event object
     * /!\ for internal calculation reasons it does _not_ take
     * the AREA scroll into consideration unless it’s the outer Document.
     * Use the public .getCursorPos() from outside, it’s more flexible
     * @param {Object} [event]
     * @param {(HTMLElement|SVGElement)} area – containing area / document if none
     * @return {{x: number, y: number}} cursor X/Y
     * @private
     */

  }, {
    key: "_getCursorPos",
    value: function _getCursorPos(event, area) {
      if (!event) return {
        x: 0,
        y: 0
      }; // touchend has not touches. so we take the last toucb if a touchevent, we need to store the positions on the prototype

      if (event.touches && event.type !== 'touchend') {
        this._lastTouch = event;
      } //if a touchevent, return the last touch rather than the regular event
      // we need .touches[0] from that event instead


      event = event.touches ? this._lastTouch.touches[0] : event;
      var cPos = {
        // event.clientX/Y fallback for <IE8
        x: event.pageX || event.clientX,
        y: event.pageY || event.clientY
      };
      var areaRect = this.getAreaRect(area || document);
      var docScroll = this.getScroll(); // needed when document is scrollable but area is not

      return {
        // if it’s constrained in an area the area should be substracted calculate
        x: (cPos.x - areaRect.left - docScroll.x) / this.zoom,
        y: (cPos.y - areaRect.top - docScroll.y) / this.zoom
      };
    }
    /**
     * Returns the starting/initial position of the cursor/selector
     * @return {{x:number,y:number}}
     */

  }, {
    key: "getInitialCursorPosition",
    value: function getInitialCursorPosition() {
      return this._initialCursorPos;
    }
    /**
     * Returns the last seen position of the cursor/selector
     * @return {{x:number,y:number}}
     */

  }, {
    key: "getCurrentCursorPosition",
    value: function getCurrentCursorPosition() {
      return this._newCursorPos;
    }
    /**
     * Returns the previous position of the cursor/selector
     * @return {{x:number,y:number}}
     */

  }, {
    key: "getPreviousCursorPosition",
    value: function getPreviousCursorPosition() {
      return this._previousCursorPos;
    }
    /**
     * Returns the cursor position difference between start and now
     * If usePreviousCursorDifference is passed,
     * it will output the cursor position difference between the previous selection and now
     * @param {boolean} [usePreviousCursorDifference]
     * @return {{x:number,y:number}}
     */

  }, {
    key: "getCursorPositionDifference",
    value: function getCursorPositionDifference(usePreviousCursorDifference) {
      var posA = this.getCurrentCursorPosition();
      var posB = usePreviousCursorDifference ? this.getPreviousCursorPosition() : this.getInitialCursorPosition();
      return {
        x: posA.x - posB.x,
        y: posA.y - posB.y
      };
    }
    /**
     * Returns the current x, y scroll value of a container
     * If container has no scroll it will return 0
     * @param {(HTMLElement|SVGElement)} [area]
     * @return {{x:number,y:number}} scroll X/Y
     */

  }, {
    key: "getScroll",
    value: function getScroll(area) {
      var body = {
        top: document.body.scrollTop > 0 ? document.body.scrollTop : document.documentElement.scrollTop,
        left: document.body.scrollLeft > 0 ? document.body.scrollLeft : document.documentElement.scrollLeft
      };
      var scroll = {
        // when the rectangle is bound to the document, no scroll is needed
        y: area && area.scrollTop >= 0 ? area.scrollTop : body.top,
        x: area && area.scrollLeft >= 0 ? area.scrollLeft : body.left
      };
      return scroll;
    }
    /**
     * Returns the top/left/bottom/right/width/height
     * values of a node. If Area is document then everything
     * except the sizes will be nulled.
     * @param {(HTMLElement|SVGElement|any)} area
     * @return {{top:number,left:number,bottom:number,right:number,width:number,height:number}}
     */

  }, {
    key: "getAreaRect",
    value: function getAreaRect(area) {
      if (area === document) {
        var size = {
          y: area.documentElement.clientHeight > 0 ? area.documentElement.clientHeight : window.innerHeight,
          x: area.documentElement.clientWidth > 0 ? area.documentElement.clientWidth : window.innerWidth
        };
        return {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          width: size.x,
          height: size.y
        };
      }

      var rect = area.getBoundingClientRect();
      return {
        top: rect.top,
        left: rect.left,
        bottom: rect.bottom,
        right: rect.right,
        width: area.clientWidth || rect.width,
        height: area.clientHeight || rect.height
      };
    }
    /**
     * Updates the node style left, top, width,
     * height values accordingly.
     * @param {(HTMLElement|SVGElement)} node
     * @param {Object} pos { x, y, w, h }
     * @return {(HTMLElement|SVGElement)}
     * @private
     */

  }, {
    key: "_updatePos",
    value: function _updatePos(node, pos) {
      node.style.left = pos.x + 'px';
      node.style.top = pos.y + 'px';
      node.style.width = pos.w + 'px';
      node.style.height = pos.h + 'px';
      return node;
    }
  }]);

  return DragSelect;
}(); // Make exportable
//////////////////////////////////////////////////////////////////////////////////////

/* eslint-disable no-undef */
// Module exporting


if (typeof module !== 'undefined' && module !== null) {
  module.exports = DragSelect; // AMD Modules
} else if ( // @ts-ignore
"function" !== 'undefined' && // @ts-ignore
"function" === 'function' && // @ts-ignore
__webpack_require__(1199)) {
  // @ts-ignore
  !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return DragSelect;
  }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {
  // @ts-ignore
  window.DragSelect = DragSelect;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146)(module)))

/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        _ = __webpack_require__(1);

    /**
     * Calculates the changing parts of the css for a backdrop viewer. Takes the backdrop model the
     * experience size and returns a promise that resolves to the new css.
     *
     * @param {BackdropModel} backdrop             The backdrop model.
     * @param {width: Number, height: Number} size The experience size as {width, height}.
     * @return {Object}                            Object with new css properties
     *
     */
    function calculateCss(backdrop, size) {
        var css = _.extend({
            backgroundColor: "",
            backgroundImage: "",
            margin: 0,
            outline: ""
        }, size);

        if (backdrop.isFitContainer()) {
            css.width += 20;
            css.height += 20;
            css.margin = -10;
            css.outline = "1px dashed #c6c6c6";
        }

        if (backdrop.isTypeImage()) {
            css.backgroundImage = "url(" + (backdrop.getImageURL() || "") + ")";
        } else {
            css.backgroundColor = backdrop.getColor();
        }

        return css;
    }

    /**
     * A Backdrop viewer.
     *
     * @class BackdropViewer
     * @constructor
     *
     * @cfg {Backdrop} model The backdrop model to display in the region.
     * @cfg {ExperienceModel} experience The Experience model.
     */
    return ImprovedView.extend({
        // No need for a template
        template: function template() {
            return "";
        },

        className: "backdrop-viewer",

        modelEvents: {
            "change": "_updateBackdrop"
        },

        onShow: function onShow() {
            this._updateBackdrop();
        },

        _updateBackdrop: function _updateBackdrop() {
            this.$el.css(calculateCss(this.model, this.options.experience.pick("width", "height")));
        }
    }, {
        // Exposed for testing purposes
        calculateCss: calculateCss
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var EditorEvents = __webpack_require__(17);
    var WidgetTypes = __webpack_require__(69);
    var Promise = __webpack_require__(21);
    var ImageModel = __webpack_require__(258);
    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);
    var GeneralFunctions = __webpack_require__(193);
    var ImageDropManager = __webpack_require__(859);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var MathUtil = __webpack_require__(72).default;

    var ADD_UPLOAD_BARS = "add:upload:bars";

    var WIDGET_OPTIONS = {
        "previous-scene": {
            width: 50,
            height: 50
        },
        "next-scene": {
            width: 50,
            height: 50
        },
        "text": {
            width: 250,
            disableCentering: true
        },
        "text-enhanced": {
            width: 250,
            disableCentering: true
        },
        "youtube": {
            width: 240,
            height: 135
        },
        "line": {
            height: 25
        },
        "link": {
            width: 128,
            height: 128
        },
        "html": {
            width: 128,
            height: 128
        },
        "shape": {
            width: 128,
            height: 128
        },
        "embed": {
            width: 128,
            height: 128
        },
        "dynamic-product": {
            width: 100,
            height: 100
        }
    };

    var logger = new Logger("SceneDropHandler");

    /**
     * Given a drop event, computes the offset coordinates for it.
     *
     * @param {Number} pageX - Position of the mouse pointer, relative to the left edge of the document
     * @param {Number} pageY - Position of the mouse pointer, relative to the top edge of the document.
     * @param {Object} offset - Scene Editor offset.
     * @param {Number} scale - Scene Editor scale factor.
     * @returns {Object} Coordinates, as an object with x and y properties.
     * @private
     */
    var getOffsetCoordinates = function getOffsetCoordinates(pageX, pageY, offset, scale) {
        return {
            x: (pageX - offset.left) / scale,
            y: (pageY - offset.top) / scale
        };
    };

    /**
     * Takes a widget type and some options and creates a new widget.
     *
     * @param {Object} experienceSize   The experience size.
     * @param {Object} widgetDescriptor The widget descriptor.
     * @param {Object} options          Set of options.
     * @return {AbstractWidgetModel}    The created Widget.
     * @private
     */
    var createWidget = GeneralFunctions.curry(function (experienceSize, widgetDescriptor, options) {
        var widget = new widgetDescriptor.modelClass(options);

        if (_.isFunction(widgetDescriptor.initializer)) {
            widgetDescriptor.initializer(widget, experienceSize);
        }

        return widget;
    });

    /**
     * Creates a function that takes a minimal options and extends it with a
     * position and updates its width and height if they exist.
     *
     * @param {Number} experienceSize
     * @param {Object} point
     * @return {Function}
     * @private
     */
    var makeExtendOptions = function makeExtendOptions(experienceSize, point) {
        return function (opt) {
            var options = _.clone(opt);
            // Round dimensions and positioning to contain exactly required for
            // experience size values accuracy. Uses here for the dropeed widgets
            options.left = MathUtil.roundToContain(point.x / experienceSize.width * 100, experienceSize.width);
            options.top = MathUtil.roundToContain(point.y / experienceSize.height * 100, experienceSize.height);

            // convert width and height to percentage
            if (options.width) {
                options.width = MathUtil.roundToContain(options.width / experienceSize.width * 100, experienceSize.width);
                if (!opt.disableCentering && !opt.imageId) {
                    options.left += options.width / 2;
                }
            }

            if (options.height) {
                options.height = MathUtil.roundToContain(options.height / experienceSize.height * 100, experienceSize.height);
                if (!opt.disableCentering && !opt.imageId) {
                    options.top += options.height / 2;
                }
            }
            return options;
        };
    };

    /**
     * Creates an options object based on a imageModel
     *
     * @param {Object} imageModel
     * @return {Object}
     * @private
     */
    var createImageOptions = function createImageOptions(imageModel) {
        var options = {
            altText: imageModel.get("altText"),
            imageId: imageModel.get("id"),
            height: imageModel.get("height"),
            width: imageModel.get("width"),
            originalImageHeight: imageModel.get("height"),
            originalImageWidth: imageModel.get("width"),
            src: imageModel.get("url"),
            supportsResize: imageModel.get("supportsResize")
        };

        if (imageModel.get("sourceType")) {
            options.sourceType = imageModel.get("sourceType");
        }

        return options;
    };

    /**
     * Takes an array of uploading ImageModels, and returns a promise that
     * resolves once all imageModels have finished.
     *
     * @param {Array} imageModels  - Array of <tt>ImageModel</tt>'s
     * @return {Promise}        - Promise that resolves with uploaded
     *                            ImageModels (failed uploads are
     *                            rejected)
     */
    var allImagesUploaded = function allImagesUploaded(imageModels) {
        var numOfFinishedUploads = 0;

        var numOfImageModels = imageModels.length;
        var deferred = $.Deferred();

        var increaseNumberOfUploads = function increaseNumberOfUploads() {
            var uploadedModels = void 0;

            numOfFinishedUploads++;

            if (numOfFinishedUploads >= numOfImageModels) {
                uploadedModels = _.reject(imageModels, function (model) {
                    return model.get("uploadFailed");
                });

                deferred.resolve(uploadedModels);
            }
        };

        _.each(imageModels, function (imageModel) {
            imageModel.once("change:uploading change:uploadfailed", increaseNumberOfUploads);
        });

        return deferred.promise();
    };

    var getWidgetDescriptor = function getWidgetDescriptor(dataTransfer) {
        try {
            var data = JSON.parse(dataTransfer.getData("Text"));

            return {
                data: data,
                descriptor: WidgetTypes.lookup(data.type, true) // true = silent -> "descriptor" can be falsey.
            };
        } catch (e) {
            // only on parse errors
            return {};
        }
    };

    return Marionette.Controller.extend({

        _sceneEditor: null,

        _loadingRegion: null,

        _sceneLoadingScreen: null,

        /**
         * Constructor.
         *
         * @param  {Object} sceneEditor - The current <tt>SceneEditor</tt> instance.
         */
        initialize: function initialize(sceneEditor) {
            this._sceneEditor = sceneEditor;
            this._loadingRegion = sceneEditor.loadingRegion;
        },


        // TODO: We need a factory for this.

        /**
         * Handles the drop event for scenes
         *
         * @param {event} event The jQuery drop event.
         * @return {Promise}
         */
        handle: function handle(event) {
            event.preventDefault();

            var originalEvent = event.originalEvent;
            var dataTransfer = originalEvent.dataTransfer;
            var widgetDescriptor = getWidgetDescriptor(dataTransfer); // {descriptor: WidgetType, options: *}
            var offset = this._sceneEditor.$el.find(".widgets-boundary").offset();
            var viewModel = this._sceneEditor.viewScope.viewModel;
            var scale = viewModel.get("zoomModel").get("scale");
            var sceneSize = this._sceneEditor.getSceneSize();
            var point = getOffsetCoordinates(originalEvent.pageX, originalEvent.pageY, offset, scale);
            var extendOptions = makeExtendOptions(sceneSize, point);

            // Dropping images from the desktop is a special case where we return
            // early with an upload descriptor containing a promise of images uploading.
            var imageModels = ImageDropManager.upload(dataTransfer).models;

            // If images were dragged frm desktop to the scene, we will create images models.
            if (imageModels.length > 0) {
                // + imageModel -> Widget
                var createWidgetFromModel = _.compose(createWidget(sceneSize, WidgetTypes.IMAGE), extendOptions, createImageOptions);

                // Trigger that uploading has started, so the SceneEditor can add some uploading bars.
                if (imageModels.length > 0) {
                    this.trigger(ADD_UPLOAD_BARS, imageModels);
                    this._trackEditorEvent(imageModels);
                }

                return allImagesUploaded(imageModels).then(GeneralFunctions.map(createWidgetFromModel));
            }

            // Sanity check, bail out if we get an invalid widget type.
            if (!widgetDescriptor.descriptor) {
                logger.warn("Invalid widget type: " + dataTransfer.getData("Text"));

                return Promise.rejected("Not a widget/image");
            }

            // The next few if statements are for widget types that needs special options at
            // creation time.

            // -> Image is dropped from Library
            var options = {};

            if (WidgetTypes.IMAGE.is(widgetDescriptor.descriptor) && widgetDescriptor.data.options && !!widgetDescriptor.data.options.imageID) {
                if ((0, _C3Utils.isC3Experience)()) {
                    options = {
                        altText: widgetDescriptor.data.options.altText,
                        imageId: widgetDescriptor.data.options.imageID,
                        height: widgetDescriptor.data.options.height,
                        width: widgetDescriptor.data.options.width,
                        originalImageHeight: widgetDescriptor.data.options.height,
                        originalImageWidth: widgetDescriptor.data.options.width,
                        src: widgetDescriptor.data.options.src
                    };
                    var _widget = createWidget(sceneSize, widgetDescriptor.descriptor, extendOptions(options));
                    return Promise.resolved([_widget]);
                } else {
                    return ImageModel.findByIdFromSource(widgetDescriptor.data.options.imageID, widgetDescriptor.data.options.sourceType).then(function (imageModel) {
                        options = createImageOptions(imageModel);
                        var widget = createWidget(sceneSize, widgetDescriptor.descriptor, extendOptions(options));
                        return [widget];
                    });
                }
            }
            _.extend(options, WIDGET_OPTIONS[widgetDescriptor.descriptor.id], widgetDescriptor.data.options);

            // Project widgets have a default action ID and a placeholder icon.
            if (widgetDescriptor.data.defaultActionId) {
                options.defaultActionId = widgetDescriptor.data.defaultActionId;
                options.icon = widgetDescriptor.data.icon;
            }

            var widget = createWidget(sceneSize, widgetDescriptor.descriptor, extendOptions(options));

            return Promise.resolved([widget]);
        },


        /**
         * Handles the mouseDown event when the cursor contains a widget. This allows for the creation of widgets via clicking the widget icon before clicking inside the canvas.
         *
         * @param {event} event The jQuery mouseDown event.
         * @return {Promise}
         */
        handleWidgetDropFromMouseDown: function handleWidgetDropFromMouseDown(event, widgetType) {
            var originalEvent = event.originalEvent;
            var descriptor = WidgetTypes.lookup(widgetType);
            if (!descriptor) {
                logger.warn("Invalid widget type: " + widgetType);
                return Promise.rejected("Not a widget/image");
            }

            var viewModel = this._sceneEditor.viewScope.viewModel;
            var offset = this._sceneEditor.$el.find(".widgets-boundary").offset();
            var scale = viewModel.get("zoomModel").get("scale");
            var sceneSize = this._sceneEditor.getSceneSize();
            var point = getOffsetCoordinates(originalEvent.pageX, originalEvent.pageY, offset, scale);
            var extendOptions = makeExtendOptions(sceneSize, point);
            var widgetOptions = WIDGET_OPTIONS[widgetType] || {};

            var widget = createWidget(this._sceneEditor.getSceneSize(), descriptor, extendOptions(widgetOptions));
            return Promise.resolved([widget]);
        },
        _trackEditorEvent: function _trackEditorEvent(imageModels) {
            var experience = this.options.experienceModel;

            if (experience) {
                var project = this.options.project;

                var imageNames = imageModels.map(function (image) {
                    return image.get("name");
                });

                var eventProperties = {
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion"),
                    location: "edit",
                    numberOfUploadedImages: imageModels.length,
                    imageNames: imageNames.join(),
                    projectId: project && project.get("id"),
                    triggerOrigin: "ExperienceSceneEditorDrop"
                };

                EditorEvents.trigger(EditorEvents.constants.UPLOAD_IMAGE, eventProperties);
            }
        }
    }, {
        ADD_UPLOAD_BARS: ADD_UPLOAD_BARS
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // TODO: this file appears to be an exact duplicate of CreateWidgetHelper.js - DEV-4316 describes this effort.

/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        Marionette = __webpack_require__(10),
        template = __webpack_require__(2979),
        UploadBarView = __webpack_require__(2980),
        _ = __webpack_require__(1),
        UPLOADS_DONE = "uploads:done:loading:screen";

    /**
     * This class is used to add an overlay including loadingbars on top of a scene when
     * images are dragged directly to a scene.
     *
     * The Class works directly with ImageModels that are expected to be in an uploading
     * state.
     */
    return Marionette.CompositeView.extend({

        template: template,

        ui: {
            amount: ".amount"
        },

        className: "scene-loading-scene",

        itemViewContainer: ".uploading-bars",

        itemView: UploadBarView,

        collectionEvents: {
            "change:uploading": "_changeUploadingHandler",
            "upload:failed": "_uploadFailedHandler",
            "add remove": "_addRemoveItemHandler"
        },

        _changeUploadingHandler: function _changeUploadingHandler(imageModel) {
            this._removeUpload(imageModel);
        },

        _uploadFailedHandler: function _uploadFailedHandler(imageModel) {
            this._removeUpload(imageModel);
        },

        _addRemoveItemHandler: function _addRemoveItemHandler() {
            this._updateCounter();
        },

        initialize: function initialize() {
            // We start with an empty collection.
            this.collection = new Backbone.Collection([]);
        },

        /**
         * Add the image models to the collection, so the loading bar is rendered.
         *
         * @return {ImageModel[]} - Array of <tt>ImageModel</tt>'s.
         * @public
         */
        addUploads: function addUploads(imageModels) {
            // First we filter out any models that might already have finished uploading.
            var filteredModels = _.filter(imageModels, function (imageModel) {
                return imageModel.get("uploading");
            }),


            // We sort files when they get added, to hopefully have the heaviest files at the
            // top. This will prevent them from "jumping around" as they finish. Files that
            // are added later, will be prepended at the front though; and not shuffled into
            // the already existing uploads.
            sortedImageModels = _.sortBy(filteredModels, function (imageModel) {
                return -imageModel.get("size");
            });

            this.collection.add(sortedImageModels, { at: 0 });
        },

        _updateCounter: function _updateCounter() {
            this.ui.amount.html(this.collection.length);

            if (this.collection.length === 0) {
                this.trigger(UPLOADS_DONE);
            }
        },

        /**
         * Removes an image model, to remove its loading bar.
         *
         * @param {ImageModel} - <tt>ImageModel<tt>.
         * @public
         */
        _removeUpload: function _removeUpload(imageModel) {
            this.collection.remove(imageModel);
        }

    }, {
        UPLOADS_DONE: UPLOADS_DONE
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2979 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h1>Uploading <span class="amount"></span> files&#8230;</h1>\n<div class="uploading-bars"></div>\n';

}
return __p
}

/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var template = __webpack_require__(2981),
        Marionette = __webpack_require__(10);

    return Marionette.ItemView.extend({

        template: template,

        className: "upload-bar-block",

        ui: {
            container: ".loading-bar-container",
            loadingBar: ".loading-bar"
        },

        modelEvents: {
            "change:progress": "_changeProgressHandler"
        },

        _changeProgressHandler: function _changeProgressHandler(model, progress) {
            this._updateLoadingBar(progress);
        },

        /**
         * Updates the loading bar.
         *
         * @param {Number} progress - between 0 and 1 - how far are we?
         */
        _updateLoadingBar: function _updateLoadingBar(progress) {
            this.ui.loadingBar.width(progress * 100 + "%");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2981 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="loading-bar-container">\n    <div class="loading-bar"></div>\n</div>\n<div class="name">' +
__e( name ) +
'</div>\n';

}
return __p
}

/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var _ = __webpack_require__(1);
    var EventDispatcher = __webpack_require__(54);
    var GuidelineCompositeView = __webpack_require__(2983);
    var GuidelineModel = __webpack_require__(252);
    var HorizontalRulerView = __webpack_require__(2988);
    var VerticalRulerView = __webpack_require__(2989);

    return EventDispatcher.extend({

        viewModel: null,

        viewScope: null,

        sceneEditor: null,

        horizontalRuler: null,

        verticalRuler: null,

        _firstRender: true,

        _zoomModel: null,

        constructor: function constructor(options) {
            this.viewScope = options.viewScope;
            this.sceneEditor = options.sceneEditor;
            this.viewModel = this.viewScope.viewModel;
            this._zoomModel = this.viewModel.get("zoomModel");
            this.horizontalRuler = new HorizontalRulerView();
            this.verticalRuler = new VerticalRulerView();

            this.guidelineCompositeView = new GuidelineCompositeView({
                collection: this.sceneEditor.model.get("guidelines"),
                viewModel: this.viewModel,
                sceneEditor: this.sceneEditor
            });
        },

        render: function render() {
            // on a scene width/height change, the rulers elements are removed from the DOM
            // so re-set them here to elements that are newly in the DOM.
            this.horizontalRuler.setElement(this.sceneEditor.ui.horizontalRuler);
            this.verticalRuler.setElement(this.sceneEditor.ui.verticalRuler);
            this.horizontalRuler.render(this.sceneEditor.experienceModel.get("width"));
            this.verticalRuler.render(this.sceneEditor.experienceModel.get("height"));

            // Needed in order to have the ruler not show up at wrong place at first
            this.horizontalRuler.$el.css("top", 0);
            this._getHorizontalRulerMask().css("top", 0);
            this._getVerticalRulerMask().css("top", 0);

            // This is a compensation for this collection view not being rendered properly with its children views
            if (!this.sceneEditor._isShown) {
                this._addEventListeners();
            } else {
                // On re-render the transformer event listener needs to be re-attached
                this.sceneEditor.sceneWidgetCollectionView.off("transforming", this._setMarkers.bind(this));
                this.sceneEditor.sceneWidgetCollectionView.on("transforming", this._setMarkers.bind(this));
            }

            this._renderGuidelines();

            this.listenTo(this.viewModel, "change:currentLayer change:sceneNumber", this._renderGuidelines);
            this.listenTo(this.sceneEditor.experienceModel, "change:width change:height", this._repositionRulers);

            this._firstRender = false;
        },

        _renderGuidelines: function _renderGuidelines() {
            if (this.guidelineCompositeView && this.sceneEditor.guidelinesContainer) {
                this.sceneEditor.guidelinesContainer.close();
            }

            var guidelineCollection = this.viewModel.get("activeLayerSceneModel").get("guidelines");

            this.guidelineCompositeView = new GuidelineCompositeView({
                collection: guidelineCollection,
                viewModel: this.viewModel,
                sceneEditor: this.sceneEditor
            });

            if (this.sceneEditor.guidelinesContainer) {
                this.sceneEditor.guidelinesContainer.show(this.guidelineCompositeView);
            }
        },


        _addEventListeners: function _addEventListeners() {
            var _this = this;

            // Connect to scrollbars event.
            this.viewScope.getScrollbarV().on("move", this._repositionRulers.bind(this));
            this.viewScope.getScrollbarH().on("move", this._repositionRulers.bind(this));

            this.viewModel.selection.on("change:widgets", this._changeSelectedWidgetsHandler.bind(this));
            this.sceneEditor.listenTo(this.viewModel, "change:activeWidgetCords", this._repositionRulers.bind(this));

            // Connect ruler to scale change and adding new scene.
            this.sceneEditor.listenTo(this._zoomModel, "change:scale", this._repositionRulers.bind(this));
            this.sceneEditor.listenTo(this.sceneEditor.experienceModel.get("scenes"), "add", this._repositionRulers.bind(this));

            this.sceneEditor.sceneWidgetCollectionView.on("transforming", this._setMarkers.bind(this));

            this.sceneEditor.listenTo(this.getHorizontalRuler(), "guideline:add", function (mouseDownEvent) {
                _this.guidelineCompositeView.addGuideline(GuidelineModel.HORIZONTAL, mouseDownEvent);
            });

            this.sceneEditor.listenTo(this.getVerticalRuler(), "guideline:add", function (mouseDownEvent) {
                _this.guidelineCompositeView.addGuideline(GuidelineModel.VERTICAL, mouseDownEvent);
            });
        },

        _repositionHorizontalRuler: function _repositionHorizontalRuler() {
            var topOffset = this.viewScope.getViewportElement().get(0).getBoundingClientRect().top - this.sceneEditor.el.getBoundingClientRect().top,
                rulerTop = Math.floor(topOffset * (1 / this._zoomModel.get("scale")));

            this._getVerticalRulerMask().css("top", rulerTop);

            if (this.sceneEditor.isCurrentScene()) {
                this.horizontalRuler.$el.css("top", rulerTop);
            } else {
                this._getHorizontalRulerMask().css("top", rulerTop);
            }
        },

        _repositionVerticalRuler: function _repositionVerticalRuler() {
            if (!this.sceneEditor.isCurrentScene()) {
                return;
            }

            var sceneOffset = this.sceneEditor.$el.offset(),
                rulerOffset = this._getRulerOffset(sceneOffset);

            // Make sure the ruler doesn't move out of the scene borders
            if (rulerOffset <= this.sceneEditor.$el.width() - this.verticalRuler.$el.width()) {
                this.verticalRuler.$el.css("left", rulerOffset);
            }
        },

        _getRulerOffset: function _getRulerOffset(sceneOffset) {
            if (sceneOffset.left > 0) {
                return 0;
            }
            return Math.floor(sceneOffset.left * (-1 / this._zoomModel.get("scale")));
        },

        _changeSelectedWidgetsHandler: function _changeSelectedWidgetsHandler(selection) {
            var _this2 = this;

            if (!this.sceneEditor.isCurrentScene()) {
                return;
            }

            var previouslySelectedWidgets = selection.previousAttributes().widgets;

            // clear events off of previously selected widgets
            if (previouslySelectedWidgets) {
                _.each(previouslySelectedWidgets, function (previousWidget) {
                    _this2.sceneEditor.stopListening(previousWidget.model, "change", _this2._setMarkers);
                });
            }

            // put events for position changing on newly selected widgets
            selection.get("widgets").forEach(function (selectedWidget) {
                _this2.sceneEditor.listenTo(selectedWidget.model, "change", _this2._setMarkers.bind(_this2));
            });

            this._setMarkers();
        },

        _setMarkers: function _setMarkers() {
            var _this3 = this;

            var sceneEditorOffset = this.sceneEditor.$el.offset();
            var rulerWidth = this.verticalRuler.$el.width();

            var elementsBounds = _.map(this.viewModel.selection.get("widgets"), function (widget) {
                var boundingBoxGlobal = widget.getBoundingBox(true);

                var boundingBoxLocal = {
                    left: Math.round((boundingBoxGlobal.left - sceneEditorOffset.left) / _this3._zoomModel.get("scale") - rulerWidth),
                    top: Math.round((boundingBoxGlobal.top - sceneEditorOffset.top) / _this3._zoomModel.get("scale") - rulerWidth),
                    bottom: Math.round((boundingBoxGlobal.bottom - sceneEditorOffset.top) / _this3._zoomModel.get("scale") - rulerWidth),
                    right: Math.round((boundingBoxGlobal.right - sceneEditorOffset.left) / _this3._zoomModel.get("scale") - rulerWidth)
                };

                return boundingBoxLocal;
            });

            if (elementsBounds.length === 0) {
                this.horizontalRuler.setMarkers([]);
                this.verticalRuler.setMarkers([]);
                return;
            }

            // outermost left, top, right and bottom values from the list of `selectedTransformableElements`
            var bounds = {
                left: _.min(_.pluck(elementsBounds, "left")),
                top: _.min(_.pluck(elementsBounds, "top")),
                right: _.max(_.pluck(elementsBounds, "right")),
                bottom: _.max(_.pluck(elementsBounds, "bottom"))
            };

            if (this.horizontalRuler) {
                this.horizontalRuler.setMarkers([bounds.left, bounds.right]);
            }

            if (this.verticalRuler) {
                this.verticalRuler.setMarkers([bounds.top, bounds.bottom]);
            }
        },

        /**
         * Re-align rulers (top/side), and show if the current scene, otherwise hide rulers.
         */
        _repositionRulers: function _repositionRulers() {
            this._repositionHorizontalRuler();
            this._repositionVerticalRuler();
        },

        getHorizontalRuler: function getHorizontalRuler() {
            return this.horizontalRuler;
        },

        getVerticalRuler: function getVerticalRuler() {
            return this.verticalRuler;
        },

        _getHorizontalRulerMask: function _getHorizontalRulerMask() {
            return this.sceneEditor.$el.find(".horizontal-ruler-mask");
        },

        _getVerticalRulerMask: function _getVerticalRulerMask() {
            return this.sceneEditor.$el.find(".vertical-ruler-mask");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var GuidelineModel = __webpack_require__(252);
    var HorizontalGuidelineView = __webpack_require__(2984);
    var Marionette = __webpack_require__(10);
    var VerticalGuidelineView = __webpack_require__(2986);

    return Marionette.CompositeView.extend("GuidelineCompositeView", {
        className: "guidelines-view",
        _mouseDownEvent: null,

        template: _.template("<div class=\"guideline-tooltip no-scale hidden\"></div><div class=\"guidelines\"></div>"),

        itemViewContainer: ".guidelines",

        initialize: function initialize() {
            this._viewModel = this.options.viewModel;
            this._sceneEditor = this.options.sceneEditor;
            this.listenTo(this._viewModel.get("zoomModel"), "change:scale", this.render);
        },

        getItemView: function getItemView(item) {
            switch (item.get("direction")) {
                case GuidelineModel.HORIZONTAL:
                    return HorizontalGuidelineView;

                case GuidelineModel.VERTICAL:
                    return VerticalGuidelineView;

                default:
                    throw new Error("'" + item.direction + "' is not a supported guideline direction.");
            }
        },

        appendHtml: function appendHtml(collectionView, itemView, index) {
            var $elem;

            if (this.itemViewContainer) {
                $elem = collectionView.$el.find(this.itemViewContainer);
            } else {
                $elem = collectionView.$el;
            }

            if (collectionView.isBuffering) {
                collectionView.elBuffer.appendChild(itemView.el);
            } else {
                // Using all child elements instead of filtering by class name. Can't figure out why
                // it would be necessary to filter by class name, but since CollectionView's
                // appendHtml has been in production for over two years, it was chosen not to mess
                // with it.
                var children = $elem.children();
                if (index >= 0 && children.length) {
                    if (index === 0) {
                        children.eq(0).before(itemView.el);
                    } else {
                        // If the children had been filtered by class name we would get an out of
                        // bounds issue here, resulting in children.eq(index - 1) returning an empty
                        // array, and then that itemView.el wouldn't be added to the DOM.
                        children.eq(index - 1).after(itemView.el);
                    }
                } else {
                    $elem.append(itemView.el);
                }
            }
        },

        itemViewOptions: function itemViewOptions() {
            return {
                sceneEditor: this.options.sceneEditor,
                viewModel: this.options.viewModel,
                tooltipElement: this.$el.find(".guideline-tooltip"),
                rulers: this.options.sceneEditor.sceneRulers
            };
        },

        onAfterItemAdded: function onAfterItemAdded(guidelineView) {
            if (this._mouseDownEvent && !guidelineView.model.get("position")) {
                guidelineView.guidelineAdded(this._mouseDownEvent);
            }
        },

        addGuideline: function addGuideline(direction, mouseDownEvent) {
            this._mouseDownEvent = mouseDownEvent;

            var newGuideline = new GuidelineModel({
                direction: direction
            });

            this._viewModel.get("activeLayerSceneModel").get("guidelines").add(newGuideline);
        },

        getViewPortOffset: function getViewPortOffset(direction) {
            var offset = {};
            var verticalOffset = 0;
            var rect = this.el.getBoundingClientRect();

            if (rect.left < 0) {
                var sceneRulers = this._sceneEditor.sceneRulers;
                verticalOffset = -rect.left + sceneRulers.verticalRuler.$el.width() * this._viewModel.get("zoomModel").get("scale");
            }

            offset[GuidelineModel.HORIZONTAL] = this._viewModel.get("contentOffsetY");
            offset[GuidelineModel.VERTICAL] = verticalOffset;

            if (direction) {
                return offset[direction];
            }

            return offset;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractGuidelineView = __webpack_require__(1232),
        GuidelineModel = __webpack_require__(252),
        template = __webpack_require__(2985);

    return AbstractGuidelineView.extend("HorizontalGuidelineView", {
        className: "horizontal-guideline",
        template: template,

        _scrollbar: null,

        _getClientXY: function _getClientXY(e) {
            return e.clientY;
        },

        _getDirection: function _getDirection() {
            return GuidelineModel.HORIZONTAL;
        },

        _getTopLeft: function _getTopLeft() {
            return "top";
        },

        _getTooltipLabel: function _getTooltipLabel() {
            return "y: ";
        },

        _getWidthHeight: function _getWidthHeight() {
            return "height";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2985 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="horizontal-guideline-inner"></div>\n';

}
return __p
}

/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractGuidelineView = __webpack_require__(1232),
        GuidelineModel = __webpack_require__(252),
        template = __webpack_require__(2987);

    return AbstractGuidelineView.extend("VerticalGuidelineView", {
        className: "vertical-guideline",
        template: template,

        initialize: function initialize(options) {
            this.__super();
            this._rulers = options.rulers;
        },

        _getClientXY: function _getClientXY(e) {
            return e.clientX;
        },

        _getDirection: function _getDirection() {
            return GuidelineModel.VERTICAL;
        },

        _getTopLeft: function _getTopLeft() {
            return "left";
        },

        _getTooltipLabel: function _getTooltipLabel() {
            return "x: ";
        },

        _getWidthHeight: function _getWidthHeight() {
            return "width";
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2987 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="vertical-guideline-inner"></div>\n';

}
return __p
}

/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var _ = __webpack_require__(1),
        AbstractRulerView = __webpack_require__(1233);

    /**
     *
     * @param {ExperienceModel} model The active experience.
     */
    return AbstractRulerView.extend({

        SPACING_CSS_PROPERTY: "margin-left",

        DISTANCE_CSS_PROPERTY: "left",

        className: "horizontal",

        // The mousedown event is not triggered if defined in AbstractRulerView.
        events: {
            "mousedown": "_onMouseDown"
        },

        /**
         * Renders the ruler for a given scene number
         * @param {Number} width
         * @param {Object} renderOptions @see AbstractRulerView#getDefaultRenderOptions
         */
        render: function render(width, renderOptions) {
            renderOptions = _.extend(this.getDefaultRenderOptions(), renderOptions);

            var $ruler = this._createRuler(width, renderOptions.scale);

            $ruler.find(this.MAJOR_INCREMENT_SELECTOR + "," + this.SUB_INCREMENT_SELECTOR).addClass("pull-left");

            this.$el.html($ruler);
            this.setDistanceToStart(renderOptions.marginAtStartPx);

            // Add 30 px to get the ruler to continue outside the scene because it looks better.
            $ruler.width(width + 30);

            this.$el.removeClass("hidden");
        },

        /**
         * @returns {Number} distance from the start in pixels
         */
        getDistanceToStart: function getDistanceToStart() {
            var spacingCssString = this.$el.find(".ruler-elements-list").css(this.SPACING_CSS_PROPERTY);
            return parseInt(spacingCssString.replace("px", ""), 10);
        },

        /**
         * @param {Number} marginAtStartPx margin at the start of the ruler in pixels
         */
        setDistanceToStart: function setDistanceToStart(marginAtStartPx) {
            this.$el.find(".ruler-elements-list").css(this.SPACING_CSS_PROPERTY, marginAtStartPx);
        },

        _onMouseDown: function _onMouseDown(mouseDownEvent) {
            this.trigger("guideline:add", mouseDownEvent);
            return false;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var _ = __webpack_require__(1),
        $ = __webpack_require__(4),
        AbstractRulerView = __webpack_require__(1233);

    /**
     *
     * @param {HTMLElement} el html element container
     * @param {ExperienceModel} model The active experience.
     */
    return AbstractRulerView.extend({

        SPACING_CSS_PROPERTY: "margin-top",

        DISTANCE_CSS_PROPERTY: "top",

        className: "vertical",

        // The mousedown event is not triggered if defined in AbstractRulerView.
        events: {
            "mousedown": "_onMouseDown"
        },

        /**
         * Renders the ruler for a given scene number
         * @param {Number} height
         * @param {Object} renderOptions @see AbstractRulerView#getDefaultRenderOptions
         */
        render: function render(height, renderOptions) {
            renderOptions = _.extend(this.getDefaultRenderOptions(), renderOptions);

            var self = this,
                unscaledRulerHeight = height + 1;

            var $ruler = this._createRuler(height, renderOptions.scale);

            $ruler.children("ul").height(unscaledRulerHeight);

            $ruler.find(".ruler-px-value").each(function (index, incrementTextElement) {
                var topPx = self._calculateIncrementTextElementTopPx(index, renderOptions.scale);

                $(incrementTextElement).css("top", topPx);
            });

            this.$el.html($ruler);

            this.$el.removeClass("hidden");
        },

        /**
         * The amount of pixels the CSS `top` property on the ruler marking label (the 100, 200, etc markers) needs to have.
         * @param {Number} index index of text element (`0` for the marker for 0px, `1` for the marker for 100px)
         * @param {Number} scaleFactor `1` for 100%, `0.67` for 67%
         * @return {Number} amount of pixels that the CSS `top` property should have marked on it to position it correctly.
         */
        _calculateIncrementTextElementTopPx: function _calculateIncrementTextElementTopPx(index, scaleFactor) {
            if (index === 0) {
                return -25;
            }

            if (scaleFactor === 0.25) {
                return -25;
            }

            return scaleFactor * -2 - 22;
        },

        _onMouseDown: function _onMouseDown(mouseDownEvent) {
            this.trigger("guideline:add", mouseDownEvent);
            return false;
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var LayerEnum = __webpack_require__(251);
    var WidgetCollectionView = __webpack_require__(2991);
    var template = __webpack_require__(3012);

    return Marionette.Layout.extend({

        ItemView: WidgetCollectionView,

        template: template,

        viewScope: null,

        regions: {
            sceneWidgetContainer: ".scene-widgets-container",
            overlayWidgetContainer: ".overlay-widgets-container",
            backgroundWidgetContainer: ".background-widgets-container"
        },

        initialize: function initialize(_ref) {
            var _this = this;

            var viewScope = _ref.viewScope,
                scene = _ref.scene;

            this.viewScope = viewScope;

            this.sceneWidgetCollectionView = new WidgetCollectionView({
                collection: scene.get("widgets"),
                viewScope: viewScope,
                edited: true,
                container: this.sceneWidgetContainer,
                layer: LayerEnum.SCENE,
                scene: scene
            });

            this.overlayWidgetCollectionView = new WidgetCollectionView({
                collection: viewScope.viewModel.get("experience").get("overlayScene").get("widgets"),
                viewScope: viewScope,
                edited: true,
                container: this.overlayWidgetContainer,
                layer: LayerEnum.OVERLAY,
                scene: scene
            });

            this.backgroundWidgetCollectionView = new WidgetCollectionView({
                collection: viewScope.viewModel.get("experience").get("backgroundScene").get("widgets"),
                viewScope: viewScope,
                edited: true,
                container: this.backgroundWidgetContainer,
                layer: LayerEnum.BACKGROUND,
                scene: scene
            });

            // eslint-disable-next-line no-unused-vars
            this.listenTo(viewScope.viewModel, "change:currentLayer", function (model, layer) {
                _this._showHideWidgetsBasedOnLayer();
            });

            // propagate events from child views
            this.widgetCollectionViews().forEach(function (widgetCollectionView) {
                _this.listenTo(widgetCollectionView.transformer, {
                    "transforming": function transforming(tGroup, model, tElement) {
                        return _this.trigger("transforming", tGroup, model, tElement);
                    },
                    "select_target": function select_target(tGroup, model, tElement) {
                        return _this.trigger("select_target", tGroup, model, tElement);
                    },
                    "translating": function translating(tGroup, model, tElement) {
                        return _this.trigger("translating", tGroup, model, tElement);
                    },
                    "transforming_end": function transforming_end(tGroup, model, tElement) {
                        return _this.trigger("transforming_end", tGroup, model, tElement);
                    }
                });
            });
        },
        onShow: function onShow() {
            this.sceneWidgetContainer.show(this.sceneWidgetCollectionView);
            this.overlayWidgetContainer.show(this.overlayWidgetCollectionView);
            this.backgroundWidgetContainer.show(this.backgroundWidgetCollectionView);

            this._showHideWidgetsBasedOnLayer();
        },


        /**
         *
         * @param {Layer} currentLayer
         */
        _showHideWidgetsBasedOnLayer: function _showHideWidgetsBasedOnLayer() {
            this.widgetCollectionViews().forEach(function (view) {
                view.setActiveState();
            });
        },
        activeLayerWidgetCollectionView: function activeLayerWidgetCollectionView() {
            var currentLayer = this.viewScope.viewModel.get("currentLayer");

            switch (currentLayer) {
                case LayerEnum.SCENE:
                    return this.sceneWidgetCollectionView;
                case LayerEnum.OVERLAY:
                    return this.overlayWidgetCollectionView;
                case LayerEnum.BACKGROUND:
                    return this.backgroundWidgetCollectionView;
                default:
                    throw new Error("unrecognised layer: '" + currentLayer.toString() + "'");
            }
        },


        // todo - marionette?
        widgetCollectionViews: function widgetCollectionViews() {
            return [this.sceneWidgetCollectionView, this.overlayWidgetCollectionView, this.backgroundWidgetCollectionView];
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var TransformableWidgetFactory = __webpack_require__(2992);
    var WidgetTypes = __webpack_require__(69);
    var WidgetTransformer = __webpack_require__(3007);

    var _require = __webpack_require__(504),
        ETW_IS_READY = _require.ETW_IS_READY;
    /**
     * The container inside each scene that holds all the widgets, and instantiates their views.
     *
     * @return {Marionette CollectionView}
     */


    return Marionette.CollectionView.extend({

        className: "widget-container-inner widget-collection-view-container",

        transformer: null,

        viewModel: null,

        _layer: null,

        scene: null,

        attributes: {
            "data-dragselectable": true
        },

        initialize: function initialize(_ref) {
            var layer = _ref.layer,
                scene = _ref.scene,
                viewScope = _ref.viewScope;

            this.viewModel = viewScope.viewModel;
            this._layer = layer;
            this.scene = scene;

            this.transformer = new WidgetTransformer({
                container: this.$el,
                layer: layer,
                scene: scene,
                viewModel: this.viewModel
            });

            this.el.className += " widget-collection-view-container-" + layer.value;
            this.el.className += " widget-collection-view-container-" + this.scene.get("sceneNumber");
            this.transformer.setViewportBoundingBoxProvider(this.viewportBoundingBoxProvider.bind(this));
            this.children.each(this.transformer.addWidget.bind(this.transformer));
            this._addListeners();
        },
        onRender: function onRender() {
            this.transformer.editorRenderHandler(this.options.viewScope.viewModel.get("zoomModel").get("scale"));
        },
        viewportBoundingBoxProvider: function viewportBoundingBoxProvider() {
            return this.options.viewScope.getViewportElement().get(0).getBoundingClientRect();
        },
        _addListeners: function _addListeners() {
            this.on("itemview:update", this._updateControlsHandler);

            this.listenTo(this.viewModel.selection, {
                "change:widgets": this._selectedWidgetsChangeHandler
            });
            this.listenTo(this.viewModel.get("zoomModel"), {
                "change:scale": this._updateControlsHandler
            });

            this.listenTo(this.transformer, "setSelectedWidgets", this._setSelectedWidgetsHandler);

            this.listenTo(this.viewModel, "change:currentLayer change:sceneNumber", this._setSelectedWidgetsHandler);

            this.listenTo(this.viewModel.get("experience"), "change:selectedWidgetId", this._setWidgetHighlight);

            this.listenTo(this.viewModel, ETW_IS_READY, this._updateControlsHandler);
        },


        collectionEvents: {
            "change": "_updateControlsHandler",
            "destroy remove": "_destroyRemoveHandler"
        },

        _updateControlsHandler: function _updateControlsHandler() {
            this.transformer.updateControls();
        },
        _destroyRemoveHandler: function _destroyRemoveHandler() {
            this.transformer.hideControls();
        },
        _setSelectedWidgetsHandler: function _setSelectedWidgetsHandler(selectedWidgets) {
            // If selected widgets were updated by our instance of the WidgetTransformer,
            // make sure that the newly selected widgets are all in the current layer. If any of
            // them are not, abort and clear the selection. If yes, ask our instance of the
            // WidgetSelectionViewModel to add the newly selected widgets to its list.
            var layerUuids = [];
            var selectedUuids = [];
            var widgetsAreSelected = selectedWidgets && selectedWidgets.length > 0;

            // Get an array of the uuid's of all widgets in the current layer.
            this.collection.each(function (widget) {
                layerUuids.push(widget.get("uuid"));
                if (widget.get("group")) {
                    widget.get("group").models.map(function (model) {
                        return layerUuids.push(model.get("uuid"));
                    });
                }
            });

            // Get an array of the uuid's of the widgets passed to us by the WidgetTransformer.
            if (widgetsAreSelected) {
                selectedUuids = selectedWidgets.map(function (widget) {
                    return widget.model.get("uuid");
                });
            }

            // If all of the selected widgets are in the current layer, we're good to go and
            // can ask our instance of the WidgetSelectionViewModel to add these widgets.
            // If one or more of the selected widgets isn't in this layer, clear the selection.
            if (this._includesAll(selectedUuids, layerUuids) && widgetsAreSelected) {
                this.viewModel.selection.select(selectedWidgets);
            } else {
                this.viewModel.selection.clear();
                this.transformer.hideControls();
            }
        },
        _includesAll: function _includesAll(subArray, array) {
            if (subArray && subArray.length > 0) {
                subArray.forEach(function (element) {
                    if (!array.includes(element)) {
                        return false;
                    }
                });
            }
            return true;
        },
        _selectedWidgetsChangeHandler: function _selectedWidgetsChangeHandler() {
            var selectedViews = this.viewModel.selection.get("widgets");
            var isCurrentScene = this.scene === this.viewModel.get("scene");

            if (isCurrentScene) {
                this.transformer.selectWidget(selectedViews);
            }

            this.children.each(function (childView) {
                // Triggers deselect from here is more consistent, previously we trigger it from Freetransform
                // See bug MOS-1857
                childView.trigger("deselect");

                if (childView.model.get("group") && childView.groupCollectionView) {
                    childView.groupCollectionView.children.each(function (grandChildView) {
                        grandChildView.trigger("deselect");
                        var grandChildViewIsSelected = selectedViews.indexOf(grandChildView) > -1;
                        grandChildView.$el.toggleClass("widget-selected", grandChildViewIsSelected && isCurrentScene);
                    });
                }

                var childViewIsSelected = selectedViews.indexOf(childView) > -1;
                childView.$el.toggleClass("widget-selected", childViewIsSelected && isCurrentScene);
            });

            this.$el.toggleClass("multi-selection", this.viewModel.selection.isMultiple());
        },
        _setWidgetHighlight: function _setWidgetHighlight() {
            if (this.viewModel.get("experience").get("selectedWidgetId")) {
                this.$el.addClass("has-highlight");
            } else {
                this.$el.removeClass("has-highlight");
            }
        },
        setActiveState: function setActiveState() {
            var isActive = this.viewModel.get("currentLayer") === this._layer;

            this.$el.toggleClass("active-layer-widgets", isActive);
        },


        /**
         * Get the view for each widget, this overwrites the default from marionette
         *
         * @param {Backbone.Model} item
         * @returns {AbstractWidgetView}    Returns the view defined for the model
         */
        getItemView: function getItemView(item) {
            var type = item.get("type");
            var ViewClass = WidgetTypes.lookup(type).viewClass;

            return TransformableWidgetFactory.create(type, ViewClass);
        },
        itemViewOptions: function itemViewOptions() {
            var _this = this;

            return {
                viewModel: this.viewModel,
                edited: this.options.edited,
                container: this.$el,
                TransformableWidgetFactory: TransformableWidgetFactory,
                addChildWidgetToTransformer: function addChildWidgetToTransformer(childWidgetView, parentTransform) {
                    _this.transformer.addWidget(childWidgetView, parentTransform);
                },
                removeChildWidgetFromTransformer: function removeChildWidgetFromTransformer(childWidgetView) {
                    _this.transformer.removeWidget(childWidgetView);
                },
                updateControls: function updateControls() {
                    _this._updateControlsHandler();
                },
                parentCollectionView: this
            };
        },


        /**
         * Marionette fires this when an itemview has been built.
         *
         * @param {Object} itemView
         */
        onAfterItemAdded: function onAfterItemAdded(itemView) {
            this.transformer.addWidget(itemView);
        },
        onClose: function onClose() {
            this.transformer.removeTransformer();
            this.transformer.close();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var TransformableTextEnhancedWidget = __webpack_require__(2993);
    var TransformableTextWidget = __webpack_require__(2996);
    var TransformableSalesforceCommerceWidget = __webpack_require__(3004);

    /**
     * The Idea of this class is avoid the mixin between (Editor and Viewer)Widget class.<p>
     * <ol>
     *  <li>#E.g. 1<p>
     *  The TextWidget that handlers a lot of different interactions in the editor, but inside of the view only display a simple text with styles.
     *
     *  <li>#E.g. 2<p>
     *  The SalesforceCommerceWidget that in the editor shows the SalesforceCommerceProduct (image,id,name), however in the widget
     *  only makes a call for the SalesforceCommerceClient Api.
     * </ol>
     * @class TextWidgetView
     * @constructor
     *
     */
    return {

        /**
         * Returns a <tt>TransformableWidget</tt> instance wrapped around the specified widget.
         *
         * @param  {String} type of the widget e.g. text, demandware
         * @param  {Object} widget instance
         *
         * @return {TransformableWidget}       A <tt>TransformableWidget</tt> instance wrapped around the specified widget.
         */
        create: function create(type, widget) {
            switch (type) {
                case "text":
                    return TransformableTextWidget;

                case "text-enhanced":
                    return TransformableTextEnhancedWidget;

                /** @see {WidgetTypes.SALESFORCE_COMMERCE} */
                case "demandware":
                    return TransformableSalesforceCommerceWidget;

                default:
                    return widget;
            }
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var TextWidgetView = __webpack_require__(518);
    var TextEditorController = __webpack_require__(2994);

    /**
     * This class decorates the Text Widget with text inline editor
     */
    return TextWidgetView.extend({
        /**
         * A flag indicating whether a mouse down is a click(vs a drag)
         * @private
         */
        _isClick: false,

        /**
         * A flag indicating whether the widget is in selected state by FreeTransform
         * @private
         */
        _isSelected: false,

        _cursorCoordinatesOnMouseDown: null,

        /**
         * The reference to the text widget inline editor
         */
        textEditorController: null,

        /**
         * Initialization
         */
        initialize: function initialize() {
            this.__super();

            // There is no way to determine deselect, so we need to get it from FreeTransform
            this.listenTo(this, "deselect", this._deselectHandler);

            this._cursorCoordinatesOnMouseDown = {};
        },


        /**
         * Use mousedown, mousemove and mouseup to determine whether if a click is a reselect.
         * We need reselect event to enable the editor
         * @private
         */
        events: {
            mousedown: "_mouseDownHandler",
            mousemove: "_mouseMoveHandler",
            mouseup: "_mouseUpHandler"
        },

        /**
         * @see events
         * @private
         */
        _mouseDownHandler: function _mouseDownHandler(event) {
            this._isClick = true;
            // if mouse down on the widget, it should always be selected to allow for editor surface changes like dragging to work.
            this._isSelected = true;
            this.model.set("isSelected", true);
            this._cursorCoordinatesOnMouseDown.x = event.pageX;
            this._cursorCoordinatesOnMouseDown.y = event.pageY;
        },


        /**
         * @see events above
         * @private
         */
        _mouseMoveHandler: function _mouseMoveHandler(event) {
            // Only cancel the click event if the cursor was actually moved. This is workaround for
            // this bug in Chrome: https://code.google.com/p/chromium/issues/detail?id=161464
            // See also FreeTransform.js.
            if (event.pageX !== this._cursorCoordinatesOnMouseDown.x || event.pageY !== this._cursorCoordinatesOnMouseDown.y) {
                this._isClick = false;
            }
        },


        /**
         * @see events above
         * @private
         */
        _mouseUpHandler: function _mouseUpHandler() {
            if (this._isClick) {
                this._clickedHandler();
            }
            // Note: A nasty hack, could not find a better solution, see bug MOS-1822
            // Reason: sometimes when a text widget is dragged, it does not fire a click event, consequently the
            // inactive scene does not activate itself. This only happens when a text widget has nested elements,
            // namely after being edited. It is fine with newly created text widget through. In addition, there are
            // different behaviors across browsers, So manually triggering a click event fixes the issue.
            this.$el.trigger("click");
        },
        _isOnlySelection: function _isOnlySelection() {
            var selection = this.viewModel.selection;
            return selection.isSingle() && selection.get("widgets")[0] === this;
        },


        /**
         * Handles when a widget is clicked. If reselected, we enable the text editor editable mode
         * Note: avoid overwriting, the AbstractWidgetView has _clickHandler
         *
         * @private
         */
        _clickedHandler: function _clickedHandler() {
            if (!this._isSelected || !this._isOnlySelection()) {
                this.textEditorController.updateEditorModelFromWidgetModel();
            }
        },


        /**
         * Handles when the widget is deselected
         * @private
         */
        _deselectHandler: function _deselectHandler() {
            if (this._isOnlySelection()) {
                return;
            }

            if (this.model.get("isSelected")) {
                this._isSelected = false;
                this.model.set("isSelected", false);
            }
        },


        /**
         * OverWrites the textWidgetView update rendering
         */
        updateRendering: function updateRendering() {
            this.__super();

            if (!this.textEditorController) {
                this.textEditorController = new TextEditorController(this);
            }
        },
        onClose: function onClose() {
            this.__super();
            this.textEditorController.close();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defer = _require.defer,
        keys = _require.keys,
        pick = _require.pick;

    var Marionette = __webpack_require__(10);
    var TextEditorModel = __webpack_require__(2995);

    /**
     * A controller that correlates between text widget and text editor
     */
    return Marionette.Controller.extend({
        /**
         * The text widget element as jQuery object
         * @private
         */
        $el: null,

        /**
         * The text widget model
         * @private
         */
        _textWidgetModel: null,

        /**
         * The text widget view that embeds the actual text editor
         * @private
         */
        _textWidgetView: null,

        /**
         * Initialization
         * @param {TextWidgetView} textWidgetView   The text widget view
         */
        initialize: function initialize(textWidgetView) {
            this._textWidgetView = textWidgetView;
            this._textWidgetModel = this._textWidgetView.model;
            this.$el = this._textWidgetView.$el;

            this._editorModel = new TextEditorModel();
            this.updateEditorModelFromWidgetModel();

            // This will trigger the textWidgetView to re-render, which in turn
            // will call this class and end up that we create two ckeditors,
            // therefore lets be silent
            this._textWidgetModel.set("editorModel", this._editorModel, { silent: true });
            this.listenTo(this._textWidgetModel, "dropped:to:scene", this._onWidgetDrop);
        },


        /**
         * Trigger update in order to update the free transform handlers
         *
         * In addition, the content change will possibly affect the height of the widget.
         * we need to trigger change of height on the model in order to update the vertical scroll bar, if needed
         *
         * @private
         */
        _contentChangeHandler: function _contentChangeHandler() {
            this._textWidgetView.trigger("update");
            this._textWidgetModel.trigger("change:height");
        },


        /**
         * Copy values from textWidgetModel to editorModel so that the property view
         * reflects the attributes of textWidgetModel.
         */
        updateEditorModelFromWidgetModel: function updateEditorModelFromWidgetModel() {
            var attrs = pick(this._textWidgetModel.attributes, keys(TextEditorModel.prototype.defaults));

            // Pass cssUpdate to stop the cyclic callbacks.
            this._editorModel.set(attrs, { "cssUpdate": false });
        },
        _onWidgetDrop: function _onWidgetDrop() {
            var _this = this;

            defer(function () {
                if (!_this._textWidgetModel.get("isSelected")) {
                    _this._textWidgetModel.set("isSelected", true);
                }
            });
        },
        onClose: function onClose() {
            this._editorModel.destroy();
            this._editorModel = null;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);

    /**
     * Model for the text editor.
     *
     * @class TextEditorModel
     * @constructor
     */
    return Backbone.Model.extend("Editor model", {
        defaults: {
            fontSize: 30,
            fontStyle: "normal",
            fontWeight: "400",
            color: "#000000",
            fontFamily: "Arial",
            fontProvider: "standard",
            fontMetadata: {},
            fontVariant: "none",
            lineHeight: 1.4,
            textAlign: "left",
            textDecoration: "none",
            textTransform: "none",
            letterSpacing: 0,
            textShadow: "none",
            nodeName: null
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var DomHandler = __webpack_require__(470);
    var WebFontsUtil = __webpack_require__(136);
    var TextWidgetView = __webpack_require__(369);
    var TextEditorController = __webpack_require__(2997);

    /**
     * This class decorates the Text Widget with text inline editor
     */
    return TextWidgetView.extend({
        /**
         * A flag indicating whether a mouse down is a click(vs a drag)
         * @private
         */
        _isClick: false,

        /**
         * A flag indicating whether the widget is in selected state by FreeTransform
         * @private
         */
        _isSelected: false,

        _cursorCoordinatesOnMouseDown: null,

        /**
         * The reference to the text widget inline editor
         */
        textEditorController: null,

        /**
         * Initialization
         */
        initialize: function initialize() {
            this.__super();

            // There is no way to determine deselect, so we need to get it from FreeTransform
            this.listenTo(this, "deselect", this._deselectHandler);

            // Overwrites the change event on the AbstractView level
            TextWidgetView.prototype.modelEvents.change = this._changeHandler;

            this._cursorCoordinatesOnMouseDown = {};
        },
        _changeHandler: function _changeHandler(model, option) {
            // For advanced text widget, we need to prevent rendering while it is being edited
            if (option.render !== false) {
                this.render();
            }
        },


        /**
         * Use mousedown, mousemove and mouseup to determine whether if a click is a reselect.
         * We need reselect event to enable the editor
         * @private
         */
        events: {
            mousedown: "_mouseDownHandler",
            mousemove: "_mouseMoveHandler",
            mouseup: "_mouseUpHandler"
        },

        /**
         * @see events
         * @private
         */
        _mouseDownHandler: function _mouseDownHandler(event) {
            this._isClick = true;
            this._cursorCoordinatesOnMouseDown.x = event.pageX;
            this._cursorCoordinatesOnMouseDown.y = event.pageY;
        },


        /**
         * @see events above
         * @private
         */
        _mouseMoveHandler: function _mouseMoveHandler(event) {
            // Only cancel the click event if the cursor was actually moved. This is workaround for
            // this bug in Chrome: https://code.google.com/p/chromium/issues/detail?id=161464
            // See also FreeTransform.js.
            if (event.pageX !== this._cursorCoordinatesOnMouseDown.x || event.pageY !== this._cursorCoordinatesOnMouseDown.y) {
                this._isClick = false;
            }
        },


        /**
         * @see events above
         * @private
         */
        _mouseUpHandler: function _mouseUpHandler() {
            if (this._isClick) {
                this._clickedHandler();
            }
            // if mouse up on the widget, it should always be selected
            this._isSelected = true;
            // Note: A nasty hack, could not find a better solution, see bug MOS-1822
            // Reason: sometimes when a text widget is dragged, it does not fire a click event, consequently the
            // inactive scene does not activate itself. This only happens when a text widget has nested elements,
            // namely after being edited. It is fine with newly created text widget through. In addition, there are
            // different behaviors across browsers, So manually triggering a click event fixes the issue.
            this.$el.trigger("click");
        },
        _isOnlySelection: function _isOnlySelection() {
            var selection = this.viewModel.selection;
            return selection.isSingle() && selection.get("widgets")[0] === this;
        },


        /**
         * Handles when a widget is clicked. If reselected, we enable the text editor editable mode
         * Note: avoid overwriting, the AbstractWidgetView has _clickHandler
         *
         * @private
         */
        _clickedHandler: function _clickedHandler() {
            if (!this._isSelected || !this._isOnlySelection()) {
                this.textEditorController.updateEditorModelFromWidgetModel();
            }
        },


        /**
         * Handles when the widget is deselected
         * @private
         */
        _deselectHandler: function _deselectHandler() {
            var _this = this;

            DomHandler.clearSelection();

            if (this._isOnlySelection()) {
                return;
            }

            this._isSelected = false;

            // Due to the introduction of composite widgets where group widgets are rendered after the composite widget has been rendered
            // this is deferred to ensure existing (deferred) group widget renderings are done
            _.defer(function () {
                _this.textEditorController.disableEditable();
            });
        },


        /**
         * OverWrites the textWidgetView update rendering
         */
        updateRendering: function updateRendering() {
            this.__super();

            var attrs = WebFontsUtil.getFontAttributes(this.model);
            this.$el.attr(attrs);

            if (!this.textEditorController) {
                this.textEditorController = new TextEditorController(this);
            }
        },
        onClose: function onClose() {
            this.__super();
            this.textEditorController.close();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);

    var _require = __webpack_require__(1),
        defer = _require.defer,
        clone = _require.clone,
        keys = _require.keys,
        pick = _require.pick;

    var Marionette = __webpack_require__(10);

    var _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank;

    var TextEditorConstants = __webpack_require__(409);
    var TextEditorView = __webpack_require__(2998);
    var TextEditorModel = __webpack_require__(3003);

    /**
     * A controller that correlates between text widget and text editor
     *
     *  TextEditorController
     */
    return Marionette.Controller.extend({
        /**
         * The text widget element as jQuery object
         * @private
         */
        $el: null,

        /**
         * The text widget model
         * @private
         */
        _textWidgetModel: null,

        /**
         * The text widget view that embeds the actual text editor
         * @private
         */
        _textWidgetView: null,

        /**
         * Initialization
         * @param {TextWidgetView} textWidgetView   The text widget view
         */
        initialize: function initialize(textWidgetView) {
            // We receive the TextWidgetView through TransformableTextWidget. This pretty much just appends a few things to the model.
            this._textWidgetView = textWidgetView;
            this._textWidgetModel = this._textWidgetView.model;
            this.$el = this._textWidgetView.$el;

            this._editorModel = new TextEditorModel();
            this.updateEditorModelFromWidgetModel();
            this._editorView = new TextEditorView({
                viewModel: this.options.viewModel,
                element: this.$el,
                model: this._editorModel,
                textWidgetView: this._textWidgetView
            });

            // This will trigger the textWidgetView to re-render, which in turn
            // will call this class and end up that we create two ckeditors,
            // therefore lets be silent
            this._textWidgetModel.set("editorModel", this._editorModel, { silent: true });
            this.listenTo(this._editorModel, "change", this._modelChangeHandler);
            this.listenTo(this._editorModel, "change:fontSize", this._reposition);

            this.listenTo(this._editorView, {
                "contentChange": this._contentChangeHandler,
                "mouseup": this._updateEditorModel,
                "arrowKeyUp": this._updateEditorModel,
                "editorBlur": this.saveModel,
                "newParagraph": this._updateEditorModel
            });

            this.listenTo(this._textWidgetView, "render", this._editorView.ieQuoteHack);
            this.listenTo(this._textWidgetModel, "dropped:to:scene", this._onWidgetDrop);
        },


        /**
         * Trigger update in order to update the free transform handlers
         *
         * In addition, the content change will possibly affect the height of the widget.
         * we need to trigger change of height on the model in order to update the vertical scroll bar, if needed
         *
         * @private
         */
        _contentChangeHandler: function _contentChangeHandler() {
            this._textWidgetView.trigger("update");
            this._textWidgetModel.trigger("change:height");
        },
        _updateEditorModel: function _updateEditorModel() {
            var _this = this;

            // When mouse up, some times the selection is still the previous one, so we need to defer.
            defer(function () {
                // Be careful when using #defer - there's a chance we're 'closed' (i.e. deleted) at this point
                if (!_this._editorModel) {
                    return;
                }

                var attributes = _this._editorView.getCss(["color", "fontSize", "fontFamily", "fontWeight", "fontStyle", "lineHeight", "textAlign", "letterSpacing", "textDecoration", "textTransform", "fontVariant", "textShadow"]);

                // Text decoration is not inherited so we pull in the widget text decoration if it's defined on the model
                if (attributes.textDecoration === "none" && _this._textWidgetModel.get("textDecoration") !== "none") {
                    attributes.textDecoration = _this._textWidgetModel.get("textDecoration");
                }

                attributes.nodeName = _this._editorView.getNodeName();

                // Pass cssUpdate to stop the circular callbacks. This shall prevent triggering the _modelChangeHandler
                // in this class. see {@Link #_modelChangeHandler()} below
                _this._editorModel.set(attributes, { "cssUpdate": false });
            });
        },


        /**
         * Copy values from textWidgetModel to editorModel so that the property view
         * reflects the attributes of textWidgetModel.
         */
        updateEditorModelFromWidgetModel: function updateEditorModelFromWidgetModel() {
            var attrs = pick(this._textWidgetModel.attributes, keys(TextEditorModel.prototype.defaults));

            // Pass cssUpdate to stop the cyclic callbacks.
            this._editorModel.set(attrs, { "cssUpdate": false });
        },


        /*
         * Update the view when model changes. If the editor is not editable, we apply changes to the whole
         * widget. Otherwise, we apply the changes to the text selection
         */
        _modelChangeHandler: function _modelChangeHandler(model, options) {
            var changed = clone(model.changed);

            if (options.cssUpdate === false) {
                return;
            }

            if (this.getViewEditable()) {
                this._editorView.applyStyle(changed, model);
            } else {
                if (changed.hasOwnProperty("nodeName")) {
                    var nodeName = changed.nodeName || TextEditorConstants.TAGS.DIV;
                    this._textWidgetView.$el.children().each(function (i, childEl) {
                        var $childEl = $(childEl);
                        // Make sure the styles are applied to the new node type as well.
                        $childEl.replaceWith("<" + nodeName + " style=\"" + $childEl.attr("style") + "\">" + childEl.innerHTML + "</" + nodeName + ">");
                    });
                } else {
                    this._textWidgetModel.set(changed);
                    this._editorView.removeStyle(keys(changed));
                }

                this.saveModel();
            }
        },


        /**
         * When the font size is set from very big to small, the widget may
         * disappear out of the top. This check prevents this behaviour.
         */
        _reposition: function _reposition() {
            var _this2 = this;

            // Find the top coordinate of the widget in pixels.
            var experience = this.options.viewModel.get("experience");
            var top = experience.getPixelPosition({
                top: this._textWidgetModel.get("top")
            }).top;

            // Wait for FreeTransform to do its resizing before we calculate
            // the new height.
            defer(function () {
                var height = _this2.$el.height();

                if (top + height < 0) {
                    _this2._textWidgetModel.set("top", 5 - height);
                }
            });
        },
        enableEditable: function enableEditable() {
            this._editorView.enableEditable();
        },
        disableEditable: function disableEditable() {
            this._editorView.disableEditable();
        },
        getViewEditable: function getViewEditable() {
            return this._editorView.isEditable;
        },
        _onWidgetDrop: function _onWidgetDrop() {
            var _this3 = this;

            defer(function () {
                _this3._editorView.editAllText();
            });
        },
        saveModel: function saveModel() {
            var data = this._editorView.getContent();
            var elements = this.$el.get();

            if (isBlank(data)) {
                return this._textWidgetModel.destroy();
            }

            var fontFamilies = this._editorView.parseFont(elements);

            // The {render: false} is to avoid loss of focus when selecting text and interacting
            // with the properties view (selecting new font, etc).
            this._textWidgetModel.set({
                text: data,
                fontFamilies: fontFamilies
            }, { render: false });

            this._textWidgetModel.trigger("content:updated");
        },
        onClose: function onClose() {
            this._editorModel.destroy();
            this._editorModel = null;
            this._editorView.close();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Browser = __webpack_require__(39);
    var CkeditorFacade = __webpack_require__(2999);
    var DomHandler = __webpack_require__(470);
    var KeyCode = __webpack_require__(88);
    var Marionette = __webpack_require__(10);
    var Preconditions = __webpack_require__(14);

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        dasherize = _require.dasherize;

    var TextEditorConstants = __webpack_require__(409);
    var TextEditorViewHelpers = __webpack_require__(3002);
    var WebFontsUtil = __webpack_require__(136);

    var $body = $("body");
    var arrowKeys = [KeyCode.UP, KeyCode.DOWN, KeyCode.LEFT, KeyCode.RIGHT];
    var stopPropagationOfKeys = [KeyCode.DELETE, KeyCode.BACK_SPACE].concat(arrowKeys);
    var MOUSEUP = "mouseup";
    var KEY_Z = "z";
    var KEY_Y = "y";
    /**
     *  The inline editor wrapper for {@Link http://ckeditor.com/ ckeditor}
     *
     *  @event mouseup          Fires when the mouse up on the editor
     *  @event mousedown        Fires when the mouse down on the editor
     *  @event contentChange    Fires when content being changed including style changes
     *  @event editorBlur       Fires when edtior loses the focus
     *  @event arrowKeyUp       Fires when arrow keys up on the editor
     *
     *  @cfg {TextEditorModel} model    The editor model to facilitate the communication between
     *                                  property view and Ckeditor
     */
    return Marionette.View.extend({

        /**
         * A flag indicating whether the editor is editable
         */
        isEditable: false,

        _ckEditor: null,

        hasFakeHighlight: false,

        modelEvents: {
            "focus:propertyView": "applyFakeHighlight"
        },

        initialize: function initialize(options) {
            this._contentChangeHandler = _.throttle(this._contentChangeHandler, 300);

            _.bindAll(this, "_mouseDownHandler", "_mouseUpHandler", "_onBlurHandler", "_keyDownHandler", "_keyUpHandler", "_contentChangeHandler", "_bodyMouseUpHandler");

            this.$el = options.element.attr("contenteditable", false).addClass("text-widget").on(MOUSEUP, this._mouseUpHandler).on("mousedown", this._mouseDownHandler).on("blur", this._onBlurHandler).on("keydown", this._keyDownHandler).on("keyup", this._keyUpHandler);

            this._ckEditor = new CkeditorFacade(options.element);
            this._ckEditor.on("change", this._contentChangeHandler);
            this._ckEditor.on("readOnly", this._onBlurHandler);

            // A hack to deal with the mouse up releasing outside the text editor
            // @see MOS-1819
            $body.on(MOUSEUP, this._bodyMouseUpHandler);
        },


        /**
         * Handles mouse down on events on the text widget element
         *
         * @param {mouseEvent} event The mouse event
         * @private
         */
        _mouseDownHandler: function _mouseDownHandler(event) {
            var selectedWidgets = this.options.viewModel.selection.get("widgets");
            var singleSelection = selectedWidgets.length < 2; // Not a group selection
            var childElement = this.$el.find(event.target).length > 0; // An actual editable element and not the expanded border
            var modifierKeyDown = event.shiftKey || event.ctrlKey || event.metaKey; // Same keys as in FreeTransform.js#down

            if (childElement && singleSelection && !modifierKeyDown) {
                // Stop propagation if trying to edit or select content
                // otherwise it will drag the widget when making text selection.
                event.stopPropagation();
                this.enableEditable();
            } else {
                // If group selection or clicked outside of the editable elements disable editable
                // so the active state only is selected but not editable
                this.disableEditable();
            }

            if (singleSelection) {
                if (modifierKeyDown) {
                    // If shift is down the user is trying to multi select the widget
                    // add this widget to the widget selection
                    var newSelectedWidgets = _.uniq([this.options.textWidgetView].concat(selectedWidgets));
                    this.options.viewModel.selection.select(newSelectedWidgets);
                } else {
                    this.options.viewModel.selection.select([this.options.textWidgetView]);
                }
            }

            // Remove any fake highlight if there is any
            this._removeFakeHighlight();
            this.isDownInEditor = true;
        },


        /**
         * Handles mouseup events dispatched from the body node.
         * @param  {MouseEvent} event The mouse event instance.
         * @private
         */
        _mouseUpHandler: function _mouseUpHandler(event) {
            this.isDownInEditor = false;
            this.trigger(MOUSEUP, event);
        },


        /**
         * Handles the event when mousedown happens inside the editor but mouseup release outside the editor.
         *
         * @see bug report MOS-1819
         * @private
         */
        _bodyMouseUpHandler: function _bodyMouseUpHandler() {
            if (this.isDownInEditor) {
                this._mouseUpHandler(event);
                this.isDownInEditor = false;
            }
        },


        /**
         * Handles key down events. If we don't stop propagation, it will trigger the parents key down events,
         * which will for example move the widget
         *
         * @param {keyEvent} event
         * @private
         */
        _keyDownHandler: function _keyDownHandler(event) {
            if (event.keyCode === KeyCode.RETURN) {
                this.trigger("newParagraph");
            }

            if (this.isEditable && stopPropagationOfKeys.indexOf(event.keyCode) !== -1) {
                event.stopPropagation();
            }

            if (event.ctrlKey && event.key) {
                if (event.key.toLowerCase() === KEY_Z || event.key.toLowerCase() === KEY_Y) {
                    // bypass check for fake highlighting already presenting, as during undo the fake highlighting spans will have been re-added without a check for hasFakeHighlight
                    this._ckEditor.removeFakeHighlight();
                }
            }

            if (!event.shiftKey) {
                // remove highlight
                this._removeFakeHighlight();
            }
        },


        /**
         * Handles key up events
         * @param {keyEvent} event
         * @private
         */
        _keyUpHandler: function _keyUpHandler(event) {
            var isArrowKey = _.contains(arrowKeys, event.keyCode);

            if (isArrowKey) {
                this.trigger("arrowKeyUp", event);
            }
        },


        /**
         * Throttled, see #initialize
         * @private
         */
        _contentChangeHandler: function _contentChangeHandler() {
            this.trigger("contentChange");
        },
        _onBlurHandler: function _onBlurHandler(event) {
            this.trigger("editorBlur", event);
        },


        /**
         * Apply style to the current text selection
         *
         * @param {Object} changed   The changed properties
         * @param {Editor} model     The editor model
         */
        applyStyle: function applyStyle(changed, model) {
            var _this = this;

            var prop = void 0;
            var nodeName = void 0;

            if (!this.isEditable) {
                return;
            }

            // The change of font family should always be accompanied with a provider, and possibly meta
            // data, so we put it into one object.
            if (changed.fontFamily) {
                changed = TextEditorViewHelpers.prepareFontFamily(changed, model, WebFontsUtil.getCssFontFamily(model));
            }

            _.each(changed, function (value, property) {
                if (property === "nodeName") {
                    nodeName = value || TextEditorConstants.TAGS.DIV;
                    _this._ckEditor.applyStyle({ nodeName: nodeName, disableFallbackStyles: true });
                } else {
                    prop = dasherize(property);
                    if (_.contains(TextEditorConstants.INLINE_STYLES, prop)) {
                        nodeName = TextEditorConstants.TAGS.SPAN;
                    } else {
                        nodeName = model.has("nodeName") ? model.get("nodeName") : TextEditorConstants.TAGS.DIV;
                    }

                    _this._ckEditor.applyStyle({ property: prop, value: value, nodeName: nodeName });
                }
            });
        },
        removeStyle: function removeStyle(properties) {
            if (properties.nodeName) {
                delete properties.nodeName;
            }
            properties.forEach(this._ckEditor.removeStyle.bind(this._ckEditor));
        },


        /**
         * _setIsEditable Toggle the editable state of the editor.
         *
         * See `setIsEditable` in CkeditorFacade.js
         *
         * @param {Boolean} isEditable
         */
        _setIsEditable: function _setIsEditable(isEditable) {
            Preconditions.isBoolean(isEditable);

            if (!isEditable) {
                this._removeFakeHighlight();
                this._ckEditor.deselectAll();
            }

            this.isEditable = isEditable;
            this._ckEditor.setIsEditable(isEditable);
        },


        /**
         * Enable the editable state, skip if it is already editable
         */
        enableEditable: function enableEditable() {
            if (this.isEditable || !this._ckEditor) {
                return;
            }

            this._setIsEditable(true);

            // Bizarre FF and IE hack. it seems like the first focus will not make the cursor show up.
            if (Browser.type.firefox || Browser.type.ie) {
                this.$el.blur().focus();
            }
        },


        /**
         * Disable the editable state
         */
        disableEditable: function disableEditable() {
            this._setIsEditable(false);
        },


        /**
         * Get the CSS style values for the current cursor/selection in the editor to update the property view.
         * Note: The selection can contain one DOM node or several nodes.
         *
         * @param {Object} properties    The style names that needs for values
         * @returns {*}
         */
        getCss: function getCss(properties) {
            var _this2 = this;

            var elements = void 0;
            var highlightedElements = void 0;
            var result = void 0;
            var computedStyles = void 0;

            /**
             *  Defining which elements from which we need to extract the css.
             *
             *  If the widget is not in an editable state, we will run through
             *  every single element in the widget.
             *
             *  Otherwise we find the elements within the selection, or the
             *  single element that the cursor is touching.
             */
            if (!this.isEditable) {
                elements = DomHandler.getTextNodeParentList([this.$el[0]]);
            } else {
                highlightedElements = this._ckEditor.getSelectedElement();
                elements = DomHandler.getTextNodeParentList(highlightedElements);
            }

            // filter out elements that have been removed from the DOM.
            elements = elements.filter(function (element) {
                return element && _this2.$el.find(element).length > 0;
            });

            /**
             * We begin by getting the font data. The font data consists of a
             * fontFamily (which is not always the same as the css font family
             * name), a fontProvider, and possibly some fontMetadata (which
             * include the cssFamilyNames).
             */
            result = TextEditorViewHelpers.getFontData(elements, this.el);
            properties = _.without(properties, "fontFamily");
            computedStyles = elements.map(Browser.computedStyle);

            return TextEditorViewHelpers.getCssValuesFromElements(result, properties, computedStyles);
        },
        getNodeName: function getNodeName() {
            var _this3 = this;

            var elements = void 0;
            var allEqual = false;

            if (!this.isEditable) {
                elements = DomHandler.getTextNodeParentList([this.$el[0]]);
            } else {
                var highlightedElements = this._ckEditor.getSelectedElement();

                // filter out elements that have been removed from the DOM.
                elements = DomHandler.getTextNodeParentList(highlightedElements).filter(function (element) {
                    return element && _this3.$el.find(element).length > 0;
                });
            }

            if (elements.length > 0) {
                allEqual = elements.every(function (val, i, arr) {
                    return val.nodeName === arr[0].nodeName;
                });
            }

            if (elements.length === 1 || allEqual) {
                var node = this._findValidBlockElement(elements[0]);
                return node.nodeName.toLowerCase();
            }

            return null;
        },
        _findValidBlockElement: function _findValidBlockElement(el) {
            if (el.nodeType === 3 || el.nodeName.toLowerCase() === TextEditorConstants.TAGS.SPAN) {
                return this._findValidBlockElement(el.parentNode);
            }

            return el;
        },


        /**
         * We only apply the style to the selection when it is in editable mode
         * And we don't apply style to empty selection, otherwise we end up with tons of empty span tags
         *
         * @returns {boolean|String|*}
         * @private
         */
        _canApplyStyle: function _canApplyStyle() {
            return this.isEditable && this._ckEditor.getSelectedText();
        },


        // apply fake highlight to the selection
        applyFakeHighlight: function applyFakeHighlight() {
            if (this._canApplyStyle() && !this.hasFakeHighlight) {
                this._ckEditor.applyFakeHighlight();
                this.hasFakeHighlight = true;
            }
        },


        /**
         * Remove fake highlight
         */
        _removeFakeHighlight: function _removeFakeHighlight() {
            if (this.hasFakeHighlight) {
                this._ckEditor.removeFakeHighlight();
                this.hasFakeHighlight = false;
            }
        },


        /**
         * Returns the Html content the Text Widget.
         * Highlighting and unused tags are stripped out.
         *
         * @returns {String} Content of Text Widget
         */
        getContent: function getContent() {
            // make a copy of the $el in a div container
            var $editorElCopy = $("<div></div>").append(this.$el.html());

            var $highlightSpans = $editorElCopy.find("." + TextEditorConstants.HIGH_LIGHT_CLASS);

            // remove highlighted tags
            $highlightSpans.each(function (i, highlightSpanEl) {
                highlightSpanEl.outerHTML = highlightSpanEl.innerHTML;
            });

            this._removeRedundantStyles($editorElCopy.get(0));
            this._removeEmptySpans($editorElCopy);

            return isBlank($editorElCopy.text()) ? "" : this._stripHtmlComments($editorElCopy.html());
        },


        /**
         * Traverses down a given tree removes redundant style definitions.
         * @param {HTMLElement} parentElement
         */
        _removeRedundantStyles: function _removeRedundantStyles(parentElement) {
            var _this4 = this;

            $(parentElement).children().each(function (i, childElement) {
                if (childElement.tagName.toUpperCase() === "SPAN") {
                    for (var _i = 0; _i < childElement.style.length; _i++) {
                        var propertyName = childElement.style[_i];
                        // need to element.style[propertyName] as jQuery's $element.css(propertyName) takes the parent element property in Firefox if a child definition for that object isn't available.
                        if (childElement.style[propertyName] === parentElement.style[propertyName]) {
                            childElement.style[propertyName] = "";
                        }
                    }
                }
                _this4._removeRedundantStyles(childElement);
            });
        },
        _removeEmptySpans: function _removeEmptySpans($parentElement) {
            $parentElement.find("span").each(function (i, spanEl) {
                if (_.isUndefined(spanEl.innerText)) {
                    // the SPAN HTMLElement object still exists, but it's already been removed from the DOM (so `innerText` is undefined)
                    return;
                }

                // Remove any zero width space characters; these can break the layout.
                if (spanEl.innerText.match(/\u200B/)) {
                    spanEl.innerText = spanEl.innerText.replace(/\u200B/g, "");
                }

                if (spanEl.innerText === "") {
                    // remove empty span
                    $(spanEl).remove();
                    return;
                }

                // remove unstyled spans
                if (!spanEl.hasAttribute("style") || spanEl.style.length === 0 || spanEl.hasAttribute("data-font-family") && !spanEl.style.fontFamily) {
                    spanEl.outerHTML = spanEl.innerHTML;
                }
            });
        },


        /**
         * Takes a string (of html), and strips out html type comments.
         *
         * CKEditor sometimes (on windows only) inserts huge comment blocks
         * when pasting formatted text from emails or word. There is no reason
         * for us to save this in the backend.
         *
         * @private
         * @param {String} str  - The string with comment blocks.
         * @return {String}     - The filtered string.
         */
        _stripHtmlComments: function _stripHtmlComments(str) {
            return str.replace(/<!--[\s\S]*?-->/g, "");
        },
        parseFont: function parseFont(elements) {
            return TextEditorViewHelpers.parseFont(elements, this.$el.parent().get(0));
        },
        editAllText: function editAllText() {
            this._ckEditor.selectAll();
            this.enableEditable();
        },
        onClose: function onClose() {
            $body.off(MOUSEUP, this._bodyMouseUpHandler);
            this._ckEditor.close();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);

    var _require = __webpack_require__(1),
        defer = _require.defer,
        compose = _require.compose,
        map = _require.map,
        flatten = _require.flatten;

    var Browser = __webpack_require__(39);
    var Ckeditor = __webpack_require__(3000);
    var CkeditorPatcher = __webpack_require__(3001);
    var Constants = __webpack_require__(409);
    var DomHandler = __webpack_require__(470);
    var Marionette = __webpack_require__(10);
    var Preconditions = __webpack_require__(14);

    var _require2 = __webpack_require__(30),
        camelize = _require2.camelize;

    var flatMap = compose(flatten, map);

    var TAGS = Constants.TAGS,
        HEADINGS = Constants.HEADINGS,
        BLOCK_STYLES = Constants.BLOCK_STYLES,
        INLINE_STYLES = Constants.INLINE_STYLES,
        INLINE_ATTRIBUTES = Constants.INLINE_ATTRIBUTES;


    var HIGH_LIGHT = new Ckeditor.style({
        element: TAGS.SPAN,
        attributes: { "class": Constants.HIGH_LIGHT_CLASS }
    });

    CkeditorPatcher.patch(Ckeditor);

    /**
     * Helper function to quick extract the needed css styles
     */
    function getCurrentDivCss(editor) {
        var el = editor.elementPath().contains(function (element) {
            return element.is("div");
        });

        return BLOCK_STYLES.reduce(function (css, property) {
            var camelProperty = camelize(property);

            if (el.$.style[camelProperty]) {
                css[property] = el.$.style[camelProperty];
            }

            return css;
        }, {});
    }

    function getCssValueFromData(_ref) {
        var property = _ref.property,
            value = _ref.value;

        switch (property) {
            case "font-family":
                return value.cssFamilyNames;

            case "letter-spacing":
            case "font-size":
                return value + "px";

            default:
                return value;
        }
    }

    function getFontAttributesFromData(_ref2) {
        var value = _ref2.value;

        var attributes = {
            "data-font-family": value.fontFamily,
            "data-font-provider": value.fontProvider
        };

        var meta = value.meta;


        if (meta && meta.kitID) {
            attributes["data-kitid"] = meta.kitID;
        }

        if (meta && meta.projectId) {
            attributes["data-projectid"] = meta.projectId;
        }

        if (meta) {
            var path = meta.path,
                customFontId = meta.customFontId,
                format = meta.format;


            if (path && customFontId && format) {
                attributes["data-path"] = path;
                attributes["data-customfontid"] = customFontId;
                attributes["data-format"] = format;
            }
        }

        return attributes;
    }

    /**
     * Configuration of CKEditor.
     */

    // Avoid automatic instantiation. We do it manually on click.
    Ckeditor.disableAutoInline = true;

    // Disable spell check, otherwise IE consumes lots of memory. see bug MOS-2185
    if (Browser.type.ie) {
        Ckeditor.config.disableNativeSpellChecker = true;
    }

    // Tell CKEditor that it has an extra plugin to load. This in itself does
    // not do anything, but without it, CK will ignore the later added plugin.
    Ckeditor.config.extraPlugins = Constants.ADDSTYLE;

    Ckeditor.config.title = false;
    // We use <div> as breaks (p tags are default) to avoid any potential
    // problems with p's default css margins.
    Ckeditor.config.enterMode = Ckeditor.ENTER_DIV;

    // Prevent filler nodes in all empty blocks. See:
    // http://docs.ckeditor.com/#!/api/CKEDITOR.config-cfg-skin
    Ckeditor.config.fillEmptyBlocks = false;

    // Avoids odd pastes from other programs.
    Ckeditor.config.forcePasteAsPlainText = true;

    // Don't load the external config.js file.
    Ckeditor.config.customConfig = false;

    // Don't load the stylesheet (we completely removed the interface).
    Ckeditor.config.stylesSet = false;

    // This is mostly for preventing loading external files (which will break
    // when compiled).
    Ckeditor.config.defaultLanguage = "en";
    Ckeditor.config.language = "en";
    // This is normally an object full of all translations, but without an
    // interface, we can get away with no translations).
    Ckeditor.lang.en = { clipboard: {} };

    // Everything that isn't included here will be stripped away when trying to
    // save or loading the editor. See:
    // http://docs.ckeditor.com/#!/guide/dev_allowed_content_rules-section-string-format
    Ckeditor.config.allowedContent = {};
    Ckeditor.config.allowedContent[TAGS.DIV] = { styles: BLOCK_STYLES.toString() };
    Ckeditor.config.allowedContent[TAGS.SPAN] = {
        attributes: INLINE_ATTRIBUTES.toString(),
        styles: INLINE_STYLES.toString()
    };
    HEADINGS.forEach(function (heading) {
        Ckeditor.config.allowedContent[heading] = Ckeditor.config.allowedContent[TAGS.DIV];
    });

    /**
     * Used by CKEditor to add new styles to the selection.
     *
     * @param {Ckeditor} editor The editor in question.
     * @param {Object} data Object containing css information.
     */
    function addStyle(editor, data) {
        // Make properties for the editor
        var properties = {
            element: data.nodeName,
            styles: !data.disableFallbackStyles && data.nodeName === TAGS.DIV ? getCurrentDivCss(editor) : {}
        };

        if (data.property) {
            properties.styles[data.property] = getCssValueFromData(data);

            if (data.property === "font-family") {
                properties.attributes = getFontAttributesFromData(data);
            }
        }

        // Apply the styles.
        editor.applyStyle(new Ckeditor.style(properties));
    }

    // Telling CKEditor to use the above function.
    Ckeditor.plugins.add(Constants.ADDSTYLE, {
        init: function init(editor) {
            editor.addCommand(Constants.ADDSTYLE, { exec: addStyle });
        }
    });

    return Marionette.Controller.extend({

        /**
         *  Raw dom element
         */
        el: null,

        /**
         * jQuery version
         */
        $el: null,

        /**
         * The instance of the editor returned by CKEditor.
         */
        _ck: null,

        elementSize: null,

        isFocused: false,

        initialize: function initialize($el) {
            this.el = $el.get(0);
            this.$el = $el;
            this._ck = Ckeditor.inline(this.el);

            var changeHandler = this._changeHandler.bind(this);
            this._ck.on("focus", this._focusHandler.bind(this));
            this._ck.on("blur", this._blurHandler.bind(this));
            this._ck.on("change", changeHandler);
            this._ck.on("paste", changeHandler);
            this._ck.on("readOnly", this._readOnlyHandler.bind(this));
        },
        _changeHandler: function _changeHandler(evt) {
            var nextSize = this.el.getBoundingClientRect();
            var heightDelta = nextSize.height - this.elementSize.height;
            if (heightDelta > 0) {
                var tinyscrollbar = $(".viewport").data("tinyscrollbar");
                tinyscrollbar.y.update().scrollTo("offset", heightDelta * -1, true, true);
            }
            this.elementSize = nextSize;
            // We need to remove the Zero-Width space to not store them into the database.
            if (evt.data) {
                evt.data.dataValue = evt.data.dataValue.replace(/\u200B/g, "");
            }

            this.triggerChange();
        },
        _focusHandler: function _focusHandler() {
            this.elementSize = this.el.getBoundingClientRect();
            if (!this.isFocused) {
                var tinyscrollbar = $(".viewport").data("tinyscrollbar");
                tinyscrollbar.y.update().scrollTo("visible", this.elementSize.bottom, true, true);

                this.isFocused = true;
            }
        },
        _blurHandler: function _blurHandler() {
            this.isFocused = false;
        },
        _readOnlyHandler: function _readOnlyHandler(evt) {
            if (evt.editor.readOnly) {
                // editor gets into read-only state, which means it has been editable until just now
                // lets propagate only this state as it is the only state we are interested so far
                this.trigger("readOnly");
            }
        },
        triggerChange: function triggerChange() {
            var _this = this;

            defer(function () {
                return _this.trigger("change");
            });
        },


        /**
         * Applies the passed in style directly to the selection of the edited
         * text.
         *
         * @param {Object} data - Object containing information about the style
         *                        being applied, such as property, value, and
         *                        nodeName. In the case of applying a font
         *                        family, it is assumed that fontProvider, and
         *                        possible fontMetadata is present.
         *
         *  Examples.
         *
         *      applyStyle({
         *          property: "color",
         *          value: "#ffff00",
         *          nodeName: "span"
         *      });
         *
         *
         *      applyStyle({
         *          property: "font-family",
         *          value: {
         *              fontFamily: "Proxima Nova",
         *              cssFamilyNames: "proximia-nova",
         *              fontProvider: "typekit",
         *              meta: {
         *                  kitID: "xxxxxx"
         *              }
         *          },
         *          nodeTyle: "span"
         *      });
         */
        applyStyle: function applyStyle(data) {
            this._ck.getCommand(Constants.ADDSTYLE).setState(Ckeditor.TRISTATE_ON);

            // It seems the below "command" (execCommand(Constants.ADDSTYLE, data)) will make CKEditor
            // steal the current focus - this is not ideal if, for say, we're currently setting the
            // text color in the widget properties panel from within an input element. Therefore, let's
            // make sure to restore focus.
            var currentFocusInputElement = document.activeElement instanceof HTMLInputElement ? document.activeElement : null;

            // This will sometimes fail due to a browser bug in Chrome. The
            // error happens deep within CKEditor, so for now, we opt to go for
            // just catching the error, log it, and continue excecution.
            // The bug does not break anything.
            // See first comment in http://jira.zmags.com/browse/MOS-1445
            try {
                // TODO: This will steal the current focus - is there an official way to avoid that without a hack?
                this._ck.execCommand(Constants.ADDSTYLE, data);
            } catch (error) {
                Preconditions.fail("CKEditor error: " + error.toString());
            }

            // Restore focus if needed...
            if (currentFocusInputElement) {
                currentFocusInputElement.focus();
            }

            this._ck.getCommand(Constants.ADDSTYLE).setState(Ckeditor.TRISTATE_OFF);

            this.triggerChange();
        },


        /**
         * Similar to `applyStyle`, only that it removes the style from the
         * selection (and all children).
         *
         * @param {Object} style - Css properties and attributes that will be
         *                         removed from the elements.
         */
        removeStyle: function removeStyle(style) {
            DomHandler.removeStyle(this.$el, style);
            this.triggerChange();
        },


        /**
         * Adds the blue highlighting of the text. This is used, so
         * even when picking properties on the right, we maintain the selection
         * visually.
         */
        applyFakeHighlight: function applyFakeHighlight() {
            this._ck.applyStyle(HIGH_LIGHT);
        },
        removeFakeHighlight: function removeFakeHighlight() {
            this._ck.removeStyle(HIGH_LIGHT);
        },
        selectAll: function selectAll() {
            var _this2 = this;

            defer(function () {
                _this2._ck.element.focus();
                var selection = _this2._ck.getSelection();
                selection.selectElement(_this2._ck.element);

                var range = _this2._ck.createRange();
                range.moveToElementEditStart(range.root);
                range.selectNodeContents(_this2._ck.element);

                selection.selectRanges([range]);
            });
        },
        deselectAll: function deselectAll() {
            var selection = this._ck.getSelection();
            selection.removeAllRanges();
        },
        getSelectedElement: function getSelectedElement() {
            var ranges = this._ck.getSelection().getRanges();

            return flatMap(ranges, function (range) {
                var startNode = range.startContainer.$;
                var endNode = range.endContainer.$;
                var commonAncestor = range.getCommonAncestor() && range.getCommonAncestor().$;

                return DomHandler.getElementsBetweenNodes(startNode, endNode, commonAncestor);
            });
        },


        /**
         * setIsEditable. Toggles the editable state of the editor. If this is
         * set to `false`, then applying or removing styles, as well as adding
         * or removing fake highlighting won't have any effect.
         *
         * @param {Boolean} isEditable - true: Editing enabled.
         *                               false: Editing impossible.
         */
        setIsEditable: function setIsEditable(isEditable) {
            this._ck.setReadOnly(!isEditable);
        },


        /**
         * getSelectedText - Returns the selected text.
         *
         * @return {String} - The selected text.
         */
        getSelectedText: function getSelectedText() {
            var selection = this._ck.getSelection();

            return selection && selection.getSelectedText();
        },


        /**
         * getSpanTouchingCursor. Returns the element closest to the cursor in
         * the editor. If there is no cursor, but rather a selection, it will
         * return the element nearest to the beginning of the selection.
         *
         * @return {HTMLElement}
         */
        getElementTouchingCursor: function getElementTouchingCursor() {
            var elementPath = this._ck.elementPath();

            return elementPath ? elementPath.elements[0].$ : null;
        },
        onClose: function onClose() {
            // We need defer here because CKEditor has a timeout call when it initializes an editor instance.
            // If initialization happens very fast like changing scene size, then we may end up having some
            // uninitialized object and calling methods against that object will throw errors. See the bug MOS-1821.
            defer(this._ck.destroy.bind(this._ck));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3000 */
/***/ (function(module, exports) {

/*
Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
For licensing, see LICENSE.md or http://ckeditor.com/license
*/
(function(){if(window.CKEDITOR&&window.CKEDITOR.dom)return;window.CKEDITOR||(window.CKEDITOR=function(){var a=/(^|.*[\\\/])ckeditor\.js(?:\?.*|;.*)?$/i,d={timestamp:"F7J9",version:"4.5.3",revision:"6c70c82",rnd:Math.floor(900*Math.random())+100,_:{pending:[],basePathSrcPattern:a},status:"unloaded",basePath:function(){var b=window.CKEDITOR_BASEPATH||"";if(!b)for(var c=document.getElementsByTagName("script"),d=0;d<c.length;d++){var i=c[d].src.match(a);if(i){b=i[1];break}}-1==b.indexOf(":/")&&"//"!=b.slice(0,2)&&(b=0===b.indexOf("/")?location.href.match(/^.*?:\/\/[^\/]*/)[0]+
b:location.href.match(/^[^\?]*\/(?:)/)[0]+b);if(!b)throw'The CKEditor installation path could not be automatically detected. Please set the global variable "CKEDITOR_BASEPATH" before creating editor instances.';return b}(),getUrl:function(a){-1==a.indexOf(":/")&&0!==a.indexOf("/")&&(a=this.basePath+a);this.timestamp&&("/"!=a.charAt(a.length-1)&&!/[&?]t=/.test(a))&&(a+=(0<=a.indexOf("?")?"&":"?")+"t="+this.timestamp);return a},domReady:function(){function a(){try{document.addEventListener?(document.removeEventListener("DOMContentLoaded",
a,!1),b()):document.attachEvent&&"complete"===document.readyState&&(document.detachEvent("onreadystatechange",a),b())}catch(c){}}function b(){for(var a;a=c.shift();)a()}var c=[];return function(b){function d(){try{document.documentElement.doScroll("left")}catch(g){setTimeout(d,1);return}a()}c.push(b);"complete"===document.readyState&&setTimeout(a,1);if(1==c.length)if(document.addEventListener)document.addEventListener("DOMContentLoaded",a,!1),window.addEventListener("load",a,!1);else if(document.attachEvent){document.attachEvent("onreadystatechange",
a);window.attachEvent("onload",a);b=!1;try{b=!window.frameElement}catch(n){}document.documentElement.doScroll&&b&&d()}}}()},b=window.CKEDITOR_GETURL;if(b){var c=d.getUrl;d.getUrl=function(a){return b.call(d,a)||c.call(d,a)}}return d}());
CKEDITOR.event||(CKEDITOR.event=function(){},CKEDITOR.event.implementOn=function(a){var d=CKEDITOR.event.prototype,b;for(b in d)a[b]==null&&(a[b]=d[b])},CKEDITOR.event.prototype=function(){function a(a){var e=d(this);return e[a]||(e[a]=new b(a))}var d=function(a){a=a.getPrivate&&a.getPrivate()||a._||(a._={});return a.events||(a.events={})},b=function(a){this.name=a;this.listeners=[]};b.prototype={getListenerIndex:function(a){for(var b=0,d=this.listeners;b<d.length;b++)if(d[b].fn==a)return b;return-1}};
return{define:function(b,d){var f=a.call(this,b);CKEDITOR.tools.extend(f,d,true)},on:function(b,d,f,h,i){function j(a,g,A,i){a={name:b,sender:this,editor:a,data:g,listenerData:h,stop:A,cancel:i,removeListener:n};return d.call(f,a)===false?false:a.data}function n(){A.removeListener(b,d)}var g=a.call(this,b);if(g.getListenerIndex(d)<0){g=g.listeners;f||(f=this);isNaN(i)&&(i=10);var A=this;j.fn=d;j.priority=i;for(var r=g.length-1;r>=0;r--)if(g[r].priority<=i){g.splice(r+1,0,j);return{removeListener:n}}g.unshift(j)}return{removeListener:n}},
once:function(){var a=Array.prototype.slice.call(arguments),b=a[1];a[1]=function(a){a.removeListener();return b.apply(this,arguments)};return this.on.apply(this,a)},capture:function(){CKEDITOR.event.useCapture=1;var a=this.on.apply(this,arguments);CKEDITOR.event.useCapture=0;return a},fire:function(){var a=0,b=function(){a=1},f=0,h=function(){f=1};return function(i,j,n){var g=d(this)[i],i=a,A=f;a=f=0;if(g){var r=g.listeners;if(r.length)for(var r=r.slice(0),y,o=0;o<r.length;o++){if(g.errorProof)try{y=
r[o].call(this,n,j,b,h)}catch(q){}else y=r[o].call(this,n,j,b,h);y===false?f=1:typeof y!="undefined"&&(j=y);if(a||f)break}}j=f?false:typeof j=="undefined"?true:j;a=i;f=A;return j}}(),fireOnce:function(a,b,f){b=this.fire(a,b,f);delete d(this)[a];return b},removeListener:function(a,b){var f=d(this)[a];if(f){var h=f.getListenerIndex(b);h>=0&&f.listeners.splice(h,1)}},removeAllListeners:function(){var a=d(this),b;for(b in a)delete a[b]},hasListeners:function(a){return(a=d(this)[a])&&a.listeners.length>
0}}}());CKEDITOR.editor||(CKEDITOR.editor=function(){CKEDITOR._.pending.push([this,arguments]);CKEDITOR.event.call(this)},CKEDITOR.editor.prototype.fire=function(a,d){a in{instanceReady:1,loaded:1}&&(this[a]=true);return CKEDITOR.event.prototype.fire.call(this,a,d,this)},CKEDITOR.editor.prototype.fireOnce=function(a,d){a in{instanceReady:1,loaded:1}&&(this[a]=true);return CKEDITOR.event.prototype.fireOnce.call(this,a,d,this)},CKEDITOR.event.implementOn(CKEDITOR.editor.prototype));
CKEDITOR.env||(CKEDITOR.env=function(){var a=navigator.userAgent.toLowerCase(),d=a.match(/edge[ \/](\d+.?\d*)/),b=a.indexOf("trident/")>-1,b=!(!d&&!b),b={ie:b,edge:!!d,webkit:!b&&a.indexOf(" applewebkit/")>-1,air:a.indexOf(" adobeair/")>-1,mac:a.indexOf("macintosh")>-1,quirks:document.compatMode=="BackCompat"&&(!document.documentMode||document.documentMode<10),mobile:a.indexOf("mobile")>-1,iOS:/(ipad|iphone|ipod)/.test(a),isCustomDomain:function(){if(!this.ie)return false;var a=document.domain,b=
window.location.hostname;return a!=b&&a!="["+b+"]"},secure:location.protocol=="https:"};b.gecko=navigator.product=="Gecko"&&!b.webkit&&!b.ie;if(b.webkit)a.indexOf("chrome")>-1?b.chrome=true:b.safari=true;var c=0;if(b.ie){c=d?parseFloat(d[1]):b.quirks||!document.documentMode?parseFloat(a.match(/msie (\d+)/)[1]):document.documentMode;b.ie9Compat=c==9;b.ie8Compat=c==8;b.ie7Compat=c==7;b.ie6Compat=c<7||b.quirks}if(b.gecko)if(d=a.match(/rv:([\d\.]+)/)){d=d[1].split(".");c=d[0]*1E4+(d[1]||0)*100+(d[2]||
0)*1}b.air&&(c=parseFloat(a.match(/ adobeair\/(\d+)/)[1]));b.webkit&&(c=parseFloat(a.match(/ applewebkit\/(\d+)/)[1]));b.version=c;b.isCompatible=!(b.ie&&c<7)&&!(b.gecko&&c<4E4)&&!(b.webkit&&c<534);b.hidpi=window.devicePixelRatio>=2;b.needsBrFiller=b.gecko||b.webkit||b.ie&&c>10;b.needsNbspFiller=b.ie&&c<11;b.cssClass="cke_browser_"+(b.ie?"ie":b.gecko?"gecko":b.webkit?"webkit":"unknown");if(b.quirks)b.cssClass=b.cssClass+" cke_browser_quirks";if(b.ie)b.cssClass=b.cssClass+(" cke_browser_ie"+(b.quirks?
"6 cke_browser_iequirks":b.version));if(b.air)b.cssClass=b.cssClass+" cke_browser_air";if(b.iOS)b.cssClass=b.cssClass+" cke_browser_ios";if(b.hidpi)b.cssClass=b.cssClass+" cke_hidpi";return b}());
"unloaded"==CKEDITOR.status&&function(){CKEDITOR.event.implementOn(CKEDITOR);CKEDITOR.loadFullCore=function(){if(CKEDITOR.status!="basic_ready")CKEDITOR.loadFullCore._load=1;else{delete CKEDITOR.loadFullCore;var a=document.createElement("script");a.type="text/javascript";a.src=CKEDITOR.basePath+"ckeditor.js";document.getElementsByTagName("head")[0].appendChild(a)}};CKEDITOR.loadFullCoreTimeout=0;CKEDITOR.add=function(a){(this._.pending||(this._.pending=[])).push(a)};(function(){CKEDITOR.domReady(function(){var a=
CKEDITOR.loadFullCore,d=CKEDITOR.loadFullCoreTimeout;if(a){CKEDITOR.status="basic_ready";a&&a._load?a():d&&setTimeout(function(){CKEDITOR.loadFullCore&&CKEDITOR.loadFullCore()},d*1E3)}})})();CKEDITOR.status="basic_loaded"}();CKEDITOR.dom={};
(function(){var a=[],d=CKEDITOR.env.gecko?"-moz-":CKEDITOR.env.webkit?"-webkit-":CKEDITOR.env.ie?"-ms-":"",b=/&/g,c=/>/g,e=/</g,f=/"/g,h=/&(lt|gt|amp|quot|nbsp|shy|#\d{1,5});/g,i={lt:"<",gt:">",amp:"&",quot:'"',nbsp:" ",shy:"­"},j=function(a,g){return g[0]=="#"?String.fromCharCode(parseInt(g.slice(1),10)):i[g]};CKEDITOR.on("reset",function(){a=[]});CKEDITOR.tools={arrayCompare:function(a,g){if(!a&&!g)return true;if(!a||!g||a.length!=g.length)return false;for(var b=0;b<a.length;b++)if(a[b]!=g[b])return false;
return true},getIndex:function(a,g){for(var b=0;b<a.length;++b)if(g(a[b]))return b;return-1},clone:function(a){var g;if(a&&a instanceof Array){g=[];for(var b=0;b<a.length;b++)g[b]=CKEDITOR.tools.clone(a[b]);return g}if(a===null||typeof a!="object"||a instanceof String||a instanceof Number||a instanceof Boolean||a instanceof Date||a instanceof RegExp||a.nodeType||a.window===a)return a;g=new a.constructor;for(b in a)g[b]=CKEDITOR.tools.clone(a[b]);return g},capitalize:function(a,g){return a.charAt(0).toUpperCase()+
(g?a.slice(1):a.slice(1).toLowerCase())},extend:function(a){var g=arguments.length,b,c;if(typeof(b=arguments[g-1])=="boolean")g--;else if(typeof(b=arguments[g-2])=="boolean"){c=arguments[g-1];g=g-2}for(var i=1;i<g;i++){var o=arguments[i],d;for(d in o)if(b===true||a[d]==null)if(!c||d in c)a[d]=o[d]}return a},prototypedCopy:function(a){var g=function(){};g.prototype=a;return new g},copy:function(a){var g={},b;for(b in a)g[b]=a[b];return g},isArray:function(a){return Object.prototype.toString.call(a)==
"[object Array]"},isEmpty:function(a){for(var g in a)if(a.hasOwnProperty(g))return false;return true},cssVendorPrefix:function(a,g,b){if(b)return d+a+":"+g+";"+a+":"+g;b={};b[a]=g;b[d+a]=g;return b},cssStyleToDomStyle:function(){var a=document.createElement("div").style,g=typeof a.cssFloat!="undefined"?"cssFloat":typeof a.styleFloat!="undefined"?"styleFloat":"float";return function(a){return a=="float"?g:a.replace(/-./g,function(a){return a.substr(1).toUpperCase()})}}(),buildStyleHtml:function(a){for(var a=
[].concat(a),g,b=[],c=0;c<a.length;c++)if(g=a[c])/@import|[{}]/.test(g)?b.push("<style>"+g+"</style>"):b.push('<link type="text/css" rel=stylesheet href="'+g+'">');return b.join("")},htmlEncode:function(a){return a===void 0||a===null?"":(""+a).replace(b,"&amp;").replace(c,"&gt;").replace(e,"&lt;")},htmlDecode:function(a){return a.replace(h,j)},htmlEncodeAttr:function(a){return CKEDITOR.tools.htmlEncode(a).replace(f,"&quot;")},htmlDecodeAttr:function(a){return CKEDITOR.tools.htmlDecode(a)},transformPlainTextToHtml:function(a,
g){var b=g==CKEDITOR.ENTER_BR,c=this.htmlEncode(a.replace(/\r\n/g,"\n")),c=c.replace(/\t/g,"&nbsp;&nbsp; &nbsp;"),i=g==CKEDITOR.ENTER_P?"p":"div";if(!b){var o=/\n{2}/g;if(o.test(c))var d="<"+i+">",j="</"+i+">",c=d+c.replace(o,function(){return j+d})+j}c=c.replace(/\n/g,"<br>");b||(c=c.replace(RegExp("<br>(?=</"+i+">)"),function(a){return CKEDITOR.tools.repeat(a,2)}));c=c.replace(/^ | $/g,"&nbsp;");return c=c.replace(/(>|\s) /g,function(a,g){return g+"&nbsp;"}).replace(/ (?=<)/g,"&nbsp;")},getNextNumber:function(){var a=
0;return function(){return++a}}(),getNextId:function(){return"cke_"+this.getNextNumber()},getUniqueId:function(){for(var a="e",g=0;g<8;g++)a=a+Math.floor((1+Math.random())*65536).toString(16).substring(1);return a},override:function(a,g){var b=g(a);b.prototype=a.prototype;return b},setTimeout:function(a,g,b,c,i){i||(i=window);b||(b=i);return i.setTimeout(function(){c?a.apply(b,[].concat(c)):a.apply(b)},g||0)},trim:function(){var a=/(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g;return function(g){return g.replace(a,
"")}}(),ltrim:function(){var a=/^[ \t\n\r]+/g;return function(g){return g.replace(a,"")}}(),rtrim:function(){var a=/[ \t\n\r]+$/g;return function(g){return g.replace(a,"")}}(),indexOf:function(a,g){if(typeof g=="function")for(var b=0,c=a.length;b<c;b++){if(g(a[b]))return b}else{if(a.indexOf)return a.indexOf(g);b=0;for(c=a.length;b<c;b++)if(a[b]===g)return b}return-1},search:function(a,b){var c=CKEDITOR.tools.indexOf(a,b);return c>=0?a[c]:null},bind:function(a,b){return function(){return a.apply(b,
arguments)}},createClass:function(a){var b=a.$,c=a.base,i=a.privates||a._,d=a.proto,a=a.statics;!b&&(b=function(){c&&this.base.apply(this,arguments)});if(i)var o=b,b=function(){var a=this._||(this._={}),b;for(b in i){var g=i[b];a[b]=typeof g=="function"?CKEDITOR.tools.bind(g,this):g}o.apply(this,arguments)};if(c){b.prototype=this.prototypedCopy(c.prototype);b.prototype.constructor=b;b.base=c;b.baseProto=c.prototype;b.prototype.base=function(){this.base=c.prototype.base;c.apply(this,arguments);this.base=
arguments.callee}}d&&this.extend(b.prototype,d,true);a&&this.extend(b,a,true);return b},addFunction:function(b,g){return a.push(function(){return b.apply(g||this,arguments)})-1},removeFunction:function(b){a[b]=null},callFunction:function(b){var g=a[b];return g&&g.apply(window,Array.prototype.slice.call(arguments,1))},cssLength:function(){var a=/^-?\d+\.?\d*px$/,b;return function(c){b=CKEDITOR.tools.trim(c+"")+"px";return a.test(b)?b:c||""}}(),convertToPx:function(){var a;return function(b){if(!a){a=
CKEDITOR.dom.element.createFromHtml('<div style="position:absolute;left:-9999px;top:-9999px;margin:0px;padding:0px;border:0px;"></div>',CKEDITOR.document);CKEDITOR.document.getBody().append(a)}if(!/%$/.test(b)){a.setStyle("width",b);return a.$.clientWidth}return b}}(),repeat:function(a,b){return Array(b+1).join(a)},tryThese:function(){for(var a,b=0,c=arguments.length;b<c;b++){var i=arguments[b];try{a=i();break}catch(d){}}return a},genKey:function(){return Array.prototype.slice.call(arguments).join("-")},
defer:function(a){return function(){var b=arguments,c=this;window.setTimeout(function(){a.apply(c,b)},0)}},normalizeCssText:function(a,b){var c=[],i,d=CKEDITOR.tools.parseCssText(a,true,b);for(i in d)c.push(i+":"+d[i]);c.sort();return c.length?c.join(";")+";":""},convertRgbToHex:function(a){return a.replace(/(?:rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\))/gi,function(a,b,c,i){a=[b,c,i];for(b=0;b<3;b++)a[b]=("0"+parseInt(a[b],10).toString(16)).slice(-2);return"#"+a.join("")})},parseCssText:function(a,
b,c){var i={};if(c){c=new CKEDITOR.dom.element("span");c.setAttribute("style",a);a=CKEDITOR.tools.convertRgbToHex(c.getAttribute("style")||"")}if(!a||a==";")return i;a.replace(/&quot;/g,'"').replace(/\s*([^:;\s]+)\s*:\s*([^;]+)\s*(?=;|$)/g,function(a,c,d){if(b){c=c.toLowerCase();c=="font-family"&&(d=d.toLowerCase().replace(/["']/g,"").replace(/\s*,\s*/g,","));d=CKEDITOR.tools.trim(d)}i[c]=d});return i},writeCssText:function(a,b){var c,i=[];for(c in a)i.push(c+":"+a[c]);b&&i.sort();return i.join("; ")},
objectCompare:function(a,b,c){var i;if(!a&&!b)return true;if(!a||!b)return false;for(i in a)if(a[i]!=b[i])return false;if(!c)for(i in b)if(a[i]!=b[i])return false;return true},objectKeys:function(a){var b=[],c;for(c in a)b.push(c);return b},convertArrayToObject:function(a,b){var c={};arguments.length==1&&(b=true);for(var i=0,d=a.length;i<d;++i)c[a[i]]=b;return c},fixDomain:function(){for(var a;;)try{a=window.parent.document.domain;break}catch(b){a=a?a.replace(/.+?(?:\.|$)/,""):document.domain;if(!a)break;
document.domain=a}return!!a},eventsBuffer:function(a,b,c){function i(){o=(new Date).getTime();d=false;c?b.call(c):b()}var d,o=0;return{input:function(){if(!d){var b=(new Date).getTime()-o;b<a?d=setTimeout(i,a-b):i()}},reset:function(){d&&clearTimeout(d);d=o=0}}},enableHtml5Elements:function(a,b){for(var c=["abbr","article","aside","audio","bdi","canvas","data","datalist","details","figcaption","figure","footer","header","hgroup","main","mark","meter","nav","output","progress","section","summary",
"time","video"],i=c.length,d;i--;){d=a.createElement(c[i]);b&&a.appendChild(d)}},checkIfAnyArrayItemMatches:function(a,b){for(var c=0,i=a.length;c<i;++c)if(a[c].match(b))return true;return false},checkIfAnyObjectPropertyMatches:function(a,b){for(var c in a)if(c.match(b))return true;return false},transparentImageData:"data:image/gif;base64,R0lGODlhAQABAPABAP///wAAACH5BAEKAAAALAAAAAABAAEAAAICRAEAOw=="}})();
CKEDITOR.dtd=function(){var a=CKEDITOR.tools.extend,d=function(a,b){for(var c=CKEDITOR.tools.clone(a),i=1;i<arguments.length;i++){var b=arguments[i],d;for(d in b)delete c[d]}return c},b={},c={},e={address:1,article:1,aside:1,blockquote:1,details:1,div:1,dl:1,fieldset:1,figure:1,footer:1,form:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,header:1,hgroup:1,hr:1,main:1,menu:1,nav:1,ol:1,p:1,pre:1,section:1,table:1,ul:1},f={command:1,link:1,meta:1,noscript:1,script:1,style:1},h={},i={"#":1},j={center:1,dir:1,noframes:1};
a(b,{a:1,abbr:1,area:1,audio:1,b:1,bdi:1,bdo:1,br:1,button:1,canvas:1,cite:1,code:1,command:1,datalist:1,del:1,dfn:1,em:1,embed:1,i:1,iframe:1,img:1,input:1,ins:1,kbd:1,keygen:1,label:1,map:1,mark:1,meter:1,noscript:1,object:1,output:1,progress:1,q:1,ruby:1,s:1,samp:1,script:1,select:1,small:1,span:1,strong:1,sub:1,sup:1,textarea:1,time:1,u:1,"var":1,video:1,wbr:1},i,{acronym:1,applet:1,basefont:1,big:1,font:1,isindex:1,strike:1,style:1,tt:1});a(c,e,b,j);d={a:d(b,{a:1,button:1}),abbr:b,address:c,
area:h,article:c,aside:c,audio:a({source:1,track:1},c),b:b,base:h,bdi:b,bdo:b,blockquote:c,body:c,br:h,button:d(b,{a:1,button:1}),canvas:b,caption:c,cite:b,code:b,col:h,colgroup:{col:1},command:h,datalist:a({option:1},b),dd:c,del:b,details:a({summary:1},c),dfn:b,div:c,dl:{dt:1,dd:1},dt:c,em:b,embed:h,fieldset:a({legend:1},c),figcaption:c,figure:a({figcaption:1},c),footer:c,form:c,h1:b,h2:b,h3:b,h4:b,h5:b,h6:b,head:a({title:1,base:1},f),header:c,hgroup:{h1:1,h2:1,h3:1,h4:1,h5:1,h6:1},hr:h,html:a({head:1,
body:1},c,f),i:b,iframe:i,img:h,input:h,ins:b,kbd:b,keygen:h,label:b,legend:b,li:c,link:h,main:c,map:c,mark:b,menu:a({li:1},c),meta:h,meter:d(b,{meter:1}),nav:c,noscript:a({link:1,meta:1,style:1},b),object:a({param:1},b),ol:{li:1},optgroup:{option:1},option:i,output:b,p:b,param:h,pre:b,progress:d(b,{progress:1}),q:b,rp:b,rt:b,ruby:a({rp:1,rt:1},b),s:b,samp:b,script:i,section:c,select:{optgroup:1,option:1},small:b,source:h,span:b,strong:b,style:i,sub:b,summary:b,sup:b,table:{caption:1,colgroup:1,thead:1,
tfoot:1,tbody:1,tr:1},tbody:{tr:1},td:c,textarea:i,tfoot:{tr:1},th:c,thead:{tr:1},time:d(b,{time:1}),title:i,tr:{th:1,td:1},track:h,u:b,ul:{li:1},"var":b,video:a({source:1,track:1},c),wbr:h,acronym:b,applet:a({param:1},c),basefont:h,big:b,center:c,dialog:h,dir:{li:1},font:b,isindex:h,noframes:c,strike:b,tt:b};a(d,{$block:a({audio:1,dd:1,dt:1,figcaption:1,li:1,video:1},e,j),$blockLimit:{article:1,aside:1,audio:1,body:1,caption:1,details:1,dir:1,div:1,dl:1,fieldset:1,figcaption:1,figure:1,footer:1,
form:1,header:1,hgroup:1,main:1,menu:1,nav:1,ol:1,section:1,table:1,td:1,th:1,tr:1,ul:1,video:1},$cdata:{script:1,style:1},$editable:{address:1,article:1,aside:1,blockquote:1,body:1,details:1,div:1,fieldset:1,figcaption:1,footer:1,form:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,header:1,hgroup:1,main:1,nav:1,p:1,pre:1,section:1},$empty:{area:1,base:1,basefont:1,br:1,col:1,command:1,dialog:1,embed:1,hr:1,img:1,input:1,isindex:1,keygen:1,link:1,meta:1,param:1,source:1,track:1,wbr:1},$inline:b,$list:{dl:1,ol:1,
ul:1},$listItem:{dd:1,dt:1,li:1},$nonBodyContent:a({body:1,head:1,html:1},d.head),$nonEditable:{applet:1,audio:1,button:1,embed:1,iframe:1,map:1,object:1,option:1,param:1,script:1,textarea:1,video:1},$object:{applet:1,audio:1,button:1,hr:1,iframe:1,img:1,input:1,object:1,select:1,table:1,textarea:1,video:1},$removeEmpty:{abbr:1,acronym:1,b:1,bdi:1,bdo:1,big:1,cite:1,code:1,del:1,dfn:1,em:1,font:1,i:1,ins:1,label:1,kbd:1,mark:1,meter:1,output:1,q:1,ruby:1,s:1,samp:1,small:1,span:1,strike:1,strong:1,
sub:1,sup:1,time:1,tt:1,u:1,"var":1},$tabIndex:{a:1,area:1,button:1,input:1,object:1,select:1,textarea:1},$tableContent:{caption:1,col:1,colgroup:1,tbody:1,td:1,tfoot:1,th:1,thead:1,tr:1},$transparent:{a:1,audio:1,canvas:1,del:1,ins:1,map:1,noscript:1,object:1,video:1},$intermediate:{caption:1,colgroup:1,dd:1,dt:1,figcaption:1,legend:1,li:1,optgroup:1,option:1,rp:1,rt:1,summary:1,tbody:1,td:1,tfoot:1,th:1,thead:1,tr:1}});return d}();CKEDITOR.dom.event=function(a){this.$=a};
CKEDITOR.dom.event.prototype={getKey:function(){return this.$.keyCode||this.$.which},getKeystroke:function(){var a=this.getKey();if(this.$.ctrlKey||this.$.metaKey)a=a+CKEDITOR.CTRL;this.$.shiftKey&&(a=a+CKEDITOR.SHIFT);this.$.altKey&&(a=a+CKEDITOR.ALT);return a},preventDefault:function(a){var d=this.$;d.preventDefault?d.preventDefault():d.returnValue=false;a&&this.stopPropagation()},stopPropagation:function(){var a=this.$;a.stopPropagation?a.stopPropagation():a.cancelBubble=true},getTarget:function(){var a=
this.$.target||this.$.srcElement;return a?new CKEDITOR.dom.node(a):null},getPhase:function(){return this.$.eventPhase||2},getPageOffset:function(){var a=this.getTarget().getDocument().$;return{x:this.$.pageX||this.$.clientX+(a.documentElement.scrollLeft||a.body.scrollLeft),y:this.$.pageY||this.$.clientY+(a.documentElement.scrollTop||a.body.scrollTop)}}};CKEDITOR.CTRL=1114112;CKEDITOR.SHIFT=2228224;CKEDITOR.ALT=4456448;CKEDITOR.EVENT_PHASE_CAPTURING=1;CKEDITOR.EVENT_PHASE_AT_TARGET=2;
CKEDITOR.EVENT_PHASE_BUBBLING=3;CKEDITOR.dom.domObject=function(a){if(a)this.$=a};
CKEDITOR.dom.domObject.prototype=function(){var a=function(a,b){return function(c){typeof CKEDITOR!="undefined"&&a.fire(b,new CKEDITOR.dom.event(c))}};return{getPrivate:function(){var a;if(!(a=this.getCustomData("_")))this.setCustomData("_",a={});return a},on:function(d){var b=this.getCustomData("_cke_nativeListeners");if(!b){b={};this.setCustomData("_cke_nativeListeners",b)}if(!b[d]){b=b[d]=a(this,d);this.$.addEventListener?this.$.addEventListener(d,b,!!CKEDITOR.event.useCapture):this.$.attachEvent&&
this.$.attachEvent("on"+d,b)}return CKEDITOR.event.prototype.on.apply(this,arguments)},removeListener:function(a){CKEDITOR.event.prototype.removeListener.apply(this,arguments);if(!this.hasListeners(a)){var b=this.getCustomData("_cke_nativeListeners"),c=b&&b[a];if(c){this.$.removeEventListener?this.$.removeEventListener(a,c,false):this.$.detachEvent&&this.$.detachEvent("on"+a,c);delete b[a]}}},removeAllListeners:function(){var a=this.getCustomData("_cke_nativeListeners"),b;for(b in a){var c=a[b];this.$.detachEvent?
this.$.detachEvent("on"+b,c):this.$.removeEventListener&&this.$.removeEventListener(b,c,false);delete a[b]}CKEDITOR.event.prototype.removeAllListeners.call(this)}}}();
(function(a){var d={};CKEDITOR.on("reset",function(){d={}});a.equals=function(a){try{return a&&a.$===this.$}catch(c){return false}};a.setCustomData=function(a,c){var e=this.getUniqueId();(d[e]||(d[e]={}))[a]=c;return this};a.getCustomData=function(a){var c=this.$["data-cke-expando"];return(c=c&&d[c])&&a in c?c[a]:null};a.removeCustomData=function(a){var c=this.$["data-cke-expando"],c=c&&d[c],e,f;if(c){e=c[a];f=a in c;delete c[a]}return f?e:null};a.clearCustomData=function(){this.removeAllListeners();
var a=this.$["data-cke-expando"];a&&delete d[a]};a.getUniqueId=function(){return this.$["data-cke-expando"]||(this.$["data-cke-expando"]=CKEDITOR.tools.getNextNumber())};CKEDITOR.event.implementOn(a)})(CKEDITOR.dom.domObject.prototype);
CKEDITOR.dom.node=function(a){return a?new CKEDITOR.dom[a.nodeType==CKEDITOR.NODE_DOCUMENT?"document":a.nodeType==CKEDITOR.NODE_ELEMENT?"element":a.nodeType==CKEDITOR.NODE_TEXT?"text":a.nodeType==CKEDITOR.NODE_COMMENT?"comment":a.nodeType==CKEDITOR.NODE_DOCUMENT_FRAGMENT?"documentFragment":"domObject"](a):this};CKEDITOR.dom.node.prototype=new CKEDITOR.dom.domObject;CKEDITOR.NODE_ELEMENT=1;CKEDITOR.NODE_DOCUMENT=9;CKEDITOR.NODE_TEXT=3;CKEDITOR.NODE_COMMENT=8;CKEDITOR.NODE_DOCUMENT_FRAGMENT=11;
CKEDITOR.POSITION_IDENTICAL=0;CKEDITOR.POSITION_DISCONNECTED=1;CKEDITOR.POSITION_FOLLOWING=2;CKEDITOR.POSITION_PRECEDING=4;CKEDITOR.POSITION_IS_CONTAINED=8;CKEDITOR.POSITION_CONTAINS=16;
CKEDITOR.tools.extend(CKEDITOR.dom.node.prototype,{appendTo:function(a,d){a.append(this,d);return a},clone:function(a,d){function b(c){c["data-cke-expando"]&&(c["data-cke-expando"]=false);if(!(c.nodeType!=CKEDITOR.NODE_ELEMENT&&c.nodeType!=CKEDITOR.NODE_DOCUMENT_FRAGMENT)){!d&&c.nodeType==CKEDITOR.NODE_ELEMENT&&c.removeAttribute("id",false);if(a)for(var c=c.childNodes,e=0;e<c.length;e++)b(c[e])}}function c(b){if(!(b.type!=CKEDITOR.NODE_ELEMENT&&b.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT)){if(b.type!=
CKEDITOR.NODE_DOCUMENT_FRAGMENT){var d=b.getName();d[0]==":"&&b.renameNode(d.substring(1))}if(a)for(d=0;d<b.getChildCount();d++)c(b.getChild(d))}}var e=this.$.cloneNode(a);b(e);e=new CKEDITOR.dom.node(e);CKEDITOR.env.ie&&(CKEDITOR.env.version<9&&(this.type==CKEDITOR.NODE_ELEMENT||this.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT))&&c(e);return e},hasPrevious:function(){return!!this.$.previousSibling},hasNext:function(){return!!this.$.nextSibling},insertAfter:function(a){a.$.parentNode.insertBefore(this.$,
a.$.nextSibling);return a},insertBefore:function(a){a.$.parentNode.insertBefore(this.$,a.$);return a},insertBeforeMe:function(a){this.$.parentNode.insertBefore(a.$,this.$);return a},getAddress:function(a){for(var d=[],b=this.getDocument().$.documentElement,c=this.$;c&&c!=b;){var e=c.parentNode;e&&d.unshift(this.getIndex.call({$:c},a));c=e}return d},getDocument:function(){return new CKEDITOR.dom.document(this.$.ownerDocument||this.$.parentNode.ownerDocument)},getIndex:function(a){function d(a,b){var c=
b?a.nextSibling:a.previousSibling;return!c||c.nodeType!=CKEDITOR.NODE_TEXT?null:c.nodeValue?c:d(c,b)}var b=this.$,c=-1,e;if(!this.$.parentNode||a&&b.nodeType==CKEDITOR.NODE_TEXT&&!b.nodeValue&&!d(b)&&!d(b,true))return-1;do if(!a||!(b!=this.$&&b.nodeType==CKEDITOR.NODE_TEXT&&(e||!b.nodeValue))){c++;e=b.nodeType==CKEDITOR.NODE_TEXT}while(b=b.previousSibling);return c},getNextSourceNode:function(a,d,b){if(b&&!b.call)var c=b,b=function(a){return!a.equals(c)};var a=!a&&this.getFirst&&this.getFirst(),e;
if(!a){if(this.type==CKEDITOR.NODE_ELEMENT&&b&&b(this,true)===false)return null;a=this.getNext()}for(;!a&&(e=(e||this).getParent());){if(b&&b(e,true)===false)return null;a=e.getNext()}return!a||b&&b(a)===false?null:d&&d!=a.type?a.getNextSourceNode(false,d,b):a},getPreviousSourceNode:function(a,d,b){if(b&&!b.call)var c=b,b=function(a){return!a.equals(c)};var a=!a&&this.getLast&&this.getLast(),e;if(!a){if(this.type==CKEDITOR.NODE_ELEMENT&&b&&b(this,true)===false)return null;a=this.getPrevious()}for(;!a&&
(e=(e||this).getParent());){if(b&&b(e,true)===false)return null;a=e.getPrevious()}return!a||b&&b(a)===false?null:d&&a.type!=d?a.getPreviousSourceNode(false,d,b):a},getPrevious:function(a){var d=this.$,b;do b=(d=d.previousSibling)&&d.nodeType!=10&&new CKEDITOR.dom.node(d);while(b&&a&&!a(b));return b},getNext:function(a){var d=this.$,b;do b=(d=d.nextSibling)&&new CKEDITOR.dom.node(d);while(b&&a&&!a(b));return b},getParent:function(a){var d=this.$.parentNode;return d&&(d.nodeType==CKEDITOR.NODE_ELEMENT||
a&&d.nodeType==CKEDITOR.NODE_DOCUMENT_FRAGMENT)?new CKEDITOR.dom.node(d):null},getParents:function(a){var d=this,b=[];do b[a?"push":"unshift"](d);while(d=d.getParent());return b},getCommonAncestor:function(a){if(a.equals(this))return this;if(a.contains&&a.contains(this))return a;var d=this.contains?this:this.getParent();do if(d.contains(a))return d;while(d=d.getParent());return null},getPosition:function(a){var d=this.$,b=a.$;if(d.compareDocumentPosition)return d.compareDocumentPosition(b);if(d==
b)return CKEDITOR.POSITION_IDENTICAL;if(this.type==CKEDITOR.NODE_ELEMENT&&a.type==CKEDITOR.NODE_ELEMENT){if(d.contains){if(d.contains(b))return CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_PRECEDING;if(b.contains(d))return CKEDITOR.POSITION_IS_CONTAINED+CKEDITOR.POSITION_FOLLOWING}if("sourceIndex"in d)return d.sourceIndex<0||b.sourceIndex<0?CKEDITOR.POSITION_DISCONNECTED:d.sourceIndex<b.sourceIndex?CKEDITOR.POSITION_PRECEDING:CKEDITOR.POSITION_FOLLOWING}for(var d=this.getAddress(),a=a.getAddress(),
b=Math.min(d.length,a.length),c=0;c<b;c++)if(d[c]!=a[c])return d[c]<a[c]?CKEDITOR.POSITION_PRECEDING:CKEDITOR.POSITION_FOLLOWING;return d.length<a.length?CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_PRECEDING:CKEDITOR.POSITION_IS_CONTAINED+CKEDITOR.POSITION_FOLLOWING},getAscendant:function(a,d){var b=this.$,c,e;if(!d)b=b.parentNode;if(typeof a=="function"){e=true;c=a}else{e=false;c=function(b){b=typeof b.nodeName=="string"?b.nodeName.toLowerCase():"";return typeof a=="string"?b==a:b in a}}for(;b;){if(c(e?
new CKEDITOR.dom.node(b):b))return new CKEDITOR.dom.node(b);try{b=b.parentNode}catch(f){b=null}}return null},hasAscendant:function(a,d){var b=this.$;if(!d)b=b.parentNode;for(;b;){if(b.nodeName&&b.nodeName.toLowerCase()==a)return true;b=b.parentNode}return false},move:function(a,d){a.append(this.remove(),d)},remove:function(a){var d=this.$,b=d.parentNode;if(b){if(a)for(;a=d.firstChild;)b.insertBefore(d.removeChild(a),d);b.removeChild(d)}return this},replace:function(a){this.insertBefore(a);a.remove()},
trim:function(){this.ltrim();this.rtrim()},ltrim:function(){for(var a;this.getFirst&&(a=this.getFirst());){if(a.type==CKEDITOR.NODE_TEXT){var d=CKEDITOR.tools.ltrim(a.getText()),b=a.getLength();if(d){if(d.length<b){a.split(b-d.length);this.$.removeChild(this.$.firstChild)}}else{a.remove();continue}}break}},rtrim:function(){for(var a;this.getLast&&(a=this.getLast());){if(a.type==CKEDITOR.NODE_TEXT){var d=CKEDITOR.tools.rtrim(a.getText()),b=a.getLength();if(d){if(d.length<b){a.split(d.length);this.$.lastChild.parentNode.removeChild(this.$.lastChild)}}else{a.remove();
continue}}break}if(CKEDITOR.env.needsBrFiller)(a=this.$.lastChild)&&(a.type==1&&a.nodeName.toLowerCase()=="br")&&a.parentNode.removeChild(a)},isReadOnly:function(a){var d=this;this.type!=CKEDITOR.NODE_ELEMENT&&(d=this.getParent());CKEDITOR.env.edge&&(d&&d.is("textarea"))&&(a=true);if(!a&&d&&typeof d.$.isContentEditable!="undefined")return!(d.$.isContentEditable||d.data("cke-editable"));for(;d;){if(d.data("cke-editable"))return false;if(d.hasAttribute("contenteditable"))return d.getAttribute("contenteditable")==
"false";d=d.getParent()}return true}});CKEDITOR.dom.window=function(a){CKEDITOR.dom.domObject.call(this,a)};CKEDITOR.dom.window.prototype=new CKEDITOR.dom.domObject;
CKEDITOR.tools.extend(CKEDITOR.dom.window.prototype,{focus:function(){this.$.focus()},getViewPaneSize:function(){var a=this.$.document,d=a.compatMode=="CSS1Compat";return{width:(d?a.documentElement.clientWidth:a.body.clientWidth)||0,height:(d?a.documentElement.clientHeight:a.body.clientHeight)||0}},getScrollPosition:function(){var a=this.$;if("pageXOffset"in a)return{x:a.pageXOffset||0,y:a.pageYOffset||0};a=a.document;return{x:a.documentElement.scrollLeft||a.body.scrollLeft||0,y:a.documentElement.scrollTop||
a.body.scrollTop||0}},getFrame:function(){var a=this.$.frameElement;return a?new CKEDITOR.dom.element.get(a):null}});CKEDITOR.dom.document=function(a){CKEDITOR.dom.domObject.call(this,a)};CKEDITOR.dom.document.prototype=new CKEDITOR.dom.domObject;
CKEDITOR.tools.extend(CKEDITOR.dom.document.prototype,{type:CKEDITOR.NODE_DOCUMENT,appendStyleSheet:function(a){if(this.$.createStyleSheet)this.$.createStyleSheet(a);else{var d=new CKEDITOR.dom.element("link");d.setAttributes({rel:"stylesheet",type:"text/css",href:a});this.getHead().append(d)}},appendStyleText:function(a){if(this.$.createStyleSheet){var d=this.$.createStyleSheet("");d.cssText=a}else{var b=new CKEDITOR.dom.element("style",this);b.append(new CKEDITOR.dom.text(a,this));this.getHead().append(b)}return d||
b.$.sheet},createElement:function(a,d){var b=new CKEDITOR.dom.element(a,this);if(d){d.attributes&&b.setAttributes(d.attributes);d.styles&&b.setStyles(d.styles)}return b},createText:function(a){return new CKEDITOR.dom.text(a,this)},focus:function(){this.getWindow().focus()},getActive:function(){var a;try{a=this.$.activeElement}catch(d){return null}return new CKEDITOR.dom.element(a)},getById:function(a){return(a=this.$.getElementById(a))?new CKEDITOR.dom.element(a):null},getByAddress:function(a,d){for(var b=
this.$.documentElement,c=0;b&&c<a.length;c++){var e=a[c];if(d)for(var f=-1,h=0;h<b.childNodes.length;h++){var i=b.childNodes[h];if(!(d===true&&i.nodeType==3&&i.previousSibling&&i.previousSibling.nodeType==3)){f++;if(f==e){b=i;break}}}else b=b.childNodes[e]}return b?new CKEDITOR.dom.node(b):null},getElementsByTag:function(a,d){!(CKEDITOR.env.ie&&document.documentMode<=8)&&d&&(a=d+":"+a);return new CKEDITOR.dom.nodeList(this.$.getElementsByTagName(a))},getHead:function(){var a=this.$.getElementsByTagName("head")[0];
return a=a?new CKEDITOR.dom.element(a):this.getDocumentElement().append(new CKEDITOR.dom.element("head"),true)},getBody:function(){return new CKEDITOR.dom.element(this.$.body)},getDocumentElement:function(){return new CKEDITOR.dom.element(this.$.documentElement)},getWindow:function(){return new CKEDITOR.dom.window(this.$.parentWindow||this.$.defaultView)},write:function(a){this.$.open("text/html","replace");CKEDITOR.env.ie&&(a=a.replace(/(?:^\s*<!DOCTYPE[^>]*?>)|^/i,'$&\n<script data-cke-temp="1">('+
CKEDITOR.tools.fixDomain+")();<\/script>"));this.$.write(a);this.$.close()},find:function(a){return new CKEDITOR.dom.nodeList(this.$.querySelectorAll(a))},findOne:function(a){return(a=this.$.querySelector(a))?new CKEDITOR.dom.element(a):null},_getHtml5ShivFrag:function(){var a=this.getCustomData("html5ShivFrag");if(!a){a=this.$.createDocumentFragment();CKEDITOR.tools.enableHtml5Elements(a,true);this.setCustomData("html5ShivFrag",a)}return a}});CKEDITOR.dom.nodeList=function(a){this.$=a};
CKEDITOR.dom.nodeList.prototype={count:function(){return this.$.length},getItem:function(a){if(a<0||a>=this.$.length)return null;return(a=this.$[a])?new CKEDITOR.dom.node(a):null}};CKEDITOR.dom.element=function(a,d){typeof a=="string"&&(a=(d?d.$:document).createElement(a));CKEDITOR.dom.domObject.call(this,a)};CKEDITOR.dom.element.get=function(a){return(a=typeof a=="string"?document.getElementById(a)||document.getElementsByName(a)[0]:a)&&(a.$?a:new CKEDITOR.dom.element(a))};
CKEDITOR.dom.element.prototype=new CKEDITOR.dom.node;CKEDITOR.dom.element.createFromHtml=function(a,d){var b=new CKEDITOR.dom.element("div",d);b.setHtml(a);return b.getFirst().remove()};
CKEDITOR.dom.element.setMarker=function(a,d,b,c){var e=d.getCustomData("list_marker_id")||d.setCustomData("list_marker_id",CKEDITOR.tools.getNextNumber()).getCustomData("list_marker_id"),f=d.getCustomData("list_marker_names")||d.setCustomData("list_marker_names",{}).getCustomData("list_marker_names");a[e]=d;f[b]=1;return d.setCustomData(b,c)};CKEDITOR.dom.element.clearAllMarkers=function(a){for(var d in a)CKEDITOR.dom.element.clearMarkers(a,a[d],1)};
CKEDITOR.dom.element.clearMarkers=function(a,d,b){var c=d.getCustomData("list_marker_names"),e=d.getCustomData("list_marker_id"),f;for(f in c)d.removeCustomData(f);d.removeCustomData("list_marker_names");if(b){d.removeCustomData("list_marker_id");delete a[e]}};
(function(){function a(a,b){return(" "+a+" ").replace(f," ").indexOf(" "+b+" ")>-1}function d(a){var b=true;if(!a.$.id){a.$.id="cke_tmp_"+CKEDITOR.tools.getNextNumber();b=false}return function(){b||a.removeAttribute("id")}}function b(a,b){return"#"+a.$.id+" "+b.split(/,\s*/).join(", #"+a.$.id+" ")}function c(a){for(var b=0,c=0,g=h[a].length;c<g;c++)b=b+(parseInt(this.getComputedStyle(h[a][c])||0,10)||0);return b}var e=!!document.createElement("span").classList,f=/[\n\t\r]/g;CKEDITOR.tools.extend(CKEDITOR.dom.element.prototype,
{type:CKEDITOR.NODE_ELEMENT,addClass:e?function(a){this.$.classList.add(a);return this}:function(b){var c=this.$.className;c&&(a(c,b)||(c=c+(" "+b)));this.$.className=c||b;return this},removeClass:e?function(a){var b=this.$;b.classList.remove(a);b.className||b.removeAttribute("class");return this}:function(b){var c=this.getAttribute("class");if(c&&a(c,b))(c=c.replace(RegExp("(?:^|\\s+)"+b+"(?=\\s|$)"),"").replace(/^\s+/,""))?this.setAttribute("class",c):this.removeAttribute("class");return this},
hasClass:function(b){return a(this.$.className,b)},append:function(a,b){typeof a=="string"&&(a=this.getDocument().createElement(a));b?this.$.insertBefore(a.$,this.$.firstChild):this.$.appendChild(a.$);return a},appendHtml:function(a){if(this.$.childNodes.length){var b=new CKEDITOR.dom.element("div",this.getDocument());b.setHtml(a);b.moveChildren(this)}else this.setHtml(a)},appendText:function(a){this.$.text!=null&&CKEDITOR.env.ie&&CKEDITOR.env.version<9?this.$.text=this.$.text+a:this.append(new CKEDITOR.dom.text(a))},
appendBogus:function(a){if(a||CKEDITOR.env.needsBrFiller){for(a=this.getLast();a&&a.type==CKEDITOR.NODE_TEXT&&!CKEDITOR.tools.rtrim(a.getText());)a=a.getPrevious();if(!a||!a.is||!a.is("br")){a=this.getDocument().createElement("br");CKEDITOR.env.gecko&&a.setAttribute("type","_moz");this.append(a)}}},breakParent:function(a,b){var c=new CKEDITOR.dom.range(this.getDocument());c.setStartAfter(this);c.setEndAfter(a);var g=c.extractContents(false,b||false);c.insertNode(this.remove());g.insertAfterNode(this)},
contains:!document.compareDocumentPosition?function(a){var b=this.$;return a.type!=CKEDITOR.NODE_ELEMENT?b.contains(a.getParent().$):b!=a.$&&b.contains(a.$)}:function(a){return!!(this.$.compareDocumentPosition(a.$)&16)},focus:function(){function a(){try{this.$.focus()}catch(b){}}return function(b){b?CKEDITOR.tools.setTimeout(a,100,this):a.call(this)}}(),getHtml:function(){var a=this.$.innerHTML;return CKEDITOR.env.ie?a.replace(/<\?[^>]*>/g,""):a},getOuterHtml:function(){if(this.$.outerHTML)return this.$.outerHTML.replace(/<\?[^>]*>/,
"");var a=this.$.ownerDocument.createElement("div");a.appendChild(this.$.cloneNode(true));return a.innerHTML},getClientRect:function(){var a=CKEDITOR.tools.extend({},this.$.getBoundingClientRect());!a.width&&(a.width=a.right-a.left);!a.height&&(a.height=a.bottom-a.top);return a},setHtml:CKEDITOR.env.ie&&CKEDITOR.env.version<9?function(a){try{var b=this.$;if(this.getParent())return b.innerHTML=a;var c=this.getDocument()._getHtml5ShivFrag();c.appendChild(b);b.innerHTML=a;c.removeChild(b);return a}catch(g){this.$.innerHTML=
"";b=new CKEDITOR.dom.element("body",this.getDocument());b.$.innerHTML=a;for(b=b.getChildren();b.count();)this.append(b.getItem(0));return a}}:function(a){return this.$.innerHTML=a},setText:function(){var a=document.createElement("p");a.innerHTML="x";a=a.textContent;return function(b){this.$[a?"textContent":"innerText"]=b}}(),getAttribute:function(){var a=function(a){return this.$.getAttribute(a,2)};return CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(a){switch(a){case "class":a=
"className";break;case "http-equiv":a="httpEquiv";break;case "name":return this.$.name;case "tabindex":a=this.$.getAttribute(a,2);a!==0&&this.$.tabIndex===0&&(a=null);return a;case "checked":a=this.$.attributes.getNamedItem(a);return(a.specified?a.nodeValue:this.$.checked)?"checked":null;case "hspace":case "value":return this.$[a];case "style":return this.$.style.cssText;case "contenteditable":case "contentEditable":return this.$.attributes.getNamedItem("contentEditable").specified?this.$.getAttribute("contentEditable"):
null}return this.$.getAttribute(a,2)}:a}(),getChildren:function(){return new CKEDITOR.dom.nodeList(this.$.childNodes)},getComputedStyle:document.defaultView&&document.defaultView.getComputedStyle?function(a){var b=this.getWindow().$.getComputedStyle(this.$,null);return b?b.getPropertyValue(a):""}:function(a){return this.$.currentStyle[CKEDITOR.tools.cssStyleToDomStyle(a)]},getDtd:function(){var a=CKEDITOR.dtd[this.getName()];this.getDtd=function(){return a};return a},getElementsByTag:CKEDITOR.dom.document.prototype.getElementsByTag,
getTabIndex:function(){var a=this.$.tabIndex;return a===0&&!CKEDITOR.dtd.$tabIndex[this.getName()]&&parseInt(this.getAttribute("tabindex"),10)!==0?-1:a},getText:function(){return this.$.textContent||this.$.innerText||""},getWindow:function(){return this.getDocument().getWindow()},getId:function(){return this.$.id||null},getNameAtt:function(){return this.$.name||null},getName:function(){var a=this.$.nodeName.toLowerCase();if(CKEDITOR.env.ie&&document.documentMode<=8){var b=this.$.scopeName;b!="HTML"&&
(a=b.toLowerCase()+":"+a)}this.getName=function(){return a};return this.getName()},getValue:function(){return this.$.value},getFirst:function(a){var b=this.$.firstChild;(b=b&&new CKEDITOR.dom.node(b))&&(a&&!a(b))&&(b=b.getNext(a));return b},getLast:function(a){var b=this.$.lastChild;(b=b&&new CKEDITOR.dom.node(b))&&(a&&!a(b))&&(b=b.getPrevious(a));return b},getStyle:function(a){return this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)]},is:function(){var a=this.getName();if(typeof arguments[0]=="object")return!!arguments[0][a];
for(var b=0;b<arguments.length;b++)if(arguments[b]==a)return true;return false},isEditable:function(a){var b=this.getName();if(this.isReadOnly()||this.getComputedStyle("display")=="none"||this.getComputedStyle("visibility")=="hidden"||CKEDITOR.dtd.$nonEditable[b]||CKEDITOR.dtd.$empty[b]||this.is("a")&&(this.data("cke-saved-name")||this.hasAttribute("name"))&&!this.getChildCount())return false;if(a!==false){a=CKEDITOR.dtd[b]||CKEDITOR.dtd.span;return!(!a||!a["#"])}return true},isIdentical:function(a){var b=
this.clone(0,1),a=a.clone(0,1);b.removeAttributes(["_moz_dirty","data-cke-expando","data-cke-saved-href","data-cke-saved-name"]);a.removeAttributes(["_moz_dirty","data-cke-expando","data-cke-saved-href","data-cke-saved-name"]);if(b.$.isEqualNode){b.$.style.cssText=CKEDITOR.tools.normalizeCssText(b.$.style.cssText);a.$.style.cssText=CKEDITOR.tools.normalizeCssText(a.$.style.cssText);return b.$.isEqualNode(a.$)}b=b.getOuterHtml();a=a.getOuterHtml();if(CKEDITOR.env.ie&&CKEDITOR.env.version<9&&this.is("a")){var c=
this.getParent();if(c.type==CKEDITOR.NODE_ELEMENT){c=c.clone();c.setHtml(b);b=c.getHtml();c.setHtml(a);a=c.getHtml()}}return b==a},isVisible:function(){var a=(this.$.offsetHeight||this.$.offsetWidth)&&this.getComputedStyle("visibility")!="hidden",b,c;if(a&&CKEDITOR.env.webkit){b=this.getWindow();if(!b.equals(CKEDITOR.document.getWindow())&&(c=b.$.frameElement))a=(new CKEDITOR.dom.element(c)).isVisible()}return!!a},isEmptyInlineRemoveable:function(){if(!CKEDITOR.dtd.$removeEmpty[this.getName()])return false;
for(var a=this.getChildren(),b=0,c=a.count();b<c;b++){var g=a.getItem(b);if(!(g.type==CKEDITOR.NODE_ELEMENT&&g.data("cke-bookmark"))&&(g.type==CKEDITOR.NODE_ELEMENT&&!g.isEmptyInlineRemoveable()||g.type==CKEDITOR.NODE_TEXT&&CKEDITOR.tools.trim(g.getText())))return false}return true},hasAttributes:CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(){for(var a=this.$.attributes,b=0;b<a.length;b++){var c=a[b];switch(c.nodeName){case "class":if(this.getAttribute("class"))return true;
case "data-cke-expando":continue;default:if(c.specified)return true}}return false}:function(){var a=this.$.attributes,b=a.length,c={"data-cke-expando":1,_moz_dirty:1};return b>0&&(b>2||!c[a[0].nodeName]||b==2&&!c[a[1].nodeName])},hasAttribute:function(){function a(b){var c=this.$.attributes.getNamedItem(b);if(this.getName()=="input")switch(b){case "class":return this.$.className.length>0;case "checked":return!!this.$.checked;case "value":b=this.getAttribute("type");return b=="checkbox"||b=="radio"?
this.$.value!="on":!!this.$.value}return!c?false:c.specified}return CKEDITOR.env.ie?CKEDITOR.env.version<8?function(b){return b=="name"?!!this.$.name:a.call(this,b)}:a:function(a){return!!this.$.attributes.getNamedItem(a)}}(),hide:function(){this.setStyle("display","none")},moveChildren:function(a,b){var c=this.$,a=a.$;if(c!=a){var g;if(b)for(;g=c.lastChild;)a.insertBefore(c.removeChild(g),a.firstChild);else for(;g=c.firstChild;)a.appendChild(c.removeChild(g))}},mergeSiblings:function(){function a(b,
c,g){if(c&&c.type==CKEDITOR.NODE_ELEMENT){for(var d=[];c.data("cke-bookmark")||c.isEmptyInlineRemoveable();){d.push(c);c=g?c.getNext():c.getPrevious();if(!c||c.type!=CKEDITOR.NODE_ELEMENT)return}if(b.isIdentical(c)){for(var i=g?b.getLast():b.getFirst();d.length;)d.shift().move(b,!g);c.moveChildren(b,!g);c.remove();i&&i.type==CKEDITOR.NODE_ELEMENT&&i.mergeSiblings()}}}return function(b){if(b===false||CKEDITOR.dtd.$removeEmpty[this.getName()]||this.is("a")){a(this,this.getNext(),true);a(this,this.getPrevious())}}}(),
show:function(){this.setStyles({display:"",visibility:""})},setAttribute:function(){var a=function(a,b){this.$.setAttribute(a,b);return this};return CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(b,c){b=="class"?this.$.className=c:b=="style"?this.$.style.cssText=c:b=="tabindex"?this.$.tabIndex=c:b=="checked"?this.$.checked=c:b=="contenteditable"?a.call(this,"contentEditable",c):a.apply(this,arguments);return this}:CKEDITOR.env.ie8Compat&&CKEDITOR.env.secure?function(b,c){if(b==
"src"&&c.match(/^http:\/\//))try{a.apply(this,arguments)}catch(g){}else a.apply(this,arguments);return this}:a}(),setAttributes:function(a){for(var b in a)this.setAttribute(b,a[b]);return this},setValue:function(a){this.$.value=a;return this},removeAttribute:function(){var a=function(a){this.$.removeAttribute(a)};return CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks)?function(a){a=="class"?a="className":a=="tabindex"?a="tabIndex":a=="contenteditable"&&(a="contentEditable");this.$.removeAttribute(a)}:
a}(),removeAttributes:function(a){if(CKEDITOR.tools.isArray(a))for(var b=0;b<a.length;b++)this.removeAttribute(a[b]);else for(b in a)a.hasOwnProperty(b)&&this.removeAttribute(b)},removeStyle:function(a){var b=this.$.style;if(!b.removeProperty&&(a=="border"||a=="margin"||a=="padding")){var c=["top","left","right","bottom"],g;a=="border"&&(g=["color","style","width"]);for(var b=[],d=0;d<c.length;d++)if(g)for(var r=0;r<g.length;r++)b.push([a,c[d],g[r]].join("-"));else b.push([a,c[d]].join("-"));for(a=
0;a<b.length;a++)this.removeStyle(b[a])}else{b.removeProperty?b.removeProperty(a):b.removeAttribute(CKEDITOR.tools.cssStyleToDomStyle(a));this.$.style.cssText||this.removeAttribute("style")}},setStyle:function(a,b){this.$.style[CKEDITOR.tools.cssStyleToDomStyle(a)]=b;return this},setStyles:function(a){for(var b in a)this.setStyle(b,a[b]);return this},setOpacity:function(a){if(CKEDITOR.env.ie&&CKEDITOR.env.version<9){a=Math.round(a*100);this.setStyle("filter",a>=100?"":"progid:DXImageTransform.Microsoft.Alpha(opacity="+
a+")")}else this.setStyle("opacity",a)},unselectable:function(){this.setStyles(CKEDITOR.tools.cssVendorPrefix("user-select","none"));if(CKEDITOR.env.ie){this.setAttribute("unselectable","on");for(var a,b=this.getElementsByTag("*"),c=0,g=b.count();c<g;c++){a=b.getItem(c);a.setAttribute("unselectable","on")}}},getPositionedAncestor:function(){for(var a=this;a.getName()!="html";){if(a.getComputedStyle("position")!="static")return a;a=a.getParent()}return null},getDocumentPosition:function(a){var b=0,
c=0,g=this.getDocument(),d=g.getBody(),r=g.$.compatMode=="BackCompat";if(document.documentElement.getBoundingClientRect){var e=this.$.getBoundingClientRect(),o=g.$.documentElement,q=o.clientTop||d.$.clientTop||0,f=o.clientLeft||d.$.clientLeft||0,h=true;if(CKEDITOR.env.ie){h=g.getDocumentElement().contains(this);g=g.getBody().contains(this);h=r&&g||!r&&h}if(h){if(CKEDITOR.env.webkit||CKEDITOR.env.ie&&CKEDITOR.env.version>=12){b=d.$.scrollLeft||o.scrollLeft;c=d.$.scrollTop||o.scrollTop}else{c=r?d.$:
o;b=c.scrollLeft;c=c.scrollTop}b=e.left+b-f;c=e.top+c-q}}else{q=this;for(f=null;q&&!(q.getName()=="body"||q.getName()=="html");){b=b+(q.$.offsetLeft-q.$.scrollLeft);c=c+(q.$.offsetTop-q.$.scrollTop);if(!q.equals(this)){b=b+(q.$.clientLeft||0);c=c+(q.$.clientTop||0)}for(;f&&!f.equals(q);){b=b-f.$.scrollLeft;c=c-f.$.scrollTop;f=f.getParent()}f=q;q=(e=q.$.offsetParent)?new CKEDITOR.dom.element(e):null}}if(a){e=this.getWindow();q=a.getWindow();if(!e.equals(q)&&e.$.frameElement){a=(new CKEDITOR.dom.element(e.$.frameElement)).getDocumentPosition(a);
b=b+a.x;c=c+a.y}}if(!document.documentElement.getBoundingClientRect&&CKEDITOR.env.gecko&&!r){b=b+(this.$.clientLeft?1:0);c=c+(this.$.clientTop?1:0)}return{x:b,y:c}},scrollIntoView:function(a){var b=this.getParent();if(b){do{(b.$.clientWidth&&b.$.clientWidth<b.$.scrollWidth||b.$.clientHeight&&b.$.clientHeight<b.$.scrollHeight)&&!b.is("body")&&this.scrollIntoParent(b,a,1);if(b.is("html")){var c=b.getWindow();try{var g=c.$.frameElement;g&&(b=new CKEDITOR.dom.element(g))}catch(d){}}}while(b=b.getParent())
}},scrollIntoParent:function(a,b,c){var g,d,e,f;function o(b,c){if(/body|html/.test(a.getName()))a.getWindow().$.scrollBy(b,c);else{a.$.scrollLeft=a.$.scrollLeft+b;a.$.scrollTop=a.$.scrollTop+c}}function q(a,b){var c={x:0,y:0};if(!a.is(w?"body":"html")){var g=a.$.getBoundingClientRect();c.x=g.left;c.y=g.top}g=a.getWindow();if(!g.equals(b)){g=q(CKEDITOR.dom.element.get(g.$.frameElement),b);c.x=c.x+g.x;c.y=c.y+g.y}return c}function h(a,b){return parseInt(a.getComputedStyle("margin-"+b)||0,10)||0}!a&&
(a=this.getWindow());e=a.getDocument();var w=e.$.compatMode=="BackCompat";a instanceof CKEDITOR.dom.window&&(a=w?e.getBody():e.getDocumentElement());e=a.getWindow();d=q(this,e);var v=q(a,e),B=this.$.offsetHeight;g=this.$.offsetWidth;var l=a.$.clientHeight,s=a.$.clientWidth;e=d.x-h(this,"left")-v.x||0;f=d.y-h(this,"top")-v.y||0;g=d.x+g+h(this,"right")-(v.x+s)||0;d=d.y+B+h(this,"bottom")-(v.y+l)||0;if(f<0||d>0)o(0,b===true?f:b===false?d:f<0?f:d);if(c&&(e<0||g>0))o(e<0?e:g,0)},setState:function(a,b,
c){b=b||"cke";switch(a){case CKEDITOR.TRISTATE_ON:this.addClass(b+"_on");this.removeClass(b+"_off");this.removeClass(b+"_disabled");c&&this.setAttribute("aria-pressed",true);c&&this.removeAttribute("aria-disabled");break;case CKEDITOR.TRISTATE_DISABLED:this.addClass(b+"_disabled");this.removeClass(b+"_off");this.removeClass(b+"_on");c&&this.setAttribute("aria-disabled",true);c&&this.removeAttribute("aria-pressed");break;default:this.addClass(b+"_off");this.removeClass(b+"_on");this.removeClass(b+
"_disabled");c&&this.removeAttribute("aria-pressed");c&&this.removeAttribute("aria-disabled")}},getFrameDocument:function(){var a=this.$;try{a.contentWindow.document}catch(b){a.src=a.src}return a&&new CKEDITOR.dom.document(a.contentWindow.document)},copyAttributes:function(a,b){for(var c=this.$.attributes,b=b||{},g=0;g<c.length;g++){var d=c[g],e=d.nodeName.toLowerCase(),f;if(!(e in b))if(e=="checked"&&(f=this.getAttribute(e)))a.setAttribute(e,f);else if(!CKEDITOR.env.ie||this.hasAttribute(e)){f=this.getAttribute(e);
if(f===null)f=d.nodeValue;a.setAttribute(e,f)}}if(this.$.style.cssText!=="")a.$.style.cssText=this.$.style.cssText},renameNode:function(a){if(this.getName()!=a){var b=this.getDocument(),a=new CKEDITOR.dom.element(a,b);this.copyAttributes(a);this.moveChildren(a);this.getParent(true)&&this.$.parentNode.replaceChild(a.$,this.$);a.$["data-cke-expando"]=this.$["data-cke-expando"];this.$=a.$;delete this.getName}},getChild:function(){function a(b,c){var g=b.childNodes;if(c>=0&&c<g.length)return g[c]}return function(b){var c=
this.$;if(b.slice)for(b=b.slice();b.length>0&&c;)c=a(c,b.shift());else c=a(c,b);return c?new CKEDITOR.dom.node(c):null}}(),getChildCount:function(){return this.$.childNodes.length},disableContextMenu:function(){this.on("contextmenu",function(a){a.data.getTarget().hasClass("cke_enable_context_menu")||a.data.preventDefault()})},getDirection:function(a){return a?this.getComputedStyle("direction")||this.getDirection()||this.getParent()&&this.getParent().getDirection(1)||this.getDocument().$.dir||"ltr":
this.getStyle("direction")||this.getAttribute("dir")},data:function(a,b){a="data-"+a;if(b===void 0)return this.getAttribute(a);b===false?this.removeAttribute(a):this.setAttribute(a,b);return null},getEditor:function(){var a=CKEDITOR.instances,b,c;for(b in a){c=a[b];if(c.element.equals(this)&&c.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO)return c}return null},find:function(a){var c=d(this),a=new CKEDITOR.dom.nodeList(this.$.querySelectorAll(b(this,a)));c();return a},findOne:function(a){var c=d(this),
a=this.$.querySelector(b(this,a));c();return a?new CKEDITOR.dom.element(a):null},forEach:function(a,b,c){if(!c&&(!b||this.type==b))var g=a(this);if(g!==false)for(var c=this.getChildren(),d=0;d<c.count();d++){g=c.getItem(d);g.type==CKEDITOR.NODE_ELEMENT?g.forEach(a,b):(!b||g.type==b)&&a(g)}}});var h={width:["border-left-width","border-right-width","padding-left","padding-right"],height:["border-top-width","border-bottom-width","padding-top","padding-bottom"]};CKEDITOR.dom.element.prototype.setSize=
function(a,b,d){if(typeof b=="number"){if(d&&(!CKEDITOR.env.ie||!CKEDITOR.env.quirks))b=b-c.call(this,a);this.setStyle(a,b+"px")}};CKEDITOR.dom.element.prototype.getSize=function(a,b){var d=Math.max(this.$["offset"+CKEDITOR.tools.capitalize(a)],this.$["client"+CKEDITOR.tools.capitalize(a)])||0;b&&(d=d-c.call(this,a));return d}})();CKEDITOR.dom.documentFragment=function(a){a=a||CKEDITOR.document;this.$=a.type==CKEDITOR.NODE_DOCUMENT?a.$.createDocumentFragment():a};
CKEDITOR.tools.extend(CKEDITOR.dom.documentFragment.prototype,CKEDITOR.dom.element.prototype,{type:CKEDITOR.NODE_DOCUMENT_FRAGMENT,insertAfterNode:function(a){a=a.$;a.parentNode.insertBefore(this.$,a.nextSibling)},getHtml:function(){var a=new CKEDITOR.dom.element("div");this.clone(1,1).appendTo(a);return a.getHtml().replace(/\s*data-cke-expando=".*?"/g,"")}},!0,{append:1,appendBogus:1,clone:1,getFirst:1,getHtml:1,getLast:1,getParent:1,getNext:1,getPrevious:1,appendTo:1,moveChildren:1,insertBefore:1,
insertAfterNode:1,replace:1,trim:1,type:1,ltrim:1,rtrim:1,getDocument:1,getChildCount:1,getChild:1,getChildren:1});
(function(){function a(a,b){var c=this.range;if(this._.end)return null;if(!this._.start){this._.start=1;if(c.collapsed){this.end();return null}c.optimize()}var g,d=c.startContainer;g=c.endContainer;var e=c.startOffset,f=c.endOffset,h,i=this.guard,l=this.type,s=a?"getPreviousSourceNode":"getNextSourceNode";if(!a&&!this._.guardLTR){var k=g.type==CKEDITOR.NODE_ELEMENT?g:g.getParent(),m=g.type==CKEDITOR.NODE_ELEMENT?g.getChild(f):g.getNext();this._.guardLTR=function(a,b){return(!b||!k.equals(a))&&(!m||
!a.equals(m))&&(a.type!=CKEDITOR.NODE_ELEMENT||!b||!a.equals(c.root))}}if(a&&!this._.guardRTL){var F=d.type==CKEDITOR.NODE_ELEMENT?d:d.getParent(),p=d.type==CKEDITOR.NODE_ELEMENT?e?d.getChild(e-1):null:d.getPrevious();this._.guardRTL=function(a,b){return(!b||!F.equals(a))&&(!p||!a.equals(p))&&(a.type!=CKEDITOR.NODE_ELEMENT||!b||!a.equals(c.root))}}var I=a?this._.guardRTL:this._.guardLTR;h=i?function(a,b){return I(a,b)===false?false:i(a,b)}:I;if(this.current)g=this.current[s](false,l,h);else{if(a)g.type==
CKEDITOR.NODE_ELEMENT&&(g=f>0?g.getChild(f-1):h(g,true)===false?null:g.getPreviousSourceNode(true,l,h));else{g=d;if(g.type==CKEDITOR.NODE_ELEMENT&&!(g=g.getChild(e)))g=h(d,true)===false?null:d.getNextSourceNode(true,l,h)}g&&h(g)===false&&(g=null)}for(;g&&!this._.end;){this.current=g;if(!this.evaluator||this.evaluator(g)!==false){if(!b)return g}else if(b&&this.evaluator)return false;g=g[s](false,l,h)}this.end();return this.current=null}function d(b){for(var c,g=null;c=a.call(this,b);)g=c;return g}
CKEDITOR.dom.walker=CKEDITOR.tools.createClass({$:function(a){this.range=a;this._={}},proto:{end:function(){this._.end=1},next:function(){return a.call(this)},previous:function(){return a.call(this,1)},checkForward:function(){return a.call(this,0,1)!==false},checkBackward:function(){return a.call(this,1,1)!==false},lastForward:function(){return d.call(this)},lastBackward:function(){return d.call(this,1)},reset:function(){delete this.current;this._={}}}});var b={block:1,"list-item":1,table:1,"table-row-group":1,
"table-header-group":1,"table-footer-group":1,"table-row":1,"table-column-group":1,"table-column":1,"table-cell":1,"table-caption":1},c={absolute:1,fixed:1};CKEDITOR.dom.element.prototype.isBlockBoundary=function(a){return this.getComputedStyle("float")=="none"&&!(this.getComputedStyle("position")in c)&&b[this.getComputedStyle("display")]?true:!!(this.is(CKEDITOR.dtd.$block)||a&&this.is(a))};CKEDITOR.dom.walker.blockBoundary=function(a){return function(b){return!(b.type==CKEDITOR.NODE_ELEMENT&&b.isBlockBoundary(a))}};
CKEDITOR.dom.walker.listItemBoundary=function(){return this.blockBoundary({br:1})};CKEDITOR.dom.walker.bookmark=function(a,b){function c(a){return a&&a.getName&&a.getName()=="span"&&a.data("cke-bookmark")}return function(g){var d,e;d=g&&g.type!=CKEDITOR.NODE_ELEMENT&&(e=g.getParent())&&c(e);d=a?d:d||c(g);return!!(b^d)}};CKEDITOR.dom.walker.whitespaces=function(a){return function(b){var c;b&&b.type==CKEDITOR.NODE_TEXT&&(c=!CKEDITOR.tools.trim(b.getText())||CKEDITOR.env.webkit&&b.getText()=="​");return!!(a^
c)}};CKEDITOR.dom.walker.invisible=function(a){var b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.env.webkit?1:0;return function(g){if(b(g))g=1;else{g.type==CKEDITOR.NODE_TEXT&&(g=g.getParent());g=g.$.offsetWidth<=c}return!!(a^g)}};CKEDITOR.dom.walker.nodeType=function(a,b){return function(c){return!!(b^c.type==a)}};CKEDITOR.dom.walker.bogus=function(a){function b(a){return!f(a)&&!h(a)}return function(c){var g=CKEDITOR.env.needsBrFiller?c.is&&c.is("br"):c.getText&&e.test(c.getText());if(g){g=c.getParent();
c=c.getNext(b);g=g.isBlockBoundary()&&(!c||c.type==CKEDITOR.NODE_ELEMENT&&c.isBlockBoundary())}return!!(a^g)}};CKEDITOR.dom.walker.temp=function(a){return function(b){b.type!=CKEDITOR.NODE_ELEMENT&&(b=b.getParent());b=b&&b.hasAttribute("data-cke-temp");return!!(a^b)}};var e=/^[\t\r\n ]*(?:&nbsp;|\xa0)$/,f=CKEDITOR.dom.walker.whitespaces(),h=CKEDITOR.dom.walker.bookmark(),i=CKEDITOR.dom.walker.temp();CKEDITOR.dom.walker.ignored=function(a){return function(b){b=f(b)||h(b)||i(b);return!!(a^b)}};var j=
CKEDITOR.dom.walker.ignored();CKEDITOR.dom.walker.empty=function(a){return function(b){for(var c=0,g=b.getChildCount();c<g;++c)if(!j(b.getChild(c)))return!!a;return!a}};var n=CKEDITOR.dom.walker.empty(),g=CKEDITOR.dom.walker.validEmptyBlockContainers=CKEDITOR.tools.extend(function(a){var b={},c;for(c in a)CKEDITOR.dtd[c]["#"]&&(b[c]=1);return b}(CKEDITOR.dtd.$block),{caption:1,td:1,th:1});CKEDITOR.dom.walker.editable=function(a){return function(b){return!!(a^(j(b)?0:b.type==CKEDITOR.NODE_TEXT||b.type==
CKEDITOR.NODE_ELEMENT&&(b.is(CKEDITOR.dtd.$inline)||(b.is("hr")||b.getAttribute("contenteditable")=="false")||!CKEDITOR.env.needsBrFiller&&b.is(g)&&n(b))?1:0))}};CKEDITOR.dom.element.prototype.getBogus=function(){var a=this;do a=a.getPreviousSourceNode();while(h(a)||f(a)||a.type==CKEDITOR.NODE_ELEMENT&&a.is(CKEDITOR.dtd.$inline)&&!a.is(CKEDITOR.dtd.$empty));return a&&(CKEDITOR.env.needsBrFiller?a.is&&a.is("br"):a.getText&&e.test(a.getText()))?a:false}})();
CKEDITOR.dom.range=function(a){this.endOffset=this.endContainer=this.startOffset=this.startContainer=null;this.collapsed=true;var d=a instanceof CKEDITOR.dom.document;this.document=d?a:a.getDocument();this.root=d?a.getBody():a};
(function(){function a(a){a.collapsed=a.startContainer&&a.endContainer&&a.startContainer.equals(a.endContainer)&&a.startOffset==a.endOffset}function d(a,b,c,d,o){function e(a,b,c,g){var k=c?a.getPrevious():a.getNext();if(g&&i)return k;if(l||g)b.append(a.clone(true,o),c);else{a.remove();n&&b.append(a)}return k}function f(){var a,b,c,g=Math.min(K.length,C.length);for(a=0;a<g;a++){b=K[a];c=C[a];if(!b.equals(c))return a}return a-1}function h(){var b=x-1,c=z&&L&&!s.equals(k);if(b<D-1||b<G-1||c){c?a.moveToPosition(k,
CKEDITOR.POSITION_BEFORE_START):G==b+1&&I?a.moveToPosition(C[b],CKEDITOR.POSITION_BEFORE_END):a.moveToPosition(C[b+1],CKEDITOR.POSITION_BEFORE_START);if(d)if((b=K[b+1])&&b.type==CKEDITOR.NODE_ELEMENT){c=CKEDITOR.dom.element.createFromHtml('<span data-cke-bookmark="1" style="display:none">&nbsp;</span>',a.document);c.insertAfter(b);b.mergeSiblings(false);a.moveToBookmark({startNode:c})}}else a.collapse(true)}a.optimizeBookmark();var i=b===0,n=b==1,l=b==2,b=l||n,s=a.startContainer,k=a.endContainer,
m=a.startOffset,F=a.endOffset,p,I,z,L,E,u;if(l&&k.type==CKEDITOR.NODE_TEXT&&s.equals(k)){s=a.document.createText(s.substring(m,F));c.append(s)}else{if(k.type==CKEDITOR.NODE_TEXT)l?u=true:k=k.split(F);else if(k.getChildCount()>0)if(F>=k.getChildCount()){k=k.getChild(F-1);I=true}else k=k.getChild(F);else L=I=true;if(s.type==CKEDITOR.NODE_TEXT)l?E=true:s.split(m);else if(s.getChildCount()>0)if(m===0){s=s.getChild(m);p=true}else s=s.getChild(m-1);else z=p=true;for(var K=s.getParents(),C=k.getParents(),
x=f(),D=K.length-1,G=C.length-1,M=c,j,U,T,Z=-1,N=x;N<=D;N++){U=K[N];T=U.getNext();for(N==D&&!(U.equals(C[N])&&D<G)?p?e(U,M,false,z):E&&M.append(a.document.createText(U.substring(m))):b&&(j=M.append(U.clone(0,o)));T;){if(T.equals(C[N])){Z=N;break}T=e(T,M)}M=j}M=c;for(N=x;N<=G;N++){c=C[N];T=c.getPrevious();if(c.equals(K[N]))b&&(M=M.getChild(0));else{N==G&&!(c.equals(K[N])&&G<D)?I?e(c,M,false,L):u&&M.append(a.document.createText(c.substring(0,F))):b&&(j=M.append(c.clone(0,o)));if(N>Z)for(;T;)T=e(T,M,
true);M=j}}l||h()}}function b(){var a=false,b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.dom.walker.bookmark(true),d=CKEDITOR.dom.walker.bogus();return function(o){if(c(o)||b(o))return true;if(d(o)&&!a)return a=true;return o.type==CKEDITOR.NODE_TEXT&&(o.hasAscendant("pre")||CKEDITOR.tools.trim(o.getText()).length)||o.type==CKEDITOR.NODE_ELEMENT&&!o.is(f)?false:true}}function c(a){var b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.dom.walker.bookmark(1);return function(d){return c(d)||b(d)?true:
!a&&h(d)||d.type==CKEDITOR.NODE_ELEMENT&&d.is(CKEDITOR.dtd.$removeEmpty)}}function e(a){return function(){var b;return this[a?"getPreviousNode":"getNextNode"](function(a){!b&&n(a)&&(b=a);return j(a)&&!(h(a)&&a.equals(b))})}}var f={abbr:1,acronym:1,b:1,bdo:1,big:1,cite:1,code:1,del:1,dfn:1,em:1,font:1,i:1,ins:1,label:1,kbd:1,q:1,samp:1,small:1,span:1,strike:1,strong:1,sub:1,sup:1,tt:1,u:1,"var":1},h=CKEDITOR.dom.walker.bogus(),i=/^[\t\r\n ]*(?:&nbsp;|\xa0)$/,j=CKEDITOR.dom.walker.editable(),n=CKEDITOR.dom.walker.ignored(true);
CKEDITOR.dom.range.prototype={clone:function(){var a=new CKEDITOR.dom.range(this.root);a._setStartContainer(this.startContainer);a.startOffset=this.startOffset;a._setEndContainer(this.endContainer);a.endOffset=this.endOffset;a.collapsed=this.collapsed;return a},collapse:function(a){if(a){this._setEndContainer(this.startContainer);this.endOffset=this.startOffset}else{this._setStartContainer(this.endContainer);this.startOffset=this.endOffset}this.collapsed=true},cloneContents:function(a){var b=new CKEDITOR.dom.documentFragment(this.document);
this.collapsed||d(this,2,b,false,typeof a=="undefined"?true:a);return b},deleteContents:function(a){this.collapsed||d(this,0,null,a)},extractContents:function(a,b){var c=new CKEDITOR.dom.documentFragment(this.document);this.collapsed||d(this,1,c,a,typeof b=="undefined"?true:b);return c},createBookmark:function(a){var b,c,d,o,e=this.collapsed;b=this.document.createElement("span");b.data("cke-bookmark",1);b.setStyle("display","none");b.setHtml("&nbsp;");if(a){d="cke_bm_"+CKEDITOR.tools.getNextNumber();
b.setAttribute("id",d+(e?"C":"S"))}if(!e){c=b.clone();c.setHtml("&nbsp;");a&&c.setAttribute("id",d+"E");o=this.clone();o.collapse();o.insertNode(c)}o=this.clone();o.collapse(true);o.insertNode(b);if(c){this.setStartAfter(b);this.setEndBefore(c)}else this.moveToPosition(b,CKEDITOR.POSITION_AFTER_END);return{startNode:a?d+(e?"C":"S"):b,endNode:a?d+"E":c,serializable:a,collapsed:e}},createBookmark2:function(){function a(c){var g=c.container,d=c.offset,e;e=g;var f=d;e=e.type!=CKEDITOR.NODE_ELEMENT||f===
0||f==e.getChildCount()?0:e.getChild(f-1).type==CKEDITOR.NODE_TEXT&&e.getChild(f).type==CKEDITOR.NODE_TEXT;if(e){g=g.getChild(d-1);d=g.getLength()}g.type==CKEDITOR.NODE_ELEMENT&&d>1&&(d=g.getChild(d-1).getIndex(true)+1);if(g.type==CKEDITOR.NODE_TEXT){e=g;for(f=0;(e=e.getPrevious())&&e.type==CKEDITOR.NODE_TEXT;)f=f+e.getLength();e=f;if(g.getText())d=d+e;else{f=g.getPrevious(b);if(e){d=e;g=f?f.getNext():g.getParent().getFirst()}else{g=g.getParent();d=f?f.getIndex(true)+1:0}}}c.container=g;c.offset=
d}var b=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_TEXT,true);return function(b){var c=this.collapsed,d={container:this.startContainer,offset:this.startOffset},e={container:this.endContainer,offset:this.endOffset};if(b){a(d);c||a(e)}return{start:d.container.getAddress(b),end:c?null:e.container.getAddress(b),startOffset:d.offset,endOffset:e.offset,normalized:b,collapsed:c,is2:true}}}(),moveToBookmark:function(a){if(a.is2){var b=this.document.getByAddress(a.start,a.normalized),c=a.startOffset,d=a.end&&
this.document.getByAddress(a.end,a.normalized),a=a.endOffset;this.setStart(b,c);d?this.setEnd(d,a):this.collapse(true)}else{b=(c=a.serializable)?this.document.getById(a.startNode):a.startNode;a=c?this.document.getById(a.endNode):a.endNode;this.setStartBefore(b);b.remove();if(a){this.setEndBefore(a);a.remove()}else this.collapse(true)}},getBoundaryNodes:function(){var a=this.startContainer,b=this.endContainer,c=this.startOffset,d=this.endOffset,e;if(a.type==CKEDITOR.NODE_ELEMENT){e=a.getChildCount();
if(e>c)a=a.getChild(c);else if(e<1)a=a.getPreviousSourceNode();else{for(a=a.$;a.lastChild;)a=a.lastChild;a=new CKEDITOR.dom.node(a);a=a.getNextSourceNode()||a}}if(b.type==CKEDITOR.NODE_ELEMENT){e=b.getChildCount();if(e>d)b=b.getChild(d).getPreviousSourceNode(true);else if(e<1)b=b.getPreviousSourceNode();else{for(b=b.$;b.lastChild;)b=b.lastChild;b=new CKEDITOR.dom.node(b)}}a.getPosition(b)&CKEDITOR.POSITION_FOLLOWING&&(a=b);return{startNode:a,endNode:b}},getCommonAncestor:function(a,b){var c=this.startContainer,
d=this.endContainer,c=c.equals(d)?a&&c.type==CKEDITOR.NODE_ELEMENT&&this.startOffset==this.endOffset-1?c.getChild(this.startOffset):c:c.getCommonAncestor(d);return b&&!c.is?c.getParent():c},optimize:function(){var a=this.startContainer,b=this.startOffset;a.type!=CKEDITOR.NODE_ELEMENT&&(b?b>=a.getLength()&&this.setStartAfter(a):this.setStartBefore(a));a=this.endContainer;b=this.endOffset;a.type!=CKEDITOR.NODE_ELEMENT&&(b?b>=a.getLength()&&this.setEndAfter(a):this.setEndBefore(a))},optimizeBookmark:function(){var a=
this.startContainer,b=this.endContainer;a.is&&(a.is("span")&&a.data("cke-bookmark"))&&this.setStartAt(a,CKEDITOR.POSITION_BEFORE_START);b&&(b.is&&b.is("span")&&b.data("cke-bookmark"))&&this.setEndAt(b,CKEDITOR.POSITION_AFTER_END)},trim:function(a,b){var c=this.startContainer,d=this.startOffset,e=this.collapsed;if((!a||e)&&c&&c.type==CKEDITOR.NODE_TEXT){if(d)if(d>=c.getLength()){d=c.getIndex()+1;c=c.getParent()}else{var f=c.split(d),d=c.getIndex()+1,c=c.getParent();if(this.startContainer.equals(this.endContainer))this.setEnd(f,
this.endOffset-this.startOffset);else if(c.equals(this.endContainer))this.endOffset=this.endOffset+1}else{d=c.getIndex();c=c.getParent()}this.setStart(c,d);if(e){this.collapse(true);return}}c=this.endContainer;d=this.endOffset;if(!b&&!e&&c&&c.type==CKEDITOR.NODE_TEXT){if(d){d>=c.getLength()||c.split(d);d=c.getIndex()+1}else d=c.getIndex();c=c.getParent();this.setEnd(c,d)}},enlarge:function(a,b){function c(a){return a&&a.type==CKEDITOR.NODE_ELEMENT&&a.hasAttribute("contenteditable")?null:a}var d=RegExp(/[^\s\ufeff]/);
switch(a){case CKEDITOR.ENLARGE_INLINE:var e=1;case CKEDITOR.ENLARGE_ELEMENT:if(this.collapsed)break;var f=this.getCommonAncestor(),h=this.root,i,n,j,l,s,k=false,m,F;m=this.startContainer;var p=this.startOffset;if(m.type==CKEDITOR.NODE_TEXT){if(p){m=!CKEDITOR.tools.trim(m.substring(0,p)).length&&m;k=!!m}if(m&&!(l=m.getPrevious()))j=m.getParent()}else{p&&(l=m.getChild(p-1)||m.getLast());l||(j=m)}for(j=c(j);j||l;){if(j&&!l){!s&&j.equals(f)&&(s=true);if(e?j.isBlockBoundary():!h.contains(j))break;if(!k||
j.getComputedStyle("display")!="inline"){k=false;s?i=j:this.setStartBefore(j)}l=j.getPrevious()}for(;l;){m=false;if(l.type==CKEDITOR.NODE_COMMENT)l=l.getPrevious();else{if(l.type==CKEDITOR.NODE_TEXT){F=l.getText();d.test(F)&&(l=null);m=/[\s\ufeff]$/.test(F)}else if((l.$.offsetWidth>(CKEDITOR.env.webkit?1:0)||b&&l.is("br"))&&!l.data("cke-bookmark"))if(k&&CKEDITOR.dtd.$removeEmpty[l.getName()]){F=l.getText();if(d.test(F))l=null;else for(var p=l.$.getElementsByTagName("*"),I=0,z;z=p[I++];)if(!CKEDITOR.dtd.$removeEmpty[z.nodeName.toLowerCase()]){l=
null;break}l&&(m=!!F.length)}else l=null;m&&(k?s?i=j:j&&this.setStartBefore(j):k=true);if(l){m=l.getPrevious();if(!j&&!m){j=l;l=null;break}l=m}else j=null}}j&&(j=c(j.getParent()))}m=this.endContainer;p=this.endOffset;j=l=null;s=k=false;var L=function(a,b){var c=new CKEDITOR.dom.range(h);c.setStart(a,b);c.setEndAt(h,CKEDITOR.POSITION_BEFORE_END);var c=new CKEDITOR.dom.walker(c),g;for(c.guard=function(a){return!(a.type==CKEDITOR.NODE_ELEMENT&&a.isBlockBoundary())};g=c.next();){if(g.type!=CKEDITOR.NODE_TEXT)return false;
F=g!=a?g.getText():g.substring(b);if(d.test(F))return false}return true};if(m.type==CKEDITOR.NODE_TEXT)if(CKEDITOR.tools.trim(m.substring(p)).length)k=true;else{k=!m.getLength();if(p==m.getLength()){if(!(l=m.getNext()))j=m.getParent()}else L(m,p)&&(j=m.getParent())}else(l=m.getChild(p))||(j=m);for(;j||l;){if(j&&!l){!s&&j.equals(f)&&(s=true);if(e?j.isBlockBoundary():!h.contains(j))break;if(!k||j.getComputedStyle("display")!="inline"){k=false;s?n=j:j&&this.setEndAfter(j)}l=j.getNext()}for(;l;){m=false;
if(l.type==CKEDITOR.NODE_TEXT){F=l.getText();L(l,0)||(l=null);m=/^[\s\ufeff]/.test(F)}else if(l.type==CKEDITOR.NODE_ELEMENT){if((l.$.offsetWidth>0||b&&l.is("br"))&&!l.data("cke-bookmark"))if(k&&CKEDITOR.dtd.$removeEmpty[l.getName()]){F=l.getText();if(d.test(F))l=null;else{p=l.$.getElementsByTagName("*");for(I=0;z=p[I++];)if(!CKEDITOR.dtd.$removeEmpty[z.nodeName.toLowerCase()]){l=null;break}}l&&(m=!!F.length)}else l=null}else m=1;m&&k&&(s?n=j:this.setEndAfter(j));if(l){m=l.getNext();if(!j&&!m){j=l;
l=null;break}l=m}else j=null}j&&(j=c(j.getParent()))}if(i&&n){f=i.contains(n)?n:i;this.setStartBefore(f);this.setEndAfter(f)}break;case CKEDITOR.ENLARGE_BLOCK_CONTENTS:case CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS:j=new CKEDITOR.dom.range(this.root);h=this.root;j.setStartAt(h,CKEDITOR.POSITION_AFTER_START);j.setEnd(this.startContainer,this.startOffset);j=new CKEDITOR.dom.walker(j);var E,u,K=CKEDITOR.dom.walker.blockBoundary(a==CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS?{br:1}:null),C=null,x=function(a){if(a.type==
CKEDITOR.NODE_ELEMENT&&a.getAttribute("contenteditable")=="false")if(C){if(C.equals(a)){C=null;return}}else C=a;else if(C)return;var b=K(a);b||(E=a);return b},e=function(a){var b=x(a);!b&&(a.is&&a.is("br"))&&(u=a);return b};j.guard=x;j=j.lastBackward();E=E||h;this.setStartAt(E,!E.is("br")&&(!j&&this.checkStartOfBlock()||j&&E.contains(j))?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_AFTER_END);if(a==CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS){j=this.clone();j=new CKEDITOR.dom.walker(j);var D=CKEDITOR.dom.walker.whitespaces(),
G=CKEDITOR.dom.walker.bookmark();j.evaluator=function(a){return!D(a)&&!G(a)};if((j=j.previous())&&j.type==CKEDITOR.NODE_ELEMENT&&j.is("br"))break}j=this.clone();j.collapse();j.setEndAt(h,CKEDITOR.POSITION_BEFORE_END);j=new CKEDITOR.dom.walker(j);j.guard=a==CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS?e:x;E=C=u=null;j=j.lastForward();E=E||h;this.setEndAt(E,!j&&this.checkEndOfBlock()||j&&E.contains(j)?CKEDITOR.POSITION_BEFORE_END:CKEDITOR.POSITION_BEFORE_START);u&&this.setEndAfter(u)}},shrink:function(a,b,c){if(!this.collapsed){var a=
a||CKEDITOR.SHRINK_TEXT,d=this.clone(),e=this.startContainer,f=this.endContainer,h=this.startOffset,i=this.endOffset,j=1,n=1;if(e&&e.type==CKEDITOR.NODE_TEXT)if(h)if(h>=e.getLength())d.setStartAfter(e);else{d.setStartBefore(e);j=0}else d.setStartBefore(e);if(f&&f.type==CKEDITOR.NODE_TEXT)if(i)if(i>=f.getLength())d.setEndAfter(f);else{d.setEndAfter(f);n=0}else d.setEndBefore(f);var d=new CKEDITOR.dom.walker(d),l=CKEDITOR.dom.walker.bookmark();d.evaluator=function(b){return b.type==(a==CKEDITOR.SHRINK_ELEMENT?
CKEDITOR.NODE_ELEMENT:CKEDITOR.NODE_TEXT)};var s;d.guard=function(b,d){if(l(b))return true;if(a==CKEDITOR.SHRINK_ELEMENT&&b.type==CKEDITOR.NODE_TEXT||d&&b.equals(s)||c===false&&b.type==CKEDITOR.NODE_ELEMENT&&b.isBlockBoundary()||b.type==CKEDITOR.NODE_ELEMENT&&b.hasAttribute("contenteditable"))return false;!d&&b.type==CKEDITOR.NODE_ELEMENT&&(s=b);return true};if(j)(e=d[a==CKEDITOR.SHRINK_ELEMENT?"lastForward":"next"]())&&this.setStartAt(e,b?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_START);
if(n){d.reset();(d=d[a==CKEDITOR.SHRINK_ELEMENT?"lastBackward":"previous"]())&&this.setEndAt(d,b?CKEDITOR.POSITION_BEFORE_END:CKEDITOR.POSITION_AFTER_END)}return!(!j&&!n)}},insertNode:function(a){this.optimizeBookmark();this.trim(false,true);var b=this.startContainer,c=b.getChild(this.startOffset);c?a.insertBefore(c):b.append(a);a.getParent()&&a.getParent().equals(this.endContainer)&&this.endOffset++;this.setStartBefore(a)},moveToPosition:function(a,b){this.setStartAt(a,b);this.collapse(true)},moveToRange:function(a){this.setStart(a.startContainer,
a.startOffset);this.setEnd(a.endContainer,a.endOffset)},selectNodeContents:function(a){this.setStart(a,0);this.setEnd(a,a.type==CKEDITOR.NODE_TEXT?a.getLength():a.getChildCount())},setStart:function(b,c){if(b.type==CKEDITOR.NODE_ELEMENT&&CKEDITOR.dtd.$empty[b.getName()]){c=b.getIndex();b=b.getParent()}this._setStartContainer(b);this.startOffset=c;if(!this.endContainer){this._setEndContainer(b);this.endOffset=c}a(this)},setEnd:function(b,c){if(b.type==CKEDITOR.NODE_ELEMENT&&CKEDITOR.dtd.$empty[b.getName()]){c=
b.getIndex()+1;b=b.getParent()}this._setEndContainer(b);this.endOffset=c;if(!this.startContainer){this._setStartContainer(b);this.startOffset=c}a(this)},setStartAfter:function(a){this.setStart(a.getParent(),a.getIndex()+1)},setStartBefore:function(a){this.setStart(a.getParent(),a.getIndex())},setEndAfter:function(a){this.setEnd(a.getParent(),a.getIndex()+1)},setEndBefore:function(a){this.setEnd(a.getParent(),a.getIndex())},setStartAt:function(b,c){switch(c){case CKEDITOR.POSITION_AFTER_START:this.setStart(b,
0);break;case CKEDITOR.POSITION_BEFORE_END:b.type==CKEDITOR.NODE_TEXT?this.setStart(b,b.getLength()):this.setStart(b,b.getChildCount());break;case CKEDITOR.POSITION_BEFORE_START:this.setStartBefore(b);break;case CKEDITOR.POSITION_AFTER_END:this.setStartAfter(b)}a(this)},setEndAt:function(b,c){switch(c){case CKEDITOR.POSITION_AFTER_START:this.setEnd(b,0);break;case CKEDITOR.POSITION_BEFORE_END:b.type==CKEDITOR.NODE_TEXT?this.setEnd(b,b.getLength()):this.setEnd(b,b.getChildCount());break;case CKEDITOR.POSITION_BEFORE_START:this.setEndBefore(b);
break;case CKEDITOR.POSITION_AFTER_END:this.setEndAfter(b)}a(this)},fixBlock:function(a,b){var c=this.createBookmark(),d=this.document.createElement(b);this.collapse(a);this.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS);this.extractContents().appendTo(d);d.trim();this.insertNode(d);var e=d.getBogus();e&&e.remove();d.appendBogus();this.moveToBookmark(c);return d},splitBlock:function(a,b){var c=new CKEDITOR.dom.elementPath(this.startContainer,this.root),d=new CKEDITOR.dom.elementPath(this.endContainer,this.root),
e=c.block,f=d.block,h=null;if(!c.blockLimit.equals(d.blockLimit))return null;if(a!="br"){if(!e){e=this.fixBlock(true,a);f=(new CKEDITOR.dom.elementPath(this.endContainer,this.root)).block}f||(f=this.fixBlock(false,a))}c=e&&this.checkStartOfBlock();d=f&&this.checkEndOfBlock();this.deleteContents();if(e&&e.equals(f))if(d){h=new CKEDITOR.dom.elementPath(this.startContainer,this.root);this.moveToPosition(f,CKEDITOR.POSITION_AFTER_END);f=null}else if(c){h=new CKEDITOR.dom.elementPath(this.startContainer,
this.root);this.moveToPosition(e,CKEDITOR.POSITION_BEFORE_START);e=null}else{f=this.splitElement(e,b||false);e.is("ul","ol")||e.appendBogus()}return{previousBlock:e,nextBlock:f,wasStartOfBlock:c,wasEndOfBlock:d,elementPath:h}},splitElement:function(a,b){if(!this.collapsed)return null;this.setEndAt(a,CKEDITOR.POSITION_BEFORE_END);var c=this.extractContents(false,b||false),d=a.clone(false,b||false);c.appendTo(d);d.insertAfter(a);this.moveToPosition(a,CKEDITOR.POSITION_AFTER_END);return d},removeEmptyBlocksAtEnd:function(){function a(d){return function(a){return b(a)||
(c(a)||a.type==CKEDITOR.NODE_ELEMENT&&a.isEmptyInlineRemoveable())||d.is("table")&&a.is("caption")?false:true}}var b=CKEDITOR.dom.walker.whitespaces(),c=CKEDITOR.dom.walker.bookmark(false);return function(b){for(var c=this.createBookmark(),d=this[b?"endPath":"startPath"](),e=d.block||d.blockLimit,f;e&&!e.equals(d.root)&&!e.getFirst(a(e));){f=e.getParent();this[b?"setEndAt":"setStartAt"](e,CKEDITOR.POSITION_AFTER_END);e.remove(1);e=f}this.moveToBookmark(c)}}(),startPath:function(){return new CKEDITOR.dom.elementPath(this.startContainer,
this.root)},endPath:function(){return new CKEDITOR.dom.elementPath(this.endContainer,this.root)},checkBoundaryOfElement:function(a,b){var d=b==CKEDITOR.START,e=this.clone();e.collapse(d);e[d?"setStartAt":"setEndAt"](a,d?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_END);e=new CKEDITOR.dom.walker(e);e.evaluator=c(d);return e[d?"checkBackward":"checkForward"]()},checkStartOfBlock:function(){var a=this.startContainer,c=this.startOffset;if(CKEDITOR.env.ie&&c&&a.type==CKEDITOR.NODE_TEXT){a=CKEDITOR.tools.ltrim(a.substring(0,
c));i.test(a)&&this.trim(0,1)}this.trim();a=new CKEDITOR.dom.elementPath(this.startContainer,this.root);c=this.clone();c.collapse(true);c.setStartAt(a.block||a.blockLimit,CKEDITOR.POSITION_AFTER_START);a=new CKEDITOR.dom.walker(c);a.evaluator=b();return a.checkBackward()},checkEndOfBlock:function(){var a=this.endContainer,c=this.endOffset;if(CKEDITOR.env.ie&&a.type==CKEDITOR.NODE_TEXT){a=CKEDITOR.tools.rtrim(a.substring(c));i.test(a)&&this.trim(1,0)}this.trim();a=new CKEDITOR.dom.elementPath(this.endContainer,
this.root);c=this.clone();c.collapse(false);c.setEndAt(a.block||a.blockLimit,CKEDITOR.POSITION_BEFORE_END);a=new CKEDITOR.dom.walker(c);a.evaluator=b();return a.checkForward()},getPreviousNode:function(a,b,c){var d=this.clone();d.collapse(1);d.setStartAt(c||this.root,CKEDITOR.POSITION_AFTER_START);c=new CKEDITOR.dom.walker(d);c.evaluator=a;c.guard=b;return c.previous()},getNextNode:function(a,b,c){var d=this.clone();d.collapse();d.setEndAt(c||this.root,CKEDITOR.POSITION_BEFORE_END);c=new CKEDITOR.dom.walker(d);
c.evaluator=a;c.guard=b;return c.next()},checkReadOnly:function(){function a(b,c){for(;b;){if(b.type==CKEDITOR.NODE_ELEMENT){if(b.getAttribute("contentEditable")=="false"&&!b.data("cke-editable"))return 0;if(b.is("html")||b.getAttribute("contentEditable")=="true"&&(b.contains(c)||b.equals(c)))break}b=b.getParent()}return 1}return function(){var b=this.startContainer,c=this.endContainer;return!(a(b,c)&&a(c,b))}}(),moveToElementEditablePosition:function(a,b){if(a.type==CKEDITOR.NODE_ELEMENT&&!a.isEditable(false)){this.moveToPosition(a,
b?CKEDITOR.POSITION_AFTER_END:CKEDITOR.POSITION_BEFORE_START);return true}for(var c=0;a;){if(a.type==CKEDITOR.NODE_TEXT){b&&this.endContainer&&this.checkEndOfBlock()&&i.test(a.getText())?this.moveToPosition(a,CKEDITOR.POSITION_BEFORE_START):this.moveToPosition(a,b?CKEDITOR.POSITION_AFTER_END:CKEDITOR.POSITION_BEFORE_START);c=1;break}if(a.type==CKEDITOR.NODE_ELEMENT)if(a.isEditable()){this.moveToPosition(a,b?CKEDITOR.POSITION_BEFORE_END:CKEDITOR.POSITION_AFTER_START);c=1}else if(b&&a.is("br")&&this.endContainer&&
this.checkEndOfBlock())this.moveToPosition(a,CKEDITOR.POSITION_BEFORE_START);else if(a.getAttribute("contenteditable")=="false"&&a.is(CKEDITOR.dtd.$block)){this.setStartBefore(a);this.setEndAfter(a);return true}var d=a,e=c,f=void 0;d.type==CKEDITOR.NODE_ELEMENT&&d.isEditable(false)&&(f=d[b?"getLast":"getFirst"](n));!e&&!f&&(f=d[b?"getPrevious":"getNext"](n));a=f}return!!c},moveToClosestEditablePosition:function(a,b){var c,d=0,e,f,h=[CKEDITOR.POSITION_AFTER_END,CKEDITOR.POSITION_BEFORE_START];if(a){c=
new CKEDITOR.dom.range(this.root);c.moveToPosition(a,h[b?0:1])}else c=this.clone();if(a&&!a.is(CKEDITOR.dtd.$block))d=1;else if(e=c[b?"getNextEditableNode":"getPreviousEditableNode"]()){d=1;if((f=e.type==CKEDITOR.NODE_ELEMENT)&&e.is(CKEDITOR.dtd.$block)&&e.getAttribute("contenteditable")=="false"){c.setStartAt(e,CKEDITOR.POSITION_BEFORE_START);c.setEndAt(e,CKEDITOR.POSITION_AFTER_END)}else if(!CKEDITOR.env.needsBrFiller&&f&&e.is(CKEDITOR.dom.walker.validEmptyBlockContainers)){c.setEnd(e,0);c.collapse()}else c.moveToPosition(e,
h[b?1:0])}d&&this.moveToRange(c);return!!d},moveToElementEditStart:function(a){return this.moveToElementEditablePosition(a)},moveToElementEditEnd:function(a){return this.moveToElementEditablePosition(a,true)},getEnclosedNode:function(){var a=this.clone();a.optimize();if(a.startContainer.type!=CKEDITOR.NODE_ELEMENT||a.endContainer.type!=CKEDITOR.NODE_ELEMENT)return null;var a=new CKEDITOR.dom.walker(a),b=CKEDITOR.dom.walker.bookmark(false,true),c=CKEDITOR.dom.walker.whitespaces(true);a.evaluator=function(a){return c(a)&&
b(a)};var d=a.next();a.reset();return d&&d.equals(a.previous())?d:null},getTouchedStartNode:function(){var a=this.startContainer;return this.collapsed||a.type!=CKEDITOR.NODE_ELEMENT?a:a.getChild(this.startOffset)||a},getTouchedEndNode:function(){var a=this.endContainer;return this.collapsed||a.type!=CKEDITOR.NODE_ELEMENT?a:a.getChild(this.endOffset-1)||a},getNextEditableNode:e(),getPreviousEditableNode:e(1),scrollIntoView:function(){var a=new CKEDITOR.dom.element.createFromHtml("<span>&nbsp;</span>",
this.document),b,c,d,e=this.clone();e.optimize();if(d=e.startContainer.type==CKEDITOR.NODE_TEXT){c=e.startContainer.getText();b=e.startContainer.split(e.startOffset);a.insertAfter(e.startContainer)}else e.insertNode(a);a.scrollIntoView();if(d){e.startContainer.setText(c);b.remove()}a.remove()},_setStartContainer:function(a){this.startContainer=a},_setEndContainer:function(a){this.endContainer=a}}})();CKEDITOR.POSITION_AFTER_START=1;CKEDITOR.POSITION_BEFORE_END=2;CKEDITOR.POSITION_BEFORE_START=3;
CKEDITOR.POSITION_AFTER_END=4;CKEDITOR.ENLARGE_ELEMENT=1;CKEDITOR.ENLARGE_BLOCK_CONTENTS=2;CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS=3;CKEDITOR.ENLARGE_INLINE=4;CKEDITOR.START=1;CKEDITOR.END=2;CKEDITOR.SHRINK_ELEMENT=1;CKEDITOR.SHRINK_TEXT=2;"use strict";
(function(){function a(a){if(!(arguments.length<1)){this.range=a;this.forceBrBreak=0;this.enlargeBr=1;this.enforceRealBlocks=0;this._||(this._={})}}function d(a){var b=[];a.forEach(function(a){if(a.getAttribute("contenteditable")=="true"){b.push(a);return false}},CKEDITOR.NODE_ELEMENT,true);return b}function b(a,c,e,f){a:{f==null&&(f=d(e));for(var h;h=f.shift();)if(h.getDtd().p){f={element:h,remaining:f};break a}f=null}if(!f)return 0;if((h=CKEDITOR.filter.instances[f.element.data("cke-filter")])&&
!h.check(c))return b(a,c,e,f.remaining);c=new CKEDITOR.dom.range(f.element);c.selectNodeContents(f.element);c=c.createIterator();c.enlargeBr=a.enlargeBr;c.enforceRealBlocks=a.enforceRealBlocks;c.activeFilter=c.filter=h;a._.nestedEditable={element:f.element,container:e,remaining:f.remaining,iterator:c};return 1}function c(a,b,c){if(!b)return false;a=a.clone();a.collapse(!c);return a.checkBoundaryOfElement(b,c?CKEDITOR.START:CKEDITOR.END)}var e=/^[\r\n\t ]+$/,f=CKEDITOR.dom.walker.bookmark(false,true),
h=CKEDITOR.dom.walker.whitespaces(true),i=function(a){return f(a)&&h(a)},j={dd:1,dt:1,li:1};a.prototype={getNextParagraph:function(a){var d,h,r,y,o,a=a||"p";if(this._.nestedEditable){if(d=this._.nestedEditable.iterator.getNextParagraph(a)){this.activeFilter=this._.nestedEditable.iterator.activeFilter;return d}this.activeFilter=this.filter;if(b(this,a,this._.nestedEditable.container,this._.nestedEditable.remaining)){this.activeFilter=this._.nestedEditable.iterator.activeFilter;return this._.nestedEditable.iterator.getNextParagraph(a)}this._.nestedEditable=
null}if(!this.range.root.getDtd()[a])return null;if(!this._.started){var q=this.range.clone();h=q.startPath();var t=q.endPath(),w=!q.collapsed&&c(q,h.block),v=!q.collapsed&&c(q,t.block,1);q.shrink(CKEDITOR.SHRINK_ELEMENT,true);w&&q.setStartAt(h.block,CKEDITOR.POSITION_BEFORE_END);v&&q.setEndAt(t.block,CKEDITOR.POSITION_AFTER_START);h=q.endContainer.hasAscendant("pre",true)||q.startContainer.hasAscendant("pre",true);q.enlarge(this.forceBrBreak&&!h||!this.enlargeBr?CKEDITOR.ENLARGE_LIST_ITEM_CONTENTS:
CKEDITOR.ENLARGE_BLOCK_CONTENTS);if(!q.collapsed){h=new CKEDITOR.dom.walker(q.clone());t=CKEDITOR.dom.walker.bookmark(true,true);h.evaluator=t;this._.nextNode=h.next();h=new CKEDITOR.dom.walker(q.clone());h.evaluator=t;h=h.previous();this._.lastNode=h.getNextSourceNode(true,null,q.root);if(this._.lastNode&&this._.lastNode.type==CKEDITOR.NODE_TEXT&&!CKEDITOR.tools.trim(this._.lastNode.getText())&&this._.lastNode.getParent().isBlockBoundary()){t=this.range.clone();t.moveToPosition(this._.lastNode,CKEDITOR.POSITION_AFTER_END);
if(t.checkEndOfBlock()){t=new CKEDITOR.dom.elementPath(t.endContainer,t.root);this._.lastNode=(t.block||t.blockLimit).getNextSourceNode(true)}}if(!this._.lastNode||!q.root.contains(this._.lastNode)){this._.lastNode=this._.docEndMarker=q.document.createText("");this._.lastNode.insertAfter(h)}q=null}this._.started=1;h=q}t=this._.nextNode;q=this._.lastNode;for(this._.nextNode=null;t;){var w=0,v=t.hasAscendant("pre"),B=t.type!=CKEDITOR.NODE_ELEMENT,l=0;if(B)t.type==CKEDITOR.NODE_TEXT&&e.test(t.getText())&&
(B=0);else{var s=t.getName();if(CKEDITOR.dtd.$block[s]&&t.getAttribute("contenteditable")=="false"){d=t;b(this,a,d);break}else if(t.isBlockBoundary(this.forceBrBreak&&!v&&{br:1})){if(s=="br")B=1;else if(!h&&!t.getChildCount()&&s!="hr"){d=t;r=t.equals(q);break}if(h){h.setEndAt(t,CKEDITOR.POSITION_BEFORE_START);if(s!="br")this._.nextNode=t}w=1}else{if(t.getFirst()){if(!h){h=this.range.clone();h.setStartAt(t,CKEDITOR.POSITION_BEFORE_START)}t=t.getFirst();continue}B=1}}if(B&&!h){h=this.range.clone();
h.setStartAt(t,CKEDITOR.POSITION_BEFORE_START)}r=(!w||B)&&t.equals(q);if(h&&!w)for(;!t.getNext(i)&&!r;){s=t.getParent();if(s.isBlockBoundary(this.forceBrBreak&&!v&&{br:1})){w=1;B=0;r||s.equals(q);h.setEndAt(s,CKEDITOR.POSITION_BEFORE_END);break}t=s;B=1;r=t.equals(q);l=1}B&&h.setEndAt(t,CKEDITOR.POSITION_AFTER_END);t=this._getNextSourceNode(t,l,q);if((r=!t)||w&&h)break}if(!d){if(!h){this._.docEndMarker&&this._.docEndMarker.remove();return this._.nextNode=null}d=new CKEDITOR.dom.elementPath(h.startContainer,
h.root);t=d.blockLimit;w={div:1,th:1,td:1};d=d.block;if(!d&&t&&!this.enforceRealBlocks&&w[t.getName()]&&h.checkStartOfBlock()&&h.checkEndOfBlock()&&!t.equals(h.root))d=t;else if(!d||this.enforceRealBlocks&&d.is(j)){d=this.range.document.createElement(a);h.extractContents().appendTo(d);d.trim();h.insertNode(d);y=o=true}else if(d.getName()!="li"){if(!h.checkStartOfBlock()||!h.checkEndOfBlock()){d=d.clone(false);h.extractContents().appendTo(d);d.trim();o=h.splitBlock();y=!o.wasStartOfBlock;o=!o.wasEndOfBlock;
h.insertNode(d)}}else if(!r)this._.nextNode=d.equals(q)?null:this._getNextSourceNode(h.getBoundaryNodes().endNode,1,q)}if(y)(y=d.getPrevious())&&y.type==CKEDITOR.NODE_ELEMENT&&(y.getName()=="br"?y.remove():y.getLast()&&y.getLast().$.nodeName.toLowerCase()=="br"&&y.getLast().remove());if(o)(y=d.getLast())&&y.type==CKEDITOR.NODE_ELEMENT&&y.getName()=="br"&&(!CKEDITOR.env.needsBrFiller||y.getPrevious(f)||y.getNext(f))&&y.remove();if(!this._.nextNode)this._.nextNode=r||d.equals(q)||!q?null:this._getNextSourceNode(d,
1,q);return d},_getNextSourceNode:function(a,b,c){function d(a){return!(a.equals(c)||a.equals(e))}for(var e=this.range.root,a=a.getNextSourceNode(b,null,d);!f(a);)a=a.getNextSourceNode(b,null,d);return a}};CKEDITOR.dom.range.prototype.createIterator=function(){return new a(this)}})();
CKEDITOR.command=function(a,d){this.uiItems=[];this.exec=function(b){if(this.state==CKEDITOR.TRISTATE_DISABLED||!this.checkAllowed())return false;this.editorFocus&&a.focus();return this.fire("exec")===false?true:d.exec.call(this,a,b)!==false};this.refresh=function(a,b){if(!this.readOnly&&a.readOnly)return true;if(this.context&&!b.isContextFor(this.context)){this.disable();return true}if(!this.checkAllowed(true)){this.disable();return true}this.startDisabled||this.enable();this.modes&&!this.modes[a.mode]&&
this.disable();return this.fire("refresh",{editor:a,path:b})===false?true:d.refresh&&d.refresh.apply(this,arguments)!==false};var b;this.checkAllowed=function(c){return!c&&typeof b=="boolean"?b:b=a.activeFilter.checkFeature(this)};CKEDITOR.tools.extend(this,d,{modes:{wysiwyg:1},editorFocus:1,contextSensitive:!!d.context,state:CKEDITOR.TRISTATE_DISABLED});CKEDITOR.event.call(this)};
CKEDITOR.command.prototype={enable:function(){this.state==CKEDITOR.TRISTATE_DISABLED&&this.checkAllowed()&&this.setState(!this.preserveState||typeof this.previousState=="undefined"?CKEDITOR.TRISTATE_OFF:this.previousState)},disable:function(){this.setState(CKEDITOR.TRISTATE_DISABLED)},setState:function(a){if(this.state==a||a!=CKEDITOR.TRISTATE_DISABLED&&!this.checkAllowed())return false;this.previousState=this.state;this.state=a;this.fire("state");return true},toggleState:function(){this.state==CKEDITOR.TRISTATE_OFF?
this.setState(CKEDITOR.TRISTATE_ON):this.state==CKEDITOR.TRISTATE_ON&&this.setState(CKEDITOR.TRISTATE_OFF)}};CKEDITOR.event.implementOn(CKEDITOR.command.prototype);CKEDITOR.ENTER_P=1;CKEDITOR.ENTER_BR=2;CKEDITOR.ENTER_DIV=3;
CKEDITOR.config={customConfig:"config.js",autoUpdateElement:!0,language:"",defaultLanguage:"en",contentsLangDirection:"",enterMode:CKEDITOR.ENTER_P,forceEnterMode:!1,shiftEnterMode:CKEDITOR.ENTER_BR,docType:"<!DOCTYPE html>",bodyId:"",bodyClass:"",fullPage:!1,height:200,extraPlugins:"",removePlugins:"",protectedSource:[],tabIndex:0,width:"",baseFloatZIndex:1E4,blockedKeystrokes:[CKEDITOR.CTRL+66,CKEDITOR.CTRL+73,CKEDITOR.CTRL+85]};
(function(){function a(a,b,c,d,k){var e,m,a=[];for(e in b){m=b[e];m=typeof m=="boolean"?{}:typeof m=="function"?{match:m}:L(m);if(e.charAt(0)!="$")m.elements=e;if(c)m.featureName=c.toLowerCase();var f=m;f.elements=h(f.elements,/\s+/)||null;f.propertiesOnly=f.propertiesOnly||f.elements===true;var g=/\s*,\s*/,p=void 0;for(p in C){f[p]=h(f[p],g)||null;var D=f,u=x[p],o=h(f[x[p]],g),z=f[p],F=[],l=true,s=void 0;o?l=false:o={};for(s in z)if(s.charAt(0)=="!"){s=s.slice(1);F.push(s);o[s]=true;l=false}for(;s=
F.pop();){z[s]=z["!"+s];delete z["!"+s]}D[u]=(l?false:o)||null}f.match=f.match||null;d.push(m);a.push(m)}for(var b=k.elements,k=k.generic,G,c=0,d=a.length;c<d;++c){e=L(a[c]);m=e.classes===true||e.styles===true||e.attributes===true;f=e;p=u=g=void 0;for(g in C)f[g]=w(f[g]);D=true;for(p in x){g=x[p];u=f[g];o=[];z=void 0;for(z in u)z.indexOf("*")>-1?o.push(RegExp("^"+z.replace(/\*/g,".*")+"$")):o.push(z);u=o;if(u.length){f[g]=u;D=false}}f.nothingRequired=D;f.noProperties=!(f.attributes||f.classes||f.styles);
if(e.elements===true||e.elements===null)k[m?"unshift":"push"](e);else{f=e.elements;delete e.elements;for(G in f)if(b[G])b[G][m?"unshift":"push"](e);else b[G]=[e]}}}function d(a,c,d,k){if(!a.match||a.match(c))if(k||i(a,c)){if(!a.propertiesOnly)d.valid=true;if(!d.allAttributes)d.allAttributes=b(a.attributes,c.attributes,d.validAttributes);if(!d.allStyles)d.allStyles=b(a.styles,c.styles,d.validStyles);if(!d.allClasses){a=a.classes;c=c.classes;k=d.validClasses;if(a)if(a===true)a=true;else{for(var e=0,
m=c.length,f;e<m;++e){f=c[e];k[f]||(k[f]=a(f))}a=false}else a=false;d.allClasses=a}}}function b(a,b,c){if(!a)return false;if(a===true)return true;for(var d in b)c[d]||(c[d]=a(d));return false}function c(a,b,c){if(!a.match||a.match(b)){if(a.noProperties)return false;c.hadInvalidAttribute=e(a.attributes,b.attributes)||c.hadInvalidAttribute;c.hadInvalidStyle=e(a.styles,b.styles)||c.hadInvalidStyle;a=a.classes;b=b.classes;if(a){for(var d=false,k=a===true,m=b.length;m--;)if(k||a(b[m])){b.splice(m,1);d=
true}a=d}else a=false;c.hadInvalidClass=a||c.hadInvalidClass}}function e(a,b){if(!a)return false;var c=false,d=a===true,k;for(k in b)if(d||a(k)){delete b[k];c=true}return c}function f(a,b,c){if(a.disabled||a.customConfig&&!c||!b)return false;a._.cachedChecks={};return true}function h(a,b){if(!a)return false;if(a===true)return a;if(typeof a=="string"){a=E(a);return a=="*"?true:CKEDITOR.tools.convertArrayToObject(a.split(b))}if(CKEDITOR.tools.isArray(a))return a.length?CKEDITOR.tools.convertArrayToObject(a):
false;var c={},d=0,k;for(k in a){c[k]=a[k];d++}return d?c:false}function i(a,b){if(a.nothingRequired)return true;var c,d,k,e;if(k=a.requiredClasses){e=b.classes;for(c=0;c<k.length;++c){d=k[c];if(typeof d=="string"){if(CKEDITOR.tools.indexOf(e,d)==-1)return false}else if(!CKEDITOR.tools.checkIfAnyArrayItemMatches(e,d))return false}}return j(b.styles,a.requiredStyles)&&j(b.attributes,a.requiredAttributes)}function j(a,b){if(!b)return true;for(var c=0,d;c<b.length;++c){d=b[c];if(typeof d=="string"){if(!(d in
a))return false}else if(!CKEDITOR.tools.checkIfAnyObjectPropertyMatches(a,d))return false}return true}function n(a){if(!a)return{};for(var a=a.split(/\s*,\s*/).sort(),b={};a.length;)b[a.shift()]=u;return b}function g(a){for(var b,c,d,k,e={},m=1,a=E(a);b=a.match(D);){if(c=b[2]){d=A(c,"styles");k=A(c,"attrs");c=A(c,"classes")}else d=k=c=null;e["$"+m++]={elements:b[1],classes:c,styles:d,attributes:k};a=a.slice(b[0].length)}return e}function A(a,b){var c=a.match(G[b]);return c?E(c[1]):null}function r(a){var b=
a.styleBackup=a.attributes.style,c=a.classBackup=a.attributes["class"];if(!a.styles)a.styles=CKEDITOR.tools.parseCssText(b||"",1);if(!a.classes)a.classes=c?c.split(/\s+/):[]}function y(a,b,k,e){var m=0,f;if(e.toHtml)b.name=b.name.replace(M,"$1");if(e.doCallbacks&&a.elementCallbacks){a:for(var g=a.elementCallbacks,p=0,D=g.length,u;p<D;++p)if(u=g[p](b)){f=u;break a}if(f)return f}if(e.doTransform)if(f=a._.transformations[b.name]){r(b);for(g=0;g<f.length;++g)s(a,b,f[g]);q(b)}if(e.doFilter){a:{g=b.name;
p=a._;a=p.allowedRules.elements[g];f=p.allowedRules.generic;g=p.disallowedRules.elements[g];p=p.disallowedRules.generic;D=e.skipRequired;u={valid:false,validAttributes:{},validClasses:{},validStyles:{},allAttributes:false,allClasses:false,allStyles:false,hadInvalidAttribute:false,hadInvalidClass:false,hadInvalidStyle:false};var h,o;if(!a&&!f)a=null;else{r(b);if(g){h=0;for(o=g.length;h<o;++h)if(c(g[h],b,u)===false){a=null;break a}}if(p){h=0;for(o=p.length;h<o;++h)c(p[h],b,u)}if(a){h=0;for(o=a.length;h<
o;++h)d(a[h],b,u,D)}if(f){h=0;for(o=f.length;h<o;++h)d(f[h],b,u,D)}a=u}}if(!a){k.push(b);return z}if(!a.valid){k.push(b);return z}o=a.validAttributes;var F=a.validStyles;f=a.validClasses;var g=b.attributes,l=b.styles,p=b.classes,D=b.classBackup,x=b.styleBackup,C,G,i=[];u=[];var I=/^data-cke-/;h=false;delete g.style;delete g["class"];delete b.classBackup;delete b.styleBackup;if(!a.allAttributes)for(C in g)if(!o[C])if(I.test(C)){if(C!=(G=C.replace(/^data-cke-saved-/,""))&&!o[G]){delete g[C];h=true}}else{delete g[C];
h=true}if(!a.allStyles||a.hadInvalidStyle){for(C in l)a.allStyles||F[C]?i.push(C+":"+l[C]):h=true;if(i.length)g.style=i.sort().join("; ")}else if(x)g.style=x;if(!a.allClasses||a.hadInvalidClass){for(C=0;C<p.length;++C)(a.allClasses||f[p[C]])&&u.push(p[C]);u.length&&(g["class"]=u.sort().join(" "));D&&u.length<D.split(/\s+/).length&&(h=true)}else D&&(g["class"]=D);h&&(m=z);if(!e.skipFinalValidation&&!t(b)){k.push(b);return z}}if(e.toHtml)b.name=b.name.replace(aa,"cke:$1");return m}function o(a){var b=
[],c;for(c in a)c.indexOf("*")>-1&&b.push(c.replace(/\*/g,".*"));return b.length?RegExp("^(?:"+b.join("|")+")$"):null}function q(a){var b=a.attributes,c;delete b.style;delete b["class"];if(c=CKEDITOR.tools.writeCssText(a.styles,true))b.style=c;a.classes.length&&(b["class"]=a.classes.sort().join(" "))}function t(a){switch(a.name){case "a":if(!a.children.length&&!a.attributes.name)return false;break;case "img":if(!a.attributes.src)return false}return true}function w(a){if(!a)return false;if(a===true)return true;
var b=o(a);return function(c){return c in a||b&&c.match(b)}}function v(){return new CKEDITOR.htmlParser.element("br")}function B(a){return a.type==CKEDITOR.NODE_ELEMENT&&(a.name=="br"||I.$block[a.name])}function l(a,b,c){var d=a.name;if(I.$empty[d]||!a.children.length)if(d=="hr"&&b=="br")a.replaceWith(v());else{a.parent&&c.push({check:"it",el:a.parent});a.remove()}else if(I.$block[d]||d=="tr")if(b=="br"){if(a.previous&&!B(a.previous)){b=v();b.insertBefore(a)}if(a.next&&!B(a.next)){b=v();b.insertAfter(a)}a.replaceWithChildren()}else{var d=
a.children,k;b:{k=I[b];for(var e=0,m=d.length,f;e<m;++e){f=d[e];if(f.type==CKEDITOR.NODE_ELEMENT&&!k[f.name]){k=false;break b}}k=true}if(k){a.name=b;a.attributes={};c.push({check:"parent-down",el:a})}else{k=a.parent;for(var e=k.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT||k.name=="body",g,p,m=d.length;m>0;){f=d[--m];if(e&&(f.type==CKEDITOR.NODE_TEXT||f.type==CKEDITOR.NODE_ELEMENT&&I.$inline[f.name])){if(!g){g=new CKEDITOR.htmlParser.element(b);g.insertAfter(a);c.push({check:"parent-down",el:g})}g.add(f,
0)}else{g=null;p=I[k.name]||I.span;f.insertAfter(a);k.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT&&(f.type==CKEDITOR.NODE_ELEMENT&&!p[f.name])&&c.push({check:"el-up",el:f})}}a.remove()}}else if(d in{style:1,script:1})a.remove();else{a.parent&&c.push({check:"it",el:a.parent});a.replaceWithChildren()}}function s(a,b,c){var d,k;for(d=0;d<c.length;++d){k=c[d];if((!k.check||a.check(k.check,false))&&(!k.left||k.left(b))){k.right(b,U);break}}}function k(a,b){var c=b.getDefinition(),d=c.attributes,k=c.styles,e,
m,f,g;if(a.name!=c.element)return false;for(e in d)if(e=="class"){c=d[e].split(/\s+/);for(f=a.classes.join("|");g=c.pop();)if(f.indexOf(g)==-1)return false}else if(a.attributes[e]!=d[e])return false;for(m in k)if(a.styles[m]!=k[m])return false;return true}function m(a,b){var c,d;if(typeof a=="string")c=a;else if(a instanceof CKEDITOR.style)d=a;else{c=a[0];d=a[1]}return[{element:c,left:d,right:function(a,c){c.transform(a,b)}}]}function F(a){return function(b){return k(b,a)}}function p(a){return function(b,
c){c[a](b)}}var I=CKEDITOR.dtd,z=1,L=CKEDITOR.tools.copy,E=CKEDITOR.tools.trim,u="cke-test",K=["","p","br","div"];CKEDITOR.FILTER_SKIP_TREE=2;CKEDITOR.filter=function(a){this.allowedContent=[];this.disallowedContent=[];this.elementCallbacks=null;this.disabled=false;this.editor=null;this.id=CKEDITOR.tools.getNextNumber();this._={allowedRules:{elements:{},generic:[]},disallowedRules:{elements:{},generic:[]},transformations:{},cachedTests:{}};CKEDITOR.filter.instances[this.id]=this;if(a instanceof CKEDITOR.editor){a=
this.editor=a;this.customConfig=true;var b=a.config.allowedContent;if(b===true)this.disabled=true;else{if(!b)this.customConfig=false;this.allow(b,"config",1);this.allow(a.config.extraAllowedContent,"extra",1);this.allow(K[a.enterMode]+" "+K[a.shiftEnterMode],"default",1);this.disallow(a.config.disallowedContent)}}else{this.customConfig=false;this.allow(a,"default",1)}};CKEDITOR.filter.instances={};CKEDITOR.filter.prototype={allow:function(b,c,d){if(!f(this,b,d))return false;var k,e;if(typeof b=="string")b=
g(b);else if(b instanceof CKEDITOR.style){if(b.toAllowedContentRules)return this.allow(b.toAllowedContentRules(this.editor),c,d);k=b.getDefinition();b={};d=k.attributes;b[k.element]=k={styles:k.styles,requiredStyles:k.styles&&CKEDITOR.tools.objectKeys(k.styles)};if(d){d=L(d);k.classes=d["class"]?d["class"].split(/\s+/):null;k.requiredClasses=k.classes;delete d["class"];k.attributes=d;k.requiredAttributes=d&&CKEDITOR.tools.objectKeys(d)}}else if(CKEDITOR.tools.isArray(b)){for(k=0;k<b.length;++k)e=
this.allow(b[k],c,d);return e}a(this,b,c,this.allowedContent,this._.allowedRules);return true},applyTo:function(a,b,c,d){if(this.disabled)return false;var k=this,e=[],m=this.editor&&this.editor.config.protectedSource,f,g=false,p={doFilter:!c,doTransform:true,doCallbacks:true,toHtml:b};a.forEach(function(a){if(a.type==CKEDITOR.NODE_ELEMENT){if(a.attributes["data-cke-filter"]=="off")return false;if(!b||!(a.name=="span"&&~CKEDITOR.tools.objectKeys(a.attributes).join("|").indexOf("data-cke-"))){f=y(k,
a,e,p);if(f&z)g=true;else if(f&2)return false}}else if(a.type==CKEDITOR.NODE_COMMENT&&a.value.match(/^\{cke_protected\}(?!\{C\})/)){var c;a:{var d=decodeURIComponent(a.value.replace(/^\{cke_protected\}/,""));c=[];var D,h,u;if(m)for(h=0;h<m.length;++h)if((u=d.match(m[h]))&&u[0].length==d.length){c=true;break a}d=CKEDITOR.htmlParser.fragment.fromHtml(d);d.children.length==1&&(D=d.children[0]).type==CKEDITOR.NODE_ELEMENT&&y(k,D,c,p);c=!c.length}c||e.push(a)}},null,true);e.length&&(g=true);for(var D,
a=[],d=K[d||(this.editor?this.editor.enterMode:CKEDITOR.ENTER_P)],h;c=e.pop();)c.type==CKEDITOR.NODE_ELEMENT?l(c,d,a):c.remove();for(;D=a.pop();){c=D.el;if(c.parent){h=I[c.parent.name]||I.span;switch(D.check){case "it":I.$removeEmpty[c.name]&&!c.children.length?l(c,d,a):t(c)||l(c,d,a);break;case "el-up":c.parent.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT&&!h[c.name]&&l(c,d,a);break;case "parent-down":c.parent.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT&&!h[c.name]&&l(c.parent,d,a)}}}return g},checkFeature:function(a){if(this.disabled||
!a)return true;a.toFeature&&(a=a.toFeature(this.editor));return!a.requiredContent||this.check(a.requiredContent)},disable:function(){this.disabled=true},disallow:function(b){if(!f(this,b,true))return false;typeof b=="string"&&(b=g(b));a(this,b,null,this.disallowedContent,this._.disallowedRules);return true},addContentForms:function(a){if(!this.disabled&&a){var b,c,d=[],k;for(b=0;b<a.length&&!k;++b){c=a[b];if((typeof c=="string"||c instanceof CKEDITOR.style)&&this.check(c))k=c}if(k){for(b=0;b<a.length;++b)d.push(m(a[b],
k));this.addTransformations(d)}}},addElementCallback:function(a){if(!this.elementCallbacks)this.elementCallbacks=[];this.elementCallbacks.push(a)},addFeature:function(a){if(this.disabled||!a)return true;a.toFeature&&(a=a.toFeature(this.editor));this.allow(a.allowedContent,a.name);this.addTransformations(a.contentTransformations);this.addContentForms(a.contentForms);return a.requiredContent&&(this.customConfig||this.disallowedContent.length)?this.check(a.requiredContent):true},addTransformations:function(a){var b,
c;if(!this.disabled&&a){var d=this._.transformations,k;for(k=0;k<a.length;++k){b=a[k];var e=void 0,m=void 0,f=void 0,g=void 0,D=void 0,h=void 0;c=[];for(m=0;m<b.length;++m){f=b[m];if(typeof f=="string"){f=f.split(/\s*:\s*/);g=f[0];D=null;h=f[1]}else{g=f.check;D=f.left;h=f.right}if(!e){e=f;e=e.element?e.element:g?g.match(/^([a-z0-9]+)/i)[0]:e.left.getDefinition().element}D instanceof CKEDITOR.style&&(D=F(D));c.push({check:g==e?null:g,left:D,right:typeof h=="string"?p(h):h})}b=e;d[b]||(d[b]=[]);d[b].push(c)}}},
check:function(a,b,c){if(this.disabled)return true;if(CKEDITOR.tools.isArray(a)){for(var d=a.length;d--;)if(this.check(a[d],b,c))return true;return false}var k,e;if(typeof a=="string"){e=a+"<"+(b===false?"0":"1")+(c?"1":"0")+">";if(e in this._.cachedChecks)return this._.cachedChecks[e];d=g(a).$1;k=d.styles;var m=d.classes;d.name=d.elements;d.classes=m=m?m.split(/\s*,\s*/):[];d.styles=n(k);d.attributes=n(d.attributes);d.children=[];m.length&&(d.attributes["class"]=m.join(" "));if(k)d.attributes.style=
CKEDITOR.tools.writeCssText(d.styles);k=d}else{d=a.getDefinition();k=d.styles;m=d.attributes||{};if(k){k=L(k);m.style=CKEDITOR.tools.writeCssText(k,true)}else k={};k={name:d.element,attributes:m,classes:m["class"]?m["class"].split(/\s+/):[],styles:k,children:[]}}var m=CKEDITOR.tools.clone(k),f=[],p;if(b!==false&&(p=this._.transformations[k.name])){for(d=0;d<p.length;++d)s(this,k,p[d]);q(k)}y(this,m,f,{doFilter:true,doTransform:b!==false,skipRequired:!c,skipFinalValidation:!c});b=f.length>0?false:
CKEDITOR.tools.objectCompare(k.attributes,m.attributes,true)?true:false;typeof a=="string"&&(this._.cachedChecks[e]=b);return b},getAllowedEnterMode:function(){var a=["p","div","br"],b={p:CKEDITOR.ENTER_P,div:CKEDITOR.ENTER_DIV,br:CKEDITOR.ENTER_BR};return function(c,d){var k=a.slice(),e;if(this.check(K[c]))return c;for(d||(k=k.reverse());e=k.pop();)if(this.check(e))return b[e];return CKEDITOR.ENTER_BR}}(),destroy:function(){delete CKEDITOR.filter.instances[this.id];delete this._;delete this.allowedContent;
delete this.disallowedContent}};var C={styles:1,attributes:1,classes:1},x={styles:"requiredStyles",attributes:"requiredAttributes",classes:"requiredClasses"},D=/^([a-z0-9\-*\s]+)((?:\s*\{[!\w\-,\s\*]+\}\s*|\s*\[[!\w\-,\s\*]+\]\s*|\s*\([!\w\-,\s\*]+\)\s*){0,3})(?:;\s*|$)/i,G={styles:/{([^}]+)}/,attrs:/\[([^\]]+)\]/,classes:/\(([^\)]+)\)/},M=/^cke:(object|embed|param)$/,aa=/^(object|embed|param)$/,U=CKEDITOR.filter.transformationsTools={sizeToStyle:function(a){this.lengthToStyle(a,"width");this.lengthToStyle(a,
"height")},sizeToAttribute:function(a){this.lengthToAttribute(a,"width");this.lengthToAttribute(a,"height")},lengthToStyle:function(a,b,c){c=c||b;if(!(c in a.styles)){var d=a.attributes[b];if(d){/^\d+$/.test(d)&&(d=d+"px");a.styles[c]=d}}delete a.attributes[b]},lengthToAttribute:function(a,b,c){c=c||b;if(!(c in a.attributes)){var d=a.styles[b],k=d&&d.match(/^(\d+)(?:\.\d*)?px$/);k?a.attributes[c]=k[1]:d==u&&(a.attributes[c]=u)}delete a.styles[b]},alignmentToStyle:function(a){if(!("float"in a.styles)){var b=
a.attributes.align;if(b=="left"||b=="right")a.styles["float"]=b}delete a.attributes.align},alignmentToAttribute:function(a){if(!("align"in a.attributes)){var b=a.styles["float"];if(b=="left"||b=="right")a.attributes.align=b}delete a.styles["float"]},matchesStyle:k,transform:function(a,b){if(typeof b=="string")a.name=b;else{var c=b.getDefinition(),d=c.styles,k=c.attributes,e,m,f,g;a.name=c.element;for(e in k)if(e=="class"){c=a.classes.join("|");for(f=k[e].split(/\s+/);g=f.pop();)c.indexOf(g)==-1&&
a.classes.push(g)}else a.attributes[e]=k[e];for(m in d)a.styles[m]=d[m]}}}})();
(function(){CKEDITOR.focusManager=function(a){if(a.focusManager)return a.focusManager;this.hasFocus=false;this.currentActive=null;this._={editor:a};return this};CKEDITOR.focusManager._={blurDelay:200};CKEDITOR.focusManager.prototype={focus:function(a){this._.timer&&clearTimeout(this._.timer);if(a)this.currentActive=a;if(!this.hasFocus&&!this._.locked){(a=CKEDITOR.currentInstance)&&a.focusManager.blur(1);this.hasFocus=true;(a=this._.editor.container)&&a.addClass("cke_focus");this._.editor.fire("focus")}},
lock:function(){this._.locked=1},unlock:function(){delete this._.locked},blur:function(a){function d(){if(this.hasFocus){this.hasFocus=false;var a=this._.editor.container;a&&a.removeClass("cke_focus");this._.editor.fire("blur")}}if(!this._.locked){this._.timer&&clearTimeout(this._.timer);var b=CKEDITOR.focusManager._.blurDelay;a||!b?d.call(this):this._.timer=CKEDITOR.tools.setTimeout(function(){delete this._.timer;d.call(this)},b,this)}},add:function(a,d){var b=a.getCustomData("focusmanager");if(!b||
b!=this){b&&b.remove(a);var b="focus",c="blur";if(d)if(CKEDITOR.env.ie){b="focusin";c="focusout"}else CKEDITOR.event.useCapture=1;var e={blur:function(){a.equals(this.currentActive)&&this.blur()},focus:function(){this.focus(a)}};a.on(b,e.focus,this);a.on(c,e.blur,this);if(d)CKEDITOR.event.useCapture=0;a.setCustomData("focusmanager",this);a.setCustomData("focusmanager_handlers",e)}},remove:function(a){a.removeCustomData("focusmanager");var d=a.removeCustomData("focusmanager_handlers");a.removeListener("blur",
d.blur);a.removeListener("focus",d.focus)}}})();CKEDITOR.keystrokeHandler=function(a){if(a.keystrokeHandler)return a.keystrokeHandler;this.keystrokes={};this.blockedKeystrokes={};this._={editor:a};return this};
(function(){var a,d=function(b){var b=b.data,d=b.getKeystroke(),f=this.keystrokes[d],h=this._.editor;a=h.fire("key",{keyCode:d,domEvent:b})===false;if(!a){f&&(a=h.execCommand(f,{from:"keystrokeHandler"})!==false);a||(a=!!this.blockedKeystrokes[d])}a&&b.preventDefault(true);return!a},b=function(b){if(a){a=false;b.data.preventDefault(true)}};CKEDITOR.keystrokeHandler.prototype={attach:function(a){a.on("keydown",d,this);if(CKEDITOR.env.gecko&&CKEDITOR.env.mac)a.on("keypress",b,this)}}})();
(function(){CKEDITOR.lang={languages:{af:1,ar:1,bg:1,bn:1,bs:1,ca:1,cs:1,cy:1,da:1,de:1,el:1,"en-au":1,"en-ca":1,"en-gb":1,en:1,eo:1,es:1,et:1,eu:1,fa:1,fi:1,fo:1,"fr-ca":1,fr:1,gl:1,gu:1,he:1,hi:1,hr:1,hu:1,id:1,is:1,it:1,ja:1,ka:1,km:1,ko:1,ku:1,lt:1,lv:1,mk:1,mn:1,ms:1,nb:1,nl:1,no:1,pl:1,"pt-br":1,pt:1,ro:1,ru:1,si:1,sk:1,sl:1,sq:1,"sr-latn":1,sr:1,sv:1,th:1,tr:1,tt:1,ug:1,uk:1,vi:1,"zh-cn":1,zh:1},rtl:{ar:1,fa:1,he:1,ku:1,ug:1},load:function(a,d,b){if(!a||!CKEDITOR.lang.languages[a])a=this.detect(d,
a);var c=this,d=function(){c[a].dir=c.rtl[a]?"rtl":"ltr";b(a,c[a])};this[a]?d():CKEDITOR.scriptLoader.load(CKEDITOR.getUrl("lang/"+a+".js"),d,this)},detect:function(a,d){var b=this.languages,d=d||navigator.userLanguage||navigator.language||a,c=d.toLowerCase().match(/([a-z]+)(?:-([a-z]+))?/),e=c[1],c=c[2];b[e+"-"+c]?e=e+"-"+c:b[e]||(e=null);CKEDITOR.lang.detect=e?function(){return e}:function(a){return a};return e||a}}})();
CKEDITOR.scriptLoader=function(){var a={},d={};return{load:function(b,c,e,f){var h=typeof b=="string";h&&(b=[b]);e||(e=CKEDITOR);var i=b.length,j=[],n=[],g=function(a){c&&(h?c.call(e,a):c.call(e,j,n))};if(i===0)g(true);else{var A=function(a,b){(b?j:n).push(a);if(--i<=0){f&&CKEDITOR.document.getDocumentElement().removeStyle("cursor");g(b)}},r=function(b,c){a[b]=1;var e=d[b];delete d[b];for(var f=0;f<e.length;f++)e[f](b,c)},y=function(b){if(a[b])A(b,true);else{var e=d[b]||(d[b]=[]);e.push(A);if(!(e.length>
1)){var f=new CKEDITOR.dom.element("script");f.setAttributes({type:"text/javascript",src:b});if(c)if(CKEDITOR.env.ie&&CKEDITOR.env.version<11)f.$.onreadystatechange=function(){if(f.$.readyState=="loaded"||f.$.readyState=="complete"){f.$.onreadystatechange=null;r(b,true)}};else{f.$.onload=function(){setTimeout(function(){r(b,true)},0)};f.$.onerror=function(){r(b,false)}}f.appendTo(CKEDITOR.document.getHead())}}};f&&CKEDITOR.document.getDocumentElement().setStyle("cursor","wait");for(var o=0;o<i;o++)y(b[o])}},
queue:function(){function a(){var b;(b=c[0])&&this.load(b.scriptUrl,b.callback,CKEDITOR,0)}var c=[];return function(d,f){var h=this;c.push({scriptUrl:d,callback:function(){f&&f.apply(this,arguments);c.shift();a.call(h)}});c.length==1&&a.call(this)}}()}}();CKEDITOR.resourceManager=function(a,d){this.basePath=a;this.fileName=d;this.registered={};this.loaded={};this.externals={};this._={waitingList:{}}};
CKEDITOR.resourceManager.prototype={add:function(a,d){if(this.registered[a])throw'[CKEDITOR.resourceManager.add] The resource name "'+a+'" is already registered.';var b=this.registered[a]=d||{};b.name=a;b.path=this.getPath(a);CKEDITOR.fire(a+CKEDITOR.tools.capitalize(this.fileName)+"Ready",b);return this.get(a)},get:function(a){return this.registered[a]||null},getPath:function(a){var d=this.externals[a];return CKEDITOR.getUrl(d&&d.dir||this.basePath+a+"/")},getFilePath:function(a){var d=this.externals[a];
return CKEDITOR.getUrl(this.getPath(a)+(d?d.file:this.fileName+".js"))},addExternal:function(a,d,b){for(var a=a.split(","),c=0;c<a.length;c++){var e=a[c];b||(d=d.replace(/[^\/]+$/,function(a){b=a;return""}));this.externals[e]={dir:d,file:b||this.fileName+".js"}}},load:function(a,d,b){CKEDITOR.tools.isArray(a)||(a=a?[a]:[]);for(var c=this.loaded,e=this.registered,f=[],h={},i={},j=0;j<a.length;j++){var n=a[j];if(n)if(!c[n]&&!e[n]){var g=this.getFilePath(n);f.push(g);g in h||(h[g]=[]);h[g].push(n)}else i[n]=
this.get(n)}CKEDITOR.scriptLoader.load(f,function(a,e){if(e.length)throw'[CKEDITOR.resourceManager.load] Resource name "'+h[e[0]].join(",")+'" was not found at "'+e[0]+'".';for(var f=0;f<a.length;f++)for(var g=h[a[f]],j=0;j<g.length;j++){var n=g[j];i[n]=this.get(n);c[n]=1}d.call(b,i)},this)}};CKEDITOR.plugins=new CKEDITOR.resourceManager("plugins/","plugin");
CKEDITOR.plugins.load=CKEDITOR.tools.override(CKEDITOR.plugins.load,function(a){var d={};return function(b,c,e){var f={},h=function(b){a.call(this,b,function(a){CKEDITOR.tools.extend(f,a);var b=[],g;for(g in a){var i=a[g],r=i&&i.requires;if(!d[g]){if(i.icons)for(var y=i.icons.split(","),o=y.length;o--;)CKEDITOR.skin.addIcon(y[o],i.path+"icons/"+(CKEDITOR.env.hidpi&&i.hidpi?"hidpi/":"")+y[o]+".png");d[g]=1}if(r){r.split&&(r=r.split(","));for(i=0;i<r.length;i++)f[r[i]]||b.push(r[i])}}if(b.length)h.call(this,
b);else{for(g in f){i=f[g];if(i.onLoad&&!i.onLoad._called){i.onLoad()===false&&delete f[g];i.onLoad._called=1}}c&&c.call(e||window,f)}},this)};h.call(this,b)}});CKEDITOR.plugins.setLang=function(a,d,b){var c=this.get(a),a=c.langEntries||(c.langEntries={}),c=c.lang||(c.lang=[]);c.split&&(c=c.split(","));CKEDITOR.tools.indexOf(c,d)==-1&&c.push(d);a[d]=b};CKEDITOR.ui=function(a){if(a.ui)return a.ui;this.items={};this.instances={};this.editor=a;this._={handlers:{}};return this};
CKEDITOR.ui.prototype={add:function(a,d,b){b.name=a.toLowerCase();var c=this.items[a]={type:d,command:b.command||null,args:Array.prototype.slice.call(arguments,2)};CKEDITOR.tools.extend(c,b)},get:function(a){return this.instances[a]},create:function(a){var d=this.items[a],b=d&&this._.handlers[d.type],c=d&&d.command&&this.editor.getCommand(d.command),b=b&&b.create.apply(this,d.args);this.instances[a]=b;c&&c.uiItems.push(b);if(b&&!b.type)b.type=d.type;return b},addHandler:function(a,d){this._.handlers[a]=
d},space:function(a){return CKEDITOR.document.getById(this.spaceId(a))},spaceId:function(a){return this.editor.id+"_"+a}};CKEDITOR.event.implementOn(CKEDITOR.ui);
(function(){function a(a,c,f){CKEDITOR.event.call(this);a=a&&CKEDITOR.tools.clone(a);if(c!==void 0){if(c instanceof CKEDITOR.dom.element){if(!f)throw Error("One of the element modes must be specified.");}else throw Error("Expect element of type CKEDITOR.dom.element.");if(CKEDITOR.env.ie&&CKEDITOR.env.quirks&&f==CKEDITOR.ELEMENT_MODE_INLINE)throw Error("Inline element mode is not supported on IE quirks.");if(!(f==CKEDITOR.ELEMENT_MODE_INLINE?c.is(CKEDITOR.dtd.$editable)||c.is("textarea"):f==CKEDITOR.ELEMENT_MODE_REPLACE?
!c.is(CKEDITOR.dtd.$nonBodyContent):1))throw Error('The specified element mode is not supported on element: "'+c.getName()+'".');this.element=c;this.elementMode=f;this.name=this.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO&&(c.getId()||c.getNameAtt())}else this.elementMode=CKEDITOR.ELEMENT_MODE_NONE;this._={};this.commands={};this.templates={};this.name=this.name||d();this.id=CKEDITOR.tools.getNextId();this.status="unloaded";this.config=CKEDITOR.tools.prototypedCopy(CKEDITOR.config);this.ui=new CKEDITOR.ui(this);
this.focusManager=new CKEDITOR.focusManager(this);this.keystrokeHandler=new CKEDITOR.keystrokeHandler(this);this.on("readOnly",b);this.on("selectionChange",function(a){e(this,a.data.path)});this.on("activeFilterChange",function(){e(this,this.elementPath(),true)});this.on("mode",b);this.on("instanceReady",function(){this.config.startupFocus&&this.focus()});CKEDITOR.fire("instanceCreated",null,this);CKEDITOR.add(this);CKEDITOR.tools.setTimeout(function(){h(this,a)},0,this)}function d(){do var a="editor"+
++r;while(CKEDITOR.instances[a]);return a}function b(){var a=this.commands,b;for(b in a)c(this,a[b])}function c(a,b){b[b.startDisabled?"disable":a.readOnly&&!b.readOnly?"disable":b.modes[a.mode]?"enable":"disable"]()}function e(a,b,c){if(b){var d,e,f=a.commands;for(e in f){d=f[e];(c||d.contextSensitive)&&d.refresh(a,b)}}}function f(a){var b=a.config.customConfig;if(!b)return false;var b=CKEDITOR.getUrl(b),c=y[b]||(y[b]={});if(c.fn){c.fn.call(a,a.config);(CKEDITOR.getUrl(a.config.customConfig)==b||
!f(a))&&a.fireOnce("customConfigLoaded")}else CKEDITOR.scriptLoader.queue(b,function(){c.fn=CKEDITOR.editorConfig?CKEDITOR.editorConfig:function(){};f(a)});return true}function h(a,b){a.on("customConfigLoaded",function(){if(b){if(b.on)for(var c in b.on)a.on(c,b.on[c]);CKEDITOR.tools.extend(a.config,b,true);delete a.config.on}c=a.config;a.readOnly=c.readOnly?true:a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?a.element.is("textarea")?a.element.hasAttribute("disabled")||a.element.hasAttribute("readonly"):
a.element.isReadOnly():a.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE?a.element.hasAttribute("disabled")||a.element.hasAttribute("readonly"):false;a.blockless=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?!(a.element.is("textarea")||CKEDITOR.dtd[a.element.getName()].p):false;a.tabIndex=c.tabIndex||a.element&&a.element.getAttribute("tabindex")||0;a.activeEnterMode=a.enterMode=a.blockless?CKEDITOR.ENTER_BR:c.enterMode;a.activeShiftEnterMode=a.shiftEnterMode=a.blockless?CKEDITOR.ENTER_BR:c.shiftEnterMode;
if(c.skin)CKEDITOR.skinName=c.skin;a.fireOnce("configLoaded");a.dataProcessor=new CKEDITOR.htmlDataProcessor(a);a.filter=a.activeFilter=new CKEDITOR.filter(a);i(a)});if(b&&b.customConfig!=null)a.config.customConfig=b.customConfig;f(a)||a.fireOnce("customConfigLoaded")}function i(a){CKEDITOR.skin.loadPart("editor",function(){j(a)})}function j(a){CKEDITOR.lang.load(a.config.language,a.config.defaultLanguage,function(b,c){var d=a.config.title;a.langCode=b;a.lang=CKEDITOR.tools.prototypedCopy(c);a.title=
typeof d=="string"||d===false?d:[a.lang.editor,a.name].join(", ");if(!a.config.contentsLangDirection)a.config.contentsLangDirection=a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?a.element.getDirection(1):a.lang.dir;a.fire("langLoaded");n(a)})}function n(a){a.getStylesSet(function(b){a.once("loaded",function(){a.fire("stylesSet",{styles:b})},null,null,1);g(a)})}function g(a){var b=a.config,c=b.plugins,d=b.extraPlugins,e=b.removePlugins;if(d)var f=RegExp("(?:^|,)(?:"+d.replace(/\s*,\s*/g,"|")+")(?=,|$)",
"g"),c=c.replace(f,""),c=c+(","+d);if(e)var g=RegExp("(?:^|,)(?:"+e.replace(/\s*,\s*/g,"|")+")(?=,|$)","g"),c=c.replace(g,"");CKEDITOR.env.air&&(c=c+",adobeair");CKEDITOR.plugins.load(c.split(","),function(c){var d=[],e=[],f=[];a.plugins=c;for(var p in c){var h=c[p],z=h.lang,i=null,j=h.requires,u;CKEDITOR.tools.isArray(j)&&(j=j.join(","));if(j&&(u=j.match(g)))for(;j=u.pop();)CKEDITOR.tools.setTimeout(function(a,b){throw Error('Plugin "'+a.replace(",","")+'" cannot be removed from the plugins list, because it\'s required by "'+
b+'" plugin.');},0,null,[j,p]);if(z&&!a.lang[p]){z.split&&(z=z.split(","));if(CKEDITOR.tools.indexOf(z,a.langCode)>=0)i=a.langCode;else{i=a.langCode.replace(/-.*/,"");i=i!=a.langCode&&CKEDITOR.tools.indexOf(z,i)>=0?i:CKEDITOR.tools.indexOf(z,"en")>=0?"en":z[0]}if(!h.langEntries||!h.langEntries[i])f.push(CKEDITOR.getUrl(h.path+"lang/"+i+".js"));else{a.lang[p]=h.langEntries[i];i=null}}e.push(i);d.push(h)}CKEDITOR.scriptLoader.load(f,function(){for(var c=["beforeInit","init","afterInit"],f=0;f<c.length;f++)for(var g=
0;g<d.length;g++){var p=d[g];f===0&&(e[g]&&p.lang&&p.langEntries)&&(a.lang[p.name]=p.langEntries[e[g]]);if(p[c[f]])p[c[f]](a)}a.fireOnce("pluginsLoaded");b.keystrokes&&a.setKeystroke(a.config.keystrokes);for(g=0;g<a.config.blockedKeystrokes.length;g++)a.keystrokeHandler.blockedKeystrokes[a.config.blockedKeystrokes[g]]=1;a.status="loaded";a.fireOnce("loaded");CKEDITOR.fire("instanceLoaded",null,a)})})}function A(){var a=this.element;if(a&&this.elementMode!=CKEDITOR.ELEMENT_MODE_APPENDTO){var b=this.getData();
this.config.htmlEncodeOutput&&(b=CKEDITOR.tools.htmlEncode(b));a.is("textarea")?a.setValue(b):a.setHtml(b);return true}return false}a.prototype=CKEDITOR.editor.prototype;CKEDITOR.editor=a;var r=0,y={};CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{addCommand:function(a,b){b.name=a.toLowerCase();var d=new CKEDITOR.command(this,b);this.mode&&c(this,d);return this.commands[a]=d},_attachToForm:function(){function a(d){b.updateElement();b._.required&&(!c.getValue()&&b.fire("required")===false)&&d.data.preventDefault()}
var b=this,c=b.element,d=new CKEDITOR.dom.element(c.$.form);if(c.is("textarea")&&d){d.on("submit",a);if(d.$.submit&&d.$.submit.call&&d.$.submit.apply)d.$.submit=CKEDITOR.tools.override(d.$.submit,function(b){return function(){a();b.apply?b.apply(this):b()}});b.on("destroy",function(){d.removeListener("submit",a)})}},destroy:function(a){this.fire("beforeDestroy");!a&&A.call(this);this.editable(null);this.filter.destroy();delete this.filter;delete this.activeFilter;this.status="destroyed";this.fire("destroy");
this.removeAllListeners();CKEDITOR.remove(this);CKEDITOR.fire("instanceDestroyed",null,this)},elementPath:function(a){if(!a){a=this.getSelection();if(!a)return null;a=a.getStartElement()}return a?new CKEDITOR.dom.elementPath(a,this.editable()):null},createRange:function(){var a=this.editable();return a?new CKEDITOR.dom.range(a):null},execCommand:function(a,b){var c=this.getCommand(a),d={name:a,commandData:b,command:c};if(c&&c.state!=CKEDITOR.TRISTATE_DISABLED&&this.fire("beforeCommandExec",d)!==false){d.returnValue=
c.exec(d.commandData);if(!c.async&&this.fire("afterCommandExec",d)!==false)return d.returnValue}return false},getCommand:function(a){return this.commands[a]},getData:function(a){!a&&this.fire("beforeGetData");var b=this._.data;if(typeof b!="string")b=(b=this.element)&&this.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE?b.is("textarea")?b.getValue():b.getHtml():"";b={dataValue:b};!a&&this.fire("getData",b);return b.dataValue},getSnapshot:function(){var a=this.fire("getSnapshot");if(typeof a!="string")a=
(a=this.element)&&this.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE?a.is("textarea")?a.getValue():a.getHtml():"";return a},loadSnapshot:function(a){this.fire("loadSnapshot",a)},setData:function(a,b,c){var d=true,e=b;if(b&&typeof b=="object"){c=b.internal;e=b.callback;d=!b.noSnapshot}!c&&d&&this.fire("saveSnapshot");if(e||!c)this.once("dataReady",function(a){!c&&d&&this.fire("saveSnapshot");e&&e.call(a.editor)});a={dataValue:a};!c&&this.fire("setData",a);this._.data=a.dataValue;!c&&this.fire("afterSetData",
a)},setReadOnly:function(a){a=a==null||a;if(this.readOnly!=a){this.readOnly=a;this.keystrokeHandler.blockedKeystrokes[8]=+a;this.editable().setReadOnly(a);this.fire("readOnly")}},insertHtml:function(a,b,c){this.fire("insertHtml",{dataValue:a,mode:b,range:c})},insertText:function(a){this.fire("insertText",a)},insertElement:function(a){this.fire("insertElement",a)},getSelectedHtml:function(a){var b=this.editable(),c=this.getSelection(),c=c&&c.getRanges();if(!b||!c||c.length===0)return null;b=b.getHtmlFromRange(c[0]);
return a?b.getHtml():b},extractSelectedHtml:function(a,b){var c=this.editable(),d=this.getSelection().getRanges();if(!c||d.length===0)return null;d=d[0];c=c.extractHtmlFromRange(d,b);b||this.getSelection().selectRanges([d]);return a?c.getHtml():c},focus:function(){this.fire("beforeFocus")},checkDirty:function(){return this.status=="ready"&&this._.previousValue!==this.getSnapshot()},resetDirty:function(){this._.previousValue=this.getSnapshot()},updateElement:function(){return A.call(this)},setKeystroke:function(){for(var a=
this.keystrokeHandler.keystrokes,b=CKEDITOR.tools.isArray(arguments[0])?arguments[0]:[[].slice.call(arguments,0)],c,d,e=b.length;e--;){c=b[e];d=0;if(CKEDITOR.tools.isArray(c)){d=c[1];c=c[0]}d?a[c]=d:delete a[c]}},addFeature:function(a){return this.filter.addFeature(a)},setActiveFilter:function(a){if(!a)a=this.filter;if(this.activeFilter!==a){this.activeFilter=a;this.fire("activeFilterChange");a===this.filter?this.setActiveEnterMode(null,null):this.setActiveEnterMode(a.getAllowedEnterMode(this.enterMode),
a.getAllowedEnterMode(this.shiftEnterMode,true))}},setActiveEnterMode:function(a,b){a=a?this.blockless?CKEDITOR.ENTER_BR:a:this.enterMode;b=b?this.blockless?CKEDITOR.ENTER_BR:b:this.shiftEnterMode;if(this.activeEnterMode!=a||this.activeShiftEnterMode!=b){this.activeEnterMode=a;this.activeShiftEnterMode=b;this.fire("activeEnterModeChange")}},showNotification:function(a){alert(a)}})})();CKEDITOR.ELEMENT_MODE_NONE=0;CKEDITOR.ELEMENT_MODE_REPLACE=1;CKEDITOR.ELEMENT_MODE_APPENDTO=2;
CKEDITOR.ELEMENT_MODE_INLINE=3;CKEDITOR.htmlParser=function(){this._={htmlPartsRegex:/<(?:(?:\/([^>]+)>)|(?:!--([\S|\s]*?)--\>)|(?:([^\/\s>]+)((?:\s+[\w\-:.]+(?:\s*=\s*?(?:(?:"[^"]*")|(?:'[^']*')|[^\s"'\/>]+))?)*)[\S\s]*?(\/?)>))/g}};
(function(){var a=/([\w\-:.]+)(?:(?:\s*=\s*(?:(?:"([^"]*)")|(?:'([^']*)')|([^\s>]+)))|(?=\s|$))/g,d={checked:1,compact:1,declare:1,defer:1,disabled:1,ismap:1,multiple:1,nohref:1,noresize:1,noshade:1,nowrap:1,readonly:1,selected:1};CKEDITOR.htmlParser.prototype={onTagOpen:function(){},onTagClose:function(){},onText:function(){},onCDATA:function(){},onComment:function(){},parse:function(b){for(var c,e,f=0,h;c=this._.htmlPartsRegex.exec(b);){e=c.index;if(e>f){f=b.substring(f,e);if(h)h.push(f);else this.onText(f)}f=
this._.htmlPartsRegex.lastIndex;if(e=c[1]){e=e.toLowerCase();if(h&&CKEDITOR.dtd.$cdata[e]){this.onCDATA(h.join(""));h=null}if(!h){this.onTagClose(e);continue}}if(h)h.push(c[0]);else if(e=c[3]){e=e.toLowerCase();if(!/="/.test(e)){var i={},j,n=c[4];c=!!c[5];if(n)for(;j=a.exec(n);){var g=j[1].toLowerCase();j=j[2]||j[3]||j[4]||"";i[g]=!j&&d[g]?g:CKEDITOR.tools.htmlDecodeAttr(j)}this.onTagOpen(e,i,c);!h&&CKEDITOR.dtd.$cdata[e]&&(h=[])}}else if(e=c[2])this.onComment(e)}if(b.length>f)this.onText(b.substring(f,
b.length))}}})();
CKEDITOR.htmlParser.basicWriter=CKEDITOR.tools.createClass({$:function(){this._={output:[]}},proto:{openTag:function(a){this._.output.push("<",a)},openTagClose:function(a,d){d?this._.output.push(" />"):this._.output.push(">")},attribute:function(a,d){typeof d=="string"&&(d=CKEDITOR.tools.htmlEncodeAttr(d));this._.output.push(" ",a,'="',d,'"')},closeTag:function(a){this._.output.push("</",a,">")},text:function(a){this._.output.push(a)},comment:function(a){this._.output.push("<\!--",a,"--\>")},write:function(a){this._.output.push(a)},
reset:function(){this._.output=[];this._.indent=false},getHtml:function(a){var d=this._.output.join("");a&&this.reset();return d}}});"use strict";
(function(){CKEDITOR.htmlParser.node=function(){};CKEDITOR.htmlParser.node.prototype={remove:function(){var a=this.parent.children,d=CKEDITOR.tools.indexOf(a,this),b=this.previous,c=this.next;b&&(b.next=c);c&&(c.previous=b);a.splice(d,1);this.parent=null},replaceWith:function(a){var d=this.parent.children,b=CKEDITOR.tools.indexOf(d,this),c=a.previous=this.previous,e=a.next=this.next;c&&(c.next=a);e&&(e.previous=a);d[b]=a;a.parent=this.parent;this.parent=null},insertAfter:function(a){var d=a.parent.children,
b=CKEDITOR.tools.indexOf(d,a),c=a.next;d.splice(b+1,0,this);this.next=a.next;this.previous=a;a.next=this;c&&(c.previous=this);this.parent=a.parent},insertBefore:function(a){var d=a.parent.children,b=CKEDITOR.tools.indexOf(d,a);d.splice(b,0,this);this.next=a;(this.previous=a.previous)&&(a.previous.next=this);a.previous=this;this.parent=a.parent},getAscendant:function(a){var d=typeof a=="function"?a:typeof a=="string"?function(b){return b.name==a}:function(b){return b.name in a},b=this.parent;for(;b&&
b.type==CKEDITOR.NODE_ELEMENT;){if(d(b))return b;b=b.parent}return null},wrapWith:function(a){this.replaceWith(a);a.add(this);return a},getIndex:function(){return CKEDITOR.tools.indexOf(this.parent.children,this)},getFilterContext:function(a){return a||{}}}})();"use strict";CKEDITOR.htmlParser.comment=function(a){this.value=a;this._={isBlockLike:false}};
CKEDITOR.htmlParser.comment.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node,{type:CKEDITOR.NODE_COMMENT,filter:function(a,d){var b=this.value;if(!(b=a.onComment(d,b,this))){this.remove();return false}if(typeof b!="string"){this.replaceWith(b);return false}this.value=b;return true},writeHtml:function(a,d){d&&this.filter(d);a.comment(this.value)}});"use strict";
(function(){CKEDITOR.htmlParser.text=function(a){this.value=a;this._={isBlockLike:false}};CKEDITOR.htmlParser.text.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node,{type:CKEDITOR.NODE_TEXT,filter:function(a,d){if(!(this.value=a.onText(d,this.value,this))){this.remove();return false}},writeHtml:function(a,d){d&&this.filter(d);a.text(this.value)}})})();"use strict";
(function(){CKEDITOR.htmlParser.cdata=function(a){this.value=a};CKEDITOR.htmlParser.cdata.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node,{type:CKEDITOR.NODE_TEXT,filter:function(){},writeHtml:function(a){a.write(this.value)}})})();"use strict";CKEDITOR.htmlParser.fragment=function(){this.children=[];this.parent=null;this._={isBlockLike:true,hasInlineStarted:false}};
(function(){function a(a){return a.attributes["data-cke-survive"]?false:a.name=="a"&&a.attributes.href||CKEDITOR.dtd.$removeEmpty[a.name]}var d=CKEDITOR.tools.extend({table:1,ul:1,ol:1,dl:1},CKEDITOR.dtd.table,CKEDITOR.dtd.ul,CKEDITOR.dtd.ol,CKEDITOR.dtd.dl),b={ol:1,ul:1},c=CKEDITOR.tools.extend({},{html:1},CKEDITOR.dtd.html,CKEDITOR.dtd.body,CKEDITOR.dtd.head,{style:1,script:1}),e={ul:"li",ol:"li",dl:"dd",table:"tbody",tbody:"tr",thead:"tr",tfoot:"tr",tr:"td"};CKEDITOR.htmlParser.fragment.fromHtml=
function(f,h,i){function j(a){var b;if(t.length>0)for(var c=0;c<t.length;c++){var d=t[c],e=d.name,f=CKEDITOR.dtd[e],g=v.name&&CKEDITOR.dtd[v.name];if((!g||g[e])&&(!a||!f||f[a]||!CKEDITOR.dtd[a])){if(!b){n();b=1}d=d.clone();d.parent=v;v=d;t.splice(c,1);c--}else if(e==v.name){A(v,v.parent,1);c--}}}function n(){for(;w.length;)A(w.shift(),v)}function g(a){if(a._.isBlockLike&&a.name!="pre"&&a.name!="textarea"){var b=a.children.length,c=a.children[b-1],d;if(c&&c.type==CKEDITOR.NODE_TEXT)(d=CKEDITOR.tools.rtrim(c.value))?
c.value=d:a.children.length=b-1}}function A(b,c,d){var c=c||v||q,e=v;if(b.previous===void 0){if(r(c,b)){v=c;o.onTagOpen(i,{});b.returnPoint=c=v}g(b);(!a(b)||b.children.length)&&c.add(b);b.name=="pre"&&(l=false);b.name=="textarea"&&(B=false)}if(b.returnPoint){v=b.returnPoint;delete b.returnPoint}else v=d?c:e}function r(a,b){if((a==q||a.name=="body")&&i&&(!a.name||CKEDITOR.dtd[a.name][i])){var c,d;return(c=b.attributes&&(d=b.attributes["data-cke-real-element-type"])?d:b.name)&&c in CKEDITOR.dtd.$inline&&
!(c in CKEDITOR.dtd.head)&&!b.isOrphan||b.type==CKEDITOR.NODE_TEXT}}function y(a,b){return a in CKEDITOR.dtd.$listItem||a in CKEDITOR.dtd.$tableContent?a==b||a=="dt"&&b=="dd"||a=="dd"&&b=="dt":false}var o=new CKEDITOR.htmlParser,q=h instanceof CKEDITOR.htmlParser.element?h:typeof h=="string"?new CKEDITOR.htmlParser.element(h):new CKEDITOR.htmlParser.fragment,t=[],w=[],v=q,B=q.name=="textarea",l=q.name=="pre";o.onTagOpen=function(e,k,f,g){k=new CKEDITOR.htmlParser.element(e,k);if(k.isUnknown&&f)k.isEmpty=
true;k.isOptionalClose=g;if(a(k))t.push(k);else{if(e=="pre")l=true;else{if(e=="br"&&l){v.add(new CKEDITOR.htmlParser.text("\n"));return}e=="textarea"&&(B=true)}if(e=="br")w.push(k);else{for(;;){g=(f=v.name)?CKEDITOR.dtd[f]||(v._.isBlockLike?CKEDITOR.dtd.div:CKEDITOR.dtd.span):c;if(!k.isUnknown&&!v.isUnknown&&!g[e])if(v.isOptionalClose)o.onTagClose(f);else if(e in b&&f in b){f=v.children;(f=f[f.length-1])&&f.name=="li"||A(f=new CKEDITOR.htmlParser.element("li"),v);!k.returnPoint&&(k.returnPoint=v);
v=f}else if(e in CKEDITOR.dtd.$listItem&&!y(e,f))o.onTagOpen(e=="li"?"ul":"dl",{},0,1);else if(f in d&&!y(e,f)){!k.returnPoint&&(k.returnPoint=v);v=v.parent}else{f in CKEDITOR.dtd.$inline&&t.unshift(v);if(v.parent)A(v,v.parent,1);else{k.isOrphan=1;break}}else break}j(e);n();k.parent=v;k.isEmpty?A(k):v=k}}};o.onTagClose=function(a){for(var b=t.length-1;b>=0;b--)if(a==t[b].name){t.splice(b,1);return}for(var c=[],d=[],e=v;e!=q&&e.name!=a;){e._.isBlockLike||d.unshift(e);c.push(e);e=e.returnPoint||e.parent}if(e!=
q){for(b=0;b<c.length;b++){var f=c[b];A(f,f.parent)}v=e;e._.isBlockLike&&n();A(e,e.parent);if(e==v)v=v.parent;t=t.concat(d)}a=="body"&&(i=false)};o.onText=function(a){if((!v._.hasInlineStarted||w.length)&&!l&&!B){a=CKEDITOR.tools.ltrim(a);if(a.length===0)return}var b=v.name,f=b?CKEDITOR.dtd[b]||(v._.isBlockLike?CKEDITOR.dtd.div:CKEDITOR.dtd.span):c;if(!B&&!f["#"]&&b in d){o.onTagOpen(e[b]||"");o.onText(a)}else{n();j();!l&&!B&&(a=a.replace(/[\t\r\n ]{2,}|[\t\r\n]/g," "));a=new CKEDITOR.htmlParser.text(a);
if(r(v,a))this.onTagOpen(i,{},0,1);v.add(a)}};o.onCDATA=function(a){v.add(new CKEDITOR.htmlParser.cdata(a))};o.onComment=function(a){n();j();v.add(new CKEDITOR.htmlParser.comment(a))};o.parse(f);for(n();v!=q;)A(v,v.parent,1);g(q);return q};CKEDITOR.htmlParser.fragment.prototype={type:CKEDITOR.NODE_DOCUMENT_FRAGMENT,add:function(a,b){isNaN(b)&&(b=this.children.length);var c=b>0?this.children[b-1]:null;if(c){if(a._.isBlockLike&&c.type==CKEDITOR.NODE_TEXT){c.value=CKEDITOR.tools.rtrim(c.value);if(c.value.length===
0){this.children.pop();this.add(a);return}}c.next=a}a.previous=c;a.parent=this;this.children.splice(b,0,a);if(!this._.hasInlineStarted)this._.hasInlineStarted=a.type==CKEDITOR.NODE_TEXT||a.type==CKEDITOR.NODE_ELEMENT&&!a._.isBlockLike},filter:function(a,b){b=this.getFilterContext(b);a.onRoot(b,this);this.filterChildren(a,false,b)},filterChildren:function(a,b,c){if(this.childrenFilteredBy!=a.id){c=this.getFilterContext(c);if(b&&!this.parent)a.onRoot(c,this);this.childrenFilteredBy=a.id;for(b=0;b<this.children.length;b++)this.children[b].filter(a,
c)===false&&b--}},writeHtml:function(a,b){b&&this.filter(b);this.writeChildrenHtml(a)},writeChildrenHtml:function(a,b,c){var d=this.getFilterContext();if(c&&!this.parent&&b)b.onRoot(d,this);b&&this.filterChildren(b,false,d);b=0;c=this.children;for(d=c.length;b<d;b++)c[b].writeHtml(a)},forEach:function(a,b,c){if(!c&&(!b||this.type==b))var d=a(this);if(d!==false)for(var c=this.children,e=0;e<c.length;e++){d=c[e];d.type==CKEDITOR.NODE_ELEMENT?d.forEach(a,b):(!b||d.type==b)&&a(d)}},getFilterContext:function(a){return a||
{}}}})();"use strict";
(function(){function a(){this.rules=[]}function d(b,c,d,f){var h,i;for(h in c){(i=b[h])||(i=b[h]=new a);i.add(c[h],d,f)}}CKEDITOR.htmlParser.filter=CKEDITOR.tools.createClass({$:function(b){this.id=CKEDITOR.tools.getNextNumber();this.elementNameRules=new a;this.attributeNameRules=new a;this.elementsRules={};this.attributesRules={};this.textRules=new a;this.commentRules=new a;this.rootRules=new a;b&&this.addRules(b,10)},proto:{addRules:function(a,c){var e;if(typeof c=="number")e=c;else if(c&&"priority"in
c)e=c.priority;typeof e!="number"&&(e=10);typeof c!="object"&&(c={});a.elementNames&&this.elementNameRules.addMany(a.elementNames,e,c);a.attributeNames&&this.attributeNameRules.addMany(a.attributeNames,e,c);a.elements&&d(this.elementsRules,a.elements,e,c);a.attributes&&d(this.attributesRules,a.attributes,e,c);a.text&&this.textRules.add(a.text,e,c);a.comment&&this.commentRules.add(a.comment,e,c);a.root&&this.rootRules.add(a.root,e,c)},applyTo:function(a){a.filter(this)},onElementName:function(a,c){return this.elementNameRules.execOnName(a,
c)},onAttributeName:function(a,c){return this.attributeNameRules.execOnName(a,c)},onText:function(a,c,d){return this.textRules.exec(a,c,d)},onComment:function(a,c,d){return this.commentRules.exec(a,c,d)},onRoot:function(a,c){return this.rootRules.exec(a,c)},onElement:function(a,c){for(var d=[this.elementsRules["^"],this.elementsRules[c.name],this.elementsRules.$],f,h=0;h<3;h++)if(f=d[h]){f=f.exec(a,c,this);if(f===false)return null;if(f&&f!=c)return this.onNode(a,f);if(c.parent&&!c.name)break}return c},
onNode:function(a,c){var d=c.type;return d==CKEDITOR.NODE_ELEMENT?this.onElement(a,c):d==CKEDITOR.NODE_TEXT?new CKEDITOR.htmlParser.text(this.onText(a,c.value)):d==CKEDITOR.NODE_COMMENT?new CKEDITOR.htmlParser.comment(this.onComment(a,c.value)):null},onAttribute:function(a,c,d,f){return(d=this.attributesRules[d])?d.exec(a,f,c,this):f}}});CKEDITOR.htmlParser.filterRulesGroup=a;a.prototype={add:function(a,c,d){this.rules.splice(this.findIndex(c),0,{value:a,priority:c,options:d})},addMany:function(a,
c,d){for(var f=[this.findIndex(c),0],h=0,i=a.length;h<i;h++)f.push({value:a[h],priority:c,options:d});this.rules.splice.apply(this.rules,f)},findIndex:function(a){for(var c=this.rules,d=c.length-1;d>=0&&a<c[d].priority;)d--;return d+1},exec:function(a,c){var d=c instanceof CKEDITOR.htmlParser.node||c instanceof CKEDITOR.htmlParser.fragment,f=Array.prototype.slice.call(arguments,1),h=this.rules,i=h.length,j,n,g,A;for(A=0;A<i;A++){if(d){j=c.type;n=c.name}g=h[A];if(!(a.nonEditable&&!g.options.applyToAll||
a.nestedEditable&&g.options.excludeNestedEditable)){g=g.value.apply(null,f);if(g===false||d&&g&&(g.name!=n||g.type!=j))return g;g!=null&&(f[0]=c=g)}}return c},execOnName:function(a,c){for(var d=0,f=this.rules,h=f.length,i;c&&d<h;d++){i=f[d];!(a.nonEditable&&!i.options.applyToAll||a.nestedEditable&&i.options.excludeNestedEditable)&&(c=c.replace(i.value[0],i.value[1]))}return c}}})();
(function(){function a(a,d){function k(a){return a||CKEDITOR.env.needsNbspFiller?new CKEDITOR.htmlParser.text(" "):new CKEDITOR.htmlParser.element("br",{"data-cke-bogus":1})}function g(a,d){return function(e){if(e.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT){var g=[],p=b(e),D,h;if(p)for(m(p,1)&&g.push(p);p;){if(f(p)&&(D=c(p))&&m(D))if((h=c(D))&&!f(h))g.push(D);else{k(u).insertAfter(D);D.remove()}p=p.previous}for(p=0;p<g.length;p++)g[p].remove();if(g=!a||(typeof d=="function"?d(e):d)!==false)if(!u&&!CKEDITOR.env.needsBrFiller&&
e.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT)g=false;else if(!u&&!CKEDITOR.env.needsBrFiller&&(document.documentMode>7||e.name in CKEDITOR.dtd.tr||e.name in CKEDITOR.dtd.$listItem))g=false;else{g=b(e);g=!g||e.name=="form"&&g.name=="input"}g&&e.add(k(a))}}}function m(a,b){if((!u||CKEDITOR.env.needsBrFiller)&&a.type==CKEDITOR.NODE_ELEMENT&&a.name=="br"&&!a.attributes["data-cke-eol"])return true;var c;if(a.type==CKEDITOR.NODE_TEXT&&(c=a.value.match(t))){if(c.index){(new CKEDITOR.htmlParser.text(a.value.substring(0,
c.index))).insertBefore(a);a.value=c[0]}if(!CKEDITOR.env.needsBrFiller&&u&&(!b||a.parent.name in z))return true;if(!u)if((c=a.previous)&&c.name=="br"||!c||f(c))return true}return false}var p={elements:{}},u=d=="html",z=CKEDITOR.tools.extend({},l),C;for(C in z)"#"in v[C]||delete z[C];for(C in z)p.elements[C]=g(u,a.config.fillEmptyBlocks);p.root=g(u,false);p.elements.br=function(a){return function(b){if(b.parent.type!=CKEDITOR.NODE_DOCUMENT_FRAGMENT){var d=b.attributes;if("data-cke-bogus"in d||"data-cke-eol"in
d)delete d["data-cke-bogus"];else{for(d=b.next;d&&e(d);)d=d.next;var g=c(b);!d&&f(b.parent)?h(b.parent,k(a)):f(d)&&(g&&!f(g))&&k(a).insertBefore(d)}}}}(u);return p}function d(a,b){return a!=CKEDITOR.ENTER_BR&&b!==false?a==CKEDITOR.ENTER_DIV?"div":"p":false}function b(a){for(a=a.children[a.children.length-1];a&&e(a);)a=a.previous;return a}function c(a){for(a=a.previous;a&&e(a);)a=a.previous;return a}function e(a){return a.type==CKEDITOR.NODE_TEXT&&!CKEDITOR.tools.trim(a.value)||a.type==CKEDITOR.NODE_ELEMENT&&
a.attributes["data-cke-bookmark"]}function f(a){return a&&(a.type==CKEDITOR.NODE_ELEMENT&&a.name in l||a.type==CKEDITOR.NODE_DOCUMENT_FRAGMENT)}function h(a,b){var c=a.children[a.children.length-1];a.children.push(b);b.parent=a;if(c){c.next=b;b.previous=c}}function i(a){a=a.attributes;a.contenteditable!="false"&&(a["data-cke-editable"]=a.contenteditable?"true":1);a.contenteditable="false"}function j(a){a=a.attributes;switch(a["data-cke-editable"]){case "true":a.contenteditable="true";break;case "1":delete a.contenteditable}}
function n(a){return a.replace(p,function(a,b,c){return"<"+b+c.replace(I,function(a,b){return z.test(b)&&c.indexOf("data-cke-saved-"+b)==-1?" data-cke-saved-"+a+" data-cke-"+CKEDITOR.rnd+"-"+a:a})+">"})}function g(a,b){return a.replace(b,function(a,b,c){a.indexOf("<textarea")===0&&(a=b+y(c).replace(/</g,"&lt;").replace(/>/g,"&gt;")+"</textarea>");return"<cke:encoded>"+encodeURIComponent(a)+"</cke:encoded>"})}function A(a){return a.replace(u,function(a,b){return decodeURIComponent(b)})}function r(a){return a.replace(/<\!--(?!{cke_protected})[\s\S]+?--\>/g,
function(a){return"<\!--"+w+"{C}"+encodeURIComponent(a).replace(/--/g,"%2D%2D")+"--\>"})}function y(a){return a.replace(/<\!--\{cke_protected\}\{C\}([\s\S]+?)--\>/g,function(a,b){return decodeURIComponent(b)})}function o(a,b){var c=b._.dataStore;return a.replace(/<\!--\{cke_protected\}([\s\S]+?)--\>/g,function(a,b){return decodeURIComponent(b)}).replace(/\{cke_protected_(\d+)\}/g,function(a,b){return c&&c[b]||""})}function q(a,b){for(var c=[],d=b.config.protectedSource,k=b._.dataStore||(b._.dataStore=
{id:1}),e=/<\!--\{cke_temp(comment)?\}(\d*?)--\>/g,d=[/<script[\s\S]*?(<\/script>|$)/gi,/<noscript[\s\S]*?<\/noscript>/gi,/<meta[\s\S]*?\/?>/gi].concat(d),a=a.replace(/<\!--[\s\S]*?--\>/g,function(a){return"<\!--{cke_tempcomment}"+(c.push(a)-1)+"--\>"}),f=0;f<d.length;f++)a=a.replace(d[f],function(a){a=a.replace(e,function(a,b,d){return c[d]});return/cke_temp(comment)?/.test(a)?a:"<\!--{cke_temp}"+(c.push(a)-1)+"--\>"});a=a.replace(e,function(a,b,d){return"<\!--"+w+(b?"{C}":"")+encodeURIComponent(c[d]).replace(/--/g,
"%2D%2D")+"--\>"});a=a.replace(/<\w+(?:\s+(?:(?:[^\s=>]+\s*=\s*(?:[^'"\s>]+|'[^']*'|"[^"]*"))|[^\s=\/>]+))+\s*\/?>/g,function(a){return a.replace(/<\!--\{cke_protected\}([^>]*)--\>/g,function(a,b){k[k.id]=decodeURIComponent(b);return"{cke_protected_"+k.id++ +"}"})});return a=a.replace(/<(title|iframe|textarea)([^>]*)>([\s\S]*?)<\/\1>/g,function(a,c,d,k){return"<"+c+d+">"+o(y(k),b)+"</"+c+">"})}CKEDITOR.htmlDataProcessor=function(b){var c,e,f=this;this.editor=b;this.dataFilter=c=new CKEDITOR.htmlParser.filter;
this.htmlFilter=e=new CKEDITOR.htmlParser.filter;this.writer=new CKEDITOR.htmlParser.basicWriter;c.addRules(s);c.addRules(k,{applyToAll:true});c.addRules(a(b,"data"),{applyToAll:true});e.addRules(m);e.addRules(F,{applyToAll:true});e.addRules(a(b,"html"),{applyToAll:true});b.on("toHtml",function(a){var a=a.data,c=a.dataValue,k,c=q(c,b),c=g(c,E),c=n(c),c=g(c,L),c=c.replace(K,"$1cke:$2"),c=c.replace(x,"<cke:$1$2></cke:$1>"),c=c.replace(/(<pre\b[^>]*>)(\r\n|\n)/g,"$1$2$2"),c=c.replace(/([^a-z0-9<\-])(on\w{3,})(?!>)/gi,
"$1data-cke-"+CKEDITOR.rnd+"-$2");k=a.context||b.editable().getName();var e;if(CKEDITOR.env.ie&&CKEDITOR.env.version<9&&k=="pre"){k="div";c="<pre>"+c+"</pre>";e=1}k=b.document.createElement(k);k.setHtml("a"+c);c=k.getHtml().substr(1);c=c.replace(RegExp("data-cke-"+CKEDITOR.rnd+"-","ig"),"");e&&(c=c.replace(/^<pre>|<\/pre>$/gi,""));c=c.replace(C,"$1$2");c=A(c);c=y(c);k=a.fixForBody===false?false:d(a.enterMode,b.config.autoParagraph);c=CKEDITOR.htmlParser.fragment.fromHtml(c,a.context,k);if(k){e=c;
if(!e.children.length&&CKEDITOR.dtd[e.name][k]){k=new CKEDITOR.htmlParser.element(k);e.add(k)}}a.dataValue=c},null,null,5);b.on("toHtml",function(a){a.data.filter.applyTo(a.data.dataValue,true,a.data.dontFilter,a.data.enterMode)&&b.fire("dataFiltered")},null,null,6);b.on("toHtml",function(a){a.data.dataValue.filterChildren(f.dataFilter,true)},null,null,10);b.on("toHtml",function(a){var a=a.data,b=a.dataValue,c=new CKEDITOR.htmlParser.basicWriter;b.writeChildrenHtml(c);b=c.getHtml(true);a.dataValue=
r(b)},null,null,15);b.on("toDataFormat",function(a){var c=a.data.dataValue;a.data.enterMode!=CKEDITOR.ENTER_BR&&(c=c.replace(/^<br *\/?>/i,""));a.data.dataValue=CKEDITOR.htmlParser.fragment.fromHtml(c,a.data.context,d(a.data.enterMode,b.config.autoParagraph))},null,null,5);b.on("toDataFormat",function(a){a.data.dataValue.filterChildren(f.htmlFilter,true)},null,null,10);b.on("toDataFormat",function(a){a.data.filter.applyTo(a.data.dataValue,false,true)},null,null,11);b.on("toDataFormat",function(a){var c=
a.data.dataValue,d=f.writer;d.reset();c.writeChildrenHtml(d);c=d.getHtml(true);c=y(c);c=o(c,b);a.data.dataValue=c},null,null,15)};CKEDITOR.htmlDataProcessor.prototype={toHtml:function(a,b,c,d){var k=this.editor,e,f,g,m;if(b&&typeof b=="object"){e=b.context;c=b.fixForBody;d=b.dontFilter;f=b.filter;g=b.enterMode;m=b.protectedWhitespaces}else e=b;!e&&e!==null&&(e=k.editable().getName());return k.fire("toHtml",{dataValue:a,context:e,fixForBody:c,dontFilter:d,filter:f||k.filter,enterMode:g||k.enterMode,
protectedWhitespaces:m}).dataValue},toDataFormat:function(a,b){var c,d,k;if(b){c=b.context;d=b.filter;k=b.enterMode}!c&&c!==null&&(c=this.editor.editable().getName());return this.editor.fire("toDataFormat",{dataValue:a,filter:d||this.editor.filter,context:c,enterMode:k||this.editor.enterMode}).dataValue}};var t=/(?:&nbsp;|\xa0)$/,w="{cke_protected}",v=CKEDITOR.dtd,B=["caption","colgroup","col","thead","tfoot","tbody"],l=CKEDITOR.tools.extend({},v.$blockLimit,v.$block),s={elements:{input:i,textarea:i}},
k={attributeNames:[[/^on/,"data-cke-pa-on"],[/^data-cke-expando$/,""]]},m={elements:{embed:function(a){var b=a.parent;if(b&&b.name=="object"){var c=b.attributes.width,b=b.attributes.height;if(c)a.attributes.width=c;if(b)a.attributes.height=b}},a:function(a){if(!a.children.length&&!a.attributes.name&&!a.attributes["data-cke-saved-name"])return false}}},F={elementNames:[[/^cke:/,""],[/^\?xml:namespace$/,""]],attributeNames:[[/^data-cke-(saved|pa)-/,""],[/^data-cke-.*/,""],["hidefocus",""]],elements:{$:function(a){var b=
a.attributes;if(b){if(b["data-cke-temp"])return false;for(var c=["name","href","src"],d,k=0;k<c.length;k++){d="data-cke-saved-"+c[k];d in b&&delete b[c[k]]}}return a},table:function(a){a.children.slice(0).sort(function(a,b){var c,d;if(a.type==CKEDITOR.NODE_ELEMENT&&b.type==a.type){c=CKEDITOR.tools.indexOf(B,a.name);d=CKEDITOR.tools.indexOf(B,b.name)}if(!(c>-1&&d>-1&&c!=d)){c=a.parent?a.getIndex():-1;d=b.parent?b.getIndex():-1}return c>d?1:-1})},param:function(a){a.children=[];a.isEmpty=true;return a},
span:function(a){a.attributes["class"]=="Apple-style-span"&&delete a.name},html:function(a){delete a.attributes.contenteditable;delete a.attributes["class"]},body:function(a){delete a.attributes.spellcheck;delete a.attributes.contenteditable},style:function(a){var b=a.children[0];if(b&&b.value)b.value=CKEDITOR.tools.trim(b.value);if(!a.attributes.type)a.attributes.type="text/css"},title:function(a){var b=a.children[0];!b&&h(a,b=new CKEDITOR.htmlParser.text);b.value=a.attributes["data-cke-title"]||
""},input:j,textarea:j},attributes:{"class":function(a){return CKEDITOR.tools.ltrim(a.replace(/(?:^|\s+)cke_[^\s]*/g,""))||false}}};if(CKEDITOR.env.ie)F.attributes.style=function(a){return a.replace(/(^|;)([^\:]+)/g,function(a){return a.toLowerCase()})};var p=/<(a|area|img|input|source)\b([^>]*)>/gi,I=/([\w-:]+)\s*=\s*(?:(?:"[^"]*")|(?:'[^']*')|(?:[^ "'>]+))/gi,z=/^(href|src|name)$/i,L=/(?:<style(?=[ >])[^>]*>[\s\S]*?<\/style>)|(?:<(:?link|meta|base)[^>]*>)/gi,E=/(<textarea(?=[ >])[^>]*>)([\s\S]*?)(?:<\/textarea>)/gi,
u=/<cke:encoded>([^<]*)<\/cke:encoded>/gi,K=/(<\/?)((?:object|embed|param|html|body|head|title)[^>]*>)/gi,C=/(<\/?)cke:((?:html|body|head|title)[^>]*>)/gi,x=/<cke:(param|embed)([^>]*?)\/?>(?!\s*<\/cke:\1)/gi})();"use strict";
CKEDITOR.htmlParser.element=function(a,d){this.name=a;this.attributes=d||{};this.children=[];var b=a||"",c=b.match(/^cke:(.*)/);c&&(b=c[1]);b=!(!CKEDITOR.dtd.$nonBodyContent[b]&&!CKEDITOR.dtd.$block[b]&&!CKEDITOR.dtd.$listItem[b]&&!CKEDITOR.dtd.$tableContent[b]&&!(CKEDITOR.dtd.$nonEditable[b]||b=="br"));this.isEmpty=!!CKEDITOR.dtd.$empty[a];this.isUnknown=!CKEDITOR.dtd[a];this._={isBlockLike:b,hasInlineStarted:this.isEmpty||!b}};
CKEDITOR.htmlParser.cssStyle=function(a){var d={};((a instanceof CKEDITOR.htmlParser.element?a.attributes.style:a)||"").replace(/&quot;/g,'"').replace(/\s*([^ :;]+)\s*:\s*([^;]+)\s*(?=;|$)/g,function(a,c,e){c=="font-family"&&(e=e.replace(/["']/g,""));d[c.toLowerCase()]=e});return{rules:d,populate:function(a){var c=this.toString();if(c)a instanceof CKEDITOR.dom.element?a.setAttribute("style",c):a instanceof CKEDITOR.htmlParser.element?a.attributes.style=c:a.style=c},toString:function(){var a=[],c;
for(c in d)d[c]&&a.push(c,":",d[c],";");return a.join("")}}};
(function(){function a(a){return function(b){return b.type==CKEDITOR.NODE_ELEMENT&&(typeof a=="string"?b.name==a:b.name in a)}}var d=function(a,b){a=a[0];b=b[0];return a<b?-1:a>b?1:0},b=CKEDITOR.htmlParser.fragment.prototype;CKEDITOR.htmlParser.element.prototype=CKEDITOR.tools.extend(new CKEDITOR.htmlParser.node,{type:CKEDITOR.NODE_ELEMENT,add:b.add,clone:function(){return new CKEDITOR.htmlParser.element(this.name,this.attributes)},filter:function(a,b){var d=this,h,i,b=d.getFilterContext(b);if(b.off)return true;
if(!d.parent)a.onRoot(b,d);for(;;){h=d.name;if(!(i=a.onElementName(b,h))){this.remove();return false}d.name=i;if(!(d=a.onElement(b,d))){this.remove();return false}if(d!==this){this.replaceWith(d);return false}if(d.name==h)break;if(d.type!=CKEDITOR.NODE_ELEMENT){this.replaceWith(d);return false}if(!d.name){this.replaceWithChildren();return false}}h=d.attributes;var j,n;for(j in h){n=j;for(i=h[j];;)if(n=a.onAttributeName(b,j))if(n!=j){delete h[j];j=n}else break;else{delete h[j];break}n&&((i=a.onAttribute(b,
d,n,i))===false?delete h[n]:h[n]=i)}d.isEmpty||this.filterChildren(a,false,b);return true},filterChildren:b.filterChildren,writeHtml:function(a,b){b&&this.filter(b);var f=this.name,h=[],i=this.attributes,j,n;a.openTag(f,i);for(j in i)h.push([j,i[j]]);a.sortAttributes&&h.sort(d);j=0;for(n=h.length;j<n;j++){i=h[j];a.attribute(i[0],i[1])}a.openTagClose(f,this.isEmpty);this.writeChildrenHtml(a);this.isEmpty||a.closeTag(f)},writeChildrenHtml:b.writeChildrenHtml,replaceWithChildren:function(){for(var a=
this.children,b=a.length;b;)a[--b].insertAfter(this);this.remove()},forEach:b.forEach,getFirst:function(b){if(!b)return this.children.length?this.children[0]:null;typeof b!="function"&&(b=a(b));for(var d=0,f=this.children.length;d<f;++d)if(b(this.children[d]))return this.children[d];return null},getHtml:function(){var a=new CKEDITOR.htmlParser.basicWriter;this.writeChildrenHtml(a);return a.getHtml()},setHtml:function(a){for(var a=this.children=CKEDITOR.htmlParser.fragment.fromHtml(a).children,b=0,
d=a.length;b<d;++b)a[b].parent=this},getOuterHtml:function(){var a=new CKEDITOR.htmlParser.basicWriter;this.writeHtml(a);return a.getHtml()},split:function(a){for(var b=this.children.splice(a,this.children.length-a),d=this.clone(),h=0;h<b.length;++h)b[h].parent=d;d.children=b;if(b[0])b[0].previous=null;if(a>0)this.children[a-1].next=null;this.parent.add(d,this.getIndex()+1);return d},addClass:function(a){if(!this.hasClass(a)){var b=this.attributes["class"]||"";this.attributes["class"]=b+(b?" ":"")+
a}},removeClass:function(a){var b=this.attributes["class"];if(b)(b=CKEDITOR.tools.trim(b.replace(RegExp("(?:\\s+|^)"+a+"(?:\\s+|$)")," ")))?this.attributes["class"]=b:delete this.attributes["class"]},hasClass:function(a){var b=this.attributes["class"];return!b?false:RegExp("(?:^|\\s)"+a+"(?=\\s|$)").test(b)},getFilterContext:function(a){var b=[];a||(a={off:false,nonEditable:false,nestedEditable:false});!a.off&&this.attributes["data-cke-processor"]=="off"&&b.push("off",true);!a.nonEditable&&this.attributes.contenteditable==
"false"?b.push("nonEditable",true):a.nonEditable&&(!a.nestedEditable&&this.attributes.contenteditable=="true")&&b.push("nestedEditable",true);if(b.length)for(var a=CKEDITOR.tools.copy(a),d=0;d<b.length;d=d+2)a[b[d]]=b[d+1];return a}},true)})();
(function(){var a={},d=/{([^}]+)}/g,b=/([\\'])/g,c=/\n/g,e=/\r/g;CKEDITOR.template=function(f){if(a[f])this.output=a[f];else{var h=f.replace(b,"\\$1").replace(c,"\\n").replace(e,"\\r").replace(d,function(a,b){return"',data['"+b+"']==undefined?'{"+b+"}':data['"+b+"'],'"});this.output=a[f]=Function("data","buffer","return buffer?buffer.push('"+h+"'):['"+h+"'].join('');")}}})();delete CKEDITOR.loadFullCore;CKEDITOR.instances={};CKEDITOR.document=new CKEDITOR.dom.document(document);
CKEDITOR.add=function(a){CKEDITOR.instances[a.name]=a;a.on("focus",function(){if(CKEDITOR.currentInstance!=a){CKEDITOR.currentInstance=a;CKEDITOR.fire("currentInstance")}});a.on("blur",function(){if(CKEDITOR.currentInstance==a){CKEDITOR.currentInstance=null;CKEDITOR.fire("currentInstance")}});CKEDITOR.fire("instance",null,a)};CKEDITOR.remove=function(a){delete CKEDITOR.instances[a.name]};
(function(){var a={};CKEDITOR.addTemplate=function(d,b){var c=a[d];if(c)return c;c={name:d,source:b};CKEDITOR.fire("template",c);return a[d]=new CKEDITOR.template(c.source)};CKEDITOR.getTemplate=function(d){return a[d]}})();(function(){var a=[];CKEDITOR.addCss=function(d){a.push(d)};CKEDITOR.getCss=function(){return a.join("\n")}})();CKEDITOR.on("instanceDestroyed",function(){CKEDITOR.tools.isEmpty(this.instances)&&CKEDITOR.fire("reset")});CKEDITOR.TRISTATE_ON=1;CKEDITOR.TRISTATE_OFF=2;
CKEDITOR.TRISTATE_DISABLED=0;
(function(){CKEDITOR.inline=function(a,d){if(!CKEDITOR.env.isCompatible)return null;a=CKEDITOR.dom.element.get(a);if(a.getEditor())throw'The editor instance "'+a.getEditor().name+'" is already attached to the provided element.';var b=new CKEDITOR.editor(d,a,CKEDITOR.ELEMENT_MODE_INLINE),c=a.is("textarea")?a:null;if(c){b.setData(c.getValue(),null,true);a=CKEDITOR.dom.element.createFromHtml('<div contenteditable="'+!!b.readOnly+'" class="cke_textarea_inline">'+c.getValue()+"</div>",CKEDITOR.document);
a.insertAfter(c);c.hide();c.$.form&&b._attachToForm()}else b.setData(a.getHtml(),null,true);b.on("loaded",function(){b.fire("uiReady");b.editable(a);b.container=a;b.ui.contentsElement=a;b.setData(b.getData(1));b.resetDirty();b.fire("contentDom");b.mode="wysiwyg";b.fire("mode");b.status="ready";b.fireOnce("instanceReady");CKEDITOR.fire("instanceReady",null,b)},null,null,1E4);b.on("destroy",function(){if(c){b.container.clearCustomData();b.container.remove();c.show()}b.element.clearCustomData();delete b.element});
return b};CKEDITOR.inlineAll=function(){var a,d,b;for(b in CKEDITOR.dtd.$editable)for(var c=CKEDITOR.document.getElementsByTag(b),e=0,f=c.count();e<f;e++){a=c.getItem(e);if(a.getAttribute("contenteditable")=="true"){d={element:a,config:{}};CKEDITOR.fire("inline",d)!==false&&CKEDITOR.inline(a,d.config)}}};CKEDITOR.domReady(function(){!CKEDITOR.disableAutoInline&&CKEDITOR.inlineAll()})})();CKEDITOR.replaceClass="ckeditor";
(function(){function a(a,e,f,h){if(!CKEDITOR.env.isCompatible)return null;a=CKEDITOR.dom.element.get(a);if(a.getEditor())throw'The editor instance "'+a.getEditor().name+'" is already attached to the provided element.';var i=new CKEDITOR.editor(e,a,h);if(h==CKEDITOR.ELEMENT_MODE_REPLACE){a.setStyle("visibility","hidden");i._.required=a.hasAttribute("required");a.removeAttribute("required")}f&&i.setData(f,null,true);i.on("loaded",function(){b(i);h==CKEDITOR.ELEMENT_MODE_REPLACE&&(i.config.autoUpdateElement&&
a.$.form)&&i._attachToForm();i.setMode(i.config.startupMode,function(){i.resetDirty();i.status="ready";i.fireOnce("instanceReady");CKEDITOR.fire("instanceReady",null,i)})});i.on("destroy",d);return i}function d(){var a=this.container,b=this.element;if(a){a.clearCustomData();a.remove()}if(b){b.clearCustomData();if(this.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE){b.show();this._.required&&b.setAttribute("required","required")}delete this.element}}function b(a){var b=a.name,d=a.element,h=a.elementMode,
i=a.fire("uiSpace",{space:"top",html:""}).html,j=a.fire("uiSpace",{space:"bottom",html:""}).html,n=new CKEDITOR.template('<{outerEl} id="cke_{name}" class="{id} cke cke_reset cke_chrome cke_editor_{name} cke_{langDir} '+CKEDITOR.env.cssClass+'"  dir="{langDir}" lang="{langCode}" role="application"'+(a.title?' aria-labelledby="cke_{name}_arialbl"':"")+">"+(a.title?'<span id="cke_{name}_arialbl" class="cke_voice_label">{voiceLabel}</span>':"")+'<{outerEl} class="cke_inner cke_reset" role="presentation">{topHtml}<{outerEl} id="{contentId}" class="cke_contents cke_reset" role="presentation"></{outerEl}>{bottomHtml}</{outerEl}></{outerEl}>'),
b=CKEDITOR.dom.element.createFromHtml(n.output({id:a.id,name:b,langDir:a.lang.dir,langCode:a.langCode,voiceLabel:a.title,topHtml:i?'<span id="'+a.ui.spaceId("top")+'" class="cke_top cke_reset_all" role="presentation" style="height:auto">'+i+"</span>":"",contentId:a.ui.spaceId("contents"),bottomHtml:j?'<span id="'+a.ui.spaceId("bottom")+'" class="cke_bottom cke_reset_all" role="presentation">'+j+"</span>":"",outerEl:CKEDITOR.env.ie?"span":"div"}));if(h==CKEDITOR.ELEMENT_MODE_REPLACE){d.hide();b.insertAfter(d)}else d.append(b);
a.container=b;a.ui.contentsElement=a.ui.space("contents");i&&a.ui.space("top").unselectable();j&&a.ui.space("bottom").unselectable();d=a.config.width;h=a.config.height;d&&b.setStyle("width",CKEDITOR.tools.cssLength(d));h&&a.ui.space("contents").setStyle("height",CKEDITOR.tools.cssLength(h));b.disableContextMenu();CKEDITOR.env.webkit&&b.on("focus",function(){a.focus()});a.fireOnce("uiReady")}CKEDITOR.replace=function(b,d){return a(b,d,null,CKEDITOR.ELEMENT_MODE_REPLACE)};CKEDITOR.appendTo=function(b,
d,f){return a(b,d,f,CKEDITOR.ELEMENT_MODE_APPENDTO)};CKEDITOR.replaceAll=function(){for(var a=document.getElementsByTagName("textarea"),b=0;b<a.length;b++){var d=null,h=a[b];if(h.name||h.id){if(typeof arguments[0]=="string"){if(!RegExp("(?:^|\\s)"+arguments[0]+"(?:$|\\s)").test(h.className))continue}else if(typeof arguments[0]=="function"){d={};if(arguments[0](h,d)===false)continue}this.replace(h,d)}}};CKEDITOR.editor.prototype.addMode=function(a,b){(this._.modes||(this._.modes={}))[a]=b};CKEDITOR.editor.prototype.setMode=
function(a,b){var d=this,h=this._.modes;if(!(a==d.mode||!h||!h[a])){d.fire("beforeSetMode",a);if(d.mode){var i=d.checkDirty(),h=d._.previousModeData,j,n=0;d.fire("beforeModeUnload");d.editable(0);d._.previousMode=d.mode;d._.previousModeData=j=d.getData(1);if(d.mode=="source"&&h==j){d.fire("lockSnapshot",{forceUpdate:true});n=1}d.ui.space("contents").setHtml("");d.mode=""}else d._.previousModeData=d.getData(1);this._.modes[a](function(){d.mode=a;i!==void 0&&!i&&d.resetDirty();n?d.fire("unlockSnapshot"):
a=="wysiwyg"&&d.fire("saveSnapshot");setTimeout(function(){d.fire("mode");b&&b.call(d)},0)})}};CKEDITOR.editor.prototype.resize=function(a,b,d,h){var i=this.container,j=this.ui.space("contents"),n=CKEDITOR.env.webkit&&this.document&&this.document.getWindow().$.frameElement,h=h?this.container.getFirst(function(a){return a.type==CKEDITOR.NODE_ELEMENT&&a.hasClass("cke_inner")}):i;h.setSize("width",a,true);n&&(n.style.width="1%");var g=(h.$.offsetHeight||0)-(j.$.clientHeight||0),i=Math.max(b-(d?0:g),
0),b=d?b+g:b;j.setStyle("height",i+"px");n&&(n.style.width="100%");this.fire("resize",{outerHeight:b,contentsHeight:i,outerWidth:a||h.getSize("width")})};CKEDITOR.editor.prototype.getResizable=function(a){return a?this.ui.space("contents"):this.container};CKEDITOR.domReady(function(){CKEDITOR.replaceClass&&CKEDITOR.replaceAll(CKEDITOR.replaceClass)})})();CKEDITOR.config.startupMode="wysiwyg";
(function(){var a,d,b,c;function e(a){var b=a.editor,c=a.data.path,d=c.blockLimit,e=a.data.selection,h=e.getRanges()[0],l;if(CKEDITOR.env.gecko||CKEDITOR.env.ie&&CKEDITOR.env.needsBrFiller)if(e=f(e,c)){e.appendBogus();l=CKEDITOR.env.ie}if(g(b,c.block,d)&&h.collapsed&&!h.getCommonAncestor().isReadOnly()){c=h.clone();c.enlarge(CKEDITOR.ENLARGE_BLOCK_CONTENTS);d=new CKEDITOR.dom.walker(c);d.guard=function(a){return!i(a)||a.type==CKEDITOR.NODE_COMMENT||a.isReadOnly()};if(!d.checkForward()||c.checkStartOfBlock()&&
c.checkEndOfBlock()){b=h.fixBlock(true,b.activeEnterMode==CKEDITOR.ENTER_DIV?"div":"p");if(!CKEDITOR.env.needsBrFiller)(b=b.getFirst(i))&&(b.type==CKEDITOR.NODE_TEXT&&CKEDITOR.tools.trim(b.getText()).match(/^(?:&nbsp;|\xa0)$/))&&b.remove();l=1;a.cancel()}}l&&h.select()}function f(a,b){if(a.isFake)return 0;var c=b.block||b.blockLimit,d=c&&c.getLast(i);if(c&&c.isBlockBoundary()&&(!d||!(d.type==CKEDITOR.NODE_ELEMENT&&d.isBlockBoundary()))&&!c.is("pre")&&!c.getBogus())return c}function h(a){var b=a.data.getTarget();
if(b.is("input")){b=b.getAttribute("type");(b=="submit"||b=="reset")&&a.data.preventDefault()}}function i(a){return o(a)&&q(a)}function j(a,b){return function(c){var d=c.data.$.toElement||c.data.$.fromElement||c.data.$.relatedTarget,d=d&&d.nodeType==CKEDITOR.NODE_ELEMENT?new CKEDITOR.dom.element(d):null;(!d||!b.equals(d)&&!b.contains(d))&&a.call(this,c)}}function n(a){function b(a){return function(b,d){d&&(b.type==CKEDITOR.NODE_ELEMENT&&b.is(e))&&(c=b);if(!d&&i(b)&&(!a||!w(b)))return false}}var c,
d=a.getRanges()[0],a=a.root,e={table:1,ul:1,ol:1,dl:1};if(d.startPath().contains(e)){var g=d.clone();g.collapse(1);g.setStartAt(a,CKEDITOR.POSITION_AFTER_START);a=new CKEDITOR.dom.walker(g);a.guard=b();a.checkBackward();if(c){g=d.clone();g.collapse();g.setEndAt(c,CKEDITOR.POSITION_AFTER_END);a=new CKEDITOR.dom.walker(g);a.guard=b(true);c=false;a.checkForward();return c}}return null}function g(a,b,c){return a.config.autoParagraph!==false&&a.activeEnterMode!=CKEDITOR.ENTER_BR&&(a.editable().equals(c)&&
!b||b&&b.getAttribute("contenteditable")=="true")}function A(a){return a.activeEnterMode!=CKEDITOR.ENTER_BR&&a.config.autoParagraph!==false?a.activeEnterMode==CKEDITOR.ENTER_DIV?"div":"p":false}function r(a){var b=a.editor;b.getSelection().scrollIntoView();setTimeout(function(){b.fire("saveSnapshot")},0)}function y(a,b,c){for(var d=a.getCommonAncestor(b),b=a=c?b:a;(a=a.getParent())&&!d.equals(a)&&a.getChildCount()==1;)b=a;b.remove()}CKEDITOR.editable=CKEDITOR.tools.createClass({base:CKEDITOR.dom.element,
$:function(a,b){this.base(b.$||b);this.editor=a;this.status="unloaded";this.hasFocus=false;this.setup()},proto:{focus:function(){var a;if(CKEDITOR.env.webkit&&!this.hasFocus){a=this.editor._.previousActive||this.getDocument().getActive();if(this.contains(a)){a.focus();return}}try{this.$[CKEDITOR.env.ie&&this.getDocument().equals(CKEDITOR.document)?"setActive":"focus"]()}catch(b){if(!CKEDITOR.env.ie)throw b;}if(CKEDITOR.env.safari&&!this.isInline()){a=CKEDITOR.document.getActive();a.equals(this.getWindow().getFrame())||
this.getWindow().focus()}},on:function(a,b){var c=Array.prototype.slice.call(arguments,0);if(CKEDITOR.env.ie&&/^focus|blur$/.exec(a)){a=a=="focus"?"focusin":"focusout";b=j(b,this);c[0]=a;c[1]=b}return CKEDITOR.dom.element.prototype.on.apply(this,c)},attachListener:function(a){!this._.listeners&&(this._.listeners=[]);var b=Array.prototype.slice.call(arguments,1),b=a.on.apply(a,b);this._.listeners.push(b);return b},clearListeners:function(){var a=this._.listeners;try{for(;a.length;)a.pop().removeListener()}catch(b){}},
restoreAttrs:function(){var a=this._.attrChanges,b,c;for(c in a)if(a.hasOwnProperty(c)){b=a[c];b!==null?this.setAttribute(c,b):this.removeAttribute(c)}},attachClass:function(a){var b=this.getCustomData("classes");if(!this.hasClass(a)){!b&&(b=[]);b.push(a);this.setCustomData("classes",b);this.addClass(a)}},changeAttr:function(a,b){var c=this.getAttribute(a);if(b!==c){!this._.attrChanges&&(this._.attrChanges={});a in this._.attrChanges||(this._.attrChanges[a]=c);this.setAttribute(a,b)}},insertText:function(a){this.editor.focus();
this.insertHtml(this.transformPlainTextToHtml(a),"text")},transformPlainTextToHtml:function(a){var b=this.editor.getSelection().getStartElement().hasAscendant("pre",true)?CKEDITOR.ENTER_BR:this.editor.activeEnterMode;return CKEDITOR.tools.transformPlainTextToHtml(a,b)},insertHtml:function(a,b,c){var d=this.editor;d.focus();d.fire("saveSnapshot");c||(c=d.getSelection().getRanges()[0]);B(this,b||"html",a,c);c.select();r(this);this.editor.fire("afterInsertHtml",{})},insertHtmlIntoRange:function(a,b,
c){B(this,c||"html",a,b);this.editor.fire("afterInsertHtml",{intoRange:b})},insertElement:function(a,b){var c=this.editor;c.focus();c.fire("saveSnapshot");var d=c.activeEnterMode,c=c.getSelection(),e=a.getName(),e=CKEDITOR.dtd.$block[e];b||(b=c.getRanges()[0]);if(this.insertElementIntoRange(a,b)){b.moveToPosition(a,CKEDITOR.POSITION_AFTER_END);if(e)if((e=a.getNext(function(a){return i(a)&&!w(a)}))&&e.type==CKEDITOR.NODE_ELEMENT&&e.is(CKEDITOR.dtd.$block))e.getDtd()["#"]?b.moveToElementEditStart(e):
b.moveToElementEditEnd(a);else if(!e&&d!=CKEDITOR.ENTER_BR){e=b.fixBlock(true,d==CKEDITOR.ENTER_DIV?"div":"p");b.moveToElementEditStart(e)}}c.selectRanges([b]);r(this)},insertElementIntoSelection:function(a){this.insertElement(a)},insertElementIntoRange:function(a,b){var c=this.editor,d=c.config.enterMode,e=a.getName(),g=CKEDITOR.dtd.$block[e];if(b.checkReadOnly())return false;b.deleteContents(1);b.startContainer.type==CKEDITOR.NODE_ELEMENT&&b.startContainer.is({tr:1,table:1,tbody:1,thead:1,tfoot:1})&&
l(b);var f,h;if(g)for(;(f=b.getCommonAncestor(0,1))&&(h=CKEDITOR.dtd[f.getName()])&&(!h||!h[e]);)if(f.getName()in CKEDITOR.dtd.span)b.splitElement(f);else if(b.checkStartOfBlock()&&b.checkEndOfBlock()){b.setStartBefore(f);b.collapse(true);f.remove()}else b.splitBlock(d==CKEDITOR.ENTER_DIV?"div":"p",c.editable());b.insertNode(a);return true},setData:function(a,b){b||(a=this.editor.dataProcessor.toHtml(a));this.setHtml(a);this.fixInitialSelection();if(this.status=="unloaded")this.status="ready";this.editor.fire("dataReady")},
getData:function(a){var b=this.getHtml();a||(b=this.editor.dataProcessor.toDataFormat(b));return b},setReadOnly:function(a){this.setAttribute("contenteditable",!a)},detach:function(){this.removeClass("cke_editable");this.status="detached";var a=this.editor;this._.detach();delete a.document;delete a.window},isInline:function(){return this.getDocument().equals(CKEDITOR.document)},fixInitialSelection:function(){function a(){var b=c.getDocument().$,d=b.getSelection(),e;if(d.anchorNode&&d.anchorNode==
c.$)e=true;else if(CKEDITOR.env.webkit){var k=c.getDocument().getActive();k&&(k.equals(c)&&!d.anchorNode)&&(e=true)}if(e){e=new CKEDITOR.dom.range(c);e.moveToElementEditStart(c);b=b.createRange();b.setStart(e.startContainer.$,e.startOffset);b.collapse(true);d.removeAllRanges();d.addRange(b)}}function b(){var a=c.getDocument().$,d=a.selection,e=c.getDocument().getActive();if(d.type=="None"&&e.equals(c)){d=new CKEDITOR.dom.range(c);a=a.body.createTextRange();d.moveToElementEditStart(c);d=d.startContainer;
d.type!=CKEDITOR.NODE_ELEMENT&&(d=d.getParent());a.moveToElementText(d.$);a.collapse(true);a.select()}}var c=this;if(CKEDITOR.env.ie&&(CKEDITOR.env.version<9||CKEDITOR.env.quirks)){if(this.hasFocus){this.focus();b()}}else if(this.hasFocus){this.focus();a()}else this.once("focus",function(){a()},null,null,-999)},getHtmlFromRange:function(e){if(e.collapsed)return new CKEDITOR.dom.documentFragment(e.document);e={doc:this.getDocument(),range:e.clone()};a.detect(e,this);d.exclude(e);b.shrink(e);e.fragment=
e.range.cloneContents();c.rebuild(e,this);a.fix(e,this);return new CKEDITOR.dom.documentFragment(e.fragment.$)},extractHtmlFromRange:function(a,b){var c=s,d={range:a,doc:a.document},e=this.getHtmlFromRange(a);if(a.collapsed){a.optimize();return e}a.enlarge(CKEDITOR.ENLARGE_INLINE,1);c.table.detectPurge(d);d.bookmark=a.createBookmark();delete d.range;var g=this.editor.createRange();g.moveToPosition(d.bookmark.startNode,CKEDITOR.POSITION_BEFORE_START);d.targetBookmark=g.createBookmark();c.list.detectMerge(d,
this);c.table.detectRanges(d,this);c.block.detectMerge(d,this);if(d.tableContentsRanges){c.table.deleteRanges(d);a.moveToBookmark(d.bookmark);d.range=a}else{a.moveToBookmark(d.bookmark);d.range=a;a.extractContents(c.detectExtractMerge(d))}a.moveToBookmark(d.targetBookmark);a.optimize();c.fixUneditableRangePosition(a);c.list.merge(d,this);c.table.purge(d,this);c.block.merge(d,this);if(b){c=a.startPath();if(d=a.checkStartOfBlock())if(d=a.checkEndOfBlock())if(d=c.block)if(d=!a.root.equals(c.block)){a:{var d=
c.block.getElementsByTag("span"),g=0,f;if(d)for(;f=d.getItem(g++);)if(!q(f)){d=true;break a}d=false}d=!d}if(d){a.moveToPosition(c.block,CKEDITOR.POSITION_BEFORE_START);c.block.remove()}}else{c.autoParagraph(this.editor,a);t(a.startContainer)&&a.startContainer.appendBogus()}a.startContainer.mergeSiblings();return e},setup:function(){var a=this.editor;this.attachListener(a,"beforeGetData",function(){var b=this.getData();this.is("textarea")||a.config.ignoreEmptyParagraph!==false&&(b=b.replace(v,function(a,
b){return b}));a.setData(b,null,1)},this);this.attachListener(a,"getSnapshot",function(a){a.data=this.getData(1)},this);this.attachListener(a,"afterSetData",function(){this.setData(a.getData(1))},this);this.attachListener(a,"loadSnapshot",function(a){this.setData(a.data,1)},this);this.attachListener(a,"beforeFocus",function(){var b=a.getSelection();(b=b&&b.getNative())&&b.type=="Control"||this.focus()},this);this.attachListener(a,"insertHtml",function(a){this.insertHtml(a.data.dataValue,a.data.mode,
a.data.range)},this);this.attachListener(a,"insertElement",function(a){this.insertElement(a.data)},this);this.attachListener(a,"insertText",function(a){this.insertText(a.data)},this);this.setReadOnly(a.readOnly);this.attachClass("cke_editable");a.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?this.attachClass("cke_editable_inline"):(a.elementMode==CKEDITOR.ELEMENT_MODE_REPLACE||a.elementMode==CKEDITOR.ELEMENT_MODE_APPENDTO)&&this.attachClass("cke_editable_themed");this.attachClass("cke_contents_"+a.config.contentsLangDirection);
a.keystrokeHandler.blockedKeystrokes[8]=+a.readOnly;a.keystrokeHandler.attach(this);this.on("blur",function(){this.hasFocus=false},null,null,-1);this.on("focus",function(){this.hasFocus=true},null,null,-1);a.focusManager.add(this);if(this.equals(CKEDITOR.document.getActive())){this.hasFocus=true;a.once("contentDom",function(){a.focusManager.focus(this)},this)}this.isInline()&&this.changeAttr("tabindex",a.tabIndex);if(!this.is("textarea")){a.document=this.getDocument();a.window=this.getWindow();var b=
a.document;this.changeAttr("spellcheck",!a.config.disableNativeSpellChecker);var c=a.config.contentsLangDirection;this.getDirection(1)!=c&&this.changeAttr("dir",c);var d=CKEDITOR.getCss();if(d){c=b.getHead();if(!c.getCustomData("stylesheet")){d=b.appendStyleText(d);d=new CKEDITOR.dom.element(d.ownerNode||d.owningElement);c.setCustomData("stylesheet",d);d.data("cke-temp",1)}}c=b.getCustomData("stylesheet_ref")||0;b.setCustomData("stylesheet_ref",c+1);this.setCustomData("cke_includeReadonly",!a.config.disableReadonlyStyling);
this.attachListener(this,"click",function(a){var a=a.data,b=(new CKEDITOR.dom.elementPath(a.getTarget(),this)).contains("a");b&&(a.$.button!=2&&b.isReadOnly())&&a.preventDefault()});var e={8:1,46:1};this.attachListener(a,"key",function(b){if(a.readOnly)return true;var c=b.data.domEvent.getKey(),d;if(c in e){var b=a.getSelection(),g,f=b.getRanges()[0],h=f.startPath(),m,p,l,c=c==8;if(CKEDITOR.env.ie&&CKEDITOR.env.version<11&&(g=b.getSelectedElement())||(g=n(b))){a.fire("saveSnapshot");f.moveToPosition(g,
CKEDITOR.POSITION_BEFORE_START);g.remove();f.select();a.fire("saveSnapshot");d=1}else if(f.collapsed)if((m=h.block)&&(l=m[c?"getPrevious":"getNext"](o))&&l.type==CKEDITOR.NODE_ELEMENT&&l.is("table")&&f[c?"checkStartOfBlock":"checkEndOfBlock"]()){a.fire("saveSnapshot");f[c?"checkEndOfBlock":"checkStartOfBlock"]()&&m.remove();f["moveToElementEdit"+(c?"End":"Start")](l);f.select();a.fire("saveSnapshot");d=1}else if(h.blockLimit&&h.blockLimit.is("td")&&(p=h.blockLimit.getAscendant("table"))&&f.checkBoundaryOfElement(p,
c?CKEDITOR.START:CKEDITOR.END)&&(l=p[c?"getPrevious":"getNext"](o))){a.fire("saveSnapshot");f["moveToElementEdit"+(c?"End":"Start")](l);f.checkStartOfBlock()&&f.checkEndOfBlock()?l.remove():f.select();a.fire("saveSnapshot");d=1}else if((p=h.contains(["td","th","caption"]))&&f.checkBoundaryOfElement(p,c?CKEDITOR.START:CKEDITOR.END))d=1}return!d});a.blockless&&(CKEDITOR.env.ie&&CKEDITOR.env.needsBrFiller)&&this.attachListener(this,"keyup",function(b){if(b.data.getKeystroke()in e&&!this.getFirst(i)){this.appendBogus();
b=a.createRange();b.moveToPosition(this,CKEDITOR.POSITION_AFTER_START);b.select()}});this.attachListener(this,"dblclick",function(b){if(a.readOnly)return false;b={element:b.data.getTarget()};a.fire("doubleclick",b)});CKEDITOR.env.ie&&this.attachListener(this,"click",h);(!CKEDITOR.env.ie||CKEDITOR.env.edge)&&this.attachListener(this,"mousedown",function(b){var c=b.data.getTarget();if(c.is("img","hr","input","textarea","select")&&!c.isReadOnly()){a.getSelection().selectElement(c);c.is("input","textarea",
"select")&&b.data.preventDefault()}});CKEDITOR.env.edge&&this.attachListener(this,"mouseup",function(b){(b=b.data.getTarget())&&b.is("img")&&a.getSelection().selectElement(b)});CKEDITOR.env.gecko&&this.attachListener(this,"mouseup",function(b){if(b.data.$.button==2){b=b.data.getTarget();if(!b.getOuterHtml().replace(v,"")){var c=a.createRange();c.moveToElementEditStart(b);c.select(true)}}});if(CKEDITOR.env.webkit){this.attachListener(this,"click",function(a){a.data.getTarget().is("input","select")&&
a.data.preventDefault()});this.attachListener(this,"mouseup",function(a){a.data.getTarget().is("input","textarea")&&a.data.preventDefault()})}CKEDITOR.env.webkit&&this.attachListener(a,"key",function(b){if(a.readOnly)return true;b=b.data.domEvent.getKey();if(b in e){var c=b==8,d=a.getSelection().getRanges()[0],b=d.startPath();if(d.collapsed){var g;a:{var f=b.block;if(f)if(d[c?"checkStartOfBlock":"checkEndOfBlock"]())if(!d.moveToClosestEditablePosition(f,!c)||!d.collapsed)g=false;else{if(d.startContainer.type==
CKEDITOR.NODE_ELEMENT){var h=d.startContainer.getChild(d.startOffset-(c?1:0));if(h&&h.type==CKEDITOR.NODE_ELEMENT&&h.is("hr")){a.fire("saveSnapshot");h.remove();g=true;break a}}if((d=d.startPath().block)&&(!d||!d.contains(f))){a.fire("saveSnapshot");var m;(m=(c?d:f).getBogus())&&m.remove();g=a.getSelection();m=g.createBookmarks();(c?f:d).moveChildren(c?d:f,false);b.lastElement.mergeSiblings();y(f,d,!c);g.selectBookmarks(m);g=true}}else g=false;else g=false}if(!g)return}else{c=d;g=b.block;m=c.endPath().block;
if(!g||!m||g.equals(m))b=false;else{a.fire("saveSnapshot");(f=g.getBogus())&&f.remove();c.enlarge(CKEDITOR.ENLARGE_INLINE);c.deleteContents();if(m.getParent()){m.moveChildren(g,false);b.lastElement.mergeSiblings();y(g,m,true)}c=a.getSelection().getRanges()[0];c.collapse(1);c.optimize();c.startContainer.getHtml()===""&&c.startContainer.appendBogus();c.select();b=true}if(!b)return}a.getSelection().scrollIntoView();a.fire("saveSnapshot");return false}},this,null,100)}}},_:{detach:function(){this.editor.setData(this.editor.getData(),
0,1);this.clearListeners();this.restoreAttrs();var a;if(a=this.removeCustomData("classes"))for(;a.length;)this.removeClass(a.pop());if(!this.is("textarea")){a=this.getDocument();var b=a.getHead();if(b.getCustomData("stylesheet")){var c=a.getCustomData("stylesheet_ref");if(--c)a.setCustomData("stylesheet_ref",c);else{a.removeCustomData("stylesheet_ref");b.removeCustomData("stylesheet").remove()}}}this.editor.fire("contentDomUnload");delete this.editor}}});CKEDITOR.editor.prototype.editable=function(a){var b=
this._.editable;if(b&&a)return 0;if(arguments.length)b=this._.editable=a?a instanceof CKEDITOR.editable?a:new CKEDITOR.editable(this,a):(b&&b.detach(),null);return b};CKEDITOR.on("instanceLoaded",function(a){var b=a.editor;b.on("insertElement",function(a){a=a.data;if(a.type==CKEDITOR.NODE_ELEMENT&&(a.is("input")||a.is("textarea"))){a.getAttribute("contentEditable")!="false"&&a.data("cke-editable",a.hasAttribute("contenteditable")?"true":"1");a.setAttribute("contentEditable",false)}});b.on("selectionChange",
function(a){if(!b.readOnly){var c=b.getSelection();if(c&&!c.isLocked){c=b.checkDirty();b.fire("lockSnapshot");e(a);b.fire("unlockSnapshot");!c&&b.resetDirty()}}})});CKEDITOR.on("instanceCreated",function(a){var b=a.editor;b.on("mode",function(){var a=b.editable();if(a&&a.isInline()){var c=b.title;a.changeAttr("role","textbox");a.changeAttr("aria-label",c);c&&a.changeAttr("title",c);var d=b.fire("ariaEditorHelpLabel",{}).label;if(d)if(c=this.ui.space(this.elementMode==CKEDITOR.ELEMENT_MODE_INLINE?
"top":"contents")){var e=CKEDITOR.tools.getNextId(),d=CKEDITOR.dom.element.createFromHtml('<span id="'+e+'" class="cke_voice_label">'+d+"</span>");c.append(d);a.changeAttr("aria-describedby",e)}}})});CKEDITOR.addCss(".cke_editable{cursor:text}.cke_editable img,.cke_editable input,.cke_editable textarea{cursor:default}");var o=CKEDITOR.dom.walker.whitespaces(true),q=CKEDITOR.dom.walker.bookmark(false,true),t=CKEDITOR.dom.walker.empty(),w=CKEDITOR.dom.walker.bogus(),v=/(^|<body\b[^>]*>)\s*<(p|div|address|h\d|center|pre)[^>]*>\s*(?:<br[^>]*>|&nbsp;|\u00A0|&#160;)?\s*(:?<\/\2>)?\s*(?=$|<\/body>)/gi,
B=function(){function a(b){return b.type==CKEDITOR.NODE_ELEMENT}function b(c,d){var e,g,f,u,l=[],p=d.range.startContainer;e=d.range.startPath();for(var p=h[p.getName()],i=0,j=c.getChildren(),s=j.count(),z=-1,K=-1,I=0,F=e.contains(h.$list);i<s;++i){e=j.getItem(i);if(a(e)){f=e.getName();if(F&&f in CKEDITOR.dtd.$list)l=l.concat(b(e,d));else{u=!!p[f];if(f=="br"&&e.data("cke-eol")&&(!i||i==s-1)){I=(g=i?l[i-1].node:j.getItem(i+1))&&(!a(g)||!g.is("br"));g=g&&a(g)&&h.$block[g.getName()]}z==-1&&!u&&(z=i);
u||(K=i);l.push({isElement:1,isLineBreak:I,isBlock:e.isBlockBoundary(),hasBlockSibling:g,node:e,name:f,allowed:u});g=I=0}}else l.push({isElement:0,node:e,allowed:1})}if(z>-1)l[z].firstNotAllowed=1;if(K>-1)l[K].lastNotAllowed=1;return l}function c(b,d){var e=[],g=b.getChildren(),f=g.count(),u,l=0,m=h[d],p=!b.is(h.$inline)||b.is("br");for(p&&e.push(" ");l<f;l++){u=g.getItem(l);a(u)&&!u.is(m)?e=e.concat(c(u,d)):e.push(u)}p&&e.push(" ");return e}function d(b){return b&&a(b)&&(b.is(h.$removeEmpty)||b.is("a")&&
!b.isBlockBoundary())}function e(b,c,d,g){var f=b.clone(),h,u;f.setEndAt(c,CKEDITOR.POSITION_BEFORE_END);if((h=(new CKEDITOR.dom.walker(f)).next())&&a(h)&&l[h.getName()]&&(u=h.getPrevious())&&a(u)&&!u.getParent().equals(b.startContainer)&&d.contains(u)&&g.contains(h)&&h.isIdentical(u)){h.moveChildren(u);h.remove();e(b,c,d,g)}}function f(b,c){function d(b,c){if(c.isBlock&&c.isElement&&!c.node.is("br")&&a(b)&&b.is("br")){b.remove();return 1}}var e=c.endContainer.getChild(c.endOffset),g=c.endContainer.getChild(c.endOffset-
1);e&&d(e,b[b.length-1]);if(g&&d(g,b[0])){c.setEnd(c.endContainer,c.endOffset-1);c.collapse()}}var h=CKEDITOR.dtd,l={p:1,div:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,ul:1,ol:1,li:1,pre:1,dl:1,blockquote:1},u={p:1,div:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1},j=CKEDITOR.tools.extend({},h.$inline);delete j.br;return function(l,x,s,G){var n=l.editor,o=false;if(x=="unfiltered_html"){x="html";o=true}if(!G.checkReadOnly()){var E=(new CKEDITOR.dom.elementPath(G.startContainer,G.root)).blockLimit||G.root,l={type:x,dontFilter:o,
editable:l,editor:n,range:G,blockLimit:E,mergeCandidates:[],zombies:[]},x=l.range,G=l.mergeCandidates,r,q;if(l.type=="text"&&x.shrink(CKEDITOR.SHRINK_ELEMENT,true,false)){r=CKEDITOR.dom.element.createFromHtml("<span>&nbsp;</span>",x.document);x.insertNode(r);x.setStartAfter(r)}o=new CKEDITOR.dom.elementPath(x.startContainer);l.endPath=E=new CKEDITOR.dom.elementPath(x.endContainer);if(!x.collapsed){var n=E.block||E.blockLimit,y=x.getCommonAncestor();n&&(!n.equals(y)&&!n.contains(y)&&x.checkEndOfBlock())&&
l.zombies.push(n);x.deleteContents()}for(;(q=a(x.startContainer)&&x.startContainer.getChild(x.startOffset-1))&&a(q)&&q.isBlockBoundary()&&o.contains(q);)x.moveToPosition(q,CKEDITOR.POSITION_BEFORE_END);e(x,l.blockLimit,o,E);if(r){x.setEndBefore(r);x.collapse();r.remove()}r=x.startPath();if(n=r.contains(d,false,1)){x.splitElement(n);l.inlineStylesRoot=n;l.inlineStylesPeak=r.lastElement}r=x.createBookmark();(n=r.startNode.getPrevious(i))&&a(n)&&d(n)&&G.push(n);(n=r.startNode.getNext(i))&&a(n)&&d(n)&&
G.push(n);for(n=r.startNode;(n=n.getParent())&&d(n);)G.push(n);x.moveToBookmark(r);if(r=s){r=l.range;if(l.type=="text"&&l.inlineStylesRoot){q=l.inlineStylesPeak;x=q.getDocument().createText("{cke-peak}");for(G=l.inlineStylesRoot.getParent();!q.equals(G);){x=x.appendTo(q.clone());q=q.getParent()}s=x.getOuterHtml().split("{cke-peak}").join(s)}q=l.blockLimit.getName();if(/^\s+|\s+$/.test(s)&&"span"in CKEDITOR.dtd[q])var v='<span data-cke-marker="1">&nbsp;</span>',s=v+s+v;s=l.editor.dataProcessor.toHtml(s,
{context:null,fixForBody:false,protectedWhitespaces:!!v,dontFilter:l.dontFilter,filter:l.editor.activeFilter,enterMode:l.editor.activeEnterMode});q=r.document.createElement("body");q.setHtml(s);if(v){q.getFirst().remove();q.getLast().remove()}if((v=r.startPath().block)&&!(v.getChildCount()==1&&v.getBogus()))a:{var t;if(q.getChildCount()==1&&a(t=q.getFirst())&&t.is(u)&&!t.hasAttribute("contenteditable")){v=t.getElementsByTag("*");r=0;for(G=v.count();r<G;r++){x=v.getItem(r);if(!x.is(j))break a}t.moveChildren(t.getParent(1));
t.remove()}}l.dataWrapper=q;r=s}if(r){t=l.range;r=t.document;var H;q=l.blockLimit;var G=0,J,v=[],w,B,s=n=0,O,V,x=t.startContainer,o=l.endPath.elements[0],W,E=o.getPosition(x),y=!!o.getCommonAncestor(x)&&E!=CKEDITOR.POSITION_IDENTICAL&&!(E&CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_IS_CONTAINED),x=b(l.dataWrapper,l);for(f(x,t);G<x.length;G++){E=x[G];if(H=E.isLineBreak){H=t;O=q;var Q=void 0,S=void 0;if(E.hasBlockSibling)H=1;else{Q=H.startContainer.getAscendant(h.$block,1);if(!Q||!Q.is({div:1,p:1}))H=
0;else{S=Q.getPosition(O);if(S==CKEDITOR.POSITION_IDENTICAL||S==CKEDITOR.POSITION_CONTAINS)H=0;else{O=H.splitElement(Q);H.moveToPosition(O,CKEDITOR.POSITION_AFTER_START);H=1}}}}if(H)s=G>0;else{H=t.startPath();if(!E.isBlock&&g(l.editor,H.block,H.blockLimit)&&(B=A(l.editor))){B=r.createElement(B);B.appendBogus();t.insertNode(B);CKEDITOR.env.needsBrFiller&&(J=B.getBogus())&&J.remove();t.moveToPosition(B,CKEDITOR.POSITION_BEFORE_END)}if((H=t.startPath().block)&&!H.equals(w)){if(J=H.getBogus()){J.remove();
v.push(H)}w=H}E.firstNotAllowed&&(n=1);if(n&&E.isElement){H=t.startContainer;for(O=null;H&&!h[H.getName()][E.name];){if(H.equals(q)){H=null;break}O=H;H=H.getParent()}if(H){if(O){V=t.splitElement(O);l.zombies.push(V);l.zombies.push(O)}}else{O=q.getName();W=!G;H=G==x.length-1;O=c(E.node,O);for(var Q=[],S=O.length,R=0,P=void 0,X=0,$=-1;R<S;R++){P=O[R];if(P==" "){if(!X&&(!W||R)){Q.push(new CKEDITOR.dom.text(" "));$=Q.length}X=1}else{Q.push(P);X=0}}H&&$==Q.length&&Q.pop();W=Q}}if(W){for(;H=W.pop();)t.insertNode(H);
W=0}else t.insertNode(E.node);if(E.lastNotAllowed&&G<x.length-1){(V=y?o:V)&&t.setEndAt(V,CKEDITOR.POSITION_AFTER_START);n=0}t.collapse()}}if(x.length!=1)J=false;else{J=x[0];J=J.isElement&&J.node.getAttribute("contenteditable")=="false"}if(J){s=true;H=x[0].node;t.setStartAt(H,CKEDITOR.POSITION_BEFORE_START);t.setEndAt(H,CKEDITOR.POSITION_AFTER_END)}l.dontMoveCaret=s;l.bogusNeededBlocks=v}J=l.range;var Y;V=l.bogusNeededBlocks;for(W=J.createBookmark();w=l.zombies.pop();)if(w.getParent()){B=J.clone();
B.moveToElementEditStart(w);B.removeEmptyBlocksAtEnd()}if(V)for(;w=V.pop();)CKEDITOR.env.needsBrFiller?w.appendBogus():w.append(J.document.createText(" "));for(;w=l.mergeCandidates.pop();)w.mergeSiblings();J.moveToBookmark(W);if(!l.dontMoveCaret){for(w=a(J.startContainer)&&J.startContainer.getChild(J.startOffset-1);w&&a(w)&&!w.is(h.$empty);){if(w.isBlockBoundary())J.moveToPosition(w,CKEDITOR.POSITION_BEFORE_END);else{if(d(w)&&w.getHtml().match(/(\s|&nbsp;)$/g)){Y=null;break}Y=J.clone();Y.moveToPosition(w,
CKEDITOR.POSITION_BEFORE_END)}w=w.getLast(i)}Y&&J.moveToRange(Y)}}}}(),l=function(){function a(b){b=new CKEDITOR.dom.walker(b);b.guard=function(a,b){if(b)return false;if(a.type==CKEDITOR.NODE_ELEMENT)return a.is(CKEDITOR.dtd.$tableContent)};b.evaluator=function(a){return a.type==CKEDITOR.NODE_ELEMENT};return b}function b(a,c,d){c=a.getDocument().createElement(c);a.append(c,d);return c}function c(a){var b=a.count(),d;for(b;b-- >0;){d=a.getItem(b);if(!CKEDITOR.tools.trim(d.getHtml())){d.appendBogus();
CKEDITOR.env.ie&&(CKEDITOR.env.version<9&&d.getChildCount())&&d.getFirst().remove()}}}return function(d){var e=d.startContainer,g=e.getAscendant("table",1),f=false;c(g.getElementsByTag("td"));c(g.getElementsByTag("th"));g=d.clone();g.setStart(e,0);g=a(g).lastBackward();if(!g){g=d.clone();g.setEndAt(e,CKEDITOR.POSITION_BEFORE_END);g=a(g).lastForward();f=true}g||(g=e);if(g.is("table")){d.setStartAt(g,CKEDITOR.POSITION_BEFORE_START);d.collapse(true);g.remove()}else{g.is({tbody:1,thead:1,tfoot:1})&&(g=
b(g,"tr",f));g.is("tr")&&(g=b(g,g.getParent().is("thead")?"th":"td",f));(e=g.getBogus())&&e.remove();d.moveToPosition(g,f?CKEDITOR.POSITION_AFTER_START:CKEDITOR.POSITION_BEFORE_END)}}}();a={detect:function(a,b){var c=a.range,d=c.clone(),e=c.clone(),g=new CKEDITOR.dom.elementPath(c.startContainer,b),f=new CKEDITOR.dom.elementPath(c.endContainer,b);d.collapse(1);e.collapse();if(g.block&&d.checkBoundaryOfElement(g.block,CKEDITOR.END)){c.setStartAfter(g.block);a.prependEolBr=1}if(f.block&&e.checkBoundaryOfElement(f.block,
CKEDITOR.START)){c.setEndBefore(f.block);a.appendEolBr=1}},fix:function(a,b){var c=b.getDocument(),d;if(a.appendEolBr){d=this.createEolBr(c);a.fragment.append(d)}a.prependEolBr&&(!d||d.getPrevious())&&a.fragment.append(this.createEolBr(c),1)},createEolBr:function(a){return a.createElement("br",{attributes:{"data-cke-eol":1}})}};d={exclude:function(a){var b=a.range.getBoundaryNodes(),c=b.startNode;(b=b.endNode)&&(w(b)&&(!c||!c.equals(b)))&&a.range.setEndBefore(b)}};c={rebuild:function(a,b){var c=a.range,
d=c.getCommonAncestor(),e=new CKEDITOR.dom.elementPath(d,b),g=new CKEDITOR.dom.elementPath(c.startContainer,b),c=new CKEDITOR.dom.elementPath(c.endContainer,b),f;d.type==CKEDITOR.NODE_TEXT&&(d=d.getParent());if(e.blockLimit.is({tr:1,table:1})){var h=e.contains("table").getParent();f=function(a){return!a.equals(h)}}else if(e.block&&e.block.is(CKEDITOR.dtd.$listItem)){g=g.contains(CKEDITOR.dtd.$list);c=c.contains(CKEDITOR.dtd.$list);if(!g.equals(c)){var l=e.contains(CKEDITOR.dtd.$list).getParent();
f=function(a){return!a.equals(l)}}}f||(f=function(a){return!a.equals(e.block)&&!a.equals(e.blockLimit)});this.rebuildFragment(a,b,d,f)},rebuildFragment:function(a,b,c,d){for(var e;c&&!c.equals(b)&&d(c);){e=c.clone(0,1);a.fragment.appendTo(e);a.fragment=e;c=c.getParent()}}};b={shrink:function(a){var a=a.range,b=a.startContainer,c=a.endContainer,d=a.startOffset,e=a.endOffset;b.type==CKEDITOR.NODE_ELEMENT&&(b.equals(c)&&b.is("tr")&&++d==e)&&a.shrink(CKEDITOR.SHRINK_TEXT)}};var s=function(){function a(b,
c){var d=b.getParent();if(d.is(CKEDITOR.dtd.$inline))b[c?"insertBefore":"insertAfter"](d)}function b(c,d,e){a(d);a(e,1);for(var g;g=e.getNext();){g.insertAfter(d);d=g}t(c)&&c.remove()}function c(a,b){var d=new CKEDITOR.dom.range(a);d.setStartAfter(b.startNode);d.setEndBefore(b.endNode);return d}return{list:{detectMerge:function(a,b){var d=c(b,a.bookmark),e=d.startPath(),g=d.endPath(),f=e.contains(CKEDITOR.dtd.$list),h=g.contains(CKEDITOR.dtd.$list);a.mergeList=f&&h&&f.getParent().equals(h.getParent())&&
!f.equals(h);a.mergeListItems=e.block&&g.block&&e.block.is(CKEDITOR.dtd.$listItem)&&g.block.is(CKEDITOR.dtd.$listItem);if(a.mergeList||a.mergeListItems){d=d.clone();d.setStartBefore(a.bookmark.startNode);d.setEndAfter(a.bookmark.endNode);a.mergeListBookmark=d.createBookmark()}},merge:function(a,c){if(a.mergeListBookmark){var d=a.mergeListBookmark.startNode,e=a.mergeListBookmark.endNode,g=new CKEDITOR.dom.elementPath(d,c),f=new CKEDITOR.dom.elementPath(e,c);if(a.mergeList){var h=g.contains(CKEDITOR.dtd.$list),
k=f.contains(CKEDITOR.dtd.$list);if(!h.equals(k)){k.moveChildren(h);k.remove()}}if(a.mergeListItems){g=g.contains(CKEDITOR.dtd.$listItem);f=f.contains(CKEDITOR.dtd.$listItem);g.equals(f)||b(f,d,e)}d.remove();e.remove()}}},block:{detectMerge:function(a,b){if(!a.tableContentsRanges&&!a.mergeListBookmark){var c=new CKEDITOR.dom.range(b);c.setStartBefore(a.bookmark.startNode);c.setEndAfter(a.bookmark.endNode);a.mergeBlockBookmark=c.createBookmark()}},merge:function(a,c){if(a.mergeBlockBookmark&&!a.purgeTableBookmark){var d=
a.mergeBlockBookmark.startNode,e=a.mergeBlockBookmark.endNode,g=new CKEDITOR.dom.elementPath(d,c),f=new CKEDITOR.dom.elementPath(e,c),g=g.block,f=f.block;g&&(f&&!g.equals(f))&&b(f,d,e);d.remove();e.remove()}}},table:function(){function a(c){var e=[],g,f=new CKEDITOR.dom.walker(c),h=c.startPath().contains(d),k=c.endPath().contains(d),l={};f.guard=function(a,f){if(a.type==CKEDITOR.NODE_ELEMENT){var m="visited_"+(f?"out":"in");if(a.getCustomData(m))return;CKEDITOR.dom.element.setMarker(l,a,m,1)}if(f&&
h&&a.equals(h)){g=c.clone();g.setEndAt(h,CKEDITOR.POSITION_BEFORE_END);e.push(g)}else if(!f&&k&&a.equals(k)){g=c.clone();g.setStartAt(k,CKEDITOR.POSITION_AFTER_START);e.push(g)}else if(!f&&a.type==CKEDITOR.NODE_ELEMENT&&a.is(d)&&(!h||b(a,h))&&(!k||b(a,k))){g=c.clone();g.selectNodeContents(a);e.push(g)}};f.lastForward();CKEDITOR.dom.element.clearAllMarkers(l);return e}function b(a,c){var d=CKEDITOR.POSITION_CONTAINS+CKEDITOR.POSITION_IS_CONTAINED,e=a.getPosition(c);return e===CKEDITOR.POSITION_IDENTICAL?
false:(e&d)===0}var d={td:1,th:1,caption:1};return{detectPurge:function(a){var b=a.range,c=b.clone();c.enlarge(CKEDITOR.ENLARGE_ELEMENT);var c=new CKEDITOR.dom.walker(c),e=0;c.evaluator=function(a){a.type==CKEDITOR.NODE_ELEMENT&&a.is(d)&&++e};c.checkForward();if(e>1){var c=b.startPath().contains("table"),g=b.endPath().contains("table");if(c&&g&&b.checkBoundaryOfElement(c,CKEDITOR.START)&&b.checkBoundaryOfElement(g,CKEDITOR.END)){b=a.range.clone();b.setStartBefore(c);b.setEndAfter(g);a.purgeTableBookmark=
b.createBookmark()}}},detectRanges:function(e,g){var f=c(g,e.bookmark),h=f.clone(),k,l,m=f.getCommonAncestor();m.is(CKEDITOR.dtd.$tableContent)&&!m.is(d)&&(m=m.getAscendant("table",true));l=m;m=new CKEDITOR.dom.elementPath(f.startContainer,l);l=new CKEDITOR.dom.elementPath(f.endContainer,l);m=m.contains("table");l=l.contains("table");if(m||l){if(m&&l&&b(m,l)){e.tableSurroundingRange=h;h.setStartAt(m,CKEDITOR.POSITION_AFTER_END);h.setEndAt(l,CKEDITOR.POSITION_BEFORE_START);h=f.clone();h.setEndAt(m,
CKEDITOR.POSITION_AFTER_END);k=f.clone();k.setStartAt(l,CKEDITOR.POSITION_BEFORE_START);k=a(h).concat(a(k))}else if(m){if(!l){e.tableSurroundingRange=h;h.setStartAt(m,CKEDITOR.POSITION_AFTER_END);f.setEndAt(m,CKEDITOR.POSITION_AFTER_END)}}else{e.tableSurroundingRange=h;h.setEndAt(l,CKEDITOR.POSITION_BEFORE_START);f.setStartAt(l,CKEDITOR.POSITION_AFTER_START)}e.tableContentsRanges=k?k:a(f)}},deleteRanges:function(a){for(var b;b=a.tableContentsRanges.pop();){b.extractContents();t(b.startContainer)&&
b.startContainer.appendBogus()}a.tableSurroundingRange&&a.tableSurroundingRange.extractContents()},purge:function(a){if(a.purgeTableBookmark){var b=a.doc,c=a.range.clone(),b=b.createElement("p");b.insertBefore(a.purgeTableBookmark.startNode);c.moveToBookmark(a.purgeTableBookmark);c.deleteContents();a.range.moveToPosition(b,CKEDITOR.POSITION_AFTER_START)}}}}(),detectExtractMerge:function(a){return!(a.range.startPath().contains(CKEDITOR.dtd.$listItem)&&a.range.endPath().contains(CKEDITOR.dtd.$listItem))},
fixUneditableRangePosition:function(a){a.startContainer.getDtd()["#"]||a.moveToClosestEditablePosition(null,true)},autoParagraph:function(a,b){var c=b.startPath(),d;if(g(a,c.block,c.blockLimit)&&(d=A(a))){d=b.document.createElement(d);d.appendBogus();b.insertNode(d);b.moveToPosition(d,CKEDITOR.POSITION_AFTER_START)}}}}()})();
(function(){function a(){var a=this._.fakeSelection,b;if(a){b=this.getSelection(1);if(!b||!b.isHidden()){a.reset();a=0}}if(!a){a=b||this.getSelection(1);if(!a||a.getType()==CKEDITOR.SELECTION_NONE)return}this.fire("selectionCheck",a);b=this.elementPath();if(!b.compare(this._.selectionPreviousPath)){if(CKEDITOR.env.webkit)this._.previousActive=this.document.getActive();this._.selectionPreviousPath=b;this.fire("selectionChange",{selection:a,path:b})}}function d(){o=true;if(!y){b.call(this);y=CKEDITOR.tools.setTimeout(b,
200,this)}}function b(){y=null;if(o){CKEDITOR.tools.setTimeout(a,0,this);o=false}}function c(a){return q(a)||a.type==CKEDITOR.NODE_ELEMENT&&!a.is(CKEDITOR.dtd.$empty)?true:false}function e(a){function b(c,d){return!c||c.type==CKEDITOR.NODE_TEXT?false:a.clone()["moveToElementEdit"+(d?"End":"Start")](c)}if(!(a.root instanceof CKEDITOR.editable))return false;var d=a.startContainer,e=a.getPreviousNode(c,null,d),g=a.getNextNode(c,null,d);return b(e)||b(g,1)||!e&&!g&&!(d.type==CKEDITOR.NODE_ELEMENT&&d.isBlockBoundary()&&
d.getBogus())?true:false}function f(a){return a.getCustomData("cke-fillingChar")}function h(a,b){var c=a&&a.removeCustomData("cke-fillingChar");if(c){if(b!==false){var d,e=a.getDocument().getSelection().getNative(),g=e&&e.type!="None"&&e.getRangeAt(0);if(c.getLength()>1&&g&&g.intersectsNode(c.$)){d=j(e);g=e.focusNode==c.$&&e.focusOffset>0;e.anchorNode==c.$&&e.anchorOffset>0&&d[0].offset--;g&&d[1].offset--}}c.setText(i(c.getText()));d&&n(a.getDocument().$,d)}}function i(a){return a.replace(/\u200B( )?/g,
function(a){return a[1]?" ":""})}function j(a){return[{node:a.anchorNode,offset:a.anchorOffset},{node:a.focusNode,offset:a.focusOffset}]}function n(a,b){var c=a.getSelection(),d=a.createRange();d.setStart(b[0].node,b[0].offset);d.collapse(true);c.removeAllRanges();c.addRange(d);c.extend(b[1].node,b[1].offset)}function g(a){var b=CKEDITOR.dom.element.createFromHtml('<div data-cke-hidden-sel="1" data-cke-temp="1" style="'+(CKEDITOR.env.ie?"display:none":"position:fixed;top:0;left:-1000px")+'">&nbsp;</div>',
a.document);a.fire("lockSnapshot");a.editable().append(b);var c=a.getSelection(1),d=a.createRange(),e=c.root.on("selectionchange",function(a){a.cancel()},null,null,0);d.setStartAt(b,CKEDITOR.POSITION_AFTER_START);d.setEndAt(b,CKEDITOR.POSITION_BEFORE_END);c.selectRanges([d]);e.removeListener();a.fire("unlockSnapshot");a._.hiddenSelectionContainer=b}function A(a){var b={37:1,39:1,8:1,46:1};return function(c){var d=c.data.getKeystroke();if(b[d]){var e=a.getSelection().getRanges(),g=e[0];if(e.length==
1&&g.collapsed)if((d=g[d<38?"getPreviousEditableNode":"getNextEditableNode"]())&&d.type==CKEDITOR.NODE_ELEMENT&&d.getAttribute("contenteditable")=="false"){a.getSelection().fake(d);c.data.preventDefault();c.cancel()}}}}function r(a){for(var b=0;b<a.length;b++){var c=a[b];c.getCommonAncestor().isReadOnly()&&a.splice(b,1);if(!c.collapsed){if(c.startContainer.isReadOnly())for(var d=c.startContainer,e;d;){if((e=d.type==CKEDITOR.NODE_ELEMENT)&&d.is("body")||!d.isReadOnly())break;e&&d.getAttribute("contentEditable")==
"false"&&c.setStartAfter(d);d=d.getParent()}d=c.startContainer;e=c.endContainer;var g=c.startOffset,f=c.endOffset,h=c.clone();d&&d.type==CKEDITOR.NODE_TEXT&&(g>=d.getLength()?h.setStartAfter(d):h.setStartBefore(d));e&&e.type==CKEDITOR.NODE_TEXT&&(f?h.setEndAfter(e):h.setEndBefore(e));d=new CKEDITOR.dom.walker(h);d.evaluator=function(d){if(d.type==CKEDITOR.NODE_ELEMENT&&d.isReadOnly()){var e=c.clone();c.setEndBefore(d);c.collapsed&&a.splice(b--,1);if(!(d.getPosition(h.endContainer)&CKEDITOR.POSITION_CONTAINS)){e.setStartAfter(d);
e.collapsed||a.splice(b+1,0,e)}return true}return false};d.next()}}return a}var y,o,q=CKEDITOR.dom.walker.invisible(1),t=function(){function a(b){return function(a){var c=a.editor.createRange();c.moveToClosestEditablePosition(a.selected,b)&&a.editor.getSelection().selectRanges([c]);return false}}function b(a){return function(b){var c=b.editor,d=c.createRange(),e;if(!(e=d.moveToClosestEditablePosition(b.selected,a)))e=d.moveToClosestEditablePosition(b.selected,!a);e&&c.getSelection().selectRanges([d]);
c.fire("saveSnapshot");b.selected.remove();if(!e){d.moveToElementEditablePosition(c.editable());c.getSelection().selectRanges([d])}c.fire("saveSnapshot");return false}}var c=a(),d=a(1);return{37:c,38:c,39:d,40:d,8:b(),46:b(1)}}();CKEDITOR.on("instanceCreated",function(b){function c(){var a=e.getSelection();a&&a.removeAllRanges()}var e=b.editor;e.on("contentDom",function(){function b(){C=new CKEDITOR.dom.selection(e.getSelection());C.lock()}function c(){f.removeListener("mouseup",c);j.removeListener("mouseup",
c);var a=CKEDITOR.document.$.selection,b=a.createRange();a.type!="None"&&b.parentElement().ownerDocument==g.$&&b.select()}var g=e.document,f=CKEDITOR.document,l=e.editable(),i=g.getBody(),j=g.getDocumentElement(),u=l.isInline(),s,C;CKEDITOR.env.gecko&&l.attachListener(l,"focus",function(a){a.removeListener();if(s!==0)if((a=e.getSelection().getNative())&&a.isCollapsed&&a.anchorNode==l.$){a=e.createRange();a.moveToElementEditStart(l);a.select()}},null,null,-2);l.attachListener(l,CKEDITOR.env.webkit?
"DOMFocusIn":"focus",function(){s&&CKEDITOR.env.webkit&&(s=e._.previousActive&&e._.previousActive.equals(g.getActive()));e.unlockSelection(s);s=0},null,null,-1);l.attachListener(l,"mousedown",function(){s=0});if(CKEDITOR.env.ie||u){w?l.attachListener(l,"beforedeactivate",b,null,null,-1):l.attachListener(e,"selectionCheck",b,null,null,-1);l.attachListener(l,CKEDITOR.env.webkit?"DOMFocusOut":"blur",function(){e.lockSelection(C);s=1},null,null,-1);l.attachListener(l,"mousedown",function(){s=0})}if(CKEDITOR.env.ie&&
!u){var x;l.attachListener(l,"mousedown",function(a){if(a.data.$.button==2){a=e.document.getSelection();if(!a||a.getType()==CKEDITOR.SELECTION_NONE)x=e.window.getScrollPosition()}});l.attachListener(l,"mouseup",function(a){if(a.data.$.button==2&&x){e.document.$.documentElement.scrollLeft=x.x;e.document.$.documentElement.scrollTop=x.y}x=null});if(g.$.compatMode!="BackCompat"){if(CKEDITOR.env.ie7Compat||CKEDITOR.env.ie6Compat)j.on("mousedown",function(a){function b(a){a=a.data.$;if(d){var c=i.$.createTextRange();
try{c.moveToPoint(a.clientX,a.clientY)}catch(e){}d.setEndPoint(g.compareEndPoints("StartToStart",c)<0?"EndToEnd":"StartToStart",c);d.select()}}function c(){j.removeListener("mousemove",b);f.removeListener("mouseup",c);j.removeListener("mouseup",c);d.select()}a=a.data;if(a.getTarget().is("html")&&a.$.y<j.$.clientHeight&&a.$.x<j.$.clientWidth){var d=i.$.createTextRange();try{d.moveToPoint(a.$.clientX,a.$.clientY)}catch(e){}var g=d.duplicate();j.on("mousemove",b);f.on("mouseup",c);j.on("mouseup",c)}});
if(CKEDITOR.env.version>7&&CKEDITOR.env.version<11)j.on("mousedown",function(a){if(a.data.getTarget().is("html")){f.on("mouseup",c);j.on("mouseup",c)}})}}l.attachListener(l,"selectionchange",a,e);l.attachListener(l,"keyup",d,e);l.attachListener(l,CKEDITOR.env.webkit?"DOMFocusIn":"focus",function(){e.forceNextSelectionCheck();e.selectionChange(1)});if(u&&(CKEDITOR.env.webkit||CKEDITOR.env.gecko)){var n;l.attachListener(l,"mousedown",function(){n=1});l.attachListener(g.getDocumentElement(),"mouseup",
function(){n&&d.call(e);n=0})}else l.attachListener(CKEDITOR.env.ie?l:g.getDocumentElement(),"mouseup",d,e);CKEDITOR.env.webkit&&l.attachListener(g,"keydown",function(a){switch(a.data.getKey()){case 13:case 33:case 34:case 35:case 36:case 37:case 39:case 8:case 45:case 46:h(l)}},null,null,-1);l.attachListener(l,"keydown",A(e),null,null,-1)});e.on("setData",function(){e.unlockSelection();CKEDITOR.env.webkit&&c()});e.on("contentDomUnload",function(){e.unlockSelection()});if(CKEDITOR.env.ie9Compat)e.on("beforeDestroy",
c,null,null,9);e.on("dataReady",function(){delete e._.fakeSelection;delete e._.hiddenSelectionContainer;e.selectionChange(1)});e.on("loadSnapshot",function(){var a=CKEDITOR.dom.walker.nodeType(CKEDITOR.NODE_ELEMENT),b=e.editable().getLast(a);if(b&&b.hasAttribute("data-cke-hidden-sel")){b.remove();if(CKEDITOR.env.gecko)(a=e.editable().getFirst(a))&&(a.is("br")&&a.getAttribute("_moz_editor_bogus_node"))&&a.remove()}},null,null,100);e.on("key",function(a){if(e.mode=="wysiwyg"){var b=e.getSelection();
if(b.isFake){var c=t[a.data.keyCode];if(c)return c({editor:e,selected:b.getSelectedElement(),selection:b,keyEvent:a})}}})});CKEDITOR.on("instanceReady",function(a){function b(){var a=d.editable();if(a)if(a=f(a)){var c=d.document.$.getSelection();if(c.type!="None"&&(c.anchorNode==a.$||c.focusNode==a.$))g=j(c);e=a.getText();a.setText(i(e))}}function c(){var a=d.editable();if(a)if(a=f(a)){a.setText(e);if(g){n(d.document.$,g);g=null}}}var d=a.editor,e,g;if(CKEDITOR.env.webkit){d.on("selectionChange",
function(){var a=d.editable(),b=f(a);b&&(b.getCustomData("ready")?h(a):b.setCustomData("ready",1))},null,null,-1);d.on("beforeSetMode",function(){h(d.editable())},null,null,-1);d.on("beforeUndoImage",b);d.on("afterUndoImage",c);d.on("beforeGetData",b,null,null,0);d.on("getData",c)}});CKEDITOR.editor.prototype.selectionChange=function(b){(b?a:d).call(this)};CKEDITOR.editor.prototype.getSelection=function(a){if((this._.savedSelection||this._.fakeSelection)&&!a)return this._.savedSelection||this._.fakeSelection;
return(a=this.editable())&&this.mode=="wysiwyg"?new CKEDITOR.dom.selection(a):null};CKEDITOR.editor.prototype.lockSelection=function(a){a=a||this.getSelection(1);if(a.getType()!=CKEDITOR.SELECTION_NONE){!a.isLocked&&a.lock();this._.savedSelection=a;return true}return false};CKEDITOR.editor.prototype.unlockSelection=function(a){var b=this._.savedSelection;if(b){b.unlock(a);delete this._.savedSelection;return true}return false};CKEDITOR.editor.prototype.forceNextSelectionCheck=function(){delete this._.selectionPreviousPath};
CKEDITOR.dom.document.prototype.getSelection=function(){return new CKEDITOR.dom.selection(this)};CKEDITOR.dom.range.prototype.select=function(){var a=this.root instanceof CKEDITOR.editable?this.root.editor.getSelection():new CKEDITOR.dom.selection(this.root);a.selectRanges([this]);return a};CKEDITOR.SELECTION_NONE=1;CKEDITOR.SELECTION_TEXT=2;CKEDITOR.SELECTION_ELEMENT=3;var w=typeof window.getSelection!="function",v=1;CKEDITOR.dom.selection=function(a){if(a instanceof CKEDITOR.dom.selection)var b=
a,a=a.root;var c=a instanceof CKEDITOR.dom.element;this.rev=b?b.rev:v++;this.document=a instanceof CKEDITOR.dom.document?a:a.getDocument();this.root=c?a:this.document.getBody();this.isLocked=0;this._={cache:{}};if(b){CKEDITOR.tools.extend(this._.cache,b._.cache);this.isFake=b.isFake;this.isLocked=b.isLocked;return this}var a=this.getNative(),d,e;if(a)if(a.getRangeAt)d=(e=a.rangeCount&&a.getRangeAt(0))&&new CKEDITOR.dom.node(e.commonAncestorContainer);else{try{e=a.createRange()}catch(g){}d=e&&CKEDITOR.dom.element.get(e.item&&
e.item(0)||e.parentElement())}if(!d||!(d.type==CKEDITOR.NODE_ELEMENT||d.type==CKEDITOR.NODE_TEXT)||!this.root.equals(d)&&!this.root.contains(d)){this._.cache.type=CKEDITOR.SELECTION_NONE;this._.cache.startElement=null;this._.cache.selectedElement=null;this._.cache.selectedText="";this._.cache.ranges=new CKEDITOR.dom.rangeList}return this};var B={img:1,hr:1,li:1,table:1,tr:1,td:1,th:1,embed:1,object:1,ol:1,ul:1,a:1,input:1,form:1,select:1,textarea:1,button:1,fieldset:1,thead:1,tfoot:1};CKEDITOR.dom.selection.prototype=
{getNative:function(){return this._.cache.nativeSel!==void 0?this._.cache.nativeSel:this._.cache.nativeSel=w?this.document.$.selection:this.document.getWindow().$.getSelection()},getType:w?function(){var a=this._.cache;if(a.type)return a.type;var b=CKEDITOR.SELECTION_NONE;try{var c=this.getNative(),d=c.type;if(d=="Text")b=CKEDITOR.SELECTION_TEXT;if(d=="Control")b=CKEDITOR.SELECTION_ELEMENT;if(c.createRange().parentElement())b=CKEDITOR.SELECTION_TEXT}catch(e){}return a.type=b}:function(){var a=this._.cache;
if(a.type)return a.type;var b=CKEDITOR.SELECTION_TEXT,c=this.getNative();if(!c||!c.rangeCount)b=CKEDITOR.SELECTION_NONE;else if(c.rangeCount==1){var c=c.getRangeAt(0),d=c.startContainer;if(d==c.endContainer&&d.nodeType==1&&c.endOffset-c.startOffset==1&&B[d.childNodes[c.startOffset].nodeName.toLowerCase()])b=CKEDITOR.SELECTION_ELEMENT}return a.type=b},getRanges:function(){var a=w?function(){function a(b){return(new CKEDITOR.dom.node(b)).getIndex()}var b=function(b,c){b=b.duplicate();b.collapse(c);
var d=b.parentElement();if(!d.hasChildNodes())return{container:d,offset:0};for(var e=d.children,g,f,h=b.duplicate(),l=0,k=e.length-1,i=-1,j,n;l<=k;){i=Math.floor((l+k)/2);g=e[i];h.moveToElementText(g);j=h.compareEndPoints("StartToStart",b);if(j>0)k=i-1;else if(j<0)l=i+1;else return{container:d,offset:a(g)}}if(i==-1||i==e.length-1&&j<0){h.moveToElementText(d);h.setEndPoint("StartToStart",b);h=h.text.replace(/(\r\n|\r)/g,"\n").length;e=d.childNodes;if(!h){g=e[e.length-1];return g.nodeType!=CKEDITOR.NODE_TEXT?
{container:d,offset:e.length}:{container:g,offset:g.nodeValue.length}}for(d=e.length;h>0&&d>0;){f=e[--d];if(f.nodeType==CKEDITOR.NODE_TEXT){n=f;h=h-f.nodeValue.length}}return{container:n,offset:-h}}h.collapse(j>0?true:false);h.setEndPoint(j>0?"StartToStart":"EndToStart",b);h=h.text.replace(/(\r\n|\r)/g,"\n").length;if(!h)return{container:d,offset:a(g)+(j>0?0:1)};for(;h>0;)try{f=g[j>0?"previousSibling":"nextSibling"];if(f.nodeType==CKEDITOR.NODE_TEXT){h=h-f.nodeValue.length;n=f}g=f}catch(o){return{container:d,
offset:a(g)}}return{container:n,offset:j>0?-h:n.nodeValue.length+h}};return function(){var a=this.getNative(),c=a&&a.createRange(),d=this.getType();if(!a)return[];if(d==CKEDITOR.SELECTION_TEXT){a=new CKEDITOR.dom.range(this.root);d=b(c,true);a.setStart(new CKEDITOR.dom.node(d.container),d.offset);d=b(c);a.setEnd(new CKEDITOR.dom.node(d.container),d.offset);a.endContainer.getPosition(a.startContainer)&CKEDITOR.POSITION_PRECEDING&&a.endOffset<=a.startContainer.getIndex()&&a.collapse();return[a]}if(d==
CKEDITOR.SELECTION_ELEMENT){for(var d=[],e=0;e<c.length;e++){for(var g=c.item(e),f=g.parentNode,h=0,a=new CKEDITOR.dom.range(this.root);h<f.childNodes.length&&f.childNodes[h]!=g;h++);a.setStart(new CKEDITOR.dom.node(f),h);a.setEnd(new CKEDITOR.dom.node(f),h+1);d.push(a)}return d}return[]}}():function(){var a=[],b,c=this.getNative();if(!c)return a;for(var d=0;d<c.rangeCount;d++){var e=c.getRangeAt(d);b=new CKEDITOR.dom.range(this.root);b.setStart(new CKEDITOR.dom.node(e.startContainer),e.startOffset);
b.setEnd(new CKEDITOR.dom.node(e.endContainer),e.endOffset);a.push(b)}return a};return function(b){var c=this._.cache,d=c.ranges;if(!d)c.ranges=d=new CKEDITOR.dom.rangeList(a.call(this));return!b?d:r(new CKEDITOR.dom.rangeList(d.slice()))}}(),getStartElement:function(){var a=this._.cache;if(a.startElement!==void 0)return a.startElement;var b;switch(this.getType()){case CKEDITOR.SELECTION_ELEMENT:return this.getSelectedElement();case CKEDITOR.SELECTION_TEXT:var c=this.getRanges()[0];if(c){if(c.collapsed){b=
c.startContainer;b.type!=CKEDITOR.NODE_ELEMENT&&(b=b.getParent())}else{for(c.optimize();;){b=c.startContainer;if(c.startOffset==(b.getChildCount?b.getChildCount():b.getLength())&&!b.isBlockBoundary())c.setStartAfter(b);else break}b=c.startContainer;if(b.type!=CKEDITOR.NODE_ELEMENT)return b.getParent();b=b.getChild(c.startOffset);if(!b||b.type!=CKEDITOR.NODE_ELEMENT)b=c.startContainer;else for(c=b.getFirst();c&&c.type==CKEDITOR.NODE_ELEMENT;){b=c;c=c.getFirst()}}b=b.$}}return a.startElement=b?new CKEDITOR.dom.element(b):
null},getSelectedElement:function(){var a=this._.cache;if(a.selectedElement!==void 0)return a.selectedElement;var b=this,c=CKEDITOR.tools.tryThese(function(){return b.getNative().createRange().item(0)},function(){for(var a=b.getRanges()[0].clone(),c,d,e=2;e&&(!(c=a.getEnclosedNode())||!(c.type==CKEDITOR.NODE_ELEMENT&&B[c.getName()]&&(d=c)));e--)a.shrink(CKEDITOR.SHRINK_ELEMENT);return d&&d.$});return a.selectedElement=c?new CKEDITOR.dom.element(c):null},getSelectedText:function(){var a=this._.cache;
if(a.selectedText!==void 0)return a.selectedText;var b=this.getNative(),b=w?b.type=="Control"?"":b.createRange().text:b.toString();return a.selectedText=b},lock:function(){this.getRanges();this.getStartElement();this.getSelectedElement();this.getSelectedText();this._.cache.nativeSel=null;this.isLocked=1},unlock:function(a){if(this.isLocked){if(a)var b=this.getSelectedElement(),c=!b&&this.getRanges(),d=this.isFake;this.isLocked=0;this.reset();if(a)(a=b||c[0]&&c[0].getCommonAncestor())&&a.getAscendant("body",
1)&&(d?this.fake(b):b?this.selectElement(b):this.selectRanges(c))}},reset:function(){this._.cache={};this.isFake=0;var a=this.root.editor;if(a&&a._.fakeSelection&&this.rev==a._.fakeSelection.rev){delete a._.fakeSelection;var b=a._.hiddenSelectionContainer;if(b){var c=a.checkDirty();a.fire("lockSnapshot");b.remove();a.fire("unlockSnapshot");!c&&a.resetDirty()}delete a._.hiddenSelectionContainer}this.rev=v++},selectElement:function(a){var b=new CKEDITOR.dom.range(this.root);b.setStartBefore(a);b.setEndAfter(a);
this.selectRanges([b])},selectRanges:function(a){var b=this.root.editor,b=b&&b._.hiddenSelectionContainer;this.reset();if(b)for(var b=this.root,c,d=0;d<a.length;++d){c=a[d];if(c.endContainer.equals(b))c.endOffset=Math.min(c.endOffset,b.getChildCount())}if(a.length)if(this.isLocked){var g=CKEDITOR.document.getActive();this.unlock();this.selectRanges(a);this.lock();g&&!g.equals(this.root)&&g.focus()}else{var f;a:{var i,j;if(a.length==1&&!(j=a[0]).collapsed&&(f=j.getEnclosedNode())&&f.type==CKEDITOR.NODE_ELEMENT){j=
j.clone();j.shrink(CKEDITOR.SHRINK_ELEMENT,true);if((i=j.getEnclosedNode())&&i.type==CKEDITOR.NODE_ELEMENT)f=i;if(f.getAttribute("contenteditable")=="false")break a}f=void 0}if(f)this.fake(f);else{if(w){j=CKEDITOR.dom.walker.whitespaces(true);i=/\ufeff|\u00a0/;b={table:1,tbody:1,tr:1};if(a.length>1){f=a[a.length-1];a[0].setEnd(f.endContainer,f.endOffset)}f=a[0];var a=f.collapsed,n,o,u;if((c=f.getEnclosedNode())&&c.type==CKEDITOR.NODE_ELEMENT&&c.getName()in B&&(!c.is("a")||!c.getText()))try{u=c.$.createControlRange();
u.addElement(c.$);u.select();return}catch(K){}if(f.startContainer.type==CKEDITOR.NODE_ELEMENT&&f.startContainer.getName()in b||f.endContainer.type==CKEDITOR.NODE_ELEMENT&&f.endContainer.getName()in b){f.shrink(CKEDITOR.NODE_ELEMENT,true);a=f.collapsed}u=f.createBookmark();b=u.startNode;if(!a)g=u.endNode;u=f.document.$.body.createTextRange();u.moveToElementText(b.$);u.moveStart("character",1);if(g){i=f.document.$.body.createTextRange();i.moveToElementText(g.$);u.setEndPoint("EndToEnd",i);u.moveEnd("character",
-1)}else{n=b.getNext(j);o=b.hasAscendant("pre");n=!(n&&n.getText&&n.getText().match(i))&&(o||!b.hasPrevious()||b.getPrevious().is&&b.getPrevious().is("br"));o=f.document.createElement("span");o.setHtml("&#65279;");o.insertBefore(b);n&&f.document.createText("﻿").insertBefore(b)}f.setStartBefore(b);b.remove();if(a){if(n){u.moveStart("character",-1);u.select();f.document.$.selection.clear()}else u.select();f.moveToPosition(o,CKEDITOR.POSITION_BEFORE_START);o.remove()}else{f.setEndBefore(g);g.remove();
u.select()}}else{g=this.getNative();if(!g)return;this.removeAllRanges();for(u=0;u<a.length;u++){if(u<a.length-1){n=a[u];o=a[u+1];i=n.clone();i.setStart(n.endContainer,n.endOffset);i.setEnd(o.startContainer,o.startOffset);if(!i.collapsed){i.shrink(CKEDITOR.NODE_ELEMENT,true);f=i.getCommonAncestor();i=i.getEnclosedNode();if(f.isReadOnly()||i&&i.isReadOnly()){o.setStart(n.startContainer,n.startOffset);a.splice(u--,1);continue}}}f=a[u];o=this.document.$.createRange();if(f.collapsed&&CKEDITOR.env.webkit&&
e(f)){n=this.root;h(n,false);i=n.getDocument().createText("​");n.setCustomData("cke-fillingChar",i);f.insertNode(i);if((n=i.getNext())&&!i.getPrevious()&&n.type==CKEDITOR.NODE_ELEMENT&&n.getName()=="br"){h(this.root);f.moveToPosition(n,CKEDITOR.POSITION_BEFORE_START)}else f.moveToPosition(i,CKEDITOR.POSITION_AFTER_END)}o.setStart(f.startContainer.$,f.startOffset);try{o.setEnd(f.endContainer.$,f.endOffset)}catch(C){if(C.toString().indexOf("NS_ERROR_ILLEGAL_VALUE")>=0){f.collapse(1);o.setEnd(f.endContainer.$,
f.endOffset)}else throw C;}g.addRange(o)}}this.reset();this.root.fire("selectionchange")}}},fake:function(a){var b=this.root.editor;this.reset();g(b);var c=this._.cache,d=new CKEDITOR.dom.range(this.root);d.setStartBefore(a);d.setEndAfter(a);c.ranges=new CKEDITOR.dom.rangeList(d);c.selectedElement=c.startElement=a;c.type=CKEDITOR.SELECTION_ELEMENT;c.selectedText=c.nativeSel=null;this.isFake=1;this.rev=v++;b._.fakeSelection=this;this.root.fire("selectionchange")},isHidden:function(){var a=this.getCommonAncestor();
a&&a.type==CKEDITOR.NODE_TEXT&&(a=a.getParent());return!(!a||!a.data("cke-hidden-sel"))},createBookmarks:function(a){a=this.getRanges().createBookmarks(a);this.isFake&&(a.isFake=1);return a},createBookmarks2:function(a){a=this.getRanges().createBookmarks2(a);this.isFake&&(a.isFake=1);return a},selectBookmarks:function(a){for(var b=[],c,d=0;d<a.length;d++){var e=new CKEDITOR.dom.range(this.root);e.moveToBookmark(a[d]);b.push(e)}if(a.isFake){c=b[0].getEnclosedNode();if(!c||c.type!=CKEDITOR.NODE_ELEMENT)a.isFake=
0}a.isFake?this.fake(c):this.selectRanges(b);return this},getCommonAncestor:function(){var a=this.getRanges();return!a.length?null:a[0].startContainer.getCommonAncestor(a[a.length-1].endContainer)},scrollIntoView:function(){this.type!=CKEDITOR.SELECTION_NONE&&this.getRanges()[0].scrollIntoView()},removeAllRanges:function(){if(this.getType()!=CKEDITOR.SELECTION_NONE){var a=this.getNative();try{a&&a[w?"empty":"removeAllRanges"]()}catch(b){}this.reset()}}}})();"use strict";CKEDITOR.STYLE_BLOCK=1;
CKEDITOR.STYLE_INLINE=2;CKEDITOR.STYLE_OBJECT=3;
(function(){function a(a,b){for(var c,d;a=a.getParent();){if(a.equals(b))break;if(a.getAttribute("data-nostyle"))c=a;else if(!d){var e=a.getAttribute("contentEditable");e=="false"?c=a:e=="true"&&(d=1)}}return c}function d(b){var e=b.document;if(b.collapsed){e=t(this,e);b.insertNode(e);b.moveToPosition(e,CKEDITOR.POSITION_BEFORE_END)}else{var g=this.element,f=this._.definition,h,i=f.ignoreReadonly,j=i||f.includeReadonly;j==null&&(j=b.root.getCustomData("cke_includeReadonly"));var k=CKEDITOR.dtd[g];
if(!k){h=true;k=CKEDITOR.dtd.span}b.enlarge(CKEDITOR.ENLARGE_INLINE,1);b.trim();var l=b.createBookmark(),n=l.startNode,o=l.endNode,m=n,r;if(!i){var q=b.getCommonAncestor(),i=a(n,q),q=a(o,q);i&&(m=i.getNextSourceNode(true));q&&(o=q)}for(m.getPosition(o)==CKEDITOR.POSITION_FOLLOWING&&(m=0);m;){i=false;if(m.equals(o)){m=null;i=true}else{var p=m.type==CKEDITOR.NODE_ELEMENT?m.getName():null,q=p&&m.getAttribute("contentEditable")=="false",s=p&&m.getAttribute("data-nostyle");if(p&&m.data("cke-bookmark")){m=
m.getNextSourceNode(true);continue}if(q&&j&&CKEDITOR.dtd.$block[p])for(var v=m,A=c(v),w=void 0,z=A.length,B=0,v=z&&new CKEDITOR.dom.range(v.getDocument());B<z;++B){var w=A[B],F=CKEDITOR.filter.instances[w.data("cke-filter")];if(F?F.check(this):1){v.selectNodeContents(w);d.call(this,v)}}A=p?!k[p]||s?0:q&&!j?0:(m.getPosition(o)|L)==L&&(!f.childRule||f.childRule(m)):1;if(A)if((A=m.getParent())&&((A.getDtd()||CKEDITOR.dtd.span)[g]||h)&&(!f.parentRule||f.parentRule(A))){if(!r&&(!p||!CKEDITOR.dtd.$removeEmpty[p]||
(m.getPosition(o)|L)==L)){r=b.clone();r.setStartBefore(m)}p=m.type;if(p==CKEDITOR.NODE_TEXT||q||p==CKEDITOR.NODE_ELEMENT&&!m.getChildCount()){for(var p=m,S;(i=!p.getNext(I))&&(S=p.getParent(),k[S.getName()])&&(S.getPosition(n)|E)==E&&(!f.childRule||f.childRule(S));)p=S;r.setEndAfter(p)}}else i=true;else i=true;m=m.getNextSourceNode(s||q)}if(i&&r&&!r.collapsed){for(var i=t(this,e),q=i.hasAttributes(),s=r.getCommonAncestor(),p={},A={},w={},z={},R,P,X;i&&s;){if(s.getName()==g){for(R in f.attributes)if(!z[R]&&
(X=s.getAttribute(P)))i.getAttribute(R)==X?A[R]=1:z[R]=1;for(P in f.styles)if(!w[P]&&(X=s.getStyle(P)))i.getStyle(P)==X?p[P]=1:w[P]=1}s=s.getParent()}for(R in A)i.removeAttribute(R);for(P in p)i.removeStyle(P);q&&!i.hasAttributes()&&(i=null);if(i){r.extractContents().appendTo(i);r.insertNode(i);y.call(this,i);i.mergeSiblings();CKEDITOR.env.ie||i.$.normalize()}else{i=new CKEDITOR.dom.element("span");r.extractContents().appendTo(i);r.insertNode(i);y.call(this,i);i.remove(true)}r=null}}b.moveToBookmark(l);
b.shrink(CKEDITOR.SHRINK_TEXT);b.shrink(CKEDITOR.NODE_ELEMENT,true)}}function b(a){function b(){for(var a=new CKEDITOR.dom.elementPath(d.getParent()),c=new CKEDITOR.dom.elementPath(j.getParent()),e=null,g=null,f=0;f<a.elements.length;f++){var h=a.elements[f];if(h==a.block||h==a.blockLimit)break;k.checkElementRemovable(h,true)&&(e=h)}for(f=0;f<c.elements.length;f++){h=c.elements[f];if(h==c.block||h==c.blockLimit)break;k.checkElementRemovable(h,true)&&(g=h)}g&&j.breakParent(g);e&&d.breakParent(e)}a.enlarge(CKEDITOR.ENLARGE_INLINE,
1);var c=a.createBookmark(),d=c.startNode;if(a.collapsed){for(var e=new CKEDITOR.dom.elementPath(d.getParent(),a.root),g,f=0,h;f<e.elements.length&&(h=e.elements[f]);f++){if(h==e.block||h==e.blockLimit)break;if(this.checkElementRemovable(h)){var i;if(a.collapsed&&(a.checkBoundaryOfElement(h,CKEDITOR.END)||(i=a.checkBoundaryOfElement(h,CKEDITOR.START)))){g=h;g.match=i?"start":"end"}else{h.mergeSiblings();h.is(this.element)?r.call(this,h):o(h,B(this)[h.getName()])}}}if(g){h=d;for(f=0;;f++){i=e.elements[f];
if(i.equals(g))break;else if(i.match)continue;else i=i.clone();i.append(h);h=i}h[g.match=="start"?"insertBefore":"insertAfter"](g)}}else{var j=c.endNode,k=this;b();for(e=d;!e.equals(j);){g=e.getNextSourceNode();if(e.type==CKEDITOR.NODE_ELEMENT&&this.checkElementRemovable(e)){e.getName()==this.element?r.call(this,e):o(e,B(this)[e.getName()]);if(g.type==CKEDITOR.NODE_ELEMENT&&g.contains(d)){b();g=d.getNext()}}e=g}}a.moveToBookmark(c);a.shrink(CKEDITOR.NODE_ELEMENT,true)}function c(a){var b=[];a.forEach(function(a){if(a.getAttribute("contenteditable")==
"true"){b.push(a);return false}},CKEDITOR.NODE_ELEMENT,true);return b}function e(a){var b=a.getEnclosedNode()||a.getCommonAncestor(false,true);(a=(new CKEDITOR.dom.elementPath(b,a.root)).contains(this.element,1))&&!a.isReadOnly()&&w(a,this)}function f(a){var b=a.getCommonAncestor(true,true);if(a=(new CKEDITOR.dom.elementPath(b,a.root)).contains(this.element,1)){var b=this._.definition,c=b.attributes;if(c)for(var d in c)a.removeAttribute(d,c[d]);if(b.styles)for(var e in b.styles)b.styles.hasOwnProperty(e)&&
a.removeStyle(e)}}function h(a){var b=a.createBookmark(true),c=a.createIterator();c.enforceRealBlocks=true;if(this._.enterMode)c.enlargeBr=this._.enterMode!=CKEDITOR.ENTER_BR;for(var d,e=a.document,g;d=c.getNextParagraph();)if(!d.isReadOnly()&&(c.activeFilter?c.activeFilter.check(this):1)){g=t(this,e,d);j(d,g)}a.moveToBookmark(b)}function i(a){var b=a.createBookmark(1),c=a.createIterator();c.enforceRealBlocks=true;c.enlargeBr=this._.enterMode!=CKEDITOR.ENTER_BR;for(var d,e;d=c.getNextParagraph();)if(this.checkElementRemovable(d))if(d.is("pre")){(e=
this._.enterMode==CKEDITOR.ENTER_BR?null:a.document.createElement(this._.enterMode==CKEDITOR.ENTER_P?"p":"div"))&&d.copyAttributes(e);j(d,e)}else r.call(this,d);a.moveToBookmark(b)}function j(a,b){var c=!b;if(c){b=a.getDocument().createElement("div");a.copyAttributes(b)}var d=b&&b.is("pre"),e=a.is("pre"),f=!d&&e;if(d&&!e){e=b;(f=a.getBogus())&&f.remove();f=a.getHtml();f=g(f,/(?:^[ \t\n\r]+)|(?:[ \t\n\r]+$)/g,"");f=f.replace(/[ \t\r\n]*(<br[^>]*>)[ \t\r\n]*/gi,"$1");f=f.replace(/([ \t\n\r]+|&nbsp;)/g,
" ");f=f.replace(/<br\b[^>]*>/gi,"\n");if(CKEDITOR.env.ie){var h=a.getDocument().createElement("div");h.append(e);e.$.outerHTML="<pre>"+f+"</pre>";e.copyAttributes(h.getFirst());e=h.getFirst().remove()}else e.setHtml(f);b=e}else f?b=A(c?[a.getHtml()]:n(a),b):a.moveChildren(b);b.replace(a);if(d){var c=b,i;if((i=c.getPrevious(z))&&i.type==CKEDITOR.NODE_ELEMENT&&i.is("pre")){d=g(i.getHtml(),/\n$/,"")+"\n\n"+g(c.getHtml(),/^\n/,"");CKEDITOR.env.ie?c.$.outerHTML="<pre>"+d+"</pre>":c.setHtml(d);i.remove()}}else c&&
q(b)}function n(a){var b=[];g(a.getOuterHtml(),/(\S\s*)\n(?:\s|(<span[^>]+data-cke-bookmark.*?\/span>))*\n(?!$)/gi,function(a,b,c){return b+"</pre>"+c+"<pre>"}).replace(/<pre\b.*?>([\s\S]*?)<\/pre>/gi,function(a,c){b.push(c)});return b}function g(a,b,c){var d="",e="",a=a.replace(/(^<span[^>]+data-cke-bookmark.*?\/span>)|(<span[^>]+data-cke-bookmark.*?\/span>$)/gi,function(a,b,c){b&&(d=b);c&&(e=c);return""});return d+a.replace(b,c)+e}function A(a,b){var c;a.length>1&&(c=new CKEDITOR.dom.documentFragment(b.getDocument()));
for(var d=0;d<a.length;d++){var e=a[d],e=e.replace(/(\r\n|\r)/g,"\n"),e=g(e,/^[ \t]*\n/,""),e=g(e,/\n$/,""),e=g(e,/^[ \t]+|[ \t]+$/g,function(a,b){return a.length==1?"&nbsp;":b?" "+CKEDITOR.tools.repeat("&nbsp;",a.length-1):CKEDITOR.tools.repeat("&nbsp;",a.length-1)+" "}),e=e.replace(/\n/g,"<br>"),e=e.replace(/[ \t]{2,}/g,function(a){return CKEDITOR.tools.repeat("&nbsp;",a.length-1)+" "});if(c){var f=b.clone();f.setHtml(e);c.append(f)}else b.setHtml(e)}return c||b}function r(a,b){var c=this._.definition,
d=c.attributes,c=c.styles,e=B(this)[a.getName()],g=CKEDITOR.tools.isEmpty(d)&&CKEDITOR.tools.isEmpty(c),f;for(f in d)if(!((f=="class"||this._.definition.fullMatch)&&a.getAttribute(f)!=l(f,d[f]))&&!(b&&f.slice(0,5)=="data-")){g=a.hasAttribute(f);a.removeAttribute(f)}for(var h in c)if(!(this._.definition.fullMatch&&a.getStyle(h)!=l(h,c[h],true))){g=g||!!a.getStyle(h);a.removeStyle(h)}o(a,e,k[a.getName()]);g&&(this._.definition.alwaysRemoveElement?q(a,1):!CKEDITOR.dtd.$block[a.getName()]||this._.enterMode==
CKEDITOR.ENTER_BR&&!a.hasAttributes()?q(a):a.renameNode(this._.enterMode==CKEDITOR.ENTER_P?"p":"div"))}function y(a){for(var b=B(this),c=a.getElementsByTag(this.element),d,e=c.count();--e>=0;){d=c.getItem(e);d.isReadOnly()||r.call(this,d,true)}for(var g in b)if(g!=this.element){c=a.getElementsByTag(g);for(e=c.count()-1;e>=0;e--){d=c.getItem(e);d.isReadOnly()||o(d,b[g])}}}function o(a,b,c){if(b=b&&b.attributes)for(var d=0;d<b.length;d++){var e=b[d][0],g;if(g=a.getAttribute(e)){var f=b[d][1];(f===null||
f.test&&f.test(g)||typeof f=="string"&&g==f)&&a.removeAttribute(e)}}c||q(a)}function q(a,b){if(!a.hasAttributes()||b)if(CKEDITOR.dtd.$block[a.getName()]){var c=a.getPrevious(z),d=a.getNext(z);c&&(c.type==CKEDITOR.NODE_TEXT||!c.isBlockBoundary({br:1}))&&a.append("br",1);d&&(d.type==CKEDITOR.NODE_TEXT||!d.isBlockBoundary({br:1}))&&a.append("br");a.remove(true)}else{c=a.getFirst();d=a.getLast();a.remove(true);if(c){c.type==CKEDITOR.NODE_ELEMENT&&c.mergeSiblings();d&&(!c.equals(d)&&d.type==CKEDITOR.NODE_ELEMENT)&&
d.mergeSiblings()}}}function t(a,b,c){var d;d=a.element;d=="*"&&(d="span");d=new CKEDITOR.dom.element(d,b);c&&c.copyAttributes(d);d=w(d,a);b.getCustomData("doc_processing_style")&&d.hasAttribute("id")?d.removeAttribute("id"):b.setCustomData("doc_processing_style",1);return d}function w(a,b){var c=b._.definition,d=c.attributes,c=CKEDITOR.style.getStyleText(c);if(d)for(var e in d)a.setAttribute(e,d[e]);c&&a.setAttribute("style",c);return a}function v(a,b){for(var c in a)a[c]=a[c].replace(p,function(a,
c){return b[c]})}function B(a){if(a._.overrides)return a._.overrides;var b=a._.overrides={},c=a._.definition.overrides;if(c){CKEDITOR.tools.isArray(c)||(c=[c]);for(var d=0;d<c.length;d++){var e=c[d],g,f;if(typeof e=="string")g=e.toLowerCase();else{g=e.element?e.element.toLowerCase():a.element;f=e.attributes}e=b[g]||(b[g]={});if(f){var e=e.attributes=e.attributes||[],h;for(h in f)e.push([h.toLowerCase(),f[h]])}}}return b}function l(a,b,c){var d=new CKEDITOR.dom.element("span");d[c?"setStyle":"setAttribute"](a,
b);return d[c?"getStyle":"getAttribute"](a)}function s(a,b,c){for(var d=a.document,e=a.getRanges(),b=b?this.removeFromRange:this.applyToRange,g,f=e.createIterator();g=f.getNextRange();)b.call(this,g,c);a.selectRanges(e);d.removeCustomData("doc_processing_style")}var k={address:1,div:1,h1:1,h2:1,h3:1,h4:1,h5:1,h6:1,p:1,pre:1,section:1,header:1,footer:1,nav:1,article:1,aside:1,figure:1,dialog:1,hgroup:1,time:1,meter:1,menu:1,command:1,keygen:1,output:1,progress:1,details:1,datagrid:1,datalist:1},m=
{a:1,blockquote:1,embed:1,hr:1,img:1,li:1,object:1,ol:1,table:1,td:1,tr:1,th:1,ul:1,dl:1,dt:1,dd:1,form:1,audio:1,video:1},F=/\s*(?:;\s*|$)/,p=/#\((.+?)\)/g,I=CKEDITOR.dom.walker.bookmark(0,1),z=CKEDITOR.dom.walker.whitespaces(1);CKEDITOR.style=function(a,b){if(typeof a.type=="string")return new CKEDITOR.style.customHandlers[a.type](a);var c=a.attributes;if(c&&c.style){a.styles=CKEDITOR.tools.extend({},a.styles,CKEDITOR.tools.parseCssText(c.style));delete c.style}if(b){a=CKEDITOR.tools.clone(a);v(a.attributes,
b);v(a.styles,b)}c=this.element=a.element?typeof a.element=="string"?a.element.toLowerCase():a.element:"*";this.type=a.type||(k[c]?CKEDITOR.STYLE_BLOCK:m[c]?CKEDITOR.STYLE_OBJECT:CKEDITOR.STYLE_INLINE);if(typeof this.element=="object")this.type=CKEDITOR.STYLE_OBJECT;this._={definition:a}};CKEDITOR.style.prototype={apply:function(a){if(a instanceof CKEDITOR.dom.document)return s.call(this,a.getSelection());if(this.checkApplicable(a.elementPath(),a)){var b=this._.enterMode;if(!b)this._.enterMode=a.activeEnterMode;
s.call(this,a.getSelection(),0,a);this._.enterMode=b}},remove:function(a){if(a instanceof CKEDITOR.dom.document)return s.call(this,a.getSelection(),1);if(this.checkApplicable(a.elementPath(),a)){var b=this._.enterMode;if(!b)this._.enterMode=a.activeEnterMode;s.call(this,a.getSelection(),1,a);this._.enterMode=b}},applyToRange:function(a){this.applyToRange=this.type==CKEDITOR.STYLE_INLINE?d:this.type==CKEDITOR.STYLE_BLOCK?h:this.type==CKEDITOR.STYLE_OBJECT?e:null;return this.applyToRange(a)},removeFromRange:function(a){this.removeFromRange=
this.type==CKEDITOR.STYLE_INLINE?b:this.type==CKEDITOR.STYLE_BLOCK?i:this.type==CKEDITOR.STYLE_OBJECT?f:null;return this.removeFromRange(a)},applyToObject:function(a){w(a,this)},checkActive:function(a,b){switch(this.type){case CKEDITOR.STYLE_BLOCK:return this.checkElementRemovable(a.block||a.blockLimit,true,b);case CKEDITOR.STYLE_OBJECT:case CKEDITOR.STYLE_INLINE:for(var c=a.elements,d=0,e;d<c.length;d++){e=c[d];if(!(this.type==CKEDITOR.STYLE_INLINE&&(e==a.block||e==a.blockLimit))){if(this.type==
CKEDITOR.STYLE_OBJECT){var g=e.getName();if(!(typeof this.element=="string"?g==this.element:g in this.element))continue}if(this.checkElementRemovable(e,true,b))return true}}}return false},checkApplicable:function(a,b,c){b&&b instanceof CKEDITOR.filter&&(c=b);if(c&&!c.check(this))return false;switch(this.type){case CKEDITOR.STYLE_OBJECT:return!!a.contains(this.element);case CKEDITOR.STYLE_BLOCK:return!!a.blockLimit.getDtd()[this.element]}return true},checkElementMatch:function(a,b){var c=this._.definition;
if(!a||!c.ignoreReadonly&&a.isReadOnly())return false;var d=a.getName();if(typeof this.element=="string"?d==this.element:d in this.element){if(!b&&!a.hasAttributes())return true;if(d=c._AC)c=d;else{var d={},e=0,g=c.attributes;if(g)for(var f in g){e++;d[f]=g[f]}if(f=CKEDITOR.style.getStyleText(c)){d.style||e++;d.style=f}d._length=e;c=c._AC=d}if(c._length){for(var h in c)if(h!="_length"){e=a.getAttribute(h)||"";if(h=="style")a:{d=c[h];typeof d=="string"&&(d=CKEDITOR.tools.parseCssText(d));typeof e==
"string"&&(e=CKEDITOR.tools.parseCssText(e,true));f=void 0;for(f in d)if(!(f in e&&(e[f]==d[f]||d[f]=="inherit"||e[f]=="inherit"))){d=false;break a}d=true}else d=c[h]==e;if(d){if(!b)return true}else if(b)return false}if(b)return true}else return true}return false},checkElementRemovable:function(a,b,c){if(this.checkElementMatch(a,b,c))return true;if(b=B(this)[a.getName()]){var d;if(!(b=b.attributes))return true;for(c=0;c<b.length;c++){d=b[c][0];if(d=a.getAttribute(d)){var e=b[c][1];if(e===null)return true;
if(typeof e=="string"){if(d==e)return true}else if(e.test(d))return true}}}return false},buildPreview:function(a){var b=this._.definition,c=[],d=b.element;d=="bdo"&&(d="span");var c=["<",d],e=b.attributes;if(e)for(var g in e)c.push(" ",g,'="',e[g],'"');(e=CKEDITOR.style.getStyleText(b))&&c.push(' style="',e,'"');c.push(">",a||b.name,"</",d,">");return c.join("")},getDefinition:function(){return this._.definition}};CKEDITOR.style.getStyleText=function(a){var b=a._ST;if(b)return b;var b=a.styles,c=
a.attributes&&a.attributes.style||"",d="";c.length&&(c=c.replace(F,";"));for(var e in b){var g=b[e],f=(e+":"+g).replace(F,";");g=="inherit"?d=d+f:c=c+f}c.length&&(c=CKEDITOR.tools.normalizeCssText(c,true));return a._ST=c+d};CKEDITOR.style.customHandlers={};CKEDITOR.style.addCustomHandler=function(a){var b=function(a){this._={definition:a};this.setup&&this.setup(a)};b.prototype=CKEDITOR.tools.extend(CKEDITOR.tools.prototypedCopy(CKEDITOR.style.prototype),{assignedTo:CKEDITOR.STYLE_OBJECT},a,true);
return this.customHandlers[a.type]=b};var L=CKEDITOR.POSITION_PRECEDING|CKEDITOR.POSITION_IDENTICAL|CKEDITOR.POSITION_IS_CONTAINED,E=CKEDITOR.POSITION_FOLLOWING|CKEDITOR.POSITION_IDENTICAL|CKEDITOR.POSITION_IS_CONTAINED})();CKEDITOR.styleCommand=function(a,d){this.requiredContent=this.allowedContent=this.style=a;CKEDITOR.tools.extend(this,d,true)};
CKEDITOR.styleCommand.prototype.exec=function(a){a.focus();this.state==CKEDITOR.TRISTATE_OFF?a.applyStyle(this.style):this.state==CKEDITOR.TRISTATE_ON&&a.removeStyle(this.style)};CKEDITOR.stylesSet=new CKEDITOR.resourceManager("","stylesSet");CKEDITOR.addStylesSet=CKEDITOR.tools.bind(CKEDITOR.stylesSet.add,CKEDITOR.stylesSet);CKEDITOR.loadStylesSet=function(a,d,b){CKEDITOR.stylesSet.addExternal(a,d,"");CKEDITOR.stylesSet.load(a,b)};
CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{attachStyleStateChange:function(a,d){var b=this._.styleStateChangeCallbacks;if(!b){b=this._.styleStateChangeCallbacks=[];this.on("selectionChange",function(a){for(var d=0;d<b.length;d++){var f=b[d],h=f.style.checkActive(a.data.path,this)?CKEDITOR.TRISTATE_ON:CKEDITOR.TRISTATE_OFF;f.fn.call(this,h)}})}b.push({style:a,fn:d})},applyStyle:function(a){a.apply(this)},removeStyle:function(a){a.remove(this)},getStylesSet:function(a){if(this._.stylesDefinitions)a(this._.stylesDefinitions);
else{var d=this,b=d.config.stylesCombo_stylesSet||d.config.stylesSet;if(b===false)a(null);else if(b instanceof Array){d._.stylesDefinitions=b;a(b)}else{b||(b="default");var b=b.split(":"),c=b[0];CKEDITOR.stylesSet.addExternal(c,b[1]?b.slice(1).join(":"):CKEDITOR.getUrl("styles.js"),"");CKEDITOR.stylesSet.load(c,function(b){d._.stylesDefinitions=b[c];a(d._.stylesDefinitions)})}}}});
CKEDITOR.dom.comment=function(a,d){typeof a=="string"&&(a=(d?d.$:document).createComment(a));CKEDITOR.dom.domObject.call(this,a)};CKEDITOR.dom.comment.prototype=new CKEDITOR.dom.node;CKEDITOR.tools.extend(CKEDITOR.dom.comment.prototype,{type:CKEDITOR.NODE_COMMENT,getOuterHtml:function(){return"<\!--"+this.$.nodeValue+"--\>"}});"use strict";
(function(){var a={},d={},b;for(b in CKEDITOR.dtd.$blockLimit)b in CKEDITOR.dtd.$list||(a[b]=1);for(b in CKEDITOR.dtd.$block)b in CKEDITOR.dtd.$blockLimit||b in CKEDITOR.dtd.$empty||(d[b]=1);CKEDITOR.dom.elementPath=function(b,e){var f=null,h=null,i=[],j=b,n,e=e||b.getDocument().getBody();do if(j.type==CKEDITOR.NODE_ELEMENT){i.push(j);if(!this.lastElement){this.lastElement=j;if(j.is(CKEDITOR.dtd.$object)||j.getAttribute("contenteditable")=="false")continue}if(j.equals(e))break;if(!h){n=j.getName();
j.getAttribute("contenteditable")=="true"?h=j:!f&&d[n]&&(f=j);if(a[n]){var g;if(g=!f){if(n=n=="div"){a:{n=j.getChildren();g=0;for(var A=n.count();g<A;g++){var r=n.getItem(g);if(r.type==CKEDITOR.NODE_ELEMENT&&CKEDITOR.dtd.$block[r.getName()]){n=true;break a}}n=false}n=!n}g=n}g?f=j:h=j}}}while(j=j.getParent());h||(h=e);this.block=f;this.blockLimit=h;this.root=e;this.elements=i}})();
CKEDITOR.dom.elementPath.prototype={compare:function(a){var d=this.elements,a=a&&a.elements;if(!a||d.length!=a.length)return false;for(var b=0;b<d.length;b++)if(!d[b].equals(a[b]))return false;return true},contains:function(a,d,b){var c;typeof a=="string"&&(c=function(b){return b.getName()==a});a instanceof CKEDITOR.dom.element?c=function(b){return b.equals(a)}:CKEDITOR.tools.isArray(a)?c=function(b){return CKEDITOR.tools.indexOf(a,b.getName())>-1}:typeof a=="function"?c=a:typeof a=="object"&&(c=
function(b){return b.getName()in a});var e=this.elements,f=e.length;d&&f--;if(b){e=Array.prototype.slice.call(e,0);e.reverse()}for(d=0;d<f;d++)if(c(e[d]))return e[d];return null},isContextFor:function(a){var d;if(a in CKEDITOR.dtd.$block){d=this.contains(CKEDITOR.dtd.$intermediate)||this.root.equals(this.block)&&this.block||this.blockLimit;return!!d.getDtd()[a]}return true},direction:function(){return(this.block||this.blockLimit||this.root).getDirection(1)}};
CKEDITOR.dom.text=function(a,d){typeof a=="string"&&(a=(d?d.$:document).createTextNode(a));this.$=a};CKEDITOR.dom.text.prototype=new CKEDITOR.dom.node;
CKEDITOR.tools.extend(CKEDITOR.dom.text.prototype,{type:CKEDITOR.NODE_TEXT,getLength:function(){return this.$.nodeValue.length},getText:function(){return this.$.nodeValue},setText:function(a){this.$.nodeValue=a},split:function(a){var d=this.$.parentNode,b=d.childNodes.length,c=this.getLength(),e=this.getDocument(),f=new CKEDITOR.dom.text(this.$.splitText(a),e);if(d.childNodes.length==b)if(a>=c){f=e.createText("");f.insertAfter(this)}else{a=e.createText("");a.insertAfter(f);a.remove()}return f},substring:function(a,
d){return typeof d!="number"?this.$.nodeValue.substr(a):this.$.nodeValue.substring(a,d)}});
(function(){function a(a,c,d){var f=a.serializable,h=c[d?"endContainer":"startContainer"],i=d?"endOffset":"startOffset",j=f?c.document.getById(a.startNode):a.startNode,a=f?c.document.getById(a.endNode):a.endNode;if(h.equals(j.getPrevious())){c.startOffset=c.startOffset-h.getLength()-a.getPrevious().getLength();h=a.getNext()}else if(h.equals(a.getPrevious())){c.startOffset=c.startOffset-h.getLength();h=a.getNext()}h.equals(j.getParent())&&c[i]++;h.equals(a.getParent())&&c[i]++;c[d?"endContainer":"startContainer"]=
h;return c}CKEDITOR.dom.rangeList=function(a){if(a instanceof CKEDITOR.dom.rangeList)return a;a?a instanceof CKEDITOR.dom.range&&(a=[a]):a=[];return CKEDITOR.tools.extend(a,d)};var d={createIterator:function(){var a=this,c=CKEDITOR.dom.walker.bookmark(),d=[],f;return{getNextRange:function(h){f=f===void 0?0:f+1;var i=a[f];if(i&&a.length>1){if(!f)for(var j=a.length-1;j>=0;j--)d.unshift(a[j].createBookmark(true));if(h)for(var n=0;a[f+n+1];){for(var g=i.document,h=0,j=g.getById(d[n].endNode),g=g.getById(d[n+
1].startNode);;){j=j.getNextSourceNode(false);if(g.equals(j))h=1;else if(c(j)||j.type==CKEDITOR.NODE_ELEMENT&&j.isBlockBoundary())continue;break}if(!h)break;n++}for(i.moveToBookmark(d.shift());n--;){j=a[++f];j.moveToBookmark(d.shift());i.setEnd(j.endContainer,j.endOffset)}}return i}}},createBookmarks:function(b){for(var c=[],d,f=0;f<this.length;f++){c.push(d=this[f].createBookmark(b,true));for(var h=f+1;h<this.length;h++){this[h]=a(d,this[h]);this[h]=a(d,this[h],true)}}return c},createBookmarks2:function(a){for(var c=
[],d=0;d<this.length;d++)c.push(this[d].createBookmark2(a));return c},moveToBookmarks:function(a){for(var c=0;c<this.length;c++)this[c].moveToBookmark(a[c])}}})();
(function(){function a(){return CKEDITOR.getUrl(CKEDITOR.skinName.split(",")[1]||"skins/"+CKEDITOR.skinName.split(",")[0]+"/")}function d(b){var c=CKEDITOR.skin["ua_"+b],d=CKEDITOR.env;if(c)for(var c=c.split(",").sort(function(a,b){return a>b?-1:1}),e=0,f;e<c.length;e++){f=c[e];if(d.ie&&(f.replace(/^ie/,"")==d.version||d.quirks&&f=="iequirks"))f="ie";if(d[f]){b=b+("_"+c[e]);break}}return CKEDITOR.getUrl(a()+b+".css")}function b(a,b){if(!f[a]){CKEDITOR.document.appendStyleSheet(d(a));f[a]=1}b&&b()}
function c(a){var b=a.getById(h);if(!b){b=a.getHead().append("style");b.setAttribute("id",h);b.setAttribute("type","text/css")}return b}function e(a,b,c){var d,e,f;if(CKEDITOR.env.webkit){b=b.split("}").slice(0,-1);for(e=0;e<b.length;e++)b[e]=b[e].split("{")}for(var h=0;h<a.length;h++)if(CKEDITOR.env.webkit)for(e=0;e<b.length;e++){f=b[e][1];for(d=0;d<c.length;d++)f=f.replace(c[d][0],c[d][1]);a[h].$.sheet.addRule(b[e][0],f)}else{f=b;for(d=0;d<c.length;d++)f=f.replace(c[d][0],c[d][1]);CKEDITOR.env.ie&&
CKEDITOR.env.version<11?a[h].$.styleSheet.cssText=a[h].$.styleSheet.cssText+f:a[h].$.innerHTML=a[h].$.innerHTML+f}}var f={};CKEDITOR.skin={path:a,loadPart:function(c,d){CKEDITOR.skin.name!=CKEDITOR.skinName.split(",")[0]?CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(a()+"skin.js"),function(){b(c,d)}):b(c,d)},getPath:function(a){return CKEDITOR.getUrl(d(a))},icons:{},addIcon:function(a,b,c,d){a=a.toLowerCase();this.icons[a]||(this.icons[a]={path:b,offset:c||0,bgsize:d||"16px"})},getIconStyle:function(a,
b,c,d,e){var f;if(a){a=a.toLowerCase();b&&(f=this.icons[a+"-rtl"]);f||(f=this.icons[a])}a=c||f&&f.path||"";d=d||f&&f.offset;e=e||f&&f.bgsize||"16px";return a&&"background-image:url("+CKEDITOR.getUrl(a)+");background-position:0 "+d+"px;background-size:"+e+";"}};CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{getUiColor:function(){return this.uiColor},setUiColor:function(a){var b=c(CKEDITOR.document);return(this.setUiColor=function(a){this.uiColor=a;var c=CKEDITOR.skin.chameleon,d="",f="";if(typeof c==
"function"){d=c(this,"editor");f=c(this,"panel")}a=[[j,a]];e([b],d,a);e(i,f,a)}).call(this,a)}});var h="cke_ui_color",i=[],j=/\$color/g;CKEDITOR.on("instanceLoaded",function(a){if(!CKEDITOR.env.ie||!CKEDITOR.env.quirks){var b=a.editor,a=function(a){a=(a.data[0]||a.data).element.getElementsByTag("iframe").getItem(0).getFrameDocument();if(!a.getById("cke_ui_color")){a=c(a);i.push(a);var d=b.getUiColor();d&&e([a],CKEDITOR.skin.chameleon(b,"panel"),[[j,d]])}};b.on("panelShow",a);b.on("menuShow",a);b.config.uiColor&&
b.setUiColor(b.config.uiColor)}})})();
(function(){if(CKEDITOR.env.webkit)CKEDITOR.env.hc=false;else{var a=CKEDITOR.dom.element.createFromHtml('<div style="width:0;height:0;position:absolute;left:-10000px;border:1px solid;border-color:red blue"></div>',CKEDITOR.document);a.appendTo(CKEDITOR.document.getHead());try{var d=a.getComputedStyle("border-top-color"),b=a.getComputedStyle("border-right-color");CKEDITOR.env.hc=!!(d&&d==b)}catch(c){CKEDITOR.env.hc=false}a.remove()}if(CKEDITOR.env.hc)CKEDITOR.env.cssClass=CKEDITOR.env.cssClass+" cke_hc";
CKEDITOR.document.appendStyleText(".cke{visibility:hidden;}");CKEDITOR.status="loaded";CKEDITOR.fireOnce("loaded");if(a=CKEDITOR._.pending){delete CKEDITOR._.pending;for(d=0;d<a.length;d++){CKEDITOR.editor.prototype.constructor.apply(a[d][0],a[d][1]);CKEDITOR.add(a[d][0])}}})();/*
 Copyright (c) 2003-2015, CKSource - Frederico Knabben. All rights reserved.
 For licensing, see LICENSE.md or http://ckeditor.com/license
*/
CKEDITOR.skin.name="moono";CKEDITOR.skin.ua_editor="ie,iequirks,ie7,ie8,gecko";CKEDITOR.skin.ua_dialog="ie,iequirks,ie7,ie8";
CKEDITOR.skin.chameleon=function(){var b=function(){return function(b,e){for(var a=b.match(/[^#]./g),c=0;3>c;c++){var f=a,h=c,d;d=parseInt(a[c],16);d=("0"+(0>e?0|d*(1+e):0|d+(255-d)*e).toString(16)).slice(-2);f[h]=d}return"#"+a.join("")}}(),c=function(){var b=new CKEDITOR.template("background:#{to};background-image:linear-gradient(to bottom,{from},{to});filter:progid:DXImageTransform.Microsoft.gradient(gradientType=0,startColorstr='{from}',endColorstr='{to}');");return function(c,a){return b.output({from:c,
to:a})}}(),f={editor:new CKEDITOR.template("{id}.cke_chrome [border-color:{defaultBorder};] {id} .cke_top [ {defaultGradient}border-bottom-color:{defaultBorder};] {id} .cke_bottom [{defaultGradient}border-top-color:{defaultBorder};] {id} .cke_resizer [border-right-color:{ckeResizer}] {id} .cke_dialog_title [{defaultGradient}border-bottom-color:{defaultBorder};] {id} .cke_dialog_footer [{defaultGradient}outline-color:{defaultBorder};border-top-color:{defaultBorder};] {id} .cke_dialog_tab [{lightGradient}border-color:{defaultBorder};] {id} .cke_dialog_tab:hover [{mediumGradient}] {id} .cke_dialog_contents [border-top-color:{defaultBorder};] {id} .cke_dialog_tab_selected, {id} .cke_dialog_tab_selected:hover [background:{dialogTabSelected};border-bottom-color:{dialogTabSelectedBorder};] {id} .cke_dialog_body [background:{dialogBody};border-color:{defaultBorder};] {id} .cke_toolgroup [{lightGradient}border-color:{defaultBorder};] {id} a.cke_button_off:hover, {id} a.cke_button_off:focus, {id} a.cke_button_off:active [{mediumGradient}] {id} .cke_button_on [{ckeButtonOn}] {id} .cke_toolbar_separator [background-color: {ckeToolbarSeparator};] {id} .cke_combo_button [border-color:{defaultBorder};{lightGradient}] {id} a.cke_combo_button:hover, {id} a.cke_combo_button:focus, {id} .cke_combo_on a.cke_combo_button [border-color:{defaultBorder};{mediumGradient}] {id} .cke_path_item [color:{elementsPathColor};] {id} a.cke_path_item:hover, {id} a.cke_path_item:focus, {id} a.cke_path_item:active [background-color:{elementsPathBg};] {id}.cke_panel [border-color:{defaultBorder};] "),
panel:new CKEDITOR.template(".cke_panel_grouptitle [{lightGradient}border-color:{defaultBorder};] .cke_menubutton_icon [background-color:{menubuttonIcon};] .cke_menubutton:hover .cke_menubutton_icon, .cke_menubutton:focus .cke_menubutton_icon, .cke_menubutton:active .cke_menubutton_icon [background-color:{menubuttonIconHover};] .cke_menuseparator [background-color:{menubuttonIcon};] a:hover.cke_colorbox, a:focus.cke_colorbox, a:active.cke_colorbox [border-color:{defaultBorder};] a:hover.cke_colorauto, a:hover.cke_colormore, a:focus.cke_colorauto, a:focus.cke_colormore, a:active.cke_colorauto, a:active.cke_colormore [background-color:{ckeColorauto};border-color:{defaultBorder};] ")};
return function(g,e){var a=g.uiColor,a={id:"."+g.id,defaultBorder:b(a,-0.1),defaultGradient:c(b(a,0.9),a),lightGradient:c(b(a,1),b(a,0.7)),mediumGradient:c(b(a,0.8),b(a,0.5)),ckeButtonOn:c(b(a,0.6),b(a,0.7)),ckeResizer:b(a,-0.4),ckeToolbarSeparator:b(a,0.5),ckeColorauto:b(a,0.8),dialogBody:b(a,0.7),dialogTabSelected:c("#FFFFFF","#FFFFFF"),dialogTabSelectedBorder:"#FFF",elementsPathColor:b(a,-0.6),elementsPathBg:a,menubuttonIcon:b(a,0.5),menubuttonIconHover:b(a,0.3)};return f[e].output(a).replace(/\[/g,
"{").replace(/\]/g,"}")}}();CKEDITOR.plugins.add("dialogui",{onLoad:function(){var h=function(b){this._||(this._={});this._["default"]=this._.initValue=b["default"]||"";this._.required=b.required||!1;for(var a=[this._],d=1;d<arguments.length;d++)a.push(arguments[d]);a.push(!0);CKEDITOR.tools.extend.apply(CKEDITOR.tools,a);return this._},r={build:function(b,a,d){return new CKEDITOR.ui.dialog.textInput(b,a,d)}},l={build:function(b,a,d){return new CKEDITOR.ui.dialog[a.type](b,a,d)}},n={isChanged:function(){return this.getValue()!=
this.getInitValue()},reset:function(b){this.setValue(this.getInitValue(),b)},setInitValue:function(){this._.initValue=this.getValue()},resetInitValue:function(){this._.initValue=this._["default"]},getInitValue:function(){return this._.initValue}},o=CKEDITOR.tools.extend({},CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors,{onChange:function(b,a){this._.domOnChangeRegistered||(b.on("load",function(){this.getInputElement().on("change",function(){b.parts.dialog.isVisible()&&this.fire("change",{value:this.getValue()})},
this)},this),this._.domOnChangeRegistered=!0);this.on("change",a)}},!0),t=/^on([A-Z]\w+)/,p=function(b){for(var a in b)(t.test(a)||"title"==a||"type"==a)&&delete b[a];return b},s=function(b){b=b.data.getKeystroke();b==CKEDITOR.SHIFT+CKEDITOR.ALT+36?this.setDirectionMarker("ltr"):b==CKEDITOR.SHIFT+CKEDITOR.ALT+35&&this.setDirectionMarker("rtl")};CKEDITOR.tools.extend(CKEDITOR.ui.dialog,{labeledElement:function(b,a,d,f){if(!(4>arguments.length)){var c=h.call(this,a);c.labelId=CKEDITOR.tools.getNextId()+
"_label";this._.children=[];var e={role:a.role||"presentation"};a.includeLabel&&(e["aria-labelledby"]=c.labelId);CKEDITOR.ui.dialog.uiElement.call(this,b,a,d,"div",null,e,function(){var e=[],g=a.required?" cke_required":"";if(a.labelLayout!="horizontal")e.push('<label class="cke_dialog_ui_labeled_label'+g+'" ',' id="'+c.labelId+'"',c.inputId?' for="'+c.inputId+'"':"",(a.labelStyle?' style="'+a.labelStyle+'"':"")+">",a.label,"</label>",'<div class="cke_dialog_ui_labeled_content"',a.controlStyle?' style="'+
a.controlStyle+'"':"",' role="presentation">',f.call(this,b,a),"</div>");else{g={type:"hbox",widths:a.widths,padding:0,children:[{type:"html",html:'<label class="cke_dialog_ui_labeled_label'+g+'" id="'+c.labelId+'" for="'+c.inputId+'"'+(a.labelStyle?' style="'+a.labelStyle+'"':"")+">"+CKEDITOR.tools.htmlEncode(a.label)+"</label>"},{type:"html",html:'<span class="cke_dialog_ui_labeled_content"'+(a.controlStyle?' style="'+a.controlStyle+'"':"")+">"+f.call(this,b,a)+"</span>"}]};CKEDITOR.dialog._.uiElementBuilders.hbox.build(b,
g,e)}return e.join("")})}},textInput:function(b,a,d){if(!(3>arguments.length)){h.call(this,a);var f=this._.inputId=CKEDITOR.tools.getNextId()+"_textInput",c={"class":"cke_dialog_ui_input_"+a.type,id:f,type:a.type};a.validate&&(this.validate=a.validate);a.maxLength&&(c.maxlength=a.maxLength);a.size&&(c.size=a.size);a.inputStyle&&(c.style=a.inputStyle);var e=this,k=!1;b.on("load",function(){e.getInputElement().on("keydown",function(a){a.data.getKeystroke()==13&&(k=true)});e.getInputElement().on("keyup",
function(a){if(a.data.getKeystroke()==13&&k){b.getButton("ok")&&setTimeout(function(){b.getButton("ok").click()},0);k=false}e.bidi&&s.call(e,a)},null,null,1E3)});CKEDITOR.ui.dialog.labeledElement.call(this,b,a,d,function(){var b=['<div class="cke_dialog_ui_input_',a.type,'" role="presentation"'];a.width&&b.push('style="width:'+a.width+'" ');b.push("><input ");c["aria-labelledby"]=this._.labelId;this._.required&&(c["aria-required"]=this._.required);for(var e in c)b.push(e+'="'+c[e]+'" ');b.push(" /></div>");
return b.join("")})}},textarea:function(b,a,d){if(!(3>arguments.length)){h.call(this,a);var f=this,c=this._.inputId=CKEDITOR.tools.getNextId()+"_textarea",e={};a.validate&&(this.validate=a.validate);e.rows=a.rows||5;e.cols=a.cols||20;e["class"]="cke_dialog_ui_input_textarea "+(a["class"]||"");"undefined"!=typeof a.inputStyle&&(e.style=a.inputStyle);a.dir&&(e.dir=a.dir);if(f.bidi)b.on("load",function(){f.getInputElement().on("keyup",s)},f);CKEDITOR.ui.dialog.labeledElement.call(this,b,a,d,function(){e["aria-labelledby"]=
this._.labelId;this._.required&&(e["aria-required"]=this._.required);var a=['<div class="cke_dialog_ui_input_textarea" role="presentation"><textarea id="',c,'" '],b;for(b in e)a.push(b+'="'+CKEDITOR.tools.htmlEncode(e[b])+'" ');a.push(">",CKEDITOR.tools.htmlEncode(f._["default"]),"</textarea></div>");return a.join("")})}},checkbox:function(b,a,d){if(!(3>arguments.length)){var f=h.call(this,a,{"default":!!a["default"]});a.validate&&(this.validate=a.validate);CKEDITOR.ui.dialog.uiElement.call(this,
b,a,d,"span",null,null,function(){var c=CKEDITOR.tools.extend({},a,{id:a.id?a.id+"_checkbox":CKEDITOR.tools.getNextId()+"_checkbox"},true),e=[],d=CKEDITOR.tools.getNextId()+"_label",g={"class":"cke_dialog_ui_checkbox_input",type:"checkbox","aria-labelledby":d};p(c);if(a["default"])g.checked="checked";if(typeof c.inputStyle!="undefined")c.style=c.inputStyle;f.checkbox=new CKEDITOR.ui.dialog.uiElement(b,c,e,"input",null,g);e.push(' <label id="',d,'" for="',g.id,'"'+(a.labelStyle?' style="'+a.labelStyle+
'"':"")+">",CKEDITOR.tools.htmlEncode(a.label),"</label>");return e.join("")})}},radio:function(b,a,d){if(!(3>arguments.length)){h.call(this,a);this._["default"]||(this._["default"]=this._.initValue=a.items[0][1]);a.validate&&(this.validate=a.validate);var f=[],c=this;a.role="radiogroup";a.includeLabel=!0;CKEDITOR.ui.dialog.labeledElement.call(this,b,a,d,function(){for(var e=[],d=[],g=(a.id?a.id:CKEDITOR.tools.getNextId())+"_radio",i=0;i<a.items.length;i++){var j=a.items[i],h=j[2]!==void 0?j[2]:j[0],
l=j[1]!==void 0?j[1]:j[0],m=CKEDITOR.tools.getNextId()+"_radio_input",n=m+"_label",m=CKEDITOR.tools.extend({},a,{id:m,title:null,type:null},true),h=CKEDITOR.tools.extend({},m,{title:h},true),o={type:"radio","class":"cke_dialog_ui_radio_input",name:g,value:l,"aria-labelledby":n},q=[];if(c._["default"]==l)o.checked="checked";p(m);p(h);if(typeof m.inputStyle!="undefined")m.style=m.inputStyle;m.keyboardFocusable=true;f.push(new CKEDITOR.ui.dialog.uiElement(b,m,q,"input",null,o));q.push(" ");new CKEDITOR.ui.dialog.uiElement(b,
h,q,"label",null,{id:n,"for":o.id},j[0]);e.push(q.join(""))}new CKEDITOR.ui.dialog.hbox(b,f,e,d);return d.join("")});this._.children=f}},button:function(b,a,d){if(arguments.length){"function"==typeof a&&(a=a(b.getParentEditor()));h.call(this,a,{disabled:a.disabled||!1});CKEDITOR.event.implementOn(this);var f=this;b.on("load",function(){var a=this.getElement();(function(){a.on("click",function(a){f.click();a.data.preventDefault()});a.on("keydown",function(a){a.data.getKeystroke()in{32:1}&&(f.click(),
a.data.preventDefault())})})();a.unselectable()},this);var c=CKEDITOR.tools.extend({},a);delete c.style;var e=CKEDITOR.tools.getNextId()+"_label";CKEDITOR.ui.dialog.uiElement.call(this,b,c,d,"a",null,{style:a.style,href:"javascript:void(0)",title:a.label,hidefocus:"true","class":a["class"],role:"button","aria-labelledby":e},'<span id="'+e+'" class="cke_dialog_ui_button">'+CKEDITOR.tools.htmlEncode(a.label)+"</span>")}},select:function(b,a,d){if(!(3>arguments.length)){var f=h.call(this,a);a.validate&&
(this.validate=a.validate);f.inputId=CKEDITOR.tools.getNextId()+"_select";CKEDITOR.ui.dialog.labeledElement.call(this,b,a,d,function(){var c=CKEDITOR.tools.extend({},a,{id:a.id?a.id+"_select":CKEDITOR.tools.getNextId()+"_select"},true),e=[],d=[],g={id:f.inputId,"class":"cke_dialog_ui_input_select","aria-labelledby":this._.labelId};e.push('<div class="cke_dialog_ui_input_',a.type,'" role="presentation"');a.width&&e.push('style="width:'+a.width+'" ');e.push(">");if(a.size!==void 0)g.size=a.size;if(a.multiple!==
void 0)g.multiple=a.multiple;p(c);for(var i=0,j;i<a.items.length&&(j=a.items[i]);i++)d.push('<option value="',CKEDITOR.tools.htmlEncode(j[1]!==void 0?j[1]:j[0]).replace(/"/g,"&quot;"),'" /> ',CKEDITOR.tools.htmlEncode(j[0]));if(typeof c.inputStyle!="undefined")c.style=c.inputStyle;f.select=new CKEDITOR.ui.dialog.uiElement(b,c,e,"select",null,g,d.join(""));e.push("</div>");return e.join("")})}},file:function(b,a,d){if(!(3>arguments.length)){void 0===a["default"]&&(a["default"]="");var f=CKEDITOR.tools.extend(h.call(this,
a),{definition:a,buttons:[]});a.validate&&(this.validate=a.validate);b.on("load",function(){CKEDITOR.document.getById(f.frameId).getParent().addClass("cke_dialog_ui_input_file")});CKEDITOR.ui.dialog.labeledElement.call(this,b,a,d,function(){f.frameId=CKEDITOR.tools.getNextId()+"_fileInput";var b=['<iframe frameborder="0" allowtransparency="0" class="cke_dialog_ui_input_file" role="presentation" id="',f.frameId,'" title="',a.label,'" src="javascript:void('];b.push(CKEDITOR.env.ie?"(function(){"+encodeURIComponent("document.open();("+
CKEDITOR.tools.fixDomain+")();document.close();")+"})()":"0");b.push(')"></iframe>');return b.join("")})}},fileButton:function(b,a,d){var f=this;if(!(3>arguments.length)){h.call(this,a);a.validate&&(this.validate=a.validate);var c=CKEDITOR.tools.extend({},a),e=c.onClick;c.className=(c.className?c.className+" ":"")+"cke_dialog_ui_button";c.onClick=function(c){var d=a["for"];if(!e||e.call(this,c)!==false){b.getContentElement(d[0],d[1]).submit();this.disable()}};b.on("load",function(){b.getContentElement(a["for"][0],
a["for"][1])._.buttons.push(f)});CKEDITOR.ui.dialog.button.call(this,b,c,d)}},html:function(){var b=/^\s*<[\w:]+\s+([^>]*)?>/,a=/^(\s*<[\w:]+(?:\s+[^>]*)?)((?:.|\r|\n)+)$/,d=/\/$/;return function(f,c,e){if(!(3>arguments.length)){var k=[],g=c.html;"<"!=g.charAt(0)&&(g="<span>"+g+"</span>");var i=c.focus;if(i){var j=this.focus;this.focus=function(){("function"==typeof i?i:j).call(this);this.fire("focus")};c.isFocusable&&(this.isFocusable=this.isFocusable);this.keyboardFocusable=!0}CKEDITOR.ui.dialog.uiElement.call(this,
f,c,k,"span",null,null,"");k=k.join("").match(b);g=g.match(a)||["","",""];d.test(g[1])&&(g[1]=g[1].slice(0,-1),g[2]="/"+g[2]);e.push([g[1]," ",k[1]||"",g[2]].join(""))}}}(),fieldset:function(b,a,d,f,c){var e=c.label;this._={children:a};CKEDITOR.ui.dialog.uiElement.call(this,b,c,f,"fieldset",null,null,function(){var a=[];e&&a.push("<legend"+(c.labelStyle?' style="'+c.labelStyle+'"':"")+">"+e+"</legend>");for(var b=0;b<d.length;b++)a.push(d[b]);return a.join("")})}},!0);CKEDITOR.ui.dialog.html.prototype=
new CKEDITOR.ui.dialog.uiElement;CKEDITOR.ui.dialog.labeledElement.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,{setLabel:function(b){var a=CKEDITOR.document.getById(this._.labelId);1>a.getChildCount()?(new CKEDITOR.dom.text(b,CKEDITOR.document)).appendTo(a):a.getChild(0).$.nodeValue=b;return this},getLabel:function(){var b=CKEDITOR.document.getById(this._.labelId);return!b||1>b.getChildCount()?"":b.getChild(0).getText()},eventProcessors:o},!0);CKEDITOR.ui.dialog.button.prototype=
CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,{click:function(){return!this._.disabled?this.fire("click",{dialog:this._.dialog}):!1},enable:function(){this._.disabled=!1;var b=this.getElement();b&&b.removeClass("cke_disabled")},disable:function(){this._.disabled=!0;this.getElement().addClass("cke_disabled")},isVisible:function(){return this.getElement().getFirst().isVisible()},isEnabled:function(){return!this._.disabled},eventProcessors:CKEDITOR.tools.extend({},CKEDITOR.ui.dialog.uiElement.prototype.eventProcessors,
{onClick:function(b,a){this.on("click",function(){a.apply(this,arguments)})}},!0),accessKeyUp:function(){this.click()},accessKeyDown:function(){this.focus()},keyboardFocusable:!0},!0);CKEDITOR.ui.dialog.textInput.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement,{getInputElement:function(){return CKEDITOR.document.getById(this._.inputId)},focus:function(){var b=this.selectParentTab();setTimeout(function(){var a=b.getInputElement();a&&a.$.focus()},0)},select:function(){var b=this.selectParentTab();
setTimeout(function(){var a=b.getInputElement();a&&(a.$.focus(),a.$.select())},0)},accessKeyUp:function(){this.select()},setValue:function(b){if(this.bidi){var a=b&&b.charAt(0);(a="‪"==a?"ltr":"‫"==a?"rtl":null)&&(b=b.slice(1));this.setDirectionMarker(a)}b||(b="");return CKEDITOR.ui.dialog.uiElement.prototype.setValue.apply(this,arguments)},getValue:function(){var b=CKEDITOR.ui.dialog.uiElement.prototype.getValue.call(this);if(this.bidi&&b){var a=this.getDirectionMarker();a&&(b=("ltr"==a?"‪":"‫")+
b)}return b},setDirectionMarker:function(b){var a=this.getInputElement();b?a.setAttributes({dir:b,"data-cke-dir-marker":b}):this.getDirectionMarker()&&a.removeAttributes(["dir","data-cke-dir-marker"])},getDirectionMarker:function(){return this.getInputElement().data("cke-dir-marker")},keyboardFocusable:!0},n,!0);CKEDITOR.ui.dialog.textarea.prototype=new CKEDITOR.ui.dialog.textInput;CKEDITOR.ui.dialog.select.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement,{getInputElement:function(){return this._.select.getElement()},
add:function(b,a,d){var f=new CKEDITOR.dom.element("option",this.getDialog().getParentEditor().document),c=this.getInputElement().$;f.$.text=b;f.$.value=void 0===a||null===a?b:a;void 0===d||null===d?CKEDITOR.env.ie?c.add(f.$):c.add(f.$,null):c.add(f.$,d);return this},remove:function(b){this.getInputElement().$.remove(b);return this},clear:function(){for(var b=this.getInputElement().$;0<b.length;)b.remove(0);return this},keyboardFocusable:!0},n,!0);CKEDITOR.ui.dialog.checkbox.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,
{getInputElement:function(){return this._.checkbox.getElement()},setValue:function(b,a){this.getInputElement().$.checked=b;!a&&this.fire("change",{value:b})},getValue:function(){return this.getInputElement().$.checked},accessKeyUp:function(){this.setValue(!this.getValue())},eventProcessors:{onChange:function(b,a){if(!CKEDITOR.env.ie||8<CKEDITOR.env.version)return o.onChange.apply(this,arguments);b.on("load",function(){var a=this._.checkbox.getElement();a.on("propertychange",function(b){b=b.data.$;
"checked"==b.propertyName&&this.fire("change",{value:a.$.checked})},this)},this);this.on("change",a);return null}},keyboardFocusable:!0},n,!0);CKEDITOR.ui.dialog.radio.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,{setValue:function(b,a){for(var d=this._.children,f,c=0;c<d.length&&(f=d[c]);c++)f.getElement().$.checked=f.getValue()==b;!a&&this.fire("change",{value:b})},getValue:function(){for(var b=this._.children,a=0;a<b.length;a++)if(b[a].getElement().$.checked)return b[a].getValue();
return null},accessKeyUp:function(){var b=this._.children,a;for(a=0;a<b.length;a++)if(b[a].getElement().$.checked){b[a].getElement().focus();return}b[0].getElement().focus()},eventProcessors:{onChange:function(b,a){if(CKEDITOR.env.ie)b.on("load",function(){for(var a=this._.children,b=this,c=0;c<a.length;c++)a[c].getElement().on("propertychange",function(a){a=a.data.$;"checked"==a.propertyName&&this.$.checked&&b.fire("change",{value:this.getAttribute("value")})})},this),this.on("change",a);else return o.onChange.apply(this,
arguments);return null}}},n,!0);CKEDITOR.ui.dialog.file.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.labeledElement,n,{getInputElement:function(){var b=CKEDITOR.document.getById(this._.frameId).getFrameDocument();return 0<b.$.forms.length?new CKEDITOR.dom.element(b.$.forms[0].elements[0]):this.getElement()},submit:function(){this.getInputElement().getParent().$.submit();return this},getAction:function(){return this.getInputElement().getParent().$.action},registerEvents:function(b){var a=
/^on([A-Z]\w+)/,d,f=function(a,b,c,d){a.on("formLoaded",function(){a.getInputElement().on(c,d,a)})},c;for(c in b)if(d=c.match(a))this.eventProcessors[c]?this.eventProcessors[c].call(this,this._.dialog,b[c]):f(this,this._.dialog,d[1].toLowerCase(),b[c]);return this},reset:function(){function b(){d.$.open();var b="";f.size&&(b=f.size-(CKEDITOR.env.ie?7:0));var h=a.frameId+"_input";d.$.write(['<html dir="'+g+'" lang="'+i+'"><head><title></title></head><body style="margin: 0; overflow: hidden; background: transparent;">',
'<form enctype="multipart/form-data" method="POST" dir="'+g+'" lang="'+i+'" action="',CKEDITOR.tools.htmlEncode(f.action),'"><label id="',a.labelId,'" for="',h,'" style="display:none">',CKEDITOR.tools.htmlEncode(f.label),'</label><input style="width:100%" id="',h,'" aria-labelledby="',a.labelId,'" type="file" name="',CKEDITOR.tools.htmlEncode(f.id||"cke_upload"),'" size="',CKEDITOR.tools.htmlEncode(0<b?b:""),'" /></form></body></html><script>',CKEDITOR.env.ie?"("+CKEDITOR.tools.fixDomain+")();":"",
"window.parent.CKEDITOR.tools.callFunction("+e+");","window.onbeforeunload = function() {window.parent.CKEDITOR.tools.callFunction("+k+")}","<\/script>"].join(""));d.$.close();for(b=0;b<c.length;b++)c[b].enable()}var a=this._,d=CKEDITOR.document.getById(a.frameId).getFrameDocument(),f=a.definition,c=a.buttons,e=this.formLoadedNumber,k=this.formUnloadNumber,g=a.dialog._.editor.lang.dir,i=a.dialog._.editor.langCode;e||(e=this.formLoadedNumber=CKEDITOR.tools.addFunction(function(){this.fire("formLoaded")},
this),k=this.formUnloadNumber=CKEDITOR.tools.addFunction(function(){this.getInputElement().clearCustomData()},this),this.getDialog()._.editor.on("destroy",function(){CKEDITOR.tools.removeFunction(e);CKEDITOR.tools.removeFunction(k)}));CKEDITOR.env.gecko?setTimeout(b,500):b()},getValue:function(){return this.getInputElement().$.value||""},setInitValue:function(){this._.initValue=""},eventProcessors:{onChange:function(b,a){this._.domOnChangeRegistered||(this.on("formLoaded",function(){this.getInputElement().on("change",
function(){this.fire("change",{value:this.getValue()})},this)},this),this._.domOnChangeRegistered=!0);this.on("change",a)}},keyboardFocusable:!0},!0);CKEDITOR.ui.dialog.fileButton.prototype=new CKEDITOR.ui.dialog.button;CKEDITOR.ui.dialog.fieldset.prototype=CKEDITOR.tools.clone(CKEDITOR.ui.dialog.hbox.prototype);CKEDITOR.dialog.addUIElement("text",r);CKEDITOR.dialog.addUIElement("password",r);CKEDITOR.dialog.addUIElement("textarea",l);CKEDITOR.dialog.addUIElement("checkbox",l);CKEDITOR.dialog.addUIElement("radio",
l);CKEDITOR.dialog.addUIElement("button",l);CKEDITOR.dialog.addUIElement("select",l);CKEDITOR.dialog.addUIElement("file",l);CKEDITOR.dialog.addUIElement("fileButton",l);CKEDITOR.dialog.addUIElement("html",l);CKEDITOR.dialog.addUIElement("fieldset",{build:function(b,a,d){for(var f=a.children,c,e=[],h=[],g=0;g<f.length&&(c=f[g]);g++){var i=[];e.push(i);h.push(CKEDITOR.dialog._.uiElementBuilders[c.type].build(b,c,i))}return new CKEDITOR.ui.dialog[a.type](b,h,e,d,a)}})}});CKEDITOR.DIALOG_RESIZE_NONE=0;CKEDITOR.DIALOG_RESIZE_WIDTH=1;CKEDITOR.DIALOG_RESIZE_HEIGHT=2;CKEDITOR.DIALOG_RESIZE_BOTH=3;CKEDITOR.DIALOG_STATE_IDLE=1;CKEDITOR.DIALOG_STATE_BUSY=2;
(function(){function t(){for(var a=this._.tabIdList.length,b=CKEDITOR.tools.indexOf(this._.tabIdList,this._.currentTabId)+a,c=b-1;c>b-a;c--)if(this._.tabs[this._.tabIdList[c%a]][0].$.offsetHeight)return this._.tabIdList[c%a];return null}function w(){for(var a=this._.tabIdList.length,b=CKEDITOR.tools.indexOf(this._.tabIdList,this._.currentTabId),c=b+1;c<b+a;c++)if(this._.tabs[this._.tabIdList[c%a]][0].$.offsetHeight)return this._.tabIdList[c%a];return null}function G(a,b){for(var c=a.$.getElementsByTagName("input"),
e=0,d=c.length;e<d;e++){var g=new CKEDITOR.dom.element(c[e]);"text"==g.getAttribute("type").toLowerCase()&&(b?(g.setAttribute("value",g.getCustomData("fake_value")||""),g.removeCustomData("fake_value")):(g.setCustomData("fake_value",g.getAttribute("value")),g.setAttribute("value","")))}}function P(a,b){var c=this.getInputElement();c&&(a?c.removeAttribute("aria-invalid"):c.setAttribute("aria-invalid",!0));a||(this.select?this.select():this.focus());b&&alert(b);this.fire("validated",{valid:a,msg:b})}
function Q(){var a=this.getInputElement();a&&a.removeAttribute("aria-invalid")}function R(a){var b=CKEDITOR.dom.element.createFromHtml(CKEDITOR.addTemplate("dialog",S).output({id:CKEDITOR.tools.getNextNumber(),editorId:a.id,langDir:a.lang.dir,langCode:a.langCode,editorDialogClass:"cke_editor_"+a.name.replace(/\./g,"\\.")+"_dialog",closeTitle:a.lang.common.close,hidpi:CKEDITOR.env.hidpi?"cke_hidpi":""})),c=b.getChild([0,0,0,0,0]),e=c.getChild(0),d=c.getChild(1);a.plugins.clipboard&&CKEDITOR.plugins.clipboard.preventDefaultDropOnElement(c);
CKEDITOR.env.ie&&(!CKEDITOR.env.quirks&&!CKEDITOR.env.edge)&&(a="javascript:void(function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+")();document.close();")+"}())",CKEDITOR.dom.element.createFromHtml('<iframe frameBorder="0" class="cke_iframe_shim" src="'+a+'" tabIndex="-1"></iframe>').appendTo(c.getParent()));e.unselectable();d.unselectable();return{element:b,parts:{dialog:b.getChild(0),title:e,close:d,tabs:c.getChild(2),contents:c.getChild([3,0,0,0]),footer:c.getChild([3,
0,1,0])}}}function H(a,b,c){this.element=b;this.focusIndex=c;this.tabIndex=0;this.isFocusable=function(){return!b.getAttribute("disabled")&&b.isVisible()};this.focus=function(){a._.currentFocusIndex=this.focusIndex;this.element.focus()};b.on("keydown",function(a){a.data.getKeystroke()in{32:1,13:1}&&this.fire("click")});b.on("focus",function(){this.fire("mouseover")});b.on("blur",function(){this.fire("mouseout")})}function T(a){function b(){a.layout()}var c=CKEDITOR.document.getWindow();c.on("resize",
b);a.on("hide",function(){c.removeListener("resize",b)})}function I(a,b){this._={dialog:a};CKEDITOR.tools.extend(this,b)}function U(a){function b(b){var c=a.getSize(),i=CKEDITOR.document.getWindow().getViewPaneSize(),o=b.data.$.screenX,j=b.data.$.screenY,n=o-e.x,k=j-e.y;e={x:o,y:j};d.x+=n;d.y+=k;a.move(d.x+h[3]<f?-h[3]:d.x-h[1]>i.width-c.width-f?i.width-c.width+("rtl"==g.lang.dir?0:h[1]):d.x,d.y+h[0]<f?-h[0]:d.y-h[2]>i.height-c.height-f?i.height-c.height+h[2]:d.y,1);b.data.preventDefault()}function c(){CKEDITOR.document.removeListener("mousemove",
b);CKEDITOR.document.removeListener("mouseup",c);if(CKEDITOR.env.ie6Compat){var a=q.getChild(0).getFrameDocument();a.removeListener("mousemove",b);a.removeListener("mouseup",c)}}var e=null,d=null,g=a.getParentEditor(),f=g.config.dialog_magnetDistance,h=CKEDITOR.skin.margins||[0,0,0,0];"undefined"==typeof f&&(f=20);a.parts.title.on("mousedown",function(f){e={x:f.data.$.screenX,y:f.data.$.screenY};CKEDITOR.document.on("mousemove",b);CKEDITOR.document.on("mouseup",c);d=a.getPosition();if(CKEDITOR.env.ie6Compat){var h=
q.getChild(0).getFrameDocument();h.on("mousemove",b);h.on("mouseup",c)}f.data.preventDefault()},a)}function V(a){var b,c;function e(d){var e="rtl"==h.lang.dir,j=o.width,C=o.height,D=j+(d.data.$.screenX-b)*(e?-1:1)*(a._.moved?1:2),n=C+(d.data.$.screenY-c)*(a._.moved?1:2),x=a._.element.getFirst(),x=e&&x.getComputedStyle("right"),y=a.getPosition();y.y+n>i.height&&(n=i.height-y.y);if((e?x:y.x)+D>i.width)D=i.width-(e?x:y.x);if(f==CKEDITOR.DIALOG_RESIZE_WIDTH||f==CKEDITOR.DIALOG_RESIZE_BOTH)j=Math.max(g.minWidth||
0,D-m);if(f==CKEDITOR.DIALOG_RESIZE_HEIGHT||f==CKEDITOR.DIALOG_RESIZE_BOTH)C=Math.max(g.minHeight||0,n-l);a.resize(j,C);a._.moved||a.layout();d.data.preventDefault()}function d(){CKEDITOR.document.removeListener("mouseup",d);CKEDITOR.document.removeListener("mousemove",e);j&&(j.remove(),j=null);if(CKEDITOR.env.ie6Compat){var a=q.getChild(0).getFrameDocument();a.removeListener("mouseup",d);a.removeListener("mousemove",e)}}var g=a.definition,f=g.resizable;if(f!=CKEDITOR.DIALOG_RESIZE_NONE){var h=a.getParentEditor(),
m,l,i,o,j,n=CKEDITOR.tools.addFunction(function(f){o=a.getSize();var h=a.parts.contents;h.$.getElementsByTagName("iframe").length&&(j=CKEDITOR.dom.element.createFromHtml('<div class="cke_dialog_resize_cover" style="height: 100%; position: absolute; width: 100%;"></div>'),h.append(j));l=o.height-a.parts.contents.getSize("height",!(CKEDITOR.env.gecko||CKEDITOR.env.ie&&CKEDITOR.env.quirks));m=o.width-a.parts.contents.getSize("width",1);b=f.screenX;c=f.screenY;i=CKEDITOR.document.getWindow().getViewPaneSize();
CKEDITOR.document.on("mousemove",e);CKEDITOR.document.on("mouseup",d);CKEDITOR.env.ie6Compat&&(h=q.getChild(0).getFrameDocument(),h.on("mousemove",e),h.on("mouseup",d));f.preventDefault&&f.preventDefault()});a.on("load",function(){var b="";f==CKEDITOR.DIALOG_RESIZE_WIDTH?b=" cke_resizer_horizontal":f==CKEDITOR.DIALOG_RESIZE_HEIGHT&&(b=" cke_resizer_vertical");b=CKEDITOR.dom.element.createFromHtml('<div class="cke_resizer'+b+" cke_resizer_"+h.lang.dir+'" title="'+CKEDITOR.tools.htmlEncode(h.lang.common.resize)+
'" onmousedown="CKEDITOR.tools.callFunction('+n+', event )">'+("ltr"==h.lang.dir?"◢":"◣")+"</div>");a.parts.footer.append(b,1)});h.on("destroy",function(){CKEDITOR.tools.removeFunction(n)})}}function E(a){a.data.preventDefault(1)}function J(a){var b=CKEDITOR.document.getWindow(),c=a.config,e=c.dialog_backgroundCoverColor||"white",d=c.dialog_backgroundCoverOpacity,g=c.baseFloatZIndex,c=CKEDITOR.tools.genKey(e,d,g),f=v[c];f?f.show():(g=['<div tabIndex="-1" style="position: ',CKEDITOR.env.ie6Compat?
"absolute":"fixed","; z-index: ",g,"; top: 0px; left: 0px; ",!CKEDITOR.env.ie6Compat?"background-color: "+e:"",'" class="cke_dialog_background_cover">'],CKEDITOR.env.ie6Compat&&(e="<html><body style=\\'background-color:"+e+";\\'></body></html>",g.push('<iframe hidefocus="true" frameborder="0" id="cke_dialog_background_iframe" src="javascript:'),g.push("void((function(){"+encodeURIComponent("document.open();("+CKEDITOR.tools.fixDomain+")();document.write( '"+e+"' );document.close();")+"})())"),g.push('" style="position:absolute;left:0;top:0;width:100%;height: 100%;filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0)"></iframe>')),
g.push("</div>"),f=CKEDITOR.dom.element.createFromHtml(g.join("")),f.setOpacity(void 0!==d?d:0.5),f.on("keydown",E),f.on("keypress",E),f.on("keyup",E),f.appendTo(CKEDITOR.document.getBody()),v[c]=f);a.focusManager.add(f);q=f;var a=function(){var a=b.getViewPaneSize();f.setStyles({width:a.width+"px",height:a.height+"px"})},h=function(){var a=b.getScrollPosition(),c=CKEDITOR.dialog._.currentTop;f.setStyles({left:a.x+"px",top:a.y+"px"});if(c){do{a=c.getPosition();c.move(a.x,a.y)}while(c=c._.parentDialog)
}};F=a;b.on("resize",a);a();(!CKEDITOR.env.mac||!CKEDITOR.env.webkit)&&f.focus();if(CKEDITOR.env.ie6Compat){var m=function(){h();arguments.callee.prevScrollHandler.apply(this,arguments)};b.$.setTimeout(function(){m.prevScrollHandler=window.onscroll||function(){};window.onscroll=m},0);h()}}function K(a){q&&(a.focusManager.remove(q),a=CKEDITOR.document.getWindow(),q.hide(),a.removeListener("resize",F),CKEDITOR.env.ie6Compat&&a.$.setTimeout(function(){window.onscroll=window.onscroll&&window.onscroll.prevScrollHandler||
null},0),F=null)}var r=CKEDITOR.tools.cssLength,S='<div class="cke_reset_all {editorId} {editorDialogClass} {hidpi}" dir="{langDir}" lang="{langCode}" role="dialog" aria-labelledby="cke_dialog_title_{id}"><table class="cke_dialog '+CKEDITOR.env.cssClass+' cke_{langDir}" style="position:absolute" role="presentation"><tr><td role="presentation"><div class="cke_dialog_body" role="presentation"><div id="cke_dialog_title_{id}" class="cke_dialog_title" role="presentation"></div><a id="cke_dialog_close_button_{id}" class="cke_dialog_close_button" href="javascript:void(0)" title="{closeTitle}" role="button"><span class="cke_label">X</span></a><div id="cke_dialog_tabs_{id}" class="cke_dialog_tabs" role="tablist"></div><table class="cke_dialog_contents" role="presentation"><tr><td id="cke_dialog_contents_{id}" class="cke_dialog_contents_body" role="presentation"></td></tr><tr><td id="cke_dialog_footer_{id}" class="cke_dialog_footer" role="presentation"></td></tr></table></div></td></tr></table></div>';
CKEDITOR.dialog=function(a,b){function c(){var a=k._.focusList;a.sort(function(a,b){return a.tabIndex!=b.tabIndex?b.tabIndex-a.tabIndex:a.focusIndex-b.focusIndex});for(var b=a.length,c=0;c<b;c++)a[c].focusIndex=c}function e(a){var b=k._.focusList,a=a||0;if(!(1>b.length)){var c=k._.currentFocusIndex;k._.tabBarMode&&0>a&&(c=0);try{b[c].getInputElement().$.blur()}catch(f){}var d=c,e=1<k._.pageCount;do{d+=a;if(e&&!k._.tabBarMode&&(d==b.length||-1==d)){k._.tabBarMode=!0;k._.tabs[k._.currentTabId][0].focus();
k._.currentFocusIndex=-1;return}d=(d+b.length)%b.length;if(d==c)break}while(a&&!b[d].isFocusable());b[d].focus();"text"==b[d].type&&b[d].select()}}function d(b){if(k==CKEDITOR.dialog._.currentTop){var c=b.data.getKeystroke(),d="rtl"==a.lang.dir,f=[37,38,39,40];o=j=0;if(9==c||c==CKEDITOR.SHIFT+9)e(c==CKEDITOR.SHIFT+9?-1:1),o=1;else if(c==CKEDITOR.ALT+121&&!k._.tabBarMode&&1<k.getPageCount())k._.tabBarMode=!0,k._.tabs[k._.currentTabId][0].focus(),k._.currentFocusIndex=-1,o=1;else if(-1!=CKEDITOR.tools.indexOf(f,
c)&&k._.tabBarMode)c=-1!=CKEDITOR.tools.indexOf([d?39:37,38],c)?t.call(k):w.call(k),k.selectPage(c),k._.tabs[c][0].focus(),o=1;else if((13==c||32==c)&&k._.tabBarMode)this.selectPage(this._.currentTabId),this._.tabBarMode=!1,this._.currentFocusIndex=-1,e(1),o=1;else if(13==c){c=b.data.getTarget();if(!c.is("a","button","select","textarea")&&(!c.is("input")||"button"!=c.$.type))(c=this.getButton("ok"))&&CKEDITOR.tools.setTimeout(c.click,0,c),o=1;j=1}else if(27==c)(c=this.getButton("cancel"))?CKEDITOR.tools.setTimeout(c.click,
0,c):!1!==this.fire("cancel",{hide:!0}).hide&&this.hide(),j=1;else return;g(b)}}function g(a){o?a.data.preventDefault(1):j&&a.data.stopPropagation()}var f=CKEDITOR.dialog._.dialogDefinitions[b],h=CKEDITOR.tools.clone(W),m=a.config.dialog_buttonsOrder||"OS",l=a.lang.dir,i={},o,j;("OS"==m&&CKEDITOR.env.mac||"rtl"==m&&"ltr"==l||"ltr"==m&&"rtl"==l)&&h.buttons.reverse();f=CKEDITOR.tools.extend(f(a),h);f=CKEDITOR.tools.clone(f);f=new L(this,f);h=R(a);this._={editor:a,element:h.element,name:b,contentSize:{width:0,
height:0},size:{width:0,height:0},contents:{},buttons:{},accessKeyMap:{},tabs:{},tabIdList:[],currentTabId:null,currentTabIndex:null,pageCount:0,lastTab:null,tabBarMode:!1,focusList:[],currentFocusIndex:0,hasFocus:!1};this.parts=h.parts;CKEDITOR.tools.setTimeout(function(){a.fire("ariaWidget",this.parts.contents)},0,this);h={position:CKEDITOR.env.ie6Compat?"absolute":"fixed",top:0,visibility:"hidden"};h["rtl"==l?"right":"left"]=0;this.parts.dialog.setStyles(h);CKEDITOR.event.call(this);this.definition=
f=CKEDITOR.fire("dialogDefinition",{name:b,definition:f},a).definition;if(!("removeDialogTabs"in a._)&&a.config.removeDialogTabs){h=a.config.removeDialogTabs.split(";");for(l=0;l<h.length;l++)if(m=h[l].split(":"),2==m.length){var n=m[0];i[n]||(i[n]=[]);i[n].push(m[1])}a._.removeDialogTabs=i}if(a._.removeDialogTabs&&(i=a._.removeDialogTabs[b]))for(l=0;l<i.length;l++)f.removeContents(i[l]);if(f.onLoad)this.on("load",f.onLoad);if(f.onShow)this.on("show",f.onShow);if(f.onHide)this.on("hide",f.onHide);
if(f.onOk)this.on("ok",function(b){a.fire("saveSnapshot");setTimeout(function(){a.fire("saveSnapshot")},0);!1===f.onOk.call(this,b)&&(b.data.hide=!1)});this.state=CKEDITOR.DIALOG_STATE_IDLE;if(f.onCancel)this.on("cancel",function(a){!1===f.onCancel.call(this,a)&&(a.data.hide=!1)});var k=this,p=function(a){var b=k._.contents,c=!1,d;for(d in b)for(var f in b[d])if(c=a.call(this,b[d][f]))return};this.on("ok",function(a){p(function(b){if(b.validate){var c=b.validate(this),d="string"==typeof c||!1===c;
d&&(a.data.hide=!1,a.stop());P.call(b,!d,"string"==typeof c?c:void 0);return d}})},this,null,0);this.on("cancel",function(b){p(function(c){if(c.isChanged())return!a.config.dialog_noConfirmCancel&&!confirm(a.lang.common.confirmCancel)&&(b.data.hide=!1),!0})},this,null,0);this.parts.close.on("click",function(a){!1!==this.fire("cancel",{hide:!0}).hide&&this.hide();a.data.preventDefault()},this);this.changeFocus=e;var u=this._.element;a.focusManager.add(u,1);this.on("show",function(){u.on("keydown",d,
this);if(CKEDITOR.env.gecko)u.on("keypress",g,this)});this.on("hide",function(){u.removeListener("keydown",d);CKEDITOR.env.gecko&&u.removeListener("keypress",g);p(function(a){Q.apply(a)})});this.on("iframeAdded",function(a){(new CKEDITOR.dom.document(a.data.iframe.$.contentWindow.document)).on("keydown",d,this,null,0)});this.on("show",function(){c();var b=1<k._.pageCount;a.config.dialog_startupFocusTab&&b?(k._.tabBarMode=!0,k._.tabs[k._.currentTabId][0].focus(),k._.currentFocusIndex=-1):this._.hasFocus||
(this._.currentFocusIndex=b?-1:this._.focusList.length-1,f.onFocus?(b=f.onFocus.call(this))&&b.focus():e(1))},this,null,4294967295);if(CKEDITOR.env.ie6Compat)this.on("load",function(){var a=this.getElement(),b=a.getFirst();b.remove();b.appendTo(a)},this);U(this);V(this);(new CKEDITOR.dom.text(f.title,CKEDITOR.document)).appendTo(this.parts.title);for(l=0;l<f.contents.length;l++)(i=f.contents[l])&&this.addPage(i);this.parts.tabs.on("click",function(a){var b=a.data.getTarget();b.hasClass("cke_dialog_tab")&&
(b=b.$.id,this.selectPage(b.substring(4,b.lastIndexOf("_"))),this._.tabBarMode&&(this._.tabBarMode=!1,this._.currentFocusIndex=-1,e(1)),a.data.preventDefault())},this);l=[];i=CKEDITOR.dialog._.uiElementBuilders.hbox.build(this,{type:"hbox",className:"cke_dialog_footer_buttons",widths:[],children:f.buttons},l).getChild();this.parts.footer.setHtml(l.join(""));for(l=0;l<i.length;l++)this._.buttons[i[l].id]=i[l]};CKEDITOR.dialog.prototype={destroy:function(){this.hide();this._.element.remove()},resize:function(){return function(a,
b){if(!this._.contentSize||!(this._.contentSize.width==a&&this._.contentSize.height==b))CKEDITOR.dialog.fire("resize",{dialog:this,width:a,height:b},this._.editor),this.fire("resize",{width:a,height:b},this._.editor),this.parts.contents.setStyles({width:a+"px",height:b+"px"}),"rtl"==this._.editor.lang.dir&&this._.position&&(this._.position.x=CKEDITOR.document.getWindow().getViewPaneSize().width-this._.contentSize.width-parseInt(this._.element.getFirst().getStyle("right"),10)),this._.contentSize={width:a,
height:b}}}(),getSize:function(){var a=this._.element.getFirst();return{width:a.$.offsetWidth||0,height:a.$.offsetHeight||0}},move:function(a,b,c){var e=this._.element.getFirst(),d="rtl"==this._.editor.lang.dir,g="fixed"==e.getComputedStyle("position");CKEDITOR.env.ie&&e.setStyle("zoom","100%");if(!g||!this._.position||!(this._.position.x==a&&this._.position.y==b))this._.position={x:a,y:b},g||(g=CKEDITOR.document.getWindow().getScrollPosition(),a+=g.x,b+=g.y),d&&(g=this.getSize(),a=CKEDITOR.document.getWindow().getViewPaneSize().width-
g.width-a),b={top:(0<b?b:0)+"px"},b[d?"right":"left"]=(0<a?a:0)+"px",e.setStyles(b),c&&(this._.moved=1)},getPosition:function(){return CKEDITOR.tools.extend({},this._.position)},show:function(){var a=this._.element,b=this.definition;!a.getParent()||!a.getParent().equals(CKEDITOR.document.getBody())?a.appendTo(CKEDITOR.document.getBody()):a.setStyle("display","block");this.resize(this._.contentSize&&this._.contentSize.width||b.width||b.minWidth,this._.contentSize&&this._.contentSize.height||b.height||
b.minHeight);this.reset();this.selectPage(this.definition.contents[0].id);null===CKEDITOR.dialog._.currentZIndex&&(CKEDITOR.dialog._.currentZIndex=this._.editor.config.baseFloatZIndex);this._.element.getFirst().setStyle("z-index",CKEDITOR.dialog._.currentZIndex+=10);null===CKEDITOR.dialog._.currentTop?(CKEDITOR.dialog._.currentTop=this,this._.parentDialog=null,J(this._.editor)):(this._.parentDialog=CKEDITOR.dialog._.currentTop,this._.parentDialog.getElement().getFirst().$.style.zIndex-=Math.floor(this._.editor.config.baseFloatZIndex/
2),CKEDITOR.dialog._.currentTop=this);a.on("keydown",M);a.on("keyup",N);this._.hasFocus=!1;for(var c in b.contents)if(b.contents[c]){var a=b.contents[c],e=this._.tabs[a.id],d=a.requiredContent,g=0;if(e){for(var f in this._.contents[a.id]){var h=this._.contents[a.id][f];"hbox"==h.type||("vbox"==h.type||!h.getInputElement())||(h.requiredContent&&!this._.editor.activeFilter.check(h.requiredContent)?h.disable():(h.enable(),g++))}!g||d&&!this._.editor.activeFilter.check(d)?e[0].addClass("cke_dialog_tab_disabled"):
e[0].removeClass("cke_dialog_tab_disabled")}}CKEDITOR.tools.setTimeout(function(){this.layout();T(this);this.parts.dialog.setStyle("visibility","");this.fireOnce("load",{});CKEDITOR.ui.fire("ready",this);this.fire("show",{});this._.editor.fire("dialogShow",this);this._.parentDialog||this._.editor.focusManager.lock();this.foreach(function(a){a.setInitValue&&a.setInitValue()})},100,this)},layout:function(){var a=this.parts.dialog,b=this.getSize(),c=CKEDITOR.document.getWindow().getViewPaneSize(),e=
(c.width-b.width)/2,d=(c.height-b.height)/2;CKEDITOR.env.ie6Compat||(b.height+(0<d?d:0)>c.height||b.width+(0<e?e:0)>c.width?a.setStyle("position","absolute"):a.setStyle("position","fixed"));this.move(this._.moved?this._.position.x:e,this._.moved?this._.position.y:d)},foreach:function(a){for(var b in this._.contents)for(var c in this._.contents[b])a.call(this,this._.contents[b][c]);return this},reset:function(){var a=function(a){a.reset&&a.reset(1)};return function(){this.foreach(a);return this}}(),
setupContent:function(){var a=arguments;this.foreach(function(b){b.setup&&b.setup.apply(b,a)})},commitContent:function(){var a=arguments;this.foreach(function(b){CKEDITOR.env.ie&&this._.currentFocusIndex==b.focusIndex&&b.getInputElement().$.blur();b.commit&&b.commit.apply(b,a)})},hide:function(){if(this.parts.dialog.isVisible()){this.fire("hide",{});this._.editor.fire("dialogHide",this);this.selectPage(this._.tabIdList[0]);var a=this._.element;a.setStyle("display","none");this.parts.dialog.setStyle("visibility",
"hidden");for(X(this);CKEDITOR.dialog._.currentTop!=this;)CKEDITOR.dialog._.currentTop.hide();if(this._.parentDialog){var b=this._.parentDialog.getElement().getFirst();b.setStyle("z-index",parseInt(b.$.style.zIndex,10)+Math.floor(this._.editor.config.baseFloatZIndex/2))}else K(this._.editor);if(CKEDITOR.dialog._.currentTop=this._.parentDialog)CKEDITOR.dialog._.currentZIndex-=10;else{CKEDITOR.dialog._.currentZIndex=null;a.removeListener("keydown",M);a.removeListener("keyup",N);var c=this._.editor;
c.focus();setTimeout(function(){c.focusManager.unlock();CKEDITOR.env.iOS&&c.window.focus()},0)}delete this._.parentDialog;this.foreach(function(a){a.resetInitValue&&a.resetInitValue()});this.setState(CKEDITOR.DIALOG_STATE_IDLE)}},addPage:function(a){if(!a.requiredContent||this._.editor.filter.check(a.requiredContent)){for(var b=[],c=a.label?' title="'+CKEDITOR.tools.htmlEncode(a.label)+'"':"",e=CKEDITOR.dialog._.uiElementBuilders.vbox.build(this,{type:"vbox",className:"cke_dialog_page_contents",children:a.elements,
expand:!!a.expand,padding:a.padding,style:a.style||"width: 100%;"},b),d=this._.contents[a.id]={},g=e.getChild(),f=0;e=g.shift();)!e.notAllowed&&("hbox"!=e.type&&"vbox"!=e.type)&&f++,d[e.id]=e,"function"==typeof e.getChild&&g.push.apply(g,e.getChild());f||(a.hidden=!0);b=CKEDITOR.dom.element.createFromHtml(b.join(""));b.setAttribute("role","tabpanel");e=CKEDITOR.env;d="cke_"+a.id+"_"+CKEDITOR.tools.getNextNumber();c=CKEDITOR.dom.element.createFromHtml(['<a class="cke_dialog_tab"',0<this._.pageCount?
" cke_last":"cke_first",c,a.hidden?' style="display:none"':"",' id="',d,'"',e.gecko&&!e.hc?"":' href="javascript:void(0)"',' tabIndex="-1" hidefocus="true" role="tab">',a.label,"</a>"].join(""));b.setAttribute("aria-labelledby",d);this._.tabs[a.id]=[c,b];this._.tabIdList.push(a.id);!a.hidden&&this._.pageCount++;this._.lastTab=c;this.updateStyle();b.setAttribute("name",a.id);b.appendTo(this.parts.contents);c.unselectable();this.parts.tabs.append(c);a.accessKey&&(O(this,this,"CTRL+"+a.accessKey,Y,Z),
this._.accessKeyMap["CTRL+"+a.accessKey]=a.id)}},selectPage:function(a){if(this._.currentTabId!=a&&!this._.tabs[a][0].hasClass("cke_dialog_tab_disabled")&&!1!==this.fire("selectPage",{page:a,currentPage:this._.currentTabId})){for(var b in this._.tabs){var c=this._.tabs[b][0],e=this._.tabs[b][1];b!=a&&(c.removeClass("cke_dialog_tab_selected"),e.hide());e.setAttribute("aria-hidden",b!=a)}var d=this._.tabs[a];d[0].addClass("cke_dialog_tab_selected");CKEDITOR.env.ie6Compat||CKEDITOR.env.ie7Compat?(G(d[1]),
d[1].show(),setTimeout(function(){G(d[1],1)},0)):d[1].show();this._.currentTabId=a;this._.currentTabIndex=CKEDITOR.tools.indexOf(this._.tabIdList,a)}},updateStyle:function(){this.parts.dialog[(1===this._.pageCount?"add":"remove")+"Class"]("cke_single_page")},hidePage:function(a){var b=this._.tabs[a]&&this._.tabs[a][0];b&&(1!=this._.pageCount&&b.isVisible())&&(a==this._.currentTabId&&this.selectPage(t.call(this)),b.hide(),this._.pageCount--,this.updateStyle())},showPage:function(a){if(a=this._.tabs[a]&&
this._.tabs[a][0])a.show(),this._.pageCount++,this.updateStyle()},getElement:function(){return this._.element},getName:function(){return this._.name},getContentElement:function(a,b){var c=this._.contents[a];return c&&c[b]},getValueOf:function(a,b){return this.getContentElement(a,b).getValue()},setValueOf:function(a,b,c){return this.getContentElement(a,b).setValue(c)},getButton:function(a){return this._.buttons[a]},click:function(a){return this._.buttons[a].click()},disableButton:function(a){return this._.buttons[a].disable()},
enableButton:function(a){return this._.buttons[a].enable()},getPageCount:function(){return this._.pageCount},getParentEditor:function(){return this._.editor},getSelectedElement:function(){return this.getParentEditor().getSelection().getSelectedElement()},addFocusable:function(a,b){if("undefined"==typeof b)b=this._.focusList.length,this._.focusList.push(new H(this,a,b));else{this._.focusList.splice(b,0,new H(this,a,b));for(var c=b+1;c<this._.focusList.length;c++)this._.focusList[c].focusIndex++}},
setState:function(a){if(this.state!=a){this.state=a;if(a==CKEDITOR.DIALOG_STATE_BUSY){if(!this.parts.spinner){var b=this.getParentEditor().lang.dir,c={attributes:{"class":"cke_dialog_spinner"},styles:{"float":"rtl"==b?"right":"left"}};c.styles["margin-"+("rtl"==b?"left":"right")]="8px";this.parts.spinner=CKEDITOR.document.createElement("div",c);this.parts.spinner.setHtml("&#8987;");this.parts.spinner.appendTo(this.parts.title,1)}this.parts.spinner.show();this.getButton("ok").disable()}else a==CKEDITOR.DIALOG_STATE_IDLE&&
(this.parts.spinner&&this.parts.spinner.hide(),this.getButton("ok").enable());this.fire("state",a)}}};CKEDITOR.tools.extend(CKEDITOR.dialog,{add:function(a,b){if(!this._.dialogDefinitions[a]||"function"==typeof b)this._.dialogDefinitions[a]=b},exists:function(a){return!!this._.dialogDefinitions[a]},getCurrent:function(){return CKEDITOR.dialog._.currentTop},isTabEnabled:function(a,b,c){a=a.config.removeDialogTabs;return!(a&&a.match(RegExp("(?:^|;)"+b+":"+c+"(?:$|;)","i")))},okButton:function(){var a=
function(a,c){c=c||{};return CKEDITOR.tools.extend({id:"ok",type:"button",label:a.lang.common.ok,"class":"cke_dialog_ui_button_ok",onClick:function(a){a=a.data.dialog;!1!==a.fire("ok",{hide:!0}).hide&&a.hide()}},c,!0)};a.type="button";a.override=function(b){return CKEDITOR.tools.extend(function(c){return a(c,b)},{type:"button"},!0)};return a}(),cancelButton:function(){var a=function(a,c){c=c||{};return CKEDITOR.tools.extend({id:"cancel",type:"button",label:a.lang.common.cancel,"class":"cke_dialog_ui_button_cancel",
onClick:function(a){a=a.data.dialog;!1!==a.fire("cancel",{hide:!0}).hide&&a.hide()}},c,!0)};a.type="button";a.override=function(b){return CKEDITOR.tools.extend(function(c){return a(c,b)},{type:"button"},!0)};return a}(),addUIElement:function(a,b){this._.uiElementBuilders[a]=b}});CKEDITOR.dialog._={uiElementBuilders:{},dialogDefinitions:{},currentTop:null,currentZIndex:null};CKEDITOR.event.implementOn(CKEDITOR.dialog);CKEDITOR.event.implementOn(CKEDITOR.dialog.prototype);var W={resizable:CKEDITOR.DIALOG_RESIZE_BOTH,
minWidth:600,minHeight:400,buttons:[CKEDITOR.dialog.okButton,CKEDITOR.dialog.cancelButton]},z=function(a,b,c){for(var e=0,d;d=a[e];e++)if(d.id==b||c&&d[c]&&(d=z(d[c],b,c)))return d;return null},A=function(a,b,c,e,d){if(c){for(var g=0,f;f=a[g];g++){if(f.id==c)return a.splice(g,0,b),b;if(e&&f[e]&&(f=A(f[e],b,c,e,!0)))return f}if(d)return null}a.push(b);return b},B=function(a,b,c){for(var e=0,d;d=a[e];e++){if(d.id==b)return a.splice(e,1);if(c&&d[c]&&(d=B(d[c],b,c)))return d}return null},L=function(a,
b){this.dialog=a;for(var c=b.contents,e=0,d;d=c[e];e++)c[e]=d&&new I(a,d);CKEDITOR.tools.extend(this,b)};L.prototype={getContents:function(a){return z(this.contents,a)},getButton:function(a){return z(this.buttons,a)},addContents:function(a,b){return A(this.contents,a,b)},addButton:function(a,b){return A(this.buttons,a,b)},removeContents:function(a){B(this.contents,a)},removeButton:function(a){B(this.buttons,a)}};I.prototype={get:function(a){return z(this.elements,a,"children")},add:function(a,b){return A(this.elements,
a,b,"children")},remove:function(a){B(this.elements,a,"children")}};var F,v={},q,s={},M=function(a){var b=a.data.$.ctrlKey||a.data.$.metaKey,c=a.data.$.altKey,e=a.data.$.shiftKey,d=String.fromCharCode(a.data.$.keyCode);if((b=s[(b?"CTRL+":"")+(c?"ALT+":"")+(e?"SHIFT+":"")+d])&&b.length)b=b[b.length-1],b.keydown&&b.keydown.call(b.uiElement,b.dialog,b.key),a.data.preventDefault()},N=function(a){var b=a.data.$.ctrlKey||a.data.$.metaKey,c=a.data.$.altKey,e=a.data.$.shiftKey,d=String.fromCharCode(a.data.$.keyCode);
if((b=s[(b?"CTRL+":"")+(c?"ALT+":"")+(e?"SHIFT+":"")+d])&&b.length)b=b[b.length-1],b.keyup&&(b.keyup.call(b.uiElement,b.dialog,b.key),a.data.preventDefault())},O=function(a,b,c,e,d){(s[c]||(s[c]=[])).push({uiElement:a,dialog:b,key:c,keyup:d||a.accessKeyUp,keydown:e||a.accessKeyDown})},X=function(a){for(var b in s){for(var c=s[b],e=c.length-1;0<=e;e--)(c[e].dialog==a||c[e].uiElement==a)&&c.splice(e,1);0===c.length&&delete s[b]}},Z=function(a,b){a._.accessKeyMap[b]&&a.selectPage(a._.accessKeyMap[b])},
Y=function(){};(function(){CKEDITOR.ui.dialog={uiElement:function(a,b,c,e,d,g,f){if(!(4>arguments.length)){var h=(e.call?e(b):e)||"div",m=["<",h," "],l=(d&&d.call?d(b):d)||{},i=(g&&g.call?g(b):g)||{},o=(f&&f.call?f.call(this,a,b):f)||"",j=this.domId=i.id||CKEDITOR.tools.getNextId()+"_uiElement";b.requiredContent&&!a.getParentEditor().filter.check(b.requiredContent)&&(l.display="none",this.notAllowed=!0);i.id=j;var n={};b.type&&(n["cke_dialog_ui_"+b.type]=1);b.className&&(n[b.className]=1);b.disabled&&
(n.cke_disabled=1);for(var k=i["class"]&&i["class"].split?i["class"].split(" "):[],j=0;j<k.length;j++)k[j]&&(n[k[j]]=1);k=[];for(j in n)k.push(j);i["class"]=k.join(" ");b.title&&(i.title=b.title);n=(b.style||"").split(";");b.align&&(k=b.align,l["margin-left"]="left"==k?0:"auto",l["margin-right"]="right"==k?0:"auto");for(j in l)n.push(j+":"+l[j]);b.hidden&&n.push("display:none");for(j=n.length-1;0<=j;j--)""===n[j]&&n.splice(j,1);0<n.length&&(i.style=(i.style?i.style+"; ":"")+n.join("; "));for(j in i)m.push(j+
'="'+CKEDITOR.tools.htmlEncode(i[j])+'" ');m.push(">",o,"</",h,">");c.push(m.join(""));(this._||(this._={})).dialog=a;"boolean"==typeof b.isChanged&&(this.isChanged=function(){return b.isChanged});"function"==typeof b.isChanged&&(this.isChanged=b.isChanged);"function"==typeof b.setValue&&(this.setValue=CKEDITOR.tools.override(this.setValue,function(a){return function(c){a.call(this,b.setValue.call(this,c))}}));"function"==typeof b.getValue&&(this.getValue=CKEDITOR.tools.override(this.getValue,function(a){return function(){return b.getValue.call(this,
a.call(this))}}));CKEDITOR.event.implementOn(this);this.registerEvents(b);this.accessKeyUp&&(this.accessKeyDown&&b.accessKey)&&O(this,a,"CTRL+"+b.accessKey);var p=this;a.on("load",function(){var b=p.getInputElement();if(b){var c=p.type in{checkbox:1,ratio:1}&&CKEDITOR.env.ie&&CKEDITOR.env.version<8?"cke_dialog_ui_focused":"";b.on("focus",function(){a._.tabBarMode=false;a._.hasFocus=true;p.fire("focus");c&&this.addClass(c)});b.on("blur",function(){p.fire("blur");c&&this.removeClass(c)})}});CKEDITOR.tools.extend(this,
b);this.keyboardFocusable&&(this.tabIndex=b.tabIndex||0,this.focusIndex=a._.focusList.push(this)-1,this.on("focus",function(){a._.currentFocusIndex=p.focusIndex}))}},hbox:function(a,b,c,e,d){if(!(4>arguments.length)){this._||(this._={});var g=this._.children=b,f=d&&d.widths||null,h=d&&d.height||null,m,l={role:"presentation"};d&&d.align&&(l.align=d.align);CKEDITOR.ui.dialog.uiElement.call(this,a,d||{type:"hbox"},e,"table",{},l,function(){var a=['<tbody><tr class="cke_dialog_ui_hbox">'];for(m=0;m<c.length;m++){var b=
"cke_dialog_ui_hbox_child",e=[];0===m&&(b="cke_dialog_ui_hbox_first");m==c.length-1&&(b="cke_dialog_ui_hbox_last");a.push('<td class="',b,'" role="presentation" ');f?f[m]&&e.push("width:"+r(f[m])):e.push("width:"+Math.floor(100/c.length)+"%");h&&e.push("height:"+r(h));d&&void 0!==d.padding&&e.push("padding:"+r(d.padding));CKEDITOR.env.ie&&(CKEDITOR.env.quirks&&g[m].align)&&e.push("text-align:"+g[m].align);0<e.length&&a.push('style="'+e.join("; ")+'" ');a.push(">",c[m],"</td>")}a.push("</tr></tbody>");
return a.join("")})}},vbox:function(a,b,c,e,d){if(!(3>arguments.length)){this._||(this._={});var g=this._.children=b,f=d&&d.width||null,h=d&&d.heights||null;CKEDITOR.ui.dialog.uiElement.call(this,a,d||{type:"vbox"},e,"div",null,{role:"presentation"},function(){var b=['<table role="presentation" cellspacing="0" border="0" '];b.push('style="');d&&d.expand&&b.push("height:100%;");b.push("width:"+r(f||"100%"),";");CKEDITOR.env.webkit&&b.push("float:none;");b.push('"');b.push('align="',CKEDITOR.tools.htmlEncode(d&&
d.align||("ltr"==a.getParentEditor().lang.dir?"left":"right")),'" ');b.push("><tbody>");for(var e=0;e<c.length;e++){var i=[];b.push('<tr><td role="presentation" ');f&&i.push("width:"+r(f||"100%"));h?i.push("height:"+r(h[e])):d&&d.expand&&i.push("height:"+Math.floor(100/c.length)+"%");d&&void 0!==d.padding&&i.push("padding:"+r(d.padding));CKEDITOR.env.ie&&(CKEDITOR.env.quirks&&g[e].align)&&i.push("text-align:"+g[e].align);0<i.length&&b.push('style="',i.join("; "),'" ');b.push(' class="cke_dialog_ui_vbox_child">',
c[e],"</td></tr>")}b.push("</tbody></table>");return b.join("")})}}}})();CKEDITOR.ui.dialog.uiElement.prototype={getElement:function(){return CKEDITOR.document.getById(this.domId)},getInputElement:function(){return this.getElement()},getDialog:function(){return this._.dialog},setValue:function(a,b){this.getInputElement().setValue(a);!b&&this.fire("change",{value:a});return this},getValue:function(){return this.getInputElement().getValue()},isChanged:function(){return!1},selectParentTab:function(){for(var a=
this.getInputElement();(a=a.getParent())&&-1==a.$.className.search("cke_dialog_page_contents"););if(!a)return this;a=a.getAttribute("name");this._.dialog._.currentTabId!=a&&this._.dialog.selectPage(a);return this},focus:function(){this.selectParentTab().getInputElement().focus();return this},registerEvents:function(a){var b=/^on([A-Z]\w+)/,c,e=function(a,b,c,d){b.on("load",function(){a.getInputElement().on(c,d,a)})},d;for(d in a)if(c=d.match(b))this.eventProcessors[d]?this.eventProcessors[d].call(this,
this._.dialog,a[d]):e(this,this._.dialog,c[1].toLowerCase(),a[d]);return this},eventProcessors:{onLoad:function(a,b){a.on("load",b,this)},onShow:function(a,b){a.on("show",b,this)},onHide:function(a,b){a.on("hide",b,this)}},accessKeyDown:function(){this.focus()},accessKeyUp:function(){},disable:function(){var a=this.getElement();this.getInputElement().setAttribute("disabled","true");a.addClass("cke_disabled")},enable:function(){var a=this.getElement();this.getInputElement().removeAttribute("disabled");
a.removeClass("cke_disabled")},isEnabled:function(){return!this.getElement().hasClass("cke_disabled")},isVisible:function(){return this.getInputElement().isVisible()},isFocusable:function(){return!this.isEnabled()||!this.isVisible()?!1:!0}};CKEDITOR.ui.dialog.hbox.prototype=CKEDITOR.tools.extend(new CKEDITOR.ui.dialog.uiElement,{getChild:function(a){if(1>arguments.length)return this._.children.concat();a.splice||(a=[a]);return 2>a.length?this._.children[a[0]]:this._.children[a[0]]&&this._.children[a[0]].getChild?
this._.children[a[0]].getChild(a.slice(1,a.length)):null}},!0);CKEDITOR.ui.dialog.vbox.prototype=new CKEDITOR.ui.dialog.hbox;(function(){var a={build:function(a,c,e){for(var d=c.children,g,f=[],h=[],m=0;m<d.length&&(g=d[m]);m++){var l=[];f.push(l);h.push(CKEDITOR.dialog._.uiElementBuilders[g.type].build(a,g,l))}return new CKEDITOR.ui.dialog[c.type](a,h,f,e,c)}};CKEDITOR.dialog.addUIElement("hbox",a);CKEDITOR.dialog.addUIElement("vbox",a)})();CKEDITOR.dialogCommand=function(a,b){this.dialogName=a;
CKEDITOR.tools.extend(this,b,!0)};CKEDITOR.dialogCommand.prototype={exec:function(a){a.openDialog(this.dialogName)},canUndo:!1,editorFocus:1};(function(){var a=/^([a]|[^a])+$/,b=/^\d*$/,c=/^\d*(?:\.\d+)?$/,e=/^(((\d*(\.\d+))|(\d*))(px|\%)?)?$/,d=/^(((\d*(\.\d+))|(\d*))(px|em|ex|in|cm|mm|pt|pc|\%)?)?$/i,g=/^(\s*[\w-]+\s*:\s*[^:;]+(?:;|$))*$/;CKEDITOR.VALIDATE_OR=1;CKEDITOR.VALIDATE_AND=2;CKEDITOR.dialog.validate={functions:function(){var a=arguments;return function(){var b=this&&this.getValue?this.getValue():
a[0],c,d=CKEDITOR.VALIDATE_AND,e=[],g;for(g=0;g<a.length;g++)if("function"==typeof a[g])e.push(a[g]);else break;g<a.length&&"string"==typeof a[g]&&(c=a[g],g++);g<a.length&&"number"==typeof a[g]&&(d=a[g]);var j=d==CKEDITOR.VALIDATE_AND?!0:!1;for(g=0;g<e.length;g++)j=d==CKEDITOR.VALIDATE_AND?j&&e[g](b):j||e[g](b);return!j?c:!0}},regex:function(a,b){return function(c){c=this&&this.getValue?this.getValue():c;return!a.test(c)?b:!0}},notEmpty:function(b){return this.regex(a,b)},integer:function(a){return this.regex(b,
a)},number:function(a){return this.regex(c,a)},cssLength:function(a){return this.functions(function(a){return d.test(CKEDITOR.tools.trim(a))},a)},htmlLength:function(a){return this.functions(function(a){return e.test(CKEDITOR.tools.trim(a))},a)},inlineStyle:function(a){return this.functions(function(a){return g.test(CKEDITOR.tools.trim(a))},a)},equals:function(a,b){return this.functions(function(b){return b==a},b)},notEqual:function(a,b){return this.functions(function(b){return b!=a},b)}};CKEDITOR.on("instanceDestroyed",
function(a){if(CKEDITOR.tools.isEmpty(CKEDITOR.instances)){for(var b;b=CKEDITOR.dialog._.currentTop;)b.hide();for(var c in v)v[c].remove();v={}}var a=a.editor._.storedDialogs,d;for(d in a)a[d].destroy()})})();CKEDITOR.tools.extend(CKEDITOR.editor.prototype,{openDialog:function(a,b){var c=null,e=CKEDITOR.dialog._.dialogDefinitions[a];null===CKEDITOR.dialog._.currentTop&&J(this);if("function"==typeof e)c=this._.storedDialogs||(this._.storedDialogs={}),c=c[a]||(c[a]=new CKEDITOR.dialog(this,a)),b&&b.call(c,
c),c.show();else{if("failed"==e)throw K(this),Error('[CKEDITOR.dialog.openDialog] Dialog "'+a+'" failed when loading definition.');"string"==typeof e&&CKEDITOR.scriptLoader.load(CKEDITOR.getUrl(e),function(){"function"!=typeof CKEDITOR.dialog._.dialogDefinitions[a]&&(CKEDITOR.dialog._.dialogDefinitions[a]="failed");this.openDialog(a,b)},this,0,1)}CKEDITOR.skin.loadPart("dialog");return c}})})();
CKEDITOR.plugins.add("dialog",{requires:"dialogui",init:function(t){t.on("doubleclick",function(w){w.data.dialog&&t.openDialog(w.data.dialog)},null,null,999)}});(function(){function o(b,a,c){a.type||(a.type="auto");if(c&&!1===b.fire("beforePaste",a)||!a.dataValue&&a.dataTransfer.isEmpty())return!1;a.dataValue||(a.dataValue="");if(CKEDITOR.env.gecko&&"drop"==a.method&&b.toolbox)b.once("afterPaste",function(){b.toolbox.focus()});return b.fire("paste",a)}function v(b){function a(){var a=b.editable();if(CKEDITOR.plugins.clipboard.isCustomCopyCutSupported){var d=function(a){k.initPasteDataTransfer(a,b);a.data.preventDefault()};a.on("copy",d);a.on("cut",d);a.on("cut",
function(){b.extractSelectedHtml()},null,null,999)}a.on(k.mainPasteEvent,function(b){"beforepaste"==k.mainPasteEvent&&m||l(b)});"beforepaste"==k.mainPasteEvent&&(a.on("paste",function(a){r||(e(),a.data.preventDefault(),l(a),f("paste")||b.openDialog("paste"))}),a.on("contextmenu",g,null,null,0),a.on("beforepaste",function(b){b.data&&(!b.data.$.ctrlKey&&!b.data.$.shiftKey)&&g()},null,null,0));a.on("beforecut",function(){!m&&h(b)});var c;a.attachListener(CKEDITOR.env.ie?a:b.document.getDocumentElement(),
"mouseup",function(){c=setTimeout(function(){p()},0)});b.on("destroy",function(){clearTimeout(c)});a.on("keyup",p)}function c(a){return{type:a,canUndo:"cut"==a,startDisabled:!0,exec:function(){"cut"==this.type&&h();var a;var d=this.type;if(CKEDITOR.env.ie)a=f(d);else try{a=b.document.$.execCommand(d,!1,null)}catch(c){a=!1}a||b.showNotification(b.lang.clipboard[this.type+"Error"]);return a}}}function d(){return{canUndo:!1,async:!0,exec:function(b,a){var d=function(a,d){a&&o(b,a,!!d);b.fire("afterCommandExec",
{name:"paste",command:c,returnValue:!!a})},c=this;"string"==typeof a?d({dataValue:a,method:"paste",dataTransfer:k.initPasteDataTransfer()},1):b.getClipboardData(d)}}}function e(){r=1;setTimeout(function(){r=0},100)}function g(){m=1;setTimeout(function(){m=0},10)}function f(a){var d=b.document,c=d.getBody(),e=!1,f=function(){e=!0};c.on(a,f);7<CKEDITOR.env.version?d.$.execCommand(a):d.$.selection.createRange().execCommand(a);c.removeListener(a,f);return e}function h(){if(CKEDITOR.env.ie&&!CKEDITOR.env.quirks){var a=
b.getSelection(),d,c,e;if(a.getType()==CKEDITOR.SELECTION_ELEMENT&&(d=a.getSelectedElement()))c=a.getRanges()[0],e=b.document.createText(""),e.insertBefore(d),c.setStartBefore(e),c.setEndAfter(d),a.selectRanges([c]),setTimeout(function(){d.getParent()&&(e.remove(),a.selectElement(d))},0)}}function i(a,d){var c=b.document,e=b.editable(),f=function(b){b.cancel()},n;if(!c.getById("cke_pastebin")){var g=b.getSelection(),h=g.createBookmarks();CKEDITOR.env.ie&&g.root.fire("selectionchange");var j=new CKEDITOR.dom.element((CKEDITOR.env.webkit||
e.is("body"))&&!CKEDITOR.env.ie?"body":"div",c);j.setAttributes({id:"cke_pastebin","data-cke-temp":"1"});var l=0,c=c.getWindow();CKEDITOR.env.webkit?(e.append(j),j.addClass("cke_editable"),e.is("body")||(l="static"!=e.getComputedStyle("position")?e:CKEDITOR.dom.element.get(e.$.offsetParent),l=l.getDocumentPosition().y)):e.getAscendant(CKEDITOR.env.ie?"body":"html",1).append(j);j.setStyles({position:"absolute",top:c.getScrollPosition().y-l+10+"px",width:"1px",height:Math.max(1,c.getViewPaneSize().height-
20)+"px",overflow:"hidden",margin:0,padding:0});CKEDITOR.env.safari&&j.setStyles(CKEDITOR.tools.cssVendorPrefix("user-select","text"));(l=j.getParent().isReadOnly())?(j.setOpacity(0),j.setAttribute("contenteditable",!0)):j.setStyle("ltr"==b.config.contentsLangDirection?"left":"right","-1000px");b.on("selectionChange",f,null,null,0);if(CKEDITOR.env.webkit||CKEDITOR.env.gecko)n=e.once("blur",f,null,null,-100);l&&j.focus();l=new CKEDITOR.dom.range(j);l.selectNodeContents(j);var i=l.select();CKEDITOR.env.ie&&
(n=e.once("blur",function(){b.lockSelection(i)}));var p=CKEDITOR.document.getWindow().getScrollPosition().y;setTimeout(function(){if(CKEDITOR.env.webkit)CKEDITOR.document.getBody().$.scrollTop=p;n&&n.removeListener();CKEDITOR.env.ie&&e.focus();g.selectBookmarks(h);j.remove();var a;if(CKEDITOR.env.webkit&&(a=j.getFirst())&&a.is&&a.hasClass("Apple-style-span"))j=a;b.removeListener("selectionChange",f);d(j.getHtml())},0)}}function s(){if("paste"==k.mainPasteEvent)return b.fire("beforePaste",{type:"auto",
method:"paste"}),!1;b.focus();e();var a=b.focusManager;a.lock();if(b.editable().fire(k.mainPasteEvent)&&!f("paste"))return a.unlock(),!1;a.unlock();return!0}function n(a){if("wysiwyg"==b.mode)switch(a.data.keyCode){case CKEDITOR.CTRL+86:case CKEDITOR.SHIFT+45:a=b.editable();e();"paste"==k.mainPasteEvent&&a.fire("beforepaste");break;case CKEDITOR.CTRL+88:case CKEDITOR.SHIFT+46:b.fire("saveSnapshot"),setTimeout(function(){b.fire("saveSnapshot")},50)}}function l(a){var d={type:"auto",method:"paste",
dataTransfer:k.initPasteDataTransfer(a)};d.dataTransfer.cacheData();var c=!1!==b.fire("beforePaste",d);c&&k.canClipboardApiBeTrusted(d.dataTransfer,b)?(a.data.preventDefault(),setTimeout(function(){o(b,d)},0)):i(a,function(a){d.dataValue=a.replace(/<span[^>]+data-cke-bookmark[^<]*?<\/span>/ig,"");c&&o(b,d)})}function p(){if("wysiwyg"==b.mode){var a=q("paste");b.getCommand("cut").setState(q("cut"));b.getCommand("copy").setState(q("copy"));b.getCommand("paste").setState(a);b.fire("pasteState",a)}}function q(a){if(t&&
a in{paste:1,cut:1})return CKEDITOR.TRISTATE_DISABLED;if("paste"==a)return CKEDITOR.TRISTATE_OFF;var a=b.getSelection(),d=a.getRanges();return a.getType()==CKEDITOR.SELECTION_NONE||1==d.length&&d[0].collapsed?CKEDITOR.TRISTATE_DISABLED:CKEDITOR.TRISTATE_OFF}var k=CKEDITOR.plugins.clipboard,m=0,r=0,t=0;(function(){b.on("key",n);b.on("contentDom",a);b.on("selectionChange",function(b){t=b.data.selection.getRanges()[0].checkReadOnly();p()});b.contextMenu&&b.contextMenu.addListener(function(b,a){t=a.getRanges()[0].checkReadOnly();
return{cut:q("cut"),copy:q("copy"),paste:q("paste")}})})();(function(){function a(d,c,e,f,n){var g=b.lang.clipboard[c];b.addCommand(c,e);b.ui.addButton&&b.ui.addButton(d,{label:g,command:c,toolbar:"clipboard,"+f});b.addMenuItems&&b.addMenuItem(c,{label:g,command:c,group:"clipboard",order:n})}a("Cut","cut",c("cut"),10,1);a("Copy","copy",c("copy"),20,4);a("Paste","paste",d(),30,8)})();b.getClipboardData=function(a,d){function c(b){b.removeListener();b.cancel();d(b.data)}function e(b){b.removeListener();
b.cancel();h=!0;d({type:g,dataValue:b.data,method:"paste"})}function f(){this.customTitle=a&&a.title}var n=!1,g="auto",h=!1;d||(d=a,a=null);b.on("paste",c,null,null,0);b.on("beforePaste",function(b){b.removeListener();n=true;g=b.data.type},null,null,1E3);!1===s()&&(b.removeListener("paste",c),n&&b.fire("pasteDialog",f)?(b.on("pasteDialogCommit",e),b.on("dialogHide",function(b){b.removeListener();b.data.removeListener("pasteDialogCommit",e);setTimeout(function(){h||d(null)},10)})):d(null))}}function w(b){if(CKEDITOR.env.webkit){if(!b.match(/^[^<]*$/g)&&
!b.match(/^(<div><br( ?\/)?><\/div>|<div>[^<]*<\/div>)*$/gi))return"html"}else if(CKEDITOR.env.ie){if(!b.match(/^([^<]|<br( ?\/)?>)*$/gi)&&!b.match(/^(<p>([^<]|<br( ?\/)?>)*<\/p>|(\r\n))*$/gi))return"html"}else if(CKEDITOR.env.gecko){if(!b.match(/^([^<]|<br( ?\/)?>)*$/gi))return"html"}else return"html";return"htmlifiedtext"}function x(b,a){function c(b){return CKEDITOR.tools.repeat("</p><p>",~~(b/2))+(1==b%2?"<br>":"")}a=a.replace(/\s+/g," ").replace(/> +</g,"><").replace(/<br ?\/>/gi,"<br>");a=a.replace(/<\/?[A-Z]+>/g,
function(b){return b.toLowerCase()});if(a.match(/^[^<]$/))return a;CKEDITOR.env.webkit&&-1<a.indexOf("<div>")&&(a=a.replace(/^(<div>(<br>|)<\/div>)(?!$|(<div>(<br>|)<\/div>))/g,"<br>").replace(/^(<div>(<br>|)<\/div>){2}(?!$)/g,"<div></div>"),a.match(/<div>(<br>|)<\/div>/)&&(a="<p>"+a.replace(/(<div>(<br>|)<\/div>)+/g,function(b){return c(b.split("</div><div>").length+1)})+"</p>"),a=a.replace(/<\/div><div>/g,"<br>"),a=a.replace(/<\/?div>/g,""));CKEDITOR.env.gecko&&b.enterMode!=CKEDITOR.ENTER_BR&&(CKEDITOR.env.gecko&&
(a=a.replace(/^<br><br>$/,"<br>")),-1<a.indexOf("<br><br>")&&(a="<p>"+a.replace(/(<br>){2,}/g,function(b){return c(b.length/4)})+"</p>"));return y(b,a)}function z(){function b(){var b={},a;for(a in CKEDITOR.dtd)"$"!=a.charAt(0)&&("div"!=a&&"span"!=a)&&(b[a]=1);return b}var a,c;return{get:function(d){if("plain-text"==d)return a||(a=new CKEDITOR.filter("br"));if("semantic-content"==d){if(!(d=c))d=new CKEDITOR.filter,d.allow({$1:{elements:b(),attributes:!0,styles:!1,classes:!1}}),d=c=d;return d}return d?
new CKEDITOR.filter(d):null}}}function u(b,a,c){var a=CKEDITOR.htmlParser.fragment.fromHtml(a),d=new CKEDITOR.htmlParser.basicWriter;c.applyTo(a,!0,!1,b.activeEnterMode);a.writeHtml(d);return d.getHtml()}function y(b,a){b.enterMode==CKEDITOR.ENTER_BR?a=a.replace(/(<\/p><p>)+/g,function(b){return CKEDITOR.tools.repeat("<br>",2*(b.length/7))}).replace(/<\/?p>/g,""):b.enterMode==CKEDITOR.ENTER_DIV&&(a=a.replace(/<(\/)?p>/g,"<$1div>"));return a}function A(b){b.data.preventDefault();b.data.$.dataTransfer.dropEffect=
"none"}function B(b){var a=CKEDITOR.plugins.clipboard;b.on("contentDom",function(){function c(a,d,c){d.select();o(b,{dataTransfer:c,method:"drop"},1);c.sourceEditor.fire("saveSnapshot");c.sourceEditor.editable().extractHtmlFromRange(a);c.sourceEditor.getSelection().selectRanges([a]);c.sourceEditor.fire("saveSnapshot")}function d(d,c){d.select();o(b,{dataTransfer:c,method:"drop"},1);a.resetDragDataTransfer()}function e(a,d,c){var e={$:a.data.$,target:a.data.getTarget()};d&&(e.dragRange=d);c&&(e.dropRange=
c);!1===b.fire(a.name,e)&&a.data.preventDefault()}function g(b){b.type!=CKEDITOR.NODE_ELEMENT&&(b=b.getParent());return b.getChildCount()}var f=b.editable(),h=CKEDITOR.plugins.clipboard.getDropTarget(b),i=b.ui.space("top"),s=b.ui.space("bottom");a.preventDefaultDropOnElement(i);a.preventDefaultDropOnElement(s);f.attachListener(h,"dragstart",e);f.attachListener(b,"dragstart",a.resetDragDataTransfer,a,null,1);f.attachListener(b,"dragstart",function(d){a.initDragDataTransfer(d,b);d=a.dragRange=b.getSelection().getRanges()[0];
CKEDITOR.env.ie&&10>CKEDITOR.env.version&&(a.dragStartContainerChildCount=d?g(d.startContainer):null,a.dragEndContainerChildCount=d?g(d.endContainer):null)},null,null,2);f.attachListener(h,"dragend",e);f.attachListener(b,"dragend",a.initDragDataTransfer,a,null,1);f.attachListener(b,"dragend",a.resetDragDataTransfer,a,null,100);f.attachListener(h,"dragover",function(b){var a=b.data.getTarget();a&&a.is&&a.is("html")?b.data.preventDefault():CKEDITOR.env.ie&&(CKEDITOR.plugins.clipboard.isFileApiSupported&&
b.data.$.dataTransfer.types.contains("Files"))&&b.data.preventDefault()});f.attachListener(h,"drop",function(d){d.data.preventDefault();var c=d.data.getTarget();if(!c.isReadOnly()||c.type==CKEDITOR.NODE_ELEMENT&&c.is("html")){var c=a.getRangeAtDropPosition(d,b),f=a.dragRange;c&&e(d,f,c)}});f.attachListener(b,"drop",a.initDragDataTransfer,a,null,1);f.attachListener(b,"drop",function(e){if(e=e.data){var f=e.dropRange,g=e.dragRange,h=e.dataTransfer;h.getTransferType(b)==CKEDITOR.DATA_TRANSFER_INTERNAL?
setTimeout(function(){a.internalDrop(g,f,h,b)},0):h.getTransferType(b)==CKEDITOR.DATA_TRANSFER_CROSS_EDITORS?c(g,f,h):d(f,h)}},null,null,9999)})}CKEDITOR.plugins.add("clipboard",{requires:"dialog",init:function(b){var a,c=z();b.config.forcePasteAsPlainText?a="plain-text":b.config.pasteFilter?a=b.config.pasteFilter:CKEDITOR.env.webkit&&!("pasteFilter"in b.config)&&(a="semantic-content");b.pasteFilter=c.get(a);v(b);B(b);CKEDITOR.dialog.add("paste",CKEDITOR.getUrl(this.path+"dialogs/paste.js"));b.on("paste",
function(a){a.data.dataTransfer||(a.data.dataTransfer=new CKEDITOR.plugins.clipboard.dataTransfer);if(!a.data.dataValue){var c=a.data.dataTransfer,g=c.getData("text/html");if(g)a.data.dataValue=g,a.data.type="html";else if(g=c.getData("text/plain"))a.data.dataValue=b.editable().transformPlainTextToHtml(g),a.data.type="text"}},null,null,1);b.on("paste",function(b){var a=b.data.dataValue,c=CKEDITOR.dtd.$block;-1<a.indexOf("Apple-")&&(a=a.replace(/<span class="Apple-converted-space">&nbsp;<\/span>/gi,
" "),"html"!=b.data.type&&(a=a.replace(/<span class="Apple-tab-span"[^>]*>([^<]*)<\/span>/gi,function(a,b){return b.replace(/\t/g,"&nbsp;&nbsp; &nbsp;")})),-1<a.indexOf('<br class="Apple-interchange-newline">')&&(b.data.startsWithEOL=1,b.data.preSniffing="html",a=a.replace(/<br class="Apple-interchange-newline">/,"")),a=a.replace(/(<[^>]+) class="Apple-[^"]*"/gi,"$1"));if(a.match(/^<[^<]+cke_(editable|contents)/i)){var f,h,i=new CKEDITOR.dom.element("div");for(i.setHtml(a);1==i.getChildCount()&&(f=
i.getFirst())&&f.type==CKEDITOR.NODE_ELEMENT&&(f.hasClass("cke_editable")||f.hasClass("cke_contents"));)i=h=f;h&&(a=h.getHtml().replace(/<br>$/i,""))}CKEDITOR.env.ie?a=a.replace(/^&nbsp;(?: |\r\n)?<(\w+)/g,function(a,f){if(f.toLowerCase()in c){b.data.preSniffing="html";return"<"+f}return a}):CKEDITOR.env.webkit?a=a.replace(/<\/(\w+)><div><br><\/div>$/,function(a,f){if(f in c){b.data.endsWithEOL=1;return"</"+f+">"}return a}):CKEDITOR.env.gecko&&(a=a.replace(/(\s)<br>$/,"$1"));b.data.dataValue=a},null,
null,3);b.on("paste",function(a){var a=a.data,e=a.type,g=a.dataValue,f,h=b.config.clipboard_defaultContentType||"html",i=a.dataTransfer.getTransferType(b);f="html"==e||"html"==a.preSniffing?"html":w(g);"htmlifiedtext"==f&&(g=x(b.config,g));"text"==e&&"html"==f?g=u(b,g,c.get("plain-text")):i==CKEDITOR.DATA_TRANSFER_EXTERNAL&&(b.pasteFilter&&!a.dontFilter)&&(g=u(b,g,b.pasteFilter));a.startsWithEOL&&(g='<br data-cke-eol="1">'+g);a.endsWithEOL&&(g+='<br data-cke-eol="1">');"auto"==e&&(e="html"==f||"html"==
h?"html":"text");a.type=e;a.dataValue=g;delete a.preSniffing;delete a.startsWithEOL;delete a.endsWithEOL},null,null,6);b.on("paste",function(a){a=a.data;a.dataValue&&(b.insertHtml(a.dataValue,a.type,a.range),setTimeout(function(){b.fire("afterPaste")},0))},null,null,1E3);b.on("pasteDialog",function(a){setTimeout(function(){b.openDialog("paste",a.data)},0)})}});CKEDITOR.plugins.clipboard={isCustomCopyCutSupported:!CKEDITOR.env.ie&&!CKEDITOR.env.iOS,isCustomDataTypesSupported:!CKEDITOR.env.ie,isFileApiSupported:!CKEDITOR.env.ie||
9<CKEDITOR.env.version,mainPasteEvent:CKEDITOR.env.ie&&!CKEDITOR.env.edge?"beforepaste":"paste",canClipboardApiBeTrusted:function(b,a){return b.getTransferType(a)!=CKEDITOR.DATA_TRANSFER_EXTERNAL||CKEDITOR.env.chrome&&!b.isEmpty()||CKEDITOR.env.gecko&&(b.getData("text/html")||b.getFilesCount())?!0:!1},getDropTarget:function(b){var a=b.editable();return CKEDITOR.env.ie&&9>CKEDITOR.env.version||a.isInline()?a:b.document},fixSplitNodesAfterDrop:function(b,a,c,d){function e(b,c,d){var e=b;e.type==CKEDITOR.NODE_TEXT&&
(e=b.getParent());if(e.equals(c)&&d!=c.getChildCount())return b=a,c=b.startContainer.getChild(b.startOffset-1),d=b.startContainer.getChild(b.startOffset),c&&(c.type==CKEDITOR.NODE_TEXT&&d&&d.type==CKEDITOR.NODE_TEXT)&&(e=c.getLength(),c.setText(c.getText()+d.getText()),d.remove(),b.setStart(c,e),b.collapse(!0)),!0}var g=a.startContainer;!("number"!=typeof d||"number"!=typeof c)&&(g.type==CKEDITOR.NODE_ELEMENT&&!e(b.startContainer,g,c))&&e(b.endContainer,g,d)},isDropRangeAffectedByDragRange:function(b,
a){var c=a.startContainer,d=a.endOffset;return b.endContainer.equals(c)&&b.endOffset<=d||b.startContainer.getParent().equals(c)&&b.startContainer.getIndex()<d||b.endContainer.getParent().equals(c)&&b.endContainer.getIndex()<d?!0:!1},internalDrop:function(b,a,c,d){var e=CKEDITOR.plugins.clipboard,g=d.editable(),f,h;d.fire("saveSnapshot");d.fire("lockSnapshot",{dontUpdate:1});CKEDITOR.env.ie&&10>CKEDITOR.env.version&&this.fixSplitNodesAfterDrop(b,a,e.dragStartContainerChildCount,e.dragEndContainerChildCount);
(h=this.isDropRangeAffectedByDragRange(b,a))||(f=b.createBookmark(!1));e=a.clone().createBookmark(!1);h&&(f=b.createBookmark(!1));b=f.startNode;h=f.endNode;var i=e.startNode;h&&b.getPosition(i)==CKEDITOR.POSITION_PRECEDING&&h.getPosition(i)==CKEDITOR.POSITION_FOLLOWING?(d.getSelection().selectRanges([a]),b.remove(),h.remove(),i.remove()):(b=d.createRange(),b.moveToBookmark(f),g.extractHtmlFromRange(b,1),a=d.createRange(),a.moveToBookmark(e),o(d,{dataTransfer:c,method:"drop",range:a},1));d.fire("unlockSnapshot")},
getRangeAtDropPosition:function(b,a){var c=b.data.$,d=c.clientX,e=c.clientY,g=a.getSelection(!0).getRanges()[0],f=a.createRange();if(b.data.testRange)return b.data.testRange;if(document.caretRangeFromPoint)c=a.document.$.caretRangeFromPoint(d,e),f.setStart(CKEDITOR.dom.node(c.startContainer),c.startOffset),f.collapse(!0);else if(c.rangeParent)f.setStart(CKEDITOR.dom.node(c.rangeParent),c.rangeOffset),f.collapse(!0);else{if(CKEDITOR.env.ie&&8<CKEDITOR.env.version&&g&&a.editable().hasFocus)return g;
if(document.body.createTextRange){a.focus();c=a.document.getBody().$.createTextRange();try{for(var h=!1,i=0;20>i&&!h;i++){if(!h)try{c.moveToPoint(d,e-i),h=!0}catch(m){}if(!h)try{c.moveToPoint(d,e+i),h=!0}catch(n){}}if(h){var l="cke-temp-"+(new Date).getTime();c.pasteHTML('<span id="'+l+'">​</span>');var p=a.document.getById(l);f.moveToPosition(p,CKEDITOR.POSITION_BEFORE_START);p.remove()}else{var q=a.document.$.elementFromPoint(d,e),k=new CKEDITOR.dom.element(q),o;if(!k.equals(a.editable())&&"html"!=
k.getName())o=k.getClientRect(),d<o.left?f.setStartAt(k,CKEDITOR.POSITION_AFTER_START):f.setStartAt(k,CKEDITOR.POSITION_BEFORE_END),f.collapse(!0);else return g&&g.startContainer&&!g.startContainer.equals(a.editable())?g:null}}catch(r){return null}}else return null}return f},initDragDataTransfer:function(b,a){var c=b.data.$?b.data.$.dataTransfer:null,d=new this.dataTransfer(c,a);c?this.dragData&&d.id==this.dragData.id?d=this.dragData:this.dragData=d:this.dragData?d=this.dragData:this.dragData=d;b.data.dataTransfer=
d},resetDragDataTransfer:function(){this.dragData=null},initPasteDataTransfer:function(b,a){if(this.isCustomCopyCutSupported&&b&&b.data&&b.data.$){var c=new this.dataTransfer(b.data.$.clipboardData,a);this.copyCutData&&c.id==this.copyCutData.id?(c=this.copyCutData,c.$=b.data.$.clipboardData):this.copyCutData=c;return c}return new this.dataTransfer(null,a)},preventDefaultDropOnElement:function(b){b&&b.on("dragover",A)}};var m=CKEDITOR.plugins.clipboard.isCustomDataTypesSupported?"cke/id":"Text";CKEDITOR.plugins.clipboard.dataTransfer=
function(b,a){b&&(this.$=b);this._={metaRegExp:/^<meta.*?>/,bodyRegExp:/<body(?:[\s\S]*?)>([\s\S]*)<\/body>/,fragmentRegExp:/<\!--(?:Start|End)Fragment--\>/g,data:{},files:[],normalizeType:function(a){a=a.toLowerCase();return a=="text"||a=="text/plain"?"Text":a=="url"?"URL":a}};this.id=this.getData(m);this.id||(this.id="Text"==m?"":"cke-"+CKEDITOR.tools.getUniqueId());if("Text"!=m)try{this.$.setData(m,this.id)}catch(c){}a&&(this.sourceEditor=a,this.setData("text/html",a.getSelectedHtml(1)),"Text"!=
m&&!this.getData("text/plain")&&this.setData("text/plain",a.getSelection().getSelectedText()))};CKEDITOR.DATA_TRANSFER_INTERNAL=1;CKEDITOR.DATA_TRANSFER_CROSS_EDITORS=2;CKEDITOR.DATA_TRANSFER_EXTERNAL=3;CKEDITOR.plugins.clipboard.dataTransfer.prototype={getData:function(b){var b=this._.normalizeType(b),a=this._.data[b];if(void 0===a||null===a||""===a)try{a=this.$.getData(b)}catch(c){}if(void 0===a||null===a||""===a)a="";if("text/html"==b){if(a=a.replace(this._.metaRegExp,""),(b=this._.bodyRegExp.exec(a))&&
b.length)a=b[1],a=a.replace(this._.fragmentRegExp,"")}else"Text"==b&&(CKEDITOR.env.gecko&&this.getFilesCount()&&"file://"==a.substring(0,7))&&(a="");return a},setData:function(b,a){b=this._.normalizeType(b);this._.data[b]=a;if(CKEDITOR.plugins.clipboard.isCustomDataTypesSupported||!("URL"!=b&&"Text"!=b)){"Text"==m&&"Text"==b&&(this.id=a);try{this.$.setData(b,a)}catch(c){}}},getTransferType:function(b){return this.sourceEditor?this.sourceEditor==b?CKEDITOR.DATA_TRANSFER_INTERNAL:CKEDITOR.DATA_TRANSFER_CROSS_EDITORS:
CKEDITOR.DATA_TRANSFER_EXTERNAL},cacheData:function(){function b(b){var b=a._.normalizeType(b),c=a.getData(b);c&&(a._.data[b]=c)}if(this.$){var a=this,c,d;if(CKEDITOR.plugins.clipboard.isCustomDataTypesSupported){if(this.$.types)for(c=0;c<this.$.types.length;c++)b(this.$.types[c])}else b("Text"),b("URL");d=this._getImageFromClipboard();if(this.$&&this.$.files||d){this._.files=[];for(c=0;c<this.$.files.length;c++)this._.files.push(this.$.files[c]);0===this._.files.length&&d&&this._.files.push(d)}}},
getFilesCount:function(){return this._.files.length?this._.files.length:this.$&&this.$.files&&this.$.files.length?this.$.files.length:this._getImageFromClipboard()?1:0},getFile:function(b){return this._.files.length?this._.files[b]:this.$&&this.$.files&&this.$.files.length?this.$.files[b]:0===b?this._getImageFromClipboard():void 0},isEmpty:function(){var b={},a;if(this.getFilesCount())return!1;for(a in this._.data)b[a]=1;if(this.$)if(CKEDITOR.plugins.clipboard.isCustomDataTypesSupported){if(this.$.types)for(var c=
0;c<this.$.types.length;c++)b[this.$.types[c]]=1}else b.Text=1,b.URL=1;"Text"!=m&&(b[m]=0);for(a in b)if(b[a]&&""!==this.getData(a))return!1;return!0},_getImageFromClipboard:function(){var b;if(this.$&&this.$.items&&this.$.items[0])try{if((b=this.$.items[0].getAsFile())&&b.type)return b}catch(a){}}}})();(function(){function n(b,d,a){a=b.config.forceEnterMode||a;"wysiwyg"==b.mode&&(d||(d=b.activeEnterMode),b.elementPath().isContextFor("p")||(d=CKEDITOR.ENTER_BR,a=1),b.fire("saveSnapshot"),d==CKEDITOR.ENTER_BR?p(b,d,null,a):q(b,d,null,a),b.fire("saveSnapshot"))}function r(b){for(var b=b.getSelection().getRanges(!0),d=b.length-1;0<d;d--)b[d].deleteContents();return b[0]}function u(b){var d=b.startContainer.getAscendant(function(a){return a.type==CKEDITOR.NODE_ELEMENT&&"true"==a.getAttribute("contenteditable")},
!0);if(b.root.equals(d))return b;d=new CKEDITOR.dom.range(d);d.moveToRange(b);return d}CKEDITOR.plugins.add("enterkey",{init:function(b){b.addCommand("enter",{modes:{wysiwyg:1},editorFocus:!1,exec:function(b){n(b)}});b.addCommand("shiftEnter",{modes:{wysiwyg:1},editorFocus:!1,exec:function(b){n(b,b.activeShiftEnterMode,1)}});b.setKeystroke([[13,"enter"],[CKEDITOR.SHIFT+13,"shiftEnter"]])}});var v=CKEDITOR.dom.walker.whitespaces(),w=CKEDITOR.dom.walker.bookmark();CKEDITOR.plugins.enterkey={enterBlock:function(b,
d,a,h){if(a=a||r(b)){var a=u(a),f=a.document,i=a.checkStartOfBlock(),k=a.checkEndOfBlock(),j=b.elementPath(a.startContainer),c=j.block,l=d==CKEDITOR.ENTER_DIV?"div":"p",e;if(i&&k){if(c&&(c.is("li")||c.getParent().is("li"))){c.is("li")||(c=c.getParent());a=c.getParent();e=a.getParent();var h=!c.hasPrevious(),m=!c.hasNext(),l=b.getSelection(),g=l.createBookmarks(),i=c.getDirection(1),k=c.getAttribute("class"),o=c.getAttribute("style"),n=e.getDirection(1)!=i,b=b.enterMode!=CKEDITOR.ENTER_BR||n||o||k;
if(e.is("li"))h||m?(h&&m&&a.remove(),c[m?"insertAfter":"insertBefore"](e)):c.breakParent(e);else{if(b)if(j.block.is("li")?(e=f.createElement(d==CKEDITOR.ENTER_P?"p":"div"),n&&e.setAttribute("dir",i),o&&e.setAttribute("style",o),k&&e.setAttribute("class",k),c.moveChildren(e)):e=j.block,h||m)e[h?"insertBefore":"insertAfter"](a);else c.breakParent(a),e.insertAfter(a);else if(c.appendBogus(!0),h||m)for(;f=c[h?"getFirst":"getLast"]();)f[h?"insertBefore":"insertAfter"](a);else for(c.breakParent(a);f=c.getLast();)f.insertAfter(a);
c.remove()}l.selectBookmarks(g);return}if(c&&c.getParent().is("blockquote")){c.breakParent(c.getParent());c.getPrevious().getFirst(CKEDITOR.dom.walker.invisible(1))||c.getPrevious().remove();c.getNext().getFirst(CKEDITOR.dom.walker.invisible(1))||c.getNext().remove();a.moveToElementEditStart(c);a.select();return}}else if(c&&c.is("pre")&&!k){p(b,d,a,h);return}if(i=a.splitBlock(l)){d=i.previousBlock;c=i.nextBlock;j=i.wasStartOfBlock;b=i.wasEndOfBlock;if(c)g=c.getParent(),g.is("li")&&(c.breakParent(g),
c.move(c.getNext(),1));else if(d&&(g=d.getParent())&&g.is("li"))d.breakParent(g),g=d.getNext(),a.moveToElementEditStart(g),d.move(d.getPrevious());if(!j&&!b)c.is("li")&&(e=a.clone(),e.selectNodeContents(c),e=new CKEDITOR.dom.walker(e),e.evaluator=function(a){return!(w(a)||v(a)||a.type==CKEDITOR.NODE_ELEMENT&&a.getName()in CKEDITOR.dtd.$inline&&!(a.getName()in CKEDITOR.dtd.$empty))},(g=e.next())&&(g.type==CKEDITOR.NODE_ELEMENT&&g.is("ul","ol"))&&(CKEDITOR.env.needsBrFiller?f.createElement("br"):f.createText(" ")).insertBefore(g)),
c&&a.moveToElementEditStart(c);else{if(d){if(d.is("li")||!s.test(d.getName())&&!d.is("pre"))e=d.clone()}else c&&(e=c.clone());e?h&&!e.is("li")&&e.renameNode(l):g&&g.is("li")?e=g:(e=f.createElement(l),d&&(m=d.getDirection())&&e.setAttribute("dir",m));if(f=i.elementPath){h=0;for(l=f.elements.length;h<l;h++){g=f.elements[h];if(g.equals(f.block)||g.equals(f.blockLimit))break;CKEDITOR.dtd.$removeEmpty[g.getName()]&&(g=g.clone(),e.moveChildren(g),e.append(g))}}e.appendBogus();e.getParent()||a.insertNode(e);
e.is("li")&&e.removeAttribute("value");if(CKEDITOR.env.ie&&j&&(!b||!d.getChildCount()))a.moveToElementEditStart(b?d:e),a.select();a.moveToElementEditStart(j&&!b?c:e)}a.select();a.scrollIntoView()}}},enterBr:function(b,d,a,h){if(a=a||r(b)){var f=a.document,i=a.checkEndOfBlock(),k=new CKEDITOR.dom.elementPath(b.getSelection().getStartElement()),j=k.block,c=j&&k.block.getName();!h&&"li"==c?q(b,d,a,h):(!h&&i&&s.test(c)?(i=j.getDirection())?(f=f.createElement("div"),f.setAttribute("dir",i),f.insertAfter(j),
a.setStart(f,0)):(f.createElement("br").insertAfter(j),CKEDITOR.env.gecko&&f.createText("").insertAfter(j),a.setStartAt(j.getNext(),CKEDITOR.env.ie?CKEDITOR.POSITION_BEFORE_START:CKEDITOR.POSITION_AFTER_START)):(b="pre"==c&&CKEDITOR.env.ie&&8>CKEDITOR.env.version?f.createText("\r"):f.createElement("br"),a.deleteContents(),a.insertNode(b),CKEDITOR.env.needsBrFiller?(f.createText("﻿").insertAfter(b),i&&(j||k.blockLimit).appendBogus(),b.getNext().$.nodeValue="",a.setStartAt(b.getNext(),CKEDITOR.POSITION_AFTER_START)):
a.setStartAt(b,CKEDITOR.POSITION_AFTER_END)),a.collapse(!0),a.select(),a.scrollIntoView())}}};var t=CKEDITOR.plugins.enterkey,p=t.enterBr,q=t.enterBlock,s=/^h[1-6]$/})();(function(){var c={canUndo:!1,async:!0,exec:function(a){a.getClipboardData({title:a.lang.pastetext.title},function(b){b&&a.fire("paste",{type:"text",dataValue:b.dataValue,method:"paste",dataTransfer:CKEDITOR.plugins.clipboard.initPasteDataTransfer()});a.fire("afterCommandExec",{name:"pastetext",command:c,returnValue:!!b})})}};CKEDITOR.plugins.add("pastetext",{requires:"clipboard",init:function(a){a.addCommand("pastetext",c);a.ui.addButton&&a.ui.addButton("PasteText",{label:a.lang.pastetext.button,
command:"pastetext",toolbar:"clipboard,40"});if(a.config.forcePasteAsPlainText)a.on("beforePaste",function(a){"html"!=a.data.type&&(a.data.type="text")});a.on("pasteState",function(b){a.getCommand("pastetext").setState(b.data)})}})})();(function(){var g=[CKEDITOR.CTRL+90,CKEDITOR.CTRL+89,CKEDITOR.CTRL+CKEDITOR.SHIFT+90],l={8:1,46:1};CKEDITOR.plugins.add("undo",{init:function(a){function b(a){d.enabled&&!1!==a.data.command.canUndo&&d.save()}function c(){d.enabled=a.readOnly?!1:"wysiwyg"==a.mode;d.onChange()}var d=a.undoManager=new e(a),j=d.editingHandler=new i(d),f=a.addCommand("undo",{exec:function(){d.undo()&&(a.selectionChange(),this.fire("afterUndo"))},startDisabled:!0,canUndo:!1}),h=a.addCommand("redo",{exec:function(){d.redo()&&
(a.selectionChange(),this.fire("afterRedo"))},startDisabled:!0,canUndo:!1});a.setKeystroke([[g[0],"undo"],[g[1],"redo"],[g[2],"redo"]]);d.onChange=function(){f.setState(d.undoable()?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED);h.setState(d.redoable()?CKEDITOR.TRISTATE_OFF:CKEDITOR.TRISTATE_DISABLED)};a.on("beforeCommandExec",b);a.on("afterCommandExec",b);a.on("saveSnapshot",function(a){d.save(a.data&&a.data.contentOnly)});a.on("contentDom",j.attachListeners,j);a.on("instanceReady",function(){a.fire("saveSnapshot")});
a.on("beforeModeUnload",function(){"wysiwyg"==a.mode&&d.save(!0)});a.on("mode",c);a.on("readOnly",c);a.ui.addButton&&(a.ui.addButton("Undo",{label:a.lang.undo.undo,command:"undo",toolbar:"undo,10"}),a.ui.addButton("Redo",{label:a.lang.undo.redo,command:"redo",toolbar:"undo,20"}));a.resetUndo=function(){d.reset();a.fire("saveSnapshot")};a.on("updateSnapshot",function(){d.currentImage&&d.update()});a.on("lockSnapshot",function(a){a=a.data;d.lock(a&&a.dontUpdate,a&&a.forceUpdate)});a.on("unlockSnapshot",
d.unlock,d)}});CKEDITOR.plugins.undo={};var e=CKEDITOR.plugins.undo.UndoManager=function(a){this.strokesRecorded=[0,0];this.locked=null;this.previousKeyGroup=-1;this.limit=a.config.undoStackSize||20;this.strokesLimit=25;this.editor=a;this.reset()};e.prototype={type:function(a,b){var c=e.getKeyGroup(a),d=this.strokesRecorded[c]+1,b=b||d>=this.strokesLimit;this.typing||(this.hasUndo=this.typing=!0,this.hasRedo=!1,this.onChange());b?(d=0,this.editor.fire("saveSnapshot")):this.editor.fire("change");this.strokesRecorded[c]=
d;this.previousKeyGroup=c},keyGroupChanged:function(a){return e.getKeyGroup(a)!=this.previousKeyGroup},reset:function(){this.snapshots=[];this.index=-1;this.currentImage=null;this.hasRedo=this.hasUndo=!1;this.locked=null;this.resetType()},resetType:function(){this.strokesRecorded=[0,0];this.typing=!1;this.previousKeyGroup=-1},refreshState:function(){this.hasUndo=!!this.getNextImage(!0);this.hasRedo=!!this.getNextImage(!1);this.resetType();this.onChange()},save:function(a,b,c){var d=this.editor;if(this.locked||
"ready"!=d.status||"wysiwyg"!=d.mode)return!1;var e=d.editable();if(!e||"ready"!=e.status)return!1;e=this.snapshots;b||(b=new f(d));if(!1===b.contents)return!1;if(this.currentImage)if(b.equalsContent(this.currentImage)){if(a||b.equalsSelection(this.currentImage))return!1}else!1!==c&&d.fire("change");e.splice(this.index+1,e.length-this.index-1);e.length==this.limit&&e.shift();this.index=e.push(b)-1;this.currentImage=b;!1!==c&&this.refreshState();return!0},restoreImage:function(a){var b=this.editor,
c;a.bookmarks&&(b.focus(),c=b.getSelection());this.locked={level:999};this.editor.loadSnapshot(a.contents);a.bookmarks?c.selectBookmarks(a.bookmarks):CKEDITOR.env.ie&&(c=this.editor.document.getBody().$.createTextRange(),c.collapse(!0),c.select());this.locked=null;this.index=a.index;this.currentImage=this.snapshots[this.index];this.update();this.refreshState();b.fire("change")},getNextImage:function(a){var b=this.snapshots,c=this.currentImage,d;if(c)if(a)for(d=this.index-1;0<=d;d--){if(a=b[d],!c.equalsContent(a))return a.index=
d,a}else for(d=this.index+1;d<b.length;d++)if(a=b[d],!c.equalsContent(a))return a.index=d,a;return null},redoable:function(){return this.enabled&&this.hasRedo},undoable:function(){return this.enabled&&this.hasUndo},undo:function(){if(this.undoable()){this.save(!0);var a=this.getNextImage(!0);if(a)return this.restoreImage(a),!0}return!1},redo:function(){if(this.redoable()&&(this.save(!0),this.redoable())){var a=this.getNextImage(!1);if(a)return this.restoreImage(a),!0}return!1},update:function(a){if(!this.locked){a||
(a=new f(this.editor));for(var b=this.index,c=this.snapshots;0<b&&this.currentImage.equalsContent(c[b-1]);)b-=1;c.splice(b,this.index-b+1,a);this.index=b;this.currentImage=a}},updateSelection:function(a){if(!this.snapshots.length)return!1;var b=this.snapshots,c=b[b.length-1];return c.equalsContent(a)&&!c.equalsSelection(a)?(this.currentImage=b[b.length-1]=a,!0):!1},lock:function(a,b){if(this.locked)this.locked.level++;else if(a)this.locked={level:1};else{var c=null;if(b)c=!0;else{var d=new f(this.editor,
!0);this.currentImage&&this.currentImage.equalsContent(d)&&(c=d)}this.locked={update:c,level:1}}},unlock:function(){if(this.locked&&!--this.locked.level){var a=this.locked.update;this.locked=null;if(!0===a)this.update();else if(a){var b=new f(this.editor,!0);a.equalsContent(b)||this.update()}}}};e.navigationKeyCodes={37:1,38:1,39:1,40:1,36:1,35:1,33:1,34:1};e.keyGroups={PRINTABLE:0,FUNCTIONAL:1};e.isNavigationKey=function(a){return!!e.navigationKeyCodes[a]};e.getKeyGroup=function(a){var b=e.keyGroups;
return l[a]?b.FUNCTIONAL:b.PRINTABLE};e.getOppositeKeyGroup=function(a){var b=e.keyGroups;return a==b.FUNCTIONAL?b.PRINTABLE:b.FUNCTIONAL};e.ieFunctionalKeysBug=function(a){return CKEDITOR.env.ie&&e.getKeyGroup(a)==e.keyGroups.FUNCTIONAL};var f=CKEDITOR.plugins.undo.Image=function(a,b){this.editor=a;a.fire("beforeUndoImage");var c=a.getSnapshot();CKEDITOR.env.ie&&c&&(c=c.replace(/\s+data-cke-expando=".*?"/g,""));this.contents=c;b||(this.bookmarks=(c=c&&a.getSelection())&&c.createBookmarks2(!0));a.fire("afterUndoImage")},
h=/\b(?:href|src|name)="[^"]*?"/gi;f.prototype={equalsContent:function(a){var b=this.contents,a=a.contents;if(CKEDITOR.env.ie&&(CKEDITOR.env.ie7Compat||CKEDITOR.env.quirks))b=b.replace(h,""),a=a.replace(h,"");return b!=a?!1:!0},equalsSelection:function(a){var b=this.bookmarks,a=a.bookmarks;if(b||a){if(!b||!a||b.length!=a.length)return!1;for(var c=0;c<b.length;c++){var d=b[c],e=a[c];if(d.startOffset!=e.startOffset||d.endOffset!=e.endOffset||!CKEDITOR.tools.arrayCompare(d.start,e.start)||!CKEDITOR.tools.arrayCompare(d.end,
e.end))return!1}}return!0}};var i=CKEDITOR.plugins.undo.NativeEditingHandler=function(a){this.undoManager=a;this.ignoreInputEvent=!1;this.keyEventsStack=new k;this.lastKeydownImage=null};i.prototype={onKeydown:function(a){var b=a.data.getKey();if(229!==b)if(-1<CKEDITOR.tools.indexOf(g,a.data.getKeystroke()))a.data.preventDefault();else if(this.keyEventsStack.cleanUp(a),a=this.undoManager,this.keyEventsStack.getLast(b)||this.keyEventsStack.push(b),this.lastKeydownImage=new f(a.editor),e.isNavigationKey(b)||
this.undoManager.keyGroupChanged(b))if(a.strokesRecorded[0]||a.strokesRecorded[1])a.save(!1,this.lastKeydownImage,!1),a.resetType()},onInput:function(){if(this.ignoreInputEvent)this.ignoreInputEvent=!1;else{var a=this.keyEventsStack.getLast();a||(a=this.keyEventsStack.push(0));this.keyEventsStack.increment(a.keyCode);this.keyEventsStack.getTotalInputs()>=this.undoManager.strokesLimit&&(this.undoManager.type(a.keyCode,!0),this.keyEventsStack.resetInputs())}},onKeyup:function(a){var b=this.undoManager,
a=a.data.getKey(),c=this.keyEventsStack.getTotalInputs();this.keyEventsStack.remove(a);if(!e.ieFunctionalKeysBug(a)||!this.lastKeydownImage||!this.lastKeydownImage.equalsContent(new f(b.editor,!0)))if(0<c)b.type(a);else if(e.isNavigationKey(a))this.onNavigationKey(!0)},onNavigationKey:function(a){var b=this.undoManager;(a||!b.save(!0,null,!1))&&b.updateSelection(new f(b.editor));b.resetType()},ignoreInputEventListener:function(){this.ignoreInputEvent=!0},attachListeners:function(){var a=this.undoManager.editor,
b=a.editable(),c=this;b.attachListener(b,"keydown",function(a){c.onKeydown(a);if(e.ieFunctionalKeysBug(a.data.getKey()))c.onInput()},null,null,999);b.attachListener(b,CKEDITOR.env.ie?"keypress":"input",c.onInput,c,null,999);b.attachListener(b,"keyup",c.onKeyup,c,null,999);b.attachListener(b,"paste",c.ignoreInputEventListener,c,null,999);b.attachListener(b,"drop",c.ignoreInputEventListener,c,null,999);b.attachListener(b.isInline()?b:a.document.getDocumentElement(),"click",function(){c.onNavigationKey()},
null,null,999);b.attachListener(this.undoManager.editor,"blur",function(){c.keyEventsStack.remove(9)},null,null,999)}};var k=CKEDITOR.plugins.undo.KeyEventsStack=function(){this.stack=[]};k.prototype={push:function(a){return this.stack[this.stack.push({keyCode:a,inputs:0})-1]},getLastIndex:function(a){if("number"!=typeof a)return this.stack.length-1;for(var b=this.stack.length;b--;)if(this.stack[b].keyCode==a)return b;return-1},getLast:function(a){a=this.getLastIndex(a);return-1!=a?this.stack[a]:
null},increment:function(a){this.getLast(a).inputs++},remove:function(a){a=this.getLastIndex(a);-1!=a&&this.stack.splice(a,1)},resetInputs:function(a){if("number"==typeof a)this.getLast(a).inputs=0;else for(a=this.stack.length;a--;)this.stack[a].inputs=0},getTotalInputs:function(){for(var a=this.stack.length,b=0;a--;)b+=this.stack[a].inputs;return b},cleanUp:function(a){a=a.data.$;!a.ctrlKey&&!a.metaKey&&this.remove(17);a.shiftKey||this.remove(16);a.altKey||this.remove(18)}}})();CKEDITOR.config.plugins='dialogui,dialog,clipboard,enterkey,pastetext,undo';CKEDITOR.config.skin='moono';(function() {var setIcons = function(icons, strip) {var path = CKEDITOR.getUrl( 'plugins/' + strip );icons = icons.split( ',' );for ( var i = 0; i < icons.length; i++ )CKEDITOR.skin.icons[ icons[ i ] ] = { path: path, offset: -icons[ ++i ], bgsize : icons[ ++i ] };};if (CKEDITOR.env.hidpi) setIcons('copy-rtl,0,,copy,24,,cut-rtl,48,,cut,72,,paste-rtl,96,,paste,120,,pastetext-rtl,144,,pastetext,168,,redo-rtl,192,,redo,216,,undo-rtl,240,,undo,264,','icons_hidpi.png');else setIcons('copy-rtl,0,auto,copy,24,auto,cut-rtl,48,auto,cut,72,auto,paste-rtl,96,auto,paste,120,auto,pastetext-rtl,144,auto,pastetext,168,auto,redo-rtl,192,auto,redo,216,auto,undo-rtl,240,auto,undo,264,auto','icons.png');})();CKEDITOR.lang.languages={"en":1};}());

/*** EXPORTS FROM exports-loader ***/
module.exports = CKEDITOR;

/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

// Allowing unused expessions in here, because we want to make as few modifications as possible to
// the original CKEditor code.
/* eslint-disable eqeqeq, no-nested-ternary, no-unused-expressions */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        WebFontsUtil = __webpack_require__(136);

    return {
        /**
         * Patch CKEditor for out needs: 1) Don't block the Backspace key and 2) quote font family
         * names.
         *
         * @param {Ckeditor} CKEDITOR CKEditor object. Using an all uppercase name to match
         *                            CKEditor's code style.
         */
        patch: function patch(CKEDITOR) {
            CKEDITOR.skin.loadPart = function (part, fn) {
                if (_.isFunction(fn)) {
                    fn.call(CKEDITOR.skin);
                }
            };

            var superSetReadOnly = CKEDITOR.editor.prototype.setReadOnly;

            /**
             * The default implementation of CKEDITOR.editor#setReadOnly blocks the BACKSPACE
             * key according to current read-only state.
             *
             * We need the BACKSPACE event for deleting widgets (MOS-1734).
             *
             * @override
             * @see CKEDITOR.editor#setReadOnly
             */
            CKEDITOR.editor.prototype.setReadOnly = function (isReadOnly) {
                superSetReadOnly.call(this, isReadOnly);
                // Make sure BACKSPACE is not blocked
                this.keystrokeHandler.blockedKeystrokes[8] = 0;
            };

            /**
             * Override to inject our call to _quoteSpecialFontNames.
             * @override
             */
            CKEDITOR.htmlParser.prototype.cssStyle = function () {
                // Loosining up the rules for CKEditor code.

                var styleText,
                    arg = arguments[0],
                    rules = {};

                styleText = arg instanceof CKEDITOR.htmlParser.element ? arg.attributes.style : arg;

                // html-encoded quote might be introduced by 'font-family'
                // from MS-Word which confused the following regexp. e.g.
                // 'font-family: &quot;Lucida, Console&quot;'
                // TODO reuse CSS methods from tools.
                (styleText || "").replace(/&quot;/g, "\"").replace(/\s*([^ :;]+)\s*:\s*([^;]+)\s*(?=;|$)/g, function (match, name, value) {
                    name == "font-family" && (value = value.replace(/["']/g, ""));

                    // Zmags patch start.
                    value = _quoteSpecialFontNames(name, value);
                    // Zmags patch end.

                    rules[name.toLowerCase()] = value;
                });

                return {
                    rules: rules,

                    /**
                     * Applies the styles to the specified element or object.
                     *
                     * @param {CKEDITOR.htmlParser.element/CKEDITOR.dom.element/Object} obj
                     */
                    populate: function populate(obj) {
                        var style = this.toString();
                        if (style) {
                            if (obj instanceof CKEDITOR.dom.element) {
                                obj.setAttribute("style", style);
                            } else if (obj instanceof CKEDITOR.htmlParser.element) {
                                obj.attributes.style = style;
                            } else {
                                obj.style = style;
                            }
                        }
                    },

                    /**
                     * Serializes CSS style declaration to a string.
                     *
                     * @returns {String}
                     */
                    toString: function toString() {
                        var output = [];
                        for (var i in rules) {
                            rules[i] && output.push(i, ":", rules[i], ";");
                        }

                        return output.join("");
                    }
                };
            };

            /**
             * Override to inject our call to _quoteSpecialFontNames.
             * @override
             */
            CKEDITOR.tools.parseCssText = function (styleText, normalize, nativeNormalize) {
                // Loosining up the rules for CKEditor code.

                var retval = {};

                if (nativeNormalize) {
                    // Injects the style in a temporary span object, so the browser parses it,
                    // retrieving its final format.
                    var temp = new CKEDITOR.dom.element("span");
                    temp.setAttribute("style", styleText);
                    styleText = CKEDITOR.tools.convertRgbToHex(temp.getAttribute("style") || "");
                }

                // IE will leave a single semicolon when failed to parse the style text. (#3891)
                if (!styleText || styleText == ";") {
                    return retval;
                }

                styleText.replace(/&quot;/g, "\"").replace(/\s*([^:;\s]+)\s*:\s*([^;]+)\s*(?=;|$)/g, function (match, name, value) {
                    if (normalize) {
                        name = name.toLowerCase();
                        // Normalize font-family property, ignore quotes and being case insensitive. (#7322)
                        // http://www.w3.org/TR/css3-fonts/#font-family-the-font-family-property
                        if (name == "font-family") {
                            value = value.toLowerCase().replace(/["']/g, "").replace(/\s*,\s*/g, ",");
                        }
                        value = CKEDITOR.tools.trim(value);

                        // Zmags patch start.
                        value = _quoteSpecialFontNames(name, value);
                        // Zmags patch end.
                    }

                    retval[name] = value;
                });

                return retval;
            };

            function _quoteSpecialFontNames(name, value) {
                if (name === "font-family") {
                    value = WebFontsUtil.quoteSpecialFontNames(value);
                }

                return value;
            }
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        clone = _require.clone,
        omit = _require.omit,
        isEqual = _require.isEqual,
        extend = _require.extend,
        values = _require.values;

    var Browser = __webpack_require__(39);
    var Color = __webpack_require__(194);
    var DomHandler = __webpack_require__(470);
    var Preconditions = __webpack_require__(14);

    var _require2 = __webpack_require__(30),
        dasherize = _require2.dasherize;

    /**
     * TextEditorViewHelpers is a bundle of helper functions, mainly aimed for
     * helping out TextEditorView (and CKEditorFacade) with parsing strings,
     * pulling information out of the dom, etc.
     *
     * The helper functions are not entirely pure, in that they sometimes will
     * edit the elements being passed in as arguments (or children of them).
     */


    var TextEditorViewHelpers = {
        prepareFontFamily: function prepareFontFamily(changed, model, cssFamilyNames) {
            Preconditions.isObject(changed);
            Preconditions.isModel(model);
            Preconditions.isString(cssFamilyNames);

            var fontData = {};

            if (!changed.fontFamily) {
                return changed;
            }

            changed = clone(changed);

            fontData = {
                fontFamily: changed.fontFamily,
                cssFamilyNames: cssFamilyNames,
                fontProvider: changed.fontProvider || model.get("fontProvider")
            };

            if (changed.fontMetadata) {
                fontData.meta = changed.fontMetadata;
            }

            changed.fontFamily = fontData;

            return omit(changed, "fontProvider", "fontMetadata");
        },
        getCssValueFromComputedStyle: function getCssValueFromComputedStyle(computedStyles, property) {
            Preconditions.isString(property);

            property = dasherize(property);

            var css = computedStyles[property];

            switch (property) {
                case "color":
                    {
                        css = Color.rgbaToHex(css).hex;
                        break;
                    }

                case "letter-spacing":
                    {
                        css = css = parseInt(css, 10) || 0;
                        break;
                    }

                case "font-size":
                    {
                        css = parseInt(css, 10);
                        break;
                    }

                case "line-height":
                    {
                        var fontSize = parseInt(computedStyles["font-size"], 10);
                        // The return line height value is the actual line height times the font size
                        // We need to limit it to 1 decimal and remove any trailing zero.
                        css = parseFloat((css.replace("px", "") / fontSize).toFixed(1));
                        break;
                    }

                case "text-decoration":
                    {
                        css = computedStyles.textDecorationLine ? computedStyles.textDecorationLine : css;
                        break;
                    }

                default:
                    {
                        // No need to log here.
                        break;
                    }
            }

            return css;
        },
        getCssValuesFromElements: function getCssValuesFromElements(result, properties, computedStyles) {
            Preconditions.isObject(result);
            Preconditions.isArray(properties);

            computedStyles.forEach(function (computedStyle) {
                properties.forEach(function (property) {
                    var oldValue = result[property];
                    var newValue = TextEditorViewHelpers.getCssValueFromComputedStyle(computedStyle, property);
                    var setValue = void 0;

                    if (!result.hasOwnProperty(property)) {
                        // Initial value
                        setValue = newValue;
                    } else if (isEqual(oldValue, newValue)) {
                        // Don't change the value
                        setValue = oldValue;
                    } else {
                        // Different values, so it's set to null
                        setValue = null;
                    }

                    result[property] = setValue;
                });
            });

            return result;
        },


        /**
         * Parse the passed elements to extract all "Fonts" that are applied to the elements and its descendants,
         * The "Font" is an object that consist of:
         *
         * <pre>
         * {
         *      fontProvider    : String,
         *      fontFamily      : String,
         *      fontStyle       : String,
         *      fontWeight      : string,
         *      fontMetadata    : object
         *  }
         *  </pre>
         *
         * @param {HTMLElement[]}   elements
         * @returns {Object[]}      An array of font Objects
         */
        parseFont: function parseFont(elements, container) {
            Preconditions.isArray(elements);

            elements = Array.isArray(elements) ? elements : [elements];

            var textNodeParentList = DomHandler.getTextNodeParentList(elements);

            var allFonts = textNodeParentList.reduce(function (fonts, element) {
                var computedStyles = Browser.computedStyle(element);
                var elementWithFontData = DomHandler.getParentWithFontFamily(element, container);
                var kitID = elementWithFontData.getAttribute("data-kitid");
                var projectId = elementWithFontData.getAttribute("data-projectid");
                var path = elementWithFontData.getAttribute("data-path");
                var customFontId = elementWithFontData.getAttribute("data-customfontid");
                var format = elementWithFontData.getAttribute("data-format");
                var fontMetadata = {};
                var fontStyle = computedStyles.fontStyle;
                var fontWeight = computedStyles.fontWeight;
                var fontFamily = elementWithFontData.getAttribute("data-font-family");
                var fontProvider = elementWithFontData.getAttribute("data-font-provider");
                var uid = fontProvider + fontFamily + fontStyle + fontWeight;

                if (kitID) {
                    fontMetadata.kitID = kitID;
                }

                if (projectId) {
                    fontMetadata.projectId = projectId;
                }

                if (path && customFontId && format) {
                    extend(fontMetadata, {
                        path: path,
                        customFontId: customFontId,
                        format: format
                    });
                }

                if (fontFamily) {
                    fonts[uid] = fonts[uid] || {
                        fontProvider: fontProvider,
                        fontFamily: fontFamily,
                        fontStyle: fontStyle,
                        fontWeight: fontWeight,
                        fontMetadata: fontMetadata
                    };
                }

                return fonts;
            }, {});

            return values(allFonts);
        },


        /**
         * Check how many Fonts applied to the passed elements, if there is only one Font, return it.
         * Otherwise, return empty Font.
         *
         * @param {HTMLElement[]} elements          The elements we are interested in
         * @parem {HTMLElement}   editorContainer   The editor element (which will be the container)
         * @returns {Object}
         */
        getFontData: function getFontData(elements, editorContainer) {
            Preconditions.isArray(elements);

            var fontData = {};

            for (var i in elements) {
                var elementWithFontData = DomHandler.getParentWithFontFamily(elements[i], editorContainer);
                var fontFamily = elementWithFontData.getAttribute("data-font-family");
                var fontProvider = elementWithFontData.getAttribute("data-font-provider");

                if (!fontData.fontFamily) {
                    fontData = {
                        fontFamily: fontFamily,
                        fontProvider: fontProvider,
                        fontMetadata: {
                            cssFamilyNames: elementWithFontData.style.fontFamily.split(",")
                        }
                    };

                    // Typekit
                    var kitID = elementWithFontData.getAttribute("data-kitid");
                    // Fonts.com
                    var projectId = elementWithFontData.getAttribute("data-projectid");
                    // Custom Fonts
                    var path = elementWithFontData.getAttribute("data-path");
                    var customFontId = elementWithFontData.getAttribute("data-customfontid");
                    var format = elementWithFontData.getAttribute("data-format");

                    if (kitID) {
                        fontData.fontMetadata.kitID = kitID;
                    } else if (projectId) {
                        fontData.fontMetadata.projectId = projectId;
                    } else if (path && customFontId && format) {
                        extend(fontData.fontMetadata, { path: path, customFontId: customFontId, format: format });
                    }
                }

                if (fontData.fontFamily !== fontFamily) {
                    return {
                        fontFamily: null,
                        fontProvider: null,
                        fontMetadata: {}
                    };
                }
            }

            return fontData;
        }
    };

    return TextEditorViewHelpers;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);

    /**
     * Model for the text editor.
     *
     * @class TextEditorModel
     * @constructor
     */
    return Backbone.Model.extend("Editor model", {
        defaults: {
            fontSize: 30,
            fontStyle: "normal",
            fontWeight: "400",
            color: "#000000",
            fontFamily: "Arial",
            fontProvider: "standard",
            fontMetadata: {},
            fontVariant: "none",
            lineHeight: 1.4,
            textAlign: "left",
            textDecoration: "none",
            textTransform: "none",
            letterSpacing: 0,
            textShadow: "none",
            nodeName: null
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        $ = __webpack_require__(4),
        AbstractWidgetView = __webpack_require__(61),
        SalesforceCommerce = __webpack_require__(206),
        SalesforceCommerceOCAPIServiceFactory = __webpack_require__(1021),
        SalesforceCommerceProductModel = __webpack_require__(604),
        SalesforceCommerceWidgetPreview = __webpack_require__(3005),
        Tooltip = __webpack_require__(35);

    /**
     * The view rendering an SalesforceCommerce widget.
     *
     * @class TransformableSalesforceCommerceWidgetView
     * @constructor
     *
     * @cfg {TransformableSalesforceCommerceWidgetView} The model of the SalesforceCommerce widget being rendered.
     */
    return AbstractWidgetView.extend("TransformableSalesforceCommerceWidgetView", {

        tagName: "div",

        className: AbstractWidgetView.prototype.className + " salesforce-commerce-widget",

        _$salesforceCommerceElement: null,

        /**
         * Last SalesforceCommerce product model selected.
         */
        _lastSalesforceCommerceProductModel: null,

        /**
         * The last state of this widget instance.
         */
        _lastIsSmallWidget: false,

        updateRendering: function updateRendering(element, bounds, active, edited, changedProperties) {
            if (element) {
                // Render the SalesforceCommerce container
                if (changedProperties && !_.isUndefined(changedProperties.productID)) {
                    this._renderProduct(element, bounds, changedProperties.productID, changedProperties.siteId);
                } else {
                    var productID = this.model.get("productID");
                    if (!this._$salesforceCommerceElement) {
                        if (!_.isNull(productID)) {
                            this._renderProduct(element, bounds, productID, this.model.get("siteId"));
                        } else {
                            this._renderEmptyState(element);
                        }
                    } else if (this._lastSalesforceCommerceProductModel) {
                        this._renderChangedSize(element, bounds, this._lastSalesforceCommerceProductModel);
                    }
                }
            }
        },

        /**
         * Render product when there isn't any product selected.
         *
         * @param {jQuery} element to be rendered.
         * @private
         */
        _renderEmptyState: function _renderEmptyState(element) {
            this._$salesforceCommerceElement = $("<div class='placeholder-icon'></div>");
            this._$salesforceCommerceElement.appendTo(element);
        },

        /**
         * Render image according with the size.
         *
         * @param {jQuery} element to be rendered.
         * @param {Boolean} isSmall
         * @param {SalesforceCommerceProductModel} salesforceCommerceProductModel
         * @private
         */
        _renderAccordingToSize: function _renderAccordingToSize(element, isSmall, salesforceCommerceProductModel) {
            element.empty();
            if (isSmall) {
                this._renderSmallWidget(element, salesforceCommerceProductModel);
            } else {
                this._renderBigWidget(element, salesforceCommerceProductModel);
            }
        },

        /**
         * The size has changed, this function will be sure that we render the right state.
         *
         * @param {jQuery} element to be rendered.
         * @param {Object} bounds with width/height.
         * @param {SalesforceCommerceProductModel} salesforceCommerceProductModel the current product.
         * @private
         */
        _renderChangedSize: function _renderChangedSize(element, bounds, salesforceCommerceProductModel) {
            if (this._lastIsSmallWidget !== this._isSmallWidget(bounds, salesforceCommerceProductModel)) {
                this._lastIsSmallWidget = !this._lastIsSmallWidget;
                this._renderAccordingToSize(element, this._lastIsSmallWidget, salesforceCommerceProductModel);
            }
        },

        /**
         * Render product according with its id and site id.
         *
         * @param {jQuery} element to be rendered.
         * @param {Object} bounds width/height of the product.
         * @param {Number} id to be rendered.
         * @param {String} siteObjectId the internal SalesforceCommerce siteId to search for (Mongo Object Id).
         * @private
         */
        _renderProduct: function _renderProduct(element, bounds, id, siteObjectId) {
            var self = this;

            var handlerProductBySize = function handlerProductBySize(salesforceCommerceProductModel) {
                self._lastSalesforceCommerceProductModel = salesforceCommerceProductModel;
                self._lastIsSmallWidget = self._isSmallWidget(bounds, salesforceCommerceProductModel);
                self._renderAccordingToSize(element, self._lastIsSmallWidget, salesforceCommerceProductModel);
            };

            var siteID = SalesforceCommerce.getSiteByObjectId(siteObjectId);
            SalesforceCommerceOCAPIServiceFactory.getService().getProductByIds(id, siteID).done(handlerProductBySize).fail(function () {
                handlerProductBySize(new SalesforceCommerceProductModel({ id: id, status: "fail" }));
            });
        },

        /**
         * Check if the widget is small, usually meaning smaller than the product thumbnail image.
         *
         * @param {Object} bounds Bounds of widget, containing width and height.
         * @param {SalesforceCommerceProductModel} salesforceCommerceProductModel The product shown on the widget.
         * @return {Boolean} True if a small widget, false if a big one.
         * @private
         */
        _isSmallWidget: function _isSmallWidget(bounds, salesforceCommerceProductModel) {
            var minimumSizeOfLargeWidget = 80;

            // If there is an issue with the product, the text in the box will be longer. We
            // increase the required size of the box, to avoid showing cropped text. The 130 pixels
            // have been determined empiricaly.
            if (salesforceCommerceProductModel.get("status") === "fail") {
                minimumSizeOfLargeWidget = 130;
            }

            return bounds.height < minimumSizeOfLargeWidget || bounds.width < minimumSizeOfLargeWidget;
        },

        /**
         * Render a small SalesforceCommerce icon with a tooltip.
         *
         * @param {jQuery} element to be rendered.
         * @param {SalesforceCommerceProductModel} salesforceCommerceProductModel the current product.
         * @private
         */
        _renderSmallWidget: function _renderSmallWidget(element, salesforceCommerceProductModel) {
            this._$salesforceCommerceElement = $("<div class='placeholder-icon'></div>");
            this._$salesforceCommerceElement.appendTo(element);

            var tooltipElement = this._createWidgetContainer(salesforceCommerceProductModel);
            Tooltip.add(this._$salesforceCommerceElement, {
                content: tooltipElement,
                width: 300,
                placement: "top",
                delay: {
                    show: 1000,
                    hide: 0
                }
            });
        },

        /**
         * Render the product in the big canvas.
         *
         * @param {jQuery} element to be rendered.
         * @param {SalesforceCommerceProductModel} salesforceCommerceProductModel the current product.
         * @private
         */
        _renderBigWidget: function _renderBigWidget(element, salesforceCommerceProductModel) {
            this._$salesforceCommerceElement = this._createWidgetContainer(salesforceCommerceProductModel);
            this._$salesforceCommerceElement.addClass("placeholder-preview");
            this._$salesforceCommerceElement.appendTo(element);
        },

        /**
         * Create an instance of a <tt>SalesforceCommerceWidgetPreview</tt>.
         *
         * @param {SalesforceCommerceProductModel} salesforceCommerceProductModel
         * @return {jQuery} The jQuery element for the created widget.
         * @private
         */
        _createWidgetContainer: function _createWidgetContainer(salesforceCommerceProductModel) {
            var salesforceCommerceWidgetPreview = new SalesforceCommerceWidgetPreview({
                model: salesforceCommerceProductModel
            });

            salesforceCommerceWidgetPreview.render();

            return salesforceCommerceWidgetPreview.$el;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        template = __webpack_require__(3006);

    /**
     * Product being showed in the selection of a demandware Product. It is also
     * used for the Tooltip when the widget is too small.
     *
     * @class SalesforceCommerceWidgetPreview
     */
    return Marionette.ItemView.extend({
        template: template,

        onRender: function onRender() {
            // No deferred here, the error event can already have happened...
            var self = this,
                $img = self.$("img");

            // Add img error handler function.
            $img.on("error", function () {
                $img.hide();

                self.$(".no-image").toggleClass("hide");
            });
        },

        // Reverts the error handler from img.
        onClose: function onClose() {
            var $img = this.$("img");

            $img.off("error");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3006 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="salesforce-commerce-item-preview">\n    <div class="container">\n        ';
 if (status) { ;
__p += '\n            <div class="picture">\n                <div class="icon-info"></div>\n            </div>\n            <div class="details">\n                <div>\n                    <div class="overflow">Id: ' +
__e( productID ) +
'</div>\n                </div>\n                <div>\n                    <span class="wrap">No connection! Verify that your\n                        <a href="#integrations-salesforce-commerce">DW Settings</a> are OK and that the\n                        product is still available.</span>\n                </div>\n            </div>\n        ';
 } else { ;
__p += '\n            <div class="picture">\n                ';
 if (image) { ;
__p += '\n                    <img src="' +
__e( image ) +
'" />\n                    <div class="no-image hide"\n                        title="Product image failed to load: \'' +
__e( image ) +
'\'">Failed to load</div>\n                ';
 } else { ;
__p += '\n                    <div class="no-image">No Image</div>\n                ';
 } ;
__p += '\n            </div>\n            <div class="details">\n                <div>\n                    <div class="overflow">' +
__e( name ) +
'</div>\n                </div>\n                <div>\n                    <span class="overflow">Id: ' +
__e( productID ) +
'</span>\n                </div>\n            </div>\n        ';
 } ;
__p += '\n    </div>\n</div>';

}
return __p
}

/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var MathUtil = __webpack_require__(72).default;
    var Marionette = __webpack_require__(10);
    var WidgetTypes = __webpack_require__(69);
    var FreeTransform = __webpack_require__(1234);
    var Preconditions = __webpack_require__(14);
    var TransformerManager = __webpack_require__(3011);

    return Marionette.Controller.extend({

        _freeTransform: null,

        _viewModel: null,

        _borderClass: {
            dynamicProductWidget: "dynamic-product-widget-border"
        },

        initialize: function initialize(_ref) {
            var layer = _ref.layer,
                scene = _ref.scene,
                viewModel = _ref.viewModel;

            Preconditions.checkArgument(layer);
            Preconditions.checkArgument(scene);
            Preconditions.checkArgument(viewModel);

            this._viewModel = viewModel;

            this._freeTransform = new FreeTransform({
                layer: layer,
                scene: scene,
                viewModel: viewModel
            });

            TransformerManager.add(this._freeTransform);
            this._addListeners();
        },
        setViewportBoundingBoxProvider: function setViewportBoundingBoxProvider(viewportBoundingBoxProviderFunction) {
            this._freeTransform.setBoundingBoxProvider(viewportBoundingBoxProviderFunction);
        },
        translate: function translate(x, y) {
            this._freeTransform.translate(x, y);
        },
        _addListeners: function _addListeners() {
            this.listenTo(this._freeTransform, FreeTransform.TARGET_TRANSFORMED, this._updateWidgetModel);
            this.listenTo(this._freeTransform, "all", this._delegateEvent);
            this.listenTo(this._freeTransform, FreeTransform.MOUSEDOWN, this._setWidgetsSelection);
        },


        /**
         * Set the selected widgets from the targets, targets can be empty array
         * @param {TElement[]} targets  array of targets
         * @private
         */
        _setWidgetsSelection: function _setWidgetsSelection(targets) {
            var widgets = _.pluck(_.pluck(targets, "data"), "widget");
            this.trigger("setSelectedWidgets", widgets);
        },


        /**
         * Trigger events on widgets that are passed from FreeTransform
         * @param {String} eventName    An event name passed in
         * @param {TElement} target     The target passed from Freetransform, the widget can be accessed from the data attribute
         * @private
         */
        _delegateEvents: function _delegateEvents(eventName, target) {
            var widget = target[0].data && target[0].data.widget;
            if (widget) {
                widget.trigger(eventName);
            }
        },


        // Destroy free transform when the scene is closed
        // We only remove the reference to the freeTransform and let it be collected by GC
        removeTransformer: function removeTransformer() {
            TransformerManager.remove(this._freeTransform);
        },
        editorRenderHandler: function editorRenderHandler(scale) {
            this._freeTransform.setContainer(this.options.container);
            this.updateControls(scale);
        },


        /**
         * Adds a widget to FreeTransform so you can interact with it
         *
         * @param itemView
         */
        addWidget: function addWidget(itemView) {
            var parentTransform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var type = itemView.model.get("type");

            this._freeTransform.add(itemView.el, {
                controls: WidgetTypes.lookup(type).freeTransformConfig,
                widget: itemView,
                parentTransform: parentTransform
            });
        },
        removeWidget: function removeWidget(itemView) {
            this._freeTransform.remove(itemView.el);
        },


        /**
         * Updates FreeTransform controls
         */
        updateControls: function updateControls(scale) {
            this._freeTransform.updateControls(scale);
            var selection = this.options.viewModel.selection;

            // Change the control/border color if the widget is a dynamic-product
            if (selection && selection.get("widgets") && this._isDynamicProductWidgetSelected(selection.get("widgets"))) {
                this._freeTransform.setClass(this._borderClass.dynamicProductWidget);
            } else {
                this._freeTransform.removeClass(this._borderClass.dynamicProductWidget);
            }
        },


        /**
         * Hides FreeTransform controls
         */
        hideControls: function hideControls() {
            this._freeTransform.hideControls();
        },


        /**
         * Selects a widget (updating controls, etc)
         */
        selectWidget: function selectWidget(views) {
            if (views.length) {
                this._freeTransform.select(_.pluck(views, "el"));
                // Change the border color of the controls if the widget is a dynamic-product
                if (this._isDynamicProductWidgetSelected(views)) {
                    this._freeTransform.setClass(this._borderClass.dynamicProductWidget);
                } else {
                    this._freeTransform.removeClass(this._borderClass.dynamicProductWidget);
                }
            } else {
                this._freeTransform.deselect();
                this.hideControls();
            }
        },
        _updateWidgetModel: function _updateWidgetModel(targets) {
            var _this = this;

            targets.forEach(function (target) {
                _this._updateWidgetFromMatrix(target.data.widget, target.getMatrix());
            });
        },
        _updateWidgetFromMatrix: function _updateWidgetFromMatrix(widget, matrix) {
            var scaledSize = widget.model.getScaledSize(matrix.getScaleX(), matrix.getScaleY());
            var experience = widget.viewModel.get("experience");
            var normalizedScaledSize = {};
            // Round dimensions and positioning to contain exactly required for
            // experience size values accuracy. Uses here for the changes has been made
            // widgets transformations
            if (scaledSize.width) {
                normalizedScaledSize.width = MathUtil.roundToContain(scaledSize.width, experience.get("width"));
            }
            if (scaledSize.height) {
                normalizedScaledSize.height = MathUtil.roundToContain(scaledSize.height, experience.get("height"));
            }
            var experienceSize = this._viewModel.get("experience").getSize();
            var properties = {
                left: MathUtil.roundToContain(matrix.x / experienceSize.width * 100, experience.get("width")),
                top: MathUtil.roundToContain(matrix.y / experienceSize.height * 100, experience.get("height")),
                rotation: matrix.getRotation()
            };

            _.extend(properties, normalizedScaledSize);
            widget.model.set(properties, { render: true });
            widget.model.trigger("transformed");
        },
        _delegateEvent: function _delegateEvent() {
            this.trigger.apply(this, arguments);
        },
        _isDynamicProductWidgetSelected: function _isDynamicProductWidgetSelected(widgets) {
            return widgets.length === 1 && widgets[0].model.get("type") === WidgetTypes.DYNAMIC_PRODUCT.id;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var Matrix = __webpack_require__(204);
    var Control = __webpack_require__(1235);
    var TGroup = __webpack_require__(718);
    var WidgetTypes = __webpack_require__(69);
    var EditorActivityManager = __webpack_require__(197);
    var UUIDGenerator = __webpack_require__(250);
    /**
     * Controls class manages all the controls for transformable elements
     * Controls is a collection of {@link Control}
     *
     * @param container
     * @constructor
     */
    function Controls(container) {
        this.container = container;
        this.target = null;
        this.scale = 1;
        this.isMoving = false;

        // transform interaction
        // where interaction starts
        this.startX = 0;
        this.startY = 0;

        // transforms to apply
        this.preMatrix = new Matrix();
        this.postMatrix = new Matrix();

        // where interaction ends
        this.endX = 0;
        this.endY = 0;

        // transform UV delta
        this.dU = 0;
        this.dV = 0;

        this.regU = 0.5;
        this.regV = 0.5;
        // registration point in px
        this.regX = 0;
        this.regY = 0;

        // inverted matrices
        this.inv = new Matrix();

        // transform controls
        this.control = null;
        this.controls = Controls.defaults();

        this.draw();
        // hide initially
        this.hide();
    }

    Controls.defaults = function () {
        return [new Control(Control.BORDER), new Control(Control.TARGET), new Control(Control.EDGE_TRANSLATE, 0, 0, -10, -10, null), new Control(Control.SCALE_X, 0, 0.5, 0, 0, "w"), new Control(Control.ROTATE_SCALE, 0, 0.5, 0, 0, null), new Control(Control.SCALE_X, 1, 0.5, 0, 0, "e"), new Control(Control.ROTATE_SCALE, 1, 0.5, 0, 0, null), new Control(Control.SCALE_Y, 0.5, 0, 0, 0, "n"), new Control(Control.SCALE_Y, 0.5, 1, 0, 0, "s"), new Control(Control.SCALE_UNIFORM, 0, 0, 0, 0, "nw"), new Control(Control.SCALE_UNIFORM, 0, 1, 0, 0, "sw"), new Control(Control.SCALE_UNIFORM, 1, 0, 0, 0, "ne"), new Control(Control.SCALE_UNIFORM, 1, 1, 0, 0, "se"), new Control(Control.ROTATE, 0.5, 1, 0, 15, null)];
    };

    Controls.prototype = {
        setTarget: function setTarget(target) {
            if (target) {
                this.target = target;
                this.updateFromTarget();
            }
        },
        removeTarget: function removeTarget() {
            this.target = null;
            this.hide();
        },
        targetIs: function targetIs(t) {
            return !!this.target && this.target === t;
        },
        hasTarget: function hasTarget() {
            return !!this.target;
        },


        /**
         * Update the target when mouse clicks, this handles multiple-selection mode also.
         * @param {TElement} transformableElement
         */
        updateTarget: function updateTarget(transformableElement, modifier) {
            if (!transformableElement) {
                this.removeTarget();
                return;
            }

            if (transformableElement === this.target) {
                return;
            }

            var newTarget = this.target; // default to the current one
            var isTGroup = this.target instanceof TGroup;

            if (modifier && this.target) {
                newTarget = isTGroup ? this.target : new TGroup([this.target]);

                if (newTarget.has(transformableElement)) {
                    newTarget.remove(transformableElement);
                } else {
                    newTarget.add(transformableElement);
                }

                // covert back to a single element
                if (newTarget.members.length === 1) {
                    newTarget = this.target.members[0];
                }
            } else if (!(isTGroup && this.target.has(transformableElement))) {
                newTarget = transformableElement;
            }

            this.setTarget(newTarget);
        },
        updateFromTarget: function updateFromTarget(scale) {
            this.scale = scale || this._getContainerScale();

            if (this.target) {
                this.target.updateFromTarget();
                this.update();
                this.config(this.target.getControlsConf());
            }
        },
        _getContainerScale: function _getContainerScale() {
            return Matrix.createFromDom(document.getElementById("experiences-region")).getScaleX();
        },


        /**
         * Show or hide each control in the control set according to the configuration
         *
         * @param configure
         */
        config: function config(configure) {
            this.controls.forEach(function (control) {
                control.setDisplay(configure[control.type] === false ? "none" : "");
            });
        },
        findControlByType: function findControlByType(type) {
            return _.find(this.controls, function (control) {
                return control.type === type;
            });
        },
        getControlAt: function getControlAt(x, y) {
            // walking in reverse order to find those
            // drawn on top (later in list) first
            var i = this.controls.length;
            while (i--) {
                if (this.controls[i].contains(x, y, this.target)) {
                    return this.controls[i];
                }
            }

            // control not found
            return null;
        },


        /**
         * Find the counter control as fixed point when scaling
         */
        _findCounterControl: function _findCounterControl(control) {
            if (!control || control.type === Control.ROTATE) return null;

            var counterU = Math.abs(control.u - 1);
            var counterV = Math.abs(control.v - 1);

            return _.find(this.controls, function (ctr) {
                return ctr.u === counterU && ctr.v === counterV;
            });
        },
        draw: function draw() {
            _.invoke(this.controls, "draw", this.container);
        },


        /**
         *  Update the current controls to reflect the target transformation
         */
        update: function update() {
            var _this = this;

            // Moving widgets (dragging/rotating/scaling) require immediate updates to appear responsive.
            if (this.isMoving) {
                this.onUpdate();
            } else {
                _.defer(function () {
                    _this.onUpdate();
                });
            }
        },
        onUpdate: function onUpdate() {
            var _this2 = this;

            var target = this.target;
            if (!target) {
                return;
            }
            var matrix = target.getMatrixWithParentOffset();

            matrix.x *= this.scale;
            matrix.y *= this.scale;
            this.controls.forEach(function (control) {
                control.updatePosition(matrix, target.getWidth() * _this2.scale, target.getHeight() * _this2.scale);
            });
        },


        /**
         * Prepare the initial state before transformation
         *
         * @param x  coordinate x when the mouse is down
         * @param y  coordinate y when the mouse is down
         * @param control  used as default control when no control found
         */
        start: function start(x, y) {
            this.commit();
            this.control = this.getControlAt(x, y) || this.findControlByType(Control.TARGET);

            this.startX = x;
            this.startY = y;
            this.dU = 0;
            this.dV = 0;
            this.setLocalReg();
            this.setGlobalReg();
        },
        move: function move(x, y) {
            var _this3 = this;

            // Need to track, if the active widget is image
            // And if the cropping are active
            // To prevent dragging conflicts
            if (this.target.data && WidgetTypes.lookup(this.target.data.widget.model.get("type")).id === "image") {
                if (this.target.data.widget.model.get("isDragAvailable") === false) {
                    return;
                }
            }

            if (!this.isMoving) {
                this.isMoving = true;
                this.target.setAttr("data-transforming", true);
                this.addClass("transforming");
                if (this.target.data && this.target.data.widget) {
                    this.target.data.widget.model.set("isTransforming", true);
                }

                if (this.target.members) {
                    EditorActivityManager.setBatchActivityId(UUIDGenerator.createUUID());
                }
            }
            this.computeMoveValues(x, y);
            if (this.control) {
                this.computeTransformOffset();
                this.target.transform(this.preMatrix, this.postMatrix, this.regU, this.regV);
            }
            // use requestAnimationFrame will improve the performance
            window.requestAnimationFrame(function () {
                if (_this3.target && _this3.target.draw) {
                    _this3.target.draw();
                }
                _this3.update();
            });
        },
        end: function end() {
            if (this.target.members && this.isMoving) {
                EditorActivityManager.setBatchActivityId(null);
            }
            this.target.setAttr("data-transforming", "");
            this.removeClass("transforming");
            this.isMoving = false;
            if (this.target.data && this.target.data.widget) {
                this.target.data.widget.model.set("isTransforming", false);
            }
            this.commit();
            this.update();
            this.control = null;
        },
        computeMoveValues: function computeMoveValues(x, y) {
            this.endX = x;
            this.endY = y;

            this.cx = (this.endX - this.startX) / this.scale;
            this.cy = (this.endY - this.startY) / this.scale;

            // inline transformPoint to target local space
            this.dU = (this.inv.a * this.cx + this.inv.c * this.cy) / this.target.width;
            this.dV = (this.inv.d * this.cy + this.inv.b * this.cx) / this.target.height;
        },


        /**
         * Compute the transformation, the result is the variation to the starting point
         *
         * Note: the transformation natively happens in this order: scale first, then translate or rotate,
         * the order affects the result, this is why we need preMatrix and postMatrix variables.
         */
        computeTransformOffset: function computeTransformOffset() {
            var w = this.target.width;
            var h = this.target.height;
            var x = 0;
            var y = 0;

            // difference between registration and control points
            var cu = this.control.u - this.regU;
            var cv = this.control.v - this.regV;

            this.preMatrix.identity();
            this.postMatrix.identity();

            // if the abs px difference is less than 0, normalize to
            // 1 (or -1) to prevent outrageous divisions by 0 or a
            // very small number resulting in oversized transforms
            if (cu > 0) {
                if (cu * w < 1) {
                    cu = 1 / w;
                }
            } else if (cu * w > -1) {
                cu = -1 / w;
            }

            if (cv > 0) {
                if (cv * h < 1) {
                    cv = 1 / h;
                }
            } else if (cv * h > -1) {
                cv = -1 / h;
            }

            // perform transform based on control type
            switch (this.control.type) {
                case Control.SCALE:
                    {
                        x = (cu + this.dU) / cu;
                        y = (cv + this.dV) / cv;
                        this.preMatrix.scale(x, y);
                        break;
                    }

                case Control.SCALE_X:
                    {
                        x = (cu + this.dU) / cu;
                        this.preMatrix.scale(x, 1);
                        break;
                    }

                case Control.SCALE_Y:
                    {
                        y = (cv + this.dV) / cv;
                        this.preMatrix.scale(1, y);
                        break;
                    }

                case Control.SCALE_UNIFORM:
                    {
                        x = (cu + this.dU) / cu;
                        y = (cv + this.dV) / cv;

                        // find the ratio to make the scaling
                        // uniform in both the x (w) and y (h) axes
                        w = y ? Math.abs(x / y) : 0;
                        h = x ? Math.abs(y / x) : 0;

                        // for 0 scale, scale both axises to 0
                        if (w === 0 || h === 0) {
                            x = 0;
                            y = 0;

                            // scale mased on the smaller ratio
                        } else if (w > h) {
                            x *= h;
                        } else {
                            y *= w;
                        }

                        this.preMatrix.scale(x, y);
                        break;
                    }

                case Control.ROTATE_SCALE:
                    {
                        // rotation in global space
                        x = this.startX - this.regX;
                        y = this.startY - this.regY;
                        var ex = this.endX - this.regX;
                        var ey = this.endY - this.regY;

                        var angle = Math.atan2(ey, ex) - Math.atan2(y, x);
                        this.postMatrix.rotate(angle);

                        // determine scale factor from change
                        // this is also done in global space
                        // in matching with the rotation
                        var s = Math.sqrt(x * x + y * y);
                        if (s === 0) {
                            this.preMatrix.scale(0, 0);
                        } else {
                            s = Math.sqrt(ex * ex + ey * ey) / s;
                            this.preMatrix.scale(s, 1);
                        }
                        break;
                    }

                case Control.ROTATE:
                    {
                        // rotation in global space
                        x = Math.atan2(this.startY - this.regY, this.startX - this.regX);
                        y = Math.atan2(this.endY - this.regY, this.endX - this.regX);
                        this.postMatrix.rotate(y - x);
                        break;
                    }

                case Control.EDGE_TRANSLATE:
                case Control.TARGET:
                    {
                        // translate in global space
                        this.postMatrix.translate(this.cx, this.cy);
                        break;
                    }

                default:
                    break;
            }
        },


        // commit the end state when transformation ends
        commit: function commit() {
            this.target.commit();

            // update inversion matrix
            this.inv.copyFrom(this.target.startMatrix);
            this.inv.invert();
        },


        /**
         * The registration(pivot) point in local space for scaling and rotating
         */
        setLocalReg: function setLocalReg() {
            var counterControl = this._findCounterControl(this.control);

            if (counterControl) {
                this.regU = counterControl.u;
                this.regV = counterControl.v;
            } else {
                this.regU = 0.5;
                this.regV = 0.5;
            }
        },


        /**
         * The registration(pivot) point in global space for scaling and rotating
         */
        setGlobalReg: function setGlobalReg() {
            var x = this.regU * this.target.width * this.scale;
            var y = this.regV * this.target.height * this.scale;
            var m = this.target.getMatrix();

            m.x *= this.scale;
            m.y *= this.scale;
            m = m.getGlobalCoordByLocalCoord(x, y);

            this.regX = m.x;
            this.regY = m.y;
        },


        /**
         * Show all controls, we need to respect the control configuration here
         */
        show: function show() {
            this.config(this.target.getControlsConf());
        },


        /**
         * Hide all controls
         */
        hide: function hide() {
            this.controls.forEach(function (control) {
                control.setDisplay("none");
            });
        },
        setControlClass: function setControlClass(value) {
            this.controls.forEach(function (control) {
                control.setClass(value);
            });
        },
        removeControlClass: function removeControlClass(value) {
            this.controls.forEach(function (control) {
                control.removeClass(value);
            });
        },
        addClass: function addClass(className) {
            if (this.container.className.indexOf(className) === -1) {
                this.container.className = className + " " + this.container.className;
            }
        },
        removeClass: function removeClass(className) {
            this.container.className = this.container.className.replace(className, "");
        },
        isTransformed: function isTransformed() {
            return this.target.isTransformed();
        },
        translate: function translate(x, y) {
            this.target.translate(x, y);
            this.update();
        }
    };

    return Controls;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defaults = _require.defaults,
        extend = _require.extend,
        pluck = _require.pluck;

    var Matrix = __webpack_require__(204);
    var Transformable = __webpack_require__(1236);

    var DEFAULT_CONTROL_OPTIONS = {
        rotateScale: false,
        edgeTranslate: false
    };

    /**
     * An TElement object is a wrapper of dom element which extends from the abstract class {@link Transformable}
     *
     * @param domElem   raw dom element
     * @param data  controls for this element
     * @constructor
     */
    function TElement(domElem, data) {
        this.domElem = domElem;
        this.data = data;
        this.startMatrix = new Matrix();
        this.endMatrix = new Matrix();

        this.border = 2;

        this.data.controls = defaults(this.data.controls || {}, DEFAULT_CONTROL_OPTIONS);

        this.setOrigin(0, 0);
    }

    // extends from transformable abstract class
    TElement.prototype = extend(new Transformable(), {
        draw: function draw() {
            // apply a clone of the matrix to the element with x and y
            // rounded off to nearest int. avoids blurred text in webkit.
            var appliedMatrix = this.matrix.clone();
            appliedMatrix.x = Math.round(this.matrix.x);
            appliedMatrix.y = Math.round(this.matrix.y);

            this._setStyle("transform", appliedMatrix.toString());
        },
        getZIndex: function getZIndex() {
            return this.domElem.style.zIndex;
        },
        setOrigin: function setOrigin(x, y) {
            this._setStyle("transformOrigin", x + " " + y);
        },


        /**
         * Safely apply css style to the element.
         * @param {String} styleName    The css property
         * @param {String} styleValue   The css value
         */
        _setStyle: function _setStyle(styleName, styleValue) {
            if (!this.domElem) {
                return;
            }

            this.domElem.style[styleName] = styleValue;
        },
        getControlsConf: function getControlsConf() {
            return this.data.controls;
        },
        setTransparency: function setTransparency(opacity) {
            this.domElem.style.opacity = opacity;
        },


        /**
         * Get the width of this element
         * @returns {int} the width
         */
        getWidth: function getWidth() {
            return this.domElem.offsetWidth || this.domElem.clientWidth;
        },


        /**
         * Get the height of this element
         * @returns {int} the height
         */
        getHeight: function getHeight() {
            return this.domElem.offsetHeight || this.domElem.clientHeight;
        },


        /**
         * Get the matrix for current target
         * @returns {Matrix} an matrix object
         */
        getMatrix: function getMatrix() {
            return Matrix.createFromDom(this.domElem);
        },
        getMatrixWithParentOffset: function getMatrixWithParentOffset() {
            var matrix = this.getMatrix();
            if (this.data.parentTransform) {
                matrix.x += this.data.parentTransform.x;
                matrix.y += this.data.parentTransform.y;
            }
            return matrix;
        },
        _getAxis: function _getAxis(axis) {
            var coords = this.getCornerCoordinates();
            return pluck(coords, axis);
        },
        setAttr: function setAttr(attr, value) {
            this.domElem.setAttribute(attr, value);
        }
    });

    return TElement;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    /**
     * Captures mouse position within the context of a DOM element.
     */

    var Mouse = {};

    Mouse.x = 0;
    Mouse.y = 0;

    // Set to false since we do not support touch event for now.
    Mouse.isTouchSupported = false;
    Mouse.START = Mouse.isTouchSupported ? "touchstart" : "mousedown";
    Mouse.MOVE = Mouse.isTouchSupported ? "touchmove" : "mousemove";
    Mouse.END = Mouse.isTouchSupported ? "touchend" : "mouseup";

    Mouse.get = function (event, elem) {
        if (!elem) {
            elem = event.currentTarget;
        }

        if (event.touches) {
            if (event.touches.length) {
                Mouse.x = parseInt(event.touches[0].pageX, 10);
                Mouse.y = parseInt(event.touches[0].pageY, 10);
            }
        } else {
            // mouse events
            Mouse.x = parseInt(event.clientX, 10);
            Mouse.y = parseInt(event.clientY, 10);
        }

        var rect = elem.getBoundingClientRect();
        Mouse.x += elem.scrollLeft - elem.clientLeft - rect.left;
        Mouse.y += elem.scrollTop - elem.clientTop - rect.top;

        return undefined;
    };

    return Mouse;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var FreeTransform = __webpack_require__(1234);

    /**
     * A coordinator/manager of all freeTransforms on the editor
     */
    var TransformerManager = Marionette.Controller.extend({

        _transfomers: [],

        add: function add(transfomer) {
            this._transfomers.push(transfomer);
            this.listenTo(transfomer, FreeTransform.MOUSEDOWN, this._mouseDownEvent);
        },
        remove: function remove(transfomer) {
            var _this = this;

            this._transfomers.forEach(function (item, index) {
                if (item.cid === transfomer.cid) {
                    _this._transfomers.splice(index, 1);
                }
            });
        },
        getLength: function getLength() {
            return this._transfomers.length;
        },


        /**
         * Handles a click event on a scene, which should deselect any selected widgets on other scenes
         * @param target   selected target
         * @param freeTransform the free transform for the scene
         * @private
         */
        _mouseDownEvent: function _mouseDownEvent(target, freeTransform) {
            this._transfomers.forEach(function (transfomer) {
                if (freeTransform.cid !== transfomer.cid && transfomer.hasTarget()) {
                    transfomer.deselect();
                }
            });
        }
    });

    // A singleton
    return new TransformerManager();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3012 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="background-widgets-container"></div>\n<div class="scene-widgets-container"></div>\n<div class="overlay-widgets-container"></div>\n';

}
return __p
}

/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var EventDispatcher = __webpack_require__(54);
    var Gridsets = __webpack_require__(3014);
    var Marionette = __webpack_require__(10);
    var Preconditions = __webpack_require__(14);
    var SnapUtils = __webpack_require__(1237);

    // Tools & Constants
    var SNAPLINE_NUDGE = 1;
    var THROTTLE_TIME = 100;

    return Marionette.Behavior.extend({
        grid: null,

        offset: null,

        selectedElements: null,

        snappingEnabled: false,

        constructor: function constructor(config, sceneEditor) {
            this._sceneEditor = sceneEditor;
            this._eventHandler = new EventDispatcher();
            _.bindAll(this, "selectWidget", "moveWidget", "dragEnd", "_buildGridlines", "_setSnappingEnabled");
            this.throttledMoveThis = _.throttle(this.moveWidget, THROTTLE_TIME);
        },
        onRender: function onRender() {
            // Attaching events onRender and not onShow, because the scenes are re-rendered when the size of an
            // experience is changed (but not re-shown).
            this._eventHandler.stopListening() // Make sure we don't attach the same events multiple times.
            .listenTo(this._sceneEditor.sceneWidgetCollectionView, {
                "select_target": this.selectWidget,
                "translating": this.throttledMoveThis,
                "transforming_end": this.dragEnd
            }).listenTo(this._sceneEditor.viewScope.viewModel, "change:rulersShown", this._buildGridlines).listenTo(this._sceneEditor.viewScope.viewModel, "change:snappingEnabled", this._setSnappingEnabled).listenTo(this._sceneEditor.model.get("guidelines"), "add change remove", this._buildGridlines);
        },
        onShow: function onShow() {
            var experienceModel = this._sceneEditor.experienceModel;
            var snappingEnabled = this._sceneEditor.viewScope.viewModel.get("snappingEnabled");
            this._setSnappingEnabled(experienceModel, snappingEnabled);
        },
        onClose: function onClose() {
            this._eventHandler.stopListening();
        },


        // Sets selected widgets and builds the internal gridsets used for snapping
        selectWidget: function selectWidget(selectedTElements, allTransformables, selectedTransformable) {
            this._setSelectedElements(selectedTransformable);

            this._buildGridlines();
        },


        // Performs the actual snapping. Throttled.
        moveWidget: function moveWidget(selectedTElements, allTransformables, selectedTransformable) {
            if (!this.snappingEnabled) {
                return;
            }

            var snaplines = this.calculateSnaplinePosition(selectedTransformable);

            if (snaplines.offset.x === undefined && snaplines.offset.y === undefined) {
                this._hideAllElements();
            }

            if (snaplines.offset.x !== undefined) {
                this._showSnapline(snaplines.transformableCornersAndCenterOffset, snaplines.offset.x, "vertical");
            }

            if (snaplines.offset.y !== undefined) {
                this._showSnapline(snaplines.transformableCornersAndCenterOffset, snaplines.offset.y, "horizontal");
            }

            // For dragEnd
            this.offset = snaplines.offsetGrid;
        },


        // Called when dragging ends. Moves the widget into place if it is currently snapped
        dragEnd: function dragEnd() {
            var _this = this;

            this._sceneEditor.trigger("isWidgetDragging", false);

            setTimeout(function () {
                _this._hideAllElements();

                if (_this.offset && _.some(_this.offset)) {
                    var offsetX = _this.offset.x ? _this.offset.x.offset : 0;
                    var offsetY = _this.offset.y ? _this.offset.y.offset : 0;
                    _this._sceneEditor.sceneWidgetCollectionView.activeLayerWidgetCollectionView().transformer.translate(offsetX, offsetY);
                }

                _this.offset = {};
            }, THROTTLE_TIME + 50);
        },
        _setSnappingEnabled: function _setSnappingEnabled(experienceModel, snappingEnabled) {
            this.snappingEnabled = snappingEnabled;
        },
        _hideAllElements: function _hideAllElements() {
            this._sceneEditor.ui.snapReplacement.hide();
            this._sceneEditor.ui.snapLineVertical.hide();
            this._sceneEditor.ui.snapLineHorizontal.hide();
            this._sceneEditor.ui.snapCross.hide();
            this._sceneEditor.ui.widgetContainer.removeClass("domElSnapped");
        },
        _getSceneSize: function _getSceneSize() {
            var sceneSize = {
                width: this._sceneEditor.experienceModel.get("width"),
                height: this._sceneEditor.experienceModel.get("height")
            };

            // Side effect
            this._setCrossPosition(sceneSize);

            return sceneSize;
        },
        _setCrossPosition: function _setCrossPosition(sceneSize) {
            this._sceneEditor.ui.snapCross.css({
                left: Math.round(sceneSize.width / 2),
                top: Math.round(sceneSize.height / 2)
            });
        },
        _lineIsFromscene: function _lineIsFromscene(coordinate, sceneSize, direction) {
            switch (direction) {
                case "vertical":
                    return coordinate === Math.round(sceneSize.width / 2);

                case "horizontal":
                    return coordinate === Math.round(sceneSize.height / 2);

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Direction '" + direction + "' not recognized.");
                    break;
            }
        },
        _drawSnaplines: function _drawSnaplines(direction, coordinate, min, max) {
            var sceneSize = this._getSceneSize();

            switch (direction) {
                case "vertical":
                    this._sceneEditor.ui.snapLineVertical.css({
                        left: coordinate === sceneSize.width ? coordinate - SNAPLINE_NUDGE : coordinate,
                        top: min,
                        height: Math.min(max - min, sceneSize.height)
                    }).show();
                    break;

                case "horizontal":
                    this._sceneEditor.ui.snapLineHorizontal.css({
                        left: min,
                        width: Math.min(max - min, sceneSize.width),
                        top: coordinate === sceneSize.height ? coordinate - SNAPLINE_NUDGE : coordinate
                    }).show();
                    break;

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Direction '" + direction + "' not recognized.");
                    break;
            }

            if (this._lineIsFromscene(coordinate, sceneSize, direction)) {
                this._sceneEditor.ui.snapCross.show();
            }

            this._sceneEditor.ui.widgetContainer.addClass("domElSnapped");
        },
        _getRotateCssObject: function _getRotateCssObject(matrix) {
            return { transform: matrix.toString(), transformOrigin: "0 0" };
        },
        _showReplacement: function _showReplacement(matrix, width, height) {
            var css = _.extend({ width: width, height: height }, this._getRotateCssObject(matrix));

            return this._sceneEditor.ui.snapReplacement.css(css).show();
        },


        /**
         * Public API for calculating the position the snaplines (and therefore widget) should be placed at.
         * @param {TElement} transformable element being transformed
         * @returns {Object} object containing properties about the snaplines to be applied
         * - transformableCornersAndCenterOffset: corners and center of the transformable element
         * - offset object containing `x` and `y` properties, which are the snaplines that are shown on those axes.
         * each key can be a `number` or `undefined` (if no snapline is applicable to be drawn)
         * - offsetGrid
         */
        calculateSnaplinePosition: function calculateSnaplinePosition(transformable) {
            var offsetGrid = this.grid.getOffset(transformable);
            var offsetMatrix = this._getOffsetMatrix(offsetGrid, transformable.getMatrix());
            var width = transformable.getWidth();
            var height = transformable.getHeight();
            var replacement = this._showReplacement(offsetMatrix, width, height);

            // Creating the snaplines
            var transformableCornersAndCenterOffset = this._addCenter(SnapUtils.getRoundedCornerCoordinatesFromDom(replacement));
            var offsetX = offsetGrid.x && offsetGrid.x.value + offsetGrid.x.offset;
            var offsetY = offsetGrid.y && offsetGrid.y.value + offsetGrid.y.offset;

            return {
                transformableCornersAndCenterOffset: transformableCornersAndCenterOffset,
                offset: {
                    x: offsetX,
                    y: offsetY
                },
                offsetGrid: offsetGrid
            };
        },
        _addCenter: function _addCenter(corners) {
            var xs = _.pluck(corners, "x");
            var ys = _.pluck(corners, "y");
            var x = Math.round((_.min(xs) + _.max(xs)) / 2);
            var y = Math.round((_.min(ys) + _.max(ys)) / 2);
            corners.push({ x: x, y: y });

            return corners;
        },
        _showSnapline: function _showSnapline(offsetCorners, offset, direction) {
            var a = direction === "vertical" ? "x" : "y";
            var b = direction === "vertical" ? "y" : "x";

            var corners = offsetCorners.filter(function (o) {
                return o[a] === offset;
            });
            var allCorners = this.grid.getSet(direction, offset).concat(_.pluck(corners, b));

            this._drawSnaplines(direction, offset, _.min(allCorners), _.max(allCorners));
        },
        _getOffsetMatrix: function _getOffsetMatrix(offset, matrix) {
            if (offset.x) {
                matrix.x = Math.round(matrix.x + offset.x.offset);
            }

            if (offset.y) {
                matrix.y = Math.round(matrix.y + offset.y.offset);
            }

            return matrix;
        },
        _addElementToGrid: function _addElementToGrid(el) {
            if (!_.contains(this.selectedElements, el)) {
                this.grid.addElement(el);
            }
        },
        _buildGridlines: function _buildGridlines() {
            this.grid = new Gridsets(this._getSceneSize());

            var allWidgetElements = this._sceneEditor.sceneWidgetCollectionView.activeLayerWidgetCollectionView().children.pluck("el");
            _.each(allWidgetElements, this._addElementToGrid, this);

            if (this._sceneEditor.viewScope.viewModel.get("rulersShown")) {
                this.grid.addGuidelines(this._sceneEditor.model.get("guidelines"));
            }
        },
        _setSelectedElements: function _setSelectedElements(transformables) {
            if (transformables) {
                this.selectedElements = transformables.domElem ? [transformables.domElem] : // one selected
                _.pluck(transformables.members, "domElem"); // multiple selected
            } else {
                this.selectedElements = []; // none selected
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);

    var _require = __webpack_require__(1),
        uniq = _require.uniq,
        pluck = _require.pluck,
        first = _require.first,
        isEmpty = _require.isEmpty,
        where = _require.where,
        union = _require.union;

    var GeneralFunctions = __webpack_require__(193);
    var GuidelineModel = __webpack_require__(252);
    var SnapUtils = __webpack_require__(1237);
    var THRESHOLD = 8;

    function getClosestValueFromOneListInAnother(arr, arr2) {
        var mappedArr = arr.map(getClosestValueFromArr(arr2));
        var index = 0;
        var smallestDiff = Infinity;

        for (var i = 0; i < arr.length; i++) {
            var diff = Math.abs(arr[i] - mappedArr[i]);
            if (diff < smallestDiff) {
                index = i;
                smallestDiff = diff;
            }
        }

        return { value: arr[index], newValue: mappedArr[index] };
    }

    // Assumes the array is sorted, and not very big.
    var getClosestValueFromArr = GeneralFunctions.curry(function (arr, n) {
        var below = first(arr);
        var above = first(arr);

        for (var i = 0; above < n; i++) {
            if (arr[i] < n) {
                below = arr[i];
            } else {
                above = arr[i];
            }
        }

        return above - n < n - below ? above : below;
    });

    /**
     * GridSet
     */
    return Class.extend({

        vList: null, // Contains a list of vertical coordinates
        hList: null, // Contains a list of horizontal coordinates
        vSet: null, // Contains the horizontal points of each vertical line
        hSet: null, // Contains the vertical points of each horizontal line
        sceneSize: null,

        constructor: function constructor(sceneSize) {
            this.sceneSize = sceneSize;

            // Some variables for setting up the gridset.
            var sceneHeight = sceneSize.height;
            var sceneHeight2 = Math.round(sceneHeight / 2);
            var sceneWidth = sceneSize.width;
            var sceneWidth2 = Math.round(sceneWidth / 2);

            // The lists container just the raw snapline coordinates. They
            // shoud always be uniq and sorted. They are used for lookups.
            this.vList = [0, sceneWidth2, sceneWidth];
            this.hList = [0, sceneHeight2, sceneHeight];

            // The sets contains the min and max coordinate
            // belonging to each snapline coordinate
            this.vSet = { "_0": [0, sceneWidth] };
            this.hSet = { "_0": [0, sceneWidth] };

            this.vSet["_" + sceneWidth2] = [sceneHeight2];
            this.vSet["_" + sceneWidth] = [0, sceneHeight];
            this.hSet["_" + sceneHeight2] = [sceneWidth2];
            this.hSet["_" + sceneHeight] = [0, sceneWidth];
        },


        // Takes an element and adds its coordinates to each of the two sets
        addElement: function addElement(el) {
            var newCoords = this._getGridCoords(el);

            this._addSet(this.vSet, newCoords.vCoords);
            this._addSet(this.hSet, newCoords.hCoords);

            this._addCoordinateToList(this.vList, newCoords.vCoords);
            this._addCoordinateToList(this.hList, newCoords.hCoords);

            this._removeDuplicatesAndSortTheLists();
        },


        /**
         * @param {GuidelineCollection} guidelines
         */
        addGuidelines: function addGuidelines(guidelines) {
            guidelines.each(function (guideline) {
                this._addGuideline(guideline);
            }, this);

            this._removeDuplicatesAndSortTheLists();
        },


        /**
         * @param {GuidelineModel} guideline
         */
        _addGuideline: function _addGuideline(guideline) {
            switch (guideline.get("direction")) {
                case GuidelineModel.HORIZONTAL:
                    {
                        var horizontalCoordinates = [[guideline.get("position"), [0, this.sceneSize.width]]];
                        this._addSet(this.hSet, horizontalCoordinates);
                        this._addCoordinateToList(this.hList, horizontalCoordinates);
                        break;
                    }

                case GuidelineModel.VERTICAL:
                    {
                        var verticalCoordinates = [[guideline.get("position"), [0, this.sceneSize.height]]];
                        this._addSet(this.vSet, verticalCoordinates);
                        this._addCoordinateToList(this.vList, verticalCoordinates);
                        break;
                    }

                default:
                    throw new Error("'" + guideline.get("direction") + "' is not a supported direction.");
            }
        },
        _removeDuplicatesAndSortTheLists: function _removeDuplicatesAndSortTheLists() {
            this.vList = GeneralFunctions.sortNumbers(uniq(this.vList));
            this.hList = GeneralFunctions.sortNumbers(uniq(this.hList));
        },


        // Takes a set and some new coordinates (made with `getGridSet`) and adds them to the set
        _addSet: function _addSet(set, coordinates) {
            coordinates.forEach(function (coordinate) {
                var key = "_" + coordinate[0];
                var val = coordinate[1];
                var coords = union(set[key] || [], val);
                var minCoord = Math.min.apply(Math, _toConsumableArray(coords));
                var maxCoord = Math.max.apply(Math, _toConsumableArray(coords));

                set[key] = uniq([minCoord, maxCoord]);
            });
        },
        _addCoordinateToList: function _addCoordinateToList(list, coordinates) {
            coordinates.forEach(function (coordinate) {
                list.push(coordinate[0]);
            });
        },


        // Gets a set of coordinates to determine to what point to draw a snapline
        // Example: getSet("vertical", 75);
        getSet: function getSet(axis, coordinate) {
            var set = axis === "vertical" ? this.vSet : this.hSet;
            var key = "_" + coordinate;

            return set[key] || null;
        },
        _getSnapCoordinatesFromCornerCoordinates: function _getSnapCoordinatesFromCornerCoordinates(cornerCoordinates) {
            var xs = cornerCoordinates.map(function (cornerCoordinate) {
                return cornerCoordinate.x;
            }); // 4 x-coords for the element
            var ys = cornerCoordinates.map(function (cornerCoordinate) {
                return cornerCoordinate.y;
            }); // 4 y-coords for the element

            // vertical gridlines
            var minX = Math.min.apply(Math, _toConsumableArray(xs)); // left
            var maxX = Math.max.apply(Math, _toConsumableArray(xs)); // right
            var cenX = Math.round((minX + maxX) / 2); // center x

            // horizontal gridlines
            var minY = Math.min.apply(Math, _toConsumableArray(ys)); // top
            var maxY = Math.max.apply(Math, _toConsumableArray(ys)); // bottom
            var cenY = Math.round((minY + maxY) / 2); // center y

            return {
                x: [minX, cenX, maxX],
                y: [minY, cenY, maxY]
            };
        },
        _getRoundedCornerCoordinates: function _getRoundedCornerCoordinates(transformable) {
            var coordinates = transformable.getCornerCoordinates() || [];

            return coordinates.map(GeneralFunctions.mapOverObj(Math.round));
        },


        // + transformable -> {snap coordinates}
        _getSnapCoordinatesFromTransformable: function _getSnapCoordinatesFromTransformable(transformable) {
            return this._getSnapCoordinatesFromCornerCoordinates(this._getRoundedCornerCoordinates(transformable));
        },


        // + element -> {[set], [set]}
        _getGridCoords: function _getGridCoords(el) {
            var cornerCoordinates = SnapUtils.getRoundedCornerCoordinatesFromDom(el);
            var snapCoords = this._getSnapCoordinatesFromCornerCoordinates(cornerCoordinates);

            // vertical Y coordinates
            var minXYs = pluck(where(cornerCoordinates, { x: snapCoords.x[0] }), "y"); // y-coords that touch the left
            var maxXYs = pluck(where(cornerCoordinates, { x: snapCoords.x[2] }), "y"); // y-coords that touch the right
            var cenXYs = [snapCoords.y[1]]; // y-coord for the center

            // horizontal X coordinates
            var minYXs = pluck(where(cornerCoordinates, { y: snapCoords.y[0] }), "x"); // x-coords that touch the top
            var maxYXs = pluck(where(cornerCoordinates, { y: snapCoords.y[2] }), "x"); // x-coords that touch the bottom
            var cenYXs = [snapCoords.x[1]]; // x-coord for the center

            var vCoords = [[snapCoords.x[0], minXYs], [snapCoords.x[1], cenXYs], [snapCoords.x[2], maxXYs]];

            var hCoords = [[snapCoords.y[0], minYXs], [snapCoords.y[1], cenYXs], [snapCoords.y[2], maxYXs]];

            return {
                vCoords: vCoords,
                hCoords: hCoords
            };
        },
        getOffset: function getOffset(transformable) {
            var snapCoords = this._getSnapCoordinatesFromTransformable(transformable);
            var newXCoords = getClosestValueFromOneListInAnother(snapCoords.x, this.vList);
            var newYCoords = getClosestValueFromOneListInAnother(snapCoords.y, this.hList);
            var xOffset = newXCoords.newValue - newXCoords.value;
            var yOffset = newYCoords.newValue - newYCoords.value;
            var result = {};

            if (Math.abs(xOffset) < THRESHOLD) result.x = { offset: xOffset, value: newXCoords.value };
            if (Math.abs(yOffset) < THRESHOLD) result.y = { offset: yOffset, value: newYCoords.value };

            return isEmpty(result) ? false : result;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3015 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (!spectatorMode) { ;
__p += '\n    <div class="vertical-ruler"></div>\n    <div class=\'vertical-ruler-mask\'></div>\n';
 } ;
__p += '\n<div class="scene-area-container">\n    ';
 if (!spectatorMode) { ;
__p += '\n        <div class="horizontal-ruler-mask"></div>\n        <div class="horizontal-ruler"></div>\n    ';
 } ;
__p += '\n    <div class="widgets-boundary ' +
__e( widgetBoundaryClass ) +
'">\n        <div class="scene-loading-region"></div>\n        <div class="master-layer backdrop"></div>\n        <div class="widgets-container">\n            ';
 if (!spectatorMode) { ;
__p += '\n                <div class="container-border no-scale"></div>\n            ';
 } ;
__p += '\n            <div class="snap-container">\n                <div class="snap-replacement"><div></div></div>\n                <span class="snap-line vertical"></span>\n                <span class="snap-line horizontal"></span>\n                <div class="snap-cross"></div>\n            </div>\n            ';
 if (!spectatorMode) { ;
__p += '\n                <div class="guidelines-container"></div>\n            ';
 } ;
__p += '\n            <div class="scene-widget-collection-views-region-container"></div>\n        </div>\n    </div>\n</div>\n<div class="scene-footer">\n    <ul class="navigation">\n        ';
 if (!spectatorMode) { ;
__p += '\n            <li class="move-scene-backwards icon no-scale" title="Move scene backwards">&larr;</li>\n        ';
 } ;
__p += '\n        <li class="scene-index  no-scale"></li>\n        ';
 if (!spectatorMode) { ;
__p += '\n            <li class="move-scene-forwards icon no-scale" title="Move scene forwards">&rarr;</li>\n        ';
 } ;
__p += '\n    </ul>\n    <div class="actions no-scale">\n        ';
 if (!spectatorMode) { ;
__p += '\n            <span class="duplicate-scene icon" title="Duplicate scene"></span>\n            <span class="delete-scene icon" title="Delete scene"></span>\n        ';
 } ;
__p += '\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 3016 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (spectatorMode) { ;
__p += '\n    <div class="spectator-mode-scene-cover"></div>\n';
 } ;
__p += '\n<div class="scenes-region inline">\n    <div class="content-shadow"></div>\n</div>\n';

}
return __p
}

/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        _ = __webpack_require__(1),
        SceneEditor = __webpack_require__(717);

    /**
     * Handlers zooming logic for experiences editor
     */
    return Marionette.Controller.extend({

        // Experiences editor
        _editor: null,

        // editor view model
        _viewModel: null,

        _zoomModel: null,

        _focusPoint: null,

        initialize: function initialize(experiencesEditor) {
            this._editor = experiencesEditor;

            this.listenTo(this._editor, {
                "render": this._onRender
            });
        },

        // On experiencesEditor render event
        _onRender: function _onRender() {
            this._viewModel = this._editor.viewScope.viewModel;

            this._zoomModel = this._viewModel.get("zoomModel");

            this._editor.stickit(this._zoomModel, this.zoomBinding);
            this._updateZoomScale(null, this._zoomModel.get("scale"));

            this.stopListening(this._zoomModel, "change:scale");
            this.listenTo(this._zoomModel, "change:scale", this._updateZoomScale);

            // This custom event is fired from jquery tinyscrollbar, where it normalizes wheeldelta value
            this._editor.ui.scrollTarget.on("scrollToZoom", this._scrollToZoom.bind(this));
        },

        _updateZoomScale: function _updateZoomScale(viewModel, scale) {
            var prevScale = this._zoomModel.previous("scale"),
                scaled = scale === 1 ? "" : "scaled";

            this._editor.ui.scrollTarget.removeClass("scaled scale-" + this._toString(prevScale)).addClass(scaled + " scale-" + this._toString(scale)); // add class so we can apply counter scale no-scale elements
        },

        _toString: function _toString(val) {
            return val.toString().replace(/\./, "");
        },

        updateScrollbar: function updateScrollbar() {
            var prevScale = this._zoomModel.previous("scale"),
                scale = this._zoomModel.get("scale"),
                factor = (prevScale - scale) / prevScale;

            if (this._focusPoint) {
                this._editor.scrollbars.x.scrollTo("offset", this._focusPoint.x * factor, true, false);
                this._editor.scrollbars.y.scrollTo("offset", this._focusPoint.y * factor, true, false);
            }
        },

        // Compute current focusing point. If widgets selected, return the center of the widget,
        // else fallback to scene center, again fallbacks to the viewport center.
        setFocusPoint: function setFocusPoint() {
            var selected = this._viewModel.selection.get("widgets"),
                sceneIndex = this._viewModel.getCurrentSceneIndex(),
                scale = this._zoomModel.get("scale"),
                margin = SceneEditor.SCENE_MARGIN * scale,
                sceneWidth = this._editor.activeExperience.get("width") * scale,
                sceneHeight = this._editor.activeExperience.get("height") * scale,


            // The current scene relative to the scroll target container
            sceneLeft = sceneWidth * sceneIndex + margin * (2 * sceneIndex + 1),
                sceneTop = margin,
                x = 0,
                y = 0;

            if (selected.length === 1) {
                // Focus on widget  TODO: what about multiple selection
                var bounds = selected[0].getBoundingBox();
                x = sceneLeft + (bounds.x + bounds.width / 2) * scale;
                y = sceneTop + (bounds.y + bounds.height / 2) * scale;
            } else if (selected.length > 1) {
                var boundPoints = null,
                    self = this,
                    axisX = [],
                    axisY = [];

                _.each(selected, function (widget) {
                    boundPoints = self.getBounds(widget);
                    axisX.push(boundPoints.left * scale, boundPoints.right * scale);
                    axisY.push(boundPoints.top * scale, boundPoints.bottom * scale);
                });

                x = sceneLeft + _.min(axisX) + (_.max(axisX) - _.min(axisX)) / 2;
                y = sceneTop + _.min(axisY) + (_.max(axisY) - _.min(axisY)) / 2;
            } else {
                // Focus on scene
                x = sceneLeft + sceneWidth / 2;
                y = sceneTop + sceneHeight / 2;
            }

            var ui = this._editor.ui,
                viewportW = ui.viewport.outerWidth(),
                viewportH = ui.viewport.outerHeight(),
                overviewPosition = ui.overview.position(),
                overviewTop = Math.abs(overviewPosition.top),
                overviewLeft = Math.abs(overviewPosition.left);

            // Check if the focusing point(x, y) computed above is within the viewport
            // If not, we fallback to the center of viewpoint
            if (overviewLeft > x || x > overviewLeft + viewportW || overviewTop > y || y > overviewTop + viewportH) {
                // Focus on viewport
                x = overviewLeft + viewportW / 2;
                y = overviewTop + viewportH / 2;
            }

            this._focusPoint = { x: x, y: y };
        },

        getBounds: function getBounds(widget) {
            var bounds = widget.getBoundingBox();

            return {
                left: bounds.x,
                right: bounds.x + bounds.width,
                top: bounds.y,
                bottom: bounds.y + bounds.height
            };
        },

        _scrollToZoom: function _scrollToZoom(e, wheelEvent) {
            var deltaSpeed;

            // Cross browser and OS nonsense
            if (wheelEvent.deltaY !== undefined) {
                deltaSpeed = wheelEvent.deltaY;
                if (deltaSpeed === 0) {
                    deltaSpeed = wheelEvent.deltaX;
                }
            } else if (wheelEvent.wheelDelta !== undefined) {
                deltaSpeed = wheelEvent.wheelDeltaY;
            } else if (wheelEvent.detail) {
                deltaSpeed = wheelEvent.detail;
            }

            this._throttledZoom(deltaSpeed > 0 ? "In" : "Out");
        },

        _throttledZoom: _.throttle(function (direction) {
            this["zoom" + direction]();
        }, 40, { trailing: false })
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3018 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="editor-area-container">\n    <div class="editor-menu row">\n        <div class="scenes-menu">\n            <div class="editor-undo-redo-container">\n                <div class="editor-undo disabled"></div>\n                <div class="editor-redo disabled"></div>\n            </div>\n            <div class="btn-group layer-selector-btn-group">\n                <button type="button" class="btn btn-small btn-default dropdown-toggle change-layer-dropdown btn-clear" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n                    <span class="layers-icon"></span><span class="caret"></span> <span class="layer-label"></span>\n                </button>\n                <ul class="dropdown-menu">\n                    ';
 LayerEnum.each(function(layer) { ;
__p += '\n                        <li><a href="#" class="change-layer" data-layer="' +
__e( layer.value ) +
'"><span class="layer-selected-icon"></span>' +
__e( layer.name ) +
'</a></li>\n                    ';
 }) ;
__p += '\n                </ul>\n            </div>\n            ';
 if (!spectatorMode) { ;
__p += '\n                <div class="switch">\n                    <label>Rulers: <input type="checkbox" class="rulers-switch" data-on-color="success" data-size="mini" data-animate="false"></label>\n                </div>\n                <div class="switch">\n                    <label>Snapping: <input type="checkbox" class="snapping-switch" data-on-color="success" data-size="mini" data-animate="false"></label>\n                </div>\n            ';
 } ;
__p += '\n            <div class="zoom-region"></div>\n            ';
 if (!spectatorMode) { ;
__p += '\n                <button class="add-new-scene btn-clear">+ new scene</button>\n            ';
 } ;
__p += '\n        </div>\n    </div>\n\n    <div class="viewport" data-dragselectable="true">\n        <div class="overview">\n            <div id="experiences-region" data-dragselectable="true" class="scroll-target"></div>\n        </div>\n        <div class="scrollbar vertical" data-axis="y">\n            <div class="track">\n                <div class="bar"></div>\n            </div>\n        </div>\n    </div>\n    <div class="bottom-bar">\n        <div class="scrollbar horizontal" data-axis="x">\n            <div class="track">\n                <div class="bar"></div>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 3019 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zoom-control">\n    <span class="zoom-percent">100%</span>\n    <button class="zoom-out btn-clear" title="Zoom out [-]">&minus;</button>\n    <button class="zoom-in btn-clear" title="Zoom in [+]">+</button>\n    <button class="reset-zoom btn-clear" title="Zoom to 100% [0]">reset</button>\n</div>\n';

}
return __p
}

/***/ }),
/* 3020 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="editor-region"></div>\n<div class="widget-toolbox"></div>\n';

}
return __p
}

/***/ }),
/* 3021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        first = _require.first,
        clone = _require.clone,
        isFunction = _require.isFunction,
        extend = _require.extend;

    var Browser = __webpack_require__(39);
    var template = __webpack_require__(3022);
    var WidgetTypes = __webpack_require__(69);
    var AbstractWidgetPropertiesView = __webpack_require__(63);
    var MultipleSelectionPropertiesView = __webpack_require__(3023);
    var BackdropView = __webpack_require__(3025);
    var Lightbox = __webpack_require__(101);
    var ReactBridge = __webpack_require__(137);
    var WidgetToolboxComponent = __webpack_require__(3027).default;
    var ExperienceSettingsComponent = __webpack_require__(3028).default;
    var WidgetTabOrderContainer = __webpack_require__(3029).default;
    var WidgetLayerOrderContainer = __webpack_require__(3031).default;
    var Keyboard = __webpack_require__(243);
    var LoggedInUserState = __webpack_require__(19);

    var _require2 = __webpack_require__(1239),
        TAB_ORDER_ENABLED = _require2.TAB_ORDER_ENABLED;

    var EditorEventFilters = __webpack_require__(154).default;
    var EditorConstants = __webpack_require__(522);

    var _require3 = __webpack_require__(551),
        mapWidgetMetaData = _require3.mapWidgetMetaData;

    var EXPAND_PROPERTY = "expandToolbox";

    /**
     * The widget toolbox view, displaying widgets that can be dragged onto a scene.
     *
     * @class WidgetToolboxView
     * @constructor
     *
     * @cfg {EditorViewModel} model The editor view model.
     */
    return AbstractWidgetPropertiesView.extend({

        expandProperty: EXPAND_PROPERTY,

        template: template,

        _widgetIcons: [],
        _widgetTypes: [],
        templateHelpers: function templateHelpers() {
            var key = Browser.os.macOS ? "\u2318" : "Ctrl";

            return {
                button: key,
                spectatorMode: this.viewScope.spectatorMode
            };
        },


        events: {
            "dragstart .widget-icon": "_dragStartHandler",
            "click .widget-icon": "_clickHandler"
        },

        ui: {
            toolboxUi: ".widget-toolbox-container"
        },

        regions: {
            widgetPropertyRegion: ".widget-controls",
            toolboxContainer: ".widget-toolbox-container",
            experienceSettingsContainer: ".experience-settings-container",
            behaviorProperties: ".behaviors-properties",
            widgetTabOrderContainer: ".widget-tab-order-container",
            widgetLayerOrderContainer: ".widget-layer-order-container"
        },

        modelEvents: {
            "change:currentLayer": "_renderWidgetIcons"
        },

        initialize: function initialize(options) {
            var _this = this;

            this.__super(options);
            this.listenTo(options.model.selection, "change:widgets", this._widgetSelectHandler);
            this.listenTo(options.model.get("experience"), "change:emailModeEnabled", this._updateWidgetIcons);
            this.listenTo(options.model.get("experience"), "change:emailModeEnabled", this.onShow);
            this.listenTo(Keyboard.Down, Keyboard.KeyCode.ESCAPE, function () {
                _this.viewScope.clearCursorWidgetType();
            });
        },
        onRender: function onRender() {
            this.__super();
            this._widgetTypes = this._getWidgetTypes();
        },
        onShow: function onShow() {
            this._renderWidgetIcons();
            this._renderExperienceSettings();
            this.behaviorProperties.show(this._setBehaviorAction({ model: this.model }));
            this._renderWidgetTabOrder();
            this._renderWidgetLayerOrder();
        },
        _updateWidgetIcons: function _updateWidgetIcons() {
            this._widgetTypes = this._getWidgetTypes();
            this._renderWidgetIcons();
        },
        _dragStartHandler: function _dragStartHandler(event) {
            if (!this.viewScope.spectatorMode) {
                // data-widget-type attribute on both image (target) and link (currentTarget)!
                var data = {
                    defaultActionId: event.target.getAttribute("data-default-action-id"),
                    icon: event.target.getAttribute("data-icon"),
                    type: event.target.getAttribute("data-widget-type")
                };

                var dataTransfer = event.originalEvent.dataTransfer;
                // IE9+ only supports "Text" as the mimetype. We have seen problems in Chromium
                // where this stopped working, renaming mime type to "text/html" fixed it. This
                // will not work in IE, so we need to differentiate if this becomes a problem in
                // Chrome as well. For now we go with Text as it is only Chromium that fails.
                // Update SceneDropHandler as well if you change this.  ataTransfer.setData() has
                // been replaced by dataTransfer.items.add() in Edge:
                // http://www.meetup.com/Copenhagen-Tech-Polyglots/events/230314018/.
                dataTransfer.setData("Text", JSON.stringify(data));

                // This is used to prevent the appearance of url when dragging a widget
                if (dataTransfer.setDragImage) {
                    dataTransfer.setDragImage(event.target, 0, 0);
                }
            } else {
                event.preventDefault();
            }
        },
        _clickHandler: function _clickHandler(event) {
            if (event.currentTarget.dataset.suspended) {
                return false;
            }
            var widgetType = event.currentTarget.dataset.widgetType;
            var icon = event.currentTarget.dataset.icon;
            this.viewScope.setCursorWidgetType(widgetType, icon);
            event.preventDefault();
        },
        _onClickBackdrop: function _onClickBackdrop(event) {
            event.preventDefault();

            if (this.viewScope.spectatorMode || event.currentTarget.dataset.suspended) {
                return;
            }
            var viewModel = this.viewScope.viewModel;

            this._showLightbox({
                view: new BackdropView({
                    model: viewModel.get("experience").get("backdrop"),
                    viewModel: viewModel,
                    integrationsCollection: LoggedInUserState.get("integrations")
                }),
                css: { width: 640 },
                experience: viewModel.get("experience"),
                props: {
                    modalType: "BackdropOptions",
                    triggerOrigin: "BackdropOptionsModal",
                    sceneNumber: viewModel.get("sceneNumber")
                }
            });
        },
        _showLightbox: function _showLightbox(_ref) {
            var view = _ref.view,
                css = _ref.css,
                experience = _ref.experience,
                props = _ref.props;

            var lightboxOptions = {
                win: false,
                css: css,
                editorEventProperties: extend({
                    experienceId: experience.get("id"),
                    experienceVersion: experience.get("version"),
                    experiencePushedVersion: experience.get("pushedVersion")
                }, props)
            };

            new Lightbox(view, lightboxOptions, this).open();
        },


        /**
         * Updates the right sidebar to show corresponding properties editing
         */
        _widgetSelectHandler: function _widgetSelectHandler(selection) {
            var propertyView = this._getPropertyView(selection);

            this._renderExperienceSettings();
            this._renderWidgetTabOrder();
            this._renderWidgetLayerOrder();

            if (propertyView) {
                this.widgetPropertyRegion.show(propertyView);
            } else {
                this.widgetPropertyRegion.reset();
            }
        },


        /**
         * Works with bootstrap's "collapse".
         *
         * @param {JQuery<HTMLElement>} $el Element to collapse
         * @param {String} hide             Can be 'hide' or 'show'.
         */
        _collapse: function _collapse($el, hide) {
            $el.collapse(hide);
        },


        /**
         * Return the widget icon path, e.g. "generic-product" => "widget-icons/generic-product-widget-icon.svg".
         */
        _getWidgetIcon: function _getWidgetIcon(iconId) {
            return "widget-icons/" + iconId + "-widget-icon.svg";
        },


        /**
         * Returns a new ordered array of widget types relevant to users of the current company.
         *
         * @return {WidgetTypes} An array of <tt>WidgetTypes</tt> constants
         */
        _getWidgetTypes: function _getWidgetTypes() {
            var _this2 = this;

            // Start with the list of widgets that declares an ordering and currently enabled.
            var widgetTypes = [];
            var prototypeWidgetCollection = this.options.prototypeWidgetCollection;


            WidgetTypes.each(function (descriptor) {
                if (descriptor.order) {
                    // If defined, call "enabled()" on the type descriptor - a static function is widget types
                    // are by design "visually singletons"...
                    if (!isFunction(descriptor.enabled) || descriptor.enabled()) {
                        if (descriptor.id === "text-enhanced") {
                            var textWidget = WidgetTypes.lookup("text");
                            if (!textWidget.enabled()) {
                                descriptor.icon = textWidget.icon;
                            }
                        }
                        if (isFunction(descriptor.suspend)) {
                            descriptor.suspend(_this2.model);
                        }
                        widgetTypes.push(descriptor);
                    }
                }
            });

            // Sort according to visual order.
            widgetTypes.sort(function (a, b) {
                return a.order - b.order;
            });

            // Add the widgets defined for the current company.
            prototypeWidgetCollection.each(function (prototypeWidget) {
                var ownedWidget = prototypeWidget.get("widget");

                if (ownedWidget.get("visible")) {
                    // TODO: if we persist "order", we can simply add all prototype widgets and do a sort of all
                    //       widgets, for example to fine tune the order of different product widgets!
                    var widgetType = WidgetTypes.lookup(ownedWidget.get("type")); // e.g. "ProductWidget"
                    // Clone the type, so that it's possible to configure multiple widgets of the same type.
                    var widgetTypeClone = clone(widgetType);
                    widgetTypeClone.defaultActionId = ownedWidget.get("defaultActionId");
                    widgetTypeClone.icon = ownedWidget.get("icon");
                    // Currently all owned widgets have a special placeholder icon.
                    widgetTypeClone.tooltip = ownedWidget.get("tooltip");

                    widgetTypes.push(widgetTypeClone);
                }
            });

            return widgetTypes;
        },
        _shouldExpandOnRender: function _shouldExpandOnRender() {
            return true;
        },


        /**
         * @private
         */
        _renderWidgetIcons: function _renderWidgetIcons() {
            this.ui.toolboxUi.empty();

            var toolboxReactComponent = ReactBridge.viewFromComponent(WidgetToolboxComponent, {
                props: {
                    widgetTypes: this._widgetTypes
                }
            });
            this.toolboxContainer.show(toolboxReactComponent);
        },
        _stripHtml: function _stripHtml(html) {
            var tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        },
        onSelectReorder: function onSelectReorder(uuid) {
            this.model.get("experience").set("selectedWidgetId", uuid);
        },
        onCancelReorder: function onCancelReorder(uuid) {
            if (uuid !== this.model.get("experience").get("selectedWidgetId")) {
                // Do not fire cancel event
                // Because it's has been obtained after new widget has been selected
                return;
            }
            this.model.get("experience").set("selectedWidgetId", null);
        },
        onItemRemove: function onItemRemove(id, columnId, index) {
            var activeLayer = this.viewScope.viewModel.get("activeLayerSceneModel");
            var source = void 0;
            var destination = void 0;
            if (columnId === TAB_ORDER_ENABLED) {
                source = "widgetTabOrder";
                destination = "removedWidgetTabOrder";
            } else {
                source = "removedWidgetTabOrder";
                destination = "widgetTabOrder";
            }

            var tabOrderSource = [].concat(_toConsumableArray(activeLayer.get(source)));
            var tabOrderDestination = [].concat(_toConsumableArray(activeLayer.get(destination)));
            var insertIndex = index || tabOrderDestination.length;

            var filteredTabOrderSource = tabOrderSource.filter(function (uuid) {
                return uuid !== id;
            });
            tabOrderDestination.splice(insertIndex, 0, id);

            activeLayer.set(destination, tabOrderDestination);
            activeLayer.set(source, filteredTabOrderSource);

            this.model.get("experience").set("selectedWidgetId", null);
        },
        onEndReorder: function onEndReorder(columnId, oldIndex, newIndex) {
            if (oldIndex !== undefined) {
                var activeLayer = this.viewScope.viewModel.get("activeLayerSceneModel");
                var source = columnId === TAB_ORDER_ENABLED ? "widgetTabOrder" : "removedWidgetTabOrder";

                var newWidgets = activeLayer.get(source + "MetaData");
                var dragWidget = newWidgets.splice(oldIndex, 1)[0];
                newWidgets.splice(newIndex, 0, dragWidget);

                activeLayer.set(source, newWidgets.map(function (widget) {
                    return widget.id;
                }), { cause: EditorEventFilters.SUPERFICIAL });
            }
            this.model.get("experience").set("selectedWidgetId", null);
        },
        _renderExperienceSettings: function _renderExperienceSettings() {
            var _this3 = this;

            var scopedGetProps = function scopedGetProps(_ref2) {
                var model = _ref2.model;

                var backdropModel = model.get("backdrop");
                var groupId = void 0;
                if (model.get("group")) {
                    groupId = model.get("group").resourceId;
                }
                return {
                    experienceId: model.get("id"),
                    isEmailMode: model.get("emailModeEnabled"),
                    groupId: groupId,
                    height: model.get("height"),
                    width: model.get("width"),
                    autoPlayDelay: Math.round(model.get("autoPlayDelay") / 1000),
                    autoPlayTransition: model.get("transition"),
                    language: model.get("language"),
                    widgetSelected: !_this3.viewScope.viewModel.selection.isEmpty(),
                    backdrop: {
                        type: backdropModel.get("type"),
                        color: backdropModel.get("color")
                    },
                    setExperienceHeight: function setExperienceHeight(height) {
                        model.set({ height: Math.max(1, height) }, { render: false });
                    },
                    setExperienceWidth: function setExperienceWidth(width) {
                        model.set({ width: Math.max(1, width) }, { render: false });
                    },
                    setExperienceAutoPlayDelay: function setExperienceAutoPlayDelay(delaySeconds) {
                        model.set({ autoPlayDelay: delaySeconds * 1000 }, { render: false });
                    },
                    setExperienceAutoPlayTransition: function setExperienceAutoPlayTransition(transition) {
                        model.set({ transition: transition }, { render: false });
                    },
                    setLanguage: function setLanguage(language) {
                        model.set({ language: language }, { render: false });
                    }
                };
            };
            var experienceSettingsView = ReactBridge.viewFromComponent(ExperienceSettingsComponent, {
                model: this.model.get("experience"),
                observe: {
                    model: "change:id change:height change:width change:autoPlayDelay change:transition change:language change:backdrop"
                },
                props: {
                    // I'm not sure if this will update if the value changes since we don't observe this model.
                    spectatorMode: this.viewScope.spectatorMode,
                    changeBackdrop: function changeBackdrop(event) {
                        _this3._onClickBackdrop(event);
                    }
                },
                getProps: scopedGetProps
            });

            this.experienceSettingsContainer.show(experienceSettingsView);
        },
        _renderWidgetTabOrder: function _renderWidgetTabOrder() {
            var _this4 = this;

            // Do not render tabOrder, if flag hasn't set
            var isTabOrderEnabled = LoggedInUserState.get("companySettings").get("adaTabOrderEnabled");

            var scopedGetProps = function scopedGetProps(_ref3) {
                var model = _ref3.model;

                var scene = model.get("activeLayerSceneModel");
                var emailModeEnabled = model.get("experience").get("emailModeEnabled");
                return {
                    widgets: isTabOrderEnabled ? scene.get("widgetTabOrderMetaData") : null,
                    removedWidgets: isTabOrderEnabled ? scene.get("removedWidgetTabOrderMetaData") : null,
                    widgetSelected: !_this4.viewScope.viewModel.selection.isEmpty(),
                    orderEnabled: isTabOrderEnabled,
                    selectedId: model.get("experience").get("selectedWidgetId"),
                    emailModeEnabled: emailModeEnabled
                };
            };

            if (isTabOrderEnabled) {
                var widgetTabOrderContainerView = ReactBridge.viewFromComponent(WidgetTabOrderContainer, {
                    // This.model is a EditorViewModel
                    model: this.model,
                    observe: {
                        model: "change:scene change:currentLayer nestedWidgetTabOrderMetaDataChange change:emailModeEnabled"
                    },
                    props: {
                        // I'm not sure if this will update if the value changes since we don't observe this model.
                        spectatorMode: this.viewScope.spectatorMode,
                        onDragEnd: this.onEndReorder.bind(this),
                        onItemRemove: this.onItemRemove.bind(this),
                        onDragStart: this.onSelectReorder.bind(this),
                        onDragCancel: this.onCancelReorder.bind(this)
                    },
                    getProps: scopedGetProps
                });

                this.widgetTabOrderContainer.show(widgetTabOrderContainerView);
            }
        },
        _renderWidgetLayerOrder: function _renderWidgetLayerOrder() {
            var _this5 = this;

            var scopedGetProps = function scopedGetProps(_ref4) {
                var model = _ref4.model;

                var activeLayer = model.get("activeLayerSceneModel");
                var widgets = [].concat(_toConsumableArray(activeLayer.get("widgets").models))
                // When widgets are cloned they don't have a UUID yet.
                .filter(function (widget) {
                    return widget.has("uuid");
                })
                // we must to render widgets' models in the reversed order in order to have
                // widget with the highest z-index at the top of the "Widget Layer Order" list
                .reverse().map(function (widget) {
                    return mapWidgetMetaData({ widget: widget, addActions: true });
                });

                return {
                    selectedId: model.get("experience").get("selectedWidgetId"),
                    widgets: widgets,
                    widgetSelected: !_this5.viewScope.viewModel.selection.isEmpty()
                };
            };

            var widgetLayerOrderContainerView = ReactBridge.viewFromComponent(WidgetLayerOrderContainer, {
                model: this.model,
                observe: {
                    model: "change:scene change:currentLayer nestedWidgetTabOrderMetaDataChange onSelectedWidgetIdChange onLockingChange"
                },
                props: {
                    onDragEnd: this.onLayerOrderDragEnd.bind(this),
                    onDragStart: this.onLayerOrderDragStart.bind(this),
                    onDragCancel: this.onLayerOrderDragCancel.bind(this),
                    onDragRelease: this.onLayerOrderDragRelease.bind(this),
                    onActionClick: this.onActionClick.bind(this),
                    onLayerChanging: this.onLayerChanging.bind(this)
                },
                getProps: scopedGetProps
            });

            this.widgetLayerOrderContainer.show(widgetLayerOrderContainerView);
        },


        // before widget is locked it should be unselected
        removeWidgetFromSelection: function removeWidgetFromSelection(currentWidget) {
            var selection = this.viewScope.viewModel.selection;
            var isInSelection = selection.get("widgets").find(function (widget) {
                return widget.model.get("uuid") === currentWidget.get("uuid");
            });

            currentWidget.set("isSelected", false);

            if (isInSelection) {
                if (selection.get("widgets").length === 1) {
                    selection.clear();
                } else {
                    var selectedWidgets = selection.get("widgets").filter(function (widget) {
                        return widget.model !== currentWidget;
                    });
                    selection.select(selectedWidgets);
                }
            }
        },
        lockWidget: function lockWidget(_ref5) {
            var widget = _ref5.widget,
                lock = _ref5.lock;

            var isLocked = widget.get("isLocked");
            if (!isLocked) {
                this.removeWidgetFromSelection(widget);
            }
            widget.set("isLocked", lock ? true : !isLocked);
        },
        onActionClick: function onActionClick(uuid, actionType) {
            switch (actionType) {
                case "lock":
                    this.onLockLayerShift({ uuid: uuid });
                    break;
                case "hide":
                    this.onLockLayerShift({ uuid: uuid, isHidingAction: true });
                    break;
                default:
            }
        },
        onLockLayerShift: function onLockLayerShift(_ref6) {
            var uuid = _ref6.uuid,
                isHidingAction = _ref6.isHidingAction;

            var activeLayer = this.model.get("activeLayerSceneModel");
            var currentWidget = activeLayer.get("widgets").find(function (widget) {
                return widget.get("uuid") === uuid;
            });

            if (isHidingAction) {
                var isHidden = currentWidget.get("isEditorHidden");
                if (!isHidden) {
                    this.lockWidget({ widget: currentWidget, lock: true });
                }
                currentWidget.set("isEditorHidden", !isHidden);
            } else {
                this.lockWidget({ widget: currentWidget });
            }

            this.model.trigger("onLockingChange");
        },
        onLayerOrderDragStart: function onLayerOrderDragStart(uuid) {
            this.setSelectedWidgetId(uuid);
        },
        onLayerOrderDragRelease: function onLayerOrderDragRelease(uuid) {
            this.addWidgetToSelection(uuid);
        },
        addWidgetToSelection: function addWidgetToSelection(uuid) {
            var scene = this.model.get("activeLayerSceneModel");
            var widgetsModels = scene.get("widgets").models;
            var widget = widgetsModels.find(function (w) {
                return w.get("uuid") === uuid;
            });
            scene.trigger("selectWidgets", [widget], true);

            widget.trigger("forceWidgetUpdate");
        },
        onLayerOrderDragEnd: function onLayerOrderDragEnd(oldIndex, newIndex) {
            if (oldIndex !== newIndex) {
                var scene = this.model.get("activeLayerSceneModel");
                var widgetsModels = scene.get("widgets").models;
                var widgetModel = [].concat(_toConsumableArray(widgetsModels)).reverse()[oldIndex];
                var siblingWidgets = widgetModel.getGroupSiblings(this.viewScope.viewModel.get("scene").get("widgets"));

                scene.orderWidget({
                    widgetModel: widgetModel,
                    to: EditorConstants.BRING_TO_TARGET.value,
                    siblingWidgets: siblingWidgets,
                    // as we render widgets in a reversed order, we have to calculate appropriate new index
                    // in order to maintain correct order of widgets' models
                    newIndex: widgetsModels.length - 1 - newIndex
                });
            }

            this.model.get("experience").set("selectedWidgetId", null);
        },
        onLayerOrderDragCancel: function onLayerOrderDragCancel() {
            this.model.get("experience").set("selectedWidgetId", null);
        },
        onLayerChanging: function onLayerChanging(uuid) {
            this.setSelectedWidgetId(uuid);
            this.addWidgetToSelection(uuid);
        },
        setSelectedWidgetId: function setSelectedWidgetId(uuid) {
            this.model.get("experience").set("selectedWidgetId", uuid);
            this.model.trigger("onSelectedWidgetIdChange");
        },


        /**
         * Get proper view instance for the given selection.
         * For empty selection returns `null`.
         * For selection of multiple widgets returns new instance of `MultipleSelectionPropertiesView`.
         * For the single widget selection returns apropriate ancestor of `AbstractWidgetPropertiesView`.
         *
         * @param {WidgetSelectionViewModel} selection
         * @returns {AbstractWidgetPropertiesView} apropriate widget properties view instance
         */
        _getPropertyView: function _getPropertyView(selection) {
            if (selection.isMultiple()) {
                return new MultipleSelectionPropertiesView({ model: selection });
            }

            if (selection.isSingle()) {
                var widgetView = first(selection.get("widgets"));
                var widgetModel = widgetView.model;
                var widgetDescriptor = WidgetTypes.lookup(widgetModel.get("type"));
                return new widgetDescriptor.propertiesViewClass({
                    model: widgetModel,
                    widgetView: widgetView
                });
            }

            return null;
        }
    }, {
        EXPAND_PROPERTY: EXPAND_PROPERTY
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3022 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="widget-toolbox-container ';
 if (spectatorMode) { ;
__p += ' spectator-mode';
 } ;
__p += '"></div>\n<div class="settings-sidebar">\n    <section class="experience-settings-container" />\n    <section class="behaviors-properties" />\n    <section class="widget-controls" />\n    <section class="widget-tab-order-container" />\n    <section class="widget-layer-order-container" />\n    <section class="widget-order-control" />\n</div>\n';

}
return __p
}

/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractWidgetPropertiesView = __webpack_require__(63);
    var SizeAndPositionPropertiesView = __webpack_require__(70);
    var template = __webpack_require__(3024);

    /**
     * The properties view for a selection of multiple widgets.
     */
    return AbstractWidgetPropertiesView.extend({

        template: template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties"
        },

        onRender: function onRender() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                shouldExpandOnRender: true,
                hideRotation: true,
                hideSizeControls: true
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3024 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="size-and-position-properties"></div>\n';

}
return __p
}

/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backdrop = __webpack_require__(523);
    var ColorPicker = __webpack_require__(208);
    var CompactImageLibraryView = __webpack_require__(552);
    var EditorEvents = __webpack_require__(17);
    var ImageCollection = __webpack_require__(314);
    var ImageLibrarySortingEnum = __webpack_require__(399);
    var ImageLibrarySortingProvider = __webpack_require__(698);
    var ImageLibrarySourceEnum = __webpack_require__(102);
    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(3026);

    /**
     * View for editing the backdrop options.
     *
     * @class BackdropView
     * @constructor
     *
     * @cfg {Backdrop} model The Backdrop model.
     */
    return ImprovedView.extend({

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                isScene7IntegrationAuthorized: this.options.integrationsCollection && this.options.integrationsCollection.isScene7IntegrationAuthorized(),
                isC3Experience: (0, _C3Utils.isC3Experience)()
            };
        },


        className: "backdrop-options",

        regions: {
            imageLibraryRegion: ".backdrop-image-library-region"
        },

        viewScope: function viewScope() {
            return {
                viewModel: this.options.viewModel
            };
        },


        events: {
            "click @ui.cancelButton": "close",
            "click @ui.okButton": "_saveBackdropSettings"
        },

        ui: {
            imageLibrary: ".backdrop-image-library-region",
            colorPicker: ".backdrop-color-picker",
            colorInput: ".color-input",
            colorBox: ".color-box",
            colorLibrary: ".color-library",
            illustrationBox: ".illustration-box",
            okButton: ".ok-btn",
            cancelButton: ".cancel-btn",
            containerBox: ".container-box",
            experienceBox: ".experience-box"
        },

        bindings: {
            ".color-input": {
                observe: "color",
                onGet: function onGet() {
                    var color = this.model.getColor();

                    return color === "transparent" ? "" : color;
                },
                onSet: function onSet(val) {
                    return val || "transparent";
                }
            },
            "input[name=type]": "type",
            "input[name=fit]": "fit"
        },

        modelEvents: {
            "change:type": "_updateTypeView _trackTypeChange",
            "change:fit": "_updateFitView _trackFitChange",
            "change": "_updateIllustration"
        },

        initialize: function initialize() {
            var tempModel = this.model.clone();

            // Save for later uses when users click the OK button
            this.backdropModel = this.model;

            // Hack: assigning experience in order to get the old background color. @see {@link Backdrop#getColor}
            tempModel.experience = this.model.experience;
            this.model = tempModel;
        },


        /**
         * Toggle the imageLibrary and colorPicker depending on the backdrop type
         * Also send an analytics events to the server
         */
        _updateTypeView: function _updateTypeView() {
            var isTypeImage = this.model.isTypeImage();

            this.ui.imageLibrary.toggle(isTypeImage);
            this.ui.colorPicker.toggle(!isTypeImage);
        },
        _trackTypeChange: function _trackTypeChange() {
            var eventProperties = {
                updatedProperty: "type",
                updatedValue: this.model.get("type"),
                experienceId: this.model.experience.get("id"),
                experienceVersion: this.model.experience.get("version"),
                experiencePushedVersion: this.model.get("pushedVersion"),
                triggerOrigin: "BackdropTypeRadioButton"
            };

            EditorEvents.trigger(EditorEvents.constants.UPDATE_BACKDROP, eventProperties);
        },


        /**
         * Toggle the container and experience class depending on the backdrop fit
         * Also send an analytics events to the server
         */
        _updateFitView: function _updateFitView() {
            var isFitContainer = this.model.isFitContainer();

            this.ui.illustrationBox.toggleClass("container", isFitContainer);
            this.ui.illustrationBox.toggleClass("experience", !isFitContainer);
        },
        _trackFitChange: function _trackFitChange() {
            var eventProperties = {
                updatedProperty: "fit",
                updatedValue: this.model.get("fit"),
                experienceId: this.model.experience.get("id"),
                experienceVersion: this.model.experience.get("version"),
                experiencePushedVersion: this.model.get("pushedVersion"),
                triggerOrigin: "BackdropFitRadioButton"
            };

            EditorEvents.trigger(EditorEvents.constants.UPDATE_BACKDROP, eventProperties);
        },


        /**
         * Set the backdrop image when an image is selected in the image library
         *
         * @param {ImageModel} imageModel The selected image, which is an instance of {@link ImageModel}.
         */
        _imageSelectedHandler: function _imageSelectedHandler(imageModel) {
            this.model.set("image", {
                id: imageModel.get("id"),
                url: imageModel.get("url"),
                width: imageModel.get("width"),
                height: imageModel.get("height"),
                supportsResize: imageModel.get("supportsResize")
            });
        },


        /**
         * Update the illustration whenever backdrop fit or type changes. Note it will remove the previous illustration.
         */
        _updateIllustration: function _updateIllustration() {
            var container = this.model.isFitContainer() ? this.ui.containerBox : this.ui.experienceBox;

            // Remove existing backgrounds
            this.ui.containerBox.add(this.ui.experienceBox).css({
                "background-image": "",
                "background-color": ""
            });

            switch (this.model.get("type")) {
                case Backdrop.TYPE.IMAGE:
                    container.css("background-image", "url(" + (this.model.getImageURL() || "") + ")");
                    break;

                case Backdrop.TYPE.COLOR:
                    container.css("background-color", this.model.getColor());
                    break;

                default:
                    break;
            }
        },


        /**
         * Render the backdrop view, set the initial fit and type and initialize the color picker.
         * Also sends an analytic event to the server.
         */
        onRender: function onRender() {
            this._updateFitView();
            this._updateTypeView();
            this._updateIllustration();

            this._backgroundColorPicker = new ColorPicker({
                color: this.model.getColor(),
                input: this.ui.colorInput,
                colorBox: this.ui.colorBox,
                library: this.ui.colorLibrary,
                includeTransparency: true,
                tracking: "colorpicker:box"
            });
        },


        /**
         * Shows the image library and listen on the image selection event. This should not be called onRender
         * because we need to respect the Marionette life cycle of showing view.
         */
        onShow: function onShow() {
            if ((0, _C3Utils.isC3Experience)()) return;
            var viewModel = this.viewScope.viewModel;

            var currentBackdropImage = this.model.get("image");

            /**
             * TODO: Re-use the ImageLibrarySortingProvider from the viewModel
             *
             * Currently new ImageLibrarySortingProvider is used for Backdrop due to MOS-3426
             * When sources are enabled for the backdrop the ImageLibrarySortingProvider
             * should instead be provided using:
             * <pre>
             *   const ImageLibrarySortingProvider = this.viewScope.viewModel.get("imageLibrarySorting");
             * </pre>
             */
            var creatorSorting = ImageLibrarySortingEnum.without(ImageLibrarySortingEnum.MOST_VIEWED);

            if (viewModel.get("imageViewedEventsEnabled")) {
                creatorSorting = ImageLibrarySortingEnum.without(ImageLibrarySortingEnum.ALPHABETICAL);
            }

            var imageLibrarySorting = ImageLibrarySortingProvider.provide({
                sources: [{ source: ImageLibrarySourceEnum.CREATOR, sorting: creatorSorting }]
            });

            var collection = new ImageCollection();
            var imageLibrary = new CompactImageLibraryView({
                collection: collection,
                selectedImageId: currentBackdropImage && currentBackdropImage.id,
                autoSelection: true,
                project: viewModel.get("project"),
                imageLibrarySorting: imageLibrarySorting,
                itemViewOptions: {
                    imageTaggingEnabled: viewModel.get("imageTaggingEnabled"),
                    inventoryEnabled: viewModel.get("inventoryEnabled")
                },
                sortingPanelOptions: {
                    showSources: false
                }
            });

            collection.query(imageLibrarySorting.getSelectedSorting().query);

            this.listenTo(imageLibrary, "image:selected", this._imageSelectedHandler);
            this.imageLibraryRegion.show(imageLibrary);
        },


        /**
         * Save all the backdrop settings for an experience.
         */
        _saveBackdropSettings: function _saveBackdropSettings() {
            this.close();

            var modelType = this.model.get("type");
            var options = {
                type: this.model.get("type"),
                fit: this.model.get("fit")
            };
            var propertyToUnset = void 0;

            switch (modelType) {
                case Backdrop.TYPE.IMAGE:
                    options.image = this.model.get("image");
                    propertyToUnset = "color";
                    break;

                case Backdrop.TYPE.COLOR:
                    options.color = this.model.getColor();
                    propertyToUnset = "image";
                    break;

                default:
                    break;
            }

            this.backdropModel.set(options);

            // Remember to unset the previous selected property. See MOS-2736.
            if (propertyToUnset) {
                this.backdropModel.unset(propertyToUnset, { silent: true });
            }

            var eventProperties = {
                fit: this.model.get("fit"),
                type: this.model.get("type"),
                experienceId: this.model.experience.get("id"),
                experienceVersion: this.model.experience.get("version"),
                experiencePushedVersion: this.model.get("pushedVersion"),
                triggerOrigin: "BackdropOptionsModalOkButton"
            };

            EditorEvents.trigger(EditorEvents.constants.SAVE_BACKDROP, eventProperties);
        },


        /**
         * On close this view, we remove the references to the color picker, so it can be garbage collected.
         */
        onClose: function onClose() {
            if (this._backgroundColorPicker) {
                this._backgroundColorPicker.dispose();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3026 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="backdrop-options-section">\n    <h2>Responsive Backdrop Options</h2>\n    <div class="row">\n        <div class="left-column">\n            <small class="intro">\n                Set the Backdrop image or color for your Experience.<br>\n                To see your Backdrop behavior in context, go to Publish Preview. ';
if (isScene7IntegrationAuthorized) { ;
__p += ' Please note that Scene7 images are not supported at this time. ';
 } ;
__p += '\n            </small>\n\n            <div class="radio">\n                <label><input type="radio" name="fit" value="Experience" class="fit fit-experience">Fit to Experience</label>\n            </div>\n            <div class="radio">\n                <label><input type="radio" name="fit" value="Container" class="fit fit-container">Fit to Container</label>\n            </div>\n\n            <div class="illustration-box">\n                <div class="container-box responsive-backdrop"></div>\n                <div class="experience-box responsive-backdrop"></div>\n                <span class="container-text illustration-text">Container</span>\n                <span class="experience-text illustration-text">Experience</span>\n            </div>\n        </div>\n\n        <div class="right-column">\n            <div class="backdrop-content-radios row">\n                <div class="col-xs-6">\n                    <label><input type="radio" name="type" value="Color" class="background-color" checked>Color</label>\n                </div>\n                <div class="col-xs-6">\n                    ';
if (!isC3Experience) { ;
__p += '\n                        <label><input type="radio" name="type" value="Image" class="background-image">Image</label>\n                    ';
 } ;
__p += '\n                </div>\n            </div>\n\n            <div class="backdrop-color-picker zmags-input-control">\n                <div class="backdrop-options-color-library color-library"></div>\n                <label class="color-library-custom">\n                    Custom Color:\n                    <div class="backdrop-options-color-box color-box"></div>\n                    <input type="text" class="backdrop-options-color-input color-input">\n                </label>\n            </div>\n            <div class="backdrop-image-library-region"></div>\n        </div>\n    </div>\n    <div class="actions">\n        <button class="ok-btn btn btn-primary pull-right ladda-button">OK</button>\n        <button class="cancel-btn btn btn-secondary pull-right">Cancel</button>\n    </div>\n</section>\n';

}
return __p
}

/***/ }),
/* 3027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetToolboxComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WidgetToolboxComponent", function() { return WidgetToolboxComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tippy_js_react__ = __webpack_require__(853);




// noinspection JSUnusedGlobalSymbols
var WidgetToolboxComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](WidgetToolboxComponent, _super);
    function WidgetToolboxComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WidgetToolboxComponent.prototype.render = function () {
        var widgetTypes = this.props.widgetTypes;
        var widgetLinks = widgetTypes.map(function (widgetType) {
            return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__tippy_js_react__["a" /* default */], { key: widgetType.icon, content: widgetType.suspended ? widgetType.suspendedTooltip : widgetType.tooltip, theme: "dark", arrow: true, placement: "bottom", arrowType: "sharp", size: "large" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { className: widgetType.suspended ? "widget-icon disabled" : "widget-icon", draggable: !widgetType.suspended, "data-suspended": widgetType.suspended ? "suspended" : null, "data-default-action-id": widgetType.defaultActionId, "data-icon": widgetType.icon, "data-widget-type": widgetType.id },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "cursor-loading-widget type " + widgetType.icon }))));
        });
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "widget-toolbox-tooltip" }, widgetLinks));
    };
    return WidgetToolboxComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
// noinspection JSUnusedGlobalSymbols



/***/ }),
/* 3028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ExperienceSettingsComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExperienceSettingsComponent", function() { return ExperienceSettingsComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__zmags_zmags_ui_library__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_shared_ui_experience_SceneTransitionTypes__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_shared_ui_common_InputComponent__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PropertyContainerComponent__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_shared_ui_common_SelectComponent__ = __webpack_require__(1179);









var MIN_WIDTH = 1;
var MIN_HEIGHT = 1;
var MIN_AUTOPLAY = 0;
var ONLY_NUMBERS_REGEX = /^\d+$/;
var BackdropType;
(function (BackdropType) {
    BackdropType["Color"] = "Color";
    BackdropType["Image"] = "Image";
})(BackdropType || (BackdropType = {}));
var languages = [
    { label: "Danish", value: "da-DK" },
    { label: "Dutch", value: "nl-NL" },
    { label: "English (US)", value: "en-US" },
    { label: "English (CA)", value: "en-CA" },
    { label: "English (GB)", value: "en-GB" },
    { label: "Finnish", value: "fi-FI" },
    { label: "French", value: "fr-FR" },
    { label: "German", value: "de-DE" },
    { label: "Greek", value: "el-GR" },
    { label: "Italian", value: "it-IT" },
    { label: "Norwegian", value: "no-NO" },
    { label: "Polish", value: "pl-PL" },
    { label: "Portuguese", value: "pt-PT" },
    { label: "Russian", value: "ru-RU" },
    { label: "Spanish", value: "es-ES" },
    { label: "Swedish", value: "sv-SE" },
    { label: "Turkish", value: "tr-TR" },
    { label: "Ukrainian", value: "uk-UA" }
];
// noinspection JSUnusedGlobalSymbols
var ExperienceSettingsComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](ExperienceSettingsComponent, _super);
    function ExperienceSettingsComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.experienceIdInputRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createRef"])();
        _this.groupIdInputRef = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createRef"])();
        _this.updateHeight = function (newHeight) {
            if (_this.validateChange(newHeight, MIN_HEIGHT)) {
                _this.updateModelAndState(_this.props.setExperienceHeight, newHeight, "height");
            }
        };
        _this.updateWidth = function (newWidth) {
            if (_this.validateChange(newWidth, MIN_WIDTH)) {
                _this.updateModelAndState(_this.props.setExperienceWidth, newWidth, "width");
            }
        };
        _this.updateAutoPlayDelay = function (newAutoPlayDelay) {
            if (_this.validateChange(newAutoPlayDelay, MIN_AUTOPLAY)) {
                _this.updateModelAndState(_this.props.setExperienceAutoPlayDelay, newAutoPlayDelay, "autoPlayDelay");
            }
        };
        _this.updateAutoPlayTransition = function (newAutoPlayTransitionOption) {
            if (!_this.props.spectatorMode) {
                _this.updateModelAndState(_this.props.setExperienceAutoPlayTransition, newAutoPlayTransitionOption.value, "autoPlayTransition");
            }
        };
        _this.updateLanguage = function (newLanguageOption) {
            var newLanguage = newLanguageOption.value;
            if (!_this.props.spectatorMode) {
                _this.updateModelAndState(_this.props.setLanguage, newLanguage, "language");
            }
        };
        _this.changeBackdropClicked = function (event) {
            _this.props.changeBackdrop(event);
        };
        _this.handleExperienceIdClick = function () {
            _this.experienceIdInputRef.current.select();
            document.execCommand("copy");
        };
        _this.handleGroupIdClick = function () {
            _this.groupIdInputRef.current.select();
            document.execCommand("copy");
        };
        _this.buildAutoPlayTransitionOptions = function () {
            return Object.keys(__WEBPACK_IMPORTED_MODULE_4_shared_ui_experience_SceneTransitionTypes__["default"]).map(function (key) {
                return { value: __WEBPACK_IMPORTED_MODULE_4_shared_ui_experience_SceneTransitionTypes__["default"][key].value.id, label: __WEBPACK_IMPORTED_MODULE_4_shared_ui_experience_SceneTransitionTypes__["default"][key].value.label };
            });
        };
        _this.state = {
            height: props.height,
            width: props.width,
            autoPlayDelay: props.autoPlayDelay,
            autoPlayTransition: props.autoPlayTransition,
            language: props.language
        };
        return _this;
    }
    ExperienceSettingsComponent.prototype.validateChange = function (newValue, minValue) {
        if (ONLY_NUMBERS_REGEX.test(String(newValue))) {
            return !(newValue < minValue || this.props.spectatorMode);
        }
        return false;
    };
    ExperienceSettingsComponent.prototype.render = function () {
        var _a = this.props, spectatorMode = _a.spectatorMode, widgetSelected = _a.widgetSelected, experienceId = _a.experienceId, groupId = _a.groupId, _b = _a.backdrop, type = _b.type, color = _b.color;
        var _c = this.state, height = _c.height, width = _c.width, autoPlayDelay = _c.autoPlayDelay, autoPlayTransition = _c.autoPlayTransition, language = _c.language;
        var autoplayTransitionOptions = this.buildAutoPlayTransitionOptions();
        var inputsDisabled = !!spectatorMode;
        var isBackdropColorType = BackdropType.Color === type;
        var backdropColorClassName = "";
        if (!isBackdropColorType) {
            backdropColorClassName = "backdrop-visible";
        }
        else if (color === "transparent") {
            backdropColorClassName = "backdrop-transparent";
        }
        var backdropStyle = isBackdropColorType && color !== "transparent"
            ? { background: color }
            : null;
        var clickToCopyPopover = (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["f" /* Popover */], { id: "experience-id-popover" }, "Click to copy."));
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__PropertyContainerComponent__["a" /* PropertyContainerComponent */], { widgetSelected: widgetSelected, label: "Experience Settings", name: "experience-settings", animateExpandOnMount: false },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "experience-settings-property" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__zmags_zmags_ui_library__["NumericInputComponent"], { label: "Width:", units: "px", classNames: "experience-settings-width-input", disabled: inputsDisabled, onChange: this.updateWidth, value: width, debounceDelay: 500 })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "experience-settings-property" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__zmags_zmags_ui_library__["NumericInputComponent"], { label: "Height:", units: "px", classNames: "experience-settings-height-input", disabled: inputsDisabled, onChange: this.updateHeight, value: height, debounceDelay: 500 })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "experience-settings-property" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__zmags_zmags_ui_library__["NumericInputComponent"], { label: "Autoplay:", units: "sec", classNames: "auto-play-delay-input", disabled: inputsDisabled, onChange: this.updateAutoPlayDelay, value: autoPlayDelay })),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "experience-settings-property" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "sub-property" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_shared_ui_common_SelectComponent__["a" /* default */], { classNames: "auto-play-transition form-control", disabled: inputsDisabled, onChange: this.updateAutoPlayTransition, value: autoplayTransitionOptions.find((function (option) { return option.value === autoPlayTransition; })), options: autoplayTransitionOptions }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "experience-settings-property" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", null,
                    "Backdrop:",
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("a", { href: "#", className: "show-backdrop", onClick: this.changeBackdropClicked },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span", { className: "img-container backdrop-container " + backdropColorClassName, style: backdropStyle })))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "experience-settings-property language-property" },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("label", null, "Language:"),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "selectLanguage" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_shared_ui_common_SelectComponent__["a" /* default */], { classNames: "language-select form-control", disabled: inputsDisabled, onChange: this.updateLanguage, value: languages.find((function (lang) { return lang.value === language; })), options: languages }))),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* OverlayTrigger */], { placement: "bottom", overlay: clickToCopyPopover },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "experience-settings-property readonly-copy-property" },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_shared_ui_common_InputComponent__["a" /* default */], { classNames: "text-box experience-copy-text-box", inputElementId: "experience-id-input", disabled: inputsDisabled, onClick: this.handleExperienceIdClick, readOnly: true, type: "text", label: "ID:", units: null, ref: this.experienceIdInputRef, value: experienceId }))),
            groupId &&
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["e" /* OverlayTrigger */], { placement: "bottom", overlay: clickToCopyPopover },
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "experience-settings-property readonly-copy-property" },
                        __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_shared_ui_common_InputComponent__["a" /* default */], { classNames: "text-box experience-copy-text-box", inputElementId: "experience-group-id-input", disabled: inputsDisabled, onClick: this.handleGroupIdClick, readOnly: true, type: "text", label: "Group ID:", units: null, ref: this.groupIdInputRef, value: groupId })))));
    };
    ExperienceSettingsComponent.prototype.updateModelAndState = function (modelSetter, value, fieldName) {
        modelSetter(value);
        var newState = {};
        newState[fieldName] = value;
        this.setState(newState);
    };
    return ExperienceSettingsComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
// noinspection JSUnusedGlobalSymbols



/***/ }),
/* 3029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetTabOrderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WidgetTabOrderContainer", function() { return WidgetTabOrderContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ui_experience_widgets_toolbox_TabOrder_TabOrderComponent__ = __webpack_require__(3030);





// noinspection JSUnusedGlobalSymbols
var WidgetTabOrderContainer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](WidgetTabOrderContainer, _super);
    function WidgetTabOrderContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleCollapse = function () {
            _this.setState({ collapsed: !_this.state.collapsed });
        };
        _this.haveWidgetsChanged = function (widgets, previousWidgets) {
            return widgets.length !== previousWidgets.length ||
                widgets.find(function (widget, index) {
                    // we're assuming the order remains the same. Maybe we should always force an update.
                    var previousWidget = previousWidgets[index];
                    return widget !== previousWidget;
                });
        };
        _this.componentDidUpdate = function (prevProps) {
            var shouldForceUpdate = _this.haveWidgetsChanged(_this.props.widgets, prevProps.widgets) ||
                _this.haveWidgetsChanged(_this.props.removedWidgets, prevProps.removedWidgets);
            if (!!shouldForceUpdate && !_this.state.shouldForceUpdate) {
                _this.setState({ shouldForceUpdate: true });
            }
            else if (prevProps.emailModeEnabled !== _this.props.emailModeEnabled) {
                _this.setState({ shouldForceUpdate: true });
            }
            else if (_this.state.shouldForceUpdate) {
                _this.setState({ shouldForceUpdate: false });
            }
        };
        _this.state = {
            collapsed: props.widgetSelected,
            previousWidgetSelected: props.widgetSelected,
            shouldForceUpdate: false,
        };
        return _this;
    }
    WidgetTabOrderContainer.getDerivedStateFromProps = function (props, state) {
        if (props.widgetSelected !== state.previousWidgetSelected) {
            return { collapsed: props.widgetSelected, previousWidgetSelected: props.widgetSelected };
        }
        return null;
    };
    WidgetTabOrderContainer.prototype.render = function () {
        var _a = this.props, spectatorMode = _a.spectatorMode, widgets = _a.widgets, removedWidgets = _a.removedWidgets, emailModeEnabled = _a.emailModeEnabled, selectedId = _a.selectedId, onDragEnd = _a.onDragEnd, onDragStart = _a.onDragStart, onDragCancel = _a.onDragCancel, orderEnabled = _a.orderEnabled, onItemRemove = _a.onItemRemove;
        var _b = this.state, collapsed = _b.collapsed, shouldForceUpdate = _b.shouldForceUpdate;
        var inputsDisabled = !!spectatorMode;
        var tabOrderEnabled = orderEnabled && !inputsDisabled;
        var collapsedClass = collapsed ? "collapsible collapsed" : "collapsible";
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { className: "experience-settings" },
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("legend", { className: collapsedClass + " " + (emailModeEnabled ? "disabled" : ""), onClick: this.toggleCollapse }, "Widget Tab Order"),
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["c" /* Collapse */], { in: !collapsed && !emailModeEnabled },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", null, !shouldForceUpdate && widgets &&
                    __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_ui_experience_widgets_toolbox_TabOrder_TabOrderComponent__["a" /* default */], { widgets: widgets, removedWidgets: removedWidgets, orderEnabled: tabOrderEnabled, selectedId: selectedId, onDragEnd: onDragEnd, onDragStart: onDragStart, onDragCancel: onDragCancel, onItemRemove: onItemRemove })))));
    };
    return WidgetTabOrderContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));
// noinspection JSUnusedGlobalSymbols



/***/ }),
/* 3030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabOrderComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ui_experience_widgets_toolbox_TabOrder_TabOrderDndTypes__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__zmags_zmags_ui_library__ = __webpack_require__(273);





var dndStyle = {
    padding: "0px",
};
var TabOrderComponent = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](TabOrderComponent, _super);
    function TabOrderComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onDragCancel = function (widgetId) {
            _this.props.onDragCancel(widgetId);
        };
        /**
         * This is onDragEnd handler
         * onDragEnd DragDropContext has been used
         */
        _this.onDragEnd = function (result) {
            var destination = result.destination, source = result.source;
            var isRemoval = !!destination && destination.droppableId !== source.droppableId;
            if (isRemoval) {
                var target = source.droppableId === __WEBPACK_IMPORTED_MODULE_3_ui_experience_widgets_toolbox_TabOrder_TabOrderDndTypes__["TAB_ORDER_ENABLED"] ?
                    _this.props.widgets[source.index] : _this.props.removedWidgets[source.index];
                _this.props.onItemRemove(target.id, source.droppableId, destination.index);
            }
            else if (!destination ||
                (destination.droppableId === source.droppableId
                    && destination.index === source.index)) {
                // Just return empty call if:
                // We have no destination - widget has been dropped outside of component
                // position of widget hasn't changed
                _this.props.onDragEnd();
            }
            else {
                _this.props.onDragEnd(source.droppableId, source.index, destination.index);
            }
        };
        _this.onWidgetRemove = function (widgetId, columnId) {
            _this.props.onItemRemove(widgetId, columnId);
        };
        return _this;
    }
    TabOrderComponent.prototype.render = function () {
        var _a = this.props, orderEnabled = _a.orderEnabled, widgets = _a.widgets, removedWidgets = _a.removedWidgets, selectedId = _a.selectedId, onDragStart = _a.onDragStart;
        return (__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div", { style: dndStyle }, orderEnabled &&
            __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_beautiful_dnd__["a" /* DragDropContext */], { onDragEnd: this.onDragEnd },
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__zmags_zmags_ui_library__["DraggableColumnComponent"], { items: widgets, columnId: __WEBPACK_IMPORTED_MODULE_3_ui_experience_widgets_toolbox_TabOrder_TabOrderDndTypes__["TAB_ORDER_ENABLED"], label: "Tab order", onDragStart: onDragStart, onRemoveItem: this.onWidgetRemove, onDragCancel: this._onDragCancel, selectedId: selectedId, changeIcon: "\u00D7", ignoredOutsideClickClassName: "layer-drag-wrapper" }),
                __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__zmags_zmags_ui_library__["DraggableColumnComponent"], { items: removedWidgets, columnId: __WEBPACK_IMPORTED_MODULE_3_ui_experience_widgets_toolbox_TabOrder_TabOrderDndTypes__["TAB_ORDER_REMOVED"], label: "Removed from tab order", onDragStart: onDragStart, onRemoveItem: this.onWidgetRemove, onDragCancel: this._onDragCancel, selectedId: selectedId, changeIcon: "+", ignoredOutsideClickClassName: "layer-drag-wrapper" }))));
    };
    return TabOrderComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 3031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WidgetLayerOrderContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PropertyContainerComponent__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_beautiful_dnd__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__zmags_zmags_ui_library__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_services_KeyCode__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_shared_services_KeyCode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_shared_services_KeyCode__);







var WidgetLayerOrderContainer = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __extends */](WidgetLayerOrderContainer, _super);
    function WidgetLayerOrderContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            shouldForceUpdate: false,
            touchedId: null
        };
        _this.onDragEnd = function (result) {
            if (!result.destination) {
                _this.props.onDragCancel();
            }
            else {
                _this.props.onDragEnd(result.source.index, result.destination.index);
            }
            _this.setState({ touchedId: result.draggableId });
        };
        _this.onDragCancel = function () {
            _this.props.onDragCancel();
        };
        _this.onDragStart = function (widgetId) {
            if (widgetId !== _this.props.selectedId) {
                _this.props.onDragStart(widgetId);
            }
        };
        _this.haveWidgetsChanged = function (widgets, previousWidgets) {
            return widgets.length !== previousWidgets.length ||
                widgets.find(function (widget, index) {
                    // we're assuming the order remains the same. Maybe we should always force an update.
                    var previousWidget = previousWidgets[index];
                    return !Object(__WEBPACK_IMPORTED_MODULE_4_underscore__["isEqual"])(widget, previousWidget);
                });
        };
        _this.onKeyDown = function (_a) {
            var keyCode = _a.keyCode;
            var _b = _this.props, selectedId = _b.selectedId, widgets = _b.widgets, onLayerChanging = _b.onLayerChanging;
            if (selectedId) {
                var selectedIdIndex = widgets.findIndex(function (widget) { return widget.id === selectedId; });
                if (selectedIdIndex !== -1) {
                    var nextIndex = selectedIdIndex;
                    if (keyCode === __WEBPACK_IMPORTED_MODULE_6_shared_services_KeyCode___default.a.DOWN) {
                        nextIndex = nextIndex + 1 > widgets.length - 1 ? 0 : nextIndex + 1;
                    }
                    if (keyCode === __WEBPACK_IMPORTED_MODULE_6_shared_services_KeyCode___default.a.UP) {
                        nextIndex = nextIndex - 1 < 0 ? widgets.length - 1 : nextIndex - 1;
                    }
                    if (selectedIdIndex !== nextIndex) {
                        onLayerChanging(widgets[nextIndex].id);
                    }
                }
            }
        };
        _this.componentDidUpdate = function (prevProps) {
            var shouldForceUpdate = _this.haveWidgetsChanged(_this.props.widgets, prevProps.widgets);
            var isUpdatedWidget = prevProps.selectedId && prevProps.selectedId !== _this.props.selectedId;
            if ((!!shouldForceUpdate && !_this.state.shouldForceUpdate) || isUpdatedWidget || _this.state.touchedId) {
                _this.setState({ shouldForceUpdate: true, touchedId: null });
            }
            else if (_this.state.shouldForceUpdate) {
                _this.setState({ shouldForceUpdate: false, touchedId: null });
            }
        };
        return _this;
    }
    WidgetLayerOrderContainer.prototype.componentDidMount = function () {
        document.addEventListener("keydown", this.onKeyDown);
    };
    WidgetLayerOrderContainer.prototype.componentWillUnmount = function () {
        document.removeEventListener("keydown", this.onKeyDown, false);
    };
    WidgetLayerOrderContainer.prototype.render = function () {
        var _a = this.props, widgets = _a.widgets, selectedId = _a.selectedId;
        var shouldForceUpdate = this.state.shouldForceUpdate;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__PropertyContainerComponent__["a" /* PropertyContainerComponent */], { widgetSelected: false, label: "Widget Layer Order", name: "experience-settings", animateExpandOnMount: false }, !shouldForceUpdate && widgets.length > 0 && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_beautiful_dnd__["a" /* DragDropContext */], { onDragEnd: this.onDragEnd },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__zmags_zmags_ui_library__["DraggableColumnComponent"], { items: widgets, columnId: "WIDGET_LAYER_ORDER", label: "Widget Layer Order", onDragStart: this.onDragStart, onDragCancel: this.onDragCancel, onDragRelease: this.props.onDragRelease, selectedId: selectedId, touchedId: this.state.touchedId, onActionClick: this.props.onActionClick, draggableWrapperClassName: "layer-drag-wrapper" }))));
    };
    return WidgetLayerOrderContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));



/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var CommentCollection = __webpack_require__(710);
    var ConcatenatedCollection = __webpack_require__(714);
    var EditorEvents = __webpack_require__(17);
    var ExperienceModel = __webpack_require__(58);
    var ImprovedModel = __webpack_require__(25);
    var LayerEnum = __webpack_require__(251);
    var LoggedInUserState = __webpack_require__(19);
    var NotificationBar = __webpack_require__(53);
    var Rectangle = __webpack_require__(248);
    var Storage = __webpack_require__(34);
    var Time = __webpack_require__(121);
    var UserCollection = __webpack_require__(184);
    var ZoomModel = __webpack_require__(1240);
    var WidgetSelectionViewModel = __webpack_require__(3033);

    /**
     * View model for the editor view.
     *
     * <p>The model must be initialized with an experience model. Other properties are optional.</p>
     *
     * @class EditorViewModel
     * @constructor
     */
    return ImprovedModel.extend({

        /**
         * The entity to keep track of widget selections.
         * @see WidgetSelectionViewModel
         */
        selection: null,

        transient: ["isSelectingElements", "isProcessingEmail", "hasOverlappedEmailWidgets"],

        defaults: {
            currentLayer: LayerEnum.SCENE,
            experience: null,
            sceneNumber: 1,
            focusedView: "canvas",
            draggingWidget: false,
            isSelectingElements: false,
            preventSelectionChange: false,

            // Currently we don't need to listen to changes inside this object, so we aren't modelling it as a
            // relational model
            widgetPropertyViewsState: {},

            rulersShown: true,
            scenesNavigatorCollapsed: false,
            snappingEnabled: false,
            showComments: true,
            showMasterLayers: true,

            emailModeEnabled: false,
            isProcessingEmail: false,
            hasOverlappedEmailWidgets: false,

            // Comment-related stuff
            commentsRenderer: null,
            experienceComments: null, // When loaded, map of scene ID to CommentCollection,
            sceneComments: new ConcatenatedCollection(),
            comments: null, // Collection containing all comments
            lastVisit: { visit: 0, sceneVisits: {} },
            zoomModel: new ZoomModel(),

            // In case this model gets passed to the view layer - expose the 'viewportVisibility' (defaults to cover all)
            viewportVisibility: new Rectangle(0, 0, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),

            // The scroll offset on Y axis. This is how much of the content is above the scrollable area.
            contentOffsetY: 0,

            /**
             * Whether image tagging is enabled for the logged in user.
             *
             * @type {Boolean}
             */
            imageTaggingEnabled: false,

            /**
             *
             * When inventory tagged is enabled for the logged in user
             *
             * @type {Boolean}
             */
            inventoryEnabled: false,

            /**
             * @type {Boolean}
             */
            imageViewedEventsEnabled: false,

            /**
             * @type {ImageLibrarySorting}
             * @see ImageLibrarySortingProvider
             */
            imageLibrarySorting: null,

            /**
             * The current `TemplateModel`, if any.
             *
             * @type {TemplateModel}
             */
            templateModel: null
        },

        computed: {
            /**
             * The scene the user is currently on.
             * Note, this always returns the scene model; if the user is the overlay or background layers, this will still return the scene model
             * (See activeLayerSceneModel)
             */
            scene: {
                deps: ["sceneNumber"],
                value: function value(sceneNumber) {
                    return this.get("experience").getSceneBySceneNumber(sceneNumber);
                }
            },
            /**
             * The model for the scene or layer the user is currently on.
             */
            activeLayerSceneModel: {
                deps: ["currentLayer", "scene"],
                value: function value(layer, scene) {
                    switch (layer) {
                        case LayerEnum.OVERLAY:
                            return this.get("experience").get("overlayScene");
                        case LayerEnum.BACKGROUND:
                            return this.get("experience").get("backgroundScene");
                        case LayerEnum.SCENE:
                            return scene;
                        default:
                            throw new Error("unrecognised layer '" + layer.toString() + "'");
                    }
                }
            }
        },

        deleteSelection: function deleteSelection(options) {
            var experience = this.get("experience");
            var project = this.get("project");

            this.selection.get("widgets").forEach(function (_ref) {
                var model = _ref.model;

                // If the model has a subtype that is not empty, it is a subwidget
                if (model.get("subtype")) {
                    // Cannot delete the subwidget - do nothing

                } else {
                    model.destroy();

                    var eventProperties = {
                        projectId: project && project.get("id"),
                        widgetType: model.get("type"),
                        experienceId: experience.get("id"),
                        experienceVersion: experience.get("version"),
                        experiencePushedVersion: experience.get("pushedVersion"),
                        triggerOrigin: options.triggerOrigin
                    };

                    EditorEvents.trigger(EditorEvents.constants.DELETE_WIDGET, eventProperties);
                }
            });

            this.selection.clear();
        },


        // This is the same with computed Scene property
        // The reason we need this is to avoid that when sceneNumber changes, both isBackgroundScene and Scene
        // properties will be recomputed in order. But any listeners on isBackgroundScene will not be able to
        // get correct scene as the scene is not computed at that point.
        getCurrentScene: function getCurrentScene() {
            return this.get("experience").getSceneBySceneNumber(this.get("sceneNumber"));
        },
        getCurrentSceneIndex: function getCurrentSceneIndex() {
            return this.getCurrentScene().getSceneIndex();
        },
        isOnBackgroundLayer: function isOnBackgroundLayer() {
            return this.get("currentLayer") === LayerEnum.BACKGROUND;
        },
        isOnOverlayLayer: function isOnOverlayLayer() {
            return this.get("currentLayer") === LayerEnum.OVERLAY;
        },
        isOnSceneLayer: function isOnSceneLayer() {
            return this.get("currentLayer") === LayerEnum.SCENE;
        },


        /**
         * Sets the scene number, triggering a change event even if the scene number hasn't changed. This is useful when
         * the scene referenced by the scene number has changed without the scene number itself changing (via an added
         * or removed scene), which conceptually should be treated as a scene number change by our listeners.
         *
         * @param {String|Number} sceneNumber The new scene number.
         * @private
         */
        _forceSetSceneNumber: function _forceSetSceneNumber(sceneNumber) {
            if (this.get("sceneNumber") !== sceneNumber) {
                this.set("sceneNumber", sceneNumber);
            } else {
                this.trigger("change:sceneNumber", this, sceneNumber, {});
            }
        },
        _sceneChangeHandler: function _sceneChangeHandler() {
            // Register scene visit
            LoggedInUserState.registerSceneVisit(this.get("experience").get("id"), this.get("scene").get("id"));
        },
        _commentRead: function _commentRead(comment) {
            if (comment.get("unread") > 0) {
                // Update counters
                this.get("experience").set("unread", this.get("experience").get("unread") - comment.get("unread"), { computedProperty: true });
                this.get("scene").set("unread", this.get("scene").get("unread") - comment.get("unread"), { computedProperty: true });
                comment.set("unread", 0, { computedProperty: true });

                // Update comment flags
                comment.set("isUnread", false, { computedProperty: true });
                comment.get("replies").each(function (reply) {
                    reply.set("isUnread", false, { computedProperty: true });
                });
            }
        },
        _fetchLastCommentedAt: function _fetchLastCommentedAt(sceneId) {
            var _this = this;

            // Currently the backend can't ignore the value of lastCommentedAt we send when saving an experience
            // As a result, we need to ensure we keep the values in sync on comment post and delete
            var experience = new ExperienceModel({ id: this.get("experience").get("id") });
            experience.fetch().done(function () {
                _this.get("experience").set("lastCommentedAt", experience.get("lastCommentedAt"), { triggeredByServerUpdate: true });
                _this.get("experience").getSceneById(sceneId).set("lastCommentedAt", experience.getSceneById(sceneId).get("lastCommentedAt"), { triggeredByServerUpdate: true });
            });
        },
        _updateWidgetTabOrder: function _updateWidgetTabOrder(experience) {
            var overlay = experience.get("overlayScene");
            var backgroundScene = experience.get("backgroundScene");
            var scenes = experience.get("scenes");

            var secondaryLayers = [overlay, backgroundScene];
            var fieldsToFix = ["widgetTabOrder", "removedWidgetTabOrder"];

            // we need to check each scene and move data to the rest layers if it is needed
            scenes.forEach(function (scene) {
                fieldsToFix.forEach(function (field) {
                    scene.get(field)
                    // filter scene's widgets in order to find widgets which don't belong to scene
                    .filter(function (widgetUUID) {
                        return !scene.get("widgets").find(function (widget) {
                            return widget.get("uuid") === widgetUUID;
                        });
                    }).forEach(function (widgetUUID) {
                        // looking for the layer to which the widget belongs
                        secondaryLayers.forEach(function (layer) {
                            var appropriateWidget = layer.get("widgets").find(function (widget) {
                                return widget.get("uuid") === widgetUUID;
                            });
                            /* when appropriateWidget is found in another layer,
                               appropriateWidget's data must be moved to the correct layer */
                            if (appropriateWidget) {
                                // delete item from scene's field
                                var sceneOrderData = [].concat(_toConsumableArray(scene.get(field))).filter(function (tabOrderId) {
                                    return tabOrderId !== widgetUUID;
                                });
                                // add item to correct layer's field
                                var layerOrderData = [].concat(_toConsumableArray(layer.get(field)));

                                // check if current layer doesn't contain widgetUUID, because each scene can contain the same data
                                if (!layerOrderData.includes(widgetUUID)) {
                                    layerOrderData.push(widgetUUID);
                                }

                                scene.set(field, sceneOrderData);
                                layer.set(field, layerOrderData);
                            }
                        });
                    });
                });
            });
        },


        // TODO: We need to break down this giant method, hard to read.
        initialize: function initialize() {
            var experience = this.get("experience");
            var scene = this.get("scene");
            var experienceId = experience.get("id");

            // Experience and valid scene is required
            if (!experience || typeof scene === "undefined") {
                NotificationBar.error("A valid experience id and scene number is required.", { raise: true });
            }

            // Fix "widgetTabOrder" and "removedWidgetTabOrder" data for layers
            this._updateWidgetTabOrder(experience);

            // When a scene is added, switch to it
            this.listenTo(experience, "add:scenes", function (scene) {
                this._forceSetSceneNumber(scene.get("sceneNumber"));
            });

            // When a scene is removed, ensure the scene number is valid and events are triggered
            this.listenTo(experience, "remove:scenes", function (scene) {
                var deletedSceneNumber = parseInt(scene.get("sceneNumber"), 10);
                var currentSceneNumber = parseInt(this.get("sceneNumber"), 10);

                // If the removed scene is after the current scene, we don't have to do anything
                // If the removed scene is the current scene, it depends on whether it was the last scene
                // If the removed scene is before the current scene, we decrement the scene number to preserve the current scene
                if (deletedSceneNumber === currentSceneNumber) {
                    this._forceSetSceneNumber(Math.max(1, Math.min(experience.get("scenes").length, deletedSceneNumber)));
                } else if (deletedSceneNumber < currentSceneNumber) {
                    this.set("sceneNumber", this.get("sceneNumber") - 1);
                }
            });

            // Update current scene number if needed, when scenes are swapped/moved
            this.listenTo(experience, "scenes:swapped", function (options) {
                var currentSceneNumber = this.get("sceneNumber");

                if (options.a.fromSceneNumber === currentSceneNumber) {
                    this.set("sceneNumber", options.a.toSceneNumber);
                }

                if (options.b.fromSceneNumber === currentSceneNumber) {
                    this.set("sceneNumber", options.b.toSceneNumber);
                }
            });

            // Fetch the last visit hash for this experience, before starting to register this session's views
            var lastVisit = LoggedInUserState.getLastExperienceVisit(experienceId);
            this.set("lastVisit", lastVisit);

            // Log initial experience and scene views
            LoggedInUserState.registerExperienceVisit(experienceId);
            LoggedInUserState.registerSceneVisit(experienceId, scene.get("id"));

            // Register the scene change handler and invoke it now
            this.listenTo(this, "change:scene", this._sceneChangeHandler);
            this._sceneChangeHandler();

            this.selection = new WidgetSelectionViewModel(null, { editorViewModel: this });

            // If there are comments on the experience, fetch the user collection since we will need it for colors
            // Also disable the comments layer, it will be enabled again if there are unread comments
            if (experience.get("lastCommentedAt")) {
                LoggedInUserState.fetchGlobalCollection(UserCollection);
                // Lookup "show comments" state
                this.set("showComments", Storage.Local.get(Storage.Keys.COMMENTS, "showComments", false));
            }

            // Initialize comments and parse to collections and models
            var experienceCommentsJSON = this.get("experienceCommentsJSON");
            var collection = new CommentCollection();
            var sceneIDs = [];

            // Store comments
            this.set("comments", collection, { silent: true });

            _.each(experienceCommentsJSON, function (sceneCommentsJSON, sceneID) {
                collection.add(sceneCommentsJSON, { parse: true, sceneID: sceneID });
                sceneIDs.push(sceneID);
            });

            // Loop through all comments to compute the initial number of unread comments per experience, scene, and thread
            var experienceUnread = 0;

            _.each(sceneIDs, function (sceneID) {
                var sceneComments = collection.getCommentsForScene(sceneID);
                var lastSceneVisit = lastVisit.sceneVisits[sceneID] || 0;
                var sceneUnread = 0;

                _.each(sceneComments, function (sceneComment) {
                    var unreadComments = sceneComment.getUnreadComments(lastSceneVisit);
                    sceneComment.set("unread", unreadComments, { computedProperty: true });
                    sceneUnread += unreadComments;
                    experienceUnread += unreadComments;
                });

                var foundScene = experience.getSceneById(sceneID);

                if (foundScene) {
                    foundScene.set("unread", sceneUnread, { computedProperty: true });
                }
            });

            experience.set("unread", experienceUnread, { computedProperty: true });

            // Set unread on all remaining scenes to 0
            var setDefaultUnread = function setDefaultUnread(scene) {
                if (!scene.get("unread")) {
                    scene.set("unread", 0, { computedProperty: true });
                }
            };

            experience.get("scenes").each(setDefaultUnread);

            setDefaultUnread(experience.get("overlayScene"));
            setDefaultUnread(experience.get("backgroundScene"));

            // Mark scene comments as read when the scene changes with the comment layer active
            this.listenTo(this, "change:scene", function () {
                if (!this.get("showComments")) {
                    return;
                }

                var previousScene = this.previous("scene");

                if (previousScene) {
                    this.markSceneCommentsRead(previousScene);
                }
            });

            // Mark scene comments as read when the comment layer is deactivated
            this.listenTo(this, "change:showComments", function () {
                if (this.get("showComments") === false && this.previous("showComments") === true) {
                    this.markSceneCommentsRead(this.get("scene"));
                }
            });

            // TODO: Consider creating a class for dealing with "last used properties" (EditorState) ?

            var scale = Storage.Local.get(Storage.Keys.EDITOR, experienceId + "-scaleFactor", 1.0);
            this.get("zoomModel").set("scale", scale, { silent: true });

            // Keep track of last used scene size
            this.listenTo(experience, "change:width change:height", function () {
                Storage.Local.update(Storage.Keys.EDITOR, "experienceSize", {
                    width: experience.get("width"),
                    height: experience.get("height")
                });
            });

            // Keep track of rulers shown setting.
            this.set("rulersShown", Storage.Local.get(Storage.Keys.RULERS_SHOWN, "rulersShown", true));

            this.listenTo(this, "change:rulersShown", function (model, value) {
                Storage.Local.update(Storage.Keys.RULERS_SHOWN, { rulersShown: value });
            });

            // Keep track of Master Layer setting
            this.set("showMasterLayers", Storage.Local.get(Storage.Keys.MASTER_LAYERS, "showMasterLayers", true));

            this.listenTo(this, "change:showMasterLayers", function (model, value) {
                Storage.Local.update(Storage.Keys.MASTER_LAYERS, { showMasterLayers: value });
            });

            // Keep track of snapping enabled setting.
            this.set("snappingEnabled", Storage.Local.get(Storage.Keys.SNAPPING_ENABLED, "snappingEnabled", false));

            this.listenTo(this, "change:snappingEnabled", function (model, value) {
                Storage.Local.update(Storage.Keys.SNAPPING_ENABLED, { snappingEnabled: value });
            });

            // Store "show comments" state locally
            this.listenTo(this, "change:showComments", function (model, value) {
                Storage.Local.update(Storage.Keys.COMMENTS, { showComments: value });
            });
        },


        /**
         * @private
         *
         * Registers/adds a new comment. At this point we expect that the passed scene has
         * been saved and contains an ID.
         *
         * @param  {Comment} comment    The comment to add.
         * @param  {Scene} scene        The scene model associated with the comment.
         */
        _registerNewComment: function _registerNewComment(comment, scene) {
            var currentSceneID = scene.get("id");

            // Ensure the comments layer is active
            this.set("showComments", true);

            // New comments need a reference to the experience and scene in order to save them
            comment.experience = this.get("experience").get("id");
            comment.sceneID = currentSceneID;
            // For backward compatibility
            comment.scene = currentSceneID;

            this.get("comments").add(comment);
        },


        /**
         * Adds a comment for the current scene.
         *
         * @param {Comment} comment The new comment to add.
         */
        addComment: function addComment(comment) {
            var _this2 = this;

            var scene = this.get("scene");

            if (scene.has("id")) {
                this._registerNewComment(comment, scene);
            } else {
                // The scene might not have been saved yet, wait for the ID to arrive.
                this.listenToOnce(scene, "change:id", function () {
                    _this2._registerNewComment(comment, scene);
                });
            }
        },
        getCurrentComments: function getCurrentComments() {
            var currentSceneID = this.get("scene").get("id");

            return this.get("comments").getCommentsForScene(currentSceneID);
        },


        /**
         * Invoked when a comment is posted.
         *
         * @param {Comment} comment The root comment.
         * @param {Promise} promise The promise for the comment save.
         */
        commentPosted: function commentPosted(comment, promise) {
            var now = Time.server();
            // Adjust unread state
            this._commentRead(comment);

            // Stamp the last commented at
            this.get("scene").set("lastCommentedAt", now, { triggeredByServerUpdate: true });
            this.get("experience").set("lastCommentedAt", now, { triggeredByServerUpdate: true });

            // Load the server's updated lastCommentedAt values when the promise is done
            promise.done(this._fetchLastCommentedAt.bind(this, this.get("scene").get("id")));

            // Record a visit to the scene.
            // This is a bit unfortunate, since it means that new comments posted by others after the experience was
            // opened will not be flagged. But this is better than flagging the user's own comments as new, and we
            // don't support concurrent editing right now anyway.
            // We add an offset to the timestamp, since the server will stamp a slightly later time.
            LoggedInUserState.registerExperienceVisit(this.get("experience").get("id"), 5000);
            LoggedInUserState.registerSceneVisit(this.get("experience").get("id"), this.get("scene").get("id"));

            this.get("lastVisit").visit = now + 5000;
            this.get("lastVisit").sceneVisits[this.get("scene").get("id")] = this.get("lastVisit").visit;
        },


        /**
         * Marks the comments on the given scene as read.
         * @param {Scene} scene The scene.
         */
        markSceneCommentsRead: function markSceneCommentsRead(scene) {
            if (scene.get("unread") > 0) {
                // Update counters
                this.get("experience").set("unread", this.get("experience").get("unread") - scene.get("unread"), { computedProperty: true });
                scene.set("unread", 0, { computedProperty: true });

                // Update comment counters and flags
                this.get("comments").each(function (comment) {
                    if (comment.get("unread") > 0) {
                        comment.set("unread", 0, { computedProperty: true });

                        comment.set("isUnread", false, { computedProperty: true });
                        comment.get("replies").each(function (reply) {
                            reply.set("isUnread", false, { computedProperty: true });
                        });
                    }
                });
            }
        },


        /**
         * Invoked when a comment is deleted.
         * @param {Comment} comment The comment that has been deleted.
         * @param {Promise} promise The promise for the comment deletion.
         */
        commentDeleted: function commentDeleted(comment, promise) {
            // Ensure the unread counter is adjusted
            this._commentRead(comment);

            // Load the server's updated lastCommentedAt values when the promise is done
            promise.done(this._fetchLastCommentedAt.bind(this, this.get("scene").get("id")));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var AbstractWidgetModel = __webpack_require__(62);
    var WidgetTypes = __webpack_require__(69);

    var _require = __webpack_require__(1),
        defaults = _require.defaults,
        pluck = _require.pluck;

    /**
     * The model for keeping track of widget selection in The Editor.
     *
     * Consumers of this class should prefer specific methods,
     * e.g. `.select(widgets)` or `.clear()`, rather than calling `.set("widgets", ...)`.
     *
     * @author Yaroslav <@yil>
     * @class WidgetSelectionViewModel
     */


    return AbstractWidgetModel.extend({
        _editorViewModel: null,

        defaults: defaults({
            widgets: [] // Array of widget views
        }, AbstractWidgetModel.prototype.defaults),

        computed: {
            models: {
                deps: ["widgets"],
                value: function value(widgets) {
                    if (widgets && !widgets.every(function (element) {
                        return typeof element === "undefined";
                    })) {
                        return pluck(widgets, "model");
                    }
                    return null;
                }
            }
        },

        isEmpty: function isEmpty() {
            return this.get("widgets").length === 0;
        },
        isSingle: function isSingle() {
            return this.get("widgets").length === 1;
        },
        isMultiple: function isMultiple() {
            return this.get("widgets").length > 1;
        },
        clear: function clear() {
            this.set("widgets", []);
        },
        select: function select(widgets) {
            this.set("widgets", widgets);
        },
        append: function append(selectedWidgets) {
            this.set("widgets", this.get("widgets").concat(selectedWidgets));
            if (selectedWidgets.length === 1) {
                selectedWidgets[0].model.set("isSelected", true);
            }
        },
        remove: function remove(widget) {
            this.set("widgets", this.get("widgets").filter(function (selectedWidget) {
                return selectedWidget !== widget;
            }));
        },
        initialize: function initialize(attrs, options) {
            this.__super(attrs, options);
            this._editorViewModel = options.editorViewModel;
            this.listenTo(this, "change:widgets", this._onNewWidgetsSelected);
            this.listenTo(this, "change:left change:top", this._onLeftOrTopChanged);
        },


        /**
         * Updates positions of containing widgets effectively moving all containing widgets
         * simultaneously by given `amount` (in absolute values) on give axis (either 'x' or 'y').
         *
         * @param {'x'|'y'} axis to update
         * @param {Number} amount in absolute values (pixels)
         */
        moveBy: function moveBy(axis, amount) {
            this.get("widgets").forEach(function (_ref) {
                var model = _ref.model,
                    viewModel = _ref.viewModel;

                var experience = viewModel.get("experience");
                var bounds = {
                    x: model.get("left"),
                    y: model.get("top")
                };
                var side = axis === "x" ? "left" : "top";
                var offset = experience.getPercentagePosition(_defineProperty({}, side, Math.abs(amount)));

                bounds[axis] += Math.sign(amount) * offset[side];

                model.set({
                    left: bounds.x,
                    top: bounds.y
                }, { render: true });
            });
        },
        _onNewWidgetsSelected: function _onNewWidgetsSelected() {
            var _this = this;

            this.previous("widgets").forEach(function (_ref2) {
                var model = _ref2.model;
                return _this.stopListening(model);
            });
            this.get("widgets").forEach(function (_ref3) {
                var model = _ref3.model;
                return _this.listenTo(model, "change:left change:top", _this._recalcCoords);
            });

            this._recalcCoords();
        },


        /**
         * Listener for `left` and `top` attributes changes (of this model).
         * Calculates offset with the previous value and moves all the containing widgets (if any) by that difference.
         * @param {WidgetSelectionViewModel} model this model
         * @param {Number} value new value for either `left` or `top`
         * @param {any} options any changes supplied to the `.set()` upon changin the value
         */
        _onLeftOrTopChanged: function _onLeftOrTopChanged(model, value, _ref4) {
            var stickitChange = _ref4.stickitChange;

            if (!stickitChange) {
                // ensure this method processes only updates from view, and not from itself
                return;
            }

            var side = stickitChange.observe;
            var diff = this.get(side) - this.previous(side);
            this.get("widgets").forEach(function (_ref5) {
                var model = _ref5.model;
                return model.set(side, model.get(side) + diff);
            });
        },
        _recalcCoords: function _recalcCoords() {
            if (this.isEmpty()) {
                this.set({ left: 0, top: 0 });
            } else {
                this.set({
                    left: this._getLeftmostCoord(),
                    top: this._getTopmostCoord()
                });
            }
        },


        // These two methods need to be adjusted for the case where we've selected
        // a subwidget in a dynamic product widget. Leftmost and topmost coordinate need
        // to add the left/top of the parent widget instead of the subwidget.
        _getLeftmostCoord: function _getLeftmostCoord() {
            return Math.min.apply(Math, _toConsumableArray(this.get("widgets").map(function (widget) {
                if (widget.parentView.model && widget.parentView.model.get("type") === WidgetTypes.DYNAMIC_PRODUCT.id) {
                    return widget.model.get("left") + widget.parentView.model.get("left");
                }
                return widget.model.get("left");
            })));
        },
        _getTopmostCoord: function _getTopmostCoord() {
            return Math.min.apply(Math, _toConsumableArray(this.get("widgets").map(function (widget) {
                if (widget.parentView.model && widget.parentView.model.get("type") === WidgetTypes.DYNAMIC_PRODUCT.id) {
                    return widget.model.get("top") + widget.parentView.model.get("top");
                }
                return widget.model.get("top");
            })));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _C3Utils = __webpack_require__(83);

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var Marionette = __webpack_require__(10);
    var _ = __webpack_require__(1);
    var EditorControllerMixin = __webpack_require__(1217);
    var ExperiencePreview = __webpack_require__(3035);
    var LayerEnum = __webpack_require__(251);
    var PreviewNavBarView = __webpack_require__(1241);
    var PreviewTemplateNavBarView = __webpack_require__(3040);
    var GroupCollection = __webpack_require__(719);
    var TemplateViewModel = __webpack_require__(3042);
    var ExperienceViewModel = __webpack_require__(343);
    var ExperienceURLProvider = __webpack_require__(168);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var ZoomModel = __webpack_require__(1240);

    var logger = new Logger("EditorPreviewController");

    /**
     * Controller for the editor.
     *
     * @author Bo Gotthardt
     * @class EditorController
     * @constructor
     *
     * @cfg {Region} region The main view region, where the editor view should be rendered.
     */
    return Marionette.Controller.extend({

        mixin: [EditorControllerMixin],

        _preview: function _preview() {
            var variants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var experience = arguments[1];
            var options = arguments[2];
            var self = arguments[3];
            var id = arguments[4];
            var layerName = arguments[5];
            var scene = arguments[6];
            var type = arguments[7];

            var isTemplate = type === ExperienceURLProvider.TYPES.TEMPLATE;

            var viewModel = void 0;
            if (isTemplate) {
                viewModel = new TemplateViewModel({
                    // TODO: Would it be OK for the VIEW model to get a cloned experience with an ID?
                    experience: experience.clone(),
                    // The ID is not cloned
                    editorCurrentLayer: LayerEnum.lookup(layerName, LayerEnum.SCENE),
                    templateId: id
                });
            } else {
                viewModel = new ExperienceViewModel({
                    // TODO: Would it be OK for the VIEW model to get a cloned experience with an ID?
                    experience: experience.clone(),
                    // The ID is not cloned
                    experienceId: experience.id,
                    editorCurrentLayer: LayerEnum.lookup(layerName, LayerEnum.SCENE)
                });
            }

            if (scene) {
                viewModel.set("currentScene", scene);
            }

            self.listenTo(viewModel, "change:currentScene", function () {
                var experienceURL = ExperienceURLProvider.provide(id, ExperienceURLProvider.ACTION.PREVIEW, viewModel.get("currentScene"), undefined, type);
                Backbone.history.navigate(experienceURL, { replace: true });
            });

            var zoomModel = new ZoomModel();

            var showViewer = function showViewer() {
                options.region.show(new ExperiencePreview({
                    experienceViewModel: viewModel,
                    zoomModel: zoomModel
                }));
            };

            // Display the viewer only once the previous view has closed
            if (options.region.isClosed()) {
                showViewer();
            } else {
                options.region.once("close", showViewer);
                options.region.close();
            }

            var navBarView = type === ExperienceURLProvider.TYPES.EXPERIENCE ? PreviewNavBarView : PreviewTemplateNavBarView;

            options.navBarRegion.show(new navBarView({
                model: viewModel,
                zoomModel: zoomModel,
                variants: variants
            }));
        },

        previewTemplate: function previewTemplate(id, scene, layerName) {
            var options = this.options;
            var self = this;

            this._fetchTemplateExperienceAndFonts(id).then(function (model) {
                self._preview(undefined, model, options, self, id, layerName, scene, ExperienceURLProvider.TYPES.TEMPLATE);
            }).fail(function (msg) {
                logger.warn(msg);
                Backbone.history.navigate("", true);
            });
        },

        /**
         * Editor preview an existing experience with the specified ID.
         *
         * @param {String} id The id of the experience to preview.
         * @param {Number} [scene] The optional start scene, defaults to 1.
         * @param layerName
         */
        previewExperience: function previewExperience(id, scene, layerName) {
            var self = this;
            var options = this.options;
            var experience = void 0;

            this._fetchExperienceAndFonts(id).then(function (model) {
                experience = model;

                return self._fetchVariantDescriptors(experience);
            }).then(function (variants) {
                self._preview(variants, experience, options, self, id, layerName, scene, ExperienceURLProvider.TYPES.EXPERIENCE);
            }).fail(function (msg) {
                logger.warn(msg);
                Backbone.history.navigate("", true);
            });
        },

        /**
         * If the specified experience is part of a group, fetch that group and create an array
         * of objects describing those experiences.
         *
         * @param  {ExperienceModel} experience The current experience model.
         * @return {Promise}                    A promise that resolves with an array of descriptors
         *                                       for the <tt>PreviewNavBarView</tt>.
         *
         * @see  PreviewNavBarView
         */
        _fetchVariantDescriptors: function _fetchVariantDescriptors(experience) {
            return GroupCollection.byAssetId(experience.get("id")).then(function (groups) {
                var newDashboardExperience = (0, _C3Utils.isC3Experience)();
                // PE-1216: New C3-API doesn't have endpoints for groups, hence we define the group as undefined instead of fetching it
                var group = newDashboardExperience ? undefined : groups.findByAssetId(experience.get("id"));
                var variants = [];
                var descriptor = function descriptor(entry) {
                    var id = entry[0].get("id");

                    return {
                        groupType: group.getDashedType(),
                        identifier: entry[1] ? entry[1].getIdentifier() : "",
                        id: id,
                        url: "#experience/" + id + "/preview/1"
                    };
                };

                if (group) {
                    variants = _.map(group.getUniqueEntries(), descriptor);
                }

                return variants;
            });
        }
    }, {
        injection: {
            parameters: ["errorLogger"],
            asOptions: true
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10),
        Browser = __webpack_require__(39),
        PreviewExperienceViewer = __webpack_require__(3036),
        NotificationBar = __webpack_require__(53),
        ExperienceCncViewer = __webpack_require__(1212),
        LoggedInUserState = __webpack_require__(19),
        template = __webpack_require__(3038);

    /**
     * Experience preview page.
     *
     * <p>Shows an experience viewer centered on the screen.</p>
     *
     * @author Bruce Mackenzie Nielsen
     * @class ExperiencePreview
     * @constructor
     *
     * @cfg {ExperienceViewModel|TemplateViewModel} experienceViewModel or templateViewModel model to show.
     */
    return Marionette.Layout.extend({

        template: template,

        _zoomModel: null,

        regions: {
            innerContainer: ".preview-inner-container"
        },

        ui: {
            container: ".preview-inner-container",
            outerContainer: ".preview-outer-container"
        },

        _setZoom: function _setZoom() {
            var scaledWidth = this.options.experienceViewModel.get("experience").get("width") * this._zoomModel.get("scale"),
                viewportWidth = this.ui.outerContainer.width(),
                widthLargerThanViewport = scaledWidth > viewportWidth;

            // We need to transform the origin to avoid having parts of the experience outside the scrollable viewport.
            this.ui.container.toggleClass("origin-left", widthLargerThanViewport);

            this.ui.container.css("transform", "scale(" + this._zoomModel.get("scale") + ")");
        },

        initialize: function initialize() {
            this._zoomModel = this.options.zoomModel;
        },

        onRender: function onRender() {
            // Tag all notifications with this view while in preview mode, so we can discard them again once
            // we leave the preview. We want to ensure that errors, for example a user clicking on a link in
            // the experience with Javascript, will not remain once we leave the preview...
            NotificationBar.tag(this);

            if (Browser.type.webkit) {
                this.$el.addClass("chrome");
            }

            this.listenTo(this._zoomModel, "change:scale", this._setZoom);

            // Change dimension to match experience size
            this.ui.container.height(this.options.experienceViewModel.get("experience").get("height"));
            this.ui.container.width(this.options.experienceViewModel.get("experience").get("width"));
        },

        onShow: function onShow() {
            var viewer = void 0;
            var integrations = LoggedInUserState.get("integrations");
            if (integrations.isNativeContentIntegrationsEnabled()) {
                viewer = new ExperienceCncViewer({
                    model: this.options.experienceViewModel,
                    groupsDisable: true
                });
            } else {
                viewer = new PreviewExperienceViewer({
                    model: this.options.experienceViewModel,
                    embedContainer: this.ui.container,
                    scrollableContainer: this.ui.outerContainer,
                    zoomModel: this._zoomModel
                });
            }
            this.innerContainer.show(viewer);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ExperienceViewer = __webpack_require__(1211),
        Size = __webpack_require__(84),
        PreviewSceneViewer = __webpack_require__(3037),
        _ = __webpack_require__(1);

    /**
     * A <tt>ExperienceViewer</tt> used specifically for editor preview. Supporting zooming.
     *
     * @class PreviewExperienceViewer
     *
     * @see  PreviewSceneViewer
     */
    return ExperienceViewer.extend({
        initialize: function initialize(_ref) {
            var zoomModel = _ref.zoomModel;

            // Setup the 'containerSizeProvider' to compensate for potential zooming.
            // See ExperienceViewer#responsiveViewerControllerOptions and ResponsiveViewerController#containerSizeProvider.
            this.responsiveViewerControllerOptions = {
                containerSizeProvider: function containerSizeProvider($container) {
                    var scale = zoomModel.get("scale");
                    return Size.from($container.width() * scale, $container.height() * scale);
                }
            };

            this.__super();

            this._zoomModel = zoomModel;
            // Minor hack to handle viewport size changes once the zoom scale changes...
            this.listenTo(zoomModel, "change:scale", this._scaleChangedHandler);
        },
        _scaleChangedHandler: function _scaleChangedHandler() {
            this._responsiveViewerController.updateIfValid();
            this._visibilityChangeHandler();
        },


        /**
         * @override
         */
        _newSceneViewer: function _newSceneViewer(options) {
            // Create a PreviewSceneViewer and pass on the zoom model...
            return new PreviewSceneViewer(_.extend(options, {
                zoomModel: this._zoomModel
            }));
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var SceneViewer = __webpack_require__(707);

    /**
     * A <tt>SceneViewer</tt> used for preview in the editor, supporting zooming.
     *
     * @class PreviewSceneViewer
     *
     * @see ExperiencePreview
     * @see PreviewExperienceViewer
     */
    return SceneViewer.extend({

        /**
         * @override
         */
        _calculateWidgetRect: function _calculateWidgetRect(widget) {
            // Compensate for the current zoom scale in editor preview.
            var zoomModel = this.options.zoomModel;

            return widget.getBoundingBox().scale(zoomModel.get("scale"));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3038 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="preview-outer-container experience-container">\n    <div class="preview-inner-container"></div>\n</div>\n';

}
return __p
}

/***/ }),
/* 3039 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<a class="return-to-editor btn btn-primary">Return to Editor</a>\n<div class="share-button">Share</div>\n';
 if (variants.length) { ;
__p += '\n<ul class="list-inline variant-list ' +
__e( variants[0].groupType ) +
'">\n    ';
 _.each(variants, function (variant, index) { ;
__p += '\n        <li class="' +
__e( variant.id === currentId ? 'selected ' : '' ) +
'">\n            <a href="' +
__e( variant.url ) +
'" class="variant-icon ' +
__e( variant.identifier ) +
'">#' +
__e( index + 1 ) +
'</a>\n        </li>\n    ';
 }); ;
__p += '\n</ul>\n';
 } ;
__p += '\n\n<div class="preview-region">\n    <div class="zoom-region"></div>\n</div>\n';

}
return __p
}

/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var PreviewTemplateNavBarView = __webpack_require__(3041);
    var PreviewNavBarView = __webpack_require__(1241);
    var TemplateItemViewController = __webpack_require__(712);

    /**
     * The nav bar view for template preview.
     *
     * @class PreviewTemplateNavBarView
     * @constructor
     *
     * @cfg {ExperienceViewModel} The experience view model.
     */
    return PreviewNavBarView.extend({

        template: PreviewTemplateNavBarView,

        controller: TemplateItemViewController,

        className: "nav-bar preview-nav-bar",

        keyboard: {
            // Overriding the extended method so it does nothing.
            escape: function escape() {}
        },

        bindings: {
            ".return-to-editor": {
                attributes: [{
                    observe: "currentScene",
                    name: "href",
                    onGet: function onGet() {
                        return "#";
                    }
                }]
            }
        },

        ui: {
            createExperience: ".create-experience"
        },

        events: {
            "click @ui.createExperience": function clickUiCreateExperience() {
                this.trigger("duplicate", this.model.get("experience"), "TemplatePreview");
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3041 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<a class="return-to-editor btn btn-primary">Return to Dashboard</a>\n<a class="create-experience btn btn-primary">Create Experience</a>\n<div class="preview-region">\n    <div class="zoom-region"></div>\n</div>\n';

}
return __p
}

/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ExperienceViewModel = __webpack_require__(343);

    /**
     * View model for the experience viewer.
     *
     * @class ExperienceViewModel
     * @constructor
     */
    return ExperienceViewModel.extend("TemplateViewModel", {
        defaults: {
            /**
             * @type {null|String}
             * template identificator and
             * same time this is marker of Template usage
             */
            templateId: null
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ExportView = __webpack_require__(3044);
    var ExportModel = __webpack_require__(3047);
    var Marionette = __webpack_require__(10);

    /**
     *
     * @class ExportController
     *
     */
    return Marionette.Controller.extend({
        construct: function construct() {
            var myModel = new ExportModel();
            this.view = new ExportView({ model: myModel });
        },

        options: {},
        view: ExportView,

        showExport: function showExport() {
            var myModel = new ExportModel();
            var view = new ExportView({ model: myModel });

            this.options.region.show(view);
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Permissions = __webpack_require__(22);
    var SettingsView = __webpack_require__(230);

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank;

    var template = __webpack_require__(3045);
    var Promise = __webpack_require__(21);
    var ExperienceModel = __webpack_require__(58);
    var BreakpointGroup = __webpack_require__(97);
    var BreakpointExportModel = __webpack_require__(3046);
    var ViewScope = __webpack_require__(171);
    var TemplateItemViewController = __webpack_require__(712);
    var MD5 = __webpack_require__(694);
    var ValidateBehavior = __webpack_require__(96);
    var LoggedInUserState = __webpack_require__(19);
    var NotificationBar = __webpack_require__(53);
    var ExportUtilities = __webpack_require__(1209).default;

    return SettingsView.extend({
        className: SettingsView.prototype.className + " export-view",
        controller: TemplateItemViewController,
        template: template,

        templateHelpers: function templateHelpers() {
            ViewScope.register(this, this);
            return {
                permissionToManage: Permissions.Privileges.ADMIN.can()
            };
        },

        ui: {
            tabMenuItem: ".tab",
            experienceExport: ".export-io",
            experienceExportApiKey: ".export-key",
            experienceGroupExportApiKey: ".export-group-key",
            exportAction: ".btn-export-action"
        },

        bindings: {
            ".export-key": "experienceExportApiKey",
            ".export-group-key": "experienceGroupExportApiKey",
            ".notification-box": {
                observe: ["experienceExportApiKey"],
                updateView: false,
                visible: function visible(values) {
                    return values[0] && values[0].length >= 0 && values[1] && values[1].length >= 0;
                }
            }
        },

        events: {
            "click @ui.exportAction": "_exportActionClickHandler"
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    ".export-key": {
                        validateAfter: "beforeSubmit",
                        model: true, // mark as bound to model, so make sure we cancel pending save requests on error!
                        validator: function validator(key) {
                            return isBlank(key) || /^\w{24,24}$/.test(key); // at least 24 word characters (upper/lowercase letters + digits)
                        },
                        errorText: function errorText() {
                            return "Not a valid Experience Id";
                        }
                    }
                }
            }
        },
        _exportActionClickHandler: function _exportActionClickHandler(event) {
            ViewScope.register(this, this);
            event.preventDefault();
            this.exportExperience();
        },

        /**
         * Function Exporting an experience, only available to SiteManager role
         *  We are adding an exportedFromExperienceId OR exportedFromExperienceGroupId
         *      property here so you know what experience/group was the source of each new object.
         *      the exportedFromExperienceHash/exportedExperienceGroupHash is meant to be a transactionID for debugging
         *      If you export an experience 5 times to an account throughout time, and you want to know which
         *      of the individual experienceIds go with each of the export attempts (yeah I know the experiences
         *      contain the groupId so this may be overkill), but you can then look at this Hash value
         *      and always are able to tie the experienceGroup and its children experienceIds together
         *      as an audit, just in case something goes wrong, like an export shits out halfway and you're left with
         *      experiences hanging around and you don't know where they came from.
         *      It doesn't act like an unique key in MongoDB, its more for auditing and no code actually ever uses it.
         */
        exportExperience: function exportExperience() {
            var _this = this;

            var experienceId = this.options.model.get("experienceExportApiKey");
            if (experienceId) {
                try {
                    var duplicateHash = MD5((+new Date()).toString(36), experienceId);
                    new ExperienceModel({ id: experienceId }).fetch().done(function (model) {
                        // this.model has the data after I fetch it
                        var experienceModel = new ExperienceModel(model.toJSON(null, ["companyId"]));
                        experienceModel.set("name", experienceModel.getDisplayName() + " (exported)");
                        experienceModel.set("exportedFromExperienceId", experienceModel.get("id"));
                        experienceModel.set("exportedExperienceHash", duplicateHash);
                        var imageIds = ExportUtilities.getImageIds(experienceModel);
                        if (imageIds !== null && imageIds.length !== null && imageIds.length > 0) {
                            return ExportUtilities.getImageIdsMap(imageIds).then(function (imageIdsMap) {
                                var modelWithReplacements = ExportUtilities.replaceImageIdsGivenMap(experienceModel, imageIdsMap);
                                _this._duplicate(modelWithReplacements);
                            });
                        }
                        return _this._duplicate(experienceModel);
                    });
                } catch (e) {
                    alert("EXPERIENCE ID IS NOT VALID!!:" + experienceId);
                }
            } else {
                var experienceGroupId = this.options.model.get("experienceGroupExportApiKey");
                /* Ok so duplicate Groups here is interesting, you can't take single experiences approach
                when you get a BreakPoint Group object it does NOT have scenes, so you can't expect to:
                    get the Breakpoints
                    loop through them
                    get all the scenes
                    replace the ids
                    save the object
                 Instead what you need to do is
                    clone the Breakpoint Group as is
                    Loop through all the experiences just made
                    then swap all the images links out in those experience directly.
                    this happens downstream AFTER the new experiences are made in DuplicateGroupAction.js
                 */
                var self = this;
                var grouplicateHash = MD5((+new Date()).toString(36), experienceGroupId);
                new BreakpointExportModel({ id: experienceGroupId }).fetch().done(function (model) {
                    var breakpointGroupModel = new BreakpointGroup(model.toJSON(null, ["companyId"]));
                    // later code in DuplicateGroupAction.js needs this id!!
                    breakpointGroupModel.set("exportedFromExperienceGroupId", breakpointGroupModel.get("id"));
                    breakpointGroupModel.set("exportedExperienceGroupHash", grouplicateHash);
                    self._fetchAssets(breakpointGroupModel).then(function () {
                        self._duplicate(breakpointGroupModel);
                    });
                });
            }
        },
        onRender: function onRender() {
            var settings = LoggedInUserState.get("companySettings");
            if (settings.get("exportingExperiencesEnabled")) {
                this._defaultSelection();
            } else {
                NotificationBar.error("Invalid Page");
            }
        },
        _duplicate: function _duplicate(experienceModel) {
            return this.trigger("duplicate", experienceModel, "ExperienceExport");
        },
        /**
         * @private
         * Activates the Export tab
         */
        _defaultSelection: function _defaultSelection() {
            this._selectTab("experienceExport");
        },

        _fetchAssets: function _fetchAssets(groupModel) {
            var promises = [];
            groupModel.get("entries").models.forEach(function (experienceModel) {
                promises.push(experienceModel.get("asset").fetch());
            });
            return Promise.all(promises);
        },


        /**
         * @private
         * Toggles active class on tabs and content.
         *
         * @param {String} tabName The tabName that should be activated.
         */
        _selectTab: function _selectTab(tabName) {
            this.ui.experienceExport.toggleClass("active", tabName === "experienceExport");
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3045 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Experience Export</h1>\n    </header>\n    <div class="tabs">\n        <span class="tab export-io">Experience Export</span>\n    </div>\n    <div class="tab-pane export-io">\n        <div class="row">\n            <section class="col-xs-4">\n                <p class="intro">Export Experiences into THIS account by putting an experience_id or experience_group ID below, a few things to note..</p>\n            </section>\n            <section class="col-xs-4">\n                <h4>Experience or Group Input </h4>\n                <p> Please put the experience_id or experience_group_id you wish to Import into this account below.</p>\n                <div class="analytics-input">\n                    <label>Experience Id:</label>\n                    <input class="export-key" type="text" class="tracking" placeholder="5xxxxxxxxxx">\n                    <label>Experience Group Id:</label>\n                    <input class="export-group-key" type="text" class="tracking" placeholder="5xxxxxxxxxx">\n                    <button class="btn btn-secondary btn-export-action"> &#43; Export!! </button>\n                </div>\n            </section>\n            <span class="help-block">Tip: Make sure the custom font is uploaded into the destination account, prior to starting</span>\n\n        </div>\n    </div>\n</div>\n<footer class="default-footer"></footer>\n';

}
return __p
}

/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var BreakpointGroup = __webpack_require__(97);
    var Configuration = __webpack_require__(297);
    /**
     * A model of a breakpoint solely for getting Export to work
     * This allows us to call to Akamai to get the last pushed experience whereas normal breakpoints call to java
     *
     * @class BreakpointExportModel
     * @constructor
     */
    return BreakpointGroup.extend("BreakpointExportModel", {
        url: function url() {
            var urlBase = Configuration.default.adminApiBaseUrl; // viewerBaseUrl calls S3
            return urlBase + "/api/groups/" + this.get("id");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25);

    /**
     * View model for Experience Export
     *
     * @class ExportModel
     * @constructor
     */
    return ImprovedModel.extend("Export", {

        selection: null,
        defaults: {
            experienceExportApiKey: null,
            triggerOrigin: null
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Backbone = __webpack_require__(7),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        Promise = __webpack_require__(21);


    var log = new Logger("FilteringRouter");

    var warn = function warn(route) {
        log.info("Pre-route filter blocked routing of '" + route + "'.");
    };

    /**
     * An Backbone.Router subclass that allows a filter function to be run before each route is dispatched.
     *
     * The filter should be set up as the "before" property, and return a Promise for the route dispatch
     * being allowed, or exactly false if the route dispatch should be blocked.
     *
     * If you need an "after" filter, just listen to Backbone.history.on("route", ...) .
     *
     * @author Bo Gotthardt
     * @class FilteringRouter
     */
    var FilteringRouter = Backbone.Router.extend({

        _routeOwner: null,

        /**
         * Keeps track of the last successful route, so we can restore it when we block a route.
         * @type {String}
         */
        lastSuccessfulRoute: null,

        /**
         * The previous route fragment.
         *
         * @type {String}
         */
        previousRoute: null,

        /**
         * @private
         *
         * Invokes the callback, and store the return value in the <tt>_routeOwner</tt> field.
         *
         * If the "route owner" contains an <tt>onClose</tt> method, this will be invoked when the route owner changes.
         *
         * @param  {Function|String} callback The route callback or function name.
         * @param  {Array}   args     Arguments
         */
        _handleCallback: function _handleCallback(callback, args) {
            var func = _.isFunction(callback) ? callback : this[callback],
                routeOwner = func.apply(this, args);

            if (this._routeOwner) {
                // It might be a Marionette.Controller or an object exposing a onClose callback...
                var closeCallback = this._routeOwner.close || this._routeOwner.onClose;

                if (closeCallback) {
                    // If the route owner has changed, close the previous
                    if (this._routeOwner !== routeOwner) {
                        closeCallback.call(this._routeOwner);
                    }

                    this._routeOwner = null;
                }
            }

            this._routeOwner = routeOwner;
        },

        route: function route(_route, callback) {
            if (this.before) {
                var newCallback = function () {
                    var _this = this;

                    var args = _.toArray(arguments),
                        blockRoute = this.before.apply(this, [_route].concat(args));

                    this.previousRoute = this.lastSuccessfulRoute;

                    if (Promise.isPromise(blockRoute)) {
                        blockRoute.done(function () {
                            _this.lastSuccessfulRoute = Backbone.history.fragment;
                            _this._handleCallback(callback, args);
                        }).fail(function () {
                            warn(_route);
                        });
                    } else {
                        /* eslint-disable no-lonely-if */
                        if (blockRoute === false) {
                            warn(_route);
                        } else {
                            this.lastSuccessfulRoute = Backbone.history.fragment;
                            this._handleCallback(callback, args);
                        }
                    }
                }.bind(this);

                Backbone.Router.prototype.route.call(this, _route, newCallback);
            } else {
                Backbone.Router.prototype.route.call(this, _route, callback);
            }
        }

    }, {

        /**
         * Convenience for navigating to the specified path - delegating to <tt>Backbone.history.navigate</tt>.<p>
         *
         * @param  {String} path The path to navigate to.
         * @param  {Object} [options] Options passed to <tt>Backbone.history.navigate</tt>, e.g. <tt>{trigger: true, replace: true}</tt>.
         */
        navigate: function navigate(path, options) {
            Backbone.history.navigate(path, options);
        },

        /**
         * The navigation call is wrapped in a <tt>defer</tt> (setTimeout of 0) to break out of the current callstack
         * to avoid messing with the router state handled in the <tt>FilteringRouter</tt>.
         *
         * @param  {String} path The path to navigate to.
         * @param  {Object} options Options passed to <tt>Backbone.history.navigate</tt>, e.g. <tt>{trigger: true, replace: true}</tt>.
         */
        navigateLater: function navigateLater(path, options) {
            _.defer(FilteringRouter.navigate.bind(FilteringRouter.navigate, path, options));
        }

    });

    return FilteringRouter;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var IntegrationsView = __webpack_require__(3050);
    var Promise = __webpack_require__(21);
    var LoggedInUserState = __webpack_require__(19);
    var ExperienceMetadataCollection = __webpack_require__(3076);
    var Marionette = __webpack_require__(10);
    var Permissions = __webpack_require__(22);

    return Marionette.Controller.extend({
        /**
         * Show integrations page.
         * @param {Backbone.Collection<IntegrationModel>} integrationsCollection a collection of integration models
         * @param {String} [tabName] The tabName that you wanna explicitly show; optional.
         */
        showIntegrations: function showIntegrations(tabName) {
            var _this = this;

            var integrationsCollection = LoggedInUserState.get("integrations");

            Promise.all([LoggedInUserState.get("companySettings").fetch(), ExperienceMetadataCollection.experiences(),
            // Fetch the prototype action collection to update the usage info lists. The
            // returned value is not used here.
            LoggedInUserState.get("prototypeActionCollection").fetch()]).then(function (results) {
                var _results = _slicedToArray(results, 2),
                    settings = _results[0],
                    experiences = _results[1];

                _this.options.region.show(new IntegrationsView({
                    model: settings,
                    experiences: experiences,
                    tabName: tabName,
                    integrationsCollection: integrationsCollection,
                    isManager: Permissions.Roles.MANAGER.is()
                }));
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        extend = _require.extend;

    var AddOnsView = __webpack_require__(3051);
    var CustomJsView = __webpack_require__(3065);
    var SettingsView = __webpack_require__(230);
    var Storage = __webpack_require__(34);
    var template = __webpack_require__(3075);

    return SettingsView.extend({

        className: SettingsView.prototype.className + " integrations-view",

        template: template,

        ui: {
            tabs: ".tabs-integrations > .tab",
            tabPanes: ".tab-pane"
        },

        regions: extend({
            addOnsRegion: ".add-ons",
            customActionsRegion: ".custom-actions"
        }, SettingsView.prototype.regions),

        events: {
            "click @ui.tabs": "_tabClickHandler"
        },

        viewScope: {
            experiences: function experiences() {
                return this.options.experiences;
            }
        },

        onShow: function onShow() {
            this.addOnsRegion.show(new AddOnsView({
                model: this.model,
                integrationsCollection: this.options.integrationsCollection,
                isManager: this.options.isManager
            }));

            var customJsView = new CustomJsView({
                experiences: this.options.experiences
            });

            this.customActionsRegion.show(customJsView);

            var activeTab = this.options.tabName || Storage.Local.get(Storage.Keys.INTEGRATIONS, "tab") || "add-ons";
            this._showTab(activeTab);
        },
        _tabClickHandler: function _tabClickHandler(event) {
            this._showTab(event.target.getAttribute("data-tab-name"));
        },
        _showTab: function _showTab(tabName) {
            var _ui = this.ui,
                tabs = _ui.tabs,
                tabPanes = _ui.tabPanes;


            tabs.each(function (index, tab) {
                tab.classList.toggle("active", tab.getAttribute("data-tab-name") === tabName);
            });

            tabPanes.each(function (index, tabPane) {
                tabPane.classList.toggle("active", tabPane.getAttribute("data-tab-pane") === tabName);
            });

            Storage.Local.update(Storage.Keys.INTEGRATIONS, "tab", tabName);
        },
        beforeNavigate: function beforeNavigate() {
            return this.addOnsRegion.currentView.beforeNavigate();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var SalesforceCommerceWidgetSettingsView = __webpack_require__(3052);
    var SalesforceCommerceQuickViewSettings = __webpack_require__(3058);
    var Scene7IntegrationView = __webpack_require__(3060);
    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(3063);
    var ShopifyStoreSettings = __webpack_require__(3064).default;
    var ReactBridge = __webpack_require__(137);
    var Configuration = __webpack_require__(27);
    var LoggedInUserState = __webpack_require__(19);
    var Storage = __webpack_require__(34);

    return ImprovedView.extend({

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                isScene7Enabled: this._isScene7Enabled,
                isShopifyMenuEnabled: this._isShopifyMenuEnabled
            };
        },


        ui: {
            tabs: ".tab",
            tabPanes: ".tab-pane"
        },

        regions: {
            widget: ".widget",
            quickView: ".quick-view-action",
            adobeScene7: ".adobe-scene-7",
            shopifySettings: ".shopify-store"
        },

        events: {
            "click @ui.tabs": "_tabClickHandler"
        },

        initialize: function initialize() {
            this._isScene7Enabled = this.options.integrationsCollection && this.options.integrationsCollection.isScene7IntegrationEnabled();
            this._isShopifyMenuEnabled = this._getConnectSettings();
        },
        onRender: function onRender() {
            // create the model class.
            this.widget.show(new SalesforceCommerceWidgetSettingsView({ model: this.model }));
            this.quickView.show(new SalesforceCommerceQuickViewSettings());
            if (this._isScene7Enabled) {
                this.adobeScene7.show(new Scene7IntegrationView({
                    integrationsCollection: this.options.integrationsCollection,
                    isManager: this.options.isManager
                }));
            }
            if (this._isShopifyMenuEnabled) {
                this.shopifySettings.show(this._setShopifySetting());
            }
        },
        _tabClickHandler: function _tabClickHandler(event) {
            this._showTab(event.target.getAttribute("data-tab-name"));
        },
        _showTab: function _showTab(tabName) {
            this.ui.tabs.each(function (index, element) {
                $(element).toggleClass("active", element.getAttribute("data-tab-name") === tabName);
            });

            this.ui.tabPanes.each(function (index, element) {
                $(element).toggleClass("active", element.getAttribute("data-tab-pane") === tabName);
            });
        },
        _setShopifySetting: function _setShopifySetting() {
            return ReactBridge.viewFromComponent(ShopifyStoreSettings);
        },
        beforeNavigate: function beforeNavigate() {
            return this.widget.currentView.beforeNavigate();
        },
        _getConnectSettings: function _getConnectSettings() {
            var companyId = LoggedInUserState.attributes.company.id,
                endpointUrl = Configuration.creatorSettingApiBaseUrl + "/v1/settings/" + companyId,
                token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"),
                bearerToken = "Bearer " + token,
                settingName = "connect",
                path = endpointUrl + "?name=" + settingName;
            var isShopifyMenuEnabled = false;

            $.ajax({
                async: false,
                url: path,
                method: "GET",
                headers: {
                    Authorization: bearerToken
                },
                success: function success(data) {
                    Storage.Local.update(Storage.Keys.CREATOR_CONNECT, data.connect);
                    isShopifyMenuEnabled = data.connect.enabled && data.connect.ipd.enabled;
                },
                error: function error() {
                    isShopifyMenuEnabled = false;
                }
            });

            return isShopifyMenuEnabled;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Configuration = __webpack_require__(27);
    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);
    var NotificationBar = __webpack_require__(53);
    var Permissions = __webpack_require__(22);
    var Promise = __webpack_require__(21);

    var _require = __webpack_require__(30),
        isBlank = _require.isBlank;

    var SyncManager = __webpack_require__(44);
    var SequentialButton = __webpack_require__(112);
    var Tooltip = __webpack_require__(35);
    var TagInputView = __webpack_require__(3053);
    var template = __webpack_require__(3057);
    var ValidateBehavior = __webpack_require__(96);
    var SalesforceCommerceConnect = __webpack_require__(206);

    var ARTICLE_LINK = Configuration.communityBaseUrl + "/hc/en-us/articles/204729309-SalesforceCommerce-Product-Link-Widget";
    var UPDATED_MESSAGE = "Your Salesforce Commerce Cloud settings have been saved.";
    var FAILED_MESSAGE = "Your Salesforce Commerce Cloud settings have not been saved.";
    var CONNECT_ERROR_MESSAGE = "But failed to connect to the Salesforce Commerce Cloud Server. Please check your setup - for more information, see the article of <a class='widget-community-link' href='" + ARTICLE_LINK + "' target='zmags_creator_community'>Salesforce Commerce Cloud Widget</a>.";

    /**
     * The salesforceCommerce widget settings view class that enables the user to Update the settings
     * of the widget.
     *
     * @class SalesforceCommerceWidgetSettingsView
     *
     * @cfg {CompanySettingsModel} model.
     * @author Pedro Augusto / <a href="http://www.zmags.com">Zmags</a>
     */
    return ImprovedView.extend({

        template: template,

        // SalesforceCommerce settings model, @see {SalesforceCommerceSettingsModel}
        salesforceCommerceSettings: null,

        // Notification message is shown when settings are saved
        notificationMessage: "",

        // Postfix notification in case of any errors when saving to give additional info
        postfixError: "",

        ui: {
            clientId: ".salesforceCommerceClientId",
            userUrl: ".salesforceCommerceUrl",
            save: ".save"
        },

        regions: {
            "sites": ".site-names"
        },

        templateHelpers: function templateHelpers() {
            return {
                isSalesforceCommerceEnabled: SalesforceCommerceConnect.isQuickViewEnabled(),
                permissionToManage: Permissions.Privileges.ADMIN.can(),
                articleLink: ARTICLE_LINK
            };
        },


        events: {
            "click .save": "_saveSettingsHandler"
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                isEnabled: function isEnabled() {
                    return Permissions.Privileges.ADMIN.can();
                },

                inputValidation: {
                    ".salesforceCommerceUrl": {
                        validateAfter: "beforeSubmit",
                        // mark as bound to model, so make sure we cancel pending save requests on error!
                        model: true,
                        validator: function validator(userUrl) {
                            // It is need to check the data in the clientId in case the user want to remove the salesforceCommerce
                            // credentials.
                            return isBlank(userUrl) && isBlank(this.ui.clientId.val()) || SalesforceCommerceConnect.validateUrl(userUrl) === null;
                        },
                        errorText: function errorText(userUrl) {
                            return SalesforceCommerceConnect.validateUrl(userUrl);
                        }
                    },
                    ".salesforceCommerceClientId": {
                        validateAfter: "beforeSubmit",
                        // mark as bound to model, so make sure we cancel pending save requests on error!
                        model: true,
                        validator: function validator(key) {
                            return isBlank(key) && isBlank(this.ui.userUrl.val()) || SalesforceCommerceConnect.validateClientId(key.trim());
                        },
                        errorText: function errorText() {
                            return "Not a valid Salesforce Commerce Cloud Client ID";
                        }
                    }
                }
            }
        },

        salesforceCommerceBindings: {
            ".salesforceCommerceUrl": {
                observe: "userUrl",
                onSet: function onSet(val) {
                    return val.trim();
                }
            },
            // We don't need to trim because the format is guarded by validation which does not allow empty spaces.
            ".salesforceCommerceClientId": {
                observe: "clientId",
                onSet: function onSet(val) {
                    return val.trim();
                }
            }
        },

        filterBindings: {
            ".name": "name",
            ".price": "price",
            ".brand": "brand",
            ".description": "description",
            ".availability": "availability"
        },

        initialize: function initialize() {
            this.salesforceCommerceSettings = SalesforceCommerceConnect.getSettings();

            // Clone a collection for editing and we copy them back once save button is hit
            this.clonedSites = this.salesforceCommerceSettings.get("sites").deepClone();
            this.oldCredentail = {
                userURL: this.salesforceCommerceSettings.get("userUrl"),
                clientId: this.salesforceCommerceSettings.get("clientId")
            };
        },
        onRender: function onRender() {
            // Bind model with the custom salesforceCommerceWebApiSettings
            this.stickit(this.salesforceCommerceSettings, this.salesforceCommerceBindings);

            // Bind model with the custom salesforceCommerceFilterSettings
            this.stickit(this.salesforceCommerceSettings.get("filters"), this.filterBindings);
        },
        onShow: function onShow() {
            this._saveSettingsHandler = SequentialButton.add(this.ui.save, this._saveSettingsHandler.bind(this));

            var tagsView = new TagInputView({
                collection: this.clonedSites,
                propName: "siteId"
            });

            this.sites.show(tagsView);
            SyncManager.onSync({
                context: this,
                target: this.model,
                // Re-render because we need to disable the delete button
                callback: tagsView.render.bind(tagsView)
            });

            if (this.salesforceCommerceSettings.get("enabled")) {
                this.listenTo(this.model, "change:demandware", this._settingChangeHandler);
                this.listenTo(this.clonedSites, "add", this.enableSaveButton);
                this.listenTo(this.salesforceCommerceSettings.get("filters"), "change", this.enableSaveButton);
                this.configureTooltip();
            }
        },
        _settingChangeHandler: function _settingChangeHandler() {
            this.enableSaveButton();
            this.configureTooltip();
        },
        enableSaveButton: function enableSaveButton() {
            if (Permissions.Privileges.ADMIN.can()) {
                this.ui.save.prop("disabled", false);
            }
        },
        disableSaveButton: function disableSaveButton() {
            this.ui.save.prop("disabled", true);
        },


        /**
         * Adds a tooltip to show the fully qualified url for the SalesforceCommerce API when available.
         *
         *  @private
         */
        configureTooltip: function configureTooltip() {
            var webApiUrl = this.salesforceCommerceSettings.get("webApiUrl");

            if (webApiUrl) {
                Tooltip.add(this.ui.userUrl, {
                    content: "Default inferred Salesforce Commerce Cloud URL: <b>" + webApiUrl + "</b>",
                    placement: "top",
                    duration: 10000,
                    delay: { show: 1500, hide: 0 },
                    width: 350
                });
            } else {
                Tooltip.remove(this.ui.userUrl);
            }
        },


        /**
         * Here we update the settings. We first check if we can connect to the SalesforceCommerce default site. If that works,
         * we then validate all the site ids and save the settings. Otherwise, we skip the validation
         * but save the settings. In the end, we clean up by calling internal finish.
         *
         * @private
         */
        _saveSettingsHandler: function _saveSettingsHandler() {
            var _this = this;

            var settings = this.salesforceCommerceSettings;
            var clientId = settings.get("clientId");
            var userUrl = settings.get("userUrl");
            var sequentialButton = Promise.deferred();
            var promise = null;

            if (SalesforceCommerceConnect.validateUrl(userUrl) || !SalesforceCommerceConnect.validateClientId(clientId)) {
                promise = Promise.rejected(null);
            } else if (clientId === this.oldCredentail.clientId && userUrl === this.oldCredentail.userURL) {
                // If the credentials are the same, then the inferred URL will be the same as well.
                promise = Promise.resolved(settings.get("webApiUrl"));
            } else {
                promise = SalesforceCommerceConnect.inferAddress(userUrl, clientId);
            }

            // Finishing up after everything is saved, including stop spinning, disable button and showing notification
            var finish = function finish() {
                var method = "open";

                sequentialButton.resolve();
                _this.disableSaveButton();

                if (_this.postfixError) {
                    method = "error";
                }

                var siteList = [];

                if (_this.clonedSites) {
                    siteList = _this.clonedSites.pluck("siteId");
                }

                var eventProperties = {
                    category: "Commerce",
                    salesforceCommerceUrl: userUrl,
                    salesforceCommerceSites: siteList.join() || "No Site",
                    integrationType: "SalesforceCommerce",
                    triggerOrigin: "SaveSalesforceCommerceSettingsButton"
                };

                EditorEvents.trigger(EditorEvents.constants.SAVE_INTEGRATION, eventProperties);

                NotificationBar[method](_this.notificationMessage + " " + _this.postfixError, { closeDelay: 7000 });

                // Reset the error message otherwise it will keep showing in the subsequent saving
                _this.postfixError = "";
            };

            /*
             * Note: we may be attempted to return this promise. But instead, we return the sequentialButton promise
             * below because we need to wait for all the promises to finish in both then and fail cases. So the
             * sequential button works in a good manner, otherwise the spinning may stop while requests are going on.
             */
            promise.then(function (url) {
                // Validate all site ids as well as save the setting to backend, followed by a finish up.
                // Note: don't use Promise.all here, because we need to wait until both validation and save are done,
                // regardless resolved or rejected. With Promise.all, it will be resolved once any promise is rejected
                Promise.any([_this._validateSiteIds(), _this._save(url)]).then(finish);
            }).fail(function () {
                _this.postfixError = CONNECT_ERROR_MESSAGE;
                // We still want to save the settings even though it fails
                _this._save().always(finish);
            });

            return sequentialButton;
        },


        /**
         * Save the current settings to the backend
         *
         * @param inferredURL   The inferred url queried based on the clientId and url.
         * @returns {Promise}
         * @private
         */
        _save: function _save(inferredURL) {
            var _this2 = this;

            var settings = this.salesforceCommerceSettings;

            // Update the old credential, so we can compare again. Note it is worth keeping the reference
            // because finding an inferred url is expensive.
            this.oldCredentail = {
                userURL: settings.get("userUrl"),
                clientId: settings.get("clientId")
            };

            settings.set({
                webApiUrl: inferredURL,
                sites: this.clonedSites
            });

            return this.model.saveLater().done(function () {
                _this2.notificationMessage = UPDATED_MESSAGE;
            }).fail(function () {
                _this2.notificationMessage = FAILED_MESSAGE;
            });
        },


        /**
         * Validate all site ids and return a promise which is resolved when all validation is done
         *
         * @returns {Promise} promise
         * @private
         */
        _validateSiteIds: function _validateSiteIds() {
            var _this3 = this;

            var settings = this.salesforceCommerceSettings;
            var failed = [];

            var promises = this.clonedSites.map(function (site) {
                var siteId = site.get("siteId");

                return SalesforceCommerceConnect.inferAddress(settings.get("userUrl"), settings.get("clientId"), siteId).fail(function () {
                    failed.push(siteId);
                });
            });

            return Promise.any(promises).then(function () {
                if (failed.length) {
                    _this3.postfixError = "But failed to connect to " + failed.join(", ");
                }
            });
        },
        beforeNavigate: function beforeNavigate() {
            return this.ui.save.length > 0 && !this.ui.save.prop("disabled");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var KeyCode = __webpack_require__(88);
    var Backbone = __webpack_require__(7);
    var Marionette = __webpack_require__(10);
    var TagView = __webpack_require__(3054);
    var template = __webpack_require__(3056);

    var SEPARATOR = [KeyCode.COMMA, KeyCode.ENTER, KeyCode.RETURN];

    /**
     * A tags input is a component of input box that automatically creates tags – also called tokens
     * It's useful for tagging and highlighting information right on the input box, providing an ease of use of UX
     *
     * This component provides the functionality like auto tag creation, edit and delete in place. But due to the
     * special requirement, the tag is designed as non-deletable after saved.
     *
     * @class TagInputView
     * @author Yijie Li
     */
    return Marionette.CompositeView.extend({

        className: "tag-input",

        template: template,

        itemView: TagView,

        itemViewContainer: ".tags",

        options: {
            propName: "tags"
        },

        ui: {
            input: ".input"
        },

        events: {
            "keydown .input": "_handleKeyEvents",
            "blur .input": "_processInput",
            "click": "_focusInput"
        },

        collectionEvents: {
            "add remove change": "_collectionChangeHandler"
        },

        constructor: function constructor(options) {
            if (!options.collection) {
                options.collection = new Backbone.Collection();
            }

            this.__super(options);
        },
        itemViewOptions: function itemViewOptions() {
            return {
                propName: this.options.propName
            };
        },
        _collectionChangeHandler: function _collectionChangeHandler() {
            this._updateClassName();

            var propName = this.options.propName;
            // Construct list of tags to be dispatched, excluding empty
            // strings (might happen if you start inline editing).

            var tags = this.collection.chain().map(function (model) {
                return model.get(propName);
            }).filter(function (tag) {
                return tag.length > 0;
            }).value();

            this.triggerMethod("change", tags);
        },
        _focusInput: function _focusInput() {
            this._updateClassName(true);
            this.ui.input.focus();
        },
        _handleKeyEvents: function _handleKeyEvents(event) {
            if (SEPARATOR.indexOf(event.keyCode) !== -1) {
                this._processInput();
                event.preventDefault();
            }
        },
        _updateClassName: function _updateClassName(state) {
            state = state || this.collection.models.length > 0;
            this.$el.toggleClass("has-tags", state);
        },
        _processInput: function _processInput() {
            var input = this.ui.input.text();
            var names = input.split(",");

            var _names = _slicedToArray(names, 1),
                name = _names[0];

            var findQuery = {};

            findQuery[this.options.propName] = name;

            var exists = this.collection.findWhere(findQuery) !== undefined;

            if (name && name.trim() && !exists) {
                this.addTag(name);
                this.ui.input.text("");
            }

            this._updateClassName();
        },
        addTag: function addTag(tag) {
            if (this.options.limit && this.collection.models.length >= this.options.limit) {
                return;
            }

            var tagModel = _defineProperty({}, this.options.propName, tag);

            this.collection.add(new this.collection.model(tagModel));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var KeyCode = __webpack_require__(88);
    var template = __webpack_require__(3055);

    var ENTER_KEYS = [KeyCode.ENTER, KeyCode.RETURN];
    /**
     * A tag view represents a single tag among all tags.
     *
     * @class TagView
     * @author Yijie Li
     */
    return ImprovedView.extend({

        tagName: "li",

        className: "tag",

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                isNew: !this.model.has("id")
            };
        },
        bindings: function bindings() {
            return {
                ".value": this.options.propName
            };
        },


        events: {
            "click .delete": "destroy",
            "keydown .value": "_handleKeyEvents",
            "click": "_clickHandler",
            "blur .value": "_blurHandler"
        },

        _clickHandler: function _clickHandler(event) {
            event.stopPropagation();
        },
        _blurHandler: function _blurHandler() {
            if (!this.model.get(this.options.propName) && !this.model.has("id")) {
                this.destroy();
            }
        },


        // We don't allow line break in the input
        _handleKeyEvents: function _handleKeyEvents(event) {
            if (ENTER_KEYS.indexOf(event.keyCode) !== -1) {
                event.preventDefault();
            }
        },
        destroy: function destroy() {
            this.model.destroy();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3055 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<span class="value" contenteditable="' +
__e(isNew ) +
'"></span>\n';
 if (isNew) { ;
__p += '\n    <span class="delete">&#10005;</span>\n';
 } ;
__p += '\n';

}
return __p
}

/***/ }),
/* 3056 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<ul class="tags list-unstyled list-inline">\n</ul>\n<div class="input" contenteditable="true"/>\n\n\n\n\n';

}
return __p
}

/***/ }),
/* 3057 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class=\'salesforce-commerce-widget-settings integrations-setup\'>\n    <!--First row with the fields and informations-->\n    <section class="row">\n        <section class="col-xs-4">\n            <h4>Salesforce Commerce Cloud Product Widget</h4>\n            <p class="intro">With Creator\'s Salesforce Commerce Cloud Widget, you can search your Product Database from within the Editor and easily create QuickView links for your Creator Experiences.</p>\n\n            ';
 if (!isSalesforceCommerceEnabled && config.salesEmail) { ;
__p += '\n                <p>Get the Add-on by contacting <a href="mailto:' +
__e( config.salesEmail ) +
'">' +
__e( config.salesEmail ) +
'</a></p>\n            ';
 } ;
__p += '\n\n            ';
 if (isSalesforceCommerceEnabled && !permissionToManage) { ;
__p += '\n                <p>You must be a <a href="#manageAccount">Manager</a> to configure your Salesforce Commerce Cloud Account to work with Zmags Creator.</p>\n            ';
 } ;
__p += '\n\n            <div class="widget-icon">\n                <div class="illustration salesforce-commerce-widget-logo"></div>\n            </div>\n\n            ';
 if (!isSalesforceCommerceEnabled) { ;
__p += '\n                <div class="illustration salesforce-commerce-logo"></div>\n            ';
 } else {;
__p += '\n                <div class="notification-box">\n                    <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">Enable Creator to connect to your Salesforce Commerce Cloud Account</span>\n                    <p>Find the instructions on how to configure your Salesforce Commerce Cloud OCAPI with Zmags Creator <a href="' +
__e( articleLink ) +
'" target="_blank" class="widget-community-link">here</a>.</p>\n                </div>\n            ';
 } ;
__p += '\n        </section>\n        ';
 if (isSalesforceCommerceEnabled) { ;
__p += '\n        <section class="col-xs-4">\n            <h4>1. Connect your Salesforce Commerce Cloud Account</h4>\n            ';
 if (permissionToManage) { ;
__p += '\n                <p>Type or copy your Salesforce Commerce Cloud credentials into the fields below:</p>\n            ';
 } ;
__p += '\n            <div class="form-group">\n                <label>Salesforce Commerce Cloud URL:</label>\n                <input type="text" class="form-control salesforceCommerceUrl" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += '\n                       id="salesforceCommerceUrl"\n                       placeholder="Type your Salesforce Commerce Cloud URL"/>\n            </div>\n\n            <div class="form-group">\n                <label>Client ID:</label>\n                <input type="text" class="form-control salesforceCommerceClientId" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += '\n                       id="salesforceCommerceClientId"\n                       placeholder="Type your Client ID"/>\n            </div>\n\n            <div class="form-group">\n                <label>Site IDs:</label><br/>\n                <div class="site-names' +
__e( permissionToManage ? '': ' disabled') +
'"></div>\n            </div>\n\n        </section>\n        <section class="col-xs-4">\n            <h4>2. Filter Product Information</h4>\n            ';
 if (permissionToManage) { ;
__p += '\n            <p>Configure Product information shown in the Salesforce Commerce Cloud Widget search results in the Editor:</p>\n            ';
 } ;
__p += '\n            <div class="row filters">\n                <div class="col-xs-6">\n                    <label>\n                        <input type="checkbox" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="availability"/> Availability\n                    </label>\n                    <label>\n                        <input type="checkbox" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="brand"/> Brand\n                    </label>\n                    <label>\n                        <input type="checkbox" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="description"/> Description\n                    </label>\n                </div>\n                <div class="col-xs-6">\n                    <label>\n                        <input type="checkbox" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="price"/> Price\n                    </label>\n                    <label>\n                        <input type="checkbox"  ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += ' class="name"/> Product Name\n                    </label>\n                </div>\n            </div>\n        </section>\n        ';
 } ;
__p += '\n    </section>\n\n    <!-- Save button -->\n    ';
 if (isSalesforceCommerceEnabled) { ;
__p += '\n        <section class="row">\n            <div class="col-xs-12">\n                <button class="btn btn-primary pull-right save ladda-button" data-style="expand-right" disabled>Save</button>\n            </div>\n        </section>\n    ';
 } ;
__p += '\n</section>\n';

}
return __p
}

/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var template = __webpack_require__(3059);
    var SalesforceCommerce = __webpack_require__(206);

    /**
     * @class SalesforceCommerceQuickViewSettings
     *
     * The <i>SalesforceCommerce Quick settings</i> responsible to inform the user about the QuickView feature.
     */
    return ImprovedView.extend({
        template: template,

        templateHelpers: function templateHelpers() {
            return {
                isSalesforceCommerceEnabled: SalesforceCommerce.isQuickViewEnabled()
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3059 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="row integrations-setup salesforce-commerce-quick-view">\n    <section class="col-xs-4">\n        <h4>Salesforce Commerce Cloud QuickView Action</h4>\n        <p class="intro">Creator\'s Salesforce Commerce Cloud QuickView Action makes it a lot easier to call your own Product\n                         QuickViews for different Widgets in your Creator Experiences.</p>\n        ';
 if (!isSalesforceCommerceEnabled && config.salesEmail) { ;
__p += '\n        <p>Get the Add-on by contacting <a href="mailto:' +
__e( config.salesEmail ) +
'">' +
__e( config.salesEmail ) +
'</a></p>\n        ';
 } ;
__p += '\n        <div class="illustration salesforce-commerce-logo"></div>\n    </section>\n    ';
 if (isSalesforceCommerceEnabled) { ;
__p += '\n    <section class="col-xs-8">\n        <section class="row">\n            <section class="col-xs-6">\n                <h4>How to use the Action</h4>\n                <p>Your Salesforce Commerce Cloud QuickView Action is available in the Action Menu inside the Editor.\n                    Simply copy your Product ID\'s into the Action field to connect your Product Database\n                    with your published Creator Experiences.\n                </p>\n            </section>\n        </section>\n        <section class="row">\n            <section class="col-xs-6">\n                <div class="illustration salesforce-commerce-action-1"></div>\n            </section>\n            <section class="col-xs-6">\n                <div class="illustration salesforce-commerce-action-2"></div>\n            </section>\n        </section>\n    </section>\n    ';
 } ;
__p += '\n</section>\n';

}
return __p
}

/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        pick = _require.pick,
        isEqual = _require.isEqual;

    var Marionette = __webpack_require__(10);
    var NotificationBar = __webpack_require__(53);
    var Preconditions = __webpack_require__(14);
    var Scene7HostedRegionEnum = __webpack_require__(1188);
    var SequentialButton = __webpack_require__(112);
    var Scene7IntegrationModel = __webpack_require__(1187);
    var template = __webpack_require__(3061);
    var Tooltip = __webpack_require__(35);

    // require scene7 example screenshot so that webpack includes the image in the build
    __webpack_require__(3062);

    var SCENE7_SAVE_MESSAGE = "The Adobe Integration has been saved.";

    return Marionette.Layout.extend({
        template: template,

        templateHelpers: function templateHelpers() {
            Preconditions.checkState(typeof this.options.isManager === "boolean"); // check it's not null

            return {
                Scene7HostedRegionEnum: Scene7HostedRegionEnum,
                isManager: this.options.isManager
            };
        },


        ui: {
            saveButton: ".save-adobe-scene7-credentials",
            saveButtonTooltipWrapper: ".save-button-tooltip-wrapper",
            usernameInput: "[name=scene7-username]",
            passwordInput: "[name=scene7-password]",
            companyNameInput: "[name=companyName]",
            regionInput: "[name=region]"
        },

        events: {
            "click @ui.saveButton": "_save",
            "keyup @ui.usernameInput": "_updateModel",
            "keyup @ui.passwordInput": "_updateModel",
            "keyup @ui.companyNameInput": "_updateModel",
            "change @ui.regionInput": "_updateModel",
            "click @ui.passwordInput": "_focusPasswordInput"
        },

        _sequentialSaveButtonAction: null,

        initialize: function initialize() {
            this.model = this._getScene7IntegrationModel();
            this._savedModelData = this.model.toJSON();
        },
        onRender: function onRender() {
            var _this = this;

            this._sequentialSaveButtonAction = SequentialButton.add(this.ui.saveButton, function () {
                if (_this.ui.saveButton.is("disabled")) {
                    return;
                }

                return _this.model.save().then(function () {
                    // TODO In future we should avoid having passwords on the model, to prevent to have a frontend model with credentials.
                    // Said so, the backend does not return the password in the API response and password is only set in this view, so
                    // it is safe to clear the password after the request is successful, as all the subsequent integrations requests thorught-out
                    // Creator, will not have it in the frontend model.
                    _this.model.unset("password", { silent: true });
                    _this.options.integrationsCollection.add(_this.model);

                    NotificationBar.open(SCENE7_SAVE_MESSAGE, { closeDelay: 7000 });
                });
            });
        },
        _hasAlreadyIntegration: function _hasAlreadyIntegration() {
            return Boolean(this.options.integrationsCollection.get(this.model));
        },
        _getScene7IntegrationModel: function _getScene7IntegrationModel() {
            var existingScene7Model = this.options.integrationsCollection.findWhere({ type: Scene7IntegrationModel.type });
            if (existingScene7Model) {
                return existingScene7Model;
            }

            return new Scene7IntegrationModel();
        },
        _focusPasswordInput: function _focusPasswordInput(event) {
            if (!this.model.isNew()) {
                event.target.select();
            }
        },
        _updateModel: function _updateModel() {
            var formData = {
                username: this.ui.usernameInput.val(),
                password: this.ui.passwordInput.val(),
                companyName: this.ui.companyNameInput.val(),
                region: Scene7HostedRegionEnum.lookup(this.ui.regionInput.val()).value
            };

            this.model.set(formData);

            var formDataKeys = Object.keys(formData);
            var changed = !isEqual(pick(this._savedModelData, formDataKeys), pick(this.model.attributes, formDataKeys));

            Tooltip.remove(this.ui.saveButtonTooltipWrapper);

            if (!this.model.isValid()) {
                Tooltip.add(this.ui.saveButtonTooltipWrapper, {
                    title: "Invalid Credentials",
                    content: this.model.validationError,
                    placement: "bottom",
                    alignCenter: true,
                    offset: {
                        align: "center"
                    },
                    width: "auto",
                    delay: { show: 0, hide: 0 }
                });

                this.ui.saveButton.prop("disabled", true);
                return;
            }

            this.ui.saveButton.prop("disabled", !changed);
        },
        _save: function _save() {
            var _this2 = this;

            this._sequentialSaveButtonAction().then(function () {
                _this2.ui.saveButton.prop("disabled", true);
                _this2._savedModelData = _this2.model.toJSON();
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3061 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<section class="row integrations-setup adobe-scene7-settings">\n    <section class="col-xs-4">\n        <h4>Adobe Scene7 Image Access</h4>\n        <p class="intro">With Creator\'s Adobe Scene7 Image Access you can access your assets from within the Editor and seamlessly add approved images to your Creator Experiences</p>\n    </section>\n    <section class="col-xs-4">\n        <img src="images/integration/addons/scene7/scene7-images-example.png" alt="Use your Scene7 images from the image picker in the Image Widget properties">\n    </section>\n    <section class="col-xs-4">\n        <h4>Connect your Adobe Scene7 Account</h4>\n        <p>Type or copy your company\'s Adobe Scene7 credentials into the fields below:</p>\n        ';
 if (!isManager) { ;
__p += '\n            <p class="error-message">You need to be a manager to set up this integration.</p>\n        ';
 } ;
__p += '\n        <ul class="list-unstyled">\n            <li class="form-group">\n                <label>Username</label>\n                <input type="text" name="scene7-username" placeholder="Enter Username" value="' +
__e( username ) +
'" ' +
__e( isManager ? "" : "disabled") +
' />\n            </li>\n            <li class="form-group">\n                <label>Password</label>\n                <input type="password" name="scene7-password" autocomplete="new-password" placeholder="Enter Password" ' +
__e( isManager ? "" : "disabled") +
' />\n            </li>\n            <li class="form-group">\n                <label>\n                    Company Name\n                    <p class="note">\n                        Only required if you have more than one account associated with this user\n                    </p>\n                </label>\n                <input type="text" name="companyName" placeholder="Enter Company Name" value="' +
__e( companyName ) +
'" ' +
__e( isManager ? "" : "disabled") +
' />\n            </li>\n            <li class="form-group">\n                <label>Region</label>\n                <select class="form-control" name="region" ' +
__e( isManager ? "" : "disabled") +
' >\n                    ';
 Scene7HostedRegionEnum.each(function(regionEnumOption) { ;
__p += '\n                        <option value="' +
__e( regionEnumOption.value ) +
'" ' +
__e( (regionEnumOption.value === region) ? "selected" : "" ) +
'>\n                            ' +
__e( regionEnumOption.name ) +
'\n                        </option>\n                    ';
 }) ;
__p += '\n                </select>\n            </li>\n        </ul>\n        <div class="save-button-tooltip-wrapper pull-right">\n            <button type="button" disabled="disabled" class="btn btn-primary save-adobe-scene7-credentials ladda-button" data-style="expand-right" data-spinner-size="28" disabled="disabled">\n                Save\n            </button>\n        </div>\n    </section>\n</section>\n';

}
return __p
}

/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/integration/addons/scene7/scene7-images-example.png";

/***/ }),
/* 3063 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="tabs tabs-internal">\n    <span class="tab active" data-tab-name="widget">Salesforce Commerce Cloud Product Widget</span>\n    <span class="tab " data-tab-name="quick-view-action" >Salesforce Commerce Cloud QuickView Action</span>\n    ';
 if (isScene7Enabled) { ;
__p += '\n        <span class="tab " data-tab-name="adobe-scene-7" >Adobe Scene7</span>\n    ';
 } ;
__p += '\n    ';
 if (isShopifyMenuEnabled) { ;
__p += '\n        <span class="tab " data-tab-name="shopify-store">Shopify</span>\n    ';
 } ;
__p += '\n</div>\n<div class="tab-pane active widget" data-tab-pane="widget"></div>\n<div class="tab-pane quick-view-action" data-tab-pane="quick-view-action"></div>\n';
 if (isScene7Enabled) { ;
__p += '\n    <div class="tab-pane adobe-scene-7" data-tab-pane="adobe-scene-7"></div>\n';
 } ;
__p += '\n';
 if (isShopifyMenuEnabled) { ;
__p += '\n    <div class="tab-pane shopify-store" data-tab-pane="shopify-store"></div>\n';
 } ;


}
return __p
}

/***/ }),
/* 3064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ShopifyStoreSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_ui_common_InputComponent__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_underscore__);




var LoggedInUserState = __webpack_require__(19), Configuration = __webpack_require__(27), Storage = __webpack_require__(34), SystemMessages = __webpack_require__(107);
function ShopifyStoreSettings() {
    var config = {
        username: "",
        password: "",
        storeUrl: "",
    }, styleClasses = {
        mainContainer: "row shopify-setting",
        inputField: "shopify-setting-input",
        submitBtn: "shopify-setting-button",
        inputError: "validation-error",
        icon: "icon",
        notVisibleIcon: "not-visible",
        visibleIcon: "visible"
    }, _a = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(config), settings = _a[0], setSettings = _a[1], _b = Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false), passwordVisible = _b[0], setPasswordVisible = _b[1], NOTIFICATION_MESSAGE = {
        INVALID_FORM: "Please fill out all the details.",
        PUT_REQUEST_FAILURE: "Failure occured while updating the details.",
        PUT_REQUEST_SUCCESS: "Successfully updated all the details.",
    }, delay = 2000;
    var creatorSettingApi = function () {
        var companyId = LoggedInUserState.attributes.company.id, endpointUrl = Configuration.creatorSettingApiBaseUrl + "/v1/settings/" + companyId, token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"), bearerToken = "Bearer " + token;
        return {
            endpointUrl: endpointUrl,
            bearerToken: bearerToken,
        };
    };
    var getShopifySettings = function () {
        var _a = creatorSettingApi(), endpointUrl = _a.endpointUrl, bearerToken = _a.bearerToken, options = {
            method: "GET",
            headers: {
                Authorization: bearerToken,
            },
        }, settingName = "connect";
        fetch(endpointUrl + "?name=" + settingName, options)
            .then(function (res) { return res.json(); })
            .then(function (data) {
            var connect = data.connect;
            if (connect) {
                var userSettings = connect.ipd.details[0];
                setSettings({
                    username: userSettings.username,
                    password: userSettings.password,
                    storeUrl: userSettings.url,
                });
                Storage.Local.update(Storage.Keys.CREATOR_CONNECT, connect);
            }
        })
            .catch(function (err) { return console.log(err); });
    };
    var updateShopifySetting = function () {
        var data = {
            settings: {
                onloadActionEnabled: true,
                connect: {
                    ipd: {
                        enabled: true,
                        details: [
                            {
                                password: settings.password,
                                type: "shopify",
                                url: settings.storeUrl,
                                username: settings.username,
                            },
                        ],
                    },
                    enabled: true,
                },
            },
        };
        var _a = creatorSettingApi(), endpointUrl = _a.endpointUrl, bearerToken = _a.bearerToken, options = {
            method: "PUT",
            headers: {
                Authorization: bearerToken,
            },
            contentType: "application/json; charset=utf-8",
            body: JSON.stringify(data),
        };
        fetch(endpointUrl, options)
            .then(function (res) { return res.json(); })
            .then(function (data) {
            if (data.Attributes) {
                SystemMessages.notify(NOTIFICATION_MESSAGE.PUT_REQUEST_SUCCESS, delay);
            }
            else {
                SystemMessages.notify(NOTIFICATION_MESSAGE.PUT_REQUEST_FAILURE, delay);
            }
        })
            .catch(function (err) {
            SystemMessages.notify(NOTIFICATION_MESSAGE.PUT_REQUEST_FAILURE, delay);
            console.log(err);
        });
    };
    Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function () {
        var connect = Storage.Local.get(Storage.Keys.CREATOR_CONNECT);
        if (Object(__WEBPACK_IMPORTED_MODULE_3_underscore__["isEmpty"])(connect)) {
            getShopifySettings();
        }
        else if (connect.ipd) {
            var userSettings = connect.ipd.details[0];
            setSettings({
                username: userSettings.username,
                password: userSettings.password,
                storeUrl: userSettings.url,
            });
        }
    }, []);
    var validateStoreUrl = function (url) {
        var isValidUrl;
        try {
            var transformedUrl = new URL(url);
            isValidUrl = transformedUrl.protocol === "https:" ? true : false;
        }
        catch (err) {
            isValidUrl = false;
            return isValidUrl;
        }
        return isValidUrl;
    };
    var toggleClass = function (isValid, targetElement) {
        var inputField = styleClasses.inputField, inputError = styleClasses.inputError;
        if (isValid) {
            targetElement.className = inputField;
        }
        else {
            targetElement.className = inputField + " " + inputError;
        }
    };
    var handleInputChange = function (e) {
        var _a;
        var _b = e.target, name = _b.name, value = _b.value;
        if (name === "storeUrl") {
            var isValidUrl = validateStoreUrl(value);
            toggleClass(isValidUrl, e.target);
        }
        else {
            var isValid = !Object(__WEBPACK_IMPORTED_MODULE_3_underscore__["isEmpty"])(value);
            toggleClass(isValid, e.target);
        }
        setSettings(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, settings, (_a = {}, _a[name] = value, _a)));
    };
    var isFormValid = function () {
        var username = settings.username, password = settings.password, storeUrl = settings.storeUrl;
        return (!Object(__WEBPACK_IMPORTED_MODULE_3_underscore__["isEmpty"])(username) && !Object(__WEBPACK_IMPORTED_MODULE_3_underscore__["isEmpty"])(password) && !Object(__WEBPACK_IMPORTED_MODULE_3_underscore__["isEmpty"])(storeUrl) && validateStoreUrl(storeUrl));
    };
    var handleSubmit = function (e) {
        e.preventDefault();
        if (isFormValid()) {
            updateShopifySetting();
        }
        else {
            SystemMessages.notify(NOTIFICATION_MESSAGE.INVALID_FORM, delay);
        }
    };
    return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", { className: styleClasses.mainContainer },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", { className: "col-xs-6" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4", null, "Shopify"),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", { className: "intro" }, "With Shopify Connect module, you can compose intelligent Creator widgets built from the product and pricing details in your Shopify backend."),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p", null,
                "To learn more about adding Shopify-powered Behaviors to your Creator experiences, contact ",
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", { href: "mailto:<%- config.salesEmail %>" }, "sales.zmags.com"))),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section", { className: "col-xs-6" },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_ui_common_InputComponent__["a" /* default */], { classNames: styleClasses.inputField, name: "username", label: "Username", type: "text", value: settings.username, onChange: handleInputChange, key: "username" }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_ui_common_InputComponent__["a" /* default */], { classNames: styleClasses.inputField, name: "password", label: "Password", type: passwordVisible ? "text" : "password", value: settings.password, onChange: handleInputChange, key: "password" }),
            settings.password.length > 0 && (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { className: styleClasses.icon + " " + (passwordVisible ? styleClasses.visibleIcon : styleClasses.notVisibleIcon), onClick: function () { return setPasswordVisible(!passwordVisible); } })),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__shared_ui_common_InputComponent__["a" /* default */], { classNames: styleClasses.inputField, name: "storeUrl", label: "Store URL", type: "text", placeholder: "https://", value: settings.storeUrl, onChange: handleInputChange, key: "storeUrl" }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", { className: styleClasses.submitBtn },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button", { onClick: handleSubmit }, "Submit")))));
}


/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CustomJsAction = __webpack_require__(190),
        CustomJsCollectionView = __webpack_require__(3066),
        EditCustomJsView = __webpack_require__(3071),
        ImprovedView = __webpack_require__(6),
        Lightbox = __webpack_require__(101),
        LoggedInUserState = __webpack_require__(19),
        PrototypeAction = __webpack_require__(1189),
        Permissions = __webpack_require__(22),
        template = __webpack_require__(3074);

    /**
     * This view is responsible for handling modifications to the prototypeActionCollection, so the
     * sub-views EditCustomJsView and CustomJsItemView trigger events on this class, when modifying
     * the collection.
     */
    return ImprovedView.extend("CustomJsView", {

        _customJsCollectionView: null,

        _editCustomJsView: null,

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                cannotCreateNew: Permissions.Roles.MANAGER.cannot()
            };
        },

        className: "custom-js-view",

        ui: {
            newCustomJsButton: ".new-custom-js"
        },

        regions: {
            customJsList: ".custom-js-list"
        },

        events: {
            "click @ui.newCustomJsButton": "_newCustomJsClickHandler"
        },

        onShow: function onShow() {
            this._customJsCollectionView = new CustomJsCollectionView({ collection: this._getCustomJsActions() });
            this.listenTo(this._customJsCollectionView, "edit", this._showEditPopup);
            this.listenTo(this._customJsCollectionView, "refresh", this._refreshCustomJsList);
            this.customJsList.show(this._customJsCollectionView);
        },

        /**
         * @returns {PrototypeActionCollection}
         */
        _getCustomJsActions: function _getCustomJsActions() {
            return LoggedInUserState.get("prototypeActionCollection").filterByType(CustomJsAction.TYPE);
        },

        _newCustomJsClickHandler: function _newCustomJsClickHandler() {
            var emptyJsAction = new PrototypeAction();
            emptyJsAction.set("action", new CustomJsAction());
            emptyJsAction.set("companyId", LoggedInUserState.get("company").get("id"));

            this._showEditPopup(emptyJsAction);
        },

        /**
         * Refreshes the actions list based on what's currently stored in Mongo.
         */
        _refreshCustomJsList: function _refreshCustomJsList() {
            var _this = this;

            return LoggedInUserState.get("prototypeActionCollection").fetch().done(function () {
                _this._customJsCollectionView.collection.reset(_this._getCustomJsActions().models);
            });
        },

        /**
         * Opens a lightbox with a custom js in it, to edit. If it is called
         * without a model, it will create a new one.
         *
         * @param {PrototypeAction<CustomJsAction>} [customJsPrototypeAction] - The model we wish to edit.
         */
        _showEditPopup: function _showEditPopup(customJsPrototypeAction) {
            this._editCustomJsView = new EditCustomJsView({
                model: customJsPrototypeAction
            });

            // Need to update the list because a newly saved action gets actionId assigned by the
            // server on first save.
            this.listenTo(this._editCustomJsView, "saved", this._refreshCustomJsList);

            var lightboxOptions = {
                css: {
                    width: 800
                },
                editorEventProperties: {
                    modalType: "AddCustomJS",
                    triggerOrigin: "AddCustomJSModal"
                }
            };

            var lightbox = new Lightbox(this._editCustomJsView, lightboxOptions, this);
            lightbox.open();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* global confirm */
!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CustomJsItemView = __webpack_require__(3067),
        LoggedInUserState = __webpack_require__(19),
        Marionette = __webpack_require__(10);

    return Marionette.CollectionView.extend("CustomJsCollectionView", {

        tagName: "ul",

        className: "custom-js-collection",

        itemView: CustomJsItemView,

        // Catch "edit" events triggered in CustomJsItemView.
        onItemviewEdit: function onItemviewEdit(customJsPrototypeAction) {
            this.trigger("edit", customJsPrototypeAction.model);
        },

        // Catch "edit" events triggered in CustomJsItemView.
        onItemviewDelete: function onItemviewDelete(customJsPrototypeAction) {
            // Double check that we do not try and delete an action that is in use.
            if (customJsPrototypeAction.model.get("actionIsInUse")) {
                return;
            }

            if (!confirm("Are you sure you want to delete " + customJsPrototypeAction.model.get("action").get("name") + "?")) {
                return;
            }

            var self = this;
            customJsPrototypeAction.model.destroy().fail(function () {
                // If the save failed, insert the action back into the collection.
                LoggedInUserState.get("prototypeActionCollection").add(customJsPrototypeAction.model);
                self.trigger("refresh");
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        CustomJsLockIconView = __webpack_require__(1242),
        EditorEvents = __webpack_require__(17),
        ImprovedView = __webpack_require__(6),
        Permissions = __webpack_require__(22),
        template = __webpack_require__(3070),
        Tooltip = __webpack_require__(35);

    return ImprovedView.extend("CustomJsItemView", {

        template: template,

        tagName: "li",

        className: "custom-js-item",

        templateHelpers: function templateHelpers() {
            return {
                readOnly: this._readOnly
            };
        },

        _readOnly: null,

        ui: {
            title: ".title",
            wrapper: ".item-wrapper",
            remove: ".delete-icon"
        },

        regions: {
            lockRegion: ".lock-region"
        },

        events: {
            "click @ui.wrapper": "_wrapperClickHandler",
            "click @ui.remove": "_delete"
        },

        bindings: {
            ".title": "action.name"
        },

        initialize: function initialize() {
            this._readOnly = this.model.get("actionIsInUse") || Permissions.Roles.MANAGER.cannot();
        },

        onShow: function onShow() {
            var tooltipContent = null;

            if (Permissions.Roles.MANAGER.cannot()) {
                tooltipContent = "You do not have permission to delete this custom action.";
            } else if (this.model.get("actionIsInUse")) {
                // Show lock icon
                this.lockRegion.show(new CustomJsLockIconView({
                    ids: this.model.get("action").get("usedBy")
                }));

                tooltipContent = "This action cannot be deleted because it is in use.";
            }

            if (tooltipContent !== null) {
                Tooltip.add(this.ui.remove, {
                    content: tooltipContent,
                    placement: "top",
                    width: 200
                });
            }
        },

        _delete: function _delete() {
            if (!this._readOnly) {
                this.trigger("delete");

                var action = self.model.get("action"),
                    parameters = _.keys(action.get("parameters")).join(),
                    eventProperties = {
                    category: "Commerce",
                    actionName: action.get("name"),
                    actionParameters: parameters,
                    integrationType: "CustomJS",
                    triggerOrigin: "DeleteCustomJSButton"
                };

                EditorEvents.trigger(EditorEvents.constants.DELETE_INTEGRATION, eventProperties);
            }
        },

        _wrapperClickHandler: function _wrapperClickHandler(event) {
            // Only trigger the edit if the container or the title was clicked, and thus not if the
            // lock or the delete icon was clicked.
            if (event.target === this.ui.wrapper[0] || event.target === this.ui.title[0]) {
                this.trigger("edit");
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3068 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="custom-js-lock-list-container">\n    <h6>Action locked (not editable, nor deletable) due to use in the following Experiences:</h6>\n    <ul>\n        ';
 _.each(experiences, function (experience) { ;
__p += '\n            <li><a href="/#experience/' +
__e( experience.get('id') ) +
'/edit">' +
__e( experience.getDisplayName() ) +
'</a></li>\n        ';
 }); ;
__p += '\n    </ul>\n</div>\n';

}
return __p
}

/***/ }),
/* 3069 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<span class="lock-icon"></span>\n';

}
return __p
}

/***/ }),
/* 3070 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="item-wrapper">\n    <span class="title';
 if (action.usedBy.length) { ;
__p += ' read-only';
 } ;
__p += '"></span>\n\n    <span class="delete-icon';
 if (readOnly) { ;
__p += ' disabled';
};
__p += '"></span>\n\n    ';
 if (action.usedBy.length) { ;
__p += '\n        <span class="lock-region"></span>\n    ';
 } ;
__p += '\n</div>';

}
return __p
}

/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        _require = __webpack_require__(1),
        isEmpty = _require.isEmpty,
        isString = _require.isString,
        keys = _require.keys,
        each = _require.each,
        CustomJsAction = __webpack_require__(190),
        CustomJsLockIconView = __webpack_require__(1242),
        EditBehavior = __webpack_require__(106),
        EditorEvents = __webpack_require__(17),
        helpers = __webpack_require__(3072),
        ImprovedView = __webpack_require__(6),
        LoggedInUserState = __webpack_require__(19),
        Permissions = __webpack_require__(22),
        SequentialButton = __webpack_require__(112),
        _require2 = __webpack_require__(30),
        isBlank = _require2.isBlank,
        template = __webpack_require__(3073),
        ValidateBehavior = __webpack_require__(96);


    var CODE_WONT_RUN_MSG = "The code is malformed",
        CODE_TITLE_HASNT_CHANGED = "Neither the code nor title has changed";

    return ImprovedView.extend("EditCustomJsView", {

        /**
         * @private @type {Boolean}
         * Is the code editable by this user
         */
        _readOnly: null,

        /**
         * @private {SequentialButton}
         * The sequential button representing the "Save" button in the ui.
         */
        _saveButton: null,

        /**
         * @private {Promise}
         * A deferred pending while a save is in progress.
         */
        _saveDeferred: null,

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                readOnly: this._readOnly,
                code: this.model.get("action").get("code")
            };
        },

        className: "new-js-lightbox",

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,

                container: ".title-container",

                editFields: [{
                    input: ".title",
                    tooltip: false // because size calculation is wrong/off, so tooltip always enabled otherwise! :/
                }]
            },

            validateBehavior: {
                behaviorClass: ValidateBehavior,

                buttonSubmit: function buttonSubmit(enable) {
                    if (this._saveButton) {
                        this._saveButton.enable(enable); // SequentialButton not created until render time!
                    }
                },

                inputValidation: {
                    ".title": {
                        validator: function validator(title) {
                            // Because of stick it, I think, this sometimes gives the jquery element, not the text
                            // value, when it is empty. So, only valid if a non-empty string...
                            return isString(title) && !isBlank(title);
                        },

                        errorText: "Title required",

                        tooltip: false
                    },
                    ".textarea": { // code!
                        validator: function validator(code) {
                            // isString check included for the same reason as above.
                            return isString(code) && !isBlank(code) && !this.model.get("actionIsInUse") && !CustomJsAction.checkRunnableCode(code, helpers.findParameters(code));
                        },

                        errorText: CODE_WONT_RUN_MSG, // for log

                        tooltip: false
                    },
                    ".textarea, .title": {
                        validator: function validator() {
                            var newName = this.ui.title.html(),
                                newCode = this.ui.textarea.val(),
                                oldName = this.model.get("name"),
                                oldCode = this.model.get("code");

                            // We return true if something has changed.
                            return newName !== oldName || newCode !== oldCode;
                        },

                        errorText: CODE_TITLE_HASNT_CHANGED,

                        tooltip: false
                    }
                }
            }
        },

        ui: {
            title: ".title",
            plus: ".plus-icon",
            textarea: ".textarea",
            codeErrorMessage: ".code-error-message",
            parameterList: ".parameter-list",
            saveButton: ".save-new-custom-js",
            cancelButton: ".cancel-new-custom-js"
        },

        regions: {
            lockRegion: ".lock-region"
        },

        events: {
            "mouseup @ui.textarea": "_handleSelectionStart",
            "keyup @ui.textarea": "_textareaChangeHandler",
            "click @ui.plus": "_handlePlusClick",
            "click @ui.saveButton": "_saveAction",
            "click @ui.cancelButton": "closeView"
        },

        initialize: function initialize() {
            this._readOnly = this.model.get("actionIsInUse") || Permissions.Roles.MANAGER.cannot();

            // The EditBehavior uses this.options.isEditable to determine if the title is editable.
            this.options.isEditable = !this._readOnly;
        },

        onRender: function onRender() {
            if (!this._readOnly) {
                this._saveButton = SequentialButton.add(this.ui.saveButton, this._save.bind(this), true, true);
            }
        },

        onShow: function onShow() {
            this._updateErrorAndParameters();

            if (this.model.get("actionIsInUse")) {
                this.lockRegion.show(new CustomJsLockIconView({
                    ids: this.model.get("action").get("usedBy")
                }));
            }
        },

        _textareaChangeHandler: function _textareaChangeHandler(event) {
            this._handleSelectionStart(event);
            this._updateErrorAndParameters();
        },

        _saveAction: function _saveAction() {
            this.ui.cancelButton.addClass("disabled").prop("disabled", true);
            // Activate the action associated with the button, i.e. this._save()).
            this._saveButton();
        },

        _save: function _save() {
            // Double check that the action isn't used by experiences, contains invalid code, or if
            // there is no code. This should not happen since the save button should be disabled in
            // these cases.
            if (!this.inputValidation()) {
                return SequentialButton.REJECT;
            }

            var code = this.ui.textarea.val();

            this.model.get("action").set({
                name: this.ui.title.text(),
                code: code,
                parameters: helpers.findParameters(code)
            });

            var self = this;
            return this.model.save().done(function () {
                LoggedInUserState.get("prototypeActionCollection").unshift(self.model);
                self.trigger("saved");
                self.closeView();

                var action = self.model.get("action"),
                    parameters = keys(action.get("parameters")).join(),
                    eventProperties = {
                    category: "Commerce",
                    actionName: action.get("name"),
                    actionParameters: parameters,
                    integrationType: "CustomJS",
                    triggerOrigin: "SaveCustomJSButton"
                };

                EditorEvents.trigger(EditorEvents.constants.SAVE_INTEGRATION, eventProperties);
            }).fail(function () {
                if (self.model.get("id")) {
                    // If the save failed and the action has an ID we revert to the previous
                    // version since that will match the version stored in the database.
                    self.model.set(self.model.previousAttributes());
                }

                self.ui.cancelButton.removeClass("disabled").prop("disabled", false);
            });
        },

        _updateErrorAndParameters: function _updateErrorAndParameters() {
            var code = this._readOnly ? this.ui.textarea.text() : this.ui.textarea.val(),
                parameters = helpers.findParameters(code),
                error = CustomJsAction.checkRunnableCode(code, parameters),
                errorText = error ? CODE_WONT_RUN_MSG + ": " + error : "",
                // &nbsp; to ensure multiple spaces are respected
            $parameters = [];

            if (!isEmpty(parameters)) {
                each(parameters, function (value, name) {
                    // "checkParameter" returns a possible error, otherwise null on no error...
                    if (!CustomJsAction.checkParameter(name)) {
                        // no value here, only parameter name to validate
                        $parameters.push($("<li>", { text: name }));
                    }
                });
            }

            if (!$parameters.length) {
                $parameters.push($("<li>", {
                    text: "(No parameters)",
                    "class": "no-parameters"
                }));
            }

            this.ui.codeErrorMessage.text(errorText);
            this.ui.parameterList.html($parameters);
        },

        _handleSelectionStart: function _handleSelectionStart(event) {
            var x = event.clientX,
                // clientX and -Y are undefined if it's keyboard event.
            y = event.clientY,
                textarea = this.ui.textarea[0],
                selection = textarea.selectionEnd > textarea.selectionStart;

            this._togglePlus(selection, x, y);
        },

        _togglePlus: function _togglePlus(selection, x, y) {
            var containerRect,
                textareaRect,
                plusRect,
                css,
                margin = 5;

            if (this._readOnly) {
                return;
            }

            this.ui.plus.toggle(selection);

            if (selection) {
                containerRect = this.el.getBoundingClientRect();
                textareaRect = this.ui.textarea[0].getBoundingClientRect();
                plusRect = this.ui.plus[0].getBoundingClientRect();

                if (x && y) {
                    // Mouseup event
                    css = {
                        left: x - containerRect.left,
                        top: y - containerRect.top
                    };
                } else {
                    // Keyup event
                    css = {
                        left: textareaRect.right - containerRect.left - plusRect.width - margin,
                        top: textareaRect.top - containerRect.top + margin
                    };
                }

                this.ui.plus.css(css);
            }
        },

        _handlePlusClick: function _handlePlusClick() {
            var newCode = helpers.addParametersToSelection(this.ui.textarea);

            // Sanity check
            if (this._readOnly) {
                return;
            }

            this.ui.plus.hide();
            this.ui.textarea.val(newCode).trigger("keyup");
            this._updateErrorAndParameters();
        },

        closeView: function closeView() {
            this.trigger("close");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        GeneralFunctions = __webpack_require__(193),
        ParametersHelper = __webpack_require__(298);

    var FIND_PARAMETERS_REGEX = new RegExp(ParametersHelper.PARAMETER_BEGIN + "(.*?)" + ParametersHelper.PARAMETER_END, "g");

    function removeSigns(text) {
        return text.slice(ParametersHelper.PARAMETER_BEGIN.length, -ParametersHelper.PARAMETER_END.length);
    }

    return {
        PARAMETER_CLASSNAME: "custom-js-parameter",
        FIND_PARAMETERS_REGEX: FIND_PARAMETERS_REGEX,

        /**
         * Takes a string, finds the parameters (as defined above with the
         * regex), and return them as an object with the parameters as keys,
         * and empty strings as their value.
         *
         * @param {String} text     - The string we are searching for parameters in.
         * @return {Object}         - Object with parameters as keys.
         */
        findParameters: function findParameters(text) {
            var parameters = _.chain(text.match(FIND_PARAMETERS_REGEX)).map(removeSigns).unique().value();

            return GeneralFunctions.arraysToObj(parameters, "");
        },

        /**
         * Takes the $textarea and surrounds the current selection (if any)
         * with our parameter signs, to turn the selection into a parameter.
         */
        addParametersToSelection: function addParametersToSelection($textarea) {
            var textarea = $textarea[0],
                begin,
                selection,
                end;

            if (_.isUndefined(textarea.selectionStart)) {
                return textarea.value;
            }

            begin = textarea.value.substr(0, textarea.selectionStart);
            selection = textarea.value.substr(textarea.selectionStart, textarea.selectionEnd - textarea.selectionStart);
            end = textarea.value.substr(textarea.selectionEnd);

            return begin + ParametersHelper.PARAMETER_BEGIN + selection + ParametersHelper.PARAMETER_END + end;
        }

    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3073 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="title-container">\n    <div class="title editable" contenteditable="' +
__e( !readOnly ) +
'">' +
__e( action.name ) +
'</div>\n    <span class="lock-region"></span>\n</div>\n\n';
 if (readOnly) { ;
__p += '\n    <div class="textarea disabled">' +
__e( code ) +
'</div>\n';
 } else { ;
__p += '\n    <div class="info">\n        Add parameters by selecting parts of the code, then click the plus icon; or manually like <tt class="nowrap">#{Parameter name}</tt>.\n    </div>\n    <textarea class="textarea" placeholder="Paste your JavaScript code here..." autofocus>' +
__e( code ) +
'</textarea>\n';
 } ;
__p += '\n\n<h3>Parameters:</h3>\n<ul class="parameter-list">\n    ';
 _.each(action.parameters, function (parameter) { ;
__p += '\n        <li>' +
__e( parameter ) +
'</li>\n    ';
 }); ;
__p += '\n</ul>\n\n<div class="code-error-message"></div>\n\n<div class="actions">\n    <button class="btn btn-grey save-new-custom-js pull-right ladda-button';
 if (readOnly) { ;
__p += ' disabled';
 } ;
__p += '" data-spinner-size="28" data-style="expand-right" ';
 if (readOnly) { ;
__p += 'disabled';
 } ;
__p += '>Save</button>\n    <button class="btn btn-secondary pull-right cancel-new-custom-js">Cancel</button>\n</div>\n\n<span class="plus-icon">+</span>\n';

}
return __p
}

/***/ }),
/* 3074 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="row">\n    <div class="col-xs-4">\n        <p class="intro">With Creator\'s Custom JavaScript Action, you can create your own JavaScript Actions for your Creator Experiences.</p>\n        <p>This will allow you to create advanced JavaScript Actions with support for runtime parameters to integrate directly with your site, for example calling a JavaScript method to open a QuickView, adding even more dynamic behavior and interactive features for your Creator Experiences.</p>\n        <p>By naming the Action, you will easily be able to find it in the Action Menu inside the Editor when you\n        are assigning actions to Widgets. </p>\n\n        ';
 if (cannotCreateNew) { ;
__p += '\n        <p>You must be a <a href="#manageAccount">Manager</a> to create, modify, or delete Actions. </p>\n        ';
 } ;
__p += '\n\n        <div class="notification-box">\n            <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">JavaScript Actions In Use Cannot Be Changed</span>\n            <p>A JavaScript Action used in Experiences is not editable, nor deletable. You will have to remove the Action from the Experiences in question, or delete the Experiences, to be able to further edit the Action. Click the <img src="images/integration/customjavascript/lock.png"> to see which Experiences use the Action.</p>\n        </div>\n    </div>\n\n    <div class="col-xs-8">\n        <h4>Your JavaScript Actions</h4>\n\n        <div class="custom-js-add-container">\n            <button class="pull-right btn btn-secondary new-custom-js';
 if (cannotCreateNew) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (cannotCreateNew) { ;
__p += ' disabled';
 } ;
__p += '>&#43; Create New Action</button>\n            ';
 if (!cannotCreateNew) { ;
__p += '\n                <p>Click "Create New Action" and follow the steps to create a new Custom JavaScript Action.</p>\n            ';
 } ;
__p += '\n        </div>\n\n        <div class="custom-js-list"></div>\n\n        <div class="custom-js-setup-illustration"></div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 3075 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Set Up Integrations</h1>\n    </header>\n\n    <div class="tabs tabs-integrations">\n        <span class="tab active" data-tab-name="add-ons">Add-ons</span>\n        <span class="tab" data-tab-name="custom-actions">Custom JavaScript Actions</span>\n    </div>\n\n    <div class="tab-pane add-ons active" data-tab-pane="add-ons"></div>\n\n    <div class="tab-pane custom-actions" data-tab-pane="custom-actions"></div>\n</div>\n\n<footer class="default-footer"></footer>\n';

}
return __p
}

/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ExperienceMetadata = __webpack_require__(3077),
        GroupMetadata = __webpack_require__(3078),
        LoggedIn = __webpack_require__(31),
        ExperienceCollection = __webpack_require__(3079),
        UrlUtil = __webpack_require__(46),
        RestApi = __webpack_require__(29);

    /**
     * A collection of experience meta data.
     *
     * @class ExperienceMetadataCollection
     * @constructor
     *
     * @cfg {boolean} pushedOnly If true, only pushed experiences will be fetched from the server.
     * @cfg {boolean} includeMeasureData Whether to inculde the experience measure data or not.
     */
    var ExperienceMetadataCollection = Backbone.Collection.extend({

        model: function model(attributes) {
            if (attributes.type && attributes.type === "ExperienceMetadata") {
                return new ExperienceMetadata(attributes);
            }

            return new GroupMetadata(attributes);
        },

        options: null,

        initialize: function initialize(attributes, options) {
            this.options = options;
        },

        url: function url() {
            var baseURL = RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, LoggedIn.companyId(), RestApi.Collections.EXPERIENCES_META);

            // Append options if any
            return this.options ? UrlUtil.appendParamObject(baseURL, this.options) : baseURL;
        },

        experiences: function experiences() {
            var filteredExperienceData = this.filter(function (model) {
                return model instanceof ExperienceMetadata;
            });

            return new ExperienceCollection(filteredExperienceData.map(function (metadata) {
                return metadata.get("model"); // already tagged as meta data by the API!
            }));
        },

        fromExperience: function fromExperience(experienceModel) {
            return this.find(function (metadata) {
                // Might be a clone? :(
                var experience = metadata.get("model");

                return experience && experience.get("id") === experienceModel.get("id");
            });
        }

    }, {

        experiences: function experiences(options) {
            return new ExperienceMetadataCollection([], options).fetch().then(function (collection) {
                return collection.experiences();
            });
        }

    });

    return ExperienceMetadataCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ImprovedModel = __webpack_require__(25),
        Syncer = __webpack_require__(50),
        ExperienceModel = __webpack_require__(58);

    /**
     * The experience meta data.
     *
     * @class ExperienceMetadata
     * @constructor
     */
    return ImprovedModel.extend("Experience Metadata", { // Still uses the experience distinguished name!

        defaults: {
            model: null,
            type: null
        },

        relations: [{
            type: Backbone.One,
            key: "model",
            relatedModel: ExperienceModel
        }],

        constructor: function constructor() {
            this.__super();
            Syncer.State.state(this).immutable = true;
        },

        _distinguishedName: function _distinguishedName() {
            var experience = this.get("model");
            return experience && experience._distinguishedName();
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25),
        Syncer = __webpack_require__(50);

    /**
     * The group meta data.
     *
     * @class GroupMetadata
     * @constructor
     * @author Antonio Lagrotteria
     */
    return ImprovedModel.extend("Group Metadata", {

        defaults: {
            type: null
        },

        relations: [],

        constructor: function constructor() {
            this.__super();
            Syncer.State.state(this).immutable = true;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7),
        ExperienceModel = __webpack_require__(58),
        PublishableState = __webpack_require__(65),
        LoggedIn = __webpack_require__(31),
        RestApi = __webpack_require__(29);

    /**
     * A collection of experiences.
     *
     * @class ExperienceCollection
     * @constructor
     *
     */
    var ExperienceCollection = Backbone.Collection.extend({

        model: ExperienceModel,

        url: function url() {
            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, LoggedIn.companyId(), RestApi.Collections.EXPERIENCES);
        },

        comparator: function comparator(experienceModel) {
            return -experienceModel.getEditedAt();
        },

        /**
         * Returns a new <tt>Backbone.Collection</tt> (not a <tt>ExperienceCollection</tt>), that contains
         * all <i>non-empty</i> experiences from *this* experience collection.
         *
         * @return {Backbone.Collection} A collection that contains all <i>non-empty</i> experiences
         * from *this* experience collection.
         */
        filterNonEmptyExperiences: function filterNonEmptyExperiences() {
            return new ExperienceCollection(this.filter(function (experience) {
                return !experience.isEmpty();
            }));
        },

        /**
         * Counts the experiences that are not variants of other experiences and are not empty.
         *
         * @returns {Number} Amount of not empty master experiences
         */
        noneEmptyExperienceCount: function noneEmptyExperienceCount() {
            return this.filterNonEmptyExperiences().length;
        },

        /**
         * Filter out the experiences that are not pushed.
         *
         * @returns {ExperienceCollection} a collection of filtered experiences.
         */
        filterPushedExperiences: function filterPushedExperiences() {
            // FIXME: We tend to see weird behavior when referencing the same models from multiple collections
            return new ExperienceCollection(this.filter(function (experience) {
                return experience.hasAtLeastState(PublishableState.PUSHED);
            }));
        },

        /**
         * Helper function that runs through every experience model and returns
         * true if all of them are empty (or if there are no experiences).
         *
         * @return {Boolean}
         */
        allExperiencesAreEmpty: function allExperiencesAreEmpty() {
            return this.every(function (experience) {
                return experience.isEmpty();
            });
        }
    });

    return ExperienceCollection;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var DashboardContentCollectionView = __webpack_require__(703);
    var ProjectDashboardContentItemView = __webpack_require__(3081);
    var $ = __webpack_require__(4);

    /**
     *
     * @class ProjectDashboardContentCollectionView
     */
    return DashboardContentCollectionView.extend({

        itemView: ProjectDashboardContentItemView,

        itemViewOptions: function itemViewOptions() {
            return {
                projectContext: this.options.projectContext
            };
        },

        itemEvents: {
            "detach": function detach(model) {
                this.collection.remove(model);
            }
        },

        /**
         * Returns the options passed to the "Create new experience" item view. In the case
         * of a project, we want to change the wording.
         *
         * @return {*} The options:
         *             @cfg label The text to display.
         *             @cfg onClick The event to fire when clicked.
         */
        createLabelOptions: function createLabelOptions() {
            var _this = this;

            return {
                label: "Create<br>New Experience<br>In Project<br>&#43;",
                onClick: function onClick() {
                    return Backbone.history.navigate("experience/create/project/" + _this.options.projectContext.project.id, { trigger: true });
                }
            };
        },

        onRender: function onRender() {
            var _this2 = this;

            var $attachButton = $("<button class='attach-button btn btn-grey pull-right'>Attach</button>");

            // Disable attach button if insufficient privileges...
            if (this.options.spectatorMode) {
                $attachButton.addClass("disabled").attr("disabled", true);
            } else {
                $attachButton.click(function () {
                    _this2.viewScope.openAttachLightbox();
                });
            }

            this.$el.prepend($attachButton);
        },

        /**
         * Invoked when any assets has been attached to the current project.
         *
         * Refreshes the current collection view to include the newly attached assets.
         */
        onAttachAsset: function onAttachAsset() {
            this.refresh();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ProjectContentItemView = __webpack_require__(1243);
    var Tooltip = __webpack_require__(35);
    var Promise = __webpack_require__(21);
    var _ = __webpack_require__(1);

    return ProjectContentItemView.extend({
        ui: function ui() {
            return _.defaults({
                detach: ".detach"
            }, ProjectContentItemView.prototype.ui);
        },
        events: function events() {
            return _.defaults({
                "click @ui.detach": "_detachClickHandler"
            }, ProjectContentItemView.prototype.events);
        },
        onRender: function onRender() {
            this.__super();

            Tooltip.add(this.ui.detach, {
                placement: "top",
                width: !this._spectatorMode ? 135 : 180
            });
        },
        _detachClickHandler: function _detachClickHandler() {
            var _this = this;

            Tooltip.remove(this.ui.detach);
            // Spectators don't have permissions to detach experiences.
            if (this._spectatorMode) {
                // TODO MOS-2643: Investigate if it's okay to use native promises here.
                return Promise.rejected();
            }

            var projectContext = this.options.projectContext;

            return projectContext.detach(this.model).then(function () {
                _this.trigger("detach", _this.model);
                _this.trigger("close");
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3082 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="experience-thumb-wrapper">\n\n    ';
 if (showExperienceActionsPanel) { ;
__p += '\n        <div class="actions-panel">\n            ';
 if (canDelete) { ;
__p += '\n                <span class="delete pull-right" data-content="Delete ' +
__e( itemLabel ) +
' forever"></span>\n                <span class="spinner loading-spinner pull-right hidden" data-spinner-color="#000" data-spinner-size="20">\n                    <span class="ladda-label"></span>\n                </span>\n            ';
 } else if (spectatorMode) { ;
__p += '\n                <span class="delete pull-right disabled" data-content="You do not have permission to delete ' +
__e( itemLabel ) +
's"></span>\n            ';
 } else { ;
__p += '\n                <span class="delete pull-right disabled" data-content="You do not have permission to delete pushed ' +
__e( itemLabel ) +
's"></span>\n            ';
 } ;
__p += '\n            ';
 if (spectatorMode) { ;
__p += '\n                <span class="detach pull-right disabled" data-content="You do not have permission to detach ' +
__e( itemLabel ) +
's"></span>\n                <span class="duplicate pull-right disabled" data-content="You do not have permission to duplicate ' +
__e( itemLabel ) +
's"></span>\n            ';
 } else { ;
__p += '\n                <span class="detach pull-right" data-content="Detach ' +
__e( itemLabel ) +
'"></span>\n                <span class="duplicate pull-right" data-content="Duplicate ' +
__e( itemLabel ) +
'"></span>\n            ';
 } ;
__p += '\n        </div>\n    ';
 } ;
__p += '\n\n    ';
 if (group) { ;
__p += '\n        <div class="group-thumb-container">\n            <div class="variant-thumbs-wrapper">\n                ';
 _.each(thumbs, function (thumb) { ;
__p += '\n                    <div class="variant-outline" style="width:' +
__e( thumb.width ) +
'px; height:' +
__e( thumb.height ) +
'px; left:' +
__e( thumb.x ) +
'px;"></div>\n                ';
 }); ;
__p += '\n                <div class="experience-thumb-container"></div>\n            </div>\n        </div>\n    ';
 } else { ;
__p += '\n        <div class="experience-thumb-container"></div>\n    ';
 } ;
__p += '\n\n    <div class="experience-meta-data">\n        <div class="title-wrapper">\n            <span class="title-container" data-content="' +
__e( name ) +
'">\n                <span class="title">' +
__e( name ) +
'</span>\n            </span>\n            ';
 if (group) { ;
__p += '\n                <span class="group-count">(' +
__e( entries.length ) +
')</span>\n            ';
 } ;
__p += '\n            ';
 if (hasComments) { ;
__p += '\n                <span class="comments-indicator"></span>\n            ';
 } ;
__p += '\n        </div>\n\n        ';
 if (group) { ;
__p += '\n            <ul class="group-variants ' +
__e(groupType ) +
'">\n                ';
 _.each(entries, function (entry, index) {
                    var identifier = entry[1] ? entry[1].getIdentifier() : "";
                ;
__p += '\n                    ';
 if (index < 8) { ;
__p += '\n                        <li class="variant-icon ' +
__e(identifier ) +
' small">#' +
__e( index + 1 ) +
'</li>\n                    ';
 } else if (index === 8) { ;
__p += '\n                        <li class="ellipsis">&#133;</li>\n                    ';
 } ;
__p += '\n                ';
 }); ;
__p += '\n            </ul>\n        ';
 } else { ;
__p += '\n            <div class="state">Status: ' +
__e( readableState ) +
'</div>\n        ';
 } ;
__p += '\n    </div>\n</div>\n\n';
 if (showSelectIndicator) { ;
__p += '\n    <div class="select-indicator in-project"></div>\n    <div class="select-indicator selected"></div>\n    <div class="select-indicator in-other-project" data-content="This ' +
__e(itemLabel) +
' belongs to another Project and will be detached from there if attached to this Project."></div>\n    <div class="select-indicator in-other-project-selected" data-content="This ' +
__e(itemLabel) +
' will be detached from another Project and attached to this Project."></div>\n';
 } ;
__p += '\n';

}
return __p
}

/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ProjectDashboardImageLibrary = __webpack_require__(3084);
    var $ = __webpack_require__(4);
    var DashboardImageLibraryView = __webpack_require__(1200);
    /**
     *
     *
     * @class ProjectDashboardImageLibraryView
     */
    return DashboardImageLibraryView.extend({

        className: "project-" + DashboardImageLibraryView.prototype.className, // "project-dashboard-image-view",

        imageLibraryClass: ProjectDashboardImageLibrary,

        initialize: function initialize() {
            var self = this;

            this.collectionViewOptions = {
                itemEvents: {
                    detach: function detach(model) {
                        self.collection.remove(model);
                    }
                }
            };

            this.__super();
        },
        itemViewOptions: function itemViewOptions() {
            return {
                project: this.options.project,
                showImageActionsPanel: true
            };
        },
        onShow: function onShow() {
            var _this = this;

            this.__super();

            var $attachButton = $("<button class='attach-button btn btn-grey pull-right'>Attach</button>");

            // Disable attach button if insufficient privileges...
            if (this.options.spectatorMode) {
                $attachButton.addClass("disabled").attr("disabled", true);
            } else {
                $attachButton.click(function () {
                    _this.viewScope.openAttachLightbox({
                        imageLibrarySorting: _this.options.imageLibrarySorting
                    });
                });
            }

            this.imageLibraryRegion.$el.prepend($attachButton);
        },


        /**
         * Invoked when any assets has been attached to the current project.
         *
         * Refreshes the current collection view to include the newly attached assets.
         */
        onAttachAsset: function onAttachAsset() {
            this._imageLibraryView.refresh();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var DropAreaHotspot = __webpack_require__(398);
    var DetailedImageLibraryCollectionView = __webpack_require__(1202);
    var ProjectDashboardImageView = __webpack_require__(3085);

    /**
     * Subclass of <tt>DetailedImageLibraryCollectionView</tt> representing the Image Dashboard in a project context. <p>
     *
     * @class ProjectDashboardImageLibrary
     * @see DetailedImageLibraryCollectionView
     * @see ProjectDashboardImageView
     */
    return DetailedImageLibraryCollectionView.extend("ProjectDashboardImageLibrary", {

        itemView: ProjectDashboardImageView,

        behaviors: {
            dropAreaHotspot: {
                behaviorClass: DropAreaHotspot,
                message: "<h4>Add <br/>images to Project</h4><p> Drag from desktop or click to upload</p>",
                dropAreaSelector: ".collection",
                iconSize: "small"
            }
        },

        onUpload: function onUpload(_ref) {
            var descriptors = _ref.descriptors;

            this.__super();

            var project = this.options.project;


            descriptors.forEach(function (imageUploadDescriptor) {
                imageUploadDescriptor.promise.then(function () {
                    project.attach(imageUploadDescriptor.model);
                });
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var template = __webpack_require__(1244);
    var _ = __webpack_require__(1);
    var ImageThumbnailView = __webpack_require__(556);
    var ProjectAsset = __webpack_require__(283);
    var Tooltip = __webpack_require__(35);

    /**
     * Subclass of ImageThumbnailView representing the item view for the Image dashboard element in a project context. <p>
     *
     * @class ProjectDashboardImageView
     * @see ImageThumbnailView
     */
    return ImageThumbnailView.extend({

        template: template,

        /**
         * @type {ProjectModel}
         */
        _project: null,

        templateHelpers: function templateHelpers() {
            var parentTemplateHelpers = this.__super();

            // Extending the parent templateHelpers
            return _.defaults({
                showImageActionsPanel: this.options.showImageActionsPanel,
                isLocked: this._project.containsInferredAsset(this.model.get("id"))
            }, parentTemplateHelpers);
        },
        ui: function ui() {
            return _.extend({}, ImageThumbnailView.prototype.ui, {
                noDetachImage: ".no-detach",
                detachImage: ".detach"
            });
        },
        events: function events() {
            return _.defaults({
                "click @ui.detachImage": "_detachImageClickHandler",

                // Override super 'deleteImage' event handler, to proper detach and delete...
                "click @ui.deleteImage": "_deleteImageClickHandler"
            }, ImageThumbnailView.prototype.events);
        },
        initialize: function initialize() {
            var _this = this;

            this.__super();

            // Store a reference to the current project
            this._project = this.options.project;

            // Re-render *this* item view if it's status as a "inferred asset" changes
            this.listenTo(this._project.get("inferredAssets"), "add remove", function (asset) {
                if (asset.get("resourceType") === ProjectAsset.Type.IMAGE && asset.get("resourceId") === _this.model.get("id")) {
                    _this.render();
                }
            });
        },
        _deleteImageClickHandler: function _deleteImageClickHandler() {
            if (this.options.isEditable && !this.model.get("timesUsed") && confirm("Are you sure you want to delete this image?")) {
                var image = this.model;
                var project = this._project;

                // First detach the image from the project, then delete it permanently.
                project.detach(image).then(function () {
                    return image.destroy();
                });
            }
        },
        _detachImageClickHandler: function _detachImageClickHandler() {
            var _this2 = this;

            if (this.options.isEditable) {
                var imageModel = this.model;

                Tooltip.remove(this.ui.detachImage);

                return this._project.detach(imageModel).then(function () {
                    _this2.trigger("detach", imageModel);
                }).always(function () {
                    _this2.trigger("close");
                });
            }
        },
        onRender: function onRender() {
            this.__super();

            Tooltip.add(this.ui.noDetachImage, {
                placement: "top",
                width: 260
            });

            Tooltip.add(this.ui.detachImage, {
                placement: "top",
                width: this.options.isEditable ? 110 : 180
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var PublishView = __webpack_require__(1194);
    var ProjectDashboardChannelSetupManualView = __webpack_require__(3087);

    /**
     * Subclass of PublishView to initialize the Channel dashboard in a project context.
     * @class ProjectDashboardPublishView
     * @see PublishView
     * @see ProjectDashboardChannelSetupManualView
     */
    return PublishView.extend({

        channelSetupViewClass: ProjectDashboardChannelSetupManualView,

        /**
         * Invoked when any assets has been attached to the current project.
         *
         * Refreshes the current collection view to include the newly attached assets.
         */
        onAttachAsset: function onAttachAsset() {
            this._channelSetupView.refresh();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        extend = _require.extend;

    var ChannelSetupManualView = __webpack_require__(700);
    var ProjectDashboardChannelSetupItemView = __webpack_require__(3088);

    /**
     * Subclass of ChannelSetupManualView representing the Channel dashboard in a project context. <p>
     *
     * @class ProjectDashboardChannelSetupManualView
     * @see ChannelSetupManualView
     * @see ProjectDashboardChannelSetupItemView
     */
    return ChannelSetupManualView.extend({

        viewOptions: {
            showAttachButton: true,
            showAttachActions: false,
            showCreateSlotField: true,
            showCreateSlotInProjectLabel: true,
            showPublishButton: true,
            showAttachHeader: false,
            showChannelActionsPanel: true
        },

        initialize: function initialize() {
            this.collectionViewOptions = {
                itemView: ProjectDashboardChannelSetupItemView,
                itemEvents: {
                    detach: function detach(model) {
                        this.collection.remove(model);
                    }
                }
            };

            this.__super();
        },
        ui: function ui() {
            return extend({}, ChannelSetupManualView.prototype.ui, {
                attachButton: ".attach-button"
            });
        },
        events: function events() {
            return extend({}, ChannelSetupManualView.prototype.events, {
                "click @ui.attachButton": "_openAttachLightbox"
            });
        },
        _openAttachLightbox: function _openAttachLightbox() {
            this.viewScope.openAttachLightbox(this.options);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defaults = _require.defaults,
        extend = _require.extend;

    var ChannelSetupItemView = __webpack_require__(701);
    var MessageNode = __webpack_require__(465);
    var MessageTypes = __webpack_require__(342);
    var template = __webpack_require__(1245);
    var Tooltip = __webpack_require__(35);

    /**
     * Subclass of ChannelSetupItemView representing the item view of the Channel dashboard element in a project context.<p>
     * @class ProjectDashboardChannelSetupItemView
     * @see ChannelSetupItemView
     */
    return ChannelSetupItemView.extend("ProjectDashboardChannelSetupItemView", {

        template: template,

        /**
         * @type {ProjectModel}
         */
        _project: null,

        templateHelpers: function templateHelpers() {
            var parentTemplateHelpers = this.__super();

            return defaults({
                showChannelActionsPanel: this.options.showChannelActionsPanel,
                isLocked: this._project.containsInferredAsset(this.model.get("id"))
            }, parentTemplateHelpers);
        },
        ui: function ui() {
            return extend({}, ChannelSetupItemView.prototype.ui, {
                noDetachChannel: ".no-detach",
                detachChannel: ".detach"
            });
        },
        events: function events() {
            return extend({}, ChannelSetupItemView.prototype.events, {
                "click @ui.noDetachChannel": function clickUiNoDetachChannel(event) {
                    // TODO: Please document why this is needed?
                    event.stopPropagation();
                },

                "click @ui.detachChannel": "_detachChannelClickHandler"
            });
        },
        initialize: function initialize() {
            this.__super();

            this._project = this.options.projectContext.project;
        },
        onShow: function onShow() {
            this.__super();

            Tooltip.add(this.ui.noDetachChannel, {
                placement: "top",
                width: 260
            });

            Tooltip.add(this.ui.detachChannel, {
                placement: "top",
                width: !this._allowedToPublish ? 180 : 100
            });
        },
        onClose: function onClose() {
            this.__super();

            Tooltip.remove(this.ui.detachChannel);
        },
        _detachChannelClickHandler: function _detachChannelClickHandler(event) {
            var _this = this;

            // Prevents to trigger the click event on the parent class, so that the Manual Channel lightbox does not get open in this view.
            event.stopPropagation();
            if (this._allowedToPublish) {
                var channelModel = this.model;

                return this._project.detach(channelModel).then(function () {
                    _this.collection.remove(channelModel);

                    // TODO still needed?
                    // Make sure we update the DnD view if opened because this may update
                    // how channels are rendered there, even with empty schedules...
                    var node = _this.options.node();
                    if (node) {
                        node.post({ action: MessageTypes.POPULATE_CHANNELS, receiver: "toolbar", selectors: MessageNode.Message.Selectors.NO_QUEUE });
                    }

                    _this.trigger("detach", channelModel);
                }).always(function () {
                    _this.trigger("close");
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var DashboardController = __webpack_require__(1215),
        Preconditions = __webpack_require__(14),
        ProjectDashboardView = __webpack_require__(3090),
        ProjectDashboardConfiguration = __webpack_require__(720),
        ProjectModel = __webpack_require__(695),
        EditorEvents = __webpack_require__(17),
        Backbone = __webpack_require__(7),
        ProjectSelector = __webpack_require__(1247),
        _ = __webpack_require__(1),
        LoggedIn = __webpack_require__(31),
        ProjectContext = __webpack_require__(1246),
        LoggedInUserState = __webpack_require__(19);

    /**
     *
     *
     * @class ProjectDashboardController
     */
    return DashboardController.extend("ProjectDashboardController", {

        dashboardView: ProjectDashboardView,

        /**
         * Explicitly define dashboard view specific options, in order to construct the project context.
         *
         * @param  {*} options The current options.
         * @return {Promise}   A promise that resolves with the options passed to the actual dashboard view.
         */
        dashboardViewOptions: function dashboardViewOptions(options) {
            return this.__super().then(function () {
                return options.project.fetch();
            }).then(function () {
                var project = options.project,
                    projectContextOptions = {
                    project: project
                };

                return _.extend(options, {
                    projectContext: new ProjectContext(projectContextOptions)
                });
            });
        },

        config: ProjectDashboardConfiguration,

        /**
         * @type {ProjectModel}
         */
        _project: null,

        /**
         * @type {ProjectContext}
         */
        _projectContext: null,

        onBeforeDashboardShow: function onBeforeDashboardShow(options) {
            // Store the project context in order to dispose it when the controller is closed.
            this._projectContext = options.projectContext;
        },

        /**
         * Shows the project dashboard.
         *
         * @param  {*} options The dashboard options, including the current project model.
         *                     @cfg {ProjectModel} project The current project model.
         *                     @cfg {DashboardTabConfiguration} tab The initial dashboard tab.
         */
        show: function show(options) {
            Preconditions.checkArgument(options.project, "A project model must be specified");

            var project = options.project,
                controllerOptions = _.extend(options, {
                // Re-create the dashboard view when the project changes...
                reset: options.project !== this._project
            });

            // Remove any previously added listeners (see below) - we need this when navigating between
            // projects (remain on the project dashboard), as this will not close *this* controller, i.e. listener(s)
            // will not be removed.
            this.stopListening(this._project);

            this._project = project;

            // If the current project is deleted/destroyed during editing (i.e. via the project selector) - we'll
            // navigate to the dashboard but keep the project selector open
            this.listenToOnce(this._project, "destroy", function (collection, model, options) {
                if (options.source === "projectSelector") {
                    Backbone.history.navigate("", true);
                    ProjectSelector.toggleProjectSelector(true);
                }
            });

            ProjectDashboardConfiguration.context({ project: project });

            this.__super(controllerOptions);
        },

        /**
         * Creates a new project and navigates to that.
         *
         * @return {Promise} Promise that resolves when the project has been created.
         */
        createProject: function createProject() {
            var principal = LoggedIn.principal(),
                model = new ProjectModel({
                createdBy: principal.get("userId"),
                companyId: principal.get("companyId")
            });

            return model.save().then(function () {
                var projects = LoggedInUserState.get("projects");
                projects.add(model);

                var eventProperties = {
                    projectId: model.get("id"),
                    triggerOrigin: "CreateNewProjectArea"
                };

                EditorEvents.trigger(EditorEvents.constants.CREATE_PROJECT, eventProperties);

                // TODO: Let the router do the navigation? (It's the only one using this method).
                Backbone.history.navigate("project/" + model.get("id"), { trigger: true, replace: true });
            });
        },

        onClose: function onClose() {
            this.__super();

            this._projectContext.dispose();
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        DashboardView = __webpack_require__(1216),
        EditBehavior = __webpack_require__(106),
        EditorEvents = __webpack_require__(17),
        Lightbox = __webpack_require__(101),
        Permissions = __webpack_require__(22),
        Preconditions = __webpack_require__(14),
        ProjectAttachChannelCollectionView = __webpack_require__(3091),
        ProjectAttachContentCollectionView = __webpack_require__(3095),
        ProjectAttachImageLibraryView = __webpack_require__(3097),
        ProjectDashboardConfiguration = __webpack_require__(720);

    var HEADER_TEMPLATE = _.template("<p class='pre-title'>Project</p>" + "<div class='project-title editable-container'>" + "<h1 contenteditable='<%- editable %>'' class='editable title<%if (!editable) { %> disabled<% } %>''  <%if (!editable) { %>disabled<% } %>><%- title %></h1>" + "</div>");

    return DashboardView.extend({

        className: DashboardView.prototype.className + " project-dashboard-view",

        templateHelpers: function templateHelpers() {
            var headerTemplateOptions = {
                title: this.options.project.get("name"),
                editable: Permissions.Privileges.CREATE.can()
            };

            return _.defaults({
                headerContentUnescaped: HEADER_TEMPLATE(headerTemplateOptions)
            }, DashboardView.prototype.templateHelpers);
        },

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,
                container: ".editable-container",
                editFields: [{
                    input: ".title",
                    save: function save(value) {
                        var project = this._project;

                        project.set("name", value);

                        return project.saveLater().then(function () {
                            var eventProperties = {
                                projectId: project.get("id"),
                                updatedProperty: "name",
                                updatedValue: value,
                                triggerOrigin: "ProjectDashboard"
                            };

                            EditorEvents.trigger(EditorEvents.constants.UPDATE_PROJECT, eventProperties);
                        });
                    }
                }]
            }
        },

        viewScope: function viewScope() {
            var superViewScope = this.__super();

            return _.extend(superViewScope, {
                openAttachLightbox: function openAttachLightbox(options) {
                    var AttachView,
                        attachViewOptions = _.defaults(options || {}, {
                        projectContext: this.options.projectContext
                    }),
                        showSpinner = true;

                    switch (this._tab) {
                        case ProjectDashboardConfiguration.EXPERIENCES:
                            AttachView = ProjectAttachContentCollectionView;
                            // The ProjectAttachContentCollectionView supports lazy loading...
                            showSpinner = false;
                            break;

                        case ProjectDashboardConfiguration.IMAGES:
                            AttachView = ProjectAttachImageLibraryView;
                            break;

                        case ProjectDashboardConfiguration.PUBLISH:
                            AttachView = ProjectAttachChannelCollectionView;
                            break;

                        default:
                            // TODO Candidate for refactoring during MOS-2934.
                            Preconditions.warn("DefaultSwitchWarn - Tab '" + this._tab + "' not recognized.");
                            break;
                    }

                    var lightboxOptions = {
                        disableElementPosition: true,
                        css: {
                            top: "40px",
                            bottom: "40px",
                            left: "40px",
                            right: "40px",
                            position: "absolute"
                        },
                        // E.g.  "lightbox-project-images"
                        lightboxClassName: "lightbox-project-" + this._tab.get("slug"),
                        // Show a spinner as the rendering might be heavy (for none "lazy" collection views)
                        showSpinner: showSpinner
                    };

                    var attachView = new AttachView(attachViewOptions),
                        box = new Lightbox(attachView, lightboxOptions, this);

                    this.listenToOnce(attachView, "attached", function (assets) {
                        var currentView = this._activeRegion.currentView;

                        if (_.isFunction(currentView.onAttachAsset)) {
                            currentView.onAttachAsset(assets);
                        }
                    });

                    box.open();
                }
            });
        },

        initialize: function initialize() {
            this.__super();

            var projectContext = this.options.projectContext;

            this._project = projectContext.project;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractProjectAttachView = __webpack_require__(721);
    var ChannelCollection = __webpack_require__(697);
    var PublishOptionsProvider = __webpack_require__(699);
    var ProjectAttachChannelSetupManualView = __webpack_require__(3093);
    var Promise = __webpack_require__(21);

    /**
     * Subclass of AbstractProjectAttachView representing the attach view in a project context. <p>
     *
     * @class ProjectAttachChannelCollectionView
     * @see AbstractProjectAttachView
     */
    return AbstractProjectAttachView.extend("ProjectAttachChannelCollectionView", {

        className: AbstractProjectAttachView.prototype.className + " channels",

        collectionView: ProjectAttachChannelSetupManualView,

        collectionOptions: function collectionOptions() {
            return Promise.all([ChannelCollection.count(), PublishOptionsProvider.provide({ maxScenes: 0 })]).then(function (results) {
                return {
                    header: {
                        label: "All Channels",
                        count: results[0]
                    },
                    collection: results[1].channelCollection
                };
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3092 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h4 class="attach-header"></h4>\n\n<div class="content-region" />\n\n<div class="actions">\n    <div class="notification-message pull-left" />\n    <button class="btn-ok-attach attach-button btn btn-primary pull-right ladda-button" data-spinner-size="28" data-style="expand-right">Attach<span class="ladda-spinner"></span></button>\n    <button class="btn-cancel-attach btn btn-secondary pull-right">Cancel</button>\n</div>\n';

}
return __p
}

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ChannelSetupManualView = __webpack_require__(700);
    var ProjectAttachChannelSetupItemView = __webpack_require__(3094);

    /**
     * Subclass of ChannelSetupManualView representing the attach lightbox Channel in a project context. <p>
     *
     * @class ProjectAttachChannelSetupManualView
     * @see ChannelSetupManualView
     * @see ProjectDashboardChannelSetupItemView
     */
    return ChannelSetupManualView.extend("ProjectAttachChannelSetupManualView", {
        initialize: function initialize() {
            this.collectionViewOptions = {
                itemView: ProjectAttachChannelSetupItemView
            };

            this.__super();
        },


        options: {
            showDropTarget: false
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        defaults = _require.defaults;

    var ChannelSetupItemView = __webpack_require__(701);
    var template = __webpack_require__(1245);

    /**
     * Subclass of ChannelSetupItemView representing the item view of the attach lightbox Channel in a project context.<p>
     * @class ProjectAttachChannelSetupItemView
     * @see ChannelSetupItemView
     */
    return ChannelSetupItemView.extend("ProjectAttachChannelSetupItemView", {

        _channelSelected: false,

        template: template,

        templateHelpers: function templateHelpers() {
            var parentTemplateHelpers = this.__super(); // ChannelSetupItemView.prototype.templateHelpers.call(this);

            // Extending the parent templateHelpers
            return defaults({
                showChannelActionsPanel: this.options.showChannelActionsPanel
            }, parentTemplateHelpers);
        },
        initialize: function initialize() {
            this.__super();
            this._itemViewOptions = this.options.itemViewOptions();
        },


        events: {
            "click": function click() {
                this._channelSelected = !this._channelSelected;
                this._itemViewOptions.selectHandler(this.model, this._channelSelected);
                this.$el.toggleClass("selected");
            }
        },

        /**
         * Invoked when any assets has been attached to the current project.
         *
         * Refreshes the current collection view to include the newly attached assets.
         */
        onAttachAsset: function onAttachAsset() {
            this.refresh();
        },


        /**
         * Do nothing as when opening the attach lightbox we do not want to check for unpushed changes.
         */
        handleUnPushedChangesOnRender: function handleUnPushedChangesOnRender() {},
        onRender: function onRender() {
            this.__super();

            var projectContext = this._itemViewOptions.projectContext;

            if (projectContext.project.containsChannel(this.model.get("id"))) {
                this.$el.addClass("in-project");
            } else {
                this.$el.removeClass("in-project");
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractProjectAttachView = __webpack_require__(721),
        _ = __webpack_require__(1),
        Promise = __webpack_require__(21),
        ContentCollection = __webpack_require__(463),
        DashboardSorting = __webpack_require__(341),
        UserCollection = __webpack_require__(184),
        LoggedIn = __webpack_require__(31),
        ProjectContext = __webpack_require__(1246),
        ProjectAttachContentItemView = __webpack_require__(3096),
        LoggedInUserState = __webpack_require__(19),
        DashboardContentCollectionView = __webpack_require__(703);

    var NOTIFICATION_MESSAGE = "You have selected Items which will be moved from other Projects";

    var CollectionView = DashboardContentCollectionView.extend({

        itemView: ProjectAttachContentItemView,

        itemViewOptions: function itemViewOptions() {
            return {
                contentMap: ProjectContext.mapContent()
            };
        }

    });

    /**
     *
     * @class ProjectAttachContentCollectionView
     *
     */
    return AbstractProjectAttachView.extend("ProjectAttachContentCollectionView", {

        className: AbstractProjectAttachView.prototype.className + " content",

        collectionView: CollectionView,

        _contentMap: null,

        collectionOptions: function collectionOptions() {
            var collection = new ContentCollection();

            return Promise.all([ContentCollection.count(), collection.query(DashboardSorting.current().query),
            // We need the list of users to correctly render "Created By"...
            new UserCollection().fetch()]).then(function (results) {
                return {
                    // The 'header' is reserved for the 'AbstractProjectAttachView'
                    header: {
                        label: "Experiences",
                        count: results[0]
                    },
                    // Hide the "Create experience disclaimer" when inside the attach view
                    showCreateDisclaimer: false,
                    collection: collection,
                    principal: LoggedIn.principal(),
                    users: results[2]
                };
            });
        },

        initialize: function initialize() {
            this.__super();

            this._contentMap = ProjectContext.mapContent();
        },

        onSelect: function onSelect(model, selected, selectedAssets) {
            // We display a warning message if the user selects content belonging to another project.
            var projectId = this.options.projectContext.project.get("id"),
                contentMap = this._contentMap,
                showNotification = !!_.find(selectedAssets, function (asset) {
                var otherProjectId = contentMap.get(asset.get("id"));

                return otherProjectId && otherProjectId !== projectId;
            });

            this.showNotification(showNotification && NOTIFICATION_MESSAGE);
        },

        onAttach: function onAttach(selectedAssets) {
            var self = this,
                projectId = self.options.projectContext.project.get("id"),
                promises = [Promise.resolved()];

            // When attaching content from other projects - re-fech/sync those to keep
            // models (and selector thumbs) updated.
            selectedAssets.forEach(function (asset) {
                var assetProjectId = self._contentMap.get(asset.get("id"));

                if (assetProjectId && assetProjectId !== projectId) {
                    var project = LoggedInUserState.get("projects").get(assetProjectId);

                    promises.push(project.fetch());
                }
            });

            return Promise.all(promises);
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        ProjectContentItemView = __webpack_require__(1243),
        Tooltip = __webpack_require__(35);

    /**
     * The <tt>ProjectContentItemView</tt> to appear in the attach dialog.
     */
    return ProjectContentItemView.extend({

        viewOptions: {
            showExperienceActionsPanel: false,
            showSelectIndicator: true
        },

        _selected: false,

        ui: function ui() {
            return _.defaults({
                selectIndicator: ".select-indicator",
                selectIndicatorInOtherProject: ".select-indicator.in-other-project",
                selectIndicatorInOtherProjectSelected: ".select-indicator.in-other-project-selected"
            }, ProjectContentItemView.prototype.ui);
        },

        events: function events() {
            return _.defaults({
                "click @ui.thumbContainer": function clickUiThumbContainer() {
                    // Overwrite this click event to avoid opening the quickview
                },

                "click @ui.groupThumbContainer": function clickUiGroupThumbContainer() {
                    // Overwrite this click event to avoid opening the quickview
                },

                "click @ui.thumbWrapper": "_toggleSelection",
                "click @ui.selectIndicator": "_toggleSelection"
            }, ProjectContentItemView.prototype.events);
        },

        _toggleSelection: function _toggleSelection() {
            this._selected = !this._selected;

            this.options.selectHandler(this.model, this._selected);

            this.$el.toggleClass("selected");
        },

        onRender: function onRender() {
            this.__super();

            var projectContext = this.options.projectContext,
                projectID = this.options.contentMap.get(this.model.get("id"));

            if (projectID) {
                this.$el.addClass(projectID === projectContext.project.get("id") ? "in-project" : "in-other-project");
            } else {
                this.$el.removeClass("in-project in-other-project");
            }

            Tooltip.add(this.ui.selectIndicatorInOtherProject, {
                placement: "top",
                alignCenter: true,
                width: 250
            });

            Tooltip.add(this.ui.selectIndicatorInOtherProjectSelected, {
                placement: "top",
                alignCenter: true,
                width: 200
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AbstractProjectAttachView = __webpack_require__(721);
    var Promise = __webpack_require__(21);
    var ProjectAttachImageView = __webpack_require__(3098);
    var ImageCollection = __webpack_require__(314);
    var AbstractImageLibraryView = __webpack_require__(1201);

    var CollectionView = AbstractImageLibraryView.extend({

        itemView: ProjectAttachImageView,

        options: {
            showDropTarget: false
        }

    });

    return AbstractProjectAttachView.extend("ProjectAttachImageLibraryView", {

        className: AbstractProjectAttachView.prototype.className + " images",

        collectionView: CollectionView,

        collectionOptions: function collectionOptions() {
            var imageCollection = new ImageCollection();
            var imageLibrarySorting = this.options.imageLibrarySorting;

            return Promise.all([ImageCollection.count(), imageCollection.query(imageLibrarySorting.getSelectedSorting().query)]).then(function (results) {
                return {
                    header: {
                        label: "All Images",
                        count: results[0]
                    },
                    collection: imageCollection,
                    imageLibrarySorting: imageLibrarySorting
                };
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        EditBehavior = __webpack_require__(106),
        ImageThumbnailView = __webpack_require__(556),
        template = __webpack_require__(1244);

    /**
     * Subclass of ImageThumbnailView representing the item view for the Image lightbox in a
     * project context.
     *
     * @class ProjectAttachImageView
     * @see ImageThumbnailView
     */
    return ImageThumbnailView.extend({

        template: template,

        templateHelpers: function templateHelpers() {
            var parentTemplateHelpers = this.__super();

            // Extending the parent templateHelpers.
            return _.defaults({
                showImageActionsPanel: this.options.showImageActionsPanel,
                isEditable: false
            }, parentTemplateHelpers);
        },

        _imageSelected: false,

        behaviors: {
            nameEditBehavior: {
                behaviorClass: EditBehavior,
                editFields: [{
                    input: ".js-name",
                    // Disable event binding of the field because click events should be disabled
                    // on images.
                    enableFieldEvents: false,
                    hideIcon: true
                }]
            },
            altTextEditBehavior: {
                behaviorClass: EditBehavior,
                editFields: [{
                    input: ".js-alt-text",
                    enableFieldEvents: false,
                    hideIcon: true
                }]
            }
        },

        events: {
            "click": function click() {
                this._imageSelected = !this._imageSelected;
                this.options.selectHandler(this.model, this._imageSelected);
                this.$el.toggleClass("selected");
            }
        },

        onRender: function onRender() {
            this.__super();

            var projectContext = this.options.projectContext;

            if (projectContext.project.containsImage(this.model.get("id"))) {
                this.$el.addClass("in-project");
            } else {
                this.$el.removeClass("in-project");
            }
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorEvents = __webpack_require__(17);
    var FilteringCollectionView = __webpack_require__(3100);
    var NoResultsItemView = __webpack_require__(207);
    var Permissions = __webpack_require__(22);
    var ProjectItemView = __webpack_require__(3102);
    var Storage = __webpack_require__(34);

    /**
     * View for all projects.
     *
     * @cfg {ProjectCollection} collection
     *
     * @class ProjectCollectionView
     */
    return FilteringCollectionView.extend({

        className: "project-selector zmags-section wide",

        itemView: ProjectItemView,

        noResultsItemView: function noResultsItemView() {
            return new NoResultsItemView({ type: "Projects" });
        },
        itemViewOptions: function itemViewOptions() {
            return {
                cannotDelete: Permissions.Privileges.CREATE.cannot()
            };
        },


        itemEvents: {
            "delete:project": "_deleteProjectHandler",
            "select:project": "_selectProjectHandler"
        },

        filterAttributeList: ["name", "id"],

        collectionName: Storage.Keys.PROJECT_COLLECTION,

        sortAttributeList: {
            lastUpdate: {
                label: "Last Updated",
                value: "editedAt",
                ascending: false
            },
            alphabetical: {
                label: "Alphabetical",
                value: "name",
                ascending: true
            },
            lastCreate: {
                label: "Last Created",
                value: "createdAt",
                ascending: false
            }
        },

        initialize: function initialize() {
            this.options.filterDropdown = false;

            // Update sorting when projects have been updated/synced
            this.listenTo(this.collection, "change", function () {
                this.updateSort();
            });
        },
        onRender: function onRender() {
            this.__super();

            if (Permissions.Privileges.CREATE.can()) {
                this._addCreateField();
            }
        },


        /**
         * Add a "create-project" button to the view.
         * Since the view is an abstract view, we need to do this in jquery.
         */
        _addCreateField: function _addCreateField() {
            this.$el.addClass("has-creation-field");
            this.$el.find(".collection").before("<a class='create-project-field' href='#project/create'>" + "<div class='text'>Create<br> New Project<br> &#43;</div></a>");
        },


        // TODO: Move below "handler" logic to view controller?

        _deleteProjectHandler: function _deleteProjectHandler(type, view, options) {
            var projectModel = options.model;

            if (Permissions.Privileges.CREATE.can() && confirm("Are you sure you want to delete the Project, '" + projectModel.get("name") + "'?\n\n" + "No Experiences, Images or Slots will be deleted.")) {
                var eventProperties = {
                    projectId: projectModel.get("id"),
                    triggerOrigin: "DeleteProjectButton"
                };

                EditorEvents.trigger(EditorEvents.constants.DELETE_PROJECT, eventProperties);

                projectModel.destroy({ source: "projectSelector" });
            }
        },
        _selectProjectHandler: function _selectProjectHandler(type, view, options) {
            var eventProperties = {
                projectId: options.model.get("id"),
                dashboardType: "Experiences",
                triggerOrigin: "ProjectThumbnail"
            };

            EditorEvents.trigger(EditorEvents.constants.OPEN_DASHBOARD, eventProperties);

            this.viewScope.toggleProjectSelector(false);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Backbone = __webpack_require__(7),
        EditorEvents = __webpack_require__(17),
        ImprovedCompositeView = __webpack_require__(865),
        Storage = __webpack_require__(34),
        template = __webpack_require__(3101);

    /**
     * @class FilteringOptions
     */
    var FilteringOptions = Backbone.Model.extend({
        defaults: {
            // The key to retrieve the saved sorting options in the LocalStorage
            collectionName: null,
            // A list of attributes available for sorting
            sortAttributeList: null,
            // An attribute to sort against the collection
            sortAttribute: "editedAt",
            // The sorting ascending
            sortAscending: false,
            /**
             * The list of attributes used to filter against a model when non-specific {@see #filterAttribute} is set.
             *
             * The filterAttributeList defines a scope for filter operation. For example, if list contains
             * ["name", "date"], then when we do filter, the provided key must match against the value of name/date
             * in the model. If no such scope is specified, then the filter will search through the whole model.
             */
            filterAttributeList: [],
            // An attribute used to filter against the collection
            filterAttribute: "",
            // A key to filter against the collection
            searchKey: ""
        },

        initialize: function initialize() {
            var savedSortAttribute = Storage.Local.get(this.get("collectionName"), "sortingOption", this.get("sortAttribute"));
            this.set("sortAttribute", savedSortAttribute);
            this.set("sortAscending", this._getAscendingBySort(savedSortAttribute));

            this.on("change:sortAttribute", this._storeSortAttribute);
        },

        _storeSortAttribute: function _storeSortAttribute() {
            Storage.Local.update(this.get("collectionName"), "sortingOption", this.get("sortAttribute"));
        },

        _getAscendingBySort: function _getAscendingBySort(sortAttribute) {
            var ascending = this.get("sortAscending"),
                list = this.get("sortAttributeList"),
                match;

            if (list) {
                match = _.findWhere(list, { value: sortAttribute });
                if (match) {
                    ascending = match.ascending;
                }
            }
            return ascending;
        }
    });

    /**
     * A CollectionView that can be sorted, filtered and searched using built-in controls.
     *
     * Note that due to limitations on how sorting works, the collection used must be fetched from the server before creating this object.
     * Note, the `events` object needs to be extended (and not overwritten) by subclasses.
     *
     *
     * @author Bo Gotthardt
     * @class FilteringCollectionView
     * @constructor
     *
     * @cfg {Boolean}   [sortAscending = true] Direction to sort in.
     * @cfg {String}    [sortAttribute = "createdAt"] Model attribute to sort on.
     * @cfg {String}    [searchKey = ""] Value to filter models by.
     * @cfg {Array}     [filterAttributeList = []] Model attributes to filter on.
     * @cfg {Object[]}  [sortAttributeList = [{label: "Name", value: "name"}]] List of values and labels to show in the sort attribute dropdown.
     */
    return ImprovedCompositeView.extend({

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                sortAttributeList: this.model.get("sortAttributeList")
            };
        },

        className: "filtering-collection-view",

        itemViewContainer: ".collection",

        model: null,

        events: {
            "click .sorting-tabs span": "_sortingTabsHandler"
        },

        ui: {
            search: ".search",
            filterDropdown: ".filter-attribute"
        },

        modelEvents: {
            "change:sortAscending": "_sortAndFilter",
            "change:sortAttribute": "_sortAndFilter",
            "change:filterAttribute": "filter",
            "change:searchKey": "throttleFilter"
        },

        bindings: {
            "input.search": "searchKey",
            "select.filter-attribute": {
                observe: "filterAttribute",
                selectOptions: {
                    collection: function collection() {
                        return this.filterAttributeList;
                    }
                }
            }
        },

        constructor: function constructor(options) {
            // Assigning here to avoid prototype sharing problem, and get it included in the superclass constructor logic.
            this.model = new FilteringOptions({
                filterAttributeList: this.filterAttributeList,
                sortAttributeList: this.sortAttributeList,
                collectionName: this.collectionName,
                sortAttribute: this.defaultSortAttribute
            });

            // We need to modify this.collection in order to implement sorting and filtering.
            // But if the collection is used for other things, they will unexpectedly get those modifications as well.
            // So we need to replace this.collection with a clone, and keep a reference to the original so we can duplicate add and remove in the clone.
            if (!options.collection) return;
            this.originalCollection = options.collection;
            // The collection will be set in the resetCollection, because we need to do sort and filter first.
            options.collection = new Backbone.Collection();
            this.originalCollection.comparator = this.sortComparator.bind(this);
            this.originalCollection.sort();

            // Superclass constructor here so we can shuffle around options.collection first.
            this.__super();

            this.listenTo(this.originalCollection, "add", function (oneOrMoreModels) {
                this._updateEmptyView();

                if (!_.isArray(oneOrMoreModels)) {
                    oneOrMoreModels = [oneOrMoreModels];
                }

                this.collection.add(_.filter(oneOrMoreModels, this.filterComparator()));
                this.filter();
            });

            this.listenTo(this.originalCollection, "remove", function (oneOrMoreModels) {
                this._updateEmptyView();
                this.collection.remove(oneOrMoreModels);
            });

            // Back up the empty view and do the initial update
            this._originalEmptyView = this.emptyView;
            this._updateEmptyView();
        },

        onRender: function onRender() {
            if (!this.options.filterDropdown) {
                this.ui.filterDropdown.remove();
                this.ui.search.addClass("full-width");
            }

            this._filterAndUpdate();
        },

        _sortingTabsHandler: function _sortingTabsHandler(event) {
            var sortBy = event.target.getAttribute("data-sort-by"),
                attribute = _.findWhere(this.sortAttributeList, { value: sortBy });

            event.preventDefault();
            this.updateSort(attribute.value, attribute.ascending);

            var eventProperties = {
                sortBy: attribute.label,
                triggerOrigin: "SortingPanel"
            };

            EditorEvents.trigger(EditorEvents.constants.SORT_DASHBOARD, eventProperties);
        },

        /**
         * Sorts the collection according to the sortAttribute and ascending.
         *
         * If invoked with no arguments, sorting/rendering is updated immediately.
         *
         * @param {String} value - The sort attribute by which we want to sort.
         * @param {Boolean} ascending - true = ascending, false = descending.
         */
        updateSort: function updateSort(value, ascending) {
            if (arguments.length === 0) {
                return this._sortAndFilter();
            }

            // Let the first setting be silent, otherwise will trigger sorting twice
            this.model.set("sortAscending", ascending, { silent: true });
            this.model.set("sortAttribute", value);
        },

        /**
         * Updates the tabs to indicate the current sorting attribute.
         *
         * @param {String} sortAttribute - "createdAt", "name", etc
         */
        _updateActiveTab: function _updateActiveTab(sortAttribute) {
            if (_.contains(_.pluck(this.sortAttributeList, "value"), sortAttribute)) {
                this.$(".sorting-tabs .active").removeClass("active");
                this.$("[data-sort-by=" + sortAttribute + "]").addClass("active");
            }
        },

        /**
         * When the original collection is empty, we use the empty view specified by the user. However, if the original
         * collection is not empty, we want to use the "no results" view as the empty view.
         *
         * @private
         */
        _updateEmptyView: function _updateEmptyView() {
            if (this.originalCollection.length === 0) {
                this.$el.addClass("empty");
                this.emptyView = this._originalEmptyView;
            } else {
                this.$el.removeClass("empty");
                this.emptyView = this.noResultsItemView || this._originalEmptyView;
            }
        },

        /**
         * Returns a function to check whether the model should be filtered out.
         *
         * @param  {String} [filterAttribute] - If empty or undefined, it will use the filter string
         * from the FilteringOptions (model.get("filter")).
         *
         * @private
         */
        filterComparator: function filterComparator(filterAttribute, value) {
            var filterList = this.model.get("filterAttributeList"),
                self = this;

            // TODO: Get changes from custom JS task (commit 67fdc7b)
            return function (model) {
                var scope;

                if (!filterAttribute && !value) {
                    return true;
                } else if (!filterAttribute) {
                    scope = filterList;
                } else {
                    scope = filterAttribute;
                }

                return self.containsValue(model, scope, value);
            };
        },

        /**
         * Given a model, attributes and a key, find if the model contains the key in any values of supplied attributes.
         *
         * @param {Backbone.Model} model
         * @param {Array} attrs
         * @param {String} key
         * @returns {boolean}
         */
        containsValue: function containsValue(model, attrs, key) {
            key = key || "";
            var haystack = "";
            attrs = _.isArray(attrs) ? attrs : [attrs];

            _.each(attrs, function (attr) {
                haystack += model.get(attr);
            });

            return haystack.toLocaleLowerCase().indexOf(key.toLocaleLowerCase()) !== -1;
        },

        /**
         * A rate limited filter when users are typing the search key
         */
        throttleFilter: _.throttle(function () {
            this.filter();
        }, 300),

        /**
         * Filter the collection and reset the collection with the result, which will trigger a re-render
         *
         * @private
         */
        filter: function filter() {
            var filterAttribute = this.model.get("filterAttribute"),
                key = this.model.get("searchKey"),
                searchKey = _.isString(key) ? key.trim() : "",

            // User-specified attribute to filter on...
            userSpecifiedAttribute = searchKey.split(/\s*::\s*/, 2); // only split on first double colon to avoid conflict with names with colon in them

            if (userSpecifiedAttribute.length === 2) {
                searchKey = userSpecifiedAttribute.pop();
                filterAttribute = userSpecifiedAttribute;
            }

            var filterFunction = this.filterComparator(filterAttribute, searchKey),
                items = this.originalCollection.filter(filterFunction);

            this._resetCollection(items);
        },

        /**
         * Filter the collection by the given key
         *
         * @param {String} key
         */
        filterBy: function filterBy(key) {
            this.model.set("searchKey", key);
        },

        /**
         * An usual sort comparator for the original collection when sorting
         *
         * @param {Backbone.Model} a
         * @param {Backbone.Model} b
         * @returns {number}
         */
        sortComparator: function sortComparator(a, b) {
            var sortAttr = this.model.get("sortAttribute"),
                aVal = a.get(sortAttr),
                bVal = b.get(sortAttr),
                comparison;

            if (_.isString(aVal)) {
                comparison = aVal.localeCompare(bVal);
            } else {
                comparison = aVal - bVal;
            }

            return (this.model.get("sortAscending") ? 1 : -1) * comparison;
        },

        /**
         * Sort the collection and sequentially do a filter if there is a search key
         * @private
         */
        _sortAndFilter: function _sortAndFilter() {
            // We only need to sort in the beginning and when sort attribute changes, no need to sort every render
            this.originalCollection.sort();
            this._filterAndUpdate();
        },

        /**
         * Filter the collection and update the tabs
         * @private
         */
        _filterAndUpdate: function _filterAndUpdate() {
            this.filter();
            this._updateActiveTab(this.model.get("sortAttribute"));
        },

        /**
         * Reset the shown collection.
         *
         * @param  {Array} items - Array of models from the collection (E.g. Images, Experiences)
         * @private
         */
        _resetCollection: function _resetCollection(items) {
            this.collection.reset(items, { merge: false });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3101 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="sorting-panel">\n    <div class="filter-search-container">\n	    <select class="filter-attribute form-control"></select>\n	    <input type="search" class="search" placeholder="Search">\n	</div>\n    <div class="sorting-tabs">\n        ';
 _.each(sortAttributeList, function (attributes, i) { ;
__p += '\n            <span ';
 if (i === 0) { ;
__p += 'class="active" ';
 } ;
__p += ' data-sort-by="' +
__e( attributes.value ) +
'">' +
__e( attributes.label ) +
'</span>\n        ';
 }); ;
__p += '\n    </div>\n</div>\n<div class="collection"></div>\n';

}
return __p
}

/***/ }),
/* 3102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var BreakpointGroup = __webpack_require__(97);
    var ExperienceModel = __webpack_require__(58);
    var ExperienceThumbnailViewer = __webpack_require__(705);
    var LoggedInUserState = __webpack_require__(19);
    var Marionette = __webpack_require__(10);
    var Promise = __webpack_require__(21);
    var SceneThumbnailViewer = __webpack_require__(466);
    var template = __webpack_require__(3103);
    var Tooltip = __webpack_require__(35);

    var MAX_THUMB_DIMENSION = { width: 130, height: 70 };
    var EXPERIENCE_RESOURCE_TYPE = "Experience";
    var BREAKPOINT_GROUP_RESOURCE_TYPE = "BreakpointGroup";

    /**
     * Item view for rendering a project thumbnail.
     *
     * @cfg {ProjectModel} model
     *
     * @class ProjectItemView
     */
    return Marionette.Layout.extend({

        className: "project-item",

        template: template,

        _assets: [],

        templateHelpers: function templateHelpers() {
            var assetsCount = this._assets ? this._assets.length : 0;
            var experienceLabel = assetsCount + " Experience" + (assetsCount !== 1 ? "s" : "");
            return {
                projectName: this.model.get("name"),
                experienceCountLabel: experienceLabel,
                cannotDelete: this.options.cannotDelete
            };
        },


        regions: {
            experienceThumb: ".experience-thumb"
        },

        ui: {
            projectThumb: ".project-thumb",
            delete: ".delete",
            disabledDelete: ".delete.disabled"
        },

        events: {
            "click @ui.delete": "_clickDeleteHandler"
        },

        triggers: {
            "click @ui.projectThumb": {
                event: "select:project",
                // Default is true (we want to execute the default anchor .project-thumb logic on click)
                preventDefault: false
            }
        },

        initialize: function initialize() {
            var experienceAssets = this.model.get("assets").models.filter(function (model) {
                return model.get("resourceType") === EXPERIENCE_RESOURCE_TYPE;
            });

            var breakpointGroupAssets = this.model.get("assets").models.filter(function (model) {
                return model.get("resourceType") === BREAKPOINT_GROUP_RESOURCE_TYPE;
            });

            this._assets = [].concat(_toConsumableArray(experienceAssets), _toConsumableArray(breakpointGroupAssets));
        },
        onRender: function onRender() {
            var experienceThumbRegion = this.experienceThumb;

            if (this.options.cannotDelete) {
                Tooltip.add(this.ui.disabledDelete, { width: 180, placement: "top" });
            } else {
                Tooltip.add(this.ui.delete, { width: 135, placement: "top" });
            }

            if (!LoggedInUserState.get("companySettings").get("lazyLoadProjectsMenu")) {
                this._experienceFetch().then(function (experienceModel) {
                    if (experienceModel) {
                        var experienceThumb = void 0;
                        if (LoggedInUserState.get("integrations").isThumbnailsNativeContentIntegrationsEnabled()) {
                            experienceThumb = new ExperienceThumbnailViewer({
                                model: experienceModel.get("scenes").at(0),
                                experience: experienceModel,
                                maxDimensions: MAX_THUMB_DIMENSION,
                                showStaticScenes: true
                            });
                        } else {
                            experienceThumb = new SceneThumbnailViewer({
                                model: experienceModel.get("scenes").at(0),
                                experience: experienceModel,
                                maxDimensions: MAX_THUMB_DIMENSION,
                                showStaticScenes: true
                            });
                        }
                        experienceThumbRegion.show(experienceThumb);
                    }
                });
            }
        },
        _clickDeleteHandler: function _clickDeleteHandler() {
            // Force hiding of the tooltip. The `mouseout` event does not seem to trigger
            // when we open a native promt/alert when clicking the delete button.
            Tooltip.hide(this.ui.delete);
            this.triggerMethod("delete:project", this);
        },
        _experienceFetch: function _experienceFetch() {
            var modelFetch = Promise.resolved();
            var targetAsset = this._assets[0];
            if (targetAsset) {
                var resourceType = targetAsset.get("resourceType");
                var resourceId = targetAsset.get("resourceId");

                if (resourceType === EXPERIENCE_RESOURCE_TYPE) {
                    var experienceModel = new ExperienceModel({ id: resourceId });
                    modelFetch = experienceModel.fetch();
                } else if (resourceType === BREAKPOINT_GROUP_RESOURCE_TYPE) {
                    var breakpointGroup = new BreakpointGroup({ id: resourceId }, { pushedOnly: true });
                    modelFetch = breakpointGroup.fetchPushedOnly().then(function (response) {
                        if (response) {
                            return response.getSortedAssets("editedAt")[0];
                        }
                    });
                }
            }

            return modelFetch;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3103 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="project-wrapper">\n    <div class="actions-panel">\n        ';
 if (cannotDelete) { ;
__p += '\n            <span class="delete pull-right disabled" data-content="You do not have permission to delete Projects."></span>\n        ';
} else {;
__p += '\n            <span class="delete pull-right" data-content="Delete Project. No Experiences, Images or Slots will be deleted."></span>\n        ';
};
__p += '\n    </div>\n    <a class="project-thumb" href="#project/' +
__e( id ) +
'">\n        <div class="project-title" title="' +
__e( projectName ) +
'">' +
__e( projectName ) +
'</div>\n        <div class="experiences-count">' +
__e( experienceCountLabel ) +
'</div>\n        <div class="experiences-thumbs">\n            <div class="experience-thumb"></div>\n        </div>\n    </a>\n</div>\n';

}
return __p
}

/***/ }),
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var UserCollection = __webpack_require__(184);
    var LoggedInUserState = __webpack_require__(19);
    var Promise = __webpack_require__(21);
    var LoggedIn = __webpack_require__(31);
    var TrafficModel = __webpack_require__(3105);
    var ManageAccountSettingsView = __webpack_require__(3106);

    /**
     * <tt>Marionette Controller</tt> for the <tt>ManageAccountView</tt>.
     *
     * Responsible for handling the traffic on the account.
     *
     */
    return Marionette.Controller.extend({
        showManageAccount: function showManageAccount() {
            var principal = LoggedIn.principal();
            var region = this.options.region;
            var trafficModel = new TrafficModel({ companyId: principal.get("companyId") });

            Promise.all([LoggedInUserState.fetchGlobalCollection(UserCollection), trafficModel.fetch()]).then(function (results) {
                var _results = _slicedToArray(results, 1),
                    collection = _results[0];

                var undeletedUsers = collection.undeletedUsers();

                region.show(new ManageAccountSettingsView({
                    trafficModel: trafficModel,
                    model: principal.get("user"),
                    collection: undeletedUsers,
                    isEditable: true // any user can change their own name
                }));
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedModel = __webpack_require__(25),
        LoggedIn = __webpack_require__(31),
        RestApi = __webpack_require__(29);

    /**
     * Model for the traffic
     *
     * @class TrafficModel
     * @constructor
     */
    return ImprovedModel.extend("Traffic Model", {

        url: function url() {
            if (this.has("id")) {
                return RestApi.pathToSpecificResource(RestApi.Collections.TRAFFIC, this.get("id"));
            }
            return RestApi.pathToCollectionOnResource(RestApi.Collections.COMPANIES, LoggedIn.companyId(), RestApi.Collections.TRAFFIC);
        },

        defaults: {
            totalKilobytes: 0,
            daysCount: 0,
            averageKilobytes: 0,
            companyId: null
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(4);
    var SettingsView = __webpack_require__(230);
    var template = __webpack_require__(3107);
    var ManageAccountCompositeView = __webpack_require__(3108);

    /**
     * View for defining manage account settings.
     *
     * @class ManageAccountSettingsView
     */
    return SettingsView.extend("ManageAccountSettingsView", {

        className: SettingsView.prototype.className + " manage-account-settings-view",

        template: template,

        regions: function regions() {
            return _.extend(SettingsView.prototype.regions, {
                manageAccountCompositeRegion: ".manage-account-composite-region"
            });
        },
        onShow: function onShow() {
            this.manageAccountCompositeRegion.show(new ManageAccountCompositeView(this.options));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3107 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Manage Account</h1>\n    </header>\n\n    <div class="manage-account-composite-region" />\n</div>\n<footer class="default-footer"></footer>\n';

}
return __p
}

/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var AddUserView = __webpack_require__(3109);
    var ConfirmationManager = __webpack_require__(339);

    var _require = __webpack_require__(120),
        DateUtil = _require.DateUtil;

    var EditBehavior = __webpack_require__(106);
    var EditorEvents = __webpack_require__(17);
    var Lightbox = __webpack_require__(101);
    var LoggedIn = __webpack_require__(31);
    var LoggedInUserState = __webpack_require__(19);
    var ManageUsersHelper = __webpack_require__(1248);
    var ManageUsersItemView = __webpack_require__(3111);
    var Marionette = __webpack_require__(10);
    var NotificationBar = __webpack_require__(53);
    var Permissions = __webpack_require__(22);
    var SequentialButton = __webpack_require__(112);
    var template = __webpack_require__(3114);
    var User = __webpack_require__(261);

    /**
     * The manage account view.
     *
     * @class ManageAccountView
     * @constructor
     *
     * @cfg {User} model The principal, current logged in user model to display.
     * @cfg {UserCollection} collection The user collection to display.
     */
    return Marionette.CompositeView.extend({

        /**
         * @private
         * @type {String}
         * The display name of the first found unconfirmed user, if any. The user is chosen at random, to
         * be able to display a message to the manager about unconfirmed users. Otherwise null.
         */
        _unconfirmed: null,

        _startDate: null,

        _endDate: null,

        template: template,

        className: "manage-account-composite-view",

        ui: {
            currentUserPermissionsSelect: ".current-user-permissions-select",
            currentUserPermissionsDisplay: ".current-user-permissions-display",
            tabMenuItem: ".tab",
            users: ".users",
            editUser: ".info-user .edit-user",
            addUser: ".btn-add-user"
        },

        behaviors: {
            editBehavior: {
                behaviorClass: EditBehavior,
                container: ".editable-container",
                editFields: [{
                    input: ".current-user-name",
                    model: "name",
                    save: function save(value) {
                        var _this = this;

                        this.model.set("name", value);

                        return this.model.saveLater().done(function () {
                            var eventProperties = {
                                userId: _this.model.get("id"),
                                name: _this.model.get("name"),
                                username: _this.model.get("username"),
                                triggerOrigin: "EditUserNameInputField",
                                updatedProperty: "name",
                                updatedValue: value
                            };

                            EditorEvents.trigger(EditorEvents.constants.UPDATE_USER, eventProperties);
                        });
                    }
                }]
            }
        },

        itemView: ManageUsersItemView,

        itemViewOptions: null,

        itemViewContainer: "#users",

        bindings: {
            ".current-user-name": {
                observe: "name",
                onGet: function onGet(name) {
                    var s = name || this.model.get("username");

                    if (ConfirmationManager.confirmationRequired(this.model)) {
                        s += " (Unconfirmed)";
                    }

                    return s;
                },

                // We need to use updateMethod "html" and escape true, because we are using a tag contenteditable
                updateMethod: "html",
                escape: true
            },
            ".current-accessed-at": {
                observe: "accessedAt",
                onGet: function onGet(date) {
                    return "Last login: " + (date ? DateUtil.formatYYYYMMDDHHmm(date) : "Never");
                }
            },
            ".current-user-email": "username",
            ".current-user-permissions-display": {
                observe: "role",
                onGet: function onGet(role) {
                    return ManageUsersHelper.createRoleLabel(role.name);
                }
            }
        },

        events: {
            "click @ui.addUser": "_addUserClickHandler"
        },

        templateHelpers: function templateHelpers() {
            var company = LoggedInUserState.get("company");

            return {
                unconfirmed: this._unconfirmed,
                cannotAdd: Permissions.Roles.MANAGER.cannot(),
                adLogin: LoggedIn.ad(),
                companyName: company.get("name"),
                salesForceId: company.get("salesForceId"),
                hasMultipleUsers: this.collection && this.collection.size() > 1,
                startDate: this._startDate,
                endDate: this._endDate
            };
        },
        initialize: function initialize() {
            var _this2 = this;

            var principal = LoggedIn.principal();

            // Generate list of roles "principal" can assign to other users from the same company...
            var roles = [];
            // Do not bother with only Spectator role, since nothing to change then - looks better with just
            // the text then...
            if (Permissions.Roles.SPECTATOR.not(principal)) {
                Permissions.Roles.each(function (role) {
                    if (role.can(principal)) {
                        roles.push(role.name);
                    }
                });
            }

            this._unconfirmed = this._findUnconfirmedUser(principal);

            this.listenTo(this.collection, "change:role", function () {
                var unconfirmed = _this2._findUnconfirmedUser(principal);

                if (unconfirmed !== _this2._unconfirmed) {
                    _this2._unconfirmed = unconfirmed;
                    _this2.render();
                }
            });

            this.itemViewOptions = {
                principal: principal,
                roles: roles
            };
        },
        _addUserClickHandler: function _addUserClickHandler(event) {
            event.preventDefault();
            // FIXME Would be nice to get this logic in a ManageUsersViewController, so far no luck with it
            this.addNewUser();
        },


        /**
         * @private
         * Toggles active class on tabs and content.
         *
         * @param {String} tabName The tabName that should be activated.
         */
        _selectTab: function _selectTab(tabName) {
            this.ui.users.toggleClass("active", tabName === "users");
        },


        /**
         * Function for creating a new user, only Manager can do that.
         */
        addNewUser: function addNewUser() {
            var _this3 = this;

            if (Permissions.Roles.MANAGER.cannot()) {
                return;
            }

            var notifyUserCreation = function notifyUserCreation(user) {
                var userModel = new User(user);
                var msg = userModel.distinguishedName() + " has been added as a user to your company.";

                if (Permissions.Roles.SPECTATOR.not(userModel)) {
                    msg += " A confirmation email has been sent to " + userModel.get("username") + ".";
                }

                _this3.collection.add(userModel);
                NotificationBar.open(msg, { queue: false, closeDelay: 7500 });
                box.close();
            };

            var addUserOptions = {
                model: new User(),
                emails: this.collection.map(function (user) {
                    return user.get("username");
                }),
                cancelHandler: function cancelHandler() {
                    box.close();
                },
                okHandler: function okHandler(addUser) {
                    addUser().done(notifyUserCreation).fail(function (state) {
                        if (state !== SequentialButton.REJECT) {
                            // validation error, e.g. invalid email
                            box.close();
                        }
                    });
                }
            };

            var addUserView = new AddUserView(addUserOptions).render();

            var lightboxOptions = {
                css: {
                    width: 640
                },
                editorEventProperties: {
                    modalType: "AddUser",
                    username: this.model.get("username"),
                    triggerOrigin: "AddUserModal"
                }
            };

            var box = new Lightbox(addUserView.el, lightboxOptions);
            box.open();
        },
        _findUnconfirmedUser: function _findUnconfirmedUser(principal) {
            var unconfirmed = null;

            if (ConfirmationManager.confirmationRequired(principal.get("user"))) {
                unconfirmed = "your account";
            } else {
                this.collection.each(function (user) {
                    if (!unconfirmed && ConfirmationManager.confirmationRequired(user)) {
                        unconfirmed = user.get("displayName"); // TODO: how do I break out of this loop early?
                    }
                });
            }

            return unconfirmed;
        },
        onRender: function onRender() {
            if (Permissions.Roles.MANAGER.cannot()) {
                this.ui.currentUserPermissionsSelect.hide();
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorEvents = __webpack_require__(17),
        EmailUtil = __webpack_require__(231),
        ErrorHandler = __webpack_require__(119),
        ImprovedView = __webpack_require__(6),
        LoggedIn = __webpack_require__(31),
        Permissions = __webpack_require__(22),
        RestApi = __webpack_require__(29),
        SequentialButton = __webpack_require__(112),
        _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        SyncManager = __webpack_require__(44),
        template = __webpack_require__(3110),
        ValidateBehavior = __webpack_require__(96);

    /**
     * View for adding/creating a new Creator user.
     *
     * @class AddUserView
     * @constructor
     * @author Antonio Lagrotteria
     */
    return ImprovedView.extend({

        template: template,

        className: "add-user-view",

        title: "Add User",

        _addUser: null,

        ui: {
            name: ".name",
            email: ".email",
            role: ".roles",
            ok: ".ok"
        },

        bindings: {
            ".name": "name",
            ".email": "username"
        },

        events: {
            "click .ok": function clickOk() {
                this.options.okHandler(this._addUser);
            },
            "click .cancel": function clickCancel() {
                this.options.cancelHandler();
            }
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                buttonSubmit: ".ok",
                inputValidation: {
                    ".name": {
                        validator: function validator(name) {
                            return !isBlank(name);
                        },
                        errorText: "Name required"
                    },
                    ".email": {
                        validator: function validator(email) {
                            if (isBlank(email)) {
                                return false;
                            }

                            // Must be valid and must not be in use for the company...
                            var valid = EmailUtil.validateEmail(email);
                            return valid && this.options.emails.filter(function (e) {
                                return email === e;
                            }).length === 0;
                        },
                        errorText: function errorText(email) {
                            if (email) {
                                // If the email is here and it is a valid email, it means that the email is already in use.
                                return EmailUtil.validateEmail(email) ? "Email already in use" : "Not a valid email";
                            }

                            return "Email required";
                        }
                    },
                    ".roles": {
                        validator: function validator(role) {
                            return !isBlank(role);
                        },
                        errorText: "Role required"
                    }
                }
            }
        },

        /**
         * @private
         * Creates a new user based on validated form data.
         *
         * @return {Promise|*} A promise that will resolve to the created user, or <tt>SequentialButton.REJECT</tt>
         *                     if the form data is invalid; never null.
         */
        _createUser: function _createUser() {
            // Make sure the form is valid...
            if (!this.inputValidation()) {
                return SequentialButton.REJECT;
            }
            var name = this.ui.name.val(),
                email = this.ui.email.val(),
                role = this.ui.role.val();

            // We post a plain JSON object rather than using the more clean Backbone way for sending requests.
            // The reason is because privileges in the User model are computed, but do not get serialized by
            // the backend...
            return SyncManager.sync({
                method: "create-user",
                role: Permissions.Roles.MANAGER,
                fn: { // http
                    type: "POST",
                    url: RestApi.API_URL + "/" + RestApi.Collections.USERS + "/create",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify({
                        companyId: LoggedIn.companyId(),
                        name: name,
                        username: email,
                        role: role
                    })
                },

                resultHandler: function resultHandler(user) {
                    var eventProperties = {
                        name: name,
                        username: email,
                        role: role,
                        userCreationType: "creator",
                        triggerOrigin: "AddUserModalOkButton"
                    };

                    EditorEvents.trigger(EditorEvents.constants.CREATE_USER, eventProperties);

                    return user;
                },
                errorHandler: function (error) {
                    return this._handleError(name, email, error);
                }.bind(this)

            }, { toString: function toString() {
                    return email;
                } }).promise();
        },

        // Displays nice error in case email is in use (most common use case for 400 errors for users)...
        _handleError: function _handleError(name, email, error) {
            if (error.status === 400) {
                // bad request, i.e. user exist
                error.message = "&quot;" + email + "&quot; is already in use.";
            }

            // Resolve error message placeholders...
            ErrorHandler.inject(error, {
                method: "creation",
                name: "&quot;" + name + "&quot;",
                typeName: "User"
            });

            return "alert";
        },

        onRender: function onRender() {
            this._addUser = SequentialButton.add(this.ui.ok, this._createUser.bind(this), true, true);
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3110 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="form-controls add-user-lightbox">\n    <h2 class="header">Add User</h2>\n    <div class="row">\n        <div class="col-xs-6">\n            <input type="text" class="name" placeholder="Enter name">\n            <input type="text" class="email" placeholder="Enter email">\n        </div>\n        <div class="col-xs-6">\n            <select class="roles form-control">\n                <option value="">Choose role</option>\n                <option value="Spectator">Spectator</option>\n                <option value="Creator">Creator</option>\n                <option value="Publisher">Publisher</option>\n                <option value="Manager">Manager</option>\n            </select>\n        </div>\n    </div>\n\n    <div class="actions">\n        <button class="btn btn-not-valid pull-right ladda-button ok" data-spinner-size="28" data-style="expand-right">OK</button>\n        <button class="btn btn-secondary pull-right cancel">Cancel</button>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 3111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ConfirmationManager = __webpack_require__(339);

    var _require = __webpack_require__(120),
        DateUtil = _require.DateUtil;

    var EditorEvents = __webpack_require__(17);
    var ImprovedView = __webpack_require__(6);
    var ManageUsersHelper = __webpack_require__(1248);
    var ManageUsersItemViewController = __webpack_require__(3112);
    var Permissions = __webpack_require__(22);
    var template = __webpack_require__(3113);
    var Tooltip = __webpack_require__(35);

    /**
     * The item view for a single user in the manage users view.
     *
     * @class ManageUsersItemView
     * @constructor
     *
     * @cfg {User}      model     The user model backing this view.
     * @cfg {Principal} principal The currently logged in principal (which may or may not be a principal for the configured user).
     * @cfg {String[]}  roles     The list of role names the principal can assign to other users in the same company.
     */
    return ImprovedView.extend({

        className: "user-profile",

        template: template,

        controller: ManageUsersItemViewController,

        templateHelpers: function templateHelpers() {
            return {
                isLoggedInUser: this._isLoggedInUser,
                accessedAt: this._accessedAt
            };
        },


        events: {
            "click .delete": "_deleteUser"
        },

        ui: {
            userPermissionsDisplay: ".user-permissions-display",
            userPermissionsChangeOptions: ".user-permissions-change-options",
            delete: ".delete"
        },

        bindings: {
            ".user-name": "displayName",
            ".accessed-at": {
                observe: "accessedAt",
                onGet: function onGet(date) {
                    return "Last login: " + (date ? DateUtil.formatYYYYMMDDHHmm(date) : "Never");
                }
            },
            ".user-confirmed": {
                observe: "confirmedAt",
                onGet: function onGet() {
                    if (ConfirmationManager.confirmationRequired(this.model)) {
                        return "(Unconfirmed)";
                    }
                }
            },
            ".user-email": "username",
            ".user-permissions-display": {
                observe: "role",
                onGet: function onGet(role) {
                    return ManageUsersHelper.createRoleLabel(role.name);
                }
            },
            ".user-permissions-select": {
                observe: "role",
                selectOptions: {
                    collection: function collection() {
                        return ManageUsersHelper.mapRoles(this.options.roles);
                    },

                    labelPath: "roleLabel",
                    valuePath: "role"
                }
            }
        },

        modelEvents: {
            "change:role": function changeRole() {
                // See ManageUsersItemViewController
                this.trigger("roleChanged");
            }
        },

        _isLoggedInUser: null,
        _role: null,
        _accessedAt: null,

        initialize: function initialize() {
            var principal = this.options.principal;
            // Logged in principal for same user as the model user for this item view?
            this._isLoggedInUser = principal.forUser(this.model);
            // Already assigned role for the user backing this view...
            this._role = this.model.get("role");
            this._accessedAt = principal.get("type") === "AD";
        },
        onRender: function onRender() {
            // Does the principal have access to the role of the user, i.e. can the principal change the role of
            // the given user? In addition, a user cannot changer her own permissions...
            if (this._isLoggedInUser || !this.options.roles.length || this.options.principal.cannot(this.model)) {
                this.ui.userPermissionsChangeOptions.hide();
            } else {
                this.ui.userPermissionsDisplay.hide();
            }

            this.ui.delete.toggleClass("hidden", !Permissions.Roles.MANAGER.can());

            if (this._isLoggedInUser) {
                this.$el.addClass("current-user");
            }
        },
        onShow: function onShow() {
            if (this.ui.delete.is(":visible")) {
                Tooltip.add(this.ui.delete, {
                    placement: "top",
                    width: 200
                });
            }
        },
        _deleteUser: function _deleteUser() {
            var _this = this;

            var name = this.model.get("displayName");
            var role = this.model.get("role").name;
            var username = this.model.get("username");
            var promptMessage = "Are you sure you want to permanently delete " + name + "? The user will no longer be able to login";
            if (confirm(promptMessage)) {
                return this.model.destroy({ wait: true }).then(function () {
                    var eventProperties = {
                        name: name,
                        username: username,
                        role: role,
                        userCreationType: "creator",
                        triggerOrigin: "DeleteUserConfirmOkButton"
                    };

                    EditorEvents.trigger(EditorEvents.constants.DELETE_USER, eventProperties);

                    return _this.model;
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var EditorEvents = __webpack_require__(17),
        ErrorHandler = __webpack_require__(119),
        NotificationBar = __webpack_require__(53),
        Permissions = __webpack_require__(22),
        RestApi = __webpack_require__(29),
        SyncManager = __webpack_require__(44),
        ViewController = __webpack_require__(126);

    /**
     * <tt>ViewController</tt> for the <tt>ManageUsersItemView</tt>.
     *
     * Responsible for handling role/privilege changes.
     *
     * @see  ManageUsersView
     * @author Kim
     */
    return ViewController.extend({

        /**
         * Invoked when the view (<tt>ManageUsersItemView</tt>) triggers a <tt>roleChanged</tt> event.
         */
        onViewRoleChanged: function onViewRoleChanged() {
            var self = this,
                scope = this.view,
                role = scope.model.get("role"),
                old = scope._role;

            if (old === role) {
                return;
            }

            var displayName = scope.model.get("displayName");

            scope._role = role;

            // Privilege changes need to be saved through a separate endpoint. Note that the model id of that
            // of the specific user, not of the currently logged in principal...
            SyncManager.sync({
                method: "update-permissions",
                role: Permissions.Roles.CREATOR, // must be at least a creator to update other users
                fn: {
                    url: RestApi.pathToCollectionOnResource(RestApi.Collections.USERS, scope.model.get("id"), "permissions"),
                    type: "PUT",
                    contentType: "text/plain",
                    data: role.name
                },
                errorHandler: function (error) {
                    return this._handleError(displayName, error);
                }.bind(this)

            }, scope.model).promise().done(function () {
                var msg = ".";
                if (!scope.model.isConfirmed() && Permissions.Roles.SPECTATOR.not(role)) {
                    // Spectator is the default when unconfirmed
                    msg += " The role will not take affect until the user is confirmed.";
                }
                NotificationBar.open("The role for " + displayName + " has been updated from " + old.name + " to " + role.name + msg, { queue: false, closeDelay: 10000 });

                // To ensure we update the display name for any user now confirmed, or any user not confirmed
                // being downgraded to Spectator...
                scope.render();

                var eventProperties = {
                    userId: self.model.get("id"),
                    username: self.model.get("username"),
                    oldRole: old.name,
                    newRole: role.name,
                    updatedProperty: "role",
                    updatedValue: role.name,
                    triggerOrigin: "UserPermissionsSelect"
                };

                EditorEvents.trigger(EditorEvents.constants.UPDATE_USER, eventProperties);
            }).fail(function () {
                // Make sure we set the old role on this view before we update the model, or we would try and
                // update with the old role...
                scope._role = old;
                scope.model.set("role", old); // Ensure we display the old role on failure...
            });
        },

        _handleError: function _handleError(displayName, error) {
            // Resolve error message placeholders...
            ErrorHandler.inject(error, {
                method: "update",
                name: "the role for " + displayName,
                typeName: "User"
            });
            return "alert";
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3113 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(!isLoggedInUser) {  ;
__p += '\n    <span class="user-color" style="background:' +
__e( backgroundColor ) +
'"></span>\n    <ul class="info-user">\n        <li class="user-name">Name here</li>\n        <li class="user-confirmed">Unconfirmed status here</li>\n        <li class="user-email">Email here</li>\n        ';
 if (accessedAt) { ;
__p += '\n            <li class="accessed-at"></li>\n        ';
 } ;
__p += '\n    </ul>\n\n    <div class="info-permission">\n        <div class="user-permissions-change-options">\n            <select class="user-permissions-select form-control"></select>\n            <div class="actions-panel">\n                <span class="delete hidden" data-content="Permanently delete this user from the company" data-original-title="" title=""></span>\n            </div>\n        </div>\n        <input type="text" class="user-permissions-display" disabled readonly/>\n    </div>\n';
 }  ;
__p += '\n';

}
return __p
}

/***/ }),
/* 3114 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="tabs">\n    <span class="tab users active">Users</span>\n</div>\n<div class="tab-pane users active">\n    <section class="current-user">\n        <h4>Your Profile</h4>\n        <div class="user-profile">\n            <span class="user-color" style="background:' +
__e( backgroundColor ) +
'"><span class="you">You</span></span>\n            <ul class="info-user current-user-profile">\n                <li class="details editable-container">\n                    <div class="current-user-name editable" contenteditable="true"></div>\n                </li>\n                <li class="current-user-email">Email here</li>\n                ';
 if (adLogin) { ;
__p += '\n                    <li class="current-accessed-at"></li>\n                ';
 } ;
__p += '\n                <li class="current-user-company">' +
__e( companyName) +
'</li>\n                ';
 if (adLogin && salesForceId) { ;
__p += '\n                    <li>' +
__e( salesForceId) +
'</li>\n                ';
 } ;
__p += '\n            </ul>\n\n            <div class="info-permission">\n                <input type="text" class="current-user-permissions-display" disabled readonly />\n            </div>\n\n            <div class="clearfix"></div>\n        </div>\n    </section>\n\n    <section class="other-users">\n        ';
 if (hasMultipleUsers) { ;
__p += '\n            <section class="header">\n                <h4>' +
__e( companyName) +
' Users</h4>\n                <button class="btn btn-secondary btn-add-user';
 if (cannotAdd) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (cannotAdd) { ;
__p += ' disabled';
 } ;
__p += '>&#43; Add User</button>\n            </section>\n        ';
 } else { ;
__p += '\n            <button class="btn btn-secondary btn-add-user';
 if (cannotAdd) { ;
__p += ' disabled';
 } ;
__p += '"';
 if (cannotAdd) { ;
__p += ' disabled';
 } ;
__p += '>&#43; Add User</button>\n        ';
 } ;
__p += '\n        <section id="users"></section>\n    </section>\n\n    ';
 if (unconfirmed) { ;
__p += '\n    <section class="unconfirmed">\n        <span>An unconfirmed user, e.g. <strong>' +
__e(unconfirmed) +
'</strong>, will always be a Spectator until the user\'s identity has been confirmed.<br><br></span>\n    </section>\n    ';
 } ;
__p += '\n</div>\n';

}
return __p
}

/***/ }),
/* 3115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var PSDImportView = __webpack_require__(3116),
        Marionette = __webpack_require__(10);

    return Marionette.Controller.extend({

        showPSDImport: function showPSDImport() {
            this.options.region.show(new PSDImportView());
        }

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var SettingsView = __webpack_require__(230);
    var template = __webpack_require__(3117);
    var PSDImportConstants = __webpack_require__(3118);
    var EditorWebFontController = __webpack_require__(176);
    var CharacterPropertiesViewControllerHelpers = __webpack_require__(408);

    return SettingsView.extend({
        template: template,

        templateHelpers: function templateHelpers() {
            return {
                psdImportBaseUrl: {"env":"PROD","cncViewFullBaseUrl":"https://cnc-api.zmags.com/view/full/","cncViewLiteBaseUrl":"https://cnc-api.zmags.com/view/lite/","psdImportBaseUrl":"https://design-file-import.creator-prod.zmags.com","behaviorUiBaseUrl":"https://behaviors.zmags.com","creatorSettingApiBaseUrl":"https://creator-settings.api.zmags.com","c3ApibaseUrl":"https://contentcontrol.api.zmags.com","adminApiBaseUrl":"https://creator-api.zmags.com","editorBaseUrl":"//creator.zmags.com","viewerBaseUrl":"//c.zmags.com","viewerApiBaseUrl":"//c.zmags.com","cncStaticAssetsBaseUrl":"//c.zmags.com/static/","cncStaticAssetsFiles":["client.js","manifest.js","vendor.js","styles.css"],"cncSsrApiBaseUrl":"//c.zmags.com","viewerAliasApiBaseUrl":"//creator.zmags.com","communityBaseUrl":"https://creatorcommunity.zmags.com","errorQueueUrl":"https://c.zmags.com/queue/error/","statsDUrl":"https://statsd.zmags.com/stats","auth0Domain":"https://zmags.us.auth0.com","auth0Audience":"https://api.zmags.com/","auth0ClientId":"XGTeepJiX2c78VRgP8OFxN0Mf4kggvby","ometriaApiUrl":"https://ometria.api.zmags.com/v1/email/generate","klaviyoApiUrl":"https://klaviyo.api.zmags.com/v1/email/generate","sfmcApiUrl":"https://sfmc.api.zmags.com/v1/email/generate","cloudinaryProviderUrl":"https://images.creator-prod.zmags.com/image/upload","salesEmail":"sales@zmags.com","supportEmail":"support@zmags.com","editorSegmentIOKey":"20jbiv8frx","matomoConfig":{"trackingScriptUrl":"//c.z-analytics.net/reporting/optimize/ztracker.js","trackerUrl":"","dashboardUrl":"//auth.reporting.creator-prod.zmags.com","segmentUrl":"//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php","siteID":1},"zsitesConfig":"//auth.reporting.creator-prod.zmags.com/","zsitesSecret":"zM4gzS3cr3t","inventoryUrl":"https://authproxy.creator-prod.zmags.com/inventory/v1/products/map","answerFileUrl":"https://static.inventory.creator-prod.zmags.com/dynamic_pricing/answer_files/","experienceUrl2PngBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/experience/signed/url2png/","experienceSharedEntityBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/sharedEntity/","msExperiencesUrl":"https://authproxy.creator-prod.zmags.com/experiences","microserviceCompanyUrl":"https://authproxy.creator-prod.zmags.com/company/","proxyUrl":"https://authproxy.creator-prod.zmags.com","forgotPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","resetPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","changePasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithTokenBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithSsoBaseUrl":"https://authproxy.creator-prod.zmags.com","loginActiveDirectoryBaseUrl":"https://creator-api.zmags.com","googleWebFontsApiBaseUrl":"https://www.googleapis.com/webfonts/v1/webfonts","googleWebFontsApiKey":"AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI","casUrl":"https://cas.zma.gs/","contentControlUrl":"https://manage.creatorbyzmags.com/","enableLogging":1,"logId":null,"trackErrors":true,"sentryEnabled":true,"sentryDSN":"https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460","experienceId":null,"groupId":null,"scene":null,"statsDBucket":"creator.prod","version":"livadug4","maxRetries":3}.psdImportBaseUrl
            };
        },


        ui: {
            iframe: ".psd-import-iframe"
        },

        initialize: function initialize() {
            window.addEventListener("message", this._handleMessage.bind(this), false);

            if (EditorWebFontController.promise()) {
                this._handleFontCollection();
            } else {
                EditorWebFontController.start();
                this.listenTo(EditorWebFontController, "fontsLoaded", this._handleFontCollection);
            }
        },
        _handleFontCollection: function _handleFontCollection() {
            EditorWebFontController.promise().then(function (results) {
                CharacterPropertiesViewControllerHelpers._fontCollection = results;
            });
        },
        _handleMessage: function _handleMessage(event) {
            var data = event.data;
            var type = data.type,
                messageData = data.data;

            switch (type) {
                case PSDImportConstants.INITIALISATION_MESSAGE_TYPE:
                    this._handleInitialisation();
                    break;
                case PSDImportConstants.FONT_QUERY_MESSAGE_TYPE:
                    this._handleFontQuery(messageData);
                    break;
                default:
                    break;
            }
        },
        _handleInitialisation: function _handleInitialisation() {
            var win = window.frames.psdImport;

            var _JSON$parse = JSON.parse(localStorage.getItem("zmags_login")),
                token = _JSON$parse.token;

            if (token) {
                win.postMessage({ type: "token", token: token }, {"env":"PROD","cncViewFullBaseUrl":"https://cnc-api.zmags.com/view/full/","cncViewLiteBaseUrl":"https://cnc-api.zmags.com/view/lite/","psdImportBaseUrl":"https://design-file-import.creator-prod.zmags.com","behaviorUiBaseUrl":"https://behaviors.zmags.com","creatorSettingApiBaseUrl":"https://creator-settings.api.zmags.com","c3ApibaseUrl":"https://contentcontrol.api.zmags.com","adminApiBaseUrl":"https://creator-api.zmags.com","editorBaseUrl":"//creator.zmags.com","viewerBaseUrl":"//c.zmags.com","viewerApiBaseUrl":"//c.zmags.com","cncStaticAssetsBaseUrl":"//c.zmags.com/static/","cncStaticAssetsFiles":["client.js","manifest.js","vendor.js","styles.css"],"cncSsrApiBaseUrl":"//c.zmags.com","viewerAliasApiBaseUrl":"//creator.zmags.com","communityBaseUrl":"https://creatorcommunity.zmags.com","errorQueueUrl":"https://c.zmags.com/queue/error/","statsDUrl":"https://statsd.zmags.com/stats","auth0Domain":"https://zmags.us.auth0.com","auth0Audience":"https://api.zmags.com/","auth0ClientId":"XGTeepJiX2c78VRgP8OFxN0Mf4kggvby","ometriaApiUrl":"https://ometria.api.zmags.com/v1/email/generate","klaviyoApiUrl":"https://klaviyo.api.zmags.com/v1/email/generate","sfmcApiUrl":"https://sfmc.api.zmags.com/v1/email/generate","cloudinaryProviderUrl":"https://images.creator-prod.zmags.com/image/upload","salesEmail":"sales@zmags.com","supportEmail":"support@zmags.com","editorSegmentIOKey":"20jbiv8frx","matomoConfig":{"trackingScriptUrl":"//c.z-analytics.net/reporting/optimize/ztracker.js","trackerUrl":"","dashboardUrl":"//auth.reporting.creator-prod.zmags.com","segmentUrl":"//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php","siteID":1},"zsitesConfig":"//auth.reporting.creator-prod.zmags.com/","zsitesSecret":"zM4gzS3cr3t","inventoryUrl":"https://authproxy.creator-prod.zmags.com/inventory/v1/products/map","answerFileUrl":"https://static.inventory.creator-prod.zmags.com/dynamic_pricing/answer_files/","experienceUrl2PngBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/experience/signed/url2png/","experienceSharedEntityBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/sharedEntity/","msExperiencesUrl":"https://authproxy.creator-prod.zmags.com/experiences","microserviceCompanyUrl":"https://authproxy.creator-prod.zmags.com/company/","proxyUrl":"https://authproxy.creator-prod.zmags.com","forgotPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","resetPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","changePasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithTokenBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithSsoBaseUrl":"https://authproxy.creator-prod.zmags.com","loginActiveDirectoryBaseUrl":"https://creator-api.zmags.com","googleWebFontsApiBaseUrl":"https://www.googleapis.com/webfonts/v1/webfonts","googleWebFontsApiKey":"AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI","casUrl":"https://cas.zma.gs/","contentControlUrl":"https://manage.creatorbyzmags.com/","enableLogging":1,"logId":null,"trackErrors":true,"sentryEnabled":true,"sentryDSN":"https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460","experienceId":null,"groupId":null,"scene":null,"statsDBucket":"creator.prod","version":"livadug4","maxRetries":3}.psdImportBaseUrl);
            }
        },
        _handleFontQuery: function _handleFontQuery(query) {
            CharacterPropertiesViewControllerHelpers._fontSelectorQuery({
                term: query,
                callback: function callback(fonts) {
                    var fontFamilyOptions = fonts.results.map(function (provider) {
                        return {
                            label: provider.text,
                            options: provider.children.map(function (fontProvider) {
                                return {
                                    label: fontProvider.text,
                                    value: fontProvider.text,
                                    fontDescriptor: fontProvider.fontDescriptor
                                };
                            })
                        };
                    });

                    var win = window.frames.psdImport;
                    // is forbidden to send reference data types via postMessage method
                    win.postMessage({ type: "fonts", fonts: JSON.stringify(fontFamilyOptions) }, {"env":"PROD","cncViewFullBaseUrl":"https://cnc-api.zmags.com/view/full/","cncViewLiteBaseUrl":"https://cnc-api.zmags.com/view/lite/","psdImportBaseUrl":"https://design-file-import.creator-prod.zmags.com","behaviorUiBaseUrl":"https://behaviors.zmags.com","creatorSettingApiBaseUrl":"https://creator-settings.api.zmags.com","c3ApibaseUrl":"https://contentcontrol.api.zmags.com","adminApiBaseUrl":"https://creator-api.zmags.com","editorBaseUrl":"//creator.zmags.com","viewerBaseUrl":"//c.zmags.com","viewerApiBaseUrl":"//c.zmags.com","cncStaticAssetsBaseUrl":"//c.zmags.com/static/","cncStaticAssetsFiles":["client.js","manifest.js","vendor.js","styles.css"],"cncSsrApiBaseUrl":"//c.zmags.com","viewerAliasApiBaseUrl":"//creator.zmags.com","communityBaseUrl":"https://creatorcommunity.zmags.com","errorQueueUrl":"https://c.zmags.com/queue/error/","statsDUrl":"https://statsd.zmags.com/stats","auth0Domain":"https://zmags.us.auth0.com","auth0Audience":"https://api.zmags.com/","auth0ClientId":"XGTeepJiX2c78VRgP8OFxN0Mf4kggvby","ometriaApiUrl":"https://ometria.api.zmags.com/v1/email/generate","klaviyoApiUrl":"https://klaviyo.api.zmags.com/v1/email/generate","sfmcApiUrl":"https://sfmc.api.zmags.com/v1/email/generate","cloudinaryProviderUrl":"https://images.creator-prod.zmags.com/image/upload","salesEmail":"sales@zmags.com","supportEmail":"support@zmags.com","editorSegmentIOKey":"20jbiv8frx","matomoConfig":{"trackingScriptUrl":"//c.z-analytics.net/reporting/optimize/ztracker.js","trackerUrl":"","dashboardUrl":"//auth.reporting.creator-prod.zmags.com","segmentUrl":"//onboarding.reporting.creator-prod.zmags.com/SegmentCreation.php","siteID":1},"zsitesConfig":"//auth.reporting.creator-prod.zmags.com/","zsitesSecret":"zM4gzS3cr3t","inventoryUrl":"https://authproxy.creator-prod.zmags.com/inventory/v1/products/map","answerFileUrl":"https://static.inventory.creator-prod.zmags.com/dynamic_pricing/answer_files/","experienceUrl2PngBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/experience/signed/url2png/","experienceSharedEntityBaseUrl":"https://authproxy.creator-prod.zmags.com/experiences/v1/sharedEntity/","msExperiencesUrl":"https://authproxy.creator-prod.zmags.com/experiences","microserviceCompanyUrl":"https://authproxy.creator-prod.zmags.com/company/","proxyUrl":"https://authproxy.creator-prod.zmags.com","forgotPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","resetPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","changePasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithTokenBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithPasswordBaseUrl":"https://authproxy.creator-prod.zmags.com","loginWithSsoBaseUrl":"https://authproxy.creator-prod.zmags.com","loginActiveDirectoryBaseUrl":"https://creator-api.zmags.com","googleWebFontsApiBaseUrl":"https://www.googleapis.com/webfonts/v1/webfonts","googleWebFontsApiKey":"AIzaSyBxV3A9pK4DwgaCBN3bXlU6HTTe86cz5WI","casUrl":"https://cas.zma.gs/","contentControlUrl":"https://manage.creatorbyzmags.com/","enableLogging":1,"logId":null,"trackErrors":true,"sentryEnabled":true,"sentryDSN":"https://a57bc1d597814a1f91c36f3b74cce2ed@o224008.ingest.sentry.io/5320460","experienceId":null,"groupId":null,"scene":null,"statsDBucket":"creator.prod","version":"livadug4","maxRetries":3}.psdImportBaseUrl);
                }
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3117 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="design-transform-section">\n    <div class="iframe-container">\n        <iframe src="' +
__e( psdImportBaseUrl ) +
'" name="psdImport"></iframe>\n    </div>\n<div>\n';

}
return __p
}

/***/ }),
/* 3118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!(module.exports = {
    INITIALISATION_MESSAGE_TYPE: "initialisation",
    FONT_QUERY_MESSAGE_TYPE: "fontQuery"
});

/***/ }),
/* 3119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        debounce = _require.debounce;

    var $ = __webpack_require__(4);
    var EditorEvents = __webpack_require__(17);
    var EditorWebFontController = __webpack_require__(176);
    var FontProvider = __webpack_require__(103);
    var FontsDotComApi = __webpack_require__(875);
    var FontsDotComIntegrationModel = __webpack_require__(403);

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var ManageFontsIntegrationView = __webpack_require__(3120);
    var Marionette = __webpack_require__(10);

    var _require3 = __webpack_require__(30),
        isBlank = _require3.isBlank;

    var SystemMessages = __webpack_require__(107);
    var TypekitApi = __webpack_require__(876);
    var TypekitIntegrationModel = __webpack_require__(407);

    var logger = new Logger("ManageFontsController");

    var FONTS_DOT_COM = "Fonts.com";
    var TYPEKIT = "Typekit";

    return Marionette.Controller.extend({
        showManageFonts: function showManageFonts(integrations) {
            var view = new ManageFontsIntegrationView({ integrations: integrations });
            var debouncedSaveIntegration = debounce(this._integrationChangedHandler, 1000).bind(this);

            this.options.region.show(view);

            // Listen to validated changes...
            this.listenTo(view, "validated", function (model) {
                debouncedSaveIntegration(model);
            });
        },


        /**
         * @private
         *
         * Callback when a potential valid Typekit Api token has been entered, which
         * performs actual token validation and font cleanup.
         */
        _integrationChangedHandler: function _integrationChangedHandler(model) {
            if (model instanceof FontsDotComIntegrationModel) {
                this._saveFontsDotComIntegration(model);
            } else if (model instanceof TypekitIntegrationModel) {
                this._saveTypekitIntegration(model);
            } else {
                logger.error("Invalid fonts integration passed.", model);
            }
        },
        _saveFontsDotComIntegration: function _saveFontsDotComIntegration(fontsDotComIntegration) {
            var authenticationKey = fontsDotComIntegration.get("authenticationKey");

            if (isBlank(authenticationKey)) {
                fontsDotComIntegration.save().then(function () {
                    EditorWebFontController.clearFontType(FontProvider.FONTS_DOT_COM);
                    SystemMessages.ManageFonts.removedKey(FONTS_DOT_COM, "authentication key");

                    var eventProperties = {
                        category: "Fonts",
                        integrationType: FONTS_DOT_COM,
                        triggerOrigin: "ApiTokenInputField"
                    };

                    EditorEvents.trigger(EditorEvents.constants.DELETE_INTEGRATION, eventProperties);
                });
                return;
            }

            this._validateFontsDotComAuthenticationKey(authenticationKey).then(function (valid) {
                if (valid) {
                    logger.info("Fonts.com authentication key is valid.");
                    fontsDotComIntegration.save().then(function () {
                        SystemMessages.ManageFonts.validKey(FONTS_DOT_COM, "authentication key", "fontsDotCom:valid:authenticationKey");
                        EditorWebFontController.reloadFonsDotComFonts();
                    });

                    var eventProperties = {
                        category: "Fonts",
                        integrationType: FONTS_DOT_COM,
                        triggerOrigin: "ApiTokenInputField"
                    };

                    EditorEvents.trigger(EditorEvents.constants.SAVE_INTEGRATION, eventProperties);
                } else {
                    SystemMessages.ManageFonts.invalidKey(FONTS_DOT_COM, "authentication key", authenticationKey, "fontsDotCom:valid:authenticationKey");
                }
            });
        },
        _saveTypekitIntegration: function _saveTypekitIntegration(typekitIntegration) {
            var typekitToken = typekitIntegration.get("typekitApiToken");

            if (isBlank(typekitToken)) {
                typekitIntegration.save().then(function () {
                    EditorWebFontController.clearFontType(FontProvider.TYPEKIT);
                    SystemMessages.ManageFonts.removedKey(TYPEKIT, "API token");

                    var eventProperties = {
                        category: "Fonts",
                        integrationType: TYPEKIT,
                        triggerOrigin: "ApiTokenInputField"
                    };

                    EditorEvents.trigger(EditorEvents.constants.DELETE_INTEGRATION, eventProperties);
                });
                return;
            }

            // Validate token before loading anything
            this._validateTypekitToken(typekitToken).then(function (valid) {
                if (valid) {
                    logger.info("Token is valid - fetching Typekit data");
                    typekitIntegration.save().then(function () {
                        SystemMessages.ManageFonts.validKey(TYPEKIT, "API token", "typekit:valid:token");
                        EditorWebFontController.reloadKits(typekitToken);

                        var eventProperties = {
                            category: "Fonts",
                            integrationType: TYPEKIT,
                            triggerOrigin: "ApiTokenInputField"
                        };

                        EditorEvents.trigger(EditorEvents.constants.SAVE_INTEGRATION, eventProperties);
                    });
                } else {
                    SystemMessages.ManageFonts.invalidKey(TYPEKIT, "API token", typekitToken, "typekit:valid:token");
                }
            });
        },
        _validateFontsDotComAuthenticationKey: function _validateFontsDotComAuthenticationKey(authenticationKey) {
            return new $.Deferred(function (deferred) {
                var failed = function failed() {
                    deferred.resolve(false);
                };

                FontsDotComApi.validate(authenticationKey).then(function (value) {
                    if (value && value.errors) {
                        failed();
                    } else {
                        deferred.resolve(true);
                    }
                }).fail(failed);
            }).promise();
        },


        /**
         * @private
         *
         * Validates the specified Typekit API token, by performing an API request, that if proves
         * successful, resolves the returned promise with a boolean value of <tt>true</tt>, otherwise <tt>false</tt>.
         *
         * @param  {String} token The API token.
         * @return {Promise} A promise the resolves to either <tt>true</tt> or <tt>false</tt>.
         */
        _validateTypekitToken: function _validateTypekitToken(token) {
            return new $.Deferred(function (deferred) {
                var typekitApi = new TypekitApi(token),
                    failed = function failed() {
                    deferred.resolve(false);
                };

                typekitApi.kits().then(function (value) {
                    if (value && value.errors) {
                        failed();
                    } else {
                        deferred.resolve(true);
                    }
                }).fail(failed);
            }).promise();
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1);
    var $ = __webpack_require__(4);
    var Enum = __webpack_require__(77);
    var FontsDotComIntegrationModel = __webpack_require__(403);
    var CustomFontIntegrationModel = __webpack_require__(562);
    var ManageFontsDotComIntegrationView = __webpack_require__(3121);
    var ManageTypekitIntegrationView = __webpack_require__(3123);
    var ManageCustomFontsIntegrationView = __webpack_require__(3125);
    var Marionette = __webpack_require__(10);
    var SettingsView = __webpack_require__(230);
    var template = __webpack_require__(3132);
    var TypekitIntegrationModel = __webpack_require__(407);

    // TODO MOS-2555: Add proper tab support to the SettingsView or introduce a concrete "TabbedView".

    var Tab = function Tab(name, slug, integration, viewClass, sortOrder) {
        this.name = name;
        this.slug = slug;
        this.integration = integration;
        this.viewClass = viewClass;
        this.sortOrder = sortOrder;
        this.active = false;
    };

    var Tabs = Enum.create("Tab", {

        CUSTOM_FONTS: new Tab("Custom", "custom-fonts", CustomFontIntegrationModel, ManageCustomFontsIntegrationView, 1),

        TYPEKIT: new Tab("Typekit", "typekit", TypekitIntegrationModel, ManageTypekitIntegrationView, 2),

        FONTS_DOT_COM: new Tab("Fonts.com", "fonts-dot-com", FontsDotComIntegrationModel, ManageFontsDotComIntegrationView, 3)

    }, {
        fromIntegration: function fromIntegration(integrationConstructor) {
            return this.each(function (tab) {
                if (tab.integration === integrationConstructor) {
                    return tab;
                }
            });
        }
    });

    /**
     * Manages font integrations configurations.
     *
     * @class ManageFontsIntegrationView
     */
    return SettingsView.extend("ManageFontsIntegrationView", {

        className: SettingsView.prototype.className + " fonts-view",

        template: template,

        ui: {
            tabs: ".tab",
            integrationsContainer: ".integrations-container"
        },

        regions: function regions() {
            return _.extend(SettingsView.prototype.regions, {
                integrationsRegion: ".integrations-region"
            });
        },


        _tabs: null,

        _regions: null,

        _children: null,

        initialize: function initialize() {
            this._tabs = this._createTabs();
        },
        onRender: function onRender() {
            var _this = this;

            this._regions = [];
            this._children = [];

            this._tabs.forEach(function (tab) {
                var $regionElement = $("<div></div>").prependTo(_this.ui.integrationsContainer);

                var region = new Marionette.Region({ el: $regionElement });
                var View = tab.viewClass;
                var model = _this._getIntegrationModel(tab.integration);

                var view = new View({ model: model });
                view.$el.addClass(tab.slug);

                view.active(tab.active);

                _this.listenTo(view, "change", _this._viewChangeHandler);

                region.show(view);

                _this._regions.push(region);
                _this._children.push(view);
            });
        },


        events: {
            "click @ui.tabs": "_tabSelectionHandler"
        },

        templateHelpers: function templateHelpers() {
            return {
                tabs: this._tabs
            };
        },
        _createTabs: function _createTabs() {
            var integrations = this.options.integrations.slice(0);

            var tabs = integrations.map(function (fontIntegration) {
                return Tabs.fromIntegration(fontIntegration.constructor);
            }).sort(function (a, b) {
                return a.sortOrder > b.sortOrder;
            });

            tabs[0].active = true;

            return tabs;
        },
        _getIntegrationModel: function _getIntegrationModel(integrationClass) {
            return _.find(this.options.integrations, function (integrationModel) {
                return integrationModel instanceof integrationClass;
            });
        },
        _viewChangeHandler: function _viewChangeHandler($el, value, view) {
            this.trigger("validated", view.model);
        },


        /**
         * @private
         *
         * Handles tab clicks and calls to select the tab.
         *
         * @param {Event} event The click event
         */
        _tabSelectionHandler: function _tabSelectionHandler(event) {
            this.ui.tabs.removeClass("active");

            var $tabElement = $(event.currentTarget);
            var slug = $tabElement.attr("data-tab");

            $tabElement.addClass("active");

            this._children.forEach(function (view) {
                view.active(view.$el.hasClass(slug));
            });
        },
        onClose: function onClose() {
            this.__super();

            _.invoke(this._regions, "close");
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        Permissions = __webpack_require__(22),
        _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        SystemMessages = __webpack_require__(107),
        template = __webpack_require__(3122),
        ValidateBehavior = __webpack_require__(96);


    return ImprovedView.extend("ManageFontsDotComIntegrationView", {

        className: "tab-pane",

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                permissionToManage: Permissions.Privileges.ADMIN.can()
            };
        },

        bindings: {
            ".jsFontsDotComAuthenticationKeyInput": {
                observe: "authenticationKey"
            }
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    ".jsFontsDotComAuthenticationKeyInput": {
                        validateAfter: "beforeSubmit",
                        // Mark as bound to model, so make sure we cancel pending save requests on error!
                        model: true,
                        validator: function validator(key) {
                            var re121hexadecimalsOrDashes = /^[0-9a-fA-F-]{121,121}$/;
                            return isBlank(key) || re121hexadecimalsOrDashes.test(key);
                        },
                        validatorAsync: {
                            "fontsDotCom:valid:key": {
                                source: SystemMessages,
                                validator: function validator(valid) {
                                    return valid;
                                }
                            }
                        },
                        errorText: function errorText() /* value, type */{
                            return "This is not a valid Fonts.com authentication key.";
                        }
                    }
                }
            }
        },

        active: function active(state) {
            this.$el.toggleClass("active", state);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3122 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="row">\n    <section class="col-xs-4">\n        <p class="intro">With Creator’s Fonts.com integration you are able to use all your favorite, high quality fonts from your Fonts.com account in your Creator Experiences.</p>\n        <p>This will allow you to choose between Fonts.com\'s high quality font families or add custom fonts to enhance brand expression, improve quality of visual appearance and align user experience between your website and your Experiences.</p>\n    </section>\n    <section class="col-xs-4">\n        <h4>1. Copy your Fonts.com Authentication Key</h4>\n        <p>Copy the authentication key from the manage account page on your Fonts.com account and paste it in the field below. If no such authentication key is present, generate and save one.</p>\n        <div class="api-token">\n            <div class="form-group">\n                <label>Fonts.com authentication key:</label>\n                <textarea class="fonts-dot-com-authentication-key jsFontsDotComAuthenticationKeyInput" ';
 if (!permissionToManage) { ;
__p += 'disabled';
 } ;
__p += '></textarea>\n            </div>\n        </div>\n        <span class="help-block">You can find your authentication key here: <a href="https://www.fonts.com/account" target="_blank">https://www.fonts.com/account</a></span>\n    </section>\n    <section class="col-xs-4">\n        <h4>2. Insert Creator\'s Domain</h4>\n        <p>Insert both Creator\'s domain [*.zmags.com] and your own domain into the "Add and Edit Domains" control for the Projects you intend to use with Creator.</p>\n        <span class="help-block">You can find the "Add & Edit Domains" field in the manage web fonts section by selecting the project and clicking on the "Add and Edit Domains" option.</span>\n    </section>\n</div>\n<div class="row">\n    <section class="col-xs-4">\n        <div class="notification-box">\n            <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">Maximize load speed!</span>\n            <p>Minimize the number of different fonts.com projects used in your experience. Setting up a single fonts.com project with the fonts in your experience will improve performance.</p>\n        </div>\n    </section>\n    <section class="col-xs-4">\n        <div class="illustration illustration-fonts-dot-com-authentication-key"></div>\n    </section>\n    <section class="col-xs-4">\n        <div class="illustration illustration-fonts-dot-com-domain"></div>\n    </section>\n</div>\n';

}
return __p
}

/***/ }),
/* 3123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        Permissions = __webpack_require__(22),
        _require = __webpack_require__(30),
        isBlank = _require.isBlank,
        SystemMessages = __webpack_require__(107),
        template = __webpack_require__(3124),
        ValidateBehavior = __webpack_require__(96);


    return ImprovedView.extend("ManageTypekitIntegrationView", {

        className: "tab-pane",

        template: template,

        templateHelpers: function templateHelpers() {
            return {
                permissionToManage: Permissions.Privileges.ADMIN.can()
            };
        },

        bindings: {
            ".typekit-api-token-input": {
                observe: "typekitApiToken"
            }
        },

        behaviors: {
            validateBehavior: {
                behaviorClass: ValidateBehavior,
                inputValidation: {
                    ".typekit-api-token-input": {
                        validateAfter: "beforeSubmit",
                        // Mark as bound to model, so make sure we cancel pending save requests on error!
                        model: true,
                        validator: function validator(key) {
                            // 40 word characters (upper/lowercase letters + digits).
                            return isBlank(key) || /^\w{40,40}$/.test(key);
                        },
                        validatorAsync: {
                            "typekit:valid:token": {
                                source: SystemMessages,
                                validator: function validator(valid) {
                                    return valid;
                                }
                            }
                        },
                        errorText: function errorText(value, type) {
                            return type === "async" ? "The Typekit token appears to be invalid" : "Not a valid Typekit API Token";
                        }
                    }
                }
            }
        },

        active: function active(state) {
            this.$el.toggleClass("active", state);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3124 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="row">\n    <section class="col-xs-4">\n        <p class="intro">With Creator’s Typekit integration you are able to use all your favorite, high quality fonts from your Typekit account in your Creator Experiences.</p>\n        <p>This will allow you to choose between Typekit’s 995+ high quality font families or add custom fonts to enhance brand expression, improve quality of visual appearance and align user experience between your website and your Experiences.</p>\n    </section>\n    <section class="col-xs-4">\n        <h4>1. Copy Your Typekit API Token</h4>\n        <p>Copy the API token from the Settings page on your Typekit account and paste it in the field below.</p>\n        <div class="api-token">\n            <label>Typekit API Token:</label>\n            <input class="typekit-api-token-input" type="text" placeholder="Typekit API Token" ';
 if (!permissionToManage) { ;
__p += 'disabled="true"';
 } ;
__p += '>\n        </div>\n        <span class="help-block">You can find your API Tokens here: <a href="https://typekit.com/account/tokens" target="_blank">https://typekit.com/account/tokens</a></span>\n    </section>\n    <section class="col-xs-4">\n        <h4>2. Insert Creator\'s Domain</h4>\n        <p>Insert both Creator\'s domain [*.zmags.com] and your own domain into the "Domains" field of the Kits you intend to use with Creator.</p>\n        <span class="help-block">You can find the "Domains" field for a specific Kit by choosing the individual Kit in your TypeKit account and select Kit Editor - Kit Settings.</span>\n    </section>\n</div>\n<div class="row">\n    <section class="col-xs-4">\n        <div class="notification-box">\n            <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">Maximize load speed!</span>\n            <p>Remove unused fonts from your Typekits. When using a Typekit font in your Experience all fonts within the Kit will be loaded - even if you don\'t use all of them.</p>\n        </div>\n    </section>\n    <section class="col-xs-4">\n        <div class="illustration typekit-token"></div>\n    </section>\n    <section class="col-xs-4">\n        <div class="illustration typekit-domain"></div>\n    </section>\n</div>\n';

}
return __p
}

/***/ }),
/* 3125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6);
    var DropAreaHotspot = __webpack_require__(398);
    var CustomFontCollectionView = __webpack_require__(3126);
    var CustomFontCollection = __webpack_require__(877);
    var CustomFontDropManager = __webpack_require__(3129);
    var FontProvider = __webpack_require__(103);
    var EditorWebFontController = __webpack_require__(176);
    var template = __webpack_require__(3131);

    return ImprovedView.extend("ManageCustomFontsIntegrationView", {

        className: "tab-pane",

        template: template,

        regions: {
            "fontCollectionRegion": ".font-collection-region"
        },

        behaviors: {
            dropAreaHotspot: {
                behaviorClass: DropAreaHotspot,
                dropManager: CustomFontDropManager,
                message: "<h4>Add <br/>Custom Fonts</h4><p>Drag from desktop or click to upload</p>",
                dropAreaSelector: ".font-drop-area",
                iconSize: "small"
            }
        },

        initialize: function initialize() {
            this._collection = new CustomFontCollection();
            this._collection.fetch();
        },


        /**
         * Invoked when uploading (triggered by the `DropAreaHotspot`).
         *
         * @param {Promise} options.promise Fulfilled when upload completes.
         * @param {CustomFontModel[]} options.models The font models.
         *
         * @see CustomFontDropManager
         */
        onUpload: function onUpload(_ref) {
            var _this = this;

            var promise = _ref.promise,
                descriptors = _ref.descriptors,
                models = _ref.models;

            this._collection.add(models);

            promise.then(function () {
                EditorWebFontController.register(models, FontProvider.CUSTOM);
            });

            // Handle failed uploads...
            descriptors.forEach(function (uploadDescriptor) {
                uploadDescriptor.promise.fail(function () {
                    _this._collection.remove(uploadDescriptor.model);
                });
            });
        },
        onShow: function onShow() {
            var collectionView = new CustomFontCollectionView({ collection: this._collection });
            this.fontCollectionRegion.show(collectionView);
        },
        active: function active(state) {
            this.$el.toggleClass("active", state);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(10),
        CollectionView = _require.CollectionView,
        ItemView = _require.ItemView;

    var _require2 = __webpack_require__(1),
        template = _require2.template;

    var CustomFontItemView = __webpack_require__(3127);
    var EditorEvents = __webpack_require__(17);
    var LoggedInUserState = __webpack_require__(19);

    // We need to preserve the same `className` for both item views for the collection view
    // ordering to work correctly, see zbone/CollectionView.
    var ITEM_VIEW_CLASS_NAME = "custom-font-item-view";

    /**
     * The item view shown during upload.
     *
     * @class UploadProgressItemView
     */
    var UploadProgressItemView = ItemView.extend("UploadProgressItemView", {

        tagName: "li",

        className: ITEM_VIEW_CLASS_NAME,

        template: template("<div class=\"progress-bar\">"),

        modelEvents: {
            "change:progress": "_progressChangeHandler",
            "change:uploading": "_uploadChangeHandler"
        },

        ui: {
            progressBar: ".progress-bar"
        },

        onBeforeRender: function onBeforeRender() {
            this.$el.addClass("uploading");
        },
        _uploadChangeHandler: function _uploadChangeHandler(model, uploading) {
            this.$el.toggleClass("uploading", uploading);

            if (uploading === undefined) {
                this.trigger("upload:complete");
            }
        },
        _progressChangeHandler: function _progressChangeHandler(model, progress) {
            if (progress !== undefined) {
                var width = progress * 100;
                this.ui.progressBar.css("width", width + "%");
            }
        }
    });

    return CollectionView.extend("CustomFontCollectionView", {

        tagName: "ul",

        className: "custom-font-collection-view",

        itemEvents: {
            "upload:complete": "_itemViewUploadCompleteHandler"
        },

        getItemView: function getItemView(model) {
            return model.has("uploading") ? UploadProgressItemView : CustomFontItemView;
        },
        _itemViewUploadCompleteHandler: function _itemViewUploadCompleteHandler(event, _ref) {
            var model = _ref.model;

            this._triggerEditorEvent(model);
            // Once upload is complete, remove the `UploadProgressItemView` instance by removing the model from the collection.
            this.collection.remove(model);
            // Re-add it to proper render a new `CustomFontItemView` instance...
            this.collection.add(model);
        },


        /**
         * @private
         *
         * @param {CustomFontItemView} model - The font uploaded
         * Send an event to MixPanel when a Custom font is uploaded.
         */
        _triggerEditorEvent: function _triggerEditorEvent(model) {
            var user = LoggedInUserState.get("user");
            var eventProperties = {
                username: user.get("username"),
                userId: user.get("id"),
                fontId: model.get("id"),
                fontName: model.get("name"),
                fontType: "custom",
                triggerOrigin: "CustomFontsUploader"
            };

            EditorEvents.trigger(EditorEvents.constants.UPLOAD_FONT, eventProperties);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(10),
        ItemView = _require.ItemView;

    var template = __webpack_require__(3128);
    var Permissions = __webpack_require__(22);
    var Tooltip = __webpack_require__(35);
    var EditorEvents = __webpack_require__(17);
    var EditorWebFontController = __webpack_require__(176);
    var FontProvider = __webpack_require__(103);

    // We need to preserve the same `className` for both item views for the collection view
    // ordering to work correctly, see zbone/CollectionView.
    var ITEM_VIEW_CLASS_NAME = "custom-font-item-view";

    /**
     * The default item view representing font family and format.
     *
     * @class CustomFontItemView
     */
    return ItemView.extend("CustomFontItemView", {

        tagName: "li",

        className: ITEM_VIEW_CLASS_NAME,

        template: template,

        ui: {
            deleteIcon: ".delete-icon"
        },

        events: {
            "click @ui.deleteIcon": "_deleteFontClickHandler"
        },

        onShow: function onShow() {
            var tooltipContent = "Delete font.";

            if (Permissions.Roles.MANAGER.cannot()) {
                tooltipContent = "You do not have permission to delete this font.";
            } else if (this.model.get("timesUsed")) {
                tooltipContent = "This font cannot be deleted because it is in use.";
            }

            Tooltip.add(this.ui.deleteIcon, {
                content: tooltipContent,
                placement: "top"
            });
        },
        _deleteFontClickHandler: function _deleteFontClickHandler() {
            var _this = this;

            if (!this.model.get("readOnly") && confirm("Are you sure you want to delete this font?")) {
                Tooltip.remove(this.ui.deleteIcon);
                this.model.destroy().then(function () {
                    EditorWebFontController.unregister(_this.model, FontProvider.CUSTOM);

                    var eventProperties = {
                        fontId: _this.model.get("id"),
                        fontName: _this.model.get("name"),
                        fontType: "custom",
                        triggerOrigin: "CustomFontDeleteIcon"
                    };

                    EditorEvents.trigger(EditorEvents.constants.DELETE_FONT, eventProperties);
                });
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3128 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<h5>' +
__e( fontFamily ) +
'</h5><label>Format: ' +
__e( extension ) +
'</label>\n<span class="delete-icon';
 if (readOnly) { ;
__p += ' disabled';
};
__p += '"></span>\n';

}
return __p
}

/***/ }),
/* 3129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var FileDropManager = __webpack_require__(860);
    var CustomFontFileStorage = __webpack_require__(3130);
    var CustomFontModel = __webpack_require__(561);

    var CustomFontDropManager = FileDropManager.extend("CustomFontDropManager", {

        fileModel: CustomFontModel,

        fileStorage: CustomFontFileStorage

    });

    // Singleton
    return new CustomFontDropManager();
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var CustomFontModel = __webpack_require__(561);
    var RestApi = __webpack_require__(29);
    var UrlUtil = __webpack_require__(46);
    var AbstractFileStorage = __webpack_require__(861);

    // Supported font extensions.
    var EXTENSIONS = "woff"; // no "woff2" for IE11 :(

    /**
     * The file storage service.
     *
     * @class CustomFontFileStorage
     */
    return AbstractFileStorage.extend("CustomFontFileStorage", {
        _modelInfo: function _modelInfo(file) {
            return {
                modelClass: CustomFontModel,
                url: UrlUtil.appendParamObject(RestApi.pathToCollection(RestApi.Collections.FONTS), { filename: file.name }),
                supportedTypes: EXTENSIONS
            };
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3131 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="row">\n    <section class="col-xs-4">\n        <p class="intro">With Creator\'s ability to integrate your favorite custom fonts, you can upload your font files right from your computer and start using them in your Creator Experiences right away.</p>\n        <p>Creator currently supports Web Open (WOFF) font format. You will only see the 20 most recently uploaded fonts in the font selection dropdown by default, but you are able to use any of your uploaded fonts by searching.</p>\n        <div class="notification-box">\n            <span class="glyphicon glyphicon-exclamation-sign"></span><span class="intro">Font Upload Permissions</span>\n            <p>Make sure your font provider allows integration with third party tools before uploading.</p>\n        </div>\n    </section>\n    <section class="col-xs-4">\n        <h4>Upload</h4>\n        <div class="font-drop-area"></div>\n    </section>\n    <section class="col-xs-4">\n        <h4>Your Custom Fonts</h4>\n        <div class="font-collection-region"></div>\n    </section>\n</div>\n';

}
return __p
}

/***/ }),
/* 3132 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Set Up Fonts</h1>\n    </header>\n\n    <div class="tabs">\n    ';
 _.each(tabs, function (tab) { ;
__p += '\n        <span class="tab ' +
__e( tab.className ) +
' ' +
__e( tab.slug ) +
' ' +
__e( (tab.active ? 'active' : '') ) +
'" data-tab="' +
__e( tab.slug ) +
'">\n            ' +
__e( tab.name ) +
'\n        </span>\n    ';
 }) ;
__p += '\n    </div>\n\n    <div class="integrations-container" />\n\n</div>\n<footer class="default-footer"></footer>\n';

}
return __p
}

/***/ }),
/* 3133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Marionette = __webpack_require__(10);
    var PublishToolbarView = __webpack_require__(3134);
    var PublishOptionsProvider = __webpack_require__(699);
    var FramedPublishToolbarView = __webpack_require__(3145);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var LoggedIn = __webpack_require__(31);
    var LoggedInUserState = __webpack_require__(19);

    var logger = new Logger("PublishController");

    // Note: the PublishView will encode the url (uri) before opening the publish toolbar window using this
    // controller, but the "url" argument here is deduced from a Backbone route! And Backbone decodes uris
    // for routes already, i.e. to ensure the matched part of the uri does not need to be decoded manually
    // every time, so trying to call "decodeUriComponent(url)" here will raise an error in case % is used in the
    // url! If the controller methods are called explicitly, the caller must thus ensure the uri's (urls) have
    // be decoded beforehand...
    return Marionette.Controller.extend({
        // This is run in a separate/window, as an entirely standalone editor, just showing this view - we
        // could (and should) optimise this a lot!
        showToolbarView: function showToolbarView(url, projectId) {
            var _this = this;

            var project = projectId ? LoggedInUserState.get("projects").get(projectId) : null;

            PublishOptionsProvider.provide({ project: project, fetchChannelConfig: true, maxScenes: 1 }).then(function (_ref) {
                var publishableCollection = _ref.publishableCollection,
                    publishables = _ref.publishables,
                    channelConfig = _ref.channelConfig;

                // Authentication controller ensures we only load pushed experiences!...
                var experienceMetadata = LoggedInUserState.get("experienceMetadata");

                _this.options.region.show(new PublishToolbarView({
                    publishables: publishables,
                    publishableCollection: publishableCollection,
                    channelConfig: channelConfig,
                    url: url,
                    experienceMetadata: experienceMetadata,
                    project: project
                }));
            }).fail(function () {
                logger.error("Unable to fetch publish options for company with id: " + LoggedIn.companyId());
            });
        },
        showFramedToolbarView: function showFramedToolbarView(url, projectId) {
            this.options.region.show(new FramedPublishToolbarView({
                url: url,
                projectId: projectId
            }));
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        clone = _require.clone,
        each = _require.each,
        isString = _require.isString,
        pluck = _require.pluck;

    var Browser = __webpack_require__(39);
    var Channel = __webpack_require__(233);
    var Configuration = __webpack_require__(27);
    var EditorEvents = __webpack_require__(17);
    var ExperienceModel = __webpack_require__(58);
    var GroupCollection = __webpack_require__(719);
    var BreakpointGroup = __webpack_require__(97);
    var LoggedIn = __webpack_require__(31);

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var Marionette = __webpack_require__(10);
    var MessageNode = __webpack_require__(465);
    var MessageTypes = __webpack_require__(342);
    var pageStatus = __webpack_require__(3135);
    var Permissions = __webpack_require__(22);
    var Promise = __webpack_require__(21);
    var ProjectAsset = __webpack_require__(283);
    var PublishUtil = __webpack_require__(234);
    var PublishToolbarThumbnailView = __webpack_require__(3136);
    var SequentialButton = __webpack_require__(112);
    var SyncManager = __webpack_require__(44);
    var SystemMessages = __webpack_require__(107);
    var template = __webpack_require__(3141);
    var Time = __webpack_require__(121);
    var UrlUtil = __webpack_require__(46);
    var Window = __webpack_require__(48);

    __webpack_require__(3142); // this is a standalone app that needs this!

    var CHECKING_TIMEOUT = 5000;
    var CURRENT_SCHEDULED_DATE = "now";

    var CONTACT_US_COMMUNITY_URL = Configuration.communityBaseUrl + "/hc/en-us/articles/202049238-Contact-Us";

    var log = new Logger("PublishToolbarView");

    var node = void 0;
    var changed = false;
    var closed = false;

    function framed() {
        return window.top !== window.self;
    }

    // For now, we support all browsers (and versions) allowed into the editor, but we can change this later on if we
    // experience problems. However, IE, Opera, and Chrome on non Windows OS does not support preview mode either! IE
    // does not support cross domain drag-n-drop between *windows* so we use a an iframe solution there. Setting this
    // flag to false in some context will ensure that a proper state is set/rendered!
    function browserSupported() {
        return !(Browser.type.ie || Browser.type.edge) || framed(); // will be "publish" if two windows are used
    }

    // If Chrome on anything but windows, we cannot do preview since we have no way of displaying the
    // bookmarks in the opened window, i.e. the "Experience Preview" bookmark can never be clicked.
    // For Opera, bookmarks are gone from version 18, but can apparently be imported in certain cases.
    // However, this will make it very hard to make a simple wizard description, so for know, we disable
    // preview in Opera altogether (even though old versions of it may support bookmarks just fine).
    // Bookmarks is gone from Safari as of 9.0 so we disable it completely too.
    function previewNotSupported() {
        // assumes supported browser!
        // Never possible to use the bookmarklet if iframed, since a bookmarklet can only alter the top document...
        return framed() || Browser.type.ie || Browser.type.edge || Browser.type.opera || Browser.type.chrome && !Browser.os.winOS || Browser.type.safari;
    }

    // Closes this window (and the customer site when closing node)...
    function doClose() {
        if (!closed) {
            if (!changed || confirm("You are leaving a page with unsaved changes.\n\nAre you sure you want to leave this page?")) {
                // Tag as already closed as to not alert multiple confirm messages to the user (see beforeNavigation)...
                closed = true;
                // Will relay message to "channels_admin" that is should close it self. This is necessary since if
                // the "publish" window is reloaded, the JS references to this and the "channels_admin" window will
                // be lost, and they will never be closed...
                node.close();
                // Close this window, necessary if connection is lost...
                window.close();
            }
        }

        return true;
    }

    return Marionette.Layout.extend({

        template: template,

        className: "publish-toolbar-view pt-page",

        transitions: {
            "in": "pt-page-moveFromTop",
            out: "pt-page-scaleDown"
        },

        regions: {
            experienceThumbnails: ".experience-thumbnails",
            publishThumbnailRegion: ".publish-thumbnail-region"
        },

        events: {
            "click #settings-link": "_settingsClickHandler",
            "click .highlight-toggle": "_highlightToogleClickHandler",
            "click .save-button": "_saveClickHandler",
            "click .discard-changes": "_discardChangesClickHandler",
            "click #support": "_supportClickHandler",
            "click .close-button": doClose
        },

        ui: {
            highlightToggleButton: ".highlight-toggle",
            discardButton: ".discard-changes",
            statusLabel: "#status-label",
            statusWrapper: "#status-wrapper",
            status: ".status",
            statusChecking: ".status.checking",
            statusBrowserNotSupported: ".status.browser-not-supported",
            statusPreviewNotSupported: ".status.preview-not-supported",
            statusWindowClosed: ".status.window-closed",
            statusNoSnippet: ".status.no-snippet",
            statusWrongBookmarklet: ".wrong-bookmarklet",
            statusSnippetOk: ".status.snippet-ok",
            statusSnippetNotOk: ".status.snippet-not-ok",
            statusHasChannels: ".status .has-channels",
            statusMessage: ".status-message",
            savePreviewButton: ".save-button"
        },

        templateHelpers: function templateHelpers() {
            var project = this.options.project;

            return {
                supportedBrowser: browserSupported(),
                previewSupported: !previewNotSupported(),
                requiresShowAsTab: Browser.type.chrome && Browser.os.winOS,
                browser: Browser,
                notAllowedToPublish: this._notAllowedToPublish,
                project: project,
                config: Configuration // only available by default for ImprovedViews
            };
        },


        channelBindings: {
            ".bookmarklet": { attributes: [{ name: "href", observe: "bookmarklet" }] }
        },

        _timer: null,
        _highlight: "on",
        _channelDescriptors: null,
        _currentPageStatus: pageStatus.UNKNOWN_IF_ENABLED, // since we set it to CHECKING on render, has to be different
        _snippetPreview: false,
        _notAllowedToPublish: false,

        publishables: null, // publishables with possible state changes...

        _settingsClickHandler: function _settingsClickHandler(event) {
            event.preventDefault();
            node.post({ action: MessageTypes.NAVIGATE_TO, data: { url: "#settings" }, receiver: "root" });
        },
        _highlightToogleClickHandler: function _highlightToogleClickHandler() {
            if (!this.ui.highlightToggleButton.hasClass("disabled")) {
                this._toggleHighlight();
            }
        },
        _saveClickHandler: function _saveClickHandler() {
            this._saveButton();
        },
        _discardChangesClickHandler: function _discardChangesClickHandler() {
            if (!this.ui.discardButton.hasClass("disabled")) {
                this._refresh("Changes successfully discarded", "Could not reload Slot configuration, please close the window to discard changes!");
            }
        },
        _supportClickHandler: function _supportClickHandler(event) {
            event.preventDefault();
            // Use Zendesk quick view in the editor if possible, i.e. if we can connect to the Editor, otherwise
            // link directly to the community...
            if (node.root() === "publish") {
                // can be framed, so we have to check for named node!
                node.post({ action: MessageTypes.SUPPORT, receiver: "publish" });
            } else {
                Window.open(CONTACT_US_COMMUNITY_URL, "zmags_creator_community");
            }
        },


        /**
         * Updates the UI to visually indicate the status of the site in the "customer site window"
         *
         * @param {pageStatus} status The status of the site (if it is enabled for channels, has any channels, etc.)
         * @private
         */
        _setPageStatus: function _setPageStatus(status) {
            this._clearTimer();

            if (this._currentPageStatus.id === status.id || this._currentPageStatus.id === pageStatus.BROWSER_NOT_SUPPORTED.id || (this._currentPageStatus.id === pageStatus.WRONG_BOOKMARKLET.id || this._currentPageStatus.id === pageStatus.PREVIEW_NOT_SUPPORTED.id) && status.id === pageStatus.WINDOW_CLOSED.id) {
                // ignore auto-reload!
                return;
            }

            this._currentPageStatus = status;
            this.ui.status.css("display", "none");

            switch (status.id) {
                case pageStatus.CHECKING.id:
                    this.ui.statusChecking.css("display", "block");
                    break;

                case pageStatus.BROWSER_NOT_SUPPORTED.id:
                    this.ui.statusBrowserNotSupported.css("display", "block");
                    node.post(MessageTypes.BROWSER_NOT_SUPPORTED);
                    break;

                case pageStatus.PREVIEW_NOT_SUPPORTED.id:
                    this.ui.statusPreviewNotSupported.css("display", "block");
                    break;

                case pageStatus.WINDOW_CLOSED.id:
                    this.ui.statusWindowClosed.css("display", "block");
                    break;

                case pageStatus.WRONG_BOOKMARKLET.id:
                    node.post(MessageTypes.WRONG_BOOKMARKLET);
                    this.ui.statusNoSnippet.css("display", "block");
                    this.ui.statusWrongBookmarklet.css("display", "block");
                    this._setMessage("Please update your bookmark in your bookmarks/favorites bar!", true);
                    this._snippetPreview = true; // since only when "Experience Preview" is clicked
                    break;

                case pageStatus.WRONG_ID.id:
                    this.ui.statusSnippetNotOk.css("display", "block");
                    node.post({ action: MessageTypes.WRONG_CONFIG_ID, data: this.options.channelConfig.get("id") });
                    break;

                case pageStatus.NOT_ENABLED_NO_CHANNELS.id:
                case pageStatus.NOT_ENABLED_HAS_CHANNELS.id:
                    if (previewNotSupported()) {
                        return this._setPageStatus(pageStatus.PREVIEW_NOT_SUPPORTED);
                    }

                    this._snippetPreview = true;
                    this.ui.statusHasChannels.css("display", status.id === pageStatus.NOT_ENABLED_NO_CHANNELS.id ? "none" : "");
                // Fall through.

                case pageStatus.ENABLED_HAS_CHANNELS.id:
                case pageStatus.ENABLED_NO_CHANNELS.id:
                    this.ui.statusSnippetOk.css("display", "block");
                    this.ui.statusSnippetOk.toggleClass("preview", this._snippetPreview);
                    break;

                default:
                    // UNKNOWN_IF_ENABLED
                    if (previewNotSupported()) {
                        return this._setPageStatus(pageStatus.PREVIEW_NOT_SUPPORTED);
                    }

                    this.ui.statusNoSnippet.css("display", "block");
                    break;
            }
        },
        _setMessage: function _setMessage(text, err, fixed, delay) {
            // TODO: eventually use NotificationBar!
            var statusMessage = this.ui.statusMessage;


            statusMessage.css({
                "display": "none",
                "color": typeof err !== "undefined" ? "orange" : "black"
            });
            statusMessage.text(text || "");

            if (err) {
                // Http call?
                if (typeof err.statusText !== "undefined") {
                    log.error(text + " => " + err.statusText + " (" + err.status + ") -> " + err.responseText, err);
                    // Some other error, for example a received error from the client site...
                } else {
                    log.error(text + " => " + (err.message || err), err);
                }
            } else if (text) {
                log.info(text);
            }

            if (text) {
                if (fixed) {
                    statusMessage.fadeIn("fast");
                } else {
                    if (!delay) {
                        if (err) {
                            delay = 6000;
                        } else {
                            delay = 3000;
                        }
                    }

                    statusMessage.fadeIn("fast").delay(delay).fadeOut("fast");
                }

                statusMessage.one("click", function () {
                    statusMessage.css("display", "none");
                });
            }
        },
        _startTimer: function _startTimer() {
            var _this = this;

            // If the "toolbar" window is loaded within this interval, it will send a PAGE_IS_CHANNELS_ENABLED
            // status ping....
            if (browserSupported()) {
                this._timer = setTimeout(function () {
                    _this._setPageStatus(pageStatus.UNKNOWN_IF_ENABLED);
                }, CHECKING_TIMEOUT);
            } else {
                this._setPageStatus(pageStatus.BROWSER_NOT_SUPPORTED);
            }
        },
        _clearTimer: function _clearTimer() {
            if (this._timer) {
                clearTimeout(this._timer);
            }

            this._timer = null;
        },


        /**
         * @private
         * Returns a JSON version of the channel config, that can be sent using "postMessage". <p>
         *
         * Augments/changes the channel json by: <ol>
         *
         * <li> Each channel will have an (temp) id if it does not already have an id. <p>
         *
         * <li> Adding the "inProject" flag for any channel, experience, and/or group in question when in
         *      project mode (true/false), always false otherwise (i.e. also when not in project mode).
         *
         * <li> If a schedule is present, it will be stored under <tt>channel.schedule</tt> (and not in
         *      an array with a single entry).
         *
         * </ol>
         *
         * @return {*} A postable channel config with augmented channels; never falsey.
         */
        _getPostableChannelConfig: function _getPostableChannelConfig() {
            var _this2 = this;

            var _options = this.options,
                channelConfig = _options.channelConfig,
                project = _options.project;
            // The toJSON may still share objects, like schedules, that will eventually be stringified to json at
            // this point, so we cannot update the blindly here as it will be reflected in the channel config!

            var json = channelConfig.toJSON({ sync: "marshal" });

            // Marshals the publishable associated with the specified schedule, "Now" (channel) or
            // actual schedule...
            var publishable = function publishable(schedule) {
                if (schedule.experience) {
                    schedule.experience = _this2._experienceToJson(project, schedule.experience);
                    delete schedule.group;
                } else if (schedule.group) {
                    schedule.group = _this2._groupToJson(project, schedule.group);
                    delete schedule.experience;
                } else {
                    delete schedule.experience;
                    delete schedule.group;
                }
            };

            json.channels = json.channels.map(function (channel) {
                return clone(channel);
            });

            json.channels.forEach(function (channel) {
                if (project) {
                    channel.inProject = project.containsChannel(channel.id || channel.cid); // handles unsaved ones as well
                }

                // For newly created channels, no "urlPattern" has been set by the backend, so we must set it here...
                if (!channel.urlPattern && channel.url) {
                    channel.urlPattern = channel.url.split("*");
                }

                // Schedule "Now" (1)...
                publishable(channel);

                // Future Schedule (2)...
                if (channel.schedules) {
                    // "schedule" is a shared reference, we must copy it!
                    var schedule = channel.schedules[0];
                    delete channel.schedules; // not a shared reference

                    if (schedule) {
                        schedule = clone(schedule);
                        publishable(schedule);
                        channel.schedule = schedule;
                    }
                }
            });

            return {
                channelConfig: json,
                origin: node.origin()
            };
        },


        /**
         * @param  {String|Model|Object} publishable
         * @return {[type]}             [description]
         */
        _lookupPublishable: function _lookupPublishable(publishable) {
            var id = isString(publishable) ? publishable : publishable.id || publishable.get("id");

            return this.options.publishableCollection.get(id);
        },
        _experienceToJson: function _experienceToJson(project, experience) {
            if (experience && experience.__typeName) {
                // we know we have a typeName on our Experience backbone models...
                experience = {
                    id: experience.get("id"),
                    version: Math.abs(experience.get("version")),
                    name: experience.get("name"),
                    state: experience.get("state")
                };
            }

            // We can never create new experiences here, so we do not have to test for temp id...
            if (project) {
                experience.inProject = project.containsExperience(experience.id);
            }

            return experience;
        },
        _groupToJson: function _groupToJson(project, group) {
            if (group) {
                if (group.__typeName) {
                    // we know we have a typeName on our Group backbone models...
                    group = group.toJSON();
                }

                group = {
                    // Only groups of type "BreakpointGroup" can be published - but still we need to
                    // tell the backend (thanks Mr. ALA).
                    type: BreakpointGroup.type,
                    id: group.id,
                    // version: Math.abs(group.version),
                    name: group.name,
                    state: group.state,
                    info: group.name
                };
            }

            // We can never create new groups here, so we do not have to test for temp id...
            if (project) {
                group.inProject = project.containsGroup(group.id);
            }

            return group;
        },
        _getHighlight: function _getHighlight() {
            return this._highlight;
        },


        /**
         * @private
         *
         * Post a message to the customer site instructing it to update all the channels according to the given channelConfig.
         *
         * @param {Boolean} [updated] If true, we notify the "publish" node as well, so it can reload the new data itself.
         */
        _postUpdateChannelsMessage: function _postUpdateChannelsMessage(updated) {
            this._setMessage(); // clear any message present now...
            var receivers = ["channels_admin"];

            if (updated) {
                receivers.push("root");
            }

            changed = !updated && !this._notAllowedToPublish; // potentially changed unless updated, we really do not know...

            if (changed) {
                this._setMessage("Unsaved changes!", false, true);
            }

            this._updateChangedButtons(changed);

            var data = this._getPostableChannelConfig();
            // Add scheduled date...
            data.scheduledDate = this._scheduledDate;
            node.post({ action: MessageTypes.POPULATE_CHANNELS, receiver: receivers, data: data });
        },
        _updateChangedButtons: function _updateChangedButtons(changed) {
            var discardButton = this.ui.discardButton;

            this._saveButton.enable(changed && !this._notAllowedToPublish);

            if (this._notAllowedToPublish || !changed) {
                discardButton.addClass("disabled");
            } else {
                discardButton.removeClass("disabled");
            }
        },


        /**
         * @private
         * Handles a message (from the customer site window) to resolve content information for in-place channels
         * where only an Experience and/or group id is available.
         *
         * @param {MessageNode.Message} message The received message; never null.
         */
        _resolveContent: function _resolveContent(message) {
            var _this3 = this;

            var data = message.data;
            var type = data.type;
            var id = data.id;
            var silent = { silent: true }; // do not alert such errors here in the Publish toolbar, the error will be shown in tooltips on the client site...
            var promise = type === "experience" ? ExperienceModel.findById(id, silent) : GroupCollection.fetchOne(id, silent);
            var project = this.options.project;


            promise.done(function (model) {
                node.reply(message, { channel: data.channel, content: type === "experience" ? _this3._experienceToJson(project, model) : _this3._groupToJson(project, model) });
            }).fail(function (xhr) {
                log.error("Could not resolve content for 'in-place' channel: " + message, message, xhr.status);
            });
        },


        /**
         * @private
         * Handles a message (from the customer site window) indicating that an content should be published to the
         * given channel.
         *
         * @param {MessageNode.Message} message The received message; never null.
         */
        _publishToChannel: function _publishToChannel(message) {
            var channel = this._getChannelByMessageChannelId(message);

            if (channel) {
                // "No Experience" scheduled for Schedule 2?
                if (message.data.noContent) {
                    this._publishContentToChannel(channel); // no content, so "type" does not matter
                    this._postUpdateChannelsMessage();

                    return;
                }

                // Find/load actual model and add it to the channel...
                this._addModelToChannel(channel, message.data.id, message.data.type);
            }
        },


        /**
         * @private
         * Fetches the specified model based on its id and type (name), then adds it to the supplied channel.
         *
         * @param {Channel} channel The channel; never falsey.
         * @param {String}  id      The model id, e.g. an experience id; never falsey.
         * @param {String}  type    The model type, e.g. "experience" or "group"; never falsey.
         *
         * @return {Promise} A promise that resolves once the model has been loaded and added to the channel and
         *                   an update of the resulting channel config has been sent to the channels admin app.
         */
        _addModelToChannel: function _addModelToChannel(channel, id, type) {
            var _this4 = this;

            var promise = type === "experience" ? ExperienceModel.findById(id) : GroupCollection.fetchOne(id);

            return promise.then(function (model) {
                _this4._publishContentToChannel(channel, model, type);
                _this4._postUpdateChannelsMessage();
            });
        },


        /**
         * @private
         * Will publish a content Model based on the scheduled date. If the scheduled date is "now" or undefined
         * we assume that the current content is the one changed. Otherwise the scheduled content is the one changed. <p>
         *
         * This will also tag <tt>channel</tt> as edited "now" and as modified via DnD.
         *
         * @param {Channel}  channel  The channel to publish to
         * @param {Model}   [content] The content model to publish (ExperienceModel or GroupModel); will be null if
         *                            "No Experience" is scheduled in Schedule 2.
         * @param {String}  [type]    The type of content; can be falsey if <tt>content</tt> is null.
         */
        _publishContentToChannel: function _publishContentToChannel(channel, content, type) {
            if (!this._scheduledDate || this._scheduledDate === CURRENT_SCHEDULED_DATE) {
                if (type === "experience") {
                    Channel.publishCurrentExperience(channel, content);
                } else {
                    Channel.publishCurrentGroup(channel, content);
                }
            } else if (type === "experience") {
                Channel.publishScheduledExperience(channel, content, this._scheduledDate);
            } else {
                Channel.publishScheduledGroup(channel, content, this._scheduledDate);
            }

            // Tag channel as edited at, but do it silently - nobody is listening for these meta data anyways...
            // channel.set({editedAt: Time.server(), editedBy: LoggedIn.principal().get("userId"), dnd: true}, {silent: true});
            channel.editedAt = Time.server();
            channel.editedBy = LoggedIn.principal().get("userId");
            channel.dnd = true;

            var project = this.options.project;
            // Make sure we add the channel as an asset if not already and the experience is from the current
            // project (we never save the project from here). This is regardless if the experience in question is
            // part of the project or not, since it will be inferred on save. We thus only need to concern
            // ourselves with the channel for the client site to get the layout right...

            if (project) {
                var id = channel.id || channel.cid;
                var assets = project.get("assets");
                var inProject = assets.containsChannel(id);

                if (!inProject) {
                    assets.addResource(id, ProjectAsset.Type.CHANNEL);
                }
            }

            var hasContent = Channel.hasContent(channel);
            var eventName = EditorEvents.constants.ADD_CHANNEL;

            if (hasContent) {
                eventName = EditorEvents.constants.UPDATE_CHANNEL;
            }

            var eventProperties = PublishUtil.buildEventProperties({
                channel: channel,
                triggerOrigin: "ClientWindowContainer",
                dragAndDrop: true,
                manual: false,
                projectId: project && project.get("id"),
                updatedProperty: hasContent ? type : null,
                updatedValue: hasContent ? content.get("id") : null
            });

            EditorEvents.trigger(eventName, eventProperties);
        },


        /**
         * @private
         * Handles a message (from the customer site window) indicating that a new channel should be created and the
         * given experience should be published to it. Also deletes any existing channels that happen to conflict
         * with the new channel that will be created (channels cannot be nested inside other channels). <p>
         *
         * This will also tag the created channel as created "now" via DnD.
         *
         * @param {MessageNode.Message} message The received message; never null.
         */
        _createChannelAndPublish: function _createChannelAndPublish(message) {
            var _options2 = this.options,
                channelConfig = _options2.channelConfig,
                project = _options2.project;


            var newChannel = new Channel({ // not a snippet channel, but an editor model
                name: message.data.name,
                url: message.data.url,
                selector: message.data.selector,
                createdBy: LoggedIn.principal().get("userId"),
                createdAt: Time.server(),
                dnd: true // created via DnD!
            });

            var cid = newChannel.cid;
            var channelJson = newChannel.toJSON();
            var channels = channelConfig.get("channels");
            var assets = project && project.get("assets");

            channelJson.cid = cid;

            channels.push(channelJson);

            // Since we are in "unsaved changes mode" here, we need to add a project reference for the channel if
            // in project mode. After save, the assets will have been added and get their actual ids...
            if (assets) {
                assets.addResource(cid, ProjectAsset.Type.CHANNEL);
            }

            // Selector of the channel that the new channel replaces (if any)
            each(message.data.remove, function (id) {
                // Invariant: "id" is either an actual id or a temp "cid", Backbone collections support both...
                var channelJson = channelConfig.channelById(id);

                if (channelJson) {
                    // Remove the channel as an asset as it will be destroyed/deleted when (if) the config is saved.
                    // Since channels are not soft-deleted, we do not bother tagging the channel with who did this...
                    if (assets) {
                        assets.removeResource(channelJson.id, ProjectAsset.Type.CHANNEL);
                    }

                    log.info("Removing channel because of new channel containing it: " + channelJson + " (new) >> " + channelJson + " (will be deleted on save)", channelJson, channelJson);

                    channelConfig.removeChannel(channelJson);
                }
            });

            this._addModelToChannel(channelJson, message.data.id, message.data.type);
        },
        _getChannelByMessageChannelId: function _getChannelByMessageChannelId(message) {
            return this.options.channelConfig.channelById(message.data.channel);
        },


        /**
         * @private
         * Handles a message (from the customer site window) indicating that the channel content should be cleared. <p>
         *
         * This will also tag the channel as edited "now" and as modified via DnD.
         *
         * @param {MessageNode.Message} message The received message; never null.
         */
        _removeContent: function _removeContent(message) {
            var channelJson = this._getChannelByMessageChannelId(message);

            if (channelJson) {
                // Tag channel as edited at, but do it silently - nobody is listening for these meta data anyways...
                channelJson.editedAt = Time.server();
                channelJson.editedBy = LoggedIn.principal().get("userId");
                channelJson.dnd = true;

                if (message.action === MessageTypes.REMOVE_SCHEDULED_CONTENT) {
                    Channel.publishScheduledExperience(channelJson, null); // clears all schedules
                } else {
                    Channel.publishCurrentExperience(channelJson, null); // also clears current group since an experience is set
                }

                var eventProperties = PublishUtil.buildEventProperties({
                    channel: channelJson,
                    triggerOrigin: "RemoveContentButton",
                    dragAndDrop: true,
                    manual: false,
                    projectId: this.project && this.project.get("id")
                });

                EditorEvents.trigger(EditorEvents.constants.UPDATE_CHANNEL, eventProperties);
            }

            this._postUpdateChannelsMessage();
        },


        /**
         * @private
         * Handles a message (from the customer site window) indicating that the given channel should be deleted.
         *
         * @param {MessageNode.Message} message The received message; never null.
         */
        _deleteChannel: function _deleteChannel(message) {
            var channelJson = this._getChannelByMessageChannelId(message);

            // Since channels are not soft-deleted, we do not bother tagging the channel with who did this...
            if (channelJson) {
                Channel.publishCurrentExperience(channelJson, null); // also clears current group since an experience is set
                Channel.publishScheduledExperience(channelJson, null); // clears all schedules

                var channelConfig = this.options.channelConfig;


                channelConfig.removeChannel(channelJson);

                // Might be a "temp" channel (cid)
                if (channelJson.id) {
                    // We are in "unsaved country", so we have to manually remove the channel as an asset if and only
                    // if it already was part of the project...
                    if (this.project) {
                        this.project.get("assets").removeResource(channelJson.id, ProjectAsset.Type.CHANNEL);
                    }

                    var eventProperties = PublishUtil.buildEventProperties({
                        channel: channelJson,
                        triggerOrigin: "DeleteChannelButton",
                        dragAndDrop: true,
                        manual: false,
                        projectId: this.project && this.project.get("id")
                    });

                    EditorEvents.trigger(EditorEvents.constants.DELETE_CHANNEL, eventProperties);
                }
            }

            this._postUpdateChannelsMessage();
        },


        /**
         * @private
         * Handles a message (from the customer site window) indicating that the selected scheduled date has
         * changed and/or if that changed requires us to post a new channel config for a full update because
         * at least one channel will change it contents because of it.
         *
         * @param {MessageNode.Message} message The received message; never null.
         */
        _scheduledDateChanged: function _scheduledDateChanged(message) {
            // If we have a correlation id, "message" is a response from the channel admin app whether or not
            // the original schedule date cause content to be changed on the page...
            if (message.correlationId) {
                // True: update, false: no update required, but we are in sync...
                if (message.data === "update") {
                    this._postUpdateChannelsMessage(false); // false: no update, only selected date change
                }
                return;
            }

            var newScheduledDate = message.data === CURRENT_SCHEDULED_DATE ? message.data : parseInt(message.data, 10);

            if (this._scheduledDate !== newScheduledDate) {
                this._scheduledDate = newScheduledDate;
                // A REPLY selector to hit this callback again with a response from the channels admin app whether
                // we should post a full update or not, which is what we are testing for above with the correlation
                // id...
                node.post({ action: MessageTypes.SCHEDULED_DATE_CHANGED, data: newScheduledDate, selectors: MessageNode.Message.Selectors.REPLY });
            }
        },


        /**
         * @private
         * Sends a message to the customer site window telling it to toggle highlighting of the channels, and updates the
         * highlight button to match the new state. <p>
         *
         * If the highlight is currently disabled, it will continue to be so until the client site tells otherwise or
         * we get a manual update from the editor.
         *
         * @param {String} [highlight] A specific highlight state to enable; default toggles based on current state.
         */
        _toggleHighlight: function _toggleHighlight(highlight) {
            // "restore" means restoring old highlight from the client side. This is done be passing on "restore" and
            // the client side responding with the previous value, eventually hitting this function again with the
            // actual value...
            if (highlight === "restore") {
                node.post({ action: MessageTypes.SET_HIGHLIGHT, data: "restore", selectors: MessageNode.Message.Selectors.REPLY });
                return;
            }

            var old = this._highlight;

            if (highlight) {
                this._highlight = highlight;
            } else if (this._highlight === "on") {
                this._highlight = "off";
            } else if (this._highlight === "off") {
                this._highlight = "on";
            } else {
                this._highlight = "disabled";
            }

            node.post({ action: MessageTypes.SET_HIGHLIGHT, data: this._highlight });

            var text = "Remove Highlight";
            if (this._highlight === "off") {
                text = "Highlight";
            } else if (this._highlight === "disabled") {
                text = "Highlight";
                if (old === "on") {
                    text += " Hidden";
                }
            }

            var highlightToggleButton = this.ui.highlightToggleButton;

            highlightToggleButton.text(text);

            if (this._highlight === "disabled") {
                highlightToggleButton.addClass("disabled");
            } else {
                highlightToggleButton.removeClass("disabled");
            }
        },
        initialize: function initialize() {
            var _this5 = this;

            this._notAllowedToPublish = Permissions.Privileges.PUBLISH.cannot();

            // Log config; ignore ping about channels being enabled, or it will flood the log...
            var logOptions = { log: Logger.level() >= Logger.LOG, ignore: MessageTypes.PAGE_IS_CHANNELS_ENABLED };

            // Create message node to (mainly) communicate with the "channels_admin" node at "this.options.url", i.e.
            // the page/iframe injected via the bookmarklet on the client website. As for the "Publish" tab, we
            // do not know if the specified url will redirect once loaded, e.g. "dr.dk" means "www.dr.dk", so we again
            // have to match on the origin ending with the hostname...
            node = new MessageNode({
                name: "toolbar", eksport: "__zmags.creator.node", log: logOptions, defaults: "channels_admin", origins: { allowed: UrlUtil.location(this.options.url, "hostname"), callback: "err" }, ignorePostAfterClosed: true
            });

            // Post to "channels_admin" node that it should initialize it self. It does not matter if said node is up
            // yet, messages will be enqueued for it and dispatched when it becomes ready. However, if "channels_admin"
            // leaves and re-joins, e.g. a reload, it must be re-initialized. This is handled below in the "on.leave"
            // and "on.join" actions...
            var flags = { notAllowedToPublish: this._notAllowedToPublish };
            var _options3 = this.options,
                project = _options3.project,
                channelConfig = _options3.channelConfig;


            if (project) {
                flags.projectId = project.get("id");
            }

            var handshake = node.bind([
            // Let the ChannelAdminApplication know whether the user is allowed to actually publish things or not
            {
                action: MessageTypes.SET_FLAGS,
                data: flags,
                selectors: MessageNode.Message.Selectors.REPLY
            }, {
                action: MessageTypes.INITIALIZE_CHANNELS,
                data: this._getPostableChannelConfig.bind(this),
                selectors: MessageNode.Message.Selectors.REPLY
            }, {
                action: MessageTypes.POPULATE_CHANNELS
            }, {
                action: MessageTypes.SET_HIGHLIGHT,
                data: this._getHighlight.bind(this)
            }]);

            var initialized = null;
            var on = {};

            // Use highlight response from SET_FLAGS in case this node is doing a reload...
            on[MessageTypes.SET_FLAGS] = function (message) {
                if (_this5._highlight !== message.data) {
                    _this5._toggleHighlight(message.data);
                }
            };

            // If the channels admin application discovers that the browser is not supported, e.g. IE 10
            // in protected mode...
            on[MessageTypes.BROWSER_NOT_SUPPORTED] = function () {
                _this5._setPageStatus(pageStatus.BROWSER_NOT_SUPPORTED);
            };

            // Notify user of errors from the client page...
            on[MessageNode.Message.Actions.ERROR] = function (message) {
                // If the drop failed, it is very likely due to the deduced Sizzle selector being invalid...
                if (message.data) {
                    var msg = void 0;

                    if (message.data.action === MessageTypes.DROP) {
                        msg = "The selected element cannot be used, please select another one!";
                    } else if (message.data.action === MessageTypes.DRAG_START) {
                        msg = message.data.message || message.data.error;
                    }

                    if (!msg) {
                        msg = "Sorry, but something went wrong, please try again!";
                    }

                    _this5._setMessage(msg, message.data, true);
                }
            };

            // Keep tabs of "publish" and "channels_admin" nodes...
            on[MessageNode.Message.Actions.LEAVE] = function (message) {
                if (message.origin === "channels_admin") {
                    initialized = false;
                    // We do not know the current schedule date any longer, i.e. must use the first incoming one
                    // on re-connect...
                    _this5._scheduledDate = null;
                } else if (node.ancestor(message.origin) && message.data !== "self") {
                    // TODO: was === "force" - how do we catch user closing browser window from a reload?
                    window.close();
                }

                _this5._setPageStatus(pageStatus.WINDOW_CLOSED); // some window!
            };

            on[MessageNode.Message.Actions.JOIN] = function (message) {
                if (message.origin === "channels_admin") {
                    if (initialized === false) {
                        initialized = true;
                        handshake();
                    }
                }
            };

            on[MessageTypes.INITIALIZE_CHANNELS] = function (message) {
                // Relay to root, so we can cancel timer check for client site breaking out of the frame. We do this
                // always, never mind if we are loaded at the wrong domain...
                node.post({ action: MessageTypes.INITIALIZE_CHANNELS, receiver: "root" });
                initialized = true;

                var remoteOrigin = message.data;
                var origin = node.origin(); // only from "channels_admin"

                if (remoteOrigin !== origin) {
                    log.info("The channel admin snippet seems to be loaded at different domain: (snippet, editor) => " + remoteOrigin + " != " + origin);
                }
            };

            // Received when manual publishing has updated the channel config from "publish" or from "channels_admin"
            // when it requests a re-rendering because of a user selection of a channel for a dom element with
            // multiple channels matching it...
            on[MessageTypes.POPULATE_CHANNELS] = function (message) {
                if (message.origin === "publish") {
                    if (initialized) {
                        _this5._refresh("Updated with manually saved configuration", "Could not update with manually saved Slot configuration, please close the windows and try reopening them to continue Drag'n Drop Publishing!");
                    }

                    // From "channels_admin"...
                } else {
                    _this5._postUpdateChannelsMessage();
                }
            };

            on[MessageTypes.PAGE_IS_CHANNELS_ENABLED] = function (message) {
                if (message.data.id === channelConfig.get("id")) {
                    // If already initialized, simply update the page status...
                    _this5._setPageStatus(message.data.status);
                } else {
                    _this5._setPageStatus(pageStatus.WRONG_ID);
                }
            };

            // Sets the highlight as dictated by the client site, e.g. disabled when a lightbox is opened...
            on[MessageTypes.SET_HIGHLIGHT] = function (message) {
                _this5._toggleHighlight(message.data);
            };

            on[MessageTypes.CONTENT] = this._resolveContent;
            on[MessageTypes.PUBLISH_TO_CHANNEL] = this._publishToChannel;
            on[MessageTypes.CREATE_CHANNEL_AND_PUBLISH] = this._createChannelAndPublish;
            on[MessageTypes.DELETE_CHANNEL] = this._deleteChannel;
            on[MessageTypes.REMOVE_SCHEDULED_CONTENT] = this._removeContent;
            on[MessageTypes.REMOVE_CURRENT_CONTENT] = this._removeContent;
            on[MessageTypes.SCHEDULED_DATE_CHANGED] = this._scheduledDateChanged;

            node.on(on, this);

            // Send handshake now, since we are ready. The message will be enqueued until "channels_admin" joins
            // then dequeued and dispatched for it. However, if "channels_admin" leaves the node network and re-joins
            // later, we have to issue the handshake again (see above)...
            handshake();
        },


        /**
         * @private
         * Performs a refresh (fetch) of the channel config, as well as project when in project mode.
         *
         * @param {String} success The message to notify the user with on success; never falsey.
         * @param {String} error   The message to notify the user with on failure; never falsey.
         *
         * @return {Promise} A promise that will resolve once the refresh is done; never null.
         */
        _refresh: function _refresh(success, error) {
            var _options4 = this.options,
                channelConfig = _options4.channelConfig,
                project = _options4.project;

            var promises = [channelConfig.fetch()];
            // Remember to reload project when in project mode, we might have add temp assets...
            if (project) {
                promises.push(project.fetch());
            }

            return this._updateAfterSync(Promise.all(promises), success, error);
        },
        onRender: function onRender() {
            var _this6 = this;

            var _options5 = this.options,
                channelConfig = _options5.channelConfig,
                project = _options5.project;


            this._setPageStatus(pageStatus.CHECKING);
            this._startTimer();
            this.stickit(channelConfig, this.channelBindings);

            this._saveButton = SequentialButton.add(this.ui.savePreviewButton, function () {
                var channelNames = pluck(channelConfig.get("channels"), "name");

                var eventProperties = {
                    channels: channelNames,
                    triggerOrigin: "SaveAndPublishButton",
                    dragAndDrop: true,
                    manual: false
                };

                EditorEvents.trigger(EditorEvents.constants.PUBLISH_CHANNEL, eventProperties);

                // When in project mode, we must ensure we update the project *after* channel save as the backend
                // will have added/tagged the assets correctly...
                var queue = SyncManager.queue(false); // false -> sequential queue!

                // Store a reference to the "previous" channels - `channels` will be overwritten on channelConfig save/sync.
                var previousChannels = channelConfig.get("channels");

                // First save...
                queue.enqueue("save", channelConfig);

                // Sync project, if any...
                if (project) {
                    queue.enqueue("fetch", project);
                    queue.enqueue({
                        method: "project.save",
                        fn: function fn() {
                            // Snapshop current persisted channels
                            var persistedChannels = new Map();

                            previousChannels.forEach(function (channel) {
                                if (channel.id) {
                                    persistedChannels.set(channel.id, channel);
                                }
                            });

                            var assets = project.get("assets");

                            channelConfig.get("channels").forEach(function (channel) {
                                if (!persistedChannels.has(channel.id)) {
                                    assets.addResource(channel.id, ProjectAsset.Type.CHANNEL);
                                }
                            });

                            return project.save();
                        }
                    });
                }

                // Start dequeing and update this view accordingly after completion...
                return _this6._updateAfterSync(queue.sync(), null, "Could not save changes!", true) // true: notify PublishView that we have saved changes, and no longer tagged as changed
                .done(function () {
                    // We need to generate this based on response data, so we cannot supply it up-front...
                    _this6._setMessage(SystemMessages.createPurgeMessage("Changes", "saved", channelConfig.get("purgeTime"), true), false, false, 8000);
                });
            });

            // Set save button state initially...
            this._updateChangedButtons(changed);
        },
        _updateAfterSync: function _updateAfterSync(promise, success, error, updated) {
            var _this7 = this;

            return promise.done(function () {
                _this7._postUpdateChannelsMessage(updated); // "changed" will be set to !"updated"...

                if (success) {
                    _this7._setMessage(success);
                }

                changed = false; // never changed after sync!
                _this7._updateChangedButtons(changed);
            }).fail(function (err) {
                _this7._setMessage(error, err);
                _this7._updateChangedButtons(changed);
            }).always(function () {
                // After sync, the client site will re-render, closing all opened lightboxes, so we must enable
                // the toggle highlight button if it was disabled explicitly because of this...
                if (_this7._highlight === "disabled") {
                    _this7._toggleHighlight("restore");
                }
            });
        },
        onShow: function onShow() {
            var _options6 = this.options,
                channelConfig = _options6.channelConfig,
                project = _options6.project,
                publishableCollection = _options6.publishableCollection;

            var collectionView = new PublishToolbarThumbnailView({
                notAllowedToPublish: this._notAllowedToPublish,
                channelConfig: channelConfig,
                project: project,
                filterDropdown: true,
                showSortIcon: false,
                collection: publishableCollection,
                node: node
            });

            this.publishThumbnailRegion.parentView = this;
            this.publishThumbnailRegion.show(collectionView);
        },
        onClose: function onClose() {
            if (node) {
                node.close();
                node = null;
            }

            this._clearTimer();
        },
        beforeNavigate: function beforeNavigate() {
            return !closed && changed;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    "use strict";

    return {
        WRONG_ID: {
            id: "wrongId"
        },
        WRONG_BOOKMARKLET: {
            id: "wrongBookmarklet"
        },
        UNKNOWN_IF_ENABLED: {
            id: "unknownIfEnabled"
        },
        ENABLED_HAS_CHANNELS: {
            id: "enabledHasChannels"
        },
        ENABLED_NO_CHANNELS: {
            id: "enabledNoChannels"
        },
        NOT_ENABLED_HAS_CHANNELS: { // preview
            id: "notEnabledHasChannels"
        },
        NOT_ENABLED_NO_CHANNELS: { // preview
            id: "notEnabledNoChannels"
        },
        BROWSER_NOT_SUPPORTED: {
            id: "browserNotSupported"
        },
        PREVIEW_NOT_SUPPORTED: {
            id: "previewNotSupported"
        },
        WINDOW_CLOSED: {
            id: "windowClosed"
        },
        CHECKING: {
            id: "checking"
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        find = _require.find,
        extend = _require.extend;

    var LocalizationGroup = __webpack_require__(232);
    var DraggableContentThumbnailView = __webpack_require__(3137);
    var Syncer = __webpack_require__(50);
    var ImprovedView = __webpack_require__(6);
    var ContentQuery = __webpack_require__(139);
    var template = __webpack_require__(3139);
    var PublishableCollectionView = __webpack_require__(3140);
    var SortingPanel = __webpack_require__(870);

    /**
     * @class PublishToolbarThumbnailView
     */
    return ImprovedView.extend({

        template: template,

        horizontalScrollBuffer: 220,

        regions: {
            sortingPanelRegion: ".sorting-panel-region",
            content: ".content"
        },

        ui: {
            experienceThumbnails: ".experience-thumbnails"
        },

        initialize: function initialize() {
            this.collection = this.options.collection;
        },
        onShow: function onShow() {
            var _this = this;

            var _options = this.options,
                project = _options.project,
                collection = _options.collection,
                collectionViewOptions = _options.collectionViewOptions;


            var publishableCollectionViewOptions = extend({
                collection: this.collection,
                itemView: DraggableContentThumbnailView,
                itemViewOptions: function itemViewOptions(model) {
                    // Since most of options are needed, we just return all options for simplicity.
                    return extend(_this.options, {
                        localizedGroup: _this._getLocalizedGroup(model)
                    });
                },
                horizontalBuffer: this.horizontalScrollBuffer,
                scrollTarget: this.ui.experienceThumbnails
            }, collectionViewOptions || this.collectionViewOptions);

            if (project) {
                this.sortingPanelOptions = extend({}, this.options);

                this.collection.options.project = project;
            }

            this._sortingPanel = new SortingPanel(this.sortingPanelOptions);

            this._collectionView = new PublishableCollectionView(publishableCollectionViewOptions);

            this.sortingPanelRegion.show(this._sortingPanel);
            this.content.show(this._collectionView);

            this.listenTo(this.collection, {
                "sync:state": function syncState() {
                    // only used for fetch
                    _this._sortingPanel.disable(!Syncer.State.complete(_this.collection));
                }
            });

            var sorting = ContentQuery.sort().field("editedAt");

            this.listenTo(this._sortingPanel, {
                "sort": function sort() {
                    _this.collection.query(sorting);
                },

                "search": function search(tags) {
                    _this.collection.query(ContentQuery.search(tags, sorting));
                }
            });

            if (project) {
                this.$el.addClass("project-context");
                this.listenTo(this._sortingPanel, "select", function (text) {
                    if (text === SortingPanel.FILTER_ATTRIBUTES.project) {
                        collection.options.project = project;
                    } else {
                        delete collection.options.project;
                    }

                    collection.query(collection.currentQuery());
                });
            }
        },
        _getLocalizedGroup: function _getLocalizedGroup(experience) {
            return find(this.collection.models(), function (model) {
                return model instanceof LocalizationGroup && !!model.findAssetById(experience.get("id"));
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _require = __webpack_require__(1),
        first = _require.first,
        extend = _require.extend,
        map = _require.map,
        escape = _require.escape;

    var Browser = __webpack_require__(39);
    var GroupModel = __webpack_require__(104);
    var GroupUtil = __webpack_require__(306);
    var Marionette = __webpack_require__(10);
    var MessageTypes = __webpack_require__(342);
    var SceneThumbnailViewer = __webpack_require__(466);
    var Size = __webpack_require__(84);
    var ThumbnailLayouter = __webpack_require__(1204);
    var Tooltip = __webpack_require__(35);
    var draggableContentTemplate = __webpack_require__(3138);

    var _require2 = __webpack_require__(24),
        Logger = _require2.Logger;

    var CURRENT_SCHEDULED_DATE = "now";
    var MAX_THUMB_DIMENSION = { width: 120, height: 90 };
    var MAX_VARIANT_THUMB_DIMENSION = { width: 77, height: 80 };

    var log = new Logger("ExperienceCollectionThumbnailView");

    return Marionette.Layout.extend({

        className: "draggable-experience-thumbnail",

        template: draggableContentTemplate,

        templateHelpers: function templateHelpers() {
            // Extract locale string in order to render associated flag - see DraggableContentThumbnailView.tpl
            var isLocalized = !!this.options.localizedGroup,
                localeString;

            if (isLocalized) {
                var entry = this.options.localizedGroup.findEntryByAssetId(this.model.get("id"));
                localeString = entry.get("value").get("localeString");
            }

            return {
                allowedToPublish: !this.options.notAllowedToPublish,
                isLocalized: isLocalized,
                localeString: localeString,
                isBreakpointGroup: !!this._group,
                thumbs: this._isGroupOneUnit && this._getThumbs()
            };
        },


        _scheduledDate: CURRENT_SCHEDULED_DATE,

        _tooltip: false,

        _timer: null,

        /**
         * The data payload sent during the drag operation, containing the thumbnail <tt>type</tt> and <tt>id</tt>.
         *
         * @type {Object}
         */
        _dragPayload: null,

        _element: null,

        _group: null,

        _variants: null,

        regions: {
            experienceThumbnailWrapper: ".experience-thumbnail-wrapper"
        },

        ui: {
            experienceThumbnailWrapper: ".experience-thumbnail-wrapper"
        },

        events: {
            "dragstart": function dragstart(event) {
                if (this.options.notAllowedToPublish) {
                    event.preventDefault();

                    return false;
                }

                this._hideTooltip();
                // Ensures that only the experience itself is used as the drag handle...
                var container = this.$el,
                    transfer = event.originalEvent.dataTransfer;

                if (transfer.setDragImage) {
                    // problems in IE on cross-domain...
                    transfer.setDragImage(container.get(0), container.width() / 2, container.height() / 2);
                }
                // We *must* set data as part of the drag start event, or Firefox will not allow drag at all. However,
                // we no longer use the data set (id) in dropPage.html, since Firefox will not allow the
                // dropPage.html to read the id if the customer site is on https and the editor on http (or
                // vice versa). The id and type are now passed to the dropPage.html as a search parameter in the
                // iframe url. Also, Firefox must not use the "Text" as the data tag or it will try and open it as
                // a link...
                transfer.setData(Browser.type.firefox ? "ContentId" : "Text", this._dragPayload.type + ":" + this._dragPayload.id);

                this.options.node.post({ action: MessageTypes.DRAG_START, data: this._dragPayload });
            },

            "selectstart": function selectstart(event) {
                // Required for IE9 to drag anything other than IMG and A
                if (!this.options.notAllowedToPublish) {
                    event.target.dragDrop();
                }
            },

            "dragend": function dragend() {
                if (!this.options.notAllowedToPublish) {
                    this.options.node.post({ action: MessageTypes.DRAG_END, data: this._dragPayload });
                }
            }
        },

        initialize: function initialize() {
            var id = this.model.get("id");

            if (this.model instanceof GroupModel) {
                this._group = this.model;
                this.model = this._group.getAssets()[0];
                this._isGroupOneUnit = this._group.isOneUnit();
                this._variants = this._isGroupOneUnit && this._getVariants();
            }

            this._dragPayload = {
                id: id,
                type: this._group ? "group" : "experience"
            };
        },
        onShow: function onShow() {
            var thumbnail = new SceneThumbnailViewer({
                model: this.model.get("scenes").at(0),
                experience: this.model,
                maxDimensions: this._group ? MAX_VARIANT_THUMB_DIMENSION : MAX_THUMB_DIMENSION,
                showStaticScenes: true
            });

            this.experienceThumbnailWrapper.show(thumbnail);

            this._addTooltip();
        },
        _getVariants: function _getVariants() {
            return GroupUtil.breakpointRangeAssets(this._group);
        },
        _getThumbs: function _getThumbs() {
            var primaryModel = first(this._variants),
                dimensions = map(this._variants, function (variant) {
                return {
                    width: variant.get("width"),
                    height: variant.get("height")
                };
            }),
                layouts;

            if (primaryModel && primaryModel.get("backdrop").isFitContainer()) {
                var firstDimension = dimensions[0],
                    size = new Size(firstDimension.width, firstDimension.height),
                    scaledSize = size.shrinkToAspectRatio(MAX_VARIANT_THUMB_DIMENSION.width / MAX_VARIANT_THUMB_DIMENSION.height);

                extend(firstDimension, scaledSize);
            }

            layouts = ThumbnailLayouter.calculateLayout(dimensions, {
                containerWidth: 110,
                fitboxDimensions: {
                    width: MAX_VARIANT_THUMB_DIMENSION.width,
                    height: MAX_VARIANT_THUMB_DIMENSION.height
                }
            });

            return layouts;
        },
        _findSlots: function _findSlots() {
            var _this = this;

            var id = this.model.get("id");
            var channels = this.options.channelConfig.get("channels");
            var slotsInfoList = [];
            var state = this.model.get("state");

            channels.forEach(function (channelJson) {
                var typeKey = _this._group ? "group" : "experience";
                var publishable = channelJson[typeKey];

                if (publishable && publishable.id === id) {
                    var name = channelJson.name,
                        url = channelJson.url;


                    slotsInfoList.push("<b>" + name + "</b>" + (url ? " &ndash; " + url : ""));
                    // State the same for all channels, computed from the backend...
                    state = publishable.state;
                }
            });

            slotsInfoList.sort();

            return { slots: slotsInfoList, state: state };
        },
        describeGroup: function describeGroup(group) {
            var s = "Breakpoint Intervals: <ol class='ranges'>";

            group.forEachRange(function (range, experience) {
                s += "<li class='word-break'>";

                if (experience) {
                    s += "<b>" + escape(experience.distinguishedName()) + "</b>"; // will include debug (id/version) info where relevant
                } else {
                    // should never happen
                    s += "[" + escape(experience.resourceId) + "]"; // mimic id format
                }

                s += " &ndash; " + range;
                s += "</li>";
            });

            return s + "</ol>";
        },
        _hideTooltip: function _hideTooltip() {
            if (this._timer) {
                clearTimeout(this._timer);
            }

            this._tooltip = false;
            Tooltip.hide(this._element);
        },


        /**
         * Visible for testing
         * @returns {string} HTML to be put inside the tooltip
         */
        buildTooltipHtml: function buildTooltipHtml() {
            var entry = this._findSlots(),
                escapedEntryState = escape(entry.state),
                titleHtml = "<p><b>" + escape(this._group ? this._group.publishableDisplayName() : this.model.publishableDisplayName()) + "</b>",
                stateHtml = "<p>Status: " + escapedEntryState,
                escapedVersion = escape(Math.abs(this.model.get("version"))),
                escapedPushedVersion = escape(this.model.get("pushedVersion")),
                changedSinceLastPush = this.model.has("changedSinceLastPush") && this.model.get("changedSinceLastPush"),
                pushedVersionUnknown = this.model.has("pushedVersionUnknown") && this.model.get("pushedVersionUnknown"),
                groupMsg = "",
                slotsHtml;

            // We cannot used distinguishedName, since localization handled explicitly below...
            if (Logger.level() >= Logger.VERBOSE) {
                titleHtml += "<br>[" + this.model.get("id") + ", #" + escapedVersion + "]";
                stateHtml += " [#" + escapedPushedVersion + "]";
                stateHtml += " [changedSinceLastPush: " + changedSinceLastPush + "]";
                stateHtml += " [pushedVersionUnknown: " + pushedVersionUnknown + "]";
            }

            titleHtml += "</p>";

            if (changedSinceLastPush) {
                stateHtml += ", but latest version not pushed";
            }

            if (pushedVersionUnknown) {
                stateHtml += " - <i>the " + escapedEntryState + " version cannot be shown here until next push; this is the latest saved version.</i>";
            }

            stateHtml += "</p>";

            if (this._group) {
                groupMsg = "<p>" + this.describeGroup(this._group) + "</p>";
            } else if (this.model.groupType) {
                groupMsg = "<p>Localization: " + this.model.identifier + "</p>";
            }

            if (entry.slots.length > 1) {
                slotsHtml = "<p>Currently used in " + entry.slots.length + " Slots:</p>";
                slotsHtml += "<ul><li class='word-break'>" + entry.slots.join("</li><li class='word-break'>") + "</li></ul>";
            } else if (entry.slots.length === 1) {
                slotsHtml = "<p class='word-break'>Slot: \"" + entry.slots[0] + "\"</p>";
            } else {
                slotsHtml = "<p>Not used in any Slots.</p>";
            }

            return titleHtml + stateHtml + groupMsg + slotsHtml;
        },
        _addTooltip: function _addTooltip() {
            var _this2 = this;

            this._element = this.$el.find(".scene-wrapper-outer");

            Tooltip.add(this._element, {
                content: this.buildTooltipHtml(),
                trigger: "manual", // hover with delay and click with no delay at the same time not supported by default!
                width: 220,
                duration: 10000, // auto hide after 10 seconds, may be a lot of text to read for the user
                html: true
            });

            this._element.on("mouseenter", function () {
                _this2._timer = setTimeout(function () {
                    if (!_this2._tooltip) {
                        _this2._tooltip = true;
                        Tooltip.show(_this2._element);
                    }
                }, 1000);
            });

            this._element.on("click", function () {
                if (_this2._timer) {
                    clearTimeout(_this2._timer);
                }

                if (_this2._tooltip) {
                    Tooltip.hide(_this2._element);
                } else {
                    Tooltip.show(_this2._element);
                    log.verbose("Experience clicked: " + _this2.model.get("id"), _this2.model);
                }

                _this2._tooltip = !_this2._tooltip;
            });

            this._element.on("mouseleave", function () {
                return _this2._hideTooltip();
            });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3138 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (isBreakpointGroup) { ;
__p += '\n    <div class="group-thumb-container';
 if (allowedToPublish) { ;
__p += ' draggable';
 } ;
__p += '" draggable="' +
__e( allowedToPublish ) +
'">\n        <div class="variant-thumbs-wrapper">\n            ';
 _.each(thumbs, function (thumb) { ;
__p += '\n                <div class="variant-outline" style="width:' +
__e( thumb.width ) +
'px; height:' +
__e( thumb.height ) +
'px; left:' +
__e( thumb.x ) +
'px;"></div>\n            ';
 }); ;
__p += '\n            <div class="experience-thumbnail-wrapper"></div>\n        </div>\n    </div>\n	<ul class="group-variants">\n        ';
 _.each(thumbs, function (thumb, index) { ;
__p += '\n            <li class="variant-icon">#' +
__e( index + 1 ) +
'</li>\n        ';
 }); ;
__p += '\n    </ul>\n';
 } else { ;
__p += '\n    <div class="experience-thumbnail-wrapper';
 if (allowedToPublish) { ;
__p += ' draggable';
 } ;
__p += '" draggable="' +
__e( allowedToPublish ) +
'" data-toggle="tooltip"></div>\n    ';
 if (isLocalized) { ;
__p += '\n    	<div class="localized flag small ' +
__e( localeString ) +
'"></div>\n    ';
 } ;
__p += '\n';
 } ;
__p += '\n';

}
return __p
}

/***/ }),
/* 3139 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="sorting-panel-region"></div>\n<div class="content collection experience-thumbnails"></div>\n';

}
return __p
}

/***/ }),
/* 3140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var InfiniteScrollingCollectionView = __webpack_require__(259);
    var NoResultsItemView = __webpack_require__(207);
    var ContentItemView = __webpack_require__(704);

    /**
     * A <tt>InfiniteScrollingCollectionView</tt> subclass for displaying (and lazy loading) publishables (experiences and/or groups).
     *
     * @cfg {PublishableCollection} collection The <tt>PublishableCollection</tt> to render.
     *
     * @see  PublishableCollection
     * @see  InfiniteScrollingCollectionView
     *
     * @class PublishableCollectionView
     */
    return InfiniteScrollingCollectionView.extend("PublishableCollectionView", {

        itemView: ContentItemView,

        onEmpty: function onEmpty() {
            return new NoResultsItemView({ type: "Contents" });
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3141 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '\n<div id="zmags-publish-toolbar">\n    <div class="status checking">\n        <div class="header">\n            <label class="status-label">\n                Please wait a few seconds. <br>\n                We are trying to connect to your website...\n            </label>\n        </div>\n    </div>\n\n    <div class="snippet-ok status">\n        <div class="header real">\n            <span class="notification ok"></span>\n            <label class="status-label">\n                Your website is Slot enabled.\n                ';
 if (!notAllowedToPublish) { ;
__p += '\n                Please go ahead and drag in Experiences or Groups to use existing Slots and/or create new ones.\n                ';
 } ;
__p += '\n            </label>\n        </div>\n        <div class="header preview">\n            <span class="notification notify"></span>\n            <label class="status-label">\n                The temporary preview of your Slot enabled website only works locally.\n                ';
 if (!notAllowedToPublish) { ;
__p += '\n                Changes saved are <b>not</b> published until the snippet is ';
 if (config.communityBaseUrl) { ;
__p += '<a target="zmags_creator_community" href="' +
__e(config.communityBaseUrl) +
'/hc/en-us/articles/205142369-Prepare-Your-Site-For-Publishing">copy/pasted</a>';
 } else { ;
__p += 'copy/pasted';
 } ;
__p += ' to your website.\n                ';
 } ;
__p += '\n                <span class="has-channels">You already have Slots that match the current page.</span>\n            </label>\n        </div>\n        <div class="snippet-ok-body content">\n            <div class="header-wrapper">\n                <h4>Experiences Ready To Publish</h4>\n            </div>\n            <div class="publish-thumbnail-region ' +
__e( project ? "project" : "" ) +
'"></div>\n\n            <hr>\n            <div class="status-message"></div>\n\n            <div class="publish-panel real">\n                ';
 if (!notAllowedToPublish) { ;
__p += '\n                    <div class="editing-options">\n                        <span class="highlight-toggle edit-option">Remove Highlight</span>\n                        <span class="discard-changes edit-option pull-right">Discard Changes</span>\n                    </div>\n                ';
 } ;
__p += '\n                <div class="button-panel">\n                    <button class="save-button btn btn-grey ladda-button';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '" type="button" data-style="expand-right">Publish</button>\n                    <button class="btn btn-secondary close-button pull-right">Close</button>\n                </div>\n            </div>\n            <div class="publish-panel preview">\n                ';
 if (!notAllowedToPublish) { ;
__p += '\n                    <div class="editing-options">\n                        <span class="highlight-toggle edit-option">Remove Highlight</span>\n                        <span class="discard-changes edit-option pull-right">Discard Changes</span>\n                    </div>\n                ';
 } ;
__p += '\n                <div class="button-panel">\n                    <button class="save-button btn btn-grey ladda-button';
 if (notAllowedToPublish) { ;
__p += ' disabled';
 } ;
__p += '" type="button" data-style="expand-right">Save</button>\n                    <button class="btn btn-secondary close-button pull-right">Close</button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="no-snippet status">\n        <div class="header">\n            <span class="notification notify"></span>\n            <label class="status-label">\n                Your website does not appear to be ready for publishing.\n                ';
 if (config.communityBaseUrl) { ;
__p += '\n                <br>For more information, visit the <a target="zmags_creator_community" href="' +
__e(config.communityBaseUrl) +
'/hc/en-us/articles/205142369-Prepare-Your-Site-For-Publishing">Creator Community</a>.\n                ';
 } ;
__p += '\n            </label>\n        </div>\n        <div class="content">\n            <h2 class="bold">Don\'t worry!</h2>\n            <h2>You can preview your Experiences anyway.</h2>\n\n            <ol class="steps">\n\n            ';
 if (requiresShowAsTab) { ;
__p += '\n                <li><span class="list-item"><b>Right-Click</b> on the top bar in the browser window now showing your website and click <b>Show as tab</b>.</span></li>\n            ';
 } ;
__p += '\n                <div class="wrong-bookmarklet">\n                    <li><span class="list-item"><b>Delete</b> the "Experience Preview" bookmark from your bookmarks/favorites bar in your website window.</span></li>\n                </div>\n                <li><span class="list-item"><b>Drag</b> the "Experience Preview"-button below into your bookmarks/favorites bar in your website window unless already there.</span></li>\n                <li><span class="list-item"><b>Click</b> the bookmark in your bookmarks/favorites bar to enable your website for preview.</span></li>\n            </ol>\n\n            <div class="bookmarklet-preview">\n                <a class="bookmarklet">Experience Preview</a>\n                <div class="bookmarklet-helptext">\n                    Drag the button above into your browser\'s bookmarks/favorites bar.\n                </div>\n            </div>\n\n            ';
 if (!browser.type.firefox) { ;
__p += '\n            <p>This works best with Firefox.</p>\n            ';
 } ;
__p += '\n\n            <hr>\n            <div class="status-message"></div>\n\n            <div class="button-panel">\n                <button class="btn btn-secondary close-button">Close</button>\n            </div>\n        </div>\n    </div>\n\n    <div class="status fullscreen snippet-not-ok">\n        <div class="content">\n            <h2 class="bold">Something is wrong!</h2>\n            <h3>The page is enabled for Slots, but the configuration does not match that of your account.</h3>\n\n            <p>\n            If this is indeed your website, please verify that the publish snippet has been copy/pasted correctly.\n\n            ';
 if (config.communityBaseUrl) { ;
__p += '\n            For more information, visit the <a target="zmags_creator_community" href="' +
__e(config.communityBaseUrl) +
'/hc/en-us/articles/205142369-Prepare-Your-Site-For-Publishing">Creator Community</a>.\n            ';
 } ;
__p += '\n            </p>\n\n            <p>If you need further assistance, click <a id="support" href="#">here</a> to open Help on the "Publish" tab in the editor window.</p>\n            ';
 if (config.supportEmail) { ;
__p += '\n            <p>You can also contact Support via <a href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>.</p>\n            ';
 };
__p += '\n\n            <hr>\n            <div class="status-message"></div>\n\n            <div class="button-panel">\n                <button class="btn btn-secondary close-button">Close</button>\n            </div>\n        </div>\n    </div>\n\n    <div class="status fullscreen browser-not-supported">\n        <div class="content">\n            <h2 class="bold">Drag\'n Drop not supported!</h2>\n            <h3>Unfortunately, the browser you are using does not support Drag\'n Drop Publishing. </h3>\n\n            <p>A solution could be to <a href="http://browsehappy.com/" target="_blank">upgrade your browser</a>\n            ';
 if (!browser.type.chrome) { ;
__p += '\n                or <a href="http://www.google.com/chromeframe/?redirect=true" target="_blank">activate Google Chrome Frame</a>\n            ';
 } ;
__p += '\n            to improve your Drag\'n Drop workflow.\n            </p>\n\n            ';
 if (!notAllowedToPublish) { ;
__p += '\n            <p>However, you can still do manual publishing on the "Publish" tab. </p>\n            ';
 } ;
__p += '\n\n            <p>If you need further assistance, click <a id="support" href="#">here</a> to open Help on the "Publish" tab in the editor window.</p>\n            ';
 if (config.supportEmail) { ;
__p += '\n            <p>You can also contact Support via <a href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>.</p>\n            ';
 } ;
__p += '\n\n            <hr>\n\n            <div class="button-panel">\n                <button class="btn btn-secondary close-button">Close</button>\n            </div>\n        </div>\n    </div>\n\n    <div class="status preview-not-supported">\n        <div class="header">\n            <span class="notification warn"></span>\n            <label class="status-label">\n                Your website does not appear to be ready for publishing, and the operating system and browser combination you are using does not support Experience preview.\n            </label>\n        </div>\n        <div class="content">\n            <h2 class="bold">Don\'t worry!</h2>\n            <h2>You may be able to view your Experiences anyway.</h2>\n\n            <ol class="steps">\n                <li><span class="list-item">You can prepare your website for publishing by <b>adding the snippet</b> found on the "Publish" tab in the editor window to the header of your website. This way, Drag\'n Drop Publishing will be enabled for your website, and Experience preview will no longer be needed.\n                    ';
 if (config.communityBaseUrl) { ;
__p += '\n                    For more information, visit the <a target="zmags_creator_community" href="' +
__e(config.communityBaseUrl) +
'/hc/en-us/articles/205142369-Prepare-Your-Site-For-Publishing">Creator Community</a>\n                    ';
 } ;
__p += '\n                    </span></li>\n\n                <li><span class="list-item">Until then, you could try and <a href="http://browsehappy.com/" target="_blank">upgrade your browser</a> to one that supports Experience preview. ';
 if (!browser.type.firefox) { ;
__p += 'Experience preview works best with <b>Firefox</b>.';
 } ;
__p += '</span></li>\n\n                ';
 if (!notAllowedToPublish) { ;
__p += '\n                <li><span class="list-item">And - you can still do <b>manual publishing</b> on the "Publish" tab in the editor window.</span></li>\n                ';
 } ;
__p += '\n            </ol>\n\n            <p>If you need further assistance, click <a id="support" href="#">here</a> to open Support on the "Publish" tab in the editor window.</p>\n            ';
 if (config.supportEmail) { ;
__p += '\n            <p>You can also contact Support via <a href="mailto:' +
__e(config.supportEmail) +
'">' +
__e(config.supportEmail) +
'</a>.</p>\n            ';
 };
__p += '\n\n            <hr>\n            <div class="status-message"></div>\n\n            <div class="button-panel">\n                <button class="btn btn-secondary close-button">Close</button>\n            </div>\n        </div>\n    </div>\n\n    <div class="status window-closed">\n        <div class="header">\n            <span class="notification notify"></span>\n            <label class="status-label">\n                We have lost the connection to your website and/or editor window. This can be because a window\n                has been closed, or because navigation is in progress. <br><br>\n\n                If navigation or reload of your Slot enabled website is in progress, this page will update itself\n                once that has completed. <br><br>\n\n                If your are in preview mode, simply click the bookmark in your bookmarks/favorites bar again after\n                reload or navigation to enable your website for preview.\n            </label>\n        </div>\n        <div class="content">\n            <div class="button-panel">\n                <button class="btn btn-secondary close-button">Close</button>\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
}

/***/ }),
/* 3142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var BreakpointGroup = __webpack_require__(97);
  var BreakpointGroupRangeMixinPrototype = __webpack_require__(3143);

  /**
   * A <tt>BreakpointGroup</tt> *mixin* that adds breakpoint range functionality to the <tt>BreakpointGroup</tt>.
   *
   * @author Kim Knudsen / <a href="http://www.zmags.com">Zmags</a>
   * @author Gunni Rode / <a href="http://www.zmags.com">Zmags</a>
   */
  return BreakpointGroup.mixin("BreakpointGroupRangeMixin", BreakpointGroupRangeMixinPrototype);
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var BreakpointRange = __webpack_require__(3144);
    var Breakpoint = __webpack_require__(372);

    return {

        /**
         * Returns all valid entries in ascending order by threshold for all valid breakpoint entries,
         * where an asset (experience) with multiple successive breakpoints will be collapsed into a single entry
         * describing the maximum threshold. <p>
         *
         * The return array can thus still contain duplicate assets, but not with successive breakpoints. <p>
         *
         * The viewer will not really need to filter our invalid entries as we only push valid group entries,
         * but this is also used for DnD where the group may contain invalid entries.
         *
         * @return {[asset, value][]} A 2D array containing the <tt>[asset, value]</tt> pairs for each
         *                                (collapsed) entry; never falsey, but can be empty.
         *
         * @see #entries
         */
        sortedEntries: function sortedEntries() {
            var sorted = [];
            var entries = this.entries();
            var entry = void 0;
            var lastEntry = void 0;
            var asset = void 0;
            var breakpoint = void 0;
            var i = void 0;

            // Filter out all invalid entries, i.e. those without both an asset reference and an actual breakpoint
            // value, before we sort. This is not an issue for the viewer, since it uses pushed data, but required
            // for the channel admin application to be able to present the correct information to the user doing
            // the DnD Publishing...
            for (i = 0; i < entries.length; i++) {
                entry = entries[i];
                breakpoint = entry[1];
                if (breakpoint && breakpoint.has("threshold")) {
                    asset = entry[0];
                    if (asset) {
                        sorted.push(entry);
                    }
                }
            }

            // Sort according to ascending threshold...
            sorted.sort(function (a, b) {
                return a[1].get("threshold") - b[1].get("threshold");
            });

            // Clear entries to be populated with collapsed entries based on sorted order...
            entries = [];
            for (i = 0; i < sorted.length; i++) {
                entry = sorted[i];
                // We know that ids are globally unique across asset types, so it suffices to check on
                // resource id here. If the ids match, we simply skip the current entry as an entry
                // for the same asset is already in "entries" with the lowest possible threshold...
                if (!lastEntry || lastEntry[0].get("id") !== entry[0].get("id")) {
                    entries.push(entry);
                }

                // Save for next iteration...
                lastEntry = entry;
            }

            return entries;
        },


        /**
         * @typedef {function(BreakpointRange):*} BreakpointRangeCallback function that takes a BreakpointRange as a parameter. Can return anything.
         */

        /**
         * Invokes the specified callback of the format <tt>fn(range:BreakpointRange, asset:Reference, group:BreakpointGroup)</tt>
         * for each range deduced from this group, in <b>ascending</b> range order without any gaps. <p>
         *
         * The first range iterated over here will always <b>end</b> with <tt>Breakpoint.INFINITE</tt>, and the last will always
         * <b>start</b> with <tt>Breakpoint.BEGIN</tt>. In case only a single range is contained, this will also be true. In
         * case this group is empty, <tt>callback</tt> will not be invoked.
         *
         * @param {BreakpointRangeCallback} callback The callback to invoke for each range deduced from this group; cannot be falsey.
         *                            If a value is returned, the iteration will stop and said value returned.
         *
         * @return {*} The first value returned by callback, if any; can be undefined.
         */
        forEachRange: function forEachRange(callback) {
            // todo this doesn't go through the whole range. Rename to something like `firstMatchInRange`?
            var entries = this.sortedEntries();
            var n = entries.length - 1;
            var from = Breakpoint.BEGIN;
            var result = void 0;
            var to = void 0;
            var entry = void 0;
            var i = void 0;

            // First range always start with Breakpoint.BEGIN, last range always end with Breakpoint.INFINITY; they
            // can be the same single range...
            for (i = 0; i <= n; i++) {
                entry = entries[i];
                to = i === n ? Breakpoint.INFINITY : entries[i + 1][1];
                result = callback(new BreakpointRange(from, to), entry[0], this);
                if (typeof result !== "undefined") {
                    return result;
                }
                from = to;
            }
            // undefined
        },


        /**
         * Returns a ranges deduced from this group, in range order, without associated assets.
         *
         * @return {BreakpointRange[]} The ranges deduced from this group, in range order; never falsey, but can
         *                             be empty.
         *
         * @see    #rangeAssets
         * @see    #rangeMap
         */
        ranges: function ranges() {
            var ranges = [];
            this.forEachRange(function (range) {
                ranges.push(range);
            });
            return ranges;
        },


        /**
         * Returns a unique assets deduced from the ranges of this group, in range order, but with no duplicates.
         *
         * @return {[]} The assets deduced from the ranges of this group; never falsey, but can be empty.
         *
         * @see    #ranges
         * @see    #rangeMap
         */
        rangeAssets: function rangeAssets() {
            var assets = [];
            // Range is unique, but assets may not be, i.e. R1:E1, R2:E2, R3:E1 again. This is O(n2), but we assume
            // very few entries, i.e <= 5 on average case...
            this.forEachRange(function (range, asset) {
                var i = void 0;
                for (i = 0; i < assets.length; i++) {
                    if (assets[i].get("id") === asset.get("id")) {
                        return;
                    }
                }
                assets.push(asset);
            });
            return assets;
        },


        /**
         * Returns a map indexed by the ranges deduced from this group where the associated values are the
         * asset associated with said range. <p>
         *
         * The same asset may be stored numerous times as a value in the returned map.
         *
         * @return {Map.<BreakpointRange,{resourceId:String, resourceType:String}} The map of ranges indexing their
         *         associated asset (experience) via a reference; never falsey, but can be empty.
         *
         * @see    #ranges
         */
        rangeMap: function rangeMap() {
            var map = new Map();
            this.forEachRange(function (range, asset) {
                map.set(range, asset);
            });
            return map;
        },


        /**
         * Returns a user friendly description of this group (primarily for logging).
         *
         * @param  {Boolean} [excludeIds] True to exclude asset ids in the description, falsey to include them (default).
         * @return {String} A user friendly description; never null.
         */
        describe: function describe(excludeIds) {
            var s = "";
            this.forEachRange(function (range, asset) {
                if (s) {
                    s += ", ";
                }
                s += range;
                if (!excludeIds) {
                    s += "'" + asset.get("id") + "'";
                }
            });
            return s;
        },


        /**
         * Returns the (to) breakpoint from this group matching the specified threshold.
         *
         * @param  {Number} threshold The current threshold/width.
         * @return {{breakpoint: Breakpoint, reference:Reference}} The matching range and associated asset; can only be
         *                                                         falsey if this group is empty.
         */
        fromThreshold: function fromThreshold(threshold) {
            threshold = Math.max(0, threshold);

            return this.forEachRange(function (range, asset) {
                if (range.contains(threshold)) {
                    return {
                        breakpoint: range.breakpoint(),
                        asset: asset
                    };
                }
            });
        }
    };
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
  "use strict";

  var _ = __webpack_require__(1);
  var Class = __webpack_require__(26);
  var Preconditions = __webpack_require__(14);

  /**
   * Describes a range between 2 breakpoints. <p>
   *
   * The "from" breakpoint is always included in the range, the "to" breakpoint is not included in the range.
   * That is, each range in mathematical terms is like [from, to[.
   *
   * @class BreakpointRange
   */
  return Class.extend("BreakpointRange", {
    // TODO: consider simply storing two numbers instead of Breakpoint models.

    /**
     * @private @type {Breakpoint}
     * The from breakpoint of this range, inclusive; never falsey.
     */
    _from: null,
    /**
     * @private @type {Breakpoint}
     * The to breakpoint of this range, exclusive; never falsey.
     */
    _to: null,

    /**
     * Constructor.
     *
     * @param {Breakpoint} from The starting breakpoint; cannot be falsey.
     * @param {Breakpoint} to   The ending breakpoint; cannot be falsey.
     */
    constructor: function constructor(from, to) {
      Preconditions.checkArguments(from, to);
      Preconditions.checkState(from.get("threshold") < to.get("threshold"));

      this._from = from;
      this._to = to;
    },


    /**
     * Returns the (to) breakpoint representing this range, always defined as the <tt>to</tt> breakpoint since
     * it is always exclusive - once said breakpoint is crossed, a new range is known to take effect, with
     * the same breakpoint threshold, but inclusive. It also ensures that we do not report <tt>Breakpoint.BEGIN</tt>
     * since that can never be crossed.
     *
     * @return {Breakpoint} The (to) breakpoint for this range; never falsey.
     */
    breakpoint: function breakpoint() {
      return this._to;
    },


    /**
     * Whether the specified threshold is contained within *this* range. <p>
     *
     * The from breakpoint of this range is always inclusive, the to breakpoint always exclusive.
     *
     * @return {Boolean} <tt>true</tt> if the threshold is contained within *this* range, <tt>false</tt> if not.
     */
    contains: function contains(threshold) {
      return threshold >= this._from.get("threshold") && threshold < this._to.get("threshold");
    },


    /**
     * Returns a user-friendly string describing this range like (0, 200) or (700, oo) for the last range. In
     * this representation, both from and to points are inclusive.
     *
     * @return {String} The range string; never falsey.
     */
    toString: function toString() {
      var to = this._to.get("threshold");
      if (_.isNumber(to) && to !== Number.POSITIVE_INFINITY) {
        to -= 1;
      }
      return "(" + this._from.get("threshold") + ", " + to + ")";
    }
  });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4),
        Browser = __webpack_require__(39),
        ImprovedView = __webpack_require__(6),
        _require = __webpack_require__(24),
        Logger = _require.Logger,
        MessageNode = __webpack_require__(465),
        MessageTypes = __webpack_require__(342),
        template = __webpack_require__(3146),
        UrlUtil = __webpack_require__(46),
        Window = __webpack_require__(48);


    var ADMIN_MODE_IDENTIFIER = "zmagsCreatorAdminMode=true";

    // Since we are about to open on a customer window, pass through our logging settings...
    var LOG_MODE_IDENTIFIER = "zmagsLog=" + Logger.level();

    /**
     *
     */
    return ImprovedView.extend({

        template: template,

        className: "zmags-framed-publish-toolbar",

        templateHelpers: function templateHelpers() {
            var projectContext = !!this.options.projectId,
                base = projectContext ? "project/" + this.options.projectId + "/" : "";

            return {
                browser: Browser,
                siteUrl: UrlUtil.appendParam(UrlUtil.appendParam(this.options.url, ADMIN_MODE_IDENTIFIER), LOG_MODE_IDENTIFIER),
                // timestamp is cache buster since Firefox and IE will not load it otherwise
                toolbarUrl: "?" + new Date().getTime() + "#" + base + "publishtoolbar/" + encodeURIComponent(this.options.url)
            };
        },

        _node: null,

        initialize: function initialize() {
            // Log config: since just an intermediate node, only log if we use verbose log level...
            var logOptions = { log: Logger.level() > Logger.LOG, ignore: MessageTypes.PAGE_IS_CHANNELS_ENABLED };

            // This frame node is just an intermediate relay node, so we do not really care which origins are
            // allowed - this is handled by the "publish", "toolbar", and "channel_admin" nodes explicitly. Also,
            // by allowing all, IE is able to post messages from "channels_admin" to this node, which we can use
            // to open NAVIGATE_TO links, even in case on domain inconsistencies...
            this._node = new MessageNode({ name: "frame", log: logOptions, eksport: "__zmags.creator.node" });

            var on = {};

            // Close both pop-up windows if either of them is closed via "Close-button" click...
            on[MessageNode.Message.Actions.LEAVE] = function (message) {
                if (message.data === "self") {
                    window.close();
                }
            };
            // Zendesk does not allow itself to be opened in a frame, and IE will not allow us to open the link directly
            // in another frame, nor by using JS, so we have to update this frame location...
            on[MessageTypes.NAVIGATE_TO] = function (message) {
                Window.open(message.data.url, message.data.target || "zmags_creator");
            };

            this._node.on(on, this);

            // We do not need a nav-bar here...
            $(document).ready(function () {
                $(".navigation-bar").remove();
                $(".main").css("top", "0");
            });
        },

        onClose: function onClose() {
            this._node.close();
            this._node = null;
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3146 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<iframe id="site" src="' +
__e( siteUrl ) +
'" sandbox="allow-forms allow-scripts allow-same-origin';
 if (browser.type.ie) { ;
__p += ' ms-allow-popups';
 } ;
__p += '" style="width: 100%; height: 100%; padding-right: 370px;"></iframe>\n<iframe id="toolbar" src="' +
__e( toolbarUrl ) +
'" style="width: 370px; height:100%; position: absolute; right: 0;" width="370px" height="100%"></iframe>\n';

}
return __p
}

/***/ }),
/* 3147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ImprovedView = __webpack_require__(6),
        template = __webpack_require__(3148);

    /**
     * The Zendesk Support Tab Error view.
     *
     * @class ZendeskErrorView
     * @constructor
     */
    return ImprovedView.extend({

        template: template

    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3148 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="message-container">\n    <div class="zmags-target-overlay-message">\n        <h1>There has been a problem launching our help box</h1>\n        <h2>Please reach out to our <a href="mailto:support@zmags.com">Support Team</a></h2>\n    </div>\n</div>';

}
return __p
}

/***/ }),
/* 3149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var Browser = __webpack_require__(39);
    var Configuration = __webpack_require__(27);
    var Login = __webpack_require__(177);
    var RestApi = __webpack_require__(29);
    var Window = __webpack_require__(48);

    var ZENDESK_URL = Configuration.communityBaseUrl;

    /**
     * Contains functions related to Zendesk.
     *
     * @see https://support.zendesk.com/entries/23675367-Setting-up-single-sign-on-with-JWT-JSON-Web-Token-
     * @class ZendeskUtil
     */
    var ZendeskUtil = {

        /**
         * Looks up the Zendesk token, aka. the JSON Web Token.
         *
         * @return {Promise} A promise object that resolves then the request completes.
         */
        getToken: function getToken() {
            return $.ajax({
                url: RestApi.API_URL + "/users/zendeskToken",
                type: "GET",
                dataType: "json"
            });
        },


        /**
         * @private
         * @static
         *
         * Constructs the proper community URL given the Zendesk token.
         *
         * @param  {String} token    The Zendesk token, see #getToken
         * @param  {String} returnTo Optional URL to navigate to once the SSO process has been successful.
         * @return {String}          The community URL.
         */
        constructCommunityURL: function constructCommunityURL(token, returnTo) {
            var url = ZENDESK_URL + "/access/jwt?jwt=" + token;
            return returnTo ? url + "&return_to=" + returnTo : url;
        },


        /**
         * Logs the user in to Zendesk using SSO.
         */
        login: function login(authController) {
            var _this = this;

            // Attempt login as persisted user
            Login.loginPersistedUser()
            // On failure, login using login form
            .then(null, authController.showLoginForm.bind(authController)).then(this.getToken).done(function (data) {
                var queryParams = Browser.getQueryParameters();
                window.location.href = _this.constructCommunityURL(data.zendeskToken, queryParams.return_to);
            });
        },


        /**
         * Opens a link to the community, trying to link to the specific page if possible.
         *
         * @param {String} [article] The article code; can be falsey.
         */
        openCommunity: function openCommunity(article) {
            var url = ZENDESK_URL;
            if (url) {
                if (article) {
                    url += "/hc/en-us/articles/" + article;
                }
                // Open named window...
                Window.open(url, "zmags_creator_community");
            }
        }
    };

    return ZendeskUtil;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Backbone = __webpack_require__(7);
    var StatsDAnalytics = __webpack_require__(3151);
    var LoggedIn = __webpack_require__(31);
    var EventDispatcher = __webpack_require__(54);
    /**
     * StatsD analytics for the editor.
     *
     * @author Bo Gotthardt
     * @class EditorStatsDAnalytics
     * @constructor
     *
     * @param {String} bucket The bucket name.
     */

    var EditorStatsDAnalytics = function (_StatsDAnalytics) {
        _inherits(EditorStatsDAnalytics, _StatsDAnalytics);

        function EditorStatsDAnalytics(bucket) {
            _classCallCheck(this, EditorStatsDAnalytics);

            var _this = _possibleConstructorReturn(this, (EditorStatsDAnalytics.__proto__ || Object.getPrototypeOf(EditorStatsDAnalytics)).call(this, bucket + ".editor"));

            _this._listener = new EventDispatcher();
            _this._listener.listenTo(Backbone.history, "route", _this.trackPageView);
            return _this;
        }

        // eslint-disable-next-line class-methods-use-this


        _createClass(EditorStatsDAnalytics, [{
            key: "_getPathSuffix",
            value: function _getPathSuffix() {
                var principal = LoggedIn.principal();
                var userSuffix = principal ? "." + principal.get("companyId") + "." + principal.get("userId") : ".unknown.unknown";

                return userSuffix;
            }
        }]);

        return EditorStatsDAnalytics;
    }(StatsDAnalytics);

    return EditorStatsDAnalytics;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    var $ = __webpack_require__(4);
    var Configuration = __webpack_require__(27);
    var Window = __webpack_require__(48);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var EventDispatcher = __webpack_require__(54);

    var log = new Logger("StatsD");

    /**
     * Base class for analytics tracking using our internal StatsD/Graphite setup.
     *
     * @author Bo Gotthardt
     * @author Sune Wettersteen
     * @class StatsDAnalytics
     * @constructor
     *
     * @param {String} bucket
     */

    var StatsDAnalytics = function () {
        function StatsDAnalytics(bucket) {
            _classCallCheck(this, StatsDAnalytics);

            this._bucket = bucket;
            this._listener = new EventDispatcher();
            // This is both used by the Editor and Viewer, even though they set up the statsD entirely different... :(
            if (Configuration.trackErrors) {
                this._windowErrorListenerRemover = Window.error(this.trackError.bind(this)).off;
            }

            // Bind methods to StatsDAnalytics class
            // so they can use 'this' correctly
            this.trackEvent = this.trackEvent.bind(this);
            this.trackError = this.trackError.bind(this);
            this.trackFrontEndError = this.trackFrontEndError.bind(this);
            this.trackPageView = this.trackPageView.bind(this);
        }

        // eslint-disable-next-line class-methods-use-this


        _createClass(StatsDAnalytics, [{
            key: "trackEvent",
            value: function trackEvent() {
                // Empty on purpose.
            }
        }, {
            key: "trackError",
            value: function trackError() {
                this._send("error");
            }
        }, {
            key: "trackFrontEndError",
            value: function trackFrontEndError(errorType) {
                this._send("frontendError. " + (errorType || "unknown"), null, null, null, true);
            }
        }, {
            key: "trackPageView",
            value: function trackPageView() {
                this._send("pageview");
            }
        }, {
            key: "trackInitTime",
            value: function trackInitTime(loadTime) {
                this._send("init", "time", loadTime);
            }
        }, {
            key: "trackLoadTime",
            value: function trackLoadTime(loadTime) {
                this._send("loaded", "time", loadTime);
            }
        }, {
            key: "track",
            value: function track(path, value) {
                this._send(path, null, value);
            }

            // eslint-disable-next-line class-methods-use-this

        }, {
            key: "_getPathSuffix",
            value: function _getPathSuffix() {
                return "";
            }
        }, {
            key: "_send",
            value: function _send(path, type, value, suffix, ignoreSuffix) {
                path = (this._bucket + "." + path + ((ignoreSuffix ? "" : this._getPathSuffix()) + (suffix || ""))).replace(/\s/g, "_");
                type = type || "counter"; // counter, gauge or time
                value = value || 1;

                log.verbose("StatsD request (path, type, value): (" + path + ", " + type + ", " + value + ")");

                $.ajax({
                    url: Configuration.statsDUrl,
                    type: "POST",
                    data: {
                        p: path,
                        t: type,
                        v: value
                    }
                });
            }
        }, {
            key: "dispose",
            value: function dispose() {
                this._listener.stopListening();

                if (this._windowErrorListenerRemover) {
                    this._windowErrorListenerRemover();
                }
            }
        }]);

        return StatsDAnalytics;
    }();

    return StatsDAnalytics;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var ErrorLogger = __webpack_require__(3153);
    var LoggedIn = __webpack_require__(31);
    var LoggedInUserState = __webpack_require__(19);
    var Sentry = __webpack_require__(3154);
    var EventDispatcher = __webpack_require__(54);

    return ErrorLogger.extend({
        constructor: function constructor(config) {
            var _this = this;

            this.__super(config.errorQueueURL, ErrorLogger.Context.EDITOR);
            this.logErrorsToSentry = !!config.sentryEnabled && !!config.sentryDSN && !!config.version && !!config.trackErrors;

            // Add Sentry error handling.
            // NOTE: release tags are global to the account so we're prefixing with "creator@"
            if (this.logErrorsToSentry) {
                this._listener = new EventDispatcher();
                this._listener.listenTo(LoggedInUserState, "change:ready", function () {
                    return _this._addUserInfoToErrorLogger();
                });
                var sentryConfig = {
                    dsn: config.sentryDSN,
                    environment: config.env
                };
                if (config.env === "PROD") {
                    sentryConfig.release = "creator@" + config.version;
                }
                Sentry.init(sentryConfig);
            }
        },
        _addUserInfoToErrorLogger: function _addUserInfoToErrorLogger() {
            if (this.logErrorsToSentry && LoggedInUserState.get("ready")) {
                var company = LoggedInUserState.get("company");
                var user = LoggedInUserState.get("user");
                Sentry.configureScope(function (scope) {
                    scope.setUser({
                        id: user.get("id"),
                        email: user.get("username"),
                        username: user.get("name")
                    });
                    scope.setTag("company.name", company.get("name"));
                    scope.setTag("company.id", company.get("id"));
                    // Storing user.role as a tag because arbitrary key/value pairs within "user" are unsearchable.
                    // Reference: https://docs.sentry.io/enriching-error-data/additional-data/
                    scope.setTag("user.role", user.get("role").name);
                });
            }
        },
        _additionalInfo: function _additionalInfo() {
            var principal = LoggedIn.principal();

            if (principal) {
                var user = principal.get("user");

                return {
                    location: LoggedInUserState.get("location"),
                    userName: principal.get("displayName"), // may reflect ad login
                    tokenType: principal.get("type"),
                    userId: user.get("id"),
                    email: user.get("username")
                };
            }
            return {};
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var Class = __webpack_require__(26);
    var Window = __webpack_require__(48);
    var $ = __webpack_require__(4);
    var _ = __webpack_require__(1);

    var _require = __webpack_require__(24),
        Logger = _require.Logger;

    var Configuration = __webpack_require__(27);
    var Promise = __webpack_require__(21);
    var GUID = __webpack_require__(858);

    var Context = {
        VIEWER: "viewer",
        CHANNELS: "channels",
        EDITOR: "editor"
    };

    var sequence = 0;

    /**
     * Abstract base class for logging/sending errors to the SQS error queue. <p>
     *
     * It will also set a window.onerror handler to catch all unhandled errors, optionally reporting them to the
     * frontend error service and/or alert the user with a message detailing the nature of the problem via
     * the configured <tt>ErrorHandler</tt> if and only if the log level is <tt>LOG</tt> or above. <p>
     *
     * Errors will only be logged via the frontend error service if the error logger is "enabled", but will still
     * be reported via <tt>ErrorHandler</tt> (providing the log level is set). <p>
     *
     * An error logger can also be associated with a statsD client, which on logged *handled* errors will
     * call <tt>statsD.traceError()</tt> to track such errors in statsD; the statsD client uses its own global
     * error handler for unhandled errors to track errors, which is why we do not call statsD on unhandled
     * errors here.
     *
     * @class ErrorLogger
     *
     * @author Kim Knudsen
     * @author Gunni Rode
     */
    var ErrorLogger = Class.extend({

        _logger: null,
        _errorQueueURL: null,
        _context: null,
        _statsD: null,

        // Array of previously obtained error ids to be submitted with the next error logged to get a better
        // context of which frontend errors potentially triggers other errors...
        _errors: [],

        enabled: false, // enabled or not? Note: will still alert the user on unhandled errors via ErrorHandler for log level >= LOG

        /**
         * Constructor.
         *
         * @param  {String}          errorQueueURL  The SQS Queue url used to post messages.
         * @param  {Context}         context  The logger 'context', as a ErrorLogger.Context.XXX constant value.
         *
         * @constructor
         */
        constructor: function constructor(errorQueueURL, context) {
            var _this = this;

            this._errorQueueURL = errorQueueURL;
            this._context = context;

            this._logger = new Logger("ErrorLogger");

            // Add global hook to unhandled errors...
            Window.error(function (resolved) {
                var message = {
                    unhandled: resolved.message,
                    trace: resolved.error.stack && resolved.error.stack.toString().split(/\s*\n+\s*/g),
                    errorType: resolved.error.name || "Unknown"
                };

                // Last false argument is to *not* report stats via statsD on such unhandled errors, since the
                // StatsD implementation already have such a global error handler by itself...
                _this.log(message, false); // may not be "enabled"!
            });
        },


        /**
         * Formats the supplied message object (error and data) into a json string.
         *
         * @param  {Object} errorObject  Object to format into a json string; never null.
         * @return {String} The json'ified string; never null.
         */
        _toJSON: function _toJSON(errorObject) {
            try {
                // Could be trouble if the actual message cannot be json'ified, e.g. because of circular errors, so on
                // error we try again without it to see if that helps; if not, we sent a message saying so...
                return JSON.stringify(errorObject);
            } catch (e) {
                this._logger.error("Could not format message for frontend error service, removing actual message", e);
                delete errorObject.errorMessage;
                try {
                    return JSON.stringify(errorObject);
                } catch (ee) {
                    this._logger.error("Could not format message for frontend error service, using default message", e);
                    return "{message:\"Cannot report error, could not format actual message into json\", error:\"" + ee.message + "\", url:\"" + window.location.url + "\"}";
                }
            }
        },


        /**
         * Performs a POST request containing the error message and any additional info, as a
         * JSON formatted string.
         *
         * @param  {Object} errorObject Object hash containing the error information.
         * @return {Promise} A promise that resolves once the error is logged; never falsey.
         */
        _post: function _post(errorObject) {
            var _this2 = this;

            // Send along any previous errors...
            errorObject.errors = this._errors;
            errorObject.sequence = ++sequence;

            this._logger.info("Error sequence: <" + errorObject.sequence + ">");

            // Compose the POST request to the SQS queue.
            return $.ajax({
                url: this._errorQueueURL,
                type: "POST",
                data: "Action=SendMessage&MessageBody=" + encodeURIComponent(this._toJSON(errorObject)),
                contentType: "application/x-www-form-urlencoded; charset=UTF-8" // Needs to be url encoded and to have the charset set
            }).done(function () {
                // Save the uuid for the next error submitted for better context...
                _this2._errors.push(errorObject.id);
                _this2._logger.info("Error sequence -> uuid: <" + errorObject.id + "> -> <" + errorObject.sequence + ">");
            }).fail(function (xhr) {
                _this2._logger.error("Could not report frontend error: <" + errorObject.sequence + "> with id " + errorObject.id, xhr);
            });
        },


        /**
         * Subclass hook to provide additional logging information.
         *
         * @return {Object} Object hash that will be appended to the log object
         * sent to the server.
         */
        _additionalInfo: function _additionalInfo() {
            return {};
        },


        /**
         * Associate, or not, the supplied statsD client with this error handler, to be notified each time
         * an error is logged.
         *
         * @param statsD The statsD client, if any; can be null/undefined.
         */
        statsD: function statsD(_statsD) {
            this._statsD = _statsD;
        },


        /**
         * Logs the specified error message and sends it to the backend error log.
         *
         * @param  {String|*} message The error message.
         * @param  {Boolean} [statsD] True or undefined to log statsD if a statsD client is set, false otherwise. The
         *                            <tt>traceError</tt> method will be used to report the statsD error.
         * @return {Promise} A promise that resolves once the error has been reported; never falsey. If this error
         *         logger is not enabled, the returned promise is already resolved.
         */
        log: function log(message, statsD) {
            if (!this.enabled) {
                return Promise.resolved();
            }

            var errorType = message.errorType ? message.errorType : "Unknown";
            var isUnhandled = message.unhandled;
            var description = "Frontend error";
            var errorObject = {
                description: description,
                id: GUID.random(),
                userAgent: Window.userAgent,
                context: this._context,
                // This needs to be a String, it cannot be a JSON object because the message is sometimes a JSON
                // object and sometimes a String and ElasticSearch will create an index based on previously reported
                // information and it will reject other messages that don't have the same format
                detail: "ErrorDescription : " + JSON.stringify(message),
                msg: "description - " + errorType + " - " + (isUnhandled ? "unhandled" : "checked"),
                url: Window.topWindow().location.href // embedded urls handled explicitly in ViewerErrorLogger
            };

            // Special trick to mark unhandled errors, needed to be reported even if the json formatting of
            // "message" fails!...
            if (isUnhandled) {
                errorObject.unhandled = isUnhandled.toString(); // make sure it can be marshalled!
                delete message.unhandled;
            }

            // Make sure some random data error will no corrupt the sending of the error...
            try {
                _.extend(errorObject, this._additionalInfo());
            } catch (e) {
                errorObject.additionalInfoFailed = e.toString();
            }

            // Add version, if defined...
            if (Configuration.version) {
                errorObject.version = Configuration.version;
            }

            var promise = this._post(errorObject);

            // Track statsD? May not want to on unhandled errors, since statsD already has such a handler...
            if ((typeof statsD === "undefined" || statsD) && this._statsD) {
                this._statsD.trackError();
            }

            // Track the front end error
            if (this._statsD) {
                this._statsD.trackFrontEndError(errorType);
            }

            return promise;
        }
    }, {
        Context: Context
    });

    return ErrorLogger;
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Integrations", function() { return INTEGRATIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__exports__ = __webpack_require__(3155);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Severity", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Status", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addGlobalEventProcessor", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "addBreadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureException", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureEvent", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "captureMessage", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "configureScope", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getHubFromCarrier", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["s"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getCurrentHub", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["r"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Hub", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeMain", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["v"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Scope", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "startTransaction", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["E"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["x"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setExtra", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["y"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setExtras", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["z"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setTag", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["A"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setTags", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["B"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "setUser", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["C"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "withScope", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["F"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "BrowserClient", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "defaultIntegrations", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["o"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "forceLoad", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["q"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["t"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "lastEventId", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["u"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "onLoad", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["w"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "showReportDialog", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["D"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["p"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "close", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["G"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SDK_NAME", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "SDK_VERSION", function() { return __WEBPACK_IMPORTED_MODULE_1__exports__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(1259);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Transports", function() { return __WEBPACK_IMPORTED_MODULE_5__transports__; });






var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
// tslint:disable: no-unsafe-any
var _window = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["m" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
// tslint:enable: no-unsafe-any
var INTEGRATIONS = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, windowIntegrations, __WEBPACK_IMPORTED_MODULE_2__sentry_core__["e" /* Integrations */], __WEBPACK_IMPORTED_MODULE_4__integrations__);

//# sourceMappingURL=index.js.map

/***/ }),
/* 3155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_types__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_core__["y"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(1256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__client__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sdk__ = __webpack_require__(3185);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_3__sdk__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_3__sdk__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__sdk__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_3__sdk__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_3__sdk__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_3__sdk__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_3__sdk__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_3__sdk__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_3__sdk__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(1260);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__version__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__version__["b"]; });





//# sourceMappingURL=exports.js.map

/***/ }),
/* 3156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogLevel */
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 3157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Severity; });
/** JSDoc */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map

/***/ }),
/* 3158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/** The status of an event. */
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 3159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = captureException;
/* harmony export (immutable) */ __webpack_exports__["d"] = captureMessage;
/* harmony export (immutable) */ __webpack_exports__["b"] = captureEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = configureScope;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBreadcrumb;
/* harmony export (immutable) */ __webpack_exports__["f"] = setContext;
/* harmony export (immutable) */ __webpack_exports__["h"] = setExtras;
/* harmony export (immutable) */ __webpack_exports__["j"] = setTags;
/* harmony export (immutable) */ __webpack_exports__["g"] = setExtra;
/* harmony export (immutable) */ __webpack_exports__["i"] = setTag;
/* harmony export (immutable) */ __webpack_exports__["k"] = setUser;
/* harmony export (immutable) */ __webpack_exports__["m"] = withScope;
/* unused harmony export _callOnClient */
/* harmony export (immutable) */ __webpack_exports__["l"] = startTransaction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(286);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["d" /* getCurrentHub */])();
    if (hub && hub[method]) {
        // tslint:disable-next-line:no-unsafe-any
        return hub[method].apply(hub, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arrity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? { captureContext: captureContext } : undefined;
    return callOnHub('captureMessage', message, level, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ originalException: message, syntheticException: syntheticException }, context));
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 * @param key String key of tag
 * @param value String value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 * @hidden
 */
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](['_invokeClient', method], args));
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual
 * tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and
 * child spans to other spans. To start a new child span within the transaction
 * or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished,
 * otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at
 * which point the transaction with all its finished child spans will be sent to
 * Sentry.
 *
 * @param context Properties of the new `Transaction`.
 */
function startTransaction(context) {
    return callOnHub('startTransaction', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, context));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 3160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["b"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 3161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forget */
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
function forget(promise) {
    promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 3162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPrototypeOf; });
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties); // tslint:disable-line:no-unbound-method
/**
 * setPrototypeOf polyfill using __proto__
 */
function setProtoOf(obj, proto) {
    // @ts-ignore
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 3163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolve */
/* unused harmony export relative */
/* unused harmony export normalizePath */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export dirname */
/* unused harmony export basename */
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    // tslint:disable:no-parameter-reassignment
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map

/***/ }),
/* 3164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromiseBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncpromise__ = __webpack_require__(1253);


/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* SentryError */]('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task
            .then(function () { return _this.remove(task); })
            .then(null, function () {
            return _this.remove(task).then(null, function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */](function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .then(null, function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());

//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 3165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addInstrumentationHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__misc__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__object__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__supports__ = __webpack_require__(1254);
/* tslint:disable:only-arrow-functions no-unsafe-any */






var global = Object(__WEBPACK_IMPORTED_MODULE_3__misc__["f" /* getGlobalObject */])();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(handler) {
    // tslint:disable-next-line:strict-type-predicates
    if (!handler || typeof handler.type !== 'string' || typeof handler.callback !== 'function') {
        return;
    }
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    instrument(handler.type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __values */](handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* logger */].error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + Object(__WEBPACK_IMPORTED_MODULE_3__misc__["e" /* getFunctionName */])(handler) + "\nError: " + e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in global.console)) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.console, level, function (originalConsoleLevel) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleLevel) {
                    Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__supports__["c" /* supportsNativeFetch */])()) {
        return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var commonHandlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData));
            return originalFetch.apply(global, args).then(function (response) {
                triggerHandlers('fetch', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData, { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, commonHandlerData, { endTimestamp: Date.now(), error: error }));
                throw error;
            });
        };
    });
}
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global && Object(__WEBPACK_IMPORTED_MODULE_1__is__["g" /* isInstanceOf */])(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var xhr = this; // tslint:disable-line:no-this-assignment
            var url = args[1];
            xhr.__sentry_xhr__ = {
                method: Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (Object(__WEBPACK_IMPORTED_MODULE_1__is__["k" /* isString */])(url) && xhr.__sentry_xhr__.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) {
                            xhr.__sentry_xhr__.status_code = xhr.status;
                        }
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!Object(__WEBPACK_IMPORTED_MODULE_5__supports__["b" /* supportsHistory */])()) {
        return;
    }
    var oldOnPopState = global.onpopstate;
    global.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            return oldOnPopState.apply(this, args);
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.history, 'pushState', historyReplacementFunction);
    Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(global.history, 'replaceState', historyReplacementFunction);
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global)) {
        return;
    }
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    global.document.addEventListener('click', domEventHandler('click', triggerHandlers.bind(null, 'dom')), false);
    global.document.addEventListener('keypress', keypressEventHandler(triggerHandlers.bind(null, 'dom')), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    ['EventTarget', 'Node'].forEach(function (target) {
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === 'click') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                domEventHandler('click', triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                    if (eventName === 'keypress') {
                        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                            return function (event) {
                                keypressEventHandler(triggerHandlers.bind(null, 'dom'))(event);
                                return innerOriginal.call(this, event);
                            };
                        });
                    }
                }
                else {
                    if (eventName === 'click') {
                        domEventHandler('click', triggerHandlers.bind(null, 'dom'), true)(this);
                    }
                    if (eventName === 'keypress') {
                        keypressEventHandler(triggerHandlers.bind(null, 'dom'))(this);
                    }
                }
                return original.call(this, eventName, fn, options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_4__object__["b" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    });
}
var debounceDuration = 1000;
var debounceTimer = 0;
var keypressTimeout;
var lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function domEventHandler(name, handler, debounce) {
    if (debounce === void 0) { debounce = false; }
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        if (debounce) {
            debounceTimer = setTimeout(function () {
                handler({ event: event, name: name });
            });
        }
        else {
            handler({ event: event, name: name });
        }
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */
function keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            domEventHandler('input', handler)(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global.onerror;
    global.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global.onunhandledrejection;
    global.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}
//# sourceMappingURL=instrument.js.map

/***/ }),
/* 3166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dsn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(722);


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w\.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        // tslint:disable-next-line:no-this-assignment
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE);
        }
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __read */](match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) {
                projectId = projectMatch[0];
            }
        }
        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": " + component + " missing");
            }
        });
        if (!this.projectId.match(/^\d+$/)) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
        }
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
        }
        if (this.port && isNaN(parseInt(this.port, 10))) {
            throw new __WEBPACK_IMPORTED_MODULE_1__error__["a" /* SentryError */](ERROR_MESSAGE + ": Invalid port " + this.port);
        }
    };
    return Dsn;
}());

//# sourceMappingURL=dsn.js.map

/***/ }),
/* 3167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API_VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hub; });
/* unused harmony export getMainCarrier */
/* harmony export (immutable) */ __webpack_exports__["d"] = makeMain;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCurrentHub;
/* harmony export (immutable) */ __webpack_exports__["c"] = getHubFromCarrier;
/* unused harmony export setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scope__ = __webpack_require__(1249);



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be incresed when the global interface
 * changes a and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */](); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [];
        this._stack.push({ client: client, scope: scope });
        this.bindClient(client);
    }
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) {
            (_a = top.client)[method].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](args, [top.scope]));
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var stack = this.getStack();
        var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
        var scope = __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(parentScope);
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        return this.getStack().pop() !== undefined;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["M" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["M" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["M" /* uuid4 */])());
        this._invokeClient('captureEvent', event, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, hint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var top = this.getStackTop();
        if (!top.scope || !top.client) {
            return;
        }
        var _a = (top.client.getOptions && top.client.getOptions()) || {}, _b = _a.beforeBreadcrumb, beforeBreadcrumb = _b === void 0 ? null : _b, _c = _a.maxBreadcrumbs, maxBreadcrumbs = _c === void 0 ? DEFAULT_BREADCRUMBS : _c;
        if (maxBreadcrumbs <= 0) {
            return;
        }
        var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["J" /* timestampWithMs */])();
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["h" /* consoleSandbox */])(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null) {
            return;
        }
        top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setContext = function (name, context) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            callback(top.scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client) {
            return null;
        }
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context) {
        return this._callExtensionMethod('startTransaction', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        // tslint:disable-next-line: strict-type-predicates
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* logger */].warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());

/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["w" /* isNodeEnv */])()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Try to read the hub from an active domain, fallback to the registry if one doesnt exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var property = 'domain';
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        // tslint:disable-next-line: strict-type-predicates
        if (!sentry || !sentry.extensions || !sentry.extensions[property]) {
            return getHubFromCarrier(registry);
        }
        var domain = sentry.extensions[property];
        var activeDomain = domain.active;
        // If there no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or its an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return true;
    }
    return false;
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return carrier.__SENTRY__.hub;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier) {
        return false;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map

/***/ }),
/* 3168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(56);

var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["a" /* Dsn */](dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */
    API.prototype.getBaseApiEndpoint = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
    };
    /** Returns the store endpoint URL. */
    API.prototype.getStoreEndpoint = function () {
        return this._getIngestEndpoint('store');
    };
    /** Returns the envelope endpoint URL. */
    API.prototype._getEnvelopeEndpoint = function () {
        return this._getIngestEndpoint('envelope');
    };
    /** Returns the ingest API endpoint for target. */
    API.prototype._getIngestEndpoint = function (target) {
        var base = this.getBaseApiEndpoint();
        var dsn = this._dsnObject;
        return "" + base + dsn.projectId + "/" + target + "/";
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        return this.getStoreEndpoint() + "?" + this._encodedAuth();
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */
    API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function () {
        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
    };
    /** Returns a URL-encoded string with auth config suitable for a query string. */
    API.prototype._encodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            // We send only the minimum set of required information. See
            // https://github.com/getsentry/sentry-javascript/issues/2572.
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION,
        };
        return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["L" /* urlEncode */])(auth);
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /**
     * Returns an object that can be used in request headers.
     * This is needed for node and the old /store endpoint in sentry
     */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this._dsnObject;
        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    return API;
}());

//# sourceMappingURL=api.js.map

/***/ }),
/* 3169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__integration__ = __webpack_require__(3170);




/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Is the client still processing a call? */
        this._processing = false;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["a" /* Dsn */](options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) {
            eventId = _this.captureEvent(event, hint, scope);
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        var promisedEvent = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["y" /* isPrimitive */])(message)
            ? this._getBackend().eventFromMessage("" + message, level, hint)
            : this._getBackend().eventFromException(message, hint);
        promisedEvent.then(function (event) {
            eventId = _this.captureEvent(event, hint, scope);
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._processEvent(event, hint, scope)
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (status) {
            clearInterval(status.interval);
            return _this._getBackend()
                .getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return status.ready && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled()) {
            this._integrations = Object(__WEBPACK_IMPORTED_MODULE_3__integration__["a" /* setupIntegrations */])(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = 0;
            clearInterval(interval);
            interval = setInterval(function () {
                if (!_this._processing) {
                    resolve({
                        interval: interval,
                        ready: true,
                    });
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        resolve({
                            interval: interval,
                            ready: false,
                        });
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["M" /* uuid4 */])()), timestamp: event.timestamp || Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["J" /* timestampWithMs */])() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* Scope */].clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */].resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            // tslint:disable-next-line:strict-type-predicates
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth) {
        if (!event) {
            return null;
        }
        // tslint:disable:no-unsafe-any
        var normalized = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return (__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, b, (b.data && {
                data: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* normalize */])(b.data, depth),
            }))); }),
        }), (event.user && {
            user: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* normalize */])(event.user, depth),
        }), (event.contexts && {
            contexts: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* normalize */])(event.contexts, depth),
        }), (event.extra && {
            extra: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* normalize */])(event.extra, depth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            normalized.contexts.trace = event.contexts.trace;
        }
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var _a = this.getOptions(), environment = _a.environment, release = _a.release, dist = _a.dist, _b = _a.maxValueLength, maxValueLength = _b === void 0 ? 250 : _b;
        if (event.environment === undefined && environment !== undefined) {
            event.environment = environment;
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["K" /* truncate */])(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["K" /* truncate */])(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["K" /* truncate */])(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var sdkInfo = event.sdk;
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */].reject('SDK not enabled, will not send event.');
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */].reject('This event has been sampled, will not send event.');
        }
        return new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            _this._prepareEvent(event, scope, hint)
                .then(function (prepared) {
                if (prepared === null) {
                    reject('An event processor returned null, will not send event.');
                    return;
                }
                var finalEvent = prepared;
                var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                // We skip beforeSend in case of transactions
                if (isInternalException || !beforeSend || isTransaction) {
                    _this._sendEvent(finalEvent);
                    resolve(finalEvent);
                    return;
                }
                var beforeSendResult = beforeSend(prepared, hint);
                // tslint:disable-next-line:strict-type-predicates
                if (typeof beforeSendResult === 'undefined') {
                    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error('`beforeSend` method has to return `null` or a valid event.');
                }
                else if (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["A" /* isThenable */])(beforeSendResult)) {
                    _this._handleAsyncBeforeSend(beforeSendResult, resolve, reject);
                }
                else {
                    finalEvent = beforeSendResult;
                    if (finalEvent === null) {
                        __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].log('`beforeSend` returned `null`, will not send event.');
                        resolve(null);
                        return;
                    }
                    // From here on we are really async
                    _this._sendEvent(finalEvent);
                    resolve(finalEvent);
                }
            })
                .then(null, function (reason) {
                _this.captureException(reason, {
                    data: {
                        __sentry__: true,
                    },
                    originalException: reason,
                });
                reject("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
            });
        });
    };
    /**
     * Resolves before send Promise and calls resolve/reject on parent SyncPromise.
     */
    BaseClient.prototype._handleAsyncBeforeSend = function (beforeSend, resolve, reject) {
        var _this = this;
        beforeSend
            .then(function (processedEvent) {
            if (processedEvent === null) {
                reject('`beforeSend` returned `null`, will not send event.');
                return;
            }
            // From here on we are really async
            _this._sendEvent(processedEvent);
            resolve(processedEvent);
        })
            .then(null, function (e) {
            reject("beforeSend rejected with " + e);
        });
    };
    return BaseClient;
}());

//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 3170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export installedIntegrations */
/* unused harmony export getIntegrationsToSetup */
/* unused harmony export setupIntegration */
/* harmony export (immutable) */ __webpack_exports__["a"] = setupIntegrations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(56);



var installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        integrations = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](defaultIntegrations);
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* addGlobalEventProcessor */], __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["d" /* getCurrentHub */]);
    installedIntegrations.push(integration.name);
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 3171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transports_noop__ = __webpack_require__(1255);


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["B" /* logger */].warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__transports_noop__["a" /* NoopTransport */]();
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["c" /* SentryError */]('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["B" /* logger */].error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 3172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eventToSentryRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(56);

/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var useEnvelope = event.type === 'transaction';
    var req = {
        body: JSON.stringify(event),
        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth(),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify({
            event_id: event.event_id,
            // We need to add * 1000 since we divide it by 1000 by default but JS works with ms precision
            // The reason we use timestampWithMs here is that all clocks across the SDK use the same clock
            sent_at: new Date(Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["J" /* timestampWithMs */])() * 1000).toISOString(),
        });
        var itemHeaders = JSON.stringify({
            type: event.type,
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}
//# sourceMappingURL=request.js.map

/***/ }),
/* 3173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAndBind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_hub__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(56);


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instanciate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["B" /* logger */].enable();
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_hub__["d" /* getCurrentHub */])();
    var client = new clientClass(options);
    hub.bindClient(client);
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 3174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functiontostring__ = __webpack_require__(3175);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__functiontostring__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inboundfilters__ = __webpack_require__(3176);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_1__inboundfilters__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 3175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionToString; });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        originalFunctionToString = Function.prototype.toString;
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry_original__ || this;
            // tslint:disable-next-line:no-unsafe-any
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 3176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InboundFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(56);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c" /* addGlobalEventProcessor */])(function (event) {
            var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["d" /* getCurrentHub */])();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event));
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            return ((event &&
                event.exception &&
                event.exception.values &&
                event.exception.values[0] &&
                event.exception.values[0].type === 'SentryError') ||
                false);
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isMatchingPattern */])(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isDeniedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isAllowedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["v" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        // tslint:disable:deprecation
        return {
            allowUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */]((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
            denyUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */]((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
            ignoreErrors: __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */]((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error("Cannot extract message for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
            }
            return null;
        }
        catch (oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* logger */].error("Cannot extract url for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["k" /* getEventDescription */])(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 3177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(1259);






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._options.transportOptions, { dsn: this._options.dsn });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["H" /* supportsFetch */])()) {
            return new __WEBPACK_IMPORTED_MODULE_5__transports__["FetchTransport"](transportOptions);
        }
        return new __WEBPACK_IMPORTED_MODULE_5__transports__["XHRTransport"](transportOptions);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        var syntheticException = (hint && hint.syntheticException) || undefined;
        var event = Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromUnknownInput */])(exception, syntheticException, {
            attachStacktrace: this._options.attachStacktrace,
        });
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
            handled: true,
            type: 'generic',
        });
        event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
        if (hint && hint.event_id) {
            event.event_id = hint.event_id;
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].resolve(event);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Info; }
        var syntheticException = (hint && hint.syntheticException) || undefined;
        var event = Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a" /* eventFromString */])(message, syntheticException, {
            attachStacktrace: this._options.attachStacktrace,
        });
        event.level = level;
        if (hint && hint.event_id) {
            event.event_id = hint.event_id;
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */].resolve(event);
    };
    return BrowserBackend;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["b" /* BaseBackend */]));

//# sourceMappingURL=backend.js.map

/***/ }),
/* 3178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__(727);





var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["m" /* getGlobalObject */])();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](FetchTransport, _super);
    function FetchTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429,
            });
        }
        var sentryReq = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["m" /* eventToSentryRequest */])(event, this._api);
        var options = {
            body: sentryReq.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["I" /* supportsReferrerPolicy */])() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            global
                .fetch(sentryReq.url, options)
                .then(function (response) {
                var status = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].fromHttpCode(response.status);
                if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* parseRetryAfterHeader */])(now, response.headers.get('Retry-After')));
                    __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(response);
            })
                .catch(reject);
        }));
    };
    return FetchTransport;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseTransport */]));

//# sourceMappingURL=fetch.js.map

/***/ }),
/* 3179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XHRTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__base__ = __webpack_require__(727);





/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429,
            });
        }
        var sentryReq = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["m" /* eventToSentryRequest */])(event, this._api);
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* SyncPromise */](function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                }
                var status = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].fromHttpCode(request.status);
                if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_2__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* parseRetryAfterHeader */])(now, request.getResponseHeader('Retry-After')));
                    __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(request);
            };
            request.open('POST', sentryReq.url);
            for (var header in _this.options.headers) {
                if (_this.options.headers.hasOwnProperty(header)) {
                    request.setRequestHeader(header, _this.options.headers[header]);
                }
            }
            request.send(sentryReq.body);
        }));
    };
    return XHRTransport;
}(__WEBPACK_IMPORTED_MODULE_4__base__["a" /* BaseTransport */]));

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 3180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(729);






/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /** JSDoc */
        this._onErrorHandlerInstalled = false;
        /** JSDoc */
        this._onUnhandledRejectionHandlerInstalled = false;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* logger */].log('Global Handler attached: onerror');
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["B" /* logger */].log('Global Handler attached: onunhandledrejection');
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
        var _this = this;
        if (this._onErrorHandlerInstalled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
            callback: function (data) {
                var error = data.error;
                var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                    return;
                }
                var client = currentHub.getClient();
                var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* isPrimitive */])(error)
                    ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column)
                    : _this._enhanceEventWithInitialFrame(Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromUnknownInput */])(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: false,
                    }), data.url, data.line, data.column);
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                    handled: false,
                    type: 'onerror',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
            },
            type: 'error',
        });
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
        var _this = this;
        if (this._onUnhandledRejectionHandlerInstalled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
            callback: function (e) {
                var error = e;
                // dig the object of the rejection out of known event types
                try {
                    // PromiseRejectionEvents store the object of the rejection under 'reason'
                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                    if ('reason' in e) {
                        error = e.reason;
                    }
                    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
                    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
                    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
                    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
                    // https://github.com/getsentry/sentry-javascript/issues/2380
                    else if ('detail' in e && 'reason' in e.detail) {
                        error = e.detail.reason;
                    }
                }
                catch (_oO) {
                    // no-empty
                }
                var currentHub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || Object(__WEBPACK_IMPORTED_MODULE_5__helpers__["a" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                    return true;
                }
                var client = currentHub.getClient();
                var event = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* isPrimitive */])(error)
                    ? _this._eventFromIncompleteRejection(error)
                    : Object(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromUnknownInput */])(error, undefined, {
                        attachStacktrace: client && client.getOptions().attachStacktrace,
                        rejection: true,
                    });
                event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["e" /* addExceptionMechanism */])(event, {
                    handled: false,
                    type: 'onunhandledrejection',
                });
                currentHub.captureEvent(event, {
                    originalException: error,
                });
                return;
            },
            type: 'unhandledrejection',
        });
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */
    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["s" /* isErrorEvent */])(msg) ? msg.message : msg;
        var name;
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* isString */])(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || 'Error',
                        value: message,
                    },
                ],
            },
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * This function creates an Event from an TraceKitStackTrace that has part of it missing.
     */
    GlobalHandlers.prototype._eventFromIncompleteRejection = function (error) {
        return {
            exception: {
                values: [
                    {
                        type: 'UnhandledRejection',
                        value: "Non-Error promise rejection captured with value: " + error,
                    },
                ],
            },
        };
    };
    /** JSDoc */
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* isString */])(url) && url.length > 0 ? url : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["n" /* getLocationHref */])();
        if (event.exception.values[0].stacktrace.frames.length === 0) {
            event.exception.values[0].stacktrace.frames.push({
                colno: colno,
                filename: filename,
                function: '?',
                in_app: true,
                lineno: lineno,
            });
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 3181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TryCatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(729);



var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* wrap */])(originalCallback, {
                mechanism: {
                    data: { function: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapRAF = function (original) {
        return function (callback) {
            return original.call(this, Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* wrap */])(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    // tslint:disable-next-line:no-unbound-method strict-type-predicates
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* wrap */])(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* wrap */])(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                /**
                 * There are 2 possible scenarios here:
                 *
                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
                 * as a pass-through, and call original `removeEventListener` with it.
                 *
                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
                 * If a function has `__sentry__` property, it means that it was wrapped, and it has additional property
                 * of `__sentry__original__`, holding the handler. And this original handler, has a reversed link,
                 * with `__sentry_wrapped__` property, which holds the wrapped version.
                 *
                 * When someone adds a handler prior to initialization, and then do it again, but after,
                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
                 * to get rid of the initial handler and it'd stick there forever.
                 * In case of second scenario, `__sentry_original__` refers to initial handler, and passed function
                 * is a wrapped version.
                 */
                var callback = fn;
                try {
                    if (callback && callback.__sentry__) {
                        original.call(this, eventName, callback.__sentry_original__, options);
                    }
                }
                catch (e) {
                    // ignore, accessing __sentry__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    };
    /** JSDoc */
    TryCatch.prototype._wrapXHR = function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var xhr = this; // tslint:disable-line:no-this-assignment
            var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
            xmlHttpRequestProps.forEach(function (prop) {
                if (prop in xhr && typeof xhr[prop] === 'function') {
                    Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(xhr, prop, function (original) {
                        var wrapOptions = {
                            mechanism: {
                                data: {
                                    function: prop,
                                    handler: Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(original),
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        };
                        // If Instrument integration has been called before TryCatch, get the name of original function
                        if (original.__sentry_original__) {
                            wrapOptions.mechanism.data.handler = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* getFunctionName */])(original.__sentry_original__);
                        }
                        // Otherwise wrap directly
                        return Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["b" /* wrap */])(original, wrapOptions);
                    });
                }
            });
            return originalSend.apply(this, args);
        };
    };
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
        if (this._options.setTimeout) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        }
        if (this._options.setInterval) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        }
        if (this._options.requestAnimationFrame) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* fill */])(XMLHttpRequest.prototype, 'send', this._wrapXHR.bind(this));
        }
        if (this._options.eventTarget) {
            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(this._wrapEventTarget.bind(this));
        }
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 3182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumbs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(56);




/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["k" /* getEventDescription */])(event),
        }, {
            event: event,
        });
    };
    /**
     * Creates breadcrumbs from console API calls
     */
    Breadcrumbs.prototype._consoleBreadcrumb = function (handlerData) {
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console',
            },
            level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString(handlerData.level),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* safeJoin */])(handlerData.args, ' '),
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["G" /* safeJoin */])(handlerData.args.slice(1), ' ') || 'console.assert');
                breadcrumb.data.arguments = handlerData.args.slice(1);
            }
            else {
                // Don't capture a breadcrumb for passed assertions
                return;
            }
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level,
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */
    Breadcrumbs.prototype._domBreadcrumb = function (handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* htmlTreeAsString */])(handlerData.event.target)
                : Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* htmlTreeAsString */])(handlerData.event);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */
    Breadcrumbs.prototype._xhrBreadcrumb = function (handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])().addBreadcrumb({
                category: 'xhr',
                data: handlerData.xhr.__sentry_xhr__,
                type: 'http',
            }, {
                xhr: handlerData.xhr,
            });
            return;
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */
    Breadcrumbs.prototype._fetchBreadcrumb = function (handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) {
            return;
        }
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
            // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
            return;
        }
        if (handlerData.error) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: handlerData.fetchData,
                level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error,
                type: 'http',
            }, {
                data: handlerData.error,
                input: handlerData.args,
            });
        }
        else {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])().addBreadcrumb({
                category: 'fetch',
                data: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, handlerData.fetchData, { status_code: handlerData.response.status }),
                type: 'http',
            }, {
                input: handlerData.args,
                response: handlerData.response,
            });
        }
    };
    /**
     * Creates breadcrumbs from history API calls
     */
    Breadcrumbs.prototype._historyBreadcrumb = function (handlerData) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["m" /* getGlobalObject */])();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* parseUrl */])(global.location.href);
        var parsedFrom = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* parseUrl */])(from);
        var parsedTo = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* parseUrl */])(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) {
            parsedFrom = parsedLoc;
        }
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
            // tslint:disable-next-line:no-parameter-reassignment
            to = parsedTo.relative;
        }
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
            // tslint:disable-next-line:no-parameter-reassignment
            from = parsedFrom.relative;
        }
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])().addBreadcrumb({
            category: 'navigation',
            data: {
                from: from,
                to: to,
            },
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        var _this = this;
        if (this._options.console) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._consoleBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](args));
                },
                type: 'console',
            });
        }
        if (this._options.dom) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._domBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](args));
                },
                type: 'dom',
            });
        }
        if (this._options.xhr) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._xhrBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](args));
                },
                type: 'xhr',
            });
        }
        if (this._options.fetch) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._fetchBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](args));
                },
                type: 'fetch',
            });
        }
        if (this._options.history) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* addInstrumentationHandler */])({
                callback: function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _this._historyBreadcrumb.apply(_this, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](args));
                },
                type: 'history',
            });
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 3183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parsers__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracekit__ = __webpack_require__(726);





var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* addGlobalEventProcessor */])(function (event, hint) {
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["u" /* isInstanceOf */])(hint.originalException, Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["u" /* isInstanceOf */])(error[key], Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_4__tracekit__["a" /* computeStackTrace */])(error[key]);
        var exception = Object(__WEBPACK_IMPORTED_MODULE_3__parsers__["c" /* exceptionFromStacktrace */])(stacktrace);
        return this._walkErrorTree(error[key], key, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 3184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(56);



var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["m" /* getGlobalObject */])();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* addGlobalEventProcessor */])(function (event) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["n" /* getCurrentHub */])().getIntegration(UserAgent)) {
                if (!global.navigator || !global.location) {
                    return event;
                }
                var request = event.request || {};
                request.url = request.url || global.location.href;
                request.headers = request.headers || {};
                request.headers['User-Agent'] = global.navigator.userAgent;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),
/* 3185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultIntegrations; });
/* harmony export (immutable) */ __webpack_exports__["e"] = init;
/* harmony export (immutable) */ __webpack_exports__["h"] = showReportDialog;
/* harmony export (immutable) */ __webpack_exports__["f"] = lastEventId;
/* harmony export (immutable) */ __webpack_exports__["d"] = forceLoad;
/* harmony export (immutable) */ __webpack_exports__["g"] = onLoad;
/* harmony export (immutable) */ __webpack_exports__["c"] = flush;
/* harmony export (immutable) */ __webpack_exports__["a"] = close;
/* harmony export (immutable) */ __webpack_exports__["i"] = wrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(728);





var defaultIntegrations = [
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["e" /* Integrations */].InboundFilters(),
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["e" /* Integrations */].FunctionToString(),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["TryCatch"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["GlobalHandlers"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["LinkedErrors"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["UserAgent"](),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["p" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* BrowserClient */], options);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["n" /* getCurrentHub */])().lastEventId();
    }
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["n" /* getCurrentHub */])().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["n" /* getCurrentHub */])().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["n" /* getCurrentHub */])().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["n" /* getCurrentHub */])().getClient();
    if (client) {
        return client.close(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* SyncPromise */].reject(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
function wrap(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["b" /* wrap */])(fn)(); // tslint:disable-line:no-unsafe-any
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 3186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var $ = __webpack_require__(4);
    var EventDispatcher = __webpack_require__(54);
    var EditorEvents = __webpack_require__(17);
    var Tip = __webpack_require__(3187);

    /**
     * Tracks user activity and shows tips to suggest when a user could do something differently.
     *
     * @author Bruce Mackenzie Nielsen
     * @class TipManager
     * @constructor
     */
    return EventDispatcher.extend({

        _currentTip: null,

        _events: {},

        /**
         * Map of editor events to their tip handler.
         *
         * <p>For convenience, the tip handler is passed the array of timestamps corresponding to occurrences of the
         * event type. You can look up occurrences of other events by looking at this._events.</p>
         */
        handlers: {
            "imageWidgetProperties:uploadButton:click": function imageWidgetPropertiesUploadButtonClick(events) {
                // Show a tip if the user does it three times
                if (events.length === 3) {
                    this._showTip(new Tip({ content: __webpack_require__(3189) }));
                }
            }
        },

        constructor: function constructor() {
            this.listenTo(EditorEvents, "all", this._eventHandler);
        },
        _eventHandler: function _eventHandler(event) {
            // Push the event into the map
            var eventArray = this._events[event] || [];
            eventArray.push(Date.now());
            this._events[event] = eventArray;

            // Invoke the handler for this type of event
            if (this.handlers[event]) {
                this.handlers[event].bind(this)(eventArray);
            }
        },
        _showTip: function _showTip(tip) {
            if (this._currentTip) {
                this._currentTip.$el.remove();
            }

            this._currentTip = tip;
            tip.render();
            $("body").append(tip.$el);
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
    "use strict";

    var _ = __webpack_require__(1),
        Marionette = __webpack_require__(10),
        template = __webpack_require__(3188);

    /**
     * View class showing a "Did you know?" tip.
     *
     * @class Tip
     * @constructor
     *
     * @cfg {String|Function} content The content to display in the tip. May either be plain HTML or a template.
     * @cfg {Object} [templateData] If content is a template, this data will be passed to it when it is rendered.
     */
    return Marionette.ItemView.extend({

        className: "tip",
        template: template,
        ui: {
            icon: ".tip-icon",
            content: ".tip-content"
        },
        events: {
            "click .tip-close": "close"
        },
        onRender: function onRender() {
            // Disabled for now, as a question mark doesn't really make sense with the current wording.
            // this.ui.icon.append(Icons.QUESTION_MARK.createElement());

            if (_.isFunction(this.options.content)) {
                this.ui.content.html(this.options.content(this.options.templateData || {}));
            } else {
                this.ui.content.html(this.options.content);
            }
        }
    });
}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3188 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="tip-title">Hint:<br>_</div>\n<div class="tip-icon"></div>\n<div class="tip-content"></div>\n<div class="tip-close">Close</div>';

}
return __p
}

/***/ }),
/* 3189 */
/***/ (function(module, exports) {

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'Upload your images easily by selecting one or more from the desktop and dragging them to the Image Widget or directly to the Scene.';

}
return __p
}

/***/ }),
/* 3190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/editor-main.livadug4.js